document.addEventListener('DOMContentLoaded', function() {
  
  var farben = 

[
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB301",
    "Farbtonhilfsbezeichnung": "DB 301",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "71",
    "Bcolor": "62",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB310",
    "Farbtonhilfsbezeichnung": "DB 310",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "37",
    "Bcolor": "31",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB501",
    "Farbtonhilfsbezeichnung": "DB 501",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "138",
    "Bcolor": "137",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB502",
    "Farbtonhilfsbezeichnung": "DB 502",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "75",
    "Bcolor": "76",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB503",
    "Farbtonhilfsbezeichnung": "DB 503",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "61",
    "Bcolor": "69",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB510",
    "Farbtonhilfsbezeichnung": "DB 510",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "80",
    "Bcolor": "99",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB601",
    "Farbtonhilfsbezeichnung": "DB 601",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "114",
    "Bcolor": "80",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB602",
    "Farbtonhilfsbezeichnung": "DB 602",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "114",
    "Bcolor": "102",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB603",
    "Farbtonhilfsbezeichnung": "DB 603",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "98",
    "Bcolor": "77",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB610",
    "Farbtonhilfsbezeichnung": "DB 610",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "105",
    "Bcolor": "84",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB701",
    "Farbtonhilfsbezeichnung": "DB 701",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "158",
    "Bcolor": "154",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB702",
    "Farbtonhilfsbezeichnung": "DB 702",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "113",
    "Bcolor": "101",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB703",
    "Farbtonhilfsbezeichnung": "DB 703",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "62",
    "Bcolor": "52",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "DB",
    "Farbton_ID": "DB704",
    "Farbtonhilfsbezeichnung": "DB 704",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "141",
    "Bcolor": "137",
    "Y": "70",
    "L": "40",
    "a": "0.58357936143875",
    "b": "78.909782409668",
    "C": "78.9119415283203",
    "h": "89.5762786865234",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38144",
    "Farbtonhilfsbezeichnung": "Altkiefer",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "127",
    "Bcolor": "40",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38100",
    "Farbtonhilfsbezeichnung": "Ebenholz",
    "Farbtonklasse": "01",
    "Rcolor": "46",
    "Gcolor": "43",
    "Bcolor": "37",
    "Y": "9.23813003658294",
    "L": "36.4387921253532",
    "a": "12.1052886552342",
    "b": "7.19040389978112",
    "C": "14.079769943736",
    "h": "0.535987655234701",
    "CMY_C": "0.5746035",
    "CMY_M": "0.6920407",
    "CMY_Y": "0.7096009",
    "CMYK_C": "0",
    "CMYK_M": "0.2760653",
    "CMYK_Y": "0.3173449",
    "CMYK_K": "0.5746035"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38146",
    "Farbtonhilfsbezeichnung": "Eiche",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "122",
    "Bcolor": "46",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38103",
    "Farbtonhilfsbezeichnung": "Eiche hell",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "146",
    "Bcolor": "76",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38111",
    "Farbtonhilfsbezeichnung": "Esche",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "145",
    "Bcolor": "69",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38148",
    "Farbtonhilfsbezeichnung": "Grau",
    "Farbtonklasse": "01",
    "Rcolor": "150",
    "Gcolor": "138",
    "Bcolor": "94",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38113",
    "Farbtonhilfsbezeichnung": "Kiefer",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "95",
    "Bcolor": "24",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38121",
    "Farbtonhilfsbezeichnung": "Mahagoni",
    "Farbtonklasse": "01",
    "Rcolor": "103",
    "Gcolor": "49",
    "Bcolor": "40",
    "Y": "9.23813003658294",
    "L": "36.4387921253532",
    "a": "12.1052886552342",
    "b": "7.19040389978112",
    "C": "14.079769943736",
    "h": "0.535987655234701",
    "CMY_C": "0.5746035",
    "CMY_M": "0.6920407",
    "CMY_Y": "0.7096009",
    "CMYK_C": "0",
    "CMYK_M": "0.2760653",
    "CMYK_Y": "0.3173449",
    "CMYK_K": "0.5746035"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38140",
    "Farbtonhilfsbezeichnung": "Nussbaum",
    "Farbtonklasse": "01",
    "Rcolor": "142",
    "Gcolor": "99",
    "Bcolor": "57",
    "Y": "9.23813003658294",
    "L": "36.4387921253532",
    "a": "12.1052886552342",
    "b": "7.19040389978112",
    "C": "14.079769943736",
    "h": "0.535987655234701",
    "CMY_C": "0.5746035",
    "CMY_M": "0.6920407",
    "CMY_Y": "0.7096009",
    "CMYK_C": "0",
    "CMYK_M": "0.2760653",
    "CMYK_Y": "0.3173449",
    "CMYK_K": "0.5746035"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38110",
    "Farbtonhilfsbezeichnung": "Palisander",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "91",
    "Bcolor": "71",
    "Y": "9.23813003658294",
    "L": "36.4387921253532",
    "a": "12.1052886552342",
    "b": "7.19040389978112",
    "C": "14.079769943736",
    "h": "0.535987655234701",
    "CMY_C": "0.5746035",
    "CMY_M": "0.6920407",
    "CMY_Y": "0.7096009",
    "CMYK_C": "0",
    "CMYK_M": "0.2760653",
    "CMYK_Y": "0.3173449",
    "CMYK_K": "0.5746035"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38147",
    "Farbtonhilfsbezeichnung": "Teak",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "66",
    "Bcolor": "24",
    "Y": "9.23813003658294",
    "L": "36.4387921253532",
    "a": "12.1052886552342",
    "b": "7.19040389978112",
    "C": "14.079769943736",
    "h": "0.535987655234701",
    "CMY_C": "0.5746035",
    "CMY_M": "0.6920407",
    "CMY_Y": "0.7096009",
    "CMYK_C": "0",
    "CMYK_M": "0.2760653",
    "CMYK_Y": "0.3173449",
    "CMYK_K": "0.5746035"
  },
  {
    "Farbtonkarten_Bezeichnung": "Lasuren",
    "Farbton_ID": "38149",
    "Farbtonhilfsbezeichnung": "Weiss",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "164",
    "Bcolor": "144",
    "Y": "29.739425814724",
    "L": "61.4287382663789",
    "a": "0.0952187737711663",
    "b": "14.1423238101794",
    "C": "14.1426443555244",
    "h": "1.56406353406059",
    "CMY_C": "0.3789806",
    "CMY_M": "0.4216477",
    "CMY_Y": "0.5198662",
    "CMYK_C": "0",
    "CMYK_M": "0.06870494",
    "CMYK_Y": "0.2268618",
    "CMYK_K": "0.3789806"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "37207",
    "Farbtonhilfsbezeichnung": "Apollo",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "219",
    "Y": "87",
    "L": "94.7523956298828",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si D6.21.20",
    "Farbtonhilfsbezeichnung": "Arabica",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "60",
    "Bcolor": "47",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si H2.30.60",
    "Farbtonhilfsbezeichnung": "Asian Dream",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "167",
    "Bcolor": "99",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "31431",
    "Farbtonhilfsbezeichnung": "Cappuccino",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "124",
    "Bcolor": "108",
    "Y": "20.89151464",
    "L": "52.83055928",
    "a": "3.183586874",
    "b": "10.28849198",
    "C": "10.7697861",
    "h": "1.270709098",
    "CMY_C": "0.456569",
    "CMY_M": "0.5145835",
    "CMY_Y": "0.5773685",
    "CMYK_C": "0",
    "CMYK_M": "0.106756",
    "CMYK_Y": "0.2222904",
    "CMYK_K": "0.456569"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si Y5.06.23",
    "Farbtonhilfsbezeichnung": "Club",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "58",
    "Bcolor": "66",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "03.03.18",
    "Farbtonhilfsbezeichnung": "Empire",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "141",
    "Bcolor": "131",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si U5.14.69",
    "Farbtonhilfsbezeichnung": "France",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "187",
    "Bcolor": "219",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "35403",
    "Farbtonhilfsbezeichnung": "Frio",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "186",
    "Bcolor": "189",
    "Y": "43.24842608",
    "L": "71.7232591",
    "a": "-17.91185078",
    "b": "-8.517478587",
    "C": "19.8338559",
    "h": "0.4438741317",
    "CMY_C": "0.503079",
    "CMY_M": "0.270947",
    "CMY_Y": "0.25831",
    "CMYK_C": "0.3300152",
    "CMYK_M": "0.017038",
    "CMYK_Y": "0",
    "CMYK_K": "0.25831"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si Z8.10.40",
    "Farbtonhilfsbezeichnung": "Geheimnisvoll",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "103",
    "Bcolor": "110",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "33414",
    "Farbtonhilfsbezeichnung": "Gentle Rose",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "182",
    "Bcolor": "188",
    "Y": "51.01929735",
    "L": "76.69069679",
    "a": "11.36825609",
    "b": "-0.138972085",
    "C": "11.3691055",
    "h": "-0.012223965",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "31111",
    "Farbtonhilfsbezeichnung": "Grassland",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "194",
    "Bcolor": "122",
    "Y": "53.54034595",
    "L": "78.19294601",
    "a": "-5.259866596",
    "b": "37.3546189",
    "C": "37.72311956",
    "h": "-1.430907024",
    "CMY_C": "0.1858538",
    "CMY_M": "0.2375184",
    "CMY_Y": "0.5209216",
    "CMYK_C": "0",
    "CMYK_M": "0.06345866",
    "CMYK_Y": "0.4115573",
    "CMYK_K": "0.1858538"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si F2.41.78",
    "Farbtonhilfsbezeichnung": "Honig-Gelb",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "199",
    "Bcolor": "96",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "27.21.24",
    "Farbtonhilfsbezeichnung": "Hot-Salsa",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "27",
    "Bcolor": "38",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "27.21.27",
    "Farbtonhilfsbezeichnung": "Kirsche",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "17",
    "Bcolor": "27",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "32401",
    "Farbtonhilfsbezeichnung": "Koralle",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "102",
    "Bcolor": "77",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "35400",
    "Farbtonhilfsbezeichnung": "Lagunada",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "125",
    "Bcolor": "129",
    "Y": "16.52884563",
    "L": "47.66081053",
    "a": "-23.27062119",
    "b": "-10.67441929",
    "C": "25.60205144",
    "h": "0.4300718302",
    "CMY_C": "0.8554659",
    "CMY_M": "0.5116861",
    "CMY_Y": "0.4929437",
    "CMYK_C": "0.7149547",
    "CMYK_M": "0.036963",
    "CMYK_Y": "0",
    "CMYK_K": "0.4929437"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si Z9.37.33",
    "Farbtonhilfsbezeichnung": "Lavendeltraum",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "61",
    "Bcolor": "95",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "32100",
    "Farbtonhilfsbezeichnung": "Namib",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "137",
    "Bcolor": "62",
    "Y": "23",
    "L": "55.2288818359375",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Scala 21.18.18",
    "Farbtonhilfsbezeichnung": "Naranja",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "128",
    "Bcolor": "37",
    "Y": "52.82567422",
    "L": "77.77196255",
    "a": "18.72319308",
    "b": "36.85155943",
    "C": "41.33515926",
    "h": "1.100713121",
    "CMY_C": "0.03737465",
    "CMY_M": "0.3015606",
    "CMY_Y": "0.5155492",
    "CMYK_C": "0",
    "CMYK_M": "0.2744431",
    "CMYK_Y": "0.4967401",
    "CMYK_K": "0.03737465"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "37100",
    "Farbtonhilfsbezeichnung": "Panteras",
    "Farbtonklasse": "02",
    "Rcolor": "55",
    "Gcolor": "61",
    "Bcolor": "61",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "3.381432097",
    "b": "46.37467782",
    "C": "46.49779378",
    "h": "1.498009654",
    "CMY_C": "0.0319899",
    "CMY_M": "0.1821529",
    "CMY_Y": "0.5162738",
    "CMYK_C": "0",
    "CMYK_M": "0.1551254",
    "CMYK_Y": "0.5002881",
    "CMYK_K": "0.0319899"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "32235",
    "Farbtonhilfsbezeichnung": "Playa",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "193",
    "Bcolor": "181",
    "Y": "54.64546623",
    "L": "78.83661284",
    "a": "3.175614986",
    "b": "7.136727083",
    "C": "7.811363773",
    "h": "1.152134909",
    "CMY_C": "0.1890057",
    "CMY_M": "0.2436309",
    "CMY_Y": "0.2915026",
    "CMYK_C": "0",
    "CMYK_M": "0.06735585",
    "CMYK_Y": "0.1263842",
    "CMYK_K": "0.1890057"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "35432",
    "Farbtonhilfsbezeichnung": "Rocket Blue",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "167",
    "Bcolor": "171",
    "Y": "36.74969214",
    "L": "67.08881356",
    "a": "-6.372630428",
    "b": "-5.252371407",
    "C": "8.25819738",
    "h": "0.689328461",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "33407",
    "Farbtonhilfsbezeichnung": "Rose",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "203",
    "Bcolor": "207",
    "Y": "64.02224894",
    "L": "83.9773523",
    "a": "9.766347802",
    "b": "0.4530194452",
    "C": "9.776848982",
    "h": "0.04635253237",
    "CMY_C": "0.1038418",
    "CMY_M": "0.2021859",
    "CMY_Y": "0.187063",
    "CMYK_C": "0",
    "CMYK_M": "0.1097397",
    "CMYK_Y": "0.09286433",
    "CMYK_K": "0.1038418"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "90.15.09",
    "Farbtonhilfsbezeichnung": "Spring",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "224",
    "Bcolor": "89",
    "Y": "62.1492729187012",
    "L": "82.9927368164063",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "35302",
    "Farbtonhilfsbezeichnung": "Swim",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "162",
    "Bcolor": "185",
    "Y": "65.35116744",
    "L": "84.66436832",
    "a": "-5.931802501",
    "b": "-9.230871607",
    "C": "10.97247791",
    "h": "0.999637413",
    "CMY_C": "0.2557528",
    "CMY_M": "0.1545365",
    "CMY_Y": "0.1110712",
    "CMYK_C": "0.1627595",
    "CMYK_M": "0.04889632",
    "CMYK_Y": "0",
    "CMYK_K": "0.1110712"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "31415",
    "Farbtonhilfsbezeichnung": "True-Nature",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "228",
    "Bcolor": "202",
    "Y": "79.13713545",
    "L": "91.29630457",
    "a": "1.531392196",
    "b": "14.05085924",
    "C": "14.1340655",
    "h": "1.462235605",
    "CMY_C": "0.04293652",
    "CMY_M": "0.1047889",
    "CMY_Y": "0.208833",
    "CMYK_C": "0",
    "CMYK_M": "0.06462728",
    "CMYK_Y": "0.1733391",
    "CMYK_K": "0.04293652"
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "36110",
    "Farbtonhilfsbezeichnung": "Velvet Green",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "150",
    "Bcolor": "131",
    "Y": "27.57582778",
    "L": "59.50357381",
    "a": "-12.84480089",
    "b": "6.163440128",
    "C": "14.24699632",
    "h": "-0.44738935",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "33133",
    "Farbtonhilfsbezeichnung": "Warm Sandalwood",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "159",
    "Bcolor": "156",
    "Y": "35.22076413",
    "L": "65.92018301",
    "a": "2.838664432",
    "b": "1.838316723",
    "C": "3.381926098",
    "h": "0.574685613",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Trendfarben",
    "Farbton_ID": "Si P0.17.41",
    "Farbtonhilfsbezeichnung": "Xian",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "117",
    "Bcolor": "115",
    "Y": "15",
    "L": "46.5874841326656",
    "a": "",
    "b": "",
    "C": "",
    "h": "",
    "CMY_C": "",
    "CMY_M": "",
    "CMY_Y": "",
    "CMYK_C": "",
    "CMYK_M": "",
    "CMYK_Y": "",
    "CMYK_K": ""
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16000",
    "Farbtonhilfsbezeichnung": "16000",
    "Farbtonklasse": "00",
    "Rcolor": "241",
    "Gcolor": "235",
    "Bcolor": "223",
    "Y": 84,
    "L": 93.2363510131836,
    "a": 0.46531543135643,
    "b": 5.4931058883667,
    "C": 5.51277875900269,
    "h": 85.1580963134766,
    "CMY_C": 0.05432212352753,
    "CMY_M": 0.07828497886658,
    "CMY_Y": 0.12410908937454,
    "CMYK_C": 0,
    "CMYK_M": 0.02533934265375,
    "CMYK_Y": 0.07379570603371,
    "CMYK_K": 0.05432212352753
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16001",
    "Farbtonhilfsbezeichnung": "16001",
    "Farbtonklasse": "00",
    "Rcolor": "241",
    "Gcolor": "237",
    "Bcolor": "227",
    "Y": 85,
    "L": 93.9351806640625,
    "a": -0.05066162347794,
    "b": 4.33750867843628,
    "C": 4.33780431747437,
    "h": 90.6691741943359,
    "CMY_C": 0.05419343709946,
    "CMY_M": 0.06889665126801,
    "CMY_Y": 0.10785353183746,
    "CMYK_C": 0,
    "CMYK_M": 0.01554568856955,
    "CMYK_Y": 0.05673474445939,
    "CMYK_K": 0.05419343709946
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16002",
    "Farbtonhilfsbezeichnung": "16002",
    "Farbtonklasse": "00",
    "Rcolor": "241",
    "Gcolor": "240",
    "Bcolor": "230",
    "Y": 87,
    "L": 94.5640106201172,
    "a": -0.73135071992874,
    "b": 4.07734775543213,
    "C": 4.14241933822632,
    "h": 100.168968200684,
    "CMY_C": 0.0533213019371,
    "CMY_M": 0.06013691425323,
    "CMY_Y": 0.0990469455719,
    "CMYK_C": 0,
    "CMYK_M": 0.00719949882478,
    "CMYK_Y": 0.04830112308264,
    "CMYK_K": 0.0533213019371
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16003",
    "Farbtonhilfsbezeichnung": "16003",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.5777206420898,
    "a": -0.34485912322998,
    "b": 5.29832029342651,
    "C": 5.30953168869019,
    "h": 93.7240371704102,
    "CMY_C": 0.05740702152252,
    "CMY_M": 0.07246834039688,
    "CMY_Y": 0.11901098489761,
    "CMYK_C": 0,
    "CMYK_M": 0.01597860269248,
    "CMYK_Y": 0.0653558447957,
    "CMYK_K": 0.05740702152252
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16004",
    "Farbtonhilfsbezeichnung": "16004",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "231",
    "Bcolor": "222",
    "Y": 79,
    "L": 91.3862533569336,
    "a": -0.70232200622559,
    "b": 3.34000396728516,
    "C": 3.41304588317871,
    "h": 101.87491607666,
    "CMY_C": 0.09115701913834,
    "CMY_M": 0.09559714794159,
    "CMY_Y": 0.12866723537445,
    "CMYK_C": 0,
    "CMYK_M": 0.00488547421992,
    "CMYK_Y": 0.04127249494195,
    "CMYK_K": 0.09115701913834
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16005",
    "Farbtonhilfsbezeichnung": "16005",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "235",
    "Bcolor": "228",
    "Y": 83,
    "L": 92.7179412841797,
    "a": -1.68446803092957,
    "b": 2.2709493637085,
    "C": 2.82748007774353,
    "h": 126.566040039063,
    "CMY_C": 0.08765077590942,
    "CMY_M": 0.07809269428253,
    "CMY_Y": 0.10616540908813,
    "CMYK_C": 0.01036772504449,
    "CMYK_M": 0,
    "CMYK_Y": 0.03045069053769,
    "CMYK_K": 0.07809269428253
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16006",
    "Farbtonhilfsbezeichnung": "16006",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "192",
    "Bcolor": "76",
    "Y": 57,
    "L": 79.9495162963867,
    "a": 5.22688579559326,
    "b": 61.9634208679199,
    "C": 62.1834869384766,
    "h": 85.1782608032227,
    "CMY_C": 0.06353467702866,
    "CMY_M": 0.2465643286705,
    "CMY_Y": 0.70124518871307,
    "CMYK_C": 0,
    "CMYK_M": 0.19544734060764,
    "CMYK_Y": 0.6809760928154,
    "CMYK_K": 0.06353467702866
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16007",
    "Farbtonhilfsbezeichnung": "16007",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "209",
    "Bcolor": "112",
    "Y": 67,
    "L": 85.045166015625,
    "a": 1.56081652641296,
    "b": 51.6570243835449,
    "C": 51.6805992126465,
    "h": 88.2693328857422,
    "CMY_C": 0.03901785612106,
    "CMY_M": 0.18110620975494,
    "CMY_Y": 0.56153011322021,
    "CMYK_C": 0,
    "CMYK_M": 0.14785742759705,
    "CMYK_Y": 0.54372733831406,
    "CMYK_K": 0.03901785612106
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16008",
    "Farbtonhilfsbezeichnung": "16008",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "227",
    "Bcolor": "156",
    "Y": 78,
    "L": 90.5257797241211,
    "a": -1.28398203849792,
    "b": 36.5411491394043,
    "C": 36.5637016296387,
    "h": 92.0124282836914,
    "CMY_C": 0.01955890655518,
    "CMY_M": 0.11144298315048,
    "CMY_Y": 0.38689029216766,
    "CMYK_C": 0,
    "CMYK_M": 0.09371708333492,
    "CMYK_Y": 0.37465929985046,
    "CMYK_K": 0.01955890655518
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16009",
    "Farbtonhilfsbezeichnung": "16009",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "239",
    "Bcolor": "205",
    "Y": 86,
    "L": 94.3384704589844,
    "a": -1.77048528194427,
    "b": 16.8386192321777,
    "C": 16.9314422607422,
    "h": 96.0022735595703,
    "CMY_C": 0.02541810274124,
    "CMY_M": 0.06350350379944,
    "CMY_Y": 0.1972159743309,
    "CMYK_C": 0,
    "CMYK_M": 0.03907870873809,
    "CMYK_Y": 0.17627853155136,
    "CMYK_K": 0.02541810274124
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16010",
    "Farbtonhilfsbezeichnung": "16010",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "197",
    "Bcolor": "121",
    "Y": 57,
    "L": 80.9932098388672,
    "a": 3.91949892044067,
    "b": 41.7734298706055,
    "C": 41.9569053649902,
    "h": 84.6397705078125,
    "CMY_C": 0.08549404144287,
    "CMY_M": 0.22933161258698,
    "CMY_Y": 0.52406257390976,
    "CMYK_C": 0,
    "CMYK_M": 0.15728445351124,
    "CMYK_Y": 0.47956880927086,
    "CMYK_K": 0.08549404144287
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16011",
    "Farbtonhilfsbezeichnung": "16011",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "219",
    "Bcolor": "164",
    "Y": 71,
    "L": 88.1427459716797,
    "a": 1.01124536991119,
    "b": 29.2499408721924,
    "C": 29.2674160003662,
    "h": 88.0199203491211,
    "CMY_C": 0.04582566022873,
    "CMY_M": 0.14189726114273,
    "CMY_Y": 0.35604214668274,
    "CMYK_C": 0,
    "CMYK_M": 0.1006855815649,
    "CMYK_Y": 0.32511511445045,
    "CMYK_K": 0.04582566022873
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16012",
    "Farbtonhilfsbezeichnung": "16012",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "232",
    "Bcolor": "194",
    "Y": 80,
    "L": 92.1498947143555,
    "a": -0.29881596565247,
    "b": 19.2915668487549,
    "C": 19.2938804626465,
    "h": 90.8874053955078,
    "CMY_C": 0.03282797336578,
    "CMY_M": 0.09209698438644,
    "CMY_Y": 0.23903304338455,
    "CMYK_C": 0,
    "CMYK_M": 0.06128073483706,
    "CMYK_Y": 0.21320413053036,
    "CMYK_K": 0.03282797336578
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16013",
    "Farbtonhilfsbezeichnung": "16013",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "172",
    "Bcolor": "98",
    "Y": 45,
    "L": 72.7915191650391,
    "a": 7.25858068466187,
    "b": 43.0732803344727,
    "C": 43.6805953979492,
    "h": 80.4345550537109,
    "CMY_C": 0.15695887804031,
    "CMY_M": 0.3253031373024,
    "CMY_Y": 0.61536782979965,
    "CMYK_C": 0,
    "CMYK_M": 0.19968688488007,
    "CMYK_Y": 0.54375636577606,
    "CMYK_K": 0.15695887804031
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16014",
    "Farbtonhilfsbezeichnung": "16014",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "181",
    "Bcolor": "141",
    "Y": 48,
    "L": 74.7021026611328,
    "a": 2.60448169708252,
    "b": 22.8426513671875,
    "C": 22.9906520843506,
    "h": 83.4953231811523,
    "CMY_C": 0.19976836442947,
    "CMY_M": 0.29024618864059,
    "CMY_Y": 0.44753170013428,
    "CMYK_C": 0,
    "CMYK_M": 0.11306454241276,
    "CMYK_Y": 0.3096145093441,
    "CMYK_K": 0.19976836442947
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16015",
    "Farbtonhilfsbezeichnung": "16015",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "212",
    "Bcolor": "185",
    "Y": 67,
    "L": 85.3026580810547,
    "a": 0.88568043708801,
    "b": 14.3645629882813,
    "C": 14.3918418884277,
    "h": 86.4717559814453,
    "CMY_C": 0.11423498392105,
    "CMY_M": 0.16956955194473,
    "CMY_Y": 0.27564966678619,
    "CMYK_C": 0,
    "CMYK_M": 0.06247093528509,
    "CMYK_Y": 0.18223194777966,
    "CMYK_K": 0.11423498392105
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16016",
    "Farbtonhilfsbezeichnung": "16016",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "145",
    "Bcolor": "118",
    "Y": 30,
    "L": 61.0718879699707,
    "a": 2.86208581924438,
    "b": 16.079833984375,
    "C": 16.3325634002686,
    "h": 79.9074859619141,
    "CMY_C": 0.36002713441849,
    "CMY_M": 0.43188768625259,
    "CMY_Y": 0.53628158569336,
    "CMYK_C": 0,
    "CMYK_M": 0.11228687316179,
    "CMYK_Y": 0.27540925145149,
    "CMYK_K": 0.36002713441849
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16017",
    "Farbtonhilfsbezeichnung": "16017",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "188",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.8132934570313,
    "a": 1.99930381774902,
    "b": 11.8588371276856,
    "C": 12.0261898040772,
    "h": 80.4303894042969,
    "CMY_C": 0.20667624473572,
    "CMY_M": 0.26378703117371,
    "CMY_Y": 0.34688252210617,
    "CMYK_C": 0,
    "CMYK_M": 0.07198925316334,
    "CMYK_Y": 0.17673273384571,
    "CMYK_K": 0.20667624473572
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16018",
    "Farbtonhilfsbezeichnung": "16018",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "230",
    "Bcolor": "219",
    "Y": 80,
    "L": 91.3936614990234,
    "a": 0.78004986047745,
    "b": 5.05819797515869,
    "C": 5.11799240112305,
    "h": 81.2331924438477,
    "CMY_C": 0.07397097349167,
    "CMY_M": 0.09951430559158,
    "CMY_Y": 0.14111107587814,
    "CMYK_C": 0,
    "CMYK_M": 0.02758372761309,
    "CMYK_Y": 0.0725032389164,
    "CMYK_K": 0.07397097349167
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16019",
    "Farbtonhilfsbezeichnung": "16019",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "176",
    "Bcolor": "72",
    "Y": 50,
    "L": 75.8966064453125,
    "a": 12.9478569030762,
    "b": 59.3682479858398,
    "C": 60.7637710571289,
    "h": 77.6967926025391,
    "CMY_C": 0.06761401891708,
    "CMY_M": 0.30916631221771,
    "CMY_Y": 0.71643483638763,
    "CMYK_C": 0,
    "CMYK_M": 0.25906899571419,
    "CMYK_Y": 0.6958714723587,
    "CMYK_K": 0.06761401891708
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16020",
    "Farbtonhilfsbezeichnung": "16020",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "199",
    "Bcolor": "116",
    "Y": 61,
    "L": 82.4767456054688,
    "a": 6.52038621902466,
    "b": 46.3039665222168,
    "C": 46.7608032226563,
    "h": 81.9844818115234,
    "CMY_C": 0.04468470811844,
    "CMY_M": 0.22041290998459,
    "CMY_Y": 0.54350554943085,
    "CMYK_C": 0,
    "CMYK_M": 0.18394786119461,
    "CMYK_Y": 0.52215307950974,
    "CMYK_K": 0.04468470811844
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16021",
    "Farbtonhilfsbezeichnung": "16021",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "219",
    "Bcolor": "159",
    "Y": 74,
    "L": 88.6328659057617,
    "a": 2.60913991928101,
    "b": 32.8749313354492,
    "C": 32.9783058166504,
    "h": 85.4621963500977,
    "CMY_C": 0.02170526981354,
    "CMY_M": 0.14107441902161,
    "CMY_Y": 0.37791937589645,
    "CMYK_C": 0,
    "CMYK_M": 0.12201756983995,
    "CMYK_Y": 0.36411738395691,
    "CMYK_K": 0.02170526981354
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16022",
    "Farbtonhilfsbezeichnung": "16022",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "236",
    "Bcolor": "205",
    "Y": 85,
    "L": 93.7091674804688,
    "a": -0.54591828584671,
    "b": 15.6550531387329,
    "C": 15.664568901062,
    "h": 91.9971923828125,
    "CMY_C": 0.02662152051926,
    "CMY_M": 0.07319456338882,
    "CMY_Y": 0.194973051548,
    "CMYK_C": 0,
    "CMYK_M": 0.04784679785371,
    "CMYK_Y": 0.17295588552952,
    "CMYK_K": 0.02662152051926
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16023",
    "Farbtonhilfsbezeichnung": "16023",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "216",
    "Bcolor": "173",
    "Y": 70,
    "L": 87.2225036621094,
    "a": 1.31884014606476,
    "b": 23.4402866363525,
    "C": 23.4773578643799,
    "h": 86.7797164916992,
    "CMY_C": 0.06701123714447,
    "CMY_M": 0.15156382322311,
    "CMY_Y": 0.32224309444427,
    "CMYK_C": 0,
    "CMYK_M": 0.09062551707029,
    "CMYK_Y": 0.27356371283531,
    "CMYK_K": 0.06701123714447
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16024",
    "Farbtonhilfsbezeichnung": "16024",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "190",
    "Y": 81,
    "L": 91.880615234375,
    "a": 0.77024382352829,
    "b": 20.8202953338623,
    "C": 20.8345375061035,
    "h": 87.8813171386719,
    "CMY_C": 0.02421379089355,
    "CMY_M": 0.09802103042603,
    "CMY_Y": 0.25318902730942,
    "CMYK_C": 0,
    "CMYK_M": 0.07563874125481,
    "CMYK_Y": 0.23465718328953,
    "CMYK_K": 0.02421379089355
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16025",
    "Farbtonhilfsbezeichnung": "16025",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "195",
    "Bcolor": "148",
    "Y": 56,
    "L": 79.8778457641602,
    "a": 3.25706171989441,
    "b": 26.5556221008301,
    "C": 26.7546157836914,
    "h": 83.0075607299805,
    "CMY_C": 0.12987726926804,
    "CMY_M": 0.2370143532753,
    "CMY_Y": 0.42147541046143,
    "CMYK_C": 0,
    "CMYK_M": 0.1231287047267,
    "CMYK_Y": 0.33512300252914,
    "CMYK_K": 0.12987726926804
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16026",
    "Farbtonhilfsbezeichnung": "16026",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "215",
    "Bcolor": "181",
    "Y": 69,
    "L": 86.5390853881836,
    "a": 1.09558832645416,
    "b": 17.9378395080566,
    "C": 17.9712657928467,
    "h": 86.5048904418945,
    "CMY_C": 0.0896030664444,
    "CMY_M": 0.15731978416443,
    "CMY_Y": 0.28875869512558,
    "CMYK_C": 0,
    "CMYK_M": 0.07438153028488,
    "CMYK_Y": 0.21875691413879,
    "CMYK_K": 0.0896030664444
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16027",
    "Farbtonhilfsbezeichnung": "16027",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "230",
    "Bcolor": "203",
    "Y": 80,
    "L": 91.6226043701172,
    "a": 0.92050278186798,
    "b": 13.7620162963867,
    "C": 13.7927665710449,
    "h": 86.1733474731445,
    "CMY_C": 0.04455500841141,
    "CMY_M": 0.09957140684128,
    "CMY_Y": 0.20324617624283,
    "CMYK_C": 0,
    "CMYK_M": 0.05758196488023,
    "CMYK_Y": 0.16609136760235,
    "CMYK_K": 0.04455500841141
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16028",
    "Farbtonhilfsbezeichnung": "16028",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "181",
    "Bcolor": "95",
    "Y": 52,
    "L": 77.3703079223633,
    "a": 11.991289138794,
    "b": 50.8057861328125,
    "C": 52.2017135620117,
    "h": 76.7199630737305,
    "CMY_C": 0.06487780809402,
    "CMY_M": 0.28990364074707,
    "CMY_Y": 0.6292097568512,
    "CMYK_C": 0,
    "CMYK_M": 0.24063789844513,
    "CMYK_Y": 0.60348469018936,
    "CMYK_K": 0.06487780809402
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16029",
    "Farbtonhilfsbezeichnung": "16029",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "199",
    "Bcolor": "129",
    "Y": 62,
    "L": 82.6638870239258,
    "a": 7.30016374588013,
    "b": 40.2945747375488,
    "C": 40.9505195617676,
    "h": 79.7311172485352,
    "CMY_C": 0.04652923345566,
    "CMY_M": 0.21935737133026,
    "CMY_Y": 0.49486023187637,
    "CMYK_C": 0,
    "CMYK_M": 0.18126212060452,
    "CMYK_Y": 0.47020947933197,
    "CMYK_K": 0.04652923345566
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16030",
    "Farbtonhilfsbezeichnung": "16030",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "216",
    "Bcolor": "163",
    "Y": 72,
    "L": 87.7165298461914,
    "a": 4.12547397613525,
    "b": 29.2351207733154,
    "C": 29.5247669219971,
    "h": 81.9678192138672,
    "CMY_C": 0.0291942358017,
    "CMY_M": 0.15416443347931,
    "CMY_Y": 0.35977357625961,
    "CMYK_C": 0,
    "CMYK_M": 0.12872831523418,
    "CMYK_Y": 0.34052059054375,
    "CMYK_K": 0.0291942358017
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16031",
    "Farbtonhilfsbezeichnung": "16031",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "231",
    "Bcolor": "196",
    "Y": 82,
    "L": 92.3220291137695,
    "a": 1.28533494472504,
    "b": 18.7147998809814,
    "C": 18.7588863372803,
    "h": 86.0710830688477,
    "CMY_C": 0.02073806524277,
    "CMY_M": 0.09385055303574,
    "CMY_Y": 0.23258715867996,
    "CMYK_C": 0,
    "CMYK_M": 0.07466080784798,
    "CMYK_Y": 0.21633547544479,
    "CMYK_K": 0.02073806524277
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16032",
    "Farbtonhilfsbezeichnung": "16032",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "232",
    "Bcolor": "217",
    "Y": 83,
    "L": 92.4927825927734,
    "a": 0.91244077682495,
    "b": 7.69141626358032,
    "C": 7.74534893035889,
    "h": 83.2345657348633,
    "CMY_C": 0.0524178147316,
    "CMY_M": 0.08827233314514,
    "CMY_Y": 0.14858305454254,
    "CMYK_C": 0,
    "CMYK_M": 0.03783790022135,
    "CMYK_Y": 0.1014848574996,
    "CMYK_K": 0.0524178147316
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16033",
    "Farbtonhilfsbezeichnung": "16033",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "187",
    "Bcolor": "137",
    "Y": 53,
    "L": 77.7387084960938,
    "a": 5.57642650604248,
    "b": 29.0396003723145,
    "C": 29.5701694488525,
    "h": 79.1299057006836,
    "CMY_C": 0.13370591402054,
    "CMY_M": 0.26614665985107,
    "CMY_Y": 0.46115255355835,
    "CMYK_C": 0,
    "CMYK_M": 0.15288196504116,
    "CMYK_Y": 0.37798553705215,
    "CMYK_K": 0.13370591402054
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16034",
    "Farbtonhilfsbezeichnung": "16034",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "167",
    "Bcolor": "142",
    "Y": 40,
    "L": 69.6819000244141,
    "a": 3.33061909675598,
    "b": 15.2145290374756,
    "C": 15.5748167037964,
    "h": 77.6521377563477,
    "CMY_C": 0.266705930233,
    "CMY_M": 0.34345585107803,
    "CMY_Y": 0.44403314590454,
    "CMYK_C": 0,
    "CMYK_M": 0.10466458648443,
    "CMYK_Y": 0.24182279407978,
    "CMYK_K": 0.266705930233
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16035",
    "Farbtonhilfsbezeichnung": "16035",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "213",
    "Bcolor": "191",
    "Y": 68,
    "L": 85.9142456054688,
    "a": 1.47688543796539,
    "b": 12.1380014419556,
    "C": 12.227520942688,
    "h": 83.0626602172852,
    "CMY_C": 0.10910558700562,
    "CMY_M": 0.16370964050293,
    "CMY_Y": 0.25267750024796,
    "CMYK_C": 0,
    "CMYK_M": 0.06129127368331,
    "CMYK_Y": 0.16115480661392,
    "CMYK_K": 0.10910558700562
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16036",
    "Farbtonhilfsbezeichnung": "16036",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "168",
    "Bcolor": "102",
    "Y": 44,
    "L": 72.4031372070313,
    "a": 12.3624172210693,
    "b": 40.9384422302246,
    "C": 42.7643013000488,
    "h": 73.1969604492188,
    "CMY_C": 0.13305902481079,
    "CMY_M": 0.3419885635376,
    "CMY_Y": 0.60144579410553,
    "CMYK_C": 0,
    "CMYK_M": 0.24099627137184,
    "CMYK_Y": 0.54027527570724,
    "CMYK_K": 0.13305902481079
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16037",
    "Farbtonhilfsbezeichnung": "16037",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "182",
    "Bcolor": "128",
    "Y": 51,
    "L": 76.8203201293945,
    "a": 9.70259761810303,
    "b": 32.8797607421875,
    "C": 34.2814674377441,
    "h": 73.5590209960938,
    "CMY_C": 0.1107063293457,
    "CMY_M": 0.28697419166565,
    "CMY_Y": 0.49785304069519,
    "CMYK_C": 0,
    "CMYK_M": 0.19821108877659,
    "CMYK_Y": 0.43534180521965,
    "CMYK_K": 0.1107063293457
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16038",
    "Farbtonhilfsbezeichnung": "16038",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "196",
    "Bcolor": "151",
    "Y": 59,
    "L": 81.1834869384766,
    "a": 7.00376987457275,
    "b": 26.3780193328857,
    "C": 27.2919902801514,
    "h": 75.1301803588867,
    "CMY_C": 0.09030371904373,
    "CMY_M": 0.23202228546143,
    "CMY_Y": 0.40596514940262,
    "CMYK_C": 0,
    "CMYK_M": 0.155786678195,
    "CMYK_Y": 0.3469965159893,
    "CMYK_K": 0.09030371904373
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16039",
    "Farbtonhilfsbezeichnung": "16039",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "213",
    "Bcolor": "182",
    "Y": 69,
    "L": 86.4644241333008,
    "a": 3.91890740394592,
    "b": 17.7923889160156,
    "C": 18.2188625335693,
    "h": 77.5785140991211,
    "CMY_C": 0.07062727212906,
    "CMY_M": 0.16491985321045,
    "CMY_Y": 0.28799360990524,
    "CMYK_C": 0,
    "CMYK_M": 0.10145830363035,
    "CMYK_Y": 0.2338849902153,
    "CMYK_K": 0.07062727212906
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16040",
    "Farbtonhilfsbezeichnung": "16040",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "218",
    "Bcolor": "197",
    "Y": 71,
    "L": 87.4422760009766,
    "a": 1.52038049697876,
    "b": 10.9232692718506,
    "C": 11.0285701751709,
    "h": 82.076057434082,
    "CMY_C": 0.09508490562439,
    "CMY_M": 0.1466737985611,
    "CMY_Y": 0.22732371091843,
    "CMYK_C": 0,
    "CMYK_M": 0.05700964853168,
    "CMYK_Y": 0.14613392949104,
    "CMYK_K": 0.09508490562439
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16041",
    "Farbtonhilfsbezeichnung": "16041",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "161",
    "Bcolor": "117",
    "Y": 40,
    "L": 68.9007797241211,
    "a": 8.70387077331543,
    "b": 27.954553604126,
    "C": 29.2782249450684,
    "h": 72.7056045532227,
    "CMY_C": 0.21491396427155,
    "CMY_M": 0.36717802286148,
    "CMY_Y": 0.54139059782028,
    "CMYK_C": 0,
    "CMYK_M": 0.19394569098949,
    "CMYK_Y": 0.41584822535515,
    "CMYK_K": 0.21491396427155
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16042",
    "Farbtonhilfsbezeichnung": "16042",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "191",
    "Bcolor": "159",
    "Y": 55,
    "L": 79.0248107910156,
    "a": 6.15873765945435,
    "b": 19.5140476226807,
    "C": 20.4628467559814,
    "h": 72.4840240478516,
    "CMY_C": 0.13482511043549,
    "CMY_M": 0.25176024436951,
    "CMY_Y": 0.37835115194321,
    "CMYK_C": 0,
    "CMYK_M": 0.1351577937603,
    "CMYK_Y": 0.28147608041763,
    "CMYK_K": 0.13482511043549
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16043",
    "Farbtonhilfsbezeichnung": "16043",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "179",
    "Bcolor": "149",
    "Y": 48,
    "L": 74.5190811157227,
    "a": 5.33810806274414,
    "b": 18.0874347686768,
    "C": 18.8587036132813,
    "h": 73.5571975708008,
    "CMY_C": 0.19369870424271,
    "CMY_M": 0.29769384860992,
    "CMY_Y": 0.41471779346466,
    "CMYK_C": 0,
    "CMYK_M": 0.12897801399231,
    "CMYK_Y": 0.27411475777626,
    "CMYK_K": 0.19369870424271
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16044",
    "Farbtonhilfsbezeichnung": "16044",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "193",
    "Y": 66,
    "L": 84.8099136352539,
    "a": 2.23598527908325,
    "b": 9.07184505462646,
    "C": 9.34333992004395,
    "h": 76.1539840698242,
    "CMY_C": 0.12441694736481,
    "CMY_M": 0.17687159776688,
    "CMY_Y": 0.24194842576981,
    "CMYK_C": 0,
    "CMYK_M": 0.05990825220942,
    "CMYK_Y": 0.13423223793507,
    "CMYK_K": 0.12441694736481
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16045",
    "Farbtonhilfsbezeichnung": "16045",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "146",
    "Bcolor": "128",
    "Y": 30,
    "L": 61.4346199035645,
    "a": 3.65254592895508,
    "b": 10.824875831604,
    "C": 11.4244928359985,
    "h": 71.3544998168945,
    "CMY_C": 0.36294597387314,
    "CMY_M": 0.42882466316223,
    "CMY_Y": 0.49645209312439,
    "CMYK_C": 0,
    "CMYK_M": 0.10341146588326,
    "CMYK_Y": 0.209567964077,
    "CMYK_K": 0.36294597387314
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16046",
    "Farbtonhilfsbezeichnung": "16046",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "166",
    "Bcolor": "151",
    "Y": 39,
    "L": 69.1984481811523,
    "a": 3.3804075717926,
    "b": 9.29950904846191,
    "C": 9.89484882354736,
    "h": 70.0235977172852,
    "CMY_C": 0.28613471984863,
    "CMY_M": 0.34727150201797,
    "CMY_Y": 0.40737944841385,
    "CMYK_C": 0,
    "CMYK_M": 0.0856419056654,
    "CMYK_Y": 0.16984258592129,
    "CMYK_K": 0.28613471984863
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16047",
    "Farbtonhilfsbezeichnung": "16047",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "189",
    "Bcolor": "174",
    "Y": 52,
    "L": 77.2086639404297,
    "a": 2.28749060630798,
    "b": 8.42503547668457,
    "C": 8.73005390167236,
    "h": 74.8097610473633,
    "CMY_C": 0.20959013700485,
    "CMY_M": 0.25936758518219,
    "CMY_Y": 0.3180775642395,
    "CMYK_C": 0,
    "CMYK_M": 0.06297675520182,
    "CMYK_Y": 0.13725464046001,
    "CMYK_K": 0.20959013700485
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16048",
    "Farbtonhilfsbezeichnung": "16048",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "204",
    "Bcolor": "192",
    "Y": 62,
    "L": 82.4778060913086,
    "a": 2.02130150794983,
    "b": 6.32921171188354,
    "C": 6.6441388130188,
    "h": 72.2885665893555,
    "CMY_C": 0.15979635715485,
    "CMY_M": 0.20114570856094,
    "CMY_Y": 0.24702566862106,
    "CMYK_C": 0,
    "CMYK_M": 0.04921348765492,
    "CMYK_Y": 0.10381925106049,
    "CMYK_K": 0.15979635715485
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16049",
    "Farbtonhilfsbezeichnung": "16049",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "223",
    "Bcolor": "213",
    "Y": 74,
    "L": 88.9641799926758,
    "a": 1.00522685050964,
    "b": 4.91844320297241,
    "C": 5.02011585235596,
    "h": 78.4490203857422,
    "CMY_C": 0.09985148906708,
    "CMY_M": 0.12702810764313,
    "CMY_Y": 0.16665822267532,
    "CMYK_C": 0,
    "CMYK_M": 0.03019126132131,
    "CMYK_Y": 0.07421745359898,
    "CMYK_K": 0.09985148906708
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16050",
    "Farbtonhilfsbezeichnung": "16050",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "142",
    "Bcolor": "65",
    "Y": 34,
    "L": 64.8977737426758,
    "a": 20.8361568450928,
    "b": 50.4359664916992,
    "C": 54.5704345703125,
    "h": 67.5534515380859,
    "CMY_C": 0.16118723154068,
    "CMY_M": 0.44423896074295,
    "CMY_Y": 0.7466744184494,
    "CMYK_C": 0,
    "CMYK_M": 0.33744326233864,
    "CMYK_Y": 0.69799506664276,
    "CMYK_K": 0.16118723154068
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16051",
    "Farbtonhilfsbezeichnung": "16051",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "177",
    "Bcolor": "114",
    "Y": 51,
    "L": 75.7484359741211,
    "a": 12.4059925079346,
    "b": 38.9849166870117,
    "C": 40.9112739562988,
    "h": 72.3476028442383,
    "CMY_C": 0.09670031070709,
    "CMY_M": 0.30642080307007,
    "CMY_Y": 0.55344676971436,
    "CMYK_C": 0,
    "CMYK_M": 0.2321715503931,
    "CMYK_Y": 0.50564223527908,
    "CMYK_K": 0.09670031070709
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16052",
    "Farbtonhilfsbezeichnung": "16052",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "208",
    "Bcolor": "164",
    "Y": 68,
    "L": 85.561408996582,
    "a": 6.52182865142822,
    "b": 26.0957202911377,
    "C": 26.898344039917,
    "h": 75.9680938720703,
    "CMY_C": 0.04408395290375,
    "CMY_M": 0.18311232328415,
    "CMY_Y": 0.3584458231926,
    "CMYK_C": 0,
    "CMYK_M": 0.14543993771076,
    "CMYK_Y": 0.32885929942131,
    "CMYK_K": 0.04408395290375
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16053",
    "Farbtonhilfsbezeichnung": "16053",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "237",
    "Bcolor": "215",
    "Y": 86,
    "L": 94.2204360961914,
    "a": 0.87132102251053,
    "b": 11.3252754211426,
    "C": 11.3587436676025,
    "h": 85.6005630493164,
    "CMY_C": 0.02238082885742,
    "CMY_M": 0.06978034973145,
    "CMY_Y": 0.15675663948059,
    "CMYK_C": 0,
    "CMYK_M": 0.0484846457839,
    "CMYK_Y": 0.13745209574699,
    "CMYK_K": 0.02238082885742
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16054",
    "Farbtonhilfsbezeichnung": "16054",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "145",
    "Bcolor": "94",
    "Y": 35,
    "L": 65.1906661987305,
    "a": 17.9476909637451,
    "b": 35.6966438293457,
    "C": 39.9545974731445,
    "h": 63.3074951171875,
    "CMY_C": 0.18989664316177,
    "CMY_M": 0.43102896213531,
    "CMY_Y": 0.63143241405487,
    "CMYK_C": 0,
    "CMYK_M": 0.29765623807907,
    "CMYK_Y": 0.54503631591797,
    "CMYK_K": 0.18989664316177
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16055",
    "Farbtonhilfsbezeichnung": "16055",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "163",
    "Bcolor": "119",
    "Y": 42,
    "L": 70.5817108154297,
    "a": 12.3187885284424,
    "b": 29.0160713195801,
    "C": 31.5227680206299,
    "h": 66.9963226318359,
    "CMY_C": 0.1717643737793,
    "CMY_M": 0.3589289188385,
    "CMY_Y": 0.53156369924545,
    "CMYK_C": 0,
    "CMYK_M": 0.225979834795,
    "CMYK_Y": 0.43441662192345,
    "CMYK_K": 0.1717643737793
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16056",
    "Farbtonhilfsbezeichnung": "16056",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "198",
    "Bcolor": "167",
    "Y": 61,
    "L": 81.9165344238281,
    "a": 7.27048826217651,
    "b": 19.2561664581299,
    "C": 20.5830020904541,
    "h": 69.3151321411133,
    "CMY_C": 0.09529238939285,
    "CMY_M": 0.22319096326828,
    "CMY_Y": 0.34612917900085,
    "CMYK_C": 0,
    "CMYK_M": 0.14137005805969,
    "CMYK_Y": 0.27725729346275,
    "CMYK_K": 0.09529238939285
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16057",
    "Farbtonhilfsbezeichnung": "16057",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "227",
    "Bcolor": "203",
    "Y": 80,
    "L": 91.2604064941406,
    "a": 3.89294075965881,
    "b": 13.3248271942139,
    "C": 13.8818588256836,
    "h": 73.7139053344727,
    "CMY_C": 0.02793103456497,
    "CMY_M": 0.11072689294815,
    "CMY_Y": 0.20343697071075,
    "CMYK_C": 0,
    "CMYK_M": 0.08517488092184,
    "CMYK_Y": 0.18054884672165,
    "CMYK_K": 0.02793103456497
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16058",
    "Farbtonhilfsbezeichnung": "16058",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "146",
    "Bcolor": "106",
    "Y": 33,
    "L": 64.2853851318359,
    "a": 13.3525772094727,
    "b": 27.4908199310303,
    "C": 30.5620098114014,
    "h": 64.0936660766602,
    "CMY_C": 0.23874992132187,
    "CMY_M": 0.42666161060333,
    "CMY_Y": 0.58242225646973,
    "CMYK_C": 0,
    "CMYK_M": 0.24684619903564,
    "CMYK_Y": 0.45145785808563,
    "CMYK_K": 0.23874992132187
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16059",
    "Farbtonhilfsbezeichnung": "16059",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "183",
    "Bcolor": "149",
    "Y": 52,
    "L": 76.7224655151367,
    "a": 7.64440011978149,
    "b": 21.643856048584,
    "C": 22.9541568756104,
    "h": 70.5472717285156,
    "CMY_C": 0.14610546827316,
    "CMY_M": 0.28060376644135,
    "CMY_Y": 0.4172670841217,
    "CMYK_C": 0,
    "CMYK_M": 0.15751160681248,
    "CMYK_Y": 0.31755867600441,
    "CMYK_K": 0.14610546827316
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16060",
    "Farbtonhilfsbezeichnung": "16060",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "212",
    "Bcolor": "186",
    "Y": 69,
    "L": 86.1579284667969,
    "a": 4.73748970031738,
    "b": 14.8163318634033,
    "C": 15.5553045272827,
    "h": 72.2684326171875,
    "CMY_C": 0.07571023702621,
    "CMY_M": 0.169577896595,
    "CMY_Y": 0.26921194791794,
    "CMYK_C": 0,
    "CMYK_M": 0.10155653208494,
    "CMYK_Y": 0.2093517780304,
    "CMYK_K": 0.07571023702621
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16061",
    "Farbtonhilfsbezeichnung": "16061",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "156",
    "Bcolor": "129",
    "Y": 36,
    "L": 66.2826995849609,
    "a": 7.52490234375,
    "b": 17.7037734985352,
    "C": 19.2366256713867,
    "h": 66.9723205566406,
    "CMY_C": 0.27046138048172,
    "CMY_M": 0.38948225975037,
    "CMY_Y": 0.49505698680878,
    "CMYK_C": 0,
    "CMYK_M": 0.16314540803432,
    "CMYK_Y": 0.30785977840424,
    "CMYK_K": 0.27046138048172
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16062",
    "Farbtonhilfsbezeichnung": "16062",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 57,
    "L": 80.0065307617188,
    "a": 2.83568835258484,
    "b": 9.78140640258789,
    "C": 10.1841564178467,
    "h": 73.8328094482422,
    "CMY_C": 0.17121702432632,
    "CMY_M": 0.23081970214844,
    "CMY_Y": 0.29821747541428,
    "CMYK_C": 0,
    "CMYK_M": 0.07191590219736,
    "CMYK_Y": 0.15323728322983,
    "CMYK_K": 0.17121702432632
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16063",
    "Farbtonhilfsbezeichnung": "16063",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "112",
    "Bcolor": "62",
    "Y": 22,
    "L": 53.2442092895508,
    "a": 21.7341156005859,
    "b": 37.5495262145996,
    "C": 43.385929107666,
    "h": 59.9372253417969,
    "CMY_C": 0.30329173803329,
    "CMY_M": 0.56237900257111,
    "CMY_Y": 0.75683224201202,
    "CMYK_C": 0,
    "CMYK_M": 0.37187337875366,
    "CMYK_Y": 0.65097618103027,
    "CMYK_K": 0.30329173803329
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16064",
    "Farbtonhilfsbezeichnung": "16064",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "158",
    "Bcolor": "106",
    "Y": 41,
    "L": 69.705680847168,
    "a": 16.9778842926025,
    "b": 35.1817092895508,
    "C": 39.0640640258789,
    "h": 64.2391128540039,
    "CMY_C": 0.14429605007172,
    "CMY_M": 0.38153094053268,
    "CMY_Y": 0.58390879631042,
    "CMYK_C": 0,
    "CMYK_M": 0.27723944187164,
    "CMYK_Y": 0.51374399662018,
    "CMYK_K": 0.14429605007172
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16065",
    "Farbtonhilfsbezeichnung": "16065",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "195",
    "Bcolor": "154",
    "Y": 60,
    "L": 81.6306915283203,
    "a": 10.0973958969116,
    "b": 25.6876430511475,
    "C": 27.6009502410889,
    "h": 68.541015625,
    "CMY_C": 0.06606131792068,
    "CMY_M": 0.23484760522842,
    "CMY_Y": 0.39564740657806,
    "CMYK_C": 0,
    "CMYK_M": 0.1807252317667,
    "CMYK_Y": 0.35289907455444,
    "CMYK_K": 0.06606131792068
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16066",
    "Farbtonhilfsbezeichnung": "16066",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "124",
    "Bcolor": "94",
    "Y": 24,
    "L": 55.5335578918457,
    "a": 12.6051769256592,
    "b": 22.5709686279297,
    "C": 25.8522548675537,
    "h": 60.8180122375488,
    "CMY_C": 0.34724140167236,
    "CMY_M": 0.51251006126404,
    "CMY_Y": 0.63257497549057,
    "CMYK_C": 0,
    "CMYK_M": 0.25318497419357,
    "CMYK_Y": 0.43711960315704,
    "CMYK_K": 0.34724140167236
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16067",
    "Farbtonhilfsbezeichnung": "16067",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "148",
    "Bcolor": "125",
    "Y": 33,
    "L": 63.4284019470215,
    "a": 8.27663230895996,
    "b": 15.760157585144,
    "C": 17.80126953125,
    "h": 62.2932586669922,
    "CMY_C": 0.30060559511185,
    "CMY_M": 0.42037099599838,
    "CMY_Y": 0.50984412431717,
    "CMYK_C": 0,
    "CMYK_M": 0.17124158143997,
    "CMYK_Y": 0.29917100071907,
    "CMYK_K": 0.30060559511185
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16068",
    "Farbtonhilfsbezeichnung": "16068",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "185",
    "Bcolor": "165",
    "Y": 52,
    "L": 76.6303024291992,
    "a": 5.79033327102661,
    "b": 12.2555122375488,
    "C": 13.554539680481,
    "h": 64.7107849121094,
    "CMY_C": 0.18107831478119,
    "CMY_M": 0.2748858332634,
    "CMY_Y": 0.35103315114975,
    "CMYK_C": 0,
    "CMYK_M": 0.11455004662275,
    "CMYK_Y": 0.20753490924835,
    "CMYK_K": 0.18107831478119
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16069",
    "Farbtonhilfsbezeichnung": "16069",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "177",
    "Bcolor": "165",
    "Y": 46,
    "L": 72.9669799804688,
    "a": 3.76665878295898,
    "b": 7.11052846908569,
    "C": 8.0465726852417,
    "h": 62.0884971618652,
    "CMY_C": 0.248714864254,
    "CMY_M": 0.30783379077911,
    "CMY_Y": 0.35292983055115,
    "CMYK_C": 0,
    "CMYK_M": 0.07869039475918,
    "CMYK_Y": 0.13871559500694,
    "CMYK_K": 0.248714864254
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16070",
    "Farbtonhilfsbezeichnung": "16070",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "203",
    "Bcolor": "191",
    "Y": 62,
    "L": 82.6145248413086,
    "a": 3.57503151893616,
    "b": 7.33437156677246,
    "C": 8.15928077697754,
    "h": 64.0137634277344,
    "CMY_C": 0.1439111828804,
    "CMY_M": 0.20362883806229,
    "CMY_Y": 0.25262612104416,
    "CMYK_C": 0,
    "CMYK_M": 0.06975638121367,
    "CMYK_Y": 0.1269902586937,
    "CMYK_K": 0.1439111828804
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16071",
    "Farbtonhilfsbezeichnung": "16071",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "219",
    "Bcolor": "207",
    "Y": 73,
    "L": 87.987174987793,
    "a": 1.81595063209534,
    "b": 6.51698589324951,
    "C": 6.76526308059692,
    "h": 74.4295654296875,
    "CMY_C": 0.09966194629669,
    "CMY_M": 0.14021390676498,
    "CMY_Y": 0.18895691633224,
    "CMYK_C": 0,
    "CMYK_M": 0.04504081606865,
    "CMYK_Y": 0.09917937964201,
    "CMYK_K": 0.09966194629669
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16072",
    "Farbtonhilfsbezeichnung": "16072",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "123",
    "Bcolor": "115",
    "Y": 21,
    "L": 52.5903167724609,
    "a": 3.78073406219482,
    "b": 5.70168447494507,
    "C": 6.84128332138062,
    "h": 56.4520111083984,
    "CMY_C": 0.46616739034653,
    "CMY_M": 0.51722717285156,
    "CMY_Y": 0.54914176464081,
    "CMYK_C": 0,
    "CMYK_M": 0.09564755111933,
    "CMYK_Y": 0.1554314494133,
    "CMYK_K": 0.46616739034653
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16073",
    "Farbtonhilfsbezeichnung": "16073",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "160",
    "Bcolor": "153",
    "Y": 37,
    "L": 66.6726226806641,
    "a": 2.95165491104126,
    "b": 4.74741125106812,
    "C": 5.59018611907959,
    "h": 58.1291389465332,
    "CMY_C": 0.32835340499878,
    "CMY_M": 0.37158060073853,
    "CMY_Y": 0.40162038803101,
    "CMYK_C": 0,
    "CMYK_M": 0.06436002999544,
    "CMYK_Y": 0.10908561944962,
    "CMYK_K": 0.32835340499878
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16074",
    "Farbtonhilfsbezeichnung": "16074",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "190",
    "Bcolor": "183",
    "Y": 53,
    "L": 77.5022735595703,
    "a": 1.90908050537109,
    "b": 3.81931734085083,
    "C": 4.26986789703369,
    "h": 63.4418907165527,
    "CMY_C": 0.22258472442627,
    "CMY_M": 0.25412464141846,
    "CMY_Y": 0.28204435110092,
    "CMYK_C": 0,
    "CMYK_M": 0.04057022929192,
    "CMYK_Y": 0.07648374140263,
    "CMYK_K": 0.22258472442627
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16075",
    "Farbtonhilfsbezeichnung": "16075",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "215",
    "Bcolor": "209",
    "Y": 69,
    "L": 86.3200073242188,
    "a": 1.02371394634247,
    "b": 2.68551230430603,
    "C": 2.87401580810547,
    "h": 69.1332168579102,
    "CMY_C": 0.13619524240494,
    "CMY_M": 0.15568256378174,
    "CMY_Y": 0.1790908575058,
    "CMYK_C": 0,
    "CMYK_M": 0.02255986817181,
    "CMYK_Y": 0.0496589243412,
    "CMYK_K": 0.13619524240494
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16076",
    "Farbtonhilfsbezeichnung": "16076",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "138",
    "Bcolor": "76",
    "Y": 32,
    "L": 63.1769561767578,
    "a": 20.4631652832031,
    "b": 42.4734687805176,
    "C": 47.1459083557129,
    "h": 64.2758331298828,
    "CMY_C": 0.19106423854828,
    "CMY_M": 0.45970785617828,
    "CMY_Y": 0.70042425394058,
    "CMYK_C": 0,
    "CMYK_M": 0.33209511637688,
    "CMYK_Y": 0.62966680526733,
    "CMYK_K": 0.19106423854828
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16077",
    "Farbtonhilfsbezeichnung": "16077",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "173",
    "Bcolor": "126",
    "Y": 48,
    "L": 74.4848861694336,
    "a": 14.2320194244385,
    "b": 31.0558586120606,
    "C": 34.1616249084473,
    "h": 65.3793563842773,
    "CMY_C": 0.11207151412964,
    "CMY_M": 0.32319045066833,
    "CMY_Y": 0.50693690776825,
    "CMYK_C": 0,
    "CMYK_M": 0.23776569962502,
    "CMYK_Y": 0.44470405578613,
    "CMYK_K": 0.11207151412964
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16078",
    "Farbtonhilfsbezeichnung": "16078",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "201",
    "Bcolor": "167",
    "Y": 64,
    "L": 83.5342483520508,
    "a": 8.94484901428223,
    "b": 21.6786155700684,
    "C": 23.4514961242676,
    "h": 67.5783843994141,
    "CMY_C": 0.06022053956985,
    "CMY_M": 0.21037298440933,
    "CMY_Y": 0.34660768508911,
    "CMYK_C": 0,
    "CMYK_M": 0.15977412462234,
    "CMYK_Y": 0.30473867058754,
    "CMYK_K": 0.06022053956985
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16079",
    "Farbtonhilfsbezeichnung": "16079",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "141",
    "Bcolor": "96",
    "Y": 34,
    "L": 64.4995574951172,
    "a": 20.6659927368164,
    "b": 33.8264541625977,
    "C": 39.6397819519043,
    "h": 58.5774993896484,
    "CMY_C": 0.18454819917679,
    "CMY_M": 0.44536572694778,
    "CMY_Y": 0.62382185459137,
    "CMYK_C": 0,
    "CMYK_M": 0.319844186306,
    "CMYK_Y": 0.53868746757507,
    "CMYK_K": 0.18454819917679
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16080",
    "Farbtonhilfsbezeichnung": "16080",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "157",
    "Bcolor": "119",
    "Y": 41,
    "L": 69.5075073242188,
    "a": 17.1560478210449,
    "b": 28.1718292236328,
    "C": 32.9845695495605,
    "h": 58.6594696044922,
    "CMY_C": 0.15580528974533,
    "CMY_M": 0.38278329372406,
    "CMY_Y": 0.53508734703064,
    "CMYK_C": 0,
    "CMYK_M": 0.2688692510128,
    "CMYK_Y": 0.44928267598152,
    "CMYK_K": 0.15580528974533
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16081",
    "Farbtonhilfsbezeichnung": "16081",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "180",
    "Bcolor": "139",
    "Y": 51,
    "L": 76.9695205688477,
    "a": 13.3813724517822,
    "b": 27.3653087615967,
    "C": 30.461799621582,
    "h": 63.9418144226074,
    "CMY_C": 0.09512889385223,
    "CMY_M": 0.2938027381897,
    "CMY_Y": 0.45509988069534,
    "CMYK_C": 0,
    "CMYK_M": 0.21956038475037,
    "CMYK_Y": 0.39781466126442,
    "CMYK_K": 0.09512889385223
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16082",
    "Farbtonhilfsbezeichnung": "16082",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "227",
    "Bcolor": "204",
    "Y": 78,
    "L": 91.0763778686523,
    "a": 2.9328715801239,
    "b": 12.794885635376,
    "C": 13.1267223358154,
    "h": 77.0895690917969,
    "CMY_C": 0.03850901126862,
    "CMY_M": 0.11028790473938,
    "CMY_Y": 0.20165109634399,
    "CMYK_C": 0,
    "CMYK_M": 0.07465373724699,
    "CMYK_Y": 0.16967613995075,
    "CMYK_K": 0.03850901126862
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16083",
    "Farbtonhilfsbezeichnung": "16083",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "146",
    "Bcolor": "109",
    "Y": 35,
    "L": 64.7957077026367,
    "a": 16.2191638946533,
    "b": 27.0037727355957,
    "C": 31.5002384185791,
    "h": 59.0098838806152,
    "CMY_C": 0.21666640043259,
    "CMY_M": 0.42885881662369,
    "CMY_Y": 0.57336163520813,
    "CMYK_C": 0,
    "CMYK_M": 0.27088385820389,
    "CMYK_Y": 0.45535546541214,
    "CMYK_K": 0.21666640043259
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16084",
    "Farbtonhilfsbezeichnung": "16084",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "183",
    "Bcolor": "151",
    "Y": 52,
    "L": 77.092399597168,
    "a": 10.6213998794556,
    "b": 21.1065082550049,
    "C": 23.6283473968506,
    "h": 63.2871475219727,
    "CMY_C": 0.12344211339951,
    "CMY_M": 0.28401571512222,
    "CMY_Y": 0.40902501344681,
    "CMYK_C": 0,
    "CMYK_M": 0.18318653106689,
    "CMYK_Y": 0.32580038905144,
    "CMYK_K": 0.12344211339951
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16085",
    "Farbtonhilfsbezeichnung": "16085",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "212",
    "Bcolor": "189",
    "Y": 70,
    "L": 86.5656814575195,
    "a": 5.82065582275391,
    "b": 13.822075843811,
    "C": 14.9976606369019,
    "h": 67.1634063720703,
    "CMY_C": 0.06593239307404,
    "CMY_M": 0.16752338409424,
    "CMY_Y": 0.25736713409424,
    "CMYK_C": 0,
    "CMYK_M": 0.108761921525,
    "CMYK_Y": 0.20494741201401,
    "CMYK_K": 0.06593239307404
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16086",
    "Farbtonhilfsbezeichnung": "16086",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "114",
    "Bcolor": "83",
    "Y": 21,
    "L": 52.3906555175781,
    "a": 16.4128856658936,
    "b": 24.7688617706299,
    "C": 29.713285446167,
    "h": 56.4698753356934,
    "CMY_C": 0.35648882389069,
    "CMY_M": 0.55398654937744,
    "CMY_Y": 0.67634499073029,
    "CMYK_C": 0,
    "CMYK_M": 0.30690643191338,
    "CMYK_Y": 0.4970483481884,
    "CMYK_K": 0.35648882389069
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16087",
    "Farbtonhilfsbezeichnung": "16087",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "168",
    "Bcolor": "139",
    "Y": 44,
    "L": 71.8020858764648,
    "a": 11.1920127868652,
    "b": 19.7713508605957,
    "C": 22.7193183898926,
    "h": 60.4870071411133,
    "CMY_C": 0.18185782432556,
    "CMY_M": 0.34132754802704,
    "CMY_Y": 0.45339864492416,
    "CMYK_C": 0,
    "CMYK_M": 0.19491688907146,
    "CMYK_Y": 0.33189931511879,
    "CMYK_K": 0.18185782432556
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16088",
    "Farbtonhilfsbezeichnung": "16088",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "207",
    "Bcolor": "188",
    "Y": 66,
    "L": 84.5171051025391,
    "a": 5.36209774017334,
    "b": 11.8054475784302,
    "C": 12.9661359786987,
    "h": 65.5721893310547,
    "CMY_C": 0.09751260280609,
    "CMY_M": 0.18834835290909,
    "CMY_Y": 0.26456546783447,
    "CMYK_C": 0,
    "CMYK_M": 0.10065043717623,
    "CMYK_Y": 0.18510271608829,
    "CMYK_K": 0.09751260280609
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16089",
    "Farbtonhilfsbezeichnung": "16089",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "108",
    "Bcolor": "69",
    "Y": 22,
    "L": 54.1613807678223,
    "a": 29.0868339538574,
    "b": 35.308219909668,
    "C": 45.7461929321289,
    "h": 50.5183792114258,
    "CMY_C": 0.25595009326935,
    "CMY_M": 0.57532745599747,
    "CMY_Y": 0.72974842786789,
    "CMYK_C": 0,
    "CMYK_M": 0.42924186587334,
    "CMYK_Y": 0.63678300380707,
    "CMYK_K": 0.25595009326935
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16090",
    "Farbtonhilfsbezeichnung": "16090",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "149",
    "Bcolor": "112",
    "Y": 38,
    "L": 67.3150863647461,
    "a": 21.2497940063477,
    "b": 28.8201408386231,
    "C": 35.8071823120117,
    "h": 53.5977401733398,
    "CMY_C": 0.15559846162796,
    "CMY_M": 0.41705292463303,
    "CMY_Y": 0.56042170524597,
    "CMYK_C": 0,
    "CMYK_M": 0.30963286757469,
    "CMYK_Y": 0.4794203042984,
    "CMYK_K": 0.15559846162796
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16091",
    "Farbtonhilfsbezeichnung": "16091",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "180",
    "Bcolor": "151",
    "Y": 52,
    "L": 77.2338256835938,
    "a": 14.9905433654785,
    "b": 21.2823257446289,
    "C": 26.0317840576172,
    "h": 54.8404426574707,
    "CMY_C": 0.09318560361862,
    "CMY_M": 0.29392433166504,
    "CMY_Y": 0.40800869464874,
    "CMYK_C": 0,
    "CMYK_M": 0.22136694192886,
    "CMYK_Y": 0.34717479348183,
    "CMYK_K": 0.09318560361862
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16092",
    "Farbtonhilfsbezeichnung": "16092",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "205",
    "Bcolor": "183",
    "Y": 67,
    "L": 84.753532409668,
    "a": 9.79291820526123,
    "b": 14.8383741378784,
    "C": 17.7785987854004,
    "h": 56.576286315918,
    "CMY_C": 0.05611389875412,
    "CMY_M": 0.19762110710144,
    "CMY_Y": 0.28348243236542,
    "CMYK_C": 0,
    "CMYK_M": 0.14991979300976,
    "CMYK_Y": 0.24088555574417,
    "CMYK_K": 0.05611389875412
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16093",
    "Farbtonhilfsbezeichnung": "16093",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "107",
    "Bcolor": "71",
    "Y": 21,
    "L": 52.31005859375,
    "a": 24.7053337097168,
    "b": 31.787036895752,
    "C": 40.2587776184082,
    "h": 52.1451454162598,
    "CMY_C": 0.30383133888245,
    "CMY_M": 0.57947206497192,
    "CMY_Y": 0.72332465648651,
    "CMYK_C": 0,
    "CMYK_M": 0.39593958854675,
    "CMYK_Y": 0.60257428884506,
    "CMYK_K": 0.30383133888245
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16094",
    "Farbtonhilfsbezeichnung": "16094",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "153",
    "Bcolor": "117",
    "Y": 39,
    "L": 68.1777572631836,
    "a": 18.7532215118408,
    "b": 27.0995769500732,
    "C": 32.9555816650391,
    "h": 55.3163146972656,
    "CMY_C": 0.16307491064072,
    "CMY_M": 0.40078300237656,
    "CMY_Y": 0.54024338722229,
    "CMYK_C": 0,
    "CMYK_M": 0.28402552008629,
    "CMYK_Y": 0.45065978169441,
    "CMYK_K": 0.16307491064072
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16095",
    "Farbtonhilfsbezeichnung": "16095",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "191",
    "Bcolor": "161",
    "Y": 58,
    "L": 80.3961944580078,
    "a": 12.1773319244385,
    "b": 20.141939163208,
    "C": 23.5368881225586,
    "h": 58.8438491821289,
    "CMY_C": 0.07770997285843,
    "CMY_M": 0.25232398509979,
    "CMY_Y": 0.36755663156509,
    "CMYK_C": 0,
    "CMYK_M": 0.18932656943798,
    "CMYK_Y": 0.31426844000816,
    "CMYK_K": 0.07770997285843
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16096",
    "Farbtonhilfsbezeichnung": "16096",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "222",
    "Bcolor": "204",
    "Y": 77,
    "L": 89.9099044799805,
    "a": 5.84297513961792,
    "b": 10.8958768844604,
    "C": 12.363676071167,
    "h": 61.7973175048828,
    "CMY_C": 0.03563815355301,
    "CMY_M": 0.12992656230927,
    "CMY_Y": 0.19975900650024,
    "CMYK_C": 0,
    "CMYK_M": 0.09777285158634,
    "CMYK_Y": 0.17018596827984,
    "CMYK_K": 0.03563815355301
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16097",
    "Farbtonhilfsbezeichnung": "16097",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "134",
    "Bcolor": "101",
    "Y": 31,
    "L": 62.1144752502441,
    "a": 23.0754642486572,
    "b": 27.7759017944336,
    "C": 36.1106338500977,
    "h": 50.281120300293,
    "CMY_C": 0.20610761642456,
    "CMY_M": 0.47555112838745,
    "CMY_Y": 0.60325992107391,
    "CMYK_C": 0,
    "CMYK_M": 0.33939552307129,
    "CMYK_Y": 0.50025963783264,
    "CMYK_K": 0.20610761642456
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16098",
    "Farbtonhilfsbezeichnung": "16098",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "147",
    "Bcolor": "120",
    "Y": 34,
    "L": 64.6454925537109,
    "a": 14.2203750610352,
    "b": 20.2861862182617,
    "C": 24.773946762085,
    "h": 54.9700012207031,
    "CMY_C": 0.24152511358261,
    "CMY_M": 0.42377263307571,
    "CMY_Y": 0.5281280875206,
    "CMYK_C": 0,
    "CMYK_M": 0.24028155207634,
    "CMYK_Y": 0.37786746025085,
    "CMYK_K": 0.24152511358261
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16099",
    "Farbtonhilfsbezeichnung": "16099",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "187",
    "Bcolor": "169",
    "Y": 54,
    "L": 77.9278030395508,
    "a": 7.53824377059937,
    "b": 12.26589012146,
    "C": 14.3971242904663,
    "h": 58.4263801574707,
    "CMY_C": 0.15462619066238,
    "CMY_M": 0.26525276899338,
    "CMY_Y": 0.33725678920746,
    "CMYK_C": 0,
    "CMYK_M": 0.13086113333702,
    "CMYK_Y": 0.21603532135487,
    "CMYK_K": 0.15462619066238
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16100",
    "Farbtonhilfsbezeichnung": "16100",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "223",
    "Bcolor": "207",
    "Y": 75,
    "L": 89.4382934570313,
    "a": 2.75348353385925,
    "b": 8.44363975524902,
    "C": 8.88125705718994,
    "h": 71.9387741088867,
    "CMY_C": 0.07064527273178,
    "CMY_M": 0.12692040205002,
    "CMY_Y": 0.18724101781845,
    "CMYK_C": 0,
    "CMYK_M": 0.06055290624499,
    "CMYK_Y": 0.12545882165432,
    "CMYK_K": 0.07064527273178
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16101",
    "Farbtonhilfsbezeichnung": "16101",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "120",
    "Bcolor": "112",
    "Y": 20,
    "L": 52.0297508239746,
    "a": 6.17317676544189,
    "b": 6.69847440719604,
    "C": 9.10920810699463,
    "h": 47.3369674682617,
    "CMY_C": 0.45393943786621,
    "CMY_M": 0.52844679355621,
    "CMY_Y": 0.56086122989655,
    "CMYK_C": 0,
    "CMYK_M": 0.13644522428513,
    "CMYK_Y": 0.19580574333668,
    "CMYK_K": 0.45393943786621
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16102",
    "Farbtonhilfsbezeichnung": "16102",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "161",
    "Bcolor": "154",
    "Y": 38,
    "L": 67.5307235717773,
    "a": 4.74724769592285,
    "b": 5.15346717834473,
    "C": 7.00675296783447,
    "h": 47.3494873046875,
    "CMY_C": 0.30553662776947,
    "CMY_M": 0.36689692735672,
    "CMY_Y": 0.39536440372467,
    "CMYK_C": 0,
    "CMYK_M": 0.08835642039776,
    "CMYK_Y": 0.12934847176075,
    "CMYK_K": 0.30553662776947
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16103",
    "Farbtonhilfsbezeichnung": "16103",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "189",
    "Y": 56,
    "L": 79.5819473266602,
    "a": 3.31547474861145,
    "b": 3.77871918678284,
    "C": 5.02703619003296,
    "h": 48.7360610961914,
    "CMY_C": 0.18964916467667,
    "CMY_M": 0.23498779535294,
    "CMY_Y": 0.25939708948135,
    "CMYK_C": 0,
    "CMYK_M": 0.05594938620925,
    "CMYK_Y": 0.08607126772404,
    "CMYK_K": 0.18964916467667
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16104",
    "Farbtonhilfsbezeichnung": "16104",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "221",
    "Bcolor": "215",
    "Y": 74,
    "L": 88.6538925170898,
    "a": 1.73937356472015,
    "b": 2.9716432094574,
    "C": 3.44326639175415,
    "h": 59.6585464477539,
    "CMY_C": 0.1038618683815,
    "CMY_M": 0.1316847205162,
    "CMY_Y": 0.1556031703949,
    "CMYK_C": 0,
    "CMYK_M": 0.03104750439525,
    "CMYK_Y": 0.05773808807135,
    "CMYK_K": 0.1038618683815
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16105",
    "Farbtonhilfsbezeichnung": "16105",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "104",
    "Bcolor": "70",
    "Y": 21,
    "L": 52.1861686706543,
    "a": 28.1318454742432,
    "b": 32.2900657653809,
    "C": 42.825798034668,
    "h": 48.9368743896484,
    "CMY_C": 0.28665190935135,
    "CMY_M": 0.59138029813766,
    "CMY_Y": 0.72697770595551,
    "CMYK_C": 0,
    "CMYK_M": 0.42718049883842,
    "CMYK_Y": 0.61726635694504,
    "CMYK_K": 0.28665190935135
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16106",
    "Farbtonhilfsbezeichnung": "16106",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "128",
    "Bcolor": "102",
    "Y": 30,
    "L": 60.6354942321777,
    "a": 26.0090065002441,
    "b": 25.5706520080566,
    "C": 36.4736442565918,
    "h": 44.5130767822266,
    "CMY_C": 0.20944488048553,
    "CMY_M": 0.49884623289108,
    "CMY_Y": 0.60147416591644,
    "CMYK_C": 0,
    "CMYK_M": 0.36607357859612,
    "CMYK_Y": 0.49589115381241,
    "CMYK_K": 0.20944488048553
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16107",
    "Farbtonhilfsbezeichnung": "16107",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "151",
    "Bcolor": "125",
    "Y": 38,
    "L": 67.5964050292969,
    "a": 19.0929145812988,
    "b": 22.1851043701172,
    "C": 29.2697486877441,
    "h": 49.2840995788574,
    "CMY_C": 0.17562168836594,
    "CMY_M": 0.40673726797104,
    "CMY_Y": 0.5111893415451,
    "CMYK_C": 0,
    "CMYK_M": 0.28035137057304,
    "CMYK_Y": 0.40705540776253,
    "CMYK_K": 0.17562168836594
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16108",
    "Farbtonhilfsbezeichnung": "16108",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "171",
    "Bcolor": "141",
    "Y": 47,
    "L": 73.754524230957,
    "a": 14.5753364562988,
    "b": 21.6804637908936,
    "C": 26.1243743896484,
    "h": 56.0878601074219,
    "CMY_C": 0.13464659452438,
    "CMY_M": 0.32990401983261,
    "CMY_Y": 0.44654262065887,
    "CMYK_C": 0,
    "CMYK_M": 0.22563894093037,
    "CMYK_Y": 0.36042618751526,
    "CMYK_K": 0.13464659452438
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16109",
    "Farbtonhilfsbezeichnung": "16109",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "123",
    "Bcolor": "96",
    "Y": 25,
    "L": 56.9213180541992,
    "a": 19.2280406951904,
    "b": 23.1644592285156,
    "C": 30.1049785614014,
    "h": 50.3050689697266,
    "CMY_C": 0.2929744720459,
    "CMY_M": 0.51626527309418,
    "CMY_Y": 0.62202328443527,
    "CMYK_C": 0,
    "CMYK_M": 0.31581717729568,
    "CMYK_Y": 0.46539875864983,
    "CMYK_K": 0.2929744720459
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16110",
    "Farbtonhilfsbezeichnung": "16110",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "150",
    "Bcolor": "131",
    "Y": 36,
    "L": 66.0418472290039,
    "a": 15.1056413650513,
    "b": 16.4652709960938,
    "C": 22.3446979522705,
    "h": 47.4659690856934,
    "CMY_C": 0.22772926092148,
    "CMY_M": 0.41083467006683,
    "CMY_Y": 0.48746860027313,
    "CMYK_C": 0,
    "CMYK_M": 0.237100020051,
    "CMYK_Y": 0.33633196353912,
    "CMYK_K": 0.22772926092148
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16111",
    "Farbtonhilfsbezeichnung": "16111",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "174",
    "Bcolor": "157",
    "Y": 48,
    "L": 74.1818389892578,
    "a": 11.7650289535523,
    "b": 13.5890092849731,
    "C": 17.97434425354,
    "h": 49.1147956848145,
    "CMY_C": 0.16470152139664,
    "CMY_M": 0.316197514534,
    "CMY_Y": 0.3849949836731,
    "CMYK_C": 0,
    "CMYK_M": 0.18136750161648,
    "CMYK_Y": 0.26373022794724,
    "CMYK_K": 0.16470152139664
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16112",
    "Farbtonhilfsbezeichnung": "16112",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "213",
    "Bcolor": "200",
    "Y": 70,
    "L": 86.5984725952148,
    "a": 5.86567687988281,
    "b": 8.38473606109619,
    "C": 10.2327890396118,
    "h": 55.0246696472168,
    "CMY_C": 0.0798054933548,
    "CMY_M": 0.16587883234024,
    "CMY_Y": 0.21710401773453,
    "CMYK_C": 0,
    "CMYK_M": 0.09353820234537,
    "CMYK_Y": 0.14920598268509,
    "CMYK_K": 0.0798054933548
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16113",
    "Farbtonhilfsbezeichnung": "16113",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "135",
    "Bcolor": "123",
    "Y": 27,
    "L": 58.8011779785156,
    "a": 10.017786026001,
    "b": 10.1590671539307,
    "C": 14.267539024353,
    "h": 45.4011878967285,
    "CMY_C": 0.35105156898499,
    "CMY_M": 0.47056263685226,
    "CMY_Y": 0.51706445217133,
    "CMYK_C": 0,
    "CMYK_M": 0.18416111171246,
    "CMYK_Y": 0.25581830739975,
    "CMYK_K": 0.35105156898499
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16114",
    "Farbtonhilfsbezeichnung": "16114",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "171",
    "Bcolor": "160",
    "Y": 42,
    "L": 71.3086166381836,
    "a": 6.17618989944458,
    "b": 7.75381708145142,
    "C": 9.91297149658203,
    "h": 51.4614372253418,
    "CMY_C": 0.24808591604233,
    "CMY_M": 0.33128541707993,
    "CMY_Y": 0.37434351444244,
    "CMYK_C": 0,
    "CMYK_M": 0.11065027862787,
    "CMYK_Y": 0.16791492700577,
    "CMYK_K": 0.24808591604233
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16115",
    "Farbtonhilfsbezeichnung": "16115",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "86",
    "Bcolor": "62",
    "Y": 15,
    "L": 45.3593826293945,
    "a": 29.8359889984131,
    "b": 27.4764518737793,
    "C": 40.5603446960449,
    "h": 42.6424789428711,
    "CMY_C": 0.36019057035446,
    "CMY_M": 0.66295373439789,
    "CMY_Y": 0.75556087493896,
    "CMYK_C": 0,
    "CMYK_M": 0.47320833802223,
    "CMYK_Y": 0.61795008182526,
    "CMYK_K": 0.36019057035446
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16116",
    "Farbtonhilfsbezeichnung": "16116",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "104",
    "Bcolor": "80",
    "Y": 21,
    "L": 51.9674606323242,
    "a": 28.0205383300781,
    "b": 26.3143119812012,
    "C": 38.4394798278809,
    "h": 43.2013854980469,
    "CMY_C": 0.29615914821625,
    "CMY_M": 0.59211307764053,
    "CMY_Y": 0.68800210952759,
    "CMYK_C": 0,
    "CMYK_M": 0.42048415541649,
    "CMYK_Y": 0.55672097206116,
    "CMYK_K": 0.29615914821625
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16117",
    "Farbtonhilfsbezeichnung": "16117",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "161",
    "Bcolor": "145",
    "Y": 41,
    "L": 69.9047775268555,
    "a": 14.5642423629761,
    "b": 13.858115196228,
    "C": 20.1038436889648,
    "h": 43.576831817627,
    "CMY_C": 0.19355291128159,
    "CMY_M": 0.36859488487244,
    "CMY_Y": 0.43032258749008,
    "CMYK_C": 0,
    "CMYK_M": 0.2170532643795,
    "CMYK_Y": 0.29359605908394,
    "CMYK_K": 0.19355291128159
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16118",
    "Farbtonhilfsbezeichnung": "16118",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "201",
    "Bcolor": "186",
    "Y": 62,
    "L": 82.7717056274414,
    "a": 7.9989972114563,
    "b": 10.1814765930176,
    "C": 12.9478349685669,
    "h": 51.845329284668,
    "CMY_C": 0.10264873504639,
    "CMY_M": 0.21350932121277,
    "CMY_Y": 0.27093660831451,
    "CMYK_C": 0,
    "CMYK_M": 0.12354201823473,
    "CMYK_Y": 0.18753845989704,
    "CMYK_K": 0.10264873504639
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16119",
    "Farbtonhilfsbezeichnung": "16119",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "107",
    "Bcolor": "87",
    "Y": 20,
    "L": 51.2841720581055,
    "a": 21.6669921875,
    "b": 21.0138072967529,
    "C": 30.1834163665771,
    "h": 44.123218536377,
    "CMY_C": 0.34470212459564,
    "CMY_M": 0.57867401838303,
    "CMY_Y": 0.66020500659943,
    "CMYK_C": 0,
    "CMYK_M": 0.35704663395882,
    "CMYK_Y": 0.48146483302116,
    "CMYK_K": 0.34470212459564
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16120",
    "Farbtonhilfsbezeichnung": "16120",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "84",
    "Bcolor": "69",
    "Y": 15,
    "L": 44.9373931884766,
    "a": 30.6569118499756,
    "b": 23.0727558135986,
    "C": 38.3692359924316,
    "h": 36.9655532836914,
    "CMY_C": 0.36528933048248,
    "CMY_M": 0.66898500919342,
    "CMY_Y": 0.73004293441772,
    "CMYK_C": 0,
    "CMYK_M": 0.47847893834114,
    "CMYK_Y": 0.57467699050903,
    "CMYK_K": 0.36528933048248
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16121",
    "Farbtonhilfsbezeichnung": "16121",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "104",
    "Bcolor": "87",
    "Y": 20,
    "L": 51.5704116821289,
    "a": 27.5956916809082,
    "b": 21.4545001983643,
    "C": 34.9545097351074,
    "h": 37.8635787963867,
    "CMY_C": 0.30883967876434,
    "CMY_M": 0.59372067451477,
    "CMY_Y": 0.65917146205902,
    "CMYK_C": 0,
    "CMYK_M": 0.41217789053917,
    "CMYK_Y": 0.50687485933304,
    "CMYK_K": 0.30883967876434
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16122",
    "Farbtonhilfsbezeichnung": "16122",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "130",
    "Bcolor": "112",
    "Y": 30,
    "L": 60.5854530334473,
    "a": 23.5139923095703,
    "b": 19.4557189941406,
    "C": 30.5193843841553,
    "h": 39.6047058105469,
    "CMY_C": 0.23318731784821,
    "CMY_M": 0.49065667390823,
    "CMY_Y": 0.56042313575745,
    "CMYK_C": 0,
    "CMYK_M": 0.33576565980911,
    "CMYK_Y": 0.42674803733826,
    "CMYK_K": 0.23318731784821
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16123",
    "Farbtonhilfsbezeichnung": "16123",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "171",
    "Bcolor": "156",
    "Y": 48,
    "L": 74.0864639282227,
    "a": 16.4285850524902,
    "b": 13.8474750518799,
    "C": 21.4860649108887,
    "h": 40.1271743774414,
    "CMY_C": 0.13484334945679,
    "CMY_M": 0.32948958873749,
    "CMY_Y": 0.38701891899109,
    "CMYK_C": 0,
    "CMYK_M": 0.22498381137848,
    "CMYK_Y": 0.2914796769619,
    "CMYK_K": 0.13484334945679
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16124",
    "Farbtonhilfsbezeichnung": "16124",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "144",
    "Bcolor": "139",
    "Y": 31,
    "L": 61.6888771057129,
    "a": 7.71115875244141,
    "b": 5.26428031921387,
    "C": 9.33673477172852,
    "h": 34.3207054138184,
    "CMY_C": 0.34701776504517,
    "CMY_M": 0.43437039852142,
    "CMY_Y": 0.45526611804962,
    "CMYK_C": 0,
    "CMYK_M": 0.13377490639687,
    "CMYK_Y": 0.16577534377575,
    "CMYK_K": 0.34701776504517
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16125",
    "Farbtonhilfsbezeichnung": "16125",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "178",
    "Bcolor": "173",
    "Y": 47,
    "L": 73.8877105712891,
    "a": 5.76470518112183,
    "b": 4.05614137649536,
    "C": 7.04869556427002,
    "h": 35.1308479309082,
    "CMY_C": 0.23312044143677,
    "CMY_M": 0.30200403928757,
    "CMY_Y": 0.32138061523438,
    "CMYK_C": 0,
    "CMYK_M": 0.08982323110104,
    "CMYK_Y": 0.11509000509977,
    "CMYK_K": 0.23312044143677
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16126",
    "Farbtonhilfsbezeichnung": "16126",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "75",
    "Bcolor": "63",
    "Y": 12,
    "L": 40.5562171936035,
    "a": 29.3426513671875,
    "b": 20.8000564575195,
    "C": 35.9671173095703,
    "h": 35.3315963745117,
    "CMY_C": 0.42294442653656,
    "CMY_M": 0.70623826980591,
    "CMY_Y": 0.75483220815659,
    "CMYK_C": 0,
    "CMYK_M": 0.49092990159988,
    "CMYK_Y": 0.57514005899429,
    "CMYK_K": 0.42294442653656
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16127",
    "Farbtonhilfsbezeichnung": "16127",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "75",
    "Bcolor": "64",
    "Y": 10,
    "L": 38.6061668395996,
    "a": 23.7628631591797,
    "b": 17.192813873291,
    "C": 29.3302993774414,
    "h": 35.886344909668,
    "CMY_C": 0.47605633735657,
    "CMY_M": 0.70593768358231,
    "CMY_Y": 0.7504780292511,
    "CMYK_C": 0,
    "CMYK_M": 0.43875202536583,
    "CMYK_Y": 0.52376180887222,
    "CMYK_K": 0.47605633735657
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16128",
    "Farbtonhilfsbezeichnung": "16128",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "96",
    "Bcolor": "85",
    "Y": 15,
    "L": 45.3863639831543,
    "a": 18.4632034301758,
    "b": 13.255989074707,
    "C": 22.7290802001953,
    "h": 35.6771392822266,
    "CMY_C": 0.43745011091232,
    "CMY_M": 0.62543332576752,
    "CMY_Y": 0.66486066579819,
    "CMYK_C": 0,
    "CMYK_M": 0.33416274189949,
    "CMYK_Y": 0.40424957871437,
    "CMYK_K": 0.43745011091232
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16129",
    "Farbtonhilfsbezeichnung": "16129",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "148",
    "Bcolor": "140",
    "Y": 34,
    "L": 64.3086700439453,
    "a": 12.3110828399658,
    "b": 8.53833484649658,
    "C": 14.9821872711182,
    "h": 34.7431907653809,
    "CMY_C": 0.28104615211487,
    "CMY_M": 0.41961234807968,
    "CMY_Y": 0.45054042339325,
    "CMYK_C": 0,
    "CMYK_M": 0.19273309409618,
    "CMYK_Y": 0.2357512563467,
    "CMYK_K": 0.28104615211487
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16130",
    "Farbtonhilfsbezeichnung": "16130",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "186",
    "Bcolor": "177",
    "Y": 54,
    "L": 77.9170684814453,
    "a": 10.1427717208862,
    "b": 7.84595155715942,
    "C": 12.8232126235962,
    "h": 37.7237815856934,
    "CMY_C": 0.1479703783989,
    "CMY_M": 0.27075064182281,
    "CMY_Y": 0.30526250600815,
    "CMYK_C": 0,
    "CMYK_M": 0.14410327374935,
    "CMYK_Y": 0.18460875749588,
    "CMYK_K": 0.1479703783989
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16131",
    "Farbtonhilfsbezeichnung": "16131",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "104",
    "Bcolor": "94",
    "Y": 20,
    "L": 51.3953666687012,
    "a": 27.1807098388672,
    "b": 16.8554573059082,
    "C": 31.9827671051025,
    "h": 31.8041172027588,
    "CMY_C": 0.31931239366531,
    "CMY_M": 0.59313917160034,
    "CMY_Y": 0.63041865825653,
    "CMYK_C": 0,
    "CMYK_M": 0.40227964520454,
    "CMYK_Y": 0.45704704523087,
    "CMYK_K": 0.31931239366531
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16132",
    "Farbtonhilfsbezeichnung": "16132",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "134",
    "Bcolor": "125",
    "Y": 31,
    "L": 61.8402328491211,
    "a": 23.3587741851807,
    "b": 13.9211931228638,
    "C": 27.192497253418,
    "h": 30.7937908172607,
    "CMY_C": 0.22938627004623,
    "CMY_M": 0.47612756490707,
    "CMY_Y": 0.51029980182648,
    "CMYK_C": 0,
    "CMYK_M": 0.32018804550171,
    "CMYK_Y": 0.36453223228455,
    "CMYK_K": 0.22938627004623
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16133",
    "Farbtonhilfsbezeichnung": "16133",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "124",
    "Bcolor": "118",
    "Y": 23,
    "L": 55.1749649047852,
    "a": 12.3721170425415,
    "b": 7.61592102050781,
    "C": 14.5283012390137,
    "h": 31.6152610778809,
    "CMY_C": 0.38029116392136,
    "CMY_M": 0.51225602626801,
    "CMY_Y": 0.53531795740128,
    "CMYK_C": 0,
    "CMYK_M": 0.21294654905796,
    "CMYK_Y": 0.25016069412231,
    "CMYK_K": 0.38029116392136
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16134",
    "Farbtonhilfsbezeichnung": "16134",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "174",
    "Bcolor": "170",
    "Y": 46,
    "L": 73.1393585205078,
    "a": 8.40192794799805,
    "b": 4.82367277145386,
    "C": 9.68814849853516,
    "h": 29.8607769012451,
    "CMY_C": 0.2206004858017,
    "CMY_M": 0.31657046079636,
    "CMY_Y": 0.33428037166595,
    "CMYK_C": 0,
    "CMYK_M": 0.12313322722912,
    "CMYK_Y": 0.14585572481155,
    "CMYK_K": 0.2206004858017
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16135",
    "Farbtonhilfsbezeichnung": "16135",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 67,
    "L": 85.6966171264648,
    "a": 4.72302007675171,
    "b": 3.02918910980225,
    "C": 5.61096286773682,
    "h": 32.6747703552246,
    "CMY_C": 0.11400485038757,
    "CMY_M": 0.17152535915375,
    "CMY_Y": 0.18785953521729,
    "CMYK_C": 0,
    "CMYK_M": 0.06492192298174,
    "CMYK_Y": 0.08335788547993,
    "CMYK_K": 0.11400485038757
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16136",
    "Farbtonhilfsbezeichnung": "16136",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "68",
    "Bcolor": "58",
    "Y": 9,
    "L": 36.7849197387695,
    "a": 26.5259761810303,
    "b": 18.1535301208496,
    "C": 32.1430892944336,
    "h": 34.3864898681641,
    "CMY_C": 0.48073148727417,
    "CMY_M": 0.73195821046829,
    "CMY_Y": 0.77193987369537,
    "CMYK_C": 0,
    "CMYK_M": 0.48380890488625,
    "CMYK_Y": 0.56080502271652,
    "CMYK_K": 0.48073148727417
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16137",
    "Farbtonhilfsbezeichnung": "16137",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "113",
    "Bcolor": "106",
    "Y": 23,
    "L": 54.3779907226563,
    "a": 25.0241718292236,
    "b": 14.3385438919067,
    "C": 28.8409957885742,
    "h": 29.8121814727783,
    "CMY_C": 0.30201560258865,
    "CMY_M": 0.55639082193375,
    "CMY_Y": 0.58572065830231,
    "CMYK_C": 0,
    "CMYK_M": 0.36444255709648,
    "CMYK_Y": 0.40646332502365,
    "CMYK_K": 0.30201560258865
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16138",
    "Farbtonhilfsbezeichnung": "16138",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "92",
    "Bcolor": "88",
    "Y": 15,
    "L": 45.8259582519531,
    "a": 24.4280643463135,
    "b": 12.7649021148682,
    "C": 27.5621662139893,
    "h": 27.5893478393555,
    "CMY_C": 0.4011532664299,
    "CMY_M": 0.638188123703,
    "CMY_Y": 0.65652394294739,
    "CMYK_C": 0,
    "CMYK_M": 0.39581888914108,
    "CMYK_Y": 0.42643746733665,
    "CMYK_K": 0.4011532664299
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16139",
    "Farbtonhilfsbezeichnung": "16139",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "109",
    "Bcolor": "100",
    "Y": 20,
    "L": 51.9694557189941,
    "a": 22.635066986084,
    "b": 13.9872722625732,
    "C": 26.608081817627,
    "h": 31.7138690948486,
    "CMY_C": 0.34240615367889,
    "CMY_M": 0.57317835092545,
    "CMY_Y": 0.60691231489182,
    "CMYK_C": 0,
    "CMYK_M": 0.35093423724174,
    "CMYK_Y": 0.40223333239555,
    "CMYK_K": 0.34240615367889
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16140",
    "Farbtonhilfsbezeichnung": "16140",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "142",
    "Bcolor": "137",
    "Y": 33,
    "L": 63.6594085693359,
    "a": 18.0214233398438,
    "b": 9.45153999328613,
    "C": 20.3495292663574,
    "h": 27.6752738952637,
    "CMY_C": 0.25012946128845,
    "CMY_M": 0.44146275520325,
    "CMY_Y": 0.46245789527893,
    "CMYK_C": 0,
    "CMYK_M": 0.25515511631966,
    "CMYK_Y": 0.28315344452858,
    "CMYK_K": 0.25012946128845
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16141",
    "Farbtonhilfsbezeichnung": "16141",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "179",
    "Bcolor": "173",
    "Y": 50,
    "L": 75.8237228393555,
    "a": 11.5577058792114,
    "b": 6.92641067504883,
    "C": 13.4742622375488,
    "h": 30.9338111877441,
    "CMY_C": 0.16386586427689,
    "CMY_M": 0.29649913311005,
    "CMY_Y": 0.32054054737091,
    "CMYK_C": 0,
    "CMYK_M": 0.1586267799139,
    "CMYK_Y": 0.18737983703613,
    "CMYK_K": 0.16386586427689
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16142",
    "Farbtonhilfsbezeichnung": "16142",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "210",
    "Bcolor": "202",
    "Y": 68,
    "L": 86.0303802490234,
    "a": 7.70501852035522,
    "b": 6.41650009155273,
    "C": 10.0269031524658,
    "h": 39.7864799499512,
    "CMY_C": 0.0783863067627,
    "CMY_M": 0.17616927623749,
    "CMY_Y": 0.2085537314415,
    "CMYK_C": 0,
    "CMYK_M": 0.10609973222017,
    "CMYK_Y": 0.14123860001564,
    "CMYK_K": 0.0783863067627
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16143",
    "Farbtonhilfsbezeichnung": "16143",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "101",
    "Bcolor": "99",
    "Y": 15,
    "L": 46.494743347168,
    "a": 15.5103073120117,
    "b": 6.44851303100586,
    "C": 16.7974090576172,
    "h": 22.5754222869873,
    "CMY_C": 0.45468455553055,
    "CMY_M": 0.60528790950775,
    "CMY_Y": 0.61105740070343,
    "CMYK_C": 0,
    "CMYK_M": 0.27617657184601,
    "CMYK_Y": 0.28675666451454,
    "CMYK_K": 0.45468455553055
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16144",
    "Farbtonhilfsbezeichnung": "16144",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "160",
    "Bcolor": "158",
    "Y": 38,
    "L": 67.6200866699219,
    "a": 8.11687469482422,
    "b": 3.2760591506958,
    "C": 8.7530689239502,
    "h": 21.9795398712158,
    "CMY_C": 0.28643417358398,
    "CMY_M": 0.37351077795029,
    "CMY_Y": 0.38090896606445,
    "CMYK_C": 0,
    "CMYK_M": 0.12203023582697,
    "CMYK_Y": 0.13239814341068,
    "CMYK_K": 0.28643417358398
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16145",
    "Farbtonhilfsbezeichnung": "16145",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "200",
    "Bcolor": "196",
    "Y": 60,
    "L": 81.6626892089844,
    "a": 4.96503925323486,
    "b": 3.13252568244934,
    "C": 5.87063312530518,
    "h": 32.2485084533691,
    "CMY_C": 0.15658354759216,
    "CMY_M": 0.21621161699295,
    "CMY_Y": 0.2321942448616,
    "CMYK_C": 0,
    "CMYK_M": 0.07069825381041,
    "CMYK_Y": 0.08964812010527,
    "CMYK_K": 0.15658354759216
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16146",
    "Farbtonhilfsbezeichnung": "16146",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "225",
    "Bcolor": "221",
    "Y": 77,
    "L": 89.9866409301758,
    "a": 2.82456541061401,
    "b": 2.06589365005493,
    "C": 3.49944090843201,
    "h": 36.1818237304688,
    "CMY_C": 0.08355790376663,
    "CMY_M": 0.11926251649857,
    "CMY_Y": 0.13414394855499,
    "CMYK_C": 0,
    "CMYK_M": 0.03896003216505,
    "CMYK_Y": 0.05519830062985,
    "CMYK_K": 0.08355790376663
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16147",
    "Farbtonhilfsbezeichnung": "16147",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "119",
    "Bcolor": "118",
    "Y": 20,
    "L": 51.7616310119629,
    "a": 7.28511047363281,
    "b": 3.00359439849854,
    "C": 7.88000106811523,
    "h": 22.4059734344482,
    "CMY_C": 0.45860707759857,
    "CMY_M": 0.53276282548904,
    "CMY_Y": 0.53892904520035,
    "CMYK_C": 0,
    "CMYK_M": 0.1369721442461,
    "CMYK_Y": 0.14836168289185,
    "CMYK_K": 0.45860707759857
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16148",
    "Farbtonhilfsbezeichnung": "16148",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "152",
    "Bcolor": "151",
    "Y": 33,
    "L": 64.280876159668,
    "a": 6.20150709152222,
    "b": 2.19432520866394,
    "C": 6.5782790184021,
    "h": 19.4856853485107,
    "CMY_C": 0.33812206983566,
    "CMY_M": 0.40331387519836,
    "CMY_Y": 0.40806651115417,
    "CMYK_C": 0,
    "CMYK_M": 0.09849520772696,
    "CMYK_Y": 0.10567574203014,
    "CMYK_K": 0.33812206983566
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16149",
    "Farbtonhilfsbezeichnung": "16149",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "178",
    "Bcolor": "177",
    "Y": 46,
    "L": 73.7100982666016,
    "a": 4.86916160583496,
    "b": 1.51760160923004,
    "C": 5.10018110275269,
    "h": 17.3110122680664,
    "CMY_C": 0.24890822172165,
    "CMY_M": 0.30106270313263,
    "CMY_Y": 0.30540668964386,
    "CMYK_C": 0,
    "CMYK_M": 0.06943822652102,
    "CMYK_Y": 0.07522179186344,
    "CMYK_K": 0.24890822172165
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16150",
    "Farbtonhilfsbezeichnung": "16150",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "201",
    "Bcolor": "199",
    "Y": 60,
    "L": 81.7496337890625,
    "a": 3.44194531440735,
    "b": 1.69869530200958,
    "C": 3.83830094337463,
    "h": 26.267614364624,
    "CMY_C": 0.17135816812515,
    "CMY_M": 0.21120154857635,
    "CMY_Y": 0.22110366821289,
    "CMYK_C": 0,
    "CMYK_M": 0.04808275401592,
    "CMYK_Y": 0.06003257259727,
    "CMYK_K": 0.17135816812515
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16151",
    "Farbtonhilfsbezeichnung": "16151",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "218",
    "Bcolor": "215",
    "Y": 71,
    "L": 87.3446884155273,
    "a": 2.065505027771,
    "b": 1.31884205341339,
    "C": 2.45064377784729,
    "h": 32.5585708618164,
    "CMY_C": 0.1212694644928,
    "CMY_M": 0.1464786529541,
    "CMY_Y": 0.15774083137512,
    "CMYK_C": 0,
    "CMYK_M": 0.02868819050491,
    "CMYK_Y": 0.04150461032987,
    "CMYK_K": 0.1212694644928
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16152",
    "Farbtonhilfsbezeichnung": "16152",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "81",
    "Bcolor": "76",
    "Y": 11,
    "L": 39.9441795349121,
    "a": 20.9221782684326,
    "b": 11.2771291732788,
    "C": 23.7678604125977,
    "h": 28.3248271942139,
    "CMY_C": 0.48456966876984,
    "CMY_M": 0.6836559176445,
    "CMY_Y": 0.70182740688324,
    "CMYK_C": 0,
    "CMYK_M": 0.38625249266624,
    "CMYK_Y": 0.42150747776031,
    "CMYK_K": 0.48456966876984
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16153",
    "Farbtonhilfsbezeichnung": "16153",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "122",
    "Bcolor": "123",
    "Y": 23,
    "L": 55.2756385803223,
    "a": 15.8786277770996,
    "b": 5.45152759552002,
    "C": 16.788387298584,
    "h": 18.9486198425293,
    "CMY_C": 0.36244624853134,
    "CMY_M": 0.51967287063599,
    "CMY_Y": 0.51936489343643,
    "CMYK_C": 0,
    "CMYK_M": 0.24660919606686,
    "CMYK_Y": 0.24612614512444,
    "CMYK_K": 0.36244624853134
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16154",
    "Farbtonhilfsbezeichnung": "16154",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "156",
    "Bcolor": "155",
    "Y": 37,
    "L": 66.9728469848633,
    "a": 11.2041854858398,
    "b": 3.96210432052612,
    "C": 11.884108543396,
    "h": 19.4749774932861,
    "CMY_C": 0.27067804336548,
    "CMY_M": 0.3880500793457,
    "CMY_Y": 0.39190512895584,
    "CMYK_C": 0,
    "CMYK_M": 0.16093309223652,
    "CMYK_Y": 0.16621889173985,
    "CMYK_K": 0.27067804336548
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16155",
    "Farbtonhilfsbezeichnung": "16155",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "182",
    "Bcolor": "180",
    "Y": 50,
    "L": 75.8965682983398,
    "a": 8.44295597076416,
    "b": 3.12352061271667,
    "C": 9.00221538543701,
    "h": 20.3022480010986,
    "CMY_C": 0.19489985704422,
    "CMY_M": 0.28686302900314,
    "CMY_Y": 0.29317885637283,
    "CMYK_C": 0,
    "CMYK_M": 0.11422575265169,
    "CMYK_Y": 0.12207052856684,
    "CMYK_K": 0.19489985704422
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16156",
    "Farbtonhilfsbezeichnung": "16156",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "98",
    "Bcolor": "97",
    "Y": 15,
    "L": 45.4713249206543,
    "a": 16.1008396148682,
    "b": 6.58741569519043,
    "C": 17.3962955474854,
    "h": 22.251184463501,
    "CMY_C": 0.46161091327667,
    "CMY_M": 0.6167323589325,
    "CMY_Y": 0.62156718969345,
    "CMYK_C": 0,
    "CMYK_M": 0.28812146186829,
    "CMYK_Y": 0.29710164666176,
    "CMYK_K": 0.46161091327667
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16157",
    "Farbtonhilfsbezeichnung": "16157",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "141",
    "Bcolor": "141",
    "Y": 30,
    "L": 61.0091018676758,
    "a": 10.2899599075317,
    "b": 3.03596043586731,
    "C": 10.7284822463989,
    "h": 16.4382209777832,
    "CMY_C": 0.34285426139832,
    "CMY_M": 0.44698536396027,
    "CMY_Y": 0.44658875465393,
    "CMYK_C": 0,
    "CMYK_M": 0.15845967829227,
    "CMYK_Y": 0.1578561514616,
    "CMYK_K": 0.34285426139832
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16158",
    "Farbtonhilfsbezeichnung": "16158",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "177",
    "Bcolor": "176",
    "Y": 47,
    "L": 73.9041595458984,
    "a": 7.2986216545105,
    "b": 2.41536259651184,
    "C": 7.68790292739868,
    "h": 18.3111400604248,
    "CMY_C": 0.22675353288651,
    "CMY_M": 0.3050941824913,
    "CMY_Y": 0.30937337875366,
    "CMYK_C": 0,
    "CMYK_M": 0.10131394118071,
    "CMYK_Y": 0.10684800893068,
    "CMYK_K": 0.22675353288651
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16159",
    "Farbtonhilfsbezeichnung": "16159",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "119",
    "Bcolor": "123",
    "Y": 21,
    "L": 52.1654815673828,
    "a": 9.91563320159912,
    "b": 0.43956291675568,
    "C": 9.92537117004395,
    "h": 2.53827667236328,
    "CMY_C": 0.44412386417389,
    "CMY_M": 0.53430986404419,
    "CMY_Y": 0.517702460289,
    "CMYK_C": 0,
    "CMYK_M": 0.16224117577076,
    "CMYK_Y": 0.13236509263515,
    "CMYK_K": 0.44412386417389
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16160",
    "Farbtonhilfsbezeichnung": "16160",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "145",
    "Bcolor": "149",
    "Y": 30,
    "L": 61.7811088562012,
    "a": 8.04511737823486,
    "b": -0.63425689935684,
    "C": 8.0700798034668,
    "h": 355.492279052734,
    "CMY_C": 0.3597714304924,
    "CMY_M": 0.43264806270599,
    "CMY_Y": 0.41404324769974,
    "CMYK_C": 0,
    "CMYK_M": 0.11382908374071,
    "CMYK_Y": 0.0847694426775,
    "CMYK_K": 0.3597714304924
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16161",
    "Farbtonhilfsbezeichnung": "16161",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "199",
    "Bcolor": "199",
    "Y": 58,
    "L": 80.7427673339844,
    "a": 3.27299332618713,
    "b": 0.18864616751671,
    "C": 3.27842545509338,
    "h": 3.29871869087219,
    "CMY_C": 0.18847161531448,
    "CMY_M": 0.22131431102753,
    "CMY_Y": 0.22107803821564,
    "CMYK_C": 0,
    "CMYK_M": 0.04047017544508,
    "CMYK_Y": 0.04017902910709,
    "CMYK_K": 0.18847161531448
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16162",
    "Farbtonhilfsbezeichnung": "16162",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "87",
    "Bcolor": "89",
    "Y": 11,
    "L": 40.037956237793,
    "a": 12.4115304946899,
    "b": 2.98030543327332,
    "C": 12.7643375396729,
    "h": 13.5024461746216,
    "CMY_C": 0.54544425010681,
    "CMY_M": 0.65817564725876,
    "CMY_Y": 0.65027463436127,
    "CMYK_C": 0,
    "CMYK_M": 0.24800345301628,
    "CMYK_Y": 0.23062162101269,
    "CMYK_K": 0.54544425010681
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16163",
    "Farbtonhilfsbezeichnung": "16163",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "119",
    "Bcolor": "125",
    "Y": 20,
    "L": 51.6006317138672,
    "a": 8.14491939544678,
    "b": -1.82165658473969,
    "C": 8.34614562988281,
    "h": 347.392944335938,
    "CMY_C": 0.46751636266708,
    "CMY_M": 0.53507924079895,
    "CMY_Y": 0.50862431526184,
    "CMYK_C": 0,
    "CMYK_M": 0.12688253819942,
    "CMYK_Y": 0.07720040529966,
    "CMYK_K": 0.46751636266708
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16164",
    "Farbtonhilfsbezeichnung": "16164",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "149",
    "Bcolor": "154",
    "Y": 32,
    "L": 62.8729057312012,
    "a": 6.45971250534058,
    "b": -1.91332674026489,
    "C": 6.73711395263672,
    "h": 343.501037597656,
    "CMY_C": 0.3631004691124,
    "CMY_M": 0.41731590032578,
    "CMY_Y": 0.39430522918701,
    "CMYK_C": 0,
    "CMYK_M": 0.08512399345636,
    "CMYK_Y": 0.04899479076266,
    "CMYK_K": 0.3631004691124
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16165",
    "Farbtonhilfsbezeichnung": "16165",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "174",
    "Bcolor": "178",
    "Y": 46,
    "L": 72.0730133056641,
    "a": 5.20935583114624,
    "b": -1.45020294189453,
    "C": 5.40744638442993,
    "h": 344.443634033203,
    "CMY_C": 0.27318608760834,
    "CMY_M": 0.31841564178467,
    "CMY_Y": 0.30170291662216,
    "CMYK_C": 0,
    "CMYK_M": 0.06222989782691,
    "CMYK_Y": 0.03923539072275,
    "CMYK_K": 0.27318608760834
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16166",
    "Farbtonhilfsbezeichnung": "16166",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 56,
    "L": 79.7262802124023,
    "a": 4.35874128341675,
    "b": -0.25092515349388,
    "C": 4.36595773696899,
    "h": 356.705230712891,
    "CMY_C": 0.19284093379974,
    "CMY_M": 0.23479723930359,
    "CMY_Y": 0.22871571779251,
    "CMYK_C": 0,
    "CMYK_M": 0.0519802197814,
    "CMYK_Y": 0.04444574192166,
    "CMYK_K": 0.19284093379974
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16167",
    "Farbtonhilfsbezeichnung": "16167",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "122",
    "Bcolor": "121",
    "Y": 20,
    "L": 52.195629119873,
    "a": 4.52544689178467,
    "b": 1.28705620765686,
    "C": 4.70491075515747,
    "h": 15.8759756088257,
    "CMY_C": 0.47690451145172,
    "CMY_M": 0.52171891927719,
    "CMY_Y": 0.52370345592499,
    "CMYK_C": 0,
    "CMYK_M": 0.08567155897617,
    "CMYK_Y": 0.08946539461613,
    "CMYK_K": 0.47690451145172
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16168",
    "Farbtonhilfsbezeichnung": "16168",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "162",
    "Bcolor": "162",
    "Y": 37,
    "L": 67.212028503418,
    "a": 3.67107534408569,
    "b": 0.34871008992195,
    "C": 3.68759989738464,
    "h": 5.42616176605225,
    "CMY_C": 0.33045411109924,
    "CMY_M": 0.36644458770752,
    "CMY_Y": 0.36540937423706,
    "CMYK_C": 0,
    "CMYK_M": 0.0537535622716,
    "CMYK_Y": 0.05220741778612,
    "CMYK_K": 0.33045411109924
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16169",
    "Farbtonhilfsbezeichnung": "16169",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "192",
    "Bcolor": "192",
    "Y": 54,
    "L": 78.1498489379883,
    "a": 3.07567286491394,
    "b": 0.02880599163473,
    "C": 3.07580780982971,
    "h": 0.53660237789154,
    "CMY_C": 0.21872305870056,
    "CMY_M": 0.24884843826294,
    "CMY_Y": 0.24782818555832,
    "CMYK_C": 0,
    "CMYK_M": 0.03855915740132,
    "CMYK_Y": 0.03725327923894,
    "CMYK_K": 0.21872305870056
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16170",
    "Farbtonhilfsbezeichnung": "16170",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "219",
    "Bcolor": "216",
    "Y": 72,
    "L": 87.7756271362305,
    "a": 1.70863628387451,
    "b": 1.07990777492523,
    "C": 2.02129626274109,
    "h": 32.2940788269043,
    "CMY_C": 0.12002736330032,
    "CMY_M": 0.14079719781876,
    "CMY_Y": 0.15131741762161,
    "CMYK_C": 0,
    "CMYK_M": 0.02360281907022,
    "CMYK_Y": 0.03555798530579,
    "CMYK_K": 0.12002736330032
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16171",
    "Farbtonhilfsbezeichnung": "16171",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "121",
    "Bcolor": "129",
    "Y": 21,
    "L": 52.3330268859863,
    "a": 6.72352027893066,
    "b": -3.21912026405334,
    "C": 7.45442533493042,
    "h": 334.415588378906,
    "CMY_C": 0.47364330291748,
    "CMY_M": 0.52413499355316,
    "CMY_Y": 0.49230724573135,
    "CMYK_C": 0,
    "CMYK_M": 0.09592675417662,
    "CMYK_Y": 0.03545873612165,
    "CMYK_K": 0.47364330291748
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16172",
    "Farbtonhilfsbezeichnung": "16172",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "151",
    "Bcolor": "158",
    "Y": 32,
    "L": 63.4985313415527,
    "a": 5.13898515701294,
    "b": -3.11241674423218,
    "C": 6.00802040100098,
    "h": 328.798889160156,
    "CMY_C": 0.36965018510818,
    "CMY_M": 0.40744000673294,
    "CMY_Y": 0.37979990243912,
    "CMYK_C": 0,
    "CMYK_M": 0.05995055660605,
    "CMYK_Y": 0.0161017216742,
    "CMYK_K": 0.36965018510818
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16173",
    "Farbtonhilfsbezeichnung": "16173",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "126",
    "Bcolor": "135",
    "Y": 22,
    "L": 53.823112487793,
    "a": 5.31562805175781,
    "b": -4.06667184829712,
    "C": 6.69281101226807,
    "h": 322.582550048828,
    "CMY_C": 0.47083050012589,
    "CMY_M": 0.50584506988525,
    "CMY_Y": 0.4719540476799,
    "CMYK_C": 0,
    "CMYK_M": 0.06616891175508,
    "CMYK_Y": 0.00212322804146,
    "CMYK_K": 0.47083050012589
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16174",
    "Farbtonhilfsbezeichnung": "16174",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "162",
    "Bcolor": "170",
    "Y": 38,
    "L": 67.2602081298828,
    "a": 3.59898161888123,
    "b": -4.26324892044067,
    "C": 5.57924365997314,
    "h": 310.170654296875,
    "CMY_C": 0.34525084495544,
    "CMY_M": 0.3644751906395,
    "CMY_Y": 0.33288633823395,
    "CMYK_C": 0.01853433251381,
    "CMYK_M": 0.04735152795911,
    "CMYK_Y": 0,
    "CMYK_K": 0.33288633823395
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16175",
    "Farbtonhilfsbezeichnung": "16175",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "194",
    "Bcolor": "196",
    "Y": 54,
    "L": 78.4938888549805,
    "a": 1.3955329656601,
    "b": -1.97918999195099,
    "C": 2.421715259552,
    "h": 305.187774658203,
    "CMY_C": 0.23441106081009,
    "CMY_M": 0.24062746763229,
    "CMY_Y": 0.22996336221695,
    "CMYK_C": 0.00577595690265,
    "CMYK_M": 0.01384882815182,
    "CMYK_Y": 0,
    "CMYK_K": 0.22996336221695
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16176",
    "Farbtonhilfsbezeichnung": "16176",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "225",
    "Bcolor": "222",
    "Y": 77,
    "L": 89.9236373901367,
    "a": 1.30308711528778,
    "b": 1.3851717710495,
    "C": 1.90177202224731,
    "h": 46.7489547729492,
    "CMY_C": 0.09826749563217,
    "CMY_M": 0.11610698699951,
    "CMY_Y": 0.13002669811249,
    "CMYK_C": 0,
    "CMYK_M": 0.01978357322514,
    "CMYK_Y": 0.03522020205855,
    "CMYK_K": 0.09826749563217
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16177",
    "Farbtonhilfsbezeichnung": "16177",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "151",
    "Bcolor": "162",
    "Y": 32,
    "L": 62.7769927978516,
    "a": 2.48244953155518,
    "b": -6.65533781051636,
    "C": 7.10324430465698,
    "h": 290.45556640625,
    "CMY_C": 0.40853577852249,
    "CMY_M": 0.40778738260269,
    "CMY_Y": 0.36330598592758,
    "CMYK_C": 0.07103850692511,
    "CMYK_M": 0.06986306607723,
    "CMYK_Y": 0,
    "CMYK_K": 0.36330598592758
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16178",
    "Farbtonhilfsbezeichnung": "16178",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "182",
    "Bcolor": "190",
    "Y": 48,
    "L": 74.3830108642578,
    "a": 2.23208785057068,
    "b": -4.55284643173218,
    "C": 5.07056474685669,
    "h": 296.116973876953,
    "CMY_C": 0.28106826543808,
    "CMY_M": 0.28597265481949,
    "CMY_Y": 0.25560253858566,
    "CMYK_C": 0.03420985117555,
    "CMYK_M": 0.04079825431108,
    "CMYK_Y": 0,
    "CMYK_K": 0.25560253858566
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16179",
    "Farbtonhilfsbezeichnung": "16179",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "147",
    "Bcolor": "155",
    "Y": 30,
    "L": 61.2925872802734,
    "a": 2.57632064819336,
    "b": -4.86172676086426,
    "C": 5.50216436386108,
    "h": 297.919952392578,
    "CMY_C": 0.4168935418129,
    "CMY_M": 0.42379558086395,
    "CMY_Y": 0.3909205198288,
    "CMYK_C": 0.04264307394624,
    "CMYK_M": 0.05397499352694,
    "CMYK_Y": 0,
    "CMYK_K": 0.3909205198288
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16180",
    "Farbtonhilfsbezeichnung": "16180",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "179",
    "Bcolor": "183",
    "Y": 46,
    "L": 73.1789627075195,
    "a": 2.42025208473206,
    "b": -2.73773622512817,
    "C": 3.65415096282959,
    "h": 311.477783203125,
    "CMY_C": 0.28626626729965,
    "CMY_M": 0.29976969957352,
    "CMY_Y": 0.2812647819519,
    "CMYK_C": 0.00695873145014,
    "CMYK_M": 0.02574650198221,
    "CMYK_Y": 0,
    "CMYK_K": 0.2812647819519
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16181",
    "Farbtonhilfsbezeichnung": "16181",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 64,
    "L": 83.5064239501953,
    "a": 1.52942204475403,
    "b": -0.58154779672623,
    "C": 1.63625478744507,
    "h": 339.181182861328,
    "CMY_C": 0.17405706644058,
    "CMY_M": 0.18684911727905,
    "CMY_Y": 0.1858097910881,
    "CMYK_C": 0,
    "CMYK_M": 0.01548781432211,
    "CMYK_Y": 0.01422946341336,
    "CMYK_K": 0.17405706644058
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16182",
    "Farbtonhilfsbezeichnung": "16182",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "107",
    "Bcolor": "118",
    "Y": 15,
    "L": 45.8484954833984,
    "a": 3.77953696250916,
    "b": -6.02303504943848,
    "C": 7.1106858253479,
    "h": 302.108825683594,
    "CMY_C": 0.56702500581741,
    "CMY_M": 0.58038520812988,
    "CMY_Y": 0.53846770524979,
    "CMYK_C": 0.0618749782443,
    "CMYK_M": 0.09082247316837,
    "CMYK_Y": 0,
    "CMYK_K": 0.53846770524979
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16183",
    "Farbtonhilfsbezeichnung": "16183",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "131",
    "Bcolor": "142",
    "Y": 23,
    "L": 55.0360946655273,
    "a": 3.1880304813385,
    "b": -6.77172756195068,
    "C": 7.4846396446228,
    "h": 295.210357666016,
    "CMY_C": 0.4826597571373,
    "CMY_M": 0.48814928531647,
    "CMY_Y": 0.44194221496582,
    "CMYK_C": 0.07296294718981,
    "CMYK_M": 0.08279979228973,
    "CMYK_Y": 0,
    "CMYK_K": 0.44194221496582
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16184",
    "Farbtonhilfsbezeichnung": "16184",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "156",
    "Bcolor": "167",
    "Y": 34,
    "L": 64.5224380493164,
    "a": 1.61617040634155,
    "b": -6.64162349700928,
    "C": 6.83543491363525,
    "h": 283.676513671875,
    "CMY_C": 0.39700520038605,
    "CMY_M": 0.38778883218765,
    "CMY_Y": 0.34531569480896,
    "CMYK_C": 0.07895332574844,
    "CMYK_M": 0.06487575173378,
    "CMYK_Y": 0,
    "CMYK_K": 0.34531569480896
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16185",
    "Farbtonhilfsbezeichnung": "16185",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "181",
    "Bcolor": "191",
    "Y": 47,
    "L": 73.8883056640625,
    "a": 1.20471167564392,
    "b": -6.18846893310547,
    "C": 6.30463933944702,
    "h": 281.016021728516,
    "CMY_C": 0.30016201734543,
    "CMY_M": 0.28840327262878,
    "CMY_Y": 0.24943172931671,
    "CMYK_C": 0.06758917123079,
    "CMYK_M": 0.05192271620035,
    "CMYK_Y": 0,
    "CMYK_K": 0.24943172931671
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16186",
    "Farbtonhilfsbezeichnung": "16186",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "210",
    "Bcolor": "214",
    "Y": 65,
    "L": 84.1808166503906,
    "a": 0.34667029976845,
    "b": -3.18439126014709,
    "C": 3.20320582389832,
    "h": 276.213073730469,
    "CMY_C": 0.18495535850525,
    "CMY_M": 0.17593151330948,
    "CMY_Y": 0.15968066453934,
    "CMYK_C": 0.0300774872303,
    "CMYK_M": 0.01933889649808,
    "CMYK_Y": 0,
    "CMYK_K": 0.15968066453934
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16187",
    "Farbtonhilfsbezeichnung": "16187",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "122",
    "Bcolor": "132",
    "Y": 20,
    "L": 51.3460693359375,
    "a": 0.98596286773682,
    "b": -6.40322256088257,
    "C": 6.47868680953979,
    "h": 278.753601074219,
    "CMY_C": 0.53438222408295,
    "CMY_M": 0.52032709121704,
    "CMY_Y": 0.48182553052902,
    "CMYK_C": 0.10142663866282,
    "CMYK_M": 0.07430230826139,
    "CMYK_Y": 0,
    "CMYK_K": 0.48182553052902
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16188",
    "Farbtonhilfsbezeichnung": "16188",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "169",
    "Bcolor": "178",
    "Y": 40,
    "L": 69.067497253418,
    "a": 0.93641501665115,
    "b": -6.10118961334229,
    "C": 6.17263221740723,
    "h": 278.725708007813,
    "CMY_C": 0.352883040905,
    "CMY_M": 0.33891433477402,
    "CMY_Y": 0.3013841509819,
    "CMYK_C": 0.07371560484171,
    "CMYK_M": 0.05372077226639,
    "CMYK_Y": 0,
    "CMYK_K": 0.3013841509819
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16189",
    "Farbtonhilfsbezeichnung": "16189",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "204",
    "Bcolor": "212",
    "Y": 61,
    "L": 82.0635757446289,
    "a": 0.3479720056057,
    "b": -5.06599521636963,
    "C": 5.07793188095093,
    "h": 273.929351806641,
    "CMY_C": 0.21485894918442,
    "CMY_M": 0.19853818416595,
    "CMY_Y": 0.16915673017502,
    "CMYK_C": 0.05500702932477,
    "CMYK_M": 0.0353634133935,
    "CMYK_Y": 0,
    "CMYK_K": 0.16915673017502
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16190",
    "Farbtonhilfsbezeichnung": "16190",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "107",
    "Bcolor": "122",
    "Y": 15,
    "L": 45.2198944091797,
    "a": 1.30443835258484,
    "b": -9.86591339111328,
    "C": 9.95177364349365,
    "h": 277.531768798828,
    "CMY_C": 0.60472363233566,
    "CMY_M": 0.58009701967239,
    "CMY_Y": 0.52013981342316,
    "CMYK_C": 0.17626763880253,
    "CMYK_M": 0.12494724243879,
    "CMYK_Y": 0,
    "CMYK_K": 0.52013981342316
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16191",
    "Farbtonhilfsbezeichnung": "16191",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "150",
    "Bcolor": "166",
    "Y": 30,
    "L": 61.5559158325195,
    "a": -0.75652021169662,
    "b": -10.690052986145,
    "C": 10.7167882919312,
    "h": 265.951995849609,
    "CMY_C": 0.46170479059219,
    "CMY_M": 0.41202914714813,
    "CMY_Y": 0.34877067804337,
    "CMYK_C": 0.17341680824757,
    "CMYK_M": 0.09713701158762,
    "CMYK_Y": 0,
    "CMYK_K": 0.34877067804337
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16192",
    "Farbtonhilfsbezeichnung": "16192",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "180",
    "Bcolor": "193",
    "Y": 45,
    "L": 72.7684631347656,
    "a": -0.98065984249115,
    "b": -8.85884380340576,
    "C": 8.91295719146729,
    "h": 263.683166503906,
    "CMY_C": 0.33965235948563,
    "CMY_M": 0.29459744691849,
    "CMY_Y": 0.24280434846878,
    "CMYK_C": 0.12790355086327,
    "CMYK_M": 0.06840121001005,
    "CMYK_Y": 0,
    "CMYK_K": 0.24280434846878
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16193",
    "Farbtonhilfsbezeichnung": "16193",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "204",
    "Bcolor": "212",
    "Y": 60,
    "L": 81.4116744995117,
    "a": -1.33619034290314,
    "b": -5.99055433273315,
    "C": 6.13776397705078,
    "h": 257.426025390625,
    "CMY_C": 0.23896259069443,
    "CMY_M": 0.20149320363998,
    "CMY_Y": 0.16979467868805,
    "CMYK_C": 0.08331422507763,
    "CMYK_M": 0.03818154707551,
    "CMYK_Y": 0,
    "CMYK_K": 0.16979467868805
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16194",
    "Farbtonhilfsbezeichnung": "16194",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "127",
    "Bcolor": "142",
    "Y": 21,
    "L": 52.7848052978516,
    "a": -0.70953726768494,
    "b": -9.93614959716797,
    "C": 9.96145153045654,
    "h": 265.915466308594,
    "CMY_C": 0.5464893579483,
    "CMY_M": 0.50138461589813,
    "CMY_Y": 0.44413870573044,
    "CMYK_C": 0.18412984907627,
    "CMYK_M": 0.10298596322536,
    "CMYK_Y": 0,
    "CMYK_K": 0.44413870573044
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16195",
    "Farbtonhilfsbezeichnung": "16195",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "163",
    "Bcolor": "177",
    "Y": 36,
    "L": 66.4039840698242,
    "a": -0.56262814998627,
    "b": -9.41638565063477,
    "C": 9.43317890167236,
    "h": 266.580657958984,
    "CMY_C": 0.40510326623917,
    "CMY_M": 0.36252778768539,
    "CMY_Y": 0.30661469697952,
    "CMYK_C": 0.14204017817974,
    "CMYK_M": 0.08063783496618,
    "CMYK_Y": 0,
    "CMYK_K": 0.30661469697952
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16196",
    "Farbtonhilfsbezeichnung": "16196",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "189",
    "Bcolor": "198",
    "Y": 51,
    "L": 76.3567047119141,
    "a": -0.08657796680927,
    "b": -6.06220388412476,
    "C": 6.06282186508179,
    "h": 269.181793212891,
    "CMY_C": 0.2835499048233,
    "CMY_M": 0.25905382633209,
    "CMY_Y": 0.22396212816238,
    "CMYK_C": 0.07678462564945,
    "CMYK_M": 0.04521905258298,
    "CMYK_Y": 0,
    "CMYK_K": 0.22396212816238
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16197",
    "Farbtonhilfsbezeichnung": "16197",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "213",
    "Bcolor": "216",
    "Y": 67,
    "L": 85.1928863525391,
    "a": -0.44111111760139,
    "b": -2.79162049293518,
    "C": 2.826256275177,
    "h": 261.020782470703,
    "CMY_C": 0.17873191833496,
    "CMY_M": 0.1630933880806,
    "CMY_Y": 0.15156584978104,
    "CMYK_C": 0.03201906383038,
    "CMYK_M": 0.01358683872968,
    "CMYK_Y": 0,
    "CMYK_K": 0.15156584978104
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16198",
    "Farbtonhilfsbezeichnung": "16198",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "142",
    "Bcolor": "175",
    "Y": 25,
    "L": 56.933708190918,
    "a": -6.9013729095459,
    "b": -23.1827201843262,
    "C": 24.1881675720215,
    "h": 253.422012329102,
    "CMY_C": 0.63210481405258,
    "CMY_M": 0.44266206026077,
    "CMY_Y": 0.31284993886948,
    "CMYK_C": 0.46460720896721,
    "CMYK_M": 0.18891379237175,
    "CMYK_Y": 0,
    "CMYK_K": 0.31284993886948
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16199",
    "Farbtonhilfsbezeichnung": "16199",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "169",
    "Bcolor": "198",
    "Y": 37,
    "L": 67.0934829711914,
    "a": -6.51806831359863,
    "b": -20.2850780487061,
    "C": 21.3065624237061,
    "h": 252.186584472656,
    "CMY_C": 0.50309813022614,
    "CMY_M": 0.33913052082062,
    "CMY_Y": 0.22420245409012,
    "CMYK_C": 0.35949543118477,
    "CMYK_M": 0.14814183115959,
    "CMYK_Y": 0,
    "CMYK_K": 0.22420245409012
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16200",
    "Farbtonhilfsbezeichnung": "16200",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "188",
    "Bcolor": "211",
    "Y": 48,
    "L": 74.4416198730469,
    "a": -6.15192174911499,
    "b": -16.1010513305664,
    "C": 17.2362995147705,
    "h": 249.089050292969,
    "CMY_C": 0.39938735961914,
    "CMY_M": 0.26314157247543,
    "CMY_Y": 0.17388939857483,
    "CMYK_C": 0.27296340465546,
    "CMYK_M": 0.10803901404142,
    "CMYK_Y": 0,
    "CMYK_K": 0.17388939857483
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16201",
    "Farbtonhilfsbezeichnung": "16201",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "214",
    "Bcolor": "228",
    "Y": 65,
    "L": 83.9028930664063,
    "a": -6.68744659423828,
    "b": -11.2104358673096,
    "C": 13.0535745620728,
    "h": 239.182342529297,
    "CMY_C": 0.27949589490891,
    "CMY_M": 0.16062837839127,
    "CMY_Y": 0.10514718294144,
    "CMYK_C": 0.19483506679535,
    "CMYK_M": 0.06200036033988,
    "CMYK_Y": 0,
    "CMYK_K": 0.10514718294144
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16202",
    "Farbtonhilfsbezeichnung": "16202",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "112",
    "Bcolor": "128",
    "Y": 16,
    "L": 46.1054573059082,
    "a": -2.86597180366516,
    "b": -11.9692678451538,
    "C": 12.3076057434082,
    "h": 256.534393310547,
    "CMY_C": 0.63797181844711,
    "CMY_M": 0.5623927116394,
    "CMY_Y": 0.4981672167778,
    "CMYK_C": 0.27858802676201,
    "CMYK_M": 0.12798185646534,
    "CMYK_Y": 0,
    "CMYK_K": 0.4981672167778
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16203",
    "Farbtonhilfsbezeichnung": "16203",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "137",
    "Bcolor": "157",
    "Y": 24,
    "L": 55.8892593383789,
    "a": -3.45785665512085,
    "b": -13.9381427764893,
    "C": 14.3606615066528,
    "h": 256.067016601563,
    "CMY_C": 0.55590689182281,
    "CMY_M": 0.46323591470718,
    "CMY_Y": 0.38589066267014,
    "CMYK_C": 0.27685010433197,
    "CMYK_M": 0.12594704329967,
    "CMYK_Y": 0,
    "CMYK_K": 0.38589066267014
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16204",
    "Farbtonhilfsbezeichnung": "16204",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "173",
    "Bcolor": "189",
    "Y": 41,
    "L": 69.6780395507813,
    "a": -2.45108079910278,
    "b": -11.1028366088867,
    "C": 11.3701705932617,
    "h": 257.550964355469,
    "CMY_C": 0.39350026845932,
    "CMY_M": 0.32346105575562,
    "CMY_Y": 0.26027566194534,
    "CMYK_C": 0.18010033667088,
    "CMYK_M": 0.08541748672724,
    "CMYK_Y": 0,
    "CMYK_K": 0.26027566194534
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16205",
    "Farbtonhilfsbezeichnung": "16205",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "202",
    "Bcolor": "214",
    "Y": 59,
    "L": 80.5716552734375,
    "a": -2.78075051307678,
    "b": -8.54027652740479,
    "C": 8.98158645629883,
    "h": 251.96452331543,
    "CMY_C": 0.27003109455109,
    "CMY_M": 0.20660263299942,
    "CMY_Y": 0.16072690486908,
    "CMYK_C": 0.13023672997952,
    "CMYK_M": 0.05466126278043,
    "CMYK_Y": 0,
    "CMYK_K": 0.16072690486908
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16206",
    "Farbtonhilfsbezeichnung": "16206",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "123",
    "Bcolor": "133",
    "Y": 20,
    "L": 50.8753890991211,
    "a": -1.77646231651306,
    "b": -7.48396301269531,
    "C": 7.69191265106201,
    "h": 256.646881103516,
    "CMY_C": 0.56394475698471,
    "CMY_M": 0.51891821622849,
    "CMY_Y": 0.4797168970108,
    "CMYK_C": 0.16188850998878,
    "CMYK_M": 0.07534613460302,
    "CMYK_Y": 0,
    "CMYK_K": 0.4797168970108
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16207",
    "Farbtonhilfsbezeichnung": "16207",
    "Farbtonklasse": "01",
    "Rcolor": "153",
    "Gcolor": "166",
    "Bcolor": "179",
    "Y": 38,
    "L": 67.5554809570313,
    "a": -1.81054294109344,
    "b": -9.03454208374023,
    "C": 9.2141752243042,
    "h": 258.667907714844,
    "CMY_C": 0.40171188116074,
    "CMY_M": 0.34784865379333,
    "CMY_Y": 0.29723638296127,
    "CMYK_C": 0.14866378903389,
    "CMYK_M": 0.07201891392469,
    "CMYK_Y": 0,
    "CMYK_K": 0.29723638296127
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16208",
    "Farbtonhilfsbezeichnung": "16208",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "197",
    "Bcolor": "206",
    "Y": 56,
    "L": 79.1513214111328,
    "a": -1.2648845911026,
    "b": -6.21223449707031,
    "C": 6.33969974517822,
    "h": 258.4912109375,
    "CMY_C": 0.26361155509949,
    "CMY_M": 0.22616124153137,
    "CMY_Y": 0.19279706478119,
    "CMYK_C": 0.08772823959589,
    "CMYK_M": 0.04133307188749,
    "CMYK_Y": 0,
    "CMYK_K": 0.19279706478119
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16209",
    "Farbtonhilfsbezeichnung": "16209",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "224",
    "Bcolor": "226",
    "Y": 74,
    "L": 88.6594619750977,
    "a": -1.59521675109863,
    "b": -3.02626872062683,
    "C": 3.42096757888794,
    "h": 242.20524597168,
    "CMY_C": 0.15076982975006,
    "CMY_M": 0.12203615903854,
    "CMY_Y": 0.11184239387512,
    "CMYK_C": 0.04382942244411,
    "CMYK_M": 0.01147742848843,
    "CMYK_Y": 0,
    "CMYK_K": 0.11184239387512
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16210",
    "Farbtonhilfsbezeichnung": "16210",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "131",
    "Bcolor": "161",
    "Y": 20,
    "L": 51.7042007446289,
    "a": -11.4544258117676,
    "b": -22.8960475921631,
    "C": 25.6014232635498,
    "h": 243.422134399414,
    "CMY_C": 0.74220931529999,
    "CMY_M": 0.48713946342468,
    "CMY_Y": 0.37000513076782,
    "CMYK_C": 0.59080511331558,
    "CMYK_M": 0.18592903017998,
    "CMYK_Y": 0,
    "CMYK_K": 0.37000513076782
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16211",
    "Farbtonhilfsbezeichnung": "16211",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "156",
    "Bcolor": "183",
    "Y": 31,
    "L": 61.9870834350586,
    "a": -8.65349102020264,
    "b": -19.9691276550293,
    "C": 21.7634773254395,
    "h": 246.570816040039,
    "CMY_C": 0.57647597789764,
    "CMY_M": 0.38830316066742,
    "CMY_Y": 0.28135758638382,
    "CMYK_C": 0.41066098213196,
    "CMYK_M": 0.14881612360477,
    "CMYK_Y": 0,
    "CMYK_K": 0.28135758638382
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16212",
    "Farbtonhilfsbezeichnung": "16212",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "181",
    "Bcolor": "203",
    "Y": 44,
    "L": 71.6419830322266,
    "a": -7.56159496307373,
    "b": -16.3158187866211,
    "C": 17.9828720092773,
    "h": 245.134552001953,
    "CMY_C": 0.4433354139328,
    "CMY_M": 0.29007321596146,
    "CMY_Y": 0.20297652482986,
    "CMYK_C": 0.30157065391541,
    "CMYK_M": 0.10927744954824,
    "CMYK_Y": 0,
    "CMYK_K": 0.20297652482986
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16213",
    "Farbtonhilfsbezeichnung": "16213",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "141",
    "Bcolor": "160",
    "Y": 25,
    "L": 56.7358665466309,
    "a": -7.13035917282104,
    "b": -14.5674953460693,
    "C": 16.218936920166,
    "h": 243.919616699219,
    "CMY_C": 0.58372342586517,
    "CMY_M": 0.44707059860229,
    "CMY_Y": 0.37324273586273,
    "CMYK_C": 0.3358248770237,
    "CMYK_M": 0.11779338866472,
    "CMYK_Y": 0,
    "CMYK_K": 0.37324273586273
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16214",
    "Farbtonhilfsbezeichnung": "16214",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "172",
    "Bcolor": "191",
    "Y": 38,
    "L": 68.4443664550781,
    "a": -6.24187612533569,
    "b": -14.4809637069702,
    "C": 15.7689352035523,
    "h": 246.682022094727,
    "CMY_C": 0.45506596565247,
    "CMY_M": 0.32735842466354,
    "CMY_Y": 0.25022560358047,
    "CMYK_C": 0.27320265769958,
    "CMYK_M": 0.10287470370531,
    "CMYK_Y": 0,
    "CMYK_K": 0.25022560358047
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16215",
    "Farbtonhilfsbezeichnung": "16215",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "196",
    "Bcolor": "208",
    "Y": 54,
    "L": 78.1089019775391,
    "a": -4.23600292205811,
    "b": -9.1122350692749,
    "C": 10.0487089157104,
    "h": 245.06770324707,
    "CMY_C": 0.31109809875488,
    "CMY_M": 0.22993510961533,
    "CMY_Y": 0.18365639448166,
    "CMYK_C": 0.15611281991005,
    "CMYK_M": 0.05669023841619,
    "CMYK_Y": 0,
    "CMYK_K": 0.18365639448166
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16216",
    "Farbtonhilfsbezeichnung": "16216",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "220",
    "Bcolor": "225",
    "Y": 71,
    "L": 86.93505859375,
    "a": -3.26180744171143,
    "b": -4.9587869644165,
    "C": 5.9353985786438,
    "h": 236.663757324219,
    "CMY_C": 0.19071847200394,
    "CMY_M": 0.13673406839371,
    "CMY_Y": 0.11690813302994,
    "CMYK_C": 0.0835817232728,
    "CMYK_M": 0.02245059236884,
    "CMYK_Y": 0,
    "CMYK_K": 0.11690813302994
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16217",
    "Farbtonhilfsbezeichnung": "16217",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "127",
    "Bcolor": "142",
    "Y": 20,
    "L": 51.3598442077637,
    "a": -6.83639907836914,
    "b": -12.2336893081665,
    "C": 14.0142612457275,
    "h": 240.802780151367,
    "CMY_C": 0.6225118637085,
    "CMY_M": 0.50263833999634,
    "CMY_Y": 0.44398146867752,
    "CMYK_C": 0.3210871219635,
    "CMYK_M": 0.10549445450306,
    "CMYK_Y": 0,
    "CMYK_K": 0.44398146867752
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16218",
    "Farbtonhilfsbezeichnung": "16218",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "178",
    "Bcolor": "193",
    "Y": 43,
    "L": 71.0400772094727,
    "a": -6.63506507873535,
    "b": -11.2753190994263,
    "C": 13.0826950073242,
    "h": 239.524932861328,
    "CMY_C": 0.41614180803299,
    "CMY_M": 0.30000925064087,
    "CMY_Y": 0.24493932723999,
    "CMYK_C": 0.22674003243446,
    "CMYK_M": 0.07293443381786,
    "CMYK_Y": 0,
    "CMYK_K": 0.24493932723999
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16219",
    "Farbtonhilfsbezeichnung": "16219",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "135",
    "Bcolor": "143",
    "Y": 23,
    "L": 55.3548927307129,
    "a": -4.00857734680176,
    "b": -7.07219314575195,
    "C": 8.12924385070801,
    "h": 240.455078125,
    "CMY_C": 0.53569710254669,
    "CMY_M": 0.46956968307495,
    "CMY_Y": 0.4374971985817,
    "CMYK_C": 0.17457674443722,
    "CMYK_M": 0.05701746791601,
    "CMYK_Y": 0,
    "CMYK_K": 0.4374971985817
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16220",
    "Farbtonhilfsbezeichnung": "16220",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "175",
    "Bcolor": "182",
    "Y": 42,
    "L": 70.2574615478516,
    "a": -4.27519702911377,
    "b": -6.45121812820435,
    "C": 7.7392201423645,
    "h": 236.467727661133,
    "CMY_C": 0.38337844610214,
    "CMY_M": 0.31477504968643,
    "CMY_Y": 0.28694927692413,
    "CMYK_C": 0.13523465394974,
    "CMYK_M": 0.03902355208993,
    "CMYK_Y": 0,
    "CMYK_K": 0.28694927692413
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16221",
    "Farbtonhilfsbezeichnung": "16221",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "205",
    "Bcolor": "209",
    "Y": 59,
    "L": 81.3480377197266,
    "a": -3.87316083908081,
    "b": -4.67246246337891,
    "C": 6.06904268264771,
    "h": 230.343536376953,
    "CMY_C": 0.25537365674973,
    "CMY_M": 0.19684243202209,
    "CMY_Y": 0.18033939599991,
    "CMYK_C": 0.09154308587313,
    "CMYK_M": 0.02013398706913,
    "CMYK_Y": 0,
    "CMYK_K": 0.18033939599991
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16222",
    "Farbtonhilfsbezeichnung": "16222",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "223",
    "Bcolor": "220",
    "Y": 74,
    "L": 88.5641403198242,
    "a": -1.47615218162537,
    "b": 0.02053727395833,
    "C": 1.47629499435425,
    "h": 179.202911376953,
    "CMY_C": 0.13992518186569,
    "CMY_M": 0.12425136566162,
    "CMY_Y": 0.13530969619751,
    "CMYK_C": 0.01789762079716,
    "CMYK_M": 0,
    "CMYK_Y": 0.01262728869915,
    "CMYK_K": 0.12425136566162
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16223",
    "Farbtonhilfsbezeichnung": "16223",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "167",
    "Bcolor": "180",
    "Y": 36,
    "L": 65.9794692993164,
    "a": -10.8314323425293,
    "b": -11.9386177062988,
    "C": 16.1198787689209,
    "h": 227.783798217773,
    "CMY_C": 0.5106195807457,
    "CMY_M": 0.34480088949203,
    "CMY_Y": 0.29470199346542,
    "CMYK_C": 0.30613666772842,
    "CMYK_M": 0.07103224098682,
    "CMYK_Y": 0,
    "CMYK_K": 0.29470199346542
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16224",
    "Farbtonhilfsbezeichnung": "16224",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "197",
    "Bcolor": "207",
    "Y": 53,
    "L": 77.6921234130859,
    "a": -8.3401050567627,
    "b": -8.99892997741699,
    "C": 12.2693967819214,
    "h": 227.175994873047,
    "CMY_C": 0.35081672668457,
    "CMY_M": 0.22561007738113,
    "CMY_Y": 0.18947911262512,
    "CMYK_C": 0.19905422627926,
    "CMYK_M": 0.04457746446133,
    "CMYK_Y": 0,
    "CMYK_K": 0.18947911262512
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16225",
    "Farbtonhilfsbezeichnung": "16225",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "156",
    "Bcolor": "160",
    "Y": 31,
    "L": 62.2328681945801,
    "a": -8.55191326141357,
    "b": -6.23221635818481,
    "C": 10.5818586349487,
    "h": 216.082733154297,
    "CMY_C": 0.50101101398468,
    "CMY_M": 0.39015120267868,
    "CMY_Y": 0.37311452627182,
    "CMYK_C": 0.20401890575886,
    "CMYK_M": 0.02717669680715,
    "CMYK_Y": 0,
    "CMYK_K": 0.37311452627182
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16226",
    "Farbtonhilfsbezeichnung": "16226",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "181",
    "Bcolor": "181",
    "Y": 44,
    "L": 71.9461288452148,
    "a": -7.49526071548462,
    "b": -3.72915863990784,
    "C": 8.37171173095703,
    "h": 206.45198059082,
    "CMY_C": 0.3816402554512,
    "CMY_M": 0.29074561595917,
    "CMY_Y": 0.28858226537704,
    "CMYK_C": 0.13080640137196,
    "CMYK_M": 0.00304090045393,
    "CMYK_Y": 0,
    "CMYK_K": 0.28858226537704
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16227",
    "Farbtonhilfsbezeichnung": "16227",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "206",
    "Bcolor": "207",
    "Y": 59,
    "L": 81.2082061767578,
    "a": -6.27100944519043,
    "b": -3.90814113616943,
    "C": 7.38912200927734,
    "h": 211.93147277832,
    "CMY_C": 0.27387177944183,
    "CMY_M": 0.19328188896179,
    "CMY_Y": 0.18769001960754,
    "CMYK_C": 0.10609467327595,
    "CMYK_M": 0.00688391085714,
    "CMYK_Y": 0,
    "CMYK_K": 0.18769001960754
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16228",
    "Farbtonhilfsbezeichnung": "16228",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "132",
    "Bcolor": "137",
    "Y": 23,
    "L": 54.4251708984375,
    "a": -1.94650423526764,
    "b": -4.38308572769165,
    "C": 4.79586458206177,
    "h": 246.054260253906,
    "CMY_C": 0.51857978105545,
    "CMY_M": 0.48394405841827,
    "CMY_Y": 0.46464467048645,
    "CMYK_C": 0.10074637830257,
    "CMYK_M": 0.0360496789217,
    "CMYK_Y": 0,
    "CMYK_K": 0.46464467048645
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16229",
    "Farbtonhilfsbezeichnung": "16229",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "188",
    "Bcolor": "188",
    "Y": 49,
    "L": 75.5491638183594,
    "a": -3.31464266777039,
    "b": -2.14438652992249,
    "C": 3.94781589508057,
    "h": 212.900573730469,
    "CMY_C": 0.30345743894577,
    "CMY_M": 0.26161968708038,
    "CMY_Y": 0.26096040010452,
    "CMYK_C": 0.05750305950642,
    "CMYK_M": 0.00089208612917,
    "CMYK_Y": 0,
    "CMYK_K": 0.26096040010452
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16230",
    "Farbtonhilfsbezeichnung": "16230",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "154",
    "Bcolor": "147",
    "Y": 30,
    "L": 61.3546905517578,
    "a": -10.0276908874512,
    "b": -0.47374692559242,
    "C": 10.038875579834,
    "h": 182.704864501953,
    "CMY_C": 0.49879664182663,
    "CMY_M": 0.39787197113037,
    "CMY_Y": 0.42176496982574,
    "CMYK_C": 0.16761331260204,
    "CMYK_M": 0,
    "CMYK_Y": 0.03968092799187,
    "CMYK_K": 0.39787197113037
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16231",
    "Farbtonhilfsbezeichnung": "16231",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "185",
    "Bcolor": "179",
    "Y": 47,
    "L": 73.4962387084961,
    "a": -8.18759346008301,
    "b": -0.16203813254833,
    "C": 8.18919658660889,
    "h": 181.133773803711,
    "CMY_C": 0.35734611749649,
    "CMY_M": 0.27368199825287,
    "CMY_Y": 0.29748994112015,
    "CMYK_C": 0.11518938094378,
    "CMYK_M": 0,
    "CMYK_Y": 0.03277895227075,
    "CMYK_K": 0.27368199825287
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16232",
    "Farbtonhilfsbezeichnung": "16232",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "213",
    "Bcolor": "205",
    "Y": 64,
    "L": 83.7877426147461,
    "a": -7.68029022216797,
    "b": 0.96887904405594,
    "C": 7.74116182327271,
    "h": 172.810043334961,
    "CMY_C": 0.23917764425278,
    "CMY_M": 0.16326874494553,
    "CMY_Y": 0.19527018070221,
    "CMYK_C": 0.09072076529264,
    "CMYK_M": 0,
    "CMYK_Y": 0.03824577480555,
    "CMYK_K": 0.16326874494553
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16233",
    "Farbtonhilfsbezeichnung": "16233",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "152",
    "Bcolor": "148",
    "Y": 30,
    "L": 61.3726005554199,
    "a": -6.96698093414307,
    "b": -0.66117805242538,
    "C": 6.99828386306763,
    "h": 185.42121887207,
    "CMY_C": 0.47441691160202,
    "CMY_M": 0.40375429391861,
    "CMY_Y": 0.41993254423141,
    "CMYK_C": 0.11851257830858,
    "CMYK_M": 0,
    "CMYK_Y": 0.02713353000581,
    "CMYK_K": 0.40375429391861
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16234",
    "Farbtonhilfsbezeichnung": "16234",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "186",
    "Bcolor": "180",
    "Y": 48,
    "L": 74.5913925170898,
    "a": -4.10174942016602,
    "b": 1.34098374843597,
    "C": 4.31538963317871,
    "h": 161.895889282227,
    "CMY_C": 0.30756652355194,
    "CMY_M": 0.27111947536469,
    "CMY_Y": 0.29604816436768,
    "CMYK_C": 0.05000414699316,
    "CMYK_M": 0,
    "CMYK_Y": 0.03420133888721,
    "CMYK_K": 0.27111947536469
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16235",
    "Farbtonhilfsbezeichnung": "16235",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "202",
    "Bcolor": "194",
    "Y": 58,
    "L": 80.4707565307617,
    "a": -3.91125059127808,
    "b": 2.41190624237061,
    "C": 4.5951247215271,
    "h": 148.339584350586,
    "CMY_C": 0.23944407701492,
    "CMY_M": 0.20830458402634,
    "CMY_Y": 0.24103134870529,
    "CMYK_C": 0.03933266922832,
    "CMYK_M": 0,
    "CMYK_Y": 0.04133756831288,
    "CMYK_K": 0.20830458402634
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16236",
    "Farbtonhilfsbezeichnung": "16236",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "215",
    "Bcolor": "210",
    "Y": 67,
    "L": 85.3262710571289,
    "a": -2.54670906066895,
    "b": 0.53551650047302,
    "C": 2.60240364074707,
    "h": 168.124969482422,
    "CMY_C": 0.18228155374527,
    "CMY_M": 0.15771168470383,
    "CMY_Y": 0.17468702793121,
    "CMYK_C": 0.02917037904263,
    "CMYK_M": 0,
    "CMYK_Y": 0.02015383914113,
    "CMYK_K": 0.15771168470383
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16237",
    "Farbtonhilfsbezeichnung": "16237",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "167",
    "Bcolor": "144",
    "Y": 37,
    "L": 66.63037109375,
    "a": -9.36945819854736,
    "b": 9.41612148284912,
    "C": 13.2834520339966,
    "h": 134.857666015625,
    "CMY_C": 0.40560960769653,
    "CMY_M": 0.34649980068207,
    "CMY_Y": 0.43630021810532,
    "CMYK_C": 0.09045109152794,
    "CMYK_M": 0,
    "CMYK_Y": 0.13741451501846,
    "CMYK_K": 0.34649980068207
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16238",
    "Farbtonhilfsbezeichnung": "16238",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "217",
    "Bcolor": "202",
    "Y": 68,
    "L": 85.852294921875,
    "a": -5.12057399749756,
    "b": 5.57179117202759,
    "C": 7.56737327575684,
    "h": 132.583557128906,
    "CMY_C": 0.17985445261002,
    "CMY_M": 0.14742600917816,
    "CMY_Y": 0.20618283748627,
    "CMYK_C": 0.03803592920303,
    "CMYK_M": 0,
    "CMYK_Y": 0.06891698390245,
    "CMYK_K": 0.14742600917816
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16239",
    "Farbtonhilfsbezeichnung": "16239",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "164",
    "Bcolor": "137",
    "Y": 35,
    "L": 65.3419189453125,
    "a": -11.4893751144409,
    "b": 11.5404081344604,
    "C": 16.2845554351807,
    "h": 134.873046875,
    "CMY_C": 0.42875880002975,
    "CMY_M": 0.35623985528946,
    "CMY_Y": 0.46448588371277,
    "CMYK_C": 0.11264901608229,
    "CMYK_M": 0,
    "CMYK_Y": 0.16814652085304,
    "CMYK_K": 0.35623985528946
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16240",
    "Farbtonhilfsbezeichnung": "16240",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "219",
    "Bcolor": "201",
    "Y": 70,
    "L": 86.5796890258789,
    "a": -4.37521886825562,
    "b": 7.19775199890137,
    "C": 8.42319297790527,
    "h": 121.29370880127,
    "CMY_C": 0.1607009768486,
    "CMY_M": 0.14150059223175,
    "CMY_Y": 0.21013408899307,
    "CMYK_C": 0.02236505225301,
    "CMYK_M": 0,
    "CMYK_Y": 0.07994588464499,
    "CMYK_K": 0.14150059223175
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16241",
    "Farbtonhilfsbezeichnung": "16241",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "176",
    "Bcolor": "138",
    "Y": 42,
    "L": 70.4436798095703,
    "a": -8.61526393890381,
    "b": 18.2512264251709,
    "C": 20.1824188232422,
    "h": 115.269073486328,
    "CMY_C": 0.33515977859497,
    "CMY_M": 0.30967736244202,
    "CMY_Y": 0.45981138944626,
    "CMYK_C": 0.03691377863288,
    "CMYK_M": 0,
    "CMYK_Y": 0.21748384833336,
    "CMYK_K": 0.30967736244202
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16242",
    "Farbtonhilfsbezeichnung": "16242",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "205",
    "Bcolor": "183",
    "Y": 60,
    "L": 81.6009063720703,
    "a": -5.28712463378906,
    "b": 9.94303607940674,
    "C": 11.2613344192505,
    "h": 118.001434326172,
    "CMY_C": 0.21370202302933,
    "CMY_M": 0.19484305381775,
    "CMY_Y": 0.28370970487595,
    "CMYK_C": 0.02342272363603,
    "CMYK_M": 0,
    "CMYK_Y": 0.1103718355298,
    "CMYK_K": 0.19484305381775
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16243",
    "Farbtonhilfsbezeichnung": "16243",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "232",
    "Bcolor": "217",
    "Y": 80,
    "L": 91.3519668579102,
    "a": -3.27404117584229,
    "b": 5.88369846343994,
    "C": 6.73329448699951,
    "h": 119.094169616699,
    "CMY_C": 0.10343861579895,
    "CMY_M": 0.09064894914627,
    "CMY_Y": 0.14828455448151,
    "CMYK_C": 0.0140646090731,
    "CMYK_M": 0,
    "CMYK_Y": 0.06338103115559,
    "CMYK_K": 0.09064894914627
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16244",
    "Farbtonhilfsbezeichnung": "16244",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "148",
    "Bcolor": "144",
    "Y": 30,
    "L": 61.158374786377,
    "a": -0.46167880296707,
    "b": 1.28058552742004,
    "C": 1.3612664937973,
    "h": 109.825332641602,
    "CMY_C": 0.42053657770157,
    "CMY_M": 0.42014098167419,
    "CMY_Y": 0.43456727266312,
    "CMYK_C": 0.0006822279538,
    "CMYK_M": 0,
    "CMYK_Y": 0.02487896196544,
    "CMYK_K": 0.42014098167419
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16245",
    "Farbtonhilfsbezeichnung": "16245",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "185",
    "Bcolor": "180",
    "Y": 49,
    "L": 75.1105651855469,
    "a": -1.02302145957947,
    "b": 1.95346856117249,
    "C": 2.20513319969177,
    "h": 117.640815734863,
    "CMY_C": 0.27622079849243,
    "CMY_M": 0.27257239818573,
    "CMY_Y": 0.2944974899292,
    "CMYK_C": 0.00501548219472,
    "CMYK_M": 0,
    "CMYK_Y": 0.03014058247209,
    "CMYK_K": 0.27257239818573
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16246",
    "Farbtonhilfsbezeichnung": "16246",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "214",
    "Bcolor": "206",
    "Y": 68,
    "L": 85.4319152832031,
    "a": -1.62295687198639,
    "b": 3.0318500995636,
    "C": 3.43891024589539,
    "h": 118.160247802734,
    "CMY_C": 0.16535729169846,
    "CMY_M": 0.15936416387558,
    "CMY_Y": 0.19165563583374,
    "CMYK_C": 0.00712927943096,
    "CMYK_M": 0,
    "CMYK_Y": 0.03841315209866,
    "CMYK_K": 0.15936416387558
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16247",
    "Farbtonhilfsbezeichnung": "16247",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "131",
    "Bcolor": "103",
    "Y": 21,
    "L": 53.1027526855469,
    "a": -8.79198265075684,
    "b": 13.4677820205688,
    "C": 16.0835361480713,
    "h": 123.137138366699,
    "CMY_C": 0.52711176872253,
    "CMY_M": 0.48768836259842,
    "CMY_Y": 0.59784108400345,
    "CMYK_C": 0.07695200294256,
    "CMYK_M": 0,
    "CMYK_Y": 0.21501116454601,
    "CMYK_K": 0.48768836259842
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16248",
    "Farbtonhilfsbezeichnung": "16248",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "169",
    "Bcolor": "155",
    "Y": 39,
    "L": 68.6028747558594,
    "a": -3.00405406951904,
    "b": 6.2751522064209,
    "C": 6.95714569091797,
    "h": 115.581474304199,
    "CMY_C": 0.34659206867218,
    "CMY_M": 0.33841490745544,
    "CMY_Y": 0.39324957132339,
    "CMYK_C": 0.01235995348543,
    "CMYK_M": 0,
    "CMYK_Y": 0.08288376778364,
    "CMYK_K": 0.33841490745544
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16249",
    "Farbtonhilfsbezeichnung": "16249",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "189",
    "Bcolor": "177",
    "Y": 51,
    "L": 76.4662322998047,
    "a": -1.84967935085297,
    "b": 5.71253108978271,
    "C": 6.00452518463135,
    "h": 107.941604614258,
    "CMY_C": 0.25605142116547,
    "CMY_M": 0.25713849067688,
    "CMY_Y": 0.30709254741669,
    "CMYK_C": 0,
    "CMYK_M": 0.00146121589933,
    "CMYK_Y": 0.06860840320587,
    "CMYK_K": 0.25605142116547
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16250",
    "Farbtonhilfsbezeichnung": "16250",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "220",
    "Bcolor": "203",
    "Y": 70,
    "L": 87.230827331543,
    "a": -2.61218476295471,
    "b": 7.25157976150513,
    "C": 7.70771789550781,
    "h": 109.810180664063,
    "CMY_C": 0.13962525129318,
    "CMY_M": 0.13835376501083,
    "CMY_Y": 0.20322269201279,
    "CMYK_C": 0.00147564767394,
    "CMYK_M": 0,
    "CMYK_Y": 0.07528487592936,
    "CMYK_K": 0.13835376501083
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16251",
    "Farbtonhilfsbezeichnung": "16251",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "204",
    "Bcolor": "144",
    "Y": 56,
    "L": 79.7830581665039,
    "a": -13.8423194885254,
    "b": 27.8904495239258,
    "C": 31.1365852355957,
    "h": 116.395683288574,
    "CMY_C": 0.24957859516144,
    "CMY_M": 0.20015943050385,
    "CMY_Y": 0.43559587001801,
    "CMYK_C": 0.06178626790643,
    "CMYK_M": 0,
    "CMYK_Y": 0.29435420036316,
    "CMYK_K": 0.20015943050385
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16252",
    "Farbtonhilfsbezeichnung": "16252",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "175",
    "Y": 71,
    "L": 87.2297592163086,
    "a": -8.79221343994141,
    "b": 22.1876468658447,
    "C": 23.8661823272705,
    "h": 111.616744995117,
    "CMY_C": 0.14393955469131,
    "CMY_M": 0.12793928384781,
    "CMY_Y": 0.31465530395508,
    "CMYK_C": 0.01834765635431,
    "CMYK_M": 0,
    "CMYK_Y": 0.21410897374153,
    "CMYK_K": 0.12793928384781
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16253",
    "Farbtonhilfsbezeichnung": "16253",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "162",
    "Bcolor": "125",
    "Y": 35,
    "L": 65.7655334472656,
    "a": -6.0941948890686,
    "b": 18.6986103057861,
    "C": 19.6666526794434,
    "h": 108.051666259766,
    "CMY_C": 0.36531323194504,
    "CMY_M": 0.36431467533112,
    "CMY_Y": 0.5095534324646,
    "CMYK_C": 0.00157083477825,
    "CMYK_M": 0,
    "CMYK_Y": 0.22847586870193,
    "CMYK_K": 0.36431467533112
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16254",
    "Farbtonhilfsbezeichnung": "16254",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "187",
    "Bcolor": "138",
    "Y": 48,
    "L": 74.6965408325195,
    "a": -7.41641473770142,
    "b": 24.1895065307617,
    "C": 25.3008975982666,
    "h": 107.045349121094,
    "CMY_C": 0.26640063524246,
    "CMY_M": 0.26802957057953,
    "CMY_Y": 0.45919686555862,
    "CMYK_C": 0,
    "CMYK_M": 0.00222046999261,
    "CMYK_Y": 0.26280862092972,
    "CMYK_K": 0.26640063524246
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16255",
    "Farbtonhilfsbezeichnung": "16255",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "222",
    "Bcolor": "199",
    "Y": 71,
    "L": 87.7150039672852,
    "a": -3.7204213142395,
    "b": 10.2522106170654,
    "C": 10.9063901901245,
    "h": 109.9453125,
    "CMY_C": 0.13357031345367,
    "CMY_M": 0.13121223449707,
    "CMY_Y": 0.2202467918396,
    "CMYK_C": 0.00271421740763,
    "CMYK_M": 0,
    "CMYK_Y": 0.10248136520386,
    "CMYK_K": 0.13121223449707
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16256",
    "Farbtonhilfsbezeichnung": "16256",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "161",
    "Bcolor": "139",
    "Y": 35,
    "L": 65.7062835693359,
    "a": -2.85028791427612,
    "b": 10.977970123291,
    "C": 11.3419561386108,
    "h": 104.554740905762,
    "CMY_C": 0.36251145601273,
    "CMY_M": 0.37021690607071,
    "CMY_Y": 0.45561444759369,
    "CMYK_C": 0,
    "CMYK_M": 0.01208719797432,
    "CMYK_Y": 0.14604653418064,
    "CMYK_K": 0.36251145601273
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16257",
    "Farbtonhilfsbezeichnung": "16257",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "185",
    "Bcolor": "159",
    "Y": 48,
    "L": 74.9173965454102,
    "a": -3.17670249938965,
    "b": 13.0479049682617,
    "C": 13.4290456771851,
    "h": 103.68327331543,
    "CMY_C": 0.26135063171387,
    "CMY_M": 0.27257692813873,
    "CMY_Y": 0.37594616413116,
    "CMYK_C": 0,
    "CMYK_M": 0.01519841048867,
    "CMYK_Y": 0.15514199435711,
    "CMYK_K": 0.26135063171387
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16258",
    "Farbtonhilfsbezeichnung": "16258",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "210",
    "Y": 81,
    "L": 92.0283584594727,
    "a": -1.95835590362549,
    "b": 10.5662441253662,
    "C": 10.7461929321289,
    "h": 100.500091552734,
    "CMY_C": 0.07094603776932,
    "CMY_M": 0.08738780021667,
    "CMY_Y": 0.17549651861191,
    "CMYK_C": 0,
    "CMYK_M": 0.01769731752574,
    "CMYK_Y": 0.11253434419632,
    "CMYK_K": 0.07094603776932
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16259",
    "Farbtonhilfsbezeichnung": "16259",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "151",
    "Bcolor": "79",
    "Y": 30,
    "L": 61.9778861999512,
    "a": -6.44620323181152,
    "b": 38.4482536315918,
    "C": 38.9848899841309,
    "h": 99.5176467895508,
    "CMY_C": 0.3701388835907,
    "CMY_M": 0.40613514184952,
    "CMY_Y": 0.68941855430603,
    "CMYK_C": 0,
    "CMYK_M": 0.05714951828122,
    "CMYK_Y": 0.50690490007401,
    "CMYK_K": 0.3701388835907
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16260",
    "Farbtonhilfsbezeichnung": "16260",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "176",
    "Bcolor": "93",
    "Y": 41,
    "L": 70.1366500854492,
    "a": -12.2269334793091,
    "b": 41.4690971374512,
    "C": 43.234058380127,
    "h": 106.427856445313,
    "CMY_C": 0.31542831659317,
    "CMY_M": 0.30942571163177,
    "CMY_Y": 0.63456624746323,
    "CMYK_C": 0.00869219284505,
    "CMYK_M": 0,
    "CMYK_Y": 0.47082629799843,
    "CMYK_K": 0.30942571163177
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16261",
    "Farbtonhilfsbezeichnung": "16261",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "214",
    "Bcolor": "141",
    "Y": 64,
    "L": 84.0768203735352,
    "a": -11.1172971725464,
    "b": 35.416145324707,
    "C": 37.120044708252,
    "h": 107.427322387695,
    "CMY_C": 0.16506844758987,
    "CMY_M": 0.16023570299149,
    "CMY_Y": 0.44743978977203,
    "CMYK_C": 0.00575488200411,
    "CMYK_M": 0,
    "CMYK_Y": 0.34200558066368,
    "CMYK_K": 0.16023570299149
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16262",
    "Farbtonhilfsbezeichnung": "16262",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "132",
    "Bcolor": "108",
    "Y": 23,
    "L": 55.0521926879883,
    "a": -1.51714622974396,
    "b": 13.0001621246338,
    "C": 13.0883893966675,
    "h": 96.6564254760742,
    "CMY_C": 0.45843309164047,
    "CMY_M": 0.48271018266678,
    "CMY_Y": 0.57477688789368,
    "CMYK_C": 0,
    "CMYK_M": 0.04482750222087,
    "CMYK_Y": 0.21482811868191,
    "CMYK_K": 0.45843309164047
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16263",
    "Farbtonhilfsbezeichnung": "16263",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "194",
    "Bcolor": "176",
    "Y": 54,
    "L": 78.5823135375977,
    "a": -0.81998205184937,
    "b": 9.35407733917236,
    "C": 9.38994884490967,
    "h": 95.009765625,
    "CMY_C": 0.2146674990654,
    "CMY_M": 0.23758262395859,
    "CMY_Y": 0.31074202060699,
    "CMYK_C": 0,
    "CMYK_M": 0.02917888201773,
    "CMYK_Y": 0.12233610451221,
    "CMYK_K": 0.2146674990654
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16264",
    "Farbtonhilfsbezeichnung": "16264",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "140",
    "Bcolor": "127",
    "Y": 26,
    "L": 58.2701148986816,
    "a": -0.49610185623169,
    "b": 6.95999431610107,
    "C": 6.97765254974365,
    "h": 94.0770950317383,
    "CMY_C": 0.4338510632515,
    "CMY_M": 0.45100325345993,
    "CMY_Y": 0.50222128629684,
    "CMYK_C": 0,
    "CMYK_M": 0.03029625117779,
    "CMYK_Y": 0.12076366692781,
    "CMYK_K": 0.4338510632515
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16265",
    "Farbtonhilfsbezeichnung": "16265",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "168",
    "Bcolor": "156",
    "Y": 39,
    "L": 68.6201858520508,
    "a": -0.85701924562454,
    "b": 5.61058330535889,
    "C": 5.67566108703613,
    "h": 98.6848297119141,
    "CMY_C": 0.33260989189148,
    "CMY_M": 0.34279435873032,
    "CMY_Y": 0.38812077045441,
    "CMYK_C": 0,
    "CMYK_M": 0.01526014041156,
    "CMYK_Y": 0.08317606151104,
    "CMYK_K": 0.33260989189148
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16266",
    "Farbtonhilfsbezeichnung": "16266",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "185",
    "Bcolor": "169",
    "Y": 48,
    "L": 75.0970993041992,
    "a": -0.20005263388157,
    "b": 7.77443313598633,
    "C": 7.77700662612915,
    "h": 91.4740219116211,
    "CMY_C": 0.25241261720657,
    "CMY_M": 0.27609497308731,
    "CMY_Y": 0.33597081899643,
    "CMYK_C": 0,
    "CMYK_M": 0.031678378582,
    "CMYK_Y": 0.1117704808712,
    "CMYK_K": 0.25241261720657
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16267",
    "Farbtonhilfsbezeichnung": "16267",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "201",
    "Bcolor": "186",
    "Y": 59,
    "L": 81.2964935302734,
    "a": 0.25685888528824,
    "b": 8.05421924591064,
    "C": 8.05831432342529,
    "h": 88.1733856201172,
    "CMY_C": 0.18080049753189,
    "CMY_M": 0.21031308174133,
    "CMY_Y": 0.27241826057434,
    "CMYK_C": 0,
    "CMYK_M": 0.03602612391114,
    "CMYK_Y": 0.11183815449476,
    "CMYK_K": 0.18080049753189
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16268",
    "Farbtonhilfsbezeichnung": "16268",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "220",
    "Bcolor": "203",
    "Y": 72,
    "L": 87.9142379760742,
    "a": -0.06486112624407,
    "b": 8.15899467468262,
    "C": 8.15925216674805,
    "h": 90.4554748535156,
    "CMY_C": 0.10974591970444,
    "CMY_M": 0.13697975873947,
    "CMY_Y": 0.20211541652679,
    "CMYK_C": 0,
    "CMYK_M": 0.03059108555317,
    "CMYK_Y": 0.10375633090734,
    "CMYK_K": 0.10974591970444
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16269",
    "Farbtonhilfsbezeichnung": "16269",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "161",
    "Bcolor": "115",
    "Y": 37,
    "L": 66.9177169799805,
    "a": 0.58125436306,
    "b": 26.0185470581055,
    "C": 26.0250396728516,
    "h": 88.7202224731445,
    "CMY_C": 0.29214972257614,
    "CMY_M": 0.36826348304749,
    "CMY_Y": 0.54880809783936,
    "CMYK_C": 0,
    "CMYK_M": 0.10752805322409,
    "CMYK_Y": 0.3625884950161,
    "CMYK_K": 0.29214972257614
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16270",
    "Farbtonhilfsbezeichnung": "16270",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "199",
    "Bcolor": "169",
    "Y": 57,
    "L": 80.2505416870117,
    "a": -0.68214476108551,
    "b": 15.2982139587402,
    "C": 15.3134145736694,
    "h": 92.5531234741211,
    "CMY_C": 0.17917829751968,
    "CMY_M": 0.22126114368439,
    "CMY_Y": 0.33614313602448,
    "CMYK_C": 0,
    "CMYK_M": 0.05126916989684,
    "CMYK_Y": 0.19122891128063,
    "CMYK_K": 0.17917829751968
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16271",
    "Farbtonhilfsbezeichnung": "16271",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "232",
    "Bcolor": "212",
    "Y": 82,
    "L": 91.9529647827148,
    "a": -0.99243998527527,
    "b": 9.66449165344238,
    "C": 9.7153148651123,
    "h": 95.8631134033203,
    "CMY_C": 0.06709319353104,
    "CMY_M": 0.09027767181396,
    "CMY_Y": 0.16945958137512,
    "CMYK_C": 0,
    "CMYK_M": 0.02485186979175,
    "CMYK_Y": 0.10972841829062,
    "CMYK_K": 0.06709319353104
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16272",
    "Farbtonhilfsbezeichnung": "16272",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "186",
    "Bcolor": "128",
    "Y": 51,
    "L": 76.2060165405273,
    "a": 0.21495848894119,
    "b": 31.6994762420654,
    "C": 31.7002048492432,
    "h": 89.6114730834961,
    "CMY_C": 0.18149596452713,
    "CMY_M": 0.27030122280121,
    "CMY_Y": 0.49743622541428,
    "CMYK_C": 0,
    "CMYK_M": 0.10849703103304,
    "CMYK_Y": 0.38599720597267,
    "CMYK_K": 0.18149596452713
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16273",
    "Farbtonhilfsbezeichnung": "16273",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "176",
    "Bcolor": "147",
    "Y": 44,
    "L": 72.3608093261719,
    "a": 0.46828413009644,
    "b": 15.9061822891235,
    "C": 15.9130744934082,
    "h": 88.3136749267578,
    "CMY_C": 0.25568944215775,
    "CMY_M": 0.30870300531387,
    "CMY_Y": 0.4220929145813,
    "CMYK_C": 0,
    "CMYK_M": 0.07122506201267,
    "CMYK_Y": 0.22356726229191,
    "CMYK_K": 0.25568944215775
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16274",
    "Farbtonhilfsbezeichnung": "16274",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "207",
    "Bcolor": "185",
    "Y": 63,
    "L": 83.1468124389648,
    "a": -0.17701536417007,
    "b": 11.2306747436523,
    "C": 11.2320699691773,
    "h": 90.9030075073242,
    "CMY_C": 0.15453881025314,
    "CMY_M": 0.18992209434509,
    "CMY_Y": 0.27585899829865,
    "CMYK_C": 0,
    "CMYK_M": 0.04185086861253,
    "CMYK_Y": 0.14349587261677,
    "CMYK_K": 0.15453881025314
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16275",
    "Farbtonhilfsbezeichnung": "16275",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "181",
    "Bcolor": "101",
    "Y": 49,
    "L": 75.3865280151367,
    "a": 3.32149529457092,
    "b": 44.6830291748047,
    "C": 44.8063087463379,
    "h": 85.7487640380859,
    "CMY_C": 0.14959901571274,
    "CMY_M": 0.2884806394577,
    "CMY_Y": 0.60318171977997,
    "CMYK_C": 0,
    "CMYK_M": 0.1633131057024,
    "CMYK_Y": 0.53337508440018,
    "CMYK_K": 0.14959901571274
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16276",
    "Farbtonhilfsbezeichnung": "16276",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "202",
    "Bcolor": "136",
    "Y": 61,
    "L": 82.0714797973633,
    "a": 0.98193293809891,
    "b": 35.7923278808594,
    "C": 35.805793762207,
    "h": 88.4285354614258,
    "CMY_C": 0.10257375240326,
    "CMY_M": 0.2095719575882,
    "CMY_Y": 0.46822398900986,
    "CMYK_C": 0,
    "CMYK_M": 0.11922785639763,
    "CMYK_Y": 0.40744322538376,
    "CMYK_K": 0.10257375240326
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16277",
    "Farbtonhilfsbezeichnung": "16277",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "220",
    "Bcolor": "168",
    "Y": 73,
    "L": 88.1003875732422,
    "a": -0.65541505813599,
    "b": 26.9613304138184,
    "C": 26.969295501709,
    "h": 91.3925552368164,
    "CMY_C": 0.06302100419998,
    "CMY_M": 0.13792139291763,
    "CMY_Y": 0.33964002132416,
    "CMYK_C": 0,
    "CMYK_M": 0.07993817329407,
    "CMYK_Y": 0.29522433876991,
    "CMYK_K": 0.06302100419998
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16278",
    "Farbtonhilfsbezeichnung": "16278",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "237",
    "Bcolor": "207",
    "Y": 85,
    "L": 93.8754730224609,
    "a": -0.99639111757278,
    "b": 15.0098247528076,
    "C": 15.0428600311279,
    "h": 93.7978668212891,
    "CMY_C": 0.02990788221359,
    "CMY_M": 0.0700963139534,
    "CMY_Y": 0.18840432167053,
    "CMYK_C": 0,
    "CMYK_M": 0.04142743721604,
    "CMYK_Y": 0.16338287293911,
    "CMYK_K": 0.02990788221359
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16279",
    "Farbtonhilfsbezeichnung": "16279",
    "Farbtonklasse": "02",
    "Rcolor": "78",
    "Gcolor": "78",
    "Bcolor": "77",
    "Y": 7,
    "L": 33.3084869384766,
    "a": -0.07876341789961,
    "b": 0.25273814797401,
    "C": 0.26472672820091,
    "h": 107.309143066406,
    "CMY_C": 0.69265961647034,
    "CMY_M": 0.69254475831985,
    "CMY_Y": 0.6970226764679,
    "CMYK_C": 0.00037357682595,
    "CMYK_M": 0,
    "CMYK_Y": 0.01456445548683,
    "CMYK_K": 0.69254475831985
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16280",
    "Farbtonhilfsbezeichnung": "16280",
    "Farbtonklasse": "01",
    "Rcolor": "112",
    "Gcolor": "112",
    "Bcolor": "111",
    "Y": 16,
    "L": 47.1397361755371,
    "a": 0.35130581259727,
    "b": 0.0267860237509,
    "C": 0.35232549905777,
    "h": 4.36019659042358,
    "CMY_C": 0.55919224023819,
    "CMY_M": 0.56214737892151,
    "CMY_Y": 0.56539905071259,
    "CMYK_C": 0,
    "CMYK_M": 0.00670391693711,
    "CMYK_Y": 0.01408053841442,
    "CMYK_K": 0.55919224023819
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16281",
    "Farbtonhilfsbezeichnung": "16281",
    "Farbtonklasse": "01",
    "Rcolor": "139",
    "Gcolor": "139",
    "Bcolor": "138",
    "Y": 26,
    "L": 57.8439102172852,
    "a": 0.04931668564677,
    "b": -0.08447043597698,
    "C": 0.0978130325675,
    "h": 300.27783203125,
    "CMY_C": 0.45495957136154,
    "CMY_M": 0.45476508140564,
    "CMY_Y": 0.45879817008972,
    "CMYK_C": 0.00035670853686,
    "CMYK_M": 0,
    "CMYK_Y": 0.00739697413519,
    "CMYK_K": 0.45476508140564
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16282",
    "Farbtonhilfsbezeichnung": "16282",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "162",
    "Bcolor": "160",
    "Y": 36,
    "L": 66.6032180786133,
    "a": -0.02325857430696,
    "b": 0.3965368270874,
    "C": 0.39721834659576,
    "h": 93.3567962646484,
    "CMY_C": 0.36370462179184,
    "CMY_M": 0.36444121599197,
    "CMY_Y": 0.37254077196121,
    "CMYK_C": 0,
    "CMYK_M": 0.00115762930363,
    "CMYK_Y": 0.01388686802238,
    "CMYK_K": 0.36370462179184
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16283",
    "Farbtonhilfsbezeichnung": "16283",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "181",
    "Bcolor": "177",
    "Y": 46,
    "L": 73.4579010009766,
    "a": -0.25649872422218,
    "b": 1.35336625576019,
    "C": 1.37745845317841,
    "h": 100.731781005859,
    "CMY_C": 0.29000896215439,
    "CMY_M": 0.29180890321732,
    "CMY_Y": 0.30760252475739,
    "CMYK_C": 0,
    "CMYK_M": 0.00253516016528,
    "CMYK_Y": 0.02477997913957,
    "CMYK_K": 0.29000896215439
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16284",
    "Farbtonhilfsbezeichnung": "16284",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "197",
    "Bcolor": "192",
    "Y": 56,
    "L": 79.4841918945313,
    "a": -0.14802026748657,
    "b": 1.70246064662933,
    "C": 1.70888328552246,
    "h": 94.9690780639648,
    "CMY_C": 0.22325038909912,
    "CMY_M": 0.22737199068069,
    "CMY_Y": 0.24598532915115,
    "CMYK_C": 0,
    "CMYK_M": 0.00530621642247,
    "CMYK_Y": 0.02926932834089,
    "CMYK_K": 0.22325038909912
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16285",
    "Farbtonhilfsbezeichnung": "16285",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "212",
    "Bcolor": "206",
    "Y": 66,
    "L": 84.8481826782227,
    "a": -0.33102005720139,
    "b": 2.19012117385864,
    "C": 2.21499538421631,
    "h": 98.5947647094727,
    "CMY_C": 0.16449952125549,
    "CMY_M": 0.16855359077454,
    "CMY_Y": 0.19166684150696,
    "CMYK_C": 0,
    "CMYK_M": 0.00485226465389,
    "CMYK_Y": 0.03251622244716,
    "CMYK_K": 0.16449952125549
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16286",
    "Farbtonhilfsbezeichnung": "16286",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 76,
    "L": 89.783561706543,
    "a": -0.19098851084709,
    "b": 1.87534379959106,
    "C": 1.8850439786911,
    "h": 95.8150634765625,
    "CMY_C": 0.10988008975983,
    "CMY_M": 0.11424970626831,
    "CMY_Y": 0.13539689779282,
    "CMYK_C": 0,
    "CMYK_M": 0.00490901991725,
    "CMYK_Y": 0.0286667086184,
    "CMYK_K": 0.10988008975983
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16287",
    "Farbtonhilfsbezeichnung": "16287",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "238",
    "Bcolor": "231",
    "Y": 86,
    "L": 94.1532974243164,
    "a": -0.11024470627308,
    "b": 2.98394012451172,
    "C": 2.98597598075867,
    "h": 92.1158828735352,
    "CMY_C": 0.05666536092758,
    "CMY_M": 0.06592839956284,
    "CMY_Y": 0.09534925222397,
    "CMYK_C": 0,
    "CMYK_M": 0.00981946196407,
    "CMYK_Y": 0.0410076007247,
    "CMYK_K": 0.05666536092758
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16288",
    "Farbtonhilfsbezeichnung": "16288",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "110",
    "Bcolor": "105",
    "Y": 15,
    "L": 46.4032363891602,
    "a": 0.08381221443415,
    "b": 2.60932946205139,
    "C": 2.61067509651184,
    "h": 88.1602783203125,
    "CMY_C": 0.56071650981903,
    "CMY_M": 0.56940937042236,
    "CMY_Y": 0.58927321434021,
    "CMYK_C": 0,
    "CMYK_M": 0.01978872530162,
    "CMYK_Y": 0.06500746309757,
    "CMYK_K": 0.56071650981903
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16289",
    "Farbtonhilfsbezeichnung": "16289",
    "Farbtonklasse": "01",
    "Rcolor": "139",
    "Gcolor": "136",
    "Bcolor": "130",
    "Y": 25,
    "L": 56.853946685791,
    "a": 0.14559407532215,
    "b": 3.12596845626831,
    "C": 3.12935709953308,
    "h": 87.3333358764648,
    "CMY_C": 0.45459401607513,
    "CMY_M": 0.4658350944519,
    "CMY_Y": 0.49034750461578,
    "CMYK_C": 0,
    "CMYK_M": 0.02061047777534,
    "CMYK_Y": 0.06555389612913,
    "CMYK_K": 0.45459401607513
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16290",
    "Farbtonhilfsbezeichnung": "16290",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "159",
    "Bcolor": "152",
    "Y": 35,
    "L": 65.6788177490234,
    "a": -0.11366012692451,
    "b": 3.68932628631592,
    "C": 3.69107675552368,
    "h": 91.7646026611328,
    "CMY_C": 0.36380189657211,
    "CMY_M": 0.37474775314331,
    "CMY_Y": 0.40491092205048,
    "CMYK_C": 0,
    "CMYK_M": 0.01720510795712,
    "CMYK_Y": 0.06461670249701,
    "CMYK_K": 0.36380189657211
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16291",
    "Farbtonhilfsbezeichnung": "16291",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "179",
    "Bcolor": "170",
    "Y": 45,
    "L": 72.9132919311523,
    "a": -0.27937108278275,
    "b": 4.1883692741394,
    "C": 4.19767618179321,
    "h": 93.8160705566406,
    "CMY_C": 0.2870734333992,
    "CMY_M": 0.2983096241951,
    "CMY_Y": 0.33339673280716,
    "CMYK_C": 0,
    "CMYK_M": 0.01576065644622,
    "CMYK_Y": 0.06497626006603,
    "CMYK_K": 0.2870734333992
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16292",
    "Farbtonhilfsbezeichnung": "16292",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "194",
    "Bcolor": "184",
    "Y": 54,
    "L": 78.5471801757813,
    "a": -0.63820868730545,
    "b": 4.97832536697388,
    "C": 5.01906681060791,
    "h": 97.3053283691406,
    "CMY_C": 0.22671943902969,
    "CMY_M": 0.23726367950439,
    "CMY_Y": 0.27961403131485,
    "CMYK_C": 0,
    "CMYK_M": 0.01363572385162,
    "CMYK_Y": 0.06840284913778,
    "CMYK_K": 0.22671943902969
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16293",
    "Farbtonhilfsbezeichnung": "16293",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "209",
    "Bcolor": "198",
    "Y": 64,
    "L": 83.7824478149414,
    "a": -0.6667332649231,
    "b": 5.03837966918945,
    "C": 5.08230304718018,
    "h": 97.538200378418,
    "CMY_C": 0.16962307691574,
    "CMY_M": 0.18023639917374,
    "CMY_Y": 0.22400808334351,
    "CMYK_C": 0,
    "CMYK_M": 0.01278133131564,
    "CMYK_Y": 0.06549435853958,
    "CMYK_K": 0.16962307691574
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16294",
    "Farbtonhilfsbezeichnung": "16294",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "124",
    "Bcolor": "127",
    "Y": 20,
    "L": 51.8803596496582,
    "a": -0.76409029960632,
    "b": -2.87095642089844,
    "C": 2.97089624404907,
    "h": 255.096496582031,
    "CMY_C": 0.52974832057953,
    "CMY_M": 0.51229643821716,
    "CMY_Y": 0.50000667572021,
    "CMYK_C": 0.05948408320546,
    "CMYK_M": 0.02457985281944,
    "CMYK_Y": 0,
    "CMYK_K": 0.50000667572021
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16295",
    "Farbtonhilfsbezeichnung": "16295",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "153",
    "Bcolor": "155",
    "Y": 31,
    "L": 62.9728355407715,
    "a": -1.15482175350189,
    "b": -2.23685073852539,
    "C": 2.51736259460449,
    "h": 242.693984985352,
    "CMY_C": 0.41854846477509,
    "CMY_M": 0.39898997545242,
    "CMY_Y": 0.39201647043228,
    "CMYK_C": 0.04363933205605,
    "CMYK_M": 0.01146989129484,
    "CMYK_Y": 0,
    "CMYK_K": 0.39201647043228
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16296",
    "Farbtonhilfsbezeichnung": "16296",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "174",
    "Bcolor": "173",
    "Y": 42,
    "L": 70.7259063720703,
    "a": -1.23140871524811,
    "b": -0.85499936342239,
    "C": 1.49913024902344,
    "h": 214.77326965332,
    "CMY_C": 0.33369714021683,
    "CMY_M": 0.31804716587067,
    "CMY_Y": 0.32092773914337,
    "CMYK_C": 0.02294876426458,
    "CMYK_M": 0,
    "CMYK_Y": 0.00422400655225,
    "CMYK_K": 0.31804716587067
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16297",
    "Farbtonhilfsbezeichnung": "16297",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "195",
    "Bcolor": "194",
    "Y": 54,
    "L": 78.4264755249023,
    "a": -1.15191423892975,
    "b": -0.75945645570755,
    "C": 1.37973928451538,
    "h": 213.396850585938,
    "CMY_C": 0.25070112943649,
    "CMY_M": 0.23584163188934,
    "CMY_Y": 0.23977392911911,
    "CMYK_C": 0.01944557391107,
    "CMYK_M": 0,
    "CMYK_Y": 0.00514591904357,
    "CMYK_K": 0.23584163188934
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16298",
    "Farbtonhilfsbezeichnung": "16298",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 65,
    "L": 84.2464904785156,
    "a": -1.1163877248764,
    "b": 0.83001762628555,
    "C": 1.39113295078278,
    "h": 143.369735717773,
    "CMY_C": 0.1817781329155,
    "CMY_M": 0.17295837402344,
    "CMY_Y": 0.18839484453201,
    "CMYK_C": 0.01066422648728,
    "CMYK_M": 0,
    "CMYK_Y": 0.01866468414664,
    "CMYK_K": 0.17295837402344
  },
  {
    "Farbtonkarten_Bezeichnung": "Sto AC Architectural Colours",
    "Farbton_ID": "16299",
    "Farbtonhilfsbezeichnung": "16299",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.8405532836914,
    "a": -0.91597729921341,
    "b": 2.8282949924469,
    "C": 2.97292232513428,
    "h": 107.945167541504,
    "CMY_C": 0.11175882816315,
    "CMY_M": 0.11217284202576,
    "CMY_Y": 0.14191073179245,
    "CMYK_C": 0,
    "CMYK_M": 0.00046610523714,
    "CMYK_Y": 0.03394562751055,
    "CMYK_K": 0.11175882816315
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31100",
    "Farbtonhilfsbezeichnung": "31100",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "183",
    "Bcolor": "61",
    "Y": 45,
    "L": 73.2044372558594,
    "a": -10.293535232544,
    "b": 60.0481986999512,
    "C": 60.9240760803223,
    "h": 99.727165222168,
    "CMY_C": 0.24278938770294,
    "CMY_M": 0.28302925825119,
    "CMY_Y": 0.76202100515366,
    "CMYK_C": 0,
    "CMYK_M": 0.05314224213362,
    "CMYK_Y": 0.68571627140045,
    "CMYK_K": 0.24278938770294
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31101",
    "Farbtonhilfsbezeichnung": "31101",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "195",
    "Bcolor": "75",
    "Y": 53,
    "L": 77.442253112793,
    "a": -10.4792709350586,
    "b": 58.8576354980469,
    "C": 59.7832450866699,
    "h": 100.095405578613,
    "CMY_C": 0.19703441858292,
    "CMY_M": 0.23713749647141,
    "CMY_Y": 0.70572900772095,
    "CMYK_C": 0,
    "CMYK_M": 0.04994370788336,
    "CMYK_Y": 0.6335197687149,
    "CMYK_K": 0.19703441858292
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31102",
    "Farbtonhilfsbezeichnung": "31102",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "203",
    "Bcolor": "89",
    "Y": 56,
    "L": 80.2297439575195,
    "a": -10.9699592590332,
    "b": 55.8006477355957,
    "C": 56.8687286376953,
    "h": 101.122055053711,
    "CMY_C": 0.17241036891937,
    "CMY_M": 0.20559006929398,
    "CMY_Y": 0.64973151683807,
    "CMYK_C": 0,
    "CMYK_M": 0.04009197279811,
    "CMYK_Y": 0.57676064968109,
    "CMYK_K": 0.17241036891937
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31103",
    "Farbtonhilfsbezeichnung": "31103",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "216",
    "Bcolor": "115",
    "Y": 65,
    "L": 85.2749404907227,
    "a": -10.012791633606,
    "b": 49.8462181091309,
    "C": 50.841926574707,
    "h": 101.358055114746,
    "CMY_C": 0.11694878339767,
    "CMY_M": 0.1517316699028,
    "CMY_Y": 0.54787296056747,
    "CMYK_C": 0,
    "CMYK_M": 0.03938943147659,
    "CMYK_Y": 0.48799455165863,
    "CMYK_K": 0.11694878339767
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31104",
    "Farbtonhilfsbezeichnung": "31104",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "224",
    "Bcolor": "137",
    "Y": 71,
    "L": 87.9745025634766,
    "a": -9.47820663452148,
    "b": 42.8718185424805,
    "C": 43.9070510864258,
    "h": 102.46656036377,
    "CMY_C": 0.09444981813431,
    "CMY_M": 0.12204110622406,
    "CMY_Y": 0.46437853574753,
    "CMYK_C": 0,
    "CMYK_M": 0.03046908788383,
    "CMYK_Y": 0.40851265192032,
    "CMYK_K": 0.09444981813431
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31105",
    "Farbtonhilfsbezeichnung": "31105",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "231",
    "Bcolor": "160",
    "Y": 77,
    "L": 90.5470352172852,
    "a": -8.16872787475586,
    "b": 34.6943664550781,
    "C": 35.6430511474609,
    "h": 103.248886108398,
    "CMY_C": 0.0721675157547,
    "CMY_M": 0.09494459629059,
    "CMY_Y": 0.37399077415466,
    "CMYK_C": 0,
    "CMYK_M": 0.02454870007932,
    "CMYK_Y": 0.32529929280281,
    "CMYK_K": 0.0721675157547
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31106",
    "Farbtonhilfsbezeichnung": "31106",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "173",
    "Y": 80,
    "L": 91.9292907714844,
    "a": -7.44046926498413,
    "b": 29.8220615386963,
    "C": 30.7362308502197,
    "h": 104.009033203125,
    "CMY_C": 0.06207942962646,
    "CMY_M": 0.08020943403244,
    "CMY_Y": 0.32208532094955,
    "CMYK_C": 0,
    "CMYK_M": 0.01933000050485,
    "CMYK_Y": 0.27721524238586,
    "CMYK_K": 0.06207942962646
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31107",
    "Farbtonhilfsbezeichnung": "31107",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "238",
    "Bcolor": "190",
    "Y": 84,
    "L": 93.4741821289062,
    "a": -5.980637550354,
    "b": 22.9486541748047,
    "C": 23.7151584625244,
    "h": 104.606918334961,
    "CMY_C": 0.05062574148178,
    "CMY_M": 0.06478279829025,
    "CMY_Y": 0.25327616930008,
    "CMYK_C": 0,
    "CMYK_M": 0.01491198688745,
    "CMYK_Y": 0.21345683932304,
    "CMYK_K": 0.05062574148178
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31108",
    "Farbtonhilfsbezeichnung": "31108",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "242",
    "Bcolor": "205",
    "Y": 87,
    "L": 94.9336242675781,
    "a": -4.57729244232178,
    "b": 17.7110900878906,
    "C": 18.2930126190186,
    "h": 104.490577697754,
    "CMY_C": 0.0375469326973,
    "CMY_M": 0.05042123794556,
    "CMY_Y": 0.19777894020081,
    "CMYK_C": 0,
    "CMYK_M": 0.01337655354291,
    "CMYK_Y": 0.16648292541504,
    "CMYK_K": 0.0375469326973
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31109",
    "Farbtonhilfsbezeichnung": "31109",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "243",
    "Bcolor": "216",
    "Y": 88,
    "L": 95.2597732543945,
    "a": -3.43258738517761,
    "b": 12.2847299575806,
    "C": 12.7552833557129,
    "h": 105.611373901367,
    "CMY_C": 0.04076308012009,
    "CMY_M": 0.04809439182281,
    "CMY_Y": 0.15323454141617,
    "CMYK_C": 0,
    "CMYK_M": 0.00764285819605,
    "CMYK_Y": 0.11725097149611,
    "CMYK_K": 0.04076308012009
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31110",
    "Farbtonhilfsbezeichnung": "31110",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "175",
    "Bcolor": "93",
    "Y": 42,
    "L": 71.1130447387695,
    "a": -5.79617071151733,
    "b": 42.9954643249512,
    "C": 43.384391784668,
    "h": 97.6776962280273,
    "CMY_C": 0.25907891988754,
    "CMY_M": 0.31279516220093,
    "CMY_Y": 0.63506978750229,
    "CMYK_C": 0,
    "CMYK_M": 0.07249927520752,
    "CMYK_Y": 0.50746411085129,
    "CMYK_K": 0.25907891988754
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31111",
    "Farbtonhilfsbezeichnung": "31111",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "195",
    "Bcolor": "119",
    "Y": 54,
    "L": 78.3553314208984,
    "a": -5.66785192489624,
    "b": 38.9903450012207,
    "C": 39.400146484375,
    "h": 98.2708969116211,
    "CMY_C": 0.18388485908508,
    "CMY_M": 0.235091984272,
    "CMY_Y": 0.53182244300842,
    "CMYK_C": 0,
    "CMYK_M": 0.06274497509003,
    "CMYK_Y": 0.42633393406868,
    "CMYK_K": 0.18388485908508
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31112",
    "Farbtonhilfsbezeichnung": "31112",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "205",
    "Bcolor": "139",
    "Y": 60,
    "L": 82.1050643920898,
    "a": -5.37898874282837,
    "b": 33.8463134765625,
    "C": 34.2710723876953,
    "h": 99.0301513671875,
    "CMY_C": 0.14947497844696,
    "CMY_M": 0.19417768716812,
    "CMY_Y": 0.45460224151611,
    "CMYK_C": 0,
    "CMYK_M": 0.05255895853043,
    "CMYK_Y": 0.35875165462494,
    "CMYK_K": 0.14947497844696
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31113",
    "Farbtonhilfsbezeichnung": "31113",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "217",
    "Bcolor": "162",
    "Y": 68,
    "L": 86.3561630249023,
    "a": -4.98828935623169,
    "b": 27.9629459381104,
    "C": 28.404390335083,
    "h": 100.114555358887,
    "CMY_C": 0.11148059368134,
    "CMY_M": 0.14732182025909,
    "CMY_Y": 0.36629194021225,
    "CMYK_C": 0,
    "CMYK_M": 0.04033814743161,
    "CMYK_Y": 0.28678196668625,
    "CMYK_K": 0.11148059368134
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31114",
    "Farbtonhilfsbezeichnung": "31114",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "174",
    "Y": 72,
    "L": 88.4440612792969,
    "a": -4.40476608276367,
    "b": 24.2480850219727,
    "C": 24.6449108123779,
    "h": 100.295745849609,
    "CMY_C": 0.09248185157776,
    "CMY_M": 0.12480425834656,
    "CMY_Y": 0.31640440225601,
    "CMYK_C": 0,
    "CMYK_M": 0.03561626374722,
    "CMYK_Y": 0.24674168229103,
    "CMYK_K": 0.09248185157776
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31115",
    "Farbtonhilfsbezeichnung": "31115",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "231",
    "Bcolor": "191",
    "Y": 78,
    "L": 91.1949157714844,
    "a": -3.63921332359314,
    "b": 19.234058380127,
    "C": 19.5753135681152,
    "h": 100.714096069336,
    "CMY_C": 0.06857168674469,
    "CMY_M": 0.09486955404282,
    "CMY_Y": 0.24944740533829,
    "CMYK_C": 0,
    "CMYK_M": 0.02823391370475,
    "CMYK_Y": 0.19419178366661,
    "CMYK_K": 0.06857168674469
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31116",
    "Farbtonhilfsbezeichnung": "31116",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "236",
    "Bcolor": "205",
    "Y": 82,
    "L": 93.0999221801758,
    "a": -2.67222285270691,
    "b": 14.8806419372559,
    "C": 15.118673324585,
    "h": 100.180503845215,
    "CMY_C": 0.05173826217651,
    "CMY_M": 0.07479470968246,
    "CMY_Y": 0.19614416360855,
    "CMYK_C": 0,
    "CMYK_M": 0.02431443333626,
    "CMYK_Y": 0.15228486061096,
    "CMYK_K": 0.05173826217651
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31120",
    "Farbtonhilfsbezeichnung": "31120",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "147",
    "Bcolor": "95",
    "Y": 29,
    "L": 60.6420059204102,
    "a": -4.70214796066284,
    "b": 28.0740413665771,
    "C": 28.4651012420654,
    "h": 99.5082702636719,
    "CMY_C": 0.39018815755844,
    "CMY_M": 0.42197513580322,
    "CMY_Y": 0.62573480606079,
    "CMYK_C": 0,
    "CMYK_M": 0.05212587863207,
    "CMYK_Y": 0.38626119494438,
    "CMYK_K": 0.39018815755844
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31121",
    "Farbtonhilfsbezeichnung": "31121",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "169",
    "Bcolor": "122",
    "Y": 40,
    "L": 68.9591064453125,
    "a": -3.56139659881592,
    "b": 24.7259922027588,
    "C": 24.9811573028564,
    "h": 98.1962051391602,
    "CMY_C": 0.30028939247131,
    "CMY_M": 0.33742696046829,
    "CMY_Y": 0.52010929584503,
    "CMYK_C": 0,
    "CMYK_M": 0.05307561159134,
    "CMYK_Y": 0.31415832042694,
    "CMYK_K": 0.30028939247131
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31122",
    "Farbtonhilfsbezeichnung": "31122",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "182",
    "Bcolor": "142",
    "Y": 46,
    "L": 73.6986541748047,
    "a": -3.26578712463379,
    "b": 20.730806350708,
    "C": 20.9864654541016,
    "h": 98.9524078369141,
    "CMY_C": 0.25581109523773,
    "CMY_M": 0.28708112239838,
    "CMY_Y": 0.44359385967255,
    "CMYK_C": 0,
    "CMYK_M": 0.04201893880963,
    "CMYK_Y": 0.2523321211338,
    "CMYK_K": 0.25581109523773
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31123",
    "Farbtonhilfsbezeichnung": "31123",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "190",
    "Bcolor": "161",
    "Y": 51,
    "L": 76.7470626831055,
    "a": -2.29052758216858,
    "b": 14.7345895767212,
    "C": 14.9115610122681,
    "h": 98.8360443115234,
    "CMY_C": 0.23060685396194,
    "CMY_M": 0.25530713796616,
    "CMY_Y": 0.36891543865204,
    "CMYK_C": 0,
    "CMYK_M": 0.03210359066725,
    "CMYK_Y": 0.17976321280003,
    "CMYK_K": 0.23060685396194
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31130",
    "Farbtonhilfsbezeichnung": "31130",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "113",
    "Bcolor": "90",
    "Y": 17,
    "L": 47.3615798950195,
    "a": -2.69943881034851,
    "b": 12.7478733062744,
    "C": 13.0305500030518,
    "h": 101.956108093262,
    "CMY_C": 0.54417705535889,
    "CMY_M": 0.55654239654541,
    "CMY_Y": 0.64663398265839,
    "CMYK_C": 0,
    "CMYK_M": 0.02712750993669,
    "CMYK_Y": 0.22477352619171,
    "CMYK_K": 0.54417705535889
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31131",
    "Farbtonhilfsbezeichnung": "31131",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "139",
    "Bcolor": "113",
    "Y": 26,
    "L": 57.5236740112305,
    "a": -2.41620993614197,
    "b": 13.6357145309448,
    "C": 13.8481330871582,
    "h": 100.048347473145,
    "CMY_C": 0.43767285346985,
    "CMY_M": 0.4559577703476,
    "CMY_Y": 0.55518788099289,
    "CMYK_C": 0,
    "CMYK_M": 0.03251650929451,
    "CMYK_Y": 0.20897983014584,
    "CMYK_K": 0.43767285346985
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31132",
    "Farbtonhilfsbezeichnung": "31132",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "156",
    "Bcolor": "132",
    "Y": 33,
    "L": 63.9481582641602,
    "a": -3.04588985443115,
    "b": 12.5048522949219,
    "C": 12.8704614639282,
    "h": 103.689338684082,
    "CMY_C": 0.3782764673233,
    "CMY_M": 0.3884249329567,
    "CMY_Y": 0.48394960165024,
    "CMYK_C": 0,
    "CMYK_M": 0.01632311567664,
    "CMYK_Y": 0.16996805369854,
    "CMYK_K": 0.3782764673233
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31133",
    "Farbtonhilfsbezeichnung": "31133",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "175",
    "Bcolor": "153",
    "Y": 43,
    "L": 71.0582122802734,
    "a": -2.66268110275269,
    "b": 10.7636079788208,
    "C": 11.088062286377,
    "h": 103.894775390625,
    "CMY_C": 0.30520218610764,
    "CMY_M": 0.31430518627167,
    "CMY_Y": 0.39948683977127,
    "CMYK_C": 0,
    "CMYK_M": 0.01310165319592,
    "CMYK_Y": 0.13570085167885,
    "CMYK_K": 0.30520218610764
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31134",
    "Farbtonhilfsbezeichnung": "31134",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "174",
    "Y": 54,
    "L": 78.2851791381836,
    "a": -2.47792291641235,
    "b": 9.9585542678833,
    "C": 10.2622079849243,
    "h": 103.972785949707,
    "CMY_C": 0.22844219207764,
    "CMY_M": 0.23716980218887,
    "CMY_Y": 0.31847536563873,
    "CMYK_C": 0,
    "CMYK_M": 0.01131167355925,
    "CMYK_Y": 0.11669012159109,
    "CMYK_K": 0.22844219207764
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31135",
    "Farbtonhilfsbezeichnung": "31135",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "208",
    "Bcolor": "190",
    "Y": 63,
    "L": 83.3844985961914,
    "a": -1.98057901859283,
    "b": 8.40631484985352,
    "C": 8.63648223876953,
    "h": 103.257453918457,
    "CMY_C": 0.17362666130066,
    "CMY_M": 0.1824352145195,
    "CMY_Y": 0.25300991535187,
    "CMYK_C": 0,
    "CMYK_M": 0.01065929047763,
    "CMYK_Y": 0.09606221318245,
    "CMYK_K": 0.17362666130066
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31136",
    "Farbtonhilfsbezeichnung": "31136",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "219",
    "Bcolor": "202",
    "Y": 70,
    "L": 87.070915222168,
    "a": -1.71330726146698,
    "b": 7.49977779388428,
    "C": 7.69298934936523,
    "h": 102.868263244629,
    "CMY_C": 0.13369596004486,
    "CMY_M": 0.14226883649826,
    "CMY_Y": 0.20664662122726,
    "CMYK_C": 0,
    "CMYK_M": 0.00989592075348,
    "CMYK_Y": 0.08420907706022,
    "CMYK_K": 0.13369596004486
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31137",
    "Farbtonhilfsbezeichnung": "31137",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "228",
    "Bcolor": "213",
    "Y": 77,
    "L": 90.4076919555664,
    "a": -1.2148848772049,
    "b": 6.76933431625366,
    "C": 6.87748718261719,
    "h": 100.174499511719,
    "CMY_C": 0.0950220823288,
    "CMY_M": 0.10622847080231,
    "CMY_Y": 0.16488766670227,
    "CMYK_C": 0,
    "CMYK_M": 0.01238305214792,
    "CMYK_Y": 0.07720142602921,
    "CMYK_K": 0.0950220823288
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31140",
    "Farbtonhilfsbezeichnung": "31140",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "150",
    "Bcolor": "63",
    "Y": 30,
    "L": 61.5576934814453,
    "a": -6.00891780853271,
    "b": 46.0961303710938,
    "C": 46.4861297607422,
    "h": 97.4269790649414,
    "CMY_C": 0.36159110069275,
    "CMY_M": 0.41230773925781,
    "CMY_Y": 0.75382286310196,
    "CMYK_C": 0,
    "CMYK_M": 0.07944224774837,
    "CMYK_Y": 0.61438953876495,
    "CMYK_K": 0.36159110069275
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31141",
    "Farbtonhilfsbezeichnung": "31141",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "121",
    "Bcolor": "71",
    "Y": 19,
    "L": 50.3898277282715,
    "a": -4.51317262649536,
    "b": 27.7849521636963,
    "C": 28.1491088867188,
    "h": 99.2261047363281,
    "CMY_C": 0.49635297060013,
    "CMY_M": 0.52562201023102,
    "CMY_Y": 0.72042566537857,
    "CMYK_C": 0,
    "CMYK_M": 0.05811418965459,
    "CMYK_Y": 0.44490027427673,
    "CMYK_K": 0.49635297060013
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31142",
    "Farbtonhilfsbezeichnung": "31142",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "102",
    "Bcolor": "70",
    "Y": 13,
    "L": 42.4881057739258,
    "a": -4.13127946853638,
    "b": 17.59543800354,
    "C": 18.0739288330078,
    "h": 103.213287353516,
    "CMY_C": 0.59113621711731,
    "CMY_M": 0.60181576013565,
    "CMY_Y": 0.72362458705902,
    "CMYK_C": 0,
    "CMYK_M": 0.0261200517416,
    "CMYK_Y": 0.32404035329819,
    "CMYK_K": 0.59113621711731
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31143",
    "Farbtonhilfsbezeichnung": "31143",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "95",
    "Bcolor": "80",
    "Y": 12,
    "L": 40.1308288574219,
    "a": -1.94979536533356,
    "b": 8.59891986846924,
    "C": 8.81720638275146,
    "h": 102.775718688965,
    "CMY_C": 0.61929792165756,
    "CMY_M": 0.62694430351257,
    "CMY_Y": 0.68682706356049,
    "CMYK_C": 0,
    "CMYK_M": 0.02008494921029,
    "CMYK_Y": 0.17738054692745,
    "CMYK_K": 0.61929792165756
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31200",
    "Farbtonhilfsbezeichnung": "31200",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "201",
    "Bcolor": "67",
    "Y": 60,
    "L": 82.4220352172852,
    "a": 2.30949735641479,
    "b": 68.4090194702148,
    "C": 68.4479904174805,
    "h": 88.0664215087891,
    "CMY_C": 0.04574936628342,
    "CMY_M": 0.2134872674942,
    "CMY_Y": 0.73876661062241,
    "CMYK_C": 0,
    "CMYK_M": 0.1757797151804,
    "CMYK_Y": 0.72624236345291,
    "CMYK_K": 0.04574936628342
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31201",
    "Farbtonhilfsbezeichnung": "31201",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "208",
    "Bcolor": "82",
    "Y": 65,
    "L": 84.6456756591797,
    "a": -0.15620654821396,
    "b": 64.4842071533203,
    "C": 64.4843978881836,
    "h": 90.1387939453125,
    "CMY_C": 0.03886044025421,
    "CMY_M": 0.18300032615662,
    "CMY_Y": 0.6772124171257,
    "CMYK_C": 0,
    "CMYK_M": 0.149967700243,
    "CMYK_Y": 0.66416156291962,
    "CMYK_K": 0.03886044025421
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31202",
    "Farbtonhilfsbezeichnung": "31202",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "215",
    "Bcolor": "101",
    "Y": 69,
    "L": 86.6990585327148,
    "a": -1.8795713186264,
    "b": 58.5060272216797,
    "C": 58.5362129211426,
    "h": 91.8400573730469,
    "CMY_C": 0.03285735845566,
    "CMY_M": 0.15573555231094,
    "CMY_Y": 0.60282158851624,
    "CMYK_C": 0,
    "CMYK_M": 0.12705281376839,
    "CMYK_Y": 0.58932799100876,
    "CMYK_K": 0.03285735845566
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31203",
    "Farbtonhilfsbezeichnung": "31203",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "225",
    "Bcolor": "129",
    "Y": 75,
    "L": 89.4110336303711,
    "a": -4.2545919418335,
    "b": 48.7462959289551,
    "C": 48.9316139221191,
    "h": 94.988151550293,
    "CMY_C": 0.03117710351944,
    "CMY_M": 0.11889976263046,
    "CMY_Y": 0.4947110414505,
    "CMYK_C": 0,
    "CMYK_M": 0.09054560959339,
    "CMYK_Y": 0.47845065593719,
    "CMYK_K": 0.03117710351944
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31204",
    "Farbtonhilfsbezeichnung": "31204",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "228",
    "Bcolor": "141",
    "Y": 77,
    "L": 90.4920654296875,
    "a": -4.61473989486694,
    "b": 44.2006950378418,
    "C": 44.4409408569336,
    "h": 95.9603271484375,
    "CMY_C": 0.02882844209671,
    "CMY_M": 0.10534399747849,
    "CMY_Y": 0.44748586416245,
    "CMYK_C": 0,
    "CMYK_M": 0.07878685742617,
    "CMYK_Y": 0.43108493089676,
    "CMYK_K": 0.02882844209671
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31205",
    "Farbtonhilfsbezeichnung": "31205",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "173",
    "Y": 82,
    "L": 92.7712860107422,
    "a": -4.68938827514648,
    "b": 30.754674911499,
    "C": 31.1101341247559,
    "h": 98.6695251464844,
    "CMY_C": 0.03015697002411,
    "CMY_M": 0.07728940248489,
    "CMY_Y": 0.31971025466919,
    "CMYK_C": 0,
    "CMYK_M": 0.04859800264239,
    "CMYK_Y": 0.29855686426163,
    "CMYK_K": 0.03015697002411
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31206",
    "Farbtonhilfsbezeichnung": "31206",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "182",
    "Y": 84,
    "L": 93.4925231933594,
    "a": -4.56634283065796,
    "b": 27.4177627563477,
    "C": 27.7954177856445,
    "h": 99.4556427001953,
    "CMY_C": 0.02875483036041,
    "CMY_M": 0.06880986690521,
    "CMY_Y": 0.28663921356201,
    "CMYK_C": 0,
    "CMYK_M": 0.0412409119308,
    "CMYK_Y": 0.26551935076714,
    "CMYK_K": 0.02875483036041
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31207",
    "Farbtonhilfsbezeichnung": "31207",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "197",
    "Y": 86,
    "L": 94.3023681640625,
    "a": -4.04313325881958,
    "b": 20.7996921539307,
    "C": 21.1890087127686,
    "h": 101.000221252441,
    "CMY_C": 0.03226548433304,
    "CMY_M": 0.05948704481125,
    "CMY_Y": 0.22780084609985,
    "CMYK_C": 0,
    "CMYK_M": 0.02812916226685,
    "CMYK_Y": 0.20205475389957,
    "CMYK_K": 0.03226548433304
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31208",
    "Farbtonhilfsbezeichnung": "31208",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "241",
    "Bcolor": "209",
    "Y": 87,
    "L": 94.8300018310547,
    "a": -3.53784537315369,
    "b": 15.1283588409424,
    "C": 15.536524772644,
    "h": 103.162376403809,
    "CMY_C": 0.03807902336121,
    "CMY_M": 0.05339431762695,
    "CMY_Y": 0.17930847406387,
    "CMYK_C": 0,
    "CMYK_M": 0.01592157222331,
    "CMYK_Y": 0.14682021737099,
    "CMYK_K": 0.03807902336121
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31209",
    "Farbtonhilfsbezeichnung": "31209",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "242",
    "Bcolor": "217",
    "Y": 88,
    "L": 94.9831924438477,
    "a": -2.82957124710083,
    "b": 11.1452970504761,
    "C": 11.4988746643066,
    "h": 104.245300292969,
    "CMY_C": 0.04264533519745,
    "CMY_M": 0.05233669281006,
    "CMY_Y": 0.14762538671494,
    "CMYK_C": 0,
    "CMYK_M": 0.01012305915356,
    "CMYK_Y": 0.1096563860774,
    "CMYK_K": 0.04264533519745
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31210",
    "Farbtonhilfsbezeichnung": "31210",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "199",
    "Bcolor": "105",
    "Y": 58,
    "L": 80.9669342041016,
    "a": -0.33328351378441,
    "b": 49.7107086181641,
    "C": 49.7118263244629,
    "h": 90.3841323852539,
    "CMY_C": 0.10170131921768,
    "CMY_M": 0.22065615653992,
    "CMY_Y": 0.58797454833984,
    "CMYK_C": 0,
    "CMYK_M": 0.13242237269878,
    "CMYK_Y": 0.54132688045502,
    "CMYK_K": 0.10170131921768
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31211",
    "Farbtonhilfsbezeichnung": "31211",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "210",
    "Bcolor": "128",
    "Y": 65,
    "L": 84.548210144043,
    "a": -1.78784871101379,
    "b": 42.9318313598633,
    "C": 42.9690399169922,
    "h": 92.3846435546875,
    "CMY_C": 0.0803838968277,
    "CMY_M": 0.17726218700409,
    "CMY_Y": 0.49823892116547,
    "CMYK_C": 0,
    "CMYK_M": 0.1053464487195,
    "CMYK_Y": 0.45437985658646,
    "CMYK_K": 0.0803838968277
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31212",
    "Farbtonhilfsbezeichnung": "31212",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "217",
    "Bcolor": "145",
    "Y": 70,
    "L": 87.0432586669922,
    "a": -2.40260982513428,
    "b": 37.7612037658691,
    "C": 37.8375625610352,
    "h": 93.6406173706055,
    "CMY_C": 0.06510078907013,
    "CMY_M": 0.14755654335022,
    "CMY_Y": 0.4327757358551,
    "CMYK_C": 0,
    "CMYK_M": 0.08819747716188,
    "CMYK_Y": 0.39327764511108,
    "CMYK_K": 0.06510078907013
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31213",
    "Farbtonhilfsbezeichnung": "31213",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "226",
    "Bcolor": "166",
    "Y": 76,
    "L": 90.0341720581055,
    "a": -2.25769734382629,
    "b": 30.790901184082,
    "C": 30.8735618591309,
    "h": 94.1936187744141,
    "CMY_C": 0.04391676187515,
    "CMY_M": 0.1134962439537,
    "CMY_Y": 0.34843766689301,
    "CMYK_C": 0,
    "CMYK_M": 0.07277555018663,
    "CMYK_Y": 0.31850877404213,
    "CMYK_K": 0.04391676187515
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31214",
    "Farbtonhilfsbezeichnung": "31214",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "177",
    "Y": 80,
    "L": 91.5006713867188,
    "a": -2.42768883705139,
    "b": 27.1249980926514,
    "C": 27.2334213256836,
    "h": 95.1143493652344,
    "CMY_C": 0.03658831119537,
    "CMY_M": 0.09602636098862,
    "CMY_Y": 0.30523687601089,
    "CMYK_C": 0,
    "CMYK_M": 0.06169537827373,
    "CMYK_Y": 0.27885127067566,
    "CMYK_K": 0.03658831119537
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31215",
    "Farbtonhilfsbezeichnung": "31215",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "236",
    "Bcolor": "195",
    "Y": 83,
    "L": 93.1025009155273,
    "a": -2.58405232429504,
    "b": 20.2953720092773,
    "C": 20.4592151641846,
    "h": 97.255989074707,
    "CMY_C": 0.03630518913269,
    "CMY_M": 0.07625567913055,
    "CMY_Y": 0.23669725656509,
    "CMYK_C": 0,
    "CMYK_M": 0.04145554080606,
    "CMYK_Y": 0.20794141292572,
    "CMYK_K": 0.03630518913269
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31216",
    "Farbtonhilfsbezeichnung": "31216",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "207",
    "Y": 86,
    "L": 94.4057159423828,
    "a": -2.46272349357605,
    "b": 15.6369333267212,
    "C": 15.8296775817871,
    "h": 98.9502182006836,
    "CMY_C": 0.03323072195053,
    "CMY_M": 0.06081861257553,
    "CMY_Y": 0.18757581710815,
    "CMYK_C": 0,
    "CMYK_M": 0.02853616885841,
    "CMYK_Y": 0.15965040028095,
    "CMYK_K": 0.03323072195053
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31220",
    "Farbtonhilfsbezeichnung": "31220",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "185",
    "Bcolor": "110",
    "Y": 50,
    "L": 75.8603439331055,
    "a": -0.33260658383369,
    "b": 40.9426879882813,
    "C": 40.9440383911133,
    "h": 90.465446472168,
    "CMY_C": 0.17320108413696,
    "CMY_M": 0.27427369356155,
    "CMY_Y": 0.57051610946655,
    "CMYK_C": 0,
    "CMYK_M": 0.12224569916725,
    "CMYK_Y": 0.48054614663124,
    "CMYK_K": 0.17320108413696
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31221",
    "Farbtonhilfsbezeichnung": "31221",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "199",
    "Bcolor": "137",
    "Y": 57,
    "L": 80.4886169433594,
    "a": -2.69561791419983,
    "b": 32.9559173583984,
    "C": 33.0659790039063,
    "h": 94.6760787963867,
    "CMY_C": 0.15079236030579,
    "CMY_M": 0.21767860651016,
    "CMY_Y": 0.46389448642731,
    "CMYK_C": 0,
    "CMYK_M": 0.07876311987638,
    "CMYK_Y": 0.36869913339615,
    "CMYK_K": 0.15079236030579
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31222",
    "Farbtonhilfsbezeichnung": "31222",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "202",
    "Bcolor": "154",
    "Y": 60,
    "L": 81.3501968383789,
    "a": -3.06695866584778,
    "b": 25.1431045532227,
    "C": 25.3294677734375,
    "h": 96.95458984375,
    "CMY_C": 0.16016572713852,
    "CMY_M": 0.20597463846207,
    "CMY_Y": 0.39709132909775,
    "CMYK_C": 0,
    "CMYK_M": 0.05454517900944,
    "CMYK_Y": 0.2821099460125,
    "CMYK_K": 0.16016572713852
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31223",
    "Farbtonhilfsbezeichnung": "31223",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "208",
    "Bcolor": "175",
    "Y": 63,
    "L": 83.136344909668,
    "a": -3.12006878852844,
    "b": 16.2234649658203,
    "C": 16.5207633972168,
    "h": 100.886116027832,
    "CMY_C": 0.16269844770432,
    "CMY_M": 0.1844334602356,
    "CMY_Y": 0.31291389465332,
    "CMYK_C": 0,
    "CMYK_M": 0.02595840394497,
    "CMYK_Y": 0.17940424382687,
    "CMYK_K": 0.16269844770432
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31224",
    "Farbtonhilfsbezeichnung": "31224",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "211",
    "Bcolor": "188",
    "Y": 65,
    "L": 84.1292724609375,
    "a": -2.29302406311035,
    "b": 11.0050935745239,
    "C": 11.2414426803589,
    "h": 101.76976776123,
    "CMY_C": 0.16010874509811,
    "CMY_M": 0.17420518398285,
    "CMY_Y": 0.26406121253967,
    "CMYK_C": 0,
    "CMYK_M": 0.01678364723921,
    "CMYK_Y": 0.12376896291971,
    "CMYK_K": 0.16010874509811
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31230",
    "Farbtonhilfsbezeichnung": "31230",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "101",
    "Bcolor": "80",
    "Y": 14,
    "L": 43.0835571289063,
    "a": 0.42219221591949,
    "b": 12.8612947463989,
    "C": 12.8682222366333,
    "h": 88.1198501586914,
    "CMY_C": 0.56629264354706,
    "CMY_M": 0.60440844297409,
    "CMY_Y": 0.68664264678955,
    "CMYK_C": 0,
    "CMYK_M": 0.08788368105888,
    "CMYK_Y": 0.27749127149582,
    "CMYK_K": 0.56629264354706
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31231",
    "Farbtonhilfsbezeichnung": "31231",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "130",
    "Bcolor": "107",
    "Y": 23,
    "L": 54.5092811584473,
    "a": 0.27929311990738,
    "b": 13.1003408432007,
    "C": 13.1033172607422,
    "h": 88.7786712646484,
    "CMY_C": 0.45185470581055,
    "CMY_M": 0.49202799797058,
    "CMY_Y": 0.58042311668396,
    "CMYK_C": 0,
    "CMYK_M": 0.07328949868679,
    "CMYK_Y": 0.23455169796944,
    "CMYK_K": 0.45185470581055
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31232",
    "Farbtonhilfsbezeichnung": "31232",
    "Farbtonklasse": "01",
    "Rcolor": "156",
    "Gcolor": "145",
    "Bcolor": "120",
    "Y": 30,
    "L": 60.5478134155273,
    "a": 0.11404589563608,
    "b": 14.1778249740601,
    "C": 14.1782836914063,
    "h": 89.5391235351563,
    "CMY_C": 0.3879811167717,
    "CMY_M": 0.43070262670517,
    "CMY_Y": 0.52881109714508,
    "CMYK_C": 0,
    "CMYK_M": 0.06980423629284,
    "CMYK_Y": 0.23010724782944,
    "CMYK_K": 0.3879811167717
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31233",
    "Farbtonhilfsbezeichnung": "31233",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "165",
    "Bcolor": "141",
    "Y": 38,
    "L": 67.8882904052734,
    "a": -0.25991985201836,
    "b": 13.1274690628052,
    "C": 13.1300420761108,
    "h": 91.1342926025391,
    "CMY_C": 0.31564033031464,
    "CMY_M": 0.35359615087509,
    "CMY_Y": 0.44814109802246,
    "CMYK_C": 0,
    "CMYK_M": 0.05546180158854,
    "CMYK_Y": 0.1936127692461,
    "CMYK_K": 0.31564033031464
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31234",
    "Farbtonhilfsbezeichnung": "31234",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "185",
    "Bcolor": "163",
    "Y": 50,
    "L": 75.5954055786133,
    "a": 0.31370282173157,
    "b": 12.0687780380249,
    "C": 12.0728540420532,
    "h": 88.5110473632813,
    "CMY_C": 0.23142206668854,
    "CMY_M": 0.27298367023468,
    "CMY_Y": 0.36135238409042,
    "CMYK_C": 0,
    "CMYK_M": 0.05407597869635,
    "CMYK_Y": 0.16905288398266,
    "CMYK_K": 0.23142206668854
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31235",
    "Farbtonhilfsbezeichnung": "31235",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "201",
    "Bcolor": "180",
    "Y": 59,
    "L": 81.0805969238281,
    "a": 0.2189679145813,
    "b": 10.8837366104126,
    "C": 10.8859386444092,
    "h": 88.8474349975586,
    "CMY_C": 0.17537105083466,
    "CMY_M": 0.21328324079514,
    "CMY_Y": 0.29522311687469,
    "CMYK_C": 0,
    "CMYK_M": 0.04597484692931,
    "CMYK_Y": 0.14534060657024,
    "CMYK_K": 0.17537105083466
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31236",
    "Farbtonhilfsbezeichnung": "31236",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "211",
    "Bcolor": "192",
    "Y": 66,
    "L": 84.9354476928711,
    "a": 0.41866463422775,
    "b": 10.1209897994995,
    "C": 10.1296453475952,
    "h": 87.6312484741211,
    "CMY_C": 0.13347172737122,
    "CMY_M": 0.17144948244095,
    "CMY_Y": 0.2485516667366,
    "CMYK_C": 0,
    "CMYK_M": 0.04382748529315,
    "CMYK_Y": 0.13280574977398,
    "CMYK_K": 0.13347172737122
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31237",
    "Farbtonhilfsbezeichnung": "31237",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "224",
    "Bcolor": "205",
    "Y": 75,
    "L": 89.5459594726563,
    "a": 0.35563138127327,
    "b": 9.51685523986816,
    "C": 9.52349758148193,
    "h": 87.8599319458008,
    "CMY_C": 0.08429217338562,
    "CMY_M": 0.12024658918381,
    "CMY_Y": 0.19437021017075,
    "CMYK_C": 0,
    "CMYK_M": 0.03926406800747,
    "CMYK_Y": 0.12021087110043,
    "CMYK_K": 0.08429217338562
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31240",
    "Farbtonhilfsbezeichnung": "31240",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "187",
    "Bcolor": "86",
    "Y": 51,
    "L": 77.0209274291992,
    "a": 0.34869235754013,
    "b": 53.7696571350098,
    "C": 53.7707862854004,
    "h": 89.6284484863281,
    "CMY_C": 0.13774704933167,
    "CMY_M": 0.26524180173874,
    "CMY_Y": 0.66126716136932,
    "CMYK_C": 0,
    "CMYK_M": 0.1478623598814,
    "CMYK_Y": 0.6071537733078,
    "CMYK_K": 0.13774704933167
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31241",
    "Farbtonhilfsbezeichnung": "31241",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "150",
    "Bcolor": "65",
    "Y": 32,
    "L": 63.1792373657227,
    "a": 0.79624497890472,
    "b": 47.2524223327637,
    "C": 47.2591323852539,
    "h": 89.0346069335938,
    "CMY_C": 0.30031907558441,
    "CMY_M": 0.41059929132462,
    "CMY_Y": 0.74506640434265,
    "CMYK_C": 0,
    "CMYK_M": 0.15761500597,
    "CMYK_Y": 0.63564306497574,
    "CMYK_K": 0.30031907558441
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31242",
    "Farbtonhilfsbezeichnung": "31242",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "132",
    "Bcolor": "66",
    "Y": 25,
    "L": 56.5047187805176,
    "a": 2.67533469200134,
    "b": 38.6079025268555,
    "C": 38.7004852294922,
    "h": 86.0360260009766,
    "CMY_C": 0.37282764911652,
    "CMY_M": 0.48155575990677,
    "CMY_Y": 0.74027323722839,
    "CMYK_C": 0,
    "CMYK_M": 0.17336240410805,
    "CMYK_Y": 0.58587658405304,
    "CMYK_K": 0.37282764911652
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31243",
    "Farbtonhilfsbezeichnung": "31243",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "101",
    "Bcolor": "67",
    "Y": 14,
    "L": 43.0962905883789,
    "a": -0.97815656661987,
    "b": 20.2929019927979,
    "C": 20.316463470459,
    "h": 92.7596282958984,
    "CMY_C": 0.56082201004028,
    "CMY_M": 0.60270690917969,
    "CMY_Y": 0.73531699180603,
    "CMYK_C": 0,
    "CMYK_M": 0.0953711271286,
    "CMYK_Y": 0.39732179045677,
    "CMYK_K": 0.56082201004028
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31244",
    "Farbtonhilfsbezeichnung": "31244",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "80",
    "Bcolor": "66",
    "Y": 8,
    "L": 33.9056777954102,
    "a": -0.52961021661758,
    "b": 8.45811748504639,
    "C": 8.47468185424805,
    "h": 93.5829315185547,
    "CMY_C": 0.66957974433899,
    "CMY_M": 0.68792867660522,
    "CMY_Y": 0.74198365211487,
    "CMYK_C": 0,
    "CMYK_M": 0.05553210526705,
    "CMYK_Y": 0.21912671625614,
    "CMYK_K": 0.66957974433899
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31300",
    "Farbtonhilfsbezeichnung": "31300",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "167",
    "Bcolor": "58",
    "Y": 44,
    "L": 72.3747253417969,
    "a": 12.3742961883545,
    "b": 61.4701728820801,
    "C": 62.703311920166,
    "h": 78.6181564331055,
    "CMY_C": 0.1112203001976,
    "CMY_M": 0.34500575065613,
    "CMY_Y": 0.77346783876419,
    "CMYK_C": 0,
    "CMYK_M": 0.26304093003273,
    "CMYK_Y": 0.7451199889183,
    "CMYK_K": 0.1112203001976
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31301",
    "Farbtonhilfsbezeichnung": "31301",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "185",
    "Bcolor": "79",
    "Y": 54,
    "L": 78.3846282958984,
    "a": 9.46758365631104,
    "b": 59.1981964111328,
    "C": 59.9504928588867,
    "h": 80.9136199951172,
    "CMY_C": 0.05897915363312,
    "CMY_M": 0.27365159988403,
    "CMY_Y": 0.69069027900696,
    "CMYK_C": 0,
    "CMYK_M": 0.22812719643116,
    "CMYK_Y": 0.6713040471077,
    "CMYK_K": 0.05897915363312
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31302",
    "Farbtonhilfsbezeichnung": "31302",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "197",
    "Bcolor": "100",
    "Y": 60,
    "L": 81.7303771972656,
    "a": 6.25589275360107,
    "b": 53.533088684082,
    "C": 53.8973808288574,
    "h": 83.3346328735352,
    "CMY_C": 0.04551821947098,
    "CMY_M": 0.2288806438446,
    "CMY_Y": 0.60928440093994,
    "CMYK_C": 0,
    "CMYK_M": 0.19210678339005,
    "CMYK_Y": 0.59065157175064,
    "CMYK_K": 0.04551821947098
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31303",
    "Farbtonhilfsbezeichnung": "31303",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "207",
    "Bcolor": "118",
    "Y": 67,
    "L": 84.9430694580078,
    "a": 3.80949330329895,
    "b": 48.3608932495117,
    "C": 48.5107040405273,
    "h": 85.4959869384766,
    "CMY_C": 0.03025788068771,
    "CMY_M": 0.1872022151947,
    "CMY_Y": 0.53538763523102,
    "CMYK_C": 0,
    "CMYK_M": 0.16184130311012,
    "CMYK_Y": 0.52089083194733,
    "CMYK_K": 0.03025788068771
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31304",
    "Farbtonhilfsbezeichnung": "31304",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "217",
    "Bcolor": "141",
    "Y": 70,
    "L": 87.6676559448242,
    "a": 1.43143844604492,
    "b": 40.4211120605469,
    "C": 40.4464492797852,
    "h": 87.9718246459961,
    "CMY_C": 0.02686095237732,
    "CMY_M": 0.1502520442009,
    "CMY_Y": 0.44586485624313,
    "CMYK_C": 0,
    "CMYK_M": 0.12679697573185,
    "CMYK_Y": 0.4305694103241,
    "CMYK_K": 0.02686095237732
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31305",
    "Farbtonhilfsbezeichnung": "31305",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "224",
    "Bcolor": "162",
    "Y": 75,
    "L": 89.7133102416992,
    "a": -0.02936761267483,
    "b": 32.6505813598633,
    "C": 32.6505928039551,
    "h": 90.0515365600586,
    "CMY_C": 0.02797210216522,
    "CMY_M": 0.12270706892014,
    "CMY_Y": 0.36545348167419,
    "CMYK_C": 0,
    "CMYK_M": 0.09746116399765,
    "CMYK_Y": 0.34719309210777,
    "CMYK_K": 0.02797210216522
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31306",
    "Farbtonhilfsbezeichnung": "31306",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "179",
    "Y": 80,
    "L": 91.5172424316406,
    "a": -0.62581092119217,
    "b": 26.3027629852295,
    "C": 26.3102073669434,
    "h": 91.3629608154297,
    "CMY_C": 0.02531170845032,
    "CMY_M": 0.09993755817413,
    "CMY_Y": 0.29851496219635,
    "CMYK_C": 0,
    "CMYK_M": 0.0765638127923,
    "CMYK_Y": 0.28029808402061,
    "CMYK_K": 0.02531170845032
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31307",
    "Farbtonhilfsbezeichnung": "31307",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "236",
    "Bcolor": "202",
    "Y": 84,
    "L": 93.5564270019531,
    "a": -0.83680313825607,
    "b": 17.3454666137695,
    "C": 17.3656406402588,
    "h": 92.7620010375977,
    "CMY_C": 0.02593582868576,
    "CMY_M": 0.07462048530579,
    "CMY_Y": 0.20934963226318,
    "CMYK_C": 0,
    "CMYK_M": 0.04998095333576,
    "CMYK_Y": 0.18829745054245,
    "CMYK_K": 0.02593582868576
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31308",
    "Farbtonhilfsbezeichnung": "31308",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "210",
    "Y": 85,
    "L": 94.0579376220703,
    "a": -0.51310795545578,
    "b": 13.8493175506592,
    "C": 13.8588190078735,
    "h": 92.1218032836914,
    "CMY_C": 0.02745467424393,
    "CMY_M": 0.06891572475433,
    "CMY_Y": 0.17764443159103,
    "CMYK_C": 0,
    "CMYK_M": 0.04263148456812,
    "CMYK_Y": 0.15442956984043,
    "CMYK_K": 0.02745467424393
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31309",
    "Farbtonhilfsbezeichnung": "31309",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "217",
    "Y": 87,
    "L": 94.5722351074219,
    "a": -0.59063202142715,
    "b": 11.0050868988037,
    "C": 11.0209245681763,
    "h": 93.0720596313477,
    "CMY_C": 0.03045511245728,
    "CMY_M": 0.06223398447037,
    "CMY_Y": 0.150734603405,
    "CMYK_C": 0,
    "CMYK_M": 0.03277710080147,
    "CMYK_Y": 0.12405768036842,
    "CMYK_K": 0.03045511245728
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31310",
    "Farbtonhilfsbezeichnung": "31310",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "178",
    "Bcolor": "93",
    "Y": 48,
    "L": 74.7518081665039,
    "a": 6.35161781311035,
    "b": 47.9059562683105,
    "C": 48.3251876831055,
    "h": 82.4474792480469,
    "CMY_C": 0.13367807865143,
    "CMY_M": 0.30303293466568,
    "CMY_Y": 0.63402414321899,
    "CMYK_C": 0,
    "CMYK_M": 0.195487216115,
    "CMYK_Y": 0.57755213975906,
    "CMYK_K": 0.13367807865143
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31311",
    "Farbtonhilfsbezeichnung": "31311",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "197",
    "Bcolor": "121",
    "Y": 58,
    "L": 80.9932098388672,
    "a": 3.91949892044067,
    "b": 41.7734298706055,
    "C": 41.9569053649902,
    "h": 84.6397705078125,
    "CMY_C": 0.08549404144287,
    "CMY_M": 0.22933161258698,
    "CMY_Y": 0.52406257390976,
    "CMYK_C": 0,
    "CMYK_M": 0.15728445351124,
    "CMYK_Y": 0.47956880927086,
    "CMYK_K": 0.08549404144287
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31312",
    "Farbtonhilfsbezeichnung": "31312",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "206",
    "Bcolor": "141",
    "Y": 65,
    "L": 84.1347503662109,
    "a": 2.4203417301178,
    "b": 35.7384414672852,
    "C": 35.8203048706055,
    "h": 86.1256332397461,
    "CMY_C": 0.06938230991364,
    "CMY_M": 0.19053602218628,
    "CMY_Y": 0.44631344079971,
    "CMYK_C": 0,
    "CMYK_M": 0.13018633425236,
    "CMYK_Y": 0.40503326058388,
    "CMYK_K": 0.06938230991364
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31313",
    "Farbtonhilfsbezeichnung": "31313",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "219",
    "Bcolor": "164",
    "Y": 72,
    "L": 88.1427459716797,
    "a": 1.01124536991119,
    "b": 29.2499408721924,
    "C": 29.2674160003662,
    "h": 88.0199203491211,
    "CMY_C": 0.04582566022873,
    "CMY_M": 0.14189726114273,
    "CMY_Y": 0.35604214668274,
    "CMYK_C": 0,
    "CMYK_M": 0.1006855815649,
    "CMYK_Y": 0.32511511445045,
    "CMYK_K": 0.04582566022873
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31314",
    "Farbtonhilfsbezeichnung": "31314",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "223",
    "Bcolor": "176",
    "Y": 75,
    "L": 89.5051574707031,
    "a": 0.33438494801521,
    "b": 24.9777050018311,
    "C": 24.9799423217773,
    "h": 89.2330093383789,
    "CMY_C": 0.04448747634888,
    "CMY_M": 0.12430894374847,
    "CMY_Y": 0.30974817276001,
    "CMYK_C": 0,
    "CMYK_M": 0.08353785425425,
    "CMYK_Y": 0.27761089801788,
    "CMYK_K": 0.04448747634888
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31315",
    "Farbtonhilfsbezeichnung": "31315",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "232",
    "Bcolor": "194",
    "Y": 81,
    "L": 92.1498947143555,
    "a": -0.29881596565247,
    "b": 19.2915668487549,
    "C": 19.2938804626465,
    "h": 90.8874053955078,
    "CMY_C": 0.03282797336578,
    "CMY_M": 0.09209698438644,
    "CMY_Y": 0.23903304338455,
    "CMYK_C": 0,
    "CMYK_M": 0.06128073483706,
    "CMYK_Y": 0.21320413053036,
    "CMYK_K": 0.03282797336578
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31316",
    "Farbtonhilfsbezeichnung": "31316",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "235",
    "Bcolor": "205",
    "Y": 84,
    "L": 93.2101516723633,
    "a": -0.6621977686882,
    "b": 14.8187322616577,
    "C": 14.8335208892822,
    "h": 92.5586471557617,
    "CMY_C": 0.03547251224518,
    "CMY_M": 0.07830274105072,
    "CMY_Y": 0.19415527582169,
    "CMYK_C": 0,
    "CMYK_M": 0.04440540075302,
    "CMYK_Y": 0.16451865434647,
    "CMYK_K": 0.03547251224518
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31320",
    "Farbtonhilfsbezeichnung": "31320",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "176",
    "Bcolor": "109",
    "Y": 47,
    "L": 73.5637359619141,
    "a": 3.7985999584198,
    "b": 38.3823165893555,
    "C": 38.5698280334473,
    "h": 84.3479843139648,
    "CMY_C": 0.17656666040421,
    "CMY_M": 0.30801248550415,
    "CMY_Y": 0.572913646698,
    "CMYK_C": 0,
    "CMYK_M": 0.15963141620159,
    "CMYK_Y": 0.48133462667465,
    "CMYK_K": 0.17656666040421
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31321",
    "Farbtonhilfsbezeichnung": "31321",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "188",
    "Bcolor": "128",
    "Y": 53,
    "L": 77.2990188598633,
    "a": 1.86180675029755,
    "b": 33.545783996582,
    "C": 33.5974082946777,
    "h": 86.8233184814453,
    "CMY_C": 0.15491229295731,
    "CMY_M": 0.26277476549149,
    "CMY_Y": 0.49972814321518,
    "CMYK_C": 0,
    "CMYK_M": 0.12763464450836,
    "CMYK_Y": 0.40802374482155,
    "CMYK_K": 0.15491229295731
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31322",
    "Farbtonhilfsbezeichnung": "31322",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "198",
    "Bcolor": "148",
    "Y": 58,
    "L": 80.40576171875,
    "a": -0.29341712594032,
    "b": 26.9240779876709,
    "C": 26.9256763458252,
    "h": 90.624382019043,
    "CMY_C": 0.14742803573608,
    "CMY_M": 0.2229790687561,
    "CMY_Y": 0.41945064067841,
    "CMYK_C": 0,
    "CMYK_M": 0.08861543238163,
    "CMYK_Y": 0.31906116008759,
    "CMYK_K": 0.14742803573608
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31323",
    "Farbtonhilfsbezeichnung": "31323",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "201",
    "Bcolor": "165",
    "Y": 59,
    "L": 80.8687515258789,
    "a": -1.52004730701447,
    "b": 18.6177406311035,
    "C": 18.6796894073486,
    "h": 94.6675720214844,
    "CMY_C": 0.16995340585709,
    "CMY_M": 0.21336889266968,
    "CMY_Y": 0.35397017002106,
    "CMYK_C": 0,
    "CMYK_M": 0.05230487883091,
    "CMYK_Y": 0.22169449925423,
    "CMYK_K": 0.16995340585709
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31324",
    "Farbtonhilfsbezeichnung": "31324",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "211",
    "Bcolor": "188",
    "Y": 66,
    "L": 84.6518020629883,
    "a": -0.9270133972168,
    "b": 11.8143510818481,
    "C": 11.850664138794,
    "h": 94.4865188598633,
    "CMY_C": 0.14180278778076,
    "CMY_M": 0.17183274030685,
    "CMY_Y": 0.26418852806091,
    "CMYK_C": 0,
    "CMYK_M": 0.0349919013679,
    "CMYK_Y": 0.14260794222355,
    "CMYK_K": 0.14180278778076
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31330",
    "Farbtonhilfsbezeichnung": "31330",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "98",
    "Bcolor": "81",
    "Y": 13,
    "L": 42.088077545166,
    "a": 2.15461182594299,
    "b": 10.7177400588989,
    "C": 10.932168006897,
    "h": 78.6332092285156,
    "CMY_C": 0.56984907388687,
    "CMY_M": 0.61713922023773,
    "CMY_Y": 0.6817455291748,
    "CMYK_C": 0,
    "CMYK_M": 0.10993849486113,
    "CMYK_Y": 0.26013299822807,
    "CMYK_K": 0.56984907388687
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31331",
    "Farbtonhilfsbezeichnung": "31331",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "126",
    "Bcolor": "107",
    "Y": 22,
    "L": 53.5857887268066,
    "a": 1.6788170337677,
    "b": 11.6702060699463,
    "C": 11.790340423584,
    "h": 81.8138809204102,
    "CMY_C": 0.4554209113121,
    "CMY_M": 0.50401127338409,
    "CMY_Y": 0.57952761650085,
    "CMYK_C": 0,
    "CMYK_M": 0.08922553807497,
    "CMYK_Y": 0.22789473831654,
    "CMYK_K": 0.4554209113121
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31332",
    "Farbtonhilfsbezeichnung": "31332",
    "Farbtonklasse": "01",
    "Rcolor": "155",
    "Gcolor": "143",
    "Bcolor": "123",
    "Y": 29,
    "L": 59.7905158996582,
    "a": 1.55658900737762,
    "b": 11.689001083374,
    "C": 11.7921886444092,
    "h": 82.4147186279297,
    "CMY_C": 0.39209115505219,
    "CMY_M": 0.44109737873077,
    "CMY_Y": 0.51901364326477,
    "CMYK_C": 0,
    "CMYK_M": 0.08061442524195,
    "CMYK_Y": 0.20878539979458,
    "CMYK_K": 0.39209115505219
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31333",
    "Farbtonhilfsbezeichnung": "31333",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "165",
    "Bcolor": "143",
    "Y": 39,
    "L": 68.0702896118164,
    "a": 0.79264032840729,
    "b": 11.8860635757446,
    "C": 11.9124631881714,
    "h": 86.1847991943359,
    "CMY_C": 0.30951285362244,
    "CMY_M": 0.35377728939056,
    "CMY_Y": 0.43742644786835,
    "CMYK_C": 0,
    "CMYK_M": 0.06410609930754,
    "CMYK_Y": 0.18525123596191,
    "CMYK_K": 0.30951285362244
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31334",
    "Farbtonhilfsbezeichnung": "31334",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "180",
    "Bcolor": "161",
    "Y": 47,
    "L": 73.7639389038086,
    "a": 1.14391720294952,
    "b": 10.587890625,
    "C": 10.6495056152344,
    "h": 83.8336715698242,
    "CMY_C": 0.24929249286652,
    "CMY_M": 0.29410630464554,
    "CMY_Y": 0.36969816684723,
    "CMYK_C": 0,
    "CMYK_M": 0.05969543755054,
    "CMYK_Y": 0.1603896021843,
    "CMYK_K": 0.24929249286652
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31335",
    "Farbtonhilfsbezeichnung": "31335",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "200",
    "Bcolor": "183",
    "Y": 59,
    "L": 80.9747085571289,
    "a": 1.5410121679306,
    "b": 9.2331714630127,
    "C": 9.36088562011719,
    "h": 80.5246963500977,
    "CMY_C": 0.17148452997208,
    "CMY_M": 0.21711891889572,
    "CMY_Y": 0.28418564796448,
    "CMYK_C": 0,
    "CMYK_M": 0.0550797060132,
    "CMYK_Y": 0.13602778315544,
    "CMYK_K": 0.17148452997208
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31336",
    "Farbtonhilfsbezeichnung": "31336",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "212",
    "Bcolor": "196",
    "Y": 67,
    "L": 85.3364028930664,
    "a": 0.50425833463669,
    "b": 8.41445922851563,
    "C": 8.42955493927002,
    "h": 86.5705032348633,
    "CMY_C": 0.13334411382675,
    "CMY_M": 0.1668114066124,
    "CMY_Y": 0.23174530267715,
    "CMYK_C": 0,
    "CMYK_M": 0.03861658647656,
    "CMYK_Y": 0.11354124546051,
    "CMYK_K": 0.13334411382675
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31337",
    "Farbtonhilfsbezeichnung": "31337",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "206",
    "Y": 74,
    "L": 88.9677200317383,
    "a": 0.46638834476471,
    "b": 8.24003314971924,
    "C": 8.25322151184082,
    "h": 86.760498046875,
    "CMY_C": 0.09372144937515,
    "CMY_M": 0.12659293413162,
    "CMY_Y": 0.19120097160339,
    "CMYK_C": 0,
    "CMYK_M": 0.03627084195614,
    "CMYK_Y": 0.1075602248311,
    "CMYK_K": 0.09372144937515
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31340",
    "Farbtonhilfsbezeichnung": "31340",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "152",
    "Bcolor": "65",
    "Y": 35,
    "L": 65.8035125732422,
    "a": 8.41359806060791,
    "b": 50.4880599975586,
    "C": 51.1843032836914,
    "h": 80.5388641357422,
    "CMY_C": 0.2216677069664,
    "CMY_M": 0.40201205015182,
    "CMY_Y": 0.74328935146332,
    "CMYK_C": 0,
    "CMYK_M": 0.23170609772205,
    "CMYK_Y": 0.67017859220505,
    "CMYK_K": 0.2216677069664
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31341",
    "Farbtonhilfsbezeichnung": "31341",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "140",
    "Bcolor": "68",
    "Y": 29,
    "L": 60.1633682250977,
    "a": 5.53580188751221,
    "b": 42.4231300354004,
    "C": 42.7827911376953,
    "h": 82.5654678344727,
    "CMY_C": 0.31111943721771,
    "CMY_M": 0.4517365694046,
    "CMY_Y": 0.73389840126038,
    "CMYK_C": 0,
    "CMYK_M": 0.20412410795689,
    "CMYK_Y": 0.6137188076973,
    "CMYK_K": 0.31111943721771
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31342",
    "Farbtonhilfsbezeichnung": "31342",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "127",
    "Bcolor": "68",
    "Y": 23,
    "L": 54.6384048461914,
    "a": 4.01713609695435,
    "b": 35.1376152038574,
    "C": 35.3665008544922,
    "h": 83.4779281616211,
    "CMY_C": 0.38945806026459,
    "CMY_M": 0.50281417369843,
    "CMY_Y": 0.73153549432755,
    "CMYK_C": 0,
    "CMYK_M": 0.18566474318504,
    "CMYK_Y": 0.56028491258621,
    "CMYK_K": 0.38945806026459
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31343",
    "Farbtonhilfsbezeichnung": "31343",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "104",
    "Bcolor": "67",
    "Y": 15,
    "L": 45.1144523620605,
    "a": 2.31873154640198,
    "b": 23.2280158996582,
    "C": 23.3434619903564,
    "h": 84.2993469238281,
    "CMY_C": 0.51612949371338,
    "CMY_M": 0.59069746732712,
    "CMY_Y": 0.73597455024719,
    "CMYK_C": 0,
    "CMYK_M": 0.15410728752613,
    "CMYK_Y": 0.4543468952179,
    "CMYK_K": 0.51612949371338
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31344",
    "Farbtonhilfsbezeichnung": "31344",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "92",
    "Bcolor": "68",
    "Y": 11,
    "L": 39.7274017333984,
    "a": 1.90087592601776,
    "b": 15.2124404907227,
    "C": 15.3307428359985,
    "h": 82.8775024414063,
    "CMY_C": 0.58584952354431,
    "CMY_M": 0.63984680175781,
    "CMY_Y": 0.73205506801605,
    "CMYK_C": 0,
    "CMYK_M": 0.13038082420826,
    "CMYK_Y": 0.35302516818047,
    "CMYK_K": 0.58584952354431
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31400",
    "Farbtonhilfsbezeichnung": "31400",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "157",
    "Bcolor": "69",
    "Y": 41,
    "L": 70.2566452026367,
    "a": 19.5306987762451,
    "b": 54.5227699279785,
    "C": 57.9152870178223,
    "h": 70.291877746582,
    "CMY_C": 0.10119718313217,
    "CMY_M": 0.38569808006287,
    "CMY_Y": 0.72844648361206,
    "CMYK_C": 0,
    "CMYK_M": 0.31653314828873,
    "CMYK_Y": 0.6978719830513,
    "CMYK_K": 0.10119718313217
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31401",
    "Farbtonhilfsbezeichnung": "31401",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "169",
    "Bcolor": "88",
    "Y": 47,
    "L": 73.8924331665039,
    "a": 16.2302837371826,
    "b": 50.0816917419434,
    "C": 52.6459693908691,
    "h": 72.0437240600586,
    "CMY_C": 0.08148384094238,
    "CMY_M": 0.33792853355408,
    "CMY_Y": 0.65669703483582,
    "CMYK_C": 0,
    "CMYK_M": 0.27919453382492,
    "CMYK_Y": 0.62624180316925,
    "CMYK_K": 0.08148384094238
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31402",
    "Farbtonhilfsbezeichnung": "31402",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "180",
    "Bcolor": "105",
    "Y": 52,
    "L": 77.1954498291016,
    "a": 13.659948348999,
    "b": 45.4044876098633,
    "C": 47.4147834777832,
    "h": 73.2560729980469,
    "CMY_C": 0.06338751316071,
    "CMY_M": 0.2953594326973,
    "CMY_Y": 0.58767116069794,
    "CMYK_C": 0,
    "CMYK_M": 0.24767118692398,
    "CMYK_Y": 0.55976581573486,
    "CMYK_K": 0.06338751316071
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31403",
    "Farbtonhilfsbezeichnung": "31403",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "198",
    "Bcolor": "136",
    "Y": 62,
    "L": 82.5779037475586,
    "a": 8.93235778808594,
    "b": 36.385181427002,
    "C": 37.4655647277832,
    "h": 76.2069854736328,
    "CMY_C": 0.04333364963531,
    "CMY_M": 0.22372627258301,
    "CMY_Y": 0.46566903591156,
    "CMYK_C": 0,
    "CMYK_M": 0.18856377899647,
    "CMYK_Y": 0.44146570563316,
    "CMYK_K": 0.04333364963531
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31404",
    "Farbtonhilfsbezeichnung": "31404",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "209",
    "Bcolor": "155",
    "Y": 68,
    "L": 85.6867370605469,
    "a": 6.11331081390381,
    "b": 30.7677593231201,
    "C": 31.3692131042481,
    "h": 78.7621383666992,
    "CMY_C": 0.03602945804596,
    "CMY_M": 0.18168479204178,
    "CMY_Y": 0.39204579591751,
    "CMYK_C": 0,
    "CMYK_M": 0.15109936892986,
    "CMYK_Y": 0.36932283639908,
    "CMYK_K": 0.03602945804596
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31405",
    "Farbtonhilfsbezeichnung": "31405",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "219",
    "Bcolor": "177",
    "Y": 74,
    "L": 88.9368743896484,
    "a": 4.00077295303345,
    "b": 23.7761898040771,
    "C": 24.1104412078857,
    "h": 80.4484252929688,
    "CMY_C": 0.02781277894974,
    "CMY_M": 0.1392315030098,
    "CMY_Y": 0.30610448122025,
    "CMYK_C": 0,
    "CMYK_M": 0.11460623890162,
    "CMYK_Y": 0.28625321388245,
    "CMYK_K": 0.02781277894974
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31406",
    "Farbtonhilfsbezeichnung": "31406",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "224",
    "Bcolor": "187",
    "Y": 76,
    "L": 90.223876953125,
    "a": 3.05685973167419,
    "b": 20.4282398223877,
    "C": 20.6556854248047,
    "h": 81.4894714355469,
    "CMY_C": 0.02761173248291,
    "CMY_M": 0.1219083070755,
    "CMY_Y": 0.2676038146019,
    "CMYK_C": 0,
    "CMYK_M": 0.09697420150042,
    "CMYK_Y": 0.24680684506893,
    "CMYK_K": 0.02761173248291
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31407",
    "Farbtonhilfsbezeichnung": "31407",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "231",
    "Bcolor": "202",
    "Y": 81,
    "L": 92.3219451904297,
    "a": 1.7243800163269,
    "b": 15.2792997360229,
    "C": 15.376296043396,
    "h": 83.5609970092773,
    "CMY_C": 0.02652978897095,
    "CMY_M": 0.09408718347549,
    "CMY_Y": 0.20684272050858,
    "CMYK_C": 0,
    "CMYK_M": 0.06939852237701,
    "CMYK_Y": 0.18522696197033,
    "CMYK_K": 0.02652978897095
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31408",
    "Farbtonhilfsbezeichnung": "31408",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "213",
    "Y": 85,
    "L": 93.5519409179688,
    "a": 0.52390038967133,
    "b": 11.5997285842896,
    "C": 11.6115531921387,
    "h": 87.4139938354492,
    "CMY_C": 0.03179603815079,
    "CMY_M": 0.07650768756866,
    "CMY_Y": 0.16617834568024,
    "CMYK_C": 0,
    "CMYK_M": 0.04617999121547,
    "CMYK_Y": 0.13879545032978,
    "CMYK_K": 0.03179603815079
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31409",
    "Farbtonhilfsbezeichnung": "31409",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "221",
    "Y": 87,
    "L": 94.8052825927734,
    "a": -0.21014483273029,
    "b": 9.18598747253418,
    "C": 9.18839073181152,
    "h": 91.3105087280273,
    "CMY_C": 0.03035634756088,
    "CMY_M": 0.06005162000656,
    "CMY_Y": 0.13449841737747,
    "CMYK_C": 0,
    "CMYK_M": 0.03062493354082,
    "CMYK_Y": 0.10740241408348,
    "CMYK_K": 0.03035634756088
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31410",
    "Farbtonhilfsbezeichnung": "31410",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "170",
    "Bcolor": "105",
    "Y": 45,
    "L": 73.0315322875977,
    "a": 12.3135042190552,
    "b": 40.2637176513672,
    "C": 42.1045036315918,
    "h": 72.995246887207,
    "CMY_C": 0.12698501348495,
    "CMY_M": 0.33513820171356,
    "CMY_Y": 0.5901392698288,
    "CMYK_C": 0,
    "CMYK_M": 0.23843026161194,
    "CMYK_Y": 0.53052270412445,
    "CMYK_K": 0.12698501348495
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31411",
    "Farbtonhilfsbezeichnung": "31411",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "187",
    "Bcolor": "126",
    "Y": 55,
    "L": 78.8716506958008,
    "a": 10.3366422653198,
    "b": 37.0241928100586,
    "C": 38.4400444030762,
    "h": 74.4010009765625,
    "CMY_C": 0.07633864879608,
    "CMY_M": 0.26739329099655,
    "CMY_Y": 0.50784134864807,
    "CMYK_C": 0,
    "CMYK_M": 0.20684489607811,
    "CMYK_Y": 0.46716547012329,
    "CMYK_K": 0.07633864879608
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31412",
    "Farbtonhilfsbezeichnung": "31412",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "200",
    "Bcolor": "150",
    "Y": 62,
    "L": 82.5971908569336,
    "a": 6.94763898849487,
    "b": 29.3183498382568,
    "C": 30.1303062438965,
    "h": 76.6684036254883,
    "CMY_C": 0.06877672672272,
    "CMY_M": 0.21715813875198,
    "CMY_Y": 0.41309416294098,
    "CMYK_C": 0,
    "CMYK_M": 0.15934032201767,
    "CMYK_Y": 0.36974745988846,
    "CMYK_K": 0.06877672672272
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31413",
    "Farbtonhilfsbezeichnung": "31413",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "213",
    "Bcolor": "171",
    "Y": 70,
    "L": 86.9890975952148,
    "a": 5.47090148925781,
    "b": 23.9487285614014,
    "C": 24.565673828125,
    "h": 77.1320343017578,
    "CMY_C": 0.0395080447197,
    "CMY_M": 0.16437101364136,
    "CMY_Y": 0.32770794630051,
    "CMYK_C": 0,
    "CMYK_M": 0.12999896705151,
    "CMYK_Y": 0.30005446076393,
    "CMYK_K": 0.0395080447197
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31414",
    "Farbtonhilfsbezeichnung": "31414",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "222",
    "Bcolor": "190",
    "Y": 75,
    "L": 89.3460540771484,
    "a": 2.92995810508728,
    "b": 17.3297595977783,
    "C": 17.5756988525391,
    "h": 80.4037017822266,
    "CMY_C": 0.04619663953781,
    "CMY_M": 0.13060259819031,
    "CMY_Y": 0.25397729873657,
    "CMYK_C": 0,
    "CMYK_M": 0.08849408477545,
    "CMYK_Y": 0.21784433722496,
    "CMYK_K": 0.04619663953781
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31415",
    "Farbtonhilfsbezeichnung": "31415",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "201",
    "Y": 79,
    "L": 91.5459213256836,
    "a": 1.78594696521759,
    "b": 14.6274862289429,
    "C": 14.7361106872559,
    "h": 83.0389099121094,
    "CMY_C": 0.03664749860764,
    "CMY_M": 0.10272973775864,
    "CMY_Y": 0.21037971973419,
    "CMYK_C": 0,
    "CMYK_M": 0.06859611719847,
    "CMYK_Y": 0.18034127354622,
    "CMYK_K": 0.03664749860764
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31416",
    "Farbtonhilfsbezeichnung": "31416",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "232",
    "Bcolor": "209",
    "Y": 82,
    "L": 92.5752334594727,
    "a": 0.95912384986877,
    "b": 11.8982601165772,
    "C": 11.9368553161621,
    "h": 85.3913269042969,
    "CMY_C": 0.03872060775757,
    "CMY_M": 0.08856099843979,
    "CMY_Y": 0.17899876832962,
    "CMYK_C": 0,
    "CMYK_M": 0.05184797570109,
    "CMYK_Y": 0.14592860639095,
    "CMYK_K": 0.03872060775757
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31420",
    "Farbtonhilfsbezeichnung": "31420",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "152",
    "Bcolor": "93",
    "Y": 36,
    "L": 65.876106262207,
    "a": 10.1447439193726,
    "b": 36.8357963562012,
    "C": 38.2072219848633,
    "h": 74.6022033691406,
    "CMY_C": 0.2265619635582,
    "CMY_M": 0.40370655059814,
    "CMY_Y": 0.63525795936584,
    "CMYK_C": 0,
    "CMYK_M": 0.22903527319431,
    "CMYK_Y": 0.52841466665268,
    "CMYK_K": 0.2265619635582
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31421",
    "Farbtonhilfsbezeichnung": "31421",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "168",
    "Bcolor": "115",
    "Y": 43,
    "L": 71.1418304443359,
    "a": 7.67069435119629,
    "b": 32.2052154541016,
    "C": 33.1061248779297,
    "h": 76.6028137207031,
    "CMY_C": 0.18919402360916,
    "CMY_M": 0.34192156791687,
    "CMY_Y": 0.55020469427109,
    "CMYK_C": 0,
    "CMYK_M": 0.18836510181427,
    "CMYK_Y": 0.4452491402626,
    "CMYK_K": 0.18919402360916
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31422",
    "Farbtonhilfsbezeichnung": "31422",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "184",
    "Bcolor": "140",
    "Y": 51,
    "L": 76.4192886352539,
    "a": 4.92948770523071,
    "b": 25.7714157104492,
    "C": 26.2386302947998,
    "h": 79.1714172363281,
    "CMY_C": 0.1591295003891,
    "CMY_M": 0.27805852890015,
    "CMY_Y": 0.45082437992096,
    "CMYK_C": 0,
    "CMYK_M": 0.14143560826778,
    "CMYK_Y": 0.34689632058144,
    "CMYK_K": 0.1591295003891
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31423",
    "Farbtonhilfsbezeichnung": "31423",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "197",
    "Bcolor": "163",
    "Y": 57,
    "L": 80.2201995849609,
    "a": 2.16143441200256,
    "b": 18.8557720184326,
    "C": 18.9792499542236,
    "h": 83.4607391357422,
    "CMY_C": 0.15050631761551,
    "CMY_M": 0.22905957698822,
    "CMY_Y": 0.36183989048004,
    "CMYK_C": 0,
    "CMYK_M": 0.09247068315744,
    "CMYK_Y": 0.24877591431141,
    "CMYK_K": 0.15050631761551
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31424",
    "Farbtonhilfsbezeichnung": "31424",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "210",
    "Bcolor": "190",
    "Y": 65,
    "L": 84.6400604248047,
    "a": 0.27378907799721,
    "b": 10.7949571609497,
    "C": 10.7984285354614,
    "h": 88.5471420288086,
    "CMY_C": 0.13590383529663,
    "CMY_M": 0.17451936006546,
    "CMY_Y": 0.25666779279709,
    "CMYK_C": 0,
    "CMYK_M": 0.04468892142177,
    "CMYK_Y": 0.13975754380226,
    "CMYK_K": 0.13590383529663
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31430",
    "Farbtonhilfsbezeichnung": "31430",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "94",
    "Bcolor": "80",
    "Y": 12,
    "L": 40.7859115600586,
    "a": 2.75363945960999,
    "b": 9.34615802764893,
    "C": 9.74336719512939,
    "h": 73.5835571289063,
    "CMY_C": 0.58183586597443,
    "CMY_M": 0.63051319122314,
    "CMY_Y": 0.68488109111786,
    "CMYK_C": 0,
    "CMYK_M": 0.11640722304583,
    "CMYK_Y": 0.24642291665077,
    "CMYK_K": 0.58183586597443
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31431",
    "Farbtonhilfsbezeichnung": "31431",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "122",
    "Bcolor": "106",
    "Y": 21,
    "L": 52.1998176574707,
    "a": 3.27663969993591,
    "b": 10.2658176422119,
    "C": 10.7760562896729,
    "h": 72.2979736328125,
    "CMY_C": 0.46245974302292,
    "CMY_M": 0.52102982997894,
    "CMY_Y": 0.58328986167908,
    "CMYK_C": 0,
    "CMYK_M": 0.10895944386721,
    "CMYK_Y": 0.22478339076042,
    "CMYK_K": 0.46245974302292
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31432",
    "Farbtonhilfsbezeichnung": "31432",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "134",
    "Bcolor": "118",
    "Y": 25,
    "L": 56.6463775634766,
    "a": 2.94588446617126,
    "b": 9.71658039093018,
    "C": 10.1533327102661,
    "h": 73.1336822509766,
    "CMY_C": 0.42022264003754,
    "CMY_M": 0.4756646156311,
    "CMY_Y": 0.53639775514603,
    "CMYK_C": 0,
    "CMYK_M": 0.09562631696463,
    "CMYK_Y": 0.20037883520126,
    "CMYK_K": 0.42022264003754
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31433",
    "Farbtonhilfsbezeichnung": "31433",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "156",
    "Bcolor": "139",
    "Y": 35,
    "L": 65.2047958374023,
    "a": 2.86135864257813,
    "b": 10.2884092330933,
    "C": 10.6788921356201,
    "h": 74.4579620361328,
    "CMY_C": 0.32976603507996,
    "CMY_M": 0.38800382614136,
    "CMY_Y": 0.45502835512161,
    "CMYK_C": 0,
    "CMYK_M": 0.08689173310995,
    "CMYK_Y": 0.18689341843128,
    "CMYK_K": 0.32976603507996
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31434",
    "Farbtonhilfsbezeichnung": "31434",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "178",
    "Bcolor": "162",
    "Y": 46,
    "L": 73.0142288208008,
    "a": 1.9934493303299,
    "b": 8.71015548706055,
    "C": 8.93535900115967,
    "h": 77.109016418457,
    "CMY_C": 0.25641423463821,
    "CMY_M": 0.30358946323395,
    "CMY_Y": 0.36402821540833,
    "CMYK_C": 0,
    "CMYK_M": 0.0634428858757,
    "CMYK_Y": 0.14472302794456,
    "CMYK_K": 0.25641423463821
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31435",
    "Farbtonhilfsbezeichnung": "31435",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "194",
    "Bcolor": "178",
    "Y": 55,
    "L": 78.9711151123047,
    "a": 2.0131413936615,
    "b": 8.76320362091064,
    "C": 8.9914665222168,
    "h": 77.0621185302734,
    "CMY_C": 0.19136375188828,
    "CMY_M": 0.23981493711472,
    "CMY_Y": 0.30195450782776,
    "CMYK_C": 0,
    "CMYK_M": 0.05991715565324,
    "CMYK_Y": 0.13676205277443,
    "CMYK_K": 0.19136375188828
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31436",
    "Farbtonhilfsbezeichnung": "31436",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "206",
    "Bcolor": "193",
    "Y": 63,
    "L": 83.2022476196289,
    "a": 1.63987731933594,
    "b": 7.04824733734131,
    "C": 7.23650407791138,
    "h": 76.9023208618164,
    "CMY_C": 0.15251129865646,
    "CMY_M": 0.19252407550812,
    "CMY_Y": 0.24453806877136,
    "CMYK_C": 0,
    "CMYK_M": 0.04721334576607,
    "CMYK_Y": 0.10858760774136,
    "CMYK_K": 0.15251129865646
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31437",
    "Farbtonhilfsbezeichnung": "31437",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "220",
    "Bcolor": "204",
    "Y": 73,
    "L": 88.1750411987305,
    "a": 1.1338529586792,
    "b": 8.0900411605835,
    "C": 8.16911220550537,
    "h": 82.021728515625,
    "CMY_C": 0.09798628091812,
    "CMY_M": 0.13692206144333,
    "CMY_Y": 0.1985992193222,
    "CMYK_C": 0,
    "CMYK_M": 0.04316539689898,
    "CMYK_Y": 0.1115425825119,
    "CMYK_K": 0.09798628091812
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31440",
    "Farbtonhilfsbezeichnung": "31440",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "147",
    "Bcolor": "81",
    "Y": 35,
    "L": 65.1703872680664,
    "a": 15.0297203063965,
    "b": 42.2845458984375,
    "C": 44.876220703125,
    "h": 70.4326324462891,
    "CMY_C": 0.19913798570633,
    "CMY_M": 0.42439752817154,
    "CMY_Y": 0.68155932426453,
    "CMYK_C": 0,
    "CMYK_M": 0.28127133846283,
    "CMYK_Y": 0.6023775935173,
    "CMYK_K": 0.19913798570633
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31441",
    "Farbtonhilfsbezeichnung": "31441",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "129",
    "Bcolor": "68",
    "Y": 27,
    "L": 58.4937362670898,
    "a": 15.8360691070557,
    "b": 40.9697074890137,
    "C": 43.9237747192383,
    "h": 68.8669281005859,
    "CMY_C": 0.27242022752762,
    "CMY_M": 0.49422633647919,
    "CMY_Y": 0.73519563674927,
    "CMYK_C": 0,
    "CMYK_M": 0.30485469102859,
    "CMYK_Y": 0.63604766130447,
    "CMYK_K": 0.27242022752762
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31442",
    "Farbtonhilfsbezeichnung": "31442",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "118",
    "Bcolor": "67",
    "Y": 21,
    "L": 52.5193710327148,
    "a": 10.1796875,
    "b": 33.452465057373,
    "C": 34.9670333862305,
    "h": 73.074836730957,
    "CMY_C": 0.37904989719391,
    "CMY_M": 0.5381772518158,
    "CMY_Y": 0.73730564117432,
    "CMYK_C": 0,
    "CMYK_M": 0.2562643289566,
    "CMYK_Y": 0.5769476890564,
    "CMYK_K": 0.37904989719391
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "31443",
    "Farbtonhilfsbezeichnung": "31443",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "101",
    "Bcolor": "67",
    "Y": 15,
    "L": 44.2987060546875,
    "a": 4.128098487854,
    "b": 22.2621307373047,
    "C": 22.6416358947754,
    "h": 79.4948883056641,
    "CMY_C": 0.51540470123291,
    "CMY_M": 0.60234028100967,
    "CMY_Y": 0.73651623725891,
    "CMYK_C": 0,
    "CMYK_M": 0.17939831316471,
    "CMYK_Y": 0.45628079771996,
    "CMYK_K": 0.51540470123291
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32100",
    "Farbtonhilfsbezeichnung": "32100",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "147",
    "Bcolor": "63",
    "Y": 39,
    "L": 68.5451431274414,
    "a": 26.8658466339111,
    "b": 55.8780632019043,
    "C": 62.0010604858398,
    "h": 64.322021484375,
    "CMY_C": 0.07941085100174,
    "CMY_M": 0.4251070022583,
    "CMY_Y": 0.75396662950516,
    "CMYK_C": 0,
    "CMYK_M": 0.37551620602608,
    "CMYK_Y": 0.73274356126785,
    "CMYK_K": 0.07941085100174
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32101",
    "Farbtonhilfsbezeichnung": "32101",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "159",
    "Bcolor": "76",
    "Y": 44,
    "L": 72.2583312988281,
    "a": 23.2143001556396,
    "b": 54.0511093139648,
    "C": 58.8253860473633,
    "h": 66.7570571899414,
    "CMY_C": 0.05653446912766,
    "CMY_M": 0.37528312206268,
    "CMY_Y": 0.70281159877777,
    "CMYK_C": 0,
    "CMYK_M": 0.33784875273705,
    "CMYK_Y": 0.68500345945358,
    "CMYK_K": 0.05653446912766
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32102",
    "Farbtonhilfsbezeichnung": "32102",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "173",
    "Bcolor": "92",
    "Y": 49,
    "L": 75.9034652709961,
    "a": 18.5707969665527,
    "b": 50.6440734863281,
    "C": 53.9416046142578,
    "h": 69.8623962402344,
    "CMY_C": 0.0430720448494,
    "CMY_M": 0.32318753004074,
    "CMY_Y": 0.64032608270645,
    "CMYK_C": 0,
    "CMYK_M": 0.29272368550301,
    "CMYK_Y": 0.62413686513901,
    "CMYK_K": 0.0430720448494
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32103",
    "Farbtonhilfsbezeichnung": "32103",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "192",
    "Bcolor": "120",
    "Y": 59,
    "L": 81.2495880126953,
    "a": 12.4520540237427,
    "b": 43.2415618896484,
    "C": 44.9987373352051,
    "h": 73.9354553222656,
    "CMY_C": 0.02595967054367,
    "CMY_M": 0.24838435649872,
    "CMY_Y": 0.53048074245453,
    "CMYK_C": 0,
    "CMYK_M": 0.22835265100002,
    "CMYK_Y": 0.51796734333038,
    "CMYK_K": 0.02595967054367
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32104",
    "Farbtonhilfsbezeichnung": "32104",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "202",
    "Bcolor": "136",
    "Y": 64,
    "L": 84.0108108520508,
    "a": 9.01526927947998,
    "b": 38.3799095153809,
    "C": 39.4245185852051,
    "h": 76.781120300293,
    "CMY_C": 0.02279788255692,
    "CMY_M": 0.20874106884003,
    "CMY_Y": 0.46606731414795,
    "CMYK_C": 0,
    "CMYK_M": 0.1902811974287,
    "CMYK_Y": 0.45361080765724,
    "CMYK_K": 0.02279788255692
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32105",
    "Farbtonhilfsbezeichnung": "32105",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "212",
    "Bcolor": "156",
    "Y": 70,
    "L": 86.9149932861328,
    "a": 5.47873449325562,
    "b": 31.7066650390625,
    "C": 32.1765327453613,
    "h": 80.1964111328125,
    "CMY_C": 0.0243022441864,
    "CMY_M": 0.16682529449463,
    "CMY_Y": 0.38643419742584,
    "CMYK_C": 0,
    "CMYK_M": 0.14607295393944,
    "CMYK_Y": 0.37115177512169,
    "CMYK_K": 0.0243022441864
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32106",
    "Farbtonhilfsbezeichnung": "32106",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "220",
    "Bcolor": "170",
    "Y": 74,
    "L": 88.9730758666992,
    "a": 3.48630166053772,
    "b": 27.3593673706055,
    "C": 27.5805969238281,
    "h": 82.738151550293,
    "CMY_C": 0.02309143543243,
    "CMY_M": 0.13834136724472,
    "CMY_Y": 0.33261823654175,
    "CMYK_C": 0,
    "CMYK_M": 0.11797412484884,
    "CMYK_Y": 0.3168431520462,
    "CMYK_K": 0.02309143543243
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32107",
    "Farbtonhilfsbezeichnung": "32107",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "228",
    "Bcolor": "187",
    "Y": 79,
    "L": 91.3376998901367,
    "a": 1.2147468328476,
    "b": 21.7721996307373,
    "C": 21.8060607910156,
    "h": 86.8065795898438,
    "CMY_C": 0.02485454082489,
    "CMY_M": 0.10535961389542,
    "CMY_Y": 0.26605898141861,
    "CMYK_C": 0,
    "CMYK_M": 0.08255699276924,
    "CMYK_Y": 0.24735227227211,
    "CMYK_K": 0.02485454082489
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32108",
    "Farbtonhilfsbezeichnung": "32108",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "202",
    "Y": 84,
    "L": 93.0640411376953,
    "a": 0.29169633984566,
    "b": 16.5633525848389,
    "C": 16.5659217834473,
    "h": 88.9910736083984,
    "CMY_C": 0.02524137496948,
    "CMY_M": 0.08264815807343,
    "CMY_Y": 0.20863622426987,
    "CMYK_C": 0,
    "CMYK_M": 0.05889333039522,
    "CMYK_Y": 0.18814386427402,
    "CMYK_K": 0.02524137496948
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32109",
    "Farbtonhilfsbezeichnung": "32109",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "238",
    "Bcolor": "214",
    "Y": 86,
    "L": 94.2861022949219,
    "a": -0.54042571783066,
    "b": 12.008957862854,
    "C": 12.0211114883423,
    "h": 92.5766754150391,
    "CMY_C": 0.03036248683929,
    "CMY_M": 0.06582516431808,
    "CMY_Y": 0.16137671470642,
    "CMYK_C": 0,
    "CMYK_M": 0.03657312691212,
    "CMYK_Y": 0.13511671125889,
    "CMYK_K": 0.03036248683929
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32110",
    "Farbtonhilfsbezeichnung": "32110",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "157",
    "Bcolor": "84",
    "Y": 41,
    "L": 69.7833404541016,
    "a": 17.6878223419189,
    "b": 46.6743316650391,
    "C": 49.9134483337402,
    "h": 69.2451705932617,
    "CMY_C": 0.12517958879471,
    "CMY_M": 0.38447314500809,
    "CMY_Y": 0.66972827911377,
    "CMYK_C": 0,
    "CMYK_M": 0.29639631509781,
    "CMYK_Y": 0.62246912717819,
    "CMYK_K": 0.12517958879471
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32111",
    "Farbtonhilfsbezeichnung": "32111",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "180",
    "Bcolor": "111",
    "Y": 53,
    "L": 77.3362731933594,
    "a": 13.3829002380371,
    "b": 42.3416595458984,
    "C": 44.4062843322754,
    "h": 72.4598541259766,
    "CMY_C": 0.06746768951416,
    "CMY_M": 0.29264062643051,
    "CMY_Y": 0.56274616718292,
    "CMYK_C": 0,
    "CMYK_M": 0.24146395921707,
    "CMYK_Y": 0.53111135959625,
    "CMYK_K": 0.06746768951416
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32112",
    "Farbtonhilfsbezeichnung": "32112",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "197",
    "Bcolor": "142",
    "Y": 60,
    "L": 81.9837036132813,
    "a": 8.56550788879395,
    "b": 32.5698738098145,
    "C": 33.677360534668,
    "h": 75.265510559082,
    "CMY_C": 0.05917352437973,
    "CMY_M": 0.22851699590683,
    "CMY_Y": 0.4432424902916,
    "CMYK_C": 0,
    "CMYK_M": 0.17999437451363,
    "CMYK_Y": 0.4082250893116,
    "CMYK_K": 0.05917352437973
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32113",
    "Farbtonhilfsbezeichnung": "32113",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "207",
    "Bcolor": "158",
    "Y": 66,
    "L": 85.1674346923828,
    "a": 6.45590782165527,
    "b": 28.7107620239258,
    "C": 29.4276504516602,
    "h": 77.3272399902344,
    "CMY_C": 0.04373955726624,
    "CMY_M": 0.18780392408371,
    "CMY_Y": 0.3820184469223,
    "CMYK_C": 0,
    "CMYK_M": 0.15065389871597,
    "CMYK_Y": 0.35375183820724,
    "CMYK_K": 0.04373955726624
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32114",
    "Farbtonhilfsbezeichnung": "32114",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "223",
    "Bcolor": "189",
    "Y": 77,
    "L": 90.07470703125,
    "a": 3.55522441864014,
    "b": 19.0806407928467,
    "C": 19.4090309143066,
    "h": 79.4453277587891,
    "CMY_C": 0.02904105186462,
    "CMY_M": 0.12446975708008,
    "CMY_Y": 0.25907325744629,
    "CMYK_C": 0,
    "CMYK_M": 0.09828294813633,
    "CMYK_Y": 0.23691238462925,
    "CMYK_K": 0.02904105186462
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32120",
    "Farbtonhilfsbezeichnung": "32120",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "157",
    "Bcolor": "117",
    "Y": 38,
    "L": 67.64990234375,
    "a": 10.820782661438,
    "b": 26.450122833252,
    "C": 28.5779342651367,
    "h": 67.7504653930664,
    "CMY_C": 0.21826535463333,
    "CMY_M": 0.38521844148636,
    "CMY_Y": 0.54255270957947,
    "CMYK_C": 0,
    "CMYK_M": 0.21356746554375,
    "CMYK_Y": 0.41483047604561,
    "CMYK_K": 0.21826535463333
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32121",
    "Farbtonhilfsbezeichnung": "32121",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "177",
    "Bcolor": "142",
    "Y": 48,
    "L": 74.1985473632813,
    "a": 7.0429253578186,
    "b": 21.7666149139404,
    "C": 22.8776817321777,
    "h": 72.0702133178711,
    "CMY_C": 0.17805165052414,
    "CMY_M": 0.30604761838913,
    "CMY_Y": 0.4440780878067,
    "CMYK_C": 0,
    "CMYK_M": 0.15572264790535,
    "CMYK_Y": 0.32365345954895,
    "CMYK_K": 0.17805165052414
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32122",
    "Farbtonhilfsbezeichnung": "32122",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "192",
    "Bcolor": "161",
    "Y": 55,
    "L": 78.8487014770508,
    "a": 3.93601965904236,
    "b": 17.5986042022705,
    "C": 18.0333881378174,
    "h": 77.3929748535156,
    "CMY_C": 0.15639311075211,
    "CMY_M": 0.24782937765121,
    "CMY_Y": 0.36669325828552,
    "CMYK_C": 0,
    "CMYK_M": 0.10838729143143,
    "CMYK_Y": 0.24928690493107,
    "CMYK_K": 0.15639311075211
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32123",
    "Farbtonhilfsbezeichnung": "32123",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "209",
    "Bcolor": "191",
    "Y": 64,
    "L": 84.1734771728516,
    "a": 0.87949812412262,
    "b": 9.48736190795898,
    "C": 9.52803993225098,
    "h": 84.7036972045898,
    "CMY_C": 0.14031583070755,
    "CMY_M": 0.18073111772537,
    "CMY_Y": 0.25201493501663,
    "CMYK_C": 0,
    "CMYK_M": 0.04701178520918,
    "CMYK_Y": 0.12993039190769,
    "CMYK_K": 0.14031583070755
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32130",
    "Farbtonhilfsbezeichnung": "32130",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "92",
    "Bcolor": "71",
    "Y": 12,
    "L": 40.7802391052246,
    "a": 6.40383529663086,
    "b": 15.0572557449341,
    "C": 16.3624591827393,
    "h": 66.9599990844727,
    "CMY_C": 0.54948306083679,
    "CMY_M": 0.63967311382294,
    "CMY_Y": 0.72078824043274,
    "CMYK_C": 0,
    "CMYK_M": 0.20019236207008,
    "CMYK_Y": 0.38024136424065,
    "CMYK_K": 0.54948306083679
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32131",
    "Farbtonhilfsbezeichnung": "32131",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "117",
    "Bcolor": "95",
    "Y": 20,
    "L": 50.7529373168945,
    "a": 5.87588262557983,
    "b": 15.0050687789917,
    "C": 16.1145305633545,
    "h": 68.6150283813477,
    "CMY_C": 0.45110780000687,
    "CMY_M": 0.54220151901245,
    "CMY_Y": 0.62819063663483,
    "CMYK_C": 0,
    "CMYK_M": 0.16595920920372,
    "CMYK_Y": 0.32261860370636,
    "CMYK_K": 0.45110780000687
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32132",
    "Farbtonhilfsbezeichnung": "32132",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "127",
    "Bcolor": "103",
    "Y": 24,
    "L": 54.8946647644043,
    "a": 6.13358211517334,
    "b": 16.2208118438721,
    "C": 17.3417282104492,
    "h": 69.2868728637695,
    "CMY_C": 0.4040195941925,
    "CMY_M": 0.50193619728088,
    "CMY_Y": 0.59677672386169,
    "CMYK_C": 0,
    "CMYK_M": 0.16429500281811,
    "CMYK_Y": 0.32342863082886,
    "CMYK_K": 0.4040195941925
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32133",
    "Farbtonhilfsbezeichnung": "32133",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "153",
    "Bcolor": "131",
    "Y": 35,
    "L": 64.7983016967773,
    "a": 5.38346719741821,
    "b": 14.2903385162354,
    "C": 15.2707395553589,
    "h": 69.3575668334961,
    "CMY_C": 0.30774581432343,
    "CMY_M": 0.39899563789368,
    "CMY_Y": 0.48648208379745,
    "CMYK_C": 0,
    "CMYK_M": 0.13181549310684,
    "CMYK_Y": 0.25819456577301,
    "CMYK_K": 0.30774581432343
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32134",
    "Farbtonhilfsbezeichnung": "32134",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 42,
    "L": 70.3193130493164,
    "a": 4.67904186248779,
    "b": 15.4770259857178,
    "C": 16.168851852417,
    "h": 73.1787872314453,
    "CMY_C": 0.25008845329285,
    "CMY_M": 0.33998477458954,
    "CMY_Y": 0.43918001651764,
    "CMYK_C": 0,
    "CMYK_M": 0.11987590044737,
    "CMYK_Y": 0.25215181708336,
    "CMYK_K": 0.25008845329285
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32135",
    "Farbtonhilfsbezeichnung": "32135",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "187",
    "Bcolor": "165",
    "Y": 52,
    "L": 77.1652145385742,
    "a": 3.86843657493591,
    "b": 13.3737840652466,
    "C": 13.9220294952393,
    "h": 73.8672103881836,
    "CMY_C": 0.18575185537338,
    "CMY_M": 0.26479351520538,
    "CMY_Y": 0.3537825345993,
    "CMYK_C": 0,
    "CMYK_M": 0.09707318246365,
    "CMYK_Y": 0.2063629925251,
    "CMYK_K": 0.18575185537338
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32136",
    "Farbtonhilfsbezeichnung": "32136",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "203",
    "Bcolor": "182",
    "Y": 62,
    "L": 82.5778961181641,
    "a": 3.05590605735779,
    "b": 11.8078842163086,
    "C": 12.1969127655029,
    "h": 75.4900817871094,
    "CMY_C": 0.13569366931915,
    "CMY_M": 0.20392292737961,
    "CMY_Y": 0.28560584783554,
    "CMYK_C": 0,
    "CMYK_M": 0.07894106209278,
    "CMYK_Y": 0.17344796657562,
    "CMYK_K": 0.13569366931915
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32137",
    "Farbtonhilfsbezeichnung": "32137",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "217",
    "Bcolor": "198",
    "Y": 71,
    "L": 87.3475112915039,
    "a": 2.0244734287262,
    "b": 10.2299718856812,
    "C": 10.4283657073975,
    "h": 78.8060150146484,
    "CMY_C": 0.09437519311905,
    "CMY_M": 0.14875084161758,
    "CMY_Y": 0.22316497564316,
    "CMYK_C": 0,
    "CMYK_M": 0.06004213541746,
    "CMYK_Y": 0.14221097528934,
    "CMYK_K": 0.09437519311905
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32138",
    "Farbtonhilfsbezeichnung": "32138",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "229",
    "Bcolor": "210",
    "Y": 79,
    "L": 91.0756759643555,
    "a": 0.44187554717064,
    "b": 9.34333610534668,
    "C": 9.35377883911133,
    "h": 87.2923278808594,
    "CMY_C": 0.06698274612427,
    "CMY_M": 0.1033940911293,
    "CMY_Y": 0.17642647027969,
    "CMYK_C": 0,
    "CMYK_M": 0.0390253700316,
    "CMYK_Y": 0.11730086058378,
    "CMYK_K": 0.06698274612427
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32140",
    "Farbtonhilfsbezeichnung": "32140",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "133",
    "Bcolor": "64",
    "Y": 29,
    "L": 60.7332954406738,
    "a": 18.1239185333252,
    "b": 45.7961006164551,
    "C": 49.2519989013672,
    "h": 68.4086990356445,
    "CMY_C": 0.22923982143402,
    "CMY_M": 0.47847241163254,
    "CMY_Y": 0.75054407119751,
    "CMYK_C": 0,
    "CMYK_M": 0.3233594596386,
    "CMYK_Y": 0.67635077238083,
    "CMYK_K": 0.22923982143402
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32141",
    "Farbtonhilfsbezeichnung": "32141",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "117",
    "Bcolor": "63",
    "Y": 22,
    "L": 53.9209671020508,
    "a": 15.9323987960815,
    "b": 37.4286499023438,
    "C": 40.6785583496094,
    "h": 66.9418106079102,
    "CMY_C": 0.32717204093933,
    "CMY_M": 0.53960251808167,
    "CMY_Y": 0.75156074762344,
    "CMYK_C": 0,
    "CMYK_M": 0.31572777032852,
    "CMYK_Y": 0.63075369596481,
    "CMYK_K": 0.32717204093933
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32142",
    "Farbtonhilfsbezeichnung": "32142",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "109",
    "Bcolor": "71",
    "Y": 19,
    "L": 49.6435813903809,
    "a": 12.9396524429321,
    "b": 27.7687034606934,
    "C": 30.6355266571045,
    "h": 65.0154342651367,
    "CMY_C": 0.40177178382874,
    "CMY_M": 0.5724161863327,
    "CMY_Y": 0.72311890125275,
    "CMYK_C": 0,
    "CMYK_M": 0.28524968028069,
    "CMYK_Y": 0.537164747715,
    "CMYK_K": 0.40177178382874
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32143",
    "Farbtonhilfsbezeichnung": "32143",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "89",
    "Bcolor": "65",
    "Y": 12,
    "L": 40.1772384643555,
    "a": 8.2836389541626,
    "b": 17.8331069946289,
    "C": 19.663122177124,
    "h": 65.0847091674805,
    "CMY_C": 0.54052966833115,
    "CMY_M": 0.65016031265259,
    "CMY_Y": 0.74371206760406,
    "CMYK_C": 0,
    "CMYK_M": 0.23860222101212,
    "CMYK_Y": 0.44221004843712,
    "CMYK_K": 0.54052966833115
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32144",
    "Farbtonhilfsbezeichnung": "32144",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "87",
    "Bcolor": "73",
    "Y": 11,
    "L": 38.1778144836426,
    "a": 4.92786884307861,
    "b": 10.3659076690674,
    "C": 11.4776277542114,
    "h": 64.5739593505859,
    "CMY_C": 0.59227246046066,
    "CMY_M": 0.65995597839355,
    "CMY_Y": 0.71476590633392,
    "CMYK_C": 0,
    "CMYK_M": 0.16600182652473,
    "CMYK_Y": 0.30042967200279,
    "CMYK_K": 0.59227246046066
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32200",
    "Farbtonhilfsbezeichnung": "32200",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "128",
    "Bcolor": "66",
    "Y": 33,
    "L": 63.9241714477539,
    "a": 34.9888153076172,
    "b": 49.5105934143066,
    "C": 60.626033782959,
    "h": 54.7513961791992,
    "CMY_C": 0.09643721580505,
    "CMY_M": 0.49816197156906,
    "CMY_Y": 0.74248379468918,
    "CMYK_C": 0,
    "CMYK_M": 0.44460082054138,
    "CMYK_Y": 0.71499907970428,
    "CMYK_K": 0.09643721580505
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32201",
    "Farbtonhilfsbezeichnung": "32201",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "141",
    "Bcolor": "76",
    "Y": 38,
    "L": 67.6829299926758,
    "a": 31.6912460327148,
    "b": 48.6587219238281,
    "C": 58.068977355957,
    "h": 56.9239501953125,
    "CMY_C": 0.06934070587158,
    "CMY_M": 0.44825357198715,
    "CMY_Y": 0.70069539546967,
    "CMYK_C": 0,
    "CMYK_M": 0.40714454650879,
    "CMYK_Y": 0.67839509248734,
    "CMYK_K": 0.06934070587158
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32202",
    "Farbtonhilfsbezeichnung": "32202",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "152",
    "Bcolor": "91",
    "Y": 42,
    "L": 70.931022644043,
    "a": 28.7092971801758,
    "b": 45.1118354797363,
    "C": 53.4724349975586,
    "h": 57.527214050293,
    "CMY_C": 0.05008858442307,
    "CMY_M": 0.40443021059036,
    "CMY_Y": 0.64263671636581,
    "CMYK_C": 0,
    "CMYK_M": 0.37302598357201,
    "CMYK_Y": 0.62379306554794,
    "CMYK_K": 0.05008858442307
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32203",
    "Farbtonhilfsbezeichnung": "32203",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "176",
    "Bcolor": "121",
    "Y": 53,
    "L": 77.3244705200195,
    "a": 19.8602123260498,
    "b": 37.8294334411621,
    "C": 42.7257995605469,
    "h": 62.3008117675781,
    "CMY_C": 0.03434854745865,
    "CMY_M": 0.3096267580986,
    "CMY_Y": 0.52704656124115,
    "CMYK_C": 0,
    "CMYK_M": 0.28506994247437,
    "CMYK_Y": 0.51022344827652,
    "CMYK_K": 0.03434854745865
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32204",
    "Farbtonhilfsbezeichnung": "32204",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "189",
    "Bcolor": "137",
    "Y": 59,
    "L": 81.1083145141602,
    "a": 16.3197746276856,
    "b": 34.4840965270996,
    "C": 38.1508560180664,
    "h": 64.6739044189453,
    "CMY_C": 0.01657390594482,
    "CMY_M": 0.25868058204651,
    "CMY_Y": 0.46468764543533,
    "CMYK_C": 0,
    "CMYK_M": 0.24618695676327,
    "CMYK_Y": 0.45566591620445,
    "CMYK_K": 0.01657390594482
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32205",
    "Farbtonhilfsbezeichnung": "32205",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "202",
    "Bcolor": "158",
    "Y": 66,
    "L": 84.6076507568359,
    "a": 11.4602279663086,
    "b": 27.8697414398193,
    "C": 30.1340217590332,
    "h": 67.6471939086914,
    "CMY_C": 0.01852655410767,
    "CMY_M": 0.2065013051033,
    "CMY_Y": 0.38056814670563,
    "CMYK_C": 0,
    "CMYK_M": 0.19152301549911,
    "CMYK_Y": 0.36887559294701,
    "CMYK_K": 0.01852655410767
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32206",
    "Farbtonhilfsbezeichnung": "32206",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "213",
    "Bcolor": "173",
    "Y": 70,
    "L": 87.5348815917969,
    "a": 8.02814960479736,
    "b": 24.1415824890137,
    "C": 25.4414463043213,
    "h": 71.6057434082031,
    "CMY_C": 0.01526266336441,
    "CMY_M": 0.16482925415039,
    "CMY_Y": 0.32289499044418,
    "CMYK_C": 0,
    "CMYK_M": 0.15188474953175,
    "CMYK_Y": 0.31240040063858,
    "CMYK_K": 0.01526266336441
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32207",
    "Farbtonhilfsbezeichnung": "32207",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "221",
    "Bcolor": "189",
    "Y": 76,
    "L": 89.7166442871094,
    "a": 5.0996208190918,
    "b": 18.7749462127686,
    "C": 19.4551982879639,
    "h": 74.8040313720703,
    "CMY_C": 0.02287179231644,
    "CMY_M": 0.13217610120773,
    "CMY_Y": 0.26036316156387,
    "CMYK_C": 0,
    "CMYK_M": 0.11186280846596,
    "CMYK_Y": 0.24305036664009,
    "CMYK_K": 0.02287179231644
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32208",
    "Farbtonhilfsbezeichnung": "32208",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "230",
    "Bcolor": "203",
    "Y": 81,
    "L": 92.1527328491211,
    "a": 2.31298613548279,
    "b": 14.6839599609375,
    "C": 14.8650121688843,
    "h": 81.0484466552734,
    "CMY_C": 0.02571779489517,
    "CMY_M": 0.09725874662399,
    "CMY_Y": 0.20413875579834,
    "CMYK_C": 0,
    "CMYK_M": 0.07342939078808,
    "CMYK_Y": 0.18313068151474,
    "CMYK_K": 0.02571779489517
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32209",
    "Farbtonhilfsbezeichnung": "32209",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "214",
    "Y": 85,
    "L": 93.7116317749023,
    "a": 0.60314214229584,
    "b": 11.0667781829834,
    "C": 11.0832014083862,
    "h": 86.8804473876953,
    "CMY_C": 0.0309345126152,
    "CMY_M": 0.07477205991745,
    "CMY_Y": 0.16043794155121,
    "CMYK_C": 0,
    "CMYK_M": 0.04523693025112,
    "CMYK_Y": 0.13363744318485,
    "CMYK_K": 0.0309345126152
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32210",
    "Farbtonhilfsbezeichnung": "32210",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "142",
    "Bcolor": "95",
    "Y": 35,
    "L": 64.9696807861328,
    "a": 20.8155097961426,
    "b": 35.1188850402832,
    "C": 40.824275970459,
    "h": 59.3441200256348,
    "CMY_C": 0.17664533853531,
    "CMY_M": 0.44118273258209,
    "CMY_Y": 0.62858819961548,
    "CMYK_C": 0,
    "CMYK_M": 0.32129216194153,
    "CMYK_Y": 0.54890424013138,
    "CMYK_K": 0.17664533853531
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32211",
    "Farbtonhilfsbezeichnung": "32211",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "165",
    "Bcolor": "120",
    "Y": 45,
    "L": 72.4320526123047,
    "a": 16.6915664672852,
    "b": 31.4436111450195,
    "C": 35.5992851257324,
    "h": 62.0387916564941,
    "CMY_C": 0.11999899148941,
    "CMY_M": 0.35151100158691,
    "CMY_Y": 0.52973008155823,
    "CMYK_C": 0,
    "CMYK_M": 0.26308152079582,
    "CMYK_Y": 0.46560296416283,
    "CMYK_K": 0.11999899148941
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32212",
    "Farbtonhilfsbezeichnung": "32212",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "180",
    "Bcolor": "139",
    "Y": 52,
    "L": 76.9695205688477,
    "a": 13.3813724517822,
    "b": 27.3653087615967,
    "C": 30.461799621582,
    "h": 63.9418144226074,
    "CMY_C": 0.09512889385223,
    "CMY_M": 0.2938027381897,
    "CMY_Y": 0.45509988069534,
    "CMYK_C": 0,
    "CMYK_M": 0.21956038475037,
    "CMYK_Y": 0.39781466126442,
    "CMYK_K": 0.09512889385223
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32213",
    "Farbtonhilfsbezeichnung": "32213",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "196",
    "Bcolor": "161",
    "Y": 61,
    "L": 81.8282470703125,
    "a": 9.68840026855469,
    "b": 22.5063152313232,
    "C": 24.5030479431152,
    "h": 66.709342956543,
    "CMY_C": 0.07294929027557,
    "CMY_M": 0.23097348213196,
    "CMY_Y": 0.37035375833511,
    "CMYK_C": 0,
    "CMYK_M": 0.17045906186104,
    "CMYK_Y": 0.32080712914467,
    "CMYK_K": 0.07294929027557
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32214",
    "Farbtonhilfsbezeichnung": "32214",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "206",
    "Bcolor": "173",
    "Y": 66,
    "L": 84.869873046875,
    "a": 8.12378692626953,
    "b": 20.029483795166,
    "C": 21.6142578125,
    "h": 67.9229431152344,
    "CMY_C": 0.05419021844864,
    "CMY_M": 0.19335293769836,
    "CMY_Y": 0.32060384750366,
    "CMYK_C": 0,
    "CMYK_M": 0.14713604748249,
    "CMYK_Y": 0.28167781233788,
    "CMYK_K": 0.05419021844864
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32215",
    "Farbtonhilfsbezeichnung": "32215",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "218",
    "Bcolor": "190",
    "Y": 73,
    "L": 88.4758911132813,
    "a": 5.2648663520813,
    "b": 16.1037826538086,
    "C": 16.9425678253174,
    "h": 71.8956985473633,
    "CMY_C": 0.04244244098663,
    "CMY_M": 0.14566469192505,
    "CMY_Y": 0.25382369756699,
    "CMYK_C": 0,
    "CMYK_M": 0.10779743641615,
    "CMYK_Y": 0.22075045108795,
    "CMYK_K": 0.04244244098663
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32216",
    "Farbtonhilfsbezeichnung": "32216",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "227",
    "Bcolor": "204",
    "Y": 78,
    "L": 91.0763778686523,
    "a": 2.9328715801239,
    "b": 12.794885635376,
    "C": 13.1267223358154,
    "h": 77.0895690917969,
    "CMY_C": 0.03850901126862,
    "CMY_M": 0.11028790473938,
    "CMY_Y": 0.20165109634399,
    "CMYK_C": 0,
    "CMYK_M": 0.07465373724699,
    "CMYK_Y": 0.16967613995075,
    "CMYK_K": 0.03850901126862
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32220",
    "Farbtonhilfsbezeichnung": "32220",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "143",
    "Bcolor": "115",
    "Y": 31,
    "L": 62.061164855957,
    "a": 9.9813985824585,
    "b": 19.7654418945313,
    "C": 22.1427421569824,
    "h": 63.2065696716309,
    "CMY_C": 0.29688793420792,
    "CMY_M": 0.43942016363144,
    "CMY_Y": 0.55076026916504,
    "CMYK_C": 0,
    "CMYK_M": 0.20271623134613,
    "CMYK_Y": 0.36106953024864,
    "CMYK_K": 0.29688793420792
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32221",
    "Farbtonhilfsbezeichnung": "32221",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "164",
    "Bcolor": "138",
    "Y": 41,
    "L": 69.2508087158203,
    "a": 7.39775323867798,
    "b": 16.9540863037109,
    "C": 18.4977779388428,
    "h": 66.4264068603516,
    "CMY_C": 0.24045479297638,
    "CMY_M": 0.35806274414063,
    "CMY_Y": 0.45997458696365,
    "CMYK_C": 0,
    "CMYK_M": 0.15483996272087,
    "CMYK_Y": 0.28901478648186,
    "CMYK_K": 0.24045479297638
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32222",
    "Farbtonhilfsbezeichnung": "32222",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "178",
    "Bcolor": "155",
    "Y": 47,
    "L": 73.8131713867188,
    "a": 5.2014012336731,
    "b": 13.8749580383301,
    "C": 14.8178625106812,
    "h": 69.4501342773438,
    "CMY_C": 0.21214443445206,
    "CMY_M": 0.30391091108322,
    "CMY_Y": 0.39192932844162,
    "CMYK_C": 0,
    "CMYK_M": 0.11647626757622,
    "CMYK_Y": 0.22819525003433,
    "CMYK_K": 0.21214443445206
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32223",
    "Farbtonhilfsbezeichnung": "32223",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "204",
    "Bcolor": "189",
    "Y": 62,
    "L": 82.5025863647461,
    "a": 1.98757016658783,
    "b": 8.00103092193604,
    "C": 8.24420547485352,
    "h": 76.0493011474609,
    "CMY_C": 0.15488237142563,
    "CMY_M": 0.20123207569122,
    "CMY_Y": 0.25890266895294,
    "CMYK_C": 0,
    "CMYK_M": 0.05484408512712,
    "CMYK_Y": 0.12308380752802,
    "CMYK_K": 0.15488237142563
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32230",
    "Farbtonhilfsbezeichnung": "32230",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "91",
    "Bcolor": "81",
    "Y": 12,
    "L": 40.0093612670898,
    "a": 5.77957439422607,
    "b": 8.0934591293335,
    "C": 9.94522762298584,
    "h": 54.4692039489746,
    "CMY_C": 0.57384818792343,
    "CMY_M": 0.64415812492371,
    "CMY_Y": 0.683633685112,
    "CMYK_C": 0,
    "CMYK_M": 0.16498801112175,
    "CMYK_Y": 0.25762063264847,
    "CMYK_K": 0.57384818792343
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32231",
    "Farbtonhilfsbezeichnung": "32231",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "120",
    "Bcolor": "109",
    "Y": 20,
    "L": 51.6316604614258,
    "a": 5.29796457290649,
    "b": 7.78755617141724,
    "C": 9.41883563995361,
    "h": 55.7720947265625,
    "CMY_C": 0.46103382110596,
    "CMY_M": 0.53064370155334,
    "CMY_Y": 0.57204961776733,
    "CMYK_C": 0,
    "CMYK_M": 0.12915444374084,
    "CMYK_Y": 0.20597915351391,
    "CMYK_K": 0.46103382110596
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32232",
    "Farbtonhilfsbezeichnung": "32232",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "133",
    "Bcolor": "120",
    "Y": 26,
    "L": 56.8030395507813,
    "a": 5.29350709915161,
    "b": 8.72525787353516,
    "C": 10.2054567337036,
    "h": 58.7553215026855,
    "CMY_C": 0.40558159351349,
    "CMY_M": 0.47919046878815,
    "CMY_Y": 0.52782249450684,
    "CMYK_C": 0,
    "CMYK_M": 0.1238334402442,
    "CMYK_Y": 0.20564790070057,
    "CMYK_K": 0.40558159351349
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32233",
    "Farbtonhilfsbezeichnung": "32233",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "154",
    "Bcolor": "142",
    "Y": 35,
    "L": 64.9674987792969,
    "a": 5.06974983215332,
    "b": 8.23889255523682,
    "C": 9.6737642288208,
    "h": 58.3942031860352,
    "CMY_C": 0.322445333004,
    "CMY_M": 0.39509266614914,
    "CMY_Y": 0.44290786981583,
    "CMYK_C": 0,
    "CMYK_M": 0.10721988230944,
    "CMYK_Y": 0.17779013514519,
    "CMYK_K": 0.322445333004
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32234",
    "Farbtonhilfsbezeichnung": "32234",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "177",
    "Bcolor": "165",
    "Y": 46,
    "L": 72.9669799804688,
    "a": 3.76665878295898,
    "b": 7.11052846908569,
    "C": 8.0465726852417,
    "h": 62.0884971618652,
    "CMY_C": 0.248714864254,
    "CMY_M": 0.30783379077911,
    "CMY_Y": 0.35292983055115,
    "CMYK_C": 0,
    "CMYK_M": 0.07869039475918,
    "CMYK_Y": 0.13871559500694,
    "CMYK_K": 0.248714864254
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32235",
    "Farbtonhilfsbezeichnung": "32235",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "192",
    "Bcolor": "179",
    "Y": 55,
    "L": 78.5185470581055,
    "a": 3.48650121688843,
    "b": 7.36544895172119,
    "C": 8.14895915985107,
    "h": 64.6690444946289,
    "CMY_C": 0.18958312273026,
    "CMY_M": 0.24782890081406,
    "CMY_Y": 0.29646861553192,
    "CMYK_C": 0,
    "CMYK_M": 0.07187137752771,
    "CMYK_Y": 0.13188952207565,
    "CMYK_K": 0.18958312273026
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32236",
    "Farbtonhilfsbezeichnung": "32236",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "206",
    "Bcolor": "193",
    "Y": 63,
    "L": 83.3414840698242,
    "a": 2.37001347541809,
    "b": 7.29118967056274,
    "C": 7.66670799255371,
    "h": 71.9931564331055,
    "CMY_C": 0.1448495388031,
    "CMY_M": 0.19280076026917,
    "CMY_Y": 0.24470293521881,
    "CMYK_C": 0,
    "CMYK_M": 0.05607343092561,
    "CMYK_Y": 0.11676704883575,
    "CMYK_K": 0.1448495388031
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32237",
    "Farbtonhilfsbezeichnung": "32237",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 73,
    "L": 88.6470947265625,
    "a": 1.42972922325134,
    "b": 7.25413417816162,
    "C": 7.39368581771851,
    "h": 78.8503799438477,
    "CMY_C": 0.09298092126846,
    "CMY_M": 0.13218367099762,
    "CMY_Y": 0.18726885318756,
    "CMYK_C": 0,
    "CMYK_M": 0.04322152584791,
    "CMYK_Y": 0.10395363718271,
    "CMYK_K": 0.09298092126846
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32240",
    "Farbtonhilfsbezeichnung": "32240",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "114",
    "Bcolor": "66",
    "Y": 23,
    "L": 55.0307273864746,
    "a": 24.3905792236328,
    "b": 37.8528861999512,
    "C": 45.0304489135742,
    "h": 57.2042121887207,
    "CMY_C": 0.26837563514709,
    "CMY_M": 0.55252063274384,
    "CMY_Y": 0.74158799648285,
    "CMYK_C": 0,
    "CMYK_M": 0.38837552070618,
    "CMYK_Y": 0.64679688215256,
    "CMYK_K": 0.26837563514709
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32241",
    "Farbtonhilfsbezeichnung": "32241",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "100",
    "Bcolor": "68",
    "Y": 17,
    "L": 47.3702926635742,
    "a": 18.1163349151611,
    "b": 26.6363086700439,
    "C": 32.213264465332,
    "h": 55.778938293457,
    "CMY_C": 0.39960676431656,
    "CMY_M": 0.60793620347977,
    "CMY_Y": 0.73486912250519,
    "CMYK_C": 0,
    "CMYK_M": 0.34698832035065,
    "CMYK_Y": 0.55840462446213,
    "CMYK_K": 0.39960676431656
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32242",
    "Farbtonhilfsbezeichnung": "32242",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "99",
    "Bcolor": "80",
    "Y": 14,
    "L": 44.2113876342773,
    "a": 9.05702877044678,
    "b": 14.6161451339722,
    "C": 17.1948089599609,
    "h": 58.2151908874512,
    "CMY_C": 0.50024181604385,
    "CMY_M": 0.61307716369629,
    "CMY_Y": 0.68618226051331,
    "CMYK_C": 0,
    "CMYK_M": 0.2257798910141,
    "CMYK_Y": 0.37206083536148,
    "CMYK_K": 0.50024181604385
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32243",
    "Farbtonhilfsbezeichnung": "32243",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "70",
    "Bcolor": "61",
    "Y": 7,
    "L": 30.73118019104,
    "a": 4.68421506881714,
    "b": 7.06033134460449,
    "C": 8.47290706634521,
    "h": 56.4375,
    "CMY_C": 0.67150056362152,
    "CMY_M": 0.72716063261032,
    "CMY_Y": 0.76074373722076,
    "CMYK_C": 0,
    "CMYK_M": 0.16943733394146,
    "CMYK_Y": 0.27166917920113,
    "CMYK_K": 0.67150056362152
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32300",
    "Farbtonhilfsbezeichnung": "32300",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "107",
    "Bcolor": "64",
    "Y": 27,
    "L": 58.6935539245605,
    "a": 43.2459907531738,
    "b": 44.6171989440918,
    "C": 62.1362228393555,
    "h": 45.8940963745117,
    "CMY_C": 0.12076836824417,
    "CMY_M": 0.5815532207489,
    "CMY_Y": 0.75058805942535,
    "CMYK_C": 0,
    "CMYK_M": 0.52407675981522,
    "CMYK_Y": 0.71632963418961,
    "CMYK_K": 0.12076836824417
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32301",
    "Farbtonhilfsbezeichnung": "32301",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "122",
    "Bcolor": "78",
    "Y": 32,
    "L": 62.8916893005371,
    "a": 38.9917869567871,
    "b": 42.1996040344238,
    "C": 57.4557762145996,
    "h": 47.2625427246094,
    "CMY_C": 0.09378468990326,
    "CMY_M": 0.52174985408783,
    "CMY_Y": 0.69464528560638,
    "CMYK_C": 0,
    "CMYK_M": 0.47225549817085,
    "CMYK_Y": 0.66304397583008,
    "CMYK_K": 0.09378468990326
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32302",
    "Farbtonhilfsbezeichnung": "32302",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "136",
    "Bcolor": "92",
    "Y": 37,
    "L": 66.7905120849609,
    "a": 35.2803840637207,
    "b": 39.4379425048828,
    "C": 52.9155616760254,
    "h": 48.1848297119141,
    "CMY_C": 0.06929689645767,
    "CMY_M": 0.46791142225266,
    "CMY_Y": 0.63826781511307,
    "CMYK_C": 0,
    "CMYK_M": 0.42829397320747,
    "CMYK_Y": 0.61133450269699,
    "CMYK_K": 0.06929689645767
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32303",
    "Farbtonhilfsbezeichnung": "32303",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "159",
    "Bcolor": "120",
    "Y": 46,
    "L": 73.5009918212891,
    "a": 28.7090244293213,
    "b": 33.349910736084,
    "C": 44.004825592041,
    "h": 49.276725769043,
    "CMY_C": 0.03331446647644,
    "CMY_M": 0.37532246112823,
    "CMY_Y": 0.53000408411026,
    "CMYK_C": 0,
    "CMYK_M": 0.35379445552826,
    "CMYK_Y": 0.51380681991577,
    "CMYK_K": 0.03331446647644
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32304",
    "Farbtonhilfsbezeichnung": "32304",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "172",
    "Bcolor": "136",
    "Y": 51,
    "L": 76.692138671875,
    "a": 24.2409934997559,
    "b": 28.8931674957275,
    "C": 37.715259552002,
    "h": 50.0037841796875,
    "CMY_C": 0.02857100963593,
    "CMY_M": 0.32716995477676,
    "CMY_Y": 0.466652572155,
    "CMYK_C": 0,
    "CMYK_M": 0.30738112330437,
    "CMYK_Y": 0.45096611976624,
    "CMYK_K": 0.02857100963593
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32305",
    "Farbtonhilfsbezeichnung": "32305",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "190",
    "Bcolor": "159",
    "Y": 60,
    "L": 81.6493530273438,
    "a": 17.7895793914795,
    "b": 23.391809463501,
    "C": 29.3878536224365,
    "h": 52.7468414306641,
    "CMY_C": 0.02030730247498,
    "CMY_M": 0.25453448295593,
    "CMY_Y": 0.3771099448204,
    "CMYK_C": 0,
    "CMYK_M": 0.2390822917223,
    "CMYK_Y": 0.36419853568077,
    "CMYK_K": 0.02030730247498
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32306",
    "Farbtonhilfsbezeichnung": "32306",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "199",
    "Bcolor": "170",
    "Y": 65,
    "L": 84.0172805786133,
    "a": 14.3381376266479,
    "b": 20.5230960845947,
    "C": 25.0355682373047,
    "h": 55.0605316162109,
    "CMY_C": 0.0210896730423,
    "CMY_M": 0.21887284517288,
    "CMY_Y": 0.33205604553223,
    "CMYK_C": 0,
    "CMYK_M": 0.20204421877861,
    "CMYK_Y": 0.31766584515572,
    "CMYK_K": 0.0210896730423
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32307",
    "Farbtonhilfsbezeichnung": "32307",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "212",
    "Bcolor": "189",
    "Y": 72,
    "L": 87.7026214599609,
    "a": 10.6377372741699,
    "b": 15.8919610977173,
    "C": 19.1236991882324,
    "h": 56.2024993896484,
    "CMY_C": 0.01407587528229,
    "CMY_M": 0.16773176193237,
    "CMY_Y": 0.25961804389954,
    "CMYK_C": 0,
    "CMYK_M": 0.15584960579872,
    "CMYK_Y": 0.24904772639275,
    "CMYK_K": 0.01407587528229
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32308",
    "Farbtonhilfsbezeichnung": "32308",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "223",
    "Bcolor": "204",
    "Y": 78,
    "L": 90.5358200073242,
    "a": 6.71115064620972,
    "b": 11.8865900039673,
    "C": 13.6502952575684,
    "h": 60.5509948730469,
    "CMY_C": 0.01955354213715,
    "CMY_M": 0.12541455030441,
    "CMY_Y": 0.20016354322433,
    "CMYK_C": 0,
    "CMYK_M": 0.10797224938869,
    "CMYK_Y": 0.18421199917793,
    "CMYK_K": 0.01955354213715
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32309",
    "Farbtonhilfsbezeichnung": "32309",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "231",
    "Bcolor": "214",
    "Y": 82,
    "L": 92.5126953125,
    "a": 3.65338087081909,
    "b": 9.41894054412842,
    "C": 10.1026544570923,
    "h": 68.799919128418,
    "CMY_C": 0.02637451887131,
    "CMY_M": 0.09517282247543,
    "CMY_Y": 0.16079539060593,
    "CMYK_C": 0,
    "CMYK_M": 0.07066197693348,
    "CMYK_Y": 0.13806219398975,
    "CMYK_K": 0.02637451887131
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32310",
    "Farbtonhilfsbezeichnung": "32310",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "129",
    "Bcolor": "97",
    "Y": 31,
    "L": 62.0621376037598,
    "a": 28.8142013549805,
    "b": 30.4330024719238,
    "C": 41.9097328186035,
    "h": 46.5650939941406,
    "CMY_C": 0.17106366157532,
    "CMY_M": 0.49389487504959,
    "CMY_Y": 0.6209979057312,
    "CMYK_C": 0,
    "CMYK_M": 0.38945236802101,
    "CMYK_Y": 0.5427850484848,
    "CMYK_K": 0.17106366157532
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32311",
    "Farbtonhilfsbezeichnung": "32311",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "153",
    "Bcolor": "122",
    "Y": 41,
    "L": 69.914421081543,
    "a": 24.5769882202148,
    "b": 27.2072505950928,
    "C": 36.6641883850098,
    "h": 47.9077072143555,
    "CMY_C": 0.10840493440628,
    "CMY_M": 0.39929139614105,
    "CMY_Y": 0.52249318361282,
    "CMYK_C": 0,
    "CMYK_M": 0.3262540102005,
    "CMYK_Y": 0.464435338974,
    "CMYK_K": 0.10840493440628
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32312",
    "Farbtonhilfsbezeichnung": "32312",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "169",
    "Bcolor": "140",
    "Y": 49,
    "L": 74.8583755493164,
    "a": 21.6123657226563,
    "b": 23.8974227905273,
    "C": 32.220817565918,
    "h": 47.8744201660156,
    "CMY_C": 0.07420343160629,
    "CMY_M": 0.33798450231552,
    "CMY_Y": 0.44979053735733,
    "CMYK_C": 0,
    "CMYK_M": 0.28492337465286,
    "CMYK_Y": 0.40569075942039,
    "CMYK_K": 0.07420343160629
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32313",
    "Farbtonhilfsbezeichnung": "32313",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "188",
    "Bcolor": "163",
    "Y": 58,
    "L": 80.6174545288086,
    "a": 17.0856628417969,
    "b": 19.8358573913574,
    "C": 26.1797847747803,
    "h": 49.2599563598633,
    "CMY_C": 0.04374796152115,
    "CMY_M": 0.26292055845261,
    "CMY_Y": 0.36211198568344,
    "CMYK_C": 0,
    "CMYK_M": 0.22919961810112,
    "CMYK_Y": 0.33292898535728,
    "CMYK_K": 0.04374796152115
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32314",
    "Farbtonhilfsbezeichnung": "32314",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "197",
    "Bcolor": "174",
    "Y": 64,
    "L": 83.3480377197266,
    "a": 14.5844507217407,
    "b": 17.3808917999268,
    "C": 22.6892395019531,
    "h": 49.9997062683105,
    "CMY_C": 0.03388684988022,
    "CMY_M": 0.22605317831039,
    "CMY_Y": 0.31609427928925,
    "CMYK_C": 0,
    "CMYK_M": 0.19890664517879,
    "CMYK_Y": 0.29210597276688,
    "CMYK_K": 0.03388684988022
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32315",
    "Farbtonhilfsbezeichnung": "32315",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "212",
    "Bcolor": "192",
    "Y": 71,
    "L": 87.4382095336914,
    "a": 10.6844320297241,
    "b": 13.5371589660645,
    "C": 17.2456302642822,
    "h": 51.7171325683594,
    "CMY_C": 0.02249449491501,
    "CMY_M": 0.1701672077179,
    "CMY_Y": 0.24511063098907,
    "CMYK_C": 0,
    "CMYK_M": 0.15107098221779,
    "CMYK_Y": 0.2277390062809,
    "CMYK_K": 0.02249449491501
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32316",
    "Farbtonhilfsbezeichnung": "32316",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "222",
    "Bcolor": "206",
    "Y": 76,
    "L": 90.1447906494141,
    "a": 7.42593097686768,
    "b": 10.173680305481,
    "C": 12.5955638885498,
    "h": 53.8736991882324,
    "CMY_C": 0.02345782518387,
    "CMY_M": 0.13110190629959,
    "CMY_Y": 0.19161599874496,
    "CMYK_C": 0,
    "CMYK_M": 0.11022983491421,
    "CMYK_Y": 0.1721975505352,
    "CMYK_K": 0.02345782518387
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32320",
    "Farbtonhilfsbezeichnung": "32320",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "138",
    "Bcolor": "118",
    "Y": 31,
    "L": 61.3989944458008,
    "a": 15.2277002334595,
    "b": 17.2139759063721,
    "C": 22.9826850891113,
    "h": 48.5036201477051,
    "CMY_C": 0.27676206827164,
    "CMY_M": 0.45899701118469,
    "CMY_Y": 0.53868317604065,
    "CMYK_C": 0,
    "CMYK_M": 0.25197094678879,
    "CMYK_Y": 0.3621506690979,
    "CMYK_K": 0.27676206827164
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32321",
    "Farbtonhilfsbezeichnung": "32321",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "164",
    "Bcolor": "143",
    "Y": 42,
    "L": 70.4673919677734,
    "a": 11.8271751403809,
    "b": 15.7281007766724,
    "C": 19.6788005828857,
    "h": 53.0576629638672,
    "CMY_C": 0.20090574026108,
    "CMY_M": 0.35606515407562,
    "CMY_Y": 0.43822038173676,
    "CMYK_C": 0,
    "CMYK_M": 0.19416910409927,
    "CMYK_Y": 0.29697954654694,
    "CMYK_K": 0.20090574026108
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32322",
    "Farbtonhilfsbezeichnung": "32322",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "178",
    "Bcolor": "161",
    "Y": 49,
    "L": 74.7829818725586,
    "a": 8.22684192657471,
    "b": 11.814697265625,
    "C": 14.3968048095703,
    "h": 55.1496276855469,
    "CMY_C": 0.18584412336349,
    "CMY_M": 0.30047249794006,
    "CMY_Y": 0.36672830581665,
    "CMYK_C": 0,
    "CMYK_M": 0.14079414308071,
    "CMYK_Y": 0.22217389941216,
    "CMYK_K": 0.18584412336349
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32323",
    "Farbtonhilfsbezeichnung": "32323",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "204",
    "Bcolor": "191",
    "Y": 62,
    "L": 82.8322219848633,
    "a": 3.45548009872437,
    "b": 7.36831855773926,
    "C": 8.13833236694336,
    "h": 64.8750915527344,
    "CMY_C": 0.1422780752182,
    "CMY_M": 0.20097720623016,
    "CMY_Y": 0.25055950880051,
    "CMYK_C": 0,
    "CMYK_M": 0.06843608617783,
    "CMYK_Y": 0.12624305486679,
    "CMYK_K": 0.1422780752182
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32330",
    "Farbtonhilfsbezeichnung": "32330",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "102",
    "Bcolor": "83",
    "Y": 16,
    "L": 46.4163703918457,
    "a": 12.9777307510376,
    "b": 15.7721881866455,
    "C": 20.4250679016113,
    "h": 50.5516395568848,
    "CMY_C": 0.45312881469727,
    "CMY_M": 0.60167062282562,
    "CMY_Y": 0.67263269424438,
    "CMYK_C": 0,
    "CMYK_M": 0.27162119746208,
    "CMYK_Y": 0.40138131380081,
    "CMYK_K": 0.45312881469727
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32331",
    "Farbtonhilfsbezeichnung": "32331",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "119",
    "Bcolor": "100",
    "Y": 21,
    "L": 52.8522262573242,
    "a": 11.6062345504761,
    "b": 15.2624588012695,
    "C": 19.1741313934326,
    "h": 52.7490692138672,
    "CMY_C": 0.3941924571991,
    "CMY_M": 0.53520536422729,
    "CMY_Y": 0.60894548892975,
    "CMYK_C": 0,
    "CMYK_M": 0.23276849091053,
    "CMYK_Y": 0.35449051856995,
    "CMYK_K": 0.3941924571991
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32332",
    "Farbtonhilfsbezeichnung": "32332",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "141",
    "Bcolor": "122",
    "Y": 31,
    "L": 61.3717803955078,
    "a": 10.6236038208008,
    "b": 14.4195079803467,
    "C": 17.91042137146,
    "h": 53.6189880371094,
    "CMY_C": 0.31073188781738,
    "CMY_M": 0.44690412282944,
    "CMY_Y": 0.52058905363083,
    "CMYK_C": 0,
    "CMYK_M": 0.19756062328815,
    "CMYK_Y": 0.30446377396584,
    "CMYK_K": 0.31073188781738
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32333",
    "Farbtonhilfsbezeichnung": "32333",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "160",
    "Bcolor": "142",
    "Y": 39,
    "L": 68.4525375366211,
    "a": 9.9367036819458,
    "b": 13.3809938430786,
    "C": 16.6670055389404,
    "h": 53.4024810791016,
    "CMY_C": 0.24040460586548,
    "CMY_M": 0.37184351682663,
    "CMY_Y": 0.44253677129745,
    "CMYK_C": 0,
    "CMYK_M": 0.17303805053234,
    "CMYK_Y": 0.26610505580902,
    "CMYK_K": 0.24040460586548
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32334",
    "Farbtonhilfsbezeichnung": "32334",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "183",
    "Bcolor": "163",
    "Y": 51,
    "L": 76.3070602416992,
    "a": 6.95682907104492,
    "b": 12.9628992080688,
    "C": 14.7117033004761,
    "h": 61.7787742614746,
    "CMY_C": 0.17487633228302,
    "CMY_M": 0.28136271238327,
    "CMY_Y": 0.35927832126617,
    "CMYK_C": 0,
    "CMYK_M": 0.12905505299568,
    "CMYK_Y": 0.22348406910896,
    "CMYK_K": 0.17487633228302
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32335",
    "Farbtonhilfsbezeichnung": "32335",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "196",
    "Bcolor": "177",
    "Y": 59,
    "L": 80.6996536254883,
    "a": 6.08441972732544,
    "b": 11.8696928024292,
    "C": 13.338282585144,
    "h": 62.8602676391602,
    "CMY_C": 0.13489836454391,
    "CMY_M": 0.2316826581955,
    "CMY_Y": 0.30547022819519,
    "CMYK_C": 0,
    "CMYK_M": 0.11187621206045,
    "CMYK_Y": 0.19716973602772,
    "CMYK_K": 0.13489836454391
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32336",
    "Farbtonhilfsbezeichnung": "32336",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "216",
    "Bcolor": "200",
    "Y": 71,
    "L": 87.3279342651367,
    "a": 3.95582222938538,
    "b": 9.35160446166992,
    "C": 10.1538677215576,
    "h": 67.0711517333984,
    "CMY_C": 0.0828452706337,
    "CMY_M": 0.15341264009476,
    "CMY_Y": 0.21661776304245,
    "CMYK_C": 0,
    "CMYK_M": 0.07694161683321,
    "CMYK_Y": 0.14585596323013,
    "CMYK_K": 0.0828452706337
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32337",
    "Farbtonhilfsbezeichnung": "32337",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "223",
    "Bcolor": "207",
    "Y": 75,
    "L": 89.4382934570313,
    "a": 2.75348353385925,
    "b": 8.44363975524902,
    "C": 8.88125705718994,
    "h": 71.9387741088867,
    "CMY_C": 0.07064527273178,
    "CMY_M": 0.12692040205002,
    "CMY_Y": 0.18724101781845,
    "CMYK_C": 0,
    "CMYK_M": 0.06055290624499,
    "CMYK_Y": 0.12545882165432,
    "CMYK_K": 0.07064527273178
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32340",
    "Farbtonhilfsbezeichnung": "32340",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "95",
    "Bcolor": "64",
    "Y": 18,
    "L": 49.2954063415527,
    "a": 30.8562335968018,
    "b": 31.8896827697754,
    "C": 44.374080657959,
    "h": 45.9435997009277,
    "CMY_C": 0.3060714006424,
    "CMY_M": 0.62871205806732,
    "CMY_Y": 0.74977815151215,
    "CMYK_C": 0,
    "CMYK_M": 0.46494790911674,
    "CMYK_Y": 0.63941270112991,
    "CMYK_K": 0.3060714006424
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32341",
    "Farbtonhilfsbezeichnung": "32341",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "90",
    "Bcolor": "72",
    "Y": 14,
    "L": 43.0522346496582,
    "a": 17.3387298583984,
    "b": 18.2247524261475,
    "C": 25.1549835205078,
    "h": 46.4271621704102,
    "CMY_C": 0.46084743738174,
    "CMY_M": 0.64573889970779,
    "CMY_Y": 0.71856290102005,
    "CMYK_C": 0,
    "CMYK_M": 0.34292978048325,
    "CMYK_Y": 0.47800099849701,
    "CMYK_K": 0.46084743738174
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32342",
    "Farbtonhilfsbezeichnung": "32342",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "82",
    "Bcolor": "67",
    "Y": 11,
    "L": 38.4798965454102,
    "a": 13.7089052200317,
    "b": 14.3272380828857,
    "C": 19.8293685913086,
    "h": 46.2634468078613,
    "CMY_C": 0.53345793485641,
    "CMY_M": 0.67855936288834,
    "CMY_Y": 0.7355163693428,
    "CMYK_C": 0,
    "CMYK_M": 0.31101468205452,
    "CMYK_Y": 0.43309798836708,
    "CMYK_K": 0.53345793485641
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32343",
    "Farbtonhilfsbezeichnung": "32343",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "76",
    "Bcolor": "65",
    "Y": 8,
    "L": 34.5212173461914,
    "a": 8.70315456390381,
    "b": 9.97416496276855,
    "C": 13.2374038696289,
    "h": 48.8930358886719,
    "CMY_C": 0.60730135440826,
    "CMY_M": 0.7021843791008,
    "CMY_Y": 0.74448657035828,
    "CMYK_C": 0,
    "CMYK_M": 0.24161790311337,
    "CMYK_Y": 0.34933966398239,
    "CMYK_K": 0.60730135440826
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32400",
    "Farbtonhilfsbezeichnung": "32400",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "85",
    "Bcolor": "62",
    "Y": 21,
    "L": 52.9811248779297,
    "a": 49.2500953674316,
    "b": 38.6301498413086,
    "C": 62.5928153991699,
    "h": 38.1094665527344,
    "CMY_C": 0.16470342874527,
    "CMY_M": 0.665682554245,
    "CMY_Y": 0.75703257322311,
    "CMYK_C": 0,
    "CMYK_M": 0.59976196289063,
    "CMYK_Y": 0.70912438631058,
    "CMYK_K": 0.16470342874527
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32401",
    "Farbtonhilfsbezeichnung": "32401",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "99",
    "Bcolor": "76",
    "Y": 26,
    "L": 57.4459114074707,
    "a": 47.3300514221191,
    "b": 36.5761337280273,
    "C": 59.8159446716309,
    "h": 37.6964492797852,
    "CMY_C": 0.12151157855988,
    "CMY_M": 0.60991615056992,
    "CMY_Y": 0.70226275920868,
    "CMYK_C": 0,
    "CMYK_M": 0.55596017837524,
    "CMYK_Y": 0.66108006238937,
    "CMYK_K": 0.12151157855988
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32402",
    "Farbtonhilfsbezeichnung": "32402",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "114",
    "Bcolor": "92",
    "Y": 31,
    "L": 61.422233581543,
    "a": 43.9434852600098,
    "b": 32.875659942627,
    "C": 54.8802223205566,
    "h": 36.8014488220215,
    "CMY_C": 0.09426057338715,
    "CMY_M": 0.55386024713516,
    "CMY_Y": 0.64007389545441,
    "CMYK_C": 0,
    "CMYK_M": 0.50743037462234,
    "CMYK_Y": 0.60261625051498,
    "CMYK_K": 0.09426057338715
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32403",
    "Farbtonhilfsbezeichnung": "32403",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "137",
    "Bcolor": "117",
    "Y": 39,
    "L": 67.8732757568359,
    "a": 38.0917739868164,
    "b": 27.4363651275635,
    "C": 46.9439811706543,
    "h": 35.7640762329102,
    "CMY_C": 0.05477344989777,
    "CMY_M": 0.4638506770134,
    "CMY_Y": 0.54113292694092,
    "CMYK_C": 0,
    "CMYK_M": 0.43278220295906,
    "CMYK_Y": 0.51454275846481,
    "CMYK_K": 0.05477344989777
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32404",
    "Farbtonhilfsbezeichnung": "32404",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "154",
    "Bcolor": "137",
    "Y": 45,
    "L": 72.4953002929688,
    "a": 33.1727066040039,
    "b": 22.8099098205566,
    "C": 40.258171081543,
    "h": 34.5128326416016,
    "CMY_C": 0.03451633453369,
    "CMY_M": 0.39771610498428,
    "CMY_Y": 0.46353954076767,
    "CMYK_C": 0,
    "CMYK_M": 0.37618428468704,
    "CMYK_Y": 0.44436091184616,
    "CMYK_K": 0.03451633453369
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32405",
    "Farbtonhilfsbezeichnung": "32405",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "173",
    "Bcolor": "159",
    "Y": 54,
    "L": 77.7066116333008,
    "a": 26.2674884796143,
    "b": 18.0266723632813,
    "C": 31.8581523895264,
    "h": 34.4607620239258,
    "CMY_C": 0.0229759812355,
    "CMY_M": 0.31981694698334,
    "CMY_Y": 0.37757080793381,
    "CMYK_C": 0,
    "CMYK_M": 0.3038215637207,
    "CMYK_Y": 0.36293357610703,
    "CMYK_K": 0.0229759812355
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32406",
    "Farbtonhilfsbezeichnung": "32406",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "183",
    "Bcolor": "169",
    "Y": 58,
    "L": 80.2864608764648,
    "a": 22.4843845367432,
    "b": 15.7896642684937,
    "C": 27.4747352600098,
    "h": 35.0784568786621,
    "CMY_C": 0.02111750841141,
    "CMY_M": 0.2805507183075,
    "CMY_Y": 0.33531886339188,
    "CMYK_C": 0,
    "CMYK_M": 0.26502999663353,
    "CMYK_Y": 0.32097965478897,
    "CMYK_K": 0.02111750841141
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32407",
    "Farbtonhilfsbezeichnung": "32407",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 66,
    "L": 84.4608764648438,
    "a": 17.4108276367188,
    "b": 11.5779905319214,
    "C": 20.9090118408203,
    "h": 33.6234245300293,
    "CMY_C": 0.01537489891052,
    "CMY_M": 0.2200887799263,
    "CMY_Y": 0.26152551174164,
    "CMYK_C": 0,
    "CMYK_M": 0.20791047811508,
    "CMYK_Y": 0.24999424815178,
    "CMYK_K": 0.01537489891052
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32408",
    "Farbtonhilfsbezeichnung": "32408",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "212",
    "Bcolor": "201",
    "Y": 72,
    "L": 87.8069610595703,
    "a": 12.3915634155273,
    "b": 9.44563770294189,
    "C": 15.5811080932617,
    "h": 37.3169555664063,
    "CMY_C": 0.01670557260513,
    "CMY_M": 0.16947990655899,
    "CMY_Y": 0.21079796552658,
    "CMYK_C": 0,
    "CMYK_M": 0.15536987781525,
    "CMYK_Y": 0.19738990068436,
    "CMYK_K": 0.01670557260513
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32409",
    "Farbtonhilfsbezeichnung": "32409",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "221",
    "Bcolor": "211",
    "Y": 77,
    "L": 90.2684860229492,
    "a": 8.44045066833496,
    "b": 7.71224975585938,
    "C": 11.4332847595215,
    "h": 42.4187240600586,
    "CMY_C": 0.02148646116257,
    "CMY_M": 0.13163965940475,
    "CMY_Y": 0.17191737890244,
    "CMYK_C": 0,
    "CMYK_M": 0.11257196962833,
    "CMYK_Y": 0.15373411774635,
    "CMYK_K": 0.02148646116257
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32410",
    "Farbtonhilfsbezeichnung": "32410",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "108",
    "Bcolor": "91",
    "Y": 25,
    "L": 56.7965965270996,
    "a": 37.5084800720215,
    "b": 26.4377307891846,
    "C": 45.8894271850586,
    "h": 35.1779708862305,
    "CMY_C": 0.19020462036133,
    "CMY_M": 0.5758330821991,
    "CMY_Y": 0.64125430583954,
    "CMYK_C": 0,
    "CMYK_M": 0.4762048125267,
    "CMYK_Y": 0.55699217319489,
    "CMYK_K": 0.19020462036133
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32411",
    "Farbtonhilfsbezeichnung": "32411",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "134",
    "Bcolor": "118",
    "Y": 35,
    "L": 65.4581832885742,
    "a": 34.1472244262695,
    "b": 23.4882736206055,
    "C": 41.4455299377441,
    "h": 34.5222587585449,
    "CMY_C": 0.11079496145248,
    "CMY_M": 0.47468036413193,
    "CMY_Y": 0.53824299573898,
    "CMYK_C": 0,
    "CMYK_M": 0.40922552347183,
    "CMYK_Y": 0.48070806264877,
    "CMYK_K": 0.11079496145248
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32412",
    "Farbtonhilfsbezeichnung": "32412",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "151",
    "Bcolor": "137",
    "Y": 42,
    "L": 70.3764953613281,
    "a": 30.0139636993408,
    "b": 19.8221302032471,
    "C": 35.9688034057617,
    "h": 33.4419784545898,
    "CMY_C": 0.08267652988434,
    "CMY_M": 0.40925651788712,
    "CMY_Y": 0.46451818943024,
    "CMYK_C": 0,
    "CMYK_M": 0.35601398348808,
    "CMYK_Y": 0.41625627875328,
    "CMYK_K": 0.08267652988434
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32413",
    "Farbtonhilfsbezeichnung": "32413",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "172",
    "Bcolor": "159",
    "Y": 52,
    "L": 76.5353240966797,
    "a": 24.1446113586426,
    "b": 15.9292097091675,
    "C": 28.925802230835,
    "h": 33.4145050048828,
    "CMY_C": 0.05378764867783,
    "CMY_M": 0.32554638385773,
    "CMY_Y": 0.37511521577835,
    "CMYK_C": 0,
    "CMYK_M": 0.28720691800117,
    "CMYK_Y": 0.33959349989891,
    "CMYK_K": 0.05378764867783
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32414",
    "Farbtonhilfsbezeichnung": "32414",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "183",
    "Bcolor": "171",
    "Y": 57,
    "L": 79.7653732299805,
    "a": 21.2263793945313,
    "b": 14.1091413497925,
    "C": 25.4877815246582,
    "h": 33.6119232177734,
    "CMY_C": 0.03870385885239,
    "CMY_M": 0.28215020895004,
    "CMY_Y": 0.3289110660553,
    "CMYK_C": 0,
    "CMYK_M": 0.25324803590775,
    "CMYK_Y": 0.30189156532288,
    "CMYK_K": 0.03870385885239
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32420",
    "Farbtonhilfsbezeichnung": "32420",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "133",
    "Bcolor": "122",
    "Y": 30,
    "L": 60.7492790222168,
    "a": 19.7399139404297,
    "b": 13.6533231735229,
    "C": 24.0016136169434,
    "h": 34.6700897216797,
    "CMY_C": 0.26340568065643,
    "CMY_M": 0.47694224119186,
    "CMY_Y": 0.51991879940033,
    "CMYK_C": 0,
    "CMYK_M": 0.28989711403847,
    "CMYK_Y": 0.34824204444885,
    "CMYK_K": 0.26340568065643
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32421",
    "Farbtonhilfsbezeichnung": "32421",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "161",
    "Bcolor": "151",
    "Y": 41,
    "L": 69.8888320922852,
    "a": 15.0676879882813,
    "b": 10.6380662918091,
    "C": 18.4446105957031,
    "h": 35.2227973937988,
    "CMY_C": 0.19748944044113,
    "CMY_M": 0.36928647756577,
    "CMY_Y": 0.40783083438873,
    "CMYK_C": 0,
    "CMYK_M": 0.21407449245453,
    "CMYK_Y": 0.26210421323776,
    "CMYK_K": 0.19748944044113
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32422",
    "Farbtonhilfsbezeichnung": "32422",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "176",
    "Bcolor": "167",
    "Y": 48,
    "L": 74.3424911499023,
    "a": 11.1685924530029,
    "b": 8.06505680084229,
    "C": 13.7761602401733,
    "h": 35.8337783813477,
    "CMY_C": 0.18001365661621,
    "CMY_M": 0.31157755851746,
    "CMY_Y": 0.34421390295029,
    "CMYK_C": 0,
    "CMYK_M": 0.16044645011425,
    "CMYK_Y": 0.20024754106998,
    "CMYK_K": 0.18001365661621
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32423",
    "Farbtonhilfsbezeichnung": "32423",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "188",
    "Bcolor": "182",
    "Y": 54,
    "L": 78.0084991455078,
    "a": 7.58855199813843,
    "b": 5.47547245025635,
    "C": 9.35771942138672,
    "h": 35.8120994567871,
    "CMY_C": 0.17114716768265,
    "CMY_M": 0.26276016235352,
    "CMY_Y": 0.28770726919174,
    "CMYK_C": 0,
    "CMYK_M": 0.11052986979485,
    "CMYK_Y": 0.14062821865082,
    "CMYK_K": 0.17114716768265
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32424",
    "Farbtonhilfsbezeichnung": "32424",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "198",
    "Bcolor": "193",
    "Y": 58,
    "L": 80.8089447021484,
    "a": 4.37817430496216,
    "b": 3.27597618103027,
    "C": 5.46812868118286,
    "h": 36.8057327270508,
    "CMY_C": 0.16987377405167,
    "CMY_M": 0.22410291433334,
    "CMY_Y": 0.24248564243317,
    "CMYK_C": 0,
    "CMYK_M": 0.06532637774944,
    "CMYK_Y": 0.08747087419033,
    "CMYK_K": 0.16987377405167
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32430",
    "Farbtonhilfsbezeichnung": "32430",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "90",
    "Bcolor": "77",
    "Y": 14,
    "L": 43.1673240661621,
    "a": 18.8901500701904,
    "b": 15.03724193573,
    "C": 24.1444911956787,
    "h": 38.5210571289063,
    "CMY_C": 0.45585411787033,
    "CMY_M": 0.64823335409164,
    "CMY_Y": 0.69668108224869,
    "CMYK_C": 0,
    "CMYK_M": 0.35354349017143,
    "CMYK_Y": 0.44257792830467,
    "CMYK_K": 0.45585411787033
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32431",
    "Farbtonhilfsbezeichnung": "32431",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "107",
    "Bcolor": "95",
    "Y": 19,
    "L": 49.7116088867188,
    "a": 17.4900226593018,
    "b": 13.4414930343628,
    "C": 22.0584373474121,
    "h": 37.5431251525879,
    "CMY_C": 0.39664083719254,
    "CMY_M": 0.58089166879654,
    "CMY_Y": 0.62569892406464,
    "CMYK_C": 0,
    "CMYK_M": 0.30537503957748,
    "CMYK_Y": 0.37963804602623,
    "CMYK_K": 0.39664083719254
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32432",
    "Farbtonhilfsbezeichnung": "32432",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "135",
    "Bcolor": "124",
    "Y": 29,
    "L": 59.8645896911621,
    "a": 13.8474893569946,
    "b": 11.0654401779175,
    "C": 17.7256011962891,
    "h": 38.6281280517578,
    "CMY_C": 0.31383895874023,
    "CMY_M": 0.46960353851318,
    "CMY_Y": 0.51207220554352,
    "CMYK_C": 0,
    "CMYK_M": 0.22700877487659,
    "CMYK_Y": 0.28890192508698,
    "CMYK_K": 0.31383895874023
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32433",
    "Farbtonhilfsbezeichnung": "32433",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "159",
    "Bcolor": "147",
    "Y": 39,
    "L": 68.4447631835938,
    "a": 12.6479940414429,
    "b": 10.7689361572266,
    "C": 16.6114940643311,
    "h": 40.4122123718262,
    "CMY_C": 0.22872871160507,
    "CMY_M": 0.37813711166382,
    "CMY_Y": 0.42391622066498,
    "CMYK_C": 0,
    "CMYK_M": 0.19371704757214,
    "CMYK_Y": 0.25307244062424,
    "CMYK_K": 0.22872871160507
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32434",
    "Farbtonhilfsbezeichnung": "32434",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "173",
    "Bcolor": "163",
    "Y": 47,
    "L": 73.4294891357422,
    "a": 10.7752685546875,
    "b": 9.11370277404785,
    "C": 14.1126184463501,
    "h": 40.224479675293,
    "CMY_C": 0.19014650583267,
    "CMY_M": 0.32053977251053,
    "CMY_Y": 0.36121982336044,
    "CMYK_C": 0,
    "CMYK_M": 0.16100846230984,
    "CMYK_Y": 0.21123982965946,
    "CMYK_K": 0.19014650583267
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32435",
    "Farbtonhilfsbezeichnung": "32435",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "195",
    "Bcolor": "185",
    "Y": 59,
    "L": 80.8460693359375,
    "a": 8.34280872344971,
    "b": 7.59889936447144,
    "C": 11.2847566604614,
    "h": 42.3282661437988,
    "CMY_C": 0.12858736515045,
    "CMY_M": 0.23459005355835,
    "CMY_Y": 0.27270036935806,
    "CMYK_C": 0,
    "CMYK_M": 0.12164465337992,
    "CMYK_Y": 0.16537860035896,
    "CMYK_K": 0.12858736515045
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32436",
    "Farbtonhilfsbezeichnung": "32436",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "202",
    "Bcolor": "193",
    "Y": 62,
    "L": 82.7640075683594,
    "a": 5.82464790344238,
    "b": 6.38558959960938,
    "C": 8.64304828643799,
    "h": 47.6303329467773,
    "CMY_C": 0.12859153747559,
    "CMY_M": 0.20720970630646,
    "CMY_Y": 0.24380081892014,
    "CMYK_C": 0,
    "CMYK_M": 0.09021965414286,
    "CMYK_Y": 0.13221041858196,
    "CMYK_K": 0.12859153747559
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32440",
    "Farbtonhilfsbezeichnung": "32440",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "77",
    "Bcolor": "58",
    "Y": 16,
    "L": 45.4121551513672,
    "a": 39.7523460388184,
    "b": 30.764591217041,
    "C": 50.2663803100586,
    "h": 37.736515045166,
    "CMY_C": 0.30759799480438,
    "CMY_M": 0.69988614320755,
    "CMY_Y": 0.77412152290344,
    "CMYK_C": 0,
    "CMYK_M": 0.56656128168106,
    "CMYK_Y": 0.67377555370331,
    "CMYK_K": 0.30759799480438
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "32441",
    "Farbtonhilfsbezeichnung": "32441",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "89",
    "Bcolor": "75",
    "Y": 15,
    "L": 44.337100982666,
    "a": 23.899564743042,
    "b": 18.1096839904785,
    "C": 29.9858283996582,
    "h": 37.1527099609375,
    "CMY_C": 0.41252470016479,
    "CMY_M": 0.65213108062744,
    "CMY_Y": 0.70478588342667,
    "CMYK_C": 0,
    "CMYK_M": 0.40785780549049,
    "CMYK_Y": 0.49748677015305,
    "CMYK_K": 0.41252470016479
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33100",
    "Farbtonhilfsbezeichnung": "33100",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "67",
    "Bcolor": "60",
    "Y": 17,
    "L": 46.9696273803711,
    "a": 50.6783332824707,
    "b": 32.1459732055664,
    "C": 60.0138053894043,
    "h": 32.387523651123,
    "CMY_C": 0.23535108566284,
    "CMY_M": 0.73529887199402,
    "CMY_Y": 0.76583611965179,
    "CMYK_C": 0,
    "CMYK_M": 0.65382659435272,
    "CMYK_Y": 0.69376289844513,
    "CMYK_K": 0.23535108566284
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33101",
    "Farbtonhilfsbezeichnung": "33101",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "81",
    "Bcolor": "76",
    "Y": 21,
    "L": 52.2542686462402,
    "a": 51.2522125244141,
    "b": 29.7607250213623,
    "C": 59.2662620544434,
    "h": 30.1425361633301,
    "CMY_C": 0.17069172859192,
    "CMY_M": 0.6811112165451,
    "CMY_Y": 0.70208781957626,
    "CMYK_C": 0,
    "CMYK_M": 0.61547619104385,
    "CMYK_Y": 0.64077025651932,
    "CMYK_K": 0.17069172859192
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33102",
    "Farbtonhilfsbezeichnung": "33102",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "95",
    "Bcolor": "92",
    "Y": 25,
    "L": 56.4882545471191,
    "a": 49.8994216918945,
    "b": 26.3258590698242,
    "C": 56.4181098937988,
    "h": 27.8151626586914,
    "CMY_C": 0.12962639331818,
    "CMY_M": 0.62898594141006,
    "CMY_Y": 0.64015114307404,
    "CMYK_C": 0,
    "CMYK_M": 0.57373011112213,
    "CMYK_Y": 0.58655816316605,
    "CMYK_K": 0.12962639331818
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33103",
    "Farbtonhilfsbezeichnung": "33103",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "118",
    "Bcolor": "117",
    "Y": 33,
    "L": 63.4603233337402,
    "a": 45.8271026611328,
    "b": 21.4896774291992,
    "C": 50.6155090332031,
    "h": 25.1232624053955,
    "CMY_C": 0.07285368442535,
    "CMY_M": 0.53727012872696,
    "CMY_Y": 0.54142808914185,
    "CMYK_C": 0,
    "CMYK_M": 0.50090956687927,
    "CMYK_Y": 0.50539422035217,
    "CMYK_K": 0.07285368442535
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33104",
    "Farbtonhilfsbezeichnung": "33104",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "135",
    "Bcolor": "136",
    "Y": 39,
    "L": 68.1238708496094,
    "a": 41.0273971557617,
    "b": 17.0130100250244,
    "C": 44.4149742126465,
    "h": 22.5225315093994,
    "CMY_C": 0.05015480518341,
    "CMY_M": 0.46900522708893,
    "CMY_Y": 0.46537894010544,
    "CMYK_C": 0,
    "CMYK_M": 0.44096702337265,
    "CMYK_Y": 0.43714928627014,
    "CMYK_K": 0.05015480518341
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33105",
    "Farbtonhilfsbezeichnung": "33105",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "157",
    "Bcolor": "158",
    "Y": 48,
    "L": 73.9470825195313,
    "a": 34.1823959350586,
    "b": 13.0093069076538,
    "C": 36.5742835998535,
    "h": 20.8360748291016,
    "CMY_C": 0.02811181545258,
    "CMY_M": 0.3830800652504,
    "CMY_Y": 0.37935537099838,
    "CMYK_C": 0,
    "CMYK_M": 0.36523568630219,
    "CMYK_Y": 0.36140325665474,
    "CMYK_K": 0.02811181545258
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33106",
    "Farbtonhilfsbezeichnung": "33106",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "169",
    "Bcolor": "170",
    "Y": 53,
    "L": 77.0604248046875,
    "a": 29.8605155944824,
    "b": 10.8641300201416,
    "C": 31.7754573822021,
    "h": 19.9928684234619,
    "CMY_C": 0.02224135398865,
    "CMY_M": 0.33568829298019,
    "CMY_Y": 0.33255285024643,
    "CMYK_C": 0,
    "CMYK_M": 0.32057699561119,
    "CMYK_Y": 0.31737023591995,
    "CMYK_K": 0.02224135398865
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33107",
    "Farbtonhilfsbezeichnung": "33107",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "186",
    "Bcolor": "187",
    "Y": 60,
    "L": 81.3656387329102,
    "a": 23.9721126556396,
    "b": 7.98057985305786,
    "C": 25.265625,
    "h": 18.4131679534912,
    "CMY_C": 0.01601338386536,
    "CMY_M": 0.27108657360077,
    "CMY_Y": 0.26742553710938,
    "CMYK_C": 0,
    "CMYK_M": 0.25922423601151,
    "CMYK_Y": 0.25550362467766,
    "CMYK_K": 0.01601338386536
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33108",
    "Farbtonhilfsbezeichnung": "33108",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "202",
    "Bcolor": "201",
    "Y": 68,
    "L": 85.45068359375,
    "a": 17.8645172119141,
    "b": 6.02310657501221,
    "C": 18.8525543212891,
    "h": 18.6317768096924,
    "CMY_C": 0.0145862698555,
    "CMY_M": 0.20900100469589,
    "CMY_Y": 0.21038097143173,
    "CMYK_C": 0,
    "CMYK_M": 0.19729249179363,
    "CMYK_Y": 0.19869288802147,
    "CMYK_K": 0.0145862698555
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33109",
    "Farbtonhilfsbezeichnung": "33109",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "213",
    "Bcolor": "212",
    "Y": 73,
    "L": 88.3263549804688,
    "a": 12.9418869018555,
    "b": 4.72584342956543,
    "C": 13.7777366638184,
    "h": 20.0601081848145,
    "CMY_C": 0.0195569396019,
    "CMY_M": 0.16389662027359,
    "CMY_Y": 0.17042464017868,
    "CMYK_C": 0,
    "CMYK_M": 0.14721882343292,
    "CMYK_Y": 0.15387706458569,
    "CMYK_K": 0.0195569396019
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33110",
    "Farbtonhilfsbezeichnung": "33110",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "107",
    "Bcolor": "94",
    "Y": 22,
    "L": 52.599983215332,
    "a": 26.5675506591797,
    "b": 18.7997379302979,
    "C": 32.5463485717773,
    "h": 35.2840003967285,
    "CMY_C": 0.30647122859955,
    "CMY_M": 0.57976472377777,
    "CMY_Y": 0.63204556703568,
    "CMYK_C": 0,
    "CMYK_M": 0.39406222105026,
    "CMYK_Y": 0.46944603323936,
    "CMYK_K": 0.30647122859955
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33111",
    "Farbtonhilfsbezeichnung": "33111",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "128",
    "Bcolor": "117",
    "Y": 30,
    "L": 59.9952087402344,
    "a": 24.5212802886963,
    "b": 16.071985244751,
    "C": 29.3189678192139,
    "h": 33.2420387268066,
    "CMY_C": 0.23952305316925,
    "CMY_M": 0.49881863594055,
    "CMY_Y": 0.54291808605194,
    "CMYK_C": 0,
    "CMYK_M": 0.34096443653107,
    "CMYK_Y": 0.39895361661911,
    "CMYK_K": 0.23952305316925
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33112",
    "Farbtonhilfsbezeichnung": "33112",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "156",
    "Bcolor": "144",
    "Y": 41,
    "L": 69.6096878051758,
    "a": 20.6550998687744,
    "b": 14.2436285018921,
    "C": 25.0901203155518,
    "h": 34.5899047851563,
    "CMY_C": 0.15786391496658,
    "CMY_M": 0.3882645368576,
    "CMY_Y": 0.43496406078339,
    "CMYK_C": 0,
    "CMYK_M": 0.2735907137394,
    "CMYK_Y": 0.32904437184334,
    "CMYK_K": 0.15786391496658
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33113",
    "Farbtonhilfsbezeichnung": "33113",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "173",
    "Bcolor": "162",
    "Y": 49,
    "L": 75.1321258544922,
    "a": 17.7448024749756,
    "b": 12.3388710021973,
    "C": 21.6130924224854,
    "h": 34.8128700256348,
    "CMY_C": 0.1178258061409,
    "CMY_M": 0.32156932353973,
    "CMY_Y": 0.36524945497513,
    "CMYK_C": 0,
    "CMYK_M": 0.23095610737801,
    "CMYK_Y": 0.28047028183937,
    "CMYK_K": 0.1178258061409
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33114",
    "Farbtonhilfsbezeichnung": "33114",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 63,
    "L": 83.1907653808594,
    "a": 12.739951133728,
    "b": 9.63655757904053,
    "C": 15.9740285873413,
    "h": 37.1040306091309,
    "CMY_C": 0.06633371114731,
    "CMY_M": 0.22092664241791,
    "CMY_Y": 0.26175075769424,
    "CMYK_C": 0,
    "CMYK_M": 0.16557621955872,
    "CMYK_Y": 0.20930074155331,
    "CMYK_K": 0.06633371114731
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33115",
    "Farbtonhilfsbezeichnung": "33115",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "211",
    "Bcolor": "200",
    "Y": 71,
    "L": 86.9567337036133,
    "a": 9.460524559021,
    "b": 8.58706951141357,
    "C": 12.7765130996704,
    "h": 42.2292022705078,
    "CMY_C": 0.04935300350189,
    "CMY_M": 0.17102205753326,
    "CMY_Y": 0.21415686607361,
    "CMYK_C": 0,
    "CMYK_M": 0.12798552215099,
    "CMYK_Y": 0.17335967719555,
    "CMYK_K": 0.04935300350189
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33116",
    "Farbtonhilfsbezeichnung": "33116",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "220",
    "Bcolor": "210",
    "Y": 75,
    "L": 89.4900970458984,
    "a": 6.78048515319824,
    "b": 7.23605680465698,
    "C": 9.91642570495605,
    "h": 46.8615951538086,
    "CMY_C": 0.0437685251236,
    "CMY_M": 0.13594436645508,
    "CMY_Y": 0.17714673280716,
    "CMYK_C": 0,
    "CMYK_M": 0.09639490395784,
    "CMYK_Y": 0.13948318362236,
    "CMYK_K": 0.0437685251236
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33120",
    "Farbtonhilfsbezeichnung": "33120",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "118",
    "Bcolor": "107",
    "Y": 25,
    "L": 55.7511405944824,
    "a": 22.9235897064209,
    "b": 15.7078523635864,
    "C": 27.7889823913574,
    "h": 34.4199752807617,
    "CMY_C": 0.2964683175087,
    "CMY_M": 0.53683233261108,
    "CMY_Y": 0.58203053474426,
    "CMYK_C": 0,
    "CMYK_M": 0.34165343642235,
    "CMYK_Y": 0.40589815378189,
    "CMYK_K": 0.2964683175087
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33121",
    "Farbtonhilfsbezeichnung": "33121",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "140",
    "Bcolor": "130",
    "Y": 33,
    "L": 63.2331161499023,
    "a": 20.2115650177002,
    "b": 13.0418720245361,
    "C": 24.0540599822998,
    "h": 32.8328475952148,
    "CMY_C": 0.23425370454788,
    "CMY_M": 0.45274174213409,
    "CMY_Y": 0.49098694324493,
    "CMYK_C": 0,
    "CMYK_M": 0.28532692790031,
    "CMYK_Y": 0.33527192473412,
    "CMYK_K": 0.23425370454788
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33122",
    "Farbtonhilfsbezeichnung": "33122",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "163",
    "Bcolor": "155",
    "Y": 42,
    "L": 70.4096374511719,
    "a": 14.3127098083496,
    "b": 9.40219306945801,
    "C": 17.1246871948242,
    "h": 33.3013954162598,
    "CMY_C": 0.19940954446793,
    "CMY_M": 0.36153435707092,
    "CMY_Y": 0.39394348859787,
    "CMYK_C": 0,
    "CMYK_M": 0.20250655710697,
    "CMYK_Y": 0.24298809468746,
    "CMYK_K": 0.19940954446793
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33123",
    "Farbtonhilfsbezeichnung": "33123",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "190",
    "Bcolor": "182",
    "Y": 55,
    "L": 78.7556304931641,
    "a": 7.8076376914978,
    "b": 6.64670181274414,
    "C": 10.2536754608154,
    "h": 40.4080085754395,
    "CMY_C": 0.15813660621643,
    "CMY_M": 0.25557637214661,
    "CMY_Y": 0.28814661502838,
    "CMYK_C": 0,
    "CMYK_M": 0.11574296653271,
    "CMYK_Y": 0.15443123877048,
    "CMYK_K": 0.15813660621643
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33130",
    "Farbtonhilfsbezeichnung": "33130",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "97",
    "Bcolor": "95",
    "Y": 13,
    "L": 42.0237617492676,
    "a": 4.0190224647522,
    "b": 2.41876840591431,
    "C": 4.69073343276978,
    "h": 31.04079246521,
    "CMY_C": 0.578069627285,
    "CMY_M": 0.6199072599411,
    "CMY_Y": 0.62921929359436,
    "CMYK_C": 0,
    "CMYK_M": 0.09915766865015,
    "CMYK_Y": 0.12122774124146,
    "CMYK_K": 0.578069627285
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33131",
    "Farbtonhilfsbezeichnung": "33131",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "117",
    "Bcolor": "115",
    "Y": 20,
    "L": 50.1931381225586,
    "a": 3.61308646202087,
    "b": 1.90831899642944,
    "C": 4.08608293533325,
    "h": 27.841609954834,
    "CMY_C": 0.5014311671257,
    "CMY_M": 0.53966021537781,
    "CMY_Y": 0.54755556583405,
    "CMYK_C": 0,
    "CMYK_M": 0.07667757570744,
    "CMYK_Y": 0.09251360595226,
    "CMYK_K": 0.5014311671257
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33132",
    "Farbtonhilfsbezeichnung": "33132",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "136",
    "Bcolor": "133",
    "Y": 26,
    "L": 57.3981399536133,
    "a": 3.33100175857544,
    "b": 2.08616995811462,
    "C": 3.93035340309143,
    "h": 32.058464050293,
    "CMY_C": 0.42983919382095,
    "CMY_M": 0.46708339452744,
    "CMY_Y": 0.47748631238937,
    "CMYK_C": 0,
    "CMYK_M": 0.06532227247953,
    "CMYK_Y": 0.08356785774231,
    "CMYK_K": 0.42983919382095
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33133",
    "Farbtonhilfsbezeichnung": "33133",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "157",
    "Bcolor": "155",
    "Y": 35,
    "L": 65.4296875,
    "a": 2.91131091117859,
    "b": 1.72340452671051,
    "C": 3.38317227363586,
    "h": 30.6241989135742,
    "CMY_C": 0.35050982236862,
    "CMY_M": 0.383640229702,
    "CMY_Y": 0.39346313476563,
    "CMYK_C": 0,
    "CMYK_M": 0.05100986734033,
    "CMYK_Y": 0.06613389402628,
    "CMYK_K": 0.35050982236862
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33134",
    "Farbtonhilfsbezeichnung": "33134",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "170",
    "Bcolor": "167",
    "Y": 42,
    "L": 70.2744750976563,
    "a": 2.70610523223877,
    "b": 1.91098499298096,
    "C": 3.31283402442932,
    "h": 35.2287979125977,
    "CMY_C": 0.30022120475769,
    "CMY_M": 0.33249199390411,
    "CMY_Y": 0.34455138444901,
    "CMYK_C": 0,
    "CMYK_M": 0.0461157001555,
    "CMYK_Y": 0.06334884464741,
    "CMYK_K": 0.30022120475769
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33135",
    "Farbtonhilfsbezeichnung": "33135",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "188",
    "Bcolor": "185",
    "Y": 52,
    "L": 76.7956924438477,
    "a": 2.13235473632813,
    "b": 1.78367066383362,
    "C": 2.78000330924988,
    "h": 39.9117851257324,
    "CMY_C": 0.23487496376038,
    "CMY_M": 0.2616947889328,
    "CMY_Y": 0.27496963739395,
    "CMYK_C": 0,
    "CMYK_M": 0.03505286574364,
    "CMYK_Y": 0.05240277200937,
    "CMYK_K": 0.23487496376038
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33136",
    "Farbtonhilfsbezeichnung": "33136",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "204",
    "Bcolor": "199",
    "Y": 62,
    "L": 82.3254623413086,
    "a": 1.76132142543793,
    "b": 2.40735173225403,
    "C": 2.98288369178772,
    "h": 53.8092041015625,
    "CMY_C": 0.17546087503433,
    "CMY_M": 0.2011342048645,
    "CMY_Y": 0.22025901079178,
    "CMYK_C": 0,
    "CMYK_M": 0.03113658167422,
    "CMYK_Y": 0.0543311201036,
    "CMYK_K": 0.17546087503433
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33137",
    "Farbtonhilfsbezeichnung": "33137",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 68,
    "L": 85.7781600952148,
    "a": 1.10196304321289,
    "b": 2.47130465507507,
    "C": 2.70585823059082,
    "h": 65.9677505493164,
    "CMY_C": 0.14227658510208,
    "CMY_M": 0.16177421808243,
    "CMY_Y": 0.18341106176376,
    "CMYK_C": 0,
    "CMYK_M": 0.02273184247315,
    "CMYK_Y": 0.04795774072409,
    "CMYK_K": 0.14227658510208
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33140",
    "Farbtonhilfsbezeichnung": "33140",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "86",
    "Bcolor": "73",
    "Y": 15,
    "L": 44.6237373352051,
    "a": 28.3382244110107,
    "b": 20.3198661804199,
    "C": 34.8705024719238,
    "h": 35.6423377990723,
    "CMY_C": 0.38367402553558,
    "CMY_M": 0.66373044252396,
    "CMY_Y": 0.71551394462585,
    "CMYK_C": 0,
    "CMYK_M": 0.45439657568932,
    "CMYK_Y": 0.53841626644135,
    "CMYK_K": 0.38367402553558
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33141",
    "Farbtonhilfsbezeichnung": "33141",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "71",
    "Bcolor": "54",
    "Y": 10,
    "L": 37.4681930541992,
    "a": 25.495626449585,
    "b": 21.5386981964111,
    "C": 33.3757781982422,
    "h": 40.1911125183105,
    "CMY_C": 0.47483724355698,
    "CMY_M": 0.72287726402283,
    "CMY_Y": 0.78760451078415,
    "CMYK_C": 0,
    "CMYK_M": 0.47231075167656,
    "CMYK_Y": 0.59556251764297,
    "CMYK_K": 0.47483724355698
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33142",
    "Farbtonhilfsbezeichnung": "33142",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "71",
    "Bcolor": "61",
    "Y": 9,
    "L": 34.2796859741211,
    "a": 16.000452041626,
    "b": 12.3913059234619,
    "C": 20.2375621795654,
    "h": 37.755443572998,
    "CMY_C": 0.56697559356689,
    "CMY_M": 0.7229009270668,
    "CMY_Y": 0.76027280092239,
    "CMYK_C": 0,
    "CMYK_M": 0.36008441448212,
    "CMYK_Y": 0.44638872146606,
    "CMYK_K": 0.56697559356689
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33143",
    "Farbtonhilfsbezeichnung": "33143",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "63",
    "Bcolor": "56",
    "Y": 7,
    "L": 29.7970676422119,
    "a": 11.3735189437866,
    "b": 9.35097122192383,
    "C": 14.724048614502,
    "h": 39.4260292053223,
    "CMY_C": 0.6400346159935,
    "CMY_M": 0.75110459327698,
    "CMY_Y": 0.78165638446808,
    "CMYK_C": 0,
    "CMYK_M": 0.30855739116669,
    "CMYK_Y": 0.39343163371086,
    "CMYK_K": 0.6400346159935
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33144",
    "Farbtonhilfsbezeichnung": "33144",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "62",
    "Bcolor": "56",
    "Y": 6,
    "L": 28.1563549041748,
    "a": 8.20573139190674,
    "b": 6.36022567749023,
    "C": 10.3820276260376,
    "h": 37.7791061401367,
    "CMY_C": 0.67756354808807,
    "CMY_M": 0.75770390033722,
    "CMY_Y": 0.77848595380783,
    "CMYK_C": 0,
    "CMYK_M": 0.24854619801044,
    "CMYK_Y": 0.31299936771393,
    "CMYK_K": 0.67756354808807
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33200",
    "Farbtonhilfsbezeichnung": "33200",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "66",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.0535087585449,
    "a": 41.6667785644531,
    "b": 24.6620025634766,
    "C": 48.4183311462402,
    "h": 30.6207141876221,
    "CMY_C": 0.34242486953735,
    "CMY_M": 0.74055850505829,
    "CMY_Y": 0.76311248540878,
    "CMYK_C": 0,
    "CMYK_M": 0.60545724630356,
    "CMYK_Y": 0.63975596427917,
    "CMYK_K": 0.34242486953735
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33201",
    "Farbtonhilfsbezeichnung": "33201",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "80",
    "Bcolor": "79",
    "Y": 18,
    "L": 49.1431465148926,
    "a": 45.507007598877,
    "b": 23.4706878662109,
    "C": 51.2031326293945,
    "h": 27.2828674316406,
    "CMY_C": 0.24219614267349,
    "CMY_M": 0.68514573574066,
    "CMY_Y": 0.69061100482941,
    "CMYK_C": 0,
    "CMYK_M": 0.58451747894287,
    "CMYK_Y": 0.59172946214676,
    "CMYK_K": 0.24219614267349
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33202",
    "Farbtonhilfsbezeichnung": "33202",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "95",
    "Bcolor": "96",
    "Y": 23,
    "L": 54.1337242126465,
    "a": 44.0160598754883,
    "b": 20.4322834014893,
    "C": 48.5272254943848,
    "h": 24.9007587432861,
    "CMY_C": 0.1944175362587,
    "CMY_M": 0.62661981582642,
    "CMY_Y": 0.62452554702759,
    "CMYK_C": 0,
    "CMYK_M": 0.53650903701782,
    "CMYK_Y": 0.53390938043594,
    "CMYK_K": 0.1944175362587
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33203",
    "Farbtonhilfsbezeichnung": "33203",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "119",
    "Bcolor": "122",
    "Y": 31,
    "L": 62.2478523254395,
    "a": 41.3624534606934,
    "b": 16.7084197998047,
    "C": 44.6096839904785,
    "h": 21.9963130950928,
    "CMY_C": 0.11812901496887,
    "CMY_M": 0.53153443336487,
    "CMY_Y": 0.52175140380859,
    "CMYK_C": 0,
    "CMYK_M": 0.46878218650818,
    "CMYK_Y": 0.45768871903419,
    "CMYK_K": 0.11812901496887
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33204",
    "Farbtonhilfsbezeichnung": "33204",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "136",
    "Bcolor": "140",
    "Y": 38,
    "L": 67.0870971679688,
    "a": 37.5902099609375,
    "b": 13.12779712677,
    "C": 39.8166160583496,
    "h": 19.2509613037109,
    "CMY_C": 0.08820939064026,
    "CMY_M": 0.46670764684677,
    "CMY_Y": 0.44968515634537,
    "CMYK_C": 0,
    "CMYK_M": 0.41511532664299,
    "CMYK_Y": 0.39644601941109,
    "CMYK_K": 0.08820939064026
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33205",
    "Farbtonhilfsbezeichnung": "33205",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "159",
    "Bcolor": "162",
    "Y": 47,
    "L": 73.6519012451172,
    "a": 31.8849754333496,
    "b": 10.1842575073242,
    "C": 33.4719390869141,
    "h": 17.7138023376465,
    "CMY_C": 0.05081188678741,
    "CMY_M": 0.37806206941605,
    "CMY_Y": 0.36294591426849,
    "CMYK_C": 0,
    "CMYK_M": 0.34476852416992,
    "CMYK_Y": 0.3288431763649,
    "CMYK_K": 0.05081188678741
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33206",
    "Farbtonhilfsbezeichnung": "33206",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "171",
    "Bcolor": "174",
    "Y": 52,
    "L": 76.9782180786133,
    "a": 28.0509796142578,
    "b": 8.49722480773926,
    "C": 29.3097305297852,
    "h": 16.8526515960693,
    "CMY_C": 0.03943675756454,
    "CMY_M": 0.33038288354874,
    "CMY_Y": 0.31690740585327,
    "CMYK_C": 0,
    "CMYK_M": 0.30289116501808,
    "CMYK_Y": 0.28886243700981,
    "CMYK_K": 0.03943675756454
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33207",
    "Farbtonhilfsbezeichnung": "33207",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "188",
    "Bcolor": "190",
    "Y": 60,
    "L": 81.5568695068359,
    "a": 22.4895935058594,
    "b": 6.43611478805542,
    "C": 23.3924217224121,
    "h": 15.9701642990112,
    "CMY_C": 0.02715915441513,
    "CMY_M": 0.26432502269745,
    "CMY_Y": 0.25450676679611,
    "CMYK_C": 0,
    "CMYK_M": 0.24378691613674,
    "CMYK_Y": 0.23369455337524,
    "CMYK_K": 0.02715915441513
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33208",
    "Farbtonhilfsbezeichnung": "33208",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "203",
    "Bcolor": "203",
    "Y": 68,
    "L": 85.604621887207,
    "a": 16.8850002288818,
    "b": 5.18209314346313,
    "C": 17.6623134613037,
    "h": 17.0615196228027,
    "CMY_C": 0.0217410326004,
    "CMY_M": 0.20441162586212,
    "CMY_Y": 0.20274329185486,
    "CMYK_C": 0,
    "CMYK_M": 0.18673029541969,
    "CMYK_Y": 0.18502488732338,
    "CMYK_K": 0.0217410326004
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33209",
    "Farbtonhilfsbezeichnung": "33209",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "216",
    "Bcolor": "214",
    "Y": 74,
    "L": 88.803825378418,
    "a": 11.561692237854,
    "b": 3.96491456031799,
    "C": 12.2226543426514,
    "h": 18.9286594390869,
    "CMY_C": 0.02615171670914,
    "CMY_M": 0.15480941534042,
    "CMY_Y": 0.15982848405838,
    "CMYK_C": 0,
    "CMYK_M": 0.13211266696453,
    "CMYK_Y": 0.13726651668549,
    "CMYK_K": 0.02615171670914
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33210",
    "Farbtonhilfsbezeichnung": "33210",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "97",
    "Bcolor": "94",
    "Y": 17,
    "L": 47.6674003601074,
    "a": 24.1363697052002,
    "b": 11.6717796325684,
    "C": 26.8103485107422,
    "h": 25.807315826416,
    "CMY_C": 0.38455468416214,
    "CMY_M": 0.61919414997101,
    "CMY_Y": 0.6322762966156,
    "CMYK_C": 0,
    "CMYK_M": 0.38125151395798,
    "CMYK_Y": 0.40250793099403,
    "CMYK_K": 0.38455468416214
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33211",
    "Farbtonhilfsbezeichnung": "33211",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "124",
    "Bcolor": "122",
    "Y": 26,
    "L": 57.4189147949219,
    "a": 21.6422901153564,
    "b": 8.95571994781494,
    "C": 23.4220752716064,
    "h": 22.4800891876221,
    "CMY_C": 0.29760640859604,
    "CMY_M": 0.51477777957916,
    "CMY_Y": 0.52072691917419,
    "CMYK_C": 0,
    "CMYK_M": 0.30918756127357,
    "CMYK_Y": 0.31765738129616,
    "CMYK_K": 0.29760640859604
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33212",
    "Farbtonhilfsbezeichnung": "33212",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "144",
    "Bcolor": "142",
    "Y": 34,
    "L": 64.4519958496094,
    "a": 19.5075283050537,
    "b": 7.75279426574707,
    "C": 20.9916534423828,
    "h": 21.6741466522217,
    "CMY_C": 0.23583298921585,
    "CMY_M": 0.43692028522491,
    "CMY_Y": 0.44255119562149,
    "CMYK_C": 0,
    "CMYK_M": 0.26314574480057,
    "CMYK_Y": 0.27051442861557,
    "CMYK_K": 0.23583298921585
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33213",
    "Farbtonhilfsbezeichnung": "33213",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "166",
    "Bcolor": "165",
    "Y": 45,
    "L": 72.0425262451172,
    "a": 16.3120574951172,
    "b": 6.06714248657227,
    "C": 17.4038333892822,
    "h": 20.4022922515869,
    "CMY_C": 0.176149725914,
    "CMY_M": 0.34874856472015,
    "CMY_Y": 0.35331010818481,
    "CMYK_C": 0,
    "CMYK_M": 0.20950268208981,
    "CMYK_Y": 0.21503953635693,
    "CMYK_K": 0.176149725914
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33214",
    "Farbtonhilfsbezeichnung": "33214",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "178",
    "Bcolor": "176",
    "Y": 51,
    "L": 75.9103622436523,
    "a": 14.6149082183838,
    "b": 5.731276512146,
    "C": 15.6985054016113,
    "h": 21.4127655029297,
    "CMY_C": 0.1452459692955,
    "CMY_M": 0.30316895246506,
    "CMY_Y": 0.3106609582901,
    "CMYK_C": 0,
    "CMYK_M": 0.18475839495659,
    "CMYK_Y": 0.19352349638939,
    "CMYK_K": 0.1452459692955
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33215",
    "Farbtonhilfsbezeichnung": "33215",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "196",
    "Bcolor": "193",
    "Y": 60,
    "L": 81.6842422485352,
    "a": 11.6689939498901,
    "b": 4.73085117340088,
    "C": 12.5915203094482,
    "h": 22.0686511993408,
    "CMY_C": 0.10360586643219,
    "CMY_M": 0.23316752910614,
    "CMY_Y": 0.24252891540527,
    "CMYK_C": 0,
    "CMYK_M": 0.14453649520874,
    "CMYK_Y": 0.15497986972332,
    "CMYK_K": 0.10360586643219
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33216",
    "Farbtonhilfsbezeichnung": "33216",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "210",
    "Bcolor": "206",
    "Y": 69,
    "L": 86.0074768066406,
    "a": 8.64994621276855,
    "b": 4.38273286819458,
    "C": 9.69690227508545,
    "h": 26.8703060150146,
    "CMY_C": 0.0776070356369,
    "CMY_M": 0.17823588848114,
    "CMY_Y": 0.1937962770462,
    "CMYK_C": 0,
    "CMYK_M": 0.10909542441368,
    "CMYK_Y": 0.12596501410007,
    "CMYK_K": 0.0776070356369
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33220",
    "Farbtonhilfsbezeichnung": "33220",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "113",
    "Bcolor": "111",
    "Y": 22,
    "L": 52.739860534668,
    "a": 19.3392124176025,
    "b": 8.77342510223389,
    "C": 21.2362461090088,
    "h": 24.4018898010254,
    "CMY_C": 0.36207646131516,
    "CMY_M": 0.55501037836075,
    "CMY_Y": 0.56565791368484,
    "CMYK_C": 0,
    "CMYK_M": 0.30244049429893,
    "CMYK_Y": 0.31913143396378,
    "CMYK_K": 0.36207646131516
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33221",
    "Farbtonhilfsbezeichnung": "33221",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "147",
    "Bcolor": "146",
    "Y": 34,
    "L": 64.5482482910156,
    "a": 14.6024141311646,
    "b": 5.83481121063232,
    "C": 15.7249965667725,
    "h": 21.7805881500244,
    "CMY_C": 0.27003240585327,
    "CMY_M": 0.42231810092926,
    "CMY_Y": 0.42916023731232,
    "CMYK_C": 0,
    "CMYK_M": 0.20861980319023,
    "CMYK_Y": 0.21799300611019,
    "CMYK_K": 0.27003240585327
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33222",
    "Farbtonhilfsbezeichnung": "33222",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "170",
    "Bcolor": "168",
    "Y": 45,
    "L": 72.1672515869141,
    "a": 11.2415132522583,
    "b": 4.37976217269897,
    "C": 12.0645732879639,
    "h": 21.2861919403076,
    "CMY_C": 0.21289283037186,
    "CMY_M": 0.33381861448288,
    "CMY_Y": 0.34090656042099,
    "CMYK_C": 0,
    "CMYK_M": 0.15363319218159,
    "CMYK_Y": 0.16263824701309,
    "CMYK_K": 0.21289283037186
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33223",
    "Farbtonhilfsbezeichnung": "33223",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "188",
    "Bcolor": "187",
    "Y": 54,
    "L": 77.9798355102539,
    "a": 7.62928152084351,
    "b": 2.71308588981628,
    "C": 8.09733104705811,
    "h": 19.5761413574219,
    "CMY_C": 0.17901045084,
    "CMY_M": 0.26241308450699,
    "CMY_Y": 0.2682312130928,
    "CMYK_C": 0,
    "CMYK_M": 0.10158793628216,
    "CMYK_Y": 0.10867466032505,
    "CMYK_K": 0.17901045084
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33224",
    "Farbtonhilfsbezeichnung": "33224",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "199",
    "Bcolor": "197",
    "Y": 60,
    "L": 81.3228759765625,
    "a": 5.07654714584351,
    "b": 1.73054206371307,
    "C": 5.36340427398682,
    "h": 18.823709487915,
    "CMY_C": 0.16377705335617,
    "CMY_M": 0.21978282928467,
    "CMY_Y": 0.22570443153381,
    "CMYK_C": 0,
    "CMYK_M": 0.06697469204664,
    "CMYK_Y": 0.07405605912209,
    "CMYK_K": 0.16377705335617
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33230",
    "Farbtonhilfsbezeichnung": "33230",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "76",
    "Bcolor": "72",
    "Y": 9,
    "L": 35.4321060180664,
    "a": 12.4330711364746,
    "b": 7.21343040466309,
    "C": 14.3741025924683,
    "h": 30.121488571167,
    "CMY_C": 0.58273160457611,
    "CMY_M": 0.70211124420166,
    "CMY_Y": 0.71877491474152,
    "CMYK_C": 0,
    "CMYK_M": 0.28609797358513,
    "CMYK_Y": 0.32603311538696,
    "CMYK_K": 0.58273160457611
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33231",
    "Farbtonhilfsbezeichnung": "33231",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "92",
    "Bcolor": "90",
    "Y": 13,
    "L": 42.0212135314941,
    "a": 11.560564994812,
    "b": 5.18206548690796,
    "C": 12.6688776016235,
    "h": 24.1444835662842,
    "CMY_C": 0.52588307857513,
    "CMY_M": 0.63789677619934,
    "CMY_Y": 0.64573907852173,
    "CMYK_C": 0,
    "CMYK_M": 0.23625753819942,
    "CMYK_Y": 0.25279840826988,
    "CMYK_K": 0.52588307857513
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33232",
    "Farbtonhilfsbezeichnung": "33232",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "119",
    "Bcolor": "117",
    "Y": 21,
    "L": 52.4487609863281,
    "a": 9.73052024841309,
    "b": 4.42090559005737,
    "C": 10.68772315979,
    "h": 24.4339103698731,
    "CMY_C": 0.43248134851456,
    "CMY_M": 0.53210145235062,
    "CMY_Y": 0.5412130355835,
    "CMYK_C": 0,
    "CMYK_M": 0.17553626000881,
    "CMYK_Y": 0.19159139692783,
    "CMYK_K": 0.43248134851456
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33233",
    "Farbtonhilfsbezeichnung": "33233",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "136",
    "Bcolor": "134",
    "Y": 28,
    "L": 58.807056427002,
    "a": 8.43767738342285,
    "b": 3.58388924598694,
    "C": 9.16726016998291,
    "h": 23.013277053833,
    "CMY_C": 0.3768110871315,
    "CMY_M": 0.46504265069962,
    "CMY_Y": 0.47276246547699,
    "CMYK_C": 0,
    "CMYK_M": 0.14158076047897,
    "CMYK_Y": 0.15396836400032,
    "CMYK_K": 0.3768110871315
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33234",
    "Farbtonhilfsbezeichnung": "33234",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "159",
    "Bcolor": "158",
    "Y": 37,
    "L": 67.0290679931641,
    "a": 7.13964223861694,
    "b": 2.49942421913147,
    "C": 7.56449699401855,
    "h": 19.2939739227295,
    "CMY_C": 0.30162936449051,
    "CMY_M": 0.37710624933243,
    "CMY_Y": 0.38176149129868,
    "CMYK_C": 0,
    "CMYK_M": 0.10807568579912,
    "CMYK_Y": 0.11474154889584,
    "CMYK_K": 0.30162936449051
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33235",
    "Farbtonhilfsbezeichnung": "33235",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "178",
    "Bcolor": "176",
    "Y": 47,
    "L": 73.6746978759766,
    "a": 5.55052995681763,
    "b": 1.97006905078888,
    "C": 5.88978385925293,
    "h": 19.5414791107178,
    "CMY_C": 0.24302095174789,
    "CMY_M": 0.30318963527679,
    "CMY_Y": 0.30888736248016,
    "CMYK_C": 0,
    "CMYK_M": 0.07948526740074,
    "CMYK_Y": 0.08701220154762,
    "CMYK_K": 0.24302095174789
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33236",
    "Farbtonhilfsbezeichnung": "33236",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "201",
    "Bcolor": "198",
    "Y": 60,
    "L": 81.5971603393555,
    "a": 3.04139471054077,
    "b": 2.04242491722107,
    "C": 3.66354775428772,
    "h": 33.8830299377441,
    "CMY_C": 0.17495512962341,
    "CMY_M": 0.21199983358383,
    "CMY_Y": 0.22528922557831,
    "CMYK_C": 0,
    "CMYK_M": 0.04490023106337,
    "CMYK_Y": 0.06100770831108,
    "CMYK_K": 0.17495512962341
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33237",
    "Farbtonhilfsbezeichnung": "33237",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "215",
    "Bcolor": "210",
    "Y": 69,
    "L": 86.3462753295898,
    "a": 2.29568910598755,
    "b": 2.32086873054504,
    "C": 3.26444792747498,
    "h": 45.3125,
    "CMY_C": 0.12733501195908,
    "CMY_M": 0.15831977128983,
    "CMY_Y": 0.17595541477203,
    "CMYK_C": 0,
    "CMYK_M": 0.03550590574741,
    "CMYK_Y": 0.05571485310793,
    "CMYK_K": 0.12733501195908
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33240",
    "Farbtonhilfsbezeichnung": "33240",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "66",
    "Bcolor": "57",
    "Y": 10,
    "L": 36.0933036804199,
    "a": 26.7916164398193,
    "b": 17.7215614318848,
    "C": 32.1223373413086,
    "h": 33.4830131530762,
    "CMY_C": 0.48734074831009,
    "CMY_M": 0.73921859264374,
    "CMY_Y": 0.77521932125092,
    "CMYK_C": 0,
    "CMYK_M": 0.49131628870964,
    "CMYK_Y": 0.56153976917267,
    "CMYK_K": 0.48734074831009
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33241",
    "Farbtonhilfsbezeichnung": "33241",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "66",
    "Bcolor": "55",
    "Y": 8,
    "L": 33.996265411377,
    "a": 21.7369709014893,
    "b": 15.8324403762817,
    "C": 26.8916721343994,
    "h": 36.0682678222656,
    "CMY_C": 0.53648114204407,
    "CMY_M": 0.74233448505402,
    "CMY_Y": 0.78283232450485,
    "CMYK_C": 0,
    "CMYK_M": 0.44410997629166,
    "CMYK_Y": 0.53148037195206,
    "CMYK_K": 0.53648114204407
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33300",
    "Farbtonhilfsbezeichnung": "33300",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "72",
    "Bcolor": "72",
    "Y": 12,
    "L": 39.3701629638672,
    "a": 29.3726119995117,
    "b": 13.0613622665405,
    "C": 32.1457557678223,
    "h": 23.9736747741699,
    "CMY_C": 0.44481319189072,
    "CMY_M": 0.71592211723328,
    "CMY_Y": 0.71660995483398,
    "CMYK_C": 0,
    "CMYK_M": 0.48832017183304,
    "CMYK_Y": 0.48955911397934,
    "CMYK_K": 0.44481319189072
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33301",
    "Farbtonhilfsbezeichnung": "33301",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "87",
    "Bcolor": "90",
    "Y": 16,
    "L": 46.6559295654297,
    "a": 32.9703598022461,
    "b": 12.5677099227905,
    "C": 35.2844429016113,
    "h": 20.8659496307373,
    "CMY_C": 0.34726190567017,
    "CMY_M": 0.65775644779205,
    "CMY_Y": 0.64590299129486,
    "CMYK_C": 0,
    "CMYK_M": 0.47568014264107,
    "CMYK_Y": 0.45752054452896,
    "CMYK_K": 0.34726190567017
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33302",
    "Farbtonhilfsbezeichnung": "33302",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "100",
    "Bcolor": "105",
    "Y": 21,
    "L": 51.7482528686523,
    "a": 33.3976287841797,
    "b": 11.4229316711426,
    "C": 35.2970962524414,
    "h": 18.882137298584,
    "CMY_C": 0.28989708423615,
    "CMY_M": 0.60855060815811,
    "CMY_Y": 0.59018498659134,
    "CMYK_C": 0,
    "CMYK_M": 0.44874274730682,
    "CMYK_Y": 0.42287939786911,
    "CMYK_K": 0.28989708423615
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33303",
    "Farbtonhilfsbezeichnung": "33303",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "125",
    "Bcolor": "132",
    "Y": 30,
    "L": 61.163948059082,
    "a": 31.9339981079102,
    "b": 9.19814014434814,
    "C": 33.2323036193848,
    "h": 16.0683040618896,
    "CMY_C": 0.1956735253334,
    "CMY_M": 0.50799113512039,
    "CMY_Y": 0.48342347145081,
    "CMYK_C": 0,
    "CMYK_M": 0.38829705119133,
    "CMYK_Y": 0.3577526807785,
    "CMYK_K": 0.1956735253334
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33304",
    "Farbtonhilfsbezeichnung": "33304",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "143",
    "Bcolor": "149",
    "Y": 37,
    "L": 66.674690246582,
    "a": 28.714485168457,
    "b": 7.13726663589478,
    "C": 29.5882110595703,
    "h": 13.958553314209,
    "CMY_C": 0.15611177682877,
    "CMY_M": 0.44050359725952,
    "CMY_Y": 0.41418433189392,
    "CMYK_C": 0,
    "CMYK_M": 0.33700177073479,
    "CMYK_Y": 0.30581367015839,
    "CMYK_K": 0.15611177682877
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33305",
    "Farbtonhilfsbezeichnung": "33305",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "164",
    "Bcolor": "170",
    "Y": 47,
    "L": 73.6877975463867,
    "a": 24.875955581665,
    "b": 5.98707818984985,
    "C": 25.5862903594971,
    "h": 13.5324211120606,
    "CMY_C": 0.10269957780838,
    "CMY_M": 0.35522145032883,
    "CMY_Y": 0.33421242237091,
    "CMYK_C": 0,
    "CMYK_M": 0.2814239859581,
    "CMYK_Y": 0.25801041722298,
    "CMYK_K": 0.10269957780838
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33306",
    "Farbtonhilfsbezeichnung": "33306",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "175",
    "Bcolor": "180",
    "Y": 52,
    "L": 76.7885131835938,
    "a": 22.262077331543,
    "b": 4.87264013290405,
    "C": 22.7890911102295,
    "h": 12.3459901809692,
    "CMY_C": 0.08685892820358,
    "CMY_M": 0.31443738937378,
    "CMY_Y": 0.29409557580948,
    "CMYK_C": 0,
    "CMYK_M": 0.24922595918179,
    "CMYK_Y": 0.2269492149353,
    "CMYK_K": 0.08685892820358
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33307",
    "Farbtonhilfsbezeichnung": "33307",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "189",
    "Bcolor": "193",
    "Y": 60,
    "L": 81.2188949584961,
    "a": 18.8924140930176,
    "b": 4.22455501556396,
    "C": 19.3589820861816,
    "h": 12.604621887207,
    "CMY_C": 0.06049871444702,
    "CMY_M": 0.25727277994156,
    "CMY_Y": 0.24277061223984,
    "CMYK_C": 0,
    "CMYK_M": 0.2094452381134,
    "CMYK_Y": 0.1940091997385,
    "CMYK_K": 0.06049871444702
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33308",
    "Farbtonhilfsbezeichnung": "33308",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 69,
    "L": 86.2721328735352,
    "a": 13.7288360595703,
    "b": 3.79032588005066,
    "C": 14.2424545288086,
    "h": 15.4340314865112,
    "CMY_C": 0.03993743658066,
    "CMY_M": 0.18826937675476,
    "CMY_Y": 0.18583339452744,
    "CMYK_C": 0,
    "CMYK_M": 0.15450236201286,
    "CMYK_Y": 0.15196505188942,
    "CMYK_K": 0.03993743658066
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33309",
    "Farbtonhilfsbezeichnung": "33309",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "219",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.5623931884766,
    "a": 9.18381500244141,
    "b": 4.16607999801636,
    "C": 10.0845766067505,
    "h": 24.4006042480469,
    "CMY_C": 0.03422331809998,
    "CMY_M": 0.14036524295807,
    "CMY_Y": 0.15336209535599,
    "CMYK_C": 0,
    "CMYK_M": 0.1099031791091,
    "CMYK_Y": 0.12336058914661,
    "CMYK_K": 0.03422331809998
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33310",
    "Farbtonhilfsbezeichnung": "33310",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "98",
    "Bcolor": "96",
    "Y": 17,
    "L": 46.8331756591797,
    "a": 20.9406967163086,
    "b": 8.99622917175293,
    "C": 22.7913341522217,
    "h": 23.2486038208008,
    "CMY_C": 0.41556495428085,
    "CMY_M": 0.61735820770264,
    "CMY_Y": 0.62341201305389,
    "CMYK_C": 0,
    "CMYK_M": 0.34527918696404,
    "CMYK_Y": 0.35563758015633,
    "CMYK_K": 0.41556495428085
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33311",
    "Farbtonhilfsbezeichnung": "33311",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "124",
    "Bcolor": "123",
    "Y": 26,
    "L": 56.7762832641602,
    "a": 19.0323944091797,
    "b": 7.26862716674805,
    "C": 20.3731441497803,
    "h": 20.9022655487061,
    "CMY_C": 0.32346045970917,
    "CMY_M": 0.51354664564133,
    "CMY_Y": 0.51619118452072,
    "CMYK_C": 0,
    "CMYK_M": 0.28096833825111,
    "CMYK_Y": 0.28487724065781,
    "CMYK_K": 0.32346045970917
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33312",
    "Farbtonhilfsbezeichnung": "33312",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "140",
    "Bcolor": "140",
    "Y": 32,
    "L": 62.5437965393066,
    "a": 17.6336669921875,
    "b": 6.21719217300415,
    "C": 18.6975860595703,
    "h": 19.4213809967041,
    "CMY_C": 0.27175337076187,
    "CMY_M": 0.45100921392441,
    "CMY_Y": 0.45165145397186,
    "CMYK_C": 0,
    "CMYK_M": 0.24614717066288,
    "CMYK_Y": 0.24702906608582,
    "CMYK_K": 0.27175337076187
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33313",
    "Farbtonhilfsbezeichnung": "33313",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "163",
    "Bcolor": "162",
    "Y": 43,
    "L": 70.5295104980469,
    "a": 14.9064788818359,
    "b": 5.15749931335449,
    "C": 15.7734880447388,
    "h": 19.0851306915283,
    "CMY_C": 0.20433586835861,
    "CMY_M": 0.3607017993927,
    "CMY_Y": 0.3628865480423,
    "CMYK_C": 0,
    "CMYK_M": 0.19652253389359,
    "CMYK_Y": 0.19926835596561,
    "CMYK_K": 0.20433586835861
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33314",
    "Farbtonhilfsbezeichnung": "33314",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "175",
    "Bcolor": "174",
    "Y": 48,
    "L": 74.4678649902344,
    "a": 13.5164070129395,
    "b": 4.41429090499878,
    "C": 14.2189741134644,
    "h": 18.0863952636719,
    "CMY_C": 0.17205500602722,
    "CMY_M": 0.31528687477112,
    "CMY_Y": 0.31667977571487,
    "CMYK_C": 0,
    "CMYK_M": 0.17299683392048,
    "CMYK_Y": 0.17467920482159,
    "CMYK_K": 0.17205500602722
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33315",
    "Farbtonhilfsbezeichnung": "33315",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "193",
    "Bcolor": "191",
    "Y": 58,
    "L": 80.5077819824219,
    "a": 10.7847776412964,
    "b": 4.00415134429932,
    "C": 11.5041151046753,
    "h": 20.3688564300537,
    "CMY_C": 0.12496697902679,
    "CMY_M": 0.24343228340149,
    "CMY_Y": 0.25003057718277,
    "CMYK_C": 0,
    "CMYK_M": 0.13538381457329,
    "CMYK_Y": 0.14292442798615,
    "CMYK_K": 0.12496697902679
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33316",
    "Farbtonhilfsbezeichnung": "33316",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "209",
    "Bcolor": "206",
    "Y": 67,
    "L": 85.6104278564453,
    "a": 7.58610916137695,
    "b": 3.57129263877869,
    "C": 8.38469982147217,
    "h": 25.2095260620117,
    "CMY_C": 0.092176258564,
    "CMY_M": 0.17969125509262,
    "CMY_Y": 0.19233846664429,
    "CMYK_C": 0,
    "CMYK_M": 0.09640086442232,
    "CMYK_Y": 0.11033222079277,
    "CMYK_K": 0.092176258564
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33317",
    "Farbtonhilfsbezeichnung": "33317",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 74,
    "L": 89.1631011962891,
    "a": 5.03732252120972,
    "b": 3.61936926841736,
    "C": 6.20277786254883,
    "h": 35.6976432800293,
    "CMY_C": 0.07108640670776,
    "CMY_M": 0.13423746824265,
    "CMY_Y": 0.1543208360672,
    "CMYK_C": 0,
    "CMYK_M": 0.06798378378153,
    "CMYK_Y": 0.08960405737162,
    "CMYK_K": 0.07108640670776
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33320",
    "Farbtonhilfsbezeichnung": "33320",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "114",
    "Bcolor": "113",
    "Y": 21,
    "L": 52.0376853942871,
    "a": 16.7909641265869,
    "b": 6.41076850891113,
    "C": 17.9731578826904,
    "h": 20.8967914581299,
    "CMY_C": 0.38922029733658,
    "CMY_M": 0.5544810295105,
    "CMY_Y": 0.55730509757996,
    "CMYK_C": 0,
    "CMYK_M": 0.27057337760925,
    "CMYK_Y": 0.27519708871841,
    "CMYK_K": 0.38922029733658
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33321",
    "Farbtonhilfsbezeichnung": "33321",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "143",
    "Bcolor": "143",
    "Y": 32,
    "L": 62.5397987365723,
    "a": 13.4078464508057,
    "b": 4.09867477416992,
    "C": 14.0203237533569,
    "h": 16.9979858398438,
    "CMY_C": 0.30356132984161,
    "CMY_M": 0.43942129611969,
    "CMY_Y": 0.43786388635635,
    "CMYK_C": 0,
    "CMYK_M": 0.1950781494379,
    "CMYK_Y": 0.19284190237522,
    "CMYK_K": 0.30356132984161
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33322",
    "Farbtonhilfsbezeichnung": "33322",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "166",
    "Bcolor": "166",
    "Y": 43,
    "L": 70.6433792114258,
    "a": 10.6129875183106,
    "b": 3.40526270866394,
    "C": 11.1459102630615,
    "h": 17.7892589569092,
    "CMY_C": 0.23638224601746,
    "CMY_M": 0.34803080558777,
    "CMY_Y": 0.35006654262543,
    "CMYK_C": 0,
    "CMYK_M": 0.1462100148201,
    "CMYK_Y": 0.14887592196465,
    "CMYK_K": 0.23638224601746
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33323",
    "Farbtonhilfsbezeichnung": "33323",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "185",
    "Bcolor": "184",
    "Y": 52,
    "L": 76.619758605957,
    "a": 7.35351228713989,
    "b": 1.86477077007294,
    "C": 7.58627128601074,
    "h": 14.22962474823,
    "CMY_C": 0.19837146997452,
    "CMY_M": 0.27609431743622,
    "CMY_Y": 0.27669322490692,
    "CMYK_C": 0,
    "CMYK_M": 0.09695618599653,
    "CMYK_Y": 0.09770330041647,
    "CMYK_K": 0.19837146997452
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33324",
    "Farbtonhilfsbezeichnung": "33324",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "196",
    "Bcolor": "195",
    "Y": 58,
    "L": 80.1394805908203,
    "a": 4.56764316558838,
    "b": 1.08387434482574,
    "C": 4.69448041915894,
    "h": 13.349045753479,
    "CMY_C": 0.18254810571671,
    "CMY_M": 0.23120474815369,
    "CMY_Y": 0.23384749889374,
    "CMYK_C": 0,
    "CMYK_M": 0.05952233076096,
    "CMYK_Y": 0.06275524199009,
    "CMYK_K": 0.18254810571671
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33330",
    "Farbtonhilfsbezeichnung": "33330",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "86",
    "Bcolor": "84",
    "Y": 12,
    "L": 40.1008110046387,
    "a": 14.6422185897827,
    "b": 6.43276977539063,
    "C": 15.9929704666138,
    "h": 23.7173385620117,
    "CMY_C": 0.52518254518509,
    "CMY_M": 0.66402852535248,
    "CMY_Y": 0.67102086544037,
    "CMYK_C": 0,
    "CMYK_M": 0.29241970181465,
    "CMYK_Y": 0.3071460723877,
    "CMYK_K": 0.52518254518509
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33331",
    "Farbtonhilfsbezeichnung": "33331",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "108",
    "Bcolor": "108",
    "Y": 19,
    "L": 49.0988693237305,
    "a": 14.061897277832,
    "b": 5.18856430053711,
    "C": 14.988600730896,
    "h": 20.2530708312988,
    "CMY_C": 0.43881750106812,
    "CMY_M": 0.57595002651215,
    "CMY_Y": 0.57817381620407,
    "CMYK_C": 0,
    "CMYK_M": 0.24436351656914,
    "CMYK_Y": 0.24832619726658,
    "CMYK_K": 0.43881750106812
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33332",
    "Farbtonhilfsbezeichnung": "33332",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "127",
    "Bcolor": "127",
    "Y": 25,
    "L": 56.068431854248,
    "a": 12.653491973877,
    "b": 3.95602107048035,
    "C": 13.2574872970581,
    "h": 17.3614692687988,
    "CMY_C": 0.37746620178223,
    "CMY_M": 0.50308430194855,
    "CMY_Y": 0.50201058387756,
    "CMYK_C": 0,
    "CMYK_M": 0.20178519189358,
    "CMYK_Y": 0.20006042718887,
    "CMYK_K": 0.37746620178223
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33333",
    "Farbtonhilfsbezeichnung": "33333",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "149",
    "Bcolor": "149",
    "Y": 35,
    "L": 64.4607162475586,
    "a": 11.3804321289063,
    "b": 3.40760469436646,
    "C": 11.8796463012695,
    "h": 16.6691017150879,
    "CMY_C": 0.29794943332672,
    "CMY_M": 0.41436320543289,
    "CMY_Y": 0.41384267807007,
    "CMYK_C": 0,
    "CMYK_M": 0.16581964492798,
    "CMYK_Y": 0.16507820785046,
    "CMYK_K": 0.29794943332672
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33334",
    "Farbtonhilfsbezeichnung": "33334",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "163",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.4637069702148,
    "a": 10.6393489837647,
    "b": 3.30140852928162,
    "C": 11.1397953033447,
    "h": 17.2392082214356,
    "CMY_C": 0.24928337335587,
    "CMY_M": 0.36045324802399,
    "CMY_Y": 0.36161738634109,
    "CMYK_C": 0,
    "CMYK_M": 0.1480849981308,
    "CMYK_Y": 0.1496357023716,
    "CMYK_K": 0.24928337335587
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33335",
    "Farbtonhilfsbezeichnung": "33335",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "182",
    "Bcolor": "181",
    "Y": 51,
    "L": 75.8283309936523,
    "a": 8.67559814453125,
    "b": 2.64186072349548,
    "C": 9.06892681121826,
    "h": 16.9363460540771,
    "CMY_C": 0.19537198543549,
    "CMY_M": 0.28803443908691,
    "CMY_Y": 0.29044198989868,
    "CMYK_C": 0,
    "CMYK_M": 0.11516185104847,
    "CMYK_Y": 0.11815398186445,
    "CMYK_K": 0.19537198543549
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33336",
    "Farbtonhilfsbezeichnung": "33336",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "199",
    "Bcolor": "197",
    "Y": 61,
    "L": 81.7788009643555,
    "a": 7.08892679214478,
    "b": 2.87011051177979,
    "C": 7.64790296554565,
    "h": 22.0416641235352,
    "CMY_C": 0.14054268598557,
    "CMY_M": 0.22007346153259,
    "CMY_Y": 0.22874253988266,
    "CMYK_C": 0,
    "CMYK_M": 0.09253603965044,
    "CMYK_Y": 0.10262272506952,
    "CMYK_K": 0.14054268598557
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33337",
    "Farbtonhilfsbezeichnung": "33337",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "212",
    "Bcolor": "208",
    "Y": 68,
    "L": 85.8579025268555,
    "a": 4.52619457244873,
    "b": 2.59976482391357,
    "C": 5.21969509124756,
    "h": 29.8722858428955,
    "CMY_C": 0.11500924825668,
    "CMY_M": 0.16915392875671,
    "CMY_Y": 0.18299627304077,
    "CMYK_C": 0,
    "CMYK_M": 0.06118106842041,
    "CMYK_Y": 0.07682230323553,
    "CMYK_K": 0.11500924825668
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33340",
    "Farbtonhilfsbezeichnung": "33340",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "66",
    "Bcolor": "57",
    "Y": 10,
    "L": 36.0776519775391,
    "a": 27.3512573242188,
    "b": 17.6919898986816,
    "C": 32.5744972229004,
    "h": 32.896556854248,
    "CMY_C": 0.48481541872025,
    "CMY_M": 0.74122530221939,
    "CMY_Y": 0.77504503726959,
    "CMYK_C": 0,
    "CMYK_M": 0.4977048933506,
    "CMYK_Y": 0.56335073709488,
    "CMYK_K": 0.48481541872025
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33341",
    "Farbtonhilfsbezeichnung": "33341",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "71",
    "Bcolor": "65",
    "Y": 9,
    "L": 35.6773910522461,
    "a": 20.4293422698975,
    "b": 11.8009204864502,
    "C": 23.5927906036377,
    "h": 30.0126914978027,
    "CMY_C": 0.53076678514481,
    "CMY_M": 0.72216367721558,
    "CMY_Y": 0.74349689483643,
    "CMYK_C": 0,
    "CMYK_M": 0.40789288282394,
    "CMYK_Y": 0.4533568918705,
    "CMYK_K": 0.53076678514481
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33342",
    "Farbtonhilfsbezeichnung": "33342",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "66",
    "Bcolor": "61",
    "Y": 8,
    "L": 31.9563980102539,
    "a": 14.9099273681641,
    "b": 9.38824081420898,
    "C": 17.6194496154785,
    "h": 32.1971321105957,
    "CMY_C": 0.60039329528809,
    "CMY_M": 0.74054968357086,
    "CMY_Y": 0.76251429319382,
    "CMYK_C": 0,
    "CMYK_M": 0.35073581337929,
    "CMYK_Y": 0.40570139884949,
    "CMYK_K": 0.60039329528809
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33400",
    "Farbtonhilfsbezeichnung": "33400",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 10,
    "L": 37.3605499267578,
    "a": 18.7038478851318,
    "b": 1.46317970752716,
    "C": 18.7609920501709,
    "h": 4.47307062149048,
    "CMY_C": 0.54000639915466,
    "CMY_M": 0.6991400718689,
    "CMY_Y": 0.66485786437988,
    "CMYK_C": 0,
    "CMYK_M": 0.34594759345055,
    "CMYK_Y": 0.27142000198364,
    "CMYK_K": 0.54000639915466
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33401",
    "Farbtonhilfsbezeichnung": "33401",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "96",
    "Bcolor": "107",
    "Y": 16,
    "L": 45.7483978271484,
    "a": 20.7550945281982,
    "b": 0.55275428295135,
    "C": 20.7624530792236,
    "h": 1.52555322647095,
    "CMY_C": 0.44435149431229,
    "CMY_M": 0.62505495548248,
    "CMY_Y": 0.57957541942596,
    "CMYK_C": 0,
    "CMYK_M": 0.3252118229866,
    "CMYK_Y": 0.24336235225201,
    "CMYK_K": 0.44435149431229
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33402",
    "Farbtonhilfsbezeichnung": "33402",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "112",
    "Bcolor": "125",
    "Y": 22,
    "L": 52.3811645507813,
    "a": 20.8224506378174,
    "b": 0.01588568463922,
    "C": 20.8224563598633,
    "h": 0.04371159151196,
    "CMY_C": 0.37543368339539,
    "CMY_M": 0.56027501821518,
    "CMY_Y": 0.51129508018494,
    "CMYK_C": 0,
    "CMYK_M": 0.29595148563385,
    "CMYK_Y": 0.21752917766571,
    "CMYK_K": 0.37543368339539
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33403",
    "Farbtonhilfsbezeichnung": "33403",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "137",
    "Bcolor": "149",
    "Y": 31,
    "L": 61.6391639709473,
    "a": 19.7328968048096,
    "b": -0.40843561291695,
    "C": 19.7371234893799,
    "h": 358.814239501953,
    "CMY_C": 0.28395694494247,
    "CMY_M": 0.46407806873322,
    "CMY_Y": 0.41543745994568,
    "CMYK_C": 0,
    "CMYK_M": 0.25155067443848,
    "CMYK_Y": 0.18362095952034,
    "CMYK_K": 0.28395694494247
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33404",
    "Farbtonhilfsbezeichnung": "33404",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "154",
    "Bcolor": "166",
    "Y": 39,
    "L": 67.8977737426758,
    "a": 17.981538772583,
    "b": -0.68682098388672,
    "C": 17.9946517944336,
    "h": 357.812591552734,
    "CMY_C": 0.22785311937332,
    "CMY_M": 0.39470797777176,
    "CMY_Y": 0.34913069009781,
    "CMYK_C": 0,
    "CMYK_M": 0.21609212458134,
    "CMYK_Y": 0.15706542134285,
    "CMYK_K": 0.22785311937332
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33405",
    "Farbtonhilfsbezeichnung": "33405",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "175",
    "Bcolor": "183",
    "Y": 49,
    "L": 74.8410491943359,
    "a": 15.5907297134399,
    "b": 0.00292897084728,
    "C": 15.5907297134399,
    "h": 0.01076393853873,
    "CMY_C": 0.16561961174011,
    "CMY_M": 0.31548702716827,
    "CMY_Y": 0.28120666742325,
    "CMYK_C": 0,
    "CMYK_M": 0.17961521446705,
    "CMYK_Y": 0.13853040337563,
    "CMYK_K": 0.16561961174011
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33406",
    "Farbtonhilfsbezeichnung": "33406",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "186",
    "Bcolor": "193",
    "Y": 55,
    "L": 78.5910873413086,
    "a": 14.4525108337402,
    "b": 0.05825328826904,
    "C": 14.4526281356812,
    "h": 0.23093907535076,
    "CMY_C": 0.13168156147003,
    "CMY_M": 0.27243322134018,
    "CMY_Y": 0.24172419309616,
    "CMYK_C": 0,
    "CMYK_M": 0.16209682822227,
    "CMYK_Y": 0.12673072516918,
    "CMYK_K": 0.13168156147003
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33407",
    "Farbtonhilfsbezeichnung": "33407",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "202",
    "Bcolor": "206",
    "Y": 64,
    "L": 83.7587814331055,
    "a": 10.8208322525024,
    "b": 0.64942622184753,
    "C": 10.8403024673462,
    "h": 3.43456029891968,
    "CMY_C": 0.09804201126099,
    "CMY_M": 0.20727473497391,
    "CMY_Y": 0.19071286916733,
    "CMYK_C": 0,
    "CMYK_M": 0.12110622227192,
    "CMYK_Y": 0.10274409502745,
    "CMYK_K": 0.09804201126099
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33408",
    "Farbtonhilfsbezeichnung": "33408",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "216",
    "Bcolor": "216",
    "Y": 72,
    "L": 88.0602035522461,
    "a": 8.27016925811768,
    "b": 1.89091980457306,
    "C": 8.48358917236328,
    "h": 12.8789215087891,
    "CMY_C": 0.06468260288239,
    "CMY_M": 0.15399074554443,
    "CMY_Y": 0.15322130918503,
    "CMYK_C": 0,
    "CMYK_M": 0.09548431634903,
    "CMYK_Y": 0.094661667943,
    "CMYK_K": 0.06468260288239
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33409",
    "Farbtonhilfsbezeichnung": "33409",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "224",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.5112609863281,
    "a": 5.37715768814087,
    "b": 2.11313557624817,
    "C": 5.77747058868408,
    "h": 21.4540195465088,
    "CMY_C": 0.05804961919785,
    "CMY_M": 0.11969894170761,
    "CMY_Y": 0.12835240364075,
    "CMYK_C": 0,
    "CMYK_M": 0.06544858962297,
    "CMYK_Y": 0.07463533431292,
    "CMYK_K": 0.05804961919785
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33410",
    "Farbtonhilfsbezeichnung": "33410",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "100",
    "Bcolor": "112",
    "Y": 16,
    "L": 46.3269004821777,
    "a": 16.2609672546387,
    "b": -1.37822914123535,
    "C": 16.3192691802979,
    "h": 355.155364990234,
    "CMY_C": 0.46906459331512,
    "CMY_M": 0.60676419734955,
    "CMY_Y": 0.56220233440399,
    "CMYK_C": 0,
    "CMYK_M": 0.25935283303261,
    "CMYK_Y": 0.17542198300362,
    "CMYK_K": 0.46906459331512
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33411",
    "Farbtonhilfsbezeichnung": "33411",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "120",
    "Bcolor": "133",
    "Y": 24,
    "L": 54.496654510498,
    "a": 16.7373504638672,
    "b": -1.81450700759888,
    "C": 16.8354187011719,
    "h": 353.812683105469,
    "CMY_C": 0.38246482610703,
    "CMY_M": 0.52767795324326,
    "CMY_Y": 0.47870343923569,
    "CMYK_C": 0,
    "CMYK_M": 0.23514956235886,
    "CMYK_Y": 0.1558431237936,
    "CMYK_K": 0.38246482610703
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33412",
    "Farbtonhilfsbezeichnung": "33412",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "141",
    "Bcolor": "152",
    "Y": 32,
    "L": 62.0836868286133,
    "a": 14.8963785171509,
    "b": -1.39244902133942,
    "C": 14.9613170623779,
    "h": 354.659759521484,
    "CMY_C": 0.31279987096786,
    "CMY_M": 0.44637185335159,
    "CMY_Y": 0.40485906600952,
    "CMYK_C": 0,
    "CMYK_M": 0.19437129795551,
    "CMYK_Y": 0.13396272063255,
    "CMYK_K": 0.31279987096786
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33413",
    "Farbtonhilfsbezeichnung": "33413",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "161",
    "Bcolor": "172",
    "Y": 41,
    "L": 69.4665603637695,
    "a": 13.8850698471069,
    "b": -1.63990485668182,
    "C": 13.981575012207,
    "h": 353.264251708984,
    "CMY_C": 0.24072992801666,
    "CMY_M": 0.36725491285324,
    "CMY_Y": 0.32665848731995,
    "CMYK_C": 0,
    "CMYK_M": 0.16664029657841,
    "CMYK_Y": 0.11317259073257,
    "CMYK_K": 0.24072992801666
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33414",
    "Farbtonhilfsbezeichnung": "33414",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "180",
    "Bcolor": "186",
    "Y": 51,
    "L": 76.0774383544922,
    "a": 12.5659456253052,
    "b": 0.20242188870907,
    "C": 12.5675754547119,
    "h": 0.92288446426392,
    "CMY_C": 0.17227280139923,
    "CMY_M": 0.29449534416199,
    "CMY_Y": 0.2698969244957,
    "CMYK_C": 0,
    "CMYK_M": 0.1476604193449,
    "CMYK_Y": 0.1179423853755,
    "CMYK_K": 0.17227280139923
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33420",
    "Farbtonhilfsbezeichnung": "33420",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "109",
    "Bcolor": "114",
    "Y": 18,
    "L": 48.5715446472168,
    "a": 11.059552192688,
    "b": 0.22447355091572,
    "C": 11.0618295669556,
    "h": 1.16276144981384,
    "CMY_C": 0.47410279512405,
    "CMY_M": 0.57234144210815,
    "CMY_Y": 0.55141031742096,
    "CMYK_C": 0,
    "CMYK_M": 0.18680199980736,
    "CMYK_Y": 0.14700120687485,
    "CMYK_K": 0.47410279512405
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33421",
    "Farbtonhilfsbezeichnung": "33421",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "141",
    "Bcolor": "146",
    "Y": 30,
    "L": 60.6185264587402,
    "a": 9.79711151123047,
    "b": -0.27397537231445,
    "C": 9.80094146728516,
    "h": 358.398132324219,
    "CMY_C": 0.35908043384552,
    "CMY_M": 0.44886082410812,
    "CMY_Y": 0.42813068628311,
    "CMYK_C": 0,
    "CMYK_M": 0.14008058607578,
    "CMYK_Y": 0.10773622244596,
    "CMYK_K": 0.35908043384552
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33422",
    "Farbtonhilfsbezeichnung": "33422",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "169",
    "Bcolor": "173",
    "Y": 43,
    "L": 70.6160507202148,
    "a": 6.58753728866577,
    "b": -1.06178367137909,
    "C": 6.67255830764771,
    "h": 350.843780517578,
    "CMY_C": 0.27761244773865,
    "CMY_M": 0.33720552921295,
    "CMY_Y": 0.31960833072662,
    "CMYK_C": 0,
    "CMYK_M": 0.08249461650848,
    "CMYK_Y": 0.05813483893871,
    "CMYK_K": 0.27761244773865
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33423",
    "Farbtonhilfsbezeichnung": "33423",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "185",
    "Bcolor": "187",
    "Y": 51,
    "L": 76.1946487426758,
    "a": 5.65213298797607,
    "b": 0.02248644828796,
    "C": 5.65217781066895,
    "h": 0.22794435918331,
    "CMY_C": 0.22088432312012,
    "CMY_M": 0.27599722146988,
    "CMY_Y": 0.26832765340805,
    "CMYK_C": 0,
    "CMYK_M": 0.07073776423931,
    "CMYK_Y": 0.06089382246137,
    "CMYK_K": 0.22088432312012
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33424",
    "Farbtonhilfsbezeichnung": "33424",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "196",
    "Bcolor": "197",
    "Y": 57,
    "L": 79.8210067749023,
    "a": 3.12588858604431,
    "b": -0.37750467658043,
    "C": 3.14860105514526,
    "h": 353.113891601563,
    "CMY_C": 0.20147901773453,
    "CMY_M": 0.23079657554626,
    "CMY_Y": 0.2269526720047,
    "CMYK_C": 0,
    "CMYK_M": 0.0367148257792,
    "CMYK_Y": 0.03190104663372,
    "CMYK_K": 0.20147901773453
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33430",
    "Farbtonhilfsbezeichnung": "33430",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "92",
    "Bcolor": "97",
    "Y": 12,
    "L": 40.7122039794922,
    "a": 7.38060092926025,
    "b": -1.24851179122925,
    "C": 7.48545598983765,
    "h": 350.398681640625,
    "CMY_C": 0.57912468910217,
    "CMY_M": 0.63886618614197,
    "CMY_Y": 0.61801487207413,
    "CMYK_C": 0,
    "CMYK_M": 0.14194583892822,
    "CMYK_Y": 0.09240309894085,
    "CMYK_K": 0.57912468910217
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33431",
    "Farbtonhilfsbezeichnung": "33431",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "112",
    "Bcolor": "120",
    "Y": 18,
    "L": 48.8585739135742,
    "a": 7.35890245437622,
    "b": -2.84502625465393,
    "C": 7.88971614837646,
    "h": 338.863006591797,
    "CMY_C": 0.50324469804764,
    "CMY_M": 0.55995047092438,
    "CMY_Y": 0.52909308671951,
    "CMYK_C": 0,
    "CMYK_M": 0.11415232717991,
    "CMYK_Y": 0.05203444883227,
    "CMYK_K": 0.50324469804764
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33432",
    "Farbtonhilfsbezeichnung": "33432",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "127",
    "Bcolor": "135",
    "Y": 24,
    "L": 54.631893157959,
    "a": 7.54711055755615,
    "b": -2.96196627616882,
    "C": 8.10753536224365,
    "h": 338.571807861328,
    "CMY_C": 0.4439417719841,
    "CMY_M": 0.50321227312088,
    "CMY_Y": 0.47090494632721,
    "CMYK_C": 0,
    "CMYK_M": 0.10659045726061,
    "CMYK_Y": 0.04848983883858,
    "CMYK_K": 0.4439417719841
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33433",
    "Farbtonhilfsbezeichnung": "33433",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "148",
    "Bcolor": "153",
    "Y": 32,
    "L": 62.7420692443848,
    "a": 7.5552544593811,
    "b": -1.37300395965576,
    "C": 7.67899799346924,
    "h": 349.700134277344,
    "CMY_C": 0.35521429777145,
    "CMY_M": 0.42140829563141,
    "CMY_Y": 0.39920699596405,
    "CMYK_C": 0,
    "CMYK_M": 0.10266046226025,
    "CMYK_Y": 0.06822840124369,
    "CMYK_K": 0.35521429777145
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33434",
    "Farbtonhilfsbezeichnung": "33434",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "169",
    "Bcolor": "174",
    "Y": 42,
    "L": 70.4083099365234,
    "a": 6.40695095062256,
    "b": -1.81180012226105,
    "C": 6.65820074081421,
    "h": 344.209808349609,
    "CMY_C": 0.2834467291832,
    "CMY_M": 0.33874726295471,
    "CMY_Y": 0.31656229496002,
    "CMYK_C": 0,
    "CMYK_M": 0.07717574387789,
    "CMYK_Y": 0.04621507972479,
    "CMYK_K": 0.2834467291832
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33435",
    "Farbtonhilfsbezeichnung": "33435",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "187",
    "Bcolor": "189",
    "Y": 52,
    "L": 76.9526596069336,
    "a": 5.97264766693115,
    "b": -0.21639086306095,
    "C": 5.97656631469727,
    "h": 357.925048828125,
    "CMY_C": 0.21103656291962,
    "CMY_M": 0.26857668161392,
    "CMY_Y": 0.25849097967148,
    "CMYK_C": 0,
    "CMYK_M": 0.07293128967285,
    "CMYK_Y": 0.06014780327678,
    "CMYK_K": 0.21103656291962
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33436",
    "Farbtonhilfsbezeichnung": "33436",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "200",
    "Bcolor": "200",
    "Y": 60,
    "L": 81.6159515380859,
    "a": 4.60319185256958,
    "b": 1.00126564502716,
    "C": 4.71082878112793,
    "h": 12.2715692520142,
    "CMY_C": 0.16633701324463,
    "CMY_M": 0.21524852514267,
    "CMY_Y": 0.21734112501144,
    "CMYK_C": 0,
    "CMYK_M": 0.05867060646415,
    "CMYK_Y": 0.06118073314428,
    "CMYK_K": 0.16633701324463
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33437",
    "Farbtonhilfsbezeichnung": "33437",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "218",
    "Bcolor": "214",
    "Y": 71,
    "L": 87.5849838256836,
    "a": 2.8385329246521,
    "b": 2.22835564613342,
    "C": 3.60871696472168,
    "h": 38.1332550048828,
    "CMY_C": 0.10972929000854,
    "CMY_M": 0.14593839645386,
    "CMY_Y": 0.16167789697647,
    "CMYK_C": 0,
    "CMYK_M": 0.04067201912403,
    "CMYK_Y": 0.05835147202015,
    "CMYK_K": 0.10972929000854
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33440",
    "Farbtonhilfsbezeichnung": "33440",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "89",
    "Bcolor": "98",
    "Y": 13,
    "L": 41.3737678527832,
    "a": 14.1514616012573,
    "b": -0.31472435593605,
    "C": 14.1549606323242,
    "h": 358.725982666016,
    "CMY_C": 0.52926921844482,
    "CMY_M": 0.64903092384338,
    "CMY_Y": 0.6167733669281,
    "CMYK_C": 0,
    "CMYK_M": 0.25441655516624,
    "CMYK_Y": 0.18589000403881,
    "CMYK_K": 0.52926921844482
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "33441",
    "Farbtonhilfsbezeichnung": "33441",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "79",
    "Bcolor": "83",
    "Y": 9,
    "L": 34.3646202087402,
    "a": 3.74819898605347,
    "b": -1.76041078567505,
    "C": 4.14101934432983,
    "h": 334.842041015625,
    "CMY_C": 0.66390478610992,
    "CMY_M": 0.69007217884064,
    "CMY_Y": 0.67460989952087,
    "CMYK_C": 0,
    "CMYK_M": 0.07785708457232,
    "CMYK_Y": 0.03185142949224,
    "CMYK_K": 0.66390478610992
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34100",
    "Farbtonhilfsbezeichnung": "34100",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "84",
    "Bcolor": "103",
    "Y": 11,
    "L": 37.6891174316406,
    "a": 9.64216041564941,
    "b": -9.55687236785889,
    "C": 13.5759000778198,
    "h": 315.254516601563,
    "CMY_C": 0.6178914308548,
    "CMY_M": 0.67002832889557,
    "CMY_Y": 0.59458315372467,
    "CMYK_C": 0.05749212950468,
    "CMYK_M": 0.18609285354614,
    "CMYK_Y": 0,
    "CMYK_K": 0.59458315372467
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34101",
    "Farbtonhilfsbezeichnung": "34101",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "105",
    "Bcolor": "127",
    "Y": 16,
    "L": 46.6240348815918,
    "a": 10.6871547698975,
    "b": -10.1919717788696,
    "C": 14.7679233551025,
    "h": 316.358612060547,
    "CMY_C": 0.52578830718994,
    "CMY_M": 0.58731377124786,
    "CMY_Y": 0.5031304359436,
    "CMYK_C": 0.04560124501586,
    "CMYK_M": 0.16942743957043,
    "CMYK_Y": 0,
    "CMYK_K": 0.5031304359436
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34102",
    "Farbtonhilfsbezeichnung": "34102",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "123",
    "Bcolor": "145",
    "Y": 23,
    "L": 53.7784538269043,
    "a": 10.4689664840698,
    "b": -10.3763980865479,
    "C": 14.7400436401367,
    "h": 315.254425048828,
    "CMY_C": 0.45585232973099,
    "CMY_M": 0.51642310619354,
    "CMY_Y": 0.42989826202393,
    "CMYK_C": 0.04552532732487,
    "CMYK_M": 0.15177088975906,
    "CMYK_Y": 0,
    "CMYK_K": 0.42989826202393
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34103",
    "Farbtonhilfsbezeichnung": "34103",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "151",
    "Bcolor": "170",
    "Y": 35,
    "L": 64.3365020751953,
    "a": 9.23688888549805,
    "b": -8.72986221313477,
    "C": 12.7094697952271,
    "h": 316.616485595703,
    "CMY_C": 0.34977012872696,
    "CMY_M": 0.4068221449852,
    "CMY_Y": 0.33197730779648,
    "CMYK_C": 0.02663505449891,
    "CMYK_M": 0.11203936487436,
    "CMYK_Y": 0,
    "CMYK_K": 0.33197730779648
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34104",
    "Farbtonhilfsbezeichnung": "34104",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "169",
    "Bcolor": "186",
    "Y": 43,
    "L": 70.7021255493164,
    "a": 8.15149688720703,
    "b": -7.77625131607056,
    "C": 11.2657442092896,
    "h": 316.349609375,
    "CMY_C": 0.28699177503586,
    "CMY_M": 0.33807039260864,
    "CMY_Y": 0.27142888307571,
    "CMYK_C": 0.02136084064841,
    "CMYK_M": 0.09146878123283,
    "CMYK_Y": 0,
    "CMYK_K": 0.27142888307571
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34105",
    "Farbtonhilfsbezeichnung": "34105",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "189",
    "Bcolor": "201",
    "Y": 54,
    "L": 77.7856369018555,
    "a": 6.48866748809814,
    "b": -5.67215442657471,
    "C": 8.61836051940918,
    "h": 318.841247558594,
    "CMY_C": 0.21588712930679,
    "CMY_M": 0.2592676281929,
    "CMY_Y": 0.21049308776855,
    "CMYK_C": 0.00683216517791,
    "CMYK_M": 0.06177848577499,
    "CMYK_Y": 0,
    "CMYK_K": 0.21049308776855
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34106",
    "Farbtonhilfsbezeichnung": "34106",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "198",
    "Bcolor": "208",
    "Y": 60,
    "L": 80.9921798706055,
    "a": 5.66355180740356,
    "b": -4.36001348495483,
    "C": 7.14741468429565,
    "h": 322.409576416016,
    "CMY_C": 0.18269038200378,
    "CMY_M": 0.22302335500717,
    "CMY_Y": 0.18524748086929,
    "CMYK_C": 0,
    "CMYK_M": 0.04934846237302,
    "CMYK_Y": 0.00312867830507,
    "CMYK_K": 0.18269038200378
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34107",
    "Farbtonhilfsbezeichnung": "34107",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "213",
    "Bcolor": "218",
    "Y": 69,
    "L": 86.1984786987305,
    "a": 4.39674854278564,
    "b": -1.8368992805481,
    "C": 4.76503896713257,
    "h": 337.325531005859,
    "CMY_C": 0.12650209665298,
    "CMY_M": 0.16381883621216,
    "CMY_Y": 0.14686727523804,
    "CMYK_C": 0,
    "CMYK_M": 0.04272104054689,
    "CMYK_Y": 0.02331451326609,
    "CMYK_K": 0.12650209665298
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34108",
    "Farbtonhilfsbezeichnung": "34108",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "223",
    "Y": 75,
    "L": 89.4773864746094,
    "a": 3.20816731452942,
    "b": 0.03628075867891,
    "C": 3.20837235450745,
    "h": 0.64792311191559,
    "CMY_C": 0.09293794631958,
    "CMY_M": 0.12526279687881,
    "CMY_Y": 0.12472516298294,
    "CMYK_C": 0,
    "CMYK_M": 0.03563686832786,
    "CMYK_Y": 0.03504414856434,
    "CMYK_K": 0.09293794631958
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34109",
    "Farbtonhilfsbezeichnung": "34109",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "231",
    "Bcolor": "228",
    "Y": 80,
    "L": 91.9121246337891,
    "a": 1.55095255374908,
    "b": 1.23043310642242,
    "C": 1.97975242137909,
    "h": 38.426383972168,
    "CMY_C": 0.07461929321289,
    "CMY_M": 0.0945091843605,
    "CMY_Y": 0.10689836740494,
    "CMYK_C": 0,
    "CMYK_M": 0.02149373851717,
    "CMYK_Y": 0.03488193824887,
    "CMYK_K": 0.07461929321289
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34110",
    "Farbtonhilfsbezeichnung": "34110",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "108",
    "Bcolor": "128",
    "Y": 17,
    "L": 46.6174392700195,
    "a": 6.92781448364258,
    "b": -11.1103963851929,
    "C": 13.0933389663696,
    "h": 301.945343017578,
    "CMY_C": 0.55482184886932,
    "CMY_M": 0.57836210727692,
    "CMY_Y": 0.49765241146088,
    "CMYK_C": 0.11380454152822,
    "CMYK_M": 0.1606650352478,
    "CMYK_Y": 0,
    "CMYK_K": 0.49765241146088
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34111",
    "Farbtonhilfsbezeichnung": "34111",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "136",
    "Bcolor": "157",
    "Y": 27,
    "L": 57.8901672363281,
    "a": 6.99352836608887,
    "b": -10.9866132736206,
    "C": 13.0236368179321,
    "h": 302.478790283203,
    "CMY_C": 0.44075375795364,
    "CMY_M": 0.46671462059021,
    "CMY_Y": 0.38399004936218,
    "CMYK_C": 0.09214738756418,
    "CMYK_M": 0.13429096341133,
    "CMYK_Y": 0,
    "CMYK_K": 0.38399004936218
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34112",
    "Farbtonhilfsbezeichnung": "34112",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "154",
    "Bcolor": "172",
    "Y": 35,
    "L": 64.7382278442383,
    "a": 6.64274501800537,
    "b": -9.02713966369629,
    "C": 11.2078237533569,
    "h": 306.347991943359,
    "CMY_C": 0.36550712585449,
    "CMY_M": 0.39637464284897,
    "CMY_Y": 0.32602071762085,
    "CMYK_C": 0.05858697742224,
    "CMYK_M": 0.10438589006662,
    "CMYK_Y": 0,
    "CMYK_K": 0.32602071762085
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34113",
    "Farbtonhilfsbezeichnung": "34113",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "164",
    "Bcolor": "179",
    "Y": 40,
    "L": 68.2991714477539,
    "a": 6.21581172943115,
    "b": -7.68505239486694,
    "C": 9.88414573669434,
    "h": 308.966583251953,
    "CMY_C": 0.32654529809952,
    "CMY_M": 0.35869765281677,
    "CMY_Y": 0.29782229661942,
    "CMYK_C": 0.04090560227633,
    "CMYK_M": 0.08669508248568,
    "CMYK_Y": 0,
    "CMYK_K": 0.29782229661942
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34114",
    "Farbtonhilfsbezeichnung": "34114",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "176",
    "Bcolor": "188",
    "Y": 46,
    "L": 72.8723754882813,
    "a": 5.22200965881348,
    "b": -5.74311256408691,
    "C": 7.76226282119751,
    "h": 312.279144287109,
    "CMY_C": 0.27864372730255,
    "CMY_M": 0.30871093273163,
    "CMY_Y": 0.26294767856598,
    "CMYK_C": 0.02129570581019,
    "CMYK_M": 0.06208955869079,
    "CMYK_Y": 0,
    "CMYK_K": 0.26294767856598
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34115",
    "Farbtonhilfsbezeichnung": "34115",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "202",
    "Bcolor": "207",
    "Y": 61,
    "L": 81.9437713623047,
    "a": 3.91441488265991,
    "b": -2.52924346923828,
    "C": 4.66044187545776,
    "h": 327.132049560547,
    "CMY_C": 0.17940998077393,
    "CMY_M": 0.20900839567184,
    "CMY_Y": 0.18835663795471,
    "CMYK_C": 0,
    "CMYK_M": 0.03606967628002,
    "CMYK_Y": 0.01090271305293,
    "CMYK_K": 0.17940998077393
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34116",
    "Farbtonhilfsbezeichnung": "34116",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "213",
    "Bcolor": "214",
    "Y": 68,
    "L": 85.8273315429688,
    "a": 2.90541791915894,
    "b": -0.63425308465958,
    "C": 2.97384095191956,
    "h": 347.685516357422,
    "CMY_C": 0.13805973529816,
    "CMY_M": 0.16465121507645,
    "CMY_Y": 0.15992599725723,
    "CMYK_C": 0,
    "CMYK_M": 0.03085072152317,
    "CMYK_Y": 0.02536865137517,
    "CMYK_K": 0.13805973529816
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34120",
    "Farbtonhilfsbezeichnung": "34120",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "117",
    "Bcolor": "132",
    "Y": 19,
    "L": 49.9878768920898,
    "a": 4.57048463821411,
    "b": -8.29488754272461,
    "C": 9.47071743011475,
    "h": 298.854766845703,
    "CMY_C": 0.5284081697464,
    "CMY_M": 0.54099041223526,
    "CMY_Y": 0.48258835077286,
    "CMYK_C": 0.08855583518744,
    "CMYK_M": 0.11287349462509,
    "CMYK_Y": 0,
    "CMYK_K": 0.48258835077286
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34121",
    "Farbtonhilfsbezeichnung": "34121",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "135",
    "Bcolor": "149",
    "Y": 26,
    "L": 57.169792175293,
    "a": 4.68701505661011,
    "b": -7.34510564804077,
    "C": 8.71313285827637,
    "h": 302.542510986328,
    "CMY_C": 0.45211166143417,
    "CMY_M": 0.4698314666748,
    "CMY_Y": 0.41618847846985,
    "CMYK_C": 0.06153215840459,
    "CMYK_M": 0.09188408404589,
    "CMYK_Y": 0,
    "CMYK_K": 0.41618847846985
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34122",
    "Farbtonhilfsbezeichnung": "34122",
    "Farbtonklasse": "01",
    "Rcolor": "161",
    "Gcolor": "156",
    "Bcolor": "167",
    "Y": 35,
    "L": 65.1651306152344,
    "a": 4.19140768051147,
    "b": -5.88451242446899,
    "C": 7.22463750839233,
    "h": 305.46142578125,
    "CMY_C": 0.36829543113708,
    "CMY_M": 0.38718980550766,
    "CMY_Y": 0.34351456165314,
    "CMYK_C": 0.03774778172374,
    "CMYK_M": 0.06652888655663,
    "CMYK_Y": 0,
    "CMYK_K": 0.34351456165314
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34123",
    "Farbtonhilfsbezeichnung": "34123",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "178",
    "Bcolor": "186",
    "Y": 47,
    "L": 73.2267837524414,
    "a": 4.02222442626953,
    "b": -4.32409000396729,
    "C": 5.90559434890747,
    "h": 312.928649902344,
    "CMY_C": 0.27903532981873,
    "CMY_M": 0.30253583192825,
    "CMY_Y": 0.26934015750885,
    "CMYK_C": 0.01326906401664,
    "CMYK_M": 0.04543245956302,
    "CMYK_Y": 0,
    "CMYK_K": 0.26934015750885
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34124",
    "Farbtonhilfsbezeichnung": "34124",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "195",
    "Bcolor": "199",
    "Y": 57,
    "L": 79.5274963378906,
    "a": 3.05872917175293,
    "b": -1.92963802814484,
    "C": 3.61653518676758,
    "h": 327.753692626953,
    "CMY_C": 0.21030288934708,
    "CMY_M": 0.23336952924728,
    "CMY_Y": 0.21896141767502,
    "CMYK_C": 0,
    "CMYK_M": 0.02920947782695,
    "CMYK_Y": 0.01096436660737,
    "CMYK_K": 0.21030288934708
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34130",
    "Farbtonhilfsbezeichnung": "34130",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "91",
    "Bcolor": "94",
    "Y": 11,
    "L": 39.3327941894531,
    "a": 2.8207106590271,
    "b": -1.52920258045197,
    "C": 3.20856189727783,
    "h": 331.536376953125,
    "CMY_C": 0.62241685390472,
    "CMY_M": 0.64189016819,
    "CMY_Y": 0.62982928752899,
    "CMYK_C": 0,
    "CMYK_M": 0.05157357826829,
    "CMYK_Y": 0.019631261006,
    "CMYK_K": 0.62241685390472
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34131",
    "Farbtonhilfsbezeichnung": "34131",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "106",
    "Bcolor": "109",
    "Y": 16,
    "L": 45.4148406982422,
    "a": 2.85599970817566,
    "b": -1.61067426204681,
    "C": 3.27887272834778,
    "h": 330.578674316406,
    "CMY_C": 0.56378626823425,
    "CMY_M": 0.58380317687988,
    "CMY_Y": 0.57122081518173,
    "CMYK_C": 0,
    "CMYK_M": 0.04588784649968,
    "CMYK_Y": 0.01704335771501,
    "CMYK_K": 0.56378626823425
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34132",
    "Farbtonhilfsbezeichnung": "34132",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "126",
    "Bcolor": "129",
    "Y": 22,
    "L": 53.2100524902344,
    "a": 2.23652768135071,
    "b": -1.93084323406219,
    "C": 2.95469307899475,
    "h": 319.195251464844,
    "CMY_C": 0.49189496040344,
    "CMY_M": 0.50570529699326,
    "CMY_Y": 0.49263602495193,
    "CMYK_C": 0,
    "CMYK_M": 0.02718008123338,
    "CMYK_Y": 0.00145848689135,
    "CMYK_K": 0.49189496040344
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34133",
    "Farbtonhilfsbezeichnung": "34133",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "142",
    "Bcolor": "145",
    "Y": 28,
    "L": 59.2420959472656,
    "a": 2.07176947593689,
    "b": -1.79783618450165,
    "C": 2.74307203292847,
    "h": 319.049255371094,
    "CMY_C": 0.43152499198914,
    "CMY_M": 0.44450682401657,
    "CMY_Y": 0.43280166387558,
    "CMYK_C": 0,
    "CMYK_M": 0.02283624000847,
    "CMYK_Y": 0.00224578357302,
    "CMYK_K": 0.43152499198914
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34134",
    "Farbtonhilfsbezeichnung": "34134",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "162",
    "Bcolor": "164",
    "Y": 38,
    "L": 66.9158554077148,
    "a": 1.80471515655518,
    "b": -1.59349846839905,
    "C": 2.40753698348999,
    "h": 318.556640625,
    "CMY_C": 0.35332584381104,
    "CMY_M": 0.36473286151886,
    "CMY_Y": 0.35524660348892,
    "CMYK_C": 0,
    "CMYK_M": 0.01763951405883,
    "CMYK_Y": 0.00297021260485,
    "CMYK_K": 0.35332584381104
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34135",
    "Farbtonhilfsbezeichnung": "34135",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "173",
    "Bcolor": "174",
    "Y": 43,
    "L": 70.8278121948242,
    "a": 1.62989246845245,
    "b": -1.25879919528961,
    "C": 2.05939912796021,
    "h": 322.320373535156,
    "CMY_C": 0.31230050325394,
    "CMY_M": 0.32330727577209,
    "CMY_Y": 0.31665015220642,
    "CMYK_C": 0,
    "CMYK_M": 0.01600520685315,
    "CMYK_Y": 0.00632492685691,
    "CMYK_K": 0.31230050325394
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34136",
    "Farbtonhilfsbezeichnung": "34136",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "192",
    "Bcolor": "192",
    "Y": 54,
    "L": 77.9476547241211,
    "a": 1.7399320602417,
    "b": -0.29041996598244,
    "C": 1.76400315761566,
    "h": 350.523864746094,
    "CMY_C": 0.23203247785568,
    "CMY_M": 0.2478039264679,
    "CMY_Y": 0.24788784980774,
    "CMYK_C": 0,
    "CMYK_M": 0.02053660899401,
    "CMYK_Y": 0.02064588852227,
    "CMYK_K": 0.23203247785568
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34137",
    "Farbtonhilfsbezeichnung": "34137",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "207",
    "Bcolor": "206",
    "Y": 63,
    "L": 83.486946105957,
    "a": 1.07904660701752,
    "b": 0.50123959779739,
    "C": 1.18978261947632,
    "h": 24.9158496856689,
    "CMY_C": 0.17412889003754,
    "CMY_M": 0.18630892038345,
    "CMY_Y": 0.19395172595978,
    "CMYK_C": 0,
    "CMYK_M": 0.01474810112268,
    "CMYK_Y": 0.02400233596563,
    "CMYK_K": 0.17412889003754
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34138",
    "Farbtonhilfsbezeichnung": "34138",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 71,
    "L": 87.5952529907227,
    "a": 0.66489464044571,
    "b": 1.80255353450775,
    "C": 1.921271443367,
    "h": 69.7528686523438,
    "CMY_C": 0.12773233652115,
    "CMY_M": 0.14051330089569,
    "CMY_Y": 0.15874576568604,
    "CMYK_C": 0,
    "CMYK_M": 0.01465257164091,
    "CMYK_Y": 0.0355549454689,
    "CMYK_K": 0.12773233652115
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34140",
    "Farbtonhilfsbezeichnung": "34140",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "90",
    "Bcolor": "108",
    "Y": 11,
    "L": 39.4111709594727,
    "a": 6.46005344390869,
    "b": -9.92277812957764,
    "C": 11.8403472900391,
    "h": 303.065460205078,
    "CMY_C": 0.6237685084343,
    "CMY_M": 0.64660835266113,
    "CMY_Y": 0.57603621482849,
    "CMYK_C": 0.11258578300476,
    "CMYK_M": 0.16645793616772,
    "CMYK_Y": 0,
    "CMYK_K": 0.57603621482849
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34141",
    "Farbtonhilfsbezeichnung": "34141",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "69",
    "Bcolor": "78",
    "Y": 7,
    "L": 30.7257194519043,
    "a": 6.16856622695923,
    "b": -4.01581811904907,
    "C": 7.36057090759277,
    "h": 326.935333251953,
    "CMY_C": 0.68881440162659,
    "CMY_M": 0.72775816917419,
    "CMY_Y": 0.69404631853104,
    "CMYK_C": 0,
    "CMYK_M": 0.12514643371105,
    "CMYK_Y": 0.01681284978986,
    "CMYK_K": 0.68881440162659
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34200",
    "Farbtonhilfsbezeichnung": "34200",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "82",
    "Bcolor": "107",
    "Y": 10,
    "L": 36.1282005310059,
    "a": 6.96418714523315,
    "b": -14.6098337173462,
    "C": 16.1847820281982,
    "h": 295.486114501953,
    "CMY_C": 0.66857588291168,
    "CMY_M": 0.67686879634857,
    "CMY_Y": 0.57846510410309,
    "CMYK_C": 0.21376825869083,
    "CMYK_M": 0.23344139754772,
    "CMYK_Y": 0,
    "CMYK_K": 0.57846510410309
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34201",
    "Farbtonhilfsbezeichnung": "34201",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "110",
    "Bcolor": "138",
    "Y": 17,
    "L": 47.3376274108887,
    "a": 6.50105619430542,
    "b": -15.7971601486206,
    "C": 17.0825634002686,
    "h": 292.368804931641,
    "CMY_C": 0.56868624687195,
    "CMY_M": 0.56886196136475,
    "CMY_Y": 0.4600265622139,
    "CMYK_C": 0.20123153924942,
    "CMYK_M": 0.20155695080757,
    "CMYK_Y": 0,
    "CMYK_K": 0.4600265622139
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34202",
    "Farbtonhilfsbezeichnung": "34202",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "128",
    "Bcolor": "155",
    "Y": 23,
    "L": 54.3460426330566,
    "a": 5.86453819274902,
    "b": -15.3773574829102,
    "C": 16.4577007293701,
    "h": 290.875610351563,
    "CMY_C": 0.5019690990448,
    "CMY_M": 0.49836266040802,
    "CMY_Y": 0.39125061035156,
    "CMYK_C": 0.18187859654427,
    "CMYK_M": 0.17595426738262,
    "CMYK_Y": 0,
    "CMYK_K": 0.39125061035156
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34203",
    "Farbtonhilfsbezeichnung": "34203",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "158",
    "Bcolor": "181",
    "Y": 36,
    "L": 65.749153137207,
    "a": 4.6057276725769,
    "b": -12.6232481002808,
    "C": 13.4372291564941,
    "h": 290.045043945313,
    "CMY_C": 0.38374131917953,
    "CMY_M": 0.37998896837234,
    "CMY_Y": 0.29073637723923,
    "CMYK_C": 0.13112887740135,
    "CMYK_M": 0.12583838403225,
    "CMYK_Y": 0,
    "CMYK_K": 0.29073637723923
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34204",
    "Farbtonhilfsbezeichnung": "34204",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "173",
    "Bcolor": "192",
    "Y": 44,
    "L": 71.0650939941406,
    "a": 4.03372716903687,
    "b": -10.9910688400269,
    "C": 11.7078838348389,
    "h": 290.153167724609,
    "CMY_C": 0.32600498199463,
    "CMY_M": 0.32343935966492,
    "CMY_Y": 0.24546766281128,
    "CMYK_C": 0.10673806071281,
    "CMYK_M": 0.10333777964115,
    "CMYK_Y": 0,
    "CMYK_K": 0.24546766281128
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34205",
    "Farbtonhilfsbezeichnung": "34205",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "192",
    "Bcolor": "206",
    "Y": 55,
    "L": 77.9947357177734,
    "a": 3.14760088920593,
    "b": -8.02288627624512,
    "C": 8.61824226379395,
    "h": 291.421447753906,
    "CMY_C": 0.24767857789993,
    "CMY_M": 0.24831157922745,
    "CMY_Y": 0.19182103872299,
    "CMYK_C": 0.06911531090736,
    "CMYK_M": 0.06989855319262,
    "CMYK_Y": 0,
    "CMYK_K": 0.19182103872299
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34206",
    "Farbtonhilfsbezeichnung": "34206",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "202",
    "Bcolor": "212",
    "Y": 60,
    "L": 81.5315017700195,
    "a": 2.47595930099487,
    "b": -5.99453067779541,
    "C": 6.48573589324951,
    "h": 292.442413330078,
    "CMY_C": 0.20717793703079,
    "CMY_M": 0.20903944969177,
    "CMY_Y": 0.16797769069672,
    "CMYK_C": 0.0471144169569,
    "CMYK_M": 0.04935175180435,
    "CMYK_Y": 0,
    "CMYK_K": 0.16797769069672
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34207",
    "Farbtonhilfsbezeichnung": "34207",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "214",
    "Bcolor": "220",
    "Y": 69,
    "L": 85.8322830200195,
    "a": 1.57015085220337,
    "b": -3.60763740539551,
    "C": 3.9345166683197,
    "h": 293.520111083984,
    "CMY_C": 0.15865641832352,
    "CMY_M": 0.1605418920517,
    "CMY_Y": 0.1383239030838,
    "CMYK_C": 0.02359647117555,
    "CMYK_M": 0.0257846172899,
    "CMYK_Y": 0,
    "CMYK_K": 0.1383239030838
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34208",
    "Farbtonhilfsbezeichnung": "34208",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "224",
    "Bcolor": "225",
    "Y": 76,
    "L": 89.4841766357422,
    "a": 1.05777323246002,
    "b": -0.90933084487915,
    "C": 1.39490747451782,
    "h": 319.315490722656,
    "CMY_C": 0.11285316944122,
    "CMY_M": 0.11974453926086,
    "CMY_Y": 0.11797511577606,
    "CMYK_C": 0,
    "CMYK_M": 0.00776801491156,
    "CMYK_Y": 0.00577350473031,
    "CMYK_K": 0.11285316944122
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34209",
    "Farbtonhilfsbezeichnung": "34209",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 81,
    "L": 92.0885696411133,
    "a": -0.21290329098701,
    "b": 0.65683615207672,
    "C": 0.69047921895981,
    "h": 107.95930480957,
    "CMY_C": 0.08849537372589,
    "CMY_M": 0.08815681934357,
    "CMY_Y": 0.10093569755554,
    "CMYK_C": 0.00037128574331,
    "CMYK_M": 0,
    "CMYK_Y": 0.01401433721185,
    "CMYK_K": 0.08815681934357
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34210",
    "Farbtonhilfsbezeichnung": "34210",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "101",
    "Bcolor": "119",
    "Y": 14,
    "L": 43.5175933837891,
    "a": 5.474778175354,
    "b": -10.2746963500977,
    "C": 11.6422758102417,
    "h": 298.050506591797,
    "CMY_C": 0.59235548973083,
    "CMY_M": 0.60530424118042,
    "CMY_Y": 0.53386664390564,
    "CMYK_C": 0.12547664344311,
    "CMYK_M": 0.15325570106506,
    "CMYK_Y": 0,
    "CMYK_K": 0.53386664390564
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34211",
    "Farbtonhilfsbezeichnung": "34211",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "125",
    "Bcolor": "146",
    "Y": 22,
    "L": 53.0688018798828,
    "a": 5.2589373588562,
    "b": -11.6681823730469,
    "C": 12.7985506057739,
    "h": 294.261444091797,
    "CMY_C": 0.50486636161804,
    "CMY_M": 0.51095974445343,
    "CMY_Y": 0.4291228055954,
    "CMYK_C": 0.1326792538166,
    "CMYK_M": 0.14335297048092,
    "CMYK_Y": 0,
    "CMYK_K": 0.4291228055954
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34212",
    "Farbtonhilfsbezeichnung": "34212",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "142",
    "Bcolor": "159",
    "Y": 29,
    "L": 59.5872421264648,
    "a": 4.68374729156494,
    "b": -9.79458332061768,
    "C": 10.8568572998047,
    "h": 295.557006835938,
    "CMY_C": 0.43613785505295,
    "CMY_M": 0.44453108310699,
    "CMY_Y": 0.3747478723526,
    "CMYK_C": 0.09818436205387,
    "CMYK_M": 0.11160811036825,
    "CMYK_Y": 0,
    "CMYK_K": 0.3747478723526
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34213",
    "Farbtonhilfsbezeichnung": "34213",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "170",
    "Bcolor": "184",
    "Y": 42,
    "L": 70.070068359375,
    "a": 3.28929400444031,
    "b": -8.09393978118896,
    "C": 8.73677921295166,
    "h": 292.116333007813,
    "CMY_C": 0.33143699169159,
    "CMY_M": 0.33312153816223,
    "CMY_Y": 0.27652281522751,
    "CMYK_C": 0.07590311765671,
    "CMYK_M": 0.07823152095079,
    "CMYK_Y": 0,
    "CMYK_K": 0.27652281522751
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34214",
    "Farbtonhilfsbezeichnung": "34214",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "187",
    "Bcolor": "197",
    "Y": 51,
    "L": 76.2501754760742,
    "a": 2.86938738822937,
    "b": -5.45194053649902,
    "C": 6.16092824935913,
    "h": 297.758087158203,
    "CMY_C": 0.25931143760681,
    "CMY_M": 0.26720362901688,
    "CMY_Y": 0.22909355163574,
    "CMYK_C": 0.03919786214828,
    "CMYK_M": 0.04943541064858,
    "CMYK_Y": 0,
    "CMYK_K": 0.22909355163574
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34215",
    "Farbtonhilfsbezeichnung": "34215",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "205",
    "Bcolor": "209",
    "Y": 63,
    "L": 82.8465042114258,
    "a": 2.11573219299316,
    "b": -2.22722506523132,
    "C": 3.07194638252258,
    "h": 313.529418945313,
    "CMY_C": 0.18233889341354,
    "CMY_M": 0.19497215747833,
    "CMY_Y": 0.18096405267715,
    "CMYK_C": 0.00167860859074,
    "CMYK_M": 0.01710316166282,
    "CMYK_Y": 0,
    "CMYK_K": 0.18096405267715
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34216",
    "Farbtonhilfsbezeichnung": "34216",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "220",
    "Bcolor": "219",
    "Y": 72,
    "L": 88.0348739624023,
    "a": 1.40782654285431,
    "b": 0.1665263324976,
    "C": 1.41764116287231,
    "h": 6.74594926834106,
    "CMY_C": 0.12253314256668,
    "CMY_M": 0.13695245981216,
    "CMY_Y": 0.14180469512939,
    "CMYK_C": 0,
    "CMYK_M": 0.01643289066851,
    "CMYK_Y": 0.02196271345019,
    "CMYK_K": 0.12253314256668
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34220",
    "Farbtonhilfsbezeichnung": "34220",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "133",
    "Bcolor": "149",
    "Y": 25,
    "L": 56.0671882629395,
    "a": 4.55721569061279,
    "b": -9.23475360870361,
    "C": 10.2980041503906,
    "h": 296.265655517578,
    "CMY_C": 0.47090125083923,
    "CMY_M": 0.48009622097015,
    "CMY_Y": 0.4147983789444,
    "CMYK_C": 0.09586930274963,
    "CMYK_M": 0.111581787467,
    "CMYK_Y": 0,
    "CMYK_K": 0.4147983789444
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34221",
    "Farbtonhilfsbezeichnung": "34221",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "154",
    "Bcolor": "168",
    "Y": 34,
    "L": 64.2906799316406,
    "a": 3.98896646499634,
    "b": -7.78098487854004,
    "C": 8.74388790130615,
    "h": 297.142211914063,
    "CMY_C": 0.38553720712662,
    "CMY_M": 0.3952242732048,
    "CMY_Y": 0.33961021900177,
    "CMYK_C": 0.06954527646303,
    "CMYK_M": 0.08421398699284,
    "CMYK_Y": 0,
    "CMYK_K": 0.33961021900177
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34222",
    "Farbtonhilfsbezeichnung": "34222",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "172",
    "Bcolor": "183",
    "Y": 43,
    "L": 70.8818664550781,
    "a": 2.7590663433075,
    "b": -5.87852764129639,
    "C": 6.49380731582642,
    "h": 295.142852783203,
    "CMY_C": 0.31894534826279,
    "CMY_M": 0.32399618625641,
    "CMY_Y": 0.2834969162941,
    "CMYK_C": 0.04947422072291,
    "CMYK_M": 0.0565235093236,
    "CMYK_Y": 0,
    "CMYK_K": 0.2834969162941
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34230",
    "Farbtonhilfsbezeichnung": "34230",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "91",
    "Bcolor": "101",
    "Y": 11,
    "L": 38.8293228149414,
    "a": 2.53935027122498,
    "b": -6.60513639450073,
    "C": 7.07644891738892,
    "h": 291.029296875,
    "CMY_C": 0.64496397972107,
    "CMY_M": 0.64468348026276,
    "CMY_Y": 0.60283613204956,
    "CMYK_C": 0.10607170313597,
    "CMYK_M": 0.10536544770002,
    "CMYK_Y": 0,
    "CMYK_K": 0.60283613204956
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34231",
    "Farbtonhilfsbezeichnung": "34231",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "113",
    "Bcolor": "126",
    "Y": 18,
    "L": 47.8508949279785,
    "a": 2.64591693878174,
    "b": -8.09139442443848,
    "C": 8.51302146911621,
    "h": 288.107940673828,
    "CMY_C": 0.56263494491577,
    "CMY_M": 0.55783665180206,
    "CMY_Y": 0.50543332099915,
    "CMYK_C": 0.11566008627415,
    "CMYK_M": 0.1059580668807,
    "CMYK_Y": 0,
    "CMYK_K": 0.50543332099915
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34232",
    "Farbtonhilfsbezeichnung": "34232",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "134",
    "Bcolor": "146",
    "Y": 25,
    "L": 56.1612854003906,
    "a": 2.17060971260071,
    "b": -7.32735204696655,
    "C": 7.64209604263306,
    "h": 286.501068115234,
    "CMY_C": 0.48078346252441,
    "CMY_M": 0.47441411018372,
    "CMY_Y": 0.42689490318298,
    "CMYK_C": 0.09402910619974,
    "CMYK_M": 0.08291534334421,
    "CMYK_Y": 0,
    "CMYK_K": 0.42689490318298
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34233",
    "Farbtonhilfsbezeichnung": "34233",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "148",
    "Bcolor": "158",
    "Y": 31,
    "L": 61.4570579528809,
    "a": 2.33649253845215,
    "b": -6.28580331802368,
    "C": 6.70600652694702,
    "h": 290.390563964844,
    "CMY_C": 0.42191749811172,
    "CMY_M": 0.42115646600723,
    "CMY_Y": 0.37953561544418,
    "CMYK_C": 0.06830671429634,
    "CMYK_M": 0.06708016246557,
    "CMYK_Y": 0,
    "CMYK_K": 0.37953561544418
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34234",
    "Farbtonhilfsbezeichnung": "34234",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "171",
    "Bcolor": "181",
    "Y": 42,
    "L": 70.1180572509766,
    "a": 1.55461323261261,
    "b": -5.85234785079956,
    "C": 6.05531167984009,
    "h": 284.876434326172,
    "CMY_C": 0.33615916967392,
    "CMY_M": 0.32931393384933,
    "CMY_Y": 0.29193121194839,
    "CMYK_C": 0.06246279925108,
    "CMYK_M": 0.05279532447457,
    "CMYK_Y": 0,
    "CMYK_K": 0.29193121194839
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34235",
    "Farbtonhilfsbezeichnung": "34235",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "196",
    "Bcolor": "200",
    "Y": 57,
    "L": 79.5817565917969,
    "a": 2.01043820381165,
    "b": -2.52092719078064,
    "C": 3.2244279384613,
    "h": 308.572357177734,
    "CMY_C": 0.21974277496338,
    "CMY_M": 0.23014169931412,
    "CMY_Y": 0.21426194906235,
    "CMYK_C": 0.00697538582608,
    "CMYK_M": 0.02020997926593,
    "CMYK_Y": 0,
    "CMYK_K": 0.21426194906235
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34236",
    "Farbtonhilfsbezeichnung": "34236",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "203",
    "Bcolor": "205",
    "Y": 61,
    "L": 81.8393020629883,
    "a": 1.23740351200104,
    "b": -1.56770384311676,
    "C": 1.99721372127533,
    "h": 308.284362792969,
    "CMY_C": 0.19789642095566,
    "CMY_M": 0.20408225059509,
    "CMY_Y": 0.19680368900299,
    "CMYK_C": 0.00136047927663,
    "CMYK_M": 0.00906199589372,
    "CMYK_Y": 0,
    "CMYK_K": 0.19680368900299
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34237",
    "Farbtonhilfsbezeichnung": "34237",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 71,
    "L": 87.368782043457,
    "a": 0.5041326880455,
    "b": 1.07399463653564,
    "C": 1.18642914295197,
    "h": 64.8546524047852,
    "CMY_C": 0.13391363620758,
    "CMY_M": 0.14243113994598,
    "CMY_Y": 0.15589797496796,
    "CMYK_C": 0,
    "CMYK_M": 0.00983447395265,
    "CMYK_Y": 0.0253835413605,
    "CMYK_K": 0.13391363620758
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34240",
    "Farbtonhilfsbezeichnung": "34240",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "110",
    "Bcolor": "128",
    "Y": 17,
    "L": 47.0345916748047,
    "a": 4.64856338500977,
    "b": -10.2207098007202,
    "C": 11.2281808853149,
    "h": 294.456909179688,
    "CMY_C": 0.56380116939545,
    "CMY_M": 0.56950962543488,
    "CMY_Y": 0.49950271844864,
    "CMYK_C": 0.12846912443638,
    "CMYK_M": 0.13987469673157,
    "CMYK_Y": 0,
    "CMYK_K": 0.49950271844864
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34241",
    "Farbtonhilfsbezeichnung": "34241",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "93",
    "Bcolor": "107",
    "Y": 12,
    "L": 39.8875694274902,
    "a": 3.90318584442139,
    "b": -8.66964721679688,
    "C": 9.50776767730713,
    "h": 294.237884521484,
    "CMY_C": 0.63255095481873,
    "CMY_M": 0.63696539402008,
    "CMY_Y": 0.57957446575165,
    "CMYK_C": 0.12600682675838,
    "CMYK_M": 0.13650676608086,
    "CMYK_Y": 0,
    "CMYK_K": 0.57957446575165
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34242",
    "Farbtonhilfsbezeichnung": "34242",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "88",
    "Bcolor": "101",
    "Y": 11,
    "L": 37.929988861084,
    "a": 2.82414817810059,
    "b": -7.55875539779663,
    "C": 8.06911373138428,
    "h": 290.486999511719,
    "CMY_C": 0.6547167301178,
    "CMY_M": 0.65345335006714,
    "CMY_Y": 0.60543024539948,
    "CMYK_C": 0.12491197139025,
    "CMYK_M": 0.12171004712582,
    "CMYK_Y": 0,
    "CMYK_K": 0.60543024539948
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34243",
    "Farbtonhilfsbezeichnung": "34243",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "80",
    "Bcolor": "87",
    "Y": 9,
    "L": 33.9690284729004,
    "a": 1.23677206039429,
    "b": -4.75091361999512,
    "C": 4.909255027771,
    "h": 284.591552734375,
    "CMY_C": 0.69303566217422,
    "CMY_M": 0.68781077861786,
    "CMY_Y": 0.66024321317673,
    "CMYK_C": 0.09651742130518,
    "CMYK_M": 0.08113911747932,
    "CMYK_Y": 0,
    "CMYK_K": 0.66024321317673
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34300",
    "Farbtonhilfsbezeichnung": "34300",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "91",
    "Bcolor": "122",
    "Y": 10,
    "L": 38.5587348937988,
    "a": 3.45796298980713,
    "b": -20.2284488677979,
    "C": 20.5218830108643,
    "h": 279.70068359375,
    "CMY_C": 0.69808495044708,
    "CMY_M": 0.64477336406708,
    "CMY_Y": 0.51976758241653,
    "CMYK_C": 0.3713147342205,
    "CMYK_M": 0.26030266284943,
    "CMYK_Y": 0,
    "CMYK_K": 0.51976758241653
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34301",
    "Farbtonhilfsbezeichnung": "34301",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "119",
    "Bcolor": "153",
    "Y": 19,
    "L": 49.6460151672363,
    "a": 2.08198046684265,
    "b": -21.2625865936279,
    "C": 21.3642749786377,
    "h": 275.592437744141,
    "CMY_C": 0.60686826705933,
    "CMY_M": 0.53471672534943,
    "CMY_Y": 0.40102565288544,
    "CMYK_C": 0.34365847706795,
    "CMYK_M": 0.22319999337196,
    "CMYK_Y": 0,
    "CMYK_K": 0.40102565288544
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34302",
    "Farbtonhilfsbezeichnung": "34302",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "136",
    "Bcolor": "169",
    "Y": 25,
    "L": 56.3913040161133,
    "a": 1.49095070362091,
    "b": -20.3179702758789,
    "C": 20.3726005554199,
    "h": 274.196899414063,
    "CMY_C": 0.53929758071899,
    "CMY_M": 0.46643245220184,
    "CMY_Y": 0.3371998667717,
    "CMYK_C": 0.30491501092911,
    "CMYK_M": 0.19497972726822,
    "CMYK_Y": 0,
    "CMYK_K": 0.3371998667717
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34303",
    "Farbtonhilfsbezeichnung": "34303",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "165",
    "Bcolor": "192",
    "Y": 38,
    "L": 67.3016357421875,
    "a": 0.53197264671326,
    "b": -16.3220043182373,
    "C": 16.3306713104248,
    "h": 271.866729736328,
    "CMY_C": 0.41620355844498,
    "CMY_M": 0.35335338115692,
    "CMY_Y": 0.24891293048859,
    "CMYK_C": 0.22273133695126,
    "CMYK_M": 0.13905239105225,
    "CMYK_Y": 0,
    "CMYK_K": 0.24891293048859
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34304",
    "Farbtonhilfsbezeichnung": "34304",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "180",
    "Bcolor": "203",
    "Y": 46,
    "L": 72.9444122314453,
    "a": 0.0047270199284,
    "b": -14.0691242218018,
    "C": 14.0691251754761,
    "h": 270.019256591797,
    "CMY_C": 0.35136353969574,
    "CMY_M": 0.29329198598862,
    "CMY_Y": 0.20393919944763,
    "CMYK_C": 0.18519231677055,
    "CMYK_M": 0.11224366724491,
    "CMYK_Y": 0,
    "CMYK_K": 0.20393919944763
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34305",
    "Farbtonhilfsbezeichnung": "34305",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "198",
    "Bcolor": "214",
    "Y": 57,
    "L": 79.4670639038086,
    "a": -0.38370451331139,
    "b": -10.0065889358521,
    "C": 10.0139427185059,
    "h": 267.804046630859,
    "CMY_C": 0.2679455280304,
    "CMY_M": 0.22358757257462,
    "CMY_Y": 0.16195374727249,
    "CMYK_C": 0.12647485733032,
    "CMYK_M": 0.07354465872049,
    "CMYK_Y": 0,
    "CMYK_K": 0.16195374727249
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34306",
    "Farbtonhilfsbezeichnung": "34306",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "207",
    "Bcolor": "219",
    "Y": 62,
    "L": 82.7915954589844,
    "a": -0.60332435369492,
    "b": -7.64404582977295,
    "C": 7.66781806945801,
    "h": 265.487152099609,
    "CMY_C": 0.22441047430038,
    "CMY_M": 0.18760627508163,
    "CMY_Y": 0.14261478185654,
    "CMYK_C": 0.09540133178234,
    "CMYK_M": 0.05247523635626,
    "CMYK_Y": 0,
    "CMYK_K": 0.14261478185654
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34307",
    "Farbtonhilfsbezeichnung": "34307",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "219",
    "Bcolor": "224",
    "Y": 70,
    "L": 86.9189834594727,
    "a": -0.77154523134232,
    "b": -4.43423461914063,
    "C": 4.50085735321045,
    "h": 260.129486083984,
    "CMY_C": 0.16845786571503,
    "CMY_M": 0.14281123876572,
    "CMY_Y": 0.12061202526093,
    "CMYK_C": 0.05440811440349,
    "CMYK_M": 0.02524393610656,
    "CMYK_Y": 0,
    "CMYK_K": 0.12061202526093
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34308",
    "Farbtonhilfsbezeichnung": "34308",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "228",
    "Bcolor": "229",
    "Y": 77,
    "L": 90.133056640625,
    "a": -1.49024093151093,
    "b": -1.9977480173111,
    "C": 2.49235129356384,
    "h": 233.278518676758,
    "CMY_C": 0.12986922264099,
    "CMY_M": 0.1061989068985,
    "CMY_Y": 0.1031112074852,
    "CMYK_C": 0.02983426116407,
    "CMYK_M": 0.00344267813489,
    "CMYK_Y": 0,
    "CMYK_K": 0.1031112074852
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34309",
    "Farbtonhilfsbezeichnung": "34309",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 82,
    "L": 92.4751052856445,
    "a": -1.53293061256409,
    "b": 0.85516023635864,
    "C": 1.7553277015686,
    "h": 150.844619750977,
    "CMY_C": 0.09403318166733,
    "CMY_M": 0.08076882362366,
    "CMY_Y": 0.09830856323242,
    "CMYK_C": 0.01442983932793,
    "CMYK_M": 0,
    "CMYK_Y": 0.01908087916672,
    "CMYK_K": 0.08076882362366
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34310",
    "Farbtonhilfsbezeichnung": "34310",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "133",
    "Bcolor": "158",
    "Y": 24,
    "L": 55.2209892272949,
    "a": 0.33534011244774,
    "b": -15.7210836410523,
    "C": 15.7246599197388,
    "h": 271.221954345703,
    "CMY_C": 0.53873550891876,
    "CMY_M": 0.47732573747635,
    "CMY_Y": 0.3804544210434,
    "CMYK_C": 0.25547933578491,
    "CMYK_M": 0.15635865926743,
    "CMYK_Y": 0,
    "CMYK_K": 0.3804544210434
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34311",
    "Farbtonhilfsbezeichnung": "34311",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "155",
    "Bcolor": "177",
    "Y": 33,
    "L": 63.4453201293945,
    "a": -0.00212974334136,
    "b": -14.0751733779907,
    "C": 14.0751733779907,
    "h": 269.991333007813,
    "CMY_C": 0.45056569576263,
    "CMY_M": 0.39308798313141,
    "CMY_Y": 0.30560970306396,
    "CMYK_C": 0.20875290036201,
    "CMYK_M": 0.12597854435444,
    "CMYK_Y": 0,
    "CMYK_K": 0.30560970306396
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34312",
    "Farbtonhilfsbezeichnung": "34312",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "174",
    "Bcolor": "193",
    "Y": 43,
    "L": 70.6768951416016,
    "a": -0.12718352675438,
    "b": -12.1483144760132,
    "C": 12.148980140686,
    "h": 269.400177001953,
    "CMY_C": 0.36814600229263,
    "CMY_M": 0.31769239902496,
    "CMY_Y": 0.24197298288345,
    "CMYK_C": 0.16644923388958,
    "CMYK_M": 0.09989012777805,
    "CMYK_Y": 0,
    "CMYK_K": 0.24197298288345
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34313",
    "Farbtonhilfsbezeichnung": "34313",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "188",
    "Bcolor": "204",
    "Y": 50,
    "L": 75.9674224853516,
    "a": -0.40268814563751,
    "b": -9.83714580535889,
    "C": 9.84538459777832,
    "h": 267.655883789063,
    "CMY_C": 0.30490839481354,
    "CMY_M": 0.26137280464172,
    "CMY_Y": 0.20128244161606,
    "CMYK_C": 0.12974041700363,
    "CMYK_M": 0.0752335563302,
    "CMYK_Y": 0,
    "CMYK_K": 0.20128244161606
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34314",
    "Farbtonhilfsbezeichnung": "34314",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "203",
    "Bcolor": "213",
    "Y": 60,
    "L": 81.2238693237305,
    "a": -0.52411317825317,
    "b": -7.08368015289307,
    "C": 7.10304307937622,
    "h": 265.768463134766,
    "CMY_C": 0.23858642578125,
    "CMY_M": 0.20507127046585,
    "CMY_Y": 0.16384208202362,
    "CMYK_C": 0.08939022570848,
    "CMYK_M": 0.04930789768696,
    "CMYK_Y": 0,
    "CMYK_K": 0.16384208202362
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34315",
    "Farbtonhilfsbezeichnung": "34315",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "211",
    "Bcolor": "218",
    "Y": 65,
    "L": 84.0643081665039,
    "a": -0.91321009397507,
    "b": -5.33075189590454,
    "C": 5.40840721130371,
    "h": 260.279022216797,
    "CMY_C": 0.20421189069748,
    "CMY_M": 0.17364782094955,
    "CMY_Y": 0.14549458026886,
    "CMYK_C": 0.06871496886015,
    "CMYK_M": 0.03294682502747,
    "CMYK_Y": 0,
    "CMYK_K": 0.14549458026886
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34320",
    "Farbtonhilfsbezeichnung": "34320",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "131",
    "Bcolor": "150",
    "Y": 23,
    "L": 54.4074859619141,
    "a": -0.43115755915642,
    "b": -12.3136386871338,
    "C": 12.3211851119995,
    "h": 267.99462890625,
    "CMY_C": 0.5380352139473,
    "CMY_M": 0.48497766256332,
    "CMY_Y": 0.41172873973846,
    "CMYK_C": 0.21470788121223,
    "CMYK_M": 0.12451555579901,
    "CMYK_Y": 0,
    "CMYK_K": 0.41172873973846
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34321",
    "Farbtonhilfsbezeichnung": "34321",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "159",
    "Bcolor": "175",
    "Y": 35,
    "L": 65.057731628418,
    "a": -0.68946838378906,
    "b": -10.4888916015625,
    "C": 10.5115280151367,
    "h": 266.239166259766,
    "CMY_C": 0.42438691854477,
    "CMY_M": 0.37596887350082,
    "CMY_Y": 0.31340527534485,
    "CMYK_C": 0.16164068877697,
    "CMYK_M": 0.09112158417702,
    "CMYK_Y": 0,
    "CMYK_K": 0.31340527534485
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34322",
    "Farbtonhilfsbezeichnung": "34322",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "189",
    "Bcolor": "198",
    "Y": 50,
    "L": 75.9985122680664,
    "a": -1.00503075122833,
    "b": -6.87851142883301,
    "C": 6.95154714584351,
    "h": 261.687255859375,
    "CMY_C": 0.29782694578171,
    "CMY_M": 0.26057857275009,
    "CMY_Y": 0.22211444377899,
    "CMYK_C": 0.09733115881681,
    "CMYK_M": 0.04944702982903,
    "CMYK_Y": 0,
    "CMYK_K": 0.22211444377899
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34323",
    "Farbtonhilfsbezeichnung": "34323",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "206",
    "Y": 59,
    "L": 80.7331161499023,
    "a": -1.14909315109253,
    "b": -4.14224767684937,
    "C": 4.29867792129517,
    "h": 254.495544433594,
    "CMY_C": 0.23785322904587,
    "CMY_M": 0.20985805988312,
    "CMY_Y": 0.19051510095596,
    "CMYK_C": 0.0584793202579,
    "CMYK_M": 0.02389539219439,
    "CMYK_Y": 0,
    "CMYK_K": 0.19051510095596
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34330",
    "Farbtonhilfsbezeichnung": "34330",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "99",
    "Bcolor": "111",
    "Y": 13,
    "L": 41.9878311157227,
    "a": 1.20123553276062,
    "b": -7.740065574646,
    "C": 7.83272504806519,
    "h": 278.821746826172,
    "CMY_C": 0.62851142883301,
    "CMY_M": 0.6116236448288,
    "CMY_Y": 0.56540763378143,
    "CMYK_C": 0.14520226418972,
    "CMYK_M": 0.10634335875511,
    "CMYK_Y": 0,
    "CMYK_K": 0.56540763378143
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34331",
    "Farbtonhilfsbezeichnung": "34331",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "110",
    "Bcolor": "123",
    "Y": 16,
    "L": 46.2673263549805,
    "a": 1.22874248027802,
    "b": -8.43864345550537,
    "C": 8.52763175964355,
    "h": 278.284545898438,
    "CMY_C": 0.58973705768585,
    "CMY_M": 0.57018661499023,
    "CMY_Y": 0.51901614665985,
    "CMYK_C": 0.14703385531902,
    "CMYK_M": 0.10638707876205,
    "CMYK_Y": 0,
    "CMYK_K": 0.51901614665985
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34332",
    "Farbtonhilfsbezeichnung": "34332",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "140",
    "Bcolor": "152",
    "Y": 27,
    "L": 58.2481956481934,
    "a": 1.37936758995056,
    "b": -7.6174693107605,
    "C": 7.74134969711304,
    "h": 280.263885498047,
    "CMY_C": 0.4666793346405,
    "CMY_M": 0.45144957304001,
    "CMY_Y": 0.40367579460144,
    "CMYK_C": 0.10565316677094,
    "CMYK_M": 0.08011376857758,
    "CMYK_Y": 0,
    "CMYK_K": 0.40367579460144
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34333",
    "Farbtonhilfsbezeichnung": "34333",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "157",
    "Bcolor": "168",
    "Y": 35,
    "L": 64.7975158691406,
    "a": 1.10527849197388,
    "b": -7.09923648834229,
    "C": 7.18476152420044,
    "h": 278.849334716797,
    "CMY_C": 0.39974409341812,
    "CMY_M": 0.38365638256073,
    "CMY_Y": 0.33934414386749,
    "CMYK_C": 0.09142422676086,
    "CMYK_M": 0.06707310676575,
    "CMYK_Y": 0,
    "CMYK_K": 0.33934414386749
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34334",
    "Farbtonhilfsbezeichnung": "34334",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "180",
    "Bcolor": "188",
    "Y": 46,
    "L": 73.2365112304688,
    "a": 0.8133133649826,
    "b": -5.40741920471191,
    "C": 5.4682412147522,
    "h": 278.553558349609,
    "CMY_C": 0.30730557441711,
    "CMY_M": 0.29469037055969,
    "CMY_Y": 0.26197999715805,
    "CMYK_C": 0.06141510605812,
    "CMYK_M": 0.04432179778814,
    "CMYK_Y": 0,
    "CMYK_K": 0.26197999715805
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34335",
    "Farbtonhilfsbezeichnung": "34335",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "191",
    "Bcolor": "198",
    "Y": 53,
    "L": 77.388542175293,
    "a": 0.65544247627258,
    "b": -4.34719276428223,
    "C": 4.39632701873779,
    "h": 278.574127197266,
    "CMY_C": 0.26035279035568,
    "CMY_M": 0.25015330314636,
    "CMY_Y": 0.22500044107437,
    "CMYK_C": 0.04561595991254,
    "CMYK_M": 0.03245532512665,
    "CMYK_Y": 0,
    "CMYK_K": 0.22500044107437
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34336",
    "Farbtonhilfsbezeichnung": "34336",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "206",
    "Bcolor": "208",
    "Y": 62,
    "L": 82.5391464233398,
    "a": 0.10827887803316,
    "b": -2.44753432273865,
    "C": 2.44992828369141,
    "h": 272.533111572266,
    "CMY_C": 0.2021496295929,
    "CMY_M": 0.19355922937393,
    "CMY_Y": 0.18297696113586,
    "CMYK_C": 0.02346649579704,
    "CMYK_M": 0.01295222714543,
    "CMYK_Y": 0,
    "CMYK_K": 0.18297696113586
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34337",
    "Farbtonhilfsbezeichnung": "34337",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "217",
    "Bcolor": "217",
    "Y": 70,
    "L": 86.3484878540039,
    "a": -0.45813393592834,
    "b": -1.28346109390259,
    "C": 1.36277627944946,
    "h": 250.355880737305,
    "CMY_C": 0.16082173585892,
    "CMY_M": 0.15076261758804,
    "CMY_Y": 0.14992666244507,
    "CMYK_C": 0.01281662750989,
    "CMYK_M": 0.00098339177202,
    "CMYK_Y": 0,
    "CMYK_K": 0.14992666244507
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34340",
    "Farbtonhilfsbezeichnung": "34340",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "87",
    "Bcolor": "107",
    "Y": 10,
    "L": 36.8350448608398,
    "a": 1.30980622768402,
    "b": -13.174861907959,
    "C": 13.2398099899292,
    "h": 275.677520751953,
    "CMY_C": 0.69788366556168,
    "CMY_M": 0.65892446041107,
    "CMY_Y": 0.58107084035873,
    "CMYK_C": 0.27883669734001,
    "CMYK_M": 0.18583957850933,
    "CMYK_Y": 0,
    "CMYK_K": 0.58107084035873
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34341",
    "Farbtonhilfsbezeichnung": "34341",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "88",
    "Bcolor": "100",
    "Y": 10,
    "L": 37.7422752380371,
    "a": 1.79981863498688,
    "b": -7.74203586578369,
    "C": 7.94848823547363,
    "h": 283.087310791016,
    "CMY_C": 0.66432547569275,
    "CMY_M": 0.65305399894714,
    "CMY_Y": 0.606181204319,
    "CMYK_C": 0.14764219522476,
    "CMYK_M": 0.11902122199535,
    "CMYK_Y": 0,
    "CMYK_K": 0.606181204319
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34400",
    "Farbtonhilfsbezeichnung": "34400",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "98",
    "Bcolor": "138",
    "Y": 12,
    "L": 40.4394798278809,
    "a": 0.00739803584293,
    "b": -27.0473690032959,
    "C": 27.0473709106445,
    "h": 270.015686035156,
    "CMY_C": 0.75666749477386,
    "CMY_M": 0.61748397350311,
    "CMY_Y": 0.45776176452637,
    "CMYK_C": 0.55124425888062,
    "CMYK_M": 0.29456093907356,
    "CMYK_Y": 0,
    "CMYK_K": 0.45776176452637
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34401",
    "Farbtonhilfsbezeichnung": "34401",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "128",
    "Bcolor": "168",
    "Y": 21,
    "L": 52.1891136169434,
    "a": -2.56328320503235,
    "b": -26.5970249176025,
    "C": 26.7202568054199,
    "h": 264.4951171875,
    "CMY_C": 0.65885925292969,
    "CMY_M": 0.49794489145279,
    "CMY_Y": 0.33948534727097,
    "CMYK_C": 0.48352280259132,
    "CMYK_M": 0.23990315198898,
    "CMYK_Y": 0,
    "CMYK_K": 0.33948534727097
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34402",
    "Farbtonhilfsbezeichnung": "34402",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "146",
    "Bcolor": "183",
    "Y": 28,
    "L": 58.9595909118652,
    "a": -3.17701196670532,
    "b": -24.6524238586426,
    "C": 24.856294631958,
    "h": 262.656646728516,
    "CMY_C": 0.58135735988617,
    "CMY_M": 0.4289333820343,
    "CMY_Y": 0.28100895881653,
    "CMYK_C": 0.41773593425751,
    "CMYK_M": 0.20573890209198,
    "CMYK_Y": 0,
    "CMYK_K": 0.28100895881653
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34403",
    "Farbtonhilfsbezeichnung": "34403",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "175",
    "Bcolor": "204",
    "Y": 42,
    "L": 69.9360427856445,
    "a": -3.91227459907532,
    "b": -19.0737171173096,
    "C": 19.4708137512207,
    "h": 258.408630371094,
    "CMY_C": 0.44151264429092,
    "CMY_M": 0.31500142812729,
    "CMY_Y": 0.20166325569153,
    "CMYK_C": 0.30043637752533,
    "CMYK_M": 0.14196787774563,
    "CMYK_Y": 0,
    "CMYK_K": 0.20166325569153
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34404",
    "Farbtonhilfsbezeichnung": "34404",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "188",
    "Bcolor": "212",
    "Y": 49,
    "L": 74.8090286254883,
    "a": -3.66447854042053,
    "b": -16.0882873535156,
    "C": 16.5003452301025,
    "h": 257.168487548828,
    "CMY_C": 0.37272781133652,
    "CMY_M": 0.26456695795059,
    "CMY_Y": 0.16970270872116,
    "CMYK_C": 0.24452097713947,
    "CMYK_M": 0.11425334960222,
    "CMYK_Y": 0,
    "CMYK_K": 0.16970270872116
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34405",
    "Farbtonhilfsbezeichnung": "34405",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "204",
    "Bcolor": "220",
    "Y": 59,
    "L": 80.8116836547852,
    "a": -3.83312630653381,
    "b": -11.4250049591065,
    "C": 12.0508756637573,
    "h": 251.453231811523,
    "CMY_C": 0.28863608837128,
    "CMY_M": 0.2007400393486,
    "CMY_Y": 0.13737690448761,
    "CMYK_C": 0.17534793913364,
    "CMYK_M": 0.07345402240753,
    "CMYK_Y": 0,
    "CMYK_K": 0.13737690448761
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34406",
    "Farbtonhilfsbezeichnung": "34406",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "211",
    "Bcolor": "222",
    "Y": 64,
    "L": 83.6429138183594,
    "a": -3.36097955703735,
    "b": -8.38329219818115,
    "C": 9.03193092346191,
    "h": 248.153457641602,
    "CMY_C": 0.24109625816345,
    "CMY_M": 0.17176216840744,
    "CMY_Y": 0.12821465730667,
    "CMYK_C": 0.12948325276375,
    "CMYK_M": 0.04995210468769,
    "CMYK_Y": 0,
    "CMYK_K": 0.12821465730667
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34407",
    "Farbtonhilfsbezeichnung": "34407",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "223",
    "Bcolor": "228",
    "Y": 72,
    "L": 87.7294006347656,
    "a": -3.41689300537109,
    "b": -5.46056652069092,
    "C": 6.44150161743164,
    "h": 237.964157104492,
    "CMY_C": 0.18526834249496,
    "CMY_M": 0.12743270397186,
    "CMY_Y": 0.10446053743362,
    "CMYK_C": 0.09023366123438,
    "CMYK_M": 0.02565176412463,
    "CMYK_Y": 0,
    "CMYK_K": 0.10446053743362
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34408",
    "Farbtonhilfsbezeichnung": "34408",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "229",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.1492004394531,
    "a": -2.90516114234924,
    "b": -2.66307163238525,
    "C": 3.94105458259583,
    "h": 222.510513305664,
    "CMY_C": 0.14368623495102,
    "CMY_M": 0.10253596305847,
    "CMY_Y": 0.09820371866226,
    "CMYK_C": 0.05043546482921,
    "CMYK_M": 0.00480401655659,
    "CMYK_Y": 0,
    "CMYK_K": 0.09820371866226
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34409",
    "Farbtonhilfsbezeichnung": "34409",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "235",
    "Bcolor": "231",
    "Y": 81,
    "L": 92.438850402832,
    "a": -2.2173535823822,
    "b": 0.05050636082888,
    "C": 2.217928647995,
    "h": 178.69514465332,
    "CMY_C": 0.10278588533401,
    "CMY_M": 0.07933926582336,
    "CMY_Y": 0.09282571077347,
    "CMYK_C": 0.02546716481447,
    "CMYK_M": 0,
    "CMYK_Y": 0.01464865915477,
    "CMYK_K": 0.07933926582336
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34410",
    "Farbtonhilfsbezeichnung": "34410",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "145",
    "Bcolor": "173",
    "Y": 27,
    "L": 58.242301940918,
    "a": -5.62798690795898,
    "b": -20.0936050415039,
    "C": 20.8668918609619,
    "h": 254.353057861328,
    "CMY_C": 0.58516120910645,
    "CMY_M": 0.43288159370422,
    "CMY_Y": 0.31990647315979,
    "CMYK_C": 0.39002683758736,
    "CMYK_M": 0.16611704230309,
    "CMYK_Y": 0,
    "CMYK_K": 0.31990647315979
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34411",
    "Farbtonhilfsbezeichnung": "34411",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "172",
    "Bcolor": "195",
    "Y": 40,
    "L": 68.551139831543,
    "a": -5.65935516357422,
    "b": -16.5620193481445,
    "C": 17.5022506713867,
    "h": 251.134353637695,
    "CMY_C": 0.45914828777313,
    "CMY_M": 0.32678151130676,
    "CMY_Y": 0.23444718122482,
    "CMYK_C": 0.29351481795311,
    "CMYK_M": 0.12061131000519,
    "CMYK_Y": 0,
    "CMYK_K": 0.23444718122482
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34412",
    "Farbtonhilfsbezeichnung": "34412",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "188",
    "Bcolor": "207",
    "Y": 49,
    "L": 74.6638412475586,
    "a": -5.16269588470459,
    "b": -13.8270235061646,
    "C": 14.7594041824341,
    "h": 249.525512695312,
    "CMY_C": 0.37685960531235,
    "CMY_M": 0.26360589265823,
    "CMY_Y": 0.18755143880844,
    "CMYK_C": 0.23300941288471,
    "CMYK_M": 0.09361141175032,
    "CMYK_Y": 0,
    "CMYK_K": 0.18755143880844
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34413",
    "Farbtonhilfsbezeichnung": "34413",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "204",
    "Bcolor": "217",
    "Y": 59,
    "L": 80.9302291870117,
    "a": -4.45167207717896,
    "b": -9.73808765411377,
    "C": 10.7073678970337,
    "h": 245.432952880859,
    "CMY_C": 0.28538626432419,
    "CMY_M": 0.19859647750854,
    "CMY_Y": 0.14834266901016,
    "CMYK_C": 0.16091400384903,
    "CMYK_M": 0.0590070746839,
    "CMYK_Y": 0,
    "CMYK_K": 0.14834266901016
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34414",
    "Farbtonhilfsbezeichnung": "34414",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "212",
    "Bcolor": "221",
    "Y": 64,
    "L": 83.7863464355469,
    "a": -4.30613327026367,
    "b": -7.60739135742188,
    "C": 8.74157810211182,
    "h": 240.488143920898,
    "CMY_C": 0.24436372518539,
    "CMY_M": 0.16829693317413,
    "CMY_Y": 0.13239765167236,
    "CMYK_C": 0.12905229628086,
    "CMYK_M": 0.0413775742054,
    "CMYK_Y": 0,
    "CMYK_K": 0.13239765167236
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34420",
    "Farbtonhilfsbezeichnung": "34420",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "132",
    "Bcolor": "151",
    "Y": 23,
    "L": 54.441276550293,
    "a": -1.36228430271149,
    "b": -12.9297218322754,
    "C": 13.0012893676758,
    "h": 263.985473632813,
    "CMY_C": 0.54799199104309,
    "CMY_M": 0.48249489068985,
    "CMY_Y": 0.40735912322998,
    "CMYK_C": 0.23729862272739,
    "CMYK_M": 0.12678128480911,
    "CMYK_Y": 0,
    "CMYK_K": 0.40735912322998
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34421",
    "Farbtonhilfsbezeichnung": "34421",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "162",
    "Bcolor": "178",
    "Y": 36,
    "L": 66.0045547485352,
    "a": -1.64834010601044,
    "b": -10.9048261642456,
    "C": 11.0287017822266,
    "h": 261.404418945313,
    "CMY_C": 0.42416447401047,
    "CMY_M": 0.3638773560524,
    "CMY_Y": 0.30063229799271,
    "CMYK_C": 0.17663408815861,
    "CMYK_M": 0.09043176472187,
    "CMYK_Y": 0,
    "CMYK_K": 0.30063229799271
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34422",
    "Farbtonhilfsbezeichnung": "34422",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "185",
    "Bcolor": "195",
    "Y": 49,
    "L": 74.4934463500977,
    "a": -1.42819082736969,
    "b": -7.43523025512695,
    "C": 7.57115411758423,
    "h": 259.126800537109,
    "CMY_C": 0.31941497325897,
    "CMY_M": 0.27560567855835,
    "CMY_Y": 0.2344121336937,
    "CMYK_C": 0.11102950572968,
    "CMYK_M": 0.05380642414093,
    "CMYK_Y": 0,
    "CMYK_K": 0.2344121336937
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34423",
    "Farbtonhilfsbezeichnung": "34423",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "202",
    "Bcolor": "208",
    "Y": 59,
    "L": 80.9565658569336,
    "a": -1.45525324344635,
    "b": -4.47432518005371,
    "C": 4.70503425598145,
    "h": 251.983123779297,
    "CMY_C": 0.23912745714188,
    "CMY_M": 0.20662933588028,
    "CMY_Y": 0.18572723865509,
    "CMYK_C": 0.06558025628328,
    "CMYK_M": 0.025669651106,
    "CMYK_Y": 0,
    "CMYK_K": 0.18572723865509
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34430",
    "Farbtonhilfsbezeichnung": "34430",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "102",
    "Bcolor": "113",
    "Y": 13,
    "L": 42.65576171875,
    "a": -0.75528997182846,
    "b": -8.36849117279053,
    "C": 8.40250587463379,
    "h": 264.842803955078,
    "CMY_C": 0.63903194665909,
    "CMY_M": 0.60106790065765,
    "CMY_Y": 0.55511081218719,
    "CMYK_C": 0.18863378465176,
    "CMYK_M": 0.10330007970333,
    "CMYK_Y": 0,
    "CMYK_K": 0.55511081218719
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34431",
    "Farbtonhilfsbezeichnung": "34431",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "114",
    "Bcolor": "128",
    "Y": 17,
    "L": 47.692756652832,
    "a": -0.69333922863007,
    "b": -9.6468563079834,
    "C": 9.67174053192139,
    "h": 265.889099121094,
    "CMY_C": 0.59516680240631,
    "CMY_M": 0.55192482471466,
    "CMY_Y": 0.49722981452942,
    "CMYK_C": 0.19479474425316,
    "CMYK_M": 0.10878729820251,
    "CMYK_Y": 0,
    "CMYK_K": 0.49722981452942
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34432",
    "Farbtonhilfsbezeichnung": "34432",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "142",
    "Bcolor": "154",
    "Y": 27,
    "L": 58.5396308898926,
    "a": -0.84487456083298,
    "b": -8.1125431060791,
    "C": 8.156418800354,
    "h": 264.054412841797,
    "CMY_C": 0.48274397850037,
    "CMY_M": 0.44352751970291,
    "CMY_Y": 0.39758139848709,
    "CMYK_C": 0.14136777818203,
    "CMYK_M": 0.07626942545176,
    "CMYK_Y": 0,
    "CMYK_K": 0.39758139848709
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34433",
    "Farbtonhilfsbezeichnung": "34433",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "163",
    "Bcolor": "175",
    "Y": 37,
    "L": 66.4888458251953,
    "a": -0.86069577932358,
    "b": -8.17189884185791,
    "C": 8.21710014343262,
    "h": 263.987548828125,
    "CMY_C": 0.40169966220856,
    "CMY_M": 0.36136090755463,
    "CMY_Y": 0.31438988447189,
    "CMYK_C": 0.127346098423,
    "CMYK_M": 0.06850981712341,
    "CMYK_Y": 0,
    "CMYK_K": 0.31438988447189
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34434",
    "Farbtonhilfsbezeichnung": "34434",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "182",
    "Bcolor": "190",
    "Y": 47,
    "L": 73.5630645751953,
    "a": -0.91281002759933,
    "b": -6.06441926956177,
    "C": 6.13273191452026,
    "h": 261.440155029297,
    "CMY_C": 0.31987792253494,
    "CMY_M": 0.28711330890656,
    "CMY_Y": 0.25405126810074,
    "CMYK_C": 0.0882455483079,
    "CMYK_M": 0.04432213678956,
    "CMYK_Y": 0,
    "CMYK_K": 0.25405126810074
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34435",
    "Farbtonhilfsbezeichnung": "34435",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "192",
    "Bcolor": "198",
    "Y": 52,
    "L": 77.2105255126953,
    "a": -0.78999054431915,
    "b": -4.76229572296143,
    "C": 4.82737445831299,
    "h": 260.581298828125,
    "CMY_C": 0.27518481016159,
    "CMY_M": 0.24864631891251,
    "CMY_Y": 0.22413200139999,
    "CMYK_C": 0.06580089777708,
    "CMYK_M": 0.03159599006176,
    "CMYK_Y": 0,
    "CMYK_K": 0.22413200139999
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34436",
    "Farbtonhilfsbezeichnung": "34436",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "207",
    "Bcolor": "210",
    "Y": 62,
    "L": 82.7056350708008,
    "a": -0.95993208885193,
    "b": -3.09124183654785,
    "C": 3.23685741424561,
    "h": 252.748718261719,
    "CMY_C": 0.21111011505127,
    "CMY_M": 0.18908232450485,
    "CMY_Y": 0.17663478851318,
    "CMYK_C": 0.04187124595046,
    "CMYK_M": 0.01511787902564,
    "CMYK_Y": 0,
    "CMYK_K": 0.17663478851318
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34437",
    "Farbtonhilfsbezeichnung": "34437",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 72,
    "L": 88.2739944458008,
    "a": -1.07165706157684,
    "b": -0.74068224430084,
    "C": 1.30271220207214,
    "h": 214.650527954102,
    "CMY_C": 0.14257287979126,
    "CMY_M": 0.12819516658783,
    "CMY_Y": 0.13284438848495,
    "CMYK_C": 0.0164918936789,
    "CMYK_M": 0,
    "CMYK_Y": 0.00533286994323,
    "CMYK_K": 0.12819516658783
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34440",
    "Farbtonhilfsbezeichnung": "34440",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "94",
    "Bcolor": "123",
    "Y": 11,
    "L": 38.6725883483887,
    "a": -2.30359983444214,
    "b": -20.2837963104248,
    "C": 20.4141845703125,
    "h": 263.520751953125,
    "CMY_C": 0.74998950958252,
    "CMY_M": 0.6322557926178,
    "CMY_Y": 0.51875030994415,
    "CMYK_C": 0.48049736022949,
    "CMYK_M": 0.23585569858551,
    "CMYK_Y": 0,
    "CMYK_K": 0.51875030994415
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34441",
    "Farbtonhilfsbezeichnung": "34441",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "89",
    "Bcolor": "109",
    "Y": 10,
    "L": 36.8583908081055,
    "a": -2.65841507911682,
    "b": -14.7267799377441,
    "C": 14.9647989273071,
    "h": 259.767425537109,
    "CMY_C": 0.73788547515869,
    "CMY_M": 0.65051335096359,
    "CMY_Y": 0.57150667905807,
    "CMYK_C": 0.388287961483,
    "CMYK_M": 0.18438249826431,
    "CMYK_Y": 0,
    "CMYK_K": 0.57150667905807
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "34442",
    "Farbtonhilfsbezeichnung": "34442",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "76",
    "Bcolor": "86",
    "Y": 7,
    "L": 31.8684825897217,
    "a": -0.04635981470346,
    "b": -7.40088272094727,
    "C": 7.40102815628052,
    "h": 269.64111328125,
    "CMY_C": 0.7303661108017,
    "CMY_M": 0.70383554697037,
    "CMY_Y": 0.66373491287231,
    "CMYK_C": 0.1981507986784,
    "CMYK_M": 0.11925303936005,
    "CMYK_Y": 0,
    "CMYK_K": 0.66373491287231
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35100",
    "Farbtonhilfsbezeichnung": "35100",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "117",
    "Bcolor": "175",
    "Y": 16,
    "L": 46.7275314331055,
    "a": -6.53763341903687,
    "b": -39.06005859375,
    "C": 39.6033935546875,
    "h": 260.498260498047,
    "CMY_C": 1,
    "CMY_M": 0.53936636447906,
    "CMY_Y": 0.31436961889267,
    "CMYK_C": 1,
    "CMYK_M": 0.328160405159,
    "CMYK_Y": 0,
    "CMYK_K": 0.31436961889267
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35101",
    "Farbtonhilfsbezeichnung": "35101",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "145",
    "Bcolor": "199",
    "Y": 26,
    "L": 57.0532417297363,
    "a": -9.6338586807251,
    "b": -36.6427688598633,
    "C": 37.8880424499512,
    "h": 255.269561767578,
    "CMY_C": 0.8183416724205,
    "CMY_M": 0.43111741542816,
    "CMY_Y": 0.21998286247253,
    "CMYK_C": 0.767109811306,
    "CMYK_M": 0.27067938446999,
    "CMYK_Y": 0,
    "CMYK_K": 0.21998286247253
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35102",
    "Farbtonhilfsbezeichnung": "35102",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "162",
    "Bcolor": "210",
    "Y": 33,
    "L": 63.4729461669922,
    "a": -10.2673273086548,
    "b": -32.8042831420898,
    "C": 34.3735237121582,
    "h": 252.620544433594,
    "CMY_C": 0.68682992458344,
    "CMY_M": 0.36507439613342,
    "CMY_Y": 0.17656534910202,
    "CMYK_C": 0.61967831850052,
    "CMYK_M": 0.22893019020557,
    "CMYK_Y": 0,
    "CMYK_K": 0.17656534910202
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35103",
    "Farbtonhilfsbezeichnung": "35103",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "185",
    "Bcolor": "221",
    "Y": 45,
    "L": 72.2426681518555,
    "a": -10.2189950942993,
    "b": -25.0093955993652,
    "C": 27.0166187286377,
    "h": 247.774765014648,
    "CMY_C": 0.5178200006485,
    "CMY_M": 0.27525842189789,
    "CMY_Y": 0.13505136966705,
    "CMYK_C": 0.4425333738327,
    "CMYK_M": 0.16209870576859,
    "CMYK_Y": 0,
    "CMYK_K": 0.13505136966705
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35104",
    "Farbtonhilfsbezeichnung": "35104",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "198",
    "Bcolor": "226",
    "Y": 53,
    "L": 77.3801345825195,
    "a": -9.35629749298096,
    "b": -19.9681758880615,
    "C": 22.05149269104,
    "h": 244.894073486328,
    "CMY_C": 0.4203314781189,
    "CMY_M": 0.22337639331818,
    "CMY_Y": 0.11425167322159,
    "CMYK_C": 0.34556069970131,
    "CMYK_M": 0.12320059537888,
    "CMYK_Y": 0,
    "CMYK_K": 0.11425167322159
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35105",
    "Farbtonhilfsbezeichnung": "35105",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "212",
    "Bcolor": "230",
    "Y": 62,
    "L": 82.7141571044922,
    "a": -8.20639133453369,
    "b": -13.9695339202881,
    "C": 16.2016277313232,
    "h": 239.567932128906,
    "CMY_C": 0.31935876607895,
    "CMY_M": 0.16952931880951,
    "CMY_Y": 0.09840667247772,
    "CMYK_C": 0.2450684607029,
    "CMYK_M": 0.07888550311327,
    "CMYK_Y": 0,
    "CMYK_K": 0.09840667247772
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35106",
    "Farbtonhilfsbezeichnung": "35106",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "218",
    "Bcolor": "231",
    "Y": 67,
    "L": 85.3403625488281,
    "a": -7.22168827056885,
    "b": -10.4333534240723,
    "C": 12.6888790130615,
    "h": 235.310043334961,
    "CMY_C": 0.26517999172211,
    "CMY_M": 0.14384162425995,
    "CMY_Y": 0.09494805335999,
    "CMYK_C": 0.18809078633785,
    "CMYK_M": 0.05402294546366,
    "CMYK_Y": 0,
    "CMYK_K": 0.09494805335999
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35107",
    "Farbtonhilfsbezeichnung": "35107",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "227",
    "Bcolor": "233",
    "Y": 74,
    "L": 88.7157135009766,
    "a": -5.73909139633179,
    "b": -6.44451522827148,
    "C": 8.62953948974609,
    "h": 228.313690185547,
    "CMY_C": 0.1981258392334,
    "CMY_M": 0.11092019081116,
    "CMY_Y": 0.08657068014145,
    "CMYK_C": 0.12212785333395,
    "CMYK_M": 0.02665724605322,
    "CMYK_Y": 0,
    "CMYK_K": 0.08657068014145
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35108",
    "Farbtonhilfsbezeichnung": "35108",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "232",
    "Bcolor": "232",
    "Y": 79,
    "L": 91.0285949707031,
    "a": -4.36040592193604,
    "b": -2.41530537605286,
    "C": 4.98466062545776,
    "h": 208.982833862305,
    "CMY_C": 0.14507836103439,
    "CMY_M": 0.08944416046143,
    "CMY_Y": 0.09047299623489,
    "CMYK_C": 0.06109916418791,
    "CMYK_M": 0,
    "CMYK_Y": 0.0011298985919,
    "CMYK_K": 0.08944416046143
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35109",
    "Farbtonhilfsbezeichnung": "35109",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "237",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.0048751831055,
    "a": -3.13402080535889,
    "b": 0.43151596188545,
    "C": 3.16358852386475,
    "h": 172.160369873047,
    "CMY_C": 0.1025658249855,
    "CMY_M": 0.0709645152092,
    "CMY_Y": 0.08950132131577,
    "CMYK_C": 0.03401518240571,
    "CMYK_M": 0,
    "CMYK_Y": 0.01995274238288,
    "CMYK_K": 0.0709645152092
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35110",
    "Farbtonhilfsbezeichnung": "35110",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "152",
    "Bcolor": "190",
    "Y": 30,
    "L": 60.2288780212402,
    "a": -9.66390609741211,
    "b": -26.2816696166992,
    "C": 28.0020942687988,
    "h": 249.811264038086,
    "CMY_C": 0.65310204029083,
    "CMY_M": 0.40236169099808,
    "CMY_Y": 0.25682473182678,
    "CMYK_C": 0.5332219004631,
    "CMYK_M": 0.1958312690258,
    "CMYK_Y": 0,
    "CMYK_K": 0.25682473182678
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35111",
    "Farbtonhilfsbezeichnung": "35111",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "178",
    "Bcolor": "207",
    "Y": 42,
    "L": 70.1652755737305,
    "a": -9.14843463897705,
    "b": -20.5606384277344,
    "C": 22.5040817260742,
    "h": 246.013381958008,
    "CMY_C": 0.49903231859207,
    "CMY_M": 0.30114090442657,
    "CMY_Y": 0.18921190500259,
    "CMYK_C": 0.3821225464344,
    "CMYK_M": 0.13804963231087,
    "CMYK_Y": 0,
    "CMYK_K": 0.18921190500259
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35112",
    "Farbtonhilfsbezeichnung": "35112",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "194",
    "Bcolor": "217",
    "Y": 51,
    "L": 76.0396957397461,
    "a": -8.48958778381348,
    "b": -17.2625579833984,
    "C": 19.2371768951416,
    "h": 243.812408447266,
    "CMY_C": 0.41074341535568,
    "CMY_M": 0.24060189723969,
    "CMY_Y": 0.14834529161453,
    "CMYK_C": 0.30810388922691,
    "CMYK_M": 0.10832630097866,
    "CMYK_Y": 0,
    "CMYK_K": 0.14834529161453
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35113",
    "Farbtonhilfsbezeichnung": "35113",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "208",
    "Bcolor": "223",
    "Y": 60,
    "L": 81.615104675293,
    "a": -7.23298978805542,
    "b": -11.9107236862183,
    "C": 13.9349012374878,
    "h": 238.731063842773,
    "CMY_C": 0.31232172250748,
    "CMY_M": 0.18433880805969,
    "CMY_Y": 0.12540221214294,
    "CMYK_C": 0.21372054517269,
    "CMYK_M": 0.06738708913326,
    "CMYK_Y": 0,
    "CMYK_K": 0.12540221214294
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35114",
    "Farbtonhilfsbezeichnung": "35114",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "215",
    "Bcolor": "226",
    "Y": 65,
    "L": 84.3661346435547,
    "a": -6.36433839797974,
    "b": -9.4461841583252,
    "C": 11.3901357650757,
    "h": 236.029998779297,
    "CMY_C": 0.2637100815773,
    "CMY_M": 0.15678203105927,
    "CMY_Y": 0.11284857988358,
    "CMYK_C": 0.17005157470703,
    "CMYK_M": 0.04952193051577,
    "CMYK_Y": 0,
    "CMYK_K": 0.11284857988358
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35120",
    "Farbtonhilfsbezeichnung": "35120",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "143",
    "Bcolor": "170",
    "Y": 26,
    "L": 57.2812080383301,
    "a": -7.1073784828186,
    "b": -19.8327121734619,
    "C": 21.0677795410156,
    "h": 250.284027099609,
    "CMY_C": 0.60842275619507,
    "CMY_M": 0.43985438346863,
    "CMY_Y": 0.33192813396454,
    "CMYK_C": 0.41386958956718,
    "CMYK_M": 0.16154886782169,
    "CMYK_Y": 0,
    "CMYK_K": 0.33192813396454
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35121",
    "Farbtonhilfsbezeichnung": "35121",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "172",
    "Bcolor": "191",
    "Y": 39,
    "L": 68.4443664550781,
    "a": -6.24187612533569,
    "b": -14.4809637069702,
    "C": 15.7689352035523,
    "h": 246.682022094727,
    "CMY_C": 0.45506596565247,
    "CMY_M": 0.32735842466354,
    "CMY_Y": 0.25022560358047,
    "CMYK_C": 0.27320265769958,
    "CMYK_M": 0.10287470370531,
    "CMYK_Y": 0,
    "CMYK_K": 0.25022560358047
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35122",
    "Farbtonhilfsbezeichnung": "35122",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "191",
    "Bcolor": "205",
    "Y": 51,
    "L": 75.9986877441406,
    "a": -5.04043340682983,
    "b": -10.4071025848389,
    "C": 11.5634660720825,
    "h": 244.157867431641,
    "CMY_C": 0.34603703022003,
    "CMY_M": 0.25057750940323,
    "CMY_Y": 0.19741374254227,
    "CMYK_C": 0.18518045544624,
    "CMYK_M": 0.06624056398869,
    "CMYK_Y": 0,
    "CMYK_K": 0.19741374254227
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35123",
    "Farbtonhilfsbezeichnung": "35123",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "203",
    "Bcolor": "209",
    "Y": 58,
    "L": 80.7075805664063,
    "a": -2.94807314872742,
    "b": -5.4624719619751,
    "C": 6.20723247528076,
    "h": 241.644439697266,
    "CMY_C": 0.25771254301071,
    "CMY_M": 0.20566934347153,
    "CMY_Y": 0.18148726224899,
    "CMYK_C": 0.09312656521797,
    "CMYK_M": 0.02954392693937,
    "CMYK_Y": 0,
    "CMYK_K": 0.18148726224899
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35124",
    "Farbtonhilfsbezeichnung": "35124",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "208",
    "Bcolor": "210",
    "Y": 62,
    "L": 82.8164291381836,
    "a": -2.00082492828369,
    "b": -2.92296314239502,
    "C": 3.54217648506165,
    "h": 235.607604980469,
    "CMY_C": 0.217638194561,
    "CMY_M": 0.18553233146667,
    "CMY_Y": 0.1767835021019,
    "CMYK_C": 0.0496281273663,
    "CMYK_M": 0.01062761619687,
    "CMYK_Y": 0,
    "CMYK_K": 0.1767835021019
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35130",
    "Farbtonhilfsbezeichnung": "35130",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "107",
    "Bcolor": "119",
    "Y": 15,
    "L": 44.5276031494141,
    "a": -2.51371479034424,
    "b": -9.09628677368164,
    "C": 9.43722343444824,
    "h": 254.552124023438,
    "CMY_C": 0.63772869110107,
    "CMY_M": 0.57929217815399,
    "CMY_Y": 0.53230249881744,
    "CMYK_C": 0.22541534900665,
    "CMYK_M": 0.10047023743391,
    "CMYK_Y": 0,
    "CMYK_K": 0.53230249881744
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35131",
    "Farbtonhilfsbezeichnung": "35131",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "115",
    "Bcolor": "128",
    "Y": 17,
    "L": 47.7316436767578,
    "a": -2.27229452133179,
    "b": -9.57550239562988,
    "C": 9.84142112731934,
    "h": 256.650482177734,
    "CMY_C": 0.60693073272705,
    "CMY_M": 0.54836046695709,
    "CMY_Y": 0.49746763706207,
    "CMYK_C": 0.21782298386097,
    "CMYK_M": 0.10127273947001,
    "CMYK_Y": 0,
    "CMYK_K": 0.49746763706207
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35132",
    "Farbtonhilfsbezeichnung": "35132",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "147",
    "Bcolor": "159",
    "Y": 29,
    "L": 60.1490287780762,
    "a": -2.48260283470154,
    "b": -8.62866878509521,
    "C": 8.97871017456055,
    "h": 253.948638916016,
    "CMY_C": 0.48152935504913,
    "CMY_M": 0.42343318462372,
    "CMY_Y": 0.37764966487885,
    "CMYK_C": 0.16691513359547,
    "CMYK_M": 0.07356551289558,
    "CMYK_Y": 0,
    "CMYK_K": 0.37764966487885
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35133",
    "Farbtonhilfsbezeichnung": "35133",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "163",
    "Bcolor": "172",
    "Y": 37,
    "L": 66.1534729003906,
    "a": -2.27052879333496,
    "b": -7.18556070327759,
    "C": 7.53575372695923,
    "h": 252.464248657227,
    "CMY_C": 0.41260582208633,
    "CMY_M": 0.36209064722061,
    "CMY_Y": 0.32492285966873,
    "CMYK_C": 0.12988583743572,
    "CMYK_M": 0.05505709722638,
    "CMYK_Y": 0,
    "CMYK_K": 0.32492285966873
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35134",
    "Farbtonhilfsbezeichnung": "35134",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "179",
    "Bcolor": "186",
    "Y": 45,
    "L": 72.1774139404297,
    "a": -2.28067374229431,
    "b": -5.888596534729,
    "C": 6.31482696533203,
    "h": 248.82844543457,
    "CMY_C": 0.34480667114258,
    "CMY_M": 0.29889136552811,
    "CMY_Y": 0.27025598287582,
    "CMYK_C": 0.10216005146503,
    "CMYK_M": 0.03924031183124,
    "CMYK_Y": 0,
    "CMYK_K": 0.27025598287582
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35135",
    "Farbtonhilfsbezeichnung": "35135",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "195",
    "Bcolor": "201",
    "Y": 54,
    "L": 78.0366287231445,
    "a": -2.20135188102722,
    "b": -5.18900156021118,
    "C": 5.63663816452026,
    "h": 247.011688232422,
    "CMY_C": 0.27926361560822,
    "CMY_M": 0.23641556501389,
    "CMY_Y": 0.21233588457108,
    "CMYK_C": 0.0849698856473,
    "CMYK_M": 0.03057100065053,
    "CMYK_Y": 0,
    "CMYK_K": 0.21233588457108
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35136",
    "Farbtonhilfsbezeichnung": "35136",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "208",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.1199798583984,
    "a": -1.41416025161743,
    "b": -2.31026124954224,
    "C": 2.7087185382843,
    "h": 238.528305053711,
    "CMY_C": 0.20741087198257,
    "CMY_M": 0.18373012542725,
    "CMY_Y": 0.17784851789474,
    "CMYK_C": 0.03595730662346,
    "CMYK_M": 0.00715392176062,
    "CMYK_Y": 0,
    "CMYK_K": 0.17784851789474
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35137",
    "Farbtonhilfsbezeichnung": "35137",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 72,
    "L": 88.0799713134766,
    "a": -1.60026395320892,
    "b": -0.84926468133926,
    "C": 1.81165540218353,
    "h": 207.955017089844,
    "CMY_C": 0.14932864904404,
    "CMY_M": 0.12908262014389,
    "CMY_Y": 0.13425189256668,
    "CMYK_C": 0.02324678562582,
    "CMYK_M": 0,
    "CMYK_Y": 0.00593543378636,
    "CMYK_K": 0.12908262014389
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35140",
    "Farbtonhilfsbezeichnung": "35140",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "102",
    "Bcolor": "142",
    "Y": 12,
    "L": 40.9817199707031,
    "a": -6.70324277877808,
    "b": -28.8062248229981,
    "C": 29.5758686065674,
    "h": 256.900329589844,
    "CMY_C": 0.86758714914322,
    "CMY_M": 0.59903526306152,
    "CMY_Y": 0.44140577316284,
    "CMYK_C": 0.76295340061188,
    "CMYK_M": 0.28218960762024,
    "CMYK_Y": 0,
    "CMYK_K": 0.44140577316284
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35141",
    "Farbtonhilfsbezeichnung": "35141",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "72",
    "Bcolor": "96",
    "Y": 7,
    "L": 29.7098560333252,
    "a": -2.32955384254456,
    "b": -17.5054721832275,
    "C": 17.6597957611084,
    "h": 262.419860839844,
    "CMY_C": 0.81863522529602,
    "CMY_M": 0.71611827611923,
    "CMY_Y": 0.62300646305084,
    "CMYK_C": 0.5189180970192,
    "CMYK_M": 0.24698516726494,
    "CMYK_Y": 0,
    "CMYK_K": 0.62300646305084
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35200",
    "Farbtonhilfsbezeichnung": "35200",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "120",
    "Bcolor": "167",
    "Y": 17,
    "L": 46.8393630981445,
    "a": -12.781792640686,
    "b": -34.2528877258301,
    "C": 36.5600128173828,
    "h": 249.53645324707,
    "CMY_C": 1,
    "CMY_M": 0.52918088436127,
    "CMY_Y": 0.34549242258072,
    "CMYK_C": 1,
    "CMYK_M": 0.28065139055252,
    "CMYK_Y": 0,
    "CMYK_K": 0.34549242258072
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35201",
    "Farbtonhilfsbezeichnung": "35201",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "146",
    "Bcolor": "189",
    "Y": 26,
    "L": 56.6618385314941,
    "a": -14.6235446929932,
    "b": -31.618034362793,
    "C": 34.8360176086426,
    "h": 245.179153442383,
    "CMY_C": 0.85663068294525,
    "CMY_M": 0.42792004346848,
    "CMY_Y": 0.25895231962204,
    "CMYK_C": 0.80653160810471,
    "CMYK_M": 0.22801195085049,
    "CMYK_Y": 0,
    "CMYK_K": 0.25895231962204
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35202",
    "Farbtonhilfsbezeichnung": "35202",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "161",
    "Bcolor": "201",
    "Y": 32,
    "L": 62.6261940002441,
    "a": -14.343074798584,
    "b": -29.2015628814697,
    "C": 32.5339050292969,
    "h": 243.840881347656,
    "CMY_C": 0.72259986400604,
    "CMY_M": 0.36752611398697,
    "CMY_Y": 0.21117359399796,
    "CMYK_C": 0.6483381986618,
    "CMYK_M": 0.19820903241634,
    "CMYK_Y": 0,
    "CMYK_K": 0.21117359399796
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35203",
    "Farbtonhilfsbezeichnung": "35203",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "186",
    "Bcolor": "216",
    "Y": 45,
    "L": 72.3636322021484,
    "a": -13.0356454849243,
    "b": -22.1634292602539,
    "C": 25.7127532958984,
    "h": 239.537658691406,
    "CMY_C": 0.52868354320526,
    "CMY_M": 0.26929730176926,
    "CMY_Y": 0.15420627593994,
    "CMYK_C": 0.4427524805069,
    "CMYK_M": 0.13607457280159,
    "CMYK_Y": 0,
    "CMYK_K": 0.15420627593994
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35204",
    "Farbtonhilfsbezeichnung": "35204",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "198",
    "Bcolor": "222",
    "Y": 52,
    "L": 76.9797592163086,
    "a": -11.7639322280884,
    "b": -18.7797718048096,
    "C": 22.1600971221924,
    "h": 237.93635559082,
    "CMY_C": 0.44247508049011,
    "CMY_M": 0.22313845157623,
    "CMY_Y": 0.12745720148087,
    "CMYK_C": 0.36103430390358,
    "CMYK_M": 0.10965794324875,
    "CMYK_Y": 0,
    "CMYK_K": 0.12745720148087
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35205",
    "Farbtonhilfsbezeichnung": "35205",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "211",
    "Bcolor": "227",
    "Y": 62,
    "L": 82.1918563842773,
    "a": -9.56163883209229,
    "b": -13.1377458572388,
    "C": 16.2488555908203,
    "h": 233.952896118164,
    "CMY_C": 0.33358609676361,
    "CMY_M": 0.17262548208237,
    "CMY_Y": 0.1103897690773,
    "CMYK_C": 0.25089228153229,
    "CMYK_M": 0.06995840370655,
    "CMYK_Y": 0,
    "CMYK_K": 0.1103897690773
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35206",
    "Farbtonhilfsbezeichnung": "35206",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "218",
    "Bcolor": "229",
    "Y": 67,
    "L": 85.059211730957,
    "a": -8.40944480895996,
    "b": -9.77212142944336,
    "C": 12.8923664093018,
    "h": 229.286209106445,
    "CMY_C": 0.27591687440872,
    "CMY_M": 0.14455664157867,
    "CMY_Y": 0.10303992033005,
    "CMYK_C": 0.1927365064621,
    "CMYK_M": 0.04628603160381,
    "CMYK_Y": 0,
    "CMYK_K": 0.10303992033005
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35207",
    "Farbtonhilfsbezeichnung": "35207",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "227",
    "Bcolor": "231",
    "Y": 74,
    "L": 88.5877075195313,
    "a": -6.54958295822144,
    "b": -5.43970775604248,
    "C": 8.51395702362061,
    "h": 219.711074829102,
    "CMY_C": 0.20237755775452,
    "CMY_M": 0.11082744598389,
    "CMY_Y": 0.0954977273941,
    "CMYK_C": 0.11816424876451,
    "CMYK_M": 0.01694823615253,
    "CMYK_Y": 0,
    "CMYK_K": 0.0954977273941
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35208",
    "Farbtonhilfsbezeichnung": "35208",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "232",
    "Bcolor": "231",
    "Y": 79,
    "L": 90.8509063720703,
    "a": -5.22596645355225,
    "b": -2.25512003898621,
    "C": 5.69177389144897,
    "h": 203.341262817383,
    "CMY_C": 0.15365952253342,
    "CMY_M": 0.08950066566467,
    "CMY_Y": 0.09374576807022,
    "CMYK_C": 0.07046557217836,
    "CMYK_M": 0,
    "CMYK_Y": 0.00466238940135,
    "CMYK_K": 0.08950066566467
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35209",
    "Farbtonhilfsbezeichnung": "35209",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "237",
    "Bcolor": "231",
    "Y": 83,
    "L": 92.8735580444336,
    "a": -3.38530707359314,
    "b": 0.80370777845383,
    "C": 3.47940373420715,
    "h": 166.644638061523,
    "CMY_C": 0.10474598407745,
    "CMY_M": 0.07195907831192,
    "CMY_Y": 0.09376323223114,
    "CMYK_C": 0.0353291593492,
    "CMYK_M": 0,
    "CMYK_Y": 0.02349481917918,
    "CMYK_K": 0.07195907831192
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35210",
    "Farbtonhilfsbezeichnung": "35210",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "150",
    "Bcolor": "181",
    "Y": 28,
    "L": 59.1263580322266,
    "a": -12.0413684844971,
    "b": -22.9309368133545,
    "C": 25.900239944458,
    "h": 242.295379638672,
    "CMY_C": 0.66752338409424,
    "CMY_M": 0.41038942337036,
    "CMY_Y": 0.29176706075668,
    "CMYK_C": 0.5305547118187,
    "CMYK_M": 0.16749060153961,
    "CMYK_Y": 0,
    "CMYK_K": 0.29176706075668
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35211",
    "Farbtonhilfsbezeichnung": "35211",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "177",
    "Bcolor": "201",
    "Y": 41,
    "L": 69.5523681640625,
    "a": -10.6083040237427,
    "b": -18.1270160675049,
    "C": 21.0029716491699,
    "h": 239.662948608398,
    "CMY_C": 0.50585389137268,
    "CMY_M": 0.30551391839981,
    "CMY_Y": 0.2131484746933,
    "CMYK_C": 0.37199574708939,
    "CMYK_M": 0.11738611757755,
    "CMYK_Y": 0,
    "CMYK_K": 0.2131484746933
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35212",
    "Farbtonhilfsbezeichnung": "35212",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "192",
    "Bcolor": "212",
    "Y": 50,
    "L": 75.2218322753906,
    "a": -9.7804012298584,
    "b": -15.7777080535889,
    "C": 18.5631980895996,
    "h": 238.205749511719,
    "CMY_C": 0.42399001121521,
    "CMY_M": 0.24722230434418,
    "CMY_Y": 0.16805279254913,
    "CMYK_C": 0.30763638019562,
    "CMYK_M": 0.0951616987586,
    "CMYK_Y": 0,
    "CMYK_K": 0.16805279254913
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35213",
    "Farbtonhilfsbezeichnung": "35213",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "207",
    "Bcolor": "220",
    "Y": 60,
    "L": 81.1283874511719,
    "a": -8.06595706939697,
    "b": -10.9058523178101,
    "C": 13.5645599365234,
    "h": 233.513412475586,
    "CMY_C": 0.32040864229202,
    "CMY_M": 0.1881787776947,
    "CMY_Y": 0.13813662528992,
    "CMYK_C": 0.21148598194122,
    "CMYK_M": 0.05806274339557,
    "CMYK_Y": 0,
    "CMYK_K": 0.13813662528992
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35220",
    "Farbtonhilfsbezeichnung": "35220",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "138",
    "Bcolor": "164",
    "Y": 23,
    "L": 54.7921714782715,
    "a": -11.1619091033935,
    "b": -19.8051490783691,
    "C": 22.7339420318604,
    "h": 240.594985961914,
    "CMY_C": 0.67884159088135,
    "CMY_M": 0.45747470855713,
    "CMY_Y": 0.35852766036987,
    "CMYK_C": 0.49934175610542,
    "CMYK_M": 0.15424990653992,
    "CMYK_Y": 0,
    "CMYK_K": 0.35852766036987
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35221",
    "Farbtonhilfsbezeichnung": "35221",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "168",
    "Bcolor": "188",
    "Y": 37,
    "L": 66.2663269042969,
    "a": -10.313850402832,
    "b": -16.2762832641602,
    "C": 19.2689628601074,
    "h": 237.638656616211,
    "CMY_C": 0.52644467353821,
    "CMY_M": 0.34146827459335,
    "CMY_Y": 0.26142352819443,
    "CMYK_C": 0.35882696509361,
    "CMYK_M": 0.10837706178427,
    "CMYK_Y": 0,
    "CMYK_K": 0.26142352819443
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35222",
    "Farbtonhilfsbezeichnung": "35222",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "188",
    "Bcolor": "202",
    "Y": 48,
    "L": 74.4197463989258,
    "a": -7.33933258056641,
    "b": -11.4360399246216,
    "C": 13.5885543823242,
    "h": 237.308776855469,
    "CMY_C": 0.38770055770874,
    "CMY_M": 0.26232773065567,
    "CMY_Y": 0.2074533700943,
    "CMYK_C": 0.22742787003517,
    "CMYK_M": 0.0692380219698,
    "CMYK_Y": 0,
    "CMYK_K": 0.2074533700943
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35223",
    "Farbtonhilfsbezeichnung": "35223",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "199",
    "Bcolor": "207",
    "Y": 56,
    "L": 78.820442199707,
    "a": -5.69322919845581,
    "b": -7.53686332702637,
    "C": 9.44548416137695,
    "h": 232.933166503906,
    "CMY_C": 0.30931377410889,
    "CMY_M": 0.21949750185013,
    "CMY_Y": 0.18740487098694,
    "CMYK_C": 0.15002416074276,
    "CMYK_M": 0.03949400037527,
    "CMYK_Y": 0,
    "CMYK_K": 0.18740487098694
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35224",
    "Farbtonhilfsbezeichnung": "35224",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "205",
    "Bcolor": "209",
    "Y": 60,
    "L": 81.3480377197266,
    "a": -3.87316083908081,
    "b": -4.67246246337891,
    "C": 6.06904268264771,
    "h": 230.343536376953,
    "CMY_C": 0.25537365674973,
    "CMY_M": 0.19684243202209,
    "CMY_Y": 0.18033939599991,
    "CMYK_C": 0.09154308587313,
    "CMYK_M": 0.02013398706913,
    "CMYK_Y": 0,
    "CMYK_K": 0.18033939599991
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35230",
    "Farbtonhilfsbezeichnung": "35230",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "99",
    "Bcolor": "105",
    "Y": 12,
    "L": 41.3249092102051,
    "a": -2.37359118461609,
    "b": -4.93803930282593,
    "C": 5.47888374328613,
    "h": 244.327575683594,
    "CMY_C": 0.65087634325027,
    "CMY_M": 0.61157047748566,
    "CMY_Y": 0.58996099233627,
    "CMYK_C": 0.14855989813805,
    "CMYK_M": 0.05270104855299,
    "CMYK_Y": 0,
    "CMYK_K": 0.58996099233627
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35231",
    "Farbtonhilfsbezeichnung": "35231",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "119",
    "Bcolor": "122",
    "Y": 19,
    "L": 49.8200454711914,
    "a": -0.85774183273315,
    "b": -2.72459030151367,
    "C": 2.85641622543335,
    "h": 252.52522277832,
    "CMY_C": 0.55025237798691,
    "CMY_M": 0.53258109092712,
    "CMY_Y": 0.52138441801071,
    "CMYK_C": 0.06031554564834,
    "CMYK_M": 0.02339387498796,
    "CMYK_Y": 0,
    "CMYK_K": 0.52138441801071
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35232",
    "Farbtonhilfsbezeichnung": "35232",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "128",
    "Bcolor": "132",
    "Y": 22,
    "L": 53.3358993530273,
    "a": -1.4857349395752,
    "b": -3.30790877342224,
    "C": 3.62624716758728,
    "h": 245.812942504883,
    "CMY_C": 0.52214515209198,
    "CMY_M": 0.49613261222839,
    "CMY_Y": 0.48267984390259,
    "CMYK_C": 0.07628797739744,
    "CMYK_M": 0.02600472420454,
    "CMYK_Y": 0,
    "CMYK_K": 0.48267984390259
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35233",
    "Farbtonhilfsbezeichnung": "35233",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "153",
    "Bcolor": "156",
    "Y": 32,
    "L": 62.3848915100098,
    "a": -2.53500056266785,
    "b": -3.89168667793274,
    "C": 4.64450788497925,
    "h": 236.92024230957,
    "CMY_C": 0.44100594520569,
    "CMY_M": 0.40164572000504,
    "CMY_Y": 0.38689762353897,
    "CMYK_C": 0.08825331926346,
    "CMYK_M": 0.02405486814678,
    "CMYK_Y": 0,
    "CMYK_K": 0.38689762353897
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35234",
    "Farbtonhilfsbezeichnung": "35234",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "181",
    "Bcolor": "182",
    "Y": 46,
    "L": 72.9338836669922,
    "a": -2.24940156936646,
    "b": -2.53424644470215,
    "C": 3.38854146003723,
    "h": 228.407684326172,
    "CMY_C": 0.32415479421616,
    "CMY_M": 0.29186260700226,
    "CMY_Y": 0.28590005636215,
    "CMYK_C": 0.05357056483626,
    "CMYK_M": 0.00834974274039,
    "CMYK_Y": 0,
    "CMYK_K": 0.28590005636215
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35235",
    "Farbtonhilfsbezeichnung": "35235",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "194",
    "Bcolor": "194",
    "Y": 54,
    "L": 78.0566558837891,
    "a": -1.65276920795441,
    "b": -1.45613050460815,
    "C": 2.20271706581116,
    "h": 221.380844116211,
    "CMY_C": 0.26103043556213,
    "CMY_M": 0.23850786685944,
    "CMY_Y": 0.23881310224533,
    "CMYK_C": 0.02957689017057,
    "CMYK_M": 0,
    "CMYK_Y": 0.00040083852946,
    "CMYK_K": 0.23850786685944
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35236",
    "Farbtonhilfsbezeichnung": "35236",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "208",
    "Y": 64,
    "L": 84.1452407836914,
    "a": -1.63092863559723,
    "b": 0.35828596353531,
    "C": 1.66981947422028,
    "h": 167.609939575195,
    "CMY_C": 0.1885512471199,
    "CMY_M": 0.17275029420853,
    "CMY_Y": 0.1861287355423,
    "CMYK_C": 0.01910058408976,
    "CMYK_M": 0,
    "CMYK_Y": 0.01617219299078,
    "CMYK_K": 0.17275029420853
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35237",
    "Farbtonhilfsbezeichnung": "35237",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "217",
    "Y": 75,
    "L": 89.404541015625,
    "a": -1.45931923389435,
    "b": 3.30822134017944,
    "C": 3.61579060554504,
    "h": 113.803184509277,
    "CMY_C": 0.11927843093872,
    "CMY_M": 0.11587858200073,
    "CMY_Y": 0.15031558275223,
    "CMYK_C": 0.00384545489214,
    "CMYK_M": 0,
    "CMYK_Y": 0.03895053267479,
    "CMYK_K": 0.11587858200073
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35240",
    "Farbtonhilfsbezeichnung": "35240",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "101",
    "Bcolor": "133",
    "Y": 12,
    "L": 40.3129615783691,
    "a": -9.6229772567749,
    "b": -24.2386913299561,
    "C": 26.0790309906006,
    "h": 248.346481323242,
    "CMY_C": 0.86654019355774,
    "CMY_M": 0.60201501846313,
    "CMY_Y": 0.47772860527039,
    "CMYK_C": 0.74446272850037,
    "CMYK_M": 0.23797285556793,
    "CMYK_Y": 0,
    "CMYK_K": 0.47772860527039
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35241",
    "Farbtonhilfsbezeichnung": "35241",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "76",
    "Bcolor": "98",
    "Y": 7,
    "L": 30.5325527191162,
    "a": -5.39764213562012,
    "b": -17.5398693084717,
    "C": 18.3516082763672,
    "h": 252.895004272461,
    "CMY_C": 0.84398204088211,
    "CMY_M": 0.70323431491852,
    "CMY_Y": 0.61519426107407,
    "CMYK_C": 0.59455394744873,
    "CMYK_M": 0.2287909090519,
    "CMYK_Y": 0,
    "CMYK_K": 0.61519426107407
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35242",
    "Farbtonhilfsbezeichnung": "35242",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "80",
    "Bcolor": "91",
    "Y": 8,
    "L": 32.8428077697754,
    "a": -3.68771171569824,
    "b": -9.19394493103027,
    "C": 9.90594959259033,
    "h": 248.144165039062,
    "CMY_C": 0.75662779808044,
    "CMY_M": 0.68759852647781,
    "CMY_Y": 0.64407217502594,
    "CMYK_C": 0.31623157858849,
    "CMYK_M": 0.12228982150555,
    "CMYK_Y": 0,
    "CMYK_K": 0.64407217502594
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35300",
    "Farbtonhilfsbezeichnung": "35300",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "142",
    "Y": 15,
    "L": 45.6279373168945,
    "a": -18.6915454864502,
    "b": -21.5993785858154,
    "C": 28.5640869140625,
    "h": 229.1279296875,
    "CMY_C": 1,
    "CMY_M": 0.53596729040146,
    "CMY_Y": 0.4416452050209,
    "CMYK_C": 1,
    "CMYK_M": 0.16892857849598,
    "CMYK_Y": 0,
    "CMYK_K": 0.4416452050209
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35301",
    "Farbtonhilfsbezeichnung": "35301",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "135",
    "Bcolor": "160",
    "Y": 21,
    "L": 52.1717720031738,
    "a": -19.5065479278564,
    "b": -21.8534927368164,
    "C": 29.2930126190186,
    "h": 228.24772644043,
    "CMY_C": 0.87498068809509,
    "CMY_M": 0.46878361701965,
    "CMY_Y": 0.37274205684662,
    "CMYK_C": 0.80068916082382,
    "CMYK_M": 0.15311333537102,
    "CMYK_Y": 0,
    "CMYK_K": 0.37274205684662
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35302",
    "Farbtonhilfsbezeichnung": "35302",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "159",
    "Bcolor": "182",
    "Y": 31,
    "L": 61.4821739196777,
    "a": -18.3954696655273,
    "b": -20.2972278594971,
    "C": 27.3928966522217,
    "h": 227.813842773438,
    "CMY_C": 0.70521211624146,
    "CMY_M": 0.37515062093735,
    "CMY_Y": 0.28534084558487,
    "CMYK_C": 0.58751261234283,
    "CMYK_M": 0.125667989254,
    "CMYK_Y": 0,
    "CMYK_K": 0.28534084558487
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35303",
    "Farbtonhilfsbezeichnung": "35303",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "183",
    "Bcolor": "202",
    "Y": 43,
    "L": 70.7874221801758,
    "a": -16.3625831604004,
    "b": -17.1177558898926,
    "C": 23.680196762085,
    "h": 226.292114257812,
    "CMY_C": 0.54920339584351,
    "CMY_M": 0.28137421607971,
    "CMY_Y": 0.20745182037354,
    "CMYK_C": 0.43120604753494,
    "CMYK_M": 0.09327179938555,
    "CMYK_Y": 0,
    "CMYK_K": 0.20745182037354
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35304",
    "Farbtonhilfsbezeichnung": "35304",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "197",
    "Bcolor": "212",
    "Y": 52,
    "L": 76.1588821411133,
    "a": -14.1358060836792,
    "b": -14.1911916732788,
    "C": 20.0302505493164,
    "h": 225.112030029297,
    "CMY_C": 0.44893848896027,
    "CMY_M": 0.22871232032776,
    "CMY_Y": 0.16961121559143,
    "CMYK_C": 0.336381316185,
    "CMYK_M": 0.07117281109095,
    "CMYK_Y": 0,
    "CMYK_K": 0.16961121559143
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35305",
    "Farbtonhilfsbezeichnung": "35305",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "211",
    "Bcolor": "221",
    "Y": 61,
    "L": 81.8227844238281,
    "a": -11.0448904037476,
    "b": -10.3431367874146,
    "C": 15.131757736206,
    "h": 223.12077331543,
    "CMY_C": 0.33775550127029,
    "CMY_M": 0.17440050840378,
    "CMY_Y": 0.1349168419838,
    "CMYK_C": 0.23447301983833,
    "CMYK_M": 0.0456414707005,
    "CMYK_Y": 0,
    "CMYK_K": 0.1349168419838
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35306",
    "Farbtonhilfsbezeichnung": "35306",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "218",
    "Bcolor": "224",
    "Y": 66,
    "L": 84.6478576660156,
    "a": -9.76015949249268,
    "b": -8.03937435150146,
    "C": 12.644850730896,
    "h": 219.478042602539,
    "CMY_C": 0.28472083806992,
    "CMY_M": 0.14670544862747,
    "CMY_Y": 0.12040853500366,
    "CMYK_C": 0.1868052482605,
    "CMYK_M": 0.02989673614502,
    "CMYK_Y": 0,
    "CMYK_K": 0.12040853500366
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35307",
    "Farbtonhilfsbezeichnung": "35307",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "226",
    "Bcolor": "229",
    "Y": 73,
    "L": 88.0894241333008,
    "a": -7.76209831237793,
    "b": -5.14985036849976,
    "C": 9.31510257720947,
    "h": 213.562728881836,
    "CMY_C": 0.21712774038315,
    "CMY_M": 0.11376243829727,
    "CMY_Y": 0.10330706834793,
    "CMYK_C": 0.12693382799625,
    "CMYK_M": 0.01165992207825,
    "CMYK_Y": 0,
    "CMYK_K": 0.10330706834793
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35308",
    "Farbtonhilfsbezeichnung": "35308",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 78,
    "L": 90.9081115722656,
    "a": -5.65092945098877,
    "b": -1.47924852371216,
    "C": 5.84133386611938,
    "h": 194.669204711914,
    "CMY_C": 0.15363162755966,
    "CMY_M": 0.08811885118484,
    "CMY_Y": 0.09891474246979,
    "CMYK_C": 0.07184354960918,
    "CMYK_M": 0,
    "CMYK_Y": 0.01183914300054,
    "CMYK_K": 0.08811885118484
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35309",
    "Farbtonhilfsbezeichnung": "35309",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "236",
    "Bcolor": "231",
    "Y": 82,
    "L": 92.5129623413086,
    "a": -4.13241720199585,
    "b": 0.34289526939392,
    "C": 4.14661884307861,
    "h": 175.256637573242,
    "CMY_C": 0.11652219295502,
    "CMY_M": 0.07414305210114,
    "CMY_Y": 0.09443879127502,
    "CMYK_C": 0.04577288031578,
    "CMYK_M": 0,
    "CMYK_Y": 0.02192103117704,
    "CMYK_K": 0.07414305210114
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35310",
    "Farbtonhilfsbezeichnung": "35310",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "139",
    "Bcolor": "156",
    "Y": 24,
    "L": 54.7934761047363,
    "a": -14.1174974441528,
    "b": -15.7074222564697,
    "C": 21.119348526001,
    "h": 228.051467895508,
    "CMY_C": 0.68366634845734,
    "CMY_M": 0.45335280895233,
    "CMY_Y": 0.38632571697235,
    "CMYK_C": 0.48452517390251,
    "CMYK_M": 0.10922258347273,
    "CMYK_Y": 0,
    "CMYK_K": 0.38632571697235
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35311",
    "Farbtonhilfsbezeichnung": "35311",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "155",
    "Bcolor": "171",
    "Y": 30,
    "L": 60.978759765625,
    "a": -13.5240507125854,
    "b": -14.8661336898804,
    "C": 20.0973110198975,
    "h": 227.706512451172,
    "CMY_C": 0.60660630464554,
    "CMY_M": 0.39102202653885,
    "CMY_Y": 0.32752555608749,
    "CMYK_C": 0.41500574350357,
    "CMYK_M": 0.09442213177681,
    "CMYK_Y": 0,
    "CMYK_K": 0.32752555608749
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35312",
    "Farbtonhilfsbezeichnung": "35312",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "178",
    "Bcolor": "191",
    "Y": 42,
    "L": 69.7521438598633,
    "a": -12.0849523544312,
    "b": -12.5383672714233,
    "C": 17.4142684936523,
    "h": 226.054916381836,
    "CMY_C": 0.48678147792816,
    "CMY_M": 0.30219370126724,
    "CMY_Y": 0.25044238567352,
    "CMYK_C": 0.31530478596687,
    "CMYK_M": 0.06904248148203,
    "CMYK_Y": 0,
    "CMYK_K": 0.25044238567352
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35313",
    "Farbtonhilfsbezeichnung": "35313",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "193",
    "Bcolor": "204",
    "Y": 50,
    "L": 75.4143905639648,
    "a": -10.5618667602539,
    "b": -10.966835975647,
    "C": 15.2257843017578,
    "h": 226.07763671875,
    "CMY_C": 0.40454828739166,
    "CMY_M": 0.24502319097519,
    "CMY_Y": 0.20037537813187,
    "CMYK_C": 0.2553359568119,
    "CMYK_M": 0.05583596602082,
    "CMYK_Y": 0,
    "CMYK_K": 0.20037537813187
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35314",
    "Farbtonhilfsbezeichnung": "35314",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "208",
    "Bcolor": "215",
    "Y": 60,
    "L": 81.3778533935547,
    "a": -8.72856140136719,
    "b": -7.72519874572754,
    "C": 11.656177520752,
    "h": 221.510391235352,
    "CMY_C": 0.30925244092941,
    "CMY_M": 0.18498533964157,
    "CMY_Y": 0.15850812196732,
    "CMYK_C": 0.17913936078548,
    "CMYK_M": 0.03146461397409,
    "CMYK_Y": 0,
    "CMYK_K": 0.15850812196732
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35315",
    "Farbtonhilfsbezeichnung": "35315",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 65,
    "L": 84.2050094604492,
    "a": -7.85956192016602,
    "b": -6.25158166885376,
    "C": 10.0426588058472,
    "h": 218.499114990234,
    "CMY_C": 0.26478654146194,
    "CMY_M": 0.1562374830246,
    "CMY_Y": 0.13810455799103,
    "CMYK_C": 0.14698068797588,
    "CMYK_M": 0.02103842794895,
    "CMYK_Y": 0,
    "CMYK_K": 0.13810455799103
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35320",
    "Farbtonhilfsbezeichnung": "35320",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "132",
    "Bcolor": "144",
    "Y": 22,
    "L": 53.1048889160156,
    "a": -8.9652156829834,
    "b": -10.8159608840942,
    "C": 14.0484914779663,
    "h": 230.345092773438,
    "CMY_C": 0.61758041381836,
    "CMY_M": 0.4814618229866,
    "CMY_Y": 0.43587505817413,
    "CMYK_C": 0.32210126519203,
    "CMYK_M": 0.08080969750881,
    "CMYK_Y": 0,
    "CMYK_K": 0.43587505817413
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35321",
    "Farbtonhilfsbezeichnung": "35321",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "152",
    "Bcolor": "162",
    "Y": 30,
    "L": 60.6628189086914,
    "a": -10.0107221603394,
    "b": -10.0651111602783,
    "C": 14.1958103179932,
    "h": 225.155227661133,
    "CMY_C": 0.54771900177002,
    "CMY_M": 0.40245240926743,
    "CMY_Y": 0.36332732439041,
    "CMYK_C": 0.28961768746376,
    "CMYK_M": 0.06145243346691,
    "CMYK_Y": 0,
    "CMYK_K": 0.36332732439041
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35322",
    "Farbtonhilfsbezeichnung": "35322",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "165",
    "Bcolor": "174",
    "Y": 36,
    "L": 65.7512664794922,
    "a": -8.8285665512085,
    "b": -8.95160293579102,
    "C": 12.5727796554565,
    "h": 225.396484375,
    "CMY_C": 0.4797220826149,
    "CMY_M": 0.35208654403687,
    "CMY_Y": 0.31763845682144,
    "CMYK_C": 0.23753336071968,
    "CMYK_M": 0.05048362910748,
    "CMYK_Y": 0,
    "CMYK_K": 0.31763845682144
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35323",
    "Farbtonhilfsbezeichnung": "35323",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "188",
    "Bcolor": "192",
    "Y": 48,
    "L": 74.2466354370117,
    "a": -7.81246948242188,
    "b": -6.38257837295532,
    "C": 10.088210105896,
    "h": 219.247894287109,
    "CMY_C": 0.37114244699478,
    "CMY_M": 0.26469248533249,
    "CMY_Y": 0.24529594182968,
    "CMYK_C": 0.16674947738647,
    "CMYK_M": 0.02570085972548,
    "CMYK_Y": 0,
    "CMYK_K": 0.24529594182968
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35324",
    "Farbtonhilfsbezeichnung": "35324",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "201",
    "Bcolor": "202",
    "Y": 56,
    "L": 79.4921112060547,
    "a": -6.28554534912109,
    "b": -3.92444491386414,
    "C": 7.41008424758911,
    "h": 211.979019165039,
    "CMY_C": 0.29245680570602,
    "CMY_M": 0.21195793151855,
    "CMY_Y": 0.20618802309036,
    "CMYK_C": 0.10867659747601,
    "CMYK_M": 0.00726860854775,
    "CMYK_Y": 0,
    "CMYK_K": 0.20618802309036
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35330",
    "Farbtonhilfsbezeichnung": "35330",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "112",
    "Bcolor": "124",
    "Y": 15,
    "L": 45.6612968444824,
    "a": -6.72612285614014,
    "b": -10.2506809234619,
    "C": 12.2603912353516,
    "h": 236.728576660156,
    "CMY_C": 0.66724336147308,
    "CMY_M": 0.5598132610321,
    "CMY_Y": 0.51407843828201,
    "CMYK_C": 0.31520503759384,
    "CMYK_M": 0.09411976486444,
    "CMYK_Y": 0,
    "CMYK_K": 0.51407843828201
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35331",
    "Farbtonhilfsbezeichnung": "35331",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "135",
    "Bcolor": "149",
    "Y": 23,
    "L": 54.6382904052734,
    "a": -7.42868375778198,
    "b": -11.2447929382324,
    "C": 13.4770441055298,
    "h": 236.549911499023,
    "CMY_C": 0.59044754505157,
    "CMY_M": 0.46880012750626,
    "CMY_Y": 0.41721898317337,
    "CMYK_C": 0.29724469780922,
    "CMYK_M": 0.08850862085819,
    "CMYK_Y": 0,
    "CMYK_K": 0.41721898317337
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35332",
    "Farbtonhilfsbezeichnung": "35332",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "152",
    "Bcolor": "165",
    "Y": 30,
    "L": 61.2034530639648,
    "a": -7.33484411239624,
    "b": -10.6592721939087,
    "C": 12.9390888214111,
    "h": 235.467407226562,
    "CMY_C": 0.5208101272583,
    "CMY_M": 0.4019815325737,
    "CMY_Y": 0.35335963964462,
    "CMYK_C": 0.25895458459854,
    "CMYK_M": 0.0751915499568,
    "CMYK_Y": 0,
    "CMYK_K": 0.35335963964462
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35333",
    "Farbtonhilfsbezeichnung": "35333",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "157",
    "Bcolor": "169",
    "Y": 33,
    "L": 63.1839599609375,
    "a": -6.4554181098938,
    "b": -9.71799182891846,
    "C": 11.6666955947876,
    "h": 236.404907226562,
    "CMY_C": 0.48858946561813,
    "CMY_M": 0.38350701332092,
    "CMY_Y": 0.33903539180756,
    "CMYK_C": 0.22626638412476,
    "CMYK_M": 0.06728290766478,
    "CMYK_Y": 0,
    "CMYK_K": 0.33903539180756
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35334",
    "Farbtonhilfsbezeichnung": "35334",
    "Farbtonklasse": "01",
    "Rcolor": "154",
    "Gcolor": "181",
    "Bcolor": "188",
    "Y": 44,
    "L": 71.8268356323242,
    "a": -6.93780136108398,
    "b": -7.8335394859314,
    "C": 10.4641017913818,
    "h": 228.470184326172,
    "CMY_C": 0.39517867565155,
    "CMY_M": 0.29201900959015,
    "CMY_Y": 0.26081854104996,
    "CMYK_C": 0.18176880478859,
    "CMYK_M": 0.04220948368311,
    "CMYK_Y": 0,
    "CMYK_K": 0.26081854104996
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35335",
    "Farbtonhilfsbezeichnung": "35335",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "196",
    "Bcolor": "201",
    "Y": 54,
    "L": 77.7399597167969,
    "a": -6.10479593276978,
    "b": -5.62453556060791,
    "C": 8.3008394241333,
    "h": 222.655319213867,
    "CMY_C": 0.31643807888031,
    "CMY_M": 0.2308823466301,
    "CMY_Y": 0.21289765834808,
    "CMYK_C": 0.13154631853104,
    "CMYK_M": 0.02284923754632,
    "CMYK_Y": 0,
    "CMYK_K": 0.21289765834808
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35336",
    "Farbtonhilfsbezeichnung": "35336",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "207",
    "Bcolor": "209",
    "Y": 62,
    "L": 82.1048736572266,
    "a": -5.0463080406189,
    "b": -3.49222540855408,
    "C": 6.13684463500977,
    "h": 214.684631347656,
    "CMY_C": 0.25236338376999,
    "CMY_M": 0.18629723787308,
    "CMY_Y": 0.18079406023026,
    "CMYK_C": 0.08736426383257,
    "CMYK_M": 0.00671769725159,
    "CMYK_Y": 0,
    "CMYK_K": 0.18079406023026
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35337",
    "Farbtonhilfsbezeichnung": "35337",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "227",
    "Bcolor": "222",
    "Y": 74,
    "L": 89.2344360351563,
    "a": -3.90025401115417,
    "b": 0.407286465168,
    "C": 3.92146182060242,
    "h": 174.038467407227,
    "CMY_C": 0.15068864822388,
    "CMY_M": 0.11131232976913,
    "CMY_Y": 0.13111472129822,
    "CMYK_C": 0.04430838674307,
    "CMYK_M": 0,
    "CMYK_Y": 0.02228273451328,
    "CMYK_K": 0.11131232976913
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35340",
    "Farbtonhilfsbezeichnung": "35340",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "116",
    "Bcolor": "135",
    "Y": 16,
    "L": 45.6451683044434,
    "a": -14.0834341049194,
    "b": -16.956226348877,
    "C": 22.0421581268311,
    "h": 230.287796020508,
    "CMY_C": 0.79177892208099,
    "CMY_M": 0.54484736919403,
    "CMY_Y": 0.47137981653214,
    "CMYK_C": 0.60610455274582,
    "CMYK_M": 0.13897985219955,
    "CMYK_Y": 0,
    "CMYK_K": 0.47137981653214
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35341",
    "Farbtonhilfsbezeichnung": "35341",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "122",
    "Bcolor": "133",
    "Y": 18,
    "L": 48.7160301208496,
    "a": -10.0226411819458,
    "b": -11.1424808502197,
    "C": 14.9869346618652,
    "h": 228.028686523438,
    "CMY_C": 0.67265784740448,
    "CMY_M": 0.52332770824432,
    "CMY_Y": 0.47814202308655,
    "CMYK_C": 0.37273707985878,
    "CMYK_M": 0.08658616989851,
    "CMYK_Y": 0,
    "CMYK_K": 0.47814202308655
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35342",
    "Farbtonhilfsbezeichnung": "35342",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "102",
    "Bcolor": "113",
    "Y": 13,
    "L": 42.0353469848633,
    "a": -5.27776575088501,
    "b": -9.08766078948975,
    "C": 10.5090618133545,
    "h": 239.853622436523,
    "CMY_C": 0.68392610549927,
    "CMY_M": 0.59805828332901,
    "CMY_Y": 0.55701321363449,
    "CMYK_C": 0.28649362921715,
    "CMYK_M": 0.09265529364347,
    "CMYK_Y": 0,
    "CMYK_K": 0.55701321363449
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35400",
    "Farbtonhilfsbezeichnung": "35400",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "125",
    "Bcolor": "129",
    "Y": 17,
    "L": 47.5335006713867,
    "a": -24.0858669281006,
    "b": -10.5281820297241,
    "C": 26.2863388061523,
    "h": 203.610641479492,
    "CMY_C": 0.87342441082001,
    "CMY_M": 0.51175427436829,
    "CMY_Y": 0.4952380657196,
    "CMYK_C": 0.74923706054688,
    "CMYK_M": 0.03272078931332,
    "CMYK_Y": 0,
    "CMYK_K": 0.4952380657196
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35401",
    "Farbtonhilfsbezeichnung": "35401",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 26,
    "L": 56.9146118164063,
    "a": -23.3537502288818,
    "b": -10.6427888870239,
    "C": 25.6645011901856,
    "h": 204.499740600586,
    "CMY_C": 0.74244749546051,
    "CMY_M": 0.41705346107483,
    "CMY_Y": 0.39944851398468,
    "CMYK_C": 0.57113999128342,
    "CMYK_M": 0.02931463345885,
    "CMYK_Y": 0,
    "CMYK_K": 0.39944851398468
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35402",
    "Farbtonhilfsbezeichnung": "35402",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "162",
    "Bcolor": "167",
    "Y": 32,
    "L": 62.270320892334,
    "a": -21.7242832183838,
    "b": -10.3346662521362,
    "C": 24.0572185516357,
    "h": 205.441345214844,
    "CMY_C": 0.65814423561096,
    "CMY_M": 0.36400192975998,
    "CMY_Y": 0.34590256214142,
    "CMYK_C": 0.47736263275146,
    "CMYK_M": 0.02767075225711,
    "CMYK_Y": 0,
    "CMYK_K": 0.34590256214142
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35403",
    "Farbtonhilfsbezeichnung": "35403",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "185",
    "Bcolor": "187",
    "Y": 43,
    "L": 71.07080078125,
    "a": -18.8903713226318,
    "b": -8.57059574127197,
    "C": 20.7437038421631,
    "h": 204.403884887695,
    "CMY_C": 0.52055954933167,
    "CMY_M": 0.27608680725098,
    "CMY_Y": 0.26500588655472,
    "CMYK_C": 0.34769484400749,
    "CMYK_M": 0.01507620327175,
    "CMYK_Y": 0,
    "CMYK_K": 0.26500588655472
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35404",
    "Farbtonhilfsbezeichnung": "35404",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "197",
    "Bcolor": "201",
    "Y": 51,
    "L": 76.3607635498047,
    "a": -15.5318384170532,
    "b": -7.94705009460449,
    "C": 17.4468803405762,
    "h": 207.097091674805,
    "CMY_C": 0.42706155776978,
    "CMY_M": 0.22559881210327,
    "CMY_Y": 0.21226179599762,
    "CMYK_C": 0.2726791203022,
    "CMYK_M": 0.01693077199161,
    "CMYK_Y": 0,
    "CMYK_K": 0.21226179599762
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35405",
    "Farbtonhilfsbezeichnung": "35405",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "212",
    "Bcolor": "213",
    "Y": 61,
    "L": 82.2874603271484,
    "a": -12.4330472946167,
    "b": -5.65063810348511,
    "C": 13.6568803787231,
    "h": 204.441101074219,
    "CMY_C": 0.32366645336151,
    "CMY_M": 0.1677657365799,
    "CMY_Y": 0.16404718160629,
    "CMYK_C": 0.19094291329384,
    "CMYK_M": 0.00444828346372,
    "CMYK_Y": 0,
    "CMYK_K": 0.16404718160629
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35406",
    "Farbtonhilfsbezeichnung": "35406",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "219",
    "Bcolor": "218",
    "Y": 66,
    "L": 85.0554122924805,
    "a": -10.6857995986938,
    "b": -4.09578561782837,
    "C": 11.4438533782959,
    "h": 200.971450805664,
    "CMY_C": 0.27132999897003,
    "CMY_M": 0.14136576652527,
    "CMY_Y": 0.14485239982605,
    "CMYK_C": 0.15136158466339,
    "CMYK_M": 0,
    "CMYK_Y": 0.00406067352742,
    "CMYK_K": 0.14136576652527
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35407",
    "Farbtonhilfsbezeichnung": "35407",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "227",
    "Bcolor": "224",
    "Y": 73,
    "L": 88.4355087280273,
    "a": -7.85203886032104,
    "b": -2.26471972465515,
    "C": 8.17211532592773,
    "h": 196.088851928711,
    "CMY_C": 0.20243972539902,
    "CMY_M": 0.11054670810699,
    "CMY_Y": 0.12074106931686,
    "CMYK_C": 0.10331404209137,
    "CMYK_M": 0,
    "CMYK_Y": 0.01146137900651,
    "CMYK_K": 0.11054670810699
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35408",
    "Farbtonhilfsbezeichnung": "35408",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "233",
    "Bcolor": "228",
    "Y": 78,
    "L": 91.226936340332,
    "a": -5.66229438781738,
    "b": -0.21234534680843,
    "C": 5.6662745475769,
    "h": 182.147674560547,
    "CMY_C": 0.14544671773911,
    "CMY_M": 0.08488756418228,
    "CMY_Y": 0.10477465391159,
    "CMYK_C": 0.06617673486471,
    "CMYK_M": 0,
    "CMYK_Y": 0.02173185348511,
    "CMYK_K": 0.08488756418228
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35409",
    "Farbtonhilfsbezeichnung": "35409",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "238",
    "Bcolor": "231",
    "Y": 83,
    "L": 93.093864440918,
    "a": -4.10210800170898,
    "b": 1.01452696323395,
    "C": 4.22570180892944,
    "h": 166.108459472656,
    "CMY_C": 0.1073916554451,
    "CMY_M": 0.06788575649261,
    "CMY_Y": 0.09298652410507,
    "CMYK_C": 0.04238310828805,
    "CMYK_M": 0,
    "CMYK_Y": 0.02692885324359,
    "CMYK_K": 0.06788575649261
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35410",
    "Farbtonhilfsbezeichnung": "35410",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "155",
    "Bcolor": "158",
    "Y": 30,
    "L": 60.2750053405762,
    "a": -17.085168838501,
    "b": -8.37379264831543,
    "C": 19.026912689209,
    "h": 206.110427856445,
    "CMY_C": 0.61262005567551,
    "CMY_M": 0.39366161823273,
    "CMY_Y": 0.37962448596954,
    "CMYK_C": 0.37557184696198,
    "CMYK_M": 0.02262683212757,
    "CMYK_Y": 0,
    "CMYK_K": 0.37962448596954
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35411",
    "Farbtonhilfsbezeichnung": "35411",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "182",
    "Bcolor": "184",
    "Y": 43,
    "L": 70.8268432617188,
    "a": -14.4885444641113,
    "b": -7.130615234375,
    "C": 16.1481761932373,
    "h": 206.204360961914,
    "CMY_C": 0.4709500670433,
    "CMY_M": 0.28756135702133,
    "CMY_Y": 0.27728480100632,
    "CMYK_C": 0.26796898245811,
    "CMYK_M": 0.01421937160194,
    "CMYK_Y": 0,
    "CMYK_K": 0.27728480100632
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35412",
    "Farbtonhilfsbezeichnung": "35412",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "193",
    "Bcolor": "195",
    "Y": 50,
    "L": 75.2882308959961,
    "a": -13.2215871810913,
    "b": -6.08566522598267,
    "C": 14.5549201965332,
    "h": 204.715789794922,
    "CMY_C": 0.40726882219315,
    "CMY_M": 0.24238407611847,
    "CMY_Y": 0.2368580698967,
    "CMYK_C": 0.22330151498318,
    "CMYK_M": 0.00724112521857,
    "CMYK_Y": 0,
    "CMYK_K": 0.2368580698967
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35413",
    "Farbtonhilfsbezeichnung": "35413",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "208",
    "Bcolor": "208",
    "Y": 60,
    "L": 81.2660675048828,
    "a": -10.5184850692749,
    "b": -4.18041515350342,
    "C": 11.3187627792358,
    "h": 201.674606323242,
    "CMY_C": 0.31095194816589,
    "CMY_M": 0.1834254860878,
    "CMY_Y": 0.18561440706253,
    "CMYK_C": 0.15617246925831,
    "CMYK_M": 0,
    "CMYK_Y": 0.00268061389215,
    "CMYK_K": 0.1834254860878
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35414",
    "Farbtonhilfsbezeichnung": "35414",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "215",
    "Bcolor": "213",
    "Y": 65,
    "L": 84.0532531738281,
    "a": -9.04901123046875,
    "b": -2.95932292938232,
    "C": 9.52061939239502,
    "h": 198.109436035156,
    "CMY_C": 0.26310533285141,
    "CMY_M": 0.15627747774124,
    "CMY_Y": 0.16392129659653,
    "CMYK_C": 0.12661491334438,
    "CMYK_M": 0,
    "CMYK_Y": 0.00905963592231,
    "CMYK_K": 0.15627747774124
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35415",
    "Farbtonhilfsbezeichnung": "35415",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "226",
    "Bcolor": "222",
    "Y": 72,
    "L": 88.2224884033203,
    "a": -6.91295623779297,
    "b": -1.27568304538727,
    "C": 7.02967500686646,
    "h": 190.455459594727,
    "CMY_C": 0.19295871257782,
    "CMY_M": 0.11528366804123,
    "CMY_Y": 0.13025152683258,
    "CMYK_C": 0.08779655396938,
    "CMYK_M": 0,
    "CMYK_Y": 0.01691825687885,
    "CMYK_K": 0.11528366804123
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35420",
    "Farbtonhilfsbezeichnung": "35420",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "138",
    "Bcolor": "143",
    "Y": 23,
    "L": 54.1743011474609,
    "a": -14.8356838226318,
    "b": -8.54454135894775,
    "C": 17.1203594207764,
    "h": 209.939575195312,
    "CMY_C": 0.65203607082367,
    "CMY_M": 0.46045035123825,
    "CMY_Y": 0.44074863195419,
    "CMYK_C": 0.37780407071114,
    "CMYK_M": 0.03522873669863,
    "CMYK_Y": 0,
    "CMYK_K": 0.44074863195419
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35421",
    "Farbtonhilfsbezeichnung": "35421",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "167",
    "Bcolor": "171",
    "Y": 35,
    "L": 65.5570983886719,
    "a": -13.0184478759766,
    "b": -7.41825914382935,
    "C": 14.9836759567261,
    "h": 209.675643920898,
    "CMY_C": 0.51286804676056,
    "CMY_M": 0.34627592563629,
    "CMY_Y": 0.33076971769333,
    "CMYK_C": 0.27210116386414,
    "CMYK_M": 0.02317021228373,
    "CMYK_Y": 0,
    "CMYK_K": 0.33076971769333
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35422",
    "Farbtonhilfsbezeichnung": "35422",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "187",
    "Bcolor": "190",
    "Y": 47,
    "L": 73.9095153808594,
    "a": -9.06838893890381,
    "b": -5.74151802062988,
    "C": 10.7331590652466,
    "h": 212.339340209961,
    "CMY_C": 0.38285851478577,
    "CMY_M": 0.2658639550209,
    "CMY_Y": 0.25360757112503,
    "CMYK_C": 0.17316754162312,
    "CMYK_M": 0.01642083004117,
    "CMYK_Y": 0,
    "CMYK_K": 0.25360757112503
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35423",
    "Farbtonhilfsbezeichnung": "35423",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "201",
    "Bcolor": "201",
    "Y": 56,
    "L": 79.3221817016602,
    "a": -6.59079551696777,
    "b": -3.58721232414246,
    "C": 7.50377750396729,
    "h": 208.558395385742,
    "CMY_C": 0.29550474882126,
    "CMY_M": 0.21323841810226,
    "CMY_Y": 0.21049278974533,
    "CMYK_C": 0.10767724364996,
    "CMYK_M": 0.00347764813341,
    "CMYK_Y": 0,
    "CMYK_K": 0.21049278974533
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35430",
    "Farbtonhilfsbezeichnung": "35430",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 18,
    "L": 49.2136116027832,
    "a": -7.44356298446655,
    "b": -6.17809724807739,
    "C": 9.67344379425049,
    "h": 219.692398071289,
    "CMY_C": 0.62051093578339,
    "CMY_M": 0.52458345890045,
    "CMY_Y": 0.5054669380188,
    "CMYK_C": 0.23263156414032,
    "CMYK_M": 0.03865569829941,
    "CMYK_Y": 0,
    "CMYK_K": 0.5054669380188
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35431",
    "Farbtonhilfsbezeichnung": "35431",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 29,
    "L": 59.9518547058105,
    "a": -7.14553737640381,
    "b": -5.59264707565308,
    "C": 9.07394123077393,
    "h": 218.049468994141,
    "CMY_C": 0.50940316915512,
    "CMY_M": 0.41672915220261,
    "CMY_Y": 0.40086382627487,
    "CMYK_C": 0.18115971982479,
    "CMYK_M": 0.02648033387959,
    "CMYK_Y": 0,
    "CMYK_K": 0.40086382627487
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35432",
    "Farbtonhilfsbezeichnung": "35432",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "166",
    "Bcolor": "170",
    "Y": 37,
    "L": 66.6811828613281,
    "a": -6.49555349349976,
    "b": -5.3078408241272,
    "C": 8.38840770721436,
    "h": 219.253967285156,
    "CMY_C": 0.43426382541656,
    "CMY_M": 0.34814411401749,
    "CMY_Y": 0.33291000127792,
    "CMYK_C": 0.15193425118923,
    "CMYK_M": 0.02283666841686,
    "CMYK_Y": 0,
    "CMYK_K": 0.33291000127792
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35433",
    "Farbtonhilfsbezeichnung": "35433",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "186",
    "Bcolor": "188",
    "Y": 48,
    "L": 74.1259918212891,
    "a": -5.45223808288574,
    "b": -3.99118185043335,
    "C": 6.75695419311523,
    "h": 216.205108642578,
    "CMY_C": 0.34279149770737,
    "CMY_M": 0.27170610427856,
    "CMY_Y": 0.263287961483,
    "CMYK_C": 0.10791670531034,
    "CMYK_M": 0.01142663974315,
    "CMYK_Y": 0,
    "CMYK_K": 0.263287961483
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35434",
    "Farbtonhilfsbezeichnung": "35434",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "194",
    "Bcolor": "195",
    "Y": 53,
    "L": 77.3460006713867,
    "a": -4.86424493789673,
    "b": -3.33496999740601,
    "C": 5.89770317077637,
    "h": 214.43489074707,
    "CMY_C": 0.30129271745682,
    "CMY_M": 0.2385066151619,
    "CMY_Y": 0.23339682817459,
    "CMYK_C": 0.08856718987226,
    "CMYK_M": 0.00666549149901,
    "CMYK_Y": 0,
    "CMYK_K": 0.23339682817459
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35435",
    "Farbtonhilfsbezeichnung": "35435",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "209",
    "Bcolor": "209",
    "Y": 62,
    "L": 82.7867889404297,
    "a": -4.06942176818848,
    "b": -2.24488139152527,
    "C": 4.64754629135132,
    "h": 208.883163452148,
    "CMY_C": 0.23222815990448,
    "CMY_M": 0.18136817216873,
    "CMY_Y": 0.18229669332504,
    "CMYK_C": 0.06212803721428,
    "CMYK_M": 0,
    "CMYK_Y": 0.00113423529547,
    "CMYK_K": 0.18136817216873
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35436",
    "Farbtonhilfsbezeichnung": "35436",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "220",
    "Bcolor": "218",
    "Y": 71,
    "L": 87.1503295898438,
    "a": -3.2218816280365,
    "b": -0.70272916555405,
    "C": 3.2976279258728,
    "h": 192.304168701172,
    "CMY_C": 0.17210525274277,
    "CMY_M": 0.13567847013474,
    "CMY_Y": 0.14575934410095,
    "CMYK_C": 0.04214494302869,
    "CMYK_M": 0,
    "CMYK_Y": 0.01166333816946,
    "CMYK_K": 0.13567847013474
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35437",
    "Farbtonhilfsbezeichnung": "35437",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "228",
    "Bcolor": "223",
    "Y": 76,
    "L": 89.8381118774414,
    "a": -2.60065150260925,
    "b": 0.74072802066803,
    "C": 2.70408320426941,
    "h": 164.101776123047,
    "CMY_C": 0.13232147693634,
    "CMY_M": 0.10768294334412,
    "CMY_Y": 0.12675100564957,
    "CMYK_C": 0.02761185914278,
    "CMYK_M": 0,
    "CMYK_Y": 0.02136915549636,
    "CMYK_K": 0.10768294334412
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35440",
    "Farbtonhilfsbezeichnung": "35440",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "137",
    "Bcolor": "141",
    "Y": 22,
    "L": 53.574535369873,
    "a": -17.9893417358398,
    "b": -8.71027660369873,
    "C": 19.9871292114258,
    "h": 205.835845947266,
    "CMY_C": 0.69347667694092,
    "CMY_M": 0.46097874641418,
    "CMY_Y": 0.44602704048157,
    "CMYK_C": 0.44668179750443,
    "CMYK_M": 0.02698995545506,
    "CMYK_Y": 0,
    "CMYK_K": 0.44602704048157
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35441",
    "Farbtonhilfsbezeichnung": "35441",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "112",
    "Bcolor": "116",
    "Y": 14,
    "L": 43.5456809997559,
    "a": -17.6349697113037,
    "b": -8.77804088592529,
    "C": 19.6988868713379,
    "h": 206.462448120117,
    "CMY_C": 0.79343903064728,
    "CMY_M": 0.5620089173317,
    "CMY_Y": 0.54539442062378,
    "CMYK_C": 0.54562598466873,
    "CMYK_M": 0.03654705733061,
    "CMYK_Y": 0,
    "CMYK_K": 0.54539442062378
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "35442",
    "Farbtonhilfsbezeichnung": "35442",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "85",
    "Bcolor": "90",
    "Y": 8,
    "L": 33.8240432739258,
    "a": -11.2467193603516,
    "b": -7.04821491241455,
    "C": 13.2727556228638,
    "h": 212.074981689453,
    "CMY_C": 0.80469089746475,
    "CMY_M": 0.66609185934067,
    "CMY_Y": 0.6487004160881,
    "CMYK_C": 0.44403833150864,
    "CMYK_M": 0.04950601607561,
    "CMYK_Y": 0,
    "CMYK_K": 0.6487004160881
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36100",
    "Farbtonhilfsbezeichnung": "36100",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "128",
    "Bcolor": "93",
    "Y": 17,
    "L": 48.138053894043,
    "a": -31.4317893981934,
    "b": 11.3600749969482,
    "C": 33.4216804504395,
    "h": 160.129135131836,
    "CMY_C": 0.78967368602753,
    "CMY_M": 0.4996092915535,
    "CMY_Y": 0.63407278060913,
    "CMYK_C": 0.57967579364777,
    "CMYK_M": 0,
    "CMYK_Y": 0.26871699094772,
    "CMYK_K": 0.4996092915535
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36101",
    "Farbtonhilfsbezeichnung": "36101",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "142",
    "Bcolor": "109",
    "Y": 22,
    "L": 53.7699508666992,
    "a": -30.7085590362549,
    "b": 10.5041170120239,
    "C": 32.4553871154785,
    "h": 161.116317749023,
    "CMY_C": 0.72614741325378,
    "CMY_M": 0.44282782077789,
    "CMY_Y": 0.57436341047287,
    "CMYK_C": 0.50849556922913,
    "CMYK_M": 0,
    "CMYK_Y": 0.23607710003853,
    "CMYK_K": 0.44282782077789
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36102",
    "Farbtonhilfsbezeichnung": "36102",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "165",
    "Bcolor": "132",
    "Y": 32,
    "L": 62.7244873046875,
    "a": -28.0641002655029,
    "b": 9.82412338256836,
    "C": 29.7339382171631,
    "h": 160.706878662109,
    "CMY_C": 0.60807752609253,
    "CMY_M": 0.35328900814056,
    "CMY_Y": 0.48109585046768,
    "CMYK_C": 0.39397585391998,
    "CMYK_M": 0,
    "CMYK_Y": 0.19762590527534,
    "CMYK_K": 0.35328900814056
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36103",
    "Farbtonhilfsbezeichnung": "36103",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "188",
    "Bcolor": "159",
    "Y": 45,
    "L": 71.9954299926758,
    "a": -22.761812210083,
    "b": 8.39440631866455,
    "C": 24.2603816986084,
    "h": 159.756362915039,
    "CMY_C": 0.46684455871582,
    "CMY_M": 0.263218998909,
    "CMY_Y": 0.37583595514297,
    "CMYK_C": 0.27637189626694,
    "CMYK_M": 0,
    "CMYK_Y": 0.15284997224808,
    "CMYK_K": 0.263218998909
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36104",
    "Farbtonhilfsbezeichnung": "36104",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "201",
    "Bcolor": "176",
    "Y": 54,
    "L": 77.3864669799805,
    "a": -19.2026042938232,
    "b": 7.36051511764526,
    "C": 20.5649509429932,
    "h": 159.027755737305,
    "CMY_C": 0.38214099407196,
    "CMY_M": 0.21121490001678,
    "CMY_Y": 0.31160390377045,
    "CMYK_C": 0.21669538319111,
    "CMYK_M": 0,
    "CMYK_Y": 0.1272704154253,
    "CMYK_K": 0.21121490001678
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36105",
    "Farbtonhilfsbezeichnung": "36105",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "214",
    "Bcolor": "192",
    "Y": 62,
    "L": 82.7763519287109,
    "a": -15.0361051559448,
    "b": 6.59122085571289,
    "C": 16.4173278808594,
    "h": 156.329299926758,
    "CMY_C": 0.29129368066788,
    "CMY_M": 0.16025167703629,
    "CMY_Y": 0.24815404415131,
    "CMYK_C": 0.15604914724827,
    "CMYK_M": 0,
    "CMYK_Y": 0.10467703640461,
    "CMYK_K": 0.16025167703629
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36106",
    "Farbtonhilfsbezeichnung": "36106",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 68,
    "L": 85.4407806396484,
    "a": -12.4483060836792,
    "b": 5.21939945220947,
    "C": 13.4982385635376,
    "h": 157.252380371094,
    "CMY_C": 0.24557185173035,
    "CMY_M": 0.13586646318436,
    "CMY_Y": 0.20907551050186,
    "CMYK_C": 0.12695421278477,
    "CMYK_M": 0,
    "CMYK_Y": 0.0847195982933,
    "CMYK_K": 0.13586646318436
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36107",
    "Farbtonhilfsbezeichnung": "36107",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "221",
    "Bcolor": "201",
    "Y": 74,
    "L": 85.5196380615234,
    "a": -12.5316781997681,
    "b": 5.70057725906372,
    "C": 13.7673358917236,
    "h": 155.539520263672,
    "CMY_C": 0.24365985393524,
    "CMY_M": 0.13493895530701,
    "CMY_Y": 0.2117635011673,
    "CMYK_C": 0.12568002939224,
    "CMYK_M": 0,
    "CMYK_Y": 0.08880823850632,
    "CMYK_K": 0.13493895530701
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36108",
    "Farbtonhilfsbezeichnung": "36108",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "235",
    "Bcolor": "219",
    "Y": 80,
    "L": 91.5458068847656,
    "a": -6.72983264923096,
    "b": 5.22024488449097,
    "C": 8.51713562011719,
    "h": 142.199737548828,
    "CMY_C": 0.13124418258667,
    "CMY_M": 0.08039087057114,
    "CMY_Y": 0.14172685146332,
    "CMYK_C": 0.05529883503914,
    "CMYK_M": 0,
    "CMYK_Y": 0.06669788062572,
    "CMYK_K": 0.08039087057114
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36109",
    "Farbtonhilfsbezeichnung": "36109",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "224",
    "Y": 84,
    "L": 93.2214965820312,
    "a": -4.59563398361206,
    "b": 4.93197965621948,
    "C": 6.74123668670654,
    "h": 132.978164672852,
    "CMY_C": 0.09631150960922,
    "CMY_M": 0.06639504432678,
    "CMY_Y": 0.12082827091217,
    "CMYK_C": 0.03204403072596,
    "CMYK_M": 0,
    "CMYK_Y": 0.05830434709787,
    "CMYK_K": 0.06639504432678
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36110",
    "Farbtonhilfsbezeichnung": "36110",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "148",
    "Bcolor": "129",
    "Y": 28,
    "L": 58.7441444396973,
    "a": -13.4594058990479,
    "b": 6.18648099899292,
    "C": 14.8131074905396,
    "h": 155.314590454102,
    "CMY_C": 0.52867841720581,
    "CMY_M": 0.41984343528748,
    "CMY_Y": 0.49399101734161,
    "CMYK_C": 0.18759587407112,
    "CMYK_M": 0,
    "CMYK_Y": 0.1278061568737,
    "CMYK_K": 0.41984343528748
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36111",
    "Farbtonhilfsbezeichnung": "36111",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "174",
    "Bcolor": "156",
    "Y": 40,
    "L": 68.8681564331055,
    "a": -12.2193660736084,
    "b": 5.7407865524292,
    "C": 13.5007238388062,
    "h": 154.835372924805,
    "CMY_C": 0.41721761226654,
    "CMY_M": 0.31626671552658,
    "CMY_Y": 0.38802319765091,
    "CMYK_C": 0.14764660596848,
    "CMYK_M": 0,
    "CMYK_Y": 0.1049480587244,
    "CMYK_K": 0.31626671552658
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36112",
    "Farbtonhilfsbezeichnung": "36112",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "189",
    "Bcolor": "172",
    "Y": 49,
    "L": 74.654296875,
    "a": -10.441068649292,
    "b": 5.26042699813843,
    "C": 11.6913642883301,
    "h": 153.26008605957,
    "CMY_C": 0.34397923946381,
    "CMY_M": 0.25792723894119,
    "CMY_Y": 0.32413446903229,
    "CMYK_C": 0.11596167832613,
    "CMYK_M": 0,
    "CMYK_Y": 0.08921932429075,
    "CMYK_K": 0.25792723894119
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36113",
    "Farbtonhilfsbezeichnung": "36113",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "206",
    "Bcolor": "191",
    "Y": 59,
    "L": 81.1144866943359,
    "a": -8.45854568481445,
    "b": 4.82542991638184,
    "C": 9.73816013336182,
    "h": 150.296112060547,
    "CMY_C": 0.26058173179626,
    "CMY_M": 0.19192057847977,
    "CMY_Y": 0.25221467018127,
    "CMYK_C": 0.08496832102537,
    "CMYK_M": 0,
    "CMYK_Y": 0.07461406290531,
    "CMYK_K": 0.19192057847977
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36114",
    "Farbtonhilfsbezeichnung": "36114",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "214",
    "Bcolor": "199",
    "Y": 65,
    "L": 84.0377044677734,
    "a": -7.29834461212158,
    "b": 4.58785009384155,
    "C": 8.62056827545166,
    "h": 147.845901489258,
    "CMY_C": 0.2204087972641,
    "CMY_M": 0.1623210310936,
    "CMY_Y": 0.21890592575073,
    "CMYK_C": 0.06934370845556,
    "CMYK_M": 0,
    "CMYK_Y": 0.0675496160984,
    "CMYK_K": 0.1623210310936
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36115",
    "Farbtonhilfsbezeichnung": "36115",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "223",
    "Bcolor": "211",
    "Y": 72,
    "L": 87.7153701782227,
    "a": -5.70558214187622,
    "b": 3.71465516090393,
    "C": 6.80825471878052,
    "h": 146.933609008789,
    "CMY_C": 0.17038786411285,
    "CMY_M": 0.12499707937241,
    "CMY_Y": 0.1723797917366,
    "CMYK_C": 0.05187501013279,
    "CMYK_M": 0,
    "CMYK_Y": 0.0541514903307,
    "CMYK_K": 0.12499707937241
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36120",
    "Farbtonhilfsbezeichnung": "36120",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "146",
    "Bcolor": "129",
    "Y": 26,
    "L": 57.5824012756348,
    "a": -15.6220006942749,
    "b": 4.41042947769165,
    "C": 16.23264503479,
    "h": 164.234481811523,
    "CMY_C": 0.56493079662323,
    "CMY_M": 0.42739814519882,
    "CMY_Y": 0.49376863241196,
    "CMYK_C": 0.24018897116184,
    "CMYK_M": 0,
    "CMYK_Y": 0.11591035872698,
    "CMYK_K": 0.42739814519882
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36121",
    "Farbtonhilfsbezeichnung": "36121",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "173",
    "Bcolor": "157",
    "Y": 39,
    "L": 68.0102615356445,
    "a": -13.123387336731,
    "b": 3.80946063995361,
    "C": 13.6651115417481,
    "h": 163.813034057617,
    "CMY_C": 0.44058281183243,
    "CMY_M": 0.32310348749161,
    "CMY_Y": 0.38345766067505,
    "CMYK_C": 0.17355580627918,
    "CMYK_M": 0,
    "CMYK_Y": 0.08916307240725,
    "CMYK_K": 0.32310348749161
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36122",
    "Farbtonhilfsbezeichnung": "36122",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "191",
    "Bcolor": "180",
    "Y": 50,
    "L": 75.5719909667969,
    "a": -8.91460037231445,
    "b": 2.30756807327271,
    "C": 9.20841884613037,
    "h": 165.487365722656,
    "CMY_C": 0.33233630657196,
    "CMY_M": 0.25048315525055,
    "CMY_Y": 0.29318416118622,
    "CMYK_C": 0.10920789092779,
    "CMYK_M": 0,
    "CMYK_Y": 0.05697137489915,
    "CMYK_K": 0.25048315525055
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36123",
    "Farbtonhilfsbezeichnung": "36123",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "200",
    "Bcolor": "191",
    "Y": 57,
    "L": 79.3541259765625,
    "a": -6.49229574203491,
    "b": 1.89650905132294,
    "C": 6.76362705230713,
    "h": 163.716033935547,
    "CMY_C": 0.27384549379349,
    "CMY_M": 0.21461468935013,
    "CMY_Y": 0.24963223934174,
    "CMYK_C": 0.07541623711586,
    "CMYK_M": 0,
    "CMYK_Y": 0.04458645731211,
    "CMYK_K": 0.21461468935013
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36124",
    "Farbtonhilfsbezeichnung": "36124",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "212",
    "Bcolor": "205",
    "Y": 64,
    "L": 83.8991470336914,
    "a": -4.03038644790649,
    "b": 1.29386258125305,
    "C": 4.23297691345215,
    "h": 162.201965332031,
    "CMY_C": 0.20706593990326,
    "CMY_M": 0.17024332284927,
    "CMY_Y": 0.19594103097916,
    "CMYK_C": 0.04437761008739,
    "CMYK_M": 0,
    "CMYK_Y": 0.03097017295659,
    "CMYK_K": 0.17024332284927
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36130",
    "Farbtonhilfsbezeichnung": "36130",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "123",
    "Bcolor": "114",
    "Y": 19,
    "L": 49.7369117736816,
    "a": -9.58596038818359,
    "b": 2.05168032646179,
    "C": 9.80306243896484,
    "h": 167.91926574707,
    "CMY_C": 0.60070550441742,
    "CMY_M": 0.51741802692413,
    "CMY_Y": 0.55458414554596,
    "CMYK_C": 0.17258721590042,
    "CMYK_M": 0,
    "CMYK_Y": 0.07701513916254,
    "CMYK_K": 0.51741802692413
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36131",
    "Farbtonhilfsbezeichnung": "36131",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "150",
    "Bcolor": "140",
    "Y": 29,
    "L": 60.1650810241699,
    "a": -9.17318058013916,
    "b": 2.25654244422913,
    "C": 9.44665145874023,
    "h": 166.180023193359,
    "CMY_C": 0.49369549751282,
    "CMY_M": 0.41253703832626,
    "CMY_Y": 0.4523983001709,
    "CMYK_C": 0.13815076649189,
    "CMYK_M": 0,
    "CMYK_Y": 0.06785323470831,
    "CMYK_K": 0.41253703832626
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36132",
    "Farbtonhilfsbezeichnung": "36132",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "167",
    "Bcolor": "158",
    "Y": 38,
    "L": 66.7929763793945,
    "a": -8.30629348754883,
    "b": 1.75754487514496,
    "C": 8.49019908905029,
    "h": 168.052886962891,
    "CMY_C": 0.42101752758026,
    "CMY_M": 0.34512090682983,
    "CMY_Y": 0.38109940290451,
    "CMYK_C": 0.11589409410954,
    "CMYK_M": 0,
    "CMYK_Y": 0.05493914335966,
    "CMYK_K": 0.34512090682983
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36133",
    "Farbtonhilfsbezeichnung": "36133",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "187",
    "Bcolor": "178",
    "Y": 48,
    "L": 74.5796203613281,
    "a": -6.94824743270874,
    "b": 2.1440167427063,
    "C": 7.2715163230896,
    "h": 162.851364135742,
    "CMY_C": 0.32747137546539,
    "CMY_M": 0.26529437303543,
    "CMY_Y": 0.30225896835327,
    "CMYK_C": 0.08462845534086,
    "CMYK_M": 0,
    "CMYK_Y": 0.05031211674213,
    "CMYK_K": 0.26529437303543
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36134",
    "Farbtonhilfsbezeichnung": "36134",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "197",
    "Bcolor": "188",
    "Y": 55,
    "L": 78.1177368164063,
    "a": -6.30703401565552,
    "b": 1.67119097709656,
    "C": 6.52468824386597,
    "h": 165.159240722656,
    "CMY_C": 0.28638219833374,
    "CMY_M": 0.22837966680527,
    "CMY_Y": 0.2612093091011,
    "CMYK_C": 0.07516977936029,
    "CMYK_M": 0,
    "CMYK_Y": 0.04254636913538,
    "CMYK_K": 0.22837966680527
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36135",
    "Farbtonhilfsbezeichnung": "36135",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "211",
    "Bcolor": "203",
    "Y": 64,
    "L": 83.6149520874023,
    "a": -5.11322259902954,
    "b": 2.09474229812622,
    "C": 5.5256667137146,
    "h": 157.72248840332,
    "CMY_C": 0.216044485569,
    "CMY_M": 0.17115116119385,
    "CMY_Y": 0.20500087738037,
    "CMYK_C": 0.05416346341372,
    "CMYK_M": 0,
    "CMYK_Y": 0.04083943367004,
    "CMYK_K": 0.17115116119385
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36136",
    "Farbtonhilfsbezeichnung": "36136",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "225",
    "Bcolor": "215",
    "Y": 74,
    "L": 88.5861968994141,
    "a": -4.3323974609375,
    "b": 2.96489024162292,
    "C": 5.24978494644165,
    "h": 145.61408996582,
    "CMY_C": 0.15233147144318,
    "CMY_M": 0.11823946237564,
    "CMY_Y": 0.15715080499649,
    "CMYK_C": 0.03866356983781,
    "CMYK_M": 0,
    "CMYK_Y": 0.04412914812565,
    "CMYK_K": 0.11823946237564
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36137",
    "Farbtonhilfsbezeichnung": "36137",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "231",
    "Bcolor": "222",
    "Y": 79,
    "L": 91.1670227050781,
    "a": -3.06139087677002,
    "b": 3.03360772132874,
    "C": 4.30985975265503,
    "h": 135.261169433594,
    "CMY_C": 0.11333388090134,
    "CMY_M": 0.09243458509445,
    "CMY_Y": 0.12914460897446,
    "CMYK_C": 0.02302786707878,
    "CMYK_M": 0,
    "CMYK_Y": 0.04044890031219,
    "CMYK_K": 0.09243458509445
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36140",
    "Farbtonhilfsbezeichnung": "36140",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "118",
    "Bcolor": "100",
    "Y": 17,
    "L": 46.8943786621094,
    "a": -14.2176465988159,
    "b": 6.14472675323486,
    "C": 15.4886779785156,
    "h": 156.62646484375,
    "CMY_C": 0.65074551105499,
    "CMY_M": 0.53819811344147,
    "CMY_Y": 0.60935890674591,
    "CMYK_C": 0.24371358752251,
    "CMYK_M": 0,
    "CMYK_Y": 0.15409377217293,
    "CMYK_K": 0.53819811344147
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36141",
    "Farbtonhilfsbezeichnung": "36141",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "101",
    "Bcolor": "81",
    "Y": 11,
    "L": 39.4369125366211,
    "a": -17.8341464996338,
    "b": 6.36576080322266,
    "C": 18.9362010955811,
    "h": 160.356369018555,
    "CMY_C": 0.75104224681854,
    "CMY_M": 0.60521137714386,
    "CMY_Y": 0.6810497045517,
    "CMYK_C": 0.36938974261284,
    "CMYK_M": 0,
    "CMYK_Y": 0.19209855794907,
    "CMYK_K": 0.60521137714386
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36142",
    "Farbtonhilfsbezeichnung": "36142",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "91",
    "Bcolor": "81",
    "Y": 10,
    "L": 36.7439498901367,
    "a": -9.42632484436035,
    "b": 2.54720735549927,
    "C": 9.76441860198975,
    "h": 164.878524780273,
    "CMY_C": 0.7201019525528,
    "CMY_M": 0.64394533634186,
    "CMY_Y": 0.68080759048462,
    "CMYK_C": 0.21389023959637,
    "CMYK_M": 0,
    "CMYK_Y": 0.10352975875139,
    "CMYK_K": 0.64394533634186
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36200",
    "Farbtonhilfsbezeichnung": "36200",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "140",
    "Bcolor": "85",
    "Y": 21,
    "L": 53.0616149902344,
    "a": -30.9950523376465,
    "b": 22.9360523223877,
    "C": 38.5584716796875,
    "h": 143.498901367188,
    "CMY_C": 0.68215990066528,
    "CMY_M": 0.45179492235184,
    "CMY_Y": 0.66650855541229,
    "CMYK_C": 0.42021679878235,
    "CMYK_M": 0,
    "CMYK_Y": 0.39166662096977,
    "CMYK_K": 0.45179492235184
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36201",
    "Farbtonhilfsbezeichnung": "36201",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "158",
    "Bcolor": "102",
    "Y": 29,
    "L": 60.477367401123,
    "a": -28.5329208374023,
    "b": 23.8076000213623,
    "C": 37.1608581542969,
    "h": 140.15869140625,
    "CMY_C": 0.58153879642487,
    "CMY_M": 0.3787397146225,
    "CMY_Y": 0.60135722160339,
    "CMYK_C": 0.32643175125122,
    "CMYK_M": 0,
    "CMYK_Y": 0.35833209753036,
    "CMYK_K": 0.3787397146225
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36202",
    "Farbtonhilfsbezeichnung": "36202",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "172",
    "Bcolor": "117",
    "Y": 36,
    "L": 65.8911514282227,
    "a": -26.2494792938232,
    "b": 22.6250782012939,
    "C": 34.654426574707,
    "h": 139.241134643555,
    "CMY_C": 0.5098865032196,
    "CMY_M": 0.32521134614944,
    "CMY_Y": 0.53951126337051,
    "CMYK_C": 0.27367851138115,
    "CMYK_M": 0,
    "CMYK_Y": 0.31758078932762,
    "CMYK_K": 0.32521134614944
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36203",
    "Farbtonhilfsbezeichnung": "36203",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "193",
    "Bcolor": "144",
    "Y": 48,
    "L": 74.356575012207,
    "a": -22.1023559570313,
    "b": 20.3296527862549,
    "C": 30.0301342010498,
    "h": 137.392288208008,
    "CMY_C": 0.39373964071274,
    "CMY_M": 0.24140673875809,
    "CMY_Y": 0.43713235855103,
    "CMYK_C": 0.20080971717834,
    "CMYK_M": 0,
    "CMYK_Y": 0.25801128149033,
    "CMYK_K": 0.24140673875809
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36204",
    "Farbtonhilfsbezeichnung": "36204",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "205",
    "Bcolor": "161",
    "Y": 56,
    "L": 78.9936828613281,
    "a": -18.8582706451416,
    "b": 17.6207962036133,
    "C": 25.8094329833984,
    "h": 136.942886352539,
    "CMY_C": 0.3260880112648,
    "CMY_M": 0.19661420583725,
    "CMY_Y": 0.36908137798309,
    "CMYK_C": 0.16116018593311,
    "CMYK_M": 0,
    "CMYK_Y": 0.21467541158199,
    "CMYK_K": 0.19661420583725
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36205",
    "Farbtonhilfsbezeichnung": "36205",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "217",
    "Bcolor": "180",
    "Y": 65,
    "L": 83.9511108398438,
    "a": -14.7415437698364,
    "b": 14.7868251800537,
    "C": 20.8797340393066,
    "h": 134.912139892578,
    "CMY_C": 0.24797075986862,
    "CMY_M": 0.14983558654785,
    "CMY_Y": 0.29558920860291,
    "CMYK_C": 0.11543081700802,
    "CMYK_M": 0,
    "CMYK_Y": 0.17144168913364,
    "CMYK_K": 0.14983558654785
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36206",
    "Farbtonhilfsbezeichnung": "36206",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "224",
    "Bcolor": "191",
    "Y": 70,
    "L": 86.8542251586914,
    "a": -12.5910615921021,
    "b": 13.2387371063232,
    "C": 18.2701663970947,
    "h": 133.563629150391,
    "CMY_C": 0.20383244752884,
    "CMY_M": 0.12184965610504,
    "CMY_Y": 0.25289577245712,
    "CMYK_C": 0.09335849434137,
    "CMYK_M": 0,
    "CMYK_Y": 0.14922970533371,
    "CMYK_K": 0.12184965610504
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36207",
    "Farbtonhilfsbezeichnung": "36207",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "231",
    "Bcolor": "204",
    "Y": 77,
    "L": 90.0015869140625,
    "a": -9.1227502822876,
    "b": 10.9326734542847,
    "C": 14.2389583587647,
    "h": 129.843246459961,
    "CMY_C": 0.14864361286163,
    "CMY_M": 0.09377562999725,
    "CMY_Y": 0.20135712623596,
    "CMYK_C": 0.06054569408298,
    "CMYK_M": 0,
    "CMYK_Y": 0.1187139749527,
    "CMYK_K": 0.09377562999725
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36208",
    "Farbtonhilfsbezeichnung": "36208",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "236",
    "Bcolor": "214",
    "Y": 81,
    "L": 92.2758712768555,
    "a": -6.38753890991211,
    "b": 8.96847915649414,
    "C": 11.0106439590454,
    "h": 125.459266662598,
    "CMY_C": 0.10784441232681,
    "CMY_M": 0.07396572828293,
    "CMY_Y": 0.16156375408173,
    "CMYK_C": 0.03658469766378,
    "CMYK_M": 0,
    "CMYK_Y": 0.09459479898214,
    "CMYK_K": 0.07396572828293
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36209",
    "Farbtonhilfsbezeichnung": "36209",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "239",
    "Bcolor": "221",
    "Y": 85,
    "L": 93.7089767456055,
    "a": -4.23230791091919,
    "b": 7.17579126358032,
    "C": 8.33093070983887,
    "h": 120.532249450684,
    "CMY_C": 0.08048951625824,
    "CMY_M": 0.06235939264297,
    "CMY_Y": 0.13214349746704,
    "CMYK_C": 0.01933589763939,
    "CMYK_M": 0,
    "CMYK_Y": 0.07442521303892,
    "CMYK_K": 0.06235939264297
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36210",
    "Farbtonhilfsbezeichnung": "36210",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "140",
    "Bcolor": "104",
    "Y": 24,
    "L": 56.0558395385742,
    "a": -12.4018878936768,
    "b": 16.9619750976563,
    "C": 21.0122680664063,
    "h": 126.172721862793,
    "CMY_C": 0.51471245288849,
    "CMY_M": 0.45158123970032,
    "CMY_Y": 0.59371399879456,
    "CMYK_C": 0.11511497944593,
    "CMYK_M": 0,
    "CMYK_Y": 0.25916829705238,
    "CMYK_K": 0.45158123970032
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36211",
    "Farbtonhilfsbezeichnung": "36211",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "165",
    "Bcolor": "131",
    "Y": 36,
    "L": 65.9604110717773,
    "a": -10.8539237976074,
    "b": 15.4417572021484,
    "C": 18.8747329711914,
    "h": 125.103164672852,
    "CMY_C": 0.40624326467514,
    "CMY_M": 0.35184025764465,
    "CMY_Y": 0.48547804355621,
    "CMYK_C": 0.08393456786871,
    "CMYK_M": 0,
    "CMYK_Y": 0.20618031919003,
    "CMYK_K": 0.35184025764465
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36212",
    "Farbtonhilfsbezeichnung": "36212",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "190",
    "Bcolor": "160",
    "Y": 50,
    "L": 75.4026489257813,
    "a": -8.60390090942383,
    "b": 13.1877756118774,
    "C": 15.7462549209595,
    "h": 123.121032714844,
    "CMY_C": 0.29624605178833,
    "CMY_M": 0.25560373067856,
    "CMY_Y": 0.37275099754333,
    "CMYK_C": 0.05459769442677,
    "CMYK_M": 0,
    "CMYK_Y": 0.15737219154835,
    "CMYK_K": 0.25560373067856
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36213",
    "Farbtonhilfsbezeichnung": "36213",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "206",
    "Bcolor": "179",
    "Y": 60,
    "L": 81.5887603759766,
    "a": -6.75287294387817,
    "b": 11.7665252685547,
    "C": 13.5665912628174,
    "h": 119.851745605469,
    "CMY_C": 0.2196062207222,
    "CMY_M": 0.19217276573181,
    "CMY_Y": 0.29732030630112,
    "CMYK_C": 0.03395955637097,
    "CMYK_M": 0,
    "CMYK_Y": 0.13016092777252,
    "CMYK_K": 0.19217276573181
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36214",
    "Farbtonhilfsbezeichnung": "36214",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "215",
    "Bcolor": "193",
    "Y": 67,
    "L": 85.1382217407227,
    "a": -5.60450983047485,
    "b": 9.76595020294189,
    "C": 11.2598543167114,
    "h": 119.850761413574,
    "CMY_C": 0.17804837226868,
    "CMY_M": 0.15528476238251,
    "CMY_Y": 0.24468970298767,
    "CMYK_C": 0.02694826386869,
    "CMYK_M": 0,
    "CMYK_Y": 0.10584033280611,
    "CMYK_K": 0.15528476238251
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36215",
    "Farbtonhilfsbezeichnung": "36215",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "229",
    "Bcolor": "210",
    "Y": 78,
    "L": 90.459716796875,
    "a": -3.554283618927,
    "b": 8.11328220367432,
    "C": 8.85766792297363,
    "h": 113.657363891602,
    "CMY_C": 0.1084098815918,
    "CMY_M": 0.10054636001587,
    "CMY_Y": 0.17462426424026,
    "CMYK_C": 0.00874255318195,
    "CMYK_M": 0,
    "CMYK_Y": 0.08235877752304,
    "CMYK_K": 0.10054636001587
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36216",
    "Farbtonhilfsbezeichnung": "36216",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "234",
    "Bcolor": "218",
    "Y": 82,
    "L": 92.3381500244141,
    "a": -2.81991291046143,
    "b": 7.18141937255859,
    "C": 7.7152247428894,
    "h": 111.438339233398,
    "CMY_C": 0.08465158939362,
    "CMY_M": 0.08102226257324,
    "CMY_Y": 0.14704346656799,
    "CMYK_C": 0.00394930876791,
    "CMYK_M": 0,
    "CMYK_Y": 0.071842007339,
    "CMYK_K": 0.08102226257324
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36217",
    "Farbtonhilfsbezeichnung": "36217",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "223",
    "Y": 85,
    "L": 93.7923812866211,
    "a": -1.34114789962769,
    "b": 6.33289432525635,
    "C": 6.47334766387939,
    "h": 101.957145690918,
    "CMY_C": 0.05946224927902,
    "CMY_M": 0.06797283887863,
    "CMY_Y": 0.12450563907623,
    "CMYK_C": 0,
    "CMYK_M": 0.00904864259064,
    "CMYK_Y": 0.06915553659201,
    "CMYK_K": 0.05946224927902
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36220",
    "Farbtonhilfsbezeichnung": "36220",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "153",
    "Bcolor": "119",
    "Y": 30,
    "L": 61.3477821350098,
    "a": -10.7620363235474,
    "b": 15.4465274810791,
    "C": 18.8259563446045,
    "h": 124.866020202637,
    "CMY_C": 0.45303332805634,
    "CMY_M": 0.40010553598404,
    "CMY_Y": 0.53138887882233,
    "CMYK_C": 0.08822850883007,
    "CMYK_M": 0,
    "CMYK_Y": 0.21884407103062,
    "CMYK_K": 0.40010553598404
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36221",
    "Farbtonhilfsbezeichnung": "36221",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "173",
    "Bcolor": "145",
    "Y": 40,
    "L": 69.0301895141602,
    "a": -8.62499809265137,
    "b": 12.4432258605957,
    "C": 15.1401605606079,
    "h": 124.727699279785,
    "CMY_C": 0.36594951152802,
    "CMY_M": 0.3233996629715,
    "CMY_Y": 0.43300592899323,
    "CMYK_C": 0.0628877133131,
    "CMYK_M": 0,
    "CMYK_Y": 0.16199558973312,
    "CMYK_K": 0.3233996629715
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36222",
    "Farbtonhilfsbezeichnung": "36222",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "188",
    "Bcolor": "165",
    "Y": 49,
    "L": 75.0196304321289,
    "a": -7.01486110687256,
    "b": 10.0357275009155,
    "C": 12.2443494796753,
    "h": 124.953117370605,
    "CMY_C": 0.29755061864853,
    "CMY_M": 0.26238739490509,
    "CMY_Y": 0.35392111539841,
    "CMYK_C": 0.04767166823149,
    "CMYK_M": 0,
    "CMYK_Y": 0.12409457564354,
    "CMYK_K": 0.26238739490509
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36223",
    "Farbtonhilfsbezeichnung": "36223",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "200",
    "Bcolor": "184",
    "Y": 57,
    "L": 79.614990234375,
    "a": -4.55619812011719,
    "b": 6.2402515411377,
    "C": 7.7265567779541,
    "h": 126.134315490723,
    "CMY_C": 0.24111837148666,
    "CMY_M": 0.21717482805252,
    "CMY_Y": 0.27790296077728,
    "CMYK_C": 0.03058606758714,
    "CMYK_M": 0,
    "CMYK_Y": 0.07757560163736,
    "CMYK_K": 0.21717482805252
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36230",
    "Farbtonhilfsbezeichnung": "36230",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "101",
    "Bcolor": "93",
    "Y": 13,
    "L": 42.1088104248047,
    "a": -3.89184260368347,
    "b": 3.40034961700439,
    "C": 5.16805744171143,
    "h": 138.855895996094,
    "CMY_C": 0.62715351581573,
    "CMY_M": 0.60315382480621,
    "CMY_Y": 0.63565587997437,
    "CMYK_C": 0.06047605350614,
    "CMYK_M": 0,
    "CMYK_Y": 0.0819008871913,
    "CMYK_K": 0.60315382480621
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36231",
    "Farbtonhilfsbezeichnung": "36231",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "130",
    "Bcolor": "122",
    "Y": 23,
    "L": 53.7820930480957,
    "a": -3.61495065689087,
    "b": 3.33034133911133,
    "C": 4.91518497467041,
    "h": 137.346588134766,
    "CMY_C": 0.51174700260162,
    "CMY_M": 0.48894852399826,
    "CMY_Y": 0.52267467975616,
    "CMYK_C": 0.04461092501879,
    "CMYK_M": 0,
    "CMYK_Y": 0.06599365919828,
    "CMYK_K": 0.48894852399826
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36232",
    "Farbtonhilfsbezeichnung": "36232",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "144",
    "Bcolor": "134",
    "Y": 28,
    "L": 58.8596305847168,
    "a": -3.95496249198914,
    "b": 3.48921155929565,
    "C": 5.27411842346191,
    "h": 138.580078125,
    "CMY_C": 0.46272307634354,
    "CMY_M": 0.4368234872818,
    "CMY_Y": 0.47326898574829,
    "CMYK_C": 0.04598840326071,
    "CMYK_M": 0,
    "CMYK_Y": 0.06471416354179,
    "CMYK_K": 0.4368234872818
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36233",
    "Farbtonhilfsbezeichnung": "36233",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "165",
    "Bcolor": "156",
    "Y": 37,
    "L": 66.9273300170898,
    "a": -3.33945965766907,
    "b": 3.2147376537323,
    "C": 4.63535642623901,
    "h": 136.09016418457,
    "CMY_C": 0.37609595060349,
    "CMY_M": 0.35452425479889,
    "CMY_Y": 0.38920778036118,
    "CMYK_C": 0.03341984003782,
    "CMYK_M": 0,
    "CMYK_Y": 0.05373327434063,
    "CMYK_K": 0.35452425479889
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36234",
    "Farbtonhilfsbezeichnung": "36234",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "185",
    "Bcolor": "176",
    "Y": 48,
    "L": 74.4132080078125,
    "a": -3.14830493927002,
    "b": 3.19582390785217,
    "C": 4.48610258102417,
    "h": 134.570846557617,
    "CMY_C": 0.29586505889893,
    "CMY_M": 0.27561873197556,
    "CMY_Y": 0.31098783016205,
    "CMYK_C": 0.02794982120395,
    "CMYK_M": 0,
    "CMYK_Y": 0.04882663115859,
    "CMYK_K": 0.27561873197556
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36235",
    "Farbtonhilfsbezeichnung": "36235",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "204",
    "Bcolor": "195",
    "Y": 60,
    "L": 81.7271957397461,
    "a": -2.23239898681641,
    "b": 3.33367276191711,
    "C": 4.01210403442383,
    "h": 123.808296203613,
    "CMY_C": 0.20961552858353,
    "CMY_M": 0.19864922761917,
    "CMY_Y": 0.23397153615952,
    "CMYK_C": 0.01368477009237,
    "CMYK_M": 0,
    "CMYK_Y": 0.04407846182585,
    "CMYK_K": 0.19864922761917
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36236",
    "Farbtonhilfsbezeichnung": "36236",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "216",
    "Bcolor": "207",
    "Y": 68,
    "L": 85.8338623046875,
    "a": -1.66995477676392,
    "b": 3.14871740341187,
    "C": 3.5641508102417,
    "h": 117.93970489502,
    "CMY_C": 0.16091841459274,
    "CMY_M": 0.15486025810242,
    "CMY_Y": 0.18815010786057,
    "CMYK_C": 0.00716823060066,
    "CMYK_M": 0,
    "CMYK_Y": 0.03938975930214,
    "CMYK_K": 0.15486025810242
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36237",
    "Farbtonhilfsbezeichnung": "36237",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "223",
    "Bcolor": "213",
    "Y": 74,
    "L": 88.7046432495117,
    "a": -1.20480406284332,
    "b": 4.14189529418945,
    "C": 4.31356573104858,
    "h": 106.218780517578,
    "CMY_C": 0.1223092675209,
    "CMY_M": 0.12447321414948,
    "CMY_Y": 0.16408902406693,
    "CMYK_C": 0,
    "CMYK_M": 0.00246550003067,
    "CMYK_Y": 0.04760191217065,
    "CMYK_K": 0.1223092675209
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36240",
    "Farbtonhilfsbezeichnung": "36240",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "119",
    "Bcolor": "91",
    "Y": 17,
    "L": 47.8219604492188,
    "a": -13.2834224700928,
    "b": 12.9192771911621,
    "C": 18.5298957824707,
    "h": 135.796188354492,
    "CMY_C": 0.61316877603531,
    "CMY_M": 0.53198194503784,
    "CMY_Y": 0.64501357078552,
    "CMYK_C": 0.1734694391489,
    "CMYK_M": 0,
    "CMYK_Y": 0.2415112555027,
    "CMYK_K": 0.53198194503784
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36241",
    "Farbtonhilfsbezeichnung": "36241",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "103",
    "Bcolor": "84",
    "Y": 13,
    "L": 41.9399833679199,
    "a": -8.98393440246582,
    "b": 8.50210094451904,
    "C": 12.3691873550415,
    "h": 136.578399658203,
    "CMY_C": 0.65012657642365,
    "CMY_M": 0.59635043144226,
    "CMY_Y": 0.67049300670624,
    "CMYK_C": 0.13322483003139,
    "CMYK_M": 0,
    "CMYK_Y": 0.18368054926395,
    "CMYK_K": 0.59635043144226
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36300",
    "Farbtonhilfsbezeichnung": "36300",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "156",
    "Bcolor": "76",
    "Y": 28,
    "L": 59.8817825317383,
    "a": -27.6932430267334,
    "b": 36.9138679504395,
    "C": 46.1470413208008,
    "h": 126.87769317627,
    "CMY_C": 0.54604780673981,
    "CMY_M": 0.38820362091064,
    "CMY_Y": 0.7031751871109,
    "CMYK_C": 0.25800117850304,
    "CMYK_M": 0,
    "CMYK_Y": 0.51483070850372,
    "CMYK_K": 0.38820362091064
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36301",
    "Farbtonhilfsbezeichnung": "36301",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "171",
    "Bcolor": "89",
    "Y": 36,
    "L": 66.0027694702148,
    "a": -25.4808406829834,
    "b": 37.7395401000977,
    "C": 45.536205291748,
    "h": 124.026290893555,
    "CMY_C": 0.46321934461594,
    "CMY_M": 0.32767003774643,
    "CMY_Y": 0.64965623617172,
    "CMYK_C": 0.20161128044128,
    "CMYK_M": 0,
    "CMYK_Y": 0.4789109826088,
    "CMYK_K": 0.32767003774643
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36302",
    "Farbtonhilfsbezeichnung": "36302",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "183",
    "Bcolor": "105",
    "Y": 42,
    "L": 70.6508560180664,
    "a": -23.2238788604736,
    "b": 35.7167015075684,
    "C": 42.6031837463379,
    "h": 123.032905578613,
    "CMY_C": 0.40105390548706,
    "CMY_M": 0.28188407421112,
    "CMY_Y": 0.58802545070648,
    "CMYK_C": 0.16594789922237,
    "CMYK_M": 0,
    "CMYK_Y": 0.42631191015244,
    "CMYK_K": 0.28188407421112
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36303",
    "Farbtonhilfsbezeichnung": "36303",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "202",
    "Bcolor": "131",
    "Y": 54,
    "L": 77.8911590576172,
    "a": -19.8013496398926,
    "b": 31.8755111694336,
    "C": 37.5252151489258,
    "h": 121.848922729492,
    "CMY_C": 0.30598276853561,
    "CMY_M": 0.20949578285217,
    "CMY_Y": 0.48578202724457,
    "CMYK_C": 0.12205751985312,
    "CMYK_M": 0,
    "CMYK_Y": 0.34950634837151,
    "CMYK_K": 0.20949578285217
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36304",
    "Farbtonhilfsbezeichnung": "36304",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "212",
    "Bcolor": "149",
    "Y": 61,
    "L": 81.9987487792969,
    "a": -17.3091526031494,
    "b": 28.325496673584,
    "C": 33.1954879760742,
    "h": 121.428276062012,
    "CMY_C": 0.25089681148529,
    "CMY_M": 0.16885960102081,
    "CMY_Y": 0.41665107011795,
    "CMYK_C": 0.09870439767838,
    "CMYK_M": 0,
    "CMYK_Y": 0.29813429713249,
    "CMYK_K": 0.16885960102081
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36305",
    "Farbtonhilfsbezeichnung": "36305",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "222",
    "Bcolor": "170",
    "Y": 69,
    "L": 86.2483901977539,
    "a": -13.6041145324707,
    "b": 23.2754287719727,
    "C": 26.9595527648926,
    "h": 120.305603027344,
    "CMY_C": 0.1888382434845,
    "CMY_M": 0.12862950563431,
    "CMY_Y": 0.33396112918854,
    "CMYK_C": 0.06909660249949,
    "CMYK_M": 0,
    "CMYK_Y": 0.2356421649456,
    "CMYK_K": 0.12862950563431
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36306",
    "Farbtonhilfsbezeichnung": "36306",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "226",
    "Bcolor": "179",
    "Y": 72,
    "L": 88.0071640014648,
    "a": -11.7063369750977,
    "b": 20.8712291717529,
    "C": 23.9300346374512,
    "h": 119.287368774414,
    "CMY_C": 0.1612743139267,
    "CMY_M": 0.11265259981155,
    "CMY_Y": 0.29709857702255,
    "CMYK_C": 0.05479445308447,
    "CMYK_M": 0,
    "CMYK_Y": 0.20786219835281,
    "CMYK_K": 0.11265259981155
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36307",
    "Farbtonhilfsbezeichnung": "36307",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "234",
    "Bcolor": "197",
    "Y": 79,
    "L": 91.1346435546875,
    "a": -8.47006988525391,
    "b": 16.348726272583,
    "C": 18.4125747680664,
    "h": 117.388114929199,
    "CMY_C": 0.11424326896667,
    "CMY_M": 0.0838617682457,
    "CMY_Y": 0.22933316230774,
    "CMYK_C": 0.03316257148981,
    "CMYK_M": 0,
    "CMYK_Y": 0.15878760814667,
    "CMYK_K": 0.0838617682457
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36308",
    "Farbtonhilfsbezeichnung": "36308",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "237",
    "Bcolor": "207",
    "Y": 83,
    "L": 92.7526550292969,
    "a": -6.39127445220947,
    "b": 13.0567426681519,
    "C": 14.5370874404907,
    "h": 116.081741333008,
    "CMY_C": 0.0897216796875,
    "CMY_M": 0.06963616609573,
    "CMY_Y": 0.18687301874161,
    "CMYK_C": 0.02158888056874,
    "CMYK_M": 0,
    "CMYK_Y": 0.12601183354855,
    "CMYK_K": 0.06963616609573
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36309",
    "Farbtonhilfsbezeichnung": "36309",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 85,
    "L": 93.9358520507812,
    "a": -3.92871332168579,
    "b": 10.5165615081787,
    "C": 11.2264356613159,
    "h": 110.484375,
    "CMY_C": 0.06493985652924,
    "CMY_M": 0.06138449907303,
    "CMY_Y": 0.15457367897034,
    "CMYK_C": 0.00378787424415,
    "CMYK_M": 0,
    "CMYK_Y": 0.09928365796804,
    "CMYK_K": 0.06138449907303
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36310",
    "Farbtonhilfsbezeichnung": "36310",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "150",
    "Bcolor": "111",
    "Y": 29,
    "L": 60.1249122619629,
    "a": -11.7127733230591,
    "b": 18.6800136566162,
    "C": 22.0484008789063,
    "h": 122.088607788086,
    "CMY_C": 0.46410024166107,
    "CMY_M": 0.41150563955307,
    "CMY_Y": 0.56598317623138,
    "CMYK_C": 0.08937146514654,
    "CMYK_M": 0,
    "CMYK_Y": 0.26249620318413,
    "CMYK_K": 0.41150563955307
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36311",
    "Farbtonhilfsbezeichnung": "36311",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "168",
    "Bcolor": "132",
    "Y": 38,
    "L": 67.2525939941406,
    "a": -10.5091724395752,
    "b": 16.9423389434814,
    "C": 19.9370403289795,
    "h": 121.810935974121,
    "CMY_C": 0.38614594936371,
    "CMY_M": 0.3392539024353,
    "CMY_Y": 0.48301964998245,
    "CMYK_C": 0.07096832990646,
    "CMYK_M": 0,
    "CMYK_Y": 0.21758092939854,
    "CMYK_K": 0.3392539024353
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36312",
    "Farbtonhilfsbezeichnung": "36312",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "193",
    "Bcolor": "161",
    "Y": 52,
    "L": 76.6534271240234,
    "a": -8.15594291687012,
    "b": 14.6022977828979,
    "C": 16.7256240844727,
    "h": 119.185035705566,
    "CMY_C": 0.27537798881531,
    "CMY_M": 0.24339210987091,
    "CMY_Y": 0.36986482143402,
    "CMYK_C": 0.04227536916733,
    "CMYK_M": 0,
    "CMYK_Y": 0.16715753078461,
    "CMYK_K": 0.24339210987091
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36313",
    "Farbtonhilfsbezeichnung": "36313",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "205",
    "Bcolor": "175",
    "Y": 60,
    "L": 81.4475555419922,
    "a": -6.12009525299072,
    "b": 13.6617336273193,
    "C": 14.9699211120606,
    "h": 114.131118774414,
    "CMY_C": 0.21075117588043,
    "CMY_M": 0.1955578327179,
    "CMY_Y": 0.31251472234726,
    "CMYK_C": 0.01888680644333,
    "CMYK_M": 0,
    "CMYK_Y": 0.14538881182671,
    "CMYK_K": 0.1955578327179
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36314",
    "Farbtonhilfsbezeichnung": "36314",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "223",
    "Bcolor": "200",
    "Y": 72,
    "L": 88.070198059082,
    "a": -3.87330985069275,
    "b": 10.3493595123291,
    "C": 11.0504198074341,
    "h": 110.518661499023,
    "CMY_C": 0.13051640987396,
    "CMY_M": 0.12694990634918,
    "CMY_Y": 0.21715086698532,
    "CMYK_C": 0.00408510770649,
    "CMYK_M": 0,
    "CMYK_Y": 0.10331705212593,
    "CMYK_K": 0.12694990634918
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36320",
    "Farbtonhilfsbezeichnung": "36320",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "146",
    "Bcolor": "106",
    "Y": 27,
    "L": 58.4246406555176,
    "a": -11.6724338531494,
    "b": 18.8051891326904,
    "C": 22.1332511901856,
    "h": 121.827995300293,
    "CMY_C": 0.4808075428009,
    "CMY_M": 0.42909455299377,
    "CMY_Y": 0.58338606357574,
    "CMYK_C": 0.09058065712452,
    "CMYK_M": 0,
    "CMYK_Y": 0.27025756239891,
    "CMYK_K": 0.42909455299377
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36321",
    "Farbtonhilfsbezeichnung": "36321",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "170",
    "Bcolor": "136",
    "Y": 39,
    "L": 67.8711166381836,
    "a": -9.31550788879395,
    "b": 15.7230892181397,
    "C": 18.2755088806152,
    "h": 120.645606994629,
    "CMY_C": 0.37408840656281,
    "CMY_M": 0.33491861820221,
    "CMY_Y": 0.46799826622009,
    "CMYK_C": 0.05889473110437,
    "CMYK_M": 0,
    "CMYK_Y": 0.20009528100491,
    "CMYK_K": 0.33491861820221
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36322",
    "Farbtonhilfsbezeichnung": "36322",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "185",
    "Bcolor": "159",
    "Y": 48,
    "L": 74.0715408325195,
    "a": -6.89516115188599,
    "b": 12.0627336502075,
    "C": 13.8943433761597,
    "h": 119.752655029297,
    "CMY_C": 0.30074548721313,
    "CMY_M": 0.27328938245773,
    "CMY_Y": 0.37824094295502,
    "CMYK_C": 0.03778134658933,
    "CMYK_M": 0,
    "CMYK_Y": 0.14442001283169,
    "CMYK_K": 0.27328938245773
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36323",
    "Farbtonhilfsbezeichnung": "36323",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "194",
    "Bcolor": "172",
    "Y": 53,
    "L": 77.4194107055664,
    "a": -5.01894807815552,
    "b": 9.8076868057251,
    "C": 11.0172843933106,
    "h": 117.100463867188,
    "CMY_C": 0.2573264837265,
    "CMY_M": 0.24082005023956,
    "CMY_Y": 0.32687443494797,
    "CMYK_C": 0.02174245193601,
    "CMYK_M": 0,
    "CMYK_Y": 0.11335176229477,
    "CMYK_K": 0.24082005023956
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36324",
    "Farbtonhilfsbezeichnung": "36324",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "203",
    "Bcolor": "188",
    "Y": 59,
    "L": 81.0143127441406,
    "a": -3.08210611343384,
    "b": 6.31496620178223,
    "C": 7.02696084976196,
    "h": 116.015327453613,
    "CMY_C": 0.21435546875,
    "CMY_M": 0.20527595281601,
    "CMY_Y": 0.26332050561905,
    "CMYK_C": 0.01142474077642,
    "CMYK_M": 0,
    "CMYK_Y": 0.07303737103939,
    "CMYK_K": 0.20527595281601
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36330",
    "Farbtonhilfsbezeichnung": "36330",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "122",
    "Bcolor": "99",
    "Y": 19,
    "L": 49.9549598693848,
    "a": -7.33433961868286,
    "b": 11.0351448059082,
    "C": 13.2501678466797,
    "h": 123.609390258789,
    "CMY_C": 0.55427098274231,
    "CMY_M": 0.52147573232651,
    "CMY_Y": 0.61148357391357,
    "CMYK_C": 0.06853414326906,
    "CMYK_M": 0,
    "CMYK_Y": 0.18809461593628,
    "CMYK_K": 0.52147573232651
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36331",
    "Farbtonhilfsbezeichnung": "36331",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "138",
    "Bcolor": "116",
    "Y": 25,
    "L": 56.4541244506836,
    "a": -5.98767280578613,
    "b": 10.4999752044678,
    "C": 12.0872535705566,
    "h": 119.694198608398,
    "CMY_C": 0.48138266801834,
    "CMY_M": 0.45876556634903,
    "CMY_Y": 0.54489469528198,
    "CMYK_C": 0.04178799316287,
    "CMYK_M": 0,
    "CMYK_Y": 0.15913461148739,
    "CMYK_K": 0.45876556634903
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36332",
    "Farbtonhilfsbezeichnung": "36332",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "158",
    "Bcolor": "137",
    "Y": 34,
    "L": 64.1968841552734,
    "a": -5.98007822036743,
    "b": 9.89885139465332,
    "C": 11.5649728775024,
    "h": 121.136940002441,
    "CMY_C": 0.40386712551117,
    "CMY_M": 0.3790470957756,
    "CMY_Y": 0.46381771564484,
    "CMYK_C": 0.03997087478638,
    "CMYK_M": 0,
    "CMYK_Y": 0.13651698827744,
    "CMYK_K": 0.3790470957756
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36333",
    "Farbtonhilfsbezeichnung": "36333",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "183",
    "Bcolor": "160",
    "Y": 47,
    "L": 73.4451522827148,
    "a": -5.26506853103638,
    "b": 10.3944854736328,
    "C": 11.6518783569336,
    "h": 116.86336517334,
    "CMY_C": 0.30001580715179,
    "CMY_M": 0.28312188386917,
    "CMY_Y": 0.37259703874588,
    "CMYK_C": 0.02356596291065,
    "CMYK_M": 0,
    "CMYK_Y": 0.1248122304678,
    "CMYK_K": 0.28312188386917
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36334",
    "Farbtonhilfsbezeichnung": "36334",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "196",
    "Bcolor": "175",
    "Y": 55,
    "L": 78.4474792480469,
    "a": -4.38869667053223,
    "b": 9.6187801361084,
    "C": 10.572681427002,
    "h": 114.52547454834,
    "CMY_C": 0.24202471971512,
    "CMY_M": 0.2310511469841,
    "CMY_Y": 0.31460338830948,
    "CMYK_C": 0.01427087467164,
    "CMYK_M": 0,
    "CMYK_Y": 0.10865773260593,
    "CMYK_K": 0.2310511469841
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36335",
    "Farbtonhilfsbezeichnung": "36335",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "208",
    "Bcolor": "190",
    "Y": 62,
    "L": 82.8905639648438,
    "a": -3.42477989196777,
    "b": 7.8183798789978,
    "C": 8.53558349609375,
    "h": 113.655448913574,
    "CMY_C": 0.19184821844101,
    "CMY_M": 0.18439644575119,
    "CMY_Y": 0.25422829389572,
    "CMYK_C": 0.00913651287556,
    "CMYK_M": 0,
    "CMYK_Y": 0.08561984449625,
    "CMYK_K": 0.18439644575119
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36336",
    "Farbtonhilfsbezeichnung": "36336",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "220",
    "Bcolor": "203",
    "Y": 71,
    "L": 87.230827331543,
    "a": -2.61218476295471,
    "b": 7.25157976150513,
    "C": 7.70771789550781,
    "h": 109.810180664063,
    "CMY_C": 0.13962525129318,
    "CMY_M": 0.13835376501083,
    "CMY_Y": 0.20322269201279,
    "CMYK_C": 0.00147564767394,
    "CMYK_M": 0,
    "CMYK_Y": 0.07528487592936,
    "CMYK_K": 0.13835376501083
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36337",
    "Farbtonhilfsbezeichnung": "36337",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "226",
    "Bcolor": "208",
    "Y": 76,
    "L": 89.549560546875,
    "a": -2.0036256313324,
    "b": 8.10420417785645,
    "C": 8.34821224212646,
    "h": 103.886924743652,
    "CMY_C": 0.10652726888657,
    "CMY_M": 0.11427867412567,
    "CMY_Y": 0.18424183130264,
    "CMYK_C": 0,
    "CMYK_M": 0.00867559202015,
    "CMYK_Y": 0.08698034286499,
    "CMYK_K": 0.10652726888657
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36340",
    "Farbtonhilfsbezeichnung": "36340",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "123",
    "Bcolor": "85",
    "Y": 18,
    "L": 49.3736610412598,
    "a": -13.2956533432007,
    "b": 18.2494010925293,
    "C": 22.5790843963623,
    "h": 126.075317382813,
    "CMY_C": 0.58422493934631,
    "CMY_M": 0.51748371124268,
    "CMY_Y": 0.66608142852783,
    "CMYK_C": 0.13831911981106,
    "CMYK_M": 0,
    "CMYK_Y": 0.30796414613724,
    "CMYK_K": 0.51748371124268
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36341",
    "Farbtonhilfsbezeichnung": "36341",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "106",
    "Bcolor": "79",
    "Y": 13,
    "L": 43.238109588623,
    "a": -9.93783569335938,
    "b": 13.1557054519653,
    "C": 16.4873638153076,
    "h": 127.067443847656,
    "CMY_C": 0.63220393657684,
    "CMY_M": 0.58295154571533,
    "CMY_Y": 0.6887139081955,
    "CMYK_C": 0.11809752881527,
    "CMYK_M": 0,
    "CMYK_Y": 0.25359728932381,
    "CMYK_K": 0.58295154571533
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36342",
    "Farbtonhilfsbezeichnung": "36342",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "78",
    "Bcolor": "71",
    "Y": 8,
    "L": 32.5107765197754,
    "a": -3.77930450439453,
    "b": 3.02249956130981,
    "C": 4.83928155899048,
    "h": 141.348922729492,
    "CMY_C": 0.71661603450775,
    "CMY_M": 0.69349765777588,
    "CMY_Y": 0.72155141830444,
    "CMYK_C": 0.07542642951012,
    "CMYK_M": 0,
    "CMYK_Y": 0.09152869880199,
    "CMYK_K": 0.69349765777588
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36400",
    "Farbtonhilfsbezeichnung": "36400",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "172",
    "Bcolor": "67",
    "Y": 37,
    "L": 67.587532043457,
    "a": -18.2639656066895,
    "b": 50.7224388122559,
    "C": 53.9104652404785,
    "h": 109.802764892578,
    "CMY_C": 0.37069493532181,
    "CMY_M": 0.32564574480057,
    "CMY_Y": 0.73739230632782,
    "CMYK_C": 0.0668034479022,
    "CMYK_M": 0,
    "CMYK_Y": 0.61057901382446,
    "CMYK_K": 0.32564574480057
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36401",
    "Farbtonhilfsbezeichnung": "36401",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "179",
    "Bcolor": "75",
    "Y": 41,
    "L": 70.2430419921875,
    "a": -17.7693481445313,
    "b": 50.1548461914063,
    "C": 53.2095680236816,
    "h": 109.508720397949,
    "CMY_C": 0.33904629945755,
    "CMY_M": 0.29839539527893,
    "CMY_Y": 0.70547437667847,
    "CMYK_C": 0.05793990567327,
    "CMYK_M": 0,
    "CMYK_Y": 0.58021140098572,
    "CMYK_K": 0.29839539527893
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36402",
    "Farbtonhilfsbezeichnung": "36402",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "193",
    "Bcolor": "96",
    "Y": 50,
    "L": 75.8897399902344,
    "a": -15.8131341934204,
    "b": 47.019359588623,
    "C": 49.6072120666504,
    "h": 108.588363647461,
    "CMY_C": 0.26798582077026,
    "CMY_M": 0.24139320850372,
    "CMY_Y": 0.62212610244751,
    "CMYK_C": 0.03505453839898,
    "CMYK_M": 0,
    "CMYK_Y": 0.50188440084457,
    "CMYK_K": 0.24139320850372
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36403",
    "Farbtonhilfsbezeichnung": "36403",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "209",
    "Bcolor": "115",
    "Y": 60,
    "L": 81.6231155395508,
    "a": -14.7822132110596,
    "b": 45.0062522888184,
    "C": 47.3716850280762,
    "h": 108.182662963867,
    "CMY_C": 0.20025658607483,
    "CMY_M": 0.18092441558838,
    "CMY_Y": 0.54771661758423,
    "CMYK_C": 0.02360242605209,
    "CMYK_M": 0,
    "CMYK_Y": 0.44781240820885,
    "CMYK_K": 0.18092441558838
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36404",
    "Farbtonhilfsbezeichnung": "36404",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "218",
    "Bcolor": "141",
    "Y": 67,
    "L": 85.2928009033203,
    "a": -12.906681060791,
    "b": 36.9752159118652,
    "C": 39.1631088256836,
    "h": 109.242210388184,
    "CMY_C": 0.16124832630157,
    "CMY_M": 0.14326655864716,
    "CMY_Y": 0.44719117879868,
    "CMYK_C": 0.02098875492811,
    "CMYK_M": 0,
    "CMYK_Y": 0.35474815964699,
    "CMYK_K": 0.14326655864716
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36405",
    "Farbtonhilfsbezeichnung": "36405",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "227",
    "Bcolor": "164",
    "Y": 74,
    "L": 88.8594741821289,
    "a": -10.2827548980713,
    "b": 30.0209369659424,
    "C": 31.73313331604,
    "h": 108.907333374023,
    "CMY_C": 0.11739611625671,
    "CMY_M": 0.10815048217773,
    "CMY_Y": 0.35655558109283,
    "CMYK_C": 0.0103668095544,
    "CMYK_M": 0,
    "CMYK_Y": 0.27852803468704,
    "CMYK_K": 0.10815048217773
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36406",
    "Farbtonhilfsbezeichnung": "36406",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "232",
    "Bcolor": "170",
    "Y": 78,
    "L": 90.8341903686523,
    "a": -8.23624610900879,
    "b": 29.8149757385254,
    "C": 30.9316749572754,
    "h": 105.442558288574,
    "CMY_C": 0.08040434122086,
    "CMY_M": 0.09065097570419,
    "CMY_Y": 0.33377993106842,
    "CMYK_C": 0,
    "CMYK_M": 0.01114254351705,
    "CMYK_Y": 0.27552935481071,
    "CMYK_K": 0.08040434122086
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36407",
    "Farbtonhilfsbezeichnung": "36407",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "237",
    "Bcolor": "192",
    "Y": 82,
    "L": 92.6783905029297,
    "a": -6.77523469924927,
    "b": 20.8913993835449,
    "C": 21.9625682830811,
    "h": 107.96826171875,
    "CMY_C": 0.07108515501022,
    "CMY_M": 0.07143568992615,
    "CMY_Y": 0.24647003412247,
    "CMYK_C": 0,
    "CMYK_M": 0.00037735956721,
    "CMYK_Y": 0.18880619108677,
    "CMYK_K": 0.07108515501022
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36408",
    "Farbtonhilfsbezeichnung": "36408",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "239",
    "Bcolor": "204",
    "Y": 85,
    "L": 93.7492218017578,
    "a": -5.14385366439819,
    "b": 16.208984375,
    "C": 17.0055999755859,
    "h": 107.606620788574,
    "CMY_C": 0.05953294038773,
    "CMY_M": 0.06207293272018,
    "CMY_Y": 0.19944775104523,
    "CMYK_C": 0,
    "CMYK_M": 0.00270077749155,
    "CMYK_Y": 0.14877162873745,
    "CMYK_K": 0.05953294038773
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36409",
    "Farbtonhilfsbezeichnung": "36409",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "240",
    "Bcolor": "213",
    "Y": 87,
    "L": 94.4339065551758,
    "a": -3.41239523887634,
    "b": 12.3710308074951,
    "C": 12.8330373764038,
    "h": 105.420852661133,
    "CMY_C": 0.04967421293259,
    "CMY_M": 0.05746078491211,
    "CMY_Y": 0.16292476654053,
    "CMYK_C": 0,
    "CMYK_M": 0.00819358136505,
    "CMYK_Y": 0.11917024105787,
    "CMYK_K": 0.04967421293259
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36410",
    "Farbtonhilfsbezeichnung": "36410",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "171",
    "Bcolor": "104",
    "Y": 39,
    "L": 68.2509765625,
    "a": -11.6367530822754,
    "b": 33.62646484375,
    "C": 35.5830459594727,
    "h": 109.088661193848,
    "CMY_C": 0.34573984146118,
    "CMY_M": 0.32941710948944,
    "CMY_Y": 0.59355795383453,
    "CMYK_C": 0.02434111014009,
    "CMYK_M": 0,
    "CMYK_Y": 0.39389738440514,
    "CMYK_K": 0.32941710948944
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36411",
    "Farbtonhilfsbezeichnung": "36411",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "192",
    "Bcolor": "131",
    "Y": 50,
    "L": 76.0509872436523,
    "a": -10.2327041625977,
    "b": 29.9308185577393,
    "C": 31.6316642761231,
    "h": 108.874458312988,
    "CMY_C": 0.25901156663895,
    "CMY_M": 0.24853986501694,
    "CMY_Y": 0.48808205127716,
    "CMYK_C": 0.01393513940275,
    "CMYK_M": 0,
    "CMYK_Y": 0.3187689781189,
    "CMYK_K": 0.24853986501694
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36412",
    "Farbtonhilfsbezeichnung": "36412",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "203",
    "Bcolor": "150",
    "Y": 58,
    "L": 80.3472366333008,
    "a": -9.02536487579346,
    "b": 25.7737674713135,
    "C": 27.3083190917969,
    "h": 109.299049377441,
    "CMY_C": 0.21270793676376,
    "CMY_M": 0.20379650592804,
    "CMY_Y": 0.41322201490402,
    "CMYK_C": 0.01119240373373,
    "CMYK_M": 0,
    "CMYK_Y": 0.26303014159203,
    "CMYK_K": 0.20379650592804
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36413",
    "Farbtonhilfsbezeichnung": "36413",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "217",
    "Bcolor": "172",
    "Y": 67,
    "L": 85.511604309082,
    "a": -7.40997362136841,
    "b": 21.4055824279785,
    "C": 22.6518573760986,
    "h": 109.094329833984,
    "CMY_C": 0.15464460849762,
    "CMY_M": 0.14983105659485,
    "CMY_Y": 0.32675051689148,
    "CMYK_C": 0.00566187687218,
    "CMYK_M": 0,
    "CMYK_Y": 0.20809918642044,
    "CMYK_K": 0.14983105659485
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36414",
    "Farbtonhilfsbezeichnung": "36414",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "222",
    "Bcolor": "183",
    "Y": 71,
    "L": 87.5084533691406,
    "a": -6.5440673828125,
    "b": 18.5041065216064,
    "C": 19.6271953582764,
    "h": 109.476387023926,
    "CMY_C": 0.13368374109268,
    "CMY_M": 0.12905335426331,
    "CMY_Y": 0.2839275598526,
    "CMYK_C": 0.00531649868935,
    "CMYK_M": 0,
    "CMYK_Y": 0.17782284319401,
    "CMYK_K": 0.12905335426331
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36415",
    "Farbtonhilfsbezeichnung": "36415",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "230",
    "Bcolor": "198",
    "Y": 77,
    "L": 90.4470825195312,
    "a": -4.88744115829468,
    "b": 14.5830202102661,
    "C": 15.3802328109741,
    "h": 108.528373718262,
    "CMY_C": 0.09931522607803,
    "CMY_M": 0.09923648834229,
    "CMY_Y": 0.22301304340363,
    "CMYK_C": 8.741221973e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.13741293549538,
    "CMYK_K": 0.09923648834229
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36416",
    "Farbtonhilfsbezeichnung": "36416",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "235",
    "Bcolor": "210",
    "Y": 82,
    "L": 92.5010986328125,
    "a": -3.64510798454285,
    "b": 11.5395889282227,
    "C": 12.1016082763672,
    "h": 107.530212402344,
    "CMY_C": 0.07572293281555,
    "CMY_M": 0.07840096950531,
    "CMY_Y": 0.17785608768463,
    "CMYK_C": 0,
    "CMYK_M": 0.0028974392917,
    "CMYK_Y": 0.11050058156252,
    "CMYK_K": 0.07572293281555
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36420",
    "Farbtonhilfsbezeichnung": "36420",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "149",
    "Bcolor": "108",
    "Y": 30,
    "L": 61.0485076904297,
    "a": -5.09333038330078,
    "b": 21.3912696838379,
    "C": 21.9892807006836,
    "h": 103.392929077148,
    "CMY_C": 0.40175187587738,
    "CMY_M": 0.41582399606705,
    "CMY_Y": 0.57473987340927,
    "CMYK_C": 0,
    "CMYK_M": 0.02352221310139,
    "CMYK_Y": 0.28915759921074,
    "CMYK_K": 0.40175187587738
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36421",
    "Farbtonhilfsbezeichnung": "36421",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "168",
    "Bcolor": "130",
    "Y": 39,
    "L": 68.2788009643555,
    "a": -5.49279975891113,
    "b": 19.4103927612305,
    "C": 20.1726093292236,
    "h": 105.800582885742,
    "CMY_C": 0.33280259370804,
    "CMY_M": 0.33938175439835,
    "CMY_Y": 0.48935431241989,
    "CMYK_C": 0,
    "CMYK_M": 0.00986089091748,
    "CMYK_Y": 0.23464077711105,
    "CMYK_K": 0.33280259370804
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36422",
    "Farbtonhilfsbezeichnung": "36422",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "184",
    "Bcolor": "151",
    "Y": 48,
    "L": 74.1450271606445,
    "a": -3.93696689605713,
    "b": 16.1643218994141,
    "C": 16.6368560791016,
    "h": 103.68839263916,
    "CMY_C": 0.26695519685745,
    "CMY_M": 0.27985841035843,
    "CMY_Y": 0.40635371208191,
    "CMYK_C": 0,
    "CMYK_M": 0.01760221645236,
    "CMYK_Y": 0.19016370177269,
    "CMYK_K": 0.26695519685745
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36423",
    "Farbtonhilfsbezeichnung": "36423",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "195",
    "Bcolor": "170",
    "Y": 54,
    "L": 78.1269454956055,
    "a": -3.45791006088257,
    "b": 11.6410799026489,
    "C": 12.1437997817993,
    "h": 106.543724060059,
    "CMY_C": 0.23262983560562,
    "CMY_M": 0.23708164691925,
    "CMY_Y": 0.3324082493782,
    "CMYK_C": 0,
    "CMYK_M": 0.00580138713121,
    "CMYK_Y": 0.13002644479275,
    "CMYK_K": 0.23262983560562
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36424",
    "Farbtonhilfsbezeichnung": "36424",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "213",
    "Bcolor": "198",
    "Y": 66,
    "L": 84.7590637207031,
    "a": -2.0620436668396,
    "b": 6.36241912841797,
    "C": 6.68822860717773,
    "h": 107.957374572754,
    "CMY_C": 0.16542768478394,
    "CMY_M": 0.16664123535156,
    "CMY_Y": 0.22333967685699,
    "CMYK_C": 0,
    "CMYK_M": 0.00145409873221,
    "CMYK_Y": 0.06939122080803,
    "CMYK_K": 0.16542768478394
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36430",
    "Farbtonhilfsbezeichnung": "36430",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "125",
    "Bcolor": "92",
    "Y": 20,
    "L": 51.1688537597656,
    "a": -6.75472450256348,
    "b": 17.1498928070068,
    "C": 18.4321765899658,
    "h": 111.497695922852,
    "CMY_C": 0.52335494756699,
    "CMY_M": 0.51169860363007,
    "CMY_Y": 0.64072662591934,
    "CMYK_C": 0.02387120760977,
    "CMYK_M": 0,
    "CMYK_Y": 0.26423847675323,
    "CMYK_K": 0.51169860363007
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36431",
    "Farbtonhilfsbezeichnung": "36431",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "140",
    "Bcolor": "107",
    "Y": 26,
    "L": 57.1266632080078,
    "a": -6.49243402481079,
    "b": 16.4021530151367,
    "C": 17.64035987854,
    "h": 111.595054626465,
    "CMY_C": 0.46310466527939,
    "CMY_M": 0.45211243629456,
    "CMY_Y": 0.57858449220657,
    "CMYK_C": 0.02006292901933,
    "CMYK_M": 0,
    "CMYK_Y": 0.23083578050137,
    "CMYK_K": 0.45211243629456
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36432",
    "Farbtonhilfsbezeichnung": "36432",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "164",
    "Bcolor": "133",
    "Y": 37,
    "L": 66.4336700439453,
    "a": -5.59348058700562,
    "b": 15.0303030014038,
    "C": 16.0373630523682,
    "h": 110.41259765625,
    "CMY_C": 0.36383885145187,
    "CMY_M": 0.35763090848923,
    "CMY_Y": 0.47701495885849,
    "CMYK_C": 0.0096641369164,
    "CMYK_M": 0,
    "CMYK_Y": 0.18584962189198,
    "CMYK_K": 0.35763090848923
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36433",
    "Farbtonhilfsbezeichnung": "36433",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "181",
    "Bcolor": "153",
    "Y": 46,
    "L": 72.8550796508789,
    "a": -5.3076114654541,
    "b": 13.5835781097412,
    "C": 14.583701133728,
    "h": 111.342445373535,
    "CMY_C": 0.29762035608292,
    "CMY_M": 0.29006206989288,
    "CMY_Y": 0.40140789747238,
    "CMYK_C": 0.01064640469849,
    "CMYK_M": 0,
    "CMYK_Y": 0.15683881938457,
    "CMYK_K": 0.29006206989288
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36434",
    "Farbtonhilfsbezeichnung": "36434",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "197",
    "Bcolor": "173",
    "Y": 56,
    "L": 78.9522857666016,
    "a": -4.16303777694702,
    "b": 11.0960502624512,
    "C": 11.8512954711914,
    "h": 110.565185546875,
    "CMY_C": 0.23051297664642,
    "CMY_M": 0.22644251585007,
    "CMY_Y": 0.31990891695023,
    "CMYK_C": 0.00526200188324,
    "CMYK_M": 0,
    "CMYK_Y": 0.12082670629025,
    "CMYK_K": 0.22644251585007
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36435",
    "Farbtonhilfsbezeichnung": "36435",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "207",
    "Bcolor": "184",
    "Y": 62,
    "L": 82.6820068359375,
    "a": -3.75720286369324,
    "b": 10.7123212814331,
    "C": 11.3521099090576,
    "h": 109.32763671875,
    "CMY_C": 0.18792527914047,
    "CMY_M": 0.18664819002151,
    "CMY_Y": 0.27757978439331,
    "CMYK_C": 0.00157015584409,
    "CMYK_M": 0,
    "CMYK_Y": 0.11179859936237,
    "CMYK_K": 0.18664819002151
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36436",
    "Farbtonhilfsbezeichnung": "36436",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "218",
    "Bcolor": "199",
    "Y": 69,
    "L": 86.7481842041016,
    "a": -2.81539154052734,
    "b": 8.73831462860107,
    "C": 9.18066310882568,
    "h": 107.858383178711,
    "CMY_C": 0.14192217588425,
    "CMY_M": 0.14360338449478,
    "CMY_Y": 0.21940225362778,
    "CMYK_C": 0,
    "CMYK_M": 0.00195927289315,
    "CMYK_Y": 0.09029492735863,
    "CMYK_K": 0.14192217588425
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36437",
    "Farbtonhilfsbezeichnung": "36437",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "209",
    "Y": 76,
    "L": 89.6851959228516,
    "a": -2.30064058303833,
    "b": 7.6974983215332,
    "C": 8.03395462036133,
    "h": 106.640441894531,
    "CMY_C": 0.10857909917831,
    "CMY_M": 0.11197191476822,
    "CMY_Y": 0.17980128526688,
    "CMYK_C": 0,
    "CMYK_M": 0.00380607577972,
    "CMYK_Y": 0.07989737391472,
    "CMYK_K": 0.10857909917831
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36440",
    "Farbtonhilfsbezeichnung": "36440",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "142",
    "Bcolor": "71",
    "Y": 25,
    "L": 56.9128799438477,
    "a": -13.3789033889771,
    "b": 36.072681427002,
    "C": 38.4738006591797,
    "h": 110.349182128906,
    "CMY_C": 0.47315633296967,
    "CMY_M": 0.44396340847015,
    "CMY_Y": 0.72166574001312,
    "CMYK_C": 0.05250180512667,
    "CMYK_M": 0,
    "CMYK_Y": 0.49943175911903,
    "CMYK_K": 0.44396340847015
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36441",
    "Farbtonhilfsbezeichnung": "36441",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "119",
    "Bcolor": "80",
    "Y": 18,
    "L": 49.0283126831055,
    "a": -6.04790639877319,
    "b": 20.9328002929688,
    "C": 21.7889728546143,
    "h": 106.11506652832,
    "CMY_C": 0.53215765953064,
    "CMY_M": 0.5349588394165,
    "CMY_Y": 0.68618535995483,
    "CMYK_C": 0,
    "CMYK_M": 0.0059874439612,
    "CMYK_Y": 0.32922992110252,
    "CMYK_K": 0.53215765953064
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36442",
    "Farbtonhilfsbezeichnung": "36442",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "106",
    "Bcolor": "74",
    "Y": 14,
    "L": 43.8804168701172,
    "a": -6.91024255752563,
    "b": 17.077262878418,
    "C": 18.4223880767822,
    "h": 112.03050994873,
    "CMY_C": 0.59647023677826,
    "CMY_M": 0.58298480510712,
    "CMY_Y": 0.70801746845245,
    "CMYK_C": 0.03233798593283,
    "CMYK_M": 0,
    "CMYK_Y": 0.29982760548592,
    "CMYK_K": 0.58298480510712
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "36443",
    "Farbtonhilfsbezeichnung": "36443",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "86",
    "Bcolor": "66",
    "Y": 9,
    "L": 35.7405471801758,
    "a": -4.7680549621582,
    "b": 11.1401853561401,
    "C": 12.11767578125,
    "h": 113.171165466309,
    "CMY_C": 0.67304396629333,
    "CMY_M": 0.66336560249329,
    "CMY_Y": 0.74294948577881,
    "CMYK_C": 0.02875037118793,
    "CMYK_M": 0,
    "CMYK_Y": 0.23641043901443,
    "CMYK_K": 0.66336560249329
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37100",
    "Farbtonhilfsbezeichnung": "37100",
    "Farbtonklasse": "02",
    "Rcolor": "66",
    "Gcolor": "66",
    "Bcolor": "65",
    "Y": 6,
    "L": 28.0346965789795,
    "a": -0.3971186876297,
    "b": 0.49006819725037,
    "C": 0.63076943159103,
    "h": 129.019012451172,
    "CMY_C": 0.74178743362427,
    "CMY_M": 0.73977851867676,
    "CMY_Y": 0.74582833051682,
    "CMYK_C": 0.00772001966834,
    "CMYK_M": 0,
    "CMYK_Y": 0.02324870228767,
    "CMYK_K": 0.73977851867676
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37101",
    "Farbtonhilfsbezeichnung": "37101",
    "Farbtonklasse": "02",
    "Rcolor": "76",
    "Gcolor": "78",
    "Bcolor": "78",
    "Y": 8,
    "L": 32.9451065063477,
    "a": -0.62053900957108,
    "b": -0.46026688814163,
    "C": 0.77260226011276,
    "h": 216.56510925293,
    "CMY_C": 0.70160806179047,
    "CMY_M": 0.69466090202332,
    "CMY_Y": 0.69604849815369,
    "CMYK_C": 0.02275227755308,
    "CMYK_M": 0,
    "CMYK_Y": 0.00454444298521,
    "CMYK_K": 0.69466090202332
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37102",
    "Farbtonhilfsbezeichnung": "37102",
    "Farbtonklasse": "01",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.6572532653809,
    "a": -0.8177433013916,
    "b": 0.08228448778391,
    "C": 0.82187277078629,
    "h": 174.254013061523,
    "CMY_C": 0.63896942138672,
    "CMY_M": 0.631791472435,
    "CMY_Y": 0.63731801509857,
    "CMYK_C": 0.01949425041676,
    "CMYK_M": 0,
    "CMYK_Y": 0.01500927377492,
    "CMYK_K": 0.631791472435
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37103",
    "Farbtonhilfsbezeichnung": "37103",
    "Farbtonklasse": "01",
    "Rcolor": "100",
    "Gcolor": "103",
    "Bcolor": "103",
    "Y": 14,
    "L": 43.1963043212891,
    "a": -0.92865538597107,
    "b": -0.90831995010376,
    "C": 1.29901731014252,
    "h": 224.365768432617,
    "CMY_C": 0.60911619663239,
    "CMY_M": 0.5975239276886,
    "CMY_Y": 0.59750705957413,
    "CMYK_C": 0.02884308248758,
    "CMYK_M": 4.190909385e-05,
    "CMYK_Y": 0,
    "CMYK_K": 0.59750705957413
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37104",
    "Farbtonhilfsbezeichnung": "37104",
    "Farbtonklasse": "01",
    "Rcolor": "114",
    "Gcolor": "117",
    "Bcolor": "116",
    "Y": 18,
    "L": 48.943775177002,
    "a": -0.9878368973732,
    "b": -0.55100601911545,
    "C": 1.13111865520477,
    "h": 209.152359008789,
    "CMY_C": 0.55272394418716,
    "CMY_M": 0.54152250289917,
    "CMY_Y": 0.54423332214355,
    "CMYK_C": 0.0244318228215,
    "CMYK_M": 0,
    "CMYK_Y": 0.00591265503317,
    "CMYK_K": 0.54152250289917
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37105",
    "Farbtonhilfsbezeichnung": "37105",
    "Farbtonklasse": "01",
    "Rcolor": "129",
    "Gcolor": "132",
    "Bcolor": "130",
    "Y": 23,
    "L": 54.8824729919434,
    "a": -1.15470063686371,
    "b": 0.26649850606918,
    "C": 1.18505489826202,
    "h": 167.004013061523,
    "CMY_C": 0.49245327711105,
    "CMY_M": 0.48223626613617,
    "CMY_Y": 0.49100536108017,
    "CMYK_C": 0.0197329595685,
    "CMYK_M": 0,
    "CMYK_Y": 0.01693647913635,
    "CMYK_K": 0.48223626613617
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37106",
    "Farbtonhilfsbezeichnung": "37106",
    "Farbtonklasse": "01",
    "Rcolor": "141",
    "Gcolor": "143",
    "Bcolor": "142",
    "Y": 28,
    "L": 59.2580375671387,
    "a": -1.00045418739319,
    "b": -0.1806860268116,
    "C": 1.01663959026337,
    "h": 190.237487792969,
    "CMY_C": 0.44855099916458,
    "CMY_M": 0.43806725740433,
    "CMY_Y": 0.44398301839828,
    "CMYK_C": 0.01865657791495,
    "CMYK_M": 0,
    "CMYK_Y": 0.01052752509713,
    "CMYK_K": 0.43806725740433
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37107",
    "Farbtonhilfsbezeichnung": "37107",
    "Farbtonklasse": "01",
    "Rcolor": "153",
    "Gcolor": "156",
    "Bcolor": "153",
    "Y": 34,
    "L": 64.0098571777344,
    "a": -1.11352324485779,
    "b": 0.32652795314789,
    "C": 1.16041135787964,
    "h": 163.656829833984,
    "CMY_C": 0.39899373054504,
    "CMY_M": 0.38902628421783,
    "CMY_Y": 0.39896124601364,
    "CMYK_C": 0.01631403528154,
    "CMYK_M": 0,
    "CMYK_Y": 0.01626086607575,
    "CMYK_K": 0.38902628421783
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37108",
    "Farbtonhilfsbezeichnung": "37108",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "175",
    "Bcolor": "171",
    "Y": 43,
    "L": 71.1666946411133,
    "a": -1.04134929180145,
    "b": 0.92494362592697,
    "C": 1.39281332492828,
    "h": 138.387985229492,
    "CMY_C": 0.32166177034378,
    "CMY_M": 0.31428456306458,
    "CMY_Y": 0.32878810167313,
    "CMYK_C": 0.0107584092766,
    "CMYK_M": 0,
    "CMYK_Y": 0.021150957793,
    "CMYK_K": 0.31428456306458
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37109",
    "Farbtonhilfsbezeichnung": "37109",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "197",
    "Bcolor": "192",
    "Y": 57,
    "L": 79.4735107421875,
    "a": -0.95780032873154,
    "b": 1.87288236618042,
    "C": 2.10358500480652,
    "h": 117.085395812988,
    "CMY_C": 0.22902244329453,
    "CMY_M": 0.22567486763,
    "CMY_Y": 0.24743711948395,
    "CMYK_C": 0.00432321708649,
    "CMYK_M": 0,
    "CMYK_Y": 0.0281047988683,
    "CMYK_K": 0.22567486763
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37110",
    "Farbtonhilfsbezeichnung": "37110",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "209",
    "Bcolor": "203",
    "Y": 65,
    "L": 83.7269897460938,
    "a": -0.81792670488358,
    "b": 2.08526515960693,
    "C": 2.23994088172913,
    "h": 111.417152404785,
    "CMY_C": 0.18092435598373,
    "CMY_M": 0.17969417572021,
    "CMY_Y": 0.20313012599945,
    "CMYK_C": 0.00149966054596,
    "CMYK_M": 0,
    "CMYK_Y": 0.0285697709769,
    "CMYK_K": 0.17969417572021
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37111",
    "Farbtonhilfsbezeichnung": "37111",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "221",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.2577972412109,
    "a": -0.48475739359856,
    "b": 5.74496698379517,
    "C": 5.76538228988647,
    "h": 94.8231582641602,
    "CMY_C": 0.11655700206757,
    "CMY_M": 0.13154900074005,
    "CMY_Y": 0.18066954612732,
    "CMYK_C": 0,
    "CMYK_M": 0.01696996763349,
    "CMYK_Y": 0.07257122546434,
    "CMYK_K": 0.11655700206757
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37200",
    "Farbtonhilfsbezeichnung": "37200",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "102",
    "Bcolor": "105",
    "Y": 14,
    "L": 42.8283767700195,
    "a": -0.97437959909439,
    "b": -2.95646524429321,
    "C": 3.11289286613464,
    "h": 251.759033203125,
    "CMY_C": 0.61954641342163,
    "CMY_M": 0.60044777393341,
    "CMY_Y": 0.58797073364258,
    "CMYK_C": 0.07663455605507,
    "CMYK_M": 0.03028192743659,
    "CMYK_Y": 0,
    "CMYK_K": 0.58797073364258
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37201",
    "Farbtonhilfsbezeichnung": "37201",
    "Farbtonklasse": "01",
    "Rcolor": "114",
    "Gcolor": "118",
    "Bcolor": "121",
    "Y": 19,
    "L": 49.321403503418,
    "a": -0.74822020530701,
    "b": -2.88165020942688,
    "C": 2.9772036075592,
    "h": 255.444580078125,
    "CMY_C": 0.55487269163132,
    "CMY_M": 0.53768992424011,
    "CMY_Y": 0.52525812387466,
    "CMYK_C": 0.06238035857677,
    "CMYK_M": 0.02618644200265,
    "CMYK_Y": 0,
    "CMYK_K": 0.52525812387466
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37202",
    "Farbtonhilfsbezeichnung": "37202",
    "Farbtonklasse": "01",
    "Rcolor": "126",
    "Gcolor": "130",
    "Bcolor": "133",
    "Y": 23,
    "L": 54.1571350097656,
    "a": -0.85008031129837,
    "b": -2.83973050117493,
    "C": 2.9642379283905,
    "h": 253.33479309082,
    "CMY_C": 0.50764840841293,
    "CMY_M": 0.48935520648956,
    "CMY_Y": 0.47749763727188,
    "CMYK_C": 0.05770456418395,
    "CMYK_M": 0.02269380912185,
    "CMYK_Y": 0,
    "CMYK_K": 0.47749763727188
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37203",
    "Farbtonhilfsbezeichnung": "37203",
    "Farbtonklasse": "01",
    "Rcolor": "150",
    "Gcolor": "155",
    "Bcolor": "158",
    "Y": 34,
    "L": 63.7706413269043,
    "a": -1.16221272945404,
    "b": -2.56912612915039,
    "C": 2.81977796554565,
    "h": 245.659118652344,
    "CMY_C": 0.41153645515442,
    "CMY_M": 0.39061975479126,
    "CMY_Y": 0.38150292634964,
    "CMYK_C": 0.04855888709426,
    "CMYK_M": 0.01474029384553,
    "CMYK_Y": 0,
    "CMYK_K": 0.38150292634964
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37204",
    "Farbtonhilfsbezeichnung": "37204",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "185",
    "Bcolor": "184",
    "Y": 49,
    "L": 74.6959686279297,
    "a": -1.06233394145966,
    "b": -0.90382081270218,
    "C": 1.39479231834412,
    "h": 220.390731811523,
    "CMY_C": 0.29047787189484,
    "CMY_M": 0.27614384889603,
    "CMY_Y": 0.27858752012253,
    "CMYK_C": 0.0198023095727,
    "CMYK_M": 0,
    "CMYK_Y": 0.00337590719573,
    "CMYK_K": 0.27614384889603
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37205",
    "Farbtonhilfsbezeichnung": "37205",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "195",
    "Bcolor": "195",
    "Y": 55,
    "L": 78.682975769043,
    "a": -0.78694212436676,
    "b": -0.83983808755875,
    "C": 1.15091526508331,
    "h": 226.862365722656,
    "CMY_C": 0.24536740779877,
    "CMY_M": 0.23387664556503,
    "CMY_Y": 0.23639392852783,
    "CMYK_C": 0.0149985793978,
    "CMYK_M": 0,
    "CMYK_Y": 0.00328574096784,
    "CMYK_K": 0.23387664556503
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37206",
    "Farbtonhilfsbezeichnung": "37206",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "212",
    "Bcolor": "208",
    "Y": 65,
    "L": 84.5200881958008,
    "a": -0.907790184021,
    "b": 0.90345746278763,
    "C": 1.2807492017746,
    "h": 135.137054443359,
    "CMY_C": 0.17689627408981,
    "CMY_M": 0.17045831680298,
    "CMY_Y": 0.18592739105225,
    "CMYK_C": 0.00776086049154,
    "CMYK_M": 0,
    "CMYK_Y": 0.01864773593843,
    "CMYK_K": 0.17045831680298
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37207",
    "Farbtonhilfsbezeichnung": "37207",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 76,
    "L": 89.6691207885742,
    "a": -0.75640505552292,
    "b": 3.60366082191467,
    "C": 3.68218946456909,
    "h": 101.85424041748,
    "CMY_C": 0.10985177755356,
    "CMY_M": 0.11466860771179,
    "CMY_Y": 0.14949613809586,
    "CMYK_C": 0,
    "CMYK_M": 0.00541126728058,
    "CMYK_Y": 0.04453680664301,
    "CMYK_K": 0.10985177755356
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37300",
    "Farbtonhilfsbezeichnung": "37300",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "98",
    "Bcolor": "101",
    "Y": 12,
    "L": 41.4907455444336,
    "a": 0.91032594442368,
    "b": -2.56100916862488,
    "C": 2.71798849105835,
    "h": 289.568054199219,
    "CMY_C": 0.61781740188599,
    "CMY_M": 0.6171886920929,
    "CMY_Y": 0.60307854413986,
    "CMYK_C": 0.03713293373585,
    "CMYK_M": 0.03554896637797,
    "CMYK_Y": 0,
    "CMYK_K": 0.60307854413986
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37301",
    "Farbtonhilfsbezeichnung": "37301",
    "Farbtonklasse": "01",
    "Rcolor": "107",
    "Gcolor": "106",
    "Bcolor": "109",
    "Y": 15,
    "L": 44.9214973449707,
    "a": 1.31785798072815,
    "b": -2.14515161514282,
    "C": 2.51762294769287,
    "h": 301.564178466797,
    "CMY_C": 0.58072710037231,
    "CMY_M": 0.58517813682556,
    "CMY_Y": 0.57273435592651,
    "CMYK_C": 0.01870673336089,
    "CMYK_M": 0.02912422455847,
    "CMYK_Y": 0,
    "CMYK_K": 0.57273435592651
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37302",
    "Farbtonhilfsbezeichnung": "37302",
    "Farbtonklasse": "01",
    "Rcolor": "120",
    "Gcolor": "119",
    "Bcolor": "122",
    "Y": 19,
    "L": 50.1640472412109,
    "a": 1.43621718883514,
    "b": -2.26474213600159,
    "C": 2.68174886703491,
    "h": 302.381378173828,
    "CMY_C": 0.52893263101578,
    "CMY_M": 0.53413617610931,
    "CMY_Y": 0.52073776721954,
    "CMYK_C": 0.01709891483188,
    "CMYK_M": 0.02795632183552,
    "CMYK_Y": 0,
    "CMYK_K": 0.52073776721954
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37303",
    "Farbtonhilfsbezeichnung": "37303",
    "Farbtonklasse": "01",
    "Rcolor": "137",
    "Gcolor": "136",
    "Bcolor": "140",
    "Y": 26,
    "L": 56.9615936279297,
    "a": 1.01481604576111,
    "b": -2.33858299255371,
    "C": 2.5492787361145,
    "h": 293.458190917969,
    "CMY_C": 0.46413451433182,
    "CMY_M": 0.46520829200745,
    "CMY_Y": 0.45240426063538,
    "CMYK_C": 0.02142137475312,
    "CMYK_M": 0.02338227070868,
    "CMYK_Y": 0,
    "CMYK_K": 0.45240426063538
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37304",
    "Farbtonhilfsbezeichnung": "37304",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "157",
    "Bcolor": "160",
    "Y": 35,
    "L": 65.0080642700195,
    "a": 0.90910392999649,
    "b": -1.80318355560303,
    "C": 2.01939129829407,
    "h": 296.755706787109,
    "CMY_C": 0.38057088851929,
    "CMY_M": 0.38254588842392,
    "CMY_Y": 0.3737216591835,
    "CMYK_C": 0.01093639805913,
    "CMYK_M": 0.01408994756639,
    "CMYK_Y": 0,
    "CMYK_K": 0.3737216591835
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37305",
    "Farbtonhilfsbezeichnung": "37305",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "181",
    "Bcolor": "182",
    "Y": 48,
    "L": 73.8350067138672,
    "a": 0.83002841472626,
    "b": -1.05587637424469,
    "C": 1.34306442737579,
    "h": 308.171020507813,
    "CMY_C": 0.28567379713058,
    "CMY_M": 0.28959757089615,
    "CMY_Y": 0.28640615940094,
    "CMYK_C": 0,
    "CMYK_M": 0.00549297174439,
    "CMYK_Y": 0.0010252490174,
    "CMYK_K": 0.28567379713058
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37306",
    "Farbtonhilfsbezeichnung": "37306",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "200",
    "Bcolor": "199",
    "Y": 59,
    "L": 80.6270141601563,
    "a": 0.62092041969299,
    "b": -0.07701921463013,
    "C": 0.62567895650864,
    "h": 352.929138183594,
    "CMY_C": 0.2108206152916,
    "CMY_M": 0.21625798940659,
    "CMY_Y": 0.22076970338821,
    "CMYK_C": 0,
    "CMYK_M": 0.00688990904018,
    "CMYK_Y": 0.0126068778336,
    "CMYK_K": 0.2108206152916
  },
  {
    "Farbtonkarten_Bezeichnung": "STOCOLOR SYSTEM",
    "Farbton_ID": "37307",
    "Farbtonhilfsbezeichnung": "37307",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "213",
    "Bcolor": "209",
    "Y": 68,
    "L": 85.2699890136719,
    "a": -0.01101121213287,
    "b": 1.14326918125153,
    "C": 1.14332222938538,
    "h": 90.5518188476562,
    "CMY_C": 0.16085129976273,
    "CMY_M": 0.16437429189682,
    "CMY_Y": 0.17939358949661,
    "CMYK_C": 0,
    "CMYK_M": 0.00419829320163,
    "CMYK_Y": 0.02209654822946,
    "CMYK_K": 0.16085129976273
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B412731",
    "Farbtonhilfsbezeichnung": "B41 27 31 Ultramarin",
    "Farbtonklasse": "03",
    "Rcolor": "35",
    "Gcolor": "63",
    "Bcolor": "110",
    "Y": 5,
    "L": 26.9495658874512,
    "a": 6.06682395935059,
    "b": -30.5709438323975,
    "C": 31.1671142578125,
    "h": 281.224548339844,
    "CMY_C": 0.860979616642,
    "CMY_M": 0.75163793563843,
    "CMY_Y": 0.56989252567291,
    "CMYK_C": 0.67677754163742,
    "CMYK_M": 0.42255812883377,
    "CMYK_Y": 0,
    "CMYK_K": 0.56989252567291
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B413010",
    "Farbtonhilfsbezeichnung": "B41 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "72",
    "Bcolor": "86",
    "Y": 6,
    "L": 30.5346946716309,
    "a": 1.44192802906036,
    "b": -9.60650825500488,
    "C": 9.71412181854248,
    "h": 278.536315917969,
    "CMY_C": 0.74009770154953,
    "CMY_M": 0.71821331977844,
    "CMY_Y": 0.66264939308167,
    "CMYK_C": 0.22957809269428,
    "CMYK_M": 0.16470676660538,
    "CMYK_Y": 0,
    "CMYK_K": 0.66264939308167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B413020",
    "Farbtonhilfsbezeichnung": "B41 30 20",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "71",
    "Bcolor": "100",
    "Y": 6,
    "L": 30.1487922668457,
    "a": 3.27068090438843,
    "b": -19.0090103149414,
    "C": 19.2883338928223,
    "h": 279.7626953125,
    "CMY_C": 0.772556245327,
    "CMY_M": 0.72224974632263,
    "CMY_Y": 0.60928827524185,
    "CMYK_C": 0.41787323355675,
    "CMYK_M": 0.28911718726158,
    "CMYK_Y": 0,
    "CMYK_K": 0.60928827524185
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B414005",
    "Farbtonhilfsbezeichnung": "B41 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "93",
    "Bcolor": "100",
    "Y": 11,
    "L": 39.6092147827148,
    "a": 0.78892266750336,
    "b": -4.6647310256958,
    "C": 4.73097372055054,
    "h": 279.599304199219,
    "CMY_C": 0.64329409599304,
    "CMY_M": 0.63426315784454,
    "CMY_Y": 0.60775566101074,
    "CMYK_C": 0.09060280025005,
    "CMYK_M": 0.06757904589176,
    "CMYK_Y": 0,
    "CMYK_K": 0.60775566101074
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B414015",
    "Farbtonhilfsbezeichnung": "B41 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "94",
    "Bcolor": "117",
    "Y": 11,
    "L": 40.0641860961914,
    "a": 2.49918532371521,
    "b": -14.7841854095459,
    "C": 14.9939346313477,
    "h": 279.594818115234,
    "CMY_C": 0.66527163982391,
    "CMY_M": 0.63045251369476,
    "CMY_Y": 0.53940415382385,
    "CMYK_C": 0.27327099442482,
    "CMYK_M": 0.19767516851425,
    "CMYK_Y": 0,
    "CMYK_K": 0.53940415382385
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B414020",
    "Farbtonhilfsbezeichnung": "B41 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "95",
    "Bcolor": "126",
    "Y": 11,
    "L": 40.3021011352539,
    "a": 3.40859818458557,
    "b": -19.7120342254639,
    "C": 20.0045700073242,
    "h": 279.810546875,
    "CMY_C": 0.67907285690308,
    "CMY_M": 0.6284071803093,
    "CMY_Y": 0.50571548938751,
    "CMYK_C": 0.35072386264801,
    "CMYK_M": 0.24822078645229,
    "CMYK_Y": 0,
    "CMYK_K": 0.50571548938751
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B415010",
    "Farbtonhilfsbezeichnung": "B41 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "119",
    "Bcolor": "135",
    "Y": 18,
    "L": 50.0074615478516,
    "a": 1.76449799537659,
    "b": -9.94262409210205,
    "C": 10.0979814529419,
    "h": 280.063385009766,
    "CMY_C": 0.55485999584198,
    "CMY_M": 0.53420126438141,
    "CMY_Y": 0.47188013792038,
    "CMYK_C": 0.15712314844131,
    "CMYK_M": 0.11800564825535,
    "CMYK_Y": 0,
    "CMYK_K": 0.47188013792038
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B415020",
    "Farbtonhilfsbezeichnung": "B41 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "120",
    "Bcolor": "152",
    "Y": 18,
    "L": 50.5133209228516,
    "a": 3.49492955207825,
    "b": -19.3665370941162,
    "C": 19.6793613433838,
    "h": 280.229614257813,
    "CMY_C": 0.57669872045517,
    "CMY_M": 0.5298547744751,
    "CMY_Y": 0.40448677539825,
    "CMYK_C": 0.28918239474297,
    "CMYK_M": 0.21052093803883,
    "CMYK_Y": 0,
    "CMYK_K": 0.40448677539825
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B416005",
    "Farbtonhilfsbezeichnung": "B41 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "143",
    "Bcolor": "151",
    "Y": 28,
    "L": 59.4830780029297,
    "a": 0.85021764039993,
    "b": -4.92897176742554,
    "C": 5.00176286697388,
    "h": 279.786865234375,
    "CMY_C": 0.4484840631485,
    "CMY_M": 0.43848252296448,
    "CMY_Y": 0.40926676988602,
    "CMYK_C": 0.06638748198748,
    "CMYK_M": 0.04945676401258,
    "CMYK_Y": 0,
    "CMYK_K": 0.40926676988602
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B416015",
    "Farbtonhilfsbezeichnung": "B41 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "144",
    "Bcolor": "169",
    "Y": 28,
    "L": 59.8440589904785,
    "a": 2.54435873031616,
    "b": -14.8673057556152,
    "C": 15.0834522247315,
    "h": 279.711395263672,
    "CMY_C": 0.47011417150497,
    "CMY_M": 0.43548512458801,
    "CMY_Y": 0.33782893419266,
    "CMYK_C": 0.19977502524853,
    "CMYK_M": 0.14747878909111,
    "CMYK_Y": 0,
    "CMYK_K": 0.33782893419266
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B416020",
    "Farbtonhilfsbezeichnung": "B41 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "145",
    "Bcolor": "178",
    "Y": 28,
    "L": 60.097038269043,
    "a": 3.37559151649475,
    "b": -19.5131568908691,
    "C": 19.8029766082764,
    "h": 279.814483642578,
    "CMY_C": 0.48154580593109,
    "CMY_M": 0.43317377567291,
    "CMY_Y": 0.30340874195099,
    "CMYK_C": 0.25572681427002,
    "CMYK_M": 0.18628576397896,
    "CMYK_Y": 0,
    "CMYK_K": 0.30340874195099
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B416510",
    "Farbtonhilfsbezeichnung": "B41 65 10",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "156",
    "Bcolor": "173",
    "Y": 34,
    "L": 64.3696441650391,
    "a": 1.82057702541351,
    "b": -10.3098220825195,
    "C": 10.4693326950073,
    "h": 280.014434814453,
    "CMY_C": 0.4107785820961,
    "CMY_M": 0.3887225985527,
    "CMY_Y": 0.32160753011703,
    "CMYK_C": 0.13144463300705,
    "CMYK_M": 0.09893250465393,
    "CMYK_Y": 0,
    "CMYK_K": 0.32160753011703
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B416515",
    "Farbtonhilfsbezeichnung": "B41 65 15",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "156",
    "Bcolor": "181",
    "Y": 34,
    "L": 64.564338684082,
    "a": 2.58919405937195,
    "b": -14.5382413864136,
    "C": 14.7670030593872,
    "h": 280.098236083984,
    "CMY_C": 0.4198157787323,
    "CMY_M": 0.38707929849625,
    "CMY_Y": 0.29028695821762,
    "CMYK_C": 0.18250872194767,
    "CMYK_M": 0.13638235628605,
    "CMYK_Y": 0,
    "CMYK_K": 0.29028695821762
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B417005",
    "Farbtonhilfsbezeichnung": "B41 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "171",
    "Bcolor": "179",
    "Y": 41,
    "L": 69.9086761474609,
    "a": 0.89949506521225,
    "b": -5.06413602828979,
    "C": 5.14340019226074,
    "h": 280.071868896484,
    "CMY_C": 0.34058940410614,
    "CMY_M": 0.33026993274689,
    "CMY_Y": 0.29975068569183,
    "CMYK_C": 0.05832025408745,
    "CMYK_M": 0.0435834005475,
    "CMYK_Y": 0,
    "CMYK_K": 0.29975068569183
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B417010",
    "Farbtonhilfsbezeichnung": "B41 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "171",
    "Bcolor": "188",
    "Y": 41,
    "L": 70.1724472045898,
    "a": 1.71376216411591,
    "b": -9.83687114715576,
    "C": 9.98503971099854,
    "h": 279.882781982422,
    "CMY_C": 0.34923559427261,
    "CMY_M": 0.32789552211761,
    "CMY_Y": 0.26339775323868,
    "CMYK_C": 0.11653214693069,
    "CMYK_M": 0.08756119012833,
    "CMYK_Y": 0,
    "CMYK_K": 0.26339775323868
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B417015",
    "Farbtonhilfsbezeichnung": "B41 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "170",
    "Bcolor": "194",
    "Y": 41,
    "L": 69.5570526123047,
    "a": 2.67148518562317,
    "b": -14.3494882583618,
    "C": 14.5960493087769,
    "h": 280.546173095703,
    "CMY_C": 0.36625027656555,
    "CMY_M": 0.33512604236603,
    "CMY_Y": 0.23824501037598,
    "CMYK_C": 0.16803994774818,
    "CMYK_M": 0.12718135118484,
    "CMYK_Y": 0,
    "CMYK_K": 0.23824501037598
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B417505",
    "Farbtonhilfsbezeichnung": "B41 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "185",
    "Bcolor": "193",
    "Y": 48,
    "L": 75.0969467163086,
    "a": 0.93423926830292,
    "b": -5.09638214111328,
    "C": 5.18130445480347,
    "h": 280.387786865234,
    "CMY_C": 0.28542041778564,
    "CMY_M": 0.27518838644028,
    "CMY_Y": 0.24425941705704,
    "CMYK_C": 0.05446445569396,
    "CMYK_M": 0.04092537984252,
    "CMYK_Y": 0,
    "CMYK_K": 0.24425941705704
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B417510",
    "Farbtonhilfsbezeichnung": "B41 75 10",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "183",
    "Bcolor": "200",
    "Y": 48,
    "L": 74.5476989746094,
    "a": 1.74025726318359,
    "b": -9.90207195281982,
    "C": 10.0538311004639,
    "h": 279.967742919922,
    "CMY_C": 0.30294543504715,
    "CMY_M": 0.28145635128021,
    "CMY_Y": 0.21593350172043,
    "CMYK_C": 0.1109751984477,
    "CMYK_M": 0.0835679769516,
    "CMYK_Y": 0,
    "CMYK_K": 0.21593350172043
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B418005",
    "Farbtonhilfsbezeichnung": "B41 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "197",
    "Bcolor": "204",
    "Y": 57,
    "L": 79.5755081176758,
    "a": 0.93822193145752,
    "b": -4.69959735870361,
    "C": 4.79233503341675,
    "h": 281.2900390625,
    "CMY_C": 0.23582112789154,
    "CMY_M": 0.22707062959671,
    "CMY_Y": 0.19879668951035,
    "CMYK_C": 0.04621104151011,
    "CMYK_M": 0.03528934344649,
    "CMYK_Y": 0,
    "CMYK_K": 0.19879668951035
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B418505",
    "Farbtonhilfsbezeichnung": "B41 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "212",
    "Bcolor": "220",
    "Y": 66,
    "L": 84.9491424560547,
    "a": 0.9473123550415,
    "b": -4.97585582733154,
    "C": 5.0652289390564,
    "h": 280.779083251953,
    "CMY_C": 0.17824310064316,
    "CMY_M": 0.16837430000305,
    "CMY_Y": 0.138123691082,
    "CMYK_C": 0.0465489178896,
    "CMYK_M": 0.03509854897857,
    "CMYK_Y": 0,
    "CMYK_K": 0.138123691082
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B418510",
    "Farbtonhilfsbezeichnung": "B41 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "212",
    "Bcolor": "228",
    "Y": 66,
    "L": 84.8931884765625,
    "a": 1.7413477897644,
    "b": -9.57052707672119,
    "C": 9.7276554107666,
    "h": 280.312103271484,
    "CMY_C": 0.18986332416534,
    "CMY_M": 0.16944444179535,
    "CMY_Y": 0.10513073205948,
    "CMYK_C": 0.09468711912632,
    "CMYK_M": 0.07186938822269,
    "CMYK_Y": 0,
    "CMYK_K": 0.10513073205948
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B419005",
    "Farbtonhilfsbezeichnung": "B41 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "225",
    "Bcolor": "232",
    "Y": 76,
    "L": 89.532096862793,
    "a": 0.80244606733322,
    "b": -4.55800724029541,
    "C": 4.6281042098999,
    "h": 279.984710693359,
    "CMY_C": 0.1273507475853,
    "CMY_M": 0.11752581596375,
    "CMY_Y": 0.09057259559631,
    "CMYK_C": 0.04044099897146,
    "CMYK_M": 0.02963757142425,
    "CMYK_Y": 0,
    "CMYK_K": 0.09057259559631
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B422513",
    "Farbtonhilfsbezeichnung": "B42 25 13 Berliner Blau",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "59",
    "Bcolor": "78",
    "Y": 4,
    "L": 24.7099418640137,
    "a": 0.37719655036926,
    "b": -13.0785446166992,
    "C": 13.0839824676514,
    "h": 271.652008056641,
    "CMY_C": 0.81505274772644,
    "CMY_M": 0.76700901985168,
    "CMY_Y": 0.69580471515656,
    "CMYK_C": 0.3920114338398,
    "CMYK_M": 0.23407432436943,
    "CMYK_Y": 0,
    "CMYK_K": 0.69580471515656
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B424010",
    "Farbtonhilfsbezeichnung": "B42 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "94",
    "Bcolor": "109",
    "Y": 11,
    "L": 39.8572959899902,
    "a": 0.81799161434174,
    "b": -9.87333393096924,
    "C": 9.90716075897217,
    "h": 274.736053466797,
    "CMY_C": 0.65959012508392,
    "CMY_M": 0.63050210475922,
    "CMY_Y": 0.57259154319763,
    "CMYK_C": 0.20354904234409,
    "CMYK_M": 0.13549230992794,
    "CMYK_Y": 0,
    "CMYK_K": 0.57259154319763
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B424020",
    "Farbtonhilfsbezeichnung": "B42 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "96",
    "Bcolor": "126",
    "Y": 11,
    "L": 40.3375053405762,
    "a": 1.56632828712463,
    "b": -19.8796672821045,
    "C": 19.9412784576416,
    "h": 274.505065917969,
    "CMY_C": 0.69531697034836,
    "CMY_M": 0.62422335147858,
    "CMY_Y": 0.50445002317429,
    "CMYK_C": 0.38516184687614,
    "CMYK_M": 0.24169777333736,
    "CMYK_Y": 0,
    "CMYK_K": 0.50445002317429
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B424520",
    "Farbtonhilfsbezeichnung": "B42 45 20",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "110",
    "Bcolor": "141",
    "Y": 15,
    "L": 45.9876251220703,
    "a": 1.63344430923462,
    "b": -20.1254367828369,
    "C": 20.1916160583496,
    "h": 274.64013671875,
    "CMY_C": 0.64098942279816,
    "CMY_M": 0.56999456882477,
    "CMY_Y": 0.44597828388214,
    "CMYK_C": 0.35199186205864,
    "CMYK_M": 0.22384732961655,
    "CMYK_Y": 0,
    "CMYK_K": 0.44597828388214
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B424535",
    "Farbtonhilfsbezeichnung": "B42 45 35 Lapis Lazuli",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "110",
    "Bcolor": "164",
    "Y": 15,
    "L": 45.5859031677246,
    "a": 2.67992496490479,
    "b": -34.5832366943359,
    "C": 34.6869163513184,
    "h": 274.431121826172,
    "CMY_C": 0.73457038402557,
    "CMY_M": 0.57040774822235,
    "CMY_Y": 0.3554305434227,
    "CMYK_C": 0.58820635080338,
    "CMYK_M": 0.33352062106133,
    "CMYK_Y": 0,
    "CMYK_K": 0.3554305434227
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B425015",
    "Farbtonhilfsbezeichnung": "B42 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "119",
    "Bcolor": "142",
    "Y": 18,
    "L": 49.8030090332031,
    "a": 1.28343307971954,
    "b": -14.8835067749023,
    "C": 14.9387407302856,
    "h": 274.928527832031,
    "CMY_C": 0.58105736970901,
    "CMY_M": 0.53365170955658,
    "CMY_Y": 0.44152426719666,
    "CMYK_C": 0.24984630942345,
    "CMYK_M": 0.16496230661869,
    "CMYK_Y": 0,
    "CMYK_K": 0.44152426719666
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B425126",
    "Farbtonhilfsbezeichnung": "B42 51 26 Smalte",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "122",
    "Bcolor": "163",
    "Y": 19,
    "L": 50.9181098937988,
    "a": 3.00353240966797,
    "b": -25.1727848052979,
    "C": 25.3513374328613,
    "h": 276.804168701172,
    "CMY_C": 0.60749119520187,
    "CMY_M": 0.52267861366272,
    "CMY_Y": 0.36183792352676,
    "CMYK_C": 0.38493868708611,
    "CMYK_M": 0.25203737616539,
    "CMYK_Y": 0,
    "CMYK_K": 0.36183792352676
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B425520",
    "Farbtonhilfsbezeichnung": "B42 55 20",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "134",
    "Bcolor": "167",
    "Y": 23,
    "L": 55.7975692749023,
    "a": 1.59466147422791,
    "b": -19.9802799224854,
    "C": 20.043815612793,
    "h": 274.563201904297,
    "CMY_C": 0.5427166223526,
    "CMY_M": 0.47276973724365,
    "CMY_Y": 0.34569293260574,
    "CMYK_C": 0.30111807584763,
    "CMYK_M": 0.19421584904194,
    "CMYK_Y": 0,
    "CMYK_K": 0.34569293260574
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B426010",
    "Farbtonhilfsbezeichnung": "B42 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "145",
    "Bcolor": "161",
    "Y": 28,
    "L": 59.8897895812988,
    "a": 1.06048762798309,
    "b": -10.2385272979736,
    "C": 10.2933025360107,
    "h": 275.913513183594,
    "CMY_C": 0.46242904663086,
    "CMY_M": 0.43321740627289,
    "CMY_Y": 0.36899697780609,
    "CMYK_C": 0.14806912839413,
    "CMYK_M": 0.1017751544714,
    "CMYK_Y": 0,
    "CMYK_K": 0.36899697780609
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B426515",
    "Farbtonhilfsbezeichnung": "B42 65 15",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "158",
    "Bcolor": "183",
    "Y": 34,
    "L": 64.7709045410156,
    "a": 1.2758674621582,
    "b": -15.2462816238403,
    "C": 15.2995729446411,
    "h": 274.783599853516,
    "CMY_C": 0.43145418167114,
    "CMY_M": 0.38176745176315,
    "CMY_Y": 0.28333812952042,
    "CMYK_C": 0.20667494833469,
    "CMYK_M": 0.13734416663647,
    "CMYK_Y": 0,
    "CMYK_K": 0.28333812952042
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B427005",
    "Farbtonhilfsbezeichnung": "B42 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "171",
    "Bcolor": "177",
    "Y": 41,
    "L": 69.781982421875,
    "a": 0.38657090067863,
    "b": -4.66772222518921,
    "C": 4.68370246887207,
    "h": 274.734313964844,
    "CMY_C": 0.34446406364441,
    "CMY_M": 0.33056610822678,
    "CMY_Y": 0.30392915010452,
    "CMYK_C": 0.05823389068246,
    "CMYK_M": 0.03826759755611,
    "CMYK_Y": 0,
    "CMYK_K": 0.30392915010452
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B427015",
    "Farbtonhilfsbezeichnung": "B42 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "171",
    "Bcolor": "196",
    "Y": 41,
    "L": 69.71533203125,
    "a": 1.31763100624084,
    "b": -15.150242805481,
    "C": 15.2074327468872,
    "h": 274.970550537109,
    "CMY_C": 0.37914079427719,
    "CMY_M": 0.33012342453003,
    "CMY_Y": 0.23107343912125,
    "CMYK_C": 0.19256371259689,
    "CMYK_M": 0.12881591916084,
    "CMYK_Y": 0,
    "CMYK_K": 0.23107343912125
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B428010",
    "Farbtonhilfsbezeichnung": "B42 80 10",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "197",
    "Bcolor": "214",
    "Y": 57,
    "L": 79.5649795532227,
    "a": 1.12767910957336,
    "b": -10.1598987579346,
    "C": 10.2222890853882,
    "h": 276.333526611328,
    "CMY_C": 0.25510984659195,
    "CMY_M": 0.22595655918121,
    "CMY_Y": 0.15959852933884,
    "CMYK_C": 0.11364962905645,
    "CMYK_M": 0.07895991951227,
    "CMYK_Y": 0,
    "CMYK_K": 0.15959852933884
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B428505",
    "Farbtonhilfsbezeichnung": "B42 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "219",
    "Y": 66,
    "L": 84.502799987793,
    "a": 0.48197063803673,
    "b": -5.1988697052002,
    "C": 5.22116279602051,
    "h": 275.296569824219,
    "CMY_C": 0.18767595291138,
    "CMY_M": 0.17211753129959,
    "CMY_Y": 0.14146244525909,
    "CMYK_C": 0.05382817238569,
    "CMYK_M": 0.03570616617799,
    "CMYK_Y": 0,
    "CMYK_K": 0.14146244525909
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B433030",
    "Farbtonhilfsbezeichnung": "B43 30 30",
    "Farbtonklasse": "03",
    "Rcolor": "26",
    "Gcolor": "74",
    "Bcolor": "116",
    "Y": 6,
    "L": 30.2189025878906,
    "a": -0.09124602377415,
    "b": -29.3536643981934,
    "C": 29.3538055419922,
    "h": 269.821899414063,
    "CMY_C": 0.8992720246315,
    "CMY_M": 0.71114432811737,
    "CMY_Y": 0.54558753967285,
    "CMYK_C": 0.77833360433578,
    "CMYK_M": 0.36433154344559,
    "CMYK_Y": 0,
    "CMYK_K": 0.54558753967285
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B434015",
    "Farbtonhilfsbezeichnung": "B43 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "96",
    "Bcolor": "118",
    "Y": 11,
    "L": 40.1858978271484,
    "a": -0.05796388536692,
    "b": -14.849142074585,
    "C": 14.8492555618286,
    "h": 269.776336669922,
    "CMY_C": 0.68488466739655,
    "CMY_M": 0.62409162521362,
    "CMY_Y": 0.53802609443665,
    "CMYK_C": 0.31789365410805,
    "CMYK_M": 0.18629954755306,
    "CMYK_Y": 0,
    "CMYK_K": 0.53802609443665
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B434025",
    "Farbtonhilfsbezeichnung": "B43 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "97",
    "Bcolor": "133",
    "Y": 11,
    "L": 40.3336563110352,
    "a": -0.35839092731476,
    "b": -23.9976615905762,
    "C": 24.000337600708,
    "h": 269.144378662109,
    "CMY_C": 0.73889255523682,
    "CMY_M": 0.61893022060394,
    "CMY_Y": 0.47838234901428,
    "CMYK_C": 0.49942752718925,
    "CMYK_M": 0.26944616436958,
    "CMYK_Y": 0,
    "CMYK_K": 0.47838234901428
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B435020",
    "Farbtonhilfsbezeichnung": "B43 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "119",
    "Bcolor": "151",
    "Y": 18,
    "L": 49.482479095459,
    "a": -0.09249209612608,
    "b": -20.2278518676758,
    "C": 20.228063583374,
    "h": 269.738006591797,
    "CMY_C": 0.62220549583435,
    "CMY_M": 0.53215003013611,
    "CMY_Y": 0.40972888469696,
    "CMYK_C": 0.35996443033218,
    "CMYK_M": 0.20739816129208,
    "CMYK_Y": 0,
    "CMYK_K": 0.40972888469696
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B435025",
    "Farbtonhilfsbezeichnung": "B43 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "121",
    "Bcolor": "160",
    "Y": 18,
    "L": 50.1084823608398,
    "a": -0.17506642639637,
    "b": -24.8227157592773,
    "C": 24.8233337402344,
    "h": 269.595916748047,
    "CMY_C": 0.6436939239502,
    "CMY_M": 0.52414548397064,
    "CMY_Y": 0.37287092208862,
    "CMYK_C": 0.43184572458267,
    "CMYK_M": 0.24121758341789,
    "CMYK_Y": 0,
    "CMYK_K": 0.37287092208862
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B436010",
    "Farbtonhilfsbezeichnung": "B43 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "146",
    "Bcolor": "161",
    "Y": 28,
    "L": 60.1458511352539,
    "a": -0.00942267663777,
    "b": -9.88115501403809,
    "C": 9.88115978240967,
    "h": 269.945373535156,
    "CMY_C": 0.46682786941528,
    "CMY_M": 0.42837601900101,
    "CMY_Y": 0.36888700723648,
    "CMYK_C": 0.15518751740456,
    "CMYK_M": 0.0942604765296,
    "CMYK_Y": 0,
    "CMYK_K": 0.36888700723648
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B436015",
    "Farbtonhilfsbezeichnung": "B43 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "144",
    "Bcolor": "169",
    "Y": 28,
    "L": 59.5215721130371,
    "a": 0.15255564451218,
    "b": -15.5189685821533,
    "C": 15.519718170166,
    "h": 270.563201904297,
    "CMY_C": 0.49587374925613,
    "CMY_M": 0.43334054946899,
    "CMY_Y": 0.33701950311661,
    "CMYK_C": 0.23960621654987,
    "CMYK_M": 0.14528489112854,
    "CMYK_Y": 0,
    "CMYK_K": 0.33701950311661
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B437010",
    "Farbtonhilfsbezeichnung": "B43 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "171",
    "Bcolor": "187",
    "Y": 41,
    "L": 69.6290893554688,
    "a": 0.00399590097368,
    "b": -10.5023984909058,
    "C": 10.5023994445801,
    "h": 270.021789550781,
    "CMY_C": 0.37127935886383,
    "CMY_M": 0.32957458496094,
    "CMY_Y": 0.26473069190979,
    "CMYK_C": 0.14491108059883,
    "CMYK_M": 0.08819066733122,
    "CMYK_Y": 0,
    "CMYK_K": 0.26473069190979
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B437020",
    "Farbtonhilfsbezeichnung": "B43 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "173",
    "Bcolor": "206",
    "Y": 41,
    "L": 70.2122573852539,
    "a": -0.02496435679495,
    "b": -19.835319519043,
    "C": 19.835334777832,
    "h": 269.927886962891,
    "CMY_C": 0.40722674131393,
    "CMY_M": 0.32029068470001,
    "CMY_Y": 0.19290643930435,
    "CMYK_C": 0.26554578542709,
    "CMYK_M": 0.15783083438873,
    "CMYK_Y": 0,
    "CMYK_K": 0.19290643930435
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B438005",
    "Farbtonhilfsbezeichnung": "B43 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "199",
    "Bcolor": "206",
    "Y": 57,
    "L": 79.967414855957,
    "a": 0.11612924933434,
    "b": -4.9602255821228,
    "C": 4.96158504486084,
    "h": 271.341156005859,
    "CMY_C": 0.23903840780258,
    "CMY_M": 0.22084230184555,
    "CMY_Y": 0.19277250766754,
    "CMYK_C": 0.05731457471848,
    "CMYK_M": 0.03477308899164,
    "CMYK_Y": 0,
    "CMYK_K": 0.19277250766754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B438010",
    "Farbtonhilfsbezeichnung": "B43 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "198",
    "Bcolor": "214",
    "Y": 57,
    "L": 79.5185089111328,
    "a": 0.1681712269783,
    "b": -10.2899398803711,
    "C": 10.291314125061,
    "h": 270.936309814453,
    "CMY_C": 0.26398915052414,
    "CMY_M": 0.22420561313629,
    "CMY_Y": 0.15928548574448,
    "CMYK_C": 0.12454128265381,
    "CMYK_M": 0.07722017914057,
    "CMYK_Y": 0,
    "CMYK_K": 0.15928548574448
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B438415",
    "Farbtonhilfsbezeichnung": "B43 84 15",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "210",
    "Bcolor": "234",
    "Y": 64,
    "L": 83.876579284668,
    "a": 0.16165322065353,
    "b": -14.4121227264404,
    "C": 14.4130296707153,
    "h": 270.642639160156,
    "CMY_C": 0.23416835069656,
    "CMY_M": 0.17534190416336,
    "CMY_Y": 0.08131659030914,
    "CMYK_C": 0.16638132929802,
    "CMYK_M": 0.10234789550304,
    "CMYK_Y": 0,
    "CMYK_K": 0.08131659030914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B443703",
    "Farbtonhilfsbezeichnung": "B44 37 03 Schiefer",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "87",
    "Bcolor": "93",
    "Y": 10,
    "L": 36.8235130310059,
    "a": -0.14093552529812,
    "b": -4.23023223876953,
    "C": 4.23257923126221,
    "h": 268.091827392578,
    "CMY_C": 0.67443537712097,
    "CMY_M": 0.65872269868851,
    "CMY_Y": 0.63692367076874,
    "CMYK_C": 0.10331630706787,
    "CMYK_M": 0.06003979220986,
    "CMYK_Y": 0,
    "CMYK_K": 0.63692367076874
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B444010",
    "Farbtonhilfsbezeichnung": "B44 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "95",
    "Bcolor": "109",
    "Y": 11,
    "L": 39.616268157959,
    "a": -1.02328062057495,
    "b": -10.3073444366455,
    "C": 10.3580141067505,
    "h": 264.330444335938,
    "CMY_C": 0.67766630649567,
    "CMY_M": 0.62898707389832,
    "CMY_Y": 0.57236605882645,
    "CMYK_C": 0.24623921513557,
    "CMYK_M": 0.13240534067154,
    "CMYK_Y": 0,
    "CMYK_K": 0.57236605882645
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B444020",
    "Farbtonhilfsbezeichnung": "B44 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "96",
    "Bcolor": "125",
    "Y": 11,
    "L": 39.6778297424316,
    "a": -1.92790615558624,
    "b": -20.0804786682129,
    "C": 20.172815322876,
    "h": 264.515899658203,
    "CMY_C": 0.73509562015533,
    "CMY_M": 0.62351763248444,
    "CMY_Y": 0.51002562046051,
    "CMYK_C": 0.45935055613518,
    "CMYK_M": 0.23162846267223,
    "CMYK_Y": 0,
    "CMYK_K": 0.51002562046051
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B444730",
    "Farbtonhilfsbezeichnung": "B44 47 30 Aegyptisch Blau",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "117",
    "Bcolor": "162",
    "Y": 16,
    "L": 47.531379699707,
    "a": -2.98042893409729,
    "b": -29.9965057373047,
    "C": 30.1442089080811,
    "h": 264.325775146484,
    "CMY_C": 0.74177861213684,
    "CMY_M": 0.54195314645767,
    "CMY_Y": 0.36571764945984,
    "CMYK_C": 0.5928920507431,
    "CMYK_M": 0.27785024046898,
    "CMYK_Y": 0,
    "CMYK_K": 0.36571764945984
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B445005",
    "Farbtonhilfsbezeichnung": "B44 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "120",
    "Bcolor": "126",
    "Y": 18,
    "L": 50.1308898925781,
    "a": -0.52363592386246,
    "b": -4.80021524429321,
    "C": 4.82869148254395,
    "h": 263.774444580078,
    "CMY_C": 0.5518593788147,
    "CMY_M": 0.52964097261429,
    "CMY_Y": 0.50465369224548,
    "CMYK_C": 0.09529834985733,
    "CMYK_M": 0.05044406279922,
    "CMYK_Y": 0,
    "CMYK_K": 0.50465369224548
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B445015",
    "Farbtonhilfsbezeichnung": "B44 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "121",
    "Bcolor": "143",
    "Y": 18,
    "L": 50.0638580322266,
    "a": -1.3490127325058,
    "b": -14.6548748016357,
    "C": 14.716833114624,
    "h": 264.740631103516,
    "CMY_C": 0.5991405248642,
    "CMY_M": 0.5256781578064,
    "CMY_Y": 0.44063061475754,
    "CMYK_C": 0.28337252140045,
    "CMYK_M": 0.15204182267189,
    "CMYK_Y": 0,
    "CMYK_K": 0.44063061475754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B445025",
    "Farbtonhilfsbezeichnung": "B44 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "124",
    "Bcolor": "161",
    "Y": 18,
    "L": 50.6562232971191,
    "a": -2.19898271560669,
    "b": -24.8295154571533,
    "C": 24.926700592041,
    "h": 264.938903808594,
    "CMY_C": 0.65855604410172,
    "CMY_M": 0.51459968090057,
    "CMY_Y": 0.36728852987289,
    "CMYK_C": 0.46034809947014,
    "CMYK_M": 0.23282516002655,
    "CMYK_Y": 0,
    "CMYK_K": 0.36728852987289
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B446010",
    "Farbtonhilfsbezeichnung": "B44 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "146",
    "Bcolor": "160",
    "Y": 28,
    "L": 59.9618873596191,
    "a": -0.84597945213318,
    "b": -9.87464332580566,
    "C": 9.91081523895264,
    "h": 265.103332519531,
    "CMY_C": 0.47532445192337,
    "CMY_M": 0.42846095561981,
    "CMY_Y": 0.3709317445755,
    "CMYK_C": 0.16594813764095,
    "CMYK_M": 0.09145145863295,
    "CMYK_Y": 0,
    "CMYK_K": 0.3709317445755
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B446020",
    "Farbtonhilfsbezeichnung": "B44 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "147",
    "Bcolor": "178",
    "Y": 28,
    "L": 59.9861145019531,
    "a": -1.68913578987122,
    "b": -19.9852275848389,
    "C": 20.0564823150635,
    "h": 265.168884277344,
    "CMY_C": 0.52920532226563,
    "CMY_M": 0.42315995693207,
    "CMY_Y": 0.30184859037399,
    "CMYK_C": 0.32565534114838,
    "CMYK_M": 0.17376083135605,
    "CMYK_Y": 0,
    "CMYK_K": 0.30184859037399
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B447005",
    "Farbtonhilfsbezeichnung": "B44 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "171",
    "Bcolor": "178",
    "Y": 41,
    "L": 69.6594085693359,
    "a": -0.36046069860458,
    "b": -5.0915412902832,
    "C": 5.10428476333618,
    "h": 265.950439453125,
    "CMY_C": 0.35307836532593,
    "CMY_M": 0.33006447553635,
    "CMY_Y": 0.30234771966934,
    "CMYK_C": 0.0727162361145,
    "CMYK_M": 0.03972861170769,
    "CMYK_Y": 0,
    "CMYK_K": 0.30234771966934
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B447015",
    "Farbtonhilfsbezeichnung": "B44 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "172",
    "Bcolor": "195",
    "Y": 41,
    "L": 69.786750793457,
    "a": -1.37114143371582,
    "b": -14.6981449127197,
    "C": 14.7619609832764,
    "h": 264.670501708984,
    "CMY_C": 0.39905273914337,
    "CMY_M": 0.32353562116623,
    "CMY_Y": 0.23376721143723,
    "CMYK_C": 0.21571189165115,
    "CMYK_M": 0.11715552955866,
    "CMYK_Y": 0,
    "CMYK_K": 0.23376721143723
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B448010",
    "Farbtonhilfsbezeichnung": "B44 80 10",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "200",
    "Bcolor": "215",
    "Y": 57,
    "L": 80.0744934082031,
    "a": -0.76019018888474,
    "b": -10.065691947937,
    "C": 10.0943565368652,
    "h": 265.681060791016,
    "CMY_C": 0.26476114988327,
    "CMY_M": 0.21611595153809,
    "CMY_Y": 0.15492272377014,
    "CMYK_C": 0.12997440993786,
    "CMYK_M": 0.07241139560938,
    "CMYK_Y": 0,
    "CMYK_K": 0.15492272377014
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B448505",
    "Farbtonhilfsbezeichnung": "B44 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "213",
    "Bcolor": "219",
    "Y": 66,
    "L": 84.9404678344727,
    "a": -0.34574294090271,
    "b": -4.56693506240845,
    "C": 4.58000373840332,
    "h": 265.670654296875,
    "CMY_C": 0.18720310926437,
    "CMY_M": 0.16556799411774,
    "CMY_Y": 0.14136838912964,
    "CMYK_C": 0.05338112264872,
    "CMYK_M": 0.02818392030895,
    "CMYK_Y": 0,
    "CMYK_K": 0.14136838912964
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B453010",
    "Farbtonhilfsbezeichnung": "B45 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "74",
    "Bcolor": "86",
    "Y": 6,
    "L": 30.6589431762695,
    "a": -1.91049098968506,
    "b": -9.52321243286133,
    "C": 9.71295833587646,
    "h": 258.65625,
    "CMY_C": 0.76370316743851,
    "CMY_M": 0.71074229478836,
    "CMY_Y": 0.66229742765427,
    "CMYK_C": 0.30028122663498,
    "CMYK_M": 0.14345423877239,
    "CMYK_Y": 0,
    "CMYK_K": 0.66229742765427
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B453015",
    "Farbtonhilfsbezeichnung": "B45 30 15",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "73",
    "Bcolor": "93",
    "Y": 6,
    "L": 30.0990619659424,
    "a": -2.99393057823181,
    "b": -14.7562370300293,
    "C": 15.0568971633911,
    "h": 258.530792236328,
    "CMY_C": 0.8042317032814,
    "CMY_M": 0.71228921413422,
    "CMY_Y": 0.63600957393646,
    "CMYK_C": 0.46216085553169,
    "CMYK_M": 0.2095649689436,
    "CMYK_Y": 0,
    "CMYK_K": 0.63600957393646
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B454005",
    "Farbtonhilfsbezeichnung": "B45 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "94",
    "Bcolor": "100",
    "Y": 11,
    "L": 39.6161842346191,
    "a": -0.96528857946396,
    "b": -4.73142433166504,
    "C": 4.82888793945313,
    "h": 258.468963623047,
    "CMY_C": 0.65591168403625,
    "CMY_M": 0.63066482543945,
    "CMY_Y": 0.60745656490326,
    "CMYK_C": 0.12343887239695,
    "CMYK_M": 0.05912278220057,
    "CMYK_Y": 0,
    "CMYK_K": 0.60745656490326
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B454015",
    "Farbtonhilfsbezeichnung": "B45 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "95",
    "Bcolor": "116",
    "Y": 11,
    "L": 39.3013000488281,
    "a": -2.63098216056824,
    "b": -15.1054821014404,
    "C": 15.3328943252563,
    "h": 260.119689941406,
    "CMY_C": 0.7165145277977,
    "CMY_M": 0.62739479541779,
    "CMY_Y": 0.54531002044678,
    "CMYK_C": 0.376530200243,
    "CMYK_M": 0.18052910268307,
    "CMYK_Y": 0,
    "CMYK_K": 0.54531002044678
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B454025",
    "Farbtonhilfsbezeichnung": "B45 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "96",
    "Bcolor": "132",
    "Y": 11,
    "L": 39.1931533813477,
    "a": -4.31965017318726,
    "b": -25.1742477416992,
    "C": 25.542163848877,
    "h": 260.263427734375,
    "CMY_C": 0.80643552541733,
    "CMY_M": 0.62180435657501,
    "CMY_Y": 0.48264759778976,
    "CMYK_C": 0.6258556842804,
    "CMYK_M": 0.26897865533829,
    "CMYK_Y": 0,
    "CMYK_K": 0.48264759778976
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B455010",
    "Farbtonhilfsbezeichnung": "B45 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "120",
    "Bcolor": "134",
    "Y": 18,
    "L": 49.8629684448242,
    "a": -1.7840188741684,
    "b": -9.73080348968506,
    "C": 9.89299011230469,
    "h": 259.610931396484,
    "CMY_C": 0.58292174339294,
    "CMY_M": 0.52828931808472,
    "CMY_Y": 0.47509032487869,
    "CMYK_C": 0.20542852580547,
    "CMYK_M": 0.10134885460138,
    "CMYK_Y": 0,
    "CMYK_K": 0.47509032487869
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B455015",
    "Farbtonhilfsbezeichnung": "B45 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "122",
    "Bcolor": "143",
    "Y": 18,
    "L": 50.2376098632813,
    "a": -2.65063190460205,
    "b": -14.6728525161743,
    "C": 14.9103469848633,
    "h": 259.760040283203,
    "CMY_C": 0.6086266040802,
    "CMY_M": 0.52130961418152,
    "CMY_Y": 0.43886911869049,
    "CMYK_C": 0.30252742767334,
    "CMYK_M": 0.1469184756279,
    "CMYK_Y": 0,
    "CMYK_K": 0.43886911869049
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B455020",
    "Farbtonhilfsbezeichnung": "B45 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "121",
    "Bcolor": "151",
    "Y": 18,
    "L": 49.6563949584961,
    "a": -3.38293099403381,
    "b": -20.1856021881104,
    "C": 20.4671134948731,
    "h": 260.486145019531,
    "CMY_C": 0.65093624591827,
    "CMY_M": 0.52379667758942,
    "CMY_Y": 0.40850710868835,
    "CMYK_C": 0.40985977649689,
    "CMYK_M": 0.19491285085678,
    "CMYK_Y": 0,
    "CMYK_K": 0.40850710868835
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B456005",
    "Farbtonhilfsbezeichnung": "B45 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "146",
    "Bcolor": "152",
    "Y": 28,
    "L": 60.0671234130859,
    "a": -0.9319766163826,
    "b": -4.89725255966187,
    "C": 4.98514413833618,
    "h": 259.225128173828,
    "CMY_C": 0.45591503381729,
    "CMY_M": 0.42865085601807,
    "CMY_Y": 0.40370035171509,
    "CMYK_C": 0.08756450563669,
    "CMYK_M": 0.04184222593904,
    "CMYK_Y": 0,
    "CMYK_K": 0.40370035171509
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B456015",
    "Farbtonhilfsbezeichnung": "B45 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "146",
    "Bcolor": "168",
    "Y": 28,
    "L": 59.6762542724609,
    "a": -2.54014706611633,
    "b": -14.8430900573731,
    "C": 15.0588731765747,
    "h": 260.288848876953,
    "CMY_C": 0.51405721902847,
    "CMY_M": 0.42625296115875,
    "CMY_Y": 0.34027183055878,
    "CMYK_C": 0.26341968774796,
    "CMYK_M": 0.13032811880112,
    "CMYK_Y": 0,
    "CMYK_K": 0.34027183055878
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B456025",
    "Farbtonhilfsbezeichnung": "B45 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "148",
    "Bcolor": "185",
    "Y": 28,
    "L": 59.6565856933594,
    "a": -4.15233755111694,
    "b": -24.7434692382813,
    "C": 25.0894641876221,
    "h": 260.4736328125,
    "CMY_C": 0.58469545841217,
    "CMY_M": 0.41975545883179,
    "CMY_Y": 0.27303200960159,
    "CMYK_C": 0.42871686816216,
    "CMYK_M": 0.20182931423187,
    "CMYK_Y": 0,
    "CMYK_K": 0.27303200960159
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B457005",
    "Farbtonhilfsbezeichnung": "B45 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "172",
    "Bcolor": "179",
    "Y": 41,
    "L": 70.1331481933594,
    "a": -0.88461768627167,
    "b": -5.02101707458496,
    "C": 5.09834861755371,
    "h": 260.007995605469,
    "CMY_C": 0.35195052623749,
    "CMY_M": 0.32391512393951,
    "CMY_Y": 0.29789656400681,
    "CMYK_C": 0.07698860019445,
    "CMYK_M": 0.03705801442266,
    "CMYK_Y": 0,
    "CMYK_K": 0.29789656400681
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B457010",
    "Farbtonhilfsbezeichnung": "B45 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "173",
    "Bcolor": "188",
    "Y": 41,
    "L": 70.0971755981445,
    "a": -1.76146602630615,
    "b": -9.94364929199219,
    "C": 10.0984611511231,
    "h": 259.954559326172,
    "CMY_C": 0.37852048873901,
    "CMY_M": 0.32089382410049,
    "CMY_Y": 0.263851583004,
    "CMYK_C": 0.15576873719692,
    "CMYK_M": 0.07748741656542,
    "CMYK_Y": 0,
    "CMYK_K": 0.263851583004
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B457015",
    "Farbtonhilfsbezeichnung": "B45 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "175",
    "Bcolor": "197",
    "Y": 41,
    "L": 70.4106216430664,
    "a": -2.74049592018127,
    "b": -14.8834266662598,
    "C": 15.1336278915405,
    "h": 259.566955566406,
    "CMY_C": 0.40520614385605,
    "CMY_M": 0.31388306617737,
    "CMY_Y": 0.22588932514191,
    "CMYK_C": 0.23164235055447,
    "CMYK_M": 0.11367075145245,
    "CMYK_Y": 0,
    "CMYK_K": 0.22588932514191
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B457020",
    "Farbtonhilfsbezeichnung": "B45 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "175",
    "Bcolor": "206",
    "Y": 41,
    "L": 70.2819213867188,
    "a": -3.50638198852539,
    "b": -19.9100723266602,
    "C": 20.2164707183838,
    "h": 260.011993408203,
    "CMY_C": 0.43851935863495,
    "CMY_M": 0.31192320585251,
    "CMY_Y": 0.19197392463684,
    "CMYK_C": 0.30512064695358,
    "CMYK_M": 0.1484472900629,
    "CMYK_Y": 0,
    "CMYK_K": 0.19197392463684
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B458005",
    "Farbtonhilfsbezeichnung": "B45 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "200",
    "Bcolor": "207",
    "Y": 57,
    "L": 80.317138671875,
    "a": -0.726955473423,
    "b": -4.84935331344604,
    "C": 4.90353870391846,
    "h": 261.474395751953,
    "CMY_C": 0.24158012866974,
    "CMY_M": 0.21513968706131,
    "CMY_Y": 0.18987947702408,
    "CMYK_C": 0.06381846964359,
    "CMYK_M": 0.03118080459535,
    "CMYK_Y": 0,
    "CMYK_K": 0.18987947702408
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B458015",
    "Farbtonhilfsbezeichnung": "B45 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "200",
    "Bcolor": "222",
    "Y": 57,
    "L": 79.5876007080078,
    "a": -2.53658318519592,
    "b": -14.4852628707886,
    "C": 14.7056827545166,
    "h": 260.0673828125,
    "CMY_C": 0.30419778823853,
    "CMY_M": 0.21598035097122,
    "CMY_Y": 0.12861549854279,
    "CMYK_C": 0.20149806141853,
    "CMYK_M": 0.10025981813669,
    "CMYK_Y": 0,
    "CMYK_K": 0.12861549854279
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B458505",
    "Farbtonhilfsbezeichnung": "B45 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "213",
    "Bcolor": "220",
    "Y": 66,
    "L": 85.0735549926758,
    "a": -0.71523350477219,
    "b": -4.77072858810425,
    "C": 4.82404518127441,
    "h": 261.4736328125,
    "CMY_C": 0.18948668241501,
    "CMY_M": 0.16318559646606,
    "CMY_Y": 0.1384664773941,
    "CMYK_C": 0.05922022089362,
    "CMYK_M": 0.02869199961424,
    "CMYK_Y": 0,
    "CMYK_K": 0.1384664773941
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B458510",
    "Farbtonhilfsbezeichnung": "B45 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "215",
    "Bcolor": "229",
    "Y": 66,
    "L": 85.2443771362305,
    "a": -1.62021315097809,
    "b": -9.55150032043457,
    "C": 9.68794345855713,
    "h": 260.372619628906,
    "CMY_C": 0.21379393339157,
    "CMY_M": 0.15775835514069,
    "CMY_Y": 0.10178995132446,
    "CMYK_C": 0.12469687312841,
    "CMYK_M": 0.06231104210019,
    "CMYK_Y": 0,
    "CMYK_K": 0.10178995132446
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B459005",
    "Farbtonhilfsbezeichnung": "B45 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "227",
    "Bcolor": "234",
    "Y": 76,
    "L": 90.0132522583008,
    "a": -0.80695563554764,
    "b": -4.94035530090332,
    "C": 5.00582551956177,
    "h": 260.723266601563,
    "CMY_C": 0.13651823997498,
    "CMY_M": 0.10826146602631,
    "CMY_Y": 0.08261388540268,
    "CMYK_C": 0.0587586350739,
    "CMYK_M": 0.02795723639429,
    "CMYK_Y": 0,
    "CMYK_K": 0.08261388540268
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B459105",
    "Farbtonhilfsbezeichnung": "B45 91 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "230",
    "Bcolor": "236",
    "Y": 78,
    "L": 90.9997940063477,
    "a": -0.81737816333771,
    "b": -4.5258903503418,
    "C": 4.59910774230957,
    "h": 259.7626953125,
    "CMY_C": 0.12411069869995,
    "CMY_M": 0.09736764431,
    "CMY_Y": 0.07469838857651,
    "CMYK_C": 0.05340130254626,
    "CMYK_M": 0.02449931576848,
    "CMYK_Y": 0,
    "CMYK_K": 0.07469838857651
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B462603",
    "Farbtonhilfsbezeichnung": "B46 26 03 Elfenbeinschwarz",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 5,
    "L": 25.9327697753906,
    "a": -0.8547728061676,
    "b": -2.43283772468567,
    "C": 2.57863068580627,
    "h": 250.641174316406,
    "CMY_C": 0.77185618877411,
    "CMY_M": 0.75691729784012,
    "CMY_Y": 0.74722838401794,
    "CMYK_C": 0.09743105620146,
    "CMYK_M": 0.03833070397377,
    "CMYK_Y": 0,
    "CMYK_K": 0.74722838401794
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B464003",
    "Farbtonhilfsbezeichnung": "B46 40 03",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "95",
    "Bcolor": "97",
    "Y": 11,
    "L": 40.0718879699707,
    "a": -0.77064073085785,
    "b": -2.41611003875732,
    "C": 2.53603529930115,
    "h": 252.309432983398,
    "CMY_C": 0.64248251914978,
    "CMY_M": 0.62733054161072,
    "CMY_Y": 0.61767637729645,
    "CMYK_C": 0.06488257646561,
    "CMYK_M": 0.02525128982961,
    "CMYK_Y": 0,
    "CMYK_K": 0.61767637729645
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B464030",
    "Farbtonhilfsbezeichnung": "B46 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "103",
    "Bcolor": "141",
    "Y": 11,
    "L": 41.0004920959473,
    "a": -7.96868371963501,
    "b": -28.1708145141602,
    "C": 29.276180267334,
    "h": 254.205383300781,
    "CMY_C": 0.88442504405975,
    "CMY_M": 0.59684997797012,
    "CMY_Y": 0.44539475440979,
    "CMYK_C": 0.79160863161087,
    "CMYK_M": 0.27308651804924,
    "CMYK_Y": 0,
    "CMYK_K": 0.44539475440979
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B465003",
    "Farbtonhilfsbezeichnung": "B46 50 03",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "120",
    "Bcolor": "122",
    "Y": 18,
    "L": 50.1467018127441,
    "a": -0.81353181600571,
    "b": -2.4572389125824,
    "C": 2.58840823173523,
    "h": 251.681549072266,
    "CMY_C": 0.54583036899567,
    "CMY_M": 0.52951335906982,
    "CMY_Y": 0.51991021633148,
    "CMYK_C": 0.05399021878839,
    "CMYK_M": 0.02000280655921,
    "CMYK_Y": 0,
    "CMYK_K": 0.51991021633148
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B465025",
    "Farbtonhilfsbezeichnung": "B46 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "124",
    "Bcolor": "158",
    "Y": 18,
    "L": 49.9333686828613,
    "a": -6.4369421005249,
    "b": -24.2534637451172,
    "C": 25.0931205749512,
    "h": 255.136199951172,
    "CMY_C": 0.70882654190063,
    "CMY_M": 0.5137015581131,
    "CMY_Y": 0.37897861003876,
    "CMYK_C": 0.53113782405853,
    "CMYK_M": 0.21693769097328,
    "CMYK_Y": 0,
    "CMYK_K": 0.37897861003876
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B466003",
    "Farbtonhilfsbezeichnung": "B46 60 03",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "145",
    "Bcolor": "148",
    "Y": 28,
    "L": 60.0400466918945,
    "a": -0.71258139610291,
    "b": -2.43370389938354,
    "C": 2.53587985038757,
    "h": 253.680114746094,
    "CMY_C": 0.44591385126114,
    "CMY_M": 0.43008369207382,
    "CMY_Y": 0.42069727182388,
    "CMYK_C": 0.04352919012308,
    "CMYK_M": 0.016202962026,
    "CMYK_Y": 0,
    "CMYK_K": 0.42069727182388
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B466020",
    "Farbtonhilfsbezeichnung": "B46 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "148",
    "Bcolor": "176",
    "Y": 28,
    "L": 59.6852760314941,
    "a": -5.07092142105103,
    "b": -19.3552837371826,
    "C": 20.0085296630859,
    "h": 255.318954467773,
    "CMY_C": 0.560542345047,
    "CMY_M": 0.41946011781693,
    "CMY_Y": 0.30965340137482,
    "CMYK_C": 0.36342459917068,
    "CMYK_M": 0.15906026959419,
    "CMYK_Y": 0,
    "CMYK_K": 0.30965340137482
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B467003",
    "Farbtonhilfsbezeichnung": "B46 70 03",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "171",
    "Bcolor": "174",
    "Y": 41,
    "L": 69.7725448608398,
    "a": -0.69895648956299,
    "b": -2.8127613067627,
    "C": 2.8983039855957,
    "h": 256.044952392578,
    "CMY_C": 0.34638303518295,
    "CMY_M": 0.3287667632103,
    "CMY_Y": 0.31715476512909,
    "CMYK_C": 0.04280365258455,
    "CMYK_M": 0.01700531505048,
    "CMYK_Y": 0,
    "CMYK_K": 0.31715476512909
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B467015",
    "Farbtonhilfsbezeichnung": "B46 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "175",
    "Bcolor": "196",
    "Y": 41,
    "L": 70.0609741210938,
    "a": -3.86910676956177,
    "b": -14.8867273330688,
    "C": 15.3813076019287,
    "h": 255.43098449707,
    "CMY_C": 0.41881430149078,
    "CMY_M": 0.31514978408813,
    "CMY_Y": 0.22975540161133,
    "CMYK_C": 0.24545307457447,
    "CMYK_M": 0.11086657643318,
    "CMYK_Y": 0,
    "CMYK_K": 0.22975540161133
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B468003",
    "Farbtonhilfsbezeichnung": "B46 80 03",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "197",
    "Bcolor": "201",
    "Y": 57,
    "L": 79.3108062744141,
    "a": -0.81347680091858,
    "b": -3.31831693649292,
    "C": 3.41657304763794,
    "h": 256.225738525391,
    "CMY_C": 0.24753367900848,
    "CMY_M": 0.22631096839905,
    "CMY_Y": 0.21182119846344,
    "CMYK_C": 0.04531012475491,
    "CMYK_M": 0.01838386058807,
    "CMYK_Y": 0,
    "CMYK_K": 0.21182119846344
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B468010",
    "Farbtonhilfsbezeichnung": "B46 80 10",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "200",
    "Bcolor": "214",
    "Y": 57,
    "L": 79.9003982543945,
    "a": -2.52066516876221,
    "b": -9.68653106689453,
    "C": 10.0091276168823,
    "h": 255.413772583008,
    "CMY_C": 0.27979099750519,
    "CMY_M": 0.21413844823837,
    "CMY_Y": 0.15977138280869,
    "CMYK_C": 0.14284162223339,
    "CMYK_M": 0.06470508873463,
    "CMYK_Y": 0,
    "CMYK_K": 0.15977138280869
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B468505",
    "Farbtonhilfsbezeichnung": "B46 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "214",
    "Bcolor": "220",
    "Y": 66,
    "L": 85.2806549072266,
    "a": -1.13086867332458,
    "b": -4.66444730758667,
    "C": 4.79957628250122,
    "h": 256.371917724609,
    "CMY_C": 0.1901929974556,
    "CMY_M": 0.15997570753098,
    "CMY_Y": 0.13701903820038,
    "CMYK_C": 0.06161660701036,
    "CMYK_M": 0.02660159394145,
    "CMYK_Y": 0,
    "CMYK_K": 0.13701903820038
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B469003",
    "Farbtonhilfsbezeichnung": "B46 90 03",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "226",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.7667617797852,
    "a": -0.6361111998558,
    "b": -2.47728157043457,
    "C": 2.55764770507813,
    "h": 255.598846435547,
    "CMY_C": 0.12876182794571,
    "CMY_M": 0.11213755607605,
    "CMY_Y": 0.10351186990738,
    "CMYK_C": 0.02816541306674,
    "CMYK_M": 0.009621639736,
    "CMYK_Y": 0,
    "CMYK_K": 0.10351186990738
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B474020",
    "Farbtonhilfsbezeichnung": "B47 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "99",
    "Bcolor": "124",
    "Y": 11,
    "L": 40.077507019043,
    "a": -7.04117393493652,
    "b": -18.8018226623535,
    "C": 20.077018737793,
    "h": 249.469360351562,
    "CMY_C": 0.77629065513611,
    "CMY_M": 0.61065661907196,
    "CMY_Y": 0.51458638906479,
    "CMYK_C": 0.5391366481781,
    "CMYK_M": 0.19791416823864,
    "CMYK_Y": 0,
    "CMYK_K": 0.51458638906479
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B475036",
    "Farbtonhilfsbezeichnung": "B47 50 36 Coelinblau",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "129",
    "Bcolor": "176",
    "Y": 18,
    "L": 50.344425201416,
    "a": -12.5770330429077,
    "b": -34.2007751464844,
    "C": 36.4400177001953,
    "h": 249.809448242188,
    "CMY_C": 1,
    "CMY_M": 0.49464851617813,
    "CMY_Y": 0.30879086256027,
    "CMYK_C": 1,
    "CMYK_M": 0.26888772845268,
    "CMYK_Y": 0,
    "CMYK_K": 0.30879086256027
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B476020",
    "Farbtonhilfsbezeichnung": "B47 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "150",
    "Bcolor": "176",
    "Y": 28,
    "L": 60.099178314209,
    "a": -6.72839164733887,
    "b": -18.9092903137207,
    "C": 20.0706882476807,
    "h": 250.413192749023,
    "CMY_C": 0.56992208957672,
    "CMY_M": 0.41200786828995,
    "CMY_Y": 0.30848044157028,
    "CMYK_C": 0.37806832790375,
    "CMYK_M": 0.14971004426479,
    "CMYK_Y": 0,
    "CMYK_K": 0.30848044157028
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B476025",
    "Farbtonhilfsbezeichnung": "B47 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "150",
    "Bcolor": "184",
    "Y": 28,
    "L": 59.6552238464355,
    "a": -8.38228893280029,
    "b": -24.011869430542,
    "C": 25.4329051971436,
    "h": 250.756439208984,
    "CMY_C": 0.62587738037109,
    "CMY_M": 0.41157394647598,
    "CMY_Y": 0.27842539548874,
    "CMYK_C": 0.48151913285255,
    "CMYK_M": 0.18452499806881,
    "CMYK_Y": 0,
    "CMYK_K": 0.27842539548874
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B477020",
    "Farbtonhilfsbezeichnung": "B47 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "176",
    "Bcolor": "204",
    "Y": 41,
    "L": 69.9837265014648,
    "a": -6.55538988113403,
    "b": -19.0199642181396,
    "C": 20.117956161499,
    "h": 250.983062744141,
    "CMY_C": 0.46583205461502,
    "CMY_M": 0.30893039703369,
    "CMY_Y": 0.20178860425949,
    "CMYK_C": 0.33079388737679,
    "CMYK_M": 0.13422733545303,
    "CMYK_Y": 0,
    "CMYK_K": 0.20178860425949
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B478010",
    "Farbtonhilfsbezeichnung": "B47 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "201",
    "Bcolor": "214",
    "Y": 57,
    "L": 80.1358947753906,
    "a": -3.1698145866394,
    "b": -9.40969181060791,
    "C": 9.92925071716309,
    "h": 251.383026123047,
    "CMY_C": 0.28158777952194,
    "CMY_M": 0.21020728349686,
    "CMY_Y": 0.15926724672318,
    "CMYK_C": 0.14549276232719,
    "CMYK_M": 0.06059004738927,
    "CMYK_Y": 0,
    "CMYK_K": 0.15926724672318
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B478015",
    "Farbtonhilfsbezeichnung": "B47 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "201",
    "Bcolor": "221",
    "Y": 57,
    "L": 79.5656509399414,
    "a": -5.08540725708008,
    "b": -13.9100637435913,
    "C": 14.8105115890503,
    "h": 249.917999267578,
    "CMY_C": 0.32434898614883,
    "CMY_M": 0.21075814962387,
    "CMY_Y": 0.13328981399536,
    "CMYK_C": 0.2204418182373,
    "CMYK_M": 0.08938205242157,
    "CMYK_Y": 0,
    "CMYK_K": 0.13328981399536
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B478510",
    "Farbtonhilfsbezeichnung": "B47 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "216",
    "Bcolor": "229",
    "Y": 66,
    "L": 85.1151962280273,
    "a": -3.57480621337891,
    "b": -9.91642570495605,
    "C": 10.5410976409912,
    "h": 250.17610168457,
    "CMY_C": 0.23334413766861,
    "CMY_M": 0.15461230278015,
    "CMY_Y": 0.10079157352448,
    "CMYK_C": 0.14741027355194,
    "CMYK_M": 0.05985345318913,
    "CMYK_Y": 0,
    "CMYK_K": 0.10079157352448
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B478515",
    "Farbtonhilfsbezeichnung": "B47 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "216",
    "Bcolor": "236",
    "Y": 66,
    "L": 84.8500900268555,
    "a": -5.08636283874512,
    "b": -13.8845806121826,
    "C": 14.7869081497192,
    "h": 249.880615234375,
    "CMY_C": 0.267209649086,
    "CMY_M": 0.15288615226746,
    "CMY_Y": 0.07492226362228,
    "CMYK_C": 0.2078607827425,
    "CMYK_M": 0.084278203547,
    "CMYK_Y": 0,
    "CMYK_K": 0.07492226362228
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B479005",
    "Farbtonhilfsbezeichnung": "B47 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "229",
    "Bcolor": "235",
    "Y": 76,
    "L": 90.5283966064453,
    "a": -1.84617030620575,
    "b": -4.98333549499512,
    "C": 5.31431818008423,
    "h": 249.671905517578,
    "CMY_C": 0.13953202962875,
    "CMY_M": 0.10007917881012,
    "CMY_Y": 0.07669806480408,
    "CMYK_C": 0.06805353611708,
    "CMYK_M": 0.02532336674631,
    "CMYK_Y": 0,
    "CMYK_K": 0.07669806480408
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B482803",
    "Farbtonhilfsbezeichnung": "B48 28 03 Anthrazit",
    "Farbtonklasse": "02",
    "Rcolor": "62",
    "Gcolor": "68",
    "Bcolor": "73",
    "Y": 5,
    "L": 28.545711517334,
    "a": -1.41868460178375,
    "b": -3.84333205223083,
    "C": 4.09681177139282,
    "h": 249.739440917969,
    "CMY_C": 0.75721687078476,
    "CMY_M": 0.73226094245911,
    "CMY_Y": 0.71563416719437,
    "CMYK_C": 0.14622960984707,
    "CMYK_M": 0.05846966430545,
    "CMYK_Y": 0,
    "CMYK_K": 0.71563416719437
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B484010",
    "Farbtonhilfsbezeichnung": "B48 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "98",
    "Bcolor": "109",
    "Y": 11,
    "L": 40.5110130310059,
    "a": -4.33492183685303,
    "b": -8.82583808898926,
    "C": 9.83295345306396,
    "h": 243.841461181641,
    "CMY_C": 0.68932569026947,
    "CMY_M": 0.61452412605286,
    "CMY_Y": 0.57337880134583,
    "CMYK_C": 0.27177947759628,
    "CMYK_M": 0.09644462913275,
    "CMYK_Y": 0,
    "CMYK_K": 0.57337880134583
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B484020",
    "Farbtonhilfsbezeichnung": "B48 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "100",
    "Bcolor": "122",
    "Y": 11,
    "L": 40.277271270752,
    "a": -8.64792919158936,
    "b": -17.5842609405518,
    "C": 19.5957374572754,
    "h": 243.812057495117,
    "CMY_C": 0.78368926048279,
    "CMY_M": 0.60628771781921,
    "CMY_Y": 0.52047944068909,
    "CMYK_C": 0.54890203475952,
    "CMYK_M": 0.17894598841667,
    "CMYK_Y": 0,
    "CMYK_K": 0.52047944068909
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B484030",
    "Farbtonhilfsbezeichnung": "B48 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "104",
    "Bcolor": "138",
    "Y": 11,
    "L": 40.7961730957031,
    "a": -12.7338762283325,
    "b": -26.5495853424072,
    "C": 29.4454078674316,
    "h": 244.376403808594,
    "CMY_C": 1,
    "CMY_M": 0.59129399061203,
    "CMY_Y": 0.45822900533676,
    "CMYK_C": 1,
    "CMYK_M": 0.24561113119125,
    "CMYK_Y": 0,
    "CMYK_K": 0.45822900533676
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B485005",
    "Farbtonhilfsbezeichnung": "B48 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "120",
    "Bcolor": "125",
    "Y": 18,
    "L": 50.0024147033691,
    "a": -2.22557425498962,
    "b": -4.33274793624878,
    "C": 4.87092256546021,
    "h": 242.812088012695,
    "CMY_C": 0.56416881084442,
    "CMY_M": 0.52753412723541,
    "CMY_Y": 0.50918710231781,
    "CMYK_C": 0.11202172935009,
    "CMYK_M": 0.0373808927834,
    "CMYK_Y": 0,
    "CMYK_K": 0.50918710231781
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B485015",
    "Farbtonhilfsbezeichnung": "B48 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "124",
    "Bcolor": "142",
    "Y": 18,
    "L": 50.3894081115723,
    "a": -6.51134777069092,
    "b": -13.6419734954834,
    "C": 15.1162528991699,
    "h": 244.484741210938,
    "CMY_C": 0.63639360666275,
    "CMY_M": 0.51252460479736,
    "CMY_Y": 0.44449055194855,
    "CMYK_C": 0.34545415639877,
    "CMYK_M": 0.12247145920992,
    "CMYK_Y": 0,
    "CMYK_K": 0.44449055194855
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B485025",
    "Farbtonhilfsbezeichnung": "B48 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "125",
    "Bcolor": "155",
    "Y": 18,
    "L": 49.6230125427246,
    "a": -10.4854431152344,
    "b": -22.5803508758545,
    "C": 24.8961200714111,
    "h": 245.091674804688,
    "CMY_C": 0.74930477142334,
    "CMY_M": 0.50985670089722,
    "CMY_Y": 0.39360469579697,
    "CMYK_C": 0.58658117055893,
    "CMYK_M": 0.19170993566513,
    "CMYK_Y": 0,
    "CMYK_K": 0.39360469579697
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B486010",
    "Farbtonhilfsbezeichnung": "B48 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "147",
    "Bcolor": "159",
    "Y": 28,
    "L": 59.8857154846191,
    "a": -4.19359683990479,
    "b": -9.06588745117188,
    "C": 9.9888219833374,
    "h": 245.176208496094,
    "CMY_C": 0.50001829862595,
    "CMY_M": 0.42243474721909,
    "CMY_Y": 0.37758630514145,
    "CMYK_C": 0.19670517742634,
    "CMYK_M": 0.07205568253994,
    "CMYK_Y": 0,
    "CMYK_K": 0.37758630514145
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B486020",
    "Farbtonhilfsbezeichnung": "B48 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "149",
    "Bcolor": "174",
    "Y": 28,
    "L": 59.4146347045898,
    "a": -8.61010360717773,
    "b": -18.4041690826416,
    "C": 20.3186454772949,
    "h": 244.928176879883,
    "CMY_C": 0.5929788351059,
    "CMY_M": 0.41550135612488,
    "CMY_Y": 0.31933099031448,
    "CMYK_C": 0.40202778577805,
    "CMYK_M": 0.141287997365,
    "CMYK_Y": 0,
    "CMYK_K": 0.31933099031448
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B487005",
    "Farbtonhilfsbezeichnung": "B48 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "172",
    "Bcolor": "177",
    "Y": 41,
    "L": 69.7444229125977,
    "a": -2.06997156143188,
    "b": -4.57768535614014,
    "C": 5.02394104003906,
    "h": 245.668121337891,
    "CMY_C": 0.36373245716095,
    "CMY_M": 0.32553344964981,
    "CMY_Y": 0.30525654554367,
    "CMYK_C": 0.084169074893,
    "CMYK_M": 0.02918617427349,
    "CMYK_Y": 0,
    "CMYK_K": 0.30525654554367
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B487015",
    "Farbtonhilfsbezeichnung": "B48 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "175",
    "Bcolor": "193",
    "Y": 41,
    "L": 69.6769638061523,
    "a": -6.2117486000061,
    "b": -13.6635570526123,
    "C": 15.0092840194702,
    "h": 245.552429199219,
    "CMY_C": 0.43792051076889,
    "CMY_M": 0.31463688611984,
    "CMY_Y": 0.24272751808167,
    "CMYK_C": 0.25775793194771,
    "CMYK_M": 0.09495837986469,
    "CMYK_Y": 0,
    "CMYK_K": 0.24272751808167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B488010",
    "Farbtonhilfsbezeichnung": "B48 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "201",
    "Bcolor": "213",
    "Y": 57,
    "L": 79.9190902709961,
    "a": -4.09571886062622,
    "b": -9.18986034393311,
    "C": 10.0612344741821,
    "h": 245.978515625,
    "CMY_C": 0.29086071252823,
    "CMY_M": 0.21057122945786,
    "CMY_Y": 0.16333389282227,
    "CMYK_C": 0.15242259204388,
    "CMYK_M": 0.05645900592208,
    "CMYK_Y": 0,
    "CMYK_K": 0.16333389282227
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B488505",
    "Farbtonhilfsbezeichnung": "B48 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "214",
    "Bcolor": "220",
    "Y": 66,
    "L": 85.1401977539063,
    "a": -2.1142053604126,
    "b": -4.69786882400513,
    "C": 5.15168285369873,
    "h": 245.770584106445,
    "CMY_C": 0.19986951351166,
    "CMY_M": 0.1592470407486,
    "CMY_Y": 0.13844496011734,
    "CMYK_C": 0.07129498571157,
    "CMYK_M": 0.02414480783045,
    "CMYK_Y": 0,
    "CMYK_K": 0.13844496011734
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B493010",
    "Farbtonhilfsbezeichnung": "B49 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "75",
    "Bcolor": "84",
    "Y": 6,
    "L": 30.4676856994629,
    "a": -5.24567699432373,
    "b": -8.71199035644531,
    "C": 10.169361114502,
    "h": 238.94694519043,
    "CMY_C": 0.78881549835205,
    "CMY_M": 0.70673441886902,
    "CMY_Y": 0.66925883293152,
    "CMYK_C": 0.36148104071617,
    "CMYK_M": 0.11330789327621,
    "CMYK_Y": 0,
    "CMYK_K": 0.66925883293152
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B493714",
    "Farbtonhilfsbezeichnung": "B49 37 14 Azurit",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "92",
    "Bcolor": "105",
    "Y": 10,
    "L": 37.1988983154297,
    "a": -7.49046230316162,
    "b": -11.6423234939575,
    "C": 13.8437976837158,
    "h": 237.243499755859,
    "CMY_C": 0.76221024990082,
    "CMY_M": 0.63945245742798,
    "CMY_Y": 0.58790040016174,
    "CMYK_C": 0.4229798913002,
    "CMYK_M": 0.1250961124897,
    "CMYK_Y": 0,
    "CMYK_K": 0.58790040016174
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B494005",
    "Farbtonhilfsbezeichnung": "B49 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "96",
    "Bcolor": "100",
    "Y": 11,
    "L": 40.0837669372559,
    "a": -2.57883930206299,
    "b": -4.08161544799805,
    "C": 4.82804298400879,
    "h": 237.714553833008,
    "CMY_C": 0.66098845005035,
    "CMY_M": 0.62323772907257,
    "CMY_Y": 0.6072643995285,
    "CMYK_C": 0.13679444789886,
    "CMYK_M": 0.04067196696997,
    "CMYK_Y": 0,
    "CMYK_K": 0.6072643995285
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B494025",
    "Farbtonhilfsbezeichnung": "B49 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "25",
    "Gcolor": "101",
    "Bcolor": "128",
    "Y": 11,
    "L": 39.8042678833008,
    "a": -12.773738861084,
    "b": -21.6223773956299,
    "C": 25.1136531829834,
    "h": 239.426910400391,
    "CMY_C": 0.90114861726761,
    "CMY_M": 0.60250627994537,
    "CMY_Y": 0.49976855516434,
    "CMYK_C": 0.80238872766495,
    "CMYK_M": 0.20538038015366,
    "CMYK_Y": 0,
    "CMYK_K": 0.49976855516434
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B495010",
    "Farbtonhilfsbezeichnung": "B49 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "122",
    "Bcolor": "132",
    "Y": 18,
    "L": 49.9109802246094,
    "a": -5.12707376480103,
    "b": -8.47926044464111,
    "C": 9.90882110595703,
    "h": 238.840301513672,
    "CMY_C": 0.60430943965912,
    "CMY_M": 0.52149295806885,
    "CMY_Y": 0.48317414522171,
    "CMYK_C": 0.23438319563866,
    "CMYK_M": 0.07414259761572,
    "CMYK_Y": 0,
    "CMYK_K": 0.48317414522171
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B495015",
    "Farbtonhilfsbezeichnung": "B49 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "124",
    "Bcolor": "139",
    "Y": 18,
    "L": 49.8712577819824,
    "a": -7.89089155197144,
    "b": -13.1325798034668,
    "C": 15.3209276199341,
    "h": 238.999862670898,
    "CMY_C": 0.6517014503479,
    "CMY_M": 0.51521152257919,
    "CMY_Y": 0.45322811603546,
    "CMYK_C": 0.36299112439156,
    "CMYK_M": 0.11336246132851,
    "CMYK_Y": 0,
    "CMYK_K": 0.45322811603546
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B495020",
    "Farbtonhilfsbezeichnung": "B49 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "127",
    "Bcolor": "148",
    "Y": 18,
    "L": 50.5046501159668,
    "a": -10.2475299835205,
    "b": -17.1327342987061,
    "C": 19.9635276794434,
    "h": 239.115264892578,
    "CMY_C": 0.69388151168823,
    "CMY_M": 0.50326985120773,
    "CMY_Y": 0.42058265209198,
    "CMYK_C": 0.47167876362801,
    "CMYK_M": 0.14270749688148,
    "CMYK_Y": 0,
    "CMYK_K": 0.42058265209198
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B495030",
    "Farbtonhilfsbezeichnung": "B49 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "130",
    "Bcolor": "162",
    "Y": 18,
    "L": 50.5631828308105,
    "a": -14.9591341018677,
    "b": -25.2424945831299,
    "C": 29.3421058654785,
    "h": 239.348281860352,
    "CMY_C": 0.8466449379921,
    "CMY_M": 0.49161404371262,
    "CMY_Y": 0.36651331186295,
    "CMYK_C": 0.75791907310486,
    "CMYK_M": 0.19747965037823,
    "CMYK_Y": 0,
    "CMYK_K": 0.36651331186295
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B496005",
    "Farbtonhilfsbezeichnung": "B49 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "146",
    "Bcolor": "151",
    "Y": 28,
    "L": 59.9473114013672,
    "a": -2.4911642074585,
    "b": -4.24427652359009,
    "C": 4.92136001586914,
    "h": 239.589340209961,
    "CMY_C": 0.4667694568634,
    "CMY_M": 0.4267383813858,
    "CMY_Y": 0.40955072641373,
    "CMYK_C": 0.09690710902214,
    "CMYK_M": 0.02910945191979,
    "CMYK_Y": 0,
    "CMYK_K": 0.40955072641373
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B496015",
    "Farbtonhilfsbezeichnung": "B49 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "149",
    "Bcolor": "164",
    "Y": 28,
    "L": 59.8557891845703,
    "a": -7.3753457069397,
    "b": -12.4885807037354,
    "C": 14.5038051605225,
    "h": 239.435287475586,
    "CMY_C": 0.54372334480286,
    "CMY_M": 0.41525876522064,
    "CMY_Y": 0.35492336750031,
    "CMYK_C": 0.29267835617065,
    "CMYK_M": 0.09353213757277,
    "CMYK_Y": 0,
    "CMYK_K": 0.35492336750031
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B496025",
    "Farbtonhilfsbezeichnung": "B49 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "153",
    "Bcolor": "180",
    "Y": 28,
    "L": 59.9924774169922,
    "a": -12.498496055603,
    "b": -21.4131946563721,
    "C": 24.7938957214356,
    "h": 239.728652954102,
    "CMY_C": 0.65149039030075,
    "CMY_M": 0.40108853578568,
    "CMY_Y": 0.29299426078796,
    "CMYK_C": 0.50706255435944,
    "CMYK_M": 0.15289023518562,
    "CMYK_Y": 0,
    "CMYK_K": 0.29299426078796
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B497005",
    "Farbtonhilfsbezeichnung": "B49 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "172",
    "Bcolor": "176",
    "Y": 41,
    "L": 69.5936813354492,
    "a": -2.36005878448486,
    "b": -4.20051860809326,
    "C": 4.818115234375,
    "h": 240.67057800293,
    "CMY_C": 0.36621034145355,
    "CMY_M": 0.32659792900085,
    "CMY_Y": 0.30952453613281,
    "CMYK_C": 0.08209677040577,
    "CMYK_M": 0.02472700923681,
    "CMYK_Y": 0,
    "CMYK_K": 0.30952453613281
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B497010",
    "Farbtonhilfsbezeichnung": "B49 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "175",
    "Bcolor": "186",
    "Y": 41,
    "L": 70.2040176391602,
    "a": -4.92586803436279,
    "b": -8.6812915802002,
    "C": 9.98143291473389,
    "h": 240.428909301758,
    "CMY_C": 0.3985498547554,
    "CMY_M": 0.31329262256622,
    "CMY_Y": 0.27193373441696,
    "CMYK_C": 0.17390741407871,
    "CMYK_M": 0.05680648982525,
    "CMYK_Y": 0,
    "CMYK_K": 0.27193373441696
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B497015",
    "Farbtonhilfsbezeichnung": "B49 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "176",
    "Bcolor": "192",
    "Y": 41,
    "L": 69.9351196289063,
    "a": -7.39987516403198,
    "b": -12.7028255462647,
    "C": 14.7010183334351,
    "h": 239.777587890625,
    "CMY_C": 0.44134509563446,
    "CMY_M": 0.30971735715866,
    "CMY_Y": 0.24683159589767,
    "CMYK_C": 0.2582603096962,
    "CMYK_M": 0.08349495381117,
    "CMYK_Y": 0,
    "CMYK_K": 0.24683159589767
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B497020",
    "Farbtonhilfsbezeichnung": "B49 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "178",
    "Bcolor": "201",
    "Y": 41,
    "L": 70.0581665039063,
    "a": -10.2732162475586,
    "b": -17.7146453857422,
    "C": 20.4779796600342,
    "h": 239.889358520508,
    "CMY_C": 0.49459087848663,
    "CMY_M": 0.30094069242477,
    "CMY_Y": 0.21054303646088,
    "CMYK_C": 0.35980156064034,
    "CMYK_M": 0.11450612545013,
    "CMYK_Y": 0,
    "CMYK_K": 0.21054303646088
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B498005",
    "Farbtonhilfsbezeichnung": "B49 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "200",
    "Bcolor": "205",
    "Y": 57,
    "L": 79.967399597168,
    "a": -2.44717597961426,
    "b": -4.38084506988525,
    "C": 5.01801490783691,
    "h": 240.811920166016,
    "CMY_C": 0.25746697187424,
    "CMY_M": 0.21516805887222,
    "CMY_Y": 0.19727027416229,
    "CMYK_C": 0.07498999685049,
    "CMYK_M": 0.02229615300894,
    "CMYK_Y": 0,
    "CMYK_K": 0.19727027416229
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B498010",
    "Farbtonhilfsbezeichnung": "B49 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "201",
    "Bcolor": "212",
    "Y": 57,
    "L": 79.6218338012695,
    "a": -5.00041437149048,
    "b": -8.82473564147949,
    "C": 10.1429824829102,
    "h": 240.462539672852,
    "CMY_C": 0.30024343729019,
    "CMY_M": 0.21191823482513,
    "CMY_Y": 0.16932058334351,
    "CMYK_C": 0.15760935842991,
    "CMYK_M": 0.05128049477935,
    "CMYK_Y": 0,
    "CMYK_K": 0.16932058334351
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B498015",
    "Farbtonhilfsbezeichnung": "B49 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "203",
    "Bcolor": "221",
    "Y": 57,
    "L": 79.8173599243164,
    "a": -7.55154132843018,
    "b": -13.2969055175781,
    "C": 15.2916145324707,
    "h": 240.407012939453,
    "CMY_C": 0.34113252162933,
    "CMY_M": 0.20286047458649,
    "CMY_Y": 0.1352167725563,
    "CMYK_C": 0.23811255395412,
    "CMYK_M": 0.07822041213512,
    "CMYK_Y": 0,
    "CMYK_K": 0.1352167725563
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B498505",
    "Farbtonhilfsbezeichnung": "B49 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "214",
    "Bcolor": "218",
    "Y": 66,
    "L": 85.1120071411133,
    "a": -2.25062489509583,
    "b": -4.06051588058472,
    "C": 4.64253187179565,
    "h": 241.001678466797,
    "CMY_C": 0.19888466596603,
    "CMY_M": 0.15943259000778,
    "CMY_Y": 0.14342522621155,
    "CMYK_C": 0.06474559009075,
    "CMYK_M": 0.01868764311075,
    "CMYK_Y": 0,
    "CMYK_K": 0.14342522621155
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B498510",
    "Farbtonhilfsbezeichnung": "B49 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "216",
    "Bcolor": "227",
    "Y": 66,
    "L": 85.1845474243164,
    "a": -4.99202108383179,
    "b": -8.86160850524902,
    "C": 10.1709575653076,
    "h": 240.606079101562,
    "CMY_C": 0.2403262257576,
    "CMY_M": 0.15098661184311,
    "CMY_Y": 0.10790061950684,
    "CMYK_C": 0.14844265580177,
    "CMYK_M": 0.04829730093479,
    "CMYK_Y": 0,
    "CMYK_K": 0.10790061950684
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B499005",
    "Farbtonhilfsbezeichnung": "B49 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "228",
    "Bcolor": "233",
    "Y": 76,
    "L": 89.9070892333984,
    "a": -2.52228164672852,
    "b": -4.43734502792358,
    "C": 5.10410976409912,
    "h": 240.385177612305,
    "CMY_C": 0.14990425109863,
    "CMY_M": 0.1055960059166,
    "CMY_Y": 0.08773177862167,
    "CMYK_C": 0.06815152615309,
    "CMYK_M": 0.01958221010864,
    "CMYK_Y": 0,
    "CMYK_K": 0.08773177862167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B499010",
    "Farbtonhilfsbezeichnung": "B49 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "229",
    "Bcolor": "239",
    "Y": 76,
    "L": 89.8378753662109,
    "a": -4.77010011672974,
    "b": -8.02512836456299,
    "C": 9.33576679229736,
    "h": 239.272933959961,
    "CMY_C": 0.18402194976807,
    "CMY_M": 0.10012990236282,
    "CMY_Y": 0.0622838139534,
    "CMYK_C": 0.12982407212257,
    "CMYK_M": 0.04035985469818,
    "CMYK_Y": 0,
    "CMYK_K": 0.0622838139534
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B506030",
    "Farbtonhilfsbezeichnung": "B50 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "155",
    "Bcolor": "186",
    "Y": 28,
    "L": 59.882438659668,
    "a": -16.9159927368164,
    "b": -24.6560955047607,
    "C": 29.9010677337646,
    "h": 235.546859741211,
    "CMY_C": 0.74795413017273,
    "CMY_M": 0.39303374290466,
    "CMY_Y": 0.27229821681976,
    "CMYK_C": 0.65364128351212,
    "CMYK_M": 0.16591346263885,
    "CMYK_Y": 0,
    "CMYK_K": 0.27229821681976
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B507025",
    "Farbtonhilfsbezeichnung": "B50 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "180",
    "Bcolor": "205",
    "Y": 41,
    "L": 69.7072601318359,
    "a": -14.5165348052979,
    "b": -20.310359954834,
    "C": 24.9647846221924,
    "h": 234.445266723633,
    "CMY_C": 0.56178307533264,
    "CMY_M": 0.29545223712921,
    "CMY_Y": 0.19646847248077,
    "CMYK_C": 0.4546363055706,
    "CMYK_M": 0.12318591028452,
    "CMYK_Y": 0,
    "CMYK_K": 0.19646847248077
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B508020",
    "Farbtonhilfsbezeichnung": "B50 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "207",
    "Bcolor": "227",
    "Y": 57,
    "L": 80.2360687255859,
    "a": -11.2561330795288,
    "b": -16.1281719207764,
    "C": 19.6677017211914,
    "h": 235.088134765625,
    "CMY_C": 0.38683295249939,
    "CMY_M": 0.18954980373383,
    "CMY_Y": 0.11053669452667,
    "CMYK_C": 0.31063255667686,
    "CMYK_M": 0.08883234113455,
    "CMYK_Y": 0,
    "CMYK_K": 0.11053669452667
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B508515",
    "Farbtonhilfsbezeichnung": "B50 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "219",
    "Bcolor": "234",
    "Y": 66,
    "L": 85.2586898803711,
    "a": -8.69238758087158,
    "b": -12.3775520324707,
    "C": 15.1248598098755,
    "h": 234.920761108398,
    "CMY_C": 0.28857105970383,
    "CMY_M": 0.14093071222305,
    "CMY_Y": 0.08180248737335,
    "CMYK_C": 0.22518964111805,
    "CMYK_M": 0.06439597904682,
    "CMYK_Y": 0,
    "CMYK_K": 0.08180248737335
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B509010",
    "Farbtonhilfsbezeichnung": "B50 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "230",
    "Bcolor": "239",
    "Y": 76,
    "L": 89.7305297851563,
    "a": -5.76452684402466,
    "b": -8.11618614196777,
    "C": 9.95501136779785,
    "h": 234.615707397461,
    "CMY_C": 0.19421917200089,
    "CMY_M": 0.09905010461807,
    "CMY_Y": 0.06293267011642,
    "CMYK_C": 0.14010359346867,
    "CMYK_M": 0.03854305297136,
    "CMYK_Y": 0,
    "CMYK_K": 0.06293267011642
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B509305",
    "Farbtonhilfsbezeichnung": "B50 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "237",
    "Bcolor": "240",
    "Y": 83,
    "L": 92.8060913085938,
    "a": -2.8556694984436,
    "b": -4.06430053710938,
    "C": 4.96723127365112,
    "h": 234.907257080078,
    "CMY_C": 0.11913311481476,
    "CMY_M": 0.07253271341324,
    "CMY_Y": 0.05823463201523,
    "CMYK_C": 0.06466417759657,
    "CMYK_M": 0.01518221199512,
    "CMYK_Y": 0,
    "CMYK_K": 0.05823463201523
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B514015",
    "Farbtonhilfsbezeichnung": "B51 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "101",
    "Bcolor": "112",
    "Y": 11,
    "L": 40.3744125366211,
    "a": -9.98324966430664,
    "b": -11.4005689620972,
    "C": 15.1538190841675,
    "h": 228.792007446289,
    "CMY_C": 0.7550955414772,
    "CMY_M": 0.6048926115036,
    "CMY_Y": 0.55890965461731,
    "CMYK_C": 0.4447748363018,
    "CMYK_M": 0.10424838960171,
    "CMYK_Y": 0,
    "CMYK_K": 0.55890965461731
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B515030",
    "Farbtonhilfsbezeichnung": "B51 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "11",
    "Gcolor": "132",
    "Bcolor": "157",
    "Y": 18,
    "L": 50.5676155090332,
    "a": -19.991626739502,
    "b": -22.6474914550781,
    "C": 30.2088394165039,
    "h": 228.564178466797,
    "CMY_C": 0.95529574155807,
    "CMY_M": 0.48400104045868,
    "CMY_Y": 0.38412094116211,
    "CMYK_C": 0.92741388082504,
    "CMYK_M": 0.16217486560345,
    "CMYK_Y": 0,
    "CMYK_K": 0.38412094116211
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B516015",
    "Farbtonhilfsbezeichnung": "B51 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "151",
    "Bcolor": "163",
    "Y": 28,
    "L": 60.1310501098633,
    "a": -9.53455066680908,
    "b": -11.4010229110718,
    "C": 14.8624019622803,
    "h": 230.094619750977,
    "CMY_C": 0.55540645122528,
    "CMY_M": 0.40848582983017,
    "CMY_Y": 0.35968995094299,
    "CMYK_C": 0.30565896630287,
    "CMYK_M": 0.07620663940907,
    "CMYK_Y": 0,
    "CMYK_K": 0.35968995094299
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B516025",
    "Farbtonhilfsbezeichnung": "B51 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "154",
    "Bcolor": "176",
    "Y": 28,
    "L": 59.8361968994141,
    "a": -16.1268272399902,
    "b": -19.0843906402588,
    "C": 24.9857654571533,
    "h": 229.801284790039,
    "CMY_C": 0.68080449104309,
    "CMY_M": 0.39677339792252,
    "CMY_Y": 0.31091207265854,
    "CMYK_C": 0.53678554296494,
    "CMYK_M": 0.12460140883923,
    "CMYK_Y": 0,
    "CMYK_K": 0.31091207265854
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B517020",
    "Farbtonhilfsbezeichnung": "B51 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "179",
    "Bcolor": "197",
    "Y": 41,
    "L": 70.0458297729492,
    "a": -12.7246980667114,
    "b": -15.4447641372681,
    "C": 20.0114631652832,
    "h": 230.515426635742,
    "CMY_C": 0.50658142566681,
    "CMY_M": 0.29690194129944,
    "CMY_Y": 0.22690564393997,
    "CMYK_C": 0.36176151037216,
    "CMYK_M": 0.09054043143988,
    "CMYK_Y": 0,
    "CMYK_K": 0.22690564393997
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B517025",
    "Farbtonhilfsbezeichnung": "B51 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "181",
    "Bcolor": "203",
    "Y": 41,
    "L": 69.9262008666992,
    "a": -15.8989152908325,
    "b": -18.9871883392334,
    "C": 24.764669418335,
    "h": 230.058883666992,
    "CMY_C": 0.56627643108368,
    "CMY_M": 0.29088538885117,
    "CMY_Y": 0.20354944467545,
    "CMYK_C": 0.45542937517166,
    "CMYK_M": 0.10965645313263,
    "CMYK_Y": 0,
    "CMYK_K": 0.20354944467545
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B518005",
    "Farbtonhilfsbezeichnung": "B51 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "201",
    "Bcolor": "205",
    "Y": 57,
    "L": 80.0869903564453,
    "a": -3.38948035240173,
    "b": -4.20220470428467,
    "C": 5.39880561828613,
    "h": 231.110504150391,
    "CMY_C": 0.26317548751831,
    "CMY_M": 0.2118027806282,
    "CMY_Y": 0.19737941026688,
    "CMYK_C": 0.08197656273842,
    "CMYK_M": 0.01797034591436,
    "CMYK_Y": 0,
    "CMYK_K": 0.19737941026688
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B518015",
    "Farbtonhilfsbezeichnung": "B51 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "205",
    "Bcolor": "218",
    "Y": 57,
    "L": 80.2330169677734,
    "a": -9.61466312408447,
    "b": -11.3522939682007,
    "C": 14.8767042160034,
    "h": 229.737548828125,
    "CMY_C": 0.34633618593216,
    "CMY_M": 0.19452875852585,
    "CMY_Y": 0.14492172002792,
    "CMYK_C": 0.23555091023445,
    "CMYK_M": 0.0580146163702,
    "CMYK_Y": 0,
    "CMYK_K": 0.14492172002792
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B518510",
    "Farbtonhilfsbezeichnung": "B51 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "218",
    "Bcolor": "225",
    "Y": 66,
    "L": 85.3407974243164,
    "a": -6.22100257873535,
    "b": -7.33670139312744,
    "C": 9.61915111541748,
    "h": 229.70442199707,
    "CMY_C": 0.24281281232834,
    "CMY_M": 0.146988093853,
    "CMY_Y": 0.11746829748154,
    "CMYK_C": 0.14202834665775,
    "CMYK_M": 0.0334489941597,
    "CMYK_Y": 0,
    "CMYK_K": 0.11746829748154
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B518515",
    "Farbtonhilfsbezeichnung": "B51 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "218",
    "Bcolor": "231",
    "Y": 66,
    "L": 84.7974853515625,
    "a": -9.44651508331299,
    "b": -11.3465051651001,
    "C": 14.7641401290894,
    "h": 230.220977783203,
    "CMY_C": 0.29561066627502,
    "CMY_M": 0.14472180604935,
    "CMY_Y": 0.09455442428589,
    "CMYK_C": 0.22205226123333,
    "CMYK_M": 0.0554062910378,
    "CMYK_Y": 0,
    "CMYK_K": 0.09455442428589
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B519005",
    "Farbtonhilfsbezeichnung": "B51 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "228",
    "Bcolor": "231",
    "Y": 76,
    "L": 89.6223373413086,
    "a": -3.12308239936829,
    "b": -3.75976991653442,
    "C": 4.88769006729126,
    "h": 230.285018920898,
    "CMY_C": 0.15543526411057,
    "CMY_M": 0.1075804233551,
    "CMY_Y": 0.09597373008728,
    "CMYK_C": 0.06577412039042,
    "CMYK_M": 0.01283888891339,
    "CMYK_Y": 0,
    "CMYK_K": 0.09597373008728
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B524010",
    "Farbtonhilfsbezeichnung": "B52 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "99",
    "Bcolor": "105",
    "Y": 11,
    "L": 40.2645645141602,
    "a": -7.28036546707153,
    "b": -6.95374631881714,
    "C": 10.0676860809326,
    "h": 223.685501098633,
    "CMY_C": 0.70785653591156,
    "CMY_M": 0.61195975542068,
    "CMY_Y": 0.58787822723389,
    "CMYK_C": 0.2911234498024,
    "CMYK_M": 0.05843304097652,
    "CMYK_Y": 0,
    "CMYK_K": 0.58787822723389
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B524020",
    "Farbtonhilfsbezeichnung": "B52 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "101",
    "Bcolor": "115",
    "Y": 11,
    "L": 39.721736907959,
    "a": -14.4104881286621,
    "b": -14.2031860351563,
    "C": 20.2334537506104,
    "h": 224.584899902344,
    "CMY_C": 0.83673369884491,
    "CMY_M": 0.60295164585114,
    "CMY_Y": 0.54787492752075,
    "CMYK_C": 0.63889127969742,
    "CMYK_M": 0.12181743979454,
    "CMYK_Y": 0,
    "CMYK_K": 0.54787492752075
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B524030",
    "Farbtonhilfsbezeichnung": "B52 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "106",
    "Bcolor": "128",
    "Y": 11,
    "L": 40.4856414794922,
    "a": -21.2096538543701,
    "b": -20.7631645202637,
    "C": 29.680944442749,
    "h": 224.390533447266,
    "CMY_C": 1,
    "CMY_M": 0.58302938938141,
    "CMY_Y": 0.49904179573059,
    "CMYK_C": 1,
    "CMYK_M": 0.16765388846397,
    "CMYK_Y": 0,
    "CMYK_K": 0.49904179573059
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B525005",
    "Farbtonhilfsbezeichnung": "B52 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "121",
    "Bcolor": "123",
    "Y": 18,
    "L": 49.7609748840332,
    "a": -3.83475470542908,
    "b": -3.45817708969116,
    "C": 5.16375160217285,
    "h": 222.044097900391,
    "CMY_C": 0.57558435201645,
    "CMY_M": 0.52691328525543,
    "CMY_Y": 0.51749515533447,
    "CMYK_C": 0.12039090692997,
    "CMYK_M": 0.01951924338937,
    "CMYK_Y": 0,
    "CMYK_K": 0.51749515533447
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B525015",
    "Farbtonhilfsbezeichnung": "B52 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "125",
    "Bcolor": "135",
    "Y": 18,
    "L": 49.855094909668,
    "a": -10.5963773727417,
    "b": -10.5655498504639,
    "C": 14.9637584686279,
    "h": 224.916534423828,
    "CMY_C": 0.66385173797607,
    "CMY_M": 0.51109874248505,
    "CMY_Y": 0.4705502986908,
    "CMYK_C": 0.36509877443314,
    "CMYK_M": 0.07658601552248,
    "CMYK_Y": 0,
    "CMYK_K": 0.4705502986908
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B525025",
    "Farbtonhilfsbezeichnung": "B52 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "129",
    "Bcolor": "147",
    "Y": 18,
    "L": 50.025146484375,
    "a": -17.7536945343018,
    "b": -17.7990207672119,
    "C": 25.1395874023438,
    "h": 225.073043823242,
    "CMY_C": 0.80689257383347,
    "CMY_M": 0.49471783638,
    "CMY_Y": 0.42170733213425,
    "CMYK_C": 0.66607320308685,
    "CMYK_M": 0.12625183165073,
    "CMYK_Y": 0,
    "CMYK_K": 0.42170733213425
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B526010",
    "Farbtonhilfsbezeichnung": "B52 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "149",
    "Bcolor": "155",
    "Y": 28,
    "L": 59.9970550537109,
    "a": -7.04635143280029,
    "b": -7.08941984176636,
    "C": 9.99554634094238,
    "h": 225.174560546875,
    "CMY_C": 0.51441943645477,
    "CMY_M": 0.41604459285736,
    "CMY_Y": 0.3901983499527,
    "CMYK_C": 0.20370736718178,
    "CMYK_M": 0.04238467290998,
    "CMYK_Y": 0,
    "CMYK_K": 0.3901983499527
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B526020",
    "Farbtonhilfsbezeichnung": "B52 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "153",
    "Bcolor": "167",
    "Y": 28,
    "L": 59.9450035095215,
    "a": -14.1506567001343,
    "b": -14.146240234375,
    "C": 20.0089282989502,
    "h": 224.991058349609,
    "CMY_C": 0.61962056159973,
    "CMY_M": 0.40080064535141,
    "CMY_Y": 0.34334629774094,
    "CMYK_C": 0.42073053121567,
    "CMYK_M": 0.0874956548214,
    "CMYK_Y": 0,
    "CMYK_K": 0.34334629774094
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B527005",
    "Farbtonhilfsbezeichnung": "B52 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "173",
    "Bcolor": "176",
    "Y": 41,
    "L": 70.0250549316406,
    "a": -3.50117683410645,
    "b": -3.55164241790771,
    "C": 4.98722410202026,
    "h": 225.409957885742,
    "CMY_C": 0.36836469173431,
    "CMY_M": 0.31973510980606,
    "CMY_Y": 0.30966222286224,
    "CMYK_C": 0.08503441512585,
    "CMYK_M": 0.01459124404937,
    "CMYK_Y": 0,
    "CMYK_K": 0.30966222286224
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B527015",
    "Farbtonhilfsbezeichnung": "B52 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "179",
    "Bcolor": "189",
    "Y": 41,
    "L": 70.41943359375,
    "a": -10.3787803649902,
    "b": -10.4553279876709,
    "C": 14.7320384979248,
    "h": 225.210510253906,
    "CMY_C": 0.45275408029556,
    "CMY_M": 0.29913586378098,
    "CMY_Y": 0.25776809453964,
    "CMYK_C": 0.26270225644112,
    "CMYK_M": 0.05573429167271,
    "CMYK_Y": 0,
    "CMYK_K": 0.25776809453964
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B528010",
    "Farbtonhilfsbezeichnung": "B52 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "202",
    "Bcolor": "209",
    "Y": 57,
    "L": 79.7306518554688,
    "a": -7.25262594223022,
    "b": -7.35479307174683,
    "C": 10.3292579650879,
    "h": 225.400726318359,
    "CMY_C": 0.31227958202362,
    "CMY_M": 0.20626544952393,
    "CMY_Y": 0.17899525165558,
    "CMYK_C": 0.16234295070171,
    "CMYK_M": 0.03321563825011,
    "CMYK_Y": 0,
    "CMYK_K": 0.17899525165558
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B528505",
    "Farbtonhilfsbezeichnung": "B52 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "215",
    "Bcolor": "218",
    "Y": 66,
    "L": 85.1768341064453,
    "a": -3.50576829910278,
    "b": -3.72462797164917,
    "C": 5.11500406265259,
    "h": 226.733779907227,
    "CMY_C": 0.20720088481903,
    "CMY_M": 0.15595483779907,
    "CMY_Y": 0.14532750844955,
    "CMYK_C": 0.07239425182343,
    "CMYK_M": 0.01243438757956,
    "CMYK_Y": 0,
    "CMYK_K": 0.14532750844955
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B533010",
    "Farbtonhilfsbezeichnung": "B53 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "74",
    "Bcolor": "79",
    "Y": 6,
    "L": 29.7774257659912,
    "a": -7.97663068771362,
    "b": -6.53906059265137,
    "C": 10.314356803894,
    "h": 219.344131469727,
    "CMY_C": 0.80816698074341,
    "CMY_M": 0.70897078514099,
    "CMY_Y": 0.68893599510193,
    "CMYK_C": 0.38330048322678,
    "CMYK_M": 0.06440728902817,
    "CMYK_Y": 0,
    "CMYK_K": 0.68893599510193
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B533020",
    "Farbtonhilfsbezeichnung": "B53 30 20",
    "Farbtonklasse": "03",
    "Rcolor": "16",
    "Gcolor": "82",
    "Bcolor": "93",
    "Y": 6,
    "L": 31.7454013824463,
    "a": -15.659104347229,
    "b": -12.3370351791382,
    "C": 19.9351444244385,
    "h": 218.232818603516,
    "CMY_C": 0.93845534324646,
    "CMY_M": 0.67726862430573,
    "CMY_Y": 0.63615882396698,
    "CMYK_C": 0.83084744215012,
    "CMYK_M": 0.11298831552267,
    "CMYK_Y": 0,
    "CMYK_K": 0.63615882396698
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B534005",
    "Farbtonhilfsbezeichnung": "B53 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "96",
    "Bcolor": "98",
    "Y": 11,
    "L": 40.0415649414063,
    "a": -3.75239086151123,
    "b": -2.78456664085388,
    "C": 4.67271327972412,
    "h": 216.57829284668,
    "CMY_C": 0.66545575857162,
    "CMY_M": 0.6217178106308,
    "CMY_Y": 0.61596769094467,
    "CMYK_C": 0.12886433303356,
    "CMYK_M": 0.01497300993651,
    "CMYK_Y": 0,
    "CMYK_K": 0.61596769094467
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B534015",
    "Farbtonhilfsbezeichnung": "B53 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "98",
    "Bcolor": "106",
    "Y": 11,
    "L": 38.9104156494141,
    "a": -11.7986402511597,
    "b": -9.60606670379639,
    "C": 15.2146120071411,
    "h": 219.151351928711,
    "CMY_C": 0.7771971821785,
    "CMY_M": 0.6163489818573,
    "CMY_Y": 0.58457970619202,
    "CMYK_C": 0.46366891264915,
    "CMYK_M": 0.07647502422333,
    "CMYK_Y": 0,
    "CMYK_K": 0.58457970619202
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B534025",
    "Farbtonhilfsbezeichnung": "B53 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "3",
    "Gcolor": "104",
    "Bcolor": "118",
    "Y": 11,
    "L": 39.8206024169922,
    "a": -19.2463512420654,
    "b": -15.9249124526978,
    "C": 24.980489730835,
    "h": 219.605209350586,
    "CMY_C": 0.98794150352478,
    "CMY_M": 0.59392195940018,
    "CMY_Y": 0.53634512424469,
    "CMYK_C": 0.97399252653122,
    "CMYK_M": 0.12418036907911,
    "CMYK_Y": 0,
    "CMYK_K": 0.53634512424469
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B535010",
    "Farbtonhilfsbezeichnung": "B53 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "124",
    "Bcolor": "128",
    "Y": 18,
    "L": 50.1785545349121,
    "a": -7.50959396362305,
    "b": -6.02303886413574,
    "C": 9.62657737731934,
    "h": 218.731216430664,
    "CMY_C": 0.61103016138077,
    "CMY_M": 0.51490581035614,
    "CMY_Y": 0.49690115451813,
    "CMYK_C": 0.22685205936432,
    "CMYK_M": 0.03578751161695,
    "CMYK_Y": 0,
    "CMYK_K": 0.49690115451813
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B535020",
    "Farbtonhilfsbezeichnung": "B53 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "127",
    "Bcolor": "138",
    "Y": 18,
    "L": 49.8418197631836,
    "a": -15.3374767303467,
    "b": -12.5719795227051,
    "C": 19.8316135406494,
    "h": 219.34114074707,
    "CMY_C": 0.72736632823944,
    "CMY_M": 0.50222861766815,
    "CMY_Y": 0.45789927244186,
    "CMYK_C": 0.49707931280136,
    "CMYK_M": 0.08177326619625,
    "CMYK_Y": 0,
    "CMYK_K": 0.45789927244186
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B535030",
    "Farbtonhilfsbezeichnung": "B53 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "131",
    "Bcolor": "149",
    "Y": 18,
    "L": 49.7929916381836,
    "a": -23.629581451416,
    "b": -19.1856956481934,
    "C": 30.4376087188721,
    "h": 219.074371337891,
    "CMY_C": 1,
    "CMY_M": 0.48714435100555,
    "CMY_Y": 0.41536128520966,
    "CMYK_C": 1,
    "CMYK_M": 0.12278192490339,
    "CMYK_Y": 0,
    "CMYK_K": 0.41536128520966
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B536005",
    "Farbtonhilfsbezeichnung": "B53 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "148",
    "Bcolor": "149",
    "Y": 28,
    "L": 60.2666702270508,
    "a": -3.84932088851929,
    "b": -3.10437321662903,
    "C": 4.94513940811157,
    "h": 218.885238647461,
    "CMY_C": 0.46993917226791,
    "CMY_M": 0.42092072963715,
    "CMY_Y": 0.41419476270676,
    "CMYK_C": 0.09515860676765,
    "CMYK_M": 0.01148157566786,
    "CMYK_Y": 0,
    "CMYK_K": 0.41419476270676
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B536015",
    "Farbtonhilfsbezeichnung": "B53 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "152",
    "Bcolor": "160",
    "Y": 28,
    "L": 60.1560974121094,
    "a": -11.6484041213989,
    "b": -9.70823287963867,
    "C": 15.1636114120483,
    "h": 219.809143066406,
    "CMY_C": 0.56645798683167,
    "CMY_M": 0.40463590621948,
    "CMY_Y": 0.37119299173355,
    "CMYK_C": 0.31053248047829,
    "CMYK_M": 0.05318470299244,
    "CMYK_Y": 0,
    "CMYK_K": 0.37119299173355
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B536025",
    "Farbtonhilfsbezeichnung": "B53 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "156",
    "Bcolor": "171",
    "Y": 28,
    "L": 60.2195472717285,
    "a": -19.1473693847656,
    "b": -15.9975128173828,
    "C": 24.9507942199707,
    "h": 219.878555297852,
    "CMY_C": 0.69131970405579,
    "CMY_M": 0.38834547996521,
    "CMY_Y": 0.32827126979828,
    "CMYK_C": 0.54046881198883,
    "CMYK_M": 0.08943224698305,
    "CMYK_Y": 0,
    "CMYK_K": 0.32827126979828
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B537010",
    "Farbtonhilfsbezeichnung": "B53 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "176",
    "Bcolor": "181",
    "Y": 41,
    "L": 69.9834365844727,
    "a": -7.63281345367432,
    "b": -6.37745904922485,
    "C": 9.94644832611084,
    "h": 219.879837036133,
    "CMY_C": 0.41415351629257,
    "CMY_M": 0.31060147285461,
    "CMY_Y": 0.29076379537582,
    "CMYK_C": 0.17397549748421,
    "CMYK_M": 0.0279704798013,
    "CMYK_Y": 0,
    "CMYK_K": 0.29076379537582
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B537020",
    "Farbtonhilfsbezeichnung": "B53 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "181",
    "Bcolor": "193",
    "Y": 41,
    "L": 70.2710113525391,
    "a": -15.384238243103,
    "b": -12.7620296478272,
    "C": 19.9886016845703,
    "h": 219.677474975586,
    "CMY_C": 0.51621347665787,
    "CMY_M": 0.29012513160706,
    "CMY_Y": 0.24364495277405,
    "CMYK_C": 0.36037114262581,
    "CMYK_M": 0.06145285815001,
    "CMYK_Y": 0,
    "CMYK_K": 0.24364495277405
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B538005",
    "Farbtonhilfsbezeichnung": "B53 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "202",
    "Bcolor": "204",
    "Y": 57,
    "L": 80.3610916137695,
    "a": -3.82106947898865,
    "b": -3.34133577346802,
    "C": 5.07593297958374,
    "h": 221.168090820312,
    "CMY_C": 0.26049381494522,
    "CMY_M": 0.20810329914093,
    "CMY_Y": 0.20067143440247,
    "CMYK_C": 0.07484079152346,
    "CMYK_M": 0.00929763447493,
    "CMYK_Y": 0,
    "CMYK_K": 0.20067143440247
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B538015",
    "Farbtonhilfsbezeichnung": "B53 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "206",
    "Bcolor": "214",
    "Y": 57,
    "L": 80.0390625,
    "a": -11.4385061264038,
    "b": -9.49017810821533,
    "C": 14.8628025054932,
    "h": 219.681457519531,
    "CMY_C": 0.35642343759537,
    "CMY_M": 0.19338184595108,
    "CMY_Y": 0.16070586442947,
    "CMYK_C": 0.23319306969643,
    "CMYK_M": 0.03893269225955,
    "CMYK_Y": 0,
    "CMYK_K": 0.16070586442947
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B538505",
    "Farbtonhilfsbezeichnung": "B53 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "215",
    "Bcolor": "217",
    "Y": 66,
    "L": 85.164680480957,
    "a": -3.6066722869873,
    "b": -3.16780233383179,
    "C": 4.80031824111938,
    "h": 221.293395996094,
    "CMY_C": 0.20605534315109,
    "CMY_M": 0.15602165460587,
    "CMY_Y": 0.14954060316086,
    "CMYK_C": 0.06645201146603,
    "CMYK_M": 0.00762064754963,
    "CMYK_Y": 0,
    "CMYK_K": 0.14954060316086
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B538510",
    "Farbtonhilfsbezeichnung": "B53 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 66,
    "L": 85.0664443969727,
    "a": -7.56790208816528,
    "b": -6.39502191543579,
    "C": 9.90804958343506,
    "h": 220.198440551758,
    "CMY_C": 0.25352615118027,
    "CMY_M": 0.14732903242111,
    "CMY_Y": 0.1275417804718,
    "CMYK_C": 0.14440160989761,
    "CMYK_M": 0.02267988398671,
    "CMYK_Y": 0,
    "CMYK_K": 0.1275417804718
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B539005",
    "Farbtonhilfsbezeichnung": "B53 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "229",
    "Bcolor": "231",
    "Y": 76,
    "L": 90.1544036865234,
    "a": -3.87196946144104,
    "b": -3.24052143096924,
    "C": 5.04907178878784,
    "h": 219.926574707031,
    "CMY_C": 0.15380448102951,
    "CMY_M": 0.10008293390274,
    "CMY_Y": 0.09400480985641,
    "CMYK_C": 0.0660044029355,
    "CMYK_M": 0.00670878170058,
    "CMYK_Y": 0,
    "CMYK_K": 0.09400480985641
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B544102",
    "Farbtonhilfsbezeichnung": "B54 41 02 Basalt",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "97",
    "Bcolor": "98",
    "Y": 12,
    "L": 40.7187232971191,
    "a": -1.79748141765594,
    "b": -2.04493260383606,
    "C": 2.72262525558472,
    "h": 228.684753417969,
    "CMY_C": 0.64241969585419,
    "CMY_M": 0.61923813819885,
    "CMY_Y": 0.61399573087692,
    "CMYK_C": 0.07363639771938,
    "CMYK_M": 0.0135812163353,
    "CMYK_Y": 0,
    "CMYK_K": 0.61399573087692
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B544503",
    "Farbtonhilfsbezeichnung": "B54 45 03",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "108",
    "Bcolor": "108",
    "Y": 15,
    "L": 44.9658088684082,
    "a": -2.57866287231445,
    "b": -1.50271058082581,
    "C": 2.98456716537476,
    "h": 210.231414794922,
    "CMY_C": 0.60582149028778,
    "CMY_M": 0.57696282863617,
    "CMY_Y": 0.57688695192337,
    "CMYK_C": 0.06838488578796,
    "CMYK_M": 0.00017932963965,
    "CMYK_Y": 0,
    "CMYK_K": 0.57688695192337
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B545503",
    "Farbtonhilfsbezeichnung": "B54 55 03",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "134",
    "Bcolor": "134",
    "Y": 23,
    "L": 55.2926025390625,
    "a": -2.61286568641663,
    "b": -1.62952387332916,
    "C": 3.07935309410095,
    "h": 211.949890136719,
    "CMY_C": 0.50531625747681,
    "CMY_M": 0.47455579042435,
    "CMY_Y": 0.47440260648727,
    "CMYK_C": 0.05881621688604,
    "CMYK_M": 0.0002914473007,
    "CMYK_Y": 0,
    "CMYK_K": 0.47440260648727
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B546030",
    "Farbtonhilfsbezeichnung": "B54 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "158",
    "Bcolor": "174",
    "Y": 28,
    "L": 60.1421585083008,
    "a": -24.6269550323486,
    "b": -17.4565105438232,
    "C": 30.1863651275635,
    "h": 215.330444335938,
    "CMY_C": 0.80084580183029,
    "CMY_M": 0.37931632995605,
    "CMY_Y": 0.31956952810287,
    "CMYK_C": 0.70731145143509,
    "CMYK_M": 0.08780735731125,
    "CMYK_Y": 0,
    "CMYK_K": 0.31956952810287
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B546503",
    "Farbtonhilfsbezeichnung": "B54 65 03",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "159",
    "Bcolor": "160",
    "Y": 34,
    "L": 65.0114364624023,
    "a": -2.5180139541626,
    "b": -1.84192037582397,
    "C": 3.11978602409363,
    "h": 216.185363769531,
    "CMY_C": 0.40658742189407,
    "CMY_M": 0.37498676776886,
    "CMY_Y": 0.37384682893753,
    "CMYK_C": 0.05228847265244,
    "CMYK_M": 0.00182054308243,
    "CMYK_Y": 0,
    "CMYK_K": 0.37384682893753
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B547025",
    "Farbtonhilfsbezeichnung": "B54 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "184",
    "Bcolor": "196",
    "Y": 41,
    "L": 70.3482131958008,
    "a": -20.3783397674561,
    "b": -14.3529624938965,
    "C": 24.9255752563477,
    "h": 215.157974243164,
    "CMY_C": 0.58257126808167,
    "CMY_M": 0.27938997745514,
    "CMY_Y": 0.23210030794144,
    "CMYK_C": 0.45640200376511,
    "CMYK_M": 0.06158313527703,
    "CMYK_Y": 0,
    "CMYK_K": 0.23210030794144
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B547503",
    "Farbtonhilfsbezeichnung": "B54 75 03",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "188",
    "Bcolor": "188",
    "Y": 48,
    "L": 75.6991653442383,
    "a": -2.40381693840027,
    "b": -1.76943206787109,
    "C": 2.9848325252533,
    "h": 216.356521606445,
    "CMY_C": 0.29328519105911,
    "CMY_M": 0.26213604211807,
    "CMY_Y": 0.26191377639771,
    "CMYK_C": 0.04250372573733,
    "CMYK_M": 0.00030113788671,
    "CMYK_Y": 0,
    "CMYK_K": 0.26191377639771
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B548020",
    "Farbtonhilfsbezeichnung": "B54 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "209",
    "Bcolor": "218",
    "Y": 57,
    "L": 80.1743316650391,
    "a": -16.1910037994385,
    "b": -11.7699937820435,
    "C": 20.0170269012451,
    "h": 216.015151977539,
    "CMY_C": 0.41339975595474,
    "CMY_M": 0.18150299787521,
    "CMY_Y": 0.1432728767395,
    "CMYK_C": 0.31530094146729,
    "CMYK_M": 0.04462345317006,
    "CMYK_Y": 0,
    "CMYK_K": 0.1432728767395
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B548503",
    "Farbtonhilfsbezeichnung": "B54 85 03",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "214",
    "Bcolor": "214",
    "Y": 66,
    "L": 84.9471664428711,
    "a": -2.64456295967102,
    "b": -2.07752227783203,
    "C": 3.3630063533783,
    "h": 218.152557373047,
    "CMY_C": 0.19653815031052,
    "CMY_M": 0.16092133522034,
    "CMY_Y": 0.15975767374039,
    "CMYK_C": 0.04377365484834,
    "CMYK_M": 0.00138491170947,
    "CMYK_Y": 0,
    "CMYK_K": 0.15975767374039
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B548515",
    "Farbtonhilfsbezeichnung": "B54 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "220",
    "Bcolor": "226",
    "Y": 66,
    "L": 85.0153045654297,
    "a": -12.4169416427612,
    "b": -8.62518215179443,
    "C": 15.118670463562,
    "h": 214.785018920898,
    "CMY_C": 0.3079805970192,
    "CMY_M": 0.13681322336197,
    "CMY_Y": 0.11238139867783,
    "CMYK_C": 0.22036401927471,
    "CMYK_M": 0.02752513810992,
    "CMYK_Y": 0,
    "CMYK_K": 0.11238139867783
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B549010",
    "Farbtonhilfsbezeichnung": "B54 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "232",
    "Bcolor": "236",
    "Y": 76,
    "L": 90.2013320922852,
    "a": -8.04466438293457,
    "b": -5.70610094070435,
    "C": 9.86287021636963,
    "h": 215.348175048828,
    "CMY_C": 0.19881367683411,
    "CMY_M": 0.08941966295242,
    "CMY_Y": 0.07578301429749,
    "CMYK_C": 0.1331188082695,
    "CMYK_M": 0.01475481316447,
    "CMYK_Y": 0,
    "CMYK_K": 0.07578301429749
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B549305",
    "Farbtonhilfsbezeichnung": "B54 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "237",
    "Bcolor": "238",
    "Y": 83,
    "L": 92.8721237182617,
    "a": -4.15483903884888,
    "b": -2.88069295883179,
    "C": 5.05579662322998,
    "h": 214.734909057617,
    "CMY_C": 0.1247141957283,
    "CMY_M": 0.0691329240799,
    "CMY_Y": 0.06647151708603,
    "CMYK_C": 0.06238982453942,
    "CMYK_M": 0.0028509113472,
    "CMYK_Y": 0,
    "CMYK_K": 0.06647151708603
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B549503",
    "Farbtonhilfsbezeichnung": "B54 95 03",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "241",
    "Bcolor": "241",
    "Y": 88,
    "L": 94.5067367553711,
    "a": -2.43063187599182,
    "b": -1.74214112758636,
    "C": 2.99048948287964,
    "h": 215.630844116211,
    "CMY_C": 0.08793944120407,
    "CMY_M": 0.05510556697845,
    "CMY_Y": 0.05646908283234,
    "CMYK_C": 0.0347487218678,
    "CMYK_M": 0,
    "CMYK_Y": 0.00144303508569,
    "CMYK_K": 0.05510556697845
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B554015",
    "Farbtonhilfsbezeichnung": "B55 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "101",
    "Bcolor": "105",
    "Y": 11,
    "L": 40.1796836853027,
    "a": -13.2874689102173,
    "b": -7.38431453704834,
    "C": 15.2014780044556,
    "h": 209.062469482422,
    "CMY_C": 0.76715481281281,
    "CMY_M": 0.60225892066956,
    "CMY_Y": 0.58653265237808,
    "CMYK_C": 0.436847448349,
    "CMYK_M": 0.03803509101272,
    "CMYK_Y": 0,
    "CMYK_K": 0.58653265237808
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B555030",
    "Farbtonhilfsbezeichnung": "B55 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "142",
    "Y": 18,
    "L": 49.8799171447754,
    "a": -26.5348625183106,
    "b": -14.8530626296997,
    "C": 30.4090843200684,
    "h": 209.238204956055,
    "CMY_C": 1,
    "CMY_M": 0.48308217525482,
    "CMY_Y": 0.4433861374855,
    "CMYK_C": 1,
    "CMYK_M": 0.07131700962782,
    "CMYK_Y": 0,
    "CMYK_K": 0.4433861374855
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B556005",
    "Farbtonhilfsbezeichnung": "B55 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "147",
    "Bcolor": "148",
    "Y": 28,
    "L": 59.956787109375,
    "a": -4.41591310501099,
    "b": -2.57209897041321,
    "C": 5.11037969589233,
    "h": 210.219146728516,
    "CMY_C": 0.475565969944,
    "CMY_M": 0.42306965589523,
    "CMY_Y": 0.42105090618134,
    "CMYK_C": 0.0941620990634,
    "CMYK_M": 0.00348692084663,
    "CMYK_Y": 0,
    "CMYK_K": 0.42105090618134
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B556025",
    "Farbtonhilfsbezeichnung": "B55 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "157",
    "Bcolor": "165",
    "Y": 28,
    "L": 60.144645690918,
    "a": -21.9626560211182,
    "b": -12.5360403060913,
    "C": 25.2885456085205,
    "h": 209.717239379883,
    "CMY_C": 0.70201510190964,
    "CMY_M": 0.38524878025055,
    "CMY_Y": 0.3529988527298,
    "CMYK_C": 0.53943681716919,
    "CMYK_M": 0.04984524101019,
    "CMYK_Y": 0,
    "CMYK_K": 0.3529988527298
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B557020",
    "Farbtonhilfsbezeichnung": "B55 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "182",
    "Bcolor": "188",
    "Y": 41,
    "L": 70.3144226074219,
    "a": -17.2767086029053,
    "b": -10.073657989502,
    "C": 19.999080657959,
    "h": 210.245498657227,
    "CMY_C": 0.52006328105927,
    "CMY_M": 0.28682506084442,
    "CMY_Y": 0.26231104135513,
    "CMYK_C": 0.34940505027771,
    "CMYK_M": 0.03323083370924,
    "CMYK_Y": 0,
    "CMYK_K": 0.26231104135513
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B558010",
    "Farbtonhilfsbezeichnung": "B55 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "204",
    "Bcolor": "206",
    "Y": 57,
    "L": 80.1724624633789,
    "a": -8.58779048919678,
    "b": -5.09064340591431,
    "C": 9.98322582244873,
    "h": 210.658493041992,
    "CMY_C": 0.3095765709877,
    "CMY_M": 0.19923633337021,
    "CMY_Y": 0.19068390130997,
    "CMYK_C": 0.14690510928631,
    "CMYK_M": 0.01056748069823,
    "CMYK_Y": 0,
    "CMYK_K": 0.19068390130997
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B558015",
    "Farbtonhilfsbezeichnung": "B55 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 57,
    "L": 80.3374633789063,
    "a": -13.1966724395752,
    "b": -7.5347318649292,
    "C": 15.196195602417,
    "h": 209.724502563477,
    "CMY_C": 0.36035358905792,
    "CMY_M": 0.18704909086227,
    "CMY_Y": 0.17177700996399,
    "CMYK_C": 0.22768817842007,
    "CMYK_M": 0.01843957602978,
    "CMYK_Y": 0,
    "CMYK_K": 0.17177700996399
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B558510",
    "Farbtonhilfsbezeichnung": "B55 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "218",
    "Bcolor": "220",
    "Y": 66,
    "L": 85.2525100708008,
    "a": -8.35495090484619,
    "b": -4.87531137466431,
    "C": 9.67335891723633,
    "h": 210.264572143555,
    "CMY_C": 0.25199490785599,
    "CMY_M": 0.14399760961533,
    "CMY_Y": 0.13669914007187,
    "CMYK_C": 0.13355223834515,
    "CMYK_M": 0.00845414400101,
    "CMYK_Y": 0,
    "CMYK_K": 0.13669914007187
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B559005",
    "Farbtonhilfsbezeichnung": "B55 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "230",
    "Bcolor": "230",
    "Y": 76,
    "L": 90.1809692382812,
    "a": -4.27559375762939,
    "b": -2.47758865356445,
    "C": 4.94157361984253,
    "h": 210.091110229492,
    "CMY_C": 0.15396738052368,
    "CMY_M": 0.0990846157074,
    "CMY_Y": 0.0994034409523,
    "CMYK_C": 0.06091888993979,
    "CMYK_M": 0,
    "CMYK_Y": 0.00035389032564,
    "CMYK_K": 0.0990846157074
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B564010",
    "Farbtonhilfsbezeichnung": "B56 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "98",
    "Bcolor": "99",
    "Y": 11,
    "L": 39.5142974853516,
    "a": -9.42890453338623,
    "b": -4.13751268386841,
    "C": 10.2967596054077,
    "h": 203.692413330078,
    "CMY_C": 0.72063845396042,
    "CMY_M": 0.61605083942413,
    "CMY_Y": 0.61303210258484,
    "CMYK_C": 0.27807566523552,
    "CMYK_M": 0.00780100049451,
    "CMYK_Y": 0,
    "CMYK_K": 0.61303210258484
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B564020",
    "Farbtonhilfsbezeichnung": "B56 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "102",
    "Bcolor": "106",
    "Y": 11,
    "L": 39.745361328125,
    "a": -18.3477363586426,
    "b": -8.38077259063721,
    "C": 20.1711864471436,
    "h": 204.549697875977,
    "CMY_C": 0.84081542491913,
    "CMY_M": 0.598109126091,
    "CMY_Y": 0.58484637737274,
    "CMYK_C": 0.6165646314621,
    "CMYK_M": 0.03194660320878,
    "CMYK_Y": 0,
    "CMYK_K": 0.58484637737274
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B564030",
    "Farbtonhilfsbezeichnung": "B56 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "109",
    "Bcolor": "115",
    "Y": 11,
    "L": 41.0809097290039,
    "a": -26.4217548370361,
    "b": -12.221601486206,
    "C": 29.1114521026611,
    "h": 204.823287963867,
    "CMY_C": 1,
    "CMY_M": 0.57219046354294,
    "CMY_Y": 0.54812574386597,
    "CMYK_C": 1,
    "CMYK_M": 0.05325534567237,
    "CMYK_Y": 0,
    "CMYK_K": 0.54812574386597
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B565005",
    "Farbtonhilfsbezeichnung": "B56 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "122",
    "Bcolor": "121",
    "Y": 18,
    "L": 50.1145286560059,
    "a": -4.59474849700928,
    "b": -1.98915505409241,
    "C": 5.00684070587158,
    "h": 203.408721923828,
    "CMY_C": 0.57266384363174,
    "CMY_M": 0.52227747440338,
    "CMY_Y": 0.52373838424683,
    "CMYK_C": 0.10547204315662,
    "CMYK_M": 0,
    "CMYK_Y": 0.00305807194673,
    "CMYK_K": 0.52227747440338
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B565015",
    "Farbtonhilfsbezeichnung": "B56 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "127",
    "Bcolor": "129",
    "Y": 18,
    "L": 50.2820358276367,
    "a": -13.6509475708008,
    "b": -6.21976327896118,
    "C": 15.001127243042,
    "h": 204.495376586914,
    "CMY_C": 0.66620492935181,
    "CMY_M": 0.50251668691635,
    "CMY_Y": 0.49520438909531,
    "CMYK_C": 0.33875203132629,
    "CMYK_M": 0.01448566000909,
    "CMYK_Y": 0,
    "CMYK_K": 0.49520438909531
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B565025",
    "Farbtonhilfsbezeichnung": "B56 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "130",
    "Bcolor": "135",
    "Y": 18,
    "L": 50.0007972717285,
    "a": -22.8893375396729,
    "b": -10.4725971221924,
    "C": 25.1713542938232,
    "h": 204.585601806641,
    "CMY_C": 0.81527900695801,
    "CMY_M": 0.48871922492981,
    "CMY_Y": 0.47081959247589,
    "CMYK_C": 0.65093004703522,
    "CMYK_M": 0.03382520005107,
    "CMYK_Y": 0,
    "CMYK_K": 0.47081959247589
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B566010",
    "Farbtonhilfsbezeichnung": "B56 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "149",
    "Bcolor": "150",
    "Y": 28,
    "L": 59.7494888305664,
    "a": -9.18256378173828,
    "b": -4.26061820983887,
    "C": 10.1228628158569,
    "h": 204.890823364258,
    "CMY_C": 0.52308744192123,
    "CMY_M": 0.41512978076935,
    "CMY_Y": 0.41223269701004,
    "CMYK_C": 0.18860311806202,
    "CMYK_M": 0.00492896372452,
    "CMYK_Y": 0,
    "CMYK_K": 0.41223269701004
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B566020",
    "Farbtonhilfsbezeichnung": "B56 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "154",
    "Bcolor": "157",
    "Y": 28,
    "L": 59.7275238037109,
    "a": -18.0011711120606,
    "b": -8.41040134429932,
    "C": 19.8689956665039,
    "h": 205.04264831543,
    "CMY_C": 0.62835484743118,
    "CMY_M": 0.39769637584686,
    "CMY_Y": 0.38512349128723,
    "CMYK_C": 0.39557757973671,
    "CMYK_M": 0.02044782042503,
    "CMYK_Y": 0,
    "CMYK_K": 0.38512349128723
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B567005",
    "Farbtonhilfsbezeichnung": "B56 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "174",
    "Bcolor": "174",
    "Y": 41,
    "L": 70.0534744262695,
    "a": -4.63148593902588,
    "b": -2.28101086616516,
    "C": 5.1627197265625,
    "h": 206.220291137695,
    "CMY_C": 0.37240076065063,
    "CMY_M": 0.31734949350357,
    "CMY_Y": 0.31841588020325,
    "CMYK_C": 0.08064341545105,
    "CMYK_M": 0,
    "CMYK_Y": 0.00156212691218,
    "CMYK_K": 0.31734949350357
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B567015",
    "Farbtonhilfsbezeichnung": "B56 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "180",
    "Bcolor": "181",
    "Y": 41,
    "L": 70.2382431030273,
    "a": -13.6304998397827,
    "b": -6.30982112884521,
    "C": 15.0201320648193,
    "h": 204.84033203125,
    "CMY_C": 0.46493363380432,
    "CMY_M": 0.29576671123505,
    "CMY_Y": 0.28921908140182,
    "CMYK_C": 0.24721337854862,
    "CMYK_M": 0.00921188201755,
    "CMYK_Y": 0,
    "CMYK_K": 0.28921908140182
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B568010",
    "Farbtonhilfsbezeichnung": "B56 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "204",
    "Bcolor": "205",
    "Y": 57,
    "L": 80.1572723388672,
    "a": -9.10512256622314,
    "b": -4.39638090133667,
    "C": 10.1109552383423,
    "h": 205.773422241211,
    "CMY_C": 0.31133282184601,
    "CMY_M": 0.19849556684494,
    "CMY_Y": 0.19592392444611,
    "CMYK_C": 0.14352981746197,
    "CMYK_M": 0.00319825764745,
    "CMYK_Y": 0,
    "CMYK_K": 0.19592392444611
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B568505",
    "Farbtonhilfsbezeichnung": "B56 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "216",
    "Bcolor": "215",
    "Y": 66,
    "L": 85.1902084350586,
    "a": -4.49862813949585,
    "b": -2.27230834960938,
    "C": 5.03994464874268,
    "h": 206.798858642578,
    "CMY_C": 0.20974510908127,
    "CMY_M": 0.15398240089417,
    "CMY_Y": 0.15591764450073,
    "CMYK_C": 0.06591199338436,
    "CMYK_M": 0,
    "CMYK_Y": 0.0022874744609,
    "CMYK_K": 0.15398240089417
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B573005",
    "Farbtonhilfsbezeichnung": "B57 30 05",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "73",
    "Bcolor": "72",
    "Y": 6,
    "L": 30.0000286102295,
    "a": -4.64358139038086,
    "b": -1.43996405601501,
    "C": 4.86172246932983,
    "h": 197.228546142578,
    "CMY_C": 0.75892853736877,
    "CMY_M": 0.71388506889343,
    "CMY_Y": 0.71722722053528,
    "CMYK_C": 0.15743137896061,
    "CMYK_M": 0,
    "CMYK_Y": 0.01168115064502,
    "CMYK_K": 0.71388506889343
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B573010",
    "Farbtonhilfsbezeichnung": "B57 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "76",
    "Bcolor": "76",
    "Y": 6,
    "L": 30.3608207702637,
    "a": -9.62811756134033,
    "b": -3.22507619857788,
    "C": 10.1539039611816,
    "h": 198.519012451172,
    "CMY_C": 0.80181223154068,
    "CMY_M": 0.70174050331116,
    "CMY_Y": 0.70371663570404,
    "CMYK_C": 0.33551898598671,
    "CMYK_M": 0,
    "CMYK_Y": 0.00662554707378,
    "CMYK_K": 0.70174050331116
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B574005",
    "Farbtonhilfsbezeichnung": "B57 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "96",
    "Bcolor": "95",
    "Y": 11,
    "L": 39.725227355957,
    "a": -4.89300346374512,
    "b": -1.6471449136734,
    "C": 5.16280651092529,
    "h": 198.604904174805,
    "CMY_C": 0.6728857755661,
    "CMY_M": 0.62285876274109,
    "CMY_Y": 0.62625241279602,
    "CMYK_C": 0.13264794647694,
    "CMYK_M": 0,
    "CMYK_Y": 0.00899835303426,
    "CMYK_K": 0.62285876274109
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B574015",
    "Farbtonhilfsbezeichnung": "B57 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "102",
    "Bcolor": "102",
    "Y": 11,
    "L": 40.2401657104492,
    "a": -14.3380184173584,
    "b": -5.05092334747314,
    "C": 15.2016639709473,
    "h": 199.40608215332,
    "CMY_C": 0.76405727863312,
    "CMY_M": 0.60053646564484,
    "CMY_Y": 0.60082411766052,
    "CMYK_C": 0.40935105085373,
    "CMYK_M": 0,
    "CMYK_Y": 0.00072009582072,
    "CMYK_K": 0.60053646564484
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B574025",
    "Farbtonhilfsbezeichnung": "B57 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "9",
    "Gcolor": "104",
    "Bcolor": "106",
    "Y": 11,
    "L": 39.7268753051758,
    "a": -23.6438617706299,
    "b": -8.45322322845459,
    "C": 25.1095428466797,
    "h": 199.673141479492,
    "CMY_C": 0.96374261379242,
    "CMY_M": 0.59040129184723,
    "CMY_Y": 0.58500522375107,
    "CMYK_C": 0.91263169050217,
    "CMYK_M": 0.01300273742527,
    "CMYK_Y": 0,
    "CMYK_K": 0.58500522375107
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B575005",
    "Farbtonhilfsbezeichnung": "B57 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "123",
    "Bcolor": "122",
    "Y": 18,
    "L": 50.3966178894043,
    "a": -4.9249439239502,
    "b": -1.64517688751221,
    "C": 5.19246387481689,
    "h": 198.471893310547,
    "CMY_C": 0.57121086120605,
    "CMY_M": 0.51890969276428,
    "CMY_Y": 0.52325785160065,
    "CMYK_C": 0.10871382802725,
    "CMYK_M": 0,
    "CMYK_Y": 0.00903813447803,
    "CMYK_K": 0.51890969276428
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B575010",
    "Farbtonhilfsbezeichnung": "B57 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "124",
    "Bcolor": "124",
    "Y": 18,
    "L": 50.1828498840332,
    "a": -9.34448623657227,
    "b": -3.21854496002197,
    "C": 9.88324069976807,
    "h": 199.005386352539,
    "CMY_C": 0.61460870504379,
    "CMY_M": 0.51213407516479,
    "CMY_Y": 0.51550829410553,
    "CMYK_C": 0.21004670858383,
    "CMYK_M": 0,
    "CMYK_Y": 0.00691628316417,
    "CMYK_K": 0.51213407516479
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B575020",
    "Farbtonhilfsbezeichnung": "B57 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "128",
    "Bcolor": "129",
    "Y": 18,
    "L": 50.0587158203125,
    "a": -18.573766708374,
    "b": -6.64714050292969,
    "C": 19.7273731231689,
    "h": 199.691177368164,
    "CMY_C": 0.72283399105072,
    "CMY_M": 0.49617236852646,
    "CMY_Y": 0.49509257078171,
    "CMYK_C": 0.4510557949543,
    "CMYK_M": 0.00213860534132,
    "CMYK_Y": 0,
    "CMYK_K": 0.49509257078171
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B576005",
    "Farbtonhilfsbezeichnung": "B57 60 05",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "148",
    "Bcolor": "147",
    "Y": 28,
    "L": 60.0813064575195,
    "a": -4.78915786743164,
    "b": -1.79366886615753,
    "C": 5.11402797698975,
    "h": 200.532287597656,
    "CMY_C": 0.47440761327744,
    "CMY_M": 0.42122578620911,
    "CMY_Y": 0.42512089014053,
    "CMYK_C": 0.09188700467348,
    "CMYK_M": 0,
    "CMYK_Y": 0.0067299194634,
    "CMYK_K": 0.42122578620911
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B576015",
    "Farbtonhilfsbezeichnung": "B57 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "152",
    "Bcolor": "152",
    "Y": 28,
    "L": 59.9974822998047,
    "a": -14.0777626037598,
    "b": -4.94676351547241,
    "C": 14.9215908050537,
    "h": 199.360885620117,
    "CMY_C": 0.56735670566559,
    "CMY_M": 0.40300345420837,
    "CMY_Y": 0.40555649995804,
    "CMYK_C": 0.27530017495155,
    "CMYK_M": 0,
    "CMYK_Y": 0.0042764833197,
    "CMYK_K": 0.40300345420837
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B577005",
    "Farbtonhilfsbezeichnung": "B57 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "174",
    "Bcolor": "173",
    "Y": 41,
    "L": 70.2025756835938,
    "a": -4.63752222061157,
    "b": -1.82583737373352,
    "C": 4.98400402069092,
    "h": 201.490036010742,
    "CMY_C": 0.3692227602005,
    "CMY_M": 0.31588184833527,
    "CMY_Y": 0.32004296779633,
    "CMYK_C": 0.07797031849623,
    "CMYK_M": 0,
    "CMYK_Y": 0.00608245749027,
    "CMYK_K": 0.31588184833527
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B577010",
    "Farbtonhilfsbezeichnung": "B57 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "177",
    "Bcolor": "177",
    "Y": 41,
    "L": 70.2895660400391,
    "a": -9.45304775238037,
    "b": -3.64375162124634,
    "C": 10.1309938430786,
    "h": 201.079544067383,
    "CMY_C": 0.41515928506851,
    "CMY_M": 0.30435466766357,
    "CMY_Y": 0.30694144964218,
    "CMYK_C": 0.15928320586681,
    "CMYK_M": 0,
    "CMYK_Y": 0.00371853564866,
    "CMYK_K": 0.30435466766357
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B577025",
    "Farbtonhilfsbezeichnung": "B57 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "184",
    "Bcolor": "184",
    "Y": 41,
    "L": 69.9494094848633,
    "a": -23.5283508300781,
    "b": -8.55712509155273,
    "C": 25.0361270904541,
    "h": 199.986022949219,
    "CMY_C": 0.58499205112457,
    "CMY_M": 0.27961921691895,
    "CMY_Y": 0.27753013372421,
    "CMYK_C": 0.42557057738304,
    "CMYK_M": 0.00289158523083,
    "CMYK_Y": 0,
    "CMYK_K": 0.27753013372421
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B578005",
    "Farbtonhilfsbezeichnung": "B57 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "202",
    "Bcolor": "200",
    "Y": 57,
    "L": 80.0979537963867,
    "a": -4.64661931991577,
    "b": -1.8525527715683,
    "C": 5.00230169296265,
    "h": 201.736587524414,
    "CMY_C": 0.26449060440063,
    "CMY_M": 0.20955407619476,
    "CMY_Y": 0.21436423063278,
    "CMYK_C": 0.06950067728758,
    "CMYK_M": 0,
    "CMYK_Y": 0.00608536833897,
    "CMYK_K": 0.20955407619476
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B578505",
    "Farbtonhilfsbezeichnung": "B57 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "214",
    "Bcolor": "213",
    "Y": 66,
    "L": 84.7104949951172,
    "a": -4.6489520072937,
    "b": -1.86558854579926,
    "C": 5.00930881500244,
    "h": 201.865203857422,
    "CMY_C": 0.21468007564545,
    "CMY_M": 0.15904533863068,
    "CMY_Y": 0.16415393352509,
    "CMYK_C": 0.06615664064884,
    "CMYK_M": 0,
    "CMYK_Y": 0.00607475684956,
    "CMYK_K": 0.15904533863068
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B586030",
    "Farbtonhilfsbezeichnung": "B58 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "159",
    "Bcolor": "157",
    "Y": 28,
    "L": 60.0918350219727,
    "a": -29.4762992858887,
    "b": -7.90908908843994,
    "C": 30.5189437866211,
    "h": 195.019836425781,
    "CMY_C": 0.77937698364258,
    "CMY_M": 0.37463253736496,
    "CMY_Y": 0.38590168952942,
    "CMYK_C": 0.64721059799194,
    "CMYK_M": 0,
    "CMYK_Y": 0.01802004873753,
    "CMYK_K": 0.37463253736496
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B587025",
    "Farbtonhilfsbezeichnung": "B58 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "184",
    "Bcolor": "181",
    "Y": 41,
    "L": 70.041145324707,
    "a": -24.3635711669922,
    "b": -6.73737668991089,
    "C": 25.2779712677002,
    "h": 195.457977294922,
    "CMY_C": 0.58200430870056,
    "CMY_M": 0.27763587236404,
    "CMY_Y": 0.28946125507355,
    "CMYK_C": 0.42135041952133,
    "CMYK_M": 0,
    "CMYK_Y": 0.01637038961053,
    "CMYK_K": 0.27763587236404
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B588020",
    "Farbtonhilfsbezeichnung": "B58 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "209",
    "Bcolor": "206",
    "Y": 57,
    "L": 79.7748718261719,
    "a": -19.5376987457275,
    "b": -5.59936618804932,
    "C": 20.3242359161377,
    "h": 195.991928100586,
    "CMY_C": 0.4186669588089,
    "CMY_M": 0.18106365203857,
    "CMY_Y": 0.19261693954468,
    "CMYK_C": 0.29013648629189,
    "CMYK_M": 0,
    "CMYK_Y": 0.01410767436028,
    "CMYK_K": 0.18106365203857
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B588515",
    "Farbtonhilfsbezeichnung": "B58 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 66,
    "L": 85.2397994995117,
    "a": -14.5579586029053,
    "b": -4.0211615562439,
    "C": 15.1031093597412,
    "h": 195.44108581543,
    "CMY_C": 0.30414569377899,
    "CMY_M": 0.13118082284927,
    "CMY_Y": 0.14384973049164,
    "CMYK_C": 0.19908040761948,
    "CMYK_M": 0,
    "CMYK_Y": 0.01458175387233,
    "CMYK_K": 0.13118082284927
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B589010",
    "Farbtonhilfsbezeichnung": "B58 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 76,
    "L": 90.0824279785156,
    "a": -9.94806480407715,
    "b": -2.79939532279968,
    "C": 10.3344383239746,
    "h": 195.716659545898,
    "CMY_C": 0.20472323894501,
    "CMY_M": 0.08740073442459,
    "CMY_Y": 0.09885120391846,
    "CMYK_C": 0.12855862081051,
    "CMYK_M": 0,
    "CMYK_Y": 0.0125470943749,
    "CMYK_K": 0.08740073442459
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B589305",
    "Farbtonhilfsbezeichnung": "B58 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "238",
    "Bcolor": "236",
    "Y": 83,
    "L": 93.1451950073242,
    "a": -4.45399761199951,
    "b": -1.21182608604431,
    "C": 4.61590909957886,
    "h": 195.22038269043,
    "CMY_C": 0.11787128448486,
    "CMY_M": 0.06586277484894,
    "CMY_Y": 0.07588762044907,
    "CMYK_C": 0.05567545071244,
    "CMYK_M": 0,
    "CMYK_Y": 0.01073166262358,
    "CMYK_K": 0.06586277484894
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B594010",
    "Farbtonhilfsbezeichnung": "B59 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "99",
    "Bcolor": "96",
    "Y": 11,
    "L": 40.0616111755371,
    "a": -9.76584529876709,
    "b": -1.62314236164093,
    "C": 9.89981460571289,
    "h": 189.436645507812,
    "CMY_C": 0.70779061317444,
    "CMY_M": 0.61083155870438,
    "CMY_Y": 0.6237468123436,
    "CMYK_C": 0.24914418160915,
    "CMYK_M": 0,
    "CMYK_Y": 0.03318679705262,
    "CMYK_K": 0.61083155870438
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B595030",
    "Farbtonhilfsbezeichnung": "B59 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "28",
    "Gcolor": "133",
    "Bcolor": "126",
    "Y": 18,
    "L": 50.2137870788574,
    "a": -29.7412433624268,
    "b": -4.92100095748901,
    "C": 30.1456108093262,
    "h": 189.395065307617,
    "CMY_C": 0.8883621096611,
    "CMY_M": 0.47750467061996,
    "CMY_Y": 0.50599652528763,
    "CMYK_C": 0.78633707761765,
    "CMYK_M": 0,
    "CMYK_Y": 0.05453035235405,
    "CMYK_K": 0.47750467061996
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B596020",
    "Farbtonhilfsbezeichnung": "B59 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "156",
    "Bcolor": "150",
    "Y": 28,
    "L": 60.3008918762207,
    "a": -19.6990909576416,
    "b": -3.51458692550659,
    "C": 20.010160446167,
    "h": 190.115921020508,
    "CMY_C": 0.61257487535477,
    "CMY_M": 0.3900071978569,
    "CMY_Y": 0.4128280878067,
    "CMYK_C": 0.3648693561554,
    "CMYK_M": 0,
    "CMYK_Y": 0.03741173818707,
    "CMYK_K": 0.3900071978569
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B596025",
    "Farbtonhilfsbezeichnung": "B59 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "158",
    "Bcolor": "151",
    "Y": 28,
    "L": 60.2569580078125,
    "a": -24.5075702667236,
    "b": -4.17644834518433,
    "C": 24.8608875274658,
    "h": 189.671127319336,
    "CMY_C": 0.67148125171661,
    "CMY_M": 0.38200408220291,
    "CMY_Y": 0.40925526618958,
    "CMYK_C": 0.46841275691986,
    "CMYK_M": 0,
    "CMYK_Y": 0.04409606009722,
    "CMYK_K": 0.38200408220291
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B597010",
    "Farbtonhilfsbezeichnung": "B59 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "177",
    "Bcolor": "173",
    "Y": 41,
    "L": 70.1155395507813,
    "a": -9.52572059631348,
    "b": -1.75051844120026,
    "C": 9.68522930145264,
    "h": 190.412933349609,
    "CMY_C": 0.409927546978,
    "CMY_M": 0.3065699338913,
    "CMY_Y": 0.3220876455307,
    "CMYK_C": 0.14905267953873,
    "CMYK_M": 0,
    "CMYK_Y": 0.02237819321454,
    "CMYK_K": 0.3065699338913
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B597020",
    "Farbtonhilfsbezeichnung": "B59 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "181",
    "Bcolor": "175",
    "Y": 41,
    "L": 69.8726043701172,
    "a": -19.6413955688477,
    "b": -3.58971357345581,
    "C": 19.9667339324951,
    "h": 190.357223510742,
    "CMY_C": 0.51376438140869,
    "CMY_M": 0.28889900445938,
    "CMY_Y": 0.31289166212082,
    "CMYK_C": 0.31622144579887,
    "CMYK_M": 0,
    "CMYK_Y": 0.03374015539885,
    "CMYK_K": 0.28889900445938
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B598010",
    "Farbtonhilfsbezeichnung": "B59 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "203",
    "Bcolor": "199",
    "Y": 57,
    "L": 79.6703643798828,
    "a": -9.73212146759033,
    "b": -1.80562496185303,
    "C": 9.89820575714111,
    "h": 190.510711669922,
    "CMY_C": 0.31136041879654,
    "CMY_M": 0.20320194959641,
    "CMY_Y": 0.21996343135834,
    "CMYK_C": 0.1357413828373,
    "CMYK_M": 0,
    "CMYK_Y": 0.02103604748845,
    "CMYK_K": 0.20320194959641
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B598015",
    "Farbtonhilfsbezeichnung": "B59 80 15",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "208",
    "Bcolor": "202",
    "Y": 57,
    "L": 80.3059005737305,
    "a": -14.8919105529785,
    "b": -2.62097883224487,
    "C": 15.1207981109619,
    "h": 189.981842041016,
    "CMY_C": 0.35381877422333,
    "CMY_M": 0.18531239032745,
    "CMY_Y": 0.20784598588943,
    "CMYK_C": 0.20683558285236,
    "CMYK_M": 0,
    "CMYK_Y": 0.02765918523073,
    "CMYK_K": 0.18531239032745
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B598510",
    "Farbtonhilfsbezeichnung": "B59 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "219",
    "Bcolor": "214",
    "Y": 66,
    "L": 85.310302734375,
    "a": -9.65845775604248,
    "b": -1.72239720821381,
    "C": 9.81083393096924,
    "h": 190.111297607422,
    "CMY_C": 0.24979037046432,
    "CMY_M": 0.14142626523972,
    "CMY_Y": 0.15928822755814,
    "CMYK_C": 0.12621408700943,
    "CMYK_M": 0,
    "CMYK_Y": 0.02080422639847,
    "CMYK_K": 0.14142626523972
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B599005",
    "Farbtonhilfsbezeichnung": "B59 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "230",
    "Bcolor": "227",
    "Y": 76,
    "L": 90.1914443969727,
    "a": -4.95784854888916,
    "b": -0.90453743934631,
    "C": 5.0396876335144,
    "h": 190.339645385742,
    "CMY_C": 0.15360695123672,
    "CMY_M": 0.09786295890808,
    "CMY_Y": 0.11100953817368,
    "CMYK_C": 0.06179104745388,
    "CMYK_M": 0,
    "CMYK_Y": 0.01457270793617,
    "CMYK_K": 0.09786295890808
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B599010",
    "Farbtonhilfsbezeichnung": "B59 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 76,
    "L": 89.4794387817383,
    "a": -9.79006862640381,
    "b": -1.71793854236603,
    "C": 9.93965530395508,
    "h": 189.952789306641,
    "CMY_C": 0.205541908741,
    "CMY_M": 0.09479504823685,
    "CMY_Y": 0.11350047588348,
    "CMYK_C": 0.12234451621771,
    "CMYK_M": 0,
    "CMYK_Y": 0.02066430076957,
    "CMYK_K": 0.09479504823685
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B604010",
    "Farbtonhilfsbezeichnung": "B60 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "98",
    "Bcolor": "93",
    "Y": 11,
    "L": 39.5921173095703,
    "a": -10.1986112594604,
    "b": -0.79480528831482,
    "C": 10.2295351028442,
    "h": 184.456207275391,
    "CMY_C": 0.71239995956421,
    "CMY_M": 0.61477279663086,
    "CMY_Y": 0.63344895839691,
    "CMYK_C": 0.25342747569084,
    "CMYK_M": 0,
    "CMYK_Y": 0.04848090186715,
    "CMYK_K": 0.61477279663086
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B604020",
    "Farbtonhilfsbezeichnung": "B60 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "103",
    "Bcolor": "95",
    "Y": 11,
    "L": 40.019847869873,
    "a": -19.9086055755615,
    "b": -1.48988735675812,
    "C": 19.9642772674561,
    "h": 184.279830932617,
    "CMY_C": 0.80657678842545,
    "CMY_M": 0.594722032547,
    "CMY_Y": 0.62600475549698,
    "CMYK_C": 0.52273941040039,
    "CMYK_M": 0,
    "CMYK_Y": 0.07718831300735,
    "CMYK_K": 0.594722032547
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B604030",
    "Farbtonhilfsbezeichnung": "B60 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "98",
    "Y": 11,
    "L": 40.1976356506348,
    "a": -29.6112194061279,
    "b": -2.68710827827454,
    "C": 29.7328910827637,
    "h": 185.185180664062,
    "CMY_C": 1,
    "CMY_M": 0.57888960838318,
    "CMY_Y": 0.61760836839676,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.0919444411993,
    "CMYK_K": 0.57888960838318
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B605005",
    "Farbtonhilfsbezeichnung": "B60 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "121",
    "Bcolor": "118",
    "Y": 18,
    "L": 49.9031448364258,
    "a": -4.99353456497192,
    "b": -0.17214912176132,
    "C": 4.99650096893311,
    "h": 181.974456787109,
    "CMY_C": 0.57142961025238,
    "CMY_M": 0.524045586586,
    "CMY_Y": 0.53779941797256,
    "CMYK_C": 0.09955580532551,
    "CMYK_M": 0,
    "CMYK_Y": 0.0288973711431,
    "CMYK_K": 0.524045586586
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B605015",
    "Farbtonhilfsbezeichnung": "B60 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "126",
    "Bcolor": "119",
    "Y": 18,
    "L": 49.9135551452637,
    "a": -15.3218612670898,
    "b": -1.1500837802887,
    "C": 15.3649644851685,
    "h": 184.292663574219,
    "CMY_C": 0.66087317466736,
    "CMY_M": 0.50455331802368,
    "CMY_Y": 0.5324273109436,
    "CMYK_C": 0.31551298499107,
    "CMYK_M": 0,
    "CMYK_Y": 0.05626032873988,
    "CMYK_K": 0.50455331802368
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B605025",
    "Farbtonhilfsbezeichnung": "B60 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "130",
    "Bcolor": "120",
    "Y": 18,
    "L": 49.847728729248,
    "a": -25.1478977203369,
    "b": -2.04917216300964,
    "C": 25.2312469482422,
    "h": 184.658447265625,
    "CMY_C": 0.77616614103317,
    "CMY_M": 0.48885732889175,
    "CMY_Y": 0.52815675735474,
    "CMYK_C": 0.56209123134613,
    "CMYK_M": 0,
    "CMYK_Y": 0.07688543945551,
    "CMYK_K": 0.48885732889175
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B606010",
    "Farbtonhilfsbezeichnung": "B60 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "151",
    "Bcolor": "145",
    "Y": 28,
    "L": 60.2260971069336,
    "a": -10.3620233535767,
    "b": -0.91666293144226,
    "C": 10.4024896621704,
    "h": 185.055435180664,
    "CMY_C": 0.51467710733414,
    "CMY_M": 0.40878045558929,
    "CMY_Y": 0.43028157949448,
    "CMYK_C": 0.17911560833454,
    "CMYK_M": 0,
    "CMYK_Y": 0.03636740893126,
    "CMYK_K": 0.40878045558929
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B606020",
    "Farbtonhilfsbezeichnung": "B60 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "155",
    "Bcolor": "146",
    "Y": 28,
    "L": 60.080680847168,
    "a": -20.0440254211426,
    "b": -1.61375522613525,
    "C": 20.1088829040527,
    "h": 184.602981567383,
    "CMY_C": 0.60830104351044,
    "CMY_M": 0.39217263460159,
    "CMY_Y": 0.42810213565826,
    "CMYK_C": 0.35557532310486,
    "CMYK_M": 0,
    "CMYK_Y": 0.05911135673523,
    "CMYK_K": 0.39217263460159
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B607005",
    "Farbtonhilfsbezeichnung": "B60 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "175",
    "Bcolor": "171",
    "Y": 41,
    "L": 70.2499847412109,
    "a": -5.07776641845703,
    "b": -0.64887183904648,
    "C": 5.11905717849731,
    "h": 187.282180786133,
    "CMY_C": 0.3679746389389,
    "CMY_M": 0.31475472450256,
    "CMY_Y": 0.32786399126053,
    "CMYK_C": 0.07766549289227,
    "CMYK_M": 0,
    "CMYK_Y": 0.01913076639175,
    "CMYK_K": 0.31475472450256
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B607015",
    "Farbtonhilfsbezeichnung": "B60 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "179",
    "Bcolor": "171",
    "Y": 41,
    "L": 69.8257522583008,
    "a": -14.8426141738892,
    "b": -1.39106464385986,
    "C": 14.907657623291,
    "h": 185.354187011719,
    "CMY_C": 0.4579062461853,
    "CMY_M": 0.29912286996841,
    "CMY_Y": 0.32829385995865,
    "CMYK_C": 0.2265495210886,
    "CMYK_M": 0,
    "CMYK_Y": 0.04162069037557,
    "CMYK_K": 0.29912286996841
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B608010",
    "Farbtonhilfsbezeichnung": "B60 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "204",
    "Bcolor": "198",
    "Y": 57,
    "L": 79.9126815795898,
    "a": -9.85610961914063,
    "b": -0.94778829813004,
    "C": 9.90157604217529,
    "h": 185.492813110352,
    "CMY_C": 0.3064278960228,
    "CMY_M": 0.2005301117897,
    "CMY_Y": 0.22355580329895,
    "CMYK_C": 0.1324599981308,
    "CMYK_M": 0,
    "CMYK_Y": 0.02880119904876,
    "CMYK_K": 0.2005301117897
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B608505",
    "Farbtonhilfsbezeichnung": "B60 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "216",
    "Bcolor": "212",
    "Y": 66,
    "L": 85.092529296875,
    "a": -4.84917163848877,
    "b": -0.63468706607819,
    "C": 4.89053106307983,
    "h": 187.456817626953,
    "CMY_C": 0.2076068520546,
    "CMY_M": 0.15473431348801,
    "CMY_Y": 0.16899502277374,
    "CMYK_C": 0.06255138665438,
    "CMYK_M": 0,
    "CMYK_Y": 0.01687127351761,
    "CMYK_K": 0.15473431348801
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B613010",
    "Farbtonhilfsbezeichnung": "B61 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "75",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.0525245666504,
    "a": -10.1642255783081,
    "b": 0.16963455080986,
    "C": 10.1656408309937,
    "h": 179.043853759766,
    "CMY_C": 0.79477769136429,
    "CMY_M": 0.70446479320526,
    "CMY_Y": 0.72700095176697,
    "CMYK_C": 0.30559098720551,
    "CMYK_M": 0,
    "CMYK_Y": 0.07625541090965,
    "CMYK_K": 0.70446479320526
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B614005",
    "Farbtonhilfsbezeichnung": "B61 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "96",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.6509704589844,
    "a": -5.26012563705444,
    "b": 0.10487579554319,
    "C": 5.26117086410522,
    "h": 178.857788085938,
    "CMY_C": 0.67031729221344,
    "CMY_M": 0.62330067157745,
    "CMY_Y": 0.63802790641785,
    "CMYK_C": 0.12481206655502,
    "CMYK_M": 0,
    "CMYK_Y": 0.03909546509385,
    "CMYK_K": 0.62330067157745
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B614015",
    "Farbtonhilfsbezeichnung": "B61 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "101",
    "Bcolor": "93",
    "Y": 11,
    "L": 39.9112510681152,
    "a": -15.2014951705933,
    "b": 0.10400634258986,
    "C": 15.2018508911133,
    "h": 179.607986450195,
    "CMY_C": 0.74941194057465,
    "CMY_M": 0.60352051258087,
    "CMY_Y": 0.63665246963501,
    "CMYK_C": 0.36796715855598,
    "CMYK_M": 0,
    "CMYK_Y": 0.08356537669897,
    "CMYK_K": 0.60352051258087
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B614025",
    "Farbtonhilfsbezeichnung": "B61 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "104",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.6265563964844,
    "a": -25.3252696990967,
    "b": 0.18776640295982,
    "C": 25.3259658813477,
    "h": 179.575210571289,
    "CMY_C": 0.87564706802368,
    "CMY_M": 0.59100240468979,
    "CMY_Y": 0.64085924625397,
    "CMYK_C": 0.69595682621002,
    "CMYK_M": 0,
    "CMYK_Y": 0.12190008163452,
    "CMYK_K": 0.59100240468979
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B615010",
    "Farbtonhilfsbezeichnung": "B61 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "125",
    "Bcolor": "118",
    "Y": 18,
    "L": 50.3032264709473,
    "a": -10.3646965026856,
    "b": 0.21247458457947,
    "C": 10.3668737411499,
    "h": 178.825607299805,
    "CMY_C": 0.60826504230499,
    "CMY_M": 0.50988566875458,
    "CMY_Y": 0.53703153133392,
    "CMYK_C": 0.20072740316391,
    "CMYK_M": 0,
    "CMYK_Y": 0.05538679659367,
    "CMYK_K": 0.50988566875458
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B615020",
    "Farbtonhilfsbezeichnung": "B61 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "128",
    "Bcolor": "117",
    "Y": 18,
    "L": 49.9159202575684,
    "a": -20.0095958709717,
    "b": -0.05906172096729,
    "C": 20.0096836090088,
    "h": 180.169128417969,
    "CMY_C": 0.70158535242081,
    "CMY_M": 0.49684542417526,
    "CMY_Y": 0.54009860754013,
    "CMYK_C": 0.40691259503365,
    "CMYK_M": 0,
    "CMYK_Y": 0.08596400916576,
    "CMYK_K": 0.49684542417526
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B615330",
    "Farbtonhilfsbezeichnung": "B61 53 30 Kobaltgruen",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "141",
    "Bcolor": "126",
    "Y": 21,
    "L": 53.2764930725098,
    "a": -30.2039031982422,
    "b": -0.14648516476154,
    "C": 30.2042579650879,
    "h": 180.277877807617,
    "CMY_C": 0.79888844490051,
    "CMY_M": 0.44647163152695,
    "CMY_Y": 0.50746738910675,
    "CMYK_C": 0.63667345046997,
    "CMYK_M": 0,
    "CMYK_Y": 0.11019445955753,
    "CMYK_K": 0.44647163152695
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B616005",
    "Farbtonhilfsbezeichnung": "B61 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "147",
    "Bcolor": "143",
    "Y": 28,
    "L": 59.9120216369629,
    "a": -4.96317386627197,
    "b": -0.0323320440948,
    "C": 4.96327924728394,
    "h": 180.373229980469,
    "CMY_C": 0.47125393152237,
    "CMY_M": 0.42306625843048,
    "CMY_Y": 0.43884915113449,
    "CMYK_C": 0.08352375775576,
    "CMYK_M": 0,
    "CMYK_Y": 0.02735650911927,
    "CMYK_K": 0.42306625843048
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B616015",
    "Farbtonhilfsbezeichnung": "B61 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "153",
    "Bcolor": "143",
    "Y": 28,
    "L": 60.0483093261719,
    "a": -15.0983753204346,
    "b": -0.00459215929732,
    "C": 15.0983762741089,
    "h": 180.017425537109,
    "CMY_C": 0.55375266075134,
    "CMY_M": 0.40184485912323,
    "CMY_Y": 0.4388632774353,
    "CMYK_C": 0.25396054983139,
    "CMYK_M": 0,
    "CMYK_Y": 0.06188765540719,
    "CMYK_K": 0.40184485912323
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B616025",
    "Farbtonhilfsbezeichnung": "B61 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "157",
    "Bcolor": "143",
    "Y": 28,
    "L": 59.9745674133301,
    "a": -25.0475006103516,
    "b": -0.10927382856607,
    "C": 25.0477390289307,
    "h": 180.249969482422,
    "CMY_C": 0.65533936023712,
    "CMY_M": 0.38505548238754,
    "CMY_Y": 0.44001108407974,
    "CMYK_C": 0.43952563405037,
    "CMYK_M": 0,
    "CMYK_Y": 0.08936676383018,
    "CMYK_K": 0.38505548238754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B617005",
    "Farbtonhilfsbezeichnung": "B61 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "175",
    "Bcolor": "171",
    "Y": 41,
    "L": 70.362907409668,
    "a": -4.95770168304443,
    "b": -0.11847639083862,
    "C": 4.95911693572998,
    "h": 181.368957519531,
    "CMY_C": 0.36395198106766,
    "CMY_M": 0.31395691633224,
    "CMY_Y": 0.33038967847824,
    "CMYK_C": 0.07287452369928,
    "CMYK_M": 0,
    "CMYK_Y": 0.02395295910537,
    "CMYK_K": 0.31395691633224
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B617010",
    "Farbtonhilfsbezeichnung": "B61 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "177",
    "Bcolor": "170",
    "Y": 41,
    "L": 70.1022491455078,
    "a": -9.92489814758301,
    "b": -0.19813956320286,
    "C": 9.92687606811523,
    "h": 181.143692016602,
    "CMY_C": 0.40735077857971,
    "CMY_M": 0.30630558729172,
    "CMY_Y": 0.33318501710892,
    "CMYK_C": 0.14566239714622,
    "CMYK_M": 0,
    "CMYK_Y": 0.03874822705984,
    "CMYK_K": 0.30630558729172
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B617020",
    "Farbtonhilfsbezeichnung": "B61 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "181",
    "Bcolor": "168",
    "Y": 41,
    "L": 69.713752746582,
    "a": -19.7634601593018,
    "b": 0.07173200696707,
    "C": 19.7635898590088,
    "h": 179.792037963867,
    "CMY_C": 0.49856245517731,
    "CMY_M": 0.29131746292114,
    "CMY_Y": 0.34033536911011,
    "CMYK_C": 0.29243698716164,
    "CMYK_M": 0,
    "CMYK_Y": 0.06916765123606,
    "CMYK_K": 0.29131746292114
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B618005",
    "Farbtonhilfsbezeichnung": "B61 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "202",
    "Bcolor": "198",
    "Y": 57,
    "L": 80.3214874267578,
    "a": -4.95366096496582,
    "b": -0.10341566056013,
    "C": 4.95474052429199,
    "h": 181.19596862793,
    "CMY_C": 0.2581799030304,
    "CMY_M": 0.20692640542984,
    "CMY_Y": 0.22461354732513,
    "CMYK_C": 0.06462641060352,
    "CMYK_M": 0,
    "CMYK_Y": 0.02230201847851,
    "CMYK_K": 0.20692640542984
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B618015",
    "Farbtonhilfsbezeichnung": "B61 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "208",
    "Bcolor": "197",
    "Y": 57,
    "L": 80.3408737182617,
    "a": -15.1170463562012,
    "b": -0.07762947678566,
    "C": 15.1172456741333,
    "h": 180.294219970703,
    "CMY_C": 0.34446114301682,
    "CMY_M": 0.18515676259995,
    "CMY_Y": 0.22589218616486,
    "CMYK_C": 0.19550310075283,
    "CMYK_M": 0,
    "CMYK_Y": 0.0499917306006,
    "CMYK_K": 0.18515676259995
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B618505",
    "Farbtonhilfsbezeichnung": "B61 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "216",
    "Bcolor": "212",
    "Y": 66,
    "L": 85.3513793945313,
    "a": -4.9086332321167,
    "b": -0.09843404591084,
    "C": 4.90962028503418,
    "h": 181.148818969727,
    "CMY_C": 0.20331263542175,
    "CMY_M": 0.15189671516418,
    "CMY_Y": 0.17009657621384,
    "CMYK_C": 0.0606245957315,
    "CMYK_M": 0,
    "CMYK_Y": 0.02145948633552,
    "CMYK_K": 0.15189671516418
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B618510",
    "Farbtonhilfsbezeichnung": "B61 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "219",
    "Bcolor": "211",
    "Y": 66,
    "L": 85.329460144043,
    "a": -9.86167240142822,
    "b": -0.04380266368389,
    "C": 9.8617696762085,
    "h": 180.254486083984,
    "CMY_C": 0.24469602108002,
    "CMY_M": 0.14123976230621,
    "CMY_Y": 0.17138689756393,
    "CMYK_C": 0.1204716488719,
    "CMYK_M": 0,
    "CMYK_Y": 0.03510541468859,
    "CMYK_K": 0.14123976230621
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B619005",
    "Farbtonhilfsbezeichnung": "B61 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "230",
    "Bcolor": "225",
    "Y": 76,
    "L": 90.2396545410156,
    "a": -4.93033933639526,
    "b": -0.07859760522842,
    "C": 4.93096590042114,
    "h": 180.913314819336,
    "CMY_C": 0.14979547262192,
    "CMY_M": 0.09762191772461,
    "CMY_Y": 0.11658203601837,
    "CMYK_C": 0.05781784281135,
    "CMYK_M": 0,
    "CMYK_Y": 0.0210112798959,
    "CMYK_K": 0.09762191772461
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B624003",
    "Farbtonhilfsbezeichnung": "B62 40 03",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "95",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.6928634643555,
    "a": -2.62104535102844,
    "b": 0.3901053071022,
    "C": 2.6499171257019,
    "h": 171.534484863281,
    "CMY_C": 0.65014278888702,
    "CMY_M": 0.62798607349396,
    "CMY_Y": 0.63912987709045,
    "CMYK_C": 0.05955883488059,
    "CMYK_M": 0,
    "CMYK_Y": 0.02995534054935,
    "CMYK_K": 0.62798607349396
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B625003",
    "Farbtonhilfsbezeichnung": "B62 50 03",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "122",
    "Bcolor": "118",
    "Y": 18,
    "L": 50.4640502929688,
    "a": -2.83949160575867,
    "b": 0.35711693763733,
    "C": 2.86186051368713,
    "h": 172.831665039063,
    "CMY_C": 0.54825246334076,
    "CMY_M": 0.52292788028717,
    "CMY_Y": 0.53552138805389,
    "CMYK_C": 0.05308334156871,
    "CMYK_M": 0,
    "CMYK_Y": 0.02639749273658,
    "CMYK_K": 0.52292788028717
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B626003",
    "Farbtonhilfsbezeichnung": "B62 60 03",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "147",
    "Bcolor": "144",
    "Y": 28,
    "L": 60.4108963012695,
    "a": -2.86004018783569,
    "b": 0.24336466193199,
    "C": 2.87037563323975,
    "h": 175.136337280273,
    "CMY_C": 0.4492552280426,
    "CMY_M": 0.4224054813385,
    "CMY_Y": 0.43539816141129,
    "CMYK_C": 0.04648546129465,
    "CMYK_M": 0,
    "CMYK_Y": 0.02249446511269,
    "CMYK_K": 0.4224054813385
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B626030",
    "Farbtonhilfsbezeichnung": "B62 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "160",
    "Bcolor": "139",
    "Y": 28,
    "L": 60.3141059875488,
    "a": -30.0294170379639,
    "b": 2.68214511871338,
    "C": 30.1489601135254,
    "h": 174.896041870117,
    "CMY_C": 0.69539350271225,
    "CMY_M": 0.37398761510849,
    "CMY_Y": 0.45624804496765,
    "CMYK_C": 0.51341778039932,
    "CMYK_M": 0,
    "CMYK_Y": 0.1314038336277,
    "CMYK_K": 0.37398761510849
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B627003",
    "Farbtonhilfsbezeichnung": "B62 70 03",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "172",
    "Bcolor": "169",
    "Y": 41,
    "L": 69.8951416015625,
    "a": -2.68470811843872,
    "b": 0.12358040362597,
    "C": 2.68755078315735,
    "h": 177.364471435547,
    "CMY_C": 0.35027432441711,
    "CMY_M": 0.32389664649963,
    "CMY_Y": 0.33669811487198,
    "CMYK_C": 0.03901426866651,
    "CMYK_M": 0,
    "CMYK_Y": 0.01893418841064,
    "CMYK_K": 0.32389664649963
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B627025",
    "Farbtonhilfsbezeichnung": "B62 70 25",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "184",
    "Bcolor": "165",
    "Y": 41,
    "L": 70.0594100952148,
    "a": -25.1056632995606,
    "b": 2.11924839019775,
    "C": 25.1949501037598,
    "h": 175.174926757813,
    "CMY_C": 0.53890979290009,
    "CMY_M": 0.27838224172592,
    "CMY_Y": 0.35178422927856,
    "CMYK_C": 0.36103263497353,
    "CMYK_M": 0,
    "CMYK_Y": 0.10171865671873,
    "CMYK_K": 0.27838224172592
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B628003",
    "Farbtonhilfsbezeichnung": "B62 80 03",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "201",
    "Bcolor": "197",
    "Y": 57,
    "L": 80.1752624511719,
    "a": -2.94777154922485,
    "b": 0.14905889332294,
    "C": 2.95153784751892,
    "h": 177.105209350586,
    "CMY_C": 0.24281448125839,
    "CMY_M": 0.21306604146957,
    "CMY_Y": 0.22774583101273,
    "CMYK_C": 0.03780296817422,
    "CMYK_M": 0,
    "CMYK_Y": 0.01865441165864,
    "CMYK_K": 0.21306604146957
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B628020",
    "Farbtonhilfsbezeichnung": "B62 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "208",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.8027191162109,
    "a": -19.5201568603516,
    "b": 1.52583730220795,
    "C": 19.5797004699707,
    "h": 175.53044128418,
    "CMY_C": 0.38386768102646,
    "CMY_M": 0.1826975941658,
    "CMY_Y": 0.24382603168488,
    "CMYK_C": 0.24613910913467,
    "CMYK_M": 0,
    "CMYK_Y": 0.07479292154312,
    "CMYK_K": 0.1826975941658
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B628515",
    "Farbtonhilfsbezeichnung": "B62 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "220",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.8617401123047,
    "a": -14.9177894592285,
    "b": 1.11424326896667,
    "C": 14.9593439102173,
    "h": 175.728378295898,
    "CMY_C": 0.2893031835556,
    "CMY_M": 0.13603389263153,
    "CMY_Y": 0.18561065196991,
    "CMYK_C": 0.17740197479725,
    "CMYK_M": 0,
    "CMYK_Y": 0.05738275870681,
    "CMYK_K": 0.13603389263153
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B629003",
    "Farbtonhilfsbezeichnung": "B62 90 03",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "228",
    "Bcolor": "224",
    "Y": 76,
    "L": 89.9091567993164,
    "a": -2.85902762413025,
    "b": 0.15163923799992,
    "C": 2.86304616928101,
    "h": 176.963943481445,
    "CMY_C": 0.1357034444809,
    "CMY_M": 0.10612678527832,
    "CMY_Y": 0.12165099382401,
    "CMYK_C": 0.03308820351958,
    "CMYK_M": 0,
    "CMYK_Y": 0.01736734993756,
    "CMYK_K": 0.10612678527832
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B629010",
    "Farbtonhilfsbezeichnung": "B62 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "231",
    "Bcolor": "222",
    "Y": 76,
    "L": 89.6488571166992,
    "a": -9.79373741149902,
    "b": 0.83472400903702,
    "C": 9.82924461364746,
    "h": 175.128433227539,
    "CMY_C": 0.19366747140884,
    "CMY_M": 0.0936051607132,
    "CMY_Y": 0.13050192594528,
    "CMYK_C": 0.11039593815804,
    "CMYK_M": 0,
    "CMYK_Y": 0.040707167238,
    "CMYK_K": 0.0936051607132
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B629305",
    "Farbtonhilfsbezeichnung": "B62 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.0659713745117,
    "a": -5.13454341888428,
    "b": 0.36708432435989,
    "C": 5.14764881134033,
    "h": 175.910705566406,
    "CMY_C": 0.11855089664459,
    "CMY_M": 0.06563967466354,
    "CMY_Y": 0.08861684799194,
    "CMYK_C": 0.05662828311324,
    "CMYK_M": 0,
    "CMYK_Y": 0.02459134161472,
    "CMYK_K": 0.06563967466354
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B634020",
    "Farbtonhilfsbezeichnung": "B63 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "103",
    "Bcolor": "87",
    "Y": 11,
    "L": 39.9770011901855,
    "a": -20.1915245056152,
    "b": 3.51953220367432,
    "C": 20.4959697723389,
    "h": 170.112274169922,
    "CMY_C": 0.78165602684021,
    "CMY_M": 0.59578281641006,
    "CMY_Y": 0.65822583436966,
    "CMYK_C": 0.45983499288559,
    "CMYK_M": 0,
    "CMYK_Y": 0.15447887778282,
    "CMYK_K": 0.59578281641006
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B635030",
    "Farbtonhilfsbezeichnung": "B63 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "132",
    "Bcolor": "107",
    "Y": 18,
    "L": 49.7209396362305,
    "a": -30.3281116485596,
    "b": 5.50517702102661,
    "C": 30.8237133026123,
    "h": 169.711669921875,
    "CMY_C": 0.79566693305969,
    "CMY_M": 0.48398530483246,
    "CMY_Y": 0.57992047071457,
    "CMYK_C": 0.60401695966721,
    "CMYK_M": 0,
    "CMYK_Y": 0.18591557443142,
    "CMYK_K": 0.48398530483246
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B636010",
    "Farbtonhilfsbezeichnung": "B63 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "149",
    "Bcolor": "139",
    "Y": 28,
    "L": 59.8429527282715,
    "a": -9.34799289703369,
    "b": 1.88842368125916,
    "C": 9.53682899475098,
    "h": 168.579162597656,
    "CMY_C": 0.49965226650238,
    "CMY_M": 0.41542255878448,
    "CMY_Y": 0.4531654715538,
    "CMYK_C": 0.14408648014069,
    "CMYK_M": 0,
    "CMYK_Y": 0.06456443667412,
    "CMYK_K": 0.41542255878448
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B636025",
    "Farbtonhilfsbezeichnung": "B63 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "156",
    "Bcolor": "135",
    "Y": 28,
    "L": 60.0293426513672,
    "a": -24.5073375701904,
    "b": 4.62290859222412,
    "C": 24.9395446777344,
    "h": 169.317611694336,
    "CMY_C": 0.62336301803589,
    "CMY_M": 0.38647973537445,
    "CMY_Y": 0.47180199623108,
    "CMYK_C": 0.38610506057739,
    "CMYK_M": 0,
    "CMYK_Y": 0.13906998932362,
    "CMYK_K": 0.38647973537445
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B637020",
    "Farbtonhilfsbezeichnung": "B63 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "180",
    "Bcolor": "162",
    "Y": 41,
    "L": 69.6954956054688,
    "a": -19.7901744842529,
    "b": 3.45718884468079,
    "C": 20.0898761749268,
    "h": 170.090866088867,
    "CMY_C": 0.48370534181595,
    "CMY_M": 0.2922967672348,
    "CMY_Y": 0.36436450481415,
    "CMYK_C": 0.27046445012093,
    "CMYK_M": 0,
    "CMYK_Y": 0.10183327645063,
    "CMYK_K": 0.2922967672348
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B638015",
    "Farbtonhilfsbezeichnung": "B63 80 15",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "207",
    "Bcolor": "192",
    "Y": 57,
    "L": 80.1225204467773,
    "a": -15.1810874938965,
    "b": 2.69055223464966,
    "C": 15.4176683425903,
    "h": 169.949798583984,
    "CMY_C": 0.33594620227814,
    "CMY_M": 0.18814343214035,
    "CMY_Y": 0.24827408790588,
    "CMYK_C": 0.18205527961254,
    "CMYK_M": 0,
    "CMYK_Y": 0.07406561821699,
    "CMYK_K": 0.18814343214035
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B638510",
    "Farbtonhilfsbezeichnung": "B63 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "219",
    "Bcolor": "208",
    "Y": 66,
    "L": 85.2646942138672,
    "a": -9.74510478973389,
    "b": 1.59805274009705,
    "C": 9.87526416778564,
    "h": 170.687240600586,
    "CMY_C": 0.23810887336731,
    "CMY_M": 0.14265418052673,
    "CMY_Y": 0.18409252166748,
    "CMYK_C": 0.11133744567633,
    "CMYK_M": 0,
    "CMYK_Y": 0.04833328723907,
    "CMYK_K": 0.14265418052673
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B639005",
    "Farbtonhilfsbezeichnung": "B63 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 76,
    "L": 90.2363128662109,
    "a": -4.79876375198364,
    "b": 0.72900104522705,
    "C": 4.85382080078125,
    "h": 171.36198425293,
    "CMY_C": 0.14580941200256,
    "CMY_M": 0.09818637371063,
    "CMY_Y": 0.1225751042366,
    "CMYK_C": 0.05280807241797,
    "CMYK_M": 0,
    "CMYK_Y": 0.02704409137368,
    "CMYK_K": 0.09818637371063
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B644010",
    "Farbtonhilfsbezeichnung": "B64 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "99",
    "Bcolor": "89",
    "Y": 11,
    "L": 39.9297409057617,
    "a": -9.99120140075684,
    "b": 2.62116813659668,
    "C": 10.329309463501,
    "h": 165.299865722656,
    "CMY_C": 0.69487261772156,
    "CMY_M": 0.6126697063446,
    "CMY_Y": 0.6518394947052,
    "CMYK_C": 0.21222949028015,
    "CMYK_M": 0,
    "CMYK_Y": 0.10112761706114,
    "CMYK_K": 0.6126697063446
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B644020",
    "Farbtonhilfsbezeichnung": "B64 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "102",
    "Bcolor": "84",
    "Y": 11,
    "L": 39.8551177978516,
    "a": -19.2866287231445,
    "b": 5.23268604278564,
    "C": 19.9838695526123,
    "h": 164.820404052734,
    "CMY_C": 0.76553952693939,
    "CMY_M": 0.59869116544724,
    "CMY_Y": 0.67015218734741,
    "CMYK_C": 0.41576048731804,
    "CMYK_M": 0,
    "CMYK_Y": 0.17806988954544,
    "CMYK_K": 0.59869116544724
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B644030",
    "Farbtonhilfsbezeichnung": "B64 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "111",
    "Bcolor": "84",
    "Y": 11,
    "L": 41.9242057800293,
    "a": -28.5190753936768,
    "b": 7.92540740966797,
    "C": 29.5998268127441,
    "h": 164.469467163086,
    "CMY_C": 0.8379579782486,
    "CMY_M": 0.56543529033661,
    "CMY_Y": 0.66930603981018,
    "CMYK_C": 0.62711650133133,
    "CMYK_M": 0,
    "CMYK_Y": 0.23902250826359,
    "CMYK_K": 0.56543529033661
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B645005",
    "Farbtonhilfsbezeichnung": "B64 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "121",
    "Bcolor": "115",
    "Y": 18,
    "L": 49.8429756164551,
    "a": -5.08160257339478,
    "b": 1.42325389385223,
    "C": 5.2771520614624,
    "h": 164.353515625,
    "CMY_C": 0.56735551357269,
    "CMY_M": 0.52485972642899,
    "CMY_Y": 0.54887890815735,
    "CMYK_C": 0.08943840116262,
    "CMYK_M": 0,
    "CMYK_Y": 0.05055176839232,
    "CMYK_K": 0.52485972642899
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B645025",
    "Farbtonhilfsbezeichnung": "B64 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "131",
    "Bcolor": "107",
    "Y": 18,
    "L": 50.2746505737305,
    "a": -24.3750286102295,
    "b": 6.60947322845459,
    "C": 25.2552394866943,
    "h": 164.828628540039,
    "CMY_C": 0.71006548404694,
    "CMY_M": 0.48762565851212,
    "CMY_Y": 0.58124661445618,
    "CMYK_C": 0.43413537740707,
    "CMYK_M": 0,
    "CMYK_Y": 0.18271984159946,
    "CMYK_K": 0.48762565851212
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B645117",
    "Farbtonhilfsbezeichnung": "B64 51 17 Nicosia Gruen",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "130",
    "Bcolor": "114",
    "Y": 19,
    "L": 51.4711875915527,
    "a": -16.2942924499512,
    "b": 4.34828233718872,
    "C": 16.8645057678223,
    "h": 165.058288574219,
    "CMY_C": 0.63101434707642,
    "CMY_M": 0.48845422267914,
    "CMY_Y": 0.55367040634155,
    "CMYK_C": 0.27868497371674,
    "CMYK_M": 0,
    "CMYK_Y": 0.12748846411705,
    "CMYK_K": 0.48845422267914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B646010",
    "Farbtonhilfsbezeichnung": "B64 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "149",
    "Bcolor": "138",
    "Y": 28,
    "L": 59.756908416748,
    "a": -9.48124122619629,
    "b": 2.49658751487732,
    "C": 9.8044319152832,
    "h": 165.247817993164,
    "CMY_C": 0.49941056966782,
    "CMY_M": 0.41619551181793,
    "CMY_Y": 0.45819455385208,
    "CMYK_C": 0.14253926277161,
    "CMYK_M": 0,
    "CMYK_Y": 0.07194025069475,
    "CMYK_K": 0.41619551181793
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B646020",
    "Farbtonhilfsbezeichnung": "B64 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "154",
    "Bcolor": "134",
    "Y": 28,
    "L": 59.9024925231934,
    "a": -19.5061874389648,
    "b": 5.19418334960938,
    "C": 20.1859073638916,
    "h": 165.089065551758,
    "CMY_C": 0.57323729991913,
    "CMY_M": 0.39658635854721,
    "CMY_Y": 0.47638958692551,
    "CMYK_C": 0.29275265336037,
    "CMYK_M": 0,
    "CMYK_Y": 0.13225294649601,
    "CMYK_K": 0.39658635854721
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B647005",
    "Farbtonhilfsbezeichnung": "B64 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "174",
    "Bcolor": "168",
    "Y": 41,
    "L": 70.1216278076172,
    "a": -4.77352380752563,
    "b": 1.14802026748657,
    "C": 4.90963125228882,
    "h": 166.477325439453,
    "CMY_C": 0.3606088757515,
    "CMY_M": 0.31724482774734,
    "CMY_Y": 0.3417871594429,
    "CMYK_C": 0.06351332366467,
    "CMYK_M": 0,
    "CMYK_Y": 0.03594602271914,
    "CMYK_K": 0.31724482774734
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B647015",
    "Farbtonhilfsbezeichnung": "B64 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "178",
    "Bcolor": "162",
    "Y": 41,
    "L": 69.5964889526367,
    "a": -14.5802268981934,
    "b": 3.66713976860046,
    "C": 15.0343246459961,
    "h": 165.882110595703,
    "CMY_C": 0.43717849254608,
    "CMY_M": 0.30335777997971,
    "CMY_Y": 0.36621844768524,
    "CMYK_C": 0.19209389388561,
    "CMYK_M": 0,
    "CMYK_Y": 0.09023378789425,
    "CMYK_K": 0.30335777997971
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B648010",
    "Farbtonhilfsbezeichnung": "B64 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "200",
    "Bcolor": "188",
    "Y": 57,
    "L": 78.7471466064453,
    "a": -9.65761756896973,
    "b": 2.59919810295105,
    "C": 10.0012702941895,
    "h": 164.936645507813,
    "CMY_C": 0.30369651317596,
    "CMY_M": 0.21459800004959,
    "CMY_Y": 0.26160442829132,
    "CMYK_C": 0.11344319581985,
    "CMYK_M": 0,
    "CMYK_Y": 0.05985015258193,
    "CMYK_K": 0.21459800004959
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B648505",
    "Farbtonhilfsbezeichnung": "B64 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "216",
    "Bcolor": "209",
    "Y": 66,
    "L": 85.2068939208984,
    "a": -4.62846946716309,
    "b": 1.04482293128967,
    "C": 4.74493265151978,
    "h": 167.279357910156,
    "CMY_C": 0.19850289821625,
    "CMY_M": 0.15443730354309,
    "CMY_Y": 0.17999088764191,
    "CMYK_C": 0.05211392790079,
    "CMYK_M": 0,
    "CMYK_Y": 0.03022080287337,
    "CMYK_K": 0.15443730354309
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B654005",
    "Farbtonhilfsbezeichnung": "B65 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "98",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.5045585632324,
    "a": -4.75084781646729,
    "b": 1.845090508461,
    "C": 5.09655904769897,
    "h": 158.775283813477,
    "CMY_C": 0.65305089950562,
    "CMY_M": 0.61652195453644,
    "CMY_Y": 0.64094626903534,
    "CMYK_C": 0.09525693953037,
    "CMYK_M": 0,
    "CMYK_Y": 0.0636915564537,
    "CMYK_K": 0.61652195453644
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B654015",
    "Farbtonhilfsbezeichnung": "B65 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "101",
    "Bcolor": "85",
    "Y": 11,
    "L": 40.3026084899902,
    "a": -14.37562084198,
    "b": 5.19126272201538,
    "C": 15.2842302322388,
    "h": 160.144546508789,
    "CMY_C": 0.71751821041107,
    "CMY_M": 0.60217720270157,
    "CMY_Y": 0.66518235206604,
    "CMYK_C": 0.28993061184883,
    "CMYK_M": 0,
    "CMYK_Y": 0.15837490558624,
    "CMYK_K": 0.60217720270157
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B654025",
    "Farbtonhilfsbezeichnung": "B65 40 25",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "103",
    "Bcolor": "78",
    "Y": 11,
    "L": 39.6648864746094,
    "a": -23.2515602111816,
    "b": 8.53537178039551,
    "C": 24.7686824798584,
    "h": 159.842407226563,
    "CMY_C": 0.79249370098114,
    "CMY_M": 0.59523087739944,
    "CMY_Y": 0.69342935085297,
    "CMYK_C": 0.48734652996063,
    "CMYK_M": 0,
    "CMYK_Y": 0.24260365962982,
    "CMYK_K": 0.59523087739944
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B655005",
    "Farbtonhilfsbezeichnung": "B65 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "121",
    "Bcolor": "114",
    "Y": 18,
    "L": 49.8134918212891,
    "a": -4.8063006401062,
    "b": 1.86682295799255,
    "C": 5.15611791610718,
    "h": 158.773254394531,
    "CMY_C": 0.5641742348671,
    "CMY_M": 0.52580308914185,
    "CMY_Y": 0.55204713344574,
    "CMYK_C": 0.08091817051172,
    "CMYK_M": 0,
    "CMYK_Y": 0.05534419044852,
    "CMYK_K": 0.52580308914185
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B655010",
    "Farbtonhilfsbezeichnung": "B65 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "124",
    "Bcolor": "112",
    "Y": 18,
    "L": 50.0572853088379,
    "a": -9.80834865570068,
    "b": 3.71227526664734,
    "C": 10.487359046936,
    "h": 159.269287109375,
    "CMY_C": 0.59356892108917,
    "CMY_M": 0.51419341564178,
    "CMY_Y": 0.56243187189102,
    "CMYK_C": 0.16338911652565,
    "CMYK_M": 0,
    "CMYK_Y": 0.09929560124874,
    "CMYK_K": 0.51419341564178
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B655015",
    "Farbtonhilfsbezeichnung": "B65 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "125",
    "Bcolor": "108",
    "Y": 18,
    "L": 49.8231811523438,
    "a": -13.7877340316773,
    "b": 5.25804901123047,
    "C": 14.7563104629517,
    "h": 159.125289916992,
    "CMY_C": 0.62227076292038,
    "CMY_M": 0.50962215662003,
    "CMY_Y": 0.57538485527039,
    "CMYK_C": 0.22971796989441,
    "CMYK_M": 0,
    "CMYK_Y": 0.13410617411137,
    "CMYK_K": 0.50962215662003
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B655020",
    "Farbtonhilfsbezeichnung": "B65 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "127",
    "Bcolor": "105",
    "Y": 18,
    "L": 49.6042137145996,
    "a": -19.0442886352539,
    "b": 6.91733407974243,
    "C": 20.2616500854492,
    "h": 160.037780761719,
    "CMY_C": 0.66332745552063,
    "CMY_M": 0.50310730934143,
    "CMY_Y": 0.58910715579987,
    "CMYK_C": 0.32244417071342,
    "CMYK_M": 0,
    "CMYK_Y": 0.17307528853416,
    "CMYK_K": 0.50310730934143
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B656005",
    "Farbtonhilfsbezeichnung": "B65 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "147",
    "Bcolor": "140",
    "Y": 28,
    "L": 60.0848045349121,
    "a": -4.93802738189697,
    "b": 1.79847776889801,
    "C": 5.25534343719482,
    "h": 159.987884521484,
    "CMY_C": 0.46310895681381,
    "CMY_M": 0.42180895805359,
    "CMY_Y": 0.44955694675446,
    "CMYK_C": 0.07142967730761,
    "CMYK_M": 0,
    "CMYK_Y": 0.04799103736877,
    "CMYK_K": 0.42180895805359
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B656015",
    "Farbtonhilfsbezeichnung": "B65 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "153",
    "Bcolor": "135",
    "Y": 28,
    "L": 60.4635810852051,
    "a": -14.2383756637573,
    "b": 5.18156814575195,
    "C": 15.1518974304199,
    "h": 160.00276184082,
    "CMY_C": 0.52152997255325,
    "CMY_M": 0.40038084983826,
    "CMY_Y": 0.47001481056213,
    "CMYK_C": 0.20204345881939,
    "CMYK_M": 0,
    "CMYK_Y": 0.11613031476736,
    "CMYK_K": 0.40038084983826
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B657005",
    "Farbtonhilfsbezeichnung": "B65 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "174",
    "Bcolor": "167",
    "Y": 41,
    "L": 70.0540084838867,
    "a": -4.57310390472412,
    "b": 1.58611154556274,
    "C": 4.84035444259644,
    "h": 160.871673583984,
    "CMY_C": 0.3582569360733,
    "CMY_M": 0.3185065984726,
    "CMY_Y": 0.34554344415665,
    "CMYK_C": 0.05832827836275,
    "CMYK_M": 0,
    "CMYK_Y": 0.03967293724418,
    "CMYK_K": 0.3185065984726
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B657010",
    "Farbtonhilfsbezeichnung": "B65 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "177",
    "Bcolor": "164",
    "Y": 41,
    "L": 70.1768112182617,
    "a": -9.34664630889893,
    "b": 3.26344990730286,
    "C": 9.89999485015869,
    "h": 160.752975463867,
    "CMY_C": 0.38901090621948,
    "CMY_M": 0.30758756399155,
    "CMY_Y": 0.35667264461517,
    "CMYK_C": 0.11759370565414,
    "CMYK_M": 0,
    "CMYK_Y": 0.07088994979858,
    "CMYK_K": 0.30758756399155
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B658005",
    "Farbtonhilfsbezeichnung": "B65 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "202",
    "Bcolor": "194",
    "Y": 57,
    "L": 80.2086563110352,
    "a": -4.42712688446045,
    "b": 1.50368499755859,
    "C": 4.67552375793457,
    "h": 161.239807128906,
    "CMY_C": 0.24948084354401,
    "CMY_M": 0.20976197719574,
    "CMY_Y": 0.23735773563385,
    "CMYK_C": 0.0502619035542,
    "CMYK_M": 0,
    "CMYK_Y": 0.03492081910372,
    "CMYK_K": 0.20976197719574
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B658505",
    "Farbtonhilfsbezeichnung": "B65 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 66,
    "L": 85.1577529907227,
    "a": -4.527184009552,
    "b": 1.49364733695984,
    "C": 4.76721906661987,
    "h": 161.740798950195,
    "CMY_C": 0.19663470983505,
    "CMY_M": 0.15533059835434,
    "CMY_Y": 0.18379235267639,
    "CMYK_C": 0.04889973625541,
    "CMYK_M": 0,
    "CMYK_Y": 0.03369573131204,
    "CMYK_K": 0.15533059835434
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B666030",
    "Farbtonhilfsbezeichnung": "B66 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "157",
    "Bcolor": "120",
    "Y": 28,
    "L": 59.8739547729492,
    "a": -27.395040512085,
    "b": 12.4705934524536,
    "C": 30.0998992919922,
    "h": 155.524322509766,
    "CMY_C": 0.61845803260803,
    "CMY_M": 0.38493090867996,
    "CMY_Y": 0.52771335840225,
    "CMYK_C": 0.37967625260353,
    "CMYK_M": 0,
    "CMYK_Y": 0.23214051127434,
    "CMYK_K": 0.38493090867996
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B666817",
    "Farbtonhilfsbezeichnung": "B66 68 17 Malachit",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "173",
    "Bcolor": "151",
    "Y": 38,
    "L": 67.9654846191406,
    "a": -15.3199853897095,
    "b": 7.21165418624878,
    "C": 16.9325103759766,
    "h": 154.7919921875,
    "CMY_C": 0.44703483581543,
    "CMY_M": 0.3201003074646,
    "CMY_Y": 0.40804380178452,
    "CMYK_C": 0.1866959631443,
    "CMYK_M": 0,
    "CMYK_Y": 0.12934774160385,
    "CMYK_K": 0.3201003074646
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B668020",
    "Farbtonhilfsbezeichnung": "B66 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "209",
    "Bcolor": "181",
    "Y": 57,
    "L": 80.2675247192383,
    "a": -18.3202056884766,
    "b": 8.4764575958252,
    "C": 20.1861400604248,
    "h": 155.170791625977,
    "CMY_C": 0.33955323696136,
    "CMY_M": 0.18167388439178,
    "CMY_Y": 0.28907978534698,
    "CMYK_C": 0.19292962551117,
    "CMYK_M": 0,
    "CMYK_Y": 0.13125072419643,
    "CMYK_K": 0.18167388439178
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B668515",
    "Farbtonhilfsbezeichnung": "B66 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "220",
    "Bcolor": "199",
    "Y": 66,
    "L": 85.3011322021484,
    "a": -13.3598947525024,
    "b": 6.20821332931519,
    "C": 14.7318935394287,
    "h": 155.076171875,
    "CMY_C": 0.25119000673294,
    "CMY_M": 0.1357387304306,
    "CMY_Y": 0.21796226501465,
    "CMYK_C": 0.13358376920223,
    "CMYK_M": 0,
    "CMYK_Y": 0.09513735771179,
    "CMYK_K": 0.1357387304306
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B669010",
    "Farbtonhilfsbezeichnung": "B66 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "232",
    "Bcolor": "217",
    "Y": 76,
    "L": 90.2060546875,
    "a": -9.08322334289551,
    "b": 4.02839326858521,
    "C": 9.93644332885742,
    "h": 156.082794189453,
    "CMY_C": 0.16963630914688,
    "CMY_M": 0.0898055434227,
    "CMY_Y": 0.14792048931122,
    "CMYK_C": 0.08770737051964,
    "CMYK_M": 0,
    "CMYK_Y": 0.06384893506765,
    "CMYK_K": 0.0898055434227
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B669305",
    "Farbtonhilfsbezeichnung": "B66 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "238",
    "Bcolor": "229",
    "Y": 83,
    "L": 93.1098175048828,
    "a": -4.36595869064331,
    "b": 2.02795457839966,
    "C": 4.81395816802979,
    "h": 155.085494995117,
    "CMY_C": 0.10575807094574,
    "CMY_M": 0.06738156080246,
    "CMY_Y": 0.10039281845093,
    "CMYK_C": 0.04114920645952,
    "CMYK_M": 0,
    "CMYK_Y": 0.03539631515741,
    "CMYK_K": 0.06738156080246
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B674010",
    "Farbtonhilfsbezeichnung": "B67 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "99",
    "Bcolor": "86",
    "Y": 11,
    "L": 40.2533416748047,
    "a": -8.41351509094238,
    "b": 4.95512580871582,
    "C": 9.76424598693848,
    "h": 149.504104614258,
    "CMY_C": 0.67226886749268,
    "CMY_M": 0.61286318302155,
    "CMY_Y": 0.66342604160309,
    "CMYK_C": 0.15344880521297,
    "CMYK_M": 0,
    "CMYK_Y": 0.13060720264912,
    "CMYK_K": 0.61286318302155
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B675050",
    "Farbtonhilfsbezeichnung": "B67 50 50",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "136",
    "Bcolor": "75",
    "Y": 18,
    "L": 50.0828895568848,
    "a": -42.8508262634277,
    "b": 24.2473831176758,
    "C": 49.2354431152344,
    "h": 150.496398925781,
    "CMY_C": 0.86734557151794,
    "CMY_M": 0.46619302034378,
    "CMY_Y": 0.70547658205032,
    "CMYK_C": 0.75149363279343,
    "CMYK_M": 0,
    "CMYK_Y": 0.44825857877731,
    "CMYK_K": 0.46619302034378
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B676030",
    "Farbtonhilfsbezeichnung": "B67 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "158",
    "Bcolor": "117",
    "Y": 28,
    "L": 60.7723159790039,
    "a": -25.5043888092041,
    "b": 15.5536251068115,
    "C": 29.8728828430176,
    "h": 148.623443603516,
    "CMY_C": 0.57910537719727,
    "CMY_M": 0.37925171852112,
    "CMY_Y": 0.5399894118309,
    "CMYK_C": 0.32195603847504,
    "CMYK_M": 0,
    "CMYK_Y": 0.25894182920456,
    "CMYK_K": 0.37925171852112
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B676040",
    "Farbtonhilfsbezeichnung": "B67 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "160",
    "Bcolor": "106",
    "Y": 28,
    "L": 60.076774597168,
    "a": -34.7455062866211,
    "b": 20.459077835083,
    "C": 40.3215103149414,
    "h": 149.509292602539,
    "CMY_C": 0.65937471389771,
    "CMY_M": 0.3725660443306,
    "CMY_Y": 0.58249390125275,
    "CMYK_C": 0.45711371302605,
    "CMYK_M": 0,
    "CMYK_Y": 0.33458161354065,
    "CMYK_K": 0.3725660443306
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B677010",
    "Farbtonhilfsbezeichnung": "B67 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "176",
    "Bcolor": "162",
    "Y": 41,
    "L": 70.2309188842773,
    "a": -8.20301055908203,
    "b": 4.6878809928894,
    "C": 9.44804763793945,
    "h": 150.25276184082,
    "CMY_C": 0.37436866760254,
    "CMY_M": 0.30973619222641,
    "CMY_Y": 0.36598211526871,
    "CMYK_C": 0.0936344563961,
    "CMYK_M": 0,
    "CMYK_Y": 0.08148467540741,
    "CMYK_K": 0.30973619222641
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B677030",
    "Farbtonhilfsbezeichnung": "B67 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "184",
    "Bcolor": "142",
    "Y": 41,
    "L": 70.1545257568359,
    "a": -26.222074508667,
    "b": 15.2322387695313,
    "C": 30.3252086639404,
    "h": 149.84797668457,
    "CMY_C": 0.49120044708252,
    "CMY_M": 0.27826523780823,
    "CMY_Y": 0.44391280412674,
    "CMYK_C": 0.2950325012207,
    "CMYK_M": 0,
    "CMYK_Y": 0.22951307892799,
    "CMYK_K": 0.27826523780823
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B678020",
    "Farbtonhilfsbezeichnung": "B67 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "207",
    "Bcolor": "178",
    "Y": 57,
    "L": 79.9543151855469,
    "a": -17.517391204834,
    "b": 10.0228824615479,
    "C": 20.1821002960205,
    "h": 150.223205566406,
    "CMY_C": 0.33020758628845,
    "CMY_M": 0.18707424402237,
    "CMY_Y": 0.30351513624191,
    "CMYK_C": 0.1760718524456,
    "CMYK_M": 0,
    "CMYK_Y": 0.14323681592941,
    "CMYK_K": 0.18707424402237
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B678510",
    "Farbtonhilfsbezeichnung": "B67 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "217",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.1116638183594,
    "a": -8.57069873809814,
    "b": 4.8797869682312,
    "C": 9.86251449584961,
    "h": 150.344680786133,
    "CMY_C": 0.21807450056076,
    "CMY_M": 0.14776742458344,
    "CMY_Y": 0.20961290597916,
    "CMYK_C": 0.08249752223492,
    "CMYK_M": 0,
    "CMYK_Y": 0.07256878167391,
    "CMYK_K": 0.14776742458344
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B679005",
    "Farbtonhilfsbezeichnung": "B67 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "229",
    "Bcolor": "220",
    "Y": 76,
    "L": 90.1347579956055,
    "a": -4.22612380981445,
    "b": 2.34360480308533,
    "C": 4.83245325088501,
    "h": 150.989364624023,
    "CMY_C": 0.13653194904327,
    "CMY_M": 0.10107749700546,
    "CMY_Y": 0.13555818796158,
    "CMYK_C": 0.03944105654955,
    "CMYK_M": 0,
    "CMYK_Y": 0.0383578017354,
    "CMYK_K": 0.10107749700546
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B684010",
    "Farbtonhilfsbezeichnung": "B68 40 10 Russisch Gruen",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "98",
    "Bcolor": "83",
    "Y": 11,
    "L": 39.788257598877,
    "a": -8.48297023773193,
    "b": 6.02672433853149,
    "C": 10.405873298645,
    "h": 144.608123779297,
    "CMY_C": 0.67386031150818,
    "CMY_M": 0.61740946769714,
    "CMY_Y": 0.67453193664551,
    "CMYK_C": 0.14754898846149,
    "CMYK_M": 0,
    "CMYK_Y": 0.14930444955826,
    "CMYK_K": 0.61740946769714
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B684030",
    "Farbtonhilfsbezeichnung": "B68 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "105",
    "Bcolor": "66",
    "Y": 11,
    "L": 40.2652587890625,
    "a": -24.6668281555176,
    "b": 16.8412532806396,
    "C": 29.867712020874,
    "h": 145.676727294922,
    "CMY_C": 0.7671759724617,
    "CMY_M": 0.58867907524109,
    "CMY_Y": 0.74200522899628,
    "CMYK_C": 0.43396016955376,
    "CMYK_M": 0,
    "CMYK_Y": 0.37276527285576,
    "CMYK_K": 0.58867907524109
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B685005",
    "Farbtonhilfsbezeichnung": "B68 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "120",
    "Bcolor": "112",
    "Y": 18,
    "L": 49.7456321716309,
    "a": -4.07920837402344,
    "b": 2.98881578445435,
    "C": 5.05697154998779,
    "h": 143.769943237305,
    "CMY_C": 0.55602383613586,
    "CMY_M": 0.52818930149078,
    "CMY_Y": 0.55998849868774,
    "CMYK_C": 0.05899513140321,
    "CMYK_M": 0,
    "CMYK_Y": 0.06739821285009,
    "CMYK_K": 0.52818930149078
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B685020",
    "Farbtonhilfsbezeichnung": "B68 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "127",
    "Bcolor": "99",
    "Y": 18,
    "L": 50.3920936584473,
    "a": -16.4172401428223,
    "b": 11.5879831314087,
    "C": 20.0949535369873,
    "h": 144.783935546875,
    "CMY_C": 0.61671459674835,
    "CMY_M": 0.50058978796005,
    "CMY_Y": 0.6122682094574,
    "CMYK_C": 0.23252390325069,
    "CMYK_M": 0,
    "CMYK_Y": 0.22362062335014,
    "CMYK_K": 0.50058978796005
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B685040",
    "Farbtonhilfsbezeichnung": "B68 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "133",
    "Bcolor": "78",
    "Y": 18,
    "L": 50.1019287109375,
    "a": -32.9226455688477,
    "b": 23.1096000671387,
    "C": 40.2238006591797,
    "h": 144.93359375,
    "CMY_C": 0.73118555545807,
    "CMY_M": 0.47933346033096,
    "CMY_Y": 0.69576060771942,
    "CMYK_C": 0.48371091485023,
    "CMYK_M": 0,
    "CMYK_Y": 0.41567322611809,
    "CMYK_K": 0.47933346033096
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B686010",
    "Farbtonhilfsbezeichnung": "B68 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "148",
    "Bcolor": "133",
    "Y": 28,
    "L": 59.8414115905762,
    "a": -8.2848949432373,
    "b": 5.78027629852295,
    "C": 10.1020336151123,
    "h": 145.096954345703,
    "CMY_C": 0.47811353206635,
    "CMY_M": 0.41847693920135,
    "CMY_Y": 0.47958081960678,
    "CMYK_C": 0.10255241394043,
    "CMYK_M": 0,
    "CMYK_Y": 0.10507559031248,
    "CMYK_K": 0.41847693920135
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B686030",
    "Farbtonhilfsbezeichnung": "B68 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "156",
    "Bcolor": "112",
    "Y": 28,
    "L": 60.1271629333496,
    "a": -24.6419868469238,
    "b": 17.4394454956055,
    "C": 30.1887683868408,
    "h": 144.712478637695,
    "CMY_C": 0.57112371921539,
    "CMY_M": 0.38780736923218,
    "CMY_Y": 0.55933517217636,
    "CMYK_C": 0.29944226145744,
    "CMYK_M": 0,
    "CMYK_Y": 0.28018599748611,
    "CMYK_K": 0.38780736923218
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B687005",
    "Farbtonhilfsbezeichnung": "B68 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "173",
    "Bcolor": "165",
    "Y": 41,
    "L": 70.0448684692383,
    "a": -3.89489388465881,
    "b": 2.67396187782288,
    "C": 4.72443342208862,
    "h": 145.529235839844,
    "CMY_C": 0.34948068857193,
    "CMY_M": 0.32035040855408,
    "CMY_Y": 0.353187084198,
    "CMYK_C": 0.0428607352078,
    "CMYK_M": 0,
    "CMYK_Y": 0.04831412434578,
    "CMYK_K": 0.32035040855408
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B687020",
    "Farbtonhilfsbezeichnung": "B68 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "180",
    "Bcolor": "149",
    "Y": 41,
    "L": 70.1211547851563,
    "a": -16.6106071472168,
    "b": 11.4546852111816,
    "C": 20.177267074585,
    "h": 145.409820556641,
    "CMY_C": 0.42077720165253,
    "CMY_M": 0.29561603069305,
    "CMY_Y": 0.41603344678879,
    "CMYK_C": 0.17768883705139,
    "CMYK_M": 0,
    "CMYK_Y": 0.17095422744751,
    "CMYK_K": 0.29561603069305
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B688010",
    "Farbtonhilfsbezeichnung": "B68 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "203",
    "Bcolor": "187",
    "Y": 57,
    "L": 80.0804824829102,
    "a": -7.94479179382324,
    "b": 5.39927768707275,
    "C": 9.60582733154297,
    "h": 145.799987792969,
    "CMY_C": 0.26558238267899,
    "CMY_M": 0.20446610450745,
    "CMY_Y": 0.26734584569931,
    "CMYK_C": 0.07682422548532,
    "CMYK_M": 0,
    "CMYK_Y": 0.0790409296751,
    "CMYK_K": 0.20446610450745
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B688505",
    "Farbtonhilfsbezeichnung": "B68 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "215",
    "Bcolor": "206",
    "Y": 66,
    "L": 85.1185913085938,
    "a": -3.82485032081604,
    "b": 2.54427528381348,
    "C": 4.59378004074097,
    "h": 146.368301391602,
    "CMY_C": 0.18779057264328,
    "CMY_M": 0.15763753652573,
    "CMY_Y": 0.19180017709732,
    "CMYK_C": 0.03579579666257,
    "CMYK_M": 0,
    "CMYK_Y": 0.04055574908853,
    "CMYK_K": 0.15763753652573
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B689305",
    "Farbtonhilfsbezeichnung": "B68 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "238",
    "Bcolor": "228",
    "Y": 83,
    "L": 93.1154556274414,
    "a": -4.10803508758545,
    "b": 2.87133121490479,
    "C": 5.01203489303589,
    "h": 145.048187255859,
    "CMY_C": 0.10063594579697,
    "CMY_M": 0.0681483745575,
    "CMY_Y": 0.1065759062767,
    "CMYK_C": 0.03486346080899,
    "CMYK_M": 0,
    "CMYK_Y": 0.04123782366514,
    "CMYK_K": 0.0681483745575
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B693010",
    "Farbtonhilfsbezeichnung": "B69 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "75",
    "Bcolor": "62",
    "Y": 6,
    "L": 30.4993858337402,
    "a": -7.26177310943604,
    "b": 6.11611557006836,
    "C": 9.49422073364258,
    "h": 139.894760131836,
    "CMY_C": 0.74972349405289,
    "CMY_M": 0.70638751983643,
    "CMY_Y": 0.7586418390274,
    "CMYK_C": 0.14759582281113,
    "CMYK_M": 0,
    "CMYK_Y": 0.17797036468983,
    "CMYK_K": 0.70638751983643
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B694005",
    "Farbtonhilfsbezeichnung": "B69 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "96",
    "Bcolor": "87",
    "Y": 11,
    "L": 39.8828277587891,
    "a": -4.25872945785522,
    "b": 3.74238252639771,
    "C": 5.66940927505493,
    "h": 138.692428588867,
    "CMY_C": 0.64974439144135,
    "CMY_M": 0.62380683422089,
    "CMY_Y": 0.65868330001831,
    "CMYK_C": 0.06894744187593,
    "CMYK_M": 0,
    "CMYK_Y": 0.09270893037319,
    "CMYK_K": 0.62380683422089
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B694020",
    "Farbtonhilfsbezeichnung": "B69 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "103",
    "Bcolor": "73",
    "Y": 11,
    "L": 40.8722229003906,
    "a": -15.6900320053101,
    "b": 13.3126707077026,
    "C": 20.576789855957,
    "h": 139.686080932617,
    "CMY_C": 0.69635254144669,
    "CMY_M": 0.59601885080338,
    "CMY_Y": 0.71220070123672,
    "CMYK_C": 0.24836230278015,
    "CMYK_M": 0,
    "CMYK_Y": 0.28759226202965,
    "CMYK_K": 0.59601885080338
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B695010",
    "Farbtonhilfsbezeichnung": "B69 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "124",
    "Bcolor": "108",
    "Y": 18,
    "L": 50.591480255127,
    "a": -8.08984279632568,
    "b": 6.92593145370483,
    "C": 10.6496047973633,
    "h": 139.432281494141,
    "CMY_C": 0.56505918502808,
    "CMY_M": 0.51283156871796,
    "CMY_Y": 0.5782665014267,
    "CMYK_C": 0.10720648616552,
    "CMYK_M": 0,
    "CMYK_Y": 0.13431686162949,
    "CMYK_K": 0.51283156871796
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B695030",
    "Farbtonhilfsbezeichnung": "B69 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "131",
    "Bcolor": "85",
    "Y": 18,
    "L": 50.6201057434082,
    "a": -23.7604084014893,
    "b": 19.7178421020508,
    "C": 30.876371383667,
    "h": 140.312026977539,
    "CMY_C": 0.65018910169601,
    "CMY_M": 0.48746252059937,
    "CMY_Y": 0.66605186462402,
    "CMYK_C": 0.31749206781387,
    "CMYK_M": 0,
    "CMYK_Y": 0.34844154119492,
    "CMYK_K": 0.48746252059937
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B695040",
    "Farbtonhilfsbezeichnung": "B69 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "132",
    "Bcolor": "74",
    "Y": 18,
    "L": 50.267032623291,
    "a": -30.724063873291,
    "b": 25.6352844238281,
    "C": 40.0141944885254,
    "h": 140.15934753418,
    "CMY_C": 0.69845509529114,
    "CMY_M": 0.48120158910751,
    "CMY_Y": 0.71158617734909,
    "CMYK_C": 0.41876286268234,
    "CMYK_M": 0,
    "CMYK_Y": 0.44407343864441,
    "CMYK_K": 0.48120158910751
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B696005",
    "Farbtonhilfsbezeichnung": "B69 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "147",
    "Bcolor": "138",
    "Y": 28,
    "L": 60.1154098510742,
    "a": -3.79975414276123,
    "b": 3.15598106384277,
    "C": 4.93946838378906,
    "h": 140.287826538086,
    "CMY_C": 0.44986468553543,
    "CMY_M": 0.42420083284378,
    "CMY_Y": 0.45834761857986,
    "CMYK_C": 0.04457084089518,
    "CMYK_M": 0,
    "CMYK_Y": 0.05930329114199,
    "CMYK_K": 0.42420083284378
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B696010",
    "Farbtonhilfsbezeichnung": "B69 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "149",
    "Bcolor": "133",
    "Y": 28,
    "L": 60.3235626220703,
    "a": -7.358717918396,
    "b": 6.47268295288086,
    "C": 9.80032444000244,
    "h": 138.665344238281,
    "CMY_C": 0.46400570869446,
    "CMY_M": 0.41553431749344,
    "CMY_Y": 0.4793553352356,
    "CMYK_C": 0.08293282985687,
    "CMYK_M": 0,
    "CMYK_Y": 0.10919549316168,
    "CMYK_K": 0.41553431749344
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B696020",
    "Farbtonhilfsbezeichnung": "B69 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "151",
    "Bcolor": "119",
    "Y": 28,
    "L": 59.5852737426758,
    "a": -15.7153644561768,
    "b": 13.0506753921509,
    "C": 20.4277458190918,
    "h": 140.292388916016,
    "CMY_C": 0.51579034328461,
    "CMY_M": 0.40841281414032,
    "CMY_Y": 0.53295415639877,
    "CMYK_C": 0.18150752782822,
    "CMYK_M": 0,
    "CMYK_Y": 0.21052068471909,
    "CMYK_K": 0.40841281414032
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B696040",
    "Farbtonhilfsbezeichnung": "B69 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "159",
    "Bcolor": "97",
    "Y": 28,
    "L": 60.3941230773926,
    "a": -31.1659393310547,
    "b": 25.9422569274902,
    "C": 40.5501708984375,
    "h": 140.226303100586,
    "CMY_C": 0.59976494312286,
    "CMY_M": 0.37569105625153,
    "CMY_Y": 0.61785960197449,
    "CMYK_C": 0.35891506075859,
    "CMYK_M": 0,
    "CMYK_Y": 0.38789856433868,
    "CMYK_K": 0.37569105625153
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B696515",
    "Farbtonhilfsbezeichnung": "B69 65 15",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "163",
    "Bcolor": "139",
    "Y": 34,
    "L": 64.810676574707,
    "a": -11.4664621353149,
    "b": 9.50573062896729,
    "C": 14.8942499160767,
    "h": 140.341171264648,
    "CMY_C": 0.44033938646317,
    "CMY_M": 0.36140668392181,
    "CMY_Y": 0.45567154884338,
    "CMYK_C": 0.12360402196646,
    "CMYK_M": 0,
    "CMYK_Y": 0.14761330187321,
    "CMYK_K": 0.36140668392181
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B697005",
    "Farbtonhilfsbezeichnung": "B69 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "172",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.535888671875,
    "a": -3.80112671852112,
    "b": 3.08988499641418,
    "C": 4.89856672286987,
    "h": 140.892807006836,
    "CMY_C": 0.35274255275726,
    "CMY_M": 0.32604271173477,
    "CMY_Y": 0.36138999462128,
    "CMYK_C": 0.03961651772261,
    "CMYK_M": 0,
    "CMYK_Y": 0.05244736373425,
    "CMYK_K": 0.32604271173477
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B697010",
    "Farbtonhilfsbezeichnung": "B69 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "175",
    "Bcolor": "159",
    "Y": 41,
    "L": 70.216796875,
    "a": -7.34265947341919,
    "b": 6.14063596725464,
    "C": 9.57194137573242,
    "h": 140.094390869141,
    "CMY_C": 0.36297529935837,
    "CMY_M": 0.31204277276993,
    "CMY_Y": 0.37623810768127,
    "CMYK_C": 0.07403443753719,
    "CMYK_M": 0,
    "CMYK_Y": 0.09331297129393,
    "CMYK_K": 0.31204277276993
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B697030",
    "Farbtonhilfsbezeichnung": "B69 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "182",
    "Bcolor": "134",
    "Y": 41,
    "L": 70.0899200439453,
    "a": -23.4270267486572,
    "b": 19.4535999298096,
    "C": 30.451078414917,
    "h": 140.294052124023,
    "CMY_C": 0.45226889848709,
    "CMY_M": 0.28480213880539,
    "CMY_Y": 0.47435599565506,
    "CMYK_C": 0.23415444791317,
    "CMYK_M": 0,
    "CMYK_Y": 0.26503694057465,
    "CMYK_K": 0.28480213880539
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B697040",
    "Farbtonhilfsbezeichnung": "B69 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "186",
    "Bcolor": "123",
    "Y": 41,
    "L": 70.2509307861328,
    "a": -30.4019432067871,
    "b": 25.4191188812256,
    "C": 39.6283950805664,
    "h": 140.100952148438,
    "CMY_C": 0.49301248788834,
    "CMY_M": 0.27182060480118,
    "CMY_Y": 0.51700234413147,
    "CMYK_C": 0.30376014113426,
    "CMYK_M": 0,
    "CMYK_Y": 0.33670511841774,
    "CMYK_K": 0.27182060480118
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B698005",
    "Farbtonhilfsbezeichnung": "B69 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "192",
    "Y": 57,
    "L": 80.1171035766602,
    "a": -3.587233543396,
    "b": 2.95866274833679,
    "C": 4.64993858337402,
    "h": 140.48503112793,
    "CMY_C": 0.23887431621552,
    "CMY_M": 0.21302449703217,
    "CMY_Y": 0.24872696399689,
    "CMYK_C": 0.03284704312682,
    "CMYK_M": 0,
    "CMYK_Y": 0.04536668211222,
    "CMYK_K": 0.21302449703217
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B698020",
    "Farbtonhilfsbezeichnung": "B69 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "207",
    "Bcolor": "173",
    "Y": 57,
    "L": 80.2222671508789,
    "a": -15.8727788925171,
    "b": 13.1048717498779,
    "C": 20.5835552215576,
    "h": 140.456268310547,
    "CMY_C": 0.30283737182617,
    "CMY_M": 0.18815618753433,
    "CMY_Y": 0.32285767793655,
    "CMYK_C": 0.14126016199589,
    "CMYK_M": 0,
    "CMYK_Y": 0.16592045128345,
    "CMYK_K": 0.18815618753433
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B698505",
    "Farbtonhilfsbezeichnung": "B69 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "214",
    "Bcolor": "205",
    "Y": 66,
    "L": 85.012565612793,
    "a": -3.74791717529297,
    "b": 3.05317664146423,
    "C": 4.83412551879883,
    "h": 140.832611083984,
    "CMY_C": 0.18660432100296,
    "CMY_M": 0.15911775827408,
    "CMY_Y": 0.19665902853012,
    "CMYK_C": 0.03268776834011,
    "CMYK_M": 0,
    "CMYK_Y": 0.0446450971067,
    "CMYK_K": 0.15911775827408
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B698510",
    "Farbtonhilfsbezeichnung": "B69 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "216",
    "Bcolor": "198",
    "Y": 66,
    "L": 84.9421005249023,
    "a": -7.51269578933716,
    "b": 6.29109954833984,
    "C": 9.79890441894531,
    "h": 140.057327270508,
    "CMY_C": 0.2064933180809,
    "CMY_M": 0.15232586860657,
    "CMY_Y": 0.22162634134293,
    "CMYK_C": 0.06390126794577,
    "CMYK_M": 0,
    "CMYK_Y": 0.08175367116928,
    "CMYK_K": 0.15232586860657
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B699005",
    "Farbtonhilfsbezeichnung": "B69 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "229",
    "Bcolor": "219",
    "Y": 76,
    "L": 90.0667266845703,
    "a": -3.94143342971802,
    "b": 3.07405281066895,
    "C": 4.99846935272217,
    "h": 142.04817199707,
    "CMY_C": 0.13245779275894,
    "CMY_M": 0.10268998146057,
    "CMY_Y": 0.14166897535324,
    "CMYK_C": 0.03317449986935,
    "CMYK_M": 0,
    "CMYK_Y": 0.0434398278594,
    "CMYK_K": 0.10268998146057
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B699305",
    "Farbtonhilfsbezeichnung": "B69 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 83,
    "L": 93.1161956787109,
    "a": -3.94443964958191,
    "b": 3.22891330718994,
    "C": 5.09749794006348,
    "h": 140.6962890625,
    "CMY_C": 0.09806251525879,
    "CMY_M": 0.06861752271652,
    "CMY_Y": 0.10920822620392,
    "CMYK_C": 0.03161428496242,
    "CMYK_M": 0,
    "CMYK_Y": 0.04358113184571,
    "CMYK_K": 0.06861752271652
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B704020",
    "Farbtonhilfsbezeichnung": "B70 40 20 Chromoxidgruen",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "100",
    "Bcolor": "70",
    "Y": 11,
    "L": 39.9712448120117,
    "a": -14.1485548019409,
    "b": 14.3371801376343,
    "C": 20.1428985595703,
    "h": 134.62060546875,
    "CMY_C": 0.69029819965363,
    "CMY_M": 0.60742217302322,
    "CMY_Y": 0.72677266597748,
    "CMYK_C": 0.21110725402832,
    "CMYK_M": 0,
    "CMYK_Y": 0.30401739478111,
    "CMYK_K": 0.60742217302322
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B706050",
    "Farbtonhilfsbezeichnung": "B70 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "160",
    "Bcolor": "78",
    "Y": 28,
    "L": 60.0384979248047,
    "a": -35.3616371154785,
    "b": 35.637752532959,
    "C": 50.2045288085938,
    "h": 134.77717590332,
    "CMY_C": 0.6139988899231,
    "CMY_M": 0.37421274185181,
    "CMY_Y": 0.69360911846161,
    "CMYK_C": 0.38317519426346,
    "CMYK_M": 0,
    "CMYK_Y": 0.51039129495621,
    "CMYK_K": 0.37421274185181
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B707040",
    "Farbtonhilfsbezeichnung": "B70 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "184",
    "Bcolor": "117",
    "Y": 41,
    "L": 70.0781936645508,
    "a": -28.3491764068604,
    "b": 28.5650234222412,
    "C": 40.2447052001953,
    "h": 134.782699584961,
    "CMY_C": 0.46701562404633,
    "CMY_M": 0.27775412797928,
    "CMY_Y": 0.54141652584076,
    "CMYK_C": 0.26204580068588,
    "CMYK_M": 0,
    "CMYK_Y": 0.36505904793739,
    "CMYK_K": 0.27775412797928
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B708030",
    "Farbtonhilfsbezeichnung": "B70 80 30",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "209",
    "Bcolor": "157",
    "Y": 57,
    "L": 80.1549377441406,
    "a": -21.4250907897949,
    "b": 21.2568435668945,
    "C": 30.1809196472168,
    "h": 135.225845336914,
    "CMY_C": 0.32373929023743,
    "CMY_M": 0.1795939207077,
    "CMY_Y": 0.38406020402908,
    "CMYK_C": 0.17570002377033,
    "CMYK_M": 0,
    "CMYK_Y": 0.24922570586205,
    "CMYK_K": 0.1795939207077
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B708520",
    "Farbtonhilfsbezeichnung": "B70 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "219",
    "Bcolor": "184",
    "Y": 66,
    "L": 84.96533203125,
    "a": -14.1984224319458,
    "b": 14.0257558822632,
    "C": 19.9578819274902,
    "h": 135.350509643555,
    "CMY_C": 0.23497384786606,
    "CMY_M": 0.13958013057709,
    "CMY_Y": 0.27912622690201,
    "CMYK_C": 0.1108687967062,
    "CMYK_M": 0,
    "CMYK_Y": 0.1621837168932,
    "CMYK_K": 0.13958013057709
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B709010",
    "Farbtonhilfsbezeichnung": "B70 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "231",
    "Bcolor": "212",
    "Y": 76,
    "L": 90.1586990356445,
    "a": -7.12399864196777,
    "b": 6.99264144897461,
    "C": 9.98240375518799,
    "h": 135.533126831055,
    "CMY_C": 0.14375895261765,
    "CMY_M": 0.09547972679138,
    "CMY_Y": 0.17012596130371,
    "CMYK_C": 0.05337550491095,
    "CMYK_M": 0,
    "CMYK_Y": 0.08252577483654,
    "CMYK_K": 0.09547972679138
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B713611",
    "Farbtonhilfsbezeichnung": "B71 36 11 Vagone Gruen",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "88",
    "Bcolor": "71",
    "Y": 9,
    "L": 36.3439750671387,
    "a": -7.01294469833374,
    "b": 8.50174236297607,
    "C": 11.0209350585938,
    "h": 129.518646240234,
    "CMY_C": 0.68859601020813,
    "CMY_M": 0.65315008163452,
    "CMY_Y": 0.72133100032806,
    "CMYK_C": 0.10219384729862,
    "CMYK_M": 0,
    "CMYK_Y": 0.19657181203365,
    "CMYK_K": 0.65315008163452
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B714020",
    "Farbtonhilfsbezeichnung": "B71 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "101",
    "Bcolor": "69",
    "Y": 11,
    "L": 40.646598815918,
    "a": -13.133885383606,
    "b": 15.9825382232666,
    "C": 20.6867218017578,
    "h": 129.412155151367,
    "CMY_C": 0.67241847515106,
    "CMY_M": 0.602892100811,
    "CMY_Y": 0.73121321201324,
    "CMYK_C": 0.17508181929588,
    "CMYK_M": 0,
    "CMYK_Y": 0.32313916087151,
    "CMYK_K": 0.602892100811
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B715010",
    "Farbtonhilfsbezeichnung": "B71 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "123",
    "Bcolor": "105",
    "Y": 18,
    "L": 50.403621673584,
    "a": -6.45637321472168,
    "b": 8.0191822052002,
    "C": 10.2952432632446,
    "h": 128.838104248047,
    "CMY_C": 0.55185216665268,
    "CMY_M": 0.51809632778168,
    "CMY_Y": 0.58709108829498,
    "CMYK_C": 0.0700468569994,
    "CMYK_M": 0,
    "CMYK_Y": 0.14317126572132,
    "CMYK_K": 0.51809632778168
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B716040",
    "Farbtonhilfsbezeichnung": "B71 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "156",
    "Bcolor": "89",
    "Y": 28,
    "L": 60.2982597351074,
    "a": -25.555534362793,
    "b": 30.5761566162109,
    "C": 39.849552154541,
    "h": 129.888854980469,
    "CMY_C": 0.53908383846283,
    "CMY_M": 0.38658660650253,
    "CMY_Y": 0.65132832527161,
    "CMYK_C": 0.24860434234142,
    "CMYK_M": 0,
    "CMYK_Y": 0.43158775568008,
    "CMYK_K": 0.38658660650253
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B717020",
    "Farbtonhilfsbezeichnung": "B71 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "178",
    "Bcolor": "142",
    "Y": 41,
    "L": 70.3002319335938,
    "a": -12.7868728637695,
    "b": 15.3647661209106,
    "C": 19.989501953125,
    "h": 129.767929077148,
    "CMY_C": 0.37600177526474,
    "CMY_M": 0.30206769704819,
    "CMY_Y": 0.44138586521149,
    "CMYK_C": 0.10593302547932,
    "CMYK_M": 0,
    "CMYK_Y": 0.19961558282375,
    "CMYK_K": 0.30206769704819
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B717030",
    "Farbtonhilfsbezeichnung": "B71 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "179",
    "Bcolor": "126",
    "Y": 41,
    "L": 69.7025299072266,
    "a": -19.2045001983643,
    "b": 23.1567993164063,
    "C": 30.0840511322021,
    "h": 129.66975402832,
    "CMY_C": 0.41054916381836,
    "CMY_M": 0.29746514558792,
    "CMY_Y": 0.50420165061951,
    "CMYK_C": 0.16096571087837,
    "CMYK_M": 0,
    "CMYK_Y": 0.29427224397659,
    "CMYK_K": 0.29746514558792
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B718020",
    "Farbtonhilfsbezeichnung": "B71 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "204",
    "Bcolor": "167",
    "Y": 57,
    "L": 79.8550567626953,
    "a": -13.0601320266724,
    "b": 15.7441244125366,
    "C": 20.4559154510498,
    "h": 129.676528930664,
    "CMY_C": 0.2756569981575,
    "CMY_M": 0.19853681325912,
    "CMY_Y": 0.34550505876541,
    "CMYK_C": 0.09622424095869,
    "CMYK_M": 0,
    "CMYK_Y": 0.18337491154671,
    "CMYK_K": 0.19853681325912
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B718510",
    "Farbtonhilfsbezeichnung": "B71 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "216",
    "Bcolor": "197",
    "Y": 66,
    "L": 84.9970092773438,
    "a": -6.21444177627563,
    "b": 7.34568643569946,
    "C": 9.62176704406738,
    "h": 130.231170654297,
    "CMY_C": 0.1920548081398,
    "CMY_M": 0.15486794710159,
    "CMY_Y": 0.22856819629669,
    "CMYK_C": 0.04400124400854,
    "CMYK_M": 0,
    "CMYK_Y": 0.08720560371876,
    "CMYK_K": 0.15486794710159
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B719005",
    "Farbtonhilfsbezeichnung": "B71 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "228",
    "Bcolor": "218",
    "Y": 76,
    "L": 90.11669921875,
    "a": -3.20450496673584,
    "b": 3.7153627872467,
    "C": 4.90640115737915,
    "h": 130.777816772461,
    "CMY_C": 0.12382376194,
    "CMY_M": 0.10400694608688,
    "CMY_Y": 0.14576011896133,
    "CMYK_C": 0.0221171528101,
    "CMYK_M": 0,
    "CMYK_Y": 0.04659988358617,
    "CMYK_K": 0.10400694608688
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B719020",
    "Farbtonhilfsbezeichnung": "B71 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "232",
    "Bcolor": "196",
    "Y": 76,
    "L": 89.6898574829102,
    "a": -12.5207691192627,
    "b": 14.5604448318481,
    "C": 19.2035465240479,
    "h": 130.692794799805,
    "CMY_C": 0.16794329881668,
    "CMY_M": 0.09070551395416,
    "CMY_Y": 0.23221457004547,
    "CMYK_C": 0.08494254201651,
    "CMYK_M": 0,
    "CMYK_Y": 0.15562510490417,
    "CMYK_K": 0.09070551395416
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B723503",
    "Farbtonhilfsbezeichnung": "B72 35 03",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "83",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.9611930847168,
    "a": -1.88519358634949,
    "b": 2.81678581237793,
    "C": 3.38943028450012,
    "h": 123.793258666992,
    "CMY_C": 0.68216156959534,
    "CMY_M": 0.6743791103363,
    "CMY_Y": 0.69790613651276,
    "CMYK_C": 0.02390036918223,
    "CMYK_M": 0,
    "CMYK_Y": 0.07225281745195,
    "CMYK_K": 0.6743791103363
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B724010",
    "Farbtonhilfsbezeichnung": "B72 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "96",
    "Bcolor": "79",
    "Y": 11,
    "L": 39.7297554016113,
    "a": -5.79634809494019,
    "b": 8.40845203399658,
    "C": 10.2127237319946,
    "h": 124.580352783203,
    "CMY_C": 0.64897394180298,
    "CMY_M": 0.62334650754929,
    "CMY_Y": 0.68982517719269,
    "CMYK_C": 0.06803981214762,
    "CMYK_M": 0,
    "CMYK_Y": 0.17649821937084,
    "CMYK_K": 0.62334650754929
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B724503",
    "Farbtonhilfsbezeichnung": "B72 45 03",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "106",
    "Bcolor": "100",
    "Y": 15,
    "L": 44.4952812194824,
    "a": -1.90419483184814,
    "b": 2.87847423553467,
    "C": 3.4513144493103,
    "h": 123.485801696777,
    "CMY_C": 0.59205681085587,
    "CMY_M": 0.58393770456314,
    "CMY_Y": 0.60949516296387,
    "CMYK_C": 0.01951416023076,
    "CMYK_M": 0,
    "CMYK_Y": 0.06142700091004,
    "CMYK_K": 0.58393770456314
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B725005",
    "Farbtonhilfsbezeichnung": "B72 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "120",
    "Bcolor": "110",
    "Y": 18,
    "L": 49.9374313354492,
    "a": -3.20217895507813,
    "b": 4.51619911193848,
    "C": 5.53624439239502,
    "h": 125.338272094727,
    "CMY_C": 0.54333794116974,
    "CMY_M": 0.52841186523438,
    "CMY_Y": 0.56805539131165,
    "CMYK_C": 0.03165065869689,
    "CMYK_M": 0,
    "CMYK_Y": 0.08406387269497,
    "CMYK_K": 0.52841186523438
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B725020",
    "Farbtonhilfsbezeichnung": "B72 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "125",
    "Bcolor": "90",
    "Y": 18,
    "L": 50.2445526123047,
    "a": -11.5835866928101,
    "b": 16.5345115661621,
    "C": 20.1883525848389,
    "h": 125.013938903809,
    "CMY_C": 0.56756794452667,
    "CMY_M": 0.51162016391754,
    "CMY_Y": 0.64608359336853,
    "CMYK_C": 0.11455792188644,
    "CMYK_M": 0,
    "CMYK_Y": 0.27532550692558,
    "CMYK_K": 0.51162016391754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B725040",
    "Farbtonhilfsbezeichnung": "B72 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "131",
    "Bcolor": "63",
    "Y": 18,
    "L": 50.9083442687988,
    "a": -23.3001499176025,
    "b": 32.4939498901367,
    "C": 39.9844207763672,
    "h": 125.64282989502,
    "CMY_C": 0.6115939617157,
    "CMY_M": 0.48706078529358,
    "CMY_Y": 0.75373041629791,
    "CMYK_C": 0.24278350174427,
    "CMYK_M": 0,
    "CMYK_Y": 0.51988542079926,
    "CMYK_K": 0.48706078529358
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B725415",
    "Farbtonhilfsbezeichnung": "B72 54 15 Verde Veronese",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "134",
    "Bcolor": "108",
    "Y": 22,
    "L": 54.5129051208496,
    "a": -8.82751560211182,
    "b": 12.5984954833984,
    "C": 15.3833389282227,
    "h": 125.018173217773,
    "CMY_C": 0.51560151576996,
    "CMY_M": 0.47323262691498,
    "CMY_Y": 0.5783942937851,
    "CMYK_C": 0.08043187856674,
    "CMYK_M": 0,
    "CMYK_Y": 0.1996358782053,
    "CMYK_K": 0.47323262691498
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B725503",
    "Farbtonhilfsbezeichnung": "B72 55 03",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "133",
    "Bcolor": "126",
    "Y": 23,
    "L": 55.1109809875488,
    "a": -1.80271255970001,
    "b": 2.71005082130432,
    "C": 3.25486516952515,
    "h": 123.631652832031,
    "CMY_C": 0.48727715015411,
    "CMY_M": 0.47918450832367,
    "CMY_Y": 0.50515311956406,
    "CMYK_C": 0.01553840469569,
    "CMYK_M": 0,
    "CMYK_Y": 0.0498614422977,
    "CMYK_K": 0.47918450832367
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B726010",
    "Farbtonhilfsbezeichnung": "B72 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "146",
    "Bcolor": "128",
    "Y": 28,
    "L": 59.5737075805664,
    "a": -5.75771570205688,
    "b": 8.29203414916992,
    "C": 10.0950050354004,
    "h": 124.774841308594,
    "CMY_C": 0.45428842306137,
    "CMY_M": 0.42691642045975,
    "CMY_Y": 0.49905014038086,
    "CMYK_C": 0.0477626696229,
    "CMYK_M": 0,
    "CMYK_Y": 0.12586945295334,
    "CMYK_K": 0.42691642045975
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B726030",
    "Farbtonhilfsbezeichnung": "B72 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "151",
    "Bcolor": "99",
    "Y": 28,
    "L": 59.6154518127441,
    "a": -17.257740020752,
    "b": 24.4082069396973,
    "C": 29.8929786682129,
    "h": 125.262092590332,
    "CMY_C": 0.4962585568428,
    "CMY_M": 0.40732526779175,
    "CMY_Y": 0.61201703548431,
    "CMYK_C": 0.15005412697792,
    "CMYK_M": 0,
    "CMYK_Y": 0.34536948800087,
    "CMYK_K": 0.40732526779175
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B726503",
    "Farbtonhilfsbezeichnung": "B72 65 03",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "159",
    "Bcolor": "151",
    "Y": 34,
    "L": 65.0126037597656,
    "a": -1.72104096412659,
    "b": 2.83953285217285,
    "C": 3.3203809261322,
    "h": 121.220054626465,
    "CMY_C": 0.38511252403259,
    "CMY_M": 0.3779354095459,
    "CMY_Y": 0.40608215332031,
    "CMYK_C": 0.01153757143766,
    "CMYK_M": 0,
    "CMYK_Y": 0.04524730145931,
    "CMYK_K": 0.3779354095459
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B727005",
    "Farbtonhilfsbezeichnung": "B72 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "172",
    "Bcolor": "162",
    "Y": 41,
    "L": 69.8776626586914,
    "a": -2.75466728210449,
    "b": 3.92580723762512,
    "C": 4.79584741592407,
    "h": 125.056640625,
    "CMY_C": 0.33855026960373,
    "CMY_M": 0.32492417097092,
    "CMY_Y": 0.36356115341187,
    "CMYK_C": 0.02018454484642,
    "CMYK_M": 0,
    "CMYK_Y": 0.05723354592919,
    "CMYK_K": 0.32492417097092
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B727020",
    "Farbtonhilfsbezeichnung": "B72 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "176",
    "Bcolor": "139",
    "Y": 41,
    "L": 69.8849105834961,
    "a": -11.712911605835,
    "b": 16.5826511383057,
    "C": 20.3021335601807,
    "h": 125.234909057617,
    "CMY_C": 0.36864227056503,
    "CMY_M": 0.30890047550201,
    "CMY_Y": 0.45409512519836,
    "CMYK_C": 0.08644456416368,
    "CMYK_M": 0,
    "CMYK_Y": 0.21009224653244,
    "CMYK_K": 0.30890047550201
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B727503",
    "Farbtonhilfsbezeichnung": "B72 75 03",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "185",
    "Bcolor": "178",
    "Y": 48,
    "L": 74.9285583496094,
    "a": -1.89351987838745,
    "b": 2.69700622558594,
    "C": 3.29533910751343,
    "h": 125.072006225586,
    "CMY_C": 0.28238660097122,
    "CMY_M": 0.27276194095612,
    "CMY_Y": 0.30183076858521,
    "CMYK_C": 0.01323453802615,
    "CMYK_M": 0,
    "CMYK_Y": 0.03997154161334,
    "CMYK_K": 0.27276194095612
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B728010",
    "Farbtonhilfsbezeichnung": "B72 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "182",
    "Y": 57,
    "L": 79.9796600341797,
    "a": -5.65682744979858,
    "b": 7.99234628677368,
    "C": 9.7916955947876,
    "h": 125.29012298584,
    "CMY_C": 0.24015730619431,
    "CMY_M": 0.2112141251564,
    "CMY_Y": 0.28684228658676,
    "CMYK_C": 0.03669333085418,
    "CMYK_M": 0,
    "CMYK_Y": 0.09587920457125,
    "CMYK_K": 0.2112141251564
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B728503",
    "Farbtonhilfsbezeichnung": "B72 85 03",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "213",
    "Bcolor": "206",
    "Y": 66,
    "L": 85.0394287109375,
    "a": -1.70737361907959,
    "b": 2.4436252117157,
    "C": 2.98101139068604,
    "h": 124.942207336426,
    "CMY_C": 0.17228192090988,
    "CMY_M": 0.16332715749741,
    "CMY_Y": 0.19163179397583,
    "CMYK_C": 0.01070282515138,
    "CMYK_M": 0,
    "CMYK_Y": 0.03382999449968,
    "CMYK_K": 0.16332715749741
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B728505",
    "Farbtonhilfsbezeichnung": "B72 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "214",
    "Bcolor": "203",
    "Y": 66,
    "L": 85.0390777587891,
    "a": -2.78376507759094,
    "b": 3.98716115951538,
    "C": 4.86279773712158,
    "h": 124.922058105469,
    "CMY_C": 0.17559254169464,
    "CMY_M": 0.1612753868103,
    "CMY_Y": 0.20306158065796,
    "CMYK_C": 0.01707015000284,
    "CMYK_M": 0,
    "CMYK_Y": 0.04982111230493,
    "CMYK_K": 0.1612753868103
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "B729305",
    "Farbtonhilfsbezeichnung": "B72 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "237",
    "Bcolor": "225",
    "Y": 83,
    "L": 93.0806503295898,
    "a": -2.90216064453125,
    "b": 4.16687774658203,
    "C": 5.0779333114624,
    "h": 124.856567382813,
    "CMY_C": 0.08688944578171,
    "CMY_M": 0.07169812917709,
    "CMY_Y": 0.11643916368484,
    "CMYK_C": 0.01636463031173,
    "CMYK_M": 0,
    "CMYK_Y": 0.04819664359093,
    "CMYK_K": 0.07169812917709
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N002500",
    "Farbtonhilfsbezeichnung": "N00 25 00",
    "Farbtonklasse": "02",
    "Rcolor": "58",
    "Gcolor": "58",
    "Bcolor": "57",
    "Y": 4,
    "L": 24.3454818725586,
    "a": 0.05373349785805,
    "b": 0.0717748478055,
    "C": 0.0896600112319,
    "h": 53.1800155639648,
    "CMY_C": 0.77265596389771,
    "CMY_M": 0.77312642335892,
    "CMY_Y": 0.77562570571899,
    "CMYK_C": 0,
    "CMYK_M": 0.00206937245093,
    "CMYK_Y": 0.01306276582181,
    "CMYK_K": 0.77265596389771
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N003000",
    "Farbtonhilfsbezeichnung": "N00 30 00",
    "Farbtonklasse": "02",
    "Rcolor": "70",
    "Gcolor": "70",
    "Bcolor": "69",
    "Y": 6,
    "L": 29.661527633667,
    "a": -0.09747288376093,
    "b": 0.2272941917181,
    "C": 0.24731278419495,
    "h": 113.211601257324,
    "CMY_C": 0.72601926326752,
    "CMY_M": 0.72569036483765,
    "CMY_Y": 0.72976911067963,
    "CMYK_C": 0.00119900424033,
    "CMYK_M": 0,
    "CMYK_Y": 0.01486913114786,
    "CMYK_K": 0.72569036483765
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N003500",
    "Farbtonhilfsbezeichnung": "N00 35 00",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "82",
    "Bcolor": "81",
    "Y": 8,
    "L": 34.7090110778809,
    "a": -0.10233941674232,
    "b": 0.24779239296913,
    "C": 0.26809406280518,
    "h": 112.440856933594,
    "CMY_C": 0.67992466688156,
    "CMY_M": 0.6795859336853,
    "CMY_Y": 0.68419629335403,
    "CMYK_C": 0.00105717335828,
    "CMYK_M": 0,
    "CMYK_Y": 0.0143887558952,
    "CMYK_K": 0.6795859336853
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N004000",
    "Farbtonhilfsbezeichnung": "N00 40 00",
    "Farbtonklasse": "01",
    "Rcolor": "94",
    "Gcolor": "94",
    "Bcolor": "93",
    "Y": 11,
    "L": 39.812915802002,
    "a": -0.10565260797739,
    "b": 0.17634229362011,
    "C": 0.2055701315403,
    "h": 120.92724609375,
    "CMY_C": 0.63239061832428,
    "CMY_M": 0.63176453113556,
    "CMY_Y": 0.63636410236359,
    "CMYK_C": 0.0017002359964,
    "CMYK_M": 0,
    "CMYK_Y": 0.01249084249139,
    "CMYK_K": 0.63176453113556
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N004500",
    "Farbtonhilfsbezeichnung": "N00 45 00",
    "Farbtonklasse": "01",
    "Rcolor": "106",
    "Gcolor": "107",
    "Bcolor": "105",
    "Y": 15,
    "L": 45.0318717956543,
    "a": -0.15001858770847,
    "b": 0.23615789413452,
    "C": 0.27977871894836,
    "h": 122.425636291504,
    "CMY_C": 0.58253782987595,
    "CMY_M": 0.58166933059692,
    "CMY_Y": 0.58715569972992,
    "CMYK_C": 0.0020761070773,
    "CMYK_M": 0,
    "CMYK_Y": 0.01311491057277,
    "CMYK_K": 0.58166933059692
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N005000",
    "Farbtonhilfsbezeichnung": "N00 50 00",
    "Farbtonklasse": "01",
    "Rcolor": "119",
    "Gcolor": "119",
    "Bcolor": "118",
    "Y": 18,
    "L": 49.9814300537109,
    "a": -0.08759627491236,
    "b": 0.24434451758862,
    "C": 0.25957146286964,
    "h": 109.722503662109,
    "CMY_C": 0.53367602825165,
    "CMY_M": 0.53336364030838,
    "CMY_Y": 0.53917682170868,
    "CMYK_C": 0.00066944619175,
    "CMYK_M": 0,
    "CMYK_Y": 0.01245762594044,
    "CMYK_K": 0.53336364030838
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N005500",
    "Farbtonhilfsbezeichnung": "N00 55 00",
    "Farbtonklasse": "01",
    "Rcolor": "132",
    "Gcolor": "132",
    "Bcolor": "130",
    "Y": 23,
    "L": 55.0331268310547,
    "a": -0.08756612241268,
    "b": 0.12012768536806,
    "C": 0.14865559339523,
    "h": 126.089881896973,
    "CMY_C": 0.48371154069901,
    "CMY_M": 0.48295015096664,
    "CMY_Y": 0.48839151859283,
    "CMYK_C": 0.00147256546188,
    "CMYK_M": 0,
    "CMYK_Y": 0.01052387431264,
    "CMYK_K": 0.48295015096664
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N006000",
    "Farbtonhilfsbezeichnung": "N00 60 00",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "145",
    "Bcolor": "144",
    "Y": 28,
    "L": 60.1501731872559,
    "a": -0.04714835807681,
    "b": 0.17218673229218,
    "C": 0.17852517962456,
    "h": 105.313438415527,
    "CMY_C": 0.43133568763733,
    "CMY_M": 0.43109631538391,
    "CMY_Y": 0.43720805644989,
    "CMYK_C": 0.00042076059617,
    "CMYK_M": 0,
    "CMYK_Y": 0.01074301544577,
    "CMYK_K": 0.43109631538391
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N006500",
    "Farbtonhilfsbezeichnung": "N00 65 00",
    "Farbtonklasse": "01",
    "Rcolor": "157",
    "Gcolor": "157",
    "Bcolor": "156",
    "Y": 34,
    "L": 64.841423034668,
    "a": -0.01099728047848,
    "b": -0.0150994528085,
    "C": 0.01867976598442,
    "h": 233.933288574219,
    "CMY_C": 0.38329309225082,
    "CMY_M": 0.3827206492424,
    "CMY_Y": 0.38790237903595,
    "CMYK_C": 0.00092736457009,
    "CMYK_M": 0,
    "CMYK_Y": 0.00839446485043,
    "CMYK_K": 0.3827206492424
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N007000",
    "Farbtonhilfsbezeichnung": "N00 70 00",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "171",
    "Bcolor": "169",
    "Y": 41,
    "L": 69.8418579101563,
    "a": 0.0134881362319,
    "b": -0.09308625012636,
    "C": 0.09405838698149,
    "h": 278.244750976563,
    "CMY_C": 0.33102536201477,
    "CMY_M": 0.33038067817688,
    "CMY_Y": 0.33538752794266,
    "CMYK_C": 0.00096276169643,
    "CMYK_M": 0,
    "CMYK_Y": 0.0074771582149,
    "CMYK_K": 0.33038067817688
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N007500",
    "Farbtonhilfsbezeichnung": "N00 75 00",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "184",
    "Bcolor": "182",
    "Y": 48,
    "L": 74.7173538208008,
    "a": 0.12324989587069,
    "b": 0.04727186262608,
    "C": 0.13200441002846,
    "h": 20.984058380127,
    "CMY_C": 0.27795380353928,
    "CMY_M": 0.27886462211609,
    "CMY_Y": 0.28496098518372,
    "CMYK_C": 0,
    "CMYK_M": 0.00126144092064,
    "CMYK_Y": 0.0097046168521,
    "CMYK_K": 0.27795380353928
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N008000",
    "Farbtonhilfsbezeichnung": "N00 80 00",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "200",
    "Bcolor": "198",
    "Y": 57,
    "L": 80.4612274169922,
    "a": 0.17850425839424,
    "b": -0.20691825449467,
    "C": 0.27327448129654,
    "h": 310.78369140625,
    "CMY_C": 0.21647417545319,
    "CMY_M": 0.21699631214142,
    "CMY_Y": 0.22167986631393,
    "CMYK_C": 0,
    "CMYK_M": 0.0006663937238,
    "CMYK_Y": 0.00664392998442,
    "CMYK_K": 0.21647417545319
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N008500",
    "Farbtonhilfsbezeichnung": "N00 85 00",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "212",
    "Bcolor": "211",
    "Y": 66,
    "L": 84.9453964233398,
    "a": 0.17586569488049,
    "b": -0.13373740017414,
    "C": 0.22093988955021,
    "h": 322.748748779297,
    "CMY_C": 0.16727221012115,
    "CMY_M": 0.1680194735527,
    "CMY_Y": 0.17358440160751,
    "CMYK_C": 0,
    "CMYK_M": 0.00089736818336,
    "CMYK_Y": 0.0075801378116,
    "CMYK_K": 0.16727221012115
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N009000",
    "Farbtonhilfsbezeichnung": "N00 90 00",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "225",
    "Y": 76,
    "L": 89.9610977172852,
    "a": -0.09151265770197,
    "b": -0.12433294206858,
    "C": 0.1543802022934,
    "h": 233.645858764648,
    "CMY_C": 0.11393058300018,
    "CMY_M": 0.11194288730621,
    "CMY_Y": 0.11866110563278,
    "CMYK_C": 0.00223825220019,
    "CMYK_M": 0,
    "CMYK_Y": 0.00756507460028,
    "CMYK_K": 0.11194288730621
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N009300",
    "Farbtonhilfsbezeichnung": "N00 93 00",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "232",
    "Y": 83,
    "L": 92.7981948852539,
    "a": 0.01697519980371,
    "b": 0.18406911194324,
    "C": 0.1848502010107,
    "h": 84.7309722900391,
    "CMY_C": 0.08036279678345,
    "CMY_M": 0.08062946796417,
    "CMY_Y": 0.08952105045319,
    "CMYK_C": 0,
    "CMYK_M": 0.00028997432673,
    "CMYK_Y": 0.00995855033398,
    "CMYK_K": 0.08036279678345
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "N009500",
    "Farbtonhilfsbezeichnung": "N00 95 00",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "237",
    "Y": 88,
    "L": 94.5006256103516,
    "a": -0.04289653524756,
    "b": 0.00289683672599,
    "C": 0.04299423843622,
    "h": 176.136627197266,
    "CMY_C": 0.06238389015198,
    "CMY_M": 0.06133705377579,
    "CMY_Y": 0.06923478841782,
    "CMYK_C": 0.0011152420193,
    "CMYK_M": 0,
    "CMYK_Y": 0.00841381307691,
    "CMYK_K": 0.06133705377579
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R173010",
    "Farbtonhilfsbezeichnung": "R17 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "66",
    "Bcolor": "60",
    "Y": 6,
    "L": 29.9021244049072,
    "a": 7.44786310195923,
    "b": 6.51011323928833,
    "C": 9.89202880859375,
    "h": 41.1564292907715,
    "CMY_C": 0.6649277806282,
    "CMY_M": 0.74048566818237,
    "CMY_Y": 0.76430052518845,
    "CMYK_C": 0,
    "CMYK_M": 0.22549732029438,
    "CMYK_Y": 0.29657113552094,
    "CMYK_K": 0.6649277806282
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R173120",
    "Farbtonhilfsbezeichnung": "R17 31 20",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "64",
    "Bcolor": "54",
    "Y": 7,
    "L": 31.3233318328857,
    "a": 15.0446138381958,
    "b": 12.8030586242676,
    "C": 19.7549667358398,
    "h": 40.3979873657227,
    "CMY_C": 0.60107362270355,
    "CMY_M": 0.74731409549713,
    "CMY_Y": 0.78869688510895,
    "CMYK_C": 0,
    "CMYK_M": 0.36658510565758,
    "CMYK_Y": 0.47032052278519,
    "CMYK_K": 0.60107362270355
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R173429",
    "Farbtonhilfsbezeichnung": "R17 34 29 Eisenoxidrot",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "66",
    "Bcolor": "53",
    "Y": 8,
    "L": 34.4769172668457,
    "a": 22.7087802886963,
    "b": 18.2667675018311,
    "C": 29.1438407897949,
    "h": 38.8129272460938,
    "CMY_C": 0.52389842271805,
    "CMY_M": 0.74132770299911,
    "CMY_Y": 0.79355841875076,
    "CMYK_C": 0,
    "CMYK_M": 0.4566867351532,
    "CMYK_Y": 0.56639170646667,
    "CMYK_K": 0.52389842271805
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R173515",
    "Farbtonhilfsbezeichnung": "R17 35 15",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "75",
    "Bcolor": "66",
    "Y": 8,
    "L": 34.6771202087402,
    "a": 11.387734413147,
    "b": 9.74445533752441,
    "C": 14.9878253936768,
    "h": 40.5535202026367,
    "CMY_C": 0.59148609638214,
    "CMY_M": 0.70704507827759,
    "CMY_Y": 0.74125909805298,
    "CMYK_C": 0,
    "CMYK_M": 0.28287649154663,
    "CMYK_Y": 0.36662888526917,
    "CMYK_K": 0.59148609638214
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R173838",
    "Farbtonhilfsbezeichnung": "R17 38 38 Terra Di Siena Gebrannt",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "68",
    "Bcolor": "51",
    "Y": 10,
    "L": 38.1303329467773,
    "a": 30.0367259979248,
    "b": 24.4501476287842,
    "C": 38.7300224304199,
    "h": 39.145881652832,
    "CMY_C": 0.4427490234375,
    "CMY_M": 0.73244285583496,
    "CMY_Y": 0.79932349920273,
    "CMYK_C": 0,
    "CMYK_M": 0.51986241340637,
    "CMYK_Y": 0.63988131284714,
    "CMYK_K": 0.4427490234375
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174005",
    "Farbtonhilfsbezeichnung": "R17 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "93",
    "Bcolor": "89",
    "Y": 11,
    "L": 40.275520324707,
    "a": 3.64663100242615,
    "b": 3.39210057258606,
    "C": 4.98038816452026,
    "h": 42.9290046691895,
    "CMY_C": 0.59492743015289,
    "CMY_M": 0.63594114780426,
    "CMY_Y": 0.65181791782379,
    "CMYK_C": 0,
    "CMYK_M": 0.10125029832125,
    "CMYK_Y": 0.14044517278671,
    "CMYK_K": 0.59492743015289
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174013",
    "Farbtonhilfsbezeichnung": "R17 40 13",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "88",
    "Bcolor": "80",
    "Y": 11,
    "L": 39.6819686889648,
    "a": 9.63878917694092,
    "b": 8.31713962554932,
    "C": 12.7311067581177,
    "h": 40.7903251647949,
    "CMY_C": 0.55411899089813,
    "CMY_M": 0.65611088275909,
    "CMY_Y": 0.68747055530548,
    "CMYK_C": 0,
    "CMYK_M": 0.22874240577221,
    "CMYK_Y": 0.29907432198524,
    "CMYK_K": 0.55411899089813
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174020",
    "Farbtonhilfsbezeichnung": "R17 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "85",
    "Bcolor": "73",
    "Y": 11,
    "L": 40.1347389221191,
    "a": 15.4559545516968,
    "b": 13.1128730773926,
    "C": 20.2690391540527,
    "h": 40.3113632202148,
    "CMY_C": 0.50891506671906,
    "CMY_M": 0.66731017827988,
    "CMY_Y": 0.71263861656189,
    "CMYK_C": 0,
    "CMYK_M": 0.3225411772728,
    "CMYK_Y": 0.41484382748604,
    "CMYK_K": 0.50891506671906
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174040",
    "Farbtonhilfsbezeichnung": "R17 40 40",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "74",
    "Bcolor": "54",
    "Y": 11,
    "L": 40.609016418457,
    "a": 30.7268199920654,
    "b": 26.082799911499,
    "C": 40.3044662475586,
    "h": 40.3266296386719,
    "CMY_C": 0.41038274765015,
    "CMY_M": 0.71153962612152,
    "CMY_Y": 0.78815680742264,
    "CMYK_C": 0,
    "CMYK_M": 0.51076674461365,
    "CMYK_Y": 0.64071065187454,
    "CMYK_K": 0.41038274765015
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174236",
    "Farbtonhilfsbezeichnung": "R17 42 36 Pompejanisch Rot",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "80",
    "Bcolor": "61",
    "Y": 13,
    "L": 42.0385627746582,
    "a": 27.9928569793701,
    "b": 23.6890697479248,
    "C": 36.6711349487305,
    "h": 40.2397041320801,
    "CMY_C": 0.41029042005539,
    "CMY_M": 0.68812012672424,
    "CMY_Y": 0.76066726446152,
    "CMYK_C": 0,
    "CMYK_M": 0.47112971544266,
    "CMYK_Y": 0.59415149688721,
    "CMYK_K": 0.41029042005539
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174510",
    "Farbtonhilfsbezeichnung": "R17 45 10",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "101",
    "Bcolor": "94",
    "Y": 15,
    "L": 44.886848449707,
    "a": 7.87547588348389,
    "b": 6.84973096847534,
    "C": 10.4375257492065,
    "h": 41.0152626037598,
    "CMY_C": 0.51543521881104,
    "CMY_M": 0.60216629505157,
    "CMY_Y": 0.62999975681305,
    "CMYK_C": 0,
    "CMYK_M": 0.17898757755756,
    "CMYK_Y": 0.23642770946026,
    "CMYK_K": 0.51543521881104
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174515",
    "Farbtonhilfsbezeichnung": "R17 45 15",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "99",
    "Bcolor": "89",
    "Y": 15,
    "L": 44.7758483886719,
    "a": 11.6637392044067,
    "b": 10.0422506332398,
    "C": 15.3912181854248,
    "h": 40.7278060913086,
    "CMY_C": 0.48768943548203,
    "CMY_M": 0.61298203468323,
    "CMY_Y": 0.65099501609802,
    "CMYK_C": 0,
    "CMYK_M": 0.24456375837326,
    "CMYK_Y": 0.31876286864281,
    "CMYK_K": 0.48768943548203
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174555",
    "Farbtonhilfsbezeichnung": "R17 45 55",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "74",
    "Bcolor": "49",
    "Y": 15,
    "L": 45.1134033203125,
    "a": 41.1548347473145,
    "b": 35.1466598510742,
    "C": 54.1203117370605,
    "h": 40.497673034668,
    "CMY_C": 0.30102336406708,
    "CMY_M": 0.709577023983,
    "CMY_Y": 0.8062270283699,
    "CMYK_C": 0,
    "CMYK_M": 0.58450257778168,
    "CMYK_Y": 0.72277617454529,
    "CMYK_K": 0.30102336406708
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R174646",
    "Farbtonhilfsbezeichnung": "R17 46 46 Rosso Ercolano",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "83",
    "Bcolor": "60",
    "Y": 15,
    "L": 46.1669158935547,
    "a": 35.2369155883789,
    "b": 30.1201648712158,
    "C": 46.3558464050293,
    "h": 40.5234909057617,
    "CMY_C": 0.32157307863235,
    "CMY_M": 0.67461824417114,
    "CMY_Y": 0.76450151205063,
    "CMYK_C": 0,
    "CMYK_M": 0.52038788795471,
    "CMYK_Y": 0.65287566184998,
    "CMYK_K": 0.32157307863235
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R175010",
    "Farbtonhilfsbezeichnung": "R17 50 10",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "114",
    "Bcolor": "107",
    "Y": 18,
    "L": 49.8685722351074,
    "a": 7.59724187850952,
    "b": 6.66134834289551,
    "C": 10.1040410995483,
    "h": 41.2446556091309,
    "CMY_C": 0.46711313724518,
    "CMY_M": 0.55304837226868,
    "CMY_Y": 0.58132326602936,
    "CMYK_C": 0,
    "CMYK_M": 0.16126357018948,
    "CMYK_Y": 0.21432340145111,
    "CMYK_K": 0.46711313724518
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R175030",
    "Farbtonhilfsbezeichnung": "R17 50 30",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "103",
    "Bcolor": "86",
    "Y": 18,
    "L": 50.0090026855469,
    "a": 22.9956836700439,
    "b": 19.7020778656006,
    "C": 30.2815685272217,
    "h": 40.5890731811523,
    "CMY_C": 0.35328996181488,
    "CMY_M": 0.59477114677429,
    "CMY_Y": 0.66310489177704,
    "CMYK_C": 0,
    "CMYK_M": 0.37339946627617,
    "CMYK_Y": 0.47906312346458,
    "CMYK_K": 0.35328996181488
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R175040",
    "Farbtonhilfsbezeichnung": "R17 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "99",
    "Bcolor": "77",
    "Y": 18,
    "L": 50.7866516113281,
    "a": 30.7991104125977,
    "b": 26.3489074707031,
    "C": 40.5320892333984,
    "h": 40.5472793579102,
    "CMY_C": 0.29493463039398,
    "CMY_M": 0.61280572414398,
    "CMY_Y": 0.69843649864197,
    "CMYK_C": 0,
    "CMYK_M": 0.45083919167519,
    "CMYK_Y": 0.57229000329971,
    "CMYK_K": 0.29493463039398
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R175060",
    "Farbtonhilfsbezeichnung": "R17 50 60",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "82",
    "Bcolor": "54",
    "Y": 18,
    "L": 50.5054321289063,
    "a": 46.5987968444824,
    "b": 39.6977119445801,
    "C": 61.2156524658203,
    "h": 40.4278182983398,
    "CMY_C": 0.20708239078522,
    "CMY_M": 0.67943871021271,
    "CMY_Y": 0.78812676668167,
    "CMYK_C": 0,
    "CMYK_M": 0.59571927785873,
    "CMYK_Y": 0.73279285430908,
    "CMYK_K": 0.20708239078522
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R175508",
    "Farbtonhilfsbezeichnung": "R17 55 08",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "128",
    "Bcolor": "122",
    "Y": 23,
    "L": 54.8236312866211,
    "a": 5.83039140701294,
    "b": 5.13350582122803,
    "C": 7.76829099655151,
    "h": 41.3630638122559,
    "CMY_C": 0.43132293224335,
    "CMY_M": 0.4994523525238,
    "CMY_Y": 0.52316462993622,
    "CMYK_C": 0,
    "CMYK_M": 0.1198033541441,
    "CMYK_Y": 0.16150061786175,
    "CMYK_K": 0.43132293224335
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R176005",
    "Farbtonhilfsbezeichnung": "R17 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "142",
    "Bcolor": "138",
    "Y": 28,
    "L": 59.9785385131836,
    "a": 3.89513039588928,
    "b": 3.42948961257935,
    "C": 5.18974351882935,
    "h": 41.3624877929688,
    "CMY_C": 0.39557707309723,
    "CMY_M": 0.44247788190842,
    "CMY_Y": 0.4605621099472,
    "CMYK_C": 0,
    "CMYK_M": 0.07759600877762,
    "CMYK_Y": 0.10751583427191,
    "CMYK_K": 0.39557707309723
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R176010",
    "Farbtonhilfsbezeichnung": "R17 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "141",
    "Bcolor": "133",
    "Y": 28,
    "L": 60.3761367797852,
    "a": 7.52169704437256,
    "b": 6.55574941635132,
    "C": 9.97766399383545,
    "h": 41.07470703125,
    "CMY_C": 0.35887050628662,
    "CMY_M": 0.44765794277191,
    "CMY_Y": 0.47730177640915,
    "CMYK_C": 0,
    "CMYK_M": 0.13848596811295,
    "CMYK_Y": 0.18472285568714,
    "CMYK_K": 0.35887050628662
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R176020",
    "Farbtonhilfsbezeichnung": "R17 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "135",
    "Bcolor": "122",
    "Y": 28,
    "L": 60.1091537475586,
    "a": 15.2587156295776,
    "b": 13.0706033706665,
    "C": 20.0915184020996,
    "h": 40.5833320617676,
    "CMY_C": 0.29849857091904,
    "CMY_M": 0.47125494480133,
    "CMY_Y": 0.52305340766907,
    "CMYK_C": 0,
    "CMYK_M": 0.24626660346985,
    "CMYK_Y": 0.3201060295105,
    "CMYK_K": 0.29849857091904
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R176030",
    "Farbtonhilfsbezeichnung": "R17 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "130",
    "Bcolor": "111",
    "Y": 28,
    "L": 60.4352722167969,
    "a": 22.9012012481689,
    "b": 19.6912956237793,
    "C": 30.2028503417969,
    "h": 40.6901550292969,
    "CMY_C": 0.23802697658539,
    "CMY_M": 0.49045807123184,
    "CMY_Y": 0.56362271308899,
    "CMYK_C": 0,
    "CMYK_M": 0.33128613233566,
    "CMYK_Y": 0.42730611562729,
    "CMYK_K": 0.23802697658539
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R176040",
    "Farbtonhilfsbezeichnung": "R17 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "121",
    "Bcolor": "98",
    "Y": 28,
    "L": 59.5480270385742,
    "a": 30.6750831604004,
    "b": 26.0289840698242,
    "C": 40.2301979064941,
    "h": 40.3158798217773,
    "CMY_C": 0.1954630613327,
    "CMY_M": 0.52452754974365,
    "CMY_Y": 0.61398196220398,
    "CMYK_C": 0,
    "CMYK_M": 0.40901103615761,
    "CMYK_Y": 0.52019846439362,
    "CMYK_K": 0.1954630613327
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R177010",
    "Farbtonhilfsbezeichnung": "R17 70 10",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "167",
    "Bcolor": "159",
    "Y": 41,
    "L": 70.3051071166992,
    "a": 7.86377859115601,
    "b": 6.43267726898193,
    "C": 10.1596431732178,
    "h": 39.2836303710938,
    "CMY_C": 0.25081408023834,
    "CMY_M": 0.34560316801071,
    "CMY_Y": 0.37520283460617,
    "CMYK_C": 0,
    "CMYK_M": 0.12652277946472,
    "CMYK_Y": 0.16603189706802,
    "CMYK_K": 0.25081408023834
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R177030",
    "Farbtonhilfsbezeichnung": "R17 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "155",
    "Bcolor": "136",
    "Y": 41,
    "L": 70.0673675537109,
    "a": 23.1303787231445,
    "b": 19.3128108978271,
    "C": 30.1330223083496,
    "h": 39.8603401184082,
    "CMY_C": 0.12811374664307,
    "CMY_M": 0.39173156023026,
    "CMY_Y": 0.46542859077454,
    "CMYK_C": 0,
    "CMYK_M": 0.30235344171524,
    "CMYK_Y": 0.38687941431999,
    "CMYK_K": 0.12811374664307
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R177040",
    "Farbtonhilfsbezeichnung": "R17 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "149",
    "Bcolor": "126",
    "Y": 41,
    "L": 70.0945587158203,
    "a": 30.3218555450439,
    "b": 25.226713180542,
    "C": 39.4436569213867,
    "h": 39.7592620849609,
    "CMY_C": 0.07571280002594,
    "CMY_M": 0.41443699598312,
    "CMY_Y": 0.505355656147,
    "CMYK_C": 0,
    "CMYK_M": 0.36647072434425,
    "CMYK_Y": 0.4648369550705,
    "CMYK_K": 0.07571280002594
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R178005",
    "Farbtonhilfsbezeichnung": "R17 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "196",
    "Bcolor": "191",
    "Y": 57,
    "L": 80.0485458374023,
    "a": 3.96932411193848,
    "b": 3.17773771286011,
    "C": 5.08463859558105,
    "h": 38.6798553466797,
    "CMY_C": 0.18153291940689,
    "CMY_M": 0.23133486509323,
    "CMY_Y": 0.24998635053635,
    "CMYK_C": 0,
    "CMYK_M": 0.06084783002734,
    "CMYK_Y": 0.08363614231348,
    "CMYK_K": 0.18153291940689
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R178020",
    "Farbtonhilfsbezeichnung": "R17 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "188",
    "Bcolor": "174",
    "Y": 57,
    "L": 80.0111999511719,
    "a": 15.4608316421509,
    "b": 12.9272298812866,
    "C": 20.1531772613525,
    "h": 39.8999290466309,
    "CMY_C": 0.07614612579346,
    "CMY_M": 0.26337438821793,
    "CMY_Y": 0.31881773471832,
    "CMYK_C": 0,
    "CMYK_M": 0.20266003906727,
    "CMYK_Y": 0.26267313957214,
    "CMYK_K": 0.07614612579346
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R178510",
    "Farbtonhilfsbezeichnung": "R17 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "207",
    "Bcolor": "199",
    "Y": 66,
    "L": 84.8859710693359,
    "a": 7.8073205947876,
    "b": 6.34663105010986,
    "C": 10.0615100860596,
    "h": 39.1079292297363,
    "CMY_C": 0.09069377183914,
    "CMY_M": 0.1889460682869,
    "CMY_Y": 0.22039139270782,
    "CMYK_C": 0,
    "CMYK_M": 0.10805193334818,
    "CMYK_Y": 0.14263360202312,
    "CMYK_K": 0.09069377183914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R178515",
    "Farbtonhilfsbezeichnung": "R17 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "205",
    "Bcolor": "194",
    "Y": 66,
    "L": 85.0725021362305,
    "a": 11.3910989761353,
    "b": 9.50828838348389,
    "C": 14.837947845459,
    "h": 39.8521614074707,
    "CMY_C": 0.05467635393143,
    "CMY_M": 0.19687563180923,
    "CMY_Y": 0.24088257551193,
    "CMYK_C": 0,
    "CMYK_M": 0.15042391419411,
    "CMYK_Y": 0.19697615504265,
    "CMYK_K": 0.05467635393143
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R178520",
    "Farbtonhilfsbezeichnung": "R17 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "186",
    "Y": 66,
    "L": 84.4318389892578,
    "a": 15.4367160797119,
    "b": 12.7831583023071,
    "C": 20.0424880981445,
    "h": 39.6281890869141,
    "CMY_C": 0.02616232633591,
    "CMY_M": 0.21538203954697,
    "CMY_Y": 0.27094519138336,
    "CMYK_C": 0,
    "CMYK_M": 0.19430314004421,
    "CMYK_Y": 0.2513590157032,
    "CMYK_K": 0.02616232633591
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R179005",
    "Farbtonhilfsbezeichnung": "R17 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.9410629272461,
    "a": 3.97882676124573,
    "b": 3.13787841796875,
    "C": 5.06728172302246,
    "h": 38.260871887207,
    "CMY_C": 0.07183867692947,
    "CMY_M": 0.12288045883179,
    "CMY_Y": 0.14239257574081,
    "CMYK_C": 0,
    "CMYK_M": 0.05499235913157,
    "CMYK_Y": 0.07601469755173,
    "CMYK_K": 0.07183867692947
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R183328",
    "Farbtonhilfsbezeichnung": "R18 33 28 Persisch Rot",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "64",
    "Bcolor": "53",
    "Y": 8,
    "L": 33.316535949707,
    "a": 22.3507251739502,
    "b": 16.2573375701904,
    "C": 27.6379432678223,
    "h": 36.0311698913574,
    "CMY_C": 0.54008257389069,
    "CMY_M": 0.75050717592239,
    "CMY_Y": 0.79119646549225,
    "CMYK_C": 0,
    "CMYK_M": 0.45752692222595,
    "CMYK_Y": 0.54599779844284,
    "CMYK_K": 0.54008257389069
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R183634",
    "Farbtonhilfsbezeichnung": "R18 36 34 Englisch Rot",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "65",
    "Bcolor": "54",
    "Y": 9,
    "L": 36.2620582580566,
    "a": 28.418966293335,
    "b": 20.0940742492676,
    "C": 34.8053092956543,
    "h": 35.2628173828125,
    "CMY_C": 0.47514855861664,
    "CMY_M": 0.74361377954483,
    "CMY_Y": 0.78821015357971,
    "CMYK_C": 0,
    "CMYK_M": 0.5115070939064,
    "CMYK_Y": 0.59647655487061,
    "CMYK_K": 0.47514855861664
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R184050",
    "Farbtonhilfsbezeichnung": "R18 40 50",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "63",
    "Bcolor": "50",
    "Y": 11,
    "L": 40.2809181213379,
    "a": 40.700798034668,
    "b": 28.6566600799561,
    "C": 49.7770957946777,
    "h": 35.1486473083496,
    "CMY_C": 0.36425536870956,
    "CMY_M": 0.75489807128906,
    "CMY_Y": 0.80477905273438,
    "CMYK_C": 0,
    "CMYK_M": 0.6144648194313,
    "CMYK_Y": 0.69292551279068,
    "CMYK_K": 0.36425536870956
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R184442",
    "Farbtonhilfsbezeichnung": "R18 44 42 Venezianisch Rot",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "79",
    "Bcolor": "66",
    "Y": 14,
    "L": 44.1582298278809,
    "a": 34.2201156616211,
    "b": 24.037130355835,
    "C": 41.8186569213867,
    "h": 35.0852355957031,
    "CMY_C": 0.35521858930588,
    "CMY_M": 0.68938219547272,
    "CMY_Y": 0.74242293834686,
    "CMYK_C": 0,
    "CMYK_M": 0.51825875043869,
    "CMYK_Y": 0.6005203127861,
    "CMYK_K": 0.35521858930588
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R185005",
    "Farbtonhilfsbezeichnung": "R18 50 05",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "117",
    "Bcolor": "113",
    "Y": 18,
    "L": 50.0867080688477,
    "a": 3.96134829521179,
    "b": 3.03671264648438,
    "C": 4.99138307571411,
    "h": 37.4732551574707,
    "CMY_C": 0.49714785814285,
    "CMY_M": 0.5417612195015,
    "CMY_Y": 0.55594897270203,
    "CMYK_C": 0,
    "CMYK_M": 0.08872063457966,
    "CMYK_Y": 0.11693520098925,
    "CMYK_K": 0.49714785814285
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R185020",
    "Farbtonhilfsbezeichnung": "R18 50 20",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "109",
    "Bcolor": "99",
    "Y": 18,
    "L": 50.1263809204102,
    "a": 16.6463031768799,
    "b": 11.9801588058472,
    "C": 20.5091114044189,
    "h": 35.7421455383301,
    "CMY_C": 0.39959228038788,
    "CMY_M": 0.57424908876419,
    "CMY_Y": 0.61231744289398,
    "CMYK_C": 0,
    "CMYK_M": 0.2908970117569,
    "CMYK_Y": 0.35430118441582,
    "CMYK_K": 0.39959228038788
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R185060",
    "Farbtonhilfsbezeichnung": "R18 50 60",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "77",
    "Bcolor": "63",
    "Y": 18,
    "L": 50.1330680847168,
    "a": 49.632682800293,
    "b": 34.545711517334,
    "C": 60.4715576171875,
    "h": 34.8389778137207,
    "CMY_C": 0.20043748617172,
    "CMY_M": 0.69673389196396,
    "CMY_Y": 0.75419789552689,
    "CMYK_C": 0,
    "CMYK_M": 0.62070995569229,
    "CMYK_Y": 0.69257926940918,
    "CMYK_K": 0.20043748617172
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R186010",
    "Farbtonhilfsbezeichnung": "R18 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "139",
    "Bcolor": "133",
    "Y": 28,
    "L": 59.7022132873535,
    "a": 8.34812355041504,
    "b": 5.95637893676758,
    "C": 10.2552242279053,
    "h": 35.5078239440918,
    "CMY_C": 0.36202639341354,
    "CMY_M": 0.45634537935257,
    "CMY_Y": 0.4798618555069,
    "CMYK_C": 0,
    "CMYK_M": 0.14784151315689,
    "CMYK_Y": 0.18470272421837,
    "CMYK_K": 0.36202639341354
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R186030",
    "Farbtonhilfsbezeichnung": "R18 60 30",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "127",
    "Bcolor": "114",
    "Y": 28,
    "L": 59.9538803100586,
    "a": 24.6656684875488,
    "b": 17.5581359863281,
    "C": 30.2767791748047,
    "h": 35.4449768066406,
    "CMY_C": 0.23671209812164,
    "CMY_M": 0.50001263618469,
    "CMY_Y": 0.55340349674225,
    "CMYK_C": 0,
    "CMYK_M": 0.34495574235916,
    "CMYK_Y": 0.41490426659584,
    "CMYK_K": 0.23671209812164
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R186050",
    "Farbtonhilfsbezeichnung": "R18 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 28,
    "L": 59.3866348266602,
    "a": 40.8230934143066,
    "b": 28.5895023345947,
    "C": 49.8385848999023,
    "h": 35.0045776367188,
    "CMY_C": 0.13969194889069,
    "CMY_M": 0.56202340126038,
    "CMY_Y": 0.63057482242584,
    "CMYK_C": 0,
    "CMYK_M": 0.49090725183487,
    "CMYK_Y": 0.57058966159821,
    "CMYK_K": 0.13969194889069
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R187005",
    "Farbtonhilfsbezeichnung": "R18 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "167",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.5592041015625,
    "a": 4.36081027984619,
    "b": 2.93785071372986,
    "C": 5.25810146331787,
    "h": 33.967903137207,
    "CMY_C": 0.29289144277573,
    "CMY_M": 0.34415054321289,
    "CMY_Y": 0.35897159576416,
    "CMYK_C": 0,
    "CMYK_M": 0.07249113172293,
    "CMYK_Y": 0.0934512168169,
    "CMYK_K": 0.29289144277573
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R187020",
    "Farbtonhilfsbezeichnung": "R18 70 20",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "161",
    "Bcolor": "151",
    "Y": 41,
    "L": 70.2390747070313,
    "a": 16.2567596435547,
    "b": 11.3559293746948,
    "C": 19.8302631378174,
    "h": 34.9356803894043,
    "CMY_C": 0.18440103530884,
    "CMY_M": 0.36894673109055,
    "CMY_Y": 0.40907067060471,
    "CMYK_C": 0,
    "CMYK_M": 0.22627013921738,
    "CMYK_Y": 0.27546581625938,
    "CMYK_K": 0.18440103530884
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R187040",
    "Farbtonhilfsbezeichnung": "R18 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "146",
    "Bcolor": "130",
    "Y": 41,
    "L": 69.5553436279297,
    "a": 32.2784652709961,
    "b": 22.5917778015137,
    "C": 39.3990821838379,
    "h": 34.9882698059082,
    "CMY_C": 0.07468658685684,
    "CMY_M": 0.42569136619568,
    "CMY_Y": 0.49174278974533,
    "CMYK_C": 0,
    "CMYK_M": 0.3793360888958,
    "CMYK_Y": 0.45071884989738,
    "CMYK_K": 0.07468658685684
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R188010",
    "Farbtonhilfsbezeichnung": "R18 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "193",
    "Bcolor": "186",
    "Y": 57,
    "L": 79.8980560302734,
    "a": 8.3166971206665,
    "b": 5.71385622024536,
    "C": 10.0903720855713,
    "h": 34.4903984069824,
    "CMY_C": 0.14444386959076,
    "CMY_M": 0.24427056312561,
    "CMY_Y": 0.26921862363815,
    "CMYK_C": 0,
    "CMYK_M": 0.11668047308922,
    "CMYK_Y": 0.14584052562714,
    "CMYK_K": 0.14444386959076
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R188030",
    "Farbtonhilfsbezeichnung": "R18 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "179",
    "Bcolor": "165",
    "Y": 57,
    "L": 79.4725952148438,
    "a": 24.7227039337158,
    "b": 17.0330772399902,
    "C": 30.0222892761231,
    "h": 34.5654792785645,
    "CMY_C": 0.01391416788101,
    "CMY_M": 0.29609048366547,
    "CMY_Y": 0.35237008333206,
    "CMYK_C": 0,
    "CMYK_M": 0.2861579656601,
    "CMYK_Y": 0.34323170781136,
    "CMYK_K": 0.01391416788101
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R188505",
    "Farbtonhilfsbezeichnung": "R18 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "206",
    "Y": 66,
    "L": 85.1836318969727,
    "a": 4.10154676437378,
    "b": 2.71574020385742,
    "C": 4.91913938522339,
    "h": 33.5095748901367,
    "CMY_C": 0.12532466650009,
    "CMY_M": 0.17555713653564,
    "CMY_Y": 0.19123393297195,
    "CMYK_C": 0,
    "CMYK_M": 0.05742984637618,
    "CMYK_Y": 0.07535283267498,
    "CMYK_K": 0.12532466650009
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R188520",
    "Farbtonhilfsbezeichnung": "R18 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "200",
    "Bcolor": "190",
    "Y": 66,
    "L": 84.6051712036133,
    "a": 16.0708141326904,
    "b": 10.8855333328247,
    "C": 19.4104595184326,
    "h": 34.1116676330566,
    "CMY_C": 0.02440220117569,
    "CMY_M": 0.2146982550621,
    "CMY_Y": 0.25516605377197,
    "CMYK_C": 0,
    "CMYK_M": 0.1950558423996,
    "CMYK_Y": 0.23653584718704,
    "CMYK_K": 0.02440220117569
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R189010",
    "Farbtonhilfsbezeichnung": "R18 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "220",
    "Bcolor": "213",
    "Y": 76,
    "L": 89.645637512207,
    "a": 8.43056869506836,
    "b": 5.6247091293335,
    "C": 10.1346855163574,
    "h": 33.7104377746582,
    "CMY_C": 0.03455585241318,
    "CMY_M": 0.13793796300888,
    "CMY_Y": 0.16331475973129,
    "CMYK_C": 0,
    "CMYK_M": 0.10708243399858,
    "CMYK_Y": 0.13336753845215,
    "CMYK_K": 0.03455585241318
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193008",
    "Farbtonhilfsbezeichnung": "R19 30 08",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "66",
    "Bcolor": "63",
    "Y": 6,
    "L": 29.6290035247803,
    "a": 6.55261421203613,
    "b": 4.03680372238159,
    "C": 7.69626760482788,
    "h": 31.6355609893799,
    "CMY_C": 0.67735481262207,
    "CMY_M": 0.74042481184006,
    "CMY_Y": 0.75202190876007,
    "CMYK_C": 0,
    "CMYK_M": 0.19547788798809,
    "CMYK_Y": 0.23142169415951,
    "CMYK_K": 0.67735481262207
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193013",
    "Farbtonhilfsbezeichnung": "R19 30 13",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "65",
    "Bcolor": "61",
    "Y": 6,
    "L": 30.3542232513428,
    "a": 10.7498588562012,
    "b": 6.49226999282837,
    "C": 12.5582256317139,
    "h": 31.1294574737549,
    "CMY_C": 0.64272856712341,
    "CMY_M": 0.74402093887329,
    "CMY_Y": 0.7597571015358,
    "CMYK_C": 0,
    "CMYK_M": 0.28351658582687,
    "CMYK_Y": 0.32756197452545,
    "CMYK_K": 0.64272856712341
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193232",
    "Farbtonhilfsbezeichnung": "R19 32 32",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "56",
    "Bcolor": "51",
    "Y": 7,
    "L": 32.2690315246582,
    "a": 28.4641456604004,
    "b": 16.6245975494385,
    "C": 32.9633865356445,
    "h": 30.2872333526611,
    "CMY_C": 0.52145957946777,
    "CMY_M": 0.78035879135132,
    "CMY_Y": 0.80107879638672,
    "CMYK_C": 0,
    "CMYK_M": 0.54101848602295,
    "CMYK_Y": 0.58431684970856,
    "CMYK_K": 0.52145957946777
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193505",
    "Farbtonhilfsbezeichnung": "R19 35 05",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "80",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.8506927490234,
    "a": 4.33329200744629,
    "b": 2.56827330589294,
    "C": 5.03720617294312,
    "h": 30.6545486450195,
    "CMY_C": 0.64454329013824,
    "CMY_M": 0.68788266181946,
    "CMY_Y": 0.69661712646484,
    "CMYK_C": 0,
    "CMYK_M": 0.12192587554455,
    "CMYK_Y": 0.14649839699268,
    "CMYK_K": 0.64454329013824
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193510",
    "Farbtonhilfsbezeichnung": "R19 35 10",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "77",
    "Bcolor": "74",
    "Y": 8,
    "L": 34.9965667724609,
    "a": 8.6373462677002,
    "b": 5.19866752624512,
    "C": 10.0811653137207,
    "h": 31.0429973602295,
    "CMY_C": 0.61204671859741,
    "CMY_M": 0.69664216041565,
    "CMY_Y": 0.71087235212326,
    "CMYK_C": 0,
    "CMYK_M": 0.21805573999882,
    "CMYK_Y": 0.25473591685295,
    "CMYK_K": 0.61204671859741
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193520",
    "Farbtonhilfsbezeichnung": "R19 35 20",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "71",
    "Bcolor": "66",
    "Y": 8,
    "L": 34.9474258422852,
    "a": 17.98952293396,
    "b": 10.6107769012451,
    "C": 20.8856773376465,
    "h": 30.5334186553955,
    "CMY_C": 0.55250871181488,
    "CMY_M": 0.721764087677,
    "CMY_Y": 0.74308323860168,
    "CMYK_C": 0,
    "CMYK_M": 0.37823167443275,
    "CMYK_Y": 0.42587316036224,
    "CMYK_K": 0.55250871181488
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193540",
    "Farbtonhilfsbezeichnung": "R19 35 40",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "57",
    "Bcolor": "51",
    "Y": 8,
    "L": 35.378303527832,
    "a": 35.3595390319824,
    "b": 20.8055667877197,
    "C": 41.026439666748,
    "h": 30.4725723266602,
    "CMY_C": 0.45126622915268,
    "CMY_M": 0.77839779853821,
    "CMY_Y": 0.79850041866302,
    "CMYK_C": 0,
    "CMYK_M": 0.5961571931839,
    "CMYK_Y": 0.63279169797897,
    "CMYK_K": 0.45126622915268
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R193727",
    "Farbtonhilfsbezeichnung": "R19 37 27 Falun Rot",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "74",
    "Bcolor": "68",
    "Y": 10,
    "L": 37.9615478515625,
    "a": 23.1919021606445,
    "b": 13.7559156417847,
    "C": 26.9645977020264,
    "h": 30.6736392974854,
    "CMY_C": 0.49015283584595,
    "CMY_M": 0.70951247215271,
    "CMY_Y": 0.73477709293365,
    "CMYK_C": 0,
    "CMYK_M": 0.43024587631226,
    "CMYK_Y": 0.47979918122292,
    "CMYK_K": 0.49015283584595
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R194007",
    "Farbtonhilfsbezeichnung": "R19 40 07",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "90",
    "Bcolor": "87",
    "Y": 11,
    "L": 39.921703338623,
    "a": 6.35431814193726,
    "b": 3.90836000442505,
    "C": 7.46006965637207,
    "h": 31.5944881439209,
    "CMY_C": 0.58041512966156,
    "CMY_M": 0.64531862735748,
    "CMY_Y": 0.65800511837006,
    "CMYK_C": 0,
    "CMYK_M": 0.15468503534794,
    "CMYK_Y": 0.18492084741592,
    "CMYK_K": 0.58041512966156
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R194050",
    "Farbtonhilfsbezeichnung": "R19 40 50",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "57",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.796817779541,
    "a": 44.0737495422363,
    "b": 26.2221527099609,
    "C": 51.2844696044922,
    "h": 30.7509860992432,
    "CMY_C": 0.35589408874512,
    "CMY_M": 0.77538812160492,
    "CMY_Y": 0.79210120439529,
    "CMYK_C": 0,
    "CMYK_M": 0.65128111839294,
    "CMYK_Y": 0.67722886800766,
    "CMYK_K": 0.35589408874512
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R194505",
    "Farbtonhilfsbezeichnung": "R19 45 05",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "104",
    "Bcolor": "101",
    "Y": 15,
    "L": 44.8158340454102,
    "a": 4.36716890335083,
    "b": 2.71977210044861,
    "C": 5.14483451843262,
    "h": 31.9136962890625,
    "CMY_C": 0.54774224758148,
    "CMY_M": 0.59396547079086,
    "CMY_Y": 0.60462212562561,
    "CMYK_C": 0,
    "CMYK_M": 0.10220548510551,
    "CMYK_Y": 0.12576872110367,
    "CMYK_K": 0.54774224758148
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R194515",
    "Farbtonhilfsbezeichnung": "R19 45 15",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "98",
    "Bcolor": "93",
    "Y": 15,
    "L": 44.7966003417969,
    "a": 12.8444700241089,
    "b": 7.64453268051147,
    "C": 14.9472169876099,
    "h": 30.7594738006592,
    "CMY_C": 0.4852631688118,
    "CMY_M": 0.61515259742737,
    "CMY_Y": 0.63521289825439,
    "CMYK_C": 0,
    "CMYK_M": 0.25234141945839,
    "CMYK_Y": 0.29131338000298,
    "CMYK_K": 0.4852631688118
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R194849",
    "Farbtonhilfsbezeichnung": "R19 48 49 Zinnober",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "81",
    "Bcolor": "74",
    "Y": 18,
    "L": 48.0502090454102,
    "a": 42.642894744873,
    "b": 24.6419830322266,
    "C": 49.2508239746094,
    "h": 30.0222606658936,
    "CMY_C": 0.26807230710983,
    "CMY_M": 0.684117436409,
    "CMY_Y": 0.70901656150818,
    "CMYK_C": 0,
    "CMYK_M": 0.568423807621,
    "CMYK_Y": 0.60244238376617,
    "CMYK_K": 0.26807230710983
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R195012",
    "Farbtonhilfsbezeichnung": "R19 50 12",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "111",
    "Bcolor": "107",
    "Y": 18,
    "L": 49.5783538818359,
    "a": 10.7268686294556,
    "b": 6.43908262252808,
    "C": 12.5110950469971,
    "h": 30.9753856658936,
    "CMY_C": 0.45127719640732,
    "CMY_M": 0.56328582763672,
    "CMY_Y": 0.58220535516739,
    "CMYK_C": 0,
    "CMYK_M": 0.20412607491016,
    "CMYK_Y": 0.23860527575016,
    "CMYK_K": 0.45127719640732
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R195040",
    "Farbtonhilfsbezeichnung": "R19 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "95",
    "Bcolor": "87",
    "Y": 18,
    "L": 50.4351539611816,
    "a": 34.2720794677734,
    "b": 20.098747253418,
    "C": 39.7307815551758,
    "h": 30.3893489837646,
    "CMY_C": 0.28812491893768,
    "CMY_M": 0.62684071063995,
    "CMY_Y": 0.65928852558136,
    "CMYK_C": 0,
    "CMYK_M": 0.47580790519714,
    "CMYK_Y": 0.52138864994049,
    "CMYK_K": 0.28812491893768
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R195510",
    "Farbtonhilfsbezeichnung": "R19 55 10",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "126",
    "Bcolor": "121",
    "Y": 23,
    "L": 54.8136596679688,
    "a": 9.0148401260376,
    "b": 5.32503938674927,
    "C": 10.470118522644,
    "h": 30.570219039917,
    "CMY_C": 0.410375893116,
    "CMY_M": 0.50707697868347,
    "CMY_Y": 0.52408754825592,
    "CMYK_C": 0,
    "CMYK_M": 0.16400463879108,
    "CMYK_Y": 0.19285449385643,
    "CMYK_K": 0.410375893116
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R196008",
    "Farbtonhilfsbezeichnung": "R19 60 08",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "140",
    "Bcolor": "136",
    "Y": 28,
    "L": 59.8678321838379,
    "a": 6.46524572372437,
    "b": 3.93268656730652,
    "C": 7.56739234924316,
    "h": 31.3113555908203,
    "CMY_C": 0.37792062759399,
    "CMY_M": 0.44967770576477,
    "CMY_Y": 0.46473854780197,
    "CMYK_C": 0,
    "CMYK_M": 0.11535035818815,
    "CMYK_Y": 0.13956083357334,
    "CMYK_K": 0.37792062759399
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R196020",
    "Farbtonhilfsbezeichnung": "R19 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "135",
    "Bcolor": "128",
    "Y": 28,
    "L": 60.4792556762695,
    "a": 17.0713958740234,
    "b": 10.1170825958252,
    "C": 19.8440895080566,
    "h": 30.6524066925049,
    "CMY_C": 0.28934609889984,
    "CMY_M": 0.47157144546509,
    "CMY_Y": 0.4989977478981,
    "CMYK_C": 0,
    "CMYK_M": 0.2564192712307,
    "CMYK_Y": 0.29501229524612,
    "CMYK_K": 0.28934609889984
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R196040",
    "Farbtonhilfsbezeichnung": "R19 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "119",
    "Bcolor": "111",
    "Y": 28,
    "L": 60.0082359313965,
    "a": 34.7073020935059,
    "b": 19.5740795135498,
    "C": 39.8464736938477,
    "h": 29.4219474792481,
    "CMY_C": 0.17669069766998,
    "CMY_M": 0.53171890974045,
    "CMY_Y": 0.56452625989914,
    "CMYK_C": 0,
    "CMYK_M": 0.43122094869614,
    "CMYK_Y": 0.47106909751892,
    "CMYK_K": 0.17669069766998
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R196505",
    "Farbtonhilfsbezeichnung": "R19 65 05",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "154",
    "Bcolor": "151",
    "Y": 34,
    "L": 64.561882019043,
    "a": 4.47690582275391,
    "b": 2.59026622772217,
    "C": 5.17224931716919,
    "h": 30.0529899597168,
    "CMY_C": 0.34602749347687,
    "CMY_M": 0.39647680521011,
    "CMY_Y": 0.40814828872681,
    "CMYK_C": 0,
    "CMYK_M": 0.07714286446571,
    "CMYK_Y": 0.09498991817236,
    "CMYK_K": 0.34602749347687
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R197030",
    "Farbtonhilfsbezeichnung": "R19 70 30",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "152",
    "Bcolor": "143",
    "Y": 41,
    "L": 69.6365203857422,
    "a": 26.2559413909912,
    "b": 15.1314401626587,
    "C": 30.3040409088135,
    "h": 29.955078125,
    "CMY_C": 0.12174034118652,
    "CMY_M": 0.40437948703766,
    "CMY_Y": 0.43988209962845,
    "CMYK_C": 0,
    "CMYK_M": 0.321817278862,
    "CMYK_Y": 0.36224111914635,
    "CMYK_K": 0.12174034118652
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R198010",
    "Farbtonhilfsbezeichnung": "R19 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "194",
    "Bcolor": "189",
    "Y": 57,
    "L": 80.3820571899414,
    "a": 8.63640594482422,
    "b": 4.84160661697388,
    "C": 9.9009428024292,
    "h": 29.2751770019531,
    "CMY_C": 0.13923072814941,
    "CMY_M": 0.23960065841675,
    "CMY_Y": 0.25772500038147,
    "CMYK_C": 0,
    "CMYK_M": 0.11660491675138,
    "CMYK_Y": 0.1376609057188,
    "CMYK_K": 0.13923072814941
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R198020",
    "Farbtonhilfsbezeichnung": "R19 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "186",
    "Bcolor": "178",
    "Y": 57,
    "L": 79.7724304199219,
    "a": 17.8296527862549,
    "b": 10.0251035690308,
    "C": 20.4548091888428,
    "h": 29.3478031158447,
    "CMY_C": 0.06986606121063,
    "CMY_M": 0.27157682180405,
    "CMY_Y": 0.3000580072403,
    "CMYK_C": 0,
    "CMYK_M": 0.21686205267906,
    "CMYK_Y": 0.24748258292675,
    "CMYK_K": 0.06986606121063
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R198510",
    "Farbtonhilfsbezeichnung": "R19 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "206",
    "Bcolor": "201",
    "Y": 66,
    "L": 84.7392196655273,
    "a": 8.9097957611084,
    "b": 4.88530826568604,
    "C": 10.1612348556519,
    "h": 28.7362899780273,
    "CMY_C": 0.08853083848953,
    "CMY_M": 0.19292163848877,
    "CMY_Y": 0.21116191148758,
    "CMYK_C": 0,
    "CMYK_M": 0.11453025788069,
    "CMYK_Y": 0.13454221189022,
    "CMYK_K": 0.08853083848953
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R199007",
    "Farbtonhilfsbezeichnung": "R19 90 07",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "222",
    "Bcolor": "217",
    "Y": 76,
    "L": 89.834228515625,
    "a": 6.5010404586792,
    "b": 3.67964243888855,
    "C": 7.47016048431396,
    "h": 29.510217666626,
    "CMY_C": 0.05240178108215,
    "CMY_M": 0.13044917583466,
    "CMY_Y": 0.14719438552856,
    "CMYK_C": 0,
    "CMYK_M": 0.08236338198185,
    "CMYK_Y": 0.10003459453583,
    "CMYK_K": 0.05240178108215
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R199010",
    "Farbtonhilfsbezeichnung": "R19 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 76,
    "L": 89.9430541992188,
    "a": 8.5207405090332,
    "b": 4.81252336502075,
    "C": 9.7858772277832,
    "h": 29.4578075408936,
    "CMY_C": 0.03287714719772,
    "CMY_M": 0.13464665412903,
    "CMY_Y": 0.15405750274658,
    "CMYK_C": 0,
    "CMYK_M": 0.105229139328,
    "CMYK_Y": 0.1252998560667,
    "CMYK_K": 0.03287714719772
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R203013",
    "Farbtonhilfsbezeichnung": "R20 30 13 Caput Mortuum Roetlich",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "65",
    "Bcolor": "63",
    "Y": 6,
    "L": 30.6452217102051,
    "a": 11.8467569351196,
    "b": 5.70184755325317,
    "C": 13.1474981307983,
    "h": 25.7015247344971,
    "CMY_C": 0.63546216487885,
    "CMY_M": 0.74386775493622,
    "CMY_Y": 0.75230133533478,
    "CMYK_C": 0,
    "CMYK_M": 0.29737815260887,
    "CMYK_Y": 0.32051315903664,
    "CMYK_K": 0.63546216487885
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R204030",
    "Farbtonhilfsbezeichnung": "R20 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "76",
    "Bcolor": "74",
    "Y": 11,
    "L": 39.9682769775391,
    "a": 27.4339351654053,
    "b": 12.90735912323,
    "C": 30.3186531066895,
    "h": 25.1964588165283,
    "CMY_C": 0.44834619760513,
    "CMY_M": 0.7037308216095,
    "CMY_Y": 0.71062761545181,
    "CMYK_C": 0,
    "CMYK_M": 0.46294364333153,
    "CMYK_Y": 0.47544568777084,
    "CMYK_K": 0.44834619760513
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R205005",
    "Farbtonhilfsbezeichnung": "R20 50 05",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "116",
    "Bcolor": "114",
    "Y": 18,
    "L": 50.0706672668457,
    "a": 4.69663095474243,
    "b": 2.40808081626892,
    "C": 5.277991771698,
    "h": 27.1453552246094,
    "CMY_C": 0.49413150548935,
    "CMY_M": 0.54339987039566,
    "CMY_Y": 0.55188608169556,
    "CMYK_C": 0,
    "CMYK_M": 0.09739362448454,
    "CMYK_Y": 0.1141691505909,
    "CMYK_K": 0.49413150548935
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R205020",
    "Farbtonhilfsbezeichnung": "R20 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "108",
    "Bcolor": "105",
    "Y": 18,
    "L": 50.188892364502,
    "a": 18.2714939117432,
    "b": 8.57642841339111,
    "C": 20.1842174530029,
    "h": 25.1448192596436,
    "CMY_C": 0.3958438038826,
    "CMY_M": 0.57717740535736,
    "CMY_Y": 0.58914864063263,
    "CMYK_C": 0,
    "CMYK_M": 0.30014356970787,
    "CMYK_Y": 0.31995838880539,
    "CMYK_K": 0.3958438038826
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R205040",
    "Farbtonhilfsbezeichnung": "R20 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "90",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.3492546081543,
    "a": 36.5750885009766,
    "b": 16.8541221618652,
    "C": 40.2715606689453,
    "h": 24.740665435791,
    "CMY_C": 0.29257595539093,
    "CMY_M": 0.64516252279282,
    "CMY_Y": 0.64768916368484,
    "CMYK_C": 0,
    "CMYK_M": 0.4984090924263,
    "CMYK_Y": 0.50198066234589,
    "CMYK_K": 0.29257595539093
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R206010",
    "Farbtonhilfsbezeichnung": "R20 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "139",
    "Bcolor": "136",
    "Y": 28,
    "L": 59.9281997680664,
    "a": 9.04064846038818,
    "b": 4.30878114700317,
    "C": 10.0149345397949,
    "h": 25.4825096130371,
    "CMY_C": 0.35922557115555,
    "CMY_M": 0.45529305934906,
    "CMY_Y": 0.46631890535355,
    "CMYK_C": 0,
    "CMYK_M": 0.1499240398407,
    "CMYK_Y": 0.16713109612465,
    "CMYK_K": 0.35922557115555
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R206030",
    "Farbtonhilfsbezeichnung": "R20 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "126",
    "Bcolor": "122",
    "Y": 28,
    "L": 59.8667068481445,
    "a": 27.1648998260498,
    "b": 12.7682399749756,
    "C": 30.0159912109375,
    "h": 25.1747989654541,
    "CMY_C": 0.23137730360031,
    "CMY_M": 0.50722074508667,
    "CMY_Y": 0.5212949514389,
    "CMYK_C": 0,
    "CMYK_M": 0.35888016223907,
    "CMYK_Y": 0.37719109654427,
    "CMYK_K": 0.23137730360031
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R207005",
    "Farbtonhilfsbezeichnung": "R20 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "169",
    "Bcolor": "166",
    "Y": 41,
    "L": 70.1258926391602,
    "a": 4.70409965515137,
    "b": 2.10336780548096,
    "C": 5.15293216705322,
    "h": 24.0910911560059,
    "CMY_C": 0.28683465719223,
    "CMY_M": 0.33877044916153,
    "CMY_Y": 0.34717756509781,
    "CMYK_C": 0,
    "CMYK_M": 0.07282433658838,
    "CMYK_Y": 0.08461278676987,
    "CMYK_K": 0.28683465719223
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R207020",
    "Farbtonhilfsbezeichnung": "R20 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "160",
    "Bcolor": "156",
    "Y": 41,
    "L": 70.1862640380859,
    "a": 17.8259201049805,
    "b": 8.36536598205566,
    "C": 19.6911849975586,
    "h": 25.1397743225098,
    "CMY_C": 0.18159037828445,
    "CMY_M": 0.37293767929077,
    "CMY_Y": 0.38842362165451,
    "CMYK_C": 0,
    "CMYK_M": 0.23380382359028,
    "CMYK_Y": 0.25272580981255,
    "CMYK_K": 0.18159037828445
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R208010",
    "Farbtonhilfsbezeichnung": "R20 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "192",
    "Bcolor": "189",
    "Y": 57,
    "L": 79.7650756835938,
    "a": 9.26036357879639,
    "b": 4.17938566207886,
    "C": 10.1598033905029,
    "h": 24.2905998229981,
    "CMY_C": 0.14350336790085,
    "CMY_M": 0.24764668941498,
    "CMY_Y": 0.25946038961411,
    "CMYK_C": 0,
    "CMYK_M": 0.12159221619368,
    "CMYK_Y": 0.13538525998592,
    "CMYK_K": 0.14350336790085
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R208507",
    "Farbtonhilfsbezeichnung": "R20 85 07",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "208",
    "Bcolor": "206",
    "Y": 66,
    "L": 85.0189895629883,
    "a": 6.64444351196289,
    "b": 2.8775417804718,
    "C": 7.24077892303467,
    "h": 23.4162254333496,
    "CMY_C": 0.10776346921921,
    "CMY_M": 0.18363547325134,
    "CMY_Y": 0.19383585453033,
    "CMYK_C": 0,
    "CMYK_M": 0.08503574877977,
    "CMYK_Y": 0.09646812826395,
    "CMYK_K": 0.10776346921921
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R209005",
    "Farbtonhilfsbezeichnung": "R20 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "223",
    "Bcolor": "220",
    "Y": 76,
    "L": 89.7899780273438,
    "a": 4.71780776977539,
    "b": 2.03757476806641,
    "C": 5.13900995254517,
    "h": 23.3590412139893,
    "CMY_C": 0.07139194011688,
    "CMY_M": 0.12605684995651,
    "CMY_Y": 0.13582736253738,
    "CMYK_C": 0,
    "CMYK_M": 0.05886758118868,
    "CMYK_Y": 0.06938925385475,
    "CMYK_K": 0.07139194011688
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R212707",
    "Farbtonhilfsbezeichnung": "R21 27 07 Caput Mortuum Dunkel",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "63",
    "Bcolor": "62",
    "Y": 5,
    "L": 27.8512954711914,
    "a": 5.9984655380249,
    "b": 2.41641998291016,
    "C": 6.46689081192017,
    "h": 21.9415321350098,
    "CMY_C": 0.70042675733566,
    "CMY_M": 0.75469899177551,
    "CMY_Y": 0.75809323787689,
    "CMYK_C": 0,
    "CMYK_M": 0.18116515874863,
    "CMYK_Y": 0.1924954354763,
    "CMYK_K": 0.70042675733566
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R213025",
    "Farbtonhilfsbezeichnung": "R21 30 25",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "54",
    "Bcolor": "58",
    "Y": 6,
    "L": 30.3547534942627,
    "a": 25.6710090637207,
    "b": 9.07709980010986,
    "C": 27.2285594940186,
    "h": 19.473258972168,
    "CMY_C": 0.5635204911232,
    "CMY_M": 0.78659009933472,
    "CMY_Y": 0.77275782823563,
    "CMYK_C": 0,
    "CMYK_M": 0.51106548309326,
    "CMYK_Y": 0.47937494516373,
    "CMYK_K": 0.5635204911232
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R213535",
    "Farbtonhilfsbezeichnung": "R21 35 35 Krapplack",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "58",
    "Bcolor": "64",
    "Y": 8,
    "L": 35.1961784362793,
    "a": 34.1399154663086,
    "b": 12.2678871154785,
    "C": 36.2771949768066,
    "h": 19.7654666900635,
    "CMY_C": 0.46770644187927,
    "CMY_M": 0.77309691905975,
    "CMY_Y": 0.74797141551971,
    "CMYK_C": 0,
    "CMYK_M": 0.57372564077377,
    "CMYK_Y": 0.52652335166931,
    "CMYK_K": 0.46770644187927
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R214005",
    "Farbtonhilfsbezeichnung": "R21 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "91",
    "Bcolor": "90",
    "Y": 11,
    "L": 39.9069976806641,
    "a": 4.81302642822266,
    "b": 1.95362281799316,
    "C": 5.19440698623657,
    "h": 22.0923900604248,
    "CMY_C": 0.59476262331009,
    "CMY_M": 0.64159572124481,
    "CMY_Y": 0.64605736732483,
    "CMYK_C": 0,
    "CMYK_M": 0.11556953936815,
    "CMYK_Y": 0.12657949328423,
    "CMYK_K": 0.59476262331009
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R214020",
    "Farbtonhilfsbezeichnung": "R21 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "83",
    "Bcolor": "84",
    "Y": 11,
    "L": 40.235164642334,
    "a": 19.0827331542969,
    "b": 6.74772357940674,
    "C": 20.2406139373779,
    "h": 19.4737796783447,
    "CMY_C": 0.4987758398056,
    "CMY_M": 0.67464870214462,
    "CMY_Y": 0.67107176780701,
    "CMYK_C": 0,
    "CMYK_M": 0.35088664293289,
    "CMYK_Y": 0.34375023841858,
    "CMYK_K": 0.4987758398056
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R214030",
    "Farbtonhilfsbezeichnung": "R21 40 30",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "75",
    "Bcolor": "78",
    "Y": 11,
    "L": 40.2161254882813,
    "a": 28.5929279327393,
    "b": 10.774395942688,
    "C": 30.5555744171143,
    "h": 20.6474285125732,
    "CMY_C": 0.44270741939545,
    "CMY_M": 0.70466476678848,
    "CMY_Y": 0.69481885433197,
    "CMYK_C": 0,
    "CMYK_M": 0.47005352377892,
    "CMYK_Y": 0.45238614082336,
    "CMYK_K": 0.44270741939545
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R214045",
    "Farbtonhilfsbezeichnung": "R21 40 45 Karminrot",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "61",
    "Bcolor": "71",
    "Y": 11,
    "L": 40.5740776062012,
    "a": 43.149845123291,
    "b": 15.7847309112549,
    "C": 45.946346282959,
    "h": 20.0931262969971,
    "CMY_C": 0.36081737279892,
    "CMY_M": 0.76014405488968,
    "CMY_Y": 0.71983361244202,
    "CMYK_C": 0,
    "CMYK_M": 0.62474584579468,
    "CMYK_Y": 0.56168019771576,
    "CMYK_K": 0.36081737279892
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R215010",
    "Farbtonhilfsbezeichnung": "R21 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "113",
    "Bcolor": "112",
    "Y": 18,
    "L": 49.977840423584,
    "a": 9.27571105957031,
    "b": 3.52006912231445,
    "C": 9.92117404937744,
    "h": 20.7814121246338,
    "CMY_C": 0.46285802125931,
    "CMY_M": 0.55515539646149,
    "CMY_Y": 0.55945456027985,
    "CMYK_C": 0,
    "CMYK_M": 0.17183050513268,
    "CMYK_Y": 0.17983427643776,
    "CMYK_K": 0.46285802125931
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R215020",
    "Farbtonhilfsbezeichnung": "R21 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "107",
    "Bcolor": "107",
    "Y": 18,
    "L": 49.8843994140625,
    "a": 18.8657474517822,
    "b": 6.96654319763184,
    "C": 20.1109218597412,
    "h": 20.2676448822021,
    "CMY_C": 0.39873623847961,
    "CMY_M": 0.58137011528015,
    "CMY_Y": 0.58146512508392,
    "CMYK_C": 0,
    "CMYK_M": 0.30375000834465,
    "CMYK_Y": 0.30390802025795,
    "CMYK_K": 0.39873623847961
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R215030",
    "Farbtonhilfsbezeichnung": "R21 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "100",
    "Bcolor": "102",
    "Y": 18,
    "L": 50.0137977600098,
    "a": 28.1214466094971,
    "b": 10.0621166229248,
    "C": 29.8674068450928,
    "h": 19.6876831054688,
    "CMY_C": 0.33987927436829,
    "CMY_M": 0.60803651809692,
    "CMY_Y": 0.59886014461517,
    "CMYK_C": 0,
    "CMYK_M": 0.40622454881668,
    "CMYK_Y": 0.39232349395752,
    "CMYK_K": 0.33987927436829
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R215515",
    "Farbtonhilfsbezeichnung": "R21 55 15",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "123",
    "Bcolor": "122",
    "Y": 23,
    "L": 55.0052070617676,
    "a": 14.0067892074585,
    "b": 5.27506113052368,
    "C": 14.9671783447266,
    "h": 20.6367473602295,
    "CMY_C": 0.37718206644058,
    "CMY_M": 0.51749193668365,
    "CMY_Y": 0.52113717794418,
    "CMYK_C": 0,
    "CMYK_M": 0.22528232634068,
    "CMYK_Y": 0.23113514482975,
    "CMYK_K": 0.37718206644058
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R215525",
    "Farbtonhilfsbezeichnung": "R21 55 25",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "116",
    "Bcolor": "117",
    "Y": 23,
    "L": 55.0008239746094,
    "a": 23.3735485076904,
    "b": 8.43141555786133,
    "C": 24.8477668762207,
    "h": 19.8356246948242,
    "CMY_C": 0.31489396095276,
    "CMY_M": 0.54383629560471,
    "CMY_Y": 0.54070490598679,
    "CMYK_C": 0,
    "CMYK_M": 0.33417066931725,
    "CMYK_Y": 0.32960000634193,
    "CMYK_K": 0.31489396095276
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216005",
    "Farbtonhilfsbezeichnung": "R21 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "142",
    "Bcolor": "141",
    "Y": 28,
    "L": 60.0583343505859,
    "a": 4.76197385787964,
    "b": 1.82537281513214,
    "C": 5.09984111785889,
    "h": 20.9729633331299,
    "CMY_C": 0.39327949285507,
    "CMY_M": 0.44323140382767,
    "CMY_Y": 0.44874507188797,
    "CMYK_C": 0,
    "CMYK_M": 0.08233100920916,
    "CMYK_Y": 0.09141866862774,
    "CMYK_K": 0.39327949285507
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216013",
    "Farbtonhilfsbezeichnung": "R21 60 13",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "136",
    "Bcolor": "135",
    "Y": 28,
    "L": 59.411491394043,
    "a": 11.8619117736816,
    "b": 4.32291030883789,
    "C": 12.6250743865967,
    "h": 20.0235729217529,
    "CMY_C": 0.34632867574692,
    "CMY_M": 0.46747732162476,
    "CMY_Y": 0.47120243310928,
    "CMYK_C": 0,
    "CMYK_M": 0.18533572554588,
    "CMYK_Y": 0.19103448092937,
    "CMYK_K": 0.34632867574692
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216020",
    "Farbtonhilfsbezeichnung": "R21 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "132",
    "Bcolor": "131",
    "Y": 28,
    "L": 59.6465530395508,
    "a": 18.4732666015625,
    "b": 6.92422771453857,
    "C": 19.7283172607422,
    "h": 20.5472145080566,
    "CMY_C": 0.29650962352753,
    "CMY_M": 0.48297667503357,
    "CMY_Y": 0.48544043302536,
    "CMYK_C": 0,
    "CMYK_M": 0.26505985856056,
    "CMYK_Y": 0.26856204867363,
    "CMYK_K": 0.29650962352753
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216040",
    "Farbtonhilfsbezeichnung": "R21 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "118",
    "Bcolor": "123",
    "Y": 28,
    "L": 60.1573524475098,
    "a": 36.8849563598633,
    "b": 12.9523124694824,
    "C": 39.0929985046387,
    "h": 19.3489456176758,
    "CMY_C": 0.17287522554398,
    "CMY_M": 0.53596389293671,
    "CMY_Y": 0.51785886287689,
    "CMYK_C": 0,
    "CMYK_M": 0.43897688388824,
    "CMYK_Y": 0.41708779335022,
    "CMYK_K": 0.17287522554398
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216510",
    "Farbtonhilfsbezeichnung": "R21 65 10",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "152",
    "Bcolor": "151",
    "Y": 34,
    "L": 64.984016418457,
    "a": 9.37520217895508,
    "b": 3.37296915054321,
    "C": 9.96350002288818,
    "h": 19.7874946594238,
    "CMY_C": 0.30582046508789,
    "CMY_M": 0.40398794412613,
    "CMY_Y": 0.40853196382523,
    "CMYK_C": 0,
    "CMYK_M": 0.14141511917114,
    "CMYK_Y": 0.1479610055685,
    "CMYK_K": 0.30582046508789
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R216515",
    "Farbtonhilfsbezeichnung": "R21 65 15",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "148",
    "Bcolor": "147",
    "Y": 34,
    "L": 64.7082901000977,
    "a": 14.4984865188599,
    "b": 5.28712940216064,
    "C": 15.4324283599854,
    "h": 20.0352764129639,
    "CMY_C": 0.27026695013046,
    "CMY_M": 0.4202521443367,
    "CMY_Y": 0.42377924919128,
    "CMYK_C": 0,
    "CMYK_M": 0.20553432404995,
    "CMYK_Y": 0.21036775410175,
    "CMYK_K": 0.27026695013046
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R217005",
    "Farbtonhilfsbezeichnung": "R21 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "168",
    "Bcolor": "167",
    "Y": 41,
    "L": 69.9076538085938,
    "a": 4.88407802581787,
    "b": 1.70335292816162,
    "C": 5.17258453369141,
    "h": 19.2265377044678,
    "CMY_C": 0.28906202316284,
    "CMY_M": 0.34138345718384,
    "CMY_Y": 0.3466295003891,
    "CMYK_C": 0,
    "CMYK_M": 0.07359493523836,
    "CMYK_Y": 0.08097398281097,
    "CMYK_K": 0.28906202316284
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R217007",
    "Farbtonhilfsbezeichnung": "R21 70 07",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "167",
    "Bcolor": "165",
    "Y": 41,
    "L": 69.9230880737305,
    "a": 7.0661940574646,
    "b": 2.51091027259827,
    "C": 7.49905109405518,
    "h": 19.5622253417969,
    "CMY_C": 0.27113032341003,
    "CMY_M": 0.34664422273636,
    "CMY_Y": 0.35181820392609,
    "CMYK_C": 0,
    "CMYK_M": 0.10360411554575,
    "CMYK_Y": 0.11070275306702,
    "CMYK_K": 0.27113032341003
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R217010",
    "Farbtonhilfsbezeichnung": "R21 70 10",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "165",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.7097702026367,
    "a": 9.31865215301514,
    "b": 3.24901938438416,
    "C": 9.86880970001221,
    "h": 19.2215003967285,
    "CMY_C": 0.25577539205551,
    "CMY_M": 0.35457891225815,
    "CMY_Y": 0.35888248682022,
    "CMYK_C": 0,
    "CMYK_M": 0.13276034593582,
    "CMYK_Y": 0.13854297995567,
    "CMYK_K": 0.25577539205551
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R217030",
    "Farbtonhilfsbezeichnung": "R21 70 30",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "152",
    "Bcolor": "152",
    "Y": 41,
    "L": 69.9560775756836,
    "a": 28.1576766967773,
    "b": 10.2304515838623,
    "C": 29.9585857391357,
    "h": 19.9674644470215,
    "CMY_C": 0.11594420671463,
    "CMY_M": 0.40546143054962,
    "CMY_Y": 0.4020864367485,
    "CMYK_C": 0,
    "CMYK_M": 0.3274874985218,
    "CMYK_Y": 0.32366988062859,
    "CMYK_K": 0.11594420671463
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R217505",
    "Farbtonhilfsbezeichnung": "R21 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "181",
    "Bcolor": "179",
    "Y": 48,
    "L": 74.585563659668,
    "a": 4.71665573120117,
    "b": 1.64086031913757,
    "C": 4.9939227104187,
    "h": 19.1820888519287,
    "CMY_C": 0.24018841981888,
    "CMY_M": 0.29140812158585,
    "CMY_Y": 0.29704856872559,
    "CMYK_C": 0,
    "CMYK_M": 0.06741105765104,
    "CMYK_Y": 0.07483454048634,
    "CMYK_K": 0.24018841981888
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R218005",
    "Farbtonhilfsbezeichnung": "R21 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "195",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.8159637451172,
    "a": 5.01040315628052,
    "b": 1.68518579006195,
    "C": 5.28620767593384,
    "h": 18.5897159576416,
    "CMY_C": 0.18095803260803,
    "CMY_M": 0.23594152927399,
    "CMY_Y": 0.24158871173859,
    "CMYK_C": 0,
    "CMYK_M": 0.06713147461414,
    "CMYK_Y": 0.07402633875608,
    "CMYK_K": 0.18095803260803
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R218020",
    "Farbtonhilfsbezeichnung": "R21 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "185",
    "Bcolor": "184",
    "Y": 57,
    "L": 79.5510406494141,
    "a": 19.0178871154785,
    "b": 6.644127368927,
    "C": 20.1450843811035,
    "h": 19.2574768066406,
    "CMY_C": 0.07256662845612,
    "CMY_M": 0.27628618478775,
    "CMY_Y": 0.27794581651688,
    "CMYK_C": 0,
    "CMYK_M": 0.21965950727463,
    "CMYK_Y": 0.2214489877224,
    "CMYK_K": 0.07256662845612
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R218505",
    "Farbtonhilfsbezeichnung": "R21 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "208",
    "Bcolor": "207",
    "Y": 66,
    "L": 84.6268615722656,
    "a": 4.85785150527954,
    "b": 1.64969623088837,
    "C": 5.13032341003418,
    "h": 18.7571678161621,
    "CMY_C": 0.12915605306625,
    "CMY_M": 0.18319708108902,
    "CMY_Y": 0.18940329551697,
    "CMYK_C": 0,
    "CMYK_M": 0.06205592676997,
    "CMYK_Y": 0.06918258965015,
    "CMYK_K": 0.12915605306625
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R218510",
    "Farbtonhilfsbezeichnung": "R21 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "205",
    "Bcolor": "203",
    "Y": 66,
    "L": 84.4021148681641,
    "a": 9.21060657501221,
    "b": 3.23105549812317,
    "C": 9.76089096069336,
    "h": 19.3307304382324,
    "CMY_C": 0.09489166736603,
    "CMY_M": 0.1969022154808,
    "CMY_Y": 0.20272475481033,
    "CMYK_C": 0,
    "CMYK_M": 0.11270534992218,
    "CMYK_Y": 0.1191383227706,
    "CMYK_K": 0.09489166736603
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R219005",
    "Farbtonhilfsbezeichnung": "R21 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 76,
    "L": 89.6142044067383,
    "a": 4.91490364074707,
    "b": 1.61681652069092,
    "C": 5.17400932312012,
    "h": 18.2092418670654,
    "CMY_C": 0.07320237159729,
    "CMY_M": 0.12837040424347,
    "CMY_Y": 0.13462948799133,
    "CMYK_C": 0,
    "CMYK_M": 0.05952543392777,
    "CMYK_Y": 0.06627888977528,
    "CMYK_K": 0.07320237159729
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R219305",
    "Farbtonhilfsbezeichnung": "R21 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 83,
    "L": 92.7431182861328,
    "a": 4.87025928497314,
    "b": 1.72583436965942,
    "C": 5.16700410842896,
    "h": 19.5123863220215,
    "CMY_C": 0.0379701256752,
    "CMY_M": 0.09347528219223,
    "CMY_Y": 0.1009019613266,
    "CMYK_C": 0,
    "CMYK_M": 0.05769587680697,
    "CMYK_Y": 0.06541568040848,
    "CMYK_K": 0.0379701256752
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R224010",
    "Farbtonhilfsbezeichnung": "R22 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "90",
    "Bcolor": "91",
    "Y": 11,
    "L": 40.493782043457,
    "a": 9.63125419616699,
    "b": 2.75061011314392,
    "C": 10.0163326263428,
    "h": 15.9389228820801,
    "CMY_C": 0.55774956941605,
    "CMY_M": 0.64714354276657,
    "CMY_Y": 0.64495062828064,
    "CMYK_C": 0,
    "CMYK_M": 0.20213428139687,
    "CMYK_Y": 0.19717574119568,
    "CMYK_K": 0.55774956941605
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R224020",
    "Farbtonhilfsbezeichnung": "R22 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "84",
    "Bcolor": "87",
    "Y": 11,
    "L": 40.5211067199707,
    "a": 18.866886138916,
    "b": 5.00772571563721,
    "C": 19.5201606750488,
    "h": 14.8649282455444,
    "CMY_C": 0.50015306472778,
    "CMY_M": 0.67091655731201,
    "CMY_Y": 0.65755409002304,
    "CMYK_C": 0,
    "CMYK_M": 0.34163156151772,
    "CMYK_Y": 0.31489846110344,
    "CMYK_K": 0.50015306472778
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R225005",
    "Farbtonhilfsbezeichnung": "R22 50 05",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "116",
    "Bcolor": "115",
    "Y": 18,
    "L": 49.7962913513184,
    "a": 5.06540536880493,
    "b": 1.50560939311981,
    "C": 5.28442907333374,
    "h": 16.5537242889404,
    "CMY_C": 0.49687319993973,
    "CMY_M": 0.54669761657715,
    "CMY_Y": 0.54860258102417,
    "CMYK_C": 0,
    "CMYK_M": 0.09902954101563,
    "CMYK_Y": 0.10281579196453,
    "CMYK_K": 0.49687319993973
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R225015",
    "Farbtonhilfsbezeichnung": "R22 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "110",
    "Bcolor": "111",
    "Y": 18,
    "L": 49.847240447998,
    "a": 14.7877836227417,
    "b": 4.20805692672729,
    "C": 15.3748588562012,
    "h": 15.8843955993652,
    "CMY_C": 0.42882424592972,
    "CMY_M": 0.57023143768311,
    "CMY_Y": 0.56443762779236,
    "CMYK_C": 0,
    "CMYK_M": 0.24757212400436,
    "CMYK_Y": 0.23742845654488,
    "CMYK_K": 0.42882424592972
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R225030",
    "Farbtonhilfsbezeichnung": "R22 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "99",
    "Bcolor": "106",
    "Y": 18,
    "L": 49.9084510803223,
    "a": 28.8210220336914,
    "b": 7.52337884902954,
    "C": 29.7867851257324,
    "h": 14.6299028396606,
    "CMY_C": 0.34145927429199,
    "CMY_M": 0.61060476303101,
    "CMY_Y": 0.58324074745178,
    "CMYK_C": 0,
    "CMYK_M": 0.40869984030724,
    "CMYK_Y": 0.36714732646942,
    "CMYK_K": 0.34145927429199
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R225525",
    "Farbtonhilfsbezeichnung": "R22 55 25",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "115",
    "Bcolor": "119",
    "Y": 23,
    "L": 54.5779571533203,
    "a": 24.1590080261231,
    "b": 6.68507862091064,
    "C": 25.0668697357178,
    "h": 15.4673852920532,
    "CMY_C": 0.31828993558884,
    "CMY_M": 0.54987913370132,
    "CMY_Y": 0.53313803672791,
    "CMYK_C": 0,
    "CMYK_M": 0.33971801400185,
    "CMYK_Y": 0.31516051292419,
    "CMYK_K": 0.31828993558884
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R226010",
    "Farbtonhilfsbezeichnung": "R22 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "137",
    "Bcolor": "138",
    "Y": 28,
    "L": 59.3913421630859,
    "a": 9.57785511016846,
    "b": 2.59529328346252,
    "C": 9.92324829101563,
    "h": 15.161262512207,
    "CMY_C": 0.36573284864426,
    "CMY_M": 0.46160137653351,
    "CMY_Y": 0.46004247665405,
    "CMYK_C": 0,
    "CMYK_M": 0.15114849805832,
    "CMYK_Y": 0.14869070053101,
    "CMYK_K": 0.36573284864426
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R226020",
    "Farbtonhilfsbezeichnung": "R22 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "132",
    "Bcolor": "135",
    "Y": 28,
    "L": 59.7298851013184,
    "a": 19.3048191070557,
    "b": 5.13559055328369,
    "C": 19.9762439727783,
    "h": 14.897159576416,
    "CMY_C": 0.29439115524292,
    "CMY_M": 0.48391610383987,
    "CMY_Y": 0.47239154577255,
    "CMYK_C": 0,
    "CMYK_M": 0.26859775185585,
    "CMYK_Y": 0.25226497650146,
    "CMYK_K": 0.29439115524292
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R227005",
    "Farbtonhilfsbezeichnung": "R22 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "167",
    "Bcolor": "167",
    "Y": 41,
    "L": 69.6552810668945,
    "a": 5.09455347061157,
    "b": 1.24483108520508,
    "C": 5.24443340301514,
    "h": 13.7309169769287,
    "CMY_C": 0.29161334037781,
    "CMY_M": 0.34440964460373,
    "CMY_Y": 0.34602689743042,
    "CMYK_C": 0,
    "CMYK_M": 0.07453034818172,
    "CMYK_Y": 0.07681335508823,
    "CMYK_K": 0.29161334037781
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R227015",
    "Farbtonhilfsbezeichnung": "R22 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "162",
    "Bcolor": "164",
    "Y": 41,
    "L": 70.1196899414063,
    "a": 14.727746963501,
    "b": 3.85325527191162,
    "C": 15.2234725952148,
    "h": 14.6617860794067,
    "CMY_C": 0.21328312158585,
    "CMY_M": 0.36417460441589,
    "CMY_Y": 0.35805332660675,
    "CMYK_C": 0,
    "CMYK_M": 0.19179897010326,
    "CMYK_Y": 0.18401817977428,
    "CMYK_K": 0.21328312158585
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R228010",
    "Farbtonhilfsbezeichnung": "R22 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "191",
    "Bcolor": "192",
    "Y": 57,
    "L": 79.7339706420898,
    "a": 10.0102844238281,
    "b": 2.41321516036987,
    "C": 10.2970581054688,
    "h": 13.5538816452026,
    "CMY_C": 0.1435307264328,
    "CMY_M": 0.24937635660172,
    "CMY_Y": 0.24699050188065,
    "CMYK_C": 0,
    "CMYK_M": 0.12358368933201,
    "CMYK_Y": 0.12079799920321,
    "CMYK_K": 0.1435307264328
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R228505",
    "Farbtonhilfsbezeichnung": "R22 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "209",
    "Bcolor": "209",
    "Y": 66,
    "L": 85.0168838500977,
    "a": 5.0450553894043,
    "b": 1.1108273267746,
    "C": 5.16589975357056,
    "h": 12.4173316955566,
    "CMY_C": 0.12511813640594,
    "CMY_M": 0.17922699451447,
    "CMY_Y": 0.18120861053467,
    "CMYK_C": 0,
    "CMYK_M": 0.06184704601765,
    "CMYK_Y": 0.06411205232143,
    "CMYK_K": 0.12511813640594
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R233015",
    "Farbtonhilfsbezeichnung": "R23 30 15",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "63",
    "Bcolor": "68",
    "Y": 6,
    "L": 30.5010414123535,
    "a": 14.7718324661255,
    "b": 2.36174583435059,
    "C": 14.9594411849976,
    "h": 9.08366870880127,
    "CMY_C": 0.62741965055466,
    "CMY_M": 0.75166666507721,
    "CMY_Y": 0.73319435119629,
    "CMYK_C": 0,
    "CMYK_M": 0.33347710967064,
    "CMYK_Y": 0.28389769792557,
    "CMYK_K": 0.62741965055466
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R233020",
    "Farbtonhilfsbezeichnung": "R23 30 20",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "58",
    "Bcolor": "66",
    "Y": 6,
    "L": 30.0978755950928,
    "a": 20.2983283996582,
    "b": 3.51008176803589,
    "C": 20.5995826721191,
    "h": 9.81083106994629,
    "CMY_C": 0.60072064399719,
    "CMY_M": 0.77070760726929,
    "CMY_Y": 0.74282783269882,
    "CMYK_C": 0,
    "CMYK_M": 0.42573440074921,
    "CMYK_Y": 0.35590916872025,
    "CMYK_K": 0.60072064399719
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R234003",
    "Farbtonhilfsbezeichnung": "R23 40 03",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "92",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.8602905273438,
    "a": 2.95218873023987,
    "b": 0.72734761238098,
    "C": 3.0404691696167,
    "h": 13.8406362533569,
    "CMY_C": 0.61022484302521,
    "CMY_M": 0.63775253295898,
    "CMY_Y": 0.6390186548233,
    "CMYK_C": 0,
    "CMYK_M": 0.07062453776598,
    "CMYK_Y": 0.07387287914753,
    "CMYK_K": 0.61022484302521
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R234015",
    "Farbtonhilfsbezeichnung": "R23 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "85",
    "Bcolor": "89",
    "Y": 11,
    "L": 39.9018440246582,
    "a": 14.6818742752075,
    "b": 2.79809951782227,
    "C": 14.9461297988892,
    "h": 10.7901420593262,
    "CMY_C": 0.53415906429291,
    "CMY_M": 0.66509401798248,
    "CMY_Y": 0.65008950233459,
    "CMYK_C": 0,
    "CMYK_M": 0.28107222914696,
    "CMYK_Y": 0.24886271357536,
    "CMYK_K": 0.53415906429291
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R234035",
    "Farbtonhilfsbezeichnung": "R23 40 35",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "71",
    "Bcolor": "86",
    "Y": 11,
    "L": 40.2692718505859,
    "a": 34.1742668151855,
    "b": 5.94345951080322,
    "C": 34.6872482299805,
    "h": 9.8659839630127,
    "CMY_C": 0.42078471183777,
    "CMY_M": 0.72247922420502,
    "CMY_Y": 0.66326934099197,
    "CMYK_C": 0,
    "CMYK_M": 0.52086764574051,
    "CMYK_Y": 0.41864335536957,
    "CMYK_K": 0.42078471183777
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R235003",
    "Farbtonhilfsbezeichnung": "R23 50 03",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "117",
    "Bcolor": "117",
    "Y": 18,
    "L": 49.8457794189453,
    "a": 2.84631872177124,
    "b": 0.68643718957901,
    "C": 2.92792177200317,
    "h": 13.5589208602905,
    "CMY_C": 0.51347327232361,
    "CMY_M": 0.54109215736389,
    "CMY_Y": 0.5430383682251,
    "CMYK_C": 0,
    "CMYK_M": 0.0567674562335,
    "CMYK_Y": 0.0607676692307,
    "CMYK_K": 0.51347327232361
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R235020",
    "Farbtonhilfsbezeichnung": "R23 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "107",
    "Bcolor": "113",
    "Y": 18,
    "L": 50.2913627624512,
    "a": 19.797082901001,
    "b": 3.72677040100098,
    "C": 20.1448078155518,
    "h": 10.6610765457153,
    "CMY_C": 0.39554667472839,
    "CMY_M": 0.57907688617706,
    "CMY_Y": 0.55624806880951,
    "CMYK_C": 0,
    "CMYK_M": 0.30363008379936,
    "CMYK_Y": 0.26586237549782,
    "CMYK_K": 0.39554667472839
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R236003",
    "Farbtonhilfsbezeichnung": "R23 60 03",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "143",
    "Bcolor": "143",
    "Y": 28,
    "L": 59.9983406066895,
    "a": 2.89717936515808,
    "b": 0.56287187337875,
    "C": 2.95135116577148,
    "h": 10.9946117401123,
    "CMY_C": 0.41057926416397,
    "CMY_M": 0.43926924467087,
    "CMY_Y": 0.44102603197098,
    "CMYK_C": 0,
    "CMYK_M": 0.0486748740077,
    "CMYK_Y": 0.05165540799499,
    "CMYK_K": 0.41057926416397
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R236025",
    "Farbtonhilfsbezeichnung": "R23 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "127",
    "Bcolor": "135",
    "Y": 28,
    "L": 59.2434272766113,
    "a": 24.7133235931396,
    "b": 4.14930486679077,
    "C": 25.0592308044434,
    "h": 9.53092288970947,
    "CMY_C": 0.26913303136826,
    "CMY_M": 0.50388216972351,
    "CMY_Y": 0.46979337930679,
    "CMYK_C": 0,
    "CMYK_M": 0.32119271159172,
    "CMYK_Y": 0.27455112338066,
    "CMYK_K": 0.26913303136826
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R236035",
    "Farbtonhilfsbezeichnung": "R23 60 35",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "120",
    "Bcolor": "134",
    "Y": 28,
    "L": 59.7341117858887,
    "a": 34.0718154907227,
    "b": 5.84683895111084,
    "C": 34.5698432922363,
    "h": 9.73730850219727,
    "CMY_C": 0.20575368404388,
    "CMY_M": 0.52864080667496,
    "CMY_Y": 0.47477746009827,
    "CMYK_C": 0,
    "CMYK_M": 0.40653273463249,
    "CMYK_Y": 0.33871579170227,
    "CMYK_K": 0.20575368404388
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R237003",
    "Farbtonhilfsbezeichnung": "R23 70 03",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "169",
    "Bcolor": "169",
    "Y": 41,
    "L": 69.9345932006836,
    "a": 3.00709843635559,
    "b": 0.50423347949982,
    "C": 3.04908061027527,
    "h": 9.51886367797852,
    "CMY_C": 0.30596405267715,
    "CMY_M": 0.33638858795166,
    "CMY_Y": 0.33820599317551,
    "CMYK_C": 0,
    "CMYK_M": 0.04383711889386,
    "CMYK_Y": 0.0464557223022,
    "CMYK_K": 0.30596405267715
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R237010",
    "Farbtonhilfsbezeichnung": "R23 70 10",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "166",
    "Bcolor": "168",
    "Y": 41,
    "L": 70.2760009765625,
    "a": 9.63278579711914,
    "b": 1.60588836669922,
    "C": 9.76572799682617,
    "h": 9.46477699279785,
    "CMY_C": 0.25202339887619,
    "CMY_M": 0.34895581007004,
    "CMY_Y": 0.34144169092178,
    "CMYK_C": 0,
    "CMYK_M": 0.12959283590317,
    "CMYK_Y": 0.11954691261053,
    "CMYK_K": 0.25202339887619
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R237020",
    "Farbtonhilfsbezeichnung": "R23 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "158",
    "Bcolor": "164",
    "Y": 41,
    "L": 69.9784469604492,
    "a": 19.9036102294922,
    "b": 3.40552997589111,
    "C": 20.1928539276123,
    "h": 9.70935153961182,
    "CMY_C": 0.18213903903961,
    "CMY_M": 0.37941831350327,
    "CMY_Y": 0.35562306642532,
    "CMYK_C": 0,
    "CMYK_M": 0.24121370911598,
    "CMYK_Y": 0.21211922168732,
    "CMYK_K": 0.18213903903961
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R238003",
    "Farbtonhilfsbezeichnung": "R23 80 03",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "197",
    "Bcolor": "196",
    "Y": 57,
    "L": 79.9884948730469,
    "a": 3.10574769973755,
    "b": 0.42753022909164,
    "C": 3.1350359916687,
    "h": 7.83794689178467,
    "CMY_C": 0.19720202684402,
    "CMY_M": 0.22916275262833,
    "CMY_Y": 0.23094707727432,
    "CMYK_C": 0,
    "CMYK_M": 0.03981166705489,
    "CMYK_Y": 0.04203429818153,
    "CMYK_K": 0.19720202684402
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R238015",
    "Farbtonhilfsbezeichnung": "R23 80 15",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "189",
    "Bcolor": "193",
    "Y": 57,
    "L": 80.0211791992188,
    "a": 14.8973293304443,
    "b": 2.52840948104858,
    "C": 15.110369682312,
    "h": 9.63258266448975,
    "CMY_C": 0.10577178001404,
    "CMY_M": 0.25893777608871,
    "CMY_Y": 0.24402403831482,
    "CMYK_C": 0,
    "CMYK_M": 0.1712828874588,
    "CMYK_Y": 0.15460512042046,
    "CMYK_K": 0.10577178001404
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R238510",
    "Farbtonhilfsbezeichnung": "R23 85 10",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "206",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.9921340942383,
    "a": 9.85230922698975,
    "b": 1.55311870574951,
    "C": 9.97397518157959,
    "h": 8.95839023590088,
    "CMY_C": 0.08856147527695,
    "CMY_M": 0.19159919023514,
    "CMY_Y": 0.18401503562927,
    "CMYK_C": 0,
    "CMYK_M": 0.1130495518446,
    "CMYK_Y": 0.10472846776247,
    "CMYK_K": 0.08856147527695
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R238808",
    "Farbtonhilfsbezeichnung": "R23 88 08",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "215",
    "Bcolor": "216",
    "Y": 72,
    "L": 87.6596755981445,
    "a": 7.69224977493286,
    "b": 1.1684502363205,
    "C": 7.78048706054688,
    "h": 8.63718414306641,
    "CMY_C": 0.07567828893661,
    "CMY_M": 0.15674430131912,
    "CMY_Y": 0.15239208936691,
    "CMYK_C": 0,
    "CMYK_M": 0.08770324289799,
    "CMYK_Y": 0.08299469947815,
    "CMYK_K": 0.07567828893661
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R239003",
    "Farbtonhilfsbezeichnung": "R23 90 03",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "225",
    "Bcolor": "224",
    "Y": 76,
    "L": 89.96728515625,
    "a": 2.75047945976257,
    "b": 0.3935461640358,
    "C": 2.77849173545837,
    "h": 8.1427698135376,
    "CMY_C": 0.08982419967651,
    "CMY_M": 0.11881989240646,
    "CMY_Y": 0.12202262878418,
    "CMYK_C": 0,
    "CMYK_M": 0.03185724467039,
    "CMYK_Y": 0.03537605330348,
    "CMYK_K": 0.08982419967651
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R239005",
    "Farbtonhilfsbezeichnung": "R23 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "223",
    "Bcolor": "223",
    "Y": 76,
    "L": 90.0010299682617,
    "a": 5.00749731063843,
    "b": 0.81579720973969,
    "C": 5.07351493835449,
    "h": 9.25305938720703,
    "CMY_C": 0.07071888446808,
    "CMY_M": 0.12407720088959,
    "CMY_Y": 0.1244490146637,
    "CMYK_C": 0,
    "CMYK_M": 0.05741892009974,
    "CMYK_Y": 0.05781902745366,
    "CMYK_K": 0.07071888446808
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R239010",
    "Farbtonhilfsbezeichnung": "R23 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "219",
    "Bcolor": "221",
    "Y": 76,
    "L": 89.5599594116211,
    "a": 10.10657787323,
    "b": 1.65810835361481,
    "C": 10.2416915893555,
    "h": 9.3170747756958,
    "CMY_C": 0.03491812944412,
    "CMY_M": 0.14203095436096,
    "CMY_Y": 0.13478076457977,
    "CMYK_C": 0,
    "CMYK_M": 0.11098832637072,
    "CMYK_Y": 0.10347581654787,
    "CMYK_K": 0.03491812944412
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R244010",
    "Farbtonhilfsbezeichnung": "R24 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "89",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.124885559082,
    "a": 9.83740901947021,
    "b": 1.11114525794983,
    "C": 9.89996242523193,
    "h": 6.44430303573608,
    "CMY_C": 0.56394052505493,
    "CMY_M": 0.65069198608398,
    "CMY_Y": 0.63808071613312,
    "CMYK_C": 0,
    "CMYK_M": 0.19894410669804,
    "CMYK_Y": 0.17002311348915,
    "CMYK_K": 0.56394052505493
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R244020",
    "Farbtonhilfsbezeichnung": "R24 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "83",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.2092590332031,
    "a": 19.7199115753174,
    "b": 1.88912642002106,
    "C": 19.8101921081543,
    "h": 5.47211742401123,
    "CMY_C": 0.50462412834167,
    "CMY_M": 0.67538177967072,
    "CMY_Y": 0.6408229470253,
    "CMYK_C": 0,
    "CMYK_M": 0.34470319747925,
    "CMYK_Y": 0.27494034171104,
    "CMYK_K": 0.50462412834167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R245005",
    "Farbtonhilfsbezeichnung": "R24 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "117",
    "Bcolor": "117",
    "Y": 18,
    "L": 50.1182632446289,
    "a": 4.87440872192383,
    "b": 0.62540644407272,
    "C": 4.91436624526978,
    "h": 7.31133651733398,
    "CMY_C": 0.49731117486954,
    "CMY_M": 0.54287368059158,
    "CMY_Y": 0.53971421718597,
    "CMYK_C": 0,
    "CMYK_M": 0.09063759446144,
    "CMYK_Y": 0.08435246348381,
    "CMYK_K": 0.49731117486954
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R245015",
    "Farbtonhilfsbezeichnung": "R24 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "109",
    "Bcolor": "115",
    "Y": 18,
    "L": 49.6708335876465,
    "a": 14.835072517395,
    "b": 1.31594824790955,
    "C": 14.8933238983154,
    "h": 5.06916618347168,
    "CMY_C": 0.43690627813339,
    "CMY_M": 0.57130742073059,
    "CMY_Y": 0.5472823381424,
    "CMYK_C": 0,
    "CMYK_M": 0.23868343234062,
    "CMYK_Y": 0.19601720571518,
    "CMYK_K": 0.43690627813339
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R246010",
    "Farbtonhilfsbezeichnung": "R24 60 10",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "138",
    "Bcolor": "142",
    "Y": 28,
    "L": 59.8850555419922,
    "a": 9.91593837738037,
    "b": 0.88500863313675,
    "C": 9.95535373687744,
    "h": 5.1001992225647,
    "CMY_C": 0.36283075809479,
    "CMY_M": 0.45694255828857,
    "CMY_Y": 0.44342756271362,
    "CMYK_C": 0,
    "CMYK_M": 0.14770299196243,
    "CMYK_Y": 0.1264919936657,
    "CMYK_K": 0.36283075809479
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R247005",
    "Farbtonhilfsbezeichnung": "R24 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "167",
    "Bcolor": "168",
    "Y": 41,
    "L": 69.5659103393555,
    "a": 5.13621234893799,
    "b": 0.32572293281555,
    "C": 5.14653015136719,
    "h": 3.62866425514221,
    "CMY_C": 0.29502540826797,
    "CMY_M": 0.34519445896149,
    "CMY_Y": 0.34052795171738,
    "CMYK_C": 0,
    "CMYK_M": 0.07116433978081,
    "CMYK_Y": 0.0645449385047,
    "CMYK_K": 0.29502540826797
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R253008",
    "Farbtonhilfsbezeichnung": "R25 30 08",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "67",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.2232398986816,
    "a": 7.95086479187012,
    "b": 0.20781306922436,
    "C": 7.95358037948608,
    "h": 1.4972083568573,
    "CMY_C": 0.67220306396484,
    "CMY_M": 0.73727983236313,
    "CMY_Y": 0.72368788719177,
    "CMYK_C": 0,
    "CMYK_M": 0.19852769374847,
    "CMYK_Y": 0.15706315636635,
    "CMYK_K": 0.67220306396484
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R253030",
    "Farbtonhilfsbezeichnung": "R25 30 30",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "49",
    "Bcolor": "71",
    "Y": 6,
    "L": 29.76735496521,
    "a": 31.1378784179688,
    "b": -0.22800649702549,
    "C": 31.1387138366699,
    "h": 359.580474853516,
    "CMY_C": 0.55659186840057,
    "CMY_M": 0.80892562866211,
    "CMY_Y": 0.72209560871124,
    "CMYK_C": 0,
    "CMYK_M": 0.56907790899277,
    "CMYK_Y": 0.37325373291969,
    "CMYK_K": 0.55659186840057
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R254005",
    "Farbtonhilfsbezeichnung": "R25 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "92",
    "Bcolor": "94",
    "Y": 11,
    "L": 40.2014961242676,
    "a": 4.75409078598022,
    "b": 0.15292820334435,
    "C": 4.75654983520508,
    "h": 1.84243857860565,
    "CMY_C": 0.59694254398346,
    "CMY_M": 0.63823997974396,
    "CMY_Y": 0.63197952508926,
    "CMYK_C": 0,
    "CMYK_M": 0.1024604216218,
    "CMYK_Y": 0.08692800998688,
    "CMYK_K": 0.59694254398346
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R254015",
    "Farbtonhilfsbezeichnung": "R25 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "86",
    "Bcolor": "94",
    "Y": 11,
    "L": 40.223690032959,
    "a": 14.9379997253418,
    "b": 0.17124238610268,
    "C": 14.9389810562134,
    "h": 0.65678375959396,
    "CMY_C": 0.53510665893555,
    "CMY_M": 0.66201984882355,
    "CMY_Y": 0.63059169054031,
    "CMYK_C": 0,
    "CMYK_M": 0.27299422025681,
    "CMYK_Y": 0.20539125800133,
    "CMYK_K": 0.53510665893555
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R254045",
    "Farbtonhilfsbezeichnung": "R25 40 45",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "61",
    "Bcolor": "99",
    "Y": 11,
    "L": 41.4921913146973,
    "a": 46.5570602416992,
    "b": -0.16174182295799,
    "C": 46.5573425292969,
    "h": 359.800964355469,
    "CMY_C": 0.35441547632217,
    "CMY_M": 0.76158249378204,
    "CMY_Y": 0.61186814308167,
    "CMYK_C": 0,
    "CMYK_M": 0.630695104599,
    "CMYK_Y": 0.39879003167152,
    "CMYK_K": 0.35441547632217
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R255010",
    "Farbtonhilfsbezeichnung": "R25 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "112",
    "Bcolor": "117",
    "Y": 18,
    "L": 49.433723449707,
    "a": 10.1042718887329,
    "b": 0.09691003710032,
    "C": 10.104736328125,
    "h": 0.54950678348541,
    "CMY_C": 0.47168385982513,
    "CMY_M": 0.56157314777374,
    "CMY_Y": 0.54228442907333,
    "CMYK_C": 0,
    "CMYK_M": 0.17014299333096,
    "CMYK_Y": 0.13363318145275,
    "CMYK_K": 0.47168385982513
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R255020",
    "Farbtonhilfsbezeichnung": "R25 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "107",
    "Bcolor": "119",
    "Y": 18,
    "L": 50.0702438354492,
    "a": 20.0641784667969,
    "b": -0.18627136945724,
    "C": 20.0650424957275,
    "h": 359.468109130859,
    "CMY_C": 0.40479683876038,
    "CMY_M": 0.58087503910065,
    "CMY_Y": 0.53285890817642,
    "CMYK_C": 0,
    "CMYK_M": 0.29582872986794,
    "CMYK_Y": 0.21515689790249,
    "CMYK_K": 0.40479683876038
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R255030",
    "Farbtonhilfsbezeichnung": "R25 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "101",
    "Bcolor": "120",
    "Y": 18,
    "L": 50.5436744689941,
    "a": 29.6946105957031,
    "b": -0.00287567637861,
    "C": 29.6946105957031,
    "h": 359.994445800781,
    "CMY_C": 0.34371012449265,
    "CMY_M": 0.60488414764404,
    "CMY_Y": 0.52802360057831,
    "CMYK_C": 0,
    "CMYK_M": 0.39795526862144,
    "CMYK_Y": 0.28084155917168,
    "CMYK_K": 0.34371012449265
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R256005",
    "Farbtonhilfsbezeichnung": "R25 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "141",
    "Bcolor": "143",
    "Y": 28,
    "L": 59.6356620788574,
    "a": 4.89909505844116,
    "b": -0.04373053088784,
    "C": 4.89929008483887,
    "h": 359.488586425781,
    "CMY_C": 0.40210217237473,
    "CMY_M": 0.44735807180405,
    "CMY_Y": 0.44032984972,
    "CMYK_C": 0,
    "CMYK_M": 0.07569169253111,
    "CMYK_Y": 0.06393680721521,
    "CMYK_K": 0.40210217237473
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R256010",
    "Farbtonhilfsbezeichnung": "R25 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "139",
    "Bcolor": "144",
    "Y": 28,
    "L": 60.1549186706543,
    "a": 9.88257122039795,
    "b": 0.07349899411201,
    "C": 9.88284492492676,
    "h": 0.42611426115036,
    "CMY_C": 0.36242038011551,
    "CMY_M": 0.45389038324356,
    "CMY_Y": 0.43519371747971,
    "CMYK_C": 0,
    "CMYK_M": 0.14346444606781,
    "CMYK_Y": 0.11413999646902,
    "CMYK_K": 0.36242038011551
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R256015",
    "Farbtonhilfsbezeichnung": "R25 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "135",
    "Bcolor": "144",
    "Y": 28,
    "L": 59.8126335144043,
    "a": 15.324146270752,
    "b": -0.08402778953314,
    "C": 15.3243770599365,
    "h": 359.685821533203,
    "CMY_C": 0.33082008361816,
    "CMY_M": 0.47100740671158,
    "CMY_Y": 0.43686467409134,
    "CMYK_C": 0,
    "CMYK_M": 0.20949122309685,
    "CMYK_Y": 0.15846946835518,
    "CMYK_K": 0.33082008361816
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R256512",
    "Farbtonhilfsbezeichnung": "R25 65 12",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "150",
    "Bcolor": "157",
    "Y": 34,
    "L": 64.9706954956055,
    "a": 12.4801197052002,
    "b": -0.03296925500035,
    "C": 12.4801635742188,
    "h": 359.8486328125,
    "CMY_C": 0.29426121711731,
    "CMY_M": 0.41090548038483,
    "CMY_Y": 0.38478481769562,
    "CMYK_C": 0,
    "CMYK_M": 0.16527965664864,
    "CMYK_Y": 0.12826785445213,
    "CMYK_K": 0.29426121711731
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R257005",
    "Farbtonhilfsbezeichnung": "R25 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "169",
    "Bcolor": "170",
    "Y": 41,
    "L": 70.1293106079102,
    "a": 5.02228212356567,
    "b": -0.07957537472248,
    "C": 5.02291250228882,
    "h": 359.092254638672,
    "CMY_C": 0.29106950759888,
    "CMY_M": 0.33888530731201,
    "CMY_Y": 0.33180922269821,
    "CMYK_C": 0,
    "CMYK_M": 0.06744779646397,
    "CMYK_Y": 0.05746644362807,
    "CMYK_K": 0.29106950759888
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R257010",
    "Farbtonhilfsbezeichnung": "R25 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "165",
    "Bcolor": "170",
    "Y": 41,
    "L": 70.0596008300781,
    "a": 10.3729362487793,
    "b": -0.11148940771818,
    "C": 10.37353515625,
    "h": 359.384216308594,
    "CMY_C": 0.25409638881683,
    "CMY_M": 0.35258197784424,
    "CMY_Y": 0.33159101009369,
    "CMYK_C": 0,
    "CMYK_M": 0.13203527033329,
    "CMYK_Y": 0.10389361530542,
    "CMYK_K": 0.25409638881683
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R257015",
    "Farbtonhilfsbezeichnung": "R25 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "162",
    "Bcolor": "171",
    "Y": 41,
    "L": 70.1263961791992,
    "a": 14.8546619415283,
    "b": -0.15745143592358,
    "C": 14.8554964065552,
    "h": 359.392730712891,
    "CMY_C": 0.22288131713867,
    "CMY_M": 0.36329120397568,
    "CMY_Y": 0.32994699478149,
    "CMYK_C": 0,
    "CMYK_M": 0.18068011105061,
    "CMYK_Y": 0.13777261972427,
    "CMYK_K": 0.22288131713867
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R257508",
    "Farbtonhilfsbezeichnung": "R25 75 08",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "180",
    "Bcolor": "183",
    "Y": 48,
    "L": 74.8015670776367,
    "a": 7.73933458328247,
    "b": -0.18730302155018,
    "C": 7.74160099029541,
    "h": 358.613616943359,
    "CMY_C": 0.22152936458588,
    "CMY_M": 0.29588681459427,
    "CMY_Y": 0.28137570619583,
    "CMYK_C": 0,
    "CMYK_M": 0.09551734477282,
    "CMYK_Y": 0.07687681168318,
    "CMYK_K": 0.22152936458588
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R258005",
    "Farbtonhilfsbezeichnung": "R25 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 57,
    "L": 79.87060546875,
    "a": 5.07095670700073,
    "b": -0.08943871408701,
    "C": 5.0717453956604,
    "h": 358.989562988281,
    "CMY_C": 0.18543922901154,
    "CMY_M": 0.23499482870102,
    "CMY_Y": 0.22822612524033,
    "CMYK_C": 0,
    "CMYK_M": 0.06083720549941,
    "CMYK_Y": 0.05252756923437,
    "CMYK_K": 0.18543922901154
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R264010",
    "Farbtonhilfsbezeichnung": "R26 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "89",
    "Bcolor": "95",
    "Y": 11,
    "L": 40.0945053100586,
    "a": 9.69343090057373,
    "b": -0.83562582731247,
    "C": 9.7293815612793,
    "h": 355.072967529297,
    "CMY_C": 0.56982171535492,
    "CMY_M": 0.65013003349304,
    "CMY_Y": 0.62616920471191,
    "CMYK_C": 0,
    "CMYK_M": 0.18668612837791,
    "CMYK_Y": 0.13098636269569,
    "CMYK_K": 0.56982171535492
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R265005",
    "Farbtonhilfsbezeichnung": "R26 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "116",
    "Bcolor": "118",
    "Y": 18,
    "L": 49.842113494873,
    "a": 4.95403814315796,
    "b": -0.30914786458015,
    "C": 4.96367454528809,
    "h": 356.42919921875,
    "CMY_C": 0.50215923786163,
    "CMY_M": 0.54552608728409,
    "CMY_Y": 0.53628987073898,
    "CMYK_C": 0,
    "CMYK_M": 0.08710987865925,
    "CMYK_Y": 0.06855732947588,
    "CMYK_K": 0.50215923786163
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R265015",
    "Farbtonhilfsbezeichnung": "R26 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "109",
    "Bcolor": "119",
    "Y": 18,
    "L": 49.6165046691895,
    "a": 15.058277130127,
    "b": -1.19106662273407,
    "C": 15.1053085327148,
    "h": 355.477478027344,
    "CMY_C": 0.4421181678772,
    "CMY_M": 0.57170969247818,
    "CMY_Y": 0.53144454956055,
    "CMYK_C": 0,
    "CMYK_M": 0.23229207098484,
    "CMYK_Y": 0.16011703014374,
    "CMYK_K": 0.4421181678772
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R266010",
    "Farbtonhilfsbezeichnung": "R26 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "138",
    "Bcolor": "145",
    "Y": 28,
    "L": 59.7272148132324,
    "a": 9.83788108825684,
    "b": -0.89732623100281,
    "C": 9.87871932983398,
    "h": 354.788391113281,
    "CMY_C": 0.36988681554794,
    "CMY_M": 0.45786255598068,
    "CMY_Y": 0.43297082185745,
    "CMYK_C": 0,
    "CMYK_M": 0.139618948102,
    "CMYK_Y": 0.1001153588295,
    "CMYK_K": 0.36988681554794
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R266015",
    "Farbtonhilfsbezeichnung": "R26 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "135",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.7405776977539,
    "a": 14.9391632080078,
    "b": -1.38404142856598,
    "C": 15.0031385421753,
    "h": 354.706939697266,
    "CMY_C": 0.33744317293167,
    "CMY_M": 0.47036576271057,
    "CMY_Y": 0.42886167764664,
    "CMYK_C": 0,
    "CMYK_M": 0.20062066614628,
    "CMYK_Y": 0.13797836005688,
    "CMYK_K": 0.33744317293167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R267008",
    "Farbtonhilfsbezeichnung": "R26 70 08",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "166",
    "Bcolor": "171",
    "Y": 41,
    "L": 69.7925033569336,
    "a": 7.61518859863281,
    "b": -0.77769804000854,
    "C": 7.6547966003418,
    "h": 354.168914794922,
    "CMY_C": 0.27824687957764,
    "CMY_M": 0.34842777252197,
    "CMY_Y": 0.33010810613632,
    "CMYK_C": 0,
    "CMYK_M": 0.09723670035601,
    "CMYK_Y": 0.0718545243144,
    "CMYK_K": 0.27824687957764
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R267012",
    "Farbtonhilfsbezeichnung": "R26 70 12",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "163",
    "Bcolor": "172",
    "Y": 41,
    "L": 69.9505767822266,
    "a": 12.5782155990601,
    "b": -1.15190076828003,
    "C": 12.6308507919312,
    "h": 354.767517089844,
    "CMY_C": 0.2430312037468,
    "CMY_M": 0.35897773504257,
    "CMY_Y": 0.3251616358757,
    "CMYK_C": 0,
    "CMYK_M": 0.15317213535309,
    "CMYK_Y": 0.10849910229445,
    "CMYK_K": 0.2430312037468
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R267505",
    "Farbtonhilfsbezeichnung": "R26 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "182",
    "Bcolor": "184",
    "Y": 48,
    "L": 75.0026397705078,
    "a": 5.03014612197876,
    "b": -0.56048262119293,
    "C": 5.06127548217773,
    "h": 353.642059326172,
    "CMY_C": 0.24017381668091,
    "CMY_M": 0.28708827495575,
    "CMY_Y": 0.27695840597153,
    "CMYK_C": 0,
    "CMYK_M": 0.06174367293715,
    "CMYK_Y": 0.04841184616089,
    "CMYK_K": 0.24017381668091
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R267510",
    "Farbtonhilfsbezeichnung": "R26 75 10",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "179",
    "Bcolor": "186",
    "Y": 48,
    "L": 75.1531982421875,
    "a": 10.3917427062988,
    "b": -1.05180835723877,
    "C": 10.4448366165161,
    "h": 354.220458984375,
    "CMY_C": 0.20135432481766,
    "CMY_M": 0.2984647154808,
    "CMY_Y": 0.27113974094391,
    "CMYK_C": 0,
    "CMYK_M": 0.12159383296967,
    "CMYK_Y": 0.08737969398499,
    "CMYK_K": 0.20135432481766
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R268007",
    "Farbtonhilfsbezeichnung": "R26 80 07",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "194",
    "Bcolor": "198",
    "Y": 57,
    "L": 79.9596405029297,
    "a": 7.43146419525146,
    "b": -0.82424259185791,
    "C": 7.47703409194946,
    "h": 353.671051025391,
    "CMY_C": 0.16933012008667,
    "CMY_M": 0.23957633972168,
    "CMY_Y": 0.22165781259537,
    "CMYK_C": 0,
    "CMYK_M": 0.08456575125456,
    "CMYK_Y": 0.06299456954002,
    "CMYK_K": 0.16933012008667
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R268505",
    "Farbtonhilfsbezeichnung": "R26 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "208",
    "Bcolor": "211",
    "Y": 66,
    "L": 84.7127990722656,
    "a": 5.24827003479004,
    "b": -0.61724501848221,
    "C": 5.28444242477417,
    "h": 353.292297363281,
    "CMY_C": 0.13247489929199,
    "CMY_M": 0.18255722522736,
    "CMY_Y": 0.17190271615982,
    "CMYK_C": 0,
    "CMYK_M": 0.05773011595011,
    "CMYK_Y": 0.04544861614704,
    "CMYK_K": 0.13247489929199
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R269005",
    "Farbtonhilfsbezeichnung": "R26 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "223",
    "Bcolor": "226",
    "Y": 76,
    "L": 89.9918746948242,
    "a": 5.13666152954102,
    "b": -0.53197276592255,
    "C": 5.16413450241089,
    "h": 354.087310791016,
    "CMY_C": 0.07421350479126,
    "CMY_M": 0.12410390377045,
    "CMY_Y": 0.11458849906921,
    "CMYK_C": 0,
    "CMYK_M": 0.05388974770904,
    "CMYK_Y": 0.04361156001687,
    "CMYK_K": 0.07421350479126
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R273025",
    "Farbtonhilfsbezeichnung": "R27 30 25",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "56",
    "Bcolor": "81",
    "Y": 6,
    "L": 31.1021404266357,
    "a": 26.8476066589356,
    "b": -4.80514192581177,
    "C": 27.2742252349854,
    "h": 349.852722167969,
    "CMY_C": 0.57232964038849,
    "CMY_M": 0.77949112653732,
    "CMY_Y": 0.68345284461975,
    "CMYK_C": 0,
    "CMYK_M": 0.4843952357769,
    "CMYK_Y": 0.2598337829113,
    "CMYK_K": 0.57232964038849
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R274015",
    "Farbtonhilfsbezeichnung": "R27 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "87",
    "Bcolor": "99",
    "Y": 11,
    "L": 40.3163070678711,
    "a": 15.0323572158813,
    "b": -2.5640606880188,
    "C": 15.2494649887085,
    "h": 350.320251464844,
    "CMY_C": 0.53993946313858,
    "CMY_M": 0.66061854362488,
    "CMY_Y": 0.61256349086761,
    "CMYK_C": 0,
    "CMYK_M": 0.26231130957603,
    "CMYK_Y": 0.15785755217075,
    "CMYK_K": 0.53993946313858
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R274414",
    "Farbtonhilfsbezeichnung": "R27 44 14 Vesuvianit",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "98",
    "Bcolor": "109",
    "Y": 14,
    "L": 44.5220222473145,
    "a": 13.5939102172852,
    "b": -2.50275754928589,
    "C": 13.822380065918,
    "h": 349.568176269531,
    "CMY_C": 0.50626087188721,
    "CMY_M": 0.61701023578644,
    "CMY_Y": 0.57282137870789,
    "CMYK_C": 0,
    "CMYK_M": 0.22430744767189,
    "CMYK_Y": 0.13480906188488,
    "CMYK_K": 0.50626087188721
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R275013",
    "Farbtonhilfsbezeichnung": "R27 50 13",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "111",
    "Bcolor": "121",
    "Y": 18,
    "L": 49.6283149719238,
    "a": 12.6200742721558,
    "b": -2.16446995735168,
    "C": 12.8043432235718,
    "h": 350.267883300781,
    "CMY_C": 0.45965194702148,
    "CMY_M": 0.56516885757446,
    "CMY_Y": 0.52529805898666,
    "CMYK_C": 0,
    "CMYK_M": 0.1952758282423,
    "CMYK_Y": 0.12148857116699,
    "CMYK_K": 0.45965194702148
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R275035",
    "Farbtonhilfsbezeichnung": "R27 50 35",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "96",
    "Bcolor": "129",
    "Y": 18,
    "L": 49.952564239502,
    "a": 34.5714263916016,
    "b": -6.16778373718262,
    "C": 35.1173057556152,
    "h": 349.884460449219,
    "CMY_C": 0.33554089069366,
    "CMY_M": 0.62484186887741,
    "CMY_Y": 0.49313479661942,
    "CMYK_C": 0,
    "CMYK_M": 0.43539321422577,
    "CMYK_Y": 0.23717622458935,
    "CMYK_K": 0.33554089069366
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R275510",
    "Farbtonhilfsbezeichnung": "R27 55 10",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "125",
    "Bcolor": "133",
    "Y": 23,
    "L": 54.6886367797852,
    "a": 9.96138858795166,
    "b": -1.83166265487671,
    "C": 10.1283884048462,
    "h": 349.5810546875,
    "CMY_C": 0.42399698495865,
    "CMY_M": 0.50869596004486,
    "CMY_Y": 0.47755295038223,
    "CMYK_C": 0,
    "CMYK_M": 0.14704605937004,
    "CMYK_Y": 0.09297861903906,
    "CMYK_K": 0.42399698495865
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R276007",
    "Farbtonhilfsbezeichnung": "R27 60 07",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "140",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.8940010070801,
    "a": 7.29737615585327,
    "b": -1.279780626297,
    "C": 7.40874719619751,
    "h": 350.052886962891,
    "CMY_C": 0.3864758014679,
    "CMY_M": 0.44997197389603,
    "CMY_Y": 0.42901462316513,
    "CMYK_C": 0,
    "CMYK_M": 0.1034941598773,
    "CMYK_Y": 0.06933519989252,
    "CMYK_K": 0.3864758014679
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R277005",
    "Farbtonhilfsbezeichnung": "R27 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "168",
    "Bcolor": "171",
    "Y": 41,
    "L": 69.9374847412109,
    "a": 4.96578073501587,
    "b": -0.98329305648804,
    "C": 5.0621976852417,
    "h": 348.799530029297,
    "CMY_C": 0.29631179571152,
    "CMY_M": 0.34051823616028,
    "CMY_Y": 0.32750189304352,
    "CMYK_C": 0,
    "CMYK_M": 0.06282106041908,
    "CMYK_Y": 0.04432374611497,
    "CMYK_K": 0.29631179571152
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R277015",
    "Farbtonhilfsbezeichnung": "R27 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "164",
    "Bcolor": "177",
    "Y": 41,
    "L": 70.6694488525391,
    "a": 14.1995353698731,
    "b": -2.67735648155212,
    "C": 14.4497423171997,
    "h": 349.322113037109,
    "CMY_C": 0.22845298051834,
    "CMY_M": 0.35513830184937,
    "CMY_Y": 0.3067085146904,
    "CMYK_C": 0,
    "CMYK_M": 0.16419650614262,
    "CMYK_Y": 0.10142678767443,
    "CMYK_K": 0.22845298051834
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R278005",
    "Farbtonhilfsbezeichnung": "R27 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "198",
    "Y": 57,
    "L": 79.8276290893555,
    "a": 5.00161170959473,
    "b": -0.99654418230057,
    "C": 5.09992361068726,
    "h": 348.731689453125,
    "CMY_C": 0.18931823968887,
    "CMY_M": 0.23503202199936,
    "CMY_Y": 0.2221736907959,
    "CMYK_C": 0,
    "CMYK_M": 0.05638930574059,
    "CMYK_Y": 0.04052817448974,
    "CMYK_K": 0.18931823968887
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R279005",
    "Farbtonhilfsbezeichnung": "R27 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "224",
    "Bcolor": "226",
    "Y": 76,
    "L": 90.0122528076172,
    "a": 4.90569734573364,
    "b": -0.85731947422028,
    "C": 4.98004627227783,
    "h": 350.087097167969,
    "CMY_C": 0.07682931423187,
    "CMY_M": 0.12321346998215,
    "CMY_Y": 0.11199533939362,
    "CMYK_C": 0,
    "CMYK_M": 0.05024439841509,
    "CMYK_Y": 0.0380926579237,
    "CMYK_K": 0.07682931423187
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R286015",
    "Farbtonhilfsbezeichnung": "R28 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "136",
    "Bcolor": "150",
    "Y": 28,
    "L": 59.7686462402344,
    "a": 14.6281080245972,
    "b": -4.02638721466064,
    "C": 15.1721239089966,
    "h": 344.610443115234,
    "CMY_C": 0.34634560346603,
    "CMY_M": 0.46849399805069,
    "CMY_Y": 0.41075074672699,
    "CMYK_C": 0,
    "CMYK_M": 0.18686999380589,
    "CMYK_Y": 0.09853088110685,
    "CMYK_K": 0.34634560346603
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R287015",
    "Farbtonhilfsbezeichnung": "R28 70 15",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "161",
    "Bcolor": "176",
    "Y": 41,
    "L": 69.4186096191406,
    "a": 14.0543394088745,
    "b": -3.93030953407288,
    "C": 14.5935525894165,
    "h": 344.376312255859,
    "CMY_C": 0.24666571617126,
    "CMY_M": 0.36750370264053,
    "CMY_Y": 0.31117051839828,
    "CMYK_C": 0,
    "CMYK_M": 0.16040420532227,
    "CMYK_Y": 0.0856257379055,
    "CMYK_K": 0.24666571617126
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R287512",
    "Farbtonhilfsbezeichnung": "R28 75 12",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "178",
    "Bcolor": "190",
    "Y": 48,
    "L": 75.0364456176758,
    "a": 12.233081817627,
    "b": -3.31663465499878,
    "C": 12.6747131347656,
    "h": 344.830627441406,
    "CMY_C": 0.19636934995651,
    "CMY_M": 0.30369478464127,
    "CMY_Y": 0.25607597827911,
    "CMYK_C": 0,
    "CMYK_M": 0.13355070352554,
    "CMYK_Y": 0.07429610937834,
    "CMYK_K": 0.19636934995651
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R288010",
    "Farbtonhilfsbezeichnung": "R28 80 10",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "193",
    "Bcolor": "202",
    "Y": 57,
    "L": 79.9764785766602,
    "a": 9.8902473449707,
    "b": -2.81102228164673,
    "C": 10.2819662094116,
    "h": 344.133697509766,
    "CMY_C": 0.15736079216003,
    "CMY_M": 0.24492990970612,
    "CMY_Y": 0.20685684680939,
    "CMYK_C": 0,
    "CMYK_M": 0.10392243415117,
    "CMYK_Y": 0.0587393194437,
    "CMYK_K": 0.15736079216003
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R288508",
    "Farbtonhilfsbezeichnung": "R28 85 08",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "209",
    "Bcolor": "216",
    "Y": 66,
    "L": 85.2422485351563,
    "a": 7.64117956161499,
    "b": -2.12335252761841,
    "C": 7.93071556091309,
    "h": 344.470306396484,
    "CMY_C": 0.1134626865387,
    "CMY_M": 0.18221414089203,
    "CMY_Y": 0.15481394529343,
    "CMYK_C": 0,
    "CMYK_M": 0.07755054533482,
    "CMYK_Y": 0.04664356261492,
    "CMYK_K": 0.1134626865387
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R289005",
    "Farbtonhilfsbezeichnung": "R28 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "223",
    "Bcolor": "227",
    "Y": 76,
    "L": 89.8646774291992,
    "a": 4.93128633499146,
    "b": -1.46620345115662,
    "C": 5.14464139938354,
    "h": 343.441375732422,
    "CMY_C": 0.08030718564987,
    "CMY_M": 0.12473410367966,
    "CMY_Y": 0.10913217067719,
    "CMYK_C": 0,
    "CMYK_M": 0.04830625653267,
    "CMYK_Y": 0.03134196996689,
    "CMYK_K": 0.08030718564987
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R293010",
    "Farbtonhilfsbezeichnung": "R29 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "76",
    "Y": 6,
    "L": 30.1428470611572,
    "a": 9.40959167480469,
    "b": -3.41677069664001,
    "C": 10.0107307434082,
    "h": 340.043243408203,
    "CMY_C": 0.67323994636536,
    "CMY_M": 0.74034911394119,
    "CMY_Y": 0.70258408784866,
    "CMYK_C": 0,
    "CMYK_M": 0.20537751913071,
    "CMYK_Y": 0.08980333060026,
    "CMYK_K": 0.67323994636536
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R293020",
    "Farbtonhilfsbezeichnung": "R29 30 20",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "60",
    "Bcolor": "81",
    "Y": 6,
    "L": 30.0777149200439,
    "a": 19.4040126800537,
    "b": -6.73216438293457,
    "C": 20.538688659668,
    "h": 340.865936279297,
    "CMY_C": 0.62570941448212,
    "CMY_M": 0.76526725292206,
    "CMY_Y": 0.68227159976959,
    "CMYK_C": 0,
    "CMYK_M": 0.37285959720612,
    "CMYK_Y": 0.15111838281155,
    "CMYK_K": 0.62570941448212
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R294005",
    "Farbtonhilfsbezeichnung": "R29 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "93",
    "Bcolor": "97",
    "Y": 11,
    "L": 40.2679023742676,
    "a": 4.27765703201294,
    "b": -1.44710958003998,
    "C": 4.51580286026001,
    "h": 341.3095703125,
    "CMY_C": 0.60373067855835,
    "CMY_M": 0.63617312908173,
    "CMY_Y": 0.62134331464767,
    "CMYK_C": 0,
    "CMYK_M": 0.08186969906092,
    "CMYK_Y": 0.04444612562656,
    "CMYK_K": 0.60373067855835
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R294015",
    "Farbtonhilfsbezeichnung": "R29 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "87",
    "Bcolor": "102",
    "Y": 11,
    "L": 40.219554901123,
    "a": 14.08131980896,
    "b": -5.0280613899231,
    "C": 14.9520893096924,
    "h": 340.349731445313,
    "CMY_C": 0.55269038677216,
    "CMY_M": 0.65839785337448,
    "CMY_Y": 0.59815061092377,
    "CMYK_C": 0,
    "CMYK_M": 0.23631834983826,
    "CMYK_Y": 0.10163033008575,
    "CMYK_K": 0.55269038677216
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R294040",
    "Farbtonhilfsbezeichnung": "R29 40 40",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "70",
    "Bcolor": "118",
    "Y": 11,
    "L": 40.8670959472656,
    "a": 38.4054985046387,
    "b": -13.4956455230713,
    "C": 40.7076759338379,
    "h": 340.638580322266,
    "CMY_C": 0.42851573228836,
    "CMY_M": 0.72551101446152,
    "CMY_Y": 0.53584909439087,
    "CMYK_C": 0,
    "CMYK_M": 0.51969110965729,
    "CMYK_Y": 0.18781508505344,
    "CMYK_K": 0.42851573228836
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R295005",
    "Farbtonhilfsbezeichnung": "R29 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "116",
    "Bcolor": "121",
    "Y": 18,
    "L": 49.947093963623,
    "a": 4.70177221298218,
    "b": -1.5852814912796,
    "C": 4.96183204650879,
    "h": 341.367614746094,
    "CMY_C": 0.50647532939911,
    "CMY_M": 0.54358941316605,
    "CMY_Y": 0.52693521976471,
    "CMYK_C": 0,
    "CMYK_M": 0.07520208507776,
    "CMYK_Y": 0.04145667329431,
    "CMYK_K": 0.50647532939911
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R295010",
    "Farbtonhilfsbezeichnung": "R29 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "114",
    "Bcolor": "124",
    "Y": 18,
    "L": 50.2200775146484,
    "a": 9.37561798095703,
    "b": -3.25356769561768,
    "C": 9.92410755157471,
    "h": 340.861968994141,
    "CMY_C": 0.47744029760361,
    "CMY_M": 0.55118906497955,
    "CMY_Y": 0.51274526119232,
    "CMYK_C": 0,
    "CMYK_M": 0.14112983644009,
    "CMYK_Y": 0.06756158918142,
    "CMYK_K": 0.47744029760361
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R296005",
    "Farbtonhilfsbezeichnung": "R29 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "142",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.8353424072266,
    "a": 4.75817537307739,
    "b": -1.74431896209717,
    "C": 5.06782817840576,
    "h": 339.867370605469,
    "CMY_C": 0.40612202882767,
    "CMY_M": 0.4445333480835,
    "CMY_Y": 0.4267874956131,
    "CMYK_C": 0,
    "CMYK_M": 0.06467881053686,
    "CMYK_Y": 0.03479749709368,
    "CMYK_K": 0.40612202882767
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R296015",
    "Farbtonhilfsbezeichnung": "R29 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "137",
    "Bcolor": "153",
    "Y": 28,
    "L": 59.9988594055176,
    "a": 13.8051061630249,
    "b": -5.02373123168945,
    "C": 14.6907739639282,
    "h": 340.003356933594,
    "CMY_C": 0.35220187902451,
    "CMY_M": 0.46374958753586,
    "CMY_Y": 0.40174561738968,
    "CMYK_C": 0,
    "CMYK_M": 0.17219516634941,
    "CMYK_Y": 0.07648020982742,
    "CMYK_K": 0.35220187902451
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R296025",
    "Farbtonhilfsbezeichnung": "R29 60 25",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "131",
    "Bcolor": "159",
    "Y": 28,
    "L": 60.2964859008789,
    "a": 23.1184577941895,
    "b": -8.23110675811768,
    "C": 24.5400524139404,
    "h": 340.402221679688,
    "CMY_C": 0.29730612039566,
    "CMY_M": 0.48471295833588,
    "CMY_Y": 0.37577962875366,
    "CMYK_C": 0,
    "CMYK_M": 0.26669770479202,
    "CMYK_Y": 0.11167524009943,
    "CMYK_K": 0.29730612039566
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R296513",
    "Farbtonhilfsbezeichnung": "R29 65 13",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "151",
    "Bcolor": "164",
    "Y": 34,
    "L": 64.9011535644531,
    "a": 11.8925828933716,
    "b": -4.45371961593628,
    "C": 12.6991786956787,
    "h": 339.469299316406,
    "CMY_C": 0.31158101558685,
    "CMY_M": 0.40884739160538,
    "CMY_Y": 0.35516691207886,
    "CMYK_C": 0,
    "CMYK_M": 0.14128950238228,
    "CMYK_Y": 0.06331303715706,
    "CMYK_K": 0.31158101558685
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R297005",
    "Farbtonhilfsbezeichnung": "R29 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "168",
    "Bcolor": "172",
    "Y": 41,
    "L": 69.8128433227539,
    "a": 4.41696929931641,
    "b": -1.69551682472229,
    "C": 4.73121500015259,
    "h": 339,
    "CMY_C": 0.30387163162231,
    "CMY_M": 0.34033930301666,
    "CMY_Y": 0.32389879226685,
    "CMYK_C": 0,
    "CMYK_M": 0.05238641798496,
    "CMYK_Y": 0.02876934967935,
    "CMYK_K": 0.30387163162231
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R297010",
    "Farbtonhilfsbezeichnung": "R29 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "165",
    "Bcolor": "176",
    "Y": 41,
    "L": 69.9220581054688,
    "a": 9.76985931396484,
    "b": -3.57974624633789,
    "C": 10.4050340652466,
    "h": 339.876800537109,
    "CMY_C": 0.27008455991745,
    "CMY_M": 0.35151809453964,
    "CMY_Y": 0.308873295784,
    "CMYK_C": 0,
    "CMYK_M": 0.11156570911407,
    "CMYK_Y": 0.05314141139388,
    "CMYK_K": 0.27008455991745
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R297507",
    "Farbtonhilfsbezeichnung": "R29 75 07",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "181",
    "Bcolor": "189",
    "Y": 48,
    "L": 75.1982498168945,
    "a": 7.12426376342773,
    "b": -2.70457315444946,
    "C": 7.62035751342773,
    "h": 339.211822509766,
    "CMY_C": 0.22947806119919,
    "CMY_M": 0.28942495584488,
    "CMY_Y": 0.25937068462372,
    "CMYK_C": 0,
    "CMYK_M": 0.07780037075281,
    "CMYK_Y": 0.03879529237747,
    "CMYK_K": 0.22947806119919
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R298005",
    "Farbtonhilfsbezeichnung": "R29 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "195",
    "Bcolor": "200",
    "Y": 57,
    "L": 79.8026657104492,
    "a": 4.52280759811401,
    "b": -1.73258674144745,
    "C": 4.84330940246582,
    "h": 339.039276123047,
    "CMY_C": 0.19556927680969,
    "CMY_M": 0.23393756151199,
    "CMY_Y": 0.21721333265305,
    "CMYK_C": 0,
    "CMYK_M": 0.04769619554281,
    "CMYK_Y": 0.02690605260432,
    "CMYK_K": 0.19556927680969
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R298505",
    "Farbtonhilfsbezeichnung": "R29 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "208",
    "Bcolor": "214",
    "Y": 66,
    "L": 84.6758499145508,
    "a": 5.18393611907959,
    "b": -2.00145077705383,
    "C": 5.55688762664795,
    "h": 338.889068603516,
    "CMY_C": 0.1378972530365,
    "CMY_M": 0.18239951133728,
    "CMY_Y": 0.16223484277725,
    "CMYK_C": 0,
    "CMYK_M": 0.05162059515715,
    "CMYK_Y": 0.02823049761355,
    "CMYK_K": 0.1378972530365
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R299005",
    "Farbtonhilfsbezeichnung": "R29 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "223",
    "Bcolor": "227",
    "Y": 76,
    "L": 89.77783203125,
    "a": 4.23351860046387,
    "b": -1.6256502866745,
    "C": 4.53491115570068,
    "h": 338.993469238281,
    "CMY_C": 0.08720338344574,
    "CMY_M": 0.1239395737648,
    "CMY_Y": 0.10901296138763,
    "CMYK_C": 0,
    "CMYK_M": 0.04024575650692,
    "CMYK_Y": 0.0238931402564,
    "CMYK_K": 0.08720338344574
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R304010",
    "Farbtonhilfsbezeichnung": "R30 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "89",
    "Bcolor": "99",
    "Y": 11,
    "L": 39.5704917907715,
    "a": 8.9652042388916,
    "b": -4.07569742202759,
    "C": 9.84815692901611,
    "h": 335.552856445313,
    "CMY_C": 0.58790671825409,
    "CMY_M": 0.65248090028763,
    "CMY_Y": 0.61091011762619,
    "CMYK_C": 0,
    "CMYK_M": 0.15669797360897,
    "CMYK_Y": 0.05582085624337,
    "CMYK_K": 0.58790671825409
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R305010",
    "Farbtonhilfsbezeichnung": "R30 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "114",
    "Bcolor": "124",
    "Y": 18,
    "L": 49.7983093261719,
    "a": 8.93199062347412,
    "b": -4.03669404983521,
    "C": 9.80180358886719,
    "h": 335.680053710938,
    "CMY_C": 0.48685425519943,
    "CMY_M": 0.55406093597412,
    "CMY_Y": 0.5118516087532,
    "CMYK_C": 0,
    "CMYK_M": 0.13096997141838,
    "CMYK_Y": 0.04871394485235,
    "CMYK_K": 0.48685425519943
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R305505",
    "Farbtonhilfsbezeichnung": "R30 55 05",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "129",
    "Bcolor": "134",
    "Y": 23,
    "L": 54.8638916015625,
    "a": 4.49701881408691,
    "b": -2.03704023361206,
    "C": 4.9368724822998,
    "h": 335.630615234375,
    "CMY_C": 0.4597282409668,
    "CMY_M": 0.4941440820694,
    "CMY_Y": 0.47511649131775,
    "CMYK_C": 0,
    "CMYK_M": 0.06370098143816,
    "CMYK_Y": 0.02848242595792,
    "CMYK_K": 0.4597282409668
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R305515",
    "Farbtonhilfsbezeichnung": "R30 55 15",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "124",
    "Bcolor": "141",
    "Y": 23,
    "L": 54.7767791748047,
    "a": 13.6788721084595,
    "b": -6.37202405929565,
    "C": 15.0902032852173,
    "h": 335.022491455078,
    "CMY_C": 0.41149550676346,
    "CMY_M": 0.5156341791153,
    "CMY_Y": 0.44599723815918,
    "CMYK_C": 0,
    "CMYK_M": 0.1769547611475,
    "CMYK_Y": 0.05862611532211,
    "CMYK_K": 0.41149550676346
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R306010",
    "Farbtonhilfsbezeichnung": "R30 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "139",
    "Bcolor": "150",
    "Y": 28,
    "L": 59.7293930053711,
    "a": 8.91822147369385,
    "b": -4.25056457519531,
    "C": 9.87937068939209,
    "h": 334.516784667969,
    "CMY_C": 0.38587093353271,
    "CMY_M": 0.45465487241745,
    "CMY_Y": 0.41036152839661,
    "CMYK_C": 0,
    "CMYK_M": 0.11200241744518,
    "CMYK_Y": 0.03987858071923,
    "CMYK_K": 0.38587093353271
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R306507",
    "Farbtonhilfsbezeichnung": "R30 65 07",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "153",
    "Bcolor": "162",
    "Y": 34,
    "L": 64.7443084716797,
    "a": 6.68281555175781,
    "b": -3.24709129333496,
    "C": 7.4299144744873,
    "h": 334.085510253906,
    "CMY_C": 0.34599709510803,
    "CMY_M": 0.39814341068268,
    "CMY_Y": 0.36577099561691,
    "CMYK_C": 0,
    "CMYK_M": 0.0797340720892,
    "CMYK_Y": 0.03023518808186,
    "CMYK_K": 0.34599709510803
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R306514",
    "Farbtonhilfsbezeichnung": "R30 65 14",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "150",
    "Bcolor": "167",
    "Y": 34,
    "L": 64.8358993530273,
    "a": 12.9240894317627,
    "b": -5.99576330184937,
    "C": 14.2471494674683,
    "h": 335.112396240234,
    "CMY_C": 0.30981308221817,
    "CMY_M": 0.41164517402649,
    "CMY_Y": 0.34510570764542,
    "CMYK_C": 0,
    "CMYK_M": 0.14754277467728,
    "CMYK_Y": 0.05113488063216,
    "CMYK_K": 0.30981308221817
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R307012",
    "Farbtonhilfsbezeichnung": "R30 70 12",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "164",
    "Bcolor": "179",
    "Y": 41,
    "L": 69.8244400024414,
    "a": 11.4224662780762,
    "b": -5.39255046844482,
    "C": 12.6314029693604,
    "h": 334.727996826172,
    "CMY_C": 0.2650420665741,
    "CMY_M": 0.35610765218735,
    "CMY_Y": 0.29702234268188,
    "CMYK_C": 0,
    "CMYK_M": 0.12390584498644,
    "CMYK_Y": 0.04351307079196,
    "CMYK_K": 0.2650420665741
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R307505",
    "Farbtonhilfsbezeichnung": "R30 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "182",
    "Bcolor": "187",
    "Y": 48,
    "L": 75.0190887451172,
    "a": 4.4889497756958,
    "b": -2.18188166618347,
    "C": 4.99111986160278,
    "h": 334.07763671875,
    "CMY_C": 0.24918138980865,
    "CMY_M": 0.28516054153442,
    "CMY_Y": 0.2653426527977,
    "CMYK_C": 0,
    "CMYK_M": 0.04791989922523,
    "CMYK_Y": 0.02152485586703,
    "CMYK_K": 0.24918138980865
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R307510",
    "Farbtonhilfsbezeichnung": "R30 75 10",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "179",
    "Bcolor": "191",
    "Y": 48,
    "L": 74.8886184692383,
    "a": 9.17215633392334,
    "b": -4.3156681060791,
    "C": 10.136736869812,
    "h": 334.802154541016,
    "CMY_C": 0.22303378582001,
    "CMY_M": 0.29727208614349,
    "CMY_Y": 0.25098150968552,
    "CMYK_C": 0,
    "CMYK_M": 0.09554894268513,
    "CMYK_Y": 0.03597031906247,
    "CMYK_K": 0.22303378582001
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R308007",
    "Farbtonhilfsbezeichnung": "R30 80 07",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "194",
    "Bcolor": "202",
    "Y": 57,
    "L": 79.7069778442383,
    "a": 6.80339288711548,
    "b": -3.35812401771545,
    "C": 7.58703851699829,
    "h": 333.729248046875,
    "CMY_C": 0.1848435997963,
    "CMY_M": 0.24001812934875,
    "CMY_Y": 0.20625591278076,
    "CMYK_C": 0,
    "CMYK_M": 0.0676858201623,
    "CMYK_Y": 0.02626773528755,
    "CMYK_K": 0.1848435997963
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R308505",
    "Farbtonhilfsbezeichnung": "R30 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "210",
    "Bcolor": "215",
    "Y": 66,
    "L": 85.022575378418,
    "a": 4.57873582839966,
    "b": -2.31973218917847,
    "C": 5.13283348083496,
    "h": 333.131774902344,
    "CMY_C": 0.13974130153656,
    "CMY_M": 0.17703300714493,
    "CMY_Y": 0.15620464086533,
    "CMYK_C": 0,
    "CMYK_M": 0.04334940761328,
    "CMYK_Y": 0.0191376619041,
    "CMYK_K": 0.13974130153656
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R313025",
    "Farbtonhilfsbezeichnung": "R31 30 25",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "58",
    "Bcolor": "93",
    "Y": 6,
    "L": 30.4379234313965,
    "a": 24.1382827758789,
    "b": -13.7527227401733,
    "C": 27.7811813354492,
    "h": 330.327789306641,
    "CMY_C": 0.61360669136047,
    "CMY_M": 0.77338933944702,
    "CMY_Y": 0.6364266872406,
    "CMYK_C": 0,
    "CMYK_M": 0.41352331638336,
    "CMYK_Y": 0.05905898287892,
    "CMYK_K": 0.61360669136047
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R314015",
    "Farbtonhilfsbezeichnung": "R31 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "89",
    "Bcolor": "106",
    "Y": 11,
    "L": 40.3683090209961,
    "a": 12.4532108306885,
    "b": -7.18872737884521,
    "C": 14.3791608810425,
    "h": 330.003936767578,
    "CMY_C": 0.56704032421112,
    "CMY_M": 0.65231657028198,
    "CMY_Y": 0.58334136009216,
    "CMYK_C": 0,
    "CMYK_M": 0.19696117937565,
    "CMYK_Y": 0.03765023872256,
    "CMYK_K": 0.56704032421112
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R314020",
    "Farbtonhilfsbezeichnung": "R31 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "86",
    "Bcolor": "112",
    "Y": 11,
    "L": 40.6590919494629,
    "a": 17.4355545043945,
    "b": -9.95004653930664,
    "C": 20.0749092102051,
    "h": 330.287658691406,
    "CMY_C": 0.54129934310913,
    "CMY_M": 0.6613095998764,
    "CMY_Y": 0.56260085105896,
    "CMYK_C": 0,
    "CMYK_M": 0.2616308927536,
    "CMYK_Y": 0.04643879830837,
    "CMYK_K": 0.54129934310913
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R315011",
    "Farbtonhilfsbezeichnung": "R31 50 11",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "114",
    "Bcolor": "127",
    "Y": 18,
    "L": 49.8616523742676,
    "a": 9.46973609924316,
    "b": -5.36042261123657,
    "C": 10.8816375732422,
    "h": 330.487609863281,
    "CMY_C": 0.48653739690781,
    "CMY_M": 0.55432319641113,
    "CMY_Y": 0.50250440835953,
    "CMYK_C": 0,
    "CMYK_M": 0.13201701641083,
    "CMYK_Y": 0.03109673596919,
    "CMYK_K": 0.48653739690781
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R315015",
    "Farbtonhilfsbezeichnung": "R31 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "111",
    "Bcolor": "131",
    "Y": 18,
    "L": 49.8454322814941,
    "a": 13.1914777755737,
    "b": -7.56109285354614,
    "C": 15.2047758102417,
    "h": 330.179534912109,
    "CMY_C": 0.46875619888306,
    "CMY_M": 0.56284391880035,
    "CMY_Y": 0.48784023523331,
    "CMYK_C": 0,
    "CMYK_M": 0.17710836231709,
    "CMYK_Y": 0.0359233096242,
    "CMYK_K": 0.46875619888306
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R315025",
    "Farbtonhilfsbezeichnung": "R31 50 25",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "107",
    "Bcolor": "140",
    "Y": 18,
    "L": 50.3391227722168,
    "a": 21.6397476196289,
    "b": -12.2435960769653,
    "C": 24.8633136749268,
    "h": 330.499176025391,
    "CMY_C": 0.42334282398224,
    "CMY_M": 0.57869005203247,
    "CMY_Y": 0.45126008987427,
    "CMYK_C": 0,
    "CMYK_M": 0.26939269900322,
    "CMYK_Y": 0.04841224104166,
    "CMYK_K": 0.42334282398224
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R315507",
    "Farbtonhilfsbezeichnung": "R31 55 07",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "128",
    "Bcolor": "137",
    "Y": 23,
    "L": 54.9153823852539,
    "a": 6.40162944793701,
    "b": -3.56259083747864,
    "C": 7.32617998123169,
    "h": 330.903472900391,
    "CMY_C": 0.4506761431694,
    "CMY_M": 0.49754476547241,
    "CMY_Y": 0.46419417858124,
    "CMYK_C": 0,
    "CMYK_M": 0.08532056957483,
    "CMYK_Y": 0.02460849843919,
    "CMYK_K": 0.4506761431694
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R316005",
    "Farbtonhilfsbezeichnung": "R31 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "142",
    "Bcolor": "148",
    "Y": 28,
    "L": 59.9963226318359,
    "a": 4.26269149780273,
    "b": -2.51666474342346,
    "C": 4.95016574859619,
    "h": 329.442687988281,
    "CMY_C": 0.41035896539688,
    "CMY_M": 0.44154274463654,
    "CMY_Y": 0.4199675321579,
    "CMYK_C": 0,
    "CMYK_M": 0.05288603901863,
    "CMYK_Y": 0.01629562117159,
    "CMYK_K": 0.41035896539688
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R316010",
    "Farbtonhilfsbezeichnung": "R31 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "140",
    "Bcolor": "153",
    "Y": 28,
    "L": 60.153247833252,
    "a": 8.53710079193115,
    "b": -5.00004577636719,
    "C": 9.89356136322021,
    "h": 329.643157958984,
    "CMY_C": 0.38640230894089,
    "CMY_M": 0.44920456409454,
    "CMY_Y": 0.40097951889038,
    "CMYK_C": 0,
    "CMYK_M": 0.1023508682847,
    "CMYK_Y": 0.02375695109367,
    "CMYK_K": 0.38640230894089
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R316015",
    "Farbtonhilfsbezeichnung": "R31 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "138",
    "Bcolor": "157",
    "Y": 28,
    "L": 60.0517044067383,
    "a": 12.4352512359619,
    "b": -7.30996751785278,
    "C": 14.4246702194214,
    "h": 329.551177978516,
    "CMY_C": 0.36770969629288,
    "CMY_M": 0.45905548334122,
    "CMY_Y": 0.3858842253685,
    "CMYK_C": 0,
    "CMYK_M": 0.14446811378002,
    "CMYK_Y": 0.02874396368861,
    "CMYK_K": 0.36770969629288
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R316513",
    "Farbtonhilfsbezeichnung": "R31 65 13",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "153",
    "Bcolor": "169",
    "Y": 34,
    "L": 65.3739929199219,
    "a": 11.0296382904053,
    "b": -6.44909572601318,
    "C": 12.7766876220703,
    "h": 329.684906005859,
    "CMY_C": 0.31866377592087,
    "CMY_M": 0.40119677782059,
    "CMY_Y": 0.33659344911575,
    "CMYK_C": 0,
    "CMYK_M": 0.12113402783871,
    "CMYK_Y": 0.02631545625627,
    "CMYK_K": 0.31866377592087
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R317005",
    "Farbtonhilfsbezeichnung": "R31 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "169",
    "Bcolor": "174",
    "Y": 41,
    "L": 69.9281005859375,
    "a": 4.4587779045105,
    "b": -2.58787822723389,
    "C": 5.15536737442017,
    "h": 329.869079589844,
    "CMY_C": 0.30520075559616,
    "CMY_M": 0.33896934986115,
    "CMY_Y": 0.31643676757813,
    "CMYK_C": 0,
    "CMYK_M": 0.04860194399953,
    "CMYK_Y": 0.01617159508169,
    "CMYK_K": 0.30520075559616
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R317010",
    "Farbtonhilfsbezeichnung": "R31 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "165",
    "Bcolor": "179",
    "Y": 41,
    "L": 69.656005859375,
    "a": 8.98409652709961,
    "b": -5.419762134552,
    "C": 10.4922742843628,
    "h": 328.899017333984,
    "CMY_C": 0.28432303667068,
    "CMY_M": 0.35182690620422,
    "CMY_Y": 0.29892611503601,
    "CMYK_C": 0,
    "CMYK_M": 0.09432170540094,
    "CMYK_Y": 0.02040456607938,
    "CMYK_K": 0.28432303667068
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R318005",
    "Farbtonhilfsbezeichnung": "R31 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "196",
    "Bcolor": "202",
    "Y": 57,
    "L": 80.0015640258789,
    "a": 4.52453279495239,
    "b": -2.74376773834229,
    "C": 5.29147052764893,
    "h": 328.766540527344,
    "CMY_C": 0.19672566652298,
    "CMY_M": 0.23149329423904,
    "CMY_Y": 0.20778870582581,
    "CMYK_C": 0,
    "CMYK_M": 0.04328238219023,
    "CMYK_Y": 0.01377242989838,
    "CMYK_K": 0.19672566652298
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R318010",
    "Farbtonhilfsbezeichnung": "R31 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "194",
    "Bcolor": "206",
    "Y": 57,
    "L": 79.907829284668,
    "a": 8.23198413848877,
    "b": -4.9228835105896,
    "C": 9.59168148040771,
    "h": 329.119781494141,
    "CMY_C": 0.1771360039711,
    "CMY_M": 0.24089056253433,
    "CMY_Y": 0.19264191389084,
    "CMYK_C": 0,
    "CMYK_M": 0.07747885584831,
    "CMYK_Y": 0.01884383149445,
    "CMYK_K": 0.1771360039711
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R319005",
    "Farbtonhilfsbezeichnung": "R31 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "228",
    "Y": 76,
    "L": 89.662239074707,
    "a": 3.85618996620178,
    "b": -2.27746987342834,
    "C": 4.47851181030273,
    "h": 329.433868408203,
    "CMY_C": 0.0936371088028,
    "CMY_M": 0.12410777807236,
    "CMY_Y": 0.10553729534149,
    "CMYK_C": 0,
    "CMYK_M": 0.03361861780286,
    "CMYK_Y": 0.01312960498035,
    "CMYK_K": 0.0936371088028
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R324010",
    "Farbtonhilfsbezeichnung": "R32 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "91",
    "Bcolor": "104",
    "Y": 11,
    "L": 40.286060333252,
    "a": 8.12253952026367,
    "b": -5.71014499664307,
    "C": 9.92881679534912,
    "h": 324.892791748047,
    "CMY_C": 0.59097647666931,
    "CMY_M": 0.64334046840668,
    "CMY_Y": 0.59391379356384,
    "CMYK_C": 0,
    "CMYK_M": 0.12802195549011,
    "CMYK_Y": 0.00718129100278,
    "CMYK_K": 0.59097647666931
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R325005",
    "Farbtonhilfsbezeichnung": "R32 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "116",
    "Bcolor": "122",
    "Y": 18,
    "L": 49.737606048584,
    "a": 4.031813621521,
    "b": -2.6924889087677,
    "C": 4.84819746017456,
    "h": 326.264556884766,
    "CMY_C": 0.51643216609955,
    "CMY_M": 0.54386538267136,
    "CMY_Y": 0.5218323469162,
    "CMYK_C": 0,
    "CMYK_M": 0.05673085525632,
    "CMYK_Y": 0.01116736978292,
    "CMYK_K": 0.51643216609955
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R325015",
    "Farbtonhilfsbezeichnung": "R32 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "111",
    "Bcolor": "131",
    "Y": 18,
    "L": 49.3287658691406,
    "a": 12.4368076324463,
    "b": -8.77151107788086,
    "C": 15.2188568115234,
    "h": 324.805206298828,
    "CMY_C": 0.4825696349144,
    "CMY_M": 0.56565910577774,
    "CMY_Y": 0.48518681526184,
    "CMYK_C": 0,
    "CMYK_M": 0.16058097779751,
    "CMYK_Y": 0.00505803385749,
    "CMYK_K": 0.4825696349144
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R325510",
    "Farbtonhilfsbezeichnung": "R32 55 10",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "126",
    "Bcolor": "140",
    "Y": 23,
    "L": 54.4125213623047,
    "a": 8.49527645111084,
    "b": -6.05767583847046,
    "C": 10.4338464736938,
    "h": 324.508697509766,
    "CMY_C": 0.44909727573395,
    "CMY_M": 0.50673234462738,
    "CMY_Y": 0.4524000287056,
    "CMYK_C": 0,
    "CMYK_M": 0.10461932420731,
    "CMYK_Y": 0.00599516555667,
    "CMYK_K": 0.44909727573395
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R326008",
    "Farbtonhilfsbezeichnung": "R32 60 08",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "141",
    "Bcolor": "151",
    "Y": 28,
    "L": 59.748706817627,
    "a": 6.3741021156311,
    "b": -4.39162635803223,
    "C": 7.74051427841187,
    "h": 325.433959960938,
    "CMY_C": 0.40385347604752,
    "CMY_M": 0.44840067625046,
    "CMY_Y": 0.40952295064926,
    "CMYK_C": 0,
    "CMYK_M": 0.07472525537014,
    "CMYK_Y": 0.00951020326465,
    "CMYK_K": 0.40385347604752
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R326505",
    "Farbtonhilfsbezeichnung": "R32 65 05",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "155",
    "Bcolor": "162",
    "Y": 34,
    "L": 64.9020309448242,
    "a": 4.17429208755493,
    "b": -2.95290088653564,
    "C": 5.1131534576416,
    "h": 324.724365234375,
    "CMY_C": 0.3614399433136,
    "CMY_M": 0.39073181152344,
    "CMY_Y": 0.3664785027504,
    "CMYK_C": 0,
    "CMYK_M": 0.04587175324559,
    "CMYK_Y": 0.00789050199091,
    "CMYK_K": 0.3614399433136
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R333010",
    "Farbtonhilfsbezeichnung": "R33 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "68",
    "Bcolor": "81",
    "Y": 6,
    "L": 30.4971961975098,
    "a": 7.48758745193481,
    "b": -6.35339832305908,
    "C": 9.81985950469971,
    "h": 319.684600830078,
    "CMY_C": 0.68944197893143,
    "CMY_M": 0.7320305109024,
    "CMY_Y": 0.68197202682495,
    "CMYK_C": 0.02348834834993,
    "CMYK_M": 0.15740276873112,
    "CMYK_Y": 0,
    "CMYK_K": 0.68197202682495
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R333015",
    "Farbtonhilfsbezeichnung": "R33 30 15",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "85",
    "Y": 6,
    "L": 30.2532558441162,
    "a": 11.3833112716675,
    "b": -9.25537204742432,
    "C": 14.6711177825928,
    "h": 320.886657714844,
    "CMY_C": 0.67638397216797,
    "CMY_M": 0.74221420288086,
    "CMY_Y": 0.66642439365387,
    "CMYK_C": 0.02985703572631,
    "CMYK_M": 0.22720429301262,
    "CMYK_Y": 0,
    "CMYK_K": 0.66642439365387
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R334005",
    "Farbtonhilfsbezeichnung": "R33 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "91",
    "Bcolor": "98",
    "Y": 11,
    "L": 39.6351928710938,
    "a": 4.06748390197754,
    "b": -3.32308459281921,
    "C": 5.2523627281189,
    "h": 320.751586914063,
    "CMY_C": 0.61657953262329,
    "CMY_M": 0.64120626449585,
    "CMY_Y": 0.61557400226593,
    "CMYK_C": 0.00261566694826,
    "CMYK_M": 0.06667671352625,
    "CMYK_Y": 0,
    "CMYK_K": 0.61557400226593
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R335010",
    "Farbtonhilfsbezeichnung": "R33 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "114",
    "Bcolor": "129",
    "Y": 18,
    "L": 49.6526641845703,
    "a": 7.92422008514404,
    "b": -6.73153018951416,
    "C": 10.397439956665,
    "h": 319.652496337891,
    "CMY_C": 0.50319361686707,
    "CMY_M": 0.55234968662262,
    "CMY_Y": 0.4957976937294,
    "CMYK_C": 0.01466856244951,
    "CMYK_M": 0.11216131597757,
    "CMYK_Y": 0,
    "CMYK_K": 0.4957976937294
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R335015",
    "Farbtonhilfsbezeichnung": "R33 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "114",
    "Bcolor": "135",
    "Y": 18,
    "L": 50.3362159729004,
    "a": 11.4485149383545,
    "b": -9.62592124938965,
    "C": 14.957501411438,
    "h": 319.942840576172,
    "CMY_C": 0.48164087533951,
    "CMY_M": 0.55309343338013,
    "CMY_Y": 0.46960163116455,
    "CMYK_C": 0.0226984936744,
    "CMYK_M": 0.15741337835789,
    "CMYK_Y": 0,
    "CMYK_K": 0.46960163116455
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R335508",
    "Farbtonhilfsbezeichnung": "R33 55 08",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "129",
    "Bcolor": "139",
    "Y": 23,
    "L": 55.055606842041,
    "a": 5.81316757202148,
    "b": -4.8812460899353,
    "C": 7.59074974060059,
    "h": 319.980224609375,
    "CMY_C": 0.45743387937546,
    "CMY_M": 0.49441021680832,
    "CMY_Y": 0.45405715703964,
    "CMYK_C": 0.00618512043729,
    "CMYK_M": 0.0739144384861,
    "CMYK_Y": 0,
    "CMYK_K": 0.45405715703964
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R335513",
    "Farbtonhilfsbezeichnung": "R33 55 13",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "126",
    "Bcolor": "144",
    "Y": 23,
    "L": 54.8562889099121,
    "a": 9.66498565673828,
    "b": -8.12338066101074,
    "C": 12.6254215240479,
    "h": 319.953094482422,
    "CMY_C": 0.44305247068405,
    "CMY_M": 0.5044459104538,
    "CMY_Y": 0.43400591611862,
    "CMYK_C": 0.01598347909749,
    "CMYK_M": 0.12445358932018,
    "CMYK_Y": 0,
    "CMYK_K": 0.43400591611862
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R336005",
    "Farbtonhilfsbezeichnung": "R33 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "141",
    "Bcolor": "148",
    "Y": 28,
    "L": 59.5707664489746,
    "a": 4.21414613723755,
    "b": -3.48455142974854,
    "C": 5.4681921005249,
    "h": 320.413665771484,
    "CMY_C": 0.41815185546875,
    "CMY_M": 0.44550126791,
    "CMY_Y": 0.41775733232498,
    "CMYK_C": 0.00067759229569,
    "CMYK_M": 0.04765012487769,
    "CMYK_Y": 0,
    "CMYK_K": 0.41775733232498
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R336510",
    "Farbtonhilfsbezeichnung": "R33 65 10",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "152",
    "Bcolor": "168",
    "Y": 34,
    "L": 64.5612411499023,
    "a": 8.05584526062012,
    "b": -6.83384418487549,
    "C": 10.5639991760254,
    "h": 319.691772460938,
    "CMY_C": 0.34960061311722,
    "CMY_M": 0.40224158763885,
    "CMY_Y": 0.34281378984451,
    "CMYK_C": 0.0103270933032,
    "CMYK_M": 0.09042763710022,
    "CMYK_Y": 0,
    "CMYK_K": 0.34281378984451
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R337005",
    "Farbtonhilfsbezeichnung": "R33 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "170",
    "Bcolor": "177",
    "Y": 41,
    "L": 70.2922058105469,
    "a": 3.74231839179993,
    "b": -3.2826726436615,
    "C": 4.97804021835327,
    "h": 318.743530273438,
    "CMY_C": 0.30890190601349,
    "CMY_M": 0.33325976133347,
    "CMY_Y": 0.30782556533813,
    "CMYK_C": 0.00155501358677,
    "CMYK_M": 0.0367453545332,
    "CMYK_Y": 0,
    "CMYK_K": 0.30782556533813
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R337505",
    "Farbtonhilfsbezeichnung": "R33 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "183",
    "Bcolor": "189",
    "Y": 48,
    "L": 75.0089340209961,
    "a": 3.86888885498047,
    "b": -3.36022806167603,
    "C": 5.12439584732056,
    "h": 319.024871826172,
    "CMY_C": 0.25782662630081,
    "CMY_M": 0.28346049785614,
    "CMY_Y": 0.25716441869736,
    "CMYK_C": 0.00089145917445,
    "CMYK_M": 0.03539959713817,
    "CMYK_Y": 0,
    "CMYK_K": 0.25716441869736
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R337510",
    "Farbtonhilfsbezeichnung": "R33 75 10",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "180",
    "Bcolor": "195",
    "Y": 48,
    "L": 74.7069320678711,
    "a": 7.91108798980713,
    "b": -6.7414493560791,
    "C": 10.3938665390015,
    "h": 319.56396484375,
    "CMY_C": 0.24223262071609,
    "CMY_M": 0.29536491632462,
    "CMY_Y": 0.2358917593956,
    "CMYK_C": 0.00829838123173,
    "CMYK_M": 0.07783342152834,
    "CMYK_Y": 0,
    "CMYK_K": 0.2358917593956
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R338008",
    "Farbtonhilfsbezeichnung": "R33 80 08",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "195",
    "Bcolor": "206",
    "Y": 57,
    "L": 80.0486068725586,
    "a": 5.84912919998169,
    "b": -5.0702748298645,
    "C": 7.74080085754395,
    "h": 319.079864501953,
    "CMY_C": 0.194016456604,
    "CMY_M": 0.23348391056061,
    "CMY_Y": 0.19036376476288,
    "CMYK_C": 0.00451152212918,
    "CMYK_M": 0.05325866490602,
    "CMYK_Y": 0,
    "CMYK_K": 0.19036376476288
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R338505",
    "Farbtonhilfsbezeichnung": "R33 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "209",
    "Bcolor": "216",
    "Y": 66,
    "L": 84.6650848388672,
    "a": 3.90139031410217,
    "b": -3.37930035591125,
    "C": 5.16144514083862,
    "h": 319.101593017578,
    "CMY_C": 0.15249437093735,
    "CMY_M": 0.17900007963181,
    "CMY_Y": 0.15249067544937,
    "CMYK_C": 4.36041e-06,
    "CMYK_M": 0.03127918764949,
    "CMYK_Y": 0,
    "CMYK_K": 0.15249067544937
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R339004",
    "Farbtonhilfsbezeichnung": "R33 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "224",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.6529312133789,
    "a": 3.12430214881897,
    "b": -2.72416973114014,
    "C": 4.14516162872314,
    "h": 318.913879394531,
    "CMY_C": 0.10100054740906,
    "CMY_M": 0.12230062484741,
    "CMY_Y": 0.10244619846344,
    "CMYK_C": 0,
    "CMYK_M": 0.02369309216738,
    "CMYK_Y": 0.00160806661006,
    "CMYK_K": 0.10100054740906
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R342501",
    "Farbtonhilfsbezeichnung": "R34 25 01 Eisenoxidschwarz",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "61",
    "Bcolor": "61",
    "Y": 4,
    "L": 25.6703071594238,
    "a": 0.51773822307587,
    "b": -0.59937584400177,
    "C": 0.79202544689178,
    "h": 310.8203125,
    "CMY_C": 0.75996887683868,
    "CMY_M": 0.76222598552704,
    "CMY_Y": 0.76012372970581,
    "CMYK_C": 0,
    "CMYK_M": 0.00940340012312,
    "CMYK_Y": 0.00064513663528,
    "CMYK_K": 0.75996887683868
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R343503",
    "Farbtonhilfsbezeichnung": "R34 35 03",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "81",
    "Bcolor": "85",
    "Y": 8,
    "L": 35.0333557128906,
    "a": 2.17341136932373,
    "b": -2.10846900939941,
    "C": 3.02809476852417,
    "h": 315.868927001953,
    "CMY_C": 0.66880124807358,
    "CMY_M": 0.6805636882782,
    "CMY_Y": 0.66647410392761,
    "CMYK_C": 0.00697740167379,
    "CMYK_M": 0.04224434867501,
    "CMYK_Y": 0,
    "CMYK_K": 0.66647410392761
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R344010",
    "Farbtonhilfsbezeichnung": "R34 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "90",
    "Bcolor": "104",
    "Y": 11,
    "L": 39.5339050292969,
    "a": 7.37537574768066,
    "b": -7.25232648849487,
    "C": 10.343713760376,
    "h": 315.481964111328,
    "CMY_C": 0.60774409770966,
    "CMY_M": 0.64829283952713,
    "CMY_Y": 0.59152257442474,
    "CMYK_C": 0.03971216455102,
    "CMYK_M": 0.1389801800251,
    "CMYK_Y": 0,
    "CMYK_K": 0.59152257442474
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R344014",
    "Farbtonhilfsbezeichnung": "R34 40 14",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "90",
    "Bcolor": "111",
    "Y": 11,
    "L": 40.2692260742188,
    "a": 10.1471004486084,
    "b": -10.0461378097534,
    "C": 14.2789545059204,
    "h": 315.286468505859,
    "CMY_C": 0.59130203723907,
    "CMY_M": 0.64685332775116,
    "CMY_Y": 0.56656831502914,
    "CMYK_C": 0.05706486850977,
    "CMYK_M": 0.18523105978966,
    "CMYK_Y": 0,
    "CMYK_K": 0.56656831502914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R344503",
    "Farbtonhilfsbezeichnung": "R34 45 03",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "105",
    "Bcolor": "109",
    "Y": 15,
    "L": 44.928882598877,
    "a": 2.0774130821228,
    "b": -1.9739887714386,
    "C": 2.86570692062378,
    "h": 316.462341308594,
    "CMY_C": 0.57490682601929,
    "CMY_M": 0.58675122261047,
    "CMY_Y": 0.57367432117462,
    "CMYK_C": 0.00289099360816,
    "CMYK_M": 0.03067350201309,
    "CMYK_Y": 0,
    "CMYK_K": 0.57367432117462
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R345005",
    "Farbtonhilfsbezeichnung": "R34 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "117",
    "Bcolor": "123",
    "Y": 18,
    "L": 49.724796295166,
    "a": 3.40417718887329,
    "b": -3.32333421707153,
    "C": 4.75741243362427,
    "h": 315.6884765625,
    "CMY_C": 0.52283871173859,
    "CMY_M": 0.54243957996368,
    "CMY_Y": 0.51790452003479,
    "CMYK_C": 0.01023488491774,
    "CMYK_M": 0.0508925318718,
    "CMYK_Y": 0,
    "CMYK_K": 0.51790452003479
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R345015",
    "Farbtonhilfsbezeichnung": "R34 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "114",
    "Bcolor": "135",
    "Y": 18,
    "L": 49.9051971435547,
    "a": 10.5025730133057,
    "b": -10.4032487869263,
    "C": 14.7828149795532,
    "h": 315.272216796875,
    "CMY_C": 0.49491345882416,
    "CMY_M": 0.55480098724365,
    "CMY_Y": 0.46894913911819,
    "CMYK_C": 0.04889234155416,
    "CMYK_M": 0.16166408360004,
    "CMYK_Y": 0,
    "CMYK_K": 0.46894913911819
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R345503",
    "Farbtonhilfsbezeichnung": "R34 55 03",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "131",
    "Bcolor": "134",
    "Y": 23,
    "L": 54.9476737976074,
    "a": 2.09262871742249,
    "b": -2.06614184379578,
    "C": 2.94075441360474,
    "h": 315.364898681641,
    "CMY_C": 0.47586286067963,
    "CMY_M": 0.48795050382614,
    "CMY_Y": 0.47437709569931,
    "CMYK_C": 0.00282667484134,
    "CMYK_M": 0.02582347206771,
    "CMYK_Y": 0,
    "CMYK_K": 0.47437709569931
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R346010",
    "Farbtonhilfsbezeichnung": "R34 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "141",
    "Bcolor": "156",
    "Y": 28,
    "L": 59.8891181945801,
    "a": 7.05622816085815,
    "b": -7.12258434295654,
    "C": 10.0260438919067,
    "h": 314.731872558594,
    "CMY_C": 0.40639686584473,
    "CMY_M": 0.44775468111038,
    "CMY_Y": 0.38947981595993,
    "CMYK_C": 0.02770924009383,
    "CMYK_M": 0.09545116871595,
    "CMYK_Y": 0,
    "CMYK_K": 0.38947981595993
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R346014",
    "Farbtonhilfsbezeichnung": "R34 60 14",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "139",
    "Bcolor": "160",
    "Y": 28,
    "L": 59.874439239502,
    "a": 10.2207927703857,
    "b": -9.65078258514404,
    "C": 14.0571050643921,
    "h": 316.64306640625,
    "CMY_C": 0.39245671033859,
    "CMY_M": 0.45466876029968,
    "CMY_Y": 0.37211185693741,
    "CMYK_C": 0.03240203484893,
    "CMYK_M": 0.13148345053196,
    "CMYK_Y": 0,
    "CMYK_K": 0.37211185693741
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R346503",
    "Farbtonhilfsbezeichnung": "R34 65 03",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "156",
    "Bcolor": "160",
    "Y": 34,
    "L": 64.7597274780273,
    "a": 2.16195440292358,
    "b": -2.22041368484497,
    "C": 3.09907793998718,
    "h": 314.235748291016,
    "CMY_C": 0.37525987625122,
    "CMY_M": 0.38782197237015,
    "CMY_Y": 0.3732578754425,
    "CMYK_C": 0.00319429743104,
    "CMYK_M": 0.02323778159916,
    "CMYK_Y": 0,
    "CMYK_K": 0.3732578754425
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R346513",
    "Farbtonhilfsbezeichnung": "R34 65 13",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "154",
    "Bcolor": "174",
    "Y": 34,
    "L": 65.2721328735352,
    "a": 8.99482727050781,
    "b": -9.11962032318115,
    "C": 12.8091526031494,
    "h": 314.605285644531,
    "CMY_C": 0.34299552440643,
    "CMY_M": 0.39643347263336,
    "CMY_Y": 0.31949025392532,
    "CMYK_C": 0.03454068303108,
    "CMYK_M": 0.11306703090668,
    "CMYK_Y": 0,
    "CMYK_K": 0.31949025392532
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R347005",
    "Farbtonhilfsbezeichnung": "R34 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "169",
    "Bcolor": "176",
    "Y": 41,
    "L": 69.8634185791016,
    "a": 3.6255202293396,
    "b": -3.67382860183716,
    "C": 5.16153192520142,
    "h": 314.620819091797,
    "CMY_C": 0.31561750173569,
    "CMY_M": 0.33739393949509,
    "CMY_Y": 0.30962419509888,
    "CMYK_C": 0.00868122372776,
    "CMYK_M": 0.04022409766912,
    "CMYK_Y": 0,
    "CMYK_K": 0.30962419509888
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R347010",
    "Farbtonhilfsbezeichnung": "R34 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "168",
    "Bcolor": "183",
    "Y": 41,
    "L": 70.0922088623047,
    "a": 7.01495695114136,
    "b": -7.17218637466431,
    "C": 10.0324411392212,
    "h": 314.365051269531,
    "CMY_C": 0.29983365535736,
    "CMY_M": 0.34193789958954,
    "CMY_Y": 0.28229153156281,
    "CMYK_C": 0.02444185130298,
    "CMYK_M": 0.08310668170452,
    "CMYK_Y": 0,
    "CMYK_K": 0.28229153156281
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R347503",
    "Farbtonhilfsbezeichnung": "R34 75 03",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "183",
    "Bcolor": "186",
    "Y": 48,
    "L": 74.5958023071289,
    "a": 2.15242195129395,
    "b": -2.17287492752075,
    "C": 3.05848097801208,
    "h": 314.729064941406,
    "CMY_C": 0.2712436914444,
    "CMY_M": 0.28420507907867,
    "CMY_Y": 0.27022504806519,
    "CMYK_C": 0.00139583216514,
    "CMYK_M": 0.01915663294494,
    "CMYK_Y": 0,
    "CMYK_K": 0.27022504806519
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R347508",
    "Farbtonhilfsbezeichnung": "R34 75 08",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "182",
    "Bcolor": "193",
    "Y": 48,
    "L": 74.9584121704102,
    "a": 5.46473169326782,
    "b": -5.51820230484009,
    "C": 7.76619911193848,
    "h": 314.721069335938,
    "CMY_C": 0.25365906953812,
    "CMY_M": 0.28714638948441,
    "CMY_Y": 0.24217933416367,
    "CMYK_C": 0.01514835376292,
    "CMYK_M": 0.05933732911944,
    "CMYK_Y": 0,
    "CMYK_K": 0.24217933416367
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R348005",
    "Farbtonhilfsbezeichnung": "R34 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "196",
    "Bcolor": "203",
    "Y": 57,
    "L": 79.9418563842773,
    "a": 3.53299593925476,
    "b": -3.63178300857544,
    "C": 5.06674528121948,
    "h": 314.210052490234,
    "CMY_C": 0.20793259143829,
    "CMY_M": 0.22951048612595,
    "CMY_Y": 0.20217502117157,
    "CMYK_C": 0.00721658300608,
    "CMYK_M": 0.03426248207688,
    "CMYK_Y": 0,
    "CMYK_K": 0.20217502117157
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R348503",
    "Farbtonhilfsbezeichnung": "R34 85 03",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "212",
    "Bcolor": "215",
    "Y": 66,
    "L": 85.227783203125,
    "a": 2.18992495536804,
    "b": -2.21056342124939,
    "C": 3.11164927482605,
    "h": 314.731292724609,
    "CMY_C": 0.1555580496788,
    "CMY_M": 0.16907232999802,
    "CMY_Y": 0.15507513284683,
    "CMYK_C": 0.0005715500447,
    "CMYK_M": 0.01656620390713,
    "CMYK_Y": 0,
    "CMYK_K": 0.15507513284683
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R349004",
    "Farbtonhilfsbezeichnung": "R34 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "224",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.6477279663086,
    "a": 2.86162281036377,
    "b": -2.85613369941711,
    "C": 4.04306650161743,
    "h": 315.054992675781,
    "CMY_C": 0.10358130931854,
    "CMY_M": 0.1216835975647,
    "CMY_Y": 0.10156613588333,
    "CMYK_C": 0.00224298471585,
    "CMYK_M": 0.02239169925451,
    "CMYK_Y": 0,
    "CMYK_K": 0.10156613588333
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R354015",
    "Farbtonhilfsbezeichnung": "R35 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "91",
    "Bcolor": "114",
    "Y": 11,
    "L": 40.5426292419434,
    "a": 9.94116687774658,
    "b": -11.6020479202271,
    "C": 15.2785577774048,
    "h": 310.591491699219,
    "CMY_C": 0.59510952234268,
    "CMY_M": 0.64329123497009,
    "CMY_Y": 0.55411684513092,
    "CMYK_C": 0.0919359177351,
    "CMYK_M": 0.19999496638775,
    "CMYK_Y": 0,
    "CMYK_K": 0.55411684513092
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R354020",
    "Farbtonhilfsbezeichnung": "R35 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "90",
    "Bcolor": "120",
    "Y": 11,
    "L": 40.7938461303711,
    "a": 12.833194732666,
    "b": -15.2544279098511,
    "C": 19.9346046447754,
    "h": 310.073120117188,
    "CMY_C": 0.5858941078186,
    "CMY_M": 0.64655292034149,
    "CMY_Y": 0.52826988697052,
    "CMYK_C": 0.12215506285429,
    "CMYK_M": 0.25074303150177,
    "CMYK_Y": 0,
    "CMYK_K": 0.52826988697052
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R355515",
    "Farbtonhilfsbezeichnung": "R35 55 15",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "127",
    "Bcolor": "150",
    "Y": 23,
    "L": 54.8404579162598,
    "a": 9.55558586120605,
    "b": -11.2353239059448,
    "C": 14.7492961883545,
    "h": 310.380981445313,
    "CMY_C": 0.45433712005615,
    "CMY_M": 0.50335782766342,
    "CMY_Y": 0.41342705488205,
    "CMYK_C": 0.06974420696497,
    "CMYK_M": 0.1533155888319,
    "CMYK_Y": 0,
    "CMYK_K": 0.41342705488205
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R356020",
    "Farbtonhilfsbezeichnung": "R35 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "139",
    "Bcolor": "171",
    "Y": 28,
    "L": 60.3599243164063,
    "a": 12.740104675293,
    "b": -15.1815385818481,
    "C": 19.8189144134521,
    "h": 310.002838134766,
    "CMY_C": 0.38864809274673,
    "CMY_M": 0.45407783985138,
    "CMY_Y": 0.32918608188629,
    "CMYK_C": 0.08864159137011,
    "CMYK_M": 0.18617944419384,
    "CMYK_Y": 0,
    "CMYK_K": 0.32918608188629
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R357012",
    "Farbtonhilfsbezeichnung": "R35 70 12",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "167",
    "Bcolor": "186",
    "Y": 41,
    "L": 69.9526062011719,
    "a": 7.69370269775391,
    "b": -9.18690204620361,
    "C": 11.9829978942871,
    "h": 309.944976806641,
    "CMY_C": 0.30325108766556,
    "CMY_M": 0.34440982341766,
    "CMY_Y": 0.26959139108658,
    "CMYK_C": 0.04608337953687,
    "CMYK_M": 0.10243366658688,
    "CMYK_Y": 0,
    "CMYK_K": 0.26959139108658
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R357510",
    "Farbtonhilfsbezeichnung": "R35 75 10",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "181",
    "Bcolor": "197",
    "Y": 48,
    "L": 74.8756332397461,
    "a": 6.58313655853271,
    "b": -7.96121978759766,
    "C": 10.3304748535156,
    "h": 309.587371826172,
    "CMY_C": 0.25457924604416,
    "CMY_M": 0.28996455669403,
    "CMY_Y": 0.22558832168579,
    "CMYK_C": 0.03743606433272,
    "CMYK_M": 0.08312921226025,
    "CMYK_Y": 0,
    "CMYK_K": 0.22558832168579
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R357909",
    "Farbtonhilfsbezeichnung": "R35 79 09",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "192",
    "Bcolor": "207",
    "Y": 55,
    "L": 78.8110809326172,
    "a": 5.77525186538696,
    "b": -7.02140283584595,
    "C": 9.09140396118164,
    "h": 309.438018798828,
    "CMY_C": 0.21483504772186,
    "CMY_M": 0.24607986211777,
    "CMY_Y": 0.18980234861374,
    "CMYK_C": 0.03089702688158,
    "CMYK_M": 0.0694614648819,
    "CMYK_Y": 0,
    "CMYK_K": 0.18980234861374
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R358010",
    "Farbtonhilfsbezeichnung": "R35 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "197",
    "Bcolor": "212",
    "Y": 57,
    "L": 80.480339050293,
    "a": 6.3753023147583,
    "b": -7.57008171081543,
    "C": 9.89700031280518,
    "h": 310.103118896484,
    "CMY_C": 0.19397985935211,
    "CMY_M": 0.22931700944901,
    "CMY_Y": 0.16759395599365,
    "CMYK_C": 0.03169835731387,
    "CMYK_M": 0.07415017485619,
    "CMYK_Y": 0,
    "CMYK_K": 0.16759395599365
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R358506",
    "Farbtonhilfsbezeichnung": "R35 85 06",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "210",
    "Bcolor": "220",
    "Y": 66,
    "L": 84.9316635131836,
    "a": 4.19320106506348,
    "b": -5.08367729187012,
    "C": 6.58989477157593,
    "h": 309.517059326172,
    "CMY_C": 0.15322256088257,
    "CMY_M": 0.17626792192459,
    "CMY_Y": 0.13710844516754,
    "CMYK_C": 0.01867455430329,
    "CMYK_M": 0.04538169130683,
    "CMYK_Y": 0,
    "CMYK_K": 0.13710844516754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R359004",
    "Farbtonhilfsbezeichnung": "R35 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "224",
    "Bcolor": "230",
    "Y": 76,
    "L": 89.6381378173828,
    "a": 2.51165246963501,
    "b": -3.13477492332458,
    "C": 4.01686573028564,
    "h": 308.702484130859,
    "CMY_C": 0.1074224114418,
    "CMY_M": 0.12086272239685,
    "CMY_Y": 0.09966486692429,
    "CMYK_C": 0.0086162853986,
    "CMYK_M": 0.02354440465569,
    "CMYK_Y": 0,
    "CMYK_K": 0.09966486692429
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R364010",
    "Farbtonhilfsbezeichnung": "R36 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "92",
    "Bcolor": "107",
    "Y": 11,
    "L": 40.0726585388184,
    "a": 5.9153733253479,
    "b": -8.28051948547363,
    "C": 10.1763763427734,
    "h": 305.540954589844,
    "CMY_C": 0.61561280488968,
    "CMY_M": 0.63967192173004,
    "CMY_Y": 0.58003067970276,
    "CMYK_C": 0.08472553640604,
    "CMYK_M": 0.14201332628727,
    "CMYK_Y": 0,
    "CMYK_K": 0.58003067970276
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R365005",
    "Farbtonhilfsbezeichnung": "R36 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "117",
    "Bcolor": "124",
    "Y": 18,
    "L": 49.8670501708984,
    "a": 2.87557768821716,
    "b": -4.01500511169434,
    "C": 4.93854379653931,
    "h": 305.610534667969,
    "CMY_C": 0.52731674909592,
    "CMY_M": 0.53969442844391,
    "CMY_Y": 0.51203036308289,
    "CMYK_C": 0.03132651001215,
    "CMYK_M": 0.05669218674302,
    "CMYK_Y": 0,
    "CMYK_K": 0.51203036308289
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R365015",
    "Farbtonhilfsbezeichnung": "R36 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "116",
    "Bcolor": "139",
    "Y": 18,
    "L": 50.2766189575195,
    "a": 8.59905338287354,
    "b": -12.2641677856445,
    "C": 14.9784355163574,
    "h": 305.036315917969,
    "CMY_C": 0.51080638170242,
    "CMY_M": 0.54605686664581,
    "CMY_Y": 0.45319890975952,
    "CMYK_C": 0.10535361617804,
    "CMYK_M": 0.16982035338879,
    "CMYK_Y": 0,
    "CMYK_K": 0.45319890975952
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R366010",
    "Farbtonhilfsbezeichnung": "R36 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "141",
    "Bcolor": "158",
    "Y": 28,
    "L": 59.7255706787109,
    "a": 6.05745601654053,
    "b": -8.58071231842041,
    "C": 10.5033988952637,
    "h": 305.219757080078,
    "CMY_C": 0.42024964094162,
    "CMY_M": 0.4466495513916,
    "CMY_Y": 0.38139474391937,
    "CMYK_C": 0.06281048804522,
    "CMYK_M": 0.1054869890213,
    "CMYK_Y": 0,
    "CMYK_K": 0.38139474391937
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R367005",
    "Farbtonhilfsbezeichnung": "R36 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "169",
    "Bcolor": "177",
    "Y": 41,
    "L": 69.8163146972656,
    "a": 2.92239832878113,
    "b": -4.228196144104,
    "C": 5.13984966278076,
    "h": 304.651031494141,
    "CMY_C": 0.32324773073196,
    "CMY_M": 0.33610284328461,
    "CMY_Y": 0.30632948875427,
    "CMYK_C": 0.024389449507,
    "CMYK_M": 0.04292146489024,
    "CMYK_Y": 0,
    "CMYK_K": 0.30632948875427
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R367505",
    "Farbtonhilfsbezeichnung": "R36 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "183",
    "Bcolor": "191",
    "Y": 48,
    "L": 74.9921493530273,
    "a": 2.93227124214172,
    "b": -4.31088256835938,
    "C": 5.2136287689209,
    "h": 304.2236328125,
    "CMY_C": 0.26834410429001,
    "CMY_M": 0.28116375207901,
    "CMY_Y": 0.25071239471436,
    "CMYK_C": 0.02353129722178,
    "CMYK_M": 0.04064041376114,
    "CMYK_Y": 0,
    "CMYK_K": 0.25071239471436
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R373010",
    "Farbtonhilfsbezeichnung": "R37 30 10",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "71",
    "Bcolor": "85",
    "Y": 6,
    "L": 30.9623222351074,
    "a": 4.34353446960449,
    "b": -8.31851959228516,
    "C": 9.38424491882324,
    "h": 297.571411132813,
    "CMY_C": 0.71149957180023,
    "CMY_M": 0.72056198120117,
    "CMY_Y": 0.66617256402969,
    "CMYK_C": 0.13577975332737,
    "CMYK_M": 0.16292674839497,
    "CMYK_Y": 0,
    "CMYK_K": 0.66617256402969
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R373020",
    "Farbtonhilfsbezeichnung": "R37 30 20",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "98",
    "Y": 6,
    "L": 30.4065494537354,
    "a": 10.1881217956543,
    "b": -17.3103904724121,
    "C": 20.0860004425049,
    "h": 300.479156494141,
    "CMY_C": 0.71024763584137,
    "CMY_M": 0.73529320955276,
    "CMY_Y": 0.61657029390335,
    "CMYK_C": 0.24431425333023,
    "CMYK_M": 0.30963411927223,
    "CMYK_Y": 0,
    "CMYK_K": 0.61657029390335
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R374005",
    "Farbtonhilfsbezeichnung": "R37 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "95",
    "Bcolor": "102",
    "Y": 11,
    "L": 40.5592269897461,
    "a": 2.37294816970825,
    "b": -4.22349214553833,
    "C": 4.84445762634277,
    "h": 299.329254150391,
    "CMY_C": 0.62190544605255,
    "CMY_M": 0.62864023447037,
    "CMY_Y": 0.60130029916763,
    "CMYK_C": 0.05168087035418,
    "CMYK_M": 0.06857275217772,
    "CMYK_Y": 0,
    "CMYK_K": 0.60130029916763
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R374015",
    "Farbtonhilfsbezeichnung": "R37 40 15",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "92",
    "Bcolor": "116",
    "Y": 11,
    "L": 40.5777549743652,
    "a": 7.72794485092163,
    "b": -13.2093639373779,
    "C": 15.3038692474365,
    "h": 300.329132080078,
    "CMY_C": 0.61553001403809,
    "CMY_M": 0.63737237453461,
    "CMY_Y": 0.543836414814,
    "CMYK_C": 0.15716642141342,
    "CMYK_M": 0.20504915714264,
    "CMYK_Y": 0,
    "CMYK_K": 0.543836414814
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R375010",
    "Farbtonhilfsbezeichnung": "R37 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "118",
    "Bcolor": "134",
    "Y": 18,
    "L": 50.480525970459,
    "a": 5.02442646026611,
    "b": -8.78301429748535,
    "C": 10.1186065673828,
    "h": 299.772216796875,
    "CMY_C": 0.52196526527405,
    "CMY_M": 0.5369947552681,
    "CMY_Y": 0.47439557313919,
    "CMYK_C": 0.09050474315882,
    "CMYK_M": 0.11909941583872,
    "CMYK_Y": 0,
    "CMYK_K": 0.47439557313919
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R375515",
    "Farbtonhilfsbezeichnung": "R37 55 15",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "128",
    "Bcolor": "153",
    "Y": 23,
    "L": 54.9652862548828,
    "a": 7.7235279083252,
    "b": -13.2284679412842,
    "C": 15.3181343078613,
    "h": 300.27880859375,
    "CMY_C": 0.47341644763947,
    "CMY_M": 0.49714505672455,
    "CMY_Y": 0.39903205633163,
    "CMYK_C": 0.123774304986,
    "CMYK_M": 0.16325829923153,
    "CMYK_Y": 0,
    "CMYK_K": 0.39903205633163
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R376005",
    "Farbtonhilfsbezeichnung": "R37 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "143",
    "Bcolor": "151",
    "Y": 28,
    "L": 59.8964767456055,
    "a": 2.63771748542786,
    "b": -4.511803150177,
    "C": 5.22627210617065,
    "h": 300.311676025391,
    "CMY_C": 0.42959171533585,
    "CMY_M": 0.43833082914352,
    "CMY_Y": 0.40764671564102,
    "CMYK_C": 0.03704714775085,
    "CMYK_M": 0.0518003590405,
    "CMYK_Y": 0,
    "CMYK_K": 0.40764671564102
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R376013",
    "Farbtonhilfsbezeichnung": "R37 60 13",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "142",
    "Bcolor": "163",
    "Y": 28,
    "L": 59.9565887451172,
    "a": 6.34526348114014,
    "b": -10.9730644226074,
    "C": 12.6755876541138,
    "h": 300.039001464844,
    "CMY_C": 0.42428058385849,
    "CMY_M": 0.44421368837357,
    "CMY_Y": 0.3627256155014,
    "CMYK_C": 0.09659099578857,
    "CMYK_M": 0.12786968052387,
    "CMYK_Y": 0,
    "CMYK_K": 0.3627256155014
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R376510",
    "Farbtonhilfsbezeichnung": "R37 65 10",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "155",
    "Bcolor": "171",
    "Y": 34,
    "L": 64.629035949707,
    "a": 4.98440027236938,
    "b": -8.64782810211182,
    "C": 9.98144149780273,
    "h": 299.958129882813,
    "CMY_C": 0.37764459848404,
    "CMY_M": 0.39374798536301,
    "CMY_Y": 0.32997626066208,
    "CMYK_C": 0.07114425301552,
    "CMYK_M": 0.09517830610275,
    "CMYK_Y": 0,
    "CMYK_K": 0.32997626066208
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R377005",
    "Farbtonhilfsbezeichnung": "R37 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "170",
    "Bcolor": "177",
    "Y": 41,
    "L": 69.8175888061523,
    "a": 2.58761548995972,
    "b": -4.45262098312378,
    "C": 5.14991140365601,
    "h": 300.162780761719,
    "CMY_C": 0.32652580738068,
    "CMY_M": 0.33525377511978,
    "CMY_Y": 0.30478698015213,
    "CMYK_C": 0.03126930445433,
    "CMYK_M": 0.04382368177176,
    "CMYK_Y": 0,
    "CMYK_K": 0.30478698015213
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R377008",
    "Farbtonhilfsbezeichnung": "R37 70 08",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "170",
    "Bcolor": "182",
    "Y": 41,
    "L": 70.0335388183594,
    "a": 3.86116790771484,
    "b": -6.73185014724731,
    "C": 7.76056861877441,
    "h": 299.837158203125,
    "CMY_C": 0.32255268096924,
    "CMY_M": 0.335245013237,
    "CMY_Y": 0.28638446331024,
    "CMYK_C": 0.05068305879831,
    "CMYK_M": 0.06846901029348,
    "CMYK_Y": 0,
    "CMYK_K": 0.28638446331024
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R377505",
    "Farbtonhilfsbezeichnung": "R37 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 48,
    "L": 75.0103073120117,
    "a": 2.67352437973022,
    "b": -4.59248352050781,
    "C": 5.31400394439697,
    "h": 300.205932617188,
    "CMY_C": 0.27110588550568,
    "CMY_M": 0.2802831530571,
    "CMY_Y": 0.24855041503906,
    "CMYK_C": 0.03001594729722,
    "CMYK_M": 0.04222869873047,
    "CMYK_Y": 0,
    "CMYK_K": 0.24855041503906
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R378005",
    "Farbtonhilfsbezeichnung": "R37 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "197",
    "Bcolor": "204",
    "Y": 57,
    "L": 79.8864440917969,
    "a": 2.53444671630859,
    "b": -4.27614593505859,
    "C": 4.9707989692688,
    "h": 300.654968261719,
    "CMY_C": 0.21847027540207,
    "CMY_M": 0.22755753993988,
    "CMY_Y": 0.19826757907867,
    "CMYK_C": 0.02519880235195,
    "CMYK_M": 0.03653333708644,
    "CMYK_Y": 0,
    "CMYK_K": 0.19826757907867
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R378505",
    "Farbtonhilfsbezeichnung": "R37 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "210",
    "Bcolor": "218",
    "Y": 66,
    "L": 84.6540908813477,
    "a": 2.63810348510742,
    "b": -4.60978555679321,
    "C": 5.31128168106079,
    "h": 299.781799316406,
    "CMY_C": 0.16676515340805,
    "CMY_M": 0.17572486400604,
    "CMY_Y": 0.14381420612335,
    "CMYK_C": 0.02680603601038,
    "CMYK_M": 0.03727071732283,
    "CMYK_Y": 0,
    "CMYK_K": 0.14381420612335
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R384010",
    "Farbtonhilfsbezeichnung": "R38 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "92",
    "Bcolor": "108",
    "Y": 11,
    "L": 39.66259765625,
    "a": 4.34718418121338,
    "b": -9.46645927429199,
    "C": 10.4169025421143,
    "h": 294.66552734375,
    "CMY_C": 0.63439106941223,
    "CMY_M": 0.63979744911194,
    "CMY_Y": 0.57668769359589,
    "CMYK_C": 0.13631395995617,
    "CMYK_M": 0.14908556640148,
    "CMYK_Y": 0,
    "CMYK_K": 0.57668769359589
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R385005",
    "Farbtonhilfsbezeichnung": "R38 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "117",
    "Bcolor": "124",
    "Y": 18,
    "L": 49.4026069641113,
    "a": 2.01751208305359,
    "b": -4.49546337127686,
    "C": 4.92742776870728,
    "h": 294.169982910156,
    "CMY_C": 0.53954470157623,
    "CMY_M": 0.54228401184082,
    "CMY_Y": 0.51358091831207,
    "CMYK_C": 0.05337739363313,
    "CMYK_M": 0.05900897830725,
    "CMYK_Y": 0,
    "CMYK_K": 0.51358091831207
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R385015",
    "Farbtonhilfsbezeichnung": "R38 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "115",
    "Bcolor": "140",
    "Y": 18,
    "L": 49.5908164978027,
    "a": 6.45830202102661,
    "b": -13.9921741485596,
    "C": 15.4107303619385,
    "h": 294.776397705078,
    "CMY_C": 0.53955614566803,
    "CMY_M": 0.54732608795166,
    "CMY_Y": 0.44902247190475,
    "CMYK_C": 0.16431464254856,
    "CMYK_M": 0.17841674387455,
    "CMYK_Y": 0,
    "CMYK_K": 0.44902247190475
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R386010",
    "Farbtonhilfsbezeichnung": "R38 60 10",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "142",
    "Bcolor": "159",
    "Y": 28,
    "L": 59.7764930725098,
    "a": 4.34362030029297,
    "b": -9.1515417098999,
    "C": 10.1300420761108,
    "h": 295.390533447266,
    "CMY_C": 0.43439871072769,
    "CMY_M": 0.4420257806778,
    "CMY_Y": 0.37719011306763,
    "CMYK_C": 0.09185563772917,
    "CMYK_M": 0.10410185903311,
    "CMYK_Y": 0,
    "CMYK_K": 0.37719011306763
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R386013",
    "Farbtonhilfsbezeichnung": "R38 60 13",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "141",
    "Bcolor": "162",
    "Y": 28,
    "L": 59.3971748352051,
    "a": 5.40973806381226,
    "b": -11.5210628509522,
    "C": 12.7279281616211,
    "h": 295.152496337891,
    "CMY_C": 0.43903720378876,
    "CMY_M": 0.44758403301239,
    "CMY_Y": 0.36492663621902,
    "CMYK_C": 0.11669607460499,
    "CMYK_M": 0.13015408813953,
    "CMYK_Y": 0,
    "CMYK_K": 0.36492663621902
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R386507",
    "Farbtonhilfsbezeichnung": "R38 65 07",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "157",
    "Bcolor": "167",
    "Y": 34,
    "L": 64.9863052368164,
    "a": 2.8969554901123,
    "b": -6.06780767440796,
    "C": 6.72388601303101,
    "h": 295.521209716797,
    "CMY_C": 0.38045126199722,
    "CMY_M": 0.38603073358536,
    "CMY_Y": 0.34427452087402,
    "CMYK_C": 0.055170558393,
    "CMYK_M": 0.06367941200733,
    "CMYK_Y": 0,
    "CMYK_K": 0.34427452087402
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R387005",
    "Farbtonhilfsbezeichnung": "R38 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "170",
    "Bcolor": "178",
    "Y": 41,
    "L": 70.0391540527344,
    "a": 2.11728525161743,
    "b": -4.66987085342407,
    "C": 5.12743520736694,
    "h": 294.389190673828,
    "CMY_C": 0.32850211858749,
    "CMY_M": 0.33177655935287,
    "CMY_Y": 0.30098301172256,
    "CMYK_C": 0.03936829417944,
    "CMYK_M": 0.04405264556408,
    "CMYK_Y": 0,
    "CMYK_K": 0.30098301172256
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R387012",
    "Farbtonhilfsbezeichnung": "R38 70 12",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "170",
    "Bcolor": "191",
    "Y": 41,
    "L": 70.3086853027344,
    "a": 5.19292402267456,
    "b": -11.4455595016479,
    "C": 12.5685043334961,
    "h": 294.404113769531,
    "CMY_C": 0.32672411203384,
    "CMY_M": 0.33398985862732,
    "CMY_Y": 0.25025314092636,
    "CMYK_C": 0.10199572145939,
    "CMYK_M": 0.1116866543889,
    "CMYK_Y": 0,
    "CMYK_K": 0.25025314092636
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R387510",
    "Farbtonhilfsbezeichnung": "R38 75 10",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "183",
    "Bcolor": "200",
    "Y": 48,
    "L": 75.0371475219727,
    "a": 4.38807058334351,
    "b": -9.23077201843262,
    "C": 10.2206811904907,
    "h": 295.425201416016,
    "CMY_C": 0.27427339553833,
    "CMY_M": 0.28260552883148,
    "CMY_Y": 0.21509748697281,
    "CMYK_C": 0.07539268583059,
    "CMYK_M": 0.08600818365812,
    "CMYK_Y": 0,
    "CMYK_K": 0.21509748697281
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R388007",
    "Farbtonhilfsbezeichnung": "R38 80 07",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "196",
    "Bcolor": "207",
    "Y": 57,
    "L": 79.411247253418,
    "a": 2.97316718101501,
    "b": -6.28917741775513,
    "C": 6.95654201507568,
    "h": 295.302124023438,
    "CMY_C": 0.22737950086594,
    "CMY_M": 0.23313283920288,
    "CMY_Y": 0.1888912320137,
    "CMYK_C": 0.04745142906904,
    "CMYK_M": 0.05454460531473,
    "CMYK_Y": 0,
    "CMYK_K": 0.1888912320137
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R388505",
    "Farbtonhilfsbezeichnung": "R38 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "212",
    "Bcolor": "219",
    "Y": 66,
    "L": 85.0698547363281,
    "a": 2.09936189651489,
    "b": -4.53487920761108,
    "C": 4.99724435806274,
    "h": 294.841156005859,
    "CMY_C": 0.16617226600647,
    "CMY_M": 0.16990256309509,
    "CMY_Y": 0.13986390829086,
    "CMYK_C": 0.03058627434075,
    "CMYK_M": 0.03492314368486,
    "CMYK_Y": 0,
    "CMYK_K": 0.13986390829086
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R389004",
    "Farbtonhilfsbezeichnung": "R38 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 76,
    "L": 89.5948638916016,
    "a": 1.75969505310059,
    "b": -3.75429701805115,
    "C": 4.14623594284058,
    "h": 295.113189697266,
    "CMY_C": 0.11606776714325,
    "CMY_M": 0.11935222148895,
    "CMY_Y": 0.09567660093307,
    "CMYK_C": 0.02254853397608,
    "CMYK_M": 0.02618047967553,
    "CMYK_Y": 0,
    "CMYK_K": 0.09567660093307
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R394020",
    "Farbtonhilfsbezeichnung": "R39 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "93",
    "Bcolor": "124",
    "Y": 11,
    "L": 40.3907051086426,
    "a": 6.73529577255249,
    "b": -18.3493995666504,
    "C": 19.5464744567871,
    "h": 290.156066894531,
    "CMY_C": 0.64532256126404,
    "CMY_M": 0.63517391681671,
    "CMY_Y": 0.51320481300354,
    "CMYK_C": 0.27140316367149,
    "CMYK_M": 0.25055527687073,
    "CMYK_Y": 0,
    "CMYK_K": 0.51320481300354
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R394515",
    "Farbtonhilfsbezeichnung": "R39 45 15",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "105",
    "Bcolor": "129",
    "Y": 15,
    "L": 45.1948928833008,
    "a": 4.81378650665283,
    "b": -14.0599842071533,
    "C": 14.8612146377563,
    "h": 288.89990234375,
    "CMY_C": 0.59524297714233,
    "CMY_M": 0.58650356531143,
    "CMY_Y": 0.49298685789108,
    "CMYK_C": 0.20168337225914,
    "CMYK_M": 0.18444631993771,
    "CMYK_Y": 0,
    "CMYK_K": 0.49298685789108
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R395015",
    "Farbtonhilfsbezeichnung": "R39 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "118",
    "Bcolor": "143",
    "Y": 18,
    "L": 50.3049354553223,
    "a": 5.30352592468262,
    "b": -14.1458473205566,
    "C": 15.1073617935181,
    "h": 290.551910400391,
    "CMY_C": 0.54168748855591,
    "CMY_M": 0.53765708208084,
    "CMY_Y": 0.44087946414948,
    "CMYK_C": 0.18029747903347,
    "CMYK_M": 0.17308901250362,
    "CMYK_Y": 0,
    "CMYK_K": 0.44087946414948
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R395030",
    "Farbtonhilfsbezeichnung": "R39 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "116",
    "Bcolor": "166",
    "Y": 18,
    "L": 50.3577499389648,
    "a": 10.304295539856,
    "b": -27.9873638153076,
    "C": 29.8240013122559,
    "h": 290.212524414063,
    "CMY_C": 0.56501233577728,
    "CMY_M": 0.54346710443497,
    "CMY_Y": 0.34837204217911,
    "CMYK_C": 0.33246010541916,
    "CMYK_M": 0.29939639568329,
    "CMYK_Y": 0,
    "CMYK_K": 0.34837204217911
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R395510",
    "Farbtonhilfsbezeichnung": "R39 55 10",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "131",
    "Bcolor": "147",
    "Y": 23,
    "L": 55.1028594970703,
    "a": 3.52215170860291,
    "b": -9.59203338623047,
    "C": 10.2182512283325,
    "h": 290.162994384766,
    "CMY_C": 0.48961246013641,
    "CMY_M": 0.48737555742264,
    "CMY_Y": 0.42238223552704,
    "CMYK_C": 0.11639223992825,
    "CMYK_M": 0.1125196069479,
    "CMYK_Y": 0,
    "CMYK_K": 0.42238223552704
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R396010",
    "Farbtonhilfsbezeichnung": "R39 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "144",
    "Bcolor": "161",
    "Y": 28,
    "L": 60.3186988830566,
    "a": 3.40306043624878,
    "b": -9.32878303527832,
    "C": 9.9301061630249,
    "h": 290.041534423828,
    "CMY_C": 0.43655866384506,
    "CMY_M": 0.43430608510971,
    "CMY_Y": 0.37047207355499,
    "CMYK_C": 0.1049780100584,
    "CMYK_M": 0.10139980912209,
    "CMYK_Y": 0,
    "CMYK_K": 0.37047207355499
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R396015",
    "Farbtonhilfsbezeichnung": "R39 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "143",
    "Bcolor": "168",
    "Y": 28,
    "L": 59.9202308654785,
    "a": 5.18979215621948,
    "b": -14.0108070373535,
    "C": 14.9411058425903,
    "h": 290.325317382813,
    "CMY_C": 0.4449822306633,
    "CMY_M": 0.4409419298172,
    "CMY_Y": 0.34258103370667,
    "CMYK_C": 0.15576246380806,
    "CMYK_M": 0.14961676299572,
    "CMYK_Y": 0,
    "CMYK_K": 0.34258103370667
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R396505",
    "Farbtonhilfsbezeichnung": "R39 65 05",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "157",
    "Bcolor": "165",
    "Y": 34,
    "L": 64.9137268066406,
    "a": 1.80128085613251,
    "b": -4.93918466567993,
    "C": 5.25739097595215,
    "h": 290.036499023438,
    "CMY_C": 0.38550680875778,
    "CMY_M": 0.38463830947876,
    "CMY_Y": 0.35295110940933,
    "CMYK_C": 0.0503141246736,
    "CMYK_M": 0.04897188022733,
    "CMYK_Y": 0,
    "CMYK_K": 0.35295110940933
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R396510",
    "Farbtonhilfsbezeichnung": "R39 65 10",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "155",
    "Bcolor": "173",
    "Y": 34,
    "L": 64.627082824707,
    "a": 3.71701717376709,
    "b": -9.83784484863281,
    "C": 10.5166254043579,
    "h": 290.697998046875,
    "CMY_C": 0.39161497354507,
    "CMY_M": 0.39048510789871,
    "CMY_Y": 0.32193899154663,
    "CMYK_C": 0.10275769233704,
    "CMYK_M": 0.10109136998653,
    "CMYK_Y": 0,
    "CMYK_K": 0.32193899154663
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R396512",
    "Farbtonhilfsbezeichnung": "R39 65 12",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "156",
    "Bcolor": "177",
    "Y": 34,
    "L": 64.8473358154297,
    "a": 4.37865829467773,
    "b": -11.8403196334839,
    "C": 12.6240177154541,
    "h": 290.294860839844,
    "CMY_C": 0.39184921979904,
    "CMY_M": 0.38908535242081,
    "CMY_Y": 0.30572462081909,
    "CMYK_C": 0.1240496262908,
    "CMYK_M": 0.12006868422031,
    "CMYK_Y": 0,
    "CMYK_K": 0.30572462081909
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R397008",
    "Farbtonhilfsbezeichnung": "R39 70 08",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "170",
    "Bcolor": "183",
    "Y": 41,
    "L": 69.9228286743164,
    "a": 2.61173105239868,
    "b": -7.24614953994751,
    "C": 7.70245552062988,
    "h": 289.820709228516,
    "CMY_C": 0.33511352539063,
    "CMY_M": 0.33337181806564,
    "CMY_Y": 0.28410893678665,
    "CMYK_C": 0.07124629616737,
    "CMYK_M": 0.06881337612867,
    "CMYK_Y": 0,
    "CMYK_K": 0.28410893678665
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R397020",
    "Farbtonhilfsbezeichnung": "R39 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "169",
    "Bcolor": "203",
    "Y": 41,
    "L": 70.2191925048828,
    "a": 6.55502271652222,
    "b": -18.1294727325439,
    "C": 19.2781257629395,
    "h": 289.878326416016,
    "CMY_C": 0.34384000301361,
    "CMY_M": 0.33590769767761,
    "CMY_Y": 0.20414066314697,
    "CMYK_C": 0.17553269863129,
    "CMYK_M": 0.16556572914124,
    "CMYK_Y": 0,
    "CMYK_K": 0.20414066314697
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R397505",
    "Farbtonhilfsbezeichnung": "R39 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 48,
    "L": 74.8979339599609,
    "a": 1.7018803358078,
    "b": -4.78767061233521,
    "C": 5.08116006851196,
    "h": 289.56884765625,
    "CMY_C": 0.28047657012939,
    "CMY_M": 0.27917462587357,
    "CMY_Y": 0.24849039316177,
    "CMYK_C": 0.0425625666976,
    "CMYK_M": 0.04083012789488,
    "CMYK_Y": 0,
    "CMYK_K": 0.24849039316177
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R397511",
    "Farbtonhilfsbezeichnung": "R39 75 11",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "183",
    "Bcolor": "202",
    "Y": 48,
    "L": 75.0089111328125,
    "a": 3.88700819015503,
    "b": -10.4748239517212,
    "C": 11.1727695465088,
    "h": 290.358947753906,
    "CMY_C": 0.28318852186203,
    "CMY_M": 0.28133481740952,
    "CMY_Y": 0.20662158727646,
    "CMYK_C": 0.09650745987892,
    "CMYK_M": 0.09417098760605,
    "CMYK_Y": 0,
    "CMYK_K": 0.20662158727646
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R398009",
    "Farbtonhilfsbezeichnung": "R39 80 09",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "197",
    "Bcolor": "213",
    "Y": 57,
    "L": 79.9197616577148,
    "a": 3.13881492614746,
    "b": -8.64926528930664,
    "C": 9.20119285583496,
    "h": 289.945831298828,
    "CMY_C": 0.22926938533783,
    "CMY_M": 0.22729063034058,
    "CMY_Y": 0.16634953022003,
    "CMYK_C": 0.07547510415316,
    "CMYK_M": 0.07310149818659,
    "CMYK_Y": 0,
    "CMYK_K": 0.16634953022003
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R398010",
    "Farbtonhilfsbezeichnung": "R39 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "197",
    "Bcolor": "214",
    "Y": 57,
    "L": 79.9968948364258,
    "a": 3.44587635993958,
    "b": -9.50157070159912,
    "C": 10.1071214675903,
    "h": 289.933868408203,
    "CMY_C": 0.22922140359879,
    "CMY_M": 0.22691351175308,
    "CMY_Y": 0.15933108329773,
    "CMYK_C": 0.08313655853271,
    "CMYK_M": 0.08039125055075,
    "CMYK_Y": 0,
    "CMYK_K": 0.15933108329773
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R399004",
    "Farbtonhilfsbezeichnung": "R39 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 76,
    "L": 89.742301940918,
    "a": 1.42386412620544,
    "b": -3.83538150787354,
    "C": 4.09115409851074,
    "h": 290.367156982422,
    "CMY_C": 0.11740154027939,
    "CMY_M": 0.11688727140427,
    "CMY_Y": 0.09348738193512,
    "CMYK_C": 0.02638039179146,
    "CMYK_M": 0.02581308782101,
    "CMYK_Y": 0,
    "CMYK_K": 0.09348738193512
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R404010",
    "Farbtonhilfsbezeichnung": "R40 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "95",
    "Bcolor": "110",
    "Y": 11,
    "L": 40.6028518676758,
    "a": 2.41533398628235,
    "b": -9.49733257293701,
    "C": 9.79965114593506,
    "h": 284.268798828125,
    "CMY_C": 0.63934183120728,
    "CMY_M": 0.62681806087494,
    "CMY_Y": 0.56758350133896,
    "CMYK_C": 0.16594725847244,
    "CMYK_M": 0.13698495924473,
    "CMYK_Y": 0,
    "CMYK_K": 0.56758350133896
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R404020",
    "Farbtonhilfsbezeichnung": "R40 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "93",
    "Bcolor": "124",
    "Y": 11,
    "L": 40.0636978149414,
    "a": 4.95782661437988,
    "b": -18.5757579803467,
    "C": 19.2259941101074,
    "h": 284.943786621094,
    "CMY_C": 0.66325747966766,
    "CMY_M": 0.63433444499969,
    "CMY_Y": 0.51517099142075,
    "CMYK_C": 0.30544066429138,
    "CMYK_M": 0.24578449130058,
    "CMYK_Y": 0,
    "CMYK_K": 0.51517099142075
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R405005",
    "Farbtonhilfsbezeichnung": "R40 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "119",
    "Bcolor": "126",
    "Y": 18,
    "L": 49.9355621337891,
    "a": 1.21647834777832,
    "b": -4.86322593688965,
    "C": 5.0130615234375,
    "h": 284.043701171875,
    "CMY_C": 0.54127156734467,
    "CMY_M": 0.53521609306335,
    "CMY_Y": 0.50598275661469,
    "CMYK_C": 0.07143234461546,
    "CMYK_M": 0.0591747276485,
    "CMYK_Y": 0,
    "CMYK_K": 0.50598275661469
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R405015",
    "Farbtonhilfsbezeichnung": "R40 50 15",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "117",
    "Bcolor": "142",
    "Y": 18,
    "L": 49.6875305175781,
    "a": 3.92572236061096,
    "b": -14.6978893280029,
    "C": 15.2131271362305,
    "h": 284.954284667969,
    "CMY_C": 0.56055575609207,
    "CMY_M": 0.54052186012268,
    "CMY_Y": 0.44366008043289,
    "CMYK_C": 0.21011556684971,
    "CMYK_M": 0.17410539090633,
    "CMYK_Y": 0,
    "CMYK_K": 0.44366008043289
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R406010",
    "Farbtonhilfsbezeichnung": "R40 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "143",
    "Bcolor": "160",
    "Y": 28,
    "L": 59.8171577453613,
    "a": 2.74716830253601,
    "b": -9.91548633575439,
    "C": 10.2890138626099,
    "h": 285.48583984375,
    "CMY_C": 0.44887280464172,
    "CMY_M": 0.43778431415558,
    "CMY_Y": 0.37175983190536,
    "CMYK_C": 0.12274441868067,
    "CMYK_M": 0.10509433597326,
    "CMYK_Y": 0,
    "CMYK_K": 0.37175983190536
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R406015",
    "Farbtonhilfsbezeichnung": "R40 60 15",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "143",
    "Bcolor": "168",
    "Y": 28,
    "L": 59.9094772338867,
    "a": 4.00024318695068,
    "b": -14.3693933486938,
    "C": 14.915810585022,
    "h": 285.556488037109,
    "CMY_C": 0.45579880475998,
    "CMY_M": 0.43823432922363,
    "CMY_Y": 0.34038001298904,
    "CMYK_C": 0.17497770488262,
    "CMYK_M": 0.14834953844547,
    "CMYK_Y": 0,
    "CMYK_K": 0.34038001298904
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R407005",
    "Farbtonhilfsbezeichnung": "R40 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "170",
    "Bcolor": "178",
    "Y": 41,
    "L": 69.896354675293,
    "a": 1.34934067726135,
    "b": -4.97651290893555,
    "C": 5.15620040893555,
    "h": 285.170532226563,
    "CMY_C": 0.33694857358932,
    "CMY_M": 0.33144390583038,
    "CMY_Y": 0.30043971538544,
    "CMYK_C": 0.05218829587102,
    "CMYK_M": 0.04431954026222,
    "CMYK_Y": 0,
    "CMYK_K": 0.30043971538544
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R407010",
    "Farbtonhilfsbezeichnung": "R40 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "170",
    "Bcolor": "187",
    "Y": 41,
    "L": 69.8327331542969,
    "a": 2.57368230819702,
    "b": -9.94206714630127,
    "C": 10.2697877883911,
    "h": 284.513458251953,
    "CMY_C": 0.34643393754959,
    "CMY_M": 0.3334077000618,
    "CMY_Y": 0.26618736982346,
    "CMYK_C": 0.10935566574335,
    "CMYK_M": 0.09160421788692,
    "CMYK_Y": 0,
    "CMYK_K": 0.26618736982346
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R408005",
    "Farbtonhilfsbezeichnung": "R40 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "197",
    "Bcolor": "205",
    "Y": 57,
    "L": 79.578857421875,
    "a": 1.38488411903381,
    "b": -5.07475566864014,
    "C": 5.26032781600952,
    "h": 285.26416015625,
    "CMY_C": 0.23362517356873,
    "CMY_M": 0.22796106338501,
    "CMY_Y": 0.19600492715836,
    "CMYK_C": 0.04679163917899,
    "CMYK_M": 0.03974668309093,
    "CMYK_Y": 0,
    "CMYK_K": 0.19600492715836
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R408010",
    "Farbtonhilfsbezeichnung": "R40 80 10",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "197",
    "Bcolor": "213",
    "Y": 57,
    "L": 79.6510467529297,
    "a": 2.50484418869019,
    "b": -9.30756568908691,
    "C": 9.63872528076172,
    "h": 285.062530517578,
    "CMY_C": 0.23973089456558,
    "CMY_M": 0.22850316762924,
    "CMY_Y": 0.1646254658699,
    "CMYK_C": 0.08990629762411,
    "CMYK_M": 0.07646594196558,
    "CMYK_Y": 0,
    "CMYK_K": 0.1646254658699
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R408505",
    "Farbtonhilfsbezeichnung": "R40 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "212",
    "Bcolor": "220",
    "Y": 66,
    "L": 85.0739288330078,
    "a": 1.31022214889526,
    "b": -4.73012018203735,
    "C": 4.90822982788086,
    "h": 285.482482910156,
    "CMY_C": 0.17308562994003,
    "CMY_M": 0.1679316163063,
    "CMY_Y": 0.13849753141403,
    "CMYK_C": 0.04014857858419,
    "CMYK_M": 0.03416598960757,
    "CMYK_Y": 0,
    "CMYK_K": 0.13849753141403
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "R409004",
    "Farbtonhilfsbezeichnung": "R40 90 04",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "224",
    "Bcolor": "231",
    "Y": 76,
    "L": 89.3277969360352,
    "a": 1.18347251415253,
    "b": -4.27086925506592,
    "C": 4.43180894851685,
    "h": 285.488250732422,
    "CMY_C": 0.12550300359726,
    "CMY_M": 0.12078696489334,
    "CMY_Y": 0.09490692615509,
    "CMYK_C": 0.03380434215069,
    "CMYK_M": 0.02859378792346,
    "CMYK_Y": 0,
    "CMYK_K": 0.09490692615509
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y015010",
    "Farbtonhilfsbezeichnung": "Y01 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "119",
    "Bcolor": "101",
    "Y": 18,
    "L": 49.186092376709,
    "a": -5.17843246459961,
    "b": 8.84773635864258,
    "C": 10.2517604827881,
    "h": 120.339721679688,
    "CMY_C": 0.55252158641815,
    "CMY_M": 0.53285109996796,
    "CMY_Y": 0.60405671596527,
    "CMYK_C": 0.04210752993822,
    "CMYK_M": 0,
    "CMYK_Y": 0.15242595970631,
    "CMYK_K": 0.53285109996796
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y015030",
    "Farbtonhilfsbezeichnung": "Y01 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "125",
    "Bcolor": "74",
    "Y": 18,
    "L": 50.0648498535156,
    "a": -15.1236686706543,
    "b": 25.7863063812256,
    "C": 29.8941287994385,
    "h": 120.391616821289,
    "CMY_C": 0.5735924243927,
    "CMY_M": 0.50850248336792,
    "CMY_Y": 0.71164512634277,
    "CMYK_C": 0.13243187963963,
    "CMYK_M": 0,
    "CMYK_Y": 0.41331365704536,
    "CMYK_K": 0.50850248336792
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y015540",
    "Farbtonhilfsbezeichnung": "Y01 55 40",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "141",
    "Bcolor": "70",
    "Y": 23,
    "L": 55.4938163757324,
    "a": -19.7302436828613,
    "b": 34.7561264038086,
    "C": 39.9658699035645,
    "h": 119.582572937012,
    "CMY_C": 0.534423828125,
    "CMY_M": 0.44675892591476,
    "CMY_Y": 0.7267609834671,
    "CMYK_C": 0.15845696628094,
    "CMYK_M": 0,
    "CMYK_Y": 0.50611221790314,
    "CMYK_K": 0.44675892591476
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y016005",
    "Farbtonhilfsbezeichnung": "Y01 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "145",
    "Bcolor": "134",
    "Y": 28,
    "L": 59.5549087524414,
    "a": -2.67958354949951,
    "b": 4.5655312538147,
    "C": 5.29379272460938,
    "h": 120.40934753418,
    "CMY_C": 0.44303548336029,
    "CMY_M": 0.43264997005463,
    "CMY_Y": 0.47343343496323,
    "CMYK_C": 0.01830530166626,
    "CMYK_M": 0,
    "CMYK_Y": 0.0718841329217,
    "CMYK_K": 0.43264997005463
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y016020",
    "Farbtonhilfsbezeichnung": "Y01 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "147",
    "Bcolor": "111",
    "Y": 28,
    "L": 59.3381767272949,
    "a": -10.0726718902588,
    "b": 17.2678661346436,
    "C": 19.99094581604,
    "h": 120.255821228027,
    "CMY_C": 0.46376991271973,
    "CMY_M": 0.42253893613815,
    "CMY_Y": 0.56360685825348,
    "CMYK_C": 0.07140044122934,
    "CMYK_M": 0,
    "CMYK_Y": 0.24428993463516,
    "CMYK_K": 0.42253893613815
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y016040",
    "Farbtonhilfsbezeichnung": "Y01 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "153",
    "Bcolor": "80",
    "Y": 28,
    "L": 59.813175201416,
    "a": -20.1269989013672,
    "b": 34.9219741821289,
    "C": 40.306827545166,
    "h": 119.956642150879,
    "CMY_C": 0.49267846345901,
    "CMY_M": 0.40164583921432,
    "CMY_Y": 0.68698823451996,
    "CMYK_C": 0.15213836729527,
    "CMYK_M": 0,
    "CMYK_Y": 0.47687876224518,
    "CMYK_K": 0.40164583921432
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y017010",
    "Farbtonhilfsbezeichnung": "Y01 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "172",
    "Bcolor": "153",
    "Y": 41,
    "L": 69.5967330932617,
    "a": -5.11276769638062,
    "b": 8.56397724151611,
    "C": 9.97407150268555,
    "h": 120.837562561035,
    "CMY_C": 0.34499728679657,
    "CMY_M": 0.32392501831055,
    "CMY_Y": 0.39937621355057,
    "CMYK_C": 0.0311685372144,
    "CMYK_M": 0,
    "CMYK_Y": 0.11160181462765,
    "CMYK_K": 0.32392501831055
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y017030",
    "Farbtonhilfsbezeichnung": "Y01 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "177",
    "Bcolor": "121",
    "Y": 41,
    "L": 69.5313034057617,
    "a": -15.260968208313,
    "b": 26.0933589935303,
    "C": 30.2284717559814,
    "h": 120.321662902832,
    "CMY_C": 0.37448489665985,
    "CMY_M": 0.30740296840668,
    "CMY_Y": 0.52644634246826,
    "CMYK_C": 0.09685564041138,
    "CMYK_M": 0,
    "CMYK_Y": 0.31626379489899,
    "CMYK_K": 0.30740296840668
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y017040",
    "Farbtonhilfsbezeichnung": "Y01 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "181",
    "Bcolor": "108",
    "Y": 41,
    "L": 70.47314453125,
    "a": -19.6924648284912,
    "b": 34.2474555969238,
    "C": 39.5054588317871,
    "h": 119.899124145508,
    "CMY_C": 0.37915372848511,
    "CMY_M": 0.29015630483627,
    "CMY_Y": 0.57797783613205,
    "CMYK_C": 0.12537609040737,
    "CMYK_M": 0,
    "CMYK_Y": 0.40547171235085,
    "CMYK_K": 0.29015630483627
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y017050",
    "Farbtonhilfsbezeichnung": "Y01 70 50",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "181",
    "Bcolor": "87",
    "Y": 41,
    "L": 69.6244354248047,
    "a": -25.5248279571533,
    "b": 43.5968322753906,
    "C": 50.5193099975586,
    "h": 120.347877502441,
    "CMY_C": 0.41343194246292,
    "CMY_M": 0.28976804018021,
    "CMY_Y": 0.65986204147339,
    "CMYK_C": 0.17411762475967,
    "CMYK_M": 0,
    "CMYK_Y": 0.52108889818192,
    "CMYK_K": 0.28976804018021
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y017520",
    "Farbtonhilfsbezeichnung": "Y01 75 20",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "189",
    "Bcolor": "150",
    "Y": 48,
    "L": 74.7419509887695,
    "a": -10.3643712997437,
    "b": 17.505895614624,
    "C": 20.3439559936523,
    "h": 120.627670288086,
    "CMY_C": 0.30446416139603,
    "CMY_M": 0.25994837284088,
    "CMY_Y": 0.41089296340942,
    "CMYK_C": 0.06015227362514,
    "CMYK_M": 0,
    "CMYK_Y": 0.20396494865417,
    "CMYK_K": 0.25994837284088
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018005",
    "Farbtonhilfsbezeichnung": "Y01 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 57,
    "L": 79.6422119140625,
    "a": -2.49841666221619,
    "b": 4.21667051315308,
    "C": 4.90126466751099,
    "h": 120.647132873535,
    "CMY_C": 0.23142468929291,
    "CMY_M": 0.22096836566925,
    "CMY_Y": 0.26272839307785,
    "CMYK_C": 0.01342220697552,
    "CMYK_M": 0,
    "CMYK_Y": 0.05360504612327,
    "CMYK_K": 0.22096836566925
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018010",
    "Farbtonhilfsbezeichnung": "Y01 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "200",
    "Bcolor": "181",
    "Y": 57,
    "L": 79.8641891479492,
    "a": -4.70332288742065,
    "b": 8.29710483551025,
    "C": 9.53746223449707,
    "h": 119.547294616699,
    "CMY_C": 0.23310625553131,
    "CMY_M": 0.21465772390366,
    "CMY_Y": 0.29013222455978,
    "CMYK_C": 0.02349107153714,
    "CMYK_M": 0,
    "CMYK_Y": 0.09610395878553,
    "CMYK_K": 0.21465772390366
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018015",
    "Farbtonhilfsbezeichnung": "Y01 80 15",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "201",
    "Bcolor": "172",
    "Y": 57,
    "L": 79.7716217041016,
    "a": -7.7135648727417,
    "b": 13.0427217483521,
    "C": 15.1529426574707,
    "h": 120.600387573242,
    "CMY_C": 0.24290698766708,
    "CMY_M": 0.21019041538239,
    "CMY_Y": 0.32591879367828,
    "CMYK_C": 0.04142336547375,
    "CMYK_M": 0,
    "CMYK_Y": 0.14652693271637,
    "CMYK_K": 0.21019041538239
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018040",
    "Farbtonhilfsbezeichnung": "Y01 80 40",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "207",
    "Bcolor": "131",
    "Y": 57,
    "L": 79.7089920043945,
    "a": -20.5583534240723,
    "b": 34.4272956848145,
    "C": 40.0984344482422,
    "h": 120.843658447266,
    "CMY_C": 0.28611123561859,
    "CMY_M": 0.18857419490814,
    "CMY_Y": 0.48666554689407,
    "CMYK_C": 0.1202045083046,
    "CMYK_M": 0,
    "CMYK_Y": 0.36736735701561,
    "CMYK_K": 0.18857419490814
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018510",
    "Farbtonhilfsbezeichnung": "Y01 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "214",
    "Bcolor": "194",
    "Y": 66,
    "L": 84.7757797241211,
    "a": -4.96057224273682,
    "b": 8.54817295074463,
    "C": 9.88324546813965,
    "h": 120.126937866211,
    "CMY_C": 0.18080699443817,
    "CMY_M": 0.16041845083237,
    "CMY_Y": 0.23956644535065,
    "CMYK_C": 0.02428417280316,
    "CMYK_M": 0,
    "CMYK_Y": 0.0942707657814,
    "CMYK_K": 0.16041845083237
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y018530",
    "Farbtonhilfsbezeichnung": "Y01 85 30",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "219",
    "Bcolor": "161",
    "Y": 66,
    "L": 84.7530136108398,
    "a": -15.3691749572754,
    "b": 25.9499034881592,
    "C": 30.159725189209,
    "h": 120.636703491211,
    "CMY_C": 0.21185368299484,
    "CMY_M": 0.14201909303665,
    "CMY_Y": 0.36992621421814,
    "CMYK_C": 0.08139410614967,
    "CMYK_M": 0,
    "CMYK_Y": 0.26563191413879,
    "CMYK_K": 0.14201909303665
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y019005",
    "Farbtonhilfsbezeichnung": "Y01 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "227",
    "Bcolor": "215",
    "Y": 76,
    "L": 89.5819244384766,
    "a": -2.49587988853455,
    "b": 4.22687244415283,
    "C": 4.90875434875488,
    "h": 120.560966491699,
    "CMY_C": 0.12242770195007,
    "CMY_M": 0.11174148321152,
    "CMY_Y": 0.15530300140381,
    "CMYK_C": 0.01203052792698,
    "CMYK_M": 0,
    "CMYK_Y": 0.04904148727655,
    "CMYK_K": 0.11174148321152
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y019020",
    "Farbtonhilfsbezeichnung": "Y01 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "231",
    "Bcolor": "192",
    "Y": 76,
    "L": 90.0271377563477,
    "a": -10.0579042434692,
    "b": 17.1900272369385,
    "C": 19.9162864685059,
    "h": 120.33194732666,
    "CMY_C": 0.13654112815857,
    "CMY_M": 0.09291410446167,
    "CMY_Y": 0.24779081344604,
    "CMYK_C": 0.04809580370784,
    "CMYK_M": 0,
    "CMYK_Y": 0.17074094712734,
    "CMYK_K": 0.09291410446167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y019115",
    "Farbtonhilfsbezeichnung": "Y01 91 15",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "233",
    "Bcolor": "202",
    "Y": 78,
    "L": 90.8524551391602,
    "a": -7.71166563034058,
    "b": 12.9990978240967,
    "C": 15.1144409179688,
    "h": 120.678375244141,
    "CMY_C": 0.12148177623749,
    "CMY_M": 0.08791887760162,
    "CMY_Y": 0.2072839140892,
    "CMYK_C": 0.03679814934731,
    "CMYK_M": 0,
    "CMYK_Y": 0.13087107241154,
    "CMYK_K": 0.08791887760162
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y019310",
    "Farbtonhilfsbezeichnung": "Y01 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "237",
    "Bcolor": "216",
    "Y": 83,
    "L": 92.7016983032227,
    "a": -4.98491954803467,
    "b": 8.42318153381348,
    "C": 9.78771686553955,
    "h": 120.617454528809,
    "CMY_C": 0.09368997812271,
    "CMY_M": 0.0722571015358,
    "CMY_Y": 0.15262722969055,
    "CMYK_C": 0.02310217171907,
    "CMYK_M": 0,
    "CMYK_Y": 0.08662974089384,
    "CMYK_K": 0.0722571015358
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y026049",
    "Farbtonhilfsbezeichnung": "Y02 60 49",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "153",
    "Bcolor": "61",
    "Y": 28,
    "L": 59.7856826782227,
    "a": -21.0947360992432,
    "b": 44.1965789794922,
    "C": 48.9727020263672,
    "h": 115.514839172363,
    "CMY_C": 0.48375421762466,
    "CMY_M": 0.40131866931915,
    "CMY_Y": 0.7603645324707,
    "CMYK_C": 0.13769520819187,
    "CMYK_M": 0,
    "CMYK_Y": 0.59972786903381,
    "CMYK_K": 0.40131866931915
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y027040",
    "Farbtonhilfsbezeichnung": "Y02 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "178",
    "Bcolor": "102",
    "Y": 41,
    "L": 69.7483673095703,
    "a": -17.2333908081055,
    "b": 36.1651039123535,
    "C": 40.0612602233887,
    "h": 115.478729248047,
    "CMY_C": 0.36466884613037,
    "CMY_M": 0.30287551879883,
    "CMY_Y": 0.59903013706207,
    "CMYK_C": 0.08864030241966,
    "CMYK_M": 0,
    "CMYK_Y": 0.42482316493988,
    "CMYK_K": 0.30287551879883
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y028030",
    "Farbtonhilfsbezeichnung": "Y02 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "204",
    "Bcolor": "146",
    "Y": 57,
    "L": 79.9510726928711,
    "a": -12.9333372116089,
    "b": 27.1139869689941,
    "C": 30.0406303405762,
    "h": 115.501083374023,
    "CMY_C": 0.24280035495758,
    "CMY_M": 0.20007163286209,
    "CMY_Y": 0.42794066667557,
    "CMYK_C": 0.05341568589211,
    "CMYK_M": 0,
    "CMYK_Y": 0.28486180305481,
    "CMYK_K": 0.20007163286209
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y028520",
    "Farbtonhilfsbezeichnung": "Y02 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "216",
    "Bcolor": "177",
    "Y": 66,
    "L": 84.9862747192383,
    "a": -8.54546165466309,
    "b": 18.0225601196289,
    "C": 19.9458656311035,
    "h": 115.368141174316,
    "CMY_C": 0.17813646793365,
    "CMY_M": 0.15237677097321,
    "CMY_Y": 0.30747216939926,
    "CMYK_C": 0.03039050288498,
    "CMYK_M": 0,
    "CMYK_Y": 0.18297681212425,
    "CMYK_K": 0.15237677097321
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y029010",
    "Farbtonhilfsbezeichnung": "Y02 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "228",
    "Bcolor": "208",
    "Y": 76,
    "L": 89.9723968505859,
    "a": -4.34547281265259,
    "b": 8.95019054412842,
    "C": 9.9493236541748,
    "h": 115.897384643555,
    "CMY_C": 0.11738538742065,
    "CMY_M": 0.10437107086182,
    "CMY_Y": 0.18625342845917,
    "CMYK_C": 0.01453092508018,
    "CMYK_M": 0,
    "CMYK_Y": 0.09142442047596,
    "CMYK_K": 0.10437107086182
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y029305",
    "Farbtonhilfsbezeichnung": "Y02 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "224",
    "Y": 83,
    "L": 92.8233947753906,
    "a": -2.17946648597717,
    "b": 4.48868989944458,
    "C": 4.98983097076416,
    "h": 115.898719787598,
    "CMY_C": 0.08294367790222,
    "CMY_M": 0.07636207342148,
    "CMY_Y": 0.12157094478607,
    "CMYK_C": 0.00712574087083,
    "CMYK_M": 0,
    "CMYK_Y": 0.04894652962685,
    "CMYK_K": 0.07636207342148
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y034005",
    "Farbtonhilfsbezeichnung": "Y03 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "94",
    "Bcolor": "85",
    "Y": 11,
    "L": 39.7999420166016,
    "a": -1.69801115989685,
    "b": 4.80421686172485,
    "C": 5.09546279907227,
    "h": 109.465538024902,
    "CMY_C": 0.63028210401535,
    "CMY_M": 0.62978321313858,
    "CMY_Y": 0.66583371162415,
    "CMYK_C": 0.00134756416082,
    "CMYK_M": 0,
    "CMYK_Y": 0.09737672656775,
    "CMYK_K": 0.62978321313858
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y035040",
    "Farbtonhilfsbezeichnung": "Y03 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "126",
    "Bcolor": "53",
    "Y": 18,
    "L": 50.9633483886719,
    "a": -13.3085861206055,
    "b": 37.795093536377,
    "C": 40.0697822570801,
    "h": 109.398422241211,
    "CMY_C": 0.53157806396484,
    "CMY_M": 0.50430917739868,
    "CMY_Y": 0.79100954532623,
    "CMYK_C": 0.05501188337803,
    "CMYK_M": 0,
    "CMYK_Y": 0.57838547229767,
    "CMYK_K": 0.50430917739868
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y036010",
    "Farbtonhilfsbezeichnung": "Y03 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "147",
    "Bcolor": "128",
    "Y": 28,
    "L": 60.5345458984375,
    "a": -3.34523820877075,
    "b": 9.51863288879395,
    "C": 10.0893507003784,
    "h": 109.363571166992,
    "CMY_C": 0.42367088794708,
    "CMY_M": 0.42235690355301,
    "CMY_Y": 0.49752134084702,
    "CMYK_C": 0.00227473396808,
    "CMYK_M": 0,
    "CMYK_Y": 0.13012263178825,
    "CMYK_K": 0.42235690355301
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y036020",
    "Farbtonhilfsbezeichnung": "Y03 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "145",
    "Bcolor": "108",
    "Y": 28,
    "L": 59.2240104675293,
    "a": -6.98684978485107,
    "b": 19.044412612915,
    "C": 20.2856044769287,
    "h": 110.146644592285,
    "CMY_C": 0.43885827064514,
    "CMY_M": 0.43020910024643,
    "CMY_Y": 0.5764993429184,
    "CMYK_C": 0.01517955120653,
    "CMYK_M": 0,
    "CMYK_Y": 0.25674372911453,
    "CMYK_K": 0.43020910024643
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y037010",
    "Farbtonhilfsbezeichnung": "Y03 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "172",
    "Bcolor": "151",
    "Y": 41,
    "L": 69.6155624389648,
    "a": -3.61312079429626,
    "b": 9.662278175354,
    "C": 10.3157291412354,
    "h": 110.502822875977,
    "CMY_C": 0.33051729202271,
    "CMY_M": 0.32722467184067,
    "CMY_Y": 0.40669029951096,
    "CMYK_C": 0.0048940856941,
    "CMYK_M": 0,
    "CMYK_Y": 0.11811614781618,
    "CMYK_K": 0.32722467184067
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y037020",
    "Farbtonhilfsbezeichnung": "Y03 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "175",
    "Bcolor": "137",
    "Y": 41,
    "L": 70.6016387939453,
    "a": -6.72051477432251,
    "b": 18.8057804107666,
    "C": 19.9705448150635,
    "h": 109.665069580078,
    "CMY_C": 0.31831079721451,
    "CMY_M": 0.31210941076279,
    "CMY_Y": 0.46185094118118,
    "CMYK_C": 0.00901507679373,
    "CMYK_M": 0,
    "CMYK_Y": 0.21768219769001,
    "CMYK_K": 0.31210941076279
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y037030",
    "Farbtonhilfsbezeichnung": "Y03 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "175",
    "Bcolor": "118",
    "Y": 41,
    "L": 69.8377685546875,
    "a": -10.6025810241699,
    "b": 28.3659553527832,
    "C": 30.2827033996582,
    "h": 110.494651794434,
    "CMY_C": 0.33213365077972,
    "CMY_M": 0.31388992071152,
    "CMY_Y": 0.53902423381805,
    "CMYK_C": 0.02659009210765,
    "CMYK_M": 0,
    "CMYK_Y": 0.32813146710396,
    "CMYK_K": 0.31388992071152
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y037050",
    "Farbtonhilfsbezeichnung": "Y03 70 50",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "178",
    "Bcolor": "81",
    "Y": 41,
    "L": 69.9667663574219,
    "a": -17.3422927856445,
    "b": 47.280590057373,
    "C": 50.3607902526855,
    "h": 110.142799377441,
    "CMY_C": 0.34343403577805,
    "CMY_M": 0.30182361602783,
    "CMY_Y": 0.68405038118362,
    "CMYK_C": 0.05959872156382,
    "CMYK_M": 0,
    "CMYK_Y": 0.54746448993683,
    "CMYK_K": 0.30182361602783
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y037545",
    "Farbtonhilfsbezeichnung": "Y03 75 45",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "190",
    "Bcolor": "100",
    "Y": 48,
    "L": 74.6077880859375,
    "a": -16.0197868347168,
    "b": 43.3884620666504,
    "C": 46.2514038085938,
    "h": 110.265037536621,
    "CMY_C": 0.28977489471436,
    "CMY_M": 0.25430124998093,
    "CMY_Y": 0.60610145330429,
    "CMYK_C": 0.04757101088762,
    "CMYK_M": 0,
    "CMYK_Y": 0.47177255153656,
    "CMYK_K": 0.25430124998093
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y038020",
    "Farbtonhilfsbezeichnung": "Y03 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "200",
    "Bcolor": "160",
    "Y": 57,
    "L": 79.5951309204102,
    "a": -7.03621816635132,
    "b": 18.9790668487549,
    "C": 20.2413768768311,
    "h": 110.34154510498,
    "CMY_C": 0.22323530912399,
    "CMY_M": 0.21491062641144,
    "CMY_Y": 0.37082171440125,
    "CMYK_C": 0.01060348376632,
    "CMYK_M": 0,
    "CMYK_Y": 0.198590233922,
    "CMYK_K": 0.21491062641144
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y038040",
    "Farbtonhilfsbezeichnung": "Y03 80 40",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "203",
    "Bcolor": "124",
    "Y": 57,
    "L": 79.5462265014648,
    "a": -13.8783950805664,
    "b": 38.0344352722168,
    "C": 40.4873809814453,
    "h": 110.046531677246,
    "CMY_C": 0.23007440567017,
    "CMY_M": 0.20441430807114,
    "CMY_Y": 0.51436018943787,
    "CMYK_C": 0.03225309029222,
    "CMYK_M": 0,
    "CMYK_Y": 0.3895820081234,
    "CMYK_K": 0.20441430807114
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y038050",
    "Farbtonhilfsbezeichnung": "Y03 80 50",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "207",
    "Bcolor": "108",
    "Y": 57,
    "L": 80.470344543457,
    "a": -17.0125732421875,
    "b": 47.296459197998,
    "C": 50.2631340026855,
    "h": 109.783699035645,
    "CMY_C": 0.22512978315353,
    "CMY_M": 0.18926805257797,
    "CMY_Y": 0.57832956314087,
    "CMYK_C": 0.04423376917839,
    "CMYK_M": 0,
    "CMYK_Y": 0.47988921403885,
    "CMYK_K": 0.18926805257797
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y038510",
    "Farbtonhilfsbezeichnung": "Y03 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "213",
    "Bcolor": "192",
    "Y": 66,
    "L": 84.6056213378906,
    "a": -3.45619511604309,
    "b": 9.37553787231445,
    "C": 9.99229717254639,
    "h": 110.235885620117,
    "CMY_C": 0.16852098703384,
    "CMY_M": 0.16590583324432,
    "CMY_Y": 0.24722272157669,
    "CMYK_C": 0.00313532189466,
    "CMYK_M": 0,
    "CMYK_Y": 0.09749125689268,
    "CMYK_K": 0.16590583324432
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y038530",
    "Farbtonhilfsbezeichnung": "Y03 85 30",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "217",
    "Bcolor": "157",
    "Y": 66,
    "L": 84.947265625,
    "a": -10.3791131973267,
    "b": 28.3792057037354,
    "C": 30.2176322937012,
    "h": 110.08895111084,
    "CMY_C": 0.16570365428925,
    "CMY_M": 0.15095567703247,
    "CMY_Y": 0.38515591621399,
    "CMYK_C": 0.01737009175122,
    "CMYK_M": 0,
    "CMYK_Y": 0.27583983540535,
    "CMYK_K": 0.15095567703247
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y039005",
    "Farbtonhilfsbezeichnung": "Y03 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "227",
    "Bcolor": "215",
    "Y": 76,
    "L": 89.7684936523438,
    "a": -1.7532753944397,
    "b": 4.69258117675781,
    "C": 5.00942039489746,
    "h": 110.48705291748,
    "CMY_C": 0.11298537254333,
    "CMY_M": 0.1115226149559,
    "CMY_Y": 0.15659493207932,
    "CMYK_C": 0.00164636445697,
    "CMYK_M": 0,
    "CMYK_Y": 0.05072984099388,
    "CMYK_K": 0.1115226149559
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y039020",
    "Farbtonhilfsbezeichnung": "Y03 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "229",
    "Bcolor": "188",
    "Y": 76,
    "L": 89.7812271118164,
    "a": -6.84699106216431,
    "b": 18.7179660797119,
    "C": 19.9309692382813,
    "h": 110.092407226563,
    "CMY_C": 0.11007034778595,
    "CMY_M": 0.10316640138626,
    "CMY_Y": 0.26129764318466,
    "CMYK_C": 0.00769813545048,
    "CMYK_M": 0,
    "CMYK_Y": 0.1763217151165,
    "CMYK_K": 0.10316640138626
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y039302",
    "Farbtonhilfsbezeichnung": "Y03 93 02 Marmorweiss",
    "Farbtonklasse": "00",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 83,
    "L": 92.9213638305664,
    "a": -0.69875210523605,
    "b": 1.57929146289825,
    "C": 1.72696733474731,
    "h": 113.866828918457,
    "CMY_C": 0.07988482713699,
    "CMY_M": 0.0779475569725,
    "CMY_Y": 0.09862929582596,
    "CMYK_C": 0.00210104114376,
    "CMYK_M": 0,
    "CMYK_Y": 0.02243011072278,
    "CMYK_K": 0.0779475569725
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y039310",
    "Farbtonhilfsbezeichnung": "Y03 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "236",
    "Bcolor": "214",
    "Y": 83,
    "L": 92.7655868530273,
    "a": -3.55055904388428,
    "b": 9.71041488647461,
    "C": 10.3391790390015,
    "h": 110.084655761719,
    "CMY_C": 0.0776172876358,
    "CMY_M": 0.0751918554306,
    "CMY_Y": 0.1613095998764,
    "CMYK_C": 0.00262263277546,
    "CMYK_M": 0,
    "CMYK_Y": 0.09311957657337,
    "CMYK_K": 0.0751918554306
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y047060",
    "Farbtonhilfsbezeichnung": "Y04 70 60",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "177",
    "Bcolor": "57",
    "Y": 41,
    "L": 69.9600830078125,
    "a": -16.001932144165,
    "b": 57.8023719787598,
    "C": 59.9764633178711,
    "h": 105.474143981934,
    "CMY_C": 0.31985992193222,
    "CMY_M": 0.3056492805481,
    "CMY_Y": 0.77746433019638,
    "CMYK_C": 0.02046608552337,
    "CMYK_M": 0,
    "CMYK_Y": 0.67950540781021,
    "CMYK_K": 0.3056492805481
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y048050",
    "Farbtonhilfsbezeichnung": "Y04 80 50",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "203",
    "Bcolor": "104",
    "Y": 57,
    "L": 79.7314834594727,
    "a": -13.1273193359375,
    "b": 48.2603149414063,
    "C": 50.013843536377,
    "h": 105.216888427734,
    "CMY_C": 0.20419651269913,
    "CMY_M": 0.20547062158585,
    "CMY_Y": 0.59255075454712,
    "CMYK_C": 0,
    "CMYK_M": 0.00160103454255,
    "CMYK_Y": 0.48800268769264,
    "CMYK_K": 0.20419651269913
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y048540",
    "Farbtonhilfsbezeichnung": "Y04 85 40",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "216",
    "Bcolor": "137",
    "Y": 66,
    "L": 84.9249649047852,
    "a": -10.4919176101685,
    "b": 38.7713584899902,
    "C": 40.1658897399902,
    "h": 105.142150878906,
    "CMY_C": 0.14418375492096,
    "CMY_M": 0.15282797813416,
    "CMY_Y": 0.46425253152847,
    "CMYK_C": 0,
    "CMYK_M": 0.0101005602628,
    "CMYK_Y": 0.37399241328239,
    "CMYK_K": 0.14418375492096
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y049030",
    "Farbtonhilfsbezeichnung": "Y04 90 30",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "229",
    "Bcolor": "169",
    "Y": 76,
    "L": 89.912353515625,
    "a": -7.81315660476685,
    "b": 29.065113067627,
    "C": 30.0969467163086,
    "h": 105.046310424805,
    "CMY_C": 0.08946025371552,
    "CMY_M": 0.10173374414444,
    "CMY_Y": 0.33775383234024,
    "CMYK_C": 0,
    "CMYK_M": 0.01347935758531,
    "CMYK_Y": 0.27268835902214,
    "CMYK_K": 0.08946025371552
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y049320",
    "Farbtonhilfsbezeichnung": "Y04 93 20",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "196",
    "Y": 83,
    "L": 93.0644683837891,
    "a": -5.29305028915405,
    "b": 19.324275970459,
    "C": 20.0360679626465,
    "h": 105.318000793457,
    "CMY_C": 0.05969893932343,
    "CMY_M": 0.07014691829681,
    "CMY_Y": 0.23027682304382,
    "CMYK_C": 0,
    "CMYK_M": 0.01111131254584,
    "CMYK_Y": 0.1814077347517,
    "CMYK_K": 0.05969893932343
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y049402",
    "Farbtonhilfsbezeichnung": "Y04 94 02 Sth04",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 85,
    "L": 94.1434326171875,
    "a": -0.689317882061,
    "b": 2.36566948890686,
    "C": 2.46405172348022,
    "h": 106.245269775391,
    "CMY_C": 0.06343650817871,
    "CMY_M": 0.06448429822922,
    "CMY_Y": 0.09092915058136,
    "CMYK_C": 0,
    "CMYK_M": 0.00111876032315,
    "CMYK_Y": 0.02935480885208,
    "CMYK_K": 0.06343650817871
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y049510",
    "Farbtonhilfsbezeichnung": "Y04 95 10",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "242",
    "Bcolor": "220",
    "Y": 88,
    "L": 94.9685516357422,
    "a": -2.59449911117554,
    "b": 9.49885082244873,
    "C": 9.84680652618408,
    "h": 105.277030944824,
    "CMY_C": 0.04603278636932,
    "CMY_M": 0.05262964963913,
    "CMY_Y": 0.13540989160538,
    "CMYK_C": 0,
    "CMYK_M": 0.00691518886015,
    "CMYK_Y": 0.09368991106749,
    "CMYK_K": 0.04603278636932
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y055020",
    "Farbtonhilfsbezeichnung": "Y05 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "122",
    "Bcolor": "86",
    "Y": 18,
    "L": 50.8040885925293,
    "a": -3.26327586174011,
    "b": 19.8616561889648,
    "C": 20.1279487609863,
    "h": 99.3303527832031,
    "CMY_C": 0.49832904338837,
    "CMY_M": 0.52280104160309,
    "CMY_Y": 0.66186201572418,
    "CMYK_C": 0,
    "CMYK_M": 0.04878097400069,
    "CMYK_Y": 0.32597655057907,
    "CMYK_K": 0.49832904338837
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y056020",
    "Farbtonhilfsbezeichnung": "Y05 60 20",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "145",
    "Bcolor": "108",
    "Y": 28,
    "L": 59.9176712036133,
    "a": -3.67932558059692,
    "b": 20.2108917236328,
    "C": 20.5430660247803,
    "h": 100.317512512207,
    "CMY_C": 0.40654921531677,
    "CMY_M": 0.43017733097076,
    "CMY_Y": 0.57727175951004,
    "CMYK_C": 0,
    "CMYK_M": 0.03981478512287,
    "CMYK_Y": 0.28767767548561,
    "CMYK_K": 0.40654921531677
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y056050",
    "Farbtonhilfsbezeichnung": "Y05 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "149",
    "Bcolor": "51",
    "Y": 28,
    "L": 60.7758903503418,
    "a": -8.47194671630859,
    "b": 50.4284439086914,
    "C": 51.1351318359375,
    "h": 99.5365982055664,
    "CMY_C": 0.38061344623566,
    "CMY_M": 0.4157087802887,
    "CMY_Y": 0.80024480819702,
    "CMYK_C": 0,
    "CMYK_M": 0.0566614381969,
    "CMYK_Y": 0.67749512195587,
    "CMYK_K": 0.38061344623566
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y057010",
    "Farbtonhilfsbezeichnung": "Y05 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "171",
    "Bcolor": "152",
    "Y": 41,
    "L": 69.7881851196289,
    "a": -1.77288520336151,
    "b": 9.77793502807617,
    "C": 9.9373607635498,
    "h": 100.276931762695,
    "CMY_C": 0.31499010324478,
    "CMY_M": 0.32947170734406,
    "CMY_Y": 0.40545928478241,
    "CMYK_C": 0,
    "CMYK_M": 0.0211407225579,
    "CMYK_Y": 0.13206988573074,
    "CMYK_K": 0.31499010324478
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y057020",
    "Farbtonhilfsbezeichnung": "Y05 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "173",
    "Bcolor": "135",
    "Y": 41,
    "L": 70.3296737670898,
    "a": -3.37367463111877,
    "b": 19.509449005127,
    "C": 19.7989978790283,
    "h": 99.8108596801758,
    "CMY_C": 0.29579091072083,
    "CMY_M": 0.32236588001251,
    "CMY_Y": 0.46904730796814,
    "CMYK_C": 0,
    "CMYK_M": 0.03773732855916,
    "CMYK_Y": 0.24602976441383,
    "CMYK_K": 0.29579091072083
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y057030",
    "Farbtonhilfsbezeichnung": "Y05 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "172",
    "Bcolor": "115",
    "Y": 41,
    "L": 69.6572952270508,
    "a": -5.21543550491333,
    "b": 29.8012008666992,
    "C": 30.25412940979,
    "h": 99.9266662597656,
    "CMY_C": 0.29377126693726,
    "CMY_M": 0.32738709449768,
    "CMY_Y": 0.55019044876099,
    "CMYK_C": 0,
    "CMYK_M": 0.04759906604886,
    "CMYK_Y": 0.36308234930038,
    "CMYK_K": 0.29377126693726
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y057540",
    "Farbtonhilfsbezeichnung": "Y05 75 40",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "186",
    "Bcolor": "109",
    "Y": 48,
    "L": 74.8837203979492,
    "a": -7.20118713378906,
    "b": 39.6163673400879,
    "C": 40.2655410766602,
    "h": 100.302337646484,
    "CMY_C": 0.23198902606964,
    "CMY_M": 0.26914608478546,
    "CMY_Y": 0.57186537981033,
    "CMYK_C": 0,
    "CMYK_M": 0.04838089644909,
    "CMYK_Y": 0.44254100322723,
    "CMYK_K": 0.23198902606964
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058010",
    "Farbtonhilfsbezeichnung": "Y05 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "200",
    "Bcolor": "180",
    "Y": 57,
    "L": 80.5012893676758,
    "a": -1.66501414775848,
    "b": 9.78109741210938,
    "C": 9.92180156707764,
    "h": 99.6607208251953,
    "CMY_C": 0.19877469539642,
    "CMY_M": 0.21495616436005,
    "CMY_Y": 0.29366129636765,
    "CMYK_C": 0,
    "CMYK_M": 0.02019590325654,
    "CMYK_Y": 0.1184268668294,
    "CMYK_K": 0.19877469539642
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058020",
    "Farbtonhilfsbezeichnung": "Y05 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "199",
    "Bcolor": "159",
    "Y": 57,
    "L": 79.8457489013672,
    "a": -3.61065125465393,
    "b": 19.9618587493896,
    "C": 20.285774230957,
    "h": 100.252662658691,
    "CMY_C": 0.19294321537018,
    "CMY_M": 0.22000765800476,
    "CMY_Y": 0.37480050325394,
    "CMYK_C": 0,
    "CMYK_M": 0.03353474289179,
    "CMYK_Y": 0.22533394396305,
    "CMYK_K": 0.19294321537018
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058035",
    "Farbtonhilfsbezeichnung": "Y05 80 35",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "200",
    "Bcolor": "132",
    "Y": 57,
    "L": 79.8353500366211,
    "a": -6.32253885269165,
    "b": 34.6699066162109,
    "C": 35.2416915893555,
    "h": 100.335113525391,
    "CMY_C": 0.17985510826111,
    "CMY_M": 0.21690708398819,
    "CMY_Y": 0.48421257734299,
    "CMYK_C": 0,
    "CMYK_M": 0.04517735168338,
    "CMYK_Y": 0.37110206484795,
    "CMYK_K": 0.17985510826111
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058060",
    "Farbtonhilfsbezeichnung": "Y05 80 60",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "202",
    "Bcolor": "81",
    "Y": 57,
    "L": 80.1091766357422,
    "a": -10.5910387039185,
    "b": 59.260326385498,
    "C": 60.1993064880371,
    "h": 100.132949829102,
    "CMY_C": 0.16666322946548,
    "CMY_M": 0.20811545848846,
    "CMY_Y": 0.68145602941513,
    "CMYK_C": 0,
    "CMYK_M": 0.04974247142673,
    "CMYK_Y": 0.61774879693985,
    "CMYK_K": 0.16666322946548
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058510",
    "Farbtonhilfsbezeichnung": "Y05 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "212",
    "Bcolor": "192",
    "Y": 66,
    "L": 84.818229675293,
    "a": -1.79630279541016,
    "b": 9.86090850830078,
    "C": 10.0231838226318,
    "h": 100.324028015137,
    "CMY_C": 0.15211111307144,
    "CMY_M": 0.16750156879425,
    "CMY_Y": 0.24824386835098,
    "CMYK_C": 0,
    "CMYK_M": 0.01815150119364,
    "CMYK_Y": 0.11337895691395,
    "CMYK_K": 0.15211111307144
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058530",
    "Farbtonhilfsbezeichnung": "Y05 85 30",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "214",
    "Bcolor": "155",
    "Y": 66,
    "L": 85.0533218383789,
    "a": -5.24229431152344,
    "b": 29.6889801025391,
    "C": 30.1482543945313,
    "h": 100.013710021973,
    "CMY_C": 0.12410008907318,
    "CMY_M": 0.16142952442169,
    "CMY_Y": 0.39287358522415,
    "CMYK_C": 0,
    "CMYK_M": 0.04261837899685,
    "CMYK_Y": 0.30685412883759,
    "CMYK_K": 0.12410008907318
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058550",
    "Farbtonhilfsbezeichnung": "Y05 85 50",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "215",
    "Bcolor": "115",
    "Y": 66,
    "L": 84.9191131591797,
    "a": -9.08902645111084,
    "b": 49.4323539733887,
    "C": 50.2609977722168,
    "h": 100.418495178223,
    "CMY_C": 0.11529433727264,
    "CMY_M": 0.15761518478394,
    "CMY_Y": 0.54791468381882,
    "CMYK_C": 0,
    "CMYK_M": 0.04783607646823,
    "CMYK_Y": 0.48899918794632,
    "CMYK_K": 0.11529433727264
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y058745",
    "Farbtonhilfsbezeichnung": "Y05 87 45",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "220",
    "Bcolor": "131",
    "Y": 70,
    "L": 86.9822311401367,
    "a": -8.01752662658691,
    "b": 44.4048767089844,
    "C": 45.122875213623,
    "h": 100.234771728516,
    "CMY_C": 0.09269601106644,
    "CMY_M": 0.13651347160339,
    "CMY_Y": 0.48631471395493,
    "CMYK_C": 0,
    "CMYK_M": 0.04829413443804,
    "CMYK_Y": 0.43383333086967,
    "CMYK_K": 0.09269601106644
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059005",
    "Farbtonhilfsbezeichnung": "Y05 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "226",
    "Bcolor": "215",
    "Y": 76,
    "L": 89.8461456298828,
    "a": -0.8616828918457,
    "b": 5.04157257080078,
    "C": 5.11467981338501,
    "h": 99.6990203857422,
    "CMY_C": 0.1040341258049,
    "CMY_M": 0.11284500360489,
    "CMY_Y": 0.15819537639618,
    "CMYK_C": 0,
    "CMYK_M": 0.00983394309878,
    "CMYK_Y": 0.06045012548566,
    "CMYK_K": 0.1040341258049
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059010",
    "Farbtonhilfsbezeichnung": "Y05 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "228",
    "Bcolor": "207",
    "Y": 76,
    "L": 90.2911148071289,
    "a": -1.69570326805115,
    "b": 9.64930152893066,
    "C": 9.79716396331787,
    "h": 99.9670028686523,
    "CMY_C": 0.09115999937057,
    "CMY_M": 0.10714989900589,
    "CMY_Y": 0.1875666975975,
    "CMYK_C": 0,
    "CMYK_M": 0.01759374514222,
    "CMYK_Y": 0.1060766428709,
    "CMYK_K": 0.09115999937057
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059020",
    "Farbtonhilfsbezeichnung": "Y05 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "228",
    "Bcolor": "188",
    "Y": 76,
    "L": 90.1948013305664,
    "a": -3.48548865318298,
    "b": 19.7612762451172,
    "C": 20.0663070678711,
    "h": 100.0029296875,
    "CMY_C": 0.07730841636658,
    "CMY_M": 0.10649281740189,
    "CMY_Y": 0.26408469676971,
    "CMYK_C": 0,
    "CMYK_M": 0.03162963688374,
    "CMYK_Y": 0.20242547988892,
    "CMYK_K": 0.07730841636658
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059025",
    "Farbtonhilfsbezeichnung": "Y05 90 25",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "227",
    "Bcolor": "178",
    "Y": 76,
    "L": 89.9415588378906,
    "a": -4.42209959030151,
    "b": 24.6191501617432,
    "C": 25.013147354126,
    "h": 100.182899475098,
    "CMY_C": 0.07480674982071,
    "CMY_M": 0.10821396112442,
    "CMY_Y": 0.30331069231033,
    "CMYK_C": 0,
    "CMYK_M": 0.03610835969448,
    "CMYK_Y": 0.24697968363762,
    "CMYK_K": 0.07480674982071
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059040",
    "Farbtonhilfsbezeichnung": "Y05 90 40",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "229",
    "Bcolor": "149",
    "Y": 76,
    "L": 90.0593719482422,
    "a": -7.07086753845215,
    "b": 39.5311851501465,
    "C": 40.1585845947266,
    "h": 100.141136169434,
    "CMY_C": 0.05985409021378,
    "CMY_M": 0.10372859239578,
    "CMY_Y": 0.41611975431442,
    "CMYK_C": 0,
    "CMYK_M": 0.04666775837541,
    "CMYK_Y": 0.37894719839096,
    "CMYK_K": 0.05985409021378
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059120",
    "Farbtonhilfsbezeichnung": "Y05 91 20",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "190",
    "Y": 78,
    "L": 91.0670471191406,
    "a": -3.53396773338318,
    "b": 19.5783309936523,
    "C": 19.8947219848633,
    "h": 100.231948852539,
    "CMY_C": 0.06831616163254,
    "CMY_M": 0.09661960601807,
    "CMY_Y": 0.2533768415451,
    "CMYK_C": 0,
    "CMYK_M": 0.03037880733609,
    "CMYK_Y": 0.19863034784794,
    "CMYK_K": 0.06831616163254
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059135",
    "Farbtonhilfsbezeichnung": "Y05 91 35",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "231",
    "Bcolor": "161",
    "Y": 78,
    "L": 91.0671615600586,
    "a": -6.10400390625,
    "b": 34.6091270446777,
    "C": 35.1432876586914,
    "h": 100.002380371094,
    "CMY_C": 0.05145347118378,
    "CMY_M": 0.09381544589996,
    "CMY_Y": 0.36743921041489,
    "CMYK_C": 0,
    "CMYK_M": 0.0446598790586,
    "CMYK_Y": 0.33312624692917,
    "CMYK_K": 0.05145347118378
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059310",
    "Farbtonhilfsbezeichnung": "Y05 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "214",
    "Y": 83,
    "L": 92.876335144043,
    "a": -1.79953122138977,
    "b": 9.89218902587891,
    "C": 10.054536819458,
    "h": 100.310180664063,
    "CMY_C": 0.06222605705261,
    "CMY_M": 0.07810020446777,
    "CMY_Y": 0.16118562221527,
    "CMYK_C": 0,
    "CMYK_M": 0.01692747697234,
    "CMYK_Y": 0.10552603751421,
    "CMYK_K": 0.06222605705261
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059330",
    "Farbtonhilfsbezeichnung": "Y05 93 30",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "236",
    "Bcolor": "176",
    "Y": 83,
    "L": 92.9605560302734,
    "a": -5.2772011756897,
    "b": 29.5842628479004,
    "C": 30.0512466430664,
    "h": 100.113967895508,
    "CMY_C": 0.03495919704437,
    "CMY_M": 0.0735712647438,
    "CMY_Y": 0.30890518426895,
    "CMYK_C": 0,
    "CMYK_M": 0.04001081362367,
    "CMYK_Y": 0.28386986255646,
    "CMYK_K": 0.03495919704437
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059405",
    "Farbtonhilfsbezeichnung": "Y05 94 05 Sth01",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "236",
    "Bcolor": "226",
    "Y": 85,
    "L": 93.4733505249023,
    "a": -0.64915347099304,
    "b": 4.46259450912476,
    "C": 4.50956201553345,
    "h": 98.2765045166016,
    "CMY_C": 0.06367230415344,
    "CMY_M": 0.07268464565277,
    "CMY_Y": 0.11397933959961,
    "CMYK_C": 0,
    "CMYK_M": 0.0096252001822,
    "CMYK_Y": 0.05372802168131,
    "CMYK_K": 0.06367230415344
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059503",
    "Farbtonhilfsbezeichnung": "Y05 95 03 Kaolin",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "242",
    "Bcolor": "234",
    "Y": 88,
    "L": 95.4327239990234,
    "a": -0.54100787639618,
    "b": 3.1132025718689,
    "C": 3.15986061096191,
    "h": 99.8583297729492,
    "CMY_C": 0.04523646831512,
    "CMY_M": 0.0505462884903,
    "CMY_Y": 0.08216577768326,
    "CMYK_C": 0,
    "CMYK_M": 0.00556139834225,
    "CMYK_Y": 0.0386790111661,
    "CMYK_K": 0.04523646831512
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y059505",
    "Farbtonhilfsbezeichnung": "Y05 95 05 Marienglas Sicilia",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "242",
    "Bcolor": "231",
    "Y": 88,
    "L": 95.3284912109375,
    "a": -0.62217336893082,
    "b": 4.43959951400757,
    "C": 4.48298358917236,
    "h": 97.9775772094727,
    "CMY_C": 0.04265344142914,
    "CMY_M": 0.05189627408981,
    "CMY_Y": 0.09326058626175,
    "CMYK_C": 0,
    "CMYK_M": 0.00965463649482,
    "CMYK_Y": 0.05286188796163,
    "CMYK_K": 0.04265344142914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y065020",
    "Farbtonhilfsbezeichnung": "Y06 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "118",
    "Bcolor": "83",
    "Y": 18,
    "L": 49.770679473877,
    "a": -1.69554114341736,
    "b": 20.0671615600586,
    "C": 20.1386642456055,
    "h": 94.8296356201172,
    "CMY_C": 0.49845111370087,
    "CMY_M": 0.53628504276276,
    "CMY_Y": 0.67263102531433,
    "CMYK_C": 0,
    "CMYK_M": 0.07543417811394,
    "CMYK_Y": 0.34728401899338,
    "CMYK_K": 0.49845111370087
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y065141",
    "Farbtonhilfsbezeichnung": "Y06 51 41",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "122",
    "Bcolor": "47",
    "Y": 19,
    "L": 51.2665634155273,
    "a": -3.61698651313782,
    "b": 41.6974411010742,
    "C": 41.8540229797363,
    "h": 94.957633972168,
    "CMY_C": 0.46308428049088,
    "CMY_M": 0.52050894498825,
    "CMY_Y": 0.81633239984512,
    "CMYK_C": 0,
    "CMYK_M": 0.10695284605026,
    "CMYK_Y": 0.65792095661163,
    "CMYK_K": 0.46308428049088
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y066010",
    "Farbtonhilfsbezeichnung": "Y06 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "144",
    "Bcolor": "126",
    "Y": 28,
    "L": 59.9678192138672,
    "a": -0.90443348884583,
    "b": 10.1039762496948,
    "C": 10.1443748474121,
    "h": 95.1150665283203,
    "CMY_C": 0.41089928150177,
    "CMY_M": 0.43352264165878,
    "CMY_Y": 0.5068027973175,
    "CMYK_C": 0,
    "CMYK_M": 0.03840321302414,
    "CMYK_Y": 0.16279646754265,
    "CMYK_K": 0.41089928150177
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y066020",
    "Farbtonhilfsbezeichnung": "Y06 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "147",
    "Bcolor": "110",
    "Y": 28,
    "L": 60.9164352416992,
    "a": -1.60179579257965,
    "b": 20.4026699066162,
    "C": 20.4654502868652,
    "h": 94.4890365600586,
    "CMY_C": 0.38183742761612,
    "CMY_M": 0.42442899942398,
    "CMY_Y": 0.5685076713562,
    "CMYK_C": 0,
    "CMYK_M": 0.06890027225018,
    "CMYK_Y": 0.30197596549988,
    "CMYK_K": 0.38183742761612
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y066031",
    "Farbtonhilfsbezeichnung": "Y06 60 31",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "145",
    "Bcolor": "88",
    "Y": 28,
    "L": 60.0533752441406,
    "a": -2.51608347892761,
    "b": 31.3811721801758,
    "C": 31.4818782806396,
    "h": 94.5840606689453,
    "CMY_C": 0.3766205906868,
    "CMY_M": 0.43316668272018,
    "CMY_Y": 0.65463119745255,
    "CMYK_C": 0,
    "CMYK_M": 0.09070894867182,
    "CMYK_Y": 0.44597336649895,
    "CMYK_K": 0.3766205906868
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y066150",
    "Farbtonhilfsbezeichnung": "Y06 61 50",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "147",
    "Bcolor": "55",
    "Y": 29,
    "L": 60.6385383605957,
    "a": -4.89546918869019,
    "b": 48.5937576293945,
    "C": 48.8397254943848,
    "h": 95.7527236938477,
    "CMY_C": 0.36182767152786,
    "CMY_M": 0.42433124780655,
    "CMY_Y": 0.78375065326691,
    "CMYK_C": 0,
    "CMYK_M": 0.09794153273106,
    "CMYK_Y": 0.66114270687103,
    "CMYK_K": 0.36182767152786
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y067010",
    "Farbtonhilfsbezeichnung": "Y06 70 10",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "172",
    "Bcolor": "154",
    "Y": 41,
    "L": 70.3672256469727,
    "a": -0.84272503852844,
    "b": 9.50135707855225,
    "C": 9.53865623474121,
    "h": 95.0685958862305,
    "CMY_C": 0.3029009103775,
    "CMY_M": 0.32536518573761,
    "CMY_Y": 0.39742070436478,
    "CMYK_C": 0,
    "CMYK_M": 0.0322253704071,
    "CMYK_Y": 0.13559018075466,
    "CMYK_K": 0.3029009103775
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y067020",
    "Farbtonhilfsbezeichnung": "Y06 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "170",
    "Bcolor": "134",
    "Y": 41,
    "L": 69.4840927124023,
    "a": -1.81591796875,
    "b": 19.0551319122314,
    "C": 19.1414623260498,
    "h": 95.4437408447266,
    "CMY_C": 0.29511314630508,
    "CMY_M": 0.33463484048843,
    "CMY_Y": 0.4740799665451,
    "CMYK_C": 0,
    "CMYK_M": 0.05606813728809,
    "CMYK_Y": 0.25389438867569,
    "CMYK_K": 0.29511314630508
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y067040",
    "Farbtonhilfsbezeichnung": "Y06 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "171",
    "Bcolor": "96",
    "Y": 41,
    "L": 69.8759994506836,
    "a": -3.64800047874451,
    "b": 40.0147132873535,
    "C": 40.1806564331055,
    "h": 95.2090530395508,
    "CMY_C": 0.26329433917999,
    "CMY_M": 0.33011597394943,
    "CMY_Y": 0.62369763851166,
    "CMYK_C": 0,
    "CMYK_M": 0.09070330113173,
    "CMYK_Y": 0.4892093539238,
    "CMYK_K": 0.26329433917999
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y067060",
    "Farbtonhilfsbezeichnung": "Y06 70 60",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "171",
    "Bcolor": "52",
    "Y": 41,
    "L": 69.8276596069336,
    "a": -5.3755898475647,
    "b": 60.041675567627,
    "C": 60.2818374633789,
    "h": 95.1161041259766,
    "CMY_C": 0.24975222349167,
    "CMY_M": 0.32923758029938,
    "CMY_Y": 0.7963593006134,
    "CMYK_C": 0,
    "CMYK_M": 0.10594547539949,
    "CMYK_Y": 0.72856873273849,
    "CMYK_K": 0.24975222349167
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068010",
    "Farbtonhilfsbezeichnung": "Y06 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "199",
    "Bcolor": "179",
    "Y": 57,
    "L": 80.1638641357422,
    "a": -0.83254384994507,
    "b": 10.1019248962402,
    "C": 10.136173248291,
    "h": 94.7113494873047,
    "CMY_C": 0.19536519050598,
    "CMY_M": 0.22061091661453,
    "CMY_Y": 0.29943019151688,
    "CMYK_C": 0,
    "CMYK_M": 0.03137538582087,
    "CMYK_Y": 0.12933196127415,
    "CMYK_K": 0.19536519050598
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068020",
    "Farbtonhilfsbezeichnung": "Y06 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "199",
    "Bcolor": "161",
    "Y": 57,
    "L": 80.2061538696289,
    "a": -1.59529745578766,
    "b": 19.6749744415283,
    "C": 19.7395439147949,
    "h": 94.6355514526367,
    "CMY_C": 0.17521798610687,
    "CMY_M": 0.22062230110168,
    "CMY_Y": 0.36860865354538,
    "CMYK_C": 0,
    "CMYK_M": 0.05505007877946,
    "CMYK_Y": 0.23447488248348,
    "CMYK_K": 0.17521798610687
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068030",
    "Farbtonhilfsbezeichnung": "Y06 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "198",
    "Bcolor": "141",
    "Y": 57,
    "L": 80.0808181762695,
    "a": -2.61938381195068,
    "b": 30.1117973327637,
    "C": 30.2255115509033,
    "h": 94.971565246582,
    "CMY_C": 0.16051179170609,
    "CMY_M": 0.22175025939941,
    "CMY_Y": 0.44684338569641,
    "CMYK_C": 0,
    "CMYK_M": 0.07294738292694,
    "CMYK_Y": 0.34107875823975,
    "CMYK_K": 0.16051179170609
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068050",
    "Farbtonhilfsbezeichnung": "Y06 80 50",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "198",
    "Bcolor": "102",
    "Y": 57,
    "L": 79.9502334594727,
    "a": -4.3282790184021,
    "b": 49.9131469726563,
    "C": 50.1004600524902,
    "h": 94.9560775756836,
    "CMY_C": 0.13937652111053,
    "CMY_M": 0.22247624397278,
    "CMY_Y": 0.6011558175087,
    "CMYK_C": 0,
    "CMYK_M": 0.0965575799346,
    "CMYK_Y": 0.53656369447708,
    "CMYK_K": 0.13937652111053
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068505",
    "Farbtonhilfsbezeichnung": "Y06 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "212",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.0733947753906,
    "a": -0.34475913643837,
    "b": 4.74402570724487,
    "C": 4.75653648376465,
    "h": 94.1565093994141,
    "CMY_C": 0.15388363599777,
    "CMY_M": 0.16674208641052,
    "CMY_Y": 0.20787328481674,
    "CMYK_C": 0,
    "CMYK_M": 0.01519702374935,
    "CMYK_Y": 0.06380877643824,
    "CMYK_K": 0.15388363599777
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068510",
    "Farbtonhilfsbezeichnung": "Y06 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "214",
    "Bcolor": "194",
    "Y": 66,
    "L": 85.4622039794922,
    "a": -0.85990053415298,
    "b": 9.49868869781494,
    "C": 9.53753185272217,
    "h": 95.1727905273438,
    "CMY_C": 0.13899910449982,
    "CMY_M": 0.16250592470169,
    "CMY_Y": 0.23853743076324,
    "CMYK_C": 0,
    "CMYK_M": 0.02730173803866,
    "CMYK_Y": 0.11560769379139,
    "CMYK_K": 0.13899910449982
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068520",
    "Farbtonhilfsbezeichnung": "Y06 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "211",
    "Bcolor": "172",
    "Y": 66,
    "L": 84.5969696044922,
    "a": -1.73921656608582,
    "b": 20.095193862915,
    "C": 20.170316696167,
    "h": 94.9465637207031,
    "CMY_C": 0.12643676996231,
    "CMY_M": 0.17248225212097,
    "CMY_Y": 0.32571876049042,
    "CMYK_C": 0,
    "CMYK_M": 0.05270995944738,
    "CMYK_Y": 0.22812543809414,
    "CMYK_K": 0.12643676996231
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068540",
    "Farbtonhilfsbezeichnung": "Y06 85 40",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "212",
    "Bcolor": "135",
    "Y": 66,
    "L": 84.9683151245117,
    "a": -3.45450448989868,
    "b": 39.9665565490723,
    "C": 40.1155738830566,
    "h": 94.940071105957,
    "CMY_C": 0.09205967187881,
    "CMY_M": 0.16830533742905,
    "CMY_Y": 0.47137975692749,
    "CMYK_C": 0,
    "CMYK_M": 0.08397651463747,
    "CMYK_Y": 0.41778084635735,
    "CMYK_K": 0.09205967187881
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y068872",
    "Farbtonhilfsbezeichnung": "Y06 88 72 Neapelgelb Zitron",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "221",
    "Bcolor": "71",
    "Y": 72,
    "L": 87.9298095703125,
    "a": -6.64273548126221,
    "b": 72.0962142944336,
    "C": 72.4015884399414,
    "h": 95.2642059326172,
    "CMY_C": 0.03365057706833,
    "CMY_M": 0.13273108005524,
    "CMY_Y": 0.71997511386871,
    "CMYK_C": 0,
    "CMYK_M": 0.10253071784973,
    "CMYK_Y": 0.71022397279739,
    "CMYK_K": 0.03365057706833
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069010",
    "Farbtonhilfsbezeichnung": "Y06 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "227",
    "Bcolor": "206",
    "Y": 76,
    "L": 90.1003952026367,
    "a": -0.93443804979324,
    "b": 9.79337406158447,
    "C": 9.83785247802734,
    "h": 95.4504013061523,
    "CMY_C": 0.08704555034637,
    "CMY_M": 0.11110001802444,
    "CMY_Y": 0.19059145450592,
    "CMYK_C": 0,
    "CMYK_M": 0.02634793892503,
    "CMYK_Y": 0.11341847479343,
    "CMYK_K": 0.08704555034637
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069020",
    "Farbtonhilfsbezeichnung": "Y06 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "227",
    "Bcolor": "187",
    "Y": 76,
    "L": 90.1657943725586,
    "a": -1.78291654586792,
    "b": 20.253791809082,
    "C": 20.3321151733398,
    "h": 95.0307083129883,
    "CMY_C": 0.06377369165421,
    "CMY_M": 0.11090588569641,
    "CMY_Y": 0.26777702569962,
    "CMYK_C": 0,
    "CMYK_M": 0.0503427349031,
    "CMYK_Y": 0.21789959073067,
    "CMYK_K": 0.06377369165421
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069030",
    "Farbtonhilfsbezeichnung": "Y06 90 30",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "226",
    "Bcolor": "168",
    "Y": 76,
    "L": 89.7610473632813,
    "a": -2.92217707633972,
    "b": 29.6661491394043,
    "C": 29.8097229003906,
    "h": 95.625602722168,
    "CMY_C": 0.0542408823967,
    "CMY_M": 0.11474752426147,
    "CMY_Y": 0.34293907880783,
    "CMYK_C": 0,
    "CMYK_M": 0.06397680193186,
    "CMYK_Y": 0.30525553226471,
    "CMYK_K": 0.0542408823967
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069040",
    "Farbtonhilfsbezeichnung": "Y06 90 40",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "225",
    "Bcolor": "148",
    "Y": 76,
    "L": 89.6393890380859,
    "a": -3.70719790458679,
    "b": 39.3530387878418,
    "C": 39.5272674560547,
    "h": 95.3815841674805,
    "CMY_C": 0.04128843545914,
    "CMY_M": 0.11609303951263,
    "CMY_Y": 0.41834938526154,
    "CMYK_C": 0,
    "CMYK_M": 0.07802618294954,
    "CMYK_Y": 0.39329966902733,
    "CMYK_K": 0.04128843545914
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069050",
    "Farbtonhilfsbezeichnung": "Y06 90 50",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "226",
    "Bcolor": "128",
    "Y": 76,
    "L": 89.8136138916016,
    "a": -4.50110912322998,
    "b": 49.8997688293457,
    "C": 50.1023635864258,
    "h": 95.1543045043945,
    "CMY_C": 0.02630108594894,
    "CMY_M": 0.1140416264534,
    "CMY_Y": 0.49988436698914,
    "CMYK_C": 0,
    "CMYK_M": 0.0901105478406,
    "CMYK_Y": 0.48637548089027,
    "CMYK_K": 0.02630108594894
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069060",
    "Farbtonhilfsbezeichnung": "Y06 90 60",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "225",
    "Bcolor": "106",
    "Y": 76,
    "L": 89.4865951538086,
    "a": -4.69330263137817,
    "b": 59.6831970214844,
    "C": 59.8674468994141,
    "h": 94.4963073730469,
    "CMY_C": 0.01703441143036,
    "CMY_M": 0.11859107017517,
    "CMY_Y": 0.58484679460526,
    "CMYK_C": 0,
    "CMYK_M": 0.10331659764051,
    "CMYK_Y": 0.57765233516693,
    "CMYK_K": 0.01703441143036
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069225",
    "Farbtonhilfsbezeichnung": "Y06 92 25",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "233",
    "Bcolor": "183",
    "Y": 81,
    "L": 92.2313537597656,
    "a": -2.09147310256958,
    "b": 24.9330596923828,
    "C": 25.0206260681152,
    "h": 94.7949447631836,
    "CMY_C": 0.03098052740097,
    "CMY_M": 0.08819657564163,
    "CMY_Y": 0.28085380792618,
    "CMYK_C": 0,
    "CMYK_M": 0.05904530361295,
    "CMYK_Y": 0.25786197185516,
    "CMYK_K": 0.03098052740097
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069230",
    "Farbtonhilfsbezeichnung": "Y06 92 30",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "173",
    "Y": 81,
    "L": 91.8527526855469,
    "a": -2.65339660644531,
    "b": 29.9371337890625,
    "C": 30.0544929504395,
    "h": 95.0650177001953,
    "CMY_C": 0.02779358625412,
    "CMY_M": 0.09214895963669,
    "CMY_Y": 0.32283025979996,
    "CMYK_C": 0,
    "CMYK_M": 0.06619517505169,
    "CMYK_Y": 0.30347123742104,
    "CMYK_K": 0.02779358625412
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069305",
    "Farbtonhilfsbezeichnung": "Y06 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 83,
    "L": 93.0285415649414,
    "a": -0.36658301949501,
    "b": 4.97078371047974,
    "C": 4.98428249359131,
    "h": 94.2177886962891,
    "CMY_C": 0.0648045539856,
    "CMY_M": 0.07848161458969,
    "CMY_Y": 0.12263363599777,
    "CMYK_C": 0,
    "CMYK_M": 0.01462481543422,
    "CMYK_Y": 0.06183635815978,
    "CMYK_K": 0.0648045539856
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069308",
    "Farbtonhilfsbezeichnung": "Y06 93 08 Bianco Meudon",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "235",
    "Bcolor": "218",
    "Y": 83,
    "L": 93.0646514892578,
    "a": -0.66009330749512,
    "b": 8.06844806671143,
    "C": 8.09540462493896,
    "h": 94.6770477294922,
    "CMY_C": 0.05689823627472,
    "CMY_M": 0.07821309566498,
    "CMY_Y": 0.14535266160965,
    "CMYK_C": 0,
    "CMYK_M": 0.0226008053869,
    "CMYK_Y": 0.09379096329212,
    "CMYK_K": 0.05689823627472
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069320",
    "Farbtonhilfsbezeichnung": "Y06 93 20",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "195",
    "Y": 83,
    "L": 93.0908660888672,
    "a": -1.61708104610443,
    "b": 20.0630798339844,
    "C": 20.1281433105469,
    "h": 94.6080703735352,
    "CMY_C": 0.02985900640488,
    "CMY_M": 0.07861763238907,
    "CMY_Y": 0.23490941524506,
    "CMYK_C": 0,
    "CMYK_M": 0.05025931820273,
    "CMYK_Y": 0.21136145293713,
    "CMYK_K": 0.02985900640488
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069402",
    "Farbtonhilfsbezeichnung": "Y06 94 02 Sth02",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 85,
    "L": 93.9331359863281,
    "a": -0.16528522968292,
    "b": 2.08501243591309,
    "C": 2.09155344963074,
    "h": 94.5325317382812,
    "CMY_C": 0.06258887052536,
    "CMY_M": 0.06801521778107,
    "CMY_Y": 0.09109646081924,
    "CMYK_C": 0,
    "CMYK_M": 0.00578865269199,
    "CMYK_Y": 0.03041097894311,
    "CMYK_K": 0.06258887052536
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069407",
    "Farbtonhilfsbezeichnung": "Y06 94 07 Bianco S. Giovanni",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "238",
    "Bcolor": "223",
    "Y": 85,
    "L": 93.997932434082,
    "a": -0.61496418714523,
    "b": 6.95721006393433,
    "C": 6.98433637619019,
    "h": 95.0513763427734,
    "CMY_C": 0.04950076341629,
    "CMY_M": 0.06755965948105,
    "CMY_Y": 0.12679141759872,
    "CMYK_C": 0,
    "CMYK_M": 0.01899937912822,
    "CMYK_Y": 0.08131585270166,
    "CMYK_K": 0.04950076341629
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069504",
    "Farbtonhilfsbezeichnung": "Y06 95 04 Kalkweiss",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "242",
    "Bcolor": "232",
    "Y": 88,
    "L": 95.4012832641602,
    "a": -0.35242062807083,
    "b": 4.33955430984497,
    "C": 4.35384082794189,
    "h": 94.6428680419922,
    "CMY_C": 0.04003411531448,
    "CMY_M": 0.0516939163208,
    "CMY_Y": 0.09166461229324,
    "CMYK_C": 0,
    "CMYK_M": 0.01214605756104,
    "CMYK_Y": 0.05378367751837,
    "CMYK_K": 0.04003411531448
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y069510",
    "Farbtonhilfsbezeichnung": "Y06 95 10",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "219",
    "Y": 88,
    "L": 94.9009780883789,
    "a": -0.92378491163254,
    "b": 10.3699264526367,
    "C": 10.4109916687012,
    "h": 95.0906448364258,
    "CMY_C": 0.03118526935577,
    "CMY_M": 0.05757838487625,
    "CMY_Y": 0.14242100715637,
    "CMYK_C": 0,
    "CMYK_M": 0.02724268659949,
    "CMYK_Y": 0.11481631547213,
    "CMYK_K": 0.03118526935577
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077010",
    "Farbtonhilfsbezeichnung": "Y07 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "171",
    "Bcolor": "152",
    "Y": 41,
    "L": 70.2097702026367,
    "a": -0.00099451572169,
    "b": 9.98841285705566,
    "C": 9.98841285705566,
    "h": 90.0057067871094,
    "CMY_C": 0.29723715782166,
    "CMY_M": 0.32903736829758,
    "CMY_Y": 0.40234386920929,
    "CMYK_C": 0,
    "CMYK_M": 0.04525027424097,
    "CMYK_Y": 0.14956213533878,
    "CMYK_K": 0.29723715782166
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077020",
    "Farbtonhilfsbezeichnung": "Y07 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "171",
    "Bcolor": "136",
    "Y": 41,
    "L": 70.5881500244141,
    "a": 0.13098014891148,
    "b": 19.8474788665771,
    "C": 19.8479118347168,
    "h": 89.6218872070313,
    "CMY_C": 0.26806074380875,
    "CMY_M": 0.32753556966782,
    "CMY_Y": 0.46823233366013,
    "CMYK_C": 0,
    "CMYK_M": 0.08125650137663,
    "CMYK_Y": 0.2734811604023,
    "CMYK_K": 0.26806074380875
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077030",
    "Farbtonhilfsbezeichnung": "Y07 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "169",
    "Bcolor": "116",
    "Y": 41,
    "L": 69.7570571899414,
    "a": -0.20701231062412,
    "b": 29.5221366882324,
    "C": 29.5228633880615,
    "h": 90.4017562866211,
    "CMY_C": 0.25978136062622,
    "CMY_M": 0.33737552165985,
    "CMY_Y": 0.54612243175507,
    "CMYK_C": 0,
    "CMYK_M": 0.10482600331306,
    "CMYK_Y": 0.386833101511,
    "CMYK_K": 0.25978136062622
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077035",
    "Farbtonhilfsbezeichnung": "Y07 70 35",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "170",
    "Bcolor": "106",
    "Y": 41,
    "L": 70.1154556274414,
    "a": -0.02858878485858,
    "b": 35.0982208251953,
    "C": 35.0982322692871,
    "h": 90.0466690063477,
    "CMY_C": 0.24498295783997,
    "CMY_M": 0.33495259284973,
    "CMY_Y": 0.5834584236145,
    "CMYK_C": 0,
    "CMYK_M": 0.11916238814592,
    "CMYK_Y": 0.44830176234245,
    "CMYK_K": 0.24498295783997
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077525",
    "Farbtonhilfsbezeichnung": "Y07 75 25",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "184",
    "Bcolor": "137",
    "Y": 48,
    "L": 75.2086486816406,
    "a": 0.06528329849243,
    "b": 25.335599899292,
    "C": 25.3356838226318,
    "h": 89.8523635864258,
    "CMY_C": 0.2061213850975,
    "CMY_M": 0.27942478656769,
    "CMY_Y": 0.46092247962952,
    "CMYK_C": 0,
    "CMYK_M": 0.09233578294516,
    "CMYK_Y": 0.32095724344254,
    "CMYK_K": 0.2061213850975
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y077530",
    "Farbtonhilfsbezeichnung": "Y07 75 30",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "183",
    "Bcolor": "128",
    "Y": 48,
    "L": 74.841926574707,
    "a": 0.02182003110647,
    "b": 30.0829277038574,
    "C": 30.082935333252,
    "h": 89.9584426879883,
    "CMY_C": 0.20103877782822,
    "CMY_M": 0.2841392159462,
    "CMY_Y": 0.49932533502579,
    "CMYK_C": 0,
    "CMYK_M": 0.10401060432196,
    "CMYK_Y": 0.37334296107292,
    "CMYK_K": 0.20103877782822
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078005",
    "Farbtonhilfsbezeichnung": "Y07 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 57,
    "L": 80.3230514526367,
    "a": 0.07901272922754,
    "b": 5.31830263137817,
    "C": 5.31888961791992,
    "h": 89.1488342285156,
    "CMY_C": 0.20096892118454,
    "CMY_M": 0.21976906061172,
    "CMY_Y": 0.2630415558815,
    "CMYK_C": 0,
    "CMYK_M": 0.02352867089212,
    "CMYK_Y": 0.07768487930298,
    "CMYK_K": 0.20096892118454
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078020",
    "Farbtonhilfsbezeichnung": "Y07 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "199",
    "Bcolor": "161",
    "Y": 57,
    "L": 80.5214157104492,
    "a": -0.07758691906929,
    "b": 20.0540027618408,
    "C": 20.0541534423828,
    "h": 90.2216720581055,
    "CMY_C": 0.16004413366318,
    "CMY_M": 0.22079586982727,
    "CMY_Y": 0.36782610416412,
    "CMYK_C": 0,
    "CMYK_M": 0.0723272934556,
    "CMYK_Y": 0.24737247824669,
    "CMYK_K": 0.16004413366318
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078030",
    "Farbtonhilfsbezeichnung": "Y07 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "198",
    "Bcolor": "142",
    "Y": 57,
    "L": 80.5163726806641,
    "a": -0.2894614636898,
    "b": 30.1558609008789,
    "C": 30.1572494506836,
    "h": 90.5499572753906,
    "CMY_C": 0.13952022790909,
    "CMY_M": 0.2224172949791,
    "CMY_Y": 0.44222790002823,
    "CMYK_C": 0,
    "CMYK_M": 0.09633819013834,
    "CMYK_Y": 0.35178941488266,
    "CMYK_K": 0.13952022790909
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078035",
    "Farbtonhilfsbezeichnung": "Y07 80 35",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "130",
    "Y": 57,
    "L": 79.4329223632813,
    "a": 0.00070333073381,
    "b": 35.3190727233887,
    "C": 35.3190727233887,
    "h": 89.9988632202148,
    "CMY_C": 0.13999581336975,
    "CMY_M": 0.23575359582901,
    "CMY_Y": 0.49178427457809,
    "CMYK_C": 0,
    "CMYK_M": 0.11134571582079,
    "CMYK_Y": 0.40905436873436,
    "CMYK_K": 0.13999581336975
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078040",
    "Farbtonhilfsbezeichnung": "Y07 80 40",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "197",
    "Bcolor": "123",
    "Y": 57,
    "L": 80.35888671875,
    "a": -0.00173683592584,
    "b": 39.747428894043,
    "C": 39.747428894043,
    "h": 90.0025024414063,
    "CMY_C": 0.12180560827255,
    "CMY_M": 0.22649312019348,
    "CMY_Y": 0.51594883203506,
    "CMYK_C": 0,
    "CMYK_M": 0.11920767277479,
    "CMYK_Y": 0.44881090521812,
    "CMYK_K": 0.12180560827255
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078315",
    "Farbtonhilfsbezeichnung": "Y07 83 15",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "204",
    "Bcolor": "176",
    "Y": 62,
    "L": 82.4886245727539,
    "a": -0.03719640150666,
    "b": 15.0181913375854,
    "C": 15.0182371139526,
    "h": 90.1419067382812,
    "CMY_C": 0.15052008628845,
    "CMY_M": 0.19834953546524,
    "CMY_Y": 0.31043952703476,
    "CMYK_C": 0,
    "CMYK_M": 0.05630439147353,
    "CMYK_Y": 0.18825571238995,
    "CMYK_K": 0.15052008628845
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078520",
    "Farbtonhilfsbezeichnung": "Y07 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "210",
    "Bcolor": "172",
    "Y": 66,
    "L": 84.5852584838867,
    "a": 0.04450041800737,
    "b": 19.9950332641602,
    "C": 19.9950828552246,
    "h": 89.8724822998047,
    "CMY_C": 0.11398905515671,
    "CMY_M": 0.17675870656967,
    "CMY_Y": 0.32479232549667,
    "CMYK_C": 0,
    "CMYK_M": 0.07084523141384,
    "CMYK_Y": 0.23792400956154,
    "CMYK_K": 0.11398905515671
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078525",
    "Farbtonhilfsbezeichnung": "Y07 85 25",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "212",
    "Bcolor": "165",
    "Y": 66,
    "L": 85.2692565917969,
    "a": 0.02953599207103,
    "b": 24.8856525421143,
    "C": 24.885669708252,
    "h": 89.9319915771484,
    "CMY_C": 0.09493213891983,
    "CMY_M": 0.17028343677521,
    "CMY_Y": 0.35377115011215,
    "CMYK_C": 0,
    "CMYK_M": 0.08325485885143,
    "CMYK_Y": 0.285988509655,
    "CMYK_K": 0.09493213891983
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078530",
    "Farbtonhilfsbezeichnung": "Y07 85 30",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "209",
    "Bcolor": "153",
    "Y": 66,
    "L": 84.5989074707031,
    "a": 0.03617119416595,
    "b": 30.1538543701172,
    "C": 30.1538753509521,
    "h": 89.931266784668,
    "CMY_C": 0.09112900495529,
    "CMY_M": 0.17871552705765,
    "CMY_Y": 0.40001660585403,
    "CMYK_C": 0,
    "CMYK_M": 0.09636848419905,
    "CMYK_Y": 0.33985856175423,
    "CMYK_K": 0.09112900495529
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078535",
    "Farbtonhilfsbezeichnung": "Y07 85 35",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "209",
    "Bcolor": "144",
    "Y": 66,
    "L": 84.7323455810547,
    "a": 0.25710824131966,
    "b": 35.1469078063965,
    "C": 35.1478500366211,
    "h": 89.5808715820313,
    "CMY_C": 0.07825893163681,
    "CMY_M": 0.17872190475464,
    "CMY_Y": 0.43616098165512,
    "CMYK_C": 0,
    "CMYK_M": 0.1089926213026,
    "CMYK_Y": 0.3882891535759,
    "CMYK_K": 0.07825893163681
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078715",
    "Farbtonhilfsbezeichnung": "Y07 87 15",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "217",
    "Bcolor": "188",
    "Y": 70,
    "L": 86.9247131347656,
    "a": 0.02998845092952,
    "b": 15.1245365142822,
    "C": 15.124566078186,
    "h": 89.8863983154297,
    "CMY_C": 0.10032510757446,
    "CMY_M": 0.14987641572952,
    "CMY_Y": 0.2640694975853,
    "CMYK_C": 0,
    "CMYK_M": 0.0550769045949,
    "CMYK_Y": 0.18200396001339,
    "CMYK_K": 0.10032510757446
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078730",
    "Farbtonhilfsbezeichnung": "Y07 87 30",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "216",
    "Bcolor": "159",
    "Y": 70,
    "L": 86.8303833007813,
    "a": -0.00027946633054,
    "b": 30.1527576446533,
    "C": 30.1527576446533,
    "h": 90.0005264282227,
    "CMY_C": 0.0659813284874,
    "CMY_M": 0.15413081645966,
    "CMY_Y": 0.37677586078644,
    "CMYK_C": 0,
    "CMYK_M": 0.09437657892704,
    "CMYK_Y": 0.33274981379509,
    "CMYK_K": 0.0659813284874
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078840",
    "Farbtonhilfsbezeichnung": "Y07 88 40",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "219",
    "Bcolor": "142",
    "Y": 72,
    "L": 88.1867446899414,
    "a": 0.21493670344353,
    "b": 40.6024856567383,
    "C": 40.6030540466309,
    "h": 89.6966934204102,
    "CMY_C": 0.02875697612762,
    "CMY_M": 0.14163810014725,
    "CMY_Y": 0.44218254089355,
    "CMYK_C": 0,
    "CMYK_M": 0.11622335761786,
    "CMYK_Y": 0.42566645145416,
    "CMYK_K": 0.02875697612762
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y078850",
    "Farbtonhilfsbezeichnung": "Y07 88 50",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "218",
    "Bcolor": "122",
    "Y": 72,
    "L": 87.8045806884766,
    "a": 0.03889168426394,
    "b": 50.3167037963867,
    "C": 50.3167190551758,
    "h": 89.9557189941406,
    "CMY_C": 0.01855576038361,
    "CMY_M": 0.14699798822403,
    "CMY_Y": 0.52274179458618,
    "CMYK_C": 0,
    "CMYK_M": 0.1308706253767,
    "CMYK_Y": 0.51371848583221,
    "CMYK_K": 0.01855576038361
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079010",
    "Farbtonhilfsbezeichnung": "Y07 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "225",
    "Bcolor": "206",
    "Y": 76,
    "L": 89.8509368896484,
    "a": 0.09867943078279,
    "b": 9.4572286605835,
    "C": 9.45774364471436,
    "h": 89.4021835327148,
    "CMY_C": 0.08299338817596,
    "CMY_M": 0.11623287200928,
    "CMY_Y": 0.19065535068512,
    "CMYK_C": 0,
    "CMYK_M": 0.03624781221151,
    "CMYK_Y": 0.1174058765173,
    "CMYK_K": 0.08299338817596
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079020",
    "Farbtonhilfsbezeichnung": "Y07 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "223",
    "Bcolor": "186",
    "Y": 76,
    "L": 89.2198104858398,
    "a": 0.08741541951895,
    "b": 19.2598304748535,
    "C": 19.2600288391113,
    "h": 89.7399520874023,
    "CMY_C": 0.06332206726074,
    "CMY_M": 0.12560784816742,
    "CMY_Y": 0.27015805244446,
    "CMYK_C": 0,
    "CMYK_M": 0.06649647653103,
    "CMYK_Y": 0.22081868350506,
    "CMYK_K": 0.06332206726074
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079025",
    "Farbtonhilfsbezeichnung": "Y07 90 25",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "225",
    "Bcolor": "177",
    "Y": 76,
    "L": 89.9306640625,
    "a": 0.01201836578548,
    "b": 25.0430679321289,
    "C": 25.0430717468262,
    "h": 89.9725036621094,
    "CMY_C": 0.04178535938263,
    "CMY_M": 0.11883294582367,
    "CMY_Y": 0.30578476190567,
    "CMYK_C": 0,
    "CMYK_M": 0.08040744066238,
    "CMYK_Y": 0.27551177144051,
    "CMYK_K": 0.04178535938263
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079031",
    "Farbtonhilfsbezeichnung": "Y07 90 31",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "225",
    "Bcolor": "166",
    "Y": 76,
    "L": 90.2731246948242,
    "a": 0.0585540086031,
    "b": 31.0456638336182,
    "C": 31.0457191467285,
    "h": 89.8919372558594,
    "CMY_C": 0.02425163984299,
    "CMY_M": 0.11639082431793,
    "CMY_Y": 0.34737926721573,
    "CMYK_C": 0,
    "CMYK_M": 0.09442924708128,
    "CMYK_Y": 0.33115875720978,
    "CMYK_K": 0.02425163984299
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079035",
    "Farbtonhilfsbezeichnung": "Y07 90 35",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "224",
    "Bcolor": "158",
    "Y": 76,
    "L": 89.9324188232422,
    "a": 0.00541092362255,
    "b": 35.0932655334473,
    "C": 35.0932655334473,
    "h": 89.9911651611328,
    "CMY_C": 0.0202898979187,
    "CMY_M": 0.12083166837692,
    "CMY_Y": 0.38174146413803,
    "CMYK_C": 0,
    "CMYK_M": 0.1026239991188,
    "CMYK_Y": 0.36893725395203,
    "CMYK_K": 0.0202898979187
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079050",
    "Farbtonhilfsbezeichnung": "Y07 90 50",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "224",
    "Bcolor": "129",
    "Y": 76,
    "L": 90.181770324707,
    "a": -0.16183356940746,
    "b": 49.603572845459,
    "C": 49.6038360595703,
    "h": 90.1869277954102,
    "CMY_C": 0,
    "CMY_M": 0.12016177177429,
    "CMY_Y": 0.49246394634247,
    "CMYK_C": 0,
    "CMYK_M": 0.12016177177429,
    "CMYK_Y": 0.49246394634247,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079115",
    "Farbtonhilfsbezeichnung": "Y07 91 15",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "229",
    "Bcolor": "200",
    "Y": 78,
    "L": 91.230224609375,
    "a": 0.04205876588821,
    "b": 14.9331665039063,
    "C": 14.9332256317139,
    "h": 89.838623046875,
    "CMY_C": 0.05230671167374,
    "CMY_M": 0.1021283864975,
    "CMY_Y": 0.21635860204697,
    "CMYK_C": 0,
    "CMYK_M": 0.05257151648402,
    "CMYK_Y": 0.17310652136803,
    "CMYK_K": 0.05230671167374
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079120",
    "Farbtonhilfsbezeichnung": "Y07 91 20",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "228",
    "Bcolor": "189",
    "Y": 78,
    "L": 90.8771133422852,
    "a": -0.09323063492775,
    "b": 20.0787925720215,
    "C": 20.079008102417,
    "h": 90.2660369873047,
    "CMY_C": 0.04378265142441,
    "CMY_M": 0.10695773363113,
    "CMY_Y": 0.25855839252472,
    "CMYK_C": 0,
    "CMYK_M": 0.06606770306826,
    "CMYK_Y": 0.22460974752903,
    "CMYK_K": 0.04378265142441
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079125",
    "Farbtonhilfsbezeichnung": "Y07 91 25",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "229",
    "Bcolor": "180",
    "Y": 78,
    "L": 91.3595352172852,
    "a": 0.05618651211262,
    "b": 25.5072822570801,
    "C": 25.5073432922363,
    "h": 89.8737945556641,
    "CMY_C": 0.02406364679337,
    "CMY_M": 0.10315465927124,
    "CMY_Y": 0.29407399892807,
    "CMYK_C": 0,
    "CMYK_M": 0.08104115724564,
    "CMYK_Y": 0.27666798233986,
    "CMYK_K": 0.02406364679337
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079209",
    "Farbtonhilfsbezeichnung": "Y07 92 09 Veroneser Weiss",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "231",
    "Bcolor": "213",
    "Y": 81,
    "L": 91.8232574462891,
    "a": 0.23142626881599,
    "b": 8.59788608551025,
    "C": 8.60099983215332,
    "h": 88.4581604003906,
    "CMY_C": 0.06240856647491,
    "CMY_M": 0.09435892105103,
    "CMY_Y": 0.16275948286057,
    "CMYK_C": 0,
    "CMYK_M": 0.03407705575228,
    "CMYK_Y": 0.10703054070473,
    "CMYK_K": 0.06240856647491
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079302",
    "Farbtonhilfsbezeichnung": "Y07 93 02 Volterra Weiss",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "229",
    "Y": 83,
    "L": 93.0924911499023,
    "a": -0.05778761953115,
    "b": 2.16387510299683,
    "C": 2.1646466255188,
    "h": 91.5297546386719,
    "CMY_C": 0.0709074139595,
    "CMY_M": 0.07772022485733,
    "CMY_Y": 0.1009915471077,
    "CMYK_C": 0,
    "CMYK_M": 0.00733275758103,
    "CMYK_Y": 0.03238012269139,
    "CMYK_K": 0.0709074139595
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079303",
    "Farbtonhilfsbezeichnung": "Y07 93 03 Beinweiss",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "236",
    "Bcolor": "228",
    "Y": 83,
    "L": 93.2348251342773,
    "a": -0.05912860110402,
    "b": 3.2597987651825,
    "C": 3.26033496856689,
    "h": 91.0391616821289,
    "CMY_C": 0.06566828489304,
    "CMY_M": 0.07643020153046,
    "CMY_Y": 0.10757267475128,
    "CMYK_C": 0,
    "CMYK_M": 0.01151830423623,
    "CMYK_Y": 0.04484958574176,
    "CMYK_K": 0.06566828489304
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079310",
    "Farbtonhilfsbezeichnung": "Y07 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "214",
    "Y": 83,
    "L": 92.8660736083984,
    "a": 0.09395937621593,
    "b": 9.98322868347168,
    "C": 9.98367118835449,
    "h": 89.4607696533203,
    "CMY_C": 0.04755532741547,
    "CMY_M": 0.08273780345917,
    "CMY_Y": 0.16168451309204,
    "CMYK_C": 0,
    "CMYK_M": 0.03693912923336,
    "CMYK_Y": 0.11982762813568,
    "CMYK_K": 0.04755532741547
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079315",
    "Farbtonhilfsbezeichnung": "Y07 93 15",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "234",
    "Bcolor": "204",
    "Y": 83,
    "L": 92.9245758056641,
    "a": 0.07059405744076,
    "b": 15.1121482849121,
    "C": 15.1123132705688,
    "h": 89.7323532104492,
    "CMY_C": 0.03241157531738,
    "CMY_M": 0.08332365751266,
    "CMY_Y": 0.19933122396469,
    "CMYK_C": 0,
    "CMYK_M": 0.05261749774218,
    "CMYK_Y": 0.17251099646091,
    "CMYK_K": 0.03241157531738
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079320",
    "Farbtonhilfsbezeichnung": "Y07 93 20",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "233",
    "Bcolor": "194",
    "Y": 83,
    "L": 92.6201934814453,
    "a": -0.09855983406305,
    "b": 20.0356006622314,
    "C": 20.0358428955078,
    "h": 90.281852722168,
    "CMY_C": 0.0240952372551,
    "CMY_M": 0.08749639987946,
    "CMY_Y": 0.23950928449631,
    "CMYK_C": 0,
    "CMYK_M": 0.06496654450893,
    "CMYK_Y": 0.22073265910149,
    "CMYK_K": 0.0240952372551
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079403",
    "Farbtonhilfsbezeichnung": "Y07 94 03 Aw15",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "236",
    "Bcolor": "228",
    "Y": 85,
    "L": 93.39306640625,
    "a": -0.01323115918785,
    "b": 3.365807056427,
    "C": 3.36583304405212,
    "h": 90.2252349853516,
    "CMY_C": 0.06318044662476,
    "CMY_M": 0.07479614019394,
    "CMY_Y": 0.1066045165062,
    "CMYK_C": 0,
    "CMYK_M": 0.01239907275885,
    "CMYK_Y": 0.04635265097022,
    "CMYK_K": 0.06318044662476
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079405",
    "Farbtonhilfsbezeichnung": "Y07 94 05",
    "Farbtonklasse": "00",
    "Y": 85,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079410",
    "Farbtonhilfsbezeichnung": "Y07 94 10",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "238",
    "Bcolor": "218",
    "Y": 85,
    "L": 94.2168197631836,
    "a": -0.00594867579639,
    "b": 9.79329299926758,
    "C": 9.79329490661621,
    "h": 90.0348052978516,
    "CMY_C": 0.03361761569977,
    "CMY_M": 0.0673109292984,
    "CMY_Y": 0.14547806978226,
    "CMYK_C": 0,
    "CMYK_M": 0.03486540541053,
    "CMYK_Y": 0.11575175076723,
    "CMYK_K": 0.03361761569977
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y079505",
    "Farbtonhilfsbezeichnung": "Y07 95 05",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "240",
    "Bcolor": "229",
    "Y": 88,
    "L": 95.0083999633789,
    "a": -0.01066872663796,
    "b": 5.0536322593689,
    "C": 5.05364370346069,
    "h": 90.1209564208984,
    "CMY_C": 0.03946036100388,
    "CMY_M": 0.05713212490082,
    "CMY_Y": 0.10131341218948,
    "CMYK_C": 0,
    "CMYK_M": 0.01839774474502,
    "CMYK_Y": 0.06439406424761,
    "CMYK_K": 0.03946036100388
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y084003",
    "Farbtonhilfsbezeichnung": "Y08 40 03",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "94",
    "Bcolor": "88",
    "Y": 11,
    "L": 39.879020690918,
    "a": 0.20550145208836,
    "b": 3.20638370513916,
    "C": 3.21296238899231,
    "h": 86.3328552246094,
    "CMY_C": 0.62124514579773,
    "CMY_M": 0.6324827671051,
    "CMY_Y": 0.65478301048279,
    "CMYK_C": 0,
    "CMYK_M": 0.02966990694404,
    "CMYK_Y": 0.08854768425226,
    "CMYK_K": 0.62124514579773
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y085003",
    "Farbtonhilfsbezeichnung": "Y08 50 03",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "118",
    "Bcolor": "112",
    "Y": 18,
    "L": 49.6964454650879,
    "a": 0.15562276542187,
    "b": 3.14093089103699,
    "C": 3.14478373527527,
    "h": 87.1634979248047,
    "CMY_C": 0.52632123231888,
    "CMY_M": 0.53740566968918,
    "CMY_Y": 0.56092554330826,
    "CMYK_C": 0,
    "CMYK_M": 0.02340074814856,
    "CMYK_Y": 0.07305438816547,
    "CMYK_K": 0.52632123231888
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y085010",
    "Farbtonhilfsbezeichnung": "Y08 50 10",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "119",
    "Bcolor": "102",
    "Y": 18,
    "L": 50.4642486572266,
    "a": 0.84058773517609,
    "b": 10.2667722702026,
    "C": 10.3011264801025,
    "h": 85.3193664550781,
    "CMY_C": 0.49580544233322,
    "CMY_M": 0.53290218114853,
    "CMY_Y": 0.60033285617828,
    "CMYK_C": 0,
    "CMYK_M": 0.07357624173164,
    "CMYK_Y": 0.20731563866138,
    "CMYK_K": 0.49580544233322
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y086003",
    "Farbtonhilfsbezeichnung": "Y08 60 03",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "143",
    "Bcolor": "137",
    "Y": 28,
    "L": 59.61181640625,
    "a": 0.28915098309517,
    "b": 3.23298287391663,
    "C": 3.24588775634766,
    "h": 84.8891906738281,
    "CMY_C": 0.42510288953781,
    "CMY_M": 0.43812465667725,
    "CMY_Y": 0.46340847015381,
    "CMYK_C": 0,
    "CMYK_M": 0.02265060506761,
    "CMYK_Y": 0.06663032621145,
    "CMYK_K": 0.42510288953781
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y086010",
    "Farbtonhilfsbezeichnung": "Y08 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "144",
    "Bcolor": "125",
    "Y": 28,
    "L": 60.024959564209,
    "a": 0.93138217926025,
    "b": 10.6205205917358,
    "C": 10.6612815856934,
    "h": 84.9881896972656,
    "CMY_C": 0.39645928144455,
    "CMY_M": 0.43707597255707,
    "CMY_Y": 0.50948852300644,
    "CMYK_C": 0,
    "CMYK_M": 0.06729734688997,
    "CMYK_Y": 0.18727691471577,
    "CMYK_K": 0.39645928144455
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y086030",
    "Farbtonhilfsbezeichnung": "Y08 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "140",
    "Bcolor": "90",
    "Y": 28,
    "L": 59.5379371643066,
    "a": 2.58431172370911,
    "b": 29.7923908233643,
    "C": 29.9042682647705,
    "h": 85.0423431396484,
    "CMY_C": 0.35273814201355,
    "CMY_M": 0.44943559169769,
    "CMY_Y": 0.64699548482895,
    "CMYK_C": 0,
    "CMYK_M": 0.1493946313858,
    "CMYK_Y": 0.45461869239807,
    "CMYK_K": 0.35273814201355
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y086150",
    "Farbtonhilfsbezeichnung": "Y08 61 50",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "143",
    "Bcolor": "56",
    "Y": 28,
    "L": 61.3007431030273,
    "a": 4.52865552902222,
    "b": 49.4598770141602,
    "C": 49.6667709350586,
    "h": 84.7684631347656,
    "CMY_C": 0.2968327999115,
    "CMY_M": 0.43864184617996,
    "CMY_Y": 0.78084683418274,
    "CMYK_C": 0,
    "CMYK_M": 0.2016718685627,
    "CMYK_Y": 0.68833422660828,
    "CMYK_K": 0.2968327999115
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y087003",
    "Farbtonhilfsbezeichnung": "Y08 70 03",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "169",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.502311706543,
    "a": 0.322330057621,
    "b": 3.12388706207275,
    "C": 3.14047241210938,
    "h": 84.1089324951172,
    "CMY_C": 0.32213032245636,
    "CMY_M": 0.33551394939423,
    "CMY_Y": 0.3614210486412,
    "CMYK_C": 0,
    "CMYK_M": 0.01974365860224,
    "CMYK_Y": 0.05796206369996,
    "CMYK_K": 0.32213032245636
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y087005",
    "Farbtonhilfsbezeichnung": "Y08 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "170",
    "Bcolor": "160",
    "Y": 41,
    "L": 69.7121200561523,
    "a": 0.46327310800552,
    "b": 5.24569654464722,
    "C": 5.26611375808716,
    "h": 84.9530258178711,
    "CMY_C": 0.31252783536911,
    "CMY_M": 0.33416777849197,
    "CMY_Y": 0.37409245967865,
    "CMYK_C": 0,
    "CMYK_M": 0.03147755563259,
    "CMYK_Y": 0.08955217152834,
    "CMYK_K": 0.31252783536911
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y087020",
    "Farbtonhilfsbezeichnung": "Y08 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "169",
    "Bcolor": "134",
    "Y": 41,
    "L": 69.8622512817383,
    "a": 1.63674569129944,
    "b": 19.7986335754395,
    "C": 19.8661727905273,
    "h": 85.2741241455078,
    "CMY_C": 0.26585215330124,
    "CMY_M": 0.33861917257309,
    "CMY_Y": 0.47494322061539,
    "CMYK_C": 0,
    "CMYK_M": 0.09911766648293,
    "CMYK_Y": 0.28480786085129,
    "CMYK_K": 0.26585215330124
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y087040",
    "Farbtonhilfsbezeichnung": "Y08 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "167",
    "Bcolor": "96",
    "Y": 41,
    "L": 69.9945068359375,
    "a": 3.40026140213013,
    "b": 40.1619110107422,
    "C": 40.3055953979492,
    "h": 85.1606597900391,
    "CMY_C": 0.2167900800705,
    "CMY_M": 0.34496182203293,
    "CMY_Y": 0.62177461385727,
    "CMYK_C": 0,
    "CMYK_M": 0.16364927589893,
    "CMYK_Y": 0.51708298921585,
    "CMYK_K": 0.2167900800705
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y087560",
    "Farbtonhilfsbezeichnung": "Y08 75 60",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "179",
    "Bcolor": "69",
    "Y": 48,
    "L": 75.0784530639648,
    "a": 5.70124959945679,
    "b": 59.5529747009277,
    "C": 59.825252532959,
    "h": 84.5315093994141,
    "CMY_C": 0.12078964710236,
    "CMY_M": 0.29942715167999,
    "CMY_Y": 0.72996294498444,
    "CMYK_C": 0,
    "CMYK_M": 0.20317947864532,
    "CMYK_Y": 0.69286412000656,
    "CMYK_K": 0.12078964710236
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088003",
    "Farbtonhilfsbezeichnung": "Y08 80 03",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "197",
    "Bcolor": "191",
    "Y": 57,
    "L": 79.7145080566406,
    "a": 0.34613427519798,
    "b": 2.87750625610352,
    "C": 2.89824962615967,
    "h": 83.140869140625,
    "CMY_C": 0.21319890022278,
    "CMY_M": 0.22633767127991,
    "CMY_Y": 0.25190997123718,
    "CMYK_C": 0,
    "CMYK_M": 0.01669897325337,
    "CMYK_Y": 0.04920057952404,
    "CMYK_K": 0.21319890022278
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088010",
    "Farbtonhilfsbezeichnung": "Y08 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "198",
    "Bcolor": "178",
    "Y": 57,
    "L": 80.1806488037109,
    "a": 0.91131263971329,
    "b": 10.4353818893433,
    "C": 10.4750986099243,
    "h": 85.0090713500977,
    "CMY_C": 0.18144804239273,
    "CMY_M": 0.22455888986588,
    "CMY_Y": 0.30139702558517,
    "CMYK_C": 0,
    "CMYK_M": 0.05266720801592,
    "CMYK_Y": 0.1465380191803,
    "CMYK_K": 0.18144804239273
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088020",
    "Farbtonhilfsbezeichnung": "Y08 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "197",
    "Bcolor": "161",
    "Y": 57,
    "L": 80.1477508544922,
    "a": 1.90697121620178,
    "b": 19.584400177002,
    "C": 19.6770248413086,
    "h": 84.4385299682617,
    "CMY_C": 0.15137529373169,
    "CMY_M": 0.22940266132355,
    "CMY_Y": 0.36794435977936,
    "CMYK_C": 0,
    "CMYK_M": 0.0919456705451,
    "CMYK_Y": 0.25520005822182,
    "CMYK_K": 0.15137529373169
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088030",
    "Farbtonhilfsbezeichnung": "Y08 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "195",
    "Bcolor": "142",
    "Y": 57,
    "L": 79.9708786010742,
    "a": 2.70794558525085,
    "b": 29.5456066131592,
    "C": 29.6694431304932,
    "h": 84.763298034668,
    "CMY_C": 0.12656503915787,
    "CMY_M": 0.23528355360031,
    "CMY_Y": 0.44267815351486,
    "CMYK_C": 0,
    "CMYK_M": 0.12447236478329,
    "CMYK_Y": 0.36191946268082,
    "CMYK_K": 0.12656503915787
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088050",
    "Farbtonhilfsbezeichnung": "Y08 80 50",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "193",
    "Bcolor": "102",
    "Y": 57,
    "L": 80.0151214599609,
    "a": 4.31803560256958,
    "b": 50.0938415527344,
    "C": 50.2796020507813,
    "h": 85.0733489990234,
    "CMY_C": 0.0823427438736,
    "CMY_M": 0.24211722612381,
    "CMY_Y": 0.59928297996521,
    "CMYK_C": 0,
    "CMYK_M": 0.17411127686501,
    "CMYK_Y": 0.56332606077194,
    "CMYK_K": 0.0823427438736
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088455",
    "Farbtonhilfsbezeichnung": "Y08 84 55",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "205",
    "Bcolor": "103",
    "Y": 64,
    "L": 84.4250640869141,
    "a": 4.26553583145142,
    "b": 55.0894393920898,
    "C": 55.2543296813965,
    "h": 85.5724639892578,
    "CMY_C": 0.02428615093231,
    "CMY_M": 0.19493979215622,
    "CMY_Y": 0.59527707099915,
    "CMYK_C": 0,
    "CMYK_M": 0.17490132153034,
    "CMYK_Y": 0.58520323038101,
    "CMYK_K": 0.02428615093231
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088505",
    "Farbtonhilfsbezeichnung": "Y08 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "212",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.2358245849609,
    "a": 0.51534706354141,
    "b": 5.16205930709839,
    "C": 5.18771982192993,
    "h": 84.2988433837891,
    "CMY_C": 0.14421862363815,
    "CMY_M": 0.16708678007126,
    "CMY_Y": 0.20904630422592,
    "CMYK_C": 0,
    "CMYK_M": 0.02672195993364,
    "CMYK_Y": 0.07575261592865,
    "CMYK_K": 0.14421862363815
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088510",
    "Farbtonhilfsbezeichnung": "Y08 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "212",
    "Bcolor": "193",
    "Y": 66,
    "L": 85.2612762451172,
    "a": 0.89959126710892,
    "b": 10.0828647613525,
    "C": 10.1229162216187,
    "h": 84.9015808105469,
    "CMY_C": 0.12639385461807,
    "CMY_M": 0.16899794340134,
    "CMY_Y": 0.24470394849777,
    "CMYK_C": 0,
    "CMYK_M": 0.04876807332039,
    "CMYK_Y": 0.13542726635933,
    "CMYK_K": 0.12639385461807
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088520",
    "Farbtonhilfsbezeichnung": "Y08 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "210",
    "Bcolor": "174",
    "Y": 66,
    "L": 85.1439437866211,
    "a": 1.69734251499176,
    "b": 19.8596992492676,
    "C": 19.9321002960205,
    "h": 85.114990234375,
    "CMY_C": 0.09626513719559,
    "CMY_M": 0.1745263338089,
    "CMY_Y": 0.31761127710342,
    "CMYK_C": 0,
    "CMYK_M": 0.08659751713276,
    "CMYK_Y": 0.24492375552654,
    "CMYK_K": 0.09626513719559
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088540",
    "Farbtonhilfsbezeichnung": "Y08 85 40",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "208",
    "Bcolor": "135",
    "Y": 66,
    "L": 85.0603713989258,
    "a": 3.55590534210205,
    "b": 40.1724243164063,
    "C": 40.3294944763184,
    "h": 84.9415817260742,
    "CMY_C": 0.04335910081863,
    "CMY_M": 0.18397039175034,
    "CMY_Y": 0.47032243013382,
    "CMYK_C": 0,
    "CMYK_M": 0.14698439836502,
    "CMYK_Y": 0.44631513953209,
    "CMYK_K": 0.04335910081863
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088560",
    "Farbtonhilfsbezeichnung": "Y08 85 60",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "207",
    "Bcolor": "96",
    "Y": 66,
    "L": 85.2334976196289,
    "a": 4.81339311599731,
    "b": 59.5934104919434,
    "C": 59.787483215332,
    "h": 85.3822174072266,
    "CMY_C": 0.00566065311432,
    "CMY_M": 0.18808460235596,
    "CMY_Y": 0.6250091791153,
    "CMYK_C": 0,
    "CMYK_M": 0.18346247076988,
    "CMYK_Y": 0.62287437915802,
    "CMYK_K": 0.00566065311432
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088630",
    "Farbtonhilfsbezeichnung": "Y08 86 30",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "212",
    "Bcolor": "157",
    "Y": 68,
    "L": 85.9514923095703,
    "a": 2.58772754669189,
    "b": 29.972017288208,
    "C": 30.0835189819336,
    "h": 85.0654296875,
    "CMY_C": 0.05850166082382,
    "CMY_M": 0.16996055841446,
    "CMY_Y": 0.38406312465668,
    "CMYK_C": 0,
    "CMYK_M": 0.11838459223509,
    "CMYK_Y": 0.34579080343246,
    "CMYK_K": 0.05850166082382
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088646",
    "Farbtonhilfsbezeichnung": "Y08 86 46",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "209",
    "Bcolor": "125",
    "Y": 66,
    "L": 85.5552062988281,
    "a": 4.43485736846924,
    "b": 45.9047622680664,
    "C": 46.1184921264648,
    "h": 84.4817810058594,
    "CMY_C": 0.02263867855072,
    "CMY_M": 0.18167340755463,
    "CMY_Y": 0.50952017307281,
    "CMYK_C": 0,
    "CMYK_M": 0.1627184599638,
    "CMYK_Y": 0.49815917015076,
    "CMYK_K": 0.02263867855072
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088708",
    "Farbtonhilfsbezeichnung": "Y08 87 08 Lencin",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "218",
    "Bcolor": "202",
    "Y": 70,
    "L": 87.2783432006836,
    "a": 0.69560164213181,
    "b": 7.92359018325806,
    "C": 7.95406436920166,
    "h": 84.9829406738281,
    "CMY_C": 0.11178487539291,
    "CMY_M": 0.14574575424194,
    "CMY_Y": 0.20715653896332,
    "CMYK_C": 0,
    "CMYK_M": 0.03823497146368,
    "CMYK_Y": 0.10737451165915,
    "CMYK_K": 0.11178487539291
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088711",
    "Farbtonhilfsbezeichnung": "Y08 87 11 Perlweiss",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "216",
    "Bcolor": "196",
    "Y": 70,
    "L": 86.7390060424805,
    "a": 0.20114064216614,
    "b": 10.2127895355225,
    "C": 10.2147703170776,
    "h": 88.871711730957,
    "CMY_C": 0.11478024721146,
    "CMY_M": 0.15111649036407,
    "CMY_Y": 0.22987949848175,
    "CMYK_C": 0,
    "CMYK_M": 0.04104771092534,
    "CMYK_Y": 0.13002336025238,
    "CMYK_K": 0.11478024721146
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088738",
    "Farbtonhilfsbezeichnung": "Y08 87 38",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "215",
    "Bcolor": "145",
    "Y": 70,
    "L": 87.2558670043945,
    "a": 3.09694838523865,
    "b": 38.027229309082,
    "C": 38.1531295776367,
    "h": 85.3440856933594,
    "CMY_C": 0.0246496796608,
    "CMY_M": 0.15840458869934,
    "CMY_Y": 0.43134135007858,
    "CMYK_C": 0,
    "CMYK_M": 0.13713525235653,
    "CMYK_Y": 0.41696983575821,
    "CMYK_K": 0.0246496796608
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y088830",
    "Farbtonhilfsbezeichnung": "Y08 88 30",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "218",
    "Bcolor": "163",
    "Y": 72,
    "L": 88.2651519775391,
    "a": 2.67283296585083,
    "b": 29.9161567687988,
    "C": 30.0353202819824,
    "h": 84.8945083618164,
    "CMY_C": 0.03148412704468,
    "CMY_M": 0.14469945430756,
    "CMY_Y": 0.35943096876144,
    "CMYK_C": 0,
    "CMYK_M": 0.11689568310976,
    "CMYK_Y": 0.338607609272,
    "CMYK_K": 0.03148412704468
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089003",
    "Farbtonhilfsbezeichnung": "Y08 90 03",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "225",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.7505264282227,
    "a": 0.24034488201141,
    "b": 2.82103681564331,
    "C": 2.8312566280365,
    "h": 85.1303100585938,
    "CMY_C": 0.10373485088348,
    "CMY_M": 0.11590278148651,
    "CMY_Y": 0.14268177747726,
    "CMYK_C": 0,
    "CMYK_M": 0.0135762616992,
    "CMYK_Y": 0.04345469176769,
    "CMYK_K": 0.10373485088348
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089007",
    "Farbtonhilfsbezeichnung": "Y08 90 07 Cremeweiss",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "210",
    "Y": 76,
    "L": 89.4290924072266,
    "a": 0.63705593347549,
    "b": 6.92993974685669,
    "C": 6.95915985107422,
    "h": 84.7476654052734,
    "CMY_C": 0.09123533964157,
    "CMY_M": 0.12153494358063,
    "CMY_Y": 0.17648160457611,
    "CMYK_C": 0,
    "CMYK_M": 0.03334153071046,
    "CMYK_Y": 0.09380455315113,
    "CMYK_K": 0.09123533964157
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089010",
    "Farbtonhilfsbezeichnung": "Y08 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "226",
    "Bcolor": "206",
    "Y": 76,
    "L": 90.3017196655273,
    "a": 0.88033366203308,
    "b": 10.310733795166,
    "C": 10.3482475280762,
    "h": 85.1199035644531,
    "CMY_C": 0.06953454017639,
    "CMY_M": 0.11330765485764,
    "CMY_Y": 0.19195634126663,
    "CMYK_C": 0,
    "CMYK_M": 0.04704431816936,
    "CMYK_Y": 0.13157048821449,
    "CMYK_K": 0.06953454017639
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089020",
    "Farbtonhilfsbezeichnung": "Y08 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "223",
    "Bcolor": "186",
    "Y": 76,
    "L": 89.4626235961914,
    "a": 1.44991827011108,
    "b": 19.6411209106445,
    "C": 19.6945648193359,
    "h": 85.7780532836914,
    "CMY_C": 0.04974639415741,
    "CMY_M": 0.12626814842224,
    "CMY_Y": 0.27016270160675,
    "CMYK_C": 0,
    "CMYK_M": 0.08052771538496,
    "CMYK_Y": 0.23195524513721,
    "CMYK_K": 0.04974639415741
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089025",
    "Farbtonhilfsbezeichnung": "Y08 90 25",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "223",
    "Bcolor": "177",
    "Y": 76,
    "L": 89.7046585083008,
    "a": 2.30875444412231,
    "b": 24.9737110137939,
    "C": 25.0802040100098,
    "h": 84.7181701660156,
    "CMY_C": 0.02820813655853,
    "CMY_M": 0.12685912847519,
    "CMY_Y": 0.3072304725647,
    "CMYK_C": 0,
    "CMYK_M": 0.10151452571154,
    "CMYK_Y": 0.28712150454521,
    "CMYK_K": 0.02820813655853
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089030",
    "Farbtonhilfsbezeichnung": "Y08 90 30",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "224",
    "Bcolor": "169",
    "Y": 76,
    "L": 90.1866226196289,
    "a": 2.69918870925903,
    "b": 29.4577236175537,
    "C": 29.5811271667481,
    "h": 84.7646484375,
    "CMY_C": 0.01012468338013,
    "CMY_M": 0.12341892719269,
    "CMY_Y": 0.33575183153152,
    "CMYK_C": 0,
    "CMYK_M": 0.11445304751396,
    "CMYK_Y": 0.32895773649216,
    "CMYK_K": 0.01012468338013
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089107",
    "Farbtonhilfsbezeichnung": "Y08 91 07 Elfenbeinweiss",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "229",
    "Bcolor": "214",
    "Y": 78,
    "L": 91.1267013549805,
    "a": 0.71034252643585,
    "b": 7.36152076721191,
    "C": 7.39571332931519,
    "h": 84.4883651733398,
    "CMY_C": 0.07033640146255,
    "CMY_M": 0.10294526815414,
    "CMY_Y": 0.16112732887268,
    "CMYK_C": 0,
    "CMYK_M": 0.03507598489523,
    "CMYK_Y": 0.0976599752903,
    "CMYK_K": 0.07033640146255
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089220",
    "Farbtonhilfsbezeichnung": "Y08 92 20",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "194",
    "Y": 81,
    "L": 91.8317565917969,
    "a": 1.44871175289154,
    "b": 19.0008983612061,
    "C": 19.0560455322266,
    "h": 85.6399536132813,
    "CMY_C": 0.0244078040123,
    "CMY_M": 0.09978199005127,
    "CMY_Y": 0.23997986316681,
    "CMYK_C": 0,
    "CMYK_M": 0.07725992798805,
    "CMYK_Y": 0.22096534073353,
    "CMYK_K": 0.0244078040123
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089303",
    "Farbtonhilfsbezeichnung": "Y08 93 03 Ruegener Kreide",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "226",
    "Y": 83,
    "L": 92.5815124511719,
    "a": 0.32180386781693,
    "b": 3.13449335098267,
    "C": 3.1509690284729,
    "h": 84.1382446289063,
    "CMY_C": 0.07042384147644,
    "CMY_M": 0.0846192240715,
    "CMY_Y": 0.11380928754807,
    "CMYK_C": 0,
    "CMYK_M": 0.01527081150562,
    "CMYK_Y": 0.04667228832841,
    "CMYK_K": 0.07042384147644
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089305",
    "Farbtonhilfsbezeichnung": "Y08 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 83,
    "L": 93.1955261230469,
    "a": 0.41124561429024,
    "b": 4.96283626556396,
    "C": 4.97984600067139,
    "h": 85.2630081176758,
    "CMY_C": 0.05689209699631,
    "CMY_M": 0.07846730947495,
    "CMY_Y": 0.12061852216721,
    "CMYK_C": 0,
    "CMYK_M": 0.02287671715021,
    "CMYK_Y": 0.06757066398859,
    "CMYK_K": 0.05689209699631
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089310",
    "Farbtonhilfsbezeichnung": "Y08 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "234",
    "Bcolor": "214",
    "Y": 83,
    "L": 93.0856704711914,
    "a": 0.8427791595459,
    "b": 9.98053359985352,
    "C": 10.0160531997681,
    "h": 85.1732635498047,
    "CMY_C": 0.0393905043602,
    "CMY_M": 0.08207768201828,
    "CMY_Y": 0.15914517641068,
    "CMYK_C": 0,
    "CMYK_M": 0.04443759843707,
    "CMYK_Y": 0.12466529756784,
    "CMYK_K": 0.0393905043602
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089406",
    "Farbtonhilfsbezeichnung": "Y08 94 06 Bianco Carrara",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "237",
    "Bcolor": "226",
    "Y": 85,
    "L": 94.0075454711914,
    "a": 0.49858209490776,
    "b": 5.24951028823853,
    "C": 5.27313423156738,
    "h": 84.5745010375977,
    "CMY_C": 0.04615026712418,
    "CMY_M": 0.06965273618698,
    "CMY_Y": 0.11377590894699,
    "CMYK_C": 0,
    "CMYK_M": 0.02463959343731,
    "CMYK_Y": 0.0708975866437,
    "CMYK_K": 0.04615026712418
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y089407",
    "Farbtonhilfsbezeichnung": "Y08 94 07 Alabasterweiss",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "236",
    "Bcolor": "222",
    "Y": 85,
    "L": 93.7035446166992,
    "a": 0.75035500526428,
    "b": 7.09810256958008,
    "C": 7.13765335083008,
    "h": 83.9655609130859,
    "CMY_C": 0.04182308912277,
    "CMY_M": 0.07417058944702,
    "CMY_Y": 0.13088119029999,
    "CMYK_C": 0,
    "CMYK_M": 0.03375942260027,
    "CMYK_Y": 0.09294536709785,
    "CMYK_K": 0.04182308912277
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y093815",
    "Farbtonhilfsbezeichnung": "Y09 38 15 Umbra Gruen Dunkel",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "88",
    "Bcolor": "65",
    "Y": 9,
    "L": 38.2195281982422,
    "a": 2.67924475669861,
    "b": 15.213080406189,
    "C": 15.4472055435181,
    "h": 80.0118103027344,
    "CMY_C": 0.59609436988831,
    "CMY_M": 0.65565204620361,
    "CMY_Y": 0.74542504549026,
    "CMYK_C": 0,
    "CMYK_M": 0.14745444059372,
    "CMYK_Y": 0.36971673369408,
    "CMYK_K": 0.59609436988831
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y095010",
    "Farbtonhilfsbezeichnung": "Y09 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "118",
    "Bcolor": "102",
    "Y": 18,
    "L": 50.1240692138672,
    "a": 1.70059180259705,
    "b": 9.99745750427246,
    "C": 10.1410636901856,
    "h": 80.3462524414063,
    "CMY_C": 0.49428516626358,
    "CMY_M": 0.53805291652679,
    "CMY_Y": 0.60167980194092,
    "CMYK_C": 0,
    "CMYK_M": 0.08654630184174,
    "CMYK_Y": 0.21236205101013,
    "CMYK_K": 0.49428516626358
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y095030",
    "Farbtonhilfsbezeichnung": "Y09 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 18,
    "L": 49.4368553161621,
    "a": 4.91084671020508,
    "b": 29.8367919921875,
    "C": 30.2382297515869,
    "h": 80.6534729003906,
    "CMY_C": 0.44674170017242,
    "CMY_M": 0.5554706454277,
    "CMY_Y": 0.74140250682831,
    "CMYK_C": 0,
    "CMYK_M": 0.19652473926544,
    "CMYK_Y": 0.53259176015854,
    "CMYK_K": 0.44674170017242
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y096010",
    "Farbtonhilfsbezeichnung": "Y09 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "144",
    "Bcolor": "127",
    "Y": 28,
    "L": 60.3586235046387,
    "a": 1.68272149562836,
    "b": 9.98966789245605,
    "C": 10.1304006576538,
    "h": 80.4384994506836,
    "CMY_C": 0.38946783542633,
    "CMY_M": 0.43519252538681,
    "CMY_Y": 0.50175076723099,
    "CMYK_C": 0,
    "CMYK_M": 0.07489316910505,
    "CMYK_Y": 0.18390993773937,
    "CMYK_K": 0.38946783542633
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y096020",
    "Farbtonhilfsbezeichnung": "Y09 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "142",
    "Bcolor": "110",
    "Y": 28,
    "L": 60.2155609130859,
    "a": 3.30297136306763,
    "b": 19.6407833099365,
    "C": 19.9165763854981,
    "h": 80.4539489746094,
    "CMY_C": 0.35891103744507,
    "CMY_M": 0.44236248731613,
    "CMY_Y": 0.56917011737823,
    "CMYK_C": 0,
    "CMYK_M": 0.13017140328884,
    "CMYK_Y": 0.32797175645828,
    "CMYK_K": 0.35891103744507
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097010",
    "Farbtonhilfsbezeichnung": "Y09 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "169",
    "Bcolor": "151",
    "Y": 41,
    "L": 69.8699264526367,
    "a": 1.8239334821701,
    "b": 10.2250118255615,
    "C": 10.3864145278931,
    "h": 79.8859786987305,
    "CMY_C": 0.28736740350723,
    "CMY_M": 0.33683317899704,
    "CMY_Y": 0.40722227096558,
    "CMYK_C": 0,
    "CMYK_M": 0.06941273063421,
    "CMYK_Y": 0.16818605363369,
    "CMYK_K": 0.28736740350723
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097030",
    "Farbtonhilfsbezeichnung": "Y09 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "165",
    "Bcolor": "114",
    "Y": 41,
    "L": 69.4553909301758,
    "a": 5.27993535995483,
    "b": 29.9712104797363,
    "C": 30.432731628418,
    "h": 80.0088958740234,
    "CMY_C": 0.22688376903534,
    "CMY_M": 0.35341030359268,
    "CMY_Y": 0.55119121074677,
    "CMYK_C": 0,
    "CMYK_M": 0.16365784406662,
    "CMYK_Y": 0.41948083043098,
    "CMYK_K": 0.22688376903534
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097040",
    "Farbtonhilfsbezeichnung": "Y09 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "167",
    "Bcolor": "101",
    "Y": 41,
    "L": 70.6466598510742,
    "a": 6.85698843002319,
    "b": 39.0175895690918,
    "C": 39.615535736084,
    "h": 80.0325698852539,
    "CMY_C": 0.18952769041061,
    "CMY_M": 0.34625667333603,
    "CMY_Y": 0.60577642917633,
    "CMYK_C": 0,
    "CMYK_M": 0.19337981939316,
    "CMYK_Y": 0.51358783245087,
    "CMYK_K": 0.18952769041061
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097367",
    "Farbtonhilfsbezeichnung": "Y09 73 67",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "169",
    "Bcolor": "46",
    "Y": 45,
    "L": 73.1564559936523,
    "a": 11.6960048675537,
    "b": 66.5102310180664,
    "C": 67.5307846069336,
    "h": 80.0263519287109,
    "CMY_C": 0.10173827409744,
    "CMY_M": 0.33554571866989,
    "CMY_Y": 0.81845933198929,
    "CMYK_C": 0,
    "CMYK_M": 0.26028877496719,
    "CMYK_Y": 0.79789781570435,
    "CMYK_K": 0.10173827409744
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097525",
    "Farbtonhilfsbezeichnung": "Y09 75 25",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "179",
    "Bcolor": "136",
    "Y": 48,
    "L": 74.492301940918,
    "a": 4.55047464370728,
    "b": 25.0738468170166,
    "C": 25.4834175109863,
    "h": 79.713752746582,
    "CMY_C": 0.18455654382706,
    "CMY_M": 0.29755914211273,
    "CMY_Y": 0.46542382240295,
    "CMYK_C": 0,
    "CMYK_M": 0.13857808709145,
    "CMYK_Y": 0.34443500638008,
    "CMYK_K": 0.18455654382706
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y097960",
    "Farbtonhilfsbezeichnung": "Y09 79 60",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "187",
    "Bcolor": "79",
    "Y": 55,
    "L": 79.171989440918,
    "a": 10.3447294235229,
    "b": 59.9555816650391,
    "C": 60.8414764404297,
    "h": 80.210578918457,
    "CMY_C": 0.04345136880875,
    "CMY_M": 0.26758033037186,
    "CMY_Y": 0.68889141082764,
    "CMYK_C": 0,
    "CMYK_M": 0.23431006073952,
    "CMYK_Y": 0.67475926876068,
    "CMYK_K": 0.04345136880875
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098005",
    "Farbtonhilfsbezeichnung": "Y09 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "197",
    "Bcolor": "187",
    "Y": 57,
    "L": 79.8410186767578,
    "a": 0.89143985509872,
    "b": 4.89785099029541,
    "C": 4.97831392288208,
    "h": 79.6847152709961,
    "CMY_C": 0.20142370462418,
    "CMY_M": 0.2267746925354,
    "CMY_Y": 0.26503700017929,
    "CMYK_C": 0,
    "CMYK_M": 0.03174522891641,
    "CMYK_Y": 0.07965838164091,
    "CMYK_K": 0.20142370462418
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098010",
    "Farbtonhilfsbezeichnung": "Y09 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "197",
    "Bcolor": "179",
    "Y": 57,
    "L": 79.9338302612305,
    "a": 1.7478438615799,
    "b": 9.59346389770508,
    "C": 9.75138473510742,
    "h": 79.6744689941406,
    "CMY_C": 0.18041062355042,
    "CMY_M": 0.22898632287979,
    "CMY_Y": 0.29779666662216,
    "CMYK_C": 0,
    "CMYK_M": 0.05926833674312,
    "CMYK_Y": 0.14322543144226,
    "CMYK_K": 0.18041062355042
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098020",
    "Farbtonhilfsbezeichnung": "Y09 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "195",
    "Bcolor": "160",
    "Y": 57,
    "L": 79.7362670898438,
    "a": 3.29046368598938,
    "b": 19.4945068359375,
    "C": 19.7702541351318,
    "h": 80.4193954467773,
    "CMY_C": 0.14655882120132,
    "CMY_M": 0.23712778091431,
    "CMY_Y": 0.3713281750679,
    "CMYK_C": 0,
    "CMYK_M": 0.10612209141254,
    "CMYK_Y": 0.26336830854416,
    "CMYK_K": 0.14655882120132
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098030",
    "Farbtonhilfsbezeichnung": "Y09 80 30",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "193",
    "Bcolor": "143",
    "Y": 57,
    "L": 79.9333267211914,
    "a": 5.17193603515625,
    "b": 29.1787338256836,
    "C": 29.6335525512695,
    "h": 79.9487075805664,
    "CMY_C": 0.11123842000961,
    "CMY_M": 0.24157643318176,
    "CMY_Y": 0.43984073400497,
    "CMYK_C": 0,
    "CMYK_M": 0.14665126800537,
    "CMYK_Y": 0.36973056197166,
    "CMYK_K": 0.11123842000961
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098050",
    "Farbtonhilfsbezeichnung": "Y09 80 50",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "191",
    "Bcolor": "105",
    "Y": 57,
    "L": 80.293586730957,
    "a": 8.60309410095215,
    "b": 49.0948371887207,
    "C": 49.8429145812988,
    "h": 80.0607376098633,
    "CMY_C": 0.05337089300156,
    "CMY_M": 0.24964511394501,
    "CMY_Y": 0.58710372447968,
    "CMYK_C": 0,
    "CMYK_M": 0.20734015107155,
    "CMYK_Y": 0.56382465362549,
    "CMYK_K": 0.05337089300156
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098235",
    "Farbtonhilfsbezeichnung": "Y09 82 35",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "200",
    "Bcolor": "139",
    "Y": 60,
    "L": 82.4590606689453,
    "a": 6.06972455978394,
    "b": 34.733943939209,
    "C": 35.2602958679199,
    "h": 80.0877075195313,
    "CMY_C": 0.06621122360229,
    "CMY_M": 0.21751588582993,
    "CMY_Y": 0.45512437820435,
    "CMYK_C": 0,
    "CMYK_M": 0.16203306615353,
    "CMYK_Y": 0.41648942232132,
    "CMYK_K": 0.06621122360229
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098250",
    "Farbtonhilfsbezeichnung": "Y09 82 50",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "196",
    "Bcolor": "109",
    "Y": 60,
    "L": 81.9863510131836,
    "a": 8.67774295806885,
    "b": 49.2741928100586,
    "C": 50.0324821472168,
    "h": 80.0119857788086,
    "CMY_C": 0.03269100189209,
    "CMY_M": 0.23161315917969,
    "CMY_Y": 0.5713564157486,
    "CMYK_C": 0,
    "CMYK_M": 0.20564489066601,
    "CMYK_Y": 0.55687004327774,
    "CMYK_K": 0.03269100189209
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098315",
    "Farbtonhilfsbezeichnung": "Y09 83 15",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "203",
    "Bcolor": "177",
    "Y": 62,
    "L": 82.6986312866211,
    "a": 2.82762622833252,
    "b": 14.891791343689,
    "C": 15.1578664779663,
    "h": 79.2487716674805,
    "CMY_C": 0.12793189287186,
    "CMY_M": 0.20281040668488,
    "CMY_Y": 0.30682730674744,
    "CMYK_C": 0,
    "CMYK_M": 0.08586315065622,
    "CMYK_Y": 0.20513926446438,
    "CMYK_K": 0.12793189287186
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098445",
    "Farbtonhilfsbezeichnung": "Y09 84 45",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "202",
    "Bcolor": "123",
    "Y": 64,
    "L": 83.8632354736328,
    "a": 8.1175012588501,
    "b": 44.8225212097168,
    "C": 45.551643371582,
    "h": 79.7348175048828,
    "CMY_C": 0.02031672000885,
    "CMY_M": 0.2091588973999,
    "CMY_Y": 0.51734751462936,
    "CMYK_C": 0,
    "CMYK_M": 0.19275839626789,
    "CMYK_Y": 0.50733822584152,
    "CMYK_K": 0.02031672000885
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098510",
    "Farbtonhilfsbezeichnung": "Y09 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "191",
    "Y": 66,
    "L": 84.7225189208984,
    "a": 1.81973624229431,
    "b": 10.141881942749,
    "C": 10.3038444519043,
    "h": 79.8277816772461,
    "CMY_C": 0.1254209280014,
    "CMY_M": 0.17711013555527,
    "CMY_Y": 0.2507700920105,
    "CMYK_C": 0,
    "CMYK_M": 0.05910181254148,
    "CMYK_Y": 0.14332513511181,
    "CMYK_K": 0.1254209280014
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098517",
    "Farbtonhilfsbezeichnung": "Y09 85 17 Elfenbein Hell",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "210",
    "Bcolor": "181",
    "Y": 66,
    "L": 84.9277420043945,
    "a": 2.10718441009521,
    "b": 15.9522161483765,
    "C": 16.0907878875732,
    "h": 82.4751663208008,
    "CMY_C": 0.10545814037323,
    "CMY_M": 0.17697304487228,
    "CMY_Y": 0.2910897731781,
    "CMYK_C": 0,
    "CMYK_M": 0.07994584739208,
    "CMYK_Y": 0.20751586556435,
    "CMYK_K": 0.10545814037323
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098520",
    "Farbtonhilfsbezeichnung": "Y09 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "209",
    "Bcolor": "175",
    "Y": 66,
    "L": 85.1445999145508,
    "a": 3.61402487754822,
    "b": 19.2366752624512,
    "C": 19.5732173919678,
    "h": 79.3597793579102,
    "CMY_C": 0.08420389890671,
    "CMY_M": 0.17899715900421,
    "CMY_Y": 0.31267714500427,
    "CMYK_C": 0,
    "CMYK_M": 0.1035091355443,
    "CMYK_Y": 0.24948047101498,
    "CMYK_K": 0.08420389890671
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098530",
    "Farbtonhilfsbezeichnung": "Y09 85 30",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "209",
    "Bcolor": "156",
    "Y": 66,
    "L": 85.3782196044922,
    "a": 5.05447006225586,
    "b": 29.8785514831543,
    "C": 30.3030605316162,
    "h": 80.3983383178711,
    "CMY_C": 0.04846054315567,
    "CMY_M": 0.18225532770157,
    "CMY_Y": 0.38882571458817,
    "CMYK_C": 0,
    "CMYK_M": 0.1406087577343,
    "CMYK_Y": 0.35769948363304,
    "CMYK_K": 0.04846054315567
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098540",
    "Farbtonhilfsbezeichnung": "Y09 85 40",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "206",
    "Bcolor": "137",
    "Y": 66,
    "L": 84.9153823852539,
    "a": 6.92964172363281,
    "b": 39.0163688659668,
    "C": 39.6269721984863,
    "h": 79.9288024902344,
    "CMY_C": 0.02475792169571,
    "CMY_M": 0.19371455907822,
    "CMY_Y": 0.46213668584824,
    "CMYK_C": 0,
    "CMYK_M": 0.17324584722519,
    "CMYK_Y": 0.44848224520683,
    "CMYK_K": 0.02475792169571
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098560",
    "Farbtonhilfsbezeichnung": "Y09 85 60",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "97",
    "Y": 66,
    "L": 84.634407043457,
    "a": 10.216269493103,
    "b": 58.5225639343262,
    "C": 59.4075965881348,
    "h": 80.0976791381836,
    "CMY_C": 0,
    "CMY_M": 0.20818626880646,
    "CMY_Y": 0.61994457244873,
    "CMYK_C": 0,
    "CMYK_M": 0.20818626880646,
    "CMYK_Y": 0.61994457244873,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098625",
    "Farbtonhilfsbezeichnung": "Y09 86 25",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "212",
    "Bcolor": "168",
    "Y": 68,
    "L": 86.2155838012695,
    "a": 4.43401050567627,
    "b": 24.4894218444824,
    "C": 24.8875923156738,
    "h": 79.7373123168945,
    "CMY_C": 0.05432885885239,
    "CMY_M": 0.170425593853,
    "CMY_Y": 0.34006345272064,
    "CMYK_C": 0,
    "CMYK_M": 0.12276650220156,
    "CMYK_Y": 0.30215007066727,
    "CMYK_K": 0.05432885885239
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098635",
    "Farbtonhilfsbezeichnung": "Y09 86 35",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "209",
    "Bcolor": "149",
    "Y": 68,
    "L": 85.9421310424805,
    "a": 5.81672048568726,
    "b": 34.330940246582,
    "C": 34.8202209472656,
    "h": 80.3836517333984,
    "CMY_C": 0.02835208177567,
    "CMY_M": 0.17884469032288,
    "CMY_Y": 0.41624444723129,
    "CMYK_C": 0,
    "CMYK_M": 0.15488389134407,
    "CMYK_Y": 0.39921081066132,
    "CMYK_K": 0.02835208177567
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098813",
    "Farbtonhilfsbezeichnung": "Y09 88 13 Champagner Kreide",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "220",
    "Bcolor": "197",
    "Y": 72,
    "L": 88.3286285400391,
    "a": 1.71885824203491,
    "b": 12.4761409759522,
    "C": 12.5939893722534,
    "h": 82.155647277832,
    "CMY_C": 0.0793462395668,
    "CMY_M": 0.1377477645874,
    "CMY_Y": 0.22918885946274,
    "CMYK_C": 0,
    "CMYK_M": 0.06343483924866,
    "CMYK_Y": 0.16275675594807,
    "CMYK_K": 0.0793462395668
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y098830",
    "Farbtonhilfsbezeichnung": "Y09 88 30",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "214",
    "Bcolor": "161",
    "Y": 72,
    "L": 87.3658905029297,
    "a": 5.24132299423218,
    "b": 29.8976974487305,
    "C": 30.353645324707,
    "h": 80.0566024780273,
    "CMY_C": 0.0242663025856,
    "CMY_M": 0.16091680526733,
    "CMY_Y": 0.36818796396255,
    "CMYK_C": 0,
    "CMYK_M": 0.14004898071289,
    "CMYK_Y": 0.35247492790222,
    "CMYK_K": 0.0242663025856
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099005",
    "Farbtonhilfsbezeichnung": "Y09 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 76,
    "L": 90.2888717651367,
    "a": 0.8990769982338,
    "b": 4.73015689849854,
    "C": 4.81484413146973,
    "h": 79.2379760742188,
    "CMY_C": 0.08646500110626,
    "CMY_M": 0.11201322078705,
    "CMY_Y": 0.15078800916672,
    "CMYK_C": 0,
    "CMYK_M": 0.02796632796526,
    "CMYK_Y": 0.07041110098362,
    "CMYK_K": 0.08646500110626
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099010",
    "Farbtonhilfsbezeichnung": "Y09 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "225",
    "Bcolor": "207",
    "Y": 76,
    "L": 89.9763793945313,
    "a": 1.72489786148071,
    "b": 9.44464778900146,
    "C": 9.60086727142334,
    "h": 79.6500015258789,
    "CMY_C": 0.06937193870544,
    "CMY_M": 0.11872673034668,
    "CMY_Y": 0.1889483332634,
    "CMYK_C": 0,
    "CMYK_M": 0.05303385108709,
    "CMYK_Y": 0.12849000096321,
    "CMYK_K": 0.06937193870544
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099020",
    "Farbtonhilfsbezeichnung": "Y09 90 20",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "222",
    "Bcolor": "188",
    "Y": 76,
    "L": 89.6801605224609,
    "a": 3.4487681388855,
    "b": 19.1846179962158,
    "C": 19.4921417236328,
    "h": 79.8089370727539,
    "CMY_C": 0.03404593467712,
    "CMY_M": 0.12860661745071,
    "CMY_Y": 0.26408952474594,
    "CMYK_C": 0,
    "CMYK_M": 0.09789355844259,
    "CMYK_Y": 0.23815168440342,
    "CMYK_K": 0.03404593467712
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099030",
    "Farbtonhilfsbezeichnung": "Y09 90 30",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "222",
    "Bcolor": "170",
    "Y": 76,
    "L": 90.054573059082,
    "a": 5.18054437637329,
    "b": 28.9675884246826,
    "C": 29.4271850585938,
    "h": 79.8604507446289,
    "CMY_C": 0,
    "CMY_M": 0.13090687990189,
    "CMY_Y": 0.33295023441315,
    "CMYK_C": 0,
    "CMYK_M": 0.13090687990189,
    "CMYK_Y": 0.33295023441315,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099115",
    "Farbtonhilfsbezeichnung": "Y09 91 15",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "226",
    "Bcolor": "198",
    "Y": 78,
    "L": 90.7363510131836,
    "a": 2.64943933486938,
    "b": 15.0031700134277,
    "C": 15.2353086471558,
    "h": 79.9852752685547,
    "CMY_C": 0.03848749399185,
    "CMY_M": 0.113929271698,
    "CMY_Y": 0.22178560495377,
    "CMYK_C": 0,
    "CMYK_M": 0.0784615650773,
    "CMYK_Y": 0.19063517451286,
    "CMYK_K": 0.03848749399185
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y099310",
    "Farbtonhilfsbezeichnung": "Y09 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "233",
    "Bcolor": "214",
    "Y": 83,
    "L": 92.8294525146484,
    "a": 1.73035299777985,
    "b": 10.0241317749023,
    "C": 10.172381401062,
    "h": 80.206184387207,
    "CMY_C": 0.03545033931732,
    "CMY_M": 0.08709943294525,
    "CMY_Y": 0.1621356010437,
    "CMYK_C": 0,
    "CMYK_M": 0.05354736745358,
    "CMYK_Y": 0.13134135305882,
    "CMYK_K": 0.03545033931732
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y104010",
    "Farbtonhilfsbezeichnung": "Y10 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "92",
    "Bcolor": "78",
    "Y": 11,
    "L": 39.8017616271973,
    "a": 2.4530131816864,
    "b": 9.63000106811523,
    "C": 9.93751430511475,
    "h": 75.7091827392578,
    "CMY_C": 0.59266090393066,
    "CMY_M": 0.63924616575241,
    "CMY_Y": 0.69574117660522,
    "CMYK_C": 0,
    "CMYK_M": 0.11436481773853,
    "CMYK_Y": 0.25305765867233,
    "CMYK_K": 0.59266090393066
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y104020",
    "Farbtonhilfsbezeichnung": "Y10 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "92",
    "Bcolor": "63",
    "Y": 11,
    "L": 40.4091682434082,
    "a": 5.08846092224121,
    "b": 19.4212837219238,
    "C": 20.0768203735352,
    "h": 75.3182678222656,
    "CMY_C": 0.5537029504776,
    "CMY_M": 0.64100217819214,
    "CMY_Y": 0.75255393981934,
    "CMYK_C": 0,
    "CMYK_M": 0.19560790061951,
    "CMYK_Y": 0.44555747509003,
    "CMYK_K": 0.5537029504776
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y105005",
    "Farbtonhilfsbezeichnung": "Y10 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "118",
    "Bcolor": "109",
    "Y": 18,
    "L": 49.8070945739746,
    "a": 1.23427963256836,
    "b": 5.30292320251465,
    "C": 5.44467067718506,
    "h": 76.8974304199219,
    "CMY_C": 0.51206964254379,
    "CMY_M": 0.53911995887756,
    "CMY_Y": 0.57389754056931,
    "CMYK_C": 0,
    "CMYK_M": 0.05543888732791,
    "CMYK_Y": 0.12671460211277,
    "CMYK_K": 0.51206964254379
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y106010",
    "Farbtonhilfsbezeichnung": "Y10 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "142",
    "Bcolor": "126",
    "Y": 28,
    "L": 59.8609199523926,
    "a": 2.62793111801147,
    "b": 10.1420316696167,
    "C": 10.4769668579102,
    "h": 75.4734039306641,
    "CMY_C": 0.38792502880096,
    "CMY_M": 0.44243156909943,
    "CMY_Y": 0.50759363174438,
    "CMYK_C": 0,
    "CMYK_M": 0.08905206620693,
    "CMYK_Y": 0.1955129802227,
    "CMYK_K": 0.38792502880096
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y106020",
    "Farbtonhilfsbezeichnung": "Y10 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "140",
    "Bcolor": "109",
    "Y": 28,
    "L": 59.8225936889648,
    "a": 5.27171516418457,
    "b": 19.8687934875488,
    "C": 20.5562629699707,
    "h": 75.1402969360352,
    "CMY_C": 0.35018020868301,
    "CMY_M": 0.4509539604187,
    "CMY_Y": 0.57420969009399,
    "CMYK_C": 0,
    "CMYK_M": 0.15507952868938,
    "CMYK_Y": 0.34475633502007,
    "CMYK_K": 0.35018020868301
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y106050",
    "Farbtonhilfsbezeichnung": "Y10 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "135",
    "Bcolor": "55",
    "Y": 28,
    "L": 60.2156753540039,
    "a": 12.8192939758301,
    "b": 48.902530670166,
    "C": 50.5548400878906,
    "h": 75.3110122680664,
    "CMY_C": 0.26205348968506,
    "CMY_M": 0.46995943784714,
    "CMY_Y": 0.78326565027237,
    "CMYK_C": 0,
    "CMYK_M": 0.28173580765724,
    "CMYK_Y": 0.70630073547363,
    "CMYK_K": 0.26205348968506
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y106505",
    "Farbtonhilfsbezeichnung": "Y10 65 05",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "156",
    "Bcolor": "147",
    "Y": 34,
    "L": 64.8190841674805,
    "a": 1.31738913059235,
    "b": 4.96946048736572,
    "C": 5.14111375808716,
    "h": 75.1525802612305,
    "CMY_C": 0.35878986120224,
    "CMY_M": 0.38720893859863,
    "CMY_Y": 0.42236715555191,
    "CMYK_C": 0,
    "CMYK_M": 0.04432100430131,
    "CMYK_Y": 0.0991520434618,
    "CMYK_K": 0.35878986120224
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y106515",
    "Farbtonhilfsbezeichnung": "Y10 65 15",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "155",
    "Bcolor": "131",
    "Y": 34,
    "L": 65.3607788085938,
    "a": 4.08098173141479,
    "b": 14.9681673049927,
    "C": 15.5145235061646,
    "h": 74.7493133544922,
    "CMY_C": 0.30878835916519,
    "CMY_M": 0.39026808738708,
    "CMY_Y": 0.48577862977982,
    "CMYK_C": 0,
    "CMYK_M": 0.11787956953049,
    "CMYK_Y": 0.25605800747871,
    "CMYK_K": 0.30878835916519
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107010",
    "Farbtonhilfsbezeichnung": "Y10 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "169",
    "Bcolor": "153",
    "Y": 41,
    "L": 69.9948043823242,
    "a": 2.57132601737976,
    "b": 9.52818775177002,
    "C": 9.86904621124268,
    "h": 74.8976287841797,
    "CMY_C": 0.28262823820114,
    "CMY_M": 0.33707368373871,
    "CMY_Y": 0.40092766284943,
    "CMYK_C": 0,
    "CMYK_M": 0.07589571923018,
    "CMYK_Y": 0.16490672528744,
    "CMYK_K": 0.28262823820114
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107020",
    "Farbtonhilfsbezeichnung": "Y10 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "168",
    "Bcolor": "136",
    "Y": 41,
    "L": 70.4054183959961,
    "a": 5.29978227615356,
    "b": 19.6719284057617,
    "C": 20.373327255249,
    "h": 74.9220275878906,
    "CMY_C": 0.23581200838089,
    "CMY_M": 0.34147369861603,
    "CMY_Y": 0.46790659427643,
    "CMYK_C": 0,
    "CMYK_M": 0.13826662302017,
    "CMYK_Y": 0.30371400713921,
    "CMYK_K": 0.23581200838089
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107040",
    "Farbtonhilfsbezeichnung": "Y10 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "163",
    "Bcolor": "99",
    "Y": 41,
    "L": 69.9906692504883,
    "a": 10.3657264709473,
    "b": 38.8793106079102,
    "C": 40.2374076843262,
    "h": 75.0714569091797,
    "CMY_C": 0.17569041252136,
    "CMY_M": 0.36183822154999,
    "CMY_Y": 0.61024689674377,
    "CMYK_C": 0,
    "CMYK_M": 0.22582268714905,
    "CMYK_Y": 0.52717632055283,
    "CMYK_K": 0.17569041252136
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107161",
    "Farbtonhilfsbezeichnung": "Y10 71 61 Neapelgelb Dunkel",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "164",
    "Bcolor": "61",
    "Y": 42,
    "L": 71.8103256225586,
    "a": 15.202467918396,
    "b": 59.7466850280762,
    "C": 61.6504783630371,
    "h": 75.7241058349609,
    "CMY_C": 0.10294735431671,
    "CMY_M": 0.35821539163589,
    "CMY_Y": 0.76138770580292,
    "CMYK_C": 0,
    "CMYK_M": 0.2845630645752,
    "CMYK_Y": 0.73400413990021,
    "CMYK_K": 0.10294735431671
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107505",
    "Farbtonhilfsbezeichnung": "Y10 75 05",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "184",
    "Bcolor": "175",
    "Y": 48,
    "L": 75.1960830688477,
    "a": 1.30229246616364,
    "b": 4.75062036514282,
    "C": 4.92588663101196,
    "h": 74.6700439453125,
    "CMY_C": 0.24920159578323,
    "CMY_M": 0.27771300077438,
    "CMY_Y": 0.3131777048111,
    "CMYK_C": 0,
    "CMYK_M": 0.03797478228807,
    "CMYK_Y": 0.08521077036858,
    "CMYK_K": 0.24920159578323
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107510",
    "Farbtonhilfsbezeichnung": "Y10 75 10",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "182",
    "Bcolor": "165",
    "Y": 48,
    "L": 74.7660827636719,
    "a": 2.49092626571655,
    "b": 9.459716796875,
    "C": 9.78217506408691,
    "h": 75.2477874755859,
    "CMY_C": 0.23187828063965,
    "CMY_M": 0.28627228736877,
    "CMY_Y": 0.35103577375412,
    "CMYK_C": 0,
    "CMYK_M": 0.07081430405378,
    "CMYK_Y": 0.1551284044981,
    "CMYK_K": 0.23187828063965
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107515",
    "Farbtonhilfsbezeichnung": "Y10 75 15",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "181",
    "Bcolor": "156",
    "Y": 48,
    "L": 74.8138580322266,
    "a": 3.91241073608398,
    "b": 14.6552629470825,
    "C": 15.1685094833374,
    "h": 75.0527420043945,
    "CMY_C": 0.20813530683517,
    "CMY_M": 0.29035997390747,
    "CMY_Y": 0.38737297058105,
    "CMYK_C": 0,
    "CMYK_M": 0.10383676737547,
    "CMYK_Y": 0.2263488471508,
    "CMYK_K": 0.20813530683517
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y107565",
    "Farbtonhilfsbezeichnung": "Y10 75 65",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "172",
    "Bcolor": "64",
    "Y": 48,
    "L": 75.136100769043,
    "a": 15.886923789978,
    "b": 62.2238578796387,
    "C": 64.2199554443359,
    "h": 75.6772918701172,
    "CMY_C": 0.05684226751328,
    "CMY_M": 0.32539123296738,
    "CMY_Y": 0.74940550327301,
    "CMYK_C": 0,
    "CMYK_M": 0.28473389148712,
    "CMYK_Y": 0.73430263996124,
    "CMYK_K": 0.05684226751328
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108010",
    "Farbtonhilfsbezeichnung": "Y10 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 57,
    "L": 80.0840911865234,
    "a": 2.62606143951416,
    "b": 9.62669944763184,
    "C": 9.97845363616943,
    "h": 74.741569519043,
    "CMY_C": 0.17230159044266,
    "CMY_M": 0.22944289445877,
    "CMY_Y": 0.29631125926971,
    "CMYK_C": 0,
    "CMYK_M": 0.06903637945652,
    "CMYK_Y": 0.14982470870018,
    "CMYK_K": 0.17230159044266
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108020",
    "Farbtonhilfsbezeichnung": "Y10 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "195",
    "Bcolor": "163",
    "Y": 57,
    "L": 80.3753204345703,
    "a": 5.19223403930664,
    "b": 19.1948585510254,
    "C": 19.8847141265869,
    "h": 74.8636627197266,
    "CMY_C": 0.12699949741364,
    "CMY_M": 0.23474812507629,
    "CMY_Y": 0.36215668916702,
    "CMYK_C": 0,
    "CMYK_M": 0.12342333048582,
    "CMYK_Y": 0.26936662197113,
    "CMYK_K": 0.12699949741364
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108030",
    "Farbtonhilfsbezeichnung": "Y10 80 30 Gelber Ocker Hell",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "192",
    "Bcolor": "143",
    "Y": 57,
    "L": 80.0514221191406,
    "a": 8.07769012451172,
    "b": 29.2839221954346,
    "C": 30.3775768280029,
    "h": 74.5789947509766,
    "CMY_C": 0.09053409099579,
    "CMY_M": 0.2475226521492,
    "CMY_Y": 0.43879836797714,
    "CMYK_C": 0,
    "CMYK_M": 0.1726162135601,
    "CMYK_Y": 0.38293275237083,
    "CMYK_K": 0.09053409099579
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108051",
    "Farbtonhilfsbezeichnung": "Y10 80 51",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "189",
    "Bcolor": "106",
    "Y": 57,
    "L": 80.2201080322266,
    "a": 12.4060935974121,
    "b": 48.8390159606934,
    "C": 50.3900833129883,
    "h": 75.7471771240234,
    "CMY_C": 0.03094798326492,
    "CMY_M": 0.26022118330002,
    "CMY_Y": 0.58461785316467,
    "CMYK_C": 0,
    "CMYK_M": 0.23659534752369,
    "CMYK_Y": 0.57135206460953,
    "CMYK_K": 0.03094798326492
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108060",
    "Farbtonhilfsbezeichnung": "Y10 80 60",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "186",
    "Bcolor": "88",
    "Y": 57,
    "L": 80.1255493164063,
    "a": 15.1648626327515,
    "b": 57.5709266662598,
    "C": 59.5347366333008,
    "h": 75.2428359985352,
    "CMY_C": 0.00526237487793,
    "CMY_M": 0.26980900764465,
    "CMY_Y": 0.65626049041748,
    "CMYK_C": 0,
    "CMYK_M": 0.26594614982605,
    "CMYK_Y": 0.65444201231003,
    "CMYK_K": 0.00526237487793
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108216",
    "Farbtonhilfsbezeichnung": "Y10 82 16 Savonniere",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "201",
    "Bcolor": "174",
    "Y": 60,
    "L": 82.262321472168,
    "a": 3.68874287605286,
    "b": 15.6806039810181,
    "C": 16.1086368560791,
    "h": 76.7622909545898,
    "CMY_C": 0.12471139431,
    "CMY_M": 0.20981955528259,
    "CMY_Y": 0.31704145669937,
    "CMYK_C": 0,
    "CMYK_M": 0.0972343981266,
    "CMYK_Y": 0.21973331272602,
    "CMYK_K": 0.12471139431
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108505",
    "Farbtonhilfsbezeichnung": "Y10 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "211",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.0665512084961,
    "a": 1.4474390745163,
    "b": 5.01818943023682,
    "C": 5.22276782989502,
    "h": 73.910400390625,
    "CMY_C": 0.13947343826294,
    "CMY_M": 0.17111027240753,
    "CMY_Y": 0.20969104766846,
    "CMYK_C": 0,
    "CMYK_M": 0.03676450625062,
    "CMYK_Y": 0.08159842342138,
    "CMYK_K": 0.13947343826294
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108510",
    "Farbtonhilfsbezeichnung": "Y10 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "210",
    "Bcolor": "193",
    "Y": 66,
    "L": 85.0724029541016,
    "a": 2.60010504722595,
    "b": 9.61053848266602,
    "C": 9.95605278015137,
    "h": 74.8612060546875,
    "CMY_C": 0.11728900671005,
    "CMY_M": 0.17500340938568,
    "CMY_Y": 0.24301248788834,
    "CMYK_C": 0,
    "CMYK_M": 0.06538312137127,
    "CMYK_Y": 0.14242881536484,
    "CMYK_K": 0.11728900671005
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108520",
    "Farbtonhilfsbezeichnung": "Y10 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "209",
    "Bcolor": "175",
    "Y": 66,
    "L": 85.2485427856445,
    "a": 5.06330442428589,
    "b": 19.3678665161133,
    "C": 20.0187740325928,
    "h": 75.3491668701172,
    "CMY_C": 0.0725604891777,
    "CMY_M": 0.18143177032471,
    "CMY_Y": 0.31228816509247,
    "CMYK_C": 0,
    "CMYK_M": 0.11738909035921,
    "CMYK_Y": 0.25848335027695,
    "CMYK_K": 0.0725604891777
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108528",
    "Farbtonhilfsbezeichnung": "Y10 85 28",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "207",
    "Bcolor": "161",
    "Y": 66,
    "L": 85.4040679931641,
    "a": 7.49760103225708,
    "b": 27.4627475738525,
    "C": 28.4678153991699,
    "h": 74.7298126220703,
    "CMY_C": 0.03649866580963,
    "CMY_M": 0.1875706911087,
    "CMY_Y": 0.37005180120468,
    "CMYK_C": 0,
    "CMYK_M": 0.15679483115673,
    "CMYK_Y": 0.34618854522705,
    "CMYK_K": 0.03649866580963
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108540",
    "Farbtonhilfsbezeichnung": "Y10 85 40",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "136",
    "Y": 66,
    "L": 83.3414764404297,
    "a": 9.56172943115234,
    "b": 37.5651626586914,
    "C": 38.7629737854004,
    "h": 75.719352722168,
    "CMY_C": 0.02841931581497,
    "CMY_M": 0.21726649999619,
    "CMY_Y": 0.46661478281021,
    "CMYK_C": 0,
    "CMYK_M": 0.1943710744381,
    "CMYK_Y": 0.45101293921471,
    "CMYK_K": 0.02841931581497
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y108713",
    "Farbtonhilfsbezeichnung": "Y10 87 13 Alba Albula",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "215",
    "Bcolor": "193",
    "Y": 70,
    "L": 87.1284790039063,
    "a": 3.44302034378052,
    "b": 12.4872875213623,
    "C": 12.9532518386841,
    "h": 74.5852966308594,
    "CMY_C": 0.08019238710403,
    "CMY_M": 0.15516418218613,
    "CMY_Y": 0.24190527200699,
    "CMYK_C": 0,
    "CMYK_M": 0.08150812983513,
    "CMYK_Y": 0.17581163346767,
    "CMYK_K": 0.08019238710403
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109010",
    "Farbtonhilfsbezeichnung": "Y10 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "225",
    "Bcolor": "207",
    "Y": 76,
    "L": 90.089241027832,
    "a": 2.35056114196777,
    "b": 9.37959289550781,
    "C": 9.66963768005371,
    "h": 75.9312057495117,
    "CMY_C": 0.06360912322998,
    "CMY_M": 0.11896693706512,
    "CMY_Y": 0.1871429681778,
    "CMYK_C": 0,
    "CMYK_M": 0.05911827459931,
    "CMYK_Y": 0.13192550837994,
    "CMYK_K": 0.06360912322998
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109018",
    "Farbtonhilfsbezeichnung": "Y10 90 18",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "223",
    "Bcolor": "191",
    "Y": 76,
    "L": 89.8707122802734,
    "a": 3.96262669563293,
    "b": 17.5141792297363,
    "C": 17.9568614959717,
    "h": 77.251335144043,
    "CMY_C": 0.03233975172043,
    "CMY_M": 0.12736052274704,
    "CMY_Y": 0.24954152107239,
    "CMYK_C": 0,
    "CMYK_M": 0.09819641709328,
    "CMYK_Y": 0.22446078062057,
    "CMYK_K": 0.03233975172043
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109025",
    "Farbtonhilfsbezeichnung": "Y10 90 25",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "179",
    "Y": 76,
    "L": 90.0560607910156,
    "a": 6.52188539505005,
    "b": 24.1563587188721,
    "C": 25.0212841033936,
    "h": 74.8911590576172,
    "CMY_C": 0,
    "CMY_M": 0.13321030139923,
    "CMY_Y": 0.2965852022171,
    "CMYK_C": 0,
    "CMYK_M": 0.13321030139923,
    "CMYK_Y": 0.2965852022171,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109030",
    "Farbtonhilfsbezeichnung": "Y10 90 30",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "169",
    "Y": 76,
    "L": 89.3906707763672,
    "a": 7.88250732421875,
    "b": 28.9100723266602,
    "C": 29.9654159545898,
    "h": 74.7486724853516,
    "CMY_C": 0,
    "CMY_M": 0.14504277706146,
    "CMY_Y": 0.33896988630295,
    "CMYK_C": 0,
    "CMYK_M": 0.14504277706146,
    "CMYK_Y": 0.33896988630295,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109305",
    "Farbtonhilfsbezeichnung": "Y10 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "223",
    "Y": 83,
    "L": 93.1037673950195,
    "a": 1.35177552700043,
    "b": 5.25882863998413,
    "C": 5.42978620529175,
    "h": 75.5842819213867,
    "CMY_C": 0.04970127344131,
    "CMY_M": 0.08183807134628,
    "CMY_Y": 0.12369602918625,
    "CMYK_C": 0,
    "CMYK_M": 0.03381757438183,
    "CMYK_Y": 0.07786472886801,
    "CMYK_K": 0.04970127344131
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y109310",
    "Farbtonhilfsbezeichnung": "Y10 93 10",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "233",
    "Bcolor": "215",
    "Y": 83,
    "L": 92.8977890014648,
    "a": 2.12914204597473,
    "b": 9.5118522644043,
    "C": 9.74723434448242,
    "h": 77.3828430175781,
    "CMY_C": 0.03316897153854,
    "CMY_M": 0.08716922998428,
    "CMY_Y": 0.15750938653946,
    "CMYK_C": 0,
    "CMYK_M": 0.05585283786058,
    "CMYK_Y": 0.12860615551472,
    "CMYK_K": 0.03316897153854
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y115010",
    "Farbtonhilfsbezeichnung": "Y11 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "116",
    "Bcolor": "101",
    "Y": 18,
    "L": 49.7356986999512,
    "a": 3.36337828636169,
    "b": 9.62105274200439,
    "C": 10.1920051574707,
    "h": 70.7311248779297,
    "CMY_C": 0.4884130358696,
    "CMY_M": 0.54542815685272,
    "CMY_Y": 0.60266304016113,
    "CMYK_C": 0,
    "CMYK_M": 0.11144756525755,
    "CMYK_Y": 0.22332470118999,
    "CMYK_K": 0.4884130358696
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y115030",
    "Farbtonhilfsbezeichnung": "Y11 50 30",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "111",
    "Bcolor": "70",
    "Y": 18,
    "L": 49.8613548278809,
    "a": 10.3699083328247,
    "b": 28.4401721954346,
    "C": 30.2717418670654,
    "h": 69.9670333862305,
    "CMY_C": 0.41293197870255,
    "CMY_M": 0.56399220228195,
    "CMY_Y": 0.72639125585556,
    "CMYK_C": 0,
    "CMYK_M": 0.25731298327446,
    "CMYK_Y": 0.53394031524658,
    "CMYK_K": 0.41293197870255
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y116005",
    "Farbtonhilfsbezeichnung": "Y11 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "143",
    "Bcolor": "134",
    "Y": 28,
    "L": 59.8227424621582,
    "a": 1.75042033195496,
    "b": 5.05011796951294,
    "C": 5.34487247467041,
    "h": 70.883186340332,
    "CMY_C": 0.40751087665558,
    "CMY_M": 0.4396458864212,
    "CMY_Y": 0.47343707084656,
    "CMYK_C": 0,
    "CMYK_M": 0.05423729866743,
    "CMYK_Y": 0.11126988381147,
    "CMYK_K": 0.40751087665558
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y116020",
    "Farbtonhilfsbezeichnung": "Y11 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "140",
    "Bcolor": "110",
    "Y": 28,
    "L": 60.1323776245117,
    "a": 6.88752937316895,
    "b": 19.2741355895996,
    "C": 20.4677886962891,
    "h": 70.3358688354492,
    "CMY_C": 0.33786857128143,
    "CMY_M": 0.45149022340775,
    "CMY_Y": 0.56679332256317,
    "CMYK_C": 0,
    "CMYK_M": 0.17159985005856,
    "CMYK_Y": 0.34573912620544,
    "CMYK_K": 0.33786857128143
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y116152",
    "Farbtonhilfsbezeichnung": "Y11 61 52 Goldocker",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "134",
    "Bcolor": "57",
    "Y": 29,
    "L": 60.8632469177246,
    "a": 17.4350662231445,
    "b": 48.9439544677734,
    "C": 51.9566383361816,
    "h": 70.392822265625,
    "CMY_C": 0.22872984409332,
    "CMY_M": 0.47565948963165,
    "CMY_Y": 0.7752583026886,
    "CMYK_C": 0,
    "CMYK_M": 0.32015973329544,
    "CMYK_Y": 0.70860832929611,
    "CMYK_K": 0.22872984409332
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y116540",
    "Farbtonhilfsbezeichnung": "Y11 65 40",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "148",
    "Bcolor": "90",
    "Y": 34,
    "L": 65.1523361206055,
    "a": 13.4192600250244,
    "b": 37.7324447631836,
    "C": 40.0476455688477,
    "h": 70.4224548339844,
    "CMY_C": 0.21417313814163,
    "CMY_M": 0.41967111825943,
    "CMY_Y": 0.64801037311554,
    "CMYK_C": 0,
    "CMYK_M": 0.26150542497635,
    "CMYK_Y": 0.55207735300064,
    "CMYK_K": 0.21417313814163
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117010",
    "Farbtonhilfsbezeichnung": "Y11 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "168",
    "Bcolor": "152",
    "Y": 41,
    "L": 69.7414855957031,
    "a": 3.34760355949402,
    "b": 9.41418933868408,
    "C": 9.99166679382324,
    "h": 70.4250564575195,
    "CMY_C": 0.28023719787598,
    "CMY_M": 0.34151512384415,
    "CMY_Y": 0.40261280536652,
    "CMYK_C": 0,
    "CMYK_M": 0.08513627946377,
    "CMYK_Y": 0.17002213001251,
    "CMYK_K": 0.28023719787598
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117020",
    "Farbtonhilfsbezeichnung": "Y11 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "167",
    "Bcolor": "137",
    "Y": 41,
    "L": 70.2438354492188,
    "a": 6.88412427902222,
    "b": 18.7217044830322,
    "C": 19.947265625,
    "h": 69.8111114501953,
    "CMY_C": 0.22917431592941,
    "CMY_M": 0.34678518772125,
    "CMY_Y": 0.4625146985054,
    "CMYK_C": 0,
    "CMYK_M": 0.15257778763771,
    "CMYK_Y": 0.30271485447884,
    "CMYK_K": 0.22917431592941
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117030",
    "Farbtonhilfsbezeichnung": "Y11 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "163",
    "Bcolor": "118",
    "Y": 41,
    "L": 69.7824020385742,
    "a": 10.3680810928345,
    "b": 28.4535751342773,
    "C": 30.2837085723877,
    "h": 69.9789733886719,
    "CMY_C": 0.19380831718445,
    "CMY_M": 0.36221659183502,
    "CMY_Y": 0.53587830066681,
    "CMYK_C": 0,
    "CMYK_M": 0.20889359712601,
    "CMYK_Y": 0.42430353164673,
    "CMYK_K": 0.19380831718445
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117040",
    "Farbtonhilfsbezeichnung": "Y11 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "163",
    "Bcolor": "105",
    "Y": 41,
    "L": 70.9396514892578,
    "a": 13.6996917724609,
    "b": 37.342041015625,
    "C": 39.7757415771484,
    "h": 69.853401184082,
    "CMY_C": 0.14672994613647,
    "CMY_M": 0.36025583744049,
    "CMY_Y": 0.58855330944061,
    "CMYK_C": 0,
    "CMYK_M": 0.25024420022964,
    "CMYK_Y": 0.51780015230179,
    "CMYK_K": 0.14672994613647
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117050",
    "Farbtonhilfsbezeichnung": "Y11 70 50 Gelber Ocker",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "158",
    "Bcolor": "85",
    "Y": 41,
    "L": 69.86474609375,
    "a": 16.9822006225586,
    "b": 46.5478401184082,
    "C": 49.5489311218262,
    "h": 69.9563446044922,
    "CMY_C": 0.12846374511719,
    "CMY_M": 0.38167858123779,
    "CMY_Y": 0.66817736625671,
    "CMYK_C": 0,
    "CMYK_M": 0.29053848981857,
    "CMYK_Y": 0.61926698684692,
    "CMYK_K": 0.12846374511719
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117645",
    "Farbtonhilfsbezeichnung": "Y11 76 45",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "176",
    "Bcolor": "108",
    "Y": 50,
    "L": 76.2930068969727,
    "a": 15.1160821914673,
    "b": 42.7156143188477,
    "C": 45.3113632202148,
    "h": 70.5122909545898,
    "CMY_C": 0.0686309337616,
    "CMY_M": 0.30841600894928,
    "CMY_Y": 0.57554823160172,
    "CMYK_C": 0,
    "CMYK_M": 0.25745442509651,
    "CMYK_Y": 0.54427111148834,
    "CMYK_K": 0.0686309337616
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y117939",
    "Farbtonhilfsbezeichnung": "Y11 79 39",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "185",
    "Bcolor": "127",
    "Y": 55,
    "L": 78.9411163330078,
    "a": 13.05930519104,
    "b": 36.2872009277344,
    "C": 38.5656127929688,
    "h": 70.2068405151367,
    "CMY_C": 0.05952996015549,
    "CMY_M": 0.27358943223953,
    "CMY_Y": 0.50094985961914,
    "CMYK_C": 0,
    "CMYK_M": 0.22760902345181,
    "CMYK_Y": 0.46936094760895,
    "CMYK_K": 0.05952996015549
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118005",
    "Farbtonhilfsbezeichnung": "Y11 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "197",
    "Bcolor": "188",
    "Y": 57,
    "L": 79.8626403808594,
    "a": 1.74982821941376,
    "b": 4.70274019241333,
    "C": 5.01773500442505,
    "h": 69.5904235839844,
    "CMY_C": 0.19538229703903,
    "CMY_M": 0.22849702835083,
    "CMY_Y": 0.26327711343765,
    "CMYK_C": 0,
    "CMYK_M": 0.04115585610271,
    "CMYK_Y": 0.08438146114349,
    "CMYK_K": 0.19538229703903
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118010",
    "Farbtonhilfsbezeichnung": "Y11 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "197",
    "Bcolor": "181",
    "Y": 57,
    "L": 80.3842697143555,
    "a": 3.38146710395813,
    "b": 9.37551784515381,
    "C": 9.96667766571045,
    "h": 70.1671524047852,
    "CMY_C": 0.16423314809799,
    "CMY_M": 0.22792685031891,
    "CMY_Y": 0.29119998216629,
    "CMYK_C": 0,
    "CMYK_M": 0.07620989531279,
    "CMYK_Y": 0.15191656351089,
    "CMYK_K": 0.16423314809799
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118020",
    "Farbtonhilfsbezeichnung": "Y11 80 20",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "193",
    "Bcolor": "162",
    "Y": 57,
    "L": 79.8502349853516,
    "a": 6.99822235107422,
    "b": 18.9101905822754,
    "C": 20.1635913848877,
    "h": 69.6916580200195,
    "CMY_C": 0.12121188640594,
    "CMY_M": 0.24479383230209,
    "CMY_Y": 0.36523795127869,
    "CMYK_C": 0,
    "CMYK_M": 0.14062769711018,
    "CMYK_Y": 0.27768474817276,
    "CMYK_K": 0.12121188640594
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118030",
    "Farbtonhilfsbezeichnung": "Y11 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "190",
    "Bcolor": "146",
    "Y": 57,
    "L": 80.0189514160156,
    "a": 10.2722253799438,
    "b": 27.8062229156494,
    "C": 29.642951965332,
    "h": 69.7246704101563,
    "CMY_C": 0.07933497428894,
    "CMY_M": 0.253138422966,
    "CMY_Y": 0.4277948141098,
    "CMYK_C": 0,
    "CMYK_M": 0.1887803375721,
    "CMYK_Y": 0.37848711013794,
    "CMYK_K": 0.07933497428894
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118055",
    "Farbtonhilfsbezeichnung": "Y11 80 55",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "184",
    "Bcolor": "102",
    "Y": 57,
    "L": 80.2202682495117,
    "a": 18.6924839019775,
    "b": 51.232852935791,
    "C": 54.5363578796387,
    "h": 69.9553298950195,
    "CMY_C": 0,
    "CMY_M": 0.27760571241379,
    "CMY_Y": 0.60165214538574,
    "CMYK_C": 0,
    "CMYK_M": 0.27760571241379,
    "CMYK_Y": 0.60165214538574,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118315",
    "Farbtonhilfsbezeichnung": "Y11 83 15",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "202",
    "Bcolor": "179",
    "Y": 62,
    "L": 82.8204879760742,
    "a": 5.15795707702637,
    "b": 13.8314733505249,
    "C": 14.7619161605835,
    "h": 69.5487823486328,
    "CMY_C": 0.11274075508118,
    "CMY_M": 0.20686793327332,
    "CMY_Y": 0.29742455482483,
    "CMYK_C": 0,
    "CMYK_M": 0.10608757287264,
    "CMYK_Y": 0.20815089344978,
    "CMYK_K": 0.11274075508118
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118329",
    "Farbtonhilfsbezeichnung": "Y11 83 29",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "199",
    "Bcolor": "155",
    "Y": 62,
    "L": 83.0467987060547,
    "a": 10.2081604003906,
    "b": 27.0911235809326,
    "C": 28.9505710601807,
    "h": 69.3531723022461,
    "CMY_C": 0.04631853103638,
    "CMY_M": 0.22007727622986,
    "CMY_Y": 0.39128464460373,
    "CMYK_C": 0,
    "CMYK_M": 0.18219788372517,
    "CMYK_Y": 0.36172047257423,
    "CMYK_K": 0.04631853103638
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118510",
    "Farbtonhilfsbezeichnung": "Y11 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "193",
    "Y": 66,
    "L": 85.087028503418,
    "a": 3.43397903442383,
    "b": 9.53484630584717,
    "C": 10.1343727111816,
    "h": 70.193489074707,
    "CMY_C": 0.11123073101044,
    "CMY_M": 0.17683160305023,
    "CMY_Y": 0.24217313528061,
    "CMYK_C": 0,
    "CMYK_M": 0.0738109126687,
    "CMYK_Y": 0.14733003079891,
    "CMYK_K": 0.11123073101044
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118525",
    "Farbtonhilfsbezeichnung": "Y11 85 25",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "205",
    "Bcolor": "168",
    "Y": 66,
    "L": 84.8916244506836,
    "a": 8.46075439453125,
    "b": 22.6608943939209,
    "C": 24.188850402832,
    "h": 69.5261993408203,
    "CMY_C": 0.04586237668991,
    "CMY_M": 0.19456517696381,
    "CMY_Y": 0.33968544006348,
    "CMYK_C": 0,
    "CMYK_M": 0.15585047006607,
    "CMYK_Y": 0.30794620513916,
    "CMYK_K": 0.04586237668991
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118720",
    "Farbtonhilfsbezeichnung": "Y11 87 20",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "211",
    "Bcolor": "181",
    "Y": 70,
    "L": 86.6231231689453,
    "a": 6.90452003479004,
    "b": 18.641357421875,
    "C": 19.8789482116699,
    "h": 69.6760177612305,
    "CMY_C": 0.04581207036972,
    "CMY_M": 0.1707581281662,
    "CMY_Y": 0.29204553365707,
    "CMYK_C": 0,
    "CMYK_M": 0.13094492256641,
    "CMYK_Y": 0.25805550813675,
    "CMYK_K": 0.04581207036972
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y118830",
    "Farbtonhilfsbezeichnung": "Y11 88 30",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "213",
    "Bcolor": "168",
    "Y": 72,
    "L": 88.2209243774414,
    "a": 10.1936111450195,
    "b": 27.630163192749,
    "C": 29.4505615234375,
    "h": 69.7494430541992,
    "CMY_C": 0,
    "CMY_M": 0.16359686851501,
    "CMY_Y": 0.34122806787491,
    "CMYK_C": 0,
    "CMYK_M": 0.16359686851501,
    "CMYK_Y": 0.34122806787491,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y119005",
    "Farbtonhilfsbezeichnung": "Y11 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "225",
    "Bcolor": "216",
    "Y": 76,
    "L": 90.1132583618164,
    "a": 1.7195508480072,
    "b": 4.59317874908447,
    "C": 4.90450286865234,
    "h": 69.4755783081055,
    "CMY_C": 0.08256250619888,
    "CMY_M": 0.11589467525482,
    "CMY_Y": 0.15158063173294,
    "CMYK_C": 0,
    "CMYK_M": 0.03633181378245,
    "CMYK_Y": 0.07522924244404,
    "CMYK_K": 0.08256250619888
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y119010",
    "Farbtonhilfsbezeichnung": "Y11 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "224",
    "Bcolor": "208",
    "Y": 76,
    "L": 89.9249954223633,
    "a": 3.1705207824707,
    "b": 8.7894926071167,
    "C": 9.34384155273438,
    "h": 70.1647567749023,
    "CMY_C": 0.06105244159698,
    "CMY_M": 0.12262630462646,
    "CMY_Y": 0.18443816900253,
    "CMYK_C": 0,
    "CMYK_M": 0.06557752937078,
    "CMYK_Y": 0.13140854239464,
    "CMYK_K": 0.06105244159698
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y123313",
    "Farbtonhilfsbezeichnung": "Y12 33 13 Umbra Natur Cyprisch",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "74",
    "Bcolor": "58",
    "Y": 8,
    "L": 32.8855400085449,
    "a": 5.45270538330078,
    "b": 11.9310140609741,
    "C": 13.1179685592651,
    "h": 65.4386749267578,
    "CMY_C": 0.63781094551086,
    "CMY_M": 0.71023637056351,
    "CMY_Y": 0.7714661359787,
    "CMYK_C": 0,
    "CMYK_M": 0.19996580481529,
    "CMYK_Y": 0.36902052164078,
    "CMYK_K": 0.63781094551086
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y125239",
    "Farbtonhilfsbezeichnung": "Y12 52 39 Terra Di Siena Natur",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "111",
    "Bcolor": "62",
    "Y": 20,
    "L": 51.6140022277832,
    "a": 16.2066879272461,
    "b": 35.2009429931641,
    "C": 38.7525901794434,
    "h": 65.2784271240234,
    "CMY_C": 0.35373210906982,
    "CMY_M": 0.56275373697281,
    "CMY_Y": 0.7565336227417,
    "CMYK_C": 0,
    "CMYK_M": 0.32342877984047,
    "CMYK_Y": 0.6232733130455,
    "CMYK_K": 0.35373210906982
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y125645",
    "Farbtonhilfsbezeichnung": "Y12 56 45 Amberger Gelb",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "120",
    "Bcolor": "61",
    "Y": 24,
    "L": 55.6927299499512,
    "a": 18.8477592468262,
    "b": 41.1123390197754,
    "C": 45.2267875671387,
    "h": 65.3711318969727,
    "CMY_C": 0.28758978843689,
    "CMY_M": 0.53043860197067,
    "CMY_Y": 0.76167166233063,
    "CMYK_C": 0,
    "CMYK_M": 0.34088340401649,
    "CMYK_Y": 0.66546195745468,
    "CMYK_K": 0.28758978843689
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y126010",
    "Farbtonhilfsbezeichnung": "Y12 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "142",
    "Bcolor": "127",
    "Y": 28,
    "L": 60.0312881469727,
    "a": 4.22452688217163,
    "b": 9.31747055053711,
    "C": 10.2304391860962,
    "h": 65.6105270385742,
    "CMY_C": 0.37751072645187,
    "CMY_M": 0.44413417577744,
    "CMY_Y": 0.50003790855408,
    "CMYK_C": 0,
    "CMYK_M": 0.10702746361494,
    "CMYK_Y": 0.19683420658112,
    "CMYK_K": 0.37751072645187
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y126921",
    "Farbtonhilfsbezeichnung": "Y12 69 21",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "161",
    "Bcolor": "133",
    "Y": 39,
    "L": 68.7795562744141,
    "a": 8.77923488616943,
    "b": 19.0421772003174,
    "C": 20.9685344696045,
    "h": 65.2483291625977,
    "CMY_C": 0.23232632875443,
    "CMY_M": 0.36683547496796,
    "CMY_Y": 0.47920233011246,
    "CMYK_C": 0,
    "CMYK_M": 0.17521657049656,
    "CMYK_Y": 0.32158976793289,
    "CMYK_K": 0.23232632875443
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y127040",
    "Farbtonhilfsbezeichnung": "Y12 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "158",
    "Bcolor": "104",
    "Y": 41,
    "L": 69.7929840087891,
    "a": 16.9210910797119,
    "b": 36.6306915283203,
    "C": 40.3501052856445,
    "h": 65.2060165405273,
    "CMY_C": 0.14166116714478,
    "CMY_M": 0.38071584701538,
    "CMY_Y": 0.59371596574783,
    "CMYK_C": 0,
    "CMYK_M": 0.27850851416588,
    "CMYK_Y": 0.52666240930557,
    "CMYK_K": 0.14166116714478
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y128010",
    "Farbtonhilfsbezeichnung": "Y12 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "195",
    "Bcolor": "180",
    "Y": 57,
    "L": 79.7744522094727,
    "a": 4.34145355224609,
    "b": 9.04348659515381,
    "C": 10.0315933227539,
    "h": 64.3560104370117,
    "CMY_C": 0.16497594118118,
    "CMY_M": 0.23674565553665,
    "CMY_Y": 0.29511839151382,
    "CMYK_C": 0,
    "CMYK_M": 0.08594927936792,
    "CMYK_Y": 0.15585473179817,
    "CMYK_K": 0.16497594118118
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y128030",
    "Farbtonhilfsbezeichnung": "Y12 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "188",
    "Bcolor": "146",
    "Y": 57,
    "L": 79.5862197875977,
    "a": 12.4929008483887,
    "b": 26.9948577880859,
    "C": 29.7455024719238,
    "h": 65.1658554077148,
    "CMY_C": 0.07143270969391,
    "CMY_M": 0.26336896419525,
    "CMY_Y": 0.42582792043686,
    "CMYK_C": 0,
    "CMYK_M": 0.20670150220394,
    "CMYK_Y": 0.38165807723999,
    "CMYK_K": 0.07143270969391
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y128505",
    "Farbtonhilfsbezeichnung": "Y12 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "210",
    "Bcolor": "202",
    "Y": 66,
    "L": 84.8286437988281,
    "a": 2.18555426597595,
    "b": 4.36007738113403,
    "C": 4.87718391418457,
    "h": 63.3769912719727,
    "CMY_C": 0.13856774568558,
    "CMY_M": 0.17529851198196,
    "CMY_Y": 0.20735436677933,
    "CMYK_C": 0,
    "CMYK_M": 0.04263918101788,
    "CMYK_Y": 0.0798514559865,
    "CMYK_K": 0.13856774568558
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y128520",
    "Farbtonhilfsbezeichnung": "Y12 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "207",
    "Bcolor": "178",
    "Y": 66,
    "L": 85.2743988037109,
    "a": 8.42895698547363,
    "b": 18.1891231536865,
    "C": 20.0472316741943,
    "h": 65.1366882324219,
    "CMY_C": 0.05168306827545,
    "CMY_M": 0.18927127122879,
    "CMY_Y": 0.30275058746338,
    "CMYK_C": 0,
    "CMYK_M": 0.14508673548698,
    "CMYK_Y": 0.26475065946579,
    "CMYK_K": 0.05168306827545
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y129010",
    "Farbtonhilfsbezeichnung": "Y12 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "224",
    "Bcolor": "208",
    "Y": 76,
    "L": 90.1041030883789,
    "a": 4.29186534881592,
    "b": 8.91363143920898,
    "C": 9.89307498931885,
    "h": 64.289436340332,
    "CMY_C": 0.0503516793251,
    "CMY_M": 0.12341511249542,
    "CMY_Y": 0.18323349952698,
    "CMYK_C": 0,
    "CMYK_M": 0.07693735510111,
    "CMYK_Y": 0.13992740213871,
    "CMYK_K": 0.0503516793251
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y129305",
    "Farbtonhilfsbezeichnung": "Y12 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "233",
    "Bcolor": "224",
    "Y": 83,
    "L": 92.7696151733398,
    "a": 2.09981799125671,
    "b": 4.29660129547119,
    "C": 4.78226089477539,
    "h": 63.9544982910156,
    "CMY_C": 0.05074512958527,
    "CMY_M": 0.08711987733841,
    "CMY_Y": 0.1201137304306,
    "CMYK_C": 0,
    "CMYK_M": 0.03831926360726,
    "CMYK_Y": 0.07307689636946,
    "CMYK_K": 0.05074512958527
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y133510",
    "Farbtonhilfsbezeichnung": "Y13 35 10",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "80",
    "Bcolor": "68",
    "Y": 8,
    "L": 35.1780853271484,
    "a": 5.06498670578003,
    "b": 9.05803298950195,
    "C": 10.3779602050781,
    "h": 60.7873573303223,
    "CMY_C": 0.62311708927155,
    "CMY_M": 0.68784248828888,
    "CMY_Y": 0.7335410118103,
    "CMYK_C": 0,
    "CMYK_M": 0.17173874378204,
    "CMYK_Y": 0.29299265146255,
    "CMYK_K": 0.62311708927155
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y134005",
    "Farbtonhilfsbezeichnung": "Y13 40 05",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "94",
    "Bcolor": "87",
    "Y": 11,
    "L": 40.4455757141113,
    "a": 2.47874093055725,
    "b": 4.53805828094482,
    "C": 5.1708927154541,
    "h": 61.3561134338379,
    "CMY_C": 0.59782028198242,
    "CMY_M": 0.63211667537689,
    "CMY_Y": 0.65761590003967,
    "CMYK_C": 0,
    "CMYK_M": 0.08527629077435,
    "CMYK_Y": 0.14867885410786,
    "CMYK_K": 0.59782028198242
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y134020",
    "Farbtonhilfsbezeichnung": "Y13 40 20",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "89",
    "Bcolor": "66",
    "Y": 11,
    "L": 40.3987312316895,
    "a": 10.1230640411377,
    "b": 17.9477252960205,
    "C": 20.6057586669922,
    "h": 60.5756759643555,
    "CMY_C": 0.52794301509857,
    "CMY_M": 0.65243530273438,
    "CMY_Y": 0.74211144447327,
    "CMYK_C": 0,
    "CMYK_M": 0.26372301578522,
    "CMYK_Y": 0.45369189977646,
    "CMYK_K": 0.52794301509857
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y134515",
    "Farbtonhilfsbezeichnung": "Y13 45 15",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "102",
    "Bcolor": "85",
    "Y": 15,
    "L": 45.2510871887207,
    "a": 7.52405786514282,
    "b": 13.2119960784912,
    "C": 15.2042198181152,
    "h": 60.3390579223633,
    "CMY_C": 0.50106453895569,
    "CMY_M": 0.59922611713409,
    "CMY_Y": 0.66772842407227,
    "CMYK_C": 0,
    "CMYK_M": 0.19674204289913,
    "CMYK_Y": 0.33403897285461,
    "CMYK_K": 0.50106453895569
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y135005",
    "Farbtonhilfsbezeichnung": "Y13 50 05",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "119",
    "Bcolor": "111",
    "Y": 18,
    "L": 50.4950294494629,
    "a": 2.50098085403442,
    "b": 4.77724933624268,
    "C": 5.39231109619141,
    "h": 62.3670845031738,
    "CMY_C": 0.49813842773438,
    "CMY_M": 0.53494572639465,
    "CMY_Y": 0.56360840797424,
    "CMYK_C": 0,
    "CMYK_M": 0.07334153354168,
    "CMYK_Y": 0.13045425713062,
    "CMYK_K": 0.49813842773438
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y135010",
    "Farbtonhilfsbezeichnung": "Y13 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "114",
    "Bcolor": "102",
    "Y": 18,
    "L": 49.4900436401367,
    "a": 4.97188234329224,
    "b": 8.93276405334473,
    "C": 10.2232036590576,
    "h": 60.900146484375,
    "CMY_C": 0.48227781057358,
    "CMY_M": 0.55127465724945,
    "CMY_Y": 0.60024607181549,
    "CMYK_C": 0,
    "CMYK_M": 0.1332700252533,
    "CMYK_Y": 0.22786016762257,
    "CMYK_K": 0.48227781057358
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y135140",
    "Farbtonhilfsbezeichnung": "Y13 51 40 Persisch Gelb",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "108",
    "Bcolor": "63",
    "Y": 19,
    "L": 51.2365989685059,
    "a": 19.5739822387695,
    "b": 34.6249809265137,
    "C": 39.7747421264648,
    "h": 60.5199241638184,
    "CMY_C": 0.34037351608276,
    "CMY_M": 0.57557052373886,
    "CMY_Y": 0.75480926036835,
    "CMYK_C": 0,
    "CMYK_M": 0.35656088590622,
    "CMYK_Y": 0.62828850746155,
    "CMYK_K": 0.34037351608276
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y135530",
    "Farbtonhilfsbezeichnung": "Y13 55 30",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "122",
    "Bcolor": "86",
    "Y": 23,
    "L": 55.3339691162109,
    "a": 15.2554225921631,
    "b": 26.6881141662598,
    "C": 30.7405815124512,
    "h": 60.2469139099121,
    "CMY_C": 0.32810205221176,
    "CMY_M": 0.52208995819092,
    "CMY_Y": 0.66218066215515,
    "CMYK_C": 0,
    "CMYK_M": 0.28871631622314,
    "CMYK_Y": 0.49721628427505,
    "CMYK_K": 0.32810205221176
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y135549",
    "Farbtonhilfsbezeichnung": "Y13 55 49",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "115",
    "Bcolor": "59",
    "Y": 23,
    "L": 55.3443145751953,
    "a": 24.0625495910645,
    "b": 41.9850578308105,
    "C": 48.3916473388672,
    "h": 60.1820411682129,
    "CMY_C": 0.2627540230751,
    "CMY_M": 0.54900616407394,
    "CMY_Y": 0.76968306303024,
    "CMYK_C": 0,
    "CMYK_M": 0.38827222585678,
    "CMYK_Y": 0.68759822845459,
    "CMYK_K": 0.2627540230751
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136005",
    "Farbtonhilfsbezeichnung": "Y13 60 05",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "142",
    "Bcolor": "134",
    "Y": 28,
    "L": 59.5298919677734,
    "a": 2.51360869407654,
    "b": 4.54089498519897,
    "C": 5.19017887115479,
    "h": 61.0333137512207,
    "CMY_C": 0.40666323900223,
    "CMY_M": 0.44421297311783,
    "CMY_Y": 0.47281181812286,
    "CMYK_C": 0,
    "CMYK_M": 0.06328570097685,
    "CMYK_Y": 0.11148572713137,
    "CMYK_K": 0.40666323900223
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136010",
    "Farbtonhilfsbezeichnung": "Y13 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "141",
    "Bcolor": "128",
    "Y": 28,
    "L": 59.8022232055664,
    "a": 4.83210611343384,
    "b": 8.49720573425293,
    "C": 9.77505779266357,
    "h": 60.3744049072266,
    "CMY_C": 0.37787985801697,
    "CMY_M": 0.44767427444458,
    "CMY_Y": 0.49664181470871,
    "CMYK_C": 0,
    "CMYK_M": 0.11218800395727,
    "CMYK_Y": 0.19089874625206,
    "CMYK_K": 0.37787985801697
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136020",
    "Farbtonhilfsbezeichnung": "Y13 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "137",
    "Bcolor": "113",
    "Y": 28,
    "L": 59.9551696777344,
    "a": 10.1839838027954,
    "b": 17.7857990264893,
    "C": 20.4950771331787,
    "h": 60.204948425293,
    "CMY_C": 0.32215476036072,
    "CMY_M": 0.46097129583359,
    "CMY_Y": 0.55768036842346,
    "CMYK_C": 0,
    "CMYK_M": 0.20479090511799,
    "CMYK_Y": 0.34746220707893,
    "CMYK_K": 0.32215476036072
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136040",
    "Farbtonhilfsbezeichnung": "Y13 60 40 Satinober Amiata",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "131",
    "Bcolor": "83",
    "Y": 28,
    "L": 60.1780815124512,
    "a": 20.0563926696777,
    "b": 35.0621223449707,
    "C": 40.3932075500488,
    "h": 60.2293853759766,
    "CMY_C": 0.23605531454086,
    "CMY_M": 0.48790299892426,
    "CMY_Y": 0.67428213357925,
    "CMYK_C": 0,
    "CMYK_M": 0.3296674489975,
    "CMYK_Y": 0.57363682985306,
    "CMYK_K": 0.23605531454086
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136050",
    "Farbtonhilfsbezeichnung": "Y13 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "127",
    "Bcolor": "68",
    "Y": 28,
    "L": 60.4718971252441,
    "a": 25.1581172943115,
    "b": 43.3867568969727,
    "C": 50.1531791687012,
    "h": 59.8923988342285,
    "CMY_C": 0.19584512710571,
    "CMY_M": 0.50100827217102,
    "CMY_Y": 0.73158442974091,
    "CMYK_C": 0,
    "CMYK_M": 0.37948304414749,
    "CMYK_Y": 0.6662141084671,
    "CMYK_K": 0.19584512710571
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136259",
    "Farbtonhilfsbezeichnung": "Y13 62 59 Franzoesischer Ocker",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "127",
    "Bcolor": "57",
    "Y": 30,
    "L": 61.9911270141602,
    "a": 29.6475219726563,
    "b": 51.2535171508789,
    "C": 59.2106285095215,
    "h": 59.9528274536133,
    "CMY_C": 0.14702409505844,
    "CMY_M": 0.50054037570953,
    "CMY_Y": 0.77800583839417,
    "CMYK_C": 0,
    "CMYK_M": 0.41445049643517,
    "CMYK_Y": 0.739741563797,
    "CMYK_K": 0.14702409505844
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136515",
    "Farbtonhilfsbezeichnung": "Y13 65 15",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "152",
    "Bcolor": "133",
    "Y": 34,
    "L": 64.7775955200195,
    "a": 7.60804224014282,
    "b": 13.2352571487427,
    "C": 15.2661170959473,
    "h": 60.1083564758301,
    "CMY_C": 0.29577702283859,
    "CMY_M": 0.40427672863007,
    "CMY_Y": 0.47900348901749,
    "CMYK_C": 0,
    "CMYK_M": 0.15407010912895,
    "CMYK_Y": 0.26018247008324,
    "CMYK_K": 0.29577702283859
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y136750",
    "Farbtonhilfsbezeichnung": "Y13 67 50",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "144",
    "Bcolor": "84",
    "Y": 37,
    "L": 66.8977890014648,
    "a": 25.0206604003906,
    "b": 43.5138397216797,
    "C": 50.1944999694824,
    "h": 60.1008987426758,
    "CMY_C": 0.12071055173874,
    "CMY_M": 0.43488955497742,
    "CMY_Y": 0.67095142602921,
    "CMYK_C": 0,
    "CMYK_M": 0.35731011629105,
    "CMYK_Y": 0.62577903270721,
    "CMYK_K": 0.12071055173874
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137005",
    "Farbtonhilfsbezeichnung": "Y13 70 05",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "170",
    "Bcolor": "163",
    "Y": 41,
    "L": 70.2335739135742,
    "a": 2.48433589935303,
    "b": 4.23297500610352,
    "C": 4.90815687179565,
    "h": 59.5912971496582,
    "CMY_C": 0.29534912109375,
    "CMY_M": 0.33302575349808,
    "CMY_Y": 0.36129420995712,
    "CMYK_C": 0,
    "CMYK_M": 0.05346851050854,
    "CMYK_Y": 0.09358547627926,
    "CMYK_K": 0.29534912109375
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137010",
    "Farbtonhilfsbezeichnung": "Y13 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "168",
    "Bcolor": "154",
    "Y": 41,
    "L": 70.0723724365234,
    "a": 5.17605972290039,
    "b": 8.89671325683594,
    "C": 10.2928667068481,
    "h": 59.809383392334,
    "CMY_C": 0.26537537574768,
    "CMY_M": 0.34220880270004,
    "CMY_Y": 0.39529818296432,
    "CMYK_C": 0,
    "CMYK_M": 0.10458868741989,
    "CMYK_Y": 0.17685604095459,
    "CMYK_K": 0.26537537574768
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137020",
    "Farbtonhilfsbezeichnung": "Y13 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "165",
    "Bcolor": "140",
    "Y": 41,
    "L": 70.4084854125977,
    "a": 10.0283851623535,
    "b": 17.353214263916,
    "C": 20.0425186157227,
    "h": 59.9764785766602,
    "CMY_C": 0.20976215600967,
    "CMY_M": 0.35250800848007,
    "CMY_Y": 0.45060461759567,
    "CMYK_C": 0,
    "CMYK_M": 0.1806365698576,
    "CMYK_Y": 0.30477210879326,
    "CMYK_K": 0.20976215600967
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137030",
    "Farbtonhilfsbezeichnung": "Y13 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "159",
    "Bcolor": "122",
    "Y": 41,
    "L": 69.6275939941406,
    "a": 15.3635330200195,
    "b": 26.5238971710205,
    "C": 30.6521663665771,
    "h": 59.919132232666,
    "CMY_C": 0.1679682135582,
    "CMY_M": 0.37639367580414,
    "CMY_Y": 0.5225020647049,
    "CMYK_C": 0,
    "CMYK_M": 0.25050181150436,
    "CMYK_Y": 0.42610612511635,
    "CMYK_K": 0.1679682135582
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137040",
    "Farbtonhilfsbezeichnung": "Y13 70 40",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "158",
    "Bcolor": "110",
    "Y": 41,
    "L": 70.4456176757813,
    "a": 19.6119556427002,
    "b": 34.4280853271484,
    "C": 39.6222381591797,
    "h": 60.3320045471191,
    "CMY_C": 0.12114375829697,
    "CMY_M": 0.38091933727264,
    "CMY_Y": 0.57044076919556,
    "CMYK_C": 0,
    "CMYK_M": 0.29558369517326,
    "CMYK_Y": 0.51122921705246,
    "CMYK_K": 0.12114375829697
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137060",
    "Farbtonhilfsbezeichnung": "Y13 70 60",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "147",
    "Bcolor": "73",
    "Y": 41,
    "L": 69.5098266601563,
    "a": 29.6746368408203,
    "b": 52.3451232910156,
    "C": 60.17138671875,
    "h": 60.4509429931641,
    "CMY_C": 0.05505061149597,
    "CMY_M": 0.4233466386795,
    "CMY_Y": 0.71323925256729,
    "CMYK_C": 0,
    "CMYK_M": 0.38975211977959,
    "CMYK_Y": 0.696533203125,
    "CMYK_K": 0.05505061149597
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137245",
    "Farbtonhilfsbezeichnung": "Y13 72 45",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "158",
    "Bcolor": "104",
    "Y": 44,
    "L": 71.5575790405273,
    "a": 22.5558986663818,
    "b": 39.086856842041,
    "C": 45.1281623840332,
    "h": 60.0119972229004,
    "CMY_C": 0.08475655317307,
    "CMY_M": 0.37846034765244,
    "CMY_Y": 0.59301245212555,
    "CMYK_C": 0,
    "CMYK_M": 0.32090237736702,
    "CMYK_Y": 0.55532318353653,
    "CMYK_K": 0.08475655317307
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137525",
    "Farbtonhilfsbezeichnung": "Y13 75 25",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "175",
    "Bcolor": "143",
    "Y": 48,
    "L": 74.6788558959961,
    "a": 12.8336524963379,
    "b": 22.0416488647461,
    "C": 25.5056247711182,
    "h": 59.7900810241699,
    "CMY_C": 0.13456553220749,
    "CMY_M": 0.31562703847885,
    "CMY_Y": 0.44005638360977,
    "CMYK_C": 0,
    "CMYK_M": 0.20921458303928,
    "CMYK_Y": 0.35299131274223,
    "CMYK_K": 0.13456553220749
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y137940",
    "Farbtonhilfsbezeichnung": "Y13 79 40",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "182",
    "Bcolor": "133",
    "Y": 55,
    "L": 79.3301391601563,
    "a": 19.8243503570557,
    "b": 34.1712036132813,
    "C": 39.5053939819336,
    "h": 59.8799285888672,
    "CMY_C": 0.01624226570129,
    "CMY_M": 0.28740650415421,
    "CMY_Y": 0.47961974143982,
    "CMYK_C": 0,
    "CMYK_M": 0.27564126253128,
    "CMYK_Y": 0.47102802991867,
    "CMYK_K": 0.01624226570129
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138005",
    "Farbtonhilfsbezeichnung": "Y13 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "196",
    "Bcolor": "188",
    "Y": 57,
    "L": 79.6571502685547,
    "a": 2.70983171463013,
    "b": 4.46428537368774,
    "C": 5.22235870361328,
    "h": 58.7421531677246,
    "CMY_C": 0.19123339653015,
    "CMY_M": 0.23292177915573,
    "CMY_Y": 0.26361519098282,
    "CMYK_C": 0,
    "CMYK_M": 0.05154562741518,
    "CMYK_Y": 0.08949651569128,
    "CMYK_K": 0.19123339653015
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138010",
    "Farbtonhilfsbezeichnung": "Y13 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "196",
    "Bcolor": "182",
    "Y": 57,
    "L": 80.2956466674805,
    "a": 5.04381084442139,
    "b": 8.63638591766357,
    "C": 10.0013589859009,
    "h": 59.7142753601074,
    "CMY_C": 0.15530496835709,
    "CMY_M": 0.23269951343536,
    "CMY_Y": 0.2865474820137,
    "CMYK_C": 0,
    "CMYK_M": 0.09162424504757,
    "CMYK_Y": 0.15537266433239,
    "CMYK_K": 0.15530496835709
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138020",
    "Farbtonhilfsbezeichnung": "Y13 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "190",
    "Bcolor": "164",
    "Y": 57,
    "L": 79.5640029907227,
    "a": 10.2929306030273,
    "b": 17.537727355957,
    "C": 20.3351001739502,
    "h": 59.591236114502,
    "CMY_C": 0.10528594255447,
    "CMY_M": 0.25583851337433,
    "CMY_Y": 0.35768800973892,
    "CMYK_C": 0,
    "CMYK_M": 0.16826891899109,
    "CMYK_Y": 0.28210359811783,
    "CMYK_K": 0.10528594255447
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138035",
    "Farbtonhilfsbezeichnung": "Y13 80 35",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "185",
    "Bcolor": "143",
    "Y": 57,
    "L": 79.8521957397461,
    "a": 17.4475498199463,
    "b": 29.5401840209961,
    "C": 34.3080101013184,
    "h": 59.4322967529297,
    "CMY_C": 0.0323394536972,
    "CMY_M": 0.27428787946701,
    "CMY_Y": 0.44070595502853,
    "CMYK_C": 0,
    "CMYK_M": 0.25003439188004,
    "CMYK_Y": 0.42201420664787,
    "CMYK_K": 0.0323394536972
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138429",
    "Farbtonhilfsbezeichnung": "Y13 84 29",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "197",
    "Bcolor": "160",
    "Y": 64,
    "L": 83.5259399414063,
    "a": 14.672381401062,
    "b": 25.0845718383789,
    "C": 29.0605316162109,
    "h": 59.6759300231934,
    "CMY_C": 0.01540446281433,
    "CMY_M": 0.2261443734169,
    "CMY_Y": 0.37061154842377,
    "CMYK_C": 0,
    "CMYK_M": 0.21403703093529,
    "CMYK_Y": 0.36076447367668,
    "CMYK_K": 0.01540446281433
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138505",
    "Farbtonhilfsbezeichnung": "Y13 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "211",
    "Bcolor": "203",
    "Y": 66,
    "L": 85.1468200683594,
    "a": 2.52942037582397,
    "b": 4.11771011352539,
    "C": 4.83254623413086,
    "h": 58.4384918212891,
    "CMY_C": 0.1332038640976,
    "CMY_M": 0.17256247997284,
    "CMY_Y": 0.20209091901779,
    "CMYK_C": 0,
    "CMYK_M": 0.04540700465441,
    "CMYK_Y": 0.07947319000959,
    "CMYK_K": 0.1332038640976
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138510",
    "Farbtonhilfsbezeichnung": "Y13 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "208",
    "Bcolor": "193",
    "Y": 66,
    "L": 84.6080856323242,
    "a": 5.20597553253174,
    "b": 8.81487369537354,
    "C": 10.2373914718628,
    "h": 59.4343338012695,
    "CMY_C": 0.10569870471954,
    "CMY_M": 0.18620264530182,
    "CMY_Y": 0.24178200960159,
    "CMYK_C": 0,
    "CMYK_M": 0.09001880884171,
    "CMYK_Y": 0.15216717123985,
    "CMYK_K": 0.10569870471954
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138525",
    "Farbtonhilfsbezeichnung": "Y13 85 25",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "204",
    "Bcolor": "171",
    "Y": 66,
    "L": 85.3245544433594,
    "a": 12.3357572555542,
    "b": 21.7678966522217,
    "C": 25.0202369689941,
    "h": 60.4599876403809,
    "CMY_C": 0.01670092344284,
    "CMY_M": 0.19962203502655,
    "CMY_Y": 0.3278214931488,
    "CMYK_C": 0,
    "CMYK_M": 0.18602794408798,
    "CMYK_Y": 0.31640481948853,
    "CMYK_K": 0.01670092344284
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y138819",
    "Farbtonhilfsbezeichnung": "Y13 88 19",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "213",
    "Bcolor": "188",
    "Y": 72,
    "L": 87.7783050537109,
    "a": 9.52817535400391,
    "b": 16.3590393066406,
    "C": 18.931568145752,
    "h": 59.7817230224609,
    "CMY_C": 0.01978397369385,
    "CMY_M": 0.16415768861771,
    "CMY_Y": 0.26244413852692,
    "CMYK_C": 0,
    "CMYK_M": 0.14728765189648,
    "CMYK_Y": 0.24755784869194,
    "CMYK_K": 0.01978397369385
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y143005",
    "Farbtonhilfsbezeichnung": "Y14 30 05 Umbra Gebrannt",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "69",
    "Bcolor": "63",
    "Y": 6,
    "L": 29.9380493164063,
    "a": 3.03070068359375,
    "b": 4.44518947601318,
    "C": 5.380042552948,
    "h": 55.7140922546387,
    "CMY_C": 0.69388091564178,
    "CMY_M": 0.73031973838806,
    "CMY_Y": 0.75220370292664,
    "CMYK_C": 0,
    "CMYK_M": 0.1190347969532,
    "CMYK_Y": 0.19052319228649,
    "CMYK_K": 0.69388091564178
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y144010",
    "Farbtonhilfsbezeichnung": "Y14 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "91",
    "Bcolor": "80",
    "Y": 11,
    "L": 39.8559722900391,
    "a": 5.424156665802,
    "b": 8.08007049560547,
    "C": 9.73185539245605,
    "h": 56.1265144348145,
    "CMY_C": 0.57749724388123,
    "CMY_M": 0.644815325737,
    "CMY_Y": 0.68500965833664,
    "CMYK_C": 0,
    "CMYK_M": 0.15933169424534,
    "CMYK_Y": 0.25446557998657,
    "CMYK_K": 0.57749724388123
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y144129",
    "Farbtonhilfsbezeichnung": "Y14 41 29",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "86",
    "Bcolor": "58",
    "Y": 12,
    "L": 41.2652244567871,
    "a": 16.4557323455811,
    "b": 24.1424579620361,
    "C": 29.2172794342041,
    "h": 55.7212791442871,
    "CMY_C": 0.47703301906586,
    "CMY_M": 0.6613467335701,
    "CMY_Y": 0.77340161800385,
    "CMYK_C": 0,
    "CMYK_M": 0.35243853926659,
    "CMYK_Y": 0.56670612096786,
    "CMYK_K": 0.47703301906586
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y145020",
    "Farbtonhilfsbezeichnung": "Y14 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "110",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.6257400512695,
    "a": 11.470175743103,
    "b": 16.4223728179932,
    "C": 20.0314559936523,
    "h": 55.0676956176758,
    "CMY_C": 0.42700946331024,
    "CMY_M": 0.56686174869537,
    "CMY_Y": 0.64723753929138,
    "CMYK_C": 0,
    "CMYK_M": 0.24407432973385,
    "CMYK_Y": 0.38434854149818,
    "CMYK_K": 0.42700946331024
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y145040",
    "Farbtonhilfsbezeichnung": "Y14 50 40",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "104",
    "Bcolor": "64",
    "Y": 18,
    "L": 50.6034889221191,
    "a": 22.7511539459229,
    "b": 33.2422256469727,
    "C": 40.2822608947754,
    "h": 55.6120567321777,
    "CMY_C": 0.3319810628891,
    "CMY_M": 0.59067094326019,
    "CMY_Y": 0.74979150295258,
    "CMYK_C": 0,
    "CMYK_M": 0.38724932074547,
    "CMYK_Y": 0.62544697523117,
    "CMYK_K": 0.3319810628891
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y145536",
    "Farbtonhilfsbezeichnung": "Y14 55 36",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "117",
    "Bcolor": "80",
    "Y": 23,
    "L": 54.9860382080078,
    "a": 20.742280960083,
    "b": 30.0215911865234,
    "C": 36.4902458190918,
    "h": 55.3589363098145,
    "CMY_C": 0.29702430963516,
    "CMY_M": 0.54109525680542,
    "CMY_Y": 0.6872444152832,
    "CMYK_C": 0,
    "CMYK_M": 0.34719684720039,
    "CMYK_Y": 0.55509757995605,
    "CMYK_K": 0.29702430963516
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y146010",
    "Farbtonhilfsbezeichnung": "Y14 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "140",
    "Bcolor": "128",
    "Y": 28,
    "L": 59.5774765014648,
    "a": 5.67289447784424,
    "b": 8.3054666519165,
    "C": 10.057957649231,
    "h": 55.6656951904297,
    "CMY_C": 0.37514561414719,
    "CMY_M": 0.45186656713486,
    "CMY_Y": 0.49745070934296,
    "CMYK_C": 0,
    "CMYK_M": 0.12278213351965,
    "CMYK_Y": 0.19573375582695,
    "CMYK_K": 0.37514561414719
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y146030",
    "Farbtonhilfsbezeichnung": "Y14 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "132",
    "Bcolor": "100",
    "Y": 28,
    "L": 59.9644584655762,
    "a": 17.2783603668213,
    "b": 25.3175640106201,
    "C": 30.6516036987305,
    "h": 55.687816619873,
    "CMY_C": 0.26714354753494,
    "CMY_M": 0.48069757223129,
    "CMY_Y": 0.60814589262009,
    "CMYK_C": 0,
    "CMYK_M": 0.291399538517,
    "CMYK_Y": 0.46530577540398,
    "CMYK_K": 0.26714354753494
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y146050",
    "Farbtonhilfsbezeichnung": "Y14 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "124",
    "Bcolor": "73",
    "Y": 28,
    "L": 60.0830001831055,
    "a": 28.383243560791,
    "b": 40.7611122131348,
    "C": 49.669677734375,
    "h": 55.1492919921875,
    "CMY_C": 0.18539476394653,
    "CMY_M": 0.51446521282196,
    "CMY_Y": 0.71431457996368,
    "CMYK_C": 0,
    "CMYK_M": 0.40396308898926,
    "CMYK_Y": 0.64929586648941,
    "CMYK_K": 0.18539476394653
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y146745",
    "Farbtonhilfsbezeichnung": "Y14 67 45",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "144",
    "Bcolor": "96",
    "Y": 37,
    "L": 66.8875885009766,
    "a": 25.8428020477295,
    "b": 36.9983329772949,
    "C": 45.1301116943359,
    "h": 55.0662536621094,
    "CMY_C": 0.12339037656784,
    "CMY_M": 0.43639212846756,
    "CMY_Y": 0.6223109960556,
    "CMYK_C": 0,
    "CMYK_M": 0.35705944895744,
    "CMYK_Y": 0.56914800405502,
    "CMYK_K": 0.12339037656784
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y147005",
    "Farbtonhilfsbezeichnung": "Y14 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "169",
    "Bcolor": "162",
    "Y": 41,
    "L": 69.8016891479492,
    "a": 2.98652315139771,
    "b": 4.16599750518799,
    "C": 5.12590026855469,
    "h": 54.3639907836914,
    "CMY_C": 0.29654717445374,
    "CMY_M": 0.33871990442276,
    "CMY_Y": 0.36524140834808,
    "CMYK_C": 0,
    "CMYK_M": 0.05995104089379,
    "CMYK_Y": 0.09765293449163,
    "CMYK_K": 0.29654717445374
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y147020",
    "Farbtonhilfsbezeichnung": "Y14 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "162",
    "Bcolor": "139",
    "Y": 41,
    "L": 69.8087692260742,
    "a": 11.6427593231201,
    "b": 16.8867721557617,
    "C": 20.5113849639893,
    "h": 55.4152793884277,
    "CMY_C": 0.20697581768036,
    "CMY_M": 0.36276704072952,
    "CMY_Y": 0.45310515165329,
    "CMYK_C": 0,
    "CMYK_M": 0.19645205140114,
    "CMYK_Y": 0.31036800146103,
    "CMYK_K": 0.20697581768036
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y147335",
    "Farbtonhilfsbezeichnung": "Y14 73 35",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "163",
    "Bcolor": "125",
    "Y": 45,
    "L": 72.6157760620117,
    "a": 20.3577308654785,
    "b": 28.9893188476563,
    "C": 35.4234085083008,
    "h": 54.921573638916,
    "CMY_C": 0.09947401285172,
    "CMY_M": 0.35920536518097,
    "CMY_Y": 0.50928294658661,
    "CMYK_C": 0,
    "CMYK_M": 0.28842183947563,
    "CMYK_Y": 0.45507729053497,
    "CMYK_K": 0.09947401285172
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y148010",
    "Farbtonhilfsbezeichnung": "Y14 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "194",
    "Bcolor": "181",
    "Y": 57,
    "L": 79.7498168945313,
    "a": 6.07060194015503,
    "b": 8.37301826477051,
    "C": 10.3421297073364,
    "h": 54.0571517944336,
    "CMY_C": 0.15474396944046,
    "CMY_M": 0.2410334944725,
    "CMY_Y": 0.29028153419495,
    "CMYK_C": 0,
    "CMYK_M": 0.10208684951067,
    "CMYK_Y": 0.16035090386868,
    "CMYK_K": 0.15474396944046
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y148030",
    "Farbtonhilfsbezeichnung": "Y14 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "184",
    "Bcolor": "151",
    "Y": 57,
    "L": 79.3382949829102,
    "a": 16.8062191009521,
    "b": 24.0785675048828,
    "C": 29.3636913299561,
    "h": 55.0859527587891,
    "CMY_C": 0.0520778298378,
    "CMY_M": 0.27689105272293,
    "CMY_Y": 0.40622466802597,
    "CMYK_C": 0,
    "CMYK_M": 0.23716421425343,
    "CMYK_Y": 0.37360328435898,
    "CMYK_K": 0.0520778298378
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y148505",
    "Farbtonhilfsbezeichnung": "Y14 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "209",
    "Bcolor": "202",
    "Y": 66,
    "L": 84.7365036010742,
    "a": 3.14056158065796,
    "b": 4.17051601409912,
    "C": 5.22075939178467,
    "h": 53.0188255310059,
    "CMY_C": 0.13299888372421,
    "CMY_M": 0.17854332923889,
    "CMY_Y": 0.20683068037033,
    "CMYK_C": 0,
    "CMYK_M": 0.05253101140261,
    "CMYK_Y": 0.08515767008066,
    "CMYK_K": 0.13299888372421
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y148520",
    "Farbtonhilfsbezeichnung": "Y14 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "204",
    "Bcolor": "180",
    "Y": 66,
    "L": 85.0837783813477,
    "a": 11.5877771377563,
    "b": 16.6156120300293,
    "C": 20.2572250366211,
    "h": 55.107967376709,
    "CMY_C": 0.03586763143539,
    "CMY_M": 0.19907635450363,
    "CMY_Y": 0.29267245531082,
    "CMYK_C": 0,
    "CMYK_M": 0.16928040981293,
    "CMYK_Y": 0.26635846495628,
    "CMYK_K": 0.03586763143539
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y149010",
    "Farbtonhilfsbezeichnung": "Y14 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "222",
    "Bcolor": "209",
    "Y": 76,
    "L": 89.8862762451172,
    "a": 5.91396379470825,
    "b": 8.29073715209961,
    "C": 10.183874130249,
    "h": 54.498908996582,
    "CMY_C": 0.04263687133789,
    "CMY_M": 0.1296774148941,
    "CMY_Y": 0.18074959516525,
    "CMYK_C": 0,
    "CMYK_M": 0.0909169614315,
    "CMYK_Y": 0.14426366984844,
    "CMYK_K": 0.04263687133789
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y153116",
    "Farbtonhilfsbezeichnung": "Y15 31 16 Braunocker",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "68",
    "Bcolor": "55",
    "Y": 7,
    "L": 31.4091835021973,
    "a": 9.96828079223633,
    "b": 12.2151613235474,
    "C": 15.766318321228,
    "h": 50.7835578918457,
    "CMY_C": 0.62727385759354,
    "CMY_M": 0.73385071754456,
    "CMY_Y": 0.78527992963791,
    "CMYK_C": 0,
    "CMYK_M": 0.28593876957893,
    "CMYK_Y": 0.42392000555992,
    "CMYK_K": 0.62727385759354
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y153901",
    "Farbtonhilfsbezeichnung": "Y15 39 01 Grafit",
    "Farbtonklasse": "02",
    "Rcolor": "93",
    "Gcolor": "91",
    "Bcolor": "89",
    "Y": 11,
    "L": 38.8840408325195,
    "a": 0.52850592136383,
    "b": 0.96360677480698,
    "C": 1.0990252494812,
    "h": 61.2567138671875,
    "CMY_C": 0.63468939065933,
    "CMY_M": 0.64201545715332,
    "CMY_Y": 0.6499308347702,
    "CMYK_C": 0,
    "CMYK_M": 0.02005434967577,
    "CMYK_Y": 0.04172187671065,
    "CMYK_K": 0.63468939065933
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y154010",
    "Farbtonhilfsbezeichnung": "Y15 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "91",
    "Bcolor": "82",
    "Y": 11,
    "L": 40.3664054870605,
    "a": 6.42025709152222,
    "b": 8.01167964935303,
    "C": 10.2667770385742,
    "h": 51.2926330566406,
    "CMY_C": 0.56669962406158,
    "CMY_M": 0.64220035076141,
    "CMY_Y": 0.67974013090134,
    "CMYK_C": 0,
    "CMYK_M": 0.17424570024014,
    "CMYK_Y": 0.26088255643845,
    "CMYK_K": 0.56669962406158
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y154503",
    "Farbtonhilfsbezeichnung": "Y15 45 03",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "105",
    "Bcolor": "101",
    "Y": 15,
    "L": 44.8450546264648,
    "a": 1.83668529987335,
    "b": 2.46481108665466,
    "C": 3.07387495040894,
    "h": 53.3078956604004,
    "CMY_C": 0.56460237503052,
    "CMY_M": 0.5881689786911,
    "CMY_Y": 0.60303115844727,
    "CMYK_C": 0,
    "CMYK_M": 0.05412662401795,
    "CMYK_Y": 0.08826135098934,
    "CMYK_K": 0.56460237503052
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y155010",
    "Farbtonhilfsbezeichnung": "Y15 50 10",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "114",
    "Bcolor": "104",
    "Y": 18,
    "L": 49.7269515991211,
    "a": 6.39336967468262,
    "b": 7.84987926483154,
    "C": 10.1240196228027,
    "h": 50.838752746582,
    "CMY_C": 0.47338515520096,
    "CMY_M": 0.55193364620209,
    "CMY_Y": 0.59065687656403,
    "CMYK_C": 0,
    "CMYK_M": 0.14915737509727,
    "CMYK_Y": 0.2226897329092,
    "CMYK_K": 0.47338515520096
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y155045",
    "Farbtonhilfsbezeichnung": "Y15 50 45 Ocra Arancio",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "99",
    "Bcolor": "61",
    "Y": 19,
    "L": 50.3999443054199,
    "a": 29.1827621459961,
    "b": 34.6217155456543,
    "C": 45.2802047729492,
    "h": 49.8723487854004,
    "CMY_C": 0.29947507381439,
    "CMY_M": 0.61276119947433,
    "CMY_Y": 0.75937312841415,
    "CMYK_C": 0,
    "CMYK_M": 0.4472162425518,
    "CMYK_Y": 0.6565049290657,
    "CMYK_K": 0.29947507381439
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y155150",
    "Farbtonhilfsbezeichnung": "Y15 51 50",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "98",
    "Bcolor": "57",
    "Y": 19,
    "L": 51.1957206726074,
    "a": 32.1513862609863,
    "b": 38.140941619873,
    "C": 49.8842964172363,
    "h": 49.8703651428223,
    "CMY_C": 0.27206039428711,
    "CMY_M": 0.61535608768463,
    "CMY_Y": 0.77632749080658,
    "CMYK_C": 0,
    "CMYK_M": 0.47159913182259,
    "CMYK_Y": 0.69273203611374,
    "CMYK_K": 0.27206039428711
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y155503",
    "Farbtonhilfsbezeichnung": "Y15 55 03",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "130",
    "Bcolor": "126",
    "Y": 23,
    "L": 54.7620124816895,
    "a": 1.88467991352081,
    "b": 2.43891358375549,
    "C": 3.08225846290588,
    "h": 52.3048057556152,
    "CMY_C": 0.46567338705063,
    "CMY_M": 0.49053692817688,
    "CMY_Y": 0.50632393360138,
    "CMYK_C": 0,
    "CMYK_M": 0.04653247818351,
    "CMYK_Y": 0.07607808709145,
    "CMYK_K": 0.46567338705063
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y155565",
    "Farbtonhilfsbezeichnung": "Y15 55 65",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "100",
    "Bcolor": "47",
    "Y": 23,
    "L": 54.9638595581055,
    "a": 40.2592010498047,
    "b": 48.3749732971191,
    "C": 62.9360084533691,
    "h": 50.231689453125,
    "CMY_C": 0.17883050441742,
    "CMY_M": 0.6085667014122,
    "CMY_Y": 0.81644058227539,
    "CMYK_C": 0,
    "CMYK_M": 0.52332216501236,
    "CMYK_Y": 0.7764658331871,
    "CMYK_K": 0.17883050441742
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156015",
    "Farbtonhilfsbezeichnung": "Y15 60 15",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "139",
    "Bcolor": "125",
    "Y": 28,
    "L": 60.3658294677734,
    "a": 9.52448177337646,
    "b": 11.6091442108154,
    "C": 15.0162572860718,
    "h": 50.633544921875,
    "CMY_C": 0.33434969186783,
    "CMY_M": 0.4538094997406,
    "CMY_Y": 0.51151049137115,
    "CMYK_C": 0,
    "CMYK_M": 0.17946331202984,
    "CMYK_Y": 0.2661469578743,
    "CMYK_K": 0.33434969186783
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156020",
    "Farbtonhilfsbezeichnung": "Y15 60 20",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "135",
    "Bcolor": "116",
    "Y": 28,
    "L": 59.8453407287598,
    "a": 13.0030241012573,
    "b": 15.6944408416748,
    "C": 20.3812198638916,
    "h": 50.3578605651855,
    "CMY_C": 0.31003451347351,
    "CMY_M": 0.46870565414429,
    "CMY_Y": 0.54393148422241,
    "CMYK_C": 0,
    "CMYK_M": 0.2299696803093,
    "CMYK_Y": 0.33899807929993,
    "CMYK_K": 0.31003451347351
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156040",
    "Farbtonhilfsbezeichnung": "Y15 60 40",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "125",
    "Bcolor": "90",
    "Y": 28,
    "L": 59.7562255859375,
    "a": 25.977445602417,
    "b": 30.9546146392822,
    "C": 40.4105911254883,
    "h": 49.996265411377,
    "CMY_C": 0.21280544996262,
    "CMY_M": 0.50871384143829,
    "CMY_Y": 0.64743065834045,
    "CMYK_C": 0,
    "CMYK_M": 0.37590250372887,
    "CMYK_Y": 0.55211919546127,
    "CMYK_K": 0.21280544996262
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156050",
    "Farbtonhilfsbezeichnung": "Y15 60 50",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "120",
    "Bcolor": "76",
    "Y": 28,
    "L": 59.8467063903809,
    "a": 32.5052795410156,
    "b": 38.7158432006836,
    "C": 50.5520477294922,
    "h": 49.9836540222168,
    "CMY_C": 0.16800618171692,
    "CMY_M": 0.5298513174057,
    "CMY_Y": 0.70010387897491,
    "CMYK_C": 0,
    "CMYK_M": 0.43491324782372,
    "CMYK_Y": 0.63954526185989,
    "CMYK_K": 0.16800618171692
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156060",
    "Farbtonhilfsbezeichnung": "Y15 60 60",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "114",
    "Bcolor": "63",
    "Y": 28,
    "L": 59.9406700134277,
    "a": 38.7583770751953,
    "b": 46.0507392883301,
    "C": 60.1903839111328,
    "h": 49.9145240783691,
    "CMY_C": 0.12767058610916,
    "CMY_M": 0.55186080932617,
    "CMY_Y": 0.75170737504959,
    "CMYK_C": 0,
    "CMYK_M": 0.48627299070358,
    "CMYK_Y": 0.71536827087402,
    "CMYK_K": 0.12767058610916
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y156503",
    "Farbtonhilfsbezeichnung": "Y15 65 03",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "157",
    "Bcolor": "153",
    "Y": 34,
    "L": 65.1833114624023,
    "a": 1.99331867694855,
    "b": 2.32683873176575,
    "C": 3.06390237808228,
    "h": 49.4145317077637,
    "CMY_C": 0.35786235332489,
    "CMY_M": 0.3842721581459,
    "CMY_Y": 0.40028995275497,
    "CMYK_C": 0,
    "CMYK_M": 0.04112794995308,
    "CMYK_Y": 0.06607243418694,
    "CMYK_K": 0.35786235332489
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157010",
    "Farbtonhilfsbezeichnung": "Y15 70 10",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "166",
    "Bcolor": "155",
    "Y": 41,
    "L": 69.7128143310547,
    "a": 6.68748760223389,
    "b": 7.93286561965942,
    "C": 10.3755893707275,
    "h": 49.868766784668,
    "CMY_C": 0.2613730430603,
    "CMY_M": 0.34936130046844,
    "CMY_Y": 0.39201259613037,
    "CMYK_C": 0,
    "CMYK_M": 0.11912407726049,
    "CMYK_Y": 0.17686811089516,
    "CMYK_K": 0.2613730430603
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157030",
    "Farbtonhilfsbezeichnung": "Y15 70 30",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "157",
    "Bcolor": "129",
    "Y": 41,
    "L": 69.9098205566406,
    "a": 19.2818775177002,
    "b": 23.0250091552734,
    "C": 30.0323467254639,
    "h": 50.0561218261719,
    "CMY_C": 0.14677155017853,
    "CMY_M": 0.38334327936172,
    "CMY_Y": 0.49398273229599,
    "CMYK_C": 0,
    "CMYK_M": 0.27726656198502,
    "CMYK_Y": 0.40693813562393,
    "CMYK_K": 0.14677155017853
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157040",
    "Farbtonhilfsbezeichnung": "Y15 70 40",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "154",
    "Bcolor": "117",
    "Y": 41,
    "L": 70.3676834106445,
    "a": 25.2043285369873,
    "b": 30.3467216491699,
    "C": 39.4484672546387,
    "h": 50.2888336181641,
    "CMY_C": 0.09486931562424,
    "CMY_M": 0.39704769849777,
    "CMY_Y": 0.54029268026352,
    "CMYK_C": 0,
    "CMYK_M": 0.33385056257248,
    "CMYK_Y": 0.49210944771767,
    "CMYK_K": 0.09486931562424
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157050",
    "Farbtonhilfsbezeichnung": "Y15 70 50",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "147",
    "Bcolor": "101",
    "Y": 41,
    "L": 69.9830780029297,
    "a": 32.5581932067871,
    "b": 38.6150131225586,
    "C": 50.508960723877,
    "h": 49.8641357421875,
    "CMY_C": 0.04685914516449,
    "CMY_M": 0.42545706033707,
    "CMY_Y": 0.6020702123642,
    "CMYK_C": 0,
    "CMYK_M": 0.39721086621284,
    "CMYK_Y": 0.58250683546066,
    "CMYK_K": 0.04685914516449
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157503",
    "Farbtonhilfsbezeichnung": "Y15 75 03",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "183",
    "Bcolor": "179",
    "Y": 48,
    "L": 75.0093841552734,
    "a": 1.94645619392395,
    "b": 2.19400382041931,
    "C": 2.93297529220581,
    "h": 48.4214973449707,
    "CMY_C": 0.25425028800964,
    "CMY_M": 0.28052175045013,
    "CMY_Y": 0.29687416553497,
    "CMYK_C": 0,
    "CMYK_M": 0.03522825613618,
    "CMYK_Y": 0.05715573951602,
    "CMYK_K": 0.25425028800964
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y157540",
    "Farbtonhilfsbezeichnung": "Y15 75 40",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "165",
    "Bcolor": "128",
    "Y": 48,
    "L": 74.8907318115234,
    "a": 26.122745513916,
    "b": 30.682767868042,
    "C": 40.2967758178711,
    "h": 49.5895347595215,
    "CMY_C": 0.03581076860428,
    "CMY_M": 0.35223948955536,
    "CMY_Y": 0.49737906455994,
    "CMYK_C": 0,
    "CMYK_M": 0.32818114757538,
    "CMYK_Y": 0.4787113070488,
    "CMYK_K": 0.03581076860428
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158005",
    "Farbtonhilfsbezeichnung": "Y15 80 05",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "188",
    "Y": 57,
    "L": 79.4761734008789,
    "a": 3.5381383895874,
    "b": 4.01516389846802,
    "C": 5.3516321182251,
    "h": 48.6136894226074,
    "CMY_C": 0.1884554028511,
    "CMY_M": 0.23672586679459,
    "CMY_Y": 0.26219618320465,
    "CMYK_C": 0,
    "CMYK_M": 0.05947974324226,
    "CMYK_Y": 0.09086473286152,
    "CMYK_K": 0.1884554028511
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158010",
    "Farbtonhilfsbezeichnung": "Y15 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "194",
    "Bcolor": "183",
    "Y": 57,
    "L": 80.1235427856445,
    "a": 6.4804835319519,
    "b": 7.64308786392212,
    "C": 10.0206518173218,
    "h": 49.7057838439941,
    "CMY_C": 0.14967799186707,
    "CMY_M": 0.23780739307404,
    "CMY_Y": 0.28099095821381,
    "CMYK_C": 0,
    "CMYK_M": 0.1036423817277,
    "CMYK_Y": 0.15442733466625,
    "CMYK_K": 0.14967799186707
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158020",
    "Farbtonhilfsbezeichnung": "Y15 80 20",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "189",
    "Bcolor": "169",
    "Y": 57,
    "L": 79.8711166381836,
    "a": 12.8454360961914,
    "b": 15.4883155822754,
    "C": 20.1219577789307,
    "h": 50.3289413452148,
    "CMY_C": 0.08933216333389,
    "CMY_M": 0.25862085819244,
    "CMY_Y": 0.33921414613724,
    "CMYK_C": 0,
    "CMYK_M": 0.18589510023594,
    "CMYK_Y": 0.27439421415329,
    "CMYK_K": 0.08933216333389
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158030",
    "Farbtonhilfsbezeichnung": "Y15 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "184",
    "Bcolor": "154",
    "Y": 57,
    "L": 79.712158203125,
    "a": 19.5241546630859,
    "b": 23.108003616333,
    "C": 30.2518177032471,
    "h": 49.8052406311035,
    "CMY_C": 0.03230941295624,
    "CMY_M": 0.2801353931427,
    "CMY_Y": 0.39477074146271,
    "CMYK_C": 0,
    "CMYK_M": 0.25610044598579,
    "CMYK_Y": 0.37456324696541,
    "CMYK_K": 0.03230941295624
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158503",
    "Farbtonhilfsbezeichnung": "Y15 85 03",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 66,
    "L": 85.0070877075195,
    "a": 1.92696642875671,
    "b": 2.10392642021179,
    "C": 2.8530170917511,
    "h": 47.5137252807617,
    "CMY_C": 0.1456612944603,
    "CMY_M": 0.17210322618484,
    "CMY_Y": 0.18899595737457,
    "CMYK_C": 0,
    "CMYK_M": 0.03095017373562,
    "CMYK_Y": 0.05072304606438,
    "CMYK_K": 0.1456612944603
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158510",
    "Farbtonhilfsbezeichnung": "Y15 85 10",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "207",
    "Bcolor": "196",
    "Y": 66,
    "L": 84.7447052001953,
    "a": 6.83910799026489,
    "b": 7.78416585922241,
    "C": 10.3617868423462,
    "h": 48.6977119445801,
    "CMY_C": 0.0952382683754,
    "CMY_M": 0.18846416473389,
    "CMY_Y": 0.23254317045212,
    "CMYK_C": 0,
    "CMYK_M": 0.10303916782141,
    "CMYK_Y": 0.15175807476044,
    "CMYK_K": 0.0952382683754
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158515",
    "Farbtonhilfsbezeichnung": "Y15 85 15",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "206",
    "Bcolor": "191",
    "Y": 66,
    "L": 85.2399673461914,
    "a": 9.58172798156738,
    "b": 11.3432884216309,
    "C": 14.8485593795776,
    "h": 49.8120651245117,
    "CMY_C": 0.06072044372559,
    "CMY_M": 0.1908802986145,
    "CMY_Y": 0.25277674198151,
    "CMYK_C": 0,
    "CMYK_M": 0.13857413828373,
    "CMYK_Y": 0.20447193086147,
    "CMYK_K": 0.06072044372559
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y158520",
    "Farbtonhilfsbezeichnung": "Y15 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "201",
    "Bcolor": "181",
    "Y": 66,
    "L": 84.3114547729492,
    "a": 13.1095600128174,
    "b": 15.271505355835,
    "C": 20.1265850067139,
    "h": 49.356128692627,
    "CMY_C": 0.0374743938446,
    "CMY_M": 0.21114790439606,
    "CMY_Y": 0.29077303409576,
    "CMYK_C": 0,
    "CMYK_M": 0.18043521046638,
    "CMYK_Y": 0.26316040754318,
    "CMYK_K": 0.0374743938446
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y159005",
    "Farbtonhilfsbezeichnung": "Y15 90 05",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "224",
    "Bcolor": "218",
    "Y": 76,
    "L": 90.043342590332,
    "a": 3.19190216064453,
    "b": 3.69114780426025,
    "C": 4.87983703613281,
    "h": 49.1485481262207,
    "CMY_C": 0.0749374628067,
    "CMY_M": 0.11998116970062,
    "CMY_Y": 0.14546889066696,
    "CMYK_C": 0,
    "CMYK_M": 0.04869260638952,
    "CMYK_Y": 0.07624503970146,
    "CMYK_K": 0.0749374628067
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y159110",
    "Farbtonhilfsbezeichnung": "Y15 91 10",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "225",
    "Bcolor": "213",
    "Y": 78,
    "L": 91.0204010009766,
    "a": 6.580482006073,
    "b": 7.67141914367676,
    "C": 10.1070976257324,
    "h": 49.377269744873,
    "CMY_C": 0.02664691209793,
    "CMY_M": 0.11858969926834,
    "CMY_Y": 0.16369169950485,
    "CMYK_C": 0,
    "CMYK_M": 0.09445985406637,
    "CMYK_Y": 0.14079658687115,
    "CMYK_K": 0.02664691209793
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y159403",
    "Farbtonhilfsbezeichnung": "Y15 94 03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "237",
    "Bcolor": "232",
    "Y": 85,
    "L": 94.1596755981445,
    "a": 2.0204381942749,
    "b": 2.34271502494812,
    "C": 3.09361982345581,
    "h": 49.2243843078613,
    "CMY_C": 0.04199713468552,
    "CMY_M": 0.07080924510956,
    "CMY_Y": 0.09019058942795,
    "CMYK_C": 0,
    "CMYK_M": 0.03007518127561,
    "CMYK_Y": 0.05030617117882,
    "CMYK_K": 0.04199713468552
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y164010",
    "Farbtonhilfsbezeichnung": "Y16 40 10",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "90",
    "Bcolor": "82",
    "Y": 11,
    "L": 40.015380859375,
    "a": 6.70008230209351,
    "b": 7.01326990127563,
    "C": 9.69933319091797,
    "h": 46.3083038330078,
    "CMY_C": 0.57057654857635,
    "CMY_M": 0.64592069387436,
    "CMY_Y": 0.67663103342056,
    "CMYK_C": 0,
    "CMYK_M": 0.17545419931412,
    "CMYK_Y": 0.2469694763422,
    "CMYK_K": 0.57057654857635
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y164238",
    "Farbtonhilfsbezeichnung": "Y16 42 38 Ocker Soforouge",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "81",
    "Bcolor": "56",
    "Y": 13,
    "L": 42.2256393432617,
    "a": 26.6718978881836,
    "b": 26.931360244751,
    "C": 37.9036712646484,
    "h": 45.2773361206055,
    "CMY_C": 0.41161501407623,
    "CMY_M": 0.68262004852295,
    "CMY_Y": 0.78069841861725,
    "CMYK_C": 0,
    "CMYK_M": 0.46059134602547,
    "CMYK_Y": 0.62728214263916,
    "CMYK_K": 0.41161501407623
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y164940",
    "Farbtonhilfsbezeichnung": "Y16 49 40 Terra Pozzuoli",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "97",
    "Bcolor": "69",
    "Y": 18,
    "L": 49.174976348877,
    "a": 28.1917667388916,
    "b": 28.3860549926758,
    "C": 40.0067977905273,
    "h": 45.1967506408691,
    "CMY_C": 0.32459527254105,
    "CMY_M": 0.62053501605988,
    "CMY_Y": 0.72766280174255,
    "CMYK_C": 0,
    "CMYK_M": 0.4381665289402,
    "CMYK_Y": 0.59677922725677,
    "CMYK_K": 0.32459527254105
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y165005",
    "Farbtonhilfsbezeichnung": "Y16 50 05",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "116",
    "Bcolor": "111",
    "Y": 18,
    "L": 49.7697792053223,
    "a": 3.57094407081604,
    "b": 3.88825392723083,
    "C": 5.27921962738037,
    "h": 47.4358596801758,
    "CMY_C": 0.50066244602203,
    "CMY_M": 0.54422771930695,
    "CMY_Y": 0.56466341018677,
    "CMYK_C": 0,
    "CMYK_M": 0.0872461348772,
    "CMYK_Y": 0.12817174196243,
    "CMYK_K": 0.50066244602203
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y165020",
    "Farbtonhilfsbezeichnung": "Y16 50 20",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "110",
    "Bcolor": "94",
    "Y": 18,
    "L": 49.9792366027832,
    "a": 13.9456472396851,
    "b": 14.3875465393066,
    "C": 20.0370292663574,
    "h": 45.8935432434082,
    "CMY_C": 0.41245645284653,
    "CMY_M": 0.56919729709625,
    "CMY_Y": 0.63002014160156,
    "CMYK_C": 0,
    "CMYK_M": 0.26677316427231,
    "CMYK_Y": 0.37029373645782,
    "CMYK_K": 0.41245645284653
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y165153",
    "Farbtonhilfsbezeichnung": "Y16 51 53 Arancione Ercolano",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "92",
    "Bcolor": "57",
    "Y": 19,
    "L": 50.9765205383301,
    "a": 37.7152824401855,
    "b": 37.9881896972656,
    "C": 53.5307846069336,
    "h": 45.2065467834473,
    "CMY_C": 0.24663692712784,
    "CMY_M": 0.63750511407852,
    "CMY_Y": 0.77512645721436,
    "CMYK_C": 0,
    "CMYK_M": 0.51883107423782,
    "CMYK_Y": 0.70150709152222,
    "CMYK_K": 0.24663692712784
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y166010",
    "Farbtonhilfsbezeichnung": "Y16 60 10",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "139",
    "Bcolor": "130",
    "Y": 28,
    "L": 59.6723594665527,
    "a": 7.04406929016113,
    "b": 7.25104284286499,
    "C": 10.1092300415039,
    "h": 45.8295059204102,
    "CMY_C": 0.36770433187485,
    "CMY_M": 0.45386397838593,
    "CMY_Y": 0.48913812637329,
    "CMYK_C": 0,
    "CMYK_M": 0.13626480102539,
    "CMYK_Y": 0.19205223023891,
    "CMYK_K": 0.36770433187485
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y166030",
    "Farbtonhilfsbezeichnung": "Y16 60 30",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "130",
    "Bcolor": "107",
    "Y": 28,
    "L": 60.166332244873,
    "a": 21.0854263305664,
    "b": 21.6367530822754,
    "C": 30.2116584777832,
    "h": 45.7393569946289,
    "CMY_C": 0.24845629930496,
    "CMY_M": 0.48842144012451,
    "CMY_Y": 0.57995241880417,
    "CMYK_C": 0,
    "CMYK_M": 0.31929633021355,
    "CMYK_Y": 0.44108694791794,
    "CMYK_K": 0.24845629930496
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y166048",
    "Farbtonhilfsbezeichnung": "Y16 60 48",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "119",
    "Bcolor": "84",
    "Y": 28,
    "L": 59.9463577270508,
    "a": 33.5012016296387,
    "b": 34.564208984375,
    "C": 48.135383605957,
    "h": 45.8947372436523,
    "CMY_C": 0.16563653945923,
    "CMY_M": 0.53144907951355,
    "CMY_Y": 0.66902601718903,
    "CMYK_C": 0,
    "CMYK_M": 0.43843308091164,
    "CMYK_Y": 0.60332155227661,
    "CMYK_K": 0.16563653945923
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y167005",
    "Farbtonhilfsbezeichnung": "Y16 70 05",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "168",
    "Bcolor": "163",
    "Y": 41,
    "L": 69.7727355957031,
    "a": 3.79168391227722,
    "b": 3.7363805770874,
    "C": 5.3232889175415,
    "h": 44.5790977478027,
    "CMY_C": 0.29235130548477,
    "CMY_M": 0.34078449010849,
    "CMY_Y": 0.36242008209229,
    "CMYK_C": 0,
    "CMYK_M": 0.06844241172075,
    "CMYK_Y": 0.09901633113623,
    "CMYK_K": 0.29235130548477
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y167020",
    "Farbtonhilfsbezeichnung": "Y16 70 20",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "162",
    "Bcolor": "145",
    "Y": 41,
    "L": 70.0786666870117,
    "a": 14.3269319534302,
    "b": 14.3678894042969,
    "C": 20.2903232574463,
    "h": 45.0817832946777,
    "CMY_C": 0.1920599937439,
    "CMY_M": 0.36627519130707,
    "CMY_Y": 0.43217122554779,
    "CMYK_C": 0,
    "CMYK_M": 0.21562887728214,
    "CMYK_Y": 0.29718944430351,
    "CMYK_K": 0.1920599937439
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y167040",
    "Farbtonhilfsbezeichnung": "Y16 70 40",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "150",
    "Bcolor": "119",
    "Y": 41,
    "L": 69.6372833251953,
    "a": 28.1410446166992,
    "b": 28.5390396118164,
    "C": 40.0798606872559,
    "h": 45.4023132324219,
    "CMY_C": 0.0889043211937,
    "CMY_M": 0.41316837072372,
    "CMY_Y": 0.5339013338089,
    "CMYK_C": 0,
    "CMYK_M": 0.35590559244156,
    "CMYK_Y": 0.48841962218285,
    "CMYK_K": 0.0889043211937
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y168010",
    "Farbtonhilfsbezeichnung": "Y16 80 10",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "194",
    "Bcolor": "184",
    "Y": 57,
    "L": 80.0215072631836,
    "a": 7.14252233505249,
    "b": 6.95964622497559,
    "C": 9.97257709503174,
    "h": 44.2570343017578,
    "CMY_C": 0.14797431230545,
    "CMY_M": 0.24035918712616,
    "CMY_Y": 0.27705037593842,
    "CMYK_C": 0,
    "CMYK_M": 0.10842968523502,
    "CMYK_Y": 0.15149316191673,
    "CMYK_K": 0.14797431230545
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y168030",
    "Farbtonhilfsbezeichnung": "Y16 80 30",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "184",
    "Bcolor": "159",
    "Y": 57,
    "L": 80.1781997680664,
    "a": 21.4826545715332,
    "b": 21.2647495269775,
    "C": 30.2273712158203,
    "h": 44.707935333252,
    "CMY_C": 0.0179654955864,
    "CMY_M": 0.28020691871643,
    "CMY_Y": 0.3761910200119,
    "CMYK_C": 0,
    "CMYK_M": 0.26703891158104,
    "CMYK_Y": 0.36477896571159,
    "CMYK_K": 0.0179654955864
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y168505",
    "Farbtonhilfsbezeichnung": "Y16 85 05",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "209",
    "Bcolor": "203",
    "Y": 66,
    "L": 84.664680480957,
    "a": 3.75742864608765,
    "b": 3.58888459205627,
    "C": 5.19599485397339,
    "h": 43.6857109069824,
    "CMY_C": 0.13096243143082,
    "CMY_M": 0.18065655231476,
    "CMY_Y": 0.20327895879745,
    "CMYK_C": 0,
    "CMYK_M": 0.05718293786049,
    "CMYK_Y": 0.08321449905634,
    "CMYK_K": 0.13096243143082
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y168520",
    "Farbtonhilfsbezeichnung": "Y16 85 20",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "202",
    "Bcolor": "185",
    "Y": 66,
    "L": 84.9968948364258,
    "a": 14.2313442230225,
    "b": 13.9839887619019,
    "C": 19.9520206451416,
    "h": 44.4977188110352,
    "CMY_C": 0.02501672506332,
    "CMY_M": 0.20631277561188,
    "CMY_Y": 0.27388924360275,
    "CMYK_C": 0,
    "CMYK_M": 0.18594785034657,
    "CMYK_Y": 0.25525823235512,
    "CMYK_K": 0.02501672506332
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y169010",
    "Farbtonhilfsbezeichnung": "Y16 90 10",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "221",
    "Bcolor": "211",
    "Y": 76,
    "L": 89.7215042114258,
    "a": 6.98735237121582,
    "b": 6.90292310714722,
    "C": 9.82208919525146,
    "h": 44.6517448425293,
    "CMY_C": 0.04058593511581,
    "CMY_M": 0.13380974531174,
    "CMY_Y": 0.17213398218155,
    "CMYK_C": 0,
    "CMYK_M": 0.09716743975878,
    "CMYK_Y": 0.13711290061474,
    "CMYK_K": 0.04058593511581
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor System 2022",
    "Farbton_ID": "Y169305",
    "Farbtonhilfsbezeichnung": "Y16 93 05",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 83,
    "L": 93.391242980957,
    "a": 3.63229632377625,
    "b": 3.52268958091736,
    "C": 5.05993270874023,
    "h": 44.1223602294922,
    "CMY_C": 0.03440582752228,
    "CMY_M": 0.08369028568268,
    "CMY_Y": 0.10726416110992,
    "CMYK_C": 0,
    "CMYK_M": 0.05104054883122,
    "CMYK_Y": 0.07545440644026,
    "CMYK_K": 0.03440582752228
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00009",
    "Farbtonhilfsbezeichnung": "Granat 0",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "86",
    "Bcolor": "75",
    "Y": 13,
    "L": 42.7676200866699,
    "a": 22.2845687866211,
    "b": 16.2530460357666,
    "C": 27.5819416046143,
    "h": 36.1048011779785,
    "CMY_C": 0.44037264585495,
    "CMY_M": 0.66195672750473,
    "CMY_Y": 0.70745456218719,
    "CMYK_C": 0,
    "CMYK_M": 0.39594933390617,
    "CMYK_Y": 0.47724956274033,
    "CMYK_K": 0.44037264585495
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00029",
    "Farbtonhilfsbezeichnung": "Bison 0",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "90",
    "Bcolor": "76",
    "Y": 10,
    "L": 39.3798522949219,
    "a": 4.57016038894653,
    "b": 9.86019897460938,
    "C": 10.8678369522095,
    "h": 65.1324768066406,
    "CMY_C": 0.58360755443573,
    "CMY_M": 0.64780086278915,
    "CMY_Y": 0.70072722434998,
    "CMYK_C": 0,
    "CMYK_M": 0.15416540205479,
    "CMYK_Y": 0.28127232193947,
    "CMYK_K": 0.58360755443573
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00065",
    "Farbtonhilfsbezeichnung": "Schiefer 15",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "182",
    "Bcolor": "170",
    "Y": 50,
    "L": 74.1766967773438,
    "a": 0.15231846272945,
    "b": 5.80972957611084,
    "C": 5.81172609329224,
    "h": 88.498176574707,
    "CMY_C": 0.26547515392303,
    "CMY_M": 0.28624147176743,
    "CMY_Y": 0.33158665895462,
    "CMYK_C": 0,
    "CMYK_M": 0.02827177010477,
    "CMYK_Y": 0.09000581502914,
    "CMYK_K": 0.26547515392303
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00067",
    "Farbtonhilfsbezeichnung": "Cognac 14",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "199",
    "Bcolor": "146",
    "Y": 65,
    "L": 82.8957290649414,
    "a": 8.85131072998047,
    "b": 31.6264915466309,
    "C": 32.8417510986328,
    "h": 74.3646545410156,
    "CMY_C": 0.0484676361084,
    "CMY_M": 0.21917104721069,
    "CMY_Y": 0.42676895856857,
    "CMYK_C": 0,
    "CMYK_M": 0.179398432374,
    "CMYK_Y": 0.39757063984871,
    "CMYK_K": 0.0484676361084
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00068",
    "Farbtonhilfsbezeichnung": "Cognac 11",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "138",
    "Bcolor": "79",
    "Y": 32,
    "L": 63.493335723877,
    "a": 20.7755699157715,
    "b": 41.4223251342773,
    "C": 46.3404083251953,
    "h": 63.3637199401855,
    "CMY_C": 0.18672800064087,
    "CMY_M": 0.4572069644928,
    "CMY_Y": 0.6893265247345,
    "CMYK_C": 0,
    "CMYK_M": 0.33258119225502,
    "CMYK_Y": 0.61799561977386,
    "CMYK_K": 0.18672800064087
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00069",
    "Farbtonhilfsbezeichnung": "Terra 14",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "185",
    "Bcolor": "150",
    "Y": 54,
    "L": 77.8938827514648,
    "a": 10.0696525573731,
    "b": 22.7568778991699,
    "C": 24.8852043151856,
    "h": 66.1311721801758,
    "CMY_C": 0.11464864015579,
    "CMY_M": 0.27439200878143,
    "CMY_Y": 0.41282588243484,
    "CMYK_C": 0,
    "CMYK_M": 0.18042935431004,
    "CMYK_Y": 0.336789727211,
    "CMYK_K": 0.11464864015579
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00074",
    "Farbtonhilfsbezeichnung": "Marone 15 G",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "193",
    "Bcolor": "171",
    "Y": 56,
    "L": 79.8464889526367,
    "a": 6.38733720779419,
    "b": 13.9010334014893,
    "C": 15.298261642456,
    "h": 65.3218612670898,
    "CMY_C": 0.13719826936722,
    "CMY_M": 0.24215108156204,
    "CMY_Y": 0.3290998339653,
    "CMYK_C": 0,
    "CMYK_M": 0.12164186686277,
    "CMYK_Y": 0.22241675853729,
    "CMYK_K": 0.13719826936722
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00078",
    "Farbtonhilfsbezeichnung": "Aprikose 11",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "134",
    "Bcolor": "67",
    "Y": 34,
    "L": 64.4046859741211,
    "a": 29.3956985473633,
    "b": 49.2087097167969,
    "C": 57.3201904296875,
    "h": 59.1472663879395,
    "CMY_C": 0.12099051475525,
    "CMY_M": 0.47480463981628,
    "CMY_Y": 0.73782908916473,
    "CMYK_C": 0,
    "CMYK_M": 0.40251457691193,
    "CMYK_Y": 0.70174276828766,
    "CMYK_K": 0.12099051475525
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00081",
    "Farbtonhilfsbezeichnung": "Terra 12",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "140",
    "Bcolor": "99",
    "Y": 30,
    "L": 62.7796478271484,
    "a": 16.661491394043,
    "b": 29.4994411468506,
    "C": 33.8795280456543,
    "h": 60.541934967041,
    "CMY_C": 0.23310577869415,
    "CMY_M": 0.45117956399918,
    "CMY_Y": 0.61050313711166,
    "CMYK_C": 0,
    "CMYK_M": 0.2843596637249,
    "CMYK_Y": 0.4921113550663,
    "CMYK_K": 0.23310577869415
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00138",
    "Farbtonhilfsbezeichnung": "Havanna 0",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "98",
    "Bcolor": "73",
    "Y": 14,
    "L": 44.0732421875,
    "a": 9.87394046783447,
    "b": 18.9534378051758,
    "C": 21.3711833953857,
    "h": 62.4823913574219,
    "CMY_C": 0.49000638723373,
    "CMY_M": 0.61716306209564,
    "CMY_Y": 0.7155339717865,
    "CMYK_C": 0,
    "CMYK_M": 0.2493299394846,
    "CMYK_Y": 0.44221648573875,
    "CMYK_K": 0.49000638723373
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00139",
    "Farbtonhilfsbezeichnung": "Bison 13",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "158",
    "Bcolor": "134",
    "Y": 37,
    "L": 66.3517532348633,
    "a": 4.30899572372437,
    "b": 14.5056467056274,
    "C": 15.1321258544922,
    "h": 73.4556121826172,
    "CMY_C": 0.29768633842468,
    "CMY_M": 0.38040602207184,
    "CMY_Y": 0.47256672382355,
    "CMYK_C": 0,
    "CMYK_M": 0.1177816838026,
    "CMYK_Y": 0.24900609254837,
    "CMYK_K": 0.29768633842468
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00155",
    "Farbtonhilfsbezeichnung": "Aprikose 14 G",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00171",
    "Farbtonhilfsbezeichnung": "Schiefer 13",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "141",
    "Bcolor": "130",
    "Y": 27,
    "L": 58.9094429016113,
    "a": 0.04179736599326,
    "b": 5.88465356826782,
    "C": 5.88480186462402,
    "h": 89.5930480957031,
    "CMY_C": 0.42649477720261,
    "CMY_M": 0.44540470838547,
    "CMY_Y": 0.48848539590836,
    "CMYK_C": 0,
    "CMYK_M": 0.03297255188227,
    "CMYK_Y": 0.10809076577425,
    "CMYK_K": 0.42649477720261
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00185",
    "Farbtonhilfsbezeichnung": "Mistral 15",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "212",
    "Bcolor": "173",
    "Y": 72,
    "L": 86.2692260742188,
    "a": 3.99271678924561,
    "b": 21.9261226654053,
    "C": 22.2866916656494,
    "h": 79.6796035766602,
    "CMY_C": 0.06252157688141,
    "CMY_M": 0.16819190979004,
    "CMY_Y": 0.32058250904083,
    "CMYK_C": 0,
    "CMYK_M": 0.11271761357784,
    "CMYK_Y": 0.27527132630348,
    "CMYK_K": 0.06252157688141
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00197",
    "Farbtonhilfsbezeichnung": "Lava 0",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "93",
    "Bcolor": "79",
    "Y": 11,
    "L": 40.2387084960938,
    "a": 2.16651368141174,
    "b": 9.48618698120117,
    "C": 9.73044300079346,
    "h": 77.1350860595703,
    "CMY_C": 0.59045958518982,
    "CMY_M": 0.63448429107666,
    "CMY_Y": 0.69087588787079,
    "CMYK_C": 0,
    "CMYK_M": 0.10749783366919,
    "CMYK_Y": 0.24519266188145,
    "CMYK_K": 0.59045958518982
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00201",
    "Farbtonhilfsbezeichnung": "Maroc 11",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "124",
    "Bcolor": "83",
    "Y": 22,
    "L": 55.498893737793,
    "a": 12.8331451416016,
    "b": 28.6523818969727,
    "C": 31.395040512085,
    "h": 65.8728179931641,
    "CMY_C": 0.33743315935135,
    "CMY_M": 0.51451927423477,
    "CMY_Y": 0.67485058307648,
    "CMYK_C": 0,
    "CMYK_M": 0.26727283000946,
    "CMYK_Y": 0.5092579126358,
    "CMYK_K": 0.33743315935135
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00207",
    "Farbtonhilfsbezeichnung": "Basalt 0",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "84",
    "Bcolor": "83",
    "Y": 8,
    "L": 35.7790794372559,
    "a": 1.2108541727066,
    "b": 0.0335398465395,
    "C": 1.21131861209869,
    "h": 1.58664894104004,
    "CMY_C": 0.66199922561646,
    "CMY_M": 0.67223083972931,
    "CMY_Y": 0.6728823184967,
    "CMYK_C": 0,
    "CMYK_M": 0.0302709788084,
    "CMYK_Y": 0.03219842538238,
    "CMYK_K": 0.66199922561646
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00214",
    "Farbtonhilfsbezeichnung": "Lava 13",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "163",
    "Bcolor": "141",
    "Y": 40,
    "L": 67.8601913452148,
    "a": 2.21615123748779,
    "b": 12.7808742523193,
    "C": 12.9715871810913,
    "h": 80.1629486083984,
    "CMY_C": 0.29970806837082,
    "CMY_M": 0.35942900180817,
    "CMY_Y": 0.4456050992012,
    "CMYK_C": 0,
    "CMYK_M": 0.08528005331755,
    "CMYK_Y": 0.20833744108677,
    "CMYK_K": 0.29970806837082
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00219",
    "Farbtonhilfsbezeichnung": "Terra 15",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "198",
    "Bcolor": "169",
    "Y": 64,
    "L": 82.2825546264648,
    "a": 8.77974033355713,
    "b": 18.7741203308106,
    "C": 20.725622177124,
    "h": 64.9367980957031,
    "CMY_C": 0.08196252584457,
    "CMY_M": 0.22289472818375,
    "CMY_Y": 0.33850508928299,
    "CMYK_C": 0,
    "CMYK_M": 0.15351465344429,
    "CMYK_Y": 0.27944672107697,
    "CMYK_K": 0.08196252584457
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00237",
    "Farbtonhilfsbezeichnung": "Taiga 0",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "107",
    "Bcolor": "78",
    "Y": 15,
    "L": 46.1676406860352,
    "a": 3.36720538139343,
    "b": 18.1596832275391,
    "C": 18.4692230224609,
    "h": 79.4954071044922,
    "CMY_C": 0.50747805833817,
    "CMY_M": 0.58195638656616,
    "CMY_Y": 0.69237220287323,
    "CMYK_C": 0,
    "CMYK_M": 0.15121829509735,
    "CMYK_Y": 0.37540286779404,
    "CMYK_K": 0.50747805833817
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00256",
    "Farbtonhilfsbezeichnung": "Palma 15",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "203",
    "Bcolor": "170",
    "Y": 64,
    "L": 81.9972152709961,
    "a": -0.72070044279099,
    "b": 17.3543033599854,
    "C": 17.3692626953125,
    "h": 92.3780517578125,
    "CMY_C": 0.15488451719284,
    "CMY_M": 0.20265436172485,
    "CMY_Y": 0.33278506994247,
    "CMYK_C": 0,
    "CMYK_M": 0.05652463436127,
    "CMYK_Y": 0.21050442755222,
    "CMYK_K": 0.15488451719284
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00257",
    "Farbtonhilfsbezeichnung": "Schiefer 16",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "198",
    "Bcolor": "187",
    "Y": 60,
    "L": 80.081672668457,
    "a": 0.22668820619583,
    "b": 5.21230936050415,
    "C": 5.21723651885986,
    "h": 87.5097198486328,
    "CMY_C": 0.20281702280045,
    "CMY_M": 0.22270286083221,
    "CMY_Y": 0.26483178138733,
    "CMYK_C": 0,
    "CMYK_M": 0.02494513615966,
    "CMYK_Y": 0.07779237627983,
    "CMYK_K": 0.20281702280045
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00258",
    "Farbtonhilfsbezeichnung": "Nutria 11",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "109",
    "Bcolor": "92",
    "Y": 15,
    "L": 47.9740028381348,
    "a": 6.62254858016968,
    "b": 12.8722448348999,
    "C": 14.4759397506714,
    "h": 62.7749557495117,
    "CMY_C": 0.4792976975441,
    "CMY_M": 0.5707032084465,
    "CMY_Y": 0.64021396636963,
    "CMYK_C": 0,
    "CMYK_M": 0.17554274201393,
    "CMYK_Y": 0.30903697013855,
    "CMYK_K": 0.4792976975441
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00278",
    "Farbtonhilfsbezeichnung": "Maroc 12",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "144",
    "Bcolor": "98",
    "Y": 33,
    "L": 63.5146827697754,
    "a": 12.8061294555664,
    "b": 30.8466205596924,
    "C": 33.3992652893066,
    "h": 67.453971862793,
    "CMY_C": 0.24560934305191,
    "CMY_M": 0.4337665438652,
    "CMY_Y": 0.61391139030457,
    "CMYK_C": 0,
    "CMYK_M": 0.24941612780094,
    "CMYK_Y": 0.48821130394936,
    "CMYK_K": 0.24560934305191
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00290",
    "Farbtonhilfsbezeichnung": "Mandarin 12",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "172",
    "Bcolor": "85",
    "Y": 51,
    "L": 75.576042175293,
    "a": 17.7283096313477,
    "b": 53.6393966674805,
    "C": 56.4931678771973,
    "h": 71.7108154296875,
    "CMY_C": 0.0488058924675,
    "CMY_M": 0.32473307847977,
    "CMY_Y": 0.66833734512329,
    "CMYK_C": 0,
    "CMYK_M": 0.29008504748344,
    "CMYK_Y": 0.65131968259811,
    "CMYK_K": 0.0488058924675
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00370",
    "Farbtonhilfsbezeichnung": "Gobi 13 H",
    "Farbtonklasse": "02",
    "Y": 60,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00374",
    "Farbtonhilfsbezeichnung": "Terra 16",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "211",
    "Bcolor": "187",
    "Y": 72,
    "L": 86.3573532104492,
    "a": 6.50064563751221,
    "b": 14.7382669448853,
    "C": 16.1082248687744,
    "h": 66.1990432739258,
    "CMY_C": 0.06114435195923,
    "CMY_M": 0.17172759771347,
    "CMY_Y": 0.26621425151825,
    "CMYK_C": 0,
    "CMYK_M": 0.117785140872,
    "CMYK_Y": 0.21842537820339,
    "CMYK_K": 0.06114435195923
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00376",
    "Farbtonhilfsbezeichnung": "Aprikose 12",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "151",
    "Bcolor": "74",
    "Y": 41,
    "L": 70.1157302856445,
    "a": 26.204158782959,
    "b": 52.2516441345215,
    "C": 58.4541893005371,
    "h": 63.3662757873535,
    "CMY_C": 0.06713771820068,
    "CMY_M": 0.40631151199341,
    "CMY_Y": 0.70795518159866,
    "CMYK_C": 0,
    "CMYK_M": 0.36358398199081,
    "CMYK_Y": 0.68693685531616,
    "CMYK_K": 0.06713771820068
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00378",
    "Farbtonhilfsbezeichnung": "Aprikose 0",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "120",
    "Bcolor": "61",
    "Y": 28,
    "L": 59.5069007873535,
    "a": 30.5727081298828,
    "b": 46.1501731872559,
    "C": 55.3581886291504,
    "h": 56.4770660400391,
    "CMY_C": 0.17580270767212,
    "CMY_M": 0.52806955575943,
    "CMY_Y": 0.76006805896759,
    "CMYK_C": 0,
    "CMYK_M": 0.42740598320961,
    "CMYK_Y": 0.70889014005661,
    "CMYK_K": 0.17580270767212
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00387",
    "Farbtonhilfsbezeichnung": "Nutria 17",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "219",
    "Bcolor": "204",
    "Y": 77,
    "L": 88.1196136474609,
    "a": 2.63462257385254,
    "b": 8.31981182098389,
    "C": 8.7269983291626,
    "h": 72.4286422729492,
    "CMY_C": 0.08669197559357,
    "CMY_M": 0.14119762182236,
    "CMY_Y": 0.20066434144974,
    "CMYK_C": 0,
    "CMYK_M": 0.05967937037349,
    "CMYK_Y": 0.12479072064161,
    "CMYK_K": 0.08669197559357
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00392",
    "Farbtonhilfsbezeichnung": "Bison 16",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "209",
    "Bcolor": "193",
    "Y": 70,
    "L": 84.4877090454102,
    "a": 1.85488831996918,
    "b": 8.93885135650635,
    "C": 9.12927532196045,
    "h": 78.2770080566406,
    "CMY_C": 0.13118880987167,
    "CMY_M": 0.17946010828018,
    "CMY_Y": 0.24449318647385,
    "CMYK_C": 0,
    "CMYK_M": 0.05556017160416,
    "CMYK_Y": 0.13041311502457,
    "CMYK_K": 0.13118880987167
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00410",
    "Farbtonhilfsbezeichnung": "Schiefer 14 H",
    "Farbtonklasse": "01",
    "Y": 39,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00413",
    "Farbtonhilfsbezeichnung": "Aprikose 15",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "205",
    "Bcolor": "150",
    "Y": 70,
    "L": 84.9921264648438,
    "a": 8.51925182342529,
    "b": 32.4723472595215,
    "C": 33.5712814331055,
    "h": 75.2995223999023,
    "CMY_C": 0.02483361959457,
    "CMY_M": 0.19567459821701,
    "CMY_Y": 0.41150683164597,
    "CMYK_C": 0,
    "CMYK_M": 0.17519162595272,
    "CMYK_Y": 0.39652025699615,
    "CMYK_K": 0.02483361959457
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00414",
    "Farbtonhilfsbezeichnung": "Olive 17",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "226",
    "Bcolor": "197",
    "Y": 81,
    "L": 89.891471862793,
    "a": -0.89704436063766,
    "b": 14.1978845596313,
    "C": 14.2261943817139,
    "h": 93.6152267456055,
    "CMY_C": 0.07642668485641,
    "CMY_M": 0.11461579799652,
    "CMY_Y": 0.2255049943924,
    "CMYK_C": 0,
    "CMYK_M": 0.04134930297732,
    "CMYK_Y": 0.1614146977663,
    "CMYK_K": 0.07642668485641
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00443",
    "Farbtonhilfsbezeichnung": "Schiefer 0",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "87",
    "Bcolor": "82",
    "Y": 8,
    "L": 36.9308891296387,
    "a": 0.30724772810936,
    "b": 2.69557404518127,
    "C": 2.71302795410156,
    "h": 83.4973602294922,
    "CMY_C": 0.64983153343201,
    "CMY_M": 0.66030889749527,
    "CMY_Y": 0.67886340618134,
    "CMYK_C": 0,
    "CMYK_M": 0.02992092445493,
    "CMYK_Y": 0.08290830254555,
    "CMYK_K": 0.64983153343201
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00453",
    "Farbtonhilfsbezeichnung": "Terra 18",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "225",
    "Bcolor": "204",
    "Y": 83,
    "L": 90.5039367675781,
    "a": 3.90191698074341,
    "b": 11.5052680969238,
    "C": 12.1489152908325,
    "h": 71.2660598754883,
    "CMY_C": 0.04141718149185,
    "CMY_M": 0.11869430541992,
    "CMY_Y": 0.19813644886017,
    "CMYK_C": 0,
    "CMYK_M": 0.08061601221561,
    "CMYK_Y": 0.16349059343338,
    "CMYK_K": 0.04141718149185
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00473",
    "Farbtonhilfsbezeichnung": "Lava 17",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "221",
    "Bcolor": "206",
    "Y": 78,
    "L": 88.4962692260742,
    "a": 1.19636130332947,
    "b": 7.53381013870239,
    "C": 7.62820911407471,
    "h": 80.9768295288086,
    "CMY_C": 0.09558844566345,
    "CMY_M": 0.13336980342865,
    "CMY_Y": 0.19100457429886,
    "CMYK_C": 0,
    "CMYK_M": 0.04177451878786,
    "CMYK_Y": 0.10550078749657,
    "CMYK_K": 0.09558844566345
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00498",
    "Farbtonhilfsbezeichnung": "Terra 17",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "220",
    "Bcolor": "193",
    "Y": 77,
    "L": 89.0770950317383,
    "a": 4.97576379776001,
    "b": 15.4420747756958,
    "C": 16.2239303588867,
    "h": 72.1399612426758,
    "CMY_C": 0.03935122489929,
    "CMY_M": 0.13814359903336,
    "CMY_Y": 0.24252563714981,
    "CMYK_C": 0,
    "CMYK_M": 0.10283922404051,
    "CMYK_Y": 0.21149708330631,
    "CMYK_K": 0.03935122489929
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00499",
    "Farbtonhilfsbezeichnung": "Maroc 18",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "228",
    "Bcolor": "208",
    "Y": 84,
    "L": 90.8431701660156,
    "a": 0.82434666156769,
    "b": 10.3291921615601,
    "C": 10.3620347976685,
    "h": 85.4370422363281,
    "CMY_C": 0.06381046772003,
    "CMY_M": 0.10715436935425,
    "CMY_Y": 0.18621456623077,
    "CMYK_C": 0,
    "CMYK_M": 0.04629821330309,
    "CMYK_Y": 0.13074713945389,
    "CMYK_K": 0.06381046772003
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00510",
    "Farbtonhilfsbezeichnung": "Taiga 17",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "220",
    "Bcolor": "199",
    "Y": 78,
    "L": 87.9360122680664,
    "a": 0.65284955501556,
    "b": 10.7413148880005,
    "C": 10.7611360549927,
    "h": 86.5218811035156,
    "CMY_C": 0.09652692079544,
    "CMY_M": 0.1391042470932,
    "CMY_Y": 0.22079408168793,
    "CMYK_C": 0,
    "CMYK_M": 0.0471262820065,
    "CMYK_Y": 0.13754384219646,
    "CMYK_K": 0.09652692079544
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00515",
    "Farbtonhilfsbezeichnung": "Marone 16",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "206",
    "Bcolor": "189",
    "Y": 70,
    "L": 84.209342956543,
    "a": 5.03288412094116,
    "b": 10.659291267395,
    "C": 11.7877225875854,
    "h": 64.7252197265625,
    "CMY_C": 0.10636913776398,
    "CMY_M": 0.19061630964279,
    "CMY_Y": 0.25953841209412,
    "CMYK_C": 0,
    "CMYK_M": 0.09427513927221,
    "CMYK_Y": 0.17140105366707,
    "CMYK_K": 0.10636913776398
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00517",
    "Farbtonhilfsbezeichnung": "Amazonas 16",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "220",
    "Bcolor": "191",
    "Y": 73,
    "L": 86.6215133666992,
    "a": -6.19544506072998,
    "b": 12.9928922653198,
    "C": 14.394401550293,
    "h": 115.493362426758,
    "CMY_C": 0.15652632713318,
    "CMY_M": 0.13837200403214,
    "CMY_Y": 0.25259310007095,
    "CMYK_C": 0.02106979303062,
    "CMYK_M": 0,
    "CMYK_Y": 0.13256427645683,
    "CMYK_K": 0.13837200403214
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00538",
    "Farbtonhilfsbezeichnung": "Bison 15",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "193",
    "Bcolor": "173",
    "Y": 60,
    "L": 79.0533752441406,
    "a": 2.76870965957642,
    "b": 11.3730316162109,
    "C": 11.7051954269409,
    "h": 76.3177642822266,
    "CMY_C": 0.17789781093597,
    "CMY_M": 0.24136221408844,
    "CMY_Y": 0.31977319717407,
    "CMYK_C": 0,
    "CMYK_M": 0.07719770818949,
    "CMYK_Y": 0.17257633805275,
    "CMYK_K": 0.17789781093597
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00544",
    "Farbtonhilfsbezeichnung": "Iris 0",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "105",
    "Bcolor": "120",
    "Y": 14,
    "L": 42.7293357849121,
    "a": -6.52162647247314,
    "b": -12.5282745361328,
    "C": 14.1240673065185,
    "h": 242.50065612793,
    "CMY_C": 0.7052149772644,
    "CMY_M": 0.58805125951767,
    "CMY_Y": 0.52835530042648,
    "CMYK_C": 0.37498497962952,
    "CMYK_M": 0.12656976282597,
    "CMYK_Y": 0,
    "CMYK_K": 0.52835530042648
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00559",
    "Farbtonhilfsbezeichnung": "Bison 14",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "177",
    "Bcolor": "154",
    "Y": 49,
    "L": 73.2676315307617,
    "a": 3.22806239128113,
    "b": 13.4590692520142,
    "C": 13.8407707214356,
    "h": 76.5127792358398,
    "CMY_C": 0.2326819896698,
    "CMY_M": 0.30492156744003,
    "CMY_Y": 0.39491856098175,
    "CMYK_C": 0,
    "CMYK_M": 0.09414555132389,
    "CMYK_Y": 0.21143329143524,
    "CMYK_K": 0.2326819896698
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00565",
    "Farbtonhilfsbezeichnung": "Nutria 12",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "128",
    "Bcolor": "106",
    "Y": 24,
    "L": 55.7993659973145,
    "a": 8.09322261810303,
    "b": 15.7472410202026,
    "C": 17.705249786377,
    "h": 62.7993087768555,
    "CMY_C": 0.38331478834152,
    "CMY_M": 0.49739891290665,
    "CMY_Y": 0.58452212810516,
    "CMYK_C": 0,
    "CMYK_M": 0.18499572575092,
    "CMYK_Y": 0.32627236843109,
    "CMYK_K": 0.38331478834152
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00568",
    "Farbtonhilfsbezeichnung": "Siam 14",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "178",
    "Bcolor": "165",
    "Y": 46,
    "L": 73.5154113769531,
    "a": 4.12110090255737,
    "b": 7.69374227523804,
    "C": 8.727952003479,
    "h": 61.8245697021484,
    "CMY_C": 0.23867845535278,
    "CMY_M": 0.30299198627472,
    "CMY_Y": 0.3512892127037,
    "CMYK_C": 0,
    "CMYK_M": 0.08447617292404,
    "CMYK_Y": 0.14791484177113,
    "CMYK_K": 0.23867845535278
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00573",
    "Farbtonhilfsbezeichnung": "Island 11",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "125",
    "Bcolor": "101",
    "Y": 19,
    "L": 51.6363716125488,
    "a": -4.8502836227417,
    "b": 12.1534509658813,
    "C": 13.0855503082275,
    "h": 111.756301879883,
    "CMY_C": 0.51749646663666,
    "CMY_M": 0.50986474752426,
    "CMY_Y": 0.60249781608582,
    "CMYK_C": 0.01557063870132,
    "CMYK_M": 0,
    "CMYK_Y": 0.18899491429329,
    "CMYK_K": 0.50986474752426
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00577",
    "Farbtonhilfsbezeichnung": "Olive 16",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "221",
    "Bcolor": "186",
    "Y": 76,
    "L": 88.1291046142578,
    "a": -1.54499292373657,
    "b": 17.5422763824463,
    "C": 17.6101799011231,
    "h": 95.0331954956055,
    "CMY_C": 0.09199208021164,
    "CMY_M": 0.1334348320961,
    "CMY_Y": 0.26933664083481,
    "CMYK_C": 0,
    "CMYK_M": 0.04564139991999,
    "CMYK_Y": 0.1953116953373,
    "CMYK_K": 0.09199208021164
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00588",
    "Farbtonhilfsbezeichnung": "Aprikose 13 H",
    "Farbtonklasse": "02",
    "Y": 54,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00589",
    "Farbtonhilfsbezeichnung": "Schiefer 18",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "218",
    "Bcolor": "208",
    "Y": 76,
    "L": 86.9391632080078,
    "a": -0.12587851285934,
    "b": 4.50615072250366,
    "C": 4.5079083442688,
    "h": 91.6001281738281,
    "CMY_C": 0.13234478235245,
    "CMY_M": 0.14664024114609,
    "CMY_Y": 0.18586081266403,
    "CMYK_C": 0,
    "CMYK_M": 0.01647596620023,
    "CMYK_Y": 0.06167891249061,
    "CMYK_K": 0.13234478235245
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00592",
    "Farbtonhilfsbezeichnung": "Schiefer 17",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "209",
    "Bcolor": "199",
    "Y": 68,
    "L": 83.7487640380859,
    "a": -0.0953765437007,
    "b": 4.53697729110718,
    "C": 4.53797960281372,
    "h": 91.2042922973633,
    "CMY_C": 0.16720932722092,
    "CMY_M": 0.18180167675018,
    "CMY_Y": 0.22063827514648,
    "CMYK_C": 0,
    "CMYK_M": 0.01752222888172,
    "CMYK_Y": 0.06415651738644,
    "CMYK_K": 0.16720932722092
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00602",
    "Farbtonhilfsbezeichnung": "Taiga 16",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "215",
    "Bcolor": "191",
    "Y": 72,
    "L": 86.5376663208008,
    "a": 1.20722496509552,
    "b": 12.6484928131104,
    "C": 12.7059736251831,
    "h": 84.547966003418,
    "CMY_C": 0.1027165055275,
    "CMY_M": 0.15633279085159,
    "CMY_Y": 0.24978965520859,
    "CMYK_C": 0,
    "CMYK_M": 0.05975400656462,
    "CMYK_Y": 0.16390934586525,
    "CMYK_K": 0.1027165055275
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00608",
    "Farbtonhilfsbezeichnung": "Mandarin 17",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "196",
    "Y": 84,
    "L": 91.4697418212891,
    "a": 1.00001633167267,
    "b": 17.3582229614258,
    "C": 17.3870048522949,
    "h": 86.7028045654297,
    "CMY_C": 0.03603672981262,
    "CMY_M": 0.10234332084656,
    "CMY_Y": 0.23168784379959,
    "CMYK_C": 0,
    "CMYK_M": 0.06878539174795,
    "CMYK_Y": 0.20296531915665,
    "CMYK_K": 0.03603672981262
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00613",
    "Farbtonhilfsbezeichnung": "Siam 15",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "195",
    "Bcolor": "183",
    "Y": 57,
    "L": 79.4779739379883,
    "a": 3.00178003311157,
    "b": 6.60282850265503,
    "C": 7.25313901901245,
    "h": 65.552490234375,
    "CMY_C": 0.18475794792175,
    "CMY_M": 0.23611825704575,
    "CMY_Y": 0.28087890148163,
    "CMYK_C": 0,
    "CMYK_M": 0.06300007551908,
    "CMYK_Y": 0.11790480464697,
    "CMYK_K": 0.18475794792175
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00626",
    "Farbtonhilfsbezeichnung": "Cognac 17",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "225",
    "Bcolor": "197",
    "Y": 83,
    "L": 90.4990921020508,
    "a": 3.03719973564148,
    "b": 15.6324014663696,
    "C": 15.9247150421143,
    "h": 79.0050582885742,
    "CMY_C": 0.03669619560242,
    "CMY_M": 0.11766546964645,
    "CMY_Y": 0.22895747423172,
    "CMYK_C": 0,
    "CMYK_M": 0.0840537250042,
    "CMYK_Y": 0.19958530366421,
    "CMYK_K": 0.03669619560242
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00637",
    "Farbtonhilfsbezeichnung": "Nutria 16",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "208",
    "Bcolor": "191",
    "Y": 69,
    "L": 84.4187088012695,
    "a": 3.09389638900757,
    "b": 9.64148330688477,
    "C": 10.1257295608521,
    "h": 72.2088623046875,
    "CMY_C": 0.12086629867554,
    "CMY_M": 0.18336164951324,
    "CMY_Y": 0.25017243623734,
    "CMYK_C": 0,
    "CMYK_M": 0.07108742743731,
    "CMYK_Y": 0.14708358049393,
    "CMYK_K": 0.12086629867554
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00639",
    "Farbtonhilfsbezeichnung": "Malaga 18",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "226",
    "Bcolor": "211",
    "Y": 83,
    "L": 90.6831741333008,
    "a": 2.99475932121277,
    "b": 8.25551319122314,
    "C": 8.78191757202148,
    "h": 70.0613174438477,
    "CMY_C": 0.05537736415863,
    "CMY_M": 0.11363482475281,
    "CMY_Y": 0.17225158214569,
    "CMYK_C": 0,
    "CMYK_M": 0.061672732234,
    "CMYK_Y": 0.12372583150864,
    "CMYK_K": 0.05537736415863
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00648",
    "Farbtonhilfsbezeichnung": "Basalt 15",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "198",
    "Bcolor": "193",
    "Y": 60,
    "L": 79.9170608520508,
    "a": -0.00310877873562,
    "b": 1.70197987556458,
    "C": 1.70198273658752,
    "h": 90.1046524047852,
    "CMY_C": 0.21744626760483,
    "CMY_M": 0.22301316261292,
    "CMY_Y": 0.24131923913956,
    "CMYK_C": 0,
    "CMYK_M": 0.00711375428364,
    "CMYK_Y": 0.03050649538636,
    "CMYK_K": 0.21744626760483
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00652",
    "Farbtonhilfsbezeichnung": "Aprikose 14",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "191",
    "Bcolor": "125",
    "Y": 63,
    "L": 81.1324157714844,
    "a": 12.8720483779907,
    "b": 40.4577865600586,
    "C": 42.4561195373535,
    "h": 72.3510131835938,
    "CMY_C": 0.02873510122299,
    "CMY_M": 0.25028192996979,
    "CMY_Y": 0.51025038957596,
    "CMYK_C": 0,
    "CMYK_M": 0.22810134291649,
    "CMYK_Y": 0.49576103687286,
    "CMYK_K": 0.02873510122299
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00655",
    "Farbtonhilfsbezeichnung": "Marone 17",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "219",
    "Bcolor": "203",
    "Y": 77,
    "L": 88.3722915649414,
    "a": 3.22543096542358,
    "b": 9.32077789306641,
    "C": 9.86307811737061,
    "h": 70.9119491577148,
    "CMY_C": 0.07658559083939,
    "CMY_M": 0.14009779691696,
    "CMY_Y": 0.20520824193954,
    "CMYK_C": 0,
    "CMYK_M": 0.06877974420786,
    "CMYK_Y": 0.13929027318954,
    "CMYK_K": 0.07658559083939
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00656",
    "Farbtonhilfsbezeichnung": "Island 16",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "215",
    "Bcolor": "197",
    "Y": 72,
    "L": 85.5463409423828,
    "a": -2.09674072265625,
    "b": 8.09122180938721,
    "C": 8.35848045349121,
    "h": 104.527931213379,
    "CMY_C": 0.15166985988617,
    "CMY_M": 0.15834927558899,
    "CMY_Y": 0.22750759124756,
    "CMYK_C": 0,
    "CMYK_M": 0.00787360407412,
    "CMYK_Y": 0.08939648419619,
    "CMYK_K": 0.15166985988617
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00657",
    "Farbtonhilfsbezeichnung": "Taiga 18",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "228",
    "Bcolor": "209",
    "Y": 83,
    "L": 90.745719909668,
    "a": 0.45496946573257,
    "b": 9.33431720733643,
    "C": 9.34539890289307,
    "h": 87.2095184326172,
    "CMY_C": 0.07061910629272,
    "CMY_M": 0.10709774494171,
    "CMY_Y": 0.17995369434357,
    "CMYK_C": 0,
    "CMYK_M": 0.03925047069788,
    "CMYK_Y": 0.11764238774776,
    "CMYK_K": 0.07061910629272
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00658",
    "Farbtonhilfsbezeichnung": "Havanna 13",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "160",
    "Bcolor": "126",
    "Y": 40,
    "L": 68.2876205444336,
    "a": 9.1831111907959,
    "b": 22.3628559112549,
    "C": 24.1749229431152,
    "h": 67.674919128418,
    "CMY_C": 0.22871202230453,
    "CMY_M": 0.3736686706543,
    "CMY_Y": 0.50752055644989,
    "CMYK_C": 0,
    "CMYK_M": 0.18794101476669,
    "CMYK_Y": 0.36148434877396,
    "CMYK_K": 0.22871202230453
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00662",
    "Farbtonhilfsbezeichnung": "Nutria 14",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "181",
    "Bcolor": "160",
    "Y": 50,
    "L": 75.0492706298828,
    "a": 4.38186407089233,
    "b": 13.0684938430786,
    "C": 13.7835502624512,
    "h": 71.4636993408203,
    "CMY_C": 0.20619314908981,
    "CMY_M": 0.28859424591064,
    "CMY_Y": 0.37352478504181,
    "CMYK_C": 0,
    "CMYK_M": 0.10380496829748,
    "CMYK_Y": 0.21079641580582,
    "CMYK_K": 0.20619314908981
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00663",
    "Farbtonhilfsbezeichnung": "Mandarin 13",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "193",
    "Bcolor": "110",
    "Y": 63,
    "L": 81.4356842041016,
    "a": 11.0363082885742,
    "b": 48.1227684020996,
    "C": 49.3720664978027,
    "h": 77.0833435058594,
    "CMY_C": 0.02594804763794,
    "CMY_M": 0.24345237016678,
    "CMY_Y": 0.56707298755646,
    "CMYK_C": 0,
    "CMYK_M": 0.22329847514629,
    "CMYK_Y": 0.55554014444351,
    "CMYK_K": 0.02594804763794
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00664",
    "Farbtonhilfsbezeichnung": "Mandarin 14",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "206",
    "Bcolor": "140",
    "Y": 71,
    "L": 85.092399597168,
    "a": 7.57277917861938,
    "b": 37.7011528015137,
    "C": 38.4541778564453,
    "h": 78.6425094604492,
    "CMY_C": 0.02068686485291,
    "CMY_M": 0.19316804409027,
    "CMY_Y": 0.45014292001724,
    "CMYK_C": 0,
    "CMYK_M": 0.17612464725971,
    "CMYK_Y": 0.43852782249451,
    "CMYK_K": 0.02068686485291
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00666",
    "Farbtonhilfsbezeichnung": "Siam 12",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "125",
    "Bcolor": "113",
    "Y": 21,
    "L": 53.8914031982422,
    "a": 5.28724050521851,
    "b": 8.56624031066895,
    "C": 10.0665473937988,
    "h": 58.3163528442383,
    "CMY_C": 0.43611657619476,
    "CMY_M": 0.50834357738495,
    "CMY_Y": 0.55527985095978,
    "CMYK_C": 0,
    "CMYK_M": 0.12808853387833,
    "CMYK_Y": 0.21132607758045,
    "CMYK_K": 0.43611657619476
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00668",
    "Farbtonhilfsbezeichnung": "Mandarin 18",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "204",
    "Y": 87,
    "L": 92.2847213745117,
    "a": 0.9630189538002,
    "b": 14.2799406051636,
    "C": 14.3123760223389,
    "h": 86.1418914794922,
    "CMY_C": 0.03530859947205,
    "CMY_M": 0.09241479635239,
    "CMY_Y": 0.19991606473923,
    "CMYK_C": 0,
    "CMYK_M": 0.05919633805752,
    "CMYK_Y": 0.17063225805759,
    "CMYK_K": 0.03530859947205
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00671",
    "Farbtonhilfsbezeichnung": "Iris 18",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "225",
    "Bcolor": "220",
    "Y": 82,
    "L": 89.1610107421875,
    "a": -2.41437697410583,
    "b": 0.96255296468735,
    "C": 2.59917759895325,
    "h": 158.264038085938,
    "CMY_C": 0.13754087686539,
    "CMY_M": 0.11570912599564,
    "CMY_Y": 0.13581585884094,
    "CMYK_C": 0.02468842640519,
    "CMYK_M": 0,
    "CMYK_Y": 0.02273769117892,
    "CMYK_K": 0.11570912599564
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00672",
    "Farbtonhilfsbezeichnung": "Iris 17",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "220",
    "Bcolor": "220",
    "Y": 77,
    "L": 86.7778854370117,
    "a": -4.68540334701538,
    "b": -2.32205438613892,
    "C": 5.22923898696899,
    "h": 206.362701416016,
    "CMY_C": 0.19414979219437,
    "CMY_M": 0.13600999116898,
    "CMY_Y": 0.13816165924072,
    "CMYK_C": 0.06729221343994,
    "CMYK_M": 0,
    "CMYK_Y": 0.00249038543552,
    "CMYK_K": 0.13600999116898
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00673",
    "Farbtonhilfsbezeichnung": "Mandarin 16",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "224",
    "Bcolor": "183",
    "Y": 81,
    "L": 90.1172256469727,
    "a": 2.4174861907959,
    "b": 22.333890914917,
    "C": 22.4643478393555,
    "h": 83.8221817016602,
    "CMY_C": 0.02882957458496,
    "CMY_M": 0.12196588516235,
    "CMY_Y": 0.28308004140854,
    "CMYK_C": 0,
    "CMYK_M": 0.09590110182762,
    "CMYK_Y": 0.26179799437523,
    "CMYK_K": 0.02882957458496
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00674",
    "Farbtonhilfsbezeichnung": "Basalt 14",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "183",
    "Bcolor": "179",
    "Y": 49,
    "L": 74.234375,
    "a": -0.01852784492075,
    "b": 1.00226259231567,
    "C": 1.00243377685547,
    "h": 91.0590515136719,
    "CMY_C": 0.28106075525284,
    "CMY_M": 0.28396677970886,
    "CMY_Y": 0.29687792062759,
    "CMYK_C": 0,
    "CMYK_M": 0.00404210016131,
    "CMYK_Y": 0.02200069837272,
    "CMYK_K": 0.28106075525284
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00677",
    "Farbtonhilfsbezeichnung": "Nutria 18",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "224",
    "Bcolor": "209",
    "Y": 82,
    "L": 89.6442337036133,
    "a": 2.02555561065674,
    "b": 7.61516618728638,
    "C": 7.87995147705078,
    "h": 75.1047973632813,
    "CMY_C": 0.07623720169067,
    "CMY_M": 0.12265688180923,
    "CMY_Y": 0.17899024486542,
    "CMYK_C": 0,
    "CMYK_M": 0.05025064945221,
    "CMYK_Y": 0.11123314499855,
    "CMYK_K": 0.07623720169067
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00684",
    "Farbtonhilfsbezeichnung": "Siam 16",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "208",
    "Bcolor": "199",
    "Y": 67,
    "L": 84.2466354370117,
    "a": 2.63593339920044,
    "b": 5.41449308395386,
    "C": 6.02203273773193,
    "h": 64.0418243408203,
    "CMY_C": 0.13841980695724,
    "CMY_M": 0.18303781747818,
    "CMY_Y": 0.22126430273056,
    "CMYK_C": 0,
    "CMYK_M": 0.05178625509143,
    "CMYK_Y": 0.09615413099527,
    "CMYK_K": 0.13841980695724
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00691",
    "Farbtonhilfsbezeichnung": "Siam 11",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "102",
    "Bcolor": "94",
    "Y": 13,
    "L": 44.7413482666016,
    "a": 5.61451816558838,
    "b": 6.8518123626709,
    "C": 8.85833740234375,
    "h": 50.6680908203125,
    "CMY_C": 0.53070604801178,
    "CMY_M": 0.59842073917389,
    "CMY_Y": 0.63171082735062,
    "CMYK_C": 0,
    "CMYK_M": 0.1442905664444,
    "CMYK_Y": 0.21522711217403,
    "CMYK_K": 0.53070604801178
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00692",
    "Farbtonhilfsbezeichnung": "Terra 13",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "163",
    "Bcolor": "124",
    "Y": 44,
    "L": 70.738883972168,
    "a": 13.8902025222778,
    "b": 26.8057289123535,
    "C": 30.1908073425293,
    "h": 62.6076927185059,
    "CMY_C": 0.16394686698914,
    "CMY_M": 0.36093521118164,
    "CMY_Y": 0.51376068592072,
    "CMYK_C": 0,
    "CMYK_M": 0.23561701178551,
    "CMYK_Y": 0.41841098666191,
    "CMYK_K": 0.16394686698914
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00694",
    "Farbtonhilfsbezeichnung": "Palma 11",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "120",
    "Bcolor": "84",
    "Y": 18,
    "L": 50.4333534240723,
    "a": -1.20647954940796,
    "b": 20.8147811889648,
    "C": 20.8497180938721,
    "h": 93.3172988891602,
    "CMY_C": 0.48722922801971,
    "CMY_M": 0.53089654445648,
    "CMY_Y": 0.67140567302704,
    "CMYK_C": 0,
    "CMYK_M": 0.08515952527523,
    "CMYK_Y": 0.35917890071869,
    "CMYK_K": 0.48722922801971
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00701",
    "Farbtonhilfsbezeichnung": "Mais 14",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "216",
    "Bcolor": "141",
    "Y": 78,
    "L": 87.9072418212891,
    "a": 3.38960409164429,
    "b": 40.9111709594727,
    "C": 41.0513496398926,
    "h": 85.2637023925781,
    "CMY_C": 0.01006120443344,
    "CMY_M": 0.15246856212616,
    "CMY_Y": 0.44669187068939,
    "CMYK_C": 0,
    "CMYK_M": 0.14385470747948,
    "CMYK_Y": 0.44106835126877,
    "CMYK_K": 0.01006120443344
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00704",
    "Farbtonhilfsbezeichnung": "Aprikose 17",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "221",
    "Bcolor": "185",
    "Y": 81,
    "L": 89.5621490478516,
    "a": 4.24914407730103,
    "b": 20.5641288757324,
    "C": 20.9985389709473,
    "h": 78.3253402709961,
    "CMY_C": 0.02636247873306,
    "CMY_M": 0.13220101594925,
    "CMY_Y": 0.2754727602005,
    "CMYK_C": 0,
    "CMYK_M": 0.10870425403118,
    "CMYK_Y": 0.25585526227951,
    "CMYK_K": 0.02636247873306
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00705",
    "Farbtonhilfsbezeichnung": "Nutria 13",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "157",
    "Bcolor": "132",
    "Y": 38,
    "L": 66.666862487793,
    "a": 6.80843305587769,
    "b": 16.1907157897949,
    "C": 17.5639991760254,
    "h": 67.1925354003906,
    "CMY_C": 0.27410471439362,
    "CMY_M": 0.38343220949173,
    "CMY_Y": 0.48075079917908,
    "CMYK_C": 0,
    "CMYK_M": 0.15061056613922,
    "CMYK_Y": 0.28467753529549,
    "CMYK_K": 0.27410471439362
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00706",
    "Farbtonhilfsbezeichnung": "Gobi 16",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "222",
    "Bcolor": "180",
    "Y": 80,
    "L": 89.7257461547852,
    "a": 3.0588493347168,
    "b": 23.174108505249,
    "C": 23.3751125335693,
    "h": 82.4807510375977,
    "CMY_C": 0.02678781747818,
    "CMY_M": 0.12805849313736,
    "CMY_Y": 0.2934073805809,
    "CMYK_C": 0,
    "CMYK_M": 0.10405816882849,
    "CMYK_Y": 0.27395829558372,
    "CMYK_K": 0.02678781747818
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00708",
    "Farbtonhilfsbezeichnung": "Terra 11",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "117",
    "Bcolor": "84",
    "Y": 21,
    "L": 53.914306640625,
    "a": 17.030122756958,
    "b": 25.874418258667,
    "C": 30.9759674072266,
    "h": 56.6477355957031,
    "CMY_C": 0.33481723070145,
    "CMY_M": 0.54077041149139,
    "CMY_Y": 0.66950803995132,
    "CMYK_C": 0,
    "CMYK_M": 0.30961894989014,
    "CMYK_Y": 0.50315618515015,
    "CMYK_K": 0.33481723070145
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00710",
    "Farbtonhilfsbezeichnung": "Basalt 17",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "218",
    "Bcolor": "210",
    "Y": 76,
    "L": 86.9704742431641,
    "a": 0.15759879350662,
    "b": 3.3473060131073,
    "C": 3.35101389884949,
    "h": 87.3043746948242,
    "CMY_C": 0.13353139162064,
    "CMY_M": 0.14664578437805,
    "CMY_Y": 0.17697739601135,
    "CMYK_C": 0,
    "CMYK_M": 0.01513545028865,
    "CMYK_Y": 0.05014146491885,
    "CMYK_K": 0.13353139162064
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00711",
    "Farbtonhilfsbezeichnung": "Havanna 15",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "196",
    "Bcolor": "168",
    "Y": 61,
    "L": 80.5319595336914,
    "a": 5.53769254684448,
    "b": 16.2910346984863,
    "C": 17.206506729126,
    "h": 71.2259368896484,
    "CMY_C": 0.12964177131653,
    "CMY_M": 0.23322880268097,
    "CMY_Y": 0.33935993909836,
    "CMYK_C": 0,
    "CMYK_M": 0.11901655048132,
    "CMYK_Y": 0.24095614254475,
    "CMYK_K": 0.12964177131653
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00712",
    "Farbtonhilfsbezeichnung": "Taiga 14",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "188",
    "Bcolor": "152",
    "Y": 54,
    "L": 77.212028503418,
    "a": 2.07550501823425,
    "b": 20.2337188720703,
    "C": 20.3398895263672,
    "h": 84.1432800292969,
    "CMY_C": 0.18130344152451,
    "CMY_M": 0.26159679889679,
    "CMY_Y": 0.40304744243622,
    "CMYK_C": 0,
    "CMYK_M": 0.09807462245226,
    "CMYK_Y": 0.27085003256798,
    "CMYK_K": 0.18130344152451
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00713",
    "Farbtonhilfsbezeichnung": "Granat 12",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "117",
    "Bcolor": "103",
    "Y": 23,
    "L": 55.1291046142578,
    "a": 21.7286548614502,
    "b": 16.7907485961914,
    "C": 27.4602203369141,
    "h": 37.694938659668,
    "CMY_C": 0.30835443735123,
    "CMY_M": 0.53986132144928,
    "CMY_Y": 0.5955057144165,
    "CMYK_C": 0,
    "CMYK_M": 0.33471897244453,
    "CMYK_Y": 0.41517114639282,
    "CMYK_K": 0.30835443735123
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00714",
    "Farbtonhilfsbezeichnung": "Mistral 13",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "186",
    "Bcolor": "129",
    "Y": 54,
    "L": 77.9354705810547,
    "a": 7.78985500335693,
    "b": 33.6480255126953,
    "C": 34.537971496582,
    "h": 76.9650955200195,
    "CMY_C": 0.10887002944946,
    "CMY_M": 0.27037388086319,
    "CMY_Y": 0.49270814657211,
    "CMYK_C": 0,
    "CMYK_M": 0.18123489618301,
    "CMYK_Y": 0.43073192238808,
    "CMYK_K": 0.10887002944946
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00715",
    "Farbtonhilfsbezeichnung": "Island 15",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "208",
    "Bcolor": "188",
    "Y": 64,
    "L": 83.2453842163086,
    "a": -2.58754348754883,
    "b": 9.54708862304688,
    "C": 9.891526222229,
    "h": 105.164543151855,
    "CMY_C": 0.17633801698685,
    "CMY_M": 0.18285447359085,
    "CMY_Y": 0.26290309429169,
    "CMYK_C": 0,
    "CMYK_M": 0.00791156664491,
    "CMYK_Y": 0.1050978153944,
    "CMYK_K": 0.17633801698685
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00716",
    "Farbtonhilfsbezeichnung": "Maroc 13",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "175",
    "Bcolor": "130",
    "Y": 47,
    "L": 74.2567977905273,
    "a": 9.55469989776611,
    "b": 28.3159141540527,
    "C": 29.8844985961914,
    "h": 71.3539505004883,
    "CMY_C": 0.14868360757828,
    "CMY_M": 0.31300711631775,
    "CMY_Y": 0.4903005361557,
    "CMYK_C": 0,
    "CMYK_M": 0.1930228471756,
    "CMYK_Y": 0.40128082036972,
    "CMYK_K": 0.14868360757828
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00717",
    "Farbtonhilfsbezeichnung": "Taiga 13",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "169",
    "Bcolor": "129",
    "Y": 43,
    "L": 70.4702224731445,
    "a": 3.24382781982422,
    "b": 23.4636650085449,
    "C": 23.6868324279785,
    "h": 82.1288070678711,
    "CMY_C": 0.24086946249008,
    "CMY_M": 0.3367006778717,
    "CMY_Y": 0.49466013908386,
    "CMYK_C": 0,
    "CMYK_M": 0.12623812258244,
    "CMYK_Y": 0.33431756496429,
    "CMYK_K": 0.24086946249008
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00720",
    "Farbtonhilfsbezeichnung": "Siam 17",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "218",
    "Bcolor": "206",
    "Y": 74,
    "L": 87.4609298706055,
    "a": 1.73492348194122,
    "b": 6.3456130027771,
    "C": 6.57850790023804,
    "h": 74.7087326049805,
    "CMY_C": 0.10666185617447,
    "CMY_M": 0.14578795433044,
    "CMY_Y": 0.19342577457428,
    "CMYK_C": 0,
    "CMYK_M": 0.04379763454199,
    "CMYK_Y": 0.09712326526642,
    "CMYK_K": 0.10666185617447
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00723",
    "Farbtonhilfsbezeichnung": "Marone 18",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 81,
    "L": 88.8501815795898,
    "a": 2.4535231590271,
    "b": 7.74687767028809,
    "C": 8.12612342834473,
    "h": 72.4264144897461,
    "CMY_C": 0.08153766393661,
    "CMY_M": 0.1325266957283,
    "CMY_Y": 0.18853914737701,
    "CMYK_C": 0,
    "CMYK_M": 0.05551564693451,
    "CMYK_Y": 0.11650067567825,
    "CMYK_K": 0.08153766393661
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00724",
    "Farbtonhilfsbezeichnung": "Granat 17",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "215",
    "Bcolor": "203",
    "Y": 74,
    "L": 87.5779418945313,
    "a": 6.49626350402832,
    "b": 8.20563697814941,
    "C": 10.4658451080322,
    "h": 51.6319389343262,
    "CMY_C": 0.06469976902008,
    "CMY_M": 0.15661460161209,
    "CMY_Y": 0.20510053634644,
    "CMYK_C": 0,
    "CMYK_M": 0.09827307611704,
    "CMYK_Y": 0.15011304616928,
    "CMYK_K": 0.06469976902008
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00729",
    "Farbtonhilfsbezeichnung": "Palma 12",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "140",
    "Bcolor": "99",
    "Y": 28,
    "L": 58.5940742492676,
    "a": -0.00583014218137,
    "b": 23.6616535186768,
    "C": 23.6616535186768,
    "h": 90.0141220092773,
    "CMY_C": 0.38954067230225,
    "CMY_M": 0.4522078037262,
    "CMY_Y": 0.6133861541748,
    "CMYK_C": 0,
    "CMYK_M": 0.10265570133924,
    "CMYK_Y": 0.36668369174004,
    "CMYK_K": 0.38954067230225
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00731",
    "Farbtonhilfsbezeichnung": "Schilf 12",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "176",
    "Bcolor": "106",
    "Y": 46,
    "L": 72.9153060913086,
    "a": 0.87384587526321,
    "b": 38.981861114502,
    "C": 38.9916534423828,
    "h": 88.7158279418945,
    "CMY_C": 0.20168590545654,
    "CMY_M": 0.30809241533279,
    "CMY_Y": 0.58462929725647,
    "CMYK_C": 0,
    "CMYK_M": 0.13328902423382,
    "CMYK_Y": 0.4796901345253,
    "CMYK_K": 0.20168590545654
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00732",
    "Farbtonhilfsbezeichnung": "Schilf 13",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "195",
    "Bcolor": "133",
    "Y": 59,
    "L": 79.6142883300781,
    "a": 1.12209784984589,
    "b": 33.7665824890137,
    "C": 33.7852210998535,
    "h": 88.0967025756836,
    "CMY_C": 0.13325572013855,
    "CMY_M": 0.2361536026001,
    "CMY_Y": 0.47804856300354,
    "CMYK_C": 0,
    "CMYK_M": 0.11871769279242,
    "CMYK_Y": 0.39780226349831,
    "CMYK_K": 0.13325572013855
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00733",
    "Farbtonhilfsbezeichnung": "Tibet 11",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "129",
    "Bcolor": "128",
    "Y": 20,
    "L": 52.5799179077148,
    "a": -5.57552576065063,
    "b": -2.00201678276062,
    "C": 5.92406606674194,
    "h": 199.751815795898,
    "CMY_C": 0.55611777305603,
    "CMY_M": 0.49573522806168,
    "CMY_Y": 0.49936079978943,
    "CMYK_C": 0.11974372714758,
    "CMYK_M": 0,
    "CMYK_Y": 0.00718981772661,
    "CMYK_K": 0.49573522806168
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00735",
    "Farbtonhilfsbezeichnung": "Tibet 13",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "173",
    "Bcolor": "170",
    "Y": 41,
    "L": 69.7838363647461,
    "a": -4.15416145324707,
    "b": -0.40029034018517,
    "C": 4.17340278625488,
    "h": 185.503967285156,
    "CMY_C": 0.36467301845551,
    "CMY_M": 0.32174158096313,
    "CMY_Y": 0.33437818288803,
    "CMYK_C": 0.06329657882452,
    "CMYK_M": 0,
    "CMYK_Y": 0.01863095536828,
    "CMYK_K": 0.32174158096313
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00737",
    "Farbtonhilfsbezeichnung": "Island 12",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "150",
    "Bcolor": "124",
    "Y": 28,
    "L": 61.4038429260254,
    "a": -4.17931318283081,
    "b": 13.2361669540405,
    "C": 13.8803014755249,
    "h": 107.523490905762,
    "CMY_C": 0.41082292795181,
    "CMY_M": 0.41247045993805,
    "CMY_Y": 0.51454067230225,
    "CMYK_C": 0,
    "CMYK_M": 0.00279632746242,
    "CMYK_Y": 0.17603832483292,
    "CMYK_K": 0.41082292795181
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00738",
    "Farbtonhilfsbezeichnung": "Island 13",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "178",
    "Bcolor": "151",
    "Y": 43,
    "L": 72.1991119384766,
    "a": -3.33011245727539,
    "b": 13.5199089050293,
    "C": 13.9239931106567,
    "h": 103.837181091309,
    "CMY_C": 0.29039031267166,
    "CMY_M": 0.3013561964035,
    "CMY_Y": 0.40739178657532,
    "CMYK_C": 0,
    "CMYK_M": 0.01545340195298,
    "CMYK_Y": 0.16488145291805,
    "CMYK_K": 0.29039031267166
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00739",
    "Farbtonhilfsbezeichnung": "Taiga 12",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "141",
    "Bcolor": "101",
    "Y": 29,
    "L": 59.8085021972656,
    "a": 3.74214792251587,
    "b": 23.8336811065674,
    "C": 24.1256713867188,
    "h": 81.076789855957,
    "CMY_C": 0.35261762142181,
    "CMY_M": 0.44830727577209,
    "CMY_Y": 0.60215163230896,
    "CMYK_C": 0,
    "CMYK_M": 0.14781010150909,
    "CMYK_Y": 0.38545072078705,
    "CMYK_K": 0.35261762142181
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00741",
    "Farbtonhilfsbezeichnung": "Lava 11",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "111",
    "Bcolor": "93",
    "Y": 16,
    "L": 47.5230865478516,
    "a": 2.16116523742676,
    "b": 11.0922784805298,
    "C": 11.3008527755737,
    "h": 78.9748992919922,
    "CMY_C": 0.51504349708557,
    "CMY_M": 0.56479179859161,
    "CMY_Y": 0.63350892066956,
    "CMYK_C": 0,
    "CMYK_M": 0.10258302092552,
    "CMYK_Y": 0.24428051710129,
    "CMYK_K": 0.51504349708557
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00742",
    "Farbtonhilfsbezeichnung": "Lava 12",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "134",
    "Bcolor": "111",
    "Y": 25,
    "L": 56.6421241760254,
    "a": 2.17519021034241,
    "b": 14.072286605835,
    "C": 14.2394065856934,
    "h": 81.2131805419922,
    "CMY_C": 0.41531008481979,
    "CMY_M": 0.47493654489517,
    "CMY_Y": 0.56601178646088,
    "CMYK_C": 0,
    "CMYK_M": 0.1019796282053,
    "CMYK_Y": 0.25774636864662,
    "CMYK_K": 0.41531008481979
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00743",
    "Farbtonhilfsbezeichnung": "Olive 11",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "139",
    "Bcolor": "82",
    "Y": 26,
    "L": 58.2123527526855,
    "a": -1.50417423248291,
    "b": 32.2048034667969,
    "C": 32.2399101257324,
    "h": 92.6741409301758,
    "CMY_C": 0.38860666751862,
    "CMY_M": 0.45420622825623,
    "CMY_Y": 0.67789751291275,
    "CMYK_C": 0,
    "CMYK_M": 0.10729518532753,
    "CMYK_Y": 0.4731664955616,
    "CMYK_K": 0.38860666751862
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00744",
    "Farbtonhilfsbezeichnung": "Olive 12",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "160",
    "Bcolor": "97",
    "Y": 36,
    "L": 66.2479400634766,
    "a": -1.53939163684845,
    "b": 34.7028427124023,
    "C": 34.7369689941406,
    "h": 92.5399322509766,
    "CMY_C": 0.29797971248627,
    "CMY_M": 0.37194961309433,
    "CMY_Y": 0.61882972717285,
    "CMYK_C": 0,
    "CMYK_M": 0.1053671836853,
    "CMYK_Y": 0.45703810453415,
    "CMYK_K": 0.29797971248627
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00745",
    "Farbtonhilfsbezeichnung": "Olive 13",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "184",
    "Bcolor": "125",
    "Y": 50,
    "L": 75.2118377685547,
    "a": -0.98791640996933,
    "b": 31.8059902191162,
    "C": 31.8213291168213,
    "h": 91.7790756225586,
    "CMY_C": 0.20043486356735,
    "CMY_M": 0.27818095684052,
    "CMY_Y": 0.50850868225098,
    "CMYK_C": 0,
    "CMYK_M": 0.09723547101021,
    "CMYK_Y": 0.38530170917511,
    "CMYK_K": 0.20043486356735
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00746",
    "Farbtonhilfsbezeichnung": "Malaga 12",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "134",
    "Bcolor": "107",
    "Y": 29,
    "L": 59.8686981201172,
    "a": 14.2392911911011,
    "b": 20.8685398101807,
    "C": 25.2636775970459,
    "h": 55.6929969787598,
    "CMY_C": 0.29307740926743,
    "CMY_M": 0.47274720668793,
    "CMY_Y": 0.57894134521484,
    "CMYK_C": 0,
    "CMYK_M": 0.25415766239166,
    "CMYK_Y": 0.40437799692154,
    "CMYK_K": 0.29307740926743
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00755",
    "Farbtonhilfsbezeichnung": "Island 18",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "228",
    "Bcolor": "212",
    "Y": 83,
    "L": 90.6413269042969,
    "a": -0.77960956096649,
    "b": 7.43350315093994,
    "C": 7.47427320480347,
    "h": 95.9871673583984,
    "CMY_C": 0.08697855472565,
    "CMY_M": 0.10482901334763,
    "CMY_Y": 0.16718989610672,
    "CMYK_C": 0,
    "CMYK_M": 0.01955097354949,
    "CMYK_Y": 0.08785263448954,
    "CMYK_K": 0.08697855472565
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00762",
    "Farbtonhilfsbezeichnung": "Palma 13",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "168",
    "Bcolor": "125",
    "Y": 43,
    "L": 69.3877792358398,
    "a": -0.08788429200649,
    "b": 23.7458362579346,
    "C": 23.7459983825684,
    "h": 90.2120513916016,
    "CMY_C": 0.2742315530777,
    "CMY_M": 0.34046137332916,
    "CMY_Y": 0.50815242528915,
    "CMYK_C": 0,
    "CMYK_M": 0.09125475585461,
    "CMYK_Y": 0.32230785489082,
    "CMYK_K": 0.2742315530777
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00770",
    "Farbtonhilfsbezeichnung": "Granat 18",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "211",
    "Y": 80,
    "L": 89.6077499389648,
    "a": 4.70825481414795,
    "b": 6.86345624923706,
    "C": 8.32314205169678,
    "h": 55.5503120422363,
    "CMY_C": 0.05880433320999,
    "CMY_M": 0.12939530611038,
    "CMY_Y": 0.17343068122864,
    "CMYK_C": 0,
    "CMYK_M": 0.07500138133764,
    "CMYK_Y": 0.12178801000118,
    "CMYK_K": 0.05880433320999
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00783",
    "Farbtonhilfsbezeichnung": "Bison 18",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "224",
    "Bcolor": "209",
    "Y": 81,
    "L": 89.5176544189453,
    "a": 0.82385671138763,
    "b": 7.4344539642334,
    "C": 7.47996282577515,
    "h": 83.676513671875,
    "CMY_C": 0.08728742599487,
    "CMY_M": 0.12113153934479,
    "CMY_Y": 0.17921513319016,
    "CMYK_C": 0,
    "CMYK_M": 0.03708080202341,
    "CMYK_Y": 0.10071922838688,
    "CMYK_K": 0.08728742599487
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00787",
    "Farbtonhilfsbezeichnung": "Maroc 16",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "214",
    "Bcolor": "187",
    "Y": 74,
    "L": 86.9423751831055,
    "a": 4.18110084533691,
    "b": 15.4098968505859,
    "C": 15.9670448303223,
    "h": 74.8196563720703,
    "CMY_C": 0.06931412220001,
    "CMY_M": 0.15973430871964,
    "CMY_Y": 0.26529544591904,
    "CMYK_C": 0,
    "CMYK_M": 0.09715435653925,
    "CMYK_Y": 0.21057730913162,
    "CMYK_K": 0.06931412220001
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00788",
    "Farbtonhilfsbezeichnung": "Havanna 16",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "211",
    "Bcolor": "187",
    "Y": 70,
    "L": 85.623046875,
    "a": 4.21438503265381,
    "b": 13.4168348312378,
    "C": 14.0631608963013,
    "h": 72.5618896484375,
    "CMY_C": 0.08908349275589,
    "CMY_M": 0.17382627725601,
    "CMY_Y": 0.2647345662117,
    "CMYK_C": 0,
    "CMYK_M": 0.09303024411201,
    "CMYK_Y": 0.19282895326614,
    "CMYK_K": 0.08908349275589
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00789",
    "Farbtonhilfsbezeichnung": "Amazonas 18",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "230",
    "Bcolor": "209",
    "Y": 83,
    "L": 90.6447067260742,
    "a": -3.07137107849121,
    "b": 8.96120357513428,
    "C": 9.47293472290039,
    "h": 108.918685913086,
    "CMY_C": 0.09992980957031,
    "CMY_M": 0.09982222318649,
    "CMY_Y": 0.17882341146469,
    "CMYK_C": 0.00011951681518,
    "CMYK_M": 0,
    "CMYK_Y": 0.087761759758,
    "CMYK_K": 0.09982222318649
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00802",
    "Farbtonhilfsbezeichnung": "Cognac 13",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "187",
    "Bcolor": "124",
    "Y": 56,
    "L": 79.5807342529297,
    "a": 12.9762411117554,
    "b": 39.098461151123,
    "C": 41.1955413818359,
    "h": 71.6397018432617,
    "CMY_C": 0.0483061671257,
    "CMY_M": 0.26700991392136,
    "CMY_Y": 0.51563060283661,
    "CMYK_C": 0,
    "CMYK_M": 0.22980473935604,
    "CMYK_Y": 0.4910449385643,
    "CMYK_K": 0.0483061671257
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00803",
    "Farbtonhilfsbezeichnung": "Aprikose 13",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "174",
    "Bcolor": "98",
    "Y": 54,
    "L": 76.2219161987305,
    "a": 18.1909961700439,
    "b": 47.9771919250488,
    "C": 51.3100700378418,
    "h": 69.2353134155273,
    "CMY_C": 0.04450815916061,
    "CMY_M": 0.31836807727814,
    "CMY_Y": 0.61608278751373,
    "CMYK_C": 0,
    "CMYK_M": 0.28661671280861,
    "CMYK_Y": 0.59819936752319,
    "CMYK_K": 0.04450815916061
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00805",
    "Farbtonhilfsbezeichnung": "Tibet 15",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "204",
    "Bcolor": "200",
    "Y": 63,
    "L": 81.5660171508789,
    "a": -2.92453455924988,
    "b": 0.48221683502197,
    "C": 2.96402359008789,
    "h": 170.636932373047,
    "CMY_C": 0.22642850875854,
    "CMY_M": 0.19806051254272,
    "CMY_Y": 0.21515303850174,
    "CMYK_C": 0.03537423536181,
    "CMYK_M": 0,
    "CMYK_Y": 0.02131398394704,
    "CMYK_K": 0.19806051254272
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00809",
    "Farbtonhilfsbezeichnung": "Basalt 18",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "226",
    "Bcolor": "216",
    "Y": 82,
    "L": 89.8268203735352,
    "a": 0.20611381530762,
    "b": 4.57404947280884,
    "C": 4.57869100570679,
    "h": 87.4199066162109,
    "CMY_C": 0.09746968746185,
    "CMY_M": 0.11545717716217,
    "CMY_Y": 0.15479749441147,
    "CMYK_C": 0,
    "CMYK_M": 0.01993006654084,
    "CMYK_Y": 0.06351897865534,
    "CMYK_K": 0.09746968746185
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00816",
    "Farbtonhilfsbezeichnung": "Siam 18",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "223",
    "Bcolor": "211",
    "Y": 80,
    "L": 89.1925964355469,
    "a": 1.3248291015625,
    "b": 6.02279710769653,
    "C": 6.16678667068481,
    "h": 77.5942687988281,
    "CMY_C": 0.09142625331879,
    "CMY_M": 0.12555783987045,
    "CMY_Y": 0.1722623705864,
    "CMYK_C": 0,
    "CMYK_M": 0.03756611421704,
    "CMYK_Y": 0.08897034078836,
    "CMYK_K": 0.09142625331879
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00819",
    "Farbtonhilfsbezeichnung": "Granat 14",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "173",
    "Bcolor": "158",
    "Y": 46,
    "L": 74.2063064575195,
    "a": 14.5624151229858,
    "b": 12.9724292755127,
    "C": 19.5025081634521,
    "h": 41.6951522827148,
    "CMY_C": 0.14747536182404,
    "CMY_M": 0.32304537296295,
    "CMY_Y": 0.37988924980164,
    "CMYK_C": 0,
    "CMYK_M": 0.20594127476215,
    "CMYK_Y": 0.27261838316917,
    "CMYK_K": 0.14747536182404
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00820",
    "Farbtonhilfsbezeichnung": "Taiga 15",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "201",
    "Bcolor": "171",
    "Y": 64,
    "L": 81.9515075683594,
    "a": 2.61318397521973,
    "b": 17.1555271148682,
    "C": 17.3534107208252,
    "h": 81.3391036987305,
    "CMY_C": 0.13213157653809,
    "CMY_M": 0.21096241474152,
    "CMY_Y": 0.33124959468842,
    "CMYK_C": 0,
    "CMYK_M": 0.09083271026611,
    "CMYK_Y": 0.22943341732025,
    "CMYK_K": 0.13213157653809
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00825",
    "Farbtonhilfsbezeichnung": "Iris 16",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "212",
    "Bcolor": "216",
    "Y": 71,
    "L": 83.6773147583008,
    "a": -5.72906875610352,
    "b": -4.93456602096558,
    "C": 7.56122827529907,
    "h": 220.738998413086,
    "CMY_C": 0.24675858020782,
    "CMY_M": 0.16711729764938,
    "CMY_Y": 0.15322840213776,
    "CMYK_C": 0.11045502871275,
    "CMYK_M": 0.01640217378736,
    "CMYK_Y": 0,
    "CMYK_K": 0.15322840213776
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00830",
    "Farbtonhilfsbezeichnung": "Havanna 18",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "224",
    "Bcolor": "208",
    "Y": 82,
    "L": 89.9889450073242,
    "a": 2.92032408714294,
    "b": 8.8356466293335,
    "C": 9.30574798583984,
    "h": 71.7104415893555,
    "CMY_C": 0.06206303834915,
    "CMY_M": 0.12131989002228,
    "CMY_Y": 0.18412214517593,
    "CMYK_C": 0,
    "CMYK_M": 0.06317786127329,
    "CMYK_Y": 0.13013572990894,
    "CMYK_K": 0.06206303834915
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00831",
    "Farbtonhilfsbezeichnung": "Mais 16",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "229",
    "Bcolor": "183",
    "Y": 85,
    "L": 91.5341262817383,
    "a": 0.6378173828125,
    "b": 24.1481266021729,
    "C": 24.1565475463867,
    "h": 88.4870147705078,
    "CMY_C": 0.0210702419281,
    "CMY_M": 0.10231149196625,
    "CMY_Y": 0.28188514709473,
    "CMYK_C": 0,
    "CMYK_M": 0.08298986405134,
    "CMYK_Y": 0.26642861962318,
    "CMYK_K": 0.0210702419281
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00834",
    "Farbtonhilfsbezeichnung": "Gobi 18",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "207",
    "Y": 87,
    "L": 92.2377548217773,
    "a": 0.9124561548233,
    "b": 12.5725145339966,
    "C": 12.6055822372437,
    "h": 85.849006652832,
    "CMY_C": 0.04097616672516,
    "CMY_M": 0.09238976240158,
    "CMY_Y": 0.18770629167557,
    "CMYK_C": 0,
    "CMYK_M": 0.05361034348607,
    "CMYK_Y": 0.15299946069717,
    "CMYK_K": 0.04097616672516
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00838",
    "Farbtonhilfsbezeichnung": "Malaga 17",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "221",
    "Bcolor": "204",
    "Y": 79,
    "L": 89.0183868408203,
    "a": 3.9403965473175,
    "b": 9.49579906463623,
    "C": 10.2809009552002,
    "h": 67.4634017944336,
    "CMY_C": 0.06353950500488,
    "CMY_M": 0.13473922014236,
    "CMY_Y": 0.19938546419144,
    "CMYK_C": 0,
    "CMYK_M": 0.07603066414595,
    "CMYK_Y": 0.14506320655346,
    "CMYK_K": 0.06353950500488
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00849",
    "Farbtonhilfsbezeichnung": "Havanna 12",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "130",
    "Bcolor": "94",
    "Y": 26,
    "L": 57.2708702087402,
    "a": 10.4010438919067,
    "b": 24.9773540496826,
    "C": 27.0564212799072,
    "h": 67.3922271728516,
    "CMY_C": 0.33758288621902,
    "CMY_M": 0.49003469944,
    "CMY_Y": 0.63306820392609,
    "CMYK_C": 0,
    "CMYK_M": 0.230144739151,
    "CMYK_Y": 0.44607138633728,
    "CMYK_K": 0.33758288621902
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00855",
    "Farbtonhilfsbezeichnung": "Palma 14",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "188",
    "Bcolor": "149",
    "Y": 54,
    "L": 76.5810775756836,
    "a": -0.43566185235977,
    "b": 21.0117912292481,
    "C": 21.0163078308106,
    "h": 91.1878051757812,
    "CMY_C": 0.20387268066406,
    "CMY_M": 0.26269263029099,
    "CMY_Y": 0.41562330722809,
    "CMYK_C": 0,
    "CMYK_M": 0.07388259470463,
    "CMYK_Y": 0.26597583293915,
    "CMYK_K": 0.20387268066406
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00864",
    "Farbtonhilfsbezeichnung": "Mais 17",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "233",
    "Bcolor": "196",
    "Y": 87,
    "L": 92.5999221801758,
    "a": -0.43224808573723,
    "b": 18.8188400268555,
    "C": 18.8238029479981,
    "h": 91.315788269043,
    "CMY_C": 0.02991592884064,
    "CMY_M": 0.08664053678513,
    "CMY_Y": 0.23066568374634,
    "CMYK_C": 0,
    "CMYK_M": 0.0584739074111,
    "CMYK_Y": 0.20694057643414,
    "CMYK_K": 0.02991592884064
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00871",
    "Farbtonhilfsbezeichnung": "Malaga 16",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "212",
    "Bcolor": "195",
    "Y": 73,
    "L": 86.2993392944336,
    "a": 5.08995056152344,
    "b": 10.6406879425049,
    "C": 11.7954158782959,
    "h": 64.4359741210938,
    "CMY_C": 0.08257269859314,
    "CMY_M": 0.16784358024597,
    "CMY_Y": 0.23698759078979,
    "CMYK_C": 0,
    "CMYK_M": 0.0929456576705,
    "CMYK_Y": 0.16831295192242,
    "CMYK_K": 0.08257269859314
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00873",
    "Farbtonhilfsbezeichnung": "Schilf 14",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "208",
    "Bcolor": "153",
    "Y": 68,
    "L": 83.9283065795898,
    "a": 0.08153457939625,
    "b": 29.1201572418213,
    "C": 29.1202716827393,
    "h": 89.8395767211914,
    "CMY_C": 0.10055857896805,
    "CMY_M": 0.18595534563065,
    "CMY_Y": 0.39924567937851,
    "CMYK_C": 0,
    "CMYK_M": 0.09494422376156,
    "CMYK_Y": 0.33208066225052,
    "CMYK_K": 0.10055857896805
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00876",
    "Farbtonhilfsbezeichnung": "Gobi 17",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "225",
    "Bcolor": "192",
    "Y": 84,
    "L": 90.408576965332,
    "a": 1.79693973064423,
    "b": 18.0876235961914,
    "C": 18.176664352417,
    "h": 84.3264846801758,
    "CMY_C": 0.04039824008942,
    "CMY_M": 0.11624646186829,
    "CMY_Y": 0.24840527772903,
    "CMYK_C": 0,
    "CMYK_M": 0.0790413543582,
    "CMYK_Y": 0.21676391363144,
    "CMYK_K": 0.04039824008942
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00880",
    "Farbtonhilfsbezeichnung": "Schiefer 12",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "112",
    "Bcolor": "103",
    "Y": 16,
    "L": 47.4303588867188,
    "a": 0.20862498879433,
    "b": 5.34989261627197,
    "C": 5.35395908355713,
    "h": 87.7668151855469,
    "CMY_C": 0.54235804080963,
    "CMY_M": 0.56029027700424,
    "CMY_Y": 0.59720230102539,
    "CMYK_C": 0,
    "CMYK_M": 0.03918398544192,
    "CMYK_Y": 0.11984097957611,
    "CMYK_K": 0.54235804080963
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00896",
    "Farbtonhilfsbezeichnung": "Lava 16",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "214",
    "Bcolor": "197",
    "Y": 71,
    "L": 85.8408432006836,
    "a": 0.96894389390945,
    "b": 8.63658809661865,
    "C": 8.69077110290527,
    "h": 83.5987243652344,
    "CMY_C": 0.12361711263657,
    "CMY_M": 0.16242128610611,
    "CMY_Y": 0.22787016630173,
    "CMYK_C": 0,
    "CMYK_M": 0.04427764937282,
    "CMYK_Y": 0.11895833909512,
    "CMYK_K": 0.12361711263657
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00906",
    "Farbtonhilfsbezeichnung": "Basalt 16",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "209",
    "Bcolor": "204",
    "Y": 69,
    "L": 83.9479598999023,
    "a": -0.14675143361092,
    "b": 2.12635064125061,
    "C": 2.13140869140625,
    "h": 93.9480438232422,
    "CMY_C": 0.17316824197769,
    "CMY_M": 0.17884373664856,
    "CMY_Y": 0.20094209909439,
    "CMYK_C": 0,
    "CMYK_M": 0.00686414679512,
    "CMYK_Y": 0.03359070047736,
    "CMYK_K": 0.17316824197769
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00911",
    "Farbtonhilfsbezeichnung": "Marone 13",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "156",
    "Bcolor": "128",
    "Y": 38,
    "L": 66.773307800293,
    "a": 9.63999938964844,
    "b": 18.9871120452881,
    "C": 21.2941303253174,
    "h": 63.0825157165527,
    "CMY_C": 0.24899840354919,
    "CMY_M": 0.38985282182693,
    "CMY_Y": 0.49876290559769,
    "CMYK_C": 0,
    "CMYK_M": 0.18755541741848,
    "CMYK_Y": 0.33257520198822,
    "CMYK_K": 0.24899840354919
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00924",
    "Farbtonhilfsbezeichnung": "Mais 0",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "164",
    "Bcolor": "60",
    "Y": 48,
    "L": 72.9832153320313,
    "a": 18.4096336364746,
    "b": 61.7449798583984,
    "C": 64.431022644043,
    "h": 73.3977355957031,
    "CMY_C": 0.06863737106323,
    "CMY_M": 0.35491573810577,
    "CMY_Y": 0.76632082462311,
    "CMYK_C": 0,
    "CMYK_M": 0.3073758482933,
    "CMYK_Y": 0.74909967184067,
    "CMYK_K": 0.06863737106323
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00925",
    "Farbtonhilfsbezeichnung": "Olive 0",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "125",
    "Bcolor": "72",
    "Y": 20,
    "L": 52.478343963623,
    "a": -2.0783166885376,
    "b": 30.0190391540527,
    "C": 30.0908966064453,
    "h": 93.9604568481445,
    "CMY_C": 0.45611518621445,
    "CMY_M": 0.51024752855301,
    "CMY_Y": 0.7162698507309,
    "CMYK_C": 0,
    "CMYK_M": 0.09952905774117,
    "CMYK_Y": 0.47832676768303,
    "CMYK_K": 0.45611518621445
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00927",
    "Farbtonhilfsbezeichnung": "Mais 15",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "223",
    "Bcolor": "166",
    "Y": 82,
    "L": 89.7567596435547,
    "a": 1.12715423107147,
    "b": 30.673849105835,
    "C": 30.6945514678955,
    "h": 87.8955307006836,
    "CMY_C": 0.02348726987839,
    "CMY_M": 0.12461233139038,
    "CMY_Y": 0.3497850894928,
    "CMYK_C": 0,
    "CMYK_M": 0.10355734080076,
    "CMYK_Y": 0.33414599299431,
    "CMYK_K": 0.02348726987839
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00929",
    "Farbtonhilfsbezeichnung": "Mistral 18",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "230",
    "Bcolor": "207",
    "Y": 86,
    "L": 91.7311706542969,
    "a": 1.56422460079193,
    "b": 11.8586959838867,
    "C": 11.9614162445068,
    "h": 82.4857635498047,
    "CMY_C": 0.04385304450989,
    "CMY_M": 0.09943336248398,
    "CMY_Y": 0.18779945373535,
    "CMYK_C": 0,
    "CMYK_M": 0.05812947079539,
    "CMYK_Y": 0.15054841339588,
    "CMYK_K": 0.04385304450989
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00936",
    "Farbtonhilfsbezeichnung": "Maroc 14",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "191",
    "Bcolor": "151",
    "Y": 58,
    "L": 79.4745559692383,
    "a": 7.38049173355103,
    "b": 24.2405338287354,
    "C": 25.3392009735107,
    "h": 73.0661315917969,
    "CMY_C": 0.11150151491165,
    "CMY_M": 0.25096333026886,
    "CMY_Y": 0.40786218643188,
    "CMYK_C": 0,
    "CMYK_M": 0.15696348249912,
    "CMYK_Y": 0.33355224132538,
    "CMYK_K": 0.11150151491165
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00937",
    "Farbtonhilfsbezeichnung": "Malaga 13",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "166",
    "Bcolor": "140",
    "Y": 44,
    "L": 70.9475173950195,
    "a": 11.3843183517456,
    "b": 18.4812870025635,
    "C": 21.7062358856201,
    "h": 58.3672790527344,
    "CMY_C": 0.19273734092712,
    "CMY_M": 0.3505220413208,
    "CMY_Y": 0.4528746008873,
    "CMYK_C": 0,
    "CMYK_M": 0.19545646011829,
    "CMYK_Y": 0.32224613428116,
    "CMYK_K": 0.19273734092712
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00950",
    "Farbtonhilfsbezeichnung": "Palma 18",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "228",
    "Bcolor": "208",
    "Y": 83,
    "L": 90.778076171875,
    "a": -0.26549181342125,
    "b": 10.1919813156128,
    "C": 10.1954383850098,
    "h": 91.4921646118164,
    "CMY_C": 0.07317984104156,
    "CMY_M": 0.10524350404739,
    "CMY_Y": 0.1860738992691,
    "CMYK_C": 0,
    "CMYK_M": 0.03459534421563,
    "CMYK_Y": 0.12180794775486,
    "CMYK_K": 0.07317984104156
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00972",
    "Farbtonhilfsbezeichnung": "Iris 13",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "169",
    "Bcolor": "187",
    "Y": 40,
    "L": 66.8722076416016,
    "a": -10.0330820083618,
    "b": -14.3344240188599,
    "C": 17.4968128204346,
    "h": 235.010711669922,
    "CMY_C": 0.50642836093903,
    "CMY_M": 0.33625262975693,
    "CMY_Y": 0.26845341920853,
    "CMYK_C": 0.32530388236046,
    "CMYK_M": 0.09267927706242,
    "CMYK_Y": 0,
    "CMYK_K": 0.26845341920853
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00985",
    "Farbtonhilfsbezeichnung": "Mistral 17",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "225",
    "Bcolor": "200",
    "Y": 83,
    "L": 90.2021255493164,
    "a": 2.66120553016663,
    "b": 13.4251871109009,
    "C": 13.6864042282104,
    "h": 78.7878952026367,
    "CMY_C": 0.04869037866592,
    "CMY_M": 0.11950147151947,
    "CMY_Y": 0.21583962440491,
    "CMYK_C": 0,
    "CMYK_M": 0.07443538308144,
    "CMYK_Y": 0.17570436000824,
    "CMYK_K": 0.04869037866592
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00988",
    "Farbtonhilfsbezeichnung": "Amazonas 17",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "224",
    "Bcolor": "201",
    "Y": 78,
    "L": 88.4415283203125,
    "a": -3.93384838104248,
    "b": 10.0598201751709,
    "C": 10.8016271591187,
    "h": 111.357765197754,
    "CMY_C": 0.12774616479874,
    "CMY_M": 0.12261945009232,
    "CMY_Y": 0.21100807189941,
    "CMYK_C": 0.00584320537746,
    "CMYK_M": 0,
    "CMYK_Y": 0.1007414907217,
    "CMYK_K": 0.12261945009232
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL00989",
    "Farbtonhilfsbezeichnung": "Schilf 15",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "216",
    "Bcolor": "173",
    "Y": 75,
    "L": 86.644401550293,
    "a": -0.84433895349503,
    "b": 22.2881011962891,
    "C": 22.3040885925293,
    "h": 92.1694946289062,
    "CMY_C": 0.09167546033859,
    "CMY_M": 0.15254575014114,
    "CMY_Y": 0.32018268108368,
    "CMYK_C": 0,
    "CMYK_M": 0.06701381504536,
    "CMYK_Y": 0.25157001614571,
    "CMYK_K": 0.09167546033859
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01010",
    "Farbtonhilfsbezeichnung": "Mistral 16",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "222",
    "Bcolor": "192",
    "Y": 78,
    "L": 89.4327011108398,
    "a": 3.42960906028748,
    "b": 16.6641750335693,
    "C": 17.0134334564209,
    "h": 78.370491027832,
    "CMY_C": 0.04330378770828,
    "CMY_M": 0.13070273399353,
    "CMY_Y": 0.24802392721176,
    "CMYK_C": 0,
    "CMYK_M": 0.09135495871305,
    "CMYK_Y": 0.21398657560349,
    "CMYK_K": 0.04330378770828
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01031",
    "Farbtonhilfsbezeichnung": "Schilf 0",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "144",
    "Bcolor": "78",
    "Y": 32,
    "L": 61.0598754882813,
    "a": 2.21307229995728,
    "b": 38.0996627807617,
    "C": 38.1638832092285,
    "h": 86.6756286621094,
    "CMY_C": 0.32641071081161,
    "CMY_M": 0.43433785438538,
    "CMY_Y": 0.69323682785034,
    "CMYK_C": 0,
    "CMYK_M": 0.16022692620754,
    "CMYK_Y": 0.54458427429199,
    "CMYK_K": 0.32641071081161
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01038",
    "Farbtonhilfsbezeichnung": "Olive 14",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "200",
    "Bcolor": "152",
    "Y": 60,
    "L": 80.9491119384766,
    "a": -1.29401469230652,
    "b": 25.78466796875,
    "C": 25.81711769104,
    "h": 92.8730087280273,
    "CMY_C": 0.15074491500854,
    "CMY_M": 0.21453434228897,
    "CMY_Y": 0.40563648939133,
    "CMYK_C": 0,
    "CMYK_M": 0.07511220872402,
    "CMYK_Y": 0.30013546347618,
    "CMYK_K": 0.15074491500854
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01039",
    "Farbtonhilfsbezeichnung": "Cognac 15",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "209",
    "Bcolor": "167",
    "Y": 72,
    "L": 85.8951034545898,
    "a": 7.14043712615967,
    "b": 24.7156562805176,
    "C": 25.7264366149902,
    "h": 73.8858184814453,
    "CMY_C": 0.0389456152916,
    "CMY_M": 0.18071091175079,
    "CMY_Y": 0.34458994865417,
    "CMYK_C": 0,
    "CMYK_M": 0.14751017093658,
    "CMYK_Y": 0.31803020834923,
    "CMYK_K": 0.0389456152916
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01040",
    "Farbtonhilfsbezeichnung": "Cognac 18",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "207",
    "Y": 85,
    "L": 92.2118148803711,
    "a": 1.7308030128479,
    "b": 12.706992149353,
    "C": 12.8243255615234,
    "h": 82.2435531616211,
    "CMY_C": 0.03478223085403,
    "CMY_M": 0.09468990564346,
    "CMY_Y": 0.18885886669159,
    "CMYK_C": 0,
    "CMYK_M": 0.06206648424268,
    "CMYK_Y": 0.15962888300419,
    "CMYK_K": 0.03478223085403
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01044",
    "Farbtonhilfsbezeichnung": "Olive 18",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "229",
    "Bcolor": "208",
    "Y": 85,
    "L": 91.2506713867188,
    "a": -0.23712286353111,
    "b": 10.5666952133179,
    "C": 10.5693550109863,
    "h": 91.285530090332,
    "CMY_C": 0.06655013561249,
    "CMY_M": 0.10014116764069,
    "CMY_Y": 0.18370795249939,
    "CMYK_C": 0,
    "CMYK_M": 0.0359858982265,
    "CMYK_Y": 0.12551055848598,
    "CMYK_K": 0.06655013561249
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01058",
    "Farbtonhilfsbezeichnung": "Havanna 14",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "181",
    "Bcolor": "150",
    "Y": 51,
    "L": 75.7628021240234,
    "a": 7.37418699264526,
    "b": 19.3864727020264,
    "C": 20.7416000366211,
    "h": 69.1742935180664,
    "CMY_C": 0.16340827941895,
    "CMY_M": 0.2896928191185,
    "CMY_Y": 0.41090375185013,
    "CMYK_C": 0,
    "CMYK_M": 0.15095122158527,
    "CMYK_Y": 0.29583781957626,
    "CMYK_K": 0.16340827941895
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01061",
    "Farbtonhilfsbezeichnung": "Mandarin 12 G",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "172",
    "Bcolor": "85",
    "Y": 49,
    "L": 75.576042175293,
    "a": 17.7283096313477,
    "b": 53.6393966674805,
    "C": 56.4931678771973,
    "h": 71.7108154296875,
    "CMY_C": 0.0488058924675,
    "CMY_M": 0.32473307847977,
    "CMY_Y": 0.66833734512329,
    "CMYK_C": 0,
    "CMYK_M": 0.29008504748344,
    "CMYK_Y": 0.65131968259811,
    "CMYK_K": 0.0488058924675
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01071",
    "Farbtonhilfsbezeichnung": "Marone 12",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "124",
    "Bcolor": "99",
    "Y": 24,
    "L": 54.9565467834473,
    "a": 11.2733888626099,
    "b": 18.5634326934814,
    "C": 21.718433380127,
    "h": 58.7301063537598,
    "CMY_C": 0.36790245771408,
    "CMY_M": 0.51414585113525,
    "CMY_Y": 0.61108732223511,
    "CMYK_C": 0,
    "CMYK_M": 0.23136205971241,
    "CMYK_Y": 0.38472679257393,
    "CMYK_K": 0.36790245771408
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01075",
    "Farbtonhilfsbezeichnung": "Havanna 17",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "217",
    "Bcolor": "198",
    "Y": 77,
    "L": 87.6755828857422,
    "a": 3.67600607872009,
    "b": 10.8934659957886,
    "C": 11.4969835281372,
    "h": 71.3530044555664,
    "CMY_C": 0.07668781280518,
    "CMY_M": 0.14929497241974,
    "CMY_Y": 0.22425007820129,
    "CMYK_C": 0,
    "CMYK_M": 0.07863771170378,
    "CMYK_Y": 0.15981838107109,
    "CMYK_K": 0.07668781280518
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01093",
    "Farbtonhilfsbezeichnung": "Maroc 15",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "204",
    "Bcolor": "172",
    "Y": 67,
    "L": 83.6230773925781,
    "a": 5.67734479904175,
    "b": 19.0089359283447,
    "C": 19.8386459350586,
    "h": 73.3708419799805,
    "CMY_C": 0.08752274513245,
    "CMY_M": 0.20062476396561,
    "CMY_Y": 0.32668787240982,
    "CMYK_C": 0,
    "CMYK_M": 0.12395051121712,
    "CMYK_Y": 0.26210531592369,
    "CMYK_K": 0.08752274513245
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01123",
    "Farbtonhilfsbezeichnung": "Island 14",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "194",
    "Bcolor": "172",
    "Y": 54,
    "L": 78.0915603637695,
    "a": -3.09120011329651,
    "b": 10.8529787063599,
    "C": 11.2846202850342,
    "h": 105.898277282715,
    "CMY_C": 0.23253226280212,
    "CMY_M": 0.23809796571732,
    "CMY_Y": 0.32704561948776,
    "CMYK_C": 0,
    "CMYK_M": 0.00725203519687,
    "CMYK_Y": 0.12314961850643,
    "CMYK_K": 0.23253226280212
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01159",
    "Farbtonhilfsbezeichnung": "Marone 18 G",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 74,
    "L": 88.8501815795898,
    "a": 2.4535231590271,
    "b": 7.74687767028809,
    "C": 8.12612342834473,
    "h": 72.4264144897461,
    "CMY_C": 0.08153766393661,
    "CMY_M": 0.1325266957283,
    "CMY_Y": 0.18853914737701,
    "CMYK_C": 0,
    "CMYK_M": 0.05551564693451,
    "CMYK_Y": 0.11650067567825,
    "CMYK_K": 0.08153766393661
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01164",
    "Farbtonhilfsbezeichnung": "Gobi 14",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "205",
    "Bcolor": "141",
    "Y": 68,
    "L": 84.4169006347656,
    "a": 6.19097995758057,
    "b": 36.1084823608398,
    "C": 36.6353759765625,
    "h": 80.2709503173828,
    "CMY_C": 0.04036641120911,
    "CMY_M": 0.19677579402924,
    "CMY_Y": 0.44534510374069,
    "CMYK_C": 0,
    "CMYK_M": 0.16298864781857,
    "CMYK_Y": 0.42201387882233,
    "CMYK_K": 0.04036641120911
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01174",
    "Farbtonhilfsbezeichnung": "Basalt 13",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "162",
    "Bcolor": "160",
    "Y": 37,
    "L": 66.6252212524414,
    "a": 0.37366846203804,
    "b": 0.66364252567291,
    "C": 0.76160979270935,
    "h": 60.6180191040039,
    "CMY_C": 0.35968124866486,
    "CMY_M": 0.36516714096069,
    "CMY_Y": 0.37411463260651,
    "CMYK_C": 0,
    "CMYK_M": 0.00856743939221,
    "CMYK_Y": 0.02254093624651,
    "CMYK_K": 0.35968124866486
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01193",
    "Farbtonhilfsbezeichnung": "Aprikose 14 C",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01238",
    "Farbtonhilfsbezeichnung": "Marone 15",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "193",
    "Bcolor": "171",
    "Y": 60,
    "L": 79.8464889526367,
    "a": 6.38733720779419,
    "b": 13.9010334014893,
    "C": 15.298261642456,
    "h": 65.3218612670898,
    "CMY_C": 0.13719826936722,
    "CMY_M": 0.24215108156204,
    "CMY_Y": 0.3290998339653,
    "CMYK_C": 0,
    "CMYK_M": 0.12164186686277,
    "CMYK_Y": 0.22241675853729,
    "CMYK_K": 0.13719826936722
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01239",
    "Farbtonhilfsbezeichnung": "Palma 17",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "222",
    "Bcolor": "198",
    "Y": 79,
    "L": 88.5540466308594,
    "a": -0.58862453699112,
    "b": 11.7806692123413,
    "C": 11.7953653335571,
    "h": 92.8604278564453,
    "CMY_C": 0.09592968225479,
    "CMY_M": 0.1295862197876,
    "CMY_Y": 0.2219877243042,
    "CMYK_C": 0,
    "CMYK_M": 0.03722778707743,
    "CMYK_Y": 0.13943389058113,
    "CMYK_K": 0.09592968225479
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01248",
    "Farbtonhilfsbezeichnung": "Marone 11",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "104",
    "Bcolor": "82",
    "Y": 16,
    "L": 47.0825881958008,
    "a": 11.6253385543823,
    "b": 17.4053363800049,
    "C": 20.930700302124,
    "h": 56.2603225708008,
    "CMY_C": 0.45118182897568,
    "CMY_M": 0.59218448400497,
    "CMY_Y": 0.67741358280182,
    "CMYK_C": 0,
    "CMYK_M": 0.25692051649094,
    "CMYK_Y": 0.41221621632576,
    "CMYK_K": 0.45118182897568
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01249",
    "Farbtonhilfsbezeichnung": "Schilf 16",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "225",
    "Bcolor": "193",
    "Y": 80,
    "L": 89.8037719726563,
    "a": -0.18547242879868,
    "b": 16.4873504638672,
    "C": 16.4883937835693,
    "h": 90.6445159912109,
    "CMY_C": 0.06591135263443,
    "CMY_M": 0.11782932281494,
    "CMY_Y": 0.24333471059799,
    "CMYK_C": 0,
    "CMYK_M": 0.05558141693473,
    "CMYK_Y": 0.18994274735451,
    "CMYK_K": 0.06591135263443
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01264",
    "Farbtonhilfsbezeichnung": "Tibet 0",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "115",
    "Bcolor": "113",
    "Y": 16,
    "L": 47.3966369628906,
    "a": -4.90622711181641,
    "b": -0.91519415378571,
    "C": 4.9908561706543,
    "h": 190.566345214844,
    "CMY_C": 0.59763467311859,
    "CMY_M": 0.54878056049347,
    "CMY_Y": 0.55740582942963,
    "CMYK_C": 0.10827129334211,
    "CMYK_M": 0,
    "CMYK_Y": 0.01911546476185,
    "CMYK_K": 0.54878056049347
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01271",
    "Farbtonhilfsbezeichnung": "Siam 13",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "156",
    "Bcolor": "144",
    "Y": 34,
    "L": 65.7053756713867,
    "a": 4.82328081130981,
    "b": 7.96097135543823,
    "C": 9.30812072753906,
    "h": 58.7897605895996,
    "CMY_C": 0.31698328256607,
    "CMY_M": 0.38679391145706,
    "CMY_Y": 0.43352514505386,
    "CMYK_C": 0,
    "CMYK_M": 0.1022092550993,
    "CMYK_Y": 0.17062813043594,
    "CMYK_K": 0.31698328256607
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01287",
    "Farbtonhilfsbezeichnung": "Terra 0",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "104",
    "Bcolor": "73",
    "Y": 17,
    "L": 48.5799903869629,
    "a": 17.1945762634277,
    "b": 25.0366954803467,
    "C": 30.3725128173828,
    "h": 55.5196952819824,
    "CMY_C": 0.39336055517197,
    "CMY_M": 0.59343463182449,
    "CMY_Y": 0.71323281526566,
    "CMYK_C": 0,
    "CMYK_M": 0.3298072218895,
    "CMYK_Y": 0.52728563547134,
    "CMYK_K": 0.39336055517197
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01289",
    "Farbtonhilfsbezeichnung": "Malaga 0",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "95",
    "Bcolor": "76",
    "Y": 15,
    "L": 44.1953659057617,
    "a": 14.4111299514771,
    "b": 17.4268474578857,
    "C": 22.6136169433594,
    "h": 50.4109573364258,
    "CMY_C": 0.46582490205765,
    "CMY_M": 0.62697684764862,
    "CMY_Y": 0.70357513427734,
    "CMYK_C": 0,
    "CMYK_M": 0.30168375372887,
    "CMYK_Y": 0.44507920742035,
    "CMYK_K": 0.46582490205765
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01299",
    "Farbtonhilfsbezeichnung": "Amazonas 13",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "177",
    "Bcolor": "132",
    "Y": 44,
    "L": 70.5483779907227,
    "a": -9.56432723999023,
    "b": 21.6836757659912,
    "C": 23.6993274688721,
    "h": 113.80152130127,
    "CMY_C": 0.33237880468369,
    "CMY_M": 0.307273209095,
    "CMY_Y": 0.48345524072647,
    "CMYK_C": 0.03624169901013,
    "CMYK_M": 0,
    "CMYK_Y": 0.25433120131493,
    "CMYK_K": 0.307273209095
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01303",
    "Farbtonhilfsbezeichnung": "Malaga 15",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "201",
    "Bcolor": "180",
    "Y": 65,
    "L": 82.7779006958008,
    "a": 6.51255035400391,
    "b": 13.2291507720947,
    "C": 14.7452955245972,
    "h": 63.7895355224609,
    "CMY_C": 0.10520756244659,
    "CMY_M": 0.21051448583603,
    "CMY_Y": 0.29326736927032,
    "CMYK_C": 0,
    "CMYK_M": 0.11768866330385,
    "CMYK_Y": 0.21017143130302,
    "CMYK_K": 0.10520756244659
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01304",
    "Farbtonhilfsbezeichnung": "Cognac 12",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "162",
    "Bcolor": "97",
    "Y": 42,
    "L": 71.4238739013672,
    "a": 17.4604187011719,
    "b": 42.3320426940918,
    "C": 45.7915725708008,
    "h": 67.5856475830078,
    "CMY_C": 0.11222440004349,
    "CMY_M": 0.36606955528259,
    "CMY_Y": 0.62019443511963,
    "CMYK_C": 0,
    "CMYK_M": 0.28593391180038,
    "CMYK_Y": 0.57218289375305,
    "CMYK_K": 0.11222440004349
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01305",
    "Farbtonhilfsbezeichnung": "Granat 16",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "205",
    "Bcolor": "190",
    "Y": 66,
    "L": 84.6036605834961,
    "a": 8.44554805755615,
    "b": 10.5477466583252,
    "C": 13.5122995376587,
    "h": 51.3158531188965,
    "CMY_C": 0.07794880867004,
    "CMY_M": 0.19475162029266,
    "CMY_Y": 0.25396364927292,
    "CMYK_C": 0,
    "CMYK_M": 0.12667714059353,
    "CMYK_Y": 0.19089487195015,
    "CMYK_K": 0.07794880867004
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01313",
    "Farbtonhilfsbezeichnung": "Iris 15",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "203",
    "Bcolor": "210",
    "Y": 62,
    "L": 79.7702865600586,
    "a": -7.93414926528931,
    "b": -7.66114139556885,
    "C": 11.0292253494263,
    "h": 223.997100830078,
    "CMY_C": 0.31914502382278,
    "CMY_M": 0.20427519083023,
    "CMY_Y": 0.1764349937439,
    "CMYK_C": 0.17328326404095,
    "CMYK_M": 0.0338044911623,
    "CMYK_Y": 0,
    "CMYK_K": 0.1764349937439
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01314",
    "Farbtonhilfsbezeichnung": "Iris 12",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "143",
    "Bcolor": "164",
    "Y": 26,
    "L": 56.925178527832,
    "a": -9.38937091827393,
    "b": -16.5958518981934,
    "C": 19.0678424835205,
    "h": 240.500289916992,
    "CMY_C": 0.61553275585175,
    "CMY_M": 0.4401113986969,
    "CMY_Y": 0.35778176784515,
    "CMYK_C": 0.40134486556053,
    "CMYK_M": 0.12819571793079,
    "CMYK_Y": 0,
    "CMYK_K": 0.35778176784515
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01320",
    "Farbtonhilfsbezeichnung": "Nutria 0",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "90",
    "Bcolor": "75",
    "Y": 11,
    "L": 40.2498664855957,
    "a": 7.33686304092407,
    "b": 12.2433567047119,
    "C": 14.2733783721924,
    "h": 59.067741394043,
    "CMY_C": 0.55435502529144,
    "CMY_M": 0.64625215530396,
    "CMY_Y": 0.70747268199921,
    "CMYK_C": 0,
    "CMYK_M": 0.20621152222157,
    "CMYK_Y": 0.34358662366867,
    "CMYK_K": 0.55435502529144
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01338",
    "Farbtonhilfsbezeichnung": "Cognac 16",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "219",
    "Bcolor": "185",
    "Y": 78,
    "L": 88.907470703125,
    "a": 4.54928398132324,
    "b": 19.4490604400635,
    "C": 19.9740314483643,
    "h": 76.8347702026367,
    "CMY_C": 0.03438240289688,
    "CMY_M": 0.13992494344711,
    "CMY_Y": 0.27411776781082,
    "CMYK_C": 0,
    "CMYK_M": 0.10930055379868,
    "CMYK_Y": 0.24827153980732,
    "CMYK_K": 0.03438240289688
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01344",
    "Farbtonhilfsbezeichnung": "Olive 15",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "171",
    "Y": 69,
    "L": 84.2852249145508,
    "a": -0.89483106136322,
    "b": 20.1827087402344,
    "C": 20.2025356292725,
    "h": 92.5386352539062,
    "CMY_C": 0.12362092733383,
    "CMY_M": 0.17788523435593,
    "CMY_Y": 0.32949954271317,
    "CMYK_C": 0,
    "CMYK_M": 0.06191876158118,
    "CMYK_Y": 0.23491959273815,
    "CMYK_K": 0.12362092733383
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01352",
    "Farbtonhilfsbezeichnung": "Palma 16",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "212",
    "Bcolor": "185",
    "Y": 72,
    "L": 85.1916580200195,
    "a": -0.55063283443451,
    "b": 13.9243783950806,
    "C": 13.9352617263794,
    "h": 92.2645492553711,
    "CMY_C": 0.12717592716217,
    "CMY_M": 0.16729789972305,
    "CMY_Y": 0.2738344669342,
    "CMYK_C": 0,
    "CMYK_M": 0.04596799612045,
    "CMYK_Y": 0.16802760958672,
    "CMYK_K": 0.12717592716217
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01353",
    "Farbtonhilfsbezeichnung": "Mais 11",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "180",
    "Bcolor": "71",
    "Y": 52,
    "L": 77.6191864013672,
    "a": 14.5602235794067,
    "b": 61.8036155700684,
    "C": 63.4955673217773,
    "h": 76.7434997558594,
    "CMY_C": 0.0350250005722,
    "CMY_M": 0.29545474052429,
    "CMY_Y": 0.719930768013,
    "CMYK_C": 0,
    "CMYK_M": 0.26988238096237,
    "CMYK_Y": 0.70976531505585,
    "CMYK_K": 0.0350250005722
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01385",
    "Farbtonhilfsbezeichnung": "Mais 18",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "233",
    "Bcolor": "205",
    "Y": 89,
    "L": 92.8263092041016,
    "a": 0.12391360849142,
    "b": 14.679594039917,
    "C": 14.6801166534424,
    "h": 89.5163650512695,
    "CMY_C": 0.0343199968338,
    "CMY_M": 0.08444410562515,
    "CMY_Y": 0.19715690612793,
    "CMYK_C": 0,
    "CMYK_M": 0.05190550535917,
    "CMYK_Y": 0.16862408816814,
    "CMYK_K": 0.0343199968338
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01396",
    "Farbtonhilfsbezeichnung": "Marone 0",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "86",
    "Bcolor": "70",
    "Y": 10,
    "L": 39.5770721435547,
    "a": 11.2005300521851,
    "b": 14.4393634796143,
    "C": 18.2742195129395,
    "h": 52.1994743347168,
    "CMY_C": 0.53573203086853,
    "CMY_M": 0.66209971904755,
    "CMY_Y": 0.72684067487717,
    "CMYK_C": 0,
    "CMYK_M": 0.27218696475029,
    "CMYK_Y": 0.41163435578346,
    "CMYK_K": 0.53573203086853
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01401",
    "Farbtonhilfsbezeichnung": "Schiefer 11",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "93",
    "Bcolor": "85",
    "Y": 11,
    "L": 39.7953300476074,
    "a": 0.23346029222012,
    "b": 4.88614892959595,
    "C": 4.89172315597534,
    "h": 87.2644882202148,
    "CMY_C": 0.61751502752304,
    "CMY_M": 0.6337103843689,
    "CMY_Y": 0.66614317893982,
    "CMYK_C": 0,
    "CMYK_M": 0.04234246537089,
    "CMYK_Y": 0.12713742256165,
    "CMYK_K": 0.61751502752304
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01417",
    "Farbtonhilfsbezeichnung": "Nutria 15",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "196",
    "Bcolor": "176",
    "Y": 60,
    "L": 80.1835861206055,
    "a": 4.34276342391968,
    "b": 11.6786413192749,
    "C": 12.4599456787109,
    "h": 69.6020889282227,
    "CMY_C": 0.15341132879257,
    "CMY_M": 0.23298531770706,
    "CMY_Y": 0.30981719493866,
    "CMYK_C": 0,
    "CMYK_M": 0.09399368613958,
    "CMYK_Y": 0.18474835157394,
    "CMYK_K": 0.15341132879257
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01424",
    "Farbtonhilfsbezeichnung": "Amazonas 12",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "151",
    "Bcolor": "103",
    "Y": 29,
    "L": 60.7176055908203,
    "a": -10.2554769515991,
    "b": 23.9367847442627,
    "C": 26.0412063598633,
    "h": 113.192230224609,
    "CMY_C": 0.43526822328568,
    "CMY_M": 0.40918552875519,
    "CMY_Y": 0.59676027297974,
    "CMYK_C": 0.04414701461792,
    "CMYK_M": 0,
    "CMYK_Y": 0.31748503446579,
    "CMYK_K": 0.40918552875519
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01425",
    "Farbtonhilfsbezeichnung": "Amazonas 14",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "193",
    "Bcolor": "153",
    "Y": 55,
    "L": 76.7871398925781,
    "a": -8.86784267425537,
    "b": 19.0048961639404,
    "C": 20.9719982147217,
    "h": 115.014144897461,
    "CMY_C": 0.26724243164063,
    "CMY_M": 0.24138027429581,
    "CMY_Y": 0.40041369199753,
    "CMYK_C": 0.03409107029438,
    "CMYK_M": 0,
    "CMYK_Y": 0.20963522791862,
    "CMYK_K": 0.24138027429581
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01427",
    "Farbtonhilfsbezeichnung": "Malaga 14",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "182",
    "Bcolor": "157",
    "Y": 55,
    "L": 76.262809753418,
    "a": 9.19281673431396,
    "b": 16.5118827819824,
    "C": 18.898416519165,
    "h": 60.8935890197754,
    "CMY_C": 0.15199947357178,
    "CMY_M": 0.28822427988052,
    "CMY_Y": 0.38478487730026,
    "CMYK_C": 0,
    "CMYK_M": 0.16064235568047,
    "CMYK_Y": 0.27451092004776,
    "CMYK_K": 0.15199947357178
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01428",
    "Farbtonhilfsbezeichnung": "Island 0",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "108",
    "Bcolor": "88",
    "Y": 14,
    "L": 45.0329360961914,
    "a": -3.69489622116089,
    "b": 10.8275785446167,
    "C": 11.4406604766846,
    "h": 108.842140197754,
    "CMY_C": 0.5780713558197,
    "CMY_M": 0.57687258720398,
    "CMY_Y": 0.65602415800095,
    "CMYK_C": 0.00283311493695,
    "CMYK_M": 0,
    "CMYK_Y": 0.18706320226192,
    "CMYK_K": 0.57687258720398
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01429",
    "Farbtonhilfsbezeichnung": "Siam 0",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "82",
    "Bcolor": "74",
    "Y": 8,
    "L": 36.2019805908203,
    "a": 5.27369451522827,
    "b": 6.65417814254761,
    "C": 8.49057960510254,
    "h": 51.6018104553223,
    "CMY_C": 0.61687862873077,
    "CMY_M": 0.67833054065704,
    "CMY_Y": 0.70942056179047,
    "CMYK_C": 0,
    "CMYK_M": 0.16039802134037,
    "CMYK_Y": 0.24154730141163,
    "CMYK_K": 0.61687862873077
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01466",
    "Farbtonhilfsbezeichnung": "Granat 15",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "190",
    "Bcolor": "175",
    "Y": 57,
    "L": 79.7083969116211,
    "a": 10.6611299514771,
    "b": 11.7679557800293,
    "C": 15.8790578842163,
    "h": 47.8251266479492,
    "CMY_C": 0.11457252502441,
    "CMY_M": 0.25381356477737,
    "CMY_Y": 0.31445395946503,
    "CMYK_C": 0,
    "CMYK_M": 0.15725855529308,
    "CMYK_Y": 0.22574569284916,
    "CMYK_K": 0.11457252502441
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01494",
    "Farbtonhilfsbezeichnung": "Island 17",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "225",
    "Bcolor": "210",
    "Y": 79,
    "L": 89.2456970214844,
    "a": -1.51978576183319,
    "b": 6.68577861785889,
    "C": 6.85633897781372,
    "h": 102.806632995605,
    "CMY_C": 0.11059719324112,
    "CMY_M": 0.11841356754303,
    "CMY_Y": 0.17699700593948,
    "CMYK_C": 0,
    "CMYK_M": 0.00878833979368,
    "CMYK_Y": 0.07465662807226,
    "CMYK_K": 0.11059719324112
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01495",
    "Farbtonhilfsbezeichnung": "Amazonas 11",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "130",
    "Bcolor": "90",
    "Y": 20,
    "L": 52.7237739562988,
    "a": -9.66729259490967,
    "b": 20.1853256225586,
    "C": 22.3808822631836,
    "h": 115.591003417969,
    "CMY_C": 0.52092516422272,
    "CMY_M": 0.491042137146,
    "CMY_Y": 0.64712154865265,
    "CMYK_C": 0.05871414765716,
    "CMYK_M": 0,
    "CMYK_Y": 0.30666470527649,
    "CMYK_K": 0.491042137146
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01521",
    "Farbtonhilfsbezeichnung": "Gobi 13",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "192",
    "Bcolor": "115",
    "Y": 60,
    "L": 80.6249771118164,
    "a": 9.23019218444824,
    "b": 44.8161926269531,
    "C": 45.7568321228027,
    "h": 78.3622817993164,
    "CMY_C": 0.05131077766418,
    "CMY_M": 0.2470229268074,
    "CMY_Y": 0.54988604784012,
    "CMYK_C": 0,
    "CMYK_M": 0.20629742741585,
    "CMYK_Y": 0.5255411863327,
    "CMYK_K": 0.05131077766418
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01540",
    "Farbtonhilfsbezeichnung": "Maroc 0",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "107",
    "Bcolor": "74",
    "Y": 16,
    "L": 48.6109275817871,
    "a": 12.3363313674927,
    "b": 24.4703311920166,
    "C": 27.4040546417236,
    "h": 63.2457618713379,
    "CMY_C": 0.42054903507233,
    "CMY_M": 0.58040976524353,
    "CMY_Y": 0.7102432847023,
    "CMYK_C": 0,
    "CMYK_M": 0.27588310837746,
    "CMYK_Y": 0.4999460875988,
    "CMYK_K": 0.42054903507233
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01570",
    "Farbtonhilfsbezeichnung": "Mandarin 15",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "216",
    "Bcolor": "158",
    "Y": 77,
    "L": 87.8568496704102,
    "a": 3.94455170631409,
    "b": 32.0164527893066,
    "C": 32.2585296630859,
    "h": 82.9763336181641,
    "CMY_C": 0.02322423458099,
    "CMY_M": 0.15273356437683,
    "CMY_Y": 0.37926208972931,
    "CMYK_C": 0,
    "CMYK_M": 0.1325885951519,
    "CMYK_Y": 0.36450317502022,
    "CMYK_K": 0.02322423458099
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01571",
    "Farbtonhilfsbezeichnung": "Amazonas 15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "209",
    "Bcolor": "173",
    "Y": 64,
    "L": 82.6437301635742,
    "a": -6.94182157516479,
    "b": 16.7193737030029,
    "C": 18.103214263916,
    "h": 112.548042297363,
    "CMY_C": 0.19528597593307,
    "CMY_M": 0.18136048316956,
    "CMY_Y": 0.32236641645432,
    "CMYK_C": 0.0170105304569,
    "CMYK_M": 0,
    "CMYK_Y": 0.17224423587322,
    "CMYK_K": 0.18136048316956
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01573",
    "Farbtonhilfsbezeichnung": "Schilf 17",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "230",
    "Bcolor": "202",
    "Y": 84,
    "L": 91.50830078125,
    "a": -0.69844663143158,
    "b": 13.9721775054932,
    "C": 13.9896240234375,
    "h": 92.8617401123047,
    "CMY_C": 0.05735802650452,
    "CMY_M": 0.09702849388123,
    "CMY_Y": 0.20631259679794,
    "CMYK_C": 0,
    "CMYK_M": 0.0420843437314,
    "CMYK_Y": 0.15801818668842,
    "CMYK_K": 0.05735802650452
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01623",
    "Farbtonhilfsbezeichnung": "Mais 13",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "206",
    "Bcolor": "115",
    "Y": 72,
    "L": 85.2027969360352,
    "a": 6.81021499633789,
    "b": 50.5376396179199,
    "C": 50.9944305419922,
    "h": 82.325325012207,
    "CMY_C": 0.00476771593094,
    "CMY_M": 0.19216150045395,
    "CMY_Y": 0.54924815893173,
    "CMYK_C": 0,
    "CMYK_M": 0.18829150497913,
    "CMYK_Y": 0.54708880186081,
    "CMYK_K": 0.00476771593094
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01630",
    "Farbtonhilfsbezeichnung": "Amazonas 0",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "115",
    "Bcolor": "81",
    "Y": 15,
    "L": 47.0299072265625,
    "a": -7.7461986541748,
    "b": 17.6009426116943,
    "C": 19.2301006317139,
    "h": 113.754364013672,
    "CMY_C": 0.57008934020996,
    "CMY_M": 0.55078721046448,
    "CMY_Y": 0.6826394200325,
    "CMYK_C": 0.04296879097819,
    "CMYK_M": 0,
    "CMYK_Y": 0.29351836442947,
    "CMYK_K": 0.55078721046448
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01658",
    "Farbtonhilfsbezeichnung": "Schilf 18",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "232",
    "Bcolor": "207",
    "Y": 87,
    "L": 92.3249588012695,
    "a": -0.09775862842798,
    "b": 12.6881999969482,
    "C": 12.6885766983032,
    "h": 90.4414367675781,
    "CMY_C": 0.04724740982056,
    "CMY_M": 0.08902186155319,
    "CMY_Y": 0.18778115510941,
    "CMYK_C": 0,
    "CMYK_M": 0.04384606331587,
    "CMYK_Y": 0.1475028693676,
    "CMYK_K": 0.04724740982056
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01690",
    "Farbtonhilfsbezeichnung": "Iris 14",
    "Farbtonklasse": "01",
    "Rcolor": "151",
    "Gcolor": "187",
    "Bcolor": "200",
    "Y": 52,
    "L": 73.8068161010742,
    "a": -9.07793140411377,
    "b": -11.3150691986084,
    "C": 14.506537437439,
    "h": 231.260391235352,
    "CMY_C": 0.40941232442856,
    "CMY_M": 0.2653067111969,
    "CMY_Y": 0.21513426303864,
    "CMYK_C": 0.24753031134605,
    "CMYK_M": 0.06392487883568,
    "CMYK_Y": 0,
    "CMYK_K": 0.21513426303864
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01721",
    "Farbtonhilfsbezeichnung": "Aprikose 14 H",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01750",
    "Farbtonhilfsbezeichnung": "Iris 11",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "123",
    "Bcolor": "142",
    "Y": 18,
    "L": 49.337043762207,
    "a": -8.38790607452393,
    "b": -15.3799810409546,
    "C": 17.5185832977295,
    "h": 241.392913818359,
    "CMY_C": 0.67473781108856,
    "CMY_M": 0.5189071893692,
    "CMY_Y": 0.44388997554779,
    "CMYK_C": 0.41511180996895,
    "CMYK_M": 0.13489635288715,
    "CMYK_Y": 0,
    "CMYK_K": 0.44388997554779
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01787",
    "Farbtonhilfsbezeichnung": "Gobi 0",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "138",
    "Bcolor": "58",
    "Y": 31,
    "L": 62.1871070861816,
    "a": 15.7823734283447,
    "b": 49.8639259338379,
    "C": 52.3019561767578,
    "h": 72.4369659423828,
    "CMY_C": 0.22175979614258,
    "CMY_M": 0.45788103342056,
    "CMY_Y": 0.77072298526764,
    "CMYK_C": 0,
    "CMYK_M": 0.30340406298637,
    "CMYK_Y": 0.70539045333862,
    "CMYK_K": 0.22175979614258
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01829",
    "Farbtonhilfsbezeichnung": "India 14",
    "Farbtonklasse": "01",
    "Y": 42,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01835",
    "Farbtonhilfsbezeichnung": "India 12",
    "Farbtonklasse": "02",
    "Y": 26,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01850",
    "Farbtonhilfsbezeichnung": "Taiga 11",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "120",
    "Bcolor": "86",
    "Y": 20,
    "L": 51.7672271728516,
    "a": 3.34639406204224,
    "b": 21.7658805847168,
    "C": 22.0216236114502,
    "h": 81.2595062255859,
    "CMY_C": 0.44367915391922,
    "CMY_M": 0.52773702144623,
    "CMY_Y": 0.66450250148773,
    "CMYK_C": 0,
    "CMYK_M": 0.15109601616859,
    "CMYK_Y": 0.39693522453308,
    "CMYK_K": 0.44367915391922
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01854",
    "Farbtonhilfsbezeichnung": "Bison 11",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "104",
    "Bcolor": "85",
    "Y": 14,
    "L": 45.23046875,
    "a": 5.0181565284729,
    "b": 12.7190561294556,
    "C": 13.6731958389282,
    "h": 68.468864440918,
    "CMY_C": 0.51713228225708,
    "CMY_M": 0.59363096952438,
    "CMY_Y": 0.66513180732727,
    "CMYK_C": 0,
    "CMYK_M": 0.1584257632494,
    "CMYK_Y": 0.30650117993355,
    "CMYK_K": 0.51713228225708
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01857",
    "Farbtonhilfsbezeichnung": "Basalt 11",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "108",
    "Bcolor": "109",
    "Y": 14,
    "L": 45.6640930175781,
    "a": 1.36190152168274,
    "b": -1.11779141426086,
    "C": 1.76188349723816,
    "h": 320.622283935547,
    "CMY_C": 0.57006537914276,
    "CMY_M": 0.57834160327911,
    "CMY_Y": 0.57216262817383,
    "CMYK_C": 0,
    "CMYK_M": 0.0192499589175,
    "CMYK_Y": 0.00487806508318,
    "CMYK_K": 0.57006537914276
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01870",
    "Farbtonhilfsbezeichnung": "Mandarin 0",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "148",
    "Bcolor": "63",
    "Y": 40,
    "L": 67.8299713134766,
    "a": 22.1029033660889,
    "b": 54.8135375976563,
    "C": 59.1021347045898,
    "h": 68.0388336181641,
    "CMY_C": 0.1154368519783,
    "CMY_M": 0.41822957992554,
    "CMY_Y": 0.75417739152908,
    "CMYK_C": 0,
    "CMYK_M": 0.3423076570034,
    "CMYK_Y": 0.72209715843201,
    "CMYK_K": 0.1154368519783
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01872",
    "Farbtonhilfsbezeichnung": "Mandarin 11",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "158",
    "Bcolor": "70",
    "Y": 44,
    "L": 71.0544509887695,
    "a": 21.1699619293213,
    "b": 55.2380638122559,
    "C": 59.155818939209,
    "h": 69.0306930541992,
    "CMY_C": 0.08163160085678,
    "CMY_M": 0.38211303949356,
    "CMY_Y": 0.72583091259003,
    "CMYK_C": 0,
    "CMYK_M": 0.32719051837921,
    "CMYK_Y": 0.70146065950394,
    "CMYK_K": 0.08163160085678
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01898",
    "Farbtonhilfsbezeichnung": "Mistral 11",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "137",
    "Bcolor": "81",
    "Y": 29,
    "L": 60.4525451660156,
    "a": 11.233699798584,
    "b": 36.2142639160156,
    "C": 37.9166030883789,
    "h": 72.7660598754883,
    "CMY_C": 0.28193604946136,
    "CMY_M": 0.46184796094894,
    "CMY_Y": 0.6825276017189,
    "CMYK_C": 0,
    "CMYK_M": 0.25055137276649,
    "CMYK_Y": 0.55787724256516,
    "CMYK_K": 0.28193604946136
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01921",
    "Farbtonhilfsbezeichnung": "India 0",
    "Farbtonklasse": "04",
    "Y": 16,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01933",
    "Farbtonhilfsbezeichnung": "Gobi 12",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "168",
    "Bcolor": "82",
    "Y": 46,
    "L": 72.7666473388672,
    "a": 13.0104560852051,
    "b": 51.2396965026855,
    "C": 52.865665435791,
    "h": 75.7529144287109,
    "CMY_C": 0.1126281619072,
    "CMY_M": 0.34134596586227,
    "CMY_Y": 0.67848694324493,
    "CMYK_C": 0,
    "CMYK_M": 0.25774741172791,
    "CMYK_Y": 0.63767945766449,
    "CMYK_K": 0.1126281619072
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01947",
    "Farbtonhilfsbezeichnung": "Tibet 18",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "228",
    "Bcolor": "218",
    "Y": 83,
    "L": 90.3259048461914,
    "a": -1.13224518299103,
    "b": 4.22354030609131,
    "C": 4.37267351150513,
    "h": 105.006973266602,
    "CMY_C": 0.10345017910004,
    "CMY_M": 0.10664731264114,
    "CMY_Y": 0.14692848920822,
    "CMYK_C": 0,
    "CMYK_M": 0.00356604112312,
    "CMYK_Y": 0.04849513992667,
    "CMYK_K": 0.10345017910004
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01954",
    "Farbtonhilfsbezeichnung": "Bison 12",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "125",
    "Bcolor": "102",
    "Y": 23,
    "L": 53.684886932373,
    "a": 5.06642913818359,
    "b": 14.8739080429077,
    "C": 15.7131109237671,
    "h": 71.1898574829102,
    "CMY_C": 0.42596012353897,
    "CMY_M": 0.51127445697784,
    "CMY_Y": 0.59950357675552,
    "CMYK_C": 0,
    "CMYK_M": 0.14862091839314,
    "CMYK_Y": 0.30231949687004,
    "CMYK_K": 0.42596012353897
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01955",
    "Farbtonhilfsbezeichnung": "Mais 12",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "192",
    "Bcolor": "89",
    "Y": 61,
    "L": 81.3441162109375,
    "a": 11.328537940979,
    "b": 58.0128974914551,
    "C": 59.1086463928223,
    "h": 78.9505462646484,
    "CMY_C": 0.01341503858566,
    "CMY_M": 0.24658733606339,
    "CMY_Y": 0.64906752109528,
    "CMYK_C": 0,
    "CMYK_M": 0.23634284734726,
    "CMYK_Y": 0.64429575204849,
    "CMYK_K": 0.01341503858566
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01956",
    "Farbtonhilfsbezeichnung": "Tibet 12",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "147",
    "Bcolor": "145",
    "Y": 28,
    "L": 59.8610076904297,
    "a": -5.27796602249146,
    "b": -1.48978996276855,
    "C": 5.48419523239136,
    "h": 195.762573242188,
    "CMY_C": 0.47936391830444,
    "CMY_M": 0.42256289720535,
    "CMY_Y": 0.42949157953262,
    "CMYK_C": 0.09836746007204,
    "CMYK_M": 0,
    "CMYK_Y": 0.01199902500957,
    "CMYK_K": 0.42256289720535
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01961",
    "Farbtonhilfsbezeichnung": "Mistral 0",
    "Farbtonklasse": "04",
    "Rcolor": "163",
    "Gcolor": "119",
    "Bcolor": "68",
    "Y": 21,
    "L": 53.383659362793,
    "a": 11.3685340881348,
    "b": 34.0758590698242,
    "C": 35.9222450256348,
    "h": 71.550048828125,
    "CMY_C": 0.36215376853943,
    "CMY_M": 0.5326761007309,
    "CMY_Y": 0.73344427347183,
    "CMYK_C": 0,
    "CMYK_M": 0.26734080910683,
    "CMYK_Y": 0.58210033178329,
    "CMYK_K": 0.36215376853943
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01962",
    "Farbtonhilfsbezeichnung": "Mistral 12",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "160",
    "Bcolor": "98",
    "Y": 40,
    "L": 69.0030822753906,
    "a": 10.9567909240723,
    "b": 38.3300857543945,
    "C": 39.8653564453125,
    "h": 74.0472259521484,
    "CMY_C": 0.18414115905762,
    "CMY_M": 0.37355917692184,
    "CMY_Y": 0.61566340923309,
    "CMYK_C": 0,
    "CMYK_M": 0.23217009007931,
    "CMYK_Y": 0.52891778945923,
    "CMYK_K": 0.18414115905762
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01965",
    "Farbtonhilfsbezeichnung": "Cognac 0",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "119",
    "Bcolor": "67",
    "Y": 27,
    "L": 55.9768409729004,
    "a": 20.6271286010742,
    "b": 38.3066940307617,
    "C": 43.5072555541992,
    "h": 61.6987228393555,
    "CMY_C": 0.27737784385681,
    "CMY_M": 0.53220784664154,
    "CMY_Y": 0.73734229803085,
    "CMYK_C": 0,
    "CMYK_M": 0.35264626145363,
    "CMYK_Y": 0.63652139902115,
    "CMYK_K": 0.27737784385681
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01967",
    "Farbtonhilfsbezeichnung": "Granat 11",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "101",
    "Bcolor": "88",
    "Y": 16,
    "L": 48.5490264892578,
    "a": 21.9531898498535,
    "b": 16.3094806671143,
    "C": 27.3485221862793,
    "h": 36.6094245910645,
    "CMY_C": 0.37975996732712,
    "CMY_M": 0.60528528690338,
    "CMY_Y": 0.65460133552551,
    "CMYK_C": 0,
    "CMYK_M": 0.36360973119736,
    "CMYK_Y": 0.44312098622322,
    "CMYK_K": 0.37975996732712
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01968",
    "Farbtonhilfsbezeichnung": "Gobi 11",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "152",
    "Bcolor": "72",
    "Y": 35,
    "L": 67.2724227905273,
    "a": 14.7238302230835,
    "b": 49.5837287902832,
    "C": 51.7236633300781,
    "h": 73.4612731933594,
    "CMY_C": 0.16877555847168,
    "CMY_M": 0.402911901474,
    "CMY_Y": 0.71876311302185,
    "CMYK_C": 0,
    "CMYK_M": 0.28167644143105,
    "CMYK_Y": 0.66165947914124,
    "CMYK_K": 0.16877555847168
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01979",
    "Farbtonhilfsbezeichnung": "Tibet 17",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "223",
    "Bcolor": "215",
    "Y": 78,
    "L": 88.6838150024414,
    "a": -1.44311738014221,
    "b": 2.98810291290283,
    "C": 3.31833505630493,
    "h": 115.778427124023,
    "CMY_C": 0.12820917367935,
    "CMY_M": 0.12383115291595,
    "CMY_Y": 0.15584844350815,
    "CMYK_C": 0.00499677751213,
    "CMYK_M": 0,
    "CMYK_Y": 0.0365423746407,
    "CMYK_K": 0.12383115291595
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01981",
    "Farbtonhilfsbezeichnung": "Marone 14",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "179",
    "Bcolor": "153",
    "Y": 50,
    "L": 74.9447402954102,
    "a": 7.32761669158936,
    "b": 16.5639362335205,
    "C": 18.1123695373535,
    "h": 66.1361846923828,
    "CMY_C": 0.17902898788452,
    "CMY_M": 0.29766154289246,
    "CMY_Y": 0.39909064769745,
    "CMYK_C": 0,
    "CMYK_M": 0.14450272917747,
    "CMYK_Y": 0.26805046200752,
    "CMYK_K": 0.17902898788452
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL01983",
    "Farbtonhilfsbezeichnung": "Malaga 11",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "112",
    "Bcolor": "90",
    "Y": 19,
    "L": 51.3133316040039,
    "a": 15.2300853729248,
    "b": 19.1239624023438,
    "C": 24.4475250244141,
    "h": 51.4666175842285,
    "CMY_C": 0.3830663561821,
    "CMY_M": 0.56040501594543,
    "CMY_Y": 0.64863204956055,
    "CMYK_C": 0,
    "CMYK_M": 0.28745174407959,
    "CMYK_Y": 0.43046072125435,
    "CMYK_K": 0.3830663561821
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02051",
    "Farbtonhilfsbezeichnung": "Mistral 14",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "200",
    "Bcolor": "153",
    "Y": 64,
    "L": 82.6028060913086,
    "a": 5.77706623077393,
    "b": 27.3742637634277,
    "C": 27.9772186279297,
    "h": 78.0831604003906,
    "CMY_C": 0.0803479552269,
    "CMY_M": 0.21379625797272,
    "CMY_Y": 0.39887672662735,
    "CMYK_C": 0,
    "CMYK_M": 0.1451073884964,
    "CMYK_Y": 0.34635791182518,
    "CMYK_K": 0.0803479552269
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02052",
    "Farbtonhilfsbezeichnung": "Schiefer 14",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "162",
    "Bcolor": "150",
    "Y": 39,
    "L": 66.8824615478516,
    "a": 0.07304901629686,
    "b": 6.42154359817505,
    "C": 6.42195892333984,
    "h": 89.3482513427734,
    "CMY_C": 0.34185361862183,
    "CMY_M": 0.36328786611557,
    "CMY_Y": 0.4115104675293,
    "CMYK_C": 0,
    "CMYK_M": 0.03256759792566,
    "CMYK_Y": 0.10583792626858,
    "CMYK_K": 0.34185361862183
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02053",
    "Farbtonhilfsbezeichnung": "Lava 14",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "184",
    "Bcolor": "164",
    "Y": 52,
    "L": 75.4823379516602,
    "a": 1.69105446338654,
    "b": 11.2596168518066,
    "C": 11.3858966827393,
    "h": 81.4587249755859,
    "CMY_C": 0.22496950626373,
    "CMY_M": 0.27718871831894,
    "CMY_Y": 0.35652983188629,
    "CMYK_C": 0,
    "CMYK_M": 0.06737697869539,
    "CMYK_Y": 0.16974857449532,
    "CMYK_K": 0.22496950626373
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02054",
    "Farbtonhilfsbezeichnung": "Lava 18",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "227",
    "Bcolor": "213",
    "Y": 83,
    "L": 90.462158203125,
    "a": 1.02339363098145,
    "b": 6.99409055709839,
    "C": 7.06856679916382,
    "h": 81.675407409668,
    "CMY_C": 0.07652842998505,
    "CMY_M": 0.11099565029144,
    "CMY_Y": 0.16562348604202,
    "CMYK_C": 0,
    "CMYK_M": 0.03732353076339,
    "CMYK_Y": 0.09647839516401,
    "CMYK_K": 0.07652842998505
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02055",
    "Farbtonhilfsbezeichnung": "Aprikose 18",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "228",
    "Bcolor": "199",
    "Y": 85,
    "L": 91.2835311889648,
    "a": 2.34958696365356,
    "b": 15.2660837173462,
    "C": 15.445837020874,
    "h": 81.2503280639648,
    "CMY_C": 0.03377062082291,
    "CMY_M": 0.10717743635178,
    "CMY_Y": 0.21787947416306,
    "CMYK_C": 0,
    "CMYK_M": 0.07597245275974,
    "CMYK_Y": 0.19054363667965,
    "CMYK_K": 0.03377062082291
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02056",
    "Farbtonhilfsbezeichnung": "Havanna 11",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "112",
    "Bcolor": "83",
    "Y": 18,
    "L": 49.866397857666,
    "a": 9.94221496582031,
    "b": 20.8275680541992,
    "C": 23.0788917541504,
    "h": 64.4821319580078,
    "CMY_C": 0.42611736059189,
    "CMY_M": 0.56161516904831,
    "CMY_Y": 0.67462027072906,
    "CMYK_C": 0,
    "CMYK_M": 0.23610717058182,
    "CMYK_Y": 0.43302044272423,
    "CMYK_K": 0.42611736059189
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02064",
    "Farbtonhilfsbezeichnung": "Granat 13",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "151",
    "Bcolor": "137",
    "Y": 35,
    "L": 67.0554428100586,
    "a": 18.4885234832764,
    "b": 14.6800012588501,
    "C": 23.6077938079834,
    "h": 38.4497909545898,
    "CMY_C": 0.1990379691124,
    "CMY_M": 0.40897887945175,
    "CMY_Y": 0.46426260471344,
    "CMYK_C": 0,
    "CMYK_M": 0.26211094856262,
    "CMYK_Y": 0.33113259077072,
    "CMYK_K": 0.1990379691124
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02066",
    "Farbtonhilfsbezeichnung": "Gobi 15",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "214",
    "Bcolor": "161",
    "Y": 75,
    "L": 87.1354064941406,
    "a": 4.46292877197266,
    "b": 29.4447746276856,
    "C": 29.7810764312744,
    "h": 81.3813095092773,
    "CMY_C": 0.03314435482025,
    "CMY_M": 0.16143304109573,
    "CMY_Y": 0.36736398935318,
    "CMYK_C": 0,
    "CMYK_M": 0.13268649578094,
    "CMYK_Y": 0.34567686915398,
    "CMYK_K": 0.03314435482025
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02083",
    "Farbtonhilfsbezeichnung": "Aprikose 16",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "214",
    "Bcolor": "170",
    "Y": 77,
    "L": 87.5778732299805,
    "a": 5.78050994873047,
    "b": 25.7399787902832,
    "C": 26.3810691833496,
    "h": 77.342887878418,
    "CMY_C": 0.02674251794815,
    "CMY_M": 0.15905451774597,
    "CMY_Y": 0.33477056026459,
    "CMYK_C": 0,
    "CMYK_M": 0.1359475851059,
    "CMYK_Y": 0.3164918422699,
    "CMYK_K": 0.02674251794815
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02086",
    "Farbtonhilfsbezeichnung": "Tibet 14",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "190",
    "Bcolor": "188",
    "Y": 53,
    "L": 76.2857055664063,
    "a": -3.58017444610596,
    "b": -0.61100596189499,
    "C": 3.63193845748901,
    "h": 189.684997558594,
    "CMY_C": 0.29222786426544,
    "CMY_M": 0.2535348534584,
    "CMY_Y": 0.26406717300415,
    "CMYK_C": 0.05183498561382,
    "CMYK_M": 0,
    "CMYK_Y": 0.01410959288478,
    "CMYK_K": 0.2535348534584
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02091",
    "Farbtonhilfsbezeichnung": "Basalt 12",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "132",
    "Bcolor": "133",
    "Y": 22,
    "L": 55.2049140930176,
    "a": 1.38271307945251,
    "b": -0.82395279407501,
    "C": 1.60959422588348,
    "h": 329.20947265625,
    "CMY_C": 0.4744239449501,
    "CMY_M": 0.4841468334198,
    "CMY_Y": 0.48018270730972,
    "CMYK_C": 0,
    "CMYK_M": 0.01849948987365,
    "CMYK_Y": 0.01095704827458,
    "CMYK_K": 0.4744239449501
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02093",
    "Farbtonhilfsbezeichnung": "Maroc 17",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "200",
    "Y": 80,
    "L": 89.4458465576172,
    "a": 2.6135516166687,
    "b": 12.4740533828735,
    "C": 12.7449073791504,
    "h": 78.166618347168,
    "CMY_C": 0.06018352508545,
    "CMY_M": 0.12753707170486,
    "CMY_Y": 0.21697503328323,
    "CMYK_C": 0,
    "CMYK_M": 0.07166670262814,
    "CMYK_Y": 0.16683204472065,
    "CMYK_K": 0.06018352508545
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02095",
    "Farbtonhilfsbezeichnung": "Bison 17",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "219",
    "Bcolor": "202",
    "Y": 77,
    "L": 87.9605331420898,
    "a": 1.2723776102066,
    "b": 8.93820476531982,
    "C": 9.02831363677979,
    "h": 81.8982238769531,
    "CMY_C": 0.09684044122696,
    "CMY_M": 0.13984626531601,
    "CMY_Y": 0.20714914798737,
    "CMYK_C": 0,
    "CMYK_M": 0.04761708527803,
    "CMYK_Y": 0.12213645130396,
    "CMYK_K": 0.09684044122696
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02096",
    "Farbtonhilfsbezeichnung": "Lava 15",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "202",
    "Bcolor": "184",
    "Y": 62,
    "L": 81.6850051879883,
    "a": 1.40727972984314,
    "b": 9.46152400970459,
    "C": 9.56560897827148,
    "h": 81.5400161743164,
    "CMY_C": 0.1639968752861,
    "CMY_M": 0.20913910865784,
    "CMY_Y": 0.27830970287323,
    "CMYK_C": 0,
    "CMYK_M": 0.05399768427014,
    "CMYK_Y": 0.13673731684685,
    "CMYK_K": 0.1639968752861
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02102",
    "Farbtonhilfsbezeichnung": "Tibet 16",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "216",
    "Bcolor": "209",
    "Y": 72,
    "L": 85.770149230957,
    "a": -2.4660120010376,
    "b": 1.96926784515381,
    "C": 3.15582489967346,
    "h": 141.390411376953,
    "CMY_C": 0.17183405160904,
    "CMY_M": 0.15340358018875,
    "CMY_Y": 0.18032336235046,
    "CMYK_C": 0.02177007868886,
    "CMYK_M": 0,
    "CMYK_Y": 0.03179765492678,
    "CMYK_K": 0.15340358018875
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02180",
    "Farbtonhilfsbezeichnung": "Palma 0",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "104",
    "Bcolor": "74",
    "Y": 13,
    "L": 44.1122627258301,
    "a": -0.84497600793839,
    "b": 17.5855140686035,
    "C": 17.6058025360107,
    "h": 92.7509231567383,
    "CMY_C": 0.55470395088196,
    "CMY_M": 0.59276509284973,
    "CMY_Y": 0.70820200443268,
    "CMYK_C": 0,
    "CMYK_M": 0.08547379076481,
    "CMYK_Y": 0.34471011161804,
    "CMYK_K": 0.55470395088196
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02315",
    "Farbtonhilfsbezeichnung": "Gobi 13 U",
    "Farbtonklasse": "02",
    "Y": 60,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02335",
    "Farbtonhilfsbezeichnung": "Aprikose 14 E",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02391",
    "Farbtonhilfsbezeichnung": "Schilf 11",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "158",
    "Bcolor": "86",
    "Y": 36,
    "L": 66.2679672241211,
    "a": 1.3057576417923,
    "b": 40.450984954834,
    "C": 40.472053527832,
    "h": 88.1511306762695,
    "CMY_C": 0.27120941877365,
    "CMY_M": 0.37900364398956,
    "CMY_Y": 0.66101121902466,
    "CMYK_C": 0,
    "CMYK_M": 0.14790837466717,
    "CMYK_Y": 0.53486120700836,
    "CMYK_K": 0.27120941877365
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02406",
    "Farbtonhilfsbezeichnung": "Aprikose 14 D",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02415",
    "Farbtonhilfsbezeichnung": "Victoria 9",
    "Farbtonklasse": "01",
    "Y": 82,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02416",
    "Farbtonhilfsbezeichnung": "Rubin 9",
    "Farbtonklasse": "01",
    "Y": 80,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02417",
    "Farbtonhilfsbezeichnung": "Aprikose 13 G",
    "Farbtonklasse": "02",
    "Y": 54,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02512",
    "Farbtonhilfsbezeichnung": "Marone 14 F",
    "Farbtonklasse": "01",
    "Y": 50,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02538",
    "Farbtonhilfsbezeichnung": "Bali 7",
    "Farbtonklasse": "01",
    "Y": 85,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02544",
    "Farbtonhilfsbezeichnung": "Aprikose 13 F",
    "Farbtonklasse": "02",
    "Y": 54,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02569",
    "Farbtonhilfsbezeichnung": "Turmalin 5",
    "Farbtonklasse": "02",
    "Y": 54,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02571",
    "Farbtonhilfsbezeichnung": "Sepia 8",
    "Farbtonklasse": "01",
    "Y": 79,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02574",
    "Farbtonhilfsbezeichnung": "Tommy 9",
    "Farbtonklasse": "01",
    "Y": 80,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02585",
    "Farbtonhilfsbezeichnung": "Rubin 0",
    "Farbtonklasse": "04",
    "Y": 15,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02589",
    "Farbtonhilfsbezeichnung": "Maroc 4",
    "Farbtonklasse": "02",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02591",
    "Farbtonhilfsbezeichnung": "India 9",
    "Farbtonklasse": "01",
    "Y": 84,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02596",
    "Farbtonhilfsbezeichnung": "Tommy 3",
    "Farbtonklasse": "03",
    "Y": 26.5,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02601",
    "Farbtonhilfsbezeichnung": "Schilf 2",
    "Farbtonklasse": "02",
    "Y": 52,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02602",
    "Farbtonhilfsbezeichnung": "Elefant 1",
    "Farbtonklasse": "03",
    "Y": 15.3,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINACOLOR",
    "Farbton_ID": "AL02614",
    "Farbtonhilfsbezeichnung": "No.12 Sanfter Morgentau",
    "Farbtonklasse": "02",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0001",
    "Farbtonhilfsbezeichnung": "1.1 Rot 1",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "67",
    "Bcolor": "82",
    "Y": 7,
    "L": 32.2436943054199,
    "a": 16.0146617889404,
    "b": -4.01728200912476,
    "C": 16.5108432769775,
    "h": 345.917907714844,
    "CMY_C": 0.61709499359131,
    "CMY_M": 0.73738676309586,
    "CMY_Y": 0.67901360988617,
    "CMYK_C": 0,
    "CMYK_M": 0.31415563821793,
    "CMYK_Y": 0.16170750558376,
    "CMYK_K": 0.61709499359131
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0002",
    "Farbtonhilfsbezeichnung": "1.2 Rot 2",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "68",
    "Bcolor": "86",
    "Y": 10,
    "L": 37.6872596740723,
    "a": 30.3364582061768,
    "b": 1.75328612327576,
    "C": 30.3870811462402,
    "h": 3.30771207809448,
    "CMY_C": 0.47460865974426,
    "CMY_M": 0.73208665847778,
    "CMY_Y": 0.66192644834518,
    "CMYK_C": 0,
    "CMYK_M": 0.49006897211075,
    "CMYK_Y": 0.35653004050255,
    "CMYK_K": 0.47460865974426
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0003",
    "Farbtonhilfsbezeichnung": "1.3 Rot 3",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "74",
    "Bcolor": "99",
    "Y": 13,
    "L": 43.0054626464844,
    "a": 38.0093154907227,
    "b": 1.96004271507263,
    "C": 38.0598182678223,
    "h": 2.95198130607605,
    "CMY_C": 0.37755209207535,
    "CMY_M": 0.70913624763489,
    "CMY_Y": 0.61213618516922,
    "CMYK_C": 0,
    "CMYK_M": 0.53270989656448,
    "CMYK_Y": 0.37687346339226,
    "CMYK_K": 0.37755209207535
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0004",
    "Farbtonhilfsbezeichnung": "1.4 Rot 4",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "67",
    "Bcolor": "86",
    "Y": 14,
    "L": 43.1602973937988,
    "a": 44.2676239013672,
    "b": 10.1789884567261,
    "C": 45.4228401184082,
    "h": 12.949610710144,
    "CMY_C": 0.33247923851013,
    "CMY_M": 0.7371701002121,
    "CMY_Y": 0.66106164455414,
    "CMYK_C": 0,
    "CMYK_M": 0.60625958442688,
    "CMYK_Y": 0.49224296212196,
    "CMYK_K": 0.33247923851013
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0005",
    "Farbtonhilfsbezeichnung": "2.1 Rot 5",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "60",
    "Bcolor": "73",
    "Y": 9,
    "L": 35.9947853088379,
    "a": 34.5911026000977,
    "b": 8.05766868591309,
    "C": 35.5171852111816,
    "h": 13.1126747131348,
    "CMY_C": 0.46207106113434,
    "CMY_M": 0.7660117149353,
    "CMY_Y": 0.71518552303314,
    "CMYK_C": 0,
    "CMYK_M": 0.5650200843811,
    "CMYK_Y": 0.4705351293087,
    "CMYK_K": 0.46207106113434
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0006",
    "Farbtonhilfsbezeichnung": "2.2 Rot 6",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "66",
    "Bcolor": "78",
    "Y": 13,
    "L": 42.8799133300781,
    "a": 44.4316024780273,
    "b": 14.8783140182495,
    "C": 46.8564987182617,
    "h": 18.5135765075684,
    "CMY_C": 0.3292835354805,
    "CMY_M": 0.7423095703125,
    "CMY_Y": 0.6930468082428,
    "CMYK_C": 0,
    "CMYK_M": 0.61579823493958,
    "CMYK_Y": 0.54235029220581,
    "CMYK_K": 0.3292835354805
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0007",
    "Farbtonhilfsbezeichnung": "2.3 Rot 7",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "73",
    "Bcolor": "79",
    "Y": 18,
    "L": 49.4459075927734,
    "a": 51.6898803710938,
    "b": 24.0293769836426,
    "C": 57.0022354125977,
    "h": 24.9325790405273,
    "CMY_C": 0.20752465724945,
    "CMY_M": 0.71191734075546,
    "CMY_Y": 0.68982434272766,
    "CMYK_C": 0,
    "CMYK_M": 0.63647747039795,
    "CMYK_Y": 0.60859900712967,
    "CMYK_K": 0.20752465724945
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0008",
    "Farbtonhilfsbezeichnung": "2.4 Rot 8",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "81",
    "Bcolor": "76",
    "Y": 21,
    "L": 52.7868118286133,
    "a": 52.7488288879395,
    "b": 30.4253997802734,
    "C": 60.89453125,
    "h": 29.976245880127,
    "CMY_C": 0.15624970197678,
    "CMY_M": 0.68307131528854,
    "CMY_Y": 0.70120275020599,
    "CMYK_C": 0,
    "CMYK_M": 0.62438094615936,
    "CMYK_Y": 0.6458700299263,
    "CMYK_K": 0.15624970197678
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0009",
    "Farbtonhilfsbezeichnung": "3.1 Rot 9",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "60",
    "Bcolor": "66",
    "Y": 12,
    "L": 40.5500450134277,
    "a": 43.6885108947754,
    "b": 19.1401309967041,
    "C": 47.6972808837891,
    "h": 23.6584396362305,
    "CMY_C": 0.35512977838516,
    "CMY_M": 0.76392877101898,
    "CMY_Y": 0.74085569381714,
    "CMYK_C": 0,
    "CMYK_M": 0.63392442464828,
    "CMYK_Y": 0.59814500808716,
    "CMYK_K": 0.35512977838516
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0010",
    "Farbtonhilfsbezeichnung": "3.2 Rot 10",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "66",
    "Bcolor": "59",
    "Y": 17,
    "L": 47.211124420166,
    "a": 52.427619934082,
    "b": 33.1909866333008,
    "C": 62.0507621765137,
    "h": 32.3371696472168,
    "CMY_C": 0.22331857681274,
    "CMY_M": 0.74250471591949,
    "CMY_Y": 0.77006620168686,
    "CMYK_C": 0,
    "CMYK_M": 0.6684672832489,
    "CMYK_Y": 0.70395350456238,
    "CMYK_K": 0.22331857681274
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0011",
    "Farbtonhilfsbezeichnung": "3.3 Rot 11",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "77",
    "Bcolor": "60",
    "Y": 20,
    "L": 51.982795715332,
    "a": 53.35009765625,
    "b": 38.9334182739258,
    "C": 66.045768737793,
    "h": 36.1209297180176,
    "CMY_C": 0.15662187337875,
    "CMY_M": 0.69678604602814,
    "CMY_Y": 0.7665593624115,
    "CMYK_C": 0,
    "CMYK_M": 0.64047688245773,
    "CMYK_Y": 0.72320759296417,
    "CMYK_K": 0.15662187337875
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0012",
    "Farbtonhilfsbezeichnung": "3.4 Rot 12",
    "Farbtonklasse": "04",
    "Rcolor": "233",
    "Gcolor": "91",
    "Bcolor": "53",
    "Y": 25,
    "L": 57.2118721008301,
    "a": 53.1491470336914,
    "b": 49.0858383178711,
    "C": 72.3481292724609,
    "h": 42.7239875793457,
    "CMY_C": 0.08621317148209,
    "CMY_M": 0.64128965139389,
    "CMY_Y": 0.79409456253052,
    "CMYK_C": 0,
    "CMYK_M": 0.607446372509,
    "CMYK_Y": 0.77466797828674,
    "CMYK_K": 0.08621317148209
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0013",
    "Farbtonhilfsbezeichnung": "4.1 Brombeere 1",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "67",
    "Bcolor": "80",
    "Y": 10,
    "L": 36.9434127807617,
    "a": 29.5955581665039,
    "b": 4.30631637573242,
    "C": 29.9072132110596,
    "h": 8.27875232696533,
    "CMY_C": 0.48209726810455,
    "CMY_M": 0.73735058307648,
    "CMY_Y": 0.68454802036285,
    "CMYK_C": 0,
    "CMYK_M": 0.49285957217216,
    "CMYK_Y": 0.39090496301651,
    "CMYK_K": 0.48209726810455
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0014",
    "Farbtonhilfsbezeichnung": "4.2 Brombeere 2",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "66",
    "Bcolor": "83",
    "Y": 13,
    "L": 41.8989372253418,
    "a": 42.3704986572266,
    "b": 10.4968662261963,
    "C": 43.6513862609863,
    "h": 13.9143056869507,
    "CMY_C": 0.35569286346436,
    "CMY_M": 0.74143308401108,
    "CMY_Y": 0.67505329847336,
    "CMYK_C": 0,
    "CMYK_M": 0.59868997335434,
    "CMYK_Y": 0.49566489458084,
    "CMYK_K": 0.35569286346436
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0015",
    "Farbtonhilfsbezeichnung": "4.3 Brombeere 3",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "70",
    "Bcolor": "86",
    "Y": 15,
    "L": 44.9538345336914,
    "a": 45.4801139831543,
    "b": 13.3609256744385,
    "C": 47.4020576477051,
    "h": 16.3714752197266,
    "CMY_C": 0.30210012197495,
    "CMY_M": 0.72540533542633,
    "CMY_Y": 0.66424262523651,
    "CMYK_C": 0,
    "CMYK_M": 0.60654145479202,
    "CMYK_Y": 0.51890325546265,
    "CMYK_K": 0.30210012197495
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0016",
    "Farbtonhilfsbezeichnung": "4.4 Brombeere 4",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "68",
    "Bcolor": "79",
    "Y": 15,
    "L": 45.513599395752,
    "a": 47.6729125976563,
    "b": 18.3562335968018,
    "C": 51.0848121643066,
    "h": 21.0589694976807,
    "CMY_C": 0.2792843580246,
    "CMY_M": 0.73168581724167,
    "CMY_Y": 0.69027131795883,
    "CMYK_C": 0,
    "CMYK_M": 0.62771147489548,
    "CMYK_Y": 0.57024842500687,
    "CMYK_K": 0.2792843580246
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0017",
    "Farbtonhilfsbezeichnung": "5.1 Navarra 1",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "64",
    "Bcolor": "66",
    "Y": 8,
    "L": 34.5549583435059,
    "a": 25.9390258789063,
    "b": 9.65646839141846,
    "C": 27.6781578063965,
    "h": 20.419075012207,
    "CMY_C": 0.51771306991577,
    "CMY_M": 0.74891972541809,
    "CMY_Y": 0.73933172225952,
    "CMYK_C": 0,
    "CMYK_M": 0.47939649224281,
    "CMYK_Y": 0.45951619744301,
    "CMYK_K": 0.51771306991577
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0018",
    "Farbtonhilfsbezeichnung": "5.2 Navarra 2",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "67",
    "Bcolor": "73",
    "Y": 10,
    "L": 37.7987442016602,
    "a": 31.4165172576904,
    "b": 10.1140956878662,
    "C": 33.0044326782227,
    "h": 17.8452167510986,
    "CMY_C": 0.45545130968094,
    "CMY_M": 0.7373046875,
    "CMY_Y": 0.71211218833923,
    "CMYK_C": 0,
    "CMYK_M": 0.51759076118469,
    "CMYK_Y": 0.47132769227028,
    "CMYK_K": 0.45545130968094
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0019",
    "Farbtonhilfsbezeichnung": "5.3 Navarra 3",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "83",
    "Bcolor": "89",
    "Y": 14,
    "L": 44.1334457397461,
    "a": 31.0956497192383,
    "b": 9.82448482513428,
    "C": 32.6107330322266,
    "h": 17.533618927002,
    "CMY_C": 0.38873869180679,
    "CMY_M": 0.67517226934433,
    "CMY_Y": 0.65228778123856,
    "CMYK_C": 0,
    "CMYK_M": 0.46859431266785,
    "CMYK_Y": 0.43115618824959,
    "CMYK_K": 0.38873869180679
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0020",
    "Farbtonhilfsbezeichnung": "5.4 Navarra 4",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "88",
    "Bcolor": "92",
    "Y": 17,
    "L": 48.4361190795898,
    "a": 37.215404510498,
    "b": 14.2495803833008,
    "C": 39.8501815795898,
    "h": 20.9515781402588,
    "CMY_C": 0.30300796031952,
    "CMY_M": 0.65596622228622,
    "CMY_Y": 0.63922393321991,
    "CMYK_C": 0,
    "CMYK_M": 0.50640213489532,
    "CMYK_Y": 0.48238137364388,
    "CMYK_K": 0.30300796031952
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0021",
    "Farbtonhilfsbezeichnung": "6.1 Johannisbeere 1",
    "Farbtonklasse": "04",
    "Rcolor": "145",
    "Gcolor": "70",
    "Bcolor": "75",
    "Y": 11,
    "L": 39.4341659545898,
    "a": 32.4610939025879,
    "b": 11.4998350143433,
    "C": 34.4378967285156,
    "h": 19.5074634552002,
    "CMY_C": 0.43071460723877,
    "CMY_M": 0.72580206394196,
    "CMY_Y": 0.70571112632751,
    "CMYK_C": 0,
    "CMYK_M": 0.51834714412689,
    "CMYK_Y": 0.4830556511879,
    "CMYK_K": 0.43071460723877
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0022",
    "Farbtonhilfsbezeichnung": "6.2 Johannisbeere 2",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "57",
    "Bcolor": "66",
    "Y": 11,
    "L": 39.1848564147949,
    "a": 43.2586784362793,
    "b": 17.0838241577148,
    "C": 46.509895324707,
    "h": 21.5501766204834,
    "CMY_C": 0.37478244304657,
    "CMY_M": 0.77528363466263,
    "CMY_Y": 0.74025726318359,
    "CMYK_C": 0,
    "CMYK_M": 0.64057892560959,
    "CMYK_Y": 0.58455622196198,
    "CMYK_K": 0.37478244304657
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0023",
    "Farbtonhilfsbezeichnung": "6.3 Johannisbeere 3",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "68",
    "Bcolor": "74",
    "Y": 15,
    "L": 45.5092086791992,
    "a": 47.9031028747559,
    "b": 21.6570930480957,
    "C": 52.5712547302246,
    "h": 24.3278255462646,
    "CMY_C": 0.27491402626038,
    "CMY_M": 0.73382520675659,
    "CMY_Y": 0.71131432056427,
    "CMYK_C": 0,
    "CMYK_M": 0.63290590047836,
    "CMYK_Y": 0.60186004638672,
    "CMYK_K": 0.27491402626038
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0024",
    "Farbtonhilfsbezeichnung": "6.4 Johannisbeere 4",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "85",
    "Bcolor": "95",
    "Y": 21,
    "L": 52.0719833374023,
    "a": 48.4997329711914,
    "b": 18.0217208862305,
    "C": 51.7397956848145,
    "h": 20.3842582702637,
    "CMY_C": 0.19856292009354,
    "CMY_M": 0.66678094863892,
    "CMY_Y": 0.62709391117096,
    "CMYK_C": 0,
    "CMYK_M": 0.58422309160233,
    "CMYK_Y": 0.53470319509506,
    "CMYK_K": 0.19856292009354
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0025",
    "Farbtonhilfsbezeichnung": "7.1 Piemont 1",
    "Farbtonklasse": "04",
    "Rcolor": "146",
    "Gcolor": "63",
    "Bcolor": "67",
    "Y": 10,
    "L": 37.959358215332,
    "a": 35.810489654541,
    "b": 14.7980642318726,
    "C": 38.7475662231445,
    "h": 22.4520130157471,
    "CMY_C": 0.42651623487473,
    "CMY_M": 0.75375366210938,
    "CMY_Y": 0.7386811375618,
    "CMYK_C": 0,
    "CMYK_M": 0.57061326503754,
    "CMYK_Y": 0.54433083534241,
    "CMYK_K": 0.42651623487473
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0026",
    "Farbtonhilfsbezeichnung": "7.2 Piemont 2",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "65",
    "Bcolor": "63",
    "Y": 12,
    "L": 41.2486724853516,
    "a": 41.2837409973145,
    "b": 21.9937896728516,
    "C": 46.77685546875,
    "h": 28.0463256835938,
    "CMY_C": 0.35590356588364,
    "CMY_M": 0.74632716178894,
    "CMY_Y": 0.75327724218369,
    "CMYK_C": 0,
    "CMYK_M": 0.60615706443787,
    "CMYK_Y": 0.61694747209549,
    "CMYK_K": 0.35590356588364
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0027",
    "Farbtonhilfsbezeichnung": "7.3 Piemont 3",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "69",
    "Bcolor": "66",
    "Y": 13,
    "L": 42.9532012939453,
    "a": 41.404296875,
    "b": 22.778715133667,
    "C": 47.2565956115723,
    "h": 28.8175411224365,
    "CMY_C": 0.33501791954041,
    "CMY_M": 0.72988188266754,
    "CMY_Y": 0.74313628673553,
    "CMYK_C": 0,
    "CMYK_M": 0.59379637241364,
    "CMYK_Y": 0.61372834444046,
    "CMYK_K": 0.33501791954041
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0028",
    "Farbtonhilfsbezeichnung": "7.4 Piemont 4",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "89",
    "Bcolor": "86",
    "Y": 19,
    "L": 51.0616607666016,
    "a": 42.2232627868652,
    "b": 21.6730880737305,
    "C": 47.4607925415039,
    "h": 27.1713085174561,
    "CMY_C": 0.23814690113068,
    "CMY_M": 0.65103739500046,
    "CMY_Y": 0.66194641590118,
    "CMYK_C": 0,
    "CMYK_M": 0.54195553064346,
    "CMYK_Y": 0.55627459287643,
    "CMYK_K": 0.23814690113068
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0029",
    "Farbtonhilfsbezeichnung": "8.1 Bardolino 1",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "68",
    "Bcolor": "61",
    "Y": 10,
    "L": 37.2120323181152,
    "a": 28.711332321167,
    "b": 16.820348739624,
    "C": 33.2755889892578,
    "h": 30.3636302947998,
    "CMY_C": 0.46690034866333,
    "CMY_M": 0.73498940467834,
    "CMY_Y": 0.75938069820404,
    "CMYK_C": 0,
    "CMYK_M": 0.50288730859756,
    "CMYK_Y": 0.54864102602005,
    "CMYK_K": 0.46690034866333
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0030",
    "Farbtonhilfsbezeichnung": "8.2 Bardolino 2",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "76",
    "Bcolor": "72",
    "Y": 13,
    "L": 42.3846588134766,
    "a": 33.5232925415039,
    "b": 17.3906707763672,
    "C": 37.7656784057617,
    "h": 27.4186496734619,
    "CMY_C": 0.38572227954865,
    "CMY_M": 0.70264089107513,
    "CMY_Y": 0.7158071398735,
    "CMYK_C": 0,
    "CMYK_M": 0.51592075824738,
    "CMYK_Y": 0.53735446929932,
    "CMYK_K": 0.38572227954865
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0031",
    "Farbtonhilfsbezeichnung": "8.3 Bardolino 3",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "93",
    "Bcolor": "89",
    "Y": 20,
    "L": 50.9545783996582,
    "a": 38.4949760437012,
    "b": 19.8954887390137,
    "C": 43.3323631286621,
    "h": 27.3314304351807,
    "CMY_C": 0.26054251194,
    "CMY_M": 0.63702654838562,
    "CMY_Y": 0.65214377641678,
    "CMYK_C": 0,
    "CMYK_M": 0.50913548469543,
    "CMYK_Y": 0.52957916259766,
    "CMYK_K": 0.26054251194
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0032",
    "Farbtonhilfsbezeichnung": "8.4 Bardolino 4",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "94",
    "Bcolor": "89",
    "Y": 22,
    "L": 53.9968185424805,
    "a": 45.0315818786621,
    "b": 24.5529708862305,
    "C": 51.2902679443359,
    "h": 28.6009368896484,
    "CMY_C": 0.18617004156113,
    "CMY_M": 0.63329458236694,
    "CMY_Y": 0.65294003486633,
    "CMYK_C": 0,
    "CMYK_M": 0.54940783977509,
    "CMYK_Y": 0.57354730367661,
    "CMYK_K": 0.18617004156113
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0033",
    "Farbtonhilfsbezeichnung": "9.1 Chianti 1",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "71",
    "Bcolor": "65",
    "Y": 11,
    "L": 39.8952751159668,
    "a": 32.5673294067383,
    "b": 18.3253879547119,
    "C": 37.3691139221191,
    "h": 29.3661251068115,
    "CMY_C": 0.4170041680336,
    "CMY_M": 0.72342890501022,
    "CMY_Y": 0.74422711133957,
    "CMYK_C": 0,
    "CMYK_M": 0.52560365200043,
    "CMYK_Y": 0.56127834320068,
    "CMYK_K": 0.4170041680336
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0034",
    "Farbtonhilfsbezeichnung": "9.2 Chianti 2",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 13,
    "L": 42.4175987243652,
    "a": 38.0057945251465,
    "b": 23.0006694793701,
    "C": 44.4237670898438,
    "h": 31.1818428039551,
    "CMY_C": 0.35740798711777,
    "CMY_M": 0.72089719772339,
    "CMY_Y": 0.75022828578949,
    "CMYK_C": 0,
    "CMYK_M": 0.56566095352173,
    "CMYK_Y": 0.6113058924675,
    "CMYK_K": 0.35740798711777
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0035",
    "Farbtonhilfsbezeichnung": "9.3 Chianti 3",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "87",
    "Bcolor": "82",
    "Y": 16,
    "L": 49.3502082824707,
    "a": 39.9429817199707,
    "b": 21.5718269348145,
    "C": 45.3958740234375,
    "h": 28.3719520568848,
    "CMY_C": 0.269710958004,
    "CMY_M": 0.65917819738388,
    "CMY_Y": 0.67769145965576,
    "CMYK_C": 0,
    "CMYK_M": 0.53330558538437,
    "CMYK_Y": 0.55865621566772,
    "CMYK_K": 0.269710958004
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0036",
    "Farbtonhilfsbezeichnung": "9.4 Chianti 4",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "114",
    "Bcolor": "108",
    "Y": 29,
    "L": 60.2951583862305,
    "a": 41.3403511047363,
    "b": 22.0261631011963,
    "C": 46.8420372009277,
    "h": 28.0487155914307,
    "CMY_C": 0.13398873806,
    "CMY_M": 0.55306327342987,
    "CMY_Y": 0.57692074775696,
    "CMYK_C": 0,
    "CMYK_M": 0.4839134812355,
    "CMYK_Y": 0.51146221160889,
    "CMYK_K": 0.13398873806
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0037",
    "Farbtonhilfsbezeichnung": "10.1 Granatapfel 1",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "75",
    "Bcolor": "61",
    "Y": 12,
    "L": 41.1736297607422,
    "a": 30.9239120483398,
    "b": 22.7729034423828,
    "C": 38.4043426513672,
    "h": 36.3685722351074,
    "CMY_C": 0.40626668930054,
    "CMY_M": 0.70618951320648,
    "CMY_Y": 0.76163762807846,
    "CMYK_C": 0,
    "CMYK_M": 0.50514739751816,
    "CMYK_Y": 0.59853631258011,
    "CMYK_K": 0.40626668930054
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0038",
    "Farbtonhilfsbezeichnung": "10.2 Granatapfel 2",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "75",
    "Bcolor": "61",
    "Y": 14,
    "L": 43.8967437744141,
    "a": 37.5007476806641,
    "b": 26.3446388244629,
    "C": 45.829532623291,
    "h": 35.0884132385254,
    "CMY_C": 0.33986693620682,
    "CMY_M": 0.70496070384979,
    "CMY_Y": 0.7589293718338,
    "CMYK_C": 0,
    "CMYK_M": 0.55306088924408,
    "CMYK_Y": 0.63481509685516,
    "CMYK_K": 0.33986693620682
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0039",
    "Farbtonhilfsbezeichnung": "10.3 Granatapfel 3",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "100",
    "Bcolor": "87",
    "Y": 22,
    "L": 53.4528121948242,
    "a": 37.439380645752,
    "b": 24.6505432128906,
    "C": 44.8258476257324,
    "h": 33.3613929748535,
    "CMY_C": 0.23159718513489,
    "CMY_M": 0.60904514789581,
    "CMY_Y": 0.66061043739319,
    "CMYK_C": 0,
    "CMYK_M": 0.49121105670929,
    "CMYK_Y": 0.5583181977272,
    "CMYK_K": 0.23159718513489
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0040",
    "Farbtonhilfsbezeichnung": "10.4 Granatapfel 4",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "116",
    "Bcolor": "103",
    "Y": 27,
    "L": 58.2676429748535,
    "a": 32.8612289428711,
    "b": 21.9638061523438,
    "C": 39.5255508422852,
    "h": 33.757999420166,
    "CMY_C": 0.20360106229782,
    "CMY_M": 0.54379653930664,
    "CMY_Y": 0.59796142578125,
    "CMYK_C": 0,
    "CMYK_M": 0.42716717720032,
    "CMYK_Y": 0.49517941474915,
    "CMYK_K": 0.20360106229782
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0041",
    "Farbtonhilfsbezeichnung": "11.1 Sangria 1",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "73",
    "Bcolor": "61",
    "Y": 13,
    "L": 42.7841796875,
    "a": 37.4580764770508,
    "b": 25.0816631317139,
    "C": 45.0798988342285,
    "h": 33.8059844970703,
    "CMY_C": 0.35395222902298,
    "CMY_M": 0.7155128121376,
    "CMY_Y": 0.76056694984436,
    "CMYK_C": 0,
    "CMYK_M": 0.55964994430542,
    "CMYK_Y": 0.62938803434372,
    "CMYK_K": 0.35395222902298
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0042",
    "Farbtonhilfsbezeichnung": "11.2 Sangria 2",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "80",
    "Bcolor": "69",
    "Y": 17,
    "L": 47.7478904724121,
    "a": 42.1724281311035,
    "b": 27.4641304016113,
    "C": 50.3268547058105,
    "h": 33.0735549926758,
    "CMY_C": 0.27127361297607,
    "CMY_M": 0.68582385778427,
    "CMY_Y": 0.73047196865082,
    "CMYK_C": 0,
    "CMYK_M": 0.56886953115463,
    "CMYK_Y": 0.63013821840286,
    "CMYK_K": 0.27127361297607
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0043",
    "Farbtonhilfsbezeichnung": "11.3 Sangria 3",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "101",
    "Bcolor": "88",
    "Y": 25,
    "L": 56.8869247436523,
    "a": 45.2272682189941,
    "b": 28.9019203186035,
    "C": 53.6733322143555,
    "h": 32.5801048278809,
    "CMY_C": 0.1461900472641,
    "CMY_M": 0.60523992776871,
    "CMY_Y": 0.65511429309845,
    "CMYK_C": 0,
    "CMYK_M": 0.53764879703522,
    "CMYK_Y": 0.59606266021729,
    "CMYK_K": 0.1461900472641
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0044",
    "Farbtonhilfsbezeichnung": "11.4 Sangria 4",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "116",
    "Bcolor": "100",
    "Y": 30,
    "L": 60.8252487182617,
    "a": 40.378360748291,
    "b": 27.097620010376,
    "C": 48.6281089782715,
    "h": 33.8652687072754,
    "CMY_C": 0.12665772438049,
    "CMY_M": 0.54520398378372,
    "CMY_Y": 0.60670185089111,
    "CMYK_C": 0,
    "CMYK_M": 0.47924652695656,
    "CMYK_Y": 0.54966324567795,
    "CMYK_K": 0.12665772438049
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0045",
    "Farbtonhilfsbezeichnung": "12.1 Erdbeere 1",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "70",
    "Bcolor": "57",
    "Y": 13,
    "L": 41.7981185913086,
    "a": 37.6914825439453,
    "b": 26.4001808166504,
    "C": 46.017578125,
    "h": 35.008487701416,
    "CMY_C": 0.36293333768845,
    "CMY_M": 0.72645139694214,
    "CMY_Y": 0.77776634693146,
    "CMYK_C": 0,
    "CMYK_M": 0.57061225175858,
    "CMYK_Y": 0.65116107463837,
    "CMYK_K": 0.36293333768845
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0046",
    "Farbtonhilfsbezeichnung": "12.2 Erdbeere 2",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "95",
    "Bcolor": "76",
    "Y": 22,
    "L": 53.9575271606445,
    "a": 43.2188568115234,
    "b": 31.6010894775391,
    "C": 53.5396919250488,
    "h": 36.1738052368164,
    "CMY_C": 0.18886584043503,
    "CMY_M": 0.62777262926102,
    "CMY_Y": 0.70136487483978,
    "CMYK_C": 0,
    "CMYK_M": 0.54110258817673,
    "CMYK_Y": 0.63183015584946,
    "CMYK_K": 0.18886584043503
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0047",
    "Farbtonhilfsbezeichnung": "12.3 Erdbeere 3",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "105",
    "Bcolor": "84",
    "Y": 27,
    "L": 58.2325286865234,
    "a": 44.6921882629395,
    "b": 33.2321243286133,
    "C": 55.6934967041016,
    "h": 36.6336784362793,
    "CMY_C": 0.12851822376251,
    "CMY_M": 0.59004151821136,
    "CMY_Y": 0.67242509126663,
    "CMYK_C": 0,
    "CMYK_M": 0.52958458662033,
    "CMYK_Y": 0.62411731481552,
    "CMYK_K": 0.12851822376251
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0048",
    "Farbtonhilfsbezeichnung": "12.4 Erdbeere 4",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "125",
    "Bcolor": "102",
    "Y": 34,
    "L": 64.5591354370117,
    "a": 40.495002746582,
    "b": 31.4147415161133,
    "C": 51.2516479492188,
    "h": 37.8031768798828,
    "CMY_C": 0.07643896341324,
    "CMY_M": 0.5078781247139,
    "CMY_Y": 0.60077053308487,
    "CMYK_C": 0,
    "CMYK_M": 0.46714743971825,
    "CMYK_Y": 0.56772810220718,
    "CMYK_K": 0.07643896341324
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0049",
    "Farbtonhilfsbezeichnung": "13.1 Camelie 1",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "172",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.0947036743164,
    "a": 22.9078407287598,
    "b": 10.8352022171021,
    "C": 25.3410892486572,
    "h": 25.3137283325195,
    "CMY_C": 0.07708692550659,
    "CMY_M": 0.32533985376358,
    "CMY_Y": 0.34365582466125,
    "CMYK_C": 0,
    "CMYK_M": 0.26898843050003,
    "CMYK_Y": 0.28883424401283,
    "CMYK_K": 0.07708692550659
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0050",
    "Farbtonhilfsbezeichnung": "13.2 Camelie 2",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "187",
    "Bcolor": "181",
    "Y": 59,
    "L": 80.4346466064453,
    "a": 18.3379688262939,
    "b": 9.42737102508545,
    "C": 20.6193218231201,
    "h": 27.20725440979,
    "CMY_C": 0.06035768985748,
    "CMY_M": 0.26567316055298,
    "CMY_Y": 0.28866344690323,
    "CMYK_C": 0,
    "CMYK_M": 0.2185038626194,
    "CMYK_Y": 0.24297091364861,
    "CMYK_K": 0.06035768985748
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0051",
    "Farbtonhilfsbezeichnung": "13.3 Camelie 3",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "217",
    "Bcolor": "210",
    "Y": 75,
    "L": 89.5468978881836,
    "a": 12.1039752960205,
    "b": 7.54293537139893,
    "C": 14.2619104385376,
    "h": 31.9302673339844,
    "CMY_C": 0.0038703083992,
    "CMY_M": 0.14902514219284,
    "CMY_Y": 0.17796266078949,
    "CMYK_C": 0,
    "CMYK_M": 0.1457188129425,
    "CMYK_Y": 0.17476876080036,
    "CMYK_K": 0.0038703083992
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0052",
    "Farbtonhilfsbezeichnung": "13.4 Camelie 4",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 79,
    "L": 91.3273010253906,
    "a": 6.93776178359985,
    "b": 6.00000810623169,
    "C": 9.17238426208496,
    "h": 40.8543472290039,
    "CMY_C": 0.02536183595657,
    "CMY_M": 0.11561757326126,
    "CMY_Y": 0.14790034294128,
    "CMYK_C": 0,
    "CMYK_M": 0.09260435402393,
    "CMYK_Y": 0.12572717666626,
    "CMYK_K": 0.02536183595657
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0053",
    "Farbtonhilfsbezeichnung": "14.1 Yasmin 1",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "180",
    "Bcolor": "178",
    "Y": 52,
    "L": 76.9682083129883,
    "a": 15.7822589874268,
    "b": 6.20540237426758,
    "C": 16.958381652832,
    "h": 21.4641799926758,
    "CMY_C": 0.12439107894897,
    "CMY_M": 0.29509562253952,
    "CMY_Y": 0.3026916384697,
    "CMYK_C": 0,
    "CMYK_M": 0.19495522975922,
    "CMYK_Y": 0.20363035798073,
    "CMYK_K": 0.12439107894897
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0054",
    "Farbtonhilfsbezeichnung": "14.2 Yasmin 2",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "195",
    "Bcolor": "192",
    "Y": 61,
    "L": 81.5876235961914,
    "a": 12.6804542541504,
    "b": 5.04686975479126,
    "C": 13.6478872299194,
    "h": 21.7027473449707,
    "CMY_C": 0.09676444530487,
    "CMY_M": 0.23691821098328,
    "CMY_Y": 0.24569398164749,
    "CMYK_C": 0,
    "CMYK_M": 0.15516856312752,
    "CMYK_Y": 0.16488449275494,
    "CMYK_K": 0.09676444530487
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0055",
    "Farbtonhilfsbezeichnung": "14.3 Yasmin 3",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "208",
    "Bcolor": "207",
    "Y": 69,
    "L": 85.7878189086914,
    "a": 9.83000946044922,
    "b": 3.44803214073181,
    "C": 10.4171981811523,
    "h": 19.3291320800781,
    "CMY_C": 0.07423663139343,
    "CMY_M": 0.18337345123291,
    "CMY_Y": 0.1891815662384,
    "CMYK_C": 0,
    "CMYK_M": 0.11788846552372,
    "CMYK_Y": 0.12416233122349,
    "CMYK_K": 0.07423663139343
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0056",
    "Farbtonhilfsbezeichnung": "14.4 Yasmin 4",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.4907379150391,
    "a": 6.73707866668701,
    "b": 3.73232841491699,
    "C": 7.70185089111328,
    "h": 28.9863662719727,
    "CMY_C": 0.05435961484909,
    "CMY_M": 0.13485872745514,
    "CMY_Y": 0.15131425857544,
    "CMYK_C": 0,
    "CMYK_M": 0.08512655645609,
    "CMYK_Y": 0.10252802819014,
    "CMYK_K": 0.05435961484909
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0057",
    "Farbtonhilfsbezeichnung": "15.1 Hibiscus 1",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "154",
    "Bcolor": "153",
    "Y": 39,
    "L": 68.9994277954102,
    "a": 21.1450901031494,
    "b": 8.43131351470947,
    "C": 22.7640476226807,
    "h": 21.7389602661133,
    "CMY_C": 0.17367434501648,
    "CMY_M": 0.39450591802597,
    "CMY_Y": 0.40056294202805,
    "CMYK_C": 0,
    "CMYK_M": 0.26724520325661,
    "CMYK_Y": 0.27457529306412,
    "CMYK_K": 0.17367434501648
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0058",
    "Farbtonhilfsbezeichnung": "15.2 Hibiscus 2",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "186",
    "Bcolor": "184",
    "Y": 55,
    "L": 79.0696563720703,
    "a": 14.8390779495239,
    "b": 5.93585443496704,
    "C": 15.9822587966919,
    "h": 21.802152633667,
    "CMY_C": 0.10786008834839,
    "CMY_M": 0.26999312639236,
    "CMY_Y": 0.27863997220993,
    "CMYK_C": 0,
    "CMYK_M": 0.18173499405384,
    "CMYK_Y": 0.19142724573612,
    "CMYK_K": 0.10786008834839
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0059",
    "Farbtonhilfsbezeichnung": "15.3 Hisbiscus 3",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.5388946533203,
    "a": 7.15142202377319,
    "b": 2.66166234016418,
    "C": 7.63068056106567,
    "h": 20.4145851135254,
    "CMY_C": 0.05398106575012,
    "CMY_M": 0.13505834341049,
    "CMY_Y": 0.14283531904221,
    "CMYK_C": 0,
    "CMYK_M": 0.0857036486268,
    "CMYK_Y": 0.09392439574003,
    "CMYK_K": 0.05398106575012
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0060",
    "Farbtonhilfsbezeichnung": "15.4 Hibiscus 4",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "228",
    "Bcolor": "226",
    "Y": 81,
    "L": 91.842155456543,
    "a": 5.32825326919556,
    "b": 1.98053896427155,
    "C": 5.68443632125854,
    "h": 20.3903560638428,
    "CMY_C": 0.04383856058121,
    "CMY_M": 0.10473400354385,
    "CMY_Y": 0.11269491910934,
    "CMYK_C": 0,
    "CMYK_M": 0.06368740648031,
    "CMYK_Y": 0.07201331853867,
    "CMYK_K": 0.04383856058121
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0061",
    "Farbtonhilfsbezeichnung": "16.1 Magnolia 1",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "153",
    "Bcolor": "159",
    "Y": 43,
    "L": 71.5411605834961,
    "a": 31.3445072174072,
    "b": 8.99081516265869,
    "C": 32.6084785461426,
    "h": 16.0049362182617,
    "CMY_C": 0.08088713884354,
    "CMY_M": 0.39831334352493,
    "CMY_Y": 0.37654948234558,
    "CMYK_C": 0,
    "CMYK_M": 0.34536150097847,
    "CMYK_Y": 0.32168230414391,
    "CMYK_K": 0.08088713884354
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0062",
    "Farbtonhilfsbezeichnung": "16.2 Magnolia 2",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "189",
    "Bcolor": "193",
    "Y": 60,
    "L": 81.5031127929688,
    "a": 20.5829830169678,
    "b": 4.98875331878662,
    "C": 21.1789245605469,
    "h": 13.6242055892944,
    "CMY_C": 0.04397231340408,
    "CMY_M": 0.25910890102386,
    "CMY_Y": 0.24496245384216,
    "CMYK_C": 0,
    "CMYK_M": 0.22503174841404,
    "CMYK_Y": 0.21023464202881,
    "CMYK_K": 0.04397231340408
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0063",
    "Farbtonhilfsbezeichnung": "16.3 Magnolia 3",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "215",
    "Bcolor": "216",
    "Y": 74,
    "L": 88.5863265991211,
    "a": 11.5795965194702,
    "b": 2.86074614524841,
    "C": 11.9277372360229,
    "h": 13.8770847320557,
    "CMY_C": 0.03166842460632,
    "CMY_M": 0.15693730115891,
    "CMY_Y": 0.1540938615799,
    "CMYK_C": 0,
    "CMYK_M": 0.12936568260193,
    "CMYK_Y": 0.12642924487591,
    "CMYK_K": 0.03166842460632
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0064",
    "Farbtonhilfsbezeichnung": "16.4 Magnolia 4",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "224",
    "Bcolor": "224",
    "Y": 80,
    "L": 91.0220031738281,
    "a": 7.845299243927,
    "b": 2.26476836204529,
    "C": 8.16565322875977,
    "h": 16.1022853851318,
    "CMY_C": 0.03326535224915,
    "CMY_M": 0.12024146318436,
    "CMY_Y": 0.12348663806915,
    "CMYK_C": 0,
    "CMYK_M": 0.08996895700693,
    "CMYK_Y": 0.09332580119371,
    "CMYK_K": 0.03326535224915
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0065",
    "Farbtonhilfsbezeichnung": "17.1 Lupine 1",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "106",
    "Bcolor": "120",
    "Y": 23,
    "L": 55.4591445922852,
    "a": 37.869686126709,
    "b": 7.99074792861938,
    "C": 38.703556060791,
    "h": 11.9149980545044,
    "CMY_C": 0.22923511266708,
    "CMY_M": 0.58594793081284,
    "CMY_Y": 0.53080880641937,
    "CMYK_C": 0,
    "CMYK_M": 0.46280366182327,
    "CMYK_Y": 0.39126548171043,
    "CMYK_K": 0.22923511266708
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0066",
    "Farbtonhilfsbezeichnung": "17.2 Lupine 2",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "131",
    "Bcolor": "144",
    "Y": 35,
    "L": 65.3210983276367,
    "a": 37.907527923584,
    "b": 8.1684045791626,
    "C": 38.7776145935059,
    "h": 12.1602954864502,
    "CMY_C": 0.1155903339386,
    "CMY_M": 0.4847719669342,
    "CMY_Y": 0.43348449468613,
    "CMYK_C": 0,
    "CMYK_M": 0.41743284463882,
    "CMYK_Y": 0.35944220423698,
    "CMYK_K": 0.1155903339386
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0067",
    "Farbtonhilfsbezeichnung": "17.3 Lupine 3",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "167",
    "Bcolor": "175",
    "Y": 49,
    "L": 75.4162063598633,
    "a": 28.1311359405518,
    "b": 5.85869312286377,
    "C": 28.7347373962402,
    "h": 11.7644624710083,
    "CMY_C": 0.06268227100372,
    "CMY_M": 0.3465029001236,
    "CMY_Y": 0.31463307142258,
    "CMYK_C": 0,
    "CMYK_M": 0.30280086398125,
    "CMYK_Y": 0.26879978179932,
    "CMYK_K": 0.06268227100372
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0068",
    "Farbtonhilfsbezeichnung": "17.4 Lupine 4",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "210",
    "Bcolor": "211",
    "Y": 71,
    "L": 86.9929656982422,
    "a": 12.5672760009766,
    "b": 3.17379808425903,
    "C": 12.9618444442749,
    "h": 14.1733808517456,
    "CMY_C": 0.04174464941025,
    "CMY_M": 0.17713558673859,
    "CMY_Y": 0.17365342378616,
    "CMYK_C": 0,
    "CMYK_M": 0.1412889957428,
    "CMYK_Y": 0.13765513896942,
    "CMYK_K": 0.04174464941025
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0069",
    "Farbtonhilfsbezeichnung": "18.1 Oleander 1",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "110",
    "Bcolor": "116",
    "Y": 28,
    "L": 58.9013938903809,
    "a": 41.6202812194824,
    "b": 15.2790727615356,
    "C": 44.3361930847168,
    "h": 20.1585102081299,
    "CMY_C": 0.15799307823181,
    "CMY_M": 0.56672066450119,
    "CMY_Y": 0.54489248991013,
    "CMYK_C": 0,
    "CMYK_M": 0.48542070388794,
    "CMYK_Y": 0.45949670672417,
    "CMYK_K": 0.15799307823181
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0070",
    "Farbtonhilfsbezeichnung": "18.2 Oleander 2",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "140",
    "Bcolor": "142",
    "Y": 39,
    "L": 68.1149749755859,
    "a": 35.6806831359863,
    "b": 13.6637763977051,
    "C": 38.2074584960938,
    "h": 20.9541435241699,
    "CMY_C": 0.08630871772766,
    "CMY_M": 0.4496356844902,
    "CMY_Y": 0.44334518909454,
    "CMYK_C": 0,
    "CMYK_M": 0.39764741063118,
    "CMYK_Y": 0.39076268672943,
    "CMYK_K": 0.08630871772766
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0071",
    "Farbtonhilfsbezeichnung": "18.3 Oleander 3",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "180",
    "Bcolor": "180",
    "Y": 56,
    "L": 79.5937652587891,
    "a": 25.0460739135742,
    "b": 9.1556978225708,
    "C": 26.6670703887939,
    "h": 20.080099105835,
    "CMY_C": 0.026870906353,
    "CMY_M": 0.29363042116165,
    "CMY_Y": 0.29450780153275,
    "CMYK_C": 0,
    "CMYK_M": 0.27412551641464,
    "CMYK_Y": 0.27502712607384,
    "CMYK_K": 0.026870906353
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0072",
    "Farbtonhilfsbezeichnung": "18.4 Oleander 4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "204",
    "Bcolor": "204",
    "Y": 69,
    "L": 85.9984741210938,
    "a": 16.4668273925781,
    "b": 5.180006980896,
    "C": 17.2623538970947,
    "h": 17.4621276855469,
    "CMY_C": 0.02013689279556,
    "CMY_M": 0.19897240400314,
    "CMY_Y": 0.19852519035339,
    "CMYK_C": 0,
    "CMYK_M": 0.18251070380211,
    "CMYK_Y": 0.18205431103706,
    "CMYK_K": 0.02013689279556
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0073",
    "Farbtonhilfsbezeichnung": "19.1 Gerbera 1",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "129",
    "Bcolor": "157",
    "Y": 34,
    "L": 64.3865051269531,
    "a": 38.5345153808594,
    "b": -0.60022628307343,
    "C": 38.5391883850098,
    "h": 359.107604980469,
    "CMY_C": 0.13974863290787,
    "CMY_M": 0.49383193254471,
    "CMY_Y": 0.38311928510666,
    "CMYK_C": 0,
    "CMYK_M": 0.41160446405411,
    "CMYK_Y": 0.28290644288063,
    "CMYK_K": 0.13974863290787
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0074",
    "Farbtonhilfsbezeichnung": "19.2 Gerbera 2",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "169",
    "Bcolor": "191",
    "Y": 50,
    "L": 75.665657043457,
    "a": 27.4449310302734,
    "b": -2.59027910232544,
    "C": 27.5668964385986,
    "h": 354.608337402344,
    "CMY_C": 0.08434021472931,
    "CMY_M": 0.33916854858398,
    "CMY_Y": 0.25235539674759,
    "CMYK_C": 0,
    "CMYK_M": 0.27830022573471,
    "CMYK_Y": 0.1834908425808,
    "CMYK_K": 0.08434021472931
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0075",
    "Farbtonhilfsbezeichnung": "19.3 Gerbera 3",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "186",
    "Bcolor": "204",
    "Y": 58,
    "L": 80.4222946166992,
    "a": 21.7620944976807,
    "b": -2.68568110466003,
    "C": 21.927188873291,
    "h": 352.964630126953,
    "CMY_C": 0.06845766305923,
    "CMY_M": 0.27175116539001,
    "CMY_Y": 0.20127332210541,
    "CMYK_C": 0,
    "CMYK_M": 0.21823324263096,
    "CMYK_Y": 0.14257608354092,
    "CMYK_K": 0.06845766305923
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0076",
    "Farbtonhilfsbezeichnung": "19.4 Gerbera 4",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "201",
    "Bcolor": "214",
    "Y": 66,
    "L": 84.5377044677734,
    "a": 16.2556552886963,
    "b": -2.06255483627319,
    "C": 16.3859844207764,
    "h": 352.768829345703,
    "CMY_C": 0.05839520692825,
    "CMY_M": 0.21220427751541,
    "CMY_Y": 0.16176247596741,
    "CMYK_C": 0,
    "CMYK_M": 0.16334779560566,
    "CMYK_Y": 0.10977776348591,
    "CMYK_K": 0.05839520692825
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0077",
    "Farbtonhilfsbezeichnung": "20.1 Anemone 1",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "141",
    "Bcolor": "162",
    "Y": 35,
    "L": 65.3980255126953,
    "a": 27.7157592773438,
    "b": -2.23156023025513,
    "C": 27.8054523468018,
    "h": 355.396697998047,
    "CMY_C": 0.19718396663666,
    "CMY_M": 0.44784051179886,
    "CMY_Y": 0.36311012506485,
    "CMYK_C": 0,
    "CMYK_M": 0.3122216463089,
    "CMYK_Y": 0.20668017864227,
    "CMYK_K": 0.19718396663666
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0078",
    "Farbtonhilfsbezeichnung": "20.2 Anemone 2",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "161",
    "Bcolor": "180",
    "Y": 44,
    "L": 71.9253540039063,
    "a": 23.3815689086914,
    "b": -2.64802098274231,
    "C": 23.5310382843018,
    "h": 353.538635253906,
    "CMY_C": 0.15310376882553,
    "CMY_M": 0.36690127849579,
    "CMY_Y": 0.29235994815826,
    "CMYK_C": 0,
    "CMYK_M": 0.25244829058647,
    "CMYK_Y": 0.16443121433258,
    "CMYK_K": 0.15310376882553
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0079",
    "Farbtonhilfsbezeichnung": "20.3 Anemone 3",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "197",
    "Bcolor": "209",
    "Y": 62,
    "L": 82.622932434082,
    "a": 14.4783344268799,
    "b": -2.48975896835327,
    "C": 14.6908502578735,
    "h": 350.242584228516,
    "CMY_C": 0.09386301040649,
    "CMY_M": 0.22818446159363,
    "CMY_Y": 0.1798112988472,
    "CMYK_C": 0,
    "CMYK_M": 0.14823526144028,
    "CMYK_Y": 0.0948513224721,
    "CMYK_K": 0.09386301040649
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0080",
    "Farbtonhilfsbezeichnung": "20.4 Anemone 4",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "221",
    "Bcolor": "226",
    "Y": 76,
    "L": 89.8739852905273,
    "a": 7.9893479347229,
    "b": -0.67930740118027,
    "C": 8.01817512512207,
    "h": 355.140014648438,
    "CMY_C": 0.05435329675674,
    "CMY_M": 0.13247907161713,
    "CMY_Y": 0.11440390348434,
    "CMYK_C": 0,
    "CMYK_M": 0.08261623978615,
    "CMYK_Y": 0.06350215524435,
    "CMYK_K": 0.05435329675674
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0081",
    "Farbtonhilfsbezeichnung": "21.1 Malve 1",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "133",
    "Bcolor": "166",
    "Y": 31,
    "L": 62.7751693725586,
    "a": 29.7462902069092,
    "b": -8.32233715057373,
    "C": 30.8885593414307,
    "h": 344.369598388672,
    "CMY_C": 0.22876453399658,
    "CMY_M": 0.4789844751358,
    "CMY_Y": 0.3485164642334,
    "CMYK_C": 0,
    "CMYK_M": 0.3244403898716,
    "CMYK_Y": 0.15527285635471,
    "CMYK_K": 0.22876453399658
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0082",
    "Farbtonhilfsbezeichnung": "21.2 Malve 2",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "172",
    "Bcolor": "197",
    "Y": 49,
    "L": 74.8457336425781,
    "a": 20.2113437652588,
    "b": -7.77192497253418,
    "C": 21.6541271209717,
    "h": 338.966613769531,
    "CMY_C": 0.15618520975113,
    "CMY_M": 0.32546019554138,
    "CMY_Y": 0.22550755739212,
    "CMYK_C": 0,
    "CMYK_M": 0.20060680806637,
    "CMYK_Y": 0.0821535140276,
    "CMYK_K": 0.15618520975113
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0083",
    "Farbtonhilfsbezeichnung": "21.3 Malve 3",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "204",
    "Bcolor": "219",
    "Y": 66,
    "L": 84.5988845825195,
    "a": 11.5747623443604,
    "b": -5.04285287857056,
    "C": 12.6255884170532,
    "h": 336.458374023438,
    "CMY_C": 0.10078686475754,
    "CMY_M": 0.19831603765488,
    "CMY_Y": 0.14008396863937,
    "CMYK_C": 0,
    "CMYK_M": 0.10846057534218,
    "CMYK_Y": 0.04370165616274,
    "CMYK_K": 0.10078686475754
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0084",
    "Farbtonhilfsbezeichnung": "21.4 Malve 4",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "224",
    "Bcolor": "228",
    "Y": 78,
    "L": 90.4827270507812,
    "a": 5.70720434188843,
    "b": -1.12931823730469,
    "C": 5.81786394119263,
    "h": 348.80712890625,
    "CMY_C": 0.06629741191864,
    "CMY_M": 0.11988824605942,
    "CMY_Y": 0.104671895504,
    "CMYK_C": 0,
    "CMYK_M": 0.05739604309201,
    "CMYK_Y": 0.0410992577672,
    "CMYK_K": 0.06629741191864
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0085",
    "Farbtonhilfsbezeichnung": "22.1 Rose 1",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "122",
    "Bcolor": "128",
    "Y": 24,
    "L": 55.4271011352539,
    "a": 17.3367691040039,
    "b": 2.66236400604248,
    "C": 17.5400047302246,
    "h": 8.73056411743164,
    "CMY_C": 0.35817211866379,
    "CMY_M": 0.52125519514084,
    "CMY_Y": 0.49908024072647,
    "CMYK_C": 0,
    "CMYK_M": 0.25409159064293,
    "CMYK_Y": 0.21954192221165,
    "CMYK_K": 0.35817211866379
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0086",
    "Farbtonhilfsbezeichnung": "22.2 Rose 2",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "148",
    "Bcolor": "153",
    "Y": 34,
    "L": 65.0494155883789,
    "a": 16.1089115142822,
    "b": 2.53062558174133,
    "C": 16.3064746856689,
    "h": 8.92790031433105,
    "CMY_C": 0.26288765668869,
    "CMY_M": 0.42018461227417,
    "CMY_Y": 0.40109485387802,
    "CMYK_C": 0,
    "CMYK_M": 0.21339617669582,
    "CMYK_Y": 0.18749815225601,
    "CMYK_K": 0.26288765668869
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0087",
    "Farbtonhilfsbezeichnung": "22.3 Rose 3",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "178",
    "Bcolor": "182",
    "Y": 49,
    "L": 75.6005554199219,
    "a": 13.5756940841675,
    "b": 1.54268383979797,
    "C": 13.663064956665,
    "h": 6.48303747177124,
    "CMY_C": 0.16679716110229,
    "CMY_M": 0.30257767438889,
    "CMY_Y": 0.28434419631958,
    "CMYK_C": 0,
    "CMYK_M": 0.1629621386528,
    "CMYK_Y": 0.1410785317421,
    "CMYK_K": 0.16679716110229
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0088",
    "Farbtonhilfsbezeichnung": "22.4 Rose 4",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "190",
    "Bcolor": "190",
    "Y": 56,
    "L": 79.2527236938477,
    "a": 9.47106266021729,
    "b": 2.90155506134033,
    "C": 9.90555667877197,
    "h": 17.0329704284668,
    "CMY_C": 0.15129673480988,
    "CMY_M": 0.25334590673447,
    "CMY_Y": 0.25572687387466,
    "CMYK_C": 0,
    "CMYK_M": 0.12024128437042,
    "CMYK_Y": 0.12304670363665,
    "CMYK_K": 0.15129673480988
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0089",
    "Farbtonhilfsbezeichnung": "23.1 Rosenholz 1",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "139",
    "Bcolor": "141",
    "Y": 28,
    "L": 59.7324676513672,
    "a": 7.63583278656006,
    "b": 0.95514053106308,
    "C": 7.6953387260437,
    "h": 7.12990283966064,
    "CMY_C": 0.37950551509857,
    "CMY_M": 0.4530320763588,
    "CMY_Y": 0.445756316185,
    "CMYK_C": 0,
    "CMYK_M": 0.11849672347307,
    "CMYK_Y": 0.10677097737789,
    "CMYK_K": 0.37950551509857
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0090",
    "Farbtonhilfsbezeichnung": "23.2 Rosenholz 2",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "164",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.5446319580078,
    "a": 9.04927825927734,
    "b": 2.10653257369995,
    "C": 9.29122829437256,
    "h": 13.1042022705078,
    "CMY_C": 0.26255357265472,
    "CMY_M": 0.35533529520035,
    "CMY_Y": 0.35265696048737,
    "CMYK_C": 0,
    "CMYK_M": 0.12581486999989,
    "CMYK_Y": 0.12218295782804,
    "CMYK_K": 0.26255357265472
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0091",
    "Farbtonhilfsbezeichnung": "23.3 Rosenholz 3",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "184",
    "Bcolor": "186",
    "Y": 50,
    "L": 76.2202301025391,
    "a": 6.92133331298828,
    "b": 0.47055062651634,
    "C": 6.93731021881104,
    "h": 3.88930010795593,
    "CMY_C": 0.21000242233276,
    "CMY_M": 0.27892392873764,
    "CMY_Y": 0.2710719704628,
    "CMYK_C": 0,
    "CMYK_M": 0.08724267780781,
    "CMYK_Y": 0.07730346173048,
    "CMYK_K": 0.21000242233276
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0092",
    "Farbtonhilfsbezeichnung": "23.4 Rosenholz 4",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "204",
    "Bcolor": "203",
    "Y": 63,
    "L": 83.4116744995117,
    "a": 6.52988052368164,
    "b": 2.12452483177185,
    "C": 6.86680030822754,
    "h": 18.0225219726563,
    "CMY_C": 0.12876236438751,
    "CMY_M": 0.20071029663086,
    "CMY_Y": 0.20579624176025,
    "CMYK_C": 0,
    "CMYK_M": 0.08258129656315,
    "CMYK_Y": 0.08841890096664,
    "CMYK_K": 0.12876236438751
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0093",
    "Farbtonhilfsbezeichnung": "24.1 Ramie 1",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "120",
    "Bcolor": "120",
    "Y": 22,
    "L": 53.9984321594238,
    "a": 14.0982627868652,
    "b": 5.26815891265869,
    "C": 15.0503988265991,
    "h": 20.4894256591797,
    "CMY_C": 0.38724130392075,
    "CMY_M": 0.52775812149048,
    "CMY_Y": 0.5309898853302,
    "CMYK_C": 0,
    "CMYK_M": 0.22931835055351,
    "CMYK_Y": 0.23459248244762,
    "CMYK_K": 0.38724130392075
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0094",
    "Farbtonhilfsbezeichnung": "24.2 Ramie 2",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "147",
    "Bcolor": "146",
    "Y": 33,
    "L": 63.3577308654785,
    "a": 9.77743434906006,
    "b": 3.99477291107178,
    "C": 10.5620279312134,
    "h": 22.2234859466553,
    "CMY_C": 0.31884807348251,
    "CMY_M": 0.42191469669342,
    "CMY_Y": 0.42936182022095,
    "CMYK_C": 0,
    "CMYK_M": 0.15131223201752,
    "CMYK_Y": 0.16224537789822,
    "CMYK_K": 0.31884807348251
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0095",
    "Farbtonhilfsbezeichnung": "24.3 Ramie 3",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "178",
    "Bcolor": "176",
    "Y": 47,
    "L": 74.2105865478516,
    "a": 6.71823692321777,
    "b": 2.8823823928833,
    "C": 7.31046056747437,
    "h": 23.2211971282959,
    "CMY_C": 0.22619992494583,
    "CMY_M": 0.30055218935013,
    "CMY_Y": 0.30953103303909,
    "CMYK_C": 0,
    "CMYK_M": 0.09608718007803,
    "CMYK_Y": 0.107690744102,
    "CMYK_K": 0.22619992494583
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0096",
    "Farbtonhilfsbezeichnung": "24.4 Ramie 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 66,
    "L": 85.1521759033203,
    "a": 3.40880465507507,
    "b": 2.01101684570313,
    "C": 3.95779466629028,
    "h": 30.538387298584,
    "CMY_C": 0.13309806585312,
    "CMY_M": 0.17403131723404,
    "CMY_Y": 0.18653237819672,
    "CMYK_C": 0,
    "CMYK_M": 0.04721785709262,
    "CMYK_Y": 0.06163824349642,
    "CMYK_K": 0.13309806585312
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0097",
    "Farbtonhilfsbezeichnung": "25.1 Brokat 1",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "122",
    "Bcolor": "118",
    "Y": 23,
    "L": 54.4296607971191,
    "a": 12.7347030639648,
    "b": 6.95137786865234,
    "C": 14.5084218978882,
    "h": 28.6284046173096,
    "CMY_C": 0.3873598575592,
    "CMY_M": 0.52043867111206,
    "CMY_Y": 0.53814458847046,
    "CMYK_C": 0,
    "CMYK_M": 0.21722182631493,
    "CMYK_Y": 0.24612283706665,
    "CMYK_K": 0.3873598575592
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0098",
    "Farbtonhilfsbezeichnung": "25.2 Brokat 2",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "149",
    "Bcolor": "145",
    "Y": 33,
    "L": 64.0552444458008,
    "a": 9.50957870483398,
    "b": 5.24463415145874,
    "C": 10.859938621521,
    "h": 28.8772029876709,
    "CMY_C": 0.30999708175659,
    "CMY_M": 0.41440236568451,
    "CMY_Y": 0.43087995052338,
    "CMYK_C": 0,
    "CMYK_M": 0.15131136775017,
    "CMYK_Y": 0.17519181966782,
    "CMYK_K": 0.30999708175659
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0099",
    "Farbtonhilfsbezeichnung": "25.3 Brokat 3",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "179",
    "Bcolor": "175",
    "Y": 48,
    "L": 74.6577453613281,
    "a": 6.77390289306641,
    "b": 4.21849346160889,
    "C": 7.98006582260132,
    "h": 31.91286277771,
    "CMY_C": 0.21713507175446,
    "CMY_M": 0.2962880730629,
    "CMY_Y": 0.31428378820419,
    "CMYK_C": 0,
    "CMYK_M": 0.10110684484243,
    "CMYK_Y": 0.12409383803606,
    "CMYK_K": 0.21713507175446
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0100",
    "Farbtonhilfsbezeichnung": "25.4 Brokat 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "209",
    "Bcolor": "205",
    "Y": 66,
    "L": 84.535530090332,
    "a": 3.84589242935181,
    "b": 2.58536601066589,
    "C": 4.63411331176758,
    "h": 33.9106063842773,
    "CMY_C": 0.13483208417892,
    "CMY_M": 0.18200677633286,
    "CMY_Y": 0.19735372066498,
    "CMYK_C": 0,
    "CMYK_M": 0.05452663078904,
    "CMYK_Y": 0.0722653195262,
    "CMYK_K": 0.13483208417892
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0101",
    "Farbtonhilfsbezeichnung": "26.1 Satin 1",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "162",
    "Bcolor": "157",
    "Y": 38,
    "L": 67.9178695678711,
    "a": 5.78451538085938,
    "b": 4.36536407470703,
    "C": 7.24686288833618,
    "h": 37.0405311584473,
    "CMY_C": 0.29636204242706,
    "CMY_M": 0.36509346961975,
    "CMY_Y": 0.3857409954071,
    "CMYK_C": 0,
    "CMYK_M": 0.09768009930849,
    "CMYK_Y": 0.12702406942844,
    "CMYK_K": 0.29636204242706
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0102",
    "Farbtonhilfsbezeichnung": "26.2 Satin 2",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "184",
    "Bcolor": "180",
    "Y": 50,
    "L": 76.0556793212891,
    "a": 5.89588212966919,
    "b": 3.19539022445679,
    "C": 6.70611238479614,
    "h": 28.456356048584,
    "CMY_C": 0.21109563112259,
    "CMY_M": 0.27895539999008,
    "CMY_Y": 0.29236948490143,
    "CMYK_C": 0,
    "CMYK_M": 0.08601773530245,
    "CMYK_Y": 0.10302117466927,
    "CMYK_K": 0.21109563112259
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0103",
    "Farbtonhilfsbezeichnung": "26.3 Satin 3",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "204",
    "Bcolor": "200",
    "Y": 64,
    "L": 83.4359359741211,
    "a": 5.71350526809692,
    "b": 3.74916577339172,
    "C": 6.83376789093018,
    "h": 33.272632598877,
    "CMY_C": 0.12961268424988,
    "CMY_M": 0.19889402389526,
    "CMY_Y": 0.21744817495346,
    "CMYK_C": 0,
    "CMYK_M": 0.07959828525782,
    "CMYK_Y": 0.10091540962458,
    "CMYK_K": 0.12961268424988
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0104",
    "Farbtonhilfsbezeichnung": "26.4 Satin 4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "218",
    "Bcolor": "213",
    "Y": 72,
    "L": 88.0454711914063,
    "a": 5.19061326980591,
    "b": 3.63869547843933,
    "C": 6.33897256851196,
    "h": 35.0310173034668,
    "CMY_C": 0.08241599798203,
    "CMY_M": 0.14697760343552,
    "CMY_Y": 0.16666448116302,
    "CMYK_C": 0,
    "CMYK_M": 0.07036042958498,
    "CMYK_Y": 0.09181555360556,
    "CMYK_K": 0.08241599798203
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0105",
    "Farbtonhilfsbezeichnung": "27.1 Batist 1",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "166",
    "Bcolor": "161",
    "Y": 41,
    "L": 69.8719100952148,
    "a": 7.71105575561523,
    "b": 4.94671535491943,
    "C": 9.16135215759277,
    "h": 32.6805572509766,
    "CMY_C": 0.2604832649231,
    "CMY_M": 0.34939563274384,
    "CMY_Y": 0.36930471658707,
    "CMYK_C": 0,
    "CMYK_M": 0.12023036926985,
    "CMYK_Y": 0.14715211093426,
    "CMYK_K": 0.2604832649231
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0106",
    "Farbtonhilfsbezeichnung": "27.2 Batist 2",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "182",
    "Bcolor": "177",
    "Y": 49,
    "L": 75.2496109008789,
    "a": 5.8939528465271,
    "b": 3.79980492591858,
    "C": 7.01264572143555,
    "h": 32.8096961975098,
    "CMY_C": 0.21813774108887,
    "CMY_M": 0.28773158788681,
    "CMY_Y": 0.30519551038742,
    "CMYK_C": 0,
    "CMYK_M": 0.08901036530733,
    "CMYK_Y": 0.11134668439627,
    "CMYK_K": 0.21813774108887
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0107",
    "Farbtonhilfsbezeichnung": "27.3 Batist 3",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "211",
    "Bcolor": "206",
    "Y": 68,
    "L": 85.5130996704102,
    "a": 4.86423063278198,
    "b": 3.49491691589355,
    "C": 5.98958969116211,
    "h": 35.6969909667969,
    "CMY_C": 0.11357015371323,
    "CMY_M": 0.17401432991028,
    "CMY_Y": 0.19323396682739,
    "CMYK_C": 0,
    "CMYK_M": 0.06818833947182,
    "CMYK_Y": 0.08987040817738,
    "CMYK_K": 0.11357015371323
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0108",
    "Farbtonhilfsbezeichnung": "27.4 Batist 4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "226",
    "Bcolor": "221",
    "Y": 77,
    "L": 90.3857650756836,
    "a": 2.33883595466614,
    "b": 2.64203786849976,
    "C": 3.52852916717529,
    "h": 48.4834785461426,
    "CMY_C": 0.08096879720688,
    "CMY_M": 0.11381512880325,
    "CMY_Y": 0.13407850265503,
    "CMYK_C": 0,
    "CMYK_M": 0.03574017062783,
    "CMYK_Y": 0.0577887929976,
    "CMYK_K": 0.08096879720688
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0109",
    "Farbtonhilfsbezeichnung": "28.1 Organza 1",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "161",
    "Bcolor": "153",
    "Y": 38,
    "L": 67.6919479370117,
    "a": 6.45202159881592,
    "b": 5.86481380462646,
    "C": 8.71920967102051,
    "h": 42.2704772949219,
    "CMY_C": 0.290118932724,
    "CMY_M": 0.36943221092224,
    "CMY_Y": 0.39840936660767,
    "CMYK_C": 0,
    "CMYK_M": 0.11172755807638,
    "CMYK_Y": 0.15254728496075,
    "CMYK_K": 0.290118932724
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0110",
    "Farbtonhilfsbezeichnung": "28.2 Organza 2",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "172",
    "Bcolor": "166",
    "Y": 45,
    "L": 72.0270919799805,
    "a": 7.26792526245117,
    "b": 5.09825325012207,
    "C": 8.87777709960938,
    "h": 35.0486221313477,
    "CMY_C": 0.23982411623001,
    "CMY_M": 0.32564580440521,
    "CMY_Y": 0.34801185131073,
    "CMYK_C": 0,
    "CMYK_M": 0.11289715021849,
    "CMYK_Y": 0.14231935143471,
    "CMYK_K": 0.23982411623001
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0111",
    "Farbtonhilfsbezeichnung": "28.3 Organza 3",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "200",
    "Bcolor": "194",
    "Y": 61,
    "L": 81.7502059936523,
    "a": 4.35878467559814,
    "b": 4.02803230285645,
    "C": 5.93498516082764,
    "h": 42.741584777832,
    "CMY_C": 0.1573925614357,
    "CMY_M": 0.21404021978378,
    "CMY_Y": 0.23781782388687,
    "CMYK_C": 0,
    "CMYK_M": 0.06722900271416,
    "CMYK_Y": 0.09544807672501,
    "CMYK_K": 0.1573925614357
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0112",
    "Farbtonhilfsbezeichnung": "28.4 Organza 4",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "215",
    "Bcolor": "207",
    "Y": 70,
    "L": 86.6330413818359,
    "a": 3.00952053070068,
    "b": 4.47605800628662,
    "C": 5.39372873306274,
    "h": 56.0847091674805,
    "CMY_C": 0.11198335886002,
    "CMY_M": 0.15747255086899,
    "CMY_Y": 0.18851464986801,
    "CMYK_C": 0,
    "CMYK_M": 0.05122560635209,
    "CMYK_Y": 0.08618227392435,
    "CMYK_K": 0.11198335886002
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0113",
    "Farbtonhilfsbezeichnung": "29.1 Espresso 1",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "73",
    "Bcolor": "66",
    "Y": 7,
    "L": 32.5035247802734,
    "a": 5.76921606063843,
    "b": 6.54116439819336,
    "C": 8.72185134887695,
    "h": 48.5881576538086,
    "CMY_C": 0.64961171150208,
    "CMY_M": 0.71333330869675,
    "CMY_Y": 0.74180853366852,
    "CMYK_C": 0,
    "CMYK_M": 0.18185995519161,
    "CMYK_Y": 0.26312756538391,
    "CMYK_K": 0.64961171150208
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0114",
    "Farbtonhilfsbezeichnung": "29.2 Espresso 2",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "91",
    "Bcolor": "79",
    "Y": 12,
    "L": 40.4786605834961,
    "a": 7.32993316650391,
    "b": 10.0648794174194,
    "C": 12.4510927200317,
    "h": 53.9353332519531,
    "CMY_C": 0.55616271495819,
    "CMY_M": 0.64363431930542,
    "CMY_Y": 0.69156461954117,
    "CMYK_C": 0,
    "CMYK_M": 0.19708034396172,
    "CMYK_Y": 0.30507105588913,
    "CMYK_K": 0.55616271495819
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0115",
    "Farbtonhilfsbezeichnung": "29.3 Espresso 3",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "126",
    "Bcolor": "113",
    "Y": 22,
    "L": 54.3025512695313,
    "a": 6.20709943771362,
    "b": 9.56052303314209,
    "C": 11.3987579345703,
    "h": 57.006649017334,
    "CMY_C": 0.4237088561058,
    "CMY_M": 0.50658476352692,
    "CMY_Y": 0.5577734708786,
    "CMYK_C": 0,
    "CMYK_M": 0.14380909502506,
    "CMYK_Y": 0.23263348639011,
    "CMYK_K": 0.4237088561058
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0116",
    "Farbtonhilfsbezeichnung": "29.4 Espresso 4",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "147",
    "Bcolor": "132",
    "Y": 31,
    "L": 62.3621406555176,
    "a": 6.1909646987915,
    "b": 10.1465177536011,
    "C": 11.8861207962036,
    "h": 58.6102714538574,
    "CMY_C": 0.33795118331909,
    "CMY_M": 0.42505568265915,
    "CMY_Y": 0.48213922977448,
    "CMYK_C": 0,
    "CMYK_M": 0.13156808912754,
    "CMYK_Y": 0.21779066324234,
    "CMYK_K": 0.33795118331909
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0117",
    "Farbtonhilfsbezeichnung": "30.1 Mocca 1",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "83",
    "Bcolor": "73",
    "Y": 9,
    "L": 37.0752067565918,
    "a": 6.52854013442993,
    "b": 8.62424945831299,
    "C": 10.8166313171387,
    "h": 52.8743476867676,
    "CMY_C": 0.59711980819702,
    "CMY_M": 0.67340642213821,
    "CMY_Y": 0.71358454227448,
    "CMYK_C": 0,
    "CMYK_M": 0.18935310840607,
    "CMYK_Y": 0.28908032178879,
    "CMYK_K": 0.59711980819702
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0118",
    "Farbtonhilfsbezeichnung": "30.2 Mocca 2",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "112",
    "Bcolor": "102",
    "Y": 17,
    "L": 48.8327026367188,
    "a": 5.73648405075073,
    "b": 7.78200531005859,
    "C": 9.66782569885254,
    "h": 53.6043167114258,
    "CMY_C": 0.48673629760742,
    "CMY_M": 0.55918562412262,
    "CMY_Y": 0.5988786816597,
    "CMYK_C": 0,
    "CMYK_M": 0.14115419983864,
    "CMYK_Y": 0.21848882734776,
    "CMYK_K": 0.48673629760742
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0119",
    "Farbtonhilfsbezeichnung": "30.3 Mocca 3",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "135",
    "Bcolor": "125",
    "Y": 26,
    "L": 57.4392280578613,
    "a": 4.88948011398315,
    "b": 6.74314880371094,
    "C": 8.32929039001465,
    "h": 54.0540046691895,
    "CMY_C": 0.4064633846283,
    "CMY_M": 0.47136801481247,
    "CMY_Y": 0.50823640823364,
    "CMYK_C": 0,
    "CMYK_M": 0.10935235768557,
    "CMYK_Y": 0.17146882414818,
    "CMYK_K": 0.4064633846283
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0120",
    "Farbtonhilfsbezeichnung": "30.4 Mocca 4",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "157",
    "Bcolor": "148",
    "Y": 36,
    "L": 65.9490051269531,
    "a": 4.58320999145508,
    "b": 6.30805444717407,
    "C": 7.79726648330688,
    "h": 53.9991683959961,
    "CMY_C": 0.32036602497101,
    "CMY_M": 0.38329017162323,
    "CMY_Y": 0.41962438821793,
    "CMYK_C": 0,
    "CMYK_M": 0.09258534759283,
    "CMYK_Y": 0.14604678750038,
    "CMYK_K": 0.32036602497101
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0121",
    "Farbtonhilfsbezeichnung": "31.1 Cafe 1",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "87",
    "Bcolor": "78",
    "Y": 11,
    "L": 39.167064666748,
    "a": 7.96102142333984,
    "b": 8.6127758026123,
    "C": 11.7285022735596,
    "h": 47.2519607543945,
    "CMY_C": 0.56831669807434,
    "CMY_M": 0.65710884332657,
    "CMY_Y": 0.69429457187653,
    "CMYK_C": 0,
    "CMYK_M": 0.20568816363811,
    "CMYK_Y": 0.2918293774128,
    "CMYK_K": 0.56831669807434
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0122",
    "Farbtonhilfsbezeichnung": "31.2 Cafe 2",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "96",
    "Bcolor": "82",
    "Y": 14,
    "L": 43.8607864379883,
    "a": 11.7396039962769,
    "b": 12.7756261825562,
    "C": 17.3503589630127,
    "h": 47.4198989868164,
    "CMY_C": 0.49169504642487,
    "CMY_M": 0.62252330780029,
    "CMY_Y": 0.67706680297852,
    "CMYK_C": 0,
    "CMYK_M": 0.25738143920898,
    "CMYK_Y": 0.36468610167503,
    "CMYK_K": 0.49169504642487
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0123",
    "Farbtonhilfsbezeichnung": "31.3 Cafe 3",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "116",
    "Bcolor": "103",
    "Y": 20,
    "L": 51.6395988464355,
    "a": 10.6146049499512,
    "b": 11.6225261688232,
    "C": 15.7401704788208,
    "h": 47.59521484375,
    "CMY_C": 0.41978174448013,
    "CMY_M": 0.54395806789398,
    "CMY_Y": 0.59651696681976,
    "CMYK_C": 0,
    "CMYK_M": 0.21401657164097,
    "CMYK_Y": 0.30460128188133,
    "CMYK_K": 0.41978174448013
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0124",
    "Farbtonhilfsbezeichnung": "31.4 Cafe 4",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "138",
    "Bcolor": "124",
    "Y": 28,
    "L": 59.921012878418,
    "a": 9.77446746826172,
    "b": 11.1077566146851,
    "C": 14.7960290908813,
    "h": 48.653263092041,
    "CMY_C": 0.33860057592392,
    "CMY_M": 0.45882880687714,
    "CMY_Y": 0.51246213912964,
    "CMYK_C": 0,
    "CMYK_M": 0.18177855014801,
    "CMYK_Y": 0.26286923885345,
    "CMYK_K": 0.33860057592392
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0125",
    "Farbtonhilfsbezeichnung": "32.1 Tartufo 1",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "89",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.6238403320313,
    "a": 14.9039840698242,
    "b": 15.7581396102905,
    "C": 21.6898059844971,
    "h": 46.5956764221191,
    "CMY_C": 0.49246668815613,
    "CMY_M": 0.65237325429916,
    "CMY_Y": 0.71609795093536,
    "CMYK_C": 0,
    "CMYK_M": 0.31506615877151,
    "CMYK_Y": 0.44062381982803,
    "CMYK_K": 0.49246668815613
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0126",
    "Farbtonhilfsbezeichnung": "32.2 Tartufo 2",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "89",
    "Bcolor": "65",
    "Y": 14,
    "L": 43.6151390075684,
    "a": 20.7494163513184,
    "b": 23.4110870361328,
    "C": 31.2828598022461,
    "h": 48.4491958618164,
    "CMY_C": 0.43027114868164,
    "CMY_M": 0.65081524848938,
    "CMY_Y": 0.74657994508743,
    "CMYK_C": 0,
    "CMYK_M": 0.38710361719131,
    "CMYK_Y": 0.55519181489944,
    "CMYK_K": 0.43027114868164
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0127",
    "Farbtonhilfsbezeichnung": "32.3 Tartufo 3",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "123",
    "Bcolor": "100",
    "Y": 24,
    "L": 56.0687980651855,
    "a": 16.5307521820068,
    "b": 19.779504776001,
    "C": 25.7777919769287,
    "h": 50.1127548217773,
    "CMY_C": 0.32302379608154,
    "CMY_M": 0.51680445671082,
    "CMY_Y": 0.60766810178757,
    "CMYK_C": 0,
    "CMYK_M": 0.28624442219734,
    "CMYK_Y": 0.42046427726746,
    "CMYK_K": 0.32302379608154
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0128",
    "Farbtonhilfsbezeichnung": "32.4 Tartufo 4",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "165",
    "Bcolor": "145",
    "Y": 42,
    "L": 70.6085052490234,
    "a": 11.9767665863037,
    "b": 14.7564420700073,
    "C": 19.0051441192627,
    "h": 50.9361915588379,
    "CMY_C": 0.20044320821762,
    "CMY_M": 0.35473817586899,
    "CMY_Y": 0.42990952730179,
    "CMYK_C": 0,
    "CMYK_M": 0.19297562539577,
    "CMYK_Y": 0.28699189424515,
    "CMYK_K": 0.20044320821762
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0129",
    "Farbtonhilfsbezeichnung": "33.1 Praline 1",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "88",
    "Bcolor": "70",
    "Y": 13,
    "L": 42.5267677307129,
    "a": 19.509126663208,
    "b": 18.5809154510498,
    "C": 26.9417228698731,
    "h": 43.6040420532227,
    "CMY_C": 0.45442110300064,
    "CMY_M": 0.65676760673523,
    "CMY_Y": 0.72516649961472,
    "CMYK_C": 0,
    "CMYK_M": 0.37088403105736,
    "CMYK_Y": 0.49625343084335,
    "CMYK_K": 0.45442110300064
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0130",
    "Farbtonhilfsbezeichnung": "33.2 Praline 2",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "93",
    "Bcolor": "76",
    "Y": 14,
    "L": 43.8723258972168,
    "a": 16.707275390625,
    "b": 16.5614967346191,
    "C": 23.5247993469238,
    "h": 44.7489395141602,
    "CMY_C": 0.45795726776123,
    "CMY_M": 0.63590162992477,
    "CMY_Y": 0.70047169923782,
    "CMYK_C": 0,
    "CMYK_M": 0.328284740448,
    "CMYK_Y": 0.44740831851959,
    "CMYK_K": 0.45795726776123
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0131",
    "Farbtonhilfsbezeichnung": "33.3 Praline 3",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "114",
    "Bcolor": "98",
    "Y": 20,
    "L": 52.0440444946289,
    "a": 16.1700496673584,
    "b": 15.1599550247192,
    "C": 22.165168762207,
    "h": 43.1533966064453,
    "CMY_C": 0.37631589174271,
    "CMY_M": 0.55484974384308,
    "CMY_Y": 0.61514914035797,
    "CMYK_C": 0,
    "CMYK_M": 0.28625684976578,
    "CMYK_Y": 0.38293945789337,
    "CMYK_K": 0.37631589174271
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0132",
    "Farbtonhilfsbezeichnung": "33.4 Praline 4",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "137",
    "Bcolor": "120",
    "Y": 29,
    "L": 60.6646385192871,
    "a": 13.4199304580688,
    "b": 14.9827013015747,
    "C": 20.114070892334,
    "h": 48.1493530273438,
    "CMY_C": 0.29996317625046,
    "CMY_M": 0.46128875017166,
    "CMY_Y": 0.53094124794006,
    "CMYK_C": 0,
    "CMYK_M": 0.23045298457146,
    "CMYK_Y": 0.32995131611824,
    "CMYK_K": 0.29996317625046
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0133",
    "Farbtonhilfsbezeichnung": "34.1 Cappuccino 1",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "88",
    "Bcolor": "81",
    "Y": 11,
    "L": 38.8917961120605,
    "a": 6.78267478942871,
    "b": 6.02409553527832,
    "C": 9.07162666320801,
    "h": 41.610179901123,
    "CMY_C": 0.58320295810699,
    "CMY_M": 0.65644860267639,
    "CMY_Y": 0.6807450056076,
    "CMYK_C": 0,
    "CMYK_M": 0.17573456466198,
    "CMYK_Y": 0.23402768373489,
    "CMYK_K": 0.58320295810699
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0134",
    "Farbtonhilfsbezeichnung": "34.2 Cappuccino 2",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "107",
    "Bcolor": "99",
    "Y": 16,
    "L": 46.9432678222656,
    "a": 6.6400294303894,
    "b": 6.78096389770508,
    "C": 9.49059867858887,
    "h": 45.6016426086426,
    "CMY_C": 0.50246047973633,
    "CMY_M": 0.57943224906921,
    "CMY_Y": 0.61025428771973,
    "CMYK_C": 0,
    "CMYK_M": 0.15470483899117,
    "CMYK_Y": 0.21665376424789,
    "CMYK_K": 0.50246047973633
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0135",
    "Farbtonhilfsbezeichnung": "34.3 Cappuccino 3",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "120",
    "Bcolor": "111",
    "Y": 21,
    "L": 52.2988586425781,
    "a": 7.79861783981323,
    "b": 7.82510566711426,
    "C": 11.0476570129395,
    "h": 45.0971374511719,
    "CMY_C": 0.43827658891678,
    "CMY_M": 0.529825091362,
    "CMY_Y": 0.56546413898468,
    "CMYK_C": 0,
    "CMYK_M": 0.16297790408134,
    "CMYK_Y": 0.22642379999161,
    "CMYK_K": 0.43827658891678
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0136",
    "Farbtonhilfsbezeichnung": "34.4 Cappuccino 4",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "140",
    "Bcolor": "129",
    "Y": 29,
    "L": 60.1939353942871,
    "a": 7.55259847640991,
    "b": 8.60523223876953,
    "C": 11.4495315551758,
    "h": 48.7273788452148,
    "CMY_C": 0.35563617944717,
    "CMY_M": 0.45009052753448,
    "CMY_Y": 0.49306321144104,
    "CMYK_C": 0,
    "CMYK_M": 0.14658543467522,
    "CMYK_Y": 0.21327552199364,
    "CMYK_K": 0.35563617944717
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0137",
    "Farbtonhilfsbezeichnung": "35.1 Nougat 1",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "76",
    "Bcolor": "69",
    "Y": 9,
    "L": 35.3103370666504,
    "a": 11.2214879989624,
    "b": 8.81149768829346,
    "C": 14.2675952911377,
    "h": 38.1402206420898,
    "CMY_C": 0.58772957324982,
    "CMY_M": 0.70063203573227,
    "CMY_Y": 0.72989386320114,
    "CMYK_C": 0,
    "CMYK_M": 0.2738553583622,
    "CMYK_Y": 0.34483262896538,
    "CMYK_K": 0.58772957324982
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0138",
    "Farbtonhilfsbezeichnung": "35.2 Nougat 2",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "95",
    "Bcolor": "84",
    "Y": 13,
    "L": 43.3793334960938,
    "a": 12.6333427429199,
    "b": 11.1539697647095,
    "C": 16.8526668548584,
    "h": 41.4412612915039,
    "CMY_C": 0.49441963434219,
    "CMY_M": 0.6289843916893,
    "CMY_Y": 0.67095649242401,
    "CMYK_C": 0,
    "CMYK_M": 0.26615899801254,
    "CMYK_Y": 0.34917664527893,
    "CMYK_K": 0.49441963434219
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0139",
    "Farbtonhilfsbezeichnung": "35.3 Nougat 3",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "110",
    "Bcolor": "98",
    "Y": 19,
    "L": 50.0394630432129,
    "a": 13.7566661834717,
    "b": 12.3879117965698,
    "C": 18.5123271942139,
    "h": 42.003116607666,
    "CMY_C": 0.41649436950684,
    "CMY_M": 0.56768822669983,
    "CMY_Y": 0.61631518602371,
    "CMYK_C": 0,
    "CMYK_M": 0.25911292433739,
    "CMYK_Y": 0.34244883060455,
    "CMYK_K": 0.41649436950684
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0140",
    "Farbtonhilfsbezeichnung": "35.4 Nougat 4",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "125",
    "Bcolor": "111",
    "Y": 24,
    "L": 55.9016990661621,
    "a": 13.67897605896,
    "b": 12.9339904785156,
    "C": 18.8255805969238,
    "h": 43.3965187072754,
    "CMY_C": 0.35369938611984,
    "CMY_M": 0.5095546245575,
    "CMY_Y": 0.56361365318298,
    "CMYK_C": 0,
    "CMYK_M": 0.2411497682333,
    "CMYK_Y": 0.32479354739189,
    "CMYK_K": 0.35369938611984
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0141",
    "Farbtonhilfsbezeichnung": "36.1 Orange 1",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "88",
    "Bcolor": "61",
    "Y": 19,
    "L": 49.8064041137695,
    "a": 39.1484565734863,
    "b": 34.4673538208008,
    "C": 52.1593742370605,
    "h": 41.3615608215332,
    "CMY_C": 0.25606954097748,
    "CMY_M": 0.6541491150856,
    "CMY_Y": 0.76031160354614,
    "CMYK_C": 0,
    "CMYK_M": 0.53510320186615,
    "CMYK_Y": 0.67780804634094,
    "CMYK_K": 0.25606954097748
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0142",
    "Farbtonhilfsbezeichnung": "36.2 Orange 2",
    "Farbtonklasse": "04",
    "Rcolor": "222",
    "Gcolor": "100",
    "Bcolor": "56",
    "Y": 25,
    "L": 57.0476150512695,
    "a": 45.3445281982422,
    "b": 46.5225830078125,
    "C": 64.9651947021484,
    "h": 45.734691619873,
    "CMY_C": 0.12892729043961,
    "CMY_M": 0.60739624500275,
    "CMY_Y": 0.77957552671432,
    "CMYK_C": 0,
    "CMYK_M": 0.54928702116013,
    "CMYK_Y": 0.74695056676865,
    "CMYK_K": 0.12892729043961
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0143",
    "Farbtonhilfsbezeichnung": "36.3 Orange 3",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "120",
    "Bcolor": "59",
    "Y": 31,
    "L": 62.1950378417969,
    "a": 38.9586029052734,
    "b": 50.9640007019043,
    "C": 64.1490631103516,
    "h": 52.6044807434082,
    "CMY_C": 0.09549629688263,
    "CMY_M": 0.53014802932739,
    "CMY_Y": 0.7690834403038,
    "CMYK_C": 0,
    "CMYK_M": 0.48054167628288,
    "CMYK_Y": 0.7447035908699,
    "CMYK_K": 0.09549629688263
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0144",
    "Farbtonhilfsbezeichnung": "36.4 Orange 4",
    "Farbtonklasse": "04",
    "Rcolor": "254",
    "Gcolor": "133",
    "Bcolor": "51",
    "Y": 38,
    "L": 68.0030136108398,
    "a": 41.0776023864746,
    "b": 61.0134124755859,
    "C": 73.5527420043945,
    "h": 56.0493774414063,
    "CMY_C": 0.00550949573517,
    "CMY_M": 0.47892850637436,
    "CMY_Y": 0.79808938503265,
    "CMYK_C": 0,
    "CMYK_M": 0.47604176402092,
    "CMYK_Y": 0.79697078466415,
    "CMYK_K": 0.00550949573517
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0145",
    "Farbtonhilfsbezeichnung": "37.1 Orange 5",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "97",
    "Bcolor": "52",
    "Y": 27,
    "L": 59.0146560668945,
    "a": 52.519214630127,
    "b": 51.4143600463867,
    "C": 73.4962844848633,
    "h": 44.3909454345703,
    "CMY_C": 0.06533825397491,
    "CMY_M": 0.61935317516327,
    "CMY_Y": 0.79607808589935,
    "CMYK_C": 0,
    "CMYK_M": 0.5927437543869,
    "CMYK_Y": 0.78182274103165,
    "CMYK_K": 0.06533825397491
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0146",
    "Farbtonhilfsbezeichnung": "37.2 Orange 6",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "101",
    "Bcolor": "50",
    "Y": 28,
    "L": 59.6761703491211,
    "a": 50.976245880127,
    "b": 53.1505279541016,
    "C": 73.6447982788086,
    "h": 46.1962280273438,
    "CMY_C": 0.0637526512146,
    "CMY_M": 0.60542738437653,
    "CMY_Y": 0.80497401952744,
    "CMYK_C": 0,
    "CMYK_M": 0.57855945825577,
    "CMYK_Y": 0.79169398546219,
    "CMYK_K": 0.0637526512146
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0147",
    "Farbtonhilfsbezeichnung": "37.3 Orange 7",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "122",
    "Bcolor": "60",
    "Y": 33,
    "L": 63.8913955688477,
    "a": 41.6533584594727,
    "b": 52.8193473815918,
    "C": 67.2672729492188,
    "h": 51.7406730651855,
    "CMY_C": 0.05917280912399,
    "CMY_M": 0.52284669876099,
    "CMY_Y": 0.76656997203827,
    "CMYK_C": 0,
    "CMYK_M": 0.49283641576767,
    "CMYK_Y": 0.75188851356506,
    "CMYK_K": 0.05917280912399
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0148",
    "Farbtonhilfsbezeichnung": "37.4 Orange 8",
    "Farbtonklasse": "04",
    "Rcolor": "254",
    "Gcolor": "136",
    "Bcolor": "52",
    "Y": 39,
    "L": 68.6376953125,
    "a": 39.5348320007324,
    "b": 61.4571151733398,
    "C": 73.0751647949219,
    "h": 57.2471733093262,
    "CMY_C": 0.00547254085541,
    "CMY_M": 0.46674382686615,
    "CMY_Y": 0.79670858383179,
    "CMYK_C": 0,
    "CMYK_M": 0.46380949020386,
    "CMYK_Y": 0.79558992385864,
    "CMYK_K": 0.00547254085541
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0149",
    "Farbtonhilfsbezeichnung": "38.1 Orange 9",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "109",
    "Bcolor": "48",
    "Y": 30,
    "L": 60.9247207641602,
    "a": 46.5078353881836,
    "b": 55.0752143859863,
    "C": 72.085075378418,
    "h": 49.8208427429199,
    "CMY_C": 0.06960320472717,
    "CMY_M": 0.57317018508911,
    "CMY_Y": 0.81205356121063,
    "CMYK_C": 0,
    "CMYK_M": 0.54123896360397,
    "CMYK_Y": 0.79799324274063,
    "CMYK_K": 0.06960320472717
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0150",
    "Farbtonhilfsbezeichnung": "38.2 Orange 10",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "133",
    "Bcolor": "45",
    "Y": 38,
    "L": 67.8444747924805,
    "a": 40.7012786865234,
    "b": 63.2527847290039,
    "C": 75.2164154052734,
    "h": 57.2399291992188,
    "CMY_C": 0.00814074277878,
    "CMY_M": 0.47946643829346,
    "CMY_Y": 0.82207900285721,
    "CMYK_C": 0,
    "CMYK_M": 0.47519412636757,
    "CMYK_Y": 0.82061868906021,
    "CMYK_K": 0.00814074277878
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0151",
    "Farbtonhilfsbezeichnung": "38.3 Orange 11",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "151",
    "Bcolor": "33",
    "Y": 43,
    "L": 72.1757965087891,
    "a": 33.2337226867676,
    "b": 71.1859283447266,
    "C": 78.5615463256836,
    "h": 64.9740982055664,
    "CMY_C": 0,
    "CMY_M": 0.40914231538773,
    "CMY_Y": 0.87098097801208,
    "CMYK_C": 0,
    "CMYK_M": 0.40914231538773,
    "CMYK_Y": 0.87098097801208,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0152",
    "Farbtonhilfsbezeichnung": "38.4 Orange 12",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "164",
    "Bcolor": "48",
    "Y": 49,
    "L": 75.3163757324219,
    "a": 27.5267391204834,
    "b": 69.1251602172852,
    "C": 74.4043655395508,
    "h": 68.2867660522461,
    "CMY_C": 0,
    "CMY_M": 0.35781127214432,
    "CMY_Y": 0.81127548217773,
    "CMYK_C": 0,
    "CMYK_M": 0.35781127214432,
    "CMYK_Y": 0.81127548217773,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0153",
    "Farbtonhilfsbezeichnung": "39.1 Hummer 1",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "87",
    "Bcolor": "68",
    "Y": 16,
    "L": 46.8135070800781,
    "a": 32.5031585693359,
    "b": 26.0670623779297,
    "C": 41.6646995544434,
    "h": 38.7291107177734,
    "CMY_C": 0.33167350292206,
    "CMY_M": 0.65765392780304,
    "CMY_Y": 0.73235619068146,
    "CMYK_C": 0,
    "CMYK_M": 0.48775625228882,
    "CMYK_Y": 0.59953135251999,
    "CMYK_K": 0.33167350292206
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0154",
    "Farbtonhilfsbezeichnung": "39.2 Hummer 2",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "88",
    "Bcolor": "60",
    "Y": 19,
    "L": 49.5683555603027,
    "a": 38.4497299194336,
    "b": 34.9767036437988,
    "C": 51.9783744812012,
    "h": 42.2919616699219,
    "CMY_C": 0.2619441151619,
    "CMY_M": 0.65390503406525,
    "CMY_Y": 0.76625752449036,
    "CMYK_C": 0,
    "CMYK_M": 0.53107213973999,
    "CMYK_Y": 0.68329977989197,
    "CMYK_K": 0.2619441151619
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0155",
    "Farbtonhilfsbezeichnung": "39.3 Hummer 3",
    "Farbtonklasse": "04",
    "Rcolor": "222",
    "Gcolor": "101",
    "Bcolor": "67",
    "Y": 26,
    "L": 57.2683372497559,
    "a": 45.2553596496582,
    "b": 40.9734268188477,
    "C": 61.0480880737305,
    "h": 42.157154083252,
    "CMY_C": 0.13067036867142,
    "CMY_M": 0.60382604598999,
    "CMY_Y": 0.73606556653976,
    "CMYK_C": 0,
    "CMYK_M": 0.54427647590637,
    "CMYK_Y": 0.69639313220978,
    "CMYK_K": 0.13067036867142
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0156",
    "Farbtonhilfsbezeichnung": "39.4 Hummer 4",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "118",
    "Bcolor": "88",
    "Y": 33,
    "L": 63.6763877868652,
    "a": 45.6453437805176,
    "b": 38.0461540222168,
    "C": 59.4222793579102,
    "h": 39.811767578125,
    "CMY_C": 0.05280721187592,
    "CMY_M": 0.53809225559235,
    "CMY_Y": 0.65469372272491,
    "CMYK_C": 0,
    "CMYK_M": 0.51234030723572,
    "CMYK_Y": 0.63544243574142,
    "CMYK_K": 0.05280721187592
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0157",
    "Farbtonhilfsbezeichnung": "40.1 Salmone 1",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "101",
    "Bcolor": "75",
    "Y": 21,
    "L": 52.4829025268555,
    "a": 32.857837677002,
    "b": 30.0652046203613,
    "C": 44.537109375,
    "h": 42.4587821960449,
    "CMY_C": 0.2608351111412,
    "CMY_M": 0.60362708568573,
    "CMY_Y": 0.70749413967133,
    "CMYK_C": 0,
    "CMYK_M": 0.46375575661659,
    "CMYK_Y": 0.60427522659302,
    "CMYK_K": 0.2608351111412
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0158",
    "Farbtonhilfsbezeichnung": "40.2 Salmone 2",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "116",
    "Bcolor": "85",
    "Y": 27,
    "L": 58.1456832885742,
    "a": 32.4440689086914,
    "b": 31.6107654571533,
    "C": 45.2974395751953,
    "h": 44.2546653747559,
    "CMY_C": 0.19558423757553,
    "CMY_M": 0.54564845561981,
    "CMY_Y": 0.66552734375,
    "CMYK_C": 0,
    "CMYK_M": 0.43517822027206,
    "CMYK_Y": 0.58420425653458,
    "CMYK_K": 0.19558423757553
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0159",
    "Farbtonhilfsbezeichnung": "40.3 Salmone 3",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "131",
    "Bcolor": "99",
    "Y": 35,
    "L": 65.255241394043,
    "a": 36.6172103881836,
    "b": 33.7836112976074,
    "C": 49.8212051391602,
    "h": 42.6951179504395,
    "CMY_C": 0.08651733398438,
    "CMY_M": 0.48735964298248,
    "CMY_Y": 0.61187756061554,
    "CMYK_C": 0,
    "CMYK_M": 0.43880668282509,
    "CMYK_Y": 0.57511788606644,
    "CMYK_K": 0.08651733398438
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0160",
    "Farbtonhilfsbezeichnung": "40.4 Salmone 4",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "154",
    "Bcolor": "124",
    "Y": 46,
    "L": 73.2144012451172,
    "a": 34.1144332885742,
    "b": 30.7269039154053,
    "C": 45.9122772216797,
    "h": 42.0093955993652,
    "CMY_C": 0.00900197029114,
    "CMY_M": 0.39497923851013,
    "CMY_Y": 0.51254725456238,
    "CMYK_C": 0,
    "CMYK_M": 0.38948339223862,
    "CMYK_Y": 0.5081193447113,
    "CMYK_K": 0.00900197029114
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0161",
    "Farbtonhilfsbezeichnung": "41.1 Langostino 1",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 27,
    "L": 58.8344688415527,
    "a": 37.2379722595215,
    "b": 43.4322319030762,
    "C": 57.2103614807129,
    "h": 49.3908386230469,
    "CMY_C": 0.15101158618927,
    "CMY_M": 0.55725079774857,
    "CMY_Y": 0.74279522895813,
    "CMYK_C": 0,
    "CMYK_M": 0.47849795222282,
    "CMYK_Y": 0.69704562425613,
    "CMYK_K": 0.15101158618927
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0162",
    "Farbtonhilfsbezeichnung": "41.2 Langostino 2",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "126",
    "Bcolor": "78",
    "Y": 35,
    "L": 65.2654571533203,
    "a": 41.7737236022949,
    "b": 45.1349105834961,
    "C": 61.499626159668,
    "h": 47.2148056030273,
    "CMY_C": 0.04747551679611,
    "CMY_M": 0.50783461332321,
    "CMY_Y": 0.69293022155762,
    "CMYK_C": 0,
    "CMYK_M": 0.48330420255661,
    "CMYK_Y": 0.67762529850006,
    "CMYK_K": 0.04747551679611
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0163",
    "Farbtonhilfsbezeichnung": "41.3 Langostino 3",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "135",
    "Bcolor": "82",
    "Y": 40,
    "L": 68.9248199462891,
    "a": 42.2516403198242,
    "b": 47.8633117675781,
    "C": 63.8443260192871,
    "h": 48.5633430480957,
    "CMY_C": 0,
    "CMY_M": 0.47173225879669,
    "CMY_Y": 0.67830830812454,
    "CMYK_C": 0,
    "CMYK_M": 0.47173225879669,
    "CMYK_Y": 0.67830830812454,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0164",
    "Farbtonhilfsbezeichnung": "41.4 Langostino 4",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "144",
    "Bcolor": "98",
    "Y": 41,
    "L": 69.6677703857422,
    "a": 34.6848602294922,
    "b": 39.9118919372559,
    "C": 52.8772048950195,
    "h": 49.0081901550293,
    "CMY_C": 0.03734493255615,
    "CMY_M": 0.43598848581314,
    "CMY_Y": 0.61404103040695,
    "CMYK_C": 0,
    "CMYK_M": 0.41410839557648,
    "CMYK_Y": 0.59906828403473,
    "CMYK_K": 0.03734493255615
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0165",
    "Farbtonhilfsbezeichnung": "41.1 Cayenne 1",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "107",
    "Bcolor": "70",
    "Y": 23,
    "L": 54.9993858337402,
    "a": 32.8000068664551,
    "b": 35.8704223632813,
    "C": 48.6058387756348,
    "h": 47.5601234436035,
    "CMY_C": 0.22621953487396,
    "CMY_M": 0.57930409908295,
    "CMY_Y": 0.72480314970016,
    "CMYK_C": 0,
    "CMYK_M": 0.45631104707718,
    "CMYK_Y": 0.64434760808945,
    "CMYK_K": 0.22621953487396
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0166",
    "Farbtonhilfsbezeichnung": "42.2 Cayenne 2",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "128",
    "Bcolor": "89",
    "Y": 30,
    "L": 61.9363136291504,
    "a": 28.9014682769775,
    "b": 34.5433349609375,
    "C": 45.0392799377441,
    "h": 50.0816917419434,
    "CMY_C": 0.1672335267067,
    "CMY_M": 0.49621516466141,
    "CMY_Y": 0.6513175368309,
    "CMYK_C": 0,
    "CMYK_M": 0.3950466811657,
    "CMYK_Y": 0.58129620552063,
    "CMYK_K": 0.1672335267067
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0167",
    "Farbtonhilfsbezeichnung": "42.3 Cayenne 3",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "143",
    "Bcolor": "101",
    "Y": 39,
    "L": 68.3357925415039,
    "a": 31.0097789764404,
    "b": 36.6811561584473,
    "C": 48.0324211120605,
    "h": 49.7892532348633,
    "CMY_C": 0.07748627662659,
    "CMY_M": 0.43731039762497,
    "CMY_Y": 0.60445493459702,
    "CMYK_C": 0,
    "CMYK_M": 0.39004743099213,
    "CMYK_Y": 0.57123124599457,
    "CMYK_K": 0.07748627662659
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0168",
    "Farbtonhilfsbezeichnung": "42.4 Cayenne 4",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "163",
    "Bcolor": "130",
    "Y": 47,
    "L": 73.8731842041016,
    "a": 25.4008636474609,
    "b": 28.4808959960938,
    "C": 38.162353515625,
    "h": 48.2716293334961,
    "CMY_C": 0.05537968873978,
    "CMY_M": 0.36039704084396,
    "CMY_Y": 0.49186211824417,
    "CMYK_C": 0,
    "CMYK_M": 0.32289943099022,
    "CMYK_Y": 0.46207183599472,
    "CMYK_K": 0.05537968873978
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0169",
    "Farbtonhilfsbezeichnung": "43.1 Karotte 1",
    "Farbtonklasse": "04",
    "Rcolor": "211",
    "Gcolor": "110",
    "Bcolor": "61",
    "Y": 26,
    "L": 57.419246673584,
    "a": 36.2198677062988,
    "b": 44.0624465942383,
    "C": 57.0383911132813,
    "h": 50.5793762207031,
    "CMY_C": 0.17281770706177,
    "CMY_M": 0.56808805465698,
    "CMY_Y": 0.76125931739807,
    "CMYK_C": 0,
    "CMYK_M": 0.47785156965256,
    "CMYK_Y": 0.71138083934784,
    "CMYK_K": 0.17281770706177
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0170",
    "Farbtonhilfsbezeichnung": "43.2 Karotte 2",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "126",
    "Bcolor": "57",
    "Y": 34,
    "L": 64.9693984985352,
    "a": 40.4163131713867,
    "b": 55.1083488464355,
    "C": 68.3403854370117,
    "h": 53.743782043457,
    "CMY_C": 0.05073511600494,
    "CMY_M": 0.50736087560654,
    "CMY_Y": 0.77596199512482,
    "CMYK_C": 0,
    "CMYK_M": 0.4810309112072,
    "CMYK_Y": 0.7639878988266,
    "CMYK_K": 0.05073511600494
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0171",
    "Farbtonhilfsbezeichnung": "43.3 Karotte 3",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "145",
    "Bcolor": "87",
    "Y": 42,
    "L": 70.5014266967773,
    "a": 35.373950958252,
    "b": 47.0995254516602,
    "C": 58.9040031433105,
    "h": 53.0917320251465,
    "CMY_C": 0.01614540815353,
    "CMY_M": 0.43078351020813,
    "CMY_Y": 0.65973138809204,
    "CMYK_C": 0,
    "CMYK_M": 0.42144244909286,
    "CMYK_Y": 0.65414744615555,
    "CMYK_K": 0.01614540815353
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0172",
    "Farbtonhilfsbezeichnung": "43.4 Karotte 4",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "163",
    "Bcolor": "113",
    "Y": 50,
    "L": 75.1486129760742,
    "a": 29.0991153717041,
    "b": 39.4648208618164,
    "C": 49.0329551696777,
    "h": 53.5970458984375,
    "CMY_C": 0.00345599651337,
    "CMY_M": 0.36026859283447,
    "CMY_Y": 0.55844789743423,
    "CMYK_C": 0,
    "CMYK_M": 0.35805001854897,
    "CMYK_Y": 0.55691659450531,
    "CMYK_K": 0.00345599651337
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0173",
    "Farbtonhilfsbezeichnung": "44.1 Bergamotte 1",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "117",
    "Bcolor": "56",
    "Y": 28,
    "L": 59.2776527404785,
    "a": 34.0387535095215,
    "b": 48.5219650268555,
    "C": 59.2707176208496,
    "h": 54.9498672485352,
    "CMY_C": 0.15847343206406,
    "CMY_M": 0.5422625541687,
    "CMY_Y": 0.77963143587112,
    "CMYK_C": 0,
    "CMYK_M": 0.45606300234795,
    "CMYK_Y": 0.73813235759735,
    "CMYK_K": 0.15847343206406
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0174",
    "Farbtonhilfsbezeichnung": "44.2 Bergamotte 2",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "132",
    "Bcolor": "73",
    "Y": 34,
    "L": 64.502197265625,
    "a": 32.0307426452637,
    "b": 46.5598907470703,
    "C": 56.5136451721191,
    "h": 55.4740867614746,
    "CMY_C": 0.10778719186783,
    "CMY_M": 0.48190706968307,
    "CMY_Y": 0.71490460634232,
    "CMYK_C": 0,
    "CMYK_M": 0.41931685805321,
    "CMYK_Y": 0.68046253919601,
    "CMYK_K": 0.10778719186783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0175",
    "Farbtonhilfsbezeichnung": "44.3 Bergamotte 3",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "149",
    "Bcolor": "91",
    "Y": 41,
    "L": 69.6661911010742,
    "a": 28.5660800933838,
    "b": 43.6452140808105,
    "C": 52.1624908447266,
    "h": 56.7949905395508,
    "CMY_C": 0.06762969493866,
    "CMY_M": 0.41696166992188,
    "CMY_Y": 0.64387738704681,
    "CMYK_C": 0,
    "CMYK_M": 0.37467086315155,
    "CMYK_Y": 0.61804592609406,
    "CMYK_K": 0.06762969493866
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0176",
    "Farbtonhilfsbezeichnung": "44.4 Bergamotte 4",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "162",
    "Bcolor": "103",
    "Y": 48,
    "L": 74.6526641845703,
    "a": 28.3940162658691,
    "b": 44.0029182434082,
    "C": 52.3686637878418,
    "h": 57.1668281555176,
    "CMY_C": 0.00817781686783,
    "CMY_M": 0.36413371562958,
    "CMY_Y": 0.59767174720764,
    "CMYK_C": 0,
    "CMYK_M": 0.35889083147049,
    "CMYK_Y": 0.59435445070267,
    "CMYK_K": 0.00817781686783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0177",
    "Farbtonhilfsbezeichnung": "45.1 Kuerbis 1",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "121",
    "Bcolor": "46",
    "Y": 32,
    "L": 63.2140579223633,
    "a": 40.2548637390137,
    "b": 58.0124130249023,
    "C": 70.6108627319336,
    "h": 55.2431831359863,
    "CMY_C": 0.07153749465942,
    "CMY_M": 0.52530372142792,
    "CMY_Y": 0.8197546005249,
    "CMYK_C": 0,
    "CMYK_M": 0.48872864246368,
    "CMYK_Y": 0.80586677789688,
    "CMYK_K": 0.07153749465942
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0178",
    "Farbtonhilfsbezeichnung": "45.2 Kuerbis 2",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "137",
    "Bcolor": "68",
    "Y": 38,
    "L": 67.7570648193359,
    "a": 36.1022987365723,
    "b": 52.8076057434082,
    "C": 63.9688911437988,
    "h": 55.6412544250488,
    "CMY_C": 0.04095685482025,
    "CMY_M": 0.46277016401291,
    "CMY_Y": 0.73141533136368,
    "CMYK_C": 0,
    "CMYK_M": 0.43982726335526,
    "CMYK_Y": 0.71994519233704,
    "CMYK_K": 0.04095685482025
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0179",
    "Farbtonhilfsbezeichnung": "45.3 Kuerbis 3",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "148",
    "Bcolor": "57",
    "Y": 43,
    "L": 71.5411987304688,
    "a": 34.1187744140625,
    "b": 61.9814186096191,
    "C": 70.7515869140625,
    "h": 61.1686325073242,
    "CMY_C": 0,
    "CMY_M": 0.41773861646652,
    "CMY_Y": 0.77472269535065,
    "CMYK_C": 0,
    "CMYK_M": 0.41773861646652,
    "CMYK_Y": 0.77472269535065,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0180",
    "Farbtonhilfsbezeichnung": "45.4 Kuerbis 4",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "160",
    "Bcolor": "71",
    "Y": 48,
    "L": 74.6868591308594,
    "a": 30.6740493774414,
    "b": 59.6446685791016,
    "C": 67.0699920654297,
    "h": 62.7841567993164,
    "CMY_C": 0,
    "CMY_M": 0.37319380044937,
    "CMY_Y": 0.72286546230316,
    "CMYK_C": 0,
    "CMYK_M": 0.37319380044937,
    "CMYK_Y": 0.72286546230316,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0181",
    "Farbtonhilfsbezeichnung": "46.1 Clementine 1",
    "Farbtonklasse": "04",
    "Rcolor": "212",
    "Gcolor": "129",
    "Bcolor": "76",
    "Y": 31,
    "L": 61.9124755859375,
    "a": 27.2250862121582,
    "b": 41.4539566040039,
    "C": 49.5947151184082,
    "h": 56.7048988342285,
    "CMY_C": 0.169473528862,
    "CMY_M": 0.49238580465317,
    "CMY_Y": 0.70252627134323,
    "CMYK_C": 0,
    "CMYK_M": 0.38880431652069,
    "CMYK_Y": 0.64182507991791,
    "CMYK_K": 0.169473528862
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0182",
    "Farbtonhilfsbezeichnung": "46.2 Clementine 2",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "148",
    "Bcolor": "77",
    "Y": 40,
    "L": 69.4494476318359,
    "a": 27.8917579650879,
    "b": 50.5450096130371,
    "C": 57.7299575805664,
    "h": 61.1091957092285,
    "CMY_C": 0.06728577613831,
    "CMY_M": 0.41816812753677,
    "CMY_Y": 0.69996273517609,
    "CMYK_C": 0,
    "CMYK_M": 0.37619492411613,
    "CMYK_Y": 0.67831814289093,
    "CMYK_K": 0.06728577613831
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0183",
    "Farbtonhilfsbezeichnung": "46.3 Clementine 3",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "172",
    "Bcolor": "89",
    "Y": 53,
    "L": 77.7101898193359,
    "a": 26.2784080505371,
    "b": 54.7291259765625,
    "C": 60.711051940918,
    "h": 64.3518218994141,
    "CMY_C": 0,
    "CMY_M": 0.32691043615341,
    "CMY_Y": 0.6525160074234,
    "CMYK_C": 0,
    "CMYK_M": 0.32691043615341,
    "CMYK_Y": 0.6525160074234,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0184",
    "Farbtonhilfsbezeichnung": "46.4 Clementine 4",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "115",
    "Y": 57,
    "L": 79.9360275268555,
    "a": 22.5095748901367,
    "b": 44.2467498779297,
    "C": 49.6432876586914,
    "h": 63.0362739562988,
    "CMY_C": 0,
    "CMY_M": 0.29039150476456,
    "CMY_Y": 0.54859501123428,
    "CMYK_C": 0,
    "CMYK_M": 0.29039150476456,
    "CMYK_Y": 0.54859501123428,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0185",
    "Farbtonhilfsbezeichnung": "47.1 Nektarine 1",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "140",
    "Bcolor": "49",
    "Y": 36,
    "L": 65.8438415527344,
    "a": 25.6121597290039,
    "b": 58.7663879394531,
    "C": 64.1051559448242,
    "h": 66.4509811401367,
    "CMY_C": 0.11689627170563,
    "CMY_M": 0.44950300455093,
    "CMY_Y": 0.80890989303589,
    "CMYK_C": 0,
    "CMYK_M": 0.37663382291794,
    "CMYK_Y": 0.78361535072327,
    "CMYK_K": 0.11689627170563
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0186",
    "Farbtonhilfsbezeichnung": "47.2 Nektarine 2",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "152",
    "Bcolor": "57",
    "Y": 42,
    "L": 70.287239074707,
    "a": 25.2995147705078,
    "b": 60.2415161132813,
    "C": 65.3383941650391,
    "h": 67.2191467285156,
    "CMY_C": 0.06353688240051,
    "CMY_M": 0.40278750658035,
    "CMY_Y": 0.77655148506165,
    "CMYK_C": 0,
    "CMYK_M": 0.36226800084114,
    "CMYK_Y": 0.76139104366302,
    "CMYK_K": 0.06353688240051
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0187",
    "Farbtonhilfsbezeichnung": "47.3 Nektarine 3",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "180",
    "Bcolor": "88",
    "Y": 56,
    "L": 79.512092590332,
    "a": 21.2650604248047,
    "b": 56.9619255065918,
    "C": 60.8018417358398,
    "h": 69.5283584594727,
    "CMY_C": 0,
    "CMY_M": 0.29327142238617,
    "CMY_Y": 0.65489149093628,
    "CMYK_C": 0,
    "CMYK_M": 0.29327142238617,
    "CMYK_Y": 0.65489149093628,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0188",
    "Farbtonhilfsbezeichnung": "47.4 Nektarine 4",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "122",
    "Y": 63,
    "L": 83.3565826416016,
    "a": 16.4310855865479,
    "b": 44.8866653442383,
    "C": 47.7995109558105,
    "h": 69.8944854736328,
    "CMY_C": 0,
    "CMY_M": 0.23657137155533,
    "CMY_Y": 0.52067703008652,
    "CMYK_C": 0,
    "CMYK_M": 0.23657137155533,
    "CMYK_Y": 0.52067703008652,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0189",
    "Farbtonhilfsbezeichnung": "48.1 Mango 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "184",
    "Bcolor": "109",
    "Y": 58,
    "L": 80.5939102172852,
    "a": 21.0741882324219,
    "b": 48.0362167358398,
    "C": 52.4556922912598,
    "h": 66.3122406005859,
    "CMY_C": 0,
    "CMY_M": 0.27983182668686,
    "CMY_Y": 0.57177305221558,
    "CMYK_C": 0,
    "CMYK_M": 0.27983182668686,
    "CMYK_Y": 0.57177305221558,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0190",
    "Farbtonhilfsbezeichnung": "48.2 Mango 2",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "131",
    "Y": 64,
    "L": 83.3549346923828,
    "a": 16.0730953216553,
    "b": 40.636287689209,
    "C": 43.6995697021484,
    "h": 68.4194488525391,
    "CMY_C": 0,
    "CMY_M": 0.23487788438797,
    "CMY_Y": 0.48815661668777,
    "CMYK_C": 0,
    "CMYK_M": 0.23487788438797,
    "CMYK_Y": 0.48815661668777,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0191",
    "Farbtonhilfsbezeichnung": "48.3 Mango 3",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "152",
    "Y": 70,
    "L": 86.4276504516602,
    "a": 12.2838926315308,
    "b": 33.6575012207031,
    "C": 35.8290596008301,
    "h": 69.9495620727539,
    "CMY_C": 0,
    "CMY_M": 0.18997293710709,
    "CMY_Y": 0.40468329191208,
    "CMYK_C": 0,
    "CMYK_M": 0.18997293710709,
    "CMYK_Y": 0.40468329191208,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0192",
    "Farbtonhilfsbezeichnung": "48.4 Mango 4",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "173",
    "Y": 76,
    "L": 89.3473739624023,
    "a": 8.18549346923828,
    "b": 26.6937732696533,
    "C": 27.9205989837646,
    "h": 72.9521408081055,
    "CMY_C": 0,
    "CMY_M": 0.14581876993179,
    "CMY_Y": 0.32275080680847,
    "CMYK_C": 0,
    "CMYK_M": 0.14581876993179,
    "CMYK_Y": 0.32275080680847,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0193",
    "Farbtonhilfsbezeichnung": "49.1 Guave 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "186",
    "Bcolor": "122",
    "Y": 59,
    "L": 80.9030685424805,
    "a": 19.4432315826416,
    "b": 42.0136833190918,
    "C": 46.2945861816406,
    "h": 65.1660919189453,
    "CMY_C": 0,
    "CMY_M": 0.27089315652847,
    "CMY_Y": 0.52264922857285,
    "CMYK_C": 0,
    "CMYK_M": 0.27089315652847,
    "CMYK_Y": 0.52264922857285,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0194",
    "Farbtonhilfsbezeichnung": "49.2 Guave 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "152",
    "Y": 67,
    "L": 85.4694290161133,
    "a": 14.7298412322998,
    "b": 32.2693061828613,
    "C": 35.4721908569336,
    "h": 65.4649124145508,
    "CMY_C": 0,
    "CMY_M": 0.20666921138763,
    "CMY_Y": 0.40366530418396,
    "CMYK_C": 0,
    "CMYK_M": 0.20666921138763,
    "CMYK_Y": 0.40366530418396,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0195",
    "Farbtonhilfsbezeichnung": "49.3 Guave 3",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "170",
    "Y": 71,
    "L": 87.0522232055664,
    "a": 11.3023262023926,
    "b": 24.9359912872314,
    "C": 27.3778419494629,
    "h": 65.6174240112305,
    "CMY_C": 0,
    "CMY_M": 0.1787274479866,
    "CMY_Y": 0.33324682712555,
    "CMYK_C": 0,
    "CMYK_M": 0.1787274479866,
    "CMYK_Y": 0.33324682712555,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0196",
    "Farbtonhilfsbezeichnung": "49.4 Guave 4",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "219",
    "Bcolor": "192",
    "Y": 76,
    "L": 89.5869903564453,
    "a": 8.64952659606934,
    "b": 17.0373058319092,
    "C": 19.1071739196777,
    "h": 63.0839347839355,
    "CMY_C": 0.00353878736496,
    "CMY_M": 0.14212691783905,
    "CMY_Y": 0.24823564291,
    "CMYK_C": 0,
    "CMYK_M": 0.13908030092716,
    "CMYK_Y": 0.24556586146355,
    "CMYK_K": 0.00353878736496
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0197",
    "Farbtonhilfsbezeichnung": "50.1 Aprikose 1",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "171",
    "Bcolor": "101",
    "Y": 52,
    "L": 77.2930679321289,
    "a": 26.0245494842529,
    "b": 48.041690826416,
    "C": 54.6377258300781,
    "h": 61.5552558898926,
    "CMY_C": 0,
    "CMY_M": 0.32958656549454,
    "CMY_Y": 0.60330241918564,
    "CMYK_C": 0,
    "CMYK_M": 0.32958656549454,
    "CMYK_Y": 0.60330241918564,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0198",
    "Farbtonhilfsbezeichnung": "50.2 Aprikose 2",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "133",
    "Y": 61,
    "L": 82.3156967163086,
    "a": 21.2938346862793,
    "b": 38.1930847167969,
    "C": 43.7280120849609,
    "h": 60.8589744567871,
    "CMY_C": 0,
    "CMY_M": 0.2602179646492,
    "CMY_Y": 0.47890591621399,
    "CMYK_C": 0,
    "CMYK_M": 0.2602179646492,
    "CMYK_Y": 0.47890591621399,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0199",
    "Farbtonhilfsbezeichnung": "50.3 Aprikose 3",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "204",
    "Bcolor": "162",
    "Y": 67,
    "L": 86.0182189941406,
    "a": 15.5002317428589,
    "b": 27.8876857757568,
    "C": 31.9058017730713,
    "h": 60.9342880249023,
    "CMY_C": 0,
    "CMY_M": 0.20183789730072,
    "CMY_Y": 0.36514914035797,
    "CMYK_C": 0,
    "CMYK_M": 0.20183789730072,
    "CMYK_Y": 0.36514914035797,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0200",
    "Farbtonhilfsbezeichnung": "50.4 Aprikose 4",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "193",
    "Y": 76,
    "L": 90.0076522827148,
    "a": 9.73147869110107,
    "b": 17.2264785766602,
    "C": 19.785177230835,
    "h": 60.5372848510742,
    "CMY_C": 0,
    "CMY_M": 0.14029622077942,
    "CMY_Y": 0.24493223428726,
    "CMYK_C": 0,
    "CMYK_M": 0.14029622077942,
    "CMYK_Y": 0.24493223428726,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0201",
    "Farbtonhilfsbezeichnung": "51.1 Pomelo 1",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "199",
    "Bcolor": "162",
    "Y": 65,
    "L": 84.2422866821289,
    "a": 14.84716796875,
    "b": 25.2529468536377,
    "C": 29.2941932678223,
    "h": 59.5471115112305,
    "CMY_C": 0.00561499595642,
    "CMY_M": 0.21886318922043,
    "CMY_Y": 0.36434495449066,
    "CMYK_C": 0,
    "CMYK_M": 0.21445234119892,
    "CMYK_Y": 0.36075559258461,
    "CMYK_K": 0.00561499595642
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0202",
    "Farbtonhilfsbezeichnung": "51.2 Pomelo 2",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "210",
    "Bcolor": "180",
    "Y": 71,
    "L": 87.138313293457,
    "a": 10.8535213470459,
    "b": 19.5879192352295,
    "C": 22.3938713073731,
    "h": 61.0094909667969,
    "CMY_C": 0.01053631305695,
    "CMY_M": 0.17538821697235,
    "CMY_Y": 0.2928484082222,
    "CMYK_C": 0,
    "CMYK_M": 0.16660733520985,
    "CMYK_Y": 0.28531828522682,
    "CMYK_K": 0.01053631305695
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0203",
    "Farbtonhilfsbezeichnung": "51.3 Pomelo 3",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "221",
    "Bcolor": "196",
    "Y": 77,
    "L": 90.0970611572266,
    "a": 7.90332698822021,
    "b": 15.3378391265869,
    "C": 17.2543296813965,
    "h": 62.7387237548828,
    "CMY_C": 0.00711810588837,
    "CMY_M": 0.13416415452957,
    "CMY_Y": 0.23028266429901,
    "CMYK_C": 0,
    "CMYK_M": 0.12795685231686,
    "CMYK_Y": 0.22476445138454,
    "CMYK_K": 0.00711810588837
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0204",
    "Farbtonhilfsbezeichnung": "51.4 Pomelo 4",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "227",
    "Bcolor": "207",
    "Y": 80,
    "L": 91.6138687133789,
    "a": 5.35625076293945,
    "b": 11.7644758224487,
    "C": 12.9264192581177,
    "h": 65.5206909179688,
    "CMY_C": 0.01744270324707,
    "CMY_M": 0.11001658439636,
    "CMY_Y": 0.18776738643646,
    "CMYK_C": 0,
    "CMYK_M": 0.09421728551388,
    "CMYK_Y": 0.17334835231304,
    "CMYK_K": 0.01744270324707
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0205",
    "Farbtonhilfsbezeichnung": "52.1 Lychee 1",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "204",
    "Bcolor": "178",
    "Y": 66,
    "L": 84.8787231445313,
    "a": 10.8048677444458,
    "b": 17.3751468658447,
    "C": 20.4607162475586,
    "h": 58.124267578125,
    "CMY_C": 0.04180133342743,
    "CMY_M": 0.19947272539139,
    "CMY_Y": 0.30054873228073,
    "CMYK_C": 0,
    "CMYK_M": 0.16454979777336,
    "CMYK_Y": 0.2700352370739,
    "CMYK_K": 0.04180133342743
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0206",
    "Farbtonhilfsbezeichnung": "52.2 Lychee 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "215",
    "Bcolor": "190",
    "Y": 74,
    "L": 88.6209259033203,
    "a": 10.8813495635986,
    "b": 16.6109180450439,
    "C": 19.8576526641846,
    "h": 56.7723121643066,
    "CMY_C": 0.00013202428818,
    "CMY_M": 0.15843063592911,
    "CMY_Y": 0.25504922866821,
    "CMYK_C": 0,
    "CMYK_M": 0.15831951797009,
    "CMYK_Y": 0.25495085120201,
    "CMYK_K": 0.00013202428818
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0207",
    "Farbtonhilfsbezeichnung": "52.3 Lychee 3",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "225",
    "Bcolor": "209",
    "Y": 79,
    "L": 91.1570892333984,
    "a": 6.49639368057251,
    "b": 10.2138147354126,
    "C": 12.10475730896,
    "h": 57.5420150756836,
    "CMY_C": 0.01857376098633,
    "CMY_M": 0.11754029989243,
    "CMY_Y": 0.18104910850525,
    "CMYK_C": 0,
    "CMYK_M": 0.10083951056004,
    "CMYK_Y": 0.16555023193359,
    "CMYK_K": 0.01857376098633
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0208",
    "Farbtonhilfsbezeichnung": "52.4 Lychee 4",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "234",
    "Bcolor": "225",
    "Y": 84,
    "L": 93.4965286254883,
    "a": 2.62397480010986,
    "b": 5.03857183456421,
    "C": 5.68088483810425,
    "h": 62.4905128479004,
    "CMY_C": 0.03617703914642,
    "CMY_M": 0.08046752214432,
    "CMY_Y": 0.1175342798233,
    "CMYK_C": 0,
    "CMYK_M": 0.04595292359591,
    "CMYK_Y": 0.08441098034382,
    "CMYK_K": 0.03617703914642
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0209",
    "Farbtonhilfsbezeichnung": "53.1 Maracuja 1",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "181",
    "Bcolor": "141",
    "Y": 56,
    "L": 79.7095642089844,
    "a": 22.2720317840576,
    "b": 30.5925350189209,
    "C": 37.8410720825195,
    "h": 53.9445686340332,
    "CMY_C": 0.00231420993805,
    "CMY_M": 0.28956645727158,
    "CMY_Y": 0.44880610704422,
    "CMYK_C": 0,
    "CMYK_M": 0.28791853785515,
    "CMYK_Y": 0.44752755761147,
    "CMYK_K": 0.00231420993805
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0210",
    "Farbtonhilfsbezeichnung": "53.2 Maracuja 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "171",
    "Y": 67,
    "L": 85.5040512084961,
    "a": 16.3499431610107,
    "b": 22.4183139801025,
    "C": 27.7470970153809,
    "h": 53.8962860107422,
    "CMY_C": 0,
    "CMY_M": 0.20852708816528,
    "CMY_Y": 0.32995057106018,
    "CMYK_C": 0,
    "CMYK_M": 0.20852708816528,
    "CMYK_Y": 0.32995057106018,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0211",
    "Farbtonhilfsbezeichnung": "53.3 Maracuja 3",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "199",
    "Y": 76,
    "L": 89.8192749023438,
    "a": 10.0946884155273,
    "b": 13.6977214813232,
    "C": 17.0155906677246,
    "h": 53.6112289428711,
    "CMY_C": 0,
    "CMY_M": 0.14243137836456,
    "CMY_Y": 0.22076410055161,
    "CMYK_C": 0,
    "CMYK_M": 0.14243137836456,
    "CMYK_Y": 0.22076410055161,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0212",
    "Farbtonhilfsbezeichnung": "53.4 Maracuja 4",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "222",
    "Bcolor": "206",
    "Y": 76,
    "L": 89.9186630249023,
    "a": 5.99811553955078,
    "b": 9.85695552825928,
    "C": 11.538498878479,
    "h": 58.6788177490234,
    "CMY_C": 0.03726452589035,
    "CMY_M": 0.12994402647018,
    "CMY_Y": 0.19195783138275,
    "CMYK_C": 0,
    "CMYK_M": 0.09626683592796,
    "CMYK_Y": 0.1606810092926,
    "CMYK_K": 0.03726452589035
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0213",
    "Farbtonhilfsbezeichnung": "54.1 Feige 1",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "153",
    "Bcolor": "110",
    "Y": 44,
    "L": 72.1764755249023,
    "a": 31.8136692047119,
    "b": 37.2050743103027,
    "C": 48.9522933959961,
    "h": 49.4665946960449,
    "CMY_C": 0.0263500213623,
    "CMY_M": 0.39978003501892,
    "CMY_Y": 0.57042026519775,
    "CMYK_C": 0,
    "CMYK_M": 0.38353618979454,
    "CMYK_Y": 0.5587944984436,
    "CMYK_K": 0.0263500213623
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0214",
    "Farbtonhilfsbezeichnung": "54.2 Feige 2",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "185",
    "Bcolor": "150",
    "Y": 58,
    "L": 80.6659393310547,
    "a": 21.1308612823486,
    "b": 26.8943500518799,
    "C": 34.2026214599609,
    "h": 51.843318939209,
    "CMY_C": 0.00428467988968,
    "CMY_M": 0.27524191141129,
    "CMY_Y": 0.41217219829559,
    "CMYK_C": 0,
    "CMYK_M": 0.27212318778038,
    "CMYK_Y": 0.40964269638062,
    "CMYK_K": 0.00428467988968
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0215",
    "Farbtonhilfsbezeichnung": "54.3 Feige 3",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "200",
    "Bcolor": "170",
    "Y": 65,
    "L": 84.5616302490234,
    "a": 15.7309112548828,
    "b": 21.5271396636963,
    "C": 26.6623191833496,
    "h": 53.8426132202148,
    "CMY_C": 0.00352972745895,
    "CMY_M": 0.21691673994064,
    "CMY_Y": 0.33343183994293,
    "CMYK_C": 0,
    "CMYK_M": 0.21414287388325,
    "CMYK_Y": 0.33107069134712,
    "CMYK_K": 0.00352972745895
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0216",
    "Farbtonhilfsbezeichnung": "54.4 Feige 4",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "212",
    "Bcolor": "187",
    "Y": 72,
    "L": 87.8321380615234,
    "a": 11.531683921814,
    "b": 16.8644332885742,
    "C": 20.4300956726074,
    "h": 55.6361808776855,
    "CMY_C": 0.00413239002228,
    "CMY_M": 0.1688694357872,
    "CMY_Y": 0.26524537801743,
    "CMYK_C": 0,
    "CMYK_M": 0.16542062163353,
    "CMYK_Y": 0.26219648122787,
    "CMYK_K": 0.00413239002228
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0217",
    "Farbtonhilfsbezeichnung": "55.1 Pelikan 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "178",
    "Bcolor": "144",
    "Y": 57,
    "L": 79.9141998291016,
    "a": 27.4919528961182,
    "b": 29.0304069519043,
    "C": 39.9821472167969,
    "h": 46.5591201782227,
    "CMY_C": 0,
    "CMY_M": 0.30241572856903,
    "CMY_Y": 0.43409013748169,
    "CMYK_C": 0,
    "CMYK_M": 0.30241572856903,
    "CMYK_Y": 0.43409013748169,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0218",
    "Farbtonhilfsbezeichnung": "55.2 Pelikan 2",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "193",
    "Bcolor": "162",
    "Y": 62,
    "L": 82.9641418457031,
    "a": 19.1352291107178,
    "b": 23.3803901672363,
    "C": 30.212574005127,
    "h": 50.7020530700684,
    "CMY_C": 0,
    "CMY_M": 0.24402725696564,
    "CMY_Y": 0.36307150125504,
    "CMYK_C": 0,
    "CMYK_M": 0.24402725696564,
    "CMYK_Y": 0.36307150125504,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0219",
    "Farbtonhilfsbezeichnung": "55.3 Pelikan 3",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "218",
    "Bcolor": "201",
    "Y": 75,
    "L": 89.5446472167969,
    "a": 10.5980367660523,
    "b": 12.192834854126,
    "C": 16.1549873352051,
    "h": 49.0027656555176,
    "CMY_C": 0.00235515832901,
    "CMY_M": 0.14637953042984,
    "CMY_Y": 0.21252620220184,
    "CMYK_C": 0,
    "CMYK_M": 0.14436437189579,
    "CMYK_Y": 0.21066719293594,
    "CMYK_K": 0.00235515832901
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0220",
    "Farbtonhilfsbezeichnung": "55.4 Pelikan 4",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "227",
    "Bcolor": "214",
    "Y": 80,
    "L": 91.5170211791992,
    "a": 5.58963871002197,
    "b": 7.95178890228271,
    "C": 9.71982574462891,
    "h": 54.8950424194336,
    "CMY_C": 0.02751445770264,
    "CMY_M": 0.11066794395447,
    "CMY_Y": 0.16049110889435,
    "CMYK_C": 0,
    "CMYK_M": 0.08550614118576,
    "CMYK_Y": 0.13673895597458,
    "CMYK_K": 0.02751445770264
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0221",
    "Farbtonhilfsbezeichnung": "56.1 Flamingo 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "162",
    "Bcolor": "134",
    "Y": 49,
    "L": 75.225456237793,
    "a": 32.1061935424805,
    "b": 27.9300422668457,
    "C": 42.5546112060547,
    "h": 41.0208854675293,
    "CMY_C": 0.00056821107864,
    "CMY_M": 0.36656582355499,
    "CMY_Y": 0.47273242473602,
    "CMYK_C": 0,
    "CMYK_M": 0.36620569229126,
    "CMYK_Y": 0.47243264317513,
    "CMYK_K": 0.00056821107864
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0222",
    "Farbtonhilfsbezeichnung": "56.2 Flamingo 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "172",
    "Y": 64,
    "L": 83.9713363647461,
    "a": 21.2337951660156,
    "b": 19.5353984832764,
    "C": 28.853178024292,
    "h": 42.614501953125,
    "CMY_C": 0,
    "CMY_M": 0.23807901144028,
    "CMY_Y": 0.32401406764984,
    "CMYK_C": 0,
    "CMYK_M": 0.23807901144028,
    "CMYK_Y": 0.32401406764984,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0223",
    "Farbtonhilfsbezeichnung": "56.3 Flamingo 3",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "190",
    "Y": 71,
    "L": 87.4699249267578,
    "a": 15.6020393371582,
    "b": 15.270149230957,
    "C": 21.8311958312988,
    "h": 44.3840675354004,
    "CMY_C": 0,
    "CMY_M": 0.18324321508408,
    "CMY_Y": 0.2566664814949,
    "CMYK_C": 0,
    "CMYK_M": 0.18324321508408,
    "CMYK_Y": 0.2566664814949,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0224",
    "Farbtonhilfsbezeichnung": "56.4 Flamingo 4",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "224",
    "Bcolor": "214",
    "Y": 78,
    "L": 90.8623733520508,
    "a": 7.36383485794067,
    "b": 6.87991285324097,
    "C": 10.0776615142822,
    "h": 43.0541610717773,
    "CMY_C": 0.0249525308609,
    "CMY_M": 0.12209856510162,
    "CMY_Y": 0.15944141149521,
    "CMYK_C": 0,
    "CMYK_M": 0.0996321067214,
    "CMYK_Y": 0.13793060183525,
    "CMYK_K": 0.0249525308609
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0225",
    "Farbtonhilfsbezeichnung": "57.1 Granada 1",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "79",
    "Bcolor": "69",
    "Y": 11,
    "L": 39.9946136474609,
    "a": 22.585334777832,
    "b": 15.8687648773193,
    "C": 27.6028079986572,
    "h": 35.0924034118652,
    "CMY_C": 0.4689205288887,
    "CMY_M": 0.68905007839203,
    "CMY_Y": 0.72998178005219,
    "CMYK_C": 0,
    "CMYK_M": 0.41449454426765,
    "CMYK_Y": 0.49156719446182,
    "CMYK_K": 0.4689205288887
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0226",
    "Farbtonhilfsbezeichnung": "57.2 Granada 2",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "101",
    "Bcolor": "87",
    "Y": 19,
    "L": 50.4923286437988,
    "a": 27.6445636749268,
    "b": 20.1795406341553,
    "C": 34.2262420654297,
    "h": 36.1281051635742,
    "CMY_C": 0.32229554653168,
    "CMY_M": 0.60423743724823,
    "CMY_Y": 0.66076099872589,
    "CMYK_C": 0,
    "CMYK_M": 0.41602483391762,
    "CMYK_Y": 0.49942928552628,
    "CMYK_K": 0.32229554653168
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0227",
    "Farbtonhilfsbezeichnung": "57.3 Granada 3",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "107",
    "Bcolor": "86",
    "Y": 22,
    "L": 54.1022682189941,
    "a": 30.894021987915,
    "b": 25.5164527893066,
    "C": 40.0690650939941,
    "h": 39.5544929504395,
    "CMY_C": 0.25753581523895,
    "CMY_M": 0.57999789714813,
    "CMY_Y": 0.66199696063995,
    "CMYK_C": 0,
    "CMYK_M": 0.43431332707405,
    "CMYK_Y": 0.54475510120392,
    "CMYK_K": 0.25753581523895
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0228",
    "Farbtonhilfsbezeichnung": "57.4 Granada 4",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "121",
    "Bcolor": "101",
    "Y": 27,
    "L": 59.0602416992188,
    "a": 29.3389453887939,
    "b": 23.715991973877,
    "C": 37.7256126403809,
    "h": 38.9501724243164,
    "CMY_C": 0.21146160364151,
    "CMY_M": 0.52472245693207,
    "CMY_Y": 0.60308969020844,
    "CMYK_C": 0,
    "CMYK_M": 0.39726772904396,
    "CMYK_Y": 0.49665063619614,
    "CMYK_K": 0.21146160364151
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0229",
    "Farbtonhilfsbezeichnung": "58.1 Marrakesch 1",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "88",
    "Bcolor": "75",
    "Y": 14,
    "L": 43.3982582092285,
    "a": 22.4439392089844,
    "b": 16.7695121765137,
    "C": 28.0169048309326,
    "h": 36.7661018371582,
    "CMY_C": 0.43207192420959,
    "CMY_M": 0.65651535987854,
    "CMY_Y": 0.70499980449677,
    "CMYK_C": 0,
    "CMYK_M": 0.39519694447517,
    "CMYK_Y": 0.48056769371033,
    "CMYK_K": 0.43207192420959
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0230",
    "Farbtonhilfsbezeichnung": "58.2 Marrakesch 2",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "114",
    "Bcolor": "100",
    "Y": 22,
    "L": 54.1487045288086,
    "a": 22.5492095947266,
    "b": 17.4288673400879,
    "C": 28.4996891021729,
    "h": 37.7013626098633,
    "CMY_C": 0.31352525949478,
    "CMY_M": 0.55212235450745,
    "CMY_Y": 0.60900473594666,
    "CMYK_C": 0,
    "CMYK_M": 0.34756863117218,
    "CMYK_Y": 0.43043023347855,
    "CMYK_K": 0.31352525949478
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0231",
    "Farbtonhilfsbezeichnung": "58.3 Marrakesch 3",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "142",
    "Bcolor": "126",
    "Y": 34,
    "L": 64.1484375,
    "a": 19.2182216644287,
    "b": 16.4715461730957,
    "C": 25.3111019134521,
    "h": 40.5992050170898,
    "CMY_C": 0.223648250103,
    "CMY_M": 0.44141834974289,
    "CMY_Y": 0.50565099716187,
    "CMYK_C": 0,
    "CMYK_M": 0.28050443530083,
    "CMYK_Y": 0.36324095726013,
    "CMYK_K": 0.223648250103
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0232",
    "Farbtonhilfsbezeichnung": "58.4 Marrakesch 4",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "169",
    "Bcolor": "156",
    "Y": 34,
    "L": 72.9587936401367,
    "a": 15.3807926177979,
    "b": 12.3690595626831,
    "C": 19.7373352050781,
    "h": 38.8058471679688,
    "CMY_C": 0.15746462345123,
    "CMY_M": 0.33825808763504,
    "CMY_Y": 0.3883695602417,
    "CMYK_C": 0,
    "CMYK_M": 0.2145826369524,
    "CMYK_Y": 0.27405962347984,
    "CMYK_K": 0.15746462345123
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0233",
    "Farbtonhilfsbezeichnung": "59.1 Damaskus 1",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "77",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.5234603881836,
    "a": 32.3269996643066,
    "b": 25.3803119659424,
    "C": 41.0998191833496,
    "h": 38.1358795166016,
    "CMY_C": 0.38172382116318,
    "CMY_M": 0.69866549968719,
    "CMY_Y": 0.76625329256058,
    "CMYK_C": 0,
    "CMYK_M": 0.51262152194977,
    "CMYK_Y": 0.62193804979324,
    "CMYK_K": 0.38172382116318
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0234",
    "Farbtonhilfsbezeichnung": "59.2 Damaskus 2",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "87",
    "Bcolor": "68",
    "Y": 15,
    "L": 46.0055923461914,
    "a": 30.86962890625,
    "b": 25.0053100585938,
    "C": 39.7265586853027,
    "h": 39.0084953308105,
    "CMY_C": 0.35017073154449,
    "CMY_M": 0.65970349311829,
    "CMY_Y": 0.73305261135101,
    "CMYK_C": 0,
    "CMYK_M": 0.47632935643196,
    "CMYK_Y": 0.58920383453369,
    "CMYK_K": 0.35017073154449
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0235",
    "Farbtonhilfsbezeichnung": "59.3 Damaskus 3",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 23,
    "L": 54.8485946655273,
    "a": 27.8892555236816,
    "b": 21.8035411834717,
    "C": 35.400634765625,
    "h": 38.0179405212402,
    "CMY_C": 0.26991200447083,
    "CMY_M": 0.5621395111084,
    "CMY_Y": 0.63059437274933,
    "CMYK_C": 0,
    "CMYK_M": 0.40026339888573,
    "CMYK_Y": 0.49402588605881,
    "CMYK_K": 0.26991200447083
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0236",
    "Farbtonhilfsbezeichnung": "59.4 Damaskus 4",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "150",
    "Bcolor": "134",
    "Y": 39,
    "L": 67.9769134521484,
    "a": 22.4042167663574,
    "b": 17.6521034240723,
    "C": 28.5227222442627,
    "h": 38.2342910766602,
    "CMY_C": 0.15926742553711,
    "CMY_M": 0.41105729341507,
    "CMY_Y": 0.47497898340225,
    "CMYK_C": 0,
    "CMYK_M": 0.2994886636734,
    "CMYK_Y": 0.37551960349083,
    "CMYK_K": 0.15926742553711
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0237",
    "Farbtonhilfsbezeichnung": "60.1 Toscana 1",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "93",
    "Bcolor": "70",
    "Y": 16,
    "L": 47.0566558837891,
    "a": 27.0625305175781,
    "b": 24.9498310089111,
    "C": 36.8086204528809,
    "h": 42.6739692687988,
    "CMY_C": 0.35793226957321,
    "CMY_M": 0.63697838783264,
    "CMY_Y": 0.72414541244507,
    "CMYK_C": 0,
    "CMYK_M": 0.43460541963577,
    "CMYK_Y": 0.57036530971527,
    "CMYK_K": 0.35793226957321
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0238",
    "Farbtonhilfsbezeichnung": "60.2 Toscana 2",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "123",
    "Bcolor": "89",
    "Y": 28,
    "L": 59.0567092895508,
    "a": 26.7571887969971,
    "b": 30.5209045410156,
    "C": 40.5890731811523,
    "h": 48.7594757080078,
    "CMY_C": 0.21708399057388,
    "CMY_M": 0.51808452606201,
    "CMY_Y": 0.65082597732544,
    "CMYK_C": 0,
    "CMYK_M": 0.38446083664894,
    "CMYK_Y": 0.55400830507278,
    "CMYK_K": 0.21708399057388
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0239",
    "Farbtonhilfsbezeichnung": "60.3",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "153",
    "Bcolor": "117",
    "Y": 41,
    "L": 69.408203125,
    "a": 23.2238483428955,
    "b": 28.9109649658203,
    "C": 37.083568572998,
    "h": 51.2254829406738,
    "CMY_C": 0.11971175670624,
    "CMY_M": 0.40097278356552,
    "CMY_Y": 0.53997457027435,
    "CMYK_C": 0,
    "CMYK_M": 0.31951016187668,
    "CMYK_Y": 0.4774149954319,
    "CMYK_K": 0.11971175670624
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0240",
    "Farbtonhilfsbezeichnung": "60.4 Toscana 4",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "177",
    "Bcolor": "145",
    "Y": 52,
    "L": 76.8334426879883,
    "a": 17.5305366516113,
    "b": 24.2227745056152,
    "C": 29.90087890625,
    "h": 54.1059417724609,
    "CMY_C": 0.0761381983757,
    "CMY_M": 0.30569487810135,
    "CMY_Y": 0.43283694982529,
    "CMYK_C": 0,
    "CMYK_M": 0.24847513437271,
    "CMYK_Y": 0.38609534502029,
    "CMYK_K": 0.0761381983757
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0241",
    "Farbtonhilfsbezeichnung": "61.1 Florenz 1",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "105",
    "Bcolor": "66",
    "Y": 19,
    "L": 50.9755058288574,
    "a": 23.6996288299561,
    "b": 32.4741592407227,
    "C": 40.2025299072266,
    "h": 53.878044128418,
    "CMY_C": 0.32354766130447,
    "CMY_M": 0.58970630168915,
    "CMY_Y": 0.74069225788116,
    "CMYK_C": 0,
    "CMYK_M": 0.39346250891685,
    "CMYK_Y": 0.61666518449783,
    "CMYK_K": 0.32354766130447
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0242",
    "Farbtonhilfsbezeichnung": "61.2 Florenz 2",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "119",
    "Bcolor": "76",
    "Y": 24,
    "L": 56.3019065856934,
    "a": 22.3122406005859,
    "b": 33.9640846252441,
    "C": 40.6373596191406,
    "h": 56.6976356506348,
    "CMY_C": 0.26902681589127,
    "CMY_M": 0.53312766551971,
    "CMY_Y": 0.70230412483215,
    "CMYK_C": 0,
    "CMYK_M": 0.36130031943321,
    "CMYK_Y": 0.59274035692215,
    "CMYK_K": 0.26902681589127
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0243",
    "Farbtonhilfsbezeichnung": "61.3 Florenz 3",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "139",
    "Bcolor": "97",
    "Y": 32,
    "L": 63.1295585632324,
    "a": 19.3940048217773,
    "b": 31.3666687011719,
    "C": 36.8781127929688,
    "h": 58.2715072631836,
    "CMY_C": 0.21074646711349,
    "CMY_M": 0.45540362596512,
    "CMY_Y": 0.61973428726196,
    "CMYK_C": 0,
    "CMYK_M": 0.30998551845551,
    "CMYK_Y": 0.51819574832916,
    "CMYK_K": 0.21074646711349
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0244",
    "Farbtonhilfsbezeichnung": "61.4 Florenz 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "172",
    "Bcolor": "141",
    "Y": 47,
    "L": 74.0993347167969,
    "a": 13.9059114456177,
    "b": 21.9514274597168,
    "C": 25.985372543335,
    "h": 57.6463317871094,
    "CMY_C": 0.13446754217148,
    "CMY_M": 0.3245512843132,
    "CMY_Y": 0.44510453939438,
    "CMYK_C": 0,
    "CMYK_M": 0.21961480379105,
    "CMYK_Y": 0.35889700055122,
    "CMYK_K": 0.13446754217148
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0245",
    "Farbtonhilfsbezeichnung": "62.1 Apulien 1",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "125",
    "Bcolor": "72",
    "Y": 27,
    "L": 58.1909637451172,
    "a": 20.9809665679932,
    "b": 38.4167709350586,
    "C": 43.7727012634277,
    "h": 61.359245300293,
    "CMY_C": 0.2499897480011,
    "CMY_M": 0.51107132434845,
    "CMY_Y": 0.71725606918335,
    "CMYK_C": 0,
    "CMYK_M": 0.34810400009155,
    "CMYK_Y": 0.62301325798035,
    "CMYK_K": 0.2499897480011
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0246",
    "Farbtonhilfsbezeichnung": "62.2 Apulien 2",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "133",
    "Bcolor": "78",
    "Y": 30,
    "L": 61.0111770629883,
    "a": 19.9979305267334,
    "b": 39.0577163696289,
    "C": 43.8796348571777,
    "h": 62.8871078491211,
    "CMY_C": 0.22234499454498,
    "CMY_M": 0.47992545366287,
    "CMY_Y": 0.6956068277359,
    "CMYK_C": 0,
    "CMYK_M": 0.33122715353966,
    "CMYK_Y": 0.60857558250427,
    "CMYK_K": 0.22234499454498
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0247",
    "Farbtonhilfsbezeichnung": "62.3 Apulien 3",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "147",
    "Bcolor": "98",
    "Y": 35,
    "L": 65.6752166748047,
    "a": 17.2971858978271,
    "b": 34.2597007751465,
    "C": 38.3786354064941,
    "h": 63.2115097045898,
    "CMY_C": 0.18998450040817,
    "CMY_M": 0.42402505874634,
    "CMY_Y": 0.61645793914795,
    "CMYK_C": 0,
    "CMYK_M": 0.28893342614174,
    "CMYK_Y": 0.52650034427643,
    "CMYK_K": 0.18998450040817
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0248",
    "Farbtonhilfsbezeichnung": "62.4 Apulien 4",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "181",
    "Bcolor": "140",
    "Y": 52,
    "L": 77.0161285400391,
    "a": 12.0657920837402,
    "b": 26.5915641784668,
    "C": 29.2009353637695,
    "h": 65.5940628051758,
    "CMY_C": 0.10437101125717,
    "CMY_M": 0.28971552848816,
    "CMY_Y": 0.44926744699478,
    "CMYK_C": 0,
    "CMYK_M": 0.20694340765476,
    "CMYK_Y": 0.38508850336075,
    "CMYK_K": 0.10437101125717
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0249",
    "Farbtonhilfsbezeichnung": "63.1 Orvieto 1",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "128",
    "Bcolor": "68",
    "Y": 28,
    "L": 59.8896369934082,
    "a": 21.882568359375,
    "b": 42.6494407653809,
    "C": 47.9356002807617,
    "h": 62.8385543823242,
    "CMY_C": 0.22122794389725,
    "CMY_M": 0.49715328216553,
    "CMY_Y": 0.73266303539276,
    "CMYK_C": 0,
    "CMYK_M": 0.3543082177639,
    "CMYK_Y": 0.65671986341476,
    "CMYK_K": 0.22122794389725
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0250",
    "Farbtonhilfsbezeichnung": "63.2 Orvieto 2",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "165",
    "Bcolor": "98",
    "Y": 43,
    "L": 72.6765594482422,
    "a": 16.9248447418213,
    "b": 43.2555961608887,
    "C": 46.4488639831543,
    "h": 68.6308212280273,
    "CMY_C": 0.09957867860794,
    "CMY_M": 0.35160887241364,
    "CMY_Y": 0.61505001783371,
    "CMYK_C": 0,
    "CMYK_M": 0.27990251779556,
    "CMYK_Y": 0.57247793674469,
    "CMYK_K": 0.09957867860794
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0251",
    "Farbtonhilfsbezeichnung": "63.3 Orvieto 3",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "189",
    "Bcolor": "127",
    "Y": 57,
    "L": 80.1131896972656,
    "a": 11.9472532272339,
    "b": 38.0585250854492,
    "C": 39.8897018432617,
    "h": 72.5719909667969,
    "CMY_C": 0.05011343955994,
    "CMY_M": 0.25840890407562,
    "CMY_Y": 0.50265276432037,
    "CMYK_C": 0,
    "CMYK_M": 0.21928456425667,
    "CMYK_Y": 0.47641408443451,
    "CMYK_K": 0.05011343955994
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0252",
    "Farbtonhilfsbezeichnung": "63.4 Orvieto 4",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "206",
    "Bcolor": "152",
    "Y": 66,
    "L": 85.1909942626953,
    "a": 7.91392183303833,
    "b": 31.8173637390137,
    "C": 32.786808013916,
    "h": 76.0322799682617,
    "CMY_C": 0.02774357795715,
    "CMY_M": 0.19183802604675,
    "CMY_Y": 0.40467011928558,
    "CMYK_C": 0,
    "CMYK_M": 0.16877692937851,
    "CMYK_Y": 0.38768222928047,
    "CMYK_K": 0.02774357795715
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0253",
    "Farbtonhilfsbezeichnung": "64.1 Pfeffer 1",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "77",
    "Bcolor": "70",
    "Y": 8,
    "L": 33.9783668518066,
    "a": 4.25814342498779,
    "b": 5.84622049331665,
    "C": 7.23257064819336,
    "h": 53.9319648742676,
    "CMY_C": 0.64581739902496,
    "CMY_M": 0.69647794961929,
    "CMY_Y": 0.72461628913879,
    "CMYK_C": 0,
    "CMYK_M": 0.14303511381149,
    "CMYK_Y": 0.22248096764088,
    "CMYK_K": 0.64581739902496
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0254",
    "Farbtonhilfsbezeichnung": "64.2 Pfeffer 2",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "95",
    "Bcolor": "82",
    "Y": 12,
    "L": 41.5285034179688,
    "a": 5.06660509109497,
    "b": 9.25936317443848,
    "C": 10.5549182891846,
    "h": 61.3130836486816,
    "CMY_C": 0.56072944402695,
    "CMY_M": 0.62845480442047,
    "CMY_Y": 0.67714965343475,
    "CMYK_C": 0,
    "CMYK_M": 0.15417687594891,
    "CMYK_Y": 0.26503077149391,
    "CMYK_K": 0.56072944402695
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0255",
    "Farbtonhilfsbezeichnung": "64.3 Pfeffer 3",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "112",
    "Bcolor": "95",
    "Y": 18,
    "L": 48.9513168334961,
    "a": 6.24777126312256,
    "b": 12.0699634552002,
    "C": 13.5911245346069,
    "h": 62.6325759887695,
    "CMY_C": 0.47316998243332,
    "CMY_M": 0.56013369560242,
    "CMY_Y": 0.62578463554382,
    "CMYK_C": 0,
    "CMYK_M": 0.16506977379322,
    "CMYK_Y": 0.28968480229378,
    "CMYK_K": 0.47316998243332
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0256",
    "Farbtonhilfsbezeichnung": "64.4 Pfeffer 4",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "125",
    "Bcolor": "106",
    "Y": 22,
    "L": 53.8801460266113,
    "a": 5.86483383178711,
    "b": 13.1789321899414,
    "C": 14.4249963760376,
    "h": 66.0101776123047,
    "CMY_C": 0.42241245508194,
    "CMY_M": 0.5108078122139,
    "CMY_Y": 0.58612501621246,
    "CMYK_C": 0,
    "CMYK_M": 0.15304234623909,
    "CMYK_Y": 0.28344199061394,
    "CMYK_K": 0.42241245508194
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0257",
    "Farbtonhilfsbezeichnung": "65.1 Kardamom 1",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "85",
    "Bcolor": "71",
    "Y": 10,
    "L": 37.9183502197266,
    "a": 6.059241771698,
    "b": 11.2185983657837,
    "C": 12.7503471374512,
    "h": 61.6262168884277,
    "CMY_C": 0.58665597438812,
    "CMY_M": 0.66503816843033,
    "CMY_Y": 0.72228920459747,
    "CMYK_C": 0,
    "CMYK_M": 0.18962943553925,
    "CMYK_Y": 0.32813641428947,
    "CMYK_K": 0.58665597438812
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0258",
    "Farbtonhilfsbezeichnung": "65.2 Kardamom 2",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "112",
    "Bcolor": "98",
    "Y": 17,
    "L": 48.711727142334,
    "a": 5.45100879669189,
    "b": 9.86748504638672,
    "C": 11.2730102539063,
    "h": 61.0828056335449,
    "CMY_C": 0.48512655496597,
    "CMY_M": 0.56018936634064,
    "CMY_Y": 0.61372792720795,
    "CMYK_C": 0,
    "CMYK_M": 0.14578886330128,
    "CMYK_Y": 0.24977278709412,
    "CMYK_K": 0.48512655496597
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0259",
    "Farbtonhilfsbezeichnung": "65.3 Kardamom 3",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "135",
    "Bcolor": "123",
    "Y": 26,
    "L": 57.561580657959,
    "a": 4.50671291351318,
    "b": 8.41418647766113,
    "C": 9.54510307312012,
    "h": 61.826099395752,
    "CMY_C": 0.40359848737717,
    "CMY_M": 0.46965229511261,
    "CMY_Y": 0.51835834980011,
    "CMYK_C": 0,
    "CMYK_M": 0.11075392365456,
    "CMYK_Y": 0.19242046773434,
    "CMYK_K": 0.40359848737717
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0260",
    "Farbtonhilfsbezeichnung": "65.4 Kardamom 4",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "158",
    "Bcolor": "146",
    "Y": 35,
    "L": 66.0680694580078,
    "a": 3.97756814956665,
    "b": 7.49748468399048,
    "C": 8.48724460601807,
    "h": 62.0531425476074,
    "CMY_C": 0.32012289762497,
    "CMY_M": 0.38093847036362,
    "CMY_Y": 0.42674326896667,
    "CMYK_C": 0,
    "CMYK_M": 0.08945082873106,
    "CMYK_Y": 0.15682300925255,
    "CMYK_K": 0.32012289762497
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0261",
    "Farbtonhilfsbezeichnung": "66.1 Kastanie 1",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "96",
    "Bcolor": "73",
    "Y": 14,
    "L": 44.5168304443359,
    "a": 14.7225723266602,
    "b": 19.6071090698242,
    "C": 24.5192337036133,
    "h": 53.0978736877441,
    "CMY_C": 0.45758616924286,
    "CMY_M": 0.62511837482452,
    "CMY_Y": 0.71480077505112,
    "CMYK_C": 0,
    "CMYK_M": 0.30886417627335,
    "CMYK_Y": 0.47420361638069,
    "CMYK_K": 0.45758616924286
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0262",
    "Farbtonhilfsbezeichnung": "66.2 Kastanie 2",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "121",
    "Bcolor": "99",
    "Y": 22,
    "L": 54.2216033935547,
    "a": 13.1914253234863,
    "b": 17.4209709167481,
    "C": 21.851863861084,
    "h": 52.8664398193359,
    "CMY_C": 0.36641669273376,
    "CMY_M": 0.52605140209198,
    "CMY_Y": 0.61004507541656,
    "CMYK_C": 0,
    "CMYK_M": 0.25195536017418,
    "CMYK_Y": 0.38452461361885,
    "CMYK_K": 0.36641669273376
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0263",
    "Farbtonhilfsbezeichnung": "66.3 Kastanie 3",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "142",
    "Bcolor": "123",
    "Y": 30,
    "L": 61.948184967041,
    "a": 11.4505386352539,
    "b": 14.9527959823608,
    "C": 18.8335056304932,
    "h": 52.5558624267578,
    "CMY_C": 0.2982611656189,
    "CMY_M": 0.44319957494736,
    "CMY_Y": 0.51840555667877,
    "CMYK_C": 0,
    "CMYK_M": 0.20654180645943,
    "CMYK_Y": 0.3137127161026,
    "CMYK_K": 0.2982611656189
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0264",
    "Farbtonhilfsbezeichnung": "66.4 Kastanie 4",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "164",
    "Bcolor": "146",
    "Y": 40,
    "L": 69.5146026611328,
    "a": 8.66706848144531,
    "b": 12.4619235992432,
    "C": 15.1795129776001,
    "h": 55.1820030212402,
    "CMY_C": 0.23920285701752,
    "CMY_M": 0.35737127065659,
    "CMY_Y": 0.42549175024033,
    "CMYK_C": 0,
    "CMYK_M": 0.15532183647156,
    "CMYK_Y": 0.24486014246941,
    "CMYK_K": 0.23920285701752
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0265",
    "Farbtonhilfsbezeichnung": "67.1 Mandel 1",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "82",
    "Bcolor": "70",
    "Y": 10,
    "L": 37.5078468322754,
    "a": 10.2937622070313,
    "b": 11.4973154067993,
    "C": 15.4321031570435,
    "h": 48.1613159179688,
    "CMY_C": 0.56637793779373,
    "CMY_M": 0.67865228652954,
    "CMY_Y": 0.72703850269318,
    "CMYK_C": 0,
    "CMYK_M": 0.25892212986946,
    "CMYK_Y": 0.37050828337669,
    "CMYK_K": 0.56637793779373
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0266",
    "Farbtonhilfsbezeichnung": "67.2 Mandel 2",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "91",
    "Bcolor": "73",
    "Y": 13,
    "L": 42.002628326416,
    "a": 12.1226892471313,
    "b": 15.8509216308594,
    "C": 19.9552326202393,
    "h": 52.5914611816406,
    "CMY_C": 0.50362241268158,
    "CMY_M": 0.64176976680756,
    "CMY_Y": 0.71378231048584,
    "CMYK_C": 0,
    "CMYK_M": 0.27831101417542,
    "CMYK_Y": 0.42338716983795,
    "CMYK_K": 0.50362241268158
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0267",
    "Farbtonhilfsbezeichnung": "67.3 Mandel 3",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "106",
    "Bcolor": "84",
    "Y": 17,
    "L": 47.8139152526855,
    "a": 11.4465236663818,
    "b": 17.4203205108643,
    "C": 20.8444347381592,
    "h": 56.6919326782227,
    "CMY_C": 0.44451385736465,
    "CMY_M": 0.58465683460236,
    "CMY_Y": 0.67076128721237,
    "CMYK_C": 0,
    "CMYK_M": 0.25228887796402,
    "CMYK_Y": 0.40729627013206,
    "CMYK_K": 0.44451385736465
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0268",
    "Farbtonhilfsbezeichnung": "67.4 Mandel 4",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "127",
    "Bcolor": "102",
    "Y": 24,
    "L": 56.2490615844727,
    "a": 12.1214065551758,
    "b": 18.7766876220703,
    "C": 22.349328994751,
    "h": 57.1554832458496,
    "CMY_C": 0.34860908985138,
    "CMY_M": 0.50338745117188,
    "CMY_Y": 0.59998667240143,
    "CMYK_C": 0,
    "CMYK_M": 0.23761209845543,
    "CMYK_Y": 0.38590896129608,
    "CMYK_K": 0.34860908985138
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0269",
    "Farbtonhilfsbezeichnung": "68.1 Kakao 1",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "101",
    "Bcolor": "73",
    "Y": 16,
    "L": 46.3909072875977,
    "a": 13.6422519683838,
    "b": 22.191333770752,
    "C": 26.0493049621582,
    "h": 58.4186363220215,
    "CMY_C": 0.44007676839828,
    "CMY_M": 0.60481238365173,
    "CMY_Y": 0.71500194072723,
    "CMYK_C": 0,
    "CMYK_M": 0.29421105980873,
    "CMYK_Y": 0.49100512266159,
    "CMYK_K": 0.44007676839828
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0270",
    "Farbtonhilfsbezeichnung": "68.2 Kakao 2",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "108",
    "Bcolor": "81",
    "Y": 18,
    "L": 48.8758277893066,
    "a": 12.642653465271,
    "b": 20.8012161254883,
    "C": 24.3418827056885,
    "h": 58.7094230651855,
    "CMY_C": 0.42123061418533,
    "CMY_M": 0.57795059680939,
    "CMY_Y": 0.68309617042542,
    "CMYK_C": 0,
    "CMYK_M": 0.27078139781952,
    "CMYK_Y": 0.45245233178139,
    "CMYK_K": 0.42123061418533
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0271",
    "Farbtonhilfsbezeichnung": "68.3 Kakao 3",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "122",
    "Bcolor": "98",
    "Y": 23,
    "L": 54.3308525085449,
    "a": 11.2484607696533,
    "b": 18.239652633667,
    "C": 21.4292507171631,
    "h": 58.3377113342285,
    "CMY_C": 0.37530279159546,
    "CMY_M": 0.52025318145752,
    "CMY_Y": 0.61488038301468,
    "CMYK_C": 0,
    "CMYK_M": 0.23203302919865,
    "CMYK_Y": 0.38350993394852,
    "CMYK_K": 0.37530279159546
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0272",
    "Farbtonhilfsbezeichnung": "68.4 Kakao 4",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "165",
    "Bcolor": "146",
    "Y": 40,
    "L": 69.1764221191406,
    "a": 5.74866104125977,
    "b": 12.1128091812134,
    "C": 13.4077310562134,
    "h": 64.6112899780273,
    "CMY_C": 0.26317346096039,
    "CMY_M": 0.35375940799713,
    "CMY_Y": 0.42696523666382,
    "CMYK_C": 0,
    "CMYK_M": 0.12294066697359,
    "CMYK_Y": 0.22229354083538,
    "CMYK_K": 0.26317346096039
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0273",
    "Farbtonhilfsbezeichnung": "69.1 Piment 1",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "106",
    "Bcolor": "81",
    "Y": 16,
    "L": 47.1469078063965,
    "a": 8.67823791503906,
    "b": 18.0360698699951,
    "C": 20.0152854919434,
    "h": 64.3049926757813,
    "CMY_C": 0.46639829874039,
    "CMY_M": 0.58455526828766,
    "CMY_Y": 0.68152952194214,
    "CMYK_C": 0,
    "CMYK_M": 0.22143289446831,
    "CMYK_Y": 0.40316817164421,
    "CMYK_K": 0.46639829874039
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0274",
    "Farbtonhilfsbezeichnung": "69.2 Piment 2",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "124",
    "Bcolor": "95",
    "Y": 23,
    "L": 54.6774444580078,
    "a": 10.2258710861206,
    "b": 20.4828929901123,
    "C": 22.8936100006104,
    "h": 63.4698143005371,
    "CMY_C": 0.37384152412415,
    "CMY_M": 0.51472151279449,
    "CMY_Y": 0.62696135044098,
    "CMYK_C": 0,
    "CMYK_M": 0.22499094903469,
    "CMYK_Y": 0.404242426157,
    "CMYK_K": 0.37384152412415
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0275",
    "Farbtonhilfsbezeichnung": "69.3 Piment 3",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "138",
    "Bcolor": "107",
    "Y": 29,
    "L": 60.3681259155273,
    "a": 10.5796756744385,
    "b": 21.4548110961914,
    "C": 23.9215068817139,
    "h": 63.7514266967773,
    "CMY_C": 0.30862122774124,
    "CMY_M": 0.45850443840027,
    "CMY_Y": 0.57886064052582,
    "CMYK_C": 0,
    "CMYK_M": 0.21678885817528,
    "CMYK_Y": 0.39087027311325,
    "CMYK_K": 0.30862122774124
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0276",
    "Farbtonhilfsbezeichnung": "69.4 Piment 4",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "150",
    "Bcolor": "126",
    "Y": 33,
    "L": 64.4650497436523,
    "a": 8.41043376922607,
    "b": 16.6475448608398,
    "C": 18.6514377593994,
    "h": 63.1968383789063,
    "CMY_C": 0.2867072224617,
    "CMY_M": 0.41021281480789,
    "CMY_Y": 0.50566589832306,
    "CMYK_C": 0,
    "CMYK_M": 0.17314852774143,
    "CMYK_Y": 0.30696886777878,
    "CMYK_K": 0.2867072224617
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0277",
    "Farbtonhilfsbezeichnung": "70.1 Macadamia 1",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "112",
    "Bcolor": "83",
    "Y": 19,
    "L": 49.8355331420898,
    "a": 9.92072105407715,
    "b": 20.6996917724609,
    "C": 22.9542579650879,
    "h": 64.3930435180664,
    "CMY_C": 0.4267680644989,
    "CMY_M": 0.5618417263031,
    "CMY_Y": 0.67405444383621,
    "CMYK_C": 0,
    "CMYK_M": 0.23563526570797,
    "CMYK_Y": 0.43138974905014,
    "CMYK_K": 0.4267680644989
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0278",
    "Farbtonhilfsbezeichnung": "70.2 Macadamia 2",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "134",
    "Bcolor": "98",
    "Y": 27,
    "L": 58.8652725219727,
    "a": 11.1641321182251,
    "b": 24.4568595886231,
    "C": 26.8844909667969,
    "h": 65.4641265869141,
    "CMY_C": 0.31649881601334,
    "CMY_M": 0.47576862573624,
    "CMY_Y": 0.61404800415039,
    "CMYK_C": 0,
    "CMYK_M": 0.23302052915096,
    "CMYK_Y": 0.43533089756966,
    "CMYK_K": 0.31649881601334
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0279",
    "Farbtonhilfsbezeichnung": "70.3 Macadamia 3",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "163",
    "Bcolor": "126",
    "Y": 40,
    "L": 69.3971252441406,
    "a": 8.82981395721436,
    "b": 23.499137878418,
    "C": 25.1032886505127,
    "h": 69.4062652587891,
    "CMY_C": 0.21652919054031,
    "CMY_M": 0.36143386363983,
    "CMY_Y": 0.50457727909088,
    "CMYK_C": 0,
    "CMYK_M": 0.1849522292614,
    "CMYK_Y": 0.36765643954277,
    "CMYK_K": 0.21652919054031
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0280",
    "Farbtonhilfsbezeichnung": "70.4 Macadamia 4",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "178",
    "Bcolor": "146",
    "Y": 48,
    "L": 74.5624923706055,
    "a": 7.39647197723389,
    "b": 20.1020011901856,
    "C": 21.4195766448975,
    "h": 69.7990570068359,
    "CMY_C": 0.17511743307114,
    "CMY_M": 0.3026904463768,
    "CMY_Y": 0.42834544181824,
    "CMYK_C": 0,
    "CMYK_M": 0.15465596318245,
    "CMYK_Y": 0.30698674917221,
    "CMYK_K": 0.17511743307114
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0281",
    "Farbtonhilfsbezeichnung": "71.1 Gelb 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "156",
    "Bcolor": "43",
    "Y": 46,
    "L": 73.2631530761719,
    "a": 30.7353115081787,
    "b": 69.0697631835938,
    "C": 75.5995483398438,
    "h": 66.0114440917969,
    "CMY_C": 0,
    "CMY_M": 0.38944268226624,
    "CMY_Y": 0.83236372470856,
    "CMYK_C": 0,
    "CMYK_M": 0.38944268226624,
    "CMYK_Y": 0.83236372470856,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0282",
    "Farbtonhilfsbezeichnung": "71.2 Gelb 2",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "165",
    "Bcolor": "17",
    "Y": 49,
    "L": 75.5990219116211,
    "a": 26.3048057556152,
    "b": 77.1832809448242,
    "C": 81.5426406860352,
    "h": 71.1803894042969,
    "CMY_C": 0,
    "CMY_M": 0.35185390710831,
    "CMY_Y": 0.93205934762955,
    "CMYK_C": 0,
    "CMYK_M": 0.35185390710831,
    "CMYK_Y": 0.93205934762955,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0283",
    "Farbtonhilfsbezeichnung": "71.3 Gelb 3",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "188",
    "Bcolor": "38",
    "Y": 58,
    "L": 81.0283050537109,
    "a": 15.9409332275391,
    "b": 77.1471939086914,
    "C": 78.7769165039063,
    "h": 78.3252716064453,
    "CMY_C": 0,
    "CMY_M": 0.2643837928772,
    "CMY_Y": 0.8524979352951,
    "CMYK_C": 0,
    "CMYK_M": 0.2643837928772,
    "CMYK_Y": 0.8524979352951,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0284",
    "Farbtonhilfsbezeichnung": "71.4 Gelb 4",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "205",
    "Bcolor": "17",
    "Y": 67,
    "L": 85.3638687133789,
    "a": 6.79489374160767,
    "b": 84.3735427856445,
    "C": 84.6467056274414,
    "h": 85.3957138061523,
    "CMY_C": 0,
    "CMY_M": 0.19418877363205,
    "CMY_Y": 0.93428415060043,
    "CMYK_C": 0,
    "CMYK_M": 0.19418877363205,
    "CMYK_Y": 0.93428415060043,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0285",
    "Farbtonhilfsbezeichnung": "72.1 Gelb 5",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "175",
    "Bcolor": "0",
    "Y": 53,
    "L": 77.905029296875,
    "a": 21.1034545898438,
    "b": 80.9621887207031,
    "C": 83.6673889160156,
    "h": 75.3904647827148,
    "CMY_C": 0,
    "CMY_M": 0.31244248151779,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.31244248151779,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0286",
    "Farbtonhilfsbezeichnung": "72.2 Gelb 6",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "10",
    "Y": 57,
    "L": 79.5392990112305,
    "a": 18.3471240997314,
    "b": 80.914909362793,
    "C": 82.9689102172852,
    "h": 77.2244415283203,
    "CMY_C": 0,
    "CMY_M": 0.28726047277451,
    "CMY_Y": 0.95983076095581,
    "CMYK_C": 0,
    "CMYK_M": 0.28726047277451,
    "CMYK_Y": 0.95983076095581,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0287",
    "Farbtonhilfsbezeichnung": "72.3 Gelb 7",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "199",
    "Bcolor": "0",
    "Y": 64,
    "L": 83.7120132446289,
    "a": 9.44912719726563,
    "b": 87.2049407958984,
    "C": 87.7153778076172,
    "h": 83.8158187866211,
    "CMY_C": 0,
    "CMY_M": 0.21908110380173,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.21908110380173,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0288",
    "Farbtonhilfsbezeichnung": "72.4 Gelb 8",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "37",
    "Y": 72,
    "L": 87.8881530761719,
    "a": -2.70051622390747,
    "b": 82.5724868774414,
    "C": 82.6166381835938,
    "h": 91.8731842041016,
    "CMY_C": 0,
    "CMY_M": 0.14329290390015,
    "CMY_Y": 0.85582649707794,
    "CMYK_C": 0,
    "CMYK_M": 0.14329290390015,
    "CMYK_Y": 0.85582649707794,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0289",
    "Farbtonhilfsbezeichnung": "73.1 Gelb 9",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "5",
    "Y": 55,
    "L": 78.8762588500977,
    "a": 15.8844976425171,
    "b": 80.7141876220703,
    "C": 82.2623672485352,
    "h": 78.8665084838867,
    "CMY_C": 0,
    "CMY_M": 0.28749370574951,
    "CMY_Y": 0.98127609491348,
    "CMYK_C": 0,
    "CMYK_M": 0.28749370574951,
    "CMYK_Y": 0.98127609491348,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0290",
    "Farbtonhilfsbezeichnung": "73.2 Gelb 10",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "197",
    "Bcolor": "43",
    "Y": 63,
    "L": 82.5947799682617,
    "a": 7.89740753173828,
    "b": 76.7461090087891,
    "C": 77.1513748168945,
    "h": 84.1247711181641,
    "CMY_C": 0.00193446874619,
    "CMY_M": 0.22629636526108,
    "CMY_Y": 0.8321830034256,
    "CMYK_C": 0,
    "CMYK_M": 0.22479675710201,
    "CMYK_Y": 0.83185774087906,
    "CMYK_K": 0.00193446874619
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0291",
    "Farbtonhilfsbezeichnung": "73.3 Gelb 11",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "45",
    "Y": 62,
    "L": 82.5182418823242,
    "a": 3.73299551010132,
    "b": 75.7644882202148,
    "C": 75.8563995361328,
    "h": 87.1792602539063,
    "CMY_C": 0.02920269966125,
    "CMY_M": 0.21662533283234,
    "CMY_Y": 0.82311546802521,
    "CMYK_C": 0,
    "CMYK_M": 0.1930605173111,
    "CMYK_Y": 0.81779456138611,
    "CMYK_K": 0.02920269966125
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0292",
    "Farbtonhilfsbezeichnung": "73.4 Gelb 12",
    "Farbtonklasse": "04",
    "Rcolor": "249",
    "Gcolor": "207",
    "Bcolor": "65",
    "Y": 66,
    "L": 84.5435180664063,
    "a": 1.10449576377869,
    "b": 71.04833984375,
    "C": 71.0569229125977,
    "h": 89.1093673706055,
    "CMY_C": 0.02529329061508,
    "CMY_M": 0.18783581256866,
    "CMY_Y": 0.74327337741852,
    "CMYK_C": 0,
    "CMYK_M": 0.16676044464111,
    "CMYK_Y": 0.73661142587662,
    "CMYK_K": 0.02529329061508
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0293",
    "Farbtonhilfsbezeichnung": "74.1 Mispel 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "60",
    "Y": 57,
    "L": 80.3196640014648,
    "a": 21.7107105255127,
    "b": 69.7120590209961,
    "C": 73.0145645141602,
    "h": 72.7016296386719,
    "CMY_C": 0,
    "CMY_M": 0.287453353405,
    "CMY_Y": 0.76446616649628,
    "CMYK_C": 0,
    "CMYK_M": 0.287453353405,
    "CMYK_Y": 0.76446616649628,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0294",
    "Farbtonhilfsbezeichnung": "74.2 Mispel 2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "86",
    "Y": 60,
    "L": 81.9644393920898,
    "a": 18.8777923583984,
    "b": 60.7664985656738,
    "C": 63.6312675476074,
    "h": 72.7420043945313,
    "CMY_C": 0,
    "CMY_M": 0.26070863008499,
    "CMY_Y": 0.66342115402222,
    "CMYK_C": 0,
    "CMYK_M": 0.26070863008499,
    "CMYK_Y": 0.66342115402222,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0295",
    "Farbtonhilfsbezeichnung": "74.3 Mispel 3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "110",
    "Y": 65,
    "L": 83.9305114746094,
    "a": 15.6846513748169,
    "b": 51.9148216247559,
    "C": 54.2324333190918,
    "h": 73.1892318725586,
    "CMY_C": 0,
    "CMY_M": 0.22943449020386,
    "CMY_Y": 0.57050895690918,
    "CMYK_C": 0,
    "CMYK_M": 0.22943449020386,
    "CMYK_Y": 0.57050895690918,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0296",
    "Farbtonhilfsbezeichnung": "74.4 Mispel 4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "138",
    "Y": 69,
    "L": 86.1820297241211,
    "a": 11.8114633560181,
    "b": 40.6556129455566,
    "C": 42.3366203308105,
    "h": 73.8001098632813,
    "CMY_C": 0,
    "CMY_M": 0.19273233413696,
    "CMY_Y": 0.46043014526367,
    "CMYK_C": 0,
    "CMYK_M": 0.19273233413696,
    "CMYK_Y": 0.46043014526367,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0297",
    "Farbtonhilfsbezeichnung": "75.1 Quitte 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "187",
    "Bcolor": "58",
    "Y": 58,
    "L": 81.0421981811523,
    "a": 16.9654121398926,
    "b": 70.9134063720703,
    "C": 72.9145812988281,
    "h": 76.5453796386719,
    "CMY_C": 0,
    "CMY_M": 0.26645249128342,
    "CMY_Y": 0.77227461338043,
    "CMYK_C": 0,
    "CMYK_M": 0.26645249128342,
    "CMYK_Y": 0.77227461338043,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0298",
    "Farbtonhilfsbezeichnung": "75.2 Quitte 2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "82",
    "Y": 63,
    "L": 83.19580078125,
    "a": 13.1969451904297,
    "b": 63.6148071289063,
    "C": 64.9692459106445,
    "h": 78.2801742553711,
    "CMY_C": 0,
    "CMY_M": 0.23225301504135,
    "CMY_Y": 0.6785591840744,
    "CMYK_C": 0,
    "CMYK_M": 0.23225301504135,
    "CMYK_Y": 0.6785591840744,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0299",
    "Farbtonhilfsbezeichnung": "75.3 Quitte 3",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "205",
    "Bcolor": "103",
    "Y": 67,
    "L": 85.5073852539063,
    "a": 9.52085494995117,
    "b": 56.8270454406738,
    "C": 57.6190910339355,
    "h": 80.4889526367188,
    "CMY_C": 0,
    "CMY_M": 0.19666302204132,
    "CMY_Y": 0.59683638811111,
    "CMYK_C": 0,
    "CMYK_M": 0.19666302204132,
    "CMYK_Y": 0.59683638811111,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0300",
    "Farbtonhilfsbezeichnung": "75.4 Quitte 4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "212",
    "Bcolor": "125",
    "Y": 72,
    "L": 87.4191818237305,
    "a": 7.01389455795288,
    "b": 48.3700294494629,
    "C": 48.8759078979492,
    "h": 81.7493286132813,
    "CMY_C": 0,
    "CMY_M": 0.16810995340347,
    "CMY_Y": 0.50912046432495,
    "CMYK_C": 0,
    "CMYK_M": 0.16810995340347,
    "CMYK_Y": 0.50912046432495,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0301",
    "Farbtonhilfsbezeichnung": "76.1 Narcisse 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "185",
    "Bcolor": "58",
    "Y": 57,
    "L": 79.8152847290039,
    "a": 14.5850858688354,
    "b": 69.3884201049805,
    "C": 70.9047088623047,
    "h": 78.1295318603516,
    "CMY_C": 0.00160139799118,
    "CMY_M": 0.27293413877487,
    "CMY_Y": 0.77131921052933,
    "CMYK_C": 0,
    "CMYK_M": 0.27176794409752,
    "CMYK_Y": 0.77095240354538,
    "CMYK_K": 0.00160139799118
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0302",
    "Farbtonhilfsbezeichnung": "76.2 Narcisse 2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "96",
    "Y": 65,
    "L": 83.8574905395508,
    "a": 8.97468948364258,
    "b": 57.8535118103027,
    "C": 58.5454864501953,
    "h": 81.1821136474609,
    "CMY_C": 0,
    "CMY_M": 0.21332150697708,
    "CMY_Y": 0.62272536754608,
    "CMYK_C": 0,
    "CMYK_M": 0.21332150697708,
    "CMYK_Y": 0.62272536754608,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0303",
    "Farbtonhilfsbezeichnung": "76.3 Narcisse 3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "129",
    "Y": 70,
    "L": 86.6396865844727,
    "a": 6.52140760421753,
    "b": 45.243896484375,
    "C": 45.7114753723145,
    "h": 81.7979354858398,
    "CMY_C": 0,
    "CMY_M": 0.17490434646606,
    "CMY_Y": 0.49263387918472,
    "CMYK_C": 0,
    "CMYK_M": 0.17490434646606,
    "CMYK_Y": 0.49263387918472,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0304",
    "Farbtonhilfsbezeichnung": "76.4 Narcisse 4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "149",
    "Y": 76,
    "L": 89.6363525390625,
    "a": 3.80128526687622,
    "b": 39.1872596740723,
    "C": 39.3711967468262,
    "h": 84.45947265625,
    "CMY_C": 0,
    "CMY_M": 0.13410419225693,
    "CMY_Y": 0.41534858942032,
    "CMYK_C": 0,
    "CMYK_M": 0.13410419225693,
    "CMYK_Y": 0.41534858942032,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0305",
    "Farbtonhilfsbezeichnung": "77.1 Arnica 1",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "180",
    "Bcolor": "101",
    "Y": 52,
    "L": 77.0280075073242,
    "a": 11.6801013946533,
    "b": 47.2519035339355,
    "C": 48.6740913391113,
    "h": 76.1155014038086,
    "CMY_C": 0.07511848211288,
    "CMY_M": 0.29222828149796,
    "CMY_Y": 0.60440140962601,
    "CMYK_C": 0,
    "CMYK_M": 0.23474337160587,
    "CMYK_Y": 0.57227104902267,
    "CMYK_K": 0.07511848211288
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0306",
    "Farbtonhilfsbezeichnung": "77.2 Arnica 2",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "192",
    "Bcolor": "120",
    "Y": 58,
    "L": 80.855583190918,
    "a": 9.92925071716309,
    "b": 42.496509552002,
    "C": 43.6410751342773,
    "h": 76.8488464355469,
    "CMY_C": 0.04751545190811,
    "CMY_M": 0.24595296382904,
    "CMY_Y": 0.52942842245102,
    "CMYK_C": 0,
    "CMYK_M": 0.20833672583103,
    "CMYK_Y": 0.50595360994339,
    "CMYK_K": 0.04751545190811
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0307",
    "Farbtonhilfsbezeichnung": "77.3 Arnica 3",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "203",
    "Bcolor": "140",
    "Y": 64,
    "L": 84.0802154541016,
    "a": 7.6046404838562,
    "b": 36.669994354248,
    "C": 37.4502220153809,
    "h": 78.2840423583984,
    "CMY_C": 0.03402060270309,
    "CMY_M": 0.20409321784973,
    "CMY_Y": 0.45272672176361,
    "CMYK_C": 0,
    "CMYK_M": 0.17606236040592,
    "CMYK_Y": 0.43345242738724,
    "CMYK_K": 0.03402060270309
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0308",
    "Farbtonhilfsbezeichnung": "77.4 Arnica 4",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "212",
    "Bcolor": "160",
    "Y": 70,
    "L": 86.8900985717773,
    "a": 5.51006841659546,
    "b": 29.969705581665,
    "C": 30.4720211029053,
    "h": 79.5822525024414,
    "CMY_C": 0.02778613567352,
    "CMY_M": 0.16682797670364,
    "CMY_Y": 0.37364768981934,
    "CMYK_C": 0,
    "CMYK_M": 0.14301569759846,
    "CMYK_Y": 0.35574635863304,
    "CMYK_K": 0.02778613567352
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0309",
    "Farbtonhilfsbezeichnung": "78.1 Butterblume 1",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "79",
    "Y": 64,
    "L": 83.9434127807617,
    "a": 7.52284288406372,
    "b": 65.476676940918,
    "C": 65.9074249267578,
    "h": 83.4458312988281,
    "CMY_C": 0,
    "CMY_M": 0.20961970090866,
    "CMY_Y": 0.69055128097534,
    "CMYK_C": 0,
    "CMYK_M": 0.20961970090866,
    "CMYK_Y": 0.69055128097534,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0310",
    "Farbtonhilfsbezeichnung": "78.2 Butterblume 2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "97",
    "Y": 69,
    "L": 86.4195098876953,
    "a": 6.23701953887939,
    "b": 60.3997077941895,
    "C": 60.7208786010742,
    "h": 84.1043930053711,
    "CMY_C": 0,
    "CMY_M": 0.17880892753601,
    "CMY_Y": 0.61911952495575,
    "CMYK_C": 0,
    "CMYK_M": 0.17880892753601,
    "CMYK_Y": 0.61911952495575,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0311",
    "Farbtonhilfsbezeichnung": "78.3 Butterblume 3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "217",
    "Bcolor": "125",
    "Y": 73,
    "L": 88.5637817382813,
    "a": 4.29017543792725,
    "b": 49.892650604248,
    "C": 50.0767631530762,
    "h": 85.085334777832,
    "CMY_C": 0,
    "CMY_M": 0.14894241094589,
    "CMY_Y": 0.51025837659836,
    "CMYK_C": 0,
    "CMYK_M": 0.14894241094589,
    "CMYK_Y": 0.51025837659836,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0312",
    "Farbtonhilfsbezeichnung": "78.4 Butterblume 4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "223",
    "Bcolor": "148",
    "Y": 77,
    "L": 90.1106109619141,
    "a": 1.77836656570435,
    "b": 40.5340042114258,
    "C": 40.572998046875,
    "h": 87.4878463745117,
    "CMY_C": 0,
    "CMY_M": 0.1241369843483,
    "CMY_Y": 0.42128533124924,
    "CMYK_C": 0,
    "CMYK_M": 0.1241369843483,
    "CMYK_Y": 0.42128533124924,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0313",
    "Farbtonhilfsbezeichnung": "79.1 Honig 1",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "196",
    "Bcolor": "101",
    "Y": 60,
    "L": 81.8274002075195,
    "a": 7.67840242385864,
    "b": 53.2774047851563,
    "C": 53.8278694152832,
    "h": 81.7989349365234,
    "CMY_C": 0.03574335575104,
    "CMY_M": 0.23136878013611,
    "CMY_Y": 0.60570466518402,
    "CMYK_C": 0,
    "CMYK_M": 0.20287692546844,
    "CMYK_Y": 0.59108883142471,
    "CMYK_K": 0.03574335575104
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0314",
    "Farbtonhilfsbezeichnung": "79.2 Honig 2",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "207",
    "Bcolor": "123",
    "Y": 66,
    "L": 85.1951141357422,
    "a": 5.65771770477295,
    "b": 46.4908561706543,
    "C": 46.8338508605957,
    "h": 83.0614929199219,
    "CMY_C": 0.01803368330002,
    "CMY_M": 0.18873316049576,
    "CMY_Y": 0.51748085021973,
    "CMYK_C": 0,
    "CMYK_M": 0.17383435368538,
    "CMYK_Y": 0.50861942768097,
    "CMYK_K": 0.01803368330002
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0315",
    "Farbtonhilfsbezeichnung": "79.3 Honig 3",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "216",
    "Bcolor": "144",
    "Y": 72,
    "L": 87.6633911132813,
    "a": 3.24119091033936,
    "b": 38.9154319763184,
    "C": 39.0501747131348,
    "h": 85.2389373779297,
    "CMY_C": 0.01736444234848,
    "CMY_M": 0.15443509817123,
    "CMY_Y": 0.43388986587524,
    "CMYK_C": 0,
    "CMYK_M": 0.13949286937714,
    "CMYK_Y": 0.42388597130775,
    "CMYK_K": 0.01736444234848
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0316",
    "Farbtonhilfsbezeichnung": "79.4 Honig 4",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "224",
    "Bcolor": "166",
    "Y": 77,
    "L": 90.1359939575195,
    "a": 1.6190265417099,
    "b": 31.1756649017334,
    "C": 31.2176761627197,
    "h": 87.0271606445313,
    "CMY_C": 0.01464015245438,
    "CMY_M": 0.1216995716095,
    "CMY_Y": 0.34948736429214,
    "CMYK_C": 0,
    "CMYK_M": 0.10865007340908,
    "CMYK_Y": 0.33982226252556,
    "CMYK_K": 0.01464015245438
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0317",
    "Farbtonhilfsbezeichnung": "80.1 Loewenzahn 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "77",
    "Y": 68,
    "L": 85.6828689575195,
    "a": 5.14515972137451,
    "b": 68.0634536743164,
    "C": 68.2576446533203,
    "h": 85.6770324707031,
    "CMY_C": 0,
    "CMY_M": 0.18502223491669,
    "CMY_Y": 0.69777822494507,
    "CMYK_C": 0,
    "CMYK_M": 0.18502223491669,
    "CMYK_Y": 0.69777822494507,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0318",
    "Farbtonhilfsbezeichnung": "80.2 Loewenzahn 2",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "213",
    "Bcolor": "96",
    "Y": 69,
    "L": 86.4945373535156,
    "a": 1.54669976234436,
    "b": 60.7111167907715,
    "C": 60.7308158874512,
    "h": 88.5406265258789,
    "CMY_C": 0.01019489765167,
    "CMY_M": 0.16644126176834,
    "CMY_Y": 0.62285578250885,
    "CMYK_C": 0,
    "CMYK_M": 0.1578556895256,
    "CMYK_Y": 0.61897122859955,
    "CMYK_K": 0.01019489765167
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0319",
    "Farbtonhilfsbezeichnung": "80.3 Loewenzahn 3",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "101",
    "Y": 75,
    "L": 89.3365249633789,
    "a": 1.39691853523254,
    "b": 61.8073196411133,
    "C": 61.8231048583984,
    "h": 88.7052612304688,
    "CMY_C": 0,
    "CMY_M": 0.13499349355698,
    "CMY_Y": 0.60272574424744,
    "CMYK_C": 0,
    "CMYK_M": 0.13499349355698,
    "CMYK_Y": 0.60272574424744,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0320",
    "Farbtonhilfsbezeichnung": "80.4 Loewenzahn 4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "226",
    "Bcolor": "127",
    "Y": 78,
    "L": 90.7789916992188,
    "a": -0.12779271602631,
    "b": 51.6517372131348,
    "C": 51.6518936157227,
    "h": 90.1417541503906,
    "CMY_C": 0,
    "CMY_M": 0.11393964290619,
    "CMY_Y": 0.5027921795845,
    "CMYK_C": 0,
    "CMYK_M": 0.11393964290619,
    "CMYK_Y": 0.5027921795845,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0321",
    "Farbtonhilfsbezeichnung": "81.1 Raps 1",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "68",
    "Y": 74,
    "L": 88.7229537963867,
    "a": -2.42027378082275,
    "b": 74.3080978393555,
    "C": 74.3475036621094,
    "h": 91.8655090332031,
    "CMY_C": 0,
    "CMY_M": 0.13401728868484,
    "CMY_Y": 0.73245936632156,
    "CMYK_C": 0,
    "CMYK_M": 0.13401728868484,
    "CMYK_Y": 0.73245936632156,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0322",
    "Farbtonhilfsbezeichnung": "81.2 Raps 2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "223",
    "Bcolor": "90",
    "Y": 75,
    "L": 89.2573471069336,
    "a": -2.70913553237915,
    "b": 66.2568206787109,
    "C": 66.3121871948242,
    "h": 92.341423034668,
    "CMY_C": 0,
    "CMY_M": 0.12657237052917,
    "CMY_Y": 0.64544916152954,
    "CMYK_C": 0,
    "CMYK_M": 0.12657237052917,
    "CMYK_Y": 0.64544916152954,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0323",
    "Farbtonhilfsbezeichnung": "81.3 Raps 3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "120",
    "Y": 76,
    "L": 90.1602020263672,
    "a": -2.1646683216095,
    "b": 53.9696846008301,
    "C": 54.0130767822266,
    "h": 92.2968444824219,
    "CMY_C": 0.00012457370758,
    "CMY_M": 0.11627638339996,
    "CMY_Y": 0.52879452705383,
    "CMYK_C": 0,
    "CMYK_M": 0.1161662787199,
    "CMYK_Y": 0.52873581647873,
    "CMYK_K": 0.00012457370758
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0324",
    "Farbtonhilfsbezeichnung": "81.4 Raps 4",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "228",
    "Bcolor": "149",
    "Y": 78,
    "L": 91.0225982666016,
    "a": -1.14391613006592,
    "b": 41.0942993164063,
    "C": 41.1102180480957,
    "h": 91.5944976806641,
    "CMY_C": 0.00421059131622,
    "CMY_M": 0.10707867145538,
    "CMY_Y": 0.41681867837906,
    "CMYK_C": 0,
    "CMYK_M": 0.10330304503441,
    "CMYK_Y": 0.41435274481773,
    "CMYK_K": 0.00421059131622
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0325",
    "Farbtonhilfsbezeichnung": "82.1 Lemongrass 1",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "196",
    "Bcolor": "114",
    "Y": 59,
    "L": 80.3052520751953,
    "a": 2.30677843093872,
    "b": 44.6520004272461,
    "C": 44.7115478515625,
    "h": 87.0426635742188,
    "CMY_C": 0.09951740503311,
    "CMY_M": 0.23332434892654,
    "CMY_Y": 0.55377388000488,
    "CMYK_C": 0,
    "CMYK_M": 0.1485947072506,
    "CMYK_Y": 0.50445890426636,
    "CMYK_K": 0.09951740503311
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0326",
    "Farbtonhilfsbezeichnung": "82.2 Lemongrass 2",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "212",
    "Bcolor": "137",
    "Y": 68,
    "L": 85.4973373413086,
    "a": -0.88146960735321,
    "b": 39.395694732666,
    "C": 39.4055557250977,
    "h": 91.2817611694336,
    "CMY_C": 0.0694368481636,
    "CMY_M": 0.16840344667435,
    "CMY_Y": 0.46093261241913,
    "CMYK_C": 0,
    "CMYK_M": 0.10635130107403,
    "CMYK_Y": 0.42070841789246,
    "CMYK_K": 0.0694368481636
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0327",
    "Farbtonhilfsbezeichnung": "82.3 Lemongrass 3",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "223",
    "Bcolor": "167",
    "Y": 75,
    "L": 89.192008972168,
    "a": -1.33116984367371,
    "b": 29.3293685913086,
    "C": 29.359561920166,
    "h": 92.5987014770508,
    "CMY_C": 0.05013871192932,
    "CMY_M": 0.1247290968895,
    "CMY_Y": 0.34607601165771,
    "CMYK_C": 0,
    "CMYK_M": 0.07852765917778,
    "CMYK_Y": 0.31155842542648,
    "CMYK_K": 0.05013871192932
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0328",
    "Farbtonhilfsbezeichnung": "82.4 Lemongrass 4",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "230",
    "Bcolor": "184",
    "Y": 80,
    "L": 91.3147811889648,
    "a": -1.7826714515686,
    "b": 23.4606494903564,
    "C": 23.5282802581787,
    "h": 94.3452987670898,
    "CMY_C": 0.04274010658264,
    "CMY_M": 0.09883165359497,
    "CMY_Y": 0.27950769662857,
    "CMYK_C": 0,
    "CMYK_M": 0.05859594419599,
    "CMYK_Y": 0.2473388761282,
    "CMYK_K": 0.04274010658264
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0329",
    "Farbtonhilfsbezeichnung": "83.1 Limoncello 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "229",
    "Bcolor": "148",
    "Y": 80,
    "L": 91.627685546875,
    "a": -0.60067790746689,
    "b": 42.1677017211914,
    "C": 42.1719779968262,
    "h": 90.8161239624023,
    "CMY_C": 0,
    "CMY_M": 0.10183709859848,
    "CMY_Y": 0.41872847080231,
    "CMYK_C": 0,
    "CMYK_M": 0.10183709859848,
    "CMYK_Y": 0.41872847080231,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0330",
    "Farbtonhilfsbezeichnung": "83.2 Limoncello 2",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "230",
    "Bcolor": "167",
    "Y": 82,
    "L": 91.9085083007812,
    "a": -0.93443483114243,
    "b": 33.185676574707,
    "C": 33.1988296508789,
    "h": 91.6128997802734,
    "CMY_C": 0.00790876150131,
    "CMY_M": 0.09625005722046,
    "CMY_Y": 0.34660851955414,
    "CMYK_C": 0,
    "CMYK_M": 0.08904553204775,
    "CMYK_Y": 0.34139981865883,
    "CMYK_K": 0.00790876150131
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0331",
    "Farbtonhilfsbezeichnung": "83.3 Limoncello 3",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "235",
    "Bcolor": "186",
    "Y": 84,
    "L": 93.4995193481445,
    "a": -1.10862529277802,
    "b": 25.5374851226807,
    "C": 25.5615367889404,
    "h": 92.4857482910156,
    "CMY_C": 0.00787305831909,
    "CMY_M": 0.0764793753624,
    "CMY_Y": 0.27167153358459,
    "CMYK_C": 0,
    "CMYK_M": 0.06915074586868,
    "CMYK_Y": 0.26589184999466,
    "CMYK_K": 0.00787305831909
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0332",
    "Farbtonhilfsbezeichnung": "83.4 Limoncello 4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "238",
    "Bcolor": "201",
    "Y": 86,
    "L": 94.2304534912109,
    "a": -1.2322404384613,
    "b": 18.6566696166992,
    "C": 18.6973190307617,
    "h": 93.7788009643555,
    "CMY_C": 0.01770943403244,
    "CMY_M": 0.06643015146255,
    "CMY_Y": 0.21195870637894,
    "CMYK_C": 0,
    "CMYK_M": 0.04959908872843,
    "CMYK_Y": 0.19775134325027,
    "CMYK_K": 0.01770943403244
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0333",
    "Farbtonhilfsbezeichnung": "84.1 Vanilla 1",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "221",
    "Bcolor": "137",
    "Y": 75,
    "L": 89.3072662353516,
    "a": 1.01343607902527,
    "b": 44.8061408996582,
    "C": 44.8176002502441,
    "h": 88.7042846679688,
    "CMY_C": 0.00308257341385,
    "CMY_M": 0.13190048933029,
    "CMY_Y": 0.46312171220779,
    "CMYK_C": 0,
    "CMYK_M": 0.12921623885632,
    "CMYK_Y": 0.46146163344383,
    "CMYK_K": 0.00308257341385
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0334",
    "Farbtonhilfsbezeichnung": "84.2 Vanilla 2",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "228",
    "Bcolor": "154",
    "Y": 79,
    "L": 91.536750793457,
    "a": 0.1747100353241,
    "b": 39.2302360534668,
    "C": 39.2306251525879,
    "h": 89.7448425292969,
    "CMY_C": 0,
    "CMY_M": 0.10419076681137,
    "CMY_Y": 0.39668136835098,
    "CMYK_C": 0,
    "CMYK_M": 0.10419076681137,
    "CMYK_Y": 0.39668136835098,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0335",
    "Farbtonhilfsbezeichnung": "84.3 Vanilla 3",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "227",
    "Bcolor": "172",
    "Y": 78,
    "L": 90.336799621582,
    "a": -2.00566697120667,
    "b": 28.10666847229,
    "C": 28.1781387329102,
    "h": 94.081657409668,
    "CMY_C": 0.04459065198898,
    "CMY_M": 0.11018252372742,
    "CMY_Y": 0.32490503787994,
    "CMYK_C": 0,
    "CMYK_M": 0.06865315884352,
    "CMYK_Y": 0.29339715838432,
    "CMYK_K": 0.04459065198898
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0336",
    "Farbtonhilfsbezeichnung": "84.4 Vanilla 4",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "238",
    "Bcolor": "209",
    "Y": 85,
    "L": 94.1703491210938,
    "a": -1.3210437297821,
    "b": 14.4733371734619,
    "C": 14.5335006713867,
    "h": 95.2151794433594,
    "CMY_C": 0.03052365779877,
    "CMY_M": 0.06588190793991,
    "CMY_Y": 0.18122506141663,
    "CMYK_C": 0,
    "CMYK_M": 0.03647149354219,
    "CMYK_Y": 0.15544618666172,
    "CMYK_K": 0.03052365779877
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0337",
    "Farbtonhilfsbezeichnung": "85.1 Panna 1",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "230",
    "Bcolor": "170",
    "Y": 81,
    "L": 92.0248794555664,
    "a": 0.4353067278862,
    "b": 31.4998970031738,
    "C": 31.5029048919678,
    "h": 89.2082595825195,
    "CMY_C": 0.00044238567352,
    "CMY_M": 0.09790527820587,
    "CMY_Y": 0.33225482702255,
    "CMYK_C": 0,
    "CMYK_M": 0.097506031394,
    "CMYK_Y": 0.33195930719376,
    "CMYK_K": 0.00044238567352
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0338",
    "Farbtonhilfsbezeichnung": "85.2 Panna 2",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "233",
    "Bcolor": "187",
    "Y": 84,
    "L": 92.9034957885742,
    "a": -0.17393320798874,
    "b": 24.0226421356201,
    "C": 24.0232715606689,
    "h": 90.4148330688477,
    "CMY_C": 0.01154369115829,
    "CMY_M": 0.08505254983902,
    "CMY_Y": 0.26644825935364,
    "CMYK_C": 0,
    "CMYK_M": 0.07436732947826,
    "CMYK_Y": 0.25788146257401,
    "CMYK_K": 0.01154369115829
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0339",
    "Farbtonhilfsbezeichnung": "85.3 Panna 3",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "237",
    "Bcolor": "203",
    "Y": 85,
    "L": 93.9532775878906,
    "a": -0.59663313627243,
    "b": 17.4490661621094,
    "C": 17.4592628479004,
    "h": 91.9583435058594,
    "CMY_C": 0.01935082674026,
    "CMY_M": 0.07077062129974,
    "CMY_Y": 0.2057837843895,
    "CMYK_C": 0,
    "CMYK_M": 0.05243444442749,
    "CMYK_Y": 0.19011177122593,
    "CMYK_K": 0.01935082674026
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0340",
    "Farbtonhilfsbezeichnung": "85.4 Panna 4",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "238",
    "Bcolor": "213",
    "Y": 86,
    "L": 94.2659683227539,
    "a": -0.7872012257576,
    "b": 12.4014949798584,
    "C": 12.4264545440674,
    "h": 93.6320495605469,
    "CMY_C": 0.03132671117783,
    "CMY_M": 0.06556153297424,
    "CMY_Y": 0.16457492113113,
    "CMYK_C": 0,
    "CMYK_M": 0.03534197062254,
    "CMYK_Y": 0.13755743205547,
    "CMYK_K": 0.03132671117783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0341",
    "Farbtonhilfsbezeichnung": "86.1 Zabaione 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "151",
    "Y": 74,
    "L": 89.0037231445313,
    "a": 3.66281676292419,
    "b": 37.3311424255371,
    "C": 37.5104026794434,
    "h": 84.3962478637695,
    "CMY_C": 0.00175595283508,
    "CMY_M": 0.14041042327881,
    "CMY_Y": 0.40772634744644,
    "CMYK_C": 0,
    "CMYK_M": 0.13889837265015,
    "CMYK_Y": 0.40668451786041,
    "CMYK_K": 0.00175595283508
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0342",
    "Farbtonhilfsbezeichnung": "86.2 Zabaione 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "227",
    "Bcolor": "170",
    "Y": 79,
    "L": 91.2533645629883,
    "a": 2.09103202819824,
    "b": 30.5153656005859,
    "C": 30.5869235992432,
    "h": 86.0800018310547,
    "CMY_C": 0,
    "CMY_M": 0.11030906438828,
    "CMY_Y": 0.3326028585434,
    "CMYK_C": 0,
    "CMYK_M": 0.11030906438828,
    "CMYK_Y": 0.3326028585434,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0343",
    "Farbtonhilfsbezeichnung": "86.3 Zabaione 3",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "232",
    "Bcolor": "189",
    "Y": 82,
    "L": 92.746467590332,
    "a": 0.70043498277664,
    "b": 22.94313621521,
    "C": 22.9538249969482,
    "h": 88.251350402832,
    "CMY_C": 0.0096127986908,
    "CMY_M": 0.08867174386978,
    "CMY_Y": 0.25984466075897,
    "CMYK_C": 0,
    "CMYK_M": 0.0798263028264,
    "CMYK_Y": 0.25266063213348,
    "CMYK_K": 0.0096127986908
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0344",
    "Farbtonhilfsbezeichnung": "86.4 Zabaione 4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "236",
    "Bcolor": "202",
    "Y": 85,
    "L": 93.5742492675781,
    "a": -0.11294101178646,
    "b": 17.022798538208,
    "C": 17.02317237854,
    "h": 90.3801345825195,
    "CMY_C": 0.02120876312256,
    "CMY_M": 0.07607543468475,
    "CMY_Y": 0.20661514997482,
    "CMYK_C": 0,
    "CMYK_M": 0.05605554208159,
    "CMYK_Y": 0.18942382931709,
    "CMYK_K": 0.02120876312256
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0345",
    "Farbtonhilfsbezeichnung": "87.1 Crema 1",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "200",
    "Bcolor": "137",
    "Y": 61,
    "L": 82.3589172363281,
    "a": 5.36965179443359,
    "b": 35.8282279968262,
    "C": 36.2283744812012,
    "h": 81.4764022827148,
    "CMY_C": 0.07005620002747,
    "CMY_M": 0.21707105636597,
    "CMY_Y": 0.46454632282257,
    "CMYK_C": 0,
    "CMYK_M": 0.1580900400877,
    "CMYK_Y": 0.42420855164528,
    "CMYK_K": 0.07005620002747
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0346",
    "Farbtonhilfsbezeichnung": "87.2 Crema 2",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "217",
    "Bcolor": "174",
    "Y": 71,
    "L": 87.6193237304688,
    "a": 1.2900915145874,
    "b": 23.193754196167,
    "C": 23.2296047210693,
    "h": 86.8163528442383,
    "CMY_C": 0.06328129768372,
    "CMY_M": 0.1470655798912,
    "CMY_Y": 0.31622093915939,
    "CMYK_C": 0,
    "CMYK_M": 0.08944444358349,
    "CMYK_Y": 0.27002730965614,
    "CMYK_K": 0.06328129768372
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0347",
    "Farbtonhilfsbezeichnung": "87.3 Crema 3",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "231",
    "Bcolor": "191",
    "Y": 82,
    "L": 92.1843566894531,
    "a": 0.92012476921082,
    "b": 21.1220588684082,
    "C": 21.14208984375,
    "h": 87.5056457519531,
    "CMY_C": 0.01890873908997,
    "CMY_M": 0.09506398439407,
    "CMY_Y": 0.25216275453568,
    "CMYK_C": 0,
    "CMYK_M": 0.07762299478054,
    "CMYK_Y": 0.23774956166744,
    "CMYK_K": 0.01890873908997
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0348",
    "Farbtonhilfsbezeichnung": "87.4 Crema 4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "233",
    "Bcolor": "196",
    "Y": 84,
    "L": 92.8750610351562,
    "a": 0.3735246360302,
    "b": 19.4799404144287,
    "C": 19.4835205078125,
    "h": 88.901496887207,
    "CMY_C": 0.01914495229721,
    "CMY_M": 0.0856522321701,
    "CMY_Y": 0.23251366615295,
    "CMYK_C": 0,
    "CMYK_M": 0.06780540943146,
    "CMYK_Y": 0.21753337979317,
    "CMYK_K": 0.01914495229721
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0349",
    "Farbtonhilfsbezeichnung": "88.1 Parfait 1",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "207",
    "Bcolor": "125",
    "Y": 66,
    "L": 84.8627319335938,
    "a": 4.56975984573364,
    "b": 44.9521789550781,
    "C": 45.1838569641113,
    "h": 84.1953506469727,
    "CMY_C": 0.0313264131546,
    "CMY_M": 0.18941563367844,
    "CMY_Y": 0.50911146402359,
    "CMYK_C": 0,
    "CMYK_M": 0.1632017493248,
    "CMYK_Y": 0.49323636293411,
    "CMYK_K": 0.0313264131546
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0350",
    "Farbtonhilfsbezeichnung": "88.2 Parfait 2",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "216",
    "Bcolor": "154",
    "Y": 73,
    "L": 87.7986221313477,
    "a": 4.2147536277771,
    "b": 34.116039276123,
    "C": 34.3754005432129,
    "h": 82.9572677612305,
    "CMY_C": 0.01800662279129,
    "CMY_M": 0.1544497013092,
    "CMY_Y": 0.3956817984581,
    "CMYK_C": 0,
    "CMYK_M": 0.13894501328468,
    "CMYK_Y": 0.38460052013397,
    "CMYK_K": 0.01800662279129
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0351",
    "Farbtonhilfsbezeichnung": "88.3 Parfait 3",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "225",
    "Bcolor": "181",
    "Y": 79,
    "L": 90.7478637695312,
    "a": 2.59695982933044,
    "b": 23.9772052764893,
    "C": 24.1174335479736,
    "h": 83.8184127807617,
    "CMY_C": 0.01649212837219,
    "CMY_M": 0.11576998233795,
    "CMY_Y": 0.28862196207047,
    "CMYK_C": 0,
    "CMYK_M": 0.10094261169434,
    "CMYK_Y": 0.27669310569763,
    "CMYK_K": 0.01649212837219
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0352",
    "Farbtonhilfsbezeichnung": "88.4 Parfait 4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "227",
    "Bcolor": "186",
    "Y": 80,
    "L": 91.0904922485352,
    "a": 2.45645904541016,
    "b": 21.8875789642334,
    "C": 22.0249919891357,
    "h": 83.5964508056641,
    "CMY_C": 0.01848292350769,
    "CMY_M": 0.1111506819725,
    "CMY_Y": 0.26934331655502,
    "CMYK_C": 0,
    "CMYK_M": 0.09441278129816,
    "CMYK_Y": 0.25558432936668,
    "CMYK_K": 0.01848292350769
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0353",
    "Farbtonhilfsbezeichnung": "89.1 Karamell 1",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "218",
    "Bcolor": "173",
    "Y": 73,
    "L": 88.3621139526367,
    "a": 2.90689086914063,
    "b": 24.9277763366699,
    "C": 25.0966930389404,
    "h": 83.3486328125,
    "CMY_C": 0.03946733474731,
    "CMY_M": 0.14315450191498,
    "CMY_Y": 0.32098925113678,
    "CMYK_C": 0,
    "CMYK_M": 0.10794757306576,
    "CMYK_Y": 0.2930893599987,
    "CMYK_K": 0.03946733474731
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0354",
    "Farbtonhilfsbezeichnung": "89.2 Karamell 2",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "222",
    "Bcolor": "181",
    "Y": 76,
    "L": 89.6848220825195,
    "a": 3.81023502349854,
    "b": 22.896167755127,
    "C": 23.2110404968262,
    "h": 80.5517807006836,
    "CMY_C": 0.02259308099747,
    "CMY_M": 0.13029223680496,
    "CMY_Y": 0.29162830114365,
    "CMYK_C": 0,
    "CMYK_M": 0.11018865555525,
    "CMYK_Y": 0.27525407075882,
    "CMYK_K": 0.02259308099747
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0355",
    "Farbtonhilfsbezeichnung": "89.3 Karamell 3",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "229",
    "Bcolor": "196",
    "Y": 80,
    "L": 91.8095474243164,
    "a": 2.0342755317688,
    "b": 17.6844921112061,
    "C": 17.8011112213135,
    "h": 83.4380111694336,
    "CMY_C": 0.02376157045364,
    "CMY_M": 0.10113805532455,
    "CMY_Y": 0.23028296232224,
    "CMYK_C": 0,
    "CMYK_M": 0.07925982028246,
    "CMYK_Y": 0.21154810488224,
    "CMYK_K": 0.02376157045364
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0356",
    "Farbtonhilfsbezeichnung": "89.4 Karamell 4",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "233",
    "Bcolor": "207",
    "Y": 83,
    "L": 92.8566741943359,
    "a": 0.97027552127838,
    "b": 13.3945531845093,
    "C": 13.4296493530273,
    "h": 85.8568420410156,
    "CMY_C": 0.03122073411942,
    "CMY_M": 0.08582049608231,
    "CMY_Y": 0.18709248304367,
    "CMYK_C": 0,
    "CMYK_M": 0.05635934323072,
    "CMYK_Y": 0.16089500486851,
    "CMYK_K": 0.03122073411942
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0357",
    "Farbtonhilfsbezeichnung": "90.1 Sorbet 1",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "150",
    "Y": 72,
    "L": 88.2141647338867,
    "a": 7.63733673095703,
    "b": 36.9687271118164,
    "C": 37.7493782043457,
    "h": 78.327522277832,
    "CMY_C": 0,
    "CMY_M": 0.15899085998535,
    "CMY_Y": 0.41225641965866,
    "CMYK_C": 0,
    "CMYK_M": 0.15899085998535,
    "CMYK_Y": 0.41225641965866,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0358",
    "Farbtonhilfsbezeichnung": "90.2 Sorbet 2",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "222",
    "Bcolor": "170",
    "Y": 77,
    "L": 89.9774398803711,
    "a": 4.97001028060913,
    "b": 28.8899421691895,
    "C": 29.3143272399902,
    "h": 80.2388076782227,
    "CMY_C": 0,
    "CMY_M": 0.13122010231018,
    "CMY_Y": 0.33322256803513,
    "CMYK_C": 0,
    "CMYK_M": 0.13122010231018,
    "CMYK_Y": 0.33322256803513,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0359",
    "Farbtonhilfsbezeichnung": "90.3 Sorbet 3",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "229",
    "Bcolor": "189",
    "Y": 81,
    "L": 91.9920043945312,
    "a": 2.67282104492188,
    "b": 21.6546115875244,
    "C": 21.818941116333,
    "h": 82.9635925292969,
    "CMY_C": 0.00716477632523,
    "CMY_M": 0.10159158706665,
    "CMY_Y": 0.25790429115295,
    "CMYK_C": 0,
    "CMYK_M": 0.09510824084282,
    "CMYK_Y": 0.2525489628315,
    "CMYK_K": 0.00716477632523
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0360",
    "Farbtonhilfsbezeichnung": "90.4 Sorbet 4",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "238",
    "Bcolor": "213",
    "Y": 85,
    "L": 94.2680435180664,
    "a": 0.39612397551537,
    "b": 12.2545223236084,
    "C": 12.2609233856201,
    "h": 88.1485748291016,
    "CMY_C": 0.02274996042252,
    "CMY_M": 0.0683382153511,
    "CMY_Y": 0.16326344013214,
    "CMYK_C": 0,
    "CMYK_M": 0.04664953052998,
    "CMYK_Y": 0.14378456771374,
    "CMYK_K": 0.02274996042252
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0361",
    "Farbtonhilfsbezeichnung": "91.1 Flan 1",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "206",
    "Bcolor": "170",
    "Y": 65,
    "L": 84.0597915649414,
    "a": 3.67342305183411,
    "b": 20.7514724731445,
    "C": 21.0740985870361,
    "h": 79.9615020751953,
    "CMY_C": 0.09248030185699,
    "CMY_M": 0.19135290384293,
    "CMY_Y": 0.33524626493454,
    "CMYK_C": 0,
    "CMYK_M": 0.10894816368818,
    "CMYK_Y": 0.26750490069389,
    "CMYK_K": 0.09248030185699
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0362",
    "Farbtonhilfsbezeichnung": "91.2 Flan 2",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "219",
    "Bcolor": "185",
    "Y": 73,
    "L": 88.4214630126953,
    "a": 2.21824884414673,
    "b": 18.9554805755615,
    "C": 19.0848331451416,
    "h": 83.3253707885742,
    "CMY_C": 0.05773067474365,
    "CMY_M": 0.13948786258698,
    "CMY_Y": 0.27605015039444,
    "CMYK_C": 0,
    "CMYK_M": 0.0867662653327,
    "CMYK_Y": 0.23169541358948,
    "CMYK_K": 0.05773067474365
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0363",
    "Farbtonhilfsbezeichnung": "91.3 Flan 3",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "222",
    "Bcolor": "190",
    "Y": 74,
    "L": 89.2990875244141,
    "a": 1.79115128517151,
    "b": 17.1777591705322,
    "C": 17.2708892822266,
    "h": 84.0471954345703,
    "CMY_C": 0.05535364151001,
    "CMY_M": 0.1283261179924,
    "CMY_Y": 0.25354689359665,
    "CMYK_C": 0,
    "CMYK_M": 0.07724846154451,
    "CMYK_Y": 0.20980682969093,
    "CMYK_K": 0.05535364151001
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0364",
    "Farbtonhilfsbezeichnung": "91.4 Flan 4",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "226",
    "Bcolor": "199",
    "Y": 78,
    "L": 90.2794036865234,
    "a": 0.76922476291656,
    "b": 13.7839527130127,
    "C": 13.8053998947144,
    "h": 86.8058776855469,
    "CMY_C": 0.06079739332199,
    "CMY_M": 0.11416637897491,
    "CMY_Y": 0.21797382831573,
    "CMYK_C": 0,
    "CMYK_M": 0.05682371929288,
    "CMYK_Y": 0.16735093295574,
    "CMYK_K": 0.06079739332199
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0365",
    "Farbtonhilfsbezeichnung": "92.1 Sierra 1",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "174",
    "Bcolor": "146",
    "Y": 44,
    "L": 71.433837890625,
    "a": 0.79455643892288,
    "b": 15.2450904846191,
    "C": 15.2657823562622,
    "h": 87.0165100097656,
    "CMY_C": 0.2650580406189,
    "CMY_M": 0.31912368535995,
    "CMY_Y": 0.42681992053986,
    "CMYK_C": 0,
    "CMYK_M": 0.0735645070672,
    "CMYK_Y": 0.2201015651226,
    "CMYK_K": 0.2650580406189
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0366",
    "Farbtonhilfsbezeichnung": "92.2 Sierra 2",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "195",
    "Bcolor": "171",
    "Y": 56,
    "L": 78.9829330444336,
    "a": 0.18577715754509,
    "b": 12.7643356323242,
    "C": 12.7656879425049,
    "h": 89.1661529541016,
    "CMY_C": 0.19351541996002,
    "CMY_M": 0.2364017367363,
    "CMY_Y": 0.33095991611481,
    "CMYK_C": 0,
    "CMYK_M": 0.05317685753107,
    "CMYK_Y": 0.17042420804501,
    "CMYK_K": 0.19351541996002
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0367",
    "Farbtonhilfsbezeichnung": "92.3 Sierra 3",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "213",
    "Bcolor": "196",
    "Y": 67,
    "L": 85.3943252563477,
    "a": 0.10007717460394,
    "b": 8.69020748138428,
    "C": 8.69078350067139,
    "h": 89.3402099609375,
    "CMY_C": 0.13491892814636,
    "CMY_M": 0.16529417037964,
    "CMY_Y": 0.23320126533508,
    "CMYK_C": 0,
    "CMYK_M": 0.03511259704828,
    "CMYK_Y": 0.11361055076122,
    "CMYK_K": 0.13491892814636
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0368",
    "Farbtonhilfsbezeichnung": "92.4 Sierra 4",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "208",
    "Y": 74,
    "L": 89.0303039550781,
    "a": 0.52962183952332,
    "b": 7.54202842712402,
    "C": 7.56060123443604,
    "h": 85.9831237792969,
    "CMY_C": 0.09464579820633,
    "CMY_M": 0.12586575746536,
    "CMY_Y": 0.18535923957825,
    "CMYK_C": 0,
    "CMYK_M": 0.03448369726539,
    "CMYK_Y": 0.10019662976265,
    "CMYK_K": 0.09464579820633
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0369",
    "Farbtonhilfsbezeichnung": "93.1 Sahara 1",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "169",
    "Bcolor": "128",
    "Y": 42,
    "L": 70.545654296875,
    "a": 3.42650723457336,
    "b": 23.977352142334,
    "C": 24.2209491729736,
    "h": 81.8671493530273,
    "CMY_C": 0.23781716823578,
    "CMY_M": 0.33643752336502,
    "CMY_Y": 0.49754595756531,
    "CMYK_C": 0,
    "CMYK_M": 0.1293919980526,
    "CMYK_Y": 0.34076967835426,
    "CMYK_K": 0.23781716823578
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0370",
    "Farbtonhilfsbezeichnung": "93.2 Sahara 2",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "184",
    "Bcolor": "150",
    "Y": 51,
    "L": 75.7433090209961,
    "a": 2.73007845878601,
    "b": 19.3734817504883,
    "C": 19.5648956298828,
    "h": 81.9787902832031,
    "CMY_C": 0.19499409198761,
    "CMY_M": 0.27869319915771,
    "CMY_Y": 0.41183984279633,
    "CMYK_C": 0,
    "CMYK_M": 0.10397328436375,
    "CMYK_Y": 0.26937162876129,
    "CMYK_K": 0.19499409198761
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0371",
    "Farbtonhilfsbezeichnung": "93.3 Sahara 3",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "203",
    "Bcolor": "176",
    "Y": 61,
    "L": 82.1957168579102,
    "a": 1.71363139152527,
    "b": 14.3401136398315,
    "C": 14.4421396255493,
    "h": 83.1855163574219,
    "CMY_C": 0.14291334152222,
    "CMY_M": 0.20550221204758,
    "CMY_Y": 0.30830436944962,
    "CMYK_C": 0,
    "CMYK_M": 0.07302513718605,
    "CMYK_Y": 0.19296884536743,
    "CMYK_K": 0.14291334152222
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0372",
    "Farbtonhilfsbezeichnung": "93.4 Sahara 4",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "217",
    "Bcolor": "195",
    "Y": 72,
    "L": 87.3968734741211,
    "a": 1.67757666110992,
    "b": 11.6923885345459,
    "C": 11.8121213912964,
    "h": 81.8351516723633,
    "CMY_C": 0.09227699041367,
    "CMY_M": 0.1477455496788,
    "CMY_Y": 0.23345041275024,
    "CMYK_C": 0,
    "CMYK_M": 0.06110736355186,
    "CMYK_Y": 0.15552477538586,
    "CMYK_K": 0.09227699041367
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0373",
    "Farbtonhilfsbezeichnung": "94.1 Duene 1",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "145",
    "Bcolor": "104",
    "Y": 31,
    "L": 62.2516899108887,
    "a": 6.71297979354858,
    "b": 26.0964431762695,
    "C": 26.9460277557373,
    "h": 75.5741500854492,
    "CMY_C": 0.30383259057999,
    "CMY_M": 0.43074697256088,
    "CMY_Y": 0.59377598762512,
    "CMYK_C": 0,
    "CMYK_M": 0.18230439722538,
    "CMYK_Y": 0.41648516058922,
    "CMYK_K": 0.30383259057999
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0374",
    "Farbtonhilfsbezeichnung": "94.2 Duene 2",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "174",
    "Bcolor": "133",
    "Y": 45,
    "L": 72.7591934204102,
    "a": 5.22043418884277,
    "b": 24.7075042724609,
    "C": 25.2529945373535,
    "h": 78.0694808959961,
    "CMY_C": 0.20015549659729,
    "CMY_M": 0.31748616695404,
    "CMY_Y": 0.48017674684525,
    "CMYK_C": 0,
    "CMYK_M": 0.1466918438673,
    "CMYK_Y": 0.35009461641312,
    "CMYK_K": 0.20015549659729
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0375",
    "Farbtonhilfsbezeichnung": "94.3 Duene 3",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "160",
    "Y": 58,
    "L": 80.0422744750977,
    "a": 3.15400910377502,
    "b": 19.9233589172363,
    "C": 20.1714649200439,
    "h": 81.0043258666992,
    "CMY_C": 0.14310139417648,
    "CMY_M": 0.23358798027039,
    "CMY_Y": 0.3712899684906,
    "CMYK_C": 0,
    "CMYK_M": 0.1055977717042,
    "CMYK_Y": 0.26629588007927,
    "CMYK_K": 0.14310139417648
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0376",
    "Farbtonhilfsbezeichnung": "94.4 Duene 4",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "211",
    "Bcolor": "180",
    "Y": 67,
    "L": 85.2040252685547,
    "a": 2.25439763069153,
    "b": 16.5271625518799,
    "C": 16.6802101135254,
    "h": 82.2324752807617,
    "CMY_C": 0.09984248876572,
    "CMY_M": 0.17443263530731,
    "CMY_Y": 0.29235434532166,
    "CMYK_C": 0,
    "CMYK_M": 0.08286343514919,
    "CMYK_Y": 0.21386463940144,
    "CMYK_K": 0.09984248876572
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0377",
    "Farbtonhilfsbezeichnung": "95.1 Kamel 1",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "170",
    "Bcolor": "76",
    "Y": 44,
    "L": 72.1560897827148,
    "a": 7.855055809021,
    "b": 53.0317306518555,
    "C": 53.6103210449219,
    "h": 81.5746154785156,
    "CMY_C": 0.14872986078262,
    "CMY_M": 0.33482140302658,
    "CMY_Y": 0.70147269964218,
    "CMYK_C": 0,
    "CMYK_M": 0.21860456466675,
    "CMYK_Y": 0.6493154168129,
    "CMYK_K": 0.14872986078262
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0378",
    "Farbtonhilfsbezeichnung": "95.2 Kamel 2",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "182",
    "Bcolor": "105",
    "Y": 51,
    "L": 76.1621017456055,
    "a": 6.33044910430908,
    "b": 43.6629829406738,
    "C": 44.1195030212402,
    "h": 81.7504959106445,
    "CMY_C": 0.12311196327209,
    "CMY_M": 0.28737473487854,
    "CMY_Y": 0.58664321899414,
    "CMYK_C": 0,
    "CMYK_M": 0.18732468783855,
    "CMYK_Y": 0.52860939502716,
    "CMYK_K": 0.12311196327209
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0379",
    "Farbtonhilfsbezeichnung": "95.3 Kamel 3",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "197",
    "Bcolor": "137",
    "Y": 59,
    "L": 81.0814514160156,
    "a": 4.78142881393433,
    "b": 34.0550422668457,
    "C": 34.3890686035156,
    "h": 82.0077438354492,
    "CMY_C": 0.09172654151917,
    "CMY_M": 0.22914272546768,
    "CMY_Y": 0.46442472934723,
    "CMYK_C": 0,
    "CMYK_M": 0.1512938439846,
    "CMYK_Y": 0.41033697128296,
    "CMYK_K": 0.09172654151917
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0380",
    "Farbtonhilfsbezeichnung": "95.4 Kamel 4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "209",
    "Bcolor": "168",
    "Y": 66,
    "L": 84.9110336303711,
    "a": 3.13219356536865,
    "b": 22.6127529144287,
    "C": 22.828649520874,
    "h": 82.113883972168,
    "CMY_C": 0.0823723077774,
    "CMY_M": 0.18114322423935,
    "CMY_Y": 0.34012013673782,
    "CMYK_C": 0,
    "CMYK_M": 0.10763724148273,
    "CMYK_Y": 0.2808849811554,
    "CMYK_K": 0.0823723077774
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0381",
    "Farbtonhilfsbezeichnung": "96.1 Strand 1",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "175",
    "Bcolor": "97",
    "Y": 46,
    "L": 73.3091430664063,
    "a": 5.4590539932251,
    "b": 44.2407264709473,
    "C": 44.5762634277344,
    "h": 82.9655838012695,
    "CMY_C": 0.16061317920685,
    "CMY_M": 0.31560176610947,
    "CMY_Y": 0.61979806423187,
    "CMYK_C": 0,
    "CMYK_M": 0.18464501202106,
    "CMYK_Y": 0.54704803228378,
    "CMYK_K": 0.16061317920685
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0382",
    "Farbtonhilfsbezeichnung": "96.2 Strand 2",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "196",
    "Bcolor": "137",
    "Y": 58,
    "L": 80.4420318603516,
    "a": 3.51122570037842,
    "b": 32.9309501647949,
    "C": 33.1176109313965,
    "h": 83.9138946533203,
    "CMY_C": 0.10946321487427,
    "CMY_M": 0.23276287317276,
    "CMY_Y": 0.46283757686615,
    "CMYK_C": 0,
    "CMYK_M": 0.13845543563366,
    "CMYK_Y": 0.39681053161621,
    "CMYK_K": 0.10946321487427
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0383",
    "Farbtonhilfsbezeichnung": "96.3 Strand 3",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "214",
    "Bcolor": "168",
    "Y": 69,
    "L": 86.5003662109375,
    "a": 2.34198355674744,
    "b": 24.8534564971924,
    "C": 24.9635562896729,
    "h": 84.616813659668,
    "CMY_C": 0.06482076644897,
    "CMY_M": 0.1622799038887,
    "CMY_Y": 0.34017097949982,
    "CMYK_C": 0,
    "CMYK_M": 0.10421439260244,
    "CMYK_Y": 0.29443576931953,
    "CMYK_K": 0.06482076644897
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0384",
    "Farbtonhilfsbezeichnung": "96.4 Strand 4",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "224",
    "Bcolor": "190",
    "Y": 76,
    "L": 89.8146133422852,
    "a": 1.6339522600174,
    "b": 17.9200477600098,
    "C": 17.994384765625,
    "h": 84.790168762207,
    "CMY_C": 0.04875153303146,
    "CMY_M": 0.12240666151047,
    "CMY_Y": 0.25356012582779,
    "CMYK_C": 0,
    "CMYK_M": 0.07742995768785,
    "CMYK_Y": 0.21530504524708,
    "CMYK_K": 0.04875153303146
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0385",
    "Farbtonhilfsbezeichnung": "97.1 Savanne 1",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "168",
    "Bcolor": "114",
    "Y": 41,
    "L": 69.6483917236328,
    "a": 1.32178103923798,
    "b": 30.406286239624,
    "C": 30.435001373291,
    "h": 87.5108871459961,
    "CMY_C": 0.24939984083176,
    "CMY_M": 0.34216719865799,
    "CMY_Y": 0.55330216884613,
    "CMYK_C": 0,
    "CMYK_M": 0.12359090894461,
    "CMYK_Y": 0.40487912297249,
    "CMYK_K": 0.24939984083176
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0386",
    "Farbtonhilfsbezeichnung": "97.2 Savanne 2",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "174",
    "Bcolor": "126",
    "Y": 44,
    "L": 71.7504806518555,
    "a": 0.67392039299011,
    "b": 26.5670757293701,
    "C": 26.5756225585938,
    "h": 88.5469055175781,
    "CMY_C": 0.23766428232193,
    "CMY_M": 0.31782609224319,
    "CMY_Y": 0.50464332103729,
    "CMYK_C": 0,
    "CMYK_M": 0.10515289753675,
    "CMYK_Y": 0.35021188855171,
    "CMYK_K": 0.23766428232193
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0387",
    "Farbtonhilfsbezeichnung": "97.3 Savanne 3",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "199",
    "Bcolor": "155",
    "Y": 58,
    "L": 80.7582550048828,
    "a": 0.76437973976135,
    "b": 23.5552539825439,
    "C": 23.5676536560059,
    "h": 88.1413803100586,
    "CMY_C": 0.14346128702164,
    "CMY_M": 0.22094660997391,
    "CMY_Y": 0.39083117246628,
    "CMYK_C": 0,
    "CMYK_M": 0.09046330302954,
    "CMYK_Y": 0.28880175948143,
    "CMYK_K": 0.14346128702164
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0388",
    "Farbtonhilfsbezeichnung": "97.4 Savanne 4",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "218",
    "Bcolor": "185",
    "Y": 72,
    "L": 87.5527038574219,
    "a": 0.43402734398842,
    "b": 17.4097995758057,
    "C": 17.4152088165283,
    "h": 88.571907043457,
    "CMY_C": 0.08433026075363,
    "CMY_M": 0.14444625377655,
    "CMY_Y": 0.27417463064194,
    "CMYK_C": 0,
    "CMYK_M": 0.06565248221159,
    "CMYK_Y": 0.20732842385769,
    "CMYK_K": 0.08433026075363
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0389",
    "Farbtonhilfsbezeichnung": "98.1 Alpaca 1",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "179",
    "Bcolor": "120",
    "Y": 47,
    "L": 74.0607528686523,
    "a": 2.58272385597229,
    "b": 33.1466636657715,
    "C": 33.2471313476563,
    "h": 85.5446319580078,
    "CMY_C": 0.18732458353043,
    "CMY_M": 0.29897618293762,
    "CMY_Y": 0.52918916940689,
    "CMYK_C": 0,
    "CMYK_M": 0.13738769292831,
    "CMYK_Y": 0.42066559195518,
    "CMYK_K": 0.18732458353043
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0390",
    "Farbtonhilfsbezeichnung": "98.2 Alpaca 2",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "203",
    "Bcolor": "153",
    "Y": 62,
    "L": 82.3867645263672,
    "a": 0.13801784813404,
    "b": 27.0446128845215,
    "C": 27.0449657440186,
    "h": 89.7076034545898,
    "CMY_C": 0.12194472551346,
    "CMY_M": 0.20249307155609,
    "CMY_Y": 0.39979273080826,
    "CMYK_C": 0,
    "CMYK_M": 0.0917349383235,
    "CMYK_Y": 0.3164356648922,
    "CMYK_K": 0.12194472551346
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0391",
    "Farbtonhilfsbezeichnung": "98.3 Alpaca 3",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "215",
    "Bcolor": "175",
    "Y": 70,
    "L": 86.5266647338867,
    "a": -0.1361860781908,
    "b": 21.1829261779785,
    "C": 21.1833648681641,
    "h": 90.3683547973633,
    "CMY_C": 0.09058260917664,
    "CMY_M": 0.15526872873306,
    "CMY_Y": 0.31310415267944,
    "CMYK_C": 0,
    "CMYK_M": 0.07112918794155,
    "CMYK_Y": 0.24468582868576,
    "CMYK_K": 0.09058260917664
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0392",
    "Farbtonhilfsbezeichnung": "98.4 Alpaca 4",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "192",
    "Y": 76,
    "L": 89.3617553710938,
    "a": 0.0498005002737,
    "b": 16.5303077697754,
    "C": 16.5303821563721,
    "h": 89.827392578125,
    "CMY_C": 0.06905215978622,
    "CMY_M": 0.12330484390259,
    "CMY_Y": 0.24836224317551,
    "CMYK_C": 0,
    "CMYK_M": 0.05827682465315,
    "CMYK_Y": 0.19261023402214,
    "CMYK_K": 0.06905215978622
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0393",
    "Farbtonhilfsbezeichnung": "99.1 Lehm 1",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "98",
    "Bcolor": "69",
    "Y": 13,
    "L": 42.7864112854004,
    "a": 3.05740284919739,
    "b": 19.0783920288086,
    "C": 19.3218212127686,
    "h": 80.8954925537109,
    "CMY_C": 0.54198241233826,
    "CMY_M": 0.61394989490509,
    "CMY_Y": 0.72934436798096,
    "CMYK_C": 0,
    "CMYK_M": 0.15712821483612,
    "CMYK_Y": 0.40907153487206,
    "CMYK_K": 0.54198241233826
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0394",
    "Farbtonhilfsbezeichnung": "99.2 Lehm 2",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "119",
    "Bcolor": "91",
    "Y": 19,
    "L": 50.8484840393066,
    "a": 2.47620916366577,
    "b": 17.1453533172607,
    "C": 17.3232421875,
    "h": 81.7819137573242,
    "CMY_C": 0.46691578626633,
    "CMY_M": 0.53404474258423,
    "CMY_Y": 0.64215135574341,
    "CMYK_C": 0,
    "CMYK_M": 0.12592561542988,
    "CMYK_Y": 0.32872024178505,
    "CMYK_K": 0.46691578626633
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0395",
    "Farbtonhilfsbezeichnung": "99.3 Lehm 3",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "143",
    "Bcolor": "120",
    "Y": 28,
    "L": 60.0776214599609,
    "a": 2.27721357345581,
    "b": 13.81312084198,
    "C": 13.9995718002319,
    "h": 80.6384963989258,
    "CMY_C": 0.37935328483582,
    "CMY_M": 0.44024515151978,
    "CMY_Y": 0.53059613704681,
    "CMYK_C": 0,
    "CMYK_M": 0.09811034798622,
    "CMYK_Y": 0.24368590116501,
    "CMYK_K": 0.37935328483582
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0396",
    "Farbtonhilfsbezeichnung": "99.4 Lehm 4",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "166",
    "Bcolor": "146",
    "Y": 39,
    "L": 68.6210327148438,
    "a": 1.29897892475128,
    "b": 11.3351202011108,
    "C": 11.4093074798584,
    "h": 83.4625549316406,
    "CMY_C": 0.30151915550232,
    "CMY_M": 0.34902399778366,
    "CMY_Y": 0.4278764128685,
    "CMYK_C": 0,
    "CMYK_M": 0.06801166385412,
    "CMYK_Y": 0.18090297281742,
    "CMYK_K": 0.30151915550232
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0397",
    "Farbtonhilfsbezeichnung": "100.1 Tuff 1",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "142",
    "Bcolor": "110",
    "Y": 28,
    "L": 59.9326019287109,
    "a": 2.83622932434082,
    "b": 19.2063217163086,
    "C": 19.414608001709,
    "h": 81.5997543334961,
    "CMY_C": 0.36576426029205,
    "CMY_M": 0.44409900903702,
    "CMY_Y": 0.56900835037231,
    "CMYK_C": 0,
    "CMYK_M": 0.12351045757532,
    "CMYK_Y": 0.32045513391495,
    "CMYK_K": 0.36576426029205
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0398",
    "Farbtonhilfsbezeichnung": "100.2 Tuff 2",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "158",
    "Bcolor": "127",
    "Y": 35,
    "L": 65.9516220092773,
    "a": 2.4412248134613,
    "b": 18.2102203369141,
    "C": 18.3731250762939,
    "h": 82.3645706176758,
    "CMY_C": 0.30616730451584,
    "CMY_M": 0.38103640079498,
    "CMY_Y": 0.50280451774597,
    "CMYK_C": 0,
    "CMYK_M": 0.10790655761957,
    "CMYK_Y": 0.28340724110603,
    "CMYK_K": 0.30616730451584
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0399",
    "Farbtonhilfsbezeichnung": "100.3 Tuff 3",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "172",
    "Bcolor": "143",
    "Y": 43,
    "L": 71.2939300537109,
    "a": 2.01146912574768,
    "b": 16.5911827087402,
    "C": 16.7126712799072,
    "h": 83.0873489379883,
    "CMY_C": 0.25499701499939,
    "CMY_M": 0.32370340824127,
    "CMY_Y": 0.43759685754776,
    "CMYK_C": 0,
    "CMYK_M": 0.09222297370434,
    "CMYK_Y": 0.2450994849205,
    "CMYK_K": 0.25499701499939
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0400",
    "Farbtonhilfsbezeichnung": "100.4 Tuff 4",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "187",
    "Bcolor": "161",
    "Y": 51,
    "L": 76.571662902832,
    "a": 1.30707883834839,
    "b": 14.7271385192871,
    "C": 14.7850284576416,
    "h": 84.9281158447266,
    "CMY_C": 0.20685160160065,
    "CMY_M": 0.26544016599655,
    "CMY_Y": 0.3701012134552,
    "CMYK_C": 0,
    "CMYK_M": 0.07386834919453,
    "CMYK_Y": 0.20582480728626,
    "CMYK_K": 0.20685160160065
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0401",
    "Farbtonhilfsbezeichnung": "101.1 Fossil 1",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "120",
    "Bcolor": "96",
    "Y": 21,
    "L": 51.7334289550781,
    "a": 4.78001594543457,
    "b": 15.3887777328491,
    "C": 16.1140632629395,
    "h": 72.7443161010742,
    "CMY_C": 0.44695019721985,
    "CMY_M": 0.53010106086731,
    "CMY_Y": 0.62163209915161,
    "CMYK_C": 0,
    "CMYK_M": 0.1503496915102,
    "CMYK_Y": 0.31585201621056,
    "CMYK_K": 0.44695019721985
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0402",
    "Farbtonhilfsbezeichnung": "101.2 Fossil 2",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "137",
    "Bcolor": "114",
    "Y": 27,
    "L": 58.2380256652832,
    "a": 3.81033110618591,
    "b": 14.6549596786499,
    "C": 15.1422080993652,
    "h": 75.4256286621094,
    "CMY_C": 0.38680768013,
    "CMY_M": 0.462606549263,
    "CMY_Y": 0.55414992570877,
    "CMYK_C": 0,
    "CMYK_M": 0.12361353635788,
    "CMYK_Y": 0.27290335297585,
    "CMYK_K": 0.38680768013
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0403",
    "Farbtonhilfsbezeichnung": "101.3 Fossil 3",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "171",
    "Bcolor": "145",
    "Y": 43,
    "L": 71.0901336669922,
    "a": 3.01370978355408,
    "b": 15.2922210693359,
    "C": 15.5863552093506,
    "h": 78.851318359375,
    "CMY_C": 0.25341236591339,
    "CMY_M": 0.32789880037308,
    "CMY_Y": 0.43029659986496,
    "CMYK_C": 0,
    "CMYK_M": 0.09976917505264,
    "CMYK_Y": 0.23692360520363,
    "CMYK_K": 0.25341236591339
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0404",
    "Farbtonhilfsbezeichnung": "101.4 Fossil 4",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "189",
    "Bcolor": "167",
    "Y": 53,
    "L": 77.3910827636719,
    "a": 1.96642971038818,
    "b": 12.4684782028198,
    "C": 12.6225910186768,
    "h": 81.0375823974609,
    "CMY_C": 0.19898879528046,
    "CMY_M": 0.25764775276184,
    "CMY_Y": 0.34522485733032,
    "CMYK_C": 0,
    "CMYK_M": 0.07323113083839,
    "CMYK_Y": 0.18256431818008,
    "CMYK_K": 0.19898879528046
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0405",
    "Farbtonhilfsbezeichnung": "102.1 Terre 1",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "110",
    "Bcolor": "77",
    "Y": 18,
    "L": 48.5832557678223,
    "a": 6.94921493530273,
    "b": 22.6424541473389,
    "C": 23.6848545074463,
    "h": 72.9381866455078,
    "CMY_C": 0.45413494110107,
    "CMY_M": 0.56736147403717,
    "CMY_Y": 0.69932317733765,
    "CMYK_C": 0,
    "CMYK_M": 0.20742586255074,
    "CMYK_Y": 0.44917371869087,
    "CMYK_K": 0.45413494110107
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0406",
    "Farbtonhilfsbezeichnung": "102.2 Terre 2",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "128",
    "Bcolor": "96",
    "Y": 23,
    "L": 55.2078247070313,
    "a": 5.96365213394165,
    "b": 20.3944511413574,
    "C": 21.2485008239746,
    "h": 73.7002716064453,
    "CMY_C": 0.39399069547653,
    "CMY_M": 0.49922740459442,
    "CMY_Y": 0.62212896347046,
    "CMYK_C": 0,
    "CMYK_M": 0.17365527153015,
    "CMYK_Y": 0.37646001577377,
    "CMYK_K": 0.39399069547653
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0407",
    "Farbtonhilfsbezeichnung": "102.3 Terre 3",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "149",
    "Bcolor": "120",
    "Y": 32,
    "L": 63.1924362182617,
    "a": 5.19537258148193,
    "b": 18.1859016418457,
    "C": 18.9134578704834,
    "h": 74.0563430786133,
    "CMY_C": 0.31788444519043,
    "CMY_M": 0.41595953702927,
    "CMY_Y": 0.52954053878784,
    "CMYK_C": 0,
    "CMYK_M": 0.14378075301647,
    "CMYK_Y": 0.31029361486435,
    "CMYK_K": 0.31788444519043
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0408",
    "Farbtonhilfsbezeichnung": "102.4 Terre 4",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 41,
    "L": 70.0463714599609,
    "a": 4.15296745300293,
    "b": 15.2168436050415,
    "C": 15.7733783721924,
    "h": 74.7346496582031,
    "CMY_C": 0.25719445943832,
    "CMY_M": 0.34155374765396,
    "CMY_Y": 0.44020754098892,
    "CMYK_C": 0,
    "CMYK_M": 0.11356846988201,
    "CMYK_Y": 0.24638088047504,
    "CMYK_K": 0.25719445943832
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0409",
    "Farbtonhilfsbezeichnung": "103.1 Fauna 1",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "119",
    "Bcolor": "72",
    "Y": 21,
    "L": 52.7832794189453,
    "a": 9.56018829345703,
    "b": 30.8125076293945,
    "C": 32.2615547180176,
    "h": 72.7624664306641,
    "CMY_C": 0.38293582201004,
    "CMY_M": 0.53366768360138,
    "CMY_Y": 0.71620464324951,
    "CMYK_C": 0,
    "CMYK_M": 0.24427258968353,
    "CMYK_Y": 0.54008775949478,
    "CMYK_K": 0.38293582201004
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0410",
    "Farbtonhilfsbezeichnung": "103.2 Fauna 2",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "132",
    "Bcolor": "83",
    "Y": 26,
    "L": 57.8620948791504,
    "a": 9.36046504974365,
    "b": 31.6377868652344,
    "C": 32.9934501647949,
    "h": 73.518440246582,
    "CMY_C": 0.3275557756424,
    "CMY_M": 0.48265510797501,
    "CMY_Y": 0.6744921207428,
    "CMYK_C": 0,
    "CMYK_M": 0.23065011203289,
    "CMYK_Y": 0.51593327522278,
    "CMYK_K": 0.3275557756424
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0411",
    "Farbtonhilfsbezeichnung": "103.3 Fauna 3",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "149",
    "Bcolor": "102",
    "Y": 33,
    "L": 64.0041122436523,
    "a": 8.27900123596191,
    "b": 29.5561237335205,
    "C": 30.6937503814697,
    "h": 74.3518447875977,
    "CMY_C": 0.26935493946075,
    "CMY_M": 0.41716820001602,
    "CMY_Y": 0.60098946094513,
    "CMYK_C": 0,
    "CMYK_M": 0.20230515301228,
    "CMYK_Y": 0.45389279723167,
    "CMYK_K": 0.26935493946075
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0412",
    "Farbtonhilfsbezeichnung": "103.4 Fauna 4",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "185",
    "Bcolor": "148",
    "Y": 52,
    "L": 76.677848815918,
    "a": 4.84778785705566,
    "b": 21.9022274017334,
    "C": 22.4323120117188,
    "h": 77.5195007324219,
    "CMY_C": 0.16472178697586,
    "CMY_M": 0.27429419755936,
    "CMY_Y": 0.4201146364212,
    "CMYK_C": 0,
    "CMYK_M": 0.13118073344231,
    "CMYK_Y": 0.30575782060623,
    "CMYK_K": 0.16472178697586
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0413",
    "Farbtonhilfsbezeichnung": "104.1 Ocker 1",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "132",
    "Bcolor": "73",
    "Y": 26,
    "L": 57.7784614562988,
    "a": 8.8061637878418,
    "b": 36.8922805786133,
    "C": 37.9287338256836,
    "h": 76.5747451782227,
    "CMY_C": 0.32497721910477,
    "CMY_M": 0.48292744159698,
    "CMY_Y": 0.7135796546936,
    "CMYK_C": 0,
    "CMYK_M": 0.23399242758751,
    "CMYK_Y": 0.57568788528442,
    "CMYK_K": 0.32497721910477
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0414",
    "Farbtonhilfsbezeichnung": "104.2 Ocker 2",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "157",
    "Bcolor": "102",
    "Y": 37,
    "L": 66.9883880615234,
    "a": 7.2077374458313,
    "b": 33.3271980285645,
    "C": 34.0977058410645,
    "h": 77.7964859008789,
    "CMY_C": 0.23692733049393,
    "CMY_M": 0.38436645269394,
    "CMY_Y": 0.5994079709053,
    "CMYK_C": 0,
    "CMYK_M": 0.19321766495705,
    "CMYK_Y": 0.47502768039703,
    "CMYK_K": 0.23692733049393
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0415",
    "Farbtonhilfsbezeichnung": "104.3 Ocker 3",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "190",
    "Bcolor": "145",
    "Y": 54,
    "L": 78.2322845458984,
    "a": 4.12767601013184,
    "b": 25.4259490966797,
    "C": 25.7588157653809,
    "h": 80.7789840698242,
    "CMY_C": 0.14482682943344,
    "CMY_M": 0.25661301612854,
    "CMY_Y": 0.42992812395096,
    "CMYK_C": 0,
    "CMYK_M": 0.1307176053524,
    "CMYK_Y": 0.3333842754364,
    "CMYK_K": 0.14482682943344
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0416",
    "Farbtonhilfsbezeichnung": "104.4 Ocker 4",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "214",
    "Bcolor": "182",
    "Y": 70,
    "L": 86.6258163452148,
    "a": 3.26789999008179,
    "b": 17.8287296295166,
    "C": 18.1257495880127,
    "h": 79.6133193969727,
    "CMY_C": 0.07333862781525,
    "CMY_M": 0.16156852245331,
    "CMY_Y": 0.28665798902512,
    "CMYK_C": 0,
    "CMYK_M": 0.09521266072989,
    "CMYK_Y": 0.23020206391811,
    "CMYK_K": 0.07333862781525
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0417",
    "Farbtonhilfsbezeichnung": "105.1 Beryl 1",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "157",
    "Bcolor": "92",
    "Y": 37,
    "L": 67.2221069335938,
    "a": 7.10804843902588,
    "b": 38.8685340881348,
    "C": 39.513126373291,
    "h": 79.6365966796875,
    "CMY_C": 0.22696256637573,
    "CMY_M": 0.38257777690887,
    "CMY_Y": 0.63813757896423,
    "CMYK_C": 0,
    "CMYK_M": 0.20130358636379,
    "CMYK_Y": 0.53189533948898,
    "CMYK_K": 0.22696256637573
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0418",
    "Farbtonhilfsbezeichnung": "105.2 Beryl 2",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "171",
    "Bcolor": "109",
    "Y": 44,
    "L": 71.9918212890625,
    "a": 6.00413131713867,
    "b": 36.0710868835449,
    "C": 36.5673751831055,
    "h": 80.5495986938477,
    "CMY_C": 0.18396079540253,
    "CMY_M": 0.32955986261368,
    "CMY_Y": 0.57067000865936,
    "CMYK_C": 0,
    "CMYK_M": 0.17842166125774,
    "CMYK_Y": 0.47388559579849,
    "CMYK_K": 0.18396079540253
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0419",
    "Farbtonhilfsbezeichnung": "105.3 Beryl 3",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "199",
    "Bcolor": "149",
    "Y": 60,
    "L": 81.7743835449219,
    "a": 3.64360857009888,
    "b": 28.6535987854004,
    "C": 28.8843307495117,
    "h": 82.7531280517578,
    "CMY_C": 0.10158884525299,
    "CMY_M": 0.21783322095871,
    "CMY_Y": 0.41734057664871,
    "CMYK_C": 0,
    "CMYK_M": 0.12938883900642,
    "CMYK_Y": 0.35145571827888,
    "CMYK_K": 0.10158884525299
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0420",
    "Farbtonhilfsbezeichnung": "105.4 Beryl 4",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "213",
    "Bcolor": "170",
    "Y": 69,
    "L": 86.1061706542969,
    "a": 1.82280194759369,
    "b": 23.1354789733887,
    "C": 23.2071762084961,
    "h": 85.4950790405273,
    "CMY_C": 0.07681530714035,
    "CMY_M": 0.16499119997025,
    "CMY_Y": 0.33165943622589,
    "CMYK_C": 0,
    "CMYK_M": 0.09551273286343,
    "CMYK_Y": 0.2760488986969,
    "CMYK_K": 0.07681530714035
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0421",
    "Farbtonhilfsbezeichnung": "106.1 Gruen 1",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "86",
    "Bcolor": "96",
    "Y": 8,
    "L": 33.5420989990234,
    "a": -14.4652271270752,
    "b": -11.5623836517334,
    "C": 18.5184097290039,
    "h": 218.636138916016,
    "CMY_C": 0.88126367330551,
    "CMY_M": 0.66245639324188,
    "CMY_Y": 0.62386035919189,
    "CMYK_C": 0.68432915210724,
    "CMYK_M": 0.10261091589928,
    "CMYK_Y": 0,
    "CMYK_K": 0.62386035919189
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0422",
    "Farbtonhilfsbezeichnung": "106.2 Gruen 2",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "122",
    "Y": 13,
    "L": 42.4194068908691,
    "a": -25.1978969573975,
    "b": -14.5987863540649,
    "C": 29.1214447021484,
    "h": 210.086517333984,
    "CMY_C": 1,
    "CMY_M": 0.56003868579865,
    "CMY_Y": 0.5196545124054,
    "CMYK_C": 1,
    "CMYK_M": 0.08407317847013,
    "CMYK_Y": 0,
    "CMYK_K": 0.5196545124054
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0423",
    "Farbtonhilfsbezeichnung": "106.3 Gruen 3",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "120",
    "Y": 17,
    "L": 48.0509834289551,
    "a": -35.2127799987793,
    "b": -4.43032264709473,
    "C": 35.4903869628906,
    "h": 187.171035766602,
    "CMY_C": 1,
    "CMY_M": 0.49200081825256,
    "CMY_Y": 0.53105437755585,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07687720656395,
    "CMYK_K": 0.49200081825256
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0424",
    "Farbtonhilfsbezeichnung": "106.4 Gruen 4",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "162",
    "Bcolor": "137",
    "Y": 27,
    "L": 58.7963943481445,
    "a": -46.4216079711914,
    "b": 1.40865230560303,
    "C": 46.4429740905762,
    "h": 178.261917114258,
    "CMY_C": 1,
    "CMY_M": 0.365787088871,
    "CMY_Y": 0.46448695659637,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.15562576055527,
    "CMYK_K": 0.365787088871
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0425",
    "Farbtonhilfsbezeichnung": "107.1 Gruen 5",
    "Farbtonklasse": "04",
    "Rcolor": "19",
    "Gcolor": "91",
    "Bcolor": "78",
    "Y": 8,
    "L": 34.3007926940918,
    "a": -24.5125045776367,
    "b": 0.56366205215454,
    "C": 24.5189838409424,
    "h": 178.682723999023,
    "CMY_C": 0.92414236068726,
    "CMY_M": 0.64374566078186,
    "CMY_Y": 0.69240021705627,
    "CMYK_C": 0.78706884384155,
    "CMYK_M": 0,
    "CMYK_Y": 0.1365725249052,
    "CMYK_K": 0.64374566078186
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0426",
    "Farbtonhilfsbezeichnung": "107.2 Gruen 6",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "104",
    "Y": 17,
    "L": 48.8251647949219,
    "a": -38.5058898925781,
    "b": 6.07249879837036,
    "C": 38.9817733764648,
    "h": 171.0380859375,
    "CMY_C": 1,
    "CMY_M": 0.48188745975494,
    "CMY_Y": 0.59316623210907,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.21477721631527,
    "CMYK_K": 0.48188745975494
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0427",
    "Farbtonhilfsbezeichnung": "107.3 Gruen 7",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "145",
    "Bcolor": "68",
    "Y": 22,
    "L": 54.2797622680664,
    "a": -38.627628326416,
    "b": 33.5806541442871,
    "C": 51.1835327148438,
    "h": 138.998153686523,
    "CMY_C": 0.71290373802185,
    "CMY_M": 0.42947828769684,
    "CMY_Y": 0.73355710506439,
    "CMYK_C": 0.49678292870522,
    "CMYK_M": 0,
    "CMYK_Y": 0.53298377990723,
    "CMYK_K": 0.42947828769684
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0428",
    "Farbtonhilfsbezeichnung": "107.4 Gruen 8",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "174",
    "Bcolor": "86",
    "Y": 35,
    "L": 65.404670715332,
    "a": -35.7172698974609,
    "b": 38.327335357666,
    "C": 52.3899612426758,
    "h": 132.981155395508,
    "CMY_C": 0.55429446697235,
    "CMY_M": 0.3170223236084,
    "CMY_Y": 0.66233992576599,
    "CMYK_C": 0.34740835428238,
    "CMYK_M": 0,
    "CMYK_Y": 0.50560599565506,
    "CMYK_K": 0.3170223236084
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0429",
    "Farbtonhilfsbezeichnung": "108.1 Gruen 9",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "133",
    "Bcolor": "63",
    "Y": 19,
    "L": 51.0313873291016,
    "a": -27.2360782623291,
    "b": 32.2545738220215,
    "C": 42.2156562805176,
    "h": 130.178085327148,
    "CMY_C": 0.64216703176498,
    "CMY_M": 0.47954553365707,
    "CMY_Y": 0.7516815662384,
    "CMYK_C": 0.31246057152748,
    "CMYK_M": 0,
    "CMYK_Y": 0.52288156747818,
    "CMYK_K": 0.47954553365707
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0430",
    "Farbtonhilfsbezeichnung": "108.2 Gruen 10",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "174",
    "Bcolor": "58",
    "Y": 36,
    "L": 66.4471282958984,
    "a": -30.5919609069824,
    "b": 52.8563613891602,
    "C": 61.0709686279297,
    "h": 120.06120300293,
    "CMY_C": 0.47032541036606,
    "CMY_M": 0.31588971614838,
    "CMY_Y": 0.77294588088989,
    "CMYK_C": 0.22574678063393,
    "CMYK_M": 0,
    "CMYK_Y": 0.66810303926468,
    "CMYK_K": 0.31588971614838
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0431",
    "Farbtonhilfsbezeichnung": "108.3 Gruen 11",
    "Farbtonklasse": "04",
    "Rcolor": "169",
    "Gcolor": "185",
    "Bcolor": "54",
    "Y": 43,
    "L": 71.7501220703125,
    "a": -21.918493270874,
    "b": 60.3340187072754,
    "C": 64.192008972168,
    "h": 109.965362548828,
    "CMY_C": 0.33769541978836,
    "CMY_M": 0.27545773983002,
    "CMY_Y": 0.78640794754028,
    "CMYK_C": 0.08589930832386,
    "CMYK_M": 0,
    "CMYK_Y": 0.70520412921906,
    "CMYK_K": 0.27545773983002
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0432",
    "Farbtonhilfsbezeichnung": "108.4 Gruen 12",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "192",
    "Bcolor": "32",
    "Y": 49,
    "L": 75.7632293701172,
    "a": -15.9100522994995,
    "b": 71.5397872924805,
    "C": 73.2875900268555,
    "h": 102.538208007813,
    "CMY_C": 0.238765001297,
    "CMY_M": 0.24512100219727,
    "CMY_Y": 0.87454795837402,
    "CMYK_C": 0,
    "CMYK_M": 0.00834959093481,
    "CMYK_Y": 0.83519929647446,
    "CMYK_K": 0.238765001297
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0433",
    "Farbtonhilfsbezeichnung": "109.1 Lorbeer 1",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "117",
    "Bcolor": "96",
    "Y": 15,
    "L": 46.0091934204102,
    "a": -16.5514602661133,
    "b": 6.72571039199829,
    "C": 17.8657779693604,
    "h": 157.885559082031,
    "CMY_C": 0.67660582065582,
    "CMY_M": 0.54309439659119,
    "CMY_Y": 0.62184655666351,
    "CMYK_C": 0.29220789670944,
    "CMYK_M": 0,
    "CMYK_Y": 0.17235980927944,
    "CMYK_K": 0.54309439659119
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0434",
    "Farbtonhilfsbezeichnung": "109.2 Lorbeer 2",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "128",
    "Bcolor": "95",
    "Y": 18,
    "L": 49.5577354431152,
    "a": -22.7769145965576,
    "b": 12.4623880386353,
    "C": 25.963415145874,
    "h": 151.314727783203,
    "CMY_C": 0.67632961273193,
    "CMY_M": 0.49854207038879,
    "CMY_Y": 0.62689816951752,
    "CMYK_C": 0.35454130172729,
    "CMYK_M": 0,
    "CMYK_Y": 0.25596582889557,
    "CMYK_K": 0.49854207038879
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0435",
    "Farbtonhilfsbezeichnung": "109.3 Lorbeer 3",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "135",
    "Bcolor": "94",
    "Y": 19,
    "L": 51.2990493774414,
    "a": -29.6506004333496,
    "b": 15.1657419204712,
    "C": 33.3040199279785,
    "h": 152.911071777344,
    "CMY_C": 0.71645933389664,
    "CMY_M": 0.47066473960876,
    "CMY_Y": 0.6295028924942,
    "CMYK_C": 0.46434578299522,
    "CMYK_M": 0,
    "CMYK_Y": 0.30007097125053,
    "CMYK_K": 0.47066473960876
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0436",
    "Farbtonhilfsbezeichnung": "109.4 Lorbeer 4",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "159",
    "Bcolor": "122",
    "Y": 29,
    "L": 61.130989074707,
    "a": -25.5083694458008,
    "b": 13.4507999420166,
    "C": 28.8374919891357,
    "h": 152.196899414063,
    "CMY_C": 0.58347487449646,
    "CMY_M": 0.37508308887482,
    "CMY_Y": 0.52182817459106,
    "CMYK_C": 0.33347117900848,
    "CMYK_M": 0,
    "CMYK_Y": 0.23482336103916,
    "CMYK_K": 0.37508308887482
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0437",
    "Farbtonhilfsbezeichnung": "110.1 Rosmarin 1",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "138",
    "Bcolor": "113",
    "Y": 22,
    "L": 53.9755020141602,
    "a": -19.285213470459,
    "b": 8.18528652191162,
    "C": 20.9503784179688,
    "h": 157.002014160156,
    "CMY_C": 0.61798715591431,
    "CMY_M": 0.45868641138077,
    "CMY_Y": 0.55528843402863,
    "CMYK_C": 0.29428550601006,
    "CMYK_M": 0,
    "CMYK_Y": 0.17845852673054,
    "CMYK_K": 0.45868641138077
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0438",
    "Farbtonhilfsbezeichnung": "110.2 Rosmarin 2",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "154",
    "Bcolor": "125",
    "Y": 28,
    "L": 59.9966201782227,
    "a": -19.7728996276856,
    "b": 9.9871187210083,
    "C": 22.1519775390625,
    "h": 153.202056884766,
    "CMY_C": 0.55588805675507,
    "CMY_M": 0.39616948366165,
    "CMY_Y": 0.50836634635925,
    "CMYK_C": 0.2645089328289,
    "CMYK_M": 0,
    "CMYK_Y": 0.18580853939056,
    "CMYK_K": 0.39616948366165
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0439",
    "Farbtonhilfsbezeichnung": "110.3 Rosmarin 3",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "184",
    "Bcolor": "152",
    "Y": 42,
    "L": 71.0356521606445,
    "a": -20.80739402771,
    "b": 11.2444429397583,
    "C": 23.6513252258301,
    "h": 151.612945556641,
    "CMY_C": 0.44797188043594,
    "CMY_M": 0.27780771255493,
    "CMY_Y": 0.40574502944946,
    "CMYK_C": 0.23562169075012,
    "CMYK_M": 0,
    "CMYK_Y": 0.17715132236481,
    "CMYK_K": 0.27780771255493
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0440",
    "Farbtonhilfsbezeichnung": "110.4 Rosmarin 4",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "210",
    "Bcolor": "183",
    "Y": 58,
    "L": 80.9468460083008,
    "a": -16.7042503356934,
    "b": 8.48738765716553,
    "C": 18.7368011474609,
    "h": 153.064987182617,
    "CMY_C": 0.31821841001511,
    "CMY_M": 0.17744970321655,
    "CMY_Y": 0.28172159194946,
    "CMYK_C": 0.17113690078259,
    "CMYK_M": 0,
    "CMYK_Y": 0.12676657736301,
    "CMYK_K": 0.17744970321655
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0441",
    "Farbtonhilfsbezeichnung": "111.1 Minze 1",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "128",
    "Bcolor": "92",
    "Y": 19,
    "L": 50.9245643615723,
    "a": -15.0060005187988,
    "b": 16.5307579040527,
    "C": 22.3259048461914,
    "h": 132.231979370117,
    "CMY_C": 0.58606785535812,
    "CMY_M": 0.49862790107727,
    "CMY_Y": 0.64017486572266,
    "CMYK_C": 0.17440131306648,
    "CMYK_M": 0,
    "CMYK_Y": 0.28231918811798,
    "CMYK_K": 0.49862790107727
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0442",
    "Farbtonhilfsbezeichnung": "111.2 Minze 2",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "148",
    "Bcolor": "102",
    "Y": 26,
    "L": 57.7969284057617,
    "a": -19.9782791137695,
    "b": 20.2028923034668,
    "C": 28.4128227233887,
    "h": 134.679718017578,
    "CMY_C": 0.5466216802597,
    "CMY_M": 0.42053323984146,
    "CMY_Y": 0.60051119327545,
    "CMYK_C": 0.21759390830994,
    "CMYK_M": 0,
    "CMYK_Y": 0.31059238314629,
    "CMYK_K": 0.42053323984146
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0443",
    "Farbtonhilfsbezeichnung": "111.3 Minze 3",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "168",
    "Bcolor": "122",
    "Y": 34,
    "L": 65.4346389770508,
    "a": -20.5480823516846,
    "b": 19.4677829742432,
    "C": 28.3057994842529,
    "h": 136.546417236328,
    "CMY_C": 0.47602498531342,
    "CMY_M": 0.33961993455887,
    "CMY_Y": 0.52063423395157,
    "CMYK_C": 0.20655536651611,
    "CMYK_M": 0,
    "CMYK_Y": 0.27410623431206,
    "CMYK_K": 0.33961993455887
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0444",
    "Farbtonhilfsbezeichnung": "111.4 Minze 4",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "192",
    "Bcolor": "154",
    "Y": 48,
    "L": 75.0610580444336,
    "a": -15.2739391326904,
    "b": 15.7485418319702,
    "C": 21.9387741088867,
    "h": 134.123519897461,
    "CMY_C": 0.34439587593079,
    "CMY_M": 0.24610358476639,
    "CMY_Y": 0.3957182765007,
    "CMYK_C": 0.13037903606892,
    "CMYK_M": 0,
    "CMYK_Y": 0.19845524430275,
    "CMYK_K": 0.24610358476639
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0445",
    "Farbtonhilfsbezeichnung": "112.1 Laubfrosch 1",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "125",
    "Bcolor": "71",
    "Y": 17,
    "L": 48.5828857421875,
    "a": -22.2477855682373,
    "b": 25.006778717041,
    "C": 33.4709281921387,
    "h": 131.658538818359,
    "CMY_C": 0.64306855201721,
    "CMY_M": 0.51119923591614,
    "CMY_Y": 0.72125160694122,
    "CMYK_C": 0.26978132128716,
    "CMYK_M": 0,
    "CMYK_Y": 0.42973002791405,
    "CMYK_K": 0.51119923591614
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0446",
    "Farbtonhilfsbezeichnung": "112.2 Laubfrosch 2",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "153",
    "Bcolor": "77",
    "Y": 27,
    "L": 58.4792976379395,
    "a": -28.5011291503906,
    "b": 34.2354927062988,
    "C": 44.5464172363281,
    "h": 129.777465820313,
    "CMY_C": 0.57302844524384,
    "CMY_M": 0.40116995573044,
    "CMY_Y": 0.69646155834198,
    "CMYK_C": 0.28699043393135,
    "CMYK_M": 0,
    "CMYK_Y": 0.49311420321465,
    "CMYK_K": 0.40116995573044
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0447",
    "Farbtonhilfsbezeichnung": "112.3 Laubfrosch 3",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "182",
    "Bcolor": "85",
    "Y": 39,
    "L": 68.7286529541016,
    "a": -31.9266471862793,
    "b": 43.0796165466309,
    "C": 53.6205558776855,
    "h": 126.542434692383,
    "CMY_C": 0.47508901357651,
    "CMY_M": 0.28818482160568,
    "CMY_Y": 0.66623306274414,
    "CMYK_C": 0.2625740468502,
    "CMYK_M": 0,
    "CMYK_Y": 0.5311045050621,
    "CMYK_K": 0.28818482160568
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0448",
    "Farbtonhilfsbezeichnung": "112.4 Laubfrosch 4",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "196",
    "Bcolor": "106",
    "Y": 47,
    "L": 74.1487884521484,
    "a": -31.2149276733398,
    "b": 39.7375831604004,
    "C": 50.5316467285156,
    "h": 128.150573730469,
    "CMY_C": 0.41914266347885,
    "CMY_M": 0.23034518957138,
    "CMY_Y": 0.58576214313507,
    "CMYK_C": 0.24530149996281,
    "CMYK_M": 0,
    "CMYK_Y": 0.46178749203682,
    "CMYK_K": 0.23034518957138
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0449",
    "Farbtonhilfsbezeichnung": "113.1 Zypresse 1",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "143",
    "Bcolor": "76",
    "Y": 24,
    "L": 55.9756507873535,
    "a": -21.1509628295898,
    "b": 31.8863277435303,
    "C": 38.2635726928711,
    "h": 123.557258605957,
    "CMY_C": 0.54564666748047,
    "CMY_M": 0.43899983167648,
    "CMY_Y": 0.70123171806335,
    "CMYK_C": 0.19010125100613,
    "CMYK_M": 0,
    "CMYK_Y": 0.4674363732338,
    "CMYK_K": 0.43899983167648
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0450",
    "Farbtonhilfsbezeichnung": "113.2 Zypresse 2",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "166",
    "Bcolor": "106",
    "Y": 33,
    "L": 64.5435333251953,
    "a": -21.3403797149658,
    "b": 26.8763408660889,
    "C": 34.3183555603027,
    "h": 128.450317382813,
    "CMY_C": 0.47113209962845,
    "CMY_M": 0.34886628389359,
    "CMY_Y": 0.58249759674072,
    "CMYK_C": 0.18777374923229,
    "CMYK_M": 0,
    "CMYK_Y": 0.35880696773529,
    "CMYK_K": 0.34886628389359
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0451",
    "Farbtonhilfsbezeichnung": "113.3 Zypresse 3",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "195",
    "Bcolor": "143",
    "Y": 49,
    "L": 75.7362594604492,
    "a": -18.3845748901367,
    "b": 22.5158882141113,
    "C": 29.0681571960449,
    "h": 129.232177734375,
    "CMY_C": 0.34227001667023,
    "CMY_M": 0.23400813341141,
    "CMY_Y": 0.43832635879517,
    "CMYK_C": 0.14133554697037,
    "CMYK_M": 0,
    "CMYK_Y": 0.266736805439,
    "CMYK_K": 0.23400813341141
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0452",
    "Farbtonhilfsbezeichnung": "113.4 Zypresse 4",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "212",
    "Bcolor": "144",
    "Y": 59,
    "L": 81.1908493041992,
    "a": -22.8351650238037,
    "b": 29.7473926544189,
    "C": 37.5013618469238,
    "h": 127.511131286621,
    "CMY_C": 0.29984784126282,
    "CMY_M": 0.16705566644669,
    "CMY_Y": 0.43664991855621,
    "CMYK_C": 0.15942503511906,
    "CMYK_M": 0,
    "CMYK_Y": 0.32366418838501,
    "CMYK_K": 0.16705566644669
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0453",
    "Farbtonhilfsbezeichnung": "114.1 Klee 1",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "161",
    "Bcolor": "44",
    "Y": 32,
    "L": 62.4360084533691,
    "a": -24.9290313720703,
    "b": 54.1967697143555,
    "C": 59.6552314758301,
    "h": 114.701141357422,
    "CMY_C": 0.46883225440979,
    "CMY_M": 0.36800253391266,
    "CMY_Y": 0.82680732011795,
    "CMYK_C": 0.15954133868217,
    "CMYK_M": 0,
    "CMYK_Y": 0.72595983743668,
    "CMYK_K": 0.36800253391266
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0454",
    "Farbtonhilfsbezeichnung": "114.2 Klee 2",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "175",
    "Bcolor": "74",
    "Y": 39,
    "L": 68.1752166748047,
    "a": -20.7327327728271,
    "b": 48.1365394592285,
    "C": 52.4115715026855,
    "h": 113.301872253418,
    "CMY_C": 0.38559228181839,
    "CMY_M": 0.31449890136719,
    "CMY_Y": 0.71011078357697,
    "CMYK_C": 0.10371009260416,
    "CMYK_M": 0,
    "CMYK_Y": 0.57711338996887,
    "CMYK_K": 0.31449890136719
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0455",
    "Farbtonhilfsbezeichnung": "114.3 Klee 3",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "191",
    "Bcolor": "104",
    "Y": 47,
    "L": 74.5045700073242,
    "a": -17.7589511871338,
    "b": 41.5648345947266,
    "C": 45.1997337341309,
    "h": 113.135032653809,
    "CMY_C": 0.30673015117645,
    "CMY_M": 0.25170820951462,
    "CMY_Y": 0.59328997135162,
    "CMYK_C": 0.0735300630331,
    "CMYK_M": 0,
    "CMYK_Y": 0.45648205280304,
    "CMYK_K": 0.25170820951462
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0456",
    "Farbtonhilfsbezeichnung": "114.4 Klee 4",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "205",
    "Bcolor": "132",
    "Y": 56,
    "L": 79.7320175170898,
    "a": -15.9963359832764,
    "b": 33.8436965942383,
    "C": 37.4336547851563,
    "h": 115.297912597656,
    "CMY_C": 0.25245958566666,
    "CMY_M": 0.19734597206116,
    "CMY_Y": 0.4810830950737,
    "CMYK_C": 0.0686642229557,
    "CMYK_M": 0,
    "CMYK_Y": 0.35349866747856,
    "CMYK_K": 0.19734597206116
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0457",
    "Farbtonhilfsbezeichnung": "115.1 Seegras 1",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "156",
    "Bcolor": "84",
    "Y": 30,
    "L": 61.8232841491699,
    "a": -16.2140369415283,
    "b": 35.2771224975586,
    "C": 38.8248672485352,
    "h": 114.684410095215,
    "CMY_C": 0.44289284944534,
    "CMY_M": 0.38800364732742,
    "CMY_Y": 0.66943359375,
    "CMYK_C": 0.089688770473,
    "CMYK_M": 0,
    "CMYK_Y": 0.45985558629036,
    "CMYK_K": 0.38800364732742
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0458",
    "Farbtonhilfsbezeichnung": "115.2 Seegras 2",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "172",
    "Bcolor": "108",
    "Y": 39,
    "L": 68.2110900878906,
    "a": -13.9920520782471,
    "b": 31.0418720245361,
    "C": 34.0496025085449,
    "h": 114.263359069824,
    "CMY_C": 0.36803936958313,
    "CMY_M": 0.32472389936447,
    "CMY_Y": 0.5753767490387,
    "CMYK_C": 0.06414482742548,
    "CMYK_M": 0,
    "CMYK_Y": 0.37118571996689,
    "CMYK_K": 0.32472389936447
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0459",
    "Farbtonhilfsbezeichnung": "115.3 Seegras 3",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "192",
    "Bcolor": "139",
    "Y": 49,
    "L": 75.7631530761719,
    "a": -11.612699508667,
    "b": 25.0354728698731,
    "C": 27.5976390838623,
    "h": 114.884216308594,
    "CMY_C": 0.28342515230179,
    "CMY_M": 0.24785572290421,
    "CMY_Y": 0.45527321100235,
    "CMYK_C": 0.04729070141912,
    "CMYK_M": 0,
    "CMYK_Y": 0.27576822042465,
    "CMYK_K": 0.24785572290421
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0460",
    "Farbtonhilfsbezeichnung": "115.4 Seegras 4",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "209",
    "Bcolor": "168",
    "Y": 61,
    "L": 82.4529571533203,
    "a": -8.98664379119873,
    "b": 19.129581451416,
    "C": 21.1352939605713,
    "h": 115.163070678711,
    "CMY_C": 0.20625084638596,
    "CMY_M": 0.17950522899628,
    "CMY_Y": 0.34238934516907,
    "CMYK_C": 0.03259693831205,
    "CMYK_M": 0,
    "CMYK_Y": 0.19851937890053,
    "CMYK_K": 0.17950522899628
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0461",
    "Farbtonhilfsbezeichnung": "116.1 Bambus 1",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "156",
    "Bcolor": "75",
    "Y": 31,
    "L": 62.3176651000977,
    "a": -14.745078086853,
    "b": 40.8492012023926,
    "C": 43.4289588928223,
    "h": 109.84774017334,
    "CMY_C": 0.41791081428528,
    "CMY_M": 0.38637846708298,
    "CMY_Y": 0.70689427852631,
    "CMYK_C": 0.05138728767633,
    "CMYK_M": 0,
    "CMYK_Y": 0.52233469486237,
    "CMYK_K": 0.38637846708298
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0462",
    "Farbtonhilfsbezeichnung": "116.2 Bambus 2",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "181",
    "Bcolor": "79",
    "Y": 42,
    "L": 70.6807022094727,
    "a": -18.7201976776123,
    "b": 48.8245811462402,
    "C": 52.290397644043,
    "h": 110.977699279785,
    "CMY_C": 0.34295493364334,
    "CMY_M": 0.29175025224686,
    "CMY_Y": 0.69013732671738,
    "CMYK_C": 0.07229749113321,
    "CMYK_M": 0,
    "CMYK_Y": 0.56249517202377,
    "CMYK_K": 0.29175025224686
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0463",
    "Farbtonhilfsbezeichnung": "116.3 Bambus 3",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "204",
    "Bcolor": "94",
    "Y": 56,
    "L": 79.3063507080078,
    "a": -17.7943782806396,
    "b": 52.4246940612793,
    "C": 55.3623390197754,
    "h": 108.74861907959,
    "CMY_C": 0.23525232076645,
    "CMY_M": 0.20105350017548,
    "CMY_Y": 0.63262867927551,
    "CMYK_C": 0.04280489310622,
    "CMYK_M": 0,
    "CMYK_Y": 0.54018032550812,
    "CMYK_K": 0.20105350017548
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0464",
    "Farbtonhilfsbezeichnung": "116.4 Bambus 4",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "221",
    "Bcolor": "142",
    "Y": 69,
    "L": 86.0402526855469,
    "a": -12.9551982879639,
    "b": 37.5147895812988,
    "C": 39.6887474060059,
    "h": 109.051628112793,
    "CMY_C": 0.15209156274796,
    "CMY_M": 0.13499462604523,
    "CMY_Y": 0.4436194896698,
    "CMYK_C": 0.01976512186229,
    "CMYK_M": 0,
    "CMYK_Y": 0.35678952932358,
    "CMYK_K": 0.13499462604523
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0465",
    "Farbtonhilfsbezeichnung": "117.1 Grashuepfer 1",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "178",
    "Bcolor": "84",
    "Y": 42,
    "L": 71.0395889282227,
    "a": -12.2203426361084,
    "b": 47.2034530639648,
    "C": 48.7596435546875,
    "h": 104.514450073242,
    "CMY_C": 0.29647278785706,
    "CMY_M": 0.30061048269272,
    "CMY_Y": 0.67117238044739,
    "CMYK_C": 0,
    "CMYK_M": 0.00588135700673,
    "CMYK_Y": 0.53260141611099,
    "CMYK_K": 0.29647278785706
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0466",
    "Farbtonhilfsbezeichnung": "117.2 Grashuepfer 2",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "202",
    "Bcolor": "90",
    "Y": 56,
    "L": 79.1662292480469,
    "a": -15.5563716888428,
    "b": 53.9599418640137,
    "C": 56.157600402832,
    "h": 106.082000732422,
    "CMY_C": 0.21869283914566,
    "CMY_M": 0.20731180906296,
    "CMY_Y": 0.6463907957077,
    "CMYK_C": 0.01435751188546,
    "CMYK_M": 0,
    "CMYK_Y": 0.55391132831573,
    "CMYK_K": 0.20731180906296
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0467",
    "Farbtonhilfsbezeichnung": "117.3 Grashuepfer 3",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "218",
    "Bcolor": "137",
    "Y": 68,
    "L": 85.5183563232422,
    "a": -11.4830465316773,
    "b": 39.491626739502,
    "C": 41.1272277832031,
    "h": 106.212928771973,
    "CMY_C": 0.14320152997971,
    "CMY_M": 0.14425808191299,
    "CMY_Y": 0.46391975879669,
    "CMYK_C": 0,
    "CMYK_M": 0.00123313942458,
    "CMYK_Y": 0.37432166934013,
    "CMYK_K": 0.14320152997971
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0468",
    "Farbtonhilfsbezeichnung": "117.4 Grashuepfer 4",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "224",
    "Bcolor": "172",
    "Y": 73,
    "L": 88.0888824462891,
    "a": -7.36568832397461,
    "b": 24.9024066925049,
    "C": 25.9688892364502,
    "h": 106.477279663086,
    "CMY_C": 0.11671537160873,
    "CMY_M": 0.12216079235077,
    "CMY_Y": 0.3255957365036,
    "CMYK_C": 0,
    "CMYK_M": 0.00616496708244,
    "CMYK_Y": 0.23648138344288,
    "CMYK_K": 0.11671537160873
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0469",
    "Farbtonhilfsbezeichnung": "118.1 Birke 1",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "216",
    "Bcolor": "146",
    "Y": 66,
    "L": 84.4987030029297,
    "a": -12.0376586914063,
    "b": 33.1006202697754,
    "C": 35.2215309143066,
    "h": 109.984741210938,
    "CMY_C": 0.17210930585861,
    "CMY_M": 0.15320497751236,
    "CMY_Y": 0.42569524049759,
    "CMYK_C": 0.02232456207275,
    "CMYK_M": 0,
    "CMYK_Y": 0.32179009914398,
    "CMYK_K": 0.15320497751236
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0470",
    "Farbtonhilfsbezeichnung": "118.2 Birke 2",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "224",
    "Bcolor": "169",
    "Y": 73,
    "L": 87.8842315673828,
    "a": -9.05794143676758,
    "b": 26.3117160797119,
    "C": 27.8271942138672,
    "h": 108.996284484863,
    "CMY_C": 0.12813818454742,
    "CMY_M": 0.12095272541046,
    "CMY_Y": 0.33862954378128,
    "CMYK_C": 0.00817414373159,
    "CMYK_M": 0,
    "CMYK_Y": 0.24762810766697,
    "CMYK_K": 0.12095272541046
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0471",
    "Farbtonhilfsbezeichnung": "118.3 Birke 3",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "231",
    "Bcolor": "187",
    "Y": 79,
    "L": 90.8440170288086,
    "a": -6.43574285507202,
    "b": 20.8583831787109,
    "C": 21.8286724090576,
    "h": 107.147331237793,
    "CMY_C": 0.08924072980881,
    "CMY_M": 0.0927260518074,
    "CMY_Y": 0.26584792137146,
    "CMYK_C": 0,
    "CMYK_M": 0.00382683123462,
    "CMYK_Y": 0.19391204416752,
    "CMYK_K": 0.08924072980881
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0472",
    "Farbtonhilfsbezeichnung": "118.4 Birke 4",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "238",
    "Bcolor": "203",
    "Y": 84,
    "L": 93.3448638916016,
    "a": -4.66848850250244,
    "b": 15.9730110168457,
    "C": 16.6412696838379,
    "h": 106.29224395752,
    "CMY_C": 0.06111282110214,
    "CMY_M": 0.06765669584274,
    "CMY_Y": 0.20199030637741,
    "CMYK_C": 0,
    "CMYK_M": 0.00696982024238,
    "CMYK_Y": 0.15004730224609,
    "CMYK_K": 0.06111282110214
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0473",
    "Farbtonhilfsbezeichnung": "119.1 Farn 1",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "207",
    "Bcolor": "110",
    "Y": 58,
    "L": 80.5535278320313,
    "a": -17.3452529907227,
    "b": 46.4079055786133,
    "C": 49.5434303283691,
    "h": 110.493553161621,
    "CMY_C": 0.22817945480347,
    "CMY_M": 0.18756067752838,
    "CMY_Y": 0.57043421268463,
    "CMYK_C": 0.04999607428908,
    "CMYK_M": 0,
    "CMYK_Y": 0.47126415371895,
    "CMYK_K": 0.18756067752838
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0474",
    "Farbtonhilfsbezeichnung": "119.2 Farn 2",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "226",
    "Bcolor": "151",
    "Y": 71,
    "L": 87.6259155273438,
    "a": -14.8067684173584,
    "b": 35.1643218994141,
    "C": 38.1545524597168,
    "h": 112.834678649902,
    "CMY_C": 0.15322375297546,
    "CMY_M": 0.11305898427963,
    "CMY_Y": 0.409519135952,
    "CMYK_C": 0.04528459906578,
    "CMYK_M": 0,
    "CMYK_Y": 0.33425012230873,
    "CMYK_K": 0.11305898427963
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0475",
    "Farbtonhilfsbezeichnung": "119.3 Farn 3",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "231",
    "Bcolor": "169",
    "Y": 75,
    "L": 89.5584106445313,
    "a": -12.9009304046631,
    "b": 28.1416034698486,
    "C": 30.9577751159668,
    "h": 114.62809753418,
    "CMY_C": 0.13395112752914,
    "CMY_M": 0.09428507089615,
    "CMY_Y": 0.33546811342239,
    "CMYK_C": 0.04379529878497,
    "CMYK_M": 0,
    "CMYK_Y": 0.26629024744034,
    "CMYK_K": 0.09428507089615
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0476",
    "Farbtonhilfsbezeichnung": "119.4 Farn 4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "186",
    "Y": 82,
    "L": 92.0659027099609,
    "a": -8.25524520874023,
    "b": 23.152961730957,
    "C": 24.5806579589844,
    "h": 109.623817443848,
    "CMY_C": 0.08322912454605,
    "CMY_M": 0.07544827461243,
    "CMY_Y": 0.270323574543,
    "CMYK_C": 0.00841580796987,
    "CMYK_M": 0,
    "CMYK_Y": 0.21077814698219,
    "CMYK_K": 0.07544827461243
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0477",
    "Farbtonhilfsbezeichnung": "120.1 Linde 1",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "204",
    "Bcolor": "142",
    "Y": 57,
    "L": 79.9068832397461,
    "a": -13.9300146102905,
    "b": 29.0888767242432,
    "C": 32.2522583007813,
    "h": 115.588722229004,
    "CMY_C": 0.24601173400879,
    "CMY_M": 0.19884729385376,
    "CMY_Y": 0.44325083494186,
    "CMYK_C": 0.05887072533369,
    "CMYK_M": 0,
    "CMYK_Y": 0.30506485700607,
    "CMYK_K": 0.19884729385376
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0478",
    "Farbtonhilfsbezeichnung": "120.2 Linde 2",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "219",
    "Bcolor": "162",
    "Y": 67,
    "L": 85.5437164306641,
    "a": -12.0187654495239,
    "b": 26.3648281097412,
    "C": 28.9750728607178,
    "h": 114.50651550293,
    "CMY_C": 0.17633146047592,
    "CMY_M": 0.14043831825256,
    "CMY_Y": 0.36415183544159,
    "CMYK_C": 0.0417574942112,
    "CMYK_M": 0,
    "CMYK_Y": 0.26026463508606,
    "CMYK_K": 0.14043831825256
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0479",
    "Farbtonhilfsbezeichnung": "120.3 Linde 3",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "231",
    "Bcolor": "190",
    "Y": 77,
    "L": 90.4287796020508,
    "a": -8.02915382385254,
    "b": 18.5840473175049,
    "C": 20.2443599700928,
    "h": 113.366546630859,
    "CMY_C": 0.11227631568909,
    "CMY_M": 0.09325402975082,
    "CMY_Y": 0.25355333089828,
    "CMYK_C": 0.02097862772644,
    "CMYK_M": 0,
    "CMYK_Y": 0.1767852306366,
    "CMYK_K": 0.09325402975082
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0480",
    "Farbtonhilfsbezeichnung": "120.4 Linde 4",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "233",
    "Bcolor": "197",
    "Y": 80,
    "L": 91.0751495361328,
    "a": -6.99112892150879,
    "b": 15.9481887817383,
    "C": 17.4132308959961,
    "h": 113.670967102051,
    "CMY_C": 0.10456240177155,
    "CMY_M": 0.08775895833969,
    "CMY_Y": 0.22674566507339,
    "CMYK_C": 0.01841996051371,
    "CMYK_M": 0,
    "CMYK_Y": 0.15235742926598,
    "CMYK_K": 0.08775895833969
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0481",
    "Farbtonhilfsbezeichnung": "121.1 Fenchel 1",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "214",
    "Bcolor": "153",
    "Y": 63,
    "L": 82.8265151977539,
    "a": -17.6105461120606,
    "b": 27.0688781738281,
    "C": 32.2932739257813,
    "h": 123.047332763672,
    "CMY_C": 0.24749463796616,
    "CMY_M": 0.1588973402977,
    "CMY_Y": 0.39874881505966,
    "CMYK_C": 0.1053346991539,
    "CMYK_M": 0,
    "CMYK_Y": 0.28516313433647,
    "CMYK_K": 0.1588973402977
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0482",
    "Farbtonhilfsbezeichnung": "121.2 Fenchel 2",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "221",
    "Bcolor": "155",
    "Y": 68,
    "L": 85.5369491577148,
    "a": -15.1981840133667,
    "b": 29.7676811218262,
    "C": 33.4230422973633,
    "h": 117.04704284668,
    "CMY_C": 0.1921678185463,
    "CMY_M": 0.13443261384964,
    "CMY_Y": 0.39036065340042,
    "CMYK_C": 0.06670214980841,
    "CMYK_M": 0,
    "CMYK_Y": 0.29567661881447,
    "CMYK_K": 0.13443261384964
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0483",
    "Farbtonhilfsbezeichnung": "121.3 Fenchel 3",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "227",
    "Bcolor": "179",
    "Y": 74,
    "L": 88.4206771850586,
    "a": -10.7929744720459,
    "b": 21.7518730163574,
    "C": 24.2823448181152,
    "h": 116.389961242676,
    "CMY_C": 0.1471785902977,
    "CMY_M": 0.11022591590881,
    "CMY_Y": 0.29912382364273,
    "CMYK_C": 0.0415304005146,
    "CMYK_M": 0,
    "CMYK_Y": 0.21229873597622,
    "CMYK_K": 0.11022591590881
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0484",
    "Farbtonhilfsbezeichnung": "121.4 Fenchel 4",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "237",
    "Bcolor": "206",
    "Y": 82,
    "L": 92.4606399536133,
    "a": -6.98530912399292,
    "b": 13.3657064437866,
    "C": 15.0810031890869,
    "h": 117.592880249023,
    "CMY_C": 0.09671467542648,
    "CMY_M": 0.07163721323013,
    "CMY_Y": 0.19245189428329,
    "CMYK_C": 0.02701256796718,
    "CMYK_M": 0,
    "CMYK_Y": 0.13013735413551,
    "CMYK_K": 0.07163721323013
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0485",
    "Farbtonhilfsbezeichnung": "122.1 Apfel 1",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "213",
    "Bcolor": "147",
    "Y": 60,
    "L": 81.6550979614258,
    "a": -20.8354511260986,
    "b": 28.8001213073731,
    "C": 35.546630859375,
    "h": 125.883857727051,
    "CMY_C": 0.28122341632843,
    "CMY_M": 0.16567581892014,
    "CMY_Y": 0.42439848184586,
    "CMYK_C": 0.13849245011806,
    "CMYK_M": 0,
    "CMYK_Y": 0.31009846925735,
    "CMYK_K": 0.16567581892014
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0486",
    "Farbtonhilfsbezeichnung": "122.2 Apfel 2",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "216",
    "Bcolor": "167",
    "Y": 65,
    "L": 83.8124008178711,
    "a": -14.9449605941773,
    "b": 21.1706581115723,
    "C": 25.9142551422119,
    "h": 125.219329833984,
    "CMY_C": 0.23188972473145,
    "CMY_M": 0.15232837200165,
    "CMY_Y": 0.34416818618774,
    "CMYK_C": 0.09385869652033,
    "CMYK_M": 0,
    "CMYK_Y": 0.226313829422,
    "CMYK_K": 0.15232837200165
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0487",
    "Farbtonhilfsbezeichnung": "122.3 Apfel 3",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "224",
    "Bcolor": "183",
    "Y": 72,
    "L": 87.1783752441406,
    "a": -12.0706357955933,
    "b": 17.9447574615479,
    "C": 21.626708984375,
    "h": 123.926948547363,
    "CMY_C": 0.18165749311447,
    "CMY_M": 0.12043935060501,
    "CMY_Y": 0.28419995307922,
    "CMYK_C": 0.06960082054138,
    "CMYK_M": 0,
    "CMYK_Y": 0.18618455529213,
    "CMYK_K": 0.12043935060501
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0488",
    "Farbtonhilfsbezeichnung": "122.4 Apfel 4",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "233",
    "Bcolor": "198",
    "Y": 79,
    "L": 90.4838256835938,
    "a": -9.74067497253418,
    "b": 14.4995183944702,
    "C": 17.4675922393799,
    "h": 123.892921447754,
    "CMY_C": 0.13704013824463,
    "CMY_M": 0.08788239955902,
    "CMY_Y": 0.22276329994202,
    "CMYK_C": 0.05389408022165,
    "CMYK_M": 0,
    "CMYK_Y": 0.14787665009499,
    "CMYK_K": 0.08788239955902
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0489",
    "Farbtonhilfsbezeichnung": "123.1 Pistacia 1",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "231",
    "Bcolor": "183",
    "Y": 73,
    "L": 88.0980453491211,
    "a": -20.4116954803467,
    "b": 18.6358222961426,
    "C": 27.6393051147461,
    "h": 137.60400390625,
    "CMY_C": 0.23777168989182,
    "CMY_M": 0.09294259548187,
    "CMY_Y": 0.28087592124939,
    "CMYK_C": 0.1596691608429,
    "CMYK_M": 0,
    "CMYK_Y": 0.20719011127949,
    "CMYK_K": 0.09294259548187
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0490",
    "Farbtonhilfsbezeichnung": "123.2 Pistacia 2",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "231",
    "Bcolor": "193",
    "Y": 74,
    "L": 88.8956451416016,
    "a": -15.2012758255005,
    "b": 14.7501192092896,
    "C": 21.1812362670898,
    "h": 135.862976074219,
    "CMY_C": 0.19802099466324,
    "CMY_M": 0.09391248226166,
    "CMY_Y": 0.24258625507355,
    "CMYK_C": 0.11489895731211,
    "CMYK_M": 0,
    "CMYK_Y": 0.16408324241638,
    "CMYK_K": 0.09391248226166
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0491",
    "Farbtonhilfsbezeichnung": "123.3 Pistacia 3",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "239",
    "Bcolor": "215",
    "Y": 82,
    "L": 92.7206878662109,
    "a": -9.00366687774658,
    "b": 9.19847774505615,
    "C": 12.8715972900391,
    "h": 134.386810302734,
    "CMY_C": 0.12324583530426,
    "CMY_M": 0.06313735246658,
    "CMY_Y": 0.1587992310524,
    "CMYK_C": 0.0641593337059,
    "CMYK_M": 0,
    "CMYK_Y": 0.10210875421762,
    "CMYK_K": 0.06313735246658
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0492",
    "Farbtonhilfsbezeichnung": "123.4 Pistacia 4",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "240",
    "Bcolor": "226",
    "Y": 85,
    "L": 93.8107376098633,
    "a": -5.82527828216553,
    "b": 5.03974485397339,
    "C": 7.7027850151062,
    "h": 139.135238647461,
    "CMY_C": 0.0993247628212,
    "CMY_M": 0.0569748878479,
    "CMY_Y": 0.11530309915543,
    "CMYK_C": 0.04490853473544,
    "CMYK_M": 0,
    "CMYK_Y": 0.06185223534703,
    "CMYK_K": 0.0569748878479
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0493",
    "Farbtonhilfsbezeichnung": "124.1 Waldmeister 1",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "214",
    "Bcolor": "151",
    "Y": 58,
    "L": 80.8021087646484,
    "a": -27.5819988250732,
    "b": 25.0905818939209,
    "C": 37.2867813110352,
    "h": 137.708068847656,
    "CMY_C": 0.35761898756027,
    "CMY_M": 0.16150003671646,
    "CMY_Y": 0.40672099590302,
    "CMYK_C": 0.23389261960983,
    "CMYK_M": 0,
    "CMYK_Y": 0.29245194792747,
    "CMYK_K": 0.16150003671646
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0494",
    "Farbtonhilfsbezeichnung": "124.2 Waldmeister 2",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "220",
    "Bcolor": "171",
    "Y": 63,
    "L": 83.467903137207,
    "a": -23.8290348052979,
    "b": 18.3037090301514,
    "C": 30.0474395751953,
    "h": 142.47119140625,
    "CMY_C": 0.31846272945404,
    "CMY_M": 0.13773214817047,
    "CMY_Y": 0.32801151275635,
    "CMYK_C": 0.20959912240505,
    "CMYK_M": 0,
    "CMYK_Y": 0.22067315876484,
    "CMYK_K": 0.13773214817047
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0495",
    "Farbtonhilfsbezeichnung": "124.3 Waldmeister 3",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "231",
    "Bcolor": "199",
    "Y": 74,
    "L": 88.9660110473633,
    "a": -14.6583156585693,
    "b": 11.9770164489746,
    "C": 18.9292144775391,
    "h": 140.748428344727,
    "CMY_C": 0.20194751024246,
    "CMY_M": 0.09362143278122,
    "CMY_Y": 0.22114360332489,
    "CMYK_C": 0.11951526999474,
    "CMYK_M": 0,
    "CMYK_Y": 0.1406941562891,
    "CMYK_K": 0.09362143278122
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0496",
    "Farbtonhilfsbezeichnung": "124.4 Waldmeister 4",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "235",
    "Bcolor": "209",
    "Y": 79,
    "L": 91.0328063964844,
    "a": -11.0250759124756,
    "b": 9.5251636505127,
    "C": 14.5698671340942,
    "h": 139.174468994141,
    "CMY_C": 0.15739279985428,
    "CMY_M": 0.07770019769669,
    "CMY_Y": 0.17996728420258,
    "CMYK_C": 0.08640639483929,
    "CMYK_M": 0,
    "CMYK_Y": 0.11088269203901,
    "CMYK_K": 0.07770019769669
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0497",
    "Farbtonhilfsbezeichnung": "125.1 Weide 1",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "203",
    "Bcolor": "159",
    "Y": 53,
    "L": 77.5575714111328,
    "a": -22.5810985565186,
    "b": 16.5093994140625,
    "C": 27.972599029541,
    "h": 143.828872680664,
    "CMY_C": 0.37661826610565,
    "CMY_M": 0.20488184690475,
    "CMY_Y": 0.37648499011993,
    "CMYK_C": 0.21598854660988,
    "CMYK_M": 0,
    "CMYK_Y": 0.21582093834877,
    "CMYK_K": 0.20488184690475
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0498",
    "Farbtonhilfsbezeichnung": "125.2 Weide 2",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "216",
    "Bcolor": "176",
    "Y": 64,
    "L": 83.3722534179688,
    "a": -16.6572780609131,
    "b": 15.6827774047852,
    "C": 22.8782520294189,
    "h": 136.725967407227,
    "CMY_C": 0.26709854602814,
    "CMY_M": 0.15248078107834,
    "CMY_Y": 0.30860084295273,
    "CMYK_C": 0.13523913919926,
    "CMYK_M": 0,
    "CMYK_Y": 0.1842082887888,
    "CMYK_K": 0.15248078107834
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0499",
    "Farbtonhilfsbezeichnung": "125.3 Weide 3",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "227",
    "Bcolor": "198",
    "Y": 74,
    "L": 88.2974395751953,
    "a": -10.1855297088623,
    "b": 11.380937576294,
    "C": 15.2732038497925,
    "h": 131.827407836914,
    "CMY_C": 0.17452991008759,
    "CMY_M": 0.11055153608322,
    "CMY_Y": 0.22327476739883,
    "CMYK_C": 0.07193038612604,
    "CMYK_M": 0,
    "CMYK_Y": 0.12673385441303,
    "CMYK_K": 0.11055153608322
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0500",
    "Farbtonhilfsbezeichnung": "125.4 Weide 4",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "228",
    "Bcolor": "208",
    "Y": 75,
    "L": 88.8988952636719,
    "a": -8.02805137634277,
    "b": 7.14834260940552,
    "C": 10.7493448257446,
    "h": 138.317474365234,
    "CMY_C": 0.16443985700607,
    "CMY_M": 0.10754841566086,
    "CMY_Y": 0.18513906002045,
    "CMYK_C": 0.06374736875296,
    "CMYK_M": 0,
    "CMYK_Y": 0.08694101125002,
    "CMYK_K": 0.10754841566086
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0501",
    "Farbtonhilfsbezeichnung": "126.1 Aloe 1",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "185",
    "Bcolor": "163",
    "Y": 45,
    "L": 72.7105178833008,
    "a": -12.1165351867676,
    "b": 7.5248851776123,
    "C": 14.2630405426025,
    "h": 148.157943725586,
    "CMY_C": 0.37021386623383,
    "CMY_M": 0.275918841362,
    "CMY_Y": 0.36080139875412,
    "CMYK_C": 0.13022714853287,
    "CMYK_M": 0,
    "CMYK_Y": 0.11722796410322,
    "CMYK_K": 0.275918841362
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0502",
    "Farbtonhilfsbezeichnung": "126.2 Aloe 2",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "216",
    "Bcolor": "199",
    "Y": 64,
    "L": 84.0970687866211,
    "a": -10.9290561676025,
    "b": 4.76121187210083,
    "C": 11.9211330413818,
    "h": 156.459777832031,
    "CMY_C": 0.24899077415466,
    "CMY_M": 0.15383893251419,
    "CMY_Y": 0.22003096342087,
    "CMYK_C": 0.1124512180686,
    "CMYK_M": 0,
    "CMYK_Y": 0.07822627574205,
    "CMYK_K": 0.15383893251419
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0503",
    "Farbtonhilfsbezeichnung": "126.3 Aloe 3",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "228",
    "Bcolor": "213",
    "Y": 74,
    "L": 88.8630523681641,
    "a": -8.65346717834473,
    "b": 4.49266004562378,
    "C": 9.75020408630371,
    "h": 152.562805175781,
    "CMY_C": 0.17915338277817,
    "CMY_M": 0.10586905479431,
    "CMY_Y": 0.1659968495369,
    "CMYK_C": 0.08196151256561,
    "CMYK_M": 0,
    "CMYK_Y": 0.06724718958139,
    "CMYK_K": 0.10586905479431
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0504",
    "Farbtonhilfsbezeichnung": "126.4 Aloe 4",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "238",
    "Bcolor": "220",
    "Y": 83,
    "L": 92.7094345092773,
    "a": -7.96368551254272,
    "b": 6.10462188720703,
    "C": 10.034276008606,
    "h": 142.527770996094,
    "CMY_C": 0.12537723779678,
    "CMY_M": 0.06479161977768,
    "CMY_Y": 0.13569396734238,
    "CMYK_C": 0.06478301435709,
    "CMYK_M": 0,
    "CMYK_Y": 0.07581449300051,
    "CMYK_K": 0.06479161977768
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0505",
    "Farbtonhilfsbezeichnung": "127.1 Martinique 1",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "211",
    "Bcolor": "195",
    "Y": 56,
    "L": 78.7106399536133,
    "a": -31.8839435577393,
    "b": -1.48077249526978,
    "C": 31.9183101654053,
    "h": 182.659057617188,
    "CMY_C": 0.54540717601776,
    "CMY_M": 0.1710222363472,
    "CMY_Y": 0.23527246713638,
    "CMYK_C": 0.45162242650986,
    "CMYK_M": 0,
    "CMYK_Y": 0.07750537246466,
    "CMYK_K": 0.1710222363472
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0506",
    "Farbtonhilfsbezeichnung": "127.2 Martinique 2",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 63,
    "L": 82.8613128662109,
    "a": -26.6448535919189,
    "b": -1.43274784088135,
    "C": 26.6833457946777,
    "h": 183.07795715332,
    "CMY_C": 0.43815380334854,
    "CMY_M": 0.13446974754333,
    "CMY_Y": 0.1901815533638,
    "CMYK_C": 0.35086473822594,
    "CMYK_M": 0,
    "CMYK_Y": 0.06436725705862,
    "CMYK_K": 0.13446974754333
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0507",
    "Farbtonhilfsbezeichnung": "127.3 Martinique 3",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "228",
    "Bcolor": "216",
    "Y": 70,
    "L": 86.2643280029297,
    "a": -21.8596515655518,
    "b": -1.27973389625549,
    "C": 21.8970794677734,
    "h": 183.350448608398,
    "CMY_C": 0.35053116083145,
    "CMY_M": 0.10574924945831,
    "CMY_Y": 0.15361458063126,
    "CMYK_C": 0.27372848987579,
    "CMYK_M": 0,
    "CMYK_Y": 0.05352562665939,
    "CMYK_K": 0.10574924945831
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0508",
    "Farbtonhilfsbezeichnung": "127.4 Martinique 4",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "238",
    "Bcolor": "229",
    "Y": 80,
    "L": 91.57861328125,
    "a": -12.6321039199829,
    "b": -0.1069673448801,
    "C": 12.6325569152832,
    "h": 180.485153198242,
    "CMY_C": 0.20096111297607,
    "CMY_M": 0.06554460525513,
    "CMY_Y": 0.10258746147156,
    "CMYK_C": 0.1449148952961,
    "CMYK_M": 0,
    "CMYK_Y": 0.03964111581445,
    "CMYK_K": 0.06554460525513
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0509",
    "Farbtonhilfsbezeichnung": "128.1 Tuerkis 1",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "125",
    "Y": 15,
    "L": 46.5618896484375,
    "a": -28.6423282623291,
    "b": -9.92214584350586,
    "C": 30.3122406005859,
    "h": 199.106872558594,
    "CMY_C": 1,
    "CMY_M": 0.51494312286377,
    "CMY_Y": 0.50922894477844,
    "CMYK_C": 1,
    "CMYK_M": 0.01164326630533,
    "CMYK_Y": 0,
    "CMYK_K": 0.50922894477844
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0510",
    "Farbtonhilfsbezeichnung": "128.2 Tuerkis 2",
    "Farbtonklasse": "03",
    "Rcolor": "24",
    "Gcolor": "144",
    "Bcolor": "148",
    "Y": 22,
    "L": 54.349967956543,
    "a": -28.5918731689453,
    "b": -11.7360868453979,
    "C": 30.9068107604981,
    "h": 202.316635131836,
    "CMY_C": 0.90782231092453,
    "CMY_M": 0.43493789434433,
    "CMY_Y": 0.41882574558258,
    "CMYK_C": 0.84139406681061,
    "CMYK_M": 0.0277234390378,
    "CMYK_Y": 0,
    "CMYK_K": 0.41882574558258
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0511",
    "Farbtonhilfsbezeichnung": "128.3 Tuerkis 3",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "171",
    "Bcolor": "170",
    "Y": 34,
    "L": 65.1739654541016,
    "a": -24.6802062988281,
    "b": -8.06817531585693,
    "C": 25.9655170440674,
    "h": 198.103012084961,
    "CMY_C": 0.64790827035904,
    "CMY_M": 0.328792989254,
    "CMY_Y": 0.33148729801178,
    "CMYK_C": 0.47543495893478,
    "CMYK_M": 0,
    "CMYK_Y": 0.00401412509382,
    "CMYK_K": 0.328792989254
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0512",
    "Farbtonhilfsbezeichnung": "128.4 Tuerkis 4",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 49,
    "L": 75.5297546386719,
    "a": -22.7929210662842,
    "b": -6.54117870330811,
    "C": 23.7129554748535,
    "h": 196.012573242188,
    "CMY_C": 0.50380504131317,
    "CMY_M": 0.22107511758804,
    "CMY_Y": 0.23208045959473,
    "CMYK_C": 0.36297458410263,
    "CMYK_M": 0,
    "CMYK_Y": 0.01412888709456,
    "CMYK_K": 0.22107511758804
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0513",
    "Farbtonhilfsbezeichnung": "129.1 Smaragd 1",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "135",
    "Bcolor": "135",
    "Y": 18,
    "L": 50.0363235473633,
    "a": -34.6104431152344,
    "b": -10.4983358383179,
    "C": 36.1676368713379,
    "h": 196.874038696289,
    "CMY_C": 1,
    "CMY_M": 0.47096657752991,
    "CMY_Y": 0.47127085924149,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.00057516538072,
    "CMYK_K": 0.47096657752991
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0514",
    "Farbtonhilfsbezeichnung": "129.2 Smaragd 2",
    "Farbtonklasse": "03",
    "Rcolor": "10",
    "Gcolor": "169",
    "Bcolor": "170",
    "Y": 31,
    "L": 62.8024406433105,
    "a": -34.4806900024414,
    "b": -11.4104204177856,
    "C": 36.3196334838867,
    "h": 198.310516357422,
    "CMY_C": 0.959985435009,
    "CMY_M": 0.33709597587585,
    "CMY_Y": 0.33409905433655,
    "CMYK_C": 0.93990916013718,
    "CMYK_M": 0.00450055161491,
    "CMYK_Y": 0,
    "CMYK_K": 0.33409905433655
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0515",
    "Farbtonhilfsbezeichnung": "129.3 Smaragd 3",
    "Farbtonklasse": "02",
    "Rcolor": "99",
    "Gcolor": "198",
    "Bcolor": "199",
    "Y": 47,
    "L": 74.2821426391602,
    "a": -28.1017608642578,
    "b": -10.4622793197632,
    "C": 29.9861335754395,
    "h": 200.420288085938,
    "CMY_C": 0.6106721162796,
    "CMY_M": 0.22397458553314,
    "CMY_Y": 0.21806919574738,
    "CMYK_C": 0.50209420919418,
    "CMYK_M": 0.00755231780931,
    "CMYK_Y": 0,
    "CMYK_K": 0.21806919574738
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0516",
    "Farbtonhilfsbezeichnung": "129.4 Smaragd 4",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "220",
    "Bcolor": "221",
    "Y": 64,
    "L": 83.6660919189453,
    "a": -18.9096546173096,
    "b": -7.65053367614746,
    "C": 20.3986682891846,
    "h": 202.027435302734,
    "CMY_C": 0.38125920295715,
    "CMY_M": 0.13875418901443,
    "CMY_Y": 0.13512724637985,
    "CMYK_C": 0.28458747267723,
    "CMYK_M": 0.00419361423701,
    "CMYK_Y": 0,
    "CMYK_K": 0.13512724637985
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0517",
    "Farbtonhilfsbezeichnung": "130.1 Antigua 1",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "157",
    "Bcolor": "138",
    "Y": 27,
    "L": 58.7395210266113,
    "a": -33.2614135742188,
    "b": 0.92545735836029,
    "C": 33.274284362793,
    "h": 178.406219482422,
    "CMY_C": 0.77502459287643,
    "CMY_M": 0.38512003421783,
    "CMY_Y": 0.46044147014618,
    "CMYK_C": 0.63411492109299,
    "CMYK_M": 0,
    "CMYK_Y": 0.12249778956175,
    "CMYK_K": 0.38512003421783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0518",
    "Farbtonhilfsbezeichnung": "130.2 Antigua 2",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "186",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.7482986450195,
    "a": -30.543083190918,
    "b": 1.54871034622192,
    "C": 30.5823230743408,
    "h": 177.097259521484,
    "CMY_C": 0.60732054710388,
    "CMY_M": 0.27216559648514,
    "CMY_Y": 0.35162651538849,
    "CMYK_C": 0.46048241853714,
    "CMYK_M": 0,
    "CMYK_Y": 0.10917444527149,
    "CMYK_K": 0.27216559648514
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0519",
    "Farbtonhilfsbezeichnung": "130.3 Antigua 3",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "209",
    "Bcolor": "196",
    "Y": 57,
    "L": 80.4503631591797,
    "a": -17.69700050354,
    "b": 0.57056480646133,
    "C": 17.7061958312988,
    "h": 178.153381347656,
    "CMY_C": 0.36412519216537,
    "CMY_M": 0.17893385887146,
    "CMY_Y": 0.22972708940506,
    "CMYK_C": 0.22554983198643,
    "CMYK_M": 0,
    "CMYK_Y": 0.06186253204942,
    "CMYK_K": 0.17893385887146
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0520",
    "Farbtonhilfsbezeichnung": "130.4 Antigua 4",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "224",
    "Bcolor": "212",
    "Y": 69,
    "L": 86.2146911621094,
    "a": -14.0605669021606,
    "b": 1.00297200679779,
    "C": 14.0962934494019,
    "h": 175.919876098633,
    "CMY_C": 0.26752054691315,
    "CMY_M": 0.12277317047119,
    "CMY_Y": 0.16994535923004,
    "CMYK_C": 0.16500563919544,
    "CMYK_M": 0,
    "CMYK_Y": 0.0537742190063,
    "CMYK_K": 0.12277317047119
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0521",
    "Farbtonhilfsbezeichnung": "131.1 Bahamas 1",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "164",
    "Bcolor": "154",
    "Y": 34,
    "L": 64.8714752197266,
    "a": -13.0519924163818,
    "b": 0.75850528478622,
    "C": 13.074013710022,
    "h": 176.674041748047,
    "CMY_C": 0.48389506340027,
    "CMY_M": 0.35559278726578,
    "CMY_Y": 0.39456760883331,
    "CMYK_C": 0.19910123944283,
    "CMYK_M": 0,
    "CMYK_Y": 0.06048166379333,
    "CMYK_K": 0.35559278726578
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0522",
    "Farbtonhilfsbezeichnung": "131.2 Bahamas 2",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "194",
    "Bcolor": "184",
    "Y": 50,
    "L": 75.9725570678711,
    "a": -11.7081089019775,
    "b": 0.78049910068512,
    "C": 11.7340955734253,
    "h": 176.186126708984,
    "CMY_C": 0.35724967718124,
    "CMY_M": 0.23993879556656,
    "CMY_Y": 0.27838450670242,
    "CMYK_C": 0.15434399247169,
    "CMYK_M": 0,
    "CMYK_Y": 0.05058239027858,
    "CMYK_K": 0.23993879556656
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0523",
    "Farbtonhilfsbezeichnung": "131.3 Bahamas 3",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "216",
    "Bcolor": "208",
    "Y": 65,
    "L": 84.5141677856445,
    "a": -8.00761127471924,
    "b": 0.46942114830017,
    "C": 8.02135848999023,
    "h": 176.645050048828,
    "CMY_C": 0.23589736223221,
    "CMY_M": 0.15441447496414,
    "CMY_Y": 0.18377763032913,
    "CMYK_C": 0.09636268019676,
    "CMYK_M": 0,
    "CMYK_Y": 0.03472523391247,
    "CMYK_K": 0.15441447496414
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0524",
    "Farbtonhilfsbezeichnung": "131.4 Bahamas 4",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "224",
    "Bcolor": "213",
    "Y": 73,
    "L": 87.8581237792969,
    "a": -6.29266786575317,
    "b": 2.79616546630859,
    "C": 6.8859429359436,
    "h": 156.041885375977,
    "CMY_C": 0.17680501937866,
    "CMY_M": 0.12184584140778,
    "CMY_Y": 0.16414213180542,
    "CMYK_C": 0.06258488446474,
    "CMYK_M": 0,
    "CMYK_Y": 0.04816499352455,
    "CMYK_K": 0.12184584140778
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0525",
    "Farbtonhilfsbezeichnung": "132.1 Atoll 1",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "180",
    "Bcolor": "179",
    "Y": 42,
    "L": 71.1809005737305,
    "a": -9.75401782989502,
    "b": -3.61248350143433,
    "C": 10.4014854431152,
    "h": 200.322540283203,
    "CMY_C": 0.40835201740265,
    "CMY_M": 0.29425114393234,
    "CMY_Y": 0.29777985811234,
    "CMYK_C": 0.16167348623276,
    "CMYK_M": 0,
    "CMYK_Y": 0.00499995751306,
    "CMYK_K": 0.29425114393234
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0526",
    "Farbtonhilfsbezeichnung": "132.2 Atoll 2",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "209",
    "Bcolor": "205",
    "Y": 59,
    "L": 81.2512283325195,
    "a": -12.0797176361084,
    "b": -2.70905017852783,
    "C": 12.3797626495361,
    "h": 192.640258789062,
    "CMY_C": 0.31869912147522,
    "CMY_M": 0.18071818351746,
    "CMY_Y": 0.19662475585938,
    "CMYK_C": 0.16841694712639,
    "CMYK_M": 0,
    "CMYK_Y": 0.01941526308656,
    "CMYK_K": 0.18071818351746
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0527",
    "Farbtonhilfsbezeichnung": "132.3 Atoll 3",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 77,
    "L": 90.3845748901367,
    "a": -8.63757801055908,
    "b": -1.73314547538757,
    "C": 8.80974197387695,
    "h": 191.345840454102,
    "CMY_C": 0.18571990728378,
    "CMY_M": 0.08720862865448,
    "CMY_Y": 0.10322654247284,
    "CMYK_C": 0.10792310535908,
    "CMYK_M": 0,
    "CMYK_Y": 0.01754827424884,
    "CMYK_K": 0.08720862865448
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0528",
    "Farbtonhilfsbezeichnung": "132.4 Atoll 4",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "235",
    "Bcolor": "231",
    "Y": 80,
    "L": 91.9950485229492,
    "a": -5.31907749176025,
    "b": -0.69939255714417,
    "C": 5.36486101150513,
    "h": 187.490707397461,
    "CMY_C": 0.13591057062149,
    "CMY_M": 0.07692968845367,
    "CMY_Y": 0.09260070323944,
    "CMYK_C": 0.06389641016722,
    "CMYK_M": 0,
    "CMYK_Y": 0.01697705499828,
    "CMYK_K": 0.07692968845367
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0529",
    "Farbtonhilfsbezeichnung": "133.1 Karibik 1",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "210",
    "Bcolor": "212",
    "Y": 56,
    "L": 79.3741989135742,
    "a": -23.6598262786865,
    "b": -9.54347038269043,
    "C": 25.5120601654053,
    "h": 201.967269897461,
    "CMY_C": 0.49055296182632,
    "CMY_M": 0.17646324634552,
    "CMY_Y": 0.16893410682678,
    "CMYK_C": 0.38699561357498,
    "CMYK_M": 0.00905961822718,
    "CMYK_Y": 0,
    "CMYK_K": 0.16893410682678
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0530",
    "Farbtonhilfsbezeichnung": "133.2 Karibik 2",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "228",
    "Bcolor": "227",
    "Y": 71,
    "L": 87.2850494384766,
    "a": -15.1164035797119,
    "b": -5.43862771987915,
    "C": 16.0650024414063,
    "h": 199.787872314453,
    "CMY_C": 0.29379457235336,
    "CMY_M": 0.10686141252518,
    "CMY_Y": 0.1109846830368,
    "CMYK_C": 0.20929916203022,
    "CMYK_M": 0,
    "CMYK_Y": 0.00461660791188,
    "CMYK_K": 0.10686141252518
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0531",
    "Farbtonhilfsbezeichnung": "133.3 Karibik 3",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "234",
    "Bcolor": "232",
    "Y": 77,
    "L": 90.1684036254883,
    "a": -11.5782661437988,
    "b": -3.92281198501587,
    "C": 12.2247581481934,
    "h": 198.716796875,
    "CMY_C": 0.22298347949982,
    "CMY_M": 0.08257055282593,
    "CMY_Y": 0.08978939056396,
    "CMYK_C": 0.15305037796497,
    "CMYK_M": 0,
    "CMYK_Y": 0.00786854792386,
    "CMYK_K": 0.08257055282593
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0532",
    "Farbtonhilfsbezeichnung": "133.4 Karibik 4",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "238",
    "Bcolor": "234",
    "Y": 82,
    "L": 92.0970993041992,
    "a": -8.66834354400635,
    "b": -2.02686882019043,
    "C": 8.90215587615967,
    "h": 193.160690307617,
    "CMY_C": 0.16831749677658,
    "CMY_M": 0.06786078214645,
    "CMY_Y": 0.08204680681229,
    "CMYK_C": 0.1077700778842,
    "CMYK_M": 0,
    "CMYK_Y": 0.01521878316998,
    "CMYK_K": 0.06786078214645
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0533",
    "Farbtonhilfsbezeichnung": "134.1 Nero 1",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "63",
    "Bcolor": "63",
    "Y": 5,
    "L": 26.6506843566895,
    "a": 0.20689025521278,
    "b": -0.49062612652779,
    "C": 0.53246366977692,
    "h": 292.864471435547,
    "CMY_C": 0.75296455621719,
    "CMY_M": 0.75300633907318,
    "CMY_Y": 0.75218391418457,
    "CMYK_C": 0.00315008615144,
    "CMYK_M": 0.00331869046204,
    "CMYK_Y": 0,
    "CMYK_K": 0.75218391418457
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0534",
    "Farbtonhilfsbezeichnung": "134.2 Nero 2",
    "Farbtonklasse": "02",
    "Rcolor": "92",
    "Gcolor": "90",
    "Bcolor": "87",
    "Y": 10,
    "L": 38.3651733398438,
    "a": 0.17144288122654,
    "b": 1.66541790962219,
    "C": 1.67421901226044,
    "h": 84.1225051879883,
    "CMY_C": 0.63999342918396,
    "CMY_M": 0.64634865522385,
    "CMY_Y": 0.65919852256775,
    "CMYK_C": 0,
    "CMYK_M": 0.01765308342874,
    "CMYK_Y": 0.05334650725126,
    "CMYK_K": 0.63999342918396
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0535",
    "Farbtonhilfsbezeichnung": "134.3 Nero 3",
    "Farbtonklasse": "01",
    "Rcolor": "120",
    "Gcolor": "120",
    "Bcolor": "116",
    "Y": 19,
    "L": 50.1781921386719,
    "a": -0.43043312430382,
    "b": 1.59961402416229,
    "C": 1.65651369094849,
    "h": 105.060729980469,
    "CMY_C": 0.53005874156952,
    "CMY_M": 0.53103917837143,
    "CMY_Y": 0.54619073867798,
    "CMYK_C": 0,
    "CMYK_M": 0.00208629644476,
    "CMYK_Y": 0.03432768955827,
    "CMYK_K": 0.53005874156952
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0536",
    "Farbtonhilfsbezeichnung": "134.4 Nero 4",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "157",
    "Bcolor": "151",
    "Y": 34,
    "L": 64.5981979370117,
    "a": -0.34213605523109,
    "b": 2.35588574409485,
    "C": 2.38059973716736,
    "h": 98.2630767822266,
    "CMY_C": 0.38078331947327,
    "CMY_M": 0.38514131307602,
    "CMY_Y": 0.40680903196335,
    "CMYK_C": 0,
    "CMYK_M": 0.00703791389242,
    "CMYK_Y": 0.04203005880117,
    "CMYK_K": 0.38078331947327
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0537",
    "Farbtonhilfsbezeichnung": "135.1 Anthrazit 1",
    "Farbtonklasse": "02",
    "Rcolor": "71",
    "Gcolor": "74",
    "Bcolor": "75",
    "Y": 7,
    "L": 31.2687015533447,
    "a": -0.78451281785965,
    "b": -1.22644340991974,
    "C": 1.45589280128479,
    "h": 237.394378662109,
    "CMY_C": 0.7202125787735,
    "CMY_M": 0.70948207378387,
    "CMY_Y": 0.70665031671524,
    "CMYK_C": 0.04623240604997,
    "CMYK_M": 0.00965317897499,
    "CMYK_Y": 0,
    "CMYK_K": 0.70665031671524
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0538",
    "Farbtonhilfsbezeichnung": "135.2 Anthrazit 2",
    "Farbtonklasse": "02",
    "Rcolor": "87",
    "Gcolor": "90",
    "Bcolor": "92",
    "Y": 10,
    "L": 37.9345474243164,
    "a": -0.44861754775047,
    "b": -2.15497350692749,
    "C": 2.20117425918579,
    "h": 258.240264892578,
    "CMY_C": 0.65948331356049,
    "CMY_M": 0.64823096990585,
    "CMY_Y": 0.63943558931351,
    "CMYK_C": 0.05560095235705,
    "CMYK_M": 0.02439336851239,
    "CMYK_Y": 0,
    "CMYK_K": 0.63943558931351
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0539",
    "Farbtonhilfsbezeichnung": "135.3 Anthrazit 3",
    "Farbtonklasse": "01",
    "Rcolor": "141",
    "Gcolor": "145",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.9690055847168,
    "a": -1.27274060249329,
    "b": -1.67873334884644,
    "C": 2.10665941238403,
    "h": 232.832214355469,
    "CMY_C": 0.44827628135681,
    "CMY_M": 0.42981058359146,
    "CMY_Y": 0.42662155628204,
    "CMYK_C": 0.03776689618826,
    "CMYK_M": 0.00556181930006,
    "CMYK_Y": 0,
    "CMYK_K": 0.42662155628204
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0540",
    "Farbtonhilfsbezeichnung": "135.4 Anthrazit 4",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "172",
    "Bcolor": "173",
    "Y": 41,
    "L": 70.1652603149414,
    "a": -1.14254140853882,
    "b": -1.51617467403412,
    "C": 1.89846956729889,
    "h": 232.999481201172,
    "CMY_C": 0.34117549657822,
    "CMY_M": 0.32399362325668,
    "CMY_Y": 0.32216835021973,
    "CMYK_C": 0.02804110199213,
    "CMYK_M": 0.00269281165674,
    "CMYK_Y": 0,
    "CMYK_K": 0.32216835021973
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0541",
    "Farbtonhilfsbezeichnung": "136.1 Asphalt 1",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "90",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.0993766784668,
    "a": 0.08048272877932,
    "b": -0.22192610800266,
    "C": 0.2360692024231,
    "h": 289.933441162109,
    "CMY_C": 0.64846742153168,
    "CMY_M": 0.64821469783783,
    "CMY_Y": 0.64989423751831,
    "CMYK_C": 0.00071840320015,
    "CMYK_M": 0,
    "CMYK_Y": 0.00477433158085,
    "CMYK_K": 0.64821469783783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0542",
    "Farbtonhilfsbezeichnung": "136.2 Asphalt 2",
    "Farbtonklasse": "01",
    "Rcolor": "120",
    "Gcolor": "121",
    "Bcolor": "120",
    "Y": 19,
    "L": 50.6090087890625,
    "a": -0.04848935455084,
    "b": -0.25563058257103,
    "C": 0.26018878817558,
    "h": 259.259429931641,
    "CMY_C": 0.52873307466507,
    "CMY_M": 0.52711027860641,
    "CMY_Y": 0.52972900867462,
    "CMYK_C": 0.00343165849335,
    "CMYK_M": 0,
    "CMYK_Y": 0.00553771853447,
    "CMYK_K": 0.52711027860641
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0543",
    "Farbtonhilfsbezeichnung": "136.3 Asphalt 3",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "159",
    "Bcolor": "156",
    "Y": 34,
    "L": 65.2591018676758,
    "a": -0.14620964229107,
    "b": 0.41270914673805,
    "C": 0.43784254789352,
    "h": 109.507606506348,
    "CMY_C": 0.37857687473297,
    "CMY_M": 0.3781915307045,
    "CMY_Y": 0.3865659236908,
    "CMYK_C": 0.00061971496325,
    "CMYK_M": 0,
    "CMYK_Y": 0.01346780173481,
    "CMYK_K": 0.3781915307045
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0544",
    "Farbtonhilfsbezeichnung": "136.4 Asphalt 4",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "186",
    "Bcolor": "184",
    "Y": 49,
    "L": 75.340087890625,
    "a": -0.34308648109436,
    "b": 0.22038598358631,
    "C": 0.40777239203453,
    "h": 147.284820556641,
    "CMY_C": 0.27427327632904,
    "CMY_M": 0.27118253707886,
    "CMY_Y": 0.27963936328888,
    "CMYK_C": 0.00424075918272,
    "CMYK_M": 0,
    "CMYK_Y": 0.01160349044949,
    "CMYK_K": 0.27118253707886
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0545",
    "Farbtonhilfsbezeichnung": "137.1 Roca 1",
    "Farbtonklasse": "01",
    "Rcolor": "121",
    "Gcolor": "118",
    "Bcolor": "116",
    "Y": 19,
    "L": 49.8369064331055,
    "a": 1.19923710823059,
    "b": 1.09238004684448,
    "C": 1.6221786737442,
    "h": 42.3302574157715,
    "CMY_C": 0.52363324165344,
    "CMY_M": 0.53772938251495,
    "CMY_Y": 0.54599237442017,
    "CMYK_C": 0,
    "CMYK_M": 0.02959094196558,
    "CMYK_Y": 0.04693680256605,
    "CMYK_K": 0.52363324165344
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0546",
    "Farbtonhilfsbezeichnung": "137.2 Roca 2",
    "Farbtonklasse": "01",
    "Rcolor": "149",
    "Gcolor": "144",
    "Bcolor": "142",
    "Y": 29,
    "L": 60.179084777832,
    "a": 1.57461762428284,
    "b": 1.14722013473511,
    "C": 1.94821321964264,
    "h": 36.0759811401367,
    "CMY_C": 0.41634058952332,
    "CMY_M": 0.43462121486664,
    "CMY_Y": 0.44333553314209,
    "CMYK_C": 0,
    "CMYK_M": 0.03132070600986,
    "CMYK_Y": 0.04625119268894,
    "CMYK_K": 0.41634058952332
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0547",
    "Farbtonhilfsbezeichnung": "137.3 Roca 3",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "184",
    "Bcolor": "181",
    "Y": 49,
    "L": 74.9403533935547,
    "a": 1.37224924564362,
    "b": 1.35122489929199,
    "C": 1.92584443092346,
    "h": 44.5577011108398,
    "CMY_C": 0.26191490888596,
    "CMY_M": 0.27970153093338,
    "CMY_Y": 0.29169344902039,
    "CMYK_C": 0,
    "CMYK_M": 0.02409833483398,
    "CMYK_Y": 0.04034567251801,
    "CMYK_K": 0.26191490888596
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0548",
    "Farbtonhilfsbezeichnung": "137.4 Roca 4",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.5995330810547,
    "a": 1.01631450653076,
    "b": 1.2339026927948,
    "C": 1.59856534004211,
    "h": 50.5231323242188,
    "CMY_C": 0.20376139879227,
    "CMY_M": 0.2178435921669,
    "CMY_Y": 0.23047071695328,
    "CMYK_C": 0,
    "CMYK_M": 0.01768589578569,
    "CMYK_Y": 0.03354436531663,
    "CMYK_K": 0.20376139879227
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0549",
    "Farbtonhilfsbezeichnung": "138.1 Tarmac 1",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "160",
    "Bcolor": "154",
    "Y": 36,
    "L": 65.8705139160156,
    "a": 0.50815612077713,
    "b": 2.51258754730225,
    "C": 2.56345844268799,
    "h": 78.5664825439453,
    "CMY_C": 0.36083573102951,
    "CMY_M": 0.37383103370667,
    "CMY_Y": 0.39470702409744,
    "CMYK_C": 0,
    "CMYK_M": 0.02033171057701,
    "CMYK_Y": 0.05299309641123,
    "CMYK_K": 0.36083573102951
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0550",
    "Farbtonhilfsbezeichnung": "138.2 Tarmac 2",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "187",
    "Bcolor": "181",
    "Y": 50,
    "L": 75.826042175293,
    "a": 0.3371294438839,
    "b": 2.46784973144531,
    "C": 2.4907705783844,
    "h": 82.221061706543,
    "CMY_C": 0.2566140294075,
    "CMY_M": 0.26813596487045,
    "CMY_Y": 0.29039579629898,
    "CMYK_C": 0,
    "CMYK_M": 0.01549926400185,
    "CMYK_Y": 0.04544310644269,
    "CMYK_K": 0.2566140294075
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0551",
    "Farbtonhilfsbezeichnung": "138.3 Tarmac 3",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "199",
    "Bcolor": "193",
    "Y": 57,
    "L": 80.1953430175781,
    "a": 0.25372934341431,
    "b": 2.19813394546509,
    "C": 2.21272945404053,
    "h": 83.4155197143555,
    "CMY_C": 0.21085000038147,
    "CMY_M": 0.22072380781174,
    "CMY_Y": 0.24187380075455,
    "CMYK_C": 0,
    "CMYK_M": 0.01251195278019,
    "CMYK_Y": 0.03931293264031,
    "CMYK_K": 0.21085000038147
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0552",
    "Farbtonhilfsbezeichnung": "138.4 Tarmac 4",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 67,
    "L": 85.7528305053711,
    "a": 0.24459969997406,
    "b": 2.42404413223267,
    "C": 2.43635368347168,
    "h": 84.238037109375,
    "CMY_C": 0.14931535720825,
    "CMY_M": 0.16001826524734,
    "CMY_Y": 0.18346154689789,
    "CMYK_C": 0,
    "CMYK_M": 0.01258152257651,
    "CMYK_Y": 0.04013965651393,
    "CMYK_K": 0.14931535720825
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0553",
    "Farbtonhilfsbezeichnung": "139.1 Bims 1",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "185",
    "Bcolor": "185",
    "Y": 48,
    "L": 74.9694290161133,
    "a": -0.87041652202606,
    "b": -1.07826685905457,
    "C": 1.38574326038361,
    "h": 231.088272094727,
    "CMY_C": 0.28667426109314,
    "CMY_M": 0.27359986305237,
    "CMY_Y": 0.27441394329071,
    "CMYK_C": 0.01799889281392,
    "CMYK_M": 0,
    "CMYK_Y": 0.00112070492469,
    "CMYK_K": 0.27359986305237
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0554",
    "Farbtonhilfsbezeichnung": "139.2 Bims 2",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "199",
    "Bcolor": "199",
    "Y": 57,
    "L": 80.0864791870117,
    "a": -0.79943662881851,
    "b": -1.08291471004486,
    "C": 1.34603238105774,
    "h": 233.564270019531,
    "CMY_C": 0.23114240169525,
    "CMY_M": 0.21856701374054,
    "CMY_Y": 0.21953612565994,
    "CMYK_C": 0.01609272696078,
    "CMYK_M": 0,
    "CMYK_Y": 0.00124017277267,
    "CMYK_K": 0.21856701374054
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0555",
    "Farbtonhilfsbezeichnung": "139.3 Bims 3",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "211",
    "Bcolor": "209",
    "Y": 65,
    "L": 84.3589782714844,
    "a": -0.80071175098419,
    "b": -0.35175815224648,
    "C": 0.87457025051117,
    "h": 203.716217041016,
    "CMY_C": 0.18211627006531,
    "CMY_M": 0.17212241888046,
    "CMY_Y": 0.17851787805557,
    "CMYK_C": 0.01207165326923,
    "CMYK_M": 0,
    "CMYK_Y": 0.00772512657568,
    "CMYK_K": 0.17212241888046
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0556",
    "Farbtonhilfsbezeichnung": "139.4 Bims 4",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 72,
    "L": 87.8078308105469,
    "a": -0.80304020643234,
    "b": -0.29484218358994,
    "C": 0.85545629262924,
    "h": 200.161087036133,
    "CMY_C": 0.14402049779892,
    "CMY_M": 0.13411426544189,
    "CMY_Y": 0.14121073484421,
    "CMYK_C": 0.01144057698548,
    "CMYK_M": 0,
    "CMYK_Y": 0.00819561909884,
    "CMYK_K": 0.13411426544189
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0557",
    "Farbtonhilfsbezeichnung": "140.1 Granito 1",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "184",
    "Bcolor": "179",
    "Y": 48,
    "L": 74.8033218383789,
    "a": -0.21877904236317,
    "b": 2.16731309890747,
    "C": 2.17832732200623,
    "h": 95.7641830444336,
    "CMY_C": 0.27273070812225,
    "CMY_M": 0.27774292230606,
    "CMY_Y": 0.29916024208069,
    "CMYK_C": 0,
    "CMYK_M": 0.00689182709903,
    "CMYK_Y": 0.0363407805562,
    "CMYK_K": 0.27273070812225
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0558",
    "Farbtonhilfsbezeichnung": "140.2 Granito 2",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "198",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.8638076782227,
    "a": -0.24197478592396,
    "b": 1.90114498138428,
    "C": 1.9164822101593,
    "h": 97.2535171508789,
    "CMY_C": 0.21920311450958,
    "CMY_M": 0.2230943441391,
    "CMY_Y": 0.24335831403732,
    "CMYK_C": 0,
    "CMYK_M": 0.00498366449028,
    "CMYK_Y": 0.03093659877777,
    "CMYK_K": 0.21920311450958
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0559",
    "Farbtonhilfsbezeichnung": "140.3 Granito 3",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "211",
    "Bcolor": "206",
    "Y": 65,
    "L": 84.3518142700195,
    "a": -0.22650724649429,
    "b": 1.69598472118378,
    "C": 1.71104347705841,
    "h": 97.6071166992188,
    "CMY_C": 0.170774102211,
    "CMY_M": 0.17410999536514,
    "CMY_Y": 0.19343847036362,
    "CMYK_C": 0,
    "CMYK_M": 0.00402290048078,
    "CMYK_Y": 0.02733195945621,
    "CMYK_K": 0.170774102211
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0560",
    "Farbtonhilfsbezeichnung": "140.4 Granito 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 72,
    "L": 87.8964233398438,
    "a": -0.16168922185898,
    "b": 1.45906364917755,
    "C": 1.46799528598785,
    "h": 96.3235473632812,
    "CMY_C": 0.13198691606522,
    "CMY_M": 0.13513475656509,
    "CMY_Y": 0.15304011106491,
    "CMYK_C": 0,
    "CMYK_M": 0.00362648977898,
    "CMYK_Y": 0.02425446733832,
    "CMYK_K": 0.13198691606522
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0561",
    "Farbtonhilfsbezeichnung": "141.1 Blau 1",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "77",
    "Bcolor": "116",
    "Y": 10,
    "L": 37.5590438842773,
    "a": 21.5041408538818,
    "b": -17.5393486022949,
    "C": 27.7498970031738,
    "h": 320.798400878906,
    "CMY_C": 0.56981909275055,
    "CMY_M": 0.69865727424622,
    "CMY_Y": 0.54490005970001,
    "CMYK_C": 0.0547550804913,
    "CMYK_M": 0.33785372972488,
    "CMYK_Y": 0,
    "CMYK_K": 0.54490005970001
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0562",
    "Farbtonhilfsbezeichnung": "141.2 Blau 2",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "79",
    "Bcolor": "116",
    "Y": 9,
    "L": 36.5310821533203,
    "a": 14.9388227462769,
    "b": -19.1761074066162,
    "C": 24.3082599639893,
    "h": 307.919769287109,
    "CMY_C": 0.62740874290466,
    "CMY_M": 0.69011974334717,
    "CMY_Y": 0.5453999042511,
    "CMYK_C": 0.1803977638483,
    "CMYK_M": 0.31834536790848,
    "CMYK_Y": 0,
    "CMYK_K": 0.5453999042511
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0563",
    "Farbtonhilfsbezeichnung": "141.3 Blau 3",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "79",
    "Bcolor": "123",
    "Y": 9,
    "L": 35.6812896728516,
    "a": 13.1277627944946,
    "b": -25.2095222473145,
    "C": 28.4228458404541,
    "h": 297.508087158203,
    "CMY_C": 0.67398285865784,
    "CMY_M": 0.69107031822205,
    "CMY_Y": 0.51625967025757,
    "CMYK_C": 0.32604929804802,
    "CMYK_M": 0.36137291789055,
    "CMYK_Y": 0,
    "CMYK_K": 0.51625967025757
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0564",
    "Farbtonhilfsbezeichnung": "141.4 Blau 4",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "88",
    "Bcolor": "134",
    "Y": 10,
    "L": 38.3909187316895,
    "a": 8.90882110595703,
    "b": -27.476188659668,
    "C": 28.884391784668,
    "h": 287.964660644531,
    "CMY_C": 0.69342356920242,
    "CMY_M": 0.65524709224701,
    "CMY_Y": 0.47511065006256,
    "CMYK_C": 0.4159217774868,
    "CMYK_M": 0.34318935871124,
    "CMYK_Y": 0,
    "CMYK_K": 0.47511065006256
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0565",
    "Farbtonhilfsbezeichnung": "142.1 Blau 5",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "77",
    "Bcolor": "115",
    "Y": 7,
    "L": 32.6450576782227,
    "a": 3.16442227363586,
    "b": -25.0413703918457,
    "C": 25.2405185699463,
    "h": 277.202178955078,
    "CMY_C": 0.7871972322464,
    "CMY_M": 0.69713342189789,
    "CMY_Y": 0.54810047149658,
    "CMYK_C": 0.52909272909164,
    "CMYK_M": 0.32979223132133,
    "CMYK_Y": 0,
    "CMYK_K": 0.54810047149658
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0566",
    "Farbtonhilfsbezeichnung": "142.2 Blau 6",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "87",
    "Bcolor": "130",
    "Y": 10,
    "L": 37.1180648803711,
    "a": 5.07218980789185,
    "b": -26.9247589111328,
    "C": 27.3983535766602,
    "h": 280.668579101563,
    "CMY_C": 0.73720449209213,
    "CMY_M": 0.65904796123505,
    "CMY_Y": 0.49171614646912,
    "CMYK_C": 0.48297491669655,
    "CMYK_M": 0.3292093873024,
    "CMYK_Y": 0,
    "CMYK_K": 0.49171614646912
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0567",
    "Farbtonhilfsbezeichnung": "142.3 Blau 7",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "86",
    "Bcolor": "143",
    "Y": 9,
    "L": 36.7505149841309,
    "a": 6.97676610946655,
    "b": -35.5645523071289,
    "C": 36.2424163818359,
    "h": 281.098876953125,
    "CMY_C": 0.78980368375778,
    "CMY_M": 0.66269952058792,
    "CMY_Y": 0.44046539068222,
    "CMYK_C": 0.62433725595474,
    "CMYK_M": 0.39717674255371,
    "CMYK_Y": 0,
    "CMYK_K": 0.44046539068222
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0568",
    "Farbtonhilfsbezeichnung": "142.4 Blau 8",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "100",
    "Bcolor": "183",
    "Y": 13,
    "L": 42.784797668457,
    "a": 11.2148027420044,
    "b": -49.8826522827148,
    "C": 51.1277885437012,
    "h": 282.670776367188,
    "CMY_C": 0.83219623565674,
    "CMY_M": 0.60813558101654,
    "CMY_Y": 0.28360402584076,
    "CMYK_C": 0.76576673984528,
    "CMYK_M": 0.45300582051277,
    "CMYK_Y": 0,
    "CMYK_K": 0.28360402584076
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0569",
    "Farbtonhilfsbezeichnung": "143.1 Blau 9",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "75",
    "Bcolor": "100",
    "Y": 7,
    "L": 31.5259246826172,
    "a": 1.63098919391632,
    "b": -16.7901382446289,
    "C": 16.8691692352295,
    "h": 275.548278808594,
    "CMY_C": 0.76172775030136,
    "CMY_M": 0.70732498168945,
    "CMY_Y": 0.60974913835526,
    "CMYK_C": 0.3894382417202,
    "CMYK_M": 0.25003364682198,
    "CMYK_Y": 0,
    "CMYK_K": 0.60974913835526
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0570",
    "Farbtonhilfsbezeichnung": "143.2 Blau 10",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "90",
    "Bcolor": "134",
    "Y": 7,
    "L": 37.1066093444824,
    "a": -1.06588685512543,
    "b": -30.0063133239746,
    "C": 30.0252380371094,
    "h": 267.965606689453,
    "CMY_C": 0.83566701412201,
    "CMY_M": 0.64567881822586,
    "CMY_Y": 0.47273671627045,
    "CMYK_C": 0.68832838535309,
    "CMYK_M": 0.32799950242043,
    "CMYK_Y": 0,
    "CMYK_K": 0.47273671627045
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0571",
    "Farbtonhilfsbezeichnung": "143.3 Blau 11",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "136",
    "Y": 10,
    "L": 38.6347198486328,
    "a": -9.17720127105713,
    "b": -28.7676696777344,
    "C": 30.19602394104,
    "h": 252.306747436523,
    "CMY_C": 1,
    "CMY_M": 0.61717963218689,
    "CMY_Y": 0.46568644046783,
    "CMYK_C": 1,
    "CMYK_M": 0.28352862596512,
    "CMYK_Y": 0,
    "CMYK_K": 0.46568644046783
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0572",
    "Farbtonhilfsbezeichnung": "143.4 Blau 12",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "131",
    "Bcolor": "165",
    "Y": 19,
    "L": 49.9579315185547,
    "a": -20.4413642883301,
    "b": -28.3496074676514,
    "C": 34.9506759643555,
    "h": 234.206665039062,
    "CMY_C": 1,
    "CMY_M": 0.48749929666519,
    "CMY_Y": 0.35251891613007,
    "CMYK_C": 1,
    "CMYK_M": 0.20847000181675,
    "CMYK_Y": 0,
    "CMYK_K": 0.35251891613007
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0573",
    "Farbtonhilfsbezeichnung": "144.1 Delphin 1",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "114",
    "Bcolor": "144",
    "Y": 16,
    "L": 47.2429008483887,
    "a": -1.71075093746185,
    "b": -19.6060638427734,
    "C": 19.6805591583252,
    "h": 265.013214111328,
    "CMY_C": 0.6557457447052,
    "CMY_M": 0.55110323429108,
    "CMY_Y": 0.43687921762466,
    "CMYK_C": 0.38866710662842,
    "CMYK_M": 0.20284105837345,
    "CMYK_Y": 0,
    "CMYK_K": 0.43687921762466
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0574",
    "Farbtonhilfsbezeichnung": "144.2 Delphin 2",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "125",
    "Bcolor": "155",
    "Y": 20,
    "L": 51.2785415649414,
    "a": -1.84201037883759,
    "b": -20.3890647888184,
    "C": 20.4721012115479,
    "h": 264.837738037109,
    "CMY_C": 0.62117230892181,
    "CMY_M": 0.51071155071259,
    "CMY_Y": 0.39029866456985,
    "CMYK_C": 0.37866678833961,
    "CMYK_M": 0.19749486446381,
    "CMYK_Y": 0,
    "CMYK_K": 0.39029866456985
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0575",
    "Farbtonhilfsbezeichnung": "144.3 Delphin 3",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "149",
    "Bcolor": "182",
    "Y": 29,
    "L": 60.6205863952637,
    "a": -2.07149219512939,
    "b": -21.2404136657715,
    "C": 21.3411865234375,
    "h": 264.429779052734,
    "CMY_C": 0.53304439783096,
    "CMY_M": 0.41540557146072,
    "CMY_Y": 0.28655982017517,
    "CMYK_C": 0.34548738598824,
    "CMYK_M": 0.18059782683849,
    "CMYK_Y": 0,
    "CMYK_K": 0.28655982017517
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0576",
    "Farbtonhilfsbezeichnung": "144.4 Delphin 4",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "172",
    "Bcolor": "197",
    "Y": 40,
    "L": 69.5517425537109,
    "a": -2.26088809967041,
    "b": -16.1494216918945,
    "C": 16.3069133758545,
    "h": 262.030487060547,
    "CMY_C": 0.41597259044647,
    "CMY_M": 0.32360130548477,
    "CMY_Y": 0.22620612382889,
    "CMYK_C": 0.24524162709713,
    "CMYK_M": 0.12586708366871,
    "CMYK_Y": 0,
    "CMYK_K": 0.22620612382889
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0577",
    "Farbtonhilfsbezeichnung": "145.1 Marino 1",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "71",
    "Bcolor": "106",
    "Y": 7,
    "L": 30.8818054199219,
    "a": 5.78267908096313,
    "b": -22.0449886322021,
    "C": 22.790807723999,
    "h": 284.6982421875,
    "CMY_C": 0.76135087013245,
    "CMY_M": 0.71963220834732,
    "CMY_Y": 0.58355152606964,
    "CMYK_C": 0.42694199085236,
    "CMYK_M": 0.32676476240158,
    "CMYK_Y": 0,
    "CMYK_K": 0.58355152606964
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0578",
    "Farbtonhilfsbezeichnung": "145.2 Marino 2",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "94",
    "Bcolor": "142",
    "Y": 11,
    "L": 39.8035850524902,
    "a": 4.65062522888184,
    "b": -30.572229385376,
    "C": 30.9239311218262,
    "h": 278.649475097656,
    "CMY_C": 0.74029260873795,
    "CMY_M": 0.63148725032806,
    "CMY_Y": 0.44129532575607,
    "CMYK_C": 0.53516161441803,
    "CMYK_M": 0.34041583538055,
    "CMYK_Y": 0,
    "CMYK_K": 0.44129532575607
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0579",
    "Farbtonhilfsbezeichnung": "145.3 Marino 3",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "135",
    "Bcolor": "184",
    "Y": 24,
    "L": 55.5812454223633,
    "a": 1.14548933506012,
    "b": -30.1233348846436,
    "C": 30.1451072692871,
    "h": 272.177703857422,
    "CMY_C": 0.60885059833527,
    "CMY_M": 0.47021865844727,
    "CMY_Y": 0.2794713973999,
    "CMYK_C": 0.45713549852371,
    "CMYK_M": 0.26473239064217,
    "CMYK_Y": 0,
    "CMYK_K": 0.2794713973999
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0580",
    "Farbtonhilfsbezeichnung": "145.4 Marino 4",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "164",
    "Bcolor": "205",
    "Y": 36,
    "L": 66.3466186523438,
    "a": -0.68062382936478,
    "b": -25.5486755371094,
    "C": 25.5577392578125,
    "h": 268.473968505859,
    "CMY_C": 0.48470222949982,
    "CMY_M": 0.35746049880981,
    "CMY_Y": 0.19497835636139,
    "CMYK_C": 0.3598957657814,
    "CMYK_M": 0.20183575153351,
    "CMYK_Y": 0,
    "CMYK_K": 0.19497835636139
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0581",
    "Farbtonhilfsbezeichnung": "146.1 Neptun 1",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "82",
    "Bcolor": "104",
    "Y": 8,
    "L": 34.3143653869629,
    "a": -1.2687714099884,
    "b": -15.221417427063,
    "C": 15.2742042541504,
    "h": 265.235168457031,
    "CMY_C": 0.7522087097168,
    "CMY_M": 0.67668581008911,
    "CMY_Y": 0.59288477897644,
    "CMYK_C": 0.39134851098061,
    "CMYK_M": 0.20584106445313,
    "CMYK_Y": 0,
    "CMYK_K": 0.59288477897644
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0582",
    "Farbtonhilfsbezeichnung": "146.2 Neptun 2",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "91",
    "Bcolor": "122",
    "Y": 10,
    "L": 37.1887474060059,
    "a": -2.71521401405334,
    "b": -21.907190322876,
    "C": 22.0748138427734,
    "h": 262.934692382813,
    "CMY_C": 0.78044450283051,
    "CMY_M": 0.64489829540253,
    "CMY_Y": 0.52324241399765,
    "CMYK_C": 0.53948187828064,
    "CMYK_M": 0.25517344474792,
    "CMYK_Y": 0,
    "CMYK_K": 0.52324241399765
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0583",
    "Farbtonhilfsbezeichnung": "146.3 Neptun 3",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "98",
    "Bcolor": "140",
    "Y": 11,
    "L": 40.1352500915527,
    "a": -2.25716090202332,
    "b": -28.3756732940674,
    "C": 28.4653053283691,
    "h": 265.451934814453,
    "CMY_C": 0.79967093467712,
    "CMY_M": 0.615483045578,
    "CMY_Y": 0.45249575376511,
    "CMYK_C": 0.63410502672195,
    "CMYK_M": 0.29769137501717,
    "CMYK_Y": 0,
    "CMYK_K": 0.45249575376511
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0584",
    "Farbtonhilfsbezeichnung": "146.4 Neptun 4",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "122",
    "Bcolor": "161",
    "Y": 18,
    "L": 49.9880523681641,
    "a": -1.62394094467163,
    "b": -25.5456867218018,
    "C": 25.5972518920898,
    "h": 266.362609863281,
    "CMY_C": 0.66435867547989,
    "CMY_M": 0.52211946249008,
    "CMY_Y": 0.36944806575775,
    "CMYK_C": 0.46770232915878,
    "CMYK_M": 0.24212342500687,
    "CMYK_Y": 0,
    "CMYK_K": 0.36944806575775
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0585",
    "Farbtonhilfsbezeichnung": "147.1 Ozean 1",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "92",
    "Bcolor": "119",
    "Y": 10,
    "L": 37.6156730651855,
    "a": -5.0219259262085,
    "b": -19.5338344573975,
    "C": 20.1690464019775,
    "h": 255.582138061523,
    "CMY_C": 0.78388923406601,
    "CMY_M": 0.63745415210724,
    "CMY_Y": 0.53414356708527,
    "CMYK_C": 0.53610008955002,
    "CMYK_M": 0.22176486253738,
    "CMYK_Y": 0,
    "CMYK_K": 0.53414356708527
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0586",
    "Farbtonhilfsbezeichnung": "147.2 Ozean 2",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "111",
    "Bcolor": "146",
    "Y": 15,
    "L": 45.2902870178223,
    "a": -4.15491104125977,
    "b": -23.9680919647217,
    "C": 24.3255577087402,
    "h": 260.165405273438,
    "CMY_C": 0.72900474071503,
    "CMY_M": 0.56387460231781,
    "CMY_Y": 0.42854017019272,
    "CMYK_C": 0.5257842540741,
    "CMYK_M": 0.23682230710983,
    "CMYK_Y": 0,
    "CMYK_K": 0.42854017019272
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0587",
    "Farbtonhilfsbezeichnung": "147.3 Ozean 3",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "128",
    "Bcolor": "169",
    "Y": 20,
    "L": 51.5545082092285,
    "a": -5.72954082489014,
    "b": -27.8051700592041,
    "C": 28.3893489837646,
    "h": 258.356597900391,
    "CMY_C": 0.71239739656448,
    "CMY_M": 0.49759811162949,
    "CMY_Y": 0.33832651376724,
    "CMYK_C": 0.56534057855606,
    "CMYK_M": 0.24071025848389,
    "CMYK_Y": 0,
    "CMYK_K": 0.33832651376724
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0588",
    "Farbtonhilfsbezeichnung": "147.4 Ozean 4",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "153",
    "Bcolor": "202",
    "Y": 29,
    "L": 60.6169357299805,
    "a": -6.90555334091187,
    "b": -32.6628227233887,
    "C": 33.3848266601563,
    "h": 258.062347412109,
    "CMY_C": 0.67021262645721,
    "CMY_M": 0.40136551856995,
    "CMY_Y": 0.20844560861588,
    "CMYK_C": 0.58336740732193,
    "CMYK_M": 0.24372287094593,
    "CMYK_Y": 0,
    "CMYK_K": 0.20844560861588
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0589",
    "Farbtonhilfsbezeichnung": "148.1 Santorin 1",
    "Farbtonklasse": "04",
    "Rcolor": "19",
    "Gcolor": "102",
    "Bcolor": "137",
    "Y": 11,
    "L": 40.2391090393066,
    "a": -10.1297626495361,
    "b": -26.6734237670898,
    "C": 28.5321502685547,
    "h": 249.204727172852,
    "CMY_C": 0.92581212520599,
    "CMY_M": 0.60098308324814,
    "CMY_Y": 0.46290510892868,
    "CMYK_C": 0.86187195777893,
    "CMYK_M": 0.25708302855492,
    "CMYK_Y": 0,
    "CMYK_K": 0.46290510892868
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0590",
    "Farbtonhilfsbezeichnung": "148.2 Santorin 2",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "125",
    "Bcolor": "157",
    "Y": 18,
    "L": 49.8090744018555,
    "a": -9.97587966918945,
    "b": -23.6014556884766,
    "C": 25.6231708526611,
    "h": 247.087158203125,
    "CMY_C": 0.74973660707474,
    "CMY_M": 0.5085756778717,
    "CMY_Y": 0.38487303256989,
    "CMYK_C": 0.5931516289711,
    "CMYK_M": 0.2011009901762,
    "CMYK_Y": 0,
    "CMYK_K": 0.38487303256989
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0591",
    "Farbtonhilfsbezeichnung": "148.3 Santorin 3",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "151",
    "Bcolor": "179",
    "Y": 28,
    "L": 60.1418304443359,
    "a": -8.25736522674561,
    "b": -20.5107364654541,
    "C": 22.1105041503906,
    "h": 248.070907592773,
    "CMY_C": 0.59507167339325,
    "CMY_M": 0.40800124406815,
    "CMY_Y": 0.29721266031265,
    "CMYK_C": 0.42382523417473,
    "CMYK_M": 0.1576416939497,
    "CMYK_Y": 0,
    "CMYK_K": 0.29721266031265
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0592",
    "Farbtonhilfsbezeichnung": "148.4 Santorin 4",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "170",
    "Bcolor": "196",
    "Y": 37,
    "L": 67.3517074584961,
    "a": -8.50315475463867,
    "b": -18.8081798553467,
    "C": 20.6410102844238,
    "h": 245.672332763672,
    "CMY_C": 0.51158910989761,
    "CMY_M": 0.332843542099,
    "CMY_Y": 0.23193067312241,
    "CMYK_C": 0.36410573124886,
    "CMYK_M": 0.13138510286808,
    "CMYK_Y": 0,
    "CMYK_K": 0.23193067312241
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0593",
    "Farbtonhilfsbezeichnung": "149.1 Amalfi 1",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "118",
    "Bcolor": "140",
    "Y": 17,
    "L": 47.692943572998,
    "a": -7.41505241394043,
    "b": -16.8072872161865,
    "C": 18.3703002929688,
    "h": 246.19384765625,
    "CMY_C": 0.69005119800568,
    "CMY_M": 0.5365663766861,
    "CMY_Y": 0.4511125087738,
    "CMYK_C": 0.43531450629234,
    "CMYK_M": 0.1556855738163,
    "CMYK_Y": 0,
    "CMYK_K": 0.4511125087738
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0594",
    "Farbtonhilfsbezeichnung": "149.2 Amalfi 2",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "150",
    "Bcolor": "180",
    "Y": 28,
    "L": 59.8002433776855,
    "a": -8.72614669799805,
    "b": -21.3209915161133,
    "C": 23.0375843048096,
    "h": 247.741943359375,
    "CMY_C": 0.60909122228622,
    "CMY_M": 0.41033285856247,
    "CMY_Y": 0.29533344507217,
    "CMYK_C": 0.44525709748268,
    "CMYK_M": 0.16319692134857,
    "CMYK_Y": 0,
    "CMYK_K": 0.29533344507217
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0595",
    "Farbtonhilfsbezeichnung": "149.3 Amalfi 3",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "177",
    "Bcolor": "200",
    "Y": 41,
    "L": 70.305419921875,
    "a": -7.58910179138184,
    "b": -16.3799381256104,
    "C": 18.0526123046875,
    "h": 245.140914916992,
    "CMY_C": 0.4579952955246,
    "CMY_M": 0.30423003435135,
    "CMY_Y": 0.21699845790863,
    "CMYK_C": 0.30778589844704,
    "CMYK_M": 0.11140664666891,
    "CMYK_Y": 0,
    "CMYK_K": 0.21699845790863
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0596",
    "Farbtonhilfsbezeichnung": "149.4 Amalfi 4",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "203",
    "Bcolor": "220",
    "Y": 57,
    "L": 79.8727340698242,
    "a": -6.26236772537231,
    "b": -12.7901239395142,
    "C": 14.2409448623657,
    "h": 243.912460327148,
    "CMY_C": 0.32637584209442,
    "CMY_M": 0.20520222187042,
    "CMY_Y": 0.13812130689621,
    "CMYK_C": 0.21842347085476,
    "CMYK_M": 0.07783103734255,
    "CMYK_Y": 0,
    "CMYK_K": 0.13812130689621
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0597",
    "Farbtonhilfsbezeichnung": "150.1 Lipari 1",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "117",
    "Bcolor": "146",
    "Y": 15,
    "L": 45.650691986084,
    "a": -14.6962633132935,
    "b": -23.7595996856689,
    "C": 27.937406539917,
    "h": 238.26155090332,
    "CMY_C": 0.89394080638885,
    "CMY_M": 0.5415540933609,
    "CMY_Y": 0.42700797319412,
    "CMYK_C": 0.81490284204483,
    "CMYK_M": 0.19990874826908,
    "CMYK_Y": 0,
    "CMYK_K": 0.42700797319412
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0598",
    "Farbtonhilfsbezeichnung": "150.2 Lipari 2",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "143",
    "Bcolor": "174",
    "Y": 24,
    "L": 55.8932991027832,
    "a": -15.1799278259277,
    "b": -24.0846729278564,
    "C": 28.4693107604981,
    "h": 237.777862548828,
    "CMY_C": 0.76200211048126,
    "CMY_M": 0.43750041723251,
    "CMY_Y": 0.31841117143631,
    "CMYK_C": 0.65081894397736,
    "CMYK_M": 0.17472299933434,
    "CMYK_Y": 0,
    "CMYK_K": 0.31841117143631
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0599",
    "Farbtonhilfsbezeichnung": "150.3 Lipari 3",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "170",
    "Bcolor": "196",
    "Y": 36,
    "L": 66.3693084716797,
    "a": -13.1549263000488,
    "b": -20.7082347869873,
    "C": 24.5333061218262,
    "h": 237.574203491211,
    "CMY_C": 0.58488893508911,
    "CMY_M": 0.33338689804077,
    "CMY_Y": 0.22968620061874,
    "CMYK_C": 0.46111434698105,
    "CMYK_M": 0.13462136685848,
    "CMYK_Y": 0,
    "CMYK_K": 0.22968620061874
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0600",
    "Farbtonhilfsbezeichnung": "150.4 Lipari 4",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "207",
    "Bcolor": "228",
    "Y": 57,
    "L": 80.3130035400391,
    "a": -12.0314311981201,
    "b": -16.8851413726807,
    "C": 20.7331466674805,
    "h": 234.528396606445,
    "CMY_C": 0.39810860157013,
    "CMY_M": 0.18685448169708,
    "CMY_Y": 0.10428804159164,
    "CMYK_C": 0.32803019881248,
    "CMYK_M": 0.09217967838049,
    "CMYK_Y": 0,
    "CMYK_K": 0.10428804159164
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0601",
    "Farbtonhilfsbezeichnung": "151.1 Capri 1",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "153",
    "Bcolor": "174",
    "Y": 29,
    "L": 60.6671257019043,
    "a": -10.6370906829834,
    "b": -16.8149318695068,
    "C": 19.8969745635986,
    "h": 237.682632446289,
    "CMY_C": 0.59125649929047,
    "CMY_M": 0.3991414308548,
    "CMY_Y": 0.31718224287033,
    "CMYK_C": 0.40138712525368,
    "CMYK_M": 0.12003083527088,
    "CMYK_Y": 0,
    "CMYK_K": 0.31718224287033
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0602",
    "Farbtonhilfsbezeichnung": "151.2 Capri 2",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "174",
    "Bcolor": "190",
    "Y": 39,
    "L": 68.6123275756836,
    "a": -9.56009101867676,
    "b": -13.5305728912354,
    "C": 16.5671882629395,
    "h": 234.756713867188,
    "CMY_C": 0.47946131229401,
    "CMY_M": 0.31906026601791,
    "CMY_Y": 0.25542521476746,
    "CMYK_C": 0.3008913397789,
    "CMYK_M": 0.08546495437622,
    "CMYK_Y": 0,
    "CMYK_K": 0.25542521476746
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0603",
    "Farbtonhilfsbezeichnung": "151.3 Capri 3",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "194",
    "Bcolor": "208",
    "Y": 51,
    "L": 76.2459182739258,
    "a": -8.07071781158447,
    "b": -11.7991247177124,
    "C": 14.2953081130981,
    "h": 235.627487182617,
    "CMY_C": 0.37673789262772,
    "CMY_M": 0.24098908901215,
    "CMY_Y": 0.185123026371,
    "CMYK_C": 0.23514576256275,
    "CMYK_M": 0.06855766475201,
    "CMYK_Y": 0,
    "CMYK_K": 0.185123026371
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0604",
    "Farbtonhilfsbezeichnung": "151.4 Capri 4",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "210",
    "Bcolor": "216",
    "Y": 61,
    "L": 82.3935623168945,
    "a": -7.66722011566162,
    "b": -7.07507801055908,
    "C": 10.4327840805054,
    "h": 222.69987487793,
    "CMY_C": 0.2861465215683,
    "CMY_M": 0.17633372545242,
    "CMY_Y": 0.15197187662125,
    "CMYK_C": 0.15821957588196,
    "CMYK_M": 0.02872764319181,
    "CMYK_Y": 0,
    "CMYK_K": 0.15197187662125
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0605",
    "Farbtonhilfsbezeichnung": "152.1 Elba 1",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "138",
    "Bcolor": "148",
    "Y": 23,
    "L": 55.2718925476074,
    "a": -10.4245767593384,
    "b": -9.80839347839355,
    "C": 14.3135032653809,
    "h": 223.255630493164,
    "CMY_C": 0.60450387001038,
    "CMY_M": 0.45704251527786,
    "CMY_Y": 0.42066735029221,
    "CMYK_C": 0.3173246383667,
    "CMYK_M": 0.06278804689646,
    "CMYK_Y": 0,
    "CMYK_K": 0.42066735029221
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0606",
    "Farbtonhilfsbezeichnung": "152.2 Elba 2",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "167",
    "Bcolor": "175",
    "Y": 35,
    "L": 65.9786987304688,
    "a": -10.8239850997925,
    "b": -9.00132751464844,
    "C": 14.0777320861816,
    "h": 219.747222900391,
    "CMY_C": 0.49576425552368,
    "CMY_M": 0.34568935632706,
    "CMY_Y": 0.31511408090591,
    "CMYK_C": 0.26376682519913,
    "CMYK_M": 0.04464287310839,
    "CMYK_Y": 0,
    "CMYK_K": 0.31511408090591
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0607",
    "Farbtonhilfsbezeichnung": "152.3 Elba 3",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "193",
    "Bcolor": "200",
    "Y": 49,
    "L": 75.8299942016602,
    "a": -9.98337078094482,
    "b": -8.01101970672607,
    "C": 12.8001613616943,
    "h": 218.744827270508,
    "CMY_C": 0.38080656528473,
    "CMY_M": 0.24261039495468,
    "CMY_Y": 0.21691107749939,
    "CMYK_C": 0.20929358899593,
    "CMYK_M": 0.03281787782907,
    "CMYK_Y": 0,
    "CMYK_K": 0.21691107749939
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0608",
    "Farbtonhilfsbezeichnung": "152.4 Elba 4",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "219",
    "Bcolor": "223",
    "Y": 67,
    "L": 85.4094619750977,
    "a": -8.85781192779541,
    "b": -5.96106481552124,
    "C": 10.6768503189087,
    "h": 213.939483642578,
    "CMY_C": 0.25928318500519,
    "CMY_M": 0.14085096120834,
    "CMY_Y": 0.12709301710129,
    "CMYK_C": 0.15143671631813,
    "CMYK_M": 0.01576106622815,
    "CMYK_Y": 0,
    "CMYK_K": 0.12709301710129
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0609",
    "Farbtonhilfsbezeichnung": "153.1 Lagune 1",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "198",
    "Bcolor": "221",
    "Y": 50,
    "L": 76.0940704345703,
    "a": -16.9198703765869,
    "b": -19.3232364654541,
    "C": 25.6840324401856,
    "h": 228.793869018555,
    "CMY_C": 0.5131618976593,
    "CMY_M": 0.22228902578354,
    "CMY_Y": 0.13383227586746,
    "CMYK_C": 0.43794015049934,
    "CMYK_M": 0.10212427377701,
    "CMYK_Y": 0,
    "CMYK_K": 0.13383227586746
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0610",
    "Farbtonhilfsbezeichnung": "153.2 Lagune 2",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "211",
    "Bcolor": "230",
    "Y": 58,
    "L": 80.8987350463867,
    "a": -15.6407852172852,
    "b": -16.9333248138428,
    "C": 23.0515003204346,
    "h": 227.272308349609,
    "CMY_C": 0.43013364076614,
    "CMY_M": 0.17304527759552,
    "CMY_Y": 0.09781849384308,
    "CMYK_C": 0.36834621429443,
    "CMYK_M": 0.0833832025528,
    "CMYK_Y": 0,
    "CMYK_K": 0.09781849384308
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0611",
    "Farbtonhilfsbezeichnung": "153.3 Lagune 3",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "213",
    "Bcolor": "224",
    "Y": 62,
    "L": 83.0572280883789,
    "a": -9.64630508422852,
    "b": -10.2508220672607,
    "C": 14.0758857727051,
    "h": 226.740234375,
    "CMY_C": 0.3110436797142,
    "CMY_M": 0.16382294893265,
    "CMY_Y": 0.12182599306107,
    "CMYK_C": 0.21546718478203,
    "CMYK_M": 0.04782304540277,
    "CMYK_Y": 0,
    "CMYK_K": 0.12182599306107
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0612",
    "Farbtonhilfsbezeichnung": "153.4 Lagune 4",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "225",
    "Bcolor": "230",
    "Y": 71,
    "L": 87.6399765014648,
    "a": -8.06392192840576,
    "b": -6.70296573638916,
    "C": 10.4860181808472,
    "h": 219.734344482422,
    "CMY_C": 0.23122364282608,
    "CMY_M": 0.11763536930084,
    "CMY_Y": 0.09689795970917,
    "CMYK_C": 0.14873810112476,
    "CMYK_M": 0.02296242117882,
    "CMYK_Y": 0,
    "CMYK_K": 0.09689795970917
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0613",
    "Farbtonhilfsbezeichnung": "154.1 Wasser 1",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "178",
    "Bcolor": "190",
    "Y": 41,
    "L": 69.8675003051758,
    "a": -11.6818170547485,
    "b": -11.4906425476074,
    "C": 16.3859615325928,
    "h": 224.527313232422,
    "CMY_C": 0.47609585523605,
    "CMY_M": 0.30208396911621,
    "CMY_Y": 0.25652939081192,
    "CMYK_C": 0.29532635211945,
    "CMYK_M": 0.06127287074924,
    "CMYK_Y": 0,
    "CMYK_K": 0.25652939081192
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0614",
    "Farbtonhilfsbezeichnung": "154.2 Wasser 2",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "202",
    "Bcolor": "208",
    "Y": 56,
    "L": 79.3685760498047,
    "a": -8.71571445465088,
    "b": -6.99211931228638,
    "C": 11.1737823486328,
    "h": 218.738082885742,
    "CMY_C": 0.32740348577499,
    "CMY_M": 0.20717877149582,
    "CMY_Y": 0.18572378158569,
    "CMYK_C": 0.17399464547634,
    "CMYK_M": 0.02634854055941,
    "CMYK_Y": 0,
    "CMYK_K": 0.18572378158569
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0615",
    "Farbtonhilfsbezeichnung": "154.3 Wasser 3",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "218",
    "Bcolor": "222",
    "Y": 66,
    "L": 85.1620941162109,
    "a": -8.20030879974365,
    "b": -6.09028291702271,
    "C": 10.2145290374756,
    "h": 216.600891113281,
    "CMY_C": 0.2567303776741,
    "CMY_M": 0.14497917890549,
    "CMY_Y": 0.1287927031517,
    "CMYK_C": 0.14685101807117,
    "CMYK_M": 0.01857936196029,
    "CMYK_Y": 0,
    "CMYK_K": 0.1287927031517
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0616",
    "Farbtonhilfsbezeichnung": "154.4 Wasser 4",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "225",
    "Bcolor": "225",
    "Y": 73,
    "L": 88.3113708496094,
    "a": -5.19844818115234,
    "b": -2.98652839660645,
    "C": 5.99526596069336,
    "h": 209.877532958984,
    "CMY_C": 0.18416994810104,
    "CMY_M": 0.11765384674072,
    "CMY_Y": 0.11645156145096,
    "CMYK_C": 0.07664366066456,
    "CMYK_M": 0.00136074633338,
    "CMYK_Y": 0,
    "CMYK_K": 0.11645156145096
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0617",
    "Farbtonhilfsbezeichnung": "155.1 Mistral 1",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "196",
    "Bcolor": "209",
    "Y": 51,
    "L": 76.8621292114258,
    "a": -10.2120990753174,
    "b": -11.8093328475952,
    "C": 15.6124086380005,
    "h": 229.148452758789,
    "CMY_C": 0.39009827375412,
    "CMY_M": 0.22982621192932,
    "CMY_Y": 0.17857521772385,
    "CMYK_C": 0.25750750303268,
    "CMYK_M": 0.06239280104637,
    "CMYK_Y": 0,
    "CMYK_K": 0.17857521772385
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0618",
    "Farbtonhilfsbezeichnung": "155.2 Mistral 2",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "208",
    "Bcolor": "219",
    "Y": 59,
    "L": 81.0500183105469,
    "a": -9.50118923187256,
    "b": -10.8647298812866,
    "C": 14.4331197738648,
    "h": 228.830352783203,
    "CMY_C": 0.33418983221054,
    "CMY_M": 0.18598079681396,
    "CMY_Y": 0.13945949077606,
    "CMYK_C": 0.226288408041,
    "CMYK_M": 0.05406056344509,
    "CMYK_Y": 0,
    "CMYK_K": 0.13945949077606
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0619",
    "Farbtonhilfsbezeichnung": "155.3 Mistral 3",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "219",
    "Bcolor": "229",
    "Y": 66,
    "L": 85.2703475952148,
    "a": -8.70199775695801,
    "b": -9.39147186279297,
    "C": 12.803300857544,
    "h": 227.182266235352,
    "CMY_C": 0.27454072237015,
    "CMY_M": 0.14170318841934,
    "CMY_Y": 0.10351896286011,
    "CMYK_C": 0.19077007472515,
    "CMYK_M": 0.04259345680475,
    "CMYK_Y": 0,
    "CMYK_K": 0.10351896286011
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0620",
    "Farbtonhilfsbezeichnung": "155.4 Mistral 4",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "231",
    "Bcolor": "236",
    "Y": 77,
    "L": 90.1604614257812,
    "a": -6.42089653015137,
    "b": -5.7846417427063,
    "C": 8.64233684539795,
    "h": 222.015975952148,
    "CMY_C": 0.18543934822083,
    "CMY_M": 0.09347814321518,
    "CMY_Y": 0.07545351982117,
    "CMYK_C": 0.11896192282438,
    "CMYK_M": 0.01949563808739,
    "CMYK_Y": 0,
    "CMYK_K": 0.07545351982117
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0621",
    "Farbtonhilfsbezeichnung": "156.1 Topas 1",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "176",
    "Bcolor": "199",
    "Y": 39,
    "L": 68.8097763061523,
    "a": -11.7807130813599,
    "b": -18.1260280609131,
    "C": 21.6180038452148,
    "h": 236.978805541992,
    "CMY_C": 0.52604860067368,
    "CMY_M": 0.31106996536255,
    "CMY_Y": 0.22129797935486,
    "CMYK_C": 0.39135718345642,
    "CMYK_M": 0.11528412997723,
    "CMYK_Y": 0,
    "CMYK_K": 0.22129797935486
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0622",
    "Farbtonhilfsbezeichnung": "156.2 Topas 2",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "185",
    "Bcolor": "200",
    "Y": 44,
    "L": 72.5662078857422,
    "a": -11.1098308563232,
    "b": -13.2190961837769,
    "C": 17.2676830291748,
    "h": 229.955032348633,
    "CMY_C": 0.45133996009827,
    "CMY_M": 0.27386999130249,
    "CMY_Y": 0.21525305509567,
    "CMYK_C": 0.30084463953972,
    "CMYK_M": 0.07469533383846,
    "CMYK_Y": 0,
    "CMYK_K": 0.21525305509567
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0623",
    "Farbtonhilfsbezeichnung": "156.3 Topas 3",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "197",
    "Bcolor": "207",
    "Y": 52,
    "L": 77.3464889526367,
    "a": -9.45290660858154,
    "b": -9.81959915161133,
    "C": 13.6301860809326,
    "h": 226.09001159668,
    "CMY_C": 0.36830997467041,
    "CMY_M": 0.22676396369934,
    "CMY_Y": 0.18747770786285,
    "CMYK_C": 0.2225566804409,
    "CMYK_M": 0.04835098981857,
    "CMYK_Y": 0,
    "CMYK_K": 0.18747770786285
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0624",
    "Farbtonhilfsbezeichnung": "156.4 Topas 4",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "220",
    "Bcolor": "225",
    "Y": 68,
    "L": 86.0096817016602,
    "a": -7.12392234802246,
    "b": -6.21352052688599,
    "C": 9.45294189453125,
    "h": 221.095092773438,
    "CMY_C": 0.23866361379623,
    "CMY_M": 0.13793230056763,
    "CMY_Y": 0.11841261386871,
    "CMYK_C": 0.13640281558037,
    "CMYK_M": 0.02214152179658,
    "CMYK_Y": 0,
    "CMYK_K": 0.11841261386871
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0625",
    "Farbtonhilfsbezeichnung": "157.1 Bergsee 1",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "188",
    "Bcolor": "209",
    "Y": 47,
    "L": 74.0179672241211,
    "a": -7.81469964981079,
    "b": -15.6115875244141,
    "C": 17.4582710266113,
    "h": 243.408813476562,
    "CMY_C": 0.41695380210876,
    "CMY_M": 0.26433366537094,
    "CMY_Y": 0.18216848373413,
    "CMYK_C": 0.28708276152611,
    "CMYK_M": 0.10046712309122,
    "CMYK_Y": 0,
    "CMYK_K": 0.18216848373413
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0626",
    "Farbtonhilfsbezeichnung": "157.2 Bergsee 2",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "203",
    "Bcolor": "219",
    "Y": 57,
    "L": 79.8329086303711,
    "a": -6.82329988479614,
    "b": -12.4313631057739,
    "C": 14.1808395385742,
    "h": 241.23860168457,
    "CMY_C": 0.3301814198494,
    "CMY_M": 0.20453286170959,
    "CMY_Y": 0.14121121168137,
    "CMYK_C": 0.22004270553589,
    "CMYK_M": 0.07373367249966,
    "CMYK_Y": 0,
    "CMYK_K": 0.14121121168137
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0627",
    "Farbtonhilfsbezeichnung": "157.3 Bergsee 3",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "215",
    "Bcolor": "225",
    "Y": 65,
    "L": 84.5672988891602,
    "a": -6.00068950653076,
    "b": -8.70917797088623,
    "C": 10.5762968063354,
    "h": 235.432861328125,
    "CMY_C": 0.25513577461243,
    "CMY_M": 0.15559405088425,
    "CMY_Y": 0.11595964431763,
    "CMYK_C": 0.15743187069893,
    "CMYK_M": 0.04483325406909,
    "CMYK_Y": 0,
    "CMYK_K": 0.11595964431763
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0628",
    "Farbtonhilfsbezeichnung": "157.4 Bergsee 4",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "224",
    "Bcolor": "231",
    "Y": 72,
    "L": 88.023796081543,
    "a": -4.9329981803894,
    "b": -6.57783937454224,
    "C": 8.22207069396973,
    "h": 233.132232666016,
    "CMY_C": 0.19933432340622,
    "CMY_M": 0.12038791179657,
    "CMY_Y": 0.09317284822464,
    "CMYK_C": 0.11706914007664,
    "CMYK_M": 0.03001130186021,
    "CMYK_Y": 0,
    "CMYK_K": 0.09317284822464
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0629",
    "Farbtonhilfsbezeichnung": "158.1 Opal 1",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "186",
    "Bcolor": "221",
    "Y": 46,
    "L": 73.1667709350586,
    "a": -8.42353057861328,
    "b": -23.8086376190186,
    "C": 25.2548427581787,
    "h": 250.516143798828,
    "CMY_C": 0.47976493835449,
    "CMY_M": 0.26945382356644,
    "CMY_Y": 0.13323312997818,
    "CMYK_C": 0.39979818463326,
    "CMYK_M": 0.15715955197811,
    "CMYK_Y": 0,
    "CMYK_K": 0.13323312997818
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0630",
    "Farbtonhilfsbezeichnung": "158.2 Opal 2",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "200",
    "Bcolor": "227",
    "Y": 54,
    "L": 78.1717987060547,
    "a": -8.2511043548584,
    "b": -19.1791934967041,
    "C": 20.8787498474121,
    "h": 246.722091674805,
    "CMY_C": 0.39616101980209,
    "CMY_M": 0.21736943721771,
    "CMY_Y": 0.11105239391327,
    "CMYK_C": 0.32072600722313,
    "CMYK_M": 0.11959877610207,
    "CMYK_Y": 0,
    "CMYK_K": 0.11105239391327
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0631",
    "Farbtonhilfsbezeichnung": "158.3 Opal 3",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "211",
    "Bcolor": "232",
    "Y": 62,
    "L": 82.7944869995117,
    "a": -7.10086345672607,
    "b": -14.8834400177002,
    "C": 16.4905738830566,
    "h": 244.494277954102,
    "CMY_C": 0.31270933151245,
    "CMY_M": 0.17074900865555,
    "CMY_Y": 0.09074437618256,
    "CMYK_C": 0.24411721527576,
    "CMYK_M": 0.08798915147781,
    "CMYK_Y": 0,
    "CMYK_K": 0.09074437618256
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0632",
    "Farbtonhilfsbezeichnung": "158.4 Opal 4",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "228",
    "Bcolor": "236",
    "Y": 75,
    "L": 89.3947906494141,
    "a": -4.75202703475952,
    "b": -6.96348428726196,
    "C": 8.43041324615479,
    "h": 235.689559936523,
    "CMY_C": 0.1843329668045,
    "CMY_M": 0.1054328083992,
    "CMY_Y": 0.07506412267685,
    "CMYK_C": 0.11813666671515,
    "CMYK_M": 0.03283328935504,
    "CMYK_Y": 0,
    "CMYK_K": 0.07506412267685
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0633",
    "Farbtonhilfsbezeichnung": "159.1 Passat 1",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "205",
    "Bcolor": "223",
    "Y": 59,
    "L": 81.0596923828125,
    "a": -4.7846302986145,
    "b": -12.6368417739868,
    "C": 13.5123071670532,
    "h": 249.262054443359,
    "CMY_C": 0.29972487688065,
    "CMY_M": 0.19554179906845,
    "CMY_Y": 0.12598949670792,
    "CMYK_C": 0.19877950847149,
    "CMYK_M": 0.07957834005356,
    "CMYK_Y": 0,
    "CMYK_K": 0.12598949670792
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0634",
    "Farbtonhilfsbezeichnung": "159.2 Passat 2",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "217",
    "Bcolor": "227",
    "Y": 67,
    "L": 85.5858993530273,
    "a": -3.22609710693359,
    "b": -8.00199890136719,
    "C": 8.62784385681152,
    "h": 248.042617797852,
    "CMY_C": 0.21727031469345,
    "CMY_M": 0.15080338716507,
    "CMY_Y": 0.10952895879745,
    "CMYK_C": 0.12099366635084,
    "CMYK_M": 0.04635123163462,
    "CMYK_Y": 0,
    "CMYK_K": 0.10952895879745
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0635",
    "Farbtonhilfsbezeichnung": "159.3 Passat 3",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "227",
    "Bcolor": "233",
    "Y": 74,
    "L": 89.0183258056641,
    "a": -4.25069141387939,
    "b": -6.16243505477905,
    "C": 7.486252784729,
    "h": 235.403076171875,
    "CMY_C": 0.18093675374985,
    "CMY_M": 0.1110053062439,
    "CMY_Y": 0.08509963750839,
    "CMYK_C": 0.10475142300129,
    "CMYK_M": 0.02831528894603,
    "CMYK_Y": 0,
    "CMYK_K": 0.08509963750839
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0636",
    "Farbtonhilfsbezeichnung": "159.4 Passat 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "232",
    "Bcolor": "235",
    "Y": 80,
    "L": 91.1755676269531,
    "a": -2.56110167503357,
    "b": -3.82166600227356,
    "C": 4.6004753112793,
    "h": 236.171859741211,
    "CMY_C": 0.13385325670242,
    "CMY_M": 0.09153980016708,
    "CMY_Y": 0.07818418741226,
    "CMYK_C": 0.0603906661272,
    "CMYK_M": 0.01448837481439,
    "CMYK_Y": 0,
    "CMYK_K": 0.07818418741226
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0637",
    "Farbtonhilfsbezeichnung": "160.1 Horizont 1",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "188",
    "Bcolor": "222",
    "Y": 47,
    "L": 74.5307998657227,
    "a": -4.38537740707397,
    "b": -21.9194297790527,
    "C": 22.3538131713867,
    "h": 258.686309814453,
    "CMY_C": 0.41274076700211,
    "CMY_M": 0.2640175819397,
    "CMY_Y": 0.13125860691071,
    "CMYK_C": 0.32401144504547,
    "CMYK_M": 0.15281760692596,
    "CMYK_Y": 0,
    "CMYK_K": 0.13125860691071
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0638",
    "Farbtonhilfsbezeichnung": "160.2 Horizont 2",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "208",
    "Bcolor": "229",
    "Y": 61,
    "L": 82.1990966796875,
    "a": -4.56733131408691,
    "b": -14.0889902114868,
    "C": 14.81081199646,
    "h": 252.038482666016,
    "CMY_C": 0.29221528768539,
    "CMY_M": 0.18310064077377,
    "CMY_Y": 0.10284233093262,
    "CMYK_C": 0.21108102798462,
    "CMYK_M": 0.08945842087269,
    "CMYK_Y": 0,
    "CMYK_K": 0.10284233093262
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0639",
    "Farbtonhilfsbezeichnung": "160.3 Horizont 3",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "217",
    "Bcolor": "232",
    "Y": 68,
    "L": 85.5625076293945,
    "a": -3.94672918319702,
    "b": -10.5958194732666,
    "C": 11.3069915771484,
    "h": 249.570648193359,
    "CMY_C": 0.2346003651619,
    "CMY_M": 0.1486274600029,
    "CMY_Y": 0.09090632200241,
    "CMYK_C": 0.15806296467781,
    "CMYK_M": 0.06349305808544,
    "CMYK_Y": 0,
    "CMYK_K": 0.09090632200241
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0640",
    "Farbtonhilfsbezeichnung": "160.4 Horizont 4",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "224",
    "Bcolor": "233",
    "Y": 73,
    "L": 88.6132659912109,
    "a": -2.03854870796204,
    "b": -6.79606962203979,
    "C": 7.09522676467896,
    "h": 253.302856445312,
    "CMY_C": 0.1693052649498,
    "CMY_M": 0.12039303779602,
    "CMY_Y": 0.08465540409088,
    "CMYK_C": 0.09247867763042,
    "CMYK_M": 0.03904281929135,
    "CMYK_Y": 0,
    "CMYK_K": 0.08465540409088
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0641",
    "Farbtonhilfsbezeichnung": "161.1 Himmel 1",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "196",
    "Bcolor": "224",
    "Y": 54,
    "L": 78.3700942993164,
    "a": -1.80805814266205,
    "b": -17.4913635253906,
    "C": 17.5845642089844,
    "h": 264.098358154297,
    "CMY_C": 0.32490175962448,
    "CMY_M": 0.22982138395309,
    "CMY_Y": 0.12032544612885,
    "CMYK_C": 0.23255908489227,
    "CMYK_M": 0.12447323650122,
    "CMYK_Y": 0,
    "CMYK_K": 0.12032544612885
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0642",
    "Farbtonhilfsbezeichnung": "161.2 Himmel 2",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "209",
    "Bcolor": "229",
    "Y": 62,
    "L": 83.0358963012695,
    "a": -1.81980788707733,
    "b": -12.6729307174683,
    "C": 12.802924156189,
    "h": 261.828308105469,
    "CMY_C": 0.25269764661789,
    "CMY_M": 0.18056839704514,
    "CMY_Y": 0.10354065895081,
    "CMYK_C": 0.16638454794884,
    "CMYK_M": 0.08592440932989,
    "CMYK_Y": 0,
    "CMYK_K": 0.10354065895081
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0643",
    "Farbtonhilfsbezeichnung": "161.3 Himmel 3",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "220",
    "Bcolor": "232",
    "Y": 70,
    "L": 86.9286041259766,
    "a": -2.24122190475464,
    "b": -8.36091899871826,
    "C": 8.65609836578369,
    "h": 254.994110107422,
    "CMY_C": 0.19575554132462,
    "CMY_M": 0.1381139755249,
    "CMY_Y": 0.09189873933792,
    "CMYK_C": 0.11436698585749,
    "CMYK_M": 0.05089216306806,
    "CMYK_Y": 0,
    "CMYK_K": 0.09189873933792
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0644",
    "Farbtonhilfsbezeichnung": "161.4 Himmel 4",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "225",
    "Bcolor": "233",
    "Y": 76,
    "L": 88.9816741943359,
    "a": -2.25616717338562,
    "b": -5.82369041442871,
    "C": 6.24545097351074,
    "h": 248.823043823242,
    "CMY_C": 0.16325008869171,
    "CMY_M": 0.11609214544296,
    "CMY_Y": 0.08775115013123,
    "CMYK_C": 0.08276133984327,
    "CMYK_M": 0.03106717579067,
    "CMYK_Y": 0,
    "CMYK_K": 0.08775115013123
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0645",
    "Farbtonhilfsbezeichnung": "162.1 Provence 1",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "103",
    "Bcolor": "151",
    "Y": 14,
    "L": 44.3612098693848,
    "a": 8.28613185882568,
    "b": -28.3968257904053,
    "C": 29.5810699462891,
    "h": 286.267120361328,
    "CMY_C": 0.64489889144897,
    "CMY_M": 0.59691888093948,
    "CMY_Y": 0.40825980901718,
    "CMYK_C": 0.39990368485451,
    "CMYK_M": 0.31882077455521,
    "CMYK_Y": 0,
    "CMYK_K": 0.40825980901718
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0646",
    "Farbtonhilfsbezeichnung": "162.2 Provence 2",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "139",
    "Bcolor": "186",
    "Y": 26,
    "L": 58.2336387634277,
    "a": 6.38994598388672,
    "b": -27.0631999969482,
    "C": 27.8073406219482,
    "h": 283.284912109375,
    "CMY_C": 0.51292848587036,
    "CMY_M": 0.45615571737289,
    "CMY_Y": 0.27146083116531,
    "CMYK_C": 0.3314408659935,
    "CMYK_M": 0.25351402163506,
    "CMYK_Y": 0,
    "CMYK_K": 0.27146083116531
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0647",
    "Farbtonhilfsbezeichnung": "162.3 Provence 3",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "175",
    "Bcolor": "211",
    "Y": 43,
    "L": 71.4347915649414,
    "a": 3.78628587722778,
    "b": -20.9938793182373,
    "C": 21.3325786590576,
    "h": 280.223510742188,
    "CMY_C": 0.36677318811417,
    "CMY_M": 0.31558388471603,
    "CMY_Y": 0.17100816965103,
    "CMYK_C": 0.23614831268787,
    "CMYK_M": 0.17439945042133,
    "CMYK_Y": 0,
    "CMYK_K": 0.17100816965103
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0648",
    "Farbtonhilfsbezeichnung": "162.4 Provence 4",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "204",
    "Bcolor": "227",
    "Y": 60,
    "L": 81.9113388061523,
    "a": 1.31859517097473,
    "b": -13.3140306472778,
    "C": 13.3791666030884,
    "h": 275.656005859375,
    "CMY_C": 0.24105107784271,
    "CMY_M": 0.19988107681274,
    "CMY_Y": 0.11097449064255,
    "CMYK_C": 0.14631366729736,
    "CMYK_M": 0.1000045388937,
    "CMYK_Y": 0,
    "CMYK_K": 0.11097449064255
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0649",
    "Farbtonhilfsbezeichnung": "163.1 Ortensia 1",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "114",
    "Bcolor": "155",
    "Y": 18,
    "L": 49.5123634338379,
    "a": 9.89011573791504,
    "b": -22.7703113555908,
    "C": 24.8254203796387,
    "h": 293.477355957031,
    "CMY_C": 0.55133575201035,
    "CMY_M": 0.55286079645157,
    "CMY_Y": 0.39175653457642,
    "CMYK_C": 0.26236075162888,
    "CMYK_M": 0.26486805081367,
    "CMYK_Y": 0,
    "CMYK_K": 0.39175653457642
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0650",
    "Farbtonhilfsbezeichnung": "163.2 Ortensia 2",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "141",
    "Bcolor": "175",
    "Y": 28,
    "L": 60.1898498535156,
    "a": 8.81945133209229,
    "b": -17.5481948852539,
    "C": 19.6398029327393,
    "h": 296.683380126953,
    "CMY_C": 0.42856341600418,
    "CMY_M": 0.4454465508461,
    "CMY_Y": 0.31527996063232,
    "CMYK_C": 0.16544492542744,
    "CMYK_M": 0.19010192155838,
    "CMYK_Y": 0,
    "CMYK_K": 0.31527996063232
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0651",
    "Farbtonhilfsbezeichnung": "163.3 Ortensia 3",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "167",
    "Bcolor": "194",
    "Y": 40,
    "L": 69.6496734619141,
    "a": 6.83249664306641,
    "b": -14.0245313644409,
    "C": 15.6003360748291,
    "h": 295.974517822266,
    "CMY_C": 0.33092767000198,
    "CMY_M": 0.34396070241928,
    "CMY_Y": 0.23906230926514,
    "CMYK_C": 0.12072651833296,
    "CMYK_M": 0.13785411417484,
    "CMYK_Y": 0,
    "CMYK_K": 0.23906230926514
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0652",
    "Farbtonhilfsbezeichnung": "163.4 Ortensia 4",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "195",
    "Bcolor": "213",
    "Y": 56,
    "L": 79.5173187255859,
    "a": 4.75686883926392,
    "b": -9.48920726776123,
    "C": 10.6147470474243,
    "h": 296.624267578125,
    "CMY_C": 0.22401887178421,
    "CMY_M": 0.23523008823395,
    "CMY_Y": 0.16450589895248,
    "CMYK_C": 0.07123087346554,
    "CMYK_M": 0.08464954048395,
    "CMYK_Y": 0,
    "CMYK_K": 0.16450589895248
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0653",
    "Farbtonhilfsbezeichnung": "164.1 Holunder 1",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "108",
    "Bcolor": "139",
    "Y": 16,
    "L": 46.967357635498,
    "a": 8.08607196807861,
    "b": -17.391622543335,
    "C": 19.1794967651367,
    "h": 294.935638427734,
    "CMY_C": 0.56702679395676,
    "CMY_M": 0.57549786567688,
    "CMY_Y": 0.45323890447617,
    "CMYK_C": 0.20811262726784,
    "CMYK_M": 0.22360581159592,
    "CMYK_Y": 0,
    "CMYK_K": 0.45323890447617
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0654",
    "Farbtonhilfsbezeichnung": "164.2 Holunder 2",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "136",
    "Bcolor": "162",
    "Y": 25,
    "L": 57.4844703674316,
    "a": 6.49367380142212,
    "b": -14.3975276947022,
    "C": 15.7941951751709,
    "h": 294.276672363281,
    "CMY_C": 0.46144872903824,
    "CMY_M": 0.46855294704437,
    "CMY_Y": 0.36523842811584,
    "CMYK_C": 0.1515692025423,
    "CMYK_M": 0.16276113688946,
    "CMYK_Y": 0,
    "CMYK_K": 0.36523842811584
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0655",
    "Farbtonhilfsbezeichnung": "164.3 Holunder 3",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "160",
    "Bcolor": "181",
    "Y": 36,
    "L": 66.7180023193359,
    "a": 5.24165296554565,
    "b": -11.2397537231445,
    "C": 12.401894569397,
    "h": 295.001953125,
    "CMY_C": 0.36338716745377,
    "CMY_M": 0.37181794643402,
    "CMY_Y": 0.28997588157654,
    "CMYK_C": 0.10339266806841,
    "CMYK_M": 0.11526659876108,
    "CMYK_Y": 0,
    "CMYK_K": 0.28997588157654
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0656",
    "Farbtonhilfsbezeichnung": "164.4 Holunder 4",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "190",
    "Bcolor": "204",
    "Y": 52,
    "L": 77.347526550293,
    "a": 3.27809953689575,
    "b": -7.86691904067993,
    "C": 8.52257919311523,
    "h": 292.621215820313,
    "CMY_C": 0.25305610895157,
    "CMY_M": 0.2556374669075,
    "CMY_Y": 0.19994556903839,
    "CMYK_C": 0.06638365983963,
    "CMYK_M": 0.06961013376713,
    "CMYK_Y": 0,
    "CMYK_K": 0.19994556903839
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0657",
    "Farbtonhilfsbezeichnung": "165.1 Violetta 1",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "93",
    "Bcolor": "152",
    "Y": 13,
    "L": 42.7973709106445,
    "a": 18.6617946624756,
    "b": -31.4507122039795,
    "C": 36.570613861084,
    "h": 300.683471679688,
    "CMY_C": 0.59238743782043,
    "CMY_M": 0.63559401035309,
    "CMY_Y": 0.40375608205795,
    "CMYK_C": 0.31636607646942,
    "CMYK_M": 0.388830691576,
    "CMYK_Y": 0,
    "CMYK_K": 0.40375608205795
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0658",
    "Farbtonhilfsbezeichnung": "165.2 Violetta 2",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "138",
    "Bcolor": "190",
    "Y": 28,
    "L": 59.9536285400391,
    "a": 14.8299674987793,
    "b": -26.7386245727539,
    "C": 30.5758399963379,
    "h": 299.013946533203,
    "CMY_C": 0.4239364862442,
    "CMY_M": 0.45909857749939,
    "CMY_Y": 0.25444716215134,
    "CMYK_C": 0.22733375430107,
    "CMYK_M": 0.2744961977005,
    "CMYK_Y": 0,
    "CMYK_K": 0.25444716215134
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0659",
    "Farbtonhilfsbezeichnung": "165.3 Violetta 3",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "177",
    "Bcolor": "213",
    "Y": 47,
    "L": 73.5869979858398,
    "a": 9.47504901885986,
    "b": -18.5560340881348,
    "C": 20.8351383209229,
    "h": 297.049682617188,
    "CMY_C": 0.28641128540039,
    "CMY_M": 0.30718576908112,
    "CMY_Y": 0.16410100460052,
    "CMYK_C": 0.14632184803486,
    "CMYK_M": 0.17117470502853,
    "CMYK_Y": 0,
    "CMYK_K": 0.16410100460052
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0660",
    "Farbtonhilfsbezeichnung": "165.4 Violetta 4",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "202",
    "Bcolor": "221",
    "Y": 62,
    "L": 82.3154678344727,
    "a": 5.80422115325928,
    "b": -9.5402135848999,
    "C": 11.1671237945557,
    "h": 301.316131591797,
    "CMY_C": 0.18548077344894,
    "CMY_M": 0.20737218856812,
    "CMY_Y": 0.13331055641174,
    "CMYK_C": 0.06019482389092,
    "CMYK_M": 0.0854534804821,
    "CMYK_Y": 0,
    "CMYK_K": 0.13331055641174
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0661",
    "Farbtonhilfsbezeichnung": "166.1 Flieder 1",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "123",
    "Bcolor": "156",
    "Y": 21,
    "L": 52.783275604248,
    "a": 8.42714500427246,
    "b": -18.1561698913574,
    "C": 20.0165748596191,
    "h": 294.898254394531,
    "CMY_C": 0.50961738824844,
    "CMY_M": 0.51886701583862,
    "CMY_Y": 0.38861918449402,
    "CMYK_C": 0.19790971279144,
    "CMYK_M": 0.21303878724575,
    "CMYK_Y": 0,
    "CMYK_K": 0.38861918449402
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0662",
    "Farbtonhilfsbezeichnung": "166.2 Flieder 2",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "167",
    "Bcolor": "196",
    "Y": 41,
    "L": 69.5334167480469,
    "a": 7.42398643493652,
    "b": -15.0432424545288,
    "C": 16.7754192352295,
    "h": 296.266784667969,
    "CMY_C": 0.33156490325928,
    "CMY_M": 0.34625196456909,
    "CMY_Y": 0.23311132192612,
    "CMYK_C": 0.12838053703308,
    "CMYK_M": 0.14753203094006,
    "CMYK_Y": 0,
    "CMYK_K": 0.23311132192612
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0663",
    "Farbtonhilfsbezeichnung": "166.3 Flieder 3",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "196",
    "Bcolor": "210",
    "Y": 57,
    "L": 79.821662902832,
    "a": 4.42450094223022,
    "b": -7.1834888458252,
    "C": 8.43674850463867,
    "h": 301.630004882813,
    "CMY_C": 0.21484541893005,
    "CMY_M": 0.2318634390831,
    "CMY_Y": 0.17781007289886,
    "CMYK_C": 0.04504475742579,
    "CMYK_M": 0.06574316322803,
    "CMYK_Y": 0,
    "CMYK_K": 0.17781007289886
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0664",
    "Farbtonhilfsbezeichnung": "166.4 Flieder 4",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "211",
    "Bcolor": "216",
    "Y": 67,
    "L": 85.3612518310547,
    "a": 3.75537848472595,
    "b": -2.36173343658447,
    "C": 4.43628835678101,
    "h": 327.83447265625,
    "CMY_C": 0.14246720075607,
    "CMY_M": 0.17131251096725,
    "CMY_Y": 0.15229994058609,
    "CMYK_C": 0,
    "CMYK_M": 0.03363756090403,
    "CMYK_Y": 0.01146631315351,
    "CMYK_K": 0.14246720075607
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0665",
    "Farbtonhilfsbezeichnung": "167.1 Veilchen 1",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "107",
    "Bcolor": "139",
    "Y": 18,
    "L": 48.9382438659668,
    "a": 17.0866527557373,
    "b": -14.2158527374268,
    "C": 22.2271041870117,
    "h": 320.240020751953,
    "CMY_C": 0.47303152084351,
    "CMY_M": 0.57941234111786,
    "CMY_Y": 0.453060567379,
    "CMYK_C": 0.03651401400566,
    "CMYK_M": 0.23101602494717,
    "CMYK_Y": 0,
    "CMYK_K": 0.453060567379
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0666",
    "Farbtonhilfsbezeichnung": "167.2 Veilchen 2",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "138",
    "Bcolor": "170",
    "Y": 29,
    "L": 60.5546264648438,
    "a": 15.0910415649414,
    "b": -14.3221940994263,
    "C": 20.8054027557373,
    "h": 316.497344970703,
    "CMY_C": 0.36686193943024,
    "CMY_M": 0.45833456516266,
    "CMY_Y": 0.33272612094879,
    "CMYK_C": 0.05115713179111,
    "CMYK_M": 0.1882412135601,
    "CMYK_Y": 0,
    "CMYK_K": 0.33272612094879
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0667",
    "Farbtonhilfsbezeichnung": "167.3 Veilchen 3",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "181",
    "Bcolor": "203",
    "Y": 49,
    "L": 75.6730041503906,
    "a": 10.9681177139282,
    "b": -9.61874961853027,
    "C": 14.5883493423462,
    "h": 318.750091552734,
    "CMY_C": 0.21889328956604,
    "CMY_M": 0.29172497987747,
    "CMY_Y": 0.20465385913849,
    "CMYK_C": 0.01790343783796,
    "CMYK_M": 0.10947575420141,
    "CMYK_Y": 0,
    "CMYK_K": 0.20465385913849
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0668",
    "Farbtonhilfsbezeichnung": "167.4 Veilchen 4",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "210",
    "Bcolor": "222",
    "Y": 67,
    "L": 85.5759887695313,
    "a": 7.68355131149292,
    "b": -5.23706674575806,
    "C": 9.29859256744385,
    "h": 325.721862792969,
    "CMY_C": 0.11974400281906,
    "CMY_M": 0.177714407444,
    "CMY_Y": 0.12843948602676,
    "CMYK_C": 0,
    "CMYK_M": 0.0658563002944,
    "CMYK_Y": 0.00987835694104,
    "CMYK_K": 0.11974400281906
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0669",
    "Farbtonhilfsbezeichnung": "168.1 Glycinie 1",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "126",
    "Bcolor": "139",
    "Y": 22,
    "L": 54.2637901306152,
    "a": 7.33752536773682,
    "b": -5.81253385543823,
    "C": 9.36081314086914,
    "h": 321.614959716797,
    "CMY_C": 0.45781791210175,
    "CMY_M": 0.50558030605316,
    "CMY_Y": 0.45567095279694,
    "CMYK_C": 0.00394423073158,
    "CMYK_M": 0.09168967604637,
    "CMYK_Y": 0,
    "CMYK_K": 0.45567095279694
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0670",
    "Farbtonhilfsbezeichnung": "168.2 Glycinie 2",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "156",
    "Bcolor": "170",
    "Y": 35,
    "L": 65.6729507446289,
    "a": 7.4727258682251,
    "b": -6.32267332077026,
    "C": 9.78865814208984,
    "h": 319.765441894531,
    "CMY_C": 0.34042847156525,
    "CMY_M": 0.38948357105255,
    "CMY_Y": 0.33477509021759,
    "CMYK_C": 0.00849845074117,
    "CMYK_M": 0.08224057406187,
    "CMYK_Y": 0,
    "CMYK_K": 0.33477509021759
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0671",
    "Farbtonhilfsbezeichnung": "168.3 Glycinie 3",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "184",
    "Bcolor": "194",
    "Y": 50,
    "L": 75.873420715332,
    "a": 5.92680025100708,
    "b": -4.37605428695679,
    "C": 7.36728000640869,
    "h": 323.559692382813,
    "CMY_C": 0.23646664619446,
    "CMY_M": 0.27881640195847,
    "CMY_Y": 0.24041599035263,
    "CMYK_C": 0,
    "CMYK_M": 0.05546549707651,
    "CMYK_Y": 0.00517245801166,
    "CMYK_K": 0.23646664619446
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0672",
    "Farbtonhilfsbezeichnung": "168.4 Glycinie 4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "213",
    "Bcolor": "218",
    "Y": 68,
    "L": 85.9613571166992,
    "a": 4.14030313491821,
    "b": -2.32237267494202,
    "C": 4.74715948104858,
    "h": 330.711120605469,
    "CMY_C": 0.13273113965988,
    "CMY_M": 0.16566103696823,
    "CMY_Y": 0.14595538377762,
    "CMYK_C": 0,
    "CMYK_M": 0.03796965256333,
    "CMYK_Y": 0.01524814777076,
    "CMYK_K": 0.13273113965988
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0673",
    "Farbtonhilfsbezeichnung": "169.1 Alabaster 1",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "224",
    "Y": 79,
    "L": 90.617546081543,
    "a": -0.72991198301315,
    "b": 1.03525471687317,
    "C": 1.26669800281525,
    "h": 125.185958862305,
    "CMY_C": 0.10770338773727,
    "CMY_M": 0.10345846414566,
    "CMY_Y": 0.12007600069046,
    "CMYK_C": 0.00473477644846,
    "CMYK_M": 0,
    "CMYK_Y": 0.01853515580297,
    "CMYK_K": 0.10345846414566
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0674",
    "Farbtonhilfsbezeichnung": "169.2 Alabaster 2",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 83,
    "L": 93.0073471069336,
    "a": -0.4817918241024,
    "b": 3.23183369636536,
    "C": 3.26754832267761,
    "h": 98.4790344238281,
    "CMY_C": 0.07163965702057,
    "CMY_M": 0.07796424627304,
    "CMY_Y": 0.10994136333466,
    "CMYK_C": 0,
    "CMYK_M": 0.00681264465675,
    "CMYK_Y": 0.04125737026334,
    "CMYK_K": 0.07163965702057
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0675",
    "Farbtonhilfsbezeichnung": "169.3 Alabaster 3",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "226",
    "Y": 83,
    "L": 92.9302062988281,
    "a": -0.32637700438499,
    "b": 3.83446049690247,
    "C": 3.84832549095154,
    "h": 94.865104675293,
    "CMY_C": 0.06929302215576,
    "CMY_M": 0.07936549186707,
    "CMY_Y": 0.11525589227676,
    "CMYK_C": 0,
    "CMYK_M": 0.01082238554955,
    "CMYK_Y": 0.04938489943743,
    "CMYK_K": 0.06929302215576
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0676",
    "Farbtonhilfsbezeichnung": "169.4 Alabaster 4",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "243",
    "Bcolor": "235",
    "Y": 89,
    "L": 95.5591735839844,
    "a": -0.67654955387115,
    "b": 2.77014803886414,
    "C": 2.85156798362732,
    "h": 103.724601745605,
    "CMY_C": 0.04604142904282,
    "CMY_M": 0.04870146512985,
    "CMY_Y": 0.0782111287117,
    "CMYK_C": 0,
    "CMYK_M": 0.00278841890395,
    "CMYK_Y": 0.03372232243419,
    "CMYK_K": 0.04604142904282
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0677",
    "Farbtonhilfsbezeichnung": "170.1 Mond 1",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "216",
    "Bcolor": "210",
    "Y": 70,
    "L": 86.1564025878906,
    "a": -0.5373387336731,
    "b": 2.1546311378479,
    "C": 2.22062349319458,
    "h": 104.003227233887,
    "CMY_C": 0.1518212556839,
    "CMY_M": 0.15366625785828,
    "CMY_Y": 0.17720556259155,
    "CMYK_C": 0,
    "CMYK_M": 0.00217525172047,
    "CMYK_Y": 0.02992801554501,
    "CMYK_K": 0.1518212556839
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0678",
    "Farbtonhilfsbezeichnung": "170.2 Mond 2",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "218",
    "Bcolor": "213",
    "Y": 71,
    "L": 86.681266784668,
    "a": -1.20772194862366,
    "b": 1.02025878429413,
    "C": 1.58098709583282,
    "h": 139.809555053711,
    "CMY_C": 0.1551126241684,
    "CMY_M": 0.14599722623825,
    "CMY_Y": 0.16326093673706,
    "CMYK_C": 0.01067373342812,
    "CMYK_M": 0,
    "CMYK_Y": 0.02021505124867,
    "CMYK_K": 0.14599722623825
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0679",
    "Farbtonhilfsbezeichnung": "170.3 Mond 3",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "220",
    "Bcolor": "217",
    "Y": 73,
    "L": 87.8595581054688,
    "a": -0.17306181788445,
    "b": 0.73008477687836,
    "C": 0.7503160238266,
    "h": 103.335456848145,
    "CMY_C": 0.13494616746902,
    "CMY_M": 0.13531047105789,
    "CMY_Y": 0.14808821678162,
    "CMYK_C": 0,
    "CMYK_M": 0.00042113399832,
    "CMYK_Y": 0.01519217528403,
    "CMYK_K": 0.13494616746902
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0680",
    "Farbtonhilfsbezeichnung": "170.4 Mond 4",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 80,
    "L": 90.9984970092773,
    "a": -0.98585742712021,
    "b": 2.03011703491211,
    "C": 2.25683188438416,
    "h": 115.901954650879,
    "CMY_C": 0.10210204124451,
    "CMY_M": 0.09888899326324,
    "CMY_Y": 0.12327402830124,
    "CMYK_C": 0.00356565159746,
    "CMYK_M": 0,
    "CMYK_Y": 0.02706107869744,
    "CMYK_K": 0.09888899326324
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0681",
    "Farbtonhilfsbezeichnung": "171.1 Muschel 1",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 68,
    "L": 86.017936706543,
    "a": 0.97450762987137,
    "b": 3.1396336555481,
    "C": 3.28739476203918,
    "h": 72.756233215332,
    "CMY_C": 0.13845276832581,
    "CMY_M": 0.15901839733124,
    "CMY_Y": 0.18570929765701,
    "CMYK_C": 0,
    "CMYK_M": 0.02387057617307,
    "CMYK_Y": 0.0548507720232,
    "CMYK_K": 0.13845276832581
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0682",
    "Farbtonhilfsbezeichnung": "171.2 Muschel 2",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "216",
    "Bcolor": "212",
    "Y": 69,
    "L": 86.2199554443359,
    "a": 0.34157398343086,
    "b": 1.30833852291107,
    "C": 1.35219168663025,
    "h": 75.3681259155273,
    "CMY_C": 0.14709150791168,
    "CMY_M": 0.15479081869125,
    "CMY_Y": 0.17019540071487,
    "CMYK_C": 0,
    "CMYK_M": 0.00902712438256,
    "CMYK_Y": 0.02708836086094,
    "CMYK_K": 0.14709150791168
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0683",
    "Farbtonhilfsbezeichnung": "171.3 Muschel 3",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "221",
    "Bcolor": "218",
    "Y": 73,
    "L": 88.2570343017578,
    "a": 0.72165840864182,
    "b": 1.10077357292175,
    "C": 1.31624209880829,
    "h": 56.7514686584473,
    "CMY_C": 0.12228548526764,
    "CMY_M": 0.13312864303589,
    "CMY_Y": 0.14632964134216,
    "CMYK_C": 0,
    "CMYK_M": 0.01235385518521,
    "CMYK_Y": 0.02739405073225,
    "CMYK_K": 0.12228548526764
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0684",
    "Farbtonhilfsbezeichnung": "171.4 Muschel 4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "232",
    "Bcolor": "224",
    "Y": 81,
    "L": 91.8578186035156,
    "a": -0.13048891723156,
    "b": 3.29181551933289,
    "C": 3.29440093040466,
    "h": 92.2700347900391,
    "CMY_C": 0.08155697584152,
    "CMY_M": 0.09167456626892,
    "CMY_Y": 0.1230309009552,
    "CMYK_C": 0,
    "CMYK_M": 0.01101602427661,
    "CMYK_Y": 0.04515677690506,
    "CMYK_K": 0.08155697584152
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0685",
    "Farbtonhilfsbezeichnung": "172.1 Kristall 1",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "227",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.5746154785156,
    "a": 1.02648556232452,
    "b": 2.17415165901184,
    "C": 2.40428948402405,
    "h": 64.7265243530273,
    "CMY_C": 0.09054630994797,
    "CMY_M": 0.10842853784561,
    "CMY_Y": 0.12872737646103,
    "CMYK_C": 0,
    "CMYK_M": 0.01966260373592,
    "CMYK_Y": 0.04198241978884,
    "CMYK_K": 0.09054630994797
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0686",
    "Farbtonhilfsbezeichnung": "172.2 Kristall 2",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 82,
    "L": 92.7144775390625,
    "a": -1.06488275527954,
    "b": 2.91092276573181,
    "C": 3.09958815574646,
    "h": 110.093688964844,
    "CMY_C": 0.08059805631638,
    "CMY_M": 0.07977199554443,
    "CMY_Y": 0.11087554693222,
    "CMYK_C": 0.00089766969904,
    "CMYK_M": 0,
    "CMYK_Y": 0.03379983082414,
    "CMYK_K": 0.07977199554443
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0687",
    "Farbtonhilfsbezeichnung": "172.3 Kristall 3",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "232",
    "Bcolor": "224",
    "Y": 82,
    "L": 91.5775909423828,
    "a": -1.50191617012024,
    "b": 2.44160914421082,
    "C": 2.86656713485718,
    "h": 121.597076416016,
    "CMY_C": 0.09834587574005,
    "CMY_M": 0.09132599830627,
    "CMY_Y": 0.12000888586044,
    "CMYK_C": 0.0077254078351,
    "CMYK_M": 0,
    "CMYK_Y": 0.03156565129757,
    "CMYK_K": 0.09132599830627
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0688",
    "Farbtonhilfsbezeichnung": "172.4 Kristall 4",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "238",
    "Bcolor": "235",
    "Y": 84,
    "L": 93.4386367797852,
    "a": -2.08498454093933,
    "b": -0.23319989442825,
    "C": 2.09798550605774,
    "h": 186.381851196289,
    "CMY_C": 0.09157305955887,
    "CMY_M": 0.06835907697678,
    "CMY_Y": 0.07958674430847,
    "CMYK_C": 0.02491730637848,
    "CMYK_M": 0,
    "CMYK_Y": 0.01205149665475,
    "CMYK_K": 0.06835907697678
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0689",
    "Farbtonhilfsbezeichnung": "173.1 Perlmutt 1",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "225",
    "Bcolor": "221",
    "Y": 77,
    "L": 89.9008941650391,
    "a": 2.23318147659302,
    "b": 1.72296273708344,
    "C": 2.82058501243591,
    "h": 37.6512031555176,
    "CMY_C": 0.09018987417221,
    "CMY_M": 0.11868876218796,
    "CMY_Y": 0.13263976573944,
    "CMYK_C": 0,
    "CMYK_M": 0.0313239954412,
    "CMYK_Y": 0.0466579683125,
    "CMYK_K": 0.09018987417221
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0690",
    "Farbtonhilfsbezeichnung": "173.2 Perlmutt 2",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 84,
    "L": 93.4235382080078,
    "a": 3.31019973754883,
    "b": 2.31992650032043,
    "C": 4.04221248626709,
    "h": 35.0243797302246,
    "CMY_C": 0.04036748409271,
    "CMY_M": 0.08219730854034,
    "CMY_Y": 0.09800261259079,
    "CMYK_C": 0,
    "CMYK_M": 0.04358942061663,
    "CMYK_Y": 0.06005958095193,
    "CMYK_K": 0.04036748409271
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0691",
    "Farbtonhilfsbezeichnung": "173.3 Perlmutt 3",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "232",
    "Bcolor": "220",
    "Y": 82,
    "L": 92.5811996459961,
    "a": 2.75170516967773,
    "b": 6.4767165184021,
    "C": 7.03702640533447,
    "h": 66.9812469482422,
    "CMY_C": 0.04110777378082,
    "CMY_M": 0.0914106965065,
    "CMY_Y": 0.13830095529556,
    "CMYK_C": 0,
    "CMYK_M": 0.05245941132307,
    "CMYK_Y": 0.10135985910892,
    "CMYK_K": 0.04110777378082
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0692",
    "Farbtonhilfsbezeichnung": "173.4 Perlmutt 4",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "220",
    "Y": 83,
    "L": 92.9418640136719,
    "a": 1.16256356239319,
    "b": 6.86653470993042,
    "C": 6.96425533294678,
    "h": 80.3904571533203,
    "CMY_C": 0.04796797037125,
    "CMY_M": 0.08363115787506,
    "CMY_Y": 0.1374745965004,
    "CMYK_C": 0,
    "CMYK_M": 0.03746007010341,
    "CMYK_Y": 0.09401640295982,
    "CMYK_K": 0.04796797037125
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0693",
    "Farbtonhilfsbezeichnung": "174.1 Porzellan 1",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "212",
    "Y": 82,
    "L": 92.649284362793,
    "a": -0.32458433508873,
    "b": 10.3713846206665,
    "C": 10.3764629364014,
    "h": 91.7925491333008,
    "CMY_C": 0.05203825235367,
    "CMY_M": 0.08426380157471,
    "CMY_Y": 0.16701281070709,
    "CMYK_C": 0,
    "CMYK_M": 0.0339945666492,
    "CMYK_Y": 0.12128607183695,
    "CMYK_K": 0.05203825235367
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0694",
    "Farbtonhilfsbezeichnung": "174.2 Porzellan 2",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "242",
    "Bcolor": "224",
    "Y": 88,
    "L": 95.2434005737305,
    "a": -1.0757269859314,
    "b": 8.15601921081543,
    "C": 8.22665405273438,
    "h": 97.5135803222656,
    "CMY_C": 0.03526890277863,
    "CMY_M": 0.05278104543686,
    "CMY_Y": 0.12209141254425,
    "CMYK_C": 0,
    "CMYK_M": 0.01815235614777,
    "CMYK_Y": 0.08999659121037,
    "CMYK_K": 0.03526890277863
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0695",
    "Farbtonhilfsbezeichnung": "174.3 Porzellan 3",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "235",
    "Bcolor": "217",
    "Y": 82,
    "L": 92.544807434082,
    "a": -3.01392197608948,
    "b": 7.57234811782837,
    "C": 8.15010356903076,
    "h": 111.703384399414,
    "CMY_C": 0.08261370658875,
    "CMY_M": 0.07835870981216,
    "CMY_Y": 0.14771497249603,
    "CMYK_C": 0.00461676018313,
    "CMYK_M": 0,
    "CMYK_Y": 0.0752529874444,
    "CMYK_K": 0.07835870981216
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0696",
    "Farbtonhilfsbezeichnung": "174.4 Porzellan 4",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "237",
    "Bcolor": "229",
    "Y": 83,
    "L": 93.3361740112305,
    "a": -1.80553805828094,
    "b": 2.80920457839966,
    "C": 3.33940076828003,
    "h": 122.729759216309,
    "CMY_C": 0.07986974716187,
    "CMY_M": 0.07102811336517,
    "CMY_Y": 0.10334467887878,
    "CMYK_C": 0.00951765477657,
    "CMYK_M": 0,
    "CMYK_Y": 0.03478745371103,
    "CMYK_K": 0.07102811336517
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0697",
    "Farbtonhilfsbezeichnung": "175.1 Polar 1",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "236",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.5585098266602,
    "a": -3.64176058769226,
    "b": 1.90504634380341,
    "C": 4.1099419593811,
    "h": 152.38542175293,
    "CMY_C": 0.1064395904541,
    "CMY_M": 0.07520639896393,
    "CMY_Y": 0.10548269748688,
    "CMYK_C": 0.03377314656973,
    "CMYK_M": 0,
    "CMYK_Y": 0.03273843973875,
    "CMYK_K": 0.07520639896393
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0698",
    "Farbtonhilfsbezeichnung": "175.2 Polar 2",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "226",
    "Bcolor": "223",
    "Y": 76,
    "L": 89.3213195800781,
    "a": -2.80283045768738,
    "b": -0.04829516634345,
    "C": 2.80324649810791,
    "h": 180.987167358398,
    "CMY_C": 0.14245969057083,
    "CMY_M": 0.11274236440659,
    "CMY_Y": 0.12664771080017,
    "CMYK_C": 0.0334934592247,
    "CMYK_M": 0,
    "CMYK_Y": 0.01567227579653,
    "CMYK_K": 0.11274236440659
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0699",
    "Farbtonhilfsbezeichnung": "175.3 Polar 3",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "227",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.93408203125,
    "a": -0.95134276151657,
    "b": -2.38901710510254,
    "C": 2.57146954536438,
    "h": 248.286804199219,
    "CMY_C": 0.12913280725479,
    "CMY_M": 0.10956168174744,
    "CMY_Y": 0.10235273838043,
    "CMYK_C": 0.02983362227678,
    "CMYK_M": 0.00803093146533,
    "CMYK_Y": 0,
    "CMYK_K": 0.10235273838043
  },
  {
    "Farbtonkarten_Bezeichnung": "Alpina Color",
    "Farbton_ID": "ALF0700",
    "Farbtonhilfsbezeichnung": "175.4 Polar 4",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "228",
    "Bcolor": "232",
    "Y": 78,
    "L": 90.4213333129883,
    "a": 0.51739722490311,
    "b": -3.41651105880737,
    "C": 3.45546627044678,
    "h": 278.611450195313,
    "CMY_C": 0.11561173200607,
    "CMY_M": 0.10730147361755,
    "CMY_Y": 0.08916223049164,
    "CMYK_C": 0.02903865277767,
    "CMYK_M": 0.01991490088403,
    "CMYK_Y": 0,
    "CMYK_K": 0.08916223049164
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0001",
    "Farbtonhilfsbezeichnung": "Soft Helia",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "216",
    "Y": 81.4063491821289,
    "L": 92.3122100830078,
    "a": -1.88721394538879,
    "b": 8.14541149139404,
    "C": 8.36117839813232,
    "h": 103.044723510742,
    "CMY_C": 0.07461553812027,
    "CMY_M": 0.08375304937363,
    "CMY_Y": 0.15436291694641,
    "CMYK_C": 0,
    "CMYK_M": 0.00987428613007,
    "CMYK_Y": 0.08617756515741,
    "CMYK_K": 0.07461553812027
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0002",
    "Farbtonhilfsbezeichnung": "Soft Camill",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "230",
    "Bcolor": "211",
    "Y": 79.8743591308594,
    "L": 91.6284561157227,
    "a": 0.25188249349594,
    "b": 9.655029296875,
    "C": 9.65831470489502,
    "h": 88.5055923461914,
    "CMY_C": 0.06128025054932,
    "CMY_M": 0.0968582034111,
    "CMY_Y": 0.17274051904678,
    "CMYK_C": 0,
    "CMYK_M": 0.03790050372481,
    "CMYK_Y": 0.11873646825552,
    "CMYK_K": 0.06128025054932
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0003",
    "Farbtonhilfsbezeichnung": "Soft Stella",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "230",
    "Bcolor": "213",
    "Y": 80.3680267333984,
    "L": 91.849739074707,
    "a": 1.55393850803375,
    "b": 9.03245067596436,
    "C": 9.16514492034912,
    "h": 80.2384185791016,
    "CMY_C": 0.0507680773735,
    "CMY_M": 0.09735411405563,
    "CMY_Y": 0.16549682617188,
    "CMYK_C": 0,
    "CMYK_M": 0.04907761141658,
    "CMYK_Y": 0.12086482346058,
    "CMYK_K": 0.0507680773735
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0004",
    "Farbtonhilfsbezeichnung": "Soft Paya",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "217",
    "Y": 81.3584060668945,
    "L": 92.2909393310547,
    "a": 2.98230481147766,
    "b": 7.59665632247925,
    "C": 8.1610860824585,
    "h": 68.5659637451172,
    "CMY_C": 0.03926676511765,
    "CMY_M": 0.09551757574081,
    "CMY_Y": 0.14977794885635,
    "CMYK_C": 0,
    "CMYK_M": 0.05854987353086,
    "CMYK_Y": 0.11502795666456,
    "CMYK_K": 0.03926676511765
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0005",
    "Farbtonhilfsbezeichnung": "Soft Chili",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "230",
    "Bcolor": "222",
    "Y": 81.3069915771484,
    "L": 92.2681274414062,
    "a": 4.43995189666748,
    "b": 5.08143091201782,
    "C": 6.74789714813232,
    "h": 48.8543319702148,
    "CMY_C": 0.0361145734787,
    "CMY_M": 0.09866344928741,
    "CMY_Y": 0.13112646341324,
    "CMYK_C": 0,
    "CMYK_M": 0.06489244103432,
    "CMYK_Y": 0.09857176989317,
    "CMYK_K": 0.0361145734787
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0006",
    "Farbtonhilfsbezeichnung": "Soft Ombra",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "227",
    "Bcolor": "220",
    "Y": 76.3122329711914,
    "L": 90.0041122436523,
    "a": -0.47580277919769,
    "b": 2.6250102519989,
    "C": 2.66778326034546,
    "h": 100.273750305176,
    "CMY_C": 0.10715889930725,
    "CMY_M": 0.11133414506912,
    "CMY_Y": 0.13854968547821,
    "CMYK_C": 0,
    "CMYK_M": 0.00467635923997,
    "CMYK_Y": 0.03515831381083,
    "CMYK_K": 0.10715889930725
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0007",
    "Farbtonhilfsbezeichnung": "Soft Lilac",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "231",
    "Y": 77.7700042724609,
    "L": 90.6748428344727,
    "a": 2.39965605735779,
    "b": -2.53198790550232,
    "C": 3.48845410346985,
    "h": 313.462951660156,
    "CMY_C": 0.09463959932327,
    "CMY_M": 0.10924863815308,
    "CMY_Y": 0.09263294935226,
    "CMYK_C": 0.00221150857396,
    "CMYK_M": 0.01831198111176,
    "CMYK_Y": 0,
    "CMYK_K": 0.09263294935226
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0008",
    "Farbtonhilfsbezeichnung": "Soft Mare",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "231",
    "Bcolor": "233",
    "Y": 78.3934173583984,
    "L": 90.9591293334961,
    "a": -2.2212860584259,
    "b": -3.21116256713867,
    "C": 3.90457129478455,
    "h": 235.326873779297,
    "CMY_C": 0.13115036487579,
    "CMY_M": 0.09492737054825,
    "CMY_Y": 0.08506846427917,
    "CMYK_C": 0.0503665022552,
    "CMYK_M": 0.0107755670324,
    "CMYK_Y": 0,
    "CMYK_K": 0.08506846427917
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0009",
    "Farbtonhilfsbezeichnung": "Soft Cielo",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 76.9093780517578,
    "L": 90.2798919677734,
    "a": -5.67461395263672,
    "b": -2.27201151847839,
    "C": 6.11255121231079,
    "h": 201.820266723633,
    "CMY_C": 0.16378301382065,
    "CMY_M": 0.09485697746277,
    "CMY_Y": 0.10001122951508,
    "CMYK_C": 0.07614932954311,
    "CMYK_M": 0,
    "CMYK_Y": 0.00569440610707,
    "CMYK_K": 0.09485697746277
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0010",
    "Farbtonhilfsbezeichnung": "Soft Salvia",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "237",
    "Bcolor": "226",
    "Y": 81.4954833984375,
    "L": 92.3517227172852,
    "a": -6.16631698608398,
    "b": 2.8567214012146,
    "C": 6.79590463638306,
    "h": 155.142730712891,
    "CMY_C": 0.12598687410355,
    "CMY_M": 0.07199567556381,
    "CMY_Y": 0.11519891023636,
    "CMYK_C": 0.05817990005016,
    "CMYK_M": 0,
    "CMYK_Y": 0.04655499383807,
    "CMYK_K": 0.07199567556381
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0011",
    "Farbtonhilfsbezeichnung": "Cassis A5",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "218",
    "Bcolor": "216",
    "Y": 75.1850280761719,
    "L": 89.4795913696289,
    "a": 11.231541633606,
    "b": 3.77800130844116,
    "C": 11.849928855896,
    "h": 18.5916137695313,
    "CMY_C": 0.02138763666153,
    "CMY_M": 0.14643597602844,
    "CMY_Y": 0.15110433101654,
    "CMYK_C": 0,
    "CMYK_M": 0.12778127193451,
    "CMYK_Y": 0.1325516551733,
    "CMYK_K": 0.02138763666153
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0012",
    "Farbtonhilfsbezeichnung": "Cassis A4",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "199",
    "Bcolor": "199",
    "Y": 63.7695083618164,
    "L": 83.8456192016602,
    "a": 16.05517578125,
    "b": 4.85746049880981,
    "C": 16.7738952636719,
    "h": 16.8330841064453,
    "CMY_C": 0.04837054014206,
    "CMY_M": 0.22126442193985,
    "CMY_Y": 0.21952533721924,
    "CMYK_C": 0,
    "CMYK_M": 0.18168193101883,
    "CMYK_Y": 0.17985445261002,
    "CMYK_K": 0.04837054014206
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0013",
    "Farbtonhilfsbezeichnung": "Cassis A3",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "178",
    "Bcolor": "180",
    "Y": 52.078067779541,
    "L": 77.3274917602539,
    "a": 19.8050479888916,
    "b": 5.77203512191772,
    "C": 20.6290168762207,
    "h": 16.2483730316162,
    "CMY_C": 0.0946831703186,
    "CMY_M": 0.3020544052124,
    "CMY_Y": 0.29517620801926,
    "CMYK_C": 0,
    "CMYK_M": 0.22905929386616,
    "CMYK_Y": 0.22146174311638,
    "CMYK_K": 0.0946831703186
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0014",
    "Farbtonhilfsbezeichnung": "Cassis A2",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "145",
    "Bcolor": "150",
    "Y": 37.4896659851074,
    "L": 67.6427917480469,
    "a": 28.5250835418701,
    "b": 7.99324178695679,
    "C": 29.6238460540771,
    "h": 15.6538286209106,
    "CMY_C": 0.14454483985901,
    "CMY_M": 0.43010675907135,
    "CMY_Y": 0.41021656990051,
    "CMYK_C": 0,
    "CMYK_M": 0.33381283283234,
    "CMYK_Y": 0.31056183576584,
    "CMYK_K": 0.14454483985901
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0015",
    "Farbtonhilfsbezeichnung": "Cassis A1",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "95",
    "Bcolor": "107",
    "Y": 19.8979225158691,
    "L": 51.7215995788574,
    "a": 39.0041999816895,
    "b": 10.235034942627,
    "C": 40.3247261047363,
    "h": 14.7034015655518,
    "CMY_C": 0.26207369565964,
    "CMY_M": 0.62861561775208,
    "CMY_Y": 0.58163952827454,
    "CMYK_C": 0,
    "CMYK_M": 0.4967188835144,
    "CMYK_Y": 0.4330592751503,
    "CMYK_K": 0.26207369565964
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0016",
    "Farbtonhilfsbezeichnung": "Indigo C3",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "189",
    "Bcolor": "198",
    "Y": 50.5919532775879,
    "L": 76.4311752319336,
    "a": 0.48572733998299,
    "b": -6.11030960083008,
    "C": 6.12958526611328,
    "h": 274.545043945313,
    "CMY_C": 0.27838855981827,
    "CMY_M": 0.25954580307007,
    "CMY_Y": 0.22274541854858,
    "CMYK_C": 0.07158933579922,
    "CMYK_M": 0.04734662920237,
    "CMYK_Y": 0,
    "CMYK_K": 0.22274541854858
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0017",
    "Farbtonhilfsbezeichnung": "Cassis B5",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "218",
    "Bcolor": "216",
    "Y": 73.8529357910156,
    "L": 88.8529281616211,
    "a": 8.7661304473877,
    "b": 2.90959763526917,
    "C": 9.23638439178467,
    "h": 18.3617057800293,
    "CMY_C": 0.04902327060699,
    "CMY_M": 0.14678800106049,
    "CMY_Y": 0.15194821357727,
    "CMYK_C": 0,
    "CMYK_M": 0.10280454903841,
    "CMYK_Y": 0.10823076963425,
    "CMYK_K": 0.04902327060699
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0018",
    "Farbtonhilfsbezeichnung": "Cassis B4",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "202",
    "Bcolor": "202",
    "Y": 63.8912544250488,
    "L": 83.9091186523438,
    "a": 10.9711198806763,
    "b": 3.26668095588684,
    "C": 11.4471254348755,
    "h": 16.5810432434082,
    "CMY_C": 0.08767372369766,
    "CMY_M": 0.20677614212036,
    "CMY_Y": 0.20806086063385,
    "CMYK_C": 0,
    "CMYK_M": 0.13054804503918,
    "CMYK_Y": 0.13195623457432,
    "CMYK_K": 0.08767372369766
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0019",
    "Farbtonhilfsbezeichnung": "Cassis B3",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "184",
    "Bcolor": "185",
    "Y": 53.793571472168,
    "L": 78.3412094116211,
    "a": 14.9261674880981,
    "b": 4.1084189414978,
    "C": 15.4812650680542,
    "h": 15.3895359039307,
    "CMY_C": 0.12017267942429,
    "CMY_M": 0.27753603458405,
    "CMY_Y": 0.2732920050621,
    "CMYK_C": 0,
    "CMYK_M": 0.17885708808899,
    "CMYK_Y": 0.17403338849545,
    "CMYK_K": 0.12017267942429
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0020",
    "Farbtonhilfsbezeichnung": "Cassis B2",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "141",
    "Bcolor": "145",
    "Y": 33.0911674499512,
    "L": 64.2346572875977,
    "a": 22.5692501068115,
    "b": 6.02743530273438,
    "C": 23.3602447509766,
    "h": 14.9526720046997,
    "CMY_C": 0.22307199239731,
    "CMY_M": 0.44725233316422,
    "CMY_Y": 0.43243944644928,
    "CMYK_C": 0,
    "CMYK_M": 0.28854712843895,
    "CMYK_Y": 0.26948115229607,
    "CMYK_K": 0.22307199239731
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0021",
    "Farbtonhilfsbezeichnung": "Cassis B1",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "103",
    "Bcolor": "110",
    "Y": 19.8712043762207,
    "L": 51.691276550293,
    "a": 30.068452835083,
    "b": 7.78407049179077,
    "C": 31.0596790313721,
    "h": 14.5140018463135,
    "CMY_C": 0.31457167863846,
    "CMY_M": 0.59704911708832,
    "CMY_Y": 0.56753027439117,
    "CMYK_C": 0,
    "CMYK_M": 0.41211813688278,
    "CMYK_Y": 0.36905184388161,
    "CMYK_K": 0.31457167863846
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0022",
    "Farbtonhilfsbezeichnung": "Cassis C5",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "219",
    "Bcolor": "217",
    "Y": 74.2700958251953,
    "L": 89.0499801635742,
    "a": 6.99154663085938,
    "b": 2.93215394020081,
    "C": 7.58150720596313,
    "h": 22.7524757385254,
    "CMY_C": 0.05985641479492,
    "CMY_M": 0.14014571905136,
    "CMY_Y": 0.15021449327469,
    "CMYK_C": 0,
    "CMYK_M": 0.08540111035109,
    "CMYK_Y": 0.09611093252897,
    "CMYK_K": 0.05985641479492
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0023",
    "Farbtonhilfsbezeichnung": "Cassis C4",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "203",
    "Bcolor": "202",
    "Y": 63.039379119873,
    "L": 83.4630966186523,
    "a": 8.04494190216064,
    "b": 2.62705993652344,
    "C": 8.46300983428955,
    "h": 18.0843467712402,
    "CMY_C": 0.11559963226318,
    "CMY_M": 0.20405060052872,
    "CMY_Y": 0.20866972208023,
    "CMYK_C": 0,
    "CMYK_M": 0.10001236200333,
    "CMYK_Y": 0.10523524880409,
    "CMYK_K": 0.11559963226318
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0024",
    "Farbtonhilfsbezeichnung": "Cassis C3",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "188",
    "Bcolor": "188",
    "Y": 53.7294464111328,
    "L": 78.3037109375,
    "a": 9.09581565856934,
    "b": 2.35375618934631,
    "C": 9.39542579650879,
    "h": 14.5083732604981,
    "CMY_C": 0.16601592302322,
    "CMY_M": 0.26246881484985,
    "CMY_Y": 0.26199412345886,
    "CMYK_C": 0,
    "CMYK_M": 0.11565315723419,
    "CMYK_Y": 0.11508397012949,
    "CMYK_K": 0.16601592302322
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0025",
    "Farbtonhilfsbezeichnung": "Cassis C2",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "146",
    "Bcolor": "148",
    "Y": 32.0586776733398,
    "L": 63.3913497924805,
    "a": 12.9946022033691,
    "b": 2.87016153335571,
    "C": 13.3077993392944,
    "h": 12.4551401138306,
    "CMY_C": 0.3001680970192,
    "CMY_M": 0.42929661273956,
    "CMY_Y": 0.42085260152817,
    "CMYK_C": 0,
    "CMYK_M": 0.18451361358166,
    "CMYK_Y": 0.17244784533978,
    "CMYK_K": 0.3001680970192
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0026",
    "Farbtonhilfsbezeichnung": "Cassis C1",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "109",
    "Bcolor": "111",
    "Y": 18.1992816925049,
    "L": 49.736930847168,
    "a": 15.0589828491211,
    "b": 4.16162919998169,
    "C": 15.6234474182129,
    "h": 15.4484176635742,
    "CMY_C": 0.42844784259796,
    "CMY_M": 0.57199716567993,
    "CMY_Y": 0.56516492366791,
    "CMYK_C": 0,
    "CMYK_M": 0.25115698575974,
    "CMYK_Y": 0.23920315504074,
    "CMYK_K": 0.42844784259796
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0027",
    "Farbtonhilfsbezeichnung": "Mare C2",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "155",
    "Bcolor": "172",
    "Y": 31.3423366546631,
    "L": 62.7955589294434,
    "a": -4.06469678878784,
    "b": -12.1696195602417,
    "C": 12.8304872512817,
    "h": 251.530502319336,
    "CMY_C": 0.48300248384476,
    "CMY_M": 0.39174264669418,
    "CMY_Y": 0.32599538564682,
    "CMYK_C": 0.23294661939144,
    "CMYK_M": 0.0975471958518,
    "CMYK_Y": 0,
    "CMYK_K": 0.32599538564682
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0028",
    "Farbtonhilfsbezeichnung": "Malva A5",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "217",
    "Bcolor": "210",
    "Y": 75.1272583007813,
    "L": 89.4525680541992,
    "a": 11.7649154663086,
    "b": 7.29823684692383,
    "C": 13.8447647094727,
    "h": 31.8129444122314,
    "CMY_C": 0.00802373886108,
    "CMY_M": 0.14911395311356,
    "CMY_Y": 0.17724102735519,
    "CMYK_C": 0,
    "CMYK_M": 0.14223144948483,
    "CMYK_Y": 0.17058601975441,
    "CMYK_K": 0.00802373886108
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0029",
    "Farbtonhilfsbezeichnung": "Malva A4",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "198",
    "Bcolor": "191",
    "Y": 64.2056503295898,
    "L": 84.0727310180664,
    "a": 16.6914958953857,
    "b": 9.64624404907227,
    "C": 19.2783832550049,
    "h": 30.024206161499,
    "CMY_C": 0.02929943799973,
    "CMY_M": 0.22184109687805,
    "CMY_Y": 0.25174796581268,
    "CMYK_C": 0,
    "CMYK_M": 0.19835330545902,
    "CMYK_Y": 0.22916287183762,
    "CMYK_K": 0.02929943799973
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0030",
    "Farbtonhilfsbezeichnung": "Malva A3",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "184",
    "Bcolor": "176",
    "Y": 56.6877250671387,
    "L": 80.0036315917969,
    "a": 20.332405090332,
    "b": 11.8449592590332,
    "C": 23.5310382843018,
    "h": 30.2236042022705,
    "CMY_C": 0.04665839672089,
    "CMY_M": 0.27648323774338,
    "CMY_Y": 0.31027662754059,
    "CMYK_C": 0,
    "CMYK_M": 0.24107292294502,
    "CMYK_Y": 0.27652022242546,
    "CMYK_K": 0.04665839672089
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0031",
    "Farbtonhilfsbezeichnung": "Malva A2",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "131",
    "Bcolor": "121",
    "Y": 33.3985404968262,
    "L": 64.4823150634766,
    "a": 34.2580757141113,
    "b": 20.2912826538086,
    "C": 39.816478729248,
    "h": 30.6385383605957,
    "CMY_C": 0.12619775533676,
    "CMY_M": 0.48439168930054,
    "CMY_Y": 0.52571427822113,
    "CMYK_C": 0,
    "CMYK_M": 0.40992563962936,
    "CMYK_Y": 0.45721617341042,
    "CMYK_K": 0.12619775533676
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0032",
    "Farbtonhilfsbezeichnung": "Malva A1",
    "Farbtonklasse": "04",
    "Rcolor": "200",
    "Gcolor": "79",
    "Bcolor": "73",
    "Y": 18.2895603179932,
    "L": 49.8454437255859,
    "a": 48.1807098388672,
    "b": 28.0422420501709,
    "C": 55.7471809387207,
    "h": 30.2003536224365,
    "CMY_C": 0.21632409095764,
    "CMY_M": 0.69128572940826,
    "CMY_Y": 0.71353685855865,
    "CMYK_C": 0,
    "CMYK_M": 0.60606896877289,
    "CMYK_Y": 0.63446223735809,
    "CMYK_K": 0.21632409095764
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0033",
    "Farbtonhilfsbezeichnung": "Lilac C4",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "203",
    "Bcolor": "212",
    "Y": 60.7174644470215,
    "L": 82.2266159057617,
    "a": 2.84167265892029,
    "b": -4.7176365852356,
    "C": 5.5073766708374,
    "h": 301.062683105469,
    "CMY_C": 0.19215029478073,
    "CMY_M": 0.20271921157837,
    "CMY_Y": 0.16957914829254,
    "CMYK_C": 0.02718036994338,
    "CMYK_M": 0.03990755230188,
    "CMYK_Y": 0,
    "CMYK_K": 0.16957914829254
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0034",
    "Farbtonhilfsbezeichnung": "Malva B5",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 72.6847915649414,
    "L": 88.2971649169922,
    "a": 9.56804752349854,
    "b": 6.41956806182861,
    "C": 11.5220823287964,
    "h": 33.8591651916504,
    "CMY_C": 0.03933644294739,
    "CMY_M": 0.15595126152039,
    "CMY_Y": 0.18369799852371,
    "CMYK_C": 0,
    "CMYK_M": 0.12138986587524,
    "CMYK_Y": 0.15027275681496,
    "CMYK_K": 0.03933644294739
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0035",
    "Farbtonhilfsbezeichnung": "Malva B4",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "200",
    "Bcolor": "193",
    "Y": 62.7951965332031,
    "L": 83.3345031738281,
    "a": 12.3213481903076,
    "b": 7.22727298736572,
    "C": 14.2845754623413,
    "h": 30.3943996429443,
    "CMY_C": 0.07379871606827,
    "CMY_M": 0.21762430667877,
    "CMY_Y": 0.24279421567917,
    "CMYK_C": 0,
    "CMYK_M": 0.15528546273708,
    "CMYK_Y": 0.18246087431908,
    "CMYK_K": 0.07379871606827
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0036",
    "Farbtonhilfsbezeichnung": "Malva B3",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "184",
    "Bcolor": "178",
    "Y": 54.0044059753418,
    "L": 78.4643020629883,
    "a": 15.9386720657349,
    "b": 8.53946304321289,
    "C": 18.0821380615234,
    "h": 28.1810722351074,
    "CMY_C": 0.10078829526901,
    "CMY_M": 0.28012853860855,
    "CMY_Y": 0.3035352230072,
    "CMYK_C": 0,
    "CMYK_M": 0.19944162666798,
    "CMYK_Y": 0.2254718542099,
    "CMYK_K": 0.10078829526901
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0037",
    "Farbtonhilfsbezeichnung": "Malva B1",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "95",
    "Bcolor": "88",
    "Y": 18.3595199584961,
    "L": 49.9292869567871,
    "a": 32.903678894043,
    "b": 18.709997177124,
    "C": 37.8512344360352,
    "h": 29.6238307952881,
    "CMY_C": 0.30273962020874,
    "CMY_M": 0.62677240371704,
    "CMY_Y": 0.65518593788147,
    "CMYK_C": 0,
    "CMYK_M": 0.46472278237343,
    "CMYK_Y": 0.50547301769257,
    "CMYK_K": 0.30273962020874
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0038",
    "Farbtonhilfsbezeichnung": "Indigo B2",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "155",
    "Bcolor": "186",
    "Y": 31.9046821594238,
    "L": 63.2640190124512,
    "a": 0.35239478945732,
    "b": -19.5746097564697,
    "C": 19.5777816772461,
    "h": 271.031372070313,
    "CMY_C": 0.4751158952713,
    "CMY_M": 0.39390641450882,
    "CMY_Y": 0.26959890127182,
    "CMYK_C": 0.2813755273819,
    "CMYK_M": 0.17019075155258,
    "CMYK_Y": 0,
    "CMYK_K": 0.26959890127182
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0039",
    "Farbtonhilfsbezeichnung": "Malva C5",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "218",
    "Bcolor": "212",
    "Y": 72.9034042358398,
    "L": 88.4016189575195,
    "a": 6.2786545753479,
    "b": 4.38248586654663,
    "C": 7.6568717956543,
    "h": 34.9149513244629,
    "CMY_C": 0.06807494163513,
    "CMY_M": 0.14594298601151,
    "CMY_Y": 0.16808182001114,
    "CMYK_C": 0,
    "CMYK_M": 0.08355612307787,
    "CMYK_Y": 0.10731214284897,
    "CMYK_K": 0.06807494163513
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0040",
    "Farbtonhilfsbezeichnung": "Malva C4",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "202",
    "Bcolor": "196",
    "Y": 62.1668701171875,
    "L": 83.002082824707,
    "a": 8.05311298370361,
    "b": 4.83650159835815,
    "C": 9.39384746551514,
    "h": 30.9879913330078,
    "CMY_C": 0.11426448822021,
    "CMY_M": 0.20971125364304,
    "CMY_Y": 0.22967278957367,
    "CMYK_C": 0,
    "CMYK_M": 0.10775989294052,
    "CMYK_Y": 0.13029657304287,
    "CMYK_K": 0.11426448822021
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0041",
    "Farbtonhilfsbezeichnung": "Malva C3",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "185",
    "Bcolor": "180",
    "Y": 52.183406829834,
    "L": 77.390380859375,
    "a": 9.98199081420898,
    "b": 5.26635694503784,
    "C": 11.2860383987427,
    "h": 27.8154945373535,
    "CMY_C": 0.16174209117889,
    "CMY_M": 0.27530354261398,
    "CMY_Y": 0.29240775108337,
    "CMYK_C": 0,
    "CMYK_M": 0.13547316193581,
    "CMYK_Y": 0.15587763488293,
    "CMYK_K": 0.16174209117889
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0042",
    "Farbtonhilfsbezeichnung": "Malva C2",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "148",
    "Bcolor": "143",
    "Y": 33.2709541320801,
    "L": 64.3797073364258,
    "a": 13.3747024536133,
    "b": 6.98597478866577,
    "C": 15.0892848968506,
    "h": 27.5793037414551,
    "CMY_C": 0.27703940868378,
    "CMY_M": 0.42119228839874,
    "CMY_Y": 0.43897593021393,
    "CMYK_C": 0,
    "CMYK_M": 0.19939243793488,
    "CMYK_Y": 0.22399079799652,
    "CMYK_K": 0.27703940868378
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0043",
    "Farbtonhilfsbezeichnung": "Malva C1",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "106",
    "Bcolor": "101",
    "Y": 17.7017116546631,
    "L": 49.1323013305664,
    "a": 16.9639339447021,
    "b": 9.12304973602295,
    "C": 19.2614917755127,
    "h": 28.270959854126,
    "CMY_C": 0.41352820396423,
    "CMY_M": 0.58414053916931,
    "CMY_Y": 0.6030445098877,
    "CMYK_C": 0,
    "CMYK_M": 0.29091310501099,
    "CMYK_Y": 0.32314649224281,
    "CMYK_K": 0.41352820396423
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0044",
    "Farbtonhilfsbezeichnung": "Flanell G2",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "143",
    "Bcolor": "141",
    "Y": 27.6788921356201,
    "L": 59.5975189208984,
    "a": 0.48524454236031,
    "b": 1.08665728569031,
    "C": 1.1900782585144,
    "h": 65.9369506835938,
    "CMY_C": 0.43028956651688,
    "CMY_M": 0.43815070390701,
    "CMY_Y": 0.44895458221436,
    "CMYK_C": 0,
    "CMYK_M": 0.01379847899079,
    "CMYK_Y": 0.03276228532195,
    "CMYK_K": 0.43028956651688
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0045",
    "Farbtonhilfsbezeichnung": "Chili A5",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "215",
    "Bcolor": "201",
    "Y": 73.9580078125,
    "L": 88.9026336669922,
    "a": 12.3958120346069,
    "b": 10.9317207336426,
    "C": 16.5275135040283,
    "h": 41.40869140625,
    "CMY_C": 0.00030851364136,
    "CMY_M": 0.15782082080841,
    "CMY_Y": 0.20987379550934,
    "CMYK_C": 0,
    "CMYK_M": 0.15756091475487,
    "CMYK_Y": 0.20962995290756,
    "CMYK_K": 0.00030851364136
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0046",
    "Farbtonhilfsbezeichnung": "Chili A4",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "200",
    "Bcolor": "184",
    "Y": 64.9250411987305,
    "L": 84.4450988769531,
    "a": 15.8733587265015,
    "b": 13.6064348220825,
    "C": 20.9069023132324,
    "h": 40.6027488708496,
    "CMY_C": 0.02115213871002,
    "CMY_M": 0.21662431955338,
    "CMY_Y": 0.27672910690308,
    "CMYK_C": 0,
    "CMYK_M": 0.19969618320465,
    "CMYK_Y": 0.26109978556633,
    "CMYK_K": 0.02115213871002
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0047",
    "Farbtonhilfsbezeichnung": "Chili A3",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "183",
    "Bcolor": "166",
    "Y": 56.0097694396973,
    "L": 79.6193771362305,
    "a": 20.1540451049805,
    "b": 16.9318561553955,
    "C": 26.3224868774414,
    "h": 40.0343589782715,
    "CMY_C": 0.04140073060989,
    "CMY_M": 0.28142219781876,
    "CMY_Y": 0.35095596313477,
    "CMYK_C": 0,
    "CMYK_M": 0.25038769841194,
    "CMYK_Y": 0.32292455434799,
    "CMYK_K": 0.04140073060989
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0048",
    "Farbtonhilfsbezeichnung": "Chili A2",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "131",
    "Bcolor": "108",
    "Y": 33.135627746582,
    "L": 64.2705764770508,
    "a": 33.3263244628906,
    "b": 27.5424137115479,
    "C": 43.2345733642578,
    "h": 39.5718994140625,
    "CMY_C": 0.12385070323944,
    "CMY_M": 0.48514604568481,
    "CMY_Y": 0.57828325033188,
    "CMYK_C": 0,
    "CMYK_M": 0.41236731410027,
    "CMYK_Y": 0.51867020130157,
    "CMYK_K": 0.12385070323944
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0049",
    "Farbtonhilfsbezeichnung": "Chili A1",
    "Farbtonklasse": "04",
    "Rcolor": "196",
    "Gcolor": "82",
    "Bcolor": "55",
    "Y": 17.9288902282715,
    "L": 49.4097442626953,
    "a": 44.2411499023438,
    "b": 37.7701835632324,
    "C": 58.1710090637207,
    "h": 40.4885215759277,
    "CMY_C": 0.23314172029495,
    "CMY_M": 0.67983186244965,
    "CMY_Y": 0.78518277406693,
    "CMYK_C": 0,
    "CMYK_M": 0.58249372243881,
    "CMYK_Y": 0.71987360715866,
    "CMYK_K": 0.23314172029495
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0050",
    "Farbtonhilfsbezeichnung": "Carbon G3",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "186",
    "Bcolor": "187",
    "Y": 48.580997467041,
    "L": 75.1899108886719,
    "a": -0.62875384092331,
    "b": -1.62589800357819,
    "C": 1.74323713779449,
    "h": 248.857925415039,
    "CMY_C": 0.28433430194855,
    "CMY_M": 0.27163058519363,
    "CMY_Y": 0.2681400179863,
    "CMYK_C": 0.02212757058442,
    "CMYK_M": 0.00476944679394,
    "CMYK_Y": 0,
    "CMYK_K": 0.2681400179863
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0051",
    "Farbtonhilfsbezeichnung": "Chili B5",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "215",
    "Bcolor": "206",
    "Y": 72.4449157714844,
    "L": 88.1823043823242,
    "a": 8.60301113128662,
    "b": 7.1935510635376,
    "C": 11.2142314910889,
    "h": 39.9012451171875,
    "CMY_C": 0.04543775320053,
    "CMY_M": 0.15497350692749,
    "CMY_Y": 0.19078344106674,
    "CMYK_C": 0,
    "CMYK_M": 0.11474972218275,
    "CMYK_Y": 0.15226423740387,
    "CMYK_K": 0.04543775320053
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0052",
    "Farbtonhilfsbezeichnung": "Chili B4",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "202",
    "Bcolor": "191",
    "Y": 63.5249252319336,
    "L": 83.7178039550781,
    "a": 10.4286031723023,
    "b": 9.09869003295898,
    "C": 13.8398675918579,
    "h": 41.1038665771484,
    "CMY_C": 0.07778543233871,
    "CMY_M": 0.20907384157181,
    "CMY_Y": 0.25257647037506,
    "CMYK_C": 0,
    "CMYK_M": 0.14236210286617,
    "CMYK_Y": 0.18953402340412,
    "CMYK_K": 0.07778543233871
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0053",
    "Farbtonhilfsbezeichnung": "Chili B3",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "185",
    "Bcolor": "172",
    "Y": 53.7212295532227,
    "L": 78.2989044189453,
    "a": 13.3340692520142,
    "b": 11.264048576355,
    "C": 17.4549770355225,
    "h": 40.1896858215332,
    "CMY_C": 0.11355358362198,
    "CMY_M": 0.27574056386948,
    "CMY_Y": 0.32522523403168,
    "CMYK_C": 0,
    "CMYK_M": 0.18296308815479,
    "CMYK_Y": 0.23878674209118,
    "CMYK_K": 0.11355358362198
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0054",
    "Farbtonhilfsbezeichnung": "Chili B2",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "138",
    "Bcolor": "121",
    "Y": 31.50901222229,
    "L": 62.9349975585938,
    "a": 21.2049007415771,
    "b": 17.5843887329102,
    "C": 27.5473880767822,
    "h": 39.6675796508789,
    "CMY_C": 0.22338330745697,
    "CMY_M": 0.45965665578842,
    "CMY_Y": 0.52497482299805,
    "CMYK_C": 0,
    "CMYK_M": 0.30423417687416,
    "CMYK_Y": 0.38834023475647,
    "CMYK_K": 0.22338330745697
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0055",
    "Farbtonhilfsbezeichnung": "Chili B1",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "97",
    "Bcolor": "80",
    "Y": 17.7288150787354,
    "L": 49.1655197143555,
    "a": 28.2823524475098,
    "b": 22.4115524291992,
    "C": 36.085578918457,
    "h": 38.3940696716309,
    "CMY_C": 0.33094054460526,
    "CMY_M": 0.61977016925812,
    "CMY_Y": 0.68770313262939,
    "CMYK_C": 0,
    "CMYK_M": 0.43169501423836,
    "CMYK_Y": 0.53323000669479,
    "CMYK_K": 0.33094054460526
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0056",
    "Farbtonhilfsbezeichnung": "Mare C3",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "192",
    "Bcolor": "201",
    "Y": 51.2758903503418,
    "L": 76.8458251953125,
    "a": -2.69172620773315,
    "b": -7.11651515960693,
    "C": 7.60855960845947,
    "h": 249.281555175781,
    "CMY_C": 0.30347031354904,
    "CMY_M": 0.24760627746582,
    "CMY_Y": 0.21146941184998,
    "CMYK_C": 0.11667384952307,
    "CMYK_M": 0.04582810774446,
    "CMYK_Y": 0,
    "CMYK_K": 0.21146941184998
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0057",
    "Farbtonhilfsbezeichnung": "Chili C5",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "218",
    "Bcolor": "211",
    "Y": 72.0580749511719,
    "L": 87.9965362548828,
    "a": 4.8220043182373,
    "b": 4.40655755996704,
    "C": 6.53218746185303,
    "h": 42.4224281311035,
    "CMY_C": 0.08338379859924,
    "CMY_M": 0.14682590961456,
    "CMY_Y": 0.17289417982101,
    "CMYK_C": 0,
    "CMYK_M": 0.06921338289976,
    "CMYK_Y": 0.0976530611515,
    "CMYK_K": 0.08338379859924
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0058",
    "Farbtonhilfsbezeichnung": "Chili C4",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "202",
    "Bcolor": "195",
    "Y": 62.3135681152344,
    "L": 83.0798950195313,
    "a": 6.84043598175049,
    "b": 5.73715829849243,
    "C": 8.92785263061523,
    "h": 39.9869766235352,
    "CMY_C": 0.11957490444183,
    "CMY_M": 0.20609492063522,
    "CMY_Y": 0.23555135726929,
    "CMYK_C": 0,
    "CMYK_M": 0.09827072918415,
    "CMYK_Y": 0.13172778487206,
    "CMYK_K": 0.11957490444183
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0059",
    "Farbtonhilfsbezeichnung": "Chili C3",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "188",
    "Bcolor": "181",
    "Y": 53.7204513549805,
    "L": 78.2984466552734,
    "a": 8.04265594482422,
    "b": 6.42952585220337,
    "C": 10.2967529296875,
    "h": 38.6398239135742,
    "CMY_C": 0.16212606430054,
    "CMY_M": 0.26102083921432,
    "CMY_Y": 0.29140073060989,
    "CMYK_C": 0,
    "CMYK_M": 0.11803061515093,
    "CMYK_Y": 0.15428891777992,
    "CMYK_K": 0.16212606430054
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0060",
    "Farbtonhilfsbezeichnung": "Chili C2",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "145",
    "Bcolor": "135",
    "Y": 31.8386764526367,
    "L": 63.2093276977539,
    "a": 12.0572566986084,
    "b": 9.61248111724854,
    "C": 15.4200267791748,
    "h": 38.563117980957,
    "CMY_C": 0.29211592674255,
    "CMY_M": 0.43054699897766,
    "CMY_Y": 0.46905183792114,
    "CMYK_C": 0,
    "CMYK_M": 0.19555613398552,
    "CMYK_Y": 0.24995040893555,
    "CMYK_K": 0.29211592674255
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0061",
    "Farbtonhilfsbezeichnung": "Chili C1",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "102",
    "Bcolor": "90",
    "Y": 16.4529151916504,
    "L": 47.563175201416,
    "a": 16.3303527832031,
    "b": 13.3723268508911,
    "C": 21.106861114502,
    "h": 39.3127899169922,
    "CMY_C": 0.42612200975418,
    "CMY_M": 0.59871077537537,
    "CMY_Y": 0.64568686485291,
    "CMYK_C": 0,
    "CMYK_M": 0.30074122548103,
    "CMYK_Y": 0.38259848952293,
    "CMYK_K": 0.42612200975418
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0062",
    "Farbtonhilfsbezeichnung": "Cotta A5",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "200",
    "Y": 75.9403076171875,
    "L": 89.8316192626953,
    "a": 10.5452175140381,
    "b": 12.8730087280273,
    "C": 16.6407928466797,
    "h": 50.6766014099121,
    "CMY_C": 0,
    "CMY_M": 0.1432471871376,
    "CMY_Y": 0.21445739269257,
    "CMYK_C": 0,
    "CMYK_M": 0.1432471871376,
    "CMYK_Y": 0.21445739269257,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0063",
    "Farbtonhilfsbezeichnung": "Cotta A4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "176",
    "Y": 65.9475936889648,
    "L": 84.9696807861328,
    "a": 16.0968780517578,
    "b": 19.1486320495606,
    "C": 25.0155868530273,
    "h": 49.9486465454102,
    "CMY_C": 0.00133728981018,
    "CMY_M": 0.21289455890656,
    "CMY_Y": 0.31162345409393,
    "CMYK_C": 0,
    "CMYK_M": 0.21184055507183,
    "CMYK_Y": 0.31070166826248,
    "CMYK_K": 0.00133728981018
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0064",
    "Farbtonhilfsbezeichnung": "Cotta A3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "183",
    "Bcolor": "150",
    "Y": 57.3268966674805,
    "L": 80.3631057739258,
    "a": 22.2472553253174,
    "b": 26.4766578674316,
    "C": 34.5825653076172,
    "h": 49.9610328674316,
    "CMY_C": 0.00160402059555,
    "CMY_M": 0.28159135580063,
    "CMY_Y": 0.41200238466263,
    "CMYK_C": 0,
    "CMYK_M": 0.2804371714592,
    "CMYK_Y": 0.41105771064758,
    "CMYK_K": 0.00160402059555
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0065",
    "Farbtonhilfsbezeichnung": "Cotta A2",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "147",
    "Bcolor": "104",
    "Y": 41.3621292114258,
    "L": 70.4288940429688,
    "a": 33.0967025756836,
    "b": 38.133358001709,
    "C": 50.4930152893066,
    "h": 49.0446357727051,
    "CMY_C": 0.03901785612106,
    "CMY_M": 0.42245310544968,
    "CMY_Y": 0.59402030706406,
    "CMYK_C": 0,
    "CMYK_M": 0.39900350570679,
    "CMYK_Y": 0.57753670215607,
    "CMYK_K": 0.03901785612106
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0066",
    "Farbtonhilfsbezeichnung": "Cotta A1",
    "Farbtonklasse": "04",
    "Rcolor": "232",
    "Gcolor": "111",
    "Bcolor": "59",
    "Y": 28.8186073303223,
    "L": 60.621208190918,
    "a": 43.8849983215332,
    "b": 49.5252494812012,
    "C": 66.1713180541992,
    "h": 48.4554100036621,
    "CMY_C": 0.09031182527542,
    "CMY_M": 0.56490850448608,
    "CMY_Y": 0.77014809846878,
    "CMYK_C": 0,
    "CMYK_M": 0.52171361446381,
    "CMYK_Y": 0.74732893705368,
    "CMYK_K": 0.09031182527542
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0067",
    "Farbtonhilfsbezeichnung": "Menta C3",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "202",
    "Bcolor": "196",
    "Y": 57.0566062927246,
    "L": 80.21142578125,
    "a": -6.05563306808472,
    "b": 0.64622789621353,
    "C": 6.09001684188843,
    "h": 173.908721923828,
    "CMY_C": 0.26558476686478,
    "CMY_M": 0.20590204000473,
    "CMY_Y": 0.23135483264923,
    "CMYK_C": 0.07515788823366,
    "CMYK_M": 0,
    "CMYK_Y": 0.0320524610579,
    "CMYK_K": 0.20590204000473
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0068",
    "Farbtonhilfsbezeichnung": "Cotta B5",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "217",
    "Bcolor": "203",
    "Y": 73.5333709716797,
    "L": 88.7014846801758,
    "a": 8.48620700836182,
    "b": 9.86505508422852,
    "C": 13.0128793716431,
    "h": 49.2969245910645,
    "CMY_C": 0.0330758690834,
    "CMY_M": 0.14966708421707,
    "CMY_Y": 0.2048265337944,
    "CMYK_C": 0,
    "CMYK_M": 0.12057948857546,
    "CMYK_Y": 0.17762579023838,
    "CMYK_K": 0.0330758690834
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0069",
    "Farbtonhilfsbezeichnung": "Cotta B4",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "200",
    "Bcolor": "181",
    "Y": 63.2639541625977,
    "L": 83.5810623168945,
    "a": 12.1321897506714,
    "b": 14.247371673584,
    "C": 18.7130336761475,
    "h": 49.5843200683594,
    "CMY_C": 0.05483198165894,
    "CMY_M": 0.21628791093826,
    "CMY_Y": 0.29122227430344,
    "CMYK_C": 0,
    "CMYK_M": 0.17082245647907,
    "CMYK_Y": 0.25010398030281,
    "CMYK_K": 0.05483198165894
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0070",
    "Farbtonhilfsbezeichnung": "Cotta B3",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "182",
    "Bcolor": "159",
    "Y": 53.244800567627,
    "L": 78.0193099975586,
    "a": 15.4337797164917,
    "b": 17.9282703399658,
    "C": 23.6563816070557,
    "h": 49.276065826416,
    "CMY_C": 0.0881153345108,
    "CMY_M": 0.28592777252197,
    "CMY_Y": 0.37564963102341,
    "CMYK_C": 0,
    "CMYK_M": 0.21692703664303,
    "CMYK_Y": 0.31531870365143,
    "CMYK_K": 0.0881153345108
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0071",
    "Farbtonhilfsbezeichnung": "Cotta B2",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "138",
    "Bcolor": "104",
    "Y": 33.0219650268555,
    "L": 64.1786880493164,
    "a": 25.0023822784424,
    "b": 28.9071254730225,
    "C": 38.2196426391602,
    "h": 49.1427803039551,
    "CMY_C": 0.16991472244263,
    "CMY_M": 0.46030557155609,
    "CMY_Y": 0.59077477455139,
    "CMYK_C": 0,
    "CMYK_M": 0.34983256459236,
    "CMYK_Y": 0.5070081949234,
    "CMYK_K": 0.16991472244263
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0072",
    "Farbtonhilfsbezeichnung": "Cotta B1",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "109",
    "Bcolor": "71",
    "Y": 23.0588073730469,
    "L": 55.1328620910645,
    "a": 30.9385814666748,
    "b": 35.7634735107422,
    "C": 47.2887077331543,
    "h": 49.1372833251953,
    "CMY_C": 0.23450273275375,
    "CMY_M": 0.5717259645462,
    "CMY_Y": 0.72340542078018,
    "CMYK_C": 0,
    "CMYK_M": 0.4405283331871,
    "CMYK_Y": 0.63867330551147,
    "CMYK_K": 0.23450273275375
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0073",
    "Farbtonhilfsbezeichnung": "Cotta C5",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "216",
    "Bcolor": "206",
    "Y": 71.4324340820313,
    "L": 87.6946792602539,
    "a": 5.72742986679077,
    "b": 6.78842878341675,
    "C": 8.88179111480713,
    "h": 49.845516204834,
    "CMY_C": 0.07302755117416,
    "CMY_M": 0.15303921699524,
    "CMY_Y": 0.19354236125946,
    "CMYK_C": 0,
    "CMYK_M": 0.08631504327059,
    "CMYK_Y": 0.13000905513763,
    "CMYK_K": 0.07302755117416
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0074",
    "Farbtonhilfsbezeichnung": "Cotta C4",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "201",
    "Bcolor": "189",
    "Y": 61.304874420166,
    "L": 82.542366027832,
    "a": 7.01174688339233,
    "b": 8.33140754699707,
    "C": 10.8893041610718,
    "h": 49.9158973693848,
    "CMY_C": 0.11712908744812,
    "CMY_M": 0.21306401491165,
    "CMY_Y": 0.26011008024216,
    "CMYK_C": 0,
    "CMYK_M": 0.10866246372461,
    "CMYK_Y": 0.16195005178452,
    "CMYK_K": 0.11712908744812
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0075",
    "Farbtonhilfsbezeichnung": "Cotta C3",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "183",
    "Bcolor": "169",
    "Y": 50.9914093017578,
    "L": 76.6738052368164,
    "a": 8.65433216094971,
    "b": 10.2282476425171,
    "C": 13.3983030319214,
    "h": 49.7647476196289,
    "CMY_C": 0.16593235731125,
    "CMY_M": 0.28095644712448,
    "CMY_Y": 0.33561593294144,
    "CMYK_C": 0,
    "CMYK_M": 0.13790738582611,
    "CMYK_Y": 0.2034410238266,
    "CMYK_K": 0.16593235731125
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0076",
    "Farbtonhilfsbezeichnung": "Cotta C2",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "146",
    "Bcolor": "128",
    "Y": 32.6580924987793,
    "L": 63.8831062316895,
    "a": 12.8419742584229,
    "b": 14.8609266281128,
    "C": 19.6408615112305,
    "h": 49.1682739257813,
    "CMY_C": 0.26871502399445,
    "CMY_M": 0.4268639087677,
    "CMY_Y": 0.49831128120422,
    "CMYK_C": 0,
    "CMYK_M": 0.21626164019108,
    "CMYK_Y": 0.31396275758743,
    "CMYK_K": 0.26871502399445
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0077",
    "Farbtonhilfsbezeichnung": "Cotta C1",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "107",
    "Bcolor": "87",
    "Y": 17.7090072631836,
    "L": 49.1412544250488,
    "a": 14.8893308639526,
    "b": 17.6963233947754,
    "C": 23.1268692016602,
    "h": 49.9234161376953,
    "CMY_C": 0.41047263145447,
    "CMY_M": 0.58050233125687,
    "CMY_Y": 0.6595624089241,
    "CMYK_C": 0,
    "CMYK_M": 0.28841698169708,
    "CMYK_Y": 0.42252454161644,
    "CMYK_K": 0.41047263145447
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0078",
    "Farbtonhilfsbezeichnung": "Carbon G4",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "203",
    "Bcolor": "203",
    "Y": 59.4239654541016,
    "L": 81.5240783691406,
    "a": -0.82513529062271,
    "b": -1.17705607414246,
    "C": 1.43746626377106,
    "h": 234.96891784668,
    "CMY_C": 0.21608555316925,
    "CMY_M": 0.20284128189087,
    "CMY_Y": 0.20332020521164,
    "CMYK_C": 0.01661434583366,
    "CMYK_M": 0,
    "CMYK_Y": 0.0006007879274,
    "CMYK_K": 0.20284128189087
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0079",
    "Farbtonhilfsbezeichnung": "Mango A5",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "216",
    "Bcolor": "189",
    "Y": 73.8612899780273,
    "L": 88.8568801879883,
    "a": 10.4374465942383,
    "b": 17.4746932983398,
    "C": 20.3544883728027,
    "h": 59.150577545166,
    "CMY_C": 0,
    "CMY_M": 0.15489113330841,
    "CMY_Y": 0.2589858174324,
    "CMYK_C": 0,
    "CMYK_M": 0.15489113330841,
    "CMYK_Y": 0.2589858174324,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0080",
    "Farbtonhilfsbezeichnung": "Mango A4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "163",
    "Y": 66.3714370727539,
    "L": 85.1855239868164,
    "a": 14.4346761703491,
    "b": 26.0014305114746,
    "C": 29.7394390106201,
    "h": 60.9631881713867,
    "CMY_C": 0,
    "CMY_M": 0.20764964818954,
    "CMY_Y": 0.36009871959686,
    "CMYK_C": 0,
    "CMYK_M": 0.20764964818954,
    "CMYK_Y": 0.36009871959686,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0081",
    "Farbtonhilfsbezeichnung": "Mango A3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "144",
    "Y": 59.5441513061523,
    "L": 81.5897827148438,
    "a": 18.8257255554199,
    "b": 31.4972534179688,
    "C": 36.6944808959961,
    "h": 59.1334838867188,
    "CMY_C": 5.775690079e-05,
    "CMY_M": 0.25978654623032,
    "CMY_Y": 0.43701481819153,
    "CMYK_C": 0,
    "CMYK_M": 0.25974377989769,
    "CMYK_Y": 0.4369823038578,
    "CMYK_K": 5.775690079e-05
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0082",
    "Farbtonhilfsbezeichnung": "Mango A2",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "153",
    "Bcolor": "90",
    "Y": 42.1713180541992,
    "L": 70.9888763427734,
    "a": 26.838680267334,
    "b": 45.6125221252441,
    "C": 52.9227447509766,
    "h": 59.5271873474121,
    "CMY_C": 0.05946218967438,
    "CMY_M": 0.39816063642502,
    "CMY_Y": 0.64654248952866,
    "CMYK_C": 0,
    "CMYK_M": 0.36011147499084,
    "CMYK_Y": 0.62419641017914,
    "CMYK_K": 0.05946218967438
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0083",
    "Farbtonhilfsbezeichnung": "Mango A1",
    "Farbtonklasse": "04",
    "Rcolor": "229",
    "Gcolor": "128",
    "Bcolor": "51",
    "Y": 32.3115386962891,
    "L": 63.5995330810547,
    "a": 33.9682731628418,
    "b": 55.7143020629883,
    "C": 65.2527923583984,
    "h": 58.6298942565918,
    "CMY_C": 0.10130250453949,
    "CMY_M": 0.49883621931076,
    "CMY_Y": 0.79855072498322,
    "CMYK_C": 0,
    "CMYK_M": 0.44234430789948,
    "CMYK_Y": 0.77584308385849,
    "CMYK_K": 0.10130250453949
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0084",
    "Farbtonhilfsbezeichnung": "Mango B5",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "219",
    "Bcolor": "199",
    "Y": 75.1376647949219,
    "L": 89.4574356079102,
    "a": 7.41994953155518,
    "b": 12.7505941390991,
    "C": 14.7523994445801,
    "h": 59.8036079406738,
    "CMY_C": 0.02447015047073,
    "CMY_M": 0.13936686515808,
    "CMY_Y": 0.21811360120773,
    "CMYK_C": 0,
    "CMYK_M": 0.11777877807617,
    "CMYK_Y": 0.19850079715252,
    "CMYK_K": 0.02447015047073
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0085",
    "Farbtonhilfsbezeichnung": "Mango B4",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "204",
    "Bcolor": "178",
    "Y": 65.6135177612305,
    "L": 84.7988891601563,
    "a": 10.5877447128296,
    "b": 17.5218372344971,
    "C": 20.4723014831543,
    "h": 58.8571128845215,
    "CMY_C": 0.0438574552536,
    "CMY_M": 0.19981986284256,
    "CMY_Y": 0.30250734090805,
    "CMYK_C": 0,
    "CMYK_M": 0.16311627626419,
    "CMYK_Y": 0.27051395177841,
    "CMYK_K": 0.0438574552536
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0086",
    "Farbtonhilfsbezeichnung": "Mango B3",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "186",
    "Bcolor": "152",
    "Y": 54.9859580993652,
    "L": 79.0331802368164,
    "a": 13.4337158203125,
    "b": 23.2871799468994,
    "C": 26.8841495513916,
    "h": 60.0205688476563,
    "CMY_C": 0.07873052358627,
    "CMY_M": 0.2709823846817,
    "CMY_Y": 0.40428870916367,
    "CMYK_C": 0,
    "CMYK_M": 0.20868146419525,
    "CMYK_Y": 0.35337996482849,
    "CMYK_K": 0.07873052358627
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0087",
    "Farbtonhilfsbezeichnung": "Mango B2",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "145",
    "Bcolor": "95",
    "Y": 35.6308975219727,
    "L": 66.236930847168,
    "a": 22.1574382781982,
    "b": 36.6244506835938,
    "C": 42.8054008483887,
    "h": 58.8264656066895,
    "CMY_C": 0.15242224931717,
    "CMY_M": 0.43221801519394,
    "CMY_Y": 0.62692475318909,
    "CMYK_C": 0,
    "CMYK_M": 0.33011221885681,
    "CMYK_Y": 0.55983358621597,
    "CMYK_K": 0.15242224931717
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0088",
    "Farbtonhilfsbezeichnung": "Mango B1",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "117",
    "Bcolor": "60",
    "Y": 25.0640773773193,
    "L": 57.1378059387207,
    "a": 27.2057647705078,
    "b": 43.7402153015137,
    "C": 51.5107765197754,
    "h": 58.1190032958984,
    "CMY_C": 0.22365480661392,
    "CMY_M": 0.5409032702446,
    "CMY_Y": 0.76509821414948,
    "CMYK_C": 0,
    "CMYK_M": 0.40864357352257,
    "CMYK_Y": 0.69742608070374,
    "CMYK_K": 0.22365480661392
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0089",
    "Farbtonhilfsbezeichnung": "Mango C5",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "220",
    "Bcolor": "206",
    "Y": 74.2360382080078,
    "L": 89.0339202880859,
    "a": 4.85193157196045,
    "b": 8.30610370635986,
    "C": 9.61938667297363,
    "h": 59.7090682983398,
    "CMY_C": 0.06003165245056,
    "CMY_M": 0.13649117946625,
    "CMY_Y": 0.19029951095581,
    "CMYK_C": 0,
    "CMYK_M": 0.08134265989065,
    "CMYK_Y": 0.13858748972416,
    "CMYK_K": 0.06003165245056
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0090",
    "Farbtonhilfsbezeichnung": "Mango C4",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "205",
    "Bcolor": "185",
    "Y": 64.8452758789063,
    "L": 84.4039459228516,
    "a": 7.53612518310547,
    "b": 12.7837724685669,
    "C": 14.8397445678711,
    "h": 59.4803466796875,
    "CMY_C": 0.08085596561432,
    "CMY_M": 0.19522047042847,
    "CMY_Y": 0.27256572246552,
    "CMYK_C": 0,
    "CMYK_M": 0.12442500889301,
    "CMYK_Y": 0.20857422053814,
    "CMYK_K": 0.08085596561432
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0091",
    "Farbtonhilfsbezeichnung": "Mango C3",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "187",
    "Bcolor": "165",
    "Y": 53.814094543457,
    "L": 78.3532104492188,
    "a": 9.09505081176758,
    "b": 15.3023452758789,
    "C": 17.8011722564697,
    "h": 59.2745895385742,
    "CMY_C": 0.13201731443405,
    "CMY_M": 0.26530140638351,
    "CMY_Y": 0.35438919067383,
    "CMYK_C": 0,
    "CMYK_M": 0.15355616807938,
    "CMYK_Y": 0.2561939060688,
    "CMYK_K": 0.13201731443405
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0092",
    "Farbtonhilfsbezeichnung": "Mango C2",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "147",
    "Bcolor": "120",
    "Y": 32.6711387634277,
    "L": 63.893741607666,
    "a": 11.8860006332398,
    "b": 19.3444633483887,
    "C": 22.7042999267578,
    "h": 58.4317970275879,
    "CMY_C": 0.26587015390396,
    "CMY_M": 0.42531073093414,
    "CMY_Y": 0.52944493293762,
    "CMYK_C": 0,
    "CMYK_M": 0.21718306839466,
    "CMYK_Y": 0.35903018712997,
    "CMYK_K": 0.26587015390396
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0093",
    "Farbtonhilfsbezeichnung": "Mango C1",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "113",
    "Bcolor": "82",
    "Y": 19.9988403320313,
    "L": 51.8358993530273,
    "a": 14.7649383544922,
    "b": 24.093957901001,
    "C": 28.2581348419189,
    "h": 58.499755859375,
    "CMY_C": 0.37270814180374,
    "CMY_M": 0.55499410629272,
    "CMY_Y": 0.67729902267456,
    "CMYK_C": 0,
    "CMYK_M": 0.29059195518494,
    "CMYK_Y": 0.48556485772133,
    "CMYK_K": 0.37270814180374
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0094",
    "Farbtonhilfsbezeichnung": "Kiwi C4",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "214",
    "Bcolor": "196",
    "Y": 65.3119659423828,
    "L": 84.6442337036133,
    "a": -4.8811731338501,
    "b": 7.43369722366333,
    "C": 8.8930139541626,
    "h": 123.290023803711,
    "CMY_C": 0.18515026569366,
    "CMY_M": 0.16176170110703,
    "CMY_Y": 0.23281627893448,
    "CMYK_C": 0.02790204808116,
    "CMYK_M": 0,
    "CMYK_Y": 0.08476655930281,
    "CMYK_K": 0.16176170110703
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0095",
    "Farbtonhilfsbezeichnung": "Melba A1",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "163",
    "Bcolor": "57",
    "Y": 46.1802291870117,
    "L": 73.6623306274414,
    "a": 23.0087223052979,
    "b": 63.6213340759277,
    "C": 67.6540832519531,
    "h": 70.1174240112305,
    "CMY_C": 0.03259998559952,
    "CMY_M": 0.36110329627991,
    "CMY_Y": 0.77473795413971,
    "CMYK_C": 0,
    "CMYK_M": 0.33957341313362,
    "CMYK_Y": 0.76714694499969,
    "CMYK_K": 0.03259998559952
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0096",
    "Farbtonhilfsbezeichnung": "Melba A2",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "183",
    "Bcolor": "106",
    "Y": 56.1521606445313,
    "L": 79.7003402709961,
    "a": 18.1018009185791,
    "b": 48.4829292297363,
    "C": 51.7520027160645,
    "h": 69.5261535644531,
    "CMY_C": 0.00285357236862,
    "CMY_M": 0.28111845254898,
    "CMY_Y": 0.58523261547089,
    "CMYK_C": 0,
    "CMYK_M": 0.27906119823456,
    "CMYK_Y": 0.58404564857483,
    "CMYK_K": 0.00285357236862
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0097",
    "Farbtonhilfsbezeichnung": "Melba A3",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "200",
    "Bcolor": "140",
    "Y": 64.4154281616211,
    "L": 84.1815948486328,
    "a": 12.9775857925415,
    "b": 36.8081321716309,
    "C": 39.0289154052734,
    "h": 70.5786819458008,
    "CMY_C": 0,
    "CMY_M": 0.21690112352371,
    "CMY_Y": 0.4514496922493,
    "CMYK_C": 0,
    "CMYK_M": 0.21690112352371,
    "CMYK_Y": 0.4514496922493,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0098",
    "Farbtonhilfsbezeichnung": "Melba A4",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "161",
    "Y": 69.8949584960938,
    "L": 86.9453201293945,
    "a": 10.2830104827881,
    "b": 29.7344055175781,
    "C": 31.4622821807861,
    "h": 70.9231491088867,
    "CMY_C": 0,
    "CMY_M": 0.17828243970871,
    "CMY_Y": 0.3703128695488,
    "CMYK_C": 0,
    "CMYK_M": 0.17828243970871,
    "CMYK_Y": 0.3703128695488,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0099",
    "Farbtonhilfsbezeichnung": "Melba A5",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "188",
    "Y": 76.6996078491211,
    "L": 90.1831741333008,
    "a": 7.02862930297852,
    "b": 19.9727840423584,
    "C": 21.1734199523926,
    "h": 70.6125030517578,
    "CMY_C": 0.00105553865433,
    "CMY_M": 0.13212031126022,
    "CMY_Y": 0.2639347910881,
    "CMYK_C": 0,
    "CMYK_M": 0.13120326399803,
    "CMYK_Y": 0.26315701007843,
    "CMYK_K": 0.00105553865433
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0100",
    "Farbtonhilfsbezeichnung": "Melba B5",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "217",
    "Bcolor": "191",
    "Y": 72.0223770141602,
    "L": 87.979362487793,
    "a": 5.29270219802856,
    "b": 14.8881902694702,
    "C": 15.8009777069092,
    "h": 70.4298706054688,
    "CMY_C": 0.05096161365509,
    "CMY_M": 0.15091586112976,
    "CMY_Y": 0.2501620054245,
    "CMYK_C": 0,
    "CMYK_M": 0.10532160848379,
    "CMYK_Y": 0.20989708602428,
    "CMYK_K": 0.05096161365509
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0101",
    "Farbtonhilfsbezeichnung": "Melba B4",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "205",
    "Bcolor": "172",
    "Y": 64.7989501953125,
    "L": 84.3800277709961,
    "a": 7.31129503250122,
    "b": 20.0316925048828,
    "C": 21.3242530822754,
    "h": 69.9486083984375,
    "CMY_C": 0.06533318758011,
    "CMY_M": 0.19666063785553,
    "CMY_Y": 0.32592964172363,
    "CMYK_C": 0,
    "CMYK_M": 0.14050723612309,
    "CMYK_Y": 0.27881214022636,
    "CMYK_K": 0.06533318758011
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0102",
    "Farbtonhilfsbezeichnung": "Melba B3",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "188",
    "Bcolor": "146",
    "Y": 55.1815872192383,
    "L": 79.1457443237305,
    "a": 9.69335842132568,
    "b": 26.5364208221436,
    "C": 28.2514209747314,
    "h": 69.9335098266602,
    "CMY_C": 0.09548783302307,
    "CMY_M": 0.26079767942429,
    "CMY_Y": 0.42756843566895,
    "CMYK_C": 0,
    "CMYK_M": 0.18276132643223,
    "CMYK_Y": 0.36713778972626,
    "CMYK_K": 0.09548783302307
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0103",
    "Farbtonhilfsbezeichnung": "Melba B2",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "167",
    "Bcolor": "113",
    "Y": 43.5400772094727,
    "L": 71.9200057983398,
    "a": 12.7661609649658,
    "b": 34.5311050415039,
    "C": 36.8153800964355,
    "h": 69.7106323242188,
    "CMY_C": 0.14516228437424,
    "CMY_M": 0.34704893827438,
    "CMY_Y": 0.55833232402802,
    "CMYK_C": 0,
    "CMYK_M": 0.23616956174374,
    "CMYK_Y": 0.48333156108856,
    "CMYK_K": 0.14516228437424
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0104",
    "Farbtonhilfsbezeichnung": "Melba B1",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "138",
    "Bcolor": "65",
    "Y": 30.9873218536377,
    "L": 62.4969367980957,
    "a": 17.265869140625,
    "b": 47.1783256530762,
    "C": 50.2384796142578,
    "h": 69.8988723754883,
    "CMY_C": 0.21228021383286,
    "CMY_M": 0.45840692520142,
    "CMY_Y": 0.74492001533508,
    "CMYK_C": 0,
    "CMYK_M": 0.31245464086533,
    "CMYK_Y": 0.67617928981781,
    "CMYK_K": 0.21228021383286
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0105",
    "Farbtonhilfsbezeichnung": "Melba C5",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "216",
    "Bcolor": "197",
    "Y": 70.7089614868164,
    "L": 87.3434143066406,
    "a": 3.93269634246826,
    "b": 10.7751226425171,
    "C": 11.4703693389893,
    "h": 69.9489669799805,
    "CMY_C": 0.07887399196625,
    "CMY_M": 0.15355354547501,
    "CMY_Y": 0.22691977024078,
    "CMYK_C": 0,
    "CMYK_M": 0.08107420057058,
    "CMYK_Y": 0.16072261333466,
    "CMYK_K": 0.07887399196625
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0106",
    "Farbtonhilfsbezeichnung": "Melba C4",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "201",
    "Bcolor": "179",
    "Y": 60.7083854675293,
    "L": 82.2217254638672,
    "a": 5.09372711181641,
    "b": 12.7856369018555,
    "C": 13.7629413604736,
    "h": 68.2779388427734,
    "CMY_C": 0.12255680561066,
    "CMY_M": 0.21297025680542,
    "CMY_Y": 0.29616802930832,
    "CMYK_C": 0,
    "CMYK_M": 0.10304193943739,
    "CMYK_Y": 0.19786036014557,
    "CMYK_K": 0.12255680561066
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0107",
    "Farbtonhilfsbezeichnung": "Melba C3",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "184",
    "Bcolor": "156",
    "Y": 50.7329635620117,
    "L": 76.5169677734375,
    "a": 6.23040342330933,
    "b": 17.3712940216064,
    "C": 18.4548034667969,
    "h": 70.2690734863281,
    "CMY_C": 0.1671427488327,
    "CMY_M": 0.27837550640106,
    "CMY_Y": 0.38884305953979,
    "CMYK_C": 0,
    "CMYK_M": 0.13355560600758,
    "CMYK_Y": 0.26619243621826,
    "CMYK_K": 0.1671427488327
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0108",
    "Farbtonhilfsbezeichnung": "Melba C2",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "149",
    "Bcolor": "115",
    "Y": 32.7228546142578,
    "L": 63.9358749389648,
    "a": 8.26894664764404,
    "b": 22.0263633728027,
    "C": 23.5273494720459,
    "h": 69.4232940673828,
    "CMY_C": 0.28293204307556,
    "CMY_M": 0.41644161939621,
    "CMY_Y": 0.5484294295311,
    "CMYK_C": 0,
    "CMYK_M": 0.1861881762743,
    "CMYK_Y": 0.37025415897369,
    "CMYK_K": 0.28293204307556
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0109",
    "Farbtonhilfsbezeichnung": "Melba C1",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "115",
    "Bcolor": "72",
    "Y": 19.6011810302734,
    "L": 51.3832740783691,
    "a": 10.8560466766357,
    "b": 29.0912094116211,
    "C": 31.0508003234863,
    "h": 69.5357894897461,
    "CMY_C": 0.39294701814651,
    "CMY_M": 0.55037593841553,
    "CMY_Y": 0.71676814556122,
    "CMYK_C": 0,
    "CMYK_M": 0.25933307409286,
    "CMYK_Y": 0.53343141078949,
    "CMYK_K": 0.39294701814651
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0111",
    "Farbtonhilfsbezeichnung": "Safro A5",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "224",
    "Bcolor": "189",
    "Y": 77.6142272949219,
    "L": 90.6035766601562,
    "a": 4.56695508956909,
    "b": 19.6570816040039,
    "C": 20.1806335449219,
    "h": 76.9204330444336,
    "CMY_C": 0.01436972618103,
    "CMY_M": 0.12123113870621,
    "CMY_Y": 0.25752139091492,
    "CMYK_C": 0,
    "CMYK_M": 0.1084193661809,
    "CMYK_Y": 0.24669662117958,
    "CMYK_K": 0.01436972618103
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0112",
    "Farbtonhilfsbezeichnung": "Safro A4",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "215",
    "Bcolor": "165",
    "Y": 71.8478469848633,
    "L": 87.8953018188477,
    "a": 6.32169198989868,
    "b": 28.4311256408691,
    "C": 29.1254653930664,
    "h": 77.4641571044922,
    "CMY_C": 0.01376456022263,
    "CMY_M": 0.15748465061188,
    "CMY_Y": 0.35142683982849,
    "CMYK_C": 0,
    "CMYK_M": 0.14572595059872,
    "CMYK_Y": 0.34237492084503,
    "CMYK_K": 0.01376456022263
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0113",
    "Farbtonhilfsbezeichnung": "Safro A3",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "204",
    "Bcolor": "129",
    "Y": 66.0865325927734,
    "L": 85.0405349731445,
    "a": 9.09257507324219,
    "b": 43.5111274719238,
    "C": 44.4510192871094,
    "h": 78.1966857910156,
    "CMY_C": 0.00214236974716,
    "CMY_M": 0.19861978292465,
    "CMY_Y": 0.49485814571381,
    "CMYK_C": 0,
    "CMYK_M": 0.19689925014973,
    "CMYK_Y": 0.4937736093998,
    "CMYK_K": 0.00214236974716
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0114",
    "Farbtonhilfsbezeichnung": "Safro A2",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "97",
    "Y": 60.7639770507813,
    "L": 82.2516937255859,
    "a": 12.3822250366211,
    "b": 55.462085723877,
    "C": 56.8274803161621,
    "h": 77.4147796630859,
    "CMY_C": 0,
    "CMY_M": 0.23923718929291,
    "CMY_Y": 0.61780536174774,
    "CMYK_C": 0,
    "CMYK_M": 0.23923718929291,
    "CMYK_Y": 0.61780536174774,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0115",
    "Farbtonhilfsbezeichnung": "Safro A1",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "181",
    "Bcolor": "51",
    "Y": 54.1522369384766,
    "L": 78.550422668457,
    "a": 15.9650688171387,
    "b": 70.8544692993164,
    "C": 72.6308441162109,
    "h": 77.3020629882813,
    "CMY_C": 0.0078182220459,
    "CMY_M": 0.29031205177307,
    "CMY_Y": 0.80159521102905,
    "CMYK_C": 0,
    "CMYK_M": 0.28471982479095,
    "CMYK_Y": 0.80003184080124,
    "CMYK_K": 0.0078182220459
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0116",
    "Farbtonhilfsbezeichnung": "Safro B5",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "223",
    "Bcolor": "192",
    "Y": 76.2442932128906,
    "L": 89.9726486206055,
    "a": 3.92130637168884,
    "b": 17.2079906463623,
    "C": 17.6491241455078,
    "h": 77.1628112792969,
    "CMY_C": 0.03224557638168,
    "CMY_M": 0.12605559825897,
    "CMY_Y": 0.24617946147919,
    "CMYK_C": 0,
    "CMYK_M": 0.0969357714057,
    "CMYK_Y": 0.22106216847897,
    "CMYK_K": 0.03224557638168
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0117",
    "Farbtonhilfsbezeichnung": "Safro B4",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "212",
    "Bcolor": "172",
    "Y": 69.2695770263672,
    "L": 86.6373672485352,
    "a": 5.39036703109741,
    "b": 23.3234252929688,
    "C": 23.9382171630859,
    "h": 76.9866333007813,
    "CMY_C": 0.04546630382538,
    "CMY_M": 0.1678985953331,
    "CMY_Y": 0.32679122686386,
    "CMYK_C": 0,
    "CMYK_M": 0.12826398015022,
    "CMYK_Y": 0.29472497105598,
    "CMYK_K": 0.04546630382538
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0118",
    "Farbtonhilfsbezeichnung": "Safro B3",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "198",
    "Bcolor": "145",
    "Y": 60.5341835021973,
    "L": 82.127685546875,
    "a": 7.06240558624268,
    "b": 31.3926486968994,
    "C": 32.1772575378418,
    "h": 77.3212509155273,
    "CMY_C": 0.06950581073761,
    "CMY_M": 0.22294813394547,
    "CMY_Y": 0.43332213163376,
    "CMYK_C": 0,
    "CMYK_M": 0.16490411758423,
    "CMYK_Y": 0.39099258184433,
    "CMYK_K": 0.06950581073761
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0119",
    "Farbtonhilfsbezeichnung": "Safro B2",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "177",
    "Bcolor": "103",
    "Y": 48.9289398193359,
    "L": 75.407096862793,
    "a": 10.4320974349976,
    "b": 43.9495964050293,
    "C": 45.1707382202148,
    "h": 76.647102355957,
    "CMY_C": 0.10598886013031,
    "CMY_M": 0.30574476718903,
    "CMY_Y": 0.595219373703,
    "CMYK_C": 0,
    "CMYK_M": 0.22343783080578,
    "CMYK_Y": 0.54723089933395,
    "CMYK_K": 0.10598886013031
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0120",
    "Farbtonhilfsbezeichnung": "Safro B1",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "160",
    "Bcolor": "65",
    "Y": 40.4581909179688,
    "L": 69.7946395874023,
    "a": 12.2603464126587,
    "b": 55.3640518188477,
    "C": 56.7053298950195,
    "h": 77.5133819580078,
    "CMY_C": 0.14792627096176,
    "CMY_M": 0.37098753452301,
    "CMY_Y": 0.74367141723633,
    "CMYK_C": 0,
    "CMYK_M": 0.26178634166718,
    "CMYK_Y": 0.69917088747025,
    "CMYK_K": 0.14792627096176
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0121",
    "Farbtonhilfsbezeichnung": "Aqua C2",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "156",
    "Bcolor": "167",
    "Y": 30.9786205291748,
    "L": 62.4895820617676,
    "a": -8.50991535186768,
    "b": -9.94647693634033,
    "C": 13.0901136398315,
    "h": 229.450668334961,
    "CMY_C": 0.51487863063812,
    "CMY_M": 0.38650542497635,
    "CMY_Y": 0.34494513273239,
    "CMYK_C": 0.25941872596741,
    "CMYK_M": 0.06344551593065,
    "CMYK_Y": 0,
    "CMYK_K": 0.34494513273239
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0122",
    "Farbtonhilfsbezeichnung": "Safro C5",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "219",
    "Bcolor": "197",
    "Y": 72.9435653686523,
    "L": 88.4207916259766,
    "a": 2.8128764629364,
    "b": 12.2113409042358,
    "C": 12.5311260223389,
    "h": 77.0282135009766,
    "CMY_C": 0.07099652290344,
    "CMY_M": 0.13930195569992,
    "CMY_Y": 0.22606575489044,
    "CMYK_C": 0,
    "CMYK_M": 0.07352548837662,
    "CMYK_Y": 0.16691997647285,
    "CMYK_K": 0.07099652290344
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0123",
    "Farbtonhilfsbezeichnung": "Safro C4",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "206",
    "Bcolor": "179",
    "Y": 63.9195365905762,
    "L": 83.9238586425781,
    "a": 3.50987315177917,
    "b": 15.3134698867798,
    "C": 15.7105560302734,
    "h": 77.0906829833984,
    "CMY_C": 0.10830819606781,
    "CMY_M": 0.19118320941925,
    "CMY_Y": 0.29682463407516,
    "CMYK_C": 0,
    "CMYK_M": 0.09294132143259,
    "CMYK_Y": 0.2114143371582,
    "CMYK_K": 0.10830819606781
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0124",
    "Farbtonhilfsbezeichnung": "Safro C3",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "192",
    "Bcolor": "159",
    "Y": 55.0820121765137,
    "L": 79.0884857177734,
    "a": 4.17227029800415,
    "b": 19.5406379699707,
    "C": 19.9811000823975,
    "h": 77.9473266601563,
    "CMY_C": 0.1476069688797,
    "CMY_M": 0.24624907970428,
    "CMY_Y": 0.37823790311813,
    "CMYK_C": 0,
    "CMYK_M": 0.11572374403477,
    "CMYK_Y": 0.27056875824928,
    "CMYK_K": 0.1476069688797
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0125",
    "Farbtonhilfsbezeichnung": "Safro C2",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "161",
    "Bcolor": "114",
    "Y": 38.0517120361328,
    "L": 68.058708190918,
    "a": 6.33138561248779,
    "b": 28.2145442962646,
    "C": 28.9162063598633,
    "h": 77.3522644042969,
    "CMY_C": 0.23874586820602,
    "CMY_M": 0.37021434307098,
    "CMY_Y": 0.55209392309189,
    "CMYK_C": 0,
    "CMYK_M": 0.17269985377789,
    "CMYK_Y": 0.4116208255291,
    "CMYK_K": 0.23874586820602
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0126",
    "Farbtonhilfsbezeichnung": "Safro C1",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "135",
    "Bcolor": "80",
    "Y": 26.959415435791,
    "L": 58.9367446899414,
    "a": 8.02269840240479,
    "b": 34.588623046875,
    "C": 35.5068511962891,
    "h": 76.9413757324219,
    "CMY_C": 0.31964558362961,
    "CMY_M": 0.46901613473892,
    "CMY_Y": 0.68592649698257,
    "CMYK_C": 0,
    "CMYK_M": 0.21954815089703,
    "CMYK_Y": 0.53836780786514,
    "CMYK_K": 0.31964558362961
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0127",
    "Farbtonhilfsbezeichnung": "Mare A5",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "222",
    "Bcolor": "231",
    "Y": 70.7240905761719,
    "L": 87.3507843017578,
    "a": -4.08944797515869,
    "b": -7.35523366928101,
    "C": 8.41564273834229,
    "h": 240.926300048828,
    "CMY_C": 0.20268267393112,
    "CMY_M": 0.12952810525894,
    "CMY_Y": 0.09482228755951,
    "CMYK_C": 0.11915934830904,
    "CMYK_M": 0.03834144026041,
    "CMYK_Y": 0,
    "CMYK_K": 0.09482228755951
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0128",
    "Farbtonhilfsbezeichnung": "Canari A5",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "226",
    "Bcolor": "184",
    "Y": 78.7717437744141,
    "L": 91.1309127807617,
    "a": 3.27905130386353,
    "b": 23.0469799041748,
    "C": 23.2790775299072,
    "h": 81.9024887084961,
    "CMY_C": 0.00941598415375,
    "CMY_M": 0.1129766702652,
    "CMY_Y": 0.27744042873383,
    "CMYK_C": 0,
    "CMYK_M": 0.10454507917166,
    "CMYK_Y": 0.27057215571404,
    "CMYK_K": 0.00941598415375
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0129",
    "Farbtonhilfsbezeichnung": "Canari A4",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "218",
    "Bcolor": "159",
    "Y": 73.5150680541992,
    "L": 88.6927871704102,
    "a": 4.24206018447876,
    "b": 32.7281532287598,
    "C": 33.0019264221191,
    "h": 82.6147766113281,
    "CMY_C": 0.01012831926346,
    "CMY_M": 0.14439213275909,
    "CMY_Y": 0.37583261728287,
    "CMYK_C": 0,
    "CMYK_M": 0.13563759624958,
    "CMYK_Y": 0.36944615840912,
    "CMYK_K": 0.01012831926346
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0130",
    "Farbtonhilfsbezeichnung": "Canari A3",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "208",
    "Bcolor": "133",
    "Y": 67.4041519165039,
    "L": 85.707633972168,
    "a": 5.63431835174561,
    "b": 42.1774253845215,
    "C": 42.5520935058594,
    "h": 82.3911209106445,
    "CMY_C": 0.0188205242157,
    "CMY_M": 0.18236863613129,
    "CMY_Y": 0.47859734296799,
    "CMYK_C": 0,
    "CMYK_M": 0.16668520867825,
    "CMYK_Y": 0.46859604120255,
    "CMYK_K": 0.0188205242157
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0131",
    "Farbtonhilfsbezeichnung": "Canari A2",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "197",
    "Bcolor": "82",
    "Y": 61.0602378845215,
    "L": 82.4111175537109,
    "a": 8.43232440948486,
    "b": 62.5857124328613,
    "C": 63.1512107849121,
    "h": 82.3266143798828,
    "CMY_C": 0.01356762647629,
    "CMY_M": 0.22817397117615,
    "CMY_Y": 0.67958414554596,
    "CMYK_C": 0,
    "CMYK_M": 0.21755808591843,
    "CMYK_Y": 0.67517709732056,
    "CMYK_K": 0.01356762647629
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0132",
    "Farbtonhilfsbezeichnung": "Canari A1",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "187",
    "Bcolor": "43",
    "Y": 55.8993148803711,
    "L": 79.5564804077148,
    "a": 10.2964782714844,
    "b": 73.7575836181641,
    "C": 74.4728012084961,
    "h": 82.0529251098633,
    "CMY_C": 0.02691853046417,
    "CMY_M": 0.26479578018188,
    "CMY_Y": 0.82976830005646,
    "CMYK_C": 0,
    "CMYK_M": 0.24445769190788,
    "CMYK_Y": 0.82505917549133,
    "CMYK_K": 0.02691853046417
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0133",
    "Farbtonhilfsbezeichnung": "Pino C4",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "213",
    "Bcolor": "191",
    "Y": 65.55078125,
    "L": 84.7667541503906,
    "a": -3.18579006195068,
    "b": 10.1428890228272,
    "C": 10.6314373016357,
    "h": 107.437034606934,
    "CMY_C": 0.16237670183182,
    "CMY_M": 0.16494369506836,
    "CMY_Y": 0.25107026100159,
    "CMYK_C": 0,
    "CMYK_M": 0.00306461541913,
    "CMYK_Y": 0.10588716715574,
    "CMYK_K": 0.16237670183182
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0134",
    "Farbtonhilfsbezeichnung": "Canari B5",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "222",
    "Bcolor": "189",
    "Y": 74.9114227294922,
    "L": 89.3514862060547,
    "a": 1.98471975326538,
    "b": 17.7907772064209,
    "C": 17.9011421203613,
    "h": 83.6344680786133,
    "CMY_C": 0.0517909526825,
    "CMY_M": 0.12835824489594,
    "CMY_Y": 0.25750356912613,
    "CMYK_C": 0,
    "CMYK_M": 0.0807493776083,
    "CMYK_Y": 0.21694858372211,
    "CMYK_K": 0.0517909526825
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0135",
    "Farbtonhilfsbezeichnung": "Canari B4",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "213",
    "Bcolor": "170",
    "Y": 68.9676895141602,
    "L": 86.4880447387695,
    "a": 2.65099239349365,
    "b": 23.7330570220947,
    "C": 23.8806571960449,
    "h": 83.6264572143555,
    "CMY_C": 0.06530922651291,
    "CMY_M": 0.16292101144791,
    "CMY_Y": 0.33191728591919,
    "CMYK_C": 0,
    "CMYK_M": 0.10443216562271,
    "CMYK_Y": 0.2852366566658,
    "CMYK_K": 0.06530922651291
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0136",
    "Farbtonhilfsbezeichnung": "Canari B3",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "200",
    "Bcolor": "146",
    "Y": 60.6491203308105,
    "L": 82.1897506713867,
    "a": 4.54918622970581,
    "b": 30.6628227233887,
    "C": 30.9984474182129,
    "h": 81.5610656738281,
    "CMY_C": 0.08685606718063,
    "CMY_M": 0.21592247486115,
    "CMY_Y": 0.42778843641281,
    "CMYK_C": 0,
    "CMYK_M": 0.14134289324284,
    "CMYK_Y": 0.37336105108261,
    "CMYK_K": 0.08685606718063
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0137",
    "Farbtonhilfsbezeichnung": "Canari B2",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "179",
    "Bcolor": "101",
    "Y": 48.5433578491211,
    "L": 75.1663589477539,
    "a": 5.74082803726196,
    "b": 44.4417991638184,
    "C": 44.8110542297363,
    "h": 82.6395034790039,
    "CMY_C": 0.13722425699234,
    "CMY_M": 0.29663753509521,
    "CMY_Y": 0.60279965400696,
    "CMYK_C": 0,
    "CMYK_M": 0.18476791679859,
    "CMYK_Y": 0.53962504863739,
    "CMYK_K": 0.13722425699234
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0138",
    "Farbtonhilfsbezeichnung": "Canari B1",
    "Farbtonklasse": "04",
    "Rcolor": "209",
    "Gcolor": "162",
    "Bcolor": "65",
    "Y": 39.9735946655273,
    "L": 69.4507217407227,
    "a": 7.79120063781738,
    "b": 55.0257148742676,
    "C": 55.5745620727539,
    "h": 81.9409484863281,
    "CMY_C": 0.17862129211426,
    "CMY_M": 0.36320382356644,
    "CMY_Y": 0.74616271257401,
    "CMYK_C": 0,
    "CMYK_M": 0.22472281754017,
    "CMYK_Y": 0.69096195697784,
    "CMYK_K": 0.17862129211426
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0139",
    "Farbtonhilfsbezeichnung": "Indigo A2",
    "Farbtonklasse": "04",
    "Rcolor": "122",
    "Gcolor": "156",
    "Bcolor": "197",
    "Y": 31.8485679626465,
    "L": 63.2175254821777,
    "a": -0.74141138792038,
    "b": -25.9534149169922,
    "C": 25.9640026092529,
    "h": 268.363677978516,
    "CMY_C": 0.52063632011414,
    "CMY_M": 0.38974291086197,
    "CMY_Y": 0.22612065076828,
    "CMYK_C": 0.38057053089142,
    "CMYK_M": 0.21143122017384,
    "CMYK_Y": 0,
    "CMYK_K": 0.22612065076828
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0140",
    "Farbtonhilfsbezeichnung": "Canari C5",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "221",
    "Bcolor": "201",
    "Y": 73.5050735473633,
    "L": 88.6880493164063,
    "a": 1.61561679840088,
    "b": 10.825777053833,
    "C": 10.9456691741943,
    "h": 81.5119400024414,
    "CMY_C": 0.08069032430649,
    "CMY_M": 0.13310569524765,
    "CMY_Y": 0.21314215660095,
    "CMYK_C": 0,
    "CMYK_M": 0.05701601132751,
    "CMYK_Y": 0.14407749474049,
    "CMYK_K": 0.08069032430649
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0141",
    "Farbtonhilfsbezeichnung": "Canari C4",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "205",
    "Bcolor": "178",
    "Y": 62.4507827758789,
    "L": 83.1525650024414,
    "a": 1.85498917102814,
    "b": 14.8024349212647,
    "C": 14.918212890625,
    "h": 82.8571243286133,
    "CMY_C": 0.13005757331848,
    "CMY_M": 0.19551593065262,
    "CMY_Y": 0.30153352022171,
    "CMYK_C": 0,
    "CMYK_M": 0.07524447143078,
    "CMYK_Y": 0.19711183011532,
    "CMYK_K": 0.13005757331848
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0142",
    "Farbtonhilfsbezeichnung": "Canari C3",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "189",
    "Bcolor": "156",
    "Y": 52.7383689880371,
    "L": 77.7202758789063,
    "a": 2.77000331878662,
    "b": 18.9979419708252,
    "C": 19.1988201141357,
    "h": 81.7044143676758,
    "CMY_C": 0.17371326684952,
    "CMY_M": 0.25750744342804,
    "CMY_Y": 0.38873314857483,
    "CMYK_C": 0,
    "CMYK_M": 0.10141053050756,
    "CMYK_Y": 0.26022428274155,
    "CMYK_K": 0.17371326684952
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0143",
    "Farbtonhilfsbezeichnung": "Canari C2",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "161",
    "Bcolor": "116",
    "Y": 37.139347076416,
    "L": 67.3814468383789,
    "a": 3.4607264995575,
    "b": 26.2951774597168,
    "C": 26.5219345092773,
    "h": 82.5023498535156,
    "CMY_C": 0.26790219545364,
    "CMY_M": 0.37010550498962,
    "CMY_Y": 0.54562509059906,
    "CMYK_C": 0,
    "CMYK_M": 0.13960336148739,
    "CMYK_Y": 0.37935218214989,
    "CMYK_K": 0.26790219545364
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0144",
    "Farbtonhilfsbezeichnung": "Canari C1",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "138",
    "Bcolor": "82",
    "Y": 27.1828918457031,
    "L": 59.143238067627,
    "a": 4.39321184158325,
    "b": 33.6250114440918,
    "C": 33.9107894897461,
    "h": 82.5562896728516,
    "CMY_C": 0.3402988910675,
    "CMY_M": 0.45818716287613,
    "CMY_Y": 0.67789834737778,
    "CMYK_C": 0,
    "CMYK_M": 0.17869952321053,
    "CMYK_Y": 0.51174610853195,
    "CMYK_K": 0.3402988910675
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0145",
    "Farbtonhilfsbezeichnung": "Melon A5",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "228",
    "Bcolor": "185",
    "Y": 79.6438903808594,
    "L": 91.5248413085938,
    "a": 2.36402893066406,
    "b": 23.4281787872314,
    "C": 23.5471477508545,
    "h": 84.2380447387695,
    "CMY_C": 0.01051419973373,
    "CMY_M": 0.10644042491913,
    "CMY_Y": 0.27625960111618,
    "CMYK_C": 0,
    "CMYK_M": 0.09694553166628,
    "CMYK_Y": 0.268569201231,
    "CMYK_K": 0.01051419973373
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0146",
    "Farbtonhilfsbezeichnung": "Melon A4",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "220",
    "Bcolor": "159",
    "Y": 74.650634765625,
    "L": 89.2290954589844,
    "a": 3.10011339187622,
    "b": 33.6990203857422,
    "C": 33.8413162231445,
    "h": 84.7439193725586,
    "CMY_C": 0.00982147455215,
    "CMY_M": 0.13584905862808,
    "CMY_Y": 0.37782150506973,
    "CMYK_C": 0,
    "CMYK_M": 0.12727764248848,
    "CMYK_Y": 0.3716501891613,
    "CMYK_K": 0.00982147455215
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0147",
    "Farbtonhilfsbezeichnung": "Melon A3",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "210",
    "Bcolor": "130",
    "Y": 67.5900955200195,
    "L": 85.8010711669922,
    "a": 3.78935027122498,
    "b": 43.5868301391602,
    "C": 43.7512397766113,
    "h": 85.0313110351563,
    "CMY_C": 0.02759879827499,
    "CMY_M": 0.17701905965805,
    "CMY_Y": 0.4890456199646,
    "CMYK_C": 0,
    "CMYK_M": 0.15366111695766,
    "CMYK_Y": 0.47454366087914,
    "CMYK_K": 0.02759879827499
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0148",
    "Farbtonhilfsbezeichnung": "Melon A2",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "83",
    "Y": 61.657844543457,
    "L": 82.7311325073242,
    "a": 5.47165870666504,
    "b": 62.152099609375,
    "C": 62.3924865722656,
    "h": 84.9688415527344,
    "CMY_C": 0.02858817577362,
    "CMY_M": 0.21720719337463,
    "CMY_Y": 0.67356777191162,
    "CMYK_C": 0,
    "CMYK_M": 0.19416998326778,
    "CMYK_Y": 0.66396105289459,
    "CMYK_K": 0.02858817577362
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0149",
    "Farbtonhilfsbezeichnung": "Melon A1",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "187",
    "Bcolor": "49",
    "Y": 54.5474395751953,
    "L": 78.7798690795898,
    "a": 7.12645673751831,
    "b": 71.1871871948242,
    "C": 71.5430068969727,
    "h": 84.2832412719727,
    "CMY_C": 0.05746620893478,
    "CMY_M": 0.26477515697479,
    "CMY_Y": 0.80930423736572,
    "CMYK_C": 0,
    "CMYK_M": 0.21994855999947,
    "CMYK_Y": 0.79767751693726,
    "CMYK_K": 0.05746620893478
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0150",
    "Farbtonhilfsbezeichnung": "Menta C2",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "157",
    "Bcolor": "150",
    "Y": 31.2455711364746,
    "L": 62.7143936157227,
    "a": -9.27775859832764,
    "b": 0.1075991615653,
    "C": 9.27838230133057,
    "h": 179.335540771484,
    "CMY_C": 0.47663843631744,
    "CMY_M": 0.38539117574692,
    "CMY_Y": 0.41176283359528,
    "CMYK_C": 0.14846396446228,
    "CMYK_M": 0,
    "CMYK_Y": 0.04290803521872,
    "CMYK_K": 0.38539117574692
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0151",
    "Farbtonhilfsbezeichnung": "Melon B5",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "226",
    "Bcolor": "194",
    "Y": 77.2525100708008,
    "L": 90.4377136230469,
    "a": 1.24823617935181,
    "b": 16.9312057495117,
    "C": 16.9771556854248,
    "h": 85.7835540771484,
    "CMY_C": 0.04704600572586,
    "CMY_M": 0.11432331800461,
    "CMY_Y": 0.23957777023315,
    "CMYK_C": 0,
    "CMYK_M": 0.07059869915247,
    "CMYK_Y": 0.20203678309917,
    "CMYK_K": 0.04704600572586
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0152",
    "Farbtonhilfsbezeichnung": "Melon B4",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "215",
    "Bcolor": "171",
    "Y": 70.0047912597656,
    "L": 86.9992141723633,
    "a": 2.34333086013794,
    "b": 23.9796524047852,
    "C": 24.0938777923584,
    "h": 84.4186859130859,
    "CMY_C": 0.06109589338303,
    "CMY_M": 0.1566070318222,
    "CMY_Y": 0.32841980457306,
    "CMYK_C": 0,
    "CMYK_M": 0.10172618925571,
    "CMYK_Y": 0.28471907973289,
    "CMYK_K": 0.06109589338303
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0153",
    "Farbtonhilfsbezeichnung": "Melon B3",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "201",
    "Bcolor": "142",
    "Y": 60.592472076416,
    "L": 82.1591720581055,
    "a": 2.96730184555054,
    "b": 32.711238861084,
    "C": 32.8455467224121,
    "h": 84.8167724609375,
    "CMY_C": 0.09392285346985,
    "CMY_M": 0.21280544996262,
    "CMY_Y": 0.44372570514679,
    "CMYK_C": 0,
    "CMYK_M": 0.13120582699776,
    "CMYK_Y": 0.38606297969818,
    "CMYK_K": 0.09392285346985
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0154",
    "Farbtonhilfsbezeichnung": "Melon B2",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "182",
    "Bcolor": "101",
    "Y": 49.7560882568359,
    "L": 75.919303894043,
    "a": 3.97115111351013,
    "b": 45.4778251647949,
    "C": 45.65087890625,
    "h": 85.0095596313477,
    "CMY_C": 0.13826644420624,
    "CMY_M": 0.28448289632797,
    "CMY_Y": 0.60388803482056,
    "CMYK_C": 0,
    "CMYK_M": 0.16967710852623,
    "CMYK_Y": 0.54033130407333,
    "CMYK_K": 0.13826644420624
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0155",
    "Farbtonhilfsbezeichnung": "Melon B1",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "157",
    "Bcolor": "69",
    "Y": 36.0879859924316,
    "L": 66.5870971679688,
    "a": 4.42988920211792,
    "b": 49.6955757141113,
    "C": 49.8926277160645,
    "h": 84.9060897827148,
    "CMY_C": 0.23720049858093,
    "CMY_M": 0.38417673110962,
    "CMY_Y": 0.73039138317108,
    "CMYK_C": 0,
    "CMYK_M": 0.19268003106117,
    "CMYK_Y": 0.64655375480652,
    "CMYK_K": 0.23720049858093
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0156",
    "Farbtonhilfsbezeichnung": "Melon C5",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "224",
    "Bcolor": "204",
    "Y": 75.1893310546875,
    "L": 89.4816055297852,
    "a": 1.03321409225464,
    "b": 10.4105405807495,
    "C": 10.4616861343384,
    "h": 84.3321304321289,
    "CMY_C": 0.07731366157532,
    "CMY_M": 0.12280821800232,
    "CMY_Y": 0.20157277584076,
    "CMYK_C": 0,
    "CMYK_M": 0.04930663108826,
    "CMYK_Y": 0.13467101752758,
    "CMYK_K": 0.07731366157532
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0157",
    "Farbtonhilfsbezeichnung": "Melon C4",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "207",
    "Bcolor": "180",
    "Y": 63.8299293518066,
    "L": 83.8771438598633,
    "a": 1.65461277961731,
    "b": 14.6501226425171,
    "C": 14.7432641983032,
    "h": 83.5562133789063,
    "CMY_C": 0.12381845712662,
    "CMY_M": 0.18708610534668,
    "CMY_Y": 0.29277408123016,
    "CMYK_C": 0,
    "CMYK_M": 0.07220837473869,
    "CMYK_Y": 0.19283175468445,
    "CMYK_K": 0.12381845712662
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0158",
    "Farbtonhilfsbezeichnung": "Melon C3",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "189",
    "Bcolor": "156",
    "Y": 52.2261428833008,
    "L": 77.4158630371094,
    "a": 1.64427649974823,
    "b": 18.4541606903076,
    "C": 18.5272693634033,
    "h": 84.9083557128906,
    "CMY_C": 0.18614357709885,
    "CMY_M": 0.25800424814224,
    "CMY_Y": 0.38814735412598,
    "CMYK_C": 0,
    "CMYK_M": 0.08829649537802,
    "CMYK_Y": 0.24820566177368,
    "CMYK_K": 0.18614357709885
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0159",
    "Farbtonhilfsbezeichnung": "Melon C2",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "159",
    "Bcolor": "115",
    "Y": 35.9479713439941,
    "L": 66.4801483154297,
    "a": 2.28245782852173,
    "b": 25.5750846862793,
    "C": 25.6767330169678,
    "h": 84.9001235961914,
    "CMY_C": 0.28667742013931,
    "CMY_M": 0.37662380933762,
    "CMY_Y": 0.54962086677551,
    "CMYK_C": 0,
    "CMYK_M": 0.12609496712685,
    "CMYK_Y": 0.368617862463,
    "CMYK_K": 0.28667742013931
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0160",
    "Farbtonhilfsbezeichnung": "Melon C1",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "130",
    "Bcolor": "74",
    "Y": 23.4311847686768,
    "L": 55.5137252807617,
    "a": 3.0298855304718,
    "b": 33.4857749938965,
    "C": 33.6225700378418,
    "h": 84.8297958374023,
    "CMY_C": 0.38801652193069,
    "CMY_M": 0.4915971159935,
    "CMY_Y": 0.711534678936,
    "CMYK_C": 0,
    "CMYK_M": 0.16925390064716,
    "CMYK_Y": 0.52863872051239,
    "CMYK_K": 0.38801652193069
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0162",
    "Farbtonhilfsbezeichnung": "Camill A5",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "230",
    "Bcolor": "181",
    "Y": 80.1119613647461,
    "L": 91.7350769042969,
    "a": 0.39193242788315,
    "b": 25.5292339324951,
    "C": 25.5322418212891,
    "h": 89.1204452514648,
    "CMY_C": 0.01730352640152,
    "CMY_M": 0.09978258609772,
    "CMY_Y": 0.29017543792725,
    "CMYK_C": 0,
    "CMYK_M": 0.08393137156963,
    "CMYK_Y": 0.27767670154572,
    "CMYK_K": 0.01730352640152
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0163",
    "Farbtonhilfsbezeichnung": "Camill A4",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "220",
    "Bcolor": "154",
    "Y": 73.1602630615234,
    "L": 88.5240936279297,
    "a": 0.37126731872559,
    "b": 35.0927124023438,
    "C": 35.0946769714355,
    "h": 89.3938598632813,
    "CMY_C": 0.03401631116867,
    "CMY_M": 0.13729274272919,
    "CMY_Y": 0.39637845754623,
    "CMYK_C": 0,
    "CMYK_M": 0.10691322386265,
    "CMYK_Y": 0.37512242794037,
    "CMYK_K": 0.03401631116867
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0164",
    "Farbtonhilfsbezeichnung": "Camill A3",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "211",
    "Bcolor": "126",
    "Y": 66.5849990844727,
    "L": 85.2939376831055,
    "a": 0.22269490361214,
    "b": 44.739429473877,
    "C": 44.7399826049805,
    "h": 89.7148056030273,
    "CMY_C": 0.05530744791031,
    "CMY_M": 0.17413324117661,
    "CMY_Y": 0.50418865680695,
    "CMYK_C": 0,
    "CMYK_M": 0.12578250467777,
    "CMYK_Y": 0.47516116499901,
    "CMYK_K": 0.05530744791031
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0165",
    "Farbtonhilfsbezeichnung": "Camill A2",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "199",
    "Bcolor": "79",
    "Y": 59.3474807739258,
    "L": 81.4822235107422,
    "a": 0.46571087837219,
    "b": 62.2442970275879,
    "C": 62.2460403442383,
    "h": 89.5713195800781,
    "CMY_C": 0.07493132352829,
    "CMY_M": 0.21856153011322,
    "CMY_Y": 0.68975293636322,
    "CMYK_C": 0,
    "CMYK_M": 0.15526437759399,
    "CMYK_Y": 0.6646226644516,
    "CMYK_K": 0.07493132352829
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0166",
    "Farbtonhilfsbezeichnung": "Camill A1",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "189",
    "Bcolor": "44",
    "Y": 52.662425994873,
    "L": 77.6752700805664,
    "a": -0.01294632069767,
    "b": 71.0853805541992,
    "C": 71.0853805541992,
    "h": 90.0104293823242,
    "CMY_C": 0.11456537246704,
    "CMY_M": 0.25924521684647,
    "CMY_Y": 0.82740944623947,
    "CMYK_C": 0,
    "CMYK_M": 0.16339980065823,
    "CMYK_Y": 0.80507814884186,
    "CMYK_K": 0.11456537246704
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0167",
    "Farbtonhilfsbezeichnung": "Flanell G3",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "183",
    "Bcolor": "179",
    "Y": 47.5686225891113,
    "L": 74.5520248413086,
    "a": 0.2247224599123,
    "b": 1.81732523441315,
    "C": 1.83116662502289,
    "h": 82.9508361816406,
    "CMY_C": 0.27320075035095,
    "CMY_M": 0.28134685754776,
    "CMY_Y": 0.29927068948746,
    "CMYK_C": 0,
    "CMYK_M": 0.01120819430798,
    "CMYK_Y": 0.03586952015758,
    "CMYK_K": 0.27320075035095
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0168",
    "Farbtonhilfsbezeichnung": "Camill B5",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "225",
    "Bcolor": "194",
    "Y": 75.7050094604492,
    "L": 89.7221984863281,
    "a": -0.17778649926186,
    "b": 15.7569570541382,
    "C": 15.757960319519,
    "h": 90.6464462280273,
    "CMY_C": 0.06872701644897,
    "CMY_M": 0.11857837438583,
    "CMY_Y": 0.23878490924835,
    "CMYK_C": 0,
    "CMYK_M": 0.05353033915162,
    "CMYK_Y": 0.18260799348354,
    "CMYK_K": 0.06872701644897
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0169",
    "Farbtonhilfsbezeichnung": "Camill B4",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "216",
    "Bcolor": "177",
    "Y": 69.4555282592773,
    "L": 86.7291259765625,
    "a": -0.16635447740555,
    "b": 20.7272071838379,
    "C": 20.7278747558594,
    "h": 90.4598388671875,
    "CMY_C": 0.08962643146515,
    "CMY_M": 0.15286576747894,
    "CMY_Y": 0.30759036540985,
    "CMYK_C": 0,
    "CMYK_M": 0.06946525722742,
    "CMYK_Y": 0.23942251503468,
    "CMYK_K": 0.08962643146515
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0170",
    "Farbtonhilfsbezeichnung": "Camill B3",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "206",
    "Bcolor": "156",
    "Y": 62.6590843200684,
    "L": 83.2626800537109,
    "a": -0.15501524507999,
    "b": 26.8180885314941,
    "C": 26.8185367584229,
    "h": 90.3311767578125,
    "CMY_C": 0.11459869146347,
    "CMY_M": 0.1922088265419,
    "CMY_Y": 0.38908350467682,
    "CMYK_C": 0,
    "CMYK_M": 0.08765532076359,
    "CMYK_Y": 0.31001174449921,
    "CMYK_K": 0.11459869146347
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0171",
    "Farbtonhilfsbezeichnung": "Camill B2",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "180",
    "Bcolor": "102",
    "Y": 46.7151222229004,
    "L": 74.0071792602539,
    "a": 0.32464405894279,
    "b": 42.1611061096191,
    "C": 42.1623573303223,
    "h": 89.5588302612305,
    "CMY_C": 0.18807303905487,
    "CMY_M": 0.29572170972824,
    "CMY_Y": 0.59820520877838,
    "CMYK_C": 0,
    "CMYK_M": 0.13258418440819,
    "CMYK_Y": 0.50513434410095,
    "CMYK_K": 0.18807303905487
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0172",
    "Farbtonhilfsbezeichnung": "Camill B1",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "162",
    "Bcolor": "59",
    "Y": 37.5320320129395,
    "L": 67.6742858886719,
    "a": 1.25568532943726,
    "b": 55.1457405090332,
    "C": 55.1600341796875,
    "h": 88.6955795288086,
    "CMY_C": 0.23828488588333,
    "CMY_M": 0.36608666181564,
    "CMY_Y": 0.76840615272522,
    "CMYK_C": 0,
    "CMYK_M": 0.16778159141541,
    "CMYK_Y": 0.69595742225647,
    "CMYK_K": 0.23828488588333
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0173",
    "Farbtonhilfsbezeichnung": "Kiwi C3",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "199",
    "Bcolor": "180",
    "Y": 55.3936882019043,
    "L": 79.2675018310547,
    "a": -5.7890567779541,
    "b": 7.92135238647461,
    "C": 9.81126880645752,
    "h": 126.159957885742,
    "CMY_C": 0.24909293651581,
    "CMY_M": 0.21864664554596,
    "CMY_Y": 0.29390102624893,
    "CMYK_C": 0.03896609693766,
    "CMYK_M": 0,
    "CMYK_Y": 0.09631286561489,
    "CMYK_K": 0.21864664554596
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0174",
    "Farbtonhilfsbezeichnung": "Camill C5",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "221",
    "Bcolor": "200",
    "Y": 72.8278274536133,
    "L": 88.3655395507813,
    "a": 0.01794632710516,
    "b": 10.6650285720825,
    "C": 10.6650438308716,
    "h": 89.9035873413086,
    "CMY_C": 0.09669464826584,
    "CMY_M": 0.13282608985901,
    "CMY_Y": 0.21569120883942,
    "CMYK_C": 0,
    "CMYK_M": 0.03999914601445,
    "CMYK_Y": 0.13173459470272,
    "CMYK_K": 0.09669464826584
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0175",
    "Farbtonhilfsbezeichnung": "Camill C4",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "212",
    "Bcolor": "187",
    "Y": 66.2945861816406,
    "L": 85.1464614868164,
    "a": 0.49567183852196,
    "b": 12.7542104721069,
    "C": 12.7638387680054,
    "h": 87.7744140625,
    "CMY_C": 0.12317943572998,
    "CMY_M": 0.16997027397156,
    "CMY_Y": 0.26556587219238,
    "CMYK_C": 0,
    "CMYK_M": 0.05336421355605,
    "CMYK_Y": 0.16238948702812,
    "CMYK_K": 0.12317943572998
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0176",
    "Farbtonhilfsbezeichnung": "Camill C3",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "198",
    "Bcolor": "168",
    "Y": 57.1735992431641,
    "L": 80.2771377563477,
    "a": -0.00232486007735,
    "b": 16.306245803833,
    "C": 16.306245803833,
    "h": 90.008171081543,
    "CMY_C": 0.17141461372375,
    "CMY_M": 0.22278153896332,
    "CMY_Y": 0.34307366609573,
    "CMYK_C": 0,
    "CMYK_M": 0.06199352070689,
    "CMYK_Y": 0.20717123150826,
    "CMYK_K": 0.17141461372375
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0177",
    "Farbtonhilfsbezeichnung": "Camill C2",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "160",
    "Bcolor": "112",
    "Y": 35.934928894043,
    "L": 66.4701766967773,
    "a": 0.97746622562408,
    "b": 26.9565334320068,
    "C": 26.9742488861084,
    "h": 87.9233169555664,
    "CMY_C": 0.29267537593842,
    "CMY_M": 0.37399470806122,
    "CMY_Y": 0.55984979867935,
    "CMYK_C": 0,
    "CMYK_M": 0.11496748030186,
    "CMYK_Y": 0.37772533297539,
    "CMYK_K": 0.29267537593842
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0178",
    "Farbtonhilfsbezeichnung": "Camill C1",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "127",
    "Bcolor": "66",
    "Y": 22.0212078094482,
    "L": 54.0494956970215,
    "a": 0.61090350151062,
    "b": 35.533935546875,
    "C": 35.5391883850098,
    "h": 89.0150604248047,
    "CMY_C": 0.41548234224319,
    "CMY_M": 0.50112694501877,
    "CMY_Y": 0.74091863632202,
    "CMYK_C": 0,
    "CMYK_M": 0.14652183651924,
    "CMYK_Y": 0.556760430336,
    "CMYK_K": 0.41548234224319
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0179",
    "Farbtonhilfsbezeichnung": "Citro A5",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "230",
    "Bcolor": "183",
    "Y": 79.4082107543945,
    "L": 91.4186782836914,
    "a": -2.16237044334412,
    "b": 24.1502513885498,
    "C": 24.2468662261963,
    "h": 95.1165161132812,
    "CMY_C": 0.04264980554581,
    "CMY_M": 0.09692895412445,
    "CMY_Y": 0.28364962339401,
    "CMYK_C": 0,
    "CMYK_M": 0.05669727548957,
    "CMYK_Y": 0.25173631310463,
    "CMYK_K": 0.04264980554581
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0180",
    "Farbtonhilfsbezeichnung": "Citro A4",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "224",
    "Bcolor": "155",
    "Y": 74.6615982055664,
    "L": 89.234245300293,
    "a": -2.61134696006775,
    "b": 35.5959434509277,
    "C": 35.6916007995605,
    "h": 94.1957473754883,
    "CMY_C": 0.0455978512764,
    "CMY_M": 0.12246459722519,
    "CMY_Y": 0.39345496892929,
    "CMYK_C": 0,
    "CMYK_M": 0.08053915947676,
    "CMYK_Y": 0.36447647213936,
    "CMYK_K": 0.0455978512764
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0181",
    "Farbtonhilfsbezeichnung": "Citro A3",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "216",
    "Bcolor": "131",
    "Y": 68.9493865966797,
    "L": 86.4789810180664,
    "a": -3.00368595123291,
    "b": 44.1403579711914,
    "C": 44.2424392700195,
    "h": 93.8928909301758,
    "CMY_C": 0.06431549787521,
    "CMY_M": 0.15344595909119,
    "CMY_Y": 0.48815220594406,
    "CMYK_C": 0,
    "CMYK_M": 0.09525696188211,
    "CMYK_Y": 0.45296967029572,
    "CMYK_K": 0.06431549787521
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0182",
    "Farbtonhilfsbezeichnung": "Citro A2",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "214",
    "Bcolor": "88",
    "Y": 67.3082580566406,
    "L": 85.6593780517578,
    "a": -4.72640466690063,
    "b": 63.1771507263184,
    "C": 63.3536987304688,
    "h": 94.2784423828125,
    "CMY_C": 0.05807262659073,
    "CMY_M": 0.16108936071396,
    "CMY_Y": 0.65624213218689,
    "CMYK_C": 0,
    "CMYK_M": 0.10936801880598,
    "CMYK_Y": 0.63504844903946,
    "CMYK_K": 0.05807262659073
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0183",
    "Farbtonhilfsbezeichnung": "Citro A1",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "202",
    "Bcolor": "34",
    "Y": 58.6890144348145,
    "L": 81.1203536987305,
    "a": -5.6698260307312,
    "b": 76.7425765991211,
    "C": 76.9517364501953,
    "h": 94.2253952026367,
    "CMY_C": 0.10435050725937,
    "CMY_M": 0.20969635248184,
    "CMY_Y": 0.86747288703918,
    "CMYK_C": 0,
    "CMYK_M": 0.11761949956417,
    "CMYK_Y": 0.85203236341476,
    "CMYK_K": 0.10435050725937
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0184",
    "Farbtonhilfsbezeichnung": "Lilac C3",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "188",
    "Bcolor": "199",
    "Y": 51.4144172668457,
    "L": 76.9293670654297,
    "a": 3.57401394844055,
    "b": -6.01115942001343,
    "C": 6.99339771270752,
    "h": 300.734161376953,
    "CMY_C": 0.24854689836502,
    "CMY_M": 0.26139760017395,
    "CMY_Y": 0.2176930308342,
    "CMYK_C": 0.03943959251046,
    "CMYK_M": 0.05586626753211,
    "CMYK_Y": 0,
    "CMYK_K": 0.2176930308342
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0185",
    "Farbtonhilfsbezeichnung": "Citro B5",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "225",
    "Bcolor": "191",
    "Y": 75.4626770019531,
    "L": 89.6092758178711,
    "a": -1.36147320270538,
    "b": 17.1028690338135,
    "C": 17.1569728851318,
    "h": 94.5514297485352,
    "CMY_C": 0.07515573501587,
    "CMY_M": 0.1173529624939,
    "CMY_Y": 0.25019532442093,
    "CMYK_C": 0,
    "CMYK_M": 0.0456263050437,
    "CMYK_Y": 0.18926385045052,
    "CMYK_K": 0.07515573501587
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0186",
    "Farbtonhilfsbezeichnung": "Citro B4",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "217",
    "Bcolor": "171",
    "Y": 69.2454528808594,
    "L": 86.6254501342773,
    "a": -1.72864556312561,
    "b": 23.6602172851563,
    "C": 23.7232818603516,
    "h": 94.1786804199219,
    "CMY_C": 0.09497207403183,
    "CMY_M": 0.15097880363464,
    "CMY_Y": 0.33073818683624,
    "CMYK_C": 0,
    "CMYK_M": 0.06188397854567,
    "CMYK_Y": 0.26050701737404,
    "CMYK_K": 0.09497207403183
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0187",
    "Farbtonhilfsbezeichnung": "Citro B3",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "204",
    "Bcolor": "148",
    "Y": 60.7174987792969,
    "L": 82.2266387939453,
    "a": -2.56739830970764,
    "b": 29.3706970214844,
    "C": 29.4826965332031,
    "h": 94.995735168457,
    "CMY_C": 0.13763791322708,
    "CMY_M": 0.19840824604034,
    "CMY_Y": 0.41925477981567,
    "CMYK_C": 0,
    "CMYK_M": 0.07046962529421,
    "CMYK_Y": 0.32656452059746,
    "CMYK_K": 0.13763791322708
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0188",
    "Farbtonhilfsbezeichnung": "Citro B2",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "187",
    "Bcolor": "112",
    "Y": 50.0790939331055,
    "L": 76.1177825927734,
    "a": -3.03175139427185,
    "b": 39.8811111450195,
    "C": 39.9961814880371,
    "h": 94.3472442626953,
    "CMY_C": 0.18976277112961,
    "CMY_M": 0.26518982648849,
    "CMY_Y": 0.56049966812134,
    "CMYK_C": 0,
    "CMYK_M": 0.09309255331755,
    "CMYK_Y": 0.45756587386131,
    "CMYK_K": 0.18976277112961
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0189",
    "Farbtonhilfsbezeichnung": "Citro B1",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "170",
    "Bcolor": "75",
    "Y": 40.1411247253418,
    "L": 69.5699310302734,
    "a": -4.16191482543945,
    "b": 50.0263748168945,
    "C": 50.1991996765137,
    "h": 94.7557373046875,
    "CMY_C": 0.2561554312706,
    "CMY_M": 0.33352261781693,
    "CMY_Y": 0.70654618740082,
    "CMYK_C": 0,
    "CMYK_M": 0.10400988161564,
    "CMYK_Y": 0.60549038648605,
    "CMYK_K": 0.2561554312706
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0190",
    "Farbtonhilfsbezeichnung": "Aqua C4",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 60.8526992797852,
    "L": 82.2994918823242,
    "a": -3.63656878471375,
    "b": -4.12782907485962,
    "C": 5.50123691558838,
    "h": 228.620330810547,
    "CMY_C": 0.24105525016785,
    "CMY_M": 0.18713366985321,
    "CMY_Y": 0.17388665676117,
    "CMYK_C": 0.08130675554276,
    "CMYK_M": 0.01603534631431,
    "CMYK_Y": 0,
    "CMYK_K": 0.17388665676117
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0191",
    "Farbtonhilfsbezeichnung": "Citro C5",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "222",
    "Bcolor": "203",
    "Y": 72.6527862548828,
    "L": 88.281852722168,
    "a": -0.94465184211731,
    "b": 8.87911796569824,
    "C": 8.92922782897949,
    "h": 96.072868347168,
    "CMY_C": 0.11016857624054,
    "CMY_M": 0.13102585077286,
    "CMY_Y": 0.20357072353363,
    "CMYK_C": 0,
    "CMYK_M": 0.02343958057463,
    "CMYK_Y": 0.10496611148119,
    "CMYK_K": 0.11016857624054
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0192",
    "Farbtonhilfsbezeichnung": "Citro C4",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "206",
    "Bcolor": "181",
    "Y": 61.9857902526855,
    "L": 82.9058609008789,
    "a": -1.00735449790955,
    "b": 12.8143844604492,
    "C": 12.8539180755615,
    "h": 94.4948501586914,
    "CMY_C": 0.15891808271408,
    "CMY_M": 0.19101023674011,
    "CMY_Y": 0.29009968042374,
    "CMYK_C": 0,
    "CMYK_M": 0.03815580159426,
    "CMYK_Y": 0.15596768260002,
    "CMYK_K": 0.15891808271408
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0193",
    "Farbtonhilfsbezeichnung": "Citro C3",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "192",
    "Bcolor": "160",
    "Y": 52.8123092651367,
    "L": 77.7640533447266,
    "a": -1.39210534095764,
    "b": 16.5381774902344,
    "C": 16.5966644287109,
    "h": 94.8115463256836,
    "CMY_C": 0.20840299129486,
    "CMY_M": 0.24680238962173,
    "CMY_Y": 0.37120532989502,
    "CMYK_C": 0,
    "CMYK_M": 0.04850877076387,
    "CMYK_Y": 0.20566315948963,
    "CMYK_K": 0.20840299129486
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0194",
    "Farbtonhilfsbezeichnung": "Citro C2",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "163",
    "Bcolor": "117",
    "Y": 36.5539817810059,
    "L": 66.9410552978516,
    "a": -2.32879257202148,
    "b": 24.8887901306152,
    "C": 24.9975032806396,
    "h": 95.3454895019531,
    "CMY_C": 0.3133647441864,
    "CMY_M": 0.36131721735001,
    "CMY_Y": 0.54107683897018,
    "CMYK_C": 0,
    "CMYK_M": 0.0698368921876,
    "CMYK_Y": 0.33163473010063,
    "CMYK_K": 0.3133647441864
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0195",
    "Farbtonhilfsbezeichnung": "Citro C1",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "135",
    "Bcolor": "77",
    "Y": 24.2045097351074,
    "L": 56.2919731140137,
    "a": -2.55310654640198,
    "b": 32.6088523864746,
    "C": 32.7086486816406,
    "h": 94.4768371582031,
    "CMY_C": 0.41498363018036,
    "CMY_M": 0.47143423557281,
    "CMY_Y": 0.69925254583359,
    "CMYK_C": 0,
    "CMYK_M": 0.09649406373501,
    "CMYK_Y": 0.48591616749763,
    "CMYK_K": 0.41498363018036
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0196",
    "Farbtonhilfsbezeichnung": "Pino A5",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "234",
    "Bcolor": "194",
    "Y": 80.4610214233398,
    "L": 91.8913192749023,
    "a": -6.22826147079468,
    "b": 18.9345836639404,
    "C": 19.9326286315918,
    "h": 108.207885742188,
    "CMY_C": 0.08110600709915,
    "CMY_M": 0.08105665445328,
    "CMY_Y": 0.24015581607819,
    "CMYK_C": 5.370586223e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.17313271760941,
    "CMYK_K": 0.08105665445328
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0197",
    "Farbtonhilfsbezeichnung": "Pino A4",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "227",
    "Bcolor": "175",
    "Y": 74.4783248901367,
    "L": 89.148063659668,
    "a": -8.26517486572266,
    "b": 24.7148609161377,
    "C": 26.060266494751,
    "h": 108.491035461426,
    "CMY_C": 0.11204242706299,
    "CMY_M": 0.10834074020386,
    "CMY_Y": 0.3131462931633,
    "CMYK_C": 0.00415145885199,
    "CMYK_M": 0,
    "CMYK_Y": 0.22969037294388,
    "CMYK_K": 0.10834074020386
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0198",
    "Farbtonhilfsbezeichnung": "Pino A3",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "220",
    "Bcolor": "151",
    "Y": 67.7409439086914,
    "L": 85.8767471313477,
    "a": -11.72718334198,
    "b": 32.7384834289551,
    "C": 34.7754974365234,
    "h": 109.70792388916,
    "CMY_C": 0.15526014566422,
    "CMY_M": 0.13859713077545,
    "CMY_Y": 0.40860056877136,
    "CMYK_C": 0.01934404298663,
    "CMYK_M": 0,
    "CMYK_Y": 0.31344619393349,
    "CMYK_K": 0.13859713077545
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0199",
    "Farbtonhilfsbezeichnung": "Pino A2",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "201",
    "Bcolor": "103",
    "Y": 54.2166786193848,
    "L": 78.5879058837891,
    "a": -16.9150791168213,
    "b": 47.1448097229004,
    "C": 50.0874519348145,
    "h": 109.73747253418,
    "CMY_C": 0.2456710934639,
    "CMY_M": 0.20996332168579,
    "CMY_Y": 0.59619152545929,
    "CMYK_C": 0.04519761353731,
    "CMYK_M": 0,
    "CMYK_Y": 0.48887374997139,
    "CMYK_K": 0.20996332168579
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0200",
    "Farbtonhilfsbezeichnung": "Pino A1",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "185",
    "Bcolor": "52",
    "Y": 43.3386344909668,
    "L": 71.7842102050781,
    "a": -22.5925407409668,
    "b": 61.0925254821777,
    "C": 65.1361618041992,
    "h": 110.294822692871,
    "CMY_C": 0.34114003181458,
    "CMY_M": 0.27389949560165,
    "CMY_Y": 0.79442727565765,
    "CMYK_C": 0.09260500222445,
    "CMYK_M": 0,
    "CMYK_Y": 0.71688115596771,
    "CMYK_K": 0.27389949560165
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0201",
    "Farbtonhilfsbezeichnung": "Indigo A3",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "196",
    "Bcolor": "222",
    "Y": 54.3174285888672,
    "L": 78.6464614868164,
    "a": -0.58305954933167,
    "b": -15.7247562408447,
    "C": 15.7355623245239,
    "h": 267.876495361328,
    "CMY_C": 0.302958548069,
    "CMY_M": 0.23018312454224,
    "CMY_Y": 0.12984728813171,
    "CMYK_C": 0.19894354045391,
    "CMYK_M": 0.11530830711126,
    "CMYK_Y": 0,
    "CMYK_K": 0.12984728813171
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0202",
    "Farbtonhilfsbezeichnung": "Pino B5",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "230",
    "Bcolor": "198",
    "Y": 77.7565307617188,
    "L": 90.6686859130859,
    "a": -4.58983373641968,
    "b": 14.7863626480103,
    "C": 15.4823474884033,
    "h": 107.24486541748,
    "CMY_C": 0.09397006034851,
    "CMY_M": 0.09749734401703,
    "CMY_Y": 0.22208607196808,
    "CMYK_C": 0,
    "CMYK_M": 0.00389312044717,
    "CMYK_Y": 0.14140373468399,
    "CMYK_K": 0.09397006034851
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0203",
    "Farbtonhilfsbezeichnung": "Pino B4",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "221",
    "Bcolor": "180",
    "Y": 70.525146484375,
    "L": 87.2537841796875,
    "a": -6.59311199188232,
    "b": 19.6799430847168,
    "C": 20.7549819946289,
    "h": 108.521713256836,
    "CMY_C": 0.13371098041534,
    "CMY_M": 0.13202685117722,
    "CMY_Y": 0.29537171125412,
    "CMYK_C": 0.00194030103739,
    "CMYK_M": 0,
    "CMYK_Y": 0.18819114565849,
    "CMYK_K": 0.13202685117722
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0204",
    "Farbtonhilfsbezeichnung": "Pino B3",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "210",
    "Bcolor": "157",
    "Y": 61.7456245422363,
    "L": 82.777961730957,
    "a": -9.61193370819092,
    "b": 25.1800765991211,
    "C": 26.9522819519043,
    "h": 110.893241882324,
    "CMY_C": 0.19173967838287,
    "CMY_M": 0.17584377527237,
    "CMY_Y": 0.38375115394592,
    "CMYK_C": 0.01928748749197,
    "CMYK_M": 0,
    "CMYK_Y": 0.25226694345474,
    "CMYK_K": 0.17584377527237
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0205",
    "Farbtonhilfsbezeichnung": "Pino B2",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "189",
    "Bcolor": "114",
    "Y": 47.6795921325684,
    "L": 74.6223831176758,
    "a": -13.5106153488159,
    "b": 36.6869964599609,
    "C": 39.0956840515137,
    "h": 110.217094421387,
    "CMY_C": 0.28414779901505,
    "CMY_M": 0.25823420286179,
    "CMY_Y": 0.55366969108582,
    "CMYK_C": 0.03493501245975,
    "CMYK_M": 0,
    "CMYK_Y": 0.39828675985336,
    "CMYK_K": 0.25823420286179
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0206",
    "Farbtonhilfsbezeichnung": "Pino B1",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "169",
    "Bcolor": "70",
    "Y": 36.1213264465332,
    "L": 66.6125259399414,
    "a": -16.9875030517578,
    "b": 48.023021697998,
    "C": 50.9390411376953,
    "h": 109.48055267334,
    "CMY_C": 0.37631583213806,
    "CMY_M": 0.3380588889122,
    "CMY_Y": 0.72358500957489,
    "CMYK_C": 0.05779508501291,
    "CMYK_M": 0,
    "CMYK_Y": 0.58241754770279,
    "CMYK_K": 0.3380588889122
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0207",
    "Farbtonhilfsbezeichnung": "Mare C1",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "117",
    "Bcolor": "139",
    "Y": 16.3049011230469,
    "L": 47.3719940185547,
    "a": -6.45147705078125,
    "b": -16.9794826507568,
    "C": 18.1638202667236,
    "h": 249.195343017578,
    "CMY_C": 0.68458211421967,
    "CMY_M": 0.54148733615875,
    "CMY_Y": 0.45315384864807,
    "CMYK_C": 0.42320543527603,
    "CMYK_M": 0.16153261065483,
    "CMYK_Y": 0,
    "CMYK_K": 0.45315384864807
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0208",
    "Farbtonhilfsbezeichnung": "Pino C5",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "208",
    "Y": 74.3940658569336,
    "L": 89.1083984375,
    "a": -2.53247594833374,
    "b": 7.38048982620239,
    "C": 7.8028883934021,
    "h": 108.938690185547,
    "CMY_C": 0.11778819561005,
    "CMY_M": 0.11776107549667,
    "CMY_Y": 0.18377280235291,
    "CMYK_C": 3.074010237e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.07482296228409,
    "CMYK_K": 0.11776107549667
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0209",
    "Farbtonhilfsbezeichnung": "Pino C3",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "197",
    "Bcolor": "169",
    "Y": 54.6117362976074,
    "L": 78.8171005249023,
    "a": -4.45227098464966,
    "b": 13.1831207275391,
    "C": 13.9146461486816,
    "h": 108.661117553711,
    "CMY_C": 0.22819298505783,
    "CMY_M": 0.22775632143021,
    "CMY_Y": 0.33645462989807,
    "CMYK_C": 0.00056544796098,
    "CMYK_M": 0,
    "CMYK_Y": 0.14075648784637,
    "CMYK_K": 0.22775632143021
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0210",
    "Farbtonhilfsbezeichnung": "Pino C2",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "167",
    "Bcolor": "127",
    "Y": 37.1292953491211,
    "L": 67.3739242553711,
    "a": -7.23338890075684,
    "b": 19.6436500549316,
    "C": 20.93310546875,
    "h": 110.215240478516,
    "CMY_C": 0.35416734218597,
    "CMY_M": 0.34526056051254,
    "CMY_Y": 0.50036805868149,
    "CMYK_C": 0.01360355131328,
    "CMYK_M": 0,
    "CMYK_Y": 0.23689958453178,
    "CMYK_K": 0.34526056051254
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0211",
    "Farbtonhilfsbezeichnung": "Pino C1",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "138",
    "Bcolor": "88",
    "Y": 24.1115188598633,
    "L": 56.199275970459,
    "a": -9.22062301635742,
    "b": 26.3096618652344,
    "C": 27.8786334991455,
    "h": 109.313789367676,
    "CMY_C": 0.46988761425018,
    "CMY_M": 0.45783251523972,
    "CMY_Y": 0.65661329030991,
    "CMYK_C": 0.02223500981927,
    "CMYK_M": 0,
    "CMYK_Y": 0.36664089560509,
    "CMYK_K": 0.45783251523972
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0212",
    "Farbtonhilfsbezeichnung": "Gruen",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "166",
    "Bcolor": "61",
    "Y": 31.5313243865967,
    "L": 62.9536209106445,
    "a": -33.4108810424805,
    "b": 47.542610168457,
    "C": 58.1084060668945,
    "h": 125.097877502441,
    "CMY_C": 0.53941178321838,
    "CMY_M": 0.34781461954117,
    "CMY_Y": 0.76136928796768,
    "CMYK_C": 0.29377713799477,
    "CMYK_M": 0,
    "CMYK_Y": 0.63410598039627,
    "CMYK_K": 0.34781461954117
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0213",
    "Farbtonhilfsbezeichnung": "Kiwi A5",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "235",
    "Bcolor": "203",
    "Y": 79.4627456665039,
    "L": 91.4432601928711,
    "a": -8.47440719604492,
    "b": 13.1958169937134,
    "C": 15.6826391220093,
    "h": 122.70874786377,
    "CMY_C": 0.12034291028976,
    "CMY_M": 0.07964634895325,
    "CMY_Y": 0.20246368646622,
    "CMYK_C": 0.04421839490533,
    "CMYK_M": 0,
    "CMYK_Y": 0.1334458142519,
    "CMYK_K": 0.07964634895325
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0214",
    "Farbtonhilfsbezeichnung": "Kiwi A4",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "228",
    "Bcolor": "188",
    "Y": 73.0362701416016,
    "L": 88.4650115966797,
    "a": -11.4974269866943,
    "b": 17.089225769043,
    "C": 20.5969047546387,
    "h": 123.932197570801,
    "CMY_C": 0.1654834151268,
    "CMY_M": 0.10717117786407,
    "CMY_Y": 0.26401841640472,
    "CMYK_C": 0.06531177461147,
    "CMYK_M": 0,
    "CMYK_Y": 0.17567448318005,
    "CMYK_K": 0.10717117786407
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0215",
    "Farbtonhilfsbezeichnung": "Kiwi A3",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "219",
    "Bcolor": "172",
    "Y": 65.9520645141602,
    "L": 84.9719619750977,
    "a": -14.3837471008301,
    "b": 20.4321002960205,
    "C": 24.9872550964356,
    "h": 125.144691467285,
    "CMY_C": 0.21691066026688,
    "CMY_M": 0.14053082466125,
    "CMY_Y": 0.32640570402145,
    "CMYK_C": 0.08886861801147,
    "CMYK_M": 0,
    "CMYK_Y": 0.21626706421375,
    "CMYK_K": 0.14053082466125
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0216",
    "Farbtonhilfsbezeichnung": "Kiwi A2",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "187",
    "Bcolor": "103",
    "Y": 42.7707824707031,
    "L": 71.3991165161133,
    "a": -26.4728164672852,
    "b": 37.6556243896484,
    "C": 46.0299491882324,
    "h": 125.108154296875,
    "CMY_C": 0.41436719894409,
    "CMY_M": 0.26822644472122,
    "CMY_Y": 0.59606313705444,
    "CMYK_C": 0.19970761239529,
    "CMYK_M": 0,
    "CMYK_Y": 0.44800293445587,
    "CMYK_K": 0.26822644472122
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0217",
    "Farbtonhilfsbezeichnung": "Kiwi A1",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "166",
    "Bcolor": "61",
    "Y": 31.5313243865967,
    "L": 62.9536209106445,
    "a": -33.4108810424805,
    "b": 47.542610168457,
    "C": 58.1084060668945,
    "h": 125.097877502441,
    "CMY_C": 0.53941178321838,
    "CMY_M": 0.34781461954117,
    "CMY_Y": 0.76136928796768,
    "CMYK_C": 0.29377713799477,
    "CMYK_M": 0,
    "CMYK_Y": 0.63410598039627,
    "CMYK_K": 0.34781461954117
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0218",
    "Farbtonhilfsbezeichnung": "Kiwi B5",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "231",
    "Bcolor": "207",
    "Y": 77.3969039916992,
    "L": 90.5039825439453,
    "a": -6.63842916488647,
    "b": 10.0307912826538,
    "C": 12.0285291671753,
    "h": 123.496803283691,
    "CMY_C": 0.12613171339035,
    "CMY_M": 0.09349513053894,
    "CMY_Y": 0.1888307929039,
    "CMYK_C": 0.03600265458226,
    "CMYK_M": 0,
    "CMYK_Y": 0.1051683947444,
    "CMYK_K": 0.09349513053894
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0219",
    "Farbtonhilfsbezeichnung": "Kiwi B4",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "222",
    "Bcolor": "193",
    "Y": 70.1516418457031,
    "L": 87.0711822509766,
    "a": -8.03085231781006,
    "b": 12.0914754867554,
    "C": 14.5154523849487,
    "h": 123.591110229492,
    "CMY_C": 0.16860783100128,
    "CMY_M": 0.12908434867859,
    "CMY_Y": 0.24140280485153,
    "CMYK_C": 0.04538152739406,
    "CMYK_M": 0,
    "CMYK_Y": 0.12896594405174,
    "CMYK_K": 0.12908434867859
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0220",
    "Farbtonhilfsbezeichnung": "Kiwi B3",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "209",
    "Bcolor": "174",
    "Y": 60.3387489318848,
    "L": 82.0219650268555,
    "a": -10.5953884124756,
    "b": 15.2946710586548,
    "C": 18.6061611175537,
    "h": 124.712287902832,
    "CMY_C": 0.23419892787933,
    "CMY_M": 0.17991816997528,
    "CMY_Y": 0.31907337903976,
    "CMYK_C": 0.06618943810463,
    "CMYK_M": 0,
    "CMYK_Y": 0.16968454420567,
    "CMYK_K": 0.17991816997528
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0221",
    "Farbtonhilfsbezeichnung": "Kiwi B2",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "173",
    "Bcolor": "119",
    "Y": 37.5475540161133,
    "L": 67.6858215332031,
    "a": -17.0168132781982,
    "b": 24.5522022247314,
    "C": 29.8727722167969,
    "h": 124.72533416748,
    "CMY_C": 0.41090685129166,
    "CMY_M": 0.32331562042236,
    "CMY_Y": 0.53399169445038,
    "CMYK_C": 0.12944178283215,
    "CMYK_M": 0,
    "CMYK_Y": 0.31133580207825,
    "CMYK_K": 0.32331562042236
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0222",
    "Farbtonhilfsbezeichnung": "Kiwi B1",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "144",
    "Bcolor": "75",
    "Y": 23.8138618469238,
    "L": 55.9009475708008,
    "a": -22.9939231872559,
    "b": 32.2630767822266,
    "C": 39.6185150146484,
    "h": 125.477500915527,
    "CMY_C": 0.55961006879807,
    "CMY_M": 0.4366774559021,
    "CMY_Y": 0.70510572195053,
    "CMYK_C": 0.21822775900364,
    "CMYK_M": 0,
    "CMYK_Y": 0.47650900483131,
    "CMYK_K": 0.4366774559021
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0223",
    "Farbtonhilfsbezeichnung": "Kiwi C5",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "226",
    "Bcolor": "209",
    "Y": 74.0241394042969,
    "L": 88.9338912963867,
    "a": -4.63501596450806,
    "b": 6.62054634094238,
    "C": 8.0817699432373,
    "h": 124.995697021484,
    "CMY_C": 0.13863635063171,
    "CMY_M": 0.1146622300148,
    "CMY_Y": 0.1803680062294,
    "CMYK_C": 0.02707906626165,
    "CMYK_M": 0,
    "CMYK_Y": 0.0742154866457,
    "CMYK_K": 0.1146622300148
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0224",
    "Farbtonhilfsbezeichnung": "Kiwi C2",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "155",
    "Bcolor": "128",
    "Y": 31.1880702972412,
    "L": 62.6660804748535,
    "a": -8.31435871124268,
    "b": 12.550311088562,
    "C": 15.0545301437378,
    "h": 123.523765563965,
    "CMY_C": 0.42936277389526,
    "CMY_M": 0.39073586463928,
    "CMY_Y": 0.49787753820419,
    "CMYK_C": 0.06339928507805,
    "CMYK_M": 0,
    "CMYK_Y": 0.17585422098637,
    "CMYK_K": 0.39073586463928
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0225",
    "Farbtonhilfsbezeichnung": "Kiwi C1",
    "Farbtonklasse": "04",
    "Rcolor": "108",
    "Gcolor": "119",
    "Bcolor": "90",
    "Y": 17.11962890625,
    "L": 48.4104118347168,
    "a": -9.66743850708008,
    "b": 14.1995429992676,
    "C": 17.1780796051025,
    "h": 124.248107910156,
    "CMY_C": 0.5777313709259,
    "CMY_M": 0.53296738862991,
    "CMY_Y": 0.64744091033936,
    "CMYK_C": 0.095847658813,
    "CMYK_M": 0,
    "CMYK_Y": 0.2451082020998,
    "CMYK_K": 0.53296738862991
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0226",
    "Farbtonhilfsbezeichnung": "Menta A5",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 77.7170715332031,
    "L": 90.6506423950195,
    "a": -10.9940547943115,
    "b": 1.09536218643188,
    "C": 11.0484867095947,
    "h": 174.310272216797,
    "CMY_C": 0.19199711084366,
    "CMY_M": 0.07984340190887,
    "CMY_Y": 0.12155228853226,
    "CMYK_C": 0.12188545614481,
    "CMYK_M": 0,
    "CMYK_Y": 0.04532803222537,
    "CMYK_K": 0.07984340190887
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0227",
    "Farbtonhilfsbezeichnung": "Menta A4",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "224",
    "Bcolor": "213",
    "Y": 69.0551376342773,
    "L": 86.5313491821289,
    "a": -13.5815200805664,
    "b": 0.7306335568428,
    "C": 13.6011581420898,
    "h": 176.920669555664,
    "CMY_C": 0.26095658540726,
    "CMY_M": 0.12018644809723,
    "CMY_Y": 0.16442543268204,
    "CMYK_C": 0.1599999666214,
    "CMYK_M": 0,
    "CMYK_Y": 0.05028222501278,
    "CMYK_K": 0.12018644809723
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0228",
    "Farbtonhilfsbezeichnung": "Menta A3",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "213",
    "Bcolor": "200",
    "Y": 59.6953392028809,
    "L": 81.6723098754883,
    "a": -17.2611064910889,
    "b": 0.72349375486374,
    "C": 17.2762622833252,
    "h": 177.599884033203,
    "CMY_C": 0.34641146659851,
    "CMY_M": 0.16639882326126,
    "CMY_Y": 0.21761286258698,
    "CMYK_C": 0.21594576537609,
    "CMYK_M": 0,
    "CMYK_Y": 0.06143710017204,
    "CMYK_K": 0.16639882326126
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0229",
    "Farbtonhilfsbezeichnung": "Menta A2",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "175",
    "Bcolor": "157",
    "Y": 35.1866188049316,
    "L": 65.8936996459961,
    "a": -29.1866512298584,
    "b": 0.52781069278717,
    "C": 29.1914234161377,
    "h": 178.963973999023,
    "CMY_C": 0.63853323459625,
    "CMY_M": 0.31564992666245,
    "CMY_Y": 0.38429009914398,
    "CMYK_C": 0.47181013226509,
    "CMYK_M": 0,
    "CMYK_Y": 0.10029979795218,
    "CMYK_K": 0.31564992666245
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0230",
    "Farbtonhilfsbezeichnung": "Menta A1",
    "Farbtonklasse": "04",
    "Rcolor": "10",
    "Gcolor": "142",
    "Bcolor": "123",
    "Y": 20.6979007720947,
    "L": 52.6172714233398,
    "a": -36.0952301025391,
    "b": 0.52399277687073,
    "C": 36.0990333557129,
    "h": 179.16828918457,
    "CMY_C": 0.96225833892822,
    "CMY_M": 0.44485968351364,
    "CMY_Y": 0.51905655860901,
    "CMYK_C": 0.93201416730881,
    "CMYK_M": 0,
    "CMYK_Y": 0.13365426659584,
    "CMYK_K": 0.44485968351364
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0231",
    "Farbtonhilfsbezeichnung": "Menta B5",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "232",
    "Bcolor": "223",
    "Y": 76.8097381591797,
    "L": 90.2339706420898,
    "a": -7.76452541351318,
    "b": 0.82740044593811,
    "C": 7.80848550796509,
    "h": 173.917419433594,
    "CMY_C": 0.17007851600647,
    "CMY_M": 0.09155058860779,
    "CMY_Y": 0.12372994422913,
    "CMYK_C": 0.0864417180419,
    "CMYK_M": 0,
    "CMYK_Y": 0.03542228788137,
    "CMYK_K": 0.09155058860779
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0232",
    "Farbtonhilfsbezeichnung": "Menta B4",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "222",
    "Bcolor": "213",
    "Y": 69.0083389282227,
    "L": 86.5081787109375,
    "a": -9.10931491851807,
    "b": 0.91910707950592,
    "C": 9.15556526184082,
    "h": 174.238494873047,
    "CMY_C": 0.22180902957916,
    "CMY_M": 0.13008278608322,
    "CMY_Y": 0.16547644138336,
    "CMYK_C": 0.10544249415398,
    "CMYK_M": 0,
    "CMYK_Y": 0.04068623483181,
    "CMYK_K": 0.13008278608322
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0233",
    "Farbtonhilfsbezeichnung": "Menta B3",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "209",
    "Bcolor": "199",
    "Y": 59.4684791564941,
    "L": 81.5484237670898,
    "a": -10.7689561843872,
    "b": 0.81164610385895,
    "C": 10.7994995117188,
    "h": 175.689819335938,
    "CMY_C": 0.28984886407852,
    "CMY_M": 0.1811751127243,
    "CMY_Y": 0.21876204013824,
    "CMYK_C": 0.13271915912628,
    "CMYK_M": 0,
    "CMYK_Y": 0.04590350016952,
    "CMYK_K": 0.1811751127243
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0234",
    "Farbtonhilfsbezeichnung": "Menta B2",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "167",
    "Bcolor": "154",
    "Y": 33.6859359741211,
    "L": 64.7125091552734,
    "a": -20.5688610076904,
    "b": 0.71391957998276,
    "C": 20.5812473297119,
    "h": 178.012130737305,
    "CMY_C": 0.55482059717178,
    "CMY_M": 0.34320229291916,
    "CMY_Y": 0.39678251743317,
    "CMYK_C": 0.32219707965851,
    "CMYK_M": 0,
    "CMYK_Y": 0.08157797157764,
    "CMYK_K": 0.34320229291916
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0235",
    "Farbtonhilfsbezeichnung": "Menta B1",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "135",
    "Bcolor": "122",
    "Y": 19.8503017425537,
    "L": 51.6675338745117,
    "a": -24.4611358642578,
    "b": -0.20870193839073,
    "C": 24.4620265960693,
    "h": 180.488830566406,
    "CMY_C": 0.7351142168045,
    "CMY_M": 0.47184908390045,
    "CMY_Y": 0.52236700057983,
    "CMYK_C": 0.49846574664116,
    "CMYK_M": 0,
    "CMYK_Y": 0.09565053135157,
    "CMYK_K": 0.47184908390045
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0236",
    "Farbtonhilfsbezeichnung": "Aqua B3",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "199",
    "Bcolor": "210",
    "Y": 53.7635459899902,
    "L": 78.3236541748047,
    "a": -8.37014293670654,
    "b": -9.69399642944336,
    "C": 12.8075313568115,
    "h": 229.191497802734,
    "CMY_C": 0.34753203392029,
    "CMY_M": 0.21848124265671,
    "CMY_Y": 0.17761838436127,
    "CMYK_C": 0.20661167800426,
    "CMYK_M": 0.04968843981624,
    "CMYK_Y": 0,
    "CMYK_K": 0.17761838436127
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0237",
    "Farbtonhilfsbezeichnung": "Menta C5",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "229",
    "Bcolor": "222",
    "Y": 75.9050369262695,
    "L": 89.8152313232422,
    "a": -4.38493585586548,
    "b": 0.89864933490753,
    "C": 4.47607326507568,
    "h": 168.418167114258,
    "CMY_C": 0.14646518230438,
    "CMY_M": 0.10387408733368,
    "CMY_Y": 0.12841379642487,
    "CMYK_C": 0.04752802476287,
    "CMYK_M": 0,
    "CMYK_Y": 0.02738421969116,
    "CMYK_K": 0.10387408733368
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0238",
    "Farbtonhilfsbezeichnung": "Menta C4",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "218",
    "Bcolor": "211",
    "Y": 67.764778137207,
    "L": 85.8886947631836,
    "a": -4.78892183303833,
    "b": 0.81554716825485,
    "C": 4.85786867141724,
    "h": 170.335327148438,
    "CMY_C": 0.19317597150803,
    "CMY_M": 0.14649045467377,
    "CMY_Y": 0.17090380191803,
    "CMYK_C": 0.05469829589128,
    "CMYK_M": 0,
    "CMYK_Y": 0.0286034848541,
    "CMYK_K": 0.14649045467377
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0239",
    "Farbtonhilfsbezeichnung": "Menta C1",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "125",
    "Bcolor": "119",
    "Y": 18.6669425964356,
    "L": 50.295238494873,
    "a": -10.7517833709717,
    "b": -0.45875191688538,
    "C": 10.7615661621094,
    "h": 182.443176269531,
    "CMY_C": 0.61414235830307,
    "CMY_M": 0.50908744335175,
    "CMY_Y": 0.53273046016693,
    "CMYK_C": 0.2139992415905,
    "CMYK_M": 0,
    "CMYK_Y": 0.04816136136651,
    "CMYK_K": 0.50908744335175
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0240",
    "Farbtonhilfsbezeichnung": "Aqua A5",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "226",
    "Bcolor": "231",
    "Y": 72.3468627929688,
    "L": 88.1352844238281,
    "a": -7.06112909317017,
    "b": -6.4833459854126,
    "C": 9.58610057830811,
    "h": 222.557342529297,
    "CMY_C": 0.21609318256378,
    "CMY_M": 0.11441111564636,
    "CMY_Y": 0.09289520978928,
    "CMYK_C": 0.13581448793411,
    "CMYK_M": 0.02371931634843,
    "CMYK_Y": 0,
    "CMYK_K": 0.09289520978928
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0241",
    "Farbtonhilfsbezeichnung": "Aqua A4",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "215",
    "Bcolor": "226",
    "Y": 63.2887001037598,
    "L": 83.5940475463867,
    "a": -10.001124382019,
    "b": -10.662109375,
    "C": 14.6185865402222,
    "h": 226.832183837891,
    "CMY_C": 0.31048899888992,
    "CMY_M": 0.15702646970749,
    "CMY_Y": 0.11294293403625,
    "CMYK_C": 0.22269825637341,
    "CMYK_M": 0.04969639331102,
    "CMYK_Y": 0,
    "CMYK_K": 0.11294293403625
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0242",
    "Farbtonhilfsbezeichnung": "Aqua A3",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "204",
    "Bcolor": "220",
    "Y": 54.6905822753906,
    "L": 78.8627014160156,
    "a": -13.2662076950073,
    "b": -14.4502210617065,
    "C": 19.6163482666016,
    "h": 227.44612121582,
    "CMY_C": 0.41252863407135,
    "CMY_M": 0.20095312595367,
    "CMY_Y": 0.13802140951157,
    "CMYK_C": 0.31846177577972,
    "CMYK_M": 0.07300844788551,
    "CMYK_Y": 0,
    "CMYK_K": 0.13802140951157
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0243",
    "Farbtonhilfsbezeichnung": "Aqua A2",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "164",
    "Bcolor": "192",
    "Y": 31.7606506347656,
    "L": 63.1445693969727,
    "a": -19.1295833587646,
    "b": -23.1235942840576,
    "C": 30.0106906890869,
    "h": 230.399871826172,
    "CMY_C": 0.72671449184418,
    "CMY_M": 0.35547769069672,
    "CMY_Y": 0.24811458587646,
    "CMYK_C": 0.63653302192688,
    "CMYK_M": 0.14279183745384,
    "CMYK_Y": 0,
    "CMYK_K": 0.24811458587646
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0244",
    "Farbtonhilfsbezeichnung": "Aqua A1",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "158",
    "Y": 16.6298217773438,
    "L": 47.7901802062988,
    "a": -22.2514247894287,
    "b": -27.7615184783936,
    "C": 35.5784721374512,
    "h": 231.287109375,
    "CMY_C": 1,
    "CMY_M": 0.50669896602631,
    "CMY_Y": 0.3791521191597,
    "CMYK_C": 1,
    "CMYK_M": 0.20543977618217,
    "CMYK_Y": 0,
    "CMYK_K": 0.3791521191597
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0245",
    "Farbtonhilfsbezeichnung": "Lilac B4",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "203",
    "Bcolor": "217",
    "Y": 60.9897689819336,
    "L": 82.3732376098633,
    "a": 4.53987407684326,
    "b": -7.50504207611084,
    "C": 8.77132320404053,
    "h": 301.170166015625,
    "CMY_C": 0.187280356884,
    "CMY_M": 0.2043280005455,
    "CMY_Y": 0.14757269620895,
    "CMYK_C": 0.04658187180758,
    "CMYK_M": 0.06658081710339,
    "CMYK_Y": 0,
    "CMYK_K": 0.14757269620895
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0246",
    "Farbtonhilfsbezeichnung": "Aqua B5",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "223",
    "Bcolor": "226",
    "Y": 71.2526016235352,
    "L": 87.6075897216797,
    "a": -5.23805141448975,
    "b": -4.46536540985107,
    "C": 6.8830714225769,
    "h": 220.447128295898,
    "CMY_C": 0.19798541069031,
    "CMY_M": 0.12494736909866,
    "CMY_Y": 0.11335325241089,
    "CMYK_C": 0.09545194357634,
    "CMYK_M": 0.01307636499405,
    "CMYK_Y": 0,
    "CMYK_K": 0.11335325241089
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0247",
    "Farbtonhilfsbezeichnung": "Aqua B4",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "213",
    "Bcolor": "220",
    "Y": 63.2638473510742,
    "L": 83.5810089111328,
    "a": -6.99981451034546,
    "b": -7.1060357093811,
    "C": 9.97462558746338,
    "h": 225.431442260742,
    "CMY_C": 0.26765435934067,
    "CMY_M": 0.164735019207,
    "CMY_Y": 0.13863337039948,
    "CMYK_C": 0.14978638291359,
    "CMYK_M": 0.0303026009351,
    "CMYK_Y": 0,
    "CMYK_K": 0.13863337039948
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0248",
    "Farbtonhilfsbezeichnung": "Aqua B2",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "162",
    "Bcolor": "183",
    "Y": 31.7306137084961,
    "L": 63.1196174621582,
    "a": -14.5605926513672,
    "b": -17.9481353759766,
    "C": 23.111608505249,
    "h": 230.948989868164,
    "CMY_C": 0.61656963825226,
    "CMY_M": 0.36578249931335,
    "CMY_Y": 0.28378707170486,
    "CMYK_C": 0.46464192867279,
    "CMYK_M": 0.11448470503092,
    "CMYK_Y": 0,
    "CMYK_K": 0.28378707170486
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0249",
    "Farbtonhilfsbezeichnung": "Aqua B1",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "121",
    "Bcolor": "146",
    "Y": 15.9971427917481,
    "L": 46.9707412719727,
    "a": -17.6750373840332,
    "b": -21.8495025634766,
    "C": 28.1035175323486,
    "h": 231.029067993164,
    "CMY_C": 0.91889727115631,
    "CMY_M": 0.52416837215424,
    "CMY_Y": 0.42623746395111,
    "CMYK_C": 0.85864758491516,
    "CMYK_M": 0.17068195343018,
    "CMYK_Y": 0,
    "CMYK_K": 0.42623746395111
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0250",
    "Farbtonhilfsbezeichnung": "Aqua C5",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "219",
    "Bcolor": "220",
    "Y": 69.2300262451172,
    "L": 86.6178283691406,
    "a": -3.19829487800598,
    "b": -2.44719862937927,
    "C": 4.02714204788208,
    "h": 217.421676635742,
    "CMY_C": 0.18413519859314,
    "CMY_M": 0.14112275838852,
    "CMY_Y": 0.13880896568298,
    "CMYK_C": 0.05263203009963,
    "CMYK_M": 0.00268673570827,
    "CMYK_Y": 0,
    "CMYK_K": 0.13880896568298
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0251",
    "Farbtonhilfsbezeichnung": "Aqua C3",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "195",
    "Bcolor": "200",
    "Y": 52.4844703674316,
    "L": 77.5696334838867,
    "a": -5.22219753265381,
    "b": -5.47482585906982,
    "C": 7.56604671478271,
    "h": 226.352890014648,
    "CMY_C": 0.31022542715073,
    "CMY_M": 0.23469066619873,
    "CMY_Y": 0.21570372581482,
    "CMYK_C": 0.12051784992218,
    "CMYK_M": 0.02420888841152,
    "CMYK_Y": 0,
    "CMYK_K": 0.21570372581482
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0252",
    "Farbtonhilfsbezeichnung": "Aqua C1",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "118",
    "Bcolor": "133",
    "Y": 15.8342046737671,
    "L": 46.7562141418457,
    "a": -12.1677541732788,
    "b": -14.1106824874878,
    "C": 18.6323795318604,
    "h": 229.228546142578,
    "CMY_C": 0.73292517662048,
    "CMY_M": 0.53803932666779,
    "CMY_Y": 0.47858649492264,
    "CMYK_C": 0.48778691887856,
    "CMYK_M": 0.1140224263072,
    "CMYK_Y": 0,
    "CMYK_K": 0.47858649492264
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0254",
    "Farbtonhilfsbezeichnung": "Mare A4",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "210",
    "Bcolor": "227",
    "Y": 61.5332794189453,
    "L": 82.6645965576172,
    "a": -5.93156051635742,
    "b": -12.6721076965332,
    "C": 13.9916305541992,
    "h": 244.916641235352,
    "CMY_C": 0.29282355308533,
    "CMY_M": 0.17543840408325,
    "CMY_Y": 0.10813230276108,
    "CMYK_C": 0.20708368718624,
    "CMYK_M": 0.07546646147966,
    "CMYK_Y": 0,
    "CMYK_K": 0.10813230276108
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0255",
    "Farbtonhilfsbezeichnung": "Mare A3",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "199",
    "Bcolor": "222",
    "Y": 53.5751571655273,
    "L": 78.2133560180664,
    "a": -7.04576969146729,
    "b": -16.7533550262451,
    "C": 18.1746463775635,
    "h": 247.190383911133,
    "CMY_C": 0.37094211578369,
    "CMY_M": 0.22028696537018,
    "CMY_Y": 0.12792646884918,
    "CMYK_C": 0.27866417169571,
    "CMYK_M": 0.1059090718627,
    "CMYK_Y": 0,
    "CMYK_K": 0.12792646884918
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0256",
    "Farbtonhilfsbezeichnung": "Mare A2",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "161",
    "Bcolor": "198",
    "Y": 32.0126724243164,
    "L": 63.3533554077148,
    "a": -9.60510540008545,
    "b": -26.3975448608398,
    "C": 28.0907173156738,
    "h": 250.005401611328,
    "CMY_C": 0.61868369579315,
    "CMY_M": 0.36998945474625,
    "CMY_Y": 0.22235530614853,
    "CMYK_C": 0.50965225696564,
    "CMYK_M": 0.18984781205654,
    "CMYK_Y": 0,
    "CMYK_K": 0.22235530614853
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0257",
    "Farbtonhilfsbezeichnung": "Mare A1",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "123",
    "Bcolor": "170",
    "Y": 16.7968578338623,
    "L": 48.0030555725098,
    "a": -13.0260763168335,
    "b": -34.3312644958496,
    "C": 36.7194023132324,
    "h": 249.222091674805,
    "CMY_C": 1,
    "CMY_M": 0.51718831062317,
    "CMY_Y": 0.33273059129715,
    "CMYK_C": 1,
    "CMYK_M": 0.27643665671349,
    "CMYK_Y": 0,
    "CMYK_K": 0.33273059129715
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0258",
    "Farbtonhilfsbezeichnung": "Mare B5",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "220",
    "Bcolor": "227",
    "Y": 70.0514221191406,
    "L": 87.0220794677734,
    "a": -3.06733202934265,
    "b": -5.74354028701782,
    "C": 6.51128101348877,
    "h": 241.895599365234,
    "CMY_C": 0.19120860099792,
    "CMY_M": 0.13598167896271,
    "CMY_Y": 0.11016535758972,
    "CMYK_C": 0.09107674658298,
    "CMYK_M": 0.0290124937892,
    "CMYK_Y": 0,
    "CMYK_K": 0.11016535758972
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0259",
    "Farbtonhilfsbezeichnung": "Mare B4",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "209",
    "Bcolor": "220",
    "Y": 61.3525505065918,
    "L": 82.5679092407227,
    "a": -3.97277855873108,
    "b": -9.0361213684082,
    "C": 9.87088966369629,
    "h": 246.267059326172,
    "CMY_C": 0.26064825057983,
    "CMY_M": 0.18197554349899,
    "CMY_Y": 0.13537913560867,
    "CMYK_C": 0.1448832899332,
    "CMYK_M": 0.05389229953289,
    "CMYK_Y": 0,
    "CMYK_K": 0.13537913560867
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0260",
    "Farbtonhilfsbezeichnung": "Mare B3",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "195",
    "Bcolor": "213",
    "Y": 52.3827896118164,
    "L": 77.5091705322266,
    "a": -4.65774202346802,
    "b": -12.4887113571167,
    "C": 13.3290090560913,
    "h": 249.546691894531,
    "CMY_C": 0.33594852685928,
    "CMY_M": 0.2344559431076,
    "CMY_Y": 0.16602647304535,
    "CMYK_C": 0.20374993979931,
    "CMYK_M": 0.08205232769251,
    "CMYK_Y": 0,
    "CMYK_K": 0.16602647304535
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0261",
    "Farbtonhilfsbezeichnung": "Mare B2",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "160",
    "Bcolor": "188",
    "Y": 32.2802505493164,
    "L": 63.5738410949707,
    "a": -7.58099412918091,
    "b": -19.9721736907959,
    "C": 21.3625659942627,
    "h": 249.21435546875,
    "CMY_C": 0.54880082607269,
    "CMY_M": 0.37393516302109,
    "CMY_Y": 0.26430469751358,
    "CMYK_C": 0.38670375943184,
    "CMYK_M": 0.14901612699032,
    "CMYK_Y": 0,
    "CMYK_K": 0.26430469751358
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0262",
    "Farbtonhilfsbezeichnung": "Mare B1",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "120",
    "Bcolor": "156",
    "Y": 16.4768390655518,
    "L": 47.5939750671387,
    "a": -10.2355222702026,
    "b": -26.4161720275879,
    "C": 28.3298435211182,
    "h": 248.820053100586,
    "CMY_C": 0.81063228845596,
    "CMY_M": 0.529128074646,
    "CMY_Y": 0.38923209905624,
    "CMYK_C": 0.68995141983032,
    "CMYK_M": 0.22904932498932,
    "CMYK_Y": 0,
    "CMYK_K": 0.38923209905624
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0263",
    "Farbtonhilfsbezeichnung": "Mare C5",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "217",
    "Bcolor": "221",
    "Y": 68.5702056884766,
    "L": 86.2907791137695,
    "a": -1.78124713897705,
    "b": -3.53361964225769,
    "C": 3.95718455314636,
    "h": 243.247985839844,
    "CMY_C": 0.18020099401474,
    "CMY_M": 0.1476731300354,
    "CMY_Y": 0.13426202535629,
    "CMYK_C": 0.05306336283684,
    "CMYK_M": 0.01549095101655,
    "CMYK_Y": 0,
    "CMYK_K": 0.13426202535629
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0264",
    "Farbtonhilfsbezeichnung": "Mare C4",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "204",
    "Bcolor": "211",
    "Y": 59.4967765808105,
    "L": 81.5638961791992,
    "a": -2.03380680084229,
    "b": -5.37699794769287,
    "C": 5.74878025054932,
    "h": 249.281280517578,
    "CMY_C": 0.24065482616425,
    "CMY_M": 0.19842612743378,
    "CMY_Y": 0.17265927791595,
    "CMYK_C": 0.08218566328287,
    "CMYK_M": 0.03114418126643,
    "CMYK_Y": 0,
    "CMYK_K": 0.17265927791595
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0265",
    "Farbtonhilfsbezeichnung": "Indigo A5",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "219",
    "Bcolor": "229",
    "Y": 70.1457824707031,
    "L": 87.0683135986328,
    "a": -0.47867393493652,
    "b": -6.79264783859253,
    "C": 6.80949306488037,
    "h": 265.969055175781,
    "CMY_C": 0.17336761951447,
    "CMY_M": 0.14113265275955,
    "CMY_Y": 0.10163104534149,
    "CMYK_C": 0.07985201478004,
    "CMYK_M": 0.04397036135197,
    "CMYK_Y": 0,
    "CMYK_K": 0.10163104534149
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0266",
    "Farbtonhilfsbezeichnung": "Indigo A4",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "207",
    "Bcolor": "225",
    "Y": 61.5237731933594,
    "L": 82.6595153808594,
    "a": -0.66918694972992,
    "b": -11.380090713501,
    "C": 11.3997488021851,
    "h": 266.634704589844,
    "CMY_C": 0.24148434400558,
    "CMY_M": 0.18773376941681,
    "CMY_Y": 0.11696147918701,
    "CMYK_C": 0.14101634919643,
    "CMYK_M": 0.0801463201642,
    "CMYK_Y": 0,
    "CMYK_K": 0.11696147918701
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0267",
    "Farbtonhilfsbezeichnung": "Indigo A1",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "120",
    "Bcolor": "178",
    "Y": 17.4627952575684,
    "L": 48.8379440307617,
    "a": -0.91121286153793,
    "b": -37.5757751464844,
    "C": 37.5868225097656,
    "h": 268.61083984375,
    "CMY_C": 0.77905976772308,
    "CMY_M": 0.53006225824356,
    "CMY_Y": 0.30143147706985,
    "CMYK_C": 0.6837243437767,
    "CMYK_M": 0.32728469371796,
    "CMYK_Y": 0,
    "CMYK_K": 0.30143147706985
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0268",
    "Farbtonhilfsbezeichnung": "Indigo B5",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "218",
    "Bcolor": "225",
    "Y": 69.2278137207031,
    "L": 86.6167373657227,
    "a": -0.30941936373711,
    "b": -5.26532220840454,
    "C": 5.27440595626831,
    "h": 266.636840820313,
    "CMY_C": 0.17113471031189,
    "CMY_M": 0.14697861671448,
    "CMY_Y": 0.11779832839966,
    "CMYK_C": 0.06045826524496,
    "CMYK_M": 0.03307666257024,
    "CMYK_Y": 0,
    "CMYK_K": 0.11779832839966
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0269",
    "Farbtonhilfsbezeichnung": "Indigo B4",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "205",
    "Bcolor": "218",
    "Y": 60.5636711120605,
    "L": 82.1436157226563,
    "a": 0.00380619545467,
    "b": -8.12661457061768,
    "C": 8.12661552429199,
    "h": 270.026824951172,
    "CMY_C": 0.22836452722549,
    "CMY_M": 0.19594013690948,
    "CMY_Y": 0.1461552977562,
    "CMYK_C": 0.09628124535084,
    "CMYK_M": 0.05830666795373,
    "CMYK_Y": 0,
    "CMYK_K": 0.1461552977562
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0270",
    "Farbtonhilfsbezeichnung": "Indigo B3",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "193",
    "Bcolor": "211",
    "Y": 52.8427352905273,
    "L": 77.7820587158203,
    "a": -0.00562815321609,
    "b": -11.1691942214966,
    "C": 11.1691951751709,
    "h": 269.971130371094,
    "CMY_C": 0.28766697645187,
    "CMY_M": 0.242316365242,
    "CMY_Y": 0.17197167873383,
    "CMYK_C": 0.13972383737564,
    "CMYK_M": 0.0849544480443,
    "CMYK_Y": 0,
    "CMYK_K": 0.17197167873383
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0271",
    "Farbtonhilfsbezeichnung": "Indigo B1",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "117",
    "Bcolor": "159",
    "Y": 16.8733692169189,
    "L": 48.1000823974609,
    "a": -0.07234204560518,
    "b": -27.7298049926758,
    "C": 27.7298984527588,
    "h": 269.850524902344,
    "CMY_C": 0.68300694227219,
    "CMY_M": 0.54304754734039,
    "CMY_Y": 0.37453329563141,
    "CMYK_C": 0.49318954348564,
    "CMYK_M": 0.26942160725594,
    "CMYK_Y": 0,
    "CMYK_K": 0.37453329563141
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0272",
    "Farbtonhilfsbezeichnung": "Indigo C5",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "217",
    "Bcolor": "220",
    "Y": 68.6804580688477,
    "L": 86.345573425293,
    "a": -0.38376063108444,
    "b": -2.88532328605652,
    "C": 2.91073226928711,
    "h": 262.423889160156,
    "CMY_C": 0.16596132516861,
    "CMY_M": 0.15050333738327,
    "CMY_Y": 0.13822251558304,
    "CMYK_C": 0.03218790143728,
    "CMYK_M": 0.01425057183951,
    "CMYK_Y": 0,
    "CMYK_K": 0.13822251558304
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0273",
    "Farbtonhilfsbezeichnung": "Indigo C4",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "203",
    "Bcolor": "210",
    "Y": 59.6759986877441,
    "L": 81.6617584228516,
    "a": -0.11143670976162,
    "b": -4.5627236366272,
    "C": 4.56408405303955,
    "h": 268.600921630859,
    "CMY_C": 0.22104102373123,
    "CMY_M": 0.20200532674789,
    "CMY_Y": 0.17724043130875,
    "CMYK_C": 0.05323619768023,
    "CMYK_M": 0.03009979613125,
    "CMYK_Y": 0,
    "CMYK_K": 0.17724043130875
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0274",
    "Farbtonhilfsbezeichnung": "Indigo C2",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "152",
    "Bcolor": "169",
    "Y": 30.7680187225342,
    "L": 62.3113136291504,
    "a": -0.43412899971008,
    "b": -11.0722522735596,
    "C": 11.0807600021362,
    "h": 267.754669189453,
    "CMY_C": 0.45295411348343,
    "CMY_M": 0.4048199057579,
    "CMY_Y": 0.33821964263916,
    "CMYK_C": 0.17337243258953,
    "CMYK_M": 0.10063801705837,
    "CMYK_Y": 0,
    "CMYK_K": 0.33821964263916
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0275",
    "Farbtonhilfsbezeichnung": "Indigo C1",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "114",
    "Bcolor": "139",
    "Y": 16.4080314636231,
    "L": 47.5053291320801,
    "a": -0.29454758763313,
    "b": -16.3360958099365,
    "C": 16.3387508392334,
    "h": 268.967041015625,
    "CMY_C": 0.62341392040253,
    "CMY_M": 0.55249357223511,
    "CMY_Y": 0.45545727014542,
    "CMYK_C": 0.30843612551689,
    "CMYK_M": 0.17819777131081,
    "CMYK_Y": 0,
    "CMYK_K": 0.45545727014542
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0276",
    "Farbtonhilfsbezeichnung": "Lilac A5",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "218",
    "Bcolor": "229",
    "Y": 71.5571975708008,
    "L": 87.755012512207,
    "a": 3.77709364891052,
    "b": -5.73310995101929,
    "C": 6.86549234390259,
    "h": 303.377746582031,
    "CMY_C": 0.12759268283844,
    "CMY_M": 0.14398550987244,
    "CMY_Y": 0.10124933719635,
    "CMYK_C": 0.02931107208133,
    "CMYK_M": 0.04755064472556,
    "CMYK_Y": 0,
    "CMYK_K": 0.10124933719635
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0277",
    "Farbtonhilfsbezeichnung": "Lilac A4",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "204",
    "Bcolor": "223",
    "Y": 62.0485076904297,
    "L": 82.939208984375,
    "a": 5.92283773422241,
    "b": -9.74742126464844,
    "C": 11.405797958374,
    "h": 301.2841796875,
    "CMY_C": 0.17848193645477,
    "CMY_M": 0.20079702138901,
    "CMY_Y": 0.12492126226425,
    "CMYK_C": 0.06120669096708,
    "CMYK_M": 0.08670735359192,
    "CMYK_Y": 0,
    "CMYK_K": 0.12492126226425
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0278",
    "Farbtonhilfsbezeichnung": "Lilac A3",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "188",
    "Bcolor": "216",
    "Y": 52.7528533935547,
    "L": 77.7288513183594,
    "a": 8.29117393493652,
    "b": -13.6931095123291,
    "C": 16.0076484680176,
    "h": 301.194885253906,
    "CMY_C": 0.23168814182281,
    "CMY_M": 0.26170694828033,
    "CMY_Y": 0.15349990129471,
    "CMYK_C": 0.0923664867878,
    "CMYK_M": 0.12782874703407,
    "CMYK_Y": 0,
    "CMYK_K": 0.15349990129471
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0279",
    "Farbtonhilfsbezeichnung": "Lilac A2",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "152",
    "Bcolor": "198",
    "Y": 34.0073661804199,
    "L": 64.9684143066406,
    "a": 13.3733797073364,
    "b": -23.2462997436523,
    "C": 26.8186073303223,
    "h": 299.911407470703,
    "CMY_C": 0.36729866266251,
    "CMY_M": 0.40543168783188,
    "CMY_Y": 0.22458297014236,
    "CMYK_C": 0.18405024707317,
    "CMYK_M": 0.23322768509388,
    "CMYK_Y": 0,
    "CMYK_K": 0.22458297014236
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0280",
    "Farbtonhilfsbezeichnung": "Lilac A1",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "108",
    "Bcolor": "174",
    "Y": 17.6684951782227,
    "L": 49.0915412902832,
    "a": 19.7884349822998,
    "b": -34.2595977783203,
    "C": 39.5638999938965,
    "h": 300.010833740234,
    "CMY_C": 0.533666908741,
    "CMY_M": 0.57669055461884,
    "CMY_Y": 0.31925702095032,
    "CMYK_C": 0.31496453285217,
    "CMYK_M": 0.37816554307938,
    "CMYK_Y": 0,
    "CMYK_K": 0.31925702095032
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0281",
    "Farbtonhilfsbezeichnung": "Lilac B5",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "217",
    "Bcolor": "226",
    "Y": 70.4633331298828,
    "L": 87.2236099243164,
    "a": 2.89379382133484,
    "b": -4.62985754013062,
    "C": 5.45981884002686,
    "h": 302.006561279297,
    "CMY_C": 0.13649439811707,
    "CMY_M": 0.14805960655212,
    "CMY_Y": 0.11533665657043,
    "CMYK_C": 0.02391614951193,
    "CMYK_M": 0.03698915615678,
    "CMYK_Y": 0,
    "CMYK_K": 0.11533665657043
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0282",
    "Farbtonhilfsbezeichnung": "Lilac B3",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "191",
    "Bcolor": "210",
    "Y": 53.6067123413086,
    "L": 78.2318496704102,
    "a": 5.71156692504883,
    "b": -9.52874279022217,
    "C": 11.1094074249268,
    "h": 300.938629150391,
    "CMY_C": 0.23065149784088,
    "CMY_M": 0.25138491392136,
    "CMY_Y": 0.17813783884048,
    "CMYK_C": 0.06389594078064,
    "CMYK_M": 0.0891233086586,
    "CMYK_Y": 0,
    "CMYK_K": 0.17813783884048
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0283",
    "Farbtonhilfsbezeichnung": "Lilac B2",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "151",
    "Bcolor": "183",
    "Y": 32.6858329772949,
    "L": 63.9057121276855,
    "a": 9.25279903411865,
    "b": -16.4649982452393,
    "C": 18.8867797851563,
    "h": 299.334594726563,
    "CMY_C": 0.38232064247131,
    "CMY_M": 0.4087501168251,
    "CMY_Y": 0.28327834606171,
    "CMYK_C": 0.13818794488907,
    "CMYK_M": 0.17506346106529,
    "CMYK_Y": 0,
    "CMYK_K": 0.28327834606171
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0284",
    "Farbtonhilfsbezeichnung": "Lilac B1",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "110",
    "Bcolor": "155",
    "Y": 17.4860954284668,
    "L": 48.8667678833008,
    "a": 13.6030139923096,
    "b": -23.4963092803955,
    "C": 27.1499271392822,
    "h": 300.068389892578,
    "CMY_C": 0.53274613618851,
    "CMY_M": 0.56779623031616,
    "CMY_Y": 0.39331436157227,
    "CMYK_C": 0.22982540726662,
    "CMYK_M": 0.28759849071503,
    "CMYK_Y": 0,
    "CMYK_K": 0.39331436157227
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0285",
    "Farbtonhilfsbezeichnung": "Lilac C5",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "216",
    "Bcolor": "222",
    "Y": 69.6960525512695,
    "L": 86.8475723266602,
    "a": 2.36225914955139,
    "b": -3.12104654312134,
    "C": 3.91423034667969,
    "h": 307.121368408203,
    "CMY_C": 0.1395012140274,
    "CMY_M": 0.15138649940491,
    "CMY_Y": 0.13061052560806,
    "CMYK_C": 0.01022635865957,
    "CMYK_M": 0.02389719896019,
    "CMYK_Y": 0,
    "CMYK_K": 0.13061052560806
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0286",
    "Farbtonhilfsbezeichnung": "Lilac C2",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "151",
    "Bcolor": "170",
    "Y": 31.9905509948731,
    "L": 63.335075378418,
    "a": 5.82692575454712,
    "b": -9.85122966766357,
    "C": 11.4455137252808,
    "h": 300.603973388672,
    "CMY_C": 0.38913375139236,
    "CMY_M": 0.40870797634125,
    "CMY_Y": 0.33517014980316,
    "CMYK_C": 0.081169039011,
    "CMYK_M": 0.11061149835587,
    "CMYK_Y": 0,
    "CMYK_K": 0.33517014980316
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0287",
    "Farbtonhilfsbezeichnung": "Lilac C1",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "106",
    "Bcolor": "132",
    "Y": 15.5394239425659,
    "L": 46.3643379211426,
    "a": 8.06576442718506,
    "b": -13.7989988327026,
    "C": 15.9833955764771,
    "h": 300.307067871094,
    "CMY_C": 0.55902409553528,
    "CMY_M": 0.58253157138824,
    "CMY_Y": 0.48265033960342,
    "CMYK_C": 0.14762502908707,
    "CMYK_M": 0.19306330382824,
    "CMYK_Y": 0,
    "CMYK_K": 0.48265033960342
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0289",
    "Farbtonhilfsbezeichnung": "Flanell G5",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "219",
    "Bcolor": "213",
    "Y": 71.085578918457,
    "L": 87.5265655517578,
    "a": 0.22830155491829,
    "b": 2.33472371101379,
    "C": 2.34585952758789,
    "h": 84.4150695800781,
    "CMY_C": 0.1301297545433,
    "CMY_M": 0.14038932323456,
    "CMY_Y": 0.1634663939476,
    "CMYK_C": 0,
    "CMYK_M": 0.0117943668738,
    "CMYK_Y": 0.03832369297743,
    "CMYK_K": 0.1301297545433
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0290",
    "Farbtonhilfsbezeichnung": "Flanell G4",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "203",
    "Bcolor": "198",
    "Y": 59.7952842712402,
    "L": 81.7267913818359,
    "a": 0.09577837586403,
    "b": 1.68620371818542,
    "C": 1.68892168998718,
    "h": 86.7490234375,
    "CMY_C": 0.19704282283783,
    "CMY_M": 0.20356166362762,
    "CMY_Y": 0.22172367572784,
    "CMYK_C": 0,
    "CMYK_M": 0.00811854097992,
    "CMYK_Y": 0.03073744662106,
    "CMYK_K": 0.19704282283783
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0291",
    "Farbtonhilfsbezeichnung": "Flanell G1",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "94",
    "Bcolor": "92",
    "Y": 11.2291593551636,
    "L": 39.9637832641602,
    "a": 0.16033896803856,
    "b": 0.96280694007874,
    "C": 0.97606647014618,
    "h": 80.5451354980469,
    "CMY_C": 0.62690490484238,
    "CMY_M": 0.63106161355972,
    "CMY_Y": 0.63986623287201,
    "CMYK_C": 0,
    "CMYK_M": 0.0111411511898,
    "CMYK_Y": 0.03474001213908,
    "CMYK_K": 0.62690490484238
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0292",
    "Farbtonhilfsbezeichnung": "Carbon G5",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "220",
    "Bcolor": "220",
    "Y": 71.5470504760742,
    "L": 87.7501068115234,
    "a": -0.43613258004189,
    "b": -0.97893190383911,
    "C": 1.07168996334076,
    "h": 245.986129760742,
    "CMY_C": 0.14413207769394,
    "CMY_M": 0.13541632890701,
    "CMY_Y": 0.13676929473877,
    "CMYK_C": 0.01008086185902,
    "CMYK_M": 0,
    "CMYK_Y": 0.00156487547792,
    "CMYK_K": 0.13541632890701
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0293",
    "Farbtonhilfsbezeichnung": "Carbon G2",
    "Farbtonklasse": "01",
    "Rcolor": "141",
    "Gcolor": "143",
    "Bcolor": "145",
    "Y": 27.4259777069092,
    "L": 59.3665657043457,
    "a": -0.38999760150909,
    "b": -2.01158595085144,
    "C": 2.04904270172119,
    "h": 259.027862548828,
    "CMY_C": 0.44895040988922,
    "CMY_M": 0.43778544664383,
    "CMY_Y": 0.43038988113403,
    "CMYK_C": 0.03258461877704,
    "CMYK_M": 0.01298355683684,
    "CMYK_Y": 0,
    "CMYK_K": 0.43038988113403
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA COLOR STUDIO",
    "Farbton_ID": "ALS0294",
    "Farbtonhilfsbezeichnung": "Carbon G1",
    "Farbtonklasse": "02",
    "Rcolor": "92",
    "Gcolor": "95",
    "Bcolor": "96",
    "Y": 11.2888631820679,
    "L": 40.0627937316895,
    "a": -0.64716970920563,
    "b": -1.7804319858551,
    "C": 1.89440405368805,
    "h": 250.024291992188,
    "CMY_C": 0.63968056440353,
    "CMY_M": 0.62782436609268,
    "CMY_Y": 0.62175267934799,
    "CMYK_C": 0.04739725589752,
    "CMYK_M": 0.01605216041207,
    "CMYK_Y": 0,
    "CMYK_K": 0.62175267934799
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV0001",
    "Farbtonhilfsbezeichnung": "Rotbraun",
    "Farbtonklasse": "03",
    "Y": 9,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1438",
    "Farbtonhilfsbezeichnung": "Avagruen",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "84",
    "Y": 10.2333660125732,
    "L": 38.2580490112305,
    "a": -30.525146484375,
    "b": 2.54230499267578,
    "C": 30.6308326721191,
    "h": 175.239074707031,
    "CMY_C": 1,
    "CMY_M": 0.59787666797638,
    "CMY_Y": 0.66900265216827,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.17687603831291,
    "CMYK_K": 0.59787666797638
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1439",
    "Farbtonhilfsbezeichnung": "Avagelb",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "0",
    "Y": 65.1748504638672,
    "L": 84.5737533569336,
    "a": 7.31542682647705,
    "b": 86.3167343139648,
    "C": 86.6261749267578,
    "h": 85.1557006835938,
    "CMY_C": 0,
    "CMY_M": 0.20422494411469,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.20422494411469,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1441",
    "Farbtonhilfsbezeichnung": "Avaorange",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "90",
    "Bcolor": "45",
    "Y": 25.6109008789063,
    "L": 57.6658592224121,
    "a": 55.344841003418,
    "b": 53.4532089233398,
    "C": 76.9434661865234,
    "h": 44.0039215087891,
    "CMY_C": 0.06718331575394,
    "CMY_M": 0.64804995059967,
    "CMY_Y": 0.82412111759186,
    "CMYK_C": 0,
    "CMYK_M": 0.6227018237114,
    "CMYK_Y": 0.81145399808884,
    "CMYK_K": 0.06718331575394
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1442",
    "Farbtonhilfsbezeichnung": "Avarotbraun",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "72",
    "Bcolor": "62",
    "Y": 10,
    "L": 38.4053726196289,
    "a": 26.3368053436279,
    "b": 18.181453704834,
    "C": 32.0030097961426,
    "h": 34.6190223693848,
    "CMY_C": 0.46417343616486,
    "CMY_M": 0.71612560749054,
    "CMY_Y": 0.75792503356934,
    "CMYK_C": 0,
    "CMYK_M": 0.47021216154099,
    "CMYK_Y": 0.54822140932083,
    "CMYK_K": 0.46417343616486
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1445",
    "Farbtonhilfsbezeichnung": "Avagruengelb",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "221",
    "Bcolor": "23",
    "Y": 72.1077575683594,
    "L": 88.0204315185547,
    "a": -6.70432472229004,
    "b": 85.0085296630859,
    "C": 85.2724914550781,
    "h": 94.5093841552734,
    "CMY_C": 0.02096003293991,
    "CMY_M": 0.13275516033173,
    "CMY_Y": 0.91153538227081,
    "CMYK_C": 0,
    "CMYK_M": 0.11418852210045,
    "CMYK_Y": 0.90964144468307,
    "CMYK_K": 0.02096003293991
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1446",
    "Farbtonhilfsbezeichnung": "Avaocker",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "130",
    "Bcolor": "70",
    "Y": 26.547607421875,
    "L": 58.5532302856445,
    "a": 15.3092021942139,
    "b": 39.4784965515137,
    "C": 42.3429260253906,
    "h": 68.8044128417969,
    "CMY_C": 0.27625930309296,
    "CMY_M": 0.49202311038971,
    "CMY_Y": 0.72354280948639,
    "CMYK_C": 0,
    "CMYK_M": 0.29812309145927,
    "CMYK_Y": 0.61801624298096,
    "CMYK_K": 0.27625930309296
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1447",
    "Farbtonhilfsbezeichnung": "Avaviolett",
    "Farbtonklasse": "04",
    "Y": 7,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1450",
    "Farbtonhilfsbezeichnung": "Avaumbra",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "86",
    "Bcolor": "66",
    "Y": 10,
    "L": 37.3683700561523,
    "a": 2.39805698394775,
    "b": 13.3798456192017,
    "C": 13.5930480957031,
    "h": 79.8388214111328,
    "CMY_C": 0.6093008518219,
    "CMY_M": 0.66268801689148,
    "CMY_Y": 0.74142956733704,
    "CMYK_C": 0,
    "CMYK_M": 0.13664519786835,
    "CMYK_Y": 0.33818531036377,
    "CMYK_K": 0.6093008518219
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1452",
    "Farbtonhilfsbezeichnung": "Avaschwarz",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "64",
    "Bcolor": "63",
    "Y": 5,
    "L": 26.9636688232422,
    "a": 0.23779572546482,
    "b": 0.0691981986165,
    "C": 0.24765944480896,
    "h": 16.2249164581299,
    "CMY_C": 0.74845254421234,
    "CMY_M": 0.75041925907135,
    "CMY_Y": 0.75272005796432,
    "CMYK_C": 0,
    "CMYK_M": 0.00781846418977,
    "CMYK_Y": 0.01696504466236,
    "CMYK_K": 0.74845254421234
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1454",
    "Farbtonhilfsbezeichnung": "Avadunkelbraun",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "72",
    "Bcolor": "65",
    "Y": 7.58067750930786,
    "L": 33.0938758850098,
    "a": 10.0946531295776,
    "b": 8.17419242858887,
    "C": 12.9892053604126,
    "h": 38.9989852905273,
    "CMY_C": 0.61675924062729,
    "CMY_M": 0.71808624267578,
    "CMY_Y": 0.74588626623154,
    "CMYK_C": 0,
    "CMYK_M": 0.26439514756203,
    "CMYK_Y": 0.33693447709084,
    "CMYK_K": 0.61675924062729
  },
  {
    "Farbtonkarten_Bezeichnung": "ALPINA VOLLTOENE",
    "Farbton_ID": "ALV1455",
    "Farbtonhilfsbezeichnung": "Ava Blau",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "79",
    "Bcolor": "119",
    "Y": 7.40354347229004,
    "L": 32.7084770202637,
    "a": 0.48681405186653,
    "b": -27.5659847259521,
    "C": 27.5702838897705,
    "h": 271.01171875,
    "CMY_C": 0.83818590641022,
    "CMY_M": 0.69033348560333,
    "CMY_Y": 0.53200221061707,
    "CMYK_C": 0.65424174070358,
    "CMYK_M": 0.33831629157066,
    "CMYK_Y": 0,
    "CMYK_K": 0.53200221061707
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0001",
    "Farbtonhilfsbezeichnung": "81.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "241",
    "Bcolor": "212",
    "Y": 83,
    "L": 93.7809906005859,
    "a": -7.40149450302124,
    "b": 11.8670387268066,
    "C": 13.9860191345215,
    "h": 121.951866149902,
    "CMY_C": 0.0898819565773,
    "CMY_M": 0.05548822879791,
    "CMY_Y": 0.16691052913666,
    "CMYK_C": 0.03641429170966,
    "CMYK_M": 0,
    "CMYK_Y": 0.11796814203262,
    "CMYK_K": 0.05548822879791
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0002",
    "Farbtonhilfsbezeichnung": "81.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "230",
    "Bcolor": "202",
    "Y": 74,
    "L": 89.721549987793,
    "a": -8.10873222351074,
    "b": 11.3486490249634,
    "C": 13.9478807449341,
    "h": 125.546211242676,
    "CMY_C": 0.14230465888977,
    "CMY_M": 0.09925693273544,
    "CMY_Y": 0.20732694864273,
    "CMYK_C": 0.04779135063291,
    "CMYK_M": 0,
    "CMYK_Y": 0.11997874081135,
    "CMYK_K": 0.09925693273544
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0004",
    "Farbtonhilfsbezeichnung": "03.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 67,
    "L": 85.2965774536133,
    "a": -0.84123939275742,
    "b": 4.55694913864136,
    "C": 4.63394737243652,
    "h": 100.459381103516,
    "CMY_C": 0.15583109855652,
    "CMY_M": 0.16308009624481,
    "CMY_Y": 0.20416152477264,
    "CMYK_C": 0,
    "CMYK_M": 0.00858714152128,
    "CMYK_Y": 0.05725207924843,
    "CMYK_K": 0.15583109855652
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0005",
    "Farbtonhilfsbezeichnung": "93.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "243",
    "Bcolor": "203",
    "Y": 88,
    "L": 95.4576950073242,
    "a": -4.11128330230713,
    "b": 19.1247730255127,
    "C": 19.5616874694824,
    "h": 102.13232421875,
    "CMY_C": 0.02414178848267,
    "CMY_M": 0.04593747854233,
    "CMY_Y": 0.20266431570053,
    "CMYK_C": 0,
    "CMYK_M": 0.0223348941654,
    "CMYK_Y": 0.1829390078783,
    "CMYK_K": 0.02414178848267
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0006",
    "Farbtonhilfsbezeichnung": "87.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "237",
    "Bcolor": "223",
    "Y": 84,
    "L": 93.5944671630859,
    "a": -1.38712453842163,
    "b": 6.11786794662476,
    "C": 6.27315092086792,
    "h": 102.774871826172,
    "CMY_C": 0.06273686885834,
    "CMY_M": 0.07002699375153,
    "CMY_Y": 0.12509036064148,
    "CMYK_C": 0,
    "CMYK_M": 0.00777809834108,
    "CMYK_Y": 0.06652720272541,
    "CMYK_K": 0.06273686885834
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0007",
    "Farbtonhilfsbezeichnung": "15.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "220",
    "Bcolor": "185",
    "Y": 76,
    "L": 89.8122863769531,
    "a": 7.19484043121338,
    "b": 20.6060047149658,
    "C": 21.8259735107422,
    "h": 70.7527236938477,
    "CMY_C": 0.00268143415451,
    "CMY_M": 0.13679432868958,
    "CMY_Y": 0.2725818157196,
    "CMYK_C": 0,
    "CMYK_M": 0.13447347283363,
    "CMYK_Y": 0.27062603831291,
    "CMYK_K": 0.00268143415451
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0008",
    "Farbtonhilfsbezeichnung": "18.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "159",
    "Bcolor": "114",
    "Y": 44,
    "L": 72.4735946655273,
    "a": 25.7872829437256,
    "b": 34.772216796875,
    "C": 43.290771484375,
    "h": 53.4391479492188,
    "CMY_C": 0.06063199043274,
    "CMY_M": 0.37755823135376,
    "CMY_Y": 0.5513209104538,
    "CMYK_C": 0,
    "CMYK_M": 0.33738240599632,
    "CMYK_Y": 0.52236068248749,
    "CMYK_K": 0.06063199043274
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0009",
    "Farbtonhilfsbezeichnung": "18.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "128",
    "Bcolor": "76",
    "Y": 31,
    "L": 62.6292419433594,
    "a": 31.6835708618164,
    "b": 42.3207359313965,
    "C": 52.8667526245117,
    "h": 53.1795043945313,
    "CMY_C": 0.13594341278076,
    "CMY_M": 0.49934542179108,
    "CMY_Y": 0.7006464600563,
    "CMYK_C": 0,
    "CMYK_M": 0.42057663202286,
    "CMYK_Y": 0.65354865789413,
    "CMYK_K": 0.13594341278076
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0010",
    "Farbtonhilfsbezeichnung": "24.15.21",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "106",
    "Bcolor": "84",
    "Y": 26,
    "L": 56.1283149719238,
    "a": 38.2776412963867,
    "b": 29.7716426849365,
    "C": 48.492561340332,
    "h": 37.8751182556152,
    "CMY_C": 0.19037288427353,
    "CMY_M": 0.58613169193268,
    "CMY_Y": 0.67010736465454,
    "CMYK_C": 0,
    "CMYK_M": 0.48881614208221,
    "CMYK_Y": 0.59253758192062,
    "CMYK_K": 0.19037288427353
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0011",
    "Farbtonhilfsbezeichnung": "06.18.09",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "206",
    "Bcolor": "103",
    "Y": 65,
    "L": 84.7940979003906,
    "a": 4.46731853485107,
    "b": 55.8753814697266,
    "C": 56.0536804199219,
    "h": 85.428840637207,
    "CMY_C": 0.0176215171814,
    "CMY_M": 0.19152611494064,
    "CMY_Y": 0.59798127412796,
    "CMYK_C": 0,
    "CMYK_M": 0.17702403664589,
    "CMYK_Y": 0.59077000617981,
    "CMYK_K": 0.0176215171814
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0012",
    "Farbtonhilfsbezeichnung": "27.12.21",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "123",
    "Bcolor": "109",
    "Y": 25,
    "L": 57.4112014770508,
    "a": 21.63307762146,
    "b": 16.6467361450195,
    "C": 27.2965908050537,
    "h": 37.5784187316895,
    "CMY_C": 0.2839492559433,
    "CMY_M": 0.51670014858246,
    "CMY_Y": 0.57254332304001,
    "CMYK_C": 0,
    "CMYK_M": 0.32504802942276,
    "CMYK_Y": 0.40303578972816,
    "CMYK_K": 0.2839492559433
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0013",
    "Farbtonhilfsbezeichnung": "75.15.18",
    "Farbtonklasse": "01",
    "Rcolor": "119",
    "Gcolor": "167",
    "Bcolor": "157",
    "Y": 34,
    "L": 65.1139526367188,
    "a": -17.9165287017822,
    "b": -0.69685393571854,
    "C": 17.9300746917725,
    "h": 182.227355957031,
    "CMY_C": 0.53168350458145,
    "CMY_M": 0.34345656633377,
    "CMY_Y": 0.38255196809769,
    "CMYK_C": 0.28669381141663,
    "CMYK_M": 0,
    "CMYK_Y": 0.05954732000828,
    "CMYK_K": 0.34345656633377
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0014",
    "Farbtonhilfsbezeichnung": "81.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "181",
    "Bcolor": "174",
    "Y": 45,
    "L": 72.8318176269531,
    "a": -3.57469272613525,
    "b": 2.04759049415588,
    "C": 4.11959409713745,
    "h": 150.195846557617,
    "CMY_C": 0.31972271203995,
    "CMY_M": 0.29127705097198,
    "CMY_Y": 0.31955409049988,
    "CMYK_C": 0.04013650491834,
    "CMYK_M": 0,
    "CMYK_Y": 0.03989858180285,
    "CMYK_K": 0.29127705097198
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0015",
    "Farbtonhilfsbezeichnung": "93.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "226",
    "Bcolor": "205",
    "Y": 75,
    "L": 89.5741271972656,
    "a": -1.8859977722168,
    "b": 9.72996234893799,
    "C": 9.91106224060059,
    "h": 100.969841003418,
    "CMY_C": 0.10038554668427,
    "CMY_M": 0.11470049619675,
    "CMY_Y": 0.19598394632339,
    "CMYK_C": 0,
    "CMYK_M": 0.01591231673956,
    "CMYK_Y": 0.10626596957445,
    "CMYK_K": 0.10038554668427
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0016",
    "Farbtonhilfsbezeichnung": "75.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "232",
    "Bcolor": "224",
    "Y": 76,
    "L": 89.9871063232422,
    "a": -10.1556386947632,
    "b": 0.29481711983681,
    "C": 10.1599168777466,
    "h": 178.337188720703,
    "CMY_C": 0.19516253471375,
    "CMY_M": 0.088882625103,
    "CMY_Y": 0.1228289604187,
    "CMYK_C": 0.11664787679911,
    "CMYK_M": 0,
    "CMYK_Y": 0.03725791722536,
    "CMYK_K": 0.088882625103
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0017",
    "Farbtonhilfsbezeichnung": "24.24.21",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "83",
    "Bcolor": "54",
    "Y": 20,
    "L": 53.1820640563965,
    "a": 50.974925994873,
    "b": 43.3122825622559,
    "C": 66.8909301757813,
    "h": 40.3538284301758,
    "CMY_C": 0.15058821439743,
    "CMY_M": 0.67268896102905,
    "CMY_Y": 0.78830516338348,
    "CMYK_C": 0,
    "CMYK_M": 0.61466151475906,
    "CMYK_Y": 0.75077480077744,
    "CMYK_K": 0.15058821439743
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0018",
    "Farbtonhilfsbezeichnung": "21.18.21",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "107",
    "Bcolor": "44",
    "Y": 30,
    "L": 60.1203269958496,
    "a": 45.8517723083496,
    "b": 55.9046669006348,
    "C": 72.3029479980469,
    "h": 50.6421546936035,
    "CMY_C": 0.08252608776093,
    "CMY_M": 0.57893991470337,
    "CMY_Y": 0.82788640260696,
    "CMYK_C": 0,
    "CMYK_M": 0.54106587171555,
    "CMYK_Y": 0.81240493059158,
    "CMYK_K": 0.08252608776093
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0019",
    "Farbtonhilfsbezeichnung": "18.24.18",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "131",
    "Bcolor": "38",
    "Y": 36,
    "L": 67.280158996582,
    "a": 40.6031761169434,
    "b": 65.2050552368164,
    "C": 76.8135223388672,
    "h": 58.0894889831543,
    "CMY_C": 0.01465529203415,
    "CMY_M": 0.48520958423615,
    "CMY_Y": 0.84944355487823,
    "CMYK_C": 0,
    "CMYK_M": 0.47755298018456,
    "CMYK_Y": 0.84720426797867,
    "CMYK_K": 0.01465529203415
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0020",
    "Farbtonhilfsbezeichnung": "15.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "150",
    "Bcolor": "52",
    "Y": 41,
    "L": 71.0965805053711,
    "a": 30.3393497467041,
    "b": 63.5054969787598,
    "C": 70.3805694580078,
    "h": 64.4641571044922,
    "CMY_C": 0.0233119726181,
    "CMY_M": 0.41027718782425,
    "CMY_Y": 0.79668855667114,
    "CMYK_C": 0,
    "CMYK_M": 0.39620146155357,
    "CMYK_Y": 0.79183584451675,
    "CMYK_K": 0.0233119726181
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0021",
    "Farbtonhilfsbezeichnung": "12.21.15",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "155",
    "Bcolor": "0",
    "Y": 46,
    "L": 73.2881240844727,
    "a": 31.1514434814453,
    "b": 85.7356109619141,
    "C": 91.2195587158203,
    "h": 70.0317306518555,
    "CMY_C": 0,
    "CMY_M": 0.39188724756241,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.39188724756241,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0022",
    "Farbtonhilfsbezeichnung": "09.24.15",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "170",
    "Bcolor": "0",
    "Y": 50,
    "L": 76.5658874511719,
    "a": 23.093282699585,
    "b": 79.8938140869141,
    "C": 83.164421081543,
    "h": 73.8780822753906,
    "CMY_C": 0,
    "CMY_M": 0.33230012655258,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.33230012655258,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0023",
    "Farbtonhilfsbezeichnung": "06.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "180",
    "Bcolor": "30",
    "Y": 54,
    "L": 78.9448471069336,
    "a": 18.0075225830078,
    "b": 77.136474609375,
    "C": 79.2105178833008,
    "h": 76.8596267700195,
    "CMY_C": 0,
    "CMY_M": 0.29232466220856,
    "CMY_Y": 0.88200157880783,
    "CMYK_C": 0,
    "CMYK_M": 0.29232466220856,
    "CMYK_Y": 0.88200157880783,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0024",
    "Farbtonhilfsbezeichnung": "03.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "40",
    "Y": 62,
    "L": 83.2531509399414,
    "a": 9.37110710144043,
    "b": 78.2805786132813,
    "C": 78.8395004272461,
    "h": 83.1735076904297,
    "CMY_C": 0,
    "CMY_M": 0.22311180830002,
    "CMY_Y": 0.84411144256592,
    "CMYK_C": 0,
    "CMYK_M": 0.22311180830002,
    "CMYK_Y": 0.84411144256592,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0025",
    "Farbtonhilfsbezeichnung": "27.24.24",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "44",
    "Bcolor": "39",
    "Y": 14,
    "L": 41.8692436218262,
    "a": 55.7805976867676,
    "b": 37.891170501709,
    "C": 67.4330444335938,
    "h": 34.1878509521484,
    "CMY_C": 0.26982080936432,
    "CMY_M": 0.82718873023987,
    "CMY_Y": 0.84708100557327,
    "CMYK_C": 0,
    "CMYK_M": 0.76333034038544,
    "CMYK_Y": 0.79057335853577,
    "CMYK_K": 0.26982080936432
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0026",
    "Farbtonhilfsbezeichnung": "30.24.24",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "65",
    "Bcolor": "72",
    "Y": 11,
    "L": 41.1795043945313,
    "a": 41.4389305114746,
    "b": 16.1822948455811,
    "C": 44.4865341186523,
    "h": 21.3311157226563,
    "CMY_C": 0.3617537021637,
    "CMY_M": 0.74621188640594,
    "CMY_Y": 0.71726858615875,
    "CMYK_C": 0,
    "CMYK_M": 0.60236650705338,
    "CMYK_Y": 0.55701833963394,
    "CMYK_K": 0.3617537021637
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0027",
    "Farbtonhilfsbezeichnung": "33.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "68",
    "Bcolor": "85",
    "Y": 14,
    "L": 44.8713989257813,
    "a": 47.1397438049316,
    "b": 13.5232257843018,
    "C": 49.0411376953125,
    "h": 16.0068740844727,
    "CMY_C": 0.29468512535095,
    "CMY_M": 0.73428606987,
    "CMY_Y": 0.66567361354828,
    "CMYK_C": 0,
    "CMYK_M": 0.62326908111572,
    "CMYK_Y": 0.52598989009857,
    "CMYK_K": 0.29468512535095
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0028",
    "Farbtonhilfsbezeichnung": "36.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "67",
    "Bcolor": "112",
    "Y": 14,
    "L": 43.6866264343262,
    "a": 46.5101509094238,
    "b": -4.80351781845093,
    "C": 46.7575454711914,
    "h": 354.103454589844,
    "CMY_C": 0.3377680182457,
    "CMY_M": 0.73645293712616,
    "CMY_Y": 0.56181085109711,
    "CMYK_C": 0,
    "CMYK_M": 0.60203212499619,
    "CMYK_Y": 0.3383147418499,
    "CMYK_K": 0.3377680182457
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0029",
    "Farbtonhilfsbezeichnung": "39.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "73",
    "Bcolor": "123",
    "Y": 12,
    "L": 42.2395324707031,
    "a": 39.2440299987793,
    "b": -13.984827041626,
    "C": 41.6613655090332,
    "h": 340.386199951172,
    "CMY_C": 0.41041547060013,
    "CMY_M": 0.71511191129684,
    "CMY_Y": 0.51911896467209,
    "CMYK_C": 0,
    "CMYK_M": 0.51679855585098,
    "CMYK_Y": 0.18437303602695,
    "CMYK_K": 0.41041547060013
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0030",
    "Farbtonhilfsbezeichnung": "42.21.27",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "75",
    "Bcolor": "120",
    "Y": 9,
    "L": 38.5729637145996,
    "a": 27.5394420623779,
    "b": -18.4873523712158,
    "C": 33.1693077087402,
    "h": 326.126373291016,
    "CMY_C": 0.52633452415466,
    "CMY_M": 0.70677947998047,
    "CMY_Y": 0.52837455272675,
    "CMYK_C": 0,
    "CMYK_M": 0.38095441460609,
    "CMYK_Y": 0.00430689752102,
    "CMYK_K": 0.52633452415466
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0031",
    "Farbtonhilfsbezeichnung": "45.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "82",
    "Bcolor": "132",
    "Y": 9,
    "L": 38.3492622292538,
    "a": 18.0815382302013,
    "b": -26.5144404541196,
    "C": 32.0929521447511,
    "h": -0.97228705231204,
    "CMY_C": 0.6179096,
    "CMY_M": 0.6782029,
    "CMY_Y": 0.4809023,
    "CMYK_C": 0.2639335,
    "CMYK_M": 0.3800837,
    "CMYK_Y": 0,
    "CMYK_K": 0.4809023
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0032",
    "Farbtonhilfsbezeichnung": "48.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "91",
    "Bcolor": "150",
    "Y": 12,
    "L": 42.4911842346191,
    "a": 19.8898963928223,
    "b": -30.7060470581055,
    "C": 36.5850982666016,
    "h": 302.933227539063,
    "CMY_C": 0.5826712846756,
    "CMY_M": 0.64209020137787,
    "CMY_Y": 0.41164237260818,
    "CMYK_C": 0.29068869352341,
    "CMYK_M": 0.39167985320091,
    "CMYK_Y": 0,
    "CMYK_K": 0.41164237260818
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0033",
    "Farbtonhilfsbezeichnung": "72.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "118",
    "Y": 15,
    "L": 43.6212730407715,
    "a": -33.1558418273926,
    "b": -10.2889556884766,
    "C": 34.7155952453613,
    "h": 197.240219116211,
    "CMY_C": 1,
    "CMY_M": 0.53825008869171,
    "CMY_Y": 0.53618407249451,
    "CMYK_C": 1,
    "CMYK_M": 0.00445438828319,
    "CMYK_Y": 0,
    "CMYK_K": 0.53618407249451
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0034",
    "Farbtonhilfsbezeichnung": "69.24.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "143",
    "Y": 15,
    "L": 46.3200531005859,
    "a": -28.8777580261231,
    "b": -20.8270053863525,
    "C": 35.604621887207,
    "h": 215.799621582031,
    "CMY_C": 1,
    "CMY_M": 0.51395523548126,
    "CMY_Y": 0.44037592411041,
    "CMYK_C": 1,
    "CMYK_M": 0.13147988915443,
    "CMYK_Y": 0,
    "CMYK_K": 0.44037592411041
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0035",
    "Farbtonhilfsbezeichnung": "66.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "160",
    "Y": 15,
    "L": 46.3418655395508,
    "a": -20.3519725799561,
    "b": -31.1753234863281,
    "C": 37.230411529541,
    "h": 236.862564086914,
    "CMY_C": 1,
    "CMY_M": 0.52293074131012,
    "CMY_Y": 0.37153697013855,
    "CMYK_C": 1,
    "CMYK_M": 0.24089527130127,
    "CMYK_Y": 0,
    "CMYK_K": 0.37153697013855
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0036",
    "Farbtonhilfsbezeichnung": "63.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "174",
    "Y": 18,
    "L": 47.9950180053711,
    "a": -13.9776802062988,
    "b": -36.3817672729492,
    "C": 38.9744606018066,
    "h": 248.983489990234,
    "CMY_C": 1,
    "CMY_M": 0.5148246884346,
    "CMY_Y": 0.31922268867493,
    "CMYK_C": 1,
    "CMYK_M": 0.2873215675354,
    "CMYK_Y": 0,
    "CMYK_K": 0.31922268867493
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0037",
    "Farbtonhilfsbezeichnung": "60.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "121",
    "Bcolor": "175",
    "Y": 17,
    "L": 47.8101005554199,
    "a": -7.83825254440308,
    "b": -37.6432991027832,
    "C": 38.4506988525391,
    "h": 258.237701416016,
    "CMY_C": 1,
    "CMY_M": 0.52693557739258,
    "CMY_Y": 0.31238251924515,
    "CMYK_C": 1,
    "CMYK_M": 0.31202384829521,
    "CMYK_Y": 0,
    "CMYK_K": 0.31238251924515
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0038",
    "Farbtonhilfsbezeichnung": "57.21.27",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "103",
    "Bcolor": "155",
    "Y": 13,
    "L": 42.4426422119141,
    "a": 0.77021026611328,
    "b": -33.947078704834,
    "C": 33.9558143615723,
    "h": 271.299743652344,
    "CMY_C": 0.78952634334564,
    "CMY_M": 0.5970653295517,
    "CMY_Y": 0.39255356788635,
    "CMYK_C": 0.65351074934006,
    "CMYK_M": 0.33667457103729,
    "CMYK_Y": 0,
    "CMYK_K": 0.39255356788635
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0039",
    "Farbtonhilfsbezeichnung": "54.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "78",
    "Bcolor": "107",
    "Y": 10,
    "L": 36.4091300964355,
    "a": 14.9670839309692,
    "b": -13.7720355987549,
    "C": 20.3391876220703,
    "h": 317.381134033203,
    "CMY_C": 0.6096476316452,
    "CMY_M": 0.69333732128143,
    "CMY_Y": 0.58018755912781,
    "CMYK_C": 0.07017436623573,
    "CMYK_M": 0.26952454447746,
    "CMYK_Y": 0,
    "CMYK_K": 0.58018755912781
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0040",
    "Farbtonhilfsbezeichnung": "51.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "88",
    "Bcolor": "137",
    "Y": 10,
    "L": 39.1415367126465,
    "a": 12.5530347824097,
    "b": -28.0545692443848,
    "C": 30.734956741333,
    "h": 294.106170654297,
    "CMY_C": 0.65905117988586,
    "CMY_M": 0.65636944770813,
    "CMY_Y": 0.46354752779007,
    "CMYK_C": 0.36443796753883,
    "CMYK_M": 0.35943895578384,
    "CMYK_Y": 0,
    "CMYK_K": 0.46354752779007
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0041",
    "Farbtonhilfsbezeichnung": "75.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "117",
    "Bcolor": "100",
    "Y": 13,
    "L": 43.0806846618652,
    "a": -35.9559440612793,
    "b": -0.12321207672358,
    "C": 35.9561538696289,
    "h": 180.196334838867,
    "CMY_C": 1,
    "CMY_M": 0.54241967201233,
    "CMY_Y": 0.60722476243973,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.14162559807301,
    "CMYK_K": 0.54241967201233
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0042",
    "Farbtonhilfsbezeichnung": "78.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "97",
    "Y": 16,
    "L": 47.7194747924805,
    "a": -41.937671661377,
    "b": 8.54770088195801,
    "C": 42.7999000549316,
    "h": 168.47981262207,
    "CMY_C": 1,
    "CMY_M": 0.48930329084396,
    "CMY_Y": 0.62050461769104,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.25690653920174,
    "CMYK_K": 0.48930329084396
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0043",
    "Farbtonhilfsbezeichnung": "81.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "152",
    "Bcolor": "85",
    "Y": 23,
    "L": 55.3834266662598,
    "a": -47.9320411682129,
    "b": 25.6251544952393,
    "C": 54.3519020080566,
    "h": 151.870407104492,
    "CMY_C": 0.8958300948143,
    "CMY_M": 0.40436595678329,
    "CMY_Y": 0.66626268625259,
    "CMYK_C": 0.825110912323,
    "CMYK_M": 0,
    "CMYK_Y": 0.43969401717186,
    "CMYK_K": 0.40436595678329
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0044",
    "Farbtonhilfsbezeichnung": "84.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "166",
    "Bcolor": "51",
    "Y": 32,
    "L": 63.4023017883301,
    "a": -30.2644653320313,
    "b": 52.1987800598145,
    "C": 60.3378028869629,
    "h": 120.104835510254,
    "CMY_C": 0.50137591362,
    "CMY_M": 0.34864002466202,
    "CMY_Y": 0.79855275154114,
    "CMYK_C": 0.23448768258095,
    "CMYK_M": 0,
    "CMYK_Y": 0.69072824716568,
    "CMYK_K": 0.34864002466202
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0045",
    "Farbtonhilfsbezeichnung": "87.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "188",
    "Bcolor": "51",
    "Y": 45,
    "L": 73.0393905639648,
    "a": -21.2731666564941,
    "b": 62.8309059143066,
    "C": 66.3345336914063,
    "h": 108.704971313477,
    "CMY_C": 0.31570708751678,
    "CMY_M": 0.26309537887573,
    "CMY_Y": 0.79840731620789,
    "CMYK_C": 0.07139554619789,
    "CMYK_M": 0,
    "CMYK_Y": 0.72643315792084,
    "CMYK_K": 0.26309537887573
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0046",
    "Farbtonhilfsbezeichnung": "90.18.12",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "206",
    "Bcolor": "51",
    "Y": 57,
    "L": 81.2123641967773,
    "a": -13.3926935195923,
    "b": 71.8279266357422,
    "C": 73.0658264160156,
    "h": 100.561820983887,
    "CMY_C": 0.15831273794174,
    "CMY_M": 0.19143325090408,
    "CMY_Y": 0.80129897594452,
    "CMYK_C": 0,
    "CMYK_M": 0.03935014083982,
    "CMYK_Y": 0.76392537355423,
    "CMYK_K": 0.15831273794174
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0047",
    "Farbtonhilfsbezeichnung": "93.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "211",
    "Bcolor": "43",
    "Y": 64,
    "L": 84.881462097168,
    "a": -3.72790741920471,
    "b": 78.2549209594727,
    "C": 78.3436660766602,
    "h": 92.7273941040039,
    "CMY_C": 0.04545432329178,
    "CMY_M": 0.17341923713684,
    "CMY_Y": 0.83257329463959,
    "CMYK_C": 0,
    "CMYK_M": 0.13405844569206,
    "CMYK_Y": 0.82460063695908,
    "CMYK_K": 0.04545432329178
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0048",
    "Farbtonhilfsbezeichnung": "96.24.12",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "212",
    "Bcolor": "48",
    "Y": 67,
    "L": 86.2219467163086,
    "a": 0.26042723655701,
    "b": 78.3604202270508,
    "C": 78.3608551025391,
    "h": 89.8095855712891,
    "CMY_C": 0.00369906425476,
    "CMY_M": 0.16820996999741,
    "CMY_Y": 0.81172698736191,
    "CMYK_C": 0,
    "CMYK_M": 0.16512170433998,
    "CMYK_Y": 0.81102794408798,
    "CMYK_K": 0.00369906425476
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0049",
    "Farbtonhilfsbezeichnung": "03.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "231",
    "Bcolor": "223",
    "Y": 82,
    "L": 91.5627822875977,
    "a": -0.10538398474455,
    "b": 3.14804744720459,
    "C": 3.14981079101563,
    "h": 91.9173202514648,
    "CMY_C": 0.08513456583023,
    "CMY_M": 0.09498852491379,
    "CMY_Y": 0.12521350383759,
    "CMYK_C": 0,
    "CMYK_M": 0.0107709383592,
    "CMYK_Y": 0.04380856081843,
    "CMYK_K": 0.08513456583023
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0050",
    "Farbtonhilfsbezeichnung": "03.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "225",
    "Bcolor": "213",
    "Y": 75,
    "L": 89.512565612793,
    "a": -0.08353075385094,
    "b": 5.6628155708313,
    "C": 5.6634316444397,
    "h": 90.8450927734375,
    "CMY_C": 0.09975636005402,
    "CMY_M": 0.11855733394623,
    "CMY_Y": 0.16631919145584,
    "CMYK_C": 0,
    "CMYK_M": 0.02088431827724,
    "CMYK_Y": 0.07393868267536,
    "CMYK_K": 0.09975636005402
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0051",
    "Farbtonhilfsbezeichnung": "03.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "196",
    "Bcolor": "185",
    "Y": 55,
    "L": 79.1309661865234,
    "a": -0.29085916280746,
    "b": 4.94356250762939,
    "C": 4.95211172103882,
    "h": 93.3671722412109,
    "CMY_C": 0.21787786483765,
    "CMY_M": 0.23173803091049,
    "CMY_Y": 0.27310353517532,
    "CMYK_C": 0,
    "CMYK_M": 0.01772123016417,
    "CMYK_Y": 0.07061003148556,
    "CMYK_K": 0.21787786483765
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0052",
    "Farbtonhilfsbezeichnung": "03.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 47,
    "L": 72.896842956543,
    "a": -0.03216871991754,
    "b": 5.14293718338013,
    "C": 5.14303779602051,
    "h": 90.3583755493164,
    "CMY_C": 0.28253388404846,
    "CMY_M": 0.29929167032242,
    "CMY_Y": 0.34028834104538,
    "CMYK_C": 0,
    "CMYK_M": 0.02335690334439,
    "CMYK_Y": 0.08049781620502,
    "CMYK_K": 0.28253388404846
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0053",
    "Farbtonhilfsbezeichnung": "03.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "142",
    "Bcolor": "133",
    "Y": 29,
    "L": 59.1291465759277,
    "a": -0.15005597472191,
    "b": 4.64374256134033,
    "C": 4.64616632461548,
    "h": 91.8507843017578,
    "CMY_C": 0.42907625436783,
    "CMY_M": 0.44244557619095,
    "CMY_Y": 0.4778938293457,
    "CMYK_C": 0,
    "CMYK_M": 0.02341700159013,
    "CMYK_Y": 0.08550629764795,
    "CMYK_K": 0.42907625436783
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0054",
    "Farbtonhilfsbezeichnung": "03.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "210",
    "Y": 83,
    "L": 92.7742309570312,
    "a": -0.1713712066412,
    "b": 11.6808423995972,
    "C": 11.6820993423462,
    "h": 90.8405303955078,
    "CMY_C": 0.04562318325043,
    "CMY_M": 0.08356767892838,
    "CMY_Y": 0.17538672685623,
    "CMYK_C": 0,
    "CMYK_M": 0.03975839912891,
    "CMYK_Y": 0.13596677780151,
    "CMYK_K": 0.04562318325043
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0055",
    "Farbtonhilfsbezeichnung": "03.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "222",
    "Bcolor": "197",
    "Y": 74,
    "L": 88.6538162231445,
    "a": 0.13875317573547,
    "b": 12.7125978469849,
    "C": 12.7133550643921,
    "h": 89.3746643066406,
    "CMY_C": 0.08674013614655,
    "CMY_M": 0.13043439388275,
    "CMY_Y": 0.22768348455429,
    "CMYK_C": 0,
    "CMYK_M": 0.04784427583218,
    "CMYK_Y": 0.15432995557785,
    "CMYK_K": 0.08674013614655
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0056",
    "Farbtonhilfsbezeichnung": "03.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "203",
    "Bcolor": "178",
    "Y": 61,
    "L": 82.0606002807617,
    "a": 0.2828660607338,
    "b": 13.2922668457031,
    "C": 13.2952766418457,
    "h": 88.7808990478516,
    "CMY_C": 0.15751278400421,
    "CMY_M": 0.20335334539413,
    "CMY_Y": 0.30233412981033,
    "CMYK_C": 0,
    "CMYK_M": 0.05441098660231,
    "CMYK_Y": 0.17189738154411,
    "CMYK_K": 0.15751278400421
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0057",
    "Farbtonhilfsbezeichnung": "03.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "171",
    "Bcolor": "150",
    "Y": 43,
    "L": 70.370735168457,
    "a": 0.51801431179047,
    "b": 11.301441192627,
    "C": 11.3133068084717,
    "h": 87.375617980957,
    "CMY_C": 0.28835898637772,
    "CMY_M": 0.32882452011108,
    "CMY_Y": 0.40986162424088,
    "CMYK_C": 0,
    "CMYK_M": 0.05686228349805,
    "CMYK_Y": 0.17073585093021,
    "CMYK_K": 0.28835898637772
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0058",
    "Farbtonhilfsbezeichnung": "03.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "147",
    "Bcolor": "124",
    "Y": 30,
    "L": 61.4703025817871,
    "a": 1.14532899856567,
    "b": 13.5801105499268,
    "C": 13.6283226013184,
    "h": 85.1791610717773,
    "CMY_C": 0.37279731035233,
    "CMY_M": 0.42340481281281,
    "CMY_Y": 0.51541423797607,
    "CMYK_C": 0,
    "CMYK_M": 0.08068763464689,
    "CMYK_Y": 0.22738571465015,
    "CMYK_K": 0.37279731035233
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0059",
    "Farbtonhilfsbezeichnung": "03.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "203",
    "Y": 84,
    "L": 93.1337814331055,
    "a": 0.43391439318657,
    "b": 15.9795255661011,
    "C": 15.9854154586792,
    "h": 88.4445495605469,
    "CMY_C": 0.02496457099915,
    "CMY_M": 0.08206802606583,
    "CMY_Y": 0.20348733663559,
    "CMYK_C": 0,
    "CMYK_M": 0.05856551975012,
    "CMYK_Y": 0.18309362232685,
    "CMYK_K": 0.02496457099915
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0060",
    "Farbtonhilfsbezeichnung": "03.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "227",
    "Bcolor": "191",
    "Y": 76,
    "L": 90.8225250244141,
    "a": 0.82994782924652,
    "b": 18.8780994415283,
    "C": 18.896333694458,
    "h": 87.4826965332031,
    "CMY_C": 0.04071444272995,
    "CMY_M": 0.10949850082397,
    "CMY_Y": 0.25001907348633,
    "CMYK_C": 0,
    "CMYK_M": 0.0717034265399,
    "CMYK_Y": 0.2181880325079,
    "CMYK_K": 0.04071444272995
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0061",
    "Farbtonhilfsbezeichnung": "03.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "212",
    "Bcolor": "160",
    "Y": 67,
    "L": 85.4875030517578,
    "a": 0.8403816819191,
    "b": 27.9260501861572,
    "C": 27.9386920928955,
    "h": 88.2763061523438,
    "CMY_C": 0.08011728525162,
    "CMY_M": 0.17044162750244,
    "CMY_Y": 0.37395960092545,
    "CMYK_C": 0,
    "CMYK_M": 0.09819114953279,
    "CMYK_Y": 0.31943455338478,
    "CMYK_K": 0.08011728525162
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0062",
    "Farbtonhilfsbezeichnung": "03.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "200",
    "Bcolor": "146",
    "Y": 59,
    "L": 81.4050903320313,
    "a": 1.79442453384399,
    "b": 29.2434730529785,
    "C": 29.2984752655029,
    "h": 86.488639831543,
    "CMY_C": 0.11711895465851,
    "CMY_M": 0.2175173163414,
    "CMY_Y": 0.42589592933655,
    "CMYK_C": 0,
    "CMYK_M": 0.11371675133705,
    "CMYK_Y": 0.34973791241646,
    "CMYK_K": 0.11711895465851
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0063",
    "Farbtonhilfsbezeichnung": "03.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "172",
    "Bcolor": "124",
    "Y": 43,
    "L": 71.2843856811523,
    "a": 1.76249825954437,
    "b": 27.2918910980225,
    "C": 27.3487434387207,
    "h": 86.3049926757813,
    "CMY_C": 0.23419398069382,
    "CMY_M": 0.32540029287338,
    "CMY_Y": 0.51433569192886,
    "CMYK_C": 0,
    "CMYK_M": 0.11909845471382,
    "CMYK_Y": 0.36581289768219,
    "CMYK_K": 0.23419398069382
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0064",
    "Farbtonhilfsbezeichnung": "03.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "146",
    "Bcolor": "104",
    "Y": 30,
    "L": 61.4438095092773,
    "a": 2.42416477203369,
    "b": 24.5790576934814,
    "C": 24.6983127593994,
    "h": 84.3672866821289,
    "CMY_C": 0.34204691648483,
    "CMY_M": 0.42874121665955,
    "CMY_Y": 0.59181082248688,
    "CMYK_C": 0,
    "CMYK_M": 0.13176365196705,
    "CMYK_Y": 0.37960746884346,
    "CMYK_K": 0.34204691648483
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0065",
    "Farbtonhilfsbezeichnung": "03.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "232",
    "Bcolor": "185",
    "Y": 83,
    "L": 92.5485763549805,
    "a": -0.52418398857117,
    "b": 24.4935512542725,
    "C": 24.4991588592529,
    "h": 91.2259979248047,
    "CMY_C": 0.0170191526413,
    "CMY_M": 0.08828294277191,
    "CMY_Y": 0.27386051416397,
    "CMYK_C": 0,
    "CMYK_M": 0.07249763607979,
    "CMYK_Y": 0.26128825545311,
    "CMYK_K": 0.0170191526413
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0066",
    "Farbtonhilfsbezeichnung": "03.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "223",
    "Bcolor": "162",
    "Y": 75,
    "L": 89.6139526367188,
    "a": 1.22516059875488,
    "b": 32.5917816162109,
    "C": 32.6147994995117,
    "h": 87.8471984863281,
    "CMY_C": 0.02050006389618,
    "CMY_M": 0.12681216001511,
    "CMY_Y": 0.36578661203384,
    "CMYK_C": 0,
    "CMYK_M": 0.10853711515665,
    "CMYK_Y": 0.35251307487488,
    "CMYK_K": 0.02050006389618
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0067",
    "Farbtonhilfsbezeichnung": "03.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "214",
    "Bcolor": "142",
    "Y": 69,
    "L": 86.6726760864258,
    "a": 1.61997509002686,
    "b": 38.904857635498,
    "C": 38.9385719299316,
    "h": 87.6156158447266,
    "CMY_C": 0.03980308771133,
    "CMY_M": 0.16138333082199,
    "CMY_Y": 0.44444566965103,
    "CMYK_C": 0,
    "CMYK_M": 0.12662011384964,
    "CMYK_Y": 0.42141625285149,
    "CMYK_K": 0.03980308771133
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0068",
    "Farbtonhilfsbezeichnung": "03.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "202",
    "Bcolor": "127",
    "Y": 58,
    "L": 82.5445785522461,
    "a": 1.66139662265778,
    "b": 40.7964668273926,
    "C": 40.8302803039551,
    "h": 87.66796875,
    "CMY_C": 0.08396911621094,
    "CMY_M": 0.20691049098969,
    "CMY_Y": 0.50134181976318,
    "CMYK_C": 0,
    "CMYK_M": 0.13421094417572,
    "CMYK_Y": 0.45563170313835,
    "CMYK_K": 0.08396911621094
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0069",
    "Farbtonhilfsbezeichnung": "03.12.15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "171",
    "Bcolor": "101",
    "Y": 42,
    "L": 71.5862197875977,
    "a": 4.11672115325928,
    "b": 39.756893157959,
    "C": 39.9694633483887,
    "h": 84.0882415771484,
    "CMY_C": 0.19489872455597,
    "CMY_M": 0.32987624406815,
    "CMY_Y": 0.60282003879547,
    "CMYK_C": 0,
    "CMYK_M": 0.16765284538269,
    "CMYK_Y": 0.50667083263397,
    "CMYK_K": 0.19489872455597
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0070",
    "Farbtonhilfsbezeichnung": "03.12.18",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "153",
    "Bcolor": "90",
    "Y": 33,
    "L": 65.0178909301758,
    "a": 4.71960163116455,
    "b": 37.0660934448242,
    "C": 37.3653564453125,
    "h": 82.7436065673828,
    "CMY_C": 0.26874160766602,
    "CMY_M": 0.39938771724701,
    "CMY_Y": 0.64672470092773,
    "CMYK_C": 0,
    "CMYK_M": 0.1786592900753,
    "CMYK_Y": 0.51689404249191,
    "CMYK_K": 0.26874160766602
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0071",
    "Farbtonhilfsbezeichnung": "03.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "128",
    "Y": 75,
    "L": 89.5273056030273,
    "a": 2.66331839561462,
    "b": 49.7204170227051,
    "C": 49.7916984558105,
    "h": 86.9338302612305,
    "CMY_C": 0,
    "CMY_M": 0.13427770137787,
    "CMY_Y": 0.49938356876373,
    "CMYK_C": 0,
    "CMYK_M": 0.13427770137787,
    "CMYK_Y": 0.49938356876373,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0072",
    "Farbtonhilfsbezeichnung": "03.15.09",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "107",
    "Y": 68,
    "L": 86.4189453125,
    "a": 5.14843606948853,
    "b": 55.8736305236816,
    "C": 56.1103286743164,
    "h": 84.7353897094727,
    "CMY_C": 0,
    "CMY_M": 0.17548358440399,
    "CMY_Y": 0.58097773790359,
    "CMYK_C": 0,
    "CMYK_M": 0.17548358440399,
    "CMYK_Y": 0.58097773790359,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0073",
    "Farbtonhilfsbezeichnung": "03.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "88",
    "Y": 66,
    "L": 85.528938293457,
    "a": 6.15887260437012,
    "b": 63.561580657959,
    "C": 63.8592681884766,
    "h": 84.4655380249023,
    "CMY_C": 0,
    "CMY_M": 0.18871980905533,
    "CMY_Y": 0.6565750837326,
    "CMYK_C": 0,
    "CMYK_M": 0.18871980905533,
    "CMYK_Y": 0.6565750837326,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0074",
    "Farbtonhilfsbezeichnung": "03.15.15",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "175",
    "Bcolor": "58",
    "Y": 48,
    "L": 73.6712493896484,
    "a": 4.53090381622314,
    "b": 62.5299339294434,
    "C": 62.6938743591309,
    "h": 85.8556060791016,
    "CMY_C": 0.14165443181992,
    "CMY_M": 0.31177335977554,
    "CMY_Y": 0.77426022291183,
    "CMYK_C": 0,
    "CMYK_M": 0.19819398224354,
    "CMYK_Y": 0.73700594902039,
    "CMYK_K": 0.14165443181992
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0075",
    "Farbtonhilfsbezeichnung": "03.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "167",
    "Bcolor": "36",
    "Y": 42,
    "L": 71.36962890625,
    "a": 7.31547546386719,
    "b": 67.7722320556641,
    "C": 68.1659088134766,
    "h": 83.839225769043,
    "CMY_C": 0.14790695905685,
    "CMY_M": 0.34326803684235,
    "CMY_Y": 0.85989516973495,
    "CMYK_C": 0,
    "CMYK_M": 0.2292720079422,
    "CMYK_Y": 0.83557564020157,
    "CMYK_K": 0.14790695905685
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0076",
    "Farbtonhilfsbezeichnung": "03.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "193",
    "Bcolor": "48",
    "Y": 56,
    "L": 80.6811828613281,
    "a": 6.62019157409668,
    "b": 73.3369064331055,
    "C": 73.6351089477539,
    "h": 84.8418350219727,
    "CMY_C": 0.03576004505157,
    "CMY_M": 0.24334532022476,
    "CMY_Y": 0.81266486644745,
    "CMYK_C": 0,
    "CMYK_M": 0.2152838408947,
    "CMYK_Y": 0.80571728944778,
    "CMYK_K": 0.03576004505157
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0077",
    "Farbtonhilfsbezeichnung": "03.18.18",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "183",
    "Bcolor": "0",
    "Y": 54,
    "L": 77.8007583618164,
    "a": 10.1476984024048,
    "b": 85.6617279052734,
    "C": 86.2606964111328,
    "h": 83.2440872192383,
    "CMY_C": 0.04170560836792,
    "CMY_M": 0.28404051065445,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.25288146734238,
    "CMYK_Y": 1,
    "CMYK_K": 0.04170560836792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0078",
    "Farbtonhilfsbezeichnung": "03.21.12",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "204",
    "Bcolor": "57",
    "Y": 65,
    "L": 84.9831771850586,
    "a": 7.21090173721313,
    "b": 74.7253189086914,
    "C": 75.0724334716797,
    "h": 84.4880981445313,
    "CMY_C": 0,
    "CMY_M": 0.19852501153946,
    "CMY_Y": 0.77570921182632,
    "CMYK_C": 0,
    "CMYK_M": 0.19852501153946,
    "CMYK_Y": 0.77570921182632,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0079",
    "Farbtonhilfsbezeichnung": "03.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "180",
    "Bcolor": "0",
    "Y": 53,
    "L": 77.1095657348633,
    "a": 11.2186546325684,
    "b": 84.307373046875,
    "C": 85.0505218505859,
    "h": 82.4202651977539,
    "CMY_C": 0.04469525814056,
    "CMY_M": 0.29405683279037,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.26102828979492,
    "CMYK_Y": 1,
    "CMYK_K": 0.04469525814056
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0080",
    "Farbtonhilfsbezeichnung": "06.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "217",
    "Y": 80,
    "L": 92.3055114746094,
    "a": 0.12360382825136,
    "b": 7.37434864044189,
    "C": 7.37538433074951,
    "h": 89.0397415161133,
    "CMY_C": 0.06154525279999,
    "CMY_M": 0.0883903503418,
    "CMY_Y": 0.14839780330658,
    "CMYK_C": 0,
    "CMYK_M": 0.02860563807189,
    "CMYK_Y": 0.09254846721888,
    "CMYK_K": 0.06154525279999
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0081",
    "Farbtonhilfsbezeichnung": "06.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "216",
    "Bcolor": "196",
    "Y": 71,
    "L": 86.7390060424805,
    "a": 0.20114064216614,
    "b": 10.2127895355225,
    "C": 10.2147703170776,
    "h": 88.871711730957,
    "CMY_C": 0.11478024721146,
    "CMY_M": 0.15111649036407,
    "CMY_Y": 0.22987949848175,
    "CMYK_C": 0,
    "CMYK_M": 0.04104771092534,
    "CMYK_Y": 0.13002336025238,
    "CMYK_K": 0.11478024721146
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0082",
    "Farbtonhilfsbezeichnung": "06.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "210",
    "Bcolor": "189",
    "Y": 64,
    "L": 84.4319229125977,
    "a": 0.56939309835434,
    "b": 10.7294912338257,
    "C": 10.7445888519287,
    "h": 86.962272644043,
    "CMY_C": 0.13621014356613,
    "CMY_M": 0.17748129367828,
    "CMY_Y": 0.25836980342865,
    "CMYK_C": 0,
    "CMYK_M": 0.04777915403247,
    "CMYK_Y": 0.14142289757729,
    "CMYK_K": 0.13621014356613
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0083",
    "Farbtonhilfsbezeichnung": "06.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "194",
    "Bcolor": "170",
    "Y": 55,
    "L": 78.7158737182617,
    "a": 0.72071784734726,
    "b": 12.7941875457764,
    "C": 12.814471244812,
    "h": 86.7758407592773,
    "CMY_C": 0.19251072406769,
    "CMY_M": 0.24053728580475,
    "CMY_Y": 0.33389317989349,
    "CMYK_C": 0,
    "CMYK_M": 0.05947640910745,
    "CMYK_Y": 0.1750889569521,
    "CMYK_K": 0.19251072406769
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0084",
    "Farbtonhilfsbezeichnung": "06.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "182",
    "Bcolor": "156",
    "Y": 47,
    "L": 74.4216766357422,
    "a": 0.64057272672653,
    "b": 14.1441173553467,
    "C": 14.1586151123047,
    "h": 87.4069061279297,
    "CMY_C": 0.2364793419838,
    "CMY_M": 0.28677046298981,
    "CMY_Y": 0.38830834627151,
    "CMYK_C": 0,
    "CMYK_M": 0.06586740165949,
    "CMYK_Y": 0.19885382056236,
    "CMYK_K": 0.2364793419838
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0085",
    "Farbtonhilfsbezeichnung": "06.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "148",
    "Bcolor": "125",
    "Y": 30,
    "L": 61.8863906860352,
    "a": 1.46093082427979,
    "b": 13.436164855957,
    "C": 13.5153560638428,
    "h": 83.7945327758789,
    "CMY_C": 0.36664718389511,
    "CMY_M": 0.41980707645416,
    "CMY_Y": 0.51024550199509,
    "CMYK_C": 0,
    "CMYK_M": 0.08393409103155,
    "CMYK_Y": 0.22672721743584,
    "CMYK_K": 0.36664718389511
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0086",
    "Farbtonhilfsbezeichnung": "06.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "212",
    "Y": 81,
    "L": 92.5942459106445,
    "a": 0.89084732532501,
    "b": 10.5112009048462,
    "C": 10.5488843917847,
    "h": 85.1556396484375,
    "CMY_C": 0.0430251955986,
    "CMY_M": 0.08782768249512,
    "CMY_Y": 0.16846638917923,
    "CMYK_C": 0,
    "CMYK_M": 0.0468167886138,
    "CMYK_Y": 0.13108098506927,
    "CMYK_K": 0.0430251955986
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0087",
    "Farbtonhilfsbezeichnung": "06.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "221",
    "Bcolor": "188",
    "Y": 73,
    "L": 88.866943359375,
    "a": 2.26265954971313,
    "b": 18.01979637146,
    "C": 18.1612968444824,
    "h": 82.8431015014648,
    "CMY_C": 0.05469799041748,
    "CMY_M": 0.13444972038269,
    "CMY_Y": 0.26434248685837,
    "CMYK_C": 0,
    "CMYK_M": 0.08436640352011,
    "CMYK_Y": 0.22177514433861,
    "CMYK_K": 0.05469799041748
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0088",
    "Farbtonhilfsbezeichnung": "06.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "204",
    "Bcolor": "164",
    "Y": 61,
    "L": 83.1174011230469,
    "a": 3.14384388923645,
    "b": 22.2829036712646,
    "C": 22.503589630127,
    "h": 81.9692764282227,
    "CMY_C": 0.10330450534821,
    "CMY_M": 0.20069319009781,
    "CMY_Y": 0.35648566484451,
    "CMYK_C": 0,
    "CMYK_M": 0.10860842466354,
    "CMYK_Y": 0.28234907984734,
    "CMYK_K": 0.10330450534821
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0089",
    "Farbtonhilfsbezeichnung": "06.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "153",
    "Y": 59,
    "L": 79.7566070556641,
    "a": 2.6715931892395,
    "b": 23.6829071044922,
    "C": 23.8331184387207,
    "h": 83.563850402832,
    "CMY_C": 0.14124798774719,
    "CMY_M": 0.23633241653442,
    "CMY_Y": 0.4017745256424,
    "CMYK_C": 0,
    "CMYK_M": 0.11072396486998,
    "CMYK_Y": 0.30337807536125,
    "CMYK_K": 0.14124798774719
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0090",
    "Farbtonhilfsbezeichnung": "06.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "174",
    "Bcolor": "127",
    "Y": 44,
    "L": 72.717529296875,
    "a": 5.02269315719604,
    "b": 27.8071899414063,
    "C": 28.2571620941162,
    "h": 79.7613067626953,
    "CMY_C": 0.19603228569031,
    "CMY_M": 0.31805521249771,
    "CMY_Y": 0.50304025411606,
    "CMYK_C": 0,
    "CMYK_M": 0.15177591145039,
    "CMYK_Y": 0.38186603784561,
    "CMYK_K": 0.19603228569031
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0091",
    "Farbtonhilfsbezeichnung": "06.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "144",
    "Bcolor": "104",
    "Y": 28,
    "L": 61.2081413269043,
    "a": 4.02363061904907,
    "b": 24.1023998260498,
    "C": 24.435941696167,
    "h": 80.5224914550781,
    "CMY_C": 0.33534234762192,
    "CMY_M": 0.43473279476166,
    "CMY_Y": 0.59043371677399,
    "CMYK_C": 0,
    "CMYK_M": 0.14953629672527,
    "CMYK_Y": 0.38379362225533,
    "CMYK_K": 0.33534234762192
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0092",
    "Farbtonhilfsbezeichnung": "06.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "228",
    "Bcolor": "190",
    "Y": 77,
    "L": 90.9900436401367,
    "a": -0.05091834813356,
    "b": 19.5598373413086,
    "C": 19.5599040985107,
    "h": 90.1491546630859,
    "CMY_C": 0.04350602626801,
    "CMY_M": 0.10568207502365,
    "CMY_Y": 0.25346297025681,
    "CMYK_C": 0,
    "CMYK_M": 0.06500411778688,
    "CMYK_Y": 0.21950681507587,
    "CMYK_K": 0.04350602626801
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0093",
    "Farbtonhilfsbezeichnung": "06.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "224",
    "Bcolor": "171",
    "Y": 76,
    "L": 90.2277526855469,
    "a": 2.30427527427673,
    "b": 28.4605598449707,
    "C": 28.5536880493164,
    "h": 85.371208190918,
    "CMY_C": 0.01453244686127,
    "CMY_M": 0.12179201841354,
    "CMY_Y": 0.32787936925888,
    "CMYK_C": 0,
    "CMYK_M": 0.10884130001068,
    "CMYK_Y": 0.31796777248383,
    "CMYK_K": 0.01453244686127
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0094",
    "Farbtonhilfsbezeichnung": "06.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "202",
    "Bcolor": "145",
    "Y": 61,
    "L": 82.8804321289063,
    "a": 3.92577624320984,
    "b": 31.980827331543,
    "C": 32.2208786010742,
    "h": 83.0017242431641,
    "CMY_C": 0.08063107728958,
    "CMY_M": 0.20715075731277,
    "CMY_Y": 0.43063682317734,
    "CMYK_C": 0,
    "CMYK_M": 0.13761578500271,
    "CMYK_Y": 0.3807021677494,
    "CMYK_K": 0.08063107728958
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0095",
    "Farbtonhilfsbezeichnung": "06.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "190",
    "Bcolor": "123",
    "Y": 54,
    "L": 79.1984405517578,
    "a": 6.38089418411255,
    "b": 38.7073135375977,
    "C": 39.2297325134277,
    "h": 80.6389923095703,
    "CMY_C": 0.09513252973557,
    "CMY_M": 0.25420808792114,
    "CMY_Y": 0.51820695400238,
    "CMYK_C": 0,
    "CMYK_M": 0.17579984664917,
    "CMYK_Y": 0.46755403280258,
    "CMYK_K": 0.09513252973557
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0096",
    "Farbtonhilfsbezeichnung": "06.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "173",
    "Bcolor": "105",
    "Y": 45,
    "L": 73.2996826171875,
    "a": 8.7492618560791,
    "b": 40.3802604675293,
    "C": 41.3172492980957,
    "h": 77.7745971679688,
    "CMY_C": 0.14559465646744,
    "CMY_M": 0.3232359290123,
    "CMY_Y": 0.58933746814728,
    "CMYK_C": 0,
    "CMYK_M": 0.20791217684746,
    "CMYK_Y": 0.51935863494873,
    "CMYK_K": 0.14559465646744
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0097",
    "Farbtonhilfsbezeichnung": "06.12.18",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "149",
    "Bcolor": "92",
    "Y": 32,
    "L": 63.8372383117676,
    "a": 6.92954063415527,
    "b": 34.5002746582031,
    "C": 35.1893081665039,
    "h": 78.6429901123047,
    "CMY_C": 0.27202939987183,
    "CMY_M": 0.41642743349075,
    "CMY_Y": 0.63865315914154,
    "CMYK_C": 0,
    "CMYK_M": 0.19835695624352,
    "CMYK_Y": 0.50362437963486,
    "CMYK_K": 0.27202939987183
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0098",
    "Farbtonhilfsbezeichnung": "06.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "223",
    "Bcolor": "154",
    "Y": 74,
    "L": 89.7011893084049,
    "a": 0.52584497062113,
    "b": 36.5366688175697,
    "C": 36.5404526684865,
    "h": 1.5564050676888,
    "CMY_C": 0.01656994,
    "CMY_M": 0.1249564,
    "CMY_Y": 0.3950807,
    "CMYK_C": 0,
    "CMYK_M": 0.1102127,
    "CMYK_Y": 0.3848883,
    "CMYK_K": 0.01656994
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0099",
    "Farbtonhilfsbezeichnung": "06.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "204",
    "Bcolor": "121",
    "Y": 65,
    "L": 84.2880172729492,
    "a": 6.79580450057983,
    "b": 46.460636138916,
    "C": 46.9550170898438,
    "h": 81.678352355957,
    "CMY_C": 0.02140688896179,
    "CMY_M": 0.20146226882935,
    "CMY_Y": 0.52620053291321,
    "CMYK_C": 0,
    "CMYK_M": 0.18399411439896,
    "CMYK_Y": 0.51583606004715,
    "CMYK_K": 0.02140688896179
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0100",
    "Farbtonhilfsbezeichnung": "06.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "188",
    "Bcolor": "98",
    "Y": 55,
    "L": 79.251106262207,
    "a": 8.76417350769043,
    "b": 51.4762496948242,
    "C": 52.2169990539551,
    "h": 80.3376617431641,
    "CMY_C": 0.06166648864746,
    "CMY_M": 0.2615886926651,
    "CMY_Y": 0.61676853895187,
    "CMYK_C": 0,
    "CMYK_M": 0.21306093037128,
    "CMYK_Y": 0.59158289432526,
    "CMYK_K": 0.06166648864746
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0101",
    "Farbtonhilfsbezeichnung": "06.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "167",
    "Bcolor": "69",
    "Y": 43,
    "L": 72.1471557617188,
    "a": 11.326337814331,
    "b": 56.2395858764648,
    "C": 57.368782043457,
    "h": 78.6132659912109,
    "CMY_C": 0.12483900785446,
    "CMY_M": 0.34409147500992,
    "CMY_Y": 0.72783386707306,
    "CMYK_C": 0,
    "CMYK_M": 0.25052815675735,
    "CMYK_Y": 0.68901020288467,
    "CMYK_K": 0.12483900785446
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0102",
    "Farbtonhilfsbezeichnung": "06.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "150",
    "Bcolor": "52",
    "Y": 33,
    "L": 65.4013977050781,
    "a": 11.1172933578491,
    "b": 56.2791709899902,
    "C": 57.3667106628418,
    "h": 78.8257522583008,
    "CMY_C": 0.20526891946793,
    "CMY_M": 0.41357803344727,
    "CMY_Y": 0.79784369468689,
    "CMYK_C": 0,
    "CMYK_M": 0.26211270689964,
    "CMYK_Y": 0.74562931060791,
    "CMYK_K": 0.20526891946793
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0103",
    "Farbtonhilfsbezeichnung": "06.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "192",
    "Bcolor": "94",
    "Y": 57,
    "L": 80.8006362915039,
    "a": 9.62522029876709,
    "b": 55.1672515869141,
    "C": 56.0006294250488,
    "h": 80.10302734375,
    "CMY_C": 0.03357940912247,
    "CMY_M": 0.24765002727509,
    "CMY_Y": 0.63116466999054,
    "CMYK_C": 0,
    "CMYK_M": 0.22150875627995,
    "CMYK_Y": 0.61834907531738,
    "CMYK_K": 0.03357940912247
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0104",
    "Farbtonhilfsbezeichnung": "06.18.15",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "162",
    "Bcolor": "31",
    "Y": 43,
    "L": 70.6586227416992,
    "a": 12.9521856307983,
    "b": 68.7174758911133,
    "C": 69.9274673461914,
    "h": 79.3258590698242,
    "CMY_C": 0.1228883266449,
    "CMY_M": 0.36514139175415,
    "CMY_Y": 0.87774759531021,
    "CMYK_C": 0,
    "CMYK_M": 0.27619409561157,
    "CMYK_Y": 0.86061936616898,
    "CMYK_K": 0.1228883266449
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0105",
    "Farbtonhilfsbezeichnung": "06.18.18",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "144",
    "Bcolor": "21",
    "Y": 33,
    "L": 63.9073448181152,
    "a": 13.0794849395752,
    "b": 64.8718032836914,
    "C": 66.1772155761719,
    "h": 78.6008224487305,
    "CMY_C": 0.20538210868835,
    "CMY_M": 0.4347215294838,
    "CMY_Y": 0.91728174686432,
    "CMYK_C": 0,
    "CMYK_M": 0.28861597180367,
    "CMYK_Y": 0.89590185880661,
    "CMYK_K": 0.20538210868835
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0106",
    "Farbtonhilfsbezeichnung": "06.21.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "205",
    "Bcolor": "94",
    "Y": 65,
    "L": 84.9713134765625,
    "a": 7.47796869277954,
    "b": 59.9138412475586,
    "C": 60.3787078857422,
    "h": 82.8855895996094,
    "CMY_C": 0,
    "CMY_M": 0.19767099618912,
    "CMY_Y": 0.62949192523956,
    "CMYK_C": 0,
    "CMYK_M": 0.19767099618912,
    "CMYK_Y": 0.62949192523956,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0107",
    "Farbtonhilfsbezeichnung": "06.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "159",
    "Bcolor": "0",
    "Y": 42,
    "L": 70.1446228027344,
    "a": 15.6888074874878,
    "b": 74.9969024658203,
    "C": 76.6203231811523,
    "h": 78.1845245361328,
    "CMY_C": 0.1096168756485,
    "CMY_M": 0.3782747387886,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.30173286795616,
    "CMYK_Y": 1,
    "CMYK_K": 0.1096168756485
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0108",
    "Farbtonhilfsbezeichnung": "09.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "221",
    "Y": 80,
    "L": 92.4537486610962,
    "a": -0.74687825000618,
    "b": 5.35004566088653,
    "C": 5.40192703522577,
    "h": -1.43209054023682,
    "CMY_C": 0.0730157,
    "CMY_M": 0.08414751,
    "CMY_Y": 0.1318449,
    "CMYK_C": 0,
    "CMYK_M": 0.01200863,
    "CMYK_Y": 0.06346302,
    "CMYK_K": 0.0730157
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0109",
    "Farbtonhilfsbezeichnung": "09.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "231",
    "Bcolor": "217",
    "Y": 80,
    "L": 91.8413772583008,
    "a": 0.42208728194237,
    "b": 7.03081703186035,
    "C": 7.04347562789917,
    "h": 86.5644378662109,
    "CMY_C": 0.0655305981636,
    "CMY_M": 0.09419637918472,
    "CMY_Y": 0.15088981389999,
    "CMYK_C": 0,
    "CMYK_M": 0.03067599795759,
    "CMYK_Y": 0.09134511649609,
    "CMYK_K": 0.0655305981636
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0110",
    "Farbtonhilfsbezeichnung": "09.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "210",
    "Y": 76,
    "L": 89.4290924072266,
    "a": 0.63705593347549,
    "b": 6.92993974685669,
    "C": 6.95915985107422,
    "h": 84.7476654052734,
    "CMY_C": 0.09123533964157,
    "CMY_M": 0.12153494358063,
    "CMY_Y": 0.17648160457611,
    "CMYK_C": 0,
    "CMYK_M": 0.03334153071046,
    "CMYK_Y": 0.09380455315113,
    "CMYK_K": 0.09123533964157
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0111",
    "Farbtonhilfsbezeichnung": "09.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "213",
    "Bcolor": "198",
    "Y": 66,
    "L": 85.4747772216797,
    "a": 1.05738532543182,
    "b": 7.52438020706177,
    "C": 7.59831285476685,
    "h": 82.0007247924805,
    "CMY_C": 0.1303004026413,
    "CMY_M": 0.16636681556702,
    "CMY_Y": 0.22365897893906,
    "CMYK_C": 0,
    "CMYK_M": 0.04146996513009,
    "CMYK_Y": 0.10734577476978,
    "CMYK_K": 0.1303004026413
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0112",
    "Farbtonhilfsbezeichnung": "09.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "199",
    "Bcolor": "180",
    "Y": 57,
    "L": 80.5463180541992,
    "a": 0.94698965549469,
    "b": 9.75934314727783,
    "C": 9.80518054962158,
    "h": 84.4577026367188,
    "CMY_C": 0.17905831336975,
    "CMY_M": 0.22050756216049,
    "CMY_Y": 0.29263001680374,
    "CMYK_C": 0,
    "CMYK_M": 0.0504898801446,
    "CMYK_Y": 0.13834320008755,
    "CMYK_K": 0.17905831336975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0113",
    "Farbtonhilfsbezeichnung": "09.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "180",
    "Bcolor": "160",
    "Y": 46,
    "L": 74.1196975708008,
    "a": 1.88719463348389,
    "b": 11.2662353515625,
    "C": 11.4232025146484,
    "h": 80.4907302856445,
    "CMY_C": 0.23837006092072,
    "CMY_M": 0.29219955205917,
    "CMY_Y": 0.37071681022644,
    "CMYK_C": 0,
    "CMYK_M": 0.07067669928074,
    "CMYK_Y": 0.17376779019833,
    "CMYK_K": 0.23837006092072
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0114",
    "Farbtonhilfsbezeichnung": "09.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "148",
    "Bcolor": "130",
    "Y": 30,
    "L": 61.8305892944336,
    "a": 2.03208661079407,
    "b": 10.3672142028809,
    "C": 10.5644931793213,
    "h": 78.9100036621094,
    "CMY_C": 0.37078273296356,
    "CMY_M": 0.42097675800323,
    "CMY_Y": 0.48960947990417,
    "CMYK_C": 0,
    "CMYK_M": 0.07977216690779,
    "CMYK_Y": 0.18884851038456,
    "CMYK_K": 0.37078273296356
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0115",
    "Farbtonhilfsbezeichnung": "09.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "233",
    "Bcolor": "207",
    "Y": 83,
    "L": 92.8743624594944,
    "a": 1.97272706493579,
    "b": 13.3396093166246,
    "C": 13.4846886798661,
    "h": 1.42397555554618,
    "CMY_C": 0.02371424,
    "CMY_M": 0.08807479,
    "CMY_Y": 0.1863279,
    "CMYK_C": 0,
    "CMYK_M": 0.06592388,
    "CMYK_Y": 0.1665636,
    "CMYK_K": 0.02371424
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0116",
    "Farbtonhilfsbezeichnung": "09.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "222",
    "Bcolor": "194",
    "Y": 74,
    "L": 89.3021516783882,
    "a": 2.37311609461388,
    "b": 15.3574819478897,
    "C": 15.5397532727606,
    "h": 1.4174838397572,
    "CMY_C": 0.05583126,
    "CMY_M": 0.1292987,
    "CMY_Y": 0.2399163,
    "CMYK_C": 0,
    "CMYK_M": 0.07781181,
    "CMYK_Y": 0.1949705,
    "CMYK_K": 0.05583126
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0117",
    "Farbtonhilfsbezeichnung": "09.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "210",
    "Bcolor": "181",
    "Y": 67,
    "L": 84.9277420043945,
    "a": 2.10718441009521,
    "b": 15.9522161483765,
    "C": 16.0907878875732,
    "h": 82.4751663208008,
    "CMY_C": 0.10545814037323,
    "CMY_M": 0.17697304487228,
    "CMY_Y": 0.2910897731781,
    "CMYK_C": 0,
    "CMYK_M": 0.07994584739208,
    "CMYK_Y": 0.20751586556435,
    "CMYK_K": 0.10545814037323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0118",
    "Farbtonhilfsbezeichnung": "09.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "193",
    "Bcolor": "161",
    "Y": 55,
    "L": 79.1285978878997,
    "a": 3.18233936459511,
    "b": 18.3308199529613,
    "C": 18.6050058849584,
    "h": 1.39890360812777,
    "CMY_C": 0.15679,
    "CMY_M": 0.2432069,
    "CMY_Y": 0.369218,
    "CMYK_C": 0,
    "CMYK_M": 0.1024856,
    "CMYK_Y": 0.2519277,
    "CMYK_K": 0.15679
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0119",
    "Farbtonhilfsbezeichnung": "09.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "176",
    "Bcolor": "133",
    "Y": 47,
    "L": 73.5996322631836,
    "a": 5.33188152313232,
    "b": 25.6141357421875,
    "C": 26.1631984710693,
    "h": 78.2411346435547,
    "CMY_C": 0.1883133649826,
    "CMY_M": 0.30903017520905,
    "CMY_Y": 0.47821378707886,
    "CMYK_C": 0,
    "CMYK_M": 0.14872342348099,
    "CMYK_Y": 0.35715806484222,
    "CMYK_K": 0.1883133649826
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0120",
    "Farbtonhilfsbezeichnung": "09.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "143",
    "Bcolor": "107",
    "Y": 29,
    "L": 60.7870315083001,
    "a": 5.03471252521454,
    "b": 22.0044930325084,
    "C": 22.5731265851513,
    "h": 1.34586429658483,
    "CMY_C": 0.3373415,
    "CMY_M": 0.4410218,
    "CMY_Y": 0.579681,
    "CMYK_C": 0,
    "CMYK_M": 0.1564613,
    "CMYK_Y": 0.365708,
    "CMYK_K": 0.3373415
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0121",
    "Farbtonhilfsbezeichnung": "09.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "222",
    "Bcolor": "178",
    "Y": 75,
    "L": 89.7885208129883,
    "a": 3.16523146629333,
    "b": 24.4668159484863,
    "C": 24.6707077026367,
    "h": 82.6286773681641,
    "CMY_C": 0.02235686779022,
    "CMY_M": 0.12790912389755,
    "CMY_Y": 0.30238455533981,
    "CMYK_C": 0,
    "CMYK_M": 0.10796603560448,
    "CMYK_Y": 0.286431401968,
    "CMYK_K": 0.02235686779022
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0122",
    "Farbtonhilfsbezeichnung": "09.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "204",
    "Bcolor": "155",
    "Y": 63,
    "L": 83.5812759399414,
    "a": 5.23703575134277,
    "b": 27.5863666534424,
    "C": 28.0790691375732,
    "h": 79.2508010864258,
    "CMY_C": 0.07239419221878,
    "CMY_M": 0.20186167955399,
    "CMY_Y": 0.39040660858154,
    "CMYK_C": 0,
    "CMYK_M": 0.13957166671753,
    "CMYK_Y": 0.34283143281937,
    "CMYK_K": 0.07239419221878
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0123",
    "Farbtonhilfsbezeichnung": "09.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "193",
    "Bcolor": "137",
    "Y": 56,
    "L": 80.315559387207,
    "a": 6.64764022827148,
    "b": 32.7325134277344,
    "C": 33.4007263183594,
    "h": 78.5199432373047,
    "CMY_C": 0.09059876203537,
    "CMY_M": 0.24176996946335,
    "CMY_Y": 0.46195733547211,
    "CMYK_C": 0,
    "CMYK_M": 0.16623158752918,
    "CMYK_Y": 0.40835502743721,
    "CMYK_K": 0.09059876203537
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0124",
    "Farbtonhilfsbezeichnung": "09.12.15",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "170",
    "Bcolor": "110",
    "Y": 44,
    "L": 71.9423599243164,
    "a": 7.02137184143066,
    "b": 35.6548805236816,
    "C": 36.3396492004395,
    "h": 78.8595199584961,
    "CMY_C": 0.17877453565598,
    "CMY_M": 0.33249592781067,
    "CMY_Y": 0.56781959533691,
    "CMYK_C": 0,
    "CMYK_M": 0.18718537688255,
    "CMYK_Y": 0.47373721003532,
    "CMYK_K": 0.17877453565598
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0125",
    "Farbtonhilfsbezeichnung": "09.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "144",
    "Bcolor": "77",
    "Y": 32,
    "L": 62.3072853088379,
    "a": 8.45569515228271,
    "b": 40.6348419189453,
    "C": 41.5052909851074,
    "h": 78.2450866699219,
    "CMY_C": 0.27200025320053,
    "CMY_M": 0.43671363592148,
    "CMY_Y": 0.69862288236618,
    "CMYK_C": 0,
    "CMYK_M": 0.2262547314167,
    "CMYK_Y": 0.58602029085159,
    "CMYK_K": 0.27200025320053
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0126",
    "Farbtonhilfsbezeichnung": "09.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "220",
    "Bcolor": "161",
    "Y": 77,
    "L": 89.7429428100586,
    "a": 5.60553693771362,
    "b": 33.3336944580078,
    "C": 33.8017349243164,
    "h": 80.4542083740234,
    "CMY_C": 0,
    "CMY_M": 0.13630485534668,
    "CMY_Y": 0.36912363767624,
    "CMYK_C": 0,
    "CMYK_M": 0.13630485534668,
    "CMYK_Y": 0.36912363767624,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0127",
    "Farbtonhilfsbezeichnung": "09.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "205",
    "Bcolor": "142",
    "Y": 65,
    "L": 84.5568618774414,
    "a": 7.31873893737793,
    "b": 35.8403167724609,
    "C": 36.5799446105957,
    "h": 78.4586410522461,
    "CMY_C": 0.03178328275681,
    "CMY_M": 0.19802665710449,
    "CMY_Y": 0.44161552190781,
    "CMYK_C": 0,
    "CMYK_M": 0.17170058190823,
    "CMYK_Y": 0.42328563332558,
    "CMYK_K": 0.03178328275681
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0128",
    "Farbtonhilfsbezeichnung": "09.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "188",
    "Bcolor": "116",
    "Y": 54,
    "L": 79.0369033813477,
    "a": 9.08559417724609,
    "b": 41.913688659668,
    "C": 42.8871231079102,
    "h": 77.7692718505859,
    "CMY_C": 0.07493054866791,
    "CMY_M": 0.26325881481171,
    "CMY_Y": 0.54355919361115,
    "CMYK_C": 0,
    "CMYK_M": 0.20358283817768,
    "CMYK_Y": 0.50658750534058,
    "CMYK_K": 0.07493054866791
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0129",
    "Farbtonhilfsbezeichnung": "09.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "168",
    "Bcolor": "97",
    "Y": 43,
    "L": 72.1666259765625,
    "a": 10.3509511947632,
    "b": 42.7969360351563,
    "C": 44.0308990478516,
    "h": 76.4034423828125,
    "CMY_C": 0.14556992053986,
    "CMY_M": 0.33959329128265,
    "CMY_Y": 0.61852592229843,
    "CMYK_C": 0,
    "CMYK_M": 0.22707928717136,
    "CMYK_Y": 0.55353391170502,
    "CMYK_K": 0.14556992053986
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0130",
    "Farbtonhilfsbezeichnung": "09.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "139",
    "Bcolor": "70",
    "Y": 29,
    "L": 61.3248596191406,
    "a": 12.1499328613281,
    "b": 43.0017547607422,
    "C": 44.6852531433105,
    "h": 74.2226181030273,
    "CMY_C": 0.25896447896957,
    "CMY_M": 0.45628082752228,
    "CMY_Y": 0.72505187988281,
    "CMYK_C": 0,
    "CMYK_M": 0.26627111434937,
    "CMYK_Y": 0.62896770238876,
    "CMYK_K": 0.25896447896957
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0131",
    "Farbtonhilfsbezeichnung": "09.18.12",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "191",
    "Bcolor": "103",
    "Y": 58,
    "L": 80.8707885742188,
    "a": 10.9919462203979,
    "b": 50.881534576416,
    "C": 52.0552940368652,
    "h": 77.8097152709961,
    "CMY_C": 0.0294092297554,
    "CMY_M": 0.24983072280884,
    "CMY_Y": 0.59482216835022,
    "CMYK_C": 0,
    "CMYK_M": 0.22710034251213,
    "CMYK_Y": 0.58254516124725,
    "CMYK_K": 0.0294092297554
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0132",
    "Farbtonhilfsbezeichnung": "09.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "176",
    "Bcolor": "100",
    "Y": 48,
    "L": 75.3752059936523,
    "a": 11.6054677963257,
    "b": 45.6847381591797,
    "C": 47.1357841491699,
    "h": 75.7464370727539,
    "CMY_C": 0.09693437814713,
    "CMY_M": 0.30936652421951,
    "CMY_Y": 0.60865491628647,
    "CMYK_C": 0,
    "CMYK_M": 0.23523445427418,
    "CMYK_Y": 0.56664824485779,
    "CMYK_K": 0.09693437814713
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0133",
    "Farbtonhilfsbezeichnung": "09.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "160",
    "Bcolor": "86",
    "Y": 40,
    "L": 70.0110549926758,
    "a": 14.8711385726929,
    "b": 46.1914291381836,
    "C": 48.5262718200684,
    "h": 72.1542587280273,
    "CMY_C": 0.13949638605118,
    "CMY_M": 0.37441962957382,
    "CMY_Y": 0.66465532779694,
    "CMYK_C": 0,
    "CMYK_M": 0.27300667762756,
    "CMYK_Y": 0.61029255390167,
    "CMYK_K": 0.13949638605118
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0134",
    "Farbtonhilfsbezeichnung": "09.21.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "101",
    "Y": 63,
    "L": 83.9719924926758,
    "a": 13.0960483551025,
    "b": 55.7281341552734,
    "C": 57.2462348937988,
    "h": 76.7755126953125,
    "CMY_C": 0,
    "CMY_M": 0.22256696224213,
    "CMY_Y": 0.60215663909912,
    "CMYK_C": 0,
    "CMYK_M": 0.22256696224213,
    "CMYK_Y": 0.60215663909912,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0135",
    "Farbtonhilfsbezeichnung": "09.21.15",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "167",
    "Bcolor": "0",
    "Y": 48,
    "L": 74.388053894043,
    "a": 19.4329338073731,
    "b": 78.5561218261719,
    "C": 80.9240570068359,
    "h": 76.1053237915039,
    "CMY_C": 0.03417903184891,
    "CMY_M": 0.34459567070007,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.32140183448792,
    "CMYK_Y": 1,
    "CMYK_K": 0.03417903184891
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0136",
    "Farbtonhilfsbezeichnung": "09.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "143",
    "Bcolor": "0",
    "Y": 37,
    "L": 65.9989166259766,
    "a": 22.489725112915,
    "b": 71.9400100708008,
    "C": 75.373420715332,
    "h": 72.6398239135742,
    "CMY_C": 0.12411987781525,
    "CMY_M": 0.43985193967819,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.36047405004501,
    "CMYK_Y": 1,
    "CMYK_K": 0.12411987781525
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0137",
    "Farbtonhilfsbezeichnung": "12.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "168",
    "Bcolor": "152",
    "Y": 41,
    "L": 70.1283416748047,
    "a": 4.18868398666382,
    "b": 10.4180564880371,
    "C": 11.2285785675049,
    "h": 68.0969085693359,
    "CMY_C": 0.26768136024475,
    "CMY_M": 0.3396572470665,
    "CMY_Y": 0.40556311607361,
    "CMYK_C": 0,
    "CMYK_M": 0.09828492999077,
    "CMYK_Y": 0.18828108906746,
    "CMYK_K": 0.26768136024475
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0138",
    "Farbtonhilfsbezeichnung": "12.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "143",
    "Bcolor": "123",
    "Y": 30,
    "L": 60.8286094665527,
    "a": 4.53965902328491,
    "b": 13.3027467727661,
    "C": 14.0560159683228,
    "h": 71.1574249267578,
    "CMY_C": 0.35775470733643,
    "CMY_M": 0.43762558698654,
    "CMY_Y": 0.51931631565094,
    "CMYK_C": 0,
    "CMYK_M": 0.12436195462942,
    "CMYK_Y": 0.25155746936798,
    "CMYK_K": 0.35775470733643
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0139",
    "Farbtonhilfsbezeichnung": "12.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "217",
    "Bcolor": "189",
    "Y": 70,
    "L": 87.9744491577148,
    "a": 4.43103694915771,
    "b": 15.8763723373413,
    "C": 16.4831218719482,
    "h": 74.4057769775391,
    "CMY_C": 0.05466192960739,
    "CMY_M": 0.14908713102341,
    "CMY_Y": 0.25765573978424,
    "CMYK_C": 0,
    "CMYK_M": 0.09988511353731,
    "CMYK_Y": 0.21473143994808,
    "CMYK_K": 0.05466192960739
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0140",
    "Farbtonhilfsbezeichnung": "12.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "194",
    "Bcolor": "161",
    "Y": 57,
    "L": 80.0633239746094,
    "a": 6.3017110824585,
    "b": 19.4547958374023,
    "C": 20.4499549865723,
    "h": 72.0520553588867,
    "CMY_C": 0.12233167886734,
    "CMY_M": 0.2408971786499,
    "CMY_Y": 0.36709988117218,
    "CMYK_C": 0,
    "CMYK_M": 0.13509146869183,
    "CMYK_Y": 0.27888461947441,
    "CMYK_K": 0.12233167886734
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0141",
    "Farbtonhilfsbezeichnung": "12.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "179",
    "Bcolor": "150",
    "Y": 48,
    "L": 75.0252456665039,
    "a": 7.04718255996704,
    "b": 18.3380088806152,
    "C": 19.6454925537109,
    "h": 68.9785461425781,
    "CMY_C": 0.17607539892197,
    "CMY_M": 0.29651755094528,
    "CMY_Y": 0.41101437807083,
    "CMYK_C": 0,
    "CMYK_M": 0.14618103206158,
    "CMYK_Y": 0.28514620661736,
    "CMYK_K": 0.17607539892197
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0142",
    "Farbtonhilfsbezeichnung": "12.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "166",
    "Bcolor": "138",
    "Y": 41,
    "L": 70.3450012207031,
    "a": 7.60510301589966,
    "b": 18.1139698028564,
    "C": 19.6456985473633,
    "h": 67.2250289916992,
    "CMY_C": 0.22462356090546,
    "CMY_M": 0.34734630584717,
    "CMY_Y": 0.45705890655518,
    "CMYK_C": 0,
    "CMYK_M": 0.15827505290508,
    "CMYK_Y": 0.29977098107338,
    "CMYK_K": 0.22462356090546
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0143",
    "Farbtonhilfsbezeichnung": "12.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "143",
    "Bcolor": "114",
    "Y": 30,
    "L": 61.9582481384277,
    "a": 9.07947635650635,
    "b": 19.761775970459,
    "C": 21.7477512359619,
    "h": 65.3237609863281,
    "CMY_C": 0.30359941720963,
    "CMY_M": 0.43825298547745,
    "CMY_Y": 0.55191290378571,
    "CMYK_C": 0,
    "CMYK_M": 0.19335648417473,
    "CMYK_Y": 0.35656702518463,
    "CMYK_K": 0.30359941720963
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0144",
    "Farbtonhilfsbezeichnung": "12.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "216",
    "Bcolor": "179",
    "Y": 72,
    "L": 88.0701293945313,
    "a": 6.02518939971924,
    "b": 21.3121509552002,
    "C": 22.1474761962891,
    "h": 74.2137985229492,
    "CMY_C": 0.02920532226563,
    "CMY_M": 0.15325981378555,
    "CMY_Y": 0.29659426212311,
    "CMYK_C": 0,
    "CMYK_M": 0.12778653204441,
    "CMYK_Y": 0.27543306350708,
    "CMYK_K": 0.02920532226563
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0145",
    "Farbtonhilfsbezeichnung": "12.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "204",
    "Bcolor": "163",
    "Y": 64,
    "L": 84.1548309326172,
    "a": 6.53191041946411,
    "b": 24.581506729126,
    "C": 25.434549331665,
    "h": 75.1189880371094,
    "CMY_C": 0.06328350305557,
    "CMY_M": 0.19818371534348,
    "CMY_Y": 0.36194336414337,
    "CMYK_C": 0,
    "CMYK_M": 0.14401391148567,
    "CMYK_Y": 0.31883698701859,
    "CMYK_K": 0.06328350305557
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0146",
    "Farbtonhilfsbezeichnung": "12.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "182",
    "Bcolor": "135",
    "Y": 51,
    "L": 76.8063049316406,
    "a": 9.25898456573486,
    "b": 28.9299411773682,
    "C": 30.37548828125,
    "h": 72.2528076171875,
    "CMY_C": 0.12053656578064,
    "CMY_M": 0.2852481007576,
    "CMY_Y": 0.46905225515366,
    "CMYK_C": 0,
    "CMYK_M": 0.18728639185429,
    "CMYK_Y": 0.39628219604492,
    "CMYK_K": 0.12053656578064
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0147",
    "Farbtonhilfsbezeichnung": "12.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "161",
    "Bcolor": "119",
    "Y": 39,
    "L": 69.420295715332,
    "a": 11.357593536377,
    "b": 27.6052207946777,
    "C": 29.8503456115723,
    "h": 67.6363067626953,
    "CMY_C": 0.19315493106842,
    "CMY_M": 0.36834973096848,
    "CMY_Y": 0.5331619977951,
    "CMYK_C": 0,
    "CMYK_M": 0.21713560819626,
    "CMYK_Y": 0.42140316963196,
    "CMYK_K": 0.19315493106842
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0148",
    "Farbtonhilfsbezeichnung": "12.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "131",
    "Bcolor": "87",
    "Y": 27,
    "L": 57.9488220214844,
    "a": 11.7519788742065,
    "b": 29.8066844940186,
    "C": 32.0397796630859,
    "h": 68.4820098876953,
    "CMY_C": 0.31514984369278,
    "CMY_M": 0.48742944002151,
    "CMY_Y": 0.66008317470551,
    "CMYK_C": 0,
    "CMYK_M": 0.25155809521675,
    "CMYK_Y": 0.50366246700287,
    "CMYK_K": 0.31514984369278
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0149",
    "Farbtonhilfsbezeichnung": "12.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "223",
    "Bcolor": "184",
    "Y": 76,
    "L": 90.4091339111328,
    "a": 4.73566055297852,
    "b": 22.3437080383301,
    "C": 22.8400478363037,
    "h": 78.0334701538086,
    "CMY_C": 0.00903970003128,
    "CMY_M": 0.12442666292191,
    "CMY_Y": 0.27961528301239,
    "CMYK_C": 0,
    "CMYK_M": 0.11643954366446,
    "CMYK_Y": 0.27304381132126,
    "CMYK_K": 0.00903970003128
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0150",
    "Farbtonhilfsbezeichnung": "12.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "199",
    "Bcolor": "150",
    "Y": 61,
    "L": 82.8143615722656,
    "a": 8.79084014892578,
    "b": 29.6526870727539,
    "C": 30.928316116333,
    "h": 73.4870071411133,
    "CMY_C": 0.05345016717911,
    "CMY_M": 0.21950823068619,
    "CMY_Y": 0.41294497251511,
    "CMYK_C": 0,
    "CMYK_M": 0.17543509602547,
    "CMYK_Y": 0.37979489564896,
    "CMYK_K": 0.05345016717911
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0151",
    "Farbtonhilfsbezeichnung": "12.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "189",
    "Bcolor": "123",
    "Y": 56,
    "L": 80.483642578125,
    "a": 13.4928092956543,
    "b": 40.7365875244141,
    "C": 42.9129981994629,
    "h": 71.6740493774414,
    "CMY_C": 0.03207355737686,
    "CMY_M": 0.25895637273788,
    "CMY_Y": 0.5187828540802,
    "CMYK_C": 0,
    "CMYK_M": 0.23440088331699,
    "CMYK_Y": 0.50283706188202,
    "CMYK_K": 0.03207355737686
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0152",
    "Farbtonhilfsbezeichnung": "12.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "159",
    "Bcolor": "91",
    "Y": 40,
    "L": 70.5335845947266,
    "a": 17.8001327514648,
    "b": 44.3928565979004,
    "C": 47.8285522460938,
    "h": 68.1507720947266,
    "CMY_C": 0.11824256181717,
    "CMY_M": 0.37662589550018,
    "CMY_Y": 0.64459705352783,
    "CMYK_C": 0,
    "CMYK_M": 0.29303219914436,
    "CMYK_Y": 0.59693795442581,
    "CMYK_K": 0.11824256181717
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0153",
    "Farbtonhilfsbezeichnung": "12.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "138",
    "Bcolor": "80",
    "Y": 30,
    "L": 62.1424674987793,
    "a": 16.7006435394287,
    "b": 39.3663291931152,
    "C": 42.7623596191406,
    "h": 67.0115585327148,
    "CMY_C": 0.22761732339859,
    "CMY_M": 0.45940828323364,
    "CMY_Y": 0.6881297826767,
    "CMYK_C": 0,
    "CMYK_M": 0.30009859800339,
    "CMYK_Y": 0.59622317552567,
    "CMYK_K": 0.22761732339859
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0154",
    "Farbtonhilfsbezeichnung": "12.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "164",
    "Y": 75,
    "L": 89.4281845092773,
    "a": 5.68902254104614,
    "b": 31.0691337585449,
    "C": 31.585693359375,
    "h": 79.6236038208008,
    "CMY_C": 0,
    "CMY_M": 0.13953846693039,
    "CMY_Y": 0.35528141260147,
    "CMYK_C": 0,
    "CMYK_M": 0.13953846693039,
    "CMYK_Y": 0.35528141260147,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0155",
    "Farbtonhilfsbezeichnung": "12.18.09",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "202",
    "Bcolor": "136",
    "Y": 65,
    "L": 84.5367736816406,
    "a": 10.422779083252,
    "b": 39.1383323669434,
    "C": 40.5023880004883,
    "h": 75.0878677368164,
    "CMY_C": 0.00632160902023,
    "CMY_M": 0.20677614212036,
    "CMY_Y": 0.46609550714493,
    "CMYK_C": 0,
    "CMYK_M": 0.20172978937626,
    "CMYK_Y": 0.46269890666008,
    "CMYK_K": 0.00632160902023
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0156",
    "Farbtonhilfsbezeichnung": "12.18.12",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "169",
    "Bcolor": "85",
    "Y": 50,
    "L": 74.9709167480469,
    "a": 19.8986759185791,
    "b": 52.9222831726074,
    "C": 56.5395927429199,
    "h": 69.3938369750977,
    "CMY_C": 0.04406988620758,
    "CMY_M": 0.33708715438843,
    "CMY_Y": 0.66765892505646,
    "CMYK_C": 0,
    "CMYK_M": 0.30652582645416,
    "CMYK_Y": 0.6523374915123,
    "CMYK_K": 0.04406988620758
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0157",
    "Farbtonhilfsbezeichnung": "12.18.15",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "153",
    "Bcolor": "43",
    "Y": 44,
    "L": 71.2854309082031,
    "a": 27.9945602416992,
    "b": 66.8972396850586,
    "C": 72.5185241699219,
    "h": 67.292106628418,
    "CMY_C": 0.0316578745842,
    "CMY_M": 0.40130716562271,
    "CMY_Y": 0.83270692825317,
    "CMYK_C": 0,
    "CMYK_M": 0.38173419237137,
    "CMYK_Y": 0.82723766565323,
    "CMYK_K": 0.0316578745842
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0158",
    "Farbtonhilfsbezeichnung": "12.18.18",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "141",
    "Bcolor": "0",
    "Y": 37,
    "L": 66.5610733032227,
    "a": 26.8561229705811,
    "b": 72.8265228271484,
    "C": 77.6205749511719,
    "h": 69.7576141357422,
    "CMY_C": 0.09304773807526,
    "CMY_M": 0.44722092151642,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3905091881752,
    "CMYK_Y": 1,
    "CMYK_K": 0.09304773807526
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0159",
    "Farbtonhilfsbezeichnung": "12.21.12",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "77",
    "Y": 56,
    "L": 79.5256118774414,
    "a": 22.4979286193848,
    "b": 62.1620292663574,
    "C": 66.1080551147461,
    "h": 70.1035919189453,
    "CMY_C": 0,
    "CMY_M": 0.29735273122787,
    "CMY_Y": 0.69944429397583,
    "CMYK_C": 0,
    "CMYK_M": 0.29735273122787,
    "CMYK_Y": 0.69944429397583,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0160",
    "Farbtonhilfsbezeichnung": "12.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "146",
    "Bcolor": "14",
    "Y": 41,
    "L": 68.7673873901367,
    "a": 27.3635425567627,
    "b": 71.7538986206055,
    "C": 76.79443359375,
    "h": 69.1255187988281,
    "CMY_C": 0.06349319219589,
    "CMY_M": 0.42595875263214,
    "CMY_Y": 0.94534879922867,
    "CMYK_C": 0,
    "CMYK_M": 0.38703995943069,
    "CMYK_Y": 0.94164353609085,
    "CMYK_K": 0.06349319219589
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0161",
    "Farbtonhilfsbezeichnung": "15.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "225",
    "Y": 87,
    "L": 94.3475112915039,
    "a": 1.94226551055908,
    "b": 6.11750936508179,
    "C": 6.41843557357788,
    "h": 72.3857269287109,
    "CMY_C": 0.02841877937317,
    "CMY_M": 0.06956595182419,
    "CMY_Y": 0.11628341674805,
    "CMYK_C": 0,
    "CMYK_M": 0.04235072806478,
    "CMYK_Y": 0.09043467789888,
    "CMYK_K": 0.02841877937317
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0162",
    "Farbtonhilfsbezeichnung": "15.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "225",
    "Bcolor": "211",
    "Y": 76,
    "L": 89.8512420654297,
    "a": 1.62996816635132,
    "b": 7.26133584976196,
    "C": 7.44202899932861,
    "h": 77.3484039306641,
    "CMY_C": 0.07796275615692,
    "CMY_M": 0.11931252479553,
    "CMY_Y": 0.17417860031128,
    "CMYK_C": 0,
    "CMYK_M": 0.04484609514475,
    "CMYK_Y": 0.10435136407614,
    "CMYK_K": 0.07796275615692
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0163",
    "Farbtonhilfsbezeichnung": "15.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "210",
    "Bcolor": "193",
    "Y": 66,
    "L": 84.9312362670898,
    "a": 3.01369404792786,
    "b": 9.43400859832764,
    "C": 9.90367984771729,
    "h": 72.2839202880859,
    "CMY_C": 0.11632567644119,
    "CMY_M": 0.17750006914139,
    "CMY_Y": 0.24317330121994,
    "CMYK_C": 0,
    "CMYK_M": 0.0692273080349,
    "CMYK_Y": 0.14354567229748,
    "CMYK_K": 0.11632567644119
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0164",
    "Farbtonhilfsbezeichnung": "15.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 56,
    "L": 79.9821014404297,
    "a": 3.66102361679077,
    "b": 9.62873268127441,
    "C": 10.3012418746948,
    "h": 69.182258605957,
    "CMY_C": 0.16596662998199,
    "CMY_M": 0.23301464319229,
    "CMY_Y": 0.29724657535553,
    "CMYK_C": 0,
    "CMYK_M": 0.08039008826017,
    "CMYK_Y": 0.15740370750427,
    "CMYK_K": 0.16596662998199
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0165",
    "Farbtonhilfsbezeichnung": "15.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "172",
    "Bcolor": "156",
    "Y": 43,
    "L": 71.7099151611328,
    "a": 5.41087198257446,
    "b": 10.2745780944824,
    "C": 11.6122560501099,
    "h": 62.2274894714355,
    "CMY_C": 0.24252331256866,
    "CMY_M": 0.32584095001221,
    "CMY_Y": 0.38807988166809,
    "CMYK_C": 0,
    "CMYK_M": 0.10999366641045,
    "CMYK_Y": 0.19215980172157,
    "CMYK_K": 0.24252331256866
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0166",
    "Farbtonhilfsbezeichnung": "15.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "146",
    "Bcolor": "132",
    "Y": 30,
    "L": 61.9073829650879,
    "a": 5.79916906356812,
    "b": 9.33209133148193,
    "C": 10.9871873855591,
    "h": 58.1422653198242,
    "CMY_C": 0.34729808568954,
    "CMY_M": 0.42860639095306,
    "CMY_Y": 0.48116886615753,
    "CMYK_C": 0,
    "CMYK_M": 0.12457188218832,
    "CMYK_Y": 0.20510247349739,
    "CMYK_K": 0.34729808568954
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0167",
    "Farbtonhilfsbezeichnung": "15.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "234",
    "Bcolor": "212",
    "Y": 83,
    "L": 93.4245147705078,
    "a": 2.5551974773407,
    "b": 11.5779047012329,
    "C": 11.8565130233765,
    "h": 77.5545501708984,
    "CMY_C": 0.01804232597351,
    "CMY_M": 0.08285492658615,
    "CMY_Y": 0.16708552837372,
    "CMYK_C": 0,
    "CMYK_M": 0.06600345671177,
    "CMYK_Y": 0.15178169310093,
    "CMYK_K": 0.01804232597351
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0168",
    "Farbtonhilfsbezeichnung": "15.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "224",
    "Bcolor": "206",
    "Y": 76,
    "L": 90.0117568969727,
    "a": 2.78099703788757,
    "b": 10.1600494384766,
    "C": 10.5337810516357,
    "h": 74.692008972168,
    "CMY_C": 0.05903393030167,
    "CMY_M": 0.1210743188858,
    "CMY_Y": 0.19369393587112,
    "CMYK_C": 0,
    "CMYK_M": 0.06593265384436,
    "CMYK_Y": 0.14310824871063,
    "CMYK_K": 0.05903393030167
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0169",
    "Farbtonhilfsbezeichnung": "15.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "204",
    "Bcolor": "183",
    "Y": 63,
    "L": 83.5627593994141,
    "a": 5.21776247024536,
    "b": 13.1125202178955,
    "C": 14.1125202178955,
    "h": 68.3013000488281,
    "CMY_C": 0.10583746433258,
    "CMY_M": 0.19874656200409,
    "CMY_Y": 0.28429758548737,
    "CMYK_C": 0,
    "CMYK_M": 0.10390627384186,
    "CMYK_Y": 0.19958353042603,
    "CMYK_K": 0.10583746433258
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0170",
    "Farbtonhilfsbezeichnung": "15.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "194",
    "Bcolor": "169",
    "Y": 57,
    "L": 80.0793685913086,
    "a": 6.67093467712402,
    "b": 15.3489141464233,
    "C": 16.7359046936035,
    "h": 66.5093002319336,
    "CMY_C": 0.12912809848785,
    "CMY_M": 0.2406815290451,
    "CMY_Y": 0.33708298206329,
    "CMYK_C": 0,
    "CMYK_M": 0.128093957901,
    "CMYK_Y": 0.23878929018974,
    "CMYK_K": 0.12912809848785
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0171",
    "Farbtonhilfsbezeichnung": "15.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "175",
    "Bcolor": "148",
    "Y": 46,
    "L": 73.660530090332,
    "a": 8.81640243530273,
    "b": 17.4277992248535,
    "C": 19.5309276580811,
    "h": 63.1659927368164,
    "CMY_C": 0.18147575855255,
    "CMY_M": 0.31518703699112,
    "CMY_Y": 0.41819590330124,
    "CMYK_C": 0,
    "CMYK_M": 0.16335652768612,
    "CMYK_Y": 0.28920358419418,
    "CMYK_K": 0.18147575855255
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0172",
    "Farbtonhilfsbezeichnung": "15.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "143",
    "Bcolor": "118",
    "Y": 31,
    "L": 62.4768981933594,
    "a": 11.1184892654419,
    "b": 18.4548950195313,
    "C": 21.5453929901123,
    "h": 58.9323692321777,
    "CMY_C": 0.28777527809143,
    "CMY_M": 0.43772327899933,
    "CMY_Y": 0.5373906493187,
    "CMYK_C": 0,
    "CMYK_M": 0.21053467690945,
    "CMYK_Y": 0.35047277808189,
    "CMYK_K": 0.28777527809143
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0173",
    "Farbtonhilfsbezeichnung": "15.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "225",
    "Bcolor": "200",
    "Y": 77,
    "L": 90.3815612792969,
    "a": 2.95014190673828,
    "b": 13.6666202545166,
    "C": 13.9814109802246,
    "h": 77.8187713623047,
    "CMY_C": 0.04388624429703,
    "CMY_M": 0.11827266216278,
    "CMY_Y": 0.21564364433289,
    "CMYK_C": 0,
    "CMYK_M": 0.07780080288649,
    "CMYK_Y": 0.17964117228985,
    "CMYK_K": 0.04388624429703
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0174",
    "Farbtonhilfsbezeichnung": "15.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "220",
    "Bcolor": "195",
    "Y": 74,
    "L": 89.4146270751953,
    "a": 5.77383232116699,
    "b": 15.1916570663452,
    "C": 16.2518787384033,
    "h": 69.1899032592773,
    "CMY_C": 0.0304359793663,
    "CMY_M": 0.13632863759995,
    "CMY_Y": 0.23690807819366,
    "CMYK_C": 0,
    "CMYK_M": 0.10921677947044,
    "CMYK_Y": 0.21295355260372,
    "CMYK_K": 0.0304359793663
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0175",
    "Farbtonhilfsbezeichnung": "15.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "205",
    "Bcolor": "172",
    "Y": 66,
    "L": 84.6008911132813,
    "a": 7.82524490356445,
    "b": 20.5629940032959,
    "C": 22.0016174316406,
    "h": 69.1656875610352,
    "CMY_C": 0.05810463428497,
    "CMY_M": 0.19566118717194,
    "CMY_Y": 0.32741498947144,
    "CMYK_C": 0,
    "CMYK_M": 0.1460422873497,
    "CMYK_Y": 0.28592386841774,
    "CMYK_K": 0.05810463428497
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0176",
    "Farbtonhilfsbezeichnung": "15.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "189",
    "Bcolor": "153",
    "Y": 56,
    "L": 79.5360870361328,
    "a": 10.5950603485107,
    "b": 23.4229755401611,
    "C": 25.7078018188477,
    "h": 65.6610412597656,
    "CMY_C": 0.09121215343475,
    "CMY_M": 0.25824040174484,
    "CMY_Y": 0.4006410241127,
    "CMYK_C": 0,
    "CMYK_M": 0.18379233777523,
    "CMYK_Y": 0.34048527479172,
    "CMYK_K": 0.09121215343475
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0177",
    "Farbtonhilfsbezeichnung": "15.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "162",
    "Bcolor": "121",
    "Y": 42,
    "L": 71.0854873657227,
    "a": 15.931131362915,
    "b": 29.2248477935791,
    "C": 33.2850227355957,
    "h": 61.4041938781738,
    "CMY_C": 0.14353781938553,
    "CMY_M": 0.36318224668503,
    "CMY_Y": 0.52725231647491,
    "CMYK_C": 0,
    "CMYK_M": 0.2564554810524,
    "CMYK_Y": 0.44802269339561,
    "CMYK_K": 0.14353781938553
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0178",
    "Farbtonhilfsbezeichnung": "15.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "139",
    "Bcolor": "105",
    "Y": 30,
    "L": 61.9303779602051,
    "a": 15.5784606933594,
    "b": 25.2155418395996,
    "C": 29.6397037506104,
    "h": 58.2917366027832,
    "CMY_C": 0.25532418489456,
    "CMY_M": 0.45615863800049,
    "CMY_Y": 0.58882069587708,
    "CMYK_C": 0,
    "CMYK_M": 0.2696937918663,
    "CMYK_Y": 0.44784119725227,
    "CMYK_K": 0.25532418489456
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0179",
    "Farbtonhilfsbezeichnung": "15.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "136",
    "Bcolor": "84",
    "Y": 30,
    "L": 62.3359298706055,
    "a": 20.5399570465088,
    "b": 37.4276275634766,
    "C": 42.6932907104492,
    "h": 61.2424011230469,
    "CMY_C": 0.20584642887115,
    "CMY_M": 0.46773505210876,
    "CMY_Y": 0.67079681158066,
    "CMYK_C": 0,
    "CMYK_M": 0.32977074384689,
    "CMYK_Y": 0.58546656370163,
    "CMYK_K": 0.20584642887115
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0180",
    "Farbtonhilfsbezeichnung": "15.18.09",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "143",
    "Y": 64,
    "L": 84.0685882568359,
    "a": 15.5585803985596,
    "b": 34.9914741516113,
    "C": 38.2945518493652,
    "h": 66.0281982421875,
    "CMY_C": 0,
    "CMY_M": 0.22468984127045,
    "CMY_Y": 0.43832695484161,
    "CMYK_C": 0,
    "CMYK_M": 0.22468984127045,
    "CMYK_Y": 0.43832695484161,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0181",
    "Farbtonhilfsbezeichnung": "15.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "108",
    "Y": 56,
    "L": 79.4060897827148,
    "a": 22.7301044464111,
    "b": 46.9256362915039,
    "C": 52.1408958435059,
    "h": 64.1551208496094,
    "CMY_C": 0,
    "CMY_M": 0.29714787006378,
    "CMY_Y": 0.57453322410583,
    "CMYK_C": 0,
    "CMYK_M": 0.29714787006378,
    "CMYK_Y": 0.57453322410583,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0182",
    "Farbtonhilfsbezeichnung": "15.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "157",
    "Bcolor": "88",
    "Y": 44,
    "L": 71.0983734130859,
    "a": 22.5477561950684,
    "b": 46.8421669006348,
    "C": 51.9864387512207,
    "h": 64.2958831787109,
    "CMY_C": 0.08136266469955,
    "CMY_M": 0.38447839021683,
    "CMY_Y": 0.65645790100098,
    "CMYK_C": 0,
    "CMYK_M": 0.32996234297752,
    "CMYK_Y": 0.6260307431221,
    "CMYK_K": 0.08136266469955
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0183",
    "Farbtonhilfsbezeichnung": "15.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "126",
    "Bcolor": "65",
    "Y": 27,
    "L": 60.2719497680664,
    "a": 25.4138011932373,
    "b": 44.9246864318848,
    "C": 51.6148109436035,
    "h": 60.5032501220703,
    "CMY_C": 0.19542169570923,
    "CMY_M": 0.50401592254639,
    "CMY_Y": 0.74527168273926,
    "CMYK_C": 0,
    "CMYK_M": 0.38354778289795,
    "CMYK_Y": 0.68340146541595,
    "CMYK_K": 0.19542169570923
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0184",
    "Farbtonhilfsbezeichnung": "15.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "125",
    "Bcolor": "54",
    "Y": 28,
    "L": 60.6029090881348,
    "a": 27.7401332855225,
    "b": 50.8798332214355,
    "C": 57.9506034851074,
    "h": 61.4003944396973,
    "CMY_C": 0.17414063215256,
    "CMY_M": 0.5085723400116,
    "CMY_Y": 0.78937315940857,
    "CMYK_C": 0,
    "CMYK_M": 0.40494993329048,
    "CMYK_Y": 0.74496042728424,
    "CMYK_K": 0.17414063215256
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0185",
    "Farbtonhilfsbezeichnung": "18.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "235",
    "Bcolor": "223",
    "Y": 83,
    "L": 93.2529296875,
    "a": 1.19382548332214,
    "b": 5.79153823852539,
    "C": 5.91330146789551,
    "h": 78.3526000976563,
    "CMY_C": 0.04756224155426,
    "CMY_M": 0.07993304729462,
    "CMY_Y": 0.12604123353958,
    "CMYK_C": 0,
    "CMYK_M": 0.03398731723428,
    "CMYK_Y": 0.08239802718163,
    "CMYK_K": 0.04756224155426
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0186",
    "Farbtonhilfsbezeichnung": "18.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "221",
    "Bcolor": "211",
    "Y": 74,
    "L": 88.6893768310547,
    "a": 2.06058263778687,
    "b": 5.26414012908936,
    "C": 5.65306758880615,
    "h": 68.6227569580078,
    "CMY_C": 0.09379684925079,
    "CMY_M": 0.13269382715225,
    "CMY_Y": 0.17205119132996,
    "CMYK_C": 0,
    "CMYK_M": 0.04292302206159,
    "CMYK_Y": 0.08635408431292,
    "CMYK_K": 0.09379684925079
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0187",
    "Farbtonhilfsbezeichnung": "18.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "209",
    "Bcolor": "200",
    "Y": 65,
    "L": 84.40478515625,
    "a": 2.33954405784607,
    "b": 4.95467233657837,
    "C": 5.47925567626953,
    "h": 64.7238159179688,
    "CMY_C": 0.14027768373489,
    "CMY_M": 0.1804735660553,
    "CMY_Y": 0.21624970436096,
    "CMYK_C": 0,
    "CMYK_M": 0.04675449430943,
    "CMYK_Y": 0.08836809545755,
    "CMYK_K": 0.14027768373489
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0188",
    "Farbtonhilfsbezeichnung": "18.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "192",
    "Bcolor": "184",
    "Y": 54,
    "L": 78.4484329223633,
    "a": 2.48610019683838,
    "b": 4.54576587677002,
    "C": 5.18118524551392,
    "h": 61.3255500793457,
    "CMY_C": 0.20583766698837,
    "CMY_M": 0.24547588825226,
    "CMY_Y": 0.27711206674576,
    "CMYK_C": 0,
    "CMYK_M": 0.04991198703647,
    "CMYK_Y": 0.08974789828062,
    "CMYK_K": 0.20583766698837
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0189",
    "Farbtonhilfsbezeichnung": "18.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "175",
    "Bcolor": "167",
    "Y": 44,
    "L": 72.1945266723633,
    "a": 2.90377831459045,
    "b": 4.84153652191162,
    "C": 5.64556503295898,
    "h": 59.0461921691895,
    "CMY_C": 0.2695876955986,
    "CMY_M": 0.31342345476151,
    "CMY_Y": 0.3450830578804,
    "CMYK_C": 0,
    "CMYK_M": 0.06001508980989,
    "CMYK_Y": 0.10335993021727,
    "CMYK_K": 0.2695876955986
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0190",
    "Farbtonhilfsbezeichnung": "18.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "161",
    "Gcolor": "149",
    "Bcolor": "142",
    "Y": 31,
    "L": 62.4241333007813,
    "a": 3.58362674713135,
    "b": 4.68046617507935,
    "C": 5.89484071731567,
    "h": 52.5603103637695,
    "CMY_C": 0.36880362033844,
    "CMY_M": 0.41702479124069,
    "CMY_Y": 0.44442164897919,
    "CMYK_C": 0,
    "CMYK_M": 0.07639646530151,
    "CMYK_Y": 0.11980111151934,
    "CMYK_K": 0.36880362033844
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0191",
    "Farbtonhilfsbezeichnung": "18.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 43,
    "L": 71.7850494384766,
    "a": 11.647590637207,
    "b": 17.5278949737549,
    "C": 21.0450344085693,
    "h": 56.3952713012695,
    "CMY_C": 0.18366754055023,
    "CMY_M": 0.34216594696045,
    "CMY_Y": 0.4375621676445,
    "CMYK_C": 0,
    "CMYK_M": 0.19415913522243,
    "CMYK_Y": 0.3110186457634,
    "CMYK_K": 0.18366754055023
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0192",
    "Farbtonhilfsbezeichnung": "18.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "143",
    "Bcolor": "121",
    "Y": 31,
    "L": 62.7104110717773,
    "a": 13.0137939453125,
    "b": 16.9826793670654,
    "C": 21.395565032959,
    "h": 52.5371246337891,
    "CMY_C": 0.2763215303421,
    "CMY_M": 0.43981337547302,
    "CMY_Y": 0.52456915378571,
    "CMYK_C": 0,
    "CMYK_M": 0.22591780126095,
    "CMYK_Y": 0.34303578734398,
    "CMYK_K": 0.2763215303421
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0193",
    "Farbtonhilfsbezeichnung": "18.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "194",
    "Y": 76,
    "L": 89.650520324707,
    "a": 8.43193340301514,
    "b": 16.0264797210693,
    "C": 18.1092662811279,
    "h": 62.2500152587891,
    "CMY_C": 0.00679802894592,
    "CMY_M": 0.14062088727951,
    "CMY_Y": 0.24010133743286,
    "CMYK_C": 0,
    "CMYK_M": 0.13473881781101,
    "CMYK_Y": 0.23490016162395,
    "CMYK_K": 0.00679802894592
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0194",
    "Farbtonhilfsbezeichnung": "18.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "199",
    "Bcolor": "170",
    "Y": 62,
    "L": 83.2183837890625,
    "a": 11.164192199707,
    "b": 19.2774887084961,
    "C": 22.2769107818604,
    "h": 59.9235382080078,
    "CMY_C": 0.05409169197083,
    "CMY_M": 0.21894115209579,
    "CMY_Y": 0.33192473649979,
    "CMYK_C": 0,
    "CMYK_M": 0.17427636682987,
    "CMYK_Y": 0.29372090101242,
    "CMYK_K": 0.05409169197083
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0195",
    "Farbtonhilfsbezeichnung": "18.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "183",
    "Bcolor": "150",
    "Y": 54,
    "L": 78.4545502131335,
    "a": 15.7170016623957,
    "b": 23.4905328307013,
    "C": 28.2635679617066,
    "h": 0.98112610963998,
    "CMY_C": 0.07032138,
    "CMY_M": 0.2833495,
    "CMY_Y": 0.4112749,
    "CMYK_C": 0,
    "CMYK_M": 0.2291417,
    "CMYK_Y": 0.3667434,
    "CMYK_K": 0.07032138
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0196",
    "Farbtonhilfsbezeichnung": "18.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "163",
    "Bcolor": "127",
    "Y": 43,
    "L": 71.7698211669922,
    "a": 17.4591464996338,
    "b": 26.5666408538818,
    "C": 31.7900638580322,
    "h": 56.6877593994141,
    "CMY_C": 0.13068461418152,
    "CMY_M": 0.35959523916245,
    "CMY_Y": 0.50097274780273,
    "CMYK_C": 0,
    "CMYK_M": 0.26332286000252,
    "CMYK_Y": 0.42595374584198,
    "CMYK_K": 0.13068461418152
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0197",
    "Farbtonhilfsbezeichnung": "18.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "139",
    "Bcolor": "106",
    "Y": 31,
    "L": 62.9508018493652,
    "a": 18.8754062652588,
    "b": 25.8994312286377,
    "C": 32.0478019714355,
    "h": 53.9155769348145,
    "CMY_C": 0.22349411249161,
    "CMY_M": 0.4547718167305,
    "CMY_Y": 0.58297872543335,
    "CMYK_C": 0,
    "CMYK_M": 0.2978441119194,
    "CMYK_Y": 0.46295157074928,
    "CMYK_K": 0.22349411249161
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0198",
    "Farbtonhilfsbezeichnung": "18.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "141",
    "Y": 57,
    "L": 80.5016174316406,
    "a": 23.4233264923096,
    "b": 31.6341533660889,
    "C": 39.362060546875,
    "h": 53.4821166992188,
    "CMY_C": 0,
    "CMY_M": 0.28459978103638,
    "CMY_Y": 0.44810652732849,
    "CMYK_C": 0,
    "CMYK_M": 0.28459978103638,
    "CMYK_Y": 0.44810652732849,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0199",
    "Farbtonhilfsbezeichnung": "18.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "127",
    "Bcolor": "89",
    "Y": 28,
    "L": 60.3421096801758,
    "a": 25.2663993835449,
    "b": 32.146312713623,
    "C": 40.8873634338379,
    "h": 51.8333168029785,
    "CMY_C": 0.20856565237045,
    "CMY_M": 0.50085127353668,
    "CMY_Y": 0.65045416355133,
    "CMYK_C": 0,
    "CMYK_M": 0.36931127309799,
    "CMYK_Y": 0.5583388209343,
    "CMYK_K": 0.20856565237045
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0200",
    "Farbtonhilfsbezeichnung": "18.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "152",
    "Bcolor": "94",
    "Y": 42,
    "L": 71.5011291503906,
    "a": 30.7409362792969,
    "b": 44.6630783081055,
    "C": 54.2198829650879,
    "h": 55.4609375,
    "CMY_C": 0.03221267461777,
    "CMY_M": 0.4047639966011,
    "CMY_Y": 0.63295167684555,
    "CMYK_C": 0,
    "CMYK_M": 0.38495165109634,
    "CMYK_Y": 0.62073451280594,
    "CMYK_K": 0.03221267461777
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0201",
    "Farbtonhilfsbezeichnung": "18.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "146",
    "Bcolor": "77",
    "Y": 41,
    "L": 71.0945205688477,
    "a": 36.1926231384277,
    "b": 52.9189147949219,
    "C": 64.1117553710938,
    "h": 55.6307601928711,
    "CMY_C": 0,
    "CMY_M": 0.42821490764618,
    "CMY_Y": 0.69949239492416,
    "CMYK_C": 0,
    "CMYK_M": 0.42821490764618,
    "CMYK_Y": 0.69949239492416,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0202",
    "Farbtonhilfsbezeichnung": "18.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "113",
    "Bcolor": "42",
    "Y": 30,
    "L": 59.5318183898926,
    "a": 38.9777374267578,
    "b": 55.6661720275879,
    "C": 67.9557723999023,
    "h": 55.0000953674316,
    "CMY_C": 0.12508344650269,
    "CMY_M": 0.55812764167786,
    "CMY_Y": 0.83623075485229,
    "CMYK_C": 0,
    "CMYK_M": 0.49495485424995,
    "CMYK_Y": 0.81281727552414,
    "CMYK_K": 0.12508344650269
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0203",
    "Farbtonhilfsbezeichnung": "21.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "234",
    "Bcolor": "219",
    "Y": 85,
    "L": 93.6450347900391,
    "a": 3.14523673057556,
    "b": 8.25611114501953,
    "C": 8.83492374420166,
    "h": 69.1452255249023,
    "CMY_C": 0.02073556184769,
    "CMY_M": 0.0809571146965,
    "CMY_Y": 0.13979625701904,
    "CMYK_C": 0,
    "CMYK_M": 0.06149672344327,
    "CMYK_Y": 0.1215817630291,
    "CMYK_K": 0.02073556184769
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0204",
    "Farbtonhilfsbezeichnung": "21.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "219",
    "Bcolor": "202",
    "Y": 73,
    "L": 88.6259384155273,
    "a": 4.74336624145508,
    "b": 10.2183284759522,
    "C": 11.2656011581421,
    "h": 65.0991897583008,
    "CMY_C": 0.06004720926285,
    "CMY_M": 0.14123898744583,
    "CMY_Y": 0.20884102582932,
    "CMYK_C": 0,
    "CMYK_M": 0.08637856692076,
    "CMYK_Y": 0.1582992374897,
    "CMYK_K": 0.06004720926285
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0205",
    "Farbtonhilfsbezeichnung": "21.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "207",
    "Bcolor": "189",
    "Y": 65,
    "L": 84.6137771606445,
    "a": 5.61743068695068,
    "b": 11.075831413269,
    "C": 12.4189195632935,
    "h": 63.1068305969238,
    "CMY_C": 0.09653460979462,
    "CMY_M": 0.18773359060287,
    "CMY_Y": 0.25816190242767,
    "CMYK_C": 0,
    "CMYK_M": 0.10094352811575,
    "CMYK_Y": 0.17889705300331,
    "CMYK_K": 0.09653460979462
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0206",
    "Farbtonhilfsbezeichnung": "21.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "188",
    "Bcolor": "169",
    "Y": 54,
    "L": 78.4887847900391,
    "a": 8.61124229431152,
    "b": 12.8913879394531,
    "C": 15.502947807312,
    "h": 56.2577056884766,
    "CMY_C": 0.13949179649353,
    "CMY_M": 0.26204627752304,
    "CMY_Y": 0.33569860458374,
    "CMYK_C": 0,
    "CMYK_M": 0.14242105185986,
    "CMYK_Y": 0.22801271080971,
    "CMYK_K": 0.13949179649353
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0207",
    "Farbtonhilfsbezeichnung": "21.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "171",
    "Bcolor": "154",
    "Y": 44,
    "L": 72.4548645019531,
    "a": 10.3480186462402,
    "b": 12.7490482330322,
    "C": 16.4201011657715,
    "h": 50.9347991943359,
    "CMY_C": 0.19512963294983,
    "CMY_M": 0.33068227767944,
    "CMY_Y": 0.39709228277206,
    "CMYK_C": 0,
    "CMYK_M": 0.16841550171375,
    "CMYK_Y": 0.25092568993568,
    "CMYK_K": 0.19512963294983
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0208",
    "Farbtonhilfsbezeichnung": "21.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "143",
    "Bcolor": "125",
    "Y": 31,
    "L": 62.3882369995117,
    "a": 12.0926332473755,
    "b": 14.2196140289307,
    "C": 18.6662578582764,
    "h": 49.6215209960938,
    "CMY_C": 0.29096353054047,
    "CMY_M": 0.44014883041382,
    "CMY_Y": 0.50889313220978,
    "CMYK_C": 0,
    "CMYK_M": 0.21040567755699,
    "CMYK_Y": 0.30736020207405,
    "CMYK_K": 0.29096353054047
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0209",
    "Farbtonhilfsbezeichnung": "21.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "200",
    "Y": 77,
    "L": 90.480110168457,
    "a": 9.3092565536499,
    "b": 13.8217859268188,
    "C": 16.6644535064697,
    "h": 56.0389251708984,
    "CMY_C": 0,
    "CMY_M": 0.13312655687332,
    "CMY_Y": 0.21467506885529,
    "CMYK_C": 0,
    "CMYK_M": 0.13312655687332,
    "CMYK_Y": 0.21467506885529,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0210",
    "Farbtonhilfsbezeichnung": "21.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "204",
    "Bcolor": "183",
    "Y": 66,
    "L": 84.7502288818359,
    "a": 10.7046785354614,
    "b": 14.4852590560913,
    "C": 18.0114650726318,
    "h": 53.5354156494141,
    "CMY_C": 0.05071818828583,
    "CMY_M": 0.19990807771683,
    "CMY_Y": 0.28078061342239,
    "CMYK_C": 0,
    "CMYK_M": 0.15716080367565,
    "CMYK_Y": 0.24235418438911,
    "CMYK_K": 0.05071818828583
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0211",
    "Farbtonhilfsbezeichnung": "21.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "184",
    "Bcolor": "161",
    "Y": 53,
    "L": 78.0015411376953,
    "a": 13.174732208252,
    "b": 17.023551940918,
    "C": 21.52614402771,
    "h": 52.2632789611816,
    "CMY_C": 0.10496646165848,
    "CMY_M": 0.2799374461174,
    "CMY_Y": 0.36973071098328,
    "CMYK_C": 0,
    "CMYK_M": 0.19549098610878,
    "CMYK_Y": 0.29581490159035,
    "CMYK_K": 0.10496646165848
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0212",
    "Farbtonhilfsbezeichnung": "21.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "164",
    "Bcolor": "138",
    "Y": 43,
    "L": 71.6260452270508,
    "a": 16.7425632476807,
    "b": 20.402530670166,
    "C": 26.3927383422852,
    "h": 50.6272850036621,
    "CMY_C": 0.14755296707153,
    "CMY_M": 0.35784560441971,
    "CMY_Y": 0.45861554145813,
    "CMYK_C": 0,
    "CMYK_M": 0.24669291079044,
    "CMYK_Y": 0.36490544676781,
    "CMYK_K": 0.14755296707153
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0213",
    "Farbtonhilfsbezeichnung": "21.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "136",
    "Bcolor": "113",
    "Y": 30,
    "L": 61.9435997009277,
    "a": 19.1287212371826,
    "b": 20.7843799591064,
    "C": 28.2470951080322,
    "h": 47.3753547668457,
    "CMY_C": 0.24132204055786,
    "CMY_M": 0.46470791101456,
    "CMY_Y": 0.55718076229095,
    "CMYK_C": 0,
    "CMYK_M": 0.29444095492363,
    "CMYK_Y": 0.41632780432701,
    "CMYK_K": 0.24132204055786
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0214",
    "Farbtonhilfsbezeichnung": "21.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "161",
    "Bcolor": "129",
    "Y": 45,
    "L": 73.3499450683594,
    "a": 25.7394142150879,
    "b": 28.3082065582275,
    "C": 38.2605819702148,
    "h": 47.7211265563965,
    "CMY_C": 0.05976897478104,
    "CMY_M": 0.36689054965973,
    "CMY_Y": 0.49579679965973,
    "CMYK_C": 0,
    "CMYK_M": 0.32664480805397,
    "CMYK_Y": 0.46374541521072,
    "CMYK_K": 0.05976897478104
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0215",
    "Farbtonhilfsbezeichnung": "21.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "129",
    "Bcolor": "97",
    "Y": 29,
    "L": 61.8319931030273,
    "a": 28.6172332763672,
    "b": 29.6570510864258,
    "C": 41.2126998901367,
    "h": 46.0222473144531,
    "CMY_C": 0.17578786611557,
    "CMY_M": 0.4954788684845,
    "CMY_Y": 0.61780750751495,
    "CMYK_C": 0,
    "CMYK_M": 0.38787466287613,
    "CMYK_Y": 0.53629356622696,
    "CMYK_K": 0.17578786611557
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0216",
    "Farbtonhilfsbezeichnung": "21.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "155",
    "Y": 60,
    "L": 82.0408248901367,
    "a": 21.3226947784424,
    "b": 26.0307292938232,
    "C": 33.6490135192871,
    "h": 50.6778755187988,
    "CMY_C": 0,
    "CMY_M": 0.26076889038086,
    "CMY_Y": 0.39161545038223,
    "CMYK_C": 0,
    "CMYK_M": 0.26076889038086,
    "CMYK_Y": 0.39161545038223,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0217",
    "Farbtonhilfsbezeichnung": "21.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "170",
    "Bcolor": "122",
    "Y": 52,
    "L": 77.7441177368164,
    "a": 28.810037612915,
    "b": 37.8909912109375,
    "C": 47.5998458862305,
    "h": 52.7528190612793,
    "CMY_C": 0,
    "CMY_M": 0.33148396015167,
    "CMY_Y": 0.52090871334076,
    "CMYK_C": 0,
    "CMYK_M": 0.33148396015167,
    "CMYK_Y": 0.52090871334076,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0218",
    "Farbtonhilfsbezeichnung": "21.18.18",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "120",
    "Bcolor": "51",
    "Y": 35,
    "L": 64.035041809082,
    "a": 43.1650314331055,
    "b": 57.1252365112305,
    "C": 71.5996704101563,
    "h": 52.9245376586914,
    "CMY_C": 0.04668915271759,
    "CMY_M": 0.52768242359161,
    "CMY_Y": 0.80138731002808,
    "CMYK_C": 0,
    "CMYK_M": 0.5045502781868,
    "CMYK_Y": 0.79166007041931,
    "CMYK_K": 0.04668915271759
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0219",
    "Farbtonhilfsbezeichnung": "24.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "235",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.6705322265625,
    "a": 2.51716637611389,
    "b": 5.43809604644775,
    "C": 5.99241304397583,
    "h": 65.1616897583008,
    "CMY_C": 0.03378176689148,
    "CMY_M": 0.07836872339249,
    "CMY_Y": 0.11860543489456,
    "CMYK_C": 0,
    "CMYK_M": 0.04614584520459,
    "CMYK_Y": 0.08778934925795,
    "CMYK_K": 0.03378176689148
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0220",
    "Farbtonhilfsbezeichnung": "24.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "219",
    "Bcolor": "207",
    "Y": 73,
    "L": 88.5776290893555,
    "a": 4.27511787414551,
    "b": 7.53206062316895,
    "C": 8.66074848175049,
    "h": 60.4212112426758,
    "CMY_C": 0.07165986299515,
    "CMY_M": 0.13991516828537,
    "CMY_Y": 0.18964183330536,
    "CMYK_C": 0,
    "CMYK_M": 0.07352402806282,
    "CMYK_Y": 0.12708915770054,
    "CMYK_K": 0.07165986299515
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0221",
    "Farbtonhilfsbezeichnung": "24.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "210",
    "Bcolor": "198",
    "Y": 66,
    "L": 85.445556640625,
    "a": 5.79403591156006,
    "b": 7.37618827819824,
    "C": 9.37971210479736,
    "h": 51.8501739501953,
    "CMY_C": 0.09609353542328,
    "CMY_M": 0.17809349298477,
    "CMY_Y": 0.22217583656311,
    "CMYK_C": 0,
    "CMYK_M": 0.09071730077267,
    "CMYK_Y": 0.13948599994183,
    "CMYK_K": 0.09609353542328
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0222",
    "Farbtonhilfsbezeichnung": "24.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "195",
    "Bcolor": "185",
    "Y": 57,
    "L": 80.2420959472656,
    "a": 6.25228500366211,
    "b": 6.92393684387207,
    "C": 9.32909297943115,
    "h": 47.9181022644043,
    "CMY_C": 0.15197104215622,
    "CMY_M": 0.2357764840126,
    "CMY_Y": 0.27458000183105,
    "CMYK_C": 0,
    "CMYK_M": 0.09882380068302,
    "CMYK_Y": 0.14458109438419,
    "CMYK_K": 0.15197104215622
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0223",
    "Farbtonhilfsbezeichnung": "24.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "174",
    "Bcolor": "166",
    "Y": 45,
    "L": 72.8310852050781,
    "a": 6.80859470367432,
    "b": 6.60862112045288,
    "C": 9.48845767974854,
    "h": 44.146110534668,
    "CMY_C": 0.23021167516708,
    "CMY_M": 0.31641632318497,
    "CMY_Y": 0.35034704208374,
    "CMYK_C": 0,
    "CMYK_M": 0.11198487132788,
    "CMYK_Y": 0.15606285631657,
    "CMYK_K": 0.23021167516708
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0224",
    "Farbtonhilfsbezeichnung": "24.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "146",
    "Bcolor": "139",
    "Y": 31,
    "L": 62.6056137084961,
    "a": 7.89340543746948,
    "b": 6.79912757873535,
    "C": 10.4179649353027,
    "h": 40.7405586242676,
    "CMY_C": 0.33224105834961,
    "CMY_M": 0.4257949590683,
    "CMY_Y": 0.45647996664047,
    "CMYK_C": 0,
    "CMYK_M": 0.140101313591,
    "CMYK_Y": 0.18605352938175,
    "CMYK_K": 0.33224105834961
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0225",
    "Farbtonhilfsbezeichnung": "24.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "205",
    "Bcolor": "190",
    "Y": 65,
    "L": 84.568977355957,
    "a": 9.41601371765137,
    "b": 10.4361763000488,
    "C": 14.0561408996582,
    "h": 47.941722869873,
    "CMY_C": 0.07180196046829,
    "CMY_M": 0.19755774736404,
    "CMY_Y": 0.25336545705795,
    "CMYK_C": 0,
    "CMYK_M": 0.13548378646374,
    "CMYK_Y": 0.19560857117176,
    "CMYK_K": 0.07180196046829
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0226",
    "Farbtonhilfsbezeichnung": "24.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "188",
    "Bcolor": "172",
    "Y": 55,
    "L": 79.0220336914063,
    "a": 11.8444271087647,
    "b": 12.5555038452148,
    "C": 17.2606811523438,
    "h": 46.6692771911621,
    "CMY_C": 0.11237418651581,
    "CMY_M": 0.26443707942963,
    "CMY_Y": 0.32715141773224,
    "CMYK_C": 0,
    "CMYK_M": 0.17131417989731,
    "CMYK_Y": 0.24196821451187,
    "CMYK_K": 0.11237418651581
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0227",
    "Farbtonhilfsbezeichnung": "24.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "170",
    "Bcolor": "155",
    "Y": 45,
    "L": 72.8593978881836,
    "a": 13.7420282363892,
    "b": 12.7938966751099,
    "C": 18.7757053375244,
    "h": 42.953685760498,
    "CMY_C": 0.16826605796814,
    "CMY_M": 0.33510941267014,
    "CMY_Y": 0.39267498254776,
    "CMYK_C": 0,
    "CMYK_M": 0.20059701800346,
    "CMYK_Y": 0.2698085308075,
    "CMYK_K": 0.16826605796814
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0228",
    "Farbtonhilfsbezeichnung": "24.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "143",
    "Bcolor": "129",
    "Y": 32,
    "L": 63.3455619812012,
    "a": 15.0118789672852,
    "b": 13.3988933563232,
    "C": 20.1218013763428,
    "h": 41.7505950927734,
    "CMY_C": 0.26405388116837,
    "CMY_M": 0.43765413761139,
    "CMY_Y": 0.49321883916855,
    "CMYK_C": 0,
    "CMYK_M": 0.23588718473911,
    "CMYK_Y": 0.31138822436333,
    "CMYK_K": 0.26405388116837
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0229",
    "Farbtonhilfsbezeichnung": "24.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "228",
    "Bcolor": "215",
    "Y": 80,
    "L": 91.8096694946289,
    "a": 5.73731803894043,
    "b": 7.7886528968811,
    "C": 9.67367172241211,
    "h": 53.6237030029297,
    "CMY_C": 0.02356958389282,
    "CMY_M": 0.10773408412933,
    "CMY_Y": 0.15605527162552,
    "CMYK_C": 0,
    "CMYK_M": 0.08619610965252,
    "CMYK_Y": 0.13568370044231,
    "CMYK_K": 0.02356958389282
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0230",
    "Farbtonhilfsbezeichnung": "24.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "218",
    "Bcolor": "203",
    "Y": 76,
    "L": 89.7260894775391,
    "a": 10.5623435974121,
    "b": 11.2116956710815,
    "C": 15.4034156799316,
    "h": 46.7081871032715,
    "CMY_C": 0.00305032730103,
    "CMY_M": 0.14402395486832,
    "CMY_Y": 0.20332300662994,
    "CMYK_C": 0,
    "CMYK_M": 0.14140495657921,
    "CMYK_Y": 0.20088544487953,
    "CMYK_K": 0.00305032730103
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0231",
    "Farbtonhilfsbezeichnung": "24.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "181",
    "Y": 66,
    "L": 85.4253387451172,
    "a": 16.7605819702148,
    "b": 16.6928520202637,
    "C": 23.6551990509033,
    "h": 44.8839988708496,
    "CMY_C": 0,
    "CMY_M": 0.20912081003189,
    "CMY_Y": 0.28869330883026,
    "CMYK_C": 0,
    "CMYK_M": 0.20912081003189,
    "CMYK_Y": 0.28869330883026,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0232",
    "Farbtonhilfsbezeichnung": "24.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "184",
    "Bcolor": "163",
    "Y": 56,
    "L": 79.0518341064453,
    "a": 17.4332809448242,
    "b": 17.3187942504883,
    "C": 24.5735607147217,
    "h": 44.8112449645996,
    "CMY_C": 0.064637362957,
    "CMY_M": 0.28010356426239,
    "CMY_Y": 0.36016142368317,
    "CMYK_C": 0,
    "CMYK_M": 0.23035579919815,
    "CMYK_Y": 0.31594598293304,
    "CMYK_K": 0.064637362957
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0233",
    "Farbtonhilfsbezeichnung": "24.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "165",
    "Bcolor": "146",
    "Y": 45,
    "L": 72.8644180297852,
    "a": 20.5951671600342,
    "b": 18.1101379394531,
    "C": 27.4251346588135,
    "h": 41.3264312744141,
    "CMY_C": 0.1138396859169,
    "CMY_M": 0.35486418008804,
    "CMY_Y": 0.429039478302,
    "CMYK_C": 0,
    "CMYK_M": 0.27198746800423,
    "CMYK_Y": 0.35569161176682,
    "CMYK_K": 0.1138396859169
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0234",
    "Farbtonhilfsbezeichnung": "24.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "134",
    "Bcolor": "111",
    "Y": 32,
    "L": 61.572135925293,
    "a": 21.647985458374,
    "b": 21.5530319213867,
    "C": 30.5478057861328,
    "h": 44.8740653991699,
    "CMY_C": 0.22955453395844,
    "CMY_M": 0.47570937871933,
    "CMY_Y": 0.5655974149704,
    "CMYK_C": 0,
    "CMYK_M": 0.31949678063393,
    "CMYK_Y": 0.43616700172424,
    "CMYK_K": 0.22955453395844
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0235",
    "Farbtonhilfsbezeichnung": "24.15.12",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "180",
    "Bcolor": "156",
    "Y": 56,
    "L": 79.7243728637695,
    "a": 23.9505310058594,
    "b": 22.2836990356445,
    "C": 32.7137756347656,
    "h": 42.9352722167969,
    "CMY_C": 0.00591230392456,
    "CMY_M": 0.2924177646637,
    "CMY_Y": 0.38778060674667,
    "CMYK_C": 0,
    "CMYK_M": 0.28820943832397,
    "CMYK_Y": 0.38413944840431,
    "CMYK_K": 0.00591230392456
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0236",
    "Farbtonhilfsbezeichnung": "24.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "160",
    "Bcolor": "134",
    "Y": 45,
    "L": 73.5693817138672,
    "a": 28.1524143218994,
    "b": 25.4883728027344,
    "C": 37.9765129089355,
    "h": 42.1567726135254,
    "CMY_C": 0.04721158742905,
    "CMY_M": 0.3712323307991,
    "CMY_Y": 0.47283905744553,
    "CMYK_C": 0,
    "CMYK_M": 0.34007629752159,
    "CMYK_Y": 0.4467177093029,
    "CMYK_K": 0.04721158742905
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0237",
    "Farbtonhilfsbezeichnung": "24.15.18",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "127",
    "Bcolor": "107",
    "Y": 30,
    "L": 62.4645881652832,
    "a": 32.7955284118652,
    "b": 25.1820068359375,
    "C": 41.3482780456543,
    "h": 37.5188140869141,
    "CMY_C": 0.15102469921112,
    "CMY_M": 0.50147098302841,
    "CMY_Y": 0.57953375577927,
    "CMYK_C": 0,
    "CMYK_M": 0.41278737783432,
    "CMYK_Y": 0.5047367811203,
    "CMYK_K": 0.15102469921112
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0238",
    "Farbtonhilfsbezeichnung": "24.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "109",
    "Bcolor": "75",
    "Y": 29,
    "L": 61.9075698852539,
    "a": 49.2324714660645,
    "b": 43.2298583984375,
    "C": 65.5183715820313,
    "h": 41.2855987548828,
    "CMY_C": 0.05147206783295,
    "CMY_M": 0.57250726222992,
    "CMY_Y": 0.70770013332367,
    "CMYK_C": 0,
    "CMYK_M": 0.54930925369263,
    "CMYK_Y": 0.69183844327927,
    "CMYK_K": 0.05147206783295
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0239",
    "Farbtonhilfsbezeichnung": "24.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "88",
    "Bcolor": "38",
    "Y": 24,
    "L": 55.0129623413086,
    "a": 51.0027236938477,
    "b": 53.0454902648926,
    "C": 73.5873794555664,
    "h": 46.1247367858887,
    "CMY_C": 0.12219089269638,
    "CMY_M": 0.65491724014282,
    "CMY_Y": 0.84913778305054,
    "CMYK_C": 0,
    "CMYK_M": 0.60688179731369,
    "CMYK_Y": 0.82813781499863,
    "CMYK_K": 0.12219089269638
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0240",
    "Farbtonhilfsbezeichnung": "27.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "224",
    "Bcolor": "214",
    "Y": 75,
    "L": 90.2692337036133,
    "a": 4.82228994369507,
    "b": 6.13915300369263,
    "C": 7.80664348602295,
    "h": 51.8504524230957,
    "CMY_C": 0.05263596773148,
    "CMY_M": 0.1221421957016,
    "CMY_Y": 0.16083872318268,
    "CMYK_C": 0,
    "CMYK_M": 0.07336802780628,
    "CMYK_Y": 0.11421454697847,
    "CMYK_K": 0.05263596773148
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0241",
    "Farbtonhilfsbezeichnung": "27.06.03",
    "Farbtonklasse": "01",
    "Y": 77,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0242",
    "Farbtonhilfsbezeichnung": "27.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "208",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.3778762817383,
    "a": 8.41606330871582,
    "b": 5.58832597732544,
    "C": 10.1024503707886,
    "h": 33.5844421386719,
    "CMY_C": 0.08292478322983,
    "CMY_M": 0.18488216400146,
    "CMY_Y": 0.20945519208908,
    "CMYK_C": 0,
    "CMYK_M": 0.11117668449879,
    "CMYK_Y": 0.13797168433666,
    "CMYK_K": 0.08292478322983
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0243",
    "Farbtonhilfsbezeichnung": "27.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "194",
    "Bcolor": "189",
    "Y": 57,
    "L": 80.6547927856445,
    "a": 9.57435321807861,
    "b": 5.36109018325806,
    "C": 10.9731273651123,
    "h": 29.2463302612305,
    "CMY_C": 0.12811505794525,
    "CMY_M": 0.239148914814,
    "CMY_Y": 0.25841319561005,
    "CMYK_C": 0,
    "CMYK_M": 0.12734921276569,
    "CMYK_Y": 0.14944419264793,
    "CMYK_K": 0.12811505794525
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0244",
    "Farbtonhilfsbezeichnung": "27.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "172",
    "Bcolor": "167",
    "Y": 45,
    "L": 73.1555938720703,
    "a": 11.3529272079468,
    "b": 6.48725938796997,
    "C": 13.07568359375,
    "h": 29.7443943023682,
    "CMY_C": 0.19583362340927,
    "CMY_M": 0.32421714067459,
    "CMY_Y": 0.3454195857048,
    "CMYK_C": 0,
    "CMYK_M": 0.15964795649052,
    "CMYK_Y": 0.18601369857788,
    "CMYK_K": 0.19583362340927
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0245",
    "Farbtonhilfsbezeichnung": "27.08.18",
    "Farbtonklasse": "01",
    "Y": 40,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0246",
    "Farbtonhilfsbezeichnung": "27.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "221",
    "Bcolor": "211",
    "Y": 77,
    "L": 90.3718643188477,
    "a": 9.2512321472168,
    "b": 7.82322597503662,
    "C": 12.1156167984009,
    "h": 40.2192497253418,
    "CMY_C": 0.01412749290466,
    "CMY_M": 0.13259202241898,
    "CMY_Y": 0.17148298025131,
    "CMYK_C": 0,
    "CMYK_M": 0.12016212195158,
    "CMYK_Y": 0.15961037576199,
    "CMYK_K": 0.01412749290466
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0247",
    "Farbtonhilfsbezeichnung": "27.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "204",
    "Bcolor": "194",
    "Y": 65,
    "L": 84.7903518676758,
    "a": 11.8735971450806,
    "b": 8.9105339050293,
    "C": 14.8451986312866,
    "h": 36.8863754272461,
    "CMY_C": 0.05605500936508,
    "CMY_M": 0.20104849338531,
    "CMY_Y": 0.23947697877884,
    "CMYK_C": 0,
    "CMYK_M": 0.15360374748707,
    "CMYK_Y": 0.19431425631046,
    "CMYK_K": 0.05605500936508
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0248",
    "Farbtonhilfsbezeichnung": "27.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "191",
    "Bcolor": "183",
    "Y": 58,
    "L": 80.7531661987305,
    "a": 14.3075542449951,
    "b": 9.10822677612305,
    "C": 16.9607162475586,
    "h": 32.4809379577637,
    "CMY_C": 0.08452880382538,
    "CMY_M": 0.25131273269653,
    "CMY_Y": 0.28363913297653,
    "CMYK_C": 0,
    "CMYK_M": 0.18218369781971,
    "CMYK_Y": 0.21749491989613,
    "CMYK_K": 0.08452880382538
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0249",
    "Farbtonhilfsbezeichnung": "27.12.15",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "168",
    "Bcolor": "158",
    "Y": 46,
    "L": 73.5159225463867,
    "a": 18.6692619323731,
    "b": 11.9866037368774,
    "C": 22.1860313415527,
    "h": 32.7025032043457,
    "CMY_C": 0.1309100985527,
    "CMY_M": 0.34113162755966,
    "CMY_Y": 0.3793517947197,
    "CMYK_C": 0,
    "CMYK_M": 0.24188697338104,
    "CMYK_Y": 0.28586420416832,
    "CMYK_K": 0.1309100985527
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0250",
    "Farbtonhilfsbezeichnung": "27.12.18",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "136",
    "Bcolor": "128",
    "Y": 31,
    "L": 62.8591690063477,
    "a": 24.2601356506348,
    "b": 13.8765640258789,
    "C": 27.9484024047852,
    "h": 29.7691402435303,
    "CMY_C": 0.21275126934052,
    "CMY_M": 0.46831858158112,
    "CMY_Y": 0.49971133470535,
    "CMYK_C": 0,
    "CMYK_M": 0.32463350892067,
    "CMYK_Y": 0.36451002955437,
    "CMYK_K": 0.21275126934052
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0251",
    "Farbtonhilfsbezeichnung": "27.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "205",
    "Y": 73,
    "L": 89.137077331543,
    "a": 14.2251949310303,
    "b": 9.63175106048584,
    "C": 17.1792545318604,
    "h": 34.1015739440918,
    "CMY_C": 0,
    "CMY_M": 0.15972262620926,
    "CMY_Y": 0.19746273756027,
    "CMYK_C": 0,
    "CMYK_M": 0.15972262620926,
    "CMYK_Y": 0.19746273756027,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0252",
    "Farbtonhilfsbezeichnung": "27.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "186",
    "Y": 65,
    "L": 84.6826248168945,
    "a": 19.7990493774414,
    "b": 13.1254930496216,
    "C": 23.7545986175537,
    "h": 33.5418128967285,
    "CMY_C": 0,
    "CMY_M": 0.22467362880707,
    "CMY_Y": 0.27001684904099,
    "CMYK_C": 0,
    "CMYK_M": 0.22467362880707,
    "CMYK_Y": 0.27001684904099,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0253",
    "Farbtonhilfsbezeichnung": "27.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "179",
    "Bcolor": "169",
    "Y": 55,
    "L": 79.1903991699219,
    "a": 24.3351058959961,
    "b": 14.7014875411987,
    "C": 28.4311637878418,
    "h": 31.1372947692871,
    "CMY_C": 0.02429163455963,
    "CMY_M": 0.29738992452621,
    "CMY_Y": 0.33863836526871,
    "CMYK_C": 0,
    "CMYK_M": 0.27989745140076,
    "CMYK_Y": 0.32217285037041,
    "CMYK_K": 0.02429163455963
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0254",
    "Farbtonhilfsbezeichnung": "27.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "167",
    "Bcolor": "156",
    "Y": 47,
    "L": 74.505859375,
    "a": 23.1339168548584,
    "b": 14.5964031219482,
    "C": 27.3538494110107,
    "h": 32.2499809265137,
    "CMY_C": 0.08608770370483,
    "CMY_M": 0.34385228157043,
    "CMY_Y": 0.38681536912918,
    "CMYK_C": 0,
    "CMYK_M": 0.28204521536827,
    "CMYK_Y": 0.32905527949333,
    "CMYK_K": 0.08608770370483
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0255",
    "Farbtonhilfsbezeichnung": "27.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "154",
    "Bcolor": "140",
    "Y": 44,
    "L": 72.4358520507813,
    "a": 32.7903022766113,
    "b": 20.911548614502,
    "C": 38.8908309936523,
    "h": 32.5271148681641,
    "CMY_C": 0.04046332836151,
    "CMY_M": 0.39665025472641,
    "CMY_Y": 0.4507999420166,
    "CMYK_C": 0,
    "CMYK_M": 0.37120720744133,
    "CMYK_Y": 0.42764037847519,
    "CMYK_K": 0.04046332836151
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0256",
    "Farbtonhilfsbezeichnung": "27.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "120",
    "Bcolor": "106",
    "Y": 30,
    "L": 62.3874053955078,
    "a": 40.5615844726563,
    "b": 25.9473896026611,
    "C": 48.1509017944336,
    "h": 32.6071929931641,
    "CMY_C": 0.10848289728165,
    "CMY_M": 0.52946209907532,
    "CMY_Y": 0.58369898796082,
    "CMYK_C": 0,
    "CMYK_M": 0.47220540046692,
    "CMYK_Y": 0.53304201364517,
    "CMYK_K": 0.10848289728165
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0257",
    "Farbtonhilfsbezeichnung": "27.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "115",
    "Bcolor": "105",
    "Y": 30,
    "L": 62.3794097900391,
    "a": 45.3833312988281,
    "b": 27.0125198364258,
    "C": 52.8140411376953,
    "h": 30.7614440917969,
    "CMY_C": 0.08144515752792,
    "CMY_M": 0.54823482036591,
    "CMY_Y": 0.58989405632019,
    "CMYK_C": 0,
    "CMYK_M": 0.50817835330963,
    "CMYK_Y": 0.55353134870529,
    "CMYK_K": 0.08144515752792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0258",
    "Farbtonhilfsbezeichnung": "30.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "224",
    "Bcolor": "221",
    "Y": 76,
    "L": 90.2278213500977,
    "a": 5.16686582565308,
    "b": 2.49493098258972,
    "C": 5.73769855499268,
    "h": 25.7745609283447,
    "CMY_C": 0.06163132190704,
    "CMY_M": 0.12243545055389,
    "CMY_Y": 0.13432246446609,
    "CMYK_C": 0,
    "CMYK_M": 0.06479769945145,
    "CMYK_Y": 0.07746543735266,
    "CMYK_K": 0.06163132190704
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0259",
    "Farbtonhilfsbezeichnung": "30.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "208",
    "Bcolor": "206",
    "Y": 65,
    "L": 84.9900665283203,
    "a": 6.21313333511353,
    "b": 2.58678984642029,
    "C": 6.73011922836304,
    "h": 22.604024887085,
    "CMY_C": 0.11214816570282,
    "CMY_M": 0.18280464410782,
    "CMY_Y": 0.19209277629852,
    "CMYK_C": 0,
    "CMYK_M": 0.07958138734102,
    "CMYK_Y": 0.09004274010658,
    "CMYK_K": 0.11214816570282
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0260",
    "Farbtonhilfsbezeichnung": "30.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "200",
    "Bcolor": "197",
    "Y": 59,
    "L": 81.6857528686523,
    "a": 5.57339000701904,
    "b": 2.46327042579651,
    "C": 6.09347009658813,
    "h": 23.8439846038818,
    "CMY_C": 0.15387415885925,
    "CMY_M": 0.21725332736969,
    "CMY_Y": 0.22702032327652,
    "CMYK_C": 0,
    "CMYK_M": 0.07490513473749,
    "CMYK_Y": 0.08644832670689,
    "CMYK_K": 0.15387415885925
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0261",
    "Farbtonhilfsbezeichnung": "30.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "173",
    "Bcolor": "171",
    "Y": 43,
    "L": 71.8341064453125,
    "a": 5.42534494400024,
    "b": 1.99340522289276,
    "C": 5.77996826171875,
    "h": 20.1745738983154,
    "CMY_C": 0.2636923789978,
    "CMY_M": 0.32241928577423,
    "CMY_Y": 0.32843112945557,
    "CMYK_C": 0,
    "CMYK_M": 0.07975865900517,
    "CMYK_Y": 0.08792351186275,
    "CMYK_K": 0.2636923789978
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0262",
    "Farbtonhilfsbezeichnung": "30.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "152",
    "Bcolor": "152",
    "Y": 33,
    "L": 64.2671813964844,
    "a": 7.21003818511963,
    "b": 1.68244707584381,
    "C": 7.40373420715332,
    "h": 13.1348123550415,
    "CMY_C": 0.33275401592255,
    "CMY_M": 0.40571063756943,
    "CMY_Y": 0.40454775094986,
    "CMYK_C": 0,
    "CMYK_M": 0.10933991521597,
    "CMYK_Y": 0.10759710520506,
    "CMYK_K": 0.33275401592255
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0263",
    "Farbtonhilfsbezeichnung": "30.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 77,
    "L": 90.30517578125,
    "a": 8.17709445953369,
    "b": 3.94086122512817,
    "C": 9.07718372344971,
    "h": 25.7312335968018,
    "CMY_C": 0.03386580944061,
    "CMY_M": 0.12951618432999,
    "CMY_Y": 0.14370596408844,
    "CMYK_C": 0,
    "CMYK_M": 0.09900319576263,
    "CMYK_Y": 0.11369036883116,
    "CMYK_K": 0.03386580944061
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0264",
    "Farbtonhilfsbezeichnung": "30.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "205",
    "Bcolor": "202",
    "Y": 65,
    "L": 84.5671539306641,
    "a": 9.74995899200439,
    "b": 4.29816389083862,
    "C": 10.6553230285645,
    "h": 23.7897644042969,
    "CMY_C": 0.08609336614609,
    "CMY_M": 0.19676697254181,
    "CMY_Y": 0.20862251520157,
    "CMYK_C": 0,
    "CMYK_M": 0.12109946459532,
    "CMYK_Y": 0.13407184183598,
    "CMYK_K": 0.08609336614609
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0265",
    "Farbtonhilfsbezeichnung": "30.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "187",
    "Bcolor": "184",
    "Y": 55,
    "L": 78.9152221679688,
    "a": 13.6612567901611,
    "b": 5.83629035949707,
    "C": 14.8557138442993,
    "h": 23.1328868865967,
    "CMY_C": 0.11787885427475,
    "CMY_M": 0.26853036880493,
    "CMY_Y": 0.27974909543991,
    "CMYK_C": 0,
    "CMYK_M": 0.17078325152397,
    "CMYK_Y": 0.18350113928318,
    "CMYK_K": 0.11787885427475
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0266",
    "Farbtonhilfsbezeichnung": "30.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "163",
    "Bcolor": "162",
    "Y": 43,
    "L": 71.8382263183594,
    "a": 19.99245262146,
    "b": 7.42244911193848,
    "C": 21.3258266448975,
    "h": 20.3680763244629,
    "CMY_C": 0.1514156460762,
    "CMY_M": 0.36126506328583,
    "CMY_Y": 0.36437439918518,
    "CMYK_C": 0,
    "CMYK_M": 0.24729353189468,
    "CMYK_Y": 0.25095766782761,
    "CMYK_K": 0.1514156460762
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0267",
    "Farbtonhilfsbezeichnung": "30.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "140",
    "Bcolor": "138",
    "Y": 33,
    "L": 64.5486068725586,
    "a": 24.4304351806641,
    "b": 10.3531627655029,
    "C": 26.5336418151856,
    "h": 22.9663257598877,
    "CMY_C": 0.19940906763077,
    "CMY_M": 0.45055937767029,
    "CMY_Y": 0.45860975980759,
    "CMYK_C": 0,
    "CMYK_M": 0.31370615959167,
    "CMYK_Y": 0.32376170158386,
    "CMYK_K": 0.19940906763077
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0268",
    "Farbtonhilfsbezeichnung": "30.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "214",
    "Y": 76,
    "L": 90.0380554199219,
    "a": 11.5483102798462,
    "b": 5.98671770095825,
    "C": 13.0078535079956,
    "h": 27.4025096893311,
    "CMY_C": 0.00648856163025,
    "CMY_M": 0.14170998334885,
    "CMY_Y": 0.1612166762352,
    "CMYK_C": 0,
    "CMYK_M": 0.13610453903675,
    "CMYK_Y": 0.15573863685131,
    "CMYK_K": 0.00648856163025
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0269",
    "Farbtonhilfsbezeichnung": "30.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "202",
    "Bcolor": "197",
    "Y": 66,
    "L": 85.0913467407227,
    "a": 16.4659652709961,
    "b": 7.77399826049805,
    "C": 18.2088737487793,
    "h": 25.2731800079346,
    "CMY_C": 0.02381879091263,
    "CMY_M": 0.20961493253708,
    "CMY_Y": 0.22722858190536,
    "CMYK_C": 0,
    "CMYK_M": 0.19032956659794,
    "CMYK_Y": 0.20837298035622,
    "CMYK_K": 0.02381879091263
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0270",
    "Farbtonhilfsbezeichnung": "30.15.12",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "183",
    "Bcolor": "179",
    "Y": 56,
    "L": 79.4624862670898,
    "a": 20.3122367858887,
    "b": 9.46645545959473,
    "C": 22.4098358154297,
    "h": 24.9877281188965,
    "CMY_C": 0.0583593249321,
    "CMY_M": 0.28160673379898,
    "CMY_Y": 0.2989147901535,
    "CMYK_C": 0,
    "CMYK_M": 0.23708343505859,
    "CMYK_Y": 0.25546419620514,
    "CMYK_K": 0.0583593249321
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0271",
    "Farbtonhilfsbezeichnung": "30.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "158",
    "Bcolor": "155",
    "Y": 43,
    "L": 72.0694732666016,
    "a": 26.4571399688721,
    "b": 12.0020236968994,
    "C": 29.052173614502,
    "h": 24.4009571075439,
    "CMY_C": 0.09861552715302,
    "CMY_M": 0.3786336183548,
    "CMY_Y": 0.39304262399673,
    "CMYK_C": 0,
    "CMYK_M": 0.31065332889557,
    "CMYK_Y": 0.32663875818253,
    "CMYK_K": 0.09861552715302
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0272",
    "Farbtonhilfsbezeichnung": "30.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "136",
    "Bcolor": "132",
    "Y": 34,
    "L": 64.8507614135742,
    "a": 29.8251094818115,
    "b": 14.4667329788208,
    "C": 33.1485061645508,
    "h": 25.8758029937744,
    "CMY_C": 0.15659493207932,
    "CMY_M": 0.46482050418854,
    "CMY_Y": 0.4828587770462,
    "CMYK_C": 0,
    "CMYK_M": 0.36545377969742,
    "CMYK_Y": 0.38684120774269,
    "CMYK_K": 0.15659493207932
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0273",
    "Farbtonhilfsbezeichnung": "30.18.12",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "178",
    "Bcolor": "180",
    "Y": 55,
    "L": 78.6482925415039,
    "a": 24.6348075866699,
    "b": 7.73026609420776,
    "C": 25.8191928863525,
    "h": 17.4215679168701,
    "CMY_C": 0.04360014200211,
    "CMY_M": 0.30217838287354,
    "CMY_Y": 0.29438811540604,
    "CMYK_C": 0,
    "CMYK_M": 0.27036625146866,
    "CMYK_Y": 0.26222082972527,
    "CMYK_K": 0.04360014200211
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0274",
    "Farbtonhilfsbezeichnung": "30.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "149",
    "Bcolor": "154",
    "Y": 42,
    "L": 71.0303421020508,
    "a": 34.8151588439941,
    "b": 10.908784866333,
    "C": 36.4841995239258,
    "h": 17.3975658416748,
    "CMY_C": 0.06232732534409,
    "CMY_M": 0.41539013385773,
    "CMY_Y": 0.39459699392319,
    "CMYK_C": 0,
    "CMYK_M": 0.37653097510338,
    "CMYK_Y": 0.35435572266579,
    "CMYK_K": 0.06232732534409
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0275",
    "Farbtonhilfsbezeichnung": "30.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "113",
    "Bcolor": "121",
    "Y": 28,
    "L": 60.4486770629883,
    "a": 43.5675849914551,
    "b": 14.9657583236694,
    "C": 46.066349029541,
    "h": 18.9579410552979,
    "CMY_C": 0.1297779083252,
    "CMY_M": 0.55807459354401,
    "CMY_Y": 0.52722787857056,
    "CMYK_C": 0,
    "CMYK_M": 0.49216940999031,
    "CMYK_Y": 0.45672246813774,
    "CMYK_K": 0.1297779083252
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0276",
    "Farbtonhilfsbezeichnung": "33.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "237",
    "Bcolor": "229",
    "Y": 84,
    "L": 94.0207386808527,
    "a": 1.26588108550457,
    "b": 3.55309105962136,
    "C": 3.77185776516022,
    "h": 1.22854138996634,
    "CMY_C": 0.04550653,
    "CMY_M": 0.07091617,
    "CMY_Y": 0.1008658,
    "CMYK_C": 0,
    "CMYK_M": 0.02662107,
    "CMYK_Y": 0.05799854,
    "CMYK_K": 0.04550653
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0277",
    "Farbtonhilfsbezeichnung": "33.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "227",
    "Bcolor": "223",
    "Y": 78,
    "L": 91.0468292236328,
    "a": 3.66114449501038,
    "b": 2.66860771179199,
    "C": 4.53050184249878,
    "h": 36.0883026123047,
    "CMY_C": 0.06332278251648,
    "CMY_M": 0.10968208312988,
    "CMY_Y": 0.1268070936203,
    "CMYK_C": 0,
    "CMYK_M": 0.04949335753918,
    "CMYK_Y": 0.06777608394623,
    "CMYK_K": 0.06332278251648
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0278",
    "Farbtonhilfsbezeichnung": "33.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "208",
    "Bcolor": "204",
    "Y": 66,
    "L": 84.5810852050781,
    "a": 4.41006469726563,
    "b": 3.14147114753723,
    "C": 5.41456460952759,
    "h": 35.4638404846191,
    "CMY_C": 0.1283894777298,
    "CMY_M": 0.18302845954895,
    "CMY_Y": 0.20083051919937,
    "CMYK_C": 0,
    "CMYK_M": 0.06268738210201,
    "CMYK_Y": 0.08311171084642,
    "CMYK_K": 0.1283894777298
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0279",
    "Farbtonhilfsbezeichnung": "33.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "196",
    "Bcolor": "193",
    "Y": 57,
    "L": 80.0657806396484,
    "a": 4.12307119369507,
    "b": 2.12214517593384,
    "C": 4.63715600967407,
    "h": 27.2348861694336,
    "CMY_C": 0.18343299627304,
    "CMY_M": 0.231225669384,
    "CMY_Y": 0.24217760562897,
    "CMYK_C": 0,
    "CMYK_M": 0.05852878466249,
    "CMYK_Y": 0.07194095104933,
    "CMYK_K": 0.18343299627304
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0280",
    "Farbtonhilfsbezeichnung": "33.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "177",
    "Bcolor": "176",
    "Y": 45,
    "L": 73.0681610107422,
    "a": 3.57134127616882,
    "b": 1.34141826629639,
    "C": 3.81495499610901,
    "h": 20.5864944458008,
    "CMY_C": 0.26579403877258,
    "CMY_M": 0.30477488040924,
    "CMY_Y": 0.31111043691635,
    "CMYK_C": 0,
    "CMYK_M": 0.05309251695871,
    "CMYK_Y": 0.06172164157033,
    "CMYK_K": 0.26579403877258
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0281",
    "Farbtonhilfsbezeichnung": "33.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "158",
    "Bcolor": "156",
    "Y": 35,
    "L": 65.8701782226563,
    "a": 4.08759689331055,
    "b": 1.58089780807495,
    "C": 4.38265752792358,
    "h": 21.1442184448242,
    "CMY_C": 0.33792680501938,
    "CMY_M": 0.38172882795334,
    "CMY_Y": 0.38778012990952,
    "CMYK_C": 0,
    "CMYK_M": 0.0661588832736,
    "CMYK_Y": 0.07529880851507,
    "CMYK_K": 0.33792680501938
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0282",
    "Farbtonhilfsbezeichnung": "33.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "209",
    "Bcolor": "209",
    "Y": 66,
    "L": 85.4382858276367,
    "a": 7.88566589355469,
    "b": 1.65138900279999,
    "C": 8.05672454833984,
    "h": 11.8277587890625,
    "CMY_C": 0.09764927625656,
    "CMY_M": 0.18178200721741,
    "CMY_Y": 0.18015879392624,
    "CMYK_C": 0,
    "CMYK_M": 0.09323728084564,
    "CMYK_Y": 0.09143841266632,
    "CMYK_K": 0.09764927625656
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0283",
    "Farbtonhilfsbezeichnung": "33.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "176",
    "Bcolor": "174",
    "Y": 47,
    "L": 73.7153549194336,
    "a": 9.09837913513184,
    "b": 3.13546657562256,
    "C": 9.62349510192871,
    "h": 19.0148811340332,
    "CMY_C": 0.2141130566597,
    "CMY_M": 0.31172150373459,
    "CMY_Y": 0.3162003159523,
    "CMYK_C": 0,
    "CMYK_M": 0.12420164048672,
    "CMYK_Y": 0.12990069389343,
    "CMYK_K": 0.2141130566597
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0284",
    "Farbtonhilfsbezeichnung": "33.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "133",
    "Bcolor": "135",
    "Y": 26,
    "L": 58.0215263366699,
    "a": 10.2593727111816,
    "b": 1.97275364398956,
    "C": 10.447319984436,
    "h": 10.8844356536865,
    "CMY_C": 0.37724250555038,
    "CMY_M": 0.47697132825851,
    "CMY_Y": 0.46953171491623,
    "CMYK_C": 0,
    "CMYK_M": 0.16014070808887,
    "CMYK_Y": 0.14819446206093,
    "CMYK_K": 0.37724250555038
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0286",
    "Farbtonhilfsbezeichnung": "33.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "225",
    "Bcolor": "223",
    "Y": 78,
    "L": 90.9880752563477,
    "a": 5.85343503952026,
    "b": 2.57356882095337,
    "C": 6.39421272277832,
    "h": 23.7335624694824,
    "CMY_C": 0.04763692617416,
    "CMY_M": 0.11571389436722,
    "CMY_Y": 0.12643402814865,
    "CMYK_C": 0,
    "CMYK_M": 0.07148215919733,
    "CMYK_Y": 0.08273851126432,
    "CMYK_K": 0.04763692617416
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0287",
    "Farbtonhilfsbezeichnung": "33.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "205",
    "Bcolor": "207",
    "Y": 65,
    "L": 84.6458511352539,
    "a": 9.68593215942383,
    "b": 1.66684746742249,
    "C": 9.82830905914307,
    "h": 9.76436328887939,
    "CMY_C": 0.09331113100052,
    "CMY_M": 0.1949959397316,
    "CMY_Y": 0.18863189220428,
    "CMYK_C": 0,
    "CMYK_M": 0.11214961856604,
    "CMYK_Y": 0.10513062030077,
    "CMYK_K": 0.09331113100052
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0288",
    "Farbtonhilfsbezeichnung": "33.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "188",
    "Bcolor": "191",
    "Y": 56,
    "L": 80.0280456542969,
    "a": 15.5918245315552,
    "b": 3.3710823059082,
    "C": 15.9520902633667,
    "h": 12.2000370025635,
    "CMY_C": 0.09864664077759,
    "CMY_M": 0.26094871759415,
    "CMY_Y": 0.24989855289459,
    "CMYK_C": 0,
    "CMYK_M": 0.18006487190723,
    "CMYK_Y": 0.16780534386635,
    "CMYK_K": 0.09864664077759
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0289",
    "Farbtonhilfsbezeichnung": "33.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "161",
    "Bcolor": "167",
    "Y": 44,
    "L": 71.3638534545898,
    "a": 21.1084804534912,
    "b": 4.03827905654907,
    "C": 21.4912929534912,
    "h": 10.8304328918457,
    "CMY_C": 0.15743446350098,
    "CMY_M": 0.36841070652008,
    "CMY_Y": 0.34541875123978,
    "CMYK_C": 0,
    "CMYK_M": 0.25039741396904,
    "CMYK_Y": 0.2231093943119,
    "CMYK_K": 0.15743446350098
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0290",
    "Farbtonhilfsbezeichnung": "33.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "138",
    "Bcolor": "144",
    "Y": 31,
    "L": 62.3751487731934,
    "a": 20.6474571228027,
    "b": 3.34653878211975,
    "C": 20.9169025421143,
    "h": 9.20643711090088,
    "CMY_C": 0.26132243871689,
    "CMY_M": 0.46017277240753,
    "CMY_Y": 0.43333506584167,
    "CMYK_C": 0,
    "CMYK_M": 0.26919773221016,
    "CMYK_Y": 0.23286564648151,
    "CMYK_K": 0.26132243871689
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0291",
    "Farbtonhilfsbezeichnung": "36.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.4724960327148,
    "a": 2.4518895149231,
    "b": 1.15925526618958,
    "C": 2.7121274471283,
    "h": 25.3048210144043,
    "CMY_C": 0.05028563737869,
    "CMY_M": 0.07922148704529,
    "CMY_Y": 0.08894437551498,
    "CMYK_C": 0,
    "CMYK_M": 0.03046794980764,
    "CMYK_Y": 0.04070564731956,
    "CMYK_K": 0.05028563737869
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0292",
    "Farbtonhilfsbezeichnung": "36.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "225",
    "Bcolor": "223",
    "Y": 76,
    "L": 90.1566619873047,
    "a": 3.02828598022461,
    "b": 1.26536214351654,
    "C": 3.28202033042908,
    "h": 22.6774959564209,
    "CMY_C": 0.08268809318542,
    "CMY_M": 0.1176398396492,
    "CMY_Y": 0.12633228302002,
    "CMYK_C": 0,
    "CMYK_M": 0.03810235857964,
    "CMYK_Y": 0.0475783534348,
    "CMYK_K": 0.08268809318542
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0293",
    "Farbtonhilfsbezeichnung": "36.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "210",
    "Bcolor": "208",
    "Y": 65,
    "L": 84.6377639770508,
    "a": 2.81484246253967,
    "b": 0.95454806089401,
    "C": 2.97228860855103,
    "h": 18.7324352264404,
    "CMY_C": 0.14667594432831,
    "CMY_M": 0.17794978618622,
    "CMY_Y": 0.18450683355331,
    "CMYK_C": 0,
    "CMYK_M": 0.0366494320333,
    "CMYK_Y": 0.04433355480433,
    "CMYK_K": 0.14667594432831
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0294",
    "Farbtonhilfsbezeichnung": "36.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "190",
    "Bcolor": "191",
    "Y": 53,
    "L": 77.7419662475586,
    "a": 3.69124794006348,
    "b": 0.0450804643333,
    "C": 3.69152331352234,
    "h": 0.69970697164536,
    "CMY_C": 0.21849489212036,
    "CMY_M": 0.25470399856567,
    "CMY_Y": 0.25222915410995,
    "CMYK_C": 0,
    "CMYK_M": 0.04633252695203,
    "CMYK_Y": 0.04316575825214,
    "CMYK_K": 0.21849489212036
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0295",
    "Farbtonhilfsbezeichnung": "36.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "178",
    "Bcolor": "179",
    "Y": 46,
    "L": 73.4975280761719,
    "a": 4.04589462280273,
    "b": 0.18968111276627,
    "C": 4.05033874511719,
    "h": 2.68419623374939,
    "CMY_C": 0.26127088069916,
    "CMY_M": 0.30100685358047,
    "CMY_Y": 0.29837065935135,
    "CMYK_C": 0,
    "CMYK_M": 0.05378963798285,
    "CMYK_Y": 0.0502210855484,
    "CMYK_K": 0.26127088069916
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0296",
    "Farbtonhilfsbezeichnung": "36.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "149",
    "Bcolor": "151",
    "Y": 31,
    "L": 62.6543121337891,
    "a": 3.90542840957642,
    "b": -0.0999304279685,
    "C": 3.90670657157898,
    "h": 358.534271240234,
    "CMY_C": 0.37792229652405,
    "CMY_M": 0.41413831710815,
    "CMY_Y": 0.40929651260376,
    "CMYK_C": 0,
    "CMYK_M": 0.05821784213185,
    "CMYK_Y": 0.05043455958366,
    "CMYK_K": 0.37792229652405
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0297",
    "Farbtonhilfsbezeichnung": "36.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "234",
    "Bcolor": "232",
    "Y": 84,
    "L": 93.5332412719727,
    "a": 3.98260617256165,
    "b": 1.55898773670197,
    "C": 4.27686738967896,
    "h": 21.377815246582,
    "CMY_C": 0.03640431165695,
    "CMY_M": 0.08240211009979,
    "CMY_Y": 0.09102648496628,
    "CMYK_C": 0,
    "CMYK_M": 0.04773557931185,
    "CMYK_Y": 0.05668577924371,
    "CMYK_K": 0.03640431165695
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0298",
    "Farbtonhilfsbezeichnung": "36.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "222",
    "Bcolor": "224",
    "Y": 75,
    "L": 89.8911666870117,
    "a": 6.15337467193604,
    "b": 0.03813455998898,
    "C": 6.15349292755127,
    "h": 0.35507693886757,
    "CMY_C": 0.06573873758316,
    "CMY_M": 0.12790459394455,
    "CMY_Y": 0.1197624206543,
    "CMYK_C": 0,
    "CMYK_M": 0.06654012203217,
    "CMYK_Y": 0.05782502889633,
    "CMYK_K": 0.06573873758316
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0299",
    "Farbtonhilfsbezeichnung": "36.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "208",
    "Bcolor": "212",
    "Y": 66,
    "L": 85.3754589865033,
    "a": 8.31687038777157,
    "b": -0.19281589297193,
    "C": 8.3191051811823,
    "h": -0.02317955552359,
    "CMY_C": 0.1008434,
    "CMY_M": 0.1830522,
    "CMY_Y": 0.1673358,
    "CMYK_C": 0,
    "CMYK_M": 0.09142882,
    "CMYK_Y": 0.07394975,
    "CMYK_K": 0.1008434
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0300",
    "Farbtonhilfsbezeichnung": "36.06.12",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "194",
    "Bcolor": "202",
    "Y": 58,
    "L": 80.8892517089844,
    "a": 11.3679780960083,
    "b": -1.47786748409271,
    "C": 11.4636392593384,
    "h": 352.592926025391,
    "CMY_C": 0.13245314359665,
    "CMY_M": 0.23921066522598,
    "CMY_Y": 0.20636737346649,
    "CMYK_C": 0,
    "CMYK_M": 0.12305677682161,
    "CMYK_Y": 0.08519911766052,
    "CMYK_K": 0.13245314359665
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0301",
    "Farbtonhilfsbezeichnung": "36.06.15",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "171",
    "Bcolor": "181",
    "Y": 45,
    "L": 72.784423828125,
    "a": 12.0337762832642,
    "b": -1.69869697093964,
    "C": 12.1530799865723,
    "h": 351.965179443359,
    "CMY_C": 0.21756511926651,
    "CMY_M": 0.32757532596588,
    "CMY_Y": 0.2915078997612,
    "CMYK_C": 0,
    "CMYK_M": 0.14059981703758,
    "CMYK_Y": 0.09450343251228,
    "CMYK_K": 0.21756511926651
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0302",
    "Farbtonhilfsbezeichnung": "36.06.18",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "143",
    "Bcolor": "155",
    "Y": 31,
    "L": 62.7497253417969,
    "a": 14.9467210769653,
    "b": -2.22388696670532,
    "C": 15.1112585067749,
    "h": 351.537170410156,
    "CMY_C": 0.30759423971176,
    "CMY_M": 0.43943464756012,
    "CMY_Y": 0.39233469963074,
    "CMYK_C": 0,
    "CMYK_M": 0.19040916860104,
    "CMYK_Y": 0.12238554656506,
    "CMYK_K": 0.30759423971176
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0303",
    "Farbtonhilfsbezeichnung": "36.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "217",
    "Bcolor": "223",
    "Y": 73,
    "L": 88.6279678344727,
    "a": 9.34965133666992,
    "b": -0.81162184476852,
    "C": 9.3848123550415,
    "h": 355.038726806641,
    "CMY_C": 0.05862820148468,
    "CMY_M": 0.14966666698456,
    "CMY_Y": 0.12698465585709,
    "CMYK_C": 0,
    "CMYK_M": 0.09670829772949,
    "CMYK_Y": 0.07261366397142,
    "CMYK_K": 0.05862820148468
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0305",
    "Farbtonhilfsbezeichnung": "36.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "200",
    "Bcolor": "211",
    "Y": 65,
    "L": 84.4505615234375,
    "a": 16.5607433319092,
    "b": -0.80484557151794,
    "C": 16.5802898406982,
    "h": 357.217651367188,
    "CMY_C": 0.05357003211975,
    "CMY_M": 0.21436095237732,
    "CMY_Y": 0.17180240154266,
    "CMYK_C": 0,
    "CMYK_M": 0.16989204287529,
    "CMYK_Y": 0.1249245852232,
    "CMYK_K": 0.05357003211975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0306",
    "Farbtonhilfsbezeichnung": "36.09.12",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "182",
    "Bcolor": "200",
    "Y": 56,
    "L": 79.4125061035156,
    "a": 22.5612506866455,
    "b": -2.15468239784241,
    "C": 22.6639080047607,
    "h": 354.544586181641,
    "CMY_C": 0.07302868366241,
    "CMY_M": 0.28504693508148,
    "CMY_Y": 0.21588557958603,
    "CMYK_C": 0,
    "CMYK_M": 0.22872148454189,
    "CMYK_Y": 0.15411145985126,
    "CMYK_K": 0.07302868366241
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0307",
    "Farbtonhilfsbezeichnung": "36.09.15",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "157",
    "Bcolor": "184",
    "Y": 44,
    "L": 71.8338394165039,
    "a": 29.7578887939453,
    "b": -4.57658672332764,
    "C": 30.1077575683594,
    "h": 351.256744384766,
    "CMY_C": 0.11792457103729,
    "CMY_M": 0.38607060909271,
    "CMY_Y": 0.2789221405983,
    "CMYK_C": 0,
    "CMYK_M": 0.30399444699287,
    "CMYK_Y": 0.18252131342888,
    "CMYK_K": 0.11792457103729
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0308",
    "Farbtonhilfsbezeichnung": "36.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "135",
    "Bcolor": "160",
    "Y": 32,
    "L": 63.2535781860352,
    "a": 27.907018661499,
    "b": -4.01003837585449,
    "C": 28.1936531066895,
    "h": 351.822967529297,
    "CMY_C": 0.22407537698746,
    "CMY_M": 0.46993869543076,
    "CMY_Y": 0.37316846847534,
    "CMYK_C": 0,
    "CMYK_M": 0.31686493754387,
    "CMYK_Y": 0.19214893877506,
    "CMYK_K": 0.22407537698746
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0309",
    "Farbtonhilfsbezeichnung": "39.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "225",
    "Y": 75,
    "L": 90.1326370239258,
    "a": 5.2360634803772,
    "b": 0.14873319864273,
    "C": 5.23817539215088,
    "h": 1.62707984447479,
    "CMY_C": 0.06965333223343,
    "CMY_M": 0.12298625707626,
    "CMY_Y": 0.11804264783859,
    "CMYK_C": 0,
    "CMYK_M": 0.05732586234808,
    "CMYK_Y": 0.05201213434339,
    "CMYK_K": 0.06965333223343
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0310",
    "Farbtonhilfsbezeichnung": "39.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "214",
    "Bcolor": "215",
    "Y": 68,
    "L": 86.4980697631836,
    "a": 4.84780025482178,
    "b": -0.03989904001355,
    "C": 4.8479642868042,
    "h": 359.528442382813,
    "CMY_C": 0.11382615566254,
    "CMY_M": 0.16214674711227,
    "CMY_Y": 0.15666407346725,
    "CMYK_C": 0,
    "CMYK_M": 0.05452721565962,
    "CMYK_Y": 0.04834030941129,
    "CMYK_K": 0.11382615566254
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0311",
    "Farbtonhilfsbezeichnung": "39.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "200",
    "Bcolor": "204",
    "Y": 58,
    "L": 81.3825836181641,
    "a": 4.47409677505493,
    "b": -1.51619517803192,
    "C": 4.72402238845825,
    "h": 341.279357910156,
    "CMY_C": 0.17794400453568,
    "CMY_M": 0.21675175428391,
    "CMY_Y": 0.20169341564178,
    "CMYK_C": 0,
    "CMYK_M": 0.04720816016197,
    "CMYK_Y": 0.02889025956392,
    "CMYK_K": 0.17794400453568
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0312",
    "Farbtonhilfsbezeichnung": "39.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "176",
    "Bcolor": "181",
    "Y": 45,
    "L": 72.8366088867188,
    "a": 4.36173725128174,
    "b": -2.04848980903625,
    "C": 4.81882381439209,
    "h": 334.842895507813,
    "CMY_C": 0.27314376831055,
    "CMY_M": 0.30814236402512,
    "CMY_Y": 0.28951424360275,
    "CMYK_C": 0,
    "CMYK_M": 0.04815064370632,
    "CMYK_Y": 0.02252230234444,
    "CMYK_K": 0.27314376831055
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0313",
    "Farbtonhilfsbezeichnung": "39.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 31,
    "L": 62.488826751709,
    "a": 4.60336112976074,
    "b": -1.5565459728241,
    "C": 4.85940027236938,
    "h": 341.317932128906,
    "CMY_C": 0.37913465499878,
    "CMY_M": 0.41704469919205,
    "CMY_Y": 0.40093493461609,
    "CMYK_C": 0,
    "CMYK_M": 0.06106001138687,
    "CMYK_Y": 0.03511273488402,
    "CMYK_K": 0.37913465499878
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0314",
    "Farbtonhilfsbezeichnung": "39.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "208",
    "Bcolor": "215",
    "Y": 67,
    "L": 85.1321868896484,
    "a": 7.5753927230835,
    "b": -2.24460411071777,
    "C": 7.90093803405762,
    "h": 343.495330810547,
    "CMY_C": 0.11557197570801,
    "CMY_M": 0.18321996927261,
    "CMY_Y": 0.15514463186264,
    "CMYK_C": 0,
    "CMYK_M": 0.07648784667253,
    "CMYK_Y": 0.04474378377199,
    "CMYK_K": 0.11557197570801
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0315",
    "Farbtonhilfsbezeichnung": "39.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "193",
    "Bcolor": "200",
    "Y": 57,
    "L": 79.9659881591797,
    "a": 8.44417667388916,
    "b": -1.80337429046631,
    "C": 8.63459777832031,
    "h": 347.944763183594,
    "CMY_C": 0.16489070653915,
    "CMY_M": 0.24172687530518,
    "CMY_Y": 0.21441036462784,
    "CMYK_C": 0,
    "CMYK_M": 0.09200732409954,
    "CMYK_Y": 0.0592972189188,
    "CMYK_K": 0.16489070653915
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0316",
    "Farbtonhilfsbezeichnung": "39.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "173",
    "Bcolor": "184",
    "Y": 45,
    "L": 72.8458557128906,
    "a": 9.87714099884033,
    "b": -3.52875399589539,
    "C": 10.4885663986206,
    "h": 340.339996337891,
    "CMY_C": 0.23763126134872,
    "CMY_M": 0.32096058130264,
    "CMY_Y": 0.27825033664703,
    "CMYK_C": 0,
    "CMYK_M": 0.10930316895247,
    "CMYK_Y": 0.05328008905053,
    "CMYK_K": 0.23763126134872
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0317",
    "Farbtonhilfsbezeichnung": "39.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "147",
    "Bcolor": "159",
    "Y": 32,
    "L": 63.3588714599609,
    "a": 10.6027708053589,
    "b": -3.81906461715698,
    "C": 11.2696056365967,
    "h": 340.191223144531,
    "CMY_C": 0.3349170088768,
    "CMY_M": 0.42173892259598,
    "CMY_Y": 0.37570542097092,
    "CMYK_C": 0,
    "CMYK_M": 0.13054297864437,
    "CMYK_Y": 0.06132830306888,
    "CMYK_K": 0.3349170088768
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0318",
    "Farbtonhilfsbezeichnung": "39.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "207",
    "Bcolor": "217",
    "Y": 67,
    "L": 85.747917175293,
    "a": 12.575909614563,
    "b": -1.84056055545807,
    "C": 12.7098846435547,
    "h": 351.673522949219,
    "CMY_C": 0.07050687074661,
    "CMY_M": 0.18932545185089,
    "CMY_Y": 0.1506495475769,
    "CMYK_C": 0,
    "CMYK_M": 0.12783159315586,
    "CMYK_Y": 0.08622191101313,
    "CMYK_K": 0.07050687074661
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0319",
    "Farbtonhilfsbezeichnung": "39.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "188",
    "Bcolor": "201",
    "Y": 56,
    "L": 79.2531280517578,
    "a": 13.7339715957642,
    "b": -3.3917350769043,
    "C": 14.1465845108032,
    "h": 346.127838134766,
    "CMY_C": 0.13946312665939,
    "CMY_M": 0.26239287853241,
    "CMY_Y": 0.20999020338058,
    "CMYK_C": 0,
    "CMYK_M": 0.14285239577293,
    "CMYK_Y": 0.081957064569,
    "CMYK_K": 0.13946312665939
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0320",
    "Farbtonhilfsbezeichnung": "39.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "165",
    "Bcolor": "183",
    "Y": 43,
    "L": 71.1425018310547,
    "a": 16.1193199157715,
    "b": -5.49087381362915,
    "C": 17.0288619995117,
    "h": 341.189147949219,
    "CMY_C": 0.21830958127975,
    "CMY_M": 0.35431277751923,
    "CMY_Y": 0.28174418210983,
    "CMYK_C": 0,
    "CMYK_M": 0.17398600280285,
    "CMYK_Y": 0.08115053921938,
    "CMYK_K": 0.21830958127975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0321",
    "Farbtonhilfsbezeichnung": "39.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "143",
    "Bcolor": "166",
    "Y": 33,
    "L": 63.6780204772949,
    "a": 18.7415561676025,
    "b": -7.03829145431519,
    "C": 20.0195770263672,
    "h": 339.416595458984,
    "CMY_C": 0.2860095500946,
    "CMY_M": 0.43843376636505,
    "CMY_Y": 0.34929883480072,
    "CMYK_C": 0,
    "CMYK_M": 0.21348215639591,
    "CMYK_Y": 0.08864164352417,
    "CMYK_K": 0.2860095500946
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0322",
    "Farbtonhilfsbezeichnung": "39.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "223",
    "Bcolor": "228",
    "Y": 76,
    "L": 90.5902862548828,
    "a": 7.86986541748047,
    "b": -0.92940759658813,
    "C": 7.92455530166626,
    "h": 353.264739990234,
    "CMY_C": 0.04797959327698,
    "CMY_M": 0.12415963411331,
    "CMY_Y": 0.10465449094772,
    "CMYK_C": 0,
    "CMYK_M": 0.08001933246851,
    "CMYK_Y": 0.05953117832541,
    "CMYK_K": 0.04797959327698
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0323",
    "Farbtonhilfsbezeichnung": "39.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "179",
    "Bcolor": "205",
    "Y": 54,
    "L": 78.2147521972656,
    "a": 23.5516529083252,
    "b": -6.76463556289673,
    "C": 24.5038909912109,
    "h": 343.974578857422,
    "CMY_C": 0.09271329641342,
    "CMY_M": 0.29921728372574,
    "CMY_Y": 0.19577538967133,
    "CMYK_C": 0,
    "CMYK_M": 0.22760610282421,
    "CMYK_Y": 0.1135937422514,
    "CMYK_K": 0.09271329641342
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0324",
    "Farbtonhilfsbezeichnung": "39.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "158",
    "Bcolor": "194",
    "Y": 44,
    "L": 72.1264877319336,
    "a": 29.6578712463379,
    "b": -9.65536499023438,
    "C": 31.1899890899658,
    "h": 341.966918945313,
    "CMY_C": 0.12871426343918,
    "CMY_M": 0.38091051578522,
    "CMY_Y": 0.24024510383606,
    "CMYK_C": 0,
    "CMYK_M": 0.28945297002792,
    "CMYK_Y": 0.12800718843937,
    "CMYK_K": 0.12871426343918
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0325",
    "Farbtonhilfsbezeichnung": "39.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "132",
    "Bcolor": "170",
    "Y": 32,
    "L": 63.1363220214844,
    "a": 32.6290893554688,
    "b": -10.2268238067627,
    "C": 34.1942291259766,
    "h": 342.597625732422,
    "CMY_C": 0.21179509162903,
    "CMY_M": 0.4836260676384,
    "CMY_Y": 0.33137661218643,
    "CMYK_C": 0,
    "CMYK_M": 0.34487348794937,
    "CMYK_Y": 0.15171374380589,
    "CMYK_K": 0.21179509162903
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0326",
    "Farbtonhilfsbezeichnung": "42.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "149",
    "Bcolor": "147",
    "Y": 32,
    "L": 61.7688789367676,
    "a": 1.36317932605743,
    "b": 0.38260021805763,
    "C": 1.41585338115692,
    "h": 15.6777086257935,
    "CMY_C": 0.40381062030792,
    "CMY_M": 0.41764330863953,
    "CMY_Y": 0.42198133468628,
    "CMYK_C": 0,
    "CMYK_M": 0.02320183627307,
    "CMYK_Y": 0.03047809191048,
    "CMYK_K": 0.40381062030792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0327",
    "Farbtonhilfsbezeichnung": "42.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "235",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.1288146972656,
    "a": 0.22488637268543,
    "b": 0.76426297426224,
    "C": 0.79666292667389,
    "h": 73.6033401489258,
    "CMY_C": 0.07300984859467,
    "CMY_M": 0.07758963108063,
    "CMY_Y": 0.09013551473618,
    "CMYK_C": 0,
    "CMYK_M": 0.00494048651308,
    "CMYK_Y": 0.01847448572516,
    "CMYK_K": 0.07300984859467
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0328",
    "Farbtonhilfsbezeichnung": "42.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "226",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.6606292724609,
    "a": 3.41135954856873,
    "b": 0.19404120743275,
    "C": 3.41687369346619,
    "h": 3.25552773475647,
    "CMY_C": 0.07761120796204,
    "CMY_M": 0.11265993118286,
    "CMY_Y": 0.11280196905136,
    "CMYK_C": 0,
    "CMYK_M": 0.0379977747798,
    "CMYK_Y": 0.03815176710486,
    "CMYK_K": 0.07761120796204
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0329",
    "Farbtonhilfsbezeichnung": "42.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "209",
    "Bcolor": "212",
    "Y": 65,
    "L": 84.5741348266602,
    "a": 4.05131816864014,
    "b": -1.12101209163666,
    "C": 4.20355176925659,
    "h": 344.533081054688,
    "CMY_C": 0.14473879337311,
    "CMY_M": 0.18102371692657,
    "CMY_Y": 0.16991126537323,
    "CMYK_C": 0,
    "CMYK_M": 0.04242554679513,
    "CMYK_Y": 0.02943249605596,
    "CMYK_K": 0.14473879337311
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0330",
    "Farbtonhilfsbezeichnung": "42.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "179",
    "Bcolor": "184",
    "Y": 45,
    "L": 73.6857147216797,
    "a": 4.71136331558228,
    "b": -2.11877512931824,
    "C": 5.16586399078369,
    "h": 335.785797119141,
    "CMY_C": 0.26167523860931,
    "CMY_M": 0.29992270469666,
    "CMY_Y": 0.27995854616165,
    "CMYK_C": 0,
    "CMYK_M": 0.05180303752422,
    "CMYK_Y": 0.02476323209703,
    "CMYK_K": 0.26167523860931
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0331",
    "Farbtonhilfsbezeichnung": "42.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "197",
    "Bcolor": "202",
    "Y": 57,
    "L": 80.3783340454102,
    "a": 4.31154775619507,
    "b": -2.00693035125732,
    "C": 4.75575590133667,
    "h": 335.0390625,
    "CMY_C": 0.19177800416946,
    "CMY_M": 0.22711682319641,
    "CMY_Y": 0.20904666185379,
    "CMYK_C": 0,
    "CMYK_M": 0.04372414946556,
    "CMYK_Y": 0.02136623114347,
    "CMYK_K": 0.19177800416946
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0332",
    "Farbtonhilfsbezeichnung": "42.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "151",
    "Bcolor": "158",
    "Y": 32,
    "L": 63.6778831481934,
    "a": 5.84611749649048,
    "b": -2.6975576877594,
    "C": 6.4384708404541,
    "h": 335.230102539063,
    "CMY_C": 0.3614217042923,
    "CMY_M": 0.40735578536987,
    "CMY_Y": 0.3807036280632,
    "CMYK_C": 0,
    "CMYK_M": 0.07193179428577,
    "CMYK_Y": 0.03019508160651,
    "CMYK_K": 0.3614217042923
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0333",
    "Farbtonhilfsbezeichnung": "42.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "146",
    "Bcolor": "161",
    "Y": 31,
    "L": 62.5389823913574,
    "a": 10.0175437927246,
    "b": -6.14309644699097,
    "C": 11.7511196136475,
    "h": 328.481964111328,
    "CMY_C": 0.35471314191818,
    "CMY_M": 0.42803186178207,
    "CMY_Y": 0.36837524175644,
    "CMYK_C": 0,
    "CMYK_M": 0.11362189799547,
    "CMYK_Y": 0.0211721342057,
    "CMYK_K": 0.35471314191818
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0334",
    "Farbtonhilfsbezeichnung": "42.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "220",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.7298965454102,
    "a": 9.67334079742432,
    "b": -2.80907416343689,
    "C": 10.0729551315308,
    "h": 343.807037353516,
    "CMY_C": 0.05015182495117,
    "CMY_M": 0.13770526647568,
    "CMY_Y": 0.10007095336914,
    "CMYK_C": 0,
    "CMYK_M": 0.09217625111341,
    "CMYK_Y": 0.05255484953523,
    "CMYK_K": 0.05015182495117
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0335",
    "Farbtonhilfsbezeichnung": "42.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "207",
    "Bcolor": "217",
    "Y": 66,
    "L": 85.2408905029297,
    "a": 9.88862419128418,
    "b": -2.92342925071716,
    "C": 10.3117084503174,
    "h": 343.530456542969,
    "CMY_C": 0.09929341077805,
    "CMY_M": 0.18764066696167,
    "CMY_Y": 0.14869076013565,
    "CMYK_C": 0,
    "CMYK_M": 0.09808661043644,
    "CMYK_Y": 0.05484288558364,
    "CMYK_K": 0.09929341077805
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0336",
    "Farbtonhilfsbezeichnung": "42.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "193",
    "Bcolor": "207",
    "Y": 57,
    "L": 80.4250640869141,
    "a": 11.4261655807495,
    "b": -4.77802610397339,
    "C": 12.3849420547485,
    "h": 337.307006835938,
    "CMY_C": 0.14741438627243,
    "CMY_M": 0.24337470531464,
    "CMY_Y": 0.18764048814774,
    "CMYK_C": 0,
    "CMYK_M": 0.11255212128162,
    "CMYK_Y": 0.04718130454421,
    "CMYK_K": 0.14741438627243
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0337",
    "Farbtonhilfsbezeichnung": "42.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "166",
    "Bcolor": "194",
    "Y": 44,
    "L": 72.5637664794922,
    "a": 20.2016735076904,
    "b": -9.39862060546875,
    "C": 22.2809715270996,
    "h": 335.05029296875,
    "CMY_C": 0.18637520074844,
    "CMY_M": 0.3490509390831,
    "CMY_Y": 0.23859304189682,
    "CMYK_C": 0,
    "CMYK_M": 0.19993950426579,
    "CMYK_Y": 0.064179264009,
    "CMYK_K": 0.18637520074844
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0338",
    "Farbtonhilfsbezeichnung": "42.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "143",
    "Bcolor": "168",
    "Y": 32,
    "L": 63.1476860046387,
    "a": 17.4284076690674,
    "b": -9.29944896697998,
    "C": 19.7542190551758,
    "h": 331.91650390625,
    "CMY_C": 0.3071340918541,
    "CMY_M": 0.43962782621384,
    "CMY_Y": 0.33953177928925,
    "CMYK_C": 0,
    "CMYK_M": 0.19122564792633,
    "CMYK_Y": 0.0467589572072,
    "CMYK_K": 0.3071340918541
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0339",
    "Farbtonhilfsbezeichnung": "42.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "143",
    "Bcolor": "178",
    "Y": 34,
    "L": 64.6106567382813,
    "a": 23.0554161071777,
    "b": -12.2247123718262,
    "C": 26.0958957672119,
    "h": 332.066040039063,
    "CMY_C": 0.26256322860718,
    "CMY_M": 0.4389785528183,
    "CMY_Y": 0.30338573455811,
    "CMYK_C": 0,
    "CMYK_M": 0.23922772705555,
    "CMYK_Y": 0.05535729601979,
    "CMYK_K": 0.26256322860718
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0340",
    "Farbtonhilfsbezeichnung": "42.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "157",
    "Bcolor": "199",
    "Y": 44,
    "L": 71.6658706665039,
    "a": 29.7753829956055,
    "b": -13.4626159667969,
    "C": 32.6774444580078,
    "h": 335.67041015625,
    "CMY_C": 0.14395326375961,
    "CMY_M": 0.38472473621368,
    "CMY_Y": 0.21850204467773,
    "CMYK_C": 0,
    "CMYK_M": 0.2812597155571,
    "CMYK_Y": 0.08708494156599,
    "CMYK_K": 0.14395326375961
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0341",
    "Farbtonhilfsbezeichnung": "42.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "133",
    "Bcolor": "184",
    "Y": 33,
    "L": 63.8126640319824,
    "a": 33.4891586303711,
    "b": -16.6826438903809,
    "C": 37.4143600463867,
    "h": 333.519775390625,
    "CMY_C": 0.21661341190338,
    "CMY_M": 0.47689735889435,
    "CMY_Y": 0.27998459339142,
    "CMYK_C": 0,
    "CMYK_M": 0.33225479722023,
    "CMYK_Y": 0.08089388161898,
    "CMYK_K": 0.21661341190338
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0342",
    "Farbtonhilfsbezeichnung": "42.21.12",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "187",
    "Bcolor": "214",
    "Y": 56,
    "L": 79.2456207275391,
    "a": 15.9080762863159,
    "b": -10.2412614822388,
    "C": 18.9195747375488,
    "h": 327.227478027344,
    "CMY_C": 0.14557856321335,
    "CMY_M": 0.26597905158997,
    "CMY_Y": 0.1606822013855,
    "CMYK_C": 0,
    "CMYK_M": 0.14091463387012,
    "CMYK_Y": 0.01767703518271,
    "CMYK_K": 0.14557856321335
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0343",
    "Farbtonhilfsbezeichnung": "42.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "167",
    "Bcolor": "204",
    "Y": 45,
    "L": 72.5990753173828,
    "a": 19.5879440307617,
    "b": -14.7987756729126,
    "C": 24.5497722625732,
    "h": 322.928802490234,
    "CMY_C": 0.20755594968796,
    "CMY_M": 0.34511750936508,
    "CMY_Y": 0.20026803016663,
    "CMYK_C": 0.00911295227706,
    "CMYK_M": 0.18112252652645,
    "CMYK_Y": 0,
    "CMYK_K": 0.20026803016663
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0344",
    "Farbtonhilfsbezeichnung": "42.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "139",
    "Bcolor": "186",
    "Y": 31,
    "L": 62.6727104187012,
    "a": 22.6509170532227,
    "b": -19.9425449371338,
    "C": 30.1789512634277,
    "h": 318.638336181641,
    "CMY_C": 0.31117159128189,
    "CMY_M": 0.45486783981323,
    "CMY_Y": 0.27105629444122,
    "CMYK_C": 0.0550320930779,
    "CMYK_M": 0.25216150283813,
    "CMYK_Y": 0,
    "CMYK_K": 0.27105629444122
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0345",
    "Farbtonhilfsbezeichnung": "45.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "238",
    "Bcolor": "236",
    "Y": 84,
    "L": 94.1181793212891,
    "a": 0.66800838708878,
    "b": -0.05920415371656,
    "C": 0.67062681913376,
    "h": 354.935241699219,
    "CMY_C": 0.06121915578842,
    "CMY_M": 0.06731826066971,
    "CMY_Y": 0.07293599843979,
    "CMYK_C": 0,
    "CMYK_M": 0.0064968355,
    "CMYK_Y": 0.01248091366142,
    "CMYK_K": 0.06121915578842
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0346",
    "Farbtonhilfsbezeichnung": "45.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "228",
    "Bcolor": "228",
    "Y": 77,
    "L": 90.717903137207,
    "a": 0.89605784416199,
    "b": -0.58540999889374,
    "C": 1.07033848762512,
    "h": 326.842712402344,
    "CMY_C": 0.09927952289581,
    "CMY_M": 0.10573279857635,
    "CMY_Y": 0.10675436258316,
    "CMYK_C": 0,
    "CMYK_M": 0.0071645709686,
    "CMYK_Y": 0.00829873420298,
    "CMYK_K": 0.09927952289581
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0347",
    "Farbtonhilfsbezeichnung": "45.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "212",
    "Bcolor": "215",
    "Y": 66,
    "L": 85.1221389770508,
    "a": 1.27971589565277,
    "b": -1.92699587345123,
    "C": 2.31321978569031,
    "h": 303.588104248047,
    "CMY_C": 0.16285222768784,
    "CMY_M": 0.16815781593323,
    "CMY_Y": 0.15842217206955,
    "CMYK_C": 0.00526398792863,
    "CMYK_M": 0.01156832277775,
    "CMYK_Y": 0,
    "CMYK_K": 0.15842217206955
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0348",
    "Farbtonhilfsbezeichnung": "45.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "181",
    "Bcolor": "184",
    "Y": 46,
    "L": 73.9008941650391,
    "a": 1.54353141784668,
    "b": -2.03054428100586,
    "C": 2.55060768127441,
    "h": 307.240509033203,
    "CMY_C": 0.28281849622726,
    "CMY_M": 0.29025691747665,
    "CMY_Y": 0.27870911359787,
    "CMYK_C": 0.00569726107642,
    "CMYK_M": 0.0160099118948,
    "CMYK_Y": 0,
    "CMYK_K": 0.27870911359787
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0349",
    "Farbtonhilfsbezeichnung": "45.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "151",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.7422561645508,
    "a": 2.27690410614014,
    "b": -3.54340791702271,
    "C": 4.21189165115356,
    "h": 302.723785400391,
    "CMY_C": 0.39971274137497,
    "CMY_M": 0.40858340263367,
    "CMY_Y": 0.38501423597336,
    "CMYK_C": 0.02390056289732,
    "CMYK_M": 0.03832473605871,
    "CMYK_Y": 0,
    "CMYK_K": 0.38501423597336
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0350",
    "Farbtonhilfsbezeichnung": "45.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "235",
    "Y": 83,
    "L": 93.3161849975586,
    "a": 0.96800911426544,
    "b": -0.71838021278381,
    "C": 1.20545089244843,
    "h": 323.420104980469,
    "CMY_C": 0.07011872529984,
    "CMY_M": 0.07684123516083,
    "CMY_Y": 0.07691782712936,
    "CMYK_C": 0,
    "CMYK_M": 0.00722942827269,
    "CMYK_Y": 0.00731179583818,
    "CMYK_K": 0.07011872529984
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0351",
    "Farbtonhilfsbezeichnung": "45.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "210",
    "Bcolor": "217",
    "Y": 65,
    "L": 85.0681838989258,
    "a": 4.48502540588379,
    "b": -3.43264889717102,
    "C": 5.64787864685059,
    "h": 322.571075439453,
    "CMY_C": 0.14372444152832,
    "CMY_M": 0.1759746670723,
    "CMY_Y": 0.14760506153107,
    "CMYK_C": 0,
    "CMYK_M": 0.03766337409616,
    "CMYK_Y": 0.00453197583556,
    "CMYK_K": 0.14372444152832
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0352",
    "Farbtonhilfsbezeichnung": "45.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "194",
    "Bcolor": "204",
    "Y": 56,
    "L": 79.6415328979492,
    "a": 6.00893831253052,
    "b": -4.58136415481567,
    "C": 7.55620527267456,
    "h": 322.677185058594,
    "CMY_C": 0.19559162855148,
    "CMY_M": 0.2384227514267,
    "CMY_Y": 0.19827765226364,
    "CMYK_C": 0,
    "CMYK_M": 0.05324549600482,
    "CMYK_Y": 0.00333912950009,
    "CMYK_K": 0.19559162855148
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0353",
    "Farbtonhilfsbezeichnung": "45.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "179",
    "Bcolor": "195",
    "Y": 47,
    "L": 74.3484802246094,
    "a": 6.81508874893188,
    "b": -7.27136564254761,
    "C": 9.96585178375244,
    "h": 313.144775390625,
    "CMY_C": 0.25609892606735,
    "CMY_M": 0.29635894298553,
    "CMY_Y": 0.23612612485886,
    "CMYK_C": 0.02614672668278,
    "CMYK_M": 0.07885178178549,
    "CMYK_Y": 0,
    "CMYK_K": 0.23612612485886
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0354",
    "Farbtonhilfsbezeichnung": "45.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "157",
    "Bcolor": "171",
    "Y": 35,
    "L": 66.0981674194336,
    "a": 7.69290447235107,
    "b": -6.3668851852417,
    "C": 9.98589038848877,
    "h": 320.387786865234,
    "CMY_C": 0.33450120687485,
    "CMY_M": 0.38558006286621,
    "CMY_Y": 0.32998442649841,
    "CMYK_C": 0.00674130674452,
    "CMYK_M": 0.0829766318202,
    "CMYK_Y": 0,
    "CMYK_K": 0.32998442649841
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0355",
    "Farbtonhilfsbezeichnung": "45.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "224",
    "Bcolor": "233",
    "Y": 74,
    "L": 89.6077499389648,
    "a": 3.19067907333374,
    "b": -5.00789594650269,
    "C": 5.93796730041504,
    "h": 302.502410888672,
    "CMY_C": 0.1090487241745,
    "CMY_M": 0.12227362394333,
    "CMY_Y": 0.08610057830811,
    "CMYK_C": 0.02511014416814,
    "CMYK_M": 0.03958099335432,
    "CMYK_Y": 0,
    "CMYK_K": 0.08610057830811
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0356",
    "Farbtonhilfsbezeichnung": "45.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "215",
    "Bcolor": "228",
    "Y": 69,
    "L": 86.7380676269531,
    "a": 5.13109540939331,
    "b": -6.63092517852783,
    "C": 8.38434886932373,
    "h": 307.733154296875,
    "CMY_C": 0.13143664598465,
    "CMY_M": 0.15821641683578,
    "CMY_Y": 0.10575532913208,
    "CMYK_C": 0.02871844545007,
    "CMYK_M": 0.0586652494967,
    "CMYK_Y": 0,
    "CMYK_K": 0.10575532913208
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0357",
    "Farbtonhilfsbezeichnung": "45.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "196",
    "Bcolor": "217",
    "Y": 57,
    "L": 80.6414184570313,
    "a": 7.45832681655884,
    "b": -9.69498634338379,
    "C": 12.2319011688232,
    "h": 307.570983886719,
    "CMY_C": 0.19150519371033,
    "CMY_M": 0.22954654693604,
    "CMY_Y": 0.15038150548935,
    "CMYK_C": 0.04840253293514,
    "CMYK_M": 0.09317716211081,
    "CMYK_Y": 0,
    "CMYK_K": 0.15038150548935
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0358",
    "Farbtonhilfsbezeichnung": "45.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "176",
    "Bcolor": "202",
    "Y": 46,
    "L": 73.5041961669922,
    "a": 8.91351509094238,
    "b": -12.5017910003662,
    "C": 15.3540067672729,
    "h": 305.488067626953,
    "CMY_C": 0.26803129911423,
    "CMY_M": 0.30876797437668,
    "CMY_Y": 0.20794808864594,
    "CMYK_C": 0.07585766911507,
    "CMYK_M": 0.12728948891163,
    "CMYK_Y": 0,
    "CMYK_K": 0.20794808864594
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0359",
    "Farbtonhilfsbezeichnung": "45.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "153",
    "Bcolor": "172",
    "Y": 33,
    "L": 64.3600921630859,
    "a": 6.58475160598755,
    "b": -9.52657890319824,
    "C": 11.5807886123657,
    "h": 304.652160644531,
    "CMY_C": 0.3716533780098,
    "CMY_M": 0.39999556541443,
    "CMY_Y": 0.3265592455864,
    "CMYK_C": 0.06696080416441,
    "CMYK_M": 0.10904644429684,
    "CMYK_Y": 0,
    "CMYK_K": 0.3265592455864
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0360",
    "Farbtonhilfsbezeichnung": "45.18.12",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "221",
    "Y": 57,
    "L": 80.5680084228516,
    "a": 9.36629486083984,
    "b": -12.2670812606812,
    "C": 15.4340133666992,
    "h": 307.362854003906,
    "CMY_C": 0.18701940774918,
    "CMY_M": 0.23422265052795,
    "CMY_Y": 0.13241243362427,
    "CMYK_C": 0.06294116377831,
    "CMYK_M": 0.11734863370657,
    "CMYK_Y": 0,
    "CMYK_K": 0.13241243362427
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0361",
    "Farbtonhilfsbezeichnung": "45.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "173",
    "Bcolor": "215",
    "Y": 45,
    "L": 73.3913726806641,
    "a": 15.130298614502,
    "b": -19.5928401947021,
    "C": 24.7549057006836,
    "h": 307.676605224609,
    "CMY_C": 0.24891650676727,
    "CMY_M": 0.32315558195114,
    "CMY_Y": 0.15826684236526,
    "CMYK_C": 0.10769406706095,
    "CMYK_M": 0.19589193165302,
    "CMYK_Y": 0,
    "CMYK_K": 0.15826684236526
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0362",
    "Farbtonhilfsbezeichnung": "45.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "143",
    "Bcolor": "197",
    "Y": 32,
    "L": 63.5036964416504,
    "a": 20.1513214111328,
    "b": -24.99072265625,
    "C": 32.1031455993652,
    "h": 308.881042480469,
    "CMY_C": 0.33891445398331,
    "CMY_M": 0.43746429681778,
    "CMY_Y": 0.227658867836,
    "CMYK_C": 0.14404979348183,
    "CMYK_M": 0.271648645401,
    "CMYK_Y": 0,
    "CMYK_K": 0.227658867836
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0363",
    "Farbtonhilfsbezeichnung": "48.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 74,
    "L": 89.5258636474609,
    "a": 0.02331547439098,
    "b": -4.31886911392212,
    "C": 4.318932056427,
    "h": 270.309295654297,
    "CMY_C": 0.13283294439316,
    "CMY_M": 0.11582273244858,
    "CMY_Y": 0.09250766038895,
    "CMYK_C": 0.04443594813347,
    "CMYK_M": 0.02569175697863,
    "CMYK_Y": 0,
    "CMYK_K": 0.09250766038895
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0364",
    "Farbtonhilfsbezeichnung": "48.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "218",
    "Bcolor": "224",
    "Y": 69,
    "L": 86.6971664428711,
    "a": -0.39505457878113,
    "b": -4.73453664779663,
    "C": 4.75098991394043,
    "h": 265.230224609375,
    "CMY_C": 0.16896241903305,
    "CMY_M": 0.14604967832565,
    "CMY_Y": 0.12080997228622,
    "CMYK_C": 0.0547690987587,
    "CMYK_M": 0.02870790846646,
    "CMYK_Y": 0,
    "CMYK_K": 0.12080997228622
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0365",
    "Farbtonhilfsbezeichnung": "48.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "201",
    "Bcolor": "207",
    "Y": 57,
    "L": 80.7122955322266,
    "a": -0.54521888494492,
    "b": -4.50442600250244,
    "C": 4.53730297088623,
    "h": 263.098449707031,
    "CMY_C": 0.23457998037338,
    "CMY_M": 0.2113618850708,
    "CMY_Y": 0.18805021047592,
    "CMYK_C": 0.05730621516705,
    "CMYK_M": 0.02871073409915,
    "CMYK_Y": 0,
    "CMYK_K": 0.18805021047592
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0366",
    "Farbtonhilfsbezeichnung": "48.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "177",
    "Bcolor": "183",
    "Y": 44,
    "L": 71.7456588745117,
    "a": -0.61367648839951,
    "b": -4.64100933074951,
    "C": 4.68140649795532,
    "h": 262.467529296875,
    "CMY_C": 0.33146464824677,
    "CMY_M": 0.30754685401917,
    "CMY_Y": 0.28344190120697,
    "CMYK_C": 0.067018635571,
    "CMYK_M": 0.03363991528749,
    "CMYK_Y": 0,
    "CMYK_K": 0.28344190120697
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0367",
    "Farbtonhilfsbezeichnung": "48.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "156",
    "Bcolor": "163",
    "Y": 33,
    "L": 64.1145935058594,
    "a": -0.49639010429382,
    "b": -4.8294792175293,
    "C": 4.8549222946167,
    "h": 264.131561279297,
    "CMY_C": 0.41087162494659,
    "CMY_M": 0.3878710269928,
    "CMY_Y": 0.36230057477951,
    "CMYK_C": 0.07616605609655,
    "CMYK_M": 0.04009797051549,
    "CMYK_Y": 0,
    "CMYK_K": 0.36230057477951
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0368",
    "Farbtonhilfsbezeichnung": "48.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "199",
    "Bcolor": "211",
    "Y": 57,
    "L": 80.4833831787109,
    "a": 2.90913653373718,
    "b": -6.91334867477417,
    "C": 7.50049781799316,
    "h": 292.821350097656,
    "CMY_C": 0.21852028369904,
    "CMY_M": 0.22117310762405,
    "CMY_Y": 0.17273062467575,
    "CMYK_C": 0.05535036325455,
    "CMYK_M": 0.05855708569288,
    "CMYK_Y": 0,
    "CMYK_K": 0.17273062467575
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0369",
    "Farbtonhilfsbezeichnung": "48.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "180",
    "Bcolor": "199",
    "Y": 46,
    "L": 74.0078125,
    "a": 5.15088844299316,
    "b": -9.98154067993164,
    "C": 11.2322216033935,
    "h": 297.295593261719,
    "CMY_C": 0.28216868638992,
    "CMY_M": 0.29515689611435,
    "CMY_Y": 0.22079467773438,
    "CMYK_C": 0.07876487076283,
    "CMYK_M": 0.09543340653181,
    "CMYK_Y": 0,
    "CMYK_K": 0.22079467773438
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0370",
    "Farbtonhilfsbezeichnung": "48.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "154",
    "Bcolor": "172",
    "Y": 33,
    "L": 64.3559951782227,
    "a": 4.82865905761719,
    "b": -9.63475322723389,
    "C": 10.7770318984985,
    "h": 296.618713378906,
    "CMY_C": 0.38522857427597,
    "CMY_M": 0.39591026306152,
    "CMY_Y": 0.32606083154678,
    "CMYK_C": 0.08779389411211,
    "CMYK_M": 0.10364352911711,
    "CMYK_Y": 0,
    "CMYK_K": 0.32606083154678
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0371",
    "Farbtonhilfsbezeichnung": "48.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "214",
    "Bcolor": "233",
    "Y": 68,
    "L": 86.4257659912109,
    "a": 4.92492055892944,
    "b": -9.63100242614746,
    "C": 10.8171644210815,
    "h": 297.083435058594,
    "CMY_C": 0.14756548404694,
    "CMY_M": 0.16020458936691,
    "CMY_Y": 0.08728951215744,
    "CMYK_C": 0.06604062765837,
    "CMYK_M": 0.07988850772381,
    "CMYK_Y": 0,
    "CMYK_K": 0.08728951215744
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0372",
    "Farbtonhilfsbezeichnung": "48.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "198",
    "Bcolor": "225",
    "Y": 57,
    "L": 80.9234008789063,
    "a": 6.3625636100769,
    "b": -13.738374710083,
    "C": 15.1401834487915,
    "h": 294.849975585938,
    "CMY_C": 0.21233832836151,
    "CMY_M": 0.22248619794846,
    "CMY_Y": 0.11823624372482,
    "CMYK_C": 0.10672029107809,
    "CMYK_M": 0.11822889745235,
    "CMYK_Y": 0,
    "CMYK_K": 0.11823624372482
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0373",
    "Farbtonhilfsbezeichnung": "48.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "175",
    "Bcolor": "199",
    "Y": 45,
    "L": 72.4889068603516,
    "a": 6.8898777961731,
    "b": -12.4089250564575,
    "C": 14.1933727264404,
    "h": 299.040588378906,
    "CMY_C": 0.29407542943954,
    "CMY_M": 0.31466168165207,
    "CMY_Y": 0.21982139348984,
    "CMYK_C": 0.09517569094896,
    "CMYK_M": 0.12156227976084,
    "CMYK_Y": 0,
    "CMYK_K": 0.21982139348984
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0374",
    "Farbtonhilfsbezeichnung": "48.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "152",
    "Bcolor": "181",
    "Y": 33,
    "L": 64.1320419311523,
    "a": 8.30724811553955,
    "b": -15.2049922943115,
    "C": 17.326343536377,
    "h": 298.649993896484,
    "CMY_C": 0.38221907615662,
    "CMY_M": 0.40457987785339,
    "CMY_Y": 0.28965818881989,
    "CMYK_C": 0.13030470907688,
    "CMYK_M": 0.16178365051746,
    "CMYK_Y": 0,
    "CMYK_K": 0.28965818881989
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0375",
    "Farbtonhilfsbezeichnung": "48.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "175",
    "Bcolor": "209",
    "Y": 45,
    "L": 72.8089828491211,
    "a": 9.22886180877686,
    "b": -17.5859088897705,
    "C": 19.8604145050049,
    "h": 297.689910888672,
    "CMY_C": 0.29273700714111,
    "CMY_M": 0.3151792883873,
    "CMY_Y": 0.179503262043,
    "CMYK_C": 0.13800632953644,
    "CMYK_M": 0.16535839438438,
    "CMYK_Y": 0,
    "CMYK_K": 0.179503262043
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0376",
    "Farbtonhilfsbezeichnung": "48.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "150",
    "Bcolor": "192",
    "Y": 33,
    "L": 64.0653610229492,
    "a": 11.7053279876709,
    "b": -21.213981628418,
    "C": 24.2290668487549,
    "h": 298.888793945313,
    "CMY_C": 0.38113296031952,
    "CMY_M": 0.41137194633484,
    "CMY_Y": 0.2485516667366,
    "CMYK_C": 0.1764343380928,
    "CMYK_M": 0.21667528152466,
    "CMYK_Y": 0,
    "CMYK_K": 0.2485516667366
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0377",
    "Farbtonhilfsbezeichnung": "51.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.1558380126953,
    "a": -0.15697385370731,
    "b": 0.57123565673828,
    "C": 0.59241116046906,
    "h": 105.365432739258,
    "CMY_C": 0.21976959705353,
    "CMY_M": 0.21975475549698,
    "CMY_Y": 0.23062539100647,
    "CMYK_C": 1.902165604e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.01393233146518,
    "CMYK_K": 0.21975475549698
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0378",
    "Farbtonhilfsbezeichnung": "51.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "155",
    "Gcolor": "155",
    "Bcolor": "156",
    "Y": 34,
    "L": 64.0096893310547,
    "a": 0.42912909388542,
    "b": -1.02294909954071,
    "C": 1.10931360721588,
    "h": 292.758148193359,
    "CMY_C": 0.39193224906921,
    "CMY_M": 0.3920561671257,
    "CMY_Y": 0.38947641849518,
    "CMYK_C": 0.00402249908075,
    "CMYK_M": 0.00422546919435,
    "CMYK_Y": 0,
    "CMYK_K": 0.38947641849518
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0379",
    "Farbtonhilfsbezeichnung": "51.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "224",
    "Bcolor": "227",
    "Y": 75,
    "L": 89.4116744995117,
    "a": 0.92371273040771,
    "b": -2.3533079624176,
    "C": 2.52810287475586,
    "h": 291.430847167969,
    "CMY_C": 0.1197669506073,
    "CMY_M": 0.11980819702148,
    "CMY_Y": 0.1081475019455,
    "CMYK_C": 0.01302844192833,
    "CMYK_M": 0.01307469047606,
    "CMYK_Y": 0,
    "CMYK_K": 0.1081475019455
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0380",
    "Farbtonhilfsbezeichnung": "51.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 68,
    "L": 86.0514373779297,
    "a": 0.33011409640312,
    "b": -3.52774333953857,
    "C": 3.54315519332886,
    "h": 275.345977783203,
    "CMY_C": 0.16580647230148,
    "CMY_M": 0.15522819757462,
    "CMY_Y": 0.13666158914566,
    "CMYK_C": 0.03375835344195,
    "CMYK_M": 0.02150559797883,
    "CMYK_Y": 0,
    "CMYK_K": 0.13666158914566
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0381",
    "Farbtonhilfsbezeichnung": "51.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "200",
    "Bcolor": "208",
    "Y": 57,
    "L": 80.7551727294922,
    "a": 0.96220952272415,
    "b": -4.84808444976807,
    "C": 4.94264793395996,
    "h": 281.225738525391,
    "CMY_C": 0.223393201828,
    "CMY_M": 0.21427929401398,
    "CMY_Y": 0.18491208553314,
    "CMYK_C": 0.04721100255847,
    "CMYK_M": 0.03602949902415,
    "CMYK_Y": 0,
    "CMYK_K": 0.18491208553314
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0382",
    "Farbtonhilfsbezeichnung": "51.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "182",
    "Bcolor": "191",
    "Y": 46,
    "L": 73.9817047119141,
    "a": 1.39288735389709,
    "b": -5.60278797149658,
    "C": 5.7733325958252,
    "h": 283.961059570313,
    "CMY_C": 0.29556977748871,
    "CMY_M": 0.28801208734512,
    "CMY_Y": 0.25255811214447,
    "CMYK_C": 0.05754516273737,
    "CMYK_M": 0.04743375629187,
    "CMYK_Y": 0,
    "CMYK_K": 0.25255811214447
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0383",
    "Farbtonhilfsbezeichnung": "51.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "155",
    "Bcolor": "164",
    "Y": 33,
    "L": 64.2756423950195,
    "a": 1.58634233474731,
    "b": -5.45215463638306,
    "C": 5.67824554443359,
    "h": 286.222717285156,
    "CMY_C": 0.39554327726364,
    "CMY_M": 0.39063048362732,
    "CMY_Y": 0.35608822107315,
    "CMYK_C": 0.06127401068807,
    "CMYK_M": 0.05364440381527,
    "CMYK_Y": 0,
    "CMYK_K": 0.35608822107315
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0384",
    "Farbtonhilfsbezeichnung": "51.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "225",
    "Bcolor": "232",
    "Y": 75,
    "L": 89.4693756103516,
    "a": 0.10052692890167,
    "b": -4.46538305282593,
    "C": 4.46651458740234,
    "h": 271.289642333984,
    "CMY_C": 0.13337481021881,
    "CMY_M": 0.11658871173859,
    "CMY_Y": 0.09204405546188,
    "CMYK_C": 0.04552065953612,
    "CMYK_M": 0.0270328707993,
    "CMYK_Y": 0,
    "CMYK_K": 0.09204405546188
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0385",
    "Farbtonhilfsbezeichnung": "51.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "214",
    "Bcolor": "223",
    "Y": 67,
    "L": 85.4636993408203,
    "a": 0.05389457195997,
    "b": -5.74948740005493,
    "C": 5.74974012374878,
    "h": 270.537048339844,
    "CMY_C": 0.18265676498413,
    "CMY_M": 0.16039001941681,
    "CMY_Y": 0.12692868709564,
    "CMYK_C": 0.06382992863655,
    "CMYK_M": 0.03832600265741,
    "CMYK_Y": 0,
    "CMYK_K": 0.12692868709564
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0386",
    "Farbtonhilfsbezeichnung": "51.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "199",
    "Bcolor": "213",
    "Y": 57,
    "L": 80.4096908569336,
    "a": 1.46210074424744,
    "b": -8.07490253448486,
    "C": 8.20620441436768,
    "h": 280.26318359375,
    "CMY_C": 0.23515748977661,
    "CMY_M": 0.21821981668472,
    "CMY_Y": 0.16534024477005,
    "CMYK_C": 0.08364754915237,
    "CMYK_M": 0.06335464119911,
    "CMYK_Y": 0,
    "CMYK_K": 0.16534024477005
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0387",
    "Farbtonhilfsbezeichnung": "51.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "178",
    "Bcolor": "197",
    "Y": 45,
    "L": 73.0156707763672,
    "a": 3.08409929275513,
    "b": -10.4281806945801,
    "C": 10.874677658081,
    "h": 286.475402832031,
    "CMY_C": 0.31060880422592,
    "CMY_M": 0.30072909593582,
    "CMY_Y": 0.22857612371445,
    "CMYK_C": 0.10633930563927,
    "CMYK_M": 0.09353219717741,
    "CMYK_Y": 0,
    "CMYK_K": 0.22857612371445
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0388",
    "Farbtonhilfsbezeichnung": "51.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "153",
    "Bcolor": "172",
    "Y": 32,
    "L": 63.6639099121094,
    "a": 2.92383170127869,
    "b": -11.0315771102905,
    "C": 11.4124708175659,
    "h": 284.844482421875,
    "CMY_C": 0.41226834058762,
    "CMY_M": 0.39828681945801,
    "CMY_Y": 0.32393538951874,
    "CMYK_C": 0.13065755367279,
    "CMYK_M": 0.10997681319714,
    "CMYK_Y": 0,
    "CMYK_K": 0.32393538951874
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0389",
    "Farbtonhilfsbezeichnung": "51.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "178",
    "Bcolor": "204",
    "Y": 45,
    "L": 73.172119140625,
    "a": 4.88612842559814,
    "b": -14.021315574646,
    "C": 14.8482837677002,
    "h": 289.212341308594,
    "CMY_C": 0.30881553888321,
    "CMY_M": 0.30211496353149,
    "CMY_Y": 0.20126122236252,
    "CMYK_C": 0.13465517759323,
    "CMYK_M": 0.12626624107361,
    "CMYK_Y": 0,
    "CMYK_K": 0.20126122236252
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0390",
    "Farbtonhilfsbezeichnung": "51.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "154",
    "Bcolor": "181",
    "Y": 33,
    "L": 63.8162231445313,
    "a": 4.01846218109131,
    "b": -15.4556522369385,
    "C": 15.9695091247559,
    "h": 284.574188232422,
    "CMY_C": 0.41995203495026,
    "CMY_M": 0.39776104688644,
    "CMY_Y": 0.29174536466599,
    "CMYK_C": 0.1810177564621,
    "CMYK_M": 0.14968582987785,
    "CMYK_Y": 0,
    "CMYK_K": 0.29174536466599
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0391",
    "Farbtonhilfsbezeichnung": "51.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "228",
    "Y": 66,
    "L": 84.7264709472656,
    "a": 2.12803101539612,
    "b": -9.88276863098145,
    "C": 10.1092844009399,
    "h": 282.151824951172,
    "CMY_C": 0.18976140022278,
    "CMY_M": 0.17209005355835,
    "CMY_Y": 0.1046524643898,
    "CMYK_C": 0.0950568690896,
    "CMYK_M": 0.07532001286745,
    "CMYK_Y": 0,
    "CMYK_K": 0.1046524643898
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0392",
    "Farbtonhilfsbezeichnung": "51.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "194",
    "Bcolor": "225",
    "Y": 55,
    "L": 78.922233581543,
    "a": 4.14467430114746,
    "b": -17.1004314422607,
    "C": 17.5955410003662,
    "h": 283.624206542969,
    "CMY_C": 0.26601934432983,
    "CMY_M": 0.23769533634186,
    "CMY_Y": 0.11637842655182,
    "CMYK_C": 0.16934955120087,
    "CMYK_M": 0.13729509711266,
    "CMYK_Y": 0,
    "CMYK_K": 0.11637842655182
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0393",
    "Farbtonhilfsbezeichnung": "51.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "174",
    "Bcolor": "217",
    "Y": 44,
    "L": 72.0714721679688,
    "a": 7.52395057678223,
    "b": -22.8402271270752,
    "C": 24.0475730895996,
    "h": 288.232757568359,
    "CMY_C": 0.33710616827011,
    "CMY_M": 0.31696754693985,
    "CMY_Y": 0.15058469772339,
    "CMYK_C": 0.21958807110786,
    "CMYK_M": 0.19587926566601,
    "CMYK_Y": 0,
    "CMYK_K": 0.15058469772339
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0394",
    "Farbtonhilfsbezeichnung": "51.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "159",
    "Bcolor": "202",
    "Y": 36,
    "L": 66.4930572509766,
    "a": 7.94686269760132,
    "b": -23.5400924682617,
    "C": 24.8452930450439,
    "h": 288.654083251953,
    "CMY_C": 0.39597749710083,
    "CMY_M": 0.37626695632935,
    "CMY_Y": 0.20656943321228,
    "CMYK_C": 0.23872040212154,
    "CMYK_M": 0.21387822926044,
    "CMYK_Y": 0,
    "CMYK_K": 0.20656943321228
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0395",
    "Farbtonhilfsbezeichnung": "54.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "202",
    "Bcolor": "213",
    "Y": 58,
    "L": 80.9225540161133,
    "a": 0.02253709919751,
    "b": -7.39784526824951,
    "C": 7.3978796005249,
    "h": 270.174560546875,
    "CMY_C": 0.23862010240555,
    "CMY_M": 0.20951449871063,
    "CMY_Y": 0.16479825973511,
    "CMYK_C": 0.08838804066181,
    "CMYK_M": 0.0535394474864,
    "CMYK_Y": 0,
    "CMYK_K": 0.16479825973511
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0396",
    "Farbtonhilfsbezeichnung": "54.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "181",
    "Bcolor": "198",
    "Y": 46,
    "L": 73.5384674072266,
    "a": 0.15103304386139,
    "b": -10.5990419387817,
    "C": 10.6001176834106,
    "h": 270.816375732422,
    "CMY_C": 0.32928001880646,
    "CMY_M": 0.28839349746704,
    "CMY_Y": 0.22207218408585,
    "CMYK_C": 0.13781206309795,
    "CMYK_M": 0.08525381237268,
    "CMYK_Y": 0,
    "CMYK_K": 0.22207218408585
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0397",
    "Farbtonhilfsbezeichnung": "54.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "159",
    "Bcolor": "177",
    "Y": 34,
    "L": 65.2233657836914,
    "a": 0.18623355031013,
    "b": -11.4340181350708,
    "C": 11.4355344772339,
    "h": 270.933135986328,
    "CMY_C": 0.41946595907211,
    "CMY_M": 0.37587243318558,
    "CMY_Y": 0.30502444505692,
    "CMYK_C": 0.16466984152794,
    "CMYK_M": 0.10194313526154,
    "CMYK_Y": 0,
    "CMYK_K": 0.30502444505692
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0398",
    "Farbtonhilfsbezeichnung": "54.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "230",
    "Bcolor": "235",
    "Y": 76,
    "L": 90.7494506835938,
    "a": -0.916812479496,
    "b": -4.35202980041504,
    "C": 4.44755077362061,
    "h": 258.103820800781,
    "CMY_C": 0.12704932689667,
    "CMY_M": 0.0999783873558,
    "CMY_Y": 0.07878571748734,
    "CMYK_C": 0.05239129438996,
    "CMYK_M": 0.02300514653325,
    "CMYK_Y": 0,
    "CMYK_K": 0.07878571748734
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0399",
    "Farbtonhilfsbezeichnung": "54.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 64,
    "L": 84.6445541381836,
    "a": -0.3743497133255,
    "b": -8.19881725311279,
    "C": 8.20735931396484,
    "h": 267.3857421875,
    "CMY_C": 0.20453071594238,
    "CMY_M": 0.16765266656876,
    "CMY_Y": 0.11814439296722,
    "CMYK_C": 0.09795971214771,
    "CMYK_M": 0.05614101886749,
    "CMYK_Y": 0,
    "CMYK_K": 0.11814439296722
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0400",
    "Farbtonhilfsbezeichnung": "54.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "204",
    "Bcolor": "223",
    "Y": 59,
    "L": 81.6418151855469,
    "a": -0.76342529058456,
    "b": -11.7846574783325,
    "C": 11.8093595504761,
    "h": 266.293487548828,
    "CMY_C": 0.25499856472015,
    "CMY_M": 0.19850409030914,
    "CMY_Y": 0.12527352571487,
    "CMYK_C": 0.14830355346203,
    "CMYK_M": 0.08371824771166,
    "CMYK_Y": 0,
    "CMYK_K": 0.12527352571487
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0401",
    "Farbtonhilfsbezeichnung": "54.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "179",
    "Bcolor": "203",
    "Y": 45,
    "L": 72.4115447998047,
    "a": -0.47118377685547,
    "b": -14.9460935592651,
    "C": 14.9535188674927,
    "h": 268.194305419922,
    "CMY_C": 0.36489099264145,
    "CMY_M": 0.29761373996735,
    "CMY_Y": 0.20356398820877,
    "CMYK_C": 0.20256116986275,
    "CMYK_M": 0.11808826774359,
    "CMYK_Y": 0,
    "CMYK_K": 0.20356398820877
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0402",
    "Farbtonhilfsbezeichnung": "54.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "156",
    "Bcolor": "185",
    "Y": 33,
    "L": 64.0175628662109,
    "a": 0.57954978942871,
    "b": -17.7259006500244,
    "C": 17.735372543335,
    "h": 271.872619628906,
    "CMY_C": 0.45639789104462,
    "CMY_M": 0.38722622394562,
    "CMY_Y": 0.27429538965225,
    "CMYK_C": 0.25093197822571,
    "CMYK_M": 0.15561543405056,
    "CMYK_Y": 0,
    "CMYK_K": 0.27429538965225
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0403",
    "Farbtonhilfsbezeichnung": "54.15.12",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "202",
    "Bcolor": "230",
    "Y": 58,
    "L": 81.0012283325195,
    "a": 0.45948821306229,
    "b": -16.7271194458008,
    "C": 16.7334289550781,
    "h": 271.573516845703,
    "CMY_C": 0.27311956882477,
    "CMY_M": 0.20667243003845,
    "CMY_Y": 0.09644585847855,
    "CMYK_C": 0.19553196430206,
    "CMYK_M": 0.12199221551418,
    "CMYK_Y": 0,
    "CMYK_K": 0.09644585847855
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0404",
    "Farbtonhilfsbezeichnung": "54.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "181",
    "Bcolor": "222",
    "Y": 45,
    "L": 73.112663269043,
    "a": 1.23473966121674,
    "b": -24.2568035125732,
    "C": 24.2882099151611,
    "h": 272.914001464844,
    "CMY_C": 0.38780552148819,
    "CMY_M": 0.29076135158539,
    "CMY_Y": 0.12970238924026,
    "CMYK_C": 0.29656881093979,
    "CMYK_M": 0.18506193161011,
    "CMYK_Y": 0,
    "CMYK_K": 0.12970238924026
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0405",
    "Farbtonhilfsbezeichnung": "54.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "161",
    "Bcolor": "205",
    "Y": 34,
    "L": 65.5755233764648,
    "a": 1.02643167972565,
    "b": -26.3588962554932,
    "C": 26.3788738250732,
    "h": 272.230010986328,
    "CMY_C": 0.48125755786896,
    "CMY_M": 0.36894029378891,
    "CMY_Y": 0.19756090641022,
    "CMYK_C": 0.35354289412498,
    "CMYK_M": 0.21357308328152,
    "CMYK_Y": 0,
    "CMYK_K": 0.19756090641022
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0406",
    "Farbtonhilfsbezeichnung": "57.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "231",
    "Bcolor": "228",
    "Y": 79,
    "L": 91.4169006347656,
    "a": -0.85134053230286,
    "b": 0.26803424954414,
    "C": 0.89253741502762,
    "h": 162.524017333984,
    "CMY_C": 0.10241967439651,
    "CMY_M": 0.09403795003891,
    "CMY_Y": 0.10557806491852,
    "CMYK_C": 0.00925173889846,
    "CMYK_M": 0,
    "CMYK_Y": 0.01273796707392,
    "CMYK_K": 0.09403795003891
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0407",
    "Farbtonhilfsbezeichnung": "57.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "226",
    "Bcolor": "230",
    "Y": 74,
    "L": 89.3363037109375,
    "a": -1.38781690597534,
    "b": -4.0904221534729,
    "C": 4.3194432258606,
    "h": 251.258728027344,
    "CMY_C": 0.14556080102921,
    "CMY_M": 0.11468684673309,
    "CMY_Y": 0.09648013114929,
    "CMYK_C": 0.05432162806392,
    "CMYK_M": 0.02015087381005,
    "CMYK_Y": 0,
    "CMYK_K": 0.09648013114929
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0408",
    "Farbtonhilfsbezeichnung": "57.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "220",
    "Bcolor": "226",
    "Y": 69,
    "L": 87.2504272460938,
    "a": -1.39133739471436,
    "b": -5.08041191101074,
    "C": 5.26748561859131,
    "h": 254.684326171875,
    "CMY_C": 0.17229604721069,
    "CMY_M": 0.13751345872879,
    "CMY_Y": 0.11229240894318,
    "CMYK_C": 0.06759392470121,
    "CMYK_M": 0.02841143868864,
    "CMYK_Y": 0,
    "CMYK_K": 0.11229240894318
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0409",
    "Farbtonhilfsbezeichnung": "57.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "213",
    "Bcolor": "228",
    "Y": 65,
    "L": 84.3879013061523,
    "a": -1.86638045310974,
    "b": -10.2436943054199,
    "C": 10.4123315811157,
    "h": 259.674102783203,
    "CMY_C": 0.22806411981583,
    "CMY_M": 0.16639918088913,
    "CMY_Y": 0.10625511407852,
    "CMYK_C": 0.13629058003426,
    "CMYK_M": 0.06729444861412,
    "CMYK_Y": 0,
    "CMYK_K": 0.10625511407852
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0410",
    "Farbtonhilfsbezeichnung": "57.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "198",
    "Bcolor": "210",
    "Y": 55,
    "L": 79.2229766845703,
    "a": -1.64749705791473,
    "b": -8.56445598602295,
    "C": 8.72147655487061,
    "h": 259.111328125,
    "CMY_C": 0.27519428730011,
    "CMY_M": 0.22380656003952,
    "CMY_Y": 0.17514765262604,
    "CMYK_C": 0.12129035592079,
    "CMYK_M": 0.05899105221033,
    "CMYK_Y": 0,
    "CMYK_K": 0.17514765262604
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0411",
    "Farbtonhilfsbezeichnung": "57.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "177",
    "Bcolor": "188",
    "Y": 43,
    "L": 71.5531692504883,
    "a": -2.04886317253113,
    "b": -7.90512228012085,
    "C": 8.16632080078125,
    "h": 255.469711303711,
    "CMY_C": 0.35735821723938,
    "CMY_M": 0.30544400215149,
    "CMY_Y": 0.26267021894455,
    "CMYK_C": 0.12842014431953,
    "CMYK_M": 0.05801174044609,
    "CMYK_Y": 0,
    "CMYK_K": 0.26267021894455
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0412",
    "Farbtonhilfsbezeichnung": "57.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "156",
    "Bcolor": "174",
    "Y": 32,
    "L": 63.7211074829102,
    "a": -1.00743103027344,
    "b": -11.6496534347534,
    "C": 11.6931324005127,
    "h": 265.057495117188,
    "CMY_C": 0.44557291269302,
    "CMY_M": 0.38881051540375,
    "CMY_Y": 0.3195116519928,
    "CMYK_C": 0.18525116145611,
    "CMYK_M": 0.10183695703745,
    "CMYK_Y": 0,
    "CMYK_K": 0.3195116519928
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0413",
    "Farbtonhilfsbezeichnung": "57.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "216",
    "Bcolor": "231",
    "Y": 66,
    "L": 85.512451171875,
    "a": -2.25170493125916,
    "b": -10.2145566940308,
    "C": 10.4597969055176,
    "h": 257.568481445313,
    "CMY_C": 0.2189627289772,
    "CMY_M": 0.15314948558807,
    "CMY_Y": 0.09404748678207,
    "CMYK_C": 0.13788276910782,
    "CMYK_M": 0.06523741036654,
    "CMYK_Y": 0,
    "CMYK_K": 0.09404748678207
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0414",
    "Farbtonhilfsbezeichnung": "57.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "203",
    "Bcolor": "226",
    "Y": 57,
    "L": 80.7941436767578,
    "a": -2.32470297813416,
    "b": -14.5054483413696,
    "C": 14.6905508041382,
    "h": 260.894958496094,
    "CMY_C": 0.28945451974869,
    "CMY_M": 0.20332306623459,
    "CMY_Y": 0.11512500047684,
    "CMYK_C": 0.19701033830643,
    "CMYK_M": 0.09967290610075,
    "CMYK_Y": 0,
    "CMYK_K": 0.11512500047684
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0415",
    "Farbtonhilfsbezeichnung": "57.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "184",
    "Bcolor": "207",
    "Y": 47,
    "L": 73.9769973754883,
    "a": -2.1866991519928,
    "b": -14.945634841919,
    "C": 15.1047563552856,
    "h": 261.676086425781,
    "CMY_C": 0.36309641599655,
    "CMY_M": 0.27710109949112,
    "CMY_Y": 0.18674689531326,
    "CMYK_C": 0.21684457361698,
    "CMYK_M": 0.11110219359398,
    "CMYK_Y": 0,
    "CMYK_K": 0.18674689531326
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0416",
    "Farbtonhilfsbezeichnung": "57.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "160",
    "Bcolor": "188",
    "Y": 34,
    "L": 64.9678115844727,
    "a": -1.11902177333832,
    "b": -17.9267253875732,
    "C": 17.9616165161133,
    "h": 266.428131103516,
    "CMY_C": 0.46226280927658,
    "CMY_M": 0.37358129024506,
    "CMY_Y": 0.26292878389359,
    "CMYK_C": 0.27044066786766,
    "CMYK_M": 0.15012457966805,
    "CMYK_Y": 0,
    "CMYK_K": 0.26292878389359
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0417",
    "Farbtonhilfsbezeichnung": "57.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "198",
    "Bcolor": "229",
    "Y": 56,
    "L": 79.227409362793,
    "a": -1.10614764690399,
    "b": -18.5247058868408,
    "C": 18.5577011108398,
    "h": 266.582824707031,
    "CMY_C": 0.31440967321396,
    "CMY_M": 0.22176247835159,
    "CMY_Y": 0.10331737995148,
    "CMYK_C": 0.2354147285223,
    "CMYK_M": 0.13209255039692,
    "CMYK_Y": 0,
    "CMYK_K": 0.10331737995148
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0418",
    "Farbtonhilfsbezeichnung": "57.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "179",
    "Bcolor": "215",
    "Y": 44,
    "L": 71.8958358764648,
    "a": -0.94810259342194,
    "b": -22.4383735656738,
    "C": 22.4583950042725,
    "h": 267.580474853516,
    "CMY_C": 0.4111567735672,
    "CMY_M": 0.29948633909225,
    "CMY_Y": 0.1562197804451,
    "CMYK_C": 0.30213671922684,
    "CMYK_M": 0.16979132592678,
    "CMYK_Y": 0,
    "CMYK_K": 0.1562197804451
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0419",
    "Farbtonhilfsbezeichnung": "57.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "163",
    "Bcolor": "201",
    "Y": 35,
    "L": 65.7336578369141,
    "a": -1.90496778488159,
    "b": -24.2107925415039,
    "C": 24.2856216430664,
    "h": 265.501098632813,
    "CMY_C": 0.49514347314835,
    "CMY_M": 0.3617137670517,
    "CMY_Y": 0.21108746528625,
    "CMYK_C": 0.36006021499634,
    "CMYK_M": 0.19092902541161,
    "CMYK_Y": 0,
    "CMYK_K": 0.21108746528625
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0420",
    "Farbtonhilfsbezeichnung": "57.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "182",
    "Bcolor": "221",
    "Y": 45,
    "L": 72.8024978637695,
    "a": -2.42570495605469,
    "b": -24.0574035644531,
    "C": 24.179386138916,
    "h": 264.242340087891,
    "CMY_C": 0.42436110973358,
    "CMY_M": 0.28600949048996,
    "CMY_Y": 0.13490331172943,
    "CMYK_C": 0.33459588885307,
    "CMYK_M": 0.17466969788074,
    "CMYK_Y": 0,
    "CMYK_K": 0.13490331172943
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0421",
    "Farbtonhilfsbezeichnung": "57.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "161",
    "Bcolor": "207",
    "Y": 34,
    "L": 64.8374099731445,
    "a": -2.03274750709534,
    "b": -29.1522312164307,
    "C": 29.223014831543,
    "h": 266.011291503906,
    "CMY_C": 0.53700602054596,
    "CMY_M": 0.36895996332169,
    "CMY_Y": 0.18641102313995,
    "CMYK_C": 0.43092396855354,
    "CMYK_M": 0.22437489032745,
    "CMYK_Y": 0,
    "CMYK_K": 0.18641102313995
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0422",
    "Farbtonhilfsbezeichnung": "57.21.18",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "158",
    "Bcolor": "210",
    "Y": 33,
    "L": 63.6578674316406,
    "a": -2.11474776268005,
    "b": -32.4299049377441,
    "C": 32.4987831115723,
    "h": 266.26904296875,
    "CMY_C": 0.57424330711365,
    "CMY_M": 0.37978005409241,
    "CMY_Y": 0.17648220062256,
    "CMYK_C": 0.48300245404243,
    "CMYK_M": 0.24686515331268,
    "CMYK_Y": 0,
    "CMYK_K": 0.17648220062256
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0423",
    "Farbtonhilfsbezeichnung": "60.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "238",
    "Bcolor": "233",
    "Y": 84,
    "L": 93.9086303710938,
    "a": -0.96035689115524,
    "b": 1.19540989398956,
    "C": 1.53339171409607,
    "h": 128.777374267578,
    "CMY_C": 0.07223212718964,
    "CMY_M": 0.06614565849304,
    "CMY_Y": 0.0848485827446,
    "CMYK_C": 0.00651757838205,
    "CMYK_M": 0,
    "CMYK_Y": 0.02002766728401,
    "CMYK_K": 0.06614565849304
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0424",
    "Farbtonhilfsbezeichnung": "60.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "230",
    "Bcolor": "230",
    "Y": 78,
    "L": 90.988410949707,
    "a": -0.95660716295242,
    "b": -1.48281860351563,
    "C": 1.76460993289948,
    "h": 237.172821044922,
    "CMY_C": 0.11421144008636,
    "CMY_M": 0.09806680679321,
    "CMY_Y": 0.09737008810043,
    "CMYK_C": 0.01865809224546,
    "CMYK_M": 0.00077187636634,
    "CMYK_Y": 0,
    "CMYK_K": 0.09737008810043
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0425",
    "Farbtonhilfsbezeichnung": "60.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "211",
    "Bcolor": "212",
    "Y": 65,
    "L": 84.3062591552734,
    "a": -1.05771470069885,
    "b": -2.02817535400391,
    "C": 2.28741240501404,
    "h": 242.457489013672,
    "CMY_C": 0.19061779975891,
    "CMY_M": 0.17162734270096,
    "CMY_Y": 0.16691392660141,
    "CMYK_C": 0.02845308929682,
    "CMYK_M": 0.00565777812153,
    "CMYK_Y": 0,
    "CMYK_K": 0.16691392660141
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0426",
    "Farbtonhilfsbezeichnung": "60.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "196",
    "Bcolor": "200",
    "Y": 54,
    "L": 78.748664855957,
    "a": -1.11927473545074,
    "b": -3.59416007995605,
    "C": 3.76440739631653,
    "h": 252.70263671875,
    "CMY_C": 0.25701367855072,
    "CMY_M": 0.23162311315536,
    "CMY_Y": 0.21595126390457,
    "CMYK_C": 0.0523722730577,
    "CMYK_M": 0.01998836174607,
    "CMYK_Y": 0,
    "CMYK_K": 0.21595126390457
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0427",
    "Farbtonhilfsbezeichnung": "60.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "181",
    "Bcolor": "184",
    "Y": 45,
    "L": 73.3799362182617,
    "a": -0.59135866165161,
    "b": -2.81067371368408,
    "C": 2.87221026420593,
    "h": 258.118408203125,
    "CMY_C": 0.30744618177414,
    "CMY_M": 0.29073113203049,
    "CMY_Y": 0.27899765968323,
    "CMYK_C": 0.03945690765977,
    "CMYK_M": 0.01627383381128,
    "CMYK_Y": 0,
    "CMYK_K": 0.27899765968323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0428",
    "Farbtonhilfsbezeichnung": "60.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "160",
    "Bcolor": "163",
    "Y": 35,
    "L": 65.5051422119141,
    "a": -1.02787899971008,
    "b": -3.0745062828064,
    "C": 3.2417778968811,
    "h": 251.514022827148,
    "CMY_C": 0.39434778690338,
    "CMY_M": 0.37273776531219,
    "CMY_Y": 0.36001962423325,
    "CMYK_C": 0.0536394007504,
    "CMYK_M": 0.01987270452082,
    "CMYK_Y": 0,
    "CMYK_K": 0.36001962423325
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0429",
    "Farbtonhilfsbezeichnung": "60.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "235",
    "Bcolor": "235",
    "Y": 81,
    "L": 92.3866348266602,
    "a": -2.44593572616577,
    "b": -2.20272970199585,
    "C": 3.29159832000732,
    "h": 222.005172729492,
    "CMY_C": 0.11340135335922,
    "CMY_M": 0.07873809337616,
    "CMY_Y": 0.07669597864151,
    "CMYK_C": 0.03975437581539,
    "CMYK_M": 0.00221174675971,
    "CMYK_Y": 0,
    "CMYK_K": 0.07669597864151
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0430",
    "Farbtonhilfsbezeichnung": "60.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "230",
    "Bcolor": "235",
    "Y": 76,
    "L": 90.4322509765625,
    "a": -3.17227411270142,
    "b": -4.68239116668701,
    "C": 5.65580320358276,
    "h": 235.882751464844,
    "CMY_C": 0.15045142173767,
    "CMY_M": 0.09816718101501,
    "CMY_Y": 0.08016556501389,
    "CMYK_C": 0.07641141861677,
    "CMYK_M": 0.01957049593329,
    "CMYK_Y": 0,
    "CMYK_K": 0.08016556501389
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0431",
    "Farbtonhilfsbezeichnung": "60.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "210",
    "Bcolor": "217",
    "Y": 62,
    "L": 83.3061904907227,
    "a": -2.75912714004517,
    "b": -6.28485822677612,
    "C": 6.86383438110352,
    "h": 246.297958374023,
    "CMY_C": 0.23126620054245,
    "CMY_M": 0.17745286226273,
    "CMY_Y": 0.14710485935211,
    "CMYK_C": 0.0986772403121,
    "CMYK_M": 0.03558233752847,
    "CMYK_Y": 0,
    "CMYK_K": 0.14710485935211
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0432",
    "Farbtonhilfsbezeichnung": "60.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "201",
    "Bcolor": "212",
    "Y": 58,
    "L": 80.1862869262695,
    "a": -2.34833168983459,
    "b": -7.98528480529785,
    "C": 8.32342720031738,
    "h": 253.612319946289,
    "CMY_C": 0.26832002401352,
    "CMY_M": 0.21193897724152,
    "CMY_Y": 0.16889184713364,
    "CMYK_C": 0.11963325738907,
    "CMYK_M": 0.05179486051202,
    "CMYK_Y": 0,
    "CMYK_K": 0.16889184713364
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0433",
    "Farbtonhilfsbezeichnung": "60.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "183",
    "Bcolor": "195",
    "Y": 46,
    "L": 73.6888427734375,
    "a": -2.15515184402466,
    "b": -8.79584884643555,
    "C": 9.05602741241455,
    "h": 256.232666015625,
    "CMY_C": 0.33929443359375,
    "CMY_M": 0.28218448162079,
    "CMY_Y": 0.23349827528,
    "CMYK_C": 0.13802468776703,
    "CMYK_M": 0.06351741403341,
    "CMYK_Y": 0,
    "CMYK_K": 0.23349827528
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0434",
    "Farbtonhilfsbezeichnung": "60.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "165",
    "Bcolor": "179",
    "Y": 36,
    "L": 66.8248291015625,
    "a": -2.91520547866821,
    "b": -10.0618009567261,
    "C": 10.4756031036377,
    "h": 253.84211730957,
    "CMY_C": 0.42262053489685,
    "CMY_M": 0.35281407833099,
    "CMY_Y": 0.29794633388519,
    "CMYK_C": 0.17758500576019,
    "CMYK_M": 0.07815320789814,
    "CMYK_Y": 0,
    "CMYK_K": 0.29794633388519
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0435",
    "Farbtonhilfsbezeichnung": "60.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "217",
    "Bcolor": "229",
    "Y": 66,
    "L": 85.6057586669922,
    "a": -3.28890776634216,
    "b": -8.97140979766846,
    "C": 9.55526638031006,
    "h": 249.867126464844,
    "CMY_C": 0.22158396244049,
    "CMY_M": 0.15014392137527,
    "CMY_Y": 0.10222810506821,
    "CMYK_C": 0.1329467445612,
    "CMYK_M": 0.05337192863226,
    "CMYK_Y": 0,
    "CMYK_K": 0.10222810506821
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0436",
    "Farbtonhilfsbezeichnung": "60.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "203",
    "Bcolor": "219",
    "Y": 56,
    "L": 80.4209899902344,
    "a": -3.93021273612976,
    "b": -11.5002174377441,
    "C": 12.1532535552979,
    "h": 251.132080078125,
    "CMY_C": 0.2940086722374,
    "CMY_M": 0.20475900173187,
    "CMY_Y": 0.14114028215408,
    "CMYK_C": 0.17798994481564,
    "CMYK_M": 0.07407347112894,
    "CMYK_Y": 0,
    "CMYK_K": 0.14114028215408
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0437",
    "Farbtonhilfsbezeichnung": "60.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "182",
    "Bcolor": "205",
    "Y": 45,
    "L": 72.9502792358398,
    "a": -3.68204617500305,
    "b": -15.4722089767456,
    "C": 15.9042987823486,
    "h": 256.613861083984,
    "CMY_C": 0.38958770036697,
    "CMY_M": 0.28463119268417,
    "CMY_Y": 0.19433790445328,
    "CMYK_C": 0.24234700202942,
    "CMYK_M": 0.11207339912653,
    "CMYK_Y": 0,
    "CMYK_K": 0.19433790445328
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0438",
    "Farbtonhilfsbezeichnung": "60.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "163",
    "Bcolor": "190",
    "Y": 34,
    "L": 65.5313262939453,
    "a": -3.67835116386414,
    "b": -18.4409255981445,
    "C": 18.8042011260986,
    "h": 258.719451904297,
    "CMY_C": 0.48205679655075,
    "CMY_M": 0.36206060647964,
    "CMY_Y": 0.25358271598816,
    "CMYK_C": 0.30609431862831,
    "CMYK_M": 0.14533142745495,
    "CMYK_Y": 0,
    "CMYK_K": 0.25358271598816
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0439",
    "Farbtonhilfsbezeichnung": "60.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "218",
    "Bcolor": "235",
    "Y": 67,
    "L": 85.828987121582,
    "a": -3.77507662773132,
    "b": -11.6394691467285,
    "C": 12.2363576889038,
    "h": 252.030349731445,
    "CMY_C": 0.23475587368011,
    "CMY_M": 0.14574486017227,
    "CMY_Y": 0.08028602600098,
    "CMYK_C": 0.16795422136784,
    "CMYK_M": 0.07117303460836,
    "CMYK_Y": 0,
    "CMYK_K": 0.08028602600098
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0440",
    "Farbtonhilfsbezeichnung": "60.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "206",
    "Bcolor": "227",
    "Y": 59,
    "L": 81.5759963989258,
    "a": -4.39243412017822,
    "b": -14.2602252960205,
    "C": 14.9213771820068,
    "h": 252.880126953125,
    "CMY_C": 0.29817378520966,
    "CMY_M": 0.190249979496,
    "CMY_Y": 0.10848289728165,
    "CMYK_C": 0.21277312934399,
    "CMYK_M": 0.09171678125858,
    "CMYK_Y": 0,
    "CMYK_K": 0.10848289728165
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0441",
    "Farbtonhilfsbezeichnung": "60.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "184",
    "Bcolor": "217",
    "Y": 45,
    "L": 73.2168579101563,
    "a": -4.61091804504395,
    "b": -21.5209579467773,
    "C": 22.0093669891357,
    "h": 257.907073974609,
    "CMY_C": 0.42671304941177,
    "CMY_M": 0.27774804830551,
    "CMY_Y": 0.14858663082123,
    "CMYK_C": 0.32666438817978,
    "CMYK_M": 0.15170235931873,
    "CMYK_Y": 0,
    "CMYK_K": 0.14858663082123
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0442",
    "Farbtonhilfsbezeichnung": "60.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "161",
    "Bcolor": "196",
    "Y": 34,
    "L": 64.5415573120117,
    "a": -4.79988193511963,
    "b": -23.4630012512207,
    "C": 23.9489307403564,
    "h": 258.438385009766,
    "CMY_C": 0.53182995319366,
    "CMY_M": 0.36832439899445,
    "CMY_Y": 0.22945642471313,
    "CMYK_C": 0.39241588115692,
    "CMYK_M": 0.18022079765797,
    "CMYK_Y": 0,
    "CMYK_K": 0.22945642471313
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0443",
    "Farbtonhilfsbezeichnung": "60.18.12",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "206",
    "Bcolor": "232",
    "Y": 58,
    "L": 81.2215805053711,
    "a": -5.37189102172852,
    "b": -17.0932216644287,
    "C": 17.9174613952637,
    "h": 252.553619384766,
    "CMY_C": 0.32466155290604,
    "CMY_M": 0.19103664159775,
    "CMY_Y": 0.09198778867722,
    "CMYK_C": 0.25624519586563,
    "CMYK_M": 0.10908317565918,
    "CMYK_Y": 0,
    "CMYK_K": 0.09198778867722
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0444",
    "Farbtonhilfsbezeichnung": "60.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "183",
    "Bcolor": "224",
    "Y": 44,
    "L": 72.4505844116211,
    "a": -6.03695154190063,
    "b": -26.3214321136475,
    "C": 27.004861831665,
    "h": 257.082336425781,
    "CMY_C": 0.4784694314003,
    "CMY_M": 0.28120744228363,
    "CMY_Y": 0.12303799390793,
    "CMYK_C": 0.40529856085777,
    "CMYK_M": 0.18036065995693,
    "CMYK_Y": 0,
    "CMYK_K": 0.12303799390793
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0445",
    "Farbtonhilfsbezeichnung": "60.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "162",
    "Bcolor": "204",
    "Y": 34,
    "L": 64.4199600219727,
    "a": -6.01510095596313,
    "b": -27.7383441925049,
    "C": 28.3830432891846,
    "h": 257.764770507813,
    "CMY_C": 0.57497572898865,
    "CMY_M": 0.36555224657059,
    "CMY_Y": 0.20115756988525,
    "CMYK_C": 0.46794980764389,
    "CMYK_M": 0.2057911157608,
    "CMYK_Y": 0,
    "CMYK_K": 0.20115756988525
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0446",
    "Farbtonhilfsbezeichnung": "60.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "162",
    "Bcolor": "211",
    "Y": 33,
    "L": 63.7708549499512,
    "a": -7.9600625038147,
    "b": -32.9882850646973,
    "C": 33.9350776672363,
    "h": 256.433868408203,
    "CMY_C": 0.65105450153351,
    "CMY_M": 0.36642330884933,
    "CMY_Y": 0.17183369398117,
    "CMYK_C": 0.57865285873413,
    "CMYK_M": 0.23496441543102,
    "CMYK_Y": 0,
    "CMYK_K": 0.17183369398117
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0447",
    "Farbtonhilfsbezeichnung": "63.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "159",
    "Bcolor": "162",
    "Y": 36,
    "L": 64.9824752807617,
    "a": -1.27906179428101,
    "b": -3.22341871261597,
    "C": 3.46791386604309,
    "h": 248.356674194336,
    "CMY_C": 0.40220630168915,
    "CMY_M": 0.37759280204773,
    "CMY_Y": 0.36445307731628,
    "CMYK_C": 0.05940273404121,
    "CMYK_M": 0.02067467197776,
    "CMYK_Y": 0,
    "CMYK_K": 0.36445307731628
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0448",
    "Farbtonhilfsbezeichnung": "63.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "140",
    "Gcolor": "150",
    "Bcolor": "155",
    "Y": 31,
    "L": 61.3358421325684,
    "a": -2.02492165565491,
    "b": -4.56794166564941,
    "C": 4.99663877487183,
    "h": 246.092788696289,
    "CMY_C": 0.45022016763687,
    "CMY_M": 0.41336846351624,
    "CMY_Y": 0.3930259346962,
    "CMYK_C": 0.09422846138477,
    "CMYK_M": 0.03351465985179,
    "CMYK_Y": 0,
    "CMYK_K": 0.3930259346962
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0449",
    "Farbtonhilfsbezeichnung": "63.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "236",
    "Bcolor": "238",
    "Y": 81,
    "L": 92.4434432983398,
    "a": -4.20128965377808,
    "b": -3.40271854400635,
    "C": 5.4064154624939,
    "h": 219.004791259766,
    "CMY_C": 0.13186198472977,
    "CMY_M": 0.07368171215057,
    "CMY_Y": 0.06737875938416,
    "CMYK_C": 0.06914192438126,
    "CMYK_M": 0.00675832014531,
    "CMYK_Y": 0,
    "CMYK_K": 0.06737875938416
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0450",
    "Farbtonhilfsbezeichnung": "63.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "229",
    "Bcolor": "233",
    "Y": 76,
    "L": 89.6401596069336,
    "a": -5.90049934387207,
    "b": -5.3387246131897,
    "C": 7.95725297927856,
    "h": 222.138549804688,
    "CMY_C": 0.1848486661911,
    "CMY_M": 0.10058838129044,
    "CMY_Y": 0.08447343111038,
    "CMYK_C": 0.10963661968708,
    "CMYK_M": 0.01760183833539,
    "CMYK_Y": 0,
    "CMYK_K": 0.08447343111038
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0451",
    "Farbtonhilfsbezeichnung": "63.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "210",
    "Bcolor": "218",
    "Y": 62,
    "L": 83.0040283203125,
    "a": -4.39932584762573,
    "b": -6.78167200088501,
    "C": 8.08363437652588,
    "h": 237.028198242188,
    "CMY_C": 0.25024646520615,
    "CMY_M": 0.17692410945892,
    "CMY_Y": 0.1470120549202,
    "CMYK_C": 0.12102681398392,
    "CMYK_M": 0.03506738319993,
    "CMYK_Y": 0,
    "CMYK_K": 0.1470120549202
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0452",
    "Farbtonhilfsbezeichnung": "63.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "209",
    "Bcolor": "221",
    "Y": 60,
    "L": 82.0592803955078,
    "a": -6.35529232025146,
    "b": -10.2429075241089,
    "C": 12.0543308258057,
    "h": 238.182144165039,
    "CMY_C": 0.29206275939941,
    "CMY_M": 0.18190276622772,
    "CMY_Y": 0.13250112533569,
    "CMYK_C": 0.18393296003342,
    "CMYK_M": 0.05694720894098,
    "CMYK_Y": 0,
    "CMYK_K": 0.13250112533569
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0453",
    "Farbtonhilfsbezeichnung": "63.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "186",
    "Bcolor": "200",
    "Y": 47,
    "L": 74.1709213256836,
    "a": -5.63339948654175,
    "b": -10.448299407959,
    "C": 11.8702211380005,
    "h": 241.667831420898,
    "CMY_C": 0.37070351839066,
    "CMY_M": 0.2689363360405,
    "CMY_Y": 0.21697497367859,
    "CMYK_C": 0.19632647931576,
    "CMYK_M": 0.06635977327824,
    "CMYK_Y": 0,
    "CMYK_K": 0.21697497367859
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0454",
    "Farbtonhilfsbezeichnung": "63.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "162",
    "Bcolor": "177",
    "Y": 34,
    "L": 65.3942718505859,
    "a": -4.62834453582764,
    "b": -11.148777961731,
    "C": 12.0713224411011,
    "h": 247.454528808594,
    "CMY_C": 0.45658618211746,
    "CMY_M": 0.36382156610489,
    "CMY_Y": 0.30571800470352,
    "CMYK_C": 0.21730101108551,
    "CMYK_M": 0.08368870615959,
    "CMYK_Y": 0,
    "CMYK_K": 0.30571800470352
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0455",
    "Farbtonhilfsbezeichnung": "63.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "228",
    "Bcolor": "228",
    "Y": 74,
    "L": 89.5826110839844,
    "a": -4.91466379165649,
    "b": -2.26535964012146,
    "C": 5.41163349151611,
    "h": 204.746810913086,
    "CMY_C": 0.16507416963577,
    "CMY_M": 0.10435980558395,
    "CMY_Y": 0.10768085718155,
    "CMYK_C": 0.06778878718615,
    "CMYK_M": 0,
    "CMYK_Y": 0.00370801985264,
    "CMYK_K": 0.10435980558395
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0456",
    "Farbtonhilfsbezeichnung": "63.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "230",
    "Bcolor": "237",
    "Y": 73,
    "L": 89.3504180908203,
    "a": -8.15399265289307,
    "b": -7.72756624221802,
    "C": 11.2340049743652,
    "h": 223.461944580078,
    "CMY_C": 0.21777695417404,
    "CMY_M": 0.09807866811752,
    "CMY_Y": 0.07033771276474,
    "CMYK_C": 0.15859441459179,
    "CMYK_M": 0.02983981929719,
    "CMYK_Y": 0,
    "CMYK_K": 0.07033771276474
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0457",
    "Farbtonhilfsbezeichnung": "63.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "213",
    "Bcolor": "227",
    "Y": 62,
    "L": 82.6041946411133,
    "a": -10.6785917282104,
    "b": -12.7184572219849,
    "C": 16.606969833374,
    "h": 229.982711791992,
    "CMY_C": 0.33764290809631,
    "CMY_M": 0.16585367918015,
    "CMY_Y": 0.10899895429611,
    "CMYK_C": 0.25661468505859,
    "CMYK_M": 0.06380993872881,
    "CMYK_Y": 0,
    "CMYK_K": 0.10899895429611
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0458",
    "Farbtonhilfsbezeichnung": "63.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "187",
    "Bcolor": "207",
    "Y": 47,
    "L": 73.5652236938477,
    "a": -9.76772212982178,
    "b": -15.4324550628662,
    "C": 18.2638740539551,
    "h": 237.668899536133,
    "CMY_C": 0.43957215547562,
    "CMY_M": 0.26519632339478,
    "CMY_Y": 0.18857532739639,
    "CMYK_C": 0.30932855606079,
    "CMYK_M": 0.09442773461342,
    "CMYK_Y": 0,
    "CMYK_K": 0.18857532739639
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0459",
    "Farbtonhilfsbezeichnung": "63.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "169",
    "Bcolor": "189",
    "Y": 36,
    "L": 66.5434265136719,
    "a": -10.0693712234497,
    "b": -16.0564727783203,
    "C": 18.9526405334473,
    "h": 237.907257080078,
    "CMY_C": 0.51982378959656,
    "CMY_M": 0.33910566568375,
    "CMY_Y": 0.25996714830399,
    "CMYK_C": 0.35114204883575,
    "CMYK_M": 0.10693919658661,
    "CMYK_Y": 0,
    "CMYK_K": 0.25996714830399
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0460",
    "Farbtonhilfsbezeichnung": "63.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "148",
    "Bcolor": "172",
    "Y": 28,
    "L": 58.8364067077637,
    "a": -10.2102527618408,
    "b": -18.1442260742188,
    "C": 20.8197555541992,
    "h": 240.632354736328,
    "CMY_C": 0.61415755748749,
    "CMY_M": 0.41843867301941,
    "CMY_Y": 0.32733732461929,
    "CMYK_C": 0.42639535665512,
    "CMYK_M": 0.13543392717838,
    "CMYK_Y": 0,
    "CMYK_K": 0.32733732461929
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0461",
    "Farbtonhilfsbezeichnung": "63.15.12",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "207",
    "Bcolor": "227",
    "Y": 57,
    "L": 80.6422500610352,
    "a": -9.8818883895874,
    "b": -15.593207359314,
    "C": 18.4607639312744,
    "h": 237.636322021484,
    "CMY_C": 0.36599457263947,
    "CMY_M": 0.18815714120865,
    "CMY_Y": 0.10976624488831,
    "CMYK_C": 0.28782141208649,
    "CMYK_M": 0.08805653452873,
    "CMYK_Y": 0,
    "CMYK_K": 0.10976624488831
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0462",
    "Farbtonhilfsbezeichnung": "63.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "188",
    "Bcolor": "214",
    "Y": 46,
    "L": 73.044807434082,
    "a": -13.0520849227905,
    "b": -20.2267284393311,
    "C": 24.0723381042481,
    "h": 237.166290283203,
    "CMY_C": 0.50811070203781,
    "CMY_M": 0.26259136199951,
    "CMY_Y": 0.1605042219162,
    "CMYK_C": 0.41406577825546,
    "CMYK_M": 0.12160530686378,
    "CMYK_Y": 0,
    "CMYK_K": 0.1605042219162
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0463",
    "Farbtonhilfsbezeichnung": "63.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "169",
    "Bcolor": "202",
    "Y": 36,
    "L": 66.0957260131836,
    "a": -11.2987327575684,
    "b": -24.0605564117432,
    "C": 26.5814170837402,
    "h": 244.845458984375,
    "CMY_C": 0.59075236320496,
    "CMY_M": 0.33874219655991,
    "CMY_Y": 0.20906656980515,
    "CMYK_C": 0.48257637023926,
    "CMYK_M": 0.16395264863968,
    "CMYK_Y": 0,
    "CMYK_K": 0.20906656980515
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0464",
    "Farbtonhilfsbezeichnung": "63.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "208",
    "Bcolor": "229",
    "Y": 57,
    "L": 79.9079666137695,
    "a": -14.4814014434815,
    "b": -17.6314067840576,
    "C": 22.8161678314209,
    "h": 230.602325439453,
    "CMY_C": 0.43267065286636,
    "CMY_M": 0.18603837490082,
    "CMY_Y": 0.10363018512726,
    "CMYK_C": 0.36708116531372,
    "CMYK_M": 0.09193547815084,
    "CMYK_Y": 0,
    "CMYK_K": 0.10363018512726
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0465",
    "Farbtonhilfsbezeichnung": "63.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "189",
    "Bcolor": "222",
    "Y": 45,
    "L": 72.4087142944336,
    "a": -17.0572738647461,
    "b": -25.84739112854,
    "C": 30.9683418273926,
    "h": 236.57829284668,
    "CMY_C": 0.60975968837738,
    "CMY_M": 0.25973403453827,
    "CMY_Y": 0.12787580490112,
    "CMYK_C": 0.5525404214859,
    "CMYK_M": 0.15119203925133,
    "CMYK_Y": 0,
    "CMYK_K": 0.12787580490112
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0466",
    "Farbtonhilfsbezeichnung": "63.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "170",
    "Bcolor": "211",
    "Y": 36,
    "L": 65.8498992919922,
    "a": -14.7854919433594,
    "b": -29.4587249755859,
    "C": 32.960994720459,
    "h": 243.347671508789,
    "CMY_C": 0.69192487001419,
    "CMY_M": 0.33273077011108,
    "CMY_Y": 0.17428302764893,
    "CMYK_C": 0.62689983844757,
    "CMYK_M": 0.19189110398293,
    "CMYK_Y": 0,
    "CMYK_K": 0.17428302764893
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0467",
    "Farbtonhilfsbezeichnung": "66.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "228",
    "Bcolor": "229",
    "Y": 75,
    "L": 89.6066207885742,
    "a": -4.36072874069214,
    "b": -2.90572619438171,
    "C": 5.24015283584595,
    "h": 213.677093505859,
    "CMY_C": 0.16263288259506,
    "CMY_M": 0.10516822338104,
    "CMY_Y": 0.10261428356171,
    "CMYK_C": 0.06688160449266,
    "CMYK_M": 0.00284597789869,
    "CMYK_Y": 0,
    "CMYK_K": 0.10261428356171
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0468",
    "Farbtonhilfsbezeichnung": "66.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "216",
    "Bcolor": "220",
    "Y": 65,
    "L": 85.1574478149414,
    "a": -4.39129590988159,
    "b": -5.13193511962891,
    "C": 6.75427532196045,
    "h": 229.447036743164,
    "CMY_C": 0.22022080421448,
    "CMY_M": 0.15375453233719,
    "CMY_Y": 0.13537406921387,
    "CMYK_C": 0.09813115000725,
    "CMYK_M": 0.0212582834065,
    "CMYK_Y": 0,
    "CMYK_K": 0.13537406921387
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0469",
    "Farbtonhilfsbezeichnung": "66.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "203",
    "Bcolor": "207",
    "Y": 57,
    "L": 80.2890548706055,
    "a": -5.04433345794678,
    "b": -5.31006145477295,
    "C": 7.32407331466675,
    "h": 226.470077514648,
    "CMY_C": 0.2790060043335,
    "CMY_M": 0.20560324192047,
    "CMY_Y": 0.18739992380142,
    "CMYK_C": 0.11273206025362,
    "CMYK_M": 0.02240132540464,
    "CMYK_Y": 0,
    "CMYK_K": 0.18739992380142
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0470",
    "Farbtonhilfsbezeichnung": "66.06.15",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "177",
    "Bcolor": "184",
    "Y": 42,
    "L": 70.9878768920898,
    "a": -4.75481843948364,
    "b": -6.37925338745117,
    "C": 7.95632886886597,
    "h": 233.300750732422,
    "CMY_C": 0.37942242622375,
    "CMY_M": 0.30601507425308,
    "CMY_Y": 0.2797537446022,
    "CMYK_C": 0.13838139176369,
    "CMYK_M": 0.03646159917116,
    "CMYK_Y": 0,
    "CMYK_K": 0.2797537446022
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0471",
    "Farbtonhilfsbezeichnung": "66.06.18",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "159",
    "Bcolor": "166",
    "Y": 33,
    "L": 64.2829818725586,
    "a": -4.48247385025024,
    "b": -6.55301475524902,
    "C": 7.93943166732788,
    "h": 235.626617431641,
    "CMY_C": 0.44728863239288,
    "CMY_M": 0.37708127498627,
    "CMY_Y": 0.34913438558578,
    "CMYK_C": 0.15080569684505,
    "CMYK_M": 0.04293803498149,
    "CMYK_Y": 0,
    "CMYK_K": 0.34913438558578
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0472",
    "Farbtonhilfsbezeichnung": "66.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "206",
    "Bcolor": "212",
    "Y": 57,
    "L": 81.2123031616211,
    "a": -6.52239656448364,
    "b": -6.64978456497192,
    "C": 9.31457424163818,
    "h": 225.554092407227,
    "CMY_C": 0.28710567951202,
    "CMY_M": 0.19188958406448,
    "CMY_Y": 0.16783952713013,
    "CMYK_C": 0.14332109689713,
    "CMYK_M": 0.02890074439347,
    "CMYK_Y": 0,
    "CMYK_K": 0.16783952713013
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0473",
    "Farbtonhilfsbezeichnung": "66.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 46,
    "L": 73.0111389160156,
    "a": -7.05202627182007,
    "b": -8.24987030029297,
    "C": 10.8531761169434,
    "h": 229.476028442383,
    "CMY_C": 0.38556772470474,
    "CMY_M": 0.27900165319443,
    "CMY_Y": 0.24521189928055,
    "CMYK_C": 0.18595394492149,
    "CMYK_M": 0.0447672046721,
    "CMYK_Y": 0,
    "CMYK_K": 0.24521189928055
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0474",
    "Farbtonhilfsbezeichnung": "66.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "158",
    "Bcolor": "170",
    "Y": 32,
    "L": 63.1704216003418,
    "a": -7.55909538269043,
    "b": -10.7301359176636,
    "C": 13.1253852844238,
    "h": 234.836318969727,
    "CMY_C": 0.50312542915344,
    "CMY_M": 0.38110333681107,
    "CMY_Y": 0.33232927322388,
    "CMYK_C": 0.25580894947052,
    "CMYK_M": 0.07305107265711,
    "CMYK_Y": 0,
    "CMYK_K": 0.33232927322388
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0475",
    "Farbtonhilfsbezeichnung": "66.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "233",
    "Bcolor": "234",
    "Y": 78,
    "L": 90.9929275512695,
    "a": -5.54909420013428,
    "b": -3.74287366867065,
    "C": 6.69339609146118,
    "h": 213.999740600586,
    "CMY_C": 0.16058838367462,
    "CMY_M": 0.08674538135529,
    "CMY_Y": 0.08118933439255,
    "CMYK_C": 0.0864150300622,
    "CMYK_M": 0.00604699878022,
    "CMYK_Y": 0,
    "CMYK_K": 0.08118933439255
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0476",
    "Farbtonhilfsbezeichnung": "66.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "231",
    "Bcolor": "237",
    "Y": 75,
    "L": 90.0949401855469,
    "a": -6.8425612449646,
    "b": -6.54823732376099,
    "C": 9.4710111618042,
    "h": 223.740875244141,
    "CMY_C": 0.19299966096878,
    "CMY_M": 0.0930363535881,
    "CMY_Y": 0.07058930397034,
    "CMYK_C": 0.13170750439167,
    "CMYK_M": 0.02415191568434,
    "CMYK_Y": 0,
    "CMYK_K": 0.07058930397034
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0477",
    "Farbtonhilfsbezeichnung": "66.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "223",
    "Bcolor": "231",
    "Y": 69,
    "L": 87.1309356689453,
    "a": -7.36528301239014,
    "b": -7.76221084594727,
    "C": 10.7004346847534,
    "h": 226.503021240234,
    "CMY_C": 0.23516863584518,
    "CMY_M": 0.12451165914536,
    "CMY_Y": 0.09467452764511,
    "CMYK_C": 0.15518629550934,
    "CMYK_M": 0.03295735269785,
    "CMYK_Y": 0,
    "CMYK_K": 0.09467452764511
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0478",
    "Farbtonhilfsbezeichnung": "66.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "205",
    "Bcolor": "217",
    "Y": 56,
    "L": 79.8785018920898,
    "a": -10.2482786178589,
    "b": -11.5356140136719,
    "C": 15.4304113388062,
    "h": 228.38200378418,
    "CMY_C": 0.35693973302841,
    "CMY_M": 0.19700962305069,
    "CMY_Y": 0.14756017923355,
    "CMYK_C": 0.24562385678291,
    "CMYK_M": 0.05800930783153,
    "CMYK_Y": 0,
    "CMYK_K": 0.14756017923355
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0479",
    "Farbtonhilfsbezeichnung": "66.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "188",
    "Bcolor": "207",
    "Y": 46,
    "L": 73.0520858764648,
    "a": -14.1633920669556,
    "b": -16.2199554443359,
    "C": 21.5334300994873,
    "h": 228.872283935547,
    "CMY_C": 0.49450087547302,
    "CMY_M": 0.26160526275635,
    "CMY_Y": 0.18901139497757,
    "CMYK_C": 0.37668776512146,
    "CMYK_M": 0.08951281011105,
    "CMYK_Y": 0,
    "CMYK_K": 0.18901139497757
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0480",
    "Farbtonhilfsbezeichnung": "66.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "160",
    "Bcolor": "180",
    "Y": 32,
    "L": 62.8607406616211,
    "a": -13.4597215652466,
    "b": -16.5632610321045,
    "C": 21.3425807952881,
    "h": 230.901824951172,
    "CMY_C": 0.59717702865601,
    "CMY_M": 0.37100237607956,
    "CMY_Y": 0.29599213600159,
    "CMYK_C": 0.42781466245651,
    "CMYK_M": 0.10654744505882,
    "CMYK_Y": 0,
    "CMYK_K": 0.29599213600159
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0481",
    "Farbtonhilfsbezeichnung": "66.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "161",
    "Gcolor": "215",
    "Bcolor": "229",
    "Y": 62,
    "L": 82.9048233032227,
    "a": -13.7344903945923,
    "b": -13.3326168060303,
    "C": 19.1414451599121,
    "h": 224.149368286133,
    "CMY_C": 0.36753880977631,
    "CMY_M": 0.15596735477448,
    "CMY_Y": 0.10153722763062,
    "CMYK_C": 0.29606300592422,
    "CMYK_M": 0.06058139353991,
    "CMYK_Y": 0,
    "CMYK_K": 0.10153722763062
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0482",
    "Farbtonhilfsbezeichnung": "66.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "205",
    "Bcolor": "225",
    "Y": 55,
    "L": 78.8415985107422,
    "a": -15.3287315368652,
    "b": -17.0689582824707,
    "C": 22.941650390625,
    "h": 228.074661254883,
    "CMY_C": 0.44997072219849,
    "CMY_M": 0.19618970155716,
    "CMY_Y": 0.11958110332489,
    "CMYK_C": 0.375264108181,
    "CMYK_M": 0.08701380342245,
    "CMYK_Y": 0,
    "CMYK_K": 0.11958110332489
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0483",
    "Farbtonhilfsbezeichnung": "66.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "194",
    "Bcolor": "220",
    "Y": 47,
    "L": 73.7458114624023,
    "a": -19.9096508026123,
    "b": -22.3821144104004,
    "C": 29.9558544158936,
    "h": 228.345825195312,
    "CMY_C": 0.60295915603638,
    "CMY_M": 0.24106281995773,
    "CMY_Y": 0.13809180259705,
    "CMYK_C": 0.53934669494629,
    "CMYK_M": 0.11946865916252,
    "CMYK_Y": 0,
    "CMYK_K": 0.13809180259705
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0484",
    "Farbtonhilfsbezeichnung": "66.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "168",
    "Bcolor": "195",
    "Y": 34,
    "L": 64.4698944091797,
    "a": -19.9525966644287,
    "b": -22.7382411956787,
    "C": 30.2511768341064,
    "h": 228.733352661133,
    "CMY_C": 0.7196232676506,
    "CMY_M": 0.3401615023613,
    "CMY_Y": 0.236607670784,
    "CMYK_C": 0.63272261619568,
    "CMYK_M": 0.13564956188202,
    "CMYK_Y": 0,
    "CMYK_K": 0.236607670784
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0485",
    "Farbtonhilfsbezeichnung": "66.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "209",
    "Bcolor": "229",
    "Y": 56,
    "L": 79.3782577514648,
    "a": -19.5499172210693,
    "b": -18.8967533111572,
    "C": 27.1898250579834,
    "h": 224.026718139648,
    "CMY_C": 0.50548958778381,
    "CMY_M": 0.18141376972198,
    "CMY_Y": 0.10085785388947,
    "CMYK_C": 0.45001974701881,
    "CMYK_M": 0.08959197252989,
    "CMYK_Y": 0,
    "CMYK_K": 0.10085785388947
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0486",
    "Farbtonhilfsbezeichnung": "66.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "191",
    "Bcolor": "221",
    "Y": 45,
    "L": 72.16015625,
    "a": -22.9224491119385,
    "b": -25.3174133300781,
    "C": 34.1527481079102,
    "h": 227.842239379883,
    "CMY_C": 0.70365810394287,
    "CMY_M": 0.25170081853867,
    "CMY_Y": 0.13490343093872,
    "CMYK_C": 0.65744644403458,
    "CMYK_M": 0.13501080870628,
    "CMYK_Y": 0,
    "CMYK_K": 0.13490343093872
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0487",
    "Farbtonhilfsbezeichnung": "66.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "169",
    "Bcolor": "205",
    "Y": 33,
    "L": 63.7021751403809,
    "a": -25.1652812957764,
    "b": -29.9583358764648,
    "C": 39.1253547668457,
    "h": 229.969421386719,
    "CMY_C": 1,
    "CMY_M": 0.33678478002548,
    "CMY_Y": 0.19505286216736,
    "CMYK_C": 1,
    "CMYK_M": 0.17607605457306,
    "CMYK_Y": 0,
    "CMYK_K": 0.19505286216736
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0488",
    "Farbtonhilfsbezeichnung": "69.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "240",
    "Bcolor": "235",
    "Y": 85,
    "L": 94.3910751342773,
    "a": -1.825932264328,
    "b": 1.29791510105133,
    "C": 2.24022603034973,
    "h": 144.593902587891,
    "CMY_C": 0.07341873645782,
    "CMY_M": 0.05870604515076,
    "CMY_Y": 0.08036905527115,
    "CMYK_C": 0.01563028432429,
    "CMYK_M": 0,
    "CMYK_Y": 0.0230140760541,
    "CMYK_K": 0.05870604515076
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0489",
    "Farbtonhilfsbezeichnung": "69.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "228",
    "Bcolor": "224",
    "Y": 73,
    "L": 89.7838668823242,
    "a": -2.92394709587097,
    "b": -0.00973842293024,
    "C": 2.92396330833435,
    "h": 180.190826416016,
    "CMY_C": 0.13818991184235,
    "CMY_M": 0.10732614994049,
    "CMY_Y": 0.12184965610504,
    "CMYK_C": 0.03457451239228,
    "CMYK_M": 0,
    "CMYK_Y": 0.01626966707408,
    "CMYK_K": 0.10732614994049
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0490",
    "Farbtonhilfsbezeichnung": "69.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "212",
    "Bcolor": "208",
    "Y": 63,
    "L": 84.1154251098633,
    "a": -3.21058058738708,
    "b": -0.13217242062092,
    "C": 3.21329998970032,
    "h": 182.357406616211,
    "CMY_C": 0.20316570997238,
    "CMY_M": 0.16932839155197,
    "CMY_Y": 0.18309241533279,
    "CMYK_C": 0.0407348908484,
    "CMYK_M": 0,
    "CMYK_Y": 0.01656975410879,
    "CMYK_K": 0.16932839155197
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0491",
    "Farbtonhilfsbezeichnung": "69.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "194",
    "Bcolor": "193",
    "Y": 51,
    "L": 77.3511505126953,
    "a": -3.90725421905518,
    "b": -2.1128408908844,
    "C": 4.44192886352539,
    "h": 208.402236938477,
    "CMY_C": 0.2888897061348,
    "CMY_M": 0.24090301990509,
    "CMY_Y": 0.24197125434875,
    "CMYK_C": 0.0632154867053,
    "CMYK_M": 0,
    "CMYK_Y": 0.00140724366065,
    "CMYK_K": 0.24090301990509
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0492",
    "Farbtonhilfsbezeichnung": "69.03.15",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "180",
    "Bcolor": "180",
    "Y": 43,
    "L": 72.5371704101563,
    "a": -3.4389488697052,
    "b": -1.98791468143463,
    "C": 3.97217488288879,
    "h": 210.03044128418,
    "CMY_C": 0.33577519655228,
    "CMY_M": 0.29362499713898,
    "CMY_Y": 0.29411649703979,
    "CMYK_C": 0.05967113748193,
    "CMYK_M": 0,
    "CMYK_Y": 0.00069580588024,
    "CMYK_K": 0.29362499713898
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0493",
    "Farbtonhilfsbezeichnung": "69.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "156",
    "Bcolor": "156",
    "Y": 32,
    "L": 63.725658416748,
    "a": -3.1149799823761,
    "b": -1.90212392807007,
    "C": 3.64981865882874,
    "h": 211.409805297852,
    "CMY_C": 0.42464286088943,
    "CMY_M": 0.38706481456757,
    "CMY_Y": 0.38679617643356,
    "CMYK_C": 0.06171958148479,
    "CMYK_M": 0.00043808945338,
    "CMYK_Y": 0,
    "CMYK_K": 0.38679617643356
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0494",
    "Farbtonhilfsbezeichnung": "69.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "186",
    "Bcolor": "194",
    "Y": 44,
    "L": 73.1467895507813,
    "a": -10.8209581375122,
    "b": -8.91465950012207,
    "C": 14.0201387405396,
    "h": 219.482818603516,
    "CMY_C": 0.42088878154755,
    "CMY_M": 0.26952159404755,
    "CMY_Y": 0.2394711971283,
    "CMYK_C": 0.23854137957096,
    "CMYK_M": 0.03951250389218,
    "CMYK_Y": 0,
    "CMYK_K": 0.2394711971283
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0495",
    "Farbtonhilfsbezeichnung": "69.06.18",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "156",
    "Bcolor": "156",
    "Y": 31,
    "L": 62.9628372192383,
    "a": -6.25440120697021,
    "b": -2.68960189819336,
    "C": 6.80819320678711,
    "h": 203.269332885742,
    "CMY_C": 0.46010273694992,
    "CMY_M": 0.38819998502731,
    "CMY_Y": 0.38962632417679,
    "CMYK_C": 0.1175265610218,
    "CMYK_M": 0,
    "CMYK_Y": 0.00233138143085,
    "CMYK_K": 0.38819998502731
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0496",
    "Farbtonhilfsbezeichnung": "69.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "206",
    "Bcolor": "209",
    "Y": 58,
    "L": 80.9234390258789,
    "a": -7.6351900100708,
    "b": -5.63195943832397,
    "C": 9.48762798309326,
    "h": 216.413665771484,
    "CMY_C": 0.29554998874664,
    "CMY_M": 0.19292652606964,
    "CMY_Y": 0.17848771810532,
    "CMYK_C": 0.14249606430531,
    "CMYK_M": 0.01757588796318,
    "CMYK_Y": 0,
    "CMYK_K": 0.17848771810532
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0497",
    "Farbtonhilfsbezeichnung": "69.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "160",
    "Bcolor": "171",
    "Y": 32,
    "L": 63.3889007568359,
    "a": -10.4583110809326,
    "b": -10.586145401001,
    "C": 14.880952835083,
    "h": 225.348037719727,
    "CMY_C": 0.52675175666809,
    "CMY_M": 0.37309139966965,
    "CMY_Y": 0.33133298158646,
    "CMYK_C": 0.29225125908852,
    "CMYK_M": 0.06245024502277,
    "CMYK_Y": 0,
    "CMYK_K": 0.33133298158646
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0498",
    "Farbtonhilfsbezeichnung": "69.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "234",
    "Bcolor": "235",
    "Y": 76,
    "L": 90.6624069213867,
    "a": -8.57050132751465,
    "b": -4.87375831604004,
    "C": 9.85936164855957,
    "h": 209.625442504883,
    "CMY_C": 0.19487869739532,
    "CMY_M": 0.08334100246429,
    "CMY_Y": 0.07687622308731,
    "CMYK_C": 0.12782952189445,
    "CMYK_M": 0.00700315553695,
    "CMYK_Y": 0,
    "CMYK_K": 0.07687622308731
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0499",
    "Farbtonhilfsbezeichnung": "69.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "219",
    "Bcolor": "224",
    "Y": 66,
    "L": 85.1086883544922,
    "a": -10.2607660293579,
    "b": -7.17352294921875,
    "C": 12.5196943283081,
    "h": 214.958221435547,
    "CMY_C": 0.28037708997726,
    "CMY_M": 0.14079284667969,
    "CMY_Y": 0.12171119451523,
    "CMYK_C": 0.18065343797207,
    "CMYK_M": 0.02172594331205,
    "CMYK_Y": 0,
    "CMYK_K": 0.12171119451523
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0500",
    "Farbtonhilfsbezeichnung": "69.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "210",
    "Bcolor": "217",
    "Y": 58,
    "L": 81.3287353515625,
    "a": -12.2210960388184,
    "b": -9.24056148529053,
    "C": 15.3213300704956,
    "h": 217.093490600586,
    "CMY_C": 0.34877038002014,
    "CMY_M": 0.1776949763298,
    "CMY_Y": 0.14847368001938,
    "CMYK_C": 0.23522080481052,
    "CMYK_M": 0.03431637585163,
    "CMYK_Y": 0,
    "CMYK_K": 0.14847368001938
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0501",
    "Farbtonhilfsbezeichnung": "69.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "193",
    "Bcolor": "209",
    "Y": 46,
    "L": 74.2173690795898,
    "a": -16.5806560516357,
    "b": -15.8116407394409,
    "C": 22.9112663269043,
    "h": 223.640014648438,
    "CMY_C": 0.50591707229614,
    "CMY_M": 0.24442404508591,
    "CMY_Y": 0.17947059869766,
    "CMYK_C": 0.39784860610962,
    "CMYK_M": 0.07916041463614,
    "CMYK_Y": 0,
    "CMYK_K": 0.17947059869766
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0502",
    "Farbtonhilfsbezeichnung": "69.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "177",
    "Bcolor": "186",
    "Y": 33,
    "L": 66.0945053100586,
    "a": -31.5345230102539,
    "b": -15.3575887680054,
    "C": 35.0753707885742,
    "h": 205.966491699219,
    "CMY_C": 0.84878355264664,
    "CMY_M": 0.30542016029358,
    "CMY_Y": 0.27163875102997,
    "CMYK_C": 0.79238814115524,
    "CMYK_M": 0.04638002067804,
    "CMYK_Y": 0,
    "CMYK_K": 0.27163875102997
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0503",
    "Farbtonhilfsbezeichnung": "69.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "233",
    "Bcolor": "237",
    "Y": 74,
    "L": 89.8475952148438,
    "a": -11.4919033050537,
    "b": -6.8812460899353,
    "C": 13.3946027755737,
    "h": 210.912796020508,
    "CMY_C": 0.2387615442276,
    "CMY_M": 0.08548623323441,
    "CMY_Y": 0.07145607471466,
    "CMYK_C": 0.18018046021461,
    "CMYK_M": 0.0151098491624,
    "CMYK_Y": 0,
    "CMYK_K": 0.07145607471466
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0504",
    "Farbtonhilfsbezeichnung": "69.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "217",
    "Bcolor": "226",
    "Y": 64,
    "L": 84.1421737670898,
    "a": -11.9287605285645,
    "b": -9.66546630859375,
    "C": 15.353063583374,
    "h": 219.016677856445,
    "CMY_C": 0.31781709194183,
    "CMY_M": 0.14719074964523,
    "CMY_Y": 0.11437451839447,
    "CMYK_C": 0.22971625626087,
    "CMYK_M": 0.03705430030823,
    "CMYK_Y": 0,
    "CMYK_K": 0.11437451839447
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0505",
    "Farbtonhilfsbezeichnung": "69.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 57,
    "L": 81.1384811401367,
    "a": -16.6659812927246,
    "b": -13.7897233963013,
    "C": 21.6312599182129,
    "h": 219.604949951172,
    "CMY_C": 0.41955012083054,
    "CMY_M": 0.1693360209465,
    "CMY_Y": 0.11807459592819,
    "CMYK_C": 0.34183788299561,
    "CMYK_M": 0.05812444537878,
    "CMYK_Y": 0,
    "CMYK_K": 0.11807459592819
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0506",
    "Farbtonhilfsbezeichnung": "69.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "190",
    "Bcolor": "210",
    "Y": 45,
    "L": 72.4902496337891,
    "a": -20.1495838165283,
    "b": -18.9044647216797,
    "C": 27.6294136047363,
    "h": 223.173919677734,
    "CMY_C": 0.59079933166504,
    "CMY_M": 0.25532913208008,
    "CMY_Y": 0.17664247751236,
    "CMYK_C": 0.50300973653793,
    "CMYK_M": 0.09556803107262,
    "CMYK_Y": 0,
    "CMYK_K": 0.17664247751236
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0507",
    "Farbtonhilfsbezeichnung": "69.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "173",
    "Bcolor": "198",
    "Y": 35,
    "L": 65.8884963989258,
    "a": -21.2432289123535,
    "b": -22.3941783905029,
    "C": 30.867036819458,
    "h": 226.510833740234,
    "CMY_C": 0.7200248837471,
    "CMY_M": 0.32294285297394,
    "CMY_Y": 0.22381842136383,
    "CMYK_C": 0.63929170370102,
    "CMYK_M": 0.12770779430866,
    "CMYK_Y": 0,
    "CMYK_K": 0.22381842136383
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0508",
    "Farbtonhilfsbezeichnung": "69.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "233",
    "Bcolor": "231",
    "Y": 74,
    "L": 89.5671310424805,
    "a": -13.4054164886475,
    "b": -4.53028964996338,
    "C": 14.1502199172974,
    "h": 198.672409057617,
    "CMY_C": 0.24884140491486,
    "CMY_M": 0.08521395921707,
    "CMY_Y": 0.09219735860825,
    "CMYK_C": 0.17886963486671,
    "CMYK_M": 0,
    "CMYK_Y": 0.00763391563669,
    "CMYK_K": 0.08521395921707
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0509",
    "Farbtonhilfsbezeichnung": "69.18.09",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "223",
    "Bcolor": "223",
    "Y": 67,
    "L": 84.8228759765625,
    "a": -19.5159912109375,
    "b": -7.11780023574829,
    "C": 20.7734680175781,
    "h": 200.037734985352,
    "CMY_C": 0.37213408946991,
    "CMY_M": 0.12484920024872,
    "CMY_Y": 0.1263552904129,
    "CMYK_C": 0.28256261348724,
    "CMYK_M": 0,
    "CMYK_Y": 0.00172094930895,
    "CMYK_K": 0.12484920024872
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0510",
    "Farbtonhilfsbezeichnung": "69.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "211",
    "Bcolor": "217",
    "Y": 57,
    "L": 79.5876083374023,
    "a": -24.1079349517822,
    "b": -11.84499168396,
    "C": 26.8606834411621,
    "h": 206.166351318359,
    "CMY_C": 0.5088866353035,
    "CMY_M": 0.17260086536407,
    "CMY_Y": 0.1500096321106,
    "CMYK_C": 0.42221301794052,
    "CMYK_M": 0.02657822333276,
    "CMYK_Y": 0,
    "CMYK_K": 0.1500096321106
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0511",
    "Farbtonhilfsbezeichnung": "69.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "192",
    "Bcolor": "205",
    "Y": 44,
    "L": 71.7144088745117,
    "a": -29.1787948608398,
    "b": -17.5968036651611,
    "C": 34.0741767883301,
    "h": 211.092849731445,
    "CMY_C": 0.7340122461319,
    "CMY_M": 0.2479841709137,
    "CMY_Y": 0.19520527124405,
    "CMYK_C": 0.66949617862701,
    "CMYK_M": 0.06558057665825,
    "CMYK_Y": 0,
    "CMYK_K": 0.19520527124405
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0512",
    "Farbtonhilfsbezeichnung": "69.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "2",
    "Gcolor": "173",
    "Bcolor": "194",
    "Y": 34,
    "L": 64.9296875,
    "a": -29.0910129547119,
    "b": -21.8000183105469,
    "C": 36.3528251647949,
    "h": 216.846893310547,
    "CMY_C": 0.99171340465546,
    "CMY_M": 0.31992447376251,
    "CMY_Y": 0.23895472288132,
    "CMYK_C": 0.98911154270172,
    "CMYK_M": 0.10639281570911,
    "CMYK_Y": 0,
    "CMYK_K": 0.23895472288132
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0513",
    "Farbtonhilfsbezeichnung": "69.21.09",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "223",
    "Bcolor": "221",
    "Y": 65,
    "L": 84.4192962646484,
    "a": -20.7972526550293,
    "b": -6.80806159973145,
    "C": 21.8832225799561,
    "h": 198.126052856445,
    "CMY_C": 0.38811928033829,
    "CMY_M": 0.12689083814621,
    "CMY_Y": 0.13321161270142,
    "CMYK_C": 0.29919332265854,
    "CMYK_M": 0,
    "CMYK_Y": 0.00723938643932,
    "CMYK_K": 0.12689083814621
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0514",
    "Farbtonhilfsbezeichnung": "69.21.12",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "209",
    "Bcolor": "209",
    "Y": 54,
    "L": 78.1834716796875,
    "a": -27.5693893432617,
    "b": -9.7651424407959,
    "C": 29.2477226257324,
    "h": 199.504272460938,
    "CMY_C": 0.55361044406891,
    "CMY_M": 0.18231153488159,
    "CMY_Y": 0.18072646856308,
    "CMYK_C": 0.45513978600502,
    "CMYK_M": 0.00193472171668,
    "CMYK_Y": 0,
    "CMYK_K": 0.18072646856308
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0515",
    "Farbtonhilfsbezeichnung": "69.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "193",
    "Bcolor": "198",
    "Y": 44,
    "L": 71.952995300293,
    "a": -31.755464553833,
    "b": -13.4066925048828,
    "C": 34.4695358276367,
    "h": 202.888763427734,
    "CMY_C": 0.72973877191544,
    "CMY_M": 0.24224662780762,
    "CMY_Y": 0.22259604930878,
    "CMYK_C": 0.65235418081284,
    "CMYK_M": 0.02527717873454,
    "CMYK_Y": 0,
    "CMYK_K": 0.22259604930878
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0516",
    "Farbtonhilfsbezeichnung": "72.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "227",
    "Bcolor": "220",
    "Y": 76,
    "L": 88.8905715942383,
    "a": -6.16390466690063,
    "b": 0.84562015533447,
    "C": 6.22163915634155,
    "h": 172.188415527344,
    "CMY_C": 0.1714408993721,
    "CMY_M": 0.11012303829193,
    "CMY_Y": 0.1384369134903,
    "CMYK_C": 0.06890600174665,
    "CMYK_M": 0,
    "CMYK_Y": 0.03181774169207,
    "CMYK_K": 0.11012303829193
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0517",
    "Farbtonhilfsbezeichnung": "72.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "231",
    "Bcolor": "225",
    "Y": 74,
    "L": 89.3576049804688,
    "a": -10.0311260223389,
    "b": -1.33545458316803,
    "C": 10.1196308135986,
    "h": 187.583251953125,
    "CMY_C": 0.20743125677109,
    "CMY_M": 0.09573674201965,
    "CMY_Y": 0.11770325899124,
    "CMYK_C": 0.12351990491152,
    "CMYK_M": 0,
    "CMYK_Y": 0.02429217100143,
    "CMYK_K": 0.09573674201965
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0518",
    "Farbtonhilfsbezeichnung": "72.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "215",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.5279922485352,
    "a": -11.9892835617065,
    "b": -2.21944904327393,
    "C": 12.1929845809937,
    "h": 190.487838745117,
    "CMY_C": 0.29143053293228,
    "CMY_M": 0.1559984087944,
    "CMY_Y": 0.17541551589966,
    "CMYK_C": 0.16046430170536,
    "CMYK_M": 0,
    "CMYK_Y": 0.02300600707531,
    "CMYK_K": 0.1559984087944
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0519",
    "Farbtonhilfsbezeichnung": "72.09.12",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "201",
    "Bcolor": "197",
    "Y": 53,
    "L": 78.2909927368164,
    "a": -13.5428228378296,
    "b": -2.95969104766846,
    "C": 13.8624610900879,
    "h": 192.327774047852,
    "CMY_C": 0.36439472436905,
    "CMY_M": 0.2099980711937,
    "CMY_Y": 0.22698706388474,
    "CMYK_C": 0.19543832540512,
    "CMYK_M": 0,
    "CMYK_Y": 0.02150500193238,
    "CMYK_K": 0.2099980711937
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0520",
    "Farbtonhilfsbezeichnung": "72.09.15",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "173",
    "Bcolor": "172",
    "Y": 38,
    "L": 67.3344116210938,
    "a": -16.8256740570068,
    "b": -5.38656616210938,
    "C": 17.6668739318848,
    "h": 197.751922607422,
    "CMY_C": 0.52114009857178,
    "CMY_M": 0.32076716423035,
    "CMY_Y": 0.32667618989944,
    "CMYK_C": 0.29499888420105,
    "CMYK_M": 0,
    "CMYK_Y": 0.00869955867529,
    "CMYK_K": 0.32076716423035
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0521",
    "Farbtonhilfsbezeichnung": "72.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "165",
    "Bcolor": "167",
    "Y": 34,
    "L": 64.7245025634766,
    "a": -13.8634719848633,
    "b": -6.59601068496704,
    "C": 15.3526287078857,
    "h": 205.4443359375,
    "CMY_C": 0.52535724639893,
    "CMY_M": 0.35363388061523,
    "CMY_Y": 0.34527170658112,
    "CMYK_C": 0.27505385875702,
    "CMYK_M": 0.01277197618037,
    "CMYK_Y": 0,
    "CMYK_K": 0.34527170658112
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0522",
    "Farbtonhilfsbezeichnung": "72.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "232",
    "Bcolor": "229",
    "Y": 75,
    "L": 89.3948113269557,
    "a": -11.55065589556,
    "b": -3.43841592685781,
    "C": 12.0515706737215,
    "h": 0.28932832390012,
    "CMY_C": 0.2291289,
    "CMY_M": 0.09144571,
    "CMY_Y": 0.1019482,
    "CMYK_C": 0.1515409,
    "CMYK_M": 0,
    "CMYK_Y": 0.01155961,
    "CMYK_K": 0.09144571
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0523",
    "Farbtonhilfsbezeichnung": "72.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "222",
    "Bcolor": "223",
    "Y": 65,
    "L": 85.0613403320313,
    "a": -15.1557655334473,
    "b": -6.79117441177368,
    "C": 16.6077480316162,
    "h": 204.136764526367,
    "CMY_C": 0.32467329502106,
    "CMY_M": 0.13113224506378,
    "CMY_Y": 0.12561118602753,
    "CMYK_C": 0.22765856981277,
    "CMYK_M": 0.00631419243291,
    "CMYK_Y": 0,
    "CMYK_K": 0.12561118602753
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0524",
    "Farbtonhilfsbezeichnung": "72.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "210",
    "Bcolor": "213",
    "Y": 55,
    "L": 80.4526290893555,
    "a": -17.5952205657959,
    "b": -8.63079261779785,
    "C": 19.5980186462402,
    "h": 206.128829956055,
    "CMY_C": 0.4076544046402,
    "CMY_M": 0.176573574543,
    "CMY_Y": 0.16309082508087,
    "CMYK_C": 0.29222238063812,
    "CMYK_M": 0.0161101706326,
    "CMYK_Y": 0,
    "CMYK_K": 0.16309082508087
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0525",
    "Farbtonhilfsbezeichnung": "72.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "188",
    "Bcolor": "194",
    "Y": 44,
    "L": 72.6423721313477,
    "a": -17.4976940155029,
    "b": -9.81265354156494,
    "C": 20.0613422393799,
    "h": 209.283569335938,
    "CMY_C": 0.49632358551025,
    "CMY_M": 0.2614648938179,
    "CMY_Y": 0.23924833536148,
    "CMYK_C": 0.33792269229889,
    "CMYK_M": 0.02920342981815,
    "CMYK_Y": 0,
    "CMYK_K": 0.23924833536148
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0526",
    "Farbtonhilfsbezeichnung": "72.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "166",
    "Bcolor": "176",
    "Y": 33,
    "L": 63.9976234436035,
    "a": -18.7721271514893,
    "b": -12.6530122756958,
    "C": 22.6382751464844,
    "h": 213.981231689453,
    "CMY_C": 0.61979269981384,
    "CMY_M": 0.35041010379791,
    "CMY_Y": 0.31149137020111,
    "CMYK_C": 0.44778135418892,
    "CMYK_M": 0.05652613937855,
    "CMYK_Y": 0,
    "CMYK_K": 0.31149137020111
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0527",
    "Farbtonhilfsbezeichnung": "72.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "190",
    "Bcolor": "188",
    "Y": 44,
    "L": 72.1320343017578,
    "a": -23.5276279449463,
    "b": -7.40233707427979,
    "C": 24.6646270751953,
    "h": 197.464782714844,
    "CMY_C": 0.55390429496765,
    "CMY_M": 0.25639319419861,
    "CMY_Y": 0.26243406534195,
    "CMYK_C": 0.40009194612503,
    "CMYK_M": 0,
    "CMYK_Y": 0.00812374334782,
    "CMYK_K": 0.25639319419861
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0528",
    "Farbtonhilfsbezeichnung": "72.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "169",
    "Bcolor": "167",
    "Y": 34,
    "L": 64.5234680175781,
    "a": -24.2104072570801,
    "b": -7.1954984664917,
    "C": 25.25705909729,
    "h": 196.552307128906,
    "CMY_C": 0.64272034168243,
    "CMY_M": 0.33674788475037,
    "CMY_Y": 0.34430140256882,
    "CMYK_C": 0.46132150292397,
    "CMYK_M": 0,
    "CMYK_Y": 0.01138860732317,
    "CMYK_K": 0.33674788475037
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0529",
    "Farbtonhilfsbezeichnung": "72.18.09",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "224",
    "Bcolor": "212",
    "Y": 64,
    "L": 84.2460174560547,
    "a": -25.3119106292725,
    "b": -2.43268394470215,
    "C": 25.4285430908203,
    "h": 185.489730834961,
    "CMY_C": 0.41413825750351,
    "CMY_M": 0.12129020690918,
    "CMY_Y": 0.1676407456398,
    "CMYK_C": 0.33327049016953,
    "CMYK_M": 0,
    "CMYK_Y": 0.05274840444326,
    "CMYK_K": 0.12129020690918
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0530",
    "Farbtonhilfsbezeichnung": "72.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "195",
    "Bcolor": "183",
    "Y": 44,
    "L": 71.8791275024414,
    "a": -37.34423828125,
    "b": -5.36037015914917,
    "C": 37.7269897460938,
    "h": 188.168411254883,
    "CMY_C": 0.74749237298965,
    "CMY_M": 0.23603999614716,
    "CMY_Y": 0.28103113174438,
    "CMYK_C": 0.66947531700134,
    "CMYK_M": 0,
    "CMYK_Y": 0.05889200419188,
    "CMYK_K": 0.23603999614716
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0531",
    "Farbtonhilfsbezeichnung": "72.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "178",
    "Bcolor": "170",
    "Y": 35,
    "L": 65.8852157592773,
    "a": -36.9703674316406,
    "b": -6.87337446212769,
    "C": 37.603874206543,
    "h": 190.531936645508,
    "CMY_C": 0.85851693153381,
    "CMY_M": 0.30137366056442,
    "CMY_Y": 0.33355009555817,
    "CMYK_C": 0.79748392105103,
    "CMYK_M": 0,
    "CMYK_Y": 0.0460567176342,
    "CMYK_K": 0.30137366056442
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0532",
    "Farbtonhilfsbezeichnung": "72.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "214",
    "Bcolor": "201",
    "Y": 56,
    "L": 79.5603179931641,
    "a": -31.1507797241211,
    "b": -3.69357061386108,
    "C": 31.368989944458,
    "h": 186.76203918457,
    "CMY_C": 0.54148072004318,
    "CMY_M": 0.16233003139496,
    "CMY_Y": 0.21002918481827,
    "CMYK_C": 0.45262539386749,
    "CMYK_M": 0,
    "CMYK_Y": 0.05694265663624,
    "CMYK_K": 0.16233003139496
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0533",
    "Farbtonhilfsbezeichnung": "72.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "175",
    "Bcolor": "177",
    "Y": 34,
    "L": 64.7063140869141,
    "a": -37.165771484375,
    "b": -12.4876737594604,
    "C": 39.2076072692871,
    "h": 198.572311401367,
    "CMY_C": 1,
    "CMY_M": 0.31227213144302,
    "CMY_Y": 0.3068510890007,
    "CMYK_C": 1,
    "CMYK_M": 0.0078208912164,
    "CMYK_Y": 0,
    "CMYK_K": 0.3068510890007
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0534",
    "Farbtonhilfsbezeichnung": "75.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 85,
    "L": 94.1434326171875,
    "a": -0.689317882061,
    "b": 2.36566948890686,
    "C": 2.46405172348022,
    "h": 106.245269775391,
    "CMY_C": 0.06343650817871,
    "CMY_M": 0.06448429822922,
    "CMY_Y": 0.09092915058136,
    "CMYK_C": 0,
    "CMYK_M": 0.00111876032315,
    "CMYK_Y": 0.02935480885208,
    "CMYK_K": 0.06343650817871
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0535",
    "Farbtonhilfsbezeichnung": "75.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "217",
    "Bcolor": "210",
    "Y": 69,
    "L": 86.6298446655273,
    "a": -1.17599654197693,
    "b": 2.83832621574402,
    "C": 3.07230591773987,
    "h": 112.505569458008,
    "CMY_C": 0.14931857585907,
    "CMY_M": 0.14714294672012,
    "CMY_Y": 0.17714476585388,
    "CMYK_C": 0.00255098915659,
    "CMYK_M": 0,
    "CMYK_Y": 0.03517801687121,
    "CMYK_K": 0.14714294672012
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0536",
    "Farbtonhilfsbezeichnung": "75.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "204",
    "Bcolor": "197",
    "Y": 61,
    "L": 81.6858215332031,
    "a": -1.8228657245636,
    "b": 2.26328778266907,
    "C": 2.90608167648315,
    "h": 128.848190307617,
    "CMY_C": 0.21041870117188,
    "CMY_M": 0.19974607229233,
    "CMY_Y": 0.22660708427429,
    "CMYK_C": 0.01333655323833,
    "CMYK_M": 0,
    "CMYK_Y": 0.0335656106472,
    "CMYK_K": 0.19974607229233
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0537",
    "Farbtonhilfsbezeichnung": "75.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "200",
    "Bcolor": "195",
    "Y": 57,
    "L": 80.3490142822266,
    "a": -1.13360440731049,
    "b": 1.42384719848633,
    "C": 1.8199999332428,
    "h": 128.525253295898,
    "CMY_C": 0.2223801612854,
    "CMY_M": 0.2156475186348,
    "CMY_Y": 0.23482888936996,
    "CMYK_C": 0.00858369562775,
    "CMYK_M": 0,
    "CMYK_Y": 0.02445503883064,
    "CMYK_K": 0.2156475186348
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0538",
    "Farbtonhilfsbezeichnung": "75.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "178",
    "Bcolor": "170",
    "Y": 44,
    "L": 72.2199249267578,
    "a": -1.51783645153046,
    "b": 3.1986231803894,
    "C": 3.54048275947571,
    "h": 115.385650634766,
    "CMY_C": 0.30678248405457,
    "CMY_M": 0.3026437163353,
    "CMY_Y": 0.33383631706238,
    "CMYK_C": 0.0059349401854,
    "CMYK_M": 0,
    "CMYK_Y": 0.04472979158163,
    "CMYK_K": 0.3026437163353
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0539",
    "Farbtonhilfsbezeichnung": "75.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "143",
    "Gcolor": "148",
    "Bcolor": "147",
    "Y": 30,
    "L": 60.8753852844238,
    "a": -1.64201784133911,
    "b": -0.9673228263855,
    "C": 1.90576386451721,
    "h": 210.502593994141,
    "CMY_C": 0.43941193819046,
    "CMY_M": 0.41990834474564,
    "CMY_Y": 0.42226624488831,
    "CMYK_C": 0.03362157195807,
    "CMYK_M": 0,
    "CMYK_Y": 0.00406470289454,
    "CMYK_K": 0.41990834474564
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0540",
    "Farbtonhilfsbezeichnung": "78.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "241",
    "Bcolor": "224",
    "Y": 84,
    "L": 93.7152633666992,
    "a": -7.55131912231445,
    "b": 5.88367557525635,
    "C": 9.5728816986084,
    "h": 142.075744628906,
    "CMY_C": 0.11158043146133,
    "CMY_M": 0.0543492436409,
    "CMY_Y": 0.12290704250336,
    "CMYK_C": 0.06052042543888,
    "CMYK_M": 0,
    "CMYK_Y": 0.07249800860882,
    "CMYK_K": 0.0543492436409
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0541",
    "Farbtonhilfsbezeichnung": "75.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "227",
    "Bcolor": "221",
    "Y": 75,
    "L": 89.7677612304688,
    "a": -2.49576473236084,
    "b": 1.47181129455566,
    "C": 2.89742469787598,
    "h": 149.471145629883,
    "CMY_C": 0.12970685958862,
    "CMY_M": 0.1089146733284,
    "CMY_Y": 0.13291162252426,
    "CMYK_C": 0.0233335532248,
    "CMYK_M": 0,
    "CMYK_Y": 0.02693002484739,
    "CMYK_K": 0.1089146733284
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0542",
    "Farbtonhilfsbezeichnung": "75.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 67,
    "L": 85.0684280395508,
    "a": -3.60627317428589,
    "b": 1.52327632904053,
    "C": 3.91478943824768,
    "h": 157.100982666016,
    "CMY_C": 0.19011795520782,
    "CMY_M": 0.158407330513,
    "CMY_Y": 0.18485540151596,
    "CMYK_C": 0.03767930343747,
    "CMYK_M": 0,
    "CMYK_Y": 0.0314262136817,
    "CMYK_K": 0.158407330513
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0543",
    "Farbtonhilfsbezeichnung": "75.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "202",
    "Bcolor": "197",
    "Y": 56,
    "L": 80.4017028808594,
    "a": -4.18250465393066,
    "b": 0.44423440098763,
    "C": 4.20602989196777,
    "h": 173.937194824219,
    "CMY_C": 0.24916195869446,
    "CMY_M": 0.20791673660278,
    "CMY_Y": 0.22760140895844,
    "CMYK_C": 0.05207182466984,
    "CMYK_M": 0,
    "CMYK_Y": 0.02485177107155,
    "CMYK_K": 0.20791673660278
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0544",
    "Farbtonhilfsbezeichnung": "75.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "181",
    "Bcolor": "177",
    "Y": 44,
    "L": 72.7520217895508,
    "a": -4.62447071075439,
    "b": -0.04618963971734,
    "C": 4.62470149993896,
    "h": 180.572250366211,
    "CMY_C": 0.33597058057785,
    "CMY_M": 0.28928196430206,
    "CMY_Y": 0.30572110414505,
    "CMYK_C": 0.06569217890501,
    "CMYK_M": 0,
    "CMYK_Y": 0.0231303256005,
    "CMYK_K": 0.28928196430206
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0545",
    "Farbtonhilfsbezeichnung": "75.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "156",
    "Bcolor": "152",
    "Y": 31,
    "L": 63.1774139404297,
    "a": -4.54808807373047,
    "b": -0.41631841659546,
    "C": 4.56710243225098,
    "h": 185.230102539062,
    "CMY_C": 0.43615061044693,
    "CMY_M": 0.39012080430984,
    "CMY_Y": 0.40283465385437,
    "CMYK_C": 0.07547364383936,
    "CMYK_M": 0,
    "CMYK_Y": 0.02084650471807,
    "CMYK_K": 0.39012080430984
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0546",
    "Farbtonhilfsbezeichnung": "75.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "240",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.56787109375,
    "a": -6.1990180015564,
    "b": 1.54576647281647,
    "C": 6.38883543014526,
    "h": 165.998458862305,
    "CMY_C": 0.11748647689819,
    "CMY_M": 0.05789589881897,
    "CMY_Y": 0.09197300672531,
    "CMYK_C": 0.06325265020132,
    "CMYK_M": 0,
    "CMYK_Y": 0.03617127612233,
    "CMYK_K": 0.05789589881897
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0547",
    "Farbtonhilfsbezeichnung": "75.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 77,
    "L": 90.9339828491211,
    "a": -7.50945425033569,
    "b": 2.01278877258301,
    "C": 7.77452373504639,
    "h": 164.995468139648,
    "CMY_C": 0.15583902597427,
    "CMY_M": 0.08461916446686,
    "CMY_Y": 0.12476044893265,
    "CMYK_C": 0.07780352979898,
    "CMYK_M": 0,
    "CMYK_Y": 0.04385200515389,
    "CMYK_K": 0.08461916446686
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0548",
    "Farbtonhilfsbezeichnung": "75.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "217",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.9855194091797,
    "a": -8.39364433288574,
    "b": 1.16736173629761,
    "C": 8.47443199157715,
    "h": 172.082275390625,
    "CMY_C": 0.23140072822571,
    "CMY_M": 0.14855992794037,
    "CMY_Y": 0.18379986286163,
    "CMYK_C": 0.09729492664337,
    "CMYK_M": 0,
    "CMYK_Y": 0.04138862714171,
    "CMYK_K": 0.14855992794037
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0549",
    "Farbtonhilfsbezeichnung": "75.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "202",
    "Bcolor": "193",
    "Y": 56,
    "L": 79.6445617675781,
    "a": -8.3347110748291,
    "b": 1.34682810306549,
    "C": 8.44282817840576,
    "h": 170.820770263672,
    "CMY_C": 0.28777271509171,
    "CMY_M": 0.20731967687607,
    "CMY_Y": 0.24279952049255,
    "CMYK_C": 0.10149493813515,
    "CMYK_M": 0,
    "CMYK_Y": 0.0447593331337,
    "CMYK_K": 0.20731967687607
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0550",
    "Farbtonhilfsbezeichnung": "75.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "183",
    "Bcolor": "176",
    "Y": 45,
    "L": 72.6899185180664,
    "a": -9.0939998626709,
    "b": 0.14339311420918,
    "C": 9.09512996673584,
    "h": 179.096649169922,
    "CMY_C": 0.37214893102646,
    "CMY_M": 0.28050345182419,
    "CMY_Y": 0.30828636884689,
    "CMYK_C": 0.12737445533276,
    "CMYK_M": 0,
    "CMYK_Y": 0.03861438483,
    "CMYK_K": 0.28050345182419
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0551",
    "Farbtonhilfsbezeichnung": "75.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "161",
    "Bcolor": "155",
    "Y": 33,
    "L": 64.5487213134766,
    "a": -8.40756034851074,
    "b": -0.0243700761348,
    "C": 8.40759563446045,
    "h": 180.166076660156,
    "CMY_C": 0.45135718584061,
    "CMY_M": 0.36798590421677,
    "CMY_Y": 0.39190918207169,
    "CMYK_C": 0.13191364705563,
    "CMYK_M": 0,
    "CMYK_Y": 0.03785244375467,
    "CMYK_K": 0.36798590421677
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0552",
    "Farbtonhilfsbezeichnung": "75.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "221",
    "Bcolor": "213",
    "Y": 65,
    "L": 85.3948440551758,
    "a": -13.274736404419,
    "b": -0.99305558204651,
    "C": 13.3118286132813,
    "h": 184.278213500977,
    "CMY_C": 0.27762186527252,
    "CMY_M": 0.13298356533051,
    "CMY_Y": 0.16416245698929,
    "CMYK_C": 0.16682301461697,
    "CMYK_M": 0,
    "CMYK_Y": 0.0359611324966,
    "CMYK_K": 0.13298356533051
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0553",
    "Farbtonhilfsbezeichnung": "75.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "206",
    "Bcolor": "197",
    "Y": 56,
    "L": 79.3991317749023,
    "a": -16.66335105896,
    "b": -1.50672924518585,
    "C": 16.7313327789307,
    "h": 185.166732788086,
    "CMY_C": 0.37488520145416,
    "CMY_M": 0.19198071956635,
    "CMY_Y": 0.22589910030365,
    "CMYK_C": 0.22636152803898,
    "CMYK_M": 0,
    "CMYK_Y": 0.04197719320655,
    "CMYK_K": 0.19198071956635
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0554",
    "Farbtonhilfsbezeichnung": "75.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "186",
    "Bcolor": "180",
    "Y": 44,
    "L": 71.4727935791016,
    "a": -20.6480007171631,
    "b": -3.86862301826477,
    "C": 21.007287979126,
    "h": 190.611938476562,
    "CMY_C": 0.50881612300873,
    "CMY_M": 0.26976066827774,
    "CMY_Y": 0.29413866996765,
    "CMYK_C": 0.32736590504646,
    "CMYK_M": 0,
    "CMYK_Y": 0.03338357806206,
    "CMYK_K": 0.26976066827774
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0555",
    "Farbtonhilfsbezeichnung": "75.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "162",
    "Bcolor": "155",
    "Y": 32,
    "L": 63.5641021728516,
    "a": -15.6126184463501,
    "b": -1.60914349555969,
    "C": 15.6953239440918,
    "h": 185.884521484375,
    "CMY_C": 0.53004497289658,
    "CMY_M": 0.36382353305817,
    "CMY_Y": 0.39196044206619,
    "CMYK_C": 0.26128196716309,
    "CMYK_M": 0,
    "CMYK_Y": 0.04422815144062,
    "CMYK_K": 0.36382353305817
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0556",
    "Farbtonhilfsbezeichnung": "75.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "220",
    "Bcolor": "205",
    "Y": 65,
    "L": 84.7985000610352,
    "a": -14.7746324539185,
    "b": 2.21826148033142,
    "C": 14.9402294158935,
    "h": 171.461395263672,
    "CMY_C": 0.2842093706131,
    "CMY_M": 0.1373233795166,
    "CMY_Y": 0.19435930252075,
    "CMYK_C": 0.17026773095131,
    "CMYK_M": 0,
    "CMYK_Y": 0.06611506640911,
    "CMYK_K": 0.1373233795166
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0557",
    "Farbtonhilfsbezeichnung": "75.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "206",
    "Bcolor": "192",
    "Y": 56,
    "L": 79.5315093994141,
    "a": -16.1631813049316,
    "b": 1.45167100429535,
    "C": 16.2282409667969,
    "h": 174.86784362793,
    "CMY_C": 0.35606557130814,
    "CMY_M": 0.19231313467026,
    "CMY_Y": 0.24577659368515,
    "CMYK_C": 0.20274247229099,
    "CMYK_M": 0,
    "CMYK_Y": 0.06619329750538,
    "CMYK_K": 0.19231313467026
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0558",
    "Farbtonhilfsbezeichnung": "75.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "188",
    "Bcolor": "176",
    "Y": 45,
    "L": 72.9869842529297,
    "a": -16.8880863189697,
    "b": 0.71916133165359,
    "C": 16.9033908843994,
    "h": 177.561584472656,
    "CMY_C": 0.43457996845245,
    "CMY_M": 0.26179355382919,
    "CMY_Y": 0.31020104885101,
    "CMYK_C": 0.23406246304512,
    "CMYK_M": 0,
    "CMYK_Y": 0.06557446718216,
    "CMYK_K": 0.26179355382919
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0559",
    "Farbtonhilfsbezeichnung": "75.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "232",
    "Bcolor": "216",
    "Y": 72,
    "L": 88.2588500976563,
    "a": -19.5617694854736,
    "b": 1.8078693151474,
    "C": 19.6451320648193,
    "h": 174.719802856445,
    "CMY_C": 0.29231995344162,
    "CMY_M": 0.08883708715439,
    "CMY_Y": 0.15423440933228,
    "CMYK_C": 0.22332215309143,
    "CMYK_M": 0,
    "CMYK_Y": 0.07177346944809,
    "CMYK_K": 0.08883708715439
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0560",
    "Farbtonhilfsbezeichnung": "75.18.09",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "222",
    "Bcolor": "202",
    "Y": 63,
    "L": 83.1253433227539,
    "a": -28.0656852722168,
    "b": 1.38694024085999,
    "C": 28.0999336242676,
    "h": 177.170867919922,
    "CMY_C": 0.43550252914429,
    "CMY_M": 0.1296079158783,
    "CMY_Y": 0.20807731151581,
    "CMYK_C": 0.35144463181496,
    "CMYK_M": 0,
    "CMYK_Y": 0.09015407413244,
    "CMYK_K": 0.1296079158783
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0561",
    "Farbtonhilfsbezeichnung": "75.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "210",
    "Bcolor": "187",
    "Y": 53,
    "L": 77.7094802856445,
    "a": -35.0862998962402,
    "b": 1.25404059886932,
    "C": 35.1087036132813,
    "h": 177.953018188477,
    "CMY_C": 0.57997870445251,
    "CMY_M": 0.17724359035492,
    "CMY_Y": 0.26610207557678,
    "CMYK_C": 0.48949494957924,
    "CMYK_M": 0,
    "CMYK_Y": 0.10800096392632,
    "CMYK_K": 0.17724359035492
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0562",
    "Farbtonhilfsbezeichnung": "75.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "195",
    "Bcolor": "174",
    "Y": 43,
    "L": 71.649543762207,
    "a": -41.2671127319336,
    "b": -0.57443618774414,
    "C": 41.271110534668,
    "h": 180.797500610352,
    "CMY_C": 0.77841413021088,
    "CMY_M": 0.23353219032288,
    "CMY_Y": 0.31784969568253,
    "CMYK_C": 0.71089994907379,
    "CMYK_M": 0,
    "CMYK_Y": 0.11000788956881,
    "CMYK_K": 0.23353219032288
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0563",
    "Farbtonhilfsbezeichnung": "75.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "181",
    "Bcolor": "163",
    "Y": 35,
    "L": 66.1045761108398,
    "a": -43.2120513916016,
    "b": -2.5032639503479,
    "C": 43.284496307373,
    "h": 183.3154296875,
    "CMY_C": 1,
    "CMY_M": 0.29066771268845,
    "CMY_Y": 0.36238604784012,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.10110682249069,
    "CMYK_K": 0.29066771268845
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0564",
    "Farbtonhilfsbezeichnung": "78.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "225",
    "Y": 84,
    "L": 93.2059020996094,
    "a": -4.72283315658569,
    "b": 4.61159992218018,
    "C": 6.60090970993042,
    "h": 135.682739257813,
    "CMY_C": 0.09860134124756,
    "CMY_M": 0.06619012355804,
    "CMY_Y": 0.11863034963608,
    "CMYK_C": 0.03470858186483,
    "CMYK_M": 0,
    "CMYK_Y": 0.05615728348494,
    "CMYK_K": 0.06619012355804
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0565",
    "Farbtonhilfsbezeichnung": "78.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "229",
    "Bcolor": "218",
    "Y": 76,
    "L": 89.9868316650391,
    "a": -5.15330219268799,
    "b": 3.28529214859009,
    "C": 6.11143732070923,
    "h": 147.481994628906,
    "CMY_C": 0.1423876285553,
    "CMY_M": 0.10086691379547,
    "CMY_Y": 0.14427816867828,
    "CMYK_C": 0.04617860913277,
    "CMYK_M": 0,
    "CMYK_Y": 0.04828123375773,
    "CMYK_K": 0.10086691379547
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0566",
    "Farbtonhilfsbezeichnung": "78.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "209",
    "Bcolor": "195",
    "Y": 62,
    "L": 82.5646667480469,
    "a": -5.79614734649658,
    "b": 4.85958242416382,
    "C": 7.56378650665283,
    "h": 140.022994995117,
    "CMY_C": 0.22343319654465,
    "CMY_M": 0.1818853020668,
    "CMY_Y": 0.23653960227966,
    "CMYK_C": 0.05078492686152,
    "CMYK_M": 0,
    "CMYK_Y": 0.06680518388748,
    "CMYK_K": 0.1818853020668
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0567",
    "Farbtonhilfsbezeichnung": "78.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "203",
    "Bcolor": "189",
    "Y": 57,
    "L": 80.0547027587891,
    "a": -7.27600717544556,
    "b": 4.09343576431274,
    "C": 8.34844303131104,
    "h": 150.638168334961,
    "CMY_C": 0.26495838165283,
    "CMY_M": 0.20586091279984,
    "CMY_Y": 0.25809252262115,
    "CMYK_C": 0.07441702485085,
    "CMYK_M": 0,
    "CMYK_Y": 0.06577136367559,
    "CMYK_K": 0.20586091279984
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0568",
    "Farbtonhilfsbezeichnung": "78.03.15",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "184",
    "Bcolor": "171",
    "Y": 45,
    "L": 73.2499694824219,
    "a": -8.5880184173584,
    "b": 3.75152516365051,
    "C": 9.37165927886963,
    "h": 156.402740478516,
    "CMY_C": 0.34902942180634,
    "CMY_M": 0.27649700641632,
    "CMY_Y": 0.32789987325668,
    "CMYK_C": 0.100251711905,
    "CMYK_M": 0,
    "CMYK_Y": 0.07104720920324,
    "CMYK_K": 0.27649700641632
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0569",
    "Farbtonhilfsbezeichnung": "78.03.18",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "157",
    "Bcolor": "146",
    "Y": 31,
    "L": 63.0066871643066,
    "a": -8.76318454742432,
    "b": 2.69388318061829,
    "C": 9.16790103912354,
    "h": 162.912094116211,
    "CMY_C": 0.46012145280838,
    "CMY_M": 0.38403046131134,
    "CMY_Y": 0.42650216817856,
    "CMYK_C": 0.12353044748306,
    "CMYK_M": 0,
    "CMYK_Y": 0.0689509883523,
    "CMYK_K": 0.38403046131134
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0570",
    "Farbtonhilfsbezeichnung": "78.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "232",
    "Bcolor": "211",
    "Y": 76,
    "L": 89.7593536376953,
    "a": -11.6901302337647,
    "b": 6.57572031021118,
    "C": 13.412652015686,
    "h": 150.642150878906,
    "CMY_C": 0.18720310926437,
    "CMY_M": 0.08976459503174,
    "CMY_Y": 0.17204684019089,
    "CMYK_C": 0.10704759508371,
    "CMYK_M": 0,
    "CMYK_Y": 0.09039666503668,
    "CMYK_K": 0.08976459503174
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0571",
    "Farbtonhilfsbezeichnung": "78.06.09",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "218",
    "Bcolor": "193",
    "Y": 64,
    "L": 83.8676300048828,
    "a": -17.4532661437988,
    "b": 7.49666833877563,
    "C": 18.9951705932617,
    "h": 156.755126953125,
    "CMY_C": 0.29718762636185,
    "CMY_M": 0.1434765458107,
    "CMY_Y": 0.24339783191681,
    "CMYK_C": 0.17945927381516,
    "CMYK_M": 0,
    "CMYK_Y": 0.11665913462639,
    "CMYK_K": 0.1434765458107
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0572",
    "Farbtonhilfsbezeichnung": "78.06.12",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "203",
    "Bcolor": "175",
    "Y": 53,
    "L": 77.6631164550781,
    "a": -20.8773880004883,
    "b": 7.88319826126099,
    "C": 22.31614112854,
    "h": 159.313705444336,
    "CMY_C": 0.39227449893951,
    "CMY_M": 0.20507609844208,
    "CMY_Y": 0.31267946958542,
    "CMYK_C": 0.23549222946167,
    "CMYK_M": 0,
    "CMYK_Y": 0.13536311686039,
    "CMYK_K": 0.20507609844208
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0573",
    "Farbtonhilfsbezeichnung": "78.06.15",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "188",
    "Bcolor": "163",
    "Y": 45,
    "L": 72.7245559692383,
    "a": -18.2022647857666,
    "b": 7.56885480880737,
    "C": 19.7131938934326,
    "h": 157.421524047852,
    "CMY_C": 0.42128866910934,
    "CMY_M": 0.26374936103821,
    "CMY_Y": 0.36179041862488,
    "CMYK_C": 0.21397510170937,
    "CMYK_M": 0,
    "CMYK_Y": 0.13316261768341,
    "CMYK_K": 0.26374936103821
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0574",
    "Farbtonhilfsbezeichnung": "78.06.18",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "167",
    "Bcolor": "142",
    "Y": 33,
    "L": 64.9649047851563,
    "a": -19.6577701568604,
    "b": 7.57841110229492,
    "C": 21.0679912567139,
    "h": 158.91748046875,
    "CMY_C": 0.51393091678619,
    "CMY_M": 0.34378862380981,
    "CMY_Y": 0.44179499149323,
    "CMYK_C": 0.25927969813347,
    "CMYK_M": 0,
    "CMYK_Y": 0.14935182034969,
    "CMYK_K": 0.34378862380981
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0575",
    "Farbtonhilfsbezeichnung": "78.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "234",
    "Bcolor": "221",
    "Y": 79,
    "L": 91.668342590332,
    "a": -5.51159811019897,
    "b": 4.3746976852417,
    "C": 7.03673887252808,
    "h": 141.56005859375,
    "CMY_C": 0.12289994955063,
    "CMY_M": 0.08155792951584,
    "CMY_Y": 0.1339248418808,
    "CMYK_C": 0.04501320421696,
    "CMYK_M": 0,
    "CMYK_Y": 0.05701711028814,
    "CMYK_K": 0.08155792951584
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0576",
    "Farbtonhilfsbezeichnung": "78.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "229",
    "Bcolor": "213",
    "Y": 75,
    "L": 89.0811538696289,
    "a": -10.176983833313,
    "b": 4.38847970962524,
    "C": 11.0828590393066,
    "h": 156.673522949219,
    "CMY_C": 0.1898245215416,
    "CMY_M": 0.10006296634674,
    "CMY_Y": 0.16305476427078,
    "CMYK_C": 0.09974204003811,
    "CMYK_M": 0,
    "CMYK_Y": 0.06999578326941,
    "CMYK_K": 0.10006296634674
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0577",
    "Farbtonhilfsbezeichnung": "78.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "217",
    "Bcolor": "201",
    "Y": 65,
    "L": 84.393669128418,
    "a": -12.3387422561646,
    "b": 4.12317943572998,
    "C": 13.0094261169434,
    "h": 161.522155761719,
    "CMY_C": 0.26002597808838,
    "CMY_M": 0.14740258455276,
    "CMY_Y": 0.21235609054565,
    "CMYK_C": 0.13209445774555,
    "CMYK_M": 0,
    "CMYK_Y": 0.0761830881238,
    "CMYK_K": 0.14740258455276
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0578",
    "Farbtonhilfsbezeichnung": "78.09.12",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "205",
    "Bcolor": "186",
    "Y": 56,
    "L": 79.4913711547852,
    "a": -15.5826759338379,
    "b": 4.76842594146729,
    "C": 16.2959403991699,
    "h": 162.985458374023,
    "CMY_C": 0.33799165487289,
    "CMY_M": 0.19476723670959,
    "CMY_Y": 0.27009910345078,
    "CMYK_C": 0.17786709964275,
    "CMYK_M": 0,
    "CMYK_Y": 0.09355290979147,
    "CMYK_K": 0.19476723670959
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0579",
    "Farbtonhilfsbezeichnung": "78.09.15",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "185",
    "Bcolor": "166",
    "Y": 43,
    "L": 71.5102615356445,
    "a": -18.3753356933594,
    "b": 3.95504951477051,
    "C": 18.7961540222168,
    "h": 167.853149414063,
    "CMY_C": 0.44979387521744,
    "CMY_M": 0.27562439441681,
    "CMY_Y": 0.34881234169006,
    "CMYK_C": 0.2404408454895,
    "CMYK_M": 0,
    "CMYK_Y": 0.10103590786457,
    "CMYK_K": 0.27562439441681
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0580",
    "Farbtonhilfsbezeichnung": "78.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "165",
    "Bcolor": "148",
    "Y": 33,
    "L": 64.2424087524414,
    "a": -18.1856918334961,
    "b": 3.5467472076416,
    "C": 18.5283241271973,
    "h": 168.964157104492,
    "CMY_C": 0.52431166172028,
    "CMY_M": 0.35318052768707,
    "CMY_Y": 0.4209578037262,
    "CMYK_C": 0.26457324624062,
    "CMYK_M": 0,
    "CMYK_Y": 0.10478545725346,
    "CMYK_K": 0.35318052768707
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0581",
    "Farbtonhilfsbezeichnung": "78.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "207",
    "Bcolor": "182",
    "Y": 55,
    "L": 78.8307495117188,
    "a": -22.6567554473877,
    "b": 5.71792793273926,
    "C": 23.3671398162842,
    "h": 165.835922241211,
    "CMY_C": 0.40552479028702,
    "CMY_M": 0.18836283683777,
    "CMY_Y": 0.28491634130478,
    "CMYK_C": 0.26756039261818,
    "CMYK_M": 0,
    "CMYK_Y": 0.1189614161849,
    "CMYK_K": 0.18836283683777
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0582",
    "Farbtonhilfsbezeichnung": "78.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "190",
    "Bcolor": "162",
    "Y": 43,
    "L": 71.8192596435547,
    "a": -27.9319477081299,
    "b": 6.51747703552246,
    "C": 28.6822452545166,
    "h": 166.865936279297,
    "CMY_C": 0.52823519706726,
    "CMY_M": 0.25540280342102,
    "CMY_Y": 0.36497175693512,
    "CMYK_C": 0.36641609668732,
    "CMYK_M": 0,
    "CMYK_Y": 0.14715197682381,
    "CMYK_K": 0.25540280342102
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0583",
    "Farbtonhilfsbezeichnung": "78.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "177",
    "Bcolor": "143",
    "Y": 33,
    "L": 65.0880889892578,
    "a": -41.5392951965332,
    "b": 6.86413049697876,
    "C": 42.1026039123535,
    "h": 170.616989135742,
    "CMY_C": 0.79154884815216,
    "CMY_M": 0.30624693632126,
    "CMY_Y": 0.43819087743759,
    "CMYK_C": 0.69953119754791,
    "CMYK_M": 0,
    "CMYK_Y": 0.19018863141537,
    "CMYK_K": 0.30624693632126
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0584",
    "Farbtonhilfsbezeichnung": "78.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "189",
    "Bcolor": "167",
    "Y": 43,
    "L": 71.6161270141602,
    "a": -27.0996112823486,
    "b": 3.411949634552,
    "C": 27.3135566711426,
    "h": 172.823989868164,
    "CMY_C": 0.53717732429504,
    "CMY_M": 0.25834792852402,
    "CMY_Y": 0.34492665529251,
    "CMYK_C": 0.3759571313858,
    "CMYK_M": 0,
    "CMYK_Y": 0.1167376562953,
    "CMYK_K": 0.25834792852402
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0585",
    "Farbtonhilfsbezeichnung": "78.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "170",
    "Bcolor": "149",
    "Y": 33,
    "L": 64.6403045654297,
    "a": -27.9646415710449,
    "b": 3.18986296653748,
    "C": 28.1459846496582,
    "h": 173.492523193359,
    "CMY_C": 0.62119567394257,
    "CMY_M": 0.33168858289719,
    "CMY_Y": 0.41557145118713,
    "CMYK_C": 0.43319189548492,
    "CMYK_M": 0,
    "CMYK_Y": 0.12551464140415,
    "CMYK_K": 0.33168858289719
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0586",
    "Farbtonhilfsbezeichnung": "78.18.09",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "222",
    "Bcolor": "193",
    "Y": 63,
    "L": 83.1553573608398,
    "a": -28.4755821228027,
    "b": 6.40283679962158,
    "C": 29.1865558624268,
    "h": 167.327606201172,
    "CMY_C": 0.41413736343384,
    "CMY_M": 0.12974768877029,
    "CMY_Y": 0.24449390172958,
    "CMYK_C": 0.32678991556168,
    "CMYK_M": 0,
    "CMYK_Y": 0.13185395300388,
    "CMYK_K": 0.12974768877029
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0587",
    "Farbtonhilfsbezeichnung": "78.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "210",
    "Bcolor": "177",
    "Y": 53,
    "L": 77.8340835571289,
    "a": -36.5533981323242,
    "b": 6.93499374389648,
    "C": 37.2054443359375,
    "h": 169.257385253906,
    "CMY_C": 0.56078678369522,
    "CMY_M": 0.17470920085907,
    "CMY_Y": 0.30602139234543,
    "CMYK_C": 0.467807918787,
    "CMYK_M": 0,
    "CMYK_Y": 0.15911020338535,
    "CMYK_K": 0.17470920085907
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0588",
    "Farbtonhilfsbezeichnung": "78.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "197",
    "Bcolor": "161",
    "Y": 45,
    "L": 72.4359283447266,
    "a": -41.3686981201172,
    "b": 7.44811201095581,
    "C": 42.0338363647461,
    "h": 169.793685913086,
    "CMY_C": 0.68785411119461,
    "CMY_M": 0.2265630364418,
    "CMY_Y": 0.36682379245758,
    "CMYK_C": 0.59641712903976,
    "CMYK_M": 0,
    "CMYK_Y": 0.18134737014771,
    "CMYK_K": 0.2265630364418
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0589",
    "Farbtonhilfsbezeichnung": "81.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "237",
    "Bcolor": "228",
    "Y": 84,
    "L": 93.3849792480469,
    "a": -2.2699031829834,
    "b": 3.32147145271301,
    "C": 4.0230131149292,
    "h": 124.348815917969,
    "CMY_C": 0.08129215240479,
    "CMY_M": 0.06953114271164,
    "CMY_Y": 0.1066866517067,
    "CMYK_C": 0.01263987459242,
    "CMYK_M": 0,
    "CMYK_Y": 0.03993202745914,
    "CMYK_K": 0.06953114271164
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0590",
    "Farbtonhilfsbezeichnung": "81.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "230",
    "Bcolor": "221",
    "Y": 76,
    "L": 90.5070953369141,
    "a": -2.97300148010254,
    "b": 2.64137768745422,
    "C": 3.97688484191895,
    "h": 138.380355834961,
    "CMY_C": 0.12129789590836,
    "CMY_M": 0.0998962521553,
    "CMY_Y": 0.13349103927612,
    "CMYK_C": 0.02377686277032,
    "CMYK_M": 0,
    "CMYK_Y": 0.03732324019074,
    "CMYK_K": 0.0998962521553
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0591",
    "Farbtonhilfsbezeichnung": "81.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "205",
    "Bcolor": "198",
    "Y": 59,
    "L": 81.7515487670898,
    "a": -3.55355358123779,
    "b": 2.02308678627014,
    "C": 4.08908605575562,
    "h": 150.346542358398,
    "CMY_C": 0.2240839600563,
    "CMY_M": 0.19503736495972,
    "CMY_Y": 0.22439557313919,
    "CMYK_C": 0.03608440235257,
    "CMYK_M": 0,
    "CMYK_Y": 0.03647151589394,
    "CMYK_K": 0.19503736495972
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0592",
    "Farbtonhilfsbezeichnung": "81.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "189",
    "Bcolor": "181",
    "Y": 49,
    "L": 75.7188186645508,
    "a": -3.60767793655396,
    "b": 2.25237250328064,
    "C": 4.25306034088135,
    "h": 148.022323608398,
    "CMY_C": 0.2886198759079,
    "CMY_M": 0.2603468298912,
    "CMY_Y": 0.29053139686584,
    "CMYK_C": 0.03822473436594,
    "CMYK_M": 0,
    "CMYK_Y": 0.04080908372998,
    "CMYK_K": 0.2603468298912
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0593",
    "Farbtonhilfsbezeichnung": "81.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "153",
    "Bcolor": "145",
    "Y": 30,
    "L": 62.3336563110352,
    "a": -3.65728759765625,
    "b": 2.43145799636841,
    "C": 4.39178085327148,
    "h": 146.383026123047,
    "CMY_C": 0.42845338582993,
    "CMY_M": 0.40146815776825,
    "CMY_Y": 0.4308996796608,
    "CMYK_C": 0.04508570209146,
    "CMYK_M": 0,
    "CMYK_Y": 0.04917285963893,
    "CMYK_K": 0.40146815776825
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0594",
    "Farbtonhilfsbezeichnung": "81.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "241",
    "Bcolor": "225",
    "Y": 85,
    "L": 94.1116180419922,
    "a": -4.99920511245728,
    "b": 5.64452075958252,
    "C": 7.54007053375244,
    "h": 131.530487060547,
    "CMY_C": 0.08721178770065,
    "CMY_M": 0.05564993619919,
    "CMY_Y": 0.11637800931931,
    "CMYK_C": 0.0334217697382,
    "CMYK_M": 0,
    "CMYK_Y": 0.06430673599243,
    "CMYK_K": 0.05564993619919
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0595",
    "Farbtonhilfsbezeichnung": "81.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "226",
    "Bcolor": "210",
    "Y": 74,
    "L": 88.8735580444336,
    "a": -5.25617694854736,
    "b": 5.82701301574707,
    "C": 7.84738683700562,
    "h": 132.051605224609,
    "CMY_C": 0.14685553312302,
    "CMY_M": 0.11371099948883,
    "CMY_Y": 0.17525547742844,
    "CMYK_C": 0.0373969823122,
    "CMYK_M": 0,
    "CMYK_Y": 0.06944064050913,
    "CMYK_K": 0.11371099948883
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0596",
    "Farbtonhilfsbezeichnung": "81.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "215",
    "Bcolor": "199",
    "Y": 66,
    "L": 85.0964050292969,
    "a": -4.79325580596924,
    "b": 6.40461111068726,
    "C": 7.99964666366577,
    "h": 126.81143951416,
    "CMY_C": 0.18282043933868,
    "CMY_M": 0.15671646595001,
    "CMY_Y": 0.22040432691574,
    "CMYK_C": 0.03095515631139,
    "CMYK_M": 0,
    "CMYK_Y": 0.07552365958691,
    "CMYK_K": 0.15671646595001
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0597",
    "Farbtonhilfsbezeichnung": "81.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "200",
    "Bcolor": "183",
    "Y": 55,
    "L": 79.1722717285156,
    "a": -6.69531059265137,
    "b": 6.22368335723877,
    "C": 9.14119338989258,
    "h": 137.090728759766,
    "CMY_C": 0.26264983415604,
    "CMY_M": 0.21727210283279,
    "CMY_Y": 0.28279179334641,
    "CMYK_C": 0.05797382816672,
    "CMYK_M": 0,
    "CMYK_Y": 0.08370685577393,
    "CMYK_K": 0.21727210283279
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0598",
    "Farbtonhilfsbezeichnung": "81.06.15",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "179",
    "Bcolor": "161",
    "Y": 42,
    "L": 71.204460144043,
    "a": -8.28735637664795,
    "b": 6.27273797988892,
    "C": 10.3936290740967,
    "h": 142.877746582031,
    "CMY_C": 0.35957771539688,
    "CMY_M": 0.29959774017334,
    "CMY_Y": 0.36705887317657,
    "CMYK_C": 0.08563646674156,
    "CMYK_M": 0,
    "CMYK_Y": 0.0963177010417,
    "CMYK_K": 0.29959774017334
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0599",
    "Farbtonhilfsbezeichnung": "81.06.18",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "156",
    "Bcolor": "139",
    "Y": 31,
    "L": 62.9366760253906,
    "a": -7.36659336090088,
    "b": 6.63504266738892,
    "C": 9.91415596008301,
    "h": 137.990844726563,
    "CMY_C": 0.4369358420372,
    "CMY_M": 0.38853538036346,
    "CMY_Y": 0.45417362451553,
    "CMYK_C": 0.07915496826172,
    "CMYK_M": 0,
    "CMYK_Y": 0.10734593868256,
    "CMYK_K": 0.38853538036346
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0600",
    "Farbtonhilfsbezeichnung": "81.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "219",
    "Bcolor": "184",
    "Y": 66,
    "L": 85.3905258178711,
    "a": -11.0751028060913,
    "b": 14.8363914489746,
    "C": 18.5142211914063,
    "h": 126.740692138672,
    "CMY_C": 0.20266962051392,
    "CMY_M": 0.14169359207153,
    "CMY_Y": 0.28008991479874,
    "CMYK_C": 0.07104226201773,
    "CMYK_M": 0,
    "CMYK_Y": 0.16124349832535,
    "CMYK_K": 0.14169359207153
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0601",
    "Farbtonhilfsbezeichnung": "81.09.12",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "204",
    "Bcolor": "170",
    "Y": 57,
    "L": 79.8529434204102,
    "a": -12.8176593780518,
    "b": 14.0547733306885,
    "C": 19.0218048095703,
    "h": 132.364166259766,
    "CMY_C": 0.27891284227371,
    "CMY_M": 0.19868844747543,
    "CMY_Y": 0.33319407701492,
    "CMYK_C": 0.1001163572073,
    "CMYK_M": 0,
    "CMYK_Y": 0.16785684227943,
    "CMYK_K": 0.19868844747543
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0602",
    "Farbtonhilfsbezeichnung": "81.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "185",
    "Bcolor": "152",
    "Y": 45,
    "L": 72.7868041992188,
    "a": -14.0016946792603,
    "b": 13.898962020874,
    "C": 19.7288780212402,
    "h": 135.210968017578,
    "CMY_C": 0.36387538909912,
    "CMY_M": 0.27274316549301,
    "CMY_Y": 0.40568554401398,
    "CMYK_C": 0.12530954182148,
    "CMYK_M": 0,
    "CMYK_Y": 0.18279977142811,
    "CMYK_K": 0.27274316549301
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0603",
    "Farbtonhilfsbezeichnung": "81.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "164",
    "Bcolor": "130",
    "Y": 33,
    "L": 64.5859832763672,
    "a": -14.9172859191895,
    "b": 13.8588848114014,
    "C": 20.3615837097168,
    "h": 137.106414794922,
    "CMY_C": 0.45628595352173,
    "CMY_M": 0.35797888040543,
    "CMY_Y": 0.48877453804016,
    "CMYK_C": 0.15312124788761,
    "CMYK_M": 0,
    "CMYK_Y": 0.20372484624386,
    "CMYK_K": 0.35797888040543
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0604",
    "Farbtonhilfsbezeichnung": "81.12.09",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "215",
    "Bcolor": "165",
    "Y": 62,
    "L": 83.1629180908203,
    "a": -15.3171081542969,
    "b": 21.5065364837646,
    "C": 26.4035015106201,
    "h": 125.45874786377,
    "CMY_C": 0.24094766378403,
    "CMY_M": 0.15879011154175,
    "CMY_Y": 0.35352516174316,
    "CMYK_C": 0.09766593575478,
    "CMYK_M": 0,
    "CMYK_Y": 0.23149400949478,
    "CMYK_K": 0.15879011154175
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0605",
    "Farbtonhilfsbezeichnung": "81.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "204",
    "Bcolor": "150",
    "Y": 54,
    "L": 78.6485137939453,
    "a": -19.8295822143555,
    "b": 22.837926864624,
    "C": 30.2453842163086,
    "h": 130.966934204102,
    "CMY_C": 0.32196450233459,
    "CMY_M": 0.19953197240829,
    "CMY_Y": 0.41101652383804,
    "CMYK_C": 0.15295118093491,
    "CMYK_M": 0,
    "CMYK_Y": 0.26420113444328,
    "CMYK_K": 0.19953197240829
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0606",
    "Farbtonhilfsbezeichnung": "81.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "189",
    "Bcolor": "131",
    "Y": 44,
    "L": 72.4338150024414,
    "a": -23.6967945098877,
    "b": 24.3891468048096,
    "C": 34.0054206848145,
    "h": 134.175109863281,
    "CMY_C": 0.41503649950027,
    "CMY_M": 0.25999242067337,
    "CMY_Y": 0.48643094301224,
    "CMYK_C": 0.20951688289642,
    "CMYK_M": 0,
    "CMYK_Y": 0.3059948682785,
    "CMYK_K": 0.25999242067337
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0607",
    "Farbtonhilfsbezeichnung": "81.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "157",
    "Bcolor": "110",
    "Y": 29,
    "L": 61.2621154785156,
    "a": -19.9517974853516,
    "b": 20.6756649017334,
    "C": 28.7325134277344,
    "h": 133.979263305664,
    "CMY_C": 0.51018536090851,
    "CMY_M": 0.38471525907516,
    "CMY_Y": 0.57017451524734,
    "CMYK_C": 0.20392201840878,
    "CMYK_M": 0,
    "CMYK_Y": 0.30142021179199,
    "CMYK_K": 0.38471525907516
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0608",
    "Farbtonhilfsbezeichnung": "81.15.09",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "225",
    "Bcolor": "187",
    "Y": 65,
    "L": 84.3496017456055,
    "a": -28.5875606536865,
    "b": 11.2865943908691,
    "C": 30.7349281311035,
    "h": 158.455505371094,
    "CMY_C": 0.38023257255554,
    "CMY_M": 0.11734700202942,
    "CMY_Y": 0.26759332418442,
    "CMYK_C": 0.29783570766449,
    "CMYK_M": 0,
    "CMYK_Y": 0.17022128403187,
    "CMYK_K": 0.11734700202942
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0609",
    "Farbtonhilfsbezeichnung": "81.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "211",
    "Bcolor": "162",
    "Y": 53,
    "L": 78.386589050293,
    "a": -36.3571968078613,
    "b": 15.762020111084,
    "C": 39.6268463134766,
    "h": 156.561706542969,
    "CMY_C": 0.50497406721115,
    "CMY_M": 0.17081302404404,
    "CMY_Y": 0.36439627408981,
    "CMYK_C": 0.40299841761589,
    "CMYK_M": 0,
    "CMYK_Y": 0.23346151411533,
    "CMYK_K": 0.17081302404404
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0610",
    "Farbtonhilfsbezeichnung": "81.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "196",
    "Bcolor": "140",
    "Y": 43,
    "L": 71.6512985229492,
    "a": -44.0207061767578,
    "b": 18.2254848480225,
    "C": 47.6444206237793,
    "h": 157.509429931641,
    "CMY_C": 0.66123867034912,
    "CMY_M": 0.23322993516922,
    "CMY_Y": 0.45268583297729,
    "CMYK_C": 0.55819696187973,
    "CMYK_M": 0,
    "CMYK_Y": 0.28620821237564,
    "CMYK_K": 0.23322993516922
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0611",
    "Farbtonhilfsbezeichnung": "81.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "183",
    "Bcolor": "126",
    "Y": 35,
    "L": 66.4643630981445,
    "a": -48.3870887756348,
    "b": 18.4681854248047,
    "C": 51.7917404174805,
    "h": 159.109359741211,
    "CMY_C": 0.80119109153748,
    "CMY_M": 0.28360271453857,
    "CMY_Y": 0.5072717666626,
    "CMYK_C": 0.72248792648315,
    "CMYK_M": 0,
    "CMYK_Y": 0.31221371889114,
    "CMYK_K": 0.28360271453857
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0612",
    "Farbtonhilfsbezeichnung": "81.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "216",
    "Bcolor": "165",
    "Y": 59,
    "L": 81.5811462402344,
    "a": -27.7885227203369,
    "b": 18.9787216186523,
    "C": 33.6510620117188,
    "h": 145.668106079102,
    "CMY_C": 0.37183606624603,
    "CMY_M": 0.15130114555359,
    "CMY_Y": 0.35340911149979,
    "CMYK_C": 0.25985062122345,
    "CMYK_M": 0,
    "CMYK_Y": 0.23813861608505,
    "CMYK_K": 0.15130114555359
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0613",
    "Farbtonhilfsbezeichnung": "84.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "237",
    "Bcolor": "219",
    "Y": 82,
    "L": 93.1829071044922,
    "a": -2.68822431564331,
    "b": 7.38122892379761,
    "C": 7.85551357269287,
    "h": 110.011497497559,
    "CMY_C": 0.0735170841217,
    "CMY_M": 0.07191777229309,
    "CMY_Y": 0.13923478126526,
    "CMYK_C": 0.00172324362211,
    "CMYK_M": 0,
    "CMYK_Y": 0.07253345102072,
    "CMYK_K": 0.07191777229309
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0614",
    "Farbtonhilfsbezeichnung": "81.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "201",
    "Bcolor": "125",
    "Y": 47,
    "L": 74.3434677124023,
    "a": -40.3692054748535,
    "b": 29.8882102966309,
    "C": 50.2292518615723,
    "h": 143.484802246094,
    "CMY_C": 0.53194946050644,
    "CMY_M": 0.21136981248856,
    "CMY_Y": 0.51059508323669,
    "CMYK_C": 0.4065018594265,
    "CMYK_M": 0,
    "CMYK_Y": 0.37942406535149,
    "CMYK_K": 0.21136981248856
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0615",
    "Farbtonhilfsbezeichnung": "81.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "173",
    "Bcolor": "104",
    "Y": 33,
    "L": 64.2071990966797,
    "a": -38.9802856445313,
    "b": 27.461727142334,
    "C": 47.6823768615723,
    "h": 144.835189819336,
    "CMY_C": 0.63411164283752,
    "CMY_M": 0.32326829433441,
    "CMY_Y": 0.59311366081238,
    "CMYK_C": 0.45933026075363,
    "CMYK_M": 0,
    "CMYK_Y": 0.39874792098999,
    "CMYK_K": 0.32326829433441
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0616",
    "Farbtonhilfsbezeichnung": "84.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "227",
    "Bcolor": "205",
    "Y": 76,
    "L": 89.9331588745117,
    "a": -3.04691743850708,
    "b": 10.0103273391724,
    "C": 10.4637641906738,
    "h": 106.929061889648,
    "CMY_C": 0.10445487499237,
    "CMY_M": 0.10807502269745,
    "CMY_Y": 0.19433879852295,
    "CMYK_C": 0,
    "CMYK_M": 0.00404239585623,
    "CMYK_Y": 0.10036783665419,
    "CMYK_K": 0.10445487499237
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0617",
    "Farbtonhilfsbezeichnung": "84.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "227",
    "Bcolor": "206",
    "Y": 74,
    "L": 89.7337875366211,
    "a": -3.80744290351868,
    "b": 9.22257328033447,
    "C": 9.97759914398193,
    "h": 112.432769775391,
    "CMY_C": 0.11498916149139,
    "CMY_M": 0.10833513736725,
    "CMY_Y": 0.19078487157822,
    "CMYK_C": 0.00746247218922,
    "CMYK_M": 0,
    "CMYK_Y": 0.09246718138456,
    "CMYK_K": 0.10833513736725
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0618",
    "Farbtonhilfsbezeichnung": "84.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "215",
    "Bcolor": "196",
    "Y": 65,
    "L": 85.4158554077148,
    "a": -4.28123044967651,
    "b": 8.58932876586914,
    "C": 9.59716129302979,
    "h": 116.493316650391,
    "CMY_C": 0.16838002204895,
    "CMY_M": 0.15491461753845,
    "CMY_Y": 0.23288583755493,
    "CMYK_C": 0.01593377999961,
    "CMYK_M": 0,
    "CMYK_Y": 0.09226430952549,
    "CMYK_K": 0.15491461753845
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0619",
    "Farbtonhilfsbezeichnung": "84.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "204",
    "Bcolor": "182",
    "Y": 58,
    "L": 81.4134216308594,
    "a": -4.72551107406616,
    "b": 10.2552328109741,
    "C": 11.2916011810303,
    "h": 114.739784240723,
    "CMY_C": 0.21050322055817,
    "CMY_M": 0.19821882247925,
    "CMY_Y": 0.28788536787033,
    "CMYK_C": 0.01532138511539,
    "CMYK_M": 0,
    "CMYK_Y": 0.1118341833353,
    "CMYK_K": 0.19821882247925
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0620",
    "Farbtonhilfsbezeichnung": "84.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "183",
    "Bcolor": "158",
    "Y": 46,
    "L": 73.5385437011719,
    "a": -4.98029565811157,
    "b": 11.4469718933106,
    "C": 12.4834489822388,
    "h": 113.512672424316,
    "CMY_C": 0.29386496543884,
    "CMY_M": 0.28298878669739,
    "CMY_Y": 0.37908071279526,
    "CMYK_C": 0.01516877114773,
    "CMYK_M": 0,
    "CMYK_Y": 0.13401733338833,
    "CMYK_K": 0.28298878669739
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0621",
    "Farbtonhilfsbezeichnung": "84.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "227",
    "Bcolor": "195",
    "Y": 75,
    "L": 89.4292755126953,
    "a": -6.11536312103271,
    "b": 14.9925518035889,
    "C": 16.1917972564697,
    "h": 112.190223693848,
    "CMY_C": 0.11892211437225,
    "CMY_M": 0.10787528753281,
    "CMY_Y": 0.23722553253174,
    "CMYK_C": 0.01238260418177,
    "CMYK_M": 0,
    "CMYK_Y": 0.14499121904373,
    "CMYK_K": 0.10787528753281
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0622",
    "Farbtonhilfsbezeichnung": "84.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "213",
    "Bcolor": "174",
    "Y": 64,
    "L": 83.8959045410156,
    "a": -8.75211334228516,
    "b": 17.687894821167,
    "C": 19.734769821167,
    "h": 116.32657623291,
    "CMY_C": 0.19262808561325,
    "CMY_M": 0.16385769844055,
    "CMY_Y": 0.31656563282013,
    "CMYK_C": 0.03440848365426,
    "CMYK_M": 0,
    "CMYK_Y": 0.18263390660286,
    "CMYK_K": 0.16385769844055
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0623",
    "Farbtonhilfsbezeichnung": "84.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "205",
    "Bcolor": "162",
    "Y": 58,
    "L": 80.7978973388672,
    "a": -8.87998962402344,
    "b": 19.9453887939453,
    "C": 21.8328361511231,
    "h": 113.999351501465,
    "CMY_C": 0.22134065628052,
    "CMY_M": 0.19801050424576,
    "CMY_Y": 0.36566561460495,
    "CMYK_C": 0.0290903467685,
    "CMYK_M": 0,
    "CMYK_Y": 0.20904901623726,
    "CMYK_K": 0.19801050424576
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0624",
    "Farbtonhilfsbezeichnung": "84.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "183",
    "Bcolor": "143",
    "Y": 44,
    "L": 72.6389846801758,
    "a": -9.7777681350708,
    "b": 18.4008522033691,
    "C": 20.8373737335205,
    "h": 117.98509979248,
    "CMY_C": 0.32005679607391,
    "CMY_M": 0.28390347957611,
    "CMY_Y": 0.43876194953918,
    "CMYK_C": 0.0504866540432,
    "CMYK_M": 0,
    "CMYK_Y": 0.21625362336636,
    "CMYK_K": 0.28390347957611
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0625",
    "Farbtonhilfsbezeichnung": "84.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "186",
    "Bcolor": "123",
    "Y": 45,
    "L": 72.9534301757813,
    "a": -16.2508926391602,
    "b": 29.7474842071533,
    "C": 33.8969650268555,
    "h": 118.64754486084,
    "CMY_C": 0.33695781230927,
    "CMY_M": 0.26953047513962,
    "CMY_Y": 0.51912975311279,
    "CMYK_C": 0.09230684489012,
    "CMYK_M": 0,
    "CMYK_Y": 0.34169703722,
    "CMYK_K": 0.26953047513962
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0626",
    "Farbtonhilfsbezeichnung": "84.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "208",
    "Bcolor": "132",
    "Y": 56,
    "L": 80.1508255004883,
    "a": -20.0533123016357,
    "b": 34.5763549804688,
    "C": 39.9707336425781,
    "h": 120.112525939941,
    "CMY_C": 0.27704864740372,
    "CMY_M": 0.18475115299225,
    "CMY_Y": 0.48318672180176,
    "CMYK_C": 0.11321388930082,
    "CMYK_M": 0,
    "CMYK_Y": 0.36606684327126,
    "CMYK_K": 0.18475115299225
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0627",
    "Farbtonhilfsbezeichnung": "84.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "190",
    "Bcolor": "104",
    "Y": 44,
    "L": 72.8531951904297,
    "a": -24.6302165985107,
    "b": 39.2753219604492,
    "C": 46.359447479248,
    "h": 122.092514038086,
    "CMY_C": 0.38077259063721,
    "CMY_M": 0.2561222910881,
    "CMY_Y": 0.59364384412766,
    "CMYK_C": 0.16756826639175,
    "CMYK_M": 0,
    "CMYK_Y": 0.45373257994652,
    "CMYK_K": 0.2561222910881
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0628",
    "Farbtonhilfsbezeichnung": "84.18.09",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "233",
    "Bcolor": "175",
    "Y": 74,
    "L": 88.9957122802734,
    "a": -19.8881397247314,
    "b": 24.0778388977051,
    "C": 31.2294807434082,
    "h": 129.556488037109,
    "CMY_C": 0.20669490098953,
    "CMY_M": 0.08509314060211,
    "CMY_Y": 0.31201386451721,
    "CMYK_C": 0.13291162252426,
    "CMYK_M": 0,
    "CMYK_Y": 0.24802604317665,
    "CMYK_K": 0.08509314060211
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0629",
    "Farbtonhilfsbezeichnung": "84.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "222",
    "Bcolor": "144",
    "Y": 63,
    "L": 83.4264755249023,
    "a": -28.9491539001465,
    "b": 32.6603202819824,
    "C": 43.643440246582,
    "h": 131.552841186523,
    "CMY_C": 0.31866490840912,
    "CMY_M": 0.13119465112686,
    "CMY_Y": 0.43674808740616,
    "CMYK_C": 0.21577934920788,
    "CMYK_M": 0,
    "CMYK_Y": 0.35169377923012,
    "CMYK_K": 0.13119465112686
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0630",
    "Farbtonhilfsbezeichnung": "84.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "214",
    "Bcolor": "123",
    "Y": 56,
    "L": 79.7126770019531,
    "a": -35.124267578125,
    "b": 37.8651847839355,
    "C": 51.6477127075195,
    "h": 132.849426269531,
    "CMY_C": 0.39828586578369,
    "CMY_M": 0.16212493181229,
    "CMY_Y": 0.51591241359711,
    "CMYK_C": 0.28185698390007,
    "CMYK_M": 0,
    "CMYK_Y": 0.42224371433258,
    "CMYK_K": 0.16212493181229
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0631",
    "Farbtonhilfsbezeichnung": "84.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "202",
    "Bcolor": "98",
    "Y": 47,
    "L": 74.7427139282227,
    "a": -40.9040260314941,
    "b": 43.886833190918,
    "C": 59.993278503418,
    "h": 132.985260009766,
    "CMY_C": 0.48867899179459,
    "CMY_M": 0.20810782909393,
    "CMY_Y": 0.61482352018356,
    "CMYK_C": 0.3543047606945,
    "CMYK_M": 0,
    "CMYK_Y": 0.51359981298447,
    "CMYK_K": 0.20810782909393
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0632",
    "Farbtonhilfsbezeichnung": "84.21.03",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "236",
    "Bcolor": "199",
    "Y": 80,
    "L": 92.0789031982422,
    "a": -8.44993495941162,
    "b": 16.3303127288818,
    "C": 18.3869667053223,
    "h": 117.358795166016,
    "CMY_C": 0.10360312461853,
    "CMY_M": 0.07332515716553,
    "CMY_Y": 0.21899491548538,
    "CMYK_C": 0.03267377614975,
    "CMYK_M": 0,
    "CMYK_Y": 0.15719619393349,
    "CMYK_K": 0.07332515716553
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0633",
    "Farbtonhilfsbezeichnung": "84.21.06",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "232",
    "Bcolor": "185",
    "Y": 77,
    "L": 90.1646957397461,
    "a": -10.3424015045166,
    "b": 21.1689300537109,
    "C": 23.56032371521,
    "h": 116.038520812988,
    "CMY_C": 0.12589943408966,
    "CMY_M": 0.09164106845856,
    "CMY_Y": 0.27610856294632,
    "CMYK_C": 0.03771457076073,
    "CMYK_M": 0,
    "CMYK_Y": 0.20307776331902,
    "CMYK_K": 0.09164106845856
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0634",
    "Farbtonhilfsbezeichnung": "84.21.09",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "234",
    "Bcolor": "153",
    "Y": 76,
    "L": 89.8283920288086,
    "a": -16.9979839324951,
    "b": 36.717700958252,
    "C": 40.461353302002,
    "h": 114.841163635254,
    "CMY_C": 0.14164167642593,
    "CMY_M": 0.08414214849472,
    "CMY_Y": 0.39893114566803,
    "CMYK_C": 0.06278215348721,
    "CMYK_M": 0,
    "CMYK_Y": 0.34370943903923,
    "CMYK_K": 0.08414214849472
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0635",
    "Farbtonhilfsbezeichnung": "84.21.12",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "226",
    "Bcolor": "126",
    "Y": 67,
    "L": 85.9189834594727,
    "a": -24.313850402832,
    "b": 45.079418182373,
    "C": 51.2183303833008,
    "h": 118.340469360352,
    "CMY_C": 0.22337979078293,
    "CMY_M": 0.11427956819534,
    "CMY_Y": 0.50662934780121,
    "CMYK_C": 0.12317681312561,
    "CMYK_M": 0,
    "CMYK_Y": 0.44297248125076,
    "CMYK_K": 0.11427956819534
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0636",
    "Farbtonhilfsbezeichnung": "84.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "208",
    "Bcolor": "102",
    "Y": 56,
    "L": 79.2509231567383,
    "a": -27.2008934020996,
    "b": 48.1067008972168,
    "C": 55.2643051147461,
    "h": 119.485046386719,
    "CMY_C": 0.31344199180603,
    "CMY_M": 0.18291485309601,
    "CMY_Y": 0.60004311800003,
    "CMYK_C": 0.15974728763103,
    "CMYK_M": 0,
    "CMYK_Y": 0.51050770282745,
    "CMYK_K": 0.18291485309601
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0637",
    "Farbtonhilfsbezeichnung": "84.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "192",
    "Bcolor": "89",
    "Y": 45,
    "L": 72.978759765625,
    "a": -28.3660297393799,
    "b": 46.768367767334,
    "C": 54.698371887207,
    "h": 121.237716674805,
    "CMY_C": 0.39340543746948,
    "CMY_M": 0.24898785352707,
    "CMY_Y": 0.65282440185547,
    "CMYK_C": 0.19229726493359,
    "CMYK_M": 0,
    "CMYK_Y": 0.53772306442261,
    "CMYK_K": 0.24898785352707
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0638",
    "Farbtonhilfsbezeichnung": "87.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "214",
    "Y": 74,
    "L": 89.801383972168,
    "a": -1.55068635940552,
    "b": 5.24081134796143,
    "C": 5.46541213989258,
    "h": 106.482788085938,
    "CMY_C": 0.10925674438477,
    "CMY_M": 0.11177891492844,
    "CMY_Y": 0.16025775671005,
    "CMYK_C": 0,
    "CMYK_M": 0.00283153471537,
    "CMYK_Y": 0.05725669115782,
    "CMYK_K": 0.10925674438477
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0639",
    "Farbtonhilfsbezeichnung": "87.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "204",
    "Bcolor": "193",
    "Y": 59,
    "L": 81.9310607910156,
    "a": -1.45082426071167,
    "b": 4.81850433349609,
    "C": 5.03218412399292,
    "h": 106.75675201416,
    "CMY_C": 0.19658446311951,
    "CMY_M": 0.19860833883286,
    "CMY_Y": 0.24243324995041,
    "CMYK_C": 0,
    "CMYK_M": 0.00251908949576,
    "CMYK_Y": 0.05706733837724,
    "CMYK_K": 0.19658446311951
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0640",
    "Farbtonhilfsbezeichnung": "87.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "192",
    "Bcolor": "180",
    "Y": 51,
    "L": 77.4716262817383,
    "a": -1.82266139984131,
    "b": 5.22735261917114,
    "C": 5.53600120544434,
    "h": 109.222526550293,
    "CMY_C": 0.24651712179184,
    "CMY_M": 0.24624520540237,
    "CMY_Y": 0.29298335313797,
    "CMYK_C": 0.00036074913805,
    "CMYK_M": 0,
    "CMYK_Y": 0.06200709939003,
    "CMYK_K": 0.24624520540237
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0641",
    "Farbtonhilfsbezeichnung": "87.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "181",
    "Bcolor": "169",
    "Y": 44,
    "L": 73.2423629760742,
    "a": -1.89445173740387,
    "b": 5.15834188461304,
    "C": 5.49521970748901,
    "h": 110.16625213623,
    "CMY_C": 0.29262095689774,
    "CMY_M": 0.29142320156097,
    "CMY_Y": 0.33704352378845,
    "CMYK_C": 0.00169036770239,
    "CMYK_M": 0,
    "CMYK_Y": 0.06438302993774,
    "CMYK_K": 0.29142320156097
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0642",
    "Farbtonhilfsbezeichnung": "87.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "152",
    "Bcolor": "141",
    "Y": 31,
    "L": 62.6219635009766,
    "a": -1.88530492782593,
    "b": 5.23763227462769,
    "C": 5.56661176681519,
    "h": 109.796524047852,
    "CMY_C": 0.40380501747131,
    "CMY_M": 0.40297138690948,
    "CMY_Y": 0.4469957947731,
    "CMYK_C": 0.00139629922342,
    "CMYK_M": 0,
    "CMYK_Y": 0.07373919337988,
    "CMYK_K": 0.40297138690948
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0643",
    "Farbtonhilfsbezeichnung": "87.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "216",
    "Y": 84,
    "L": 93.7292709350586,
    "a": -2.49236917495728,
    "b": 9.77012634277344,
    "C": 10.0830192565918,
    "h": 104.310981750488,
    "CMY_C": 0.05836498737335,
    "CMY_M": 0.06687289476395,
    "CMY_Y": 0.15103757381439,
    "CMYK_C": 0,
    "CMYK_M": 0.0090352492407,
    "CMYK_Y": 0.09841667115688,
    "CMYK_K": 0.05836498737335
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0644",
    "Farbtonhilfsbezeichnung": "87.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "228",
    "Bcolor": "201",
    "Y": 76,
    "L": 90.1727142333984,
    "a": -3.74087810516357,
    "b": 12.4487924575806,
    "C": 12.9987154006958,
    "h": 106.725593566895,
    "CMY_C": 0.09981697797775,
    "CMY_M": 0.1044128537178,
    "CMY_Y": 0.20993447303772,
    "CMYK_C": 0,
    "CMYK_M": 0.00510549033061,
    "CMYK_Y": 0.1223278939724,
    "CMYK_K": 0.09981697797775
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0645",
    "Farbtonhilfsbezeichnung": "87.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "213",
    "Bcolor": "187",
    "Y": 65,
    "L": 84.9375,
    "a": -3.51098275184631,
    "b": 12.3687829971313,
    "C": 12.8574409484863,
    "h": 105.847038269043,
    "CMY_C": 0.15643101930618,
    "CMY_M": 0.16287070512772,
    "CMY_Y": 0.26560258865356,
    "CMYK_C": 0,
    "CMYK_M": 0.00763385789469,
    "CMYK_Y": 0.12941628694534,
    "CMYK_K": 0.15643101930618
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0646",
    "Farbtonhilfsbezeichnung": "87.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "200",
    "Bcolor": "173",
    "Y": 56,
    "L": 80.0078735351563,
    "a": -3.74746632575989,
    "b": 13.0097179412842,
    "C": 13.5386953353882,
    "h": 106.069114685059,
    "CMY_C": 0.21047055721283,
    "CMY_M": 0.21637427806854,
    "CMY_Y": 0.32258015871048,
    "CMYK_C": 0,
    "CMYK_M": 0.00747751817107,
    "CMYK_Y": 0.141995459795,
    "CMYK_K": 0.21047055721283
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0647",
    "Farbtonhilfsbezeichnung": "87.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "180",
    "Bcolor": "151",
    "Y": 44,
    "L": 72.6705017089844,
    "a": -4.61815404891968,
    "b": 14.0643796920776,
    "C": 14.8031797409058,
    "h": 108.178016662598,
    "CMY_C": 0.29324227571487,
    "CMY_M": 0.29363679885864,
    "CMY_Y": 0.4066236615181,
    "CMYK_C": 0,
    "CMYK_M": 0.0005582155427,
    "CMYK_Y": 0.16042467951775,
    "CMYK_K": 0.29324227571487
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0648",
    "Farbtonhilfsbezeichnung": "87.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "155",
    "Bcolor": "134",
    "Y": 32,
    "L": 63.4269638061523,
    "a": -3.31254720687866,
    "b": 10.4689922332764,
    "C": 10.9805631637573,
    "h": 107.558158874512,
    "CMY_C": 0.39096558094025,
    "CMY_M": 0.39280432462692,
    "CMY_Y": 0.4751210808754,
    "CMYK_C": 0,
    "CMYK_M": 0.00301911286078,
    "CMYK_Y": 0.13817855715752,
    "CMYK_K": 0.39096558094025
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0649",
    "Farbtonhilfsbezeichnung": "87.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "199",
    "Y": 83,
    "L": 93.35986328125,
    "a": -5.27622365951538,
    "b": 18.0884571075439,
    "C": 18.8422622680664,
    "h": 106.261436462402,
    "CMY_C": 0.0596370100975,
    "CMY_M": 0.06658458709717,
    "CMY_Y": 0.21779960393906,
    "CMYK_C": 0,
    "CMYK_M": 0.00738818617538,
    "CMYK_Y": 0.16819313168526,
    "CMYK_K": 0.0596370100975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0650",
    "Farbtonhilfsbezeichnung": "87.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "230",
    "Bcolor": "174",
    "Y": 76,
    "L": 90.0917892456055,
    "a": -8.27125072479248,
    "b": 26.7732524871826,
    "C": 28.0217895507813,
    "h": 107.167861938477,
    "CMY_C": 0.09635490179062,
    "CMY_M": 0.09824186563492,
    "CMY_Y": 0.3186326622963,
    "CMYK_C": 0,
    "CMYK_M": 0.00208816910163,
    "CMYK_Y": 0.24597904086113,
    "CMYK_K": 0.09635490179062
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0651",
    "Farbtonhilfsbezeichnung": "87.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "214",
    "Bcolor": "155",
    "Y": 64,
    "L": 84.4550094604492,
    "a": -8.89458084106445,
    "b": 28.6369514465332,
    "C": 29.9864730834961,
    "h": 107.254692077637,
    "CMY_C": 0.15961408615112,
    "CMY_M": 0.15966588258743,
    "CMY_Y": 0.39192789793015,
    "CMYK_C": 0,
    "CMYK_M": 6.16341058e-05,
    "CMYK_Y": 0.276437073946,
    "CMYK_K": 0.15961408615112
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0652",
    "Farbtonhilfsbezeichnung": "87.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "200",
    "Bcolor": "153",
    "Y": 55,
    "L": 79.4012985229492,
    "a": -7.18749761581421,
    "b": 22.8346614837646,
    "C": 23.9391288757324,
    "h": 107.472053527832,
    "CMY_C": 0.21671831607819,
    "CMY_M": 0.21749150753021,
    "CMY_Y": 0.40103834867477,
    "CMYK_C": 0,
    "CMYK_M": 0.00098711799365,
    "CMYK_Y": 0.23531769216061,
    "CMYK_K": 0.21671831607819
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0653",
    "Farbtonhilfsbezeichnung": "87.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "183",
    "Bcolor": "133",
    "Y": 45,
    "L": 73.1125793457031,
    "a": -8.72428607940674,
    "b": 24.5168743133545,
    "C": 26.0228805541992,
    "h": 109.588005065918,
    "CMY_C": 0.29214131832123,
    "CMY_M": 0.28225994110107,
    "CMY_Y": 0.47786980867386,
    "CMYK_C": 0.01376734767109,
    "CMYK_M": 0,
    "CMYK_Y": 0.27253580093384,
    "CMYK_K": 0.28225994110107
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0654",
    "Farbtonhilfsbezeichnung": "87.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "156",
    "Bcolor": "109",
    "Y": 31,
    "L": 63.2391510009766,
    "a": -7.18521451950073,
    "b": 23.8788299560547,
    "C": 24.9364356994629,
    "h": 106.746704101563,
    "CMY_C": 0.38777285814285,
    "CMY_M": 0.38930976390839,
    "CMY_Y": 0.57123255729675,
    "CMYK_C": 0,
    "CMYK_M": 0.00251035229303,
    "CMYK_Y": 0.29965952038765,
    "CMYK_K": 0.38777285814285
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0655",
    "Farbtonhilfsbezeichnung": "87.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "202",
    "Bcolor": "136",
    "Y": 56,
    "L": 79.738639831543,
    "a": -10.9063415527344,
    "b": 31.8642559051514,
    "C": 33.6790618896484,
    "h": 108.894798278809,
    "CMY_C": 0.21926558017731,
    "CMY_M": 0.20752483606339,
    "CMY_Y": 0.46509718894958,
    "CMYK_C": 0.01481528300792,
    "CMYK_M": 0,
    "CMYK_Y": 0.32502260804176,
    "CMYK_K": 0.20752483606339
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0656",
    "Farbtonhilfsbezeichnung": "87.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "183",
    "Bcolor": "114",
    "Y": 44,
    "L": 72.6872787475586,
    "a": -12.3547039031982,
    "b": 34.1942558288574,
    "C": 36.3577461242676,
    "h": 109.865257263184,
    "CMY_C": 0.30186480283737,
    "CMY_M": 0.28094381093979,
    "CMY_Y": 0.55399966239929,
    "CMYK_C": 0.02909507229924,
    "CMYK_M": 0,
    "CMYK_Y": 0.37974202632904,
    "CMYK_K": 0.28094381093979
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0657",
    "Farbtonhilfsbezeichnung": "87.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "163",
    "Bcolor": "101",
    "Y": 34,
    "L": 65.5819473266602,
    "a": -10.5181837081909,
    "b": 31.6200866699219,
    "C": 33.3235969543457,
    "h": 108.399314880371,
    "CMY_C": 0.37032407522202,
    "CMY_M": 0.35939919948578,
    "CMY_Y": 0.60469019412994,
    "CMYK_C": 0.01705410890281,
    "CMYK_M": 0,
    "CMYK_Y": 0.38290771842003,
    "CMYK_K": 0.35939919948578
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0658",
    "Farbtonhilfsbezeichnung": "87.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "239",
    "Bcolor": "187",
    "Y": 83,
    "L": 93.2987442016602,
    "a": -7.09053945541382,
    "b": 24.5073795318604,
    "C": 25.5124950408936,
    "h": 106.136352539063,
    "CMY_C": 0.05696189403534,
    "CMY_M": 0.06455141305923,
    "CMY_Y": 0.26713395118713,
    "CMYK_C": 0,
    "CMYK_M": 0.00804794486612,
    "CMYK_Y": 0.2228669822216,
    "CMYK_K": 0.05696189403534
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0659",
    "Farbtonhilfsbezeichnung": "87.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "238",
    "Bcolor": "166",
    "Y": 81,
    "L": 92.2706069946289,
    "a": -11.7802410125732,
    "b": 33.5757102966309,
    "C": 35.582332611084,
    "h": 109.333724975586,
    "CMY_C": 0.08179956674576,
    "CMY_M": 0.06742024421692,
    "CMY_Y": 0.34800171852112,
    "CMYK_C": 0.01541886664927,
    "CMYK_M": 0,
    "CMYK_Y": 0.3008659183979,
    "CMYK_K": 0.06742024421692
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0660",
    "Farbtonhilfsbezeichnung": "87.15.09",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "230",
    "Bcolor": "131",
    "Y": 72,
    "L": 88.6684722900391,
    "a": -17.1261100769043,
    "b": 46.468433380127,
    "C": 49.5239219665527,
    "h": 110.231552124023,
    "CMY_C": 0.13519978523254,
    "CMY_M": 0.09841948747635,
    "CMY_Y": 0.48753362894058,
    "CMYK_C": 0.04079535603523,
    "CMYK_M": 0,
    "CMYK_Y": 0.43159112334251,
    "CMYK_K": 0.09841948747635
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0661",
    "Farbtonhilfsbezeichnung": "87.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "220",
    "Bcolor": "90",
    "Y": 64,
    "L": 84.6393356323242,
    "a": -20.3627223968506,
    "b": 60.3306694030762,
    "C": 63.6744079589844,
    "h": 108.650497436523,
    "CMY_C": 0.1812549829483,
    "CMY_M": 0.13831770420074,
    "CMY_Y": 0.64710593223572,
    "CMYK_C": 0.04982959479094,
    "CMYK_M": 0,
    "CMYK_Y": 0.59045916795731,
    "CMYK_K": 0.13831770420074
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0662",
    "Farbtonhilfsbezeichnung": "87.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "188",
    "Bcolor": "74",
    "Y": 45,
    "L": 73.3410034179688,
    "a": -18.3588199615479,
    "b": 54.3642921447754,
    "C": 57.3805084228516,
    "h": 108.659828186035,
    "CMY_C": 0.30292952060699,
    "CMY_M": 0.26463615894318,
    "CMY_Y": 0.7107595205307,
    "CMYK_C": 0.05207403376698,
    "CMYK_M": 0,
    "CMYK_Y": 0.60667026042938,
    "CMYK_K": 0.26463615894318
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0663",
    "Farbtonhilfsbezeichnung": "87.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "166",
    "Bcolor": "43",
    "Y": 35,
    "L": 66.0160064697266,
    "a": -15.8936204910278,
    "b": 58.704662322998,
    "C": 60.8181266784668,
    "h": 105.149017333984,
    "CMY_C": 0.36192065477371,
    "CMY_M": 0.3474907875061,
    "CMY_Y": 0.83062195777893,
    "CMYK_C": 0.02211442776024,
    "CMYK_M": 0,
    "CMYK_Y": 0.74042046070099,
    "CMYK_K": 0.3474907875061
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0664",
    "Farbtonhilfsbezeichnung": "87.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "214",
    "Bcolor": "61",
    "Y": 60,
    "L": 82.1975708007813,
    "a": -23.5402965545654,
    "b": 68.9750137329102,
    "C": 72.8814010620117,
    "h": 108.844116210938,
    "CMY_C": 0.22042399644852,
    "CMY_M": 0.15982043743134,
    "CMY_Y": 0.76143485307693,
    "CMYK_C": 0.07213167846203,
    "CMYK_M": 0,
    "CMYK_Y": 0.71605455875397,
    "CMYK_K": 0.15982043743134
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0665",
    "Farbtonhilfsbezeichnung": "90.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "174",
    "Bcolor": "158",
    "Y": 44,
    "L": 71.2323760986328,
    "a": -0.80465841293335,
    "b": 8.30738067626953,
    "C": 8.34625911712646,
    "h": 95.5324478149414,
    "CMY_C": 0.29673719406128,
    "CMY_M": 0.3160103559494,
    "CMY_Y": 0.38007110357285,
    "CMYK_C": 0,
    "CMYK_M": 0.02740534767509,
    "CMYK_Y": 0.11849611252546,
    "CMYK_K": 0.29673719406128
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0666",
    "Farbtonhilfsbezeichnung": "90.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "204",
    "Y": 75,
    "L": 90.0792465209961,
    "a": -2.49516320228577,
    "b": 10.8933134078979,
    "C": 11.1754245758057,
    "h": 102.901306152344,
    "CMY_C": 0.0959233045578,
    "CMY_M": 0.1079558134079,
    "CMY_Y": 0.1992130279541,
    "CMYK_C": 0,
    "CMYK_M": 0.01330916862935,
    "CMYK_Y": 0.11424884945154,
    "CMYK_K": 0.0959233045578
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0667",
    "Farbtonhilfsbezeichnung": "90.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "214",
    "Bcolor": "189",
    "Y": 66,
    "L": 85.3625335693359,
    "a": -1.80789971351624,
    "b": 12.138632774353,
    "C": 12.2725267410278,
    "h": 98.4712295532227,
    "CMY_C": 0.1395805478096,
    "CMY_M": 0.16205650568008,
    "CMY_Y": 0.25910574197769,
    "CMYK_C": 0,
    "CMYK_M": 0.02612209320068,
    "CMYK_Y": 0.13891503214836,
    "CMYK_K": 0.1395805478096
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0668",
    "Farbtonhilfsbezeichnung": "90.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "195",
    "Bcolor": "171",
    "Y": 54,
    "L": 78.5298004150391,
    "a": -2.53334021568298,
    "b": 11.8037834167481,
    "C": 12.0725774765015,
    "h": 102.113121032715,
    "CMY_C": 0.22094565629959,
    "CMY_M": 0.23484522104263,
    "CMY_Y": 0.32921028137207,
    "CMYK_C": 0,
    "CMYK_M": 0.01784158498049,
    "CMYK_Y": 0.13896928727627,
    "CMYK_K": 0.22094565629959
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0669",
    "Farbtonhilfsbezeichnung": "90.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "180",
    "Bcolor": "153",
    "Y": 45,
    "L": 73.0034408569336,
    "a": -2.17453813552856,
    "b": 13.8968935012817,
    "C": 14.0659971237183,
    "h": 98.8933334350586,
    "CMY_C": 0.27245336771011,
    "CMY_M": 0.2954472899437,
    "CMY_Y": 0.40162086486816,
    "CMYK_C": 0,
    "CMYK_M": 0.03160474076867,
    "CMYK_Y": 0.17753843963146,
    "CMYK_K": 0.27245336771011
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0670",
    "Farbtonhilfsbezeichnung": "90.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "150",
    "Bcolor": "127",
    "Y": 30,
    "L": 61.9188957214355,
    "a": -1.84988117218018,
    "b": 12.4614448547363,
    "C": 12.5980024337769,
    "h": 98.4438018798828,
    "CMY_C": 0.39120233058929,
    "CMY_M": 0.41197049617767,
    "CMY_Y": 0.503726541996,
    "CMYK_C": 0,
    "CMYK_M": 0.0341134108603,
    "CMYK_Y": 0.1848302334547,
    "CMYK_K": 0.39120233058929
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0671",
    "Farbtonhilfsbezeichnung": "90.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "241",
    "Bcolor": "210",
    "Y": 86,
    "L": 94.4640731811523,
    "a": -3.9958233833313,
    "b": 14.2884931564331,
    "C": 14.8366994857788,
    "h": 105.623817443848,
    "CMY_C": 0.04817497730255,
    "CMY_M": 0.05623513460159,
    "CMY_Y": 0.17706793546677,
    "CMYK_C": 0,
    "CMYK_M": 0.00846810825169,
    "CMYK_Y": 0.13541665673256,
    "CMYK_K": 0.04817497730255
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0672",
    "Farbtonhilfsbezeichnung": "90.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "228",
    "Bcolor": "194",
    "Y": 76,
    "L": 89.9690093994141,
    "a": -3.97108626365662,
    "b": 16.1837711334229,
    "C": 16.6638526916504,
    "h": 103.786544799805,
    "CMY_C": 0.09314477443695,
    "CMY_M": 0.10705280303955,
    "CMY_Y": 0.23992735147476,
    "CMYK_C": 0,
    "CMYK_M": 0.01533654797822,
    "CMYK_Y": 0.16185888648033,
    "CMYK_K": 0.09314477443695
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0673",
    "Farbtonhilfsbezeichnung": "90.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "211",
    "Bcolor": "175",
    "Y": 64,
    "L": 84.4311218261719,
    "a": -3.11323976516724,
    "b": 18.047664642334,
    "C": 18.3142147064209,
    "h": 99.7872619628906,
    "CMY_C": 0.14349949359894,
    "CMY_M": 0.17067492008209,
    "CMY_Y": 0.31262457370758,
    "CMYK_C": 0,
    "CMYK_M": 0.03172844275832,
    "CMYK_Y": 0.1974605768919,
    "CMYK_K": 0.14349949359894
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0674",
    "Farbtonhilfsbezeichnung": "90.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "201",
    "Bcolor": "153",
    "Y": 57,
    "L": 80.4836120605469,
    "a": -4.16098117828369,
    "b": 24.2314796447754,
    "C": 24.5861415863037,
    "h": 99.7436828613281,
    "CMY_C": 0.17964512109756,
    "CMY_M": 0.21273446083069,
    "CMY_Y": 0.39955234527588,
    "CMYK_C": 0,
    "CMYK_M": 0.04033539816737,
    "CMYK_Y": 0.26806351542473,
    "CMYK_K": 0.17964512109756
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0675",
    "Farbtonhilfsbezeichnung": "90.09.15",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "178",
    "Bcolor": "128",
    "Y": 43,
    "L": 72.1974029541016,
    "a": -5.02656078338623,
    "b": 26.2128429412842,
    "C": 26.6904373168945,
    "h": 100.85523223877,
    "CMY_C": 0.27218544483185,
    "CMY_M": 0.30026310682297,
    "CMY_Y": 0.49870467185974,
    "CMYK_C": 0,
    "CMYK_M": 0.03857804462314,
    "CMYK_Y": 0.31123206019402,
    "CMYK_K": 0.27218544483185
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0676",
    "Farbtonhilfsbezeichnung": "90.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "153",
    "Bcolor": "106",
    "Y": 31,
    "L": 62.808235168457,
    "a": -4.2309513092041,
    "b": 25.0120391845703,
    "C": 25.3673610687256,
    "h": 99.6010665893555,
    "CMY_C": 0.36996698379517,
    "CMY_M": 0.40015876293182,
    "CMY_Y": 0.58290529251099,
    "CMYK_C": 0,
    "CMYK_M": 0.04792094603181,
    "CMYK_Y": 0.33797961473465,
    "CMYK_K": 0.36996698379517
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0677",
    "Farbtonhilfsbezeichnung": "90.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "227",
    "Bcolor": "177",
    "Y": 75,
    "L": 89.6644134521484,
    "a": -5.56664991378784,
    "b": 24.7271423339844,
    "C": 25.3459892272949,
    "h": 102.68709564209,
    "CMY_C": 0.08610516786575,
    "CMY_M": 0.10869306325912,
    "CMY_Y": 0.30727279186249,
    "CMYK_C": 0,
    "CMYK_M": 0.02471607737243,
    "CMYK_Y": 0.24200555682182,
    "CMYK_K": 0.08610516786575
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0678",
    "Farbtonhilfsbezeichnung": "90.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "214",
    "Bcolor": "157",
    "Y": 66,
    "L": 85.270866394043,
    "a": -4.68491077423096,
    "b": 28.860559463501,
    "C": 29.2383365631104,
    "h": 99.220344543457,
    "CMY_C": 0.11949509382248,
    "CMY_M": 0.16014170646667,
    "CMY_Y": 0.38429099321365,
    "CMYK_C": 0,
    "CMYK_M": 0.04616284742951,
    "CMYK_Y": 0.30073189735413,
    "CMYK_K": 0.11949509382248
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0679",
    "Farbtonhilfsbezeichnung": "90.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "203",
    "Bcolor": "127",
    "Y": 58,
    "L": 80.9993438720703,
    "a": -7.63220739364624,
    "b": 38.3848495483398,
    "C": 39.1362648010254,
    "h": 101.245666503906,
    "CMY_C": 0.16884917020798,
    "CMY_M": 0.20199555158615,
    "CMY_Y": 0.50083965063095,
    "CMYK_C": 0,
    "CMYK_M": 0.03988010436296,
    "CMYK_Y": 0.39943468570709,
    "CMYK_K": 0.16884917020798
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0680",
    "Farbtonhilfsbezeichnung": "90.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "180",
    "Bcolor": "95",
    "Y": 43,
    "L": 72.6668701171875,
    "a": -6.33707809448242,
    "b": 43.9357681274414,
    "C": 44.3904304504395,
    "h": 98.2074584960938,
    "CMY_C": 0.24392330646515,
    "CMY_M": 0.29528367519379,
    "CMY_Y": 0.62716805934906,
    "CMYK_C": 0,
    "CMYK_M": 0.06793010234833,
    "CMYK_Y": 0.50688606500626,
    "CMYK_K": 0.24392330646515
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0681",
    "Farbtonhilfsbezeichnung": "90.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "151",
    "Bcolor": "71",
    "Y": 30,
    "L": 61.8802795410156,
    "a": -5.41555881500244,
    "b": 42.3019866943359,
    "C": 42.6472320556641,
    "h": 97.2954025268555,
    "CMY_C": 0.3591725230217,
    "CMY_M": 0.40979099273682,
    "CMY_Y": 0.71985197067261,
    "CMYK_C": 0,
    "CMYK_M": 0.07898923009634,
    "CMYK_Y": 0.56283390522003,
    "CMYK_K": 0.3591725230217
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0682",
    "Farbtonhilfsbezeichnung": "90.15.06",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "227",
    "Bcolor": "125",
    "Y": 74,
    "L": 89.1474990844727,
    "a": -10.4762697219849,
    "b": 49.9489898681641,
    "C": 51.0358085632324,
    "h": 101.845474243164,
    "CMY_C": 0.07546144723892,
    "CMY_M": 0.10791307687759,
    "CMY_Y": 0.50884652137756,
    "CMYK_C": 0,
    "CMYK_M": 0.03510035201907,
    "CMYK_Y": 0.4687582552433,
    "CMYK_K": 0.07546144723892
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0683",
    "Farbtonhilfsbezeichnung": "90.15.09",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "215",
    "Bcolor": "96",
    "Y": 64,
    "L": 84.6662445068359,
    "a": -11.9557371139526,
    "b": 57.8893508911133,
    "C": 59.1110534667969,
    "h": 101.669090270996,
    "CMY_C": 0.12523478269577,
    "CMY_M": 0.1552642583847,
    "CMY_Y": 0.62218630313873,
    "CMYK_C": 0,
    "CMYK_M": 0.03432861343026,
    "CMYK_Y": 0.56809705495834,
    "CMYK_K": 0.12523478269577
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0684",
    "Farbtonhilfsbezeichnung": "90.15.12",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "203",
    "Bcolor": "62",
    "Y": 55,
    "L": 79.9851837158203,
    "a": -12.6553239822388,
    "b": 66.6273498535156,
    "C": 67.8185882568359,
    "h": 100.754753112793,
    "CMY_C": 0.1731898188591,
    "CMY_M": 0.20583701133728,
    "CMY_Y": 0.75555443763733,
    "CMYK_C": 0,
    "CMYK_M": 0.03948571532965,
    "CMYK_Y": 0.70435106754303,
    "CMYK_K": 0.1731898188591
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0685",
    "Farbtonhilfsbezeichnung": "90.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "179",
    "Bcolor": "37",
    "Y": 42,
    "L": 72.1518173217773,
    "a": -9.01973628997803,
    "b": 67.3100128173828,
    "C": 67.9116592407227,
    "h": 97.6323394775391,
    "CMY_C": 0.23927569389343,
    "CMY_M": 0.29755789041519,
    "CMY_Y": 0.85665458440781,
    "CMYK_C": 0,
    "CMYK_M": 0.07661408185959,
    "CMYK_Y": 0.81156718730927,
    "CMYK_K": 0.23927569389343
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0686",
    "Farbtonhilfsbezeichnung": "93.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 84,
    "L": 92.9213638305664,
    "a": -0.69875210523605,
    "b": 1.57929146289825,
    "C": 1.72696733474731,
    "h": 113.866828918457,
    "CMY_C": 0.07988482713699,
    "CMY_M": 0.0779475569725,
    "CMY_Y": 0.09862929582596,
    "CMYK_C": 0.00210104114376,
    "CMYK_M": 0,
    "CMYK_Y": 0.02243011072278,
    "CMYK_K": 0.0779475569725
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0687",
    "Farbtonhilfsbezeichnung": "93.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "237",
    "Bcolor": "223",
    "Y": 85,
    "L": 93.6361541748047,
    "a": -0.64844465255737,
    "b": 6.18611097335815,
    "C": 6.22000408172607,
    "h": 95.9840393066406,
    "CMY_C": 0.05627703666687,
    "CMY_M": 0.07133114337921,
    "CMY_Y": 0.12503057718277,
    "CMYK_C": 0,
    "CMYK_M": 0.01595182903111,
    "CMYK_Y": 0.07285352051258,
    "CMYK_K": 0.05627703666687
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0688",
    "Farbtonhilfsbezeichnung": "93.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "213",
    "Bcolor": "188",
    "Y": 67,
    "L": 85.4897689819336,
    "a": -0.18093505501747,
    "b": 12.6990280151367,
    "C": 12.7003173828125,
    "h": 90.816291809082,
    "CMY_C": 0.12449556589127,
    "CMY_M": 0.16459119319916,
    "CMY_Y": 0.26160049438477,
    "CMYK_C": 0,
    "CMYK_M": 0.04579717293382,
    "CMYK_Y": 0.15660107135773,
    "CMYK_K": 0.12449556589127
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0689",
    "Farbtonhilfsbezeichnung": "93.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "198",
    "Bcolor": "175",
    "Y": 56,
    "L": 80.0524749755859,
    "a": -0.49739480018616,
    "b": 12.0036010742188,
    "C": 12.0139017105103,
    "h": 92.3728179931641,
    "CMY_C": 0.18880808353424,
    "CMY_M": 0.22305715084076,
    "CMY_Y": 0.31431436538696,
    "CMYK_C": 0,
    "CMYK_M": 0.04222067072988,
    "CMYK_Y": 0.15471835434437,
    "CMYK_K": 0.18880808353424
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0690",
    "Farbtonhilfsbezeichnung": "93.03.18",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "174",
    "Bcolor": "147",
    "Y": 43,
    "L": 71.441780090332,
    "a": -0.43596199154854,
    "b": 14.7779397964478,
    "C": 14.784369468689,
    "h": 91.6897811889648,
    "CMY_C": 0.27469658851624,
    "CMY_M": 0.31613564491272,
    "CMY_Y": 0.42362546920776,
    "CMYK_C": 0,
    "CMYK_M": 0.05713341012597,
    "CMYK_Y": 0.20533321797848,
    "CMYK_K": 0.27469658851624
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0691",
    "Farbtonhilfsbezeichnung": "93.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "223",
    "Bcolor": "196",
    "Y": 73,
    "L": 88.8923034667969,
    "a": -1.22508013248444,
    "b": 13.7736406326294,
    "C": 13.8280153274536,
    "h": 95.0827255249023,
    "CMY_C": 0.09127563238144,
    "CMY_M": 0.12483143806458,
    "CMY_Y": 0.23318201303482,
    "CMYK_C": 0,
    "CMYK_M": 0.03692627325654,
    "CMYK_Y": 0.15615998208523,
    "CMYK_K": 0.09127563238144
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0692",
    "Farbtonhilfsbezeichnung": "93.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "211",
    "Bcolor": "182",
    "Y": 64,
    "L": 84.7066192626953,
    "a": -1.11579465866089,
    "b": 14.7332801818848,
    "C": 14.7754707336426,
    "h": 94.3309097290039,
    "CMY_C": 0.13453775644302,
    "CMY_M": 0.17149758338928,
    "CMY_Y": 0.28502535820007,
    "CMYK_C": 0,
    "CMYK_M": 0.04270530119538,
    "CMYK_Y": 0.17388118803501,
    "CMYK_K": 0.13453775644302
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0693",
    "Farbtonhilfsbezeichnung": "93.06.18",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "201",
    "Bcolor": "173",
    "Y": 57,
    "L": 80.811882019043,
    "a": -1.70656526088715,
    "b": 14.0514192581177,
    "C": 14.1546726226807,
    "h": 96.9247436523438,
    "CMY_C": 0.18374651670456,
    "CMY_M": 0.21251553297043,
    "CMY_Y": 0.32135367393494,
    "CMYK_C": 0,
    "CMYK_M": 0.03524519875646,
    "CMYK_Y": 0.16858385503292,
    "CMYK_K": 0.18374651670456
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0694",
    "Farbtonhilfsbezeichnung": "93.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "226",
    "Bcolor": "183",
    "Y": 75,
    "L": 89.6078033447266,
    "a": -3.77072548866272,
    "b": 21.4121932983398,
    "C": 21.7416744232178,
    "h": 99.9874877929688,
    "CMY_C": 0.08177298307419,
    "CMY_M": 0.11273193359375,
    "CMY_Y": 0.28273391723633,
    "CMYK_C": 0,
    "CMYK_M": 0.03371600806713,
    "CMYK_Y": 0.21885757148266,
    "CMYK_K": 0.08177298307419
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0695",
    "Farbtonhilfsbezeichnung": "93.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "212",
    "Bcolor": "163",
    "Y": 65,
    "L": 84.6795806884766,
    "a": -3.51532530784607,
    "b": 24.8201160430908,
    "C": 25.0678215026856,
    "h": 98.0613021850586,
    "CMY_C": 0.12694019079208,
    "CMY_M": 0.16849327087402,
    "CMY_Y": 0.36012125015259,
    "CMYK_C": 0,
    "CMYK_M": 0.04759477078915,
    "CMYK_Y": 0.26708486676216,
    "CMYK_K": 0.12694019079208
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0696",
    "Farbtonhilfsbezeichnung": "93.09.18",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "201",
    "Bcolor": "149",
    "Y": 58,
    "L": 80.7762756347656,
    "a": -3.16421604156494,
    "b": 26.8710327148438,
    "C": 27.0566940307617,
    "h": 96.7159805297852,
    "CMY_C": 0.16339820623398,
    "CMY_M": 0.21233886480331,
    "CMY_Y": 0.41579675674438,
    "CMYK_C": 0,
    "CMYK_M": 0.05849934741855,
    "CMYK_Y": 0.30169495940208,
    "CMYK_K": 0.16339820623398
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0697",
    "Farbtonhilfsbezeichnung": "93.12.12",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "226",
    "Bcolor": "167",
    "Y": 75,
    "L": 89.8695220947266,
    "a": -3.69985008239746,
    "b": 29.9616966247559,
    "C": 30.1892719268799,
    "h": 97.0395889282227,
    "CMY_C": 0.05792772769928,
    "CMY_M": 0.11179023981094,
    "CMY_Y": 0.34418445825577,
    "CMYK_C": 0,
    "CMYK_M": 0.05717450007796,
    "CMYK_Y": 0.30385857820511,
    "CMYK_K": 0.05792772769928
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0698",
    "Farbtonhilfsbezeichnung": "93.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "214",
    "Bcolor": "144",
    "Y": 67,
    "L": 85.7210388183594,
    "a": -2.6498281955719,
    "b": 36.076831817627,
    "C": 36.174015045166,
    "h": 94.2008056640625,
    "CMY_C": 0.08515733480453,
    "CMY_M": 0.16122800111771,
    "CMY_Y": 0.43365252017975,
    "CMYK_C": 0,
    "CMYK_M": 0.08315163850784,
    "CMYK_Y": 0.38093456625938,
    "CMYK_K": 0.08515733480453
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0699",
    "Farbtonhilfsbezeichnung": "93.12.18",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "199",
    "Bcolor": "124",
    "Y": 57,
    "L": 80.640625,
    "a": -2.22549510002136,
    "b": 39.5430946350098,
    "C": 39.6056709289551,
    "h": 93.2212219238281,
    "CMY_C": 0.13380545377731,
    "CMY_M": 0.2182434797287,
    "CMY_Y": 0.51206839084625,
    "CMYK_C": 0,
    "CMYK_M": 0.09748159348965,
    "CMYK_Y": 0.43669512867928,
    "CMYK_K": 0.13380545377731
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0700",
    "Farbtonhilfsbezeichnung": "93.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "185",
    "Y": 87,
    "L": 94.0600280761719,
    "a": -5.52283191680908,
    "b": 26.5586948394775,
    "C": 27.1268482208252,
    "h": 101.747138977051,
    "CMY_C": 0.03142899274826,
    "CMY_M": 0.06003963947296,
    "CMY_Y": 0.27423089742661,
    "CMYK_C": 0,
    "CMYK_M": 0.02953902818263,
    "CMYK_Y": 0.25068053603172,
    "CMYK_K": 0.03142899274826
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0701",
    "Farbtonhilfsbezeichnung": "93.15.12",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "231",
    "Bcolor": "133",
    "Y": 79,
    "L": 91.2477951049805,
    "a": -5.40669107437134,
    "b": 49.032958984375,
    "C": 49.3301467895508,
    "h": 96.2923812866211,
    "CMY_C": 0.01719605922699,
    "CMY_M": 0.09587705135345,
    "CMY_Y": 0.47824656963348,
    "CMYK_C": 0,
    "CMYK_M": 0.08005766570568,
    "CMYK_Y": 0.46911749243736,
    "CMYK_K": 0.01719605922699
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0702",
    "Farbtonhilfsbezeichnung": "93.15.15",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "218",
    "Bcolor": "103",
    "Y": 69,
    "L": 87.0742340087891,
    "a": -4.13360357284546,
    "b": 58.0325202941895,
    "C": 58.1795501708984,
    "h": 94.0742416381836,
    "CMY_C": 0.04398596286774,
    "CMY_M": 0.14629024267197,
    "CMY_Y": 0.59563589096069,
    "CMYK_C": 0,
    "CMYK_M": 0.1070112735033,
    "CMYK_Y": 0.57703119516373,
    "CMYK_K": 0.04398596286774
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0703",
    "Farbtonhilfsbezeichnung": "93.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "200",
    "Bcolor": "73",
    "Y": 58,
    "L": 81.0226287841797,
    "a": -3.118084192276,
    "b": 64.090934753418,
    "C": 64.1667404174805,
    "h": 92.7853012084961,
    "CMY_C": 0.10126668214798,
    "CMY_M": 0.21536368131638,
    "CMY_Y": 0.71372091770172,
    "CMYK_C": 0,
    "CMYK_M": 0.126953125,
    "CMYK_Y": 0.6814638376236,
    "CMYK_K": 0.10126668214798
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0704",
    "Farbtonhilfsbezeichnung": "93.18.15",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "220",
    "Bcolor": "62",
    "Y": 72,
    "L": 86.7026519775391,
    "a": -9.85200595855713,
    "b": 73.8913269042969,
    "C": 74.5452194213867,
    "h": 97.5945129394531,
    "CMY_C": 0.06772327423096,
    "CMY_M": 0.13921064138412,
    "CMY_Y": 0.75621366500854,
    "CMYK_C": 0,
    "CMYK_M": 0.07668041437864,
    "CMYK_Y": 0.73850435018539,
    "CMYK_K": 0.06772327423096
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0705",
    "Farbtonhilfsbezeichnung": "96.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "241",
    "Bcolor": "214",
    "Y": 88,
    "L": 95.1399765014648,
    "a": -1.15773248672485,
    "b": 13.3338117599487,
    "C": 13.383978843689,
    "h": 94.9623641967773,
    "CMY_C": 0.02153426408768,
    "CMY_M": 0.0550891160965,
    "CMY_Y": 0.16206049919128,
    "CMYK_C": 0,
    "CMYK_M": 0.03429333493114,
    "CMYK_Y": 0.14361897110939,
    "CMYK_K": 0.02153426408768
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0706",
    "Farbtonhilfsbezeichnung": "96.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "225",
    "Bcolor": "183",
    "Y": 75,
    "L": 89.7142333984375,
    "a": -1.67613863945007,
    "b": 21.396577835083,
    "C": 21.4621295928955,
    "h": 94.4792175292969,
    "CMY_C": 0.06521558761597,
    "CMY_M": 0.1164328455925,
    "CMY_Y": 0.28111273050308,
    "CMYK_C": 0,
    "CMYK_M": 0.0547904483974,
    "CMYK_Y": 0.23095928132534,
    "CMYK_K": 0.06521558761597
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0707",
    "Farbtonhilfsbezeichnung": "96.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "211",
    "Bcolor": "163",
    "Y": 65,
    "L": 84.8323059082031,
    "a": -0.85161608457565,
    "b": 25.3383331298828,
    "C": 25.3526401519775,
    "h": 91.9249725341797,
    "CMY_C": 0.10505872964859,
    "CMY_M": 0.17309749126434,
    "CMY_Y": 0.3618728518486,
    "CMYK_C": 0,
    "CMYK_M": 0.07602594792843,
    "CMYK_Y": 0.28696197271347,
    "CMYK_K": 0.10505872964859
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0708",
    "Farbtonhilfsbezeichnung": "96.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "204",
    "Bcolor": "149",
    "Y": 60,
    "L": 82.3762969970703,
    "a": -1.00072109699249,
    "b": 28.9163284301758,
    "C": 28.9336395263672,
    "h": 91.9820709228516,
    "CMY_C": 0.1260085105896,
    "CMY_M": 0.20031356811523,
    "CMY_Y": 0.41401463747025,
    "CMYK_C": 0,
    "CMYK_M": 0.08501805365086,
    "CMYK_Y": 0.3295296728611,
    "CMYK_K": 0.1260085105896
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0709",
    "Farbtonhilfsbezeichnung": "96.09.15",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "186",
    "Bcolor": "138",
    "Y": 50,
    "L": 75.9263381958008,
    "a": -0.35833114385605,
    "b": 26.3058471679688,
    "C": 26.3082866668701,
    "h": 90.7804183959961,
    "CMY_C": 0.19905167818069,
    "CMY_M": 0.27096182107925,
    "CMY_Y": 0.46077638864517,
    "CMYK_C": 0,
    "CMYK_M": 0.08978125452995,
    "CMYK_Y": 0.32676854729652,
    "CMYK_K": 0.19905167818069
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0710",
    "Farbtonhilfsbezeichnung": "96.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "142",
    "Bcolor": "100",
    "Y": 29,
    "L": 59.516544342041,
    "a": 0.5785516500473,
    "b": 23.9598903656006,
    "C": 23.9668750762939,
    "h": 88.6167678833008,
    "CMY_C": 0.37549060583115,
    "CMY_M": 0.44416654109955,
    "CMY_Y": 0.60647404193878,
    "CMYK_C": 0,
    "CMYK_M": 0.10996782034636,
    "CMYK_Y": 0.36986383795738,
    "CMYK_K": 0.37549060583115
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0711",
    "Farbtonhilfsbezeichnung": "96.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "207",
    "Y": 82,
    "L": 92.7359924316406,
    "a": -1.2309752702713,
    "b": 13.5764064788818,
    "C": 13.632098197937,
    "h": 95.1808547973633,
    "CMY_C": 0.04862684011459,
    "CMY_M": 0.08195018768311,
    "CMY_Y": 0.19011837244034,
    "CMYK_C": 0,
    "CMYK_M": 0.03502658009529,
    "CMYK_Y": 0.14872348308563,
    "CMYK_K": 0.04862684011459
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0712",
    "Farbtonhilfsbezeichnung": "96.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "224",
    "Bcolor": "183",
    "Y": 74,
    "L": 89.2690811157227,
    "a": -0.81709676980972,
    "b": 21.1099262237549,
    "C": 21.1257343292236,
    "h": 92.2166213989258,
    "CMY_C": 0.06470745801926,
    "CMY_M": 0.12333565950394,
    "CMY_Y": 0.28356754779816,
    "CMYK_C": 0,
    "CMYK_M": 0.06268434971571,
    "CMYK_Y": 0.23400174081326,
    "CMYK_K": 0.06470745801926
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0713",
    "Farbtonhilfsbezeichnung": "96.12.09",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "213",
    "Bcolor": "149",
    "Y": 68,
    "L": 85.9416580200195,
    "a": -0.33770275115967,
    "b": 34.2461204528809,
    "C": 34.2477836608887,
    "h": 90.5649719238281,
    "CMY_C": 0.07021695375443,
    "CMY_M": 0.16388934850693,
    "CMY_Y": 0.41696238517761,
    "CMYK_C": 0,
    "CMYK_M": 0.10074650496244,
    "CMYK_Y": 0.37293154001236,
    "CMYK_K": 0.07021695375443
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0714",
    "Farbtonhilfsbezeichnung": "96.12.12",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "200",
    "Bcolor": "128",
    "Y": 59,
    "L": 81.5056533813477,
    "a": 0.23532354831696,
    "b": 38.775218963623,
    "C": 38.7759323120117,
    "h": 89.6522827148438,
    "CMY_C": 0.10877591371536,
    "CMY_M": 0.21446669101715,
    "CMY_Y": 0.4968084692955,
    "CMYK_C": 0,
    "CMYK_M": 0.11859057843685,
    "CMYK_Y": 0.43539279699326,
    "CMYK_K": 0.10877591371536
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0715",
    "Farbtonhilfsbezeichnung": "96.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "176",
    "Bcolor": "105",
    "Y": 44,
    "L": 72.5334548950195,
    "a": 0.36103448271751,
    "b": 38.8086280822754,
    "C": 38.8103065490723,
    "h": 89.4669952392578,
    "CMY_C": 0.20955115556717,
    "CMY_M": 0.31092244386673,
    "CMY_Y": 0.58723843097687,
    "CMYK_C": 0,
    "CMYK_M": 0.12824521958828,
    "CMYK_Y": 0.4778136909008,
    "CMYK_K": 0.20955115556717
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0716",
    "Farbtonhilfsbezeichnung": "96.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "148",
    "Bcolor": "85",
    "Y": 30,
    "L": 61.8376083374023,
    "a": -0.52279376983643,
    "b": 35.2768135070801,
    "C": 35.2806854248047,
    "h": 90.8490524291992,
    "CMY_C": 0.33875572681427,
    "CMY_M": 0.4198414683342,
    "CMY_Y": 0.66549152135849,
    "CMYK_C": 0,
    "CMYK_M": 0.12262599915266,
    "CMYK_Y": 0.49412268400192,
    "CMYK_K": 0.33875572681427
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0717",
    "Farbtonhilfsbezeichnung": "96.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "226",
    "Bcolor": "177",
    "Y": 77,
    "L": 90.1493225097656,
    "a": -0.4040235877037,
    "b": 25.5530052185059,
    "C": 25.5561981201172,
    "h": 90.9058456420898,
    "CMY_C": 0.0410875082016,
    "CMY_M": 0.11552250385284,
    "CMY_Y": 0.30736839771271,
    "CMYK_C": 0,
    "CMYK_M": 0.07762438803911,
    "CMYK_Y": 0.27769050002098,
    "CMYK_K": 0.0410875082016
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0718",
    "Farbtonhilfsbezeichnung": "96.15.09",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "213",
    "Bcolor": "132",
    "Y": 68,
    "L": 86.0898666381836,
    "a": -0.2520580291748,
    "b": 42.7878761291504,
    "C": 42.7886199951172,
    "h": 90.337516784668,
    "CMY_C": 0.05246245861053,
    "CMY_M": 0.16396480798721,
    "CMY_Y": 0.48089760541916,
    "CMYK_C": 0,
    "CMYK_M": 0.11767591536045,
    "CMYK_Y": 0.45215639472008,
    "CMYK_K": 0.05246245861053
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0719",
    "Farbtonhilfsbezeichnung": "96.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "199",
    "Bcolor": "106",
    "Y": 58,
    "L": 81.39208984375,
    "a": 0.53028255701065,
    "b": 49.9059562683105,
    "C": 49.9087753295898,
    "h": 89.3912200927734,
    "CMY_C": 0.09087461233139,
    "CMY_M": 0.21811836957932,
    "CMY_Y": 0.58496630191803,
    "CMYK_C": 0,
    "CMYK_M": 0.13996282219887,
    "CMYK_Y": 0.54348021745682,
    "CMYK_K": 0.09087461233139
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0720",
    "Farbtonhilfsbezeichnung": "96.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "175",
    "Bcolor": "81",
    "Y": 44,
    "L": 72.5124588012695,
    "a": 1.14818120002747,
    "b": 50.840991973877,
    "C": 50.8539543151855,
    "h": 88.7062606811523,
    "CMY_C": 0.18825405836105,
    "CMY_M": 0.31464982032776,
    "CMY_Y": 0.68200373649597,
    "CMYK_C": 0,
    "CMYK_M": 0.15570852160454,
    "CMYK_Y": 0.6082563996315,
    "CMYK_K": 0.18825405836105
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0721",
    "Farbtonhilfsbezeichnung": "96.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "148",
    "Bcolor": "66",
    "Y": 30,
    "L": 62.2425994873047,
    "a": 0.04826904833317,
    "b": 45.6544151306152,
    "C": 45.6544418334961,
    "h": 89.9394226074219,
    "CMY_C": 0.31712412834167,
    "CMY_M": 0.41833329200745,
    "CMY_Y": 0.74138909578323,
    "CMYK_C": 0,
    "CMYK_M": 0.14821019768715,
    "CMYK_Y": 0.62129151821136,
    "CMYK_K": 0.31712412834167
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0722",
    "Farbtonhilfsbezeichnung": "96.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "223",
    "Bcolor": "149",
    "Y": 75,
    "L": 89.5853652954102,
    "a": -0.7524202466011,
    "b": 39.0063972473145,
    "C": 39.0136528015137,
    "h": 91.1050796508789,
    "CMY_C": 0.02205407619476,
    "CMY_M": 0.12358742952347,
    "CMY_Y": 0.41555309295654,
    "CMYK_C": 0,
    "CMYK_M": 0.10382307320833,
    "CMYK_Y": 0.40237298607826,
    "CMYK_K": 0.02205407619476
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0723",
    "Farbtonhilfsbezeichnung": "96.18.09",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "207",
    "Bcolor": "102",
    "Y": 64,
    "L": 84.150993347168,
    "a": -0.05068160966039,
    "b": 55.2578125,
    "C": 55.2578353881836,
    "h": 90.0525512695313,
    "CMY_C": 0.05516195297241,
    "CMY_M": 0.18750447034836,
    "CMY_Y": 0.60096979141235,
    "CMYK_C": 0,
    "CMYK_M": 0.14006899297237,
    "CMYK_Y": 0.57767343521118,
    "CMYK_K": 0.05516195297241
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0724",
    "Farbtonhilfsbezeichnung": "96.18.12",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "199",
    "Bcolor": "99",
    "Y": 59,
    "L": 81.5507049560547,
    "a": 0.85235887765884,
    "b": 53.5600357055664,
    "C": 53.5668182373047,
    "h": 89.088264465332,
    "CMY_C": 0.08202558755875,
    "CMY_M": 0.2176673412323,
    "CMY_Y": 0.61316508054733,
    "CMYK_C": 0,
    "CMYK_M": 0.14776201546192,
    "CMYK_Y": 0.57859945297241,
    "CMYK_K": 0.08202558755875
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0725",
    "Farbtonhilfsbezeichnung": "96.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "173",
    "Bcolor": "60",
    "Y": 43,
    "L": 72.3010406494141,
    "a": 3.43252563476563,
    "b": 60.1993865966797,
    "C": 60.2971687316895,
    "h": 86.736572265625,
    "CMY_C": 0.16658443212509,
    "CMY_M": 0.3233328461647,
    "CMY_Y": 0.7665382027626,
    "CMYK_C": 0,
    "CMYK_M": 0.18807953596115,
    "CMYK_Y": 0.71987348794937,
    "CMYK_K": 0.16658443212509
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0726",
    "Farbtonhilfsbezeichnung": "96.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "153",
    "Bcolor": "52",
    "Y": 32,
    "L": 64.0932312011719,
    "a": 0.30497828125954,
    "b": 54.2516975402832,
    "C": 54.252555847168,
    "h": 89.6779098510742,
    "CMY_C": 0.28570264577866,
    "CMY_M": 0.40085673332214,
    "CMY_Y": 0.79768192768097,
    "CMYK_C": 0,
    "CMYK_M": 0.16121309995651,
    "CMYK_Y": 0.71675932407379,
    "CMYK_K": 0.28570264577866
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0727",
    "Farbtonhilfsbezeichnung": "96.21.06",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "227",
    "Bcolor": "142",
    "Y": 79,
    "L": 90.9274368286133,
    "a": -1.12791013717651,
    "b": 44.1437377929688,
    "C": 44.158145904541,
    "h": 91.4636383056641,
    "CMY_C": 0,
    "CMY_M": 0.10869777202606,
    "CMY_Y": 0.44163209199905,
    "CMYK_C": 0,
    "CMYK_M": 0.10869777202606,
    "CMYK_Y": 0.44163209199905,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0728",
    "Farbtonhilfsbezeichnung": "96.21.09",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "209",
    "Bcolor": "89",
    "Y": 66,
    "L": 85.1360855102539,
    "a": 1.02606499195099,
    "b": 62.2425880432129,
    "C": 62.2510452270508,
    "h": 89.0555725097656,
    "CMY_C": 0.02794682979584,
    "CMY_M": 0.18021905422211,
    "CMY_Y": 0.6509336233139,
    "CMYK_C": 0,
    "CMYK_M": 0.15665009617805,
    "CMYK_Y": 0.64089787006378,
    "CMYK_K": 0.02794682979584
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0729",
    "Farbtonhilfsbezeichnung": "96.21.12",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "203",
    "Bcolor": "77",
    "Y": 61,
    "L": 82.9659576416016,
    "a": 1.46094954013824,
    "b": 64.8942108154297,
    "C": 64.9106521606445,
    "h": 88.710334777832,
    "CMY_C": 0.04813235998154,
    "CMY_M": 0.20517385005951,
    "CMY_Y": 0.69836163520813,
    "CMYK_C": 0,
    "CMYK_M": 0.16498248279095,
    "CMYK_Y": 0.6831089258194,
    "CMYK_K": 0.04813235998154
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0730",
    "Farbtonhilfsbezeichnung": "96.21.15",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "181",
    "Bcolor": "45",
    "Y": 46,
    "L": 74.8892517089844,
    "a": 0.3087902367115,
    "b": 67.9691009521484,
    "C": 67.9698028564453,
    "h": 89.7397003173828,
    "CMY_C": 0.14826840162277,
    "CMY_M": 0.28937691450119,
    "CMY_Y": 0.82295852899551,
    "CMYK_C": 0,
    "CMYK_M": 0.16567251086235,
    "CMYK_Y": 0.79213935136795,
    "CMYK_K": 0.14826840162277
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0731",
    "Farbtonhilfsbezeichnung": "96.24.09",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "202",
    "Bcolor": "62",
    "Y": 63,
    "L": 83.0194778442383,
    "a": 2.81833553314209,
    "b": 70.852783203125,
    "C": 70.9088134765625,
    "h": 87.7221298217773,
    "CMY_C": 0.03307259082794,
    "CMY_M": 0.20850521326065,
    "CMY_Y": 0.75771868228912,
    "CMYK_C": 0,
    "CMYK_M": 0.18143308162689,
    "CMYK_Y": 0.74943172931671,
    "CMYK_K": 0.03307259082794
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0732",
    "Farbtonhilfsbezeichnung": "99.00.03",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "237",
    "Bcolor": "229",
    "Y": 85,
    "L": 93.5491485595703,
    "a": -0.68008917570114,
    "b": 2.88425850868225,
    "C": 2.96335434913635,
    "h": 103.267623901367,
    "CMY_C": 0.06828796863556,
    "CMY_M": 0.07132256031036,
    "CMY_Y": 0.10138469934464,
    "CMYK_C": 0,
    "CMYK_M": 0.00325700594112,
    "CMYK_Y": 0.03552249073982,
    "CMYK_K": 0.06828796863556
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0733",
    "Farbtonhilfsbezeichnung": "99.00.06",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.7031326293945,
    "a": -0.57865315675735,
    "b": 2.45784163475037,
    "C": 2.52503967285156,
    "h": 103.247970581055,
    "CMY_C": 0.07839852571487,
    "CMY_M": 0.08092415332794,
    "CMY_Y": 0.10756266117096,
    "CMYK_C": 0,
    "CMYK_M": 0.00274047697894,
    "CMYK_Y": 0.03164506331086,
    "CMYK_K": 0.07839852571487
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0734",
    "Farbtonhilfsbezeichnung": "99.00.09",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "229",
    "Bcolor": "223",
    "Y": 78,
    "L": 90.9329681396484,
    "a": -0.55553656816483,
    "b": 2.08292412757874,
    "C": 2.15573501586914,
    "h": 104.933731079102,
    "CMY_C": 0.09925335645676,
    "CMY_M": 0.10064995288849,
    "CMY_Y": 0.1243269443512,
    "CMYK_C": 0,
    "CMYK_M": 0.00155048747547,
    "CMYK_Y": 0.02783644944429,
    "CMYK_K": 0.09925335645676
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0735",
    "Farbtonhilfsbezeichnung": "99.00.12",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "217",
    "Bcolor": "213",
    "Y": 69,
    "L": 86.4315414428711,
    "a": -0.41181290149689,
    "b": 1.01293349266052,
    "C": 1.09344601631165,
    "h": 112.124435424805,
    "CMY_C": 0.15163058042526,
    "CMY_M": 0.15060752630234,
    "CMY_Y": 0.16582649946213,
    "CMYK_C": 0.00120445399079,
    "CMYK_M": 0,
    "CMYK_Y": 0.01791748031974,
    "CMYK_K": 0.15060752630234
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0736",
    "Farbtonhilfsbezeichnung": "99.00.15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "206",
    "Bcolor": "202",
    "Y": 61,
    "L": 82.4524230957031,
    "a": -0.6098198890686,
    "b": 1.00465643405914,
    "C": 1.17525100708008,
    "h": 121.257484436035,
    "CMY_C": 0.19683939218521,
    "CMY_M": 0.19382125139236,
    "CMY_Y": 0.2090460062027,
    "CMYK_C": 0.00374376121908,
    "CMYK_M": 0,
    "CMYK_Y": 0.01888508535922,
    "CMYK_K": 0.19382125139236
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0737",
    "Farbtonhilfsbezeichnung": "99.00.18",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "198",
    "Bcolor": "194",
    "Y": 56,
    "L": 79.6072235107422,
    "a": -0.44553673267365,
    "b": 0.80176758766174,
    "C": 0.91724276542664,
    "h": 119.060623168945,
    "CMY_C": 0.22717446088791,
    "CMY_M": 0.22510612010956,
    "CMY_Y": 0.23822247982025,
    "CMYK_C": 0.00266919238493,
    "CMYK_M": 0,
    "CMYK_Y": 0.01692665368319,
    "CMYK_K": 0.22510612010956
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0738",
    "Farbtonhilfsbezeichnung": "99.00.21",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "187",
    "Bcolor": "184",
    "Y": 50,
    "L": 75.579460144043,
    "a": -0.4860098361969,
    "b": 0.57030361890793,
    "C": 0.74930083751678,
    "h": 130.437454223633,
    "CMY_C": 0.27164137363434,
    "CMY_M": 0.26838707923889,
    "CMY_Y": 0.27960532903671,
    "CMYK_C": 0.0044481093064,
    "CMYK_M": 0,
    "CMYK_Y": 0.01533358637244,
    "CMYK_K": 0.26838707923889
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0739",
    "Farbtonhilfsbezeichnung": "99.00.24",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "178",
    "Bcolor": "176",
    "Y": 45,
    "L": 72.4794235229492,
    "a": -0.48140722513199,
    "b": 0.36218348145485,
    "C": 0.60243654251099,
    "h": 143.04426574707,
    "CMY_C": 0.30535739660263,
    "CMY_M": 0.30145126581192,
    "CMY_Y": 0.31094324588776,
    "CMYK_C": 0.00559177994728,
    "CMYK_M": 0,
    "CMYK_Y": 0.01358814258128,
    "CMYK_K": 0.30145126581192
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0740",
    "Farbtonhilfsbezeichnung": "99.00.30",
    "Farbtonklasse": "01",
    "Rcolor": "155",
    "Gcolor": "156",
    "Bcolor": "155",
    "Y": 33,
    "L": 64.3840637207031,
    "a": -0.33940789103508,
    "b": -0.17599521577358,
    "C": 0.38232451677322,
    "h": 207.40837097168,
    "CMY_C": 0.39099460840225,
    "CMY_M": 0.38670444488525,
    "CMY_Y": 0.39154928922653,
    "CMYK_C": 0.00699526257813,
    "CMYK_M": 0,
    "CMYK_Y": 0.00789968948811,
    "CMYK_K": 0.38670444488525
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0741",
    "Farbtonhilfsbezeichnung": "99.00.27",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "165",
    "Bcolor": "163",
    "Y": 38,
    "L": 67.6041793823242,
    "a": -0.50531911849976,
    "b": 0.01757020503283,
    "C": 0.50562447309494,
    "h": 178.008590698242,
    "CMY_C": 0.35806554555893,
    "CMY_M": 0.35279041528702,
    "CMY_Y": 0.35957914590836,
    "CMYK_C": 0.0081505747512,
    "CMYK_M": 0,
    "CMYK_Y": 0.01048923097551,
    "CMYK_K": 0.35279041528702
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0742",
    "Farbtonhilfsbezeichnung": "99.00.33",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "149",
    "Bcolor": "148",
    "Y": 30,
    "L": 61.416259765625,
    "a": -0.26340767741203,
    "b": -0.36962658166885,
    "C": 0.45388039946556,
    "h": 234.525115966797,
    "CMY_C": 0.42167353630066,
    "CMY_M": 0.41748815774918,
    "CMY_Y": 0.42065060138702,
    "CMYK_C": 0.00718505308032,
    "CMYK_M": 0,
    "CMYK_Y": 0.00542897731066,
    "CMYK_K": 0.41748815774918
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0743",
    "Farbtonhilfsbezeichnung": "99.00.36",
    "Farbtonklasse": "01",
    "Rcolor": "134",
    "Gcolor": "135",
    "Bcolor": "135",
    "Y": 24,
    "L": 56.3558006286621,
    "a": -0.21506950259209,
    "b": -0.362518876791,
    "C": 0.42151492834091,
    "h": 239.320861816406,
    "CMY_C": 0.47282075881958,
    "CMY_M": 0.46920758485794,
    "CMY_Y": 0.47193330526352,
    "CMYK_C": 0.00680713169277,
    "CMYK_M": 0,
    "CMYK_Y": 0.00513519113883,
    "CMYK_K": 0.46920758485794
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0744",
    "Farbtonhilfsbezeichnung": "35.03.03",
    "Farbtonklasse": "01",
    "Y": 83,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0746",
    "Farbtonhilfsbezeichnung": "03.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "129",
    "Bcolor": "121",
    "Y": 22,
    "L": 54.1646270751953,
    "a": 0.02079618908465,
    "b": 4.28186225891113,
    "C": 4.2819128036499,
    "h": 89.7217254638672,
    "CMY_C": 0.47938215732574,
    "CMY_M": 0.49294835329056,
    "CMY_Y": 0.52477371692657,
    "CMYK_C": 0,
    "CMYK_M": 0.02605787664652,
    "CMYK_Y": 0.08718787133694,
    "CMYK_K": 0.47938215732574
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0747",
    "Farbtonhilfsbezeichnung": "03.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "106",
    "Bcolor": "99",
    "Y": 16,
    "L": 45.0799865722656,
    "a": 0.5135685801506,
    "b": 4.07194185256958,
    "C": 4.10420083999634,
    "h": 82.8115997314453,
    "CMY_C": 0.56675869226456,
    "CMY_M": 0.58349901437759,
    "CMY_Y": 0.61130672693253,
    "CMYK_C": 0,
    "CMYK_M": 0.03863971680403,
    "CMYK_Y": 0.10282499343157,
    "CMYK_K": 0.56675869226456
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0748",
    "Farbtonhilfsbezeichnung": "03.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "82",
    "Bcolor": "70",
    "Y": 10,
    "L": 35.1469802856445,
    "a": 0.89448976516724,
    "b": 7.6719822883606,
    "C": 7.72395133972168,
    "h": 83.3498077392578,
    "CMY_C": 0.65094763040543,
    "CMY_M": 0.67914509773254,
    "CMY_Y": 0.72584390640259,
    "CMYK_C": 0,
    "CMYK_M": 0.08078291267157,
    "CMYK_Y": 0.21457031369209,
    "CMYK_K": 0.65094763040543
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0749",
    "Farbtonhilfsbezeichnung": "03.03.30",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "65",
    "Bcolor": "53",
    "Y": 7,
    "L": 27.8043117523193,
    "a": 0.37659966945648,
    "b": 7.89591455459595,
    "C": 7.90489053726196,
    "h": 87.2693176269531,
    "CMY_C": 0.72163999080658,
    "CMY_M": 0.74483525753021,
    "CMY_Y": 0.79176634550095,
    "CMYK_C": 0,
    "CMYK_M": 0.08332829922438,
    "CMYK_Y": 0.25192683935165,
    "CMYK_K": 0.72163999080658
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0750",
    "Farbtonhilfsbezeichnung": "03.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "126",
    "Bcolor": "104",
    "Y": 21,
    "L": 53.4257164001465,
    "a": 1.51931643486023,
    "b": 13.2787675857544,
    "C": 13.365403175354,
    "h": 83.472770690918,
    "CMY_C": 0.45449030399323,
    "CMY_M": 0.50559890270233,
    "CMY_Y": 0.59187108278275,
    "CMYK_C": 0,
    "CMYK_M": 0.09368962794542,
    "CMYK_Y": 0.2518393099308,
    "CMYK_K": 0.45449030399323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0751",
    "Farbtonhilfsbezeichnung": "03.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "103",
    "Bcolor": "85",
    "Y": 13,
    "L": 44.2937812805176,
    "a": 2.05056023597717,
    "b": 11.6583395004273,
    "C": 11.8373003005981,
    "h": 80.0243988037109,
    "CMY_C": 0.54674249887466,
    "CMY_M": 0.59596955776215,
    "CMY_Y": 0.66742610931396,
    "CMYK_C": 0,
    "CMYK_M": 0.10860726982355,
    "CMYK_Y": 0.26625838875771,
    "CMYK_K": 0.54674249887466
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0752",
    "Farbtonhilfsbezeichnung": "03.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "90",
    "Bcolor": "77",
    "Y": 10,
    "L": 38.7458419799805,
    "a": 1.1721099615097,
    "b": 8.32235145568848,
    "C": 8.40448570251465,
    "h": 81.9832611083984,
    "CMY_C": 0.61352974176407,
    "CMY_M": 0.64626467227936,
    "CMY_Y": 0.69730854034424,
    "CMYK_C": 0,
    "CMYK_M": 0.08470232784748,
    "CMYK_Y": 0.21677942574024,
    "CMYK_K": 0.61352974176407
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0753",
    "Farbtonhilfsbezeichnung": "03.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "74",
    "Bcolor": "67",
    "Y": 6,
    "L": 31.3158550262451,
    "a": 0.00578413298354,
    "b": 3.83148121833801,
    "C": 3.83148550987244,
    "h": 89.9135055541992,
    "CMY_C": 0.70093274116516,
    "CMY_M": 0.71171933412552,
    "CMY_Y": 0.73668885231018,
    "CMYK_C": 0,
    "CMYK_M": 0.03606744855642,
    "CMYK_Y": 0.11955875903368,
    "CMYK_K": 0.70093274116516
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0754",
    "Farbtonhilfsbezeichnung": "03.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "127",
    "Bcolor": "92",
    "Y": 22,
    "L": 54.4205589294434,
    "a": 3.07252502441406,
    "b": 21.6572380065918,
    "C": 21.8741035461426,
    "h": 81.9253005981445,
    "CMY_C": 0.41778999567032,
    "CMY_M": 0.50072455406189,
    "CMY_Y": 0.63879430294037,
    "CMYK_C": 0,
    "CMYK_M": 0.14244784414768,
    "CMYK_Y": 0.37959551811218,
    "CMYK_K": 0.41778999567032
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0755",
    "Farbtonhilfsbezeichnung": "03.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "98",
    "Bcolor": "67",
    "Y": 15,
    "L": 42.7117004394531,
    "a": 3.85795855522156,
    "b": 20.4622497558594,
    "C": 20.8227634429932,
    "h": 79.3227767944336,
    "CMY_C": 0.53587728738785,
    "CMY_M": 0.61663317680359,
    "CMY_Y": 0.73896545171738,
    "CMYK_C": 0,
    "CMYK_M": 0.1739968508482,
    "CMYK_Y": 0.43757429718971,
    "CMYK_K": 0.53587728738785
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0756",
    "Farbtonhilfsbezeichnung": "03.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "85",
    "Bcolor": "62",
    "Y": 9,
    "L": 36.9082298278809,
    "a": 1.47347974777222,
    "b": 14.9988965988159,
    "C": 15.071099281311,
    "h": 84.3893127441406,
    "CMY_C": 0.61627960205078,
    "CMY_M": 0.66534376144409,
    "CMY_Y": 0.75592613220215,
    "CMYK_C": 0,
    "CMYK_M": 0.12786434590816,
    "CMYK_Y": 0.3639278113842,
    "CMYK_K": 0.61627960205078
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0757",
    "Farbtonhilfsbezeichnung": "03.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "122",
    "Bcolor": "70",
    "Y": 20,
    "L": 52.8526649475098,
    "a": 5.32088232040405,
    "b": 32.0115661621094,
    "C": 32.4507637023926,
    "h": 80.5627136230469,
    "CMY_C": 0.40508669614792,
    "CMY_M": 0.5231100320816,
    "CMY_Y": 0.72517800331116,
    "CMYK_C": 0,
    "CMYK_M": 0.19838745892048,
    "CMYK_Y": 0.53804695606232,
    "CMYK_K": 0.40508669614792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0758",
    "Farbtonhilfsbezeichnung": "03.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "102",
    "Bcolor": "64",
    "Y": 13,
    "L": 44.4360656738281,
    "a": 3.30301189422607,
    "b": 24.5194473266602,
    "C": 24.7409210205078,
    "h": 82.3278732299805,
    "CMY_C": 0.51544535160065,
    "CMY_M": 0.59956008195877,
    "CMY_Y": 0.75061643123627,
    "CMYK_C": 0,
    "CMYK_M": 0.17359183728695,
    "CMYK_Y": 0.48533448576927,
    "CMYK_K": 0.51544535160065
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0759",
    "Farbtonhilfsbezeichnung": "03.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "146",
    "Bcolor": "49",
    "Y": 30,
    "L": 62.8488540649414,
    "a": 5.84720611572266,
    "b": 54.1937294006348,
    "C": 54.5082588195801,
    "h": 83.841926574707,
    "CMY_C": 0.26709628105164,
    "CMY_M": 0.42648470401764,
    "CMY_Y": 0.80737525224686,
    "CMYK_C": 0,
    "CMYK_M": 0.21747525036335,
    "CMYK_Y": 0.73717594146729,
    "CMYK_K": 0.26709628105164
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0760",
    "Farbtonhilfsbezeichnung": "03.15.24",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "128",
    "Bcolor": "42",
    "Y": 25,
    "L": 55.9225540161133,
    "a": 6.02239370346069,
    "b": 49.6809272766113,
    "C": 50.0446166992188,
    "h": 83.088249206543,
    "CMY_C": 0.34850907325745,
    "CMY_M": 0.49636405706406,
    "CMY_Y": 0.83622407913208,
    "CMYK_C": 0,
    "CMYK_M": 0.22694864869118,
    "CMYK_Y": 0.74861365556717,
    "CMYK_K": 0.34850907325745
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0761",
    "Farbtonhilfsbezeichnung": "06.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "131",
    "Bcolor": "112",
    "Y": 23,
    "L": 55.4978485107422,
    "a": 2.44537234306335,
    "b": 11.4144697189331,
    "C": 11.67347240448,
    "h": 77.9080505371094,
    "CMY_C": 0.431371986866,
    "CMY_M": 0.48649120330811,
    "CMY_Y": 0.55914658308029,
    "CMYK_C": 0,
    "CMYK_M": 0.09693370014429,
    "CMYK_Y": 0.22470682859421,
    "CMYK_K": 0.431371986866
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0762",
    "Farbtonhilfsbezeichnung": "06.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "95",
    "Bcolor": "82",
    "Y": 11,
    "L": 41.2165679931641,
    "a": 2.69335412979126,
    "b": 9.23299789428711,
    "C": 9.61781692504883,
    "h": 73.7375259399414,
    "CMY_C": 0.57823610305786,
    "CMY_M": 0.62627470493317,
    "CMY_Y": 0.68020939826965,
    "CMYK_C": 0,
    "CMYK_M": 0.11389927566051,
    "CMYK_Y": 0.24177815020084,
    "CMYK_K": 0.57823610305786
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0763",
    "Farbtonhilfsbezeichnung": "06.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "75",
    "Bcolor": "68",
    "Y": 6,
    "L": 32.3847579956055,
    "a": 1.41430294513702,
    "b": 4.75965404510498,
    "C": 4.96533584594727,
    "h": 73.4509963989258,
    "CMY_C": 0.68020325899124,
    "CMY_M": 0.70496279001236,
    "CMY_Y": 0.7326158285141,
    "CMYK_C": 0,
    "CMYK_M": 0.07742271572351,
    "CMYK_Y": 0.16389338672161,
    "CMYK_K": 0.68020325899124
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0764",
    "Farbtonhilfsbezeichnung": "06.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "117",
    "Bcolor": "82",
    "Y": 18,
    "L": 50.8779335021973,
    "a": 5.12083768844604,
    "b": 22.6384811401367,
    "C": 23.2104244232178,
    "h": 77.2541580200195,
    "CMY_C": 0.44085448980331,
    "CMY_M": 0.54067051410675,
    "CMY_Y": 0.67839062213898,
    "CMYK_C": 0,
    "CMYK_M": 0.17851528525352,
    "CMYK_Y": 0.42481988668442,
    "CMYK_K": 0.44085448980331
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0765",
    "Farbtonhilfsbezeichnung": "06.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "100",
    "Bcolor": "73",
    "Y": 13,
    "L": 43.4765701293945,
    "a": 4.20361948013306,
    "b": 17.6059093475342,
    "C": 18.1007862091064,
    "h": 76.5713653564453,
    "CMY_C": 0.5307639837265,
    "CMY_M": 0.60959923267365,
    "CMY_Y": 0.71322590112686,
    "CMYK_C": 0,
    "CMYK_M": 0.16800767183304,
    "CMYK_Y": 0.38884893059731,
    "CMYK_K": 0.5307639837265
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0766",
    "Farbtonhilfsbezeichnung": "06.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "89",
    "Bcolor": "66",
    "Y": 10,
    "L": 38.8484230041504,
    "a": 2.7724666595459,
    "b": 15.531343460083,
    "C": 15.7768564224243,
    "h": 79.8788604736328,
    "CMY_C": 0.58882367610931,
    "CMY_M": 0.65001010894775,
    "CMY_Y": 0.74182599782944,
    "CMYK_C": 0,
    "CMYK_M": 0.14880825579166,
    "CMYK_Y": 0.3721087872982,
    "CMYK_K": 0.58882367610931
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0767",
    "Farbtonhilfsbezeichnung": "06.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "126",
    "Bcolor": "71",
    "Y": 23,
    "L": 55.5988807678223,
    "a": 9.19196128845215,
    "b": 35.1704521179199,
    "C": 36.3517913818359,
    "h": 75.3531036376953,
    "CMY_C": 0.34888029098511,
    "CMY_M": 0.5054544210434,
    "CMY_Y": 0.72132968902588,
    "CMYK_C": 0,
    "CMYK_M": 0.24046903848648,
    "CMYK_Y": 0.57201373577118,
    "CMYK_K": 0.34888029098511
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0768",
    "Farbtonhilfsbezeichnung": "06.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "105",
    "Bcolor": "67",
    "Y": 15,
    "L": 46.4706115722656,
    "a": 6.29504728317261,
    "b": 25.5443439483643,
    "C": 26.3085746765137,
    "h": 76.1561050415039,
    "CMY_C": 0.47578257322311,
    "CMY_M": 0.58682560920715,
    "CMY_Y": 0.73846405744553,
    "CMYK_C": 0,
    "CMYK_M": 0.21182629466057,
    "CMYK_Y": 0.50109261274338,
    "CMYK_K": 0.47578257322311
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0769",
    "Farbtonhilfsbezeichnung": "06.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "123",
    "Bcolor": "57",
    "Y": 21,
    "L": 54.1643371582031,
    "a": 8.17591571807861,
    "b": 40.7123794555664,
    "C": 41.5252151489258,
    "h": 78.6448287963867,
    "CMY_C": 0.36430096626282,
    "CMY_M": 0.51799488067627,
    "CMY_Y": 0.77675026655197,
    "CMYK_C": 0,
    "CMYK_M": 0.24177150428295,
    "CMYK_Y": 0.6488122344017,
    "CMYK_K": 0.36430096626282
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0770",
    "Farbtonhilfsbezeichnung": "09.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "106",
    "Bcolor": "93",
    "Y": 16,
    "L": 45.5460357666016,
    "a": 2.62249732017517,
    "b": 8.29504585266113,
    "C": 8.69972896575928,
    "h": 72.4555358886719,
    "CMY_C": 0.53810781240463,
    "CMY_M": 0.58440369367599,
    "CMY_Y": 0.63387137651443,
    "CMYK_C": 0,
    "CMYK_M": 0.10023092478514,
    "CMYK_Y": 0.20732882618904,
    "CMYK_K": 0.53810781240463
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0771",
    "Farbtonhilfsbezeichnung": "09.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "86",
    "Bcolor": "74",
    "Y": 9,
    "L": 37.5549583435059,
    "a": 2.80531930923462,
    "b": 8.40637016296387,
    "C": 8.86210346221924,
    "h": 71.5454483032227,
    "CMY_C": 0.61485004425049,
    "CMY_M": 0.66083896160126,
    "CMY_Y": 0.70842987298965,
    "CMYK_C": 0,
    "CMYK_M": 0.11940522491932,
    "CMYK_Y": 0.24296985566616,
    "CMYK_K": 0.61485004425049
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0772",
    "Farbtonhilfsbezeichnung": "09.06.27",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "60",
    "Bcolor": "51",
    "Y": 6,
    "L": 25.8351421356201,
    "a": 0.82323902845383,
    "b": 6.29955339431763,
    "C": 6.35311698913574,
    "h": 82.5546569824219,
    "CMY_C": 0.74012303352356,
    "CMY_M": 0.76281750202179,
    "CMY_Y": 0.79909354448318,
    "CMYK_C": 0,
    "CMYK_M": 0.08732774108648,
    "CMYK_Y": 0.22691704332829,
    "CMYK_K": 0.74012303352356
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0773",
    "Farbtonhilfsbezeichnung": "09.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "109",
    "Bcolor": "70",
    "Y": 18,
    "L": 47.9973907470703,
    "a": 7.29101896286011,
    "b": 25.6693592071533,
    "C": 26.6847324371338,
    "h": 74.1435546875,
    "CMY_C": 0.45390796661377,
    "CMY_M": 0.57435685396194,
    "CMY_Y": 0.72515797615051,
    "CMYK_C": 0,
    "CMYK_M": 0.22056518495083,
    "CMYK_Y": 0.49671116471291,
    "CMYK_K": 0.45390796661377
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0774",
    "Farbtonhilfsbezeichnung": "09.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "87",
    "Bcolor": "68",
    "Y": 10,
    "L": 38.2336235046387,
    "a": 3.94173169136047,
    "b": 13.266279220581,
    "C": 13.8394870758057,
    "h": 73.4520492553711,
    "CMY_C": 0.59206414222717,
    "CMY_M": 0.65785825252533,
    "CMY_Y": 0.73271811008453,
    "CMYK_C": 0,
    "CMYK_M": 0.16128543019295,
    "CMYK_Y": 0.34479433298111,
    "CMYK_K": 0.59206414222717
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0775",
    "Farbtonhilfsbezeichnung": "09.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "115",
    "Bcolor": "66",
    "Y": 19,
    "L": 51.1523323059082,
    "a": 9.77376365661621,
    "b": 32.0955009460449,
    "C": 33.5506744384766,
    "h": 73.0633850097656,
    "CMY_C": 0.39782321453094,
    "CMY_M": 0.55044007301331,
    "CMY_Y": 0.74034035205841,
    "CMYK_C": 0,
    "CMYK_M": 0.25344195961952,
    "CMYK_Y": 0.56879830360413,
    "CMYK_K": 0.39782321453094
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0776",
    "Farbtonhilfsbezeichnung": "09.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "101",
    "Bcolor": "69",
    "Y": 14,
    "L": 44.9951324462891,
    "a": 7.76913261413574,
    "b": 22.1474056243896,
    "C": 23.4705562591553,
    "h": 70.6695327758789,
    "CMY_C": 0.48758149147034,
    "CMY_M": 0.60390383005142,
    "CMY_Y": 0.72867518663406,
    "CMYK_C": 0,
    "CMYK_M": 0.22700650990009,
    "CMYK_Y": 0.47050154209137,
    "CMYK_K": 0.48758149147034
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0777",
    "Farbtonhilfsbezeichnung": "12.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "126",
    "Bcolor": "111",
    "Y": 21,
    "L": 54.1909141540527,
    "a": 4.92428255081177,
    "b": 10.1166219711304,
    "C": 11.2514266967773,
    "h": 64.0454177856445,
    "CMY_C": 0.43179279565811,
    "CMY_M": 0.50487780570984,
    "CMY_Y": 0.56277233362198,
    "CMYK_C": 0,
    "CMYK_M": 0.12862387299538,
    "CMYK_Y": 0.23051369190216,
    "CMYK_K": 0.43179279565811
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0778",
    "Farbtonhilfsbezeichnung": "12.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "102",
    "Bcolor": "89",
    "Y": 13,
    "L": 44.593391418457,
    "a": 4.84716892242432,
    "b": 9.55963516235352,
    "C": 10.7182865142822,
    "h": 63.112922668457,
    "CMY_C": 0.53098511695862,
    "CMY_M": 0.5987321138382,
    "CMY_Y": 0.65065068006516,
    "CMYK_C": 0,
    "CMYK_M": 0.14444530010223,
    "CMYK_Y": 0.25514236092567,
    "CMYK_K": 0.53098511695862
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0779",
    "Farbtonhilfsbezeichnung": "12.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "118",
    "Bcolor": "94",
    "Y": 19,
    "L": 52.1247444152832,
    "a": 8.91109180450439,
    "b": 17.7942352294922,
    "C": 19.9008140563965,
    "h": 63.3989639282227,
    "CMY_C": 0.41337025165558,
    "CMY_M": 0.53634285926819,
    "CMY_Y": 0.63328504562378,
    "CMYK_C": 0,
    "CMYK_M": 0.20962558686733,
    "CMYK_Y": 0.37487834692001,
    "CMYK_K": 0.41337025165558
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0780",
    "Farbtonhilfsbezeichnung": "12.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "101",
    "Bcolor": "78",
    "Y": 13,
    "L": 44.6790199279785,
    "a": 7.57432842254639,
    "b": 16.3324031829834,
    "C": 18.0032730102539,
    "h": 65.1199798583984,
    "CMY_C": 0.50107449293137,
    "CMY_M": 0.60545432567596,
    "CMY_Y": 0.69330286979675,
    "CMYK_C": 0,
    "CMYK_M": 0.20920924842358,
    "CMYK_Y": 0.38528472185135,
    "CMYK_K": 0.50107449293137
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0781",
    "Farbtonhilfsbezeichnung": "12.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "86",
    "Bcolor": "69",
    "Y": 10,
    "L": 38.5286979675293,
    "a": 6.9245400428772,
    "b": 13.1450862884522,
    "C": 14.8574075698853,
    "h": 62.2207336425781,
    "CMY_C": 0.5722593665123,
    "CMY_M": 0.66164898872375,
    "CMY_Y": 0.72880482673645,
    "CMYK_C": 0,
    "CMYK_M": 0.20898090302944,
    "CMYK_Y": 0.36598220467567,
    "CMYK_K": 0.5722593665123
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0782",
    "Farbtonhilfsbezeichnung": "12.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "63",
    "Bcolor": "53",
    "Y": 6,
    "L": 28.2594985961914,
    "a": 6.09014129638672,
    "b": 9.00496673583984,
    "C": 10.8710279464722,
    "h": 55.9291496276855,
    "CMY_C": 0.68334627151489,
    "CMY_M": 0.75265562534332,
    "CMY_Y": 0.79365223646164,
    "CMYK_C": 0,
    "CMYK_M": 0.2188805937767,
    "CMYK_Y": 0.34834885597229,
    "CMYK_K": 0.68334627151489
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0783",
    "Farbtonhilfsbezeichnung": "12.09.33",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "38",
    "Bcolor": "39",
    "Y": 4,
    "L": 15.6206960678101,
    "a": 1.42749726772308,
    "b": -0.22253248095512,
    "C": 1.44473838806152,
    "h": 351.139465332031,
    "CMY_C": 0.83950400352478,
    "CMY_M": 0.84954875707626,
    "CMY_Y": 0.84731829166412,
    "CMYK_C": 0,
    "CMYK_M": 0.06258569657803,
    "CMYK_Y": 0.04868836700916,
    "CMYK_K": 0.83950400352478
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0784",
    "Farbtonhilfsbezeichnung": "12.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "113",
    "Bcolor": "76",
    "Y": 19,
    "L": 51.2910842895508,
    "a": 12.4778928756714,
    "b": 26.8599014282227,
    "C": 29.6167545318604,
    "h": 65.0825576782227,
    "CMY_C": 0.38771241903305,
    "CMY_M": 0.55497115850449,
    "CMY_Y": 0.70178186893463,
    "CMYK_C": 0,
    "CMYK_M": 0.27317023277283,
    "CMYK_Y": 0.51294434070587,
    "CMYK_K": 0.38771241903305
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0785",
    "Farbtonhilfsbezeichnung": "12.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "100",
    "Bcolor": "68",
    "Y": 15,
    "L": 45.6446304321289,
    "a": 11.7209053039551,
    "b": 23.6355247497559,
    "C": 26.3821468353271,
    "h": 63.6230888366699,
    "CMY_C": 0.45663219690323,
    "CMY_M": 0.6074138879776,
    "CMY_Y": 0.73185467720032,
    "CMYK_C": 0,
    "CMYK_M": 0.27749469876289,
    "CMYK_Y": 0.50651228427887,
    "CMYK_K": 0.45663219690323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0786",
    "Farbtonhilfsbezeichnung": "12.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "79",
    "Bcolor": "50",
    "Y": 11,
    "L": 37.0591239929199,
    "a": 11.9327096939087,
    "b": 22.9237861633301,
    "C": 25.8435592651367,
    "h": 62.501293182373,
    "CMY_C": 0.54608362913132,
    "CMY_M": 0.6888073682785,
    "CMY_Y": 0.80342179536819,
    "CMYK_C": 0,
    "CMYK_M": 0.31442737579346,
    "CMYK_Y": 0.56692856550217,
    "CMYK_K": 0.54608362913132
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0787",
    "Farbtonhilfsbezeichnung": "12.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "102",
    "Bcolor": "57",
    "Y": 18,
    "L": 48.3624114990234,
    "a": 17.6860771179199,
    "b": 33.789005279541,
    "C": 38.1378326416016,
    "h": 62.371223449707,
    "CMY_C": 0.38328832387924,
    "CMY_M": 0.5982551574707,
    "CMY_Y": 0.77568078041077,
    "CMYK_C": 0,
    "CMYK_M": 0.34856942296028,
    "CMYK_Y": 0.63626563549042,
    "CMYK_K": 0.38328832387924
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0788",
    "Farbtonhilfsbezeichnung": "12.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "93",
    "Bcolor": "60",
    "Y": 13,
    "L": 43.8795013427734,
    "a": 15.5082263946533,
    "b": 26.5053806304932,
    "C": 30.7089614868164,
    "h": 59.668212890625,
    "CMY_C": 0.45140892267227,
    "CMY_M": 0.63443160057068,
    "CMY_Y": 0.76613771915436,
    "CMYK_C": 0,
    "CMYK_M": 0.33362314105034,
    "CMYK_Y": 0.57370382547379,
    "CMYK_K": 0.45140892267227
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0789",
    "Farbtonhilfsbezeichnung": "12.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "113",
    "Bcolor": "53",
    "Y": 22,
    "L": 54.172420501709,
    "a": 22.2812671661377,
    "b": 43.2431564331055,
    "C": 48.6459197998047,
    "h": 62.7399711608887,
    "CMY_C": 0.28469479084015,
    "CMY_M": 0.55555284023285,
    "CMY_Y": 0.79115390777588,
    "CMYK_C": 0,
    "CMYK_M": 0.37866079807281,
    "CMYK_Y": 0.70803219079971,
    "CMYK_K": 0.28469479084015
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0790",
    "Farbtonhilfsbezeichnung": "15.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "135",
    "Bcolor": "121",
    "Y": 26,
    "L": 57.7766456604004,
    "a": 5.93284749984741,
    "b": 10.0201225280762,
    "C": 11.6448068618774,
    "h": 59.3705101013184,
    "CMY_C": 0.38825410604477,
    "CMY_M": 0.47114193439484,
    "CMY_Y": 0.52687501907349,
    "CMYK_C": 0,
    "CMYK_M": 0.13549388945103,
    "CMYK_Y": 0.22659884393215,
    "CMYK_K": 0.38825410604477
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0791",
    "Farbtonhilfsbezeichnung": "15.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "90",
    "Bcolor": "74",
    "Y": 13,
    "L": 40.5193672180176,
    "a": 9.41299343109131,
    "b": 13.2720308303833,
    "C": 16.2711791992188,
    "h": 54.6543846130371,
    "CMY_C": 0.53804528713226,
    "CMY_M": 0.64873337745667,
    "CMY_Y": 0.71122062206268,
    "CMYK_C": 0,
    "CMYK_M": 0.23960809409618,
    "CMYK_Y": 0.3748751282692,
    "CMYK_K": 0.53804528713226
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0792",
    "Farbtonhilfsbezeichnung": "15.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "82",
    "Bcolor": "74",
    "Y": 8,
    "L": 36.2654647827148,
    "a": 5.2745566368103,
    "b": 6.68185806274414,
    "C": 8.51282405853271,
    "h": 51.7129783630371,
    "CMY_C": 0.6162041425705,
    "CMY_M": 0.67774993181229,
    "CMY_Y": 0.70901727676392,
    "CMYK_C": 0,
    "CMYK_M": 0.16036073863506,
    "CMYK_Y": 0.24182942509651,
    "CMYK_K": 0.6162041425705
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0793",
    "Farbtonhilfsbezeichnung": "15.06.30",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "53",
    "Bcolor": "49",
    "Y": 6,
    "L": 23.9568023681641,
    "a": 7.88490581512451,
    "b": 5.51669406890869,
    "C": 9.62318325042725,
    "h": 34.9786567687988,
    "CMY_C": 0.71989774703979,
    "CMY_M": 0.79358106851578,
    "CMY_Y": 0.80951380729675,
    "CMYK_C": 0,
    "CMYK_M": 0.26305866241455,
    "CMYK_Y": 0.31994050741196,
    "CMYK_K": 0.71989774703979
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0794",
    "Farbtonhilfsbezeichnung": "15.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "120",
    "Bcolor": "99",
    "Y": 21,
    "L": 53.4683151245117,
    "a": 10.8733062744141,
    "b": 16.7269382476807,
    "C": 19.9504203796387,
    "h": 56.9742126464844,
    "CMY_C": 0.38937598466873,
    "CMY_M": 0.52759063243866,
    "CMY_Y": 0.61299991607666,
    "CMYK_C": 0,
    "CMYK_M": 0.2263498455286,
    "CMYK_Y": 0.36622196435928,
    "CMYK_K": 0.38937598466873
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0795",
    "Farbtonhilfsbezeichnung": "15.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "83",
    "Bcolor": "62",
    "Y": 13,
    "L": 38.893913269043,
    "a": 13.3563175201416,
    "b": 18.5081882476807,
    "C": 22.8242034912109,
    "h": 54.1841354370117,
    "CMY_C": 0.52515780925751,
    "CMY_M": 0.67458605766296,
    "CMY_Y": 0.75846672058105,
    "CMYK_C": 0,
    "CMYK_M": 0.31469032168388,
    "CMYK_Y": 0.49133989214897,
    "CMYK_K": 0.52515780925751
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0796",
    "Farbtonhilfsbezeichnung": "15.09.27",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "82",
    "Bcolor": "68",
    "Y": 9,
    "L": 36.8594818115234,
    "a": 8.4411563873291,
    "b": 11.3835973739624,
    "C": 14.1717824935913,
    "h": 53.4423522949219,
    "CMY_C": 0.58330905437469,
    "CMY_M": 0.68030679225922,
    "CMY_Y": 0.73244249820709,
    "CMYK_C": 0,
    "CMYK_M": 0.23278100788593,
    "CMYK_Y": 0.35789939761162,
    "CMYK_K": 0.58330905437469
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0797",
    "Farbtonhilfsbezeichnung": "15.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "66",
    "Bcolor": "54",
    "Y": 8,
    "L": 29.6009826660156,
    "a": 6.61097860336304,
    "b": 9.742919921875,
    "C": 11.7741041183472,
    "h": 55.8414688110352,
    "CMY_C": 0.6665872335434,
    "CMY_M": 0.74198132753372,
    "CMY_Y": 0.78646147251129,
    "CMYK_C": 0,
    "CMYK_M": 0.2261283993721,
    "CMYK_Y": 0.35953703522682,
    "CMYK_K": 0.6665872335434
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0798",
    "Farbtonhilfsbezeichnung": "15.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "114",
    "Bcolor": "80",
    "Y": 20,
    "L": 52.5938682556152,
    "a": 16.5637321472168,
    "b": 26.6979427337646,
    "C": 31.4187431335449,
    "h": 58.184024810791,
    "CMY_C": 0.35085040330887,
    "CMY_M": 0.5527263879776,
    "CMY_Y": 0.68760353326797,
    "CMYK_C": 0,
    "CMYK_M": 0.31098529696465,
    "CMYK_Y": 0.51876044273376,
    "CMYK_K": 0.35085040330887
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0799",
    "Farbtonhilfsbezeichnung": "15.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "82",
    "Bcolor": "53",
    "Y": 12,
    "L": 39.5800819396973,
    "a": 16.994722366333,
    "b": 24.574146270752,
    "C": 29.8782405853271,
    "h": 55.3334579467773,
    "CMY_C": 0.49167567491531,
    "CMY_M": 0.67869341373444,
    "CMY_Y": 0.79098254442215,
    "CMYK_C": 0,
    "CMYK_M": 0.36791026592255,
    "CMYK_Y": 0.58881086111069,
    "CMYK_K": 0.49167567491531
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0800",
    "Farbtonhilfsbezeichnung": "15.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "74",
    "Bcolor": "51",
    "Y": 10,
    "L": 35.3280220031738,
    "a": 14.2628536224365,
    "b": 20.0565547943115,
    "C": 24.6108589172363,
    "h": 54.5821571350098,
    "CMY_C": 0.55522811412811,
    "CMY_M": 0.71017080545425,
    "CMY_Y": 0.79939115047455,
    "CMYK_C": 0,
    "CMYK_M": 0.34836441278458,
    "CMYK_Y": 0.54896241426468,
    "CMYK_K": 0.55522811412811
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0801",
    "Farbtonhilfsbezeichnung": "15.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "114",
    "Bcolor": "69",
    "Y": 21,
    "L": 53.5544624328613,
    "a": 20.063404083252,
    "b": 33.8532829284668,
    "C": 39.3520622253418,
    "h": 59.3465766906738,
    "CMY_C": 0.31249672174454,
    "CMY_M": 0.55400419235229,
    "CMY_Y": 0.72775399684906,
    "CMYK_C": 0,
    "CMYK_M": 0.35128191113472,
    "CMYK_Y": 0.60400772094727,
    "CMYK_K": 0.31249672174454
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0802",
    "Farbtonhilfsbezeichnung": "15.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "92",
    "Bcolor": "59",
    "Y": 13,
    "L": 44.4320373535156,
    "a": 18.8315582275391,
    "b": 27.4637222290039,
    "C": 33.2999038696289,
    "h": 55.5620155334473,
    "CMY_C": 0.42689049243927,
    "CMY_M": 0.63828837871552,
    "CMY_Y": 0.76680064201355,
    "CMYK_C": 0,
    "CMYK_M": 0.36886125802994,
    "CMYK_Y": 0.59309810400009,
    "CMYK_K": 0.42689049243927
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0803",
    "Farbtonhilfsbezeichnung": "15.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "112",
    "Bcolor": "62",
    "Y": 21,
    "L": 53.9305801391602,
    "a": 23.073299407959,
    "b": 38.5190811157227,
    "C": 44.9009666442871,
    "h": 59.0779876708984,
    "CMY_C": 0.2874031662941,
    "CMY_M": 0.55963063240051,
    "CMY_Y": 0.75715851783752,
    "CMYK_C": 0,
    "CMYK_M": 0.38202172517776,
    "CMYK_Y": 0.6592161655426,
    "CMYK_K": 0.2874031662941
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0804",
    "Farbtonhilfsbezeichnung": "18.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "126",
    "Bcolor": "121",
    "Y": 21,
    "L": 53.4702796936035,
    "a": 3.18747401237488,
    "b": 3.49684715270996,
    "C": 4.73158836364746,
    "h": 47.6499557495117,
    "CMY_C": 0.46694886684418,
    "CMY_M": 0.50660365819931,
    "CMY_Y": 0.52596336603165,
    "CMYK_C": 0,
    "CMYK_M": 0.07439209520817,
    "CMYK_Y": 0.11071076244116,
    "CMYK_K": 0.46694886684418
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0805",
    "Farbtonhilfsbezeichnung": "18.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "103",
    "Bcolor": "99",
    "Y": 14,
    "L": 44.4390182495117,
    "a": 3.76689577102661,
    "b": 2.96850275993347,
    "C": 4.79598903656006,
    "h": 38.2398834228516,
    "CMY_C": 0.55466723442078,
    "CMY_M": 0.59634745121002,
    "CMY_Y": 0.60988545417786,
    "CMYK_C": 0,
    "CMYK_M": 0.09359341859818,
    "CMYK_Y": 0.12399316579103,
    "CMYK_K": 0.55466723442078
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0806",
    "Farbtonhilfsbezeichnung": "18.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "85",
    "Bcolor": "82",
    "Y": 9,
    "L": 37.111385345459,
    "a": 3.85339117050171,
    "b": 2.69616675376892,
    "C": 4.70297145843506,
    "h": 34.9799728393555,
    "CMY_C": 0.6257187128067,
    "CMY_M": 0.66593724489212,
    "CMY_Y": 0.67676246166229,
    "CMYK_C": 0,
    "CMYK_M": 0.10745536535978,
    "CMYK_Y": 0.1363780349493,
    "CMYK_K": 0.6257187128067
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0807",
    "Farbtonhilfsbezeichnung": "18.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "72",
    "Bcolor": "70",
    "Y": 6,
    "L": 31.1669883728027,
    "a": 3.00522208213806,
    "b": 2.09621572494507,
    "C": 3.6640796661377,
    "h": 34.8967132568359,
    "CMY_C": 0.68814241886139,
    "CMY_M": 0.71866118907928,
    "CMY_Y": 0.72717094421387,
    "CMYK_C": 0,
    "CMYK_M": 0.09786124527454,
    "CMYK_Y": 0.12514854967594,
    "CMYK_K": 0.68814241886139
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0808",
    "Farbtonhilfsbezeichnung": "18.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "119",
    "Bcolor": "101",
    "Y": 21,
    "L": 53.158130645752,
    "a": 12.5820913314819,
    "b": 15.2517032623291,
    "C": 19.771785736084,
    "h": 50.478630065918,
    "CMY_C": 0.38518619537354,
    "CMY_M": 0.53461170196533,
    "CMY_Y": 0.60577797889709,
    "CMYK_C": 0,
    "CMYK_M": 0.24304188787937,
    "CMYK_Y": 0.35879445075989,
    "CMYK_K": 0.38518619537354
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0809",
    "Farbtonhilfsbezeichnung": "18.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "102",
    "Bcolor": "84",
    "Y": 15,
    "L": 46.8329734802246,
    "a": 13.4771003723145,
    "b": 16.0400810241699,
    "C": 20.9503326416016,
    "h": 49.9625549316406,
    "CMY_C": 0.44550359249115,
    "CMY_M": 0.59896111488342,
    "CMY_Y": 0.67042756080627,
    "CMYK_C": 0,
    "CMYK_M": 0.27675116062164,
    "CMYK_Y": 0.40563648939133,
    "CMYK_K": 0.44550359249115
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0810",
    "Farbtonhilfsbezeichnung": "18.09.27",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "63",
    "Bcolor": "50",
    "Y": 8,
    "L": 29.9353809356689,
    "a": 12.0419797897339,
    "b": 13.2750692367554,
    "C": 17.9230785369873,
    "h": 47.7884407043457,
    "CMY_C": 0.62946766614914,
    "CMY_M": 0.75225341320038,
    "CMY_Y": 0.80401945114136,
    "CMYK_C": 0,
    "CMYK_M": 0.33137661218643,
    "CMYK_Y": 0.47108381986618,
    "CMYK_K": 0.62946766614914
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0811",
    "Farbtonhilfsbezeichnung": "18.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "117",
    "Bcolor": "90",
    "Y": 22,
    "L": 54.1022148132324,
    "a": 17.7517604827881,
    "b": 23.0143585205078,
    "C": 29.0651969909668,
    "h": 52.355770111084,
    "CMY_C": 0.33267402648926,
    "CMY_M": 0.5403214097023,
    "CMY_Y": 0.64805948734283,
    "CMYK_C": 0,
    "CMYK_M": 0.31116333603859,
    "CMYK_Y": 0.47261080145836,
    "CMYK_K": 0.33267402648926
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0812",
    "Farbtonhilfsbezeichnung": "18.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "94",
    "Bcolor": "71",
    "Y": 14,
    "L": 44.8327369689941,
    "a": 18.3495006561279,
    "b": 21.2252864837646,
    "C": 28.0573863983154,
    "h": 49.1562118530273,
    "CMY_C": 0.43247038125992,
    "CMY_M": 0.63205349445343,
    "CMY_Y": 0.72176861763,
    "CMYK_C": 0,
    "CMYK_M": 0.35166993737221,
    "CMYK_Y": 0.50975000858307,
    "CMYK_K": 0.43247038125992
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0813",
    "Farbtonhilfsbezeichnung": "18.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "79",
    "Bcolor": "63",
    "Y": 10,
    "L": 38.222354888916,
    "a": 16.459264755249,
    "b": 17.0428142547607,
    "C": 23.6931400299072,
    "h": 45.9978942871094,
    "CMY_C": 0.51772856712341,
    "CMY_M": 0.68863129615784,
    "CMY_Y": 0.75444757938385,
    "CMYK_C": 0,
    "CMYK_M": 0.35437041521072,
    "CMYK_Y": 0.49084186553955,
    "CMYK_K": 0.51772856712341
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0814",
    "Farbtonhilfsbezeichnung": "18.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "92",
    "Bcolor": "55",
    "Y": 17,
    "L": 46.8172340393066,
    "a": 26.9625282287598,
    "b": 33.5674476623535,
    "C": 43.0552139282227,
    "h": 51.2273712158203,
    "CMY_C": 0.35264664888382,
    "CMY_M": 0.64044737815857,
    "CMY_Y": 0.78509342670441,
    "CMYK_C": 0,
    "CMYK_M": 0.44458058476448,
    "CMYK_Y": 0.66802275180817,
    "CMYK_K": 0.35264664888382
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0815",
    "Farbtonhilfsbezeichnung": "18.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "87",
    "Bcolor": "65",
    "Y": 13,
    "L": 43.9367942810059,
    "a": 24.3335151672363,
    "b": 23.9857177734375,
    "C": 34.1677436828613,
    "h": 44.5875968933105,
    "CMY_C": 0.40759253501892,
    "CMY_M": 0.65843063592911,
    "CMY_Y": 0.74660390615463,
    "CMYK_C": 0,
    "CMYK_M": 0.42342156171799,
    "CMYK_Y": 0.5722604393959,
    "CMYK_K": 0.40759253501892
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0816",
    "Farbtonhilfsbezeichnung": "18.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "110",
    "Bcolor": "73",
    "Y": 20,
    "L": 52.6970748901367,
    "a": 22.1703929901123,
    "b": 31.0080318450928,
    "C": 38.1185569763184,
    "h": 54.4356575012207,
    "CMY_C": 0.31385415792465,
    "CMY_M": 0.56803506612778,
    "CMY_Y": 0.71502608060837,
    "CMYK_C": 0,
    "CMYK_M": 0.37044733762741,
    "CMYK_Y": 0.58467441797256,
    "CMYK_K": 0.31385415792465
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0817",
    "Farbtonhilfsbezeichnung": "18.24.21",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "111",
    "Bcolor": "21",
    "Y": 28,
    "L": 58.0612106323242,
    "a": 36.1676406860352,
    "b": 61.3516426086426,
    "C": 71.2188339233398,
    "h": 59.4800605773926,
    "CMY_C": 0.15454059839249,
    "CMY_M": 0.56347358226776,
    "CMY_Y": 0.91944181919098,
    "CMYK_C": 0,
    "CMYK_M": 0.48368141055107,
    "CMYK_Y": 0.90471667051315,
    "CMYK_K": 0.15454059839249
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0818",
    "Farbtonhilfsbezeichnung": "21.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "120",
    "Bcolor": "107",
    "Y": 21,
    "L": 53.7407341003418,
    "a": 12.986102104187,
    "b": 12.4937372207642,
    "C": 18.0203304290771,
    "h": 43.8929710388184,
    "CMY_C": 0.38172751665115,
    "CMY_M": 0.52924346923828,
    "CMY_Y": 0.58170807361603,
    "CMYK_C": 0,
    "CMYK_M": 0.23859375715256,
    "CMYK_Y": 0.32345053553581,
    "CMYK_K": 0.38172751665115
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0819",
    "Farbtonhilfsbezeichnung": "21.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "80",
    "Bcolor": "66",
    "Y": 12,
    "L": 38.4116096496582,
    "a": 16.1598243713379,
    "b": 15.0219841003418,
    "C": 22.0635433197021,
    "h": 42.9101753234863,
    "CMY_C": 0.52010917663574,
    "CMY_M": 0.68568110466003,
    "CMY_Y": 0.7400506734848,
    "CMYK_C": 0,
    "CMYK_M": 0.34501999616623,
    "CMYK_Y": 0.45831570029259,
    "CMYK_K": 0.52010917663574
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0820",
    "Farbtonhilfsbezeichnung": "21.09.27",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "54",
    "Bcolor": "48",
    "Y": 7,
    "L": 27.77512550354,
    "a": 18.8085556030273,
    "b": 11.7160034179688,
    "C": 22.1591186523438,
    "h": 31.919116973877,
    "CMY_C": 0.61945974826813,
    "CMY_M": 0.78911250829697,
    "CMY_Y": 0.81176310777664,
    "CMYK_C": 0,
    "CMYK_M": 0.44582080841064,
    "CMYK_Y": 0.50534301996231,
    "CMYK_K": 0.61945974826813
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0821",
    "Farbtonhilfsbezeichnung": "21.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "112",
    "Bcolor": "91",
    "Y": 21,
    "L": 53.767650604248,
    "a": 23.5469055175781,
    "b": 22.1095600128174,
    "C": 32.299991607666,
    "h": 43.1968231201172,
    "CMY_C": 0.30538129806519,
    "CMY_M": 0.55981087684631,
    "CMY_Y": 0.64382952451706,
    "CMYK_C": 0,
    "CMYK_M": 0.36628669500351,
    "CMYK_Y": 0.48724317550659,
    "CMYK_K": 0.30538129806519
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0822",
    "Farbtonhilfsbezeichnung": "21.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "77",
    "Bcolor": "55",
    "Y": 13,
    "L": 40.3264274597168,
    "a": 26.083402633667,
    "b": 24.793815612793,
    "C": 35.9871826171875,
    "h": 43.5480346679688,
    "CMY_C": 0.43755286931992,
    "CMY_M": 0.69842225313187,
    "CMY_Y": 0.78349047899246,
    "CMYK_C": 0,
    "CMYK_M": 0.46381139755249,
    "CMYK_Y": 0.61505800485611,
    "CMYK_K": 0.43755286931992
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0823",
    "Farbtonhilfsbezeichnung": "21.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "76",
    "Bcolor": "66",
    "Y": 9,
    "L": 36.976978302002,
    "a": 17.2224597930908,
    "b": 13.4672212600708,
    "C": 21.8627338409424,
    "h": 38.0238761901855,
    "CMY_C": 0.53154200315475,
    "CMY_M": 0.7015478014946,
    "CMY_Y": 0.74287569522858,
    "CMYK_C": 0,
    "CMYK_M": 0.36290511488914,
    "CMYK_Y": 0.45112624764442,
    "CMYK_K": 0.53154200315475
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0824",
    "Farbtonhilfsbezeichnung": "21.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "55",
    "Bcolor": "49",
    "Y": 8,
    "L": 29.1606044769287,
    "a": 21.0596599578857,
    "b": 12.8226709365845,
    "C": 24.6562404632568,
    "h": 31.3361320495606,
    "CMY_C": 0.59327745437622,
    "CMY_M": 0.78359913825989,
    "CMY_Y": 0.80618131160736,
    "CMYK_C": 0,
    "CMYK_M": 0.46793985366821,
    "CMYK_Y": 0.52346217632294,
    "CMYK_K": 0.59327745437622
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0825",
    "Farbtonhilfsbezeichnung": "21.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "102",
    "Bcolor": "77",
    "Y": 19,
    "L": 52.1612319946289,
    "a": 30.4331951141357,
    "b": 28.4270725250244,
    "C": 41.644660949707,
    "h": 43.0479545593262,
    "CMY_C": 0.2788901925087,
    "CMY_M": 0.59838032722473,
    "CMY_Y": 0.6999340057373,
    "CMYK_C": 0,
    "CMYK_M": 0.44305336475372,
    "CMYK_Y": 0.58388310670853,
    "CMYK_K": 0.2788901925087
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0826",
    "Farbtonhilfsbezeichnung": "21.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "87",
    "Bcolor": "70",
    "Y": 13,
    "L": 43.777717590332,
    "a": 24.2019920349121,
    "b": 20.5121116638184,
    "C": 31.725118637085,
    "h": 40.2825469970703,
    "CMY_C": 0.4140157699585,
    "CMY_M": 0.65889656543732,
    "CMY_Y": 0.72535568475723,
    "CMYK_C": 0,
    "CMYK_M": 0.41789656877518,
    "CMYK_Y": 0.53131109476089,
    "CMYK_K": 0.4140157699585
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0827",
    "Farbtonhilfsbezeichnung": "21.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "93",
    "Bcolor": "44",
    "Y": 23,
    "L": 53.134765625,
    "a": 42.5300140380859,
    "b": 47.8927993774414,
    "C": 64.0509338378906,
    "h": 48.394115447998,
    "CMY_C": 0.19001632928848,
    "CMY_M": 0.63613450527191,
    "CMY_Y": 0.82855021953583,
    "CMYK_C": 0,
    "CMYK_M": 0.55077427625656,
    "CMYK_Y": 0.78832936286926,
    "CMYK_K": 0.19001632928848
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0828",
    "Farbtonhilfsbezeichnung": "24.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "128",
    "Bcolor": "114",
    "Y": 24,
    "L": 55.6347336936294,
    "a": 7.93010562188856,
    "b": 10.7405313311927,
    "C": 13.3508647079745,
    "h": 0.93480298959906,
    "CMY_C": 0.3963375,
    "CMY_M": 0.4975963,
    "CMY_Y": 0.5524248,
    "CMYK_C": 0,
    "CMYK_M": 0.1677407,
    "CMYK_Y": 0.2585673,
    "CMYK_K": 0.3963375
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0829",
    "Farbtonhilfsbezeichnung": "24.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "104",
    "Bcolor": "97",
    "Y": 15,
    "L": 45.9682159423828,
    "a": 8.39790344238281,
    "b": 6.59707307815552,
    "C": 10.6792392730713,
    "h": 38.1518287658691,
    "CMY_C": 0.50192224979401,
    "CMY_M": 0.59289526939392,
    "CMY_Y": 0.61807143688202,
    "CMYK_C": 0,
    "CMYK_M": 0.18264822661877,
    "CMYK_Y": 0.23319488763809,
    "CMYK_K": 0.50192224979401
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0830",
    "Farbtonhilfsbezeichnung": "24.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "84",
    "Bcolor": "83",
    "Y": 9,
    "L": 37.7720222473145,
    "a": 8.73850059509277,
    "b": 3.45205450057983,
    "C": 9.3956413269043,
    "h": 21.5559864044189,
    "CMY_C": 0.58818161487579,
    "CMY_M": 0.67076694965363,
    "CMY_Y": 0.67473369836807,
    "CMYK_C": 0,
    "CMYK_M": 0.20053824782372,
    "CMYK_Y": 0.21017052233219,
    "CMYK_K": 0.58818161487579
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0831",
    "Farbtonhilfsbezeichnung": "24.06.30",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "46",
    "Bcolor": "49",
    "Y": 5,
    "L": 21.3926258087158,
    "a": 10.244794845581,
    "b": 1.74491488933563,
    "C": 10.3923311233521,
    "h": 9.66598033905029,
    "CMY_C": 0.73798990249634,
    "CMY_M": 0.82009100914001,
    "CMY_Y": 0.80928987264633,
    "CMYK_C": 0,
    "CMYK_M": 0.31335091590881,
    "CMYK_Y": 0.27212679386139,
    "CMYK_K": 0.73798990249634
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0832",
    "Farbtonhilfsbezeichnung": "24.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "129",
    "Bcolor": "119",
    "Y": 25,
    "L": 57.0022926330566,
    "a": 11.5485277175903,
    "b": 10.1817979812622,
    "C": 15.3960218429565,
    "h": 41.4011192321777,
    "CMY_C": 0.36053156852722,
    "CMY_M": 0.49250066280365,
    "CMY_Y": 0.53470408916473,
    "CMYK_C": 0,
    "CMYK_M": 0.20637312531471,
    "CMYK_Y": 0.27237078547478,
    "CMYK_K": 0.36053156852722
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0833",
    "Farbtonhilfsbezeichnung": "24.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "95",
    "Bcolor": "88",
    "Y": 13,
    "L": 44.0763282775879,
    "a": 14.646824836731,
    "b": 9.55359649658203,
    "C": 17.4871578216553,
    "h": 33.1149635314941,
    "CMY_C": 0.47872447967529,
    "CMY_M": 0.62705683708191,
    "CMY_Y": 0.65390813350677,
    "CMYK_C": 0,
    "CMYK_M": 0.28455653786659,
    "CMYK_Y": 0.336067289114,
    "CMYK_K": 0.47872447967529
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0834",
    "Farbtonhilfsbezeichnung": "24.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "77",
    "Bcolor": "75",
    "Y": 8,
    "L": 36.1011543273926,
    "a": 13.4596118927002,
    "b": 6.07023429870605,
    "C": 14.7651243209839,
    "h": 24.2751960754395,
    "CMY_C": 0.57255375385284,
    "CMY_M": 0.69822943210602,
    "CMY_Y": 0.70554196834564,
    "CMYK_C": 0,
    "CMYK_M": 0.29401516914368,
    "CMYK_Y": 0.31112265586853,
    "CMYK_K": 0.57255375385284
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0835",
    "Farbtonhilfsbezeichnung": "24.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "56",
    "Bcolor": "50",
    "Y": 6,
    "L": 26.633918762207,
    "a": 11.3376150131226,
    "b": 8.33240413665771,
    "C": 14.070198059082,
    "h": 36.3134498596191,
    "CMY_C": 0.67229032516479,
    "CMY_M": 0.77882713079453,
    "CMY_Y": 0.80273461341858,
    "CMYK_C": 0,
    "CMYK_M": 0.32509508728981,
    "CMYK_Y": 0.39804834127426,
    "CMYK_K": 0.67229032516479
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0836",
    "Farbtonhilfsbezeichnung": "24.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "112",
    "Bcolor": "97",
    "Y": 21,
    "L": 53.400318145752,
    "a": 22.2950687408447,
    "b": 17.9797554016113,
    "C": 28.6416072845459,
    "h": 38.8842811584473,
    "CMY_C": 0.32234746217728,
    "CMY_M": 0.55894243717194,
    "CMY_Y": 0.61986476182938,
    "CMYK_C": 0,
    "CMYK_M": 0.3491390645504,
    "CMYK_Y": 0.43904107809067,
    "CMYK_K": 0.32234746217728
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0837",
    "Farbtonhilfsbezeichnung": "24.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "87",
    "Bcolor": "74",
    "Y": 14,
    "L": 44.6931190490723,
    "a": 27.0777759552002,
    "b": 19.4674549102783,
    "C": 33.349479675293,
    "h": 35.7140884399414,
    "CMY_C": 0.3904100060463,
    "CMY_M": 0.65882241725922,
    "CMY_Y": 0.70964384078979,
    "CMYK_C": 0,
    "CMYK_M": 0.44031628966331,
    "CMYK_Y": 0.523686170578,
    "CMYK_K": 0.3904100060463
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0838",
    "Farbtonhilfsbezeichnung": "24.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "55",
    "Bcolor": "49",
    "Y": 8,
    "L": 30.1286907196045,
    "a": 23.6402454376221,
    "b": 14.6149969100952,
    "C": 27.7931518554688,
    "h": 31.7254028320313,
    "CMY_C": 0.56894791126251,
    "CMY_M": 0.78325974941254,
    "CMY_Y": 0.80818963050842,
    "CMYK_C": 0,
    "CMYK_M": 0.49718314409256,
    "CMYK_Y": 0.55501812696457,
    "CMYK_K": 0.56894791126251
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0839",
    "Farbtonhilfsbezeichnung": "24.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "67",
    "Bcolor": "65",
    "Y": 6,
    "L": 32.3218765258789,
    "a": 15.0074148178101,
    "b": 6.78742361068726,
    "C": 16.4709320068359,
    "h": 24.3358764648438,
    "CMY_C": 0.60044503211975,
    "CMY_M": 0.73691439628601,
    "CMY_Y": 0.7435542345047,
    "CMYK_C": 0,
    "CMYK_M": 0.34155341982841,
    "CMYK_Y": 0.35817149281502,
    "CMYK_K": 0.60044503211975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0840",
    "Farbtonhilfsbezeichnung": "24.18.21",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "101",
    "Bcolor": "77",
    "Y": 25,
    "L": 55.5696182250977,
    "a": 41.7627296447754,
    "b": 33.0277099609375,
    "C": 53.2442970275879,
    "h": 38.3384170532227,
    "CMY_C": 0.17575073242188,
    "CMY_M": 0.60572457313538,
    "CMY_Y": 0.69672816991806,
    "CMYK_C": 0,
    "CMYK_M": 0.52165508270264,
    "CMYK_Y": 0.63206297159195,
    "CMYK_K": 0.17575073242188
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0841",
    "Farbtonhilfsbezeichnung": "24.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "80",
    "Bcolor": "67",
    "Y": 13,
    "L": 44.1632690429688,
    "a": 33.1644859313965,
    "b": 23.0692977905273,
    "C": 40.3989562988281,
    "h": 34.822566986084,
    "CMY_C": 0.36139410734177,
    "CMY_M": 0.68529105186462,
    "CMY_Y": 0.73635113239288,
    "CMYK_C": 0,
    "CMYK_M": 0.50719380378723,
    "CMYK_Y": 0.58714932203293,
    "CMYK_K": 0.36139410734177
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0842",
    "Farbtonhilfsbezeichnung": "24.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "81",
    "Bcolor": "71",
    "Y": 12,
    "L": 41.9018287658691,
    "a": 26.0815944671631,
    "b": 17.3074226379395,
    "C": 31.301700592041,
    "h": 33.567756652832,
    "CMY_C": 0.42867332696915,
    "CMY_M": 0.68198376893997,
    "CMY_Y": 0.72124767303467,
    "CMYK_C": 0,
    "CMYK_M": 0.44337233901024,
    "CMYK_Y": 0.5120964050293,
    "CMYK_K": 0.42867332696915
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0843",
    "Farbtonhilfsbezeichnung": "24.21.21",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "88",
    "Bcolor": "37",
    "Y": 23,
    "L": 54.3548126220703,
    "a": 49.4548187255859,
    "b": 52.7905426025391,
    "C": 72.3368530273438,
    "h": 46.868595123291,
    "CMY_C": 0.13813805580139,
    "CMY_M": 0.65448808670044,
    "CMY_Y": 0.8543838262558,
    "CMYK_C": 0,
    "CMYK_M": 0.59910988807678,
    "CMYK_Y": 0.83104467391968,
    "CMYK_K": 0.13813805580139
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0844",
    "Farbtonhilfsbezeichnung": "24.21.24",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "75",
    "Bcolor": "40",
    "Y": 17,
    "L": 46.3038635253906,
    "a": 42.8843460083008,
    "b": 41.6508827209473,
    "C": 59.781795501709,
    "h": 44.1640510559082,
    "CMY_C": 0.27443224191666,
    "CMY_M": 0.70613884925842,
    "CMY_Y": 0.84202241897583,
    "CMYK_C": 0,
    "CMYK_M": 0.59499144554138,
    "CMYK_Y": 0.78227037191391,
    "CMYK_K": 0.27443224191666
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0845",
    "Farbtonhilfsbezeichnung": "24.24.24",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "76",
    "Bcolor": "62",
    "Y": 14,
    "L": 44.9268035888672,
    "a": 39.5343704223633,
    "b": 27.6840858459473,
    "C": 48.263599395752,
    "h": 35.0017738342285,
    "CMY_C": 0.31688159704208,
    "CMY_M": 0.7032276391983,
    "CMY_Y": 0.75798350572586,
    "CMYK_C": 0,
    "CMYK_M": 0.56556236743927,
    "CMYK_Y": 0.64571809768677,
    "CMYK_K": 0.31688159704208
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0846",
    "Farbtonhilfsbezeichnung": "27.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "128",
    "Bcolor": "114",
    "Y": 26,
    "L": 58.2958793640137,
    "a": 17.7988014221191,
    "b": 14.7296409606934,
    "C": 23.1032390594482,
    "h": 39.609920501709,
    "CMY_C": 0.2998908162117,
    "CMY_M": 0.49673634767532,
    "CMY_Y": 0.55167812108994,
    "CMYK_C": 0,
    "CMYK_M": 0.28116405010223,
    "CMYK_Y": 0.35964006185532,
    "CMYK_K": 0.2998908162117
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0847",
    "Farbtonhilfsbezeichnung": "27.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "94",
    "Bcolor": "90",
    "Y": 13,
    "L": 44.3857574462891,
    "a": 17.2702445983887,
    "b": 9.07181930541992,
    "C": 19.5079288482666,
    "h": 27.7123203277588,
    "CMY_C": 0.46163272857666,
    "CMY_M": 0.63085377216339,
    "CMY_Y": 0.64751094579697,
    "CMYK_C": 0,
    "CMYK_M": 0.31432268023491,
    "CMYK_Y": 0.34526285529137,
    "CMYK_K": 0.46163272857666
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0848",
    "Farbtonhilfsbezeichnung": "27.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "76",
    "Bcolor": "76",
    "Y": 9,
    "L": 37.6843948364258,
    "a": 20.0176982879639,
    "b": 7.79582786560059,
    "C": 21.4821586608887,
    "h": 21.2782649993896,
    "CMY_C": 0.51826912164688,
    "CMY_M": 0.70142924785614,
    "CMY_Y": 0.70081424713135,
    "CMYK_C": 0,
    "CMYK_M": 0.3802125453949,
    "CMYK_Y": 0.37893590331078,
    "CMYK_K": 0.51826912164688
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0849",
    "Farbtonhilfsbezeichnung": "27.09.30",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "43",
    "Bcolor": "48",
    "Y": 6,
    "L": 25.1404418945313,
    "a": 24.5908203125,
    "b": 7.84637117385864,
    "C": 25.8122844696045,
    "h": 17.6966991424561,
    "CMY_C": 0.62349915504456,
    "CMY_M": 0.82976877689362,
    "CMY_Y": 0.8103443980217,
    "CMYK_C": 0,
    "CMYK_M": 0.54785966873169,
    "CMYK_Y": 0.49626779556274,
    "CMYK_K": 0.62349915504456
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0850",
    "Farbtonhilfsbezeichnung": "27.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "86",
    "Bcolor": "82",
    "Y": 13,
    "L": 43.0998039245605,
    "a": 24.3047790527344,
    "b": 12.2523460388184,
    "C": 27.2184181213379,
    "h": 26.7532501220703,
    "CMY_C": 0.43187230825424,
    "CMY_M": 0.66390883922577,
    "CMY_Y": 0.67850995063782,
    "CMYK_C": 0,
    "CMYK_M": 0.40842321515083,
    "CMYK_Y": 0.43412360548973,
    "CMYK_K": 0.43187230825424
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0851",
    "Farbtonhilfsbezeichnung": "27.12.27",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "71",
    "Bcolor": "70",
    "Y": 9,
    "L": 37.3559341430664,
    "a": 25.1935958862305,
    "b": 11.1376323699951,
    "C": 27.5456733703613,
    "h": 23.8493537902832,
    "CMY_C": 0.48994487524033,
    "CMY_M": 0.72076547145844,
    "CMY_Y": 0.72356051206589,
    "CMYK_C": 0,
    "CMYK_M": 0.45254048705101,
    "CMYK_Y": 0.45802035927773,
    "CMYK_K": 0.48994487524033
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0852",
    "Farbtonhilfsbezeichnung": "27.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "44",
    "Bcolor": "44",
    "Y": 8,
    "L": 29.397346496582,
    "a": 33.8768577575684,
    "b": 17.315544128418,
    "C": 38.0456237792969,
    "h": 27.0730266571045,
    "CMY_C": 0.52683186531067,
    "CMY_M": 0.82891666889191,
    "CMY_Y": 0.82818156480789,
    "CMYK_C": 0,
    "CMYK_M": 0.63843017816544,
    "CMYK_Y": 0.63687658309937,
    "CMYK_K": 0.52683186531067
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0853",
    "Farbtonhilfsbezeichnung": "27.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "105",
    "Bcolor": "96",
    "Y": 21,
    "L": 53.2708129882813,
    "a": 31.6746597290039,
    "b": 18.6783847808838,
    "C": 36.7718124389648,
    "h": 30.5276355743408,
    "CMY_C": 0.27151894569397,
    "CMY_M": 0.58938527107239,
    "CMY_Y": 0.62381738424301,
    "CMYK_C": 0,
    "CMYK_M": 0.43634122610092,
    "CMYK_Y": 0.48360687494278,
    "CMYK_K": 0.27151894569397
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0854",
    "Farbtonhilfsbezeichnung": "27.15.24",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "81",
    "Bcolor": "75",
    "Y": 13,
    "L": 44.7274932861328,
    "a": 33.9471855163574,
    "b": 19.3270740509033,
    "C": 39.0633735656738,
    "h": 29.6540584564209,
    "CMY_C": 0.35519313812256,
    "CMY_M": 0.68179428577423,
    "CMY_Y": 0.70687347650528,
    "CMYK_C": 0,
    "CMYK_M": 0.50651001930237,
    "CMYK_Y": 0.54540413618088,
    "CMYK_K": 0.35519313812256
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0855",
    "Farbtonhilfsbezeichnung": "27.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "95",
    "Bcolor": "86",
    "Y": 20,
    "L": 52.283618927002,
    "a": 39.3703155517578,
    "b": 23.2319107055664,
    "C": 45.7137107849121,
    "h": 30.5443019866943,
    "CMY_C": 0.23678421974182,
    "CMY_M": 0.62775850296021,
    "CMY_Y": 0.66157305240631,
    "CMYK_C": 0,
    "CMYK_M": 0.51227229833603,
    "CMYK_Y": 0.55657762289047,
    "CMYK_K": 0.23678421974182
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0856",
    "Farbtonhilfsbezeichnung": "27.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "63",
    "Bcolor": "50",
    "Y": 14,
    "L": 40.6824264526367,
    "a": 41.4173774719238,
    "b": 28.9622974395752,
    "C": 50.5392303466797,
    "h": 34.964282989502,
    "CMY_C": 0.35600632429123,
    "CMY_M": 0.75418186187744,
    "CMY_Y": 0.80306655168533,
    "CMYK_C": 0,
    "CMYK_M": 0.61829107999802,
    "CMYK_Y": 0.69419974088669,
    "CMYK_K": 0.35600632429123
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0857",
    "Farbtonhilfsbezeichnung": "27.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "57",
    "Bcolor": "52",
    "Y": 11,
    "L": 37.8840408325195,
    "a": 40.055004119873,
    "b": 24.3362045288086,
    "C": 46.8684768676758,
    "h": 31.2815933227539,
    "CMY_C": 0.39815092086792,
    "CMY_M": 0.77507501840591,
    "CMY_Y": 0.79782050848007,
    "CMYK_C": 0,
    "CMYK_M": 0.62627679109573,
    "CMYK_Y": 0.66406947374344,
    "CMYK_K": 0.39815092086792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0858",
    "Farbtonhilfsbezeichnung": "27.18.30",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "42",
    "Bcolor": "46",
    "Y": 8,
    "L": 31.540319442749,
    "a": 39.6350593566895,
    "b": 18.8493461608887,
    "C": 43.8889045715332,
    "h": 25.434476852417,
    "CMY_C": 0.47607868909836,
    "CMY_M": 0.83574175834656,
    "CMY_Y": 0.81795161962509,
    "CMYK_C": 0,
    "CMYK_M": 0.6864829659462,
    "CMYK_Y": 0.65252727270126,
    "CMYK_K": 0.47607868909836
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0859",
    "Farbtonhilfsbezeichnung": "27.21.21",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "59",
    "Bcolor": "42",
    "Y": 16,
    "L": 44.5811347961426,
    "a": 51.6655235290527,
    "b": 39.4311981201172,
    "C": 64.9934310913086,
    "h": 37.3509254455566,
    "CMY_C": 0.25493723154068,
    "CMY_M": 0.76838934421539,
    "CMY_Y": 0.83653682470322,
    "CMYK_C": 0,
    "CMYK_M": 0.68913942575455,
    "CMYK_Y": 0.78060483932495,
    "CMYK_K": 0.25493723154068
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0860",
    "Farbtonhilfsbezeichnung": "27.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "66",
    "Bcolor": "66",
    "Y": 14,
    "L": 45.1347999572754,
    "a": 48.3478622436523,
    "b": 25.9853382110596,
    "C": 54.888557434082,
    "h": 28.2565231323242,
    "CMY_C": 0.27327907085419,
    "CMY_M": 0.74118602275848,
    "CMY_Y": 0.74239909648895,
    "CMYK_C": 0,
    "CMYK_M": 0.64386057853699,
    "CMYK_Y": 0.64552980661392,
    "CMYK_K": 0.27327907085419
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0861",
    "Farbtonhilfsbezeichnung": "27.21.27",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "42",
    "Bcolor": "43",
    "Y": 11,
    "L": 35.5074310302734,
    "a": 46.3064498901367,
    "b": 26.5441188812256,
    "C": 53.3748779296875,
    "h": 29.8225116729736,
    "CMY_C": 0.39525365829468,
    "CMY_M": 0.83356380462646,
    "CMY_Y": 0.82997649908066,
    "CMYK_C": 0,
    "CMYK_M": 0.72478348016739,
    "CMYK_Y": 0.7188515663147,
    "CMYK_K": 0.39525365829468
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0862",
    "Farbtonhilfsbezeichnung": "27.21.30",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "58",
    "Bcolor": "62",
    "Y": 13,
    "L": 40.4236145019531,
    "a": 45.3732452392578,
    "b": 21.431453704834,
    "C": 50.180061340332,
    "h": 25.283088684082,
    "CMY_C": 0.34649276733398,
    "CMY_M": 0.77428734302521,
    "CMY_Y": 0.755899310112,
    "CMYK_C": 0,
    "CMYK_M": 0.65461337566376,
    "CMYK_Y": 0.62647593021393,
    "CMYK_K": 0.34649276733398
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0863",
    "Farbtonhilfsbezeichnung": "27.24.27",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 12,
    "L": 39.2133827209473,
    "a": 46.3977737426758,
    "b": 28.1887054443359,
    "C": 54.2895622253418,
    "h": 31.28053855896,
    "CMY_C": 0.35047245025635,
    "CMY_M": 0.79424893856049,
    "CMY_Y": 0.80898976325989,
    "CMYK_C": 0,
    "CMYK_M": 0.68322968482971,
    "CMYK_Y": 0.70592433214188,
    "CMYK_K": 0.35047245025635
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0864",
    "Farbtonhilfsbezeichnung": "27.24.30",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "45",
    "Bcolor": "44",
    "Y": 11,
    "L": 35.7861862182617,
    "a": 45.3938140869141,
    "b": 26.395471572876,
    "C": 52.510181427002,
    "h": 30.1770286560059,
    "CMY_C": 0.39623486995697,
    "CMY_M": 0.82495057582855,
    "CMY_Y": 0.82701045274734,
    "CMYK_C": 0,
    "CMYK_M": 0.71007031202316,
    "CMYK_Y": 0.71348202228546,
    "CMYK_K": 0.39623486995697
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0865",
    "Farbtonhilfsbezeichnung": "30.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "122",
    "Bcolor": "123",
    "Y": 21,
    "L": 53.4792900085449,
    "a": 9.1385612487793,
    "b": 2.38466453552246,
    "C": 9.44457149505615,
    "h": 14.6249361038208,
    "CMY_C": 0.4306303858757,
    "CMY_M": 0.51992708444595,
    "CMY_Y": 0.5176887512207,
    "CMYK_C": 0,
    "CMYK_M": 0.15683431923389,
    "CMYK_Y": 0.15290307998657,
    "CMYK_K": 0.4306303858757
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0866",
    "Farbtonhilfsbezeichnung": "30.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "101",
    "Bcolor": "103",
    "Y": 14,
    "L": 44.9358558654785,
    "a": 8.57413578033447,
    "b": 1.63827168941498,
    "C": 8.72924613952637,
    "h": 10.8172006607056,
    "CMY_C": 0.52270948886871,
    "CMY_M": 0.60204696655273,
    "CMY_Y": 0.59598529338837,
    "CMYK_C": 0,
    "CMYK_M": 0.16622471809387,
    "CMYK_Y": 0.15352453291416,
    "CMYK_K": 0.52270948886871
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0867",
    "Farbtonhilfsbezeichnung": "30.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "103",
    "Bcolor": "105",
    "Y": 9,
    "L": 44.9122886657715,
    "a": 5.55303621292114,
    "b": 0.23056671023369,
    "C": 5.55782079696655,
    "h": 2.37760305404663,
    "CMY_C": 0.54569005966187,
    "CMY_M": 0.59503191709518,
    "CMY_Y": 0.58756875991821,
    "CMYK_C": 0,
    "CMYK_M": 0.10860835760832,
    "CMYK_Y": 0.09218090027571,
    "CMYK_K": 0.54569005966187
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0868",
    "Farbtonhilfsbezeichnung": "30.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "72",
    "Bcolor": "75",
    "Y": 6,
    "L": 32.0543746948242,
    "a": 6.16880464553833,
    "b": 0.056630063802,
    "C": 6.16906452178955,
    "h": 0.52596455812454,
    "CMY_C": 0.66586953401566,
    "CMY_M": 0.71679377555847,
    "CMY_Y": 0.70649194717407,
    "CMYK_C": 0,
    "CMYK_M": 0.15240825712681,
    "CMYK_Y": 0.1215765029192,
    "CMYK_K": 0.66586953401566
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0869",
    "Farbtonhilfsbezeichnung": "30.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "120",
    "Bcolor": "120",
    "Y": 22,
    "L": 54.5195541381836,
    "a": 16.3870639801025,
    "b": 6.02799654006958,
    "C": 17.4606018066406,
    "h": 20.1960926055908,
    "CMY_C": 0.36614155769348,
    "CMY_M": 0.52870082855225,
    "CMY_Y": 0.53056919574738,
    "CMYK_C": 0,
    "CMYK_M": 0.25645989179611,
    "CMYK_Y": 0.25940752029419,
    "CMYK_K": 0.36614155769348
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0870",
    "Farbtonhilfsbezeichnung": "30.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "99",
    "Bcolor": "100",
    "Y": 15,
    "L": 46.0526351928711,
    "a": 16.0871467590332,
    "b": 5.46683406829834,
    "C": 16.9906616210938,
    "h": 18.7691078186035,
    "CMY_C": 0.45789343118668,
    "CMY_M": 0.61081343889236,
    "CMY_Y": 0.60885572433472,
    "CMYK_C": 0,
    "CMYK_M": 0.28208476305008,
    "CMYK_Y": 0.27847346663475,
    "CMYK_K": 0.45789343118668
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0871",
    "Farbtonhilfsbezeichnung": "30.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "78",
    "Bcolor": "81",
    "Y": 9,
    "L": 36.8780975341797,
    "a": 15.524694442749,
    "b": 3.77796101570129,
    "C": 15.9777698516846,
    "h": 13.6771745681763,
    "CMY_C": 0.5577849149704,
    "CMY_M": 0.6957471370697,
    "CMY_Y": 0.68402945995331,
    "CMYK_C": 0,
    "CMYK_M": 0.31197991967201,
    "CMYK_Y": 0.28548222780228,
    "CMYK_K": 0.5577849149704
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0872",
    "Farbtonhilfsbezeichnung": "30.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "67",
    "Bcolor": "71",
    "Y": 6,
    "L": 31.3013477325439,
    "a": 11.4033193588257,
    "b": 1.53135097026825,
    "C": 11.5056819915772,
    "h": 7.64848852157593,
    "CMY_C": 0.63962686061859,
    "CMY_M": 0.73589795827866,
    "CMY_Y": 0.72151350975037,
    "CMYK_C": 0,
    "CMYK_M": 0.26714283227921,
    "CMYK_Y": 0.22722738981247,
    "CMYK_K": 0.63962686061859
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0873",
    "Farbtonhilfsbezeichnung": "30.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "111",
    "Bcolor": "113",
    "Y": 20,
    "L": 52.6820945739746,
    "a": 22.990198135376,
    "b": 7.480299949646,
    "C": 24.1765193939209,
    "h": 18.023286819458,
    "CMY_C": 0.34407240152359,
    "CMY_M": 0.56553530693054,
    "CMY_Y": 0.55710101127625,
    "CMYK_C": 0,
    "CMYK_M": 0.33763316273689,
    "CMYK_Y": 0.32477459311485,
    "CMYK_K": 0.34407240152359
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0874",
    "Farbtonhilfsbezeichnung": "30.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "92",
    "Bcolor": "95",
    "Y": 14,
    "L": 45.4005851745605,
    "a": 23.989387512207,
    "b": 7.36848545074463,
    "C": 25.0955238342285,
    "h": 17.0746574401856,
    "CMY_C": 0.41683405637741,
    "CMY_M": 0.63963514566422,
    "CMY_Y": 0.62599050998688,
    "CMYK_C": 0,
    "CMYK_M": 0.38205435872078,
    "CMYK_Y": 0.3586568236351,
    "CMYK_K": 0.41683405637741
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0875",
    "Farbtonhilfsbezeichnung": "30.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "75",
    "Bcolor": "80",
    "Y": 9,
    "L": 37.5705375671387,
    "a": 20.9694919586182,
    "b": 5.14513731002808,
    "C": 21.591480255127,
    "h": 13.7859191894531,
    "CMY_C": 0.51885974407196,
    "CMY_M": 0.70453774929047,
    "CMY_Y": 0.68531548976898,
    "CMYK_C": 0,
    "CMYK_M": 0.38591241836548,
    "CMYK_Y": 0.3459609746933,
    "CMYK_K": 0.51885974407196
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0876",
    "Farbtonhilfsbezeichnung": "30.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "63",
    "Bcolor": "69",
    "Y": 6,
    "L": 30.9222183227539,
    "a": 16.3586864471436,
    "b": 2.13125276565552,
    "C": 16.4969348907471,
    "h": 7.42283630371094,
    "CMY_C": 0.61534321308136,
    "CMY_M": 0.75196409225464,
    "CMY_Y": 0.72784239053726,
    "CMYK_C": 0,
    "CMYK_M": 0.35517606139183,
    "CMYK_Y": 0.29246637225151,
    "CMYK_K": 0.61534321308136
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0877",
    "Farbtonhilfsbezeichnung": "30.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "114",
    "Bcolor": "116",
    "Y": 28,
    "L": 57.6675300598145,
    "a": 34.8311004638672,
    "b": 13.2012872695923,
    "C": 37.2488861083984,
    "h": 20.7571392059326,
    "CMY_C": 0.21239280700684,
    "CMY_M": 0.55435568094254,
    "CMY_Y": 0.54437631368637,
    "CMYK_C": 0,
    "CMYK_M": 0.43417948484421,
    "CMYK_Y": 0.42150896787643,
    "CMYK_K": 0.21239280700684
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0878",
    "Farbtonhilfsbezeichnung": "30.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "105",
    "Bcolor": "103",
    "Y": 21,
    "L": 53.736644744873,
    "a": 32.8716430664063,
    "b": 14.9385471343994,
    "C": 36.1068572998047,
    "h": 24.4394626617432,
    "CMY_C": 0.26508736610413,
    "CMY_M": 0.58781844377518,
    "CMY_Y": 0.59435176849365,
    "CMYK_C": 0,
    "CMYK_M": 0.43914210796356,
    "CMYK_Y": 0.44803202152252,
    "CMYK_K": 0.26508736610413
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0879",
    "Farbtonhilfsbezeichnung": "30.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "85",
    "Bcolor": "85",
    "Y": 14,
    "L": 44.4699668884277,
    "a": 29.086181640625,
    "b": 12.3704452514648,
    "C": 31.6074962615967,
    "h": 23.0402030944824,
    "CMY_C": 0.39182734489441,
    "CMY_M": 0.66584360599518,
    "CMY_Y": 0.66572070121765,
    "CMYK_C": 0,
    "CMYK_M": 0.45055669546127,
    "CMYK_Y": 0.45035460591316,
    "CMYK_K": 0.39182734489441
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0880",
    "Farbtonhilfsbezeichnung": "30.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "70",
    "Bcolor": "78",
    "Y": 9,
    "L": 37.8921775817871,
    "a": 28.5249786376953,
    "b": 7.4949951171875,
    "C": 29.4932079315186,
    "h": 14.7218103408813,
    "CMY_C": 0.47261190414429,
    "CMY_M": 0.72563755512238,
    "CMY_Y": 0.6956479549408,
    "CMYK_C": 0,
    "CMYK_M": 0.47977125644684,
    "CMYK_Y": 0.42290687561035,
    "CMYK_K": 0.47261190414429
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0881",
    "Farbtonhilfsbezeichnung": "30.15.33",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "62",
    "Bcolor": "69",
    "Y": 6,
    "L": 32.6329193115234,
    "a": 22.6396465301514,
    "b": 4.97833728790283,
    "C": 23.1805400848389,
    "h": 12.4016618728638,
    "CMY_C": 0.56096303462982,
    "CMY_M": 0.75504517555237,
    "CMY_Y": 0.72870635986328,
    "CMYK_C": 0,
    "CMYK_M": 0.442063331604,
    "CMYK_Y": 0.38207107782364,
    "CMYK_K": 0.56096303462982
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0882",
    "Farbtonhilfsbezeichnung": "30.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "86",
    "Bcolor": "94",
    "Y": 22,
    "L": 51.9686851501465,
    "a": 47.1235046386719,
    "b": 18.2928371429443,
    "C": 50.5495071411133,
    "h": 21.2156753540039,
    "CMY_C": 0.20645451545715,
    "CMY_M": 0.66170805692673,
    "CMY_Y": 0.63015401363373,
    "CMYK_C": 0,
    "CMYK_M": 0.57369560003281,
    "CMYK_Y": 0.53393220901489,
    "CMYK_K": 0.20645451545715
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0883",
    "Farbtonhilfsbezeichnung": "30.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "68",
    "Bcolor": "79",
    "Y": 19,
    "L": 47.7456741333008,
    "a": 52.4754447937012,
    "b": 21.7002716064453,
    "C": 56.7853317260742,
    "h": 22.4666557312012,
    "CMY_C": 0.22620910406113,
    "CMY_M": 0.73386234045029,
    "CMY_Y": 0.69007885456085,
    "CMYK_C": 0,
    "CMYK_M": 0.65605998039246,
    "CMYK_Y": 0.59947687387466,
    "CMYK_K": 0.22620910406113
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0884",
    "Farbtonhilfsbezeichnung": "30.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "46",
    "Bcolor": "66",
    "Y": 13,
    "L": 39.4131278991699,
    "a": 51.643310546875,
    "b": 18.1502056121826,
    "C": 54.7399444580078,
    "h": 19.3641872406006,
    "CMY_C": 0.33184725046158,
    "CMY_M": 0.82109004259109,
    "CMY_Y": 0.74273890256882,
    "CMYK_C": 0,
    "CMYK_M": 0.73223197460175,
    "CMYK_Y": 0.61496663093567,
    "CMYK_K": 0.33184725046158
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0885",
    "Farbtonhilfsbezeichnung": "30.18.30",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "60",
    "Bcolor": "66",
    "Y": 9,
    "L": 37.9284324645996,
    "a": 38.7118301391602,
    "b": 15.3607044219971,
    "C": 41.6480140686035,
    "h": 21.6429862976074,
    "CMY_C": 0.41233289241791,
    "CMY_M": 0.76639485359192,
    "CMY_Y": 0.74178904294968,
    "CMYK_C": 0,
    "CMYK_M": 0.60248726606369,
    "CMYK_Y": 0.56061697006226,
    "CMYK_K": 0.41233289241791
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0886",
    "Farbtonhilfsbezeichnung": "30.18.33",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "47",
    "Bcolor": "53",
    "Y": 7,
    "L": 28.5190315246582,
    "a": 29.0174922943115,
    "b": 9.78403282165527,
    "C": 30.6225757598877,
    "h": 18.632926940918,
    "CMY_C": 0.5659431219101,
    "CMY_M": 0.81549561023712,
    "CMY_Y": 0.79212337732315,
    "CMYK_C": 0,
    "CMYK_M": 0.57493036985397,
    "CMYK_Y": 0.52108436822891,
    "CMYK_K": 0.5659431219101
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0887",
    "Farbtonhilfsbezeichnung": "30.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "95",
    "Bcolor": "109",
    "Y": 22,
    "L": 54.0045776367188,
    "a": 44.3033752441406,
    "b": 12.651725769043,
    "C": 46.0744514465332,
    "h": 15.93776512146,
    "CMY_C": 0.20443743467331,
    "CMY_M": 0.62693309783936,
    "CMY_Y": 0.57443660497665,
    "CMYK_C": 0,
    "CMYK_M": 0.53106528520584,
    "CMYK_Y": 0.46507865190506,
    "CMYK_K": 0.20443743467331
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0888",
    "Farbtonhilfsbezeichnung": "30.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "81",
    "Bcolor": "91",
    "Y": 14,
    "L": 45.3187408447266,
    "a": 36.5375099182129,
    "b": 10.0800189971924,
    "C": 37.902458190918,
    "h": 15.4231901168823,
    "CMY_C": 0.34720057249069,
    "CMY_M": 0.68318402767181,
    "CMY_Y": 0.64184391498566,
    "CMYK_C": 0,
    "CMYK_M": 0.51468098163605,
    "CMYK_Y": 0.45135354995728,
    "CMYK_K": 0.34720057249069
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0889",
    "Farbtonhilfsbezeichnung": "30.24.21",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "69",
    "Bcolor": "75",
    "Y": 15,
    "L": 45.5014038085938,
    "a": 46.8888282775879,
    "b": 20.9560527801514,
    "C": 51.3587226867676,
    "h": 24.0813293457031,
    "CMY_C": 0.28061109781265,
    "CMY_M": 0.72869598865509,
    "CMY_Y": 0.7071613073349,
    "CMYK_C": 0,
    "CMYK_M": 0.62286877632141,
    "CMYK_Y": 0.59293407201767,
    "CMYK_K": 0.28061109781265
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0890",
    "Farbtonhilfsbezeichnung": "33.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "150",
    "Bcolor": "148",
    "Y": 31,
    "L": 62.8590393066406,
    "a": 3.25239896774292,
    "b": 1.70559620857239,
    "C": 3.6724865436554,
    "h": 27.6730442047119,
    "CMY_C": 0.37502819299698,
    "CMY_M": 0.41102105379105,
    "CMY_Y": 0.41965740919113,
    "CMYK_C": 0,
    "CMYK_M": 0.05759117379785,
    "CMYK_Y": 0.07140997052193,
    "CMYK_K": 0.37502819299698
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0891",
    "Farbtonhilfsbezeichnung": "33.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "122",
    "Bcolor": "122",
    "Y": 20,
    "L": 52.4560334919527,
    "a": 5.42551154261517,
    "b": 1.09292414251698,
    "C": 5.53449714792111,
    "h": 0.19878140241389,
    "CMY_C": 0.4687978,
    "CMY_M": 0.5211375,
    "CMY_Y": 0.5197364,
    "CMYK_C": 0,
    "CMYK_M": 0.09853055,
    "CMYK_Y": 0.09589303,
    "CMYK_K": 0.4687978
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0892",
    "Farbtonhilfsbezeichnung": "33.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "102",
    "Bcolor": "103",
    "Y": 14,
    "L": 44.2736391492059,
    "a": 5.62233370320969,
    "b": 0.47904181698721,
    "C": 5.64270478872234,
    "h": 0.08499808899385,
    "CMY_C": 0.550874,
    "CMY_M": 0.6014206,
    "CMY_Y": 0.5952774,
    "CMYK_C": 0,
    "CMYK_M": 0.1125443,
    "CMYK_Y": 0.09886636,
    "CMYK_K": 0.550874
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0893",
    "Farbtonhilfsbezeichnung": "33.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "85",
    "Bcolor": "89",
    "Y": 9,
    "L": 37.1501372919274,
    "a": 3.9209727023948,
    "b": -1.44925874552,
    "C": 4.1802365775625,
    "h": -0.35404312588209,
    "CMY_C": 0.6357668,
    "CMY_M": 0.6647192,
    "CMY_Y": 0.6506718,
    "CMYK_C": 0,
    "CMYK_M": 0.07948849,
    "CMYK_Y": 0.04092176,
    "CMYK_K": 0.6357668
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0894",
    "Farbtonhilfsbezeichnung": "33.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "123",
    "Bcolor": "129",
    "Y": 23,
    "L": 55.0579299926758,
    "a": 15.10950756073,
    "b": 1.54210472106934,
    "C": 15.1879987716675,
    "h": 5.82753610610962,
    "CMY_C": 0.37846893072128,
    "CMY_M": 0.51879578828812,
    "CMY_Y": 0.49561607837677,
    "CMYK_C": 0,
    "CMYK_M": 0.22577609121799,
    "CMYK_Y": 0.18848156929016,
    "CMYK_K": 0.37846893072128
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0895",
    "Farbtonhilfsbezeichnung": "33.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "98",
    "Bcolor": "104",
    "Y": 14,
    "L": 44.9145889282227,
    "a": 14.936842918396,
    "b": 0.98862755298615,
    "C": 14.9695243835449,
    "h": 3.78672313690186,
    "CMY_C": 0.48588335514069,
    "CMY_M": 0.61761486530304,
    "CMY_Y": 0.59117990732193,
    "CMYK_C": 0,
    "CMYK_M": 0.25622883439064,
    "CMYK_Y": 0.20481061935425,
    "CMYK_K": 0.48588335514069
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0896",
    "Farbtonhilfsbezeichnung": "33.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 8,
    "L": 36.3335189819336,
    "a": 15.5133295059204,
    "b": 0.15115217864513,
    "C": 15.5140657424927,
    "h": 0.55823659896851,
    "CMY_C": 0.57062101364136,
    "CMY_M": 0.69980663061142,
    "CMY_Y": 0.66671442985535,
    "CMYK_C": 0,
    "CMYK_M": 0.3008661866188,
    "CMYK_Y": 0.2237962782383,
    "CMYK_K": 0.57062101364136
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0897",
    "Farbtonhilfsbezeichnung": "33.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "67",
    "Bcolor": "73",
    "Y": 6,
    "L": 32.4481925964355,
    "a": 16.0909099578857,
    "b": 2.14816761016846,
    "C": 16.2336692810059,
    "h": 7.60413503646851,
    "CMY_C": 0.60176408290863,
    "CMY_M": 0.73745834827423,
    "CMY_Y": 0.71428370475769,
    "CMYK_C": 0,
    "CMYK_M": 0.34073838591576,
    "CMYK_Y": 0.28254514932632,
    "CMYK_K": 0.60176408290863
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0898",
    "Farbtonhilfsbezeichnung": "33.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "116",
    "Bcolor": "127",
    "Y": 22,
    "L": 54.1083984375,
    "a": 21.9839477539063,
    "b": 1.47895133495331,
    "C": 22.0336399078369,
    "h": 3.84872531890869,
    "CMY_C": 0.3468325138092,
    "CMY_M": 0.54682612419128,
    "CMY_Y": 0.50365519523621,
    "CMYK_C": 0,
    "CMYK_M": 0.30619040131569,
    "CMYK_Y": 0.24009566009045,
    "CMYK_K": 0.3468325138092
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0899",
    "Farbtonhilfsbezeichnung": "33.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "98",
    "Bcolor": "111",
    "Y": 16,
    "L": 46.942497253418,
    "a": 21.8176994323731,
    "b": 0.1569682508707,
    "C": 21.8182640075684,
    "h": 0.4122094810009,
    "CMY_C": 0.42661613225937,
    "CMY_M": 0.61639016866684,
    "CMY_Y": 0.56534838676453,
    "CMYK_C": 0,
    "CMYK_M": 0.33097204566002,
    "CMYK_Y": 0.2419535368681,
    "CMYK_K": 0.42661613225937
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0900",
    "Farbtonhilfsbezeichnung": "33.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "75",
    "Bcolor": "89",
    "Y": 9,
    "L": 37.4112930297852,
    "a": 21.011194229126,
    "b": -0.51650816202164,
    "C": 21.017541885376,
    "h": 358.591796875,
    "CMY_C": 0.53084242343903,
    "CMY_M": 0.70457029342651,
    "CMY_Y": 0.65186131000519,
    "CMYK_C": 0,
    "CMYK_M": 0.37029749155045,
    "CMYK_Y": 0.2579493522644,
    "CMYK_K": 0.53084242343903
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0901",
    "Farbtonhilfsbezeichnung": "33.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "65",
    "Bcolor": "77",
    "Y": 6,
    "L": 31.177095413208,
    "a": 14.3462142944336,
    "b": -2.4995584487915,
    "C": 14.5623369216919,
    "h": 350.116485595703,
    "CMY_C": 0.63321566581726,
    "CMY_M": 0.74318736791611,
    "CMY_Y": 0.69809508323669,
    "CMYK_C": 0,
    "CMYK_M": 0.29982659220695,
    "CMYK_Y": 0.17688709497452,
    "CMYK_K": 0.63321566581726
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0902",
    "Farbtonhilfsbezeichnung": "33.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "108",
    "Bcolor": "125",
    "Y": 21,
    "L": 53.7223205566406,
    "a": 29.9698715209961,
    "b": 1.74036991596222,
    "C": 30.0203609466553,
    "h": 3.32347083091736,
    "CMY_C": 0.30399227142334,
    "CMY_M": 0.57472908496857,
    "CMY_Y": 0.5080184340477,
    "CMYK_C": 0,
    "CMYK_M": 0.3889853656292,
    "CMYK_Y": 0.29313778877258,
    "CMYK_K": 0.30399227142334
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0903",
    "Farbtonhilfsbezeichnung": "33.15.24",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "68",
    "Bcolor": "82",
    "Y": 12,
    "L": 38.7565040588379,
    "a": 32.8868675231934,
    "b": 6.24238872528076,
    "C": 33.4740715026855,
    "h": 10.7476825714111,
    "CMY_C": 0.44320160150528,
    "CMY_M": 0.73239207267761,
    "CMY_Y": 0.67928051948547,
    "CMYK_C": 0,
    "CMYK_M": 0.51938092708588,
    "CMYK_Y": 0.42399352788925,
    "CMYK_K": 0.44320160150528
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0904",
    "Farbtonhilfsbezeichnung": "33.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "60",
    "Bcolor": "75",
    "Y": 7,
    "L": 32.2540435791016,
    "a": 24.820930480957,
    "b": 0.59271991252899,
    "C": 24.8280065014332,
    "h": 1.36795421082069,
    "CMY_C": 0.75294119119644,
    "CMY_M": 0.62745094299316,
    "CMY_Y": 0.80000001192093,
    "CMYK_C": 0.33684220910072,
    "CMYK_M": 0,
    "CMYK_Y": 0.46315798163414,
    "CMYK_K": 0.62745094
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0905",
    "Farbtonhilfsbezeichnung": "33.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "64",
    "Bcolor": "78",
    "Y": 9,
    "L": 37.0756187438965,
    "a": 33.4971389770508,
    "b": 6.38457155227661,
    "C": 34.1001625061035,
    "h": 10.7911710739136,
    "CMY_C": 0.45805978775024,
    "CMY_M": 0.75086033344269,
    "CMY_Y": 0.6954060792923,
    "CMYK_C": 0,
    "CMYK_M": 0.5402820110321,
    "CMYK_Y": 0.4379566013813,
    "CMYK_K": 0.45805978775024
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0906",
    "Farbtonhilfsbezeichnung": "36.03.21",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "126",
    "Bcolor": "128",
    "Y": 21,
    "L": 53.4275093078613,
    "a": 3.6880190372467,
    "b": -0.80959933996201,
    "C": 3.77583575248718,
    "h": 347.618743896484,
    "CMY_C": 0.47617483139038,
    "CMY_M": 0.50703436136246,
    "CMY_Y": 0.49773043394089,
    "CMYK_C": 0,
    "CMYK_M": 0.05891188979149,
    "CMYK_Y": 0.04115037620068,
    "CMYK_K": 0.47617483139038
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0907",
    "Farbtonhilfsbezeichnung": "36.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "104",
    "Bcolor": "108",
    "Y": 14,
    "L": 44.8588256835938,
    "a": 4.38792562484741,
    "b": -1.46180510520935,
    "C": 4.62501525878906,
    "h": 341.574890136719,
    "CMY_C": 0.55853044986725,
    "CMY_M": 0.59253495931625,
    "CMY_Y": 0.57736551761627,
    "CMYK_C": 0,
    "CMYK_M": 0.07702571898699,
    "CMYK_Y": 0.04266447946429,
    "CMYK_K": 0.55853044986725
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0908",
    "Farbtonhilfsbezeichnung": "36.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "85",
    "Bcolor": "89",
    "Y": 9,
    "L": 36.7297264375078,
    "a": 3.82823977609592,
    "b": -2.30458187531413,
    "C": 4.46839091881063,
    "h": -0.54188524973414,
    "CMY_C": 0.642745,
    "CMY_M": 0.6682202,
    "CMY_Y": 0.6493057,
    "CMYK_C": 0,
    "CMYK_M": 0.07130798,
    "CMYK_Y": 0.01836405,
    "CMYK_K": 0.642745
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0909",
    "Farbtonhilfsbezeichnung": "36.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "73",
    "Bcolor": "76",
    "Y": 6,
    "L": 31.5325031280518,
    "a": 3.29093146324158,
    "b": -1.78759109973907,
    "C": 3.74509167671204,
    "h": 331.489776611328,
    "CMY_C": 0.69309079647064,
    "CMY_M": 0.71500205993652,
    "CMY_Y": 0.70042312145233,
    "CMYK_C": 0,
    "CMYK_M": 0.07139331102371,
    "CMYK_Y": 0.02389086037874,
    "CMYK_K": 0.69309079647064
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0910",
    "Farbtonhilfsbezeichnung": "36.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "110",
    "Bcolor": "138",
    "Y": 21,
    "L": 54.0376968383789,
    "a": 29.3810710906982,
    "b": -5.14716100692749,
    "C": 29.828519821167,
    "h": 350.063385009766,
    "CMY_C": 0.31876492500305,
    "CMY_M": 0.56747007369995,
    "CMY_Y": 0.45955944061279,
    "CMYK_C": 0,
    "CMYK_M": 0.36507979035378,
    "CMYK_Y": 0.20667538046837,
    "CMYK_K": 0.31876492500305
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0911",
    "Farbtonhilfsbezeichnung": "36.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "88",
    "Bcolor": "116",
    "Y": 14,
    "L": 44.9908256530762,
    "a": 28.4326763153076,
    "b": -5.63145065307617,
    "C": 28.9850025177002,
    "h": 348.796844482422,
    "CMY_C": 0.42211097478867,
    "CMY_M": 0.65331476926804,
    "CMY_Y": 0.54639613628387,
    "CMYK_C": 0,
    "CMYK_M": 0.40008339285851,
    "CMYK_Y": 0.21506752073765,
    "CMYK_K": 0.42211097478867
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0912",
    "Farbtonhilfsbezeichnung": "36.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "71",
    "Bcolor": "96",
    "Y": 9,
    "L": 36.7277641296387,
    "a": 25.5226936340332,
    "b": -5.98623132705688,
    "C": 26.2153167724609,
    "h": 346.800140380859,
    "CMY_C": 0.52470427751541,
    "CMY_M": 0.72267889976501,
    "CMY_Y": 0.62402856349945,
    "CMYK_C": 0,
    "CMYK_M": 0.41652935743332,
    "CMYK_Y": 0.2089736610651,
    "CMYK_K": 0.52470427751541
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0913",
    "Farbtonhilfsbezeichnung": "36.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "61",
    "Bcolor": "80",
    "Y": 6,
    "L": 30.5263442993164,
    "a": 18.5173778533936,
    "b": -5.43962526321411,
    "C": 19.2998142242432,
    "h": 343.629425048828,
    "CMY_C": 0.62322020530701,
    "CMY_M": 0.75918078422546,
    "CMY_Y": 0.68596315383911,
    "CMYK_C": 0,
    "CMYK_M": 0.36084890365601,
    "CMYK_Y": 0.16652418673038,
    "CMYK_K": 0.62322020530701
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0914",
    "Farbtonhilfsbezeichnung": "36.09.33",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "50",
    "Bcolor": "68",
    "Y": 6,
    "L": 24.4416427612305,
    "a": 15.5212049484253,
    "b": -6.83571863174438,
    "C": 16.9598007202148,
    "h": 336.230743408203,
    "CMY_C": 0.70046555995941,
    "CMY_M": 0.80454105138779,
    "CMY_Y": 0.73317277431488,
    "CMYK_C": 0,
    "CMYK_M": 0.347457498312,
    "CMYK_Y": 0.10919350385666,
    "CMYK_K": 0.70046555995941
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0915",
    "Farbtonhilfsbezeichnung": "36.12.21",
    "Farbtonklasse": "04",
    "Rcolor": "193",
    "Gcolor": "99",
    "Bcolor": "140",
    "Y": 24,
    "L": 54.2138404846191,
    "a": 42.7651023864746,
    "b": -5.96550893783569,
    "C": 43.1791763305664,
    "h": 352.058776855469,
    "CMY_C": 0.24206250905991,
    "CMY_M": 0.61210656166077,
    "CMY_Y": 0.45050632953644,
    "CMYK_C": 0,
    "CMYK_M": 0.48822501301765,
    "CMYK_Y": 0.27501451969147,
    "CMYK_K": 0.24206250905991
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0916",
    "Farbtonhilfsbezeichnung": "36.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "79",
    "Bcolor": "121",
    "Y": 14,
    "L": 45.4939041137695,
    "a": 40.0166931152344,
    "b": -7.70107746124268,
    "C": 40.7509803771973,
    "h": 349.106811523438,
    "CMY_C": 0.35741168260574,
    "CMY_M": 0.68867272138596,
    "CMY_Y": 0.52672290802002,
    "CMYK_C": 0,
    "CMYK_M": 0.51551049947739,
    "CMYK_Y": 0.26348319649696,
    "CMYK_K": 0.35741168260574
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0917",
    "Farbtonhilfsbezeichnung": "36.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "67",
    "Bcolor": "102",
    "Y": 10,
    "L": 38.4286155700684,
    "a": 34.320125579834,
    "b": -6.80499362945557,
    "C": 34.9882698059082,
    "h": 348.784851074219,
    "CMY_C": 0.46184593439102,
    "CMY_M": 0.73633855581284,
    "CMY_Y": 0.60168468952179,
    "CMYK_C": 0,
    "CMYK_M": 0.51006329059601,
    "CMYK_Y": 0.25984892249107,
    "CMYK_K": 0.46184593439102
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0918",
    "Farbtonhilfsbezeichnung": "36.15.21",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "68",
    "Bcolor": "121",
    "Y": 18,
    "L": 47.1585083007813,
    "a": 52.8927192687988,
    "b": -5.04655885696411,
    "C": 53.1329231262207,
    "h": 354.549835205078,
    "CMY_C": 0.26614367961884,
    "CMY_M": 0.73189783096313,
    "CMY_Y": 0.52536344528198,
    "CMYK_C": 0,
    "CMYK_M": 0.63466668128967,
    "CMYK_Y": 0.35322958230972,
    "CMYK_K": 0.26614367961884
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0919",
    "Farbtonhilfsbezeichnung": "36.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "67",
    "Bcolor": "93",
    "Y": 9,
    "L": 38.1745986938477,
    "a": 33.7016067504883,
    "b": -1.92214596271515,
    "C": 33.7563781738281,
    "h": 356.735717773438,
    "CMY_C": 0.45852601528168,
    "CMY_M": 0.7383183836937,
    "CMY_Y": 0.63428556919098,
    "CMYK_C": 0,
    "CMYK_M": 0.51672357320786,
    "CMYK_Y": 0.32459464669228,
    "CMYK_K": 0.45852601528168
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0920",
    "Farbtonhilfsbezeichnung": "39.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "126",
    "Bcolor": "132",
    "Y": 22,
    "L": 54.2368698120117,
    "a": 6.31200075149536,
    "b": -1.66806840896606,
    "C": 6.52869081497192,
    "h": 345.196899414063,
    "CMY_C": 0.45255345106125,
    "CMY_M": 0.50465798377991,
    "CMY_Y": 0.48362636566162,
    "CMYK_C": 0,
    "CMYK_M": 0.09517738968134,
    "CMYK_Y": 0.05675972253084,
    "CMYK_K": 0.45255345106125
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0921",
    "Farbtonhilfsbezeichnung": "39.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "103",
    "Bcolor": "108",
    "Y": 15,
    "L": 45.1951217651367,
    "a": 6.59794473648071,
    "b": -1.0294041633606,
    "C": 6.67776536941528,
    "h": 351.132263183594,
    "CMY_C": 0.53956151008606,
    "CMY_M": 0.594318151474,
    "CMY_Y": 0.57662761211395,
    "CMYK_C": 0,
    "CMYK_M": 0.11892281472683,
    "CMYK_Y": 0.080501742661,
    "CMYK_K": 0.53956151008606
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0922",
    "Farbtonhilfsbezeichnung": "39.06.27",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "84",
    "Bcolor": "93",
    "Y": 9,
    "L": 37.0613708496094,
    "a": 6.78379154205322,
    "b": -3.89236330986023,
    "C": 7.82114553451538,
    "h": 330.153930664063,
    "CMY_C": 0.6252326965332,
    "CMY_M": 0.67107880115509,
    "CMY_Y": 0.63602864742279,
    "CMYK_C": 0,
    "CMYK_M": 0.12233218550682,
    "CMYK_Y": 0.02880707755685,
    "CMYK_K": 0.6252326965332
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0923",
    "Farbtonhilfsbezeichnung": "39.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "58",
    "Bcolor": "58",
    "Y": 6,
    "L": 25.0268955230713,
    "a": 2.78589534759521,
    "b": 0.86763840913773,
    "C": 2.9178774356842,
    "h": 17.2986621856689,
    "CMY_C": 0.74810421466827,
    "CMY_M": 0.77259558439255,
    "CMY_Y": 0.7740364074707,
    "CMYK_C": 0,
    "CMYK_M": 0.09722818434238,
    "CMYK_Y": 0.10294809937477,
    "CMYK_K": 0.74810421466827
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0924",
    "Farbtonhilfsbezeichnung": "39.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "132",
    "Bcolor": "144",
    "Y": 27,
    "L": 57.671932220459,
    "a": 11.0175285339356,
    "b": -3.69018697738647,
    "C": 11.6190967559815,
    "h": 341.482360839844,
    "CMY_C": 0.39135193824768,
    "CMY_M": 0.48076367378235,
    "CMY_Y": 0.4348771572113,
    "CMYK_C": 0,
    "CMYK_M": 0.14690218865871,
    "CMYK_Y": 0.07151130586863,
    "CMYK_K": 0.39135193824768
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0925",
    "Farbtonhilfsbezeichnung": "39.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "101",
    "Bcolor": "117",
    "Y": 15,
    "L": 45.7169570922852,
    "a": 12.6896800994873,
    "b": -5.69069528579712,
    "C": 13.9072637557983,
    "h": 335.846130371094,
    "CMY_C": 0.50830346345901,
    "CMY_M": 0.60233283042908,
    "CMY_Y": 0.54087615013123,
    "CMYK_C": 0,
    "CMYK_M": 0.19123455882072,
    "CMYK_Y": 0.0662455111742,
    "CMYK_K": 0.50830346345901
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0926",
    "Farbtonhilfsbezeichnung": "39.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "74",
    "Bcolor": "91",
    "Y": 8,
    "L": 34.788948059082,
    "a": 14.1139011383057,
    "b": -6.29170513153076,
    "C": 15.4527587890625,
    "h": 335.973602294922,
    "CMY_C": 0.60888910293579,
    "CMY_M": 0.7086124420166,
    "CMY_Y": 0.6417715549469,
    "CMYK_C": 0,
    "CMYK_M": 0.25497457385063,
    "CMYK_Y": 0.0840744972229,
    "CMYK_K": 0.60888910293579
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0927",
    "Farbtonhilfsbezeichnung": "39.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "118",
    "Bcolor": "139",
    "Y": 21,
    "L": 53.8284034729004,
    "a": 18.9040451049805,
    "b": -6.50161075592041,
    "C": 19.9908447265625,
    "h": 341.020538330078,
    "CMY_C": 0.38809823989868,
    "CMY_M": 0.53865694999695,
    "CMY_Y": 0.45408809185028,
    "CMYK_C": 0,
    "CMYK_M": 0.24605046212673,
    "CMYK_Y": 0.10784386843443,
    "CMYK_K": 0.38809823989868
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0928",
    "Farbtonhilfsbezeichnung": "39.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "97",
    "Bcolor": "119",
    "Y": 14,
    "L": 45.1975326538086,
    "a": 18.0696811676025,
    "b": -7.29144048690796,
    "C": 19.4853401184082,
    "h": 338.025054931641,
    "CMY_C": 0.48453140258789,
    "CMY_M": 0.62061661481857,
    "CMY_Y": 0.53506022691727,
    "CMYK_C": 0,
    "CMYK_M": 0.26400291919708,
    "CMYK_Y": 0.09802503138781,
    "CMYK_K": 0.48453140258789
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0929",
    "Farbtonhilfsbezeichnung": "39.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "75",
    "Bcolor": "101",
    "Y": 8,
    "L": 36.4304618835449,
    "a": 19.6177539825439,
    "b": -9.53253269195557,
    "C": 21.8111305236816,
    "h": 334.084259033203,
    "CMY_C": 0.56917595863342,
    "CMY_M": 0.70688658952713,
    "CMY_Y": 0.60571146011353,
    "CMYK_C": 0,
    "CMYK_M": 0.31964471936226,
    "CMYK_Y": 0.08480376750231,
    "CMYK_K": 0.56917595863342
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0930",
    "Farbtonhilfsbezeichnung": "39.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "114",
    "Bcolor": "145",
    "Y": 23,
    "L": 54.8207969665527,
    "a": 27.0892429351807,
    "b": -8.48922634124756,
    "C": 28.3882732391357,
    "h": 342.600067138672,
    "CMY_C": 0.33214789628983,
    "CMY_M": 0.55143761634827,
    "CMY_Y": 0.42980796098709,
    "CMYK_C": 0,
    "CMYK_M": 0.32835072278976,
    "CMYK_Y": 0.14623007178307,
    "CMYK_K": 0.33214789628983
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0931",
    "Farbtonhilfsbezeichnung": "39.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "89",
    "Bcolor": "119",
    "Y": 14,
    "L": 44.1033554077148,
    "a": 25.5800952911377,
    "b": -9.03897380828857,
    "C": 27.1301364898682,
    "h": 340.538635253906,
    "CMY_C": 0.45564562082291,
    "CMY_M": 0.6518360376358,
    "CMY_Y": 0.5337473154068,
    "CMYK_C": 0,
    "CMYK_M": 0.36040937900543,
    "CMYK_Y": 0.14347583055496,
    "CMYK_K": 0.45564562082291
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0932",
    "Farbtonhilfsbezeichnung": "39.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "78",
    "Bcolor": "106",
    "Y": 10,
    "L": 39.1901016235352,
    "a": 24.6082515716553,
    "b": -8.90008926391602,
    "C": 26.1682567596436,
    "h": 340.116424560547,
    "CMY_C": 0.51136362552643,
    "CMY_M": 0.69573199748993,
    "CMY_Y": 0.58258163928986,
    "CMYK_C": 0,
    "CMYK_M": 0.37731200456619,
    "CMYK_Y": 0.1457484960556,
    "CMYK_K": 0.51136362552643
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0933",
    "Farbtonhilfsbezeichnung": "39.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "65",
    "Bcolor": "85",
    "Y": 5,
    "L": 31.1890907287598,
    "a": 16.4824371337891,
    "b": -7.81575393676758,
    "C": 18.2416210174561,
    "h": 334.630310058594,
    "CMY_C": 0.6338055729866,
    "CMY_M": 0.74696266651154,
    "CMY_Y": 0.66585063934326,
    "CMYK_C": 0,
    "CMYK_M": 0.30900824069977,
    "CMYK_Y": 0.08750834316015,
    "CMYK_K": 0.6338055729866
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0934",
    "Farbtonhilfsbezeichnung": "39.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "105",
    "Bcolor": "154",
    "Y": 23,
    "L": 55.0902938842773,
    "a": 40.0554504394531,
    "b": -13.11936378479,
    "C": 42.1492195129395,
    "h": 341.864837646484,
    "CMY_C": 0.2636786699295,
    "CMY_M": 0.58998823165894,
    "CMY_Y": 0.39466845989227,
    "CMYK_C": 0,
    "CMYK_M": 0.44316190481186,
    "CMYK_Y": 0.17789758741856,
    "CMYK_K": 0.2636786699295
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0935",
    "Farbtonhilfsbezeichnung": "42.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "129",
    "Bcolor": "133",
    "Y": 23,
    "L": 55.0572280883789,
    "a": 5.34425401687622,
    "b": -1.38258361816406,
    "C": 5.52019834518433,
    "h": 345.495330810547,
    "CMY_C": 0.44996297359467,
    "CMY_M": 0.49430537223816,
    "CMY_Y": 0.47743743658066,
    "CMYK_C": 0,
    "CMYK_M": 0.08061711490154,
    "CMYK_Y": 0.04995020478964,
    "CMYK_K": 0.44996297359467
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0936",
    "Farbtonhilfsbezeichnung": "42.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "106",
    "Bcolor": "113",
    "Y": 15,
    "L": 45.9944877624512,
    "a": 5.56688117980957,
    "b": -2.85021662712097,
    "C": 6.25411081314087,
    "h": 332.887756347656,
    "CMY_C": 0.54357916116714,
    "CMY_M": 0.58378446102142,
    "CMY_Y": 0.55729269981384,
    "CMYK_C": 0,
    "CMYK_M": 0.08808822184801,
    "CMYK_Y": 0.03004582040012,
    "CMYK_K": 0.54357916116714
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0937",
    "Farbtonhilfsbezeichnung": "42.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "89",
    "Bcolor": "99",
    "Y": 10,
    "L": 39.3234214782715,
    "a": 7.14841079711914,
    "b": -4.49185466766357,
    "C": 8.44254302978516,
    "h": 327.855926513672,
    "CMY_C": 0.60297048091888,
    "CMY_M": 0.6505600810051,
    "CMY_Y": 0.61086112260818,
    "CMYK_C": 0,
    "CMYK_M": 0.11986413598061,
    "CMYK_Y": 0.01987419463694,
    "CMYK_K": 0.60297048091888
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0938",
    "Farbtonhilfsbezeichnung": "42.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "123",
    "Bcolor": "141",
    "Y": 21,
    "L": 53.7176818847656,
    "a": 11.0027294158935,
    "b": -7.78534603118896,
    "C": 13.4785633087158,
    "h": 324.717407226563,
    "CMY_C": 0.44448763132095,
    "CMY_M": 0.51913696527481,
    "CMY_Y": 0.44765782356262,
    "CMYK_C": 0,
    "CMYK_M": 0.1343792527914,
    "CMYK_Y": 0.00570678943768,
    "CMYK_K": 0.44448763132095
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0939",
    "Farbtonhilfsbezeichnung": "42.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "102",
    "Bcolor": "122",
    "Y": 15,
    "L": 45.5273056030273,
    "a": 10.9285154342651,
    "b": -8.7286434173584,
    "C": 13.9864816665649,
    "h": 321.385528564453,
    "CMY_C": 0.53045415878296,
    "CMY_M": 0.59895616769791,
    "CMY_Y": 0.52340757846832,
    "CMYK_C": 0.01478533819318,
    "CMYK_M": 0.15851823985577,
    "CMYK_Y": 0,
    "CMYK_K": 0.52340757846832
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0940",
    "Farbtonhilfsbezeichnung": "42.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "83",
    "Bcolor": "103",
    "Y": 9,
    "L": 37.5532073974609,
    "a": 11.7751092910767,
    "b": -9.42692756652832,
    "C": 15.0837717056274,
    "h": 321.319915771484,
    "CMY_C": 0.60519182682037,
    "CMY_M": 0.67635172605515,
    "CMY_Y": 0.59647238254547,
    "CMYK_C": 0.02160804904997,
    "CMYK_M": 0.19795261323452,
    "CMYK_Y": 0,
    "CMYK_K": 0.59647238254547
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0941",
    "Farbtonhilfsbezeichnung": "42.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "119",
    "Bcolor": "146",
    "Y": 22,
    "L": 53.6983261108398,
    "a": 17.6176013946533,
    "b": -10.5589981079102,
    "C": 20.539529800415,
    "h": 329.063903808594,
    "CMY_C": 0.40924066305161,
    "CMY_M": 0.53517949581146,
    "CMY_Y": 0.42868387699127,
    "CMYK_C": 0,
    "CMYK_M": 0.21318128705025,
    "CMYK_Y": 0.03291224315763,
    "CMYK_K": 0.40924066305161
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0942",
    "Farbtonhilfsbezeichnung": "42.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "98",
    "Bcolor": "132",
    "Y": 17,
    "L": 45.935718536377,
    "a": 19.2854232788086,
    "b": -14.3365306854248,
    "C": 24.0304737091064,
    "h": 323.373382568359,
    "CMY_C": 0.48970222473145,
    "CMY_M": 0.61433732509613,
    "CMY_Y": 0.48230719566345,
    "CMYK_C": 0.01428458932787,
    "CMYK_M": 0.25503566861153,
    "CMYK_Y": 0,
    "CMYK_K": 0.48230719566345
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0943",
    "Farbtonhilfsbezeichnung": "42.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "114",
    "Bcolor": "153",
    "Y": 22,
    "L": 54.1215362548828,
    "a": 25.4575290679932,
    "b": -14.3011264801025,
    "C": 29.1994514465332,
    "h": 330.674285888672,
    "CMY_C": 0.36559796333313,
    "CMY_M": 0.55144375562668,
    "CMY_Y": 0.39860063791275,
    "CMYK_C": 0,
    "CMYK_M": 0.29294639825821,
    "CMYK_Y": 0.05202170461416,
    "CMYK_K": 0.36559796333313
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0944",
    "Farbtonhilfsbezeichnung": "42.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "96",
    "Bcolor": "131",
    "Y": 14,
    "L": 45.9991836547852,
    "a": 22.5796146392822,
    "b": -13.4819345474243,
    "C": 26.298318862915,
    "h": 329.159240722656,
    "CMY_C": 0.46588909626007,
    "CMY_M": 0.62315851449966,
    "CMY_Y": 0.48682099580765,
    "CMYK_C": 0,
    "CMYK_M": 0.29445087909698,
    "CMYK_Y": 0.03919017314911,
    "CMYK_K": 0.46588909626007
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0945",
    "Farbtonhilfsbezeichnung": "42.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "78",
    "Bcolor": "107",
    "Y": 9,
    "L": 36.9709396362305,
    "a": 17.6427173614502,
    "b": -12.5283346176148,
    "C": 21.6384983062744,
    "h": 324.620910644531,
    "CMY_C": 0.58385336399078,
    "CMY_M": 0.6954819560051,
    "CMY_Y": 0.58220171928406,
    "CMYK_C": 0.0039532110095,
    "CMYK_M": 0.27113619446754,
    "CMYK_Y": 0,
    "CMYK_K": 0.58220171928406
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0946",
    "Farbtonhilfsbezeichnung": "42.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "65",
    "Bcolor": "84",
    "Y": 5,
    "L": 29.8858547210693,
    "a": 11.6081123352051,
    "b": -8.81240367889404,
    "C": 14.5741806030273,
    "h": 322.795715332031,
    "CMY_C": 0.67717462778091,
    "CMY_M": 0.74617958068848,
    "CMY_Y": 0.6724573969841,
    "CMYK_C": 0.01440188474953,
    "CMYK_M": 0.22507663071156,
    "CMYK_Y": 0,
    "CMYK_K": 0.6724573969841
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0947",
    "Farbtonhilfsbezeichnung": "42.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "107",
    "Bcolor": "162",
    "Y": 22,
    "L": 53.8274841308594,
    "a": 34.9670600891113,
    "b": -19.8622398376465,
    "C": 40.2144737243652,
    "h": 330.402252197266,
    "CMY_C": 0.32579636573792,
    "CMY_M": 0.58194208145142,
    "CMY_Y": 0.36361527442932,
    "CMYK_C": 0,
    "CMYK_M": 0.37992337346077,
    "CMYK_Y": 0.05609419196844,
    "CMYK_K": 0.32579636573792
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0948",
    "Farbtonhilfsbezeichnung": "42.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "83",
    "Bcolor": "139",
    "Y": 14,
    "L": 44.4278144836426,
    "a": 34.408203125,
    "b": -20.5796413421631,
    "C": 40.0929679870605,
    "h": 329.116241455078,
    "CMY_C": 0.43149834871292,
    "CMY_M": 0.67257821559906,
    "CMY_Y": 0.45571482181549,
    "CMYK_C": 0,
    "CMYK_M": 0.42406186461449,
    "CMYK_Y": 0.04259701445699,
    "CMYK_K": 0.43149834871292
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0949",
    "Farbtonhilfsbezeichnung": "42.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "71",
    "Bcolor": "111",
    "Y": 10,
    "L": 38.5888748168945,
    "a": 30.7757205963135,
    "b": -12.275239944458,
    "C": 33.1334648132324,
    "h": 338.254852294922,
    "CMY_C": 0.49123042821884,
    "CMY_M": 0.71990972757339,
    "CMY_Y": 0.5666595697403,
    "CMYK_C": 0,
    "CMYK_M": 0.44947519898415,
    "CMYK_Y": 0.14825797080994,
    "CMYK_K": 0.49123042821884
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0950",
    "Farbtonhilfsbezeichnung": "42.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "116",
    "Bcolor": "166",
    "Y": 23,
    "L": 54.6779365539551,
    "a": 26.4505367279053,
    "b": -20.6031036376953,
    "C": 33.5278816223145,
    "h": 322.083923339844,
    "CMY_C": 0.37290865182877,
    "CMY_M": 0.54632186889648,
    "CMY_Y": 0.35073387622833,
    "CMYK_C": 0.03415359929204,
    "CMYK_M": 0.30124473571777,
    "CMYK_Y": 0,
    "CMYK_K": 0.35073387622833
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0951",
    "Farbtonhilfsbezeichnung": "42.21.24",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "89",
    "Bcolor": "135",
    "Y": 14,
    "L": 44.7701263427734,
    "a": 28.6972522735596,
    "b": -18.0479679107666,
    "C": 33.9007586015473,
    "h": 327.83383217691,
    "CMY_C": 0.50196075439453,
    "CMY_M": 0.50980389118195,
    "CMY_Y": 0.68627452850342,
    "CMYK_C": 0,
    "CMYK_M": 0.01574802957475,
    "CMYK_Y": 0.37007880210876,
    "CMYK_K": 0.50196075
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0952",
    "Farbtonhilfsbezeichnung": "45.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "132",
    "Bcolor": "138",
    "Y": 23,
    "L": 55.6906814575195,
    "a": 2.66192531585693,
    "b": -3.32857513427734,
    "C": 4.26207208633423,
    "h": 308.649993896484,
    "CMY_C": 0.4683296084404,
    "CMY_M": 0.48138308525085,
    "CMY_Y": 0.45839720964432,
    "CMYK_C": 0.01833889819682,
    "CMYK_M": 0.04244046658278,
    "CMYK_Y": 0,
    "CMYK_K": 0.45839720964432
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0953",
    "Farbtonhilfsbezeichnung": "45.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "106",
    "Bcolor": "112",
    "Y": 15,
    "L": 45.3981552124023,
    "a": 3.12489819526672,
    "b": -3.42075634002686,
    "C": 4.63320207595825,
    "h": 312.412048339844,
    "CMY_C": 0.56761682033539,
    "CMY_M": 0.58405935764313,
    "CMY_Y": 0.5597020983696,
    "CMYK_C": 0.01797583326697,
    "CMYK_M": 0.05531995370984,
    "CMYK_Y": 0,
    "CMYK_K": 0.5597020983696
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0954",
    "Farbtonhilfsbezeichnung": "45.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "89",
    "Bcolor": "96",
    "Y": 9,
    "L": 38.1519088745117,
    "a": 2.9882869720459,
    "b": -4.45153999328613,
    "C": 5.36153602600098,
    "h": 303.873168945313,
    "CMY_C": 0.64127576351166,
    "CMY_M": 0.6525799036026,
    "CMY_Y": 0.62268704175949,
    "CMYK_C": 0.04926605895162,
    "CMYK_M": 0.07922564446926,
    "CMYK_Y": 0,
    "CMYK_K": 0.62268704175949
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0955",
    "Farbtonhilfsbezeichnung": "45.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "71",
    "Bcolor": "81",
    "Y": 6,
    "L": 30.703161239624,
    "a": 2.83407235145569,
    "b": -6.24329566955566,
    "C": 6.85643529891968,
    "h": 294.415130615234,
    "CMY_C": 0.71700721979141,
    "CMY_M": 0.72041112184525,
    "CMY_Y": 0.68121117353439,
    "CMYK_C": 0.11228764057159,
    "CMYK_M": 0.12296525388956,
    "CMYK_Y": 0,
    "CMYK_K": 0.68121117353439
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0956",
    "Farbtonhilfsbezeichnung": "45.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "129",
    "Bcolor": "147",
    "Y": 23,
    "L": 55.3246994018555,
    "a": 7.39416551589966,
    "b": -8.9463062286377,
    "C": 11.6064672470093,
    "h": 309.573913574219,
    "CMY_C": 0.45689594745636,
    "CMY_M": 0.49414300918579,
    "CMY_Y": 0.42400079965591,
    "CMYK_C": 0.05710970982909,
    "CMYK_M": 0.12177483737469,
    "CMYK_Y": 0,
    "CMYK_K": 0.42400079965591
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0957",
    "Farbtonhilfsbezeichnung": "45.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "104",
    "Bcolor": "123",
    "Y": 14,
    "L": 45.2565460205078,
    "a": 7.7753438949585,
    "b": -10.060338973999,
    "C": 12.7148103713989,
    "h": 307.699401855469,
    "CMY_C": 0.55863475799561,
    "CMY_M": 0.59378838539124,
    "CMY_Y": 0.51785433292389,
    "CMYK_C": 0.08458112925291,
    "CMYK_M": 0.1574919372797,
    "CMYK_Y": 0,
    "CMYK_K": 0.51785433292389
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0958",
    "Farbtonhilfsbezeichnung": "45.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "83",
    "Bcolor": "106",
    "Y": 9,
    "L": 37.2377777099609,
    "a": 9.47463703155518,
    "b": -12.1122035980225,
    "C": 15.3777179718018,
    "h": 308.033905029297,
    "CMY_C": 0.63169896602631,
    "CMY_M": 0.67302465438843,
    "CMY_Y": 0.58303618431091,
    "CMYK_C": 0.11670744419098,
    "CMYK_M": 0.21581842005253,
    "CMYK_Y": 0,
    "CMYK_K": 0.58303618431091
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0959",
    "Farbtonhilfsbezeichnung": "45.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "69",
    "Bcolor": "94",
    "Y": 6,
    "L": 31.166524887085,
    "a": 10.024640083313,
    "b": -13.646107673645,
    "C": 16.932502746582,
    "h": 306.301574707031,
    "CMY_C": 0.69054025411606,
    "CMY_M": 0.72939014434814,
    "CMY_Y": 0.63155150413513,
    "CMYK_C": 0.16010040044785,
    "CMYK_M": 0.26554223895073,
    "CMYK_Y": 0,
    "CMYK_K": 0.63155150413513
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0960",
    "Farbtonhilfsbezeichnung": "45.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "125",
    "Bcolor": "158",
    "Y": 22,
    "L": 54.6195793151855,
    "a": 12.1044988632202,
    "b": -16.7214775085449,
    "C": 20.6428375244141,
    "h": 305.900390625,
    "CMY_C": 0.45815169811249,
    "CMY_M": 0.50985896587372,
    "CMY_Y": 0.3787966966629,
    "CMYK_C": 0.12774400413036,
    "CMYK_M": 0.21098127961159,
    "CMYK_Y": 0,
    "CMYK_K": 0.3787966966629
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0961",
    "Farbtonhilfsbezeichnung": "45.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "105",
    "Bcolor": "136",
    "Y": 16,
    "L": 46.7832641601563,
    "a": 12.5790576934815,
    "b": -15.7484674453735,
    "C": 20.1555671691895,
    "h": 308.616027832031,
    "CMY_C": 0.53031325340271,
    "CMY_M": 0.58845883607864,
    "CMY_Y": 0.4653405547142,
    "CMYK_C": 0.12152165174484,
    "CMYK_M": 0.23027421534061,
    "CMYK_Y": 0,
    "CMYK_K": 0.4653405547142
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0962",
    "Farbtonhilfsbezeichnung": "45.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "82",
    "Bcolor": "116",
    "Y": 9,
    "L": 37.7500991821289,
    "a": 14.2231502532959,
    "b": -17.0338592529297,
    "C": 22.1912231445313,
    "h": 309.861633300781,
    "CMY_C": 0.61252927780151,
    "CMY_M": 0.67784851789474,
    "CMY_Y": 0.5468829870224,
    "CMYK_C": 0.14487712085247,
    "CMYK_M": 0.28903245925903,
    "CMYK_Y": 0,
    "CMYK_K": 0.5468829870224
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0963",
    "Farbtonhilfsbezeichnung": "45.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "123",
    "Bcolor": "152",
    "Y": 22,
    "L": 54.5665702819824,
    "a": 14.6125335693359,
    "b": -12.9665088653565,
    "C": 19.5360298156738,
    "h": 318.415588378906,
    "CMY_C": 0.42787843942642,
    "CMY_M": 0.51794230937958,
    "CMY_Y": 0.40413242578506,
    "CMYK_C": 0.03985115885735,
    "CMYK_M": 0.19099861383438,
    "CMYK_Y": 0,
    "CMYK_K": 0.40413242578506
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0964",
    "Farbtonhilfsbezeichnung": "45.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "100",
    "Bcolor": "130",
    "Y": 14,
    "L": 45.5305099487305,
    "a": 15.2078590393066,
    "b": -13.8933458328247,
    "C": 20.5986423492432,
    "h": 317.586303710938,
    "CMY_C": 0.51873350143433,
    "CMY_M": 0.6077446937561,
    "CMY_Y": 0.48965728282928,
    "CMYK_C": 0.05697390809655,
    "CMYK_M": 0.23138844966888,
    "CMYK_Y": 0,
    "CMYK_K": 0.48965728282928
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0965",
    "Farbtonhilfsbezeichnung": "45.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "76",
    "Bcolor": "128",
    "Y": 8,
    "L": 37.0625114440918,
    "a": 21.6590385437012,
    "b": -25.8985900878906,
    "C": 33.7616767883301,
    "h": 309.905792236328,
    "CMY_C": 0.60341912508011,
    "CMY_M": 0.70007437467575,
    "CMY_Y": 0.49742996692657,
    "CMYK_C": 0.2108943015337,
    "CMYK_M": 0.40321624279022,
    "CMYK_Y": 0,
    "CMYK_K": 0.49742996692657
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0966",
    "Farbtonhilfsbezeichnung": "45.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "118",
    "Bcolor": "176",
    "Y": 23,
    "L": 54.3619651794434,
    "a": 22.6605415344238,
    "b": -27.0708065032959,
    "C": 35.3033790588379,
    "h": 309.932159423828,
    "CMY_C": 0.42549562454224,
    "CMY_M": 0.5358704328537,
    "CMY_Y": 0.31113016605377,
    "CMYK_C": 0.16601896286011,
    "CMYK_M": 0.32624489068985,
    "CMYK_Y": 0,
    "CMYK_K": 0.31113016605377
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0967",
    "Farbtonhilfsbezeichnung": "45.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "92",
    "Bcolor": "152",
    "Y": 14,
    "L": 44.3542861938477,
    "a": 24.3373641967773,
    "b": -28.7157344818115,
    "C": 37.6417427062988,
    "h": 310.282196044922,
    "CMY_C": 0.52357447147369,
    "CMY_M": 0.63759052753448,
    "CMY_Y": 0.4049066901207,
    "CMYK_C": 0.19941037893295,
    "CMYK_M": 0.39100396633148,
    "CMYK_Y": 0,
    "CMYK_K": 0.4049066901207
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0968",
    "Farbtonhilfsbezeichnung": "45.18.30",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "65",
    "Bcolor": "98",
    "Y": 6,
    "L": 30.8388290405273,
    "a": 15.7721157073975,
    "b": -16.6731395721436,
    "C": 22.9511051177979,
    "h": 313.409271240234,
    "CMY_C": 0.66741365194321,
    "CMY_M": 0.74511742591858,
    "CMY_Y": 0.61582052707672,
    "CMYK_C": 0.13429433107376,
    "CMYK_M": 0.33655336499214,
    "CMYK_Y": 0,
    "CMYK_K": 0.61582052707672
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0969",
    "Farbtonhilfsbezeichnung": "48.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "132",
    "Bcolor": "142",
    "Y": 23,
    "L": 55.1001052856445,
    "a": 0.26815697550774,
    "b": -6.66784811019897,
    "C": 6.6732382774353,
    "h": 272.302978515625,
    "CMY_C": 0.50333774089813,
    "CMY_M": 0.48118245601654,
    "CMY_Y": 0.44231712818146,
    "CMYK_C": 0.10941812396049,
    "CMYK_M": 0.06969073414803,
    "CMYK_Y": 0,
    "CMYK_K": 0.44231712818146
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0970",
    "Farbtonhilfsbezeichnung": "48.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "106",
    "Bcolor": "118",
    "Y": 14,
    "L": 44.7421073913574,
    "a": 0.75180470943451,
    "b": -7.66204833984375,
    "C": 7.69884395599365,
    "h": 275.603942871094,
    "CMY_C": 0.60513097047806,
    "CMY_M": 0.58422291278839,
    "CMY_Y": 0.53908723592758,
    "CMYK_C": 0.14328901469707,
    "CMYK_M": 0.09792672097683,
    "CMYK_Y": 0,
    "CMYK_K": 0.53908723592758
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0971",
    "Farbtonhilfsbezeichnung": "48.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "92",
    "Bcolor": "105",
    "Y": 10,
    "L": 38.9328994750977,
    "a": 1.46163237094879,
    "b": -8.57708835601807,
    "C": 8.7007360458374,
    "h": 279.670959472656,
    "CMY_C": 0.65861546993256,
    "CMY_M": 0.64092803001404,
    "CMY_Y": 0.58959454298019,
    "CMYK_C": 0.1681774109602,
    "CMYK_M": 0.12507992982864,
    "CMYK_Y": 0,
    "CMYK_K": 0.58959454298019
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0972",
    "Farbtonhilfsbezeichnung": "48.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "72",
    "Bcolor": "82",
    "Y": 6,
    "L": 30.6731700897217,
    "a": 1.77411258220673,
    "b": -6.8269567489624,
    "C": 7.05370903015137,
    "h": 284.567169189453,
    "CMY_C": 0.72637927532196,
    "CMY_M": 0.71840554475784,
    "CMY_Y": 0.67807859182358,
    "CMYK_C": 0.15003874897957,
    "CMYK_M": 0.125269562006,
    "CMYK_Y": 0,
    "CMYK_K": 0.67807859182358
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0973",
    "Farbtonhilfsbezeichnung": "48.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "129",
    "Bcolor": "150",
    "Y": 23,
    "L": 54.773853302002,
    "a": 5.99059820175171,
    "b": -11.6021633148193,
    "C": 13.0574674606323,
    "h": 297.308868408203,
    "CMY_C": 0.48205530643463,
    "CMY_M": 0.49559980630875,
    "CMY_Y": 0.41205060482025,
    "CMYK_C": 0.11906585842371,
    "CMYK_M": 0.14210270345211,
    "CMYK_Y": 0,
    "CMYK_K": 0.41205060482025
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0974",
    "Farbtonhilfsbezeichnung": "48.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "107",
    "Bcolor": "129",
    "Y": 15,
    "L": 46.3460235595703,
    "a": 6.81072425842285,
    "b": -12.1190948486328,
    "C": 13.9017419815063,
    "h": 299.335235595703,
    "CMY_C": 0.56195867061615,
    "CMY_M": 0.5804101228714,
    "CMY_Y": 0.4938400387764,
    "CMYK_C": 0.13457925617695,
    "CMYK_M": 0.17103305459023,
    "CMYK_Y": 0,
    "CMYK_K": 0.4938400387764
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0975",
    "Farbtonhilfsbezeichnung": "48.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "84",
    "Bcolor": "106",
    "Y": 9,
    "L": 37.064266204834,
    "a": 6.91324901580811,
    "b": -12.0588827133179,
    "C": 13.8999881744385,
    "h": 299.825256347656,
    "CMY_C": 0.65048336982727,
    "CMY_M": 0.66890382766724,
    "CMY_Y": 0.58528983592987,
    "CMYK_C": 0.15720264613628,
    "CMYK_M": 0.20162031054497,
    "CMYK_Y": 0,
    "CMYK_K": 0.58528983592987
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0976",
    "Farbtonhilfsbezeichnung": "48.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "69",
    "Bcolor": "94",
    "Y": 6,
    "L": 31.0718574523926,
    "a": 9.59021854400635,
    "b": -13.5337820053101,
    "C": 16.5872097015381,
    "h": 305.321899414063,
    "CMY_C": 0.69386667013168,
    "CMY_M": 0.72929251194,
    "CMY_Y": 0.63316518068314,
    "CMYK_C": 0.1654736250639,
    "CMYK_M": 0.26204526424408,
    "CMYK_Y": 0,
    "CMYK_K": 0.63316518068314
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0977",
    "Farbtonhilfsbezeichnung": "48.12.21",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "107",
    "Bcolor": "154",
    "Y": 19,
    "L": 48.2083778381348,
    "a": 15.8253269195557,
    "b": -24.1943359375,
    "C": 28.9103240966797,
    "h": 303.188385009766,
    "CMY_C": 0.52597379684448,
    "CMY_M": 0.57947373390198,
    "CMY_Y": 0.39533412456512,
    "CMYK_C": 0.2160526663065,
    "CMYK_M": 0.30453118681908,
    "CMYK_Y": 0,
    "CMYK_K": 0.39533412456512
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0978",
    "Farbtonhilfsbezeichnung": "48.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "101",
    "Bcolor": "131",
    "Y": 14,
    "L": 44.416187286377,
    "a": 9.73525428771973,
    "b": -16.3677482604981,
    "C": 19.044116973877,
    "h": 300.743438720703,
    "CMY_C": 0.57599800825119,
    "CMY_M": 0.60430216789246,
    "CMY_Y": 0.48542636632919,
    "CMYK_C": 0.17601299285889,
    "CMYK_M": 0.23101805150509,
    "CMYK_Y": 0,
    "CMYK_K": 0.48542636632919
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0979",
    "Farbtonhilfsbezeichnung": "48.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "83",
    "Bcolor": "113",
    "Y": 9,
    "L": 37.0899658203125,
    "a": 10.0881748199463,
    "b": -16.2514095306396,
    "C": 19.1279792785645,
    "h": 301.830230712891,
    "CMY_C": 0.64393818378448,
    "CMY_M": 0.67439472675323,
    "CMY_Y": 0.55861461162567,
    "CMYK_C": 0.19330856204033,
    "CMYK_M": 0.26231071352959,
    "CMYK_Y": 0,
    "CMYK_K": 0.55861461162567
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0980",
    "Farbtonhilfsbezeichnung": "48.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "126",
    "Bcolor": "181",
    "Y": 24,
    "L": 55.8210220336914,
    "a": 16.8999443054199,
    "b": -27.7371559143066,
    "C": 32.4801177978516,
    "h": 301.353485107422,
    "CMY_C": 0.45547205209732,
    "CMY_M": 0.50562590360641,
    "CMY_Y": 0.29168325662613,
    "CMYK_C": 0.2312366515398,
    "CMYK_M": 0.30204376578331,
    "CMYK_Y": 0,
    "CMYK_K": 0.29168325662613
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0981",
    "Farbtonhilfsbezeichnung": "48.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "100",
    "Bcolor": "160",
    "Y": 15,
    "L": 46.1762733459473,
    "a": 20.0996608734131,
    "b": -30.799409866333,
    "C": 36.7777099609375,
    "h": 303.12841796875,
    "CMY_C": 0.5443103313446,
    "CMY_M": 0.6073831319809,
    "CMY_Y": 0.37275034189224,
    "CMYK_C": 0.27351149916649,
    "CMYK_M": 0.37406602501869,
    "CMYK_Y": 0,
    "CMYK_K": 0.37275034189224
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0982",
    "Farbtonhilfsbezeichnung": "48.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "80",
    "Bcolor": "132",
    "Y": 9,
    "L": 37.824291229248,
    "a": 18.9363040924072,
    "b": -27.1367359161377,
    "C": 33.0905723571777,
    "h": 304.907745361328,
    "CMY_C": 0.61974835395813,
    "CMY_M": 0.68503272533417,
    "CMY_Y": 0.4821869134903,
    "CMYK_C": 0.26565849781036,
    "CMYK_M": 0.39173558354378,
    "CMYK_Y": 0,
    "CMYK_K": 0.4821869134903
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0983",
    "Farbtonhilfsbezeichnung": "48.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "68",
    "Bcolor": "109",
    "Y": 6,
    "L": 31.9434757232666,
    "a": 16.0080127716064,
    "b": -21.8704853057861,
    "C": 27.1030368804932,
    "h": 306.202117919922,
    "CMY_C": 0.67465841770172,
    "CMY_M": 0.7336550951004,
    "CMY_Y": 0.57350778579712,
    "CMYK_C": 0.23716875910759,
    "CMYK_M": 0.3754988014698,
    "CMYK_Y": 0,
    "CMYK_K": 0.57350778579712
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0984",
    "Farbtonhilfsbezeichnung": "48.15.33",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "68",
    "Bcolor": "104",
    "Y": 6,
    "L": 31.1169395446777,
    "a": 13.0415573120117,
    "b": -20.4197864532471,
    "C": 24.2291126251221,
    "h": 302.565246582031,
    "CMY_C": 0.69668173789978,
    "CMY_M": 0.73438322544098,
    "CMY_Y": 0.59062904119492,
    "CMYK_C": 0.25906258821487,
    "CMYK_M": 0.35115873813629,
    "CMYK_Y": 0,
    "CMYK_K": 0.59062904119492
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0985",
    "Farbtonhilfsbezeichnung": "51.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "127",
    "Bcolor": "126",
    "Y": 23,
    "L": 53.0001907348633,
    "a": -0.56113088130951,
    "b": -0.20873928070068,
    "C": 0.59869855642319,
    "h": 200.405075073242,
    "CMY_C": 0.50849199295044,
    "CMY_M": 0.50224941968918,
    "CMY_Y": 0.50648820400238,
    "CMYK_C": 0.01254156883806,
    "CMYK_M": 0,
    "CMYK_Y": 0.00851588044316,
    "CMYK_K": 0.50224941968918
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0986",
    "Farbtonhilfsbezeichnung": "51.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "131",
    "Bcolor": "141",
    "Y": 23,
    "L": 54.6974792480469,
    "a": 1.49960243701935,
    "b": -6.58238792419434,
    "C": 6.75104713439941,
    "h": 282.834106445313,
    "CMY_C": 0.49783486127853,
    "CMY_M": 0.48790788650513,
    "CMY_Y": 0.44683063030243,
    "CMYK_C": 0.09220363944769,
    "CMYK_M": 0.07425800710917,
    "CMYK_Y": 0,
    "CMYK_K": 0.44683063030243
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0987",
    "Farbtonhilfsbezeichnung": "51.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "110",
    "Bcolor": "123",
    "Y": 15,
    "L": 46.755859375,
    "a": 1.88893532752991,
    "b": -8.07797908782959,
    "C": 8.29589176177979,
    "h": 283.161437988281,
    "CMY_C": 0.57880073785782,
    "CMY_M": 0.56692218780518,
    "CMY_Y": 0.51645267009735,
    "CMYK_C": 0.12893891334534,
    "CMYK_M": 0.10437347739935,
    "CMYK_Y": 0,
    "CMYK_K": 0.51645267009735
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0988",
    "Farbtonhilfsbezeichnung": "51.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "90",
    "Bcolor": "105",
    "Y": 10,
    "L": 38.7705764770508,
    "a": 2.90088367462158,
    "b": -8.74763202667236,
    "C": 9.21608352661133,
    "h": 288.346527099609,
    "CMY_C": 0.65045750141144,
    "CMY_M": 0.64537119865417,
    "CMY_Y": 0.58994126319885,
    "CMYK_C": 0.14757943153381,
    "CMYK_M": 0.13517560064793,
    "CMYK_Y": 0,
    "CMYK_K": 0.58994126319885
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0989",
    "Farbtonhilfsbezeichnung": "51.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "68",
    "Bcolor": "79",
    "Y": 5,
    "L": 29.3185081481934,
    "a": 2.94659399986267,
    "b": -7.06244850158691,
    "C": 7.65248966217041,
    "h": 292.646881103516,
    "CMY_C": 0.73149275779724,
    "CMY_M": 0.73288011550903,
    "CMY_Y": 0.68899464607239,
    "CMYK_C": 0.13664752244949,
    "CMYK_M": 0.14110840857029,
    "CMYK_Y": 0,
    "CMYK_K": 0.68899464607239
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0990",
    "Farbtonhilfsbezeichnung": "51.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "128",
    "Bcolor": "152",
    "Y": 22,
    "L": 54.0478515625,
    "a": 4.0332236289978,
    "b": -13.9581270217896,
    "C": 14.5291500091553,
    "h": 286.116729736328,
    "CMY_C": 0.51325911283493,
    "CMY_M": 0.49771094322205,
    "CMY_Y": 0.4039848446846,
    "CMYK_C": 0.1833414286375,
    "CMYK_M": 0.15725456178188,
    "CMYK_Y": 0,
    "CMYK_K": 0.4039848446846
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0991",
    "Farbtonhilfsbezeichnung": "51.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "110",
    "Bcolor": "132",
    "Y": 16,
    "L": 46.8569526672363,
    "a": 3.69802021980286,
    "b": -13.0134992599487,
    "C": 13.5287294387817,
    "h": 285.863464355469,
    "CMY_C": 0.5832125544548,
    "CMY_M": 0.56829524040222,
    "CMY_Y": 0.48324429988861,
    "CMYK_C": 0.19345360994339,
    "CMYK_M": 0.16458636522293,
    "CMYK_Y": 0,
    "CMYK_K": 0.48324429988861
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0992",
    "Farbtonhilfsbezeichnung": "51.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "89",
    "Bcolor": "111",
    "Y": 10,
    "L": 38.2094612121582,
    "a": 4.31597852706909,
    "b": -13.5775060653687,
    "C": 14.246976852417,
    "h": 287.63427734375,
    "CMY_C": 0.66397428512573,
    "CMY_M": 0.65211933851242,
    "CMY_Y": 0.56496357917786,
    "CMYK_C": 0.22759176790714,
    "CMYK_M": 0.20034129917622,
    "CMYK_Y": 0,
    "CMYK_K": 0.56496357917786
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0993",
    "Farbtonhilfsbezeichnung": "51.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "131",
    "Bcolor": "162",
    "Y": 23,
    "L": 55.438289642334,
    "a": 6.06620979309082,
    "b": -17.5582084655762,
    "C": 18.576587677002,
    "h": 289.059600830078,
    "CMY_C": 0.49847424030304,
    "CMY_M": 0.4871267080307,
    "CMY_Y": 0.36530083417892,
    "CMYK_C": 0.20982129871845,
    "CMYK_M": 0.19194270670414,
    "CMYK_Y": 0,
    "CMYK_K": 0.36530083417892
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0994",
    "Farbtonhilfsbezeichnung": "51.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "112",
    "Bcolor": "147",
    "Y": 17,
    "L": 47.84326171875,
    "a": 6.49261903762817,
    "b": -20.3571701049805,
    "C": 21.3674621582031,
    "h": 287.689300537109,
    "CMY_C": 0.58358305692673,
    "CMY_M": 0.56231337785721,
    "CMY_Y": 0.42510414123535,
    "CMYK_C": 0.27566543221474,
    "CMYK_M": 0.23866797983646,
    "CMYK_Y": 0,
    "CMYK_K": 0.42510414123535
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0995",
    "Farbtonhilfsbezeichnung": "51.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "89",
    "Bcolor": "121",
    "Y": 10,
    "L": 38.6976127624512,
    "a": 6.91467189788818,
    "b": -19.093017578125,
    "C": 20.3065509796143,
    "h": 289.908203125,
    "CMY_C": 0.66352617740631,
    "CMY_M": 0.65124118328094,
    "CMY_Y": 0.52526783943176,
    "CMYK_C": 0.29123440384865,
    "CMYK_M": 0.26535665988922,
    "CMYK_Y": 0,
    "CMYK_K": 0.52526783943176
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0996",
    "Farbtonhilfsbezeichnung": "51.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "48",
    "Bcolor": "91",
    "Y": 5,
    "L": 21.3593120574951,
    "a": 10.4311246871948,
    "b": -27.4860763549805,
    "C": 29.3988571166992,
    "h": 290.782043457031,
    "CMY_C": 0.84553492069244,
    "CMY_M": 0.81046426296234,
    "CMY_Y": 0.64193689823151,
    "CMYK_C": 0.56860935688019,
    "CMYK_M": 0.47066387534142,
    "CMYK_Y": 0,
    "CMYK_K": 0.64193689823151
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0997",
    "Farbtonhilfsbezeichnung": "51.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "130",
    "Bcolor": "174",
    "Y": 24,
    "L": 55.470329284668,
    "a": 8.35558986663818,
    "b": -24.7730484008789,
    "C": 26.1442127227783,
    "h": 288.638519287109,
    "CMY_C": 0.51283574104309,
    "CMY_M": 0.48943173885345,
    "CMY_Y": 0.31620478630066,
    "CMYK_C": 0.2875582575798,
    "CMYK_M": 0.25333163142204,
    "CMYK_Y": 0,
    "CMYK_K": 0.31620478630066
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0998",
    "Farbtonhilfsbezeichnung": "51.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "106",
    "Bcolor": "149",
    "Y": 15,
    "L": 46.0368843078613,
    "a": 9.56921195983887,
    "b": -24.535192489624,
    "C": 26.3352527618408,
    "h": 291.306762695313,
    "CMY_C": 0.59689688682556,
    "CMY_M": 0.58525955677032,
    "CMY_Y": 0.41605633497238,
    "CMYK_C": 0.30968835949898,
    "CMYK_M": 0.28975948691368,
    "CMYK_Y": 0,
    "CMYK_K": 0.41605633497238
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS0999",
    "Farbtonhilfsbezeichnung": "51.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "87",
    "Bcolor": "129",
    "Y": 9,
    "L": 38.6018943786621,
    "a": 10.0453853607178,
    "b": -24.1524124145508,
    "C": 26.1581497192383,
    "h": 292.583221435547,
    "CMY_C": 0.66422963142395,
    "CMY_M": 0.65721046924591,
    "CMY_Y": 0.49398255348206,
    "CMYK_C": 0.33644506335258,
    "CMYK_M": 0.32257369160652,
    "CMYK_Y": 0,
    "CMYK_K": 0.49398255348206
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1000",
    "Farbtonhilfsbezeichnung": "51.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "71",
    "Bcolor": "117",
    "Y": 7,
    "L": 32.3018379211426,
    "a": 12.8743467330933,
    "b": -26.7892951965332,
    "C": 29.7222995758057,
    "h": 295.667907714844,
    "CMY_C": 0.71633982658386,
    "CMY_M": 0.72060489654541,
    "CMY_Y": 0.53997075557709,
    "CMYK_C": 0.3833866417408,
    "CMYK_M": 0.39265796542168,
    "CMYK_Y": 0,
    "CMYK_K": 0.53997075557709
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1001",
    "Farbtonhilfsbezeichnung": "51.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "132",
    "Bcolor": "185",
    "Y": 25,
    "L": 56.7026138305664,
    "a": 11.4787216186523,
    "b": -28.6784286499023,
    "C": 30.8903427124023,
    "h": 291.814056396484,
    "CMY_C": 0.4938417673111,
    "CMY_M": 0.48289310932159,
    "CMY_Y": 0.27639549970627,
    "CMYK_C": 0.30050429701805,
    "CMYK_M": 0.28537359833717,
    "CMYK_Y": 0,
    "CMYK_K": 0.27639549970627
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1002",
    "Farbtonhilfsbezeichnung": "51.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "108",
    "Bcolor": "161",
    "Y": 16,
    "L": 47.6401329040527,
    "a": 12.4753465652466,
    "b": -29.4889545440674,
    "C": 32.0192565917969,
    "h": 292.930847167969,
    "CMY_C": 0.58246231079102,
    "CMY_M": 0.57453036308289,
    "CMY_Y": 0.36671340465546,
    "CMYK_C": 0.34068131446838,
    "CMYK_M": 0.32815626263618,
    "CMYK_Y": 0,
    "CMYK_K": 0.36671340465546
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1003",
    "Farbtonhilfsbezeichnung": "54.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "131",
    "Bcolor": "151",
    "Y": 23,
    "L": 54.6549606323242,
    "a": 0.82412552833557,
    "b": -12.279932975769,
    "C": 12.3075561523438,
    "h": 273.839447021484,
    "CMY_C": 0.52537190914154,
    "CMY_M": 0.48516660928726,
    "CMY_Y": 0.40928673744202,
    "CMYK_C": 0.1965169608593,
    "CMYK_M": 0.12845465540886,
    "CMYK_Y": 0,
    "CMYK_K": 0.40928673744202
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1004",
    "Farbtonhilfsbezeichnung": "54.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "109",
    "Bcolor": "129",
    "Y": 14,
    "L": 45.7861251831055,
    "a": 1.33968961238861,
    "b": -12.9344482421875,
    "C": 13.0036420822144,
    "h": 275.913330078125,
    "CMY_C": 0.6113988161087,
    "CMY_M": 0.57373452186584,
    "CMY_Y": 0.49469524621964,
    "CMYK_C": 0.23095680773258,
    "CMYK_M": 0.15641902387142,
    "CMYK_Y": 0,
    "CMYK_K": 0.49469524621964
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1005",
    "Farbtonhilfsbezeichnung": "54.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "91",
    "Bcolor": "113",
    "Y": 10,
    "L": 38.7122573852539,
    "a": 1.72375500202179,
    "b": -14.0113487243652,
    "C": 14.1169834136963,
    "h": 277.013610839844,
    "CMY_C": 0.68070948123932,
    "CMY_M": 0.64188373088837,
    "CMY_Y": 0.5575807094574,
    "CMYK_C": 0.27830788493156,
    "CMYK_M": 0.19055005908012,
    "CMYK_Y": 0,
    "CMYK_K": 0.5575807094574
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1006",
    "Farbtonhilfsbezeichnung": "54.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "77",
    "Bcolor": "94",
    "Y": 7,
    "L": 32.4617538452148,
    "a": 1.38504385948181,
    "b": -12.0950689315796,
    "C": 12.1741132736206,
    "h": 276.532653808594,
    "CMY_C": 0.7330983877182,
    "CMY_M": 0.69982892274857,
    "CMY_Y": 0.62950640916824,
    "CMYK_C": 0.27960532903671,
    "CMYK_M": 0.18980763852596,
    "CMYK_Y": 0,
    "CMYK_K": 0.62950640916824
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1007",
    "Farbtonhilfsbezeichnung": "54.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "135",
    "Bcolor": "175",
    "Y": 24,
    "L": 55.763729095459,
    "a": 1.92389476299286,
    "b": -24.9713954925537,
    "C": 25.0453987121582,
    "h": 274.405578613281,
    "CMY_C": 0.56688612699509,
    "CMY_M": 0.47202098369598,
    "CMY_Y": 0.31234133243561,
    "CMYK_C": 0.37016153335571,
    "CMYK_M": 0.23220771551132,
    "CMYK_Y": 0,
    "CMYK_K": 0.31234133243561
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1008",
    "Farbtonhilfsbezeichnung": "54.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "109",
    "Bcolor": "152",
    "Y": 15,
    "L": 45.9214248657227,
    "a": 3.74384379386902,
    "b": -26.6313362121582,
    "C": 26.8932037353516,
    "h": 278.002227783203,
    "CMY_C": 0.65982449054718,
    "CMY_M": 0.57265877723694,
    "CMY_Y": 0.4040384888649,
    "CMYK_C": 0.42919886112213,
    "CMYK_M": 0.2829382121563,
    "CMYK_Y": 0,
    "CMYK_K": 0.4040384888649
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1009",
    "Farbtonhilfsbezeichnung": "54.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "91",
    "Bcolor": "131",
    "Y": 10,
    "L": 38.8020477294922,
    "a": 4.36522817611694,
    "b": -24.8970317840576,
    "C": 25.2768154144287,
    "h": 279.944671630859,
    "CMY_C": 0.71424281597137,
    "CMY_M": 0.64262509346008,
    "CMY_Y": 0.48769950866699,
    "CMYK_C": 0.44220787286758,
    "CMYK_M": 0.3024115562439,
    "CMYK_Y": 0,
    "CMYK_K": 0.48769950866699
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1010",
    "Farbtonhilfsbezeichnung": "54.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "75",
    "Bcolor": "111",
    "Y": 7,
    "L": 32.2983512878418,
    "a": 5.33566093444824,
    "b": -23.0030384063721,
    "C": 23.6137466430664,
    "h": 283.05908203125,
    "CMY_C": 0.75722193717957,
    "CMY_M": 0.70550709962845,
    "CMY_Y": 0.56392693519592,
    "CMYK_C": 0.44326287508011,
    "CMYK_M": 0.32467073202133,
    "CMYK_Y": 0,
    "CMYK_K": 0.56392693519592
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1011",
    "Farbtonhilfsbezeichnung": "54.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "135",
    "Bcolor": "184",
    "Y": 24,
    "L": 55.8257293701172,
    "a": 2.37061762809753,
    "b": -29.8119106292725,
    "C": 29.9060173034668,
    "h": 274.546539306641,
    "CMY_C": 0.59171330928802,
    "CMY_M": 0.470498919487,
    "CMY_Y": 0.27886921167374,
    "CMYK_C": 0.43382436037064,
    "CMYK_M": 0.26573503017426,
    "CMYK_Y": 0,
    "CMYK_K": 0.27886921167374
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1012",
    "Farbtonhilfsbezeichnung": "54.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "112",
    "Bcolor": "172",
    "Y": 16,
    "L": 47.0744209289551,
    "a": 4.9838342666626,
    "b": -36.5466957092285,
    "C": 36.8849487304688,
    "h": 277.765472412109,
    "CMY_C": 0.70799595117569,
    "CMY_M": 0.55995672941208,
    "CMY_Y": 0.3265985250473,
    "CMYK_C": 0.56637448072433,
    "CMYK_M": 0.34653651714325,
    "CMYK_Y": 0,
    "CMYK_K": 0.3265985250473
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1013",
    "Farbtonhilfsbezeichnung": "54.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "14",
    "Gcolor": "61",
    "Bcolor": "123",
    "Y": 7,
    "L": 26.3576850891113,
    "a": 9.91500949859619,
    "b": -39.7811698913574,
    "C": 40.9981575012207,
    "h": 283.995178222656,
    "CMY_C": 0.94447308778763,
    "CMY_M": 0.76015400886536,
    "CMY_Y": 0.5192803144455,
    "CMYK_C": 0.88449209928513,
    "CMYK_M": 0.5010689496994,
    "CMYK_Y": 0,
    "CMYK_K": 0.5192803144455
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1014",
    "Farbtonhilfsbezeichnung": "57.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "110",
    "Bcolor": "120",
    "Y": 15,
    "L": 46.140567779541,
    "a": -1.20425391197205,
    "b": -7.32177209854126,
    "C": 7.42014646530151,
    "h": 260.659851074219,
    "CMY_C": 0.60501563549042,
    "CMY_M": 0.56673276424408,
    "CMY_Y": 0.52774596214294,
    "CMYK_C": 0.1636188775301,
    "CMYK_M": 0.08255472779274,
    "CMYK_Y": 0,
    "CMYK_K": 0.52774596214294
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1015",
    "Farbtonhilfsbezeichnung": "57.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "92",
    "Bcolor": "103",
    "Y": 10,
    "L": 38.6915130615234,
    "a": -0.78927332162857,
    "b": -7.78695678710938,
    "C": 7.82685422897339,
    "h": 264.212371826172,
    "CMY_C": 0.67444413900375,
    "CMY_M": 0.6389240026474,
    "CMY_Y": 0.59708750247955,
    "CMYK_C": 0.1919936388731,
    "CMYK_M": 0.10383520275354,
    "CMYK_Y": 0,
    "CMYK_K": 0.59708750247955
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1016",
    "Farbtonhilfsbezeichnung": "57.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "76",
    "Bcolor": "85",
    "Y": 6,
    "L": 32.0830917358398,
    "a": -0.31056040525436,
    "b": -6.58551549911499,
    "C": 6.59283399581909,
    "h": 267.300048828125,
    "CMY_C": 0.72731906175613,
    "CMY_M": 0.70159196853638,
    "CMY_Y": 0.66671603918076,
    "CMYK_C": 0.18183599412441,
    "CMYK_M": 0.10464328527451,
    "CMYK_Y": 0,
    "CMYK_K": 0.66671603918076
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1017",
    "Farbtonhilfsbezeichnung": "57.06.33",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "43",
    "Bcolor": "45",
    "Y": 4,
    "L": 17.3349494934082,
    "a": -0.195337459445,
    "b": -2.08152484893799,
    "C": 2.09067034721375,
    "h": 264.638854980469,
    "CMY_C": 0.83988165855408,
    "CMY_M": 0.83205914497375,
    "CMY_Y": 0.82311141490936,
    "CMYK_C": 0.09480682015419,
    "CMYK_M": 0.05058398842812,
    "CMYK_Y": 0,
    "CMYK_K": 0.82311141490936
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1018",
    "Farbtonhilfsbezeichnung": "57.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "138",
    "Bcolor": "155",
    "Y": 25,
    "L": 56.8851776123047,
    "a": -1.08478832244873,
    "b": -11.6195163726807,
    "C": 11.6700439453125,
    "h": 264.666381835938,
    "CMY_C": 0.51556146144867,
    "CMY_M": 0.45879125595093,
    "CMY_Y": 0.39097231626511,
    "CMYK_C": 0.20457057654858,
    "CMYK_M": 0.11135608702898,
    "CMYK_Y": 0,
    "CMYK_K": 0.39097231626511
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1019",
    "Farbtonhilfsbezeichnung": "57.09.33",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "50",
    "Bcolor": "66",
    "Y": 5,
    "L": 19.91042137146,
    "a": -1.68031215667725,
    "b": -12.8582038879395,
    "C": 12.9675312042236,
    "h": 262.554779052734,
    "CMY_C": 0.87342494726181,
    "CMY_M": 0.80488646030426,
    "CMY_Y": 0.74056911468506,
    "CMYK_C": 0.5121049284935,
    "CMYK_M": 0.24791707098484,
    "CMYK_Y": 0,
    "CMYK_K": 0.74056911468506
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1020",
    "Farbtonhilfsbezeichnung": "57.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "97",
    "Bcolor": "118",
    "Y": 15,
    "L": 40.9550476074219,
    "a": 1.03026235103607,
    "b": -13.8881902694702,
    "C": 13.9263515472412,
    "h": 274.242584228516,
    "CMY_C": 0.66436094045639,
    "CMY_M": 0.61927139759064,
    "CMY_Y": 0.53646266460419,
    "CMYK_C": 0.27591794729233,
    "CMYK_M": 0.17864522337914,
    "CMYK_Y": 0,
    "CMYK_K": 0.53646266460419
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1021",
    "Farbtonhilfsbezeichnung": "57.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "80",
    "Bcolor": "96",
    "Y": 7,
    "L": 33.5449295043945,
    "a": 0.36658972501755,
    "b": -11.5598697662354,
    "C": 11.5656814575195,
    "h": 271.816375732422,
    "CMY_C": 0.72863817214966,
    "CMY_M": 0.68806630373001,
    "CMY_Y": 0.62261766195297,
    "CMYK_C": 0.28093659877777,
    "CMYK_M": 0.17342793941498,
    "CMYK_Y": 0,
    "CMYK_K": 0.62261766195297
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1022",
    "Farbtonhilfsbezeichnung": "57.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "136",
    "Bcolor": "167",
    "Y": 24,
    "L": 55.8446006774902,
    "a": -0.3398277759552,
    "b": -20.1907348632813,
    "C": 20.1935939788818,
    "h": 269.035766601563,
    "CMY_C": 0.56031966209412,
    "CMY_M": 0.46809858083725,
    "CMY_Y": 0.34396243095398,
    "CMYK_C": 0.32979395985603,
    "CMYK_M": 0.18922109901905,
    "CMYK_Y": 0,
    "CMYK_K": 0.34396243095398
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1023",
    "Farbtonhilfsbezeichnung": "57.12.33",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "53",
    "Bcolor": "84",
    "Y": 6,
    "L": 22.0421104431152,
    "a": 2.31787180900574,
    "b": -21.845329284668,
    "C": 21.9679527282715,
    "h": 276.056640625,
    "CMY_C": 0.87627148628235,
    "CMY_M": 0.79066514968872,
    "CMY_Y": 0.66903936862946,
    "CMYK_C": 0.6261533498764,
    "CMYK_M": 0.36749321222305,
    "CMYK_Y": 0,
    "CMYK_K": 0.66903936862946
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1024",
    "Farbtonhilfsbezeichnung": "57.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "56",
    "Bcolor": "84",
    "Y": 6,
    "L": 22.777437210083,
    "a": -0.05754501000047,
    "b": -20.371301651001,
    "C": 20.3713836669922,
    "h": 269.838134765625,
    "CMY_C": 0.88311940431595,
    "CMY_M": 0.78056460618973,
    "CMY_Y": 0.67096185684204,
    "CMYK_C": 0.64478099346161,
    "CMYK_M": 0.33310043811798,
    "CMYK_Y": 0,
    "CMYK_K": 0.67096185684204
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1025",
    "Farbtonhilfsbezeichnung": "57.12.27",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "91",
    "Bcolor": "122",
    "Y": 9,
    "L": 37.9196166992188,
    "a": 0.22647570073605,
    "b": -20.7752704620361,
    "C": 20.7765045166016,
    "h": 270.624572753906,
    "CMY_C": 0.73594963550568,
    "CMY_M": 0.64406657218933,
    "CMY_Y": 0.52291011810303,
    "CMYK_C": 0.44653958082199,
    "CMYK_M": 0.25394889712334,
    "CMYK_Y": 0,
    "CMYK_K": 0.52291011810303
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1026",
    "Farbtonhilfsbezeichnung": "57.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "112",
    "Bcolor": "142",
    "Y": 16,
    "L": 46.5625877380371,
    "a": 0.4650074839592,
    "b": -19.8903789520264,
    "C": 19.8958129882813,
    "h": 271.339233398438,
    "CMY_C": 0.6443235874176,
    "CMY_M": 0.56206500530243,
    "CMY_Y": 0.4417627453804,
    "CMYK_C": 0.36285796761513,
    "CMYK_M": 0.21550381183624,
    "CMYK_Y": 0,
    "CMYK_K": 0.4417627453804
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1027",
    "Farbtonhilfsbezeichnung": "57.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "138",
    "Bcolor": "178",
    "Y": 24,
    "L": 56.3909378051758,
    "a": -0.80758196115494,
    "b": -25.8176326751709,
    "C": 25.8302593231201,
    "h": 268.208343505859,
    "CMY_C": 0.591672539711,
    "CMY_M": 0.45957267284393,
    "CMY_Y": 0.30020380020142,
    "CMYK_C": 0.41650518774986,
    "CMYK_M": 0.22773611545563,
    "CMYK_Y": 0,
    "CMYK_K": 0.30020380020142
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1028",
    "Farbtonhilfsbezeichnung": "57.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "110",
    "Bcolor": "150",
    "Y": 15,
    "L": 45.6444282531738,
    "a": 0.38593131303787,
    "b": -25.8390083312988,
    "C": 25.841890335083,
    "h": 270.855712890625,
    "CMY_C": 0.69023025035858,
    "CMY_M": 0.56868124008179,
    "CMY_Y": 0.41234010457993,
    "CMYK_C": 0.47287580370903,
    "CMYK_M": 0.26604017615318,
    "CMYK_Y": 0,
    "CMYK_K": 0.41234010457993
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1029",
    "Farbtonhilfsbezeichnung": "57.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "90",
    "Bcolor": "130",
    "Y": 9,
    "L": 37.3427124023438,
    "a": 0.21180540323257,
    "b": -26.6640243530273,
    "C": 26.6648654937744,
    "h": 270.455108642578,
    "CMY_C": 0.78358006477356,
    "CMY_M": 0.64725381135941,
    "CMY_Y": 0.49146038293839,
    "CMYK_C": 0.57442855834961,
    "CMYK_M": 0.3063545525074,
    "CMYK_Y": 0,
    "CMYK_K": 0.49146038293839
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1030",
    "Farbtonhilfsbezeichnung": "57.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "78",
    "Bcolor": "109",
    "Y": 6,
    "L": 32.1223526000977,
    "a": -0.67022466659546,
    "b": -22.132303237915,
    "C": 22.142448425293,
    "h": 268.265472412109,
    "CMY_C": 0.81077969074249,
    "CMY_M": 0.69560492038727,
    "CMY_Y": 0.57144045829773,
    "CMYK_C": 0.55847370624542,
    "CMYK_M": 0.28972512483597,
    "CMYK_Y": 0,
    "CMYK_K": 0.57144045829773
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1031",
    "Farbtonhilfsbezeichnung": "57.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "128",
    "Bcolor": "175",
    "Y": 20,
    "L": 51.9907188415527,
    "a": -1.80989253520966,
    "b": -30.9896984100342,
    "C": 31.0425052642822,
    "h": 266.657562255859,
    "CMY_C": 0.68669909238815,
    "CMY_M": 0.49975478649139,
    "CMY_Y": 0.31208270788193,
    "CMYK_C": 0.54456603527069,
    "CMYK_M": 0.2728119790554,
    "CMYK_Y": 0,
    "CMYK_K": 0.31208270788193
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1032",
    "Farbtonhilfsbezeichnung": "57.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "109",
    "Bcolor": "157",
    "Y": 15,
    "L": 45.0722389221191,
    "a": -0.18416950106621,
    "b": -30.9092578887939,
    "C": 30.9098072052002,
    "h": 269.658599853516,
    "CMY_C": 0.74206280708313,
    "CMY_M": 0.57109791040421,
    "CMY_Y": 0.38513368368149,
    "CMYK_C": 0.58049875497818,
    "CMYK_M": 0.30244660377502,
    "CMYK_Y": 0,
    "CMYK_K": 0.38513368368149
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1033",
    "Farbtonhilfsbezeichnung": "57.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "90",
    "Bcolor": "137",
    "Y": 9,
    "L": 37.4860877990723,
    "a": 0.78940284252167,
    "b": -30.7010116577148,
    "C": 30.7111587524414,
    "h": 271.472900390625,
    "CMY_C": 0.81230670213699,
    "CMY_M": 0.64540457725525,
    "CMY_Y": 0.46435087919235,
    "CMYK_C": 0.6495965719223,
    "CMYK_M": 0.33800801634789,
    "CMYK_Y": 0,
    "CMYK_K": 0.46435087919235
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1034",
    "Farbtonhilfsbezeichnung": "57.18.30",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "76",
    "Bcolor": "115",
    "Y": 6,
    "L": 31.5079822540283,
    "a": 0.9832016825676,
    "b": -26.564001083374,
    "C": 26.5821895599365,
    "h": 272.119689941406,
    "CMY_C": 0.83527636528015,
    "CMY_M": 0.70262670516968,
    "CMY_Y": 0.5500226020813,
    "CMYK_C": 0.63392907381058,
    "CMYK_M": 0.33913725614548,
    "CMYK_Y": 0,
    "CMYK_K": 0.5500226020813
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1035",
    "Farbtonhilfsbezeichnung": "57.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "140",
    "Bcolor": "192",
    "Y": 25,
    "L": 56.9849967956543,
    "a": 0.01440101955086,
    "b": -32.8386306762695,
    "C": 32.8386344909668,
    "h": 270.025115966797,
    "CMY_C": 0.62608528137207,
    "CMY_M": 0.45255374908447,
    "CMY_Y": 0.2460173368454,
    "CMYK_C": 0.50408047437668,
    "CMYK_M": 0.27392727136612,
    "CMYK_Y": 0,
    "CMYK_K": 0.2460173368454
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1036",
    "Farbtonhilfsbezeichnung": "57.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "117",
    "Bcolor": "177",
    "Y": 17,
    "L": 48.5561714172363,
    "a": 2.64571142196655,
    "b": -37.2248001098633,
    "C": 37.3187026977539,
    "h": 274.065399169922,
    "CMY_C": 0.72664225101471,
    "CMY_M": 0.54024887084961,
    "CMY_Y": 0.30652582645416,
    "CMYK_C": 0.60581409931183,
    "CMYK_M": 0.33703207969666,
    "CMYK_Y": 0,
    "CMYK_K": 0.30652582645416
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1037",
    "Farbtonhilfsbezeichnung": "57.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "93",
    "Bcolor": "146",
    "Y": 10,
    "L": 38.3862380981445,
    "a": 1.07224786281586,
    "b": -35.1279792785645,
    "C": 35.1443405151367,
    "h": 271.748352050781,
    "CMY_C": 0.85105061531067,
    "CMY_M": 0.63561111688614,
    "CMY_Y": 0.42683750391006,
    "CMYK_C": 0.74012714624405,
    "CMYK_M": 0.36424854397774,
    "CMYK_Y": 0,
    "CMYK_K": 0.42683750391006
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1038",
    "Farbtonhilfsbezeichnung": "60.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "152",
    "Bcolor": "153",
    "Y": 30,
    "L": 62.6017875671387,
    "a": -1.21492063999176,
    "b": -1.91489458084106,
    "C": 2.26778601662777,
    "h": 237.606579084701,
    "CMY_C": 0.42352938652039,
    "CMY_M": 0.45882350206375,
    "CMY_Y": 0.4313725233078,
    "CMYK_C": 0,
    "CMYK_M": 0.06122448295355,
    "CMYK_Y": 0.01360544096678,
    "CMYK_K": 0.42352939
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1039",
    "Farbtonhilfsbezeichnung": "60.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "131",
    "Bcolor": "136",
    "Y": 22,
    "L": 54.4358673095703,
    "a": -0.63305234909058,
    "b": -3.92571711540222,
    "C": 3.97643184661865,
    "h": 260.839477539063,
    "CMY_C": 0.50697898864746,
    "CMY_M": 0.4867182970047,
    "CMY_Y": 0.46743607521057,
    "CMYK_C": 0.07425007969141,
    "CMYK_M": 0.03620639815927,
    "CMYK_Y": 0,
    "CMYK_K": 0.46743607521057
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1040",
    "Farbtonhilfsbezeichnung": "60.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "110",
    "Bcolor": "115",
    "Y": 15,
    "L": 46.0521354675293,
    "a": -0.33367717266083,
    "b": -3.94432544708252,
    "C": 3.95841431617737,
    "h": 265.164489746094,
    "CMY_C": 0.58728635311127,
    "CMY_M": 0.57030135393143,
    "CMY_Y": 0.55035018920898,
    "CMYK_C": 0.08214429020882,
    "CMYK_M": 0.04437045007944,
    "CMYK_Y": 0,
    "CMYK_K": 0.55035018920898
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1041",
    "Farbtonhilfsbezeichnung": "60.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "87",
    "Bcolor": "93",
    "Y": 11,
    "L": 36.8235130310059,
    "a": -0.14093552529812,
    "b": -4.23023223876953,
    "C": 4.23257923126221,
    "h": 268.091827392578,
    "CMY_C": 0.67443537712097,
    "CMY_M": 0.65872269868851,
    "CMY_Y": 0.63692367076874,
    "CMYK_C": 0.10331630706787,
    "CMYK_M": 0.06003979220986,
    "CMYK_Y": 0,
    "CMYK_K": 0.63692367076874
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1042",
    "Farbtonhilfsbezeichnung": "60.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "76",
    "Bcolor": "81",
    "Y": 9,
    "L": 31.9507160186768,
    "a": -0.39187660813332,
    "b": -4.2149076461792,
    "C": 4.23308563232422,
    "h": 264.688262939453,
    "CMY_C": 0.72084593772888,
    "CMY_M": 0.70327281951904,
    "CMY_Y": 0.68231797218323,
    "CMYK_C": 0.12127839028835,
    "CMYK_M": 0.0659617036581,
    "CMYK_Y": 0,
    "CMYK_K": 0.68231797218323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1043",
    "Farbtonhilfsbezeichnung": "60.09.21",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "125",
    "Bcolor": "149",
    "Y": 21,
    "L": 51.2536468505859,
    "a": -2.66185712814331,
    "b": -16.6850128173828,
    "C": 16.8960094451904,
    "h": 260.935668945313,
    "CMY_C": 0.60879462957382,
    "CMY_M": 0.51054126024246,
    "CMY_Y": 0.41519618034363,
    "CMYK_C": 0.33104854822159,
    "CMYK_M": 0.16303771734238,
    "CMYK_Y": 0,
    "CMYK_K": 0.41519618034363
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1044",
    "Farbtonhilfsbezeichnung": "60.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "112",
    "Bcolor": "131",
    "Y": 15,
    "L": 46.1711616516113,
    "a": -2.70655703544617,
    "b": -13.5573930740356,
    "C": 13.8249177932739,
    "h": 258.710083007813,
    "CMY_C": 0.64344465732574,
    "CMY_M": 0.56157964468002,
    "CMY_Y": 0.487195789814,
    "CMYK_C": 0.30469498038292,
    "CMYK_M": 0.14505313336849,
    "CMYK_Y": 0,
    "CMYK_K": 0.487195789814
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1045",
    "Farbtonhilfsbezeichnung": "60.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "92",
    "Bcolor": "112",
    "Y": 10,
    "L": 38.4187812805176,
    "a": -2.03760385513306,
    "b": -13.8217506408691,
    "C": 13.9711351394653,
    "h": 261.613861083984,
    "CMY_C": 0.71316343545914,
    "CMY_M": 0.63728666305542,
    "CMY_Y": 0.56196534633636,
    "CMYK_C": 0.34517380595207,
    "CMYK_M": 0.1719528734684,
    "CMYK_Y": 0,
    "CMYK_K": 0.56196534633636
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1046",
    "Farbtonhilfsbezeichnung": "60.09.30",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "77",
    "Bcolor": "93",
    "Y": 6,
    "L": 32.0599632263184,
    "a": -1.22250819206238,
    "b": -11.8570384979248,
    "C": 11.9198942184448,
    "h": 264.113372802734,
    "CMY_C": 0.75600349903107,
    "CMY_M": 0.69856327772141,
    "CMY_Y": 0.63497519493103,
    "CMYK_C": 0.33156186342239,
    "CMYK_M": 0.17420208454132,
    "CMYK_Y": 0,
    "CMYK_K": 0.63497519493103
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1047",
    "Farbtonhilfsbezeichnung": "60.09.33",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "42",
    "Bcolor": "51",
    "Y": 4,
    "L": 16.8000926971436,
    "a": 0.17857050895691,
    "b": -6.84142351150513,
    "C": 6.84375381469727,
    "h": 271.495147705078,
    "CMY_C": 0.85747683048248,
    "CMY_M": 0.83598613739014,
    "CMY_Y": 0.80128663778305,
    "CMYK_C": 0.28277006745338,
    "CMYK_M": 0.17462086677551,
    "CMYK_Y": 0,
    "CMYK_K": 0.80128663778305
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1048",
    "Farbtonhilfsbezeichnung": "60.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "139",
    "Bcolor": "167",
    "Y": 24,
    "L": 56.1957473754883,
    "a": -4.20460033416748,
    "b": -19.6150093078613,
    "C": 20.0605888366699,
    "h": 257.9013671875,
    "CMY_C": 0.5893896818161,
    "CMY_M": 0.45676332712173,
    "CMY_Y": 0.34452402591705,
    "CMYK_C": 0.37356922030449,
    "CMYK_M": 0.17123328149319,
    "CMYK_Y": 0,
    "CMYK_K": 0.34452402591705
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1049",
    "Farbtonhilfsbezeichnung": "60.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "109",
    "Bcolor": "142",
    "Y": 16,
    "L": 44.4698486328125,
    "a": -3.2333357334137,
    "b": -23.0906352996826,
    "C": 23.3159160614014,
    "h": 262.02880859375,
    "CMY_C": 0.72079640626907,
    "CMY_M": 0.57393741607666,
    "CMY_Y": 0.44255191087723,
    "CMYK_C": 0.49913975596428,
    "CMYK_M": 0.235691010952,
    "CMYK_Y": 0,
    "CMYK_K": 0.44255191087723
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1050",
    "Farbtonhilfsbezeichnung": "60.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "92",
    "Bcolor": "119",
    "Y": 10,
    "L": 37.9860191345215,
    "a": -1.58675158023834,
    "b": -19.1963939666748,
    "C": 19.2618618011475,
    "h": 265.274749755859,
    "CMY_C": 0.74278992414474,
    "CMY_M": 0.64047712087631,
    "CMY_Y": 0.53234958648682,
    "CMYK_C": 0.44999498128891,
    "CMYK_M": 0.23121444880962,
    "CMYK_Y": 0,
    "CMYK_K": 0.53234958648682
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1051",
    "Farbtonhilfsbezeichnung": "60.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "78",
    "Bcolor": "103",
    "Y": 6,
    "L": 32.2632598876953,
    "a": -1.22734200954437,
    "b": -17.8892841339111,
    "C": 17.9313373565674,
    "h": 266.075225830078,
    "CMY_C": 0.78620004653931,
    "CMY_M": 0.69476789236069,
    "CMY_Y": 0.59618508815765,
    "CMYK_C": 0.4705496430397,
    "CMYK_M": 0.24412868916988,
    "CMYK_Y": 0,
    "CMYK_K": 0.59618508815765
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1052",
    "Farbtonhilfsbezeichnung": "60.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "139",
    "Bcolor": "176",
    "Y": 24,
    "L": 55.8446617126465,
    "a": -5.02128744125366,
    "b": -25.1651859283447,
    "C": 25.6612529754639,
    "h": 258.715789794922,
    "CMY_C": 0.63695502281189,
    "CMY_M": 0.45675081014633,
    "CMY_Y": 0.31077319383621,
    "CMYK_C": 0.47325760126114,
    "CMYK_M": 0.21179910004139,
    "CMYK_Y": 0,
    "CMYK_K": 0.31077319383621
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1053",
    "Farbtonhilfsbezeichnung": "60.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "115",
    "Bcolor": "152",
    "Y": 16,
    "L": 46.6046180725098,
    "a": -4.87661981582642,
    "b": -25.7991409301758,
    "C": 26.2559909820557,
    "h": 259.296081542969,
    "CMY_C": 0.73838603496552,
    "CMY_M": 0.5489849448204,
    "CMY_Y": 0.40311568975449,
    "CMYK_C": 0.56170070171356,
    "CMYK_M": 0.24438446760178,
    "CMYK_Y": 0,
    "CMYK_K": 0.40311568975449
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1054",
    "Farbtonhilfsbezeichnung": "60.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "93",
    "Bcolor": "128",
    "Y": 10,
    "L": 37.7232208251953,
    "a": -3.92545294761658,
    "b": -24.9720783233643,
    "C": 25.2787246704102,
    "h": 261.066558837891,
    "CMY_C": 0.81548207998276,
    "CMY_M": 0.63651537895203,
    "CMY_Y": 0.49865281581879,
    "CMYK_C": 0.63195580244064,
    "CMYK_M": 0.2749842107296,
    "CMYK_Y": 0,
    "CMYK_K": 0.49865281581879
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1055",
    "Farbtonhilfsbezeichnung": "60.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "78",
    "Bcolor": "110",
    "Y": 7,
    "L": 32.1040191650391,
    "a": -2.09961104393005,
    "b": -22.6764011383057,
    "C": 22.7733955383301,
    "h": 264.710052490234,
    "CMY_C": 0.83156096935272,
    "CMY_M": 0.69293248653412,
    "CMY_Y": 0.56836831569672,
    "CMYK_C": 0.60976213216782,
    "CMYK_M": 0.28858903050423,
    "CMYK_Y": 0,
    "CMYK_K": 0.56836831569672
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1056",
    "Farbtonhilfsbezeichnung": "60.18.21",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "143",
    "Bcolor": "191",
    "Y": 25,
    "L": 56.6290588378906,
    "a": -7.90625238418579,
    "b": -32.4826393127441,
    "C": 33.4309844970703,
    "h": 256.320251464844,
    "CMY_C": 0.7310266494751,
    "CMY_M": 0.4403874874115,
    "CMY_Y": 0.25289976596832,
    "CMYK_C": 0.63997691869736,
    "CMYK_M": 0.25095391273499,
    "CMYK_Y": 0,
    "CMYK_K": 0.25289976596832
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1057",
    "Farbtonhilfsbezeichnung": "60.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "119",
    "Bcolor": "166",
    "Y": 17,
    "L": 47.9361190795898,
    "a": -5.92874050140381,
    "b": -32.0570030212402,
    "C": 32.6006355285645,
    "h": 259.521911621094,
    "CMY_C": 0.80390816926956,
    "CMY_M": 0.53151261806488,
    "CMY_Y": 0.34805548191071,
    "CMYK_C": 0.69922006130219,
    "CMYK_M": 0.28139993548393,
    "CMYK_Y": 0,
    "CMYK_K": 0.34805548191071
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1058",
    "Farbtonhilfsbezeichnung": "60.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "80",
    "Bcolor": "124",
    "Y": 9,
    "L": 31.5579090118408,
    "a": -7.14416980743408,
    "b": -32.4782676696777,
    "C": 33.2547302246094,
    "h": 257.594360351563,
    "CMY_C": 1,
    "CMY_M": 0.68535244464874,
    "CMY_Y": 0.5133461356163,
    "CMYK_C": 1,
    "CMYK_M": 0.3534469306469,
    "CMYK_Y": 0,
    "CMYK_K": 0.5133461356163
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1059",
    "Farbtonhilfsbezeichnung": "60.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "141",
    "Bcolor": "197",
    "Y": 24,
    "L": 55.5704307556152,
    "a": -8.5780782699585,
    "b": -37.9002876281738,
    "C": 38.8589134216309,
    "h": 257.246948242188,
    "CMY_C": 0.84240335226059,
    "CMY_M": 0.44770759344101,
    "CMY_Y": 0.22738951444626,
    "CMYK_C": 0.79602056741714,
    "CMYK_M": 0.28516060113907,
    "CMYK_Y": 0,
    "CMYK_K": 0.22738951444626
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1060",
    "Farbtonhilfsbezeichnung": "60.21.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "137",
    "Y": 10,
    "L": 34.084789276123,
    "a": -5.89849185943604,
    "b": -36.1824531555176,
    "C": 36.6600875854492,
    "h": 260.741058349609,
    "CMY_C": 1,
    "CMY_M": 0.66252934932709,
    "CMY_Y": 0.46454256772995,
    "CMYK_C": 1,
    "CMYK_M": 0.36975261569023,
    "CMYK_Y": 0,
    "CMYK_K": 0.46454256772995
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1061",
    "Farbtonhilfsbezeichnung": "63.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "134",
    "Bcolor": "138",
    "Y": 25,
    "L": 55.5537338256836,
    "a": -1.69683241844177,
    "b": -3.40322089195251,
    "C": 3.8027822971344,
    "h": 243.499328613281,
    "CMY_C": 0.50194942951202,
    "CMY_M": 0.47335773706436,
    "CMY_Y": 0.45979517698288,
    "CMYK_C": 0.07803383469582,
    "CMYK_M": 0.02510632947087,
    "CMYK_Y": 0,
    "CMYK_K": 0.45979517698288
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1062",
    "Farbtonhilfsbezeichnung": "63.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "132",
    "Bcolor": "140",
    "Y": 22,
    "L": 54.3011360168457,
    "a": -2.69475293159485,
    "b": -6.53652763366699,
    "C": 7.07021141052246,
    "h": 247.595581054688,
    "CMY_C": 0.5336149930954,
    "CMY_M": 0.48304337263107,
    "CMY_Y": 0.45161533355713,
    "CMYK_C": 0.14952945709229,
    "CMYK_M": 0.05731020867825,
    "CMYK_Y": 0,
    "CMYK_K": 0.45161533355713
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1063",
    "Farbtonhilfsbezeichnung": "63.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "112",
    "Bcolor": "121",
    "Y": 15,
    "L": 46.3786354064941,
    "a": -2.56366515159607,
    "b": -7.13151073455811,
    "C": 7.57831287384033,
    "h": 250.227294921875,
    "CMY_C": 0.6124210357666,
    "CMY_M": 0.56173133850098,
    "CMY_Y": 0.52677488327026,
    "CMYK_C": 0.18098396062851,
    "CMYK_M": 0.07386855781078,
    "CMYK_Y": 0,
    "CMYK_K": 0.52677488327026
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1064",
    "Farbtonhilfsbezeichnung": "63.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "91",
    "Bcolor": "100",
    "Y": 9,
    "L": 37.9645042419434,
    "a": -2.2613730430603,
    "b": -7.29127025604248,
    "C": 7.63390016555786,
    "h": 252.768829345703,
    "CMY_C": 0.69038903713226,
    "CMY_M": 0.64305907487869,
    "CMY_Y": 0.60727959871292,
    "CMYK_C": 0.21162496507168,
    "CMYK_M": 0.09110674262047,
    "CMYK_Y": 0,
    "CMYK_K": 0.60727959871292
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1065",
    "Farbtonhilfsbezeichnung": "63.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "63",
    "Bcolor": "73",
    "Y": 6,
    "L": 25.8250522613525,
    "a": -2.7855851650238,
    "b": -8.08137321472168,
    "C": 8.54798698425293,
    "h": 250.981338500977,
    "CMY_C": 0.80721753835678,
    "CMY_M": 0.75294941663742,
    "CMY_Y": 0.71524226665497,
    "CMYK_C": 0.32299482822418,
    "CMYK_M": 0.13241834938526,
    "CMYK_Y": 0,
    "CMYK_K": 0.71524226665497
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1066",
    "Farbtonhilfsbezeichnung": "63.06.33",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "60",
    "Bcolor": "62",
    "Y": 6,
    "L": 25.0424404144287,
    "a": -0.58986836671829,
    "b": -1.85654389858246,
    "C": 1.94799900054932,
    "h": 252.37370300293,
    "CMY_C": 0.77614206075668,
    "CMY_M": 0.76538515090942,
    "CMY_Y": 0.7584068775177,
    "CMYK_C": 0.07340930402279,
    "CMYK_M": 0.02888440340757,
    "CMYK_Y": 0,
    "CMYK_K": 0.7584068775177
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1067",
    "Farbtonhilfsbezeichnung": "63.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "136",
    "Bcolor": "150",
    "Y": 23,
    "L": 54.8090591430664,
    "a": -6.61774682998657,
    "b": -11.759539604187,
    "C": 13.4937524795532,
    "h": 240.631118774414,
    "CMY_C": 0.58399164676666,
    "CMY_M": 0.46850508451462,
    "CMY_Y": 0.4119428396225,
    "CMYK_C": 0.29257157444954,
    "CMYK_M": 0.09618494659662,
    "CMYK_Y": 0,
    "CMYK_K": 0.4119428396225
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1068",
    "Farbtonhilfsbezeichnung": "63.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "113",
    "Bcolor": "129",
    "Y": 15,
    "L": 45.9383964538574,
    "a": -6.05091333389282,
    "b": -12.8582420349121,
    "C": 14.2108392715454,
    "h": 244.798965454102,
    "CMY_C": 0.6716388463974,
    "CMY_M": 0.55760478973389,
    "CMY_Y": 0.49436700344086,
    "CMYK_C": 0.35059389472008,
    "CMYK_M": 0.12506657838821,
    "CMYK_Y": 0,
    "CMYK_K": 0.49436700344086
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1069",
    "Farbtonhilfsbezeichnung": "63.09.27",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "97",
    "Bcolor": "111",
    "Y": 11,
    "L": 39.8151512145996,
    "a": -4.8790864944458,
    "b": -11.4519214630127,
    "C": 12.4479713439941,
    "h": 246.923583984375,
    "CMY_C": 0.71269416809082,
    "CMY_M": 0.61939203739166,
    "CMY_Y": 0.56357139348984,
    "CMYK_C": 0.34168881177902,
    "CMYK_M": 0.1279032677412,
    "CMYK_Y": 0,
    "CMYK_K": 0.56357139348984
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1070",
    "Farbtonhilfsbezeichnung": "63.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "140",
    "Bcolor": "164",
    "Y": 24,
    "L": 56.1180839538574,
    "a": -8.06174945831299,
    "b": -18.2113399505615,
    "C": 19.9159412384033,
    "h": 246.122100830078,
    "CMY_C": 0.62008565664291,
    "CMY_M": 0.45038557052612,
    "CMY_Y": 0.35516256093979,
    "CMYK_C": 0.4108370244503,
    "CMYK_M": 0.14766979217529,
    "CMYK_Y": 0,
    "CMYK_K": 0.35516256093979
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1071",
    "Farbtonhilfsbezeichnung": "63.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "106",
    "Bcolor": "139",
    "Y": 15,
    "L": 42.8337936401367,
    "a": -6.88812398910522,
    "b": -23.6875877380371,
    "C": 24.6687679290771,
    "h": 253.786071777344,
    "CMY_C": 0.78639161586761,
    "CMY_M": 0.58273684978485,
    "CMY_Y": 0.45559638738632,
    "CMYK_C": 0.60762864351273,
    "CMYK_M": 0.23354081809521,
    "CMYK_Y": 0,
    "CMYK_K": 0.45559638738632
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1072",
    "Farbtonhilfsbezeichnung": "63.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "93",
    "Bcolor": "118",
    "Y": 10,
    "L": 37.5876007080078,
    "a": -6.64646434783936,
    "b": -18.9821796417236,
    "C": 20.1121520996094,
    "h": 250.702697753906,
    "CMY_C": 0.7985452413559,
    "CMY_M": 0.63499248027802,
    "CMY_Y": 0.53801733255386,
    "CMYK_C": 0.56393438577652,
    "CMYK_M": 0.20991079509258,
    "CMYK_Y": 0,
    "CMYK_K": 0.53801733255386
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1073",
    "Farbtonhilfsbezeichnung": "63.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "78",
    "Bcolor": "100",
    "Y": 6,
    "L": 31.565393447876,
    "a": -4.53134775161743,
    "b": -17.0232696533203,
    "C": 17.6160392761231,
    "h": 255.094329833984,
    "CMY_C": 0.82020550966263,
    "CMY_M": 0.69546216726303,
    "CMY_Y": 0.60842370986938,
    "CMYK_C": 0.54084426164627,
    "CMYK_M": 0.22227713465691,
    "CMYK_Y": 0,
    "CMYK_K": 0.60842370986938
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1074",
    "Farbtonhilfsbezeichnung": "63.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "143",
    "Bcolor": "174",
    "Y": 24,
    "L": 56.3349876403809,
    "a": -11.024787902832,
    "b": -23.4849739074707,
    "C": 25.943977355957,
    "h": 244.852767944336,
    "CMY_C": 0.6899561882019,
    "CMY_M": 0.44077038764954,
    "CMY_Y": 0.31747406721115,
    "CMYK_C": 0.54574060440063,
    "CMYK_M": 0.1806470900774,
    "CMYK_Y": 0,
    "CMYK_K": 0.31747406721115
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1075",
    "Farbtonhilfsbezeichnung": "63.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "118",
    "Bcolor": "151",
    "Y": 16,
    "L": 46.8603096008301,
    "a": -10.0544328689575,
    "b": -24.8099479675293,
    "C": 26.7698554992676,
    "h": 247.939346313477,
    "CMY_C": 0.79759454727173,
    "CMY_M": 0.53727638721466,
    "CMY_Y": 0.40736651420593,
    "CMYK_C": 0.65846437215805,
    "CMYK_M": 0.21920777857304,
    "CMYK_Y": 0,
    "CMYK_K": 0.40736651420593
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1076",
    "Farbtonhilfsbezeichnung": "63.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "93",
    "Bcolor": "117",
    "Y": 11,
    "L": 36.8896369934082,
    "a": -10.9552507400513,
    "b": -19.8233985900879,
    "C": 22.6491641998291,
    "h": 241.073104858398,
    "CMY_C": 0.87670958042145,
    "CMY_M": 0.63395720720291,
    "CMY_Y": 0.53990817070007,
    "CMYK_C": 0.73203086853027,
    "CMYK_M": 0.20441362261772,
    "CMYK_Y": 0,
    "CMYK_K": 0.53990817070007
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1077",
    "Farbtonhilfsbezeichnung": "63.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "179",
    "Y": 23,
    "L": 52.6944732666016,
    "a": -15.1113138198853,
    "b": -31.9956855773926,
    "C": 35.3846817016602,
    "h": 244.718994140625,
    "CMY_C": 1,
    "CMY_M": 0.46738594770432,
    "CMY_Y": 0.29882168769836,
    "CMYK_C": 1,
    "CMYK_M": 0.24040141701698,
    "CMYK_Y": 0,
    "CMYK_K": 0.29882168769836
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1078",
    "Farbtonhilfsbezeichnung": "63.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "130",
    "Y": 11,
    "L": 36.8479270935059,
    "a": -11.253378868103,
    "b": -27.9016723632813,
    "C": 30.0855751037598,
    "h": 248.03466796875,
    "CMY_C": 1,
    "CMY_M": 0.63103812932968,
    "CMY_Y": 0.48935443162918,
    "CMYK_C": 1,
    "CMYK_M": 0.27745994925499,
    "CMYK_Y": 0,
    "CMYK_K": 0.48935443162918
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1079",
    "Farbtonhilfsbezeichnung": "63.21.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "140",
    "Y": 11,
    "L": 36.2848167419434,
    "a": -12.360761642456,
    "b": -34.8311233520508,
    "C": 36.9593772888184,
    "h": 250.461395263672,
    "CMY_C": 1,
    "CMY_M": 0.63188028335571,
    "CMY_Y": 0.45106935501099,
    "CMYK_C": 1,
    "CMYK_M": 0.32938757538795,
    "CMYK_Y": 0,
    "CMYK_K": 0.45106935501099
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1080",
    "Farbtonhilfsbezeichnung": "66.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "136",
    "Bcolor": "142",
    "Y": 26,
    "L": 55.9976692199707,
    "a": -3.22972893714905,
    "b": -5.37552452087402,
    "C": 6.27115726470947,
    "h": 239.001647949219,
    "CMY_C": 0.51647418737411,
    "CMY_M": 0.46513712406158,
    "CMY_Y": 0.44226104021072,
    "CMYK_C": 0.13306072354317,
    "CMYK_M": 0.04101575538516,
    "CMYK_Y": 0,
    "CMYK_K": 0.44226104021072
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1081",
    "Farbtonhilfsbezeichnung": "66.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "95",
    "Gcolor": "109",
    "Bcolor": "113",
    "Y": 16,
    "L": 44.9368782043457,
    "a": -3.60743451118469,
    "b": -4.88801956176758,
    "C": 6.07505702972412,
    "h": 233.57209777832,
    "CMY_C": 0.62570202350616,
    "CMY_M": 0.5743368268013,
    "CMY_Y": 0.5554906129837,
    "CMYK_C": 0.15795259177685,
    "CMYK_M": 0.04239778593183,
    "CMYK_Y": 0,
    "CMYK_K": 0.5554906129837
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1082",
    "Farbtonhilfsbezeichnung": "66.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "92",
    "Bcolor": "100",
    "Y": 9,
    "L": 37.9882850646973,
    "a": -3.20414066314697,
    "b": -6.94711971282959,
    "C": 7.65042400360107,
    "h": 245.239974975586,
    "CMY_C": 0.69603329896927,
    "CMY_M": 0.64113301038742,
    "CMY_Y": 0.60929644107819,
    "CMYK_C": 0.22200171649456,
    "CMYK_M": 0.08148522675037,
    "CMYK_Y": 0,
    "CMYK_K": 0.60929644107819
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1083",
    "Farbtonhilfsbezeichnung": "66.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "76",
    "Bcolor": "81",
    "Y": 6,
    "L": 31.3580837249756,
    "a": -3.08557438850403,
    "b": -5.00149059295654,
    "C": 5.87670612335205,
    "h": 238.328277587891,
    "CMY_C": 0.74815893173218,
    "CMY_M": 0.70344042778015,
    "CMY_Y": 0.68326568603516,
    "CMYK_C": 0.20488226413727,
    "CMYK_M": 0.06369610130787,
    "CMYK_Y": 0,
    "CMYK_K": 0.68326568603516
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1084",
    "Farbtonhilfsbezeichnung": "66.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "136",
    "Bcolor": "149",
    "Y": 22,
    "L": 54.445240020752,
    "a": -8.79654884338379,
    "b": -11.9024000167847,
    "C": 14.8002157211304,
    "h": 233.533508300781,
    "CMY_C": 0.60828512907028,
    "CMY_M": 0.46791940927505,
    "CMY_Y": 0.41492760181427,
    "CMYK_C": 0.33048477768898,
    "CMYK_M": 0.09057307988405,
    "CMYK_Y": 0,
    "CMYK_K": 0.41492760181427
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1085",
    "Farbtonhilfsbezeichnung": "66.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "113",
    "Bcolor": "127",
    "Y": 14,
    "L": 45.6970825195313,
    "a": -7.81932592391968,
    "b": -12.2438287734985,
    "C": 14.5276699066162,
    "h": 237.436309814453,
    "CMY_C": 0.68710774183273,
    "CMY_M": 0.55684787034988,
    "CMY_Y": 0.50091695785522,
    "CMYK_C": 0.37306573987007,
    "CMYK_M": 0.11206734925508,
    "CMYK_Y": 0,
    "CMYK_K": 0.50091695785522
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1086",
    "Farbtonhilfsbezeichnung": "66.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "90",
    "Bcolor": "102",
    "Y": 9,
    "L": 36.328426361084,
    "a": -6.98071956634521,
    "b": -11.1197557449341,
    "C": 13.1293344497681,
    "h": 237.88037109375,
    "CMY_C": 0.7626850605011,
    "CMY_M": 0.64870935678482,
    "CMY_Y": 0.59946781396866,
    "CMYK_C": 0.40750095248222,
    "CMYK_M": 0.12294028699398,
    "CMYK_Y": 0,
    "CMYK_K": 0.59946781396866
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1087",
    "Farbtonhilfsbezeichnung": "66.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "77",
    "Bcolor": "88",
    "Y": 6,
    "L": 31.3627071380615,
    "a": -5.58130359649658,
    "b": -9.98988914489746,
    "C": 11.4432878494263,
    "h": 240.808120727539,
    "CMY_C": 0.78993552923203,
    "CMY_M": 0.69761204719543,
    "CMY_Y": 0.65323650836945,
    "CMYK_C": 0.39421400427818,
    "CMYK_M": 0.1279706209898,
    "CMYK_Y": 0,
    "CMYK_K": 0.65323650836945
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1088",
    "Farbtonhilfsbezeichnung": "66.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "140",
    "Bcolor": "161",
    "Y": 23,
    "L": 55.2597503662109,
    "a": -12.6132135391235,
    "b": -17.4921722412109,
    "C": 21.5654640197754,
    "h": 234.205474853516,
    "CMY_C": 0.67394626140594,
    "CMY_M": 0.45077925920486,
    "CMY_Y": 0.3693562746048,
    "CMYK_C": 0.48298266530037,
    "CMYK_M": 0.12911090254784,
    "CMYK_Y": 0,
    "CMYK_K": 0.3693562746048
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1089",
    "Farbtonhilfsbezeichnung": "66.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "118",
    "Bcolor": "138",
    "Y": 15,
    "L": 46.9029388427734,
    "a": -11.4307832717896,
    "b": -17.1912479400635,
    "C": 20.6446552276611,
    "h": 236.379333496094,
    "CMY_C": 0.74533301591873,
    "CMY_M": 0.536945104599,
    "CMY_Y": 0.45694077014923,
    "CMYK_C": 0.53105115890503,
    "CMYK_M": 0.14732156693935,
    "CMYK_Y": 0,
    "CMYK_K": 0.45694077014923
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1090",
    "Farbtonhilfsbezeichnung": "66.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "96",
    "Bcolor": "118",
    "Y": 10,
    "L": 38.381965637207,
    "a": -9.41193294525146,
    "b": -17.8231964111328,
    "C": 20.1556644439697,
    "h": 242.162719726562,
    "CMY_C": 0.8149174451828,
    "CMY_M": 0.62301123142242,
    "CMY_Y": 0.53772187232971,
    "CMYK_C": 0.59962946176529,
    "CMYK_M": 0.18449793756008,
    "CMYK_Y": 0,
    "CMYK_K": 0.53772187232971
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1091",
    "Farbtonhilfsbezeichnung": "66.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "85",
    "Bcolor": "102",
    "Y": 7,
    "L": 33.7149047851563,
    "a": -10.1264705657959,
    "b": -15.1136713027954,
    "C": 18.1925392150879,
    "h": 236.177093505859,
    "CMY_C": 0.84999996423721,
    "CMY_M": 0.66668671369553,
    "CMY_Y": 0.60000109672546,
    "CMYK_C": 0.62499886751175,
    "CMYK_M": 0.16671450436115,
    "CMYK_Y": 0,
    "CMYK_K": 0.60000109672546
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1092",
    "Farbtonhilfsbezeichnung": "66.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "144",
    "Bcolor": "173",
    "Y": 23,
    "L": 55.5180320739746,
    "a": -17.6206684112549,
    "b": -24.0587024688721,
    "C": 29.8212871551514,
    "h": 233.780838012695,
    "CMY_C": 0.81294023990631,
    "CMY_M": 0.43707007169724,
    "CMY_Y": 0.322738468647,
    "CMYK_C": 0.72379982471466,
    "CMYK_M": 0.16881455481052,
    "CMYK_Y": 0,
    "CMYK_K": 0.322738468647
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1093",
    "Farbtonhilfsbezeichnung": "66.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "24",
    "Gcolor": "120",
    "Bcolor": "148",
    "Y": 16,
    "L": 46.8071899414063,
    "a": -16.3443393707275,
    "b": -22.9931621551514,
    "C": 28.210334777832,
    "h": 234.593460083008,
    "CMY_C": 0.90499019622803,
    "CMY_M": 0.52760618925095,
    "CMY_Y": 0.42030721902847,
    "CMYK_C": 0.83610320091248,
    "CMYK_M": 0.1850962638855,
    "CMYK_Y": 0,
    "CMYK_K": 0.42030721902847
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1094",
    "Farbtonhilfsbezeichnung": "66.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "3",
    "Gcolor": "100",
    "Bcolor": "128",
    "Y": 10,
    "L": 39.086009979248,
    "a": -13.6881856918335,
    "b": -23.0163440704346,
    "C": 26.7790679931641,
    "h": 239.259368896484,
    "CMY_C": 0.98885107040405,
    "CMY_M": 0.60745918750763,
    "CMY_Y": 0.49812340736389,
    "CMYK_C": 0.97778552770615,
    "CMYK_M": 0.21785391867161,
    "CMYK_Y": 0,
    "CMYK_K": 0.49812340736389
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1095",
    "Farbtonhilfsbezeichnung": "66.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "77",
    "Bcolor": "100",
    "Y": 8,
    "L": 30.4777545928955,
    "a": -8.99232292175293,
    "b": -19.0615634918213,
    "C": 21.0761737823486,
    "h": 244.744323730469,
    "CMY_C": 0.91361254453659,
    "CMY_M": 0.6972536444664,
    "CMY_Y": 0.60670149326324,
    "CMYK_C": 0.78035140037537,
    "CMYK_M": 0.23023772239685,
    "CMYK_Y": 0,
    "CMYK_K": 0.60670149326324
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1096",
    "Farbtonhilfsbezeichnung": "66.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "148",
    "Bcolor": "187",
    "Y": 24,
    "L": 56.3579063415527,
    "a": -21.9369411468506,
    "b": -30.8267326354981,
    "C": 37.835391998291,
    "h": 234.563568115234,
    "CMY_C": 1,
    "CMY_M": 0.4187558889389,
    "CMY_Y": 0.26813966035843,
    "CMYK_C": 1,
    "CMYK_M": 0.20579914748669,
    "CMYK_Y": 0,
    "CMYK_K": 0.26813966035843
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1097",
    "Farbtonhilfsbezeichnung": "66.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "106",
    "Bcolor": "140",
    "Y": 11,
    "L": 40.7510299682617,
    "a": -16.4233455657959,
    "b": -27.8653011322021,
    "C": 32.3450355529785,
    "h": 239.485610961914,
    "CMY_C": 1,
    "CMY_M": 0.58532547950745,
    "CMY_Y": 0.45045733451843,
    "CMYK_C": 1,
    "CMYK_M": 0.24541887640953,
    "CMYK_Y": 0,
    "CMYK_K": 0.45045733451843
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1098",
    "Farbtonhilfsbezeichnung": "69.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "133",
    "Bcolor": "133",
    "Y": 22,
    "L": 54.8202171325684,
    "a": -2.84375429153442,
    "b": -1.9233250617981,
    "C": 3.43309164047241,
    "h": 214.071792602539,
    "CMY_C": 0.51277101039886,
    "CMY_M": 0.47876542806625,
    "CMY_Y": 0.47720181941986,
    "CMYK_C": 0.06803617626429,
    "CMYK_M": 0.00299084559083,
    "CMYK_Y": 0,
    "CMYK_K": 0.47720181941986
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1099",
    "Farbtonhilfsbezeichnung": "69.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "111",
    "Bcolor": "113",
    "Y": 15,
    "L": 46.3221778869629,
    "a": -2.81808543205261,
    "b": -2.37572288513184,
    "C": 3.68587374687195,
    "h": 220.131790161133,
    "CMY_C": 0.59746688604355,
    "CMY_M": 0.56305372714996,
    "CMY_Y": 0.55814111232758,
    "CMYK_C": 0.08900075405836,
    "CMYK_M": 0.01111806277186,
    "CMYK_Y": 0,
    "CMYK_K": 0.55814111232758
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1100",
    "Farbtonhilfsbezeichnung": "69.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "96",
    "Bcolor": "98",
    "Y": 11,
    "L": 40.0180168151855,
    "a": -2.40713882446289,
    "b": -3.09283828735352,
    "C": 3.9191792011261,
    "h": 232.106582641602,
    "CMY_C": 0.65689790248871,
    "CMY_M": 0.62445133924484,
    "CMY_Y": 0.61410319805145,
    "CMYK_C": 0.11089675873518,
    "CMYK_M": 0.02681582607329,
    "CMYK_Y": 0,
    "CMYK_K": 0.61410319805145
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1101",
    "Farbtonhilfsbezeichnung": "69.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "76",
    "Bcolor": "79",
    "Y": 6,
    "L": 31.5990924835205,
    "a": -2.67247772216797,
    "b": -3.56045579910278,
    "C": 4.45185136795044,
    "h": 233.108123779297,
    "CMY_C": 0.73780280351639,
    "CMY_M": 0.70236086845398,
    "CMY_Y": 0.68973422050476,
    "CMYK_C": 0.15492711961269,
    "CMYK_M": 0.04069622978568,
    "CMYK_Y": 0,
    "CMYK_K": 0.68973422050476
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1102",
    "Farbtonhilfsbezeichnung": "69.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "134",
    "Bcolor": "137",
    "Y": 22,
    "L": 54.4807205200195,
    "a": -5.56378984451294,
    "b": -4.92461204528809,
    "C": 7.43017911911011,
    "h": 221.512634277344,
    "CMY_C": 0.54834395647049,
    "CMY_M": 0.47586226463318,
    "CMY_Y": 0.460877597332,
    "CMYK_C": 0.16223840415478,
    "CMYK_M": 0.0277945548296,
    "CMYK_Y": 0,
    "CMYK_K": 0.460877597332
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1103",
    "Farbtonhilfsbezeichnung": "69.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "113",
    "Bcolor": "117",
    "Y": 15,
    "L": 46.0272216796875,
    "a": -6.55622911453247,
    "b": -5.24812364578247,
    "C": 8.39803218841553,
    "h": 218.676544189453,
    "CMY_C": 0.6399610042572,
    "CMY_M": 0.55793225765228,
    "CMY_Y": 0.5428341627121,
    "CMYK_C": 0.21245428919792,
    "CMYK_M": 0.03302542120218,
    "CMYK_Y": 0,
    "CMYK_K": 0.5428341627121
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1104",
    "Farbtonhilfsbezeichnung": "69.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "95",
    "Bcolor": "98",
    "Y": 10,
    "L": 39.1776008605957,
    "a": -5.36775636672974,
    "b": -4.45746231079102,
    "C": 6.97723293304443,
    "h": 219.706726074219,
    "CMY_C": 0.69195950031281,
    "CMY_M": 0.62648111581802,
    "CMY_Y": 0.6138072013855,
    "CMYK_C": 0.20236602425575,
    "CMYK_M": 0.03281758353114,
    "CMYK_Y": 0,
    "CMYK_K": 0.6138072013855
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1105",
    "Farbtonhilfsbezeichnung": "69.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "73",
    "Bcolor": "75",
    "Y": 8,
    "L": 29.9388198852539,
    "a": -3.7215940952301,
    "b": -3.47642588615417,
    "C": 5.09272003173828,
    "h": 223.049224853516,
    "CMY_C": 0.75991797447205,
    "CMY_M": 0.71559292078018,
    "CMY_Y": 0.70546245574951,
    "CMYK_C": 0.18488481640816,
    "CMYK_M": 0.03439447656274,
    "CMYK_Y": 0,
    "CMYK_K": 0.70546245574951
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1106",
    "Farbtonhilfsbezeichnung": "69.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "139",
    "Bcolor": "146",
    "Y": 22,
    "L": 54.9671897888184,
    "a": -13.0971937179565,
    "b": -9.55068397521973,
    "C": 16.2096290588379,
    "h": 216.100128173828,
    "CMY_C": 0.63206392526627,
    "CMY_M": 0.4552441239357,
    "CMY_Y": 0.42577189207077,
    "CMYK_C": 0.35925102233887,
    "CMYK_M": 0.05132495611906,
    "CMYK_Y": 0,
    "CMYK_K": 0.42577189207077
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1107",
    "Farbtonhilfsbezeichnung": "69.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "115",
    "Bcolor": "124",
    "Y": 14,
    "L": 45.7605476379395,
    "a": -11.2771673202515,
    "b": -10.4282217025757,
    "C": 15.3597631454468,
    "h": 222.760177612305,
    "CMY_C": 0.71003758907318,
    "CMY_M": 0.55049902200699,
    "CMY_Y": 0.51237136125565,
    "CMYK_C": 0.40536221861839,
    "CMYK_M": 0.07818995416164,
    "CMYK_Y": 0,
    "CMYK_K": 0.51237136125565
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1108",
    "Farbtonhilfsbezeichnung": "69.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "95",
    "Bcolor": "104",
    "Y": 9,
    "L": 38.2266654968262,
    "a": -9.39491748809814,
    "b": -9.25162315368652,
    "C": 13.1854848861694,
    "h": 224.559692382812,
    "CMY_C": 0.7574371099472,
    "CMY_M": 0.62705993652344,
    "CMY_Y": 0.59316563606262,
    "CMYK_C": 0.40377974510193,
    "CMYK_M": 0.08331228792667,
    "CMYK_Y": 0,
    "CMYK_K": 0.59316563606262
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1109",
    "Farbtonhilfsbezeichnung": "69.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "81",
    "Bcolor": "89",
    "Y": 6,
    "L": 32.7632064819336,
    "a": -8.1513500213623,
    "b": -8.37084484100342,
    "C": 11.6839866638184,
    "h": 225.761108398438,
    "CMY_C": 0.79193896055222,
    "CMY_M": 0.68074452877045,
    "CMY_Y": 0.65023773908615,
    "CMYK_C": 0.40513581037521,
    "CMYK_M": 0.08722150325775,
    "CMYK_Y": 0,
    "CMYK_K": 0.65023773908615
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1110",
    "Farbtonhilfsbezeichnung": "69.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "142",
    "Bcolor": "160",
    "Y": 23,
    "L": 55.2771377563477,
    "a": -15.9237308502197,
    "b": -17.1099357604981,
    "C": 23.373384475708,
    "h": 227.056549072266,
    "CMY_C": 0.71194338798523,
    "CMY_M": 0.44475549459457,
    "CMY_Y": 0.37204003334045,
    "CMYK_C": 0.54128187894821,
    "CMYK_M": 0.11579633504152,
    "CMYK_Y": 0,
    "CMYK_K": 0.37204003334045
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1111",
    "Farbtonhilfsbezeichnung": "69.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "116",
    "Bcolor": "134",
    "Y": 15,
    "L": 45.5952262878418,
    "a": -13.5720949172974,
    "b": -16.3169765472412,
    "C": 21.2237014770508,
    "h": 230.2470703125,
    "CMY_C": 0.77946925163269,
    "CMY_M": 0.5464072227478,
    "CMY_Y": 0.47599720954895,
    "CMYK_C": 0.5791420340538,
    "CMYK_M": 0.13436953723431,
    "CMYK_Y": 0,
    "CMYK_K": 0.47599720954895
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1112",
    "Farbtonhilfsbezeichnung": "69.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "96",
    "Bcolor": "115",
    "Y": 9,
    "L": 38.0138168334961,
    "a": -12.5278034210205,
    "b": -16.7598991394043,
    "C": 20.9246292114258,
    "h": 233.222366333008,
    "CMY_C": 0.85343039035797,
    "CMY_M": 0.62164396047592,
    "CMY_Y": 0.54827845096588,
    "CMYK_C": 0.67553108930588,
    "CMYK_M": 0.16241312026978,
    "CMYK_Y": 0,
    "CMYK_K": 0.54827845096588
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1113",
    "Farbtonhilfsbezeichnung": "69.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "81",
    "Bcolor": "98",
    "Y": 7,
    "L": 32.2170753479004,
    "a": -10.0223846435547,
    "b": -15.1726160049438,
    "C": 18.1839618682861,
    "h": 236.552947998047,
    "CMY_C": 0.86511290073395,
    "CMY_M": 0.68077433109283,
    "CMY_Y": 0.61393678188324,
    "CMYK_C": 0.65060877799988,
    "CMYK_M": 0.1731259226799,
    "CMYK_Y": 0,
    "CMYK_K": 0.61393678188324
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1114",
    "Farbtonhilfsbezeichnung": "69.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "148",
    "Bcolor": "175",
    "Y": 24,
    "L": 56.6518287658691,
    "a": -20.3409442901611,
    "b": -23.8919868469238,
    "C": 31.3780345916748,
    "h": 229.589889526367,
    "CMY_C": 0.85938620567322,
    "CMY_M": 0.4207957983017,
    "CMY_Y": 0.31211572885513,
    "CMYK_C": 0.79558509588242,
    "CMYK_M": 0.15799179673195,
    "CMYK_Y": 0,
    "CMYK_K": 0.31211572885513
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1115",
    "Farbtonhilfsbezeichnung": "69.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "123",
    "Bcolor": "148",
    "Y": 16,
    "L": 47.2529792785645,
    "a": -20.5769901275635,
    "b": -22.5584297180176,
    "C": 30.5335102081299,
    "h": 227.63005065918,
    "CMY_C": 1,
    "CMY_M": 0.51645934581757,
    "CMY_Y": 0.41890239715576,
    "CMYK_C": 1,
    "CMYK_M": 0.16788393259048,
    "CMYK_Y": 0,
    "CMYK_K": 0.41890239715576
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1116",
    "Farbtonhilfsbezeichnung": "69.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "127",
    "Y": 10,
    "L": 39.6485328674316,
    "a": -17.7657375335693,
    "b": -21.2708377838135,
    "C": 27.714075088501,
    "h": 230.130844116211,
    "CMY_C": 1,
    "CMY_M": 0.59619688987732,
    "CMY_Y": 0.503910779953,
    "CMYK_C": 1,
    "CMYK_M": 0.18602724373341,
    "CMYK_Y": 0,
    "CMYK_K": 0.503910779953
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1117",
    "Farbtonhilfsbezeichnung": "69.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "151",
    "Bcolor": "173",
    "Y": 24,
    "L": 56.2192497253418,
    "a": -30.7321891784668,
    "b": -23.1671504974365,
    "C": 38.486156463623,
    "h": 217.010437011719,
    "CMY_C": 1,
    "CMY_M": 0.40886414051056,
    "CMY_Y": 0.32239031791687,
    "CMYK_C": 1,
    "CMYK_M": 0.12761597335339,
    "CMYK_Y": 0,
    "CMYK_K": 0.32239031791687
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1118",
    "Farbtonhilfsbezeichnung": "69.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "146",
    "Y": 17,
    "L": 47.8081016540527,
    "a": -30.1227264404297,
    "b": -20.4411888122559,
    "C": 36.4035835266113,
    "h": 214.160690307617,
    "CMY_C": 1,
    "CMY_M": 0.49723970890045,
    "CMY_Y": 0.4278364777565,
    "CMYK_C": 1,
    "CMYK_M": 0.1212996467948,
    "CMYK_Y": 0,
    "CMYK_K": 0.4278364777565
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1119",
    "Farbtonhilfsbezeichnung": "69.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "123",
    "Y": 10,
    "L": 39.0990104675293,
    "a": -20.7291164398193,
    "b": -19.7853851318359,
    "C": 28.6558494567871,
    "h": 223.665618896484,
    "CMY_C": 1,
    "CMY_M": 0.59755480289459,
    "CMY_Y": 0.51902794837952,
    "CMYK_C": 1,
    "CMYK_M": 0.16326698660851,
    "CMYK_Y": 0,
    "CMYK_K": 0.51902794837952
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1120",
    "Farbtonhilfsbezeichnung": "69.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "154",
    "Bcolor": "166",
    "Y": 25,
    "L": 57.062931060791,
    "a": -35.6077346801758,
    "b": -17.8181285858154,
    "C": 39.8170356750488,
    "h": 206.583404541016,
    "CMY_C": 1,
    "CMY_M": 0.39441204071045,
    "CMY_Y": 0.350266456604,
    "CMYK_C": 1,
    "CMYK_M": 0.06794413924217,
    "CMYK_Y": 0,
    "CMYK_K": 0.350266456604
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1121",
    "Farbtonhilfsbezeichnung": "69.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "139",
    "Y": 16,
    "L": 47.2733955383301,
    "a": -29.6420974731445,
    "b": -16.9522686004639,
    "C": 34.1472320556641,
    "h": 209.765167236328,
    "CMY_C": 1,
    "CMY_M": 0.50438547134399,
    "CMY_Y": 0.45617938041687,
    "CMYK_C": 1,
    "CMYK_M": 0.08864336460829,
    "CMYK_Y": 0,
    "CMYK_K": 0.45617938041687
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1122",
    "Farbtonhilfsbezeichnung": "69.21.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "116",
    "Y": 10,
    "L": 39.0534210205078,
    "a": -23.8105010986328,
    "b": -15.7570743560791,
    "C": 28.5521507263184,
    "h": 213.495391845703,
    "CMY_C": 1,
    "CMY_M": 0.59477061033249,
    "CMY_Y": 0.54526388645172,
    "CMYK_C": 1,
    "CMYK_M": 0.10886912792921,
    "CMYK_Y": 0,
    "CMYK_K": 0.54526388645172
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1123",
    "Farbtonhilfsbezeichnung": "72.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "97",
    "Bcolor": "98",
    "Y": 13,
    "L": 40.7187232971191,
    "a": -1.79748141765594,
    "b": -2.04493260383606,
    "C": 2.72262525558472,
    "h": 228.684753417969,
    "CMY_C": 0.64241969585419,
    "CMY_M": 0.61923813819885,
    "CMY_Y": 0.61399573087692,
    "CMYK_C": 0.07363639771938,
    "CMYK_M": 0.0135812163353,
    "CMYK_Y": 0,
    "CMYK_K": 0.61399573087692
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1124",
    "Farbtonhilfsbezeichnung": "72.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "89",
    "Bcolor": "93",
    "Y": 12,
    "L": 37.3432121276855,
    "a": -1.68962335586548,
    "b": -3.43416738510132,
    "C": 3.82731413841248,
    "h": 243.802642822266,
    "CMY_C": 0.67786741256714,
    "CMY_M": 0.6510306596756,
    "CMY_Y": 0.63715189695358,
    "CMYK_C": 0.11221090704203,
    "CMYK_M": 0.03824951127172,
    "CMYK_Y": 0,
    "CMYK_K": 0.63715189695358
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1125",
    "Farbtonhilfsbezeichnung": "72.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "68",
    "Bcolor": "73",
    "Y": 7,
    "L": 28.545711517334,
    "a": -1.41868460178375,
    "b": -3.84333205223083,
    "C": 4.09681177139282,
    "h": 249.739440917969,
    "CMY_C": 0.75721687078476,
    "CMY_M": 0.73226094245911,
    "CMY_Y": 0.71563416719437,
    "CMYK_C": 0.14622960984707,
    "CMYK_M": 0.05846966430545,
    "CMYK_Y": 0,
    "CMYK_K": 0.71563416719437
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1126",
    "Farbtonhilfsbezeichnung": "72.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "138",
    "Bcolor": "141",
    "Y": 23,
    "L": 54.9018630981445,
    "a": -12.4516525268555,
    "b": -6.55484247207642,
    "C": 14.0715885162354,
    "h": 207.763381958008,
    "CMY_C": 0.61088478565216,
    "CMY_M": 0.45792365074158,
    "CMY_Y": 0.44645398855209,
    "CMYK_C": 0.29704990983009,
    "CMYK_M": 0.02072034031153,
    "CMYK_Y": 0,
    "CMYK_K": 0.44645398855209
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1127",
    "Farbtonhilfsbezeichnung": "72.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "115",
    "Bcolor": "119",
    "Y": 15,
    "L": 45.6859436035156,
    "a": -12.6751775741577,
    "b": -7.56157207489014,
    "C": 14.7593193054199,
    "h": 210.818832397461,
    "CMY_C": 0.70865422487259,
    "CMY_M": 0.54956638813019,
    "CMY_Y": 0.5318124294281,
    "CMYK_C": 0.37771570682526,
    "CMYK_M": 0.03792060911655,
    "CMYK_Y": 0,
    "CMYK_K": 0.5318124294281
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1128",
    "Farbtonhilfsbezeichnung": "72.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "95",
    "Bcolor": "97",
    "Y": 10,
    "L": 38.0197601318359,
    "a": -11.6263847351074,
    "b": -5.60713386535645,
    "C": 12.9078569412231,
    "h": 205.746932983398,
    "CMY_C": 0.76132792234421,
    "CMY_M": 0.62619948387146,
    "CMY_Y": 0.61819022893906,
    "CMYK_C": 0.37489268183708,
    "CMYK_M": 0.02097708173096,
    "CMYK_Y": 0,
    "CMYK_K": 0.61819022893906
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1129",
    "Farbtonhilfsbezeichnung": "72.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "87",
    "Bcolor": "93",
    "Y": 7,
    "L": 34.1308174133301,
    "a": -12.6323566436768,
    "b": -8.72220420837402,
    "C": 15.3510026931763,
    "h": 214.623733520508,
    "CMY_C": 0.82704496383667,
    "CMY_M": 0.66055560112,
    "CMY_Y": 0.6356452703476,
    "CMYK_C": 0.52531141042709,
    "CMYK_M": 0.06836834549904,
    "CMYK_Y": 0,
    "CMYK_K": 0.6356452703476
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1130",
    "Farbtonhilfsbezeichnung": "72.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "140",
    "Bcolor": "155",
    "Y": 22,
    "L": 54.513973236084,
    "a": -18.1375274658203,
    "b": -15.0719928741455,
    "C": 23.5825119018555,
    "h": 219.726028442383,
    "CMY_C": 0.73315519094467,
    "CMY_M": 0.44931823015213,
    "CMY_Y": 0.393834233284,
    "CMYK_C": 0.55978244543076,
    "CMYK_M": 0.09153271466494,
    "CMYK_Y": 0,
    "CMYK_K": 0.393834233284
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1131",
    "Farbtonhilfsbezeichnung": "72.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "120",
    "Bcolor": "136",
    "Y": 16,
    "L": 46.912223815918,
    "a": -16.80495262146,
    "b": -15.7008895874023,
    "C": 22.9983558654785,
    "h": 223.0546875,
    "CMY_C": 0.80594211816788,
    "CMY_M": 0.52810573577881,
    "CMY_Y": 0.46702867746353,
    "CMYK_C": 0.63589429855347,
    "CMYK_M": 0.11459726840258,
    "CMYK_Y": 0,
    "CMYK_K": 0.46702867746353
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1132",
    "Farbtonhilfsbezeichnung": "72.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "98",
    "Bcolor": "111",
    "Y": 10,
    "L": 38.227855682373,
    "a": -14.3340892791748,
    "b": -13.97216796875,
    "C": 20.017183303833,
    "h": 224.267456054688,
    "CMY_C": 0.85021072626114,
    "CMY_M": 0.61750906705856,
    "CMY_Y": 0.56389343738556,
    "CMYK_C": 0.65653055906296,
    "CMYK_M": 0.12294157594442,
    "CMYK_Y": 0,
    "CMYK_K": 0.56389343738556
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1133",
    "Farbtonhilfsbezeichnung": "72.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "28",
    "Gcolor": "82",
    "Bcolor": "94",
    "Y": 7,
    "L": 31.9173698425293,
    "a": -13.040150642395,
    "b": -12.923791885376,
    "C": 18.3594646453857,
    "h": 224.743225097656,
    "CMY_C": 0.89141130447388,
    "CMY_M": 0.6794513463974,
    "CMY_Y": 0.6307600736618,
    "CMYK_C": 0.70591288805008,
    "CMYK_M": 0.13186892867088,
    "CMYK_Y": 0,
    "CMYK_K": 0.6307600736618
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1134",
    "Farbtonhilfsbezeichnung": "72.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "140",
    "Bcolor": "140",
    "Y": 22,
    "L": 52.6669731140137,
    "a": -28.8356018066406,
    "b": -9.21192932128906,
    "C": 30.2712993621826,
    "h": 197.716796875,
    "CMY_C": 0.89515924453735,
    "CMY_M": 0.45261061191559,
    "CMY_Y": 0.45284879207611,
    "CMYK_C": 0.80847132205963,
    "CMYK_M": 0,
    "CMYK_Y": 0.00043512016418,
    "CMYK_K": 0.45261061191559
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1135",
    "Farbtonhilfsbezeichnung": "72.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "120",
    "Bcolor": "123",
    "Y": 15,
    "L": 46.0853996276855,
    "a": -22.0664844512939,
    "b": -9.43759822845459,
    "C": 23.9999580383301,
    "h": 203.155883789062,
    "CMY_C": 0.83788126707077,
    "CMY_M": 0.52967262268066,
    "CMY_Y": 0.51655006408691,
    "CMYK_C": 0.66466283798218,
    "CMYK_M": 0.02714357338846,
    "CMYK_Y": 0,
    "CMYK_K": 0.51655006408691
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1136",
    "Farbtonhilfsbezeichnung": "72.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "99",
    "Bcolor": "107",
    "Y": 10,
    "L": 38.3940391540527,
    "a": -17.9557800292969,
    "b": -10.8716278076172,
    "C": 20.9905300140381,
    "h": 211.193511962891,
    "CMY_C": 0.8753445148468,
    "CMY_M": 0.6111204624176,
    "CMY_Y": 0.58209812641144,
    "CMYK_C": 0.70171111822128,
    "CMYK_M": 0.06944772601128,
    "CMYK_Y": 0,
    "CMYK_K": 0.58209812641144
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1137",
    "Farbtonhilfsbezeichnung": "72.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "70",
    "Bcolor": "78",
    "Y": 7,
    "L": 26.0474967956543,
    "a": -17.9570140838623,
    "b": -11.5258731842041,
    "C": 21.3377628326416,
    "h": 212.694747924805,
    "CMY_C": 1,
    "CMY_M": 0.72683656215668,
    "CMY_Y": 0.6940506696701,
    "CMYK_C": 1,
    "CMYK_M": 0.10716118663549,
    "CMYK_Y": 0,
    "CMYK_K": 0.6940506696701
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1138",
    "Farbtonhilfsbezeichnung": "72.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "153",
    "Bcolor": "148",
    "Y": 25,
    "L": 56.8927230834961,
    "a": -36.1685447692871,
    "b": -7.72546720504761,
    "C": 36.9844093322754,
    "h": 192.056991577148,
    "CMY_C": 1,
    "CMY_M": 0.39813911914825,
    "CMY_Y": 0.42058581113815,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.03729548305273,
    "CMYK_K": 0.39813911914825
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1139",
    "Farbtonhilfsbezeichnung": "72.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "108",
    "Y": 10,
    "L": 38.6368217468262,
    "a": -26.4782810211182,
    "b": -11.6417169570923,
    "C": 28.92453956604,
    "h": 203.733673095703,
    "CMY_C": 1,
    "CMY_M": 0.59627950191498,
    "CMY_Y": 0.57555317878723,
    "CMYK_C": 1,
    "CMYK_M": 0.04883137717843,
    "CMYK_Y": 0,
    "CMYK_K": 0.57555317878723
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1140",
    "Farbtonhilfsbezeichnung": "72.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "145",
    "Y": 21,
    "L": 52.4624519348145,
    "a": -37.6933212280273,
    "b": -12.7657175064087,
    "C": 39.7963562011719,
    "h": 198.709869384766,
    "CMY_C": 1,
    "CMY_M": 0.44101691246033,
    "CMY_Y": 0.43190777301788,
    "CMYK_C": 1,
    "CMYK_M": 0.01603461429477,
    "CMYK_Y": 0,
    "CMYK_K": 0.43190777301788
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1141",
    "Farbtonhilfsbezeichnung": "72.21.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "134",
    "Y": 16,
    "L": 47.7364501953125,
    "a": -31.8036365509033,
    "b": -13.2167339324951,
    "C": 34.4405784606934,
    "h": 202.566452026367,
    "CMY_C": 1,
    "CMY_M": 0.49768352508545,
    "CMY_Y": 0.4762020111084,
    "CMYK_C": 1,
    "CMYK_M": 0.04101106524467,
    "CMYK_Y": 0,
    "CMYK_K": 0.4762020111084
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1142",
    "Farbtonhilfsbezeichnung": "75.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "134",
    "Bcolor": "131",
    "Y": 23,
    "L": 55.5774307250977,
    "a": -2.06309795379639,
    "b": 0.77496683597565,
    "C": 2.20384812355042,
    "h": 159.412185668945,
    "CMY_C": 0.49047696590424,
    "CMY_M": 0.47344833612442,
    "CMY_Y": 0.48758524656296,
    "CMYK_C": 0.03233990445733,
    "CMYK_M": 0,
    "CMYK_Y": 0.02684809826314,
    "CMYK_K": 0.47344833612442
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1143",
    "Farbtonhilfsbezeichnung": "75.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "113",
    "Bcolor": "110",
    "Y": 18,
    "L": 47.2060203552246,
    "a": -1.29143381118774,
    "b": 0.75744885206223,
    "C": 1.49717402458191,
    "h": 149.607620239258,
    "CMY_C": 0.56779718399048,
    "CMY_M": 0.55828607082367,
    "CMY_Y": 0.56969875097275,
    "CMYK_C": 0.02153229154646,
    "CMYK_M": 0,
    "CMYK_Y": 0.02583726495504,
    "CMYK_K": 0.55828607082367
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1144",
    "Farbtonhilfsbezeichnung": "75.03.27",
    "Farbtonklasse": "02",
    "Rcolor": "84",
    "Gcolor": "88",
    "Bcolor": "87",
    "Y": 11,
    "L": 37.0981101989746,
    "a": -1.64116489887238,
    "b": -0.49436241388321,
    "C": 1.71400594711304,
    "h": 196.763702392578,
    "CMY_C": 0.67032301425934,
    "CMY_M": 0.65415477752686,
    "CMY_Y": 0.65772211551666,
    "CMYK_C": 0.04674991965294,
    "CMYK_M": 0,
    "CMYK_Y": 0.01031483989209,
    "CMYK_K": 0.65415477752686
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1145",
    "Farbtonhilfsbezeichnung": "75.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "134",
    "Bcolor": "131",
    "Y": 23,
    "L": 55.1847534179688,
    "a": -3.94458484649658,
    "b": -0.1935825496912,
    "C": 3.94933199882507,
    "h": 182.8095703125,
    "CMY_C": 0.51152664422989,
    "CMY_M": 0.47327184677124,
    "CMY_Y": 0.48525285720825,
    "CMYK_C": 0.07262720912695,
    "CMYK_M": 0,
    "CMYK_Y": 0.02274609915912,
    "CMYK_K": 0.47327184677124
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1146",
    "Farbtonhilfsbezeichnung": "75.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "112",
    "Bcolor": "109",
    "Y": 15,
    "L": 46.2961502075195,
    "a": -4.06859445571899,
    "b": -0.48449471592903,
    "C": 4.09734010696411,
    "h": 186.790893554688,
    "CMY_C": 0.60054171085358,
    "CMY_M": 0.56131279468536,
    "CMY_Y": 0.57077872753143,
    "CMYK_C": 0.08942343294621,
    "CMYK_M": 0,
    "CMYK_Y": 0.02157786488533,
    "CMYK_K": 0.56131279468536
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1147",
    "Farbtonhilfsbezeichnung": "75.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "90",
    "Bcolor": "90",
    "Y": 9,
    "L": 37.4222183227539,
    "a": -3.55987596511841,
    "b": -1.46061778068542,
    "C": 3.84787225723267,
    "h": 202.308349609375,
    "CMY_C": 0.68389272689819,
    "CMY_M": 0.64720845222473,
    "CMY_Y": 0.64890140295029,
    "CMYK_C": 0.10398285835981,
    "CMYK_M": 0,
    "CMYK_Y": 0.00479872804135,
    "CMYK_K": 0.64720845222473
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1148",
    "Farbtonhilfsbezeichnung": "75.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "137",
    "Bcolor": "131",
    "Y": 23,
    "L": 55.4226989746094,
    "a": -8.14621067047119,
    "b": 0.15356341004372,
    "C": 8.1476583480835,
    "h": 178.920059204102,
    "CMY_C": 0.54044008255005,
    "CMY_M": 0.4625523686409,
    "CMY_Y": 0.48570507764816,
    "CMYK_C": 0.14492149651051,
    "CMYK_M": 0,
    "CMYK_Y": 0.04307900369167,
    "CMYK_K": 0.4625523686409
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1149",
    "Farbtonhilfsbezeichnung": "75.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "113",
    "Bcolor": "109",
    "Y": 15,
    "L": 46.0793724060059,
    "a": -7.245041847229,
    "b": -0.33029866218567,
    "C": 7.25256681442261,
    "h": 182.610290527344,
    "CMY_C": 0.62607401609421,
    "CMY_M": 0.55736935138702,
    "CMY_Y": 0.57423710823059,
    "CMYK_C": 0.15521894395351,
    "CMYK_M": 0,
    "CMYK_Y": 0.03810797259212,
    "CMYK_K": 0.55736935138702
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1150",
    "Farbtonhilfsbezeichnung": "75.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "81",
    "Bcolor": "78",
    "Y": 7,
    "L": 32.817066192627,
    "a": -8.75380706787109,
    "b": -1.35637545585632,
    "C": 8.85826683044434,
    "h": 188.807769775391,
    "CMY_C": 0.76471585035324,
    "CMY_M": 0.68097126483917,
    "CMY_Y": 0.69261693954468,
    "CMYK_C": 0.2624985575676,
    "CMYK_M": 0,
    "CMYK_Y": 0.03650352731347,
    "CMYK_K": 0.68097126483917
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1152",
    "Farbtonhilfsbezeichnung": "75.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "117",
    "Bcolor": "114",
    "Y": 15,
    "L": 46.4571990966797,
    "a": -13.0258569717407,
    "b": -3.24704742431641,
    "C": 13.4244651794434,
    "h": 193.997253417969,
    "CMY_C": 0.68280804157257,
    "CMY_M": 0.54245615005493,
    "CMY_Y": 0.55228042602539,
    "CMYK_C": 0.30675068497658,
    "CMYK_M": 0,
    "CMYK_Y": 0.02147176861763,
    "CMYK_K": 0.54245615005493
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1153",
    "Farbtonhilfsbezeichnung": "75.12.27",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "71",
    "Bcolor": "69",
    "Y": 7,
    "L": 27.112491607666,
    "a": -17.0429649353027,
    "b": -4.25085115432739,
    "C": 17.5650901794434,
    "h": 194.004943847656,
    "CMY_C": 0.92295008897781,
    "CMY_M": 0.72013437747955,
    "CMY_Y": 0.72748959064484,
    "CMYK_C": 0.72468960285187,
    "CMYK_M": 0,
    "CMYK_Y": 0.0262812320143,
    "CMYK_K": 0.72013437747955
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1154",
    "Farbtonhilfsbezeichnung": "75.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "137",
    "Bcolor": "129",
    "Y": 22,
    "L": 52.8050003051758,
    "a": -21.9442958831787,
    "b": -2.75278186798096,
    "C": 22.1162815093994,
    "h": 187.15007019043,
    "CMY_C": 0.7092912197113,
    "CMY_M": 0.463707447052,
    "CMY_Y": 0.49390000104904,
    "CMYK_C": 0.45792874693871,
    "CMYK_M": 0,
    "CMYK_Y": 0.05629866197705,
    "CMYK_K": 0.463707447052
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1155",
    "Farbtonhilfsbezeichnung": "75.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "117",
    "Bcolor": "110",
    "Y": 15,
    "L": 46.4356460571289,
    "a": -14.4963636398315,
    "b": -0.89325648546219,
    "C": 14.5238580703735,
    "h": 183.526062011719,
    "CMY_C": 0.68564909696579,
    "CMY_M": 0.54069149494171,
    "CMY_Y": 0.56793653964996,
    "CMYK_C": 0.31559965014458,
    "CMYK_M": 0,
    "CMYK_Y": 0.05931752547622,
    "CMYK_K": 0.54069149494171
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1156",
    "Farbtonhilfsbezeichnung": "75.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "93",
    "Bcolor": "91",
    "Y": 9,
    "L": 37.1541061401367,
    "a": -12.3097715377808,
    "b": -3.1669704914093,
    "C": 12.7106323242188,
    "h": 194.427764892578,
    "CMY_C": 0.76365721225739,
    "CMY_M": 0.63390636444092,
    "CMY_Y": 0.6416711807251,
    "CMYK_C": 0.35441982746124,
    "CMYK_M": 0,
    "CMYK_Y": 0.02120991796255,
    "CMYK_K": 0.63390636444092
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1157",
    "Farbtonhilfsbezeichnung": "75.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "155",
    "Bcolor": "140",
    "Y": 24,
    "L": 56.7569351196289,
    "a": -42.6864891052246,
    "b": -3.40841889381409,
    "C": 42.8223495483398,
    "h": 184.565246582031,
    "CMY_C": 1,
    "CMY_M": 0.39144933223724,
    "CMY_Y": 0.45183330774307,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09922587871552,
    "CMYK_K": 0.39144933223724
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1158",
    "Farbtonhilfsbezeichnung": "75.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "119",
    "Y": 16,
    "L": 47.6410446166992,
    "a": -33.8812484741211,
    "b": -4.43797302246094,
    "C": 34.1706695556641,
    "h": 187.462463378906,
    "CMY_C": 1,
    "CMY_M": 0.49799853563309,
    "CMY_Y": 0.5349109172821,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07353042811155,
    "CMYK_K": 0.49799853563309
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1159",
    "Farbtonhilfsbezeichnung": "75.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "97",
    "Y": 10,
    "L": 38.6624946594238,
    "a": -28.2182712554932,
    "b": -4.62983751296997,
    "C": 28.5955638885498,
    "h": 189.317626953125,
    "CMY_C": 1,
    "CMY_M": 0.59541416168213,
    "CMY_Y": 0.61971306800842,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.06005871668458,
    "CMYK_K": 0.59541416168213
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1160",
    "Farbtonhilfsbezeichnung": "78.03.21",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "134",
    "Bcolor": "125",
    "Y": 22,
    "L": 54.2122611999512,
    "a": -8.13103771209717,
    "b": 2.24436354637146,
    "C": 8.43510150909424,
    "h": 164.569198608398,
    "CMY_C": 0.54488086700439,
    "CMY_M": 0.47534781694412,
    "CMY_Y": 0.5117409825325,
    "CMYK_C": 0.13253170251846,
    "CMYK_M": 0,
    "CMYK_Y": 0.06936626881361,
    "CMYK_K": 0.47534781694412
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1161",
    "Farbtonhilfsbezeichnung": "78.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "110",
    "Bcolor": "103",
    "Y": 14,
    "L": 45.1093635559082,
    "a": -6.56825923919678,
    "b": 1.40497052669525,
    "C": 6.71684217453003,
    "h": 167.926208496094,
    "CMY_C": 0.62417757511139,
    "CMY_M": 0.56854182481766,
    "CMY_Y": 0.5947060585022,
    "CMYK_C": 0.1289481818676,
    "CMYK_M": 0,
    "CMYK_Y": 0.06064141541719,
    "CMYK_K": 0.56854182481766
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1162",
    "Farbtonhilfsbezeichnung": "78.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "90",
    "Bcolor": "87",
    "Y": 9,
    "L": 36.8175315856934,
    "a": -7.08062791824341,
    "b": -0.85967010259628,
    "C": 7.13262414932251,
    "h": 186.922485351562,
    "CMY_C": 0.71346712112427,
    "CMY_M": 0.64659470319748,
    "CMY_Y": 0.65865576267242,
    "CMYK_C": 0.18922302126884,
    "CMYK_M": 0,
    "CMYK_Y": 0.03412812203169,
    "CMYK_K": 0.64659470319748
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1163",
    "Farbtonhilfsbezeichnung": "78.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "63",
    "Bcolor": "61",
    "Y": 6,
    "L": 25.6129741668701,
    "a": -5.74925327301025,
    "b": -0.44213616847992,
    "C": 5.76622915267944,
    "h": 184.397567749023,
    "CMY_C": 0.80192053318024,
    "CMY_M": 0.7516176700592,
    "CMY_Y": 0.76220011711121,
    "CMYK_C": 0.202521905303,
    "CMYK_M": 0,
    "CMYK_Y": 0.04260547459126,
    "CMYK_K": 0.7516176700592
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1164",
    "Farbtonhilfsbezeichnung": "78.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "143",
    "Bcolor": "115",
    "Y": 22,
    "L": 54.80078125,
    "a": -25.2130088806152,
    "b": 8.15329456329346,
    "C": 26.4985294342041,
    "h": 162.080001831055,
    "CMY_C": 0.66643536090851,
    "CMY_M": 0.4403390288353,
    "CMY_Y": 0.54775047302246,
    "CMYK_C": 0.4039880335331,
    "CMYK_M": 0,
    "CMYK_Y": 0.19192233681679,
    "CMYK_K": 0.4403390288353
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1165",
    "Farbtonhilfsbezeichnung": "78.06.24",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "117",
    "Bcolor": "98",
    "Y": 17,
    "L": 45.127628326416,
    "a": -22.6083927154541,
    "b": 4.63749742507935,
    "C": 23.0791206359863,
    "h": 168.408126831055,
    "CMY_C": 0.75178629159927,
    "CMY_M": 0.54167038202286,
    "CMY_Y": 0.61730146408081,
    "CMYK_C": 0.45843842625618,
    "CMYK_M": 0,
    "CMYK_Y": 0.16501460969448,
    "CMYK_K": 0.54167038202286
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1166",
    "Farbtonhilfsbezeichnung": "78.06.27",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "88",
    "Bcolor": "72",
    "Y": 10,
    "L": 34.5863456726074,
    "a": -15.7517690658569,
    "b": 5.04897880554199,
    "C": 16.5411739349365,
    "h": 162.227584838867,
    "CMY_C": 0.78229749202728,
    "CMY_M": 0.65451073646545,
    "CMY_Y": 0.71671509742737,
    "CMYK_C": 0.3698718547821,
    "CMYK_M": 0,
    "CMYK_Y": 0.18004715442657,
    "CMYK_K": 0.65451073646545
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1167",
    "Farbtonhilfsbezeichnung": "78.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "139",
    "Bcolor": "118",
    "Y": 22,
    "L": 54.5949783325195,
    "a": -18.2616367340088,
    "b": 6.48547458648682,
    "C": 19.3790798187256,
    "h": 160.447906494141,
    "CMY_C": 0.60941332578659,
    "CMY_M": 0.4537752866745,
    "CMY_Y": 0.53765940666199,
    "CMYK_C": 0.2849340736866,
    "CMYK_M": 0,
    "CMYK_Y": 0.1535707116127,
    "CMYK_K": 0.4537752866745
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1168",
    "Farbtonhilfsbezeichnung": "78.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "116",
    "Bcolor": "99",
    "Y": 15,
    "L": 45.8575630187988,
    "a": -15.8428640365601,
    "b": 4.84283781051636,
    "C": 16.5665149688721,
    "h": 163.002685546875,
    "CMY_C": 0.67910146713257,
    "CMY_M": 0.54539662599564,
    "CMY_Y": 0.61093091964722,
    "CMYK_C": 0.29411315917969,
    "CMYK_M": 0,
    "CMYK_Y": 0.14415708184242,
    "CMYK_K": 0.54539662599564
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1169",
    "Farbtonhilfsbezeichnung": "78.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "153",
    "Bcolor": "130",
    "Y": 24,
    "L": 56.7526969909668,
    "a": -37.0150337219238,
    "b": 2.2699077129364,
    "C": 37.0845680236816,
    "h": 176.490783691406,
    "CMY_C": 0.86752140522003,
    "CMY_M": 0.40073508024216,
    "CMY_Y": 0.48990458250046,
    "CMYK_C": 0.77893149852753,
    "CMYK_M": 0,
    "CMYK_Y": 0.14879813790321,
    "CMYK_K": 0.40073508024216
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1170",
    "Farbtonhilfsbezeichnung": "78.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "13",
    "Gcolor": "125",
    "Bcolor": "106",
    "Y": 15,
    "L": 46.7096405029297,
    "a": -33.2175903320313,
    "b": 1.62107419967651,
    "C": 33.2571220397949,
    "h": 177.206085205078,
    "CMY_C": 0.95036989450455,
    "CMY_M": 0.50972604751587,
    "CMY_Y": 0.58360052108765,
    "CMYK_C": 0.89877068996429,
    "CMYK_M": 0,
    "CMYK_Y": 0.15067999064922,
    "CMYK_K": 0.50972604751587
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1171",
    "Farbtonhilfsbezeichnung": "78.12.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "80",
    "Y": 10,
    "L": 35.0691375732422,
    "a": -34.6402778625488,
    "b": 0.3838033080101,
    "C": 34.6424026489258,
    "h": 179.365203857422,
    "CMY_C": 1,
    "CMY_M": 0.62361574172974,
    "CMY_Y": 0.68514561653137,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.16347621381283,
    "CMYK_K": 0.62361574172974
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1172",
    "Farbtonhilfsbezeichnung": "78.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "147",
    "Bcolor": "125",
    "Y": 24,
    "L": 56.2243881225586,
    "a": -25.5968627929688,
    "b": 4.66982364654541,
    "C": 26.0193519592285,
    "h": 169.66081237793,
    "CMY_C": 0.67338520288467,
    "CMY_M": 0.42428469657898,
    "CMY_Y": 0.51020556688309,
    "CMYK_C": 0.43268001079559,
    "CMYK_M": 0,
    "CMYK_Y": 0.14924193918705,
    "CMYK_K": 0.42428469657898
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1173",
    "Farbtonhilfsbezeichnung": "78.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "118",
    "Bcolor": "99",
    "Y": 14,
    "L": 45.4659843444824,
    "a": -23.3847675323486,
    "b": 4.16452646255493,
    "C": 23.7526969909668,
    "h": 169.902221679688,
    "CMY_C": 0.75948792695999,
    "CMY_M": 0.53701281547546,
    "CMY_Y": 0.61109524965286,
    "CMYK_C": 0.48052111268044,
    "CMYK_M": 0,
    "CMYK_Y": 0.1600096821785,
    "CMYK_K": 0.53701281547546
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1174",
    "Farbtonhilfsbezeichnung": "78.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "96",
    "Bcolor": "86",
    "Y": 9,
    "L": 37.3905334472656,
    "a": -19.1813411712646,
    "b": 0.40993049740791,
    "C": 19.1857204437256,
    "h": 178.775695800781,
    "CMY_C": 0.8123664855957,
    "CMY_M": 0.62165492773056,
    "CMY_Y": 0.66250944137573,
    "CMYK_C": 0.50406777858734,
    "CMYK_M": 0,
    "CMYK_Y": 0.10798215121031,
    "CMYK_K": 0.62165492773056
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1175",
    "Farbtonhilfsbezeichnung": "78.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "155",
    "Bcolor": "120",
    "Y": 24,
    "L": 56.5133399963379,
    "a": -45.737003326416,
    "b": 7.31173849105835,
    "C": 46.3177604675293,
    "h": 170.917266845703,
    "CMY_C": 1,
    "CMY_M": 0.39223003387451,
    "CMY_Y": 0.52754080295563,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.22263483703136,
    "CMYK_K": 0.39223003387451
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1176",
    "Farbtonhilfsbezeichnung": "81.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "132",
    "Bcolor": "125",
    "Y": 22,
    "L": 54.5270652770996,
    "a": -3.69431352615356,
    "b": 2.37552833557129,
    "C": 4.39216184616089,
    "h": 147.258056640625,
    "CMY_C": 0.50785911083221,
    "CMY_M": 0.48106056451797,
    "CMY_Y": 0.50894778966904,
    "CMYK_C": 0.05164099112153,
    "CMYK_M": 0,
    "CMYK_Y": 0.05373888090253,
    "CMYK_K": 0.48106056451797
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1177",
    "Farbtonhilfsbezeichnung": "81.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "113",
    "Bcolor": "108",
    "Y": 16,
    "L": 47.0561180114746,
    "a": -3.77605199813843,
    "b": 1.51955354213715,
    "C": 4.0703330039978,
    "h": 158.079223632813,
    "CMY_C": 0.58458548784256,
    "CMY_M": 0.55493915081024,
    "CMY_Y": 0.57639908790588,
    "CMYK_C": 0.06661187112331,
    "CMYK_M": 0,
    "CMYK_Y": 0.04821798577905,
    "CMYK_K": 0.55493915081024
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1178",
    "Farbtonhilfsbezeichnung": "81.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "93",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.7231788635254,
    "a": -4.17328834533691,
    "b": 0.92435711622238,
    "C": 4.27443218231201,
    "h": 167.510971069336,
    "CMY_C": 0.66848039627075,
    "CMY_M": 0.63433861732483,
    "CMY_Y": 0.65173709392548,
    "CMYK_C": 0.09336993098259,
    "CMYK_M": 0,
    "CMYK_Y": 0.04758084192872,
    "CMYK_K": 0.63433861732483
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1179",
    "Farbtonhilfsbezeichnung": "81.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "74",
    "Bcolor": "71",
    "Y": 6,
    "L": 31.0035610198975,
    "a": -2.83710598945618,
    "b": 0.69283801317215,
    "C": 2.9204785823822,
    "h": 166.276626586914,
    "CMY_C": 0.73061889410019,
    "CMY_M": 0.70850044488907,
    "CMY_Y": 0.72085118293762,
    "CMYK_C": 0.07587815821171,
    "CMYK_M": 0,
    "CMYK_Y": 0.04236966371536,
    "CMYK_K": 0.70850044488907
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1180",
    "Farbtonhilfsbezeichnung": "81.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "135",
    "Bcolor": "110",
    "Y": 21,
    "L": 53.6450347900391,
    "a": -14.6088809967041,
    "b": 9.73485851287842,
    "C": 17.5552520751953,
    "h": 146.321868896484,
    "CMY_C": 0.57644408941269,
    "CMY_M": 0.47060358524323,
    "CMY_Y": 0.5683189034462,
    "CMYK_C": 0.1999267488718,
    "CMYK_M": 0,
    "CMYK_Y": 0.18457873165607,
    "CMYK_K": 0.47060358524323
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1181",
    "Farbtonhilfsbezeichnung": "81.09.24",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "108",
    "Bcolor": "87",
    "Y": 13,
    "L": 43.0912933349609,
    "a": -13.0618352890015,
    "b": 8.23994541168213,
    "C": 15.4437122344971,
    "h": 147.754577636719,
    "CMY_C": 0.67051780223846,
    "CMY_M": 0.57796275615692,
    "CMY_Y": 0.65864717960358,
    "CMYK_C": 0.21930539608002,
    "CMYK_M": 0,
    "CMYK_Y": 0.19117844104767,
    "CMYK_K": 0.57796275615692
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1182",
    "Farbtonhilfsbezeichnung": "81.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "95",
    "Bcolor": "79",
    "Y": 9,
    "L": 38.2681427001953,
    "a": -11.1349153518677,
    "b": 5.96184825897217,
    "C": 12.6305179595947,
    "h": 151.834548950195,
    "CMY_C": 0.70785075426102,
    "CMY_M": 0.62726980447769,
    "CMY_Y": 0.68842589855194,
    "CMYK_C": 0.21619109809399,
    "CMYK_M": 0,
    "CMYK_Y": 0.16407604515553,
    "CMYK_K": 0.62726980447769
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1183",
    "Farbtonhilfsbezeichnung": "81.09.30",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "70",
    "Bcolor": "57",
    "Y": 7,
    "L": 26.6337070465088,
    "a": -18.5910453796387,
    "b": 3.51855325698853,
    "C": 18.9210777282715,
    "h": 169.282913208008,
    "CMY_C": 0.89072412252426,
    "CMY_M": 0.72399079799652,
    "CMY_Y": 0.77799475193024,
    "CMYK_C": 0.60408610105515,
    "CMYK_M": 0,
    "CMYK_Y": 0.19565998017788,
    "CMYK_K": 0.72399079799652
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1184",
    "Farbtonhilfsbezeichnung": "81.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "143",
    "Bcolor": "112",
    "Y": 24,
    "L": 56.7906303405762,
    "a": -13.7667922973633,
    "b": 13.1660203933716,
    "C": 19.0491123199463,
    "h": 136.277847290039,
    "CMY_C": 0.52812361717224,
    "CMY_M": 0.44079917669296,
    "CMY_Y": 0.56085085868835,
    "CMYK_C": 0.15615935623646,
    "CMYK_M": 0,
    "CMYK_Y": 0.21468438208103,
    "CMYK_K": 0.44079917669296
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1185",
    "Farbtonhilfsbezeichnung": "81.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "109",
    "Bcolor": "85",
    "Y": 13,
    "L": 44.1703300476074,
    "a": -10.8376054763794,
    "b": 11.0697593688965,
    "C": 15.4917163848877,
    "h": 134.392852783203,
    "CMY_C": 0.63523435592651,
    "CMY_M": 0.57189035415649,
    "CMY_Y": 0.66665160655975,
    "CMYK_C": 0.14796209335327,
    "CMYK_M": 0,
    "CMYK_Y": 0.22134809195995,
    "CMYK_K": 0.57189035415649
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1186",
    "Farbtonhilfsbezeichnung": "81.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "91",
    "Bcolor": "73",
    "Y": 9,
    "L": 36.877571105957,
    "a": -9.76982307434082,
    "b": 8.08869552612305,
    "C": 12.6837072372437,
    "h": 140.377731323242,
    "CMY_C": 0.70409828424454,
    "CMY_M": 0.64320969581604,
    "CMY_Y": 0.71428924798965,
    "CMYK_C": 0.17065651714802,
    "CMYK_M": 0,
    "CMYK_Y": 0.19921940565109,
    "CMYK_K": 0.64320969581604
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1187",
    "Farbtonhilfsbezeichnung": "81.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "81",
    "Bcolor": "70",
    "Y": 7,
    "L": 33.0021781921387,
    "a": -8.22266864776611,
    "b": 4.51409578323364,
    "C": 9.38026332855225,
    "h": 151.234008789063,
    "CMY_C": 0.73870605230331,
    "CMY_M": 0.68141847848892,
    "CMY_Y": 0.72678506374359,
    "CMYK_C": 0.17982076108456,
    "CMYK_M": 0,
    "CMYK_Y": 0.14240181446075,
    "CMYK_K": 0.68141847848892
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1188",
    "Farbtonhilfsbezeichnung": "81.12.33",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "56",
    "Bcolor": "43",
    "Y": 6,
    "L": 22.7277545928955,
    "a": -5.76256418228149,
    "b": 7.13853645324707,
    "C": 9.1741943359375,
    "h": 128.912109375,
    "CMY_C": 0.80518567562103,
    "CMY_M": 0.77845424413681,
    "CMY_Y": 0.83104360103607,
    "CMYK_C": 0.12065874040127,
    "CMYK_M": 0,
    "CMYK_Y": 0.23737469315529,
    "CMYK_K": 0.77845424413681
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1189",
    "Farbtonhilfsbezeichnung": "81.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "151",
    "Bcolor": "102",
    "Y": 23,
    "L": 55.9015884399414,
    "a": -40.2113914489746,
    "b": 16.8001537322998,
    "C": 43.5798263549805,
    "h": 157.32502746582,
    "CMY_C": 0.79763066768646,
    "CMY_M": 0.40791988372803,
    "CMY_Y": 0.59809339046478,
    "CMYK_C": 0.65820616483688,
    "CMYK_M": 0,
    "CMYK_Y": 0.32119557261467,
    "CMYK_K": 0.40791988372803
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1190",
    "Farbtonhilfsbezeichnung": "81.15.24",
    "Farbtonklasse": "04",
    "Rcolor": "13",
    "Gcolor": "134",
    "Bcolor": "87",
    "Y": 19,
    "L": 49.1324234008789,
    "a": -41.8450393676758,
    "b": 16.4792060852051,
    "C": 44.9730110168457,
    "h": 158.504730224609,
    "CMY_C": 0.9472883939743,
    "CMY_M": 0.47618645429611,
    "CMY_Y": 0.66045022010803,
    "CMYK_C": 0.89936953783035,
    "CMYK_M": 0,
    "CMYK_Y": 0.35177358984947,
    "CMYK_K": 0.47618645429611
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1191",
    "Farbtonhilfsbezeichnung": "81.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "128",
    "Bcolor": "86",
    "Y": 18,
    "L": 47.9015121459961,
    "a": -35.7561454772949,
    "b": 15.4897832870483,
    "C": 38.9671058654785,
    "h": 156.577438354492,
    "CMY_C": 0.82932645082474,
    "CMY_M": 0.4966921210289,
    "CMY_Y": 0.66449594497681,
    "CMYK_C": 0.66089630126953,
    "CMYK_M": 0,
    "CMYK_Y": 0.33340194821358,
    "CMYK_K": 0.4966921210289
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1192",
    "Farbtonhilfsbezeichnung": "81.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "108",
    "Bcolor": "80",
    "Y": 12,
    "L": 39.7272567749023,
    "a": -36.8596687316895,
    "b": 7.3609185218811,
    "C": 37.587474822998,
    "h": 168.706527709961,
    "CMY_C": 1,
    "CMY_M": 0.57631826400757,
    "CMY_Y": 0.68680512905121,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.26077798008919,
    "CMYK_K": 0.57631826400757
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1193",
    "Farbtonhilfsbezeichnung": "81.18.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "85",
    "Y": 15,
    "L": 46.5566062927246,
    "a": -41.4096260070801,
    "b": 13.7794952392578,
    "C": 43.6420860290527,
    "h": 161.594589233398,
    "CMY_C": 1,
    "CMY_M": 0.50279819965363,
    "CMY_Y": 0.66625440120697,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.32875221967697,
    "CMYK_K": 0.50279819965363
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1194",
    "Farbtonhilfsbezeichnung": "81.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "68",
    "Y": 13,
    "L": 41.4096527099609,
    "a": -43.1151351928711,
    "b": 16.8621807098389,
    "C": 46.2952270507813,
    "h": 158.639709472656,
    "CMY_C": 1,
    "CMY_M": 0.55356526374817,
    "CMY_Y": 0.73429918289185,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.40483838319778,
    "CMYK_K": 0.55356526374817
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1195",
    "Farbtonhilfsbezeichnung": "81.18.30",
    "Farbtonklasse": "03",
    "Rcolor": "30",
    "Gcolor": "106",
    "Bcolor": "70",
    "Y": 10,
    "L": 39.7725067138672,
    "a": -32.2874717712402,
    "b": 13.4860391616821,
    "C": 34.9907722473145,
    "h": 157.330368041992,
    "CMY_C": 0.88279265165329,
    "CMY_M": 0.58260035514832,
    "CMY_Y": 0.7254878282547,
    "CMYK_C": 0.71919631958008,
    "CMYK_M": 0,
    "CMYK_Y": 0.34232774376869,
    "CMYK_K": 0.58260035514832
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1196",
    "Farbtonhilfsbezeichnung": "81.18.33",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "94",
    "Bcolor": "74",
    "Y": 8,
    "L": 36.149953946484,
    "a": -22.6499459566658,
    "b": 6.24773691565977,
    "C": 23.495835128958,
    "h": -0.26914599243605,
    "CMY_C": 0.8313833,
    "CMY_M": 0.6296827,
    "CMY_Y": 0.710841,
    "CMYK_C": 0.5446696,
    "CMYK_M": 0,
    "CMYK_Y": 0.2191588,
    "CMYK_K": 0.6296827
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1197",
    "Farbtonhilfsbezeichnung": "84.03.24",
    "Farbtonklasse": "01",
    "Rcolor": "128",
    "Gcolor": "128",
    "Bcolor": "119",
    "Y": 23,
    "L": 53.5077629089355,
    "a": -1.5399317741394,
    "b": 4.37529039382935,
    "C": 4.63837862014771,
    "h": 109.390083312988,
    "CMY_C": 0.49659758806229,
    "CMY_M": 0.49624764919281,
    "CMY_Y": 0.53206706047058,
    "CMYK_C": 0.00069466448622,
    "CMYK_M": 0,
    "CMYK_Y": 0.07110519707203,
    "CMYK_K": 0.49624764919281
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1198",
    "Farbtonhilfsbezeichnung": "84.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "155",
    "Bcolor": "131",
    "Y": 31,
    "L": 63.0721588134766,
    "a": -5.98287439346313,
    "b": 11.2394027709961,
    "C": 12.7325944900513,
    "h": 118.026924133301,
    "CMY_C": 0.41174846887589,
    "CMY_M": 0.39102464914322,
    "CMY_Y": 0.48440140485764,
    "CMYK_C": 0.03403063863516,
    "CMYK_M": 0,
    "CMYK_Y": 0.15333421528339,
    "CMYK_K": 0.39102464914322
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1199",
    "Farbtonhilfsbezeichnung": "84.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "131",
    "Bcolor": "117",
    "Y": 24,
    "L": 54.2324409484863,
    "a": -3.59753346443176,
    "b": 6.68273639678955,
    "C": 7.58954620361328,
    "h": 118.295021057129,
    "CMY_C": 0.49728310108185,
    "CMY_M": 0.48524177074432,
    "CMY_Y": 0.54063320159912,
    "CMYK_C": 0.02339220605791,
    "CMYK_M": 0,
    "CMYK_Y": 0.10760669410229,
    "CMYK_K": 0.48524177074432
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1200",
    "Farbtonhilfsbezeichnung": "84.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "106",
    "Bcolor": "91",
    "Y": 13,
    "L": 44.2814788818359,
    "a": -3.87341499328613,
    "b": 7.55673456192017,
    "C": 8.49161815643311,
    "h": 117.138671875,
    "CMY_C": 0.59473323822021,
    "CMY_M": 0.58314025402069,
    "CMY_Y": 0.64189922809601,
    "CMYK_C": 0.02781027555466,
    "CMYK_M": 0,
    "CMYK_Y": 0.14095622301102,
    "CMYK_K": 0.58314025402069
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1201",
    "Farbtonhilfsbezeichnung": "84.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "90",
    "Bcolor": "79",
    "Y": 9,
    "L": 37.6478576660156,
    "a": -3.74517893791199,
    "b": 5.60908842086792,
    "C": 6.74449682235718,
    "h": 123.730964660645,
    "CMY_C": 0.66202509403229,
    "CMY_M": 0.64633214473724,
    "CMY_Y": 0.69096636772156,
    "CMYK_C": 0.04437199607491,
    "CMYK_M": 0,
    "CMYK_Y": 0.12620379030704,
    "CMYK_K": 0.64633214473724
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1202",
    "Farbtonhilfsbezeichnung": "84.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "159",
    "Bcolor": "120",
    "Y": 32,
    "L": 63.7862968444824,
    "a": -10.1451959609985,
    "b": 18.6222362518311,
    "C": 21.2064304351807,
    "h": 118.581069946289,
    "CMY_C": 0.41515916585922,
    "CMY_M": 0.37663018703461,
    "CMY_Y": 0.52933967113495,
    "CMYK_C": 0.06180758029222,
    "CMYK_M": 0,
    "CMYK_Y": 0.24497413635254,
    "CMYK_K": 0.37663018703461
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1203",
    "Farbtonhilfsbezeichnung": "84.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "155",
    "Bcolor": "121",
    "Y": 31,
    "L": 61.7339706420898,
    "a": -11.9196662902832,
    "b": 14.9966239929199,
    "C": 19.1566486358643,
    "h": 128.478500366211,
    "CMY_C": 0.45896065235138,
    "CMY_M": 0.39374947547913,
    "CMY_Y": 0.52463150024414,
    "CMYK_C": 0.10756473243237,
    "CMYK_M": 0,
    "CMYK_Y": 0.21588769555092,
    "CMYK_K": 0.39374947547913
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1204",
    "Farbtonhilfsbezeichnung": "84.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "125",
    "Bcolor": "91",
    "Y": 20,
    "L": 50.3653945922852,
    "a": -12.471489906311,
    "b": 16.0627384185791,
    "C": 20.3359203338623,
    "h": 127.826606750488,
    "CMY_C": 0.5739877820015,
    "CMY_M": 0.50870323181152,
    "CMY_Y": 0.64191114902496,
    "CMYK_C": 0.13288210332394,
    "CMYK_M": 0,
    "CMYK_Y": 0.2711353302002,
    "CMYK_K": 0.50870323181152
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1205",
    "Farbtonhilfsbezeichnung": "84.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "95",
    "Bcolor": "74",
    "Y": 9,
    "L": 38.6503524780273,
    "a": -8.45326995849609,
    "b": 10.0373392105103,
    "C": 13.1227264404297,
    "h": 130.103485107422,
    "CMY_C": 0.67309606075287,
    "CMY_M": 0.62908583879471,
    "CMY_Y": 0.71036463975906,
    "CMYK_C": 0.11865338683128,
    "CMYK_M": 0,
    "CMYK_Y": 0.21913102269173,
    "CMYK_K": 0.62908583879471
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1206",
    "Farbtonhilfsbezeichnung": "84.09.33",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "73",
    "Bcolor": "58",
    "Y": 8,
    "L": 29.8840026855469,
    "a": -7.19901323318481,
    "b": 7.49749994277954,
    "C": 10.3941469192505,
    "h": 133.836471557617,
    "CMY_C": 0.75110352039337,
    "CMY_M": 0.71235942840576,
    "CMY_Y": 0.77239292860031,
    "CMYK_C": 0.13469620049,
    "CMYK_M": 0,
    "CMYK_Y": 0.20871013402939,
    "CMYK_K": 0.71235942840576
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1207",
    "Farbtonhilfsbezeichnung": "84.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "161",
    "Bcolor": "92",
    "Y": 31,
    "L": 62.8016319274902,
    "a": -20.5245227813721,
    "b": 32.5877418518066,
    "C": 38.5125541687012,
    "h": 122.203681945801,
    "CMY_C": 0.46951109170914,
    "CMY_M": 0.36949688196182,
    "CMY_Y": 0.64094948768616,
    "CMYK_C": 0.15862603485584,
    "CMYK_M": 0,
    "CMYK_Y": 0.43053331971169,
    "CMYK_K": 0.36949688196182
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1208",
    "Farbtonhilfsbezeichnung": "84.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "137",
    "Bcolor": "90",
    "Y": 22,
    "L": 54.3579902648926,
    "a": -15.2162504196167,
    "b": 22.133508682251,
    "C": 26.8593826293945,
    "h": 124.50757598877,
    "CMY_C": 0.53956413269043,
    "CMY_M": 0.46454221010208,
    "CMY_Y": 0.6460212469101,
    "CMYK_C": 0.14010800421238,
    "CMYK_M": 0,
    "CMYK_Y": 0.33892315626144,
    "CMYK_K": 0.46454221010208
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1209",
    "Farbtonhilfsbezeichnung": "84.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "113",
    "Bcolor": "65",
    "Y": 16,
    "L": 45.097583770752,
    "a": -14.6113920211792,
    "b": 23.7940826416016,
    "C": 27.922233581543,
    "h": 121.553123474121,
    "CMY_C": 0.62286376953125,
    "CMY_M": 0.55828523635864,
    "CMY_Y": 0.74335908889771,
    "CMYK_C": 0.14619962871075,
    "CMYK_M": 0,
    "CMYK_Y": 0.4189895093441,
    "CMYK_K": 0.55828523635864
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1210",
    "Farbtonhilfsbezeichnung": "84.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "94",
    "Bcolor": "67",
    "Y": 9,
    "L": 37.6694831848145,
    "a": -12.5195627212524,
    "b": 13.0438899993897,
    "C": 18.0798931121826,
    "h": 133.824981689453,
    "CMY_C": 0.70316541194916,
    "CMY_M": 0.63192772865295,
    "CMY_Y": 0.73890566825867,
    "CMYK_C": 0.19354264438152,
    "CMYK_M": 0,
    "CMYK_Y": 0.29064384102821,
    "CMYK_K": 0.63192772865295
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1211",
    "Farbtonhilfsbezeichnung": "84.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "161",
    "Bcolor": "76",
    "Y": 30,
    "L": 61.9053955078125,
    "a": -27.6376457214356,
    "b": 39.279857635498,
    "C": 48.0286026000977,
    "h": 125.130554199219,
    "CMY_C": 0.51972186565399,
    "CMY_M": 0.36739671230316,
    "CMY_Y": 0.70195341110229,
    "CMYK_C": 0.24079096317291,
    "CMYK_M": 0,
    "CMYK_Y": 0.5288570523262,
    "CMYK_K": 0.36739671230316
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1212",
    "Farbtonhilfsbezeichnung": "84.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "134",
    "Bcolor": "71",
    "Y": 20,
    "L": 52.3961029052734,
    "a": -21.1261405944824,
    "b": 30.2087631225586,
    "C": 36.8630332946777,
    "h": 124.96656036377,
    "CMY_C": 0.58497565984726,
    "CMY_M": 0.47530657052994,
    "CMY_Y": 0.72263741493225,
    "CMYK_C": 0.20901556313038,
    "CMYK_M": 0,
    "CMYK_Y": 0.4713816344738,
    "CMYK_K": 0.47530657052994
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1213",
    "Farbtonhilfsbezeichnung": "84.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "112",
    "Bcolor": "60",
    "Y": 14,
    "L": 43.403694152832,
    "a": -22.6084442138672,
    "b": 24.6502323150635,
    "C": 33.4481048583984,
    "h": 132.526107788086,
    "CMY_C": 0.69688653945923,
    "CMY_M": 0.56203985214233,
    "CMY_Y": 0.76610749959946,
    "CMYK_C": 0.30789715051651,
    "CMYK_M": 0,
    "CMYK_Y": 0.46595028042793,
    "CMYK_K": 0.56203985214233
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1214",
    "Farbtonhilfsbezeichnung": "84.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "95",
    "Bcolor": "52",
    "Y": 11,
    "L": 36.5120124816895,
    "a": -22.5468864440918,
    "b": 19.9881286621094,
    "C": 30.1311702728271,
    "h": 138.442565917969,
    "CMY_C": 0.77351415157318,
    "CMY_M": 0.62849569320679,
    "CMY_Y": 0.79577875137329,
    "CMYK_C": 0.39035472273827,
    "CMYK_M": 0,
    "CMYK_Y": 0.45028564333916,
    "CMYK_K": 0.62849569320679
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1215",
    "Farbtonhilfsbezeichnung": "84.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "171",
    "Bcolor": "86",
    "Y": 33,
    "L": 64.0708236694336,
    "a": -36.7198028564453,
    "b": 36.8049430847168,
    "C": 51.9898796081543,
    "h": 134.933654785156,
    "CMY_C": 0.58166640996933,
    "CMY_M": 0.3295019865036,
    "CMY_Y": 0.66381376981735,
    "CMYK_C": 0.37608525156975,
    "CMYK_M": 0,
    "CMYK_Y": 0.49860221147537,
    "CMYK_K": 0.3295019865036
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1216",
    "Farbtonhilfsbezeichnung": "84.18.24",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "130",
    "Bcolor": "72",
    "Y": 20,
    "L": 50.269344329834,
    "a": -23.7598266601563,
    "b": 26.9069671630859,
    "C": 35.895881652832,
    "h": 131.445663452148,
    "CMY_C": 0.63398265838623,
    "CMY_M": 0.49206328392029,
    "CMY_Y": 0.71929758787155,
    "CMYK_C": 0.27940365672112,
    "CMYK_M": 0,
    "CMYK_Y": 0.44736734032631,
    "CMYK_K": 0.49206328392029
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1217",
    "Farbtonhilfsbezeichnung": "84.21.27",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "146",
    "Bcolor": "63",
    "Y": 22,
    "L": 54.2240676879883,
    "a": -40.5720596313477,
    "b": 35.8408737182617,
    "C": 54.1355743408203,
    "h": 138.543014526367,
    "CMY_C": 0.72786009311676,
    "CMY_M": 0.42760723829269,
    "CMY_Y": 0.75184404850006,
    "CMYK_C": 0.52455741167068,
    "CMYK_M": 0,
    "CMYK_Y": 0.56645864248276,
    "CMYK_K": 0.42760723829269
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1218",
    "Farbtonhilfsbezeichnung": "84.21.24",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "153",
    "Bcolor": "66",
    "Y": 27,
    "L": 57.9785652160645,
    "a": -34.0910606384277,
    "b": 39.0620994567871,
    "C": 51.8463897705078,
    "h": 131.112503051758,
    "CMY_C": 0.61495125293732,
    "CMY_M": 0.398177921772,
    "CMY_Y": 0.73975872993469,
    "CMYK_C": 0.36019504070282,
    "CMYK_M": 0,
    "CMYK_Y": 0.56757771968842,
    "CMYK_K": 0.398177921772
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1219",
    "Farbtonhilfsbezeichnung": "87.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "131",
    "Bcolor": "120",
    "Y": 22,
    "L": 54.5073127746582,
    "a": -2.07158064842224,
    "b": 5.66227054595947,
    "C": 6.02932453155518,
    "h": 110.095397949219,
    "CMY_C": 0.48664098978043,
    "CMY_M": 0.4854062795639,
    "CMY_Y": 0.53090190887451,
    "CMYK_C": 0.00239938846789,
    "CMYK_M": 0,
    "CMYK_Y": 0.08841077238321,
    "CMYK_K": 0.4854062795639
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1220",
    "Farbtonhilfsbezeichnung": "87.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "111",
    "Bcolor": "100",
    "Y": 15,
    "L": 46.4195671081543,
    "a": -1.59455406665802,
    "b": 5.3757209777832,
    "C": 5.60722541809082,
    "h": 106.521484375,
    "CMY_C": 0.56432092189789,
    "CMY_M": 0.56643974781036,
    "CMY_Y": 0.60726284980774,
    "CMYK_C": 0,
    "CMYK_M": 0.0048632719554,
    "CMYK_Y": 0.09856320917606,
    "CMYK_K": 0.56432092189789
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1221",
    "Farbtonhilfsbezeichnung": "87.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "95",
    "Bcolor": "86",
    "Y": 11,
    "L": 40.1222686767578,
    "a": -1.43280446529388,
    "b": 4.58490610122681,
    "C": 4.80357074737549,
    "h": 107.354270935059,
    "CMY_C": 0.62604677677155,
    "CMY_M": 0.62720066308975,
    "CMY_Y": 0.66142535209656,
    "CMYK_C": 0,
    "CMYK_M": 0.00308564351872,
    "CMYK_Y": 0.0946069508791,
    "CMYK_K": 0.62604677677155
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1222",
    "Farbtonhilfsbezeichnung": "87.03.30",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "62",
    "Bcolor": "56",
    "Y": 7,
    "L": 26.1201362609863,
    "a": -1.66282284259796,
    "b": 3.60087585449219,
    "C": 3.96626853942871,
    "h": 114.786682128906,
    "CMY_C": 0.75859117507935,
    "CMY_M": 0.75511807203293,
    "CMY_Y": 0.78108131885529,
    "CMYK_C": 0.01418276596814,
    "CMYK_M": 0,
    "CMYK_Y": 0.10602353513241,
    "CMYK_K": 0.75511807203293
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1223",
    "Farbtonhilfsbezeichnung": "27.06.21",
    "Farbtonklasse": "03",
    "Y": 22,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1224",
    "Farbtonhilfsbezeichnung": "87.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "106",
    "Bcolor": "88",
    "Y": 13,
    "L": 44.2857933044434,
    "a": -3.46700239181519,
    "b": 9.37830066680908,
    "C": 9.99863147735596,
    "h": 110.288520812988,
    "CMY_C": 0.58733606338501,
    "CMY_M": 0.58427375555038,
    "CMY_Y": 0.65356969833374,
    "CMYK_C": 0.00736616412178,
    "CMYK_M": 0,
    "CMYK_Y": 0.16668647527695,
    "CMYK_K": 0.58427375555038
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1225",
    "Farbtonhilfsbezeichnung": "87.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "134",
    "Bcolor": "98",
    "Y": 22,
    "L": 54.8621826171875,
    "a": -6.97523212432861,
    "b": 18.8468246459961,
    "C": 20.0961856842041,
    "h": 110.3095703125,
    "CMY_C": 0.48384022712708,
    "CMY_M": 0.47454088926315,
    "CMY_Y": 0.61718535423279,
    "CMYK_C": 0.01769754849374,
    "CMYK_M": 0,
    "CMYK_Y": 0.27146634459496,
    "CMYK_K": 0.47454088926315
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1226",
    "Farbtonhilfsbezeichnung": "87.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "109",
    "Bcolor": "76",
    "Y": 14,
    "L": 44.9497985839844,
    "a": -6.47659349441528,
    "b": 17.390983581543,
    "C": 18.5578174591064,
    "h": 110.425880432129,
    "CMY_C": 0.58253061771393,
    "CMY_M": 0.57348495721817,
    "CMY_Y": 0.70021879673004,
    "CMYK_C": 0.02120830304921,
    "CMYK_M": 0,
    "CMYK_Y": 0.29713803529739,
    "CMYK_K": 0.57348495721817
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1227",
    "Farbtonhilfsbezeichnung": "87.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "94",
    "Bcolor": "72",
    "Y": 10,
    "L": 38.7690887451172,
    "a": -6.70875263214111,
    "b": 11.6777925491333,
    "C": 13.4676723480225,
    "h": 119.876853942871,
    "CMY_C": 0.65608221292496,
    "CMY_M": 0.63140648603439,
    "CMY_Y": 0.71946901082993,
    "CMYK_C": 0.06694563478231,
    "CMYK_M": 0,
    "CMYK_Y": 0.23891501128674,
    "CMYK_K": 0.63140648603439
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1228",
    "Farbtonhilfsbezeichnung": "87.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "130",
    "Bcolor": "79",
    "Y": 20,
    "L": 52.7450294494629,
    "a": -10.4779596328735,
    "b": 26.1742973327637,
    "C": 28.1936416625977,
    "h": 111.816955566406,
    "CMY_C": 0.51390248537064,
    "CMY_M": 0.49024325609207,
    "CMY_Y": 0.68847393989563,
    "CMYK_C": 0.04641278460622,
    "CMYK_M": 0,
    "CMYK_Y": 0.38887310028076,
    "CMYK_K": 0.49024325609207
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1229",
    "Farbtonhilfsbezeichnung": "87.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "110",
    "Bcolor": "69",
    "Y": 14,
    "L": 45.0571403503418,
    "a": -8.68912220001221,
    "b": 22.02001953125,
    "C": 23.6723918914795,
    "h": 111.534240722656,
    "CMY_C": 0.58672475814819,
    "CMY_M": 0.56901454925537,
    "CMY_Y": 0.73053967952728,
    "CMYK_C": 0.04109235852957,
    "CMYK_M": 0,
    "CMYK_Y": 0.37478092312813,
    "CMYK_K": 0.56901454925537
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1230",
    "Farbtonhilfsbezeichnung": "87.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "92",
    "Bcolor": "62",
    "Y": 9,
    "L": 37.3979110717773,
    "a": -9.09709167480469,
    "b": 15.640588760376,
    "C": 18.093786239624,
    "h": 120.183723449707,
    "CMY_C": 0.67588663101196,
    "CMY_M": 0.6407755613327,
    "CMY_Y": 0.75743293762207,
    "CMYK_C": 0.09774131327868,
    "CMYK_M": 0,
    "CMYK_Y": 0.32474789023399,
    "CMYK_K": 0.6407755613327
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1231",
    "Farbtonhilfsbezeichnung": "87.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "143",
    "Bcolor": "52",
    "Y": 24,
    "L": 57.2046089172363,
    "a": -15.551215171814,
    "b": 45.7071495056152,
    "C": 48.2802619934082,
    "h": 108.790153503418,
    "CMY_C": 0.47055304050446,
    "CMY_M": 0.43802666664124,
    "CMY_Y": 0.79678827524185,
    "CMYK_C": 0.05787885561585,
    "CMYK_M": 0,
    "CMYK_Y": 0.63839614391327,
    "CMYK_K": 0.43802666664124
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1232",
    "Farbtonhilfsbezeichnung": "90.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "119",
    "Bcolor": "105",
    "Y": 20,
    "L": 49.8220443725586,
    "a": -1.37996327877045,
    "b": 7.48653650283813,
    "C": 7.61265563964844,
    "h": 100.443870544434,
    "CMY_C": 0.52377849817276,
    "CMY_M": 0.53395962715149,
    "CMY_Y": 0.58846938610077,
    "CMYK_C": 0,
    "CMYK_M": 0.02137897722423,
    "CMYK_Y": 0.13584201037884,
    "CMYK_K": 0.52377849817276
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1233",
    "Farbtonhilfsbezeichnung": "90.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "85",
    "Y": 13,
    "L": 39.5147018432617,
    "a": -2.52619075775146,
    "b": 4.19948863983154,
    "C": 4.90074920654297,
    "h": 121.02889251709,
    "CMY_C": 0.64011776447296,
    "CMY_M": 0.63073319196701,
    "CMY_Y": 0.66476881504059,
    "CMYK_C": 0.02541407011449,
    "CMYK_M": 0,
    "CMYK_Y": 0.09217081964016,
    "CMYK_K": 0.63073319196701
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1234",
    "Farbtonhilfsbezeichnung": "90.03.27",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "93",
    "Bcolor": "88",
    "Y": 12,
    "L": 39.0233192443848,
    "a": -2.28616046905518,
    "b": 2.00727367401123,
    "C": 3.04231452941895,
    "h": 138.716506958008,
    "CMY_C": 0.64928686618805,
    "CMY_M": 0.63536041975021,
    "CMY_Y": 0.65551507472992,
    "CMYK_C": 0.03819236159325,
    "CMYK_M": 0,
    "CMYK_Y": 0.0552728138864,
    "CMYK_K": 0.63536041975021
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1235",
    "Farbtonhilfsbezeichnung": "90.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "80",
    "Bcolor": "76",
    "Y": 9,
    "L": 34.2134742736816,
    "a": -0.18994432687759,
    "b": 2.26875329017639,
    "C": 2.27669072151184,
    "h": 94.7857513427734,
    "CMY_C": 0.67950755357742,
    "CMY_M": 0.68445992469788,
    "CMY_Y": 0.70113384723663,
    "CMYK_C": 0,
    "CMYK_M": 0.01545238029212,
    "CMYK_Y": 0.06747832894325,
    "CMYK_K": 0.67950755357742
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1236",
    "Farbtonhilfsbezeichnung": "90.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "130",
    "Bcolor": "109",
    "Y": 22,
    "L": 54.1104469299316,
    "a": -1.91667580604553,
    "b": 11.5940380096435,
    "C": 11.7513980865479,
    "h": 99.3869934082031,
    "CMY_C": 0.4740549325943,
    "CMY_M": 0.49103486537933,
    "CMY_Y": 0.57449269294739,
    "CMYK_C": 0,
    "CMYK_M": 0.03228461369872,
    "CMYK_Y": 0.19096624851227,
    "CMYK_K": 0.4740549325943
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1237",
    "Farbtonhilfsbezeichnung": "90.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "106",
    "Bcolor": "88",
    "Y": 14,
    "L": 44.6441116333008,
    "a": -2.06694936752319,
    "b": 10.2431545257568,
    "C": 10.4496173858643,
    "h": 101.408424377441,
    "CMY_C": 0.5725491642952,
    "CMY_M": 0.58377122879028,
    "CMY_Y": 0.65562200546265,
    "CMYK_C": 0,
    "CMYK_M": 0.02625346183777,
    "CMYK_Y": 0.19434478878975,
    "CMYK_K": 0.5725491642952
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1238",
    "Farbtonhilfsbezeichnung": "90.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "90",
    "Bcolor": "76",
    "Y": 9,
    "L": 37.7749977111816,
    "a": -2.41098856925964,
    "b": 7.8262882232666,
    "C": 8.18924045562744,
    "h": 107.122116088867,
    "CMY_C": 0.64648771286011,
    "CMY_M": 0.64814412593842,
    "CMY_Y": 0.70352971553802,
    "CMYK_C": 0,
    "CMYK_M": 0.00468558864668,
    "CMYK_Y": 0.16135790944099,
    "CMYK_K": 0.64648771286011
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1239",
    "Farbtonhilfsbezeichnung": "90.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "67",
    "Bcolor": "59",
    "Y": 7,
    "L": 28.2124328613281,
    "a": -1.31986784934998,
    "b": 4.29766511917114,
    "C": 4.49577331542969,
    "h": 107.072387695313,
    "CMY_C": 0.73613631725311,
    "CMY_M": 0.73727869987488,
    "CMY_Y": 0.76700127124786,
    "CMYK_C": 0,
    "CMYK_M": 0.00432944251224,
    "CMYK_Y": 0.11697310209274,
    "CMYK_K": 0.73613631725311
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1240",
    "Farbtonhilfsbezeichnung": "90.06.33",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "55",
    "Bcolor": "45",
    "Y": 6,
    "L": 22.9498157501221,
    "a": -0.5759225487709,
    "b": 6.08378601074219,
    "C": 6.11098527908325,
    "h": 95.4077987670898,
    "CMY_C": 0.77427494525909,
    "CMY_M": 0.78533232212067,
    "CMY_Y": 0.82240200042725,
    "CMYK_C": 0,
    "CMYK_M": 0.04898604005575,
    "CMYK_Y": 0.21321095526218,
    "CMYK_K": 0.77427494525909
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1241",
    "Farbtonhilfsbezeichnung": "90.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "130",
    "Bcolor": "92",
    "Y": 22,
    "L": 54.2222671508789,
    "a": -2.7137885093689,
    "b": 21.0896320343018,
    "C": 21.2635192871094,
    "h": 97.3324584960938,
    "CMY_C": 0.45743548870087,
    "CMY_M": 0.49007600545883,
    "CMY_Y": 0.63787794113159,
    "CMYK_C": 0,
    "CMYK_M": 0.0601596981287,
    "CMYK_Y": 0.33257326483727,
    "CMYK_K": 0.45743548870087
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1242",
    "Farbtonhilfsbezeichnung": "90.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "107",
    "Bcolor": "75",
    "Y": 14,
    "L": 44.8139839172363,
    "a": -3.27600860595703,
    "b": 18.3184947967529,
    "C": 18.6091232299805,
    "h": 100.139373779297,
    "CMY_C": 0.56147122383118,
    "CMY_M": 0.58119827508926,
    "CMY_Y": 0.707046687603,
    "CMYK_C": 0,
    "CMYK_M": 0.04498462378979,
    "CMYK_Y": 0.33196330070496,
    "CMYK_K": 0.56147122383118
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1243",
    "Farbtonhilfsbezeichnung": "90.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "85",
    "Bcolor": "63",
    "Y": 10,
    "L": 35.1859436035156,
    "a": -5.30092620849609,
    "b": 12.1231241226196,
    "C": 13.2314004898071,
    "h": 113.617713928223,
    "CMY_C": 0.67946124076843,
    "CMY_M": 0.66772782802582,
    "CMY_Y": 0.75411701202393,
    "CMYK_C": 0.03531265631318,
    "CMYK_M": 0,
    "CMYK_Y": 0.259995251894,
    "CMYK_K": 0.66772782802582
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1244",
    "Farbtonhilfsbezeichnung": "90.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "129",
    "Bcolor": "61",
    "Y": 21,
    "L": 53.5124473571777,
    "a": -6.23587322235107,
    "b": 37.4496879577637,
    "C": 37.9653167724609,
    "h": 99.4537734985352,
    "CMY_C": 0.46042037010193,
    "CMY_M": 0.49236863851547,
    "CMY_Y": 0.76230192184448,
    "CMYK_C": 0,
    "CMYK_M": 0.05920955166221,
    "CMYK_Y": 0.55947542190552,
    "CMYK_K": 0.46042037010193
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1245",
    "Farbtonhilfsbezeichnung": "90.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "111",
    "Bcolor": "66",
    "Y": 15,
    "L": 46.1270980834961,
    "a": -5.46655035018921,
    "b": 24.9833984375,
    "C": 25.5744667053223,
    "h": 102.342224121094,
    "CMY_C": 0.55019915103912,
    "CMY_M": 0.56516921520233,
    "CMY_Y": 0.74032467603683,
    "CMYK_C": 0,
    "CMYK_M": 0.03328153863549,
    "CMYK_Y": 0.42268821597099,
    "CMYK_K": 0.55019915103912
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1246",
    "Farbtonhilfsbezeichnung": "93.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "139",
    "Bcolor": "116",
    "Y": 27,
    "L": 58.1973648071289,
    "a": -0.23248529434204,
    "b": 13.3715314865112,
    "C": 13.3735523223877,
    "h": 90.9960784912109,
    "CMY_C": 0.41663444042206,
    "CMY_M": 0.45374578237534,
    "CMY_Y": 0.54645496606827,
    "CMYK_C": 0,
    "CMYK_M": 0.06361592561007,
    "CMYK_Y": 0.2225371748209,
    "CMYK_K": 0.41663444042206
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1247",
    "Farbtonhilfsbezeichnung": "93.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "124",
    "Bcolor": "104",
    "Y": 22,
    "L": 52.0959625244141,
    "a": 0.08938348293304,
    "b": 11.4400129318237,
    "C": 11.4403619766235,
    "h": 89.5523452758789,
    "CMY_C": 0.48149818181992,
    "CMY_M": 0.51537150144577,
    "CMY_Y": 0.59258699417114,
    "CMYK_C": 0,
    "CMYK_M": 0.06532922387123,
    "CMYK_Y": 0.21424961090088,
    "CMYK_K": 0.48149818181992
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1248",
    "Farbtonhilfsbezeichnung": "93.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "101",
    "Bcolor": "85",
    "Y": 12,
    "L": 43.1127853393555,
    "a": 0.17787565290928,
    "b": 10.0037536621094,
    "C": 10.005334854126,
    "h": 88.981330871582,
    "CMY_C": 0.57365620136261,
    "CMY_M": 0.60305869579315,
    "CMY_Y": 0.66799104213715,
    "CMYK_C": 0,
    "CMYK_M": 0.06896428018808,
    "CMYK_Y": 0.22126471996307,
    "CMYK_K": 0.57365620136261
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1249",
    "Farbtonhilfsbezeichnung": "93.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "89",
    "Bcolor": "76",
    "Y": 9,
    "L": 38.0184364318848,
    "a": 0.02701388113201,
    "b": 7.87107467651367,
    "C": 7.87112092971802,
    "h": 89.8033599853516,
    "CMY_C": 0.62861609458923,
    "CMY_M": 0.65067863464355,
    "CMY_Y": 0.70126020908356,
    "CMYK_C": 0,
    "CMYK_M": 0.05940629169345,
    "CMYK_Y": 0.1956038326025,
    "CMYK_K": 0.62861609458923
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1250",
    "Farbtonhilfsbezeichnung": "93.03.33",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "78",
    "Bcolor": "72",
    "Y": 7,
    "L": 33.4225463867188,
    "a": 1.24455332756042,
    "b": 3.88948655128479,
    "C": 4.08375072479248,
    "h": 72.2564315795898,
    "CMY_C": 0.67367255687714,
    "CMY_M": 0.69494086503983,
    "CMY_Y": 0.71803152561188,
    "CMYK_C": 0,
    "CMYK_M": 0.06517474353313,
    "CMYK_Y": 0.13593392074108,
    "CMYK_K": 0.67367255687714
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1251",
    "Farbtonhilfsbezeichnung": "93.06.21",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "181",
    "Bcolor": "151",
    "Y": 45,
    "L": 73.9455947875977,
    "a": -0.51768201589584,
    "b": 16.1249809265137,
    "C": 16.1332893371582,
    "h": 91.8388137817383,
    "CMY_C": 0.24486058950424,
    "CMY_M": 0.28964459896088,
    "CMY_Y": 0.40756160020828,
    "CMYK_C": 0,
    "CMYK_M": 0.05930561944842,
    "CMYK_Y": 0.21545824408531,
    "CMYK_K": 0.24486058950424
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1252",
    "Farbtonhilfsbezeichnung": "93.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "152",
    "Bcolor": "128",
    "Y": 30,
    "L": 62.9522094726563,
    "a": -0.96681821346283,
    "b": 13.2094526290894,
    "C": 13.2447872161865,
    "h": 94.1860961914062,
    "CMY_C": 0.37246787548065,
    "CMY_M": 0.40339952707291,
    "CMY_Y": 0.49846112728119,
    "CMYK_C": 0,
    "CMYK_M": 0.04929094389081,
    "CMYK_Y": 0.20077578723431,
    "CMYK_K": 0.37246787548065
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1253",
    "Farbtonhilfsbezeichnung": "93.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "118",
    "Bcolor": "91",
    "Y": 20,
    "L": 49.5425682067871,
    "a": -2.15945911407471,
    "b": 15.50048828125,
    "C": 15.6501884460449,
    "h": 97.9311447143555,
    "CMY_C": 0.5128630399704,
    "CMY_M": 0.53674840927124,
    "CMY_Y": 0.64426016807556,
    "CMYK_C": 0,
    "CMYK_M": 0.04903214424849,
    "CMYK_Y": 0.26973342895508,
    "CMYK_K": 0.5128630399704
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1254",
    "Farbtonhilfsbezeichnung": "93.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "109",
    "Bcolor": "92",
    "Y": 15,
    "L": 46.0972175598145,
    "a": -1.34509146213531,
    "b": 9.6880407333374,
    "C": 9.78097152709961,
    "h": 97.9044342041016,
    "CMY_C": 0.55490219593048,
    "CMY_M": 0.57102173566818,
    "CMY_Y": 0.63829785585403,
    "CMYK_C": 0,
    "CMYK_M": 0.03621572628617,
    "CMYK_Y": 0.18736480176449,
    "CMYK_K": 0.55490219593048
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1255",
    "Farbtonhilfsbezeichnung": "93.06.33",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "94",
    "Bcolor": "80",
    "Y": 10,
    "L": 39.7201766967773,
    "a": -1.59008073806763,
    "b": 8.09051704406738,
    "C": 8.24529075622559,
    "h": 101.118980407715,
    "CMY_C": 0.62211453914642,
    "CMY_M": 0.63144707679749,
    "CMY_Y": 0.68732154369354,
    "CMYK_C": 0,
    "CMYK_M": 0.0246967356652,
    "CMYK_Y": 0.17255759239197,
    "CMYK_K": 0.62211453914642
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1256",
    "Farbtonhilfsbezeichnung": "93.09.21",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "176",
    "Bcolor": "127",
    "Y": 43,
    "L": 71.8540420532227,
    "a": -1.85596561431885,
    "b": 26.4061717987061,
    "C": 26.4713153839111,
    "h": 94.0204391479492,
    "CMY_C": 0.25382196903229,
    "CMY_M": 0.31095445156097,
    "CMY_Y": 0.50293934345245,
    "CMYK_C": 0,
    "CMYK_M": 0.07656682282686,
    "CMYK_Y": 0.33385783433914,
    "CMYK_K": 0.25382196903229
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1257",
    "Farbtonhilfsbezeichnung": "93.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "154",
    "Bcolor": "108",
    "Y": 32,
    "L": 63.7989463806152,
    "a": -2.20991349220276,
    "b": 25.5210857391357,
    "C": 25.6165866851807,
    "h": 94.9489898681641,
    "CMY_C": 0.34502339363098,
    "CMY_M": 0.39435940980911,
    "CMY_Y": 0.57645243406296,
    "CMYK_C": 0,
    "CMYK_M": 0.07532485574484,
    "CMYK_Y": 0.35333940386772,
    "CMYK_K": 0.34502339363098
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1258",
    "Farbtonhilfsbezeichnung": "93.09.27",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "132",
    "Bcolor": "89",
    "Y": 22,
    "L": 55.3408393859863,
    "a": -0.94806391000748,
    "b": 24.8383312225342,
    "C": 24.8564186096191,
    "h": 92.1858825683594,
    "CMY_C": 0.4276020526886,
    "CMY_M": 0.48323160409927,
    "CMY_Y": 0.65279877185822,
    "CMYK_C": 0,
    "CMYK_M": 0.09718684852123,
    "CMYK_Y": 0.39342683553696,
    "CMYK_K": 0.4276020526886
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1259",
    "Farbtonhilfsbezeichnung": "93.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "105",
    "Bcolor": "72",
    "Y": 13,
    "L": 44.590404510498,
    "a": -0.97069519758224,
    "b": 19.3909645080566,
    "C": 19.4152450561523,
    "h": 92.8657836914062,
    "CMY_C": 0.54742550849915,
    "CMY_M": 0.5882026553154,
    "CMY_Y": 0.71577388048172,
    "CMYK_C": 0,
    "CMYK_M": 0.0901004076004,
    "CMYK_Y": 0.37197935581207,
    "CMYK_K": 0.54742550849915
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1260",
    "Farbtonhilfsbezeichnung": "93.09.33",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "90",
    "Bcolor": "68",
    "Y": 9,
    "L": 38.2464485168457,
    "a": -0.75442904233932,
    "b": 13.2856121063232,
    "C": 13.3070154190063,
    "h": 93.2500762939453,
    "CMY_C": 0.61978536844254,
    "CMY_M": 0.6480085849762,
    "CMY_Y": 0.73348969221115,
    "CMYK_C": 0,
    "CMYK_M": 0.0742296949029,
    "CMYK_Y": 0.29905298352242,
    "CMYK_K": 0.61978536844254
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1261",
    "Farbtonhilfsbezeichnung": "93.12.21",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "175",
    "Bcolor": "110",
    "Y": 43,
    "L": 71.5564346313477,
    "a": -2.61487412452698,
    "b": 34.9084243774414,
    "C": 35.0062217712402,
    "h": 94.2838363647461,
    "CMY_C": 0.24624514579773,
    "CMY_M": 0.31389063596725,
    "CMY_Y": 0.56839549541473,
    "CMYK_C": 0,
    "CMYK_M": 0.0897446796298,
    "CMYK_Y": 0.42739406228065,
    "CMYK_K": 0.24624514579773
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1262",
    "Farbtonhilfsbezeichnung": "93.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "144",
    "Bcolor": "81",
    "Y": 28,
    "L": 60.105167388916,
    "a": -2.24297904968262,
    "b": 35.1968116760254,
    "C": 35.2682075500488,
    "h": 93.6463470458984,
    "CMY_C": 0.36840522289276,
    "CMY_M": 0.43378937244415,
    "CMY_Y": 0.68192768096924,
    "CMYK_C": 0,
    "CMYK_M": 0.1035223081708,
    "CMYK_Y": 0.49639812111855,
    "CMYK_K": 0.36840522289276
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1263",
    "Farbtonhilfsbezeichnung": "93.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "126",
    "Bcolor": "69",
    "Y": 20,
    "L": 53.0793876647949,
    "a": -1.39878678321838,
    "b": 32.7123680114746,
    "C": 32.742259979248,
    "h": 92.448486328125,
    "CMY_C": 0.44171720743179,
    "CMY_M": 0.50608086585999,
    "CMY_Y": 0.72983968257904,
    "CMYK_C": 0,
    "CMYK_M": 0.11528863012791,
    "CMYK_Y": 0.51608699560165,
    "CMYK_K": 0.44171720743179
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1264",
    "Farbtonhilfsbezeichnung": "93.15.21",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "177",
    "Bcolor": "62",
    "Y": 43,
    "L": 72.2806625366211,
    "a": -4.48055648803711,
    "b": 58.9672813415527,
    "C": 59.1372604370117,
    "h": 94.3451995849609,
    "CMY_C": 0.21711879968643,
    "CMY_M": 0.30524641275406,
    "CMY_Y": 0.75867557525635,
    "CMYK_C": 0,
    "CMYK_M": 0.11256831139326,
    "CMYK_Y": 0.69174832105637,
    "CMYK_K": 0.21711879968643
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1265",
    "Farbtonhilfsbezeichnung": "93.15.24",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "149",
    "Bcolor": "51",
    "Y": 29,
    "L": 61.9128456115723,
    "a": -2.31238675117493,
    "b": 51.7553939819336,
    "C": 51.8070259094238,
    "h": 92.558219909668,
    "CMY_C": 0.32852590084076,
    "CMY_M": 0.41716623306274,
    "CMY_Y": 0.79812288284302,
    "CMYK_C": 0,
    "CMYK_M": 0.13200856745243,
    "CMYK_Y": 0.69935232400894,
    "CMYK_K": 0.32852590084076
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1266",
    "Farbtonhilfsbezeichnung": "96.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "126",
    "Bcolor": "87",
    "Y": 21,
    "L": 53.3036575317383,
    "a": -0.14791786670685,
    "b": 23.1135082244873,
    "C": 23.1139812469482,
    "h": 90.3666687011719,
    "CMY_C": 0.44686716794968,
    "CMY_M": 0.50505232810974,
    "CMY_Y": 0.65995836257935,
    "CMYK_C": 0,
    "CMYK_M": 0.10519202053547,
    "CMYK_Y": 0.38524416089058,
    "CMYK_K": 0.44686716794968
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1267",
    "Farbtonhilfsbezeichnung": "96.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "107",
    "Bcolor": "73",
    "Y": 14,
    "L": 45.6193542480469,
    "a": -0.15442654490471,
    "b": 20.7268962860107,
    "C": 20.7274723052979,
    "h": 90.426872253418,
    "CMY_C": 0.52978777885437,
    "CMY_M": 0.58016800880432,
    "CMY_Y": 0.7151095867157,
    "CMYK_C": 0,
    "CMYK_M": 0.10714360326529,
    "CMYK_Y": 0.39412376284599,
    "CMYK_K": 0.52978777885437
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1268",
    "Farbtonhilfsbezeichnung": "96.12.21",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "123",
    "Bcolor": "69",
    "Y": 20,
    "L": 52.2998886108398,
    "a": 0.48861894011497,
    "b": 31.588228225708,
    "C": 31.5920066833496,
    "h": 89.1138000488281,
    "CMY_C": 0.44011813402176,
    "CMY_M": 0.51771867275238,
    "CMY_Y": 0.72851222753525,
    "CMYK_C": 0,
    "CMYK_M": 0.13860163092613,
    "CMYK_Y": 0.51509809494019,
    "CMYK_K": 0.44011813402176
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1269",
    "Farbtonhilfsbezeichnung": "99.00.39",
    "Farbtonklasse": "01",
    "Rcolor": "128",
    "Gcolor": "131",
    "Bcolor": "130",
    "Y": 22,
    "L": 54.3523254394531,
    "a": -0.73745262622833,
    "b": -0.74666821956635,
    "C": 1.0494521856308,
    "h": 225.355773925781,
    "CMY_C": 0.49796915054321,
    "CMY_M": 0.4881876707077,
    "CMY_Y": 0.4894807934761,
    "CMYK_C": 0.01911145821214,
    "CMYK_M": 0,
    "CMYK_Y": 0.00252655660734,
    "CMYK_K": 0.4881876707077
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1270",
    "Farbtonhilfsbezeichnung": "99.00.42",
    "Farbtonklasse": "01",
    "Rcolor": "123",
    "Gcolor": "125",
    "Bcolor": "125",
    "Y": 19,
    "L": 52.1724090576172,
    "a": -0.64898198843002,
    "b": -0.6538844704628,
    "C": 0.92127221822739,
    "h": 225.215591430664,
    "CMY_C": 0.5187663435936,
    "CMY_M": 0.51021158695221,
    "CMY_Y": 0.51175177097321,
    "CMYK_C": 0.01746622845531,
    "CMYK_M": 0,
    "CMYK_Y": 0.00314459064975,
    "CMYK_K": 0.51021158695221
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1271",
    "Farbtonhilfsbezeichnung": "99.00.45",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "114",
    "Bcolor": "114",
    "Y": 16,
    "L": 47.9138717651367,
    "a": -0.26659953594208,
    "b": -0.590680539608,
    "C": 0.64805769920349,
    "h": 245.708297729492,
    "CMY_C": 0.55782389640808,
    "CMY_M": 0.55312752723694,
    "CMY_Y": 0.55393874645233,
    "CMYK_C": 0.01050941739231,
    "CMYK_M": 0,
    "CMYK_Y": 0.0018153260462,
    "CMYK_K": 0.55312752723694
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1272",
    "Farbtonhilfsbezeichnung": "99.00.48",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "105",
    "Bcolor": "106",
    "Y": 13,
    "L": 44.202392578125,
    "a": 0.06713812798262,
    "b": -1.25262272357941,
    "C": 1.25442063808441,
    "h": 273.068023681641,
    "CMY_C": 0.59357970952988,
    "CMY_M": 0.5897650718689,
    "CMY_Y": 0.58554071187973,
    "CMYK_C": 0.01939634978771,
    "CMYK_M": 0.01019246038049,
    "CMYK_Y": 0,
    "CMYK_K": 0.58554071187973
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1273",
    "Farbtonhilfsbezeichnung": "99.00.51",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "97",
    "Bcolor": "99",
    "Y": 11,
    "L": 41.1075325012207,
    "a": -0.00817039236426,
    "b": -1.73140478134155,
    "C": 1.73142409324646,
    "h": 269.729614257813,
    "CMY_C": 0.62520730495453,
    "CMY_M": 0.61918330192566,
    "CMY_Y": 0.61208355426788,
    "CMYK_C": 0.03383138403296,
    "CMYK_M": 0.01830225996673,
    "CMYK_Y": 0,
    "CMYK_K": 0.61208355426788
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1274",
    "Farbtonhilfsbezeichnung": "99.00.54",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "89",
    "Bcolor": "91",
    "Y": 9,
    "L": 38.0047760009766,
    "a": 0.35807156562805,
    "b": -1.24117040634155,
    "C": 1.2917891740799,
    "h": 286.092590332031,
    "CMY_C": 0.65051400661469,
    "CMY_M": 0.64940929412842,
    "CMY_Y": 0.644386947155,
    "CMYK_C": 0.01722956821322,
    "CMYK_M": 0.01412306725979,
    "CMYK_Y": 0,
    "CMYK_K": 0.644386947155
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1275",
    "Farbtonhilfsbezeichnung": "99.00.57",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "83",
    "Bcolor": "84",
    "Y": 8,
    "L": 35.2682075500488,
    "a": 0.42318797111511,
    "b": -1.3645738363266,
    "C": 1.4286881685257,
    "h": 287.229949951172,
    "CMY_C": 0.6759694814682,
    "CMY_M": 0.67505407333374,
    "CMY_Y": 0.66907227039337,
    "CMYK_C": 0.02084204554558,
    "CMYK_M": 0.01807585917413,
    "CMYK_Y": 0,
    "CMYK_K": 0.66907227039337
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1276",
    "Farbtonhilfsbezeichnung": "99.00.60",
    "Farbtonklasse": "02",
    "Rcolor": "77",
    "Gcolor": "77",
    "Bcolor": "79",
    "Y": 7,
    "L": 32.7376365661621,
    "a": 0.7832219004631,
    "b": -1.74042952060699,
    "C": 1.90854167938232,
    "h": 294.228515625,
    "CMY_C": 0.69801247119904,
    "CMY_M": 0.69898998737335,
    "CMY_Y": 0.68999886512756,
    "CMYK_C": 0.02585024759173,
    "CMYK_M": 0.02900351397693,
    "CMYK_Y": 0,
    "CMYK_K": 0.68999886512756
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1277",
    "Farbtonhilfsbezeichnung": "99.00.63",
    "Farbtonklasse": "02",
    "Rcolor": "50",
    "Gcolor": "51",
    "Bcolor": "53",
    "Y": 5,
    "L": 21.364387512207,
    "a": 0.2244116961956,
    "b": -1.77463710308075,
    "C": 1.78876984119415,
    "h": 277.207092285156,
    "CMY_C": 0.80247664451599,
    "CMY_M": 0.79881680011749,
    "CMY_Y": 0.79069328308105,
    "CMYK_C": 0.05629710108042,
    "CMYK_M": 0.03881154581904,
    "CMYK_Y": 0,
    "CMYK_K": 0.79069328308105
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1278",
    "Farbtonhilfsbezeichnung": "99.00.66",
    "Farbtonklasse": "02",
    "Rcolor": "46",
    "Gcolor": "43",
    "Bcolor": "43",
    "Y": 4,
    "L": 17.9026184082031,
    "a": 1.09319579601288,
    "b": 0.13853415846825,
    "C": 1.10193860530853,
    "h": 7.22225475311279,
    "CMY_C": 0.82148993015289,
    "CMY_M": 0.83013010025024,
    "CMY_Y": 0.83055663108826,
    "CMYK_C": 0,
    "CMYK_M": 0.04840158298612,
    "CMYK_Y": 0.05079097673297,
    "CMYK_K": 0.82148993015289
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1279",
    "Farbtonhilfsbezeichnung": "99.00.69",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "33",
    "Bcolor": "34",
    "Y": 4,
    "L": 12.4969816207886,
    "a": 0.20537930727005,
    "b": -1.20154058933258,
    "C": 1.21896696090698,
    "h": 279.699829101563,
    "CMY_C": 0.87441521883011,
    "CMY_M": 0.87250149250031,
    "CMY_Y": 0.86742454767227,
    "CMYK_C": 0.05272975564003,
    "CMYK_M": 0.03829475864768,
    "CMYK_Y": 0,
    "CMYK_K": 0.86742454767227
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1281",
    "Farbtonhilfsbezeichnung": "87.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "132",
    "Bcolor": "114",
    "Y": 22,
    "L": 54.747486114502,
    "a": -3.04036355018616,
    "b": 9.09386730194092,
    "C": 9.58865165710449,
    "h": 108.486389160156,
    "CMY_C": 0.481625020504,
    "CMY_M": 0.48174887895584,
    "CMY_Y": 0.55167770385742,
    "CMYK_C": 0,
    "CMYK_M": 0.0002389360161,
    "CMYK_Y": 0.1351390182972,
    "CMYK_K": 0.481625020504
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1283",
    "Farbtonhilfsbezeichnung": "27.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "126",
    "Bcolor": "114",
    "Y": 30,
    "L": 61.9851417541504,
    "a": 33.1684646606445,
    "b": 20.8605880737305,
    "C": 39.183048248291,
    "h": 32.1669502258301,
    "CMY_C": 0.16048938035965,
    "CMY_M": 0.50663483142853,
    "CMY_Y": 0.55437350273132,
    "CMYK_C": 0,
    "CMYK_M": 0.41231814026833,
    "CMYK_Y": 0.46918302774429,
    "CMYK_K": 0.16048938035965
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1284",
    "Farbtonhilfsbezeichnung": "27.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "224",
    "Bcolor": "216",
    "Y": 77,
    "L": 90.4338531494141,
    "a": 5.9624171257019,
    "b": 5.50309705734253,
    "C": 8.11384582519531,
    "h": 42.7059020996094,
    "CMY_C": 0.04417538642883,
    "CMY_M": 0.12296545505524,
    "CMY_Y": 0.15416473150253,
    "CMYK_C": 0,
    "CMYK_M": 0.08243151009083,
    "CMYK_Y": 0.11507272720337,
    "CMYK_K": 0.04417538642883
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1285",
    "Farbtonhilfsbezeichnung": "27.09.18",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "161",
    "Bcolor": "150",
    "Y": 40,
    "L": 69.5414886474609,
    "a": 13.9266424179077,
    "b": 10.4155931472778,
    "C": 17.3906860351563,
    "h": 36.7924385070801,
    "CMY_C": 0.20918619632721,
    "CMY_M": 0.36988461017609,
    "CMY_Y": 0.41002160310745,
    "CMYK_C": 0,
    "CMYK_M": 0.20320639014244,
    "CMYK_Y": 0.2539604306221,
    "CMYK_K": 0.20918619632721
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1286",
    "Farbtonhilfsbezeichnung": "30.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "232",
    "Bcolor": "225",
    "Y": 84,
    "L": 93.1198883056641,
    "a": 5.6386342048645,
    "b": 4.47075939178467,
    "C": 7.19596290588379,
    "h": 38.4101905822754,
    "CMY_C": 0.0192848443985,
    "CMY_M": 0.09195810556412,
    "CMY_Y": 0.11702001094818,
    "CMYK_C": 0,
    "CMYK_M": 0.07410231232643,
    "CMYK_Y": 0.09965703636408,
    "CMYK_K": 0.0192848443985
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1287",
    "Farbtonhilfsbezeichnung": "36.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "99",
    "Bcolor": "111",
    "Y": 14,
    "L": 45.0494766235352,
    "a": 13.5490827560425,
    "b": -3.25439119338989,
    "C": 13.9344434738159,
    "h": 346.493835449219,
    "CMY_C": 0.50313568115234,
    "CMY_M": 0.61161422729492,
    "CMY_Y": 0.56291043758392,
    "CMYK_C": 0,
    "CMYK_M": 0.21832630038261,
    "CMYK_Y": 0.12030398100615,
    "CMYK_K": 0.50313568115234
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1288",
    "Farbtonhilfsbezeichnung": "36.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "120",
    "Bcolor": "132",
    "Y": 21,
    "L": 53.5478363037109,
    "a": 13.8136167526245,
    "b": -2.86310005187988,
    "C": 14.1072092056274,
    "h": 348.290313720703,
    "CMY_C": 0.41358023881912,
    "CMY_M": 0.5292746424675,
    "CMY_Y": 0.4816380739212,
    "CMYK_C": 0,
    "CMYK_M": 0.19728940725327,
    "CMYK_Y": 0.11605651676655,
    "CMYK_K": 0.41358023881912
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1289",
    "Farbtonhilfsbezeichnung": "36.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "83",
    "Bcolor": "93",
    "Y": 9,
    "L": 37.8382339477539,
    "a": 11.8604040145874,
    "b": -2.63809251785278,
    "C": 12.1502561569214,
    "h": 347.459930419922,
    "CMY_C": 0.58332741260529,
    "CMY_M": 0.67593568563461,
    "CMY_Y": 0.63591146469116,
    "CMYK_C": 0,
    "CMYK_M": 0.22225669026375,
    "CMYK_Y": 0.1261999309063,
    "CMYK_K": 0.58332741260529
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1290",
    "Farbtonhilfsbezeichnung": "36.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "69",
    "Bcolor": "79",
    "Y": 6,
    "L": 31.7608184814453,
    "a": 10.4826517105103,
    "b": -3.14554643630981,
    "C": 10.9444255828857,
    "h": 343.296997070313,
    "CMY_C": 0.65110516548157,
    "CMY_M": 0.72833359241486,
    "CMY_Y": 0.68934166431427,
    "CMYK_C": 0,
    "CMYK_M": 0.22135159373283,
    "CMYK_Y": 0.10959319025278,
    "CMYK_K": 0.65110516548157
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1292",
    "Farbtonhilfsbezeichnung": "57.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "111",
    "Bcolor": "131",
    "Y": 15,
    "L": 46.4112434387207,
    "a": 0.19442746043205,
    "b": -13.4338216781616,
    "C": 13.4352283477783,
    "h": 270.829193115234,
    "CMY_C": 0.6165657043457,
    "CMY_M": 0.56512308120728,
    "CMY_Y": 0.48532062768936,
    "CMYK_C": 0.25500357151031,
    "CMYK_M": 0.15505275130272,
    "CMYK_Y": 0,
    "CMYK_K": 0.48532062768936
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1293",
    "Farbtonhilfsbezeichnung": "69.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "161",
    "Gcolor": "180",
    "Bcolor": "180",
    "Y": 44,
    "L": 71.9628601074219,
    "a": -6.30141830444336,
    "b": -2.62504315376282,
    "C": 6.8263258934021,
    "h": 202.615631103516,
    "CMY_C": 0.36724942922592,
    "CMY_M": 0.29339641332626,
    "CMY_Y": 0.2960529923439,
    "CMYK_C": 0.10451831668615,
    "CMYK_M": 0,
    "CMYK_Y": 0.00375964562409,
    "CMYK_K": 0.29339641332626
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1294",
    "Farbtonhilfsbezeichnung": "69.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "165",
    "Bcolor": "183",
    "Y": 33,
    "L": 64.2519912719727,
    "a": -15.8009042739868,
    "b": -16.2610645294189,
    "C": 22.6735706329346,
    "h": 225.822265625,
    "CMY_C": 0.60706740617752,
    "CMY_M": 0.35210824012756,
    "CMY_Y": 0.2835339307785,
    "CMYK_C": 0.45156845450401,
    "CMYK_M": 0.09571187198162,
    "CMYK_Y": 0,
    "CMYK_K": 0.2835339307785
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1295",
    "Farbtonhilfsbezeichnung": "75.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "240",
    "Bcolor": "230",
    "Y": 84,
    "L": 94.1318206787109,
    "a": -3.34774899482727,
    "b": 3.19938135147095,
    "C": 4.63070869445801,
    "h": 136.298187255859,
    "CMY_C": 0.08200204372406,
    "CMY_M": 0.05858534574509,
    "CMY_Y": 0.09765690565109,
    "CMYK_C": 0.02487394586205,
    "CMYK_M": 0,
    "CMYK_Y": 0.04150303080678,
    "CMYK_K": 0.05858534574509
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1297",
    "Farbtonhilfsbezeichnung": "78.12.18",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "169",
    "Bcolor": "141",
    "Y": 33,
    "L": 64.1008758544922,
    "a": -29.4289569854736,
    "b": 6.65627384185791,
    "C": 30.1723289489746,
    "h": 167.255233764648,
    "CMY_C": 0.6245049238205,
    "CMY_M": 0.33576065301895,
    "CMY_Y": 0.44535386562347,
    "CMYK_C": 0.43469914793968,
    "CMYK_M": 0,
    "CMYK_Y": 0.16499054431915,
    "CMYK_K": 0.33576065301895
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1298",
    "Farbtonhilfsbezeichnung": "81.06.21",
    "Farbtonklasse": "01",
    "Rcolor": "119",
    "Gcolor": "131",
    "Bcolor": "114",
    "Y": 21,
    "L": 53.2484970092773,
    "a": -7.38630104064941,
    "b": 7.04911756515503,
    "C": 10.2101669311523,
    "h": 136.338073730469,
    "CMY_C": 0.53336030244827,
    "CMY_M": 0.48762023448944,
    "CMY_Y": 0.55321180820465,
    "CMYK_C": 0.08926985412836,
    "CMYK_M": 0,
    "CMYK_Y": 0.12801359593868,
    "CMYK_K": 0.48762023448944
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1299",
    "Farbtonhilfsbezeichnung": "81.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "107",
    "Bcolor": "92",
    "Y": 13,
    "L": 43.6747665405273,
    "a": -7.38009214401245,
    "b": 6.46421527862549,
    "C": 9.8108024597168,
    "h": 138.784912109375,
    "CMY_C": 0.62800788879395,
    "CMY_M": 0.58209621906281,
    "CMY_Y": 0.64101338386536,
    "CMYK_C": 0.1098618209362,
    "CMYK_M": 0,
    "CMYK_Y": 0.14098261296749,
    "CMYK_K": 0.58209621906281
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1300",
    "Farbtonhilfsbezeichnung": "81.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "91",
    "Bcolor": "80",
    "Y": 9,
    "L": 37.5922775268555,
    "a": -4.84982872009277,
    "b": 4.58121776580811,
    "C": 6.67146110534668,
    "h": 136.631439208984,
    "CMY_C": 0.67283886671066,
    "CMY_M": 0.64456737041473,
    "CMY_Y": 0.68518137931824,
    "CMYK_C": 0.07954107969999,
    "CMYK_M": 0,
    "CMYK_Y": 0.11426640301943,
    "CMYK_K": 0.64456737041473
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1301",
    "Farbtonhilfsbezeichnung": "81.06.30",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "62",
    "Bcolor": "53",
    "Y": 6,
    "L": 24.6995582580566,
    "a": -7.03851652145386,
    "b": 3.27454400062561,
    "C": 7.76294755935669,
    "h": 155.050628662109,
    "CMY_C": 0.80706143379211,
    "CMY_M": 0.75835573673248,
    "CMY_Y": 0.79200381040573,
    "CMYK_C": 0.20155949890614,
    "CMYK_M": 0,
    "CMYK_Y": 0.13924631476402,
    "CMYK_K": 0.75835573673248
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1302",
    "Farbtonhilfsbezeichnung": "84.18.27",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "104",
    "Bcolor": "56",
    "Y": 13,
    "L": 39.5320281982422,
    "a": -27.2819747924805,
    "b": 21.6129951477051,
    "C": 34.8055686950684,
    "h": 141.61344909668,
    "CMY_C": 0.78324401378632,
    "CMY_M": 0.59280687570572,
    "CMY_Y": 0.78079444169998,
    "CMYK_C": 0.46768260002136,
    "CMYK_M": 0,
    "CMYK_Y": 0.46166685223579,
    "CMYK_K": 0.59280687570572
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1308",
    "Farbtonhilfsbezeichnung": "45.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "191",
    "Bcolor": "197",
    "Y": 52,
    "L": 77.7317123413086,
    "a": 2.138343334198,
    "b": -3.20657730102539,
    "C": 3.85417318344116,
    "h": 303.697814941406,
    "CMY_C": 0.24113774299622,
    "CMY_M": 0.25022667646408,
    "CMY_Y": 0.22927558422089,
    "CMYK_C": 0.0153909213841,
    "CMYK_M": 0.02718363702297,
    "CMYK_Y": 0,
    "CMYK_K": 0.22927558422089
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1311",
    "Farbtonhilfsbezeichnung": "75.12.21",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "142",
    "Bcolor": "138",
    "Y": 24,
    "L": 56.0146789550781,
    "a": -15.1850643157959,
    "b": -3.08838391304016,
    "C": 15.4959440231323,
    "h": 191.496185302734,
    "CMY_C": 0.6087241768837,
    "CMY_M": 0.44247609376907,
    "CMY_Y": 0.45877677202225,
    "CMYK_C": 0.29819005727768,
    "CMYK_M": 0,
    "CMYK_Y": 0.02923763170838,
    "CMYK_K": 0.44247609376907
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1312",
    "Farbtonhilfsbezeichnung": "03.03.16",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "163",
    "Bcolor": "154",
    "Y": 38,
    "L": 67.1700668334961,
    "a": -0.14829501509666,
    "b": 4.43503427505493,
    "C": 4.43751287460327,
    "h": 91.9151000976562,
    "CMY_C": 0.34619915485382,
    "CMY_M": 0.35928827524185,
    "CMY_Y": 0.39476537704468,
    "CMYK_C": 0,
    "CMYK_M": 0.02002004161477,
    "CMYK_Y": 0.07428289949894,
    "CMYK_K": 0.34619915485382
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1313",
    "Farbtonhilfsbezeichnung": "03.03.25",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "104",
    "Bcolor": "96",
    "Y": 13,
    "L": 44.3153762817383,
    "a": 0.55791920423508,
    "b": 4.72794532775879,
    "C": 4.76074981689453,
    "h": 83.2699584960938,
    "CMY_C": 0.57219743728638,
    "CMY_M": 0.59113347530365,
    "CMY_Y": 0.62277364730835,
    "CMYK_C": 0,
    "CMYK_M": 0.04426349699497,
    "CMYK_Y": 0.11822324991226,
    "CMYK_K": 0.57219743728638
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1314",
    "Farbtonhilfsbezeichnung": "03.06.16",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "156",
    "Bcolor": "134",
    "Y": 34,
    "L": 64.8299026489258,
    "a": 0.87831211090088,
    "b": 12.4707622528076,
    "C": 12.5016536712647,
    "h": 85.971321105957,
    "CMY_C": 0.34186595678329,
    "CMY_M": 0.38789433240891,
    "CMY_Y": 0.47425597906113,
    "CMYK_C": 0,
    "CMYK_M": 0.06993769109249,
    "CMYK_Y": 0.20115965604782,
    "CMYK_K": 0.34186595678329
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1315",
    "Farbtonhilfsbezeichnung": "03.09.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "203",
    "Y": 88,
    "L": 93.1902847290039,
    "a": 0.45522949099541,
    "b": 15.8729972839356,
    "C": 15.879524230957,
    "h": 88.3572387695313,
    "CMY_C": 0.02445179224014,
    "CMY_M": 0.08146113157272,
    "CMY_Y": 0.20207363367081,
    "CMYK_C": 0,
    "CMYK_M": 0.05843826010823,
    "CMYK_Y": 0.18207387626171,
    "CMYK_K": 0.02445179224014
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1316",
    "Farbtonhilfsbezeichnung": "03.12.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "236",
    "Bcolor": "199",
    "Y": 87,
    "L": 93.5760650634766,
    "a": -1.08880186080933,
    "b": 18.5340824127197,
    "C": 18.5660362243652,
    "h": 93.3620300292969,
    "CMY_C": 0.02441966533661,
    "CMY_M": 0.07408195734024,
    "CMY_Y": 0.21809780597687,
    "CMYK_C": 0,
    "CMYK_M": 0.05090538412333,
    "CMYK_Y": 0.19852608442307,
    "CMYK_K": 0.02441966533661
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1317",
    "Farbtonhilfsbezeichnung": "03.09.16",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "154",
    "Bcolor": "113",
    "Y": 33.6398124694824,
    "L": 64.6756591796875,
    "a": 2.29111957550049,
    "b": 24.0942993164063,
    "C": 24.2029857635498,
    "h": 84.5680999755859,
    "CMY_C": 0.30898326635361,
    "CMY_M": 0.39508759975433,
    "CMY_Y": 0.55687069892883,
    "CMYK_C": 0,
    "CMYK_M": 0.12460528314114,
    "CMYK_Y": 0.35872855782509,
    "CMYK_K": 0.30898326635361
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1318",
    "Farbtonhilfsbezeichnung": "06.12.02",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "205",
    "Y": 84,
    "L": 93.2393569946289,
    "a": -0.01684329658747,
    "b": 15.0241413116455,
    "C": 15.0241508483887,
    "h": 90.0642318725586,
    "CMY_C": 0.02973413467407,
    "CMY_M": 0.07956975698471,
    "CMY_Y": 0.19526851177216,
    "CMYK_C": 0,
    "CMYK_M": 0.05136285349727,
    "CMYK_Y": 0.17060723900795,
    "CMYK_K": 0.02973413467407
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1319",
    "Farbtonhilfsbezeichnung": "06.12.01",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "239",
    "Bcolor": "219",
    "Y": 87,
    "L": 94.5037231445312,
    "a": -0.64425712823868,
    "b": 9.78925609588623,
    "C": 9.81043338775635,
    "h": 93.7653579711914,
    "CMY_C": 0.03528124094009,
    "CMY_M": 0.06256002187729,
    "CMY_Y": 0.14239549636841,
    "CMYK_C": 0,
    "CMYK_M": 0.02827640809119,
    "CMYK_Y": 0.11103158444166,
    "CMYK_K": 0.03528124094009
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1320",
    "Farbtonhilfsbezeichnung": "06.15.01",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "240",
    "Bcolor": "210",
    "Y": 89,
    "L": 94.9144821166992,
    "a": -1.19615042209625,
    "b": 15.0900764465332,
    "C": 15.1374101638794,
    "h": 94.5322113037109,
    "CMY_C": 0.01938873529434,
    "CMY_M": 0.05797106027603,
    "CMY_Y": 0.17771679162979,
    "CMYK_C": 0,
    "CMYK_M": 0.03934517875314,
    "CMYK_Y": 0.16145853698254,
    "CMYK_K": 0.01938873529434
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1321",
    "Farbtonhilfsbezeichnung": "06.15.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "234",
    "Bcolor": "190",
    "Y": 85,
    "L": 93.1401062011719,
    "a": -0.71926110982895,
    "b": 22.9915103912354,
    "C": 23.0027580261231,
    "h": 91.7918395996094,
    "CMY_C": 0.01530528068542,
    "CMY_M": 0.08087056875229,
    "CMY_Y": 0.25624293088913,
    "CMYK_C": 0,
    "CMYK_M": 0.06658437848091,
    "CMYK_Y": 0.24468258023262,
    "CMYK_K": 0.01530528068542
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1322",
    "Farbtonhilfsbezeichnung": "09.06.02",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "232",
    "Bcolor": "222",
    "Y": 80,
    "L": 91.8502655029297,
    "a": -0.64021408557892,
    "b": 4.32173347473145,
    "C": 4.36889600753784,
    "h": 98.4264144897461,
    "CMY_C": 0.0822588801384,
    "CMY_M": 0.09083384275436,
    "CMY_Y": 0.13083219528198,
    "CMYK_C": 0,
    "CMYK_M": 0.00934355240315,
    "CMYK_Y": 0.05292703211308,
    "CMYK_K": 0.0822588801384
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1323",
    "Farbtonhilfsbezeichnung": "09.07.03",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "230",
    "Bcolor": "212",
    "Y": 81,
    "L": 91.6635971069336,
    "a": 0.49341458082199,
    "b": 9.37366104125977,
    "C": 9.38663864135742,
    "h": 86.9868240356445,
    "CMY_C": 0.05988657474518,
    "CMY_M": 0.09697049856186,
    "CMY_Y": 0.17022901773453,
    "CMYK_C": 0,
    "CMYK_M": 0.03944622352719,
    "CMYK_Y": 0.11737141758204,
    "CMYK_K": 0.05988657474518
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1324",
    "Farbtonhilfsbezeichnung": "09.07.06",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "223",
    "Bcolor": "203",
    "Y": 75,
    "L": 89.4274978637695,
    "a": 1.18821787834167,
    "b": 10.408350944519,
    "C": 10.4759550094604,
    "h": 83.4873046875,
    "CMY_C": 0.07676756381989,
    "CMY_M": 0.12377899885178,
    "CMY_Y": 0.20211905241013,
    "CMYK_C": 0,
    "CMYK_M": 0.05092047527432,
    "CMYK_Y": 0.13577456772327,
    "CMYK_K": 0.07676756381989
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1325",
    "Farbtonhilfsbezeichnung": "09.07.09",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "208",
    "Bcolor": "185",
    "Y": 64,
    "L": 84.1213836669922,
    "a": 2.12634468078613,
    "b": 12.5622301101685,
    "C": 12.7409172058106,
    "h": 80.3928985595703,
    "CMY_C": 0.12321275472641,
    "CMY_M": 0.1850311756134,
    "CMY_Y": 0.27483463287354,
    "CMYK_C": 0,
    "CMYK_M": 0.07050561159849,
    "CMYK_Y": 0.17292892932892,
    "CMYK_K": 0.12321275472641
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1326",
    "Farbtonhilfsbezeichnung": "09.09.01",
    "Farbtonklasse": "01",
    "Y": 91,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1327",
    "Farbtonhilfsbezeichnung": "09.09.02",
    "Farbtonklasse": "01",
    "Y": 88,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1328",
    "Farbtonhilfsbezeichnung": "09.11.06",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "218",
    "Bcolor": "180",
    "Y": 73,
    "L": 88.2451019287109,
    "a": 3.47822308540344,
    "b": 21.1688842773438,
    "C": 21.4527320861816,
    "h": 80.6691970825195,
    "CMY_C": 0.04541331529617,
    "CMY_M": 0.14500749111176,
    "CMY_Y": 0.29413467645645,
    "CMYK_C": 0,
    "CMYK_M": 0.10433224588633,
    "CMYK_Y": 0.26055398583412,
    "CMYK_K": 0.04541331529617
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1329",
    "Farbtonhilfsbezeichnung": "09.11.09",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "208",
    "Bcolor": "167",
    "Y": 66,
    "L": 85.0164947509766,
    "a": 4.40145921707153,
    "b": 23.5062198638916,
    "C": 23.9147491455078,
    "h": 79.3943710327148,
    "CMY_C": 0.07037264108658,
    "CMY_M": 0.18327456712723,
    "CMY_Y": 0.34538000822067,
    "CMYK_C": 0,
    "CMYK_M": 0.12144858390093,
    "CMYK_Y": 0.29582539200783,
    "CMYK_K": 0.07037264108658
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1330",
    "Farbtonhilfsbezeichnung": "09.11.12",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "195",
    "Bcolor": "150",
    "Y": 58,
    "L": 80.6037292480469,
    "a": 5.15979433059692,
    "b": 26.4350757598877,
    "C": 26.933931350708,
    "h": 78.9554443359375,
    "CMY_C": 0.10910612344742,
    "CMY_M": 0.23375558853149,
    "CMY_Y": 0.41273558139801,
    "CMYK_C": 0,
    "CMYK_M": 0.13991504907608,
    "CMYK_Y": 0.34081438183784,
    "CMYK_K": 0.10910612344742
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1331",
    "Farbtonhilfsbezeichnung": "09.11.15",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "172",
    "Bcolor": "124",
    "Y": 45,
    "L": 72.8262786865234,
    "a": 8.84954738616943,
    "b": 29.4510879516602,
    "C": 30.7519283294678,
    "h": 73.2753753662109,
    "CMY_C": 0.16735833883286,
    "CMY_M": 0.32659447193146,
    "CMY_Y": 0.51307511329651,
    "CMYK_C": 0,
    "CMYK_M": 0.19124209880829,
    "CMYK_Y": 0.41520476341248,
    "CMYK_K": 0.16735833883286
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1332",
    "Farbtonhilfsbezeichnung": "09.12.01",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "235",
    "Bcolor": "215",
    "Y": 85,
    "L": 93.3763046264648,
    "a": 0.41435334086418,
    "b": 9.88589096069336,
    "C": 9.89457035064697,
    "h": 87.5999298095703,
    "CMY_C": 0.03964042663574,
    "CMY_M": 0.07776856422424,
    "CMY_Y": 0.15532302856445,
    "CMYK_C": 0,
    "CMYK_M": 0.03970193862915,
    "CMYK_Y": 0.12045758962631,
    "CMYK_K": 0.03964042663574
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1333",
    "Farbtonhilfsbezeichnung": "09.12.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "232",
    "Bcolor": "200",
    "Y": 84,
    "L": 92.8178024291992,
    "a": 1.85450768470764,
    "b": 17.0278968811035,
    "C": 17.1285858154297,
    "h": 83.7844161987305,
    "CMY_C": 0.01528519392014,
    "CMY_M": 0.08929240703583,
    "CMY_Y": 0.21451479196548,
    "CMYK_C": 0,
    "CMYK_M": 0.07515598833561,
    "CMYK_Y": 0.20232212543488,
    "CMYK_K": 0.01528519392014
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1334",
    "Farbtonhilfsbezeichnung": "09.15.07",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "212",
    "Bcolor": "151",
    "Y": 71,
    "L": 86.9233627319336,
    "a": 6.06836080551147,
    "b": 34.6375694274902,
    "C": 35.1651268005371,
    "h": 80.0628662109375,
    "CMY_C": 0.01472014188766,
    "CMY_M": 0.16877484321594,
    "CMY_Y": 0.40832591056824,
    "CMYK_C": 0,
    "CMYK_M": 0.1563562899828,
    "CMYK_Y": 0.39948627352715,
    "CMYK_K": 0.01472014188766
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1335",
    "Farbtonhilfsbezeichnung": "12.06.19",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "139",
    "Bcolor": "123",
    "Y": 26,
    "L": 58.9353828430176,
    "a": 4.17529010772705,
    "b": 10.3727798461914,
    "C": 11.1815748214722,
    "h": 68.0740432739258,
    "CMY_C": 0.38677406311035,
    "CMY_M": 0.45542162656784,
    "CMY_Y": 0.51809811592102,
    "CMYK_C": 0,
    "CMYK_M": 0.11194497346878,
    "CMYK_Y": 0.2141527980566,
    "CMYK_K": 0.38677406311035
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1336",
    "Farbtonhilfsbezeichnung": "12.12.17",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "148",
    "Bcolor": "107",
    "Y": 33,
    "L": 64.5724487304688,
    "a": 11.5476608276367,
    "b": 27.3294277191162,
    "C": 29.6689414978027,
    "h": 67.0942077636719,
    "CMY_C": 0.24668204784393,
    "CMY_M": 0.41905802488327,
    "CMY_Y": 0.57887572050095,
    "CMYK_C": 0,
    "CMYK_M": 0.22882233560085,
    "CMYK_Y": 0.44097405672073,
    "CMYK_K": 0.24668204784393
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1337",
    "Farbtonhilfsbezeichnung": "12.09.19",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "132",
    "Bcolor": "106",
    "Y": 25,
    "L": 57.568920135498,
    "a": 9.10867214202881,
    "b": 18.4506816864014,
    "C": 20.5765781402588,
    "h": 63.7255210876465,
    "CMY_C": 0.35316669940948,
    "CMY_M": 0.48261684179306,
    "CMY_Y": 0.58561229705811,
    "CMYK_C": 0,
    "CMYK_M": 0.20012906193733,
    "CMYK_Y": 0.35935935378075,
    "CMYK_K": 0.35316669940948
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1338",
    "Farbtonhilfsbezeichnung": "12.18.02",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "229",
    "Bcolor": "191",
    "Y": 81,
    "L": 91.9119338989258,
    "a": 2.40703821182251,
    "b": 20.6332778930664,
    "C": 20.7732028961182,
    "h": 83.346061706543,
    "CMY_C": 0.01247656345367,
    "CMY_M": 0.10159891843796,
    "CMY_Y": 0.25116121768951,
    "CMYK_C": 0,
    "CMYK_M": 0.09024834632874,
    "CMYK_Y": 0.24170024693012,
    "CMYK_K": 0.01247656345367
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1339",
    "Farbtonhilfsbezeichnung": "12.18.07",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "211",
    "Bcolor": "152",
    "Y": 71,
    "L": 87.1085205078125,
    "a": 8.08712768554688,
    "b": 34.5127716064453,
    "C": 35.4476089477539,
    "h": 76.8122253417969,
    "CMY_C": 0,
    "CMY_M": 0.17181348800659,
    "CMY_Y": 0.40500575304031,
    "CMYK_C": 0,
    "CMYK_M": 0.17181348800659,
    "CMYK_Y": 0.40500575304031,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1340",
    "Farbtonhilfsbezeichnung": "12.13.12",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "183",
    "Bcolor": "122",
    "Y": 53,
    "L": 77.6682510375977,
    "a": 11.8345947265625,
    "b": 37.3709678649902,
    "C": 39.2000885009766,
    "h": 72.428108215332,
    "CMY_C": 0.08033949136734,
    "CMY_M": 0.28420317173004,
    "CMY_Y": 0.52221459150314,
    "CMYK_C": 0,
    "CMYK_M": 0.22167275846004,
    "CMYK_Y": 0.48047631978989,
    "CMYK_K": 0.08033949136734
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1341",
    "Farbtonhilfsbezeichnung": "12.13.15",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "170",
    "Bcolor": "111",
    "Y": 45,
    "L": 72.9576263427734,
    "a": 12.0901832580566,
    "b": 36.8988761901855,
    "C": 38.8291091918945,
    "h": 71.8582382202148,
    "CMY_C": 0.13391208648682,
    "CMY_M": 0.33478206396103,
    "CMY_Y": 0.56572031974792,
    "CMYK_C": 0,
    "CMYK_M": 0.23192793130875,
    "CMYK_Y": 0.49857321381569,
    "CMYK_K": 0.13391208648682
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1342",
    "Farbtonhilfsbezeichnung": "12.13.18",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "141",
    "Bcolor": "88",
    "Y": 31,
    "L": 62.3907318115234,
    "a": 13.6280536651611,
    "b": 35.1652870178223,
    "C": 37.7136764526367,
    "h": 68.816520690918,
    "CMY_C": 0.24753773212433,
    "CMY_M": 0.44810104370117,
    "CMY_Y": 0.65568292140961,
    "CMYK_C": 0,
    "CMYK_M": 0.26654267311096,
    "CMYK_Y": 0.54241281747818,
    "CMYK_K": 0.24753773212433
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1343",
    "Farbtonhilfsbezeichnung": "12.15.13",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "172",
    "Bcolor": "108",
    "Y": 49,
    "L": 75.0158767700195,
    "a": 15.8056373596191,
    "b": 41.1263313293457,
    "C": 44.0589752197266,
    "h": 68.9772720336914,
    "CMY_C": 0.08154195547104,
    "CMY_M": 0.32355719804764,
    "CMY_Y": 0.57599234580994,
    "CMYK_C": 0,
    "CMYK_M": 0.26350167393684,
    "CMYK_Y": 0.53834837675095,
    "CMYK_K": 0.08154195547104
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1344",
    "Farbtonhilfsbezeichnung": "15.03.22",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "122",
    "Bcolor": "116",
    "Y": 20,
    "L": 51.9330749511719,
    "a": 2.73956108093262,
    "b": 4.01686000823975,
    "C": 4.86213541030884,
    "h": 55.7054023742676,
    "CMY_C": 0.48409450054169,
    "CMY_M": 0.52104544639587,
    "CMY_Y": 0.54455381631851,
    "CMYK_C": 0,
    "CMYK_M": 0.07162347435951,
    "CMYK_Y": 0.11719068139791,
    "CMYK_K": 0.48409450054169
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1345",
    "Farbtonhilfsbezeichnung": "15.09.17",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "158",
    "Bcolor": "134",
    "Y": 38,
    "L": 67.8328323364258,
    "a": 9.82025146484375,
    "b": 16.9311485290527,
    "C": 19.5729694366455,
    "h": 59.885799407959,
    "CMY_C": 0.24035811424255,
    "CMY_M": 0.37883150577545,
    "CMY_Y": 0.47369128465652,
    "CMYK_C": 0,
    "CMYK_M": 0.182287722826,
    "CMYK_Y": 0.30716207623482,
    "CMYK_K": 0.24035811424255
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1346",
    "Farbtonhilfsbezeichnung": "15.06.22",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "117",
    "Bcolor": "104",
    "Y": 19,
    "L": 50.9842948913574,
    "a": 6.32397270202637,
    "b": 10.1113758087158,
    "C": 11.9261293411255,
    "h": 57.9768447875977,
    "CMY_C": 0.45596671104431,
    "CMY_M": 0.53991293907166,
    "CMY_Y": 0.59348946809769,
    "CMYK_C": 0,
    "CMYK_M": 0.15430347621441,
    "CMYK_Y": 0.25278371572495,
    "CMYK_K": 0.45596671104431
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1347",
    "Farbtonhilfsbezeichnung": "18.12.07",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "180",
    "Y": 69,
    "L": 86.1406478881836,
    "a": 10.2425966262817,
    "b": 18.0779514312744,
    "C": 20.7779483795166,
    "h": 60.4650001525879,
    "CMY_C": 0.02959030866623,
    "CMY_M": 0.18439102172852,
    "CMY_Y": 0.29242658615112,
    "CMYK_C": 0,
    "CMYK_M": 0.15952098369598,
    "CMYK_Y": 0.27085083723068,
    "CMYK_K": 0.02959030866623
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1348",
    "Farbtonhilfsbezeichnung": "18.12.13",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "179",
    "Bcolor": "144",
    "Y": 52,
    "L": 76.7697906494141,
    "a": 14.8445386886597,
    "b": 24.1365814208984,
    "C": 28.3361053466797,
    "h": 58.4075508117676,
    "CMY_C": 0.09399199485779,
    "CMY_M": 0.29911953210831,
    "CMY_Y": 0.43340796232224,
    "CMYK_C": 0,
    "CMYK_M": 0.22640807926655,
    "CMYK_Y": 0.37462800741196,
    "CMYK_K": 0.09399199485779
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1349",
    "Farbtonhilfsbezeichnung": "21.09.02",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "236",
    "Bcolor": "222",
    "Y": 87,
    "L": 94.226188659668,
    "a": 2.64533948898315,
    "b": 7.65665721893311,
    "C": 8.100754737854,
    "h": 70.9402084350586,
    "CMY_C": 0.01971471309662,
    "CMY_M": 0.07306009531021,
    "CMY_Y": 0.12900573015213,
    "CMYK_C": 0,
    "CMYK_M": 0.05441822111607,
    "CMYK_Y": 0.11148899048567,
    "CMYK_K": 0.01971471309662
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1350",
    "Farbtonhilfsbezeichnung": "21.12.16",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "152",
    "Bcolor": "129",
    "Y": 38,
    "L": 67.4917602539063,
    "a": 17.2117424011231,
    "b": 19.541109085083,
    "C": 26.0403347015381,
    "h": 48.6265106201172,
    "CMY_C": 0.19284415245056,
    "CMY_M": 0.40211170911789,
    "CMY_Y": 0.49404680728912,
    "CMYK_C": 0,
    "CMYK_M": 0.2592653632164,
    "CMYK_Y": 0.37316542863846,
    "CMYK_K": 0.19284415245056
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1351",
    "Farbtonhilfsbezeichnung": "21.15.16",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "149",
    "Bcolor": "117",
    "Y": 39,
    "L": 68.6619491577148,
    "a": 25.3471031188965,
    "b": 28.2299671173096,
    "C": 37.9395141601563,
    "h": 48.0799903869629,
    "CMY_C": 0.11694842576981,
    "CMY_M": 0.41484051942825,
    "CMY_Y": 0.54200178384781,
    "CMYK_C": 0,
    "CMYK_M": 0.33734393119812,
    "CMYK_Y": 0.4813460111618,
    "CMYK_K": 0.11694842576981
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1352",
    "Farbtonhilfsbezeichnung": "24.06.19",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "130",
    "Bcolor": "123",
    "Y": 24,
    "L": 56.1325263977051,
    "a": 7.99555587768555,
    "b": 6.56053400039673,
    "C": 10.342607498169,
    "h": 39.3696517944336,
    "CMY_C": 0.4002303481102,
    "CMY_M": 0.49173718690872,
    "CMY_Y": 0.51948630809784,
    "CMYK_C": 0,
    "CMYK_M": 0.15256996452808,
    "CMYK_Y": 0.19883626699448,
    "CMYK_K": 0.4002303481102
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1353",
    "Farbtonhilfsbezeichnung": "24.09.16",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "158",
    "Bcolor": "145",
    "Y": 39,
    "L": 68.6281204223633,
    "a": 13.6386995315552,
    "b": 12.3814888000488,
    "C": 18.4205150604248,
    "h": 42.2338066101074,
    "CMY_C": 0.21676337718964,
    "CMY_M": 0.3791708946228,
    "CMY_Y": 0.43314373493195,
    "CMYK_C": 0,
    "CMYK_M": 0.20735435187817,
    "CMYK_Y": 0.27626433968544,
    "CMYK_K": 0.21676337718964
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1354",
    "Farbtonhilfsbezeichnung": "24.12.16",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "155",
    "Bcolor": "134",
    "Y": 40,
    "L": 69.1268157958984,
    "a": 20.2124938964844,
    "b": 18.9284000396729,
    "C": 27.6916809082031,
    "h": 43.1209716796875,
    "CMY_C": 0.15720015764236,
    "CMY_M": 0.39319103956223,
    "CMY_Y": 0.47276967763901,
    "CMYK_C": 0,
    "CMYK_M": 0.28000822663307,
    "CMYK_Y": 0.37442997097969,
    "CMYK_K": 0.15720015764236
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1355",
    "Farbtonhilfsbezeichnung": "24.13.18",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "140",
    "Bcolor": "121",
    "Y": 34,
    "L": 64.4514312744141,
    "a": 23.9033374786377,
    "b": 19.8912982940674,
    "C": 31.0971584320068,
    "h": 39.7657279968262,
    "CMY_C": 0.18654817342758,
    "CMY_M": 0.45236325263977,
    "CMY_Y": 0.52539598941803,
    "CMYK_C": 0,
    "CMYK_M": 0.32677420973778,
    "CMYK_Y": 0.41655549407005,
    "CMYK_K": 0.18654817342758
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1356",
    "Farbtonhilfsbezeichnung": "24.13.21",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "115",
    "Bcolor": "98",
    "Y": 24,
    "L": 55.8313941955566,
    "a": 26.574182510376,
    "b": 20.8138847351074,
    "C": 33.7550735473633,
    "h": 38.0693626403809,
    "CMY_C": 0.26739954948425,
    "CMY_M": 0.54803144931793,
    "CMY_Y": 0.61486613750458,
    "CMYK_C": 0,
    "CMYK_M": 0.38306269049644,
    "CMYK_Y": 0.47429206967354,
    "CMYK_K": 0.26739954948425
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1357",
    "Farbtonhilfsbezeichnung": "24.13.24",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "98",
    "Bcolor": "86",
    "Y": 17,
    "L": 48.3697624206543,
    "a": 25.1467361450195,
    "b": 17.135383605957,
    "C": 30.4299144744873,
    "h": 34.2711372375488,
    "CMY_C": 0.36325669288635,
    "CMY_M": 0.61665737628937,
    "CMY_Y": 0.66104310750961,
    "CMYK_C": 0,
    "CMYK_M": 0.39796364307404,
    "CMYK_Y": 0.4676710665226,
    "CMYK_K": 0.36325669288635
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1358",
    "Farbtonhilfsbezeichnung": "27.12.23",
    "Farbtonklasse": "03",
    "Y": 20,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1359",
    "Farbtonhilfsbezeichnung": "27.13.21",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "116",
    "Bcolor": "106",
    "Y": 24,
    "L": 55.7348899841309,
    "a": 26.1036109924316,
    "b": 16.1156101226807,
    "C": 30.6775398254395,
    "h": 31.6899738311768,
    "CMY_C": 0.27807933092117,
    "CMY_M": 0.54650175571442,
    "CMY_Y": 0.58431059122086,
    "CMYK_C": 0,
    "CMYK_M": 0.37181705236435,
    "CMYK_Y": 0.42418962717056,
    "CMYK_K": 0.27807933092117
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1360",
    "Farbtonhilfsbezeichnung": "33.09.16",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "163",
    "Bcolor": "162",
    "Y": 40,
    "L": 69.1530303955078,
    "a": 8.85746192932129,
    "b": 2.96596312522888,
    "C": 9.34085464477539,
    "h": 18.5133666992188,
    "CMY_C": 0.26572287082672,
    "CMY_M": 0.35920542478561,
    "CMY_Y": 0.36275905370712,
    "CMYK_C": 0,
    "CMYK_M": 0.12731236219406,
    "CMYK_Y": 0.13215199112892,
    "CMYK_K": 0.26572287082672
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1361",
    "Farbtonhilfsbezeichnung": "60.06.19",
    "Farbtonklasse": "01",
    "Rcolor": "138",
    "Gcolor": "143",
    "Bcolor": "149",
    "Y": 27,
    "L": 59.2478561401367,
    "a": -0.82839041948318,
    "b": -4.14523506164551,
    "C": 4.22719812393188,
    "h": 258.698791503906,
    "CMY_C": 0.46076673269272,
    "CMY_M": 0.43746829032898,
    "CMY_Y": 0.4171866774559,
    "CMYK_C": 0.07477532327175,
    "CMYK_M": 0.03479950129986,
    "CMYK_Y": 0,
    "CMYK_K": 0.4171866774559
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1362",
    "Farbtonhilfsbezeichnung": "78.01.03",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "236",
    "Bcolor": "229",
    "Y": 83,
    "L": 92.8850326538086,
    "a": -1.87396430969238,
    "b": 1.69361460208893,
    "C": 2.52588057518005,
    "h": 137.893981933594,
    "CMY_C": 0.08928251266479,
    "CMY_M": 0.07561260461807,
    "CMY_Y": 0.10004723072052,
    "CMYK_C": 0.01478807255626,
    "CMYK_M": 0,
    "CMYK_Y": 0.02643331885338,
    "CMYK_K": 0.07561260461807
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1363",
    "Farbtonhilfsbezeichnung": "78.01.06",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "214",
    "Y": 72,
    "L": 87.2827072143555,
    "a": -2.01976323127747,
    "b": 1.44753432273865,
    "C": 2.48491430282593,
    "h": 144.371383666992,
    "CMY_C": 0.1534498333931,
    "CMY_M": 0.13758558034897,
    "CMY_Y": 0.15993082523346,
    "CMYK_C": 0.01839516125619,
    "CMYK_M": 0,
    "CMYK_Y": 0.02591010183096,
    "CMYK_K": 0.13758558034897
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1364",
    "Farbtonhilfsbezeichnung": "78.01.09",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "207",
    "Bcolor": "202",
    "Y": 62,
    "L": 82.816032409668,
    "a": -1.6771981716156,
    "b": 1.47672021389008,
    "C": 2.23465800285339,
    "h": 138.637100219727,
    "CMY_C": 0.19960975646973,
    "CMY_M": 0.18751895427704,
    "CMY_Y": 0.2086843252182,
    "CMYK_C": 0.01488133426756,
    "CMYK_M": 0,
    "CMYK_Y": 0.02605029568076,
    "CMYK_K": 0.18751895427704
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1365",
    "Farbtonhilfsbezeichnung": "78.01.27",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "90",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.0309181213379,
    "a": -1.59285020828247,
    "b": -0.17998568713665,
    "C": 1.60298681259155,
    "h": 186.446853637695,
    "CMY_C": 0.66033661365509,
    "CMY_M": 0.64556151628494,
    "CMY_Y": 0.65098744630814,
    "CMYK_C": 0.04168592765927,
    "CMYK_M": 0,
    "CMYK_Y": 0.01530852355063,
    "CMYK_K": 0.64556151628494
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1366",
    "Farbtonhilfsbezeichnung": "78.01.21",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "128",
    "Bcolor": "126",
    "Y": 21,
    "L": 53.3846321105957,
    "a": -1.70970857143402,
    "b": 0.38976067304611,
    "C": 1.75357258319855,
    "h": 167.157806396484,
    "CMY_C": 0.51105213165283,
    "CMY_M": 0.49614536762238,
    "CMY_Y": 0.50679135322571,
    "CMYK_C": 0.02958544529974,
    "CMYK_M": 0,
    "CMYK_Y": 0.02112908102572,
    "CMYK_K": 0.49614536762238
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1367",
    "Farbtonhilfsbezeichnung": "78.01.18",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "144",
    "Bcolor": "142",
    "Y": 28,
    "L": 59.5006942749023,
    "a": -1.68011748790741,
    "b": 0.20969294011593,
    "C": 1.69315266609192,
    "h": 172.885787963867,
    "CMY_C": 0.44983220100403,
    "CMY_M": 0.43423318862915,
    "CMY_Y": 0.44425785541534,
    "CMYK_C": 0.02757145091891,
    "CMYK_M": 0,
    "CMYK_Y": 0.01771872490644,
    "CMYK_K": 0.43423318862915
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1368",
    "Farbtonhilfsbezeichnung": "78.01.15",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "162",
    "Bcolor": "159",
    "Y": 36,
    "L": 66.3552703857422,
    "a": -1.95193636417389,
    "b": 0.77401185035706,
    "C": 2.09979748725891,
    "h": 158.369918823242,
    "CMY_C": 0.37949413061142,
    "CMY_M": 0.36288791894913,
    "CMY_Y": 0.37797683477402,
    "CMYK_C": 0.02606482058764,
    "CMYK_M": 0,
    "CMYK_Y": 0.02368329837918,
    "CMYK_K": 0.36288791894913
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1369",
    "Farbtonhilfsbezeichnung": "81.06.16",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "167",
    "Bcolor": "151",
    "Y": 37,
    "L": 67.1101455688477,
    "a": -7.3672456741333,
    "b": 6.35384273529053,
    "C": 9.7287015914917,
    "h": 139.224044799805,
    "CMY_C": 0.39483922719955,
    "CMY_M": 0.34485751390457,
    "CMY_Y": 0.4097421169281,
    "CMYK_C": 0.07629135996103,
    "CMYK_M": 0,
    "CMYK_Y": 0.0990389212966,
    "CMYK_K": 0.34485751390457
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1370",
    "Farbtonhilfsbezeichnung": "81.09.16",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "173",
    "Bcolor": "142",
    "Y": 39,
    "L": 68.2430038452148,
    "a": -14.4792785644531,
    "b": 12.8384132385254,
    "C": 19.35133934021,
    "h": 138.437408447266,
    "CMY_C": 0.41834491491318,
    "CMY_M": 0.32003897428513,
    "CMY_Y": 0.44466531276703,
    "CMYK_C": 0.14457584917545,
    "CMYK_M": 0,
    "CMYK_Y": 0.18328453600407,
    "CMYK_K": 0.32003897428513
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1371",
    "Farbtonhilfsbezeichnung": "81.12.16",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "176",
    "Bcolor": "123",
    "Y": 38,
    "L": 68.02587890625,
    "a": -22.2472972869873,
    "b": 22.5213851928711,
    "C": 31.656831741333,
    "h": 134.649215698242,
    "CMY_C": 0.45433247089386,
    "CMY_M": 0.30958545207977,
    "CMY_Y": 0.51689976453781,
    "CMYK_C": 0.20965233445168,
    "CMYK_M": 0,
    "CMYK_Y": 0.30027511715889,
    "CMYK_K": 0.30958545207977
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1372",
    "Farbtonhilfsbezeichnung": "90.03.19",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "155",
    "Bcolor": "142",
    "Y": 32,
    "L": 63.8551063537598,
    "a": -1.18569338321686,
    "b": 6.59750938415527,
    "C": 6.70320796966553,
    "h": 100.188339233398,
    "CMY_C": 0.38205260038376,
    "CMY_M": 0.39206123352051,
    "CMY_Y": 0.44376277923584,
    "CMYK_C": 0,
    "CMYK_M": 0.01619657687843,
    "CMYK_Y": 0.09986315667629,
    "CMYK_K": 0.38205260038376
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1373",
    "Farbtonhilfsbezeichnung": "96.18.01",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "238",
    "Bcolor": "212",
    "Y": 87,
    "L": 94.1556396484375,
    "a": -0.67190712690353,
    "b": 12.726279258728,
    "C": 12.7440042495728,
    "h": 93.0222320556641,
    "CMY_C": 0.0307599902153,
    "CMY_M": 0.06715762615204,
    "CMY_Y": 0.16819429397583,
    "CMYK_C": 0,
    "CMYK_M": 0.03755275905132,
    "CMYK_Y": 0.14179594814777,
    "CMYK_K": 0.0307599902153
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1374",
    "Farbtonhilfsbezeichnung": "96.18.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "234",
    "Bcolor": "188",
    "Y": 84,
    "L": 93.0025253295898,
    "a": -0.76161170005798,
    "b": 23.6903858184814,
    "C": 23.7026252746582,
    "h": 91.8413391113281,
    "CMY_C": 0.01548111438751,
    "CMY_M": 0.08246421813965,
    "CMY_Y": 0.26299142837524,
    "CMYK_C": 0,
    "CMYK_M": 0.06803638488054,
    "CMYK_Y": 0.25140228867531,
    "CMYK_K": 0.01548111438751
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1375",
    "Farbtonhilfsbezeichnung": "12.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "226",
    "Bcolor": "216",
    "Y": 77,
    "L": 90.0552597045898,
    "a": 1.08340167999268,
    "b": 4.63185977935791,
    "C": 4.75687742233276,
    "h": 76.8350830078125,
    "CMY_C": 0.08797043561935,
    "CMY_M": 0.11502432823181,
    "CMY_Y": 0.15259474515915,
    "CMYK_C": 0,
    "CMYK_M": 0.02966339513659,
    "CMYK_Y": 0.0708576887846,
    "CMYK_K": 0.08797043561935
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1376",
    "Farbtonhilfsbezeichnung": "09.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "221",
    "Bcolor": "157",
    "Y": 76,
    "L": 89.5574264526367,
    "a": 2.92539715766907,
    "b": 35.2073059082031,
    "C": 35.3286323547363,
    "h": 85.2501678466797,
    "CMY_C": 0.00429594516754,
    "CMY_M": 0.13208085298538,
    "CMY_Y": 0.38589549064636,
    "CMYK_C": 0,
    "CMYK_M": 0.12833623588085,
    "CMYK_Y": 0.38324594497681,
    "CMYK_K": 0.00429594516754
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1377",
    "Farbtonhilfsbezeichnung": "15.15.06",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "189",
    "Y": 75.2427444458008,
    "L": 89.5065765380859,
    "a": 7.37307214736938,
    "b": 18.5471286773682,
    "C": 19.958911895752,
    "h": 68.3206100463867,
    "CMY_C": 0.00978726148605,
    "CMY_M": 0.1401395201683,
    "CMY_Y": 0.26051902770996,
    "CMYK_C": 0,
    "CMYK_M": 0.13164065778255,
    "CMYK_Y": 0.25321000814438,
    "CMYK_K": 0.00978726148605
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1378",
    "Farbtonhilfsbezeichnung": "15.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "183",
    "Bcolor": "138",
    "Y": 55.3,
    "L": 78.6478500366211,
    "a": 15.8607473373413,
    "b": 30.4402599334717,
    "C": 34.324520111084,
    "h": 62.4784507751465,
    "CMY_C": 0.0548055768013,
    "CMY_M": 0.28307747840881,
    "CMY_Y": 0.45996260643005,
    "CMYK_C": 0,
    "CMYK_M": 0.24150787293911,
    "CMYK_Y": 0.42864939570427,
    "CMYK_K": 0.0548055768013
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1379",
    "Farbtonhilfsbezeichnung": "12.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "234",
    "Bcolor": "205",
    "Y": 86,
    "L": 93.3892364501953,
    "a": 1.48440206050873,
    "b": 15.5367336273193,
    "C": 15.6074838638306,
    "h": 84.5424423217773,
    "CMY_C": 0.01546066999435,
    "CMY_M": 0.08163982629776,
    "CMY_Y": 0.19722634553909,
    "CMYK_C": 0,
    "CMYK_M": 0.06721840053797,
    "CMYK_Y": 0.18462002277374,
    "CMYK_K": 0.01546066999435
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1380",
    "Farbtonhilfsbezeichnung": "63.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "233",
    "Bcolor": "237",
    "Y": 80,
    "L": 91.7691116333008,
    "a": -1.99167835712433,
    "b": -3.74830746650696,
    "C": 4.24459552764893,
    "h": 242.015869140625,
    "CMY_C": 0.12229323387146,
    "CMY_M": 0.08625400066376,
    "CMY_Y": 0.07204192876816,
    "CMYK_C": 0.05415255948901,
    "CMYK_M": 0.01531542465091,
    "CMYK_Y": 0,
    "CMYK_K": 0.07204192876816
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1381",
    "Farbtonhilfsbezeichnung": "12.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "202",
    "Bcolor": "190",
    "Y": 59.4201850891113,
    "L": 81.5220108032227,
    "a": 0.49519979953766,
    "b": 5.73218154907227,
    "C": 5.75353193283081,
    "h": 85.0625076293945,
    "CMY_C": 0.18347573280334,
    "CMY_M": 0.20781219005585,
    "CMY_Y": 0.25315791368484,
    "CMYK_C": 0,
    "CMYK_M": 0.02980494126678,
    "CMYK_Y": 0.08534000068903,
    "CMYK_K": 0.18347573280334
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1382",
    "Farbtonhilfsbezeichnung": "15.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "233",
    "Bcolor": "212",
    "Y": 83.2702484130859,
    "L": 93.1326293945312,
    "a": 2.95033240318298,
    "b": 11.2450246810913,
    "C": 11.6256198883057,
    "h": 75.2987823486328,
    "CMY_C": 0.01935631036758,
    "CMY_M": 0.08700037002563,
    "CMY_Y": 0.16772878170013,
    "CMYK_C": 0,
    "CMYK_M": 0.06897924095392,
    "CMYK_Y": 0.15130110085011,
    "CMYK_K": 0.01935631036758
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1383",
    "Farbtonhilfsbezeichnung": "18.09.12",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "189",
    "Bcolor": "164",
    "Y": 55.0207672119141,
    "L": 79.0532302856445,
    "a": 9.66024780273438,
    "b": 16.8662071228027,
    "C": 19.436803817749,
    "h": 60.1977500915527,
    "CMY_C": 0.11678624153137,
    "CMY_M": 0.2595722079277,
    "CMY_Y": 0.35827088356018,
    "CMYK_C": 0,
    "CMYK_M": 0.16166637837887,
    "CMYK_Y": 0.27341586351395,
    "CMYK_K": 0.11678624153137
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1384",
    "Farbtonhilfsbezeichnung": "06.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "229",
    "Bcolor": "172",
    "Y": 79.3956680297852,
    "L": 91.4130172729492,
    "a": 0.16905057430267,
    "b": 29.6091918945313,
    "C": 29.6096744537354,
    "h": 89.6728744506836,
    "CMY_C": 0.01343220472336,
    "CMY_M": 0.10369408130646,
    "CMY_Y": 0.3244401216507,
    "CMYK_C": 0,
    "CMYK_M": 0.0914907976985,
    "CMYK_Y": 0.31524232029915,
    "CMYK_K": 0.01343220472336
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1385",
    "Farbtonhilfsbezeichnung": "18.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "220",
    "Bcolor": "198",
    "Y": 74.8602828979492,
    "L": 89.327507019043,
    "a": 5.49627256393433,
    "b": 13.0271329879761,
    "C": 14.1391372680664,
    "h": 67.1246566772461,
    "CMY_C": 0.03903782367706,
    "CMY_M": 0.13606107234955,
    "CMY_Y": 0.22187656164169,
    "CMYK_C": 0,
    "CMYK_M": 0.10096468776464,
    "CMYK_Y": 0.19026632606983,
    "CMYK_K": 0.03903782367706
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1386",
    "Farbtonhilfsbezeichnung": "18.09.06",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "215",
    "Bcolor": "192",
    "Y": 71,
    "L": 87.2369995117188,
    "a": 4.51533603668213,
    "b": 13.1800146102905,
    "C": 13.9320154190063,
    "h": 71.0890731811523,
    "CMY_C": 0.06936693191528,
    "CMY_M": 0.1567599773407,
    "CMY_Y": 0.24566447734833,
    "CMYK_C": 0,
    "CMYK_M": 0.09390709549189,
    "CMYK_Y": 0.18943829834461,
    "CMYK_K": 0.06936693191528
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1387",
    "Farbtonhilfsbezeichnung": "09.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "178",
    "Y": 78.521125793457,
    "L": 91.0171813964844,
    "a": 3.99447536468506,
    "b": 26.1793479919434,
    "C": 26.4823360443115,
    "h": 81.3246536254883,
    "CMY_C": 0,
    "CMY_M": 0.11669480800629,
    "CMY_Y": 0.302017390728,
    "CMYK_C": 0,
    "CMYK_M": 0.11669480800629,
    "CMYK_Y": 0.302017390728,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1388",
    "Farbtonhilfsbezeichnung": "03.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "237",
    "Bcolor": "217",
    "Y": 84.9914016723633,
    "L": 93.8794097900391,
    "a": -0.17250497639179,
    "b": 9.99361896514893,
    "C": 9.99510765075684,
    "h": 90.9889144897461,
    "CMY_C": 0.03810924291611,
    "CMY_M": 0.07075017690659,
    "CMY_Y": 0.15070360898972,
    "CMYK_C": 0,
    "CMYK_M": 0.03393413871527,
    "CMYK_Y": 0.1170552521944,
    "CMYK_K": 0.03810924291611
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1389",
    "Farbtonhilfsbezeichnung": "42.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "174",
    "Bcolor": "171",
    "Y": 42,
    "L": 71.2202072143555,
    "a": 1.12303280830383,
    "b": 1.32387614250183,
    "C": 1.73604452610016,
    "h": 49.6923446655273,
    "CMY_C": 0.30360132455826,
    "CMY_M": 0.31870800256729,
    "CMY_Y": 0.33074527978897,
    "CMYK_C": 0,
    "CMYK_M": 0.02169257216156,
    "CMYK_Y": 0.03897760808468,
    "CMYK_K": 0.30360132455826
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1390",
    "Farbtonhilfsbezeichnung": "12.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "177",
    "Bcolor": "160",
    "Y": 46,
    "L": 73.2213973999023,
    "a": 3.93536782264709,
    "b": 10.5237407684326,
    "C": 11.2354898452759,
    "h": 69.4966430664063,
    "CMY_C": 0.23567938804626,
    "CMY_M": 0.3063805103302,
    "CMY_Y": 0.37443882226944,
    "CMYK_C": 0,
    "CMYK_M": 0.09250191599131,
    "CMYK_Y": 0.18154610693455,
    "CMYK_K": 0.23567938804626
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1391",
    "Farbtonhilfsbezeichnung": "12.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "225",
    "Bcolor": "179",
    "Y": 77.7628021240234,
    "L": 90.6715545654297,
    "a": 3.21052408218384,
    "b": 25.1693115234375,
    "C": 25.3732471466064,
    "h": 82.7307739257813,
    "CMY_C": 0.01031094789505,
    "CMY_M": 0.11838138103485,
    "CMY_Y": 0.29825711250305,
    "CMYK_C": 0,
    "CMYK_M": 0.10919634997845,
    "CMYK_Y": 0.29094609618187,
    "CMYK_K": 0.01031094789505
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1392",
    "Farbtonhilfsbezeichnung": "84.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "233",
    "Bcolor": "171",
    "Y": 74.3,
    "L": 90.001838684082,
    "a": -14.6261644363403,
    "b": 27.7304229736328,
    "C": 31.3512535095215,
    "h": 117.80899810791,
    "CMY_C": 0.14337676763535,
    "CMY_M": 0.08554357290268,
    "CMY_Y": 0.32798963785172,
    "CMYK_C": 0.06324324756861,
    "CMYK_M": 0,
    "CMYK_Y": 0.26512587070465,
    "CMYK_K": 0.08554357290268
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1393",
    "Farbtonhilfsbezeichnung": "90.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "237",
    "Bcolor": "217",
    "Y": 84.3701629638672,
    "L": 93.6110382080078,
    "a": -1.65324950218201,
    "b": 9.13848781585693,
    "C": 9.28682899475098,
    "h": 100.254501342773,
    "CMY_C": 0.05512863397598,
    "CMY_M": 0.07001411914825,
    "CMY_Y": 0.14748847484589,
    "CMYK_C": 0,
    "CMYK_M": 0.015753980726,
    "CMYK_Y": 0.09774858504534,
    "CMYK_K": 0.05512863397598
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1394",
    "Farbtonhilfsbezeichnung": "12.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "183",
    "Bcolor": "172",
    "Y": 47.8069763183594,
    "L": 74.7030181884766,
    "a": 0.58543545007706,
    "b": 5.77084827423096,
    "C": 5.8004674911499,
    "h": 84.2073364257813,
    "CMY_C": 0.25674796104431,
    "CMY_M": 0.28159987926483,
    "CMY_Y": 0.32572543621063,
    "CMYK_C": 0,
    "CMYK_M": 0.03343673050404,
    "CMYK_Y": 0.09280496090651,
    "CMYK_K": 0.25674796104431
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1395",
    "Farbtonhilfsbezeichnung": "12.03.21",
    "Farbtonklasse": "01",
    "Rcolor": "135",
    "Gcolor": "132",
    "Bcolor": "126",
    "Y": 23.1,
    "L": 55.3093414306641,
    "a": 0.21308661997318,
    "b": 3.08296370506287,
    "C": 3.09031891822815,
    "h": 86.0461502075195,
    "CMY_C": 0.46990162134171,
    "CMY_M": 0.48156493902206,
    "CMY_Y": 0.50541830062866,
    "CMYK_C": 0,
    "CMYK_M": 0.02200217545033,
    "CMYK_Y": 0.0670001655817,
    "CMYK_K": 0.46990162134171
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1396",
    "Farbtonhilfsbezeichnung": "03.15.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "235",
    "Bcolor": "183",
    "Y": 85,
    "L": 93.2325057983398,
    "a": -1.85803258419037,
    "b": 26.3432388305664,
    "C": 26.4086818695068,
    "h": 94.0344848632812,
    "CMY_C": 0.01447230577469,
    "CMY_M": 0.07785886526108,
    "CMY_Y": 0.28076285123825,
    "CMYK_C": 0,
    "CMYK_M": 0.0643173828721,
    "CMYK_Y": 0.2702009677887,
    "CMYK_K": 0.01447230577469
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1397",
    "Farbtonhilfsbezeichnung": "09.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "229",
    "Bcolor": "184",
    "Y": 80.3789291381836,
    "L": 91.8546142578125,
    "a": 1.18205738067627,
    "b": 23.9998950958252,
    "C": 24.0289878845215,
    "h": 87.180305480957,
    "CMY_C": 0.01384246349335,
    "CMY_M": 0.10002225637436,
    "CMY_Y": 0.27724802494049,
    "CMYK_C": 0,
    "CMYK_M": 0.08738947659731,
    "CMYK_Y": 0.26710292696953,
    "CMYK_K": 0.01384246349335
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1398",
    "Farbtonhilfsbezeichnung": "03.15.03",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "228",
    "Bcolor": "162",
    "Y": 78.9948959350586,
    "L": 91.2319793701172,
    "a": -0.52776426076889,
    "b": 34.8642616271973,
    "C": 34.8682556152344,
    "h": 90.8672561645508,
    "CMY_C": 0.00943666696548,
    "CMY_M": 0.10508000850677,
    "CMY_Y": 0.366470515728,
    "CMYK_C": 0,
    "CMYK_M": 0.09655449539423,
    "CMYK_Y": 0.3604351580143,
    "CMYK_K": 0.00943666696548
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1399",
    "Farbtonhilfsbezeichnung": "18.18.12",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "171",
    "Bcolor": "118",
    "Y": 51.9087791442871,
    "L": 77.2262573242188,
    "a": 25.6556358337402,
    "b": 39.3994827270508,
    "C": 47.016284942627,
    "h": 56.9291572570801,
    "CMY_C": 0,
    "CMY_M": 0.32772701978683,
    "CMY_Y": 0.53820079565048,
    "CMYK_C": 0,
    "CMYK_M": 0.32772701978683,
    "CMYK_Y": 0.53820079565048,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1400",
    "Farbtonhilfsbezeichnung": "21.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "182",
    "Bcolor": "149",
    "Y": 54.4984283447266,
    "L": 78.7514724731445,
    "a": 18.5474224090576,
    "b": 24.4812412261963,
    "C": 30.7138080596924,
    "h": 52.8517837524414,
    "CMY_C": 0.04710423946381,
    "CMY_M": 0.28804177045822,
    "CMY_Y": 0.41483664512634,
    "CMYK_C": 0,
    "CMYK_M": 0.25284773111343,
    "CMYK_Y": 0.38591042160988,
    "CMYK_K": 0.04710423946381
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1401",
    "Farbtonhilfsbezeichnung": "69.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "234",
    "Bcolor": "232",
    "Y": 77.5020141601563,
    "L": 90.5521774291992,
    "a": -10.0138282775879,
    "b": -3.33903527259827,
    "C": 10.5558471679688,
    "h": 198.440582275391,
    "CMY_C": 0.20238673686981,
    "CMY_M": 0.08184319734573,
    "CMY_Y": 0.08965289592743,
    "CMYK_C": 0.13128861784935,
    "CMYK_M": 0,
    "CMYK_Y": 0.00850584451109,
    "CMYK_K": 0.08184319734573
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1402",
    "Farbtonhilfsbezeichnung": "87.12.09",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "218",
    "Bcolor": "142",
    "Y": 66.7321472167969,
    "L": 85.3684997558594,
    "a": -12.2331008911133,
    "b": 36.4545440673828,
    "C": 38.4523429870605,
    "h": 108.550277709961,
    "CMY_C": 0.1565620303154,
    "CMY_M": 0.14378303289413,
    "CMY_Y": 0.44227474927902,
    "CMYK_C": 0.01492495276034,
    "CMYK_M": 0,
    "CMYK_Y": 0.34861692786217,
    "CMYK_K": 0.14378303289413
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1403",
    "Farbtonhilfsbezeichnung": "09.15.02",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "232",
    "Bcolor": "198",
    "Y": 82.8984298706055,
    "L": 92.9699554443359,
    "a": 2.09397625923157,
    "b": 18.6368350982666,
    "C": 18.7541027069092,
    "h": 83.5893096923828,
    "CMY_C": 0.00763607025146,
    "CMY_M": 0.08856135606766,
    "CMY_Y": 0.22487181425095,
    "CMYK_C": 0,
    "CMYK_M": 0.08154799044132,
    "CMYK_Y": 0.21890734136105,
    "CMYK_K": 0.00763607025146
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1404",
    "Farbtonhilfsbezeichnung": "42.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "122",
    "Bcolor": "120",
    "Y": 19.7,
    "L": 51.2240600585938,
    "a": 0.66305786371231,
    "b": 0.62054640054703,
    "C": 0.90814292430878,
    "h": 43.1031227111816,
    "CMY_C": 0.51496684551239,
    "CMY_M": 0.52274441719055,
    "CMY_Y": 0.52936112880707,
    "CMYK_C": 0,
    "CMYK_M": 0.01603513397276,
    "CMYK_Y": 0.02967690676451,
    "CMYK_K": 0.51496684551239
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1405",
    "Farbtonhilfsbezeichnung": "18.09.03",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "209",
    "Y": 80.0334625244141,
    "L": 91.6998748779297,
    "a": 3.00720262527466,
    "b": 10.6861639022827,
    "C": 11.1012325286865,
    "h": 74.2828216552734,
    "CMY_C": 0.03677743673325,
    "CMY_M": 0.10298669338226,
    "CMY_Y": 0.17919433116913,
    "CMYK_C": 0,
    "CMYK_M": 0.06873723864555,
    "CMYK_Y": 0.14785461127758,
    "CMYK_K": 0.03677743673325
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1406",
    "Farbtonhilfsbezeichnung": "15.15.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "239",
    "Bcolor": "222",
    "Y": 87.1081848144531,
    "L": 94.7841567993164,
    "a": 1.1572972536087,
    "b": 8.47912979125977,
    "C": 8.55774402618408,
    "h": 82.2278518676758,
    "CMY_C": 0.02224630117416,
    "CMY_M": 0.06339681148529,
    "CMY_Y": 0.12923264503479,
    "CMYK_C": 0,
    "CMYK_M": 0.04208678379655,
    "CMYK_Y": 0.10942054539919,
    "CMYK_K": 0.02224630117416
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1407",
    "Farbtonhilfsbezeichnung": "15.18.07",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "208",
    "Bcolor": "165",
    "Y": 68.597770690918,
    "L": 86.3044815063477,
    "a": 10.3719501495361,
    "b": 26.4265651702881,
    "C": 28.3890953063965,
    "h": 68.5708847045898,
    "CMY_C": 0.00890684127808,
    "CMY_M": 0.18483328819275,
    "CMY_Y": 0.35235381126404,
    "CMYK_C": 0,
    "CMYK_M": 0.1775074750185,
    "CMYK_Y": 0.34653347730637,
    "CMYK_K": 0.00890684127808
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1408",
    "Farbtonhilfsbezeichnung": "96.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "231",
    "Bcolor": "168",
    "Y": 81.0748672485352,
    "L": 92.1649932861328,
    "a": -1.20223498344421,
    "b": 32.9063415527344,
    "C": 32.928295135498,
    "h": 92.0923767089844,
    "CMY_C": 0.00742423534393,
    "CMY_M": 0.09269642829895,
    "CMY_Y": 0.34182471036911,
    "CMYK_C": 0,
    "CMYK_M": 0.0859100073576,
    "CMYK_Y": 0.33690172433853,
    "CMYK_K": 0.00742423534393
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1409",
    "Farbtonhilfsbezeichnung": "09.18.09",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "213",
    "Bcolor": "142",
    "Y": 70.4159774780273,
    "L": 87.2004852294922,
    "a": 5.80495738983154,
    "b": 39.4233932495117,
    "C": 39.8484802246094,
    "h": 81.6235885620117,
    "CMY_C": 0.00478041172028,
    "CMY_M": 0.16595959663391,
    "CMY_Y": 0.44196504354477,
    "CMYK_C": 0,
    "CMYK_M": 0.16195338964462,
    "CMYK_Y": 0.4392845928669,
    "CMYK_K": 0.00478041172028
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1410",
    "Farbtonhilfsbezeichnung": "96.12.01",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "216",
    "Bcolor": "199",
    "Y": 68.5842132568359,
    "L": 86.297737121582,
    "a": -0.49755492806435,
    "b": 8.11613082885742,
    "C": 8.13136768341064,
    "h": 93.5080947875977,
    "CMY_C": 0.13111793994904,
    "CMY_M": 0.15379917621613,
    "CMY_Y": 0.21934902667999,
    "CMYK_C": 0,
    "CMYK_M": 0.02610393054783,
    "CMYK_Y": 0.1015455275774,
    "CMYK_K": 0.13111793994904
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1411",
    "Farbtonhilfsbezeichnung": "15.03.15",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "166",
    "Bcolor": "154",
    "Y": 39.6,
    "L": 68.8083419799805,
    "a": 2.81096148490906,
    "b": 7.08694648742676,
    "C": 7.62406158447266,
    "h": 68.3647766113281,
    "CMY_C": 0.30017417669296,
    "CMY_M": 0.34950166940689,
    "CMY_Y": 0.39598202705383,
    "CMYK_C": 0,
    "CMYK_M": 0.07048538327217,
    "CMYK_Y": 0.13690242171288,
    "CMYK_K": 0.30017417669296
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1412",
    "Farbtonhilfsbezeichnung": "42.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "232",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.0552825927734,
    "a": 0.10769484937191,
    "b": 1.42176687717438,
    "C": 1.42583978176117,
    "h": 85.6682739257813,
    "CMY_C": 0.08371806144714,
    "CMY_M": 0.08950942754745,
    "CMY_Y": 0.10693699121475,
    "CMYK_C": 0,
    "CMYK_M": 0.00632050679997,
    "CMYK_Y": 0.02534037642181,
    "CMYK_K": 0.08371806144714
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1413",
    "Farbtonhilfsbezeichnung": "15.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "166",
    "Bcolor": "110",
    "Y": 46.4440536499023,
    "L": 73.8327484130859,
    "a": 20.6054439544678,
    "b": 38.6100082397461,
    "C": 43.7643356323242,
    "h": 61.9119911193848,
    "CMY_C": 0.07001984119415,
    "CMY_M": 0.3488844037056,
    "CMY_Y": 0.56752240657806,
    "CMYK_C": 0,
    "CMYK_M": 0.29986077547073,
    "CMYK_Y": 0.53496038913727,
    "CMYK_K": 0.07001984119415
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1414",
    "Farbtonhilfsbezeichnung": "18.09.09",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "200",
    "Bcolor": "175",
    "Y": 62,
    "L": 82.5546798706055,
    "a": 7.80762529373169,
    "b": 15.7229995727539,
    "C": 17.5548210144043,
    "h": 63.5922241210938,
    "CMY_C": 0.09259331226349,
    "CMY_M": 0.2167729139328,
    "CMY_Y": 0.31356924772263,
    "CMYK_C": 0,
    "CMYK_M": 0.13685110211372,
    "CMYK_Y": 0.24352470040321,
    "CMYK_K": 0.09259331226349
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1415",
    "Farbtonhilfsbezeichnung": "15.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "221",
    "Y": 82.6029968261719,
    "L": 92.8403472900391,
    "a": 0.77309459447861,
    "b": 5.94667053222656,
    "C": 5.99671268463135,
    "h": 82.5928268432617,
    "CMY_C": 0.05496823787689,
    "CMY_M": 0.08358055353165,
    "CMY_Y": 0.13180309534073,
    "CMYK_C": 0,
    "CMYK_M": 0.03027656488121,
    "CMYK_Y": 0.08130399137735,
    "CMYK_K": 0.05496823787689
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1416",
    "Farbtonhilfsbezeichnung": "12.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "216",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.514892578125,
    "a": 1.19634509086609,
    "b": 5.25432729721069,
    "C": 5.38880300521851,
    "h": 77.1731338500977,
    "CMY_C": 0.12459772825241,
    "CMY_M": 0.15464675426483,
    "CMY_Y": 0.19576507806778,
    "CMYK_C": 0,
    "CMYK_M": 0.03432596474886,
    "CMYK_Y": 0.08129674196243,
    "CMYK_K": 0.12459772825241
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1417",
    "Farbtonhilfsbezeichnung": "12.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "166",
    "Bcolor": "157",
    "Y": 39,
    "L": 68.4758148193359,
    "a": 0.62470704317093,
    "b": 4.90630674362183,
    "C": 4.94591808319092,
    "h": 82.7437286376953,
    "CMY_C": 0.32544618844986,
    "CMY_M": 0.34745281934738,
    "CMY_Y": 0.3844810128212,
    "CMYK_C": 0,
    "CMYK_M": 0.03262398019433,
    "CMYK_Y": 0.08751685172319,
    "CMYK_K": 0.32544618844986
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1418",
    "Farbtonhilfsbezeichnung": "63.06.15",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "183",
    "Bcolor": "192",
    "Y": 46,
    "L": 73.5912933349609,
    "a": -2.29541540145874,
    "b": -6.93401145935059,
    "C": 7.30407047271729,
    "h": 251.683547973633,
    "CMY_C": 0.33405536413193,
    "CMY_M": 0.28347444534302,
    "CMY_Y": 0.2477560043335,
    "CMYK_C": 0.11472256481647,
    "CMYK_M": 0.04748252034187,
    "CMYK_Y": 0,
    "CMYK_K": 0.2477560043335
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1419",
    "Farbtonhilfsbezeichnung": "24.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "127",
    "Bcolor": "104",
    "Y": 32,
    "L": 63.6098480224609,
    "a": 35.9282569885254,
    "b": 28.554557800293,
    "C": 45.8933792114258,
    "h": 38.4764823913574,
    "CMY_C": 0.11600798368454,
    "CMY_M": 0.50093936920166,
    "CMY_Y": 0.59111177921295,
    "CMYK_C": 0,
    "CMYK_M": 0.43544667959213,
    "CMYK_Y": 0.53745257854462,
    "CMYK_K": 0.11600798368454
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1420",
    "Farbtonhilfsbezeichnung": "12.03.27",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "98",
    "Bcolor": "92",
    "Y": 12,
    "L": 41.9061279296875,
    "a": 1.17771315574646,
    "b": 3.8507981300354,
    "C": 4.02686643600464,
    "h": 72.9944763183594,
    "CMY_C": 0.59378457069397,
    "CMY_M": 0.6153472661972,
    "CMY_Y": 0.63978636264801,
    "CMYK_C": 0,
    "CMYK_M": 0.0530819222331,
    "CMYK_Y": 0.11324481666088,
    "CMYK_K": 0.59378457069397
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1421",
    "Farbtonhilfsbezeichnung": "03.15.01",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "238",
    "Bcolor": "195",
    "Y": 85.7013854980469,
    "L": 94.1845245361328,
    "a": -2.08636069297791,
    "b": 21.7909526824951,
    "C": 21.890604019165,
    "h": 95.4690780639648,
    "CMY_C": 0.01642751693726,
    "CMY_M": 0.06564116477966,
    "CMY_Y": 0.23620331287384,
    "CMYK_C": 0,
    "CMYK_M": 0.05003560706973,
    "CMYK_Y": 0.22344647347927,
    "CMYK_K": 0.01642751693726
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1422",
    "Farbtonhilfsbezeichnung": "90.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "208",
    "Bcolor": "191",
    "Y": 62.9931793212891,
    "L": 83.4387893676758,
    "a": -1.67179667949677,
    "b": 8.03621768951416,
    "C": 8.20827007293701,
    "h": 101.75178527832,
    "CMY_C": 0.17180627584457,
    "CMY_M": 0.18245702981949,
    "CMY_Y": 0.2496857047081,
    "CMYK_C": 0,
    "CMYK_M": 0.01286022085696,
    "CMYK_Y": 0.09403528273106,
    "CMYK_K": 0.17180627584457
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1423",
    "Farbtonhilfsbezeichnung": "36.09.36",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "58",
    "Bcolor": "66",
    "Y": 4,
    "L": 26.8532962799072,
    "a": 9.76322746276855,
    "b": -1.86566913127899,
    "C": 9.93988609313965,
    "h": 349.181701660156,
    "CMY_C": 0.69803082942963,
    "CMY_M": 0.7708113193512,
    "CMY_Y": 0.74125391244888,
    "CMYK_C": 0,
    "CMYK_M": 0.24101960659027,
    "CMYK_Y": 0.14313741028309,
    "CMYK_K": 0.69803082942963
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1424",
    "Farbtonhilfsbezeichnung": "42.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "210",
    "Bcolor": "206",
    "Y": 64.7159805297852,
    "L": 84.3371658325195,
    "a": 0.70478874444962,
    "b": 1.62519955635071,
    "C": 1.77144026756287,
    "h": 66.5554122924805,
    "CMY_C": 0.16396820545197,
    "CMY_M": 0.17643094062805,
    "CMY_Y": 0.19295281171799,
    "CMYK_C": 0,
    "CMYK_M": 0.01490701083094,
    "CMYK_Y": 0.03466926142573,
    "CMYK_K": 0.16396820545197
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1425",
    "Farbtonhilfsbezeichnung": "27.12.19",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "132",
    "Bcolor": "121",
    "Y": 29.3,
    "L": 60.6936531066895,
    "a": 21.5692367553711,
    "b": 14.5967903137207,
    "C": 26.0441589355469,
    "h": 34.0878295898438,
    "CMY_C": 0.25147390365601,
    "CMY_M": 0.48285168409348,
    "CMY_Y": 0.52656561136246,
    "CMYK_C": 0,
    "CMYK_M": 0.3091111779213,
    "CMYK_Y": 0.36751118302345,
    "CMYK_K": 0.25147390365601
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1426",
    "Farbtonhilfsbezeichnung": "15.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "223",
    "Bcolor": "211",
    "Y": 74,
    "L": 89.2340545654297,
    "a": 1.39039325714111,
    "b": 6.21641111373901,
    "C": 6.37000465393066,
    "h": 77.3924407958984,
    "CMY_C": 0.08986920118332,
    "CMY_M": 0.12530714273453,
    "CMY_Y": 0.17322891950607,
    "CMYK_C": 0,
    "CMYK_M": 0.03893719613552,
    "CMYK_Y": 0.09159091860056,
    "CMYK_K": 0.08986920118332
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1427",
    "Farbtonhilfsbezeichnung": "27.09.19",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "145",
    "Bcolor": "133",
    "Y": 33.2,
    "L": 63.7789764404297,
    "a": 14.9241161346435,
    "b": 12.1242513656616,
    "C": 19.2282791137695,
    "h": 39.0901718139648,
    "CMY_C": 0.26245588064194,
    "CMY_M": 0.43266940116882,
    "CMY_Y": 0.48012894392014,
    "CMYK_C": 0,
    "CMYK_M": 0.23078419268131,
    "CMYK_Y": 0.29513224959373,
    "CMYK_K": 0.26245588064194
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1428",
    "Farbtonhilfsbezeichnung": "66.03.03",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "226",
    "Bcolor": "218",
    "Y": 75.6,
    "L": 89.4705123901367,
    "a": -1.90504312515259,
    "b": 2.80707406997681,
    "C": 3.39247012138367,
    "h": 124.1630859375,
    "CMY_C": 0.12373793125153,
    "CMY_M": 0.1139662861824,
    "CMY_Y": 0.14595550298691,
    "CMYK_C": 0.01102852541953,
    "CMYK_M": 0,
    "CMYK_Y": 0.03610383719206,
    "CMYK_K": 0.1139662861824
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1429",
    "Farbtonhilfsbezeichnung": "21.18.16",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "154",
    "Bcolor": "101",
    "Y": 49,
    "L": 73.5154190063477,
    "a": 34.9354934692383,
    "b": 43.5661735534668,
    "C": 55.8435325622559,
    "h": 51.2740516662598,
    "CMY_C": 0,
    "CMY_M": 0.39699840545654,
    "CMY_Y": 0.60350167751312,
    "CMYK_C": 0,
    "CMYK_M": 0.39699840545654,
    "CMYK_Y": 0.60350167751312,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1430",
    "Farbtonhilfsbezeichnung": "21.16.18",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "125",
    "Bcolor": "89",
    "Y": 30.564208984375,
    "L": 62.1380157470703,
    "a": 33.2083511352539,
    "b": 35.1068115234375,
    "C": 48.324764251709,
    "h": 46.5918235778809,
    "CMY_C": 0.14073747396469,
    "CMY_M": 0.50818079710007,
    "CMY_Y": 0.65217638015747,
    "CMYK_C": 0,
    "CMYK_M": 0.42762637138367,
    "CMYK_Y": 0.59520679712296,
    "CMYK_K": 0.14073747396469
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1431",
    "Farbtonhilfsbezeichnung": "66.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "187",
    "Bcolor": "188",
    "Y": 47.9662780761719,
    "L": 74.8036575317383,
    "a": -3.75754690170288,
    "b": -2.89053440093994,
    "C": 4.74071168899536,
    "h": 217.569686889648,
    "CMY_C": 0.31765615940094,
    "CMY_M": 0.26843857765198,
    "CMY_Y": 0.26366502046585,
    "CMYK_C": 0.07332415133715,
    "CMYK_M": 0.00648286100477,
    "CMYK_Y": 0,
    "CMYK_K": 0.26366502046585
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1432",
    "Farbtonhilfsbezeichnung": "12.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "156",
    "Bcolor": "148",
    "Y": 33.9,
    "L": 64.5124969482422,
    "a": 0.20381025969982,
    "b": 4.00565242767334,
    "C": 4.01083421707153,
    "h": 87.0872650146484,
    "CMY_C": 0.37274312973022,
    "CMY_M": 0.3876610994339,
    "CMY_Y": 0.41899716854095,
    "CMYK_C": 0,
    "CMYK_M": 0.02378287166357,
    "CMYK_Y": 0.0737401843071,
    "CMYK_K": 0.37274312973022
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1433",
    "Farbtonhilfsbezeichnung": "21.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "93",
    "Bcolor": "87",
    "Y": 11.8,
    "L": 40.6688957214355,
    "a": 5.17976951599121,
    "b": 5.2586555480957,
    "C": 7.38129186630249,
    "h": 45.432991027832,
    "CMY_C": 0.57717370986938,
    "CMY_M": 0.63597476482391,
    "CMY_Y": 0.65972709655762,
    "CMYK_C": 0,
    "CMYK_M": 0.13906669616699,
    "CMYK_Y": 0.19524185359478,
    "CMYK_K": 0.57717370986938
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1434",
    "Farbtonhilfsbezeichnung": "57.06.15",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "183",
    "Bcolor": "192",
    "Y": 47.2,
    "L": 73.8057250976563,
    "a": -2.44285917282104,
    "b": -6.72800636291504,
    "C": 7.1577672958374,
    "h": 250.044647216797,
    "CMY_C": 0.3321830034256,
    "CMY_M": 0.28091722726822,
    "CMY_Y": 0.24693518877029,
    "CMYK_C": 0.11320116370916,
    "CMYK_M": 0.04512498527765,
    "CMYK_Y": 0,
    "CMYK_K": 0.24693518877029
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1435",
    "Farbtonhilfsbezeichnung": "18.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "156",
    "Y": 63.4802055358887,
    "L": 83.6943969726563,
    "a": 18.9180641174316,
    "b": 27.6992607116699,
    "C": 33.543140411377,
    "h": 55.6676750183105,
    "CMY_C": 0,
    "CMY_M": 0.23647099733353,
    "CMY_Y": 0.38723790645599,
    "CMYK_C": 0,
    "CMYK_M": 0.23647099733353,
    "CMYK_Y": 0.38723790645599,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1436",
    "Farbtonhilfsbezeichnung": "15.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "149",
    "Bcolor": "141",
    "Y": 31.2,
    "L": 62.3395614624023,
    "a": 2.68986296653748,
    "b": 5.04870653152466,
    "C": 5.72055959701538,
    "h": 61.9520835876465,
    "CMY_C": 0.37486392259598,
    "CMY_M": 0.41595333814621,
    "CMY_Y": 0.44792604446411,
    "CMYK_C": 0,
    "CMYK_M": 0.06572875380516,
    "CMYK_Y": 0.11687394976616,
    "CMYK_K": 0.37486392259598
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1437",
    "Farbtonhilfsbezeichnung": "21.16.24",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "95",
    "Bcolor": "65",
    "Y": 20,
    "L": 51.4177703857422,
    "a": 36.6884689331055,
    "b": 34.2284545898438,
    "C": 50.1759986877441,
    "h": 43.0132789611816,
    "CMY_C": 0.24968433380127,
    "CMY_M": 0.6286209821701,
    "CMY_Y": 0.7448570728302,
    "CMYK_C": 0,
    "CMYK_M": 0.5050362944603,
    "CMYK_Y": 0.6599525809288,
    "CMYK_K": 0.24968433380127
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1438",
    "Farbtonhilfsbezeichnung": "60.09.19",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "149",
    "Bcolor": "168",
    "Y": 28.8718547821045,
    "L": 60.6683654785156,
    "a": -3.65644526481628,
    "b": -13.352105140686,
    "C": 13.8437099456787,
    "h": 254.685134887695,
    "CMY_C": 0.50661599636078,
    "CMY_M": 0.41420167684555,
    "CMY_Y": 0.34016442298889,
    "CMYK_C": 0.25226220488548,
    "CMYK_M": 0.11220560967922,
    "CMYK_Y": 0,
    "CMYK_K": 0.34016442298889
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1439",
    "Farbtonhilfsbezeichnung": "84.15.12",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "224",
    "Bcolor": "153",
    "Y": 68.1336135864258,
    "L": 86.0732192993164,
    "a": -18.4597606658936,
    "b": 31.6014022827148,
    "C": 36.5979690551758,
    "h": 120.291061401367,
    "CMY_C": 0.20694774389267,
    "CMY_M": 0.12207365036011,
    "CMY_Y": 0.39926260709763,
    "CMYK_C": 0.09667564183474,
    "CMYK_M": 0,
    "CMYK_Y": 0.31573143601418,
    "CMYK_K": 0.12207365036011
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1440",
    "Farbtonhilfsbezeichnung": "66.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "223",
    "Bcolor": "216",
    "Y": 72.5924530029297,
    "L": 88.2529830932617,
    "a": -2.09301710128784,
    "b": 2.00716495513916,
    "C": 2.89990210533142,
    "h": 136.199523925781,
    "CMY_C": 0.14141297340393,
    "CMY_M": 0.12682580947876,
    "CMY_Y": 0.15343397855759,
    "CMYK_C": 0.01670590415597,
    "CMYK_M": 0,
    "CMYK_Y": 0.03047292120755,
    "CMYK_K": 0.12682580947876
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1441",
    "Farbtonhilfsbezeichnung": "21.06.33",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "65",
    "Bcolor": "62",
    "Y": 5.6618504524231,
    "L": 28.5427951812744,
    "a": 3.78359627723694,
    "b": 3.18275189399719,
    "C": 4.9442400932312,
    "h": 40.0704650878906,
    "CMY_C": 0.70511388778687,
    "CMY_M": 0.74407875537872,
    "CMY_Y": 0.75684297084808,
    "CMYK_C": 0,
    "CMYK_M": 0.13213530182838,
    "CMYK_Y": 0.17542055249214,
    "CMYK_K": 0.70511388778687
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1442",
    "Farbtonhilfsbezeichnung": "18.06.33",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "66",
    "Bcolor": "63",
    "Y": 5.65735340118408,
    "L": 28.5310001373291,
    "a": 2.67578983306885,
    "b": 2.7345757484436,
    "C": 3.82593202590942,
    "h": 45.6225166320801,
    "CMY_C": 0.71276211738586,
    "CMY_M": 0.74183392524719,
    "CMY_Y": 0.75441980361938,
    "CMYK_C": 0,
    "CMYK_M": 0.10121160745621,
    "CMYK_Y": 0.14502853155136,
    "CMYK_K": 0.71276211738586
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1443",
    "Farbtonhilfsbezeichnung": "18.06.17",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "160",
    "Bcolor": "154",
    "Y": 36.7,
    "L": 66.6913528442383,
    "a": 2.8405659198761,
    "b": 4.01502847671509,
    "C": 4.91825866699219,
    "h": 54.7212295532227,
    "CMY_C": 0.33102452754974,
    "CMY_M": 0.37094181776047,
    "CMY_Y": 0.39635902643204,
    "CMYK_C": 0,
    "CMYK_M": 0.05966928973794,
    "CMYK_Y": 0.09766352176666,
    "CMYK_K": 0.33102452754974
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1444",
    "Farbtonhilfsbezeichnung": "66.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "211",
    "Bcolor": "209",
    "Y": 63.9321746826172,
    "L": 83.9304428100586,
    "a": -2.85565328598022,
    "b": -0.94329297542572,
    "C": 3.00741696357727,
    "h": 198.279678344727,
    "CMY_C": 0.20522499084473,
    "CMY_M": 0.17193865776062,
    "CMY_Y": 0.17915117740631,
    "CMYK_C": 0.04019790887833,
    "CMYK_M": 0,
    "CMYK_Y": 0.00871012732387,
    "CMYK_K": 0.17193865776062
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1445",
    "Farbtonhilfsbezeichnung": "57.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "207",
    "Bcolor": "215",
    "Y": 62.6,
    "L": 82.6646499633789,
    "a": -1.81114530563354,
    "b": -5.93897819519043,
    "C": 6.20900249481201,
    "h": 253.040435791016,
    "CMY_C": 0.22906893491745,
    "CMY_M": 0.18673974275589,
    "CMY_Y": 0.15652984380722,
    "CMYK_C": 0.08600077778101,
    "CMYK_M": 0.03581620380282,
    "CMYK_Y": 0,
    "CMYK_K": 0.15652984380722
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1446",
    "Farbtonhilfsbezeichnung": "12.03.24",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "116",
    "Bcolor": "110",
    "Y": 17.5,
    "L": 49.2503547668457,
    "a": 0.86807429790497,
    "b": 3.78493738174438,
    "C": 3.88320803642273,
    "h": 77.0826263427734,
    "CMY_C": 0.52411830425262,
    "CMY_M": 0.54346370697021,
    "CMY_Y": 0.56937891244888,
    "CMYK_C": 0,
    "CMYK_M": 0.04065170511603,
    "CMYK_Y": 0.09510894864798,
    "CMYK_K": 0.52411830425262
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1447",
    "Farbtonhilfsbezeichnung": "42.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "220",
    "Bcolor": "216",
    "Y": 71.7343368530273,
    "L": 87.8405609130859,
    "a": 0.37250602245331,
    "b": 1.20738840103149,
    "C": 1.26354563236237,
    "h": 72.8538513183594,
    "CMY_C": 0.12927120923996,
    "CMY_M": 0.13694161176682,
    "CMY_Y": 0.15172839164734,
    "CMYK_C": 0,
    "CMYK_M": 0.00880917534232,
    "CMYK_Y": 0.02579124830663,
    "CMYK_K": 0.12927120923996
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1448",
    "Farbtonhilfsbezeichnung": "03.12.16",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "161",
    "Bcolor": "98",
    "Y": 37.9782676696777,
    "L": 68.0045928955078,
    "a": 4.39101409912109,
    "b": 36.8894462585449,
    "C": 37.1498603820801,
    "h": 83.2119216918945,
    "CMY_C": 0.23768728971481,
    "CMY_M": 0.36760622262955,
    "CMY_Y": 0.61642229557037,
    "CMYK_C": 0,
    "CMYK_M": 0.17042735219002,
    "CMYK_Y": 0.49682366847992,
    "CMYK_K": 0.23768728971481
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1449",
    "Farbtonhilfsbezeichnung": "27.09.33",
    "Farbtonklasse": "04",
    "Rcolor": "86",
    "Gcolor": "63",
    "Bcolor": "64",
    "Y": 5.1,
    "L": 29.1958465576172,
    "a": 10.0679292678833,
    "b": 3.0106029510498,
    "C": 10.5084218978882,
    "h": 16.6481895446777,
    "CMY_C": 0.66400575637817,
    "CMY_M": 0.75198155641556,
    "CMY_Y": 0.74926209449768,
    "CMYK_C": 0,
    "CMYK_M": 0.26183721423149,
    "CMYK_Y": 0.2537434399128,
    "CMYK_K": 0.66400575637817
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1450",
    "Farbtonhilfsbezeichnung": "81.12.06",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "232",
    "Bcolor": "174",
    "Y": 75.5,
    "L": 89.170036315918,
    "a": -17.2135486602783,
    "b": 25.3821487426758,
    "C": 30.6685466766357,
    "h": 124.144149780273,
    "CMY_C": 0.17933160066605,
    "CMY_M": 0.08892279863358,
    "CMY_Y": 0.31952482461929,
    "CMYK_C": 0.09923286736012,
    "CMYK_M": 0,
    "CMYK_Y": 0.25310921669006,
    "CMYK_K": 0.08892279863358
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1451",
    "Farbtonhilfsbezeichnung": "18.09.25",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "86",
    "Bcolor": "71",
    "Y": 11.2108430862427,
    "L": 39.9333381652832,
    "a": 12.4443969726563,
    "b": 14.0648517608643,
    "C": 18.7798576354981,
    "h": 48.4980163574219,
    "CMY_C": 0.52586770057678,
    "CMY_M": 0.661736369133,
    "CMY_Y": 0.72103023529053,
    "CMYK_C": 0,
    "CMYK_M": 0.28656277060509,
    "CMYK_Y": 0.41162040829659,
    "CMYK_K": 0.52586770057678
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1452",
    "Farbtonhilfsbezeichnung": "63.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "158",
    "Bcolor": "166",
    "Y": 33.8,
    "L": 64.2175750732422,
    "a": -2.33646512031555,
    "b": -6.7801775932312,
    "C": 7.17146253585815,
    "h": 250.985931396484,
    "CMY_C": 0.43150907754898,
    "CMY_M": 0.38225221633911,
    "CMY_Y": 0.34800481796265,
    "CMYK_C": 0.12807495892048,
    "CMYK_M": 0.05252707377076,
    "CMYK_Y": 0,
    "CMYK_K": 0.34800481796265
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1453",
    "Farbtonhilfsbezeichnung": "93.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "214",
    "Y": 83.6,
    "L": 93.0683135986328,
    "a": -0.49732971191406,
    "b": 9.91226005554199,
    "C": 9.92472839355469,
    "h": 92.8722991943359,
    "CMY_C": 0.04999911785126,
    "CMY_M": 0.07904320955276,
    "CMY_Y": 0.15903371572495,
    "CMYK_C": 0,
    "CMYK_M": 0.0305726993829,
    "CMYK_Y": 0.11477315425873,
    "CMYK_K": 0.04999911785126
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1454",
    "Farbtonhilfsbezeichnung": "12.03.19",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "145",
    "Bcolor": "139",
    "Y": 28.1,
    "L": 60.3697395324707,
    "a": 0.0521790497005,
    "b": 3.10848450660706,
    "C": 3.10892248153687,
    "h": 89.0383224487305,
    "CMY_C": 0.41937404870987,
    "CMY_M": 0.42982131242752,
    "CMY_Y": 0.45495039224625,
    "CMYK_C": 0,
    "CMYK_M": 0.01799310557544,
    "CMYK_Y": 0.06127239763737,
    "CMYK_K": 0.41937404870987
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1455",
    "Farbtonhilfsbezeichnung": "21.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "78",
    "Bcolor": "73",
    "Y": 8,
    "L": 34.3599586486816,
    "a": 4.46143341064453,
    "b": 4.39917755126953,
    "C": 6.26555252075195,
    "h": 44.5974388122559,
    "CMY_C": 0.64417028427124,
    "CMY_M": 0.69308924674988,
    "CMY_Y": 0.71228468418121,
    "CMYK_C": 0,
    "CMYK_M": 0.13747857511044,
    "CMYK_Y": 0.19142414629459,
    "CMYK_K": 0.64417028427124
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1456",
    "Farbtonhilfsbezeichnung": "75.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "238",
    "Bcolor": "224",
    "Y": 80.6,
    "L": 91.4258575439453,
    "a": -13.1247539520264,
    "b": 2.41613578796387,
    "C": 13.3452939987183,
    "h": 169.569198608398,
    "CMY_C": 0.19686353206635,
    "CMY_M": 0.06688892841339,
    "CMY_Y": 0.12309205532074,
    "CMYK_C": 0.1392916738987,
    "CMYK_M": 0,
    "CMYK_Y": 0.06023197993636,
    "CMYK_K": 0.06688892841339
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1457",
    "Farbtonhilfsbezeichnung": "42.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "200",
    "Bcolor": "197",
    "Y": 58.8,
    "L": 80.7465667724609,
    "a": 0.90576374530792,
    "b": 1.0757132768631,
    "C": 1.40625989437103,
    "h": 49.902214050293,
    "CMY_C": 0.20352005958557,
    "CMY_M": 0.21594440937042,
    "CMY_Y": 0.22776168584824,
    "CMYK_C": 0,
    "CMYK_M": 0.01559907477349,
    "CMYK_Y": 0.03043595328927,
    "CMYK_K": 0.20352005958557
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1458",
    "Farbtonhilfsbezeichnung": "24.18.23",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "100",
    "Bcolor": "81",
    "Y": 21.3,
    "L": 52.7795448303223,
    "a": 35.444221496582,
    "b": 26.859525680542,
    "C": 44.4716415405273,
    "h": 37.1547393798828,
    "CMY_C": 0.24733585119247,
    "CMY_M": 0.60906875133514,
    "CMY_Y": 0.68224722146988,
    "CMYK_C": 0,
    "CMYK_M": 0.4806033372879,
    "CMYK_Y": 0.57782924175262,
    "CMYK_K": 0.24733585119247
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1459",
    "Farbtonhilfsbezeichnung": "15.06.16",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "160",
    "Bcolor": "146",
    "Y": 37.2,
    "L": 67.0674743652344,
    "a": 5.25450944900513,
    "b": 9.19090938568115,
    "C": 10.5869112014771,
    "h": 60.2430801391602,
    "CMY_C": 0.29638683795929,
    "CMY_M": 0.37393587827682,
    "CMY_Y": 0.42813014984131,
    "CMYK_C": 0,
    "CMYK_M": 0.11021544784307,
    "CMYK_Y": 0.18723827600479,
    "CMYK_K": 0.29638683795929
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1460",
    "Farbtonhilfsbezeichnung": "15.03.21",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "131",
    "Bcolor": "124",
    "Y": 23.9,
    "L": 55.564079284668,
    "a": 2.80485153198242,
    "b": 5.03523254394531,
    "C": 5.76374530792236,
    "h": 60.8802223205566,
    "CMY_C": 0.44409650564194,
    "CMY_M": 0.48515212535858,
    "CMY_Y": 0.5156187415123,
    "CMYK_C": 0,
    "CMYK_M": 0.07385386526585,
    "CMYK_Y": 0.12865944206715,
    "CMYK_K": 0.44409650564194
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1461",
    "Farbtonhilfsbezeichnung": "18.09.30",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "69",
    "Bcolor": "61",
    "Y": 7,
    "L": 31.7316226959229,
    "a": 8.85465812683105,
    "b": 8.89386558532715,
    "C": 12.5501317977905,
    "h": 45.1265678405762,
    "CMY_C": 0.63546240329742,
    "CMY_M": 0.72770243883133,
    "CMY_Y": 0.76245427131653,
    "CMYK_C": 0,
    "CMYK_M": 0.2530329823494,
    "CMYK_Y": 0.34836426377296,
    "CMYK_K": 0.63546240329742
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1462",
    "Farbtonhilfsbezeichnung": "15.03.09",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "202",
    "Bcolor": "190",
    "Y": 60.2939682006836,
    "L": 81.9977111816406,
    "a": 2.21876049041748,
    "b": 6.5793251991272,
    "C": 6.94337224960327,
    "h": 71.3642349243164,
    "CMY_C": 0.16288495063782,
    "CMY_M": 0.20691102743149,
    "CMY_Y": 0.25395256280899,
    "CMYK_C": 0,
    "CMYK_M": 0.05259262397885,
    "CMYK_Y": 0.10878744721413,
    "CMYK_K": 0.16288495063782
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1463",
    "Farbtonhilfsbezeichnung": "15.03.24",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "113",
    "Bcolor": "106",
    "Y": 17.2,
    "L": 48.3570747375488,
    "a": 3.40019083023071,
    "b": 4.76689958572388,
    "C": 5.85530757904053,
    "h": 54.5000419616699,
    "CMY_C": 0.5136559009552,
    "CMY_M": 0.55792897939682,
    "CMY_Y": 0.58407938480377,
    "CMYK_C": 0,
    "CMYK_M": 0.09103241562843,
    "CMYK_Y": 0.14480176568031,
    "CMYK_K": 0.5136559009552
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1464",
    "Farbtonhilfsbezeichnung": "21.09.22",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "108",
    "Bcolor": "96",
    "Y": 17.5053596496582,
    "L": 48.8905792236328,
    "a": 13.0761337280273,
    "b": 11.8278713226318,
    "C": 17.6318969726563,
    "h": 42.1305656433105,
    "CMY_C": 0.43354898691177,
    "CMY_M": 0.57707136869431,
    "CMY_Y": 0.62365233898163,
    "CMYK_C": 0,
    "CMYK_M": 0.25337120890617,
    "CMYK_Y": 0.33560422062874,
    "CMYK_K": 0.43354898691177
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1465",
    "Farbtonhilfsbezeichnung": "42.03.27",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "110",
    "Bcolor": "108",
    "Y": 15.7,
    "L": 46.511962890625,
    "a": 0.97935765981674,
    "b": 0.65964990854263,
    "C": 1.18079614639282,
    "h": 33.9623832702637,
    "CMY_C": 0.55913949012756,
    "CMY_M": 0.56974560022354,
    "CMY_Y": 0.57549631595612,
    "CMYK_C": 0,
    "CMYK_M": 0.02405774593353,
    "CMYK_Y": 0.03710204362869,
    "CMYK_K": 0.55913949012756
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1466",
    "Farbtonhilfsbezeichnung": "75.01.09",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "200",
    "Bcolor": "191",
    "Y": 58.3,
    "L": 80.2431793212891,
    "a": -1.53800106048584,
    "b": 3.63870429992676,
    "C": 3.95039439201355,
    "h": 112.912719726563,
    "CMY_C": 0.21939092874527,
    "CMY_M": 0.2164717912674,
    "CMY_Y": 0.25200128555298,
    "CMYK_C": 0.00372563162819,
    "CMYK_M": 0,
    "CMYK_Y": 0.04534551873803,
    "CMYK_K": 0.2164717912674
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1467",
    "Farbtonhilfsbezeichnung": "15.15.09",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "201",
    "Bcolor": "161",
    "Y": 65.1,
    "L": 83.9966583251953,
    "a": 11.3707971572876,
    "b": 25.3999309539795,
    "C": 27.8289699554443,
    "h": 65.8833465576172,
    "CMY_C": 0.031005859375,
    "CMY_M": 0.21239364147186,
    "CMY_Y": 0.368687748909,
    "CMYK_C": 0,
    "CMYK_M": 0.18719182908535,
    "CMYK_Y": 0.34848701953888,
    "CMYK_K": 0.031005859375
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1468",
    "Farbtonhilfsbezeichnung": "18.09.13",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "179",
    "Bcolor": "155",
    "Y": 49.5359992980957,
    "L": 75.783576965332,
    "a": 10.4319114685059,
    "b": 16.8255767822266,
    "C": 19.7970905303955,
    "h": 58.2009582519531,
    "CMY_C": 0.14843934774399,
    "CMY_M": 0.29653602838516,
    "CMY_Y": 0.39176946878433,
    "CMYK_C": 0,
    "CMYK_M": 0.17391207814217,
    "CMYK_Y": 0.2857460975647,
    "CMYK_K": 0.14843934774399
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1469",
    "Farbtonhilfsbezeichnung": "24.18.15",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "149",
    "Bcolor": "120",
    "Y": 43.7,
    "L": 71.3960037231445,
    "a": 34.5730094909668,
    "b": 30.4377746582031,
    "C": 46.0624694824219,
    "h": 41.360408782959,
    "CMY_C": 0.02854561805725,
    "CMY_M": 0.41561096906662,
    "CMY_Y": 0.52845776081085,
    "CMYK_C": 0,
    "CMYK_M": 0.39843904972076,
    "CMYK_Y": 0.51460176706314,
    "CMYK_K": 0.02854561805725
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1470",
    "Farbtonhilfsbezeichnung": "27.13.18",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "140",
    "Bcolor": "128",
    "Y": 34.7,
    "L": 64.9295196533203,
    "a": 25.9698104858398,
    "b": 16.4391956329346,
    "C": 30.7356185913086,
    "h": 32.3342933654785,
    "CMY_C": 0.17480754852295,
    "CMY_M": 0.45272427797318,
    "CMY_Y": 0.49638426303864,
    "CMYK_C": 0,
    "CMYK_M": 0.33679020404816,
    "CMYK_Y": 0.38969904184341,
    "CMYK_K": 0.17480754852295
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1471",
    "Farbtonhilfsbezeichnung": "33.06.17",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "166",
    "Bcolor": "164",
    "Y": 39.7,
    "L": 68.800895690918,
    "a": 3.83499550819397,
    "b": 1.25339531898499,
    "C": 4.03462409973145,
    "h": 18.0989952087402,
    "CMY_C": 0.30971038341522,
    "CMY_M": 0.35043454170227,
    "CMY_Y": 0.35516566038132,
    "CMYK_C": 0,
    "CMYK_M": 0.05899575725198,
    "CMYK_Y": 0.06584957242012,
    "CMYK_K": 0.30971038341522
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1472",
    "Farbtonhilfsbezeichnung": "33.12.17",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "149",
    "Bcolor": "154",
    "Y": 36.7,
    "L": 66.0799102783203,
    "a": 17.9002170562744,
    "b": 3.54259753227234,
    "C": 18.2474040985107,
    "h": 11.1946382522583,
    "CMY_C": 0.23766112327576,
    "CMY_M": 0.41458922624588,
    "CMY_Y": 0.39720964431763,
    "CMYK_C": 0,
    "CMYK_M": 0.23208589851856,
    "CMYK_Y": 0.20928817987442,
    "CMYK_K": 0.23766112327576
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1473",
    "Farbtonhilfsbezeichnung": "57.06.18",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "160",
    "Bcolor": "170",
    "Y": 34.7,
    "L": 65.052734375,
    "a": -2.10716891288757,
    "b": -7.44074535369873,
    "C": 7.73335981369019,
    "h": 254.188232421875,
    "CMY_C": 0.42365556955338,
    "CMY_M": 0.3738597035408,
    "CMY_Y": 0.33468574285507,
    "CMYK_C": 0.13372601568699,
    "CMYK_M": 0.05888038501143,
    "CMYK_Y": 0,
    "CMYK_K": 0.33468574285507
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1474",
    "Farbtonhilfsbezeichnung": "63.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "223",
    "Bcolor": "230",
    "Y": 72.8,
    "L": 88.2762985229492,
    "a": -2.35458064079285,
    "b": -5.23417568206787,
    "C": 5.73939418792725,
    "h": 245.779525756836,
    "CMY_C": 0.16954326629639,
    "CMY_M": 0.12387430667877,
    "CMY_Y": 0.09993189573288,
    "CMYK_C": 0.07734011113644,
    "CMYK_M": 0.02660066634417,
    "CMYK_Y": 0,
    "CMYK_K": 0.09993189573288
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1475",
    "Farbtonhilfsbezeichnung": "63.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "215",
    "Bcolor": "222",
    "Y": 66.3,
    "L": 85.1911163330078,
    "a": -2.37245726585388,
    "b": -5.63941097259521,
    "C": 6.11812973022461,
    "h": 247.183883666992,
    "CMY_C": 0.2050456404686,
    "CMY_M": 0.15781474113464,
    "CMY_Y": 0.13104277849197,
    "CMYK_C": 0.08516283333302,
    "CMYK_M": 0.03080929815769,
    "CMYK_Y": 0,
    "CMYK_K": 0.13104277849197
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1476",
    "Farbtonhilfsbezeichnung": "63.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "205",
    "Bcolor": "213",
    "Y": 59.5188217163086,
    "L": 81.5759429931641,
    "a": -2.50243353843689,
    "b": -6.5859203338623,
    "C": 7.04531908035278,
    "h": 249.194854736328,
    "CMY_C": 0.24905449151993,
    "CMY_M": 0.19687217473984,
    "CMY_Y": 0.16383785009384,
    "CMYK_C": 0.10191401094198,
    "CMYK_M": 0.03950707986951,
    "CMYK_Y": 0,
    "CMYK_K": 0.16383785009384
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1477",
    "Farbtonhilfsbezeichnung": "66.03.12",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "203",
    "Bcolor": "203",
    "Y": 58,
    "L": 80.9678955078125,
    "a": -3.17558097839355,
    "b": -1.7848265171051,
    "C": 3.64279007911682,
    "h": 209.338043212891,
    "CMY_C": 0.2429633140564,
    "CMY_M": 0.20338344573975,
    "CMY_Y": 0.20525616407394,
    "CMYK_C": 0.04968496784568,
    "CMYK_M": 0,
    "CMYK_Y": 0.00235084025189,
    "CMYK_K": 0.20338344573975
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1478",
    "Farbtonhilfsbezeichnung": "66.03.18",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "166",
    "Bcolor": "172",
    "Y": 37,
    "L": 67.2701110839844,
    "a": -3.85740828514099,
    "b": -5.56118869781494,
    "C": 6.76804399490356,
    "h": 235.253662109375,
    "CMY_C": 0.40751856565475,
    "CMY_M": 0.34744703769684,
    "CMY_Y": 0.32466113567352,
    "CMYK_C": 0.12269015610218,
    "CMYK_M": 0.03373995423317,
    "CMYK_Y": 0,
    "CMYK_K": 0.32466113567352
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1479",
    "Farbtonhilfsbezeichnung": "66.06.03",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "232",
    "Bcolor": "231",
    "Y": 78.9,
    "L": 91.0442047119141,
    "a": -4.34409332275391,
    "b": -1.72692227363586,
    "C": 4.67476272583008,
    "h": 201.679473876953,
    "CMY_C": 0.14217537641525,
    "CMY_M": 0.08950620889664,
    "CMY_Y": 0.09539747238159,
    "CMYK_C": 0.05784681811929,
    "CMYK_M": 0,
    "CMYK_Y": 0.006470405031,
    "CMYK_K": 0.08950620889664
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1480",
    "Farbtonhilfsbezeichnung": "69.06.09",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "208",
    "Bcolor": "205",
    "Y": 62.9,
    "L": 82.6217422485352,
    "a": -4.57019805908203,
    "b": -0.80324059724808,
    "C": 4.64024829864502,
    "h": 189.968276977539,
    "CMY_C": 0.23278319835663,
    "CMY_M": 0.18246096372604,
    "CMY_Y": 0.19462269544601,
    "CMYK_C": 0.0615533106029,
    "CMYK_M": 0,
    "CMYK_Y": 0.01487602572888,
    "CMYK_K": 0.18246096372604
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1481",
    "Farbtonhilfsbezeichnung": "69.06.12",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "195",
    "Bcolor": "193",
    "Y": 53.7,
    "L": 77.5730972290039,
    "a": -5.53226470947266,
    "b": -1.39564037322998,
    "C": 5.70559072494507,
    "h": 194.158752441406,
    "CMY_C": 0.29704028367996,
    "CMY_M": 0.23513275384903,
    "CMY_Y": 0.24493515491486,
    "CMYK_C": 0.08093892037868,
    "CMYK_M": 0,
    "CMYK_Y": 0.01281582005322,
    "CMYK_K": 0.23513275384903
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1482",
    "Farbtonhilfsbezeichnung": "75.01.12",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "191",
    "Bcolor": "182",
    "Y": 52.5,
    "L": 77.1450881958008,
    "a": -1.69502592086792,
    "b": 3.8440887928009,
    "C": 4.20120573043823,
    "h": 113.794769287109,
    "CMY_C": 0.25342124700546,
    "CMY_M": 0.2496931552887,
    "CMY_Y": 0.2865184545517,
    "CMYK_C": 0.00496875587851,
    "CMYK_M": 0,
    "CMYK_Y": 0.04908031970263,
    "CMYK_K": 0.2496931552887
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1483",
    "Farbtonhilfsbezeichnung": "78.01.12",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "184",
    "Bcolor": "179",
    "Y": 48.4,
    "L": 74.3260345458984,
    "a": -1.8440158367157,
    "b": 1.34443128108978,
    "C": 2.28208017349243,
    "h": 143.905044555664,
    "CMY_C": 0.29286730289459,
    "CMY_M": 0.27896249294281,
    "CMY_Y": 0.29858076572418,
    "CMYK_C": 0.01928444765508,
    "CMYK_M": 0,
    "CMYK_Y": 0.02720839343965,
    "CMYK_K": 0.27896249294281
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1484",
    "Farbtonhilfsbezeichnung": "78.18.03",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "236",
    "Bcolor": "214",
    "Y": 77.9,
    "L": 89.8158569335938,
    "a": -19.2234954833984,
    "b": 4.99656248092651,
    "C": 19.8622360229492,
    "h": 165.430099487305,
    "CMY_C": 0.25870227813721,
    "CMY_M": 0.07287406921387,
    "CMY_Y": 0.16075509786606,
    "CMYK_C": 0.20043469965458,
    "CMYK_M": 0,
    "CMYK_Y": 0.09478866308928,
    "CMYK_K": 0.07287406921387
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1485",
    "Farbtonhilfsbezeichnung": "78.18.06",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "233",
    "Bcolor": "208",
    "Y": 73.6,
    "L": 87.9692687988281,
    "a": -22.8365268707275,
    "b": 5.23216772079468,
    "C": 23.4282417297363,
    "h": 167.095458984375,
    "CMY_C": 0.31157130002975,
    "CMY_M": 0.08641320466995,
    "CMY_Y": 0.18312811851501,
    "CMYK_C": 0.24645507335663,
    "CMYK_M": 0,
    "CMYK_Y": 0.10586286336184,
    "CMYK_K": 0.08641320466995
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1486",
    "Farbtonhilfsbezeichnung": "90.03.06",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "223",
    "Bcolor": "206",
    "Y": 73.9,
    "L": 88.6557464599609,
    "a": -1.51337289810181,
    "b": 7.96744346618652,
    "C": 8.10989856719971,
    "h": 100.754898071289,
    "CMY_C": 0.11312597990036,
    "CMY_M": 0.12531310319901,
    "CMY_Y": 0.19287586212158,
    "CMYK_C": 0,
    "CMYK_M": 0.01374166272581,
    "CMYK_Y": 0.08992245048285,
    "CMYK_K": 0.11312597990036
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1487",
    "Farbtonhilfsbezeichnung": "90.03.15",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "190",
    "Bcolor": "172",
    "Y": 50.4,
    "L": 76.7204208374023,
    "a": -1.28084099292755,
    "b": 8.42553329467773,
    "C": 8.5223331451416,
    "h": 98.6438674926758,
    "CMY_C": 0.24095243215561,
    "CMY_M": 0.25637656450272,
    "CMY_Y": 0.32374864816666,
    "CMYK_C": 0,
    "CMYK_M": 0.02032037638128,
    "CMYK_Y": 0.10907908529043,
    "CMYK_K": 0.24095243215561
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1488",
    "Farbtonhilfsbezeichnung": "93.06.06",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "242",
    "Bcolor": "228",
    "Y": 89.2,
    "L": 95.3339080810547,
    "a": -0.8849681019783,
    "b": 6.30129241943359,
    "C": 6.36313247680664,
    "h": 97.9944686889648,
    "CMY_C": 0.03861927986145,
    "CMY_M": 0.05171835422516,
    "CMY_Y": 0.10717356204987,
    "CMYK_C": 0,
    "CMYK_M": 0.01362527254969,
    "CMYK_Y": 0.07130815088749,
    "CMYK_K": 0.03861927986145
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1489",
    "Farbtonhilfsbezeichnung": "96.12.02",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "236",
    "Bcolor": "212",
    "Y": 85,
    "L": 93.5207977294922,
    "a": -0.95041865110397,
    "b": 11.7133913040161,
    "C": 11.7518863677979,
    "h": 94.638786315918,
    "CMY_C": 0.04301244020462,
    "CMY_M": 0.07335782051086,
    "CMY_Y": 0.1676008105278,
    "CMYK_C": 0,
    "CMYK_M": 0.03170927241445,
    "CMYK_Y": 0.13018807768822,
    "CMYK_K": 0.04301244020462
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1490",
    "Farbtonhilfsbezeichnung": "21.16.21",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "113",
    "Bcolor": "83",
    "Y": 25.3668613433838,
    "L": 57.4311408996582,
    "a": 33.0790824890137,
    "b": 32.0023994445801,
    "C": 46.0258560180664,
    "h": 44.0522079467773,
    "CMY_C": 0.20012766122818,
    "CMY_M": 0.55507755279541,
    "CMY_Y": 0.6748046875,
    "CMYK_C": 0,
    "CMYK_M": 0.44375818967819,
    "CMYK_Y": 0.59344100952148,
    "CMYK_K": 0.20012766122818
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1491",
    "Farbtonhilfsbezeichnung": "33.09.13",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "193",
    "Bcolor": "194",
    "Y": 56.8,
    "L": 79.6619720458984,
    "a": 8.02828884124756,
    "b": 1.23116266727448,
    "C": 8.12214183807373,
    "h": 8.71856117248535,
    "CMY_C": 0.16199058294296,
    "CMY_M": 0.24485903978348,
    "CMY_Y": 0.23955255746841,
    "CMYK_C": 0,
    "CMYK_M": 0.09888726472855,
    "CMYK_Y": 0.09255501627922,
    "CMYK_K": 0.16199058294296
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1492",
    "Farbtonhilfsbezeichnung": "09.12.03",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "227",
    "Bcolor": "189",
    "Y": 79.2824783325195,
    "L": 91.3619537353516,
    "a": 2.71447372436523,
    "b": 20.8152809143066,
    "C": 20.9915294647217,
    "h": 82.5701141357422,
    "CMY_C": 0.01611548662186,
    "CMY_M": 0.10851567983627,
    "CMY_Y": 0.25836908817291,
    "CMYK_C": 0,
    "CMYK_M": 0.09391365945339,
    "CMYK_Y": 0.24622158706188,
    "CMYK_K": 0.01611548662186
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1493",
    "Farbtonhilfsbezeichnung": "42.03.30",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "92",
    "Bcolor": "90",
    "Y": 10.8,
    "L": 39.2231826782227,
    "a": 1.21277070045471,
    "b": 0.85590773820877,
    "C": 1.48438227176666,
    "h": 35.2123680114746,
    "CMY_C": 0.62726831436157,
    "CMY_M": 0.64018416404724,
    "CMY_Y": 0.64600491523743,
    "CMYK_C": 0,
    "CMYK_M": 0.03465186804533,
    "CMYK_Y": 0.05026833340526,
    "CMYK_K": 0.62726831436157
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1494",
    "Farbtonhilfsbezeichnung": "15.03.12",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "185",
    "Bcolor": "171",
    "Y": 50.4,
    "L": 75.7153091430664,
    "a": 2.64129495620728,
    "b": 7.96281099319458,
    "C": 8.38944530487061,
    "h": 71.6491241455078,
    "CMY_C": 0.22459232807159,
    "CMY_M": 0.27610194683075,
    "CMY_Y": 0.3304129242897,
    "CMYK_C": 0,
    "CMYK_M": 0.06642907857895,
    "CMYK_Y": 0.13647091388702,
    "CMYK_K": 0.22459232807159
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1495",
    "Farbtonhilfsbezeichnung": "18.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "85",
    "Bcolor": "67",
    "Y": 12.1,
    "L": 41.3672256469727,
    "a": 19.0651187896729,
    "b": 18.5970687866211,
    "C": 26.6332454681396,
    "h": 44.2879867553711,
    "CMY_C": 0.46905839443207,
    "CMY_M": 0.66651922464371,
    "CMY_Y": 0.73579579591751,
    "CMYK_C": 0,
    "CMYK_M": 0.37190687656403,
    "CMYK_Y": 0.50238555669785,
    "CMYK_K": 0.46905839443207
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1496",
    "Farbtonhilfsbezeichnung": "21.06.24",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "112",
    "Bcolor": "105",
    "Y": 17.5,
    "L": 48.5999031066895,
    "a": 6.22464179992676,
    "b": 5.92872381210327,
    "C": 8.59627437591553,
    "h": 43.6052017211914,
    "CMY_C": 0.49030476808548,
    "CMY_M": 0.56214201450348,
    "CMY_Y": 0.58893233537674,
    "CMYK_C": 0,
    "CMYK_M": 0.14094157516956,
    "CMYK_Y": 0.19350302219391,
    "CMYK_K": 0.49030476808548
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1497",
    "Farbtonhilfsbezeichnung": "21.15.27",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "75",
    "Bcolor": "60",
    "Y": 10.5,
    "L": 38.666633605957,
    "a": 24.3654003143311,
    "b": 19.737699508667,
    "C": 31.3568096160889,
    "h": 39.0099220275879,
    "CMY_C": 0.46942490339279,
    "CMY_M": 0.70773333311081,
    "CMY_Y": 0.76592218875885,
    "CMYK_C": 0,
    "CMYK_M": 0.44915118813515,
    "CMYK_Y": 0.558822453022,
    "CMYK_K": 0.46942490339279
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1498",
    "Farbtonhilfsbezeichnung": "27.13.24",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "101",
    "Bcolor": "93",
    "Y": 19.7,
    "L": 50.9777488708496,
    "a": 29.7216854095459,
    "b": 16.8277568817139,
    "C": 34.1548233032227,
    "h": 29.5175743103027,
    "CMY_C": 0.31031852960587,
    "CMY_M": 0.60532701015472,
    "CMY_Y": 0.63366138935089,
    "CMYK_C": 0,
    "CMYK_M": 0.42774599790573,
    "CMYK_Y": 0.46882927417755,
    "CMYK_K": 0.31031852960587
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1499",
    "Farbtonhilfsbezeichnung": "33.09.17",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "150",
    "Bcolor": "152",
    "Y": 32.8240737915039,
    "L": 64.0182037353516,
    "a": 9.28284740447998,
    "b": 1.18411004543304,
    "C": 9.35806465148926,
    "h": 7.26933002471924,
    "CMY_C": 0.32262700796127,
    "CMY_M": 0.41314297914505,
    "CMY_Y": 0.40339434146881,
    "CMYK_C": 0,
    "CMYK_M": 0.13362796604633,
    "CMYK_Y": 0.11923612654209,
    "CMYK_K": 0.32262700796127
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1500",
    "Farbtonhilfsbezeichnung": "27.09.23",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "111",
    "Bcolor": "104",
    "Y": 19.4544696807861,
    "L": 51.214729309082,
    "a": 16.4834537506104,
    "b": 10.7149324417114,
    "C": 19.6599597930908,
    "h": 33.0255470275879,
    "CMY_C": 0.39128762483597,
    "CMY_M": 0.56283855438232,
    "CMY_Y": 0.5936313867569,
    "CMYK_C": 0,
    "CMYK_M": 0.28182592988014,
    "CMYK_Y": 0.33241274952888,
    "CMYK_K": 0.39128762483597
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1501",
    "Farbtonhilfsbezeichnung": "12.06.27",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "87",
    "Bcolor": "75",
    "Y": 10.3346567153931,
    "L": 38.4364776611328,
    "a": 4.96470737457275,
    "b": 9.52742671966553,
    "C": 10.7433786392212,
    "h": 62.4761428833008,
    "CMY_C": 0.59116816520691,
    "CMY_M": 0.65744614601135,
    "CMY_Y": 0.70714712142944,
    "CMYK_C": 0,
    "CMYK_M": 0.16211551427841,
    "CMYK_Y": 0.28368377685547,
    "CMYK_K": 0.59116816520691
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1502",
    "Farbtonhilfsbezeichnung": "42.12.15",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "168",
    "Bcolor": "189",
    "Y": 44,
    "L": 72.1797180175781,
    "a": 14.8639163970947,
    "b": -6.95814752578735,
    "C": 16.4119415283203,
    "h": 334.914611816406,
    "CMY_C": 0.22016191482544,
    "CMY_M": 0.33962768316269,
    "CMY_Y": 0.26055866479874,
    "CMYK_C": 0,
    "CMYK_M": 0.15319304168224,
    "CMYK_Y": 0.05180145800114,
    "CMYK_K": 0.22016191482544
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1503",
    "Farbtonhilfsbezeichnung": "24.18.30",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 8.08589267730713,
    "L": 34.1611289978027,
    "a": 24.0321140289307,
    "b": 13.0611190795898,
    "C": 27.3520622253418,
    "h": 28.5234642028809,
    "CMY_C": 0.52681332826614,
    "CMY_M": 0.74726891517639,
    "CMY_Y": 0.76391589641571,
    "CMYK_C": 0,
    "CMYK_M": 0.46589559316635,
    "CMYK_Y": 0.50107616186142,
    "CMYK_K": 0.52681332826614
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1504",
    "Farbtonhilfsbezeichnung": "21.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "132",
    "Bcolor": "123",
    "Y": 24.7070140838623,
    "L": 56.7888298034668,
    "a": 7.4604697227478,
    "b": 7.37760305404663,
    "C": 10.492265701294,
    "h": 44.6800193786621,
    "CMY_C": 0.3948882818222,
    "CMY_M": 0.48406785726547,
    "CMY_Y": 0.51856958866119,
    "CMYK_C": 0,
    "CMYK_M": 0.14737704396248,
    "CMYK_Y": 0.2043941617012,
    "CMYK_K": 0.3948882818222
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1505",
    "Farbtonhilfsbezeichnung": "42.03.21",
    "Farbtonklasse": "01",
    "Rcolor": "137",
    "Gcolor": "134",
    "Bcolor": "132",
    "Y": 24.5,
    "L": 56.0624847412109,
    "a": 1.01154172420502,
    "b": 0.82992678880692,
    "C": 1.30843234062195,
    "h": 39.3674163818359,
    "CMY_C": 0.4633201956749,
    "CMY_M": 0.47513073682785,
    "CMY_Y": 0.48271858692169,
    "CMYK_C": 0,
    "CMYK_M": 0.02200668118894,
    "CMYK_Y": 0.03614518418908,
    "CMYK_K": 0.4633201956749
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1506",
    "Farbtonhilfsbezeichnung": "78.01.24",
    "Farbtonklasse": "01",
    "Rcolor": "107",
    "Gcolor": "111",
    "Bcolor": "108",
    "Y": 15.5353574752808,
    "L": 46.3588943481445,
    "a": -1.61913192272186,
    "b": 0.50769776105881,
    "C": 1.69686329364777,
    "h": 162.590576171875,
    "CMY_C": 0.57910323143005,
    "CMY_M": 0.56583297252655,
    "CMY_Y": 0.57630640268326,
    "CMYK_C": 0.03056487068534,
    "CMYK_M": 0,
    "CMYK_Y": 0.02412304282188,
    "CMYK_K": 0.56583297252655
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1507",
    "Farbtonhilfsbezeichnung": "24.06.22",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "117",
    "Bcolor": "111",
    "Y": 19.5,
    "L": 51.1174087524414,
    "a": 8.11789512634277,
    "b": 6.200035572052,
    "C": 10.2147274017334,
    "h": 37.3707504272461,
    "CMY_C": 0.45213907957077,
    "CMY_M": 0.54186701774597,
    "CMY_Y": 0.56614679098129,
    "CMYK_C": 0,
    "CMYK_M": 0.16377867758274,
    "CMYK_Y": 0.20809608697891,
    "CMYK_K": 0.45213907957077
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1508",
    "Farbtonhilfsbezeichnung": "57.06.21",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "138",
    "Bcolor": "149",
    "Y": 24.7,
    "L": 56.8634605407715,
    "a": -1.5269867181778,
    "b": -8.00939464569092,
    "C": 8.15365505218506,
    "h": 259.206115722656,
    "CMY_C": 0.50458347797394,
    "CMY_M": 0.45916044712067,
    "CMY_Y": 0.41555190086365,
    "CMYK_C": 0.15233445167542,
    "CMYK_M": 0.07461491972208,
    "CMYK_Y": 0,
    "CMYK_K": 0.41555190086365
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1509",
    "Farbtonhilfsbezeichnung": "78.06.30",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "81",
    "Bcolor": "70",
    "Y": 7.31691408157349,
    "L": 32.517749786377,
    "a": -10.4107151031494,
    "b": 3.54413437843323,
    "C": 10.9974489212036,
    "h": 161.199813842773,
    "CMY_C": 0.76247608661652,
    "CMY_M": 0.68204820156097,
    "CMY_Y": 0.72543632984161,
    "CMYK_C": 0.25295621156693,
    "CMYK_M": 0,
    "CMYK_Y": 0.13646133244038,
    "CMYK_K": 0.68204820156097
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1510",
    "Farbtonhilfsbezeichnung": "81.03.16",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "165",
    "Bcolor": "159",
    "Y": 36.8966522216797,
    "L": 67.1994247436523,
    "a": -3.46258616447449,
    "b": 1.64035058021545,
    "C": 3.83148193359375,
    "h": 154.651412963867,
    "CMY_C": 0.37931567430496,
    "CMY_M": 0.35100054740906,
    "CMY_Y": 0.3754575252533,
    "CMYK_C": 0.04362889006734,
    "CMYK_M": 0,
    "CMYK_Y": 0.03768412768841,
    "CMYK_K": 0.35100054740906
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1511",
    "Farbtonhilfsbezeichnung": "84.21.30",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "118",
    "Bcolor": "69",
    "Y": 14,
    "L": 44.4802169799805,
    "a": -32.840259552002,
    "b": 20.3879337310791,
    "C": 38.6542434692383,
    "h": 148.167098999023,
    "CMY_C": 0.79904675483704,
    "CMY_M": 0.53600585460663,
    "CMY_Y": 0.72879838943481,
    "CMYK_C": 0.56690561771393,
    "CMYK_M": 0,
    "CMYK_Y": 0.41550639271736,
    "CMYK_K": 0.53600585460663
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1512",
    "Farbtonhilfsbezeichnung": "75.09.30",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "71",
    "Bcolor": "68",
    "Y": 5.6,
    "L": 28.7814788818359,
    "a": -5.6802921295166,
    "b": -0.27925384044647,
    "C": 5.68715238571167,
    "h": 182.814498901367,
    "CMY_C": 0.77324789762497,
    "CMY_M": 0.72338366508484,
    "CMY_Y": 0.73519277572632,
    "CMYK_C": 0.18026496469975,
    "CMYK_M": 0,
    "CMYK_Y": 0.04269129782915,
    "CMYK_K": 0.72338366508484
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1513",
    "Farbtonhilfsbezeichnung": "69.06.36",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "64",
    "Bcolor": "66",
    "Y": 4.96814918518066,
    "L": 26.6438293457031,
    "a": -2.25637435913086,
    "b": -2.60873365402222,
    "C": 3.44916176795959,
    "h": 229.142456054688,
    "CMY_C": 0.77563780546188,
    "CMY_M": 0.7480241060257,
    "CMY_Y": 0.7400381565094,
    "CMYK_C": 0.13694182038307,
    "CMYK_M": 0.03071969933808,
    "CMYK_Y": 0,
    "CMYK_K": 0.7400381565094
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1514",
    "Farbtonhilfsbezeichnung": "57.09.36",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "63",
    "Bcolor": "71",
    "Y": 4.87420558929443,
    "L": 26.3733291625977,
    "a": 0.47445437312126,
    "b": -6.06416416168213,
    "C": 6.08269643783569,
    "h": 274.473663330078,
    "CMY_C": 0.77098548412323,
    "CMY_M": 0.75457870960236,
    "CMY_Y": 0.72186601161957,
    "CMYK_C": 0.17660363018513,
    "CMYK_M": 0.11761488765478,
    "CMYK_Y": 0,
    "CMYK_K": 0.72186601161957
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1524",
    "Farbtonhilfsbezeichnung": "81.06.33",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "70",
    "Bcolor": "64",
    "Y": 5.7845573425293,
    "L": 28.8622817993164,
    "a": -4.85076713562012,
    "b": 1.86029827594757,
    "C": 5.19525289535522,
    "h": 159.017883300781,
    "CMY_C": 0.75991559028625,
    "CMY_M": 0.72455811500549,
    "CMY_Y": 0.74716567993164,
    "CMYK_C": 0.12836636602879,
    "CMYK_M": 0,
    "CMYK_Y": 0.0820774435997,
    "CMYK_K": 0.72455811500549
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1526",
    "Farbtonhilfsbezeichnung": "84.06.25",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "119",
    "Bcolor": "105",
    "Y": 18.0367946624756,
    "L": 49.5407028198242,
    "a": -3.65811777114868,
    "b": 7.13594579696655,
    "C": 8.01894950866699,
    "h": 117.141143798828,
    "CMY_C": 0.54307997226715,
    "CMY_M": 0.53200733661652,
    "CMY_Y": 0.5891786813736,
    "CMYK_C": 0.0236598495394,
    "CMYK_M": 0,
    "CMYK_Y": 0.12216290831566,
    "CMYK_K": 0.53200733661652
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1527",
    "Farbtonhilfsbezeichnung": "36.06.33",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "64",
    "Bcolor": "72",
    "Y": 5.6,
    "L": 29.2270526885986,
    "a": 8.64237594604492,
    "b": -2.01421809196472,
    "C": 8.87399196624756,
    "h": 346.880676269531,
    "CMY_C": 0.68275690078735,
    "CMY_M": 0.74717950820923,
    "CMY_Y": 0.71930515766144,
    "CMYK_C": 0,
    "CMYK_M": 0.20307016372681,
    "CMYK_Y": 0.11520583927631,
    "CMYK_K": 0.68275690078735
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1528",
    "Farbtonhilfsbezeichnung": "18.12.30",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "75",
    "Bcolor": "60",
    "Y": 8.6523265838623,
    "L": 35.306095123291,
    "a": 13.0193386077881,
    "b": 14.5232610702515,
    "C": 19.5045719146729,
    "h": 48.1254463195801,
    "CMY_C": 0.56908464431763,
    "CMY_M": 0.70623922348022,
    "CMY_Y": 0.76500391960144,
    "CMYK_C": 0,
    "CMYK_M": 0.31828659772873,
    "CMYK_Y": 0.45465838909149,
    "CMYK_K": 0.56908464431763
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1529",
    "Farbtonhilfsbezeichnung": "69.06.33",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "74",
    "Bcolor": "76",
    "Y": 6.60543155670166,
    "L": 30.8912391662598,
    "a": -3.1311309337616,
    "b": -2.47418284416199,
    "C": 3.99068427085876,
    "h": 218.315368652344,
    "CMY_C": 0.74369204044342,
    "CMY_M": 0.70824563503265,
    "CMY_Y": 0.70279252529144,
    "CMYK_C": 0.13761267066002,
    "CMYK_M": 0.01834782212973,
    "CMYK_Y": 0,
    "CMYK_K": 0.70279252529144
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1530",
    "Farbtonhilfsbezeichnung": "78.01.30",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "83",
    "Bcolor": "81",
    "Y": 8.48621559143066,
    "L": 34.9756393432617,
    "a": -1.13655006885529,
    "b": 0.49664425849915,
    "C": 1.24032318592072,
    "h": 156.395874023438,
    "CMY_C": 0.68360275030136,
    "CMY_M": 0.67515808343887,
    "CMY_Y": 0.68339931964874,
    "CMYK_C": 0.02599623426795,
    "CMYK_M": 0,
    "CMYK_Y": 0.02536999061704,
    "CMYK_K": 0.67515808343887
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1531",
    "Farbtonhilfsbezeichnung": "78.01.33",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "71",
    "Bcolor": "68",
    "Y": 6.06949090957642,
    "L": 29.5871105194092,
    "a": -1.89054882526398,
    "b": 0.64842295646667,
    "C": 1.99865639209747,
    "h": 161.068984985352,
    "CMY_C": 0.73714506626129,
    "CMY_M": 0.72308075428009,
    "CMY_Y": 0.73315405845642,
    "CMYK_C": 0.05078849568963,
    "CMYK_M": 0,
    "CMYK_Y": 0.03637632355094,
    "CMYK_K": 0.72308075428009
  },
  {
    "Farbtonkarten_Bezeichnung": "Brillux Scala helle\/dunkle Farbtoene",
    "Farbton_ID": "BRS1532",
    "Farbtonhilfsbezeichnung": "81.03.33",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 4.98921966552734,
    "L": 26.704029083252,
    "a": -3.37795233726501,
    "b": -1.01359701156616,
    "C": 3.52674651145935,
    "h": 196.702529907227,
    "CMY_C": 0.77764999866486,
    "CMY_M": 0.7458633184433,
    "CMY_Y": 0.74901354312897,
    "CMYK_C": 0.12507709860802,
    "CMYK_M": 0,
    "CMYK_Y": 0.01239578891546,
    "CMYK_K": 0.7458633184433
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0001",
    "Farbtonhilfsbezeichnung": "Aprico 55",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "209",
    "Bcolor": "196",
    "Y": 66,
    "L": 85.8958740234375,
    "a": 8.96642971038818,
    "b": 9.47010898590088,
    "C": 13.0414657592773,
    "h": 46.5649108886719,
    "CMY_C": 0.0625107884407,
    "CMY_M": 0.18164390325546,
    "CMY_Y": 0.23213976621628,
    "CMYK_C": 0,
    "CMYK_M": 0.12707678973675,
    "CMYK_Y": 0.18093965947628,
    "CMYK_K": 0.0625107884407
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0002",
    "Farbtonhilfsbezeichnung": "Aprico 75",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "175",
    "Bcolor": "151",
    "Y": 49,
    "L": 75.7308044433594,
    "a": 16.7403621673584,
    "b": 19.2076606750488,
    "C": 25.4788913726807,
    "h": 48.9263496398926,
    "CMY_C": 0.10322451591492,
    "CMY_M": 0.31416082382202,
    "CMY_Y": 0.40822529792786,
    "CMYK_C": 0,
    "CMYK_M": 0.23521640896797,
    "CMYK_Y": 0.34010830521584,
    "CMYK_K": 0.10322451591492
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0007",
    "Farbtonhilfsbezeichnung": "Lazur 85",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "173",
    "Bcolor": "186",
    "Y": 42,
    "L": 70.3113555908203,
    "a": -1.44260096549988,
    "b": -8.46416091918945,
    "C": 8.58621692657471,
    "h": 260.327667236328,
    "CMY_C": 0.36768317222595,
    "CMY_M": 0.31977885961533,
    "CMY_Y": 0.27191436290741,
    "CMYK_C": 0.1315350830555,
    "CMYK_M": 0.06574020534754,
    "CMYK_Y": 0,
    "CMYK_K": 0.27191436290741
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0008",
    "Farbtonhilfsbezeichnung": "Lazur 90",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "203",
    "Bcolor": "214",
    "Y": 58,
    "L": 80.9710693359375,
    "a": -1.71329605579376,
    "b": -7.69750022888184,
    "C": 7.88586664199829,
    "h": 257.451751708984,
    "CMY_C": 0.25345706939697,
    "CMY_M": 0.20492160320282,
    "CMY_Y": 0.16231626272202,
    "CMYK_C": 0.10880097746849,
    "CMYK_M": 0.050860889256,
    "CMYK_Y": 0,
    "CMYK_K": 0.16231626272202
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0009",
    "Farbtonhilfsbezeichnung": "Lazur 45",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "227",
    "Bcolor": "230",
    "Y": 78,
    "L": 89.8980941772461,
    "a": -1.1604779958725,
    "b": -2.97423982620239,
    "C": 3.19261837005615,
    "h": 248.685455322266,
    "CMY_C": 0.13335943222046,
    "CMY_M": 0.10929995775223,
    "CMY_Y": 0.09845775365829,
    "CMYK_C": 0.03871330246329,
    "CMYK_M": 0.01202628482133,
    "CMYK_Y": 0,
    "CMYK_K": 0.09845775365829
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0012",
    "Farbtonhilfsbezeichnung": "Arctis 75",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "193",
    "Bcolor": "201",
    "Y": 50,
    "L": 75.8732147216797,
    "a": -9.90854358673096,
    "b": -8.51591110229492,
    "C": 13.0652198791504,
    "h": 220.677459716797,
    "CMY_C": 0.38199031352997,
    "CMY_M": 0.24215066432953,
    "CMY_Y": 0.21283042430878,
    "CMYK_C": 0.21489638090134,
    "CMYK_M": 0.03724768012762,
    "CMYK_Y": 0,
    "CMYK_K": 0.21283042430878
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0013",
    "Farbtonhilfsbezeichnung": "Arctis 85",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "220",
    "Bcolor": "223",
    "Y": 67,
    "L": 85.7149429321289,
    "a": -9.0201358795166,
    "b": -5.82293176651001,
    "C": 10.7363576889038,
    "h": 212.844192504883,
    "CMY_C": 0.25681573152542,
    "CMY_M": 0.13715845346451,
    "CMY_Y": 0.12475699186325,
    "CMYK_C": 0.1508823633194,
    "CMYK_M": 0.01416916400194,
    "CMYK_Y": 0,
    "CMYK_K": 0.12475699186325
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0015",
    "Farbtonhilfsbezeichnung": "Melisse 75",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "169",
    "Bcolor": "119",
    "Y": 41,
    "L": 69.6664581298828,
    "a": -0.82279396057129,
    "b": 27.8248882293701,
    "C": 27.8370513916016,
    "h": 91.6937637329102,
    "CMY_C": 0.26801627874374,
    "CMY_M": 0.33663332462311,
    "CMY_Y": 0.53484797477722,
    "CMYK_C": 0,
    "CMYK_M": 0.09374121576548,
    "CMYK_Y": 0.36453229188919,
    "CMYK_K": 0.26801627874374
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0016",
    "Farbtonhilfsbezeichnung": "Curry 140",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "212",
    "Bcolor": "96",
    "Y": 69,
    "L": 86.5011825561523,
    "a": 1.77066624164581,
    "b": 60.9745025634766,
    "C": 61.0002059936523,
    "h": 88.3366241455078,
    "CMY_C": 0.00835430622101,
    "CMY_M": 0.16694468259811,
    "CMY_Y": 0.62501531839371,
    "CMYK_C": 0,
    "CMYK_M": 0.15992644429207,
    "CMYK_Y": 0.62185621261597,
    "CMYK_K": 0.00835430622101
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0017",
    "Farbtonhilfsbezeichnung": "Pacific 20",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "186",
    "Bcolor": "186",
    "Y": 49,
    "L": 74.9278793334961,
    "a": -1.87198448181152,
    "b": -1.71791779994965,
    "C": 2.54078078269958,
    "h": 222.542572021484,
    "CMY_C": 0.29713624715805,
    "CMY_M": 0.27161526679993,
    "CMY_Y": 0.27043831348419,
    "CMYK_C": 0.0365944840014,
    "CMYK_M": 0.00161323347129,
    "CMYK_Y": 0,
    "CMYK_K": 0.27043831348419
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0018",
    "Farbtonhilfsbezeichnung": "Tundra 120",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "201",
    "Bcolor": "145",
    "Y": 58,
    "L": 80.7269973754883,
    "a": -3.91713929176331,
    "b": 29.0566177368164,
    "C": 29.319465637207,
    "h": 97.6777877807617,
    "CMY_C": 0.16452586650848,
    "CMY_M": 0.21158987283707,
    "CMY_Y": 0.43263775110245,
    "CMYK_C": 0,
    "CMYK_M": 0.05633209273219,
    "CMYK_Y": 0.32090985774994,
    "CMYK_K": 0.16452586650848
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0020",
    "Farbtonhilfsbezeichnung": "Tundra 80",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "146",
    "Bcolor": "105",
    "Y": 28,
    "L": 60.4725685119629,
    "a": -2.39978694915771,
    "b": 22.6694850921631,
    "C": 22.7961521148682,
    "h": 96.0428161621094,
    "CMY_C": 0.3871573805809,
    "CMY_M": 0.42767530679703,
    "CMY_Y": 0.58878028392792,
    "CMYK_C": 0,
    "CMYK_M": 0.06611473113298,
    "CMYK_Y": 0.32899621129036,
    "CMYK_K": 0.3871573805809
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0021",
    "Farbtonhilfsbezeichnung": "Curry 90",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "235",
    "Bcolor": "197",
    "Y": 85,
    "L": 93.2085800170898,
    "a": -0.27961513400078,
    "b": 19.2021713256836,
    "C": 19.2042064666748,
    "h": 90.8342590332031,
    "CMY_C": 0.02086186408997,
    "CMY_M": 0.08028817176819,
    "CMY_Y": 0.22694456577301,
    "CMYK_C": 0,
    "CMYK_M": 0.06069246679544,
    "CMYK_Y": 0.21047356724739,
    "CMYK_K": 0.02086186408997
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0022",
    "Farbtonhilfsbezeichnung": "Ginster 90",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "233",
    "Bcolor": "206",
    "Y": 83,
    "L": 92.9755554199219,
    "a": 1.57764291763306,
    "b": 14.229754447937,
    "C": 14.3169431686401,
    "h": 83.6734924316406,
    "CMY_C": 0.02303338050842,
    "CMY_M": 0.08616954088211,
    "CMY_Y": 0.19193649291992,
    "CMYK_C": 0,
    "CMYK_M": 0.06462468206882,
    "CMYK_Y": 0.1728852391243,
    "CMYK_K": 0.02303338050842
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0023",
    "Farbtonhilfsbezeichnung": "Moos 115",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "229",
    "Bcolor": "193",
    "Y": 77,
    "L": 89.6852075720348,
    "a": -7.4826211232249,
    "b": 16.1455662053863,
    "C": 17.7951939288742,
    "h": -1.13681596184868,
    "CMY_C": 0.1233048,
    "CMY_M": 0.1022421,
    "CMY_Y": 0.2432667,
    "CMYK_C": 0.02346152,
    "CMYK_M": 0,
    "CMYK_Y": 0.1570854,
    "CMYK_K": 0.1022421
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0024",
    "Farbtonhilfsbezeichnung": "Palazzo 300",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "212",
    "Bcolor": "143",
    "Y": 74,
    "L": 87.5238647460938,
    "a": 7.69046020507813,
    "b": 39.6340866088867,
    "C": 40.3733062744141,
    "h": 79.0189819335938,
    "CMY_C": 0,
    "CMY_M": 0.16720223426819,
    "CMY_Y": 0.43977755308151,
    "CMYK_C": 0,
    "CMYK_M": 0.16720223426819,
    "CMYK_Y": 0.43977755308151,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0025",
    "Farbtonhilfsbezeichnung": "Cameo 75",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "159",
    "Bcolor": "149",
    "Y": 39,
    "L": 69.0455093383789,
    "a": 14.3906726837158,
    "b": 10.4332885742188,
    "C": 17.7748413085938,
    "h": 35.9422454833984,
    "CMY_C": 0.21162444353104,
    "CMY_M": 0.37628298997879,
    "CMY_Y": 0.41514962911606,
    "CMYK_C": 0,
    "CMYK_M": 0.20885799825191,
    "CMYK_Y": 0.25815767049789,
    "CMYK_K": 0.21162444353104
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0026",
    "Farbtonhilfsbezeichnung": "Falb 25",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "224",
    "Bcolor": "217",
    "Y": 78,
    "L": 89.5750344084628,
    "a": 0.92098029364817,
    "b": 3.41588061320797,
    "C": 3.53785882490784,
    "h": 1.30744128199087,
    "CMY_C": 0.09848381,
    "CMY_M": 0.1196685,
    "CMY_Y": 0.1489021,
    "CMYK_C": 0,
    "CMYK_M": 0.023499,
    "CMYK_Y": 0.0559261,
    "CMYK_K": 0.09848381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0027",
    "Farbtonhilfsbezeichnung": "Falb 10",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "183",
    "Bcolor": "170",
    "Y": 50,
    "L": 75.1311336092306,
    "a": 3.25540415154835,
    "b": 7.25470778314456,
    "C": 7.95163135518345,
    "h": 1.1489991355507,
    "CMY_C": 0.2285195,
    "CMY_M": 0.2836449,
    "CMY_Y": 0.331403,
    "CMYK_C": 0,
    "CMYK_M": 0.07145407,
    "CMYK_Y": 0.1333585,
    "CMYK_K": 0.2285195
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0028",
    "Farbtonhilfsbezeichnung": "Curry 145",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "221",
    "Bcolor": "137",
    "Y": 76,
    "L": 89.293083190918,
    "a": 1.00681030750275,
    "b": 44.6865234375,
    "C": 44.6978645324707,
    "h": 88.7093124389648,
    "CMY_C": 0.0034915804863,
    "CMY_M": 0.13202142715454,
    "CMY_Y": 0.46233111619949,
    "CMYK_C": 0,
    "CMYK_M": 0.12898018956184,
    "CMYK_Y": 0.4604472219944,
    "CMYK_K": 0.0034915804863
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0029",
    "Farbtonhilfsbezeichnung": "Jade 15",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "208",
    "Bcolor": "201",
    "Y": 63,
    "L": 83.3220748901367,
    "a": -0.51854926347733,
    "b": 2.74752616882324,
    "C": 2.79603171348572,
    "h": 100.687896728516,
    "CMY_C": 0.18086677789688,
    "CMY_M": 0.18500423431396,
    "CMY_Y": 0.21228635311127,
    "CMYK_C": 0,
    "CMYK_M": 0.00505101773888,
    "CMYK_Y": 0.03835710138083,
    "CMYK_K": 0.18086677789688
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0032",
    "Farbtonhilfsbezeichnung": "Melisse 60",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "240",
    "Bcolor": "226",
    "Y": 89,
    "L": 94.6407852172852,
    "a": -0.52626442909241,
    "b": 6.18057250976563,
    "C": 6.20293712615967,
    "h": 94.8668899536133,
    "CMY_C": 0.04402238130569,
    "CMY_M": 0.06034028530121,
    "CMY_Y": 0.11388236284256,
    "CMYK_C": 0,
    "CMYK_M": 0.01706933602691,
    "CMYK_Y": 0.07307700812817,
    "CMYK_K": 0.04402238130569
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0034",
    "Farbtonhilfsbezeichnung": "Siena 145",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "218",
    "Bcolor": "191",
    "Y": 77,
    "L": 89.3949890136719,
    "a": 8.86929893493652,
    "b": 17.0510272979736,
    "C": 19.2198333740234,
    "h": 62.5182571411133,
    "CMY_C": 0.00417304039001,
    "CMY_M": 0.14481371641159,
    "CMY_Y": 0.25035899877548,
    "CMYK_C": 0,
    "CMYK_M": 0.14123003184795,
    "CMYK_Y": 0.2472176104784,
    "CMYK_K": 0.00417304039001
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0036",
    "Farbtonhilfsbezeichnung": "Lavendel 145",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "208",
    "Bcolor": "228",
    "Y": 64,
    "L": 83.3072662353516,
    "a": 1.76818239688873,
    "b": -11.7924861907959,
    "C": 11.9243116378784,
    "h": 278.527496337891,
    "CMY_C": 0.21584403514862,
    "CMY_M": 0.18618136644363,
    "CMY_Y": 0.10651135444641,
    "CMYK_C": 0.12236605584621,
    "CMYK_M": 0.08916734904051,
    "CMYK_Y": 0,
    "CMYK_K": 0.10651135444641
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0037",
    "Farbtonhilfsbezeichnung": "Marin 25",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 79,
    "L": 91.4314994668938,
    "a": -1.13797406229166,
    "b": 1.5148504118466,
    "C": 1.8946653363379,
    "h": -0.92651988166945,
    "CMY_C": 0.1002515,
    "CMY_M": 0.09358353,
    "CMY_Y": 0.1146988,
    "CMYK_C": 0.007356356,
    "CMYK_M": 0,
    "CMYK_Y": 0.0232953,
    "CMYK_K": 0.09358353
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0040",
    "Farbtonhilfsbezeichnung": "Ginster 120",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "229",
    "Bcolor": "192",
    "Y": 82,
    "L": 91.7763977050781,
    "a": 2.14258003234863,
    "b": 19.7887954711914,
    "C": 19.9044494628906,
    "h": 83.8205184936523,
    "CMY_C": 0.01802337169647,
    "CMY_M": 0.10226804018021,
    "CMY_Y": 0.2463453412056,
    "CMYK_C": 0,
    "CMYK_M": 0.08579090982676,
    "CMYK_Y": 0.23251263797283,
    "CMYK_K": 0.01802337169647
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0041",
    "Farbtonhilfsbezeichnung": "Palazzo 360",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "204",
    "Bcolor": "97",
    "Y": 67,
    "L": 84.9331970214844,
    "a": 8.1605806350708,
    "b": 58.5644454956055,
    "C": 59.1302757263184,
    "h": 82.0672760009766,
    "CMY_C": 0,
    "CMY_M": 0.19964897632599,
    "CMY_Y": 0.61798942089081,
    "CMYK_C": 0,
    "CMYK_M": 0.19964897632599,
    "CMYK_Y": 0.61798942089081,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0044",
    "Farbtonhilfsbezeichnung": "Arctis 120",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "223",
    "Bcolor": "232",
    "Y": 72,
    "L": 86.5937042236328,
    "a": -10.2336854934692,
    "b": -9.18615055084229,
    "C": 13.7518606185913,
    "h": 221.912368774414,
    "CMY_C": 0.27321898937225,
    "CMY_M": 0.12378942966461,
    "CMY_Y": 0.09052658081055,
    "CMYK_C": 0.20087713003159,
    "CMYK_M": 0.03657374531031,
    "CMYK_Y": 0,
    "CMYK_K": 0.09052658081055
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0045",
    "Farbtonhilfsbezeichnung": "Cameo 180",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "197",
    "Bcolor": "183",
    "Y": 66,
    "L": 84.8084106445313,
    "a": 20.6443157196045,
    "b": 15.0533256530762,
    "C": 25.5497627258301,
    "h": 36.0986099243164,
    "CMY_C": 0,
    "CMY_M": 0.22617715597153,
    "CMY_Y": 0.28257602453232,
    "CMYK_C": 0,
    "CMYK_M": 0.22617715597153,
    "CMYK_Y": 0.28257602453232,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0046",
    "Farbtonhilfsbezeichnung": "Marin 80",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "193",
    "Bcolor": "216",
    "Y": 51,
    "L": 76.3211726294813,
    "a": -6.93824865363996,
    "b": -16.127452921562,
    "C": 17.5565951174177,
    "h": 1.16451806255504,
    "CMY_C": 0.3869137,
    "CMY_M": 0.2412238,
    "CMY_Y": 0.1532174,
    "CMYK_C": 0.2759814,
    "CMYK_M": 0.1039303,
    "CMYK_Y": 0,
    "CMYK_K": 0.1532174
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0047",
    "Farbtonhilfsbezeichnung": "Palazzo 170",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "189",
    "Bcolor": "160",
    "Y": 53,
    "L": 77.6594696044922,
    "a": 3.00824737548828,
    "b": 16.6614398956299,
    "C": 16.9308338165283,
    "h": 79.7654190063477,
    "CMY_C": 0.17823100090027,
    "CMY_M": 0.25820231437683,
    "CMY_Y": 0.3724439740181,
    "CMYK_C": 0,
    "CMYK_M": 0.09731604903936,
    "CMYK_Y": 0.23633523285389,
    "CMYK_K": 0.17823100090027
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0048",
    "Farbtonhilfsbezeichnung": "Grau 35",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "107",
    "Bcolor": "107",
    "Y": 14,
    "L": 45.0937161351946,
    "a": 0.51651031777721,
    "b": -0.82024169977312,
    "C": 0.96931901581318,
    "h": -1.00882077698764,
    "CMY_C": 0.5805324,
    "CMY_M": 0.5821975,
    "CMY_Y": 0.5796855,
    "CMYK_C": 0.002014918,
    "CMYK_M": 0.0059764,
    "CMYK_Y": 0,
    "CMYK_K": 0.5796855
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0049",
    "Farbtonhilfsbezeichnung": "Grau 40",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "129",
    "Bcolor": "129",
    "Y": 22,
    "L": 53.9615659928648,
    "a": 0.37116112971641,
    "b": -0.69878584132336,
    "C": 0.79124094702332,
    "h": -1.08253921855241,
    "CMY_C": 0.4937552,
    "CMY_M": 0.4944997,
    "CMY_Y": 0.4935611,
    "CMYK_C": 0.0003833886,
    "CMYK_M": 0.00185349,
    "CMYK_Y": 0,
    "CMYK_K": 0.4935611
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0050",
    "Farbtonhilfsbezeichnung": "Grau 60",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 81,
    "L": 89.7704185503165,
    "a": -0.325404085867,
    "b": 1.88302621368632,
    "C": 1.91093577613922,
    "h": -1.39967723508729,
    "CMY_C": 0.1110694,
    "CMY_M": 0.1141108,
    "CMY_Y": 0.1356175,
    "CMYK_C": 0,
    "CMYK_M": 0.003421452,
    "CMYK_Y": 0.02761538,
    "CMYK_K": 0.1110694
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0051",
    "Farbtonhilfsbezeichnung": "Aquarell 20",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "214",
    "Bcolor": "214",
    "Y": 68,
    "L": 85.4801635742188,
    "a": -0.11829083412886,
    "b": -1.09758424758911,
    "C": 1.10394012928009,
    "h": 263.848754882813,
    "CMY_C": 0.16702800989151,
    "CMY_M": 0.16117608547211,
    "CMY_Y": 0.16074800491333,
    "CMYK_C": 0.0074828597717,
    "CMYK_M": 0.00051007390721,
    "CMYK_Y": 0,
    "CMYK_K": 0.16074800491333
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0052",
    "Farbtonhilfsbezeichnung": "Aquarell 50",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "214",
    "Bcolor": "218",
    "Y": 68,
    "L": 85.5229415893555,
    "a": 0.00875295139849,
    "b": -3.0255925655365,
    "C": 3.02560520172119,
    "h": 270.165740966797,
    "CMY_C": 0.17236548662186,
    "CMY_M": 0.16044306755066,
    "CMY_Y": 0.14617902040482,
    "CMYK_C": 0.03066973946989,
    "CMYK_M": 0.01670613326132,
    "CMYK_Y": 0,
    "CMYK_K": 0.14617902040482
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0053",
    "Farbtonhilfsbezeichnung": "Onyx 115",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "210",
    "Bcolor": "189",
    "Y": 67,
    "L": 85.6229400634766,
    "a": 5.2423849105835,
    "b": 12.6088733673096,
    "C": 13.6552658081055,
    "h": 67.423942565918,
    "CMY_C": 0.08383470773697,
    "CMY_M": 0.17614388465881,
    "CMY_Y": 0.25864470005035,
    "CMYK_C": 0,
    "CMYK_M": 0.10075602680445,
    "CMYK_Y": 0.19080616533756,
    "CMYK_K": 0.08383470773697
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0054",
    "Farbtonhilfsbezeichnung": "Aprico 90",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "204",
    "Bcolor": "188",
    "Y": 65,
    "L": 85.0206909179688,
    "a": 11.8979692459106,
    "b": 12.6389770507813,
    "C": 17.3581504821777,
    "h": 46.7297859191895,
    "CMY_C": 0.04389357566833,
    "CMY_M": 0.19957512617111,
    "CMY_Y": 0.26420611143112,
    "CMYK_C": 0,
    "CMYK_M": 0.16282868385315,
    "CMYK_Y": 0.23042678833008,
    "CMYK_K": 0.04389357566833
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0055",
    "Farbtonhilfsbezeichnung": "Pacific 60",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "227",
    "Bcolor": "224",
    "Y": 78,
    "L": 89.7791748046875,
    "a": -1.67938363552094,
    "b": -0.12824067473412,
    "C": 1.68427288532257,
    "h": 184.366729736328,
    "CMY_C": 0.12863010168076,
    "CMY_M": 0.11023545265198,
    "CMY_Y": 0.12085688114166,
    "CMYK_C": 0.02067361399531,
    "CMYK_M": 0,
    "CMYK_Y": 0.01193734724075,
    "CMYK_K": 0.11023545265198
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0056",
    "Farbtonhilfsbezeichnung": "Siena 110",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "201",
    "Bcolor": "175",
    "Y": 63,
    "L": 83.5951995849609,
    "a": 9.48709011077881,
    "b": 17.3876056671143,
    "C": 19.8074150085449,
    "h": 61.3820686340332,
    "CMY_C": 0.06539022922516,
    "CMY_M": 0.21009284257889,
    "CMY_Y": 0.31444275379181,
    "CMYK_C": 0,
    "CMYK_M": 0.15482677519321,
    "CMYK_Y": 0.26647755503654,
    "CMYK_K": 0.06539022922516
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0057",
    "Farbtonhilfsbezeichnung": "Siena 120",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "224",
    "Bcolor": "207",
    "Y": 76,
    "L": 90.3020629882812,
    "a": 5.05224561691284,
    "b": 9.99054431915283,
    "C": 11.1953630447388,
    "h": 63.1741561889648,
    "CMY_C": 0.03946626186371,
    "CMY_M": 0.12337785959244,
    "CMY_Y": 0.18892830610275,
    "CMYK_C": 0,
    "CMYK_M": 0.08735934644938,
    "CMYK_Y": 0.15560311079025,
    "CMYK_K": 0.03946626186371
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0058",
    "Farbtonhilfsbezeichnung": "Ceramic 60",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "222",
    "Bcolor": "206",
    "Y": 76,
    "L": 90.0616836547852,
    "a": 5.90351533889771,
    "b": 9.97264099121094,
    "C": 11.5890064239502,
    "h": 59.3756942749023,
    "CMY_C": 0.03601229190826,
    "CMY_M": 0.1281533241272,
    "CMY_Y": 0.19127416610718,
    "CMYK_C": 0,
    "CMYK_M": 0.09558320045471,
    "CMYK_Y": 0.16106209158897,
    "CMYK_K": 0.03601229190826
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0061",
    "Farbtonhilfsbezeichnung": "Palazzo 330",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "122",
    "Y": 69,
    "L": 86.2168502807617,
    "a": 7.47069215774536,
    "b": 48.4898071289063,
    "C": 49.0619277954102,
    "h": 81.2414627075195,
    "CMY_C": 0,
    "CMY_M": 0.18244987726212,
    "CMY_Y": 0.52229529619217,
    "CMYK_C": 0,
    "CMYK_M": 0.18244987726212,
    "CMYK_Y": 0.52229529619217,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0062",
    "Farbtonhilfsbezeichnung": "Ginster 150",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "151",
    "Y": 74,
    "L": 88.9619064331055,
    "a": 3.78601956367493,
    "b": 37.2355918884277,
    "C": 37.4275741577148,
    "h": 84.1942672729492,
    "CMY_C": 0.00158447027206,
    "CMY_M": 0.14115816354752,
    "CMY_Y": 0.40740275382996,
    "CMYK_C": 0,
    "CMYK_M": 0.1397951990366,
    "CMYK_Y": 0.40646231174469,
    "CMYK_K": 0.00158447027206
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0065",
    "Farbtonhilfsbezeichnung": "Lazur 20",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "199",
    "Bcolor": "200",
    "Y": 58,
    "L": 80.2193222045898,
    "a": -0.44525301456451,
    "b": -1.64853096008301,
    "C": 1.70760202407837,
    "h": 254.88557434082,
    "CMY_C": 0.22889667749405,
    "CMY_M": 0.21777707338333,
    "CMY_Y": 0.21397852897644,
    "CMYK_C": 0.01897931471467,
    "CMYK_M": 0.00483262166381,
    "CMYK_Y": 0,
    "CMYK_K": 0.21397852897644
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0066",
    "Farbtonhilfsbezeichnung": "Palazzo 180",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "231",
    "Bcolor": "208",
    "Y": 83,
    "L": 92.6105499267578,
    "a": 2.62285208702087,
    "b": 12.8894357681274,
    "C": 13.1535892486572,
    "h": 78.4980087280273,
    "CMY_C": 0.02312207221985,
    "CMY_M": 0.0924546122551,
    "CMY_Y": 0.18573576211929,
    "CMYK_C": 0,
    "CMYK_M": 0.07097359746695,
    "CMYK_Y": 0.16646264493465,
    "CMYK_K": 0.02312207221985
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0067",
    "Farbtonhilfsbezeichnung": "Palazzo 175",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "210",
    "Bcolor": "179",
    "Y": 66,
    "L": 85.4955902099609,
    "a": 4.07900142669678,
    "b": 17.5209045410156,
    "C": 17.9894504547119,
    "h": 76.8945465087891,
    "CMY_C": 0.08110630512238,
    "CMY_M": 0.17588365077972,
    "CMY_Y": 0.29625475406647,
    "CMYK_C": 0,
    "CMYK_M": 0.1031428873539,
    "CMYK_Y": 0.23413856327534,
    "CMYK_K": 0.08110630512238
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0068",
    "Farbtonhilfsbezeichnung": "Aquarell 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 81,
    "L": 92.2160949707031,
    "a": 0.20689329504967,
    "b": 1.16888475418091,
    "C": 1.18705368041992,
    "h": 79.9625778198242,
    "CMY_C": 0.08199280500412,
    "CMY_M": 0.08787626028061,
    "CMY_Y": 0.10326582193375,
    "CMYK_C": 0,
    "CMYK_M": 0.00640894239768,
    "CMYK_Y": 0.02317303977907,
    "CMYK_K": 0.08199280500412
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0069",
    "Farbtonhilfsbezeichnung": "Patina 80",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "193",
    "Bcolor": "184",
    "Y": 50,
    "L": 75.8127670288086,
    "a": -11.7395668029785,
    "b": 0.79228764772415,
    "C": 11.7662715911865,
    "h": 176.139038085938,
    "CMY_C": 0.35915637016296,
    "CMY_M": 0.24160534143448,
    "CMY_Y": 0.28017127513885,
    "CMYK_C": 0.154999807477,
    "CMYK_M": 0,
    "CMYK_Y": 0.05085206404328,
    "CMYK_K": 0.24160534143448
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0071",
    "Farbtonhilfsbezeichnung": "Ginster 115",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "218",
    "Bcolor": "173",
    "Y": 72,
    "L": 88.1040496826172,
    "a": 2.9965877532959,
    "b": 24.7983551025391,
    "C": 24.9787502288818,
    "h": 83.1098937988281,
    "CMY_C": 0.04207825660706,
    "CMY_M": 0.14619338512421,
    "CMY_Y": 0.32273346185684,
    "CMYK_C": 0,
    "CMYK_M": 0.10868855565786,
    "CMYK_Y": 0.29298344254494,
    "CMYK_K": 0.04207825660706
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0072",
    "Farbtonhilfsbezeichnung": "Curry 55",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "234",
    "Bcolor": "208",
    "Y": 82,
    "L": 93.001953125,
    "a": 0.41495987772942,
    "b": 13.1970367431641,
    "C": 13.203558921814,
    "h": 88.1990203857422,
    "CMY_C": 0.03428715467453,
    "CMY_M": 0.08280885219574,
    "CMY_Y": 0.18412601947784,
    "CMYK_C": 0,
    "CMYK_M": 0.05024443566799,
    "CMYK_Y": 0.1551588177681,
    "CMYK_K": 0.03428715467453
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0073",
    "Farbtonhilfsbezeichnung": "Palazzo 265",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "205",
    "Bcolor": "142",
    "Y": 65,
    "L": 85.1574249267578,
    "a": 8.38636684417725,
    "b": 36.6909217834473,
    "C": 37.6371459960938,
    "h": 77.1251907348633,
    "CMY_C": 0.01632010936737,
    "CMY_M": 0.19433689117432,
    "CMY_Y": 0.4416139125824,
    "CMYK_C": 0,
    "CMYK_M": 0.18097023665905,
    "CMYK_Y": 0.43234980106354,
    "CMYK_K": 0.01632010936737
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0074",
    "Farbtonhilfsbezeichnung": "Onyx 130",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "167",
    "Bcolor": "122",
    "Y": 43,
    "L": 71.7100448608398,
    "a": 12.0484247207642,
    "b": 29.0619716644287,
    "C": 31.4604949951172,
    "h": 67.4822311401367,
    "CMY_C": 0.16057580709457,
    "CMY_M": 0.34639596939087,
    "CMY_Y": 0.52071440219879,
    "CMYK_C": 0,
    "CMYK_M": 0.22136622667313,
    "CMYK_Y": 0.42903050780296,
    "CMYK_K": 0.16057580709457
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0075",
    "Farbtonhilfsbezeichnung": "Coelin 40",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "191",
    "Bcolor": "195",
    "Y": 50,
    "L": 76.2788772583008,
    "a": -3.56375288963318,
    "b": -4.47681283950806,
    "C": 5.72207880020142,
    "h": 231.478576660156,
    "CMY_C": 0.30638289451599,
    "CMY_M": 0.25255608558655,
    "CMY_Y": 0.23654270172119,
    "CMYK_C": 0.09147884696722,
    "CMYK_M": 0.02097482606769,
    "CMYK_Y": 0,
    "CMYK_K": 0.23654270172119
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0076",
    "Farbtonhilfsbezeichnung": "Onyx 140",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "201",
    "Bcolor": "167",
    "Y": 62,
    "L": 83.3286209106445,
    "a": 8.09828472137451,
    "b": 21.3404579162598,
    "C": 22.825366973877,
    "h": 69.2192306518555,
    "CMY_C": 0.06902557611465,
    "CMY_M": 0.2103945016861,
    "CMY_Y": 0.34643805027008,
    "CMYK_C": 0,
    "CMYK_M": 0.15185049176216,
    "CMYK_Y": 0.29798075556755,
    "CMYK_K": 0.06902557611465
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0079",
    "Farbtonhilfsbezeichnung": "Melisse 20",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "232",
    "Bcolor": "225",
    "Y": 82,
    "L": 92.122428894043,
    "a": 0.03361780568957,
    "b": 3.13312721252441,
    "C": 3.13330745697021,
    "h": 89.38525390625,
    "CMY_C": 0.07783168554306,
    "CMY_M": 0.08906424045563,
    "CMY_Y": 0.1189101934433,
    "CMYK_C": 0,
    "CMYK_M": 0.01218059100211,
    "CMYK_Y": 0.0445455648005,
    "CMYK_K": 0.07783168554306
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0080",
    "Farbtonhilfsbezeichnung": "Mai 45",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "181",
    "Bcolor": "158",
    "Y": 46,
    "L": 73.4818649291992,
    "a": -2.2066707611084,
    "b": 11.4413604736328,
    "C": 11.6522150039673,
    "h": 100.916473388672,
    "CMY_C": 0.27411293983459,
    "CMY_M": 0.28971070051193,
    "CMY_Y": 0.37920653820038,
    "CMYK_C": 0,
    "CMYK_M": 0.02148786187172,
    "CMYK_Y": 0.14477954804897,
    "CMYK_K": 0.27411293983459
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0082",
    "Farbtonhilfsbezeichnung": "Lachs 115",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "131",
    "Bcolor": "99",
    "Y": 34,
    "L": 65.2293319702148,
    "a": 36.568962097168,
    "b": 33.5933036804199,
    "C": 49.656810760498,
    "h": 42.5714797973633,
    "CMY_C": 0.08730536699295,
    "CMY_M": 0.48742407560349,
    "CMY_Y": 0.61078697443008,
    "CMYK_C": 0,
    "CMYK_M": 0.43839275836945,
    "CMYK_Y": 0.57355612516403,
    "CMYK_K": 0.08730536699295
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0083",
    "Farbtonhilfsbezeichnung": "Palazzo 325",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "121",
    "Y": 65,
    "L": 84.6639556884766,
    "a": 10.8298387527466,
    "b": 47.1138648986816,
    "C": 48.3425445556641,
    "h": 77.0545654296875,
    "CMY_C": 0,
    "CMY_M": 0.20780110359192,
    "CMY_Y": 0.52634274959564,
    "CMYK_C": 0,
    "CMYK_M": 0.20780110359192,
    "CMYK_Y": 0.52634274959564,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0087",
    "Farbtonhilfsbezeichnung": "Siena 165",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "171",
    "Bcolor": "123",
    "Y": 48,
    "L": 75.1733169555664,
    "a": 18.7017955780029,
    "b": 33.5583915710449,
    "C": 38.4177398681641,
    "h": 60.8694648742676,
    "CMY_C": 0.07280021905899,
    "CMY_M": 0.32846564054489,
    "CMY_Y": 0.51730293035507,
    "CMYK_C": 0,
    "CMYK_M": 0.27573931217194,
    "CMYK_Y": 0.47940337657928,
    "CMYK_K": 0.07280021905899
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0088",
    "Farbtonhilfsbezeichnung": "Palazzo 150",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "204",
    "Bcolor": "181",
    "Y": 62,
    "L": 82.7366485595703,
    "a": 2.6259560585022,
    "b": 12.7084703445435,
    "C": 12.9769353866577,
    "h": 78.3252563476563,
    "CMY_C": 0.13462591171265,
    "CMY_M": 0.20138543844223,
    "CMY_Y": 0.29054486751556,
    "CMYK_C": 0,
    "CMYK_M": 0.07714527845383,
    "CMYK_Y": 0.18017520010471,
    "CMYK_K": 0.13462591171265
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0089",
    "Farbtonhilfsbezeichnung": "Pacific 15",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "161",
    "Bcolor": "165",
    "Y": 34,
    "L": 65.4825057983398,
    "a": -2.65526914596558,
    "b": -4.40925788879395,
    "C": 5.14703893661499,
    "h": 238.943511962891,
    "CMY_C": 0.41202729940414,
    "CMY_M": 0.36906844377518,
    "CMY_Y": 0.35121911764145,
    "CMYK_C": 0.09372683614492,
    "CMYK_M": 0.02751210331917,
    "CMYK_Y": 0,
    "CMYK_K": 0.35121911764145
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0091",
    "Farbtonhilfsbezeichnung": "Lazur 75",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "121",
    "Bcolor": "133",
    "Y": 19,
    "L": 50.1620979309082,
    "a": -1.07270693778992,
    "b": -8.88186645507813,
    "C": 8.94641017913818,
    "h": 263.113464355469,
    "CMY_C": 0.57095682621002,
    "CMY_M": 0.52703619003296,
    "CMY_Y": 0.47759330272675,
    "CMYK_C": 0.17871809005737,
    "CMYK_M": 0.09464443475008,
    "CMYK_Y": 0,
    "CMYK_K": 0.47759330272675
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0093",
    "Farbtonhilfsbezeichnung": "Marin 90",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "227",
    "Bcolor": "232",
    "Y": 74,
    "L": 89.0654580812278,
    "a": -4.71089741899028,
    "b": -5.23149059817924,
    "C": 7.03996082170115,
    "h": 0.83771136965248,
    "CMY_C": 0.1806053,
    "CMY_M": 0.1097361,
    "CMY_Y": 0.09149915,
    "CMYK_C": 0.09808039,
    "CMYK_M": 0.02007368,
    "CMYK_Y": 0,
    "CMYK_K": 0.09149915
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0094",
    "Farbtonhilfsbezeichnung": "Tundra 150",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "236",
    "Bcolor": "182",
    "Y": 87,
    "L": 92.9186096191406,
    "a": -4.32949542999268,
    "b": 26.3603534698486,
    "C": 26.7135314941406,
    "h": 99.3271408081055,
    "CMY_C": 0.03609949350357,
    "CMY_M": 0.07556927204132,
    "CMY_Y": 0.28471076488495,
    "CMYK_C": 0,
    "CMYK_M": 0.04094798117876,
    "CMYK_Y": 0.25792214274406,
    "CMYK_K": 0.03609949350357
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0095",
    "Farbtonhilfsbezeichnung": "Marin 85",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "205",
    "Bcolor": "221",
    "Y": 59,
    "L": 80.9789179703209,
    "a": -5.17367018918891,
    "b": -11.7511733445457,
    "C": 12.8396626980643,
    "h": 1.1560646154467,
    "CMY_C": 0.3000271,
    "CMY_M": 0.1958624,
    "CMY_Y": 0.1333327,
    "CMYK_C": 0.1923396,
    "CMYK_M": 0.07214958,
    "CMYK_Y": 0,
    "CMYK_K": 0.1333327
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0096",
    "Farbtonhilfsbezeichnung": "Tundra 145",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "231",
    "Bcolor": "109",
    "Y": 78,
    "L": 90.7284774780273,
    "a": -8.7031135559082,
    "b": 59.447380065918,
    "C": 60.0810699462891,
    "h": 98.3289489746094,
    "CMY_C": 0.02994334697723,
    "CMY_M": 0.09561204910278,
    "CMY_Y": 0.5711522102356,
    "CMYK_C": 0,
    "CMYK_M": 0.06769573688507,
    "CMYK_Y": 0.55791467428207,
    "CMYK_K": 0.02994334697723
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0097",
    "Farbtonhilfsbezeichnung": "Moos 110",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "204",
    "Bcolor": "157",
    "Y": 58,
    "L": 80.448840626125,
    "a": -10.2462113944938,
    "b": 21.7853083966895,
    "C": 24.0745614680626,
    "h": -1.13116791421217,
    "CMY_C": 0.2306041,
    "CMY_M": 0.1992921,
    "CMY_Y": 0.3830242,
    "CMYK_C": 0.03910545,
    "CMYK_M": 0,
    "CMYK_Y": 0.229462,
    "CMYK_K": 0.1992921
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0098",
    "Farbtonhilfsbezeichnung": "Offwhite 20",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "239",
    "Bcolor": "223",
    "Y": 89,
    "L": 94.4094085693359,
    "a": -0.00478359358385,
    "b": 7.14644432067871,
    "C": 7.14644575119019,
    "h": 90.0383529663086,
    "CMY_C": 0.03953075408936,
    "CMY_M": 0.06444895267487,
    "CMY_Y": 0.12357693910599,
    "CMYK_C": 0,
    "CMYK_M": 0.02594377472997,
    "CMYK_Y": 0.08750534057617,
    "CMYK_K": 0.03953075408936
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0100",
    "Farbtonhilfsbezeichnung": "Pacific 55",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "210",
    "Bcolor": "211",
    "Y": 64,
    "L": 83.7698059082031,
    "a": -1.45586502552032,
    "b": -1.87096428871155,
    "C": 2.37066459655762,
    "h": 232.112228393555,
    "CMY_C": 0.19908827543259,
    "CMY_M": 0.17664033174515,
    "CMY_Y": 0.17396503686905,
    "CMYK_C": 0.03041425533593,
    "CMYK_M": 0.00323871872388,
    "CMYK_Y": 0,
    "CMYK_K": 0.17396503686905
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0101",
    "Farbtonhilfsbezeichnung": "Pacific 40",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "111",
    "Bcolor": "120",
    "Y": 14,
    "L": 46.2173156738281,
    "a": -2.68149256706238,
    "b": -7.06979942321777,
    "C": 7.56124782562256,
    "h": 249.228851318359,
    "CMY_C": 0.61464738845825,
    "CMY_M": 0.5630898475647,
    "CMY_Y": 0.5287749171257,
    "CMYK_C": 0.18223237991333,
    "CMYK_M": 0.07282067835331,
    "CMYK_Y": 0,
    "CMYK_K": 0.5287749171257
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0102",
    "Farbtonhilfsbezeichnung": "Bordeaux 25",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "211",
    "Bcolor": "208",
    "Y": 66,
    "L": 85.2588500976563,
    "a": 2.78711152076721,
    "b": 1.88906168937683,
    "C": 3.36697864532471,
    "h": 34.1288185119629,
    "CMY_C": 0.1370170712471,
    "CMY_M": 0.17133265733719,
    "CMY_Y": 0.18457001447678,
    "CMYK_C": 0,
    "CMYK_M": 0.03976392373443,
    "CMYK_Y": 0.05510299280286,
    "CMYK_K": 0.1370170712471
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0103",
    "Farbtonhilfsbezeichnung": "Soja 30",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "239",
    "Bcolor": "220",
    "Y": 87,
    "L": 94.4119262695312,
    "a": -0.83599048852921,
    "b": 8.83782863616943,
    "C": 8.87727928161621,
    "h": 95.4036560058594,
    "CMY_C": 0.04069536924362,
    "CMY_M": 0.06288421154022,
    "CMY_Y": 0.13631772994995,
    "CMYK_C": 0,
    "CMYK_M": 0.02313013188541,
    "CMYK_Y": 0.09967882931232,
    "CMYK_K": 0.04069536924362
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0106",
    "Farbtonhilfsbezeichnung": "Grau 20",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "197",
    "Bcolor": "194",
    "Y": 59,
    "L": 79.6112039760331,
    "a": -0.23580925519423,
    "b": 0.94889897689116,
    "C": 0.97776033524599,
    "h": -1.32722212493226,
    "CMY_C": 0.2250381,
    "CMY_M": 0.2256126,
    "CMY_Y": 0.2392112,
    "CMYK_C": 0,
    "CMYK_M": 0.0007414392,
    "CMYK_Y": 0.01828878,
    "CMYK_K": 0.2250381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0108",
    "Farbtonhilfsbezeichnung": "Melisse 110",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "217",
    "Bcolor": "82",
    "Y": 70,
    "L": 86.9641571044922,
    "a": -4.22057056427002,
    "b": 67.153434753418,
    "C": 67.2859344482422,
    "h": 93.5962905883789,
    "CMY_C": 0.03463506698608,
    "CMY_M": 0.148393034935,
    "CMY_Y": 0.67942476272583,
    "CMYK_C": 0,
    "CMYK_M": 0.11783934384584,
    "CMYK_Y": 0.66792327165604,
    "CMYK_K": 0.03463506698608
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0110",
    "Farbtonhilfsbezeichnung": "Grau 10",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "142",
    "Bcolor": "141",
    "Y": 28,
    "L": 58.9107280899626,
    "a": 0.36283229351485,
    "b": -0.05554808283156,
    "C": 0.36705975361447,
    "h": -0.1519161943476,
    "CMY_C": 0.4417495,
    "CMY_M": 0.4446144,
    "CMY_Y": 0.4481775,
    "CMYK_C": 0,
    "CMYK_M": 0.005131937,
    "CMYK_Y": 0.01151462,
    "CMYK_K": 0.4417495
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0111",
    "Farbtonhilfsbezeichnung": "Grau 15",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "172",
    "Bcolor": "169",
    "Y": 43,
    "L": 70.2988761841017,
    "a": 0.06137189417043,
    "b": 0.81046597448788,
    "C": 0.81278632197931,
    "h": 1.49521636081379,
    "CMY_C": 0.3229164,
    "CMY_M": 0.3259318,
    "CMY_Y": 0.3369322,
    "CMYK_C": 0,
    "CMYK_M": 0.004453387,
    "CMYK_Y": 0.02070024,
    "CMYK_K": 0.3229164
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0112",
    "Farbtonhilfsbezeichnung": "Grau 25",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "217",
    "Bcolor": "212",
    "Y": 74,
    "L": 86.6741863164202,
    "a": -0.47980835421779,
    "b": 1.54906897760341,
    "C": 1.62167529245236,
    "h": -1.27042803839967,
    "CMY_C": 0.1476949,
    "CMY_M": 0.1479504,
    "CMY_Y": 0.1671142,
    "CMYK_C": 0,
    "CMYK_M": 0.0002998553,
    "CMYK_Y": 0.02278447,
    "CMYK_K": 0.1476949
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0113",
    "Farbtonhilfsbezeichnung": "Grau 30",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "228",
    "Bcolor": "219",
    "Y": 85,
    "L": 90.6225714441948,
    "a": -0.15689839898436,
    "b": 4.09833171429446,
    "C": 4.10133392300549,
    "h": -1.53253153373864,
    "CMY_C": 0.09294833,
    "CMY_M": 0.1056438,
    "CMY_Y": 0.1426059,
    "CMYK_C": 0,
    "CMYK_M": 0.01399644,
    "CMYK_Y": 0.05474612,
    "CMYK_K": 0.09294833
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0114",
    "Farbtonhilfsbezeichnung": "Grau 45",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "159",
    "Bcolor": "158",
    "Y": 35,
    "L": 65.5334386989705,
    "a": 0.60482829691488,
    "b": 0.00621503254387,
    "C": 0.6048602279688,
    "h": 0.01027533572932,
    "CMY_C": 0.3714821,
    "CMY_M": 0.3769169,
    "CMY_Y": 0.3808262,
    "CMYK_C": 0,
    "CMYK_M": 0.008647008,
    "CMYK_Y": 0.01486696,
    "CMYK_K": 0.3714821
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0115",
    "Farbtonhilfsbezeichnung": "Grau 50",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "185",
    "Bcolor": "181",
    "Y": 51,
    "L": 75.2016986543556,
    "a": 0.04191281855248,
    "b": 1.29492195497525,
    "C": 1.29560007480547,
    "h": 1.53844056106259,
    "CMY_C": 0.269311,
    "CMY_M": 0.2738616,
    "CMY_Y": 0.2887034,
    "CMYK_C": 0,
    "CMYK_M": 0.006227883,
    "CMYK_Y": 0.02653987,
    "CMYK_K": 0.269311
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0116",
    "Farbtonhilfsbezeichnung": "Grau 55",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "212",
    "Bcolor": "207",
    "Y": 69,
    "L": 84.7738302333836,
    "a": -0.7924846317816,
    "b": 1.46990876816915,
    "C": 1.6699292435162,
    "h": -1.07633018798271,
    "CMY_C": 0.1713138,
    "CMY_M": 0.1681246,
    "CMY_Y": 0.1872843,
    "CMYK_C": 0.003833797,
    "CMYK_M": 0,
    "CMYK_Y": 0.02303199,
    "CMYK_K": 0.1681246
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0117",
    "Farbtonhilfsbezeichnung": "Falb 80",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "208",
    "Bcolor": "178",
    "Y": 67,
    "L": 85.6503546916058,
    "a": 8.50277898741714,
    "b": 18.7571418961701,
    "C": 20.5943590000253,
    "h": 1.14519414315165,
    "CMY_C": 0.04558827,
    "CMY_M": 0.1855222,
    "CMY_Y": 0.3029318,
    "CMYK_C": 0,
    "CMYK_M": 0.146618,
    "CMYK_Y": 0.2696358,
    "CMYK_K": 0.04558827
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0118",
    "Farbtonhilfsbezeichnung": "Offwhite 60",
    "Farbtonklasse": "01",
    "Y": 83,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0119",
    "Farbtonhilfsbezeichnung": "Offwhite 55",
    "Farbtonklasse": "01",
    "Y": 83,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0120",
    "Farbtonhilfsbezeichnung": "Offwhite 50",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "237",
    "Bcolor": "233",
    "Y": 84,
    "L": 93.5531997680664,
    "a": -1.10736858844757,
    "b": 0.72163951396942,
    "C": 1.3217521905899,
    "h": 146.908905029297,
    "CMY_C": 0.07903438806534,
    "CMY_M": 0.06965172290802,
    "CMY_Y": 0.08528935909271,
    "CMYK_C": 0.01008511055261,
    "CMYK_M": 0,
    "CMYK_Y": 0.01680836826563,
    "CMYK_K": 0.06965172290802
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0121",
    "Farbtonhilfsbezeichnung": "Offwhite 45",
    "Farbtonklasse": "01",
    "Y": 85,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0123",
    "Farbtonhilfsbezeichnung": "Offwhite 40",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "241",
    "Bcolor": "232",
    "Y": 86,
    "L": 94.2951431274414,
    "a": -4.35805797576904,
    "b": 2.24227261543274,
    "C": 4.90106678009033,
    "h": 152.773635864258,
    "CMY_C": 0.09171682596207,
    "CMY_M": 0.05413383245468,
    "CMY_Y": 0.0888404250145,
    "CMYK_C": 0.0397339425981,
    "CMYK_M": 0,
    "CMYK_Y": 0.03669292107224,
    "CMYK_K": 0.05413383245468
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0124",
    "Farbtonhilfsbezeichnung": "Offwhite 35",
    "Farbtonklasse": "01",
    "Y": 88,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0125",
    "Farbtonhilfsbezeichnung": "Rose 10",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "209",
    "Bcolor": "206",
    "Y": 64,
    "L": 84.0783233642578,
    "a": 1.49292230606079,
    "b": 1.31935882568359,
    "C": 1.99236667156219,
    "h": 41.4683990478516,
    "CMY_C": 0.16175764799118,
    "CMY_M": 0.18103992938995,
    "CMY_Y": 0.19342631101608,
    "CMYK_C": 0,
    "CMYK_M": 0.02300322987139,
    "CMYK_Y": 0.03777984157205,
    "CMYK_K": 0.16175764799118
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0126",
    "Farbtonhilfsbezeichnung": "Rose 15",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "221",
    "Bcolor": "218",
    "Y": 74,
    "L": 88.9346923828125,
    "a": 3.9513566493988,
    "b": 1.83059442043304,
    "C": 4.35480117797852,
    "h": 24.8574638366699,
    "CMY_C": 0.08745855093002,
    "CMY_M": 0.13359957933426,
    "CMY_Y": 0.1438085436821,
    "CMYK_C": 0,
    "CMYK_M": 0.05056321248412,
    "CMYK_Y": 0.06175061315298,
    "CMYK_K": 0.08745855093002
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0127",
    "Farbtonhilfsbezeichnung": "Rose 20",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "226",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.2832870483398,
    "a": 2.15471935272217,
    "b": 1.69593822956085,
    "C": 2.74208354949951,
    "h": 38.2056045532227,
    "CMY_C": 0.08661180734634,
    "CMY_M": 0.11424273252487,
    "CMY_Y": 0.12824136018753,
    "CMYK_C": 0,
    "CMYK_M": 0.03025102056563,
    "CMYK_Y": 0.04557706415653,
    "CMYK_K": 0.08661180734634
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0128",
    "Farbtonhilfsbezeichnung": "Rose 30",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "233",
    "Bcolor": "227",
    "Y": 82,
    "L": 92.4001922607422,
    "a": 0.59118127822876,
    "b": 2.30503082275391,
    "C": 2.37963485717773,
    "h": 75.6151580810547,
    "CMY_C": 0.07308882474899,
    "CMY_M": 0.08705824613571,
    "CMY_Y": 0.10961174964905,
    "CMYK_C": 0,
    "CMYK_M": 0.01507093850523,
    "CMYK_Y": 0.0394028313458,
    "CMYK_K": 0.07308882474899
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0129",
    "Farbtonhilfsbezeichnung": "Rose 35",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "139",
    "Bcolor": "141",
    "Y": 27,
    "L": 59.6441879272461,
    "a": 7.63775873184204,
    "b": 0.78062891960144,
    "C": 7.67754793167114,
    "h": 5.83573961257935,
    "CMY_C": 0.38089674711227,
    "CMY_M": 0.45388776063919,
    "CMY_Y": 0.44546794891357,
    "CMYK_C": 0,
    "CMYK_M": 0.11789796501398,
    "CMYK_Y": 0.10429795086384,
    "CMYK_K": 0.38089674711227
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0130",
    "Farbtonhilfsbezeichnung": "Rose 40",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "164",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.4012145996094,
    "a": 9.26240634918213,
    "b": 1.76573860645294,
    "C": 9.42920970916748,
    "h": 10.7930765151978,
    "CMY_C": 0.26357758045197,
    "CMY_M": 0.35726952552795,
    "CMY_Y": 0.35174167156219,
    "CMYK_C": 0,
    "CMYK_M": 0.12722581624985,
    "CMYK_Y": 0.11971945315599,
    "CMYK_K": 0.26357758045197
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0131",
    "Farbtonhilfsbezeichnung": "Rose 45",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "171",
    "Bcolor": "172",
    "Y": 43,
    "L": 71.2831039428711,
    "a": 5.5495491027832,
    "b": 0.52043265104294,
    "C": 5.57389879226685,
    "h": 5.35748720169067,
    "CMY_C": 0.27311015129089,
    "CMY_M": 0.32813340425491,
    "CMY_Y": 0.32384014129639,
    "CMYK_C": 0,
    "CMYK_M": 0.07569682598114,
    "CMYK_Y": 0.06979047507048,
    "CMYK_K": 0.27311015129089
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0132",
    "Farbtonhilfsbezeichnung": "Rose 50",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "183",
    "Bcolor": "186",
    "Y": 50,
    "L": 75.977783203125,
    "a": 6.90285444259644,
    "b": -0.02809971384704,
    "C": 6.90291166305542,
    "h": 359.766754150391,
    "CMY_C": 0.21429026126862,
    "CMY_M": 0.28133141994476,
    "CMY_Y": 0.27010750770569,
    "CMYK_C": 0,
    "CMYK_M": 0.08532560616732,
    "CMYK_Y": 0.07104054093361,
    "CMYK_K": 0.21429026126862
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0133",
    "Farbtonhilfsbezeichnung": "Rose 55",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "204",
    "Bcolor": "202",
    "Y": 62,
    "L": 83.4301452636719,
    "a": 6.35676765441895,
    "b": 2.18827366828918,
    "C": 6.7228741645813,
    "h": 18.9956722259521,
    "CMY_C": 0.12963873147964,
    "CMY_M": 0.20010048151016,
    "CMY_Y": 0.2060838341713,
    "CMYK_C": 0,
    "CMYK_M": 0.08095689862967,
    "CMYK_Y": 0.08783145993948,
    "CMYK_K": 0.12963873147964
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0134",
    "Farbtonhilfsbezeichnung": "Rose 60",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "229",
    "Bcolor": "228",
    "Y": 81,
    "L": 92.1822280883789,
    "a": 5.30688571929932,
    "b": 1.35610783100128,
    "C": 5.47741413116455,
    "h": 14.3344602584839,
    "CMY_C": 0.04215103387833,
    "CMY_M": 0.10071003437042,
    "CMY_Y": 0.10430717468262,
    "CMYK_C": 0,
    "CMYK_M": 0.06113594397902,
    "CMYK_Y": 0.06489138305187,
    "CMYK_K": 0.04215103387833
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0135",
    "Farbtonhilfsbezeichnung": "Rose 65",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "91",
    "Bcolor": "95",
    "Y": 11,
    "L": 40.822811126709,
    "a": 10.0826168060303,
    "b": 0.56579476594925,
    "C": 10.0984792709351,
    "h": 3.21183371543884,
    "CMY_C": 0.5568853020668,
    "CMY_M": 0.64454257488251,
    "CMY_Y": 0.62805438041687,
    "CMYK_C": 0,
    "CMYK_M": 0.19782072305679,
    "CMYK_Y": 0.16061095893383,
    "CMYK_K": 0.5568853020668
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0136",
    "Farbtonhilfsbezeichnung": "Rose 70",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "113",
    "Bcolor": "117",
    "Y": 18,
    "L": 49.9023361206055,
    "a": 9.32186508178711,
    "b": 0.80308824777603,
    "C": 9.35639476776123,
    "h": 4.92393255233765,
    "CMY_C": 0.4700835943222,
    "CMY_M": 0.55530029535294,
    "CMY_Y": 0.54241412878036,
    "CMYK_C": 0,
    "CMYK_M": 0.16081158816814,
    "CMYK_Y": 0.13649423420429,
    "CMYK_K": 0.4700835943222
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0137",
    "Farbtonhilfsbezeichnung": "Rose 75",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "122",
    "Bcolor": "128",
    "Y": 23,
    "L": 55.4816360473633,
    "a": 17.3523464202881,
    "b": 2.4296772480011,
    "C": 17.5216217041016,
    "h": 7.97073936462402,
    "CMY_C": 0.35803109407425,
    "CMY_M": 0.52068686485291,
    "CMY_Y": 0.49698674678802,
    "CMYK_C": 0,
    "CMYK_M": 0.25337016582489,
    "CMYK_Y": 0.21645231544971,
    "CMYK_K": 0.35803109407425
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0138",
    "Farbtonhilfsbezeichnung": "Rose 80",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "148",
    "Bcolor": "154",
    "Y": 34,
    "L": 65.2187957763672,
    "a": 16.3980979919434,
    "b": 2.04508757591248,
    "C": 16.5251331329346,
    "h": 7.1089334487915,
    "CMY_C": 0.26038581132889,
    "CMY_M": 0.41906183958054,
    "CMY_Y": 0.39597243070602,
    "CMYK_C": 0,
    "CMYK_M": 0.21453891694546,
    "CMYK_Y": 0.18332074582577,
    "CMYK_K": 0.26038581132889
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0139",
    "Farbtonhilfsbezeichnung": "Rose 85",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "178",
    "Bcolor": "183",
    "Y": 50,
    "L": 75.4823684692383,
    "a": 13.4872770309448,
    "b": 1.09848713874817,
    "C": 13.5319366455078,
    "h": 4.65624475479126,
    "CMY_C": 0.16993600130081,
    "CMY_M": 0.30347949266434,
    "CMY_Y": 0.28245949745178,
    "CMYK_C": 0,
    "CMYK_M": 0.16088336706161,
    "CMYK_Y": 0.13556002080441,
    "CMYK_K": 0.16993600130081
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0140",
    "Farbtonhilfsbezeichnung": "Rose 90",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 77,
    "L": 90.1570510864258,
    "a": 9.18007469177246,
    "b": 2.3094425201416,
    "C": 9.46611309051514,
    "h": 14.1209402084351,
    "CMY_C": 0.03301894664764,
    "CMY_M": 0.13323944807053,
    "CMY_Y": 0.13314789533615,
    "CMYK_C": 0,
    "CMYK_M": 0.10364267230034,
    "CMYK_Y": 0.10354799777269,
    "CMYK_K": 0.03301894664764
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0141",
    "Farbtonhilfsbezeichnung": "Rose 95",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "71",
    "Bcolor": "98",
    "Y": 14,
    "L": 44.3434028625488,
    "a": 43.9904136657715,
    "b": 5.00018358230591,
    "C": 44.2736740112305,
    "h": 6.48471069335938,
    "CMY_C": 0.32750874757767,
    "CMY_M": 0.72199779748917,
    "CMY_Y": 0.61755585670471,
    "CMYK_C": 0,
    "CMYK_M": 0.58660846948624,
    "CMYK_Y": 0.43130242824554,
    "CMYK_K": 0.32750874757767
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0142",
    "Farbtonhilfsbezeichnung": "Rose 100",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "82",
    "Bcolor": "106",
    "Y": 16,
    "L": 46.8643989562988,
    "a": 39.385669708252,
    "b": 3.53386855125427,
    "C": 39.543888092041,
    "h": 5.12711906433105,
    "CMY_C": 0.3251565694809,
    "CMY_M": 0.67673468589783,
    "CMY_Y": 0.58504045009613,
    "CMYK_C": 0,
    "CMYK_M": 0.5209773182869,
    "CMYK_Y": 0.38510248064995,
    "CMYK_K": 0.3251565694809
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0143",
    "Farbtonhilfsbezeichnung": "Rose 105",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "95",
    "Bcolor": "104",
    "Y": 15,
    "L": 45.4926986694336,
    "a": 20.9150123596191,
    "b": 2.16478538513184,
    "C": 21.0267448425293,
    "h": 5.90929460525513,
    "CMY_C": 0.44274878501892,
    "CMY_M": 0.62843000888824,
    "CMY_Y": 0.5923228263855,
    "CMYK_C": 0,
    "CMYK_M": 0.33320918679237,
    "CMYK_Y": 0.26841402053833,
    "CMYK_K": 0.44274878501892
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0144",
    "Farbtonhilfsbezeichnung": "Rose 110",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "112",
    "Bcolor": "123",
    "Y": 22,
    "L": 54.0369682312012,
    "a": 26.0312919616699,
    "b": 3.62486958503723,
    "C": 26.2824630737305,
    "h": 7.92748641967773,
    "CMY_C": 0.31938004493713,
    "CMY_M": 0.55996918678284,
    "CMY_Y": 0.51793301105499,
    "CMYK_C": 0,
    "CMYK_M": 0.35348528623581,
    "CMYK_Y": 0.29172369837761,
    "CMYK_K": 0.31938004493713
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0145",
    "Farbtonhilfsbezeichnung": "Rose 115",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "135",
    "Bcolor": "149",
    "Y": 34,
    "L": 65.0255661010742,
    "a": 32.9516563415527,
    "b": 5.28864526748657,
    "C": 33.373363494873,
    "h": 9.11804580688477,
    "CMY_C": 0.1533038020134,
    "CMY_M": 0.47038680315018,
    "CMY_Y": 0.41764587163925,
    "CMYK_C": 0,
    "CMYK_M": 0.37449443340302,
    "CMYK_Y": 0.31220415234566,
    "CMYK_K": 0.1533038020134
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0146",
    "Farbtonhilfsbezeichnung": "Rose 120",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "174",
    "Bcolor": "180",
    "Y": 49,
    "L": 75.3360595703125,
    "a": 17.7699928283691,
    "b": 2.56185007095337,
    "C": 17.9537105560303,
    "h": 8.20364761352539,
    "CMY_C": 0.13859015703201,
    "CMY_M": 0.31679975986481,
    "CMY_Y": 0.293761074543,
    "CMYK_C": 0,
    "CMYK_M": 0.20688131451607,
    "CMYK_Y": 0.18013599514961,
    "CMYK_K": 0.13859015703201
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0147",
    "Farbtonhilfsbezeichnung": "Baccara 10",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "78",
    "Bcolor": "87",
    "Y": 11,
    "L": 40.2298316955566,
    "a": 25.5172214508057,
    "b": 4.81905698776245,
    "C": 25.9682865142822,
    "h": 10.6946401596069,
    "CMY_C": 0.4677175283432,
    "CMY_M": 0.69305068254471,
    "CMY_Y": 0.65805780887604,
    "CMYK_C": 0,
    "CMYK_M": 0.42333379387856,
    "CMYK_Y": 0.35759261250496,
    "CMYK_K": 0.4677175283432
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0148",
    "Farbtonhilfsbezeichnung": "Baccara 15",
    "Farbtonklasse": "04",
    "Rcolor": "196",
    "Gcolor": "104",
    "Bcolor": "119",
    "Y": 23,
    "L": 55.1164474487305,
    "a": 38.2297630310059,
    "b": 7.96448755264282,
    "C": 39.0505790710449,
    "h": 11.7682218551636,
    "CMY_C": 0.23120886087418,
    "CMY_M": 0.59072184562683,
    "CMY_Y": 0.53393280506134,
    "CMYK_C": 0,
    "CMYK_M": 0.46763414144516,
    "CMYK_Y": 0.39376616477966,
    "CMYK_K": 0.23120886087418
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0149",
    "Farbtonhilfsbezeichnung": "Baccara 20",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "132",
    "Bcolor": "146",
    "Y": 35,
    "L": 65.5977478027344,
    "a": 38.2557716369629,
    "b": 7.85643148422241,
    "C": 39.0541610717773,
    "h": 11.6052446365356,
    "CMY_C": 0.11094743013382,
    "CMY_M": 0.48300319910049,
    "CMY_Y": 0.42847692966461,
    "CMYK_C": 0,
    "CMYK_M": 0.41848567128181,
    "CMYK_Y": 0.35715490579605,
    "CMYK_K": 0.11094743013382
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0150",
    "Farbtonhilfsbezeichnung": "Baccara 25",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "168",
    "Bcolor": "177",
    "Y": 52,
    "L": 75.9738540649414,
    "a": 28.5914421081543,
    "b": 5.69739055633545,
    "C": 29.1535739898682,
    "h": 11.2696590423584,
    "CMY_C": 0.05372726917267,
    "CMY_M": 0.34191143512726,
    "CMY_Y": 0.3075413107872,
    "CMYK_C": 0,
    "CMYK_M": 0.30454662442207,
    "CMYK_Y": 0.26822504401207,
    "CMYK_K": 0.05372726917267
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0151",
    "Farbtonhilfsbezeichnung": "Baccara 30",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "210",
    "Bcolor": "212",
    "Y": 71,
    "L": 87.2989654541016,
    "a": 12.9475717544556,
    "b": 2.7626416683197,
    "C": 13.2390260696411,
    "h": 12.0446624755859,
    "CMY_C": 0.03672379255295,
    "CMY_M": 0.17465007305145,
    "CMY_Y": 0.16724932193756,
    "CMYK_C": 0,
    "CMYK_M": 0.14318455755711,
    "CMYK_Y": 0.13550166785717,
    "CMYK_K": 0.03672379255295
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0152",
    "Farbtonhilfsbezeichnung": "Quarz 10",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "162",
    "Bcolor": "161",
    "Y": 37,
    "L": 67.0807945457882,
    "a": 2.47687551263581,
    "b": 0.39100069268138,
    "C": 2.50754737677521,
    "h": 0.1565684277738,
    "CMY_C": 0.3403575,
    "CMY_M": 0.3651077,
    "CMY_Y": 0.3672238,
    "CMYK_C": 0,
    "CMYK_M": 0.03752071,
    "CMYK_Y": 0.04072868,
    "CMYK_K": 0.3403575
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0153",
    "Farbtonhilfsbezeichnung": "Quarz 15",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "183",
    "Bcolor": "181",
    "Y": 48,
    "L": 74.8542829145803,
    "a": 2.73514923123375,
    "b": 1.2064889707899,
    "C": 2.98942418431313,
    "h": 0.41543256476557,
    "CMY_C": 0.2531678,
    "CMY_M": 0.2837752,
    "CMY_Y": 0.2913924,
    "CMYK_C": 0,
    "CMYK_M": 0.04098295,
    "CMYK_Y": 0.05118241,
    "CMYK_K": 0.2531678
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0154",
    "Farbtonhilfsbezeichnung": "Quarz 20",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "196",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.6591722290047,
    "a": 2.87467378010764,
    "b": 1.56066324067892,
    "C": 3.27099665130443,
    "h": 0.49737658240157,
    "CMY_C": 0.1989355,
    "CMY_M": 0.2325278,
    "CMY_Y": 0.2426731,
    "CMYK_C": 0,
    "CMYK_M": 0.04193458,
    "CMYK_Y": 0.05459933,
    "CMYK_K": 0.1989355
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0155",
    "Farbtonhilfsbezeichnung": "Quarz 25",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "205",
    "Bcolor": "202",
    "Y": 62,
    "L": 82.8428899238396,
    "a": 2.60258195605723,
    "b": 1.74493589750619,
    "C": 3.13340615375671,
    "h": 0.59062649411081,
    "CMY_C": 0.1655318,
    "CMY_M": 0.1973301,
    "CMY_Y": 0.2097502,
    "CMYK_C": 0,
    "CMYK_M": 0.03810608,
    "CMYK_Y": 0.05299004,
    "CMYK_K": 0.1655318
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0156",
    "Farbtonhilfsbezeichnung": "Quarz 30",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 72,
    "L": 87.9491358322462,
    "a": 2.78494700885223,
    "b": 2.11470549487383,
    "C": 3.49684274341363,
    "h": 0.64944827734034,
    "CMY_C": 0.1064611,
    "CMY_M": 0.1417872,
    "CMY_Y": 0.1568676,
    "CMYK_C": 0,
    "CMYK_M": 0.03953502,
    "CMYK_Y": 0.05641218,
    "CMYK_K": 0.1064611
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0157",
    "Farbtonhilfsbezeichnung": "Quarz 45",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "179",
    "Bcolor": "177",
    "Y": 48,
    "L": 74.9772235333197,
    "a": 9.13645043830918,
    "b": 3.45543631686023,
    "C": 9.76804825702436,
    "h": 0.36157613950391,
    "CMY_C": 0.1991735,
    "CMY_M": 0.2985184,
    "CMY_Y": 0.3051594,
    "CMYK_C": 0,
    "CMYK_M": 0.1240529,
    "CMYK_Y": 0.1323456,
    "CMYK_K": 0.1991735
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0158",
    "Farbtonhilfsbezeichnung": "Quarz 50",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "187",
    "Bcolor": "185",
    "Y": 52,
    "L": 77.4587498748121,
    "a": 7.31246830686921,
    "b": 3.01649757715088,
    "C": 7.91021177794399,
    "h": 0.39124778005391,
    "CMY_C": 0.1861294,
    "CMY_M": 0.2673503,
    "CMY_Y": 0.2759962,
    "CMYK_C": 0,
    "CMYK_M": 0.0997958,
    "CMYK_Y": 0.110419,
    "CMYK_K": 0.1861294
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0159",
    "Farbtonhilfsbezeichnung": "Quarz 55",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "203",
    "Bcolor": "201",
    "Y": 62,
    "L": 82.8011556176347,
    "a": 4.9316871976402,
    "b": 1.82143908213539,
    "C": 5.25729768467589,
    "h": 0.35379386783637,
    "CMY_C": 0.148285,
    "CMY_M": 0.2034066,
    "CMY_Y": 0.2104294,
    "CMYK_C": 0,
    "CMYK_M": 0.06471841,
    "CMYK_Y": 0.07296386,
    "CMYK_K": 0.148285
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0160",
    "Farbtonhilfsbezeichnung": "Quarz 60",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "215",
    "Bcolor": "211",
    "Y": 73,
    "L": 86.8162632994449,
    "a": 4.02718038044286,
    "b": 2.59133613605627,
    "C": 4.78886257754959,
    "h": 0.5717651007628,
    "CMY_C": 0.1081328,
    "CMY_M": 0.1574287,
    "CMY_Y": 0.1725658,
    "CMYK_C": 0,
    "CMYK_M": 0.05527271,
    "CMYK_Y": 0.07224507,
    "CMYK_K": 0.1081328
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0161",
    "Farbtonhilfsbezeichnung": "Venezia 10",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "126",
    "Bcolor": "127",
    "Y": 32,
    "L": 63.1364097595215,
    "a": 37.2305870056152,
    "b": 14.9896211624146,
    "C": 40.134838104248,
    "h": 21.9304924011231,
    "CMY_C": 0.13325506448746,
    "CMY_M": 0.50704753398895,
    "CMY_Y": 0.50210297107697,
    "CMYK_C": 0,
    "CMYK_M": 0.43126004934311,
    "CMYK_Y": 0.42555531859398,
    "CMYK_K": 0.13325506448746
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0162",
    "Farbtonhilfsbezeichnung": "Venezia 15",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "139",
    "Bcolor": "140",
    "Y": 38,
    "L": 67.8386001586914,
    "a": 36.1710243225098,
    "b": 14.4169406890869,
    "C": 38.9383010864258,
    "h": 21.7310924530029,
    "CMY_C": 0.08542114496231,
    "CMY_M": 0.45437926054001,
    "CMY_Y": 0.45125955343246,
    "CMYK_C": 0,
    "CMYK_M": 0.40341860055923,
    "CMYK_Y": 0.40000751614571,
    "CMYK_K": 0.08542114496231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0163",
    "Farbtonhilfsbezeichnung": "Venezia 20",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "180",
    "Bcolor": "180",
    "Y": 57,
    "L": 79.5004272460938,
    "a": 25.0731506347656,
    "b": 9.05037307739258,
    "C": 26.6565589904785,
    "h": 19.8474922180176,
    "CMY_C": 0.02800852060318,
    "CMY_M": 0.29468303918839,
    "CMY_Y": 0.29473680257797,
    "CMYK_C": 0,
    "CMYK_M": 0.27435889840126,
    "CMYK_Y": 0.27441421151161,
    "CMYK_K": 0.02800852060318
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0164",
    "Farbtonhilfsbezeichnung": "Venezia 25",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "219",
    "Bcolor": "216",
    "Y": 76,
    "L": 89.7120666503906,
    "a": 9.85733413696289,
    "b": 4.45631265640259,
    "C": 10.8178443908691,
    "h": 24.3268184661865,
    "CMY_C": 0.02676659822464,
    "CMY_M": 0.14051431417465,
    "CMY_Y": 0.1537601351738,
    "CMYK_C": 0,
    "CMYK_M": 0.11687608808279,
    "CMYK_Y": 0.13048620522022,
    "CMYK_K": 0.02676659822464
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0165",
    "Farbtonhilfsbezeichnung": "Venezia 30",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "223",
    "Bcolor": "219",
    "Y": 80,
    "L": 90.6297912597656,
    "a": 8.20672130584717,
    "b": 4.32789373397827,
    "C": 9.27798175811768,
    "h": 27.8053550720215,
    "CMY_C": 0.0288211107254,
    "CMY_M": 0.12610024213791,
    "CMY_Y": 0.14299583435059,
    "CMYK_C": 0,
    "CMYK_M": 0.10016603022814,
    "CMYK_Y": 0.11756302416325,
    "CMYK_K": 0.0288211107254
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0166",
    "Farbtonhilfsbezeichnung": "Korall 10",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "168",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.5804972920786,
    "a": 3.80202664591167,
    "b": 1.96283561249433,
    "C": 4.27880009557567,
    "h": 0.47657110969784,
    "CMY_C": 0.2995413,
    "CMY_M": 0.3423861,
    "CMY_Y": 0.3520064,
    "CMYK_C": 0,
    "CMYK_M": 0.06116674,
    "CMYK_Y": 0.07490104,
    "CMYK_K": 0.2995413
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0167",
    "Farbtonhilfsbezeichnung": "Korall 15",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "203",
    "Bcolor": "199",
    "Y": 62,
    "L": 82.6252179820469,
    "a": 3.48359553164473,
    "b": 2.81333079370991,
    "C": 4.47775255936855,
    "h": 0.67935429773039,
    "CMY_C": 0.1579492,
    "CMY_M": 0.2021068,
    "CMY_Y": 0.2197262,
    "CMYK_C": 0,
    "CMYK_M": 0.05244055,
    "CMYK_Y": 0.07336499,
    "CMYK_K": 0.1579492
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0168",
    "Farbtonhilfsbezeichnung": "Korall 20",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "216",
    "Bcolor": "210",
    "Y": 71,
    "L": 86.7957696800072,
    "a": 2.83474570915765,
    "b": 3.05846711565987,
    "C": 4.17013241194575,
    "h": 0.82334249589355,
    "CMY_C": 0.1159135,
    "CMY_M": 0.1549003,
    "CMY_Y": 0.1763824,
    "CMYK_C": 0,
    "CMYK_M": 0.04409836,
    "CMYK_Y": 0.06839702,
    "CMYK_K": 0.1159135
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0169",
    "Farbtonhilfsbezeichnung": "Korall 25",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "219",
    "Bcolor": "214",
    "Y": 71,
    "L": 87.6193435797928,
    "a": 0.94986481890602,
    "b": 2.32575819934115,
    "C": 2.51224886824494,
    "h": 1.18306033497187,
    "CMY_C": 0.1235515,
    "CMY_M": 0.1410998,
    "CMY_Y": 0.1622852,
    "CMYK_C": 0,
    "CMYK_M": 0.02002203,
    "CMYK_Y": 0.04419395,
    "CMYK_K": 0.1235515
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0170",
    "Farbtonhilfsbezeichnung": "Korall 30",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "222",
    "Bcolor": "215",
    "Y": 75,
    "L": 88.7669706123519,
    "a": 0.96872969592265,
    "b": 3.22485156005947,
    "C": 3.36721024116113,
    "h": 1.27897706935217,
    "CMY_C": 0.1077352,
    "CMY_M": 0.1286935,
    "CMY_Y": 0.1563404,
    "CMYK_C": 0,
    "CMYK_M": 0.02348888,
    "CMYK_Y": 0.05447401,
    "CMYK_K": 0.1077352
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0171",
    "Farbtonhilfsbezeichnung": "Korall 35",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "163",
    "Bcolor": "160",
    "Y": 39,
    "L": 68.3365529217224,
    "a": 6.04842846612363,
    "b": 2.88729476197576,
    "C": 6.70223529520915,
    "h": 0.44537440489188,
    "CMY_C": 0.2941896,
    "CMY_M": 0.3609789,
    "CMY_Y": 0.3710799,
    "CMYK_C": 0,
    "CMYK_M": 0.0946278,
    "CMYK_Y": 0.108939,
    "CMYK_K": 0.2941896
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0172",
    "Farbtonhilfsbezeichnung": "Korall 40",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "166",
    "Bcolor": "162",
    "Y": 41,
    "L": 70.0829940287305,
    "a": 7.82308948867688,
    "b": 4.35287208371251,
    "C": 8.95255407830695,
    "h": 0.50775381395186,
    "CMY_C": 0.2590463,
    "CMY_M": 0.347325,
    "CMY_Y": 0.3629405,
    "CMYK_C": 0,
    "CMYK_M": 0.119142,
    "CMYK_Y": 0.1402169,
    "CMYK_K": 0.2590463
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0173",
    "Farbtonhilfsbezeichnung": "Korall 45",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "188",
    "Bcolor": "184",
    "Y": 53,
    "L": 77.492171736417,
    "a": 5.02182174853616,
    "b": 3.42226506467163,
    "C": 6.07705453710452,
    "h": 0.59818717810173,
    "CMY_C": 0.2010813,
    "CMY_M": 0.2615364,
    "CMY_Y": 0.2788693,
    "CMYK_C": 0,
    "CMYK_M": 0.07567129,
    "CMYK_Y": 0.09736671,
    "CMYK_K": 0.2010813
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0174",
    "Farbtonhilfsbezeichnung": "Korall 50",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "191",
    "Bcolor": "186",
    "Y": 55,
    "L": 78.6807387381348,
    "a": 6.15996324476686,
    "b": 3.84205789341014,
    "C": 7.25992810110361,
    "h": 0.55767431807803,
    "CMY_C": 0.1786032,
    "CMY_M": 0.2516149,
    "CMY_Y": 0.2690614,
    "CMYK_C": 0,
    "CMYK_M": 0.08888721,
    "CMYK_Y": 0.1101273,
    "CMYK_K": 0.1786032
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0175",
    "Farbtonhilfsbezeichnung": "Korall 55",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "212",
    "Bcolor": "203",
    "Y": 70,
    "L": 86.5352621697131,
    "a": 7.11998968269212,
    "b": 6.28680313929413,
    "C": 9.49832336751496,
    "h": 0.72333138955632,
    "CMY_C": 0.07733383,
    "CMY_M": 0.1691646,
    "CMY_Y": 0.2022281,
    "CMYK_C": 0,
    "CMYK_M": 0.09952759,
    "CMYK_Y": 0.1353623,
    "CMYK_K": 0.07733383
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0176",
    "Farbtonhilfsbezeichnung": "Korall 60",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "218",
    "Bcolor": "210",
    "Y": 75,
    "L": 88.7153661418006,
    "a": 7.19009902840656,
    "b": 6.26866182059935,
    "C": 9.53905891895699,
    "h": 0.7170410855053,
    "CMY_C": 0.05231168,
    "CMY_M": 0.1453134,
    "CMY_Y": 0.1783987,
    "CMYK_C": 0,
    "CMYK_M": 0.09813535,
    "CMYK_Y": 0.1330469,
    "CMYK_K": 0.05231168
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0177",
    "Farbtonhilfsbezeichnung": "Korall 65",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "120",
    "Bcolor": "116",
    "Y": 20,
    "L": 52.9117909637796,
    "a": 10.705232448008,
    "b": 5.78242444922643,
    "C": 12.167104597105,
    "h": 0.49524889531454,
    "CMY_C": 0.4184133,
    "CMY_M": 0.5302445,
    "CMY_Y": 0.5455471,
    "CMYK_C": 0,
    "CMYK_M": 0.1922865,
    "CMYK_Y": 0.2185982,
    "CMYK_K": 0.4184133
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0178",
    "Farbtonhilfsbezeichnung": "Korall 70",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "118",
    "Bcolor": "113",
    "Y": 22,
    "L": 53.7012231425618,
    "a": 15.9015045167369,
    "b": 8.68082611747905,
    "C": 18.1166936270864,
    "h": 0.49969940739487,
    "CMY_C": 0.37225,
    "CMY_M": 0.5362743,
    "CMY_Y": 0.5562598,
    "CMYK_C": 0,
    "CMYK_M": 0.2612891,
    "CMYK_Y": 0.2931258,
    "CMYK_K": 0.37225
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0179",
    "Farbtonhilfsbezeichnung": "Korall 75",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "142",
    "Bcolor": "136",
    "Y": 33,
    "L": 63.7150512536577,
    "a": 19.1604295612194,
    "b": 10.3538031396504,
    "C": 21.7789646316138,
    "h": 0.49542299060584,
    "CMY_C": 0.2406402,
    "CMY_M": 0.444268,
    "CMY_Y": 0.4678994,
    "CMYK_C": 0,
    "CMYK_M": 0.2681572,
    "CMYK_Y": 0.2992774,
    "CMYK_K": 0.2406402
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0180",
    "Farbtonhilfsbezeichnung": "Korall 80",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "145",
    "Bcolor": "140",
    "Y": 33,
    "L": 63.6947998909879,
    "a": 13.8511412263449,
    "b": 7.57070387632253,
    "C": 15.7851091366235,
    "h": 0.50021075941693,
    "CMY_C": 0.2800596,
    "CMY_M": 0.4296543,
    "CMY_Y": 0.4498613,
    "CMYK_C": 0,
    "CMYK_M": 0.2077876,
    "CMYK_Y": 0.2358553,
    "CMYK_K": 0.2800596
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0181",
    "Farbtonhilfsbezeichnung": "Korall 85",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "174",
    "Bcolor": "168",
    "Y": 47,
    "L": 74.1822833199502,
    "a": 12.4859102156361,
    "b": 7.56844737107154,
    "C": 14.6006626398121,
    "h": 0.54493590452809,
    "CMY_C": 0.1741573,
    "CMY_M": 0.3165531,
    "CMY_Y": 0.3421653,
    "CMYK_C": 0,
    "CMYK_M": 0.1724248,
    "CMYK_Y": 0.2034382,
    "CMYK_K": 0.1741573
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0182",
    "Farbtonhilfsbezeichnung": "Korall 90",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "187",
    "Bcolor": "180",
    "Y": 56,
    "L": 78.7569354705283,
    "a": 11.5920243487702,
    "b": 7.61350444738433,
    "C": 13.8686869772456,
    "h": 0.58113242800723,
    "CMY_C": 0.1292523,
    "CMY_M": 0.2653978,
    "CMY_Y": 0.294491,
    "CMYK_C": 0,
    "CMYK_M": 0.1563547,
    "CMYK_Y": 0.1897665,
    "CMYK_K": 0.1292523
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0183",
    "Farbtonhilfsbezeichnung": "Korall 95",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "69",
    "Bcolor": "68",
    "Y": 6,
    "L": 31.3047870444329,
    "a": 7.87575217229744,
    "b": 3.24607729152098,
    "C": 8.51847932802422,
    "h": 0.3909457745364,
    "CMY_C": 0.6557669,
    "CMY_M": 0.7281253,
    "CMY_Y": 0.7322513,
    "CMYK_C": 0,
    "CMYK_M": 0.2102019,
    "CMYK_Y": 0.2221878,
    "CMYK_K": 0.6557669
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0184",
    "Farbtonhilfsbezeichnung": "Korall 100",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "81",
    "Bcolor": "78",
    "Y": 9,
    "L": 37.6731404221803,
    "a": 12.8312383193125,
    "b": 6.64058793729888,
    "C": 14.4477709339536,
    "h": 0.47757534209952,
    "CMY_C": 0.5593119,
    "CMY_M": 0.6822543,
    "CMY_Y": 0.6948727,
    "CMYK_C": 0,
    "CMYK_M": 0.2789782,
    "CMYK_Y": 0.3076116,
    "CMYK_K": 0.5593119
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0185",
    "Farbtonhilfsbezeichnung": "Korall 105",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "87",
    "Bcolor": "83",
    "Y": 11,
    "L": 40.9132014888836,
    "a": 15.4844808808677,
    "b": 8.10250808052726,
    "C": 17.4762634835072,
    "h": 0.48208698735067,
    "CMY_C": 0.5091559,
    "CMY_M": 0.658974,
    "CMY_Y": 0.673894,
    "CMYK_C": 0,
    "CMYK_M": 0.3052253,
    "CMYK_Y": 0.3356219,
    "CMYK_K": 0.5091559
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0186",
    "Farbtonhilfsbezeichnung": "Korall 110",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "90",
    "Bcolor": "89",
    "Y": 11,
    "L": 40.685246339678,
    "a": 9.76930100245579,
    "b": 4.24652486064599,
    "C": 10.6523338038511,
    "h": 0.41004148075423,
    "CMY_C": 0.5517238,
    "CMY_M": 0.6460526,
    "CMY_Y": 0.6525595,
    "CMYK_C": 0,
    "CMYK_M": 0.2104257,
    "CMYK_Y": 0.2249409,
    "CMYK_K": 0.5517238
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0187",
    "Farbtonhilfsbezeichnung": "Korall 115",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "96",
    "Bcolor": "91",
    "Y": 14,
    "L": 45.1859302614721,
    "a": 17.3190702298859,
    "b": 9.52795781786462,
    "C": 19.7669464967842,
    "h": 0.50295266358484,
    "CMY_C": 0.4522043,
    "CMY_M": 0.6234507,
    "CMY_Y": 0.642937,
    "CMYK_C": 0,
    "CMYK_M": 0.31261,
    "CMYK_Y": 0.3481822,
    "CMYK_K": 0.4522043
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0188",
    "Farbtonhilfsbezeichnung": "Korall 120",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "106",
    "Bcolor": "103",
    "Y": 15,
    "L": 46.6112934315984,
    "a": 8.2500720304528,
    "b": 4.1129458375714,
    "C": 9.21846039045868,
    "h": 0.46247455128176,
    "CMY_C": 0.5019849,
    "CMY_M": 0.5857553,
    "CMY_Y": 0.5959244,
    "CMYK_C": 0,
    "CMYK_M": 0.1682086,
    "CMYK_Y": 0.1886278,
    "CMYK_K": 0.5019849
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0189",
    "Farbtonhilfsbezeichnung": "Korall 125",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "65",
    "Bcolor": "62",
    "Y": 8,
    "L": 35.1090338035542,
    "a": 25.4925742987303,
    "b": 13.1001145487454,
    "C": 28.6615482060292,
    "h": 0.47468955536437,
    "CMY_C": 0.5096002,
    "CMY_M": 0.7431929,
    "CMY_Y": 0.7555515,
    "CMYK_C": 0,
    "CMYK_M": 0.4763311,
    "CMYK_Y": 0.5015323,
    "CMYK_K": 0.5096002
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0190",
    "Farbtonhilfsbezeichnung": "Korall 130",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "73",
    "Bcolor": "71",
    "Y": 8,
    "L": 35.3675011127611,
    "a": 16.1406516045557,
    "b": 7.64431949822242,
    "C": 17.8593464273067,
    "h": 0.44231085201461,
    "CMY_C": 0.5626368,
    "CMY_M": 0.7122845,
    "CMY_Y": 0.7214312,
    "CMYK_C": 0,
    "CMYK_M": 0.3421589,
    "CMYK_Y": 0.3630721,
    "CMYK_K": 0.5626368
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0191",
    "Farbtonhilfsbezeichnung": "Korall 135",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "91",
    "Bcolor": "85",
    "Y": 15,
    "L": 45.8963379566312,
    "a": 26.0293897124587,
    "b": 14.4067461321111,
    "C": 29.7503523158659,
    "h": 0.5055110549577,
    "CMY_C": 0.3894441,
    "CMY_M": 0.6428338,
    "CMY_Y": 0.6661394,
    "CMYK_C": 0,
    "CMYK_M": 0.4150148,
    "CMYK_Y": 0.4531859,
    "CMYK_K": 0.3894441
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0192",
    "Farbtonhilfsbezeichnung": "Korall 140",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "108",
    "Bcolor": "101",
    "Y": 23,
    "L": 54.340586905913,
    "a": 30.6474413474821,
    "b": 16.9013387809311,
    "C": 34.9988701779809,
    "h": 0.50397597059033,
    "CMY_C": 0.2674785,
    "CMY_M": 0.5749564,
    "CMY_Y": 0.6020375,
    "CMYK_C": 0,
    "CMYK_M": 0.4197528,
    "CMYK_Y": 0.4567225,
    "CMYK_K": 0.2674785
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0193",
    "Farbtonhilfsbezeichnung": "Korall 145",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "125",
    "Bcolor": "118",
    "Y": 27,
    "L": 59.6547396274659,
    "a": 27.6940600056338,
    "b": 14.8022474868242,
    "C": 31.4017115816454,
    "h": 0.49085879888846,
    "CMY_C": 0.2272874,
    "CMY_M": 0.5115615,
    "CMY_Y": 0.5370446,
    "CMYK_C": 0,
    "CMYK_M": 0.3678911,
    "CMYK_Y": 0.40087,
    "CMYK_K": 0.2272874
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0194",
    "Farbtonhilfsbezeichnung": "Korall 150",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "152",
    "Bcolor": "146",
    "Y": 40,
    "L": 69.1578387974795,
    "a": 24.7373669689157,
    "b": 12.8861339881776,
    "C": 27.8924680463395,
    "h": 0.4802414450327,
    "CMY_C": 0.1406259,
    "CMY_M": 0.4043756,
    "CMY_Y": 0.4293577,
    "CMYK_C": 0,
    "CMYK_M": 0.3069091,
    "CMYK_Y": 0.3359792,
    "CMYK_K": 0.1406259
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0195",
    "Farbtonhilfsbezeichnung": "Korall 155",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "87",
    "Bcolor": "82",
    "Y": 16,
    "L": 47.1373330333151,
    "a": 33.8188246481096,
    "b": 18.1420945749572,
    "C": 38.3777083232738,
    "h": 0.49238033668068,
    "CMY_C": 0.3301755,
    "CMY_M": 0.6574734,
    "CMY_Y": 0.6771903,
    "CMYK_C": 0,
    "CMYK_M": 0.4886324,
    "CMYK_Y": 0.5180683,
    "CMYK_K": 0.3301755
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0196",
    "Farbtonhilfsbezeichnung": "Korall 160",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "91",
    "Bcolor": "88",
    "Y": 18,
    "L": 49.0085092187859,
    "a": 34.6557617742279,
    "b": 17.3963274598578,
    "C": 38.776978134489,
    "h": 0.4652263937378,
    "CMY_C": 0.305694,
    "CMY_M": 0.6417907,
    "CMY_Y": 0.6548117,
    "CMYK_C": 0,
    "CMYK_M": 0.4840758,
    "CMYK_Y": 0.5028298,
    "CMYK_K": 0.305694
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0197",
    "Farbtonhilfsbezeichnung": "Korall 165",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "103",
    "Bcolor": "98",
    "Y": 25,
    "L": 56.2861680500457,
    "a": 41.3600053554257,
    "b": 22.0706106393195,
    "C": 46.8802932690622,
    "h": 0.49018207483257,
    "CMY_C": 0.1810349,
    "CMY_M": 0.594476,
    "CMY_Y": 0.6156599,
    "CMYK_C": 0,
    "CMYK_M": 0.5048337,
    "CMYK_Y": 0.5307003,
    "CMYK_K": 0.1810349
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0198",
    "Farbtonhilfsbezeichnung": "Korall 170",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "114",
    "Bcolor": "109",
    "Y": 30,
    "L": 61.0697523307774,
    "a": 43.1865510201681,
    "b": 22.6458926292217,
    "C": 48.7638661509915,
    "h": 0.48295591963136,
    "CMY_C": 0.114124,
    "CMY_M": 0.5523105,
    "CMY_Y": 0.5732104,
    "CMYK_C": 0,
    "CMYK_M": 0.4946363,
    "CMYK_Y": 0.5182287,
    "CMYK_K": 0.114124
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0199",
    "Farbtonhilfsbezeichnung": "Korall 175",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "145",
    "Bcolor": "138",
    "Y": 41,
    "L": 70.0694955162096,
    "a": 35.643020586874,
    "b": 18.8787914621497,
    "C": 40.3340263751049,
    "h": 0.4870954958346,
    "CMY_C": 0.05500244,
    "CMY_M": 0.4304791,
    "CMY_Y": 0.459857,
    "CMYK_C": 0,
    "CMYK_M": 0.3973308,
    "CMYK_Y": 0.4284186,
    "CMYK_K": 0.05500244
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0200",
    "Farbtonhilfsbezeichnung": "Korall 180",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "163",
    "Bcolor": "156",
    "Y": 47,
    "L": 73.4206666326343,
    "a": 24.7199361969291,
    "b": 13.2428364887124,
    "C": 28.0436795703955,
    "h": 0.4918096011455,
    "CMY_C": 0.09137671,
    "CMY_M": 0.3596409,
    "CMY_Y": 0.3881577,
    "CMYK_C": 0,
    "CMYK_M": 0.2952425,
    "CMYK_Y": 0.3266271,
    "CMYK_K": 0.09137671
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0201",
    "Farbtonhilfsbezeichnung": "Bordeaux 10",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "152",
    "Bcolor": "145",
    "Y": 35,
    "L": 65.6567001342773,
    "a": 11.8374767303467,
    "b": 7.79534006118774,
    "C": 14.1736793518066,
    "h": 33.3661270141602,
    "CMY_C": 0.27125024795532,
    "CMY_M": 0.40430426597595,
    "CMY_Y": 0.43181145191193,
    "CMYK_C": 0,
    "CMYK_M": 0.18257847428322,
    "CMYK_Y": 0.220324203372,
    "CMYK_K": 0.27125024795532
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0202",
    "Farbtonhilfsbezeichnung": "Bordeaux 15",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "166",
    "Bcolor": "162",
    "Y": 40,
    "L": 69.7987899780273,
    "a": 7.87186193466187,
    "b": 4.41820573806763,
    "C": 9.02700138092041,
    "h": 29.3040008544922,
    "CMY_C": 0.26158994436264,
    "CMY_M": 0.35041451454163,
    "CMY_Y": 0.36634159088135,
    "CMYK_C": 0,
    "CMYK_M": 0.12029165774584,
    "CMYK_Y": 0.14186108112335,
    "CMYK_K": 0.26158994436264
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0203",
    "Farbtonhilfsbezeichnung": "Bordeaux 20",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "181",
    "Bcolor": "178",
    "Y": 48,
    "L": 75.2384414672852,
    "a": 6.20831346511841,
    "b": 3.45363426208496,
    "C": 7.10427665710449,
    "h": 29.0868320465088,
    "CMY_C": 0.21701037883759,
    "CMY_M": 0.28851640224457,
    "CMY_Y": 0.30280804634094,
    "CMYK_C": 0,
    "CMYK_M": 0.09132435917854,
    "CMYK_Y": 0.1095770150423,
    "CMYK_K": 0.21701037883759
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0204",
    "Farbtonhilfsbezeichnung": "Bordeaux 30",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "226",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.4502563476562,
    "a": 2.50778436660767,
    "b": 2.33567190170288,
    "C": 3.42700242996216,
    "h": 42.9648475646973,
    "CMY_C": 0.07993453741074,
    "CMY_M": 0.11341995000839,
    "CMY_Y": 0.13108021020889,
    "CMYK_C": 0,
    "CMYK_M": 0.03639459609985,
    "CMYK_Y": 0.05558916553855,
    "CMYK_K": 0.07993453741074
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0205",
    "Farbtonhilfsbezeichnung": "Bordeaux 35",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "84",
    "Bcolor": "77",
    "Y": 10,
    "L": 40.5004959106445,
    "a": 18.559419631958,
    "b": 11.1224384307861,
    "C": 21.6370220184326,
    "h": 30.9337520599365,
    "CMY_C": 0.49155390262604,
    "CMY_M": 0.67174398899078,
    "CMY_Y": 0.69620245695114,
    "CMYK_C": 0,
    "CMYK_M": 0.35439369082451,
    "CMYK_Y": 0.402498036623,
    "CMYK_K": 0.49155390262604
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0206",
    "Farbtonhilfsbezeichnung": "Bordeaux 40",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "105",
    "Bcolor": "97",
    "Y": 18,
    "L": 49.7057342529297,
    "a": 19.8504810333252,
    "b": 12.3378896713257,
    "C": 23.372314453125,
    "h": 31.8626480102539,
    "CMY_C": 0.38524687290192,
    "CMY_M": 0.58714497089386,
    "CMY_Y": 0.6181036233902,
    "CMYK_C": 0,
    "CMYK_M": 0.32842141389847,
    "CMYK_Y": 0.37878090143204,
    "CMYK_K": 0.38524687290192
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0207",
    "Farbtonhilfsbezeichnung": "Bordeaux 45",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "114",
    "Bcolor": "105",
    "Y": 22,
    "L": 54.6466064453125,
    "a": 24.8907833099365,
    "b": 14.9933204650879,
    "C": 29.0577144622803,
    "h": 31.0632591247559,
    "CMY_C": 0.29873770475388,
    "CMY_M": 0.55347126722336,
    "CMY_Y": 0.58752208948135,
    "CMYK_C": 0,
    "CMYK_M": 0.36325004696846,
    "CMYK_Y": 0.4118065237999,
    "CMYK_K": 0.29873770475388
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0208",
    "Farbtonhilfsbezeichnung": "Bordeaux 50",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "130",
    "Bcolor": "122",
    "Y": 28,
    "L": 59.7882347106934,
    "a": 20.5653781890869,
    "b": 12.4066562652588,
    "C": 24.0179080963135,
    "h": 31.1016902923584,
    "CMY_C": 0.27141559123993,
    "CMY_M": 0.48869109153748,
    "CMY_Y": 0.52079439163208,
    "CMYK_C": 0,
    "CMYK_M": 0.29821595549583,
    "CMYK_Y": 0.34227854013443,
    "CMYK_K": 0.27141559123993
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0209",
    "Farbtonhilfsbezeichnung": "Bordeaux 55",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "162",
    "Bcolor": "156",
    "Y": 42,
    "L": 70.7705688476563,
    "a": 16.972692489624,
    "b": 9.39368534088135,
    "C": 19.3988037109375,
    "h": 28.9627208709717,
    "CMY_C": 0.17824125289917,
    "CMY_M": 0.36478233337402,
    "CMY_Y": 0.38973516225815,
    "CMYK_C": 0,
    "CMYK_M": 0.22700224816799,
    "CMYK_Y": 0.25736740231514,
    "CMYK_K": 0.17824125289917
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0210",
    "Farbtonhilfsbezeichnung": "Bordeaux 60",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "193",
    "Bcolor": "187",
    "Y": 59,
    "L": 81.1910781860352,
    "a": 12.528920173645,
    "b": 7.57762622833252,
    "C": 14.6422080993652,
    "h": 31.1660022735596,
    "CMY_C": 0.09560751914978,
    "CMY_M": 0.24151247739792,
    "CMY_Y": 0.26822167634964,
    "CMYK_C": 0,
    "CMYK_M": 0.16132925450802,
    "CMYK_Y": 0.19086199998856,
    "CMYK_K": 0.09560751914978
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0211",
    "Farbtonhilfsbezeichnung": "Bordeaux 65",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "69",
    "Bcolor": "63",
    "Y": 12,
    "L": 42.112174987793,
    "a": 39.3852615356445,
    "b": 23.2589988708496,
    "C": 45.7403526306152,
    "h": 30.5640106201172,
    "CMY_C": 0.35397213697433,
    "CMY_M": 0.72970706224442,
    "CMY_Y": 0.75422328710556,
    "CMYK_C": 0,
    "CMYK_M": 0.58160793781281,
    "CMYK_Y": 0.61955708265305,
    "CMYK_K": 0.35397213697433
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0212",
    "Farbtonhilfsbezeichnung": "Bordeaux 70",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "93",
    "Bcolor": "85",
    "Y": 17,
    "L": 48.873462677002,
    "a": 31.8894023895264,
    "b": 18.7286434173584,
    "C": 36.9823760986328,
    "h": 30.4257125854492,
    "CMY_C": 0.31990498304367,
    "CMY_M": 0.63373720645905,
    "CMY_Y": 0.66535955667496,
    "CMYK_C": 0,
    "CMYK_M": 0.46145349740982,
    "CMYK_Y": 0.50795048475266,
    "CMYK_K": 0.31990498304367
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0213",
    "Farbtonhilfsbezeichnung": "Bordeaux 75",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "96",
    "Bcolor": "88",
    "Y": 18,
    "L": 49.4974746704102,
    "a": 30.3379154205322,
    "b": 17.9193515777588,
    "C": 35.2348175048828,
    "h": 30.5685901641846,
    "CMY_C": 0.3221008181572,
    "CMY_M": 0.6222071647644,
    "CMY_Y": 0.65458488464355,
    "CMYK_C": 0,
    "CMYK_M": 0.4427005648613,
    "CMYK_Y": 0.49046242237091,
    "CMYK_K": 0.3221008181572
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0214",
    "Farbtonhilfsbezeichnung": "Bordeaux 80",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "120",
    "Bcolor": "107",
    "Y": 28,
    "L": 60.0877342224121,
    "a": 33.7619400024414,
    "b": 21.8282413482666,
    "C": 40.2037391662598,
    "h": 32.8840408325195,
    "CMY_C": 0.17783063650131,
    "CMY_M": 0.52825289964676,
    "CMY_Y": 0.57929837703705,
    "CMYK_C": 0,
    "CMYK_M": 0.42621663212776,
    "CMYK_Y": 0.48830297589302,
    "CMYK_K": 0.17783063650131
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0215",
    "Farbtonhilfsbezeichnung": "Bordeaux 85",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "158",
    "Bcolor": "148",
    "Y": 48,
    "L": 74.6308822631836,
    "a": 34.7464637756348,
    "b": 19.923620223999,
    "C": 40.0533065795898,
    "h": 29.8299560546875,
    "CMY_C": 0.00461202859879,
    "CMY_M": 0.37950003147125,
    "CMY_Y": 0.42106282711029,
    "CMYK_C": 0,
    "CMYK_M": 0.37662500143051,
    "CMYK_Y": 0.41838037967682,
    "CMYK_K": 0.00461202859879
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0216",
    "Farbtonhilfsbezeichnung": "Bordeaux 90",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "217",
    "Bcolor": "209",
    "Y": 76,
    "L": 89.4663238525391,
    "a": 11.9470653533935,
    "b": 7.62889528274536,
    "C": 14.1750631332398,
    "h": 32.5605926513672,
    "CMY_C": 0.00567555427551,
    "CMY_M": 0.14952880144119,
    "CMY_Y": 0.17949843406677,
    "CMYK_C": 0,
    "CMYK_M": 0.14467436075211,
    "CMYK_Y": 0.17481505870819,
    "CMYK_K": 0.00567555427551
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0217",
    "Farbtonhilfsbezeichnung": "Grau 5",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "118",
    "Bcolor": "119",
    "Y": 18,
    "L": 49.7138152097533,
    "a": 0.2916371570355,
    "b": -0.74927854477169,
    "C": 0.80403393524088,
    "h": -1.19961402335083,
    "CMY_C": 0.5367115,
    "CMY_M": 0.5365665,
    "CMY_Y": 0.5352408,
    "CMYK_C": 0.00316444,
    "CMYK_M": 0.002852574,
    "CMYK_Y": 0,
    "CMYK_K": 0.5352408
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0218",
    "Farbtonhilfsbezeichnung": "Offwhite 5",
    "Farbtonklasse": "01",
    "Y": 85,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0219",
    "Farbtonhilfsbezeichnung": "Rose 5",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "186",
    "Bcolor": "183",
    "Y": 50,
    "L": 75.8494491577148,
    "a": 2.48746156692505,
    "b": 1.27649080753326,
    "C": 2.79587078094482,
    "h": 27.1655368804932,
    "CMY_C": 0.24404776096344,
    "CMY_M": 0.27253884077072,
    "CMY_Y": 0.28136473894119,
    "CMYK_C": 0,
    "CMYK_M": 0.03768899291754,
    "CMYK_Y": 0.04936420172453,
    "CMYK_K": 0.24404776096344
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0220",
    "Farbtonhilfsbezeichnung": "Baccara 5",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "71",
    "Bcolor": "73",
    "Y": 7,
    "L": 34.2037582397461,
    "a": 15.8841953277588,
    "b": 4.6626296043396,
    "C": 16.5543880462646,
    "h": 16.359016418457,
    "CMY_C": 0.58084034919739,
    "CMY_M": 0.72154772281647,
    "CMY_Y": 0.71371722221375,
    "CMYK_C": 0,
    "CMYK_M": 0.33568921685219,
    "CMYK_Y": 0.31700778007507,
    "CMYK_K": 0.58084034919739
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0221",
    "Farbtonhilfsbezeichnung": "Venezia 5",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "92",
    "Bcolor": "98",
    "Y": 23,
    "L": 53.8571319580078,
    "a": 46.4279518127441,
    "b": 18.5819473266602,
    "C": 50.0084342956543,
    "h": 21.8128623962402,
    "CMY_C": 0.18743723630905,
    "CMY_M": 0.63911914825439,
    "CMY_Y": 0.61436724662781,
    "CMYK_C": 0,
    "CMYK_M": 0.55587327480316,
    "CMYK_Y": 0.52541172504425,
    "CMYK_K": 0.18743723630905
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0222",
    "Farbtonhilfsbezeichnung": "Korall 5",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "143",
    "Bcolor": "140",
    "Y": 28,
    "L": 60.5522722247979,
    "a": 5.59949152112693,
    "b": 2.81788140686967,
    "C": 6.26855333536807,
    "h": 0.46623529270033,
    "CMY_C": 0.3796422,
    "CMY_M": 0.4404114,
    "CMY_Y": 0.4503804,
    "CMYK_C": 0,
    "CMYK_M": 0.09795831,
    "CMYK_Y": 0.1140281,
    "CMYK_K": 0.3796422
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0223",
    "Farbtonhilfsbezeichnung": "Bordeaux 5",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "139",
    "Bcolor": "133",
    "Y": 29,
    "L": 60.4760246276855,
    "a": 10.7019376754761,
    "b": 6.85484790802002,
    "C": 12.7090682983398,
    "h": 32.6405372619629,
    "CMY_C": 0.3364155292511,
    "CMY_M": 0.45442754030228,
    "CMY_Y": 0.47786217927933,
    "CMYK_C": 0,
    "CMYK_M": 0.17784021794796,
    "CMYK_Y": 0.21315544843674,
    "CMYK_K": 0.3364155292511
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0224",
    "Farbtonhilfsbezeichnung": "Cameo 5",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "141",
    "Bcolor": "137",
    "Y": 27,
    "L": 59.6698417663574,
    "a": 4.95549440383911,
    "b": 3.38603210449219,
    "C": 6.00184440612793,
    "h": 34.3443450927734,
    "CMY_C": 0.39164954423904,
    "CMY_M": 0.44804412126541,
    "CMY_Y": 0.46323198080063,
    "CMYK_C": 0,
    "CMYK_M": 0.09270080178976,
    "CMYK_Y": 0.11766644567251,
    "CMYK_K": 0.39164954423904
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0225",
    "Farbtonhilfsbezeichnung": "Cameo 10",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "171",
    "Bcolor": "168",
    "Y": 41,
    "L": 70.7728500366211,
    "a": 3.60645437240601,
    "b": 2.10166096687317,
    "C": 4.17414569854736,
    "h": 30.2314891815186,
    "CMY_C": 0.28781098127365,
    "CMY_M": 0.32937532663345,
    "CMY_Y": 0.34055811166763,
    "CMYK_C": 0,
    "CMYK_M": 0.0583613961935,
    "CMYK_Y": 0.07406338304281,
    "CMYK_K": 0.28781098127365
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0226",
    "Farbtonhilfsbezeichnung": "Cameo 15",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.7016677856445,
    "a": 1.72049903869629,
    "b": 1.5895870923996,
    "C": 2.34241414070129,
    "h": 42.735164642334,
    "CMY_C": 0.19614696502686,
    "CMY_M": 0.2184818983078,
    "CMY_Y": 0.23184168338776,
    "CMYK_C": 0,
    "CMYK_M": 0.02778484672308,
    "CMYK_Y": 0.04440453276038,
    "CMYK_K": 0.19614696502686
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0227",
    "Farbtonhilfsbezeichnung": "Cameo 20",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "209",
    "Bcolor": "203",
    "Y": 65,
    "L": 84.4394989013672,
    "a": 3.42407846450806,
    "b": 3.45301365852356,
    "C": 4.86288166046143,
    "h": 45.2410697937012,
    "CMY_C": 0.13636934757233,
    "CMY_M": 0.18228244781494,
    "CMY_Y": 0.20477533340454,
    "CMYK_C": 0,
    "CMYK_M": 0.05316288769245,
    "CMYK_Y": 0.07920745760202,
    "CMYK_K": 0.13636934757233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0228",
    "Farbtonhilfsbezeichnung": "Cameo 25",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "229",
    "Bcolor": "224",
    "Y": 78,
    "L": 91.0733489990234,
    "a": 0.61078029870987,
    "b": 1.87912452220917,
    "C": 1.97589516639709,
    "h": 71.9940567016602,
    "CMY_C": 0.08920079469681,
    "CMY_M": 0.10179710388184,
    "CMY_Y": 0.12110543251038,
    "CMYK_C": 0,
    "CMYK_M": 0.01382995210588,
    "CMYK_Y": 0.03502927720547,
    "CMYK_K": 0.08920079469681
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0229",
    "Farbtonhilfsbezeichnung": "Cameo 30",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "232",
    "Bcolor": "226",
    "Y": 82,
    "L": 92.0496597290039,
    "a": 1.02071106433868,
    "b": 2.23873972892761,
    "C": 2.46044850349426,
    "h": 65.4902877807617,
    "CMY_C": 0.07387399673462,
    "CMY_M": 0.09198582172394,
    "CMY_Y": 0.11293357610703,
    "CMYK_C": 0,
    "CMYK_M": 0.01955654472113,
    "CMYK_Y": 0.04217523336411,
    "CMYK_K": 0.07387399673462
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0230",
    "Farbtonhilfsbezeichnung": "Cameo 35",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "114",
    "Bcolor": "111",
    "Y": 18,
    "L": 49.808422088623,
    "a": 6.95074510574341,
    "b": 4.24048137664795,
    "C": 8.14214611053467,
    "h": 31.3863544464111,
    "CMY_C": 0.47752529382706,
    "CMY_M": 0.55155467987061,
    "CMY_Y": 0.56613582372665,
    "CMYK_C": 0,
    "CMYK_M": 0.14168989658356,
    "CMYK_Y": 0.16959774494171,
    "CMYK_K": 0.47752529382706
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0231",
    "Farbtonhilfsbezeichnung": "Cameo 40",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "146",
    "Bcolor": "140",
    "Y": 30,
    "L": 62.3247566223145,
    "a": 6.74232244491577,
    "b": 5.48196935653687,
    "C": 8.68970108032227,
    "h": 39.1134719848633,
    "CMY_C": 0.34621679782867,
    "CMY_M": 0.42560076713562,
    "CMY_Y": 0.45046734809875,
    "CMYK_C": 0,
    "CMYK_M": 0.12142246961594,
    "CMYK_Y": 0.15945737063885,
    "CMYK_K": 0.34621679782867
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0232",
    "Farbtonhilfsbezeichnung": "Cameo 45",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "164",
    "Bcolor": "157",
    "Y": 39,
    "L": 69.4413223266602,
    "a": 8.29933452606201,
    "b": 6.51129722595215,
    "C": 10.5487413406372,
    "h": 38.1161880493164,
    "CMY_C": 0.25698971748352,
    "CMY_M": 0.35575765371323,
    "CMY_Y": 0.38462042808533,
    "CMYK_C": 0,
    "CMYK_M": 0.13292942941189,
    "CMYK_Y": 0.17177516222,
    "CMYK_K": 0.25698971748352
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0233",
    "Farbtonhilfsbezeichnung": "Cameo 50",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "180",
    "Bcolor": "173",
    "Y": 47,
    "L": 74.7732696533203,
    "a": 6.58458995819092,
    "b": 5.28411102294922,
    "C": 8.44266891479492,
    "h": 38.7469253540039,
    "CMY_C": 0.21423548460007,
    "CMY_M": 0.29488229751587,
    "CMY_Y": 0.32065933942795,
    "CMYK_C": 0,
    "CMYK_M": 0.10263483971357,
    "CMYK_Y": 0.13543988764286,
    "CMYK_K": 0.21423548460007
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0234",
    "Farbtonhilfsbezeichnung": "Cameo 55",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "212",
    "Bcolor": "207",
    "Y": 67,
    "L": 85.9524536132813,
    "a": 5.07898378372192,
    "b": 3.49495697021484,
    "C": 6.16528987884521,
    "h": 34.5326881408691,
    "CMY_C": 0.10707819461823,
    "CMY_M": 0.16971522569656,
    "CMY_Y": 0.1884309053421,
    "CMYK_C": 0,
    "CMYK_M": 0.07014839351177,
    "CMYK_Y": 0.09110844135284,
    "CMYK_K": 0.10707819461823
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0235",
    "Farbtonhilfsbezeichnung": "Cameo 60",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 85,
    "L": 93.7714385986328,
    "a": 2.83126401901245,
    "b": 2.98276829719543,
    "C": 4.1125373840332,
    "h": 46.4926986694336,
    "CMY_C": 0.03800028562546,
    "CMY_M": 0.07731848955154,
    "CMY_Y": 0.09915059804916,
    "CMYK_C": 0,
    "CMYK_M": 0.04087132588029,
    "CMYK_Y": 0.06356583535671,
    "CMYK_K": 0.03800028562546
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0236",
    "Farbtonhilfsbezeichnung": "Cameo 65",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "111",
    "Bcolor": "103",
    "Y": 18,
    "L": 50.0264854431152,
    "a": 12.4681234359741,
    "b": 9.08082675933838,
    "C": 15.4245100021362,
    "h": 36.0667266845703,
    "CMY_C": 0.43058842420578,
    "CMY_M": 0.56381213665009,
    "CMY_Y": 0.59493350982666,
    "CMYK_C": 0,
    "CMYK_M": 0.23396733403206,
    "CMYK_Y": 0.2886226773262,
    "CMYK_K": 0.43058842420578
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0237",
    "Farbtonhilfsbezeichnung": "Cameo 70",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "136",
    "Bcolor": "128",
    "Y": 27,
    "L": 59.6748924255371,
    "a": 11.5597085952759,
    "b": 8.44606399536133,
    "C": 14.3165235519409,
    "h": 36.1536102294922,
    "CMY_C": 0.33581548929214,
    "CMY_M": 0.46510052680969,
    "CMY_Y": 0.49653953313828,
    "CMYK_C": 0,
    "CMYK_M": 0.19465228915215,
    "CMYK_Y": 0.24198703467846,
    "CMYK_K": 0.33581548929214
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0238",
    "Farbtonhilfsbezeichnung": "Cameo 80",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "189",
    "Bcolor": "179",
    "Y": 55,
    "L": 78.9554061889648,
    "a": 9.40732860565186,
    "b": 8.09011745452881,
    "C": 12.4075717926025,
    "h": 40.694881439209,
    "CMY_C": 0.14088249206543,
    "CMY_M": 0.25779908895493,
    "CMY_Y": 0.29614877700806,
    "CMYK_C": 0,
    "CMYK_M": 0.13608917593956,
    "CMYK_Y": 0.18072764575481,
    "CMYK_K": 0.14088249206543
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0239",
    "Farbtonhilfsbezeichnung": "Cameo 85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "210",
    "Bcolor": "203",
    "Y": 67,
    "L": 86.2107925415039,
    "a": 7.97901439666748,
    "b": 5.94898986816406,
    "C": 9.95264530181885,
    "h": 36.7074584960938,
    "CMY_C": 0.07569891214371,
    "CMY_M": 0.17474895715714,
    "CMY_Y": 0.20314061641693,
    "CMYK_C": 0,
    "CMYK_M": 0.10716210305691,
    "CMYK_Y": 0.13787899911404,
    "CMYK_K": 0.07569891214371
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0240",
    "Farbtonhilfsbezeichnung": "Cameo 90",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "223",
    "Bcolor": "217",
    "Y": 77,
    "L": 90.4734649658203,
    "a": 7.32368469238281,
    "b": 4.88764476776123,
    "C": 8.80485248565674,
    "h": 33.7181587219238,
    "CMY_C": 0.03545898199081,
    "CMY_M": 0.12576204538345,
    "CMY_Y": 0.14897871017456,
    "CMYK_C": 0,
    "CMYK_M": 0.09362283349037,
    "CMYK_Y": 0.11769299954176,
    "CMYK_K": 0.03545898199081
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0241",
    "Farbtonhilfsbezeichnung": "Cameo 95",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "85",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.7520446777344,
    "a": 20.9196472167969,
    "b": 16.1244869232178,
    "C": 26.4127006530762,
    "h": 37.6243858337402,
    "CMY_C": 0.45854157209396,
    "CMY_M": 0.66762435436249,
    "CMY_Y": 0.71611267328262,
    "CMYK_C": 0,
    "CMYK_M": 0.38614743947983,
    "CMYK_Y": 0.47569876909256,
    "CMYK_K": 0.45854157209396
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0242",
    "Farbtonhilfsbezeichnung": "Cameo 100",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "123",
    "Bcolor": "109",
    "Y": 24,
    "L": 56.3616638183594,
    "a": 18.7734355926514,
    "b": 14.9338321685791,
    "C": 23.9887733459473,
    "h": 38.5014343261719,
    "CMY_C": 0.31493008136749,
    "CMY_M": 0.51887214183807,
    "CMY_Y": 0.57169842720032,
    "CMYK_C": 0,
    "CMYK_M": 0.29769524931908,
    "CMYK_Y": 0.3748060464859,
    "CMYK_K": 0.31493008136749
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0243",
    "Farbtonhilfsbezeichnung": "Cameo 105",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "157",
    "Bcolor": "142",
    "Y": 41,
    "L": 70.6629180908203,
    "a": 23.6011219024658,
    "b": 16.8455200195313,
    "C": 28.9962844848633,
    "h": 35.5177001953125,
    "CMY_C": 0.12289780378342,
    "CMY_M": 0.38626515865326,
    "CMY_Y": 0.44196343421936,
    "CMYK_C": 0,
    "CMYK_M": 0.30026987195015,
    "CMYK_Y": 0.36377248167992,
    "CMYK_K": 0.12289780378342
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0244",
    "Farbtonhilfsbezeichnung": "Cameo 110",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "175",
    "Bcolor": "163",
    "Y": 48,
    "L": 75.3683242797852,
    "a": 16.2523975372314,
    "b": 12.1331462860107,
    "C": 20.2818546295166,
    "h": 36.7429962158203,
    "CMY_C": 0.12528067827225,
    "CMY_M": 0.31498044729233,
    "CMY_Y": 0.36158430576324,
    "CMYK_C": 0,
    "CMYK_M": 0.21686930954456,
    "CMYK_Y": 0.27014794945717,
    "CMYK_K": 0.12528067827225
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0245",
    "Farbtonhilfsbezeichnung": "Cameo 115",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "199",
    "Bcolor": "190",
    "Y": 62,
    "L": 83.1616668701172,
    "a": 12.7637701034546,
    "b": 8.56832599639893,
    "C": 15.3730297088623,
    "h": 33.8734817504883,
    "CMY_C": 0.06920874118805,
    "CMY_M": 0.22101962566376,
    "CMY_Y": 0.2543061375618,
    "CMYK_C": 0,
    "CMYK_M": 0.16309873759747,
    "CMYK_Y": 0.198860257864,
    "CMYK_K": 0.06920874118805
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0246",
    "Farbtonhilfsbezeichnung": "Cameo 120",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "220",
    "Bcolor": "210",
    "Y": 76,
    "L": 89.9369506835938,
    "a": 8.73097133636475,
    "b": 7.66696786880493,
    "C": 11.6194772720337,
    "h": 41.2874870300293,
    "CMY_C": 0.02327799797058,
    "CMY_M": 0.13603907823563,
    "CMY_Y": 0.17515403032303,
    "CMYK_C": 0,
    "CMYK_M": 0.11544848978519,
    "CMYK_Y": 0.15549565851688,
    "CMYK_K": 0.02327799797058
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0247",
    "Farbtonhilfsbezeichnung": "Cameo 125",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "83",
    "Bcolor": "66",
    "Y": 14,
    "L": 44.2979202270508,
    "a": 30.9358520507813,
    "b": 23.6293792724609,
    "C": 38.9278106689453,
    "h": 37.3732643127441,
    "CMY_C": 0.37045669555664,
    "CMY_M": 0.67625522613525,
    "CMY_Y": 0.73936176300049,
    "CMYK_C": 0,
    "CMYK_M": 0.48574662208557,
    "CMYK_Y": 0.58598840236664,
    "CMYK_K": 0.37045669555664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0248",
    "Farbtonhilfsbezeichnung": "Cameo 130",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "104",
    "Bcolor": "91",
    "Y": 20,
    "L": 51.381893157959,
    "a": 26.7488288879395,
    "b": 18.6974964141846,
    "C": 32.6358108520508,
    "h": 34.9536437988281,
    "CMY_C": 0.31919229030609,
    "CMY_M": 0.59234899282455,
    "CMY_Y": 0.64280998706818,
    "CMYK_C": 0,
    "CMYK_M": 0.40122446417809,
    "CMYK_Y": 0.47534376382828,
    "CMYK_K": 0.31919229030609
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0249",
    "Farbtonhilfsbezeichnung": "Cameo 135",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "127",
    "Bcolor": "111",
    "Y": 28,
    "L": 60.2146949768066,
    "a": 25.6680927276611,
    "b": 19.8932037353516,
    "C": 32.4744606018066,
    "h": 37.7762870788574,
    "CMY_C": 0.22437292337418,
    "CMY_M": 0.50087922811508,
    "CMY_Y": 0.56658744812012,
    "CMYK_C": 0,
    "CMYK_M": 0.35649389028549,
    "CMYK_Y": 0.44121012091637,
    "CMYK_K": 0.22437292337418
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0250",
    "Farbtonhilfsbezeichnung": "Cameo 140",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "167",
    "Bcolor": "150",
    "Y": 49,
    "L": 75.4791870117188,
    "a": 27.103141784668,
    "b": 19.7938137054443,
    "C": 33.5615158081055,
    "h": 36.1411895751953,
    "CMY_C": 0.04063045978546,
    "CMY_M": 0.34648871421814,
    "CMY_Y": 0.41299730539322,
    "CMYK_C": 0,
    "CMYK_M": 0.3188117146492,
    "CMYK_Y": 0.38813704252243,
    "CMYK_K": 0.04063045978546
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0251",
    "Farbtonhilfsbezeichnung": "Cameo 145",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "185",
    "Bcolor": "171",
    "Y": 56,
    "L": 80.1619567871094,
    "a": 20.0843296051025,
    "b": 14.9885978698731,
    "C": 25.0606937408447,
    "h": 36.7333602905273,
    "CMY_C": 0.03963327407837,
    "CMY_M": 0.27490335702896,
    "CMY_Y": 0.33128374814987,
    "CMYK_C": 0,
    "CMYK_M": 0.24497942626476,
    "CMYK_Y": 0.30368655920029,
    "CMYK_K": 0.03963327407837
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0252",
    "Farbtonhilfsbezeichnung": "Cameo 150",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "226",
    "Bcolor": "218",
    "Y": 82,
    "L": 91.4835357666016,
    "a": 6.78310966491699,
    "b": 6.09372711181641,
    "C": 9.11833763122559,
    "h": 41.9355049133301,
    "CMY_C": 0.02445822954178,
    "CMY_M": 0.11351728439331,
    "CMY_Y": 0.14690405130386,
    "CMYK_C": 0,
    "CMYK_M": 0.0912918895483,
    "CMYK_Y": 0.12551571428776,
    "CMYK_K": 0.02445822954178
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0253",
    "Farbtonhilfsbezeichnung": "Cameo 155",
    "Farbtonklasse": "04",
    "Rcolor": "209",
    "Gcolor": "93",
    "Bcolor": "74",
    "Y": 21,
    "L": 53.9109268188477,
    "a": 44.5382652282715,
    "b": 32.7224617004395,
    "C": 55.2667770385742,
    "h": 36.3048896789551,
    "CMY_C": 0.18172639608383,
    "CMY_M": 0.63394248485565,
    "CMY_Y": 0.70907062292099,
    "CMYK_C": 0,
    "CMYK_M": 0.55264657735825,
    "CMYK_Y": 0.64445954561234,
    "CMYK_K": 0.18172639608383
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0254",
    "Farbtonhilfsbezeichnung": "Cameo 160",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "88",
    "Bcolor": "69",
    "Y": 21,
    "L": 54.293815612793,
    "a": 49.8622398376465,
    "b": 36.3670120239258,
    "C": 61.7154960632324,
    "h": 36.1051330566406,
    "CMY_C": 0.14735198020935,
    "CMY_M": 0.65427696704865,
    "CMY_Y": 0.72895979881287,
    "CMYK_C": 0,
    "CMYK_M": 0.59453016519547,
    "CMYK_Y": 0.68211948871613,
    "CMYK_K": 0.14735198020935
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0255",
    "Farbtonhilfsbezeichnung": "Cameo 165",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "91",
    "Bcolor": "67",
    "Y": 24,
    "L": 56.2137298583984,
    "a": 51.265983581543,
    "b": 40.0563430786133,
    "C": 65.0592956542969,
    "h": 38.0020599365234,
    "CMY_C": 0.11399149894714,
    "CMY_M": 0.6412867307663,
    "CMY_Y": 0.73684585094452,
    "CMYK_C": 0,
    "CMYK_M": 0.59513562917709,
    "CMYK_Y": 0.70298916101456,
    "CMYK_K": 0.11399149894714
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0256",
    "Farbtonhilfsbezeichnung": "Cameo 170",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "125",
    "Bcolor": "102",
    "Y": 34,
    "L": 64.5068740844727,
    "a": 40.5950317382813,
    "b": 31.3174877166748,
    "C": 51.2712554931641,
    "h": 37.6487884521484,
    "CMY_C": 0.07663583755493,
    "CMY_M": 0.50876712799072,
    "CMY_Y": 0.6005642414093,
    "CMYK_C": 0,
    "CMYK_M": 0.46799659729004,
    "CMYK_Y": 0.56741255521774,
    "CMYK_K": 0.07663583755493
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0257",
    "Farbtonhilfsbezeichnung": "Cameo 175",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "161",
    "Bcolor": "143",
    "Y": 49,
    "L": 75.7268218994141,
    "a": 34.1003761291504,
    "b": 23.9696941375732,
    "C": 41.6819114685059,
    "h": 35.1039886474609,
    "CMY_C": 0,
    "CMY_M": 0.36673372983932,
    "CMY_Y": 0.43881696462631,
    "CMYK_C": 0,
    "CMYK_M": 0.36673372983932,
    "CMYK_Y": 0.43881696462631,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0258",
    "Farbtonhilfsbezeichnung": "Lachs 15",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "193",
    "Bcolor": "180",
    "Y": 58,
    "L": 80.4244995117188,
    "a": 10.2470664978027,
    "b": 9.97054386138916,
    "C": 14.2973461151123,
    "h": 44.2163963317871,
    "CMY_C": 0.11383879184723,
    "CMY_M": 0.24457049369812,
    "CMY_Y": 0.29399436712265,
    "CMYK_C": 0,
    "CMYK_M": 0.14752586185932,
    "CMYK_Y": 0.20329886674881,
    "CMYK_K": 0.11383879184723
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0259",
    "Farbtonhilfsbezeichnung": "Lachs 20",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "207",
    "Bcolor": "195",
    "Y": 67,
    "L": 85.4582138061523,
    "a": 9.0297384262085,
    "b": 9.07247352600098,
    "C": 12.8002328872681,
    "h": 45.1352615356445,
    "CMY_C": 0.06806355714798,
    "CMY_M": 0.18649399280548,
    "CMY_Y": 0.23393130302429,
    "CMYK_C": 0,
    "CMYK_M": 0.12707994878292,
    "CMYK_Y": 0.17798182368279,
    "CMYK_K": 0.06806355714798
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0260",
    "Farbtonhilfsbezeichnung": "Lachs 25",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "224",
    "Bcolor": "214",
    "Y": 77,
    "L": 90.7552871704102,
    "a": 7.39614915847778,
    "b": 7.14260387420654,
    "C": 10.2820138931274,
    "h": 44.000904083252,
    "CMY_C": 0.02517974376678,
    "CMY_M": 0.12344098091125,
    "CMY_Y": 0.1625509262085,
    "CMYK_C": 0,
    "CMYK_M": 0.10079933702946,
    "CMYK_Y": 0.14091950654984,
    "CMYK_K": 0.02517974376678
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0261",
    "Farbtonhilfsbezeichnung": "Lachs 30",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "221",
    "Y": 82,
    "L": 92.5915298461914,
    "a": 5.37016344070435,
    "b": 5.97187423706055,
    "C": 8.03131008148193,
    "h": 48.0367736816406,
    "CMY_C": 0.02276420593262,
    "CMY_M": 0.09760725498199,
    "CMY_Y": 0.13404071331024,
    "CMYK_C": 0,
    "CMYK_M": 0.07658647745848,
    "CMYK_Y": 0.1138686388731,
    "CMYK_K": 0.02276420593262
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0262",
    "Farbtonhilfsbezeichnung": "Lachs 35",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "128",
    "Bcolor": "111",
    "Y": 27,
    "L": 58.4299545288086,
    "a": 19.0923900604248,
    "b": 17.1174144744873,
    "C": 25.6422557830811,
    "h": 41.8780326843262,
    "CMY_C": 0.28662919998169,
    "CMY_M": 0.49944823980331,
    "CMY_Y": 0.56632602214813,
    "CMYK_C": 0,
    "CMYK_M": 0.29832878708839,
    "CMYK_Y": 0.39207774400711,
    "CMYK_K": 0.28662919998169
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0263",
    "Farbtonhilfsbezeichnung": "Lachs 40",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "147",
    "Bcolor": "133",
    "Y": 34,
    "L": 64.7166976928711,
    "a": 15.1738090515137,
    "b": 13.062180519104,
    "C": 20.021614074707,
    "h": 40.7230987548828,
    "CMY_C": 0.24869233369827,
    "CMY_M": 0.42389899492264,
    "CMY_Y": 0.47714918851852,
    "CMYK_C": 0,
    "CMYK_M": 0.23320227861404,
    "CMYK_Y": 0.30407896637917,
    "CMYK_K": 0.24869233369827
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0264",
    "Farbtonhilfsbezeichnung": "Lachs 45",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "163",
    "Bcolor": "150",
    "Y": 41,
    "L": 70.3285446166992,
    "a": 13.1306200027466,
    "b": 11.6259851455688,
    "C": 17.5378646850586,
    "h": 41.5220069885254,
    "CMY_C": 0.20293086767197,
    "CMY_M": 0.35988050699234,
    "CMY_Y": 0.41056561470032,
    "CMYK_C": 0,
    "CMYK_M": 0.19690844416618,
    "CMYK_Y": 0.2604977786541,
    "CMYK_K": 0.20293086767197
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0265",
    "Farbtonhilfsbezeichnung": "Lachs 50",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "165",
    "Bcolor": "147",
    "Y": 44,
    "L": 72.4012908935547,
    "a": 18.6418209075928,
    "b": 16.8754348754883,
    "C": 25.1455326080322,
    "h": 42.1528434753418,
    "CMY_C": 0.13364708423615,
    "CMY_M": 0.35403400659561,
    "CMY_Y": 0.42538774013519,
    "CMYK_C": 0,
    "CMYK_M": 0.25438469648361,
    "CMYK_Y": 0.33674573898315,
    "CMYK_K": 0.13364708423615
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0266",
    "Farbtonhilfsbezeichnung": "Lachs 55",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "191",
    "Bcolor": "177",
    "Y": 58,
    "L": 80.7185287475586,
    "a": 14.2438945770264,
    "b": 12.2238321304321,
    "C": 18.7699394226074,
    "h": 40.6355476379395,
    "CMY_C": 0.07785820960999,
    "CMY_M": 0.25233525037766,
    "CMY_Y": 0.30649119615555,
    "CMYK_C": 0,
    "CMYK_M": 0.18920847773552,
    "CMYK_Y": 0.24793690443039,
    "CMYK_K": 0.07785820960999
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0267",
    "Farbtonhilfsbezeichnung": "Lachs 60",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "214",
    "Bcolor": "200",
    "Y": 72,
    "L": 87.9895782470703,
    "a": 9.83854103088379,
    "b": 10.1176910400391,
    "C": 14.1125679016113,
    "h": 45.8014068603516,
    "CMY_C": 0.03086370229721,
    "CMY_M": 0.16103386878967,
    "CMY_Y": 0.21417140960693,
    "CMYK_C": 0,
    "CMYK_M": 0.13431563973427,
    "CMYK_Y": 0.18914543092251,
    "CMYK_K": 0.03086370229721
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0268",
    "Farbtonhilfsbezeichnung": "Lachs 65",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "104",
    "Bcolor": "82",
    "Y": 19,
    "L": 50.8155326843262,
    "a": 24.9161891937256,
    "b": 23.2516078948975,
    "C": 34.0801086425781,
    "h": 43.0207633972168,
    "CMY_C": 0.32932960987091,
    "CMY_M": 0.59328293800354,
    "CMY_Y": 0.67881381511688,
    "CMYK_C": 0,
    "CMYK_M": 0.3935663998127,
    "CMYK_Y": 0.52109682559967,
    "CMYK_K": 0.32932960987091
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0269",
    "Farbtonhilfsbezeichnung": "Lachs 70",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "126",
    "Bcolor": "98",
    "Y": 29,
    "L": 60.7113990783691,
    "a": 28.8603382110596,
    "b": 28.0846385955811,
    "C": 40.2699165344238,
    "h": 44.2195701599121,
    "CMY_C": 0.18939489126205,
    "CMY_M": 0.50735127925873,
    "CMY_Y": 0.61751103401184,
    "CMYK_C": 0,
    "CMYK_M": 0.39224570989609,
    "CMYK_Y": 0.52814388275146,
    "CMYK_K": 0.18939489126205
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0270",
    "Farbtonhilfsbezeichnung": "Lachs 75",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "140",
    "Bcolor": "110",
    "Y": 35,
    "L": 65.5058975219727,
    "a": 26.2289199829102,
    "b": 27.5417213439941,
    "C": 38.0329170227051,
    "h": 46.3985900878906,
    "CMY_C": 0.14944916963577,
    "CMY_M": 0.450040102005,
    "CMY_Y": 0.56793403625488,
    "CMYK_C": 0,
    "CMYK_M": 0.35340738296509,
    "CMYK_Y": 0.49201628565788,
    "CMYK_K": 0.14944916963577
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0271",
    "Farbtonhilfsbezeichnung": "Lachs 80",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "151",
    "Bcolor": "128",
    "Y": 41,
    "L": 69.9107894897461,
    "a": 27.1090812683106,
    "b": 23.9738311767578,
    "C": 36.1890449523926,
    "h": 41.4878349304199,
    "CMY_C": 0.09851133823395,
    "CMY_M": 0.40618091821671,
    "CMY_Y": 0.49904012680054,
    "CMYK_C": 0,
    "CMYK_M": 0.34129056334496,
    "CMYK_Y": 0.44429707527161,
    "CMYK_K": 0.09851133823395
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0272",
    "Farbtonhilfsbezeichnung": "Lachs 85",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "173",
    "Y": 65,
    "L": 83.8965530395508,
    "a": 21.2207489013672,
    "b": 19.1880607604981,
    "C": 28.6094722747803,
    "h": 42.1202735900879,
    "CMY_C": 0,
    "CMY_M": 0.23876917362213,
    "CMY_Y": 0.32226926088333,
    "CMYK_C": 0,
    "CMYK_M": 0.23876917362213,
    "CMYK_Y": 0.32226926088333,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0273",
    "Farbtonhilfsbezeichnung": "Lachs 95",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "86",
    "Bcolor": "58",
    "Y": 17,
    "L": 48.8946685791016,
    "a": 38.6901893615723,
    "b": 35.1015243530273,
    "C": 52.2402877807617,
    "h": 42.215763092041,
    "CMY_C": 0.26857823133469,
    "CMY_M": 0.66160178184509,
    "CMY_Y": 0.77311742305756,
    "CMYK_C": 0,
    "CMYK_M": 0.53734189271927,
    "CMYK_Y": 0.68980610370636,
    "CMYK_K": 0.26857823133469
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0274",
    "Farbtonhilfsbezeichnung": "Lachs 100",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "100",
    "Bcolor": "73",
    "Y": 19,
    "L": 52.0026664733887,
    "a": 33.0894470214844,
    "b": 30.2280654907227,
    "C": 44.8179359436035,
    "h": 42.4125061035156,
    "CMY_C": 0.26502168178558,
    "CMY_M": 0.60923498868942,
    "CMY_Y": 0.71296465396881,
    "CMYK_C": 0,
    "CMYK_M": 0.46833124756813,
    "CMYK_Y": 0.60946422815323,
    "CMYK_K": 0.26502168178558
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0275",
    "Farbtonhilfsbezeichnung": "Lachs 105",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "115",
    "Bcolor": "85",
    "Y": 25,
    "L": 57.9528579711914,
    "a": 32.5310401916504,
    "b": 31.3892803192139,
    "C": 45.2057037353516,
    "h": 43.976676940918,
    "CMY_C": 0.19761204719543,
    "CMY_M": 0.54784816503525,
    "CMY_Y": 0.66577333211899,
    "CMYK_C": 0,
    "CMYK_M": 0.43649223446846,
    "CMYK_Y": 0.58346003293991,
    "CMYK_K": 0.19761204719543
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0277",
    "Farbtonhilfsbezeichnung": "Lachs 120",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "161",
    "Bcolor": "135",
    "Y": 48,
    "L": 75.1884841918945,
    "a": 32.4911842346191,
    "b": 27.6531620025635,
    "C": 42.6658477783203,
    "h": 40.4010200500488,
    "CMY_C": 0,
    "CMY_M": 0.36812615394592,
    "CMY_Y": 0.47102683782578,
    "CMYK_C": 0,
    "CMYK_M": 0.36812615394592,
    "CMYK_Y": 0.47102683782578,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0278",
    "Farbtonhilfsbezeichnung": "Aprico 5",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "155",
    "Bcolor": "144",
    "Y": 35,
    "L": 65.6354675292969,
    "a": 7.38737440109253,
    "b": 8.12247657775879,
    "C": 10.9794321060181,
    "h": 47.713550567627,
    "CMY_C": 0.30002093315125,
    "CMY_M": 0.39364367723465,
    "CMY_Y": 0.43496966362,
    "CMYK_C": 0,
    "CMYK_M": 0.13375078141689,
    "CMYK_Y": 0.19278965890408,
    "CMYK_K": 0.30002093315125
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0279",
    "Farbtonhilfsbezeichnung": "Aprico 10",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "168",
    "Bcolor": "159",
    "Y": 41,
    "L": 70.5942306518555,
    "a": 6.86920595169067,
    "b": 7.25883913040161,
    "C": 9.99383449554443,
    "h": 46.5797424316406,
    "CMY_C": 0.25234299898148,
    "CMY_M": 0.3403599858284,
    "CMY_Y": 0.37815564870834,
    "CMYK_C": 0,
    "CMYK_M": 0.11772374808788,
    "CMYK_Y": 0.16827589273453,
    "CMYK_K": 0.25234299898148
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0280",
    "Farbtonhilfsbezeichnung": "Aprico 15",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "199",
    "Bcolor": "191",
    "Y": 59,
    "L": 81.1823196411133,
    "a": 3.94997954368591,
    "b": 5.09605884552002,
    "C": 6.44764709472656,
    "h": 52.2205657958984,
    "CMY_C": 0.16348457336426,
    "CMY_M": 0.21951544284821,
    "CMY_Y": 0.25168979167938,
    "CMYK_C": 0,
    "CMYK_M": 0.06698127090931,
    "CMYK_Y": 0.10544362664223,
    "CMYK_K": 0.16348457336426
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0281",
    "Farbtonhilfsbezeichnung": "Aprico 20",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "212",
    "Bcolor": "206",
    "Y": 67,
    "L": 85.422248840332,
    "a": 2.59138798713684,
    "b": 3.18852066993713,
    "C": 4.10876560211182,
    "h": 50.8984031677246,
    "CMY_C": 0.13257747888565,
    "CMY_M": 0.16943120956421,
    "CMY_Y": 0.19230961799622,
    "CMYK_C": 0,
    "CMYK_M": 0.04248648136854,
    "CMYK_Y": 0.06886164098978,
    "CMYK_K": 0.13257747888565
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0282",
    "Farbtonhilfsbezeichnung": "Aprico 25",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "228",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.8351821899414,
    "a": 1.25322699546814,
    "b": 2.75009083747864,
    "C": 3.02218103408813,
    "h": 65.5010604858398,
    "CMY_C": 0.08398193120956,
    "CMY_M": 0.10623216629028,
    "CMY_Y": 0.13008671998978,
    "CMYK_C": 0,
    "CMYK_M": 0.02429017052054,
    "CMYK_Y": 0.05033174529672,
    "CMYK_K": 0.08398193120956
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0283",
    "Farbtonhilfsbezeichnung": "Aprico 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 80,
    "L": 91.8203430175781,
    "a": 0.54672223329544,
    "b": 1.7451319694519,
    "C": 1.82876753807068,
    "h": 72.6050567626953,
    "CMY_C": 0.08179914951324,
    "CMY_M": 0.0932725071907,
    "CMY_Y": 0.11187273263931,
    "CMYK_C": 0,
    "CMYK_M": 0.01249547675252,
    "CMYK_Y": 0.03275272995234,
    "CMYK_K": 0.08179914951324
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0284",
    "Farbtonhilfsbezeichnung": "Aprico 35",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "116",
    "Bcolor": "103",
    "Y": 19,
    "L": 51.3537101745605,
    "a": 10.7493715286255,
    "b": 11.329644203186,
    "C": 15.6176128387451,
    "h": 46.5054817199707,
    "CMY_C": 0.42253804206848,
    "CMY_M": 0.54704058170319,
    "CMY_Y": 0.59729713201523,
    "CMYK_C": 0,
    "CMYK_M": 0.21560300886631,
    "CMYK_Y": 0.3026330769062,
    "CMYK_K": 0.42253804206848
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0285",
    "Farbtonhilfsbezeichnung": "Aprico 40",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "137",
    "Bcolor": "125",
    "Y": 28,
    "L": 59.7168388366699,
    "a": 9.85005760192871,
    "b": 10.6842555999756,
    "C": 14.5319290161133,
    "h": 47.3263397216797,
    "CMY_C": 0.34122222661972,
    "CMY_M": 0.46098899841309,
    "CMY_Y": 0.51159179210663,
    "CMYK_C": 0,
    "CMYK_M": 0.18180148303509,
    "CMYK_Y": 0.25861462950706,
    "CMYK_K": 0.34122222661972
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0286",
    "Farbtonhilfsbezeichnung": "Aprico 45",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "177",
    "Bcolor": "163",
    "Y": 48,
    "L": 75.249870300293,
    "a": 12.3162393569946,
    "b": 11.8841028213501,
    "C": 17.114953994751,
    "h": 43.9770011901855,
    "CMY_C": 0.15304726362228,
    "CMY_M": 0.3058415055275,
    "CMY_Y": 0.36170083284378,
    "CMYK_C": 0,
    "CMYK_M": 0.1804046779871,
    "CMYK_Y": 0.24635797739029,
    "CMYK_K": 0.15304726362228
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0287",
    "Farbtonhilfsbezeichnung": "Aprico 50",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "196",
    "Bcolor": "183",
    "Y": 59,
    "L": 81.2644805908203,
    "a": 8.28408145904541,
    "b": 9.69247722625732,
    "C": 12.750298500061,
    "h": 49.4797592163086,
    "CMY_C": 0.11879456043243,
    "CMY_M": 0.23046028614044,
    "CMY_Y": 0.28338587284088,
    "CMYK_C": 0,
    "CMYK_M": 0.12671928107738,
    "CMYK_Y": 0.18677972257137,
    "CMYK_K": 0.11879456043243
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0288",
    "Farbtonhilfsbezeichnung": "Aprico 60",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "224",
    "Bcolor": "211",
    "Y": 78,
    "L": 90.73583984375,
    "a": 6.52653455734253,
    "b": 8.6941385269165,
    "C": 10.8712329864502,
    "h": 53.105094909668,
    "CMY_C": 0.02737390995026,
    "CMY_M": 0.12189078330994,
    "CMY_Y": 0.17437833547592,
    "CMYK_C": 0,
    "CMYK_M": 0.09717698395252,
    "CMYK_Y": 0.15114176273346,
    "CMYK_K": 0.02737390995026
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0289",
    "Farbtonhilfsbezeichnung": "Aprico 65",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "137",
    "Bcolor": "120",
    "Y": 28,
    "L": 60.6475257873535,
    "a": 13.5100555419922,
    "b": 14.8755254745483,
    "C": 20.0948467254639,
    "h": 47.7540512084961,
    "CMY_C": 0.29980492591858,
    "CMY_M": 0.46166968345642,
    "CMY_Y": 0.53036111593246,
    "CMYK_C": 0,
    "CMYK_M": 0.2311709523201,
    "CMYK_Y": 0.32927423715591,
    "CMYK_K": 0.29980492591858
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0290",
    "Farbtonhilfsbezeichnung": "Aprico 70",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "151",
    "Bcolor": "135",
    "Y": 35,
    "L": 65.5479965209961,
    "a": 12.148383140564,
    "b": 13.2999267578125,
    "C": 18.0130863189697,
    "h": 47.5908813476563,
    "CMY_C": 0.25811183452606,
    "CMY_M": 0.4075670838356,
    "CMY_Y": 0.47095614671707,
    "CMYK_C": 0,
    "CMYK_M": 0.20145253837109,
    "CMYK_Y": 0.28689542412758,
    "CMYK_K": 0.25811183452606
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0291",
    "Farbtonhilfsbezeichnung": "Aprico 80",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "189",
    "Bcolor": "170",
    "Y": 56,
    "L": 80.0151214599609,
    "a": 13.6901683807373,
    "b": 14.9498929977417,
    "C": 20.2711620330811,
    "h": 47.5185127258301,
    "CMY_C": 0.08328431844711,
    "CMY_M": 0.25914925336838,
    "CMY_Y": 0.33366966247559,
    "CMYK_C": 0,
    "CMYK_M": 0.19184239208698,
    "CMYK_Y": 0.27313303947449,
    "CMYK_K": 0.08328431844711
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0292",
    "Farbtonhilfsbezeichnung": "Aprico 85",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "190",
    "Bcolor": "174",
    "Y": 56,
    "L": 79.9131240844727,
    "a": 12.5969324111938,
    "b": 12.6044158935547,
    "C": 17.8200454711914,
    "h": 45.0170135498047,
    "CMY_C": 0.09714770317078,
    "CMY_M": 0.25680410861969,
    "CMY_Y": 0.31800609827042,
    "CMYK_C": 0,
    "CMYK_M": 0.17683558166027,
    "CMYK_Y": 0.24462294578552,
    "CMYK_K": 0.09714770317078
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0293",
    "Farbtonhilfsbezeichnung": "Aprico 95",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "114",
    "Bcolor": "93",
    "Y": 20,
    "L": 52.6047554016113,
    "a": 16.5481681823731,
    "b": 19.0057754516602,
    "C": 25.2004241943359,
    "h": 48.9541854858398,
    "CMY_C": 0.36182487010956,
    "CMY_M": 0.55112665891647,
    "CMY_Y": 0.63540756702423,
    "CMYK_C": 0,
    "CMYK_M": 0.29662984609604,
    "CMYK_Y": 0.42869532108307,
    "CMYK_K": 0.36182487010956
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0294",
    "Farbtonhilfsbezeichnung": "Aprico 100",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "142",
    "Bcolor": "112",
    "Y": 34,
    "L": 65.3424758911133,
    "a": 22.7513694763184,
    "b": 26.0931701660156,
    "C": 34.6190452575684,
    "h": 48.9139099121094,
    "CMY_C": 0.17345970869064,
    "CMY_M": 0.4411848783493,
    "CMY_Y": 0.56013715267181,
    "CMYK_C": 0,
    "CMYK_M": 0.32391062378883,
    "CMYK_Y": 0.46782648563385,
    "CMYK_K": 0.17345970869064
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0295",
    "Farbtonhilfsbezeichnung": "Aprico 105",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "144",
    "Bcolor": "121",
    "Y": 33,
    "L": 64.2332000732422,
    "a": 17.4541358947754,
    "b": 19.324577331543,
    "C": 26.0400867462158,
    "h": 47.9113616943359,
    "CMY_C": 0.22821062803268,
    "CMY_M": 0.43638169765472,
    "CMY_Y": 0.52489292621613,
    "CMYK_C": 0,
    "CMYK_M": 0.26972523331642,
    "CMYK_Y": 0.38440838456154,
    "CMYK_K": 0.22821062803268
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0296",
    "Farbtonhilfsbezeichnung": "Aprico 110",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "156",
    "Bcolor": "124",
    "Y": 42,
    "L": 70.5614166259766,
    "a": 23.0165939331055,
    "b": 26.6636257171631,
    "C": 35.2237510681152,
    "h": 49.198558807373,
    "CMY_C": 0.11095833778381,
    "CMY_M": 0.38786381483078,
    "CMY_Y": 0.51252955198288,
    "CMYK_C": 0,
    "CMYK_M": 0.31146514415741,
    "CMYK_Y": 0.45168998837471,
    "CMYK_K": 0.11095833778381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0297",
    "Farbtonhilfsbezeichnung": "Aprico 115",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "169",
    "Bcolor": "138",
    "Y": 49,
    "L": 75.4364852905273,
    "a": 23.0910549163818,
    "b": 26.1936359405518,
    "C": 34.9185256958008,
    "h": 48.6021423339844,
    "CMY_C": 0.05459582805634,
    "CMY_M": 0.33659464120865,
    "CMY_Y": 0.4601166844368,
    "CMYK_C": 0,
    "CMYK_M": 0.29828387498856,
    "CMYK_Y": 0.42893913388252,
    "CMYK_K": 0.05459582805634
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0298",
    "Farbtonhilfsbezeichnung": "Aprico 120",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "170",
    "Bcolor": "143",
    "Y": 47,
    "L": 74.6896743774414,
    "a": 19.7566204071045,
    "b": 22.1676464080811,
    "C": 29.6939144134521,
    "h": 48.2914009094238,
    "CMY_C": 0.09063583612442,
    "CMY_M": 0.33416378498077,
    "CMY_Y": 0.43948882818222,
    "CMYK_C": 0,
    "CMYK_M": 0.26780024170876,
    "CMYK_Y": 0.38362297415733,
    "CMYK_K": 0.09063583612442
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0299",
    "Farbtonhilfsbezeichnung": "Aprico 125",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "106",
    "Bcolor": "69",
    "Y": 22,
    "L": 54.7552185058594,
    "a": 33.164909362793,
    "b": 36.1272888183594,
    "C": 49.0417404174805,
    "h": 47.4480209350586,
    "CMY_C": 0.22694367170334,
    "CMY_M": 0.58303779363632,
    "CMY_Y": 0.72877353429794,
    "CMYK_C": 0,
    "CMYK_M": 0.46063151955605,
    "CMYK_Y": 0.64915043115616,
    "CMYK_K": 0.22694367170334
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0300",
    "Farbtonhilfsbezeichnung": "Aprico 130",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "128",
    "Bcolor": "89",
    "Y": 30,
    "L": 61.7412719726563,
    "a": 29.2541522979736,
    "b": 34.4746932983398,
    "C": 45.2140464782715,
    "h": 49.6831016540527,
    "CMY_C": 0.16765820980072,
    "CMY_M": 0.49930346012115,
    "CMY_Y": 0.6525861620903,
    "CMYK_C": 0,
    "CMYK_M": 0.39844840764999,
    "CMYK_Y": 0.58260673284531,
    "CMYK_K": 0.16765820980072
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0301",
    "Farbtonhilfsbezeichnung": "Aprico 135",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "125",
    "Bcolor": "95",
    "Y": 28,
    "L": 59.9432678222656,
    "a": 26.5571823120117,
    "b": 28.477876663208,
    "C": 38.9393539428711,
    "h": 46.998779296875,
    "CMY_C": 0.21049934625626,
    "CMY_M": 0.50811231136322,
    "CMY_Y": 0.62816762924194,
    "CMYK_C": 0,
    "CMYK_M": 0.37696355581284,
    "CMYK_Y": 0.52902841567993,
    "CMYK_K": 0.21049934625626
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0302",
    "Farbtonhilfsbezeichnung": "Aprico 140",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "125",
    "Bcolor": "79",
    "Y": 34,
    "L": 65.1166076660156,
    "a": 41.507266998291,
    "b": 44.7180137634277,
    "C": 61.0127372741699,
    "h": 47.1325225830078,
    "CMY_C": 0.05107587575912,
    "CMY_M": 0.50832343101501,
    "CMY_Y": 0.6913161277771,
    "CMYK_C": 0,
    "CMYK_M": 0.4818589091301,
    "CMYK_Y": 0.67470121383667,
    "CMYK_K": 0.05107587575912
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0303",
    "Farbtonhilfsbezeichnung": "Aprico 145",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "134",
    "Bcolor": "82",
    "Y": 39,
    "L": 68.811882019043,
    "a": 42.5256042480469,
    "b": 47.7861595153809,
    "C": 63.9683036804199,
    "h": 48.3336448669434,
    "CMY_C": 0,
    "CMY_M": 0.47392475605011,
    "CMY_Y": 0.67870104312897,
    "CMYK_C": 0,
    "CMYK_M": 0.47392475605011,
    "CMYK_Y": 0.67870104312897,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0304",
    "Farbtonhilfsbezeichnung": "Aprico 150",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "178",
    "Bcolor": "144",
    "Y": 56,
    "L": 79.867057800293,
    "a": 27.4616870880127,
    "b": 28.9907188415527,
    "C": 39.9325180053711,
    "h": 46.5514945983887,
    "CMY_C": 0,
    "CMY_M": 0.30282193422318,
    "CMY_Y": 0.43428987264633,
    "CMYK_C": 0,
    "CMYK_M": 0.30282193422318,
    "CMYK_Y": 0.43428987264633,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0305",
    "Farbtonhilfsbezeichnung": "Aprico 175",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "218",
    "Bcolor": "201",
    "Y": 76,
    "L": 89.5478591918945,
    "a": 10.4595413208008,
    "b": 12.1605854034424,
    "C": 16.0400066375732,
    "h": 49.3005752563477,
    "CMY_C": 0.00337696075439,
    "CMY_M": 0.14597719907761,
    "CMY_Y": 0.21227622032166,
    "CMYK_C": 0,
    "CMYK_M": 0.14308342337608,
    "CMYK_Y": 0.20960709452629,
    "CMYK_K": 0.00337696075439
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0306",
    "Farbtonhilfsbezeichnung": "Aprico 180",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "227",
    "Bcolor": "214",
    "Y": 82,
    "L": 91.6450271606445,
    "a": 5.60776901245117,
    "b": 7.98120927810669,
    "C": 9.75432109832764,
    "h": 54.907299041748,
    "CMY_C": 0.02584266662598,
    "CMY_M": 0.10929638147354,
    "CMY_Y": 0.15930598974228,
    "CMYK_C": 0,
    "CMYK_M": 0.0856675952673,
    "CMYK_Y": 0.13700386881828,
    "CMYK_K": 0.02584266662598
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0307",
    "Farbtonhilfsbezeichnung": "Perl 5",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "140",
    "Bcolor": "121",
    "Y": 29,
    "L": 60.5743838576114,
    "a": 9.65661142393859,
    "b": 13.9559599814481,
    "C": 16.9711214478219,
    "h": 0.96550392554953,
    "CMY_C": 0.326328,
    "CMY_M": 0.4525795,
    "CMY_Y": 0.5254565,
    "CMYK_C": 0,
    "CMYK_M": 0.187408,
    "CMYK_Y": 0.2955867,
    "CMYK_K": 0.326328
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0308",
    "Farbtonhilfsbezeichnung": "Perl 10",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "152",
    "Bcolor": "131",
    "Y": 35,
    "L": 65.7512724664233,
    "a": 11.2389636582677,
    "b": 15.8896896749565,
    "C": 19.4626961667257,
    "h": 0.95518000863545,
    "CMY_C": 0.2562836,
    "CMY_M": 0.403801,
    "CMY_Y": 0.4870612,
    "CMYK_C": 0,
    "CMYK_M": 0.1983516,
    "CMYK_Y": 0.3103032,
    "CMYK_K": 0.2562836
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0309",
    "Farbtonhilfsbezeichnung": "Perl 15",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "168",
    "Bcolor": "144",
    "Y": 46,
    "L": 72.376962188937,
    "a": 13.2197380977319,
    "b": 18.2970280978956,
    "C": 22.5730527972581,
    "h": 0.94512389648318,
    "CMY_C": 0.1654027,
    "CMY_M": 0.3401935,
    "CMY_Y": 0.4367062,
    "CMYK_C": 0,
    "CMYK_M": 0.2094313,
    "CMYK_Y": 0.3250712,
    "CMYK_K": 0.1654027
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0310",
    "Farbtonhilfsbezeichnung": "Perl 20",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "175",
    "Bcolor": "151",
    "Y": 49,
    "L": 75.1415182628456,
    "a": 14.3072142792489,
    "b": 18.1414416786861,
    "C": 23.1042915194021,
    "h": 0.90301567979608,
    "CMY_C": 0.127624,
    "CMY_M": 0.3137363,
    "CMY_Y": 0.4071057,
    "CMYK_C": 0,
    "CMYK_M": 0.2133395,
    "CMYK_Y": 0.3203683,
    "CMYK_K": 0.127624
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0311",
    "Farbtonhilfsbezeichnung": "Perl 25",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "191",
    "Bcolor": "171",
    "Y": 56,
    "L": 79.9550449768553,
    "a": 10.6404584653083,
    "b": 14.4574362052315,
    "C": 17.9509559071457,
    "h": 0.93632521922533,
    "CMY_C": 0.1055455,
    "CMY_M": 0.2518146,
    "CMY_Y": 0.331268,
    "CMYK_C": 0,
    "CMYK_M": 0.1635288,
    "CMYK_Y": 0.2523577,
    "CMYK_K": 0.1055455
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0312",
    "Farbtonhilfsbezeichnung": "Perl 30",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "218",
    "Bcolor": "206",
    "Y": 75,
    "L": 88.8129350906727,
    "a": 6.91216669238098,
    "b": 8.18737936372223,
    "C": 10.7150001973292,
    "h": 0.86965194078541,
    "CMY_C": 0.04779071,
    "CMY_M": 0.14406,
    "CMY_Y": 0.1915074,
    "CMYK_C": 0,
    "CMYK_M": 0.1011009,
    "CMYK_Y": 0.1509297,
    "CMYK_K": 0.04779071
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0313",
    "Farbtonhilfsbezeichnung": "Perl 40",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "162",
    "Bcolor": "139",
    "Y": 42,
    "L": 70.3253424392641,
    "a": 14.485342530679,
    "b": 18.0360690810621,
    "C": 23.1327675847043,
    "h": 0.8941486014515,
    "CMY_C": 0.1808641,
    "CMY_M": 0.3650069,
    "CMY_Y": 0.4554643,
    "CMYK_C": 0,
    "CMYK_M": 0.2248013,
    "CMYK_Y": 0.3352315,
    "CMYK_K": 0.1808641
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0314",
    "Farbtonhilfsbezeichnung": "Perl 45",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "178",
    "Bcolor": "151",
    "Y": 51,
    "L": 76.3062061869824,
    "a": 14.8030910734061,
    "b": 20.1988507269095,
    "C": 25.0424654540149,
    "h": 0.93835016851432,
    "CMY_C": 0.1070984,
    "CMY_M": 0.303127,
    "CMY_Y": 0.4097863,
    "CMYK_C": 0,
    "CMYK_M": 0.2195411,
    "CMYK_Y": 0.3389936,
    "CMYK_K": 0.1070984
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0315",
    "Farbtonhilfsbezeichnung": "Perl 50",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "203",
    "Bcolor": "182",
    "Y": 66,
    "L": 84.7759692371936,
    "a": 12.3381189789069,
    "b": 15.1791017880321,
    "C": 19.5610406427956,
    "h": 0.88827747023089,
    "CMY_C": 0.03762098,
    "CMY_M": 0.204084,
    "CMY_Y": 0.2852994,
    "CMYK_C": 0,
    "CMYK_M": 0.1729703,
    "CMYK_Y": 0.2573605,
    "CMYK_K": 0.03762098
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0316",
    "Farbtonhilfsbezeichnung": "Perl 55",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "215",
    "Bcolor": "194",
    "Y": 76,
    "L": 88.4943190875078,
    "a": 10.6618768907162,
    "b": 14.2968610291969,
    "C": 17.8346812172508,
    "h": 0.93002109600066,
    "CMY_C": 0.008698091,
    "CMY_M": 0.1587234,
    "CMY_Y": 0.2393664,
    "CMYK_C": 0,
    "CMYK_M": 0.1513417,
    "CMYK_Y": 0.2326923,
    "CMYK_K": 0.008698091
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0317",
    "Farbtonhilfsbezeichnung": "Perl 60",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "223",
    "Bcolor": "209",
    "Y": 81,
    "L": 90.4299095487523,
    "a": 7.07380972310412,
    "b": 9.02875874436548,
    "C": 11.4698416930069,
    "h": 0.90621293538986,
    "CMY_C": 0.02592991,
    "CMY_M": 0.1267901,
    "CMY_Y": 0.1801035,
    "CMYK_C": 0,
    "CMYK_M": 0.1035452,
    "CMYK_Y": 0.1582778,
    "CMYK_K": 0.02592991
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0318",
    "Farbtonhilfsbezeichnung": "Ceramic 5",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "118",
    "Bcolor": "100",
    "Y": 19,
    "L": 51.743766784668,
    "a": 8.48382759094238,
    "b": 13.2183084487915,
    "C": 15.706654548645,
    "h": 57.3066787719727,
    "CMY_C": 0.42843157052994,
    "CMY_M": 0.53814685344696,
    "CMY_Y": 0.60645318031311,
    "CMYK_C": 0,
    "CMYK_M": 0.19195476174355,
    "CMYK_Y": 0.31146159768105,
    "CMYK_K": 0.42843157052994
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0319",
    "Farbtonhilfsbezeichnung": "Ceramic 10",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "140",
    "Bcolor": "122",
    "Y": 28,
    "L": 60.2264823913574,
    "a": 7.78401660919189,
    "b": 12.6009969711304,
    "C": 14.8113479614258,
    "h": 58.2951164245605,
    "CMY_C": 0.34475493431091,
    "CMY_M": 0.45124572515488,
    "CMY_Y": 0.51994162797928,
    "CMYK_C": 0,
    "CMYK_M": 0.16252055764198,
    "CMYK_Y": 0.26736056804657,
    "CMYK_K": 0.34475493431091
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0320",
    "Farbtonhilfsbezeichnung": "Ceramic 20",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "170",
    "Bcolor": "158",
    "Y": 42,
    "L": 70.9433135986328,
    "a": 5.25603151321411,
    "b": 8.20873165130615,
    "C": 9.74726295471191,
    "h": 57.3686561584473,
    "CMY_C": 0.25720757246017,
    "CMY_M": 0.33305341005325,
    "CMY_Y": 0.38146430253983,
    "CMYK_C": 0,
    "CMYK_M": 0.10210905969143,
    "CMYK_Y": 0.1672832518816,
    "CMYK_K": 0.25720757246017
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0321",
    "Farbtonhilfsbezeichnung": "Ceramic 25",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "185",
    "Bcolor": "174",
    "Y": 50,
    "L": 76.0724182128906,
    "a": 4.40514469146729,
    "b": 6.88616466522217,
    "C": 8.17462921142578,
    "h": 57.3925704956055,
    "CMY_C": 0.21107590198517,
    "CMY_M": 0.27617806196213,
    "CMY_Y": 0.31871747970581,
    "CMYK_C": 0,
    "CMYK_M": 0.08252017945051,
    "CMYK_Y": 0.13644097745419,
    "CMYK_K": 0.21107590198517
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0322",
    "Farbtonhilfsbezeichnung": "Ceramic 30",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "198",
    "Bcolor": "189",
    "Y": 58,
    "L": 80.8245391845703,
    "a": 3.73537182807922,
    "b": 5.50325107574463,
    "C": 6.65122365951538,
    "h": 55.8330116271973,
    "CMY_C": 0.16780042648315,
    "CMY_M": 0.2229927778244,
    "CMY_Y": 0.25848996639252,
    "CMYK_C": 0,
    "CMYK_M": 0.06632105261087,
    "CMYK_Y": 0.10897570848465,
    "CMYK_K": 0.16780042648315
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0323",
    "Farbtonhilfsbezeichnung": "Ceramic 35",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "165",
    "Bcolor": "144",
    "Y": 40,
    "L": 70.3112411499023,
    "a": 9.938645362854,
    "b": 14.951210975647,
    "C": 17.9531440734863,
    "h": 56.3864822387695,
    "CMY_C": 0.21653836965561,
    "CMY_M": 0.35275512933731,
    "CMY_Y": 0.4346609711647,
    "CMYK_C": 0,
    "CMYK_M": 0.1738652586937,
    "CMYK_Y": 0.27840879559517,
    "CMYK_K": 0.21653836965561
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0324",
    "Farbtonhilfsbezeichnung": "Ceramic 40",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "179",
    "Bcolor": "160",
    "Y": 48,
    "L": 75.2420806884766,
    "a": 9.07373428344727,
    "b": 13.3621397018433,
    "C": 16.151762008667,
    "h": 55.8210258483887,
    "CMY_C": 0.17135655879974,
    "CMY_M": 0.29806572198868,
    "CMY_Y": 0.37285131216049,
    "CMYK_C": 0,
    "CMYK_M": 0.15291155874729,
    "CMYK_Y": 0.24316218495369,
    "CMYK_K": 0.17135655879974
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0325",
    "Farbtonhilfsbezeichnung": "Ceramic 45",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "187",
    "Bcolor": "165",
    "Y": 54,
    "L": 78.587272644043,
    "a": 10.3204565048218,
    "b": 15.6171731948853,
    "C": 18.7191867828369,
    "h": 56.5416679382324,
    "CMY_C": 0.12041699886322,
    "CMY_M": 0.26596033573151,
    "CMY_Y": 0.35400468111038,
    "CMYK_C": 0,
    "CMYK_M": 0.16546855866909,
    "CMYK_Y": 0.26556637883186,
    "CMYK_K": 0.12041699886322
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0326",
    "Farbtonhilfsbezeichnung": "Ceramic 50",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "192",
    "Bcolor": "170",
    "Y": 56,
    "L": 80.1068878173828,
    "a": 9.64830112457275,
    "b": 15.070484161377,
    "C": 17.8943901062012,
    "h": 57.3721466064453,
    "CMY_C": 0.10911720991135,
    "CMY_M": 0.24775916337967,
    "CMY_Y": 0.33427381515503,
    "CMYK_C": 0,
    "CMYK_M": 0.15562310814857,
    "CMYK_Y": 0.2527342736721,
    "CMYK_K": 0.10911720991135
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0327",
    "Farbtonhilfsbezeichnung": "Ceramic 55",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "198",
    "Bcolor": "181",
    "Y": 59,
    "L": 81.5142135620117,
    "a": 6.80436182022095,
    "b": 10.9636831283569,
    "C": 12.9035530090332,
    "h": 58.1751327514648,
    "CMY_C": 0.12308996915817,
    "CMY_M": 0.22439938783646,
    "CMY_Y": 0.29017144441605,
    "CMYK_C": 0,
    "CMYK_M": 0.11553000658751,
    "CMYK_Y": 0.19053433835506,
    "CMYK_K": 0.12308996915817
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0328",
    "Farbtonhilfsbezeichnung": "Ceramic 65",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "153",
    "Bcolor": "123",
    "Y": 36,
    "L": 66.7201538085938,
    "a": 13.6111936569214,
    "b": 21.770809173584,
    "C": 25.6755275726318,
    "h": 57.9862174987793,
    "CMY_C": 0.21955370903015,
    "CMY_M": 0.40107077360153,
    "CMY_Y": 0.51808220148087,
    "CMYK_C": 0,
    "CMYK_M": 0.23258110880852,
    "CMYK_Y": 0.38250997662544,
    "CMYK_K": 0.21955370903015
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0329",
    "Farbtonhilfsbezeichnung": "Ceramic 70",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "175",
    "Bcolor": "144",
    "Y": 48,
    "L": 75.0781784057617,
    "a": 13.9740228652954,
    "b": 22.0841655731201,
    "C": 26.1339569091797,
    "h": 57.6759223937988,
    "CMY_C": 0.12267971038818,
    "CMY_M": 0.31437683105469,
    "CMY_Y": 0.43606734275818,
    "CMYK_C": 0,
    "CMYK_M": 0.21850301325321,
    "CMYK_Y": 0.35721006989479,
    "CMYK_K": 0.12267971038818
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0330",
    "Farbtonhilfsbezeichnung": "Ceramic 75",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "203",
    "Bcolor": "177",
    "Y": 65,
    "L": 84.6211700439453,
    "a": 11.1045236587524,
    "b": 17.5045909881592,
    "C": 20.7297172546387,
    "h": 57.6098670959473,
    "CMY_C": 0.04241228103638,
    "CMY_M": 0.20308935642242,
    "CMY_Y": 0.30417048931122,
    "CMYK_C": 0,
    "CMYK_M": 0.16779358685017,
    "CMYK_Y": 0.27335166931152,
    "CMYK_K": 0.04241228103638
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0331",
    "Farbtonhilfsbezeichnung": "Ceramic 80",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "214",
    "Bcolor": "189",
    "Y": 75,
    "L": 88.4715194702148,
    "a": 10.5623073577881,
    "b": 16.6669998168945,
    "C": 19.7319850921631,
    "h": 57.6365089416504,
    "CMY_C": 0.00392490625381,
    "CMY_M": 0.15926402807236,
    "CMY_Y": 0.25711935758591,
    "CMYK_C": 0,
    "CMYK_M": 0.1559512168169,
    "CMYK_Y": 0.25419214367867,
    "CMYK_K": 0.00392490625381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0332",
    "Farbtonhilfsbezeichnung": "Ceramic 85",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "225",
    "Bcolor": "209",
    "Y": 82,
    "L": 91.1775131225586,
    "a": 6.39123058319092,
    "b": 10.1602020263672,
    "C": 12.0032300949097,
    "h": 57.8282356262207,
    "CMY_C": 0.01925611495972,
    "CMY_M": 0.11703556776047,
    "CMY_Y": 0.18044584989548,
    "CMYK_C": 0,
    "CMYK_M": 0.09969927370548,
    "CMYK_Y": 0.1643545627594,
    "CMYK_K": 0.01925611495972
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0333",
    "Farbtonhilfsbezeichnung": "Ceramic 90",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 87,
    "L": 93.5510177612305,
    "a": 2.66295433044434,
    "b": 4.12317609786987,
    "C": 4.90835094451904,
    "h": 57.1435928344727,
    "CMY_C": 0.03814387321472,
    "CMY_M": 0.0796976685524,
    "CMY_Y": 0.11010909080505,
    "CMYK_C": 0,
    "CMYK_M": 0.04320167377591,
    "CMYK_Y": 0.07481911033392,
    "CMYK_K": 0.03814387321472
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0334",
    "Farbtonhilfsbezeichnung": "Ceramic 95",
    "Farbtonklasse": "04",
    "Y": 36,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0335",
    "Farbtonhilfsbezeichnung": "Ceramic 100",
    "Farbtonklasse": "03",
    "Y": 49,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0336",
    "Farbtonhilfsbezeichnung": "Ceramic 105",
    "Farbtonklasse": "02",
    "Y": 66,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0337",
    "Farbtonhilfsbezeichnung": "Kreide 5",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "169",
    "Bcolor": "164",
    "Y": 41,
    "L": 69.441984097841,
    "a": 1.32543114935207,
    "b": 2.58234660392989,
    "C": 2.90263358254206,
    "h": 1.09659219439785,
    "CMY_C": 0.3170848,
    "CMY_M": 0.3383035,
    "CMY_Y": 0.3581213,
    "CMYK_C": 0,
    "CMYK_M": 0.0310708,
    "CMYK_Y": 0.0600902,
    "CMYK_K": 0.3170848
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0338",
    "Farbtonhilfsbezeichnung": "Kreide 10",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "192",
    "Bcolor": "183",
    "Y": 55,
    "L": 78.3902106456884,
    "a": 2.24272168259099,
    "b": 4.99826742058695,
    "C": 5.47836451445728,
    "h": 1.1490241588975,
    "CMY_C": 0.2069246,
    "CMY_M": 0.2456815,
    "CMY_Y": 0.2810146,
    "CMYK_C": 0,
    "CMYK_M": 0.04886917,
    "CMYK_Y": 0.09342109,
    "CMYK_K": 0.2069246
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0339",
    "Farbtonhilfsbezeichnung": "Kreide 15",
    "Farbtonklasse": "01",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0340",
    "Farbtonhilfsbezeichnung": "Kreide 20",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "219",
    "Bcolor": "212",
    "Y": 72,
    "L": 87.7307406838745,
    "a": 1.19114611339061,
    "b": 3.18401810767732,
    "C": 3.39952943412211,
    "h": 1.21281357016381,
    "CMY_C": 0.117676,
    "CMY_M": 0.140681,
    "CMY_Y": 0.1673385,
    "CMYK_C": 0,
    "CMYK_M": 0.02607321,
    "CMYK_Y": 0.05628602,
    "CMYK_K": 0.117676
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0341",
    "Farbtonhilfsbezeichnung": "Kreide 25",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "220",
    "Y": 78,
    "L": 90.3068082774428,
    "a": 0.36422721954382,
    "b": 3.07516061983648,
    "C": 3.09665534169525,
    "h": 1.452903872099,
    "CMY_C": 0.09574769,
    "CMY_M": 0.1101135,
    "CMY_Y": 0.1384312,
    "CMYK_C": 0,
    "CMYK_M": 0.0158869,
    "CMYK_Y": 0.0472031,
    "CMYK_K": 0.09574769
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0342",
    "Farbtonhilfsbezeichnung": "Kreide 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 82,
    "L": 91.6707559936224,
    "a": 0.1424441257406,
    "b": 3.03619365187933,
    "C": 3.0395332241432,
    "h": 1.52391533996657,
    "CMY_C": 0.08236761,
    "CMY_M": 0.09437337,
    "CMY_Y": 0.1231586,
    "CMYK_C": 0,
    "CMYK_M": 0.01308341,
    "CMYK_Y": 0.04445243,
    "CMYK_K": 0.08236761
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0343",
    "Farbtonhilfsbezeichnung": "Siena 5",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "110",
    "Bcolor": "97",
    "Y": 16,
    "L": 47.6065711975098,
    "a": 5.02753639221191,
    "b": 9.26213836669922,
    "C": 10.5386590957642,
    "h": 61.5066604614258,
    "CMY_C": 0.5002613067627,
    "CMY_M": 0.56989181041718,
    "CMY_Y": 0.62032830715179,
    "CMYK_C": 0,
    "CMYK_M": 0.13933382928371,
    "CMYK_Y": 0.24025955796242,
    "CMYK_K": 0.5002613067627
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0344",
    "Farbtonhilfsbezeichnung": "Siena 10",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "131",
    "Bcolor": "120",
    "Y": 23,
    "L": 55.7922134399414,
    "a": 3.64797306060791,
    "b": 7.24222850799561,
    "C": 8.10910511016846,
    "h": 63.265209197998,
    "CMY_C": 0.43044245243073,
    "CMY_M": 0.48527354001999,
    "CMY_Y": 0.52804601192474,
    "CMYK_C": 0,
    "CMYK_M": 0.09626961499453,
    "CMYK_Y": 0.17136733233929,
    "CMYK_K": 0.43044245243073
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0345",
    "Farbtonhilfsbezeichnung": "Siena 15",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "155",
    "Bcolor": "147",
    "Y": 34,
    "L": 64.8774948120117,
    "a": 2.97178196907043,
    "b": 5.52565002441406,
    "C": 6.27409744262695,
    "h": 61.7279319763184,
    "CMY_C": 0.34498316049576,
    "CMY_M": 0.39049488306046,
    "CMY_Y": 0.42538034915924,
    "CMYK_C": 0,
    "CMYK_M": 0.06948176026344,
    "CMYK_Y": 0.12274064123631,
    "CMYK_K": 0.34498316049576
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0346",
    "Farbtonhilfsbezeichnung": "Siena 20",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "186",
    "Bcolor": "179",
    "Y": 50,
    "L": 75.9710388183594,
    "a": 2.15740561485291,
    "b": 4.01791000366211,
    "C": 4.56048250198364,
    "h": 61.7665481567383,
    "CMY_C": 0.23674249649048,
    "CMY_M": 0.27120649814606,
    "CMY_Y": 0.29965698719025,
    "CMYK_C": 0,
    "CMYK_M": 0.04515383392572,
    "CMYK_Y": 0.08242891728878,
    "CMYK_K": 0.23674249649048
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0347",
    "Farbtonhilfsbezeichnung": "Siena 25",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 67,
    "L": 86.0541076660156,
    "a": 1.24117279052734,
    "b": 3.07441544532776,
    "C": 3.31550002098083,
    "h": 68.0155715942383,
    "CMY_C": 0.13621884584427,
    "CMY_M": 0.15923380851746,
    "CMY_Y": 0.18480086326599,
    "CMYK_C": 0,
    "CMYK_M": 0.02664443664253,
    "CMYK_Y": 0.05624343454838,
    "CMYK_K": 0.13621884584427
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0348",
    "Farbtonhilfsbezeichnung": "Siena 30",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.4926452636719,
    "a": 0.49160760641098,
    "b": 2.20131897926331,
    "C": 2.25554490089417,
    "h": 77.4110412597656,
    "CMY_C": 0.09554558992386,
    "CMY_M": 0.10807251930237,
    "CMY_Y": 0.12990671396255,
    "CMYK_C": 0,
    "CMYK_M": 0.01385026052594,
    "CMYK_Y": 0.03799099475145,
    "CMYK_K": 0.09554558992386
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0349",
    "Farbtonhilfsbezeichnung": "Siena 35",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "124",
    "Bcolor": "108",
    "Y": 21,
    "L": 53.6310501098633,
    "a": 6.20886564254761,
    "b": 11.3392133712769,
    "C": 12.9277906417847,
    "h": 61.2967796325684,
    "CMY_C": 0.42673397064209,
    "CMY_M": 0.51368570327759,
    "CMY_Y": 0.57616901397705,
    "CMYK_C": 0,
    "CMYK_M": 0.15167780220509,
    "CMYK_Y": 0.26067310571671,
    "CMYK_K": 0.42673397064209
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0350",
    "Farbtonhilfsbezeichnung": "Siena 40",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "148",
    "Bcolor": "132",
    "Y": 30,
    "L": 62.5276527404785,
    "a": 5.37793684005737,
    "b": 10.4660692214966,
    "C": 11.7669372558594,
    "h": 62.8038635253906,
    "CMY_C": 0.34080523252487,
    "CMY_M": 0.42152011394501,
    "CMY_Y": 0.48280251026154,
    "CMYK_C": 0,
    "CMYK_M": 0.12244466692209,
    "CMYK_Y": 0.21541020274162,
    "CMYK_K": 0.34080523252487
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0351",
    "Farbtonhilfsbezeichnung": "Siena 45",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "176",
    "Bcolor": "162",
    "Y": 45,
    "L": 73.072021484375,
    "a": 4.67144680023193,
    "b": 8.96534729003906,
    "C": 10.1093950271606,
    "h": 62.4779663085938,
    "CMY_C": 0.23622739315033,
    "CMY_M": 0.30932807922363,
    "CMY_Y": 0.36483061313629,
    "CMYK_C": 0,
    "CMYK_M": 0.09571000933647,
    "CMYK_Y": 0.16837893426418,
    "CMYK_K": 0.23622739315033
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0352",
    "Farbtonhilfsbezeichnung": "Siena 50",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "204",
    "Bcolor": "192",
    "Y": 62,
    "L": 82.9248809814453,
    "a": 3.28323245048523,
    "b": 7.2623610496521,
    "C": 7.97003793716431,
    "h": 65.6727981567383,
    "CMY_C": 0.14281952381134,
    "CMY_M": 0.19952511787415,
    "CMY_Y": 0.24882286787033,
    "CMYK_C": 0,
    "CMYK_M": 0.0661536231637,
    "CMYK_Y": 0.12366513907909,
    "CMYK_K": 0.14281952381134
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0353",
    "Farbtonhilfsbezeichnung": "Siena 55",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "212",
    "Bcolor": "196",
    "Y": 68,
    "L": 85.8829116821289,
    "a": 3.77442049980164,
    "b": 9.19139957427979,
    "C": 9.93620014190674,
    "h": 67.6746444702148,
    "CMY_C": 0.100814640522,
    "CMY_M": 0.16883182525635,
    "CMY_Y": 0.23105192184448,
    "CMYK_C": 0,
    "CMYK_M": 0.0756431221962,
    "CMYK_Y": 0.14483919739723,
    "CMYK_K": 0.100814640522
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0354",
    "Farbtonhilfsbezeichnung": "Siena 60",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "231",
    "Bcolor": "220",
    "Y": 83,
    "L": 92.451416015625,
    "a": 2.84378862380981,
    "b": 6.13816547393799,
    "C": 6.76492500305176,
    "h": 65.1418914794922,
    "CMY_C": 0.04290723800659,
    "CMY_M": 0.09299254417419,
    "CMY_Y": 0.13719749450684,
    "CMYK_C": 0,
    "CMYK_M": 0.05233066901565,
    "CMYK_Y": 0.09851736575365,
    "CMYK_K": 0.04290723800659
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0355",
    "Farbtonhilfsbezeichnung": "Siena 65",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "105",
    "Bcolor": "81",
    "Y": 15,
    "L": 46.9735298156738,
    "a": 8.83706283569336,
    "b": 18.0140914916992,
    "C": 20.0649242401123,
    "h": 63.8690986633301,
    "CMY_C": 0.4673165678978,
    "CMY_M": 0.58660733699799,
    "CMY_Y": 0.6829582452774,
    "CMYK_C": 0,
    "CMYK_M": 0.22394308447838,
    "CMYK_Y": 0.40482145547867,
    "CMYK_K": 0.4673165678978
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0356",
    "Farbtonhilfsbezeichnung": "Siena 70",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "124",
    "Bcolor": "95",
    "Y": 22,
    "L": 54.732551574707,
    "a": 10.4150810241699,
    "b": 20.5733280181885,
    "C": 23.0593967437744,
    "h": 63.1495513916016,
    "CMY_C": 0.37197923660278,
    "CMY_M": 0.51465427875519,
    "CMY_Y": 0.62701463699341,
    "CMYK_C": 0,
    "CMYK_M": 0.22718204557896,
    "CMYK_Y": 0.40609389543533,
    "CMYK_K": 0.37197923660278
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0357",
    "Farbtonhilfsbezeichnung": "Siena 75",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "138",
    "Bcolor": "107",
    "Y": 28,
    "L": 60.2444114685059,
    "a": 10.7361459732056,
    "b": 21.4788627624512,
    "C": 24.0126285552979,
    "h": 63.4419593811035,
    "CMY_C": 0.30897676944733,
    "CMY_M": 0.46015548706055,
    "CMY_Y": 0.58019733428955,
    "CMYK_C": 0,
    "CMYK_M": 0.2187751531601,
    "CMYK_Y": 0.39249125123024,
    "CMYK_K": 0.30897676944733
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0358",
    "Farbtonhilfsbezeichnung": "Siena 80",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "150",
    "Bcolor": "126",
    "Y": 33,
    "L": 64.3893432617188,
    "a": 8.34944534301758,
    "b": 16.4712066650391,
    "C": 18.4665603637695,
    "h": 63.1190223693848,
    "CMY_C": 0.28827887773514,
    "CMY_M": 0.41080677509308,
    "CMY_Y": 0.50520515441895,
    "CMYK_C": 0,
    "CMYK_M": 0.17215716838837,
    "CMYK_Y": 0.30479112267494,
    "CMYK_K": 0.28827887773514
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0359",
    "Farbtonhilfsbezeichnung": "Siena 85",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "182",
    "Bcolor": "162",
    "Y": 50,
    "L": 75.7433471679688,
    "a": 6.04289865493774,
    "b": 12.6365957260132,
    "C": 14.0071468353272,
    "h": 64.4425811767578,
    "CMY_C": 0.18816918134689,
    "CMY_M": 0.28507930040359,
    "CMY_Y": 0.36296075582504,
    "CMYK_C": 0,
    "CMYK_M": 0.11937230825424,
    "CMYK_Y": 0.21530541777611,
    "CMYK_K": 0.18816918134689
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0360",
    "Farbtonhilfsbezeichnung": "Siena 90",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "203",
    "Bcolor": "181",
    "Y": 63,
    "L": 83.3157958984375,
    "a": 6.59287977218628,
    "b": 13.7541418075562,
    "C": 15.2526216506958,
    "h": 64.3898391723633,
    "CMY_C": 0.09728437662125,
    "CMY_M": 0.20498532056808,
    "CMY_Y": 0.29137301445007,
    "CMYK_C": 0,
    "CMYK_M": 0.11930771917105,
    "CMYK_Y": 0.2150052934885,
    "CMYK_K": 0.09728437662125
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0361",
    "Farbtonhilfsbezeichnung": "Siena 95",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "162",
    "Bcolor": "136",
    "Y": 40,
    "L": 68.995361328125,
    "a": 8.89025783538818,
    "b": 17.7645359039307,
    "C": 19.8649291992188,
    "h": 63.4143371582031,
    "CMY_C": 0.23184818029404,
    "CMY_M": 0.36457502841949,
    "CMY_Y": 0.46800202131271,
    "CMYK_C": 0,
    "CMYK_M": 0.17278726398945,
    "CMYK_Y": 0.3074312210083,
    "CMYK_K": 0.23184818029404
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0362",
    "Farbtonhilfsbezeichnung": "Siena 100",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "183",
    "Bcolor": "157",
    "Y": 50,
    "L": 76.8445434570313,
    "a": 9.84727001190186,
    "b": 17.3137168884277,
    "C": 19.9181709289551,
    "h": 60.3707084655762,
    "CMY_C": 0.13935858011246,
    "CMY_M": 0.2838414311409,
    "CMY_Y": 0.38440668582916,
    "CMYK_C": 0,
    "CMYK_M": 0.16787810623646,
    "CMYK_Y": 0.28472730517387,
    "CMYK_K": 0.13935858011246
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0363",
    "Farbtonhilfsbezeichnung": "Siena 105",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "186",
    "Bcolor": "161",
    "Y": 52,
    "L": 77.8983154296875,
    "a": 8.63888168334961,
    "b": 16.6066627502441,
    "C": 18.7192821502686,
    "h": 62.5162925720215,
    "CMY_C": 0.13720673322678,
    "CMY_M": 0.26935029029846,
    "CMY_Y": 0.36860054731369,
    "CMYK_C": 0,
    "CMYK_M": 0.1531578451395,
    "CMYK_Y": 0.26819148659706,
    "CMYK_K": 0.13720673322678
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0364",
    "Farbtonhilfsbezeichnung": "Siena 115",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "217",
    "Bcolor": "196",
    "Y": 72,
    "L": 88.600700378418,
    "a": 6.7505054473877,
    "b": 13.4913101196289,
    "C": 15.0859127044678,
    "h": 63.4184684753418,
    "CMY_C": 0.03708392381668,
    "CMY_M": 0.14734017848969,
    "CMY_Y": 0.23293387889862,
    "CMYK_C": 0,
    "CMYK_M": 0.1145024523139,
    "CMYK_Y": 0.20339255034924,
    "CMYK_K": 0.03708392381668
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0365",
    "Farbtonhilfsbezeichnung": "Siena 125",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "150",
    "Bcolor": "97",
    "Y": 36,
    "L": 67.0753631591797,
    "a": 17.2962627410889,
    "b": 36.5733947753906,
    "C": 40.4570617675781,
    "h": 64.6896286010742,
    "CMY_C": 0.17089545726776,
    "CMY_M": 0.40995740890503,
    "CMY_Y": 0.61975002288818,
    "CMYK_C": 0,
    "CMYK_M": 0.2883375287056,
    "CMYK_Y": 0.54137271642685,
    "CMYK_K": 0.17089545726776
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0366",
    "Farbtonhilfsbezeichnung": "Siena 130",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "150",
    "Bcolor": "109",
    "Y": 35,
    "L": 65.6544494628906,
    "a": 13.4110155105591,
    "b": 27.7250499725342,
    "C": 30.7982749938965,
    "h": 64.1862564086914,
    "CMY_C": 0.22270131111145,
    "CMY_M": 0.41275662183762,
    "CMY_Y": 0.57069742679596,
    "CMYK_C": 0,
    "CMYK_M": 0.24450743198395,
    "CMYK_Y": 0.44769933819771,
    "CMYK_K": 0.22270131111145
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0367",
    "Farbtonhilfsbezeichnung": "Siena 135",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "173",
    "Bcolor": "131",
    "Y": 48,
    "L": 74.592170715332,
    "a": 13.8620929718018,
    "b": 28.103006362915,
    "C": 31.3358669281006,
    "h": 63.7447128295898,
    "CMY_C": 0.11804538965225,
    "CMY_M": 0.32050079107285,
    "CMY_Y": 0.48445153236389,
    "CMYK_C": 0,
    "CMYK_M": 0.2295530885458,
    "CMYK_Y": 0.41544783115387,
    "CMYK_K": 0.11804538965225
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0368",
    "Farbtonhilfsbezeichnung": "Siena 140",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "163",
    "Y": 67,
    "L": 85.3863372802734,
    "a": 13.3558139801025,
    "b": 26.3614978790283,
    "C": 29.5517578125,
    "h": 63.1313629150391,
    "CMY_C": 0,
    "CMY_M": 0.20266568660736,
    "CMY_Y": 0.36088198423386,
    "CMYK_C": 0,
    "CMYK_M": 0.20266568660736,
    "CMYK_Y": 0.36088198423386,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0369",
    "Farbtonhilfsbezeichnung": "Siena 150",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "227",
    "Bcolor": "210",
    "Y": 82,
    "L": 91.9034729003906,
    "a": 6.63725996017456,
    "b": 10.4873180389404,
    "C": 12.4111671447754,
    "h": 57.6709213256836,
    "CMY_C": 0.00828725099564,
    "CMY_M": 0.10966473817825,
    "CMY_Y": 0.17492085695267,
    "CMYK_C": 0,
    "CMYK_M": 0.10222464799881,
    "CMYK_Y": 0.16802607476711,
    "CMYK_K": 0.00828725099564
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0370",
    "Farbtonhilfsbezeichnung": "Siena 155",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "127",
    "Bcolor": "66",
    "Y": 27,
    "L": 59.6071929931641,
    "a": 22.2132663726807,
    "b": 43.3698081970215,
    "C": 48.7275009155273,
    "h": 62.8792610168457,
    "CMY_C": 0.22202098369598,
    "CMY_M": 0.50105810165405,
    "CMY_Y": 0.74075984954834,
    "CMYK_C": 0,
    "CMYK_M": 0.35866922140121,
    "CMYK_Y": 0.66677743196487,
    "CMYK_K": 0.22202098369598
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0371",
    "Farbtonhilfsbezeichnung": "Siena 160",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "154",
    "Bcolor": "91",
    "Y": 41,
    "L": 70.1889114379883,
    "a": 23.4875202178955,
    "b": 43.937629699707,
    "C": 49.8214721679688,
    "h": 61.8726005554199,
    "CMY_C": 0.0899121761322,
    "CMY_M": 0.39626759290695,
    "CMY_Y": 0.64265602827072,
    "CMYK_C": 0,
    "CMYK_M": 0.33662182092667,
    "CMYK_Y": 0.60735219717026,
    "CMYK_K": 0.0899121761322
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0372",
    "Farbtonhilfsbezeichnung": "Siena 170",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "116",
    "Y": 57,
    "L": 80.0455627441406,
    "a": 22.6262931823731,
    "b": 44.0977592468262,
    "C": 49.5637130737305,
    "h": 62.8379173278809,
    "CMY_C": 0,
    "CMY_M": 0.28952968120575,
    "CMY_Y": 0.54631555080414,
    "CMYK_C": 0,
    "CMYK_M": 0.28952968120575,
    "CMYK_Y": 0.54631555080414,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0373",
    "Farbtonhilfsbezeichnung": "Siena 175",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "145",
    "Y": 65,
    "L": 83.4740676879883,
    "a": 17.5679454803467,
    "b": 33.1211395263672,
    "C": 37.4919013977051,
    "h": 62.0578575134277,
    "CMY_C": 0,
    "CMY_M": 0.23625689744949,
    "CMY_Y": 0.42999398708344,
    "CMYK_C": 0,
    "CMYK_M": 0.23625689744949,
    "CMYK_Y": 0.42999398708344,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0374",
    "Farbtonhilfsbezeichnung": "Falb 5",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "170",
    "Bcolor": "155",
    "Y": 41,
    "L": 70.5445889796744,
    "a": 3.84376113807794,
    "b": 8.98950423475131,
    "C": 9.77679324079271,
    "h": 1.16673970770983,
    "CMY_C": 0.2692719,
    "CMY_M": 0.3341446,
    "CMY_Y": 0.3912876,
    "CMYK_C": 0,
    "CMYK_M": 0.08877822,
    "CMYK_Y": 0.1669783,
    "CMYK_K": 0.2692719
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0375",
    "Farbtonhilfsbezeichnung": "Falb 15",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "197",
    "Bcolor": "186",
    "Y": 58,
    "L": 79.9238333203408,
    "a": 2.15431315133507,
    "b": 5.99364528818975,
    "C": 6.36905401097011,
    "h": 1.22574289611575,
    "CMY_C": 0.1878723,
    "CMY_M": 0.2291586,
    "CMY_Y": 0.2718708,
    "CMYK_C": 0,
    "CMYK_M": 0.05083721,
    "CMYK_Y": 0.1034302,
    "CMYK_K": 0.1878723
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0376",
    "Farbtonhilfsbezeichnung": "Falb 20",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "209",
    "Bcolor": "199",
    "Y": 66,
    "L": 84.1787746955933,
    "a": 1.75394934998596,
    "b": 4.87395496451806,
    "C": 5.17993970220372,
    "h": 1.22536325140587,
    "CMY_C": 0.1474309,
    "CMY_M": 0.1815658,
    "CMY_Y": 0.218187,
    "CMYK_C": 0,
    "CMYK_M": 0.04003775,
    "CMYK_Y": 0.08299169,
    "CMYK_K": 0.1474309
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0377",
    "Farbtonhilfsbezeichnung": "Falb 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "230",
    "Bcolor": "223",
    "Y": 81,
    "L": 91.3282321340202,
    "a": 0.5189632593956,
    "b": 3.09843280562767,
    "C": 3.14159334026418,
    "h": 1.40484455672027,
    "CMY_C": 0.0830535,
    "CMY_M": 0.09911059,
    "CMY_Y": 0.1273416,
    "CMYK_C": 0,
    "CMYK_M": 0.01751148,
    "CMYK_Y": 0.04829953,
    "CMYK_K": 0.0830535
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0378",
    "Farbtonhilfsbezeichnung": "Falb 35",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "120",
    "Bcolor": "101",
    "Y": 20,
    "L": 52.2866590215815,
    "a": 6.28103960938148,
    "b": 13.8014401191834,
    "C": 15.1634827113703,
    "h": 1.14370908787878,
    "CMY_C": 0.4351143,
    "CMY_M": 0.5277647,
    "CMY_Y": 0.6055138,
    "CMYK_C": 0,
    "CMYK_M": 0.1640162,
    "CMYK_Y": 0.3016529,
    "CMYK_K": 0.4351143
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0379",
    "Farbtonhilfsbezeichnung": "Falb 40",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "143",
    "Bcolor": "123",
    "Y": 29,
    "L": 60.8748414738592,
    "a": 5.90896873687002,
    "b": 12.9953964267288,
    "C": 14.2757220420245,
    "h": 1.14404318323304,
    "CMY_C": 0.3490609,
    "CMY_M": 0.4403063,
    "CMY_Y": 0.5165307,
    "CMYK_C": 0,
    "CMYK_M": 0.140175,
    "CMYK_Y": 0.2572742,
    "CMYK_K": 0.3490609
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0380",
    "Farbtonhilfsbezeichnung": "Falb 45",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "166",
    "Bcolor": "146",
    "Y": 43,
    "L": 70.1122510923049,
    "a": 7.1002333685688,
    "b": 13.7576486604084,
    "C": 15.4818025614388,
    "h": 1.09435694730948,
    "CMY_C": 0.240104,
    "CMY_M": 0.3476112,
    "CMY_Y": 0.4287602,
    "CMYK_C": 0,
    "CMYK_M": 0.1414761,
    "CMYK_Y": 0.2482657,
    "CMYK_K": 0.240104
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0381",
    "Farbtonhilfsbezeichnung": "Falb 50",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "168",
    "Bcolor": "150",
    "Y": 41,
    "L": 70.4397998924814,
    "a": 5.44687402992405,
    "b": 11.8267335885676,
    "C": 13.0207551268279,
    "h": 1.13919872178211,
    "CMY_C": 0.2522232,
    "CMY_M": 0.3397308,
    "CMY_Y": 0.4120825,
    "CMYK_C": 0,
    "CMYK_M": 0.1170237,
    "CMYK_Y": 0.2137794,
    "CMYK_K": 0.2522232
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0382",
    "Farbtonhilfsbezeichnung": "Falb 55",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "194",
    "Bcolor": "176",
    "Y": 58,
    "L": 79.747553173823,
    "a": 4.98204407759939,
    "b": 10.8689216418789,
    "C": 11.9563464673975,
    "h": 1.14099945377061,
    "CMY_C": 0.1558443,
    "CMY_M": 0.2390801,
    "CMY_Y": 0.3084713,
    "CMYK_C": 0,
    "CMYK_M": 0.0986024,
    "CMYK_Y": 0.1808043,
    "CMYK_K": 0.1558443
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0383",
    "Farbtonhilfsbezeichnung": "Falb 60",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "221",
    "Bcolor": "203",
    "Y": 77,
    "L": 89.3167043941432,
    "a": 3.97429098858443,
    "b": 10.4016267504135,
    "C": 11.1350270730187,
    "h": 1.20582988609839,
    "CMY_C": 0.0573893,
    "CMY_M": 0.1317925,
    "CMY_Y": 0.2028344,
    "CMYK_C": 0,
    "CMYK_M": 0.07893308,
    "CMYK_Y": 0.1543003,
    "CMYK_K": 0.0573893
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0384",
    "Farbtonhilfsbezeichnung": "Falb 65",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "140",
    "Bcolor": "114",
    "Y": 28,
    "L": 60.2442707134362,
    "a": 8.07413882400182,
    "b": 17.5960274958045,
    "C": 19.3600594364367,
    "h": 1.14059769375695,
    "CMY_C": 0.3324882,
    "CMY_M": 0.4528818,
    "CMY_Y": 0.5539328,
    "CMYK_C": 0,
    "CMYK_M": 0.1803617,
    "CMYK_Y": 0.3317463,
    "CMYK_K": 0.3324882
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0385",
    "Farbtonhilfsbezeichnung": "Falb 70",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "181",
    "Bcolor": "156",
    "Y": 50,
    "L": 75.9949875179892,
    "a": 8.32549216937567,
    "b": 16.4724548977793,
    "C": 18.4568575391833,
    "h": 1.10282289786309,
    "CMY_C": 0.160883,
    "CMY_M": 0.2889484,
    "CMY_Y": 0.3874235,
    "CMYK_C": 0,
    "CMYK_M": 0.1526193,
    "CMYK_Y": 0.2699749,
    "CMYK_K": 0.160883
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0386",
    "Farbtonhilfsbezeichnung": "Falb 75",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "193",
    "Bcolor": "167",
    "Y": 58,
    "L": 80.0677595091612,
    "a": 8.1124908378285,
    "b": 16.2748799660426,
    "C": 18.1847250598667,
    "h": 1.10837585757101,
    "CMY_C": 0.1172097,
    "CMY_M": 0.2446464,
    "CMY_Y": 0.3436644,
    "CMYK_C": 0,
    "CMYK_M": 0.1443567,
    "CMYK_Y": 0.2565216,
    "CMYK_K": 0.1172097
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0387",
    "Farbtonhilfsbezeichnung": "Onyx 5",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "168",
    "Bcolor": "162",
    "Y": 39,
    "L": 69.2112121582031,
    "a": 1.64226853847504,
    "b": 3.2131974697113,
    "C": 3.6085569858551,
    "h": 62.9283752441406,
    "CMY_C": 0.3153081536293,
    "CMY_M": 0.34159463644028,
    "CMY_Y": 0.36488997936249,
    "CMYK_C": 0,
    "CMYK_M": 0.03839169815183,
    "CMYK_Y": 0.07241480052471,
    "CMYK_K": 0.3153081536293
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0388",
    "Farbtonhilfsbezeichnung": "Onyx 10",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "187",
    "Bcolor": "179",
    "Y": 50,
    "L": 76.3826293945313,
    "a": 1.48400747776031,
    "b": 4.1337513923645,
    "C": 4.39205837249756,
    "h": 70.2519760131836,
    "CMY_C": 0.23690491914749,
    "CMY_M": 0.26525437831879,
    "CMY_Y": 0.29622429609299,
    "CMYK_C": 0,
    "CMYK_M": 0.03715062513947,
    "CMYK_Y": 0.07773523777723,
    "CMYK_K": 0.23690491914749
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0389",
    "Farbtonhilfsbezeichnung": "Onyx 15",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "194",
    "Bcolor": "188",
    "Y": 54,
    "L": 78.7169036865234,
    "a": 1.12689757347107,
    "b": 2.73194265365601,
    "C": 2.95523405075073,
    "h": 67.5843658447266,
    "CMY_C": 0.21860295534134,
    "CMY_M": 0.23890727758408,
    "CMY_Y": 0.26142007112503,
    "CMYK_C": 0,
    "CMYK_M": 0.02598464116454,
    "CMYK_Y": 0.0547955930233,
    "CMYK_K": 0.21860295534134
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0390",
    "Farbtonhilfsbezeichnung": "Onyx 20",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "206",
    "Bcolor": "199",
    "Y": 62,
    "L": 83.1459579467773,
    "a": 1.96350347995758,
    "b": 3.57496500015259,
    "C": 4.07869100570679,
    "h": 61.2227745056152,
    "CMY_C": 0.16124445199966,
    "CMY_M": 0.19297730922699,
    "CMY_Y": 0.2198514342308,
    "CMYK_C": 0,
    "CMYK_M": 0.03783326223493,
    "CMYK_Y": 0.06987373530865,
    "CMYK_K": 0.16124445199966
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0391",
    "Farbtonhilfsbezeichnung": "Onyx 25",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "207",
    "Bcolor": "202",
    "Y": 63,
    "L": 83.5170516967773,
    "a": 1.12759864330292,
    "b": 2.66021609306335,
    "C": 2.8893301486969,
    "h": 67.0291366577148,
    "CMY_C": 0.16638779640198,
    "CMY_M": 0.18669503927231,
    "CMY_Y": 0.20931321382523,
    "CMYK_C": 0,
    "CMYK_M": 0.02436053939164,
    "CMYK_Y": 0.05149326846004,
    "CMYK_K": 0.16638779640198
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0392",
    "Farbtonhilfsbezeichnung": "Onyx 30",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "220",
    "Bcolor": "216",
    "Y": 72,
    "L": 87.9186706542969,
    "a": 0.48029071092606,
    "b": 1.57256245613098,
    "C": 1.64427244663239,
    "h": 73.0163269042969,
    "CMY_C": 0.12634611129761,
    "CMY_M": 0.13643509149551,
    "CMY_Y": 0.15354126691818,
    "CMYK_C": 0,
    "CMYK_M": 0.01154802832752,
    "CMYK_Y": 0.0311280656606,
    "CMYK_K": 0.12634611129761
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0393",
    "Farbtonhilfsbezeichnung": "Onyx 35",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "117",
    "Bcolor": "109",
    "Y": 17,
    "L": 49.9134826660156,
    "a": 2.43943810462952,
    "b": 5.52380275726318,
    "C": 6.03848123550415,
    "h": 66.1726455688477,
    "CMY_C": 0.50245189666748,
    "CMY_M": 0.54072487354279,
    "CMY_Y": 0.57415509223938,
    "CMYK_C": 0,
    "CMYK_M": 0.07692316919565,
    "CMYK_Y": 0.14411309361458,
    "CMYK_K": 0.50245189666748
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0394",
    "Farbtonhilfsbezeichnung": "Onyx 40",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "140",
    "Bcolor": "130",
    "Y": 25,
    "L": 58.7976531982422,
    "a": 2.27290296554565,
    "b": 5.84127473831177,
    "C": 6.26790046691895,
    "h": 68.7384490966797,
    "CMY_C": 0.41234904527664,
    "CMY_M": 0.45145285129547,
    "CMY_Y": 0.48899602890015,
    "CMYK_C": 0,
    "CMYK_M": 0.06654257327318,
    "CMYK_Y": 0.13042943179607,
    "CMYK_K": 0.41234904527664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0395",
    "Farbtonhilfsbezeichnung": "Onyx 45",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "175",
    "Bcolor": "165",
    "Y": 43,
    "L": 71.9147720336914,
    "a": 2.3878071308136,
    "b": 5.48397350311279,
    "C": 5.98126983642578,
    "h": 66.4709396362305,
    "CMY_C": 0.27444815635681,
    "CMY_M": 0.31535619497299,
    "CMY_Y": 0.35260754823685,
    "CMYK_C": 0,
    "CMYK_M": 0.05638196319342,
    "CMYK_Y": 0.10772406309843,
    "CMYK_K": 0.27444815635681
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0396",
    "Farbtonhilfsbezeichnung": "Onyx 50",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 67,
    "L": 86.0088500976563,
    "a": 2.4651403427124,
    "b": 5.41555213928223,
    "C": 5.95022010803223,
    "h": 65.5251388549805,
    "CMY_C": 0.12014871835709,
    "CMY_M": 0.16328912973404,
    "CMY_Y": 0.20224714279175,
    "CMYK_C": 0,
    "CMYK_M": 0.04903148114681,
    "CMYK_Y": 0.09330943226814,
    "CMYK_K": 0.12014871835709
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0397",
    "Farbtonhilfsbezeichnung": "Onyx 55",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "219",
    "Bcolor": "210",
    "Y": 72,
    "L": 87.8486633300781,
    "a": 1.36559104919434,
    "b": 4.46653318405151,
    "C": 4.67062711715698,
    "h": 72.9995956420898,
    "CMY_C": 0.1109431385994,
    "CMY_M": 0.14011406898499,
    "CMY_Y": 0.17545175552368,
    "CMYK_C": 0,
    "CMYK_M": 0.03281109780073,
    "CMYK_Y": 0.07255848497152,
    "CMYK_K": 0.1109431385994
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0398",
    "Farbtonhilfsbezeichnung": "Onyx 60",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "225",
    "Y": 82,
    "L": 92.8636245727539,
    "a": 1.40102303028107,
    "b": 4.02161931991577,
    "C": 4.25867223739624,
    "h": 70.7930526733398,
    "CMY_C": 0.05596274137497,
    "CMY_M": 0.08430194854736,
    "CMY_Y": 0.11713314056396,
    "CMYK_C": 0,
    "CMYK_M": 0.03001916222274,
    "CMYK_Y": 0.06479659676552,
    "CMYK_K": 0.05596274137497
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0399",
    "Farbtonhilfsbezeichnung": "Onyx 65",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "153",
    "Bcolor": "131",
    "Y": 33,
    "L": 65.0577392578125,
    "a": 6.40577554702759,
    "b": 14.7559499740601,
    "C": 16.0863914489746,
    "h": 66.5336227416992,
    "CMY_C": 0.2972354888916,
    "CMY_M": 0.39883929491043,
    "CMY_Y": 0.4869487285614,
    "CMYK_C": 0,
    "CMYK_M": 0.14457730948925,
    "CMYK_Y": 0.26995277404785,
    "CMYK_K": 0.2972354888916
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0400",
    "Farbtonhilfsbezeichnung": "Onyx 70",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "191",
    "Bcolor": "175",
    "Y": 53,
    "L": 78.1959609985352,
    "a": 3.93344235420227,
    "b": 9.52780723571777,
    "C": 10.3078165054321,
    "h": 67.5672988891602,
    "CMY_C": 0.18395817279816,
    "CMY_M": 0.25292295217514,
    "CMY_Y": 0.31534159183502,
    "CMYK_C": 0,
    "CMYK_M": 0.08451133221388,
    "CMYK_Y": 0.16100083291531,
    "CMYK_K": 0.18395817279816
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0401",
    "Farbtonhilfsbezeichnung": "Onyx 75",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "204",
    "Bcolor": "184",
    "Y": 63,
    "L": 83.2278366088867,
    "a": 4.77102756500244,
    "b": 11.8342866897583,
    "C": 12.7598218917847,
    "h": 68.0430297851563,
    "CMY_C": 0.11608850955963,
    "CMY_M": 0.20099073648453,
    "CMY_Y": 0.27861452102661,
    "CMYK_C": 0,
    "CMYK_M": 0.0960528627038,
    "CMYK_Y": 0.18387135863304,
    "CMYK_K": 0.11608850955963
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0402",
    "Farbtonhilfsbezeichnung": "Onyx 80",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "212",
    "Bcolor": "195",
    "Y": 67,
    "L": 85.7533264160156,
    "a": 3.62040305137634,
    "b": 9.79955005645752,
    "C": 10.4469375610352,
    "h": 69.7234573364258,
    "CMY_C": 0.10168641805649,
    "CMY_M": 0.17003899812698,
    "CMY_Y": 0.23692345619202,
    "CMYK_C": 0,
    "CMYK_M": 0.07608988881111,
    "CMYK_Y": 0.15054546296597,
    "CMYK_K": 0.10168641805649
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0403",
    "Farbtonhilfsbezeichnung": "Onyx 85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "226",
    "Bcolor": "214",
    "Y": 77,
    "L": 90.5740356445312,
    "a": 2.37935328483582,
    "b": 6.76128578186035,
    "C": 7.16772699356079,
    "h": 70.6126022338867,
    "CMY_C": 0.06568765640259,
    "CMY_M": 0.11295425891876,
    "CMY_Y": 0.16247397661209,
    "CMYK_C": 0,
    "CMYK_M": 0.05058972164989,
    "CMYK_Y": 0.103590965271,
    "CMYK_K": 0.06568765640259
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0404",
    "Farbtonhilfsbezeichnung": "Onyx 90",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "232",
    "Bcolor": "218",
    "Y": 83,
    "L": 92.7463455200195,
    "a": 2.35317087173462,
    "b": 7.39190912246704,
    "C": 7.75743103027344,
    "h": 72.3414306640625,
    "CMY_C": 0.03949248790741,
    "CMY_M": 0.08884257078171,
    "CMY_Y": 0.14335352182388,
    "CMYK_C": 0,
    "CMYK_M": 0.05137917399406,
    "CMYK_Y": 0.10813140869141,
    "CMYK_K": 0.03949248790741
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0405",
    "Farbtonhilfsbezeichnung": "Onyx 95",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "131",
    "Bcolor": "109",
    "Y": 24,
    "L": 56.5331916809082,
    "a": 6.03860139846802,
    "b": 14.7264728546143,
    "C": 15.9164600372315,
    "h": 67.7038803100586,
    "CMY_C": 0.39038693904877,
    "CMY_M": 0.48497039079666,
    "CMY_Y": 0.57086408138275,
    "CMYK_C": 0,
    "CMYK_M": 0.15515325963497,
    "CMYK_Y": 0.29605194926262,
    "CMYK_K": 0.39038693904877
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0406",
    "Farbtonhilfsbezeichnung": "Onyx 100",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "155",
    "Bcolor": "128",
    "Y": 35,
    "L": 65.8839950561523,
    "a": 6.89961671829224,
    "b": 17.4867191314697,
    "C": 18.7986717224121,
    "h": 68.4676361083984,
    "CMY_C": 0.27927511930466,
    "CMY_M": 0.3920618891716,
    "CMY_Y": 0.49763309955597,
    "CMYK_C": 0,
    "CMYK_M": 0.15649074316025,
    "CMYK_Y": 0.30296996235847,
    "CMYK_K": 0.27927511930466
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0407",
    "Farbtonhilfsbezeichnung": "Onyx 105",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "178",
    "Bcolor": "145",
    "Y": 48,
    "L": 75.1193771362305,
    "a": 8.73221683502197,
    "b": 21.5312023162842,
    "C": 23.2345485687256,
    "h": 67.9244384765625,
    "CMY_C": 0.15715086460114,
    "CMY_M": 0.30038845539093,
    "CMY_Y": 0.43267321586609,
    "CMYK_C": 0,
    "CMYK_M": 0.16994452476501,
    "CMYK_Y": 0.3268940448761,
    "CMYK_K": 0.15715086460114
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0408",
    "Farbtonhilfsbezeichnung": "Onyx 110",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "195",
    "Bcolor": "168",
    "Y": 57,
    "L": 80.6374588012695,
    "a": 6.51107549667358,
    "b": 16.8225708007813,
    "C": 18.0386524200439,
    "h": 68.8413696289063,
    "CMY_C": 0.12048691511154,
    "CMY_M": 0.23460191488266,
    "CMY_Y": 0.34194552898407,
    "CMYK_C": 0,
    "CMYK_M": 0.12974792718887,
    "CMYK_Y": 0.2517968416214,
    "CMYK_K": 0.12048691511154
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0409",
    "Farbtonhilfsbezeichnung": "Onyx 120",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "213",
    "Y": 82,
    "L": 92.0109405517578,
    "a": 3.40271043777466,
    "b": 8.97412586212158,
    "C": 9.59757137298584,
    "h": 69.2348251342773,
    "CMY_C": 0.03522247076035,
    "CMY_M": 0.10003763437271,
    "CMY_Y": 0.16301560401917,
    "CMYK_C": 0,
    "CMYK_M": 0.06718146055937,
    "CMYK_Y": 0.13245865702629,
    "CMYK_K": 0.03522247076035
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0410",
    "Farbtonhilfsbezeichnung": "Onyx 125",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "150",
    "Bcolor": "117",
    "Y": 34,
    "L": 64.9239349365234,
    "a": 10.7700538635254,
    "b": 22.7048225402832,
    "C": 25.1297245025635,
    "h": 64.6226348876953,
    "CMY_C": 0.25532728433609,
    "CMY_M": 0.41258227825165,
    "CMY_Y": 0.54297173023224,
    "CMYK_C": 0,
    "CMYK_M": 0.21117329597473,
    "CMYK_Y": 0.38626962900162,
    "CMYK_K": 0.25532728433609
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0411",
    "Farbtonhilfsbezeichnung": "Onyx 135",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "185",
    "Bcolor": "144",
    "Y": 52,
    "L": 77.8521270751953,
    "a": 10.4725360870361,
    "b": 25.5883483886719,
    "C": 27.6484642028809,
    "h": 67.7421951293945,
    "CMY_C": 0.10696786642075,
    "CMY_M": 0.27646785974503,
    "CMY_Y": 0.43374979496002,
    "CMYK_C": 0,
    "CMYK_M": 0.18980279564857,
    "CMYK_Y": 0.36592403054237,
    "CMYK_K": 0.10696786642075
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0412",
    "Farbtonhilfsbezeichnung": "Onyx 145",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "216",
    "Bcolor": "188",
    "Y": 72,
    "L": 88.0942993164063,
    "a": 6.71403074264526,
    "b": 16.7747764587402,
    "C": 18.0685176849365,
    "h": 68.1864624023438,
    "CMY_C": 0.0348544716835,
    "CMY_M": 0.15364754199982,
    "CMY_Y": 0.26262080669403,
    "CMYK_C": 0,
    "CMYK_M": 0.12308306246996,
    "CMYK_Y": 0.23599170148373,
    "CMYK_K": 0.0348544716835
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0413",
    "Farbtonhilfsbezeichnung": "Onyx 150",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "225",
    "Bcolor": "204",
    "Y": 80,
    "L": 91.1646041870117,
    "a": 6.34271860122681,
    "b": 12.5657339096069,
    "C": 14.0757856369019,
    "h": 63.217041015625,
    "CMY_C": 0.01323556900024,
    "CMY_M": 0.11768364906311,
    "CMY_Y": 0.19843780994415,
    "CMYK_C": 0,
    "CMYK_M": 0.10584904998541,
    "CMYK_Y": 0.18768638372421,
    "CMYK_K": 0.01323556900024
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0414",
    "Farbtonhilfsbezeichnung": "Onyx 155",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "134",
    "Bcolor": "78",
    "Y": 29,
    "L": 60.1139717102051,
    "a": 15.1040229797363,
    "b": 37.4367866516113,
    "C": 40.3688545227051,
    "h": 68.0281829833984,
    "CMY_C": 0.26201009750366,
    "CMY_M": 0.47544312477112,
    "CMY_Y": 0.69363445043564,
    "CMYK_C": 0,
    "CMYK_M": 0.28920859098434,
    "CMYK_Y": 0.58486485481262,
    "CMYK_K": 0.26201009750366
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0415",
    "Farbtonhilfsbezeichnung": "Onyx 160",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "147",
    "Bcolor": "99",
    "Y": 34,
    "L": 64.4912338256836,
    "a": 12.1824264526367,
    "b": 31.8308582305908,
    "C": 34.0824737548828,
    "h": 69.0569610595703,
    "CMY_C": 0.23694741725922,
    "CMY_M": 0.42231386899948,
    "CMY_Y": 0.61166888475418,
    "CMYK_C": 0,
    "CMYK_M": 0.24292749166489,
    "CMYK_Y": 0.49108210206032,
    "CMYK_K": 0.23694741725922
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0416",
    "Farbtonhilfsbezeichnung": "Onyx 165",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "173",
    "Bcolor": "124",
    "Y": 48,
    "L": 75.0122451782227,
    "a": 15.3168382644653,
    "b": 32.7639122009277,
    "C": 36.1673812866211,
    "h": 64.9443283081055,
    "CMY_C": 0.09658229351044,
    "CMY_M": 0.32081079483032,
    "CMY_Y": 0.51389575004578,
    "CMYK_C": 0,
    "CMYK_M": 0.24820025265217,
    "CMYK_Y": 0.46192747354507,
    "CMYK_K": 0.09658229351044
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0417",
    "Farbtonhilfsbezeichnung": "Onyx 170",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "189",
    "Bcolor": "137",
    "Y": 57,
    "L": 80.3270111083984,
    "a": 12.9705429077148,
    "b": 33.173656463623,
    "C": 35.6191864013672,
    "h": 68.6450347900391,
    "CMY_C": 0.04896956682205,
    "CMY_M": 0.25788760185242,
    "CMY_Y": 0.46369284391403,
    "CMYK_C": 0,
    "CMYK_M": 0.21967545151711,
    "CMYK_Y": 0.43607783317566,
    "CMYK_K": 0.04896956682205
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0418",
    "Farbtonhilfsbezeichnung": "Onyx 175",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "204",
    "Bcolor": "162",
    "Y": 67,
    "L": 85.2027435302734,
    "a": 11.1944742202759,
    "b": 26.6460475921631,
    "C": 28.902042388916,
    "h": 67.2118682861328,
    "CMY_C": 0.01576119661331,
    "CMY_M": 0.1990584731102,
    "CMY_Y": 0.36534649133682,
    "CMYK_C": 0,
    "CMYK_M": 0.18623252213001,
    "CMYK_Y": 0.35518342256546,
    "CMYK_K": 0.01576119661331
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0419",
    "Farbtonhilfsbezeichnung": "Onyx 180",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "189",
    "Y": 77,
    "L": 89.503532409668,
    "a": 7.70704698562622,
    "b": 18.5515308380127,
    "C": 20.0887489318848,
    "h": 67.4400482177734,
    "CMY_C": 0.00747120380402,
    "CMY_M": 0.14101934432983,
    "CMY_Y": 0.26052510738373,
    "CMYK_C": 0,
    "CMYK_M": 0.13455341756344,
    "CMYK_Y": 0.25495874881744,
    "CMYK_K": 0.00747120380402
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0420",
    "Farbtonhilfsbezeichnung": "Onyx 185",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "157",
    "Bcolor": "93",
    "Y": 40,
    "L": 69.6148681640625,
    "a": 17.8182067871094,
    "b": 41.7908248901367,
    "C": 45.4308433532715,
    "h": 66.9082260131836,
    "CMY_C": 0.13193243741989,
    "CMY_M": 0.3858597278595,
    "CMY_Y": 0.63372814655304,
    "CMYK_C": 0,
    "CMYK_M": 0.29252019524574,
    "CMYK_Y": 0.57806068658829,
    "CMYK_K": 0.13193243741989
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0421",
    "Farbtonhilfsbezeichnung": "Onyx 190",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "161",
    "Bcolor": "92",
    "Y": 43,
    "L": 71.7109069824219,
    "a": 19.6686954498291,
    "b": 45.4368057250977,
    "C": 49.5112190246582,
    "h": 66.5931701660156,
    "CMY_C": 0.09227496385574,
    "CMY_M": 0.36965703964233,
    "CMY_Y": 0.6404824256897,
    "CMYK_C": 0,
    "CMYK_M": 0.3055793941021,
    "CMYK_Y": 0.60393559932709,
    "CMYK_K": 0.09227496385574
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0422",
    "Farbtonhilfsbezeichnung": "Onyx 195",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "178",
    "Bcolor": "112",
    "Y": 52,
    "L": 77.6388778686523,
    "a": 17.7172012329102,
    "b": 42.8277015686035,
    "C": 46.3477210998535,
    "h": 67.5258255004883,
    "CMY_C": 0.03683495521545,
    "CMY_M": 0.30118054151535,
    "CMY_Y": 0.56219917535782,
    "CMYK_C": 0,
    "CMYK_M": 0.27445513010025,
    "CMYK_Y": 0.54545605182648,
    "CMYK_K": 0.03683495521545
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0423",
    "Farbtonhilfsbezeichnung": "Onyx 200",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "193",
    "Bcolor": "135",
    "Y": 61,
    "L": 82.4878768920898,
    "a": 15.8207521438599,
    "b": 37.1960601806641,
    "C": 40.420825958252,
    "h": 66.9582977294922,
    "CMY_C": 0,
    "CMY_M": 0.24294853210449,
    "CMY_Y": 0.47102952003479,
    "CMYK_C": 0,
    "CMYK_M": 0.24294853210449,
    "CMYK_Y": 0.47102952003479,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0424",
    "Farbtonhilfsbezeichnung": "Onyx 205",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "160",
    "Y": 71,
    "L": 86.7735290527344,
    "a": 11.7849988937378,
    "b": 29.6510677337646,
    "C": 31.9072399139404,
    "h": 68.324348449707,
    "CMY_C": 0,
    "CMY_M": 0.18406051397324,
    "CMY_Y": 0.37116855382919,
    "CMYK_C": 0,
    "CMYK_M": 0.18406051397324,
    "CMYK_Y": 0.37116855382919,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0425",
    "Farbtonhilfsbezeichnung": "Onyx 210",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "237",
    "Bcolor": "226",
    "Y": 87,
    "L": 94.2772521972656,
    "a": 1.98931086063385,
    "b": 5.51473140716553,
    "C": 5.86256074905396,
    "h": 70.1642761230469,
    "CMY_C": 0.03073310852051,
    "CMY_M": 0.07030308246613,
    "CMY_Y": 0.11255359649658,
    "CMYK_C": 0,
    "CMYK_M": 0.04082464054227,
    "CMYK_Y": 0.08441481739283,
    "CMYK_K": 0.03073310852051
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0427",
    "Farbtonhilfsbezeichnung": "Onyx 220",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "152",
    "Bcolor": "56",
    "Y": 40,
    "L": 70.2126007080078,
    "a": 25.2255268096924,
    "b": 60.7554550170898,
    "C": 65.7841339111328,
    "h": 67.4518890380859,
    "CMY_C": 0.06447541713715,
    "CMY_M": 0.40339994430542,
    "CMY_Y": 0.78227496147156,
    "CMYK_C": 0,
    "CMYK_M": 0.36228287220001,
    "CMYK_Y": 0.767269551754,
    "CMYK_K": 0.06447541713715
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0428",
    "Farbtonhilfsbezeichnung": "Onyx 225",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "88",
    "Y": 56,
    "L": 79.6934509277344,
    "a": 20.9976005554199,
    "b": 57.1797294616699,
    "C": 60.9132232666016,
    "h": 69.8357009887695,
    "CMY_C": 0,
    "CMY_M": 0.29059630632401,
    "CMY_Y": 0.65499234199524,
    "CMYK_C": 0,
    "CMYK_M": 0.29059630632401,
    "CMYK_Y": 0.65499234199524,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0429",
    "Farbtonhilfsbezeichnung": "Onyx 230",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "97",
    "Y": 57,
    "L": 79.809196472168,
    "a": 19.7549209594727,
    "b": 53.1924285888672,
    "C": 56.7423248291016,
    "h": 69.6257095336914,
    "CMY_C": 0,
    "CMY_M": 0.28527617454529,
    "CMY_Y": 0.62125879526138,
    "CMYK_C": 0,
    "CMYK_M": 0.28527617454529,
    "CMYK_Y": 0.62125879526138,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0430",
    "Farbtonhilfsbezeichnung": "Caramel 5",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "170",
    "Bcolor": "154",
    "Y": 41,
    "L": 70.405337899476,
    "a": 2.55132995085089,
    "b": 9.58446843130751,
    "C": 9.91823167852209,
    "h": 1.31063508217368,
    "CMY_C": 0.2782233,
    "CMY_M": 0.3327441,
    "CMY_Y": 0.3971038,
    "CMYK_C": 0,
    "CMYK_M": 0.07553693,
    "CMYK_Y": 0.1647053,
    "CMYK_K": 0.2782233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0431",
    "Farbtonhilfsbezeichnung": "Caramel 10",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "185",
    "Bcolor": "172",
    "Y": 50,
    "L": 75.8033840540032,
    "a": 2.18315575533329,
    "b": 7.51163240872974,
    "C": 7.82245425016496,
    "h": 1.287951734222,
    "CMY_C": 0.228207,
    "CMY_M": 0.2740014,
    "CMY_Y": 0.3263383,
    "CMYK_C": 0,
    "CMYK_M": 0.05933502,
    "CMYK_Y": 0.1271471,
    "CMYK_K": 0.228207
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0432",
    "Farbtonhilfsbezeichnung": "Caramel 15",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 59,
    "L": 80.6816816901664,
    "a": 1.79733599552417,
    "b": 5.94912348853387,
    "C": 6.214699265663,
    "h": 1.27739774695436,
    "CMY_C": 0.182338,
    "CMY_M": 0.2200878,
    "CMY_Y": 0.2635203,
    "CMYK_C": 0,
    "CMYK_M": 0.04616806,
    "CMYK_Y": 0.09928591,
    "CMYK_K": 0.182338
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0433",
    "Farbtonhilfsbezeichnung": "Caramel 20",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "214",
    "Bcolor": "205",
    "Y": 68,
    "L": 85.7735948312589,
    "a": 0.6761639111385,
    "b": 4.34771456081617,
    "C": 4.39997949279984,
    "h": 1.41651061761432,
    "CMY_C": 0.1396101,
    "CMY_M": 0.1613636,
    "CMY_Y": 0.1972446,
    "CMYK_C": 0,
    "CMYK_M": 0.02528331,
    "CMYK_Y": 0.06698646,
    "CMYK_K": 0.1396101
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0434",
    "Farbtonhilfsbezeichnung": "Caramel 25",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "218",
    "Y": 78,
    "L": 90.1220085983422,
    "a": 0.44255736231618,
    "b": 3.67554614276233,
    "C": 3.70209352482015,
    "h": 1.45096730318244,
    "CMY_C": 0.09524712,
    "CMY_M": 0.1125222,
    "CMY_Y": 0.144888,
    "CMYK_C": 0,
    "CMYK_M": 0.01909371,
    "CMYK_Y": 0.05486673,
    "CMYK_K": 0.09524712
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0435",
    "Farbtonhilfsbezeichnung": "Caramel 30",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 81,
    "L": 91.4345567661123,
    "a": 0.17602169300956,
    "b": 2.41289232742556,
    "C": 2.419304242992,
    "h": 1.49797482747103,
    "CMY_C": 0.08680882,
    "CMY_M": 0.09691472,
    "CMY_Y": 0.1211372,
    "CMYK_C": 0,
    "CMYK_M": 0.01106658,
    "CMYK_Y": 0.03759169,
    "CMYK_K": 0.08680882
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0436",
    "Farbtonhilfsbezeichnung": "Caramel 35",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "121",
    "Bcolor": "96",
    "Y": 20,
    "L": 52.0769678786542,
    "a": 4.8578588686416,
    "b": 15.8862176254491,
    "C": 16.6123659732974,
    "h": 1.27403539422694,
    "CMY_C": 0.4419499,
    "CMY_M": 0.5270039,
    "CMY_Y": 0.6216803,
    "CMYK_C": 0,
    "CMYK_M": 0.152413,
    "CMYK_Y": 0.3220686,
    "CMYK_K": 0.4419499
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0437",
    "Farbtonhilfsbezeichnung": "Caramel 40",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "140",
    "Bcolor": "120",
    "Y": 27,
    "L": 59.3910191076267,
    "a": 4.65521354403525,
    "b": 12.7213659555328,
    "C": 13.5463709130955,
    "h": 1.21999522050717,
    "CMY_C": 0.3734725,
    "CMY_M": 0.452449,
    "CMY_Y": 0.5295165,
    "CMYK_C": 0,
    "CMYK_M": 0.1260543,
    "CMYK_Y": 0.2490616,
    "CMYK_K": 0.3734725
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0438",
    "Farbtonhilfsbezeichnung": "Caramel 45",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "168",
    "Bcolor": "147",
    "Y": 41,
    "L": 69.970996145124,
    "a": 3.15139059462993,
    "b": 12.6102556330826,
    "C": 12.9980694647941,
    "h": 1.3259052367829,
    "CMY_C": 0.271045,
    "CMY_M": 0.3394337,
    "CMY_Y": 0.4227638,
    "CMYK_C": 0,
    "CMYK_M": 0.09381752,
    "CMYK_Y": 0.2081319,
    "CMYK_K": 0.271045
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0439",
    "Farbtonhilfsbezeichnung": "Caramel 50",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "196",
    "Bcolor": "175",
    "Y": 58,
    "L": 79.9237205353909,
    "a": 3.09398332947836,
    "b": 11.6878032563813,
    "C": 12.0903878268221,
    "h": 1.312013197029,
    "CMY_C": 0.1651553,
    "CMY_M": 0.2328389,
    "CMY_Y": 0.312824,
    "CMYK_C": 0,
    "CMYK_M": 0.08107327,
    "CMYK_Y": 0.1768817,
    "CMYK_K": 0.1651553
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0440",
    "Farbtonhilfsbezeichnung": "Caramel 55",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "210",
    "Bcolor": "192",
    "Y": 68,
    "L": 85.068854588549,
    "a": 2.87354609008905,
    "b": 10.1761120033674,
    "C": 10.5740494909446,
    "h": 1.29558059874949,
    "CMY_C": 0.1137512,
    "CMY_M": 0.1758789,
    "CMY_Y": 0.2471451,
    "CMYK_C": 0,
    "CMYK_M": 0.07010185,
    "CMYK_Y": 0.1505152,
    "CMYK_K": 0.1137512
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0441",
    "Farbtonhilfsbezeichnung": "Caramel 60",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "230",
    "Bcolor": "215",
    "Y": 82,
    "L": 91.871758161958,
    "a": 2.01024282655227,
    "b": 8.01952460294946,
    "C": 8.26763878498671,
    "h": 1.32518851306549,
    "CMY_C": 0.05009439,
    "CMY_M": 0.09797933,
    "CMY_Y": 0.1576613,
    "CMYK_C": 0,
    "CMYK_M": 0.05041021,
    "CMYK_Y": 0.1132396,
    "CMYK_K": 0.05009439
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0442",
    "Farbtonhilfsbezeichnung": "Caramel 65",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "177",
    "Bcolor": "143",
    "Y": 48,
    "L": 73.9874598301931,
    "a": 6.33078873486009,
    "b": 20.5409644981557,
    "C": 21.4944204043729,
    "h": 1.27183085546369,
    "CMY_C": 0.1876514,
    "CMY_M": 0.3063256,
    "CMY_Y": 0.4375635,
    "CMYK_C": 0,
    "CMYK_M": 0.1460877,
    "CMYK_Y": 0.3076414,
    "CMYK_K": 0.1876514
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0443",
    "Farbtonhilfsbezeichnung": "Caramel 70",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "200",
    "Bcolor": "175",
    "Y": 59,
    "L": 81.8957730704035,
    "a": 4.01881118978253,
    "b": 14.6646947135964,
    "C": 15.2053975423895,
    "h": 1.30331660732822,
    "CMY_C": 0.129025,
    "CMY_M": 0.2143972,
    "CMY_Y": 0.3134559,
    "CMYK_C": 0,
    "CMYK_M": 0.09801915,
    "CMYK_Y": 0.2117523,
    "CMYK_K": 0.129025
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0444",
    "Farbtonhilfsbezeichnung": "Caramel 75",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "211",
    "Bcolor": "185",
    "Y": 68,
    "L": 85.6384721111775,
    "a": 4.26340943879316,
    "b": 14.7640707858715,
    "C": 15.3673174696501,
    "h": 1.28967456477813,
    "CMY_C": 0.08508988,
    "CMY_M": 0.1741452,
    "CMY_Y": 0.2744482,
    "CMYK_C": 0,
    "CMYK_M": 0.09733776,
    "CMYK_Y": 0.2069693,
    "CMYK_K": 0.08508988
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0445",
    "Farbtonhilfsbezeichnung": "Caramel 80",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "222",
    "Bcolor": "197",
    "Y": 77,
    "L": 89.9983628255123,
    "a": 5.3287290954131,
    "b": 14.6265941336743,
    "C": 15.5670359967316,
    "h": 1.22142357229192,
    "CMY_C": 0.02844455,
    "CMY_M": 0.1286574,
    "CMY_Y": 0.2265089,
    "CMYK_C": 0,
    "CMYK_M": 0.1031468,
    "CMYK_Y": 0.2038632,
    "CMYK_K": 0.02844455
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0446",
    "Farbtonhilfsbezeichnung": "Caramel 85",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "224",
    "Bcolor": "204",
    "Y": 77,
    "L": 90.1866273097688,
    "a": 2.97830935898541,
    "b": 11.1881261399191,
    "C": 11.5777585551159,
    "h": 1.31062715124867,
    "CMY_C": 0.05270739,
    "CMY_M": 0.1199153,
    "CMY_Y": 0.199377,
    "CMYK_C": 0,
    "CMYK_M": 0.07094739,
    "CMYK_Y": 0.1548303,
    "CMYK_K": 0.05270739
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0447",
    "Farbtonhilfsbezeichnung": "Caramel 90",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "234",
    "Bcolor": "220",
    "Y": 88,
    "L": 93.2123318374142,
    "a": 1.69865264939961,
    "b": 7.20903488243798,
    "C": 7.40645696399567,
    "h": 1.33938902969976,
    "CMY_C": 0.0397755,
    "CMY_M": 0.08202804,
    "CMY_Y": 0.1369708,
    "CMYK_C": 0,
    "CMYK_M": 0.04400277,
    "CMYK_Y": 0.1012215,
    "CMYK_K": 0.0397755
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0448",
    "Farbtonhilfsbezeichnung": "Caramel 95",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "160",
    "Bcolor": "107",
    "Y": 40,
    "L": 69.050584024881,
    "a": 11.134559494794,
    "b": 33.8130374310786,
    "C": 35.5991561059897,
    "h": 1.25268212125204,
    "CMY_C": 0.1889216,
    "CMY_M": 0.3728148,
    "CMY_Y": 0.5817947,
    "CMYK_C": 0,
    "CMYK_M": 0.2267268,
    "CMYK_Y": 0.4843836,
    "CMYK_K": 0.1889216
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0449",
    "Farbtonhilfsbezeichnung": "Caramel 100",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "171",
    "Bcolor": "102",
    "Y": 48,
    "L": 74.3499039196235,
    "a": 14.9446452869861,
    "b": 43.2711880093593,
    "C": 45.7792325677829,
    "h": 1.23825061851095,
    "CMY_C": 0.09177156,
    "CMY_M": 0.3286884,
    "CMY_Y": 0.5991945,
    "CMYK_C": 0,
    "CMYK_M": 0.260856,
    "CMYK_Y": 0.5586953,
    "CMYK_K": 0.09177156
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0450",
    "Farbtonhilfsbezeichnung": "Caramel 105",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "175",
    "Bcolor": "66",
    "Y": 52,
    "L": 76.8583616429047,
    "a": 18.7013694939489,
    "b": 63.5451794953808,
    "C": 66.2399506193156,
    "h": 1.28457672343214,
    "CMY_C": 0.01837308,
    "CMY_M": 0.3151356,
    "CMY_Y": 0.7422232,
    "CMYK_C": 0,
    "CMYK_M": 0.302317,
    "CMYK_Y": 0.7373984,
    "CMYK_K": 0.01837308
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0451",
    "Farbtonhilfsbezeichnung": "Caramel 110",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "205",
    "Bcolor": "155",
    "Y": 66,
    "L": 85.0358148199398,
    "a": 8.62758034998207,
    "b": 29.9548955635174,
    "C": 31.1725987193341,
    "h": 1.29036715423157,
    "CMY_C": 0.02832256,
    "CMY_M": 0.1950176,
    "CMY_Y": 0.3922108,
    "CMYK_C": 0,
    "CMYK_M": 0.1715539,
    "CMYK_Y": 0.3744949,
    "CMYK_K": 0.02832256
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0452",
    "Farbtonhilfsbezeichnung": "Caramel 115",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "212",
    "Bcolor": "160",
    "Y": 73,
    "L": 87.4077092044889,
    "a": 8.64362554334847,
    "b": 30.7984301008893,
    "C": 31.9883659978591,
    "h": 1.29718359207154,
    "CMY_C": 0,
    "CMY_M": 0.1692596,
    "CMY_Y": 0.3737969,
    "CMYK_C": 0,
    "CMYK_M": 0.1692596,
    "CMYK_Y": 0.3737969,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0453",
    "Farbtonhilfsbezeichnung": "Caramel 120",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "216",
    "Bcolor": "176",
    "Y": 76,
    "L": 88.4011128682323,
    "a": 6.84085755817271,
    "b": 23.6866891376118,
    "C": 24.6547475029266,
    "h": 1.2896406456682,
    "CMY_C": 0.01443319,
    "CMY_M": 0.1522358,
    "CMY_Y": 0.3105803,
    "CMYK_C": 0,
    "CMYK_M": 0.1398207,
    "CMYK_Y": 0.3004841,
    "CMYK_K": 0.01443319
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0454",
    "Farbtonhilfsbezeichnung": "Palazzo 5",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "160",
    "Bcolor": "155",
    "Y": 35,
    "L": 66.0027770996094,
    "a": 0.59233373403549,
    "b": 2.1803240776062,
    "C": 2.25935220718384,
    "h": 74.801155090332,
    "CMY_C": 0.35985445976257,
    "CMY_M": 0.37255364656448,
    "CMY_Y": 0.39103198051453,
    "CMYK_C": 0,
    "CMYK_M": 0.01983796805143,
    "CMYK_Y": 0.04870380088687,
    "CMYK_K": 0.35985445976257
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0455",
    "Farbtonhilfsbezeichnung": "Palazzo 10",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "173",
    "Bcolor": "167",
    "Y": 41,
    "L": 70.6425704956055,
    "a": 0.40086427330971,
    "b": 2.28271222114563,
    "C": 2.31764268875122,
    "h": 80.0399169921875,
    "CMY_C": 0.31207555532455,
    "CMY_M": 0.32343530654907,
    "CMY_Y": 0.34362769126892,
    "CMYK_C": 0,
    "CMYK_M": 0.01651307940483,
    "CMYK_Y": 0.04586569964886,
    "CMYK_K": 0.31207555532455
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0456",
    "Farbtonhilfsbezeichnung": "Palazzo 15",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "186",
    "Bcolor": "181",
    "Y": 49,
    "L": 75.6731185913086,
    "a": 0.4760622382164,
    "b": 2.22556185722351,
    "C": 2.27590870857239,
    "h": 77.9260177612305,
    "CMY_C": 0.25798213481903,
    "CMY_M": 0.27002942562103,
    "CMY_Y": 0.2902712225914,
    "CMYK_C": 0,
    "CMYK_M": 0.0162358507514,
    "CMYK_Y": 0.0435152426362,
    "CMYK_K": 0.25798213481903
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0457",
    "Farbtonhilfsbezeichnung": "Palazzo 20",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "199",
    "Bcolor": "194",
    "Y": 57,
    "L": 80.2309417724609,
    "a": 0.31331419944763,
    "b": 1.88449084758759,
    "C": 1.91035902500153,
    "h": 80.5603866577148,
    "CMY_C": 0.2110230922699,
    "CMY_M": 0.22038966417313,
    "CMY_Y": 0.23922193050385,
    "CMYK_C": 0,
    "CMYK_M": 0.01187179517001,
    "CMYK_Y": 0.03574101999402,
    "CMYK_K": 0.2110230922699
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0458",
    "Farbtonhilfsbezeichnung": "Palazzo 25",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "214",
    "Bcolor": "209",
    "Y": 67,
    "L": 85.7237548828125,
    "a": 0.41210052371025,
    "b": 1.96878373622894,
    "C": 2.01145124435425,
    "h": 78.1776885986328,
    "CMY_C": 0.14983260631561,
    "CMY_M": 0.16060572862625,
    "CMY_Y": 0.18042582273483,
    "CMYK_C": 0,
    "CMYK_M": 0.01267176587135,
    "CMYK_Y": 0.03598493337631,
    "CMYK_K": 0.14983260631561
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0459",
    "Farbtonhilfsbezeichnung": "Palazzo 30",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "227",
    "Bcolor": "221",
    "Y": 76,
    "L": 90.1780624389648,
    "a": 0.29977235198021,
    "b": 2.3934109210968,
    "C": 2.41211104393005,
    "h": 82.8609390258789,
    "CMY_C": 0.09991711378098,
    "CMY_M": 0.11117076873779,
    "CMY_Y": 0.13481593132019,
    "CMYK_C": 0,
    "CMYK_M": 0.01250290963799,
    "CMYK_Y": 0.03877289220691,
    "CMYK_K": 0.09991711378098
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0460",
    "Farbtonhilfsbezeichnung": "Palazzo 35",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "129",
    "Bcolor": "123",
    "Y": 21,
    "L": 54.4358291625977,
    "a": 0.97489213943481,
    "b": 3.78758645057678,
    "C": 3.91103887557983,
    "h": 75.5658721923828,
    "CMY_C": 0.47143858671188,
    "CMY_M": 0.49216276407242,
    "CMY_Y": 0.51867353916168,
    "CMYK_C": 0,
    "CMYK_M": 0.0392086468637,
    "CMYK_Y": 0.08936511725187,
    "CMYK_K": 0.47143858671188
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0461",
    "Farbtonhilfsbezeichnung": "Palazzo 40",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "169",
    "Bcolor": "161",
    "Y": 39,
    "L": 69.3569564819336,
    "a": 1.00952208042145,
    "b": 3.83080554008484,
    "C": 3.9615912437439,
    "h": 75.2366409301758,
    "CMY_C": 0.31651157140732,
    "CMY_M": 0.33878254890442,
    "CMY_Y": 0.36778581142426,
    "CMYK_C": 0,
    "CMYK_M": 0.03258427977562,
    "CMYK_Y": 0.07501844316721,
    "CMYK_K": 0.31651157140732
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0462",
    "Farbtonhilfsbezeichnung": "Palazzo 45",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "186",
    "Bcolor": "178",
    "Y": 49,
    "L": 75.6367340087891,
    "a": 0.95156246423721,
    "b": 4.02809238433838,
    "C": 4.13896131515503,
    "h": 76.7085952758789,
    "CMY_C": 0.24922096729279,
    "CMY_M": 0.2719943523407,
    "CMY_Y": 0.30343270301819,
    "CMYK_C": 0,
    "CMYK_M": 0.03033300675452,
    "CMYK_Y": 0.07220730930567,
    "CMYK_K": 0.24922096729279
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0463",
    "Farbtonhilfsbezeichnung": "Palazzo 50",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "203",
    "Bcolor": "193",
    "Y": 60,
    "L": 81.9561157226563,
    "a": 0.7486629486084,
    "b": 5.18694162368774,
    "C": 5.24069261550903,
    "h": 81.7868728637695,
    "CMY_C": 0.17847841978073,
    "CMY_M": 0.2035323381424,
    "CMY_Y": 0.24452042579651,
    "CMYK_C": 0,
    "CMYK_M": 0.03049696981907,
    "CMYK_Y": 0.08038986474276,
    "CMYK_K": 0.17847841978073
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0464",
    "Farbtonhilfsbezeichnung": "Palazzo 55",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "216",
    "Bcolor": "206",
    "Y": 69,
    "L": 86.7596435546875,
    "a": 1.35939526557922,
    "b": 5.28297233581543,
    "C": 5.4550666809082,
    "h": 75.5699005126953,
    "CMY_C": 0.12055498361588,
    "CMY_M": 0.15234434604645,
    "CMY_Y": 0.19329482316971,
    "CMYK_C": 0,
    "CMYK_M": 0.03614707291126,
    "CMYK_Y": 0.08271107077599,
    "CMYK_K": 0.12055498361588
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0465",
    "Farbtonhilfsbezeichnung": "Palazzo 60",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "227",
    "Bcolor": "218",
    "Y": 77,
    "L": 90.4455871582031,
    "a": 0.92217123508453,
    "b": 4.35705280303955,
    "C": 4.45357275009155,
    "h": 78.049690246582,
    "CMY_C": 0.08571994304657,
    "CMY_M": 0.11022263765335,
    "CMY_Y": 0.14630645513535,
    "CMYK_C": 0,
    "CMYK_M": 0.02679998800159,
    "CMYK_Y": 0.06626690924168,
    "CMYK_K": 0.08571994304657
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0466",
    "Farbtonhilfsbezeichnung": "Palazzo 65",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "73",
    "Bcolor": "66",
    "Y": 6,
    "L": 31.0691890716553,
    "a": 0.62615162134171,
    "b": 4.49600744247437,
    "C": 4.53939962387085,
    "h": 82.0715026855469,
    "CMY_C": 0.69776827096939,
    "CMY_M": 0.71530985832214,
    "CMY_Y": 0.74281984567642,
    "CMYK_C": 0,
    "CMYK_M": 0.0580401904881,
    "CMYK_Y": 0.1490630209446,
    "CMYK_K": 0.69776827096939
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0467",
    "Farbtonhilfsbezeichnung": "Palazzo 70",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "95",
    "Bcolor": "89",
    "Y": 11,
    "L": 40.7567672729492,
    "a": 0.86098384857178,
    "b": 4.1080846786499,
    "C": 4.19733858108521,
    "h": 78.1631240844727,
    "CMY_C": 0.60623699426651,
    "CMY_M": 0.62569981813431,
    "CMY_Y": 0.65221107006073,
    "CMYK_C": 0,
    "CMYK_M": 0.0494277626276,
    "CMYK_Y": 0.11675570160151,
    "CMYK_K": 0.60623699426651
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0468",
    "Farbtonhilfsbezeichnung": "Palazzo 75",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "122",
    "Bcolor": "115",
    "Y": 19,
    "L": 51.5410346984863,
    "a": 1.05595779418945,
    "b": 4.20220470428467,
    "C": 4.332848072052,
    "h": 75.894401550293,
    "CMY_C": 0.49887299537659,
    "CMY_M": 0.52132487297058,
    "CMY_Y": 0.54983329772949,
    "CMYK_C": 0,
    "CMYK_M": 0.04480277001858,
    "CMYK_Y": 0.10169139504433,
    "CMYK_K": 0.49887299537659
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0469",
    "Farbtonhilfsbezeichnung": "Palazzo 80",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "155",
    "Bcolor": "144",
    "Y": 33,
    "L": 64.3430404663086,
    "a": 1.37330985069275,
    "b": 5.89084148406982,
    "C": 6.04880094528198,
    "h": 76.8772277832031,
    "CMY_C": 0.36078518629074,
    "CMY_M": 0.39250230789185,
    "CMY_Y": 0.43357115983963,
    "CMYK_C": 0,
    "CMYK_M": 0.04961887747049,
    "CMYK_Y": 0.11386778205633,
    "CMYK_K": 0.36078518629074
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0470",
    "Farbtonhilfsbezeichnung": "Palazzo 85",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "189",
    "Bcolor": "176",
    "Y": 51,
    "L": 76.901252746582,
    "a": 1.47863566875458,
    "b": 6.8903694152832,
    "C": 7.04723739624023,
    "h": 77.8883285522461,
    "CMY_C": 0.22316431999207,
    "CMY_M": 0.26038998365402,
    "CMY_Y": 0.31044799089432,
    "CMYK_C": 0,
    "CMYK_M": 0.04791961237788,
    "CMYK_Y": 0.11235795915127,
    "CMYK_K": 0.22316431999207
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0471",
    "Farbtonhilfsbezeichnung": "Palazzo 90",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "220",
    "Y": 82,
    "L": 93.0580825805664,
    "a": 1.12804687023163,
    "b": 7.0145320892334,
    "C": 7.10465717315674,
    "h": 80.8641586303711,
    "CMY_C": 0.04646563529968,
    "CMY_M": 0.08228749036789,
    "CMY_Y": 0.1373039484024,
    "CMYK_C": 0,
    "CMYK_M": 0.03756745159626,
    "CMYK_Y": 0.09526485204697,
    "CMYK_K": 0.04646563529968
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0472",
    "Farbtonhilfsbezeichnung": "Palazzo 95",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "129",
    "Bcolor": "118",
    "Y": 22,
    "L": 54.5956192016602,
    "a": 1.43233251571655,
    "b": 6.74145269393921,
    "C": 6.89193439483643,
    "h": 78.0049438476563,
    "CMY_C": 0.45874851942062,
    "CMY_M": 0.49226206541061,
    "CMY_Y": 0.53676789999008,
    "CMYK_C": 0,
    "CMYK_M": 0.06191862374544,
    "CMYK_Y": 0.1441462635994,
    "CMYK_K": 0.45874851942062
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0473",
    "Farbtonhilfsbezeichnung": "Palazzo 100",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "139",
    "Bcolor": "124",
    "Y": 26,
    "L": 58.7083930969238,
    "a": 2.21379590034485,
    "b": 9.12989139556885,
    "C": 9.394455909729,
    "h": 76.3701095581055,
    "CMY_C": 0.40518295764923,
    "CMY_M": 0.45300763845444,
    "CMY_Y": 0.51219803094864,
    "CMYK_C": 0,
    "CMYK_M": 0.08040233701468,
    "CMYK_Y": 0.17991258203983,
    "CMYK_K": 0.40518295764923
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0474",
    "Farbtonhilfsbezeichnung": "Palazzo 105",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "159",
    "Bcolor": "145",
    "Y": 34,
    "L": 65.8887634277344,
    "a": 1.73707592487335,
    "b": 8.1073112487793,
    "C": 8.29131603240967,
    "h": 77.906623840332,
    "CMY_C": 0.33592766523361,
    "CMY_M": 0.37781137228012,
    "CMY_Y": 0.43313044309616,
    "CMYK_C": 0,
    "CMYK_M": 0.06307099759579,
    "CMYK_Y": 0.14637377858162,
    "CMYK_K": 0.33592766523361
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0475",
    "Farbtonhilfsbezeichnung": "Palazzo 110",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "173",
    "Bcolor": "160",
    "Y": 42,
    "L": 71.2298889160156,
    "a": 1.63955140113831,
    "b": 7.40574312210083,
    "C": 7.58506155014038,
    "h": 77.5166854858398,
    "CMY_C": 0.28171414136887,
    "CMY_M": 0.32136726379395,
    "CMY_Y": 0.37338149547577,
    "CMYK_C": 0,
    "CMYK_M": 0.05520521104336,
    "CMYK_Y": 0.12761959433556,
    "CMYK_K": 0.28171414136887
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0476",
    "Farbtonhilfsbezeichnung": "Palazzo 115",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "208",
    "Bcolor": "196",
    "Y": 63,
    "L": 83.7762756347656,
    "a": 1.39829349517822,
    "b": 6.08645057678223,
    "C": 6.2450065612793,
    "h": 77.0614547729492,
    "CMY_C": 0.15084570646286,
    "CMY_M": 0.18542248010635,
    "CMY_Y": 0.23140722513199,
    "CMYK_C": 0,
    "CMYK_M": 0.0407190695405,
    "CMYK_Y": 0.09487265348434,
    "CMYK_K": 0.15084570646286
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0477",
    "Farbtonhilfsbezeichnung": "Palazzo 120",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "220",
    "Bcolor": "204",
    "Y": 73,
    "L": 88.4361190795898,
    "a": 1.83605659008026,
    "b": 8.60348510742188,
    "C": 8.79721927642822,
    "h": 77.9533004760742,
    "CMY_C": 0.08827966451645,
    "CMY_M": 0.13584893941879,
    "CMY_Y": 0.1994441151619,
    "CMYK_C": 0,
    "CMYK_M": 0.05217529088259,
    "CMYK_Y": 0.1219282373786,
    "CMYK_K": 0.08827966451645
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0478",
    "Farbtonhilfsbezeichnung": "Palazzo 125",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "83",
    "Bcolor": "70",
    "Y": 8,
    "L": 35.8060569763184,
    "a": 2.26436424255371,
    "b": 8.73799610137939,
    "C": 9.0266227722168,
    "h": 75.4719543457031,
    "CMY_C": 0.63416194915771,
    "CMY_M": 0.67605233192444,
    "CMY_Y": 0.72634768486023,
    "CMYK_C": 0,
    "CMYK_M": 0.11450526118279,
    "CMYK_Y": 0.25198510289192,
    "CMYK_K": 0.63416194915771
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0479",
    "Farbtonhilfsbezeichnung": "Palazzo 130",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "103",
    "Bcolor": "88",
    "Y": 14,
    "L": 44.3493804931641,
    "a": 2.32296276092529,
    "b": 9.62454319000244,
    "C": 9.90090847015381,
    "h": 76.4307022094727,
    "CMY_C": 0.54885828495026,
    "CMY_M": 0.59559869766235,
    "CMY_Y": 0.65372657775879,
    "CMYK_C": 0,
    "CMYK_M": 0.10360472649336,
    "CMYK_Y": 0.23245088756084,
    "CMYK_K": 0.54885828495026
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0480",
    "Farbtonhilfsbezeichnung": "Palazzo 135",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "125",
    "Bcolor": "105",
    "Y": 21,
    "L": 53.4055213928223,
    "a": 3.28904318809509,
    "b": 12.5051918029785,
    "C": 12.9304924011231,
    "h": 75.2641372680664,
    "CMY_C": 0.44503140449524,
    "CMY_M": 0.50954729318619,
    "CMY_Y": 0.58660221099854,
    "CMYK_C": 0,
    "CMYK_M": 0.11625142395496,
    "CMYK_Y": 0.25509697198868,
    "CMYK_K": 0.44503140449524
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0481",
    "Farbtonhilfsbezeichnung": "Palazzo 140",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "159",
    "Bcolor": "138",
    "Y": 36,
    "L": 66.4937515258789,
    "a": 2.97362065315247,
    "b": 12.6869258880615,
    "C": 13.0307521820068,
    "h": 76.8088684082031,
    "CMY_C": 0.30939072370529,
    "CMY_M": 0.37541592121124,
    "CMY_Y": 0.45866298675537,
    "CMYK_C": 0,
    "CMYK_M": 0.09560427069664,
    "CMYK_Y": 0.21614575386047,
    "CMYK_K": 0.30939072370529
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0482",
    "Farbtonhilfsbezeichnung": "Palazzo 145",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "183",
    "Bcolor": "163",
    "Y": 48,
    "L": 75.2383728027344,
    "a": 2.17402243614197,
    "b": 11.4990253448486,
    "C": 11.702733039856,
    "h": 79.2939376831055,
    "CMY_C": 0.22356998920441,
    "CMY_M": 0.28098273277283,
    "CMY_Y": 0.36070513725281,
    "CMYK_C": 0,
    "CMYK_M": 0.07394451647997,
    "CMYK_Y": 0.17662267386913,
    "CMYK_K": 0.22356998920441
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0483",
    "Farbtonhilfsbezeichnung": "Palazzo 155",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "92",
    "Bcolor": "73",
    "Y": 11,
    "L": 40.2783088684082,
    "a": 3.45965647697449,
    "b": 12.9823551177979,
    "C": 13.4354295730591,
    "h": 75.0780792236328,
    "CMY_C": 0.57530552148819,
    "CMY_M": 0.63754516839981,
    "CMY_Y": 0.71255558729172,
    "CMYK_C": 0,
    "CMYK_M": 0.14655157923698,
    "CMYK_Y": 0.32317364215851,
    "CMYK_K": 0.57530552148819
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0484",
    "Farbtonhilfsbezeichnung": "Palazzo 160",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "112",
    "Bcolor": "91",
    "Y": 16,
    "L": 48.0674629211426,
    "a": 2.40844440460205,
    "b": 13.3785915374756,
    "C": 13.5936498641968,
    "h": 79.794792175293,
    "CMY_C": 0.50316667556763,
    "CMY_M": 0.56047815084457,
    "CMY_Y": 0.64334732294083,
    "CMYK_C": 0,
    "CMYK_M": 0.11535352468491,
    "CMYK_Y": 0.28214824199677,
    "CMYK_K": 0.50316667556763
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0485",
    "Farbtonhilfsbezeichnung": "Palazzo 165",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "138",
    "Bcolor": "114",
    "Y": 26,
    "L": 58.3059883117676,
    "a": 2.88807988166809,
    "b": 14.3487281799316,
    "C": 14.63649559021,
    "h": 78.6196899414063,
    "CMY_C": 0.39272546768188,
    "CMY_M": 0.45976155996323,
    "CMY_Y": 0.5515501499176,
    "CMYK_C": 0,
    "CMYK_M": 0.11038844287395,
    "CMYK_Y": 0.26153686642647,
    "CMYK_K": 0.39272546768188
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0486",
    "Farbtonhilfsbezeichnung": "Palazzo 185",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "97",
    "Bcolor": "65",
    "Y": 12,
    "L": 42.884651184082,
    "a": 5.60802412033081,
    "b": 21.9266834259033,
    "C": 22.6324844360352,
    "h": 75.653434753418,
    "CMY_C": 0.52190136909485,
    "CMY_M": 0.61910331249237,
    "CMY_Y": 0.74673426151276,
    "CMYK_C": 0,
    "CMYK_M": 0.20330940186977,
    "CMYK_Y": 0.47026467323303,
    "CMYK_K": 0.52190136909485
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0487",
    "Farbtonhilfsbezeichnung": "Palazzo 190",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "124",
    "Bcolor": "87",
    "Y": 21,
    "L": 53.8338623046875,
    "a": 5.58839321136475,
    "b": 23.9855403900146,
    "C": 24.6279582977295,
    "h": 76.884635925293,
    "CMY_C": 0.40472686290741,
    "CMY_M": 0.51271641254425,
    "CMY_Y": 0.65979969501495,
    "CMYK_C": 0,
    "CMYK_M": 0.18141175806522,
    "CMYK_Y": 0.42849713563919,
    "CMYK_K": 0.40472686290741
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0488",
    "Farbtonhilfsbezeichnung": "Palazzo 195",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "159",
    "Bcolor": "121",
    "Y": 36,
    "L": 66.7404174804688,
    "a": 4.26644563674927,
    "b": 22.6704807281494,
    "C": 23.0684471130371,
    "h": 79.3419418334961,
    "CMY_C": 0.27655476331711,
    "CMY_M": 0.37797564268112,
    "CMY_Y": 0.52603578567505,
    "CMYK_C": 0,
    "CMYK_M": 0.14019151031971,
    "CMYK_Y": 0.34485128521919,
    "CMYK_K": 0.27655476331711
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0489",
    "Farbtonhilfsbezeichnung": "Palazzo 200",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "173",
    "Bcolor": "138",
    "Y": 44,
    "L": 72.1434478759766,
    "a": 4.50042200088501,
    "b": 21.0527381896973,
    "C": 21.5283908843994,
    "h": 77.9335479736328,
    "CMY_C": 0.21909791231155,
    "CMY_M": 0.32152885198593,
    "CMY_Y": 0.46031057834625,
    "CMYK_C": 0,
    "CMYK_M": 0.13117001950741,
    "CMYK_Y": 0.30888977646828,
    "CMYK_K": 0.21909791231155
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0490",
    "Farbtonhilfsbezeichnung": "Palazzo 205",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "195",
    "Bcolor": "157",
    "Y": 57,
    "L": 80.5195541381836,
    "a": 5.99791955947876,
    "b": 22.6341190338135,
    "C": 23.4153442382813,
    "h": 75.1580657958984,
    "CMY_C": 0.11230266094208,
    "CMY_M": 0.23592174053192,
    "CMY_Y": 0.38558489084244,
    "CMYK_C": 0,
    "CMYK_M": 0.13925814628601,
    "CMYK_Y": 0.30785518884659,
    "CMYK_K": 0.11230266094208
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0491",
    "Farbtonhilfsbezeichnung": "Palazzo 210",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "225",
    "Bcolor": "195",
    "Y": 77,
    "L": 90.6800384521484,
    "a": 3.12611627578735,
    "b": 16.6066360473633,
    "C": 16.8983116149902,
    "h": 79.3391189575195,
    "CMY_C": 0.03146451711655,
    "CMY_M": 0.11610966920853,
    "CMY_Y": 0.23423629999161,
    "CMYK_C": 0,
    "CMYK_M": 0.08739499002695,
    "CMYK_Y": 0.20935916900635,
    "CMYK_K": 0.03146451711655
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0492",
    "Farbtonhilfsbezeichnung": "Palazzo 215",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "139",
    "Bcolor": "86",
    "Y": 28,
    "L": 60.2467575073242,
    "a": 7.20190620422363,
    "b": 33.1996803283691,
    "C": 33.9718437194824,
    "h": 77.760627746582,
    "CMY_C": 0.31194841861725,
    "CMY_M": 0.45355743169785,
    "CMY_Y": 0.6635936498642,
    "CMYK_C": 0,
    "CMYK_M": 0.20581161975861,
    "CMYK_Y": 0.51107394695282,
    "CMYK_K": 0.31194841861725
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0493",
    "Farbtonhilfsbezeichnung": "Palazzo 220",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "172",
    "Bcolor": "127",
    "Y": 43,
    "L": 72.0217666625977,
    "a": 5.4258508682251,
    "b": 26.8031806945801,
    "C": 27.3468532562256,
    "h": 78.5560913085938,
    "CMY_C": 0.20303153991699,
    "CMY_M": 0.3261861205101,
    "CMY_Y": 0.50267148017883,
    "CMYK_C": 0,
    "CMYK_M": 0.15452879667282,
    "CMYK_Y": 0.37597465515137,
    "CMYK_K": 0.20303153991699
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0494",
    "Farbtonhilfsbezeichnung": "Palazzo 225",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "180",
    "Bcolor": "137",
    "Y": 49,
    "L": 75.3737030029297,
    "a": 6.54422760009766,
    "b": 26.0768527984619,
    "C": 26.8854827880859,
    "h": 75.9120407104492,
    "CMY_C": 0.15963852405548,
    "CMY_M": 0.29321181774139,
    "CMY_Y": 0.46335858106613,
    "CMYK_C": 0,
    "CMYK_M": 0.15894742310047,
    "CMYK_Y": 0.3614159822464,
    "CMYK_K": 0.15963852405548
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0495",
    "Farbtonhilfsbezeichnung": "Palazzo 230",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "159",
    "Y": 66,
    "L": 85.7321166992188,
    "a": 7.06141519546509,
    "b": 28.6253280639648,
    "C": 29.4834365844727,
    "h": 76.1427001953125,
    "CMY_C": 0.03333050012589,
    "CMY_M": 0.18312615156174,
    "CMY_Y": 0.37537097930908,
    "CMYK_C": 0,
    "CMYK_M": 0.15496055781841,
    "CMYK_Y": 0.35383394360542,
    "CMYK_K": 0.03333050012589
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0496",
    "Farbtonhilfsbezeichnung": "Palazzo 235",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "222",
    "Bcolor": "180",
    "Y": 77,
    "L": 90.0501937866211,
    "a": 5.57474613189697,
    "b": 23.7028293609619,
    "C": 24.3495769500732,
    "h": 76.7649536132813,
    "CMY_C": 0.00418424606323,
    "CMY_M": 0.13079941272736,
    "CMY_Y": 0.29343718290329,
    "CMYK_C": 0,
    "CMYK_M": 0.12714718282223,
    "CMYK_Y": 0.29046833515167,
    "CMYK_K": 0.00418424606323
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0497",
    "Farbtonhilfsbezeichnung": "Palazzo 240",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "217",
    "Y": 86,
    "L": 93.5942001342773,
    "a": 1.23391044139862,
    "b": 9.48377132415771,
    "C": 9.56370544433594,
    "h": 82.587028503418,
    "CMY_C": 0.03213679790497,
    "CMY_M": 0.07719755172729,
    "CMY_Y": 0.14980679750443,
    "CMYK_C": 0,
    "CMYK_M": 0.04655694589019,
    "CMYK_Y": 0.12157709896564,
    "CMYK_K": 0.03213679790497
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0498",
    "Farbtonhilfsbezeichnung": "Palazzo 245",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "122",
    "Bcolor": "71",
    "Y": 21,
    "L": 53.4918556213379,
    "a": 7.61055326461792,
    "b": 32.2132110595703,
    "C": 33.1000213623047,
    "h": 76.7072830200195,
    "CMY_C": 0.38465338945389,
    "CMY_M": 0.52217161655426,
    "CMY_Y": 0.72007775306702,
    "CMYK_C": 0,
    "CMYK_M": 0.22348092496395,
    "CMYK_Y": 0.54509824514389,
    "CMYK_K": 0.38465338945389
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0499",
    "Farbtonhilfsbezeichnung": "Palazzo 250",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "138",
    "Bcolor": "74",
    "Y": 28,
    "L": 60.1341514587402,
    "a": 8.90164279937744,
    "b": 39.3169136047363,
    "C": 40.3120193481445,
    "h": 77.2428817749023,
    "CMY_C": 0.29531663656235,
    "CMY_M": 0.45972353219986,
    "CMY_Y": 0.70930051803589,
    "CMYK_C": 0,
    "CMYK_M": 0.2333060503006,
    "CMYK_Y": 0.58747506141663,
    "CMYK_K": 0.29531663656235
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0500",
    "Farbtonhilfsbezeichnung": "Palazzo 255",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "169",
    "Bcolor": "103",
    "Y": 44,
    "L": 72.0585098266602,
    "a": 9.37129211425781,
    "b": 39.4706115722656,
    "C": 40.5678482055664,
    "h": 76.6438751220703,
    "CMY_C": 0.15727627277374,
    "CMY_M": 0.33773630857468,
    "CMY_Y": 0.59458458423615,
    "CMYK_C": 0,
    "CMYK_M": 0.21413902938366,
    "CMYK_Y": 0.51892250776291,
    "CMYK_K": 0.15727627277374
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0501",
    "Farbtonhilfsbezeichnung": "Palazzo 260",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "185",
    "Bcolor": "128",
    "Y": 53,
    "L": 77.6945190429688,
    "a": 8.2157621383667,
    "b": 34.2373466491699,
    "C": 35.2092971801758,
    "h": 76.5061645507813,
    "CMY_C": 0.10791045427322,
    "CMY_M": 0.27412754297256,
    "CMY_Y": 0.49942767620087,
    "CMYK_C": 0,
    "CMYK_M": 0.18632332980633,
    "CMYK_Y": 0.43887659907341,
    "CMYK_K": 0.10791045427322
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0502",
    "Farbtonhilfsbezeichnung": "Palazzo 270",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "217",
    "Bcolor": "158",
    "Y": 75,
    "L": 88.7652359008789,
    "a": 6.33862781524658,
    "b": 33.4039649963379,
    "C": 34.0000457763672,
    "h": 79.255485534668,
    "CMY_C": 0,
    "CMY_M": 0.14895242452621,
    "CMY_Y": 0.3797350525856,
    "CMYK_C": 0,
    "CMYK_M": 0.14895242452621,
    "CMYK_Y": 0.3797350525856,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0503",
    "Farbtonhilfsbezeichnung": "Palazzo 280",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "117",
    "Bcolor": "59",
    "Y": 20,
    "L": 51.9174385070801,
    "a": 9.22685718536377,
    "b": 36.6918907165527,
    "C": 37.8342399597168,
    "h": 75.8845901489258,
    "CMY_C": 0.38732671737671,
    "CMY_M": 0.54222255945206,
    "CMY_Y": 0.76684331893921,
    "CMYK_C": 0,
    "CMYK_M": 0.25281965732574,
    "CMYK_Y": 0.61944371461868,
    "CMYK_K": 0.38732671737671
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0504",
    "Farbtonhilfsbezeichnung": "Palazzo 285",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "161",
    "Bcolor": "79",
    "Y": 40,
    "L": 69.6447219848633,
    "a": 10.4868841171265,
    "b": 48.5185089111328,
    "C": 49.6389007568359,
    "h": 77.803596496582,
    "CMY_C": 0.16709458827972,
    "CMY_M": 0.36715042591095,
    "CMY_Y": 0.68826591968536,
    "CMYK_C": 0,
    "CMYK_M": 0.24019034206867,
    "CMYK_Y": 0.62572693824768,
    "CMYK_K": 0.16709458827972
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0505",
    "Farbtonhilfsbezeichnung": "Palazzo 290",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "172",
    "Bcolor": "92",
    "Y": 47,
    "L": 73.7007064819336,
    "a": 11.1088094711304,
    "b": 47.2178115844727,
    "C": 48.5069808959961,
    "h": 76.7609329223633,
    "CMY_C": 0.11763817071915,
    "CMY_M": 0.32602059841156,
    "CMY_Y": 0.63750660419464,
    "CMYK_C": 0,
    "CMYK_M": 0.23616437613964,
    "CMYK_Y": 0.58917826414108,
    "CMYK_K": 0.11763817071915
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0506",
    "Farbtonhilfsbezeichnung": "Palazzo 295",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "189",
    "Bcolor": "117",
    "Y": 57,
    "L": 79.8532485961914,
    "a": 10.5311574935913,
    "b": 42.7589378356934,
    "C": 44.0367126464844,
    "h": 76.1639175415039,
    "CMY_C": 0.0550901889801,
    "CMY_M": 0.25833070278168,
    "CMY_Y": 0.54141783714294,
    "CMYK_C": 0,
    "CMYK_M": 0.21508985757828,
    "CMYK_Y": 0.5146815776825,
    "CMYK_K": 0.0550901889801
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0507",
    "Farbtonhilfsbezeichnung": "Palazzo 305",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "134",
    "Bcolor": "62",
    "Y": 27,
    "L": 59.3873062133789,
    "a": 11.961859703064,
    "b": 44.6014518737793,
    "C": 46.1776542663574,
    "h": 74.9868927001953,
    "CMY_C": 0.28041237592697,
    "CMY_M": 0.47561222314835,
    "CMY_Y": 0.75629711151123,
    "CMYK_C": 0,
    "CMYK_M": 0.27126625180244,
    "CMYK_Y": 0.66132980585098,
    "CMYK_K": 0.28041237592697
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0508",
    "Farbtonhilfsbezeichnung": "Palazzo 310",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "143",
    "Bcolor": "57",
    "Y": 32,
    "L": 63.2642211914063,
    "a": 12.5697154998779,
    "b": 51.6041870117188,
    "C": 53.1129913330078,
    "h": 76.3105163574219,
    "CMY_C": 0.22588092088699,
    "CMY_M": 0.43867242336273,
    "CMY_Y": 0.77640318870544,
    "CMYK_C": 0,
    "CMYK_M": 0.27488213777542,
    "CMYK_Y": 0.71115964651108,
    "CMYK_K": 0.22588092088699
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0509",
    "Farbtonhilfsbezeichnung": "Palazzo 315",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "150",
    "Bcolor": "69",
    "Y": 34,
    "L": 65.5365982055664,
    "a": 11.2595300674438,
    "b": 48.8015365600586,
    "C": 50.0835990905762,
    "h": 77.0080184936523,
    "CMY_C": 0.20980799198151,
    "CMY_M": 0.4117004275322,
    "CMY_Y": 0.73076665401459,
    "CMYK_C": 0,
    "CMYK_M": 0.25549793243408,
    "CMYK_Y": 0.65928113460541,
    "CMYK_K": 0.20980799198151
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0510",
    "Farbtonhilfsbezeichnung": "Palazzo 320",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "173",
    "Bcolor": "71",
    "Y": 48,
    "L": 74.4529113769531,
    "a": 11.8116760253906,
    "b": 58.4147148132324,
    "C": 59.5969352722168,
    "h": 78.5687103271484,
    "CMY_C": 0.09252339601517,
    "CMY_M": 0.32134431600571,
    "CMY_Y": 0.72330743074417,
    "CMYK_C": 0,
    "CMYK_M": 0.25215077400208,
    "CMYK_Y": 0.69509673118591,
    "CMYK_K": 0.09252339601517
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0511",
    "Farbtonhilfsbezeichnung": "Palazzo 335",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "140",
    "Bcolor": "49",
    "Y": 30,
    "L": 61.9570503234863,
    "a": 12.3982915878296,
    "b": 53.4801025390625,
    "C": 54.8984413146973,
    "h": 76.9476928710938,
    "CMY_C": 0.24038952589035,
    "CMY_M": 0.45173984766006,
    "CMY_Y": 0.8065612912178,
    "CMYK_C": 0,
    "CMYK_M": 0.27823513746262,
    "CMYK_Y": 0.74534487724304,
    "CMYK_K": 0.24038952589035
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0512",
    "Farbtonhilfsbezeichnung": "Palazzo 340",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "149",
    "Bcolor": "50",
    "Y": 35,
    "L": 65.6671829223633,
    "a": 13.5697469711304,
    "b": 57.5280380249023,
    "C": 59.1067962646484,
    "h": 76.7276458740234,
    "CMY_C": 0.18709182739258,
    "CMY_M": 0.41731685400009,
    "CMY_Y": 0.80576455593109,
    "CMYK_C": 0,
    "CMYK_M": 0.28321158885956,
    "CMYK_Y": 0.7610610127449,
    "CMYK_K": 0.18709182739258
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0513",
    "Farbtonhilfsbezeichnung": "Palazzo 345",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "171",
    "Bcolor": "48",
    "Y": 47,
    "L": 73.6719055175781,
    "a": 11.7328948974609,
    "b": 66.4103927612305,
    "C": 67.4388656616211,
    "h": 79.9807968139648,
    "CMY_C": 0.09540188312531,
    "CMY_M": 0.33021622896194,
    "CMY_Y": 0.81123471260071,
    "CMYK_C": 0,
    "CMYK_M": 0.25957864522934,
    "CMYK_Y": 0.79132688045502,
    "CMYK_K": 0.09540188312531
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0514",
    "Farbtonhilfsbezeichnung": "Palazzo 350",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "1",
    "Y": 55,
    "L": 79.5002899169922,
    "a": 18.4113178253174,
    "b": 81.8059310913086,
    "C": 83.8521728515625,
    "h": 77.316291809082,
    "CMY_C": 0,
    "CMY_M": 0.28792655467987,
    "CMY_Y": 0.99490827322006,
    "CMYK_C": 0,
    "CMYK_M": 0.28792655467987,
    "CMYK_Y": 0.99490827322006,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0515",
    "Farbtonhilfsbezeichnung": "Palazzo 355",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "185",
    "Bcolor": "59",
    "Y": 57,
    "L": 79.7901000976563,
    "a": 14.9040937423706,
    "b": 69.2829742431641,
    "C": 70.867919921875,
    "h": 77.8595962524414,
    "CMY_C": 0.0001021027565,
    "CMY_M": 0.27405327558517,
    "CMY_Y": 0.77026659250259,
    "CMYK_C": 0,
    "CMYK_M": 0.2739791572094,
    "CMYK_Y": 0.77024310827255,
    "CMYK_K": 0.0001021027565
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0516",
    "Farbtonhilfsbezeichnung": "Ginster 5",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "167",
    "Bcolor": "148",
    "Y": 39,
    "L": 68.8544464111328,
    "a": 1.56808769702911,
    "b": 10.3397636413574,
    "C": 10.4579925537109,
    "h": 81.3764572143555,
    "CMY_C": 0.29971939325333,
    "CMY_M": 0.3469535112381,
    "CMY_Y": 0.41847151517868,
    "CMYK_C": 0,
    "CMYK_M": 0.06745027005672,
    "CMYK_Y": 0.16957791149616,
    "CMYK_K": 0.29971939325333
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0517",
    "Farbtonhilfsbezeichnung": "Ginster 10",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "181",
    "Bcolor": "165",
    "Y": 47,
    "L": 74.0912551879883,
    "a": 1.87113189697266,
    "b": 8.84312915802002,
    "C": 9.03891944885254,
    "h": 78.0529098510742,
    "CMY_C": 0.24528849124908,
    "CMY_M": 0.29187428951263,
    "CMY_Y": 0.35377997159958,
    "CMYK_C": 0,
    "CMYK_M": 0.06172662973404,
    "CMYK_Y": 0.14375224709511,
    "CMYK_K": 0.24528849124908
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0518",
    "Farbtonhilfsbezeichnung": "Ginster 15",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "195",
    "Bcolor": "181",
    "Y": 55,
    "L": 79.1457595825195,
    "a": 1.12081301212311,
    "b": 7.16399383544922,
    "C": 7.25113964080811,
    "h": 81.1081085205078,
    "CMY_C": 0.20055025815964,
    "CMY_M": 0.2354279756546,
    "CMY_Y": 0.28872436285019,
    "CMYK_C": 0,
    "CMYK_M": 0.04362715408206,
    "CMYK_Y": 0.11029349267483,
    "CMYK_K": 0.20055025815964
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0519",
    "Farbtonhilfsbezeichnung": "Ginster 20",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "214",
    "Bcolor": "203",
    "Y": 67,
    "L": 85.8472290039063,
    "a": 0.73820054531097,
    "b": 5.26663541793823,
    "C": 5.31811904907227,
    "h": 82.0210952758789,
    "CMY_C": 0.13543856143951,
    "CMY_M": 0.16091704368591,
    "CMY_Y": 0.20316052436829,
    "CMYK_C": 0,
    "CMYK_M": 0.02946983464062,
    "CMYK_Y": 0.07833100110292,
    "CMYK_K": 0.13543856143951
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0520",
    "Farbtonhilfsbezeichnung": "Ginster 25",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "230",
    "Bcolor": "220",
    "Y": 77,
    "L": 91.3321533203125,
    "a": 0.56080359220505,
    "b": 4.36662626266479,
    "C": 4.40249061584473,
    "h": 82.6815948486328,
    "CMY_C": 0.07856041193008,
    "CMY_M": 0.09948623180389,
    "CMY_Y": 0.13669174909592,
    "CMYK_C": 0,
    "CMYK_M": 0.02270992100239,
    "CMYK_Y": 0.06308751553297,
    "CMYK_K": 0.07856041193008
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0521",
    "Farbtonhilfsbezeichnung": "Ginster 30",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "226",
    "Y": 81,
    "L": 92.372444152832,
    "a": 0.42365649342537,
    "b": 3.00914359092712,
    "C": 3.03882050514221,
    "h": 81.9860153198242,
    "CMY_C": 0.07238346338272,
    "CMY_M": 0.08716571331024,
    "CMY_Y": 0.11517286300659,
    "CMYK_C": 0,
    "CMYK_M": 0.01593573391438,
    "CMYK_Y": 0.04612832888961,
    "CMYK_K": 0.07238346338272
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0522",
    "Farbtonhilfsbezeichnung": "Ginster 35",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "123",
    "Bcolor": "96",
    "Y": 20,
    "L": 52.4554901123047,
    "a": 3.00146627426147,
    "b": 16.6154346466064,
    "C": 16.8843555450439,
    "h": 79.7603302001953,
    "CMY_C": 0.44812202453613,
    "CMY_M": 0.51919436454773,
    "CMY_Y": 0.62329137325287,
    "CMYK_C": 0,
    "CMYK_M": 0.12878270447254,
    "CMYK_Y": 0.31740593910217,
    "CMYK_K": 0.44812202453613
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0523",
    "Farbtonhilfsbezeichnung": "Ginster 40",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "140",
    "Bcolor": "117",
    "Y": 26,
    "L": 58.8937835693359,
    "a": 2.06693577766418,
    "b": 13.7522535324097,
    "C": 13.9067144393921,
    "h": 81.4525375366211,
    "CMY_C": 0.39327090978622,
    "CMY_M": 0.45182090997696,
    "CMY_Y": 0.5418564081192,
    "CMYK_C": 0,
    "CMYK_M": 0.09650105983019,
    "CMYK_Y": 0.24489594995975,
    "CMYK_K": 0.39327090978622
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0524",
    "Farbtonhilfsbezeichnung": "Ginster 45",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "169",
    "Bcolor": "145",
    "Y": 41,
    "L": 69.7630081176758,
    "a": 1.57363045215607,
    "b": 13.3437347412109,
    "C": 13.436203956604,
    "h": 83.2741546630859,
    "CMY_C": 0.28233087062836,
    "CMY_M": 0.33811259269714,
    "CMY_Y": 0.43030518293381,
    "CMYK_C": 0,
    "CMYK_M": 0.07772623747587,
    "CMYK_Y": 0.20618736743927,
    "CMYK_K": 0.28233087062836
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0525",
    "Farbtonhilfsbezeichnung": "Ginster 50",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "198",
    "Bcolor": "175",
    "Y": 58,
    "L": 80.5649490356445,
    "a": 1.68524181842804,
    "b": 12.7853479385376,
    "C": 12.8959360122681,
    "h": 82.4911041259766,
    "CMY_C": 0.16525083780289,
    "CMY_M": 0.22278481721878,
    "CMY_Y": 0.31422728300095,
    "CMYK_C": 0,
    "CMYK_M": 0.06892367452383,
    "CMYK_Y": 0.17846851050854,
    "CMYK_K": 0.16525083780289
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0526",
    "Farbtonhilfsbezeichnung": "Ginster 55",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "213",
    "Bcolor": "192",
    "Y": 67,
    "L": 85.9688415527344,
    "a": 1.42793881893158,
    "b": 11.7163906097412,
    "C": 11.8030853271484,
    "h": 83.0513305664063,
    "CMY_C": 0.11001884937286,
    "CMY_M": 0.16288763284683,
    "CMY_Y": 0.24900585412979,
    "CMYK_C": 0,
    "CMYK_M": 0.05940438434482,
    "CMYK_Y": 0.15616847574711,
    "CMYK_K": 0.11001884937286
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0527",
    "Farbtonhilfsbezeichnung": "Ginster 60",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "227",
    "Bcolor": "204",
    "Y": 77,
    "L": 90.8918762207031,
    "a": 1.69859135150909,
    "b": 12.1113424301148,
    "C": 12.2298746109009,
    "h": 82.0164566040039,
    "CMY_C": 0.05162805318832,
    "CMY_M": 0.10917127132416,
    "CMY_Y": 0.19877457618713,
    "CMYK_C": 0,
    "CMYK_M": 0.06067579239607,
    "CMYK_Y": 0.15515697002411,
    "CMYK_K": 0.05162805318832
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0528",
    "Farbtonhilfsbezeichnung": "Ginster 65",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "142",
    "Bcolor": "100",
    "Y": 29,
    "L": 60.3025360107422,
    "a": 3.54775142669678,
    "b": 25.3985557556152,
    "C": 25.6451396942139,
    "h": 82.0481948852539,
    "CMY_C": 0.34578227996826,
    "CMY_M": 0.44311171770096,
    "CMY_Y": 0.60837632417679,
    "CMYK_C": 0,
    "CMYK_M": 0.14877223968506,
    "CMYK_Y": 0.40138632059097,
    "CMYK_K": 0.34578227996826
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0529",
    "Farbtonhilfsbezeichnung": "Ginster 70",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "169",
    "Bcolor": "128",
    "Y": 41,
    "L": 70.5521011352539,
    "a": 3.45904803276062,
    "b": 23.8215885162354,
    "C": 24.0714168548584,
    "h": 81.7380294799805,
    "CMY_C": 0.23784118890762,
    "CMY_M": 0.33641529083252,
    "CMY_Y": 0.49635946750641,
    "CMYK_C": 0,
    "CMYK_M": 0.12933538854122,
    "CMYK_Y": 0.33919215202332,
    "CMYK_K": 0.23784118890762
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0530",
    "Farbtonhilfsbezeichnung": "Ginster 75",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "187",
    "Bcolor": "155",
    "Y": 51,
    "L": 76.9151840209961,
    "a": 2.32652807235718,
    "b": 18.2485885620117,
    "C": 18.3962955474854,
    "h": 82.734504699707,
    "CMY_C": 0.18742156028748,
    "CMY_M": 0.26494067907333,
    "CMY_Y": 0.39172267913818,
    "CMYK_C": 0,
    "CMYK_M": 0.09539893269539,
    "CMYK_Y": 0.25142326951027,
    "CMYK_K": 0.18742156028748
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0531",
    "Farbtonhilfsbezeichnung": "Ginster 80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "203",
    "Bcolor": "166",
    "Y": 61,
    "L": 82.4891510009766,
    "a": 2.48858046531677,
    "b": 20.3921890258789,
    "C": 20.5434761047363,
    "h": 83.0422592163086,
    "CMY_C": 0.11926108598709,
    "CMY_M": 0.20554691553116,
    "CMY_Y": 0.34929668903351,
    "CMYK_C": 0,
    "CMYK_M": 0.097969815135,
    "CMYK_Y": 0.26118478178978,
    "CMYK_K": 0.11926108598709
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0532",
    "Farbtonhilfsbezeichnung": "Ginster 85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "220",
    "Bcolor": "185",
    "Y": 72,
    "L": 88.5227737426758,
    "a": 2.37939691543579,
    "b": 18.9731216430664,
    "C": 19.1217384338379,
    "h": 82.851921081543,
    "CMY_C": 0.05538231134415,
    "CMY_M": 0.13876211643219,
    "CMY_Y": 0.27507215738297,
    "CMYK_C": 0,
    "CMYK_M": 0.08826830983162,
    "CMYK_Y": 0.23257011175156,
    "CMYK_K": 0.05538231134415
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0533",
    "Farbtonhilfsbezeichnung": "Ginster 95",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "188",
    "Bcolor": "140",
    "Y": 53,
    "L": 77.8512420654297,
    "a": 4.20068979263306,
    "b": 27.8501739501953,
    "C": 28.1651916503906,
    "h": 81.4226379394531,
    "CMY_C": 0.14380097389221,
    "CMY_M": 0.26136767864227,
    "CMY_Y": 0.45155775547028,
    "CMYK_C": 0,
    "CMYK_M": 0.13731235265732,
    "CMYK_Y": 0.35944536328316,
    "CMYK_K": 0.14380097389221
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0534",
    "Farbtonhilfsbezeichnung": "Ginster 100",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "193",
    "Bcolor": "128",
    "Y": 56,
    "L": 80.0871047973633,
    "a": 5.14002704620361,
    "b": 37.2490501403809,
    "C": 37.6020164489746,
    "h": 82.1433258056641,
    "CMY_C": 0.09529137611389,
    "CMY_M": 0.2413324713707,
    "CMY_Y": 0.49847918748856,
    "CMYK_C": 0,
    "CMYK_M": 0.16142335534096,
    "CMYK_Y": 0.44565486907959,
    "CMYK_K": 0.09529137611389
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0535",
    "Farbtonhilfsbezeichnung": "Ginster 105",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "207",
    "Bcolor": "140",
    "Y": 66,
    "L": 85.3371124267578,
    "a": 6.1295371055603,
    "b": 38.1204109191895,
    "C": 38.6100616455078,
    "h": 80.8653717041016,
    "CMY_C": 0.02660423517227,
    "CMY_M": 0.18694466352463,
    "CMY_Y": 0.45115792751312,
    "CMYK_C": 0,
    "CMYK_M": 0.16472275555134,
    "CMYK_Y": 0.43615731596947,
    "CMYK_K": 0.02660423517227
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0536",
    "Farbtonhilfsbezeichnung": "Ginster 110",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "209",
    "Bcolor": "147",
    "Y": 66,
    "L": 85.2882537841797,
    "a": 3.88045120239258,
    "b": 34.5473213195801,
    "C": 34.7645683288574,
    "h": 83.5912399291992,
    "CMY_C": 0.04847872257233,
    "CMY_M": 0.18125998973846,
    "CMY_Y": 0.4250785112381,
    "CMYK_C": 0,
    "CMYK_M": 0.13954629004002,
    "CMYK_Y": 0.39578703045845,
    "CMYK_K": 0.04847872257233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0537",
    "Farbtonhilfsbezeichnung": "Ginster 125",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "173",
    "Bcolor": "18",
    "Y": 47,
    "L": 74.833610534668,
    "a": 12.3309564590454,
    "b": 75.3241729736328,
    "C": 76.3268203735352,
    "h": 80.7028503417969,
    "CMY_C": 0.07148170471191,
    "CMY_M": 0.3203404545784,
    "CMY_Y": 0.92962092161179,
    "CMYK_C": 0,
    "CMYK_M": 0.26801705360413,
    "CMYK_Y": 0.92420279979706,
    "CMYK_K": 0.07148170471191
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0538",
    "Farbtonhilfsbezeichnung": "Ginster 130",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "185",
    "Bcolor": "11",
    "Y": 55,
    "L": 78.6820907592773,
    "a": 10.4687232971191,
    "b": 79.4940948486328,
    "C": 80.1804580688477,
    "h": 82.4977874755859,
    "CMY_C": 0.03258907794952,
    "CMY_M": 0.27505618333817,
    "CMY_Y": 0.95697736740112,
    "CMYK_C": 0,
    "CMYK_M": 0.25063505768776,
    "CMYK_Y": 0.95552808046341,
    "CMYK_K": 0.03258907794952
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0539",
    "Farbtonhilfsbezeichnung": "Ginster 135",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "78",
    "Y": 63,
    "L": 83.8324203491211,
    "a": 7.80335569381714,
    "b": 65.8161773681641,
    "C": 66.2771606445313,
    "h": 83.238410949707,
    "CMY_C": 0,
    "CMY_M": 0.21157419681549,
    "CMY_Y": 0.69482731819153,
    "CMYK_C": 0,
    "CMYK_M": 0.21157419681549,
    "CMYK_Y": 0.69482731819153,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0540",
    "Farbtonhilfsbezeichnung": "Ginster 140",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "203",
    "Bcolor": "111",
    "Y": 64,
    "L": 84.1485061645508,
    "a": 6.41389417648315,
    "b": 51.1429862976074,
    "C": 51.5436019897461,
    "h": 82.8517990112305,
    "CMY_C": 0.01897728443146,
    "CMY_M": 0.20273274183273,
    "CMY_Y": 0.56503677368164,
    "CMYK_C": 0,
    "CMYK_M": 0.18731009960175,
    "CMYK_Y": 0.55662268400192,
    "CMYK_K": 0.01897728443146
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0541",
    "Farbtonhilfsbezeichnung": "Ginster 145",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "98",
    "Y": 70,
    "L": 86.5562515258789,
    "a": 6.57727861404419,
    "b": 60.2511940002441,
    "C": 60.609130859375,
    "h": 83.77001953125,
    "CMY_C": 0,
    "CMY_M": 0.17815452814102,
    "CMY_Y": 0.61627316474915,
    "CMYK_C": 0,
    "CMYK_M": 0.17815452814102,
    "CMYK_Y": 0.61627316474915,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0542",
    "Farbtonhilfsbezeichnung": "Curry 5",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "175",
    "Bcolor": "149",
    "Y": 43,
    "L": 72.1062088012695,
    "a": 0.95505166053772,
    "b": 14.5236759185791,
    "C": 14.55504322052,
    "h": 86.2377395629883,
    "CMY_C": 0.2584382891655,
    "CMY_M": 0.31220877170563,
    "CMY_Y": 0.41479229927063,
    "CMYK_C": 0,
    "CMYK_M": 0.07250978797674,
    "CMYK_Y": 0.21084423363209,
    "CMYK_K": 0.2584382891655
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0543",
    "Farbtonhilfsbezeichnung": "Curry 10",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "195",
    "Bcolor": "172",
    "Y": 55,
    "L": 79.2220764160156,
    "a": 0.41069170832634,
    "b": 12.3725299835205,
    "C": 12.3793439865112,
    "h": 88.0988311767578,
    "CMY_C": 0.19031667709351,
    "CMY_M": 0.23424428701401,
    "CMY_Y": 0.32558238506317,
    "CMYK_C": 0,
    "CMYK_M": 0.05425282940269,
    "CMYK_Y": 0.16706001758575,
    "CMYK_K": 0.19031667709351
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0544",
    "Farbtonhilfsbezeichnung": "Curry 15",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "213",
    "Bcolor": "196",
    "Y": 67,
    "L": 85.5610275268555,
    "a": 0.27354788780212,
    "b": 8.66056346893311,
    "C": 8.66488265991211,
    "h": 88.1908874511719,
    "CMY_C": 0.13185685873032,
    "CMY_M": 0.16386204957962,
    "CMY_Y": 0.23116415739059,
    "CMYK_C": 0,
    "CMYK_M": 0.03686625882983,
    "CMYK_Y": 0.11439046263695,
    "CMYK_K": 0.13185685873032
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0545",
    "Farbtonhilfsbezeichnung": "Curry 20",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "208",
    "Y": 74,
    "L": 89.0372161865234,
    "a": 0.56762492656708,
    "b": 7.40143156051636,
    "C": 7.42316579818726,
    "h": 85.614501953125,
    "CMY_C": 0.09470647573471,
    "CMY_M": 0.12584227323532,
    "CMY_Y": 0.18424075841904,
    "CMYK_C": 0,
    "CMYK_M": 0.03439304232597,
    "CMYK_Y": 0.09890083223581,
    "CMYK_K": 0.09470647573471
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0546",
    "Farbtonhilfsbezeichnung": "Curry 25",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "220",
    "Y": 83,
    "L": 93.2415466308594,
    "a": 0.43995973467827,
    "b": 7.19583082199097,
    "C": 7.20926809310913,
    "h": 86.5012359619141,
    "CMY_C": 0.04912239313126,
    "CMY_M": 0.07862734794617,
    "CMY_Y": 0.13674038648605,
    "CMYK_C": 0,
    "CMYK_M": 0.03102918341756,
    "CMYK_Y": 0.0921443477273,
    "CMYK_K": 0.04912239313126
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0547",
    "Farbtonhilfsbezeichnung": "Curry 30",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "222",
    "Y": 87,
    "L": 94.7102661132812,
    "a": -0.06545221060514,
    "b": 8.26130294799805,
    "C": 8.26156234741211,
    "h": 90.4539337158203,
    "CMY_C": 0.03314357995987,
    "CMY_M": 0.0612216591835,
    "CMY_Y": 0.12860405445099,
    "CMYK_C": 0,
    "CMYK_M": 0.02904058806598,
    "CMYK_Y": 0.09873283654451,
    "CMYK_K": 0.03314357995987
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0548",
    "Farbtonhilfsbezeichnung": "Curry 35",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "145",
    "Bcolor": "100",
    "Y": 29,
    "L": 61.117000579834,
    "a": 1.90160822868347,
    "b": 26.6100177764893,
    "C": 26.6778774261475,
    "h": 85.912467956543,
    "CMY_C": 0.34525907039642,
    "CMY_M": 0.43125969171524,
    "CMY_Y": 0.60938942432404,
    "CMYK_C": 0,
    "CMYK_M": 0.13135060667992,
    "CMYK_Y": 0.40341201424599,
    "CMYK_K": 0.34525907039642
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0549",
    "Farbtonhilfsbezeichnung": "Curry 40",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "174",
    "Bcolor": "127",
    "Y": 43,
    "L": 71.9931945800781,
    "a": 1.13085043430328,
    "b": 26.3632736206055,
    "C": 26.3875160217285,
    "h": 87.5438079833984,
    "CMY_C": 0.23235499858856,
    "CMY_M": 0.31627279520035,
    "CMY_Y": 0.50064325332642,
    "CMYK_C": 0,
    "CMYK_M": 0.10931849479675,
    "CMYK_Y": 0.34949520230293,
    "CMYK_K": 0.23235499858856
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0550",
    "Farbtonhilfsbezeichnung": "Curry 45",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "198",
    "Bcolor": "156",
    "Y": 58,
    "L": 80.6717758178711,
    "a": 1.22245383262634,
    "b": 23.3272590637207,
    "C": 23.3592681884766,
    "h": 87.0001831054688,
    "CMY_C": 0.1417573094368,
    "CMY_M": 0.22291541099548,
    "CMY_Y": 0.38997054100037,
    "CMYK_C": 0,
    "CMYK_M": 0.09456311166286,
    "CMYK_Y": 0.28921100497246,
    "CMYK_K": 0.1417573094368
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0551",
    "Farbtonhilfsbezeichnung": "Curry 50",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "218",
    "Bcolor": "186",
    "Y": 71,
    "L": 87.5604705810547,
    "a": 0.47519224882126,
    "b": 17.046875,
    "C": 17.0534973144531,
    "h": 88.4032592773438,
    "CMY_C": 0.08487987518311,
    "CMY_M": 0.14437317848206,
    "CMY_Y": 0.2714005112648,
    "CMYK_C": 0,
    "CMYK_M": 0.06501147150993,
    "CMYK_Y": 0.20382092893124,
    "CMYK_K": 0.08487987518311
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0552",
    "Farbtonhilfsbezeichnung": "Curry 75",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "204",
    "Bcolor": "154",
    "Y": 62,
    "L": 82.8177108764648,
    "a": 1.64083433151245,
    "b": 27.0113506317139,
    "C": 27.0611419677734,
    "h": 86.5237808227539,
    "CMY_C": 0.10677754878998,
    "CMY_M": 0.20134961605072,
    "CMY_Y": 0.39478474855423,
    "CMYK_C": 0,
    "CMYK_M": 0.10587739944458,
    "CMYK_Y": 0.3224361538887,
    "CMYK_K": 0.10677754878998
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0553",
    "Farbtonhilfsbezeichnung": "Curry 65",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "168",
    "Bcolor": "114",
    "Y": 40,
    "L": 69.8022613525391,
    "a": 1.18694806098938,
    "b": 30.3306980133057,
    "C": 30.3539142608643,
    "h": 87.7589569091797,
    "CMY_C": 0.24871283769608,
    "CMY_M": 0.34022724628448,
    "CMY_Y": 0.55125689506531,
    "CMYK_C": 0,
    "CMYK_M": 0.1218101605773,
    "CMYK_Y": 0.40270096063614,
    "CMYK_K": 0.24871283769608
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0554",
    "Farbtonhilfsbezeichnung": "Curry 70",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "189",
    "Bcolor": "129",
    "Y": 52,
    "L": 77.3935775756836,
    "a": 1.28768527507782,
    "b": 33.0708465576172,
    "C": 33.0959053039551,
    "h": 87.7701950073242,
    "CMY_C": 0.15850335359573,
    "CMY_M": 0.26032286882401,
    "CMY_Y": 0.49536573886871,
    "CMYK_C": 0,
    "CMYK_M": 0.12099812179804,
    "CMYK_Y": 0.40031340718269,
    "CMYK_K": 0.15850335359573
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0555",
    "Farbtonhilfsbezeichnung": "Curry 80",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "218",
    "Bcolor": "174",
    "Y": 72,
    "L": 87.7737579345703,
    "a": 1.50660002231598,
    "b": 23.358211517334,
    "C": 23.4067497253418,
    "h": 86.3095474243164,
    "CMY_C": 0.05961090326309,
    "CMY_M": 0.14591783285141,
    "CMY_Y": 0.31577175855637,
    "CMYK_C": 0,
    "CMYK_M": 0.09177789092064,
    "CMYK_Y": 0.27239879965782,
    "CMYK_K": 0.05961090326309
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0556",
    "Farbtonhilfsbezeichnung": "Curry 85",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "231",
    "Bcolor": "191",
    "Y": 82,
    "L": 92.3020553588867,
    "a": 1.08633947372437,
    "b": 20.9319839477539,
    "C": 20.9601554870606,
    "h": 87.0290985107422,
    "CMY_C": 0.01682794094086,
    "CMY_M": 0.09410887956619,
    "CMY_Y": 0.24944370985031,
    "CMYK_C": 0,
    "CMYK_M": 0.07860367745161,
    "CMYK_Y": 0.23659721016884,
    "CMYK_K": 0.01682794094086
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0557",
    "Farbtonhilfsbezeichnung": "Curry 95",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "151",
    "Bcolor": "60",
    "Y": 32,
    "L": 63.852466583252,
    "a": 2.26285743713379,
    "b": 50.6023330688477,
    "C": 50.652904510498,
    "h": 87.4395294189453,
    "CMY_C": 0.28030347824097,
    "CMY_M": 0.40741354227066,
    "CMY_Y": 0.76622128486633,
    "CMYK_C": 0,
    "CMYK_M": 0.17661619186401,
    "CMYK_Y": 0.67517042160034,
    "CMYK_K": 0.28030347824097
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0558",
    "Farbtonhilfsbezeichnung": "Curry 100",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "169",
    "Bcolor": "100",
    "Y": 41,
    "L": 70.4336776733398,
    "a": 1.56781721115112,
    "b": 38.8018493652344,
    "C": 38.8335113525391,
    "h": 87.6861801147461,
    "CMY_C": 0.22539377212524,
    "CMY_M": 0.33585828542709,
    "CMY_Y": 0.60763800144196,
    "CMYK_C": 0,
    "CMYK_M": 0.14260731637478,
    "CMYK_Y": 0.49346908926964,
    "CMYK_K": 0.22539377212524
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0559",
    "Farbtonhilfsbezeichnung": "Curry 105",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "197",
    "Bcolor": "123",
    "Y": 58,
    "L": 81.0677185058594,
    "a": 2.86120390892029,
    "b": 41.2107734680176,
    "C": 41.3099784851074,
    "h": 86.0284118652344,
    "CMY_C": 0.09242099523544,
    "CMY_M": 0.22587192058563,
    "CMY_Y": 0.5192523598671,
    "CMYK_C": 0,
    "CMYK_M": 0.14704056084156,
    "CMYK_Y": 0.47029665112495,
    "CMYK_K": 0.09242099523544
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0560",
    "Farbtonhilfsbezeichnung": "Curry 110",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "211",
    "Bcolor": "145",
    "Y": 67,
    "L": 85.6638031005859,
    "a": 2.1938693523407,
    "b": 35.6763725280762,
    "C": 35.7437629699707,
    "h": 86.4811019897461,
    "CMY_C": 0.05342847108841,
    "CMY_M": 0.17325574159622,
    "CMY_Y": 0.43011850118637,
    "CMYK_C": 0,
    "CMYK_M": 0.12659081816673,
    "CMYK_Y": 0.39795199036598,
    "CMYK_K": 0.05342847108841
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0561",
    "Farbtonhilfsbezeichnung": "Curry 115",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "218",
    "Bcolor": "145",
    "Y": 73,
    "L": 88.0716400146484,
    "a": 0.76200085878372,
    "b": 39.2520027160645,
    "C": 39.2593994140625,
    "h": 88.8878555297852,
    "CMY_C": 0.028784096241,
    "CMY_M": 0.14398288726807,
    "CMY_Y": 0.43282926082611,
    "CMYK_C": 0,
    "CMYK_M": 0.11861295998096,
    "CMYK_Y": 0.41601991653442,
    "CMYK_K": 0.028784096241
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0562",
    "Farbtonhilfsbezeichnung": "Curry 120",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "228",
    "Bcolor": "173",
    "Y": 82,
    "L": 91.2197341918945,
    "a": 0.64548701047897,
    "b": 29.2116298675537,
    "C": 29.2187614440918,
    "h": 88.7341461181641,
    "CMY_C": 0.01315188407898,
    "CMY_M": 0.10690969228745,
    "CMY_Y": 0.32338362932205,
    "CMYK_C": 0,
    "CMYK_M": 0.09500733017921,
    "CMYK_Y": 0.31436625123024,
    "CMYK_K": 0.01315188407898
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0563",
    "Farbtonhilfsbezeichnung": "Curry 125",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "175",
    "Bcolor": "50",
    "Y": 47,
    "L": 73.2023239135742,
    "a": 2.85682153701782,
    "b": 64.7343826293945,
    "C": 64.7973861694336,
    "h": 87.4730911254883,
    "CMY_C": 0.15537202358246,
    "CMY_M": 0.31291943788528,
    "CMY_Y": 0.80375343561172,
    "CMYK_C": 0,
    "CMYK_M": 0.18652877211571,
    "CMYK_Y": 0.76765322685242,
    "CMYK_K": 0.15537202358246
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0564",
    "Farbtonhilfsbezeichnung": "Curry 130",
    "Farbtonklasse": "04",
    "Rcolor": "233",
    "Gcolor": "190",
    "Bcolor": "51",
    "Y": 53,
    "L": 78.6849899291992,
    "a": 2.97279167175293,
    "b": 69.925178527832,
    "C": 69.9883422851563,
    "h": 87.5655975341797,
    "CMY_C": 0.08503782749176,
    "CMY_M": 0.25544649362564,
    "CMY_Y": 0.79826974868774,
    "CMYK_C": 0,
    "CMYK_M": 0.18624667823315,
    "CMYK_Y": 0.77952069044113,
    "CMYK_K": 0.08503782749176
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0565",
    "Farbtonhilfsbezeichnung": "Curry 135",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "204",
    "Bcolor": "105",
    "Y": 61,
    "L": 83.3138580322266,
    "a": 1.46358561515808,
    "b": 52.6232070922852,
    "C": 52.6435546875,
    "h": 88.406867980957,
    "CMY_C": 0.05865699052811,
    "CMY_M": 0.19987398386002,
    "CMY_Y": 0.58719658851624,
    "CMYK_C": 0,
    "CMYK_M": 0.15001651644707,
    "CMYK_Y": 0.56147396564484,
    "CMYK_K": 0.05865699052811
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0567",
    "Farbtonhilfsbezeichnung": "Melisse 5",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 58,
    "L": 80.3184051513672,
    "a": -0.28595265746117,
    "b": 5.14219045639038,
    "C": 5.1501350402832,
    "h": 93.1828918457031,
    "CMY_C": 0.2043085694313,
    "CMY_M": 0.21892863512039,
    "CMY_Y": 0.26187205314636,
    "CMYK_C": 0,
    "CMYK_M": 0.0183740388602,
    "CMYK_Y": 0.07234397530556,
    "CMYK_K": 0.2043085694313
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0578",
    "Farbtonhilfsbezeichnung": "Melisse 65",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "118",
    "Bcolor": "82",
    "Y": 18,
    "L": 50.0577430725098,
    "a": -0.88004088401794,
    "b": 21.1515827178955,
    "C": 21.1698818206787,
    "h": 92.3824920654297,
    "CMY_C": 0.48841100931168,
    "CMY_M": 0.53534686565399,
    "CMY_Y": 0.67712950706482,
    "CMYK_C": 0,
    "CMYK_M": 0.09174524247646,
    "CMYK_Y": 0.36888694763184,
    "CMYK_K": 0.48841100931168
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0579",
    "Farbtonhilfsbezeichnung": "Melisse 70",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "145",
    "Bcolor": "116",
    "Y": 29,
    "L": 60.4976043701172,
    "a": -0.82653403282166,
    "b": 16.6139850616455,
    "C": 16.6345329284668,
    "h": 92.8480758666992,
    "CMY_C": 0.38925141096115,
    "CMY_M": 0.42966198921204,
    "CMY_Y": 0.54622900485992,
    "CMYK_C": 0,
    "CMYK_M": 0.06616564840078,
    "CMYK_Y": 0.25702488422394,
    "CMYK_K": 0.38925141096115
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0580",
    "Farbtonhilfsbezeichnung": "Melisse 80",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "205",
    "Bcolor": "153",
    "Y": 62,
    "L": 82.5060958862305,
    "a": -1.80728244781494,
    "b": 27.1488952636719,
    "C": 27.208984375,
    "h": 93.8085250854492,
    "CMY_C": 0.1339322924614,
    "CMY_M": 0.19667840003967,
    "CMY_Y": 0.39970767498016,
    "CMYK_C": 0,
    "CMYK_M": 0.07244942337275,
    "CMYK_Y": 0.3068759739399,
    "CMYK_K": 0.1339322924614
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0581",
    "Farbtonhilfsbezeichnung": "Melisse 85",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "231",
    "Bcolor": "178",
    "Y": 81,
    "L": 91.7906188964844,
    "a": -1.56008231639862,
    "b": 27.3571147918701,
    "C": 27.4015617370606,
    "h": 93.2638473510742,
    "CMY_C": 0.02647441625595,
    "CMY_M": 0.09489119052887,
    "CMY_Y": 0.30374157428741,
    "CMYK_C": 0,
    "CMYK_M": 0.070277325809,
    "CMYK_Y": 0.28480726480484,
    "CMYK_K": 0.02647441625595
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0582",
    "Farbtonhilfsbezeichnung": "Melisse 90",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "237",
    "Bcolor": "209",
    "Y": 86,
    "L": 93.9092254638672,
    "a": -0.85562819242477,
    "b": 13.912543296814,
    "C": 13.9388294219971,
    "h": 93.519287109375,
    "CMY_C": 0.03155136108398,
    "CMY_M": 0.06978178024292,
    "CMY_Y": 0.17979514598846,
    "CMYK_C": 0,
    "CMYK_M": 0.0394759401679,
    "CMYK_Y": 0.15307345986366,
    "CMYK_K": 0.03155136108398
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0583",
    "Farbtonhilfsbezeichnung": "Melisse 95",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "175",
    "Bcolor": "57",
    "Y": 43,
    "L": 72.0339202880859,
    "a": -1.98967802524567,
    "b": 60.8126487731934,
    "C": 60.8451881408691,
    "h": 91.8739471435547,
    "CMY_C": 0.20244741439819,
    "CMY_M": 0.31360954046249,
    "CMY_Y": 0.77826172113419,
    "CMYK_C": 0,
    "CMYK_M": 0.13937905430794,
    "CMYK_Y": 0.72197657823563,
    "CMYK_K": 0.20244741439819
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0584",
    "Farbtonhilfsbezeichnung": "Melisse 100",
    "Farbtonklasse": "04",
    "Rcolor": "211",
    "Gcolor": "185",
    "Bcolor": "59",
    "Y": 50,
    "L": 75.2419281005859,
    "a": -3.60997867584229,
    "b": 63.3512878417969,
    "C": 63.4540596008301,
    "h": 93.2613906860352,
    "CMY_C": 0.17286944389343,
    "CMY_M": 0.27620965242386,
    "CMY_Y": 0.76971197128296,
    "CMYK_C": 0,
    "CMYK_M": 0.12493820488453,
    "CMYK_Y": 0.72158199548721,
    "CMYK_K": 0.17286944389343
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0585",
    "Farbtonhilfsbezeichnung": "Melisse 105",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "207",
    "Bcolor": "77",
    "Y": 62,
    "L": 83.4073333740234,
    "a": -3.63788247108459,
    "b": 65.0218963623047,
    "C": 65.1235809326172,
    "h": 93.2022857666016,
    "CMY_C": 0.07545453310013,
    "CMY_M": 0.18839532136917,
    "CMY_Y": 0.69717955589294,
    "CMYK_C": 0,
    "CMYK_M": 0.12215817719698,
    "CMYK_Y": 0.67246562242508,
    "CMYK_K": 0.07545453310013
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0586",
    "Farbtonhilfsbezeichnung": "Melisse 115",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "227",
    "Bcolor": "116",
    "Y": 77,
    "L": 90.296501159668,
    "a": -5.16225814819336,
    "b": 56.1052665710449,
    "C": 56.3422546386719,
    "h": 95.2569961547852,
    "CMY_C": 0.01565062999725,
    "CMY_M": 0.10805118083954,
    "CMY_Y": 0.54607045650482,
    "CMYK_C": 0,
    "CMYK_M": 0.09386967122555,
    "CMYK_Y": 0.53885322809219,
    "CMYK_K": 0.01565062999725
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0587",
    "Farbtonhilfsbezeichnung": "Melisse 120",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "235",
    "Bcolor": "193",
    "Y": 86,
    "L": 93.2098541259766,
    "a": -1.93436300754547,
    "b": 21.3318710327148,
    "C": 21.4193954467773,
    "h": 95.1813812255859,
    "CMY_C": 0.0275896191597,
    "CMY_M": 0.07682430744171,
    "CMY_Y": 0.24321961402893,
    "CMYK_C": 0,
    "CMYK_M": 0.05063159391284,
    "CMYK_Y": 0.22174793481827,
    "CMYK_K": 0.0275896191597
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0588",
    "Farbtonhilfsbezeichnung": "Soja 5",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "183",
    "Bcolor": "162",
    "Y": 48,
    "L": 74.5428466796875,
    "a": -1.10239994525909,
    "b": 10.9764289855957,
    "C": 11.0316486358643,
    "h": 95.7351760864258,
    "CMY_C": 0.25595885515213,
    "CMY_M": 0.28075504302979,
    "CMY_Y": 0.36471766233444,
    "CMYK_C": 0,
    "CMYK_M": 0.03332636505365,
    "CMYK_Y": 0.14617310464382,
    "CMYK_K": 0.25595885515213
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0589",
    "Farbtonhilfsbezeichnung": "Soja 10",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "200",
    "Bcolor": "184",
    "Y": 57,
    "L": 80.5868148803711,
    "a": -0.40912494063377,
    "b": 7.68186378479004,
    "C": 7.69275093078613,
    "h": 93.0486068725586,
    "CMY_C": 0.19462466239929,
    "CMY_M": 0.21638756990433,
    "CMY_Y": 0.27737772464752,
    "CMYK_C": 0,
    "CMYK_M": 0.02702206932008,
    "CMYK_Y": 0.10275092720985,
    "CMYK_K": 0.19462466239929
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0590",
    "Farbtonhilfsbezeichnung": "Soja 15",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "227",
    "Bcolor": "205",
    "Y": 76,
    "L": 90.2426071166992,
    "a": -0.67180168628693,
    "b": 10.9681634902954,
    "C": 10.9887180328369,
    "h": 93.504997253418,
    "CMY_C": 0.07999038696289,
    "CMY_M": 0.1104388833046,
    "CMY_Y": 0.19771260023117,
    "CMYK_C": 0,
    "CMYK_M": 0.03309584408998,
    "CMYK_Y": 0.12795759737492,
    "CMYK_K": 0.07999038696289
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0591",
    "Farbtonhilfsbezeichnung": "Soja 20",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "238",
    "Bcolor": "209",
    "Y": 88,
    "L": 94.2236862182617,
    "a": -1.35730147361755,
    "b": 14.5268020629883,
    "C": 14.5900735855103,
    "h": 95.337890625,
    "CMY_C": 0.03004199266434,
    "CMY_M": 0.065210044384,
    "CMY_Y": 0.18105041980743,
    "CMYK_C": 0,
    "CMYK_M": 0.03625729307532,
    "CMYK_Y": 0.15568552911282,
    "CMYK_K": 0.03004199266434
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0592",
    "Farbtonhilfsbezeichnung": "Soja 25",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 88,
    "L": 94.4262084960938,
    "a": -1.24665892124176,
    "b": 10.8242492675781,
    "C": 10.8958034515381,
    "h": 96.5699691772461,
    "CMY_C": 0.03767782449722,
    "CMY_M": 0.06226372718811,
    "CMY_Y": 0.15108501911163,
    "CMYK_C": 0,
    "CMYK_M": 0.02554851584136,
    "CMYK_Y": 0.11784742772579,
    "CMYK_K": 0.03767782449722
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0593",
    "Farbtonhilfsbezeichnung": "Tundra 5",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "95",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.4117584228516,
    "a": -0.42674857378006,
    "b": 1.59048318862915,
    "C": 1.64673948287964,
    "h": 105.019485473633,
    "CMY_C": 0.62479537725449,
    "CMY_M": 0.62577533721924,
    "CMY_Y": 0.63969153165817,
    "CMYK_C": 0,
    "CMYK_M": 0.00261180149391,
    "CMYK_Y": 0.03970141336322,
    "CMYK_K": 0.62479537725449
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0594",
    "Farbtonhilfsbezeichnung": "Tundra 10",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "118",
    "Bcolor": "107",
    "Y": 17,
    "L": 49.6935348510742,
    "a": -0.31106451153755,
    "b": 6.1071925163269,
    "C": 6.11510944366455,
    "h": 92.9157867431641,
    "CMY_C": 0.52144730091095,
    "CMY_M": 0.53714865446091,
    "CMY_Y": 0.58048671483994,
    "CMYK_C": 0,
    "CMYK_M": 0.03281008079648,
    "CMYK_Y": 0.12337076663971,
    "CMYK_K": 0.52144730091095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0595",
    "Farbtonhilfsbezeichnung": "Tundra 15",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "140",
    "Bcolor": "129",
    "Y": 26,
    "L": 58.2074508666992,
    "a": -0.62089508771896,
    "b": 5.89072561264038,
    "C": 5.9233570098877,
    "h": 96.0168838500977,
    "CMY_C": 0.43830424547195,
    "CMY_M": 0.45111781358719,
    "CMY_Y": 0.49561965465546,
    "CMYK_C": 0,
    "CMYK_M": 0.02281229384243,
    "CMYK_Y": 0.10203995555639,
    "CMYK_K": 0.43830424547195
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0596",
    "Farbtonhilfsbezeichnung": "Tundra 20",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "186",
    "Bcolor": "173",
    "Y": 49,
    "L": 75.3330917358398,
    "a": -0.55447161197662,
    "b": 6.19687271118164,
    "C": 6.22162914276123,
    "h": 95.1129837036133,
    "CMY_C": 0.25710695981979,
    "CMY_M": 0.27236133813858,
    "CMY_Y": 0.32230180501938,
    "CMYK_C": 0,
    "CMYK_M": 0.02053374797106,
    "CMYK_Y": 0.08775804936886,
    "CMYK_K": 0.25710695981979
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0597",
    "Farbtonhilfsbezeichnung": "Tundra 25",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "222",
    "Bcolor": "208",
    "Y": 72,
    "L": 88.6258850097656,
    "a": -0.61674892902374,
    "b": 7.02371454238892,
    "C": 7.05074071884155,
    "h": 95.0182418823242,
    "CMY_C": 0.10948896408081,
    "CMY_M": 0.12750005722046,
    "CMY_Y": 0.18610602617264,
    "CMYK_C": 0,
    "CMYK_M": 0.02022556960583,
    "CMYK_Y": 0.08603718131781,
    "CMYK_K": 0.10948896408081
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0598",
    "Farbtonhilfsbezeichnung": "Tundra 30",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "220",
    "Y": 81,
    "L": 92.4450302124023,
    "a": -0.4445553123951,
    "b": 5.80820655822754,
    "C": 5.82519483566284,
    "h": 94.376838684082,
    "CMY_C": 0.06927937269211,
    "CMY_M": 0.08505517244339,
    "CMY_Y": 0.13530308008194,
    "CMYK_C": 0,
    "CMYK_M": 0.0169500913471,
    "CMYK_Y": 0.07093826681376,
    "CMYK_K": 0.06927937269211
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0599",
    "Farbtonhilfsbezeichnung": "Tundra 35",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "163",
    "Bcolor": "138",
    "Y": 36,
    "L": 67.1641082763672,
    "a": -0.75780034065247,
    "b": 13.4473114013672,
    "C": 13.4686470031738,
    "h": 93.2253952026367,
    "CMY_C": 0.32600402832031,
    "CMY_M": 0.36013793945313,
    "CMY_Y": 0.45779353380203,
    "CMYK_C": 0,
    "CMYK_M": 0.0506440885365,
    "CMYK_Y": 0.19553455710411,
    "CMYK_K": 0.32600402832031
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0600",
    "Farbtonhilfsbezeichnung": "Tundra 40",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "186",
    "Bcolor": "157",
    "Y": 49,
    "L": 75.4580841064453,
    "a": -1.95478332042694,
    "b": 15.2145118713379,
    "C": 15.3395748138428,
    "h": 97.3213348388672,
    "CMY_C": 0.24094206094742,
    "CMY_M": 0.27001476287842,
    "CMY_Y": 0.38567650318146,
    "CMYK_C": 0,
    "CMYK_M": 0.03830103203654,
    "CMYK_Y": 0.19067640602589,
    "CMYK_K": 0.24094206094742
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0601",
    "Farbtonhilfsbezeichnung": "Tundra 45",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "200",
    "Bcolor": "177",
    "Y": 58,
    "L": 80.6486740112305,
    "a": -1.44932687282562,
    "b": 11.5711584091187,
    "C": 11.6615715026856,
    "h": 97.1393127441406,
    "CMY_C": 0.19046175479889,
    "CMY_M": 0.2142875790596,
    "CMY_Y": 0.30503582954407,
    "CMYK_C": 0,
    "CMYK_M": 0.02943137660623,
    "CMYK_Y": 0.14153015613556,
    "CMYK_K": 0.19046175479889
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0602",
    "Farbtonhilfsbezeichnung": "Tundra 50",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "214",
    "Bcolor": "197",
    "Y": 67,
    "L": 85.4365844726563,
    "a": -1.23133873939514,
    "b": 7.99860811233521,
    "C": 8.0928316116333,
    "h": 98.7516479492188,
    "CMY_C": 0.14656901359558,
    "CMY_M": 0.16153854131699,
    "CMY_Y": 0.22788298130035,
    "CMYK_C": 0,
    "CMYK_M": 0.01754040829837,
    "CMYK_Y": 0.09527890384197,
    "CMYK_K": 0.14656901359558
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0603",
    "Farbtonhilfsbezeichnung": "Tundra 55",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "234",
    "Bcolor": "213",
    "Y": 83,
    "L": 92.5105056762695,
    "a": -1.40563631057739,
    "b": 9.72174835205078,
    "C": 9.82284069061279,
    "h": 98.2271957397461,
    "CMY_C": 0.06382358074188,
    "CMY_M": 0.08308148384094,
    "CMY_Y": 0.16385638713837,
    "CMYK_C": 0,
    "CMYK_M": 0.0205708052963,
    "CMYK_Y": 0.10685251653194,
    "CMYK_K": 0.06382358074188
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0604",
    "Farbtonhilfsbezeichnung": "Tundra 60",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "240",
    "Bcolor": "228",
    "Y": 90,
    "L": 94.6547012329102,
    "a": -1.18723034858704,
    "b": 5.20785236358643,
    "C": 5.34146451950073,
    "h": 102.842216491699,
    "CMY_C": 0.052186191082,
    "CMY_M": 0.05834412574768,
    "CMY_Y": 0.10655552148819,
    "CMYK_C": 0,
    "CMYK_M": 0.00649698777124,
    "CMYK_Y": 0.05736288055778,
    "CMYK_K": 0.052186191082
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0605",
    "Farbtonhilfsbezeichnung": "Tundra 65",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "95",
    "Bcolor": "77",
    "Y": 11,
    "L": 40.7434463500977,
    "a": 0.09729658812284,
    "b": 11.0768575668335,
    "C": 11.0772848129273,
    "h": 89.4967422485352,
    "CMY_C": 0.5949142575264,
    "CMY_M": 0.62572884559631,
    "CMY_Y": 0.69668877124786,
    "CMYK_C": 0,
    "CMYK_M": 0.07606929540634,
    "CMYK_Y": 0.25124189257622,
    "CMYK_K": 0.5949142575264
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0606",
    "Farbtonhilfsbezeichnung": "Tundra 70",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "120",
    "Bcolor": "95",
    "Y": 18,
    "L": 50.0003242492676,
    "a": -2.84182190895081,
    "b": 13.6946363449097,
    "C": 13.9863872528076,
    "h": 101.723266601563,
    "CMY_C": 0.5166984796524,
    "CMY_M": 0.53048086166382,
    "CMY_Y": 0.62803399562836,
    "CMYK_C": 0,
    "CMYK_M": 0.02851714938879,
    "CMYK_Y": 0.23036450147629,
    "CMYK_K": 0.5166984796524
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0607",
    "Farbtonhilfsbezeichnung": "Tundra 75",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "132",
    "Bcolor": "98",
    "Y": 22,
    "L": 54.6623344421387,
    "a": -3.43158507347107,
    "b": 18.7033443450928,
    "C": 19.0155429840088,
    "h": 100.396675109863,
    "CMY_C": 0.46243911981583,
    "CMY_M": 0.48373264074326,
    "CMY_Y": 0.617506980896,
    "CMYK_C": 0,
    "CMYK_M": 0.03961136564612,
    "CMYK_Y": 0.28846567869186,
    "CMYK_K": 0.46243911981583
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0608",
    "Farbtonhilfsbezeichnung": "Tundra 85",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "173",
    "Bcolor": "140",
    "Y": 42,
    "L": 70.6710510253906,
    "a": -1.82914805412292,
    "b": 17.6152820587158,
    "C": 17.7099952697754,
    "h": 95.9282684326172,
    "CMY_C": 0.28581672906876,
    "CMY_M": 0.32177978754044,
    "CMY_Y": 0.45185059309006,
    "CMYK_C": 0,
    "CMYK_M": 0.05035550519824,
    "CMYK_Y": 0.23248074948788,
    "CMYK_K": 0.28581672906876
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0609",
    "Farbtonhilfsbezeichnung": "Tundra 90",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "215",
    "Bcolor": "182",
    "Y": 67,
    "L": 85.8794860839844,
    "a": -2.01075458526611,
    "b": 16.3571491241455,
    "C": 16.4802742004395,
    "h": 97.0081024169922,
    "CMY_C": 0.12372553348541,
    "CMY_M": 0.15690618753433,
    "CMY_Y": 0.28463751077652,
    "CMYK_C": 0,
    "CMYK_M": 0.03786559402943,
    "CMYK_Y": 0.18363194167614,
    "CMYK_K": 0.12372553348541
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0610",
    "Farbtonhilfsbezeichnung": "Tundra 95",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "122",
    "Bcolor": "80",
    "Y": 18,
    "L": 50.7120056152344,
    "a": -3.75568294525146,
    "b": 23.1026878356934,
    "C": 23.4059677124023,
    "h": 99.2335052490234,
    "CMY_C": 0.49629759788513,
    "CMY_M": 0.52325165271759,
    "CMY_Y": 0.68486535549164,
    "CMYK_C": 0,
    "CMYK_M": 0.05351186543703,
    "CMYK_Y": 0.3743634223938,
    "CMYK_K": 0.49629759788513
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0611",
    "Farbtonhilfsbezeichnung": "Tundra 100",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "129",
    "Bcolor": "81",
    "Y": 21,
    "L": 53.7438583374023,
    "a": -3.29284691810608,
    "b": 26.6427268981934,
    "C": 26.8454418182373,
    "h": 97.0456085205078,
    "CMY_C": 0.45593273639679,
    "CMY_M": 0.49458247423172,
    "CMY_Y": 0.68091547489166,
    "CMYK_C": 0,
    "CMYK_M": 0.07103852927685,
    "CMYK_Y": 0.41352006793022,
    "CMYK_K": 0.45593273639679
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0612",
    "Farbtonhilfsbezeichnung": "Tundra 105",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "144",
    "Bcolor": "89",
    "Y": 27,
    "L": 59.4821624755859,
    "a": -4.32455015182495,
    "b": 30.2592105865479,
    "C": 30.5666732788086,
    "h": 98.1334533691406,
    "CMY_C": 0.39616078138351,
    "CMY_M": 0.43498224020004,
    "CMY_Y": 0.65241861343384,
    "CMYK_C": 0,
    "CMYK_M": 0.06429105252028,
    "CMYK_Y": 0.42438089847565,
    "CMYK_K": 0.39616078138351
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0613",
    "Farbtonhilfsbezeichnung": "Tundra 110",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "158",
    "Bcolor": "101",
    "Y": 34,
    "L": 64.8908233642578,
    "a": -3.99739265441895,
    "b": 31.0079364776611,
    "C": 31.2645378112793,
    "h": 97.3457794189453,
    "CMY_C": 0.33492875099182,
    "CMY_M": 0.38010036945343,
    "CMY_Y": 0.60555779933929,
    "CMYK_C": 0,
    "CMYK_M": 0.06791996955872,
    "CMYK_Y": 0.40691736340523,
    "CMYK_K": 0.33492875099182
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0614",
    "Farbtonhilfsbezeichnung": "Tundra 115",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "187",
    "Bcolor": "142",
    "Y": 50,
    "L": 75.7055740356445,
    "a": -2.56383633613586,
    "b": 23.5593528747559,
    "C": 23.6984462738037,
    "h": 96.2107467651367,
    "CMY_C": 0.22255712747574,
    "CMY_M": 0.26776403188705,
    "CMY_Y": 0.44345015287399,
    "CMYK_C": 0,
    "CMYK_M": 0.05814820155501,
    "CMYK_Y": 0.28412765264511,
    "CMYK_K": 0.22255712747574
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0615",
    "Farbtonhilfsbezeichnung": "Tundra 125",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "154",
    "Bcolor": "72",
    "Y": 32,
    "L": 63.1690559387207,
    "a": -6.02640867233276,
    "b": 43.517692565918,
    "C": 43.9329833984375,
    "h": 97.88427734375,
    "CMY_C": 0.34737730026245,
    "CMY_M": 0.39538240432739,
    "CMY_Y": 0.71715617179871,
    "CMYK_C": 0,
    "CMYK_M": 0.07355720549822,
    "CMYK_Y": 0.56660437583923,
    "CMYK_K": 0.34737730026245
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0616",
    "Farbtonhilfsbezeichnung": "Tundra 130",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "188",
    "Bcolor": "73",
    "Y": 48,
    "L": 75.3516616821289,
    "a": -8.60993099212646,
    "b": 57.5298042297363,
    "C": 58.1705207824707,
    "h": 98.5117263793945,
    "CMY_C": 0.21019458770752,
    "CMY_M": 0.26343297958374,
    "CMY_Y": 0.71471190452576,
    "CMYK_C": 0,
    "CMYK_M": 0.06740697473288,
    "CMYK_Y": 0.63878685235977,
    "CMYK_K": 0.21019458770752
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0617",
    "Farbtonhilfsbezeichnung": "Tundra 135",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "201",
    "Bcolor": "73",
    "Y": 57,
    "L": 80.0104141235352,
    "a": -9.30358219146729,
    "b": 62.5448722839355,
    "C": 63.2330436706543,
    "h": 98.4607391357422,
    "CMY_C": 0.15520703792572,
    "CMY_M": 0.21232801675797,
    "CMY_Y": 0.71254670619965,
    "CMYK_C": 0,
    "CMYK_M": 0.06761536002159,
    "CMYK_Y": 0.65973520278931,
    "CMYK_K": 0.15520703792572
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0618",
    "Farbtonhilfsbezeichnung": "Tundra 140",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "219",
    "Bcolor": "80",
    "Y": 69,
    "L": 86.4685211181641,
    "a": -10.2289438247681,
    "b": 67.1074905395508,
    "C": 67.8825912475586,
    "h": 98.6666717529297,
    "CMY_C": 0.0805236697197,
    "CMY_M": 0.14026737213135,
    "CMY_Y": 0.68712520599365,
    "CMYK_C": 0,
    "CMYK_M": 0.06497579067945,
    "CMYK_Y": 0.65972501039505,
    "CMYK_K": 0.0805236697197
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0619",
    "Farbtonhilfsbezeichnung": "Mai 5",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "112",
    "Bcolor": "107",
    "Y": 15,
    "L": 47.1946754455566,
    "a": -0.06483706086874,
    "b": 2.65999269485474,
    "C": 2.66078281402588,
    "h": 91.3963012695312,
    "CMY_C": 0.55383813381195,
    "CMY_M": 0.56139123439789,
    "CMY_Y": 0.58201134204865,
    "CMYK_C": 0,
    "CMYK_M": 0.01692905835807,
    "CMYK_Y": 0.06314571201801,
    "CMYK_K": 0.55383813381195
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0620",
    "Farbtonhilfsbezeichnung": "Mai 10",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "130",
    "Bcolor": "125",
    "Y": 22,
    "L": 54.5012550354004,
    "a": 0.05499332025647,
    "b": 2.66277670860291,
    "C": 2.66334462165833,
    "h": 88.8168640136719,
    "CMY_C": 0.48038464784622,
    "CMY_M": 0.48924696445465,
    "CMY_Y": 0.51064133644104,
    "CMYK_C": 0,
    "CMYK_M": 0.01705553196371,
    "CMYK_Y": 0.05822901055217,
    "CMYK_K": 0.48038464784622
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0621",
    "Farbtonhilfsbezeichnung": "Mai 15",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "168",
    "Bcolor": "158",
    "Y": 38,
    "L": 68.6068344116211,
    "a": -0.67539459466934,
    "b": 4.48480987548828,
    "C": 4.53538084030151,
    "h": 98.5641632080078,
    "CMY_C": 0.33477628231049,
    "CMY_M": 0.34305477142334,
    "CMY_Y": 0.38036262989044,
    "CMYK_C": 0,
    "CMYK_M": 0.01244466938078,
    "CMYK_Y": 0.06852784752846,
    "CMYK_K": 0.33477628231049
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0622",
    "Farbtonhilfsbezeichnung": "Mai 20",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "184",
    "Y": 55,
    "L": 78.7751312255859,
    "a": -0.81460338830948,
    "b": 4.95342302322388,
    "C": 5.01995801925659,
    "h": 99.3388519287109,
    "CMY_C": 0.22565519809723,
    "CMY_M": 0.2343881726265,
    "CMY_Y": 0.27703601121902,
    "CMYK_C": 0,
    "CMYK_M": 0.01127788890153,
    "CMYK_Y": 0.06635391712189,
    "CMYK_K": 0.22565519809723
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0623",
    "Farbtonhilfsbezeichnung": "Mai 25",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "217",
    "Bcolor": "207",
    "Y": 69,
    "L": 86.8111724853516,
    "a": -0.46303400397301,
    "b": 4.84693241119385,
    "C": 4.86899948120117,
    "h": 95.4569854736328,
    "CMY_C": 0.13527280092239,
    "CMY_M": 0.14735352993011,
    "CMY_Y": 0.18980115652084,
    "CMYK_C": 0,
    "CMYK_M": 0.01397056691349,
    "CMYK_Y": 0.06305845081806,
    "CMYK_K": 0.13527280092239
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0624",
    "Farbtonhilfsbezeichnung": "Mai 30",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.7473526000977,
    "a": -0.61925905942917,
    "b": 5.49990606307983,
    "C": 5.53465890884399,
    "h": 96.4241333007812,
    "CMY_C": 0.05699443817139,
    "CMY_M": 0.0699667930603,
    "CMY_Y": 0.11868190765381,
    "CMYK_C": 0,
    "CMYK_M": 0.01375639252365,
    "CMYK_Y": 0.06541580706835,
    "CMYK_K": 0.05699443817139
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0625",
    "Farbtonhilfsbezeichnung": "Mai 35",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "130",
    "Bcolor": "108",
    "Y": 22,
    "L": 54.2933654785156,
    "a": -1.84997320175171,
    "b": 11.9015827178955,
    "C": 12.0445041656494,
    "h": 98.8353118896484,
    "CMY_C": 0.47100555896759,
    "CMY_M": 0.48940402269363,
    "CMY_Y": 0.57477790117264,
    "CMYK_C": 0,
    "CMYK_M": 0.03478007018566,
    "CMYK_Y": 0.19616906344891,
    "CMYK_K": 0.47100555896759
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0626",
    "Farbtonhilfsbezeichnung": "Mai 40",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "151",
    "Bcolor": "129",
    "Y": 30,
    "L": 62.3014831542969,
    "a": -2.12915754318237,
    "b": 11.3605031967163,
    "C": 11.5583019256592,
    "h": 100.615089416504,
    "CMY_C": 0.39196395874023,
    "CMY_M": 0.40718162059784,
    "CMY_Y": 0.49236875772476,
    "CMYK_C": 0,
    "CMYK_M": 0.02502756565809,
    "CMYK_Y": 0.16512967646122,
    "CMYK_K": 0.39196395874023
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0627",
    "Farbtonhilfsbezeichnung": "Mai 50",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "200",
    "Bcolor": "178",
    "Y": 58,
    "L": 80.5475845336914,
    "a": -1.90061581134796,
    "b": 11.2269449234009,
    "C": 11.3866863250732,
    "h": 99.6085357666016,
    "CMY_C": 0.19587743282318,
    "CMY_M": 0.21426910161972,
    "CMY_Y": 0.30367928743362,
    "CMYK_C": 0,
    "CMYK_M": 0.02287172339857,
    "CMYK_Y": 0.13406147062778,
    "CMYK_K": 0.19587743282318
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0628",
    "Farbtonhilfsbezeichnung": "Mai 55",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "223",
    "Bcolor": "199",
    "Y": 74,
    "L": 88.7743377685547,
    "a": -1.20445263385773,
    "b": 11.6950798034668,
    "C": 11.7569379806519,
    "h": 95.8800430297852,
    "CMY_C": 0.09834510087967,
    "CMY_M": 0.12567394971848,
    "CMY_Y": 0.21907341480255,
    "CMYK_C": 0,
    "CMYK_M": 0.03030965477228,
    "CMYK_Y": 0.13389636576176,
    "CMYK_K": 0.09834510087967
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0629",
    "Farbtonhilfsbezeichnung": "Mai 60",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 87,
    "L": 94.2239074707031,
    "a": -1.58795142173767,
    "b": 10.9121837615967,
    "C": 11.0271186828613,
    "h": 98.2796173095703,
    "CMY_C": 0.04232656955719,
    "CMY_M": 0.06374847888947,
    "CMY_Y": 0.15401428937912,
    "CMYK_C": 0,
    "CMYK_M": 0.02236869931221,
    "CMYK_Y": 0.11662401258945,
    "CMYK_K": 0.04232656955719
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0630",
    "Farbtonhilfsbezeichnung": "Mai 65",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "173",
    "Bcolor": "122",
    "Y": 41,
    "L": 69.785270690918,
    "a": -6.70539999008179,
    "b": 26.1824016571045,
    "C": 27.0274028778076,
    "h": 104.364891052246,
    "CMY_C": 0.30996370315552,
    "CMY_M": 0.32220357656479,
    "CMY_Y": 0.52295607328415,
    "CMYK_C": 0,
    "CMYK_M": 0.01773801445961,
    "CMYK_Y": 0.30866834521294,
    "CMYK_K": 0.30996370315552
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0631",
    "Farbtonhilfsbezeichnung": "Mai 70",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "178",
    "Bcolor": "83",
    "Y": 42,
    "L": 70.9837341308594,
    "a": -11.7390985488892,
    "b": 47.4661064147949,
    "C": 48.8961944580078,
    "h": 103.891387939453,
    "CMY_C": 0.29344910383224,
    "CMY_M": 0.30222052335739,
    "CMY_Y": 0.67372596263885,
    "CMYK_C": 0,
    "CMYK_M": 0.01241442002356,
    "CMYK_Y": 0.53821581602097,
    "CMYK_K": 0.29344910383224
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0632",
    "Farbtonhilfsbezeichnung": "Mai 75",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "193",
    "Bcolor": "72",
    "Y": 51,
    "L": 76.1470947265625,
    "a": -14.5687637329102,
    "b": 58.6669158935547,
    "C": 60.448787689209,
    "h": 103.946159362793,
    "CMY_C": 0.23955398797989,
    "CMY_M": 0.24252653121948,
    "CMY_Y": 0.71925354003906,
    "CMYK_C": 0,
    "CMYK_M": 0.00390894711018,
    "CMYK_Y": 0.63081341981888,
    "CMYK_K": 0.23955398797989
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0633",
    "Farbtonhilfsbezeichnung": "Mai 80",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "202",
    "Bcolor": "94",
    "Y": 56,
    "L": 79.7283935546875,
    "a": -11.9867649078369,
    "b": 52.901741027832,
    "C": 54.2427558898926,
    "h": 102.766815185547,
    "CMY_C": 0.18917113542557,
    "CMY_M": 0.20851248502731,
    "CMY_Y": 0.63049829006195,
    "CMYK_C": 0,
    "CMYK_M": 0.02385379932821,
    "CMYK_Y": 0.54429137706757,
    "CMYK_K": 0.18917113542557
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0634",
    "Farbtonhilfsbezeichnung": "Mai 85",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "218",
    "Bcolor": "141",
    "Y": 67,
    "L": 85.6152725219727,
    "a": -10.6683950424194,
    "b": 37.657585144043,
    "C": 39.1396026611328,
    "h": 105.817428588867,
    "CMY_C": 0.13991671800613,
    "CMY_M": 0.14464694261551,
    "CMY_Y": 0.44860762357712,
    "CMYK_C": 0,
    "CMYK_M": 0.00549972848967,
    "CMYK_Y": 0.3589081466198,
    "CMYK_K": 0.13991671800613
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0635",
    "Farbtonhilfsbezeichnung": "Mai 90",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "224",
    "Bcolor": "127",
    "Y": 74,
    "L": 88.0464553833008,
    "a": -8.93521690368652,
    "b": 47.52490234375,
    "C": 48.3575668334961,
    "h": 100.647956848145,
    "CMY_C": 0.08145022392273,
    "CMY_M": 0.12318098545074,
    "CMY_Y": 0.50031518936157,
    "CMYK_C": 0,
    "CMYK_M": 0.04543113708496,
    "CMYK_Y": 0.45600682497025,
    "CMYK_K": 0.08145022392273
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0636",
    "Farbtonhilfsbezeichnung": "Jade 5",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "174",
    "Bcolor": "168",
    "Y": 42,
    "L": 70.9929351806641,
    "a": -1.00257956981659,
    "b": 2.15475392341614,
    "C": 2.37657952308655,
    "h": 114.951957702637,
    "CMY_C": 0.31923133134842,
    "CMY_M": 0.31653994321823,
    "CMY_Y": 0.33925461769104,
    "CMYK_C": 0.0039378865622,
    "CMYK_M": 0,
    "CMYK_Y": 0.03323482349515,
    "CMYK_K": 0.31653994321823
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0637",
    "Farbtonhilfsbezeichnung": "Jade 10",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "188",
    "Bcolor": "181",
    "Y": 50,
    "L": 75.9758605957031,
    "a": -0.78588891029358,
    "b": 2.80297422409058,
    "C": 2.91106271743774,
    "h": 105.662261962891,
    "CMY_C": 0.26240986585617,
    "CMY_M": 0.26405513286591,
    "CMY_Y": 0.29135155677795,
    "CMYK_C": 0,
    "CMYK_M": 0.00223059789278,
    "CMYK_Y": 0.0392381735146,
    "CMYK_K": 0.26240986585617
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0638",
    "Farbtonhilfsbezeichnung": "Jade 20",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 67,
    "L": 85.380989074707,
    "a": -0.408695936203,
    "b": 2.09312725067139,
    "C": 2.13265419006348,
    "h": 101.048347473145,
    "CMY_C": 0.15956354141235,
    "CMY_M": 0.16248822212219,
    "CMY_Y": 0.18517887592316,
    "CMYK_C": 0,
    "CMYK_M": 0.00347995455377,
    "CMYK_Y": 0.03047860972583,
    "CMYK_K": 0.15956354141235
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0639",
    "Farbtonhilfsbezeichnung": "Jade 25",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "221",
    "Bcolor": "214",
    "Y": 73,
    "L": 88.0381469726563,
    "a": -0.12962177395821,
    "b": 2.49141311645508,
    "C": 2.49478268623352,
    "h": 92.9782638549805,
    "CMY_C": 0.12673020362854,
    "CMY_M": 0.13392978906631,
    "CMY_Y": 0.15907394886017,
    "CMYK_C": 0,
    "CMYK_M": 0.00824439991266,
    "CMYK_Y": 0.03703751787543,
    "CMYK_K": 0.12673020362854
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0640",
    "Farbtonhilfsbezeichnung": "Jade 30",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "233",
    "Bcolor": "227",
    "Y": 83,
    "L": 92.4565734863281,
    "a": -0.05710938200355,
    "b": 2.32164788246155,
    "C": 2.32235026359558,
    "h": 91.4091110229492,
    "CMY_C": 0.07749891281128,
    "CMY_M": 0.08488482236862,
    "CMY_Y": 0.10920375585556,
    "CMYK_C": 0,
    "CMYK_M": 0.00800639670342,
    "CMYK_Y": 0.03436835482717,
    "CMYK_K": 0.07749891281128
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0641",
    "Farbtonhilfsbezeichnung": "Jade 35",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "146",
    "Bcolor": "140",
    "Y": 27,
    "L": 60.3394813537598,
    "a": -1.00670993328094,
    "b": 2.31535530090332,
    "C": 2.52474451065063,
    "h": 113.499267578125,
    "CMY_C": 0.42969709634781,
    "CMY_M": 0.42763030529022,
    "CMY_Y": 0.44999527931213,
    "CMYK_C": 0.00361093715765,
    "CMYK_M": 0,
    "CMYK_Y": 0.03907435014844,
    "CMYK_K": 0.42763030529022
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0642",
    "Farbtonhilfsbezeichnung": "Jade 40",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "176",
    "Bcolor": "165",
    "Y": 42,
    "L": 71.7123870849609,
    "a": -1.66447985172272,
    "b": 5.09305238723755,
    "C": 5.35814094543457,
    "h": 108.098106384277,
    "CMY_C": 0.30738270282745,
    "CMY_M": 0.3081967830658,
    "CMY_Y": 0.35253208875656,
    "CMYK_C": 0,
    "CMYK_M": 0.0011753680883,
    "CMYK_Y": 0.06518662720919,
    "CMYK_K": 0.30738270282745
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0643",
    "Farbtonhilfsbezeichnung": "Jade 45",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "189",
    "Bcolor": "176",
    "Y": 50,
    "L": 76.551513671875,
    "a": -1.41162645816803,
    "b": 6.04685163497925,
    "C": 6.20943689346313,
    "h": 103.140258789063,
    "CMY_C": 0.25082123279572,
    "CMY_M": 0.25729691982269,
    "CMY_Y": 0.30852115154266,
    "CMYK_C": 0,
    "CMYK_M": 0.00864371377975,
    "CMYK_Y": 0.07701756060123,
    "CMYK_K": 0.25082123279572
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0644",
    "Farbtonhilfsbezeichnung": "Jade 50",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "202",
    "Bcolor": "192",
    "Y": 58,
    "L": 81.1228103637695,
    "a": -1.05293488502502,
    "b": 4.0890736579895,
    "C": 4.22246313095093,
    "h": 104.43994140625,
    "CMY_C": 0.20466959476471,
    "CMY_M": 0.20813709497452,
    "CMY_Y": 0.24576383829117,
    "CMYK_C": 0,
    "CMYK_M": 0.00435982365161,
    "CMYK_Y": 0.05166940018535,
    "CMYK_K": 0.20466959476471
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0645",
    "Farbtonhilfsbezeichnung": "Jade 55",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "215",
    "Bcolor": "207",
    "Y": 68,
    "L": 85.8872985839844,
    "a": -0.55165278911591,
    "b": 3.30502820014954,
    "C": 3.35075092315674,
    "h": 99.4760665893555,
    "CMY_C": 0.15111911296844,
    "CMY_M": 0.15691441297531,
    "CMY_Y": 0.18855583667755,
    "CMYK_C": 0,
    "CMYK_M": 0.00682698842138,
    "CMYK_Y": 0.04410126805305,
    "CMYK_K": 0.15111911296844
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0646",
    "Farbtonhilfsbezeichnung": "Jade 60",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "223",
    "Y": 83,
    "L": 92.6116790771484,
    "a": -1.11084342002869,
    "b": 4.92824459075928,
    "C": 5.05188751220703,
    "h": 102.70238494873,
    "CMY_C": 0.0754451751709,
    "CMY_M": 0.08137118816376,
    "CMY_Y": 0.12702113389969,
    "CMYK_C": 0,
    "CMYK_M": 0.00640958547592,
    "CMYK_Y": 0.05578463897109,
    "CMYK_K": 0.0754451751709
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0647",
    "Farbtonhilfsbezeichnung": "Jade 65",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "131",
    "Bcolor": "103",
    "Y": 21,
    "L": 54.009895324707,
    "a": -4.57536697387695,
    "b": 14.6489639282227,
    "C": 15.3468608856201,
    "h": 107.345352172852,
    "CMY_C": 0.48575341701508,
    "CMY_M": 0.48716622591019,
    "CMY_Y": 0.59644174575806,
    "CMYK_C": 0,
    "CMYK_M": 0.00274733733386,
    "CMYK_Y": 0.21524368226528,
    "CMYK_K": 0.48575341701508
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0648",
    "Farbtonhilfsbezeichnung": "Jade 70",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "162",
    "Bcolor": "142",
    "Y": 35,
    "L": 66.0889892578125,
    "a": -2.65140008926392,
    "b": 9.83253955841064,
    "C": 10.1837491989136,
    "h": 105.091178894043,
    "CMY_C": 0.36018550395966,
    "CMY_M": 0.36639147996902,
    "CMY_Y": 0.4437341094017,
    "CMYK_C": 0,
    "CMYK_M": 0.00969964917749,
    "CMYK_Y": 0.13058254122734,
    "CMYK_K": 0.36018550395966
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0649",
    "Farbtonhilfsbezeichnung": "Jade 75",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "187",
    "Bcolor": "163",
    "Y": 49,
    "L": 75.3435821533203,
    "a": -3.29163789749146,
    "b": 11.546425819397,
    "C": 12.0064496994019,
    "h": 105.911712646484,
    "CMY_C": 0.26174104213715,
    "CMY_M": 0.26740288734436,
    "CMY_Y": 0.36079347133636,
    "CMYK_C": 0,
    "CMYK_M": 0.00766918575391,
    "CMYK_Y": 0.13417030870914,
    "CMYK_K": 0.26174104213715
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0650",
    "Farbtonhilfsbezeichnung": "Jade 80",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "208",
    "Bcolor": "177",
    "Y": 62,
    "L": 82.8576507568359,
    "a": -4.81915473937988,
    "b": 14.7279396057129,
    "C": 15.4963369369507,
    "h": 108.118705749512,
    "CMY_C": 0.18248742818832,
    "CMY_M": 0.18329036235809,
    "CMY_Y": 0.30519092082977,
    "CMYK_C": 0,
    "CMYK_M": 0.00098216731567,
    "CMYK_Y": 0.15009370446205,
    "CMYK_K": 0.18248742818832
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0651",
    "Farbtonhilfsbezeichnung": "Jade 85",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "223",
    "Bcolor": "198",
    "Y": 73,
    "L": 88.3374176025391,
    "a": -3.29951071739197,
    "b": 11.8327703475952,
    "C": 12.2841863632202,
    "h": 105.580871582031,
    "CMY_C": 0.11871236562729,
    "CMY_M": 0.12567687034607,
    "CMY_Y": 0.22513341903687,
    "CMYK_C": 0,
    "CMYK_M": 0.00790264643729,
    "CMYK_Y": 0.12075632065535,
    "CMYK_K": 0.11871236562729
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0652",
    "Farbtonhilfsbezeichnung": "Jade 90",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "236",
    "Bcolor": "215",
    "Y": 83,
    "L": 92.9567184448242,
    "a": -2.14044189453125,
    "b": 9.58492946624756,
    "C": 9.82101631164551,
    "h": 102.588363647461,
    "CMY_C": 0.06489378213882,
    "CMY_M": 0.07631707191467,
    "CMY_Y": 0.15806668996811,
    "CMYK_C": 0,
    "CMYK_M": 0.01221603434533,
    "CMYK_Y": 0.09963884949684,
    "CMYK_K": 0.06489378213882
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0653",
    "Farbtonhilfsbezeichnung": "Jade 120",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "230",
    "Bcolor": "163",
    "Y": 77,
    "L": 89.766487121582,
    "a": -10.2199764251709,
    "b": 32.0003509521484,
    "C": 33.5927124023438,
    "h": 107.711959838867,
    "CMY_C": 0.1021026968956,
    "CMY_M": 0.09856772422791,
    "CMY_Y": 0.36203610897064,
    "CMYK_C": 0.00392150646076,
    "CMYK_M": 0,
    "CMYK_Y": 0.29227751493454,
    "CMYK_K": 0.09856772422791
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0654",
    "Farbtonhilfsbezeichnung": "Jade 100",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "161",
    "Bcolor": "125",
    "Y": 34,
    "L": 65.3540802001953,
    "a": -6.5899395942688,
    "b": 18.1992492675781,
    "C": 19.355619430542,
    "h": 109.905296325684,
    "CMY_C": 0.37434321641922,
    "CMY_M": 0.36747294664383,
    "CMY_Y": 0.51022166013718,
    "CMYK_C": 0.01086162216961,
    "CMYK_M": 0,
    "CMYK_Y": 0.22568000853062,
    "CMYK_K": 0.36747294664383
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0655",
    "Farbtonhilfsbezeichnung": "Jade 105",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "188",
    "Bcolor": "141",
    "Y": 48,
    "L": 74.9550857543945,
    "a": -8.45098209381104,
    "b": 22.9336719512939,
    "C": 24.4412021636963,
    "h": 110.228675842285,
    "CMY_C": 0.27403515577316,
    "CMY_M": 0.2627974152565,
    "CMY_Y": 0.44762754440308,
    "CMYK_C": 0.01524376124144,
    "CMYK_M": 0,
    "CMYK_Y": 0.25071823596954,
    "CMYK_K": 0.2627974152565
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0656",
    "Farbtonhilfsbezeichnung": "Jade 110",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "216",
    "Bcolor": "169",
    "Y": 67,
    "L": 85.2381286621094,
    "a": -7.05425310134888,
    "b": 22.6464691162109,
    "C": 23.7197189331055,
    "h": 107.301528930664,
    "CMY_C": 0.15184456110001,
    "CMY_M": 0.15390133857727,
    "CMY_Y": 0.33877032995224,
    "CMYK_C": 0,
    "CMYK_M": 0.00242500053719,
    "CMYK_Y": 0.22039093077183,
    "CMYK_K": 0.15184456110001
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0657",
    "Farbtonhilfsbezeichnung": "Jade 115",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "223",
    "Bcolor": "171",
    "Y": 72,
    "L": 87.5639114379883,
    "a": -9.05837154388428,
    "b": 24.8361797332764,
    "C": 26.4365253448486,
    "h": 110.038162231445,
    "CMY_C": 0.13540214300156,
    "CMY_M": 0.12420302629471,
    "CMY_Y": 0.33094865083694,
    "CMYK_C": 0.01278734300286,
    "CMYK_M": 0,
    "CMYK_Y": 0.23606570065022,
    "CMYK_K": 0.12420302629471
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0658",
    "Farbtonhilfsbezeichnung": "Herba 5",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "149",
    "Bcolor": "125",
    "Y": 29,
    "L": 60.76426181585,
    "a": -5.41935641115132,
    "b": 11.7849988345404,
    "C": 12.9713384598971,
    "h": -1.13977966652133,
    "CMY_C": 0.4299861,
    "CMY_M": 0.4161731,
    "CMY_Y": 0.5110865,
    "CMYK_C": 0.02365941,
    "CMYK_M": 0,
    "CMYK_Y": 0.162571,
    "CMYK_K": 0.4161731
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0659",
    "Farbtonhilfsbezeichnung": "Herba 10",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "161",
    "Bcolor": "137",
    "Y": 34,
    "L": 65.34840828122,
    "a": -4.84308105384862,
    "b": 11.3538483839661,
    "C": 12.3436342792647,
    "h": -1.16760631817354,
    "CMY_C": 0.3795585,
    "CMY_M": 0.3697859,
    "CMY_Y": 0.4621449,
    "CMYK_C": 0.01550679,
    "CMYK_M": 0,
    "CMYK_Y": 0.1465517,
    "CMYK_K": 0.3697859
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0660",
    "Farbtonhilfsbezeichnung": "Herba 15",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "176",
    "Bcolor": "154",
    "Y": 43,
    "L": 71.1669660440734,
    "a": -4.53110959648012,
    "b": 10.4211409988691,
    "C": 11.3635880730351,
    "h": -1.16065456250346,
    "CMY_C": 0.3187006,
    "CMY_M": 0.3090067,
    "CMY_Y": 0.3962262,
    "CMYK_C": 0.01402903,
    "CMYK_M": 0,
    "CMYK_Y": 0.1262234,
    "CMYK_K": 0.3090067
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0661",
    "Farbtonhilfsbezeichnung": "Herba 20",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "199",
    "Bcolor": "175",
    "Y": 57,
    "L": 79.3746184824222,
    "a": -4.40153533080617,
    "b": 10.706035204695,
    "C": 11.575521719236,
    "h": -1.18073504679071,
    "CMY_C": 0.2288781,
    "CMY_M": 0.2212631,
    "CMY_Y": 0.3126775,
    "CMYK_C": 0.009778734,
    "CMYK_M": 0,
    "CMYK_Y": 0.1173881,
    "CMYK_K": 0.2212631
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0662",
    "Farbtonhilfsbezeichnung": "Herba 25",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "221",
    "Bcolor": "204",
    "Y": 72,
    "L": 87.4023313090447,
    "a": -3.35886726654666,
    "b": 7.13531275881132,
    "C": 7.88636021751062,
    "h": -1.13083063332111,
    "CMY_C": 0.1439045,
    "CMY_M": 0.1347355,
    "CMY_Y": 0.200619,
    "CMYK_C": 0.01059672,
    "CMYK_M": 0,
    "CMYK_Y": 0.07614256,
    "CMYK_K": 0.1347355
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0663",
    "Farbtonhilfsbezeichnung": "Herba 30",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "239",
    "Bcolor": "225",
    "Y": 88,
    "L": 94.0946908903045,
    "a": -2.20175862581906,
    "b": 5.68265131881256,
    "C": 6.09428150462142,
    "h": -1.20115315903642,
    "CMY_C": 0.06495208,
    "CMY_M": 0.06240061,
    "CMY_Y": 0.1164429,
    "CMYK_C": 0.002721281,
    "CMYK_M": 0,
    "CMYK_Y": 0.05763903,
    "CMYK_K": 0.06240061
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0664",
    "Farbtonhilfsbezeichnung": "Herba 40",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "185",
    "Bcolor": "77",
    "Y": 44,
    "L": 71.9510894417138,
    "a": -21.5132536137668,
    "b": 51.1035195402069,
    "C": 55.4471801848079,
    "h": -1.17234066397318,
    "CMY_C": 0.3455092,
    "CMY_M": 0.2731405,
    "CMY_Y": 0.6975263,
    "CMYK_C": 0.09956349,
    "CMYK_M": 0,
    "CMYK_Y": 0.5838622,
    "CMYK_K": 0.2731405
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0665",
    "Farbtonhilfsbezeichnung": "Herba 45",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "199",
    "Bcolor": "97",
    "Y": 53,
    "L": 77.4903320255434,
    "a": -18.8620810352295,
    "b": 48.7053085378695,
    "C": 52.2301175639939,
    "h": -1.20131245128745,
    "CMY_C": 0.2692288,
    "CMY_M": 0.2182253,
    "CMY_Y": 0.6205336,
    "CMYK_C": 0.06524069,
    "CMYK_M": 0,
    "CMYK_Y": 0.5146091,
    "CMYK_K": 0.2182253
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0666",
    "Farbtonhilfsbezeichnung": "Herba 50",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "224",
    "Bcolor": "150",
    "Y": 71,
    "L": 86.9070824831026,
    "a": -14.1170298939686,
    "b": 34.5190643813424,
    "C": 37.2941863940006,
    "h": -1.18258694280269,
    "CMY_C": 0.1575472,
    "CMY_M": 0.1224196,
    "CMY_Y": 0.4119247,
    "CMYK_C": 0.04002779,
    "CMYK_M": 0,
    "CMYK_Y": 0.3298901,
    "CMYK_K": 0.1224196
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0667",
    "Farbtonhilfsbezeichnung": "Herba 55",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "229",
    "Bcolor": "168",
    "Y": 76,
    "L": 88.8756766373078,
    "a": -11.9854345660667,
    "b": 27.8830015490638,
    "C": 30.3498338895382,
    "h": -1.16482709778101,
    "CMY_C": 0.1352493,
    "CMY_M": 0.1038583,
    "CMY_Y": 0.3405485,
    "CMYK_C": 0.03502907,
    "CMYK_M": 0,
    "CMYK_Y": 0.2641214,
    "CMYK_K": 0.1038583
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0668",
    "Farbtonhilfsbezeichnung": "Herba 60",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "218",
    "Y": 88,
    "L": 93.8356736755667,
    "a": -3.14141111398808,
    "b": 9.32790978100366,
    "C": 9.84268076641885,
    "h": -1.24595106336106,
    "CMY_C": 0.06361004,
    "CMY_M": 0.06407275,
    "CMY_Y": 0.1466651,
    "CMYK_C": 0,
    "CMYK_M": 0.0004941469,
    "CMYK_Y": 0.08869704,
    "CMYK_K": 0.06361004
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0669",
    "Farbtonhilfsbezeichnung": "Moos 5",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "93",
    "Bcolor": "87",
    "Y": 10,
    "L": 39.1930923461914,
    "a": -1.61939370632172,
    "b": 2.9267852306366,
    "C": 3.3449227809906,
    "h": 118.95580291748,
    "CMY_C": 0.6405770778656,
    "CMY_M": 0.63526785373688,
    "CMY_Y": 0.65963137149811,
    "CMYK_C": 0.01455650199205,
    "CMYK_M": 0,
    "CMYK_Y": 0.0667983815074,
    "CMYK_K": 0.63526785373688
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0670",
    "Farbtonhilfsbezeichnung": "Moos 10",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "114",
    "Bcolor": "108",
    "Y": 16,
    "L": 47.9845848083496,
    "a": -1.34016573429108,
    "b": 2.95622134208679,
    "C": 3.24581098556519,
    "h": 114.386566162109,
    "CMY_C": 0.5540132522583,
    "CMY_M": 0.55109047889709,
    "CMY_Y": 0.57648551464081,
    "CMYK_C": 0.00651082955301,
    "CMYK_M": 0,
    "CMYK_Y": 0.05657050013542,
    "CMYK_K": 0.55109047889709
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0671",
    "Farbtonhilfsbezeichnung": "Moos 15",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "137",
    "Bcolor": "130",
    "Y": 24,
    "L": 56.6993675231934,
    "a": -1.14516234397888,
    "b": 2.56867647171021,
    "C": 2.8123824596405,
    "h": 114.028175354004,
    "CMY_C": 0.4669793844223,
    "CMY_M": 0.46449202299118,
    "CMY_Y": 0.48830926418304,
    "CMYK_C": 0.00464486330748,
    "CMYK_M": 0,
    "CMYK_Y": 0.04447598010302,
    "CMYK_K": 0.46449202299118
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0672",
    "Farbtonhilfsbezeichnung": "Moos 20",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "164",
    "Bcolor": "161",
    "Y": 37,
    "L": 67.3432159423828,
    "a": -0.440309882164,
    "b": 1.19882726669312,
    "C": 1.27712941169739,
    "h": 110.167465209961,
    "CMY_C": 0.35649424791336,
    "CMY_M": 0.35598570108414,
    "CMY_Y": 0.37050038576126,
    "CMYK_C": 0.00078965147259,
    "CMYK_M": 0,
    "CMYK_Y": 0.02253782935441,
    "CMYK_K": 0.35598570108414
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0673",
    "Farbtonhilfsbezeichnung": "Moos 25",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "212",
    "Bcolor": "206",
    "Y": 67,
    "L": 84.817024230957,
    "a": -1.10669958591461,
    "b": 1.99564242362976,
    "C": 2.28196692466736,
    "h": 119.01091003418,
    "CMY_C": 0.171521961689,
    "CMY_M": 0.1670383810997,
    "CMY_Y": 0.19069385528564,
    "CMYK_C": 0.00538269756362,
    "CMYK_M": 0,
    "CMYK_Y": 0.02839923650026,
    "CMYK_K": 0.1670383810997
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0674",
    "Farbtonhilfsbezeichnung": "Moos 30",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "228",
    "Bcolor": "221",
    "Y": 78,
    "L": 90.4612274169922,
    "a": -0.1241005435586,
    "b": 2.57993578910828,
    "C": 2.58291888237,
    "h": 92.7539291381836,
    "CMY_C": 0.0994593501091,
    "CMY_M": 0.10706597566605,
    "CMY_Y": 0.13313990831375,
    "CMYK_C": 0,
    "CMYK_M": 0.00844673160464,
    "CMYK_Y": 0.03740037605166,
    "CMYK_K": 0.0994593501091
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0675",
    "Farbtonhilfsbezeichnung": "Moos 35",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "151",
    "Bcolor": "132",
    "Y": 30,
    "L": 61.7736320495605,
    "a": -4.48959541320801,
    "b": 9.19402408599854,
    "C": 10.2316446304321,
    "h": 116.027030944824,
    "CMY_C": 0.42000645399094,
    "CMY_M": 0.40711879730225,
    "CMY_Y": 0.48308402299881,
    "CMYK_C": 0.02173733338714,
    "CMYK_M": 0,
    "CMYK_Y": 0.12812891602516,
    "CMYK_K": 0.40711879730225
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0676",
    "Farbtonhilfsbezeichnung": "Moos 40",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "168",
    "Bcolor": "155",
    "Y": 38,
    "L": 68.4364776611328,
    "a": -3.09774971008301,
    "b": 6.13177967071533,
    "C": 6.86984539031982,
    "h": 116.802711486816,
    "CMY_C": 0.349465072155,
    "CMY_M": 0.33992713689804,
    "CMY_Y": 0.3939733505249,
    "CMYK_C": 0.01444982178509,
    "CMYK_M": 0,
    "CMYK_Y": 0.08187916129827,
    "CMYK_K": 0.33992713689804
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0677",
    "Farbtonhilfsbezeichnung": "Moos 45",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "183",
    "Bcolor": "177",
    "Y": 48,
    "L": 74.3689956665039,
    "a": -0.97691214084625,
    "b": 2.35093951225281,
    "C": 2.5458345413208,
    "h": 112.564895629883,
    "CMY_C": 0.28251594305038,
    "CMY_M": 0.28072041273117,
    "CMY_Y": 0.30515712499619,
    "CMYK_C": 0.00249628978781,
    "CMYK_M": 0,
    "CMYK_Y": 0.03397387266159,
    "CMYK_K": 0.28072041273117
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0678",
    "Farbtonhilfsbezeichnung": "Moos 50",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "189",
    "Bcolor": "177",
    "Y": 51,
    "L": 76.1430816650391,
    "a": -2.30668640136719,
    "b": 5.09813070297241,
    "C": 5.59568929672241,
    "h": 114.3447265625,
    "CMY_C": 0.26488095521927,
    "CMY_M": 0.25942766666412,
    "CMY_Y": 0.30617707967758,
    "CMYK_C": 0.00736361369491,
    "CMYK_M": 0,
    "CMYK_Y": 0.0631260573864,
    "CMYK_K": 0.25942766666412
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0679",
    "Farbtonhilfsbezeichnung": "Moos 55",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "207",
    "Bcolor": "199",
    "Y": 62,
    "L": 82.8836898803711,
    "a": -1.34367990493774,
    "b": 3.07478332519531,
    "C": 3.35555791854858,
    "h": 113.605323791504,
    "CMY_C": 0.19096797704697,
    "CMY_M": 0.1879820227623,
    "CMY_Y": 0.21951359510422,
    "CMYK_C": 0.00367720215581,
    "CMYK_M": 0,
    "CMYK_Y": 0.03883112594485,
    "CMYK_K": 0.1879820227623
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0680",
    "Farbtonhilfsbezeichnung": "Moos 60",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 72,
    "L": 87.6519393920898,
    "a": -2.5662784576416,
    "b": 6.07479524612427,
    "C": 6.59461307525635,
    "h": 112.901473999023,
    "CMY_C": 0.13833957910538,
    "CMY_M": 0.1334912776947,
    "CMY_Y": 0.18999081850052,
    "CMYK_C": 0.00559521373361,
    "CMYK_M": 0,
    "CMYK_Y": 0.06520365923643,
    "CMYK_K": 0.1334912776947
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0681",
    "Farbtonhilfsbezeichnung": "Moos 70",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "163",
    "Bcolor": "121",
    "Y": 35,
    "L": 65.1905517578125,
    "a": -10.2860460281372,
    "b": 19.912088394165,
    "C": 22.4119167327881,
    "h": 117.319648742676,
    "CMY_C": 0.39837515354156,
    "CMY_M": 0.36193382740021,
    "CMY_Y": 0.52452754974365,
    "CMYK_C": 0.05711214244366,
    "CMYK_M": 0,
    "CMYK_Y": 0.25482267141342,
    "CMYK_K": 0.36193382740021
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0682",
    "Farbtonhilfsbezeichnung": "Moos 75",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "177",
    "Bcolor": "155",
    "Y": 43,
    "L": 71.384880065918,
    "a": -4.53791046142578,
    "b": 9.93440437316895,
    "C": 10.9217681884766,
    "h": 114.550323486328,
    "CMY_C": 0.31782746315002,
    "CMY_M": 0.30654096603394,
    "CMY_Y": 0.3905376791954,
    "CMYK_C": 0.01627565175295,
    "CMYK_M": 0,
    "CMYK_Y": 0.12112714350224,
    "CMYK_K": 0.30654096603394
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0683",
    "Farbtonhilfsbezeichnung": "Moos 80",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "202",
    "Bcolor": "180",
    "Y": 58,
    "L": 80.5072174072266,
    "a": -4.67817258834839,
    "b": 9.5463228225708,
    "C": 10.6309728622437,
    "h": 116.107147216797,
    "CMY_C": 0.22212916612625,
    "CMY_M": 0.20802760124207,
    "CMY_Y": 0.29234945774078,
    "CMYK_C": 0.01780562661588,
    "CMYK_M": 0,
    "CMYK_Y": 0.10647070407867,
    "CMYK_K": 0.20802760124207
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0684",
    "Farbtonhilfsbezeichnung": "Moos 85",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "215",
    "Bcolor": "190",
    "Y": 67,
    "L": 85.2279586791992,
    "a": -5.42674493789673,
    "b": 11.2091646194458,
    "C": 12.4537115097046,
    "h": 115.833229064941,
    "CMY_C": 0.17127746343613,
    "CMY_M": 0.15505105257034,
    "CMY_Y": 0.25428515672684,
    "CMYK_C": 0.0192040130496,
    "CMYK_M": 0,
    "CMYK_Y": 0.11744390428066,
    "CMYK_K": 0.15505105257034
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0685",
    "Farbtonhilfsbezeichnung": "Moos 90",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "235",
    "Bcolor": "216",
    "Y": 83,
    "L": 92.425407409668,
    "a": -2.89980459213257,
    "b": 7.86340141296387,
    "C": 8.38104724884033,
    "h": 110.242576599121,
    "CMY_C": 0.08213049173355,
    "CMY_M": 0.08003878593445,
    "CMY_Y": 0.15117466449738,
    "CMYK_C": 0.00227368902415,
    "CMYK_M": 0,
    "CMYK_Y": 0.07732486724854,
    "CMYK_K": 0.08003878593445
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0686",
    "Farbtonhilfsbezeichnung": "Moos 95",
    "Farbtonklasse": "04",
    "Rcolor": "138",
    "Gcolor": "154",
    "Bcolor": "77",
    "Y": 30,
    "L": 60.9988639606977,
    "a": -17.6618216891043,
    "b": 37.7568743317323,
    "C": 41.6835879535333,
    "h": -1.1332572572303,
    "CMY_C": 0.457308,
    "CMY_M": 0.3942093,
    "CMY_Y": 0.696471,
    "CMYK_C": 0.1041593,
    "CMYK_M": 0,
    "CMYK_Y": 0.498954,
    "CMYK_K": 0.3942093
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0687",
    "Farbtonhilfsbezeichnung": "Moos 100",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "174",
    "Bcolor": "109",
    "Y": 40,
    "L": 68.6073250607084,
    "a": -14.8142466094926,
    "b": 30.9295139094259,
    "C": 34.2942667698295,
    "h": -1.12411546215131,
    "CMY_C": 0.3700248,
    "CMY_M": 0.3189139,
    "CMY_Y": 0.5708094,
    "CMYK_C": 0.07504324,
    "CMYK_M": 0,
    "CMYK_Y": 0.3698438,
    "CMYK_K": 0.3189139
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0688",
    "Farbtonhilfsbezeichnung": "Moos 105",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "173",
    "Bcolor": "128",
    "Y": 40,
    "L": 68.9972715652858,
    "a": -10.5234304977899,
    "b": 21.2717030582793,
    "C": 23.7324238214605,
    "h": -1.11138565241497,
    "CMY_C": 0.3568256,
    "CMY_M": 0.3216817,
    "CMY_Y": 0.496259,
    "CMYK_C": 0.05181044,
    "CMYK_M": 0,
    "CMYK_Y": 0.2573678,
    "CMYK_K": 0.3216817
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0689",
    "Farbtonhilfsbezeichnung": "Moos 120",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "236",
    "Bcolor": "205",
    "Y": 82,
    "L": 92.2054444533479,
    "a": -6.66547072582452,
    "b": 13.4300971293953,
    "C": 14.9931987548293,
    "h": -1.11010631427053,
    "CMY_C": 0.09687293,
    "CMY_M": 0.07526986,
    "CMY_Y": 0.1956568,
    "CMYK_C": 0.02336148,
    "CMYK_M": 0,
    "CMYK_Y": 0.130186,
    "CMYK_K": 0.07526986
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0690",
    "Farbtonhilfsbezeichnung": "Oase 5",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "141",
    "Bcolor": "125",
    "Y": 26,
    "L": 57.7512588500977,
    "a": -5.46743392944336,
    "b": 7.05728960037231,
    "C": 8.92738342285156,
    "h": 127.76570892334,
    "CMY_C": 0.47424238920212,
    "CMY_M": 0.44586616754532,
    "CMY_Y": 0.50872135162354,
    "CMYK_C": 0.0512082464993,
    "CMYK_M": 0,
    "CMYK_Y": 0.11342960596085,
    "CMYK_K": 0.44586616754532
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0691",
    "Farbtonhilfsbezeichnung": "Oase 10",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "161",
    "Bcolor": "147",
    "Y": 35,
    "L": 65.3644943237305,
    "a": -4.45347023010254,
    "b": 6.0187840461731,
    "C": 7.48726654052734,
    "h": 126.498794555664,
    "CMY_C": 0.39193099737167,
    "CMY_M": 0.36918306350708,
    "CMY_Y": 0.42486304044724,
    "CMYK_C": 0.03606107085943,
    "CMYK_M": 0,
    "CMYK_Y": 0.08826646208763,
    "CMYK_K": 0.36918306350708
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0692",
    "Farbtonhilfsbezeichnung": "Oase 15",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "173",
    "Bcolor": "160",
    "Y": 41,
    "L": 69.9180755615234,
    "a": -4.42492866516113,
    "b": 5.18043756484985,
    "C": 6.81299686431885,
    "h": 130.502655029297,
    "CMY_C": 0.34678786993027,
    "CMY_M": 0.32118278741837,
    "CMY_Y": 0.37217956781387,
    "CMYK_C": 0.03772014379501,
    "CMYK_M": 0,
    "CMYK_Y": 0.07512594014406,
    "CMYK_K": 0.32118278741837
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0693",
    "Farbtonhilfsbezeichnung": "Oase 20",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "202",
    "Bcolor": "191",
    "Y": 58,
    "L": 80.4803771972656,
    "a": -3.46051597595215,
    "b": 3.61255383491516,
    "C": 5.00257110595703,
    "h": 133.768600463867,
    "CMY_C": 0.23178094625473,
    "CMY_M": 0.20953071117401,
    "CMY_Y": 0.24953955411911,
    "CMYK_C": 0.0281481333077,
    "CMYK_M": 0,
    "CMYK_Y": 0.05061403661966,
    "CMYK_K": 0.20953071117401
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0694",
    "Farbtonhilfsbezeichnung": "Oase 25",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "216",
    "Bcolor": "206",
    "Y": 67,
    "L": 85.9217147827148,
    "a": -2.26627564430237,
    "b": 3.81140184402466,
    "C": 4.43427419662476,
    "h": 120.735900878906,
    "CMY_C": 0.16242831945419,
    "CMY_M": 0.15269458293915,
    "CMY_Y": 0.19213032722473,
    "CMYK_C": 0.01148787233979,
    "CMYK_M": 0,
    "CMYK_Y": 0.04654253646731,
    "CMYK_K": 0.15269458293915
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0695",
    "Farbtonhilfsbezeichnung": "Oase 30",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "227",
    "Bcolor": "219",
    "Y": 77,
    "L": 90.0714569091797,
    "a": -1.65322482585907,
    "b": 2.88984537124634,
    "C": 3.32931804656982,
    "h": 119.77303314209,
    "CMY_C": 0.11479723453522,
    "CMY_M": 0.10789161920547,
    "CMY_Y": 0.13993328809738,
    "CMYK_C": 0.00774078071117,
    "CMYK_M": 0,
    "CMYK_Y": 0.03591679036617,
    "CMYK_K": 0.10789161920547
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0696",
    "Farbtonhilfsbezeichnung": "Oase 35",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "85",
    "Bcolor": "73",
    "Y": 8,
    "L": 35.0681571960449,
    "a": -5.0337061882019,
    "b": 5.58798933029175,
    "C": 7.52089262008667,
    "h": 132.012786865234,
    "CMY_C": 0.69464254379272,
    "CMY_M": 0.66808432340622,
    "CMY_Y": 0.71443748474121,
    "CMYK_C": 0.0800149589777,
    "CMYK_M": 0,
    "CMYK_Y": 0.139653429389,
    "CMYK_K": 0.66808432340622
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0697",
    "Farbtonhilfsbezeichnung": "Oase 40",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "99",
    "Bcolor": "84",
    "Y": 11,
    "L": 40.9652214050293,
    "a": -5.59096956253052,
    "b": 7.21424913406372,
    "C": 9.12712097167969,
    "h": 127.775314331055,
    "CMY_C": 0.63905358314514,
    "CMY_M": 0.61169981956482,
    "CMY_Y": 0.6708310842514,
    "CMYK_C": 0.07044488936663,
    "CMYK_M": 0,
    "CMYK_Y": 0.15228235721588,
    "CMYK_K": 0.61169981956482
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0698",
    "Farbtonhilfsbezeichnung": "Oase 45",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "129",
    "Bcolor": "103",
    "Y": 20,
    "L": 52.6995964050293,
    "a": -8.38299369812012,
    "b": 12.6574573516846,
    "C": 15.1817588806152,
    "h": 123.516372680664,
    "CMY_C": 0.53031611442566,
    "CMY_M": 0.49236935377121,
    "CMY_Y": 0.59620332717896,
    "CMYK_C": 0.07475269585848,
    "CMYK_M": 0,
    "CMYK_Y": 0.20454630255699,
    "CMYK_K": 0.49236935377121
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0699",
    "Farbtonhilfsbezeichnung": "Oase 50",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "188",
    "Bcolor": "165",
    "Y": 49,
    "L": 74.9766082763672,
    "a": -7.61894035339355,
    "b": 9.66338443756104,
    "C": 12.3056592941284,
    "h": 128.253433227539,
    "CMY_C": 0.30378443002701,
    "CMY_M": 0.26146817207336,
    "CMY_Y": 0.35179626941681,
    "CMYK_C": 0.05729781091213,
    "CMYK_M": 0,
    "CMYK_Y": 0.1223076581955,
    "CMYK_K": 0.26146817207336
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0700",
    "Farbtonhilfsbezeichnung": "Oase 55",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "217",
    "Bcolor": "205",
    "Y": 68,
    "L": 86.0958251953125,
    "a": -3.26788425445557,
    "b": 4.5040020942688,
    "C": 5.56462955474854,
    "h": 125.962814331055,
    "CMY_C": 0.16608649492264,
    "CMY_M": 0.14866077899933,
    "CMY_Y": 0.19545513391495,
    "CMYK_C": 0.02046859264374,
    "CMYK_M": 0,
    "CMYK_Y": 0.05496558174491,
    "CMYK_K": 0.14866077899933
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0701",
    "Farbtonhilfsbezeichnung": "Oase 60",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "225",
    "Y": 83,
    "L": 92.4922409057617,
    "a": -2.34520244598389,
    "b": 3.32807779312134,
    "C": 4.07137298583984,
    "h": 125.171279907227,
    "CMY_C": 0.09184944629669,
    "CMY_M": 0.07936400175095,
    "CMY_Y": 0.1166153550148,
    "CMYK_C": 0.01356176007539,
    "CMYK_M": 0,
    "CMYK_Y": 0.04046262800694,
    "CMYK_K": 0.07936400175095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0702",
    "Farbtonhilfsbezeichnung": "Oase 65",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "90",
    "Bcolor": "66",
    "Y": 9,
    "L": 36.2679328918457,
    "a": -10.4425916671753,
    "b": 11.5325784683228,
    "C": 15.5578947067261,
    "h": 132.160400390625,
    "CMY_C": 0.70520013570786,
    "CMY_M": 0.64843189716339,
    "CMY_Y": 0.74153304100037,
    "CMYK_C": 0.1614715307951,
    "CMYK_M": 0,
    "CMYK_Y": 0.26481682062149,
    "CMYK_K": 0.64843189716339
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0703",
    "Farbtonhilfsbezeichnung": "Oase 80",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "204",
    "Bcolor": "185",
    "Y": 58,
    "L": 81.0846176147461,
    "a": -6.00568580627441,
    "b": 8.04674243927002,
    "C": 10.0408325195313,
    "h": 126.735809326172,
    "CMY_C": 0.23074066638947,
    "CMY_M": 0.19841796159744,
    "CMY_Y": 0.27554059028625,
    "CMYK_C": 0.0403236374259,
    "CMYK_M": 0,
    "CMYK_Y": 0.09621302038431,
    "CMYK_K": 0.19841796159744
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0704",
    "Farbtonhilfsbezeichnung": "Oase 85",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "217",
    "Bcolor": "201",
    "Y": 67,
    "L": 85.9684143066406,
    "a": -4.76276779174805,
    "b": 6.64267110824585,
    "C": 8.17367935180664,
    "h": 125.64037322998,
    "CMY_C": 0.17224806547165,
    "CMY_M": 0.14723068475723,
    "CMY_Y": 0.21272641420364,
    "CMYK_C": 0.02933663316071,
    "CMYK_M": 0,
    "CMYK_Y": 0.07680357247591,
    "CMYK_K": 0.14723068475723
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0705",
    "Farbtonhilfsbezeichnung": "Oase 90",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "231",
    "Bcolor": "218",
    "Y": 77,
    "L": 91.0783767700195,
    "a": -3.08664727210999,
    "b": 5.31439971923828,
    "C": 6.14574956893921,
    "h": 120.148368835449,
    "CMY_C": 0.10687226057053,
    "CMY_M": 0.09398686885834,
    "CMY_Y": 0.14703488349915,
    "CMYK_C": 0.01422208081931,
    "CMYK_M": 0,
    "CMYK_Y": 0.05855104327202,
    "CMYK_K": 0.09398686885834
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0706",
    "Farbtonhilfsbezeichnung": "Oase 95",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "102",
    "Bcolor": "65",
    "Y": 11,
    "L": 40.2471313476563,
    "a": -16.5813541412354,
    "b": 17.6894264221191,
    "C": 24.2457656860352,
    "h": 133.148101806641,
    "CMY_C": 0.69721353054047,
    "CMY_M": 0.60131227970123,
    "CMY_Y": 0.74652087688446,
    "CMYK_C": 0.24054227769375,
    "CMYK_M": 0,
    "CMYK_Y": 0.36421638727188,
    "CMYK_K": 0.60131227970123
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0707",
    "Farbtonhilfsbezeichnung": "Oase 100",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "123",
    "Bcolor": "82",
    "Y": 17,
    "L": 48.5632629394531,
    "a": -16.9188804626465,
    "b": 18.9838466644287,
    "C": 25.4290180206299,
    "h": 131.708236694336,
    "CMY_C": 0.61709952354431,
    "CMY_M": 0.51933020353317,
    "CMY_Y": 0.6791889667511,
    "CMYK_C": 0.20340225100517,
    "CMYK_M": 0,
    "CMYK_Y": 0.33257502317429,
    "CMYK_K": 0.51933020353317
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0708",
    "Farbtonhilfsbezeichnung": "Oase 105",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "142",
    "Bcolor": "107",
    "Y": 25,
    "L": 57.1169471740723,
    "a": -10.3403387069702,
    "b": 16.7877178192139,
    "C": 19.7167453765869,
    "h": 121.630844116211,
    "CMY_C": 0.48946416378021,
    "CMY_M": 0.44466942548752,
    "CMY_Y": 0.58193838596344,
    "CMYK_C": 0.08066319674253,
    "CMYK_M": 0,
    "CMYK_Y": 0.24718423187733,
    "CMYK_K": 0.44466942548752
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0709",
    "Farbtonhilfsbezeichnung": "Oase 110",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "195",
    "Bcolor": "143",
    "Y": 49,
    "L": 75.6312866210938,
    "a": -18.0894527435303,
    "b": 22.5569534301758,
    "C": 28.9144325256348,
    "h": 128.727722167969,
    "CMY_C": 0.34091931581497,
    "CMY_M": 0.23573207855225,
    "CMY_Y": 0.43964964151382,
    "CMYK_C": 0.13763137161732,
    "CMYK_M": 0,
    "CMYK_Y": 0.26681423187256,
    "CMYK_K": 0.23573207855225
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0710",
    "Farbtonhilfsbezeichnung": "Oase 115",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "194",
    "Bcolor": "158",
    "Y": 50,
    "L": 76.4791259765625,
    "a": -11.5907049179077,
    "b": 15.6416292190552,
    "C": 19.4680500030518,
    "h": 126.539047241211,
    "CMY_C": 0.30059534311295,
    "CMY_M": 0.23826014995575,
    "CMY_Y": 0.37970805168152,
    "CMYK_C": 0.08183265477419,
    "CMYK_M": 0,
    "CMYK_Y": 0.18569056689739,
    "CMYK_K": 0.23826014995575
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0711",
    "Farbtonhilfsbezeichnung": "Oase 120",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "239",
    "Bcolor": "212",
    "Y": 82,
    "L": 93.0633697509766,
    "a": -7.75968551635742,
    "b": 11.0227937698364,
    "C": 13.4801597595215,
    "h": 125.14427947998,
    "CMY_C": 0.10343307256699,
    "CMY_M": 0.06253808736801,
    "CMY_Y": 0.16849184036255,
    "CMYK_C": 0.04362308979034,
    "CMYK_M": 0,
    "CMYK_Y": 0.11302192509174,
    "CMYK_K": 0.06253808736801
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0712",
    "Farbtonhilfsbezeichnung": "Oase 125",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "125",
    "Bcolor": "70",
    "Y": 17,
    "L": 48.5865173339844,
    "a": -22.8993034362793,
    "b": 25.4731483459473,
    "C": 34.252872467041,
    "h": 131.954223632813,
    "CMY_C": 0.64707845449448,
    "CMY_M": 0.51018333435059,
    "CMY_Y": 0.72459959983826,
    "CMYK_C": 0.27948236465454,
    "CMYK_M": 0,
    "CMYK_Y": 0.43774798512459,
    "CMYK_K": 0.51018333435059
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0713",
    "Farbtonhilfsbezeichnung": "Oase 130",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "152",
    "Bcolor": "77",
    "Y": 26,
    "L": 58.2901382446289,
    "a": -29.1513748168945,
    "b": 34.4409484863281,
    "C": 45.1218528747559,
    "h": 130.245101928711,
    "CMY_C": 0.57990097999573,
    "CMY_M": 0.40211600065231,
    "CMY_Y": 0.69995474815369,
    "CMYK_C": 0.29735699295998,
    "CMYK_M": 0,
    "CMYK_Y": 0.49815472960472,
    "CMYK_K": 0.40211600065231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0714",
    "Farbtonhilfsbezeichnung": "Oase 135",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "165",
    "Bcolor": "106",
    "Y": 33,
    "L": 64.2421493530273,
    "a": -20.8621063232422,
    "b": 26.754487991333,
    "C": 33.9268341064453,
    "h": 127.945709228516,
    "CMY_C": 0.47078728675842,
    "CMY_M": 0.35288405418396,
    "CMY_Y": 0.5844806432724,
    "CMYK_C": 0.18219800293446,
    "CMYK_M": 0,
    "CMYK_Y": 0.35789039731026,
    "CMYK_K": 0.35288405418396
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0715",
    "Farbtonhilfsbezeichnung": "Oase 140",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "182",
    "Bcolor": "84",
    "Y": 39,
    "L": 68.6822128295898,
    "a": -32.535774230957,
    "b": 43.3973541259766,
    "C": 54.2393493652344,
    "h": 126.859550476074,
    "CMY_C": 0.47997897863388,
    "CMY_M": 0.28770017623901,
    "CMY_Y": 0.6694011092186,
    "CMYK_C": 0.26994082331657,
    "CMYK_M": 0,
    "CMYK_Y": 0.53587114810944,
    "CMYK_K": 0.28770017623901
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0716",
    "Farbtonhilfsbezeichnung": "Oase 145",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "197",
    "Bcolor": "107",
    "Y": 47,
    "L": 74.2869720458984,
    "a": -31.5852546691895,
    "b": 39.1233100891113,
    "C": 50.2818222045898,
    "h": 128.914840698242,
    "CMY_C": 0.42228478193283,
    "CMY_M": 0.2281077504158,
    "CMY_Y": 0.57968854904175,
    "CMYK_C": 0.2515597641468,
    "CMYK_M": 0,
    "CMYK_Y": 0.45547911524773,
    "CMYK_K": 0.2281077504158
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0717",
    "Farbtonhilfsbezeichnung": "Oase 150",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "212",
    "Bcolor": "145",
    "Y": 58,
    "L": 80.9101486206055,
    "a": -22.7725086212158,
    "b": 28.8976612091064,
    "C": 36.7921447753906,
    "h": 128.239517211914,
    "CMY_C": 0.30465734004974,
    "CMY_M": 0.1701175570488,
    "CMY_Y": 0.43316072225571,
    "CMYK_C": 0.1621190905571,
    "CMYK_M": 0,
    "CMYK_Y": 0.31696435809135,
    "CMYK_K": 0.1701175570488
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0718",
    "Farbtonhilfsbezeichnung": "Agave 5",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "119",
    "Bcolor": "115",
    "Y": 18,
    "L": 49.6655197143555,
    "a": -0.87308824062347,
    "b": 1.46201014518738,
    "C": 1.70286726951599,
    "h": 120.844955444336,
    "CMY_C": 0.53862977027893,
    "CMY_M": 0.53514754772186,
    "CMY_Y": 0.55034792423248,
    "CMYK_C": 0.00749102747068,
    "CMYK_M": 0,
    "CMYK_Y": 0.03269935771823,
    "CMYK_K": 0.53514754772186
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0719",
    "Farbtonhilfsbezeichnung": "Agave 10",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "148",
    "Bcolor": "143",
    "Y": 29,
    "L": 61.031307220459,
    "a": -1.26979434490204,
    "b": 1.98017871379852,
    "C": 2.35233616828918,
    "h": 122.670112609863,
    "CMY_C": 0.42555791139603,
    "CMY_M": 0.41987562179565,
    "CMY_Y": 0.44073647260666,
    "CMYK_C": 0.00979495048523,
    "CMYK_M": 0,
    "CMYK_Y": 0.03595927357674,
    "CMYK_K": 0.41987562179565
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0720",
    "Farbtonhilfsbezeichnung": "Agave 15",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "173",
    "Bcolor": "167",
    "Y": 42,
    "L": 70.3941802978516,
    "a": -1.00197052955627,
    "b": 1.91946160793304,
    "C": 2.16524314880371,
    "h": 117.564834594727,
    "CMY_C": 0.32630735635757,
    "CMY_M": 0.32281541824341,
    "CMY_Y": 0.34385997056961,
    "CMYK_C": 0.00515655288473,
    "CMYK_M": 0,
    "CMYK_Y": 0.03107653744519,
    "CMYK_K": 0.32281541824341
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0721",
    "Farbtonhilfsbezeichnung": "Agave 20",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "200",
    "Bcolor": "193",
    "Y": 58,
    "L": 80.2708053588867,
    "a": -1.43963098526001,
    "b": 2.24424242973328,
    "C": 2.66630101203918,
    "h": 122.679252624512,
    "CMY_C": 0.22287660837173,
    "CMY_M": 0.21602123975754,
    "CMY_Y": 0.2416296005249,
    "CMYK_C": 0.0087443292141,
    "CMYK_M": 0,
    "CMYK_Y": 0.03266461193562,
    "CMYK_K": 0.21602123975754
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0722",
    "Farbtonhilfsbezeichnung": "Agave 25",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "215",
    "Bcolor": "207",
    "Y": 68,
    "L": 85.5234527587891,
    "a": -1.39865708351135,
    "b": 2.69380116462708,
    "C": 3.03526043891907,
    "h": 117.438926696777,
    "CMY_C": 0.16371923685074,
    "CMY_M": 0.1587832570076,
    "CMY_Y": 0.18815821409225,
    "CMYK_C": 0.00586766703054,
    "CMYK_M": 0,
    "CMYK_Y": 0.03491960465908,
    "CMYK_K": 0.1587832570076
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0723",
    "Farbtonhilfsbezeichnung": "Agave 30",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "226",
    "Y": 83,
    "L": 92.7003021240234,
    "a": -1.00107216835022,
    "b": 3.03106427192688,
    "C": 3.19209909439087,
    "h": 108.276885986328,
    "CMY_C": 0.07984870672226,
    "CMY_M": 0.0801152586937,
    "CMY_Y": 0.11191660165787,
    "CMYK_C": 0,
    "CMYK_M": 0.00028968276456,
    "CMYK_Y": 0.03485067561269,
    "CMYK_K": 0.07984870672226
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0724",
    "Farbtonhilfsbezeichnung": "Agave 35",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "145",
    "Bcolor": "130",
    "Y": 27,
    "L": 59.2256736755371,
    "a": -5.82861280441284,
    "b": 6.3383002281189,
    "C": 8.61085224151611,
    "h": 132.601211547852,
    "CMY_C": 0.46411603689194,
    "CMY_M": 0.42989176511765,
    "CMY_Y": 0.48921430110931,
    "CMYK_C": 0.06003118306398,
    "CMYK_M": 0,
    "CMYK_Y": 0.10405486822128,
    "CMYK_K": 0.42989176511765
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0725",
    "Farbtonhilfsbezeichnung": "Agave 40",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "176",
    "Bcolor": "163",
    "Y": 42,
    "L": 70.9744033813477,
    "a": -5.18056154251099,
    "b": 4.97128582000732,
    "C": 7.17996501922607,
    "h": 136.180953979492,
    "CMY_C": 0.34211164712906,
    "CMY_M": 0.30830764770508,
    "CMY_Y": 0.35984301567078,
    "CMYK_C": 0.0488714389503,
    "CMYK_M": 0,
    "CMYK_Y": 0.07450620085001,
    "CMYK_K": 0.30830764770508
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0726",
    "Farbtonhilfsbezeichnung": "Agave 45",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "201",
    "Bcolor": "191",
    "Y": 58,
    "L": 80.442626953125,
    "a": -3.38483285903931,
    "b": 3.70847201347351,
    "C": 5.02094173431396,
    "h": 132.387634277344,
    "CMY_C": 0.23128271102905,
    "CMY_M": 0.2101371884346,
    "CMY_Y": 0.2506263256073,
    "CMYK_C": 0.02677113376558,
    "CMYK_M": 0,
    "CMYK_Y": 0.05126097425818,
    "CMYK_K": 0.2101371884346
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0727",
    "Farbtonhilfsbezeichnung": "Agave 50",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "223",
    "Bcolor": "212",
    "Y": 73,
    "L": 88.2598266601563,
    "a": -2.77012920379639,
    "b": 3.82409238815308,
    "C": 4.72200155258179,
    "h": 125.919143676758,
    "CMY_C": 0.14057111740112,
    "CMY_M": 0.12568163871765,
    "CMY_Y": 0.16683030128479,
    "CMYK_C": 0.01702981442213,
    "CMYK_M": 0,
    "CMYK_Y": 0.04706370458007,
    "CMYK_K": 0.12568163871765
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0728",
    "Farbtonhilfsbezeichnung": "Agave 55",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "235",
    "Bcolor": "226",
    "Y": 82,
    "L": 92.3762359619141,
    "a": -2.6909191608429,
    "b": 2.7789134979248,
    "C": 3.86825633049011,
    "h": 134.078353881836,
    "CMY_C": 0.0977755188942,
    "CMY_M": 0.07970291376114,
    "CMY_Y": 0.11386269330978,
    "CMYK_C": 0.01963779516518,
    "CMYK_M": 0,
    "CMYK_Y": 0.0371182076633,
    "CMYK_K": 0.07970291376114
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0729",
    "Farbtonhilfsbezeichnung": "Agave 60",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "240",
    "Bcolor": "233",
    "Y": 88,
    "L": 94.5738906860352,
    "a": -1.05292761325836,
    "b": 2.55053067207336,
    "C": 2.75932288169861,
    "h": 112.432151794434,
    "CMY_C": 0.06086778640747,
    "CMY_M": 0.05883431434631,
    "CMY_Y": 0.08757996559143,
    "CMYK_C": 0.00216058874503,
    "CMYK_M": 0,
    "CMYK_Y": 0.03054260462523,
    "CMYK_K": 0.05883431434631
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0730",
    "Farbtonhilfsbezeichnung": "Agave 65",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "161",
    "Bcolor": "134",
    "Y": 33,
    "L": 64.3132553100586,
    "a": -10.9696750640869,
    "b": 11.4396390914917,
    "C": 15.8492622375488,
    "h": 133.798583984375,
    "CMY_C": 0.43562573194504,
    "CMY_M": 0.36801987886429,
    "CMY_Y": 0.47406595945358,
    "CMYK_C": 0.10697465389967,
    "CMYK_M": 0,
    "CMYK_Y": 0.16779971122742,
    "CMYK_K": 0.36801987886429
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0731",
    "Farbtonhilfsbezeichnung": "Agave 70",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "192",
    "Bcolor": "153",
    "Y": 48,
    "L": 74.7339630126953,
    "a": -15.7028722763062,
    "b": 15.8323154449463,
    "C": 22.2989330291748,
    "h": 134.76481628418,
    "CMY_C": 0.35104048252106,
    "CMY_M": 0.24879884719849,
    "CMY_Y": 0.3997614979744,
    "CMYK_C": 0.1361042112112,
    "CMYK_M": 0,
    "CMYK_Y": 0.20096169412136,
    "CMYK_K": 0.24879884719849
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0732",
    "Farbtonhilfsbezeichnung": "Agave 75",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "190",
    "Bcolor": "169",
    "Y": 49,
    "L": 75.462287902832,
    "a": -8.5330982208252,
    "b": 8.26889801025391,
    "C": 11.8822746276856,
    "h": 135.900863647461,
    "CMY_C": 0.31011003255844,
    "CMY_M": 0.25396400690079,
    "CMY_Y": 0.33687937259674,
    "CMYK_C": 0.07525913417339,
    "CMYK_M": 0,
    "CMYK_Y": 0.11114124208689,
    "CMYK_K": 0.25396400690079
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0733",
    "Farbtonhilfsbezeichnung": "Agave 80",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "219",
    "Bcolor": "194",
    "Y": 67,
    "L": 85.3938064575195,
    "a": -11.2967214584351,
    "b": 9.18392467498779,
    "C": 14.5588598251343,
    "h": 140.889831542969,
    "CMY_C": 0.22252708673477,
    "CMY_M": 0.13983744382858,
    "CMY_Y": 0.23851108551025,
    "CMYK_C": 0.09613257646561,
    "CMYK_M": 0,
    "CMYK_Y": 0.1147151067853,
    "CMYK_K": 0.13983744382858
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0734",
    "Farbtonhilfsbezeichnung": "Agave 85",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "217",
    "Bcolor": "202",
    "Y": 67,
    "L": 85.6426620483398,
    "a": -5.12321996688843,
    "b": 5.61286211013794,
    "C": 7.59944772720337,
    "h": 132.388702392578,
    "CMY_C": 0.18203610181808,
    "CMY_M": 0.1497443318367,
    "CMY_Y": 0.20875287055969,
    "CMYK_C": 0.03797889500856,
    "CMYK_M": 0,
    "CMYK_Y": 0.06940093636513,
    "CMYK_K": 0.1497443318367
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0735",
    "Farbtonhilfsbezeichnung": "Agave 95",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "142",
    "Bcolor": "83",
    "Y": 22,
    "L": 54.5268821716309,
    "a": -27.344331741333,
    "b": 25.9606113433838,
    "C": 37.7049827575684,
    "h": 136.48698425293,
    "CMY_C": 0.62431401014328,
    "CMY_M": 0.4428134560585,
    "CMY_Y": 0.67338424921036,
    "CMYK_C": 0.32574468851089,
    "CMYK_M": 0,
    "CMYK_Y": 0.41381257772446,
    "CMYK_K": 0.4428134560585
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0736",
    "Farbtonhilfsbezeichnung": "Agave 100",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "167",
    "Bcolor": "121",
    "Y": 34,
    "L": 64.9301376342773,
    "a": -21.0118255615234,
    "b": 19.6415748596191,
    "C": 28.7626190185547,
    "h": 136.930450439453,
    "CMY_C": 0.48447847366333,
    "CMY_M": 0.3441367149353,
    "CMY_Y": 0.52694630622864,
    "CMYK_C": 0.21398019790649,
    "CMYK_M": 0,
    "CMYK_Y": 0.2787312567234,
    "CMYK_K": 0.3441367149353
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0737",
    "Farbtonhilfsbezeichnung": "Agave 105",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "220",
    "Bcolor": "171",
    "Y": 63,
    "L": 83.3180541992188,
    "a": -24.4183979034424,
    "b": 18.3044490814209,
    "C": 30.5173892974854,
    "h": 143.144134521484,
    "CMY_C": 0.3252649307251,
    "CMY_M": 0.13826006650925,
    "CMY_Y": 0.32968556880951,
    "CMYK_C": 0.21700847148895,
    "CMYK_M": 0,
    "CMYK_Y": 0.22213837504387,
    "CMYK_K": 0.13826006650925
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0738",
    "Farbtonhilfsbezeichnung": "Agave 110",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "232",
    "Bcolor": "193",
    "Y": 76,
    "L": 89.0463485717773,
    "a": -15.251856803894,
    "b": 14.8221139907837,
    "C": 21.2676792144775,
    "h": 135.81867980957,
    "CMY_C": 0.19655424356461,
    "CMY_M": 0.09213727712631,
    "CMY_Y": 0.24150931835175,
    "CMYK_C": 0.11501404643059,
    "CMYK_M": 0,
    "CMYK_Y": 0.16453152894974,
    "CMYK_K": 0.09213727712631
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0739",
    "Farbtonhilfsbezeichnung": "Agave 115",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "238",
    "Bcolor": "214",
    "Y": 82,
    "L": 92.4418411254883,
    "a": -9.03814220428467,
    "b": 9.01519870758057,
    "C": 12.7656497955322,
    "h": 135.072814941406,
    "CMY_C": 0.12723433971405,
    "CMY_M": 0.06614720821381,
    "CMY_Y": 0.16048890352249,
    "CMYK_C": 0.06541409343481,
    "CMYK_M": 0,
    "CMYK_Y": 0.10102415829897,
    "CMYK_K": 0.06614720821381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0740",
    "Farbtonhilfsbezeichnung": "Agave 120",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "241",
    "Bcolor": "225",
    "Y": 87,
    "L": 93.7639312744141,
    "a": -6.14353704452515,
    "b": 5.33060693740845,
    "C": 8.13378238677979,
    "h": 139.05256652832,
    "CMY_C": 0.10143709182739,
    "CMY_M": 0.05685210227966,
    "CMY_Y": 0.11803758144379,
    "CMYK_C": 0.04727253317833,
    "CMYK_M": 0,
    "CMYK_Y": 0.06487368792295,
    "CMYK_K": 0.05685210227966
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0741",
    "Farbtonhilfsbezeichnung": "Agave 125",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "169",
    "Bcolor": "85",
    "Y": 31,
    "L": 62.5977439880371,
    "a": -40.7286224365234,
    "b": 35.0111694335938,
    "C": 53.70849609375,
    "h": 139.316970825195,
    "CMY_C": 0.64290529489517,
    "CMY_M": 0.33890771865845,
    "CMY_Y": 0.66522914171219,
    "CMYK_C": 0.45984137058258,
    "CMYK_M": 0,
    "CMYK_Y": 0.49360948801041,
    "CMYK_K": 0.33890771865845
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0742",
    "Farbtonhilfsbezeichnung": "Agave 130",
    "Farbtonklasse": "04",
    "Rcolor": "122",
    "Gcolor": "181",
    "Bcolor": "112",
    "Y": 39,
    "L": 68.3301391601563,
    "a": -32.35107421875,
    "b": 28.8778476715088,
    "C": 43.3649864196777,
    "h": 138.246627807617,
    "CMY_C": 0.51988160610199,
    "CMY_M": 0.28978884220123,
    "CMY_Y": 0.56178736686707,
    "CMYK_C": 0.32397797703743,
    "CMYK_M": 0,
    "CMYK_Y": 0.38298261165619,
    "CMYK_K": 0.28978884220123
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0743",
    "Farbtonhilfsbezeichnung": "Agave 135",
    "Farbtonklasse": "04",
    "Rcolor": "126",
    "Gcolor": "191",
    "Bcolor": "110",
    "Y": 43,
    "L": 71.5396041870117,
    "a": -36.0121803283691,
    "b": 34.117618560791,
    "C": 49.607349395752,
    "h": 136.547470092773,
    "CMY_C": 0.5043123960495,
    "CMY_M": 0.24979776144028,
    "CMY_Y": 0.56969583034515,
    "CMYK_C": 0.3392613530159,
    "CMYK_M": 0,
    "CMYK_Y": 0.42641577124596,
    "CMYK_K": 0.24979776144028
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0744",
    "Farbtonhilfsbezeichnung": "Agave 140",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "201",
    "Bcolor": "137",
    "Y": 54,
    "L": 76.339599609375,
    "a": -27.2600288391113,
    "b": 26.418342590332,
    "C": 37.9610061645508,
    "h": 135.898330688477,
    "CMY_C": 0.39816325902939,
    "CMY_M": 0.21139907836914,
    "CMY_Y": 0.46232610940933,
    "CMYK_C": 0.23682977259159,
    "CMYK_M": 0,
    "CMYK_Y": 0.31819266080856,
    "CMYK_K": 0.21139907836914
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0745",
    "Farbtonhilfsbezeichnung": "Palm 5",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "98",
    "Bcolor": "90",
    "Y": 11,
    "L": 40.1628774542651,
    "a": -6.88597050523737,
    "b": 2.40688229227997,
    "C": 7.29449601877264,
    "h": -0.3362598055473,
    "CMY_C": 0.6699399,
    "CMY_M": 0.6159533,
    "CMY_Y": 0.6479491,
    "CMYK_C": 0.1405732,
    "CMYK_M": 0,
    "CMYK_Y": 0.08331239,
    "CMYK_K": 0.6159533
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0746",
    "Farbtonhilfsbezeichnung": "Palm 10",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "98",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.7060831922358,
    "a": -3.46635307732734,
    "b": 1.64670679832313,
    "C": 3.8376095341163,
    "h": -0.44349284268439,
    "CMY_C": 0.6426846,
    "CMY_M": 0.617015,
    "CMY_Y": 0.6376491,
    "CMYK_C": 0.06702519,
    "CMYK_M": 0,
    "CMYK_Y": 0.05387705,
    "CMYK_K": 0.617015
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0747",
    "Farbtonhilfsbezeichnung": "Palm 15",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "108",
    "Bcolor": "96",
    "Y": 14,
    "L": 44.3003528564304,
    "a": -6.94900348067484,
    "b": 4.39603930090504,
    "C": 8.22276175682676,
    "h": -0.56405607265602,
    "CMY_C": 0.6251251,
    "CMY_M": 0.5763937,
    "CMY_Y": 0.6217411,
    "CMYK_C": 0.1150392,
    "CMYK_M": 0,
    "CMYK_Y": 0.1070507,
    "CMYK_K": 0.5763937
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0748",
    "Farbtonhilfsbezeichnung": "Palm 20",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "120",
    "Bcolor": "113",
    "Y": 18,
    "L": 49.6446218980519,
    "a": -3.44280776551292,
    "b": 2.19784534140326,
    "C": 4.08453785084728,
    "h": -0.56816839109492,
    "CMY_C": 0.5548679,
    "CMY_M": 0.5302921,
    "CMY_Y": 0.5556986,
    "CMYK_C": 0.05232159,
    "CMYK_M": 0,
    "CMYK_Y": 0.05408998,
    "CMYK_K": 0.5302921
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0749",
    "Farbtonhilfsbezeichnung": "Palm 25",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "153",
    "Bcolor": "132",
    "Y": 29,
    "L": 61.0768255822773,
    "a": -11.6179828350069,
    "b": 8.11186343068271,
    "C": 14.1696807823099,
    "h": -0.60952775672644,
    "CMY_C": 0.4840015,
    "CMY_M": 0.3997074,
    "CMY_Y": 0.4836183,
    "CMYK_C": 0.1404216,
    "CMYK_M": 0,
    "CMYK_Y": 0.1397832,
    "CMYK_K": 0.3997074
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0750",
    "Farbtonhilfsbezeichnung": "Palm 30",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "179",
    "Bcolor": "160",
    "Y": 42,
    "L": 70.8893612284607,
    "a": -11.3952873480958,
    "b": 6.32797121710709,
    "C": 13.0344080598318,
    "h": -0.50691447863276,
    "CMY_C": 0.3874901,
    "CMY_M": 0.2965844,
    "CMY_Y": 0.3711415,
    "CMYK_C": 0.1292347,
    "CMYK_M": 0,
    "CMYK_Y": 0.1059929,
    "CMYK_K": 0.2965844
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0751",
    "Farbtonhilfsbezeichnung": "Palm 35",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "88",
    "Bcolor": "72",
    "Y": 8,
    "L": 34.80579936786,
    "a": -13.8641225371906,
    "b": 5.62895266112282,
    "C": 14.9632550532095,
    "h": -0.38567542876358,
    "CMY_C": 0.7621014,
    "CMY_M": 0.6555095,
    "CMY_Y": 0.7181236,
    "CMYK_C": 0.3094187,
    "CMYK_M": 0,
    "CMYK_Y": 0.1817585,
    "CMYK_K": 0.6555095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0752",
    "Farbtonhilfsbezeichnung": "Palm 40",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "102",
    "Bcolor": "74",
    "Y": 10,
    "L": 39.5161776957703,
    "a": -20.7419369215699,
    "b": 11.1811156915828,
    "C": 23.5636435078904,
    "h": -0.49440397173354,
    "CMY_C": 0.7581406,
    "CMY_M": 0.6008594,
    "CMY_Y": 0.7114458,
    "CMYK_C": 0.3940496,
    "CMYK_M": 0,
    "CMYK_Y": 0.2770613,
    "CMYK_K": 0.6008594
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0753",
    "Farbtonhilfsbezeichnung": "Palm 45",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "100",
    "Bcolor": "82",
    "Y": 10,
    "L": 39.5803401391854,
    "a": -14.2178397284404,
    "b": 6.42519650188925,
    "C": 15.6022471660818,
    "h": -0.42444188091428,
    "CMY_C": 0.7184985,
    "CMY_M": 0.6096476,
    "CMY_Y": 0.6796803,
    "CMYK_C": 0.278853,
    "CMYK_M": 0,
    "CMYK_Y": 0.1794092,
    "CMYK_K": 0.6096476
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0754",
    "Farbtonhilfsbezeichnung": "Palm 50",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "114",
    "Bcolor": "85",
    "Y": 13,
    "L": 44.204751970402,
    "a": -21.5736661231861,
    "b": 10.7944609930097,
    "C": 24.1235042670901,
    "h": -0.46393042982507,
    "CMY_C": 0.723017,
    "CMY_M": 0.5536078,
    "CMY_Y": 0.6659694,
    "CMYK_C": 0.3795077,
    "CMYK_M": 0,
    "CMYK_Y": 0.2517104,
    "CMYK_K": 0.5536078
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0755",
    "Farbtonhilfsbezeichnung": "Palm 55",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "128",
    "Bcolor": "97",
    "Y": 17,
    "L": 49.4973983173088,
    "a": -22.76742610673,
    "b": 11.205095781596,
    "C": 25.3753790710632,
    "h": -0.45735169516823,
    "CMY_C": 0.6816453,
    "CMY_M": 0.4989389,
    "CMY_Y": 0.6190768,
    "CMYK_C": 0.364639,
    "CMYK_M": 0,
    "CMYK_Y": 0.2397671,
    "CMYK_K": 0.4989389
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0756",
    "Farbtonhilfsbezeichnung": "Palm 60",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "125",
    "Bcolor": "104",
    "Y": 18,
    "L": 49.4512712895599,
    "a": -15.1645729664984,
    "b": 7.12272489451147,
    "C": 16.7540288641016,
    "h": -0.43911108519513,
    "CMY_C": 0.6305744,
    "CMY_M": 0.5113179,
    "CMY_Y": 0.5914561,
    "CMYK_C": 0.244037,
    "CMYK_M": 0,
    "CMYK_Y": 0.1639884,
    "CMYK_K": 0.5113179
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0757",
    "Farbtonhilfsbezeichnung": "Palm 65",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "109",
    "Bcolor": "69",
    "Y": 11,
    "L": 41.0673542638545,
    "a": -30.3331998283498,
    "b": 15.7864238045783,
    "C": 34.1952363402325,
    "h": -0.47986073367835,
    "CMY_C": 0.8252939,
    "CMY_M": 0.5727345,
    "CMY_Y": 0.728613,
    "CMYK_C": 0.5911064,
    "CMYK_M": 0,
    "CMYK_Y": 0.364828,
    "CMYK_K": 0.5727345
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0758",
    "Farbtonhilfsbezeichnung": "Palm 70",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "116",
    "Bcolor": "75",
    "Y": 13,
    "L": 43.8521534667507,
    "a": -29.3965851852051,
    "b": 16.2532928302926,
    "C": 33.5906050612111,
    "h": -0.50506491034396,
    "CMY_C": 0.7835087,
    "CMY_M": 0.5464432,
    "CMY_Y": 0.7062321,
    "CMYK_C": 0.5226811,
    "CMYK_M": 0,
    "CMYK_Y": 0.3523019,
    "CMYK_K": 0.5464432
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0759",
    "Farbtonhilfsbezeichnung": "Palm 75",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "128",
    "Bcolor": "88",
    "Y": 17,
    "L": 48.8380102107406,
    "a": -29.0458821039968,
    "b": 15.4660178663425,
    "C": 32.9068530224527,
    "h": -0.48928378719223,
    "CMY_C": 0.7332976,
    "CMY_M": 0.4966845,
    "CMY_Y": 0.6546794,
    "CMYK_C": 0.470109,
    "CMYK_M": 0,
    "CMYK_Y": 0.3139083,
    "CMYK_K": 0.4966845
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0760",
    "Farbtonhilfsbezeichnung": "Mint 5",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "146",
    "Bcolor": "140",
    "Y": 27,
    "L": 59.6200561523438,
    "a": -3.5683000087738,
    "b": 1.60366797447205,
    "C": 3.91209864616394,
    "h": 155.799865722656,
    "CMY_C": 0.45813947916031,
    "CMY_M": 0.42937767505646,
    "CMY_Y": 0.45275694131851,
    "CMYK_C": 0.05040427297354,
    "CMYK_M": 0,
    "CMYK_Y": 0.04097152501345,
    "CMYK_K": 0.42937767505646
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0761",
    "Farbtonhilfsbezeichnung": "Mint 10",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "170",
    "Bcolor": "164",
    "Y": 39,
    "L": 68.8852996826172,
    "a": -4.00329971313477,
    "b": 1.65578067302704,
    "C": 4.33220720291138,
    "h": 157.529815673828,
    "CMY_C": 0.36583453416824,
    "CMY_M": 0.33210331201553,
    "CMY_Y": 0.35813897848129,
    "CMYK_C": 0.05050365254283,
    "CMYK_M": 0,
    "CMYK_Y": 0.03898157924414,
    "CMYK_K": 0.33210331201553
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0762",
    "Farbtonhilfsbezeichnung": "Mint 15",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "194",
    "Y": 58,
    "L": 80.3414764404297,
    "a": -3.53071331977844,
    "b": 1.89996099472046,
    "C": 4.00946235656738,
    "h": 151.714248657227,
    "CMY_C": 0.23958337306976,
    "CMY_M": 0.21042639017105,
    "CMY_Y": 0.2386708855629,
    "CMYK_C": 0.03692750260234,
    "CMYK_M": 0,
    "CMYK_Y": 0.03577183187008,
    "CMYK_K": 0.21042639017105
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0763",
    "Farbtonhilfsbezeichnung": "Mint 20",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "214",
    "Bcolor": "207",
    "Y": 67,
    "L": 85.2197647094727,
    "a": -2.63564944267273,
    "b": 2.05619835853577,
    "C": 3.3428430557251,
    "h": 142.040481567383,
    "CMY_C": 0.17891454696655,
    "CMY_M": 0.15910172462463,
    "CMY_Y": 0.18697041273117,
    "CMYK_C": 0.02356149628758,
    "CMYK_M": 0,
    "CMYK_Y": 0.03314156830311,
    "CMYK_K": 0.15910172462463
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0764",
    "Farbtonhilfsbezeichnung": "Mint 25",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 76,
    "L": 89.6709060668945,
    "a": -1.59832894802094,
    "b": 1.74355614185333,
    "C": 2.36529994010925,
    "h": 132.511672973633,
    "CMY_C": 0.12269020080566,
    "CMY_M": 0.1121581196785,
    "CMY_Y": 0.13585942983627,
    "CMYK_C": 0.01186256390065,
    "CMYK_M": 0,
    "CMYK_Y": 0.02669541724026,
    "CMYK_K": 0.1121581196785
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0765",
    "Farbtonhilfsbezeichnung": "Mint 30",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 83,
    "L": 92.6985092163086,
    "a": -0.58348977565765,
    "b": 2.25297689437866,
    "C": 2.32730865478516,
    "h": 104.519790649414,
    "CMY_C": 0.07917869091034,
    "CMY_M": 0.08090680837631,
    "CMY_Y": 0.10609120130539,
    "CMYK_C": 0,
    "CMYK_M": 0.00187671312597,
    "CMYK_Y": 0.02922663651407,
    "CMYK_K": 0.07917869091034
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0766",
    "Farbtonhilfsbezeichnung": "Mint 35",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "125",
    "Bcolor": "112",
    "Y": 19,
    "L": 50.9674911499023,
    "a": -7.77424335479736,
    "b": 4.61212205886841,
    "C": 9.03938770294189,
    "h": 149.321166992188,
    "CMY_C": 0.5661877989769,
    "CMY_M": 0.50917345285416,
    "CMY_Y": 0.55927675962448,
    "CMYK_C": 0.11615986377001,
    "CMYK_M": 0,
    "CMYK_Y": 0.10207945853472,
    "CMYK_K": 0.50917345285416
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0767",
    "Farbtonhilfsbezeichnung": "Mint 40",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "140",
    "Bcolor": "119",
    "Y": 23,
    "L": 55.6476898193359,
    "a": -14.5528802871704,
    "b": 7.57284069061279,
    "C": 16.4053115844727,
    "h": 152.509017944336,
    "CMY_C": 0.56352853775024,
    "CMY_M": 0.44987773895264,
    "CMY_Y": 0.53418588638306,
    "CMYK_C": 0.2065918892622,
    "CMYK_M": 0,
    "CMYK_Y": 0.15325348079205,
    "CMYK_K": 0.44987773895264
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0768",
    "Farbtonhilfsbezeichnung": "Mint 45",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "162",
    "Bcolor": "144",
    "Y": 33,
    "L": 64.3401107788086,
    "a": -11.5507116317749,
    "b": 5.65113019943237,
    "C": 12.8590126037598,
    "h": 153.930038452148,
    "CMY_C": 0.45857882499695,
    "CMY_M": 0.36528539657593,
    "CMY_Y": 0.43370300531387,
    "CMYK_C": 0.14698484539986,
    "CMYK_M": 0,
    "CMYK_Y": 0.10779271274805,
    "CMYK_K": 0.36528539657593
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0769",
    "Farbtonhilfsbezeichnung": "Mint 50",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "179",
    "Bcolor": "170",
    "Y": 43,
    "L": 71.4615478515625,
    "a": -7.65527582168579,
    "b": 1.7945249080658,
    "C": 7.86279630661011,
    "h": 166.80712890625,
    "CMY_C": 0.36718088388443,
    "CMY_M": 0.29705989360809,
    "CMY_Y": 0.33268648386002,
    "CMYK_C": 0.09975386410952,
    "CMYK_M": 0,
    "CMYK_Y": 0.05068225413561,
    "CMYK_K": 0.29705989360809
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0770",
    "Farbtonhilfsbezeichnung": "Mint 55",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "204",
    "Bcolor": "192",
    "Y": 58,
    "L": 80.4527969360352,
    "a": -7.57292366027832,
    "b": 3.22244620323181,
    "C": 8.23002624511719,
    "h": 156.949188232422,
    "CMY_C": 0.26611590385437,
    "CMY_M": 0.20064824819565,
    "CMY_Y": 0.24757742881775,
    "CMYK_C": 0.08190093189478,
    "CMYK_M": 0,
    "CMYK_Y": 0.05870904773474,
    "CMYK_K": 0.20064824819565
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0771",
    "Farbtonhilfsbezeichnung": "Mint 60",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "229",
    "Bcolor": "219",
    "Y": 78,
    "L": 90.2232971191406,
    "a": -3.74388313293457,
    "b": 3.03548979759216,
    "C": 4.81983995437622,
    "h": 140.965316772461,
    "CMY_C": 0.12926959991455,
    "CMY_M": 0.1013885140419,
    "CMY_Y": 0.13963598012924,
    "CMYK_C": 0.03102685324848,
    "CMYK_M": 0,
    "CMYK_Y": 0.04256284981966,
    "CMYK_K": 0.1013885140419
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0772",
    "Farbtonhilfsbezeichnung": "Mint 65",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "136",
    "Bcolor": "96",
    "Y": 19,
    "L": 51.1570775669917,
    "a": -32.9901556271714,
    "b": 14.224016870175,
    "C": 35.9259380424229,
    "h": -0.40707615543797,
    "CMY_C": 0.761623,
    "CMY_M": 0.4670357,
    "CMY_Y": 0.624909,
    "CMYK_C": 0.5527336,
    "CMYK_M": 0,
    "CMYK_Y": 0.2962173,
    "CMYK_K": 0.4670357
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0773",
    "Farbtonhilfsbezeichnung": "Mint 70",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "132",
    "Bcolor": "102",
    "Y": 18,
    "L": 51.0395812928234,
    "a": -24.0235500445001,
    "b": 10.6155805094284,
    "C": 26.2644532837209,
    "h": -0.41608273760333,
    "CMY_C": 0.6809517,
    "CMY_M": 0.4812094,
    "CMY_Y": 0.6005821,
    "CMYK_C": 0.3850152,
    "CMYK_M": 0,
    "CMYK_Y": 0.2300981,
    "CMYK_K": 0.4812094
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0774",
    "Farbtonhilfsbezeichnung": "Mint 75",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "158",
    "Bcolor": "119",
    "Y": 27,
    "L": 60.1985619890934,
    "a": -28.5525723970112,
    "b": 13.6252967433544,
    "C": 31.6369736515841,
    "h": -0.44524207020375,
    "CMY_C": 0.6219358,
    "CMY_M": 0.3798587,
    "CMY_Y": 0.5326625,
    "CMYK_C": 0.390358,
    "CMYK_M": 0,
    "CMYK_Y": 0.2464015,
    "CMYK_K": 0.3798587
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0775",
    "Farbtonhilfsbezeichnung": "Mint 80",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "185",
    "Bcolor": "151",
    "Y": 41,
    "L": 70.4332299039954,
    "a": -26.400847089028,
    "b": 10.7435061101513,
    "C": 28.5031165060436,
    "h": -0.38647300725234,
    "CMY_C": 0.5079517,
    "CMY_M": 0.2740235,
    "CMY_Y": 0.4091294,
    "CMYK_C": 0.3222255,
    "CMYK_M": 0,
    "CMYK_Y": 0.1861023,
    "CMYK_K": 0.2740235
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0776",
    "Farbtonhilfsbezeichnung": "Mint 85",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "180",
    "Bcolor": "154",
    "Y": 41,
    "L": 69.9505556404552,
    "a": -18.3453765489324,
    "b": 8.21543431959584,
    "C": 20.100900521661,
    "h": -0.4210399120024,
    "CMY_C": 0.448854,
    "CMY_M": 0.2934094,
    "CMY_Y": 0.3951087,
    "CMYK_C": 0.2199925,
    "CMYK_M": 0,
    "CMYK_Y": 0.1439296,
    "CMYK_K": 0.2934094
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0777",
    "Farbtonhilfsbezeichnung": "Mint 90",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "229",
    "Bcolor": "209",
    "Y": 77,
    "L": 88.5194815300049,
    "a": -11.5988987850225,
    "b": 5.78482199768582,
    "C": 12.961428106891,
    "h": -0.46263821854019,
    "CMY_C": 0.2028654,
    "CMY_M": 0.1036275,
    "CMY_Y": 0.1797,
    "CMYK_C": 0.1107105,
    "CMYK_M": 0,
    "CMYK_Y": 0.08486707,
    "CMYK_K": 0.1036275
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0778",
    "Farbtonhilfsbezeichnung": "Patina 5",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "146",
    "Bcolor": "139",
    "Y": 27,
    "L": 58.4203262329102,
    "a": -10.6128644943237,
    "b": -0.02062238752842,
    "C": 10.6128845214844,
    "h": 180.111343383789,
    "CMY_C": 0.53135299682617,
    "CMY_M": 0.42712032794952,
    "CMY_Y": 0.45471155643463,
    "CMYK_C": 0.181945130229,
    "CMYK_M": 0,
    "CMYK_Y": 0.04816234484315,
    "CMYK_K": 0.42712032794952
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0779",
    "Farbtonhilfsbezeichnung": "Patina 10",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "176",
    "Bcolor": "169",
    "Y": 41,
    "L": 70.1443786621094,
    "a": -8.10658645629883,
    "b": 0.34607490897179,
    "C": 8.11396980285645,
    "h": 177.55549621582,
    "CMY_C": 0.38983368873596,
    "CMY_M": 0.30974942445755,
    "CMY_Y": 0.33634150028229,
    "CMYK_C": 0.11602202057838,
    "CMYK_M": 0,
    "CMYK_Y": 0.03852524980903,
    "CMYK_K": 0.30974942445755
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0780",
    "Farbtonhilfsbezeichnung": "Patina 15",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "189",
    "Bcolor": "184",
    "Y": 49,
    "L": 75.3513488769531,
    "a": -6.11585474014282,
    "b": 0.22330389916897,
    "C": 6.11993026733398,
    "h": 177.908935546875,
    "CMY_C": 0.31945890188217,
    "CMY_M": 0.25827759504318,
    "CMY_Y": 0.28029578924179,
    "CMYK_C": 0.08248545229435,
    "CMYK_M": 0,
    "CMYK_Y": 0.02968522161245,
    "CMYK_K": 0.25827759504318
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0781",
    "Farbtonhilfsbezeichnung": "Patina 20",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "202",
    "Bcolor": "196",
    "Y": 57,
    "L": 80.2468032836914,
    "a": -5.597327709198,
    "b": 0.57152456045151,
    "C": 5.62643051147461,
    "h": 174.169921875,
    "CMY_C": 0.26175767183304,
    "CMY_M": 0.20650339126587,
    "CMY_Y": 0.23037457466125,
    "CMYK_C": 0.06963392347097,
    "CMYK_M": 0,
    "CMYK_Y": 0.0300835352391,
    "CMYK_K": 0.20650339126587
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0782",
    "Farbtonhilfsbezeichnung": "Patina 25",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "214",
    "Bcolor": "211",
    "Y": 67,
    "L": 85.1713104248047,
    "a": -2.69772911071777,
    "b": 0.17881867289543,
    "C": 2.70364904403687,
    "h": 176.207702636719,
    "CMY_C": 0.18643206357956,
    "CMY_M": 0.15897238254547,
    "CMY_Y": 0.17379105091095,
    "CMYK_C": 0.03265015408397,
    "CMYK_M": 0,
    "CMYK_Y": 0.01761971600354,
    "CMYK_K": 0.15897238254547
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0783",
    "Farbtonhilfsbezeichnung": "Patina 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 83,
    "L": 92.7701644897461,
    "a": -0.70140308141708,
    "b": 1.49322009086609,
    "C": 1.64974927902222,
    "h": 115.160621643066,
    "CMY_C": 0.08189189434052,
    "CMY_M": 0.07961040735245,
    "CMY_Y": 0.0996652841568,
    "CMYK_C": 0.00247882748954,
    "CMYK_M": 0,
    "CMYK_Y": 0.0217895526439,
    "CMYK_K": 0.07961040735245
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0784",
    "Farbtonhilfsbezeichnung": "Patina 35",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "85",
    "Bcolor": "82",
    "Y": 8,
    "L": 35.0708198547363,
    "a": -4.07742595672607,
    "b": -0.22568079829216,
    "C": 4.08366680145264,
    "h": 183.168029785156,
    "CMY_C": 0.70517098903656,
    "CMY_M": 0.66854679584503,
    "CMY_Y": 0.67840683460236,
    "CMYK_C": 0.11049582064152,
    "CMYK_M": 0,
    "CMYK_Y": 0.02974790520966,
    "CMYK_K": 0.66854679584503
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0785",
    "Farbtonhilfsbezeichnung": "Patina 40",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "86",
    "Bcolor": "81",
    "Y": 8,
    "L": 34.9339447021484,
    "a": -8.94778728485107,
    "b": 0.2369299530983,
    "C": 8.95092391967773,
    "h": 178.483215332031,
    "CMY_C": 0.74109065532684,
    "CMY_M": 0.66128128767014,
    "CMY_Y": 0.68304443359375,
    "CMYK_C": 0.23562137782574,
    "CMYK_M": 0,
    "CMYK_Y": 0.06425138562918,
    "CMYK_K": 0.66128128767014
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0786",
    "Farbtonhilfsbezeichnung": "Patina 45",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "110",
    "Bcolor": "104",
    "Y": 14,
    "L": 44.5204620361328,
    "a": -8.82098770141602,
    "b": -0.14725263416767,
    "C": 8.82221698760986,
    "h": 180.95637512207,
    "CMY_C": 0.65259730815887,
    "CMY_M": 0.56973469257355,
    "CMY_Y": 0.5906023979187,
    "CMYK_C": 0.19258493185043,
    "CMYK_M": 0,
    "CMYK_Y": 0.04849962517619,
    "CMYK_K": 0.56973469257355
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0787",
    "Farbtonhilfsbezeichnung": "Patina 50",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "152",
    "Bcolor": "146",
    "Y": 30,
    "L": 61.3703765869141,
    "a": -6.68079471588135,
    "b": 0.3715940117836,
    "C": 6.69112110137939,
    "h": 176.81640625,
    "CMY_C": 0.46844989061356,
    "CMY_M": 0.40462535619736,
    "CMY_Y": 0.4269837141037,
    "CMYK_C": 0.10720062255859,
    "CMYK_M": 0,
    "CMYK_Y": 0.03755342587829,
    "CMYK_K": 0.40462535619736
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0788",
    "Farbtonhilfsbezeichnung": "Patina 55",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "192",
    "Bcolor": "186",
    "Y": 50,
    "L": 75.9505081176758,
    "a": -8.59588623046875,
    "b": -0.4341781437397,
    "C": 8.60684394836426,
    "h": 182.891555786133,
    "CMY_C": 0.33589434623718,
    "CMY_M": 0.24634724855423,
    "CMY_Y": 0.26954656839371,
    "CMYK_C": 0.11881744861603,
    "CMYK_M": 0,
    "CMYK_Y": 0.03078250586987,
    "CMYK_K": 0.24634724855423
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0789",
    "Farbtonhilfsbezeichnung": "Patina 60",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.3889846801758,
    "a": -7.8848557472229,
    "b": 0.51249587535858,
    "C": 7.90149354934692,
    "h": 176.281143188477,
    "CMY_C": 0.23606759309769,
    "CMY_M": 0.15607476234436,
    "CMY_Y": 0.18543750047684,
    "CMYK_C": 0.09478662908077,
    "CMYK_M": 0,
    "CMYK_Y": 0.03479305654764,
    "CMYK_K": 0.15607476234436
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0790",
    "Farbtonhilfsbezeichnung": "Patina 65",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "89",
    "Bcolor": "78",
    "Y": 8,
    "L": 34.1870269775391,
    "a": -18.8408050537109,
    "b": 0.52842485904694,
    "C": 18.8482131958008,
    "h": 178.393463134766,
    "CMY_C": 0.83880031108856,
    "CMY_M": 0.65275049209595,
    "CMY_Y": 0.69268482923508,
    "CMYK_C": 0.5357813835144,
    "CMYK_M": 0,
    "CMYK_Y": 0.11500185728073,
    "CMYK_K": 0.65275049209595
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0791",
    "Farbtonhilfsbezeichnung": "Patina 75",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "163",
    "Bcolor": "153",
    "Y": 33,
    "L": 64.38525390625,
    "a": -13.213924407959,
    "b": 0.62286961078644,
    "C": 13.2285966873169,
    "h": 177.301223754883,
    "CMY_C": 0.49078381061554,
    "CMY_M": 0.36034709215164,
    "CMY_Y": 0.39864951372147,
    "CMYK_C": 0.20391796529293,
    "CMYK_M": 0,
    "CMYK_Y": 0.05988000705838,
    "CMYK_K": 0.36034709215164
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0792",
    "Farbtonhilfsbezeichnung": "Patina 85",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "209",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.3818435668945,
    "a": -17.9651908874512,
    "b": 0.53518551588058,
    "C": 17.9731616973877,
    "h": 178.293655395508,
    "CMY_C": 0.36750537157059,
    "CMY_M": 0.17914408445358,
    "CMY_Y": 0.23024165630341,
    "CMYK_C": 0.22946937382221,
    "CMYK_M": 0,
    "CMYK_Y": 0.06224913522601,
    "CMYK_K": 0.17914408445358
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0793",
    "Farbtonhilfsbezeichnung": "Patina 90",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "236",
    "Bcolor": "229",
    "Y": 82,
    "L": 92.6793518066406,
    "a": -3.62295436859131,
    "b": 1.73048281669617,
    "C": 4.01501798629761,
    "h": 154.468795776367,
    "CMY_C": 0.10555571317673,
    "CMY_M": 0.07384645938873,
    "CMY_Y": 0.10284382104874,
    "CMYK_C": 0.03423757851124,
    "CMYK_M": 0,
    "CMYK_Y": 0.03130945563316,
    "CMYK_K": 0.07384645938873
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0794",
    "Farbtonhilfsbezeichnung": "Patina 95",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "116",
    "Bcolor": "101",
    "Y": 13,
    "L": 44.018367767334,
    "a": -28.09397315979,
    "b": 0.70798510313034,
    "C": 28.1028919219971,
    "h": 178.556411743164,
    "CMY_C": 0.86704754829407,
    "CMY_M": 0.54377782344818,
    "CMY_Y": 0.60293483734131,
    "CMYK_C": 0.70857959985733,
    "CMYK_M": 0,
    "CMYK_Y": 0.12966711819172,
    "CMYK_K": 0.54377782344818
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0795",
    "Farbtonhilfsbezeichnung": "Patina 100",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "130",
    "Bcolor": "114",
    "Y": 17,
    "L": 49.2999114990234,
    "a": -28.7865600585938,
    "b": 0.89295369386673,
    "C": 28.8004055023193,
    "h": 178.223266601563,
    "CMY_C": 0.81323838233948,
    "CMY_M": 0.48957550525665,
    "CMY_Y": 0.55330544710159,
    "CMYK_C": 0.63410532474518,
    "CMYK_M": 0,
    "CMYK_Y": 0.12485674768686,
    "CMYK_K": 0.48957550525665
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0796",
    "Farbtonhilfsbezeichnung": "Patina 105",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "156",
    "Bcolor": "137",
    "Y": 26,
    "L": 58.1958503723145,
    "a": -34.6832618713379,
    "b": 0.62234944105148,
    "C": 34.6888465881348,
    "h": 178.97200012207,
    "CMY_C": 0.81183761358261,
    "CMY_M": 0.38862293958664,
    "CMY_Y": 0.46399283409119,
    "CMYK_C": 0.69223183393478,
    "CMYK_M": 0,
    "CMYK_Y": 0.12327890843153,
    "CMYK_K": 0.38862293958664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0797",
    "Farbtonhilfsbezeichnung": "Patina 110",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "153",
    "Bcolor": "137",
    "Y": 27,
    "L": 58.429069519043,
    "a": -24.9321212768555,
    "b": 0.84727412462234,
    "C": 24.9465141296387,
    "h": 178.053649902344,
    "CMY_C": 0.66443628072739,
    "CMY_M": 0.40161639451981,
    "CMY_Y": 0.46214807033539,
    "CMYK_C": 0.43921637535095,
    "CMYK_M": 0,
    "CMYK_Y": 0.10115864872932,
    "CMYK_K": 0.40161639451981
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0798",
    "Farbtonhilfsbezeichnung": "Patina 115",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "185",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.3455810546875,
    "a": -31.4656486511231,
    "b": 1.05722188949585,
    "C": 31.4834041595459,
    "h": 178.075622558594,
    "CMY_C": 0.62655341625214,
    "CMY_M": 0.2748504281044,
    "CMY_Y": 0.35245901346207,
    "CMYK_C": 0.48500752449036,
    "CMYK_M": 0,
    "CMYK_Y": 0.10702424496412,
    "CMYK_K": 0.2748504281044
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0799",
    "Farbtonhilfsbezeichnung": "Patina 120",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "181",
    "Bcolor": "166",
    "Y": 41,
    "L": 69.5692596435547,
    "a": -22.0860748291016,
    "b": 1.31946396827698,
    "C": 22.1254539489746,
    "h": 176.581100463867,
    "CMY_C": 0.51698541641235,
    "CMY_M": 0.28889483213425,
    "CMY_Y": 0.35089999437332,
    "CMYK_C": 0.32075506448746,
    "CMYK_M": 0,
    "CMYK_Y": 0.08719548583031,
    "CMYK_K": 0.28889483213425
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0800",
    "Farbtonhilfsbezeichnung": "Verona 5",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "174",
    "Bcolor": "173",
    "Y": 42,
    "L": 70.9392700195313,
    "a": -1.16115081310272,
    "b": -0.36032482981682,
    "C": 1.21577346324921,
    "h": 197.240005493164,
    "CMY_C": 0.32923847436905,
    "CMY_M": 0.31607913970947,
    "CMY_Y": 0.32215249538422,
    "CMYK_C": 0.01924102008343,
    "CMYK_M": 0,
    "CMYK_Y": 0.00888020265847,
    "CMYK_K": 0.31607913970947
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0801",
    "Farbtonhilfsbezeichnung": "Verona 10",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "201",
    "Bcolor": "198",
    "Y": 58,
    "L": 80.8934936523438,
    "a": -0.94829022884369,
    "b": 0.47744587063789,
    "C": 1.06170094013214,
    "h": 153.275619506836,
    "CMY_C": 0.21821254491806,
    "CMY_M": 0.20989030599594,
    "CMY_Y": 0.2221103310585,
    "CMYK_C": 0.01053301710635,
    "CMYK_M": 0,
    "CMYK_Y": 0.01546623837203,
    "CMYK_K": 0.20989030599594
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0802",
    "Farbtonhilfsbezeichnung": "Verona 15",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "210",
    "Bcolor": "206",
    "Y": 64,
    "L": 83.9249114990234,
    "a": -1.71275854110718,
    "b": 0.90136128664017,
    "C": 1.93545699119568,
    "h": 152.243835449219,
    "CMY_C": 0.18973964452744,
    "CMY_M": 0.17513114213943,
    "CMY_Y": 0.19248884916306,
    "CMYK_C": 0.01771009154618,
    "CMYK_M": 0,
    "CMYK_Y": 0.02104298956692,
    "CMYK_K": 0.17513114213943
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0803",
    "Farbtonhilfsbezeichnung": "Verona 20",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "215",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.9617385864258,
    "a": -0.59907710552216,
    "b": 0.1801592707634,
    "C": 0.62558031082153,
    "h": 163.262496948242,
    "CMY_C": 0.16110974550247,
    "CMY_M": 0.15511471033096,
    "CMY_Y": 0.16488909721375,
    "CMYK_C": 0.00709567964077,
    "CMYK_M": 0,
    "CMYK_Y": 0.01156889181584,
    "CMYK_K": 0.15511471033096
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0804",
    "Farbtonhilfsbezeichnung": "Verona 25",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "223",
    "Y": 78,
    "L": 90.7401885986328,
    "a": -0.81423765420914,
    "b": 1.73731911182404,
    "C": 1.91866111755371,
    "h": 115.111297607422,
    "CMY_C": 0.10461282730103,
    "CMY_M": 0.10209113359451,
    "CMY_Y": 0.12393015623093,
    "CMYK_C": 0.00280840718187,
    "CMYK_M": 0,
    "CMYK_Y": 0.02432209253311,
    "CMYK_K": 0.10209113359451
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0805",
    "Farbtonhilfsbezeichnung": "Verona 30",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "235",
    "Bcolor": "229",
    "Y": 83,
    "L": 92.7073059082031,
    "a": -0.77797108888626,
    "b": 1.90672492980957,
    "C": 2.05932974815369,
    "h": 112.196166992188,
    "CMY_C": 0.08179432153702,
    "CMY_M": 0.08024972677231,
    "CMY_Y": 0.10344690084457,
    "CMYK_C": 0.00167936319485,
    "CMYK_M": 0,
    "CMYK_Y": 0.02522116526961,
    "CMYK_K": 0.08024972677231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0806",
    "Farbtonhilfsbezeichnung": "Verona 35",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "100",
    "Bcolor": "101",
    "Y": 11,
    "L": 41.719970703125,
    "a": -3.27359414100647,
    "b": -2.14814519882202,
    "C": 3.91547513008118,
    "h": 213.273040771484,
    "CMY_C": 0.64395332336426,
    "CMY_M": 0.60675859451294,
    "CMY_Y": 0.60397756099701,
    "CMYK_C": 0.10094317793846,
    "CMYK_M": 0.00702241389081,
    "CMYK_Y": 0,
    "CMYK_K": 0.60397756099701
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0807",
    "Farbtonhilfsbezeichnung": "Verona 40",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "150",
    "Bcolor": "149",
    "Y": 30,
    "L": 61.4621124267578,
    "a": -3.09870982170105,
    "b": -1.0760463476181,
    "C": 3.28022527694702,
    "h": 199.149871826172,
    "CMY_C": 0.4448082447052,
    "CMY_M": 0.41073828935623,
    "CMY_Y": 0.41571015119553,
    "CMYK_C": 0.05781803652644,
    "CMYK_M": 0,
    "CMYK_Y": 0.00843744259328,
    "CMYK_K": 0.41073828935623
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0808",
    "Farbtonhilfsbezeichnung": "Verona 45",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "183",
    "Bcolor": "182",
    "Y": 47,
    "L": 73.8687744140625,
    "a": -2.66786742210388,
    "b": -0.81933122873306,
    "C": 2.79084587097168,
    "h": 197.072296142578,
    "CMY_C": 0.31147390604019,
    "CMY_M": 0.28143054246902,
    "CMY_Y": 0.28817844390869,
    "CMYK_C": 0.04180996492505,
    "CMYK_M": 0,
    "CMYK_Y": 0.00939074344933,
    "CMYK_K": 0.28143054246902
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0809",
    "Farbtonhilfsbezeichnung": "Verona 50",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "196",
    "Bcolor": "193",
    "Y": 55,
    "L": 78.8291854858398,
    "a": -1.53731203079224,
    "b": 0.12077133357525,
    "C": 1.54204869270325,
    "h": 175.508056640625,
    "CMY_C": 0.24634718894958,
    "CMY_M": 0.23085325956345,
    "CMY_Y": 0.24182343482971,
    "CMYK_C": 0.0201443079859,
    "CMYK_M": 0,
    "CMYK_Y": 0.01426278613508,
    "CMYK_K": 0.23085325956345
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0810",
    "Farbtonhilfsbezeichnung": "Verona 55",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "217",
    "Bcolor": "215",
    "Y": 68,
    "L": 86.2425765991211,
    "a": -2.66010522842407,
    "b": -0.35245421528816,
    "C": 2.68335318565369,
    "h": 187.547515869141,
    "CMY_C": 0.17627680301666,
    "CMY_M": 0.14709877967834,
    "CMY_Y": 0.15819877386093,
    "CMYK_C": 0.03421032056212,
    "CMYK_M": 0,
    "CMYK_Y": 0.01301439572126,
    "CMYK_K": 0.14709877967834
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0811",
    "Farbtonhilfsbezeichnung": "Verona 60",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "227",
    "Bcolor": "222",
    "Y": 77,
    "L": 89.4211959838867,
    "a": -3.01696276664734,
    "b": 0.58910691738129,
    "C": 3.07394075393677,
    "h": 168.951171875,
    "CMY_C": 0.1408224105835,
    "CMY_M": 0.11131703853607,
    "CMY_Y": 0.13028031587601,
    "CMYK_C": 0.03320123627782,
    "CMYK_M": 0,
    "CMYK_Y": 0.02133863046765,
    "CMYK_K": 0.11131703853607
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0812",
    "Farbtonhilfsbezeichnung": "Verona 65",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "96",
    "Bcolor": "97",
    "Y": 10,
    "L": 37.8877792358398,
    "a": -14.1262464523315,
    "b": -5.81751394271851,
    "C": 15.2772483825684,
    "h": 202.382995605469,
    "CMY_C": 0.78878808021545,
    "CMY_M": 0.62330269813538,
    "CMY_Y": 0.61835384368896,
    "CMYK_C": 0.4465765953064,
    "CMYK_M": 0.0129671273753,
    "CMYK_Y": 0,
    "CMYK_K": 0.61835384368896
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0813",
    "Farbtonhilfsbezeichnung": "Verona 70",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "122",
    "Bcolor": "121",
    "Y": 17,
    "L": 49.3301239013672,
    "a": -8.41995906829834,
    "b": -3.08565020561218,
    "C": 8.96754932403564,
    "h": 200.12629699707,
    "CMY_C": 0.61465382575989,
    "CMY_M": 0.52239322662354,
    "CMY_Y": 0.52469551563263,
    "CMYK_C": 0.19317272305489,
    "CMYK_M": 0,
    "CMYK_Y": 0.00482046976686,
    "CMYK_K": 0.52239322662354
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0814",
    "Farbtonhilfsbezeichnung": "Verona 75",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "145",
    "Bcolor": "144",
    "Y": 27,
    "L": 58.6205291748047,
    "a": -6.32217168807983,
    "b": -2.44413948059082,
    "C": 6.77817630767822,
    "h": 201.136413574219,
    "CMY_C": 0.50362825393677,
    "CMY_M": 0.43290895223618,
    "CMY_Y": 0.43575400114059,
    "CMYK_C": 0.12470537424088,
    "CMYK_M": 0,
    "CMYK_Y": 0.00501691736281,
    "CMYK_K": 0.43290895223618
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0815",
    "Farbtonhilfsbezeichnung": "Verona 80",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "178",
    "Bcolor": "176",
    "Y": 43,
    "L": 71.430305480957,
    "a": -5.01738882064819,
    "b": -1.53823781013489,
    "C": 5.24789142608643,
    "h": 197.044570922852,
    "CMY_C": 0.35835838317871,
    "CMY_M": 0.30211037397385,
    "CMY_Y": 0.30918395519257,
    "CMYK_C": 0.08059728145599,
    "CMYK_M": 0,
    "CMYK_Y": 0.01013567298651,
    "CMYK_K": 0.30211037397385
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0816",
    "Farbtonhilfsbezeichnung": "Verona 85",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "216",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.3452835083008,
    "a": -5.17188501358032,
    "b": -0.61463338136673,
    "C": 5.20827865600586,
    "h": 186.777313232422,
    "CMY_C": 0.20742350816727,
    "CMY_M": 0.15122854709625,
    "CMY_Y": 0.16642427444458,
    "CMYK_C": 0.06620740890503,
    "CMYK_M": 0,
    "CMYK_Y": 0.01790320314467,
    "CMYK_K": 0.15122854709625
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0817",
    "Farbtonhilfsbezeichnung": "Verona 90",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "236",
    "Bcolor": "230",
    "Y": 82,
    "L": 92.1259155273438,
    "a": -5.68376302719116,
    "b": 0.03449042886496,
    "C": 5.68386745452881,
    "h": 179.652328491211,
    "CMY_C": 0.13476365804672,
    "CMY_M": 0.0748398900032,
    "CMY_Y": 0.09664994478226,
    "CMYK_C": 0.06477124243975,
    "CMYK_M": 0,
    "CMYK_Y": 0.02357435785234,
    "CMYK_K": 0.0748398900032
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0818",
    "Farbtonhilfsbezeichnung": "Verona 95",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "128",
    "Bcolor": "131",
    "Y": 18,
    "L": 49.5664863586426,
    "a": -21.0963611602783,
    "b": -8.78481006622314,
    "C": 22.8523368835449,
    "h": 202.607513427734,
    "CMY_C": 0.77595150470734,
    "CMY_M": 0.49643194675446,
    "CMY_Y": 0.48614579439163,
    "CMYK_C": 0.56398433446884,
    "CMYK_M": 0.02001764811575,
    "CMYK_Y": 0,
    "CMYK_K": 0.48614579439163
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0819",
    "Farbtonhilfsbezeichnung": "Verona 100",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "124",
    "Bcolor": "126",
    "Y": 18,
    "L": 49.5967483520508,
    "a": -12.2626056671143,
    "b": -5.34898567199707,
    "C": 13.3784580230713,
    "h": 203.566970825195,
    "CMY_C": 0.65541434288025,
    "CMY_M": 0.51208305358887,
    "CMY_Y": 0.5076054930687,
    "CMYK_C": 0.30018380284309,
    "CMYK_M": 0.00909344106913,
    "CMYK_Y": 0,
    "CMYK_K": 0.5076054930687
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0820",
    "Farbtonhilfsbezeichnung": "Verona 105",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "153",
    "Bcolor": "154",
    "Y": 28,
    "L": 59.6429481506348,
    "a": -17.4679489135742,
    "b": -6.99954795837402,
    "C": 18.8181533813477,
    "h": 201.836364746094,
    "CMY_C": 0.61524188518524,
    "CMY_M": 0.39991581439972,
    "CMY_Y": 0.39556086063385,
    "CMYK_C": 0.3634460568428,
    "CMYK_M": 0.0072049498558,
    "CMYK_Y": 0,
    "CMYK_K": 0.39556086063385
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0821",
    "Farbtonhilfsbezeichnung": "Verona 110",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "179",
    "Bcolor": "179",
    "Y": 43,
    "L": 70.9022369384766,
    "a": -9.94301509857178,
    "b": -4.19196605682373,
    "C": 10.7905578613281,
    "h": 202.860244750977,
    "CMY_C": 0.41530823707581,
    "CMY_M": 0.29667562246323,
    "CMY_Y": 0.29666829109192,
    "CMYK_C": 0.16868278384209,
    "CMYK_M": 1.042377517e-05,
    "CMYK_Y": 0,
    "CMYK_K": 0.29666829109192
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0822",
    "Farbtonhilfsbezeichnung": "Verona 115",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "209",
    "Bcolor": "205",
    "Y": 59,
    "L": 81.1933517456055,
    "a": -12.1873598098755,
    "b": -2.86541962623596,
    "C": 12.519679069519,
    "h": 193.230743408203,
    "CMY_C": 0.32093960046768,
    "CMY_M": 0.1810849905014,
    "CMY_Y": 0.19613307714462,
    "CMYK_C": 0.17078037559986,
    "CMYK_M": 0,
    "CMYK_Y": 0.01837563887239,
    "CMYK_K": 0.1810849905014
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0823",
    "Farbtonhilfsbezeichnung": "Verona 120",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "232",
    "Bcolor": "228",
    "Y": 78,
    "L": 90.113151550293,
    "a": -8.96526527404785,
    "b": -1.58418607711792,
    "C": 9.10415458679199,
    "h": 190.020874023438,
    "CMY_C": 0.19092893600464,
    "CMY_M": 0.08956241607666,
    "CMY_Y": 0.10737597942352,
    "CMYK_C": 0.11133824288845,
    "CMYK_M": 0,
    "CMYK_Y": 0.01956593617797,
    "CMYK_K": 0.08956241607666
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0824",
    "Farbtonhilfsbezeichnung": "Verona 125",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "113",
    "Y": 13,
    "L": 42.4652137756348,
    "a": -27.9155025482178,
    "b": -8.83545112609863,
    "C": 29.2803764343262,
    "h": 197.562942504883,
    "CMY_C": 1,
    "CMY_M": 0.55727916955948,
    "CMY_Y": 0.55642604827881,
    "CMYK_C": 1,
    "CMYK_M": 0.00192328984849,
    "CMYK_Y": 0,
    "CMYK_K": 0.55642604827881
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0825",
    "Farbtonhilfsbezeichnung": "Verona 135",
    "Farbtonklasse": "04",
    "Rcolor": "14",
    "Gcolor": "144",
    "Bcolor": "149",
    "Y": 22,
    "L": 54.1842269897461,
    "a": -28.9837188720703,
    "b": -12.1893510818481,
    "C": 31.4425868988037,
    "h": 202.809600830078,
    "CMY_C": 0.94350647926331,
    "CMY_M": 0.43592745065689,
    "CMY_Y": 0.41750860214233,
    "CMYK_C": 0.9030140042305,
    "CMYK_M": 0.03162080794573,
    "CMYK_Y": 0,
    "CMYK_K": 0.41750860214233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0826",
    "Farbtonhilfsbezeichnung": "Verona 145",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "198",
    "Bcolor": "196",
    "Y": 50,
    "L": 75.377571105957,
    "a": -22.8409767150879,
    "b": -7.04587936401367,
    "C": 23.9030246734619,
    "h": 197.143707275391,
    "CMY_C": 0.50898188352585,
    "CMY_M": 0.2225056886673,
    "CMY_Y": 0.2301145195961,
    "CMYK_C": 0.36846083402634,
    "CMYK_M": 0,
    "CMYK_Y": 0.00978634972125,
    "CMYK_K": 0.2225056886673
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0827",
    "Farbtonhilfsbezeichnung": "Arctis 5",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "107",
    "Bcolor": "111",
    "Y": 14,
    "L": 44.8174934387207,
    "a": -2.26308059692383,
    "b": -3.38862204551697,
    "C": 4.07483673095703,
    "h": 236.263153076172,
    "CMY_C": 0.61133742332458,
    "CMY_M": 0.57854551076889,
    "CMY_Y": 0.56615269184113,
    "CMYK_C": 0.10414892435074,
    "CMYK_M": 0.0285649318248,
    "CMYK_Y": 0,
    "CMYK_K": 0.56615269184113
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0828",
    "Farbtonhilfsbezeichnung": "Arctis 10",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "133",
    "Bcolor": "137",
    "Y": 22,
    "L": 54.9464569091797,
    "a": -2.20615530014038,
    "b": -3.74388957023621,
    "C": 4.34555292129517,
    "h": 239.490509033203,
    "CMY_C": 0.51306992769241,
    "CMY_M": 0.47832816839218,
    "CMY_Y": 0.46369409561157,
    "CMYK_C": 0.09206654876471,
    "CMYK_M": 0.02728680148721,
    "CMYK_Y": 0,
    "CMYK_K": 0.46369409561157
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0829",
    "Farbtonhilfsbezeichnung": "Arctis 15",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "162",
    "Bcolor": "164",
    "Y": 35,
    "L": 66.1853637695313,
    "a": -2.24890398979187,
    "b": -2.4822998046875,
    "C": 3.34953451156616,
    "h": 227.824172973633,
    "CMY_C": 0.3946168422699,
    "CMY_M": 0.36314034461975,
    "CMY_Y": 0.35719388723373,
    "CMYK_C": 0.05821810662746,
    "CMYK_M": 0.00925077870488,
    "CMYK_Y": 0,
    "CMYK_K": 0.35719388723373
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0830",
    "Farbtonhilfsbezeichnung": "Arctis 20",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "189",
    "Bcolor": "189",
    "Y": 50,
    "L": 75.856315612793,
    "a": -2.740394115448,
    "b": -1.97243273258209,
    "C": 3.37642574310303,
    "h": 215.744918823242,
    "CMY_C": 0.29499858617783,
    "CMY_M": 0.25964033603668,
    "CMY_Y": 0.25883150100708,
    "CMYK_C": 0.04879738762975,
    "CMYK_M": 0.00109129713383,
    "CMYK_Y": 0,
    "CMYK_K": 0.25883150100708
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0831",
    "Farbtonhilfsbezeichnung": "Arctis 25",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "216",
    "Bcolor": "215",
    "Y": 67,
    "L": 85.7406616210938,
    "a": -2.07095575332642,
    "b": -1.51654815673828,
    "C": 2.56686115264893,
    "h": 216.215087890625,
    "CMY_C": 0.1812030673027,
    "CMY_M": 0.15365815162659,
    "CMY_Y": 0.1550959944725,
    "CMYK_C": 0.0325458496809,
    "CMYK_M": 0,
    "CMYK_Y": 0.00169889139943,
    "CMYK_K": 0.15365815162659
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0832",
    "Farbtonhilfsbezeichnung": "Arctis 30",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "227",
    "Bcolor": "224",
    "Y": 77,
    "L": 89.8082275390625,
    "a": -1.11409819126129,
    "b": 0.10931357741356,
    "C": 1.11944818496704,
    "h": 174.39616394043,
    "CMY_C": 0.12295180559158,
    "CMY_M": 0.11130249500275,
    "CMY_Y": 0.12221330404282,
    "CMYK_C": 0.01310829631984,
    "CMYK_M": 0,
    "CMYK_Y": 0.01227730326355,
    "CMYK_K": 0.11130249500275
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0833",
    "Farbtonhilfsbezeichnung": "Arctis 35",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "125",
    "Bcolor": "133",
    "Y": 18,
    "L": 50.6813316345215,
    "a": -7.4749436378479,
    "b": -8.11655902862549,
    "C": 11.0341882705688,
    "h": 227.356475830078,
    "CMY_C": 0.6150643825531,
    "CMY_M": 0.50938320159912,
    "CMY_Y": 0.47808593511581,
    "CMYK_C": 0.26245403289795,
    "CMYK_M": 0.0599663220346,
    "CMYK_Y": 0,
    "CMYK_K": 0.47808593511581
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0834",
    "Farbtonhilfsbezeichnung": "Arctis 40",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 18,
    "L": 49.7656288146973,
    "a": -4.33045959472656,
    "b": -5.44619989395142,
    "C": 6.95801496505737,
    "h": 231.510589599609,
    "CMY_C": 0.58685320615768,
    "CMY_M": 0.5253484249115,
    "CMY_Y": 0.50445866584778,
    "CMYK_C": 0.16627177596092,
    "CMYK_M": 0.04215543344617,
    "CMYK_Y": 0,
    "CMYK_K": 0.50445866584778
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0835",
    "Farbtonhilfsbezeichnung": "Arctis 45",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "146",
    "Bcolor": "150",
    "Y": 27,
    "L": 59.4474601745605,
    "a": -4.70788764953613,
    "b": -4.63731908798218,
    "C": 6.60824728012085,
    "h": 224.567352294922,
    "CMY_C": 0.49074226617813,
    "CMY_M": 0.42713260650635,
    "CMY_Y": 0.41225665807724,
    "CMYK_C": 0.13353721797466,
    "CMYK_M": 0.02531027980149,
    "CMYK_Y": 0,
    "CMYK_K": 0.41225665807724
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0836",
    "Farbtonhilfsbezeichnung": "Arctis 50",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "175",
    "Bcolor": "177",
    "Y": 42,
    "L": 70.5445251464844,
    "a": -3.84749054908752,
    "b": -3.15581202507019,
    "C": 4.97617673873901,
    "h": 219.359497070312,
    "CMY_C": 0.36422806978226,
    "CMY_M": 0.31359314918518,
    "CMY_Y": 0.30700325965881,
    "CMYK_C": 0.08257587254047,
    "CMYK_M": 0.0095092644915,
    "CMYK_Y": 0,
    "CMYK_K": 0.30700325965881
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0837",
    "Farbtonhilfsbezeichnung": "Arctis 55",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "203",
    "Bcolor": "203",
    "Y": 58,
    "L": 80.9452972412109,
    "a": -2.98341250419617,
    "b": -1.94002962112427,
    "C": 3.55871677398682,
    "h": 213.034820556641,
    "CMY_C": 0.24222588539124,
    "CMY_M": 0.20401853322983,
    "CMY_Y": 0.20435440540314,
    "CMYK_C": 0.04800030216575,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004219597904,
    "CMYK_K": 0.20401853322983
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0838",
    "Farbtonhilfsbezeichnung": "Arctis 60",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 79,
    "L": 91.2136993408203,
    "a": -2.29163265228271,
    "b": -0.55508613586426,
    "C": 2.35790181159973,
    "h": 193.616104125977,
    "CMY_C": 0.11917573213577,
    "CMY_M": 0.09269380569458,
    "CMY_Y": 0.10192537307739,
    "CMYK_C": 0.02918741852045,
    "CMYK_M": 0,
    "CMYK_Y": 0.01017469912767,
    "CMYK_K": 0.09269380569458
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0839",
    "Farbtonhilfsbezeichnung": "Arctis 65",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "151",
    "Bcolor": "158",
    "Y": 29,
    "L": 60.4552001953125,
    "a": -8.71125793457031,
    "b": -7.66612672805786,
    "C": 11.6041164398193,
    "h": 221.348587036133,
    "CMY_C": 0.5267186164856,
    "CMY_M": 0.40783870220184,
    "CMY_Y": 0.38171917200089,
    "CMYK_C": 0.23452036082745,
    "CMYK_M": 0.04224541410804,
    "CMYK_Y": 0,
    "CMYK_K": 0.38171917200089
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0840",
    "Farbtonhilfsbezeichnung": "Arctis 70",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "178",
    "Bcolor": "182",
    "Y": 42,
    "L": 70.6077575683594,
    "a": -7.73843908309937,
    "b": -6.04431867599487,
    "C": 9.81922721862793,
    "h": 217.992584228516,
    "CMY_C": 0.40715783834457,
    "CMY_M": 0.30384290218353,
    "CMY_Y": 0.28649562597275,
    "CMYK_C": 0.16911208629608,
    "CMYK_M": 0.02431278117001,
    "CMYK_Y": 0,
    "CMYK_K": 0.28649562597275
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0841",
    "Farbtonhilfsbezeichnung": "Arctis 80",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "204",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.812141418457,
    "a": -5.6995701789856,
    "b": -4.32888650894165,
    "C": 7.1571192741394,
    "h": 217.217071533203,
    "CMY_C": 0.27499091625214,
    "CMY_M": 0.19874060153961,
    "CMY_Y": 0.18888115882874,
    "CMYK_C": 0.10616170614958,
    "CMYK_M": 0.01215536147356,
    "CMYK_Y": 0,
    "CMYK_K": 0.18888115882874
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0842",
    "Farbtonhilfsbezeichnung": "Arctis 90",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "218",
    "Bcolor": "219",
    "Y": 67,
    "L": 85.8617630004883,
    "a": -5.43705415725708,
    "b": -3.45388913154602,
    "C": 6.44134378433228,
    "h": 212.425750732422,
    "CMY_C": 0.21474570035934,
    "CMY_M": 0.14412432909012,
    "CMY_Y": 0.14003348350525,
    "CMYK_C": 0.08687805384398,
    "CMYK_M": 0.00475698243827,
    "CMYK_Y": 0,
    "CMYK_K": 0.14003348350525
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0843",
    "Farbtonhilfsbezeichnung": "Arctis 95",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "116",
    "Bcolor": "127",
    "Y": 15,
    "L": 45.871711730957,
    "a": -13.3148908615112,
    "b": -12.1487321853638,
    "C": 18.0243721008301,
    "h": 222.377853393555,
    "CMY_C": 0.74146938323975,
    "CMY_M": 0.54535633325577,
    "CMY_Y": 0.50028902292252,
    "CMYK_C": 0.48263970017433,
    "CMYK_M": 0.09018675237894,
    "CMYK_Y": 0,
    "CMYK_K": 0.50028902292252
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0844",
    "Farbtonhilfsbezeichnung": "Arctis 100",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "138",
    "Bcolor": "148",
    "Y": 23,
    "L": 55.2288818359375,
    "a": -10.14111328125,
    "b": -10.0354738235474,
    "C": 14.2671966552734,
    "h": 224.700012207031,
    "CMY_C": 0.60343289375305,
    "CMY_M": 0.45795130729675,
    "CMY_Y": 0.41955482959747,
    "CMYK_C": 0.31678798794746,
    "CMYK_M": 0.06615005433559,
    "CMYK_Y": 0,
    "CMYK_K": 0.41955482959747
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0845",
    "Farbtonhilfsbezeichnung": "Arctis 105",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "167",
    "Bcolor": "175",
    "Y": 35,
    "L": 66.0302658081055,
    "a": -10.9079761505127,
    "b": -9.24191570281982,
    "C": 14.2967462539673,
    "h": 220.273345947266,
    "CMY_C": 0.49718308448792,
    "CMY_M": 0.34491056203842,
    "CMY_Y": 0.31290864944458,
    "CMYK_C": 0.26819494366646,
    "CMYK_M": 0.04657592251897,
    "CMYK_Y": 0,
    "CMYK_K": 0.31290864944458
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0846",
    "Farbtonhilfsbezeichnung": "Arctis 110",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "195",
    "Bcolor": "209",
    "Y": 48,
    "L": 74.6182403564453,
    "a": -19.3473320007324,
    "b": -15.1718416213989,
    "C": 24.5866641998291,
    "h": 218.102935791016,
    "CMY_C": 0.52916473150253,
    "CMY_M": 0.23496156930923,
    "CMY_Y": 0.17994177341461,
    "CMYK_C": 0.4258514046669,
    "CMYK_M": 0.06709254533052,
    "CMYK_Y": 0,
    "CMYK_K": 0.17994177341461
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0847",
    "Farbtonhilfsbezeichnung": "Arctis 115",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "208",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.7139053344727,
    "a": -11.8432836532593,
    "b": -8.94198989868164,
    "C": 14.8398971557617,
    "h": 217.053756713867,
    "CMY_C": 0.35036408901215,
    "CMY_M": 0.18531370162964,
    "CMY_Y": 0.15732979774475,
    "CMYK_C": 0.22907453775406,
    "CMYK_M": 0.03320860862732,
    "CMYK_Y": 0,
    "CMYK_K": 0.15732979774475
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0848",
    "Farbtonhilfsbezeichnung": "Coelin 5",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "183",
    "Bcolor": "185",
    "Y": 46,
    "L": 73.8086929321289,
    "a": -1.75936710834503,
    "b": -2.78785181045532,
    "C": 3.29658770561218,
    "h": 237.744659423828,
    "CMY_C": 0.3119438290596,
    "CMY_M": 0.28354287147522,
    "CMY_Y": 0.27474641799927,
    "CMYK_C": 0.05128883570433,
    "CMYK_M": 0.01212879735976,
    "CMYK_Y": 0,
    "CMYK_K": 0.27474641799927
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0849",
    "Farbtonhilfsbezeichnung": "Coelin 10",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "196",
    "Bcolor": "198",
    "Y": 54,
    "L": 78.8206481933594,
    "a": -1.39038121700287,
    "b": -2.25298023223877,
    "C": 2.6474666595459,
    "h": 238.320022583008,
    "CMY_C": 0.25356352329254,
    "CMY_M": 0.23061269521713,
    "CMY_Y": 0.22484236955643,
    "CMYK_C": 0.03705201670527,
    "CMYK_M": 0.0074440673925,
    "CMYK_Y": 0,
    "CMYK_K": 0.22484236955643
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0850",
    "Farbtonhilfsbezeichnung": "Coelin 15",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "208",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.2991561889648,
    "a": -1.08606040477753,
    "b": -1.32522344589233,
    "C": 1.71340143680573,
    "h": 230.664352416992,
    "CMY_C": 0.19934546947479,
    "CMY_M": 0.18280565738678,
    "CMY_Y": 0.18301087617874,
    "CMYK_C": 0.02023975364864,
    "CMYK_M": 0,
    "CMYK_Y": 0.00025112606818,
    "CMYK_K": 0.18280565738678
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0851",
    "Farbtonhilfsbezeichnung": "Coelin 20",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "223",
    "Bcolor": "221",
    "Y": 73,
    "L": 88.5249252319336,
    "a": -0.67547702789307,
    "b": -0.06205622851849,
    "C": 0.67832159996033,
    "h": 185.249038696289,
    "CMY_C": 0.13427305221558,
    "CMY_M": 0.12653487920761,
    "CMY_Y": 0.13502371311188,
    "CMYK_C": 0.00885916687548,
    "CMYK_M": 0,
    "CMYK_Y": 0.00971857272089,
    "CMYK_K": 0.12653487920761
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0852",
    "Farbtonhilfsbezeichnung": "Coelin 25",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 82,
    "L": 92.6459884643555,
    "a": -1.25613927841187,
    "b": -0.36753091216087,
    "C": 1.30880284309387,
    "h": 196.308837890625,
    "CMY_C": 0.09419512748718,
    "CMY_M": 0.07915717363358,
    "CMY_Y": 0.08728700876236,
    "CMYK_C": 0.01633064076304,
    "CMYK_M": 0,
    "CMYK_Y": 0.00882868934423,
    "CMYK_K": 0.07915717363358
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0853",
    "Farbtonhilfsbezeichnung": "Coelin 35",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "177",
    "Bcolor": "183",
    "Y": 42,
    "L": 71.3102493286133,
    "a": -4.15838003158569,
    "b": -5.64397048950195,
    "C": 7.01045846939087,
    "h": 233.617858886719,
    "CMY_C": 0.36821258068085,
    "CMY_M": 0.30408602952957,
    "CMY_Y": 0.28143262863159,
    "CMYK_C": 0.1207680106163,
    "CMYK_M": 0.03152578696609,
    "CMYK_Y": 0,
    "CMYK_K": 0.28143262863159
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0854",
    "Farbtonhilfsbezeichnung": "Coelin 45",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "204",
    "Bcolor": "207",
    "Y": 59,
    "L": 81.1333694458008,
    "a": -3.35611605644226,
    "b": -4.03325939178467,
    "C": 5.24697017669678,
    "h": 230.235824584961,
    "CMY_C": 0.2509902715683,
    "CMY_M": 0.20052939653397,
    "CMY_Y": 0.18723261356354,
    "CMYK_C": 0.07844515144825,
    "CMYK_M": 0.01635988801718,
    "CMYK_Y": 0,
    "CMYK_K": 0.18723261356354
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0855",
    "Farbtonhilfsbezeichnung": "Coelin 50",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "216",
    "Bcolor": "218",
    "Y": 68,
    "L": 85.6007614135742,
    "a": -2.50565791130066,
    "b": -2.98172235488892,
    "C": 3.89473867416382,
    "h": 229.958343505859,
    "CMY_C": 0.19159722328186,
    "CMY_M": 0.15377926826477,
    "CMY_Y": 0.14597457647324,
    "CMYK_C": 0.05342071130872,
    "CMYK_M": 0.00913871172816,
    "CMYK_Y": 0,
    "CMYK_K": 0.14597457647324
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0856",
    "Farbtonhilfsbezeichnung": "Coelin 55",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "230",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.6209716796875,
    "a": -2.62783455848694,
    "b": -1.7320784330368,
    "C": 3.14731788635254,
    "h": 213.38996887207,
    "CMY_C": 0.1327508687973,
    "CMY_M": 0.0981884598732,
    "CMY_Y": 0.0998227596283,
    "CMYK_C": 0.03832553327084,
    "CMYK_M": 0,
    "CMYK_Y": 0.00181224092375,
    "CMYK_K": 0.0981884598732
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0857",
    "Farbtonhilfsbezeichnung": "Coelin 65",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "168",
    "Bcolor": "183",
    "Y": 37,
    "L": 66.4428176879883,
    "a": -10.9172630310059,
    "b": -12.9568958282471,
    "C": 16.9430751800537,
    "h": 229.883071899414,
    "CMY_C": 0.51205611228943,
    "CMY_M": 0.33944368362427,
    "CMY_Y": 0.2827120423317,
    "CMYK_C": 0.31973779201508,
    "CMYK_M": 0.07909186184406,
    "CMYK_Y": 0,
    "CMYK_K": 0.2827120423317
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0858",
    "Farbtonhilfsbezeichnung": "Coelin 70",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "180",
    "Bcolor": "195",
    "Y": 42,
    "L": 70.6487350463867,
    "a": -10.9952239990234,
    "b": -13.4558124542236,
    "C": 17.3768196105957,
    "h": 230.746505737305,
    "CMY_C": 0.4716369509697,
    "CMY_M": 0.29453760385513,
    "CMY_Y": 0.23424559831619,
    "CMYK_C": 0.31000977754593,
    "CMYK_M": 0.07873543351889,
    "CMYK_Y": 0,
    "CMYK_K": 0.23424559831619
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0859",
    "Farbtonhilfsbezeichnung": "Coelin 80",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "207",
    "Bcolor": "219",
    "Y": 59,
    "L": 80.7323684692383,
    "a": -9.60453128814697,
    "b": -10.9056062698364,
    "C": 14.5320081710815,
    "h": 228.629745483398,
    "CMY_C": 0.33874499797821,
    "CMY_M": 0.18922603130341,
    "CMY_Y": 0.1426659822464,
    "CMYK_C": 0.2287078499794,
    "CMYK_M": 0.05430794507265,
    "CMYK_Y": 0,
    "CMYK_K": 0.1426659822464
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0860",
    "Farbtonhilfsbezeichnung": "Coelin 85",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "218",
    "Bcolor": "228",
    "Y": 66,
    "L": 85.0161285400391,
    "a": -8.93609237670898,
    "b": -9.46870517730713,
    "C": 13.0196056365967,
    "h": 226.657608032227,
    "CMY_C": 0.27976721525192,
    "CMY_M": 0.14398288726807,
    "CMY_Y": 0.10579687356949,
    "CMYK_C": 0.19455349445343,
    "CMYK_M": 0.04270396009088,
    "CMYK_Y": 0,
    "CMYK_K": 0.10579687356949
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0861",
    "Farbtonhilfsbezeichnung": "Coelin 90",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "231",
    "Bcolor": "235",
    "Y": 77,
    "L": 90.147087097168,
    "a": -6.73984527587891,
    "b": -5.23102998733521,
    "C": 8.53165817260742,
    "h": 217.816299438477,
    "CMY_C": 0.18606781959534,
    "CMY_M": 0.0930762887001,
    "CMY_Y": 0.07973694801331,
    "CMYK_C": 0.11554399877787,
    "CMYK_M": 0.01449513901025,
    "CMYK_Y": 0,
    "CMYK_K": 0.07973694801331
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0862",
    "Farbtonhilfsbezeichnung": "Coelin 95",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "117",
    "Bcolor": "145",
    "Y": 14,
    "L": 45.28271484375,
    "a": -18.1660823822021,
    "b": -23.9399242401123,
    "C": 30.0520629882813,
    "h": 232.808059692383,
    "CMY_C": 1,
    "CMY_M": 0.53945881128311,
    "CMY_Y": 0.4298397898674,
    "CMYK_C": 1,
    "CMYK_M": 0.19226002693176,
    "CMYK_Y": 0,
    "CMYK_K": 0.4298397898674
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0863",
    "Farbtonhilfsbezeichnung": "Coelin 100",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "147",
    "Bcolor": "172",
    "Y": 24,
    "L": 56.4398307800293,
    "a": -19.3737297058106,
    "b": -22.0673561096191,
    "C": 29.3651084899902,
    "h": 228.718933105469,
    "CMY_C": 0.80759388208389,
    "CMY_M": 0.42523211240768,
    "CMY_Y": 0.32666438817978,
    "CMYK_C": 0.71424931287766,
    "CMYK_M": 0.14638721942902,
    "CMYK_Y": 0,
    "CMYK_K": 0.32666438817978
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0864",
    "Farbtonhilfsbezeichnung": "Coelin 105",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "173",
    "Bcolor": "196",
    "Y": 37,
    "L": 66.705940246582,
    "a": -17.5058116912842,
    "b": -19.9124011993408,
    "C": 26.5133399963379,
    "h": 228.679962158203,
    "CMY_C": 0.62923789024353,
    "CMY_M": 0.32185858488083,
    "CMY_Y": 0.23201441764832,
    "CMYK_C": 0.51722776889801,
    "CMYK_M": 0.1169867888093,
    "CMYK_Y": 0,
    "CMYK_K": 0.23201441764832
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0865",
    "Farbtonhilfsbezeichnung": "Coelin 110",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "198",
    "Bcolor": "221",
    "Y": 50,
    "L": 76.0229110717773,
    "a": -16.9500160217285,
    "b": -19.5324478149414,
    "C": 25.8615455627441,
    "h": 229.048965454102,
    "CMY_C": 0.51580035686493,
    "CMY_M": 0.22293621301651,
    "CMY_Y": 0.13311898708344,
    "CMYK_C": 0.44144624471664,
    "CMYK_M": 0.10360963642597,
    "CMYK_Y": 0,
    "CMYK_K": 0.13311898708344
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0866",
    "Farbtonhilfsbezeichnung": "Coelin 115",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "210",
    "Bcolor": "230",
    "Y": 58,
    "L": 80.5259780883789,
    "a": -16.076265335083,
    "b": -17.226318359375,
    "C": 23.562520980835,
    "h": 226.977828979492,
    "CMY_C": 0.44082576036453,
    "CMY_M": 0.17617523670197,
    "CMY_Y": 0.09987443685532,
    "CMYK_C": 0.37878194451332,
    "CMYK_M": 0.08476684242487,
    "CMYK_Y": 0,
    "CMYK_K": 0.09987443685532
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0867",
    "Farbtonhilfsbezeichnung": "Pacific 5",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "75",
    "Bcolor": "80",
    "Y": 6,
    "L": 31.4322986602783,
    "a": -2.21751666069031,
    "b": -4.4595193862915,
    "C": 4.9804310798645,
    "h": 243.560928344727,
    "CMY_C": 0.73920345306396,
    "CMY_M": 0.70449805259705,
    "CMY_Y": 0.68577718734741,
    "CMYK_C": 0.17002668976784,
    "CMYK_M": 0.05957831442356,
    "CMYK_Y": 0,
    "CMYK_K": 0.68577718734741
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0868",
    "Farbtonhilfsbezeichnung": "Pacific 10",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "96",
    "Bcolor": "102",
    "Y": 11,
    "L": 40.3654708862305,
    "a": -1.90556907653809,
    "b": -4.73745584487915,
    "C": 5.10633754730225,
    "h": 248.088302612305,
    "CMY_C": 0.6557309627533,
    "CMY_M": 0.62169480323792,
    "CMY_Y": 0.60036909580231,
    "CMYK_C": 0.13853248953819,
    "CMYK_M": 0.05336350947618,
    "CMYK_Y": 0,
    "CMYK_K": 0.60036909580231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0869",
    "Farbtonhilfsbezeichnung": "Pacific 25",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "201",
    "Y": 58,
    "L": 80.7022552490234,
    "a": -0.81194967031479,
    "b": -1.04564726352692,
    "C": 1.32387328147888,
    "h": 232.170516967773,
    "CMY_C": 0.22444200515747,
    "CMY_M": 0.21185678243637,
    "CMY_Y": 0.21315813064575,
    "CMYK_C": 0.01596819236875,
    "CMYK_M": 0,
    "CMYK_Y": 0.00165115704294,
    "CMYK_K": 0.21185678243637
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0870",
    "Farbtonhilfsbezeichnung": "Pacific 30",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "218",
    "Y": 72,
    "L": 87.4374618530273,
    "a": -1.32081377506256,
    "b": -0.4130687713623,
    "C": 1.38389837741852,
    "h": 197.366455078125,
    "CMY_C": 0.15263849496841,
    "CMY_M": 0.13697153329849,
    "CMY_Y": 0.14447909593582,
    "CMYK_C": 0.01815347000957,
    "CMYK_M": 0,
    "CMYK_Y": 0.00869909022003,
    "CMYK_K": 0.13697153329849
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0871",
    "Farbtonhilfsbezeichnung": "Pacific 35",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "99",
    "Bcolor": "109",
    "Y": 11,
    "L": 40.834831237793,
    "a": -4.155442237854,
    "b": -8.7201452255249,
    "C": 9.65963935852051,
    "h": 244.520629882812,
    "CMY_C": 0.68435448408127,
    "CMY_M": 0.61179703474045,
    "CMY_Y": 0.57089722156525,
    "CMYK_C": 0.26440578699112,
    "CMYK_M": 0.09531472623348,
    "CMYK_Y": 0,
    "CMYK_K": 0.57089722156525
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0872",
    "Farbtonhilfsbezeichnung": "Pacific 45",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "133",
    "Bcolor": "140",
    "Y": 22,
    "L": 54.7368774414063,
    "a": -3.73159193992615,
    "b": -6.07382917404175,
    "C": 7.12854671478271,
    "h": 238.434585571289,
    "CMY_C": 0.53566914796829,
    "CMY_M": 0.47665745019913,
    "CMY_Y": 0.45041143894196,
    "CMYK_C": 0.15513005852699,
    "CMYK_M": 0.04775574430823,
    "CMYK_Y": 0,
    "CMYK_K": 0.45041143894196
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0873",
    "Farbtonhilfsbezeichnung": "Pacific 50",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 55,
    "L": 78.2342147827148,
    "a": -1.83196723461151,
    "b": -2.74141359329224,
    "C": 3.29718852043152,
    "h": 236.246917724609,
    "CMY_C": 0.26511889696121,
    "CMY_M": 0.23581922054291,
    "CMY_Y": 0.22770982980728,
    "CMYK_C": 0.04843913391232,
    "CMYK_M": 0.01050044503063,
    "CMYK_Y": 0,
    "CMYK_K": 0.22770982980728
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0874",
    "Farbtonhilfsbezeichnung": "Pacific 65",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "162",
    "Bcolor": "168",
    "Y": 36,
    "L": 65.8329544067383,
    "a": -3.13982200622559,
    "b": -5.43562173843384,
    "C": 6.27729749679565,
    "h": 239.987640380859,
    "CMY_C": 0.41611754894257,
    "CMY_M": 0.36407697200775,
    "CMY_Y": 0.34051167964935,
    "CMYK_C": 0.1146432235837,
    "CMYK_M": 0.03573269024491,
    "CMYK_Y": 0,
    "CMYK_K": 0.34051167964935
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0875",
    "Farbtonhilfsbezeichnung": "Pacific 70",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "175",
    "Bcolor": "184",
    "Y": 42,
    "L": 70.3014831542969,
    "a": -4.29388809204102,
    "b": -7.44222068786621,
    "C": 8.59209632873535,
    "h": 240.016632080078,
    "CMY_C": 0.3870764374733,
    "CMY_M": 0.31397885084152,
    "CMY_Y": 0.27952527999878,
    "CMYK_C": 0.14927817881107,
    "CMYK_M": 0.04782065376639,
    "CMYK_Y": 0,
    "CMYK_K": 0.27952527999878
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0876",
    "Farbtonhilfsbezeichnung": "Pacific 75",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "176",
    "Bcolor": "184",
    "Y": 42,
    "L": 70.8378753662109,
    "a": -3.67265915870667,
    "b": -6.65773344039917,
    "C": 7.60354137420654,
    "h": 241.117202758789,
    "CMY_C": 0.37318044900894,
    "CMY_M": 0.30985969305038,
    "CMY_Y": 0.27926242351532,
    "CMYK_C": 0.13030821084976,
    "CMYK_M": 0.04245271906257,
    "CMYK_Y": 0,
    "CMYK_K": 0.27926242351532
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0877",
    "Farbtonhilfsbezeichnung": "Pacific 80",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "202",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.2831649780273,
    "a": -3.83293271064758,
    "b": -5.31461238861084,
    "C": 6.55259323120117,
    "h": 234.200622558594,
    "CMY_C": 0.26900213956833,
    "CMY_M": 0.20835310220718,
    "CMY_Y": 0.1872815489769,
    "CMYK_C": 0.10055215656757,
    "CMYK_M": 0.0259272493422,
    "CMYK_Y": 0,
    "CMYK_K": 0.1872815489769
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0878",
    "Farbtonhilfsbezeichnung": "Pacific 85",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "228",
    "Bcolor": "227",
    "Y": 78,
    "L": 89.859375,
    "a": -2.9625301361084,
    "b": -1.60265552997589,
    "C": 3.36824727058411,
    "h": 208.412292480469,
    "CMY_C": 0.14343512058258,
    "CMY_M": 0.10594022274017,
    "CMY_Y": 0.10925531387329,
    "CMYK_C": 0.04193779826164,
    "CMYK_M": 0,
    "CMYK_Y": 0.00370790762827,
    "CMYK_K": 0.10594022274017
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0879",
    "Farbtonhilfsbezeichnung": "Pacific 90",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 83,
    "L": 92.2826614379883,
    "a": -2.99727773666382,
    "b": -1.09411120414734,
    "C": 3.19072914123535,
    "h": 200.053848266602,
    "CMY_C": 0.11500334739685,
    "CMY_M": 0.07894092798233,
    "CMY_Y": 0.08616214990616,
    "CMYK_C": 0.03915321081877,
    "CMYK_M": 0,
    "CMYK_Y": 0.0078401286155,
    "CMYK_K": 0.07894092798233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0880",
    "Farbtonhilfsbezeichnung": "Pacific 95",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "71",
    "Bcolor": "90",
    "Y": 6,
    "L": 28.6338939666748,
    "a": -5.91024780273438,
    "b": -14.9945802688599,
    "C": 16.1173343658447,
    "h": 248.487670898438,
    "CMY_C": 0.8490446805954,
    "CMY_M": 0.72042274475098,
    "CMY_Y": 0.64856827259064,
    "CMYK_C": 0.57045620679855,
    "CMYK_M": 0.20446211099625,
    "CMYK_Y": 0,
    "CMYK_K": 0.64856827259064
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0881",
    "Farbtonhilfsbezeichnung": "Pacific 100",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "98",
    "Bcolor": "113",
    "Y": 11,
    "L": 39.7100639343262,
    "a": -7.19766235351563,
    "b": -12.4112730026245,
    "C": 14.3473358154297,
    "h": 239.889297485352,
    "CMY_C": 0.73985862731934,
    "CMY_M": 0.61588025093079,
    "CMY_Y": 0.55873560905457,
    "CMYK_C": 0.41046372056007,
    "CMYK_M": 0.12950204312801,
    "CMYK_Y": 0,
    "CMYK_K": 0.55873560905457
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0882",
    "Farbtonhilfsbezeichnung": "Pacific 105",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "154",
    "Bcolor": "167",
    "Y": 31,
    "L": 61.920051574707,
    "a": -5.81485080718994,
    "b": -10.954155921936,
    "C": 12.40185546875,
    "h": 242.0390625,
    "CMY_C": 0.50151968002319,
    "CMY_M": 0.3975618481636,
    "CMY_Y": 0.34369945526123,
    "CMYK_C": 0.24046944081783,
    "CMYK_M": 0.08206970989704,
    "CMYK_Y": 0,
    "CMYK_K": 0.34369945526123
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0883",
    "Farbtonhilfsbezeichnung": "Pacific 110",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "147",
    "Bcolor": "159",
    "Y": 29,
    "L": 59.7650184631348,
    "a": -4.56974649429321,
    "b": -9.45627689361572,
    "C": 10.5025596618652,
    "h": 244.20783996582,
    "CMY_C": 0.50604867935181,
    "CMY_M": 0.42278331518173,
    "CMY_Y": 0.37622052431107,
    "CMYK_C": 0.20813149213791,
    "CMYK_M": 0.07464623451233,
    "CMYK_Y": 0,
    "CMYK_K": 0.37622052431107
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0884",
    "Farbtonhilfsbezeichnung": "Pacific 115",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "204",
    "Bcolor": "216",
    "Y": 58,
    "L": 80.619499206543,
    "a": -6.22415733337402,
    "b": -9.61939811706543,
    "C": 11.457441329956,
    "h": 237.095428466797,
    "CMY_C": 0.3036133646965,
    "CMY_M": 0.19812476634979,
    "CMY_Y": 0.15281569957733,
    "CMYK_C": 0.17799864709377,
    "CMYK_M": 0.05348194763064,
    "CMYK_Y": 0,
    "CMYK_K": 0.15281569957733
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0885",
    "Farbtonhilfsbezeichnung": "Pacific 120",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "204",
    "Bcolor": "212",
    "Y": 59,
    "L": 80.635139465332,
    "a": -5.09385967254639,
    "b": -7.41218900680542,
    "C": 8.99377250671387,
    "h": 235.502090454102,
    "CMY_C": 0.28424775600433,
    "CMY_M": 0.20110040903091,
    "CMY_Y": 0.16845792531967,
    "CMYK_C": 0.13924710452557,
    "CMYK_M": 0.03925536200404,
    "CMYK_Y": 0,
    "CMYK_K": 0.16845792531967
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0886",
    "Farbtonhilfsbezeichnung": "Pacific 125",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "87",
    "Bcolor": "106",
    "Y": 8,
    "L": 34.9108047485352,
    "a": -8.85089683532715,
    "b": -15.727596282959,
    "C": 18.0470409393311,
    "h": 240.630828857422,
    "CMY_C": 0.8264582157135,
    "CMY_M": 0.65742969512939,
    "CMY_Y": 0.58460932970047,
    "CMYK_C": 0.58222031593323,
    "CMYK_M": 0.17530573904514,
    "CMYK_Y": 0,
    "CMYK_K": 0.58460932970047
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0887",
    "Farbtonhilfsbezeichnung": "Pacific 130",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "104",
    "Bcolor": "123",
    "Y": 11,
    "L": 41.3278503417969,
    "a": -10.9864740371704,
    "b": -16.7325611114502,
    "C": 20.0170230865479,
    "h": 236.711395263672,
    "CMY_C": 0.7947324514389,
    "CMY_M": 0.59238082170486,
    "CMY_Y": 0.51569128036499,
    "CMYK_C": 0.57616382837296,
    "CMYK_M": 0.15834845602512,
    "CMYK_Y": 0,
    "CMYK_K": 0.51569128036499
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0888",
    "Farbtonhilfsbezeichnung": "Pacific 135",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "125",
    "Bcolor": "142",
    "Y": 19,
    "L": 50.4222068786621,
    "a": -6.97265148162842,
    "b": -13.8117742538452,
    "C": 15.4720058441162,
    "h": 243.213806152344,
    "CMY_C": 0.64127039909363,
    "CMY_M": 0.51126092672348,
    "CMY_Y": 0.44308000802994,
    "CMYK_C": 0.35586869716644,
    "CMYK_M": 0.12242498248816,
    "CMYK_Y": 0,
    "CMYK_K": 0.44308000802994
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0889",
    "Farbtonhilfsbezeichnung": "Pacific 140",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "150",
    "Bcolor": "166",
    "Y": 29,
    "L": 60.2801475524902,
    "a": -6.68797731399536,
    "b": -12.5949201583862,
    "C": 14.2604713439941,
    "h": 242.031433105469,
    "CMY_C": 0.53370916843414,
    "CMY_M": 0.4122314453125,
    "CMY_Y": 0.34970164299011,
    "CMYK_C": 0.28295862674713,
    "CMYK_M": 0.09615556150675,
    "CMYK_Y": 0,
    "CMYK_K": 0.34970164299011
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0890",
    "Farbtonhilfsbezeichnung": "Pacific 145",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "177",
    "Bcolor": "190",
    "Y": 42,
    "L": 70.4842376708984,
    "a": -6.53798961639404,
    "b": -10.9429473876953,
    "C": 12.7472896575928,
    "h": 239.143310546875,
    "CMY_C": 0.41955256462097,
    "CMY_M": 0.30622529983521,
    "CMY_Y": 0.25322580337524,
    "CMYK_C": 0.22272698581219,
    "CMYK_M": 0.07097125053406,
    "CMYK_Y": 0,
    "CMYK_K": 0.25322580337524
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0891",
    "Farbtonhilfsbezeichnung": "Pacific 150",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "205",
    "Bcolor": "220",
    "Y": 59,
    "L": 80.5481338500977,
    "a": -8.02151107788086,
    "b": -11.7412929534912,
    "C": 14.2197961807251,
    "h": 235.659576416016,
    "CMY_C": 0.33015084266663,
    "CMY_M": 0.19436120986938,
    "CMY_Y": 0.13846784830093,
    "CMYK_C": 0.22249081730843,
    "CMYK_M": 0.06487669795752,
    "CMYK_Y": 0,
    "CMYK_K": 0.13846784830093
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0892",
    "Farbtonhilfsbezeichnung": "Pacific 155",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "117",
    "Bcolor": "147",
    "Y": 14,
    "L": 45.526050567627,
    "a": -15.0324993133545,
    "b": -24.2189464569092,
    "C": 28.5049724578857,
    "h": 238.172470092773,
    "CMY_C": 0.91756564378738,
    "CMY_M": 0.54206764698029,
    "CMY_Y": 0.42530477046967,
    "CMYK_C": 0.85655987262726,
    "CMYK_M": 0.20317356288433,
    "CMYK_Y": 0,
    "CMYK_K": 0.42530477046967
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0893",
    "Farbtonhilfsbezeichnung": "Pacific 160",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "128",
    "Bcolor": "150",
    "Y": 19,
    "L": 51.2382049560547,
    "a": -9.36022472381592,
    "b": -17.3763427734375,
    "C": 19.7370491027832,
    "h": 241.689697265625,
    "CMY_C": 0.67830419540405,
    "CMY_M": 0.49748653173447,
    "CMY_Y": 0.41137373447418,
    "CMYK_C": 0.45348036289215,
    "CMYK_M": 0.14629451930523,
    "CMYK_Y": 0,
    "CMYK_K": 0.41137373447418
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0894",
    "Farbtonhilfsbezeichnung": "Pacific 165",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "144",
    "Bcolor": "175",
    "Y": 24,
    "L": 56.0457077026367,
    "a": -14.8723726272583,
    "b": -24.3650665283203,
    "C": 28.5454711914063,
    "h": 238.600219726562,
    "CMY_C": 0.75815922021866,
    "CMY_M": 0.43639200925827,
    "CMY_Y": 0.31487673521042,
    "CMYK_C": 0.64701128005981,
    "CMYK_M": 0.17736265063286,
    "CMYK_Y": 0,
    "CMYK_K": 0.31487673521042
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0895",
    "Farbtonhilfsbezeichnung": "Pacific 170",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "154",
    "Bcolor": "175",
    "Y": 29,
    "L": 60.9699211120605,
    "a": -10.0739870071411,
    "b": -16.9766674041748,
    "C": 19.740629196167,
    "h": 239.315017700195,
    "CMY_C": 0.58324670791626,
    "CMY_M": 0.39704352617264,
    "CMY_Y": 0.31282758712769,
    "CMYK_C": 0.39352440834045,
    "CMYK_M": 0.12255430966616,
    "CMYK_Y": 0,
    "CMYK_K": 0.31282758712769
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0896",
    "Farbtonhilfsbezeichnung": "Pacific 175",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "170",
    "Bcolor": "197",
    "Y": 36,
    "L": 66.3855667114258,
    "a": -13.1073732376099,
    "b": -21.1998596191406,
    "C": 24.9246311187744,
    "h": 238.272476196289,
    "CMY_C": 0.58773756027222,
    "CMY_M": 0.33314388990402,
    "CMY_Y": 0.22607374191284,
    "CMYK_C": 0.46731042861938,
    "CMYK_M": 0.13834670186043,
    "CMYK_Y": 0,
    "CMYK_K": 0.22607374191284
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0897",
    "Farbtonhilfsbezeichnung": "Pacific 180",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "208",
    "Bcolor": "229",
    "Y": 58,
    "L": 80.564811706543,
    "a": -12.0756597518921,
    "b": -16.9732112884521,
    "C": 20.8305416107178,
    "h": 234.569900512695,
    "CMY_C": 0.39634394645691,
    "CMY_M": 0.18397569656372,
    "CMY_Y": 0.10086315870285,
    "CMYK_C": 0.32862716913223,
    "CMYK_M": 0.09243591874838,
    "CMYK_Y": 0,
    "CMYK_K": 0.10086315870285
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0898",
    "Farbtonhilfsbezeichnung": "Marin 5",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "177",
    "Bcolor": "188",
    "Y": 43,
    "L": 70.9891242742983,
    "a": -3.8534236992262,
    "b": -9.01136058826584,
    "C": 9.80068843793685,
    "h": 1.16670995345396,
    "CMY_C": 0.3827122,
    "CMY_M": 0.3071825,
    "CMY_Y": 0.2611153,
    "CMYK_C": 0.1645682,
    "CMYK_M": 0.0623469,
    "CMYK_Y": 0,
    "CMYK_K": 0.2611153
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0899",
    "Farbtonhilfsbezeichnung": "Marin 10",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "191",
    "Bcolor": "199",
    "Y": 51,
    "L": 76.4000558040353,
    "a": -3.35793543670032,
    "b": -6.64534084366681,
    "C": 7.44555473591821,
    "h": 1.10291235345951,
    "CMY_C": 0.3118545,
    "CMY_M": 0.2510923,
    "CMY_Y": 0.2197315,
    "CMYK_C": 0.1180658,
    "CMYK_M": 0.04019231,
    "CMYK_Y": 0,
    "CMYK_K": 0.2197315
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0900",
    "Farbtonhilfsbezeichnung": "Marin 15",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "203",
    "Bcolor": "208",
    "Y": 59,
    "L": 80.9501861656657,
    "a": -2.39209716484334,
    "b": -4.5418405973771,
    "C": 5.13326843814293,
    "h": 1.08603313814348,
    "CMY_C": 0.2470437,
    "CMY_M": 0.2045739,
    "CMY_Y": 0.1854278,
    "CMYK_C": 0.07564208,
    "CMYK_M": 0.02350446,
    "CMYK_Y": 0,
    "CMYK_K": 0.1854278
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0901",
    "Farbtonhilfsbezeichnung": "Marin 20",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "218",
    "Bcolor": "217",
    "Y": 68,
    "L": 86.3879074136465,
    "a": -1.95729004709655,
    "b": -1.42527753850408,
    "C": 2.42123943265169,
    "h": 0.62939546952763,
    "CMY_C": 0.1728785,
    "CMY_M": 0.1468326,
    "CMY_Y": 0.1486568,
    "CMYK_C": 0.03052848,
    "CMYK_M": 0,
    "CMYK_Y": 0.002138105,
    "CMYK_K": 0.1468326
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0902",
    "Farbtonhilfsbezeichnung": "Marin 30",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.4206060574512,
    "a": -0.83741779538215,
    "b": 1.8333544814757,
    "C": 2.01555382432962,
    "h": -1.14232834287403,
    "CMY_C": 0.08573547,
    "CMY_M": 0.08332784,
    "CMY_Y": 0.1060841,
    "CMYK_C": 0.002626484,
    "CMYK_M": 0,
    "CMYK_Y": 0.02482491,
    "CMYK_K": 0.08332784
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0903",
    "Farbtonhilfsbezeichnung": "Marin 35",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "121",
    "Bcolor": "139",
    "Y": 18,
    "L": 49.4022972118178,
    "a": -4.85701568332558,
    "b": -13.6053141016159,
    "C": 14.4462857908772,
    "h": 1.22790439890238,
    "CMY_C": 0.6309146,
    "CMY_M": 0.5255578,
    "CMY_Y": 0.4545783,
    "CMYK_C": 0.3233028,
    "CMYK_M": 0.1301368,
    "CMYK_Y": 0,
    "CMYK_K": 0.4545783
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0904",
    "Farbtonhilfsbezeichnung": "Marin 40",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "149",
    "Bcolor": "166",
    "Y": 28,
    "L": 60.4773848665773,
    "a": -4.75917863713082,
    "b": -12.3520647107779,
    "C": 13.2371932039752,
    "h": 1.20303130623504,
    "CMY_C": 0.513468,
    "CMY_M": 0.4142084,
    "CMY_Y": 0.3491026,
    "CMYK_C": 0.2525211,
    "CMYK_M": 0.1000247,
    "CMYK_Y": 0,
    "CMYK_K": 0.3491026
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0905",
    "Farbtonhilfsbezeichnung": "Marin 45",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "178",
    "Bcolor": "193",
    "Y": 43,
    "L": 71.1203963534837,
    "a": -4.79027829583073,
    "b": -11.387749034948,
    "C": 12.3542540946212,
    "h": 1.17261431396822,
    "CMY_C": 0.3996303,
    "CMY_M": 0.3030486,
    "CMY_Y": 0.2430828,
    "CMYK_C": 0.2068226,
    "CMYK_M": 0.07922381,
    "CMYK_Y": 0,
    "CMYK_K": 0.2430828
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0906",
    "Farbtonhilfsbezeichnung": "Marin 50",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "204",
    "Bcolor": "217",
    "Y": 59,
    "L": 80.6903332653282,
    "a": -5.14220591756781,
    "b": -9.9577641731214,
    "C": 11.2071115380445,
    "h": 1.09411365413602,
    "CMY_C": 0.2949007,
    "CMY_M": 0.1996385,
    "CMY_Y": 0.1494678,
    "CMYK_C": 0.1709905,
    "CMYK_M": 0.05898749,
    "CMYK_Y": 0,
    "CMYK_K": 0.1494678
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0907",
    "Farbtonhilfsbezeichnung": "Marin 55",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "217",
    "Bcolor": "225",
    "Y": 68,
    "L": 85.6967426304246,
    "a": -3.95045874839517,
    "b": -6.80232874175026,
    "C": 7.86624437922022,
    "h": 1.04465081065214,
    "CMY_C": 0.2173237,
    "CMY_M": 0.1483247,
    "CMY_Y": 0.1171666,
    "CMYK_C": 0.1134495,
    "CMYK_M": 0.03529323,
    "CMYK_Y": 0,
    "CMYK_K": 0.1171666
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0908",
    "Farbtonhilfsbezeichnung": "Marin 60",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "233",
    "Bcolor": "233",
    "Y": 80,
    "L": 91.3389010159866,
    "a": -3.41685544017767,
    "b": -2.29126797975361,
    "C": 4.11397740077846,
    "h": 0.59070554191542,
    "CMY_C": 0.1333665,
    "CMY_M": 0.08820837,
    "CMY_Y": 0.08782141,
    "CMYK_C": 0.04993005,
    "CMYK_M": 0.0004242117,
    "CMYK_Y": 0,
    "CMYK_K": 0.08782141
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0909",
    "Farbtonhilfsbezeichnung": "Marin 65",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "165",
    "Y": 17,
    "L": 48.0699896967125,
    "a": -16.3726024234451,
    "b": -30.9994025513732,
    "C": 35.057453824519,
    "h": 1.08487639082119,
    "CMY_C": 1,
    "CMY_M": 0.5121395,
    "CMY_Y": 0.3543861,
    "CMYK_C": 1,
    "CMYK_M": 0.2443463,
    "CMYK_Y": 0,
    "CMYK_K": 0.3543861
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0910",
    "Farbtonhilfsbezeichnung": "Marin 70",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "143",
    "Bcolor": "186",
    "Y": 24,
    "L": 55.7828607220318,
    "a": -13.6344803295896,
    "b": -31.3983168435711,
    "C": 34.2308830512338,
    "h": 1.16112340449519,
    "CMY_C": 0.8403221,
    "CMY_M": 0.4387774,
    "CMY_Y": 0.269804,
    "CMYK_C": 0.7813218,
    "CMYK_M": 0.2314084,
    "CMYK_Y": 0,
    "CMYK_K": 0.269804
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0911",
    "Farbtonhilfsbezeichnung": "Marin 75",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "178",
    "Bcolor": "217",
    "Y": 40,
    "L": 68.9108411721993,
    "a": -13.9694273693109,
    "b": -28.0462769710601,
    "C": 31.3327073991998,
    "h": 1.10868196230488,
    "CMY_C": 0.6276253,
    "CMY_M": 0.3023411,
    "CMY_Y": 0.1505666,
    "CMYK_C": 0.5616199,
    "CMYK_M": 0.1786774,
    "CMYK_Y": 0,
    "CMYK_K": 0.1505666
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0913",
    "Farbtonhilfsbezeichnung": "Lazur 5",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "131",
    "Bcolor": "141",
    "Y": 22,
    "L": 54.2451972961426,
    "a": -0.72822380065918,
    "b": -7.05765581130981,
    "C": 7.09512615203857,
    "h": 264.108947753906,
    "CMY_C": 0.52090549468994,
    "CMY_M": 0.4875540137291,
    "CMY_Y": 0.44848954677582,
    "CMYK_C": 0.13130475580692,
    "CMYK_M": 0.07083178311586,
    "CMYK_Y": 0,
    "CMYK_K": 0.44848954677582
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0914",
    "Farbtonhilfsbezeichnung": "Lazur 10",
    "Farbtonklasse": "01",
    "Rcolor": "144",
    "Gcolor": "152",
    "Bcolor": "159",
    "Y": 31,
    "L": 62.3341064453125,
    "a": -0.85916942358017,
    "b": -5.43710374832153,
    "C": 5.50456809997559,
    "h": 261.020385742188,
    "CMY_C": 0.4341744184494,
    "CMY_M": 0.40533685684204,
    "CMY_Y": 0.37663835287094,
    "CMYK_C": 0.09229965507984,
    "CMYK_M": 0.04603828862309,
    "CMYK_Y": 0,
    "CMYK_K": 0.37663835287094
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0915",
    "Farbtonhilfsbezeichnung": "Lazur 15",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "173",
    "Bcolor": "179",
    "Y": 42,
    "L": 70.520622253418,
    "a": -0.62921321392059,
    "b": -4.28869771957397,
    "C": 4.33460903167725,
    "h": 261.653442382813,
    "CMY_C": 0.34321850538254,
    "CMY_M": 0.3205971121788,
    "CMY_Y": 0.29890441894531,
    "CMYK_C": 0.06320691108704,
    "CMYK_M": 0.03094113618135,
    "CMYK_Y": 0,
    "CMYK_K": 0.29890441894531
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0916",
    "Farbtonhilfsbezeichnung": "Lazur 25",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "213",
    "Bcolor": "212",
    "Y": 66,
    "L": 85.1055450439453,
    "a": -0.30734476447105,
    "b": -0.82200700044632,
    "C": 0.87758553028107,
    "h": 249.499450683594,
    "CMY_C": 0.17167419195175,
    "CMY_M": 0.1649341583252,
    "CMY_Y": 0.16687971353531,
    "CMYK_C": 0.00807126052678,
    "CMYK_M": 0,
    "CMYK_Y": 0.00232982262969,
    "CMYK_K": 0.1649341583252
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0917",
    "Farbtonhilfsbezeichnung": "Lazur 30",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "228",
    "Bcolor": "224",
    "Y": 78,
    "L": 90.2787704467773,
    "a": -0.4937119781971,
    "b": 0.70806342363358,
    "C": 0.86319482326508,
    "h": 124.886932373047,
    "CMY_C": 0.11072039604187,
    "CMY_M": 0.10769593715668,
    "CMY_Y": 0.12136125564575,
    "CMYK_C": 0.00338949356228,
    "CMYK_M": 0,
    "CMYK_Y": 0.01531464327127,
    "CMYK_K": 0.10769593715668
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0918",
    "Farbtonhilfsbezeichnung": "Lazur 35",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "202",
    "Bcolor": "210",
    "Y": 58,
    "L": 80.7019805908203,
    "a": -1.29762828350067,
    "b": -6.14430141448975,
    "C": 6.27983093261719,
    "h": 258.074829101563,
    "CMY_C": 0.24690765142441,
    "CMY_M": 0.2092656493187,
    "CMY_Y": 0.17642027139664,
    "CMYK_C": 0.08558659255505,
    "CMYK_M": 0.03988123685122,
    "CMYK_Y": 0,
    "CMYK_K": 0.17642027139664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0919",
    "Farbtonhilfsbezeichnung": "Lazur 40",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 67,
    "L": 85.4000778198242,
    "a": -1.31642603874207,
    "b": -4.65724754333496,
    "C": 4.83972454071045,
    "h": 254.216430664062,
    "CMY_C": 0.1903675198555,
    "CMY_M": 0.15823423862457,
    "CMY_Y": 0.13578224182129,
    "CMYK_C": 0.06316148489714,
    "CMYK_M": 0.02597955986857,
    "CMYK_Y": 0,
    "CMYK_K": 0.13578224182129
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0920",
    "Farbtonhilfsbezeichnung": "Lazur 50",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "230",
    "Bcolor": "229",
    "Y": 78,
    "L": 91.1987915039062,
    "a": -0.24392186105251,
    "b": -0.59482854604721,
    "C": 0.64289879798889,
    "h": 247.702896118164,
    "CMY_C": 0.1030108332634,
    "CMY_M": 0.09765958786011,
    "CMY_Y": 0.1015168428421,
    "CMYK_C": 0.0059304065071,
    "CMYK_M": 0,
    "CMYK_Y": 0.00427472265437,
    "CMYK_K": 0.09765958786011
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0921",
    "Farbtonhilfsbezeichnung": "Lazur 55",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 83,
    "L": 92.7356109619141,
    "a": -0.71788161993027,
    "b": -0.23468555510044,
    "C": 0.75526905059814,
    "h": 198.103286743164,
    "CMY_C": 0.08839726448059,
    "CMY_M": 0.07946383953094,
    "CMY_Y": 0.08720481395721,
    "CMYK_C": 0.00970458891243,
    "CMYK_M": 0,
    "CMYK_Y": 0.00840920209885,
    "CMYK_K": 0.07946383953094
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0922",
    "Farbtonhilfsbezeichnung": "Lazur 60",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "237",
    "Bcolor": "234",
    "Y": 86,
    "L": 93.6095123291016,
    "a": -0.76709920167923,
    "b": 0.5573011636734,
    "C": 0.94816970825195,
    "h": 144.001419067383,
    "CMY_C": 0.07624822854996,
    "CMY_M": 0.06977909803391,
    "CMY_Y": 0.08339190483093,
    "CMYK_C": 0.00695440266281,
    "CMYK_M": 0,
    "CMYK_Y": 0.01463395077735,
    "CMYK_K": 0.06977909803391
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0923",
    "Farbtonhilfsbezeichnung": "Lazur 65",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "87",
    "Bcolor": "100",
    "Y": 9,
    "L": 36.1437759399414,
    "a": -2.10657262802124,
    "b": -10.1370077133179,
    "C": 10.3535776138306,
    "h": 258.260437011719,
    "CMY_C": 0.71783500909805,
    "CMY_M": 0.65963637828827,
    "CMY_Y": 0.60690546035767,
    "CMYK_C": 0.28219559788704,
    "CMYK_M": 0.1341430991888,
    "CMYK_Y": 0,
    "CMYK_K": 0.60690546035767
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0924",
    "Farbtonhilfsbezeichnung": "Lazur 70",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "95",
    "Bcolor": "110",
    "Y": 11,
    "L": 39.8514976501465,
    "a": -1.50707876682281,
    "b": -10.2756385803223,
    "C": 10.3855686187744,
    "h": 261.656188964844,
    "CMY_C": 0.67910802364349,
    "CMY_M": 0.62581568956375,
    "CMY_Y": 0.57033360004425,
    "CMYK_C": 0.25316017866135,
    "CMYK_M": 0.12912829220295,
    "CMYK_Y": 0,
    "CMYK_K": 0.57033360004425
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0925",
    "Farbtonhilfsbezeichnung": "Lazur 80",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "145",
    "Bcolor": "162",
    "Y": 28,
    "L": 59.6321182250977,
    "a": -1.3464195728302,
    "b": -11.2366952896118,
    "C": 11.3170738220215,
    "h": 263.167205810547,
    "CMY_C": 0.48834085464478,
    "CMY_M": 0.43035560846329,
    "CMY_Y": 0.36514735221863,
    "CMYK_C": 0.19405055046082,
    "CMYK_M": 0.10271400213242,
    "CMYK_Y": 0,
    "CMYK_K": 0.36514735221863
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0926",
    "Farbtonhilfsbezeichnung": "Lazur 95",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "84",
    "Bcolor": "104",
    "Y": 8,
    "L": 34.4668083190918,
    "a": -3.06276202201843,
    "b": -14.8331356048584,
    "C": 15.1460361480713,
    "h": 258.333465576172,
    "CMY_C": 0.76456844806671,
    "CMY_M": 0.67204618453979,
    "CMY_Y": 0.59396511316299,
    "CMYK_C": 0.42016914486885,
    "CMYK_M": 0.19230139255524,
    "CMYK_Y": 0,
    "CMYK_K": 0.59396511316299
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0927",
    "Farbtonhilfsbezeichnung": "Lazur 100",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "107",
    "Bcolor": "128",
    "Y": 14,
    "L": 44.066032409668,
    "a": -2.43097448348999,
    "b": -15.0055465698242,
    "C": 15.2011861801148,
    "h": 260.797760009766,
    "CMY_C": 0.6685739159584,
    "CMY_M": 0.58213925361633,
    "CMY_Y": 0.49883133172989,
    "CMYK_C": 0.33869352936745,
    "CMYK_M": 0.16622731089592,
    "CMYK_Y": 0,
    "CMYK_K": 0.49883133172989
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0928",
    "Farbtonhilfsbezeichnung": "Lazur 105",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "122",
    "Bcolor": "145",
    "Y": 19,
    "L": 50.4062614440918,
    "a": -2.01446676254272,
    "b": -15.6928157806397,
    "C": 15.8215847015381,
    "h": 262.685028076172,
    "CMY_C": 0.60646975040436,
    "CMY_M": 0.52059614658356,
    "CMY_Y": 0.43036264181137,
    "CMYK_C": 0.30915653705597,
    "CMYK_M": 0.15840516984463,
    "CMYK_Y": 0,
    "CMYK_K": 0.43036264181137
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0929",
    "Farbtonhilfsbezeichnung": "Lazur 110",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "150",
    "Bcolor": "167",
    "Y": 30,
    "L": 61.2125205993652,
    "a": -1.83160591125488,
    "b": -12.0444450378418,
    "C": 12.182915687561,
    "h": 261.353240966797,
    "CMY_C": 0.47973203659058,
    "CMY_M": 0.41284549236298,
    "CMY_Y": 0.34321439266205,
    "CMYK_C": 0.20785723626614,
    "CMYK_M": 0.10601800680161,
    "CMYK_Y": 0,
    "CMYK_K": 0.34321439266205
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0930",
    "Farbtonhilfsbezeichnung": "Lazur 115",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "188",
    "Bcolor": "205",
    "Y": 50,
    "L": 75.3332061767578,
    "a": -3.11511206626892,
    "b": -11.7610063552856,
    "C": 12.1665601730347,
    "h": 255.164840698242,
    "CMY_C": 0.3424443602562,
    "CMY_M": 0.26152926683426,
    "CMY_Y": 0.19476252794266,
    "CMYK_C": 0.18340158462524,
    "CMYK_M": 0.08291558921337,
    "CMYK_Y": 0,
    "CMYK_K": 0.19476252794266
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0931",
    "Farbtonhilfsbezeichnung": "Lazur 120",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "203",
    "Bcolor": "218",
    "Y": 59,
    "L": 80.6858062744141,
    "a": -2.7148118019104,
    "b": -10.6839799880981,
    "C": 11.0235033035278,
    "h": 255.742813110352,
    "CMY_C": 0.27718281745911,
    "CMY_M": 0.20484554767609,
    "CMY_Y": 0.14398539066315,
    "CMYK_C": 0.15560181438923,
    "CMYK_M": 0.07109709829092,
    "CMYK_Y": 0,
    "CMYK_K": 0.14398539066315
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0932",
    "Farbtonhilfsbezeichnung": "Lazur 125",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "91",
    "Bcolor": "118",
    "Y": 9,
    "L": 36.8430290222168,
    "a": -5.00321912765503,
    "b": -20.1092357635498,
    "C": 20.7222957611084,
    "h": 256.028381347656,
    "CMY_C": 0.79586541652679,
    "CMY_M": 0.64457547664642,
    "CMY_Y": 0.53813427686691,
    "CMYK_C": 0.55802178382874,
    "CMYK_M": 0.23045918345451,
    "CMYK_Y": 0,
    "CMYK_K": 0.53813427686691
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0933",
    "Farbtonhilfsbezeichnung": "Lazur 130",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "109",
    "Bcolor": "137",
    "Y": 14,
    "L": 44.9064598083496,
    "a": -3.38325142860413,
    "b": -19.3811168670654,
    "C": 19.6741981506348,
    "h": 260.097991943359,
    "CMY_C": 0.69344091415405,
    "CMY_M": 0.57069563865662,
    "CMY_Y": 0.46220123767853,
    "CMYK_C": 0.42997434735298,
    "CMYK_M": 0.20173791050911,
    "CMYK_Y": 0,
    "CMYK_K": 0.46220123767853
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0934",
    "Farbtonhilfsbezeichnung": "Lazur 135",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "149",
    "Bcolor": "180",
    "Y": 29,
    "L": 60.1299476623535,
    "a": -3.49796915054321,
    "b": -21.0289878845215,
    "C": 21.3179302215576,
    "h": 260.555877685547,
    "CMY_C": 0.55041754245758,
    "CMY_M": 0.41754686832428,
    "CMY_Y": 0.29335570335388,
    "CMYK_C": 0.36377826333046,
    "CMYK_M": 0.17574778199196,
    "CMYK_Y": 0,
    "CMYK_K": 0.29335570335388
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0935",
    "Farbtonhilfsbezeichnung": "Lazur 140",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "148",
    "Bcolor": "170",
    "Y": 29,
    "L": 60.1649055480957,
    "a": -2.61773657798767,
    "b": -15.2377662658691,
    "C": 15.4609851837158,
    "h": 260.252166748047,
    "CMY_C": 0.51164585351944,
    "CMY_M": 0.42094963788986,
    "CMY_Y": 0.3324658870697,
    "CMYK_C": 0.26842069625854,
    "CMYK_M": 0.13255314528942,
    "CMYK_Y": 0,
    "CMYK_K": 0.3324658870697
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0936",
    "Farbtonhilfsbezeichnung": "Lazur 145",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "176",
    "Bcolor": "201",
    "Y": 43,
    "L": 70.6044540405273,
    "a": -2.9056396484375,
    "b": -16.5334949493408,
    "C": 16.7868766784668,
    "h": 260.032470703125,
    "CMY_C": 0.41248595714569,
    "CMY_M": 0.3109318614006,
    "CMY_Y": 0.21219819784164,
    "CMYK_C": 0.25423622131348,
    "CMYK_M": 0.12532804906368,
    "CMYK_Y": 0,
    "CMYK_K": 0.21219819784164
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0937",
    "Farbtonhilfsbezeichnung": "Lazur 150",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "175",
    "Bcolor": "194",
    "Y": 42,
    "L": 70.4304733276367,
    "a": -2.16180324554443,
    "b": -12.8086929321289,
    "C": 12.989842414856,
    "h": 260.420104980469,
    "CMY_C": 0.3905987739563,
    "CMY_M": 0.31559717655182,
    "CMY_Y": 0.24020290374756,
    "CMYK_C": 0.19794215261936,
    "CMYK_M": 0.09922948479652,
    "CMYK_Y": 0,
    "CMYK_K": 0.24020290374756
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0938",
    "Farbtonhilfsbezeichnung": "Lazur 155",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "92",
    "Bcolor": "126",
    "Y": 9,
    "L": 37.0527496337891,
    "a": -6.940833568573,
    "b": -25.065465927124,
    "C": 26.0087051391602,
    "h": 254.522155761719,
    "CMY_C": 0.87130379676819,
    "CMY_M": 0.6374146938324,
    "CMY_Y": 0.50497227907181,
    "CMYK_C": 0.74002224206924,
    "CMYK_M": 0.26754546165466,
    "CMYK_Y": 0,
    "CMYK_K": 0.50497227907181
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0939",
    "Farbtonhilfsbezeichnung": "Lazur 160",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "109",
    "Bcolor": "145",
    "Y": 14,
    "L": 44.401496887207,
    "a": -4.38889694213867,
    "b": -24.6617450714111,
    "C": 25.0492324829102,
    "h": 259.909088134766,
    "CMY_C": 0.74654603004456,
    "CMY_M": 0.57182615995407,
    "CMY_Y": 0.43313205242157,
    "CMYK_C": 0.55288708209991,
    "CMYK_M": 0.24466739594936,
    "CMYK_Y": 0,
    "CMYK_K": 0.43313205242157
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0940",
    "Farbtonhilfsbezeichnung": "Lazur 165",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "124",
    "Bcolor": "159",
    "Y": 19,
    "L": 50.2559547424316,
    "a": -4.10893583297729,
    "b": -24.1741065979004,
    "C": 24.5208225250244,
    "h": 260.353485107422,
    "CMY_C": 0.67839980125427,
    "CMY_M": 0.51502108573914,
    "CMY_Y": 0.37596517801285,
    "CMYK_C": 0.48464381694794,
    "CMYK_M": 0.22283357381821,
    "CMYK_Y": 0,
    "CMYK_K": 0.37596517801285
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0941",
    "Farbtonhilfsbezeichnung": "Lazur 170",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "151",
    "Bcolor": "186",
    "Y": 29,
    "L": 60.7043991088867,
    "a": -4.36657524108887,
    "b": -23.6969585418701,
    "C": 24.0959091186523,
    "h": 259.559387207031,
    "CMY_C": 0.56916147470474,
    "CMY_M": 0.40891492366791,
    "CMY_Y": 0.26902711391449,
    "CMYK_C": 0.41059574484825,
    "CMYK_M": 0.19137209653854,
    "CMYK_Y": 0,
    "CMYK_K": 0.26902711391449
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0942",
    "Farbtonhilfsbezeichnung": "Lazur 175",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "178",
    "Bcolor": "215",
    "Y": 43,
    "L": 70.8606262207031,
    "a": -5.27315998077393,
    "b": -24.0077800750732,
    "C": 24.5800666809082,
    "h": 257.612060546875,
    "CMY_C": 0.47295469045639,
    "CMY_M": 0.3005918264389,
    "CMY_Y": 0.15689420700073,
    "CMYK_C": 0.37487640976906,
    "CMYK_M": 0.17043842375278,
    "CMYK_Y": 0,
    "CMYK_K": 0.15689420700073
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0943",
    "Farbtonhilfsbezeichnung": "Lazur 185",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "142",
    "Y": 10,
    "L": 38.644344329834,
    "a": -6.45617389678955,
    "b": -32.1055297851563,
    "C": 32.7482414245605,
    "h": 258.629913330078,
    "CMY_C": 1,
    "CMY_M": 0.620485663414,
    "CMY_Y": 0.44405591487885,
    "CMYK_C": 1,
    "CMYK_M": 0.31735160946846,
    "CMYK_Y": 0,
    "CMYK_K": 0.44405591487885
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0944",
    "Farbtonhilfsbezeichnung": "Lazur 190",
    "Farbtonklasse": "04",
    "Rcolor": "23",
    "Gcolor": "100",
    "Bcolor": "141",
    "Y": 11,
    "L": 39.9179992675781,
    "a": -7.31527853012085,
    "b": -29.3756046295166,
    "C": 30.2727508544922,
    "h": 256.016326904297,
    "CMY_C": 0.910440325737,
    "CMY_M": 0.60791909694672,
    "CMY_Y": 0.44863277673721,
    "CMYK_C": 0.83756798505783,
    "CMYK_M": 0.28889334201813,
    "CMYK_Y": 0,
    "CMYK_K": 0.44863277673721
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0945",
    "Farbtonhilfsbezeichnung": "Lazur 195",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "127",
    "Bcolor": "168",
    "Y": 19,
    "L": 51.0132369995117,
    "a": -5.6902027130127,
    "b": -28.0967178344727,
    "C": 28.6671237945557,
    "h": 258.551208496094,
    "CMY_C": 0.72052133083344,
    "CMY_M": 0.5029701590538,
    "CMY_Y": 0.34206414222717,
    "CMYK_C": 0.57521897554398,
    "CMYK_M": 0.24456186592579,
    "CMYK_Y": 0,
    "CMYK_K": 0.34206414222717
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0946",
    "Farbtonhilfsbezeichnung": "Lazur 200",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "151",
    "Bcolor": "201",
    "Y": 29,
    "L": 60.1269302368164,
    "a": -6.69378519058228,
    "b": -33.0520515441895,
    "C": 33.7230606079102,
    "h": 258.551177978516,
    "CMY_C": 0.67687058448792,
    "CMY_M": 0.40668493509293,
    "CMY_Y": 0.21106892824173,
    "CMYK_C": 0.59042125940323,
    "CMYK_M": 0.24795068800449,
    "CMYK_Y": 0,
    "CMYK_K": 0.21106892824173
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0947",
    "Farbtonhilfsbezeichnung": "Lazur 205",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "152",
    "Bcolor": "193",
    "Y": 29,
    "L": 60.7560844421387,
    "a": -5.39578294754028,
    "b": -27.2801189422607,
    "C": 27.8086204528809,
    "h": 258.811767578125,
    "CMY_C": 0.60417658090591,
    "CMY_M": 0.40499138832092,
    "CMY_Y": 0.24392998218536,
    "CMYK_C": 0.47647252678871,
    "CMYK_M": 0.21302445232868,
    "CMYK_Y": 0,
    "CMYK_K": 0.24392998218536
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0948",
    "Farbtonhilfsbezeichnung": "Astra 5",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "159",
    "Bcolor": "167",
    "Y": 35,
    "L": 65.2078128231001,
    "a": -0.84011401492861,
    "b": -5.75733682936426,
    "C": 5.81830894030504,
    "h": 1.42589838527371,
    "CMY_C": 0.405638,
    "CMY_M": 0.3755049,
    "CMY_Y": 0.3445497,
    "CMYK_C": 0.09320044,
    "CMYK_M": 0.04722722,
    "CMYK_Y": 0,
    "CMYK_K": 0.3445497
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0949",
    "Farbtonhilfsbezeichnung": "Astra 10",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "187",
    "Bcolor": "191",
    "Y": 49,
    "L": 75.5948904992315,
    "a": -0.75349785303419,
    "b": -3.57862271839324,
    "C": 3.65708894821105,
    "h": 1.36327238039883,
    "CMY_C": 0.2878759,
    "CMY_M": 0.2664728,
    "CMY_Y": 0.2499329,
    "CMYK_C": 0.05058615,
    "CMYK_M": 0.02205119,
    "CMYK_Y": 0,
    "CMYK_K": 0.2499329
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0950",
    "Farbtonhilfsbezeichnung": "Astra 15",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "202",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.7827787841986,
    "a": -1.31778887094491,
    "b": -4.62921770508666,
    "C": 4.81313038151618,
    "h": 1.29346451038573,
    "CMY_C": 0.2404879,
    "CMY_M": 0.2088133,
    "CMY_Y": 0.1864816,
    "CMYK_C": 0.06638604,
    "CMYK_M": 0.02745069,
    "CMYK_Y": 0,
    "CMYK_K": 0.1864816
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0951",
    "Farbtonhilfsbezeichnung": "Astra 20",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "216",
    "Bcolor": "217",
    "Y": 68,
    "L": 85.9575182322872,
    "a": -1.01908964034503,
    "b": -2.17253325023705,
    "C": 2.39967589862551,
    "h": 1.13219010020257,
    "CMY_C": 0.1727564,
    "CMY_M": 0.153537,
    "CMY_Y": 0.1477831,
    "CMYK_C": 0.02930398,
    "CMYK_M": 0.006751697,
    "CMYK_Y": 0,
    "CMYK_K": 0.1477831
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0952",
    "Farbtonhilfsbezeichnung": "Astra 25",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "221",
    "Bcolor": "223",
    "Y": 72,
    "L": 88.0219672771664,
    "a": -0.67813547581624,
    "b": -2.08628818821481,
    "C": 2.19373337665387,
    "h": 1.25652462394146,
    "CMY_C": 0.146999,
    "CMY_M": 0.1315467,
    "CMY_Y": 0.1256727,
    "CMYK_C": 0.02439169,
    "CMYK_M": 0.0067184,
    "CMYK_Y": 0,
    "CMYK_K": 0.1256727
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0953",
    "Farbtonhilfsbezeichnung": "Astra 30",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "228",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.3854230185161,
    "a": -0.68349184148192,
    "b": -0.01404206769821,
    "C": 0.6836360706089,
    "h": 0.02054171201157,
    "CMY_C": 0.113552,
    "CMY_M": 0.1058841,
    "CMY_Y": 0.1148725,
    "CMYK_C": 0.008575927,
    "CMYK_M": 0,
    "CMYK_Y": 0.01005276,
    "CMYK_K": 0.1058841
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0954",
    "Farbtonhilfsbezeichnung": "Astra 35",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "174",
    "Bcolor": "187",
    "Y": 42,
    "L": 70.3793022922227,
    "a": -1.78575758756094,
    "b": -9.13529616102877,
    "C": 9.30819886504572,
    "h": 1.37775173999396,
    "CMY_C": 0.3724728,
    "CMY_M": 0.3181194,
    "CMY_Y": 0.2665181,
    "CMYK_C": 0.1444544,
    "CMYK_M": 0.07035115,
    "CMYK_Y": 0,
    "CMYK_K": 0.2665181
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0955",
    "Farbtonhilfsbezeichnung": "Astra 40",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "188",
    "Bcolor": "197",
    "Y": 50,
    "L": 75.5286376902239,
    "a": -1.50862514629463,
    "b": -6.86061534700153,
    "C": 7.02452793940955,
    "h": 1.35434476756391,
    "CMY_C": 0.3068461,
    "CMY_M": 0.2645198,
    "CMY_Y": 0.2273677,
    "CMYK_C": 0.102867,
    "CMYK_M": 0.04808502,
    "CMYK_Y": 0,
    "CMYK_K": 0.2273677
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0956",
    "Farbtonhilfsbezeichnung": "Astra 45",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "215",
    "Bcolor": "221",
    "Y": 68,
    "L": 85.6437971534239,
    "a": -0.7817330190375,
    "b": -4.59559729457346,
    "C": 4.66161141741184,
    "h": 1.4023043445903,
    "CMY_C": 0.1831436,
    "CMY_M": 0.1568328,
    "CMY_Y": 0.1334833,
    "CMYK_C": 0.05731019,
    "CMYK_M": 0.02694632,
    "CMYK_Y": 0,
    "CMYK_K": 0.1334833
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0957",
    "Farbtonhilfsbezeichnung": "Astra 50",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 74,
    "L": 88.8578754904457,
    "a": -2.6557319304093,
    "b": -5.05567308035535,
    "C": 5.71075672583111,
    "h": 1.08711621220955,
    "CMY_C": 0.1649665,
    "CMY_M": 0.1168006,
    "CMY_Y": 0.09483639,
    "CMYK_C": 0.07747786,
    "CMYK_M": 0.02426548,
    "CMYK_Y": 0,
    "CMYK_K": 0.09483639
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0958",
    "Farbtonhilfsbezeichnung": "Astra 55",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "234",
    "Bcolor": "233",
    "Y": 81,
    "L": 92.2122174254716,
    "a": -1.26996364532239,
    "b": -0.89228910279211,
    "C": 1.55209133217156,
    "h": 0.61247546673144,
    "CMY_C": 0.10102269999999999,
    "CMY_M": 0.08385753,
    "CMY_Y": 0.08820986,
    "CMYK_C": 0.0187363,
    "CMYK_M": 0,
    "CMYK_Y": 0.004750715,
    "CMYK_K": 0.08385753
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0959",
    "Farbtonhilfsbezeichnung": "Astra 60",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "233",
    "Bcolor": "233",
    "Y": 80,
    "L": 91.724881691756,
    "a": -1.94426294487221,
    "b": -1.68713788969246,
    "C": 2.57421690182453,
    "h": 0.71471011308009,
    "CMY_C": 0.1147784,
    "CMY_M": 0.08749362,
    "CMY_Y": 0.08781619,
    "CMYK_C": 0.02990094,
    "CMYK_M": 0,
    "CMYK_Y": 0.0003534955,
    "CMYK_K": 0.08749362
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0960",
    "Farbtonhilfsbezeichnung": "Astra 65",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "119",
    "Bcolor": "140",
    "Y": 17,
    "L": 49.2094356289452,
    "a": -1.4073231434833,
    "b": -14.468004721857,
    "C": 14.5362897281893,
    "h": 1.47382997721403,
    "CMY_C": 0.6071568,
    "CMY_M": 0.5340763,
    "CMY_Y": 0.4505371,
    "CMYK_C": 0.2850415,
    "CMYK_M": 0.152038,
    "CMYK_Y": 0,
    "CMYK_K": 0.4505371
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0961",
    "Farbtonhilfsbezeichnung": "Astra 70",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "148",
    "Bcolor": "169",
    "Y": 29,
    "L": 60.661221227702,
    "a": -1.67051259583723,
    "b": -13.732892150441,
    "C": 13.8341222760425,
    "h": 1.44974786835078,
    "CMY_C": 0.4914892,
    "CMY_M": 0.4183437,
    "CMY_Y": 0.3374352,
    "CMYK_C": 0.2325117,
    "CMYK_M": 0.122114,
    "CMYK_Y": 0,
    "CMYK_K": 0.3374352
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0962",
    "Farbtonhilfsbezeichnung": "Astra 75",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "174",
    "Bcolor": "193",
    "Y": 42,
    "L": 70.3422826729851,
    "a": -1.68824746425944,
    "b": -12.2561157987735,
    "C": 12.3718452129633,
    "h": 1.43391041276448,
    "CMY_C": 0.3851194,
    "CMY_M": 0.3177603,
    "CMY_Y": 0.2449819,
    "CMYK_C": 0.1856082,
    "CMYK_M": 0.09639294,
    "CMYK_Y": 0,
    "CMYK_K": 0.2449819
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0963",
    "Farbtonhilfsbezeichnung": "Astra 80",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "202",
    "Bcolor": "216",
    "Y": 58,
    "L": 80.4869456009032,
    "a": -2.25517801790026,
    "b": -9.8227794177945,
    "C": 10.0783343555901,
    "h": 1.34512065355448,
    "CMY_C": 0.2718261,
    "CMY_M": 0.2083347,
    "CMY_Y": 0.1523331,
    "CMYK_C": 0.140967,
    "CMYK_M": 0.06606566,
    "CMYK_Y": 0,
    "CMYK_K": 0.1523331
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0964",
    "Farbtonhilfsbezeichnung": "Aquarell 5",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "159",
    "Bcolor": "168",
    "Y": 35,
    "L": 65.1754913330078,
    "a": -0.03077034279704,
    "b": -6.51073837280273,
    "C": 6.51081085205078,
    "h": 269.729217529297,
    "CMY_C": 0.40245014429092,
    "CMY_M": 0.37738120555878,
    "CMY_Y": 0.33958584070206,
    "CMYK_C": 0.09518921375275,
    "CMYK_M": 0.05722979083657,
    "CMYK_Y": 0,
    "CMYK_K": 0.33958584070206
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0965",
    "Farbtonhilfsbezeichnung": "Aquarell 10",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "186",
    "Bcolor": "191",
    "Y": 50,
    "L": 75.4904022216797,
    "a": 0.1655306071043,
    "b": -3.65205597877502,
    "C": 3.65580534934998,
    "h": 272.595184326172,
    "CMY_C": 0.28204661607742,
    "CMY_M": 0.26963663101196,
    "CMY_Y": 0.25041228532791,
    "CMYK_C": 0.0422023050487,
    "CMYK_M": 0.02564655989408,
    "CMYK_Y": 0,
    "CMYK_K": 0.25041228532791
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0966",
    "Farbtonhilfsbezeichnung": "Aquarell 15",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "205",
    "Y": 58,
    "L": 80.8558502197266,
    "a": 0.16928334534168,
    "b": -3.43481540679932,
    "C": 3.43898439407349,
    "h": 272.821502685547,
    "CMY_C": 0.22347396612167,
    "CMY_M": 0.21176111698151,
    "CMY_Y": 0.19412022829056,
    "CMYK_C": 0.03642446175218,
    "CMYK_M": 0.02189022488892,
    "CMYK_Y": 0,
    "CMYK_K": 0.19412022829056
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0967",
    "Farbtonhilfsbezeichnung": "Aquarell 25",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "229",
    "Bcolor": "226",
    "Y": 78,
    "L": 90.8704528808594,
    "a": 0.10665170103312,
    "b": 0.35925957560539,
    "C": 0.37475594878197,
    "h": 73.4656753540039,
    "CMY_C": 0.10057431459427,
    "CMY_M": 0.10242658853531,
    "CMY_Y": 0.11216515302658,
    "CMYK_C": 0,
    "CMYK_M": 0.00205939635634,
    "CMYK_Y": 0.01288693305105,
    "CMYK_K": 0.10057431459427
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0968",
    "Farbtonhilfsbezeichnung": "Aquarell 35",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "172",
    "Bcolor": "188",
    "Y": 42,
    "L": 70.1305313110352,
    "a": 0.09608344733715,
    "b": -9.8888463973999,
    "C": 9.88931274414063,
    "h": 270.556671142578,
    "CMY_C": 0.36281055212021,
    "CMY_M": 0.32467526197433,
    "CMY_Y": 0.26366746425629,
    "CMYK_C": 0.13464444875717,
    "CMYK_M": 0.08285359293222,
    "CMYK_Y": 0,
    "CMYK_K": 0.26366746425629
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0969",
    "Farbtonhilfsbezeichnung": "Aquarell 40",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "179",
    "Bcolor": "189",
    "Y": 45,
    "L": 72.7270050048828,
    "a": 0.0409316457808,
    "b": -6.49690580368042,
    "C": 6.49703454971313,
    "h": 270.360961914063,
    "CMY_C": 0.32278323173523,
    "CMY_M": 0.29804223775864,
    "CMY_Y": 0.25981652736664,
    "CMYK_C": 0.08506905287504,
    "CMYK_M": 0.05164356157184,
    "CMYK_Y": 0,
    "CMYK_K": 0.25981652736664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0970",
    "Farbtonhilfsbezeichnung": "Aquarell 45",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "208",
    "Y": 58,
    "L": 80.5161056518555,
    "a": -0.52199351787567,
    "b": -5.35369157791138,
    "C": 5.37907886505127,
    "h": 264.431182861328,
    "CMY_C": 0.23966205120087,
    "CMY_M": 0.21329760551453,
    "CMY_Y": 0.1840528845787,
    "CMYK_C": 0.0681529045105,
    "CMYK_M": 0.0358414426446,
    "CMYK_Y": 0,
    "CMYK_K": 0.1840528845787
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0971",
    "Farbtonhilfsbezeichnung": "Aquarell 55",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "227",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.0695266723633,
    "a": 0.00867909379303,
    "b": -2.58790302276611,
    "C": 2.58791756629944,
    "h": 270.192138671875,
    "CMY_C": 0.12061560153961,
    "CMY_M": 0.11025702953339,
    "CMY_Y": 0.09925502538681,
    "CMYK_C": 0.02371434308589,
    "CMYK_M": 0.01221433840692,
    "CMYK_Y": 0,
    "CMYK_K": 0.09925502538681
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0972",
    "Farbtonhilfsbezeichnung": "Aquarell 60",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 81,
    "L": 92.157829284668,
    "a": -0.22519943118095,
    "b": -0.76723963022232,
    "C": 0.79960703849792,
    "h": 253.642028808594,
    "CMY_C": 0.09277266263962,
    "CMY_M": 0.08694291114807,
    "CMY_Y": 0.08959913253784,
    "CMYK_C": 0.00638487096876,
    "CMYK_M": 0,
    "CMYK_Y": 0.0029091516044,
    "CMYK_K": 0.08694291114807
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0973",
    "Farbtonhilfsbezeichnung": "Aquarell 65",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "121",
    "Bcolor": "142",
    "Y": 19,
    "L": 50.3670310974121,
    "a": 0.84931319952011,
    "b": -14.0607042312622,
    "C": 14.0863313674927,
    "h": 273.456665039063,
    "CMY_C": 0.57535719871521,
    "CMY_M": 0.52742695808411,
    "CMY_Y": 0.44125133752823,
    "CMYK_C": 0.24001106619835,
    "CMYK_M": 0.15422967076302,
    "CMYK_Y": 0,
    "CMYK_K": 0.44125133752823
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0974",
    "Farbtonhilfsbezeichnung": "Aquarell 70",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "146",
    "Bcolor": "168",
    "Y": 29,
    "L": 60.10302734375,
    "a": 0.49792757630348,
    "b": -14.098292350769,
    "C": 14.1070823669434,
    "h": 272.022766113281,
    "CMY_C": 0.4807613492012,
    "CMY_M": 0.42859697341919,
    "CMY_Y": 0.3405653834343,
    "CMYK_C": 0.21260024607182,
    "CMYK_M": 0.13349555432796,
    "CMYK_Y": 0,
    "CMYK_K": 0.3405653834343
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0975",
    "Farbtonhilfsbezeichnung": "Aquarell 75",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "173",
    "Bcolor": "194",
    "Y": 42,
    "L": 70.4303512573242,
    "a": -0.21602302789688,
    "b": -12.711033821106,
    "C": 12.712869644165,
    "h": 269.0263671875,
    "CMY_C": 0.37384867668152,
    "CMY_M": 0.31992453336716,
    "CMY_Y": 0.2406759262085,
    "CMYK_C": 0.175383284688,
    "CMYK_M": 0.10436730831861,
    "CMYK_Y": 0,
    "CMYK_K": 0.2406759262085
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0976",
    "Farbtonhilfsbezeichnung": "Aquarell 80",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "200",
    "Bcolor": "217",
    "Y": 58,
    "L": 80.2065811157227,
    "a": -0.40546923875809,
    "b": -10.6736516952515,
    "C": 10.6813507080078,
    "h": 267.824493408203,
    "CMY_C": 0.26288002729416,
    "CMY_M": 0.21530121564865,
    "CMY_Y": 0.14904826879501,
    "CMYK_C": 0.13376992940903,
    "CMYK_M": 0.07785746455193,
    "CMYK_Y": 0,
    "CMYK_K": 0.14904826879501
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0977",
    "Farbtonhilfsbezeichnung": "Aquarell 85",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "212",
    "Bcolor": "228",
    "Y": 66,
    "L": 84.730224609375,
    "a": 0.03444497659802,
    "b": -9.74763011932373,
    "C": 9.74769115447998,
    "h": 270.202453613281,
    "CMY_C": 0.20638424158096,
    "CMY_M": 0.16717851161957,
    "CMY_Y": 0.10585248470306,
    "CMYK_C": 0.11243307590485,
    "CMYK_M": 0.06858602911234,
    "CMYK_Y": 0,
    "CMYK_K": 0.10585248470306
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0978",
    "Farbtonhilfsbezeichnung": "Aquarell 90",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "231",
    "Bcolor": "235",
    "Y": 79,
    "L": 91.0650634765625,
    "a": -1.39492702484131,
    "b": -4.10234069824219,
    "C": 4.33301496505737,
    "h": 251.220321655273,
    "CMY_C": 0.12652975320816,
    "CMY_M": 0.09541028738022,
    "CMY_Y": 0.07718288898468,
    "CMYK_C": 0.05347415432334,
    "CMYK_M": 0.0197519082576,
    "CMYK_Y": 0,
    "CMYK_K": 0.07718288898468
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0979",
    "Farbtonhilfsbezeichnung": "Aquarell 95",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "130",
    "Bcolor": "184",
    "Y": 22,
    "L": 53.137508392334,
    "a": -0.28914710879326,
    "b": -34.0840950012207,
    "C": 34.0853233337402,
    "h": 269.513946533203,
    "CMY_C": 0.68235814571381,
    "CMY_M": 0.4901510477066,
    "CMY_Y": 0.27891975641251,
    "CMYK_C": 0.55949169397354,
    "CMYK_M": 0.29293727874756,
    "CMYK_Y": 0,
    "CMYK_K": 0.27891975641251
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0980",
    "Farbtonhilfsbezeichnung": "Aquarell 100",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "157",
    "Bcolor": "211",
    "Y": 33,
    "L": 63.2150039672852,
    "a": -1.36328542232513,
    "b": -33.4665451049805,
    "C": 33.4943008422852,
    "h": 267.667297363281,
    "CMY_C": 0.57853662967682,
    "CMY_M": 0.38554716110229,
    "CMY_Y": 0.17405670881271,
    "CMYK_C": 0.48971876502037,
    "CMYK_M": 0.25605928897858,
    "CMYK_Y": 0,
    "CMYK_K": 0.17405670881271
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0981",
    "Farbtonhilfsbezeichnung": "Aquarell 105",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "186",
    "Bcolor": "225",
    "Y": 49,
    "L": 74.2253799438477,
    "a": -1.67225813865662,
    "b": -24.02294921875,
    "C": 24.0810832977295,
    "h": 266.018005371094,
    "CMY_C": 0.40173870325089,
    "CMY_M": 0.27247089147568,
    "CMY_Y": 0.11935615539551,
    "CMYK_C": 0.32065466046333,
    "CMYK_M": 0.17386680841446,
    "CMYK_Y": 0,
    "CMYK_K": 0.11935615539551
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0982",
    "Farbtonhilfsbezeichnung": "Aquarell 110",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "200",
    "Bcolor": "227",
    "Y": 58,
    "L": 79.7367706298828,
    "a": -1.38309025764465,
    "b": -16.9871311187744,
    "C": 17.0433444976807,
    "h": 265.345245361328,
    "CMY_C": 0.30405175685883,
    "CMY_M": 0.21612858772278,
    "CMY_Y": 0.10879319906235,
    "CMYK_C": 0.21909455955029,
    "CMYK_M": 0.12043824791908,
    "CMYK_Y": 0,
    "CMYK_K": 0.10879319906235
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0983",
    "Farbtonhilfsbezeichnung": "Aquarell 115",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "229",
    "Bcolor": "234",
    "Y": 78,
    "L": 90.5499877929688,
    "a": -0.75528508424759,
    "b": -4.33955860137939,
    "C": 4.40479564666748,
    "h": 260.126770019531,
    "CMY_C": 0.12789410352707,
    "CMY_M": 0.10258507728577,
    "CMY_Y": 0.0810763835907,
    "CMYK_C": 0.05094843357801,
    "CMYK_M": 0.02340639941394,
    "CMYK_Y": 0,
    "CMYK_K": 0.0810763835907
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0984",
    "Farbtonhilfsbezeichnung": "Aquarell 120",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "235",
    "Bcolor": "235",
    "Y": 83,
    "L": 92.9054946899414,
    "a": -0.40080207586288,
    "b": -1.11804842948914,
    "C": 1.18771827220917,
    "h": 250.278076171875,
    "CMY_C": 0.0870708823204,
    "CMY_M": 0.07805681228638,
    "CMY_Y": 0.07870495319366,
    "CMYK_C": 0.0097772506997,
    "CMYK_M": 0,
    "CMYK_Y": 0.00070301612141,
    "CMYK_K": 0.07805681228638
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0985",
    "Farbtonhilfsbezeichnung": "Lavendel 5",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "147",
    "Bcolor": "154",
    "Y": 29,
    "L": 60.8073844909668,
    "a": 0.83048015832901,
    "b": -4.90218639373779,
    "C": 4.9720344543457,
    "h": 279.615203857422,
    "CMY_C": 0.43501758575439,
    "CMY_M": 0.42488849163055,
    "CMY_Y": 0.39585012197495,
    "CMYK_C": 0.06483070552349,
    "CMYK_M": 0.04806484282017,
    "CMYK_Y": 0,
    "CMYK_K": 0.39585012197495
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0986",
    "Farbtonhilfsbezeichnung": "Lavendel 10",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "172",
    "Bcolor": "182",
    "Y": 42,
    "L": 70.523063659668,
    "a": 1.32798385620117,
    "b": -6.22470188140869,
    "C": 6.36478233337402,
    "h": 282.042999267578,
    "CMY_C": 0.33498740196228,
    "CMY_M": 0.32441145181656,
    "CMY_Y": 0.28505152463913,
    "CMYK_C": 0.06984542310238,
    "CMYK_M": 0.05505281686783,
    "CMYK_Y": 0,
    "CMYK_K": 0.28505152463913
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0987",
    "Farbtonhilfsbezeichnung": "Lavendel 15",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "185",
    "Bcolor": "195",
    "Y": 50,
    "L": 75.3449478149414,
    "a": 1.13513588905334,
    "b": -5.91952514648438,
    "C": 6.02737998962402,
    "h": 280.855346679688,
    "CMY_C": 0.28418701887131,
    "CMY_M": 0.27274918556213,
    "CMY_Y": 0.23571836948395,
    "CMYK_C": 0.06341726332903,
    "CMYK_M": 0.04845179244876,
    "CMYK_Y": 0,
    "CMYK_K": 0.23571836948395
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0988",
    "Farbtonhilfsbezeichnung": "Lavendel 20",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "200",
    "Bcolor": "205",
    "Y": 58,
    "L": 80.7947158813477,
    "a": 0.74972760677338,
    "b": -3.36281204223633,
    "C": 3.44537305831909,
    "h": 282.568359375,
    "CMY_C": 0.21931344270706,
    "CMY_M": 0.2137930393219,
    "CMY_Y": 0.19522821903229,
    "CMYK_C": 0.02992801740766,
    "CMYK_M": 0.02306842803955,
    "CMYK_Y": 0,
    "CMYK_K": 0.19522821903229
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0989",
    "Farbtonhilfsbezeichnung": "Lavendel 25",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "214",
    "Bcolor": "217",
    "Y": 67,
    "L": 85.7091445922852,
    "a": 0.85252809524536,
    "b": -2.5513288974762,
    "C": 2.68999695777893,
    "h": 288.477081298828,
    "CMY_C": 0.16193944215775,
    "CMY_M": 0.16051316261292,
    "CMY_Y": 0.14748966693878,
    "CMYK_C": 0.01694967783988,
    "CMYK_M": 0.01527664251626,
    "CMYK_Y": 0,
    "CMYK_K": 0.14748966693878
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0990",
    "Farbtonhilfsbezeichnung": "Lavendel 30",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "226",
    "Y": 76,
    "L": 89.5062408447266,
    "a": 0.68227690458298,
    "b": -1.52910053730011,
    "C": 1.67441046237946,
    "h": 294.046173095703,
    "CMY_C": 0.1177339553833,
    "CMY_M": 0.11842584609985,
    "CMY_Y": 0.11321204900742,
    "CMYK_C": 0.00509919691831,
    "CMYK_M": 0.00587941799313,
    "CMYK_Y": 0,
    "CMYK_K": 0.11321204900742
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0991",
    "Farbtonhilfsbezeichnung": "Lavendel 35",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "73",
    "Bcolor": "81",
    "Y": 6,
    "L": 31.1816139221191,
    "a": 0.77101391553879,
    "b": -5.05789613723755,
    "C": 5.11632442474365,
    "h": 278.667297363281,
    "CMY_C": 0.72264355421066,
    "CMY_M": 0.71230614185333,
    "CMY_Y": 0.68416410684586,
    "CMYK_C": 0.12183367460966,
    "CMYK_M": 0.08910334855318,
    "CMYK_Y": 0,
    "CMYK_K": 0.68416410684586
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0992",
    "Farbtonhilfsbezeichnung": "Lavendel 40",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "103",
    "Y": 11,
    "L": 39.947093963623,
    "a": 1.36158204078674,
    "b": -6.12699890136719,
    "C": 6.27646589279175,
    "h": 282.529052734375,
    "CMY_C": 0.64102458953857,
    "CMY_M": 0.63183200359344,
    "CMY_Y": 0.59527051448822,
    "CMYK_C": 0.11304853111506,
    "CMYK_M": 0.09033562242985,
    "CMYK_Y": 0,
    "CMYK_K": 0.59527051448822
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0993",
    "Farbtonhilfsbezeichnung": "Lavendel 45",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "118",
    "Bcolor": "127",
    "Y": 18,
    "L": 49.5742645263672,
    "a": 1.34761762619019,
    "b": -6.05441951751709,
    "C": 6.20258569717407,
    "h": 282.548553466797,
    "CMY_C": 0.54797685146332,
    "CMY_M": 0.53872525691986,
    "CMY_Y": 0.50175070762634,
    "CMYK_C": 0.09277714043856,
    "CMYK_M": 0.07420893758535,
    "CMYK_Y": 0,
    "CMYK_K": 0.50175070762634
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0994",
    "Farbtonhilfsbezeichnung": "Lavendel 50",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "161",
    "Bcolor": "172",
    "Y": 36,
    "L": 66.1644134521484,
    "a": 1.29437124729156,
    "b": -7.07402467727661,
    "C": 7.19146871566772,
    "h": 280.369018554688,
    "CMY_C": 0.38400560617447,
    "CMY_M": 0.36985433101654,
    "CMY_Y": 0.32516515254974,
    "CMYK_C": 0.0871923789382,
    "CMYK_M": 0.06622239202261,
    "CMYK_Y": 0,
    "CMYK_K": 0.32516515254974
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0995",
    "Farbtonhilfsbezeichnung": "Lavendel 55",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "202",
    "Bcolor": "212",
    "Y": 60,
    "L": 81.4280090332031,
    "a": 0.69055098295212,
    "b": -6.20237970352173,
    "C": 6.24070310592651,
    "h": 276.352935791016,
    "CMY_C": 0.22323608398438,
    "CMY_M": 0.20592129230499,
    "CMY_Y": 0.16783100366592,
    "CMYK_C": 0.06657911837101,
    "CMYK_M": 0.04577229917049,
    "CMYK_Y": 0,
    "CMYK_K": 0.16783100366592
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0996",
    "Farbtonhilfsbezeichnung": "Lavendel 60",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "228",
    "Bcolor": "233",
    "Y": 78,
    "L": 90.6210784912109,
    "a": 0.46393838524818,
    "b": -3.25321888923645,
    "C": 3.28613328933716,
    "h": 278.116180419922,
    "CMY_C": 0.11323034763336,
    "CMY_M": 0.1049987077713,
    "CMY_Y": 0.08815771341324,
    "CMYK_C": 0.02749667875469,
    "CMYK_M": 0.01846919581294,
    "CMYK_Y": 0,
    "CMYK_K": 0.08815771341324
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0997",
    "Farbtonhilfsbezeichnung": "Lavendel 65",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "84",
    "Bcolor": "106",
    "Y": 8,
    "L": 35.9898071289063,
    "a": 2.56650733947754,
    "b": -13.8543920516968,
    "C": 14.0901079177856,
    "h": 280.494995117188,
    "CMY_C": 0.69907331466675,
    "CMY_M": 0.66912150382996,
    "CMY_Y": 0.58488810062408,
    "CMYK_C": 0.27507093548775,
    "CMYK_M": 0.2029173374176,
    "CMYK_Y": 0,
    "CMYK_K": 0.58488810062408
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0998",
    "Farbtonhilfsbezeichnung": "Lavendel 70",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "110",
    "Bcolor": "133",
    "Y": 15,
    "L": 46.317440032959,
    "a": 2.00987982749939,
    "b": -14.7548151016235,
    "C": 14.891077041626,
    "h": 277.757019042969,
    "CMY_C": 0.60881912708282,
    "CMY_M": 0.56938934326172,
    "CMY_Y": 0.47751426696777,
    "CMYK_C": 0.2513080239296,
    "CMYK_M": 0.17584227025509,
    "CMYK_Y": 0,
    "CMYK_K": 0.47751426696777
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD0999",
    "Farbtonhilfsbezeichnung": "Lavendel 75",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "130",
    "Bcolor": "155",
    "Y": 22,
    "L": 54.4587783813477,
    "a": 2.88501644134521,
    "b": -15.2792224884033,
    "C": 15.5492105484009,
    "h": 280.692687988281,
    "CMY_C": 0.52366507053375,
    "CMY_M": 0.49063271284103,
    "CMY_Y": 0.39104330539703,
    "CMYK_C": 0.21778520941734,
    "CMYK_M": 0.16354103386402,
    "CMYK_Y": 0,
    "CMYK_K": 0.39104330539703
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1000",
    "Farbtonhilfsbezeichnung": "Lavendel 80",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "159",
    "Bcolor": "184",
    "Y": 35,
    "L": 65.3631057739258,
    "a": 2.31195330619812,
    "b": -14.852840423584,
    "C": 15.0317001342773,
    "h": 278.847503662109,
    "CMY_C": 0.41511702537537,
    "CMY_M": 0.37805330753326,
    "CMY_Y": 0.27965003252029,
    "CMYK_C": 0.18805719912052,
    "CMYK_M": 0.13660481572151,
    "CMYK_Y": 0,
    "CMYK_K": 0.27965003252029
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1001",
    "Farbtonhilfsbezeichnung": "Lavendel 85",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "162",
    "Bcolor": "185",
    "Y": 36,
    "L": 66.9174118041992,
    "a": 2.59171772003174,
    "b": -13.1102151870728,
    "C": 13.3639345169067,
    "h": 281.182434082031,
    "CMY_C": 0.38939827680588,
    "CMY_M": 0.36304485797882,
    "CMY_Y": 0.27515989542007,
    "CMYK_C": 0.1576049476862,
    "CMYK_M": 0.12124738097191,
    "CMYK_Y": 0,
    "CMYK_K": 0.27515989542007
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1002",
    "Farbtonhilfsbezeichnung": "Lavendel 90",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "173",
    "Bcolor": "195",
    "Y": 42,
    "L": 70.8090972900391,
    "a": 2.28103613853455,
    "b": -12.9666976928711,
    "C": 13.1658029556274,
    "h": 279.977111816406,
    "CMY_C": 0.35049146413803,
    "CMY_M": 0.32147061824799,
    "CMY_Y": 0.23452752828598,
    "CMYK_C": 0.15149328112602,
    "CMYK_M": 0.11358094960451,
    "CMYK_Y": 0,
    "CMYK_K": 0.23452752828598
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1003",
    "Farbtonhilfsbezeichnung": "Lavendel 95",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "98",
    "Bcolor": "128",
    "Y": 12,
    "L": 41.6319389343262,
    "a": 3.61860418319702,
    "b": -18.7550182342529,
    "C": 19.1009159088135,
    "h": 280.920501708984,
    "CMY_C": 0.65976560115814,
    "CMY_M": 0.61655080318451,
    "CMY_Y": 0.49853253364563,
    "CMYK_C": 0.32152247428894,
    "CMYK_M": 0.23534581065178,
    "CMYK_Y": 0,
    "CMYK_K": 0.49853253364563
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1004",
    "Farbtonhilfsbezeichnung": "Lavendel 100",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "129",
    "Bcolor": "163",
    "Y": 23,
    "L": 54.292724609375,
    "a": 3.63866925239563,
    "b": -20.0324516296387,
    "C": 20.3602313995361,
    "h": 280.294891357422,
    "CMY_C": 0.54084479808807,
    "CMY_M": 0.49232739210129,
    "CMY_Y": 0.36087650060654,
    "CMYK_C": 0.28158611059189,
    "CMYK_M": 0.2056736946106,
    "CMYK_Y": 0,
    "CMYK_K": 0.36087650060654
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1005",
    "Farbtonhilfsbezeichnung": "Lavendel 105",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "184",
    "Bcolor": "209",
    "Y": 48,
    "L": 74.8110504150391,
    "a": 2.33343100547791,
    "b": -14.5488195419312,
    "C": 14.7347564697266,
    "h": 279.111846923828,
    "CMY_C": 0.31422418355942,
    "CMY_M": 0.27851462364197,
    "CMY_Y": 0.17998260259628,
    "CMYK_C": 0.16370576620102,
    "CMYK_M": 0.12015844881535,
    "CMYK_Y": 0,
    "CMYK_K": 0.17998260259628
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1006",
    "Farbtonhilfsbezeichnung": "Lavendel 110",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "185",
    "Bcolor": "201",
    "Y": 50,
    "L": 75.237663269043,
    "a": 1.5701996088028,
    "b": -9.66219806671143,
    "C": 9.78895282745361,
    "h": 279.230407714844,
    "CMY_C": 0.29601329565048,
    "CMY_M": 0.27375787496567,
    "CMY_Y": 0.21019899845123,
    "CMYK_C": 0.1086530610919,
    "CMYK_M": 0.08047454804182,
    "CMYK_Y": 0,
    "CMYK_K": 0.21019899845123
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1007",
    "Farbtonhilfsbezeichnung": "Lavendel 115",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "213",
    "Bcolor": "225",
    "Y": 67,
    "L": 85.2630004882813,
    "a": 1.47592544555664,
    "b": -7.0901665687561,
    "C": 7.2421555519104,
    "h": 281.759063720703,
    "CMY_C": 0.17842143774033,
    "CMY_M": 0.16552793979645,
    "CMY_Y": 0.11917293071747,
    "CMYK_C": 0.06726463139057,
    "CMYK_M": 0.05262668430805,
    "CMYK_Y": 0,
    "CMYK_K": 0.11917293071747
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1008",
    "Farbtonhilfsbezeichnung": "Lavendel 120",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "225",
    "Bcolor": "233",
    "Y": 76,
    "L": 89.5066604614258,
    "a": 0.85193198919296,
    "b": -5.02037572860718,
    "C": 5.09214687347412,
    "h": 279.631042480469,
    "CMY_C": 0.12893790006638,
    "CMY_M": 0.11778622865677,
    "CMY_Y": 0.08743888139725,
    "CMYK_C": 0.04547533020377,
    "CMYK_M": 0.03325514122844,
    "CMYK_Y": 0,
    "CMYK_K": 0.08743888139725
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1009",
    "Farbtonhilfsbezeichnung": "Lavendel 125",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "157",
    "Bcolor": "190",
    "Y": 35,
    "L": 64.7152099609375,
    "a": 3.12800979614258,
    "b": -19.4932594299316,
    "C": 19.7426338195801,
    "h": 279.116333007813,
    "CMY_C": 0.43585032224655,
    "CMY_M": 0.38505101203918,
    "CMY_Y": 0.25435322523117,
    "CMYK_C": 0.24340894818306,
    "CMYK_M": 0.17528109252453,
    "CMYK_Y": 0,
    "CMYK_K": 0.25435322523117
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1010",
    "Farbtonhilfsbezeichnung": "Lavendel 130",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "175",
    "Bcolor": "204",
    "Y": 44,
    "L": 71.437858581543,
    "a": 2.54281783103943,
    "b": -16.9114265441895,
    "C": 17.1015281677246,
    "h": 278.550994873047,
    "CMY_C": 0.35853832960129,
    "CMY_M": 0.31411010026932,
    "CMY_Y": 0.19992190599442,
    "CMYK_C": 0.1982511729002,
    "CMYK_M": 0.14272131025791,
    "CMYK_Y": 0,
    "CMYK_K": 0.19992190599442
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1011",
    "Farbtonhilfsbezeichnung": "Lavendel 135",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "183",
    "Bcolor": "216",
    "Y": 49,
    "L": 74.3608245849609,
    "a": 2.30479955673218,
    "b": -18.7984733581543,
    "C": 18.9392375946045,
    "h": 276.989898681641,
    "CMY_C": 0.33805948495865,
    "CMY_M": 0.28182488679886,
    "CMY_Y": 0.15467602014542,
    "CMYK_C": 0.21693867444992,
    "CMYK_M": 0.15041436254978,
    "CMYK_Y": 0,
    "CMYK_K": 0.15467602014542
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1012",
    "Farbtonhilfsbezeichnung": "Lavendel 140",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "199",
    "Bcolor": "228",
    "Y": 59,
    "L": 80.2804946899414,
    "a": 2.60058426856995,
    "b": -16.6840114593506,
    "C": 16.8854751586914,
    "h": 278.859558105469,
    "CMY_C": 0.26244795322418,
    "CMY_M": 0.21949446201324,
    "CMY_Y": 0.10451400279999,
    "CMYK_C": 0.17636674642563,
    "CMYK_M": 0.12840005755424,
    "CMYK_Y": 0,
    "CMYK_K": 0.10451400279999
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1013",
    "Farbtonhilfsbezeichnung": "Lavendel 150",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "209",
    "Bcolor": "232",
    "Y": 65,
    "L": 83.9296875,
    "a": 1.87331783771515,
    "b": -12.9000234603882,
    "C": 13.0353336334229,
    "h": 278.262634277344,
    "CMY_C": 0.2127338051796,
    "CMY_M": 0.17925477027893,
    "CMY_Y": 0.09153819084167,
    "CMYK_C": 0.13340748846531,
    "CMYK_M": 0.09655505418777,
    "CMYK_Y": 0,
    "CMYK_K": 0.09153819084167
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1014",
    "Farbtonhilfsbezeichnung": "Lavendel 155",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "70",
    "Bcolor": "98",
    "Y": 6,
    "L": 29.6590576171875,
    "a": 3.20655679702759,
    "b": -18.826753616333,
    "C": 19.0978698730469,
    "h": 279.665802001953,
    "CMY_C": 0.77664959430695,
    "CMY_M": 0.72659242153168,
    "CMY_Y": 0.61507713794708,
    "CMYK_C": 0.41975280642509,
    "CMYK_M": 0.28970813751221,
    "CMYK_Y": 0,
    "CMYK_K": 0.61507713794708
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1015",
    "Farbtonhilfsbezeichnung": "Lavendel 160",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "84",
    "Bcolor": "125",
    "Y": 8,
    "L": 35.3773384094238,
    "a": 3.64382290840149,
    "b": -26.5928592681885,
    "C": 26.8413410186768,
    "h": 277.80224609375,
    "CMY_C": 0.76625853776932,
    "CMY_M": 0.67238700389862,
    "CMY_Y": 0.51133382320404,
    "CMYK_C": 0.52167457342148,
    "CMYK_M": 0.32957708835602,
    "CMYK_Y": 0,
    "CMYK_K": 0.51133382320404
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1016",
    "Farbtonhilfsbezeichnung": "Lavendel 165",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "91",
    "Bcolor": "136",
    "Y": 11,
    "L": 38.6789169311523,
    "a": 3.90879344940186,
    "b": -28.5050239562988,
    "C": 28.7717761993408,
    "h": 277.808074951172,
    "CMY_C": 0.74405360221863,
    "CMY_M": 0.64139020442963,
    "CMY_Y": 0.46601980924606,
    "CMYK_C": 0.52068185806274,
    "CMYK_M": 0.32842117547989,
    "CMYK_Y": 0,
    "CMYK_K": 0.46601980924606
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1017",
    "Farbtonhilfsbezeichnung": "Lavendel 170",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "93",
    "Bcolor": "132",
    "Y": 11,
    "L": 39.5740127563477,
    "a": 3.6271870136261,
    "b": -24.4581737518311,
    "C": 24.7256698608398,
    "h": 278.435577392578,
    "CMY_C": 0.7107304930687,
    "CMY_M": 0.63399016857147,
    "CMY_Y": 0.48278546333313,
    "CMYK_C": 0.44071659445763,
    "CMYK_M": 0.29234427213669,
    "CMYK_Y": 0,
    "CMYK_K": 0.48278546333313
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1018",
    "Farbtonhilfsbezeichnung": "Lavendel 175",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "120",
    "Bcolor": "169",
    "Y": 19,
    "L": 50.3823051452637,
    "a": 5.02474212646484,
    "b": -29.7638263702393,
    "C": 30.184986114502,
    "h": 279.582336425781,
    "CMY_C": 0.62196666002274,
    "CMY_M": 0.53054869174957,
    "CMY_Y": 0.33673524856567,
    "CMYK_C": 0.43004155158997,
    "CMYK_M": 0.29221129417419,
    "CMYK_Y": 0,
    "CMYK_K": 0.33673524856567
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1019",
    "Farbtonhilfsbezeichnung": "Lavendel 180",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "148",
    "Bcolor": "190",
    "Y": 30,
    "L": 61.199031829834,
    "a": 4.11846733093262,
    "b": -25.09202003479,
    "C": 25.4277648925781,
    "h": 279.321105957031,
    "CMY_C": 0.49169373512268,
    "CMY_M": 0.42153149843216,
    "CMY_Y": 0.25336915254593,
    "CMYK_C": 0.31920000910759,
    "CMYK_M": 0.22522823512554,
    "CMYK_Y": 0,
    "CMYK_K": 0.25336915254593
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1020",
    "Farbtonhilfsbezeichnung": "Litho 5",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "104",
    "Bcolor": "127",
    "Y": 15,
    "L": 44.6799632576742,
    "a": 4.34025526075532,
    "b": -13.3388280443935,
    "C": 14.0271932091353,
    "h": -1.25621620050892,
    "CMY_C": 0.6008952,
    "CMY_M": 0.5906967,
    "CMY_Y": 0.5028175,
    "CMYK_C": 0.1972671,
    "CMYK_M": 0.1767544,
    "CMYK_Y": 0,
    "CMYK_K": 0.5028175
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1021",
    "Farbtonhilfsbezeichnung": "Litho 10",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "135",
    "Bcolor": "152",
    "Y": 24,
    "L": 56.5850893664592,
    "a": 3.43012172736634,
    "b": -10.3452691292687,
    "C": 10.8990975966614,
    "h": -1.25063876298744,
    "CMY_C": 0.4781646,
    "CMY_M": 0.4720252,
    "CMY_Y": 0.4021557,
    "CMYK_C": 0.1271382,
    "CMYK_M": 0.116869,
    "CMYK_Y": 0,
    "CMYK_K": 0.4021557
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1022",
    "Farbtonhilfsbezeichnung": "Litho 15",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "165",
    "Bcolor": "175",
    "Y": 38,
    "L": 67.7614303238318,
    "a": 1.65382705849265,
    "b": -6.26907729383503,
    "C": 6.48355412219875,
    "h": -1.31286555687762,
    "CMY_C": 0.3616564,
    "CMY_M": 0.3542235,
    "CMY_Y": 0.3139113,
    "CMYK_C": 0.06959023,
    "CMYK_M": 0.05875654,
    "CMYK_Y": 0,
    "CMYK_K": 0.3139113
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1023",
    "Farbtonhilfsbezeichnung": "Litho 20",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "188",
    "Bcolor": "192",
    "Y": 50,
    "L": 76.0927597337719,
    "a": 0.62854059616546,
    "b": -3.14270119295159,
    "C": 3.20493901177657,
    "h": -1.3734006575416,
    "CMY_C": 0.2702148,
    "CMY_M": 0.2644041,
    "CMY_Y": 0.2475291,
    "CMYK_C": 0.03014827,
    "CMYK_M": 0.02242602,
    "CMYK_Y": 0,
    "CMYK_K": 0.2475291
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1024",
    "Farbtonhilfsbezeichnung": "Litho 25",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "219",
    "Bcolor": "219",
    "Y": 71,
    "L": 87.3769628013599,
    "a": 0.55661828970227,
    "b": -0.67855161303871,
    "C": 0.87764241692646,
    "h": -0.8837972048866,
    "CMY_C": 0.1393735,
    "CMY_M": 0.1419946,
    "CMY_Y": 0.1429403,
    "CMYK_C": 0,
    "CMYK_M": 0.003045557,
    "CMYK_Y": 0.004144423,
    "CMYK_K": 0.1393735
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1025",
    "Farbtonhilfsbezeichnung": "Litho 30",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 81,
    "L": 91.9422385859522,
    "a": -0.29696748639096,
    "b": 1.75490192482248,
    "C": 1.77985124482891,
    "h": -1.40316270607091,
    "CMY_C": 0.08706573,
    "CMY_M": 0.08993585,
    "CMY_Y": 0.110717,
    "CMYK_C": 0,
    "CMYK_M": 0.003143834,
    "CMYK_Y": 0.0259069,
    "CMYK_K": 0.08706573
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1026",
    "Farbtonhilfsbezeichnung": "Amethyst 5",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "72",
    "Bcolor": "73",
    "Y": 6,
    "L": 30.5790389640739,
    "a": 0.26244429256958,
    "b": -1.2174889519175,
    "C": 1.24545427645639,
    "h": -1.35848310729793,
    "CMY_C": 0.7195312,
    "CMY_M": 0.7177647,
    "CMY_Y": 0.7128265,
    "CMYK_C": 0.02334708,
    "CMYK_M": 0.01719592,
    "CMYK_Y": 0,
    "CMYK_K": 0.7128265
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1027",
    "Farbtonhilfsbezeichnung": "Amethyst 10",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "92",
    "Bcolor": "94",
    "Y": 11,
    "L": 39.2883057026361,
    "a": 0.41512927393608,
    "b": -1.62737094661467,
    "C": 1.67948459712027,
    "h": -1.32103098523723,
    "CMY_C": 0.6392219,
    "CMY_M": 0.637346,
    "CMY_Y": 0.6299093,
    "CMYK_C": 0.0251631,
    "CMYK_M": 0.02009438,
    "CMYK_Y": 0,
    "CMYK_K": 0.6299093
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1028",
    "Farbtonhilfsbezeichnung": "Amethyst 15",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "147",
    "Bcolor": "151",
    "Y": 29,
    "L": 61.0573566943498,
    "a": 1.4677169694699,
    "b": -2.4868048215138,
    "C": 2.88762728252352,
    "h": -1.03761245191684,
    "CMY_C": 0.4195416,
    "CMY_M": 0.4244284,
    "CMY_Y": 0.4096641,
    "CMYK_C": 0.01673204,
    "CMYK_M": 0.02501013,
    "CMYK_Y": 0,
    "CMYK_K": 0.4096641
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1029",
    "Farbtonhilfsbezeichnung": "Amethyst 20",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "191",
    "Bcolor": "193",
    "Y": 53,
    "L": 77.5259316304191,
    "a": 1.15108224538341,
    "b": -1.76127095188305,
    "C": 2.10405933889326,
    "h": -0.99192810859817,
    "CMY_C": 0.2460117,
    "CMY_M": 0.2505909,
    "CMY_Y": 0.2419588,
    "CMYK_C": 0.005346623,
    "CMYK_M": 0.01138744,
    "CMYK_Y": 0,
    "CMYK_K": 0.2419588
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1030",
    "Farbtonhilfsbezeichnung": "Amethyst 25",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "220",
    "Bcolor": "217",
    "Y": 72,
    "L": 87.7430704770049,
    "a": 0.0241096039022,
    "b": 0.74869287056851,
    "C": 0.7490809618729,
    "h": 1.53860518906709,
    "CMY_C": 0.1346356,
    "CMY_M": 0.1370982,
    "CMY_Y": 0.1494756,
    "CMYK_C": 0,
    "CMYK_M": 0.002845758,
    "CMYK_Y": 0.01714882,
    "CMYK_K": 0.1346356
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1031",
    "Farbtonhilfsbezeichnung": "Amethyst 30",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "227",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.1466791006915,
    "a": -0.08834436051102,
    "b": 1.81328149891276,
    "C": 1.81543232325895,
    "h": -1.52211411240799,
    "CMY_C": 0.1052537,
    "CMY_M": 0.1104673,
    "CMY_Y": 0.1309292,
    "CMYK_C": 0,
    "CMYK_M": 0.005826926,
    "CMYK_Y": 0.02869584,
    "CMYK_K": 0.1052537
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1032",
    "Farbtonhilfsbezeichnung": "Amethyst 35",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "96",
    "Bcolor": "104",
    "Y": 12,
    "L": 40.908364652196,
    "a": 2.50018338752095,
    "b": -5.13397729688083,
    "C": 5.71039752172504,
    "h": -1.11761270599939,
    "CMY_C": 0.6206406,
    "CMY_M": 0.6253566,
    "CMY_Y": 0.5921983,
    "CMYK_C": 0.06974559,
    "CMYK_M": 0.08130981,
    "CMYK_Y": 0,
    "CMYK_K": 0.5921983
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1033",
    "Farbtonhilfsbezeichnung": "Amethyst 40",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "146",
    "Bcolor": "154",
    "Y": 29,
    "L": 60.8584495499417,
    "a": 2.37821054380677,
    "b": -4.77680442960589,
    "C": 5.33607964233819,
    "h": -1.10885703414345,
    "CMY_C": 0.4225394,
    "CMY_M": 0.4278506,
    "CMY_Y": 0.3959948,
    "CMYK_C": 0.04394764,
    "CMYK_M": 0.05274098,
    "CMYK_Y": 0,
    "CMYK_K": 0.3959948
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1034",
    "Farbtonhilfsbezeichnung": "Amethyst 45",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "172",
    "Bcolor": "181",
    "Y": 42,
    "L": 70.8549547099137,
    "a": 2.842856543395,
    "b": -4.8819283508104,
    "C": 5.64934135530596,
    "h": -1.04347643440059,
    "CMY_C": 0.3151138,
    "CMY_M": 0.3247927,
    "CMY_Y": 0.2907704,
    "CMYK_C": 0.03432372,
    "CMYK_M": 0.0479708,
    "CMYK_Y": 0,
    "CMYK_K": 0.2907704
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1035",
    "Farbtonhilfsbezeichnung": "Amethyst 50",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 50,
    "L": 75.2414531785621,
    "a": 2.29327200708418,
    "b": -4.24945116302566,
    "C": 4.82876088509424,
    "h": -1.0759239358454,
    "CMY_C": 0.2703606,
    "CMY_M": 0.277052,
    "CMY_Y": 0.2485603,
    "CMYK_C": 0.02901135,
    "CMYK_M": 0.03791618,
    "CMYK_Y": 0,
    "CMYK_K": 0.2485603
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1036",
    "Farbtonhilfsbezeichnung": "Amethyst 55",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "211",
    "Bcolor": "216",
    "Y": 67,
    "L": 85.011620511482,
    "a": 1.97304450666014,
    "b": -2.66249135329952,
    "C": 3.31387459504075,
    "h": -0.93304658582786,
    "CMY_C": 0.1612068,
    "CMY_M": 0.1708273,
    "CMY_Y": 0.1541752,
    "CMYK_C": 0.008313254,
    "CMYK_M": 0.01968738,
    "CMYK_Y": 0,
    "CMYK_K": 0.1541752
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1037",
    "Farbtonhilfsbezeichnung": "Amethyst 60",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "228",
    "Bcolor": "226",
    "Y": 80,
    "L": 90.58740729556,
    "a": 1.03902883245838,
    "b": 0.26404466666651,
    "C": 1.07205433662425,
    "h": 0.24885855619991,
    "CMY_C": 0.09671152,
    "CMY_M": 0.1078037,
    "CMY_Y": 0.1144596,
    "CMYK_C": 0,
    "CMYK_M": 0.01227978,
    "CMYK_Y": 0.01964831,
    "CMYK_K": 0.09671152
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1038",
    "Farbtonhilfsbezeichnung": "Amethyst 70",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "92",
    "Bcolor": "108",
    "Y": 11,
    "L": 39.8430309367718,
    "a": 4.89324935499583,
    "b": -9.48974408385539,
    "C": 10.6770376054051,
    "h": -1.09471866689509,
    "CMY_C": 0.6289505,
    "CMY_M": 0.6392717,
    "CMY_Y": 0.5747424,
    "CMYK_C": 0.1274711,
    "CMYK_M": 0.1517417,
    "CMYK_Y": 0,
    "CMYK_K": 0.5747424
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1039",
    "Farbtonhilfsbezeichnung": "Amethyst 75",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "105",
    "Bcolor": "126",
    "Y": 14,
    "L": 45.4379201370926,
    "a": 6.0971461541508,
    "b": -11.6782577297295,
    "C": 13.1740993933954,
    "h": -1.0896302919107,
    "CMY_C": 0.5743414,
    "CMY_M": 0.5877632,
    "CMY_Y": 0.5058064,
    "CMYK_C": 0.1386804,
    "CMYK_M": 0.1658394,
    "CMYK_Y": 0,
    "CMYK_K": 0.5058064
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1040",
    "Farbtonhilfsbezeichnung": "Amethyst 80",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "172",
    "Bcolor": "185",
    "Y": 42,
    "L": 70.9052368076327,
    "a": 4.08094811175774,
    "b": -7.3126942231883,
    "C": 8.3743438126644,
    "h": -1.06178337535367,
    "CMY_C": 0.3137233,
    "CMY_M": 0.326408,
    "CMY_Y": 0.2730165,
    "CMYK_C": 0.05599415,
    "CMYK_M": 0.07344254,
    "CMYK_Y": 0,
    "CMYK_K": 0.2730165
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1041",
    "Farbtonhilfsbezeichnung": "Amethyst 85",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "198",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.5195562665554,
    "a": 3.11151652405783,
    "b": -4.74345422556874,
    "C": 5.67290869568257,
    "h": -0.99024266048206,
    "CMY_C": 0.2087673,
    "CMY_M": 0.2219443,
    "CMY_Y": 0.1879538,
    "CMYK_C": 0.02563087,
    "CMYK_M": 0.04185781,
    "CMYK_Y": 0,
    "CMYK_K": 0.1879538
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1042",
    "Farbtonhilfsbezeichnung": "Amethyst 90",
    "Farbtonklasse": "01",
    "Y": 78,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1043",
    "Farbtonhilfsbezeichnung": "Amethyst 95",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "68",
    "Bcolor": "99",
    "Y": 6,
    "L": 30.3213990541691,
    "a": 9.3399294537902,
    "b": -17.9351632477567,
    "C": 20.221383803426,
    "h": -1.0906783770588,
    "CMY_C": 0.719493,
    "CMY_M": 0.7339217,
    "CMY_Y": 0.6136702,
    "CMYK_C": 0.2739184,
    "CMYK_M": 0.3112665,
    "CMYK_Y": 0,
    "CMYK_K": 0.6136702
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1044",
    "Farbtonhilfsbezeichnung": "Amethyst 100",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "91",
    "Bcolor": "114",
    "Y": 11,
    "L": 39.6656354799489,
    "a": 6.90127299203752,
    "b": -13.473384342505,
    "C": 15.1380201661738,
    "h": -1.0974243364229,
    "CMY_C": 0.6310823,
    "CMY_M": 0.6440681,
    "CMY_Y": 0.5511791,
    "CMYK_C": 0.178029,
    "CMYK_M": 0.2069621,
    "CMYK_Y": 0,
    "CMYK_K": 0.5511791
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1045",
    "Farbtonhilfsbezeichnung": "Amethyst 105",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "116",
    "Bcolor": "146",
    "Y": 19,
    "L": 50.3531741814951,
    "a": 9.08790836301604,
    "b": -15.8477392774012,
    "C": 18.268577356189,
    "h": -1.05012663563135,
    "CMY_C": 0.5198489,
    "CMY_M": 0.5452605,
    "CMY_Y": 0.4288046,
    "CMYK_C": 0.1593926,
    "CMYK_M": 0.203881,
    "CMYK_Y": 0,
    "CMYK_K": 0.4288046
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1046",
    "Farbtonhilfsbezeichnung": "Amethyst 110",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "143",
    "Bcolor": "162",
    "Y": 29,
    "L": 60.3274011371643,
    "a": 5.01791710839072,
    "b": -9.86169085155997,
    "C": 11.0649192748263,
    "h": -1.10011026395782,
    "CMY_C": 0.426302,
    "CMY_M": 0.4377386,
    "CMY_Y": 0.3665752,
    "CMYK_C": 0.09429178,
    "CMYK_M": 0.112347,
    "CMYK_Y": 0,
    "CMYK_K": 0.3665752
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1047",
    "Farbtonhilfsbezeichnung": "Amethyst 115",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "198",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.7779972124585,
    "a": 5.18571892026548,
    "b": -8.36646602873383,
    "C": 9.84324309005709,
    "h": -1.01592925318536,
    "CMY_C": 0.2028124,
    "CMY_M": 0.2229867,
    "CMY_Y": 0.1587482,
    "CMYK_C": 0.05237938,
    "CMYK_M": 0.07636064,
    "CMYK_Y": 0,
    "CMYK_K": 0.1587482
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1048",
    "Farbtonhilfsbezeichnung": "Amethyst 120",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 77,
    "L": 89.8941911515031,
    "a": 2.89303989954703,
    "b": -3.34089168526226,
    "C": 4.41941592442096,
    "h": -0.85711593627397,
    "CMY_C": 0.1022989,
    "CMY_M": 0.1189093,
    "CMY_Y": 0.09525476,
    "CMYK_C": 0.007785756,
    "CMYK_M": 0.02614499,
    "CMYK_Y": 0,
    "CMYK_K": 0.09525476
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1049",
    "Farbtonhilfsbezeichnung": "Amethyst 65",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "70",
    "Bcolor": "85",
    "Y": 6,
    "L": 30.5084256409547,
    "a": 4.3278686456184,
    "b": -8.96447415729146,
    "C": 9.95450872371275,
    "h": -1.12101939240492,
    "CMY_C": 0.7179573,
    "CMY_M": 0.7244498,
    "CMY_Y": 0.6664929,
    "CMYK_C": 0.1543127,
    "CMYK_M": 0.1737799,
    "CMYK_Y": 0,
    "CMYK_K": 0.6664929
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1050",
    "Farbtonhilfsbezeichnung": "Atmo 5",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "173",
    "Bcolor": "181",
    "Y": 42,
    "L": 71.1528238027326,
    "a": 2.72157291414254,
    "b": -4.65397136331167,
    "C": 5.39132716290891,
    "h": -1.04163941057076,
    "CMY_C": 0.312087,
    "CMY_M": 0.3214304,
    "CMY_Y": 0.2892287,
    "CMYK_C": 0.03215975,
    "CMYK_M": 0.04530516,
    "CMYK_Y": 0,
    "CMYK_K": 0.2892287
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1051",
    "Farbtonhilfsbezeichnung": "Atmo 10",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "186",
    "Bcolor": "193",
    "Y": 50,
    "L": 75.9720615856915,
    "a": 3.01029782922019,
    "b": -4.14563241842285,
    "C": 5.12329592833425,
    "h": -0.94274315162937,
    "CMY_C": 0.2566644,
    "CMY_M": 0.2709303,
    "CMY_Y": 0.241373,
    "CMYK_C": 0.02015658,
    "CMYK_M": 0.0389616,
    "CMYK_Y": 0,
    "CMYK_K": 0.241373
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1052",
    "Farbtonhilfsbezeichnung": "Atmo 15",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "200",
    "Bcolor": "205",
    "Y": 58,
    "L": 80.8729467661357,
    "a": 2.18903368060647,
    "b": -3.08462387340267,
    "C": 3.7824294963945,
    "h": -0.95361662736558,
    "CMY_C": 0.2062812,
    "CMY_M": 0.2164193,
    "CMY_Y": 0.1962,
    "CMYK_C": 0.01254191,
    "CMYK_M": 0.02515465,
    "CMYK_Y": 0,
    "CMYK_K": 0.1962
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1053",
    "Farbtonhilfsbezeichnung": "Atmo 20",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "226",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.1655884969359,
    "a": 1.8673025054402,
    "b": -0.50645352145455,
    "C": 1.93476453766782,
    "h": -0.26485045362971,
    "CMY_C": 0.09753344,
    "CMY_M": 0.1142586,
    "CMY_Y": 0.1133118,
    "CMYK_C": 0,
    "CMYK_M": 0.0185327,
    "CMYK_Y": 0.01748355,
    "CMYK_K": 0.09753344
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1054",
    "Farbtonhilfsbezeichnung": "Atmo 25",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "232",
    "Bcolor": "229",
    "Y": 82,
    "L": 92.1506567440075,
    "a": 0.85547618219927,
    "b": 1.04477668342073,
    "C": 1.35033248369795,
    "h": 0.88468916282587,
    "CMY_C": 0.07804188,
    "CMY_M": 0.0901539,
    "CMY_Y": 0.1029786,
    "CMYK_C": 0,
    "CMYK_M": 0.01313728,
    "CMYK_Y": 0.02704762,
    "CMYK_K": 0.07804188
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1055",
    "Farbtonhilfsbezeichnung": "Viola 5",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "127",
    "Bcolor": "138",
    "Y": 22,
    "L": 53.9676971435547,
    "a": 5.30794954299927,
    "b": -5.80937051773071,
    "C": 7.86912393569946,
    "h": 312.417541503906,
    "CMY_C": 0.47498458623886,
    "CMY_M": 0.5038822889328,
    "CMY_Y": 0.45891934633255,
    "CMYK_C": 0.02969102561474,
    "CMYK_M": 0.08309841156006,
    "CMYK_Y": 0,
    "CMYK_K": 0.45891934633255
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1056",
    "Farbtonhilfsbezeichnung": "Viola 10",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "156",
    "Bcolor": "164",
    "Y": 35,
    "L": 65.1462326049805,
    "a": 4.03405714035034,
    "b": -4.10412120819092,
    "C": 5.75477457046509,
    "h": 314.506744384766,
    "CMY_C": 0.36366528272629,
    "CMY_M": 0.38754445314407,
    "CMY_Y": 0.35601705312729,
    "CMYK_C": 0.01187644712627,
    "CMYK_M": 0.04895688593388,
    "CMYK_Y": 0,
    "CMYK_K": 0.35601705312729
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1057",
    "Farbtonhilfsbezeichnung": "Viola 15",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "185",
    "Bcolor": "189",
    "Y": 50,
    "L": 75.5149917602539,
    "a": 2.03981113433838,
    "b": -2.19549512863159,
    "C": 2.9968364238739,
    "h": 312.894836425781,
    "CMY_C": 0.26231473684311,
    "CMY_M": 0.27410459518433,
    "CMY_Y": 0.26027292013168,
    "CMYK_C": 0.00276022986509,
    "CMYK_M": 0.01869834959507,
    "CMYK_Y": 0,
    "CMYK_K": 0.26027292013168
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1058",
    "Farbtonhilfsbezeichnung": "Viola 20",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "213",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.2821197509766,
    "a": 0.99212956428528,
    "b": -0.95543855428696,
    "C": 1.37738299369812,
    "h": 316.079284667969,
    "CMY_C": 0.15999644994736,
    "CMY_M": 0.1660019159317,
    "CMY_Y": 0.16380149126053,
    "CMYK_C": 0,
    "CMYK_M": 0.00714933406562,
    "CMYK_Y": 0.00452979188412,
    "CMYK_K": 0.15999644994736
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1059",
    "Farbtonhilfsbezeichnung": "Viola 25",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "226",
    "Bcolor": "223",
    "Y": 78,
    "L": 90.1380157470703,
    "a": 0.54659461975098,
    "b": 0.94617229700089,
    "C": 1.09270656108856,
    "h": 59.9853858947754,
    "CMY_C": 0.10326701402664,
    "CMY_M": 0.11179435253143,
    "CMY_Y": 0.12452840805054,
    "CMYK_C": 0,
    "CMYK_M": 0.00950933992863,
    "CMYK_Y": 0.02370983734727,
    "CMYK_K": 0.10326701402664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1060",
    "Farbtonhilfsbezeichnung": "Viola 30",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "233",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.4752502441406,
    "a": 0.3648370206356,
    "b": 1.8731564283371,
    "C": 1.90835559368134,
    "h": 78.9784164428711,
    "CMY_C": 0.0754685997963,
    "CMY_M": 0.08555555343628,
    "CMY_Y": 0.10560518503189,
    "CMYK_C": 0,
    "CMYK_M": 0.01091034151614,
    "CMYK_Y": 0.03259660676122,
    "CMYK_K": 0.0754685997963
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1061",
    "Farbtonhilfsbezeichnung": "Viola 35",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "91",
    "Bcolor": "106",
    "Y": 11,
    "L": 40.3338470458984,
    "a": 7.84448575973511,
    "b": -7.39598226547241,
    "C": 10.7813034057617,
    "h": 316.685638427734,
    "CMY_C": 0.59741365909576,
    "CMY_M": 0.64176344871521,
    "CMY_Y": 0.5828765630722,
    "CMYK_C": 0.0348508246243,
    "CMYK_M": 0.14117376506329,
    "CMYK_Y": 0,
    "CMYK_K": 0.5828765630722
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1062",
    "Farbtonhilfsbezeichnung": "Viola 40",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "124",
    "Bcolor": "137",
    "Y": 21,
    "L": 53.4364395141602,
    "a": 7.75135326385498,
    "b": -6.11412191390991,
    "C": 9.87248516082764,
    "h": 321.734283447266,
    "CMY_C": 0.46431165933609,
    "CMY_M": 0.51470863819122,
    "CMY_Y": 0.4619665145874,
    "CMYK_C": 0.0043587340042,
    "CMYK_M": 0.09802758693695,
    "CMYK_Y": 0,
    "CMYK_K": 0.4619665145874
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1063",
    "Farbtonhilfsbezeichnung": "Viola 45",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "153",
    "Bcolor": "168",
    "Y": 35,
    "L": 64.8508682250977,
    "a": 7.91317462921143,
    "b": -6.75019073486328,
    "C": 10.4011249542236,
    "h": 319.534759521484,
    "CMY_C": 0.34730821847916,
    "CMY_M": 0.39892864227295,
    "CMY_Y": 0.34037840366364,
    "CMYK_C": 0.01050574239343,
    "CMYK_M": 0.08876337110996,
    "CMYK_Y": 0,
    "CMYK_K": 0.34037840366364
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1064",
    "Farbtonhilfsbezeichnung": "Viola 50",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "182",
    "Bcolor": "193",
    "Y": 50,
    "L": 75.3376693725586,
    "a": 6.05121374130249,
    "b": -4.71557188034058,
    "C": 7.67162322998047,
    "h": 322.071533203125,
    "CMY_C": 0.24246025085449,
    "CMY_M": 0.28474307060242,
    "CMY_Y": 0.24373537302017,
    "CMYK_C": 0,
    "CMYK_M": 0.05581597611308,
    "CMYK_Y": 0.00168324122205,
    "CMYK_K": 0.24246025085449
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1065",
    "Farbtonhilfsbezeichnung": "Viola 55",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "212",
    "Bcolor": "218",
    "Y": 67,
    "L": 85.6536865234375,
    "a": 4.1071252822876,
    "b": -2.72390174865723,
    "C": 4.928297996521,
    "h": 326.447113037109,
    "CMY_C": 0.13775163888931,
    "CMY_M": 0.16884309053421,
    "CMY_Y": 0.14640301465988,
    "CMYK_C": 0,
    "CMYK_M": 0.03605857864022,
    "CMYK_Y": 0.01003350783139,
    "CMYK_K": 0.13775163888931
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1066",
    "Farbtonhilfsbezeichnung": "Viola 60",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "233",
    "Y": 83,
    "L": 92.8667678833008,
    "a": 2.75543022155762,
    "b": -0.18537431955338,
    "C": 2.76165890693665,
    "h": 356.151153564453,
    "CMY_C": 0.05923098325729,
    "CMY_M": 0.08634871244431,
    "CMY_Y": 0.08563214540482,
    "CMYK_C": 0,
    "CMYK_M": 0.0288250669837,
    "CMYK_Y": 0.02806338481605,
    "CMYK_K": 0.05923098325729
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1067",
    "Farbtonhilfsbezeichnung": "Viola 65",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "90",
    "Bcolor": "113",
    "Y": 11,
    "L": 40.708423614502,
    "a": 11.3419981002808,
    "b": -10.7586555480957,
    "C": 15.6329650878906,
    "h": 316.511962890625,
    "CMY_C": 0.58151167631149,
    "CMY_M": 0.64529991149902,
    "CMY_Y": 0.55767947435379,
    "CMYK_C": 0.05387993529439,
    "CMYK_M": 0.19809263944626,
    "CMYK_Y": 0,
    "CMYK_K": 0.55767947435379
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1068",
    "Farbtonhilfsbezeichnung": "Viola 70",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "100",
    "Bcolor": "127",
    "Y": 14,
    "L": 45.0415458679199,
    "a": 13.657114982605,
    "b": -12.881965637207,
    "C": 18.7739658355713,
    "h": 316.673004150391,
    "CMY_C": 0.53052091598511,
    "CMY_M": 0.60891592502594,
    "CMY_Y": 0.50121307373047,
    "CMYK_C": 0.05875824019313,
    "CMYK_M": 0.21592958271503,
    "CMYK_Y": 0,
    "CMYK_K": 0.50121307373047
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1069",
    "Farbtonhilfsbezeichnung": "Viola 75",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "114",
    "Bcolor": "134",
    "Y": 18,
    "L": 49.868896484375,
    "a": 9.84511089324951,
    "b": -9.33389186859131,
    "C": 13.5664196014404,
    "h": 316.52685546875,
    "CMY_C": 0.49626636505127,
    "CMY_M": 0.55393147468567,
    "CMY_Y": 0.47639006376266,
    "CMYK_C": 0.03796013072133,
    "CMYK_M": 0.14809003472328,
    "CMYK_Y": 0,
    "CMYK_K": 0.47639006376266
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1070",
    "Farbtonhilfsbezeichnung": "Viola 80",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "152",
    "Bcolor": "175",
    "Y": 34,
    "L": 64.9763488769531,
    "a": 11.4976024627685,
    "b": -10.178412437439,
    "C": 15.3556156158447,
    "h": 318.482696533203,
    "CMY_C": 0.33167368173599,
    "CMY_M": 0.40529137849808,
    "CMY_Y": 0.31500554084778,
    "CMYK_C": 0.02433324977756,
    "CMYK_M": 0.13180521130562,
    "CMYK_Y": 0,
    "CMYK_K": 0.31500554084778
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1071",
    "Farbtonhilfsbezeichnung": "Viola 85",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "181",
    "Bcolor": "204",
    "Y": 49,
    "L": 75.6778945922852,
    "a": 10.8467130661011,
    "b": -10.009467124939,
    "C": 14.7594242095947,
    "h": 317.298828125,
    "CMY_C": 0.22108769416809,
    "CMY_M": 0.29124057292938,
    "CMY_Y": 0.20183801651001,
    "CMYK_C": 0.0241175070405,
    "CMYK_M": 0.11201053857803,
    "CMYK_Y": 0,
    "CMYK_K": 0.20183801651001
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1072",
    "Farbtonhilfsbezeichnung": "Viola 90",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "210",
    "Bcolor": "223",
    "Y": 68,
    "L": 85.6935043334961,
    "a": 7.55262136459351,
    "b": -5.27231168746948,
    "C": 9.21082878112793,
    "h": 325.082000732422,
    "CMY_C": 0.11955589056015,
    "CMY_M": 0.17608851194382,
    "CMY_Y": 0.12690478563309,
    "CMYK_C": 0,
    "CMYK_M": 0.06420920789242,
    "CMYK_Y": 0.00834680441767,
    "CMYK_K": 0.11955589056015
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1073",
    "Farbtonhilfsbezeichnung": "Viola 95",
    "Farbtonklasse": "04",
    "Rcolor": "86",
    "Gcolor": "67",
    "Bcolor": "94",
    "Y": 6,
    "L": 31.2917766571045,
    "a": 14.3760585784912,
    "b": -13.3760099411011,
    "C": 19.6364135742188,
    "h": 317.063781738281,
    "CMY_C": 0.66096389293671,
    "CMY_M": 0.73874497413635,
    "CMY_Y": 0.63159650564194,
    "CMYK_C": 0.07971528172493,
    "CMYK_M": 0.29084542393684,
    "CMYK_Y": 0,
    "CMYK_K": 0.63159650564194
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1074",
    "Farbtonhilfsbezeichnung": "Viola 100",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "83",
    "Bcolor": "121",
    "Y": 11,
    "L": 39.5739212036133,
    "a": 19.9510803222656,
    "b": -17.4916915893555,
    "C": 26.5330905914307,
    "h": 318.758026123047,
    "CMY_C": 0.55933725833893,
    "CMY_M": 0.67552018165588,
    "CMY_Y": 0.52549254894257,
    "CMYK_C": 0.07132598012686,
    "CMYK_M": 0.31617549061775,
    "CMYK_Y": 0,
    "CMYK_K": 0.52549254894257
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1075",
    "Farbtonhilfsbezeichnung": "Viola 105",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "106",
    "Bcolor": "152",
    "Y": 19,
    "L": 49.9166488647461,
    "a": 23.6385192871094,
    "b": -20.2270851135254,
    "C": 31.1113262176514,
    "h": 319.446960449219,
    "CMY_C": 0.43987107276917,
    "CMY_M": 0.58541524410248,
    "CMY_Y": 0.40298998355865,
    "CMYK_C": 0.0617763325572,
    "CMYK_M": 0.30556482076645,
    "CMYK_Y": 0,
    "CMYK_K": 0.40298998355865
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1076",
    "Farbtonhilfsbezeichnung": "Viola 110",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "105",
    "Bcolor": "139",
    "Y": 17,
    "L": 48.2296905517578,
    "a": 17.6526298522949,
    "b": -14.8186950683594,
    "C": 23.0479736328125,
    "h": 319.987854003906,
    "CMY_C": 0.47847503423691,
    "CMY_M": 0.58758509159088,
    "CMY_Y": 0.45624190568924,
    "CMYK_C": 0.04088790342212,
    "CMYK_M": 0.24154709279537,
    "CMYK_Y": 0,
    "CMYK_K": 0.45624190568924
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1077",
    "Farbtonhilfsbezeichnung": "Viola 115",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "136",
    "Bcolor": "169",
    "Y": 29,
    "L": 59.8323402404785,
    "a": 15.3874225616455,
    "b": -14.9428586959839,
    "C": 21.4490509033203,
    "h": 315.839752197266,
    "CMY_C": 0.37449413537979,
    "CMY_M": 0.46622276306152,
    "CMY_Y": 0.33605486154556,
    "CMYK_C": 0.05789525434375,
    "CMYK_M": 0.19605219364166,
    "CMYK_Y": 0,
    "CMYK_K": 0.33605486154556
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1078",
    "Farbtonhilfsbezeichnung": "Viola 120",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "164",
    "Bcolor": "191",
    "Y": 42,
    "L": 70.0230331420898,
    "a": 14.1155452728272,
    "b": -11.8660688400269,
    "C": 18.4405040740967,
    "h": 319.948303222656,
    "CMY_C": 0.26473331451416,
    "CMY_M": 0.35877639055252,
    "CMY_Y": 0.2493155002594,
    "CMYK_C": 0.020538341254,
    "CMYK_M": 0.14581477642059,
    "CMYK_Y": 0,
    "CMYK_K": 0.2493155002594
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1079",
    "Farbtonhilfsbezeichnung": "Clematis 5",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "104",
    "Bcolor": "113",
    "Y": 14,
    "L": 45.4466161348337,
    "a": 7.69255935532598,
    "b": -3.86323527471433,
    "C": 8.60813895235261,
    "h": -0.46540937829513,
    "CMY_C": 0.5379266,
    "CMY_M": 0.5936271,
    "CMY_Y": 0.5558532,
    "CMYK_C": 0,
    "CMYK_M": 0.1205447,
    "CMYK_Y": 0.03879595,
    "CMYK_K": 0.5379266
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1080",
    "Farbtonhilfsbezeichnung": "Clematis 10",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "127",
    "Bcolor": "135",
    "Y": 22,
    "L": 54.5273903659284,
    "a": 6.57289949439543,
    "b": -3.23858785816753,
    "C": 7.32744560392596,
    "h": -0.45780529766798,
    "CMY_C": 0.4524768,
    "CMY_M": 0.5019395,
    "CMY_Y": 0.4702344,
    "CMYK_C": 0,
    "CMYK_M": 0.09033906,
    "CMYK_Y": 0.03243259,
    "CMYK_K": 0.4524768
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1081",
    "Farbtonhilfsbezeichnung": "Clematis 15",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "156",
    "Bcolor": "161",
    "Y": 34,
    "L": 65.4916579886773,
    "a": 4.80857724732747,
    "b": -1.67575732699263,
    "C": 5.09220755296609,
    "h": -0.33533198690143,
    "CMY_C": 0.3466462,
    "CMY_M": 0.3864683,
    "CMY_Y": 0.3690927,
    "CMYK_C": 0,
    "CMYK_M": 0.06095021,
    "CMYK_Y": 0.03435573,
    "CMYK_K": 0.3466462
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1082",
    "Farbtonhilfsbezeichnung": "Clematis 20",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "185",
    "Bcolor": "185",
    "Y": 49,
    "L": 75.5898693382733,
    "a": 2.73275713363264,
    "b": 0.09724084284996,
    "C": 2.73448666717141,
    "h": 0.03556841233484,
    "CMY_C": 0.2487722,
    "CMY_M": 0.2755938,
    "CMY_Y": 0.2756966,
    "CMYK_C": 0,
    "CMYK_M": 0.03570374,
    "CMYK_Y": 0.03584052,
    "CMYK_K": 0.2487722
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1083",
    "Farbtonhilfsbezeichnung": "Clematis 25",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "213",
    "Bcolor": "210",
    "Y": 67,
    "L": 85.4522606600872,
    "a": 1.32302998028994,
    "b": 0.8323664632017,
    "C": 1.5630874120819,
    "h": 0.56156835516958,
    "CMY_C": 0.1495458,
    "CMY_M": 0.165453,
    "CMY_Y": 0.1749535,
    "CMYK_C": 0,
    "CMYK_M": 0.01870429,
    "CMYK_Y": 0.02987537,
    "CMYK_K": 0.1495458
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1084",
    "Farbtonhilfsbezeichnung": "Clematis 30",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "226",
    "Bcolor": "221",
    "Y": 77,
    "L": 89.9081486825785,
    "a": 0.37002379018369,
    "b": 2.05525281848415,
    "C": 2.08829637580229,
    "h": 1.39266649500641,
    "CMY_C": 0.1035095,
    "CMY_M": 0.1142755,
    "CMY_Y": 0.1352769,
    "CMYK_C": 0,
    "CMYK_M": 0.0120091,
    "CMYK_Y": 0.0354353,
    "CMYK_K": 0.1035095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1085",
    "Farbtonhilfsbezeichnung": "Clematis 35",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "89",
    "Bcolor": "106",
    "Y": 11,
    "L": 41.0923886129753,
    "a": 13.9806352588027,
    "b": -5.90330241859683,
    "C": 15.1758736712286,
    "h": -0.39953780495712,
    "CMY_C": 0.5469695,
    "CMY_M": 0.6496687,
    "CMY_Y": 0.5842846,
    "CMYK_C": 0,
    "CMYK_M": 0.2266938,
    "CMYK_Y": 0.08236779,
    "CMYK_K": 0.5469695
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1086",
    "Farbtonhilfsbezeichnung": "Clematis 40",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "112",
    "Bcolor": "125",
    "Y": 18,
    "L": 49.4460849749802,
    "a": 11.1661552635233,
    "b": -5.13144874343854,
    "C": 12.2888074920086,
    "h": -0.43077037989132,
    "CMY_C": 0.4789353,
    "CMY_M": 0.5625539,
    "CMY_Y": 0.5079235,
    "CMYK_C": 0,
    "CMYK_M": 0.1604764,
    "CMYK_Y": 0.05563268,
    "CMYK_K": 0.4789353
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1087",
    "Farbtonhilfsbezeichnung": "Clematis 45",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "139",
    "Bcolor": "148",
    "Y": 27,
    "L": 59.8696801763607,
    "a": 10.0323629227405,
    "b": -2.88150571826127,
    "C": 10.4379778222581,
    "h": -0.27969214140981,
    "CMY_C": 0.3727389,
    "CMY_M": 0.4563481,
    "CMY_Y": 0.4180582,
    "CMYK_C": 0,
    "CMYK_M": 0.1332925,
    "CMYK_Y": 0.07224949,
    "CMYK_K": 0.3727389
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1088",
    "Farbtonhilfsbezeichnung": "Clematis 50",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "169",
    "Bcolor": "176",
    "Y": 42,
    "L": 71.0193665942444,
    "a": 8.06218355858707,
    "b": -1.87515426184792,
    "C": 8.27737924938069,
    "h": -0.2285234509821,
    "CMY_C": 0.2652282,
    "CMY_M": 0.3363152,
    "CMY_Y": 0.3094617,
    "CMYK_C": 0,
    "CMYK_M": 0.09674712,
    "CMYK_Y": 0.06020038,
    "CMYK_K": 0.2652282
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1089",
    "Farbtonhilfsbezeichnung": "Clematis 55",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "196",
    "Bcolor": "199",
    "Y": 57,
    "L": 80.3088129790946,
    "a": 6.2445793464036,
    "b": -0.58338915434501,
    "C": 6.27177121066592,
    "h": -0.09315290892649,
    "CMY_C": 0.1734991,
    "CMY_M": 0.2329909,
    "CMY_Y": 0.2197884,
    "CMYK_C": 0,
    "CMYK_M": 0.07198034,
    "CMYK_Y": 0.05600634,
    "CMYK_K": 0.1734991
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1090",
    "Farbtonhilfsbezeichnung": "Clematis 60",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "223",
    "Y": 77,
    "L": 90.2489188432027,
    "a": 4.23852245969758,
    "b": 1.50681984312235,
    "C": 4.49839734583197,
    "h": 0.34157142856045,
    "CMY_C": 0.07159659,
    "CMY_M": 0.1196697,
    "CMY_Y": 0.1269276,
    "CMYK_C": 0,
    "CMYK_M": 0.05178047,
    "CMYK_Y": 0.05959798,
    "CMYK_K": 0.07159659
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1091",
    "Farbtonhilfsbezeichnung": "Clematis 65",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "67",
    "Bcolor": "93",
    "Y": 7,
    "L": 33.276078275921,
    "a": 20.2648889826444,
    "b": -9.28824984086924,
    "C": 22.2920907629883,
    "h": -0.42976944506189,
    "CMY_C": 0.5959263,
    "CMY_M": 0.7378425,
    "CMY_Y": 0.6370426,
    "CMYK_C": 0,
    "CMYK_M": 0.3512137,
    "CMYK_Y": 0.1017544,
    "CMYK_K": 0.5959263
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1092",
    "Farbtonhilfsbezeichnung": "Clematis 70",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "79",
    "Bcolor": "116",
    "Y": 12,
    "L": 41.2970914074027,
    "a": 29.1155363793841,
    "b": -11.5468507790977,
    "C": 31.3216254618752,
    "h": -0.37756090161835,
    "CMY_C": 0.4706961,
    "CMY_M": 0.6889028,
    "CMY_Y": 0.5449871,
    "CMYK_C": 0,
    "CMYK_M": 0.4122522,
    "CMYK_Y": 0.1403561,
    "CMYK_K": 0.4706961
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1093",
    "Farbtonhilfsbezeichnung": "Clematis 75",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "98",
    "Bcolor": "118",
    "Y": 14,
    "L": 45.3996721908002,
    "a": 17.1307789457828,
    "b": -6.75203827662121,
    "C": 18.4134083802601,
    "h": -0.37545018012215,
    "CMY_C": 0.486783,
    "CMY_M": 0.6163879,
    "CMY_Y": 0.5366458,
    "CMYK_C": 0,
    "CMYK_M": 0.2525343,
    "CMYK_Y": 0.09715725,
    "CMYK_K": 0.486783
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1094",
    "Farbtonhilfsbezeichnung": "Clematis 80",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "110",
    "Bcolor": "131",
    "Y": 18,
    "L": 50.7228818764876,
    "a": 18.4049467428576,
    "b": -6.57960424488884,
    "C": 19.5456710457017,
    "h": -0.34333273538431,
    "CMY_C": 0.4238239,
    "CMY_M": 0.5680289,
    "CMY_Y": 0.4848614,
    "CMYK_C": 0,
    "CMYK_M": 0.2502795,
    "CMYK_Y": 0.1059355,
    "CMYK_K": 0.4238239
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1095",
    "Farbtonhilfsbezeichnung": "Clematis 85",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "152",
    "Bcolor": "168",
    "Y": 35,
    "L": 65.70323124052,
    "a": 13.3482927176711,
    "b": -5.05649917530648,
    "C": 14.2739308666711,
    "h": -0.36210887645764,
    "CMY_C": 0.2948339,
    "CMY_M": 0.4040738,
    "CMY_Y": 0.3424582,
    "CMYK_C": 0,
    "CMYK_M": 0.1549137,
    "CMYK_Y": 0.0675364,
    "CMYK_K": 0.2948339
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1096",
    "Farbtonhilfsbezeichnung": "Clematis 90",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "210",
    "Bcolor": "215",
    "Y": 67,
    "L": 86.1036504065095,
    "a": 9.54209068349526,
    "b": -0.45390263999645,
    "C": 9.55288031007627,
    "h": -0.04753263845806,
    "CMY_C": 0.08446305,
    "CMY_M": 0.1780843,
    "CMY_Y": 0.1572976,
    "CMYK_C": 0,
    "CMYK_M": 0.1022583,
    "CMYK_Y": 0.0795539,
    "CMYK_K": 0.08446305
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1097",
    "Farbtonhilfsbezeichnung": "Flamenco 5",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "121",
    "Bcolor": "122",
    "Y": 19,
    "L": 51.3415412902832,
    "a": 3.20706248283386,
    "b": -0.37069508433342,
    "C": 3.2284152507782,
    "h": 353.406616210938,
    "CMY_C": 0.49914562702179,
    "CMY_M": 0.52682971954346,
    "CMY_Y": 0.52135670185089,
    "CMYK_C": 0,
    "CMYK_M": 0.0552737377584,
    "CMYK_Y": 0.04434637352824,
    "CMYK_K": 0.49914562702179
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1098",
    "Farbtonhilfsbezeichnung": "Flamenco 10",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "171",
    "Bcolor": "173",
    "Y": 42,
    "L": 70.8163070678711,
    "a": 4.01195383071899,
    "b": -0.56103497743607,
    "C": 4.05099153518677,
    "h": 352.039337158203,
    "CMY_C": 0.29256796836853,
    "CMY_M": 0.32913285493851,
    "CMY_Y": 0.32135736942291,
    "CMYK_C": 0,
    "CMYK_M": 0.05168678238988,
    "CMYK_Y": 0.04069564118981,
    "CMYK_K": 0.29256796836853
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1099",
    "Farbtonhilfsbezeichnung": "Flamenco 15",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "198",
    "Bcolor": "198",
    "Y": 58,
    "L": 80.5779418945313,
    "a": 3.13574552536011,
    "b": 0.25999683141708,
    "C": 3.14650583267212,
    "h": 4.73977375030518,
    "CMY_C": 0.19107836484909,
    "CMY_M": 0.22279667854309,
    "CMY_Y": 0.22338837385178,
    "CMYK_C": 0,
    "CMYK_M": 0.03921061381698,
    "CMYK_Y": 0.03994207456708,
    "CMYK_K": 0.19107836484909
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1100",
    "Farbtonhilfsbezeichnung": "Flamenco 20",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "213",
    "Bcolor": "211",
    "Y": 67,
    "L": 85.6522216796875,
    "a": 2.085369348526,
    "b": 0.87346684932709,
    "C": 2.26090908050537,
    "h": 22.7266044616699,
    "CMY_C": 0.14131820201874,
    "CMY_M": 0.1650470495224,
    "CMY_Y": 0.1729673743248,
    "CMYK_C": 0,
    "CMYK_M": 0.02763403952122,
    "CMYK_Y": 0.03685785830021,
    "CMYK_K": 0.14131820201874
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1101",
    "Farbtonhilfsbezeichnung": "Flamenco 25",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 73,
    "L": 88.1503829956055,
    "a": 1.16694760322571,
    "b": 0.29247760772705,
    "C": 1.20304191112518,
    "h": 14.0704669952393,
    "CMY_C": 0.12270706892014,
    "CMY_M": 0.13513696193695,
    "CMY_Y": 0.14149516820908,
    "CMYK_C": 0,
    "CMYK_M": 0.01416846364737,
    "CMYK_Y": 0.02141599357128,
    "CMYK_K": 0.12270706892014
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1102",
    "Farbtonhilfsbezeichnung": "Flamenco 30",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "232",
    "Bcolor": "228",
    "Y": 83,
    "L": 92.3289794921875,
    "a": 0.99609047174454,
    "b": 1.88629877567291,
    "C": 2.13314771652222,
    "h": 62.1629867553711,
    "CMY_C": 0.07210516929626,
    "CMY_M": 0.08870607614517,
    "CMY_Y": 0.10723203420639,
    "CMYK_C": 0,
    "CMYK_M": 0.01789093576372,
    "CMYK_Y": 0.03785651549697,
    "CMYK_K": 0.07210516929626
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1103",
    "Farbtonhilfsbezeichnung": "Flamenco 35",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "114",
    "Bcolor": "118",
    "Y": 18,
    "L": 49.7843132019043,
    "a": 8.044114112854,
    "b": -0.40847057104111,
    "C": 8.05447864532471,
    "h": 357.093078613281,
    "CMY_C": 0.48267555236816,
    "CMY_M": 0.55312812328339,
    "CMY_Y": 0.53581565618515,
    "CMYK_C": 0,
    "CMYK_M": 0.13618643581867,
    "CMYK_Y": 0.1027210354805,
    "CMYK_K": 0.48267555236816
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1104",
    "Farbtonhilfsbezeichnung": "Flamenco 40",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "140",
    "Bcolor": "145",
    "Y": 28,
    "L": 59.6888580322266,
    "a": 6.13038158416748,
    "b": -1.44221186637878,
    "C": 6.29774188995361,
    "h": 346.761535644531,
    "CMY_C": 0.39713722467422,
    "CMY_M": 0.44928050041199,
    "CMY_Y": 0.43015271425247,
    "CMYK_C": 0,
    "CMYK_M": 0.08649277687073,
    "CMYK_Y": 0.05476451665163,
    "CMYK_K": 0.39713722467422
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1105",
    "Farbtonhilfsbezeichnung": "Flamenco 45",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "155",
    "Bcolor": "159",
    "Y": 35,
    "L": 65.7824859619141,
    "a": 7.81836080551147,
    "b": -0.25849935412407,
    "C": 7.82263326644897,
    "h": 358.106323242188,
    "CMY_C": 0.3180428147316,
    "CMY_M": 0.39094233512878,
    "CMY_Y": 0.37547093629837,
    "CMYK_C": 0,
    "CMYK_M": 0.10689750313759,
    "CMYK_Y": 0.08421074599028,
    "CMYK_K": 0.3180428147316
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1106",
    "Farbtonhilfsbezeichnung": "Flamenco 55",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "200",
    "Bcolor": "201",
    "Y": 59,
    "L": 81.4609146118164,
    "a": 4.74610996246338,
    "b": -0.17815484106541,
    "C": 4.74945259094238,
    "h": 357.850311279297,
    "CMY_C": 0.17070752382278,
    "CMY_M": 0.21694266796112,
    "CMY_Y": 0.21047365665436,
    "CMYK_C": 0,
    "CMYK_M": 0.05575251951814,
    "CMYK_Y": 0.04795188084245,
    "CMYK_K": 0.17070752382278
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1107",
    "Farbtonhilfsbezeichnung": "Flamenco 50",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "173",
    "Bcolor": "176",
    "Y": 43,
    "L": 71.8214340209961,
    "a": 5.42423439025879,
    "b": -0.79882776737213,
    "C": 5.48274040222168,
    "h": 351.622253417969,
    "CMY_C": 0.27228051424026,
    "CMY_M": 0.32177418470383,
    "CMY_Y": 0.30891507863998,
    "CMYK_C": 0,
    "CMYK_M": 0.06801201403141,
    "CMYK_Y": 0.05034160241485,
    "CMYK_K": 0.27228051424026
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1108",
    "Farbtonhilfsbezeichnung": "Flamenco 60",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "227",
    "Bcolor": "223",
    "Y": 77,
    "L": 90.7111968994141,
    "a": 2.50151896476746,
    "b": 2.10043215751648,
    "C": 3.26640653610229,
    "h": 40.0189247131348,
    "CMY_C": 0.07782274484634,
    "CMY_M": 0.11043566465378,
    "CMY_Y": 0.12646794319153,
    "CMYK_C": 0,
    "CMYK_M": 0.03536513075233,
    "CMYK_Y": 0.05275037884712,
    "CMYK_K": 0.07782274484634
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1109",
    "Farbtonhilfsbezeichnung": "Flamenco 65",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "90",
    "Bcolor": "97",
    "Y": 12,
    "L": 40.5010757446289,
    "a": 10.0935792922974,
    "b": -1.36294937133789,
    "C": 10.1851844787598,
    "h": 352.309783935547,
    "CMY_C": 0.56471759080887,
    "CMY_M": 0.64709424972534,
    "CMY_Y": 0.61896324157715,
    "CMYK_C": 0,
    "CMYK_M": 0.18924877047539,
    "CMYK_Y": 0.12462174147367,
    "CMYK_K": 0.56471759080887
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1110",
    "Farbtonhilfsbezeichnung": "Flamenco 70",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "110",
    "Bcolor": "118",
    "Y": 18,
    "L": 49.3484497070313,
    "a": 12.8840637207031,
    "b": -0.63526314496994,
    "C": 12.899715423584,
    "h": 357.17724609375,
    "CMY_C": 0.45694571733475,
    "CMY_M": 0.56899619102478,
    "CMY_Y": 0.53798234462738,
    "CMYK_C": 0,
    "CMYK_M": 0.20633383095264,
    "CMYK_Y": 0.14922380447388,
    "CMYK_K": 0.45694571733475
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1111",
    "Farbtonhilfsbezeichnung": "Flamenco 75",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "138",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.9516677856445,
    "a": 11.2907075881958,
    "b": -1.07362937927246,
    "C": 11.3416385650635,
    "h": 354.568084716797,
    "CMY_C": 0.35831964015961,
    "CMY_M": 0.4590921998024,
    "CMY_Y": 0.42930054664612,
    "CMYK_C": 0,
    "CMYK_M": 0.15704479813576,
    "CMYK_Y": 0.11061723530293,
    "CMYK_K": 0.35831964015961
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1112",
    "Farbtonhilfsbezeichnung": "Flamenco 80",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "167",
    "Bcolor": "172",
    "Y": 42,
    "L": 70.6791229248047,
    "a": 9.69319820404053,
    "b": 0.1048578992486,
    "C": 9.69376564025879,
    "h": 0.61978316307068,
    "CMY_C": 0.25150901079178,
    "CMY_M": 0.344442486763,
    "CMY_Y": 0.32670050859451,
    "CMYK_C": 0,
    "CMYK_M": 0.12416111677885,
    "CMYK_Y": 0.10045745223761,
    "CMYK_K": 0.25150901079178
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1113",
    "Farbtonhilfsbezeichnung": "Flamenco 85",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "196",
    "Bcolor": "198",
    "Y": 58,
    "L": 80.7554626464844,
    "a": 7.33617115020752,
    "b": 0.74578827619553,
    "C": 7.37398195266724,
    "h": 5.80469369888306,
    "CMY_C": 0.15642821788788,
    "CMY_M": 0.23118263483047,
    "CMY_Y": 0.22439551353455,
    "CMYK_C": 0,
    "CMYK_M": 0.08861654251814,
    "CMYK_Y": 0.08057084679604,
    "CMYK_K": 0.15642821788788
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1114",
    "Farbtonhilfsbezeichnung": "Flamenco 90",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 82,
    "L": 92.4992599487305,
    "a": 4.45943164825439,
    "b": 1.67334711551666,
    "C": 4.76304769515991,
    "h": 20.5679874420166,
    "CMY_C": 0.04403924942017,
    "CMY_M": 0.09516817331314,
    "CMY_Y": 0.10327237844467,
    "CMYK_C": 0,
    "CMYK_M": 0.05348433554173,
    "CMYK_Y": 0.06196188554168,
    "CMYK_K": 0.04403924942017
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1115",
    "Farbtonhilfsbezeichnung": "Flamenco 95",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "88",
    "Bcolor": "98",
    "Y": 12,
    "L": 41.0722885131836,
    "a": 15.8273372650147,
    "b": -1.01634919643402,
    "C": 15.8599357604981,
    "h": 356.325805664063,
    "CMY_C": 0.52411025762558,
    "CMY_M": 0.6559716463089,
    "CMY_Y": 0.61499977111816,
    "CMYK_C": 0,
    "CMYK_M": 0.2770839035511,
    "CMYK_Y": 0.19098860025406,
    "CMYK_K": 0.52411025762558
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1116",
    "Farbtonhilfsbezeichnung": "Flamenco 100",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "95",
    "Bcolor": "108",
    "Y": 14,
    "L": 45.2264289855957,
    "a": 19.3431549072266,
    "b": -0.97108656167984,
    "C": 19.3675155639648,
    "h": 357.1259765625,
    "CMY_C": 0.4612420797348,
    "CMY_M": 0.62572908401489,
    "CMY_Y": 0.5750560760498,
    "CMYK_C": 0,
    "CMYK_M": 0.30530780553818,
    "CMYK_Y": 0.21125257015228,
    "CMYK_K": 0.4612420797348
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1117",
    "Farbtonhilfsbezeichnung": "Flamenco 105",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "134",
    "Bcolor": "146",
    "Y": 28,
    "L": 59.916316986084,
    "a": 16.4662933349609,
    "b": -1.35019850730896,
    "C": 16.5215568542481,
    "h": 355.312377929688,
    "CMY_C": 0.32563555240631,
    "CMY_M": 0.47257030010223,
    "CMY_Y": 0.42709356546402,
    "CMYK_C": 0,
    "CMYK_M": 0.2178862541914,
    "CMYK_Y": 0.15044982731342,
    "CMYK_K": 0.32563555240631
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1118",
    "Farbtonhilfsbezeichnung": "Flamenco 110",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "163",
    "Bcolor": "172",
    "Y": 42,
    "L": 70.4206085205078,
    "a": 14.3933219909668,
    "b": -0.27179485559464,
    "C": 14.3958883285523,
    "h": 358.918182373047,
    "CMY_C": 0.22309595346451,
    "CMY_M": 0.35896962881088,
    "CMY_Y": 0.32612586021423,
    "CMYK_C": 0,
    "CMYK_M": 0.17489118874073,
    "CMYK_Y": 0.13261599838734,
    "CMYK_K": 0.22309595346451
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1119",
    "Farbtonhilfsbezeichnung": "Flamenco 115",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "193",
    "Bcolor": "199",
    "Y": 58,
    "L": 80.7387161254883,
    "a": 11.9137420654297,
    "b": 0.05865673720837,
    "C": 11.9138860702515,
    "h": 0.28209072351456,
    "CMY_C": 0.12564814090729,
    "CMY_M": 0.24269366264343,
    "CMY_Y": 0.21898084878922,
    "CMYK_C": 0,
    "CMYK_M": 0.1338654756546,
    "CMYK_Y": 0.10674501955509,
    "CMYK_K": 0.12564814090729
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1120",
    "Farbtonhilfsbezeichnung": "Flamenco 120",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "222",
    "Bcolor": "224",
    "Y": 77,
    "L": 90.2326278686523,
    "a": 8.42143821716309,
    "b": 0.84105956554413,
    "C": 8.46333312988281,
    "h": 5.70328903198242,
    "CMY_C": 0.04228496551514,
    "CMY_M": 0.13004523515701,
    "CMY_Y": 0.12159419059753,
    "CMYK_C": 0,
    "CMYK_M": 0.09163505584002,
    "CMYK_Y": 0.08281087875366,
    "CMYK_K": 0.04228496551514
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1121",
    "Farbtonhilfsbezeichnung": "Flamenco 125",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "76",
    "Bcolor": "97",
    "Y": 11,
    "L": 39.9749870300293,
    "a": 28.1947822570801,
    "b": -1.54106962680817,
    "C": 28.2368659973145,
    "h": 356.871429443359,
    "CMY_C": 0.46768647432327,
    "CMY_M": 0.7020737528801,
    "CMY_Y": 0.62044668197632,
    "CMYK_C": 0,
    "CMYK_M": 0.44031810760498,
    "CMYK_Y": 0.286974132061,
    "CMYK_K": 0.46768647432327
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1122",
    "Farbtonhilfsbezeichnung": "Flamenco 130",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "91",
    "Bcolor": "112",
    "Y": 15,
    "L": 46.2215118408203,
    "a": 28.706657409668,
    "b": -1.38357627391815,
    "C": 28.7399806976318,
    "h": 357.240661621094,
    "CMY_C": 0.39852893352509,
    "CMY_M": 0.64366978406906,
    "CMY_Y": 0.56148910522461,
    "CMYK_C": 0,
    "CMYK_M": 0.4075688123703,
    "CMYK_Y": 0.27093601226807,
    "CMYK_K": 0.39852893352509
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1123",
    "Farbtonhilfsbezeichnung": "Flamenco 135",
    "Farbtonklasse": "04",
    "Rcolor": "176",
    "Gcolor": "114",
    "Bcolor": "132",
    "Y": 22,
    "L": 54.9165992736816,
    "a": 27.1151752471924,
    "b": -0.2074388563633,
    "C": 27.1159687042236,
    "h": 359.561676025391,
    "CMY_C": 0.31148654222488,
    "CMY_M": 0.55330747365952,
    "CMY_Y": 0.48370355367661,
    "CMYK_C": 0,
    "CMYK_M": 0.35122179985046,
    "CMYK_Y": 0.25012874603271,
    "CMYK_K": 0.31148654222488
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1124",
    "Farbtonhilfsbezeichnung": "Flamenco 140",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "142",
    "Bcolor": "160",
    "Y": 34,
    "L": 65.3098373413086,
    "a": 25.4101009368896,
    "b": -1.31310963630676,
    "C": 25.4440059661865,
    "h": 357.041778564453,
    "CMY_C": 0.2103179693222,
    "CMY_M": 0.44219779968262,
    "CMY_Y": 0.37065941095352,
    "CMYK_C": 0,
    "CMYK_M": 0.29363694787025,
    "CMYK_Y": 0.20304557681084,
    "CMYK_K": 0.2103179693222
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1125",
    "Farbtonhilfsbezeichnung": "Flamenco 145",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "172",
    "Bcolor": "191",
    "Y": 50,
    "L": 76.1561965942383,
    "a": 25.1500663757324,
    "b": -2.24243521690369,
    "C": 25.2498378753662,
    "h": 354.904846191406,
    "CMY_C": 0.0928909778595,
    "CMY_M": 0.32730305194855,
    "CMY_Y": 0.24990099668503,
    "CMYK_C": 0,
    "CMYK_M": 0.25841665267944,
    "CMYK_Y": 0.17308837175369,
    "CMYK_K": 0.0928909778595
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1126",
    "Farbtonhilfsbezeichnung": "Diva 5",
    "Farbtonklasse": "04",
    "Rcolor": "14",
    "Gcolor": "56",
    "Bcolor": "103",
    "Y": 7,
    "L": 23.3745231628418,
    "a": 4.74101734161377,
    "b": -31.764087677002,
    "C": 32.1159553527832,
    "h": 278.489135742188,
    "CMY_C": 0.94695818424225,
    "CMY_M": 0.77952468395233,
    "CMY_Y": 0.59759145975113,
    "CMYK_C": 0.86818915605545,
    "CMYK_M": 0.45211073756218,
    "CMYK_Y": 0,
    "CMYK_K": 0.59759145975113
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1127",
    "Farbtonhilfsbezeichnung": "Diva 10",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "78",
    "Bcolor": "124",
    "Y": 11,
    "L": 33.3598556518555,
    "a": 5.09628438949585,
    "b": -29.2879791259766,
    "C": 29.7280654907227,
    "h": 279.870971679688,
    "CMY_C": 0.79215967655182,
    "CMY_M": 0.69277036190033,
    "CMY_Y": 0.51449680328369,
    "CMYK_C": 0.5719074010849,
    "CMYK_M": 0.36719337105751,
    "CMYK_Y": 0,
    "CMYK_K": 0.51449680328369
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1128",
    "Farbtonhilfsbezeichnung": "Diva 15",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "59",
    "Bcolor": "106",
    "Y": 9,
    "L": 27.463773727417,
    "a": 14.9501066207886,
    "b": -27.4810428619385,
    "C": 31.2843952178955,
    "h": 298.546875,
    "CMY_C": 0.75026041269302,
    "CMY_M": 0.76841115951538,
    "CMY_Y": 0.58302134275436,
    "CMYK_C": 0.40107345581055,
    "CMYK_M": 0.44460263848305,
    "CMYK_Y": 0,
    "CMYK_K": 0.58302134275436
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1129",
    "Farbtonhilfsbezeichnung": "Diva 20",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "76",
    "Bcolor": "93",
    "Y": 11,
    "L": 33.1314582824707,
    "a": 5.35478067398071,
    "b": -9.81931400299072,
    "C": 11.1844806671143,
    "h": 298.605010986328,
    "CMY_C": 0.68993836641312,
    "CMY_M": 0.70251530408859,
    "CMY_Y": 0.6367067694664,
    "CMYK_C": 0.14652515947819,
    "CMYK_M": 0.18114440143108,
    "CMYK_Y": 0,
    "CMYK_K": 0.6367067694664
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1130",
    "Farbtonhilfsbezeichnung": "Diva 25",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "60",
    "Bcolor": "106",
    "Y": 10,
    "L": 31.5085506439209,
    "a": 25.6701240539551,
    "b": -20.7951202392578,
    "C": 33.0362281799316,
    "h": 320.989410400391,
    "CMY_C": 0.61476409435272,
    "CMY_M": 0.76532649993896,
    "CMY_Y": 0.58345890045166,
    "CMYK_C": 0.07515511661768,
    "CMYK_M": 0.4366138279438,
    "CMYK_Y": 0,
    "CMYK_K": 0.58345890045166
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1131",
    "Farbtonhilfsbezeichnung": "Diva 30",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "51",
    "Bcolor": "96",
    "Y": 11,
    "L": 32.8507652282715,
    "a": 37.1392707824707,
    "b": -12.1405563354492,
    "C": 39.0732460021973,
    "h": 341.897796630859,
    "CMY_C": 0.51669675111771,
    "CMY_M": 0.79909932613373,
    "CMY_Y": 0.62186074256897,
    "CMYK_C": 0,
    "CMYK_M": 0.58431756496429,
    "CMYK_Y": 0.21759422123432,
    "CMYK_K": 0.51669675111771
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1132",
    "Farbtonhilfsbezeichnung": "Blu 5",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "68",
    "Bcolor": "80",
    "Y": 8,
    "L": 24.8153514862061,
    "a": -20.2972793579102,
    "b": -14.4984159469604,
    "C": 24.9436092376709,
    "h": 215.538345336914,
    "CMY_C": 1,
    "CMY_M": 0.73424679040909,
    "CMY_Y": 0.68789839744568,
    "CMYK_C": 1,
    "CMYK_M": 0.14850418269634,
    "CMYK_Y": 0,
    "CMYK_K": 0.68789839744568
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1133",
    "Farbtonhilfsbezeichnung": "Blu 10",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "148",
    "Bcolor": "163",
    "Y": 28,
    "L": 56.321590423584,
    "a": -25.1557083129883,
    "b": -17.0600891113281,
    "C": 30.3950042724609,
    "h": 214.144317626953,
    "CMY_C": 0.86930114030838,
    "CMY_M": 0.41840749979019,
    "CMY_Y": 0.36230456829071,
    "CMYK_C": 0.79504501819611,
    "CMYK_M": 0.08797762542963,
    "CMYK_Y": 0,
    "CMYK_K": 0.36230456829071
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1134",
    "Farbtonhilfsbezeichnung": "Blu 15",
    "Farbtonklasse": "04",
    "Rcolor": "4",
    "Gcolor": "53",
    "Bcolor": "73",
    "Y": 6,
    "L": 20.2733573913574,
    "a": -7.01220035552979,
    "b": -16.9151954650879,
    "C": 18.311056137085,
    "h": 247.483520507812,
    "CMY_C": 0.98301964998245,
    "CMY_M": 0.79194003343582,
    "CMY_Y": 0.71445095539093,
    "CMYK_C": 0.94053441286087,
    "CMYK_M": 0.27136871218681,
    "CMYK_Y": 0,
    "CMYK_K": 0.71445095539093
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1135",
    "Farbtonhilfsbezeichnung": "Blu 20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "118",
    "Y": 11,
    "L": 33.2879829406738,
    "a": -19.3344230651856,
    "b": -25.7467250823975,
    "C": 32.1980400085449,
    "h": 233.095397949219,
    "CMY_C": 1,
    "CMY_M": 0.65330839157104,
    "CMY_Y": 0.53881299495697,
    "CMYK_C": 1,
    "CMYK_M": 0.24826240539551,
    "CMYK_Y": 0,
    "CMYK_K": 0.53881299495697
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1136",
    "Farbtonhilfsbezeichnung": "Blu 25",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "67",
    "Bcolor": "89",
    "Y": 8,
    "L": 27.0802631378174,
    "a": -4.70413541793823,
    "b": -17.3141212463379,
    "C": 17.9417858123779,
    "h": 254.800018310547,
    "CMY_C": 0.86865013837814,
    "CMY_M": 0.73569428920746,
    "CMY_Y": 0.64915311336517,
    "CMYK_C": 0.62562054395676,
    "CMYK_M": 0.24666365981102,
    "CMYK_Y": 0,
    "CMYK_K": 0.64915311336517
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1137",
    "Farbtonhilfsbezeichnung": "Blu 30",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "96",
    "Bcolor": "130",
    "Y": 15,
    "L": 38.7362365722656,
    "a": -6.70768880844116,
    "b": -24.8826274871826,
    "C": 25.7708797454834,
    "h": 254.913223266602,
    "CMY_C": 0.84357053041458,
    "CMY_M": 0.62194341421127,
    "CMY_Y": 0.48926508426666,
    "CMYK_C": 0.69371688365936,
    "CMYK_M": 0.25977924466133,
    "CMYK_Y": 0,
    "CMYK_K": 0.48926508426666
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1138",
    "Farbtonhilfsbezeichnung": "Peru 5",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "75",
    "Bcolor": "64",
    "Y": 8,
    "L": 27.5364971160889,
    "a": -24.806324005127,
    "b": -0.22869300842285,
    "C": 24.8073787689209,
    "h": 180.528198242188,
    "CMY_C": 1,
    "CMY_M": 0.70703256130219,
    "CMY_Y": 0.7483184337616,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.14092308282852,
    "CMYK_K": 0.70703256130219
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1139",
    "Farbtonhilfsbezeichnung": "Peru 10",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "75",
    "Y": 10,
    "L": 32.5099639892578,
    "a": -29.9933795928955,
    "b": 0.23063461482525,
    "C": 29.9942665100098,
    "h": 179.559432983398,
    "CMY_C": 1,
    "CMY_M": 0.65386694669724,
    "CMY_Y": 0.70709997415543,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.15379354357719,
    "CMYK_K": 0.65386694669724
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1140",
    "Farbtonhilfsbezeichnung": "Peru 15",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "64",
    "Bcolor": "59",
    "Y": 6,
    "L": 23.2650146484375,
    "a": -22.4949588775635,
    "b": -3.37261915206909,
    "C": 22.7463779449463,
    "h": 188.526718139648,
    "CMY_C": 1,
    "CMY_M": 0.74839186668396,
    "CMY_Y": 0.76704078912735,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07411891967058,
    "CMYK_K": 0.74839186668396
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1141",
    "Farbtonhilfsbezeichnung": "Peru 20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "110",
    "Y": 18,
    "L": 44.3069038391113,
    "a": -42.0997085571289,
    "b": -4.42878293991089,
    "C": 42.3320159912109,
    "h": 186.005294799805,
    "CMY_C": 1,
    "CMY_M": 0.52147597074509,
    "CMY_Y": 0.56811428070068,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09746284037828,
    "CMYK_K": 0.52147597074509
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1142",
    "Farbtonhilfsbezeichnung": "Peru 25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "71",
    "Bcolor": "79",
    "Y": 8,
    "L": 26.6684246063232,
    "a": -18.8382358551025,
    "b": -11.4269495010376,
    "C": 22.0330276489258,
    "h": 211.240280151367,
    "CMY_C": 1,
    "CMY_M": 0.72002416849136,
    "CMY_Y": 0.68901717662811,
    "CMYK_C": 1,
    "CMYK_M": 0.0997064486146,
    "CMYK_Y": 0,
    "CMYK_K": 0.68901717662811
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1143",
    "Farbtonhilfsbezeichnung": "Peru 30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "101",
    "Bcolor": "109",
    "Y": 14,
    "L": 36.8061828613281,
    "a": -32.8919334411621,
    "b": -15.215537071228,
    "C": 36.2407493591309,
    "h": 204.82487487793,
    "CMY_C": 1,
    "CMY_M": 0.60501956939697,
    "CMY_Y": 0.57116568088531,
    "CMYK_C": 1,
    "CMYK_M": 0.07894398272038,
    "CMYK_Y": 0,
    "CMYK_K": 0.57116568088531
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1144",
    "Farbtonhilfsbezeichnung": "Verdo 5",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "78",
    "Bcolor": "41",
    "Y": 10,
    "L": 30.3486175537109,
    "a": -16.2950687408447,
    "b": 18.4755306243896,
    "C": 24.634822845459,
    "h": 131.411682128906,
    "CMY_C": 0.78411763906479,
    "CMY_M": 0.69537913799286,
    "CMY_Y": 0.838010430336,
    "CMYK_C": 0.29130801558495,
    "CMYK_M": 0,
    "CMYK_Y": 0.46822562813759,
    "CMYK_K": 0.69537913799286
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1145",
    "Farbtonhilfsbezeichnung": "Verdo 10",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "127",
    "Bcolor": "44",
    "Y": 20,
    "L": 48.3846702575684,
    "a": -30.7722415924072,
    "b": 38.4896545410156,
    "C": 49.2786407470703,
    "h": 128.642120361328,
    "CMY_C": 0.68495619297028,
    "CMY_M": 0.50170797109604,
    "CMY_Y": 0.82615101337433,
    "CMYK_C": 0.36775267124176,
    "CMYK_M": 0,
    "CMYK_Y": 0.65111023187637,
    "CMYK_K": 0.50170797109604
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1146",
    "Farbtonhilfsbezeichnung": "Verdo 15",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "69",
    "Bcolor": "47",
    "Y": 7,
    "L": 25.8839874267578,
    "a": -21.6133308410645,
    "b": 8.96997547149658,
    "C": 23.4007797241211,
    "h": 157.460540771484,
    "CMY_C": 0.90424007177353,
    "CMY_M": 0.72782230377197,
    "CMY_Y": 0.81734073162079,
    "CMYK_C": 0.64817130565643,
    "CMYK_M": 0,
    "CMYK_Y": 0.32889699935913,
    "CMYK_K": 0.72782230377197
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1147",
    "Farbtonhilfsbezeichnung": "Verdo 20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "48",
    "Y": 12,
    "L": 35.1928291320801,
    "a": -37.1671714782715,
    "b": 20.2331085205078,
    "C": 42.3175773620605,
    "h": 151.436965942383,
    "CMY_C": 1,
    "CMY_M": 0.6225962638855,
    "CMY_Y": 0.81122434139252,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.49980446696281,
    "CMYK_K": 0.6225962638855
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1148",
    "Farbtonhilfsbezeichnung": "Verdo 25",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "76",
    "Bcolor": "70",
    "Y": 9,
    "L": 29.8724212646484,
    "a": -12.6446113586426,
    "b": -0.08809065073729,
    "C": 12.6449184417725,
    "h": 180.399154663086,
    "CMY_C": 0.81870138645172,
    "CMY_M": 0.70216107368469,
    "CMY_Y": 0.72730708122253,
    "CMYK_C": 0.39128637313843,
    "CMYK_M": 0,
    "CMYK_Y": 0.08442821353674,
    "CMYK_K": 0.70216107368469
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1149",
    "Farbtonhilfsbezeichnung": "Verdo 30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "93",
    "Y": 19,
    "L": 46.1622161865234,
    "a": -41.4252319335938,
    "b": 8.69651699066162,
    "C": 42.3282318115234,
    "h": 168.143905639648,
    "CMY_C": 1,
    "CMY_M": 0.50595772266388,
    "CMY_Y": 0.63615381717682,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.26353228092194,
    "CMYK_K": 0.50595772266388
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1150",
    "Farbtonhilfsbezeichnung": "Oliv 5",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "31",
    "Bcolor": "33",
    "Y": 5,
    "L": 11.5757179260254,
    "a": -0.69855290651321,
    "b": -2.09493350982666,
    "C": 2.20833015441895,
    "h": 251.559097290039,
    "CMY_C": 0.88955390453339,
    "CMY_M": 0.87814223766327,
    "CMY_Y": 0.87013846635818,
    "CMYK_C": 0.14950877428055,
    "CMYK_M": 0.06163311749697,
    "CMYK_Y": 0,
    "CMYK_K": 0.87013846635818
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1151",
    "Farbtonhilfsbezeichnung": "Oliv 10",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "146",
    "Bcolor": "0",
    "Y": 40,
    "L": 65.2738876342773,
    "a": 14.9819011688232,
    "b": 70.4761962890625,
    "C": 72.0510330200195,
    "h": 77.9986572265625,
    "CMY_C": 0.17510342597961,
    "CMY_M": 0.42622023820877,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.30442216992378,
    "CMYK_Y": 1,
    "CMYK_K": 0.17510342597961
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1152",
    "Farbtonhilfsbezeichnung": "Oliv 15",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "87",
    "Bcolor": "61",
    "Y": 12,
    "L": 36.6604347229004,
    "a": -2.99979114532471,
    "b": 15.1763124465942,
    "C": 15.4699449539185,
    "h": 101.181114196777,
    "CMY_C": 0.64502227306366,
    "CMY_M": 0.65880012512207,
    "CMY_Y": 0.76000303030014,
    "CMYK_C": 0,
    "CMYK_M": 0.03881328552961,
    "CMYK_Y": 0.32390978932381,
    "CMYK_K": 0.64502227306366
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1153",
    "Farbtonhilfsbezeichnung": "Oliv 20",
    "Farbtonklasse": "04",
    "Rcolor": "200",
    "Gcolor": "163",
    "Bcolor": "0",
    "Y": 46,
    "L": 68.255241394043,
    "a": 1.20624446868896,
    "b": 72.8085708618164,
    "C": 72.8185653686523,
    "h": 89.0508422851563,
    "CMY_C": 0.21747976541519,
    "CMY_M": 0.36147266626358,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.18401172757149,
    "CMYK_Y": 1,
    "CMYK_K": 0.21747976541519
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1154",
    "Farbtonhilfsbezeichnung": "Oliv 25",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "126",
    "Bcolor": "30",
    "Y": 25,
    "L": 52.6194381713867,
    "a": -4.61582040786743,
    "b": 50.3333206176758,
    "C": 50.5445251464844,
    "h": 95.2396621704102,
    "CMY_C": 0.44599580764771,
    "CMY_M": 0.50587075948715,
    "CMY_Y": 0.88375335931778,
    "CMYK_C": 0,
    "CMYK_M": 0.10807671397924,
    "CMYK_Y": 0.79017013311386,
    "CMYK_K": 0.44599580764771
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1155",
    "Farbtonhilfsbezeichnung": "Oliv 30",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "16",
    "Y": 53,
    "L": 77.5080490112305,
    "a": -12.1737051010132,
    "b": 76.3352890014648,
    "C": 77.2999038696289,
    "h": 99.0610427856445,
    "CMY_C": 0.18948519229889,
    "CMY_M": 0.23444646596909,
    "CMY_Y": 0.93812531232834,
    "CMYK_C": 0,
    "CMYK_M": 0.0554724894464,
    "CMYK_Y": 0.92366003990173,
    "CMYK_K": 0.18948519229889
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1156",
    "Farbtonhilfsbezeichnung": "Brasil 5",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "48",
    "Bcolor": "47",
    "Y": 7,
    "L": 23.8624801635742,
    "a": 14.8705816268921,
    "b": 6.60097217559814,
    "C": 16.2698192596436,
    "h": 23.9361820220947,
    "CMY_C": 0.68379718065262,
    "CMY_M": 0.81149011850357,
    "CMY_Y": 0.81553709506989,
    "CMYK_C": 0,
    "CMYK_M": 0.40383237600327,
    "CMYK_Y": 0.41663104295731,
    "CMYK_K": 0.68379718065262
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1157",
    "Farbtonhilfsbezeichnung": "Brasil 10",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "116",
    "Bcolor": "0",
    "Y": 36,
    "L": 62.5417251586914,
    "a": 43.2509841918945,
    "b": 71.5266952514648,
    "C": 83.5865783691406,
    "h": 58.83935546875,
    "CMY_C": 0.05789560079575,
    "CMY_M": 0.54501044750214,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.51704972982407,
    "CMYK_Y": 1,
    "CMYK_K": 0.05789560079575
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1158",
    "Farbtonhilfsbezeichnung": "Brasil 15",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "64",
    "Bcolor": "50",
    "Y": 8,
    "L": 29.9489345550537,
    "a": 10.5060758590698,
    "b": 12.9457540512085,
    "C": 16.6724376678467,
    "h": 50.939079284668,
    "CMY_C": 0.63767421245575,
    "CMY_M": 0.74836152791977,
    "CMY_Y": 0.80218398571014,
    "CMYK_C": 0,
    "CMYK_M": 0.30549111962318,
    "CMYK_Y": 0.45403826236725,
    "CMYK_K": 0.63767421245575
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1159",
    "Farbtonhilfsbezeichnung": "Brasil 20",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "114",
    "Bcolor": "56",
    "Y": 27,
    "L": 54.4846878051758,
    "a": 22.5636291503906,
    "b": 42.1893005371094,
    "C": 47.8440628051758,
    "h": 61.8612976074219,
    "CMY_C": 0.2804828286171,
    "CMY_M": 0.55314755439758,
    "CMY_Y": 0.77989286184311,
    "CMYK_C": 0,
    "CMYK_M": 0.37895512580872,
    "CMYK_Y": 0.69409048557281,
    "CMYK_K": 0.2804828286171
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1160",
    "Farbtonhilfsbezeichnung": "Brasil 25",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "68",
    "Bcolor": "56",
    "Y": 8,
    "L": 29.2647571563721,
    "a": 1.63633847236633,
    "b": 8.19237232208252,
    "C": 8.35419464111328,
    "h": 78.7044372558594,
    "CMY_C": 0.70036399364471,
    "CMY_M": 0.73431146144867,
    "CMY_Y": 0.78077429533005,
    "CMYK_C": 0,
    "CMYK_M": 0.1132956892252,
    "CMYK_Y": 0.2683599293232,
    "CMYK_K": 0.70036399364471
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1161",
    "Farbtonhilfsbezeichnung": "Brasil 30",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "174",
    "Bcolor": "0",
    "Y": 56,
    "L": 77.2843780517578,
    "a": 20.8987560272217,
    "b": 92.0090026855469,
    "C": 94.3526077270508,
    "h": 77.2030639648438,
    "CMY_C": 0,
    "CMY_M": 0.3191699385643,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3191699385643,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1162",
    "Farbtonhilfsbezeichnung": "Rubin 5",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "41",
    "Bcolor": "49",
    "Y": 6,
    "L": 21.7698497772217,
    "a": 19.0392436981201,
    "b": 2.3111047744751,
    "C": 19.1789989471436,
    "h": 6.92106676101685,
    "CMY_C": 0.69025695323944,
    "CMY_M": 0.8401535153389,
    "CMY_Y": 0.80812954902649,
    "CMYK_C": 0,
    "CMYK_M": 0.48393842577934,
    "CMYK_Y": 0.3805496096611,
    "CMYK_K": 0.69025695323944
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1163",
    "Farbtonhilfsbezeichnung": "Rubin 10",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "43",
    "Bcolor": "53",
    "Y": 14,
    "L": 37.7099227905273,
    "a": 50.1468849182129,
    "b": 23.6332626342773,
    "C": 55.4368209838867,
    "h": 25.2336006164551,
    "CMY_C": 0.35418248176575,
    "CMY_M": 0.83267253637314,
    "CMY_Y": 0.79184126853943,
    "CMYK_C": 0,
    "CMYK_M": 0.74090594053268,
    "CMYK_Y": 0.67768180370331,
    "CMYK_K": 0.35418248176575
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1164",
    "Farbtonhilfsbezeichnung": "Rubin 15",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "46",
    "Bcolor": "37",
    "Y": 10,
    "L": 29.4717388153076,
    "a": 31.6332454681396,
    "b": 21.4101142883301,
    "C": 38.197582244873,
    "h": 34.0910530090332,
    "CMY_C": 0.53277838230133,
    "CMY_M": 0.8195469379425,
    "CMY_Y": 0.85294914245605,
    "CMYK_C": 0,
    "CMYK_M": 0.61377418041229,
    "CMYK_Y": 0.68526530265808,
    "CMYK_K": 0.53277838230133
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1165",
    "Farbtonhilfsbezeichnung": "Rubin 20",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "44",
    "Bcolor": "35",
    "Y": 14,
    "L": 37.0846290588379,
    "a": 47.6608505249023,
    "b": 33.6693420410156,
    "C": 58.353931427002,
    "h": 35.2387580871582,
    "CMY_C": 0.36640971899033,
    "CMY_M": 0.82611900568008,
    "CMY_Y": 0.86261808872223,
    "CMYK_C": 0,
    "CMYK_M": 0.72556239366531,
    "CMYK_Y": 0.78316915035248,
    "CMYK_K": 0.36640971899033
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1166",
    "Farbtonhilfsbezeichnung": "Rubin 25",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "54",
    "Bcolor": "41",
    "Y": 9,
    "L": 27.5310001373291,
    "a": 17.1071147918701,
    "b": 16.1841793060303,
    "C": 23.5495433807373,
    "h": 43.411994934082,
    "CMY_C": 0.62491190433502,
    "CMY_M": 0.78731966018677,
    "CMY_Y": 0.8408630490303,
    "CMYK_C": 0,
    "CMYK_M": 0.43298563361168,
    "CMYK_Y": 0.57573449611664,
    "CMYK_K": 0.62491190433502
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1167",
    "Farbtonhilfsbezeichnung": "Rubin 30",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "64",
    "Bcolor": "32",
    "Y": 18,
    "L": 45.1182174682617,
    "a": 48.7518692016602,
    "b": 44.7439765930176,
    "C": 66.1722640991211,
    "h": 42.5454025268555,
    "CMY_C": 0.25929886102676,
    "CMY_M": 0.74723136425018,
    "CMY_Y": 0.87360107898712,
    "CMYK_C": 0,
    "CMYK_M": 0.65874409675598,
    "CMYK_Y": 0.82935231924057,
    "CMYK_K": 0.25929886102676
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1168",
    "Farbtonhilfsbezeichnung": "Laser 5",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "64",
    "Bcolor": "108",
    "Y": 10,
    "L": 30.4695854187012,
    "a": 17.6404628753662,
    "b": -23.9938812255859,
    "C": 29.7807369232178,
    "h": 306.323577880859,
    "CMY_C": 0.68642312288284,
    "CMY_M": 0.75019115209579,
    "CMY_Y": 0.57474434375763,
    "CMYK_C": 0.26261562108994,
    "CMYK_M": 0.41256785392761,
    "CMYK_Y": 0,
    "CMYK_K": 0.57474434375763
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1169",
    "Farbtonhilfsbezeichnung": "Laser 10",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "62",
    "Bcolor": "104",
    "Y": 12,
    "L": 33.5251884460449,
    "a": 28.7131309509277,
    "b": -16.3979053497314,
    "C": 33.0656204223633,
    "h": 330.269561767578,
    "CMY_C": 0.56466263532639,
    "CMY_M": 0.75871020555496,
    "CMY_Y": 0.5904848575592,
    "CMYK_C": 0,
    "CMYK_M": 0.44574066996574,
    "CMYK_Y": 0.05931542813778,
    "CMYK_K": 0.56466263532639
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1170",
    "Farbtonhilfsbezeichnung": "Laser 15",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "50",
    "Bcolor": "88",
    "Y": 14,
    "L": 36.59326171875,
    "a": 45.0535430908203,
    "b": -0.36431381106377,
    "C": 45.0550155639648,
    "h": 359.536712646484,
    "CMY_C": 0.41658872365952,
    "CMY_M": 0.80507135391235,
    "CMY_Y": 0.65684658288956,
    "CMYK_C": 0,
    "CMYK_M": 0.66588127613068,
    "CMYK_Y": 0.4118155837059,
    "CMYK_K": 0.41658872365952
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1171",
    "Farbtonhilfsbezeichnung": "Laser 20",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "43",
    "Bcolor": "59",
    "Y": 14,
    "L": 36.6417045593262,
    "a": 48.5351028442383,
    "b": 18.1632881164551,
    "C": 51.8223991394043,
    "h": 20.5173530578613,
    "CMY_C": 0.37837111949921,
    "CMY_M": 0.83248913288116,
    "CMY_Y": 0.76787674427032,
    "CMYK_C": 0,
    "CMYK_M": 0.73052912950516,
    "CMYK_Y": 0.62658870220184,
    "CMYK_K": 0.37837111949921
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1172",
    "Farbtonhilfsbezeichnung": "Laser 25",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "57",
    "Bcolor": "61",
    "Y": 18,
    "L": 44.7156753540039,
    "a": 53.8227462768555,
    "b": 28.5032997131348,
    "C": 60.9042358398438,
    "h": 27.9046745300293,
    "CMY_C": 0.25024592876434,
    "CMY_M": 0.77741992473602,
    "CMY_Y": 0.76070308685303,
    "CMYK_C": 0,
    "CMYK_M": 0.70312923192978,
    "CMYK_Y": 0.68083280324936,
    "CMYK_K": 0.25024592876434
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1173",
    "Farbtonhilfsbezeichnung": "Laser 30",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "82",
    "Bcolor": "22",
    "Y": 29,
    "L": 54.2765884399414,
    "a": 53.8251037597656,
    "b": 59.020450592041,
    "C": 79.8783798217773,
    "h": 47.6360015869141,
    "CMY_C": 0.11499744653702,
    "CMY_M": 0.6776579618454,
    "CMY_Y": 0.91502183675766,
    "CMYK_C": 0,
    "CMYK_M": 0.63577276468277,
    "CMYK_Y": 0.90397977828979,
    "CMYK_K": 0.11499744653702
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1174",
    "Farbtonhilfsbezeichnung": "Laser 35",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "129",
    "Bcolor": "18",
    "Y": 41,
    "L": 66.2476959228516,
    "a": 39.8442573547363,
    "b": 69.9057464599609,
    "C": 80.4635238647461,
    "h": 60.3181114196777,
    "CMY_C": 0.02927380800247,
    "CMY_M": 0.49363851547241,
    "CMY_Y": 0.93076139688492,
    "CMYK_C": 0,
    "CMYK_M": 0.47836837172508,
    "CMYK_Y": 0.92867338657379,
    "CMYK_K": 0.02927380800247
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1175",
    "Farbtonhilfsbezeichnung": "Laser 40",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "156",
    "Bcolor": "0",
    "Y": 48,
    "L": 72.4836883544922,
    "a": 27.4458923339844,
    "b": 84.7029266357422,
    "C": 89.0385437011719,
    "h": 72.0463638305664,
    "CMY_C": 0.01036828756332,
    "CMY_M": 0.38856488466263,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.38215893507004,
    "CMYK_Y": 1,
    "CMYK_K": 0.01036828756332
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1176",
    "Farbtonhilfsbezeichnung": "Laser 45",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "180",
    "Bcolor": "0",
    "Y": 59,
    "L": 77.9701690673828,
    "a": 15.1913270950317,
    "b": 83.5310974121094,
    "C": 84.901237487793,
    "h": 79.6925888061523,
    "CMY_C": 0.01125800609589,
    "CMY_M": 0.29544281959534,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.28742060065269,
    "CMYK_Y": 1,
    "CMYK_K": 0.01125800609589
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1177",
    "Farbtonhilfsbezeichnung": "Laser 50",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "209",
    "Bcolor": "44",
    "Y": 73,
    "L": 84.1310729980469,
    "a": -4.15420579910278,
    "b": 77.0734252929688,
    "C": 77.1852951049805,
    "h": 93.0852203369141,
    "CMY_C": 0.05825799703598,
    "CMY_M": 0.18050897121429,
    "CMY_Y": 0.82617235183716,
    "CMYK_C": 0,
    "CMYK_M": 0.1298136562109,
    "CMYK_Y": 0.81541901826859,
    "CMYK_K": 0.05825799703598
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1178",
    "Farbtonhilfsbezeichnung": "Laser 55",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "188",
    "Bcolor": "0",
    "Y": 52,
    "L": 73.9916915893555,
    "a": -17.590087890625,
    "b": 77.1494293212891,
    "C": 79.1292953491211,
    "h": 102.843894958496,
    "CMY_C": 0.26554560661316,
    "CMY_M": 0.26116114854813,
    "CMY_Y": 1,
    "CMYK_C": 0.00593425473198,
    "CMYK_M": 0,
    "CMYK_Y": 1,
    "CMYK_K": 0.26116114854813
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1179",
    "Farbtonhilfsbezeichnung": "Laser 60",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "169",
    "Bcolor": "46",
    "Y": 37,
    "L": 64.2396697998047,
    "a": -32.9499588012695,
    "b": 55.2185745239258,
    "C": 64.3023376464844,
    "h": 120.825325012207,
    "CMY_C": 0.50891268253326,
    "CMY_M": 0.33565616607666,
    "CMY_Y": 0.82127213478088,
    "CMYK_C": 0.26079344749451,
    "CMYK_M": 0,
    "CMYK_Y": 0.73097085952759,
    "CMYK_K": 0.33565616607666
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1180",
    "Farbtonhilfsbezeichnung": "Laser 65",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "138",
    "Bcolor": "57",
    "Y": 23,
    "L": 51.1118392944336,
    "a": -42.3614196777344,
    "b": 35.0928268432617,
    "C": 55.0090560913086,
    "h": 140.361145019531,
    "CMY_C": 0.78704869747162,
    "CMY_M": 0.45746618509293,
    "CMY_Y": 0.77584248781204,
    "CMYK_C": 0.6074874997139,
    "CMYK_M": 0,
    "CMYK_Y": 0.58683216571808,
    "CMYK_K": 0.45746618509293
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1181",
    "Farbtonhilfsbezeichnung": "Laser 70",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "93",
    "Y": 19,
    "L": 44.813117980957,
    "a": -45.4376487731934,
    "b": 6.40695953369141,
    "C": 45.887134552002,
    "h": 171.973892211914,
    "CMY_C": 1,
    "CMY_M": 0.51455646753311,
    "CMY_Y": 0.63417708873749,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.24641510844231,
    "CMYK_K": 0.51455646753311
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1182",
    "Farbtonhilfsbezeichnung": "Laser 75",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "101",
    "Bcolor": "111",
    "Y": 13,
    "L": 36.9408836364746,
    "a": -32.5971832275391,
    "b": -16.0735721588135,
    "C": 36.3446846008301,
    "h": 206.247772216797,
    "CMY_C": 1,
    "CMY_M": 0.60381853580475,
    "CMY_Y": 0.56444334983826,
    "CMYK_C": 1,
    "CMYK_M": 0.09040198475122,
    "CMYK_Y": 0,
    "CMYK_K": 0.56444334983826
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1183",
    "Farbtonhilfsbezeichnung": "Laser 80",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "128",
    "Y": 12,
    "L": 32.704029083252,
    "a": -13.4331693649292,
    "b": -33.1410675048828,
    "C": 35.7600402832031,
    "h": 247.935653686523,
    "CMY_C": 1,
    "CMY_M": 0.6645724773407,
    "CMY_Y": 0.49806362390518,
    "CMYK_C": 1,
    "CMYK_M": 0.33173298835754,
    "CMYK_Y": 0,
    "CMYK_K": 0.49806362390518
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1184",
    "Farbtonhilfsbezeichnung": "Laser 85",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "75",
    "Bcolor": "126",
    "Y": 10,
    "L": 30.7301158905029,
    "a": -0.07865919917822,
    "b": -34.9572639465332,
    "C": 34.9573516845703,
    "h": 269.871063232422,
    "CMY_C": 1,
    "CMY_M": 0.70409172773361,
    "CMY_Y": 0.50580251216888,
    "CMYK_C": 1,
    "CMYK_M": 0.40123477578163,
    "CMYK_Y": 0,
    "CMYK_K": 0.50580251216888
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1185",
    "Farbtonhilfsbezeichnung": "Laser 90",
    "Farbtonklasse": "04",
    "Rcolor": "37",
    "Gcolor": "68",
    "Bcolor": "120",
    "Y": 10,
    "L": 29.0588645935059,
    "a": 7.47712755203247,
    "b": -33.8618240356445,
    "C": 34.6775207519531,
    "h": 282.451843261719,
    "CMY_C": 0.85373616218567,
    "CMY_M": 0.73435586690903,
    "CMY_Y": 0.5288519859314,
    "CMYK_C": 0.68955862522125,
    "CMYK_M": 0.43617689609528,
    "CMYK_Y": 0,
    "CMYK_K": 0.5288519859314
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1192",
    "Farbtonhilfsbezeichnung": "Coelin 75",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "196",
    "Bcolor": "209",
    "Y": 50,
    "L": 76.517707824707,
    "a": -10.4498615264893,
    "b": -11.8779888153076,
    "C": 15.8204364776611,
    "h": 228.659744262695,
    "CMY_C": 0.39633929729462,
    "CMY_M": 0.2330436706543,
    "CMY_Y": 0.1818619966507,
    "CMYK_C": 0.26215296983719,
    "CMYK_M": 0.06255873292685,
    "CMYK_Y": 0,
    "CMYK_K": 0.1818619966507
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1193",
    "Farbtonhilfsbezeichnung": "Melisse 30",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "238",
    "Bcolor": "217",
    "Y": 87,
    "L": 93.9974899291992,
    "a": -0.58456718921661,
    "b": 9.94553852081299,
    "C": 9.96270275115967,
    "h": 93.3637924194336,
    "CMY_C": 0.04007565975189,
    "CMY_M": 0.06842774152756,
    "CMY_Y": 0.14911282062531,
    "CMYK_C": 0,
    "CMYK_M": 0.02953574620187,
    "CMYK_Y": 0.11358933150768,
    "CMYK_K": 0.04007565975189
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1196",
    "Farbtonhilfsbezeichnung": "Offwhite 15",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "236",
    "Bcolor": "230",
    "Y": 87,
    "L": 93.9868698120117,
    "a": 1.98192918300629,
    "b": 3.28724479675293,
    "C": 3.83849215507507,
    "h": 58.9135932922363,
    "CMY_C": 0.04116612672806,
    "CMY_M": 0.07292145490646,
    "CMY_Y": 0.09915482997894,
    "CMYK_C": 0,
    "CMYK_M": 0.03311869502068,
    "CMYK_Y": 0.06047836318612,
    "CMYK_K": 0.04116612672806
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1197",
    "Farbtonhilfsbezeichnung": "Melisse 10",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "213",
    "Bcolor": "202",
    "Y": 67,
    "L": 85.1824417114258,
    "a": -0.28702762722969,
    "b": 4.69258975982666,
    "C": 4.70135974884033,
    "h": 93.5001983642578,
    "CMY_C": 0.1524019241333,
    "CMY_M": 0.16566467285156,
    "CMY_Y": 0.20630913972855,
    "CMYK_C": 0,
    "CMYK_M": 0.01564745046198,
    "CMYK_Y": 0.06359997391701,
    "CMYK_K": 0.1524019241333
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1199",
    "Farbtonhilfsbezeichnung": "Oase 70",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "109",
    "Bcolor": "84",
    "Y": 14,
    "L": 44.1719436645508,
    "a": -10.3338108062744,
    "b": 11.4658231735229,
    "C": 15.4354381561279,
    "h": 132.027404785156,
    "CMY_C": 0.63049852848053,
    "CMY_M": 0.5728520154953,
    "CMY_Y": 0.66914331912994,
    "CMYK_C": 0.13495677709579,
    "CMYK_M": 0,
    "CMYK_Y": 0.22542843222618,
    "CMYK_K": 0.5728520154953
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1200",
    "Farbtonhilfsbezeichnung": "Oase 75",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "160",
    "Bcolor": "131",
    "Y": 33,
    "L": 64.0860137939453,
    "a": -9.56771469116211,
    "b": 12.6407566070557,
    "C": 15.8533878326416,
    "h": 127.121871948242,
    "CMY_C": 0.42381662130356,
    "CMY_M": 0.37345260381699,
    "CMY_Y": 0.48449695110321,
    "CMYK_C": 0.08038341253996,
    "CMYK_M": 0,
    "CMYK_Y": 0.17723216116428,
    "CMYK_K": 0.37345260381699
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1201",
    "Farbtonhilfsbezeichnung": "Melisse 25",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "216",
    "Y": 83,
    "L": 92.3584136962891,
    "a": 0.18331870436668,
    "b": 7.98522806167603,
    "C": 7.98733186721802,
    "h": 88.6848754882813,
    "CMY_C": 0.05861562490463,
    "CMY_M": 0.08810430765152,
    "CMY_Y": 0.15235245227814,
    "CMYK_C": 0,
    "CMYK_M": 0.03132480755448,
    "CMYK_Y": 0.09957338124514,
    "CMYK_K": 0.05861562490463
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1202",
    "Farbtonhilfsbezeichnung": "Offwhite 30",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "243",
    "Bcolor": "228",
    "Y": 89,
    "L": 95.5559234619141,
    "a": -2.33609700202942,
    "b": 6.21427297592163,
    "C": 6.63886547088623,
    "h": 110.602470397949,
    "CMY_C": 0.04782724380493,
    "CMY_M": 0.04574912786484,
    "CMY_Y": 0.10427886247635,
    "CMYK_C": 0.00217774580233,
    "CMYK_M": 0,
    "CMYK_Y": 0.06133579462767,
    "CMYK_K": 0.04574912786484
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1203",
    "Farbtonhilfsbezeichnung": "Agave 90",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "228",
    "Bcolor": "220",
    "Y": 77,
    "L": 90.1243286132812,
    "a": -2.92724180221558,
    "b": 2.33803963661194,
    "C": 3.74635481834412,
    "h": 141.385025024414,
    "CMY_C": 0.12621825933456,
    "CMY_M": 0.10418486595154,
    "CMY_Y": 0.13545095920563,
    "CMYK_C": 0.02459591627121,
    "CMYK_M": 0,
    "CMYK_Y": 0.0349023938179,
    "CMYK_K": 0.10418486595154
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1208",
    "Farbtonhilfsbezeichnung": "Flamenco 150",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "206",
    "Bcolor": "216",
    "Y": 67,
    "L": 86.1192855834961,
    "a": 15.0344171524048,
    "b": -0.98650366067886,
    "C": 15.0667476654053,
    "h": 356.245849609375,
    "CMY_C": 0.04603397846222,
    "CMY_M": 0.19198668003082,
    "CMY_Y": 0.15245741605759,
    "CMYK_C": 0,
    "CMYK_M": 0.15299570560455,
    "CMYK_Y": 0.11155893653631,
    "CMYK_K": 0.04603397846222
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1210",
    "Farbtonhilfsbezeichnung": "Patina 70",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "124",
    "Bcolor": "115",
    "Y": 17,
    "L": 49.567455291748,
    "a": -12.8244400024414,
    "b": 1.08216464519501,
    "C": 12.8700170516968,
    "h": 175.176635742188,
    "CMY_C": 0.63249564170837,
    "CMY_M": 0.5129576921463,
    "CMY_Y": 0.55023372173309,
    "CMYK_C": 0.2454364746809,
    "CMYK_M": 0,
    "CMYK_Y": 0.07653550803661,
    "CMYK_K": 0.5129576921463
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1211",
    "Farbtonhilfsbezeichnung": "Lachs 110",
    "Farbtonklasse": "04",
    "Rcolor": "222",
    "Gcolor": "100",
    "Bcolor": "65",
    "Y": 24,
    "L": 57.0959739685059,
    "a": 45.983528137207,
    "b": 42.060905456543,
    "C": 62.3185729980469,
    "h": 42.4490013122559,
    "CMY_C": 0.12825399637222,
    "CMY_M": 0.60884821414948,
    "CMY_Y": 0.74531352519989,
    "CMYK_C": 0,
    "CMYK_M": 0.55130076408386,
    "CMYK_Y": 0.70784324407578,
    "CMYK_K": 0.12825399637222
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1212",
    "Farbtonhilfsbezeichnung": "Melisse 40",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "199",
    "Bcolor": "174",
    "Y": 57,
    "L": 80.3003387451172,
    "a": -1.11202085018158,
    "b": 12.9043416976929,
    "C": 12.952166557312,
    "h": 94.9252471923828,
    "CMY_C": 0.1881200671196,
    "CMY_M": 0.21916669607162,
    "CMY_Y": 0.3183228969574,
    "CMYK_C": 0,
    "CMYK_M": 0.0382404178381,
    "CMYK_Y": 0.16037201881409,
    "CMYK_K": 0.1881200671196
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1213",
    "Farbtonhilfsbezeichnung": "Melisse 55",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "213",
    "Y": 83,
    "L": 92.8877258300781,
    "a": -0.79080200195313,
    "b": 10.1788759231567,
    "C": 10.2095489501953,
    "h": 94.4424133300781,
    "CMY_C": 0.05348342657089,
    "CMY_M": 0.08043563365936,
    "CMY_Y": 0.1630432009697,
    "CMYK_C": 0,
    "CMYK_M": 0.0284751560539,
    "CMYK_Y": 0.11575050652027,
    "CMYK_K": 0.05348342657089
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1215",
    "Farbtonhilfsbezeichnung": "Offwhite 25",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "241",
    "Bcolor": "223",
    "Y": 89,
    "L": 95.0500946044922,
    "a": -1.014044880867,
    "b": 8.11380290985107,
    "C": 8.17692375183105,
    "h": 97.1237564086914,
    "CMY_C": 0.03710561990738,
    "CMY_M": 0.05509251356125,
    "CMY_Y": 0.12389826774597,
    "CMYK_C": 0,
    "CMYK_M": 0.01868002675474,
    "CMYK_Y": 0.09013724327087,
    "CMYK_K": 0.03710561990738
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1217",
    "Farbtonhilfsbezeichnung": "Offwhite 10",
    "Farbtonklasse": "01",
    "Y": 86,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1218",
    "Farbtonhilfsbezeichnung": "Rose 25",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "228",
    "Bcolor": "223",
    "Y": 77,
    "L": 90.7060317993164,
    "a": 1.20562064647675,
    "b": 2.19566202163696,
    "C": 2.50488591194153,
    "h": 61.2291641235352,
    "CMY_C": 0.08761221170425,
    "CMY_M": 0.10740035772324,
    "CMY_Y": 0.12741351127625,
    "CMYK_C": 0,
    "CMYK_M": 0.02168830670416,
    "CMYK_Y": 0.04362322762609,
    "CMYK_K": 0.08761221170425
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1219",
    "Farbtonhilfsbezeichnung": "Ceramic 15",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "166",
    "Bcolor": "149",
    "Y": 41,
    "L": 69.9433212280273,
    "a": 7.11492729187012,
    "b": 11.6793384552002,
    "C": 13.675859451294,
    "h": 58.6506767272949,
    "CMY_C": 0.24670332670212,
    "CMY_M": 0.3488946557045,
    "CMY_Y": 0.41586452722549,
    "CMYK_C": 0,
    "CMYK_M": 0.13565881550312,
    "CMYK_Y": 0.22456119954586,
    "CMYK_K": 0.24670332670212
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1220",
    "Farbtonhilfsbezeichnung": "Melisse 15",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "217",
    "Y": 78,
    "L": 90.3963928222656,
    "a": -0.00186049181502,
    "b": 4.39200687408447,
    "C": 4.39200735092163,
    "h": 90.0242691040039,
    "CMY_C": 0.0933073759079,
    "CMY_M": 0.10857880115509,
    "CMY_Y": 0.14723861217499,
    "CMYK_C": 0,
    "CMYK_M": 0.01684300228953,
    "CMYK_Y": 0.05948127806187,
    "CMYK_K": 0.0933073759079
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1221",
    "Farbtonhilfsbezeichnung": "Melisse 35",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "171",
    "Bcolor": "140",
    "Y": 40,
    "L": 70.0161437988281,
    "a": -0.65237510204315,
    "b": 16.7550678253174,
    "C": 16.7677631378174,
    "h": 92.229736328125,
    "CMY_C": 0.28673434257507,
    "CMY_M": 0.33114504814148,
    "CMY_Y": 0.45219331979752,
    "CMYK_C": 0,
    "CMYK_M": 0.06226390600204,
    "CMYK_Y": 0.23197384178638,
    "CMYK_K": 0.28673434257507
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1222",
    "Farbtonhilfsbezeichnung": "Melisse 45",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "215",
    "Bcolor": "191",
    "Y": 67,
    "L": 85.9576263427734,
    "a": -0.57161730527878,
    "b": 12.0486335754395,
    "C": 12.0621852874756,
    "h": 92.7162170410156,
    "CMY_C": 0.12400376796722,
    "CMY_M": 0.15836721658707,
    "CMY_Y": 0.25188034772873,
    "CMYK_C": 0,
    "CMYK_M": 0.03922785073519,
    "CMYK_Y": 0.14597846567631,
    "CMYK_K": 0.12400376796722
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1223",
    "Farbtonhilfsbezeichnung": "Melisse 50",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "223",
    "Bcolor": "199",
    "Y": 74,
    "L": 88.9088439941406,
    "a": -0.59352034330368,
    "b": 11.7961730957031,
    "C": 11.8110952377319,
    "h": 92.8803863525391,
    "CMY_C": 0.09195160865784,
    "CMY_M": 0.12564611434937,
    "CMY_Y": 0.21827226877213,
    "CMYK_C": 0,
    "CMYK_M": 0.03710651025176,
    "CMYK_Y": 0.13911224901676,
    "CMYK_K": 0.09195160865784
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1249",
    "Farbtonhilfsbezeichnung": "Curcuma 120",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "228",
    "Bcolor": "192",
    "Y": 80,
    "L": 91.7403182983398,
    "a": 2.94420599937439,
    "b": 19.9030265808106,
    "C": 20.1196136474609,
    "h": 81.5854034423828,
    "CMY_C": 0.01236921548843,
    "CMY_M": 0.10465443134308,
    "CMY_Y": 0.24744582176208,
    "CMYK_C": 0,
    "CMYK_M": 0.09344100952148,
    "CMYK_Y": 0.23802073299885,
    "CMYK_K": 0.01236921548843
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1250",
    "Farbtonhilfsbezeichnung": "Granit 30",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "145",
    "Bcolor": "144",
    "Y": 28,
    "L": 60.0685577392578,
    "a": 0.05563190951943,
    "b": -0.28296902775764,
    "C": 0.28838580846786,
    "h": 281.122528076172,
    "CMY_C": 0.43286752700806,
    "CMY_M": 0.43203562498093,
    "CMY_Y": 0.43492996692657,
    "CMYK_C": 0.00146470812615,
    "CMYK_M": 0,
    "CMYK_Y": 0.00509599223733,
    "CMYK_K": 0.43203562498093
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1251",
    "Farbtonhilfsbezeichnung": "Granit 25",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "133",
    "Bcolor": "133",
    "Y": 23,
    "L": 55.3514404296875,
    "a": -0.10655560344458,
    "b": -0.69731372594833,
    "C": 0.70540803670883,
    "h": 261.311920166016,
    "CMY_C": 0.48322087526321,
    "CMY_M": 0.47949081659317,
    "CMY_Y": 0.47974628210068,
    "CMYK_C": 0.00716617284343,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004907992552,
    "CMYK_K": 0.47949081659317
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1252",
    "Farbtonhilfsbezeichnung": "Granit 20",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "120",
    "Bcolor": "120",
    "Y": 19,
    "L": 50.346061706543,
    "a": -0.08545484393835,
    "b": -0.58158504962921,
    "C": 0.58782964944839,
    "h": 261.641082763672,
    "CMY_C": 0.53260660171509,
    "CMY_M": 0.5295518040657,
    "CMY_Y": 0.53017640113831,
    "CMYK_C": 0.00649337749928,
    "CMYK_M": 0,
    "CMYK_Y": 0.00132766389288,
    "CMYK_K": 0.5295518040657
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1253",
    "Farbtonhilfsbezeichnung": "Granit 15",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "106",
    "Bcolor": "106",
    "Y": 15,
    "L": 44.7853012084961,
    "a": 0.19099450111389,
    "b": -0.77454537153244,
    "C": 0.79774647951126,
    "h": 283.852172851563,
    "CMY_C": 0.58562278747559,
    "CMY_M": 0.58450627326965,
    "CMY_Y": 0.58298742771149,
    "CMYK_C": 0.00631961692125,
    "CMYK_M": 0.0036422056146,
    "CMYK_Y": 0,
    "CMYK_K": 0.58298742771149
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1254",
    "Farbtonhilfsbezeichnung": "Granit 10",
    "Farbtonklasse": "02",
    "Rcolor": "88",
    "Gcolor": "88",
    "Bcolor": "88",
    "Y": 10,
    "L": 37.4971618652344,
    "a": 0.14315387606621,
    "b": -0.50365704298019,
    "C": 0.52360618114471,
    "h": 285.86669921875,
    "CMY_C": 0.65452444553375,
    "CMY_M": 0.65392470359802,
    "CMY_Y": 0.65374708175659,
    "CMYK_C": 0.00224507506937,
    "CMYK_M": 0.00051298295148,
    "CMYK_Y": 0,
    "CMYK_K": 0.65374708175659
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1255",
    "Farbtonhilfsbezeichnung": "Granit 5",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "72",
    "Bcolor": "72",
    "Y": 6,
    "L": 30.4609184265137,
    "a": 0.14735092222691,
    "b": -0.70752358436584,
    "C": 0.72270458936691,
    "h": 281.764434814453,
    "CMY_C": 0.71986711025238,
    "CMY_M": 0.71872270107269,
    "CMY_Y": 0.71696782112122,
    "CMYK_C": 0.01024367287755,
    "CMYK_M": 0.00620028423145,
    "CMYK_Y": 0,
    "CMYK_K": 0.71696782112122
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1256",
    "Farbtonhilfsbezeichnung": "Granit 35",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "158",
    "Bcolor": "157",
    "Y": 34,
    "L": 65.1206359863281,
    "a": -0.30479407310486,
    "b": 0.11863671243191,
    "C": 0.32706895470619,
    "h": 158.732238769531,
    "CMY_C": 0.38213890790939,
    "CMY_M": 0.37920367717743,
    "CMY_Y": 0.38598310947418,
    "CMYK_C": 0.00472817011178,
    "CMYK_M": 0,
    "CMYK_Y": 0.0109205422923,
    "CMYK_K": 0.37920367717743
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1257",
    "Farbtonhilfsbezeichnung": "Granit 40",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "171",
    "Bcolor": "169",
    "Y": 41,
    "L": 69.9272079467773,
    "a": -0.04466203227639,
    "b": 0.36111426353455,
    "C": 0.3638656437397,
    "h": 97.0504455566406,
    "CMY_C": 0.32907962799072,
    "CMY_M": 0.32947283983231,
    "CMY_Y": 0.33768433332443,
    "CMYK_C": 0,
    "CMYK_M": 0.00058607826941,
    "CMYK_Y": 0.0128252254799,
    "CMYK_K": 0.32907962799072
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1258",
    "Farbtonhilfsbezeichnung": "Granit 45",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "186",
    "Bcolor": "185",
    "Y": 49,
    "L": 75.4228897094727,
    "a": -0.26129603385925,
    "b": -0.10225359350443,
    "C": 0.2805911898613,
    "h": 201.372009277344,
    "CMY_C": 0.27383655309677,
    "CMY_M": 0.27039188146591,
    "CMY_Y": 0.27645188570023,
    "CMYK_C": 0.0047212629579,
    "CMYK_M": 0,
    "CMYK_Y": 0.00830583460629,
    "CMYK_K": 0.27039188146591
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1259",
    "Farbtonhilfsbezeichnung": "Granit 50",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "198",
    "Bcolor": "196",
    "Y": 57,
    "L": 79.9328689575195,
    "a": 0.26100078225136,
    "b": 0.48519802093506,
    "C": 0.55094331502914,
    "h": 61.7230262756348,
    "CMY_C": 0.21925604343414,
    "CMY_M": 0.22311615943909,
    "CMY_Y": 0.23234754800797,
    "CMYK_C": 0,
    "CMYK_M": 0.00494415080175,
    "CMYK_Y": 0.01676798798144,
    "CMYK_K": 0.21925604343414
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1260",
    "Farbtonhilfsbezeichnung": "Granit 55",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "210",
    "Bcolor": "207",
    "Y": 65,
    "L": 84.2011032104492,
    "a": -0.03947812691331,
    "b": 0.65606355667114,
    "C": 0.65725028514862,
    "h": 93.4435806274414,
    "CMY_C": 0.17444688081741,
    "CMY_M": 0.17590951919556,
    "CMY_Y": 0.18747407197952,
    "CMYK_C": 0,
    "CMYK_M": 0.00177170720417,
    "CMYK_Y": 0.01577995531261,
    "CMYK_K": 0.17444688081741
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1261",
    "Farbtonhilfsbezeichnung": "Granit 60",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 73,
    "L": 88.278450012207,
    "a": -0.14722946286201,
    "b": 1.03957664966583,
    "C": 1.04995048046112,
    "h": 98.0608749389648,
    "CMY_C": 0.12905693054199,
    "CMY_M": 0.13082081079483,
    "CMY_Y": 0.1457651257515,
    "CMYK_C": 0,
    "CMYK_M": 0.00202525313944,
    "CMYK_Y": 0.01918402686715,
    "CMYK_K": 0.12905693054199
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1262",
    "Farbtonhilfsbezeichnung": "Ferro 5",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "70",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.1856498718262,
    "a": 1.86461102962494,
    "b": 0.51487112045288,
    "C": 1.93439054489136,
    "h": 15.4363145828247,
    "CMY_C": 0.70811951160431,
    "CMY_M": 0.72486239671707,
    "CMY_Y": 0.72658205032349,
    "CMYK_C": 0,
    "CMYK_M": 0.05736212432384,
    "CMYK_Y": 0.06325376033783,
    "CMYK_K": 0.70811951160431
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1263",
    "Farbtonhilfsbezeichnung": "Ferro 10",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "87",
    "Bcolor": "86",
    "Y": 10,
    "L": 37.4777679443359,
    "a": 1.50094652175903,
    "b": 0.77950084209442,
    "C": 1.69129002094269,
    "h": 27.4446353912354,
    "CMY_C": 0.64211285114288,
    "CMY_M": 0.65716111660004,
    "CMY_Y": 0.66175317764282,
    "CMYK_C": 0,
    "CMYK_M": 0.04204751551151,
    "CMYK_Y": 0.05487854778767,
    "CMYK_K": 0.64211285114288
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1264",
    "Farbtonhilfsbezeichnung": "Ferro 15",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "106",
    "Bcolor": "104",
    "Y": 15,
    "L": 45.0878524780273,
    "a": 1.44834136962891,
    "b": 0.82451069355011,
    "C": 1.66658651828766,
    "h": 29.6519622802734,
    "CMY_C": 0.56938254833221,
    "CMY_M": 0.58459955453873,
    "CMY_Y": 0.59020888805389,
    "CMYK_C": 0,
    "CMYK_M": 0.0353376455605,
    "CMYK_Y": 0.04836390167475,
    "CMYK_K": 0.56938254833221
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1265",
    "Farbtonhilfsbezeichnung": "Ferro 20",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "118",
    "Bcolor": "117",
    "Y": 19,
    "L": 50.0692367553711,
    "a": 1.40863692760468,
    "b": 0.71707689762115,
    "C": 1.58065092563629,
    "h": 26.9787006378174,
    "CMY_C": 0.52098393440247,
    "CMY_M": 0.53578960895538,
    "CMY_Y": 0.54123306274414,
    "CMYK_C": 0,
    "CMYK_M": 0.03090851381421,
    "CMYK_Y": 0.04227233678102,
    "CMYK_K": 0.52098393440247
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1266",
    "Farbtonhilfsbezeichnung": "Ferro 25",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "131",
    "Bcolor": "129",
    "Y": 23,
    "L": 54.990161895752,
    "a": 1.43504333496094,
    "b": 0.72849416732788,
    "C": 1.60936415195465,
    "h": 26.9144515991211,
    "CMY_C": 0.4714879989624,
    "CMY_M": 0.48682647943497,
    "CMY_Y": 0.49269282817841,
    "CMYK_C": 0,
    "CMYK_M": 0.02902201004326,
    "CMYK_Y": 0.04012175649405,
    "CMYK_K": 0.4714879989624
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1267",
    "Farbtonhilfsbezeichnung": "Ferro 30",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "144",
    "Bcolor": "142",
    "Y": 29,
    "L": 60.0300788879395,
    "a": 1.62303364276886,
    "b": 0.91802442073822,
    "C": 1.86467349529266,
    "h": 29.4934768676758,
    "CMY_C": 0.41822093725204,
    "CMY_M": 0.43619239330292,
    "CMY_Y": 0.44328188896179,
    "CMYK_C": 0,
    "CMYK_M": 0.03089051693678,
    "CMYK_Y": 0.04307640716434,
    "CMYK_K": 0.41822093725204
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1268",
    "Farbtonhilfsbezeichnung": "Ferro 35",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "158",
    "Bcolor": "155",
    "Y": 34,
    "L": 65.2989730834961,
    "a": 1.47605907917023,
    "b": 1.11751437187195,
    "C": 1.85137486457825,
    "h": 37.1291160583496,
    "CMY_C": 0.36405348777771,
    "CMY_M": 0.38158321380615,
    "CMY_Y": 0.39081346988678,
    "CMYK_C": 0,
    "CMYK_M": 0.02756478078663,
    "CMYK_Y": 0.04207898303866,
    "CMYK_K": 0.36405348777771
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1269",
    "Farbtonhilfsbezeichnung": "Ferro 40",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "170",
    "Bcolor": "168",
    "Y": 41,
    "L": 69.9820556640625,
    "a": 1.56501972675323,
    "b": 0.89635276794434,
    "C": 1.80353403091431,
    "h": 29.8015880584717,
    "CMY_C": 0.31481575965881,
    "CMY_M": 0.33268219232559,
    "CMY_Y": 0.34064865112305,
    "CMYK_C": 0,
    "CMYK_M": 0.02607537060976,
    "CMYK_Y": 0.03770210966468,
    "CMYK_K": 0.31481575965881
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1270",
    "Farbtonhilfsbezeichnung": "Ferro 50",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.4666595458984,
    "a": 1.19308912754059,
    "b": 1.11368334293365,
    "C": 1.6321005821228,
    "h": 43.028491973877,
    "CMY_C": 0.2042527794838,
    "CMY_M": 0.21966582536697,
    "CMY_Y": 0.2310089468956,
    "CMYK_C": 0,
    "CMYK_M": 0.01936927437782,
    "CMYK_Y": 0.03362395241857,
    "CMYK_K": 0.2042527794838
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1271",
    "Farbtonhilfsbezeichnung": "Ferro 45",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "184",
    "Bcolor": "181",
    "Y": 49,
    "L": 75.0893478393555,
    "a": 1.29434978961945,
    "b": 1.27997958660126,
    "C": 1.82035410404205,
    "h": 44.6801719665527,
    "CMY_C": 0.26112407445908,
    "CMY_M": 0.27790832519531,
    "CMY_Y": 0.28961843252182,
    "CMYK_C": 0,
    "CMYK_M": 0.02271592617035,
    "CMYK_Y": 0.03856446966529,
    "CMYK_K": 0.26112407445908
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1272",
    "Farbtonhilfsbezeichnung": "Ferro 55",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "210",
    "Bcolor": "207",
    "Y": 65,
    "L": 84.4919052124023,
    "a": 0.77163624763489,
    "b": 0.9768653512001,
    "C": 1.24486482143402,
    "h": 51.6944198608398,
    "CMY_C": 0.16388988494873,
    "CMY_M": 0.17470949888229,
    "CMY_Y": 0.18653845787048,
    "CMYK_C": 0,
    "CMYK_M": 0.01294041704386,
    "CMYK_Y": 0.02708802558482,
    "CMYK_K": 0.16388988494873
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1273",
    "Farbtonhilfsbezeichnung": "Ferro 60",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 73,
    "L": 88.520263671875,
    "a": 0.80969303846359,
    "b": 1.34848546981812,
    "C": 1.57290041446686,
    "h": 59.0174446105957,
    "CMY_C": 0.11785078048706,
    "CMY_M": 0.13049221038818,
    "CMY_Y": 0.14525145292282,
    "CMYK_C": 0,
    "CMYK_M": 0.01433026231825,
    "CMYK_Y": 0.03106126748025,
    "CMYK_K": 0.11785078048706
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1274",
    "Farbtonhilfsbezeichnung": "Jura 5",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "70",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.6621360778809,
    "a": 0.24237515032291,
    "b": 0.9614394903183,
    "C": 0.99151986837387,
    "h": 75.8507843017578,
    "CMY_C": 0.72184777259827,
    "CMY_M": 0.72650593519211,
    "CMY_Y": 0.73411846160889,
    "CMYK_C": 0,
    "CMYK_M": 0.01674680970609,
    "CMYK_Y": 0.04411501437426,
    "CMYK_K": 0.72184777259827
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1275",
    "Farbtonhilfsbezeichnung": "Jura 10",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "88",
    "Bcolor": "85",
    "Y": 10,
    "L": 37.5527877807617,
    "a": 0.45780289173126,
    "b": 1.55357265472412,
    "C": 1.61962080001831,
    "h": 73.580940246582,
    "CMY_C": 0.64607799053192,
    "CMY_M": 0.65452718734741,
    "CMY_Y": 0.66600131988525,
    "CMYK_C": 0,
    "CMYK_M": 0.02387304790318,
    "CMYK_Y": 0.05629299208522,
    "CMYK_K": 0.64607799053192
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1276",
    "Farbtonhilfsbezeichnung": "Jura 15",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "106",
    "Bcolor": "102",
    "Y": 15,
    "L": 44.6928863525391,
    "a": 0.03591043129563,
    "b": 1.50874841213226,
    "C": 1.50917565822601,
    "h": 88.6365356445313,
    "CMY_C": 0.58081495761871,
    "CMY_M": 0.58564692735672,
    "CMY_Y": 0.59856498241425,
    "CMYK_C": 0,
    "CMYK_M": 0.01152705680579,
    "CMYK_Y": 0.04234412685037,
    "CMYK_K": 0.58081495761871
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1277",
    "Farbtonhilfsbezeichnung": "Jura 20",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "120",
    "Bcolor": "116",
    "Y": 20,
    "L": 50.2803421020508,
    "a": -0.49133524298668,
    "b": 1.51386737823486,
    "C": 1.59160447120667,
    "h": 107.981163024902,
    "CMY_C": 0.52972906827927,
    "CMY_M": 0.52988004684448,
    "CMY_Y": 0.54463672637939,
    "CMYK_C": 0,
    "CMYK_M": 0.00032104592538,
    "CMYK_Y": 0.0317001491785,
    "CMYK_K": 0.52972906827927
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1278",
    "Farbtonhilfsbezeichnung": "Jura 25",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "132",
    "Bcolor": "128",
    "Y": 23,
    "L": 55.0806159973145,
    "a": -0.36757028102875,
    "b": 1.65976011753082,
    "C": 1.6999739408493,
    "h": 102.487182617188,
    "CMY_C": 0.48051035404205,
    "CMY_M": 0.4822673201561,
    "CMY_Y": 0.49824506044388,
    "CMYK_C": 0,
    "CMYK_M": 0.00338210025802,
    "CMYK_Y": 0.03413870930672,
    "CMYK_K": 0.48051035404205
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1279",
    "Farbtonhilfsbezeichnung": "Jura 30",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "145",
    "Bcolor": "140",
    "Y": 28,
    "L": 60.1689910888672,
    "a": -0.23544049263,
    "b": 2.07655191421509,
    "C": 2.08985638618469,
    "h": 96.4686050415039,
    "CMY_C": 0.42659687995911,
    "CMY_M": 0.43098801374435,
    "CMY_Y": 0.44999372959137,
    "CMYK_C": 0,
    "CMYK_M": 0.00765802199021,
    "CMYK_Y": 0.04080349206924,
    "CMYK_K": 0.42659687995911
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1280",
    "Farbtonhilfsbezeichnung": "Jura 35",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "157",
    "Bcolor": "153",
    "Y": 34,
    "L": 64.7152709960938,
    "a": 0.23755557835102,
    "b": 1.54226291179657,
    "C": 1.5604510307312,
    "h": 81.2435150146484,
    "CMY_C": 0.3778463602066,
    "CMY_M": 0.38499522209167,
    "CMY_Y": 0.39991623163223,
    "CMYK_C": 0,
    "CMYK_M": 0.01149050891399,
    "CMYK_Y": 0.03547334671021,
    "CMYK_K": 0.3778463602066
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1281",
    "Farbtonhilfsbezeichnung": "Jura 40",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "171",
    "Bcolor": "167",
    "Y": 41,
    "L": 70.0378036499023,
    "a": -0.36500492691994,
    "b": 1.78712403774261,
    "C": 1.82401776313782,
    "h": 101.543411254883,
    "CMY_C": 0.32572615146637,
    "CMY_M": 0.32796937227249,
    "CMY_Y": 0.34656792879105,
    "CMYK_C": 0,
    "CMYK_M": 0.00332686910406,
    "CMYK_Y": 0.03090995922685,
    "CMYK_K": 0.32572615146637
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1282",
    "Farbtonhilfsbezeichnung": "Jura 45",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "184",
    "Bcolor": "179",
    "Y": 48,
    "L": 74.904411315918,
    "a": -0.15140794217587,
    "b": 1.92539536952972,
    "C": 1.93133938312531,
    "h": 94.496337890625,
    "CMY_C": 0.27191406488419,
    "CMY_M": 0.27674931287766,
    "CMY_Y": 0.29636198282242,
    "CMYK_C": 0,
    "CMYK_M": 0.00664104009047,
    "CMYK_Y": 0.03357833996415,
    "CMYK_K": 0.27191406488419
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1283",
    "Farbtonhilfsbezeichnung": "Jura 50",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "200",
    "Bcolor": "195",
    "Y": 58,
    "L": 80.4395141601563,
    "a": -0.01477839890867,
    "b": 1.84345984458923,
    "C": 1.84351909160614,
    "h": 90.4593124389648,
    "CMY_C": 0.21139740943909,
    "CMY_M": 0.21735399961472,
    "CMY_Y": 0.23673087358475,
    "CMYK_C": 0,
    "CMYK_M": 0.00755334831774,
    "CMYK_Y": 0.03212450072169,
    "CMYK_K": 0.21139740943909
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1284",
    "Farbtonhilfsbezeichnung": "Jura 55",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "211",
    "Bcolor": "206",
    "Y": 65,
    "L": 84.3645629882813,
    "a": -0.08968752622604,
    "b": 1.65666568279266,
    "C": 1.65909159183502,
    "h": 93.0988159179688,
    "CMY_C": 0.16970348358154,
    "CMY_M": 0.17427861690521,
    "CMY_Y": 0.19299459457397,
    "CMYK_C": 0,
    "CMYK_M": 0.00551024032757,
    "CMYK_Y": 0.028051558882,
    "CMYK_K": 0.16970348358154
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1285",
    "Farbtonhilfsbezeichnung": "Jura 60",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "221",
    "Bcolor": "217",
    "Y": 73,
    "L": 88.1811218261719,
    "a": -0.14055962860584,
    "b": 1.36220002174377,
    "C": 1.3694326877594,
    "h": 95.8912582397461,
    "CMY_C": 0.12899428606033,
    "CMY_M": 0.13200533390045,
    "CMY_Y": 0.14920485019684,
    "CMYK_C": 0,
    "CMYK_M": 0.00345697836019,
    "CMYK_Y": 0.02320371009409,
    "CMYK_K": 0.12899428606033
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1286",
    "Farbtonhilfsbezeichnung": "Venato 5",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "71",
    "Bcolor": "72",
    "Y": 7,
    "L": 29.7252216339111,
    "a": -0.83098143339157,
    "b": -1.62067830562592,
    "C": 1.82129848003387,
    "h": 242.854110717773,
    "CMY_C": 0.73560750484467,
    "CMY_M": 0.72328716516495,
    "CMY_Y": 0.71821820735931,
    "CMYK_C": 0.06171192601323,
    "CMYK_M": 0.01798894815147,
    "CMYK_Y": 0,
    "CMYK_K": 0.71821820735931
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1287",
    "Farbtonhilfsbezeichnung": "Venato 10",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "89",
    "Bcolor": "92",
    "Y": 10,
    "L": 37.7737579345703,
    "a": -0.61859804391861,
    "b": -2.49837732315063,
    "C": 2.5738205909729,
    "h": 256.09326171875,
    "CMY_C": 0.66325128078461,
    "CMY_M": 0.64931911230087,
    "CMY_Y": 0.63882201910019,
    "CMYK_C": 0.0676377415657,
    "CMYK_M": 0.02906349115074,
    "CMYK_Y": 0,
    "CMYK_K": 0.63882201910019
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1288",
    "Farbtonhilfsbezeichnung": "Venato 15",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "108",
    "Bcolor": "110",
    "Y": 15,
    "L": 45.2488288879395,
    "a": -0.75254207849503,
    "b": -2.38776969909668,
    "C": 2.5035502910614,
    "h": 252.506958007812,
    "CMY_C": 0.59287422895432,
    "CMY_M": 0.57766425609589,
    "CMY_Y": 0.56824481487274,
    "CMYK_C": 0.05704485997558,
    "CMYK_M": 0.02181662619114,
    "CMYK_Y": 0,
    "CMYK_K": 0.56824481487274
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1289",
    "Farbtonhilfsbezeichnung": "Venato 20",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "121",
    "Bcolor": "123",
    "Y": 19,
    "L": 50.4017372131348,
    "a": -1.11136162281036,
    "b": -2.19814705848694,
    "C": 2.46312308311462,
    "h": 243.179290771484,
    "CMY_C": 0.54462778568268,
    "CMY_M": 0.52643835544586,
    "CMY_Y": 0.51912927627563,
    "CMYK_C": 0.05302570387721,
    "CMYK_M": 0.01519967615604,
    "CMYK_Y": 0,
    "CMYK_K": 0.51912927627563
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1290",
    "Farbtonhilfsbezeichnung": "Venato 25",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "133",
    "Bcolor": "135",
    "Y": 23,
    "L": 55.118278503418,
    "a": -0.90121650695801,
    "b": -2.32413649559021,
    "C": 2.4927499294281,
    "h": 248.80549621582,
    "CMY_C": 0.4966784119606,
    "CMY_M": 0.47971779108047,
    "CMY_Y": 0.47130233049393,
    "CMYK_C": 0.04799734055996,
    "CMYK_M": 0.01591734029353,
    "CMYK_Y": 0,
    "CMYK_K": 0.47130233049393
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1291",
    "Farbtonhilfsbezeichnung": "Venato 30",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "146",
    "Bcolor": "147",
    "Y": 28,
    "L": 60.1126899719238,
    "a": -1.1350257396698,
    "b": -2.01675724983215,
    "C": 2.31421542167664,
    "h": 240.629302978516,
    "CMY_C": 0.44692325592041,
    "CMY_M": 0.42854285240173,
    "CMY_Y": 0.42284166812897,
    "CMYK_C": 0.04172440618277,
    "CMYK_M": 0.00987802445889,
    "CMYK_Y": 0,
    "CMYK_K": 0.42284166812897
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1292",
    "Farbtonhilfsbezeichnung": "Venato 35",
    "Farbtonklasse": "01",
    "Rcolor": "154",
    "Gcolor": "158",
    "Bcolor": "160",
    "Y": 34,
    "L": 64.7602996826172,
    "a": -0.64834243059158,
    "b": -2.20953512191772,
    "C": 2.30269265174866,
    "h": 253.646759033203,
    "CMY_C": 0.39618229866028,
    "CMY_M": 0.38156419992447,
    "CMY_Y": 0.37367832660675,
    "CMYK_C": 0.0359303727746,
    "CMYK_M": 0.012590771541,
    "CMYK_Y": 0,
    "CMYK_K": 0.37367832660675
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1293",
    "Farbtonhilfsbezeichnung": "Venato 40",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "173",
    "Bcolor": "173",
    "Y": 41,
    "L": 70.2601089477539,
    "a": -1.06942653656006,
    "b": -1.60926723480225,
    "C": 1.93220448493958,
    "h": 236.394271850586,
    "CMY_C": 0.33993601799011,
    "CMY_M": 0.32312762737274,
    "CMY_Y": 0.32050907611847,
    "CMYK_C": 0.02859043702483,
    "CMYK_M": 0.00385369569995,
    "CMYK_Y": 0,
    "CMYK_K": 0.32050907611847
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1294",
    "Farbtonhilfsbezeichnung": "Venato 45",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "185",
    "Bcolor": "186",
    "Y": 49,
    "L": 75.0146331787109,
    "a": -0.85317593812943,
    "b": -1.27423799037933,
    "C": 1.53349006175995,
    "h": 236.195404052734,
    "CMY_C": 0.28673160076141,
    "CMY_M": 0.27309983968735,
    "CMY_Y": 0.27253723144531,
    "CMYK_C": 0.01951215974987,
    "CMYK_M": 0.0007733842358,
    "CMYK_Y": 0,
    "CMYK_K": 0.27253723144531
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1295",
    "Farbtonhilfsbezeichnung": "Venato 50",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "199",
    "Bcolor": "199",
    "Y": 57,
    "L": 80.0634994506836,
    "a": -0.78604012727737,
    "b": -1.13524067401886,
    "C": 1.38080787658691,
    "h": 235.301284790039,
    "CMY_C": 0.23146760463715,
    "CMY_M": 0.21883249282837,
    "CMY_Y": 0.21940511465073,
    "CMYK_C": 0.01617465168238,
    "CMYK_M": 0,
    "CMYK_Y": 0.00073303334648,
    "CMYK_K": 0.21883249282837
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1296",
    "Farbtonhilfsbezeichnung": "Venato 55",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "211",
    "Bcolor": "209",
    "Y": 65,
    "L": 84.3789901733398,
    "a": -0.62909698486328,
    "b": -0.27925252914429,
    "C": 0.68829137086868,
    "h": 203.936157226562,
    "CMY_C": 0.18029606342316,
    "CMY_M": 0.17232149839401,
    "CMY_Y": 0.17880517244339,
    "CMYK_C": 0.0096348579973,
    "CMYK_M": 0,
    "CMYK_Y": 0.00783356558532,
    "CMYK_K": 0.17232149839401
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1297",
    "Farbtonhilfsbezeichnung": "Venato 60",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 73,
    "L": 88.0892333984375,
    "a": -0.61381286382675,
    "b": -0.69533336162567,
    "C": 0.92749917507172,
    "h": 228.563201904297,
    "CMY_C": 0.14080601930618,
    "CMY_M": 0.13132661581039,
    "CMY_Y": 0.13514846563339,
    "CMYK_C": 0.0109125059098,
    "CMYK_M": 0,
    "CMYK_Y": 0.00439963955432,
    "CMYK_K": 0.13132661581039
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1298",
    "Farbtonhilfsbezeichnung": "Amber 5",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "85",
    "Bcolor": "71",
    "Y": 10,
    "L": 38.0009117126465,
    "a": 6.3213062286377,
    "b": 11.2404317855835,
    "C": 12.8959770202637,
    "h": 60.6478118896484,
    "CMY_C": 0.58429932594299,
    "CMY_M": 0.66485512256622,
    "CMY_Y": 0.72164118289948,
    "CMYK_C": 0,
    "CMYK_M": 0.19378317892551,
    "CMYK_Y": 0.3303864300251,
    "CMYK_K": 0.58429932594299
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1299",
    "Farbtonhilfsbezeichnung": "Amber 10",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "112",
    "Bcolor": "99",
    "Y": 17,
    "L": 48.7771492004395,
    "a": 5.54309129714966,
    "b": 9.71241092681885,
    "C": 11.182879447937,
    "h": 60.2856254577637,
    "CMY_C": 0.484226167202,
    "CMY_M": 0.55972385406494,
    "CMY_Y": 0.61207544803619,
    "CMYK_C": 0,
    "CMYK_M": 0.14637750387192,
    "CMYK_Y": 0.24787856638432,
    "CMYK_K": 0.484226167202
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1300",
    "Farbtonhilfsbezeichnung": "Amber 15",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "135",
    "Bcolor": "123",
    "Y": 25,
    "L": 57.3937339782715,
    "a": 4.26210927963257,
    "b": 8.16139030456543,
    "C": 9.20727252960205,
    "h": 62.425163269043,
    "CMY_C": 0.40756952762604,
    "CMY_M": 0.47073179483414,
    "CMY_Y": 0.51834636926651,
    "CMYK_C": 0,
    "CMYK_M": 0.10661549121141,
    "CMYK_Y": 0.18698707222939,
    "CMYK_K": 0.40756952762604
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1301",
    "Farbtonhilfsbezeichnung": "Amber 20",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "158",
    "Bcolor": "146",
    "Y": 35,
    "L": 66.017692565918,
    "a": 3.97123074531555,
    "b": 7.41261959075928,
    "C": 8.40937614440918,
    "h": 61.8203010559082,
    "CMY_C": 0.32092475891113,
    "CMY_M": 0.38142663240433,
    "CMY_Y": 0.42666929960251,
    "CMYK_C": 0,
    "CMYK_M": 0.08909450471401,
    "CMYK_Y": 0.15571844577789,
    "CMYK_K": 0.32092475891113
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1302",
    "Farbtonhilfsbezeichnung": "Amber 25",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "181",
    "Bcolor": "172",
    "Y": 48,
    "L": 74.6173553466797,
    "a": 3.19197916984558,
    "b": 5.62827920913696,
    "C": 6.47041416168213,
    "h": 60.4410285949707,
    "CMY_C": 0.23913240432739,
    "CMY_M": 0.28853166103363,
    "CMY_Y": 0.32523632049561,
    "CMYK_C": 0,
    "CMYK_M": 0.06492490321398,
    "CMYK_Y": 0.1131654381752,
    "CMYK_K": 0.23913240432739
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1303",
    "Farbtonhilfsbezeichnung": "Amber 30",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "206",
    "Bcolor": "198",
    "Y": 62,
    "L": 83.4888763427734,
    "a": 2.5079243183136,
    "b": 4.39642143249512,
    "C": 5.06144285202026,
    "h": 60.2975463867188,
    "CMY_C": 0.15084058046341,
    "CMY_M": 0.1907474398613,
    "CMY_Y": 0.2220447063446,
    "CMYK_C": 0,
    "CMYK_M": 0.04699572175741,
    "CMYK_Y": 0.08385248482227,
    "CMYK_K": 0.15084058046341
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1304",
    "Farbtonhilfsbezeichnung": "Amber 35",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "99",
    "Bcolor": "66",
    "Y": 15,
    "L": 45.8021926879883,
    "a": 13.4955186843872,
    "b": 25.0822448730469,
    "C": 28.4824161529541,
    "h": 61.7174949645996,
    "CMY_C": 0.44335782527924,
    "CMY_M": 0.61059606075287,
    "CMY_Y": 0.73972791433334,
    "CMYK_C": 0,
    "CMYK_M": 0.30044117569923,
    "CMYK_Y": 0.53242480754852,
    "CMYK_K": 0.44335782527924
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1305",
    "Farbtonhilfsbezeichnung": "Amber 40",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "123",
    "Bcolor": "94",
    "Y": 23,
    "L": 54.7055053710938,
    "a": 11.8344535827637,
    "b": 21.2710361480713,
    "C": 24.3415546417236,
    "h": 60.9099807739258,
    "CMY_C": 0.36276453733444,
    "CMY_M": 0.51857936382294,
    "CMY_Y": 0.63173341751099,
    "CMYK_C": 0,
    "CMYK_M": 0.24451687932014,
    "CMYK_Y": 0.42208713293076,
    "CMYK_K": 0.36276453733444
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1306",
    "Farbtonhilfsbezeichnung": "Amber 45",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "144",
    "Bcolor": "118",
    "Y": 31,
    "L": 62.3882102966309,
    "a": 9.85549449920654,
    "b": 18.3410587310791,
    "C": 20.821268081665,
    "h": 61.7488174438477,
    "CMY_C": 0.29678928852081,
    "CMY_M": 0.43546581268311,
    "CMY_Y": 0.53770792484283,
    "CMYK_C": 0,
    "CMYK_M": 0.19720479846001,
    "CMYK_Y": 0.34259808063507,
    "CMYK_K": 0.29678928852081
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1307",
    "Farbtonhilfsbezeichnung": "Amber 55",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "188",
    "Bcolor": "172",
    "Y": 53,
    "L": 77.7710037231445,
    "a": 6.06265211105347,
    "b": 10.4696636199951,
    "C": 12.0983304977417,
    "h": 59.9262237548828,
    "CMY_C": 0.17113047838211,
    "CMY_M": 0.26286923885345,
    "CMY_Y": 0.32624310255051,
    "CMYK_C": 0,
    "CMYK_M": 0.1106793731451,
    "CMYK_Y": 0.18713755905628,
    "CMYK_K": 0.17113047838211
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1308",
    "Farbtonhilfsbezeichnung": "Amber 50",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "166",
    "Bcolor": "144",
    "Y": 41,
    "L": 70.0847854614258,
    "a": 8.13752937316895,
    "b": 14.6414852142334,
    "C": 16.7508945465088,
    "h": 60.9353141784668,
    "CMY_C": 0.23152083158493,
    "CMY_M": 0.35060060024261,
    "CMY_Y": 0.4350910782814,
    "CMYK_C": 0,
    "CMYK_M": 0.15495510399342,
    "CMYK_Y": 0.26490014791489,
    "CMYK_K": 0.23152083158493
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1309",
    "Farbtonhilfsbezeichnung": "Amber 60",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "198",
    "Y": 66,
    "L": 85.2234649658203,
    "a": 4.11597967147827,
    "b": 7.34427928924561,
    "C": 8.41901016235352,
    "h": 60.7322731018066,
    "CMY_C": 0.11093109846115,
    "CMY_M": 0.1764150261879,
    "CMY_Y": 0.22459179162979,
    "CMYK_C": 0,
    "CMYK_M": 0.07365450263023,
    "CMYK_Y": 0.12784239649773,
    "CMYK_K": 0.11093109846115
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1310",
    "Farbtonhilfsbezeichnung": "Amber 65",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "115",
    "Bcolor": "63",
    "Y": 22,
    "L": 54.3640213012695,
    "a": 21.1079959869385,
    "b": 38.2954406738281,
    "C": 43.7274322509766,
    "h": 61.136962890625,
    "CMY_C": 0.29318445920944,
    "CMY_M": 0.5496072769165,
    "CMY_Y": 0.75214564800262,
    "CMYK_C": 0,
    "CMYK_M": 0.36278605461121,
    "CMYK_Y": 0.64933657646179,
    "CMYK_K": 0.29318445920944
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1311",
    "Farbtonhilfsbezeichnung": "Amber 70",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "134",
    "Bcolor": "87",
    "Y": 29,
    "L": 60.8713111877441,
    "a": 18.3620300292969,
    "b": 33.975025177002,
    "C": 38.6195106506348,
    "h": 61.6106986999512,
    "CMY_C": 0.23901897668839,
    "CMY_M": 0.47599971294403,
    "CMY_Y": 0.66031932830811,
    "CMYK_C": 0,
    "CMYK_M": 0.31141477823257,
    "CMYK_Y": 0.55362790822983,
    "CMYK_K": 0.23901897668839
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1312",
    "Farbtonhilfsbezeichnung": "Amber 75",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "152",
    "Bcolor": "114",
    "Y": 37,
    "L": 66.959098815918,
    "a": 15.4216022491455,
    "b": 27.2547454833984,
    "C": 31.3152828216553,
    "h": 60.4974365234375,
    "CMY_C": 0.19664192199707,
    "CMY_M": 0.40444964170456,
    "CMY_Y": 0.5541028380394,
    "CMYK_C": 0,
    "CMYK_M": 0.25867384672165,
    "CMYK_Y": 0.44495838880539,
    "CMYK_K": 0.19664192199707
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1313",
    "Farbtonhilfsbezeichnung": "Amber 80",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "172",
    "Bcolor": "139",
    "Y": 46,
    "L": 73.6128082275391,
    "a": 12.2708606719971,
    "b": 22.5267906188965,
    "C": 25.6521015167236,
    "h": 61.4218559265137,
    "CMY_C": 0.14927524328232,
    "CMY_M": 0.32557195425034,
    "CMY_Y": 0.45449095964432,
    "CMYK_C": 0,
    "CMYK_M": 0.2072311937809,
    "CMYK_Y": 0.35877141356468,
    "CMYK_K": 0.14927524328232
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1314",
    "Farbtonhilfsbezeichnung": "Amber 85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "193",
    "Bcolor": "167",
    "Y": 57,
    "L": 80.3555145263672,
    "a": 8.55451679229736,
    "b": 16.9503746032715,
    "C": 18.9867038726807,
    "h": 63.220832824707,
    "CMY_C": 0.1094001531601,
    "CMY_M": 0.2427653670311,
    "CMY_Y": 0.34547030925751,
    "CMYK_C": 0,
    "CMYK_M": 0.14974762499332,
    "CMYK_Y": 0.26506870985031,
    "CMYK_K": 0.1094001531601
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1315",
    "Farbtonhilfsbezeichnung": "Amber 90",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "214",
    "Bcolor": "196",
    "Y": 70,
    "L": 87.116569519043,
    "a": 5.70059394836426,
    "b": 10.9118804931641,
    "C": 12.3112106323242,
    "h": 62.4164962768555,
    "CMY_C": 0.06822854280472,
    "CMY_M": 0.1604306101799,
    "CMY_Y": 0.2300882935524,
    "CMYK_C": 0,
    "CMYK_M": 0.09895352274179,
    "CMYK_Y": 0.1737118512392,
    "CMYK_K": 0.06822854280472
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1316",
    "Farbtonhilfsbezeichnung": "Amber 95",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "127",
    "Bcolor": "51",
    "Y": 30,
    "L": 61.819450378418,
    "a": 29.3879642486572,
    "b": 53.498420715332,
    "C": 61.0387878417969,
    "h": 61.2189521789551,
    "CMY_C": 0.14883530139923,
    "CMY_M": 0.50173270702362,
    "CMY_Y": 0.79918849468231,
    "CMYK_C": 0,
    "CMYK_M": 0.41460531949997,
    "CMYK_Y": 0.76407444477081,
    "CMYK_K": 0.14883530139923
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1317",
    "Farbtonhilfsbezeichnung": "Amber 100",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "146",
    "Bcolor": "80",
    "Y": 37,
    "L": 67.1805648803711,
    "a": 23.9973564147949,
    "b": 45.8306694030762,
    "C": 51.7331924438477,
    "h": 62.363037109375,
    "CMY_C": 0.1207577586174,
    "CMY_M": 0.42927998304367,
    "CMY_Y": 0.68635523319244,
    "CMYK_C": 0,
    "CMYK_M": 0.35089558362961,
    "CMYK_Y": 0.64327830076218,
    "CMYK_K": 0.1207577586174
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1318",
    "Farbtonhilfsbezeichnung": "Amber 105",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "163",
    "Bcolor": "108",
    "Y": 45,
    "L": 72.3109741210938,
    "a": 19.5636768341064,
    "b": 37.8796920776367,
    "C": 42.6334190368652,
    "h": 62.68505859375,
    "CMY_C": 0.09503167867661,
    "CMY_M": 0.36184817552567,
    "CMY_Y": 0.5774450302124,
    "CMYK_C": 0,
    "CMYK_M": 0.29483518004417,
    "CMYK_Y": 0.53307211399078,
    "CMYK_K": 0.09503167867661
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1319",
    "Farbtonhilfsbezeichnung": "Amber 110",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "179",
    "Bcolor": "135",
    "Y": 53,
    "L": 77.3994979858398,
    "a": 16.0957870483398,
    "b": 29.9879016876221,
    "C": 34.0345191955566,
    "h": 61.7756462097168,
    "CMY_C": 0.06857740879059,
    "CMY_M": 0.29696917533875,
    "CMY_Y": 0.46928542852402,
    "CMYK_C": 0,
    "CMYK_M": 0.24520745873451,
    "CMYK_Y": 0.43021076917648,
    "CMYK_K": 0.06857740879059
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1320",
    "Farbtonhilfsbezeichnung": "Amber 115",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "198",
    "Bcolor": "164",
    "Y": 63,
    "L": 83.1052093505859,
    "a": 12.0923385620117,
    "b": 22.5059242248535,
    "C": 25.5488014221191,
    "h": 61.751049041748,
    "CMY_C": 0.04234975576401,
    "CMY_M": 0.22332286834717,
    "CMY_Y": 0.35657155513763,
    "CMYK_C": 0,
    "CMYK_M": 0.18897621333599,
    "CMYK_Y": 0.32811748981476,
    "CMYK_K": 0.04234975576401
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1321",
    "Farbtonhilfsbezeichnung": "Amber 120",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "217",
    "Bcolor": "194",
    "Y": 73,
    "L": 88.6514511108398,
    "a": 7.66109371185303,
    "b": 14.3904409408569,
    "C": 16.3026733398438,
    "h": 61.9703330993652,
    "CMY_C": 0.02773773670197,
    "CMY_M": 0.14929640293121,
    "CMY_Y": 0.23887407779694,
    "CMYK_C": 0,
    "CMYK_M": 0.12502662837505,
    "CMYK_Y": 0.21715986728668,
    "CMYK_K": 0.02773773670197
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1322",
    "Farbtonhilfsbezeichnung": "Amber 125",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "138",
    "Bcolor": "39",
    "Y": 38,
    "L": 68.6853179931641,
    "a": 37.8142051696777,
    "b": 66.0538787841797,
    "C": 76.1119537353516,
    "h": 60.2099342346191,
    "CMY_C": 0.01128959655762,
    "CMY_M": 0.46065056324005,
    "CMY_Y": 0.84526520967484,
    "CMYK_C": 0,
    "CMYK_M": 0.4544920027256,
    "CMYK_Y": 0.84349834918976,
    "CMYK_K": 0.01128959655762
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1323",
    "Farbtonhilfsbezeichnung": "Amber 130",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "156",
    "Bcolor": "72",
    "Y": 46,
    "L": 73.5513687133789,
    "a": 31.1996593475342,
    "b": 57.9559707641602,
    "C": 65.8203125,
    "h": 61.7049179077148,
    "CMY_C": 0,
    "CMY_M": 0.38662046194077,
    "CMY_Y": 0.71940004825592,
    "CMYK_C": 0,
    "CMYK_M": 0.38662046194077,
    "CMYK_Y": 0.71940004825592,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1324",
    "Farbtonhilfsbezeichnung": "Amber 135",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "171",
    "Bcolor": "101",
    "Y": 53,
    "L": 77.2411880493164,
    "a": 26.1887989044189,
    "b": 47.9131202697754,
    "C": 54.6032981872559,
    "h": 61.3394546508789,
    "CMY_C": 0,
    "CMY_M": 0.33061140775681,
    "CMY_Y": 0.60276240110397,
    "CMYK_C": 0,
    "CMYK_M": 0.33061140775681,
    "CMYK_Y": 0.60276240110397,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1325",
    "Farbtonhilfsbezeichnung": "Amber 140",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "134",
    "Y": 60,
    "L": 82.2939071655273,
    "a": 20.9110660552979,
    "b": 37.6999893188477,
    "C": 43.1110420227051,
    "h": 60.9841690063477,
    "CMY_C": 0,
    "CMY_M": 0.25926977396011,
    "CMY_Y": 0.47551995515823,
    "CMYK_C": 0,
    "CMYK_M": 0.25926977396011,
    "CMYK_Y": 0.47551995515823,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1326",
    "Farbtonhilfsbezeichnung": "Amber 145",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "162",
    "Y": 68,
    "L": 85.9365386962891,
    "a": 15.5123281478882,
    "b": 27.5860958099365,
    "C": 31.6484603881836,
    "h": 60.64990234375,
    "CMY_C": 0,
    "CMY_M": 0.20269745588303,
    "CMY_Y": 0.36376202106476,
    "CMYK_C": 0,
    "CMYK_M": 0.20269745588303,
    "CMYK_Y": 0.36376202106476,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1327",
    "Farbtonhilfsbezeichnung": "Amber 150",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "193",
    "Y": 77,
    "L": 90.0607681274414,
    "a": 9.8647575378418,
    "b": 17.2959232330322,
    "C": 19.9113636016846,
    "h": 60.3016586303711,
    "CMY_C": 0,
    "CMY_M": 0.14006948471069,
    "CMY_Y": 0.24485331773758,
    "CMYK_C": 0,
    "CMYK_M": 0.14006948471069,
    "CMYK_Y": 0.24485331773758,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1328",
    "Farbtonhilfsbezeichnung": "Barolo 5",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 6,
    "L": 29.9480304718018,
    "a": 10.0040044784546,
    "b": 3.76734709739685,
    "C": 10.6898555755615,
    "h": 20.6355667114258,
    "CMY_C": 0.655726313591,
    "CMY_M": 0.7452894449234,
    "CMY_Y": 0.74713706970215,
    "CMYK_C": 0,
    "CMYK_M": 0.26015096902847,
    "CMYK_Y": 0.26551768183708,
    "CMYK_K": 0.655726313591
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1329",
    "Farbtonhilfsbezeichnung": "Barolo 10",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "91",
    "Bcolor": "91",
    "Y": 12,
    "L": 40.6715354919434,
    "a": 8.5023365020752,
    "b": 2.93986892700195,
    "C": 8.99625205993652,
    "h": 19.0739479064941,
    "CMY_C": 0.56231987476349,
    "CMY_M": 0.64288264513016,
    "CMY_Y": 0.64462959766388,
    "CMYK_C": 0,
    "CMYK_M": 0.18406769633293,
    "CMYK_Y": 0.18805907666683,
    "CMYK_K": 0.56231987476349
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1330",
    "Farbtonhilfsbezeichnung": "Barolo 15",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "118",
    "Bcolor": "118",
    "Y": 20,
    "L": 51.2799758911133,
    "a": 7.51014852523804,
    "b": 2.30014252662659,
    "C": 7.85448837280273,
    "h": 17.0283203125,
    "CMY_C": 0.46385532617569,
    "CMY_M": 0.53786766529083,
    "CMY_Y": 0.53898525238037,
    "CMYK_C": 0,
    "CMYK_M": 0.13804545998573,
    "CMYK_Y": 0.14012995362282,
    "CMYK_K": 0.46385532617569
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1331",
    "Farbtonhilfsbezeichnung": "Barolo 20",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "146",
    "Bcolor": "145",
    "Y": 30,
    "L": 61.8404502868652,
    "a": 5.86484336853027,
    "b": 2.04670572280884,
    "C": 6.21171426773071,
    "h": 19.2379016876221,
    "CMY_C": 0.36650025844574,
    "CMY_M": 0.42761373519897,
    "CMY_Y": 0.4320222735405,
    "CMYK_C": 0,
    "CMYK_M": 0.09646961838007,
    "CMYK_Y": 0.10342863947153,
    "CMYK_K": 0.36650025844574
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1332",
    "Farbtonhilfsbezeichnung": "Barolo 25",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "174",
    "Bcolor": "173",
    "Y": 45,
    "L": 72.1471405029297,
    "a": 4.60242795944214,
    "b": 1.2139083147049,
    "C": 4.75982332229614,
    "h": 14.7754955291748,
    "CMY_C": 0.26857399940491,
    "CMY_M": 0.31693947315216,
    "CMY_Y": 0.31976699829102,
    "CMYK_C": 0,
    "CMYK_M": 0.0661249011755,
    "CMYK_Y": 0.06999067217112,
    "CMYK_K": 0.26857399940491
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1333",
    "Farbtonhilfsbezeichnung": "Barolo 30",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "206",
    "Bcolor": "203",
    "Y": 63,
    "L": 83.1405334472656,
    "a": 2.65206694602966,
    "b": 1.40745306015015,
    "C": 3.00239634513855,
    "h": 27.9549102783203,
    "CMY_C": 0.16295099258423,
    "CMY_M": 0.19407296180725,
    "CMY_Y": 0.20407277345657,
    "CMYK_C": 0,
    "CMYK_M": 0.03718058019876,
    "CMYK_Y": 0.04912708699703,
    "CMYK_K": 0.16295099258423
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1334",
    "Farbtonhilfsbezeichnung": "Barolo 35",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "64",
    "Bcolor": "64",
    "Y": 7,
    "L": 31.7954254150391,
    "a": 18.3316955566406,
    "b": 7.3156886100769,
    "C": 19.7375373840332,
    "h": 21.7556171417236,
    "CMY_C": 0.58763164281845,
    "CMY_M": 0.75072538852692,
    "CMY_Y": 0.75086969137192,
    "CMYK_C": 0,
    "CMYK_M": 0.3955050110817,
    "CMYK_Y": 0.39585492014885,
    "CMYK_K": 0.58763164281845
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1335",
    "Farbtonhilfsbezeichnung": "Barolo 40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "91",
    "Bcolor": "91",
    "Y": 13,
    "L": 42.5540885925293,
    "a": 15.9364032745361,
    "b": 5.89984750747681,
    "C": 16.993444442749,
    "h": 20.3151569366455,
    "CMY_C": 0.49393147230148,
    "CMY_M": 0.64404112100601,
    "CMY_Y": 0.64465749263763,
    "CMYK_C": 0,
    "CMYK_M": 0.29661920666695,
    "CMYK_Y": 0.29783716797829,
    "CMYK_K": 0.49393147230148
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1336",
    "Farbtonhilfsbezeichnung": "Barolo 45",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "118",
    "Bcolor": "117",
    "Y": 21,
    "L": 52.7336959838867,
    "a": 12.876163482666,
    "b": 4.6206488609314,
    "C": 13.6801309585571,
    "h": 19.7406730651856,
    "CMY_C": 0.40946280956268,
    "CMY_M": 0.53705477714539,
    "CMY_Y": 0.53929126262665,
    "CMYK_C": 0,
    "CMYK_M": 0.21606084704399,
    "CMYK_Y": 0.21984805166721,
    "CMYK_K": 0.40946280956268
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1337",
    "Farbtonhilfsbezeichnung": "Barolo 50",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "148",
    "Bcolor": "147",
    "Y": 33,
    "L": 63.552734375,
    "a": 9.89590072631836,
    "b": 3.64044427871704,
    "C": 10.5442724227905,
    "h": 20.1972560882568,
    "CMY_C": 0.31689941883087,
    "CMY_M": 0.42010450363159,
    "CMY_Y": 0.42492818832397,
    "CMYK_C": 0,
    "CMYK_M": 0.15108329057693,
    "CMYK_Y": 0.15814474225044,
    "CMYK_K": 0.31689941883087
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1338",
    "Farbtonhilfsbezeichnung": "Barolo 55",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "178",
    "Bcolor": "177",
    "Y": 47,
    "L": 74.2182464599609,
    "a": 6.91137790679932,
    "b": 2.64270496368408,
    "C": 7.39939403533936,
    "h": 20.9253654479981,
    "CMY_C": 0.22543495893478,
    "CMY_M": 0.30087369680405,
    "CMY_Y": 0.30772483348846,
    "CMYK_C": 0,
    "CMYK_M": 0.09739496558905,
    "CMYK_Y": 0.1062401086092,
    "CMYK_K": 0.22543495893478
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1339",
    "Farbtonhilfsbezeichnung": "Barolo 60",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "210",
    "Bcolor": "208",
    "Y": 66,
    "L": 85.0888290405273,
    "a": 3.61173248291016,
    "b": 1.76994597911835,
    "C": 4.02210378646851,
    "h": 26.1073760986328,
    "CMY_C": 0.13302981853485,
    "CMY_M": 0.17514759302139,
    "CMY_Y": 0.18543392419815,
    "CMYK_C": 0,
    "CMYK_M": 0.04858041927218,
    "CMYK_Y": 0.06044510751963,
    "CMYK_K": 0.13302981853485
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1340",
    "Farbtonhilfsbezeichnung": "Barolo 65",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "60",
    "Bcolor": "63",
    "Y": 8,
    "L": 33.3323249816895,
    "a": 27.0899448394775,
    "b": 9.83322620391846,
    "C": 28.819393157959,
    "h": 19.9501056671143,
    "CMY_C": 0.52464187145233,
    "CMY_M": 0.76413202285767,
    "CMY_Y": 0.75100362300873,
    "CMYK_C": 0,
    "CMYK_M": 0.50380992889404,
    "CMYK_Y": 0.4761920273304,
    "CMYK_K": 0.52464187145233
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1341",
    "Farbtonhilfsbezeichnung": "Barolo 70",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "90",
    "Bcolor": "90",
    "Y": 13,
    "L": 44.3207511901855,
    "a": 23.4048748016357,
    "b": 8.93050670623779,
    "C": 25.0507907867432,
    "h": 20.8851585388184,
    "CMY_C": 0.42885780334473,
    "CMY_M": 0.64869886636734,
    "CMY_Y": 0.64620023965836,
    "CMYK_C": 0,
    "CMYK_M": 0.38491475582123,
    "CMYK_Y": 0.38053998351097,
    "CMYK_K": 0.42885780334473
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1342",
    "Farbtonhilfsbezeichnung": "Barolo 75",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "120",
    "Bcolor": "120",
    "Y": 23,
    "L": 55.0321655273438,
    "a": 18.4210796356201,
    "b": 6.90636539459229,
    "C": 19.6731815338135,
    "h": 20.5518474578857,
    "CMY_C": 0.34661960601807,
    "CMY_M": 0.52924853563309,
    "CMY_Y": 0.53105676174164,
    "CMYK_C": 0,
    "CMYK_M": 0.27951395511627,
    "CMYK_Y": 0.28228142857552,
    "CMYK_K": 0.34661960601807
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1343",
    "Farbtonhilfsbezeichnung": "Barolo 80",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "150",
    "Bcolor": "149",
    "Y": 35,
    "L": 65.5068969726563,
    "a": 13.9844131469727,
    "b": 5.03804397583008,
    "C": 14.8642425537109,
    "h": 19.8121337890625,
    "CMY_C": 0.26553356647491,
    "CMY_M": 0.41060847043991,
    "CMY_Y": 0.41398286819458,
    "CMYK_C": 0,
    "CMYK_M": 0.19752421975136,
    "CMYK_Y": 0.20211856067181,
    "CMYK_K": 0.26553356647491
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1344",
    "Farbtonhilfsbezeichnung": "Barolo 85",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "181",
    "Bcolor": "180",
    "Y": 50,
    "L": 76.0235290527344,
    "a": 9.77415466308594,
    "b": 3.53047895431519,
    "C": 10.3922271728516,
    "h": 19.8600006103516,
    "CMY_C": 0.18301397562027,
    "CMY_M": 0.28893291950226,
    "CMY_Y": 0.29453748464584,
    "CMYK_C": 0,
    "CMYK_M": 0.12964597344398,
    "CMYK_Y": 0.1365060210228,
    "CMYK_K": 0.18301397562027
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1345",
    "Farbtonhilfsbezeichnung": "Barolo 90",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "214",
    "Bcolor": "211",
    "Y": 70,
    "L": 86.674674987793,
    "a": 4.68352031707764,
    "b": 2.2500433921814,
    "C": 5.19596576690674,
    "h": 25.6604270935059,
    "CMY_C": 0.10582321882248,
    "CMY_M": 0.16045689582825,
    "CMY_Y": 0.17151647806168,
    "CMYK_C": 0,
    "CMYK_M": 0.06109941378236,
    "CMYK_Y": 0.07346786558628,
    "CMYK_K": 0.10582321882248
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1346",
    "Farbtonhilfsbezeichnung": "Barolo 95",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "58",
    "Bcolor": "63",
    "Y": 9,
    "L": 35.2317810058594,
    "a": 33.6664924621582,
    "b": 12.9010457992554,
    "C": 36.0537071228027,
    "h": 20.9668998718262,
    "CMY_C": 0.46885418891907,
    "CMY_M": 0.77104520797729,
    "CMY_Y": 0.75160759687424,
    "CMYK_C": 0,
    "CMYK_M": 0.56894171237946,
    "CMYK_Y": 0.53234612941742,
    "CMYK_K": 0.46885418891907
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1347",
    "Farbtonhilfsbezeichnung": "Barolo 100",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "89",
    "Bcolor": "92",
    "Y": 16,
    "L": 46.2520751953125,
    "a": 30.3122653961182,
    "b": 11.024640083313,
    "C": 32.2548637390137,
    "h": 19.9864406585693,
    "CMY_C": 0.36787098646164,
    "CMY_M": 0.65223979949951,
    "CMY_Y": 0.64028692245483,
    "CMYK_C": 0,
    "CMYK_M": 0.44985881447792,
    "CMYK_Y": 0.43094989657402,
    "CMYK_K": 0.36787098646164
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1348",
    "Farbtonhilfsbezeichnung": "Barolo 105",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "121",
    "Bcolor": "121",
    "Y": 25,
    "L": 57.0953063964844,
    "a": 24.4783325195313,
    "b": 9.15745544433594,
    "C": 26.135181427002,
    "h": 20.5110511779785,
    "CMY_C": 0.28419196605682,
    "CMY_M": 0.52626168727875,
    "CMY_Y": 0.52479541301727,
    "CMYK_C": 0,
    "CMYK_M": 0.33817687630653,
    "CMYK_Y": 0.33612844347954,
    "CMYK_K": 0.28419196605682
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1349",
    "Farbtonhilfsbezeichnung": "Barolo 110",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "151",
    "Bcolor": "150",
    "Y": 37,
    "L": 66.9547653198242,
    "a": 18.2510833740234,
    "b": 6.80760955810547,
    "C": 19.479362487793,
    "h": 20.4553928375244,
    "CMY_C": 0.21820324659348,
    "CMY_M": 0.4073686003685,
    "CMY_Y": 0.41073143482208,
    "CMYK_C": 0,
    "CMYK_M": 0.24196231365204,
    "CMYK_Y": 0.24626372754574,
    "CMYK_K": 0.21820324659348
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1350",
    "Farbtonhilfsbezeichnung": "Barolo 115",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "185",
    "Bcolor": "183",
    "Y": 53,
    "L": 78.0165710449219,
    "a": 11.8143291473389,
    "b": 4.72598361968994,
    "C": 12.724515914917,
    "h": 21.8024616241455,
    "CMY_C": 0.1435352563858,
    "CMY_M": 0.27309513092041,
    "CMY_Y": 0.28162813186646,
    "CMYK_C": 0,
    "CMYK_M": 0.15127286314964,
    "CMYK_Y": 0.1612359136343,
    "CMYK_K": 0.1435352563858
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1351",
    "Farbtonhilfsbezeichnung": "Barolo 120",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "217",
    "Bcolor": "213",
    "Y": 73,
    "L": 87.9996185302734,
    "a": 6.30777788162231,
    "b": 3.34658622741699,
    "C": 7.14056730270386,
    "h": 27.948148727417,
    "CMY_C": 0.07549124956131,
    "CMY_M": 0.15016329288483,
    "CMY_Y": 0.16485661268234,
    "CMYK_C": 0,
    "CMYK_M": 0.08076942712069,
    "CMYK_Y": 0.09666253626347,
    "CMYK_K": 0.07549124956131
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1352",
    "Farbtonhilfsbezeichnung": "Barolo 125",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "56",
    "Bcolor": "66",
    "Y": 11,
    "L": 38.7776832580566,
    "a": 43.677433013916,
    "b": 16.8092746734619,
    "C": 46.8003196716309,
    "h": 21.0492382049561,
    "CMY_C": 0.37771201133728,
    "CMY_M": 0.78147965669632,
    "CMY_Y": 0.742063164711,
    "CMYK_C": 0,
    "CMYK_M": 0.64884370565414,
    "CMYK_Y": 0.58550244569778,
    "CMYK_K": 0.37771201133728
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1353",
    "Farbtonhilfsbezeichnung": "Barolo 130",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "87",
    "Bcolor": "92",
    "Y": 17,
    "L": 48.074634552002,
    "a": 37.4778175354004,
    "b": 13.8480520248413,
    "C": 39.9544143676758,
    "h": 20.2792682647705,
    "CMY_C": 0.30627542734146,
    "CMY_M": 0.66044807434082,
    "CMY_Y": 0.63996875286102,
    "CMYK_C": 0,
    "CMYK_M": 0.51053786277771,
    "CMYK_Y": 0.48101702332497,
    "CMYK_K": 0.30627542734146
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1354",
    "Farbtonhilfsbezeichnung": "Barolo 135",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "121",
    "Bcolor": "120",
    "Y": 28,
    "L": 58.8436965942383,
    "a": 29.7248954772949,
    "b": 12.4173974990845,
    "C": 32.2143020629883,
    "h": 22.6724414825439,
    "CMY_C": 0.22886681556702,
    "CMY_M": 0.52544748783112,
    "CMY_Y": 0.52853989601135,
    "CMYK_C": 0,
    "CMYK_M": 0.38460370898247,
    "CMYK_Y": 0.38861390948296,
    "CMYK_K": 0.22886681556702
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1355",
    "Farbtonhilfsbezeichnung": "Barolo 140",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "155",
    "Bcolor": "154",
    "Y": 40,
    "L": 69.1060409545898,
    "a": 21.0382671356201,
    "b": 8.1561803817749,
    "C": 22.5639533996582,
    "h": 21.1904697418213,
    "CMY_C": 0.17374867200851,
    "CMY_M": 0.39301943778992,
    "CMY_Y": 0.39756935834885,
    "CMYK_C": 0,
    "CMYK_M": 0.26538023352623,
    "CMYK_Y": 0.27088692784309,
    "CMYK_K": 0.17374867200851
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1356",
    "Farbtonhilfsbezeichnung": "Barolo 145",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "186",
    "Bcolor": "185",
    "Y": 56,
    "L": 79.1393737792969,
    "a": 14.8687210083008,
    "b": 5.63087701797485,
    "C": 15.8992338180542,
    "h": 20.7419891357422,
    "CMY_C": 0.10765844583511,
    "CMY_M": 0.26923716068268,
    "CMY_Y": 0.27570754289627,
    "CMYK_C": 0,
    "CMYK_M": 0.18107272684574,
    "CMYK_Y": 0.1883237361908,
    "CMYK_K": 0.10765844583511
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1357",
    "Farbtonhilfsbezeichnung": "Barolo 150",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.8329620361328,
    "a": 7.62248039245605,
    "b": 2.98431277275085,
    "C": 8.18586158752441,
    "h": 21.3810710906982,
    "CMY_C": 0.04617953300476,
    "CMY_M": 0.13307696580887,
    "CMY_Y": 0.14191567897797,
    "CMYK_C": 0,
    "CMYK_M": 0.09110460430384,
    "CMYK_Y": 0.10037124156952,
    "CMYK_K": 0.04617953300476
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1358",
    "Farbtonhilfsbezeichnung": "Grenadin 5",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "64",
    "Bcolor": "62",
    "Y": 6,
    "L": 29.6359386444092,
    "a": 10.2185115814209,
    "b": 4.8243613243103,
    "C": 11.3001079559326,
    "h": 25.2729225158691,
    "CMY_C": 0.65550768375397,
    "CMY_M": 0.74882507324219,
    "CMY_Y": 0.7561639547348,
    "CMYK_C": 0,
    "CMYK_M": 0.27088379859924,
    "CMYK_Y": 0.29218727350235,
    "CMYK_K": 0.65550768375397
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1359",
    "Farbtonhilfsbezeichnung": "Grenadin 10",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "92",
    "Bcolor": "89",
    "Y": 12,
    "L": 41.1149444580078,
    "a": 8.47123336791992,
    "b": 4.33382081985474,
    "C": 9.5154504776001,
    "h": 27.0939521789551,
    "CMY_C": 0.55497932434082,
    "CMY_M": 0.63895517587662,
    "CMY_Y": 0.64927935600281,
    "CMYK_C": 0,
    "CMYK_M": 0.18870101869106,
    "CMYK_Y": 0.21190033853054,
    "CMYK_K": 0.55497932434082
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1360",
    "Farbtonhilfsbezeichnung": "Grenadin 15",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "120",
    "Bcolor": "117",
    "Y": 20,
    "L": 51.9755783081055,
    "a": 6.84149885177612,
    "b": 3.71066617965698,
    "C": 7.78300380706787,
    "h": 28.4743499755859,
    "CMY_C": 0.45750200748444,
    "CMY_M": 0.5297948718071,
    "CMY_Y": 0.54155814647675,
    "CMYK_C": 0,
    "CMYK_M": 0.13325922191143,
    "CMYK_Y": 0.15494276583195,
    "CMYK_K": 0.45750200748444
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1361",
    "Farbtonhilfsbezeichnung": "Grenadin 20",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "145",
    "Bcolor": "143",
    "Y": 31,
    "L": 61.5988922119141,
    "a": 6.39598941802979,
    "b": 3.02518606185913,
    "C": 7.07533979415894,
    "h": 25.3132934570313,
    "CMY_C": 0.36270290613174,
    "CMY_M": 0.43159401416779,
    "CMY_Y": 0.44108164310455,
    "CMYK_C": 0,
    "CMYK_M": 0.1080988869071,
    "CMYK_Y": 0.12298618257046,
    "CMYK_K": 0.36270290613174
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1362",
    "Farbtonhilfsbezeichnung": "Grenadin 25",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "176",
    "Bcolor": "173",
    "Y": 45,
    "L": 72.5732879638672,
    "a": 3.99035739898682,
    "b": 2.20963096618652,
    "C": 4.56129598617554,
    "h": 28.9751682281494,
    "CMY_C": 0.26542848348618,
    "CMY_M": 0.31125056743622,
    "CMY_Y": 0.32239204645157,
    "CMYK_C": 0,
    "CMYK_M": 0.06237933784723,
    "CMYK_Y": 0.07754665613174,
    "CMYK_K": 0.26542848348618
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1363",
    "Farbtonhilfsbezeichnung": "Grenadin 30",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "206",
    "Bcolor": "203",
    "Y": 63,
    "L": 83.2875595092773,
    "a": 2.60665392875671,
    "b": 1.60995244979858,
    "C": 3.06375455856323,
    "h": 31.7007999420166,
    "CMY_C": 0.16102939844131,
    "CMY_M": 0.1924152970314,
    "CMY_Y": 0.20395761728287,
    "CMYK_C": 0,
    "CMYK_M": 0.03741000965238,
    "CMYK_Y": 0.05116772651672,
    "CMYK_K": 0.16102939844131
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1364",
    "Farbtonhilfsbezeichnung": "Grenadin 35",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 7,
    "L": 32.1300735473633,
    "a": 18.0504627227783,
    "b": 9.79984855651855,
    "C": 20.5391387939453,
    "h": 28.4981536865234,
    "CMY_C": 0.58196175098419,
    "CMY_M": 0.74747860431671,
    "CMY_Y": 0.76295632123947,
    "CMYK_C": 0,
    "CMYK_M": 0.39593711495399,
    "CMYK_Y": 0.43296173214912,
    "CMYK_K": 0.58196175098419
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1365",
    "Farbtonhilfsbezeichnung": "Grenadin 40",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "94",
    "Bcolor": "90",
    "Y": 14,
    "L": 43.5980262756348,
    "a": 15.3622016906738,
    "b": 7.62587118148804,
    "C": 17.1508350372314,
    "h": 26.4000225067139,
    "CMY_C": 0.48317068815231,
    "CMY_M": 0.63302075862885,
    "CMY_Y": 0.64594799280167,
    "CMYK_C": 0,
    "CMYK_M": 0.28994113206863,
    "CMYK_Y": 0.31495371460915,
    "CMYK_K": 0.48317068815231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1366",
    "Farbtonhilfsbezeichnung": "Grenadin 45",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "122",
    "Bcolor": "118",
    "Y": 22,
    "L": 54.2428512573242,
    "a": 12.6757469177246,
    "b": 6.4688720703125,
    "C": 14.2309827804565,
    "h": 27.036792755127,
    "CMY_C": 0.39075016975403,
    "CMY_M": 0.52203118801117,
    "CMY_Y": 0.53677606582642,
    "CMYK_C": 0,
    "CMYK_M": 0.21547977626324,
    "CMYK_Y": 0.2396814674139,
    "CMYK_K": 0.39075016975403
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1367",
    "Farbtonhilfsbezeichnung": "Grenadin 50",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "150",
    "Bcolor": "146",
    "Y": 33,
    "L": 64.195686340332,
    "a": 9.31992816925049,
    "b": 5.04088401794434,
    "C": 10.5958280563354,
    "h": 28.407693862915,
    "CMY_C": 0.31027472019196,
    "CMY_M": 0.41243678331375,
    "CMY_Y": 0.42807656526566,
    "CMYK_C": 0,
    "CMYK_M": 0.1481199413538,
    "CMYK_Y": 0.17079530656338,
    "CMYK_K": 0.31027472019196
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1368",
    "Farbtonhilfsbezeichnung": "Grenadin 55",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "180",
    "Bcolor": "175",
    "Y": 46,
    "L": 74.75830078125,
    "a": 6.89912748336792,
    "b": 4.02312564849854,
    "C": 7.98645734786987,
    "h": 30.2479782104492,
    "CMY_C": 0.21570456027985,
    "CMY_M": 0.29546827077866,
    "CMY_Y": 0.31181985139847,
    "CMYK_C": 0,
    "CMYK_M": 0.10170110315084,
    "CMYK_Y": 0.12254985421896,
    "CMYK_K": 0.21570456027985
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1369",
    "Farbtonhilfsbezeichnung": "Grenadin 60",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "209",
    "Bcolor": "206",
    "Y": 66,
    "L": 84.8454818725586,
    "a": 3.8115246295929,
    "b": 2.5481903553009,
    "C": 4.58486557006836,
    "h": 33.7646598815918,
    "CMY_C": 0.1317725777626,
    "CMY_M": 0.17851692438126,
    "CMY_Y": 0.19372481107712,
    "CMYK_C": 0,
    "CMYK_M": 0.05383882671595,
    "CMYK_Y": 0.07135484367609,
    "CMYK_K": 0.1317725777626
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1370",
    "Farbtonhilfsbezeichnung": "Grenadin 65",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "65",
    "Bcolor": "60",
    "Y": 9,
    "L": 35.7886390686035,
    "a": 27.8874034881592,
    "b": 15.750693321228,
    "C": 32.0279808044434,
    "h": 29.4575881958008,
    "CMY_C": 0.48746764659882,
    "CMY_M": 0.74532747268677,
    "CMY_Y": 0.76541209220886,
    "CMYK_C": 0,
    "CMYK_M": 0.50310933589935,
    "CMYK_Y": 0.54229640960693,
    "CMYK_K": 0.48746764659882
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1371",
    "Farbtonhilfsbezeichnung": "Grenadin 70",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "94",
    "Bcolor": "90",
    "Y": 16,
    "L": 46.172176361084,
    "a": 23.3327407836914,
    "b": 12.0044841766357,
    "C": 26.2397499084473,
    "h": 27.2254104614258,
    "CMY_C": 0.40450060367584,
    "CMY_M": 0.63139593601227,
    "CMY_Y": 0.6485983133316,
    "CMYK_C": 0,
    "CMYK_M": 0.38101691007614,
    "CMYK_Y": 0.40990421175957,
    "CMYK_K": 0.40450060367584
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1372",
    "Farbtonhilfsbezeichnung": "Grenadin 75",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "125",
    "Bcolor": "119",
    "Y": 25,
    "L": 56.8524703979492,
    "a": 17.7283210754395,
    "b": 9.68168640136719,
    "C": 20.1997127532959,
    "h": 28.6395778656006,
    "CMY_C": 0.32556426525116,
    "CMY_M": 0.50986397266388,
    "CMY_Y": 0.53181707859039,
    "CMYK_C": 0,
    "CMYK_M": 0.27326503396034,
    "CMYK_Y": 0.30581536889076,
    "CMYK_K": 0.32556426525116
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1373",
    "Farbtonhilfsbezeichnung": "Grenadin 80",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "152",
    "Bcolor": "147",
    "Y": 36,
    "L": 66.3616256713867,
    "a": 13.9692277908325,
    "b": 7.51175165176392,
    "C": 15.8608236312866,
    "h": 28.2685031890869,
    "CMY_C": 0.2504500746727,
    "CMY_M": 0.40237313508987,
    "CMY_Y": 0.42233633995056,
    "CMYK_C": 0,
    "CMYK_M": 0.20268571376801,
    "CMYK_Y": 0.22931930422783,
    "CMYK_K": 0.2504500746727
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1374",
    "Farbtonhilfsbezeichnung": "Grenadin 85",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "183",
    "Bcolor": "178",
    "Y": 52,
    "L": 76.5693893432617,
    "a": 9.06008434295654,
    "b": 5.28348970413208,
    "C": 10.4881067276001,
    "h": 30.2490768432617,
    "CMY_C": 0.17718523740768,
    "CMY_M": 0.28179115056992,
    "CMY_Y": 0.30135476589203,
    "CMYK_C": 0,
    "CMYK_M": 0.12713178992271,
    "CMYK_Y": 0.15090824663639,
    "CMYK_K": 0.17718523740768
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1375",
    "Farbtonhilfsbezeichnung": "Grenadin 90",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "215",
    "Bcolor": "211",
    "Y": 69,
    "L": 86.9866180419922,
    "a": 4.68164873123169,
    "b": 3.0238151550293,
    "C": 5.57326602935791,
    "h": 32.8578834533691,
    "CMY_C": 0.09995520114899,
    "CMY_M": 0.15723490715027,
    "CMY_Y": 0.17378211021423,
    "CMYK_C": 0,
    "CMYK_M": 0.06364095211029,
    "CMYK_Y": 0.08202581852674,
    "CMYK_K": 0.09995520114899
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1376",
    "Farbtonhilfsbezeichnung": "Grenadin 95",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "69",
    "Bcolor": "65",
    "Y": 11,
    "L": 39.5857124328613,
    "a": 33.4335479736328,
    "b": 18.350830078125,
    "C": 38.1386299133301,
    "h": 28.7612705230713,
    "CMY_C": 0.41616690158844,
    "CMY_M": 0.72962856292725,
    "CMY_Y": 0.74693340063095,
    "CMYK_C": 0,
    "CMYK_M": 0.53690284490585,
    "CMYK_Y": 0.56654292345047,
    "CMYK_K": 0.41616690158844
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1377",
    "Farbtonhilfsbezeichnung": "Grenadin 100",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "95",
    "Bcolor": "89",
    "Y": 18,
    "L": 48.5541076660156,
    "a": 28.7825508117676,
    "b": 15.9299926757813,
    "C": 32.8968086242676,
    "h": 28.9627742767334,
    "CMY_C": 0.34352624416351,
    "CMY_M": 0.62594467401505,
    "CMY_Y": 0.65072321891785,
    "CMYK_C": 0,
    "CMYK_M": 0.4302051961422,
    "CMYK_Y": 0.46795013546944,
    "CMYK_K": 0.34352624416351
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1378",
    "Farbtonhilfsbezeichnung": "Grenadin 105",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "126",
    "Bcolor": "120",
    "Y": 27,
    "L": 58.9672813415527,
    "a": 23.005880355835,
    "b": 12.5287380218506,
    "C": 26.1961784362793,
    "h": 28.5722026824951,
    "CMY_C": 0.26590514183044,
    "CMY_M": 0.50395703315735,
    "CMY_Y": 0.52928411960602,
    "CMYK_C": 0,
    "CMYK_M": 0.3242794573307,
    "CMYK_Y": 0.35878059267998,
    "CMYK_K": 0.26590514183044
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1379",
    "Farbtonhilfsbezeichnung": "Grenadin 110",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "156",
    "Bcolor": "150",
    "Y": 39,
    "L": 68.7839431762695,
    "a": 17.8476161956787,
    "b": 9.68155670166016,
    "C": 20.3044319152832,
    "h": 28.4779090881348,
    "CMY_C": 0.19411790370941,
    "CMY_M": 0.38800400495529,
    "CMY_Y": 0.41201877593994,
    "CMYK_C": 0,
    "CMYK_M": 0.24058866500854,
    "CMYK_Y": 0.27038803696632,
    "CMYK_K": 0.19411790370941
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1380",
    "Farbtonhilfsbezeichnung": "Grenadin 115",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "186",
    "Bcolor": "181",
    "Y": 54,
    "L": 78.2720642089844,
    "a": 12.158637046814,
    "b": 6.31108045578003,
    "C": 13.6989850997925,
    "h": 27.4320888519287,
    "CMY_C": 0.13412988185883,
    "CMY_M": 0.27167195081711,
    "CMY_Y": 0.29020702838898,
    "CMYK_C": 0,
    "CMYK_M": 0.15884838998318,
    "CMYK_Y": 0.18025468289852,
    "CMYK_K": 0.13412988185883
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1381",
    "Farbtonhilfsbezeichnung": "Grenadin 120",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "218",
    "Bcolor": "213",
    "Y": 73,
    "L": 88.2509155273438,
    "a": 5.22509002685547,
    "b": 3.50143814086914,
    "C": 6.28980398178101,
    "h": 33.8268356323242,
    "CMY_C": 0.08027505874634,
    "CMY_M": 0.14475506544113,
    "CMY_Y": 0.16340613365173,
    "CMYK_C": 0,
    "CMYK_M": 0.07010792195797,
    "CMYK_Y": 0.09038688987494,
    "CMYK_K": 0.08027505874634
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1382",
    "Farbtonhilfsbezeichnung": "Grenadin 125",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "66",
    "Bcolor": "64",
    "Y": 13,
    "L": 42.4544639587402,
    "a": 42.8032760620117,
    "b": 23.2464370727539,
    "C": 48.7084922790527,
    "h": 28.5063610076904,
    "CMY_C": 0.33360540866852,
    "CMY_M": 0.74133318662643,
    "CMY_Y": 0.75017756223679,
    "CMYK_C": 0,
    "CMYK_M": 0.61184138059616,
    "CMYK_Y": 0.62511336803436,
    "CMYK_K": 0.33360540866852
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1383",
    "Farbtonhilfsbezeichnung": "Grenadin 130",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "95",
    "Bcolor": "88",
    "Y": 20,
    "L": 51.1979370117188,
    "a": 36.7073364257813,
    "b": 20.3624000549316,
    "C": 41.9768486022949,
    "h": 29.0181331634521,
    "CMY_C": 0.26643353700638,
    "CMY_M": 0.62803733348846,
    "CMY_Y": 0.65335249900818,
    "CMYK_C": 0,
    "CMYK_M": 0.49293938279152,
    "CMYK_Y": 0.52744907140732,
    "CMYK_K": 0.26643353700638
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1384",
    "Farbtonhilfsbezeichnung": "Grenadin 135",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "127",
    "Bcolor": "118",
    "Y": 30,
    "L": 61.0588455200195,
    "a": 29.6912040710449,
    "b": 16.6583099365234,
    "C": 34.0450706481934,
    "h": 29.2946910858154,
    "CMY_C": 0.19701212644577,
    "CMY_M": 0.50388038158417,
    "CMY_Y": 0.53547096252441,
    "CMYK_C": 0,
    "CMYK_M": 0.38215801119804,
    "CMYK_Y": 0.42149931192398,
    "CMYK_K": 0.19701212644577
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1385",
    "Farbtonhilfsbezeichnung": "Grenadin 140",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "156",
    "Bcolor": "149",
    "Y": 42,
    "L": 69.85693359375,
    "a": 22.3360500335693,
    "b": 11.6725654602051,
    "C": 25.2021408081055,
    "h": 27.5910568237305,
    "CMY_C": 0.14982682466507,
    "CMY_M": 0.38976901769638,
    "CMY_Y": 0.41417044401169,
    "CMYK_C": 0,
    "CMYK_M": 0.28222742676735,
    "CMYK_Y": 0.31092914938927,
    "CMYK_K": 0.14982682466507
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1386",
    "Farbtonhilfsbezeichnung": "Grenadin 145",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "189",
    "Bcolor": "183",
    "Y": 57,
    "L": 80.0255813598633,
    "a": 13.9838562011719,
    "b": 7.83102798461914,
    "C": 16.0272655487061,
    "h": 29.2490386962891,
    "CMY_C": 0.09811645746231,
    "CMY_M": 0.25796711444855,
    "CMY_Y": 0.28222244977951,
    "CMYK_C": 0,
    "CMYK_M": 0.1772409081459,
    "CMYK_Y": 0.20413500070572,
    "CMYK_K": 0.09811645746231
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1387",
    "Farbtonhilfsbezeichnung": "Grenadin 150",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "222",
    "Bcolor": "217",
    "Y": 75,
    "L": 89.8150177001953,
    "a": 6.57262563705444,
    "b": 4.07548332214355,
    "C": 7.73362588882446,
    "h": 31.8017807006836,
    "CMY_C": 0.05089122056961,
    "CMY_M": 0.13095235824585,
    "CMY_Y": 0.15031427145004,
    "CMYK_C": 0,
    "CMYK_M": 0.08435401320457,
    "CMYK_Y": 0.10475411266088,
    "CMYK_K": 0.05089122056961
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1388",
    "Farbtonhilfsbezeichnung": "Magma 5",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "71",
    "Bcolor": "67",
    "Y": 8,
    "L": 32.4889793395996,
    "a": 8.66206169128418,
    "b": 6.09976530075073,
    "C": 10.5942649841309,
    "h": 35.152946472168,
    "CMY_C": 0.63431686162949,
    "CMY_M": 0.71981108188629,
    "CMY_Y": 0.7388459444046,
    "CMYK_C": 0,
    "CMYK_M": 0.23379316926003,
    "CMYK_Y": 0.28584605455399,
    "CMYK_K": 0.63431686162949
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1389",
    "Farbtonhilfsbezeichnung": "Magma 10",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "96",
    "Bcolor": "91",
    "Y": 13,
    "L": 42.4218521118164,
    "a": 7.66386699676514,
    "b": 5.19890403747559,
    "C": 9.26085662841797,
    "h": 34.1516227722168,
    "CMY_C": 0.54496031999588,
    "CMY_M": 0.62489235401154,
    "CMY_Y": 0.64264714717865,
    "CMYK_C": 0,
    "CMYK_M": 0.17565947771072,
    "CMYK_Y": 0.21467760205269,
    "CMYK_K": 0.54496031999588
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1390",
    "Farbtonhilfsbezeichnung": "Magma 15",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "123",
    "Bcolor": "118",
    "Y": 22,
    "L": 52.9667854309082,
    "a": 6.44515514373779,
    "b": 4.34152984619141,
    "C": 7.77102994918823,
    "h": 33.964656829834,
    "CMY_C": 0.44835597276688,
    "CMY_M": 0.5192004442215,
    "CMY_Y": 0.5360723733902,
    "CMYK_C": 0,
    "CMYK_M": 0.12842425704002,
    "CMYK_Y": 0.15900906920433,
    "CMYK_K": 0.44835597276688
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1391",
    "Farbtonhilfsbezeichnung": "Magma 20",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "150",
    "Bcolor": "146",
    "Y": 32,
    "L": 63.0073890686035,
    "a": 4.67738056182861,
    "b": 3.35239744186401,
    "C": 5.75469017028809,
    "h": 35.6301307678223,
    "CMY_C": 0.35880959033966,
    "CMY_M": 0.41319698095322,
    "CMY_Y": 0.42924183607101,
    "CMYK_C": 0,
    "CMYK_M": 0.08482252806425,
    "CMYK_Y": 0.10984607040882,
    "CMYK_K": 0.35880959033966
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1392",
    "Farbtonhilfsbezeichnung": "Magma 25",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "178",
    "Bcolor": "174",
    "Y": 46,
    "L": 73.3017730712891,
    "a": 3.8887050151825,
    "b": 2.71548938751221,
    "C": 4.74298524856567,
    "h": 34.9266624450684,
    "CMY_C": 0.25681781768799,
    "CMY_M": 0.30341154336929,
    "CMY_Y": 0.31831985712051,
    "CMYK_C": 0,
    "CMYK_M": 0.06269489228725,
    "CMYK_Y": 0.08275499939919,
    "CMYK_K": 0.25681781768799
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1393",
    "Farbtonhilfsbezeichnung": "Magma 30",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "206",
    "Bcolor": "202",
    "Y": 63,
    "L": 83.2549591064453,
    "a": 2.37672138214111,
    "b": 2.21821451187134,
    "C": 3.25104284286499,
    "h": 43.0243072509766,
    "CMY_C": 0.16119134426117,
    "CMY_M": 0.19239401817322,
    "CMY_Y": 0.20876038074493,
    "CMYK_C": 0,
    "CMYK_M": 0.03719879686832,
    "CMYK_Y": 0.05671023577452,
    "CMYK_K": 0.16119134426117
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1394",
    "Farbtonhilfsbezeichnung": "Magma 35",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "75",
    "Bcolor": "67",
    "Y": 9,
    "L": 36.1524925231934,
    "a": 15.6268291473389,
    "b": 11.4530792236328,
    "C": 19.3744888305664,
    "h": 36.238109588623,
    "CMY_C": 0.55131411552429,
    "CMY_M": 0.70450937747955,
    "CMY_Y": 0.73797672986984,
    "CMYK_C": 0,
    "CMYK_M": 0.34143099188805,
    "CMYK_Y": 0.41602069139481,
    "CMYK_K": 0.55131411552429
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1395",
    "Farbtonhilfsbezeichnung": "Magma 40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "98",
    "Bcolor": "89",
    "Y": 15,
    "L": 44.8533210754395,
    "a": 13.8009691238403,
    "b": 10.0559377670288,
    "C": 17.0759658813477,
    "h": 36.0785751342773,
    "CMY_C": 0.47459119558334,
    "CMY_M": 0.61756980419159,
    "CMY_Y": 0.65001493692398,
    "CMYK_C": 0,
    "CMYK_M": 0.27212831377983,
    "CMYK_Y": 0.33388048410416,
    "CMYK_K": 0.47459119558334
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1396",
    "Farbtonhilfsbezeichnung": "Magma 45",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "126",
    "Bcolor": "118",
    "Y": 24,
    "L": 55.6018676757813,
    "a": 11.9080667495728,
    "b": 8.4555606842041,
    "C": 14.6047449111938,
    "h": 35.3774185180664,
    "CMY_C": 0.376828789711,
    "CMY_M": 0.50703305006027,
    "CMY_Y": 0.53681099414825,
    "CMYK_C": 0,
    "CMYK_M": 0.2089381814003,
    "CMYK_Y": 0.25672271847725,
    "CMYK_K": 0.376828789711
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1397",
    "Farbtonhilfsbezeichnung": "Magma 50",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "151",
    "Bcolor": "144",
    "Y": 34,
    "L": 64.7046432495117,
    "a": 9.53593730926514,
    "b": 7.11151027679443,
    "C": 11.8957004547119,
    "h": 36.7140617370605,
    "CMY_C": 0.29822582006454,
    "CMY_M": 0.40824496746063,
    "CMY_Y": 0.43712323904037,
    "CMYK_C": 0,
    "CMYK_M": 0.15677286684513,
    "CMYK_Y": 0.19792324304581,
    "CMYK_K": 0.29822582006454
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1398",
    "Farbtonhilfsbezeichnung": "Magma 55",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "181",
    "Bcolor": "175",
    "Y": 49,
    "L": 75.3964767456055,
    "a": 6.76659440994263,
    "b": 5.32317113876343,
    "C": 8.60946846008301,
    "h": 38.1915588378906,
    "CMY_C": 0.20604062080383,
    "CMY_M": 0.28868687152863,
    "CMY_Y": 0.31435161828995,
    "CMYK_C": 0,
    "CMYK_M": 0.10409380495548,
    "CMYK_Y": 0.13641881942749,
    "CMYK_K": 0.20604062080383
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1399",
    "Farbtonhilfsbezeichnung": "Magma 60",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "206",
    "Y": 67,
    "L": 85.2735137939453,
    "a": 4.07742357254028,
    "b": 3.01514959335327,
    "C": 5.07114505767822,
    "h": 36.4819717407227,
    "CMY_C": 0.12357991933823,
    "CMY_M": 0.17459607124329,
    "CMY_Y": 0.1924461722374,
    "CMYK_C": 0,
    "CMYK_M": 0.05820970237255,
    "CMYK_Y": 0.07857676595449,
    "CMYK_K": 0.12357991933823
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1400",
    "Farbtonhilfsbezeichnung": "Magma 65",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "78",
    "Bcolor": "68",
    "Y": 10,
    "L": 39.7398452758789,
    "a": 22.970874786377,
    "b": 16.0668258666992,
    "C": 28.0321960449219,
    "h": 34.9706077575684,
    "CMY_C": 0.46939712762833,
    "CMY_M": 0.69264382123947,
    "CMY_Y": 0.73343813419342,
    "CMYK_C": 0,
    "CMYK_M": 0.42074158787727,
    "CMYK_Y": 0.49762454628944,
    "CMYK_K": 0.46939712762833
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1401",
    "Farbtonhilfsbezeichnung": "Magma 70",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "101",
    "Bcolor": "90",
    "Y": 17,
    "L": 48.1219825744629,
    "a": 20.2122135162354,
    "b": 14.4349126815796,
    "C": 24.8374767303467,
    "h": 35.5332069396973,
    "CMY_C": 0.39679092168808,
    "CMY_M": 0.60408091545105,
    "CMY_Y": 0.64667534828186,
    "CMYK_C": 0,
    "CMYK_M": 0.34364533424377,
    "CMYK_Y": 0.41425839066505,
    "CMYK_K": 0.39679092168808
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1402",
    "Farbtonhilfsbezeichnung": "Magma 75",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "127",
    "Bcolor": "116",
    "Y": 26,
    "L": 57.6789016723633,
    "a": 16.9837455749512,
    "b": 12.7250728607178,
    "C": 21.2220420837402,
    "h": 36.8423881530762,
    "CMY_C": 0.31516170501709,
    "CMY_M": 0.50029838085175,
    "CMY_Y": 0.5443063378334,
    "CMYK_C": 0,
    "CMYK_M": 0.27033632993698,
    "CMYK_Y": 0.33459669351578,
    "CMYK_K": 0.31516170501709
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1403",
    "Farbtonhilfsbezeichnung": "Magma 80",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "154",
    "Bcolor": "144",
    "Y": 37,
    "L": 67.0474090576172,
    "a": 13.5587329864502,
    "b": 10.3722105026245,
    "C": 17.0710868835449,
    "h": 37.4154014587402,
    "CMY_C": 0.23907256126404,
    "CMY_M": 0.39492571353912,
    "CMY_Y": 0.4352433681488,
    "CMYK_C": 0,
    "CMYK_M": 0.20481999218464,
    "CMYK_Y": 0.25780487060547,
    "CMYK_K": 0.23907256126404
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1404",
    "Farbtonhilfsbezeichnung": "Magma 85",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "184",
    "Bcolor": "177",
    "Y": 52,
    "L": 77.0854949951172,
    "a": 9.70469284057617,
    "b": 6.90739679336548,
    "C": 11.9118928909302,
    "h": 35.4416809082031,
    "CMY_C": 0.1626660823822,
    "CMY_M": 0.27831435203552,
    "CMY_Y": 0.30739629268646,
    "CMYK_C": 0,
    "CMYK_M": 0.13811486959457,
    "CMYK_Y": 0.17284646630287,
    "CMYK_K": 0.1626660823822
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1405",
    "Farbtonhilfsbezeichnung": "Magma 90",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "212",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.1309356689453,
    "a": 5.37208890914917,
    "b": 4.57123613357544,
    "C": 7.05376052856445,
    "h": 40.3952369689941,
    "CMY_C": 0.09967178106308,
    "CMY_M": 0.16877120733261,
    "CMY_Y": 0.19431906938553,
    "CMYK_C": 0,
    "CMYK_M": 0.07674915343523,
    "CMYK_Y": 0.10512531548738,
    "CMYK_K": 0.09967178106308
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1406",
    "Farbtonhilfsbezeichnung": "Magma 95",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "72",
    "Bcolor": "59",
    "Y": 12,
    "L": 40.413703918457,
    "a": 32.0233535766602,
    "b": 23.1514625549316,
    "C": 39.5156364440918,
    "h": 35.8652572631836,
    "CMY_C": 0.40896815061569,
    "CMY_M": 0.71748518943787,
    "CMY_Y": 0.77048993110657,
    "CMYK_C": 0,
    "CMYK_M": 0.52199733257294,
    "CMYK_Y": 0.61167901754379,
    "CMYK_K": 0.40896815061569
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1407",
    "Farbtonhilfsbezeichnung": "Magma 100",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "99",
    "Bcolor": "85",
    "Y": 19,
    "L": 49.9470520019531,
    "a": 28.0159549713135,
    "b": 20.3130683898926,
    "C": 34.6051216125488,
    "h": 35.9441223144531,
    "CMY_C": 0.32623207569122,
    "CMY_M": 0.61080551147461,
    "CMY_Y": 0.66664236783981,
    "CMYK_C": 0,
    "CMYK_M": 0.42236122488976,
    "CMYK_Y": 0.50523376464844,
    "CMYK_K": 0.32623207569122
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1408",
    "Farbtonhilfsbezeichnung": "Magma 110",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "156",
    "Bcolor": "145",
    "Y": 40,
    "L": 68.9266510009766,
    "a": 17.8059043884277,
    "b": 12.89182472229,
    "C": 21.9829330444336,
    "h": 35.9052772521973,
    "CMY_C": 0.185975253582,
    "CMY_M": 0.38721770048141,
    "CMY_Y": 0.43296307325363,
    "CMYK_C": 0,
    "CMYK_M": 0.2472190707922,
    "CMYK_Y": 0.30341562628746,
    "CMYK_K": 0.185975253582
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1409",
    "Farbtonhilfsbezeichnung": "Magma 105",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "128",
    "Bcolor": "114",
    "Y": 28,
    "L": 59.5885696411133,
    "a": 22.297306060791,
    "b": 16.7893733978271,
    "C": 27.9115200042725,
    "h": 36.978931427002,
    "CMY_C": 0.25571358203888,
    "CMY_M": 0.49665313959122,
    "CMY_Y": 0.55219751596451,
    "CMYK_C": 0,
    "CMYK_M": 0.32371887564659,
    "CMYK_Y": 0.3983465731144,
    "CMYK_K": 0.25571358203888
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1410",
    "Farbtonhilfsbezeichnung": "Magma 115",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "186",
    "Bcolor": "176",
    "Y": 55,
    "L": 78.6177825927734,
    "a": 12.3849544525147,
    "b": 9.29584980010986,
    "C": 15.4854745864868,
    "h": 36.8910140991211,
    "CMY_C": 0.1211411356926,
    "CMY_M": 0.26934009790421,
    "CMY_Y": 0.30790394544601,
    "CMYK_C": 0,
    "CMYK_M": 0.16862657666206,
    "CMYK_Y": 0.21250602602959,
    "CMYK_K": 0.1211411356926
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1411",
    "Farbtonhilfsbezeichnung": "Magma 120",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "217",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.1537170410156,
    "a": 7.01367425918579,
    "b": 5.68230867385864,
    "C": 9.02664184570313,
    "h": 39.0135536193848,
    "CMY_C": 0.06162244081497,
    "CMY_M": 0.1508726477623,
    "CMY_Y": 0.1802299618721,
    "CMYK_C": 0,
    "CMYK_M": 0.09511119127274,
    "CMYK_Y": 0.12639637291431,
    "CMYK_K": 0.06162244081497
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1412",
    "Farbtonhilfsbezeichnung": "Magma 130",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "106",
    "Bcolor": "87",
    "Y": 22,
    "L": 54.5903053283691,
    "a": 33.3519744873047,
    "b": 25.5472717285156,
    "C": 42.0121078491211,
    "h": 37.4517478942871,
    "CMY_C": 0.23885142803192,
    "CMY_M": 0.58334374427795,
    "CMY_Y": 0.65702348947525,
    "CMYK_C": 0,
    "CMYK_M": 0.45259535312653,
    "CMYK_Y": 0.54939609766006,
    "CMYK_K": 0.23885142803192
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1413",
    "Farbtonhilfsbezeichnung": "Magma 125",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "73",
    "Bcolor": "59",
    "Y": 13,
    "L": 43.2794303894043,
    "a": 38.2832374572754,
    "b": 27.0505504608154,
    "C": 46.8757781982422,
    "h": 35.2446441650391,
    "CMY_C": 0.34252727031708,
    "CMY_M": 0.71435630321503,
    "CMY_Y": 0.76879638433456,
    "CMYK_C": 0,
    "CMYK_M": 0.56554287672043,
    "CMYK_Y": 0.64834493398666,
    "CMYK_K": 0.34252727031708
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1414",
    "Farbtonhilfsbezeichnung": "Magma 135",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "132",
    "Bcolor": "116",
    "Y": 32,
    "L": 62.920768737793,
    "a": 28.1397914886475,
    "b": 20.4050312042236,
    "C": 34.7593612670898,
    "h": 35.9470252990723,
    "CMY_C": 0.17872369289398,
    "CMY_M": 0.48089420795441,
    "CMY_Y": 0.54315114021301,
    "CMYK_C": 0,
    "CMYK_M": 0.36792796850204,
    "CMYK_Y": 0.44373306632042,
    "CMYK_K": 0.17872369289398
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1415",
    "Farbtonhilfsbezeichnung": "Magma 140",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "163",
    "Bcolor": "149",
    "Y": 45,
    "L": 72.5624237060547,
    "a": 21.2818031311035,
    "b": 16.0379390716553,
    "C": 26.6482772827148,
    "h": 37.0016326904297,
    "CMY_C": 0.11699485778809,
    "CMY_M": 0.35947799682617,
    "CMY_Y": 0.4173349738121,
    "CMYK_C": 0,
    "CMYK_M": 0.27461123466492,
    "CMYK_Y": 0.34013405442238,
    "CMYK_K": 0.11699485778809
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1416",
    "Farbtonhilfsbezeichnung": "Magma 145",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "191",
    "Bcolor": "180",
    "Y": 60,
    "L": 81.2625045776367,
    "a": 15.748929977417,
    "b": 11.3322257995606,
    "C": 19.402271270752,
    "h": 35.7371025085449,
    "CMY_C": 0.06368762254715,
    "CMY_M": 0.25023174285889,
    "CMY_Y": 0.29404789209366,
    "CMYK_C": 0,
    "CMYK_M": 0.19923278689384,
    "CMYK_Y": 0.24602928757668,
    "CMYK_K": 0.06368762254715
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1417",
    "Farbtonhilfsbezeichnung": "Magma 150",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "218",
    "Bcolor": "210",
    "Y": 77,
    "L": 89.4111709594727,
    "a": 9.55481910705566,
    "b": 7.33748388290405,
    "C": 12.0471258163452,
    "h": 37.5219345092773,
    "CMY_C": 0.02422302961349,
    "CMY_M": 0.14387011528015,
    "CMY_Y": 0.17832624912262,
    "CMYK_C": 0,
    "CMYK_M": 0.12261724472046,
    "CMYK_Y": 0.15792873501778,
    "CMYK_K": 0.02422302961349
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1418",
    "Farbtonhilfsbezeichnung": "Papaya 5",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "81",
    "Bcolor": "71",
    "Y": 10,
    "L": 36.1340446472168,
    "a": 6.65481519699097,
    "b": 8.73377418518066,
    "C": 10.9802265167236,
    "h": 52.6939277648926,
    "CMY_C": 0.60535162687302,
    "CMY_M": 0.68243861198425,
    "CMY_Y": 0.72272789478302,
    "CMYK_C": 0,
    "CMYK_M": 0.19533081352711,
    "CMYK_Y": 0.29741987586021,
    "CMYK_K": 0.60535162687302
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1419",
    "Farbtonhilfsbezeichnung": "Papaya 10",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "111",
    "Bcolor": "101",
    "Y": 18,
    "L": 48.3850631713867,
    "a": 5.58636903762817,
    "b": 7.73039388656616,
    "C": 9.53763675689697,
    "h": 54.1462440490723,
    "CMY_C": 0.49232369661331,
    "CMY_M": 0.56321156024933,
    "CMY_Y": 0.60284185409546,
    "CMYK_C": 0,
    "CMYK_M": 0.13963201642036,
    "CMYK_Y": 0.21769414842129,
    "CMYK_K": 0.49232369661331
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1420",
    "Farbtonhilfsbezeichnung": "Papaya 15",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "135",
    "Bcolor": "125",
    "Y": 25,
    "L": 57.4331245422363,
    "a": 4.87000560760498,
    "b": 6.76039934158325,
    "C": 8.33186340332031,
    "h": 54.2320594787598,
    "CMY_C": 0.40661245584488,
    "CMY_M": 0.47138923406601,
    "CMY_Y": 0.508416056633,
    "CMYK_C": 0,
    "CMYK_M": 0.10916437208652,
    "CMYK_Y": 0.1715634316206,
    "CMYK_K": 0.40661245584488
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1421",
    "Farbtonhilfsbezeichnung": "Papaya 20",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "157",
    "Bcolor": "148",
    "Y": 36,
    "L": 65.8029937744141,
    "a": 4.75631141662598,
    "b": 6.06274747848511,
    "C": 7.70580339431763,
    "h": 51.8853149414063,
    "CMY_C": 0.32137876749039,
    "CMY_M": 0.38515019416809,
    "CMY_Y": 0.41939204931259,
    "CMYK_C": 0,
    "CMYK_M": 0.09397204965353,
    "CMYK_Y": 0.14443002641201,
    "CMYK_K": 0.32137876749039
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1422",
    "Farbtonhilfsbezeichnung": "Papaya 25",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "181",
    "Bcolor": "173",
    "Y": 48,
    "L": 74.7683410644531,
    "a": 3.87491202354431,
    "b": 5.26631927490234,
    "C": 6.53827667236328,
    "h": 53.6546859741211,
    "CMY_C": 0.23362153768539,
    "CMY_M": 0.28843611478806,
    "CMY_Y": 0.32097899913788,
    "CMYK_C": 0,
    "CMYK_M": 0.07152415812016,
    "CMYK_Y": 0.11398736387491,
    "CMYK_K": 0.23362153768539
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1423",
    "Farbtonhilfsbezeichnung": "Papaya 30",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "207",
    "Bcolor": "198",
    "Y": 63,
    "L": 83.5806274414063,
    "a": 2.66961073875427,
    "b": 4.47970008850098,
    "C": 5.2148380279541,
    "h": 59.2078018188477,
    "CMY_C": 0.14836412668228,
    "CMY_M": 0.19015276432037,
    "CMY_Y": 0.22163736820221,
    "CMYK_C": 0,
    "CMYK_M": 0.04906866699457,
    "CMYK_Y": 0.08603822439909,
    "CMYK_K": 0.14836412668228
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1424",
    "Farbtonhilfsbezeichnung": "Papaya 35",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "94",
    "Bcolor": "71",
    "Y": 14,
    "L": 44.0065460205078,
    "a": 14.9466743469238,
    "b": 19.8536968231201,
    "C": 24.8510036468506,
    "h": 53.0260696411133,
    "CMY_C": 0.46141064167023,
    "CMY_M": 0.63062185049057,
    "CMY_Y": 0.72100281715393,
    "CMYK_C": 0,
    "CMYK_M": 0.31417480111122,
    "CMYK_Y": 0.48198533058167,
    "CMYK_K": 0.46141064167023
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1425",
    "Farbtonhilfsbezeichnung": "Papaya 40",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "120",
    "Bcolor": "99",
    "Y": 22,
    "L": 53.8486289978027,
    "a": 13.0936756134033,
    "b": 17.3622150421143,
    "C": 21.7460536956787,
    "h": 52.9783096313477,
    "CMY_C": 0.37108969688416,
    "CMY_M": 0.52949750423431,
    "CMY_Y": 0.61322927474976,
    "CMYK_C": 0,
    "CMYK_M": 0.25187662243843,
    "CMYK_Y": 0.38501447439194,
    "CMYK_K": 0.37108969688416
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1426",
    "Farbtonhilfsbezeichnung": "Papaya 45",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "141",
    "Bcolor": "123",
    "Y": 30,
    "L": 61.540885925293,
    "a": 11.0621061325073,
    "b": 14.5063962936401,
    "C": 18.2429637908936,
    "h": 52.6720352172852,
    "CMY_C": 0.30598962306976,
    "CMY_M": 0.44628858566284,
    "CMY_Y": 0.51943743228912,
    "CMYK_C": 0,
    "CMYK_M": 0.20215687155724,
    "CMYK_Y": 0.30755707621574,
    "CMYK_K": 0.30598962306976
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1427",
    "Farbtonhilfsbezeichnung": "Papaya 50",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "164",
    "Bcolor": "147",
    "Y": 40,
    "L": 69.4785614013672,
    "a": 8.91639995574951,
    "b": 12.2463226318359,
    "C": 15.148419380188,
    "h": 53.9420890808105,
    "CMY_C": 0.23844516277313,
    "CMY_M": 0.35831183195114,
    "CMY_Y": 0.42430603504181,
    "CMYK_C": 0,
    "CMYK_M": 0.1573972851038,
    "CMYK_Y": 0.24405448138714,
    "CMYK_K": 0.23844516277313
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1428",
    "Farbtonhilfsbezeichnung": "Papaya 55",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "186",
    "Bcolor": "172",
    "Y": 53,
    "L": 77.3931350708008,
    "a": 6.85940217971802,
    "b": 9.79213047027588,
    "C": 11.9556350708008,
    "h": 54.988697052002,
    "CMY_C": 0.17149502038956,
    "CMY_M": 0.26870304346085,
    "CMY_Y": 0.32523047924042,
    "CMYK_C": 0,
    "CMYK_M": 0.11732944101095,
    "CMYK_Y": 0.18555767834187,
    "CMYK_K": 0.17149502038956
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1429",
    "Farbtonhilfsbezeichnung": "Papaya 60",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "199",
    "Y": 67,
    "L": 85.1714172363281,
    "a": 4.66262054443359,
    "b": 6.835045337677,
    "C": 8.27392768859863,
    "h": 55.6996040344238,
    "CMY_C": 0.10896706581116,
    "CMY_M": 0.17818069458008,
    "CMY_Y": 0.22135090827942,
    "CMYK_C": 0,
    "CMYK_M": 0.07767797261477,
    "CMYK_Y": 0.12612760066986,
    "CMYK_K": 0.10896706581116
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1430",
    "Farbtonhilfsbezeichnung": "Papaya 65",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "109",
    "Bcolor": "72",
    "Y": 21,
    "L": 52.8130683898926,
    "a": 23.4256439208984,
    "b": 31.6971416473389,
    "C": 39.4140777587891,
    "h": 53.5338973999023,
    "CMY_C": 0.30505645275116,
    "CMY_M": 0.57067501544952,
    "CMY_Y": 0.71841835975647,
    "CMYK_C": 0,
    "CMYK_M": 0.38221603631973,
    "CMYK_Y": 0.59481364488602,
    "CMYK_K": 0.30505645275116
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1431",
    "Farbtonhilfsbezeichnung": "Papaya 70",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "127",
    "Bcolor": "94",
    "Y": 27,
    "L": 58.815372467041,
    "a": 20.2315921783447,
    "b": 27.2457294464111,
    "C": 33.9359245300293,
    "h": 53.4038925170898,
    "CMY_C": 0.26036304235458,
    "CMY_M": 0.50079703330994,
    "CMY_Y": 0.63188338279724,
    "CMYK_C": 0,
    "CMYK_M": 0.32507029175758,
    "CMYK_Y": 0.50230091810226,
    "CMYK_K": 0.26036304235458
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1432",
    "Farbtonhilfsbezeichnung": "Papaya 75",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "150",
    "Bcolor": "119",
    "Y": 36,
    "L": 66.5641860961914,
    "a": 16.1781024932861,
    "b": 23.7610607147217,
    "C": 28.7457656860352,
    "h": 55.750373840332,
    "CMY_C": 0.20220392942429,
    "CMY_M": 0.40985542535782,
    "CMY_Y": 0.53311514854431,
    "CMYK_C": 0,
    "CMYK_M": 0.26028141379356,
    "CMYK_Y": 0.41478171944618,
    "CMYK_K": 0.20220392942429
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1433",
    "Farbtonhilfsbezeichnung": "Papaya 80",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "172",
    "Bcolor": "147",
    "Y": 46,
    "L": 73.7896270751953,
    "a": 13.370267868042,
    "b": 18.2167053222656,
    "C": 22.5967350006104,
    "h": 53.7229537963867,
    "CMY_C": 0.14872980117798,
    "CMY_M": 0.32559412717819,
    "CMY_Y": 0.42168068885803,
    "CMYK_C": 0,
    "CMYK_M": 0.2077652066946,
    "CMYK_Y": 0.32063955068588,
    "CMYK_K": 0.14872980117798
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1434",
    "Farbtonhilfsbezeichnung": "Papaya 85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "191",
    "Bcolor": "172",
    "Y": 57,
    "L": 80.0261840820313,
    "a": 9.93538379669189,
    "b": 13.9643182754517,
    "C": 17.1380882263184,
    "h": 54.5687713623047,
    "CMY_C": 0.11067360639572,
    "CMY_M": 0.24908792972565,
    "CMY_Y": 0.3270770907402,
    "CMYK_C": 0,
    "CMYK_M": 0.15563951432705,
    "CMYK_Y": 0.24333415925503,
    "CMYK_K": 0.11067360639572
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1435",
    "Farbtonhilfsbezeichnung": "Papaya 90",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "214",
    "Bcolor": "201",
    "Y": 71,
    "L": 87.3290786743164,
    "a": 6.27797365188599,
    "b": 8.60162448883057,
    "C": 10.6489858627319,
    "h": 53.8758239746094,
    "CMY_C": 0.06798493862152,
    "CMY_M": 0.15891849994659,
    "CMY_Y": 0.21073567867279,
    "CMYK_C": 0,
    "CMYK_M": 0.09756661951542,
    "CMYK_Y": 0.15316355228424,
    "CMYK_K": 0.06798493862152
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1436",
    "Farbtonhilfsbezeichnung": "Papaya 95",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "117",
    "Bcolor": "65",
    "Y": 27,
    "L": 58.8945808410645,
    "a": 32.4252815246582,
    "b": 43.5324745178223,
    "C": 54.2814445495605,
    "h": 53.3193168640137,
    "CMY_C": 0.17544049024582,
    "CMY_M": 0.53999543190002,
    "CMY_Y": 0.74488246440887,
    "CMYK_C": 0,
    "CMYK_M": 0.44212085008621,
    "CMYK_Y": 0.6906014084816,
    "CMYK_K": 0.17544049024582
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1437",
    "Farbtonhilfsbezeichnung": "Papaya 100",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "137",
    "Bcolor": "91",
    "Y": 34,
    "L": 65.0387802124023,
    "a": 27.6856193542481,
    "b": 37.2228965759277,
    "C": 46.3900604248047,
    "h": 53.3588943481445,
    "CMY_C": 0.13453334569931,
    "CMY_M": 0.46110862493515,
    "CMY_Y": 0.64127898216248,
    "CMYK_C": 0,
    "CMYK_M": 0.3773401081562,
    "CMYK_Y": 0.58551722764969,
    "CMYK_K": 0.13453334569931
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1438",
    "Farbtonhilfsbezeichnung": "Papaya 105",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "155",
    "Bcolor": "115",
    "Y": 42,
    "L": 70.4142837524414,
    "a": 22.9997463226318,
    "b": 31.5170631408691,
    "C": 39.0168380737305,
    "h": 53.8796997070313,
    "CMY_C": 0.10558998584747,
    "CMY_M": 0.39033180475235,
    "CMY_Y": 0.54878652095795,
    "CMYK_C": 0,
    "CMYK_M": 0.31835713982582,
    "CMYK_Y": 0.49551829695702,
    "CMYK_K": 0.10558998584747
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1439",
    "Farbtonhilfsbezeichnung": "Papaya 110",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "175",
    "Bcolor": "142",
    "Y": 51,
    "L": 76.1744155883789,
    "a": 17.9353008270264,
    "b": 24.6842098236084,
    "C": 30.5120506286621,
    "h": 53.998218536377,
    "CMY_C": 0.08037209510803,
    "CMY_M": 0.31392180919647,
    "CMY_Y": 0.44281500577927,
    "CMYK_C": 0,
    "CMYK_M": 0.25396108627319,
    "CMYK_Y": 0.39411908388138,
    "CMYK_K": 0.08037209510803
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1440",
    "Farbtonhilfsbezeichnung": "Papaya 115",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "197",
    "Bcolor": "172",
    "Y": 61,
    "L": 82.7734909057617,
    "a": 13.2549753189087,
    "b": 18.0753974914551,
    "C": 22.4146022796631,
    "h": 53.7468147277832,
    "CMY_C": 0.04781419038773,
    "CMY_M": 0.22893971204758,
    "CMY_Y": 0.32744783163071,
    "CMYK_C": 0,
    "CMYK_M": 0.19022077322006,
    "CMYK_Y": 0.29367551207542,
    "CMYK_K": 0.04781419038773
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1441",
    "Farbtonhilfsbezeichnung": "Papaya 120",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "217",
    "Bcolor": "199",
    "Y": 73,
    "L": 88.6185607910156,
    "a": 8.43267250061035,
    "b": 11.7169961929321,
    "C": 14.4359951019287,
    "h": 54.2575950622559,
    "CMY_C": 0.02949804067612,
    "CMY_M": 0.15093165636063,
    "CMY_Y": 0.21937787532806,
    "CMYK_C": 0,
    "CMYK_M": 0.12512454390526,
    "CMYK_Y": 0.19565115869045,
    "CMYK_K": 0.02949804067612
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1442",
    "Farbtonhilfsbezeichnung": "Papaya 125",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "124",
    "Bcolor": "55",
    "Y": 34,
    "L": 64.612419128418,
    "a": 41.3014984130859,
    "b": 55.826416015625,
    "C": 69.4435195922852,
    "h": 53.5052223205566,
    "CMY_C": 0.05004376173019,
    "CMY_M": 0.5144430398941,
    "CMY_Y": 0.78522276878357,
    "CMYK_C": 0,
    "CMYK_M": 0.48886385560036,
    "CMYK_Y": 0.77390831708908,
    "CMYK_K": 0.05004376173019
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1444",
    "Farbtonhilfsbezeichnung": "Papaya 130",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "146",
    "Bcolor": "87",
    "Y": 41,
    "L": 70.7807312011719,
    "a": 35.7260093688965,
    "b": 47.3316192626953,
    "C": 59.3011779785156,
    "h": 52.9544143676758,
    "CMY_C": 0.01056241989136,
    "CMY_M": 0.42907857894897,
    "CMY_Y": 0.65866422653198,
    "CMYK_C": 0,
    "CMYK_M": 0.4229838848114,
    "CMYK_Y": 0.65502041578293,
    "CMYK_K": 0.01056241989136
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1445",
    "Farbtonhilfsbezeichnung": "Papaya 135",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "164",
    "Bcolor": "114",
    "Y": 49,
    "L": 75.4332809448242,
    "a": 29.3639144897461,
    "b": 39.255558013916,
    "C": 49.022834777832,
    "h": 53.2028007507324,
    "CMY_C": 0,
    "CMY_M": 0.35803401470184,
    "CMY_Y": 0.55398595333099,
    "CMYK_C": 0,
    "CMYK_M": 0.35803401470184,
    "CMYK_Y": 0.55398595333099,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1446",
    "Farbtonhilfsbezeichnung": "Papaya 140",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "141",
    "Y": 57,
    "L": 79.7267608642578,
    "a": 22.6099472045898,
    "b": 30.5070743560791,
    "C": 37.9722442626953,
    "h": 53.4564552307129,
    "CMY_C": 0.00017124414444,
    "CMY_M": 0.29033595323563,
    "CMY_Y": 0.44792604446411,
    "CMYK_C": 0,
    "CMYK_M": 0.29021441936493,
    "CMYK_Y": 0.44783148169518,
    "CMYK_K": 0.00017124414444
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1447",
    "Farbtonhilfsbezeichnung": "Papaya 145",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "171",
    "Y": 67,
    "L": 85.5398559570313,
    "a": 16.2257823944092,
    "b": 22.1863117218018,
    "C": 27.4865131378174,
    "h": 53.820426940918,
    "CMY_C": 0,
    "CMY_M": 0.20774525403976,
    "CMY_Y": 0.32789051532745,
    "CMYK_C": 0,
    "CMYK_M": 0.20774525403976,
    "CMYK_Y": 0.32789051532745,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1448",
    "Farbtonhilfsbezeichnung": "Papaya 150",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "199",
    "Y": 77,
    "L": 89.9540176391602,
    "a": 9.96721076965332,
    "b": 13.5756721496582,
    "C": 16.841739654541,
    "h": 53.7140159606934,
    "CMY_C": 0,
    "CMY_M": 0.14058089256287,
    "CMY_Y": 0.2184277176857,
    "CMYK_C": 0,
    "CMYK_M": 0.14058089256287,
    "CMYK_Y": 0.2184277176857,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1449",
    "Farbtonhilfsbezeichnung": "Marill 5",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "92",
    "Bcolor": "74",
    "Y": 11,
    "L": 40.0507774353027,
    "a": 3.60039901733398,
    "b": 12.1388092041016,
    "C": 12.6614990234375,
    "h": 73.4795227050781,
    "CMY_C": 0.57831245660782,
    "CMY_M": 0.63983464241028,
    "CMY_Y": 0.70922166109085,
    "CMYK_C": 0,
    "CMYK_M": 0.14589519798756,
    "CMYK_Y": 0.31044125556946,
    "CMYK_K": 0.57831245660782
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1450",
    "Farbtonhilfsbezeichnung": "Marill 10",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "114",
    "Bcolor": "98",
    "Y": 18,
    "L": 49.0087242126465,
    "a": 2.95393657684326,
    "b": 10.4440507888794,
    "C": 10.8537521362305,
    "h": 74.207275390625,
    "CMY_C": 0.49651247262955,
    "CMY_M": 0.55184602737427,
    "CMY_Y": 0.61506778001785,
    "CMYK_C": 0,
    "CMYK_M": 0.10990054905415,
    "CMYK_Y": 0.23546820878983,
    "CMYK_K": 0.49651247262955
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1451",
    "Farbtonhilfsbezeichnung": "Marill 15",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "139",
    "Bcolor": "124",
    "Y": 27,
    "L": 58.4831085205078,
    "a": 2.42059850692749,
    "b": 8.80557823181152,
    "C": 9.13222312927246,
    "h": 74.6294097900391,
    "CMY_C": 0.4069384932518,
    "CMY_M": 0.45568460226059,
    "CMY_Y": 0.51219844818115,
    "CMYK_C": 0,
    "CMYK_M": 0.0821940228343,
    "CMYK_Y": 0.17748573422432,
    "CMYK_K": 0.4069384932518
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1452",
    "Farbtonhilfsbezeichnung": "Marill 25",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "185",
    "Bcolor": "174",
    "Y": 49,
    "L": 75.4718856811523,
    "a": 1.61346936225891,
    "b": 5.67035961151123,
    "C": 5.8954439163208,
    "h": 74.1165924072266,
    "CMY_C": 0.24121963977814,
    "CMY_M": 0.2757214307785,
    "CMY_Y": 0.3167781829834,
    "CMYK_C": 0,
    "CMYK_M": 0.04547006264329,
    "CMYK_Y": 0.09957893937826,
    "CMYK_K": 0.24121963977814
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1453",
    "Farbtonhilfsbezeichnung": "Marill 20",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "162",
    "Bcolor": "150",
    "Y": 37,
    "L": 67.260009765625,
    "a": 1.9523913860321,
    "b": 6.98263740539551,
    "C": 7.25045204162598,
    "h": 74.3786544799805,
    "CMY_C": 0.32295721769333,
    "CMY_M": 0.36372262239456,
    "CMY_Y": 0.41127878427505,
    "CMYK_C": 0,
    "CMYK_M": 0.06021097302437,
    "CMYK_Y": 0.13045197725296,
    "CMYK_K": 0.32295721769333
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1454",
    "Farbtonhilfsbezeichnung": "Marill 30",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "211",
    "Bcolor": "201",
    "Y": 66,
    "L": 84.854118347168,
    "a": 1.3596259355545,
    "b": 5.15792417526245,
    "C": 5.33411312103271,
    "h": 75.232780456543,
    "CMY_C": 0.14205604791641,
    "CMY_M": 0.17327135801315,
    "CMY_Y": 0.2130206823349,
    "CMYK_C": 0,
    "CMYK_M": 0.03638385608792,
    "CMYK_Y": 0.08271476626396,
    "CMYK_K": 0.14205604791641
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1455",
    "Farbtonhilfsbezeichnung": "Marill 35",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "111",
    "Bcolor": "77",
    "Y": 17,
    "L": 48.8182601928711,
    "a": 7.17299509048462,
    "b": 22.7568550109863,
    "C": 23.860559463501,
    "h": 72.5050659179688,
    "CMY_C": 0.45019960403442,
    "CMY_M": 0.56561028957367,
    "CMY_Y": 0.69787919521332,
    "CMYK_C": 0,
    "CMYK_M": 0.20991379022598,
    "CMYK_Y": 0.45049002766609,
    "CMYK_K": 0.45019960403442
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1456",
    "Farbtonhilfsbezeichnung": "Marill 40",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "128",
    "Bcolor": "97",
    "Y": 23,
    "L": 55.2316589355469,
    "a": 5.98033952713013,
    "b": 20.3447418212891,
    "C": 21.205493927002,
    "h": 73.6192932128906,
    "CMY_C": 0.39372497797012,
    "CMY_M": 0.49901837110519,
    "CMY_Y": 0.62155944108963,
    "CMYK_C": 0,
    "CMYK_M": 0.17367266118526,
    "CMYK_Y": 0.37579390406609,
    "CMYK_K": 0.39372497797012
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1457",
    "Farbtonhilfsbezeichnung": "Marill 45",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "148",
    "Bcolor": "119",
    "Y": 32,
    "L": 62.9848556518555,
    "a": 5.42645835876465,
    "b": 18.1741752624512,
    "C": 18.9670009613037,
    "h": 73.3753890991211,
    "CMY_C": 0.31865441799164,
    "CMY_M": 0.41863518953323,
    "CMY_Y": 0.53146779537201,
    "CMYK_C": 0,
    "CMYK_M": 0.14674018323421,
    "CMYK_Y": 0.3123427927494,
    "CMYK_K": 0.31865441799164
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1458",
    "Farbtonhilfsbezeichnung": "Marill 50",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 42,
    "L": 70.0813751220703,
    "a": 4.35642576217651,
    "b": 15.2689294815063,
    "C": 15.8782444000244,
    "h": 74.0758590698242,
    "CMY_C": 0.25532341003418,
    "CMY_M": 0.34167748689651,
    "CMY_Y": 0.44018530845642,
    "CMYK_C": 0,
    "CMYK_M": 0.11596184968948,
    "CMYK_Y": 0.24824453890324,
    "CMYK_K": 0.25532341003418
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1459",
    "Farbtonhilfsbezeichnung": "Marill 55",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "189",
    "Bcolor": "169",
    "Y": 52,
    "L": 77.6705703735352,
    "a": 3.69486379623413,
    "b": 11.9078216552734,
    "C": 12.467887878418,
    "h": 72.7614669799805,
    "CMY_C": 0.18514138460159,
    "CMY_M": 0.25859642028809,
    "CMY_Y": 0.33799678087234,
    "CMYK_C": 0,
    "CMYK_M": 0.09014451503754,
    "CMYK_Y": 0.18758517503738,
    "CMYK_K": 0.18514138460159
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1460",
    "Farbtonhilfsbezeichnung": "Marill 60",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "214",
    "Bcolor": "198",
    "Y": 69,
    "L": 86.3434906005859,
    "a": 2.03117203712463,
    "b": 8.65922737121582,
    "C": 8.89426136016846,
    "h": 76.798942565918,
    "CMY_C": 0.11004430055618,
    "CMY_M": 0.15942668914795,
    "CMY_Y": 0.22245669364929,
    "CMYK_C": 0,
    "CMYK_M": 0.05548859015107,
    "CMYK_Y": 0.12631234526634,
    "CMYK_K": 0.11004430055618
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1461",
    "Farbtonhilfsbezeichnung": "Marill 65",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "133",
    "Bcolor": "72",
    "Y": 27,
    "L": 58.7118339538574,
    "a": 11.3596696853638,
    "b": 38.7618103027344,
    "C": 40.3920783996582,
    "h": 73.6660690307617,
    "CMY_C": 0.29767274856567,
    "CMY_M": 0.48012697696686,
    "CMY_Y": 0.7179034948349,
    "CMYK_C": 0,
    "CMYK_M": 0.25978520512581,
    "CMYK_Y": 0.59834039211273,
    "CMYK_K": 0.29767274856567
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1462",
    "Farbtonhilfsbezeichnung": "Marill 70",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "149",
    "Bcolor": "94",
    "Y": 34,
    "L": 64.6249694824219,
    "a": 9.47854423522949,
    "b": 34.466968536377,
    "C": 35.7465362548828,
    "h": 74.6235504150391,
    "CMY_C": 0.2478951215744,
    "CMY_M": 0.4145622253418,
    "CMY_Y": 0.6301497220993,
    "CMYK_C": 0,
    "CMYK_M": 0.22160087525845,
    "CMYK_Y": 0.50824642181396,
    "CMYK_K": 0.2478951215744
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1463",
    "Farbtonhilfsbezeichnung": "Marill 75",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "164",
    "Bcolor": "119",
    "Y": 41,
    "L": 70.0573196411133,
    "a": 8.8463077545166,
    "b": 28.5632362365723,
    "C": 29.9017658233643,
    "h": 72.7917404174805,
    "CMY_C": 0.20004683732986,
    "CMY_M": 0.35554820299149,
    "CMY_Y": 0.53426790237427,
    "CMYK_C": 0,
    "CMYK_M": 0.19438809156418,
    "CMYK_Y": 0.41780078411102,
    "CMYK_K": 0.20004683732986
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1464",
    "Farbtonhilfsbezeichnung": "Marill 80",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "181",
    "Bcolor": "141",
    "Y": 50,
    "L": 75.8552932739258,
    "a": 7.66187000274658,
    "b": 24.5113315582275,
    "C": 25.6809196472168,
    "h": 72.6415481567383,
    "CMY_C": 0.1499490737915,
    "CMY_M": 0.29051446914673,
    "CMY_Y": 0.44688296318054,
    "CMYK_C": 0,
    "CMYK_M": 0.16536115109921,
    "CMYK_Y": 0.3493130505085,
    "CMYK_K": 0.1499490737915
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1465",
    "Farbtonhilfsbezeichnung": "Marill 85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "198",
    "Bcolor": "165",
    "Y": 59,
    "L": 81.430419921875,
    "a": 5.58359432220459,
    "b": 19.5308818817139,
    "C": 20.3133430480957,
    "h": 74.045539855957,
    "CMY_C": 0.11169654130936,
    "CMY_M": 0.2243555188179,
    "CMY_Y": 0.35352110862732,
    "CMYK_C": 0,
    "CMYK_M": 0.1268248707056,
    "CMYK_Y": 0.27223193645477,
    "CMYK_K": 0.11169654130936
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1466",
    "Farbtonhilfsbezeichnung": "Marill 90",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "219",
    "Bcolor": "198",
    "Y": 73,
    "L": 88.2129592895508,
    "a": 3.12091279029846,
    "b": 11.7640333175659,
    "C": 12.1709728240967,
    "h": 75.1420974731445,
    "CMY_C": 0.07230651378632,
    "CMY_M": 0.14223331212997,
    "CMY_Y": 0.22495752573013,
    "CMYK_C": 0,
    "CMYK_M": 0.07537704706192,
    "CMYK_Y": 0.1645489782095,
    "CMYK_K": 0.07230651378632
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1467",
    "Farbtonhilfsbezeichnung": "Marill 95",
    "Farbtonklasse": "04",
    "Rcolor": "222",
    "Gcolor": "157",
    "Bcolor": "65",
    "Y": 40,
    "L": 69.5437088012695,
    "a": 15.9771232604981,
    "b": 55.2896385192871,
    "C": 57.5518264770508,
    "h": 73.8822174072266,
    "CMY_C": 0.12939196825027,
    "CMY_M": 0.38342559337616,
    "CMY_Y": 0.74388325214386,
    "CMYK_C": 0,
    "CMYK_M": 0.29178875684738,
    "CMYK_Y": 0.7058185338974,
    "CMYK_K": 0.12939196825027
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1468",
    "Farbtonhilfsbezeichnung": "Marill 100",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "169",
    "Bcolor": "90",
    "Y": 46,
    "L": 73.367805480957,
    "a": 14.1423635482788,
    "b": 47.9918098449707,
    "C": 50.0321922302246,
    "h": 73.5806579589844,
    "CMY_C": 0.10241037607193,
    "CMY_M": 0.33756273984909,
    "CMY_Y": 0.6459419131279,
    "CMYK_C": 0,
    "CMYK_M": 0.2619820535183,
    "CMYK_Y": 0.60554569959641,
    "CMYK_K": 0.10241037607193
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1469",
    "Farbtonhilfsbezeichnung": "Marill 105",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "185",
    "Bcolor": "116",
    "Y": 54,
    "L": 78.4867935180664,
    "a": 11.7676467895508,
    "b": 41.2619857788086,
    "C": 42.9072151184082,
    "h": 74.0821990966797,
    "CMY_C": 0.06549090147018,
    "CMY_M": 0.27594029903412,
    "CMY_Y": 0.54339736700058,
    "CMYK_C": 0,
    "CMYK_M": 0.22519780695438,
    "CMYK_Y": 0.51139843463898,
    "CMYK_K": 0.06549090147018
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1470",
    "Farbtonhilfsbezeichnung": "Marill 115",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "206",
    "Bcolor": "161",
    "Y": 66,
    "L": 84.8703536987305,
    "a": 7.54063892364502,
    "b": 26.5521392822266,
    "C": 27.6021251678467,
    "h": 74.1457901000977,
    "CMY_C": 0.04418849945068,
    "CMY_M": 0.19332003593445,
    "CMY_Y": 0.36885464191437,
    "CMYK_C": 0,
    "CMYK_M": 0.1560260951519,
    "CMYK_Y": 0.33967590332031,
    "CMYK_K": 0.04418849945068
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1471",
    "Farbtonhilfsbezeichnung": "Marill 110",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "194",
    "Bcolor": "137",
    "Y": 59,
    "L": 81.3364410400391,
    "a": 9.44412803649902,
    "b": 34.4832954406738,
    "C": 35.7531700134277,
    "h": 74.6836624145508,
    "CMY_C": 0.05763202905655,
    "CMY_M": 0.23811411857605,
    "CMY_Y": 0.46396201848984,
    "CMYK_C": 0,
    "CMYK_M": 0.19151976704597,
    "CMYK_Y": 0.4311797618866,
    "CMYK_K": 0.05763202905655
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1472",
    "Farbtonhilfsbezeichnung": "Marill 120",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "223",
    "Bcolor": "194",
    "Y": 77,
    "L": 90.3331604003906,
    "a": 4.91750764846802,
    "b": 16.8233890533447,
    "C": 17.5273590087891,
    "h": 73.7062606811523,
    "CMY_C": 0.02195757627487,
    "CMY_M": 0.12442380189896,
    "CMY_Y": 0.23927599191666,
    "CMYK_C": 0,
    "CMYK_M": 0.10476664453745,
    "CMYK_Y": 0.22219732403755,
    "CMYK_K": 0.02195757627487
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1473",
    "Farbtonhilfsbezeichnung": "Marill 125",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "180",
    "Bcolor": "57",
    "Y": 57,
    "L": 79.7430191040039,
    "a": 21.5364990234375,
    "b": 70.0339279174805,
    "C": 73.2705383300781,
    "h": 72.9065399169922,
    "CMY_C": 0,
    "CMY_M": 0.29314339160919,
    "CMY_Y": 0.7745521068573,
    "CMYK_C": 0,
    "CMYK_M": 0.29314339160919,
    "CMYK_Y": 0.7745521068573,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1474",
    "Farbtonhilfsbezeichnung": "Marill 130",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "189",
    "Bcolor": "86",
    "Y": 60,
    "L": 82.0814971923828,
    "a": 19.0982875823975,
    "b": 61.0132369995117,
    "C": 63.9324607849121,
    "h": 72.618896484375,
    "CMY_C": 0,
    "CMY_M": 0.26010036468506,
    "CMY_Y": 0.66427665948868,
    "CMYK_C": 0,
    "CMYK_M": 0.26010036468506,
    "CMYK_Y": 0.66427665948868,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1475",
    "Farbtonhilfsbezeichnung": "Marill 135",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "197",
    "Bcolor": "109",
    "Y": 64,
    "L": 84.0271224975586,
    "a": 15.7150278091431,
    "b": 52.1552505493164,
    "C": 54.4713897705078,
    "h": 73.2317962646484,
    "CMY_C": 0,
    "CMY_M": 0.22850668430328,
    "CMY_Y": 0.57145190238953,
    "CMYK_C": 0,
    "CMYK_M": 0.22850668430328,
    "CMYK_Y": 0.57145190238953,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1476",
    "Farbtonhilfsbezeichnung": "Marill 140",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "137",
    "Y": 68,
    "L": 86.4142761230469,
    "a": 12.0607376098633,
    "b": 41.0339126586914,
    "C": 42.7696533203125,
    "h": 73.6208190917969,
    "CMY_C": 0,
    "CMY_M": 0.19091856479645,
    "CMY_Y": 0.46087688207626,
    "CMYK_C": 0,
    "CMYK_M": 0.19091856479645,
    "CMYK_Y": 0.46087688207626,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1477",
    "Farbtonhilfsbezeichnung": "Marill 145",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "157",
    "Y": 73,
    "L": 88.268440246582,
    "a": 9.24360275268555,
    "b": 33.4890174865723,
    "C": 34.7413063049316,
    "h": 74.5694885253906,
    "CMY_C": 0,
    "CMY_M": 0.16183120012283,
    "CMY_Y": 0.3849304318428,
    "CMYK_C": 0,
    "CMYK_M": 0.16183120012283,
    "CMYK_Y": 0.3849304318428,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1478",
    "Farbtonhilfsbezeichnung": "Marill 150",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "223",
    "Bcolor": "183",
    "Y": 79,
    "L": 90.5072479248047,
    "a": 6.19185209274292,
    "b": 22.9981193542481,
    "C": 23.8170642852783,
    "h": 74.931396484375,
    "CMY_C": 0,
    "CMY_M": 0.12712198495865,
    "CMY_Y": 0.28318810462952,
    "CMYK_C": 0,
    "CMYK_M": 0.12712198495865,
    "CMYK_Y": 0.28318810462952,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1479",
    "Farbtonhilfsbezeichnung": "Curcuma 5",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "98",
    "Bcolor": "69",
    "Y": 13,
    "L": 42.7678451538086,
    "a": 3.42020916938782,
    "b": 19.1475028991699,
    "C": 19.4505710601807,
    "h": 79.8723983764648,
    "CMY_C": 0.53993821144104,
    "CMY_M": 0.61492484807968,
    "CMY_Y": 0.72989666461945,
    "CMYK_C": 0,
    "CMYK_M": 0.16299253702164,
    "CMYK_Y": 0.4128977060318,
    "CMYK_K": 0.53993821144104
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1480",
    "Farbtonhilfsbezeichnung": "Curcuma 10",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "118",
    "Bcolor": "91",
    "Y": 19,
    "L": 50.7041397094727,
    "a": 2.53021931648254,
    "b": 16.9345149993896,
    "C": 17.1224937438965,
    "h": 81.5021896362305,
    "CMY_C": 0.46846932172775,
    "CMY_M": 0.53554785251617,
    "CMY_Y": 0.64209240674973,
    "CMYK_C": 0,
    "CMYK_M": 0.12619879841805,
    "CMYK_Y": 0.32664734125137,
    "CMYK_K": 0.46846932172775
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1481",
    "Farbtonhilfsbezeichnung": "Curcuma 15",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "142",
    "Bcolor": "119",
    "Y": 28,
    "L": 59.8677101135254,
    "a": 2.05232191085815,
    "b": 13.6762104034424,
    "C": 13.8293437957764,
    "h": 81.4655838012695,
    "CMY_C": 0.38334965705872,
    "CMY_M": 0.44185245037079,
    "CMY_Y": 0.53176313638687,
    "CMYK_C": 0,
    "CMYK_M": 0.09487190842628,
    "CMYK_Y": 0.24067687988281,
    "CMYK_K": 0.38334965705872
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1482",
    "Farbtonhilfsbezeichnung": "Curcuma 20",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "165",
    "Bcolor": "147",
    "Y": 39,
    "L": 68.4474639892578,
    "a": 1.57039248943329,
    "b": 10.6187992095947,
    "C": 10.7342920303345,
    "h": 81.5876235961914,
    "CMY_C": 0.30332458019257,
    "CMY_M": 0.35129606723785,
    "CMY_Y": 0.42458546161652,
    "CMYK_C": 0,
    "CMYK_M": 0.06885772943497,
    "CMYK_Y": 0.17405650019646,
    "CMYK_K": 0.30332458019257
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1483",
    "Farbtonhilfsbezeichnung": "Curcuma 25",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "190",
    "Bcolor": "175",
    "Y": 53,
    "L": 77.4080276489258,
    "a": 1.32049250602722,
    "b": 8.16898250579834,
    "C": 8.27502155303955,
    "h": 80.8177261352539,
    "CMY_C": 0.21514523029327,
    "CMY_M": 0.25489687919617,
    "CMY_Y": 0.31428736448288,
    "CMYK_C": 0,
    "CMYK_M": 0.05064841359854,
    "CMYK_Y": 0.1263190805912,
    "CMYK_K": 0.21514523029327
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1484",
    "Farbtonhilfsbezeichnung": "Curcuma 30",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "216",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.5104675292969,
    "a": 0.31270068883896,
    "b": 5.32982873916626,
    "C": 5.33899402618408,
    "h": 86.6423110961914,
    "CMY_C": 0.13113671541214,
    "CMY_M": 0.1526243686676,
    "CMY_Y": 0.19649511575699,
    "CMYK_C": 0,
    "CMYK_M": 0.02473076432943,
    "CMYK_Y": 0.07522287964821,
    "CMYK_K": 0.13113671541214
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1485",
    "Farbtonhilfsbezeichnung": "Curcuma 35",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "122",
    "Bcolor": "56",
    "Y": 21,
    "L": 53.0668678283691,
    "a": 5.29376602172852,
    "b": 39.6237487792969,
    "C": 39.9758110046387,
    "h": 82.3902969360352,
    "CMY_C": 0.39389646053314,
    "CMY_M": 0.52193248271942,
    "CMY_Y": 0.77961838245392,
    "CMYK_C": 0,
    "CMYK_M": 0.21124447882175,
    "CMYK_Y": 0.63639611005783,
    "CMYK_K": 0.39389646053314
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1486",
    "Farbtonhilfsbezeichnung": "Curcuma 40",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "140",
    "Bcolor": "84",
    "Y": 28,
    "L": 60.0062980651855,
    "a": 4.77944993972778,
    "b": 33.8150596618652,
    "C": 34.1511535644531,
    "h": 81.9550552368164,
    "CMY_C": 0.3282710313797,
    "CMY_M": 0.4503590464592,
    "CMY_Y": 0.67096334695816,
    "CMYK_C": 0,
    "CMYK_M": 0.18175189197063,
    "CMYK_Y": 0.51016455888748,
    "CMYK_K": 0.3282710313797
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1487",
    "Farbtonhilfsbezeichnung": "Curcuma 45",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "159",
    "Bcolor": "111",
    "Y": 37,
    "L": 66.6970672607422,
    "a": 3.84485387802124,
    "b": 27.7756385803223,
    "C": 28.0404891967773,
    "h": 82.118896484375,
    "CMY_C": 0.27028793096542,
    "CMY_M": 0.37839907407761,
    "CMY_Y": 0.56289047002792,
    "CMYK_C": 0,
    "CMYK_M": 0.14815589785576,
    "CMYK_Y": 0.4009835422039,
    "CMYK_K": 0.27028793096542
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1488",
    "Farbtonhilfsbezeichnung": "Curcuma 50",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "178",
    "Bcolor": "140",
    "Y": 47,
    "L": 73.7981414794922,
    "a": 3.2983021736145,
    "b": 21.9111843109131,
    "C": 22.1580410003662,
    "h": 81.4395065307617,
    "CMY_C": 0.20706272125244,
    "CMY_M": 0.3013129234314,
    "CMY_Y": 0.44989037513733,
    "CMYK_C": 0,
    "CMYK_M": 0.11886211484671,
    "CMYK_Y": 0.30623817443848,
    "CMYK_K": 0.20706272125244
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1489",
    "Farbtonhilfsbezeichnung": "Curcuma 55",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "200",
    "Bcolor": "174",
    "Y": 59,
    "L": 81.4085235595703,
    "a": 1.90124940872192,
    "b": 14.2976417541504,
    "C": 14.4234981536865,
    "h": 82.4254531860352,
    "CMY_C": 0.15041548013687,
    "CMY_M": 0.21450024843216,
    "CMY_Y": 0.3162733912468,
    "CMYK_C": 0,
    "CMYK_M": 0.07543071359396,
    "CMYK_Y": 0.1952223777771,
    "CMYK_K": 0.15041548013687
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1490",
    "Farbtonhilfsbezeichnung": "Curcuma 60",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "219",
    "Bcolor": "202",
    "Y": 72,
    "L": 87.9412002563477,
    "a": 1.1319864988327,
    "b": 8.89156723022461,
    "C": 8.96333408355713,
    "h": 82.7446975708008,
    "CMY_C": 0.09824532270432,
    "CMY_M": 0.13971281051636,
    "CMY_Y": 0.2070364356041,
    "CMYK_C": 0,
    "CMYK_M": 0.04598532989621,
    "CMYK_Y": 0.12064380198717,
    "CMYK_K": 0.09824532270432
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1491",
    "Farbtonhilfsbezeichnung": "Curcuma 65",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "158",
    "Bcolor": "42",
    "Y": 38,
    "L": 68.6757659912109,
    "a": 10.7722063064575,
    "b": 63.4487075805664,
    "C": 64.3566513061523,
    "h": 80.3643035888672,
    "CMY_C": 0.16297167539597,
    "CMY_M": 0.37962102890015,
    "CMY_Y": 0.83668613433838,
    "CMYK_C": 0,
    "CMYK_M": 0.25883156061172,
    "CMYK_Y": 0.80488848686218,
    "CMYK_K": 0.16297167539597
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1492",
    "Farbtonhilfsbezeichnung": "Curcuma 70",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "169",
    "Bcolor": "76",
    "Y": 44,
    "L": 72.1093978881836,
    "a": 8.12431716918945,
    "b": 53.0760726928711,
    "C": 53.694263458252,
    "h": 81.2973251342773,
    "CMY_C": 0.14760476350784,
    "CMY_M": 0.33598810434341,
    "CMY_Y": 0.70221364498138,
    "CMYK_C": 0,
    "CMYK_M": 0.22100467979908,
    "CMYK_Y": 0.65064758062363,
    "CMYK_K": 0.14760476350784
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1493",
    "Farbtonhilfsbezeichnung": "Curcuma 75",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "183",
    "Bcolor": "107",
    "Y": 51,
    "L": 76.7801284790039,
    "a": 6.87681198120117,
    "b": 43.5106315612793,
    "C": 44.0507164001465,
    "h": 81.0187454223633,
    "CMY_C": 0.11274820566177,
    "CMY_M": 0.28211319446564,
    "CMY_Y": 0.57912600040436,
    "CMYK_C": 0,
    "CMYK_M": 0.19088716804981,
    "CMYK_Y": 0.52564311027527,
    "CMYK_K": 0.11274820566177
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1494",
    "Farbtonhilfsbezeichnung": "Curcuma 80",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "196",
    "Bcolor": "136",
    "Y": 58,
    "L": 80.8969497680664,
    "a": 4.97018241882324,
    "b": 33.9755058288574,
    "C": 34.3371200561523,
    "h": 81.6773910522461,
    "CMY_C": 0.09273713827133,
    "CMY_M": 0.23158556222916,
    "CMY_Y": 0.4656720161438,
    "CMYK_C": 0,
    "CMYK_M": 0.15304100513458,
    "CMYK_Y": 0.4110549390316,
    "CMYK_K": 0.09273713827133
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1495",
    "Farbtonhilfsbezeichnung": "Curcuma 85",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "210",
    "Bcolor": "170",
    "Y": 66,
    "L": 85.2382278442383,
    "a": 3.42834997177124,
    "b": 21.9200744628906,
    "C": 22.1865558624268,
    "h": 81.1108245849609,
    "CMY_C": 0.07817697525024,
    "CMY_M": 0.17812496423721,
    "CMY_Y": 0.33150881528854,
    "CMYK_C": 0,
    "CMYK_M": 0.10842426866293,
    "CMYK_Y": 0.27481612563133,
    "CMYK_K": 0.07817697525024
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1496",
    "Farbtonhilfsbezeichnung": "Curcuma 90",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "222",
    "Bcolor": "199",
    "Y": 74,
    "L": 89.2125930786133,
    "a": 1.77297794818878,
    "b": 12.3057231903076,
    "C": 12.4327898025513,
    "h": 81.801383972168,
    "CMY_C": 0.06947433948517,
    "CMY_M": 0.12804859876633,
    "CMY_Y": 0.21838444471359,
    "CMYK_C": 0,
    "CMYK_M": 0.06294749677181,
    "CMYK_Y": 0.16002793610096,
    "CMYK_K": 0.06947433948517
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1497",
    "Farbtonhilfsbezeichnung": "Curcuma 95",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "0",
    "Y": 54,
    "L": 79.0750885009766,
    "a": 16.0344104766846,
    "b": 81.3903961181641,
    "C": 82.9548034667969,
    "h": 78.8551025390625,
    "CMY_C": 0,
    "CMY_M": 0.2858412861824,
    "CMY_Y": 0.9999081492424,
    "CMYK_C": 0,
    "CMYK_M": 0.2858412861824,
    "CMYK_Y": 0.9999081492424,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1498",
    "Farbtonhilfsbezeichnung": "Curcuma 100",
    "Farbtonklasse": "04",
    "Rcolor": "254",
    "Gcolor": "192",
    "Bcolor": "58",
    "Y": 59,
    "L": 81.28466796875,
    "a": 10.7131309509277,
    "b": 70.7347793579102,
    "C": 71.5414581298828,
    "h": 81.3877258300781,
    "CMY_C": 0.00571179389954,
    "CMY_M": 0.24707347154617,
    "CMY_Y": 0.77160853147507,
    "CMYK_C": 0,
    "CMYK_M": 0.2427482008934,
    "CMYK_Y": 0.77029651403427,
    "CMYK_K": 0.00571179389954
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1499",
    "Farbtonhilfsbezeichnung": "Curcuma 105",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "96",
    "Y": 65,
    "L": 84.0830383300781,
    "a": 9.08357048034668,
    "b": 58.2011566162109,
    "C": 58.9057388305664,
    "h": 81.1292953491211,
    "CMY_C": 0,
    "CMY_M": 0.21120065450668,
    "CMY_Y": 0.6233229637146,
    "CMYK_C": 0,
    "CMYK_M": 0.21120065450668,
    "CMYK_Y": 0.6233229637146,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1500",
    "Farbtonhilfsbezeichnung": "Curcuma 110",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "211",
    "Bcolor": "130",
    "Y": 69,
    "L": 86.7126998901367,
    "a": 6.44226455688477,
    "b": 45.0531463623047,
    "C": 45.5114135742188,
    "h": 81.8622970581055,
    "CMY_C": 0,
    "CMY_M": 0.17387413978577,
    "CMY_Y": 0.49041199684143,
    "CMYK_C": 0,
    "CMYK_M": 0.17387413978577,
    "CMYK_Y": 0.49041199684143,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1501",
    "Farbtonhilfsbezeichnung": "Curcuma 115",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "163",
    "Y": 75,
    "L": 89.6116104125977,
    "a": 4.36830186843872,
    "b": 32.2550048828125,
    "C": 32.5494613647461,
    "h": 82.2873458862305,
    "CMY_C": 0,
    "CMY_M": 0.1344610452652,
    "CMY_Y": 0.36259496212006,
    "CMYK_C": 0,
    "CMYK_M": 0.1344610452652,
    "CMYK_Y": 0.36259496212006,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1502",
    "Farbtonhilfsbezeichnung": "Citrus 5",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "95",
    "Bcolor": "64",
    "Y": 11,
    "L": 40.42041015625,
    "a": -1.25761127471924,
    "b": 18.5427188873291,
    "C": 18.5853176116943,
    "h": 93.879997253418,
    "CMY_C": 0.59198802709579,
    "CMY_M": 0.62737548351288,
    "CMY_Y": 0.74793475866318,
    "CMYK_C": 0,
    "CMYK_M": 0.08673141896725,
    "CMYK_Y": 0.38221117854118,
    "CMYK_K": 0.59198802709579
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1503",
    "Farbtonhilfsbezeichnung": "Citrus 10",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "117",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.452823638916,
    "a": -0.46444675326347,
    "b": 15.8796834945679,
    "C": 15.8864736557007,
    "h": 91.6753082275391,
    "CMY_C": 0.50210791826248,
    "CMY_M": 0.5412346124649,
    "CMY_Y": 0.6473480463028,
    "CMYK_C": 0,
    "CMYK_M": 0.07858468592167,
    "CMYK_Y": 0.29171004891396,
    "CMYK_K": 0.50210791826248
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1504",
    "Farbtonhilfsbezeichnung": "Citrus 15",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "142",
    "Bcolor": "117",
    "Y": 27,
    "L": 59.1200294494629,
    "a": -0.39426976442337,
    "b": 13.8580312728882,
    "C": 13.8636388778687,
    "h": 91.6296615600586,
    "CMY_C": 0.40701287984848,
    "CMY_M": 0.44410681724548,
    "CMY_Y": 0.54075288772583,
    "CMYK_C": 0,
    "CMYK_M": 0.0625543743372,
    "CMYK_Y": 0.22553610801697,
    "CMYK_K": 0.40701287984848
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1505",
    "Farbtonhilfsbezeichnung": "Citrus 20",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "167",
    "Bcolor": "146",
    "Y": 39,
    "L": 68.5555801391602,
    "a": -0.68819719552994,
    "b": 10.9007625579834,
    "C": 10.9224653244019,
    "h": 93.6124572753906,
    "CMY_C": 0.3172909617424,
    "CMY_M": 0.34512704610825,
    "CMY_Y": 0.42580270767212,
    "CMYK_C": 0,
    "CMYK_M": 0.0407729819417,
    "CMYK_Y": 0.15894289314747,
    "CMYK_K": 0.3172909617424
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1506",
    "Farbtonhilfsbezeichnung": "Citrus 25",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "193",
    "Bcolor": "175",
    "Y": 53,
    "L": 78.0394973754883,
    "a": -0.40495654940605,
    "b": 8.93840885162354,
    "C": 8.94757747650146,
    "h": 92.5940246582031,
    "CMY_C": 0.21870696544647,
    "CMY_M": 0.24429368972778,
    "CMY_Y": 0.31341356039047,
    "CMYK_C": 0,
    "CMYK_M": 0.03274920210242,
    "CMYK_Y": 0.12121776491404,
    "CMYK_K": 0.21870696544647
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1507",
    "Farbtonhilfsbezeichnung": "Citrus 30",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "219",
    "Bcolor": "206",
    "Y": 71,
    "L": 87.3301544189453,
    "a": -0.21037326753139,
    "b": 6.1380786895752,
    "C": 6.14168262481689,
    "h": 91.9629592895508,
    "CMY_C": 0.12352585792542,
    "CMY_M": 0.14256155490875,
    "CMY_Y": 0.19360756874084,
    "CMYK_C": 0,
    "CMYK_M": 0.02171849273145,
    "CMYK_Y": 0.07995867729187,
    "CMYK_K": 0.12352585792542
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1508",
    "Farbtonhilfsbezeichnung": "Citrus 35",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "135",
    "Bcolor": "58",
    "Y": 25,
    "L": 56.598217010498,
    "a": -1.57005417346954,
    "b": 42.6409378051758,
    "C": 42.6698341369629,
    "h": 92.1087036132812,
    "CMY_C": 0.39241605997086,
    "CMY_M": 0.47173810005188,
    "CMY_Y": 0.77220332622528,
    "CMYK_C": 0,
    "CMYK_M": 0.13055321574211,
    "CMYK_Y": 0.62507784366608,
    "CMYK_K": 0.39241605997086
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1509",
    "Farbtonhilfsbezeichnung": "Citrus 40",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "152",
    "Bcolor": "84",
    "Y": 32,
    "L": 63.4096565246582,
    "a": -1.37171101570129,
    "b": 37.8383293151855,
    "C": 37.8631858825684,
    "h": 92.076171875,
    "CMY_C": 0.32318419218063,
    "CMY_M": 0.40217578411102,
    "CMY_Y": 0.66965824365616,
    "CMYK_C": 0,
    "CMYK_M": 0.11671061813831,
    "CMYK_Y": 0.51191776990891,
    "CMYK_K": 0.32318419218063
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1510",
    "Farbtonhilfsbezeichnung": "Citrus 45",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "171",
    "Bcolor": "112",
    "Y": 41,
    "L": 70.1822662353516,
    "a": -1.12376737594604,
    "b": 32.3243217468262,
    "C": 32.3438491821289,
    "h": 91.9911041259766,
    "CMY_C": 0.2560915350914,
    "CMY_M": 0.33131110668182,
    "CMY_Y": 0.56257474422455,
    "CMYK_C": 0,
    "CMYK_M": 0.10111401230097,
    "CMYK_Y": 0.411990493536,
    "CMYK_K": 0.2560915350914
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1511",
    "Farbtonhilfsbezeichnung": "Citrus 50",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "187",
    "Bcolor": "138",
    "Y": 51,
    "L": 76.3518218994141,
    "a": -0.99352204799652,
    "b": 26.5407218933106,
    "C": 26.5593109130859,
    "h": 92.143798828125,
    "CMY_C": 0.19818717241287,
    "CMY_M": 0.2649894952774,
    "CMY_Y": 0.4582867026329,
    "CMYK_C": 0,
    "CMYK_M": 0.08331411331892,
    "CMYK_Y": 0.32438933849335,
    "CMYK_K": 0.19818717241287
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1512",
    "Farbtonhilfsbezeichnung": "Citrus 55",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "206",
    "Bcolor": "168",
    "Y": 62,
    "L": 82.921745300293,
    "a": -0.75992500782013,
    "b": 20.0814266204834,
    "C": 20.0958003997803,
    "h": 92.1671600341797,
    "CMY_C": 0.13812327384949,
    "CMY_M": 0.19309031963348,
    "CMY_Y": 0.34305799007416,
    "CMYK_C": 0,
    "CMYK_M": 0.06377599388361,
    "CMYK_Y": 0.23777729272842,
    "CMYK_K": 0.13812327384949
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1513",
    "Farbtonhilfsbezeichnung": "Citrus 60",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "223",
    "Bcolor": "196",
    "Y": 75,
    "L": 89.0503921508789,
    "a": -0.78752690553665,
    "b": 13.7300529479981,
    "C": 13.7526197433472,
    "h": 93.2827682495117,
    "CMY_C": 0.08635550737381,
    "CMY_M": 0.12409788370132,
    "CMY_Y": 0.23108619451523,
    "CMYK_C": 0,
    "CMYK_M": 0.04130969569087,
    "CMYK_Y": 0.15841028094292,
    "CMYK_K": 0.08635550737381
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1514",
    "Farbtonhilfsbezeichnung": "Citrus 65",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "186",
    "Bcolor": "47",
    "Y": 51,
    "L": 76.4253845214844,
    "a": -0.99694442749023,
    "b": 68.7818603515625,
    "C": 68.7890853881836,
    "h": 90.8304061889648,
    "CMY_C": 0.13749861717224,
    "CMY_M": 0.27008366584778,
    "CMY_Y": 0.81485801935196,
    "CMYK_C": 0,
    "CMYK_M": 0.15372155606747,
    "CMYK_Y": 0.78534299135208,
    "CMYK_K": 0.13749861717224
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1515",
    "Farbtonhilfsbezeichnung": "Citrus 70",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "194",
    "Bcolor": "78",
    "Y": 55,
    "L": 79.1615600585938,
    "a": -1.81380021572113,
    "b": 59.7876358032227,
    "C": 59.8151435852051,
    "h": 91.7376708984375,
    "CMY_C": 0.1195148229599,
    "CMY_M": 0.23796910047531,
    "CMY_Y": 0.69264686107635,
    "CMYK_C": 0,
    "CMYK_M": 0.13453295826912,
    "CMYK_Y": 0.65092754364014,
    "CMYK_K": 0.1195148229599
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1516",
    "Farbtonhilfsbezeichnung": "Citrus 75",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "203",
    "Bcolor": "107",
    "Y": 61,
    "L": 82.3056869506836,
    "a": -0.87576937675476,
    "b": 50.5668830871582,
    "C": 50.5744667053223,
    "h": 90.9922103881836,
    "CMY_C": 0.08850228786469,
    "CMY_M": 0.20499211549759,
    "CMY_Y": 0.58144241571426,
    "CMYK_C": 0,
    "CMYK_M": 0.12780046463013,
    "CMYK_Y": 0.54080235958099,
    "CMYK_K": 0.08850228786469
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1517",
    "Farbtonhilfsbezeichnung": "Citrus 80",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "212",
    "Bcolor": "134",
    "Y": 67,
    "L": 85.4005508422852,
    "a": -1.15582489967346,
    "b": 40.9757804870605,
    "C": 40.9920768737793,
    "h": 91.6157455444336,
    "CMY_C": 0.06963020563126,
    "CMY_M": 0.16908746957779,
    "CMY_Y": 0.47416615486145,
    "CMYK_C": 0,
    "CMYK_M": 0.10690078884363,
    "CMYK_Y": 0.43481200933456,
    "CMYK_K": 0.06963020563126
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1518",
    "Farbtonhilfsbezeichnung": "Citrus 85",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "222",
    "Bcolor": "161",
    "Y": 73,
    "L": 89.0470962524414,
    "a": -0.54801785945892,
    "b": 31.9716758728027,
    "C": 31.9763717651367,
    "h": 90.9819946289062,
    "CMY_C": 0.04065752029419,
    "CMY_M": 0.12871646881104,
    "CMY_Y": 0.36740505695343,
    "CMYK_C": 0,
    "CMYK_M": 0.09179093688726,
    "CMYK_Y": 0.34059530496597,
    "CMYK_K": 0.04065752029419
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1519",
    "Farbtonhilfsbezeichnung": "Citrus 90",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "230",
    "Bcolor": "189",
    "Y": 79,
    "L": 91.7942352294922,
    "a": -0.20019644498825,
    "b": 21.4947338104248,
    "C": 21.4956665039063,
    "h": 90.5336227416992,
    "CMY_C": 0.03058314323425,
    "CMY_M": 0.09680819511414,
    "CMY_Y": 0.25934255123138,
    "CMYK_C": 0,
    "CMYK_M": 0.06831432133913,
    "CMYK_Y": 0.23597630858421,
    "CMYK_K": 0.03058314323425
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1520",
    "Farbtonhilfsbezeichnung": "Citrus 95",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "30",
    "Y": 73,
    "L": 87.7469940185547,
    "a": -2.00347137451172,
    "b": 83.9073867797852,
    "C": 83.9313049316406,
    "h": 91.367805480957,
    "CMY_C": 0,
    "CMY_M": 0.14659821987152,
    "CMY_Y": 0.88359957933426,
    "CMYK_C": 0,
    "CMYK_M": 0.14659821987152,
    "CMYK_Y": 0.88359957933426,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1521",
    "Farbtonhilfsbezeichnung": "Citrus 100",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "67",
    "Y": 75,
    "L": 88.8240203857422,
    "a": -2.19454646110535,
    "b": 74.9457244873047,
    "C": 74.9778442382813,
    "h": 91.67724609375,
    "CMY_C": 0,
    "CMY_M": 0.13350212574005,
    "CMY_Y": 0.73826283216476,
    "CMYK_C": 0,
    "CMYK_M": 0.13350212574005,
    "CMYK_Y": 0.73826283216476,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1522",
    "Farbtonhilfsbezeichnung": "Citrus 105",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "223",
    "Bcolor": "89",
    "Y": 77,
    "L": 89.2610549926758,
    "a": -2.42312908172607,
    "b": 66.7538986206055,
    "C": 66.7978668212891,
    "h": 92.0788955688477,
    "CMY_C": 0,
    "CMY_M": 0.12726420164108,
    "CMY_Y": 0.64994299411774,
    "CMYK_C": 0,
    "CMYK_M": 0.12726420164108,
    "CMYK_Y": 0.64994299411774,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1523",
    "Farbtonhilfsbezeichnung": "Citrus 115",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "228",
    "Bcolor": "149",
    "Y": 80,
    "L": 91.0225448608398,
    "a": -1.16443920135498,
    "b": 40.9925765991211,
    "C": 41.0091133117676,
    "h": 91.6271133422852,
    "CMY_C": 0.00453877449036,
    "CMY_M": 0.10701245069504,
    "CMY_Y": 0.41603338718414,
    "CMYK_C": 0,
    "CMYK_M": 0.10294090211391,
    "CMYK_Y": 0.4133708178997,
    "CMYK_K": 0.00453877449036
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1524",
    "Farbtonhilfsbezeichnung": "Citrus 120",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "232",
    "Bcolor": "174",
    "Y": 83,
    "L": 92.4094772338867,
    "a": -0.71396803855896,
    "b": 30.1695556640625,
    "C": 30.1780033111572,
    "h": 91.3556671142578,
    "CMY_C": 0.00700479745865,
    "CMY_M": 0.09058517217636,
    "CMY_Y": 0.31830471754074,
    "CMYK_C": 0,
    "CMYK_M": 0.08416996896267,
    "CMYK_Y": 0.31349590420723,
    "CMYK_K": 0.00700479745865
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1525",
    "Farbtonhilfsbezeichnung": "Pinie 5",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "93",
    "Bcolor": "72",
    "Y": 10,
    "L": 38.6597099304199,
    "a": -5.14515829086304,
    "b": 11.0691156387329,
    "C": 12.2064723968506,
    "h": 114.929992675781,
    "CMY_C": 0.64822441339493,
    "CMY_M": 0.63522350788116,
    "CMY_Y": 0.71636092662811,
    "CMYK_C": 0.03564074262977,
    "CMYK_M": 0,
    "CMYK_Y": 0.22243049740791,
    "CMYK_K": 0.63522350788116
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1526",
    "Farbtonhilfsbezeichnung": "Pinie 10",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "115",
    "Bcolor": "96",
    "Y": 17,
    "L": 47.8518371582031,
    "a": -4.70939683914185,
    "b": 10.0147218704224,
    "C": 11.0667552947998,
    "h": 115.185127258301,
    "CMY_C": 0.55934286117554,
    "CMY_M": 0.54717010259628,
    "CMY_Y": 0.62435615062714,
    "CMYK_C": 0.02688152529299,
    "CMYK_M": 0,
    "CMYK_Y": 0.17045263946056,
    "CMYK_K": 0.54717010259628
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1527",
    "Farbtonhilfsbezeichnung": "Pinie 15",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "140",
    "Bcolor": "122",
    "Y": 26,
    "L": 57.6183586120605,
    "a": -4.2302451133728,
    "b": 8.8681468963623,
    "C": 9.82542610168457,
    "h": 115.50186920166,
    "CMY_C": 0.46153271198273,
    "CMY_M": 0.45017158985138,
    "CMY_Y": 0.52213883399963,
    "CMYK_C": 0.02066303230822,
    "CMYK_M": 0,
    "CMYK_Y": 0.13089036941528,
    "CMYK_K": 0.45017158985138
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1528",
    "Farbtonhilfsbezeichnung": "Pinie 20",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "166",
    "Bcolor": "150",
    "Y": 37,
    "L": 67.6533050537109,
    "a": -3.31867671012878,
    "b": 7.4864649772644,
    "C": 8.18906402587891,
    "h": 113.907241821289,
    "CMY_C": 0.35528737306595,
    "CMY_M": 0.34800982475281,
    "CMY_Y": 0.41151940822601,
    "CMYK_C": 0.01116205193102,
    "CMYK_M": 0,
    "CMYK_Y": 0.09740880131721,
    "CMYK_K": 0.34800982475281
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1529",
    "Farbtonhilfsbezeichnung": "Pinie 25",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "193",
    "Bcolor": "180",
    "Y": 52,
    "L": 77.4994964599609,
    "a": -2.68758893013,
    "b": 5.64356565475464,
    "C": 6.2508373260498,
    "h": 115.464813232422,
    "CMY_C": 0.25148087739944,
    "CMY_M": 0.24410277605057,
    "CMY_Y": 0.29579490423203,
    "CMYK_C": 0.00976072065532,
    "CMYK_M": 0,
    "CMYK_Y": 0.06838512420654,
    "CMYK_K": 0.24410277605057
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1530",
    "Farbtonhilfsbezeichnung": "Pinie 30",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "217",
    "Bcolor": "206",
    "Y": 69,
    "L": 86.4374542236328,
    "a": -2.13253712654114,
    "b": 4.80159854888916,
    "C": 5.25386190414429,
    "h": 113.947471618652,
    "CMY_C": 0.15247112512589,
    "CMY_M": 0.14758032560349,
    "CMY_Y": 0.19376707077026,
    "CMYK_C": 0.00573754869401,
    "CMYK_M": 0,
    "CMYK_Y": 0.05418310686946,
    "CMYK_K": 0.14758032560349
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1531",
    "Farbtonhilfsbezeichnung": "Pinie 35",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "114",
    "Bcolor": "66",
    "Y": 15,
    "L": 46.3716773986816,
    "a": -11.3081712722778,
    "b": 25.1480884552002,
    "C": 27.5735569000244,
    "h": 114.211700439453,
    "CMY_C": 0.58519333600998,
    "CMY_M": 0.55181360244751,
    "CMY_Y": 0.74042481184006,
    "CMYK_C": 0.07447734475136,
    "CMYK_M": 0,
    "CMYK_Y": 0.42083206772804,
    "CMYK_K": 0.55181360244751
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1532",
    "Farbtonhilfsbezeichnung": "Pinie 40",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "135",
    "Bcolor": "91",
    "Y": 22,
    "L": 54.654857635498,
    "a": -10.3135814666748,
    "b": 22.3167228698731,
    "C": 24.5846710205078,
    "h": 114.803825378418,
    "CMY_C": 0.50127446651459,
    "CMY_M": 0.47070866823196,
    "CMY_Y": 0.64360457658768,
    "CMYK_C": 0.05774853378534,
    "CMYK_M": 0,
    "CMYK_Y": 0.32665547728539,
    "CMYK_K": 0.47070866823196
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1533",
    "Farbtonhilfsbezeichnung": "Pinie 45",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "156",
    "Bcolor": "115",
    "Y": 32,
    "L": 62.8447952270508,
    "a": -8.77123832702637,
    "b": 19.9350872039795,
    "C": 21.7794017791748,
    "h": 113.749015808105,
    "CMY_C": 0.41184556484222,
    "CMY_M": 0.38943529129028,
    "CMY_Y": 0.54760372638702,
    "CMYK_C": 0.03670417517424,
    "CMYK_M": 0,
    "CMYK_Y": 0.25905269384384,
    "CMYK_K": 0.38943529129028
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1534",
    "Farbtonhilfsbezeichnung": "Pinie 50",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "177",
    "Bcolor": "143",
    "Y": 42,
    "L": 71.0777969360352,
    "a": -7.53881692886353,
    "b": 16.3568267822266,
    "C": 18.0105400085449,
    "h": 114.744842529297,
    "CMY_C": 0.32547944784164,
    "CMY_M": 0.30481082201004,
    "CMY_Y": 0.43970364332199,
    "CMYK_C": 0.02973093651235,
    "CMYK_M": 0,
    "CMYK_Y": 0.19403757154942,
    "CMYK_K": 0.30481082201004
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1535",
    "Farbtonhilfsbezeichnung": "Pinie 55",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "174",
    "Y": 57,
    "L": 80.0199432373047,
    "a": -5.39120626449585,
    "b": 12.2786598205566,
    "C": 13.4100933074951,
    "h": 113.704895019531,
    "CMY_C": 0.22475504875183,
    "CMY_M": 0.21240293979645,
    "CMY_Y": 0.31740772724152,
    "CMYK_C": 0.01568328402936,
    "CMYK_M": 0,
    "CMYK_Y": 0.13332298398018,
    "CMYK_K": 0.21240293979645
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1536",
    "Farbtonhilfsbezeichnung": "Pinie 60",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "224",
    "Bcolor": "201",
    "Y": 72,
    "L": 88.282470703125,
    "a": -4.58283472061157,
    "b": 10.063310623169,
    "C": 11.0576934814453,
    "h": 114.484535217285,
    "CMY_C": 0.13452839851379,
    "CMY_M": 0.12290054559708,
    "CMY_Y": 0.21285253763199,
    "CMYK_C": 0.01325716543943,
    "CMYK_M": 0,
    "CMYK_Y": 0.10255620628595,
    "CMYK_K": 0.12290054559708
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1537",
    "Farbtonhilfsbezeichnung": "Pinie 65",
    "Farbtonklasse": "04",
    "Rcolor": "122",
    "Gcolor": "136",
    "Bcolor": "56",
    "Y": 22,
    "L": 53.9506568908691,
    "a": -16.981201171875,
    "b": 40.0783882141113,
    "C": 43.5274429321289,
    "h": 112.962364196777,
    "CMY_C": 0.52206152677536,
    "CMY_M": 0.46791249513626,
    "CMY_Y": 0.781893491745,
    "CMYK_C": 0.10176715254784,
    "CMYK_M": 0,
    "CMYK_Y": 0.59009277820587,
    "CMYK_K": 0.46791249513626
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1538",
    "Farbtonhilfsbezeichnung": "Pinie 70",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "156",
    "Bcolor": "84",
    "Y": 30,
    "L": 61.7890357971191,
    "a": -15.8710746765137,
    "b": 35.192310333252,
    "C": 38.6055641174316,
    "h": 114.274490356445,
    "CMY_C": 0.44098401069641,
    "CMY_M": 0.38899230957031,
    "CMY_Y": 0.66904938220978,
    "CMYK_C": 0.08509173244238,
    "CMYK_M": 0,
    "CMYK_Y": 0.45835277438164,
    "CMYK_K": 0.38899230957031
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1539",
    "Farbtonhilfsbezeichnung": "Pinie 75",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "172",
    "Bcolor": "109",
    "Y": 38,
    "L": 67.9894332885742,
    "a": -13.948450088501,
    "b": 30.5194664001465,
    "C": 33.5558815002441,
    "h": 114.562042236328,
    "CMY_C": 0.37117719650269,
    "CMY_M": 0.32706850767136,
    "CMY_Y": 0.57372069358826,
    "CMYK_C": 0.0655470713973,
    "CMYK_M": 0,
    "CMYK_Y": 0.36653387546539,
    "CMYK_K": 0.32706850767136
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1540",
    "Farbtonhilfsbezeichnung": "Pinie 80",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "191",
    "Bcolor": "140",
    "Y": 49,
    "L": 75.6852645874023,
    "a": -11.3751745223999,
    "b": 24.3178024291992,
    "C": 26.8467903137207,
    "h": 115.068855285645,
    "CMY_C": 0.28425407409668,
    "CMY_M": 0.24905276298523,
    "CMY_Y": 0.45078104734421,
    "CMYK_C": 0.04687587916851,
    "CMYK_M": 0,
    "CMYK_Y": 0.26863175630569,
    "CMYK_K": 0.24905276298523
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1541",
    "Farbtonhilfsbezeichnung": "Pinie 85",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "210",
    "Bcolor": "169",
    "Y": 61,
    "L": 82.6444320678711,
    "a": -8.74308967590332,
    "b": 18.5231990814209,
    "C": 20.4829330444336,
    "h": 115.26766204834,
    "CMY_C": 0.20395940542221,
    "CMY_M": 0.17780411243439,
    "CMY_Y": 0.33588480949402,
    "CMYK_C": 0.0318115092814,
    "CMYK_M": 0,
    "CMYK_Y": 0.1922664642334,
    "CMYK_K": 0.17780411243439
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1542",
    "Farbtonhilfsbezeichnung": "Pinie 90",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "226",
    "Bcolor": "198",
    "Y": 75,
    "L": 88.8835220336914,
    "a": -5.99012470245361,
    "b": 12.5669317245483,
    "C": 13.9215431213379,
    "h": 115.485168457031,
    "CMY_C": 0.13118201494217,
    "CMY_M": 0.1136469244957,
    "CMY_Y": 0.22509253025055,
    "CMYK_C": 0.0197834149003,
    "CMYK_M": 0,
    "CMYK_Y": 0.12573499977589,
    "CMYK_K": 0.1136469244957
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1543",
    "Farbtonhilfsbezeichnung": "Pinie 95",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "162",
    "Bcolor": "42",
    "Y": 31,
    "L": 62.5526542663574,
    "a": -25.5900783538818,
    "b": 55.1717376708984,
    "C": 60.8175354003906,
    "h": 114.883087158203,
    "CMY_C": 0.47109770774841,
    "CMY_M": 0.36572444438934,
    "CMY_Y": 0.83623623847961,
    "CMYK_C": 0.16613167524338,
    "CMYK_M": 0,
    "CMYK_Y": 0.74180972576141,
    "CMYK_K": 0.36572444438934
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1544",
    "Farbtonhilfsbezeichnung": "Pinie 100",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "175",
    "Bcolor": "75",
    "Y": 39,
    "L": 68.2673721313477,
    "a": -20.5567855834961,
    "b": 47.9460411071777,
    "C": 52.1670799255371,
    "h": 113.207153320313,
    "CMY_C": 0.38363367319107,
    "CMY_M": 0.31382793188095,
    "CMY_Y": 0.70753359794617,
    "CMYK_C": 0.10173211991787,
    "CMYK_M": 0,
    "CMYK_Y": 0.57377105951309,
    "CMYK_K": 0.31382793188095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1545",
    "Farbtonhilfsbezeichnung": "Pinie 105",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "190",
    "Bcolor": "102",
    "Y": 47,
    "L": 74.0038604736328,
    "a": -17.9569759368896,
    "b": 41.5333595275879,
    "C": 45.2490119934082,
    "h": 113.381278991699,
    "CMY_C": 0.31368309259415,
    "CMY_M": 0.2567058801651,
    "CMY_Y": 0.59809899330139,
    "CMYK_C": 0.07665500044823,
    "CMYK_M": 0,
    "CMYK_Y": 0.45929747819901,
    "CMYK_K": 0.2567058801651
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1546",
    "Farbtonhilfsbezeichnung": "Pinie 110",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "203",
    "Bcolor": "131",
    "Y": 56,
    "L": 79.258415222168,
    "a": -15.2317924499512,
    "b": 34.0031471252441,
    "C": 37.258846282959,
    "h": 114.130111694336,
    "CMY_C": 0.2515954375267,
    "CMY_M": 0.2041003704071,
    "CMY_Y": 0.48695397377014,
    "CMYK_C": 0.05967469513416,
    "CMYK_M": 0,
    "CMYK_Y": 0.35538852214813,
    "CMYK_K": 0.2041003704071
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1547",
    "Farbtonhilfsbezeichnung": "Pinie 115",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "218",
    "Bcolor": "162",
    "Y": 67,
    "L": 85.3197555541992,
    "a": -11.8875722885132,
    "b": 26.2444305419922,
    "C": 28.8111877441406,
    "h": 114.368438720703,
    "CMY_C": 0.17811638116837,
    "CMY_M": 0.14317125082016,
    "CMY_Y": 0.36557161808014,
    "CMYK_C": 0.04078426584601,
    "CMYK_M": 0,
    "CMYK_Y": 0.2595622241497,
    "CMYK_K": 0.14317125082016
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1548",
    "Farbtonhilfsbezeichnung": "Pinie 120",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "230",
    "Bcolor": "190",
    "Y": 78,
    "L": 90.0972366333008,
    "a": -7.69953441619873,
    "b": 18.2075481414795,
    "C": 19.7686023712158,
    "h": 112.922332763672,
    "CMY_C": 0.11449521780014,
    "CMY_M": 0.09760797023773,
    "CMY_Y": 0.25424414873123,
    "CMYK_C": 0.0187138710171,
    "CMYK_M": 0,
    "CMYK_Y": 0.17357885837555,
    "CMYK_K": 0.09760797023773
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1549",
    "Farbtonhilfsbezeichnung": "Malachit 5",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "87",
    "Bcolor": "77",
    "Y": 9,
    "L": 35.6044387817383,
    "a": -7.49856376647949,
    "b": 3.50817513465881,
    "C": 8.27863216400146,
    "h": 154.927642822266,
    "CMY_C": 0.71298903226852,
    "CMY_M": 0.65822529792786,
    "CMY_Y": 0.69698762893677,
    "CMYK_C": 0.16023343801498,
    "CMYK_M": 0,
    "CMYK_Y": 0.11341486126184,
    "CMYK_K": 0.65822529792786
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1550",
    "Farbtonhilfsbezeichnung": "Malachit 10",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "110",
    "Bcolor": "100",
    "Y": 15,
    "L": 45.088737487793,
    "a": -6.80453681945801,
    "b": 3.30771207809448,
    "C": 7.56588935852051,
    "h": 154.075439453125,
    "CMY_C": 0.61993658542633,
    "CMY_M": 0.56873500347137,
    "CMY_Y": 0.60721522569656,
    "CMYK_C": 0.11872417479753,
    "CMYK_M": 0,
    "CMYK_Y": 0.08922639489174,
    "CMYK_K": 0.56873500347137
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1551",
    "Farbtonhilfsbezeichnung": "Malachit 15",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "135",
    "Bcolor": "126",
    "Y": 24,
    "L": 55.3490676879883,
    "a": -5.74680709838867,
    "b": 3.13146829605103,
    "C": 6.54460716247559,
    "h": 151.413772583008,
    "CMY_C": 0.51246702671051,
    "CMY_M": 0.46877980232239,
    "CMY_Y": 0.50611805915833,
    "CMYK_C": 0.08223938941956,
    "CMYK_M": 0,
    "CMYK_Y": 0.07028771936893,
    "CMYK_K": 0.46877980232239
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1552",
    "Farbtonhilfsbezeichnung": "Malachit 20",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "161",
    "Bcolor": "153",
    "Y": 35,
    "L": 65.258918762207,
    "a": -4.77594900131226,
    "b": 2.36348223686218,
    "C": 5.32876491546631,
    "h": 153.670486450195,
    "CMY_C": 0.40706717967987,
    "CMY_M": 0.36869567632675,
    "CMY_Y": 0.40066123008728,
    "CMYK_C": 0.06078130751848,
    "CMYK_M": 0,
    "CMYK_Y": 0.0506341420114,
    "CMYK_K": 0.36869567632675
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1553",
    "Farbtonhilfsbezeichnung": "Malachit 25",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "187",
    "Bcolor": "179",
    "Y": 49,
    "L": 75.1761245727539,
    "a": -3.87776684761047,
    "b": 2.23239040374756,
    "C": 4.47444343566895,
    "h": 150.071411132813,
    "CMY_C": 0.29657363891602,
    "CMY_M": 0.2655753493309,
    "CMY_Y": 0.29617285728455,
    "CMYK_C": 0.04220758378506,
    "CMYK_M": 0,
    "CMYK_Y": 0.04166187345982,
    "CMYK_K": 0.2655753493309
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1554",
    "Farbtonhilfsbezeichnung": "Malachit 30",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "213",
    "Bcolor": "206",
    "Y": 67,
    "L": 84.6248779296875,
    "a": -3.01864814758301,
    "b": 1.79628753662109,
    "C": 3.51267504692078,
    "h": 149.244659423828,
    "CMY_C": 0.18934524059296,
    "CMY_M": 0.16470044851303,
    "CMY_Y": 0.19158911705017,
    "CMYK_C": 0.02950413711369,
    "CMYK_M": 0,
    "CMYK_Y": 0.03219044953585,
    "CMYK_K": 0.16470044851303
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1555",
    "Farbtonhilfsbezeichnung": "Malachit 35",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "96",
    "Bcolor": "73",
    "Y": 10,
    "L": 37.5721397399902,
    "a": -17.6634864807129,
    "b": 8.71827125549316,
    "C": 19.6978931427002,
    "h": 153.730163574219,
    "CMY_C": 0.75779896974564,
    "CMY_M": 0.62385565042496,
    "CMY_Y": 0.71297001838684,
    "CMYK_C": 0.35609552264214,
    "CMYK_M": 0,
    "CMYK_Y": 0.23691534996033,
    "CMYK_K": 0.62385565042496
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1556",
    "Farbtonhilfsbezeichnung": "Malachit 40",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "120",
    "Bcolor": "99",
    "Y": 16,
    "L": 47.5310745239258,
    "a": -15.3136987686157,
    "b": 7.55954694747925,
    "C": 17.0779418945313,
    "h": 153.726928710938,
    "CMY_C": 0.64870029687881,
    "CMY_M": 0.5302802324295,
    "CMY_Y": 0.61270451545715,
    "CMYK_C": 0.25210788846016,
    "CMYK_M": 0,
    "CMYK_Y": 0.17547543346882,
    "CMYK_K": 0.5302802324295
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1557",
    "Farbtonhilfsbezeichnung": "Malachit 45",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "144",
    "Bcolor": "124",
    "Y": 25,
    "L": 57.3130989074707,
    "a": -13.617395401001,
    "b": 6.87104368209839,
    "C": 15.2526950836182,
    "h": 153.225479125977,
    "CMY_C": 0.5418336391449,
    "CMY_M": 0.43441015481949,
    "CMY_Y": 0.51288485527039,
    "CMYK_C": 0.18993178009987,
    "CMYK_M": 0,
    "CMYK_Y": 0.13874842226505,
    "CMYK_K": 0.43441015481949
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1558",
    "Farbtonhilfsbezeichnung": "Malachit 50",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "171",
    "Bcolor": "154",
    "Y": 38,
    "L": 67.9976501464844,
    "a": -11.1259307861328,
    "b": 5.76780128479004,
    "C": 12.5321130752563,
    "h": 152.597305297852,
    "CMY_C": 0.41721767187119,
    "CMY_M": 0.32768261432648,
    "CMY_Y": 0.39703702926636,
    "CMYK_C": 0.13317379355431,
    "CMYK_M": 0,
    "CMYK_Y": 0.10315725207329,
    "CMYK_K": 0.32768261432648
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1559",
    "Farbtonhilfsbezeichnung": "Malachit 55",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "196",
    "Bcolor": "183",
    "Y": 52,
    "L": 77.5743560791016,
    "a": -8.38574504852295,
    "b": 4.03045606613159,
    "C": 9.30404758453369,
    "h": 154.329574584961,
    "CMY_C": 0.30065733194351,
    "CMY_M": 0.23040550947189,
    "CMY_Y": 0.2842133641243,
    "CMYK_C": 0.09128420799971,
    "CMYK_M": 0,
    "CMYK_Y": 0.06991714984179,
    "CMYK_K": 0.23040550947189
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1560",
    "Farbtonhilfsbezeichnung": "Malachit 60",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "221",
    "Bcolor": "210",
    "Y": 70,
    "L": 86.9620361328125,
    "a": -5.79504537582397,
    "b": 3.36002635955811,
    "C": 6.69868087768555,
    "h": 149.894409179688,
    "CMY_C": 0.18060541152954,
    "CMY_M": 0.13305109739304,
    "CMY_Y": 0.17799746990204,
    "CMYK_C": 0.0548525005579,
    "CMYK_M": 0,
    "CMYK_Y": 0.05184431374073,
    "CMYK_K": 0.13305109739304
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1561",
    "Farbtonhilfsbezeichnung": "Malachit 65",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "103",
    "Bcolor": "71",
    "Y": 11,
    "L": 39.4876327514648,
    "a": -25.6599521636963,
    "b": 12.720401763916,
    "C": 28.6398639678955,
    "h": 153.63102722168,
    "CMY_C": 0.80089467763901,
    "CMY_M": 0.59422302246094,
    "CMY_Y": 0.7222586274147,
    "CMYK_C": 0.50932323932648,
    "CMYK_M": 0,
    "CMYK_Y": 0.31553196907043,
    "CMYK_K": 0.59422302246094
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1562",
    "Farbtonhilfsbezeichnung": "Mlachit 70",
    "Farbtonklasse": "04",
    "Y": 18,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1563",
    "Farbtonhilfsbezeichnung": "Malachit 75",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "154",
    "Bcolor": "126",
    "Y": 28,
    "L": 59.9024848937988,
    "a": -19.9066028594971,
    "b": 9.47965908050537,
    "C": 22.0485095977783,
    "h": 154.535903930664,
    "CMY_C": 0.5598908662796,
    "CMY_M": 0.39680564403534,
    "CMY_Y": 0.50583052635193,
    "CMYK_C": 0.27036929130554,
    "CMYK_M": 0,
    "CMYK_Y": 0.18074585497379,
    "CMYK_K": 0.39680564403534
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1564",
    "Farbtonhilfsbezeichnung": "Malachit 80",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "177",
    "Bcolor": "154",
    "Y": 40,
    "L": 69.2933044433594,
    "a": -15.8283576965332,
    "b": 7.3447117805481,
    "C": 17.4494037628174,
    "h": 155.107635498047,
    "CMY_C": 0.43717885017395,
    "CMY_M": 0.30503362417221,
    "CMY_Y": 0.39539939165115,
    "CMYK_C": 0.19014620780945,
    "CMYK_M": 0,
    "CMYK_Y": 0.13002897799015,
    "CMYK_K": 0.30503362417221
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1565",
    "Farbtonhilfsbezeichnung": "Malachit 85",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "202",
    "Bcolor": "182",
    "Y": 55,
    "L": 78.7852630615234,
    "a": -12.5447816848755,
    "b": 5.75697660446167,
    "C": 13.8026924133301,
    "h": 155.34895324707,
    "CMY_C": 0.31584668159485,
    "CMY_M": 0.20894080400467,
    "CMY_Y": 0.28434324264526,
    "CMYK_C": 0.13514269888401,
    "CMYK_M": 0,
    "CMYK_Y": 0.09531832486391,
    "CMYK_K": 0.20894080400467
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1566",
    "Farbtonhilfsbezeichnung": "Malachit 90",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "228",
    "Bcolor": "213",
    "Y": 74,
    "L": 88.8391571044922,
    "a": -8.54165649414063,
    "b": 4.15882444381714,
    "C": 9.50030040740967,
    "h": 154.039138793945,
    "CMY_C": 0.17968064546585,
    "CMY_M": 0.10629373788834,
    "CMY_Y": 0.16377705335617,
    "CMYK_C": 0.08211524039507,
    "CMYK_M": 0,
    "CMYK_Y": 0.06432014703751,
    "CMYK_K": 0.10629373788834
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1567",
    "Farbtonhilfsbezeichnung": "Malachit 95",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "110",
    "Bcolor": "69",
    "Y": 12,
    "L": 41.0481986999512,
    "a": -32.3513259887695,
    "b": 16.0057926177979,
    "C": 36.0942344665527,
    "h": 153.676132202148,
    "CMY_C": 0.85195183753967,
    "CMY_M": 0.57027208805084,
    "CMY_Y": 0.7305018901825,
    "CMYK_C": 0.65548396110535,
    "CMYK_M": 0,
    "CMYK_Y": 0.37286338210106,
    "CMYK_K": 0.57027208805084
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1568",
    "Farbtonhilfsbezeichnung": "Malachit 105",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "159",
    "Bcolor": "122",
    "Y": 29,
    "L": 60.8773040771484,
    "a": -26.2727279663086,
    "b": 13.1535005569458,
    "C": 29.3814697265625,
    "h": 153.405059814453,
    "CMY_C": 0.59449148178101,
    "CMY_M": 0.3764026761055,
    "CMY_Y": 0.52237832546234,
    "CMYK_C": 0.34972697496414,
    "CMYK_M": 0,
    "CMYK_Y": 0.23408639431,
    "CMYK_K": 0.3764026761055
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1569",
    "Farbtonhilfsbezeichnung": "Malachit 100",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "134",
    "Bcolor": "94",
    "Y": 19,
    "L": 50.8102416992188,
    "a": -30.4466571807861,
    "b": 14.9250802993774,
    "C": 33.9080657958984,
    "h": 153.885711669922,
    "CMY_C": 0.73124563694,
    "CMY_M": 0.47443395853043,
    "CMY_Y": 0.63261413574219,
    "CMYK_C": 0.48863825201988,
    "CMYK_M": 0,
    "CMYK_Y": 0.30097109079361,
    "CMYK_K": 0.47443395853043
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1570",
    "Farbtonhilfsbezeichnung": "Malachit 110",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "183",
    "Bcolor": "151",
    "Y": 43,
    "L": 70.6122436523438,
    "a": -20.968729019165,
    "b": 10.7461624145508,
    "C": 23.5619945526123,
    "h": 152.865539550781,
    "CMY_C": 0.45562922954559,
    "CMY_M": 0.28194552659988,
    "CMY_Y": 0.40657764673233,
    "CMYK_C": 0.24188095331192,
    "CMYK_M": 0,
    "CMYK_Y": 0.17356917262077,
    "CMYK_K": 0.28194552659988
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1571",
    "Farbtonhilfsbezeichnung": "Malachit 115",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "210",
    "Bcolor": "183",
    "Y": 59,
    "L": 80.8317184448242,
    "a": -16.9288997650146,
    "b": 8.54601287841797,
    "C": 18.9637012481689,
    "h": 153.21452331543,
    "CMY_C": 0.32116973400116,
    "CMY_M": 0.17827576398849,
    "CMY_Y": 0.28340244293213,
    "CMYK_C": 0.1738952845335,
    "CMYK_M": 0,
    "CMYK_Y": 0.12793426215649,
    "CMYK_K": 0.17827576398849
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1572",
    "Farbtonhilfsbezeichnung": "Malachit 120",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "235",
    "Bcolor": "216",
    "Y": 78,
    "L": 90.9723434448242,
    "a": -11.4391965866089,
    "b": 5.65364074707031,
    "C": 12.7600498199463,
    "h": 153.699844360352,
    "CMY_C": 0.17509859800339,
    "CMY_M": 0.07648527622223,
    "CMY_Y": 0.15190404653549,
    "CMYK_C": 0.10678045451641,
    "CMYK_M": 0,
    "CMYK_Y": 0.08166493475437,
    "CMYK_K": 0.07648527622223
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1573",
    "Farbtonhilfsbezeichnung": "Lago 5",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "73",
    "Bcolor": "82",
    "Y": 6,
    "L": 30.0702533721924,
    "a": -2.72871088981628,
    "b": -7.47287034988403,
    "C": 7.95547962188721,
    "h": 249.940383911133,
    "CMY_C": 0.76666903495789,
    "CMY_M": 0.71515941619873,
    "CMY_Y": 0.68016600608826,
    "CMYK_C": 0.27046227455139,
    "CMYK_M": 0.10941116511822,
    "CMYK_Y": 0,
    "CMYK_K": 0.68016600608826
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1574",
    "Farbtonhilfsbezeichnung": "Lago 10",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "98",
    "Bcolor": "106",
    "Y": 12,
    "L": 40.6147346496582,
    "a": -2.49847817420959,
    "b": -6.65940237045288,
    "C": 7.11266708374023,
    "h": 249.43489074707,
    "CMY_C": 0.66495651006699,
    "CMY_M": 0.61764639616013,
    "CMY_Y": 0.58590042591095,
    "CMYK_C": 0.19091080129147,
    "CMYK_M": 0.0766626521945,
    "CMYK_Y": 0,
    "CMYK_K": 0.58590042591095
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1575",
    "Farbtonhilfsbezeichnung": "Lago 15",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "124",
    "Bcolor": "130",
    "Y": 20,
    "L": 51.3401107788086,
    "a": -2.4327552318573,
    "b": -5.45882797241211,
    "C": 5.97637844085693,
    "h": 245.979614257812,
    "CMY_C": 0.55674666166306,
    "CMY_M": 0.51352167129517,
    "CMY_Y": 0.48849231004715,
    "CMYK_C": 0.13343758881092,
    "CMYK_M": 0.04893252253532,
    "CMYK_Y": 0,
    "CMYK_K": 0.48849231004715
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1576",
    "Farbtonhilfsbezeichnung": "Lago 20",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "152",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.1803359985352,
    "a": -2.29490756988525,
    "b": -4.49791574478149,
    "C": 5.04953908920288,
    "h": 242.968597412109,
    "CMY_C": 0.44344305992126,
    "CMY_M": 0.40410226583481,
    "CMY_Y": 0.38482803106308,
    "CMYK_C": 0.09528234601021,
    "CMYK_M": 0.03133145719767,
    "CMYK_Y": 0,
    "CMYK_K": 0.38482803106308
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1577",
    "Farbtonhilfsbezeichnung": "Lago 25",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "180",
    "Bcolor": "183",
    "Y": 44,
    "L": 72.6076812744141,
    "a": -1.84632170200348,
    "b": -3.30797815322876,
    "C": 3.78835368156433,
    "h": 240.832275390625,
    "CMY_C": 0.32721298933029,
    "CMY_M": 0.2960142493248,
    "CMY_Y": 0.28384417295456,
    "CMYK_C": 0.06055779382586,
    "CMYK_M": 0.0169936157763,
    "CMYK_Y": 0,
    "CMYK_K": 0.28384417295456
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1578",
    "Farbtonhilfsbezeichnung": "Lago 30",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "208",
    "Bcolor": "209",
    "Y": 63,
    "L": 83.1765289306641,
    "a": -0.98975348472595,
    "b": -1.74492537975311,
    "C": 2.00608491897583,
    "h": 240.437301635742,
    "CMY_C": 0.20140063762665,
    "CMY_M": 0.1842502951622,
    "CMY_Y": 0.18128341436386,
    "CMYK_C": 0.02457165718079,
    "CMYK_M": 0.0036238192115,
    "CMYK_Y": 0,
    "CMYK_K": 0.18128341436386
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1579",
    "Farbtonhilfsbezeichnung": "Lago 35",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "81",
    "Bcolor": "99",
    "Y": 8,
    "L": 32.7395668029785,
    "a": -5.99216270446777,
    "b": -14.9650554656982,
    "C": 16.1201400756836,
    "h": 248.178329467773,
    "CMY_C": 0.81011068820953,
    "CMY_M": 0.68275856971741,
    "CMY_Y": 0.60992360115051,
    "CMYK_C": 0.51319968700409,
    "CMYK_M": 0.18671974539757,
    "CMYK_Y": 0,
    "CMYK_K": 0.60992360115051
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1580",
    "Farbtonhilfsbezeichnung": "Lago 40",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "106",
    "Bcolor": "122",
    "Y": 14,
    "L": 43.2796745300293,
    "a": -4.66088151931763,
    "b": -12.5675287246704,
    "C": 13.4039764404297,
    "h": 249.651840209961,
    "CMY_C": 0.68336844444275,
    "CMY_M": 0.5861998796463,
    "CMY_Y": 0.5225065946579,
    "CMYK_C": 0.3368881046772,
    "CMYK_M": 0.13339091837406,
    "CMYK_Y": 0,
    "CMYK_K": 0.5225065946579
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1581",
    "Farbtonhilfsbezeichnung": "Lago 45",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "133",
    "Bcolor": "147",
    "Y": 22,
    "L": 54.3868980407715,
    "a": -3.62145733833313,
    "b": -10.8160219192505,
    "C": 11.4061946868897,
    "h": 251.488250732422,
    "CMY_C": 0.55793476104736,
    "CMY_M": 0.479039311409,
    "CMY_Y": 0.42227232456207,
    "CMYK_C": 0.23482073843479,
    "CMYK_M": 0.0982590764761,
    "CMYK_Y": 0,
    "CMYK_K": 0.42227232456207
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1582",
    "Farbtonhilfsbezeichnung": "Lago 50",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "160",
    "Bcolor": "171",
    "Y": 34,
    "L": 64.9990615844727,
    "a": -3.73242926597595,
    "b": -8.17625427246094,
    "C": 8.98788928985596,
    "h": 245.463485717773,
    "CMY_C": 0.44036930799484,
    "CMY_M": 0.37072855234146,
    "CMY_Y": 0.33034926652908,
    "CMYK_C": 0.1642946600914,
    "CMYK_M": 0.06029902398586,
    "CMYK_Y": 0,
    "CMYK_K": 0.33034926652908
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1583",
    "Farbtonhilfsbezeichnung": "Lago 55",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "189",
    "Bcolor": "197",
    "Y": 49,
    "L": 75.6534957885742,
    "a": -3.70826244354248,
    "b": -6.74378395080566,
    "C": 7.69609212875366,
    "h": 241.194549560547,
    "CMY_C": 0.32306379079819,
    "CMY_M": 0.2583070397377,
    "CMY_Y": 0.22711926698685,
    "CMYK_C": 0.12413884699345,
    "CMYK_M": 0.04035263508558,
    "CMYK_Y": 0,
    "CMYK_K": 0.22711926698685
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1584",
    "Farbtonhilfsbezeichnung": "Lago 60",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "216",
    "Bcolor": "220",
    "Y": 67,
    "L": 85.533935546875,
    "a": -2.29411721229553,
    "b": -4.20966577529907,
    "C": 4.79419040679932,
    "h": 241.411193847656,
    "CMY_C": 0.19519406557083,
    "CMY_M": 0.15464156866074,
    "CMY_Y": 0.13770616054535,
    "CMYK_C": 0.06666857749224,
    "CMYK_M": 0.01963995024562,
    "CMYK_Y": 0,
    "CMYK_K": 0.13770616054535
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1585",
    "Farbtonhilfsbezeichnung": "Lago 65",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "89",
    "Bcolor": "116",
    "Y": 9,
    "L": 35.4106025695801,
    "a": -8.92790985107422,
    "b": -21.1903591156006,
    "C": 22.9943237304688,
    "h": 247.153366088867,
    "CMY_C": 0.87681382894516,
    "CMY_M": 0.6508412361145,
    "CMY_Y": 0.54572623968124,
    "CMYK_C": 0.72882831096649,
    "CMYK_M": 0.23139129579067,
    "CMYK_Y": 0,
    "CMYK_K": 0.54572623968124
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1586",
    "Farbtonhilfsbezeichnung": "Lago 75",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "142",
    "Bcolor": "163",
    "Y": 25,
    "L": 57.2963943481445,
    "a": -6.13798570632935,
    "b": -15.3746452331543,
    "C": 16.554594039917,
    "h": 248.236740112305,
    "CMY_C": 0.57307040691376,
    "CMY_M": 0.44306749105453,
    "CMY_Y": 0.36186814308167,
    "CMYK_C": 0.33096963167191,
    "CMYK_M": 0.12724541127682,
    "CMYK_Y": 0,
    "CMYK_K": 0.36186814308167
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1587",
    "Farbtonhilfsbezeichnung": "Lago 80",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "169",
    "Bcolor": "185",
    "Y": 37,
    "L": 67.5105895996094,
    "a": -5.75005531311035,
    "b": -12.3557624816895,
    "C": 13.6282062530518,
    "h": 245.0439453125,
    "CMY_C": 0.45005732774734,
    "CMY_M": 0.33889758586884,
    "CMY_Y": 0.27499973773956,
    "CMYK_C": 0.24145865440369,
    "CMYK_M": 0.08813492953777,
    "CMYK_Y": 0,
    "CMYK_K": 0.27499973773956
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1588",
    "Farbtonhilfsbezeichnung": "Lago 85",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "197",
    "Bcolor": "209",
    "Y": 53,
    "L": 78.1112747192383,
    "a": -4.68324327468872,
    "b": -9.65509128570557,
    "C": 10.7309627532959,
    "h": 244.124099731445,
    "CMY_C": 0.31721389293671,
    "CMY_M": 0.22876071929932,
    "CMY_Y": 0.17978662252426,
    "CMYK_C": 0.16755063831806,
    "CMYK_M": 0.0597089715302,
    "CMYK_Y": 0,
    "CMYK_K": 0.17978662252426
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1589",
    "Farbtonhilfsbezeichnung": "Lago 90",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "222",
    "Bcolor": "229",
    "Y": 71,
    "L": 87.4975433349609,
    "a": -2.86361384391785,
    "b": -6.33408117294312,
    "C": 6.95132112503052,
    "h": 245.672454833984,
    "CMY_C": 0.18662476539612,
    "CMY_M": 0.13100630044937,
    "CMY_Y": 0.10054141283035,
    "CMYK_C": 0.09570574015379,
    "CMYK_M": 0.03387024998665,
    "CMYK_Y": 0,
    "CMYK_K": 0.10054141283035
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1590",
    "Farbtonhilfsbezeichnung": "Lago 95",
    "Farbtonklasse": "04",
    "Rcolor": "4",
    "Gcolor": "100",
    "Bcolor": "136",
    "Y": 11,
    "L": 39.416633605957,
    "a": -10.2548217773438,
    "b": -27.5470504760742,
    "C": 29.3938999176025,
    "h": 249.581420898438,
    "CMY_C": 0.98272579908371,
    "CMY_M": 0.60834145545959,
    "CMY_Y": 0.46564376354218,
    "CMYK_C": 0.96767288446426,
    "CMYK_M": 0.26704600453377,
    "CMYK_Y": 0,
    "CMYK_K": 0.46564376354218
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1591",
    "Farbtonhilfsbezeichnung": "Lago 100",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "125",
    "Bcolor": "157",
    "Y": 18,
    "L": 49.7541580200195,
    "a": -10.0594100952148,
    "b": -23.9556770324707,
    "C": 25.9820365905762,
    "h": 247.221603393555,
    "CMY_C": 0.75489914417267,
    "CMY_M": 0.50884836912155,
    "CMY_Y": 0.3831000328064,
    "CMYK_C": 0.60268944501877,
    "CMYK_M": 0.20383910834789,
    "CMYK_Y": 0,
    "CMYK_K": 0.3831000328064
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1592",
    "Farbtonhilfsbezeichnung": "Lago 105",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "151",
    "Bcolor": "181",
    "Y": 28,
    "L": 60.1100234985352,
    "a": -8.15069580078125,
    "b": -21.4325542449951,
    "C": 22.9300727844238,
    "h": 249.178436279297,
    "CMY_C": 0.60033625364304,
    "CMY_M": 0.4082282781601,
    "CMY_Y": 0.29122877120972,
    "CMYK_C": 0.43611741065979,
    "CMYK_M": 0.16507372260094,
    "CMYK_Y": 0,
    "CMYK_K": 0.29122877120972
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1593",
    "Farbtonhilfsbezeichnung": "Lago 110",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "177",
    "Bcolor": "201",
    "Y": 41,
    "L": 70.3131408691406,
    "a": -7.25605630874634,
    "b": -16.9484424591064,
    "C": 18.4363784790039,
    "h": 246.823013305664,
    "CMY_C": 0.45777606964111,
    "CMY_M": 0.30465495586395,
    "CMY_Y": 0.21287721395493,
    "CMYK_C": 0.31113171577454,
    "CMYK_M": 0.11659901589155,
    "CMYK_Y": 0,
    "CMYK_K": 0.21287721395493
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1594",
    "Farbtonhilfsbezeichnung": "Lago 115",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "203",
    "Bcolor": "221",
    "Y": 57,
    "L": 80.1050338745117,
    "a": -6.16445302963257,
    "b": -12.9310922622681,
    "C": 14.3252792358398,
    "h": 244.512130737305,
    "CMY_C": 0.32366555929184,
    "CMY_M": 0.20283883810043,
    "CMY_Y": 0.13453650474548,
    "CMYK_C": 0.21852920949459,
    "CMYK_M": 0.07891994714737,
    "CMYK_Y": 0,
    "CMYK_K": 0.13453650474548
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1595",
    "Farbtonhilfsbezeichnung": "Lago 120",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "230",
    "Bcolor": "240",
    "Y": 76,
    "L": 90.0252151489258,
    "a": -4.3813157081604,
    "b": -8.00754737854004,
    "C": 9.12780094146729,
    "h": 241.314804077148,
    "CMY_C": 0.17853564023972,
    "CMY_M": 0.09893029928207,
    "CMY_Y": 0.06027263402939,
    "CMYK_C": 0.12584820389748,
    "CMYK_M": 0.04113710671663,
    "CMYK_Y": 0,
    "CMYK_K": 0.06027263402939
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1596",
    "Farbtonhilfsbezeichnung": "Saphir 5",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "74",
    "Bcolor": "86",
    "Y": 7,
    "L": 31.2621936798096,
    "a": -0.54685705900192,
    "b": -8.60579013824463,
    "C": 8.62314796447754,
    "h": 266.364013671875,
    "CMY_C": 0.74411749839783,
    "CMY_M": 0.70806759595871,
    "CMY_Y": 0.66211402416229,
    "CMYK_C": 0.24269570410252,
    "CMYK_M": 0.13600319623947,
    "CMYK_Y": 0,
    "CMYK_K": 0.66211402416229
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1597",
    "Farbtonhilfsbezeichnung": "Saphir 10",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "99",
    "Bcolor": "111",
    "Y": 12,
    "L": 41.3736953735352,
    "a": -0.59604090452194,
    "b": -8.5414514541626,
    "C": 8.56222248077393,
    "h": 266.008239746094,
    "CMY_C": 0.65067136287689,
    "CMY_M": 0.61361908912659,
    "CMY_Y": 0.56645941734314,
    "CMYK_C": 0.1942423582077,
    "CMYK_M": 0.10877798497677,
    "CMYK_Y": 0,
    "CMYK_K": 0.56645941734314
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1598",
    "Farbtonhilfsbezeichnung": "Saphir 15",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "124",
    "Bcolor": "133",
    "Y": 20,
    "L": 51.6182632446289,
    "a": -0.7217230796814,
    "b": -6.59749317169189,
    "C": 6.63685178756714,
    "h": 263.757019042969,
    "CMY_C": 0.54518306255341,
    "CMY_M": 0.51396691799164,
    "CMY_Y": 0.47800552845001,
    "CMYK_C": 0.12869395315647,
    "CMYK_M": 0.06889227777719,
    "CMYK_Y": 0,
    "CMYK_K": 0.47800552845001
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1599",
    "Farbtonhilfsbezeichnung": "Saphir 20",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "152",
    "Bcolor": "160",
    "Y": 31,
    "L": 62.5323486328125,
    "a": -0.61734902858734,
    "b": -5.64083385467529,
    "C": 5.67451572418213,
    "h": 263.754241943359,
    "CMY_C": 0.43102037906647,
    "CMY_M": 0.40375638008118,
    "CMY_Y": 0.37316125631332,
    "CMYK_C": 0.09230304509401,
    "CMYK_M": 0.04880860447884,
    "CMYK_Y": 0,
    "CMYK_K": 0.37316125631332
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1600",
    "Farbtonhilfsbezeichnung": "Saphir 25",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "179",
    "Bcolor": "185",
    "Y": 45,
    "L": 72.7509765625,
    "a": -0.6257905960083,
    "b": -4.31396198272705,
    "C": 4.35911464691162,
    "h": 261.746154785156,
    "CMY_C": 0.31974637508392,
    "CMY_M": 0.29692554473877,
    "CMY_Y": 0.27506297826767,
    "CMYK_C": 0.06163762509823,
    "CMYK_M": 0.03015788458288,
    "CMYK_Y": 0,
    "CMYK_K": 0.27506297826767
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1601",
    "Farbtonhilfsbezeichnung": "Saphir 30",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "210",
    "Bcolor": "212",
    "Y": 64,
    "L": 84.018798828125,
    "a": -0.6652135848999,
    "b": -2.35819387435913,
    "C": 2.45022201538086,
    "h": 254.246978759766,
    "CMY_C": 0.19181162118912,
    "CMY_M": 0.17559468746185,
    "CMY_Y": 0.16759842634201,
    "CMYK_C": 0.02908835746348,
    "CMYK_M": 0.00960625428706,
    "CMYK_Y": 0,
    "CMYK_K": 0.16759842634201
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1602",
    "Farbtonhilfsbezeichnung": "Saphir 35",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "81",
    "Bcolor": "104",
    "Y": 8,
    "L": 33.7246551513672,
    "a": -0.9533696770668,
    "b": -16.0894432067871,
    "C": 16.1176643371582,
    "h": 266.608947753906,
    "CMY_C": 0.75961339473724,
    "CMY_M": 0.68245023488998,
    "CMY_Y": 0.59317541122437,
    "CMYK_C": 0.40911486744881,
    "CMYK_M": 0.21944303810596,
    "CMYK_Y": 0,
    "CMYK_K": 0.59317541122437
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1603",
    "Farbtonhilfsbezeichnung": "Saphir 40",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "104",
    "Bcolor": "123",
    "Y": 14,
    "L": 43.2563896179199,
    "a": -1.35289144515991,
    "b": -13.391752243042,
    "C": 13.4599161148071,
    "h": 264.231323242188,
    "CMY_C": 0.65939819812775,
    "CMY_M": 0.59259462356567,
    "CMY_Y": 0.51714712381363,
    "CMYK_C": 0.29460543394089,
    "CMYK_M": 0.15625360608101,
    "CMYK_Y": 0,
    "CMYK_K": 0.51714712381363
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1604",
    "Farbtonhilfsbezeichnung": "Saphir 45",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "131",
    "Bcolor": "148",
    "Y": 23,
    "L": 54.277099609375,
    "a": -1.233025431633,
    "b": -11.2883796691895,
    "C": 11.3555212020874,
    "h": 263.766326904297,
    "CMY_C": 0.54144805669785,
    "CMY_M": 0.4849219918251,
    "CMY_Y": 0.41999387741089,
    "CMYK_C": 0.20940154790878,
    "CMYK_M": 0.11194384098053,
    "CMYK_Y": 0,
    "CMYK_K": 0.41999387741089
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1605",
    "Farbtonhilfsbezeichnung": "Saphir 50",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "158",
    "Bcolor": "170",
    "Y": 34,
    "L": 64.5557632446289,
    "a": -0.61643570661545,
    "b": -8.54483127593994,
    "C": 8.56703758239746,
    "h": 265.873748779297,
    "CMY_C": 0.42120027542114,
    "CMY_M": 0.38194066286087,
    "CMY_Y": 0.33210110664368,
    "CMYK_C": 0.13340218365192,
    "CMYK_M": 0.07462140917778,
    "CMYK_Y": 0,
    "CMYK_K": 0.33210110664368
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1606",
    "Farbtonhilfsbezeichnung": "Saphir 55",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "186",
    "Bcolor": "196",
    "Y": 49,
    "L": 75.2804107666016,
    "a": -0.63139379024506,
    "b": -6.47023868560791,
    "C": 6.50097274780273,
    "h": 264.426483154297,
    "CMY_C": 0.30091917514801,
    "CMY_M": 0.26925283670425,
    "CMY_Y": 0.23271143436432,
    "CMYK_C": 0.08889450877905,
    "CMYK_M": 0.04762406647205,
    "CMYK_Y": 0,
    "CMYK_K": 0.23271143436432
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1607",
    "Farbtonhilfsbezeichnung": "Saphir 60",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 67,
    "L": 85.6575775146484,
    "a": -0.9002873301506,
    "b": -3.82175374031067,
    "C": 3.92636203765869,
    "h": 256.744537353516,
    "CMY_C": 0.18107223510742,
    "CMY_M": 0.15660899877548,
    "CMY_Y": 0.13900208473206,
    "CMYK_C": 0.04886208102107,
    "CMYK_M": 0.0204494278878,
    "CMYK_Y": 0,
    "CMYK_K": 0.13900208473206
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1608",
    "Farbtonhilfsbezeichnung": "Saphir 65",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "90",
    "Bcolor": "122",
    "Y": 10,
    "L": 36.8955154418945,
    "a": -2.94575595855713,
    "b": -22.7615833282471,
    "C": 22.9514083862305,
    "h": 262.625885009766,
    "CMY_C": 0.79265117645264,
    "CMY_M": 0.64691686630249,
    "CMY_Y": 0.52078664302826,
    "CMYK_C": 0.56731420755386,
    "CMYK_M": 0.26320263743401,
    "CMYK_Y": 0,
    "CMYK_K": 0.52078664302826
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1609",
    "Farbtonhilfsbezeichnung": "Saphir 70",
    "Farbtonklasse": "04",
    "Rcolor": "86",
    "Gcolor": "114",
    "Bcolor": "144",
    "Y": 16,
    "L": 47.1439895629883,
    "a": -1.87604606151581,
    "b": -20.126594543457,
    "C": 20.2138404846191,
    "h": 264.674713134766,
    "CMY_C": 0.66126936674118,
    "CMY_M": 0.55156362056732,
    "CMY_Y": 0.43449747562408,
    "CMYK_C": 0.4010095000267,
    "CMYK_M": 0.20701259374619,
    "CMYK_Y": 0,
    "CMYK_K": 0.43449747562408
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1610",
    "Farbtonhilfsbezeichnung": "Saphir 75",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "139",
    "Bcolor": "164",
    "Y": 25,
    "L": 57.0317611694336,
    "a": -1.7535103559494,
    "b": -16.2345733642578,
    "C": 16.3289985656738,
    "h": 263.835327148438,
    "CMY_C": 0.5407047867775,
    "CMY_M": 0.45443546772003,
    "CMY_Y": 0.35838693380356,
    "CMYK_C": 0.2841554582119,
    "CMYK_M": 0.14969852566719,
    "CMYK_Y": 0,
    "CMYK_K": 0.35838693380356
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1611",
    "Farbtonhilfsbezeichnung": "Saphir 80",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "168",
    "Bcolor": "189",
    "Y": 38,
    "L": 68.2901992797852,
    "a": -1.37591087818146,
    "b": -13.1330461502075,
    "C": 13.2049245834351,
    "h": 264.019104003906,
    "CMY_C": 0.40774178504944,
    "CMY_M": 0.33980745077133,
    "CMY_Y": 0.26078379154205,
    "CMYK_C": 0.19880245625973,
    "CMYK_M": 0.10690195858479,
    "CMYK_Y": 0,
    "CMYK_K": 0.26078379154205
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1612",
    "Farbtonhilfsbezeichnung": "Saphir 85",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "194",
    "Bcolor": "209",
    "Y": 53,
    "L": 78.0000762939453,
    "a": -1.34778892993927,
    "b": -9.55580997467041,
    "C": 9.650390625,
    "h": 261.971740722656,
    "CMY_C": 0.28983801603317,
    "CMY_M": 0.23741883039474,
    "CMY_Y": 0.1813188791275,
    "CMYK_C": 0.13255360722542,
    "CMYK_M": 0.06852479279041,
    "CMYK_Y": 0,
    "CMYK_K": 0.1813188791275
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1613",
    "Farbtonhilfsbezeichnung": "Saphir 90",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "222",
    "Bcolor": "229",
    "Y": 72,
    "L": 87.8642883300781,
    "a": -1.22764945030212,
    "b": -5.52626132965088,
    "C": 5.66097927093506,
    "h": 257.475219726563,
    "CMY_C": 0.16590344905853,
    "CMY_M": 0.13096469640732,
    "CMY_Y": 0.10220491886139,
    "CMYK_C": 0.07094996422529,
    "CMYK_M": 0.03203378990293,
    "CMYK_Y": 0,
    "CMYK_K": 0.10220491886139
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1614",
    "Farbtonhilfsbezeichnung": "Saphir 95",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "96",
    "Bcolor": "139",
    "Y": 11,
    "L": 39.4380950927734,
    "a": -2.23423957824707,
    "b": -29.1866760253906,
    "C": 29.272066116333,
    "h": 265.622528076172,
    "CMY_C": 0.815902531147,
    "CMY_M": 0.62182748317719,
    "CMY_Y": 0.45438826084137,
    "CMYK_C": 0.66258519887924,
    "CMYK_M": 0.30688345432281,
    "CMYK_Y": 0,
    "CMYK_K": 0.45438826084137
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1615",
    "Farbtonhilfsbezeichnung": "Saphir 100",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "121",
    "Bcolor": "160",
    "Y": 18,
    "L": 49.5272827148438,
    "a": -1.78054821491241,
    "b": -26.0348796844482,
    "C": 26.0956954956055,
    "h": 266.087585449219,
    "CMY_C": 0.6741915345192,
    "CMY_M": 0.52618086338043,
    "CMY_Y": 0.37101680040359,
    "CMYK_C": 0.48200768232346,
    "CMYK_M": 0.2466903179884,
    "CMYK_Y": 0,
    "CMYK_K": 0.37101680040359
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1616",
    "Farbtonhilfsbezeichnung": "Saphir 105",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "149",
    "Bcolor": "182",
    "Y": 29,
    "L": 60.4294624328613,
    "a": -2.21590423583984,
    "b": -21.6929206848145,
    "C": 21.8058032989502,
    "h": 264.167541503906,
    "CMY_C": 0.53890788555145,
    "CMY_M": 0.41690903902054,
    "CMY_Y": 0.28550726175308,
    "CMYK_C": 0.35465806722641,
    "CMYK_M": 0.18390917778015,
    "CMYK_Y": 0,
    "CMYK_K": 0.28550726175308
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1617",
    "Farbtonhilfsbezeichnung": "Saphir 110",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "172",
    "Bcolor": "197",
    "Y": 41,
    "L": 69.2281494140625,
    "a": -2.17095565795898,
    "b": -16.619104385376,
    "C": 16.7603015899658,
    "h": 262.557586669922,
    "CMY_C": 0.42081695795059,
    "CMY_M": 0.32705980539322,
    "CMY_Y": 0.22639161348343,
    "CMYK_C": 0.25132268667221,
    "CMYK_M": 0.13012810051441,
    "CMYK_Y": 0,
    "CMYK_K": 0.22639161348343
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1618",
    "Farbtonhilfsbezeichnung": "Saphir 115",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "199",
    "Bcolor": "217",
    "Y": 57,
    "L": 79.415885925293,
    "a": -1.79808044433594,
    "b": -12.0999851226807,
    "C": 12.2328548431397,
    "h": 261.547607421875,
    "CMY_C": 0.28909456729889,
    "CMY_M": 0.2202712893486,
    "CMY_Y": 0.14760828018188,
    "CMYK_C": 0.1659874022007,
    "CMYK_M": 0.08524602651596,
    "CMYK_Y": 0,
    "CMYK_K": 0.14760828018188
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1619",
    "Farbtonhilfsbezeichnung": "Saphir 120",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "227",
    "Bcolor": "238",
    "Y": 76,
    "L": 89.6196060180664,
    "a": -0.91272467374802,
    "b": -7.55771684646606,
    "C": 7.61263084411621,
    "h": 263.113891601563,
    "CMY_C": 0.15183925628662,
    "CMY_M": 0.11159574985504,
    "CMY_Y": 0.06769025325775,
    "CMYK_C": 0.09025863558054,
    "CMYK_M": 0.04709324985743,
    "CMYK_Y": 0,
    "CMYK_K": 0.06769025325775
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1620",
    "Farbtonhilfsbezeichnung": "Velvet 5",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "68",
    "Bcolor": "83",
    "Y": 6,
    "L": 29.6491413116455,
    "a": 4.47515296936035,
    "b": -9.25946998596191,
    "C": 10.284200668335,
    "h": 295.794738769531,
    "CMY_C": 0.72579312324524,
    "CMY_M": 0.7323859333992,
    "CMY_Y": 0.67266339063644,
    "CMYK_C": 0.16230916976929,
    "CMYK_M": 0.18244993686676,
    "CMYK_Y": 0,
    "CMYK_K": 0.67266339063644
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1621",
    "Farbtonhilfsbezeichnung": "Velvet 10",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "94",
    "Bcolor": "108",
    "Y": 12,
    "L": 40.4695930480957,
    "a": 4.41938209533691,
    "b": -8.22328662872314,
    "C": 9.33559799194336,
    "h": 298.254608154297,
    "CMY_C": 0.62187093496323,
    "CMY_M": 0.63269114494324,
    "CMY_Y": 0.5767148733139,
    "CMYK_C": 0.10668001323938,
    "CMYK_M": 0.13224247097969,
    "CMYK_Y": 0,
    "CMYK_K": 0.5767148733139
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1622",
    "Farbtonhilfsbezeichnung": "Velvet 15",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "121",
    "Bcolor": "132",
    "Y": 20,
    "L": 51.153247833252,
    "a": 3.34166884422302,
    "b": -6.81815147399902,
    "C": 7.59301900863647,
    "h": 296.110107421875,
    "CMY_C": 0.52056062221527,
    "CMY_M": 0.52720749378204,
    "CMY_Y": 0.48075950145721,
    "CMYK_C": 0.07665257155895,
    "CMYK_M": 0.08945371955633,
    "CMYK_Y": 0,
    "CMYK_K": 0.48075950145721
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1623",
    "Farbtonhilfsbezeichnung": "Velvet 20",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "149",
    "Bcolor": "160",
    "Y": 30,
    "L": 62.0069046020508,
    "a": 2.86385655403137,
    "b": -6.1956467628479,
    "C": 6.82551908493042,
    "h": 294.80810546875,
    "CMY_C": 0.41200190782547,
    "CMY_M": 0.4167138338089,
    "CMY_Y": 0.37439775466919,
    "CMYK_C": 0.06010872498155,
    "CMYK_M": 0.06764055043459,
    "CMYK_Y": 0,
    "CMYK_K": 0.37439775466919
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1624",
    "Farbtonhilfsbezeichnung": "Velvet 25",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "180",
    "Bcolor": "185",
    "Y": 45,
    "L": 73.3254699707031,
    "a": 1.52092385292053,
    "b": -3.28858423233032,
    "C": 3.62325763702393,
    "h": 294.819885253906,
    "CMY_C": 0.29341262578964,
    "CMY_M": 0.29597824811935,
    "CMY_Y": 0.27592778205872,
    "CMYK_C": 0.02414792776108,
    "CMYK_M": 0.02769125252962,
    "CMYK_Y": 0,
    "CMYK_K": 0.27592778205872
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1625",
    "Farbtonhilfsbezeichnung": "Velvet 30",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "208",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.482421875,
    "a": 0.872309923172,
    "b": -2.16004109382629,
    "C": 2.32952833175659,
    "h": 291.990814208984,
    "CMY_C": 0.18483805656433,
    "CMY_M": 0.18511211872101,
    "CMY_Y": 0.1746888756752,
    "CMYK_C": 0.01229740027338,
    "CMYK_M": 0.01262947078794,
    "CMYK_Y": 0,
    "CMYK_K": 0.1746888756752
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1626",
    "Farbtonhilfsbezeichnung": "Velvet 35",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "69",
    "Bcolor": "95",
    "Y": 7,
    "L": 30.5273361206055,
    "a": 7.19312572479248,
    "b": -15.3100061416626,
    "C": 16.9155941009521,
    "h": 295.165618896484,
    "CMY_C": 0.72187447547913,
    "CMY_M": 0.72828161716461,
    "CMY_Y": 0.62778162956238,
    "CMYK_C": 0.2527893781662,
    "CMYK_M": 0.2700027525425,
    "CMYK_Y": 0,
    "CMYK_K": 0.62778162956238
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1627",
    "Farbtonhilfsbezeichnung": "Velvet 40",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "99",
    "Bcolor": "122",
    "Y": 14,
    "L": 42.9829978942871,
    "a": 6.80673551559448,
    "b": -13.0516128540039,
    "C": 14.7199268341065,
    "h": 297.543151855469,
    "CMY_C": 0.59823620319366,
    "CMY_M": 0.61248970031738,
    "CMY_Y": 0.52125024795532,
    "CMYK_C": 0.16080625355244,
    "CMYK_M": 0.19057859480381,
    "CMYK_Y": 0,
    "CMYK_K": 0.52125024795532
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1628",
    "Farbtonhilfsbezeichnung": "Velvet 50",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "153",
    "Bcolor": "169",
    "Y": 34,
    "L": 63.9125595092773,
    "a": 4.27947330474854,
    "b": -8.69060325622559,
    "C": 9.68712902069092,
    "h": 296.216796875,
    "CMY_C": 0.39054584503174,
    "CMY_M": 0.39952653646469,
    "CMY_Y": 0.33727473020554,
    "CMYK_C": 0.0803819000721,
    "CMYK_M": 0.09393305331469,
    "CMYK_Y": 0,
    "CMYK_K": 0.33727473020554
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1629",
    "Farbtonhilfsbezeichnung": "Velvet 45",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "126",
    "Bcolor": "146",
    "Y": 22,
    "L": 53.641731262207,
    "a": 5.57649755477905,
    "b": -11.234375,
    "C": 12.5422687530518,
    "h": 296.398803710938,
    "CMY_C": 0.49515569210052,
    "CMY_M": 0.50609934329987,
    "CMY_Y": 0.42612677812576,
    "CMYK_C": 0.12028600275517,
    "CMYK_M": 0.13935580849648,
    "CMYK_Y": 0,
    "CMYK_K": 0.42612677812576
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1630",
    "Farbtonhilfsbezeichnung": "Velvet 55",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "184",
    "Bcolor": "194",
    "Y": 49,
    "L": 75.3085021972656,
    "a": 2.62577962875366,
    "b": -5.58444166183472,
    "C": 6.1709566116333,
    "h": 295.182708740234,
    "CMY_C": 0.27177029848099,
    "CMY_M": 0.27668708562851,
    "CMY_Y": 0.2383074760437,
    "CMYK_C": 0.04393219202757,
    "CMYK_M": 0.05038727447391,
    "CMYK_Y": 0,
    "CMYK_K": 0.2383074760437
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1631",
    "Farbtonhilfsbezeichnung": "Velvet 60",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "212",
    "Bcolor": "217",
    "Y": 67,
    "L": 85.0313873291016,
    "a": 1.71025383472443,
    "b": -3.26225423812866,
    "C": 3.68337774276733,
    "h": 297.666015625,
    "CMY_C": 0.16513752937317,
    "CMY_M": 0.16978144645691,
    "CMY_Y": 0.14961892366409,
    "CMYK_C": 0.01824900135398,
    "CMYK_M": 0.02370998449624,
    "CMYK_Y": 0,
    "CMYK_K": 0.14961892366409
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1632",
    "Farbtonhilfsbezeichnung": "Velvet 65",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "76",
    "Bcolor": "111",
    "Y": 8,
    "L": 33.8332481384277,
    "a": 9.62687587738037,
    "b": -20.68528175354,
    "C": 22.815731048584,
    "h": 294.957153320313,
    "CMY_C": 0.69658815860748,
    "CMY_M": 0.70171129703522,
    "CMY_Y": 0.56290578842163,
    "CMYK_C": 0.30584338307381,
    "CMYK_M": 0.31756427884102,
    "CMYK_Y": 0,
    "CMYK_K": 0.56290578842163
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1633",
    "Farbtonhilfsbezeichnung": "Velvet 70",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "107",
    "Bcolor": "139",
    "Y": 16,
    "L": 46.4798812866211,
    "a": 8.21829319000244,
    "b": -17.8374843597412,
    "C": 19.6396579742432,
    "h": 294.737030029297,
    "CMY_C": 0.57269263267517,
    "CMY_M": 0.58037352561951,
    "CMY_Y": 0.4552658200264,
    "CMYK_C": 0.2155671864748,
    "CMYK_M": 0.2296674400568,
    "CMYK_Y": 0,
    "CMYK_K": 0.4552658200264
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1634",
    "Farbtonhilfsbezeichnung": "Velvet 75",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "135",
    "Bcolor": "162",
    "Y": 25,
    "L": 57.156566619873,
    "a": 6.6964259147644,
    "b": -14.8790493011475,
    "C": 16.3165016174316,
    "h": 294.23046875,
    "CMY_C": 0.46515238285065,
    "CMY_M": 0.47217392921448,
    "CMY_Y": 0.36538010835648,
    "CMYK_C": 0.15721580386162,
    "CMYK_M": 0.16827997565269,
    "CMYK_Y": 0,
    "CMYK_K": 0.36538010835648
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1635",
    "Farbtonhilfsbezeichnung": "Velvet 80",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "160",
    "Bcolor": "181",
    "Y": 37,
    "L": 66.5543899536133,
    "a": 5.69316959381104,
    "b": -11.682975769043,
    "C": 12.9963111877441,
    "h": 295.980194091797,
    "CMY_C": 0.36331760883331,
    "CMY_M": 0.37443590164185,
    "CMY_Y": 0.28858518600464,
    "CMYK_C": 0.10504760593176,
    "CMYK_M": 0.12067603319883,
    "CMYK_Y": 0,
    "CMYK_K": 0.28858518600464
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1636",
    "Farbtonhilfsbezeichnung": "Velvet 85",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "190",
    "Bcolor": "204",
    "Y": 53,
    "L": 77.4115447998047,
    "a": 3.46160650253296,
    "b": -8.00920486450195,
    "C": 8.72525501251221,
    "h": 293.374176025391,
    "CMY_C": 0.25145483016968,
    "CMY_M": 0.25533658266068,
    "CMY_Y": 0.19821125268936,
    "CMYK_C": 0.06640598922968,
    "CMYK_M": 0.0712473616004,
    "CMYK_Y": 0,
    "CMYK_K": 0.19821125268936
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1637",
    "Farbtonhilfsbezeichnung": "Velvet 90",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "218",
    "Bcolor": "226",
    "Y": 71,
    "L": 87.4466171264648,
    "a": 2.42647290229797,
    "b": -4.33658313751221,
    "C": 4.96927785873413,
    "h": 299.228576660156,
    "CMY_C": 0.13667261600494,
    "CMY_M": 0.14456522464752,
    "CMY_Y": 0.11508530378342,
    "CMYK_C": 0.02439479529858,
    "CMYK_M": 0.03331385552883,
    "CMYK_Y": 0,
    "CMYK_K": 0.11508530378342
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1638",
    "Farbtonhilfsbezeichnung": "Velvet 95",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "83",
    "Bcolor": "132",
    "Y": 10,
    "L": 37.1988868713379,
    "a": 12.7521419525147,
    "b": -27.9603862762451,
    "C": 30.7310962677002,
    "h": 294.516723632813,
    "CMY_C": 0.67601752281189,
    "CMY_M": 0.67497110366821,
    "CMY_Y": 0.48377805948257,
    "CMYK_C": 0.37239691615105,
    "CMYK_M": 0.3703698515892,
    "CMYK_Y": 0,
    "CMYK_K": 0.48377805948257
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1639",
    "Farbtonhilfsbezeichnung": "Velvet 100",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "111",
    "Bcolor": "153",
    "Y": 18,
    "L": 48.4549713134766,
    "a": 10.4733209609985,
    "b": -23.4301357269287,
    "C": 25.6644058227539,
    "h": 294.084747314453,
    "CMY_C": 0.56041216850281,
    "CMY_M": 0.56431567668915,
    "CMY_Y": 0.39829218387604,
    "CMYK_C": 0.26943308115005,
    "CMYK_M": 0.27592045068741,
    "CMYK_Y": 0,
    "CMYK_K": 0.39829218387604
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1640",
    "Farbtonhilfsbezeichnung": "Velvet 105",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "139",
    "Bcolor": "173",
    "Y": 29,
    "L": 59.4130630493164,
    "a": 9.09693908691406,
    "b": -18.1047630310059,
    "C": 20.2617073059082,
    "h": 296.677734375,
    "CMY_C": 0.43672227859497,
    "CMY_M": 0.45381814241409,
    "CMY_Y": 0.31965667009354,
    "CMYK_C": 0.17206843197346,
    "CMYK_M": 0.19719672203064,
    "CMYK_Y": 0,
    "CMYK_K": 0.31965667009354
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1641",
    "Farbtonhilfsbezeichnung": "Velvet 110",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "166",
    "Bcolor": "194",
    "Y": 41,
    "L": 69.1301422119141,
    "a": 7.02732515335083,
    "b": -14.8066120147705,
    "C": 16.3896026611328,
    "h": 295.389343261719,
    "CMY_C": 0.3379835486412,
    "CMY_M": 0.3496196269989,
    "CMY_Y": 0.23915189504623,
    "CMYK_C": 0.12989670038223,
    "CMYK_M": 0.1451902538538,
    "CMYK_Y": 0,
    "CMYK_K": 0.23915189504623
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1642",
    "Farbtonhilfsbezeichnung": "Velvet 115",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "194",
    "Bcolor": "212",
    "Y": 56,
    "L": 79.2510528564453,
    "a": 4.88989305496216,
    "b": -9.58649921417236,
    "C": 10.7615995407104,
    "h": 297.025268554688,
    "CMY_C": 0.22622781991959,
    "CMY_M": 0.238396525383,
    "CMY_Y": 0.1667006611824,
    "CMYK_C": 0.07143550366163,
    "CMYK_M": 0.08603854477406,
    "CMYK_Y": 0,
    "CMYK_K": 0.1667006611824
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1643",
    "Farbtonhilfsbezeichnung": "Velvet 120",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "223",
    "Bcolor": "230",
    "Y": 76,
    "L": 89.1004486083984,
    "a": 2.76605582237244,
    "b": -4.40003347396851,
    "C": 5.19724559783936,
    "h": 302.1552734375,
    "CMY_C": 0.11587679386139,
    "CMY_M": 0.12706059217453,
    "CMY_Y": 0.09626811742783,
    "CMYK_C": 0.02169744856656,
    "CMYK_M": 0.03407257795334,
    "CMYK_Y": 0,
    "CMYK_K": 0.09626811742783
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1644",
    "Farbtonhilfsbezeichnung": "Lachs 90",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "190",
    "Y": 71,
    "L": 87.6333847045898,
    "a": 15.8118867874146,
    "b": 15.1230697631836,
    "C": 21.8797397613525,
    "h": 43.7244262695313,
    "CMY_C": 0,
    "CMY_M": 0.18197786808014,
    "CMY_Y": 0.2537984251976,
    "CMYK_C": 0,
    "CMYK_M": 0.18197786808014,
    "CMYK_Y": 0.2537984251976,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1646",
    "Farbtonhilfsbezeichnung": "Onyx 235",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "122",
    "Y": 62,
    "L": 83.3542327880859,
    "a": 16.7964782714844,
    "b": 44.9593162536621,
    "C": 47.9943923950195,
    "h": 69.5146713256836,
    "CMY_C": 0,
    "CMY_M": 0.23760974407196,
    "CMY_Y": 0.52115905284882,
    "CMYK_C": 0,
    "CMYK_M": 0.23760974407196,
    "CMYK_Y": 0.52115905284882,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1648",
    "Farbtonhilfsbezeichnung": "Aprico 170",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "193",
    "Bcolor": "163",
    "Y": 61,
    "L": 82.9202423095703,
    "a": 19.0835819244385,
    "b": 23.0701999664307,
    "C": 29.9402275085449,
    "h": 50.4025764465332,
    "CMY_C": 0,
    "CMY_M": 0.24428772926331,
    "CMY_Y": 0.36127066612244,
    "CMYK_C": 0,
    "CMYK_M": 0.24428772926331,
    "CMYK_Y": 0.36127066612244,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1649",
    "Farbtonhilfsbezeichnung": "Siena 180",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "152",
    "Y": 68,
    "L": 85.4695434570313,
    "a": 15.0990266799927,
    "b": 32.3070182800293,
    "C": 35.6612396240234,
    "h": 64.9504699707031,
    "CMY_C": 0,
    "CMY_M": 0.20766949653625,
    "CMY_Y": 0.4038633108139,
    "CMYK_C": 0,
    "CMYK_M": 0.20766949653625,
    "CMYK_Y": 0.4038633108139,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1650",
    "Farbtonhilfsbezeichnung": "Lago 70",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "118",
    "Bcolor": "141",
    "Y": 16,
    "L": 47.6103820800781,
    "a": -7.49461698532104,
    "b": -17.2985992431641,
    "C": 18.8523426055908,
    "h": 246.575332641602,
    "CMY_C": 0.69480586051941,
    "CMY_M": 0.53707575798035,
    "CMY_Y": 0.44874000549316,
    "CMYK_C": 0.44636988639832,
    "CMYK_M": 0.16024336218834,
    "CMYK_Y": 0,
    "CMYK_K": 0.44874000549316
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1651",
    "Farbtonhilfsbezeichnung": "Citrus 110",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "121",
    "Y": 79,
    "L": 90.0718460083008,
    "a": -1.91098415851593,
    "b": 53.4967269897461,
    "C": 53.5308494567871,
    "h": 92.0458221435547,
    "CMY_C": 0.00015938282013,
    "CMY_M": 0.11778771877289,
    "CMY_Y": 0.52574074268341,
    "CMYK_C": 0,
    "CMYK_M": 0.11764708906412,
    "CMYK_Y": 0.52566516399384,
    "CMYK_K": 0.00015938282013
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1652",
    "Farbtonhilfsbezeichnung": "Aprico 160",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "143",
    "Bcolor": "101",
    "Y": 38,
    "L": 68.2982177734375,
    "a": 30.9561328887939,
    "b": 36.3160209655762,
    "C": 47.7193412780762,
    "h": 49.5554008483887,
    "CMY_C": 0.07866036891937,
    "CMY_M": 0.43746316432953,
    "CMY_Y": 0.60218238830566,
    "CMYK_C": 0,
    "CMYK_M": 0.3894359767437,
    "CMYK_Y": 0.56821829080582,
    "CMYK_K": 0.07866036891937
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1653",
    "Farbtonhilfsbezeichnung": "Curry 60",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "239",
    "Bcolor": "217",
    "Y": 86,
    "L": 94.6724243164062,
    "a": 0.13052785396576,
    "b": 10.6926584243774,
    "C": 10.6934547424316,
    "h": 89.3006134033203,
    "CMY_C": 0.02473449707031,
    "CMY_M": 0.06275671720505,
    "CMY_Y": 0.14718341827393,
    "CMYK_C": 0,
    "CMYK_M": 0.03898653388023,
    "CMYK_Y": 0.1255544424057,
    "CMYK_K": 0.02473449707031
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1654",
    "Farbtonhilfsbezeichnung": "Coelin 60",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "237",
    "Bcolor": "236",
    "Y": 82.5849838256836,
    "L": 92.8324356079102,
    "a": -3.5912721157074,
    "b": -1.87632179260254,
    "C": 4.05189085006714,
    "h": 207.585586547852,
    "CMY_C": 0.1166735291481,
    "CMY_M": 0.07117372751236,
    "CMY_Y": 0.07431054115295,
    "CMYK_C": 0.04898634180427,
    "CMYK_M": 0,
    "CMYK_Y": 0.00337718008086,
    "CMYK_K": 0.07117372751236
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1655",
    "Farbtonhilfsbezeichnung": "Lazur 180",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "187",
    "Bcolor": "213",
    "Y": 48,
    "L": 74.5596923828125,
    "a": -3.87714719772339,
    "b": -17.0454349517822,
    "C": 17.4808216094971,
    "h": 257.185546875,
    "CMY_C": 0.38198453187943,
    "CMY_M": 0.26646387577057,
    "CMY_Y": 0.16563355922699,
    "CMYK_C": 0.25929969549179,
    "CMYK_M": 0.12084656208754,
    "CMYK_Y": 0,
    "CMYK_K": 0.16563355922699
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1656",
    "Farbtonhilfsbezeichnung": "Verona 140",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "171",
    "Bcolor": "171",
    "Y": 34,
    "L": 65.138298034668,
    "a": -24.719762802124,
    "b": -8.27714920043945,
    "C": 26.0687141418457,
    "h": 198.512573242188,
    "CMY_C": 0.65035581588745,
    "CMY_M": 0.32904696464539,
    "CMY_Y": 0.33041363954544,
    "CMYK_C": 0.47888427972794,
    "CMYK_M": 0,
    "CMYK_Y": 0.00203691585921,
    "CMYK_K": 0.32904696464539
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1657",
    "Farbtonhilfsbezeichnung": "Aprico 165",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "170",
    "Bcolor": "132",
    "Y": 50,
    "L": 76.4473724365234,
    "a": 25.9511756896973,
    "b": 30.6497783660889,
    "C": 40.1605834960938,
    "h": 49.7454032897949,
    "CMY_C": 0.01847487688065,
    "CMY_M": 0.33519500494003,
    "CMY_Y": 0.48149830102921,
    "CMYK_C": 0,
    "CMYK_M": 0.32268163561821,
    "CMYK_Y": 0.47173872590065,
    "CMYK_K": 0.01847487688065
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1658",
    "Farbtonhilfsbezeichnung": "Onyx 240",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "204",
    "Bcolor": "148",
    "Y": 67,
    "L": 85.9385070800781,
    "a": 13.4922599792481,
    "b": 35.2369537353516,
    "C": 37.7317390441895,
    "h": 69.0481185913086,
    "CMY_C": 0,
    "CMY_M": 0.19882875680923,
    "CMY_Y": 0.42136591672897,
    "CMYK_C": 0,
    "CMYK_M": 0.19882875680923,
    "CMYK_Y": 0.42136591672897,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1660",
    "Farbtonhilfsbezeichnung": "Coelin 120",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "214",
    "Bcolor": "225",
    "Y": 62,
    "L": 83.2769470214844,
    "a": -9.57940578460693,
    "b": -10.4062404632568,
    "C": 14.1440753936768,
    "h": 227.369049072266,
    "CMY_C": 0.30879342556,
    "CMY_M": 0.16149979829788,
    "CMY_Y": 0.11826175451279,
    "CMYK_C": 0.21608643233776,
    "CMYK_M": 0.04903727769852,
    "CMYK_Y": 0,
    "CMYK_K": 0.11826175451279
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1661",
    "Farbtonhilfsbezeichnung": "Onyx 215",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "139",
    "Bcolor": "43",
    "Y": 35,
    "L": 65.2121047973633,
    "a": 25.6747379302979,
    "b": 60.3174629211426,
    "C": 65.5544662475586,
    "h": 66.9424819946289,
    "CMY_C": 0.12314671278,
    "CMY_M": 0.45633685588837,
    "CMY_Y": 0.83124613761902,
    "CMYK_C": 0,
    "CMYK_M": 0.37998390197754,
    "CMYK_Y": 0.80754607915878,
    "CMYK_K": 0.12314671278
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1663",
    "Farbtonhilfsbezeichnung": "Aprico 155",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 27,
    "L": 58.6535873413086,
    "a": 36.3057022094727,
    "b": 42.8601875305176,
    "C": 56.1702728271484,
    "h": 49.7329711914063,
    "CMY_C": 0.15851104259491,
    "CMY_M": 0.55567944049835,
    "CMY_Y": 0.74055862426758,
    "CMYK_C": 0,
    "CMYK_M": 0.47198289632797,
    "CMYK_Y": 0.69168770313263,
    "CMYK_K": 0.15851104259491
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1664",
    "Farbtonhilfsbezeichnung": "Curry 150",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "228",
    "Bcolor": "155",
    "Y": 82,
    "L": 91.5402374267578,
    "a": 0.25824624300003,
    "b": 38.8123626708984,
    "C": 38.8132209777832,
    "h": 89.6187744140625,
    "CMY_C": 0,
    "CMY_M": 0.1042771935463,
    "CMY_Y": 0.39339655637741,
    "CMYK_C": 0,
    "CMYK_M": 0.1042771935463,
    "CMYK_Y": 0.39339655637741,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1665",
    "Farbtonhilfsbezeichnung": "Pink 5",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "36",
    "Bcolor": "65",
    "Y": 5,
    "L": 28.449312210083,
    "a": 38.8217811584473,
    "b": 2.03960537910461,
    "C": 38.8753204345703,
    "h": 3.00742077827454,
    "CMY_C": 0.53103959560394,
    "CMY_M": 0.85740315914154,
    "CMY_Y": 0.74587398767471,
    "CMYK_C": 0,
    "CMYK_M": 0.69592988491058,
    "CMYK_Y": 0.45810773968697,
    "CMYK_K": 0.53103959560394
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1666",
    "Farbtonhilfsbezeichnung": "Pink 10",
    "Farbtonklasse": "04",
    "Rcolor": "182",
    "Gcolor": "75",
    "Bcolor": "112",
    "Y": 17,
    "L": 47.2323150634766,
    "a": 47.0405578613281,
    "b": 0.18426881730556,
    "C": 47.0409202575684,
    "h": 0.22443975508213,
    "CMY_C": 0.28670591115952,
    "CMY_M": 0.70433551073074,
    "CMY_Y": 0.55888271331787,
    "CMYK_C": 0,
    "CMYK_M": 0.58549427986145,
    "CMYK_Y": 0.38157725334167,
    "CMYK_K": 0.28670591115952
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1667",
    "Farbtonhilfsbezeichnung": "Pink 15",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "39",
    "Bcolor": "63",
    "Y": 3,
    "L": 22.3514728546143,
    "a": 23.5675201416016,
    "b": -6.81221342086792,
    "C": 24.5323104858398,
    "h": 343.878021240234,
    "CMY_C": 0.67891508340836,
    "CMY_M": 0.84644919633865,
    "CMY_Y": 0.75098806619644,
    "CMYK_C": 0,
    "CMYK_M": 0.52177506685257,
    "CMYK_Y": 0.22446703910828,
    "CMYK_K": 0.67891508340836
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1668",
    "Farbtonhilfsbezeichnung": "Pink 20",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "85",
    "Bcolor": "132",
    "Y": 17,
    "L": 48.6407585144043,
    "a": 42.4984359741211,
    "b": -9.48360157012939,
    "C": 43.5437240600586,
    "h": 347.420440673828,
    "CMY_C": 0.31303369998932,
    "CMY_M": 0.66624563932419,
    "CMY_Y": 0.48370116949081,
    "CMYK_C": 0,
    "CMYK_M": 0.51416194438934,
    "CMYK_Y": 0.24843645095825,
    "CMYK_K": 0.31303369998932
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1669",
    "Farbtonhilfsbezeichnung": "Pink 25",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "54",
    "Bcolor": "84",
    "Y": 6,
    "L": 28.1426963806152,
    "a": 22.2218532562256,
    "b": -11.6727647781372,
    "C": 25.1010799407959,
    "h": 332.287811279297,
    "CMY_C": 0.64106005430222,
    "CMY_M": 0.78903949260712,
    "CMY_Y": 0.67049330472946,
    "CMYK_C": 0,
    "CMYK_M": 0.41226795315742,
    "CMYK_Y": 0.08200048655272,
    "CMYK_K": 0.64106005430222
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1670",
    "Farbtonhilfsbezeichnung": "Pink 30",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "95",
    "Bcolor": "148",
    "Y": 19,
    "L": 48.878173828125,
    "a": 34.0972557067871,
    "b": -19.1774749755859,
    "C": 39.1203079223633,
    "h": 330.645080566406,
    "CMY_C": 0.38221806287766,
    "CMY_M": 0.62853825092316,
    "CMY_Y": 0.41942083835602,
    "CMYK_C": 0,
    "CMYK_M": 0.398717045784,
    "CMYK_Y": 0.06021991372108,
    "CMYK_K": 0.38221806287766
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1671",
    "Farbtonhilfsbezeichnung": "Lachs 10",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "177",
    "Bcolor": "164",
    "Y": 48,
    "L": 74.7334899902344,
    "a": 10.7433681488037,
    "b": 10.455358505249,
    "C": 14.9911470413208,
    "h": 44.2216148376465,
    "CMY_C": 0.17268139123917,
    "CMY_M": 0.3069583773613,
    "CMY_Y": 0.35716891288757,
    "CMYK_C": 0,
    "CMYK_M": 0.16230383515358,
    "CMYK_Y": 0.22299452126026,
    "CMYK_K": 0.17268139123917
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1672",
    "Farbtonhilfsbezeichnung": "Agave 150",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "232",
    "Bcolor": "184",
    "Y": 72,
    "L": 88.2286682128906,
    "a": -20.6896991729736,
    "b": 18.7029819488525,
    "C": 27.8902339935303,
    "h": 137.887191772461,
    "CMY_C": 0.23849529027939,
    "CMY_M": 0.0909326672554,
    "CMY_Y": 0.28002804517746,
    "CMYK_C": 0.162323102355,
    "CMYK_M": 0,
    "CMYK_Y": 0.20801031589508,
    "CMYK_K": 0.0909326672554
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1674",
    "Farbtonhilfsbezeichnung": "Agave 145",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "213",
    "Bcolor": "151",
    "Y": 60,
    "L": 80.5062637329102,
    "a": -28.0654525756836,
    "b": 24.8797302246094,
    "C": 37.5056076049805,
    "h": 138.443344116211,
    "CMY_C": 0.36571419239044,
    "CMY_M": 0.16383600234985,
    "CMY_Y": 0.40829455852509,
    "CMYK_C": 0.24143372476101,
    "CMYK_M": 0,
    "CMYK_Y": 0.29235717654228,
    "CMYK_K": 0.16383600234985
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1675",
    "Farbtonhilfsbezeichnung": "Verona 130",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "125",
    "Y": 15,
    "L": 45.6916160583496,
    "a": -30.0046825408936,
    "b": -10.8755855560303,
    "C": 31.9148769378662,
    "h": 199.923690795898,
    "CMY_C": 1,
    "CMY_M": 0.52153819799423,
    "CMY_Y": 0.51174175739288,
    "CMYK_C": 1,
    "CMYK_M": 0.02006405591965,
    "CMYK_Y": 0,
    "CMYK_K": 0.51174175739288
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1676",
    "Farbtonhilfsbezeichnung": "Malachit 70",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "127",
    "Bcolor": "95",
    "Y": 18,
    "L": 49.1536178588867,
    "a": -23.3294830322266,
    "b": 11.7098426818848,
    "C": 26.1033554077148,
    "h": 153.346405029297,
    "CMY_C": 0.68827718496323,
    "CMY_M": 0.50159955024719,
    "CMY_Y": 0.62577778100967,
    "CMYK_C": 0.37455350160599,
    "CMYK_M": 0,
    "CMYK_Y": 0.24915352463722,
    "CMYK_K": 0.50159955024719
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1677",
    "Farbtonhilfsbezeichnung": "Lazur 210",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "160",
    "Bcolor": "197",
    "Y": 32.9243392944336,
    "L": 64.0996017456055,
    "a": -5.06982040405273,
    "b": -24.5583419799805,
    "C": 25.0761890411377,
    "h": 258.335723876953,
    "CMY_C": 0.54621243476868,
    "CMY_M": 0.37198507785797,
    "CMY_Y": 0.22664952278137,
    "CMYK_C": 0.41321873664856,
    "CMYK_M": 0.18792973458767,
    "CMYK_Y": 0,
    "CMYK_K": 0.22664952278137
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1678",
    "Farbtonhilfsbezeichnung": "Lachs 5",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "159",
    "Bcolor": "147",
    "Y": 38,
    "L": 68.2248458862305,
    "a": 10.8675870895386,
    "b": 10.6145153045654,
    "C": 15.1911945343018,
    "h": 44.3250503540039,
    "CMY_C": 0.24307101964951,
    "CMY_M": 0.37588077783585,
    "CMY_Y": 0.42537027597427,
    "CMYK_C": 0,
    "CMYK_M": 0.17545868456364,
    "CMYK_Y": 0.24084062874317,
    "CMYK_K": 0.24307101964951
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1679",
    "Farbtonhilfsbezeichnung": "Coelin 30",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "241",
    "Bcolor": "239",
    "Y": 87.4396896362305,
    "L": 94.9245071411133,
    "a": -1.41120314598083,
    "b": -0.10838940739632,
    "C": 1.41535949707031,
    "h": 184.392059326172,
    "CMY_C": 0.06903576850891,
    "CMY_M": 0.05328112840652,
    "CMY_Y": 0.06386399269104,
    "CMYK_C": 0.01664130762219,
    "CMYK_M": 0,
    "CMYK_Y": 0.01117846556008,
    "CMYK_K": 0.05328112840652
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1681",
    "Farbtonhilfsbezeichnung": "Jade 95",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "116",
    "Bcolor": "80",
    "Y": 17,
    "L": 47.6499290466309,
    "a": -7.08604192733765,
    "b": 18.8939113616943,
    "C": 20.1789951324463,
    "h": 110.558235168457,
    "CMY_C": 0.55682444572449,
    "CMY_M": 0.54617780447006,
    "CMY_Y": 0.68542230129242,
    "CMYK_C": 0.02345993928611,
    "CMYK_M": 0,
    "CMYK_Y": 0.30682611465454,
    "CMYK_K": 0.54617780447006
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1682",
    "Farbtonhilfsbezeichnung": "Moos 65",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "133",
    "Bcolor": "106",
    "Y": 23,
    "L": 54.4646301269531,
    "a": -7.22082233428955,
    "b": 13.4193410873413,
    "C": 15.238733291626,
    "h": 118.284286499023,
    "CMY_C": 0.50248020887375,
    "CMY_M": 0.4770336151123,
    "CMY_Y": 0.58416557312012,
    "CMYK_C": 0.04865818098187,
    "CMYK_M": 0,
    "CMYK_Y": 0.20485438406467,
    "CMYK_K": 0.4770336151123
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1683",
    "Farbtonhilfsbezeichnung": "Verona 150",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "220",
    "Bcolor": "218",
    "Y": 64,
    "L": 84.2961883544922,
    "a": -15.8660049438477,
    "b": -5.18222427368164,
    "C": 16.690881729126,
    "h": 198.088302612305,
    "CMY_C": 0.33200454711914,
    "CMY_M": 0.13861954212189,
    "CMY_Y": 0.14587247371674,
    "CMYK_C": 0.22450591623783,
    "CMYK_M": 0,
    "CMYK_Y": 0.00842012558132,
    "CMYK_K": 0.13861954212189
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1685",
    "Farbtonhilfsbezeichnung": "Palazzo 275",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "107",
    "Bcolor": "56",
    "Y": 17,
    "L": 48.1126365661621,
    "a": 9.8511848449707,
    "b": 34.0346565246582,
    "C": 35.4316749572754,
    "h": 73.8571472167969,
    "CMY_C": 0.4280977845192,
    "CMY_M": 0.58054834604263,
    "CMY_Y": 0.78213787078857,
    "CMYK_C": 0,
    "CMYK_M": 0.26656752824783,
    "CMYK_Y": 0.61905699968338,
    "CMYK_K": 0.4280977845192
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1720",
    "Farbtonhilfsbezeichnung": "Monte 10",
    "Farbtonklasse": "02",
    "Y": 26,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1721",
    "Farbtonhilfsbezeichnung": "Monte 20",
    "Farbtonklasse": "02",
    "Y": 43,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1722",
    "Farbtonhilfsbezeichnung": "Monte 30",
    "Farbtonklasse": "01",
    "Y": 54,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1723",
    "Farbtonhilfsbezeichnung": "Monte 25",
    "Farbtonklasse": "02",
    "Y": 39,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1724",
    "Farbtonhilfsbezeichnung": "Monte 5",
    "Farbtonklasse": "03",
    "Y": 23,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1725",
    "Farbtonhilfsbezeichnung": "Bruno 5",
    "Farbtonklasse": "03",
    "Y": 13,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1726",
    "Farbtonhilfsbezeichnung": "Bruno 15",
    "Farbtonklasse": "03",
    "Y": 14,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1727",
    "Farbtonhilfsbezeichnung": "Bruno 10",
    "Farbtonklasse": "04",
    "Y": 7,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1729",
    "Farbtonhilfsbezeichnung": "Universo 15",
    "Farbtonklasse": "03",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1730",
    "Farbtonhilfsbezeichnung": "Universo 20",
    "Farbtonklasse": "03",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1731",
    "Farbtonhilfsbezeichnung": "Universo 10",
    "Farbtonklasse": "03",
    "Y": 5,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1732",
    "Farbtonhilfsbezeichnung": "Universo 5",
    "Farbtonklasse": "03",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1733",
    "Farbtonhilfsbezeichnung": "Universo 30",
    "Farbtonklasse": "03",
    "Y": 5,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1734",
    "Farbtonhilfsbezeichnung": "Mars 5",
    "Farbtonklasse": "03",
    "Y": 9,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1735",
    "Farbtonhilfsbezeichnung": "Mars 10",
    "Farbtonklasse": "03",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1736",
    "Farbtonhilfsbezeichnung": "Mars 15",
    "Farbtonklasse": "04",
    "Y": 8,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1737",
    "Farbtonhilfsbezeichnung": "Mars 30",
    "Farbtonklasse": "04",
    "Y": 30,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1738",
    "Farbtonhilfsbezeichnung": "Mars 25",
    "Farbtonklasse": "04",
    "Y": 15,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1739",
    "Farbtonhilfsbezeichnung": "Mars 20",
    "Farbtonklasse": "04",
    "Y": 8,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1740",
    "Farbtonhilfsbezeichnung": "Solaris 5",
    "Farbtonklasse": "04",
    "Y": 27,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1741",
    "Farbtonhilfsbezeichnung": "Solaris 10",
    "Farbtonklasse": "04",
    "Y": 35,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1742",
    "Farbtonhilfsbezeichnung": "Solaris 15",
    "Farbtonklasse": "04",
    "Y": 47,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1745",
    "Farbtonhilfsbezeichnung": "Solaris 20",
    "Farbtonklasse": "04",
    "Y": 56,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1746",
    "Farbtonhilfsbezeichnung": "Solaris 25",
    "Farbtonklasse": "03",
    "Y": 38,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1747",
    "Farbtonhilfsbezeichnung": "Flora 30",
    "Farbtonklasse": "01",
    "Y": 85,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1748",
    "Farbtonhilfsbezeichnung": "Flora 25",
    "Farbtonklasse": "02",
    "Y": 41,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1749",
    "Farbtonhilfsbezeichnung": "Flora 15",
    "Farbtonklasse": "04",
    "Y": 12,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1750",
    "Farbtonhilfsbezeichnung": "Flora 10",
    "Farbtonklasse": "03",
    "Y": 9,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1751",
    "Farbtonhilfsbezeichnung": "Flora 5",
    "Farbtonklasse": "04",
    "Y": 8,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1752",
    "Farbtonhilfsbezeichnung": "Aqua 5",
    "Farbtonklasse": "04",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1753",
    "Farbtonhilfsbezeichnung": "Aqua 10",
    "Farbtonklasse": "04",
    "Y": 7,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1754",
    "Farbtonhilfsbezeichnung": "Aqua 15",
    "Farbtonklasse": "04",
    "Y": 13,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1755",
    "Farbtonhilfsbezeichnung": "Aqua 25",
    "Farbtonklasse": "03",
    "Y": 16,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D SYSTEM",
    "Farbton_ID": "CPD1756",
    "Farbtonhilfsbezeichnung": "Aqua 30",
    "Farbtonklasse": "03",
    "Y": 22,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D GRAUTOENE",
    "Farbton_ID": "CPG0004",
    "Farbtonhilfsbezeichnung": "Umbra Grau",
    "Farbtonklasse": "02",
    "Y": 11,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0001",
    "Farbtonhilfsbezeichnung": "Warmweiss",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "229",
    "Bcolor": "221",
    "Y": 78,
    "L": 90.9667739868164,
    "a": 0.23069967329502,
    "b": 3.58108329772949,
    "C": 3.5885066986084,
    "h": 86.3140029907227,
    "CMY_C": 0.08775299787521,
    "CMY_M": 0.10255551338196,
    "CMY_Y": 0.13493716716766,
    "CMYK_C": 0,
    "CMYK_M": 0.01622643321753,
    "CMYK_Y": 0.05172301828861,
    "CMYK_K": 0.08775299787521
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0002",
    "Farbtonhilfsbezeichnung": "Naturweiss",
    "Farbtonklasse": "00",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "225",
    "Y": 83,
    "L": 93.069938659668,
    "a": -0.16896779835224,
    "b": 4.34122753143311,
    "C": 4.3445143699646,
    "h": 92.2289199829102,
    "CMY_C": 0.06483513116837,
    "CMY_M": 0.07831567525864,
    "CMY_Y": 0.11746144294739,
    "CMYK_C": 0,
    "CMYK_M": 0.01441515237093,
    "CMYK_Y": 0.05627490207553,
    "CMYK_K": 0.06483513116837
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0003",
    "Farbtonhilfsbezeichnung": "Umbraweiss",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "230",
    "Bcolor": "219",
    "Y": 79,
    "L": 91.2100219726562,
    "a": -0.40427026152611,
    "b": 4.76058340072632,
    "C": 4.77771806716919,
    "h": 94.8539276123047,
    "CMY_C": 0.08615672588348,
    "CMY_M": 0.09865987300873,
    "CMY_Y": 0.14109468460083,
    "CMYK_C": 0,
    "CMYK_M": 0.01368193794042,
    "CMYK_Y": 0.06011748313904,
    "CMYK_K": 0.08615672588348
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0004",
    "Farbtonhilfsbezeichnung": "Hellweiss",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "243",
    "Bcolor": "234",
    "Y": 89,
    "L": 95.6809158325195,
    "a": -0.86672121286392,
    "b": 3.38826751708984,
    "C": 3.49736499786377,
    "h": 104.348617553711,
    "CMY_C": 0.0441027879715,
    "CMY_M": 0.04704934358597,
    "CMY_Y": 0.08151078224182,
    "CMYK_C": 0,
    "CMYK_M": 0.00308250263333,
    "CMYK_Y": 0.03913391008973,
    "CMYK_K": 0.0441027879715
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0005",
    "Farbtonhilfsbezeichnung": "Grauweiss",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "228",
    "Y": 82,
    "L": 93.1483840942383,
    "a": -0.26867890357971,
    "b": 3.09398579597473,
    "C": 3.10562968254089,
    "h": 94.9630661010742,
    "CMY_C": 0.06883651018143,
    "CMY_M": 0.07685279846191,
    "CMY_Y": 0.10732471942902,
    "CMYK_C": 0,
    "CMYK_M": 0.00860889442265,
    "CMYK_Y": 0.04133345931768,
    "CMYK_K": 0.06883651018143
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0006",
    "Farbtonhilfsbezeichnung": "Kuehlweiss",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "230",
    "Bcolor": "226",
    "Y": 78,
    "L": 91.3227920532227,
    "a": -0.47517603635788,
    "b": 1.32484829425812,
    "C": 1.4074854850769,
    "h": 109.731109619141,
    "CMY_C": 0.09683811664581,
    "CMY_M": 0.09627813100815,
    "CMY_Y": 0.11439836025238,
    "CMYK_C": 0.00061964377528,
    "CMYK_M": 0,
    "CMYK_Y": 0.0200506709516,
    "CMYK_K": 0.09627813100815
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0007",
    "Farbtonhilfsbezeichnung": "Indeko-plus Weiss",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "244",
    "Bcolor": "237",
    "Y": 90,
    "L": 96.1352310180664,
    "a": -0.46146434545517,
    "b": 2.63772773742676,
    "C": 2.67778944969177,
    "h": 99.92333984375,
    "CMY_C": 0.03828001022339,
    "CMY_M": 0.04268354177475,
    "CMY_Y": 0.07077151536942,
    "CMYK_C": 0,
    "CMYK_M": 0.00457880832255,
    "CMYK_Y": 0.03378478810191,
    "CMYK_K": 0.03828001022339
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0008",
    "Farbtonhilfsbezeichnung": "Porzellanweiss",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "238",
    "Bcolor": "234",
    "Y": 85,
    "L": 93.9120788574219,
    "a": 0.08040801435709,
    "b": 0.72343969345093,
    "C": 0.72789454460144,
    "h": 83.6577911376953,
    "CMY_C": 0.06551307439804,
    "CMY_M": 0.06844991445541,
    "CMY_Y": 0.08114647865295,
    "CMYK_C": 0,
    "CMYK_M": 0.00314272986725,
    "CMYK_Y": 0.01672939769924,
    "CMYK_K": 0.06551307439804
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0009",
    "Farbtonhilfsbezeichnung": "Verkehrsweiß",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "241",
    "Bcolor": "234",
    "Y": 88,
    "L": 95.123405456543,
    "a": -0.86389583349228,
    "b": 2.90017795562744,
    "C": 3.02611112594604,
    "h": 106.587577819824,
    "CMY_C": 0.05200147628784,
    "CMY_M": 0.05319929122925,
    "CMY_Y": 0.08405858278275,
    "CMYK_C": 0,
    "CMYK_M": 0.00126351986546,
    "CMYK_Y": 0.03381556645036,
    "CMYK_K": 0.05200147628784
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0010",
    "Farbtonhilfsbezeichnung": "Muschelweiss",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "241",
    "Bcolor": "233",
    "Y": 88,
    "L": 95.142936706543,
    "a": -0.33837482333183,
    "b": 3.42954659461975,
    "C": 3.4461989402771,
    "h": 95.6348266601562,
    "CMY_C": 0.0458425283432,
    "CMY_M": 0.05438232421875,
    "CMY_Y": 0.08772432804108,
    "CMYK_C": 0,
    "CMYK_M": 0.00895009096712,
    "CMYK_Y": 0.0438940115273,
    "CMYK_K": 0.0458425283432
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0011",
    "Farbtonhilfsbezeichnung": "Altweiss",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "240",
    "Bcolor": "229",
    "Y": 87,
    "L": 94.7724685668945,
    "a": -0.48384094238281,
    "b": 4.70953226089478,
    "C": 4.73432111740112,
    "h": 95.8657913208008,
    "CMY_C": 0.04694986343384,
    "CMY_M": 0.05855828523636,
    "CMY_Y": 0.10142433643341,
    "CMYK_C": 0,
    "CMYK_M": 0.01218028459698,
    "CMYK_Y": 0.05715803429484,
    "CMYK_K": 0.04694986343384
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0012",
    "Farbtonhilfsbezeichnung": "Antikweiss",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "240",
    "Bcolor": "229",
    "Y": 87,
    "L": 94.7523956298828,
    "a": -0.16881392896175,
    "b": 4.72035884857178,
    "C": 4.72337675094604,
    "h": 92.0481948852539,
    "CMY_C": 0.0446674823761,
    "CMY_M": 0.05954027175903,
    "CMY_Y": 0.10168153047562,
    "CMYK_C": 0,
    "CMYK_M": 0.01556818094105,
    "CMYK_Y": 0.05967979505658,
    "CMYK_K": 0.0446674823761
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0013",
    "Farbtonhilfsbezeichnung": "Lichtweiss",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "242",
    "Bcolor": "232",
    "Y": 90,
    "L": 95.5599517822266,
    "a": -0.17009600996971,
    "b": 4.31402730941772,
    "C": 4.31737947463989,
    "h": 92.2579193115234,
    "CMY_C": 0.03689062595367,
    "CMY_M": 0.05033659934998,
    "CMY_Y": 0.0896852016449,
    "CMYK_C": 0,
    "CMYK_M": 0.01396100316197,
    "CMYK_Y": 0.05481680110097,
    "CMYK_K": 0.03689062595367
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0014",
    "Farbtonhilfsbezeichnung": "Marmorweiss",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 82,
    "L": 92.6127395629883,
    "a": -0.67796391248703,
    "b": 0.94585037231445,
    "C": 1.16373026371002,
    "h": 125.632080078125,
    "CMY_C": 0.0853443145752,
    "CMY_M": 0.08127272129059,
    "CMY_Y": 0.09733784198761,
    "CMYK_C": 0.00443177577108,
    "CMYK_M": 0,
    "CMYK_Y": 0.01748627796769,
    "CMYK_K": 0.08127272129059
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0015",
    "Farbtonhilfsbezeichnung": "Signalweiss",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 85,
    "L": 93.903076171875,
    "a": -0.8256830573082,
    "b": 2.13023066520691,
    "C": 2.2846519947052,
    "h": 111.186462402344,
    "CMY_C": 0.06801700592041,
    "CMY_M": 0.06679284572601,
    "CMY_Y": 0.09186083078384,
    "CMYK_C": 0.00131177750882,
    "CMYK_M": 0,
    "CMYK_Y": 0.02686218731105,
    "CMYK_K": 0.06679284572601
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0016",
    "Farbtonhilfsbezeichnung": "Reinweiss",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "239",
    "Bcolor": "228",
    "Y": 86,
    "L": 94.4294509887695,
    "a": -0.51525962352753,
    "b": 4.98224067687988,
    "C": 5.00881385803223,
    "h": 95.9044952392578,
    "CMY_C": 0.05017417669296,
    "CMY_M": 0.06241422891617,
    "CMY_Y": 0.10726433992386,
    "CMYK_C": 0,
    "CMYK_M": 0.01288662850857,
    "CMYK_Y": 0.06010592728853,
    "CMYK_K": 0.05017417669296
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0017",
    "Farbtonhilfsbezeichnung": "Samtweiss",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "236",
    "Bcolor": "224",
    "Y": 84,
    "L": 93.5542984008789,
    "a": 0.37805169820786,
    "b": 5.4942193031311,
    "C": 5.50721073150635,
    "h": 86.0637359619141,
    "CMY_C": 0.05141520500183,
    "CMY_M": 0.07451343536377,
    "CMY_Y": 0.12062329053879,
    "CMYK_C": 0,
    "CMYK_M": 0.02435020171106,
    "CMYK_Y": 0.0729593038559,
    "CMYK_K": 0.05141520500183
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0018",
    "Farbtonhilfsbezeichnung": "Cremeweiss",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "225",
    "Bcolor": "211",
    "Y": 76,
    "L": 89.8332977294922,
    "a": 0.57631468772888,
    "b": 7.06220197677612,
    "C": 7.08567810058594,
    "h": 85.3346862792969,
    "CMY_C": 0.08677268028259,
    "CMY_M": 0.11693680286407,
    "CMY_Y": 0.17306017875671,
    "CMYK_C": 0,
    "CMYK_M": 0.03303024545312,
    "CMYK_Y": 0.09448633342981,
    "CMYK_K": 0.08677268028259
  },
  {
    "Farbtonkarten_Bezeichnung": "CAPAROL 3D WEISSFARBTOENE",
    "Farbton_ID": "CPW0019",
    "Farbtonhilfsbezeichnung": "Perlmuttweiss",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "228",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.808464050293,
    "a": 1.60862863063812,
    "b": 2.41726565361023,
    "C": 2.90359425544739,
    "h": 56.3572463989258,
    "CMY_C": 0.08260959386826,
    "CMY_M": 0.10728931427002,
    "CMY_Y": 0.12786740064621,
    "CMYK_C": 0,
    "CMYK_M": 0.02690209075809,
    "CMYK_Y": 0.04933320358396,
    "CMYK_K": 0.08260959386826
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0001",
    "Farbtonhilfsbezeichnung": "No 01 B15",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "232",
    "Bcolor": "230",
    "Y": 80.5292892456055,
    "L": 91.9218215942383,
    "a": 0.63369256258011,
    "b": -0.14303277432919,
    "C": 0.6496342420578,
    "h": 347.280731201172,
    "CMY_C": 0.08639305830002,
    "CMY_M": 0.09180635213852,
    "CMY_Y": 0.09673148393631,
    "CMYK_C": 0,
    "CMYK_M": 0.00592518923804,
    "CMYK_Y": 0.01131605450064,
    "CMYK_K": 0.08639305830002
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0002",
    "Farbtonhilfsbezeichnung": "No 02 Teahupoo",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "239",
    "Bcolor": "229",
    "Y": 86.5767135620117,
    "L": 94.5583877563477,
    "a": -0.17885293066502,
    "b": 4.46942949295044,
    "C": 4.47300672531128,
    "h": 92.2915802001953,
    "CMY_C": 0.0477499961853,
    "CMY_M": 0.06162774562836,
    "CMY_Y": 0.10195755958557,
    "CMYK_C": 0,
    "CMYK_M": 0.01457364112139,
    "CMYK_Y": 0.05692576989532,
    "CMYK_K": 0.0477499961853
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0003",
    "Farbtonhilfsbezeichnung": "No 03 Clouds Of California",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "241",
    "Bcolor": "234",
    "Y": 88.1268768310547,
    "L": 95.2143402099609,
    "a": -0.47441032528877,
    "b": 3.03651213645935,
    "C": 3.07334852218628,
    "h": 98.8798370361328,
    "CMY_C": 0.04742628335953,
    "CMY_M": 0.05314308404922,
    "CMY_Y": 0.0840111374855,
    "CMYK_C": 0,
    "CMYK_M": 0.00600142590702,
    "CMYK_Y": 0.03840632364154,
    "CMYK_K": 0.04742628335953
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0004",
    "Farbtonhilfsbezeichnung": "No 04 White Russian",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "231",
    "Y": 83.5232620239258,
    "L": 93.243049621582,
    "a": -0.51528918743134,
    "b": 1.61705100536346,
    "C": 1.69716727733612,
    "h": 107.674987792969,
    "CMY_C": 0.07469522953033,
    "CMY_M": 0.07478934526443,
    "CMY_Y": 0.09531760215759,
    "CMYK_C": 0,
    "CMYK_M": 0.00010171322356,
    "CMYK_Y": 0.02228711359203,
    "CMYK_K": 0.07469522953033
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0005",
    "Farbtonhilfsbezeichnung": "No 05 Granny Takes A Trip",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "230",
    "Bcolor": "225",
    "Y": 79.2919616699219,
    "L": 91.3662338256836,
    "a": -0.26510611176491,
    "b": 1.65197575092316,
    "C": 1.67311239242554,
    "h": 99.1169967651367,
    "CMY_C": 0.0935817360878,
    "CMY_M": 0.09638339281082,
    "CMY_Y": 0.11631345748901,
    "CMYK_C": 0,
    "CMYK_M": 0.00309090944938,
    "CMYK_Y": 0.02507862262428,
    "CMYK_K": 0.0935817360878
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0006",
    "Farbtonhilfsbezeichnung": "No 06 Paninaro",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "216",
    "Bcolor": "212",
    "Y": 68.6704254150391,
    "L": 86.3405838012695,
    "a": -0.11846777051687,
    "b": 1.26577174663544,
    "C": 1.27130353450775,
    "h": 95.346923828125,
    "CMY_C": 0.14948779344559,
    "CMY_M": 0.15236854553223,
    "CMY_Y": 0.16863089799881,
    "CMYK_C": 0,
    "CMYK_M": 0.00338707910851,
    "CMYK_Y": 0.02250773645937,
    "CMYK_K": 0.14948779344559
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0007",
    "Farbtonhilfsbezeichnung": "No 07 Disco Ball",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "188",
    "Bcolor": "181",
    "Y": 50.2332077026367,
    "L": 76.2121810913086,
    "a": 0.50101917982101,
    "b": 2.94830632209778,
    "C": 2.99057364463806,
    "h": 80.355598449707,
    "CMY_C": 0.2497141957283,
    "CMY_M": 0.26449704170227,
    "CMY_Y": 0.28970640897751,
    "CMYK_C": 0,
    "CMYK_M": 0.01970295235515,
    "CMYK_Y": 0.05330263823271,
    "CMYK_K": 0.2497141957283
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0008",
    "Farbtonhilfsbezeichnung": "No 08 Pet Rock",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "135",
    "Bcolor": "137",
    "Y": 24.0981731414795,
    "L": 56.1859512329102,
    "a": -0.64030003547668,
    "b": -1.95328450202942,
    "C": 2.05555462837219,
    "h": 251.850509643555,
    "CMY_C": 0.48279845714569,
    "CMY_M": 0.4695947766304,
    "CMY_Y": 0.46301764249802,
    "CMYK_C": 0.03683699294925,
    "CMYK_M": 0.01224832423031,
    "CMYK_Y": 0,
    "CMYK_K": 0.46301764249802
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0010",
    "Farbtonhilfsbezeichnung": "No 10 Tribute To Vinyl",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "66",
    "Bcolor": "68",
    "Y": 5.50960922241211,
    "L": 28.1399230957031,
    "a": 0.08125638961792,
    "b": -1.51750528812408,
    "C": 1.51967918872833,
    "h": 273.065032958984,
    "CMY_C": 0.74347591400146,
    "CMY_M": 0.73927646875381,
    "CMY_Y": 0.73293501138687,
    "CMYK_C": 0.03946942836046,
    "CMYK_M": 0.02374499663711,
    "CMYK_Y": 0,
    "CMYK_K": 0.73293501138687
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0011",
    "Farbtonhilfsbezeichnung": "No 11 Hommage To Berlin",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "218",
    "Bcolor": "211",
    "Y": 70.3481826782227,
    "L": 87.167350769043,
    "a": 0.23012338578701,
    "b": 3.12434506416321,
    "C": 3.13280844688416,
    "h": 85.7874908447266,
    "CMY_C": 0.13151341676712,
    "CMY_M": 0.1445814371109,
    "CMY_Y": 0.17318499088287,
    "CMYK_C": 0,
    "CMYK_M": 0.01504688803107,
    "CMYK_Y": 0.04798182845116,
    "CMYK_K": 0.13151341676712
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0013",
    "Farbtonhilfsbezeichnung": "No 13 Sea Of Tranquility",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "138",
    "Bcolor": "137",
    "Y": 25.6522235870361,
    "L": 57.7054595947266,
    "a": 0.92013502120972,
    "b": 0.54926687479019,
    "C": 1.07160747051239,
    "h": 30.8347358703613,
    "CMY_C": 0.44813907146454,
    "CMY_M": 0.45822995901108,
    "CMY_Y": 0.46435743570328,
    "CMYK_C": 0,
    "CMYK_M": 0.01828519999981,
    "CMYK_Y": 0.02938849851489,
    "CMYK_K": 0.44813907146454
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0014",
    "Farbtonhilfsbezeichnung": "No 14 Chesterfield",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "121",
    "Bcolor": "118",
    "Y": 19.9030914306641,
    "L": 51.7274703979492,
    "a": 3.17519497871399,
    "b": 2.71282172203064,
    "C": 4.17627382278442,
    "h": 40.5098991394043,
    "CMY_C": 0.48676270246506,
    "CMY_M": 0.52372294664383,
    "CMY_Y": 0.53789556026459,
    "CMYK_C": 0,
    "CMYK_M": 0.07201395183802,
    "CMYK_Y": 0.09962809830904,
    "CMYK_K": 0.48676270246506
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0015",
    "Farbtonhilfsbezeichnung": "No 15 Dynasty",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "108",
    "Bcolor": "106",
    "Y": 15.2586479187012,
    "L": 45.9864387512207,
    "a": 1.48822569847107,
    "b": 1.25686800479889,
    "C": 1.94795608520508,
    "h": 40.1824722290039,
    "CMY_C": 0.55911505222321,
    "CMY_M": 0.57607805728912,
    "CMY_Y": 0.58435797691345,
    "CMYK_C": 0,
    "CMYK_M": 0.03847490251064,
    "CMYK_Y": 0.05725513026118,
    "CMYK_K": 0.55911505222321
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0016",
    "Farbtonhilfsbezeichnung": "No 16 Lace",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "241",
    "Bcolor": "228",
    "Y": 88.0831146240234,
    "L": 95.1959228515625,
    "a": -0.71182101964951,
    "b": 5.90596103668213,
    "C": 5.94870281219482,
    "h": 96.8724670410156,
    "CMY_C": 0.04008877277374,
    "CMY_M": 0.05357760190964,
    "CMY_Y": 0.10571593046188,
    "CMYK_C": 0,
    "CMYK_M": 0.01405216287822,
    "CMYK_Y": 0.06836794316769,
    "CMYK_K": 0.04008877277374
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0017",
    "Farbtonhilfsbezeichnung": "No 17 Lullaby",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "200",
    "Bcolor": "186",
    "Y": 58.2368125915527,
    "L": 80.8702697753906,
    "a": 0.91737723350525,
    "b": 7.45141696929932,
    "C": 7.5076756477356,
    "h": 82.9813842773438,
    "CMY_C": 0.18234211206436,
    "CMY_M": 0.21633440256119,
    "CMY_Y": 0.27249717712402,
    "CMYK_C": 0,
    "CMYK_M": 0.04157275334001,
    "CMYK_Y": 0.11026012897491,
    "CMYK_K": 0.18234211206436
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0018",
    "Farbtonhilfsbezeichnung": "No 18 Carlota",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "139",
    "Bcolor": "121",
    "Y": 27.076452255249,
    "L": 59.0450325012207,
    "a": 4.17511510848999,
    "b": 11.3665103912354,
    "C": 12.1090517044067,
    "h": 69.8308410644531,
    "CMY_C": 0.38330680131912,
    "CMY_M": 0.45453250408173,
    "CMY_Y": 0.52377313375473,
    "CMYK_C": 0,
    "CMYK_M": 0.11549617350101,
    "CMYK_Y": 0.22777344286442,
    "CMYK_K": 0.38330680131912
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0019",
    "Farbtonhilfsbezeichnung": "No 19 Leopard",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "106",
    "Bcolor": "98",
    "Y": 15.0878820419312,
    "L": 45.7543296813965,
    "a": 4.50110149383545,
    "b": 5.5369439125061,
    "C": 7.13566112518311,
    "h": 50.8915939331055,
    "CMY_C": 0.5306271314621,
    "CMY_M": 0.58586430549622,
    "CMY_Y": 0.61381059885025,
    "CMYK_C": 0,
    "CMYK_M": 0.11768292635679,
    "CMYK_Y": 0.17722257971764,
    "CMYK_K": 0.5306271314621
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0020",
    "Farbtonhilfsbezeichnung": "No 20 Nacional",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "69",
    "Bcolor": "66",
    "Y": 6.38507604598999,
    "L": 30.3639068603516,
    "a": 3.79566788673401,
    "b": 3.0645387172699,
    "C": 4.87836980819702,
    "h": 38.9166412353516,
    "CMY_C": 0.68854856491089,
    "CMY_M": 0.72775769233704,
    "CMY_Y": 0.74005562067032,
    "CMYK_C": 0,
    "CMYK_M": 0.1258916258812,
    "CMYK_Y": 0.16537748277187,
    "CMYK_K": 0.68854856491089
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0021",
    "Farbtonhilfsbezeichnung": "No 21 Chukka",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "221",
    "Y": 81.6724166870117,
    "L": 92.4300842285156,
    "a": -0.08897574990988,
    "b": 5.61251783370972,
    "C": 5.6132230758667,
    "h": 90.9082412719727,
    "CMY_C": 0.06730759143829,
    "CMY_M": 0.0860156416893,
    "CMY_Y": 0.13396006822586,
    "CMYK_C": 0,
    "CMYK_M": 0.02005811408162,
    "CMYK_Y": 0.07146244496107,
    "CMYK_K": 0.06730759143829
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0022",
    "Farbtonhilfsbezeichnung": "No 22 Boombox",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "201",
    "Bcolor": "189",
    "Y": 58.2355499267578,
    "L": 80.8695755004883,
    "a": -0.73692381381989,
    "b": 5.32654476165771,
    "C": 5.37727975845337,
    "h": 97.8768310546875,
    "CMY_C": 0.20113742351532,
    "CMY_M": 0.21194738149643,
    "CMY_Y": 0.25737929344177,
    "CMYK_C": 0,
    "CMYK_M": 0.01353168673813,
    "CMYK_Y": 0.07040243595839,
    "CMYK_K": 0.20113742351532
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0023",
    "Farbtonhilfsbezeichnung": "No 23 Runway",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "178",
    "Bcolor": "162",
    "Y": 44.5022773742676,
    "L": 72.5629501342773,
    "a": -0.22430749237537,
    "b": 7.92221117019653,
    "C": 7.92538595199585,
    "h": 91.621826171875,
    "CMY_C": 0.27940100431442,
    "CMY_M": 0.30310726165771,
    "CMY_Y": 0.36346685886383,
    "CMYK_C": 0,
    "CMYK_M": 0.03289798647165,
    "CMYK_Y": 0.11666107922792,
    "CMYK_K": 0.27940100431442
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0024",
    "Farbtonhilfsbezeichnung": "No 24 Library Love",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "141",
    "Bcolor": "128",
    "Y": 27.3109970092773,
    "L": 59.2610969543457,
    "a": 1.31665146350861,
    "b": 8.09700584411621,
    "C": 8.2033576965332,
    "h": 80.7639846801758,
    "CMY_C": 0.40815317630768,
    "CMY_M": 0.44514536857605,
    "CMY_Y": 0.49982458353043,
    "CMYK_C": 0,
    "CMYK_M": 0.06250298023224,
    "CMYK_Y": 0.15489043295383,
    "CMYK_K": 0.40815317630768
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0026",
    "Farbtonhilfsbezeichnung": "No 26 Understatement",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "217",
    "Bcolor": "203",
    "Y": 69.9046401977539,
    "L": 86.9500732421875,
    "a": 1.26014876365662,
    "b": 7.05042839050293,
    "C": 7.16215848922729,
    "h": 79.866325378418,
    "CMY_C": 0.11380213499069,
    "CMY_M": 0.15048032999039,
    "CMY_Y": 0.20421260595322,
    "CMYK_C": 0,
    "CMYK_M": 0.04138826951385,
    "CMYK_Y": 0.1020206362009,
    "CMYK_K": 0.11380213499069
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0027",
    "Farbtonhilfsbezeichnung": "No 27 Flokati Frill",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "213",
    "Bcolor": "194",
    "Y": 68.4262161254883,
    "L": 86.219123840332,
    "a": 3.04403901100159,
    "b": 10.8959875106812,
    "C": 11.3132095336914,
    "h": 74.3910980224609,
    "CMY_C": 0.09764325618744,
    "CMY_M": 0.16380578279495,
    "CMY_Y": 0.24004507064819,
    "CMYK_C": 0,
    "CMYK_M": 0.07332191616297,
    "CMYK_Y": 0.15781100094318,
    "CMYK_K": 0.09764325618744
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0028",
    "Farbtonhilfsbezeichnung": "No 28 Greek Diner",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "199",
    "Bcolor": "172",
    "Y": 59.0810241699219,
    "L": 81.3361129760742,
    "a": 3.16029477119446,
    "b": 15.5119686126709,
    "C": 15.830623626709,
    "h": 78.4845733642578,
    "CMY_C": 0.1391915678978,
    "CMY_M": 0.21857535839081,
    "CMY_Y": 0.32565718889236,
    "CMYK_C": 0,
    "CMYK_M": 0.09222004562616,
    "CMYK_Y": 0.21661686897278,
    "CMYK_K": 0.1391915678978
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0029",
    "Farbtonhilfsbezeichnung": "No 29 Boogaloo",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "193",
    "Bcolor": "177",
    "Y": 54.8382949829102,
    "L": 78.9480285644531,
    "a": 2.59468293190002,
    "b": 9.54945945739746,
    "C": 9.89568328857422,
    "h": 74.7991485595703,
    "CMY_C": 0.18522995710373,
    "CMY_M": 0.24163454771042,
    "CMY_Y": 0.3077712059021,
    "CMYK_C": 0,
    "CMYK_M": 0.06922762095928,
    "CMYK_Y": 0.1503998041153,
    "CMYK_K": 0.18522995710373
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0030",
    "Farbtonhilfsbezeichnung": "No 30 Bungee",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "158",
    "Bcolor": "136",
    "Y": 35.2095260620117,
    "L": 65.9114685058594,
    "a": 2.02405476570129,
    "b": 12.7751731872559,
    "C": 12.9345216751099,
    "h": 80.9970855712891,
    "CMY_C": 0.32183283567429,
    "CMY_M": 0.37931942939758,
    "CMY_Y": 0.4653052687645,
    "CMYK_C": 0,
    "CMYK_M": 0.08476758748293,
    "CMYK_Y": 0.2115591019392,
    "CMYK_K": 0.32183283567429
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0031",
    "Farbtonhilfsbezeichnung": "No 31 Pillbox",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "212",
    "Bcolor": "202",
    "Y": 66.6503067016602,
    "L": 85.3270416259766,
    "a": 1.0878666639328,
    "b": 5.07516574859619,
    "C": 5.19044923782349,
    "h": 77.9016647338867,
    "CMY_C": 0.13913559913635,
    "CMY_M": 0.16741245985031,
    "CMY_Y": 0.20734143257141,
    "CMYK_C": 0,
    "CMYK_M": 0.03284705430269,
    "CMYK_Y": 0.07922947406769,
    "CMYK_K": 0.13913559913635
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0032",
    "Farbtonhilfsbezeichnung": "No 32 Nude",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "198",
    "Bcolor": "186",
    "Y": 58.9522857666016,
    "L": 81.2653579711914,
    "a": 5.37848997116089,
    "b": 7.68658018112183,
    "C": 9.38145351409912,
    "h": 55.0185661315918,
    "CMY_C": 0.14478635787964,
    "CMY_M": 0.2227566242218,
    "CMY_Y": 0.26931869983673,
    "CMYK_C": 0,
    "CMYK_M": 0.0911705121398,
    "CMYK_Y": 0.14561547338963,
    "CMYK_K": 0.14478635787964
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0033",
    "Farbtonhilfsbezeichnung": "No 33 Global Gypset",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "196",
    "Bcolor": "188",
    "Y": 56.4752807617188,
    "L": 79.8835525512695,
    "a": 2.63103866577148,
    "b": 4.80300283432007,
    "C": 5.47642230987549,
    "h": 61.2864952087402,
    "CMY_C": 0.18832242488861,
    "CMY_M": 0.23037499189377,
    "CMY_Y": 0.2636496424675,
    "CMYK_C": 0,
    "CMYK_M": 0.05180944874883,
    "CMYK_Y": 0.09280435740948,
    "CMYK_K": 0.18832242488861
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0034",
    "Farbtonhilfsbezeichnung": "No 34 Code Lisa",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "181",
    "Bcolor": "173",
    "Y": 46.8976211547852,
    "L": 74.1242370605469,
    "a": 1.91690075397491,
    "b": 4.46047782897949,
    "C": 4.85493278503418,
    "h": 66.744270324707,
    "CMY_C": 0.25711047649384,
    "CMY_M": 0.29051065444946,
    "CMY_Y": 0.3223083615303,
    "CMYK_C": 0,
    "CMYK_M": 0.04495981708169,
    "CMYK_Y": 0.08776255697012,
    "CMYK_K": 0.25711047649384
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0035",
    "Farbtonhilfsbezeichnung": "No 35 Nouvelle Vague",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "171",
    "Bcolor": "167",
    "Y": 41.3543548583984,
    "L": 70.4234771728516,
    "a": 1.57298231124878,
    "b": 2.21014714241028,
    "C": 2.71275210380554,
    "h": 54.5601844787598,
    "CMY_C": 0.30599248409271,
    "CMY_M": 0.32839578390121,
    "CMY_Y": 0.34524780511856,
    "CMYK_C": 0,
    "CMYK_M": 0.03228106349707,
    "CMYK_Y": 0.0565632507205,
    "CMYK_K": 0.30599248409271
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0036",
    "Farbtonhilfsbezeichnung": "No 36 Petticoat",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 81.0916900634766,
    "L": 92.172477722168,
    "a": 3.21089196205139,
    "b": 2.54336357116699,
    "C": 4.09615993499756,
    "h": 38.3829193115234,
    "CMY_C": 0.05451542139053,
    "CMY_M": 0.09600120782852,
    "CMY_Y": 0.11352354288101,
    "CMYK_C": 0,
    "CMYK_M": 0.04387780278921,
    "CMYK_Y": 0.0624104551971,
    "CMYK_K": 0.05451542139053
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0037",
    "Farbtonhilfsbezeichnung": "No 37 Kiss Catch",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 67.4619216918945,
    "L": 85.7366790771484,
    "a": 5.57803964614868,
    "b": 3.23179316520691,
    "C": 6.44662809371948,
    "h": 30.0870552062988,
    "CMY_C": 0.10657489299774,
    "CMY_M": 0.17323523759842,
    "CMY_Y": 0.188780605793,
    "CMYK_C": 0,
    "CMYK_M": 0.07461212575436,
    "CMYK_Y": 0.0920118689537,
    "CMYK_K": 0.10657489299774
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0038",
    "Farbtonhilfsbezeichnung": "No 38 Bubblegum",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "209",
    "Bcolor": "210",
    "Y": 69.8040924072266,
    "L": 86.9006881713867,
    "a": 13.159423828125,
    "b": 3.26070880889893,
    "C": 13.5573835372925,
    "h": 13.9167404174805,
    "CMY_C": 0.03832125663757,
    "CMY_M": 0.1797246336937,
    "CMY_Y": 0.17520648241043,
    "CMYK_C": 0,
    "CMYK_M": 0.14703805744648,
    "CMYK_Y": 0.14233987033367,
    "CMYK_K": 0.03832125663757
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0039",
    "Farbtonhilfsbezeichnung": "No 39 So Boho",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "169",
    "Bcolor": "166",
    "Y": 43.0284385681152,
    "L": 71.5742645263672,
    "a": 10.2495079040527,
    "b": 4.57439422607422,
    "C": 11.2239694595337,
    "h": 24.0513877868652,
    "CMY_C": 0.22561436891556,
    "CMY_M": 0.3376356959343,
    "CMY_Y": 0.34861433506012,
    "CMYK_C": 0,
    "CMYK_M": 0.14465832710266,
    "CMYK_Y": 0.15883554518223,
    "CMYK_K": 0.22561436891556
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0040",
    "Farbtonhilfsbezeichnung": "No 40 Vamp",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "142",
    "Bcolor": "137",
    "Y": 28.3605899810791,
    "L": 60.2131156921387,
    "a": 5.51577138900757,
    "b": 4.15624856948853,
    "C": 6.9063835144043,
    "h": 36.9987869262695,
    "CMY_C": 0.3801149725914,
    "CMY_M": 0.44399839639664,
    "CMY_Y": 0.46291279792786,
    "CMYK_C": 0,
    "CMYK_M": 0.10305689275265,
    "CMYK_Y": 0.13356964290142,
    "CMYK_K": 0.3801149725914
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0041",
    "Farbtonhilfsbezeichnung": "No 41 Marshmallow",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "233",
    "Bcolor": "233",
    "Y": 82.7414169311523,
    "L": 92.9011077880859,
    "a": 2.46718978881836,
    "b": -0.26889875531197,
    "C": 2.4818000793457,
    "h": 353.779876708984,
    "CMY_C": 0.06138741970062,
    "CMY_M": 0.08523952960968,
    "CMY_Y": 0.08466994762421,
    "CMYK_C": 0,
    "CMYK_M": 0.02541209198534,
    "CMYK_Y": 0.02480525895953,
    "CMYK_K": 0.06138741970062
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0042",
    "Farbtonhilfsbezeichnung": "No 42 Sky On Mars",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "202",
    "Bcolor": "200",
    "Y": 60.8638763427734,
    "L": 82.3055114746094,
    "a": 4.28673028945923,
    "b": 2.06384754180908,
    "C": 4.75768041610718,
    "h": 25.7085018157959,
    "CMY_C": 0.157790184021,
    "CMY_M": 0.20728141069412,
    "CMY_Y": 0.21763068437576,
    "CMYK_C": 0,
    "CMYK_M": 0.05876353755593,
    "CMYK_Y": 0.07105176895857,
    "CMYK_K": 0.157790184021
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0043",
    "Farbtonhilfsbezeichnung": "No 43 Blush",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "143",
    "Bcolor": "143",
    "Y": 40.4906539916992,
    "L": 69.8175811767578,
    "a": 37.3636131286621,
    "b": 15.8464584350586,
    "C": 40.5850944519043,
    "h": 22.982515335083,
    "CMY_C": 0.05294615030289,
    "CMY_M": 0.43805456161499,
    "CMY_Y": 0.44090729951859,
    "CMYK_C": 0,
    "CMYK_M": 0.40663835406303,
    "CMYK_Y": 0.40965056419373,
    "CMYK_K": 0.05294615030289
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0044",
    "Farbtonhilfsbezeichnung": "No 44 Mini",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "156",
    "Bcolor": "174",
    "Y": 44.0039710998535,
    "L": 72.2311553955078,
    "a": 31.5150947570801,
    "b": 1.7429141998291,
    "C": 31.56325340271,
    "h": 3.16546750068665,
    "CMY_C": 0.08725321292877,
    "CMY_M": 0.38938677310944,
    "CMY_Y": 0.31865859031677,
    "CMYK_C": 0,
    "CMYK_M": 0.33101573586464,
    "CMYK_Y": 0.25352635979652,
    "CMYK_K": 0.08725321292877
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0045",
    "Farbtonhilfsbezeichnung": "No 45 Untitled Pink",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "96",
    "Bcolor": "117",
    "Y": 23.0946922302246,
    "L": 55.1697425842285,
    "a": 46.567024230957,
    "b": 9.18477630615234,
    "C": 47.4641761779785,
    "h": 11.1576747894287,
    "CMY_C": 0.18394768238068,
    "CMY_M": 0.62321054935455,
    "CMY_Y": 0.53991651535034,
    "CMYK_C": 0,
    "CMYK_M": 0.53827780485153,
    "CMYK_Y": 0.43620833754539,
    "CMYK_K": 0.18394768238068
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0046",
    "Farbtonhilfsbezeichnung": "No 46 B-boy",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "214",
    "Bcolor": "215",
    "Y": 67.0977935791016,
    "L": 85.5533065795898,
    "a": -0.08702540397644,
    "b": -1.36488604545593,
    "C": 1.36765766143799,
    "h": 266.351745605469,
    "CMY_C": 0.16690969467163,
    "CMY_M": 0.16036748886108,
    "CMY_Y": 0.15799087285995,
    "CMYK_C": 0.01059230975807,
    "CMYK_M": 0.00282255373895,
    "CMYK_Y": 0,
    "CMYK_K": 0.15799087285995
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0047",
    "Farbtonhilfsbezeichnung": "No 47 Unisex",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "171",
    "Bcolor": "166",
    "Y": 42.1576652526855,
    "L": 70.9794845581055,
    "a": 4.73659324645996,
    "b": 3.66120600700378,
    "C": 5.9866304397583,
    "h": 37.7026557922363,
    "CMY_C": 0.2729309797287,
    "CMY_M": 0.33026570081711,
    "CMY_Y": 0.34919565916061,
    "CMYK_C": 0,
    "CMYK_M": 0.07885733246803,
    "CMYK_Y": 0.10489331185818,
    "CMYK_K": 0.2729309797287
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0048",
    "Farbtonhilfsbezeichnung": "No 48 Sputnik",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "151",
    "Bcolor": "157",
    "Y": 31.3180541992188,
    "L": 62.7752075195313,
    "a": 1.64205396175385,
    "b": -3.38411498069763,
    "C": 3.76145911216736,
    "h": 295.8837890625,
    "CMY_C": 0.40353137254715,
    "CMY_M": 0.40686696767807,
    "CMY_Y": 0.38584351539612,
    "CMYK_C": 0.02880024537444,
    "CMYK_M": 0.03423142433167,
    "CMYK_Y": 0,
    "CMYK_K": 0.38584351539612
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0049",
    "Farbtonhilfsbezeichnung": "No 49 Punk Purple",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "131",
    "Bcolor": "141",
    "Y": 23.5651798248291,
    "L": 55.649787902832,
    "a": 5.35417175292969,
    "b": -5.26733732223511,
    "C": 7.51079225540161,
    "h": 315.468414306641,
    "CMY_C": 0.45586025714874,
    "CMY_M": 0.48728436231613,
    "CMY_Y": 0.44552105665207,
    "CMYK_C": 0.01864669658244,
    "CMYK_M": 0.0753199160099,
    "CMYK_Y": 0,
    "CMYK_K": 0.44552105665207
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0050",
    "Farbtonhilfsbezeichnung": "No 50 Fetish",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "85",
    "Bcolor": "95",
    "Y": 9.603835105896,
    "L": 37.1218109130859,
    "a": 4.32120847702026,
    "b": -5.30607223510742,
    "C": 6.8430438041687,
    "h": 309.158996582031,
    "CMY_C": 0.64476627111435,
    "CMY_M": 0.66478776931763,
    "CMY_Y": 0.62696254253387,
    "CMYK_C": 0.0477263815701,
    "CMYK_M": 0.10139793157578,
    "CMYK_Y": 0,
    "CMYK_K": 0.62696254253387
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0051",
    "Farbtonhilfsbezeichnung": "No 51 Grey Matter",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "195",
    "Bcolor": "194",
    "Y": 54.6504440307617,
    "L": 78.8394927978516,
    "a": 0.69102168083191,
    "b": -0.40356558561325,
    "C": 0.80023503303528,
    "h": 329.714508056641,
    "CMY_C": 0.23076528310776,
    "CMY_M": 0.23570483922958,
    "CMY_Y": 0.23764926195145,
    "CMYK_C": 0,
    "CMYK_M": 0.00642138998955,
    "CMYK_Y": 0.00894912611693,
    "CMYK_K": 0.23076528310776
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0052",
    "Farbtonhilfsbezeichnung": "No 52 Woogie",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "207",
    "Bcolor": "226",
    "Y": 63.6727027893066,
    "L": 83.7950668334961,
    "a": 4.755126953125,
    "b": -10.2713499069214,
    "C": 11.3186511993408,
    "h": 294.841796875,
    "CMY_C": 0.18030577898026,
    "CMY_M": 0.18845057487488,
    "CMY_Y": 0.11180859804153,
    "CMYK_C": 0.07711984217167,
    "CMYK_M": 0.08628993481398,
    "CMYK_Y": 0,
    "CMYK_K": 0.11180859804153
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0053",
    "Farbtonhilfsbezeichnung": "No 53 Ultra Ultra Violet",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "157",
    "Bcolor": "179",
    "Y": 33.6600914001465,
    "L": 64.6918640136719,
    "a": 2.01488709449768,
    "b": -13.1092863082886,
    "C": 13.2632255554199,
    "h": 278.737945556641,
    "CMY_C": 0.41714507341385,
    "CMY_M": 0.38493025302887,
    "CMY_Y": 0.29886698722839,
    "CMYK_C": 0.1686956435442,
    "CMYK_M": 0.12274884432554,
    "CMYK_Y": 0,
    "CMYK_K": 0.29886698722839
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0054",
    "Farbtonhilfsbezeichnung": "No 54 Fiction",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "102",
    "Bcolor": "131",
    "Y": 13.4766654968262,
    "L": 43.4728546142578,
    "a": 3.84871888160706,
    "b": -17.522668838501,
    "C": 17.9403610229492,
    "h": 282.387878417969,
    "CMY_C": 0.63429486751556,
    "CMY_M": 0.59985589981079,
    "CMY_Y": 0.48799782991409,
    "CMYK_C": 0.2857351899147,
    "CMYK_M": 0.21847186982632,
    "CMYK_Y": 0,
    "CMYK_K": 0.48799782991409
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0055",
    "Farbtonhilfsbezeichnung": "No 55 Denim",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "84",
    "Bcolor": "111",
    "Y": 8.65776824951172,
    "L": 35.3168487548828,
    "a": 1.33242571353912,
    "b": -18.3315944671631,
    "C": 18.3799533843994,
    "h": 274.1572265625,
    "CMY_C": 0.73693305253983,
    "CMY_M": 0.67139971256256,
    "CMY_Y": 0.56369817256927,
    "CMYK_C": 0.39705285429955,
    "CMYK_M": 0.24685099720955,
    "CMYK_Y": 0,
    "CMYK_K": 0.56369817256927
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0056",
    "Farbtonhilfsbezeichnung": "No 56 Pearls",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 76.5008697509766,
    "L": 90.0913848876953,
    "a": -1.08210682868958,
    "b": -2.62446141242981,
    "C": 2.83879423141479,
    "h": 247.592864990234,
    "CMY_C": 0.12930375337601,
    "CMY_M": 0.10743498802185,
    "CMY_Y": 0.09888827800751,
    "CMYK_C": 0.03375327959657,
    "CMYK_M": 0.00948462821543,
    "CMYK_Y": 0,
    "CMYK_K": 0.09888827800751
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0057",
    "Farbtonhilfsbezeichnung": "No 57 Babyboom",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "201",
    "Bcolor": "225",
    "Y": 56.4431610107422,
    "L": 79.8653717041016,
    "a": -2.64593839645386,
    "b": -15.6096048355103,
    "C": 15.8322696685791,
    "h": 260.37939453125,
    "CMY_C": 0.3073678612709,
    "CMY_M": 0.21234905719757,
    "CMY_Y": 0.11745095252991,
    "CMYK_C": 0.21519133448601,
    "CMYK_M": 0.10752728581429,
    "CMYK_Y": 0,
    "CMYK_K": 0.11745095252991
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0058",
    "Farbtonhilfsbezeichnung": "No 58 Copacabana",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "169",
    "Bcolor": "217",
    "Y": 37.3729705810547,
    "L": 67.5559158325195,
    "a": -3.79689574241638,
    "b": -30.3312072753906,
    "C": 30.5679340362549,
    "h": 262.864776611328,
    "CMY_C": 0.53492349386215,
    "CMY_M": 0.33632278442383,
    "CMY_Y": 0.14849925041199,
    "CMYK_C": 0.45381551980972,
    "CMYK_M": 0.22057941555977,
    "CMYK_Y": 0,
    "CMYK_K": 0.14849925041199
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0059",
    "Farbtonhilfsbezeichnung": "No 59 Deca-dance",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "116",
    "Bcolor": "141",
    "Y": 16.9429607391357,
    "L": 48.1880874633789,
    "a": -0.84428817033768,
    "b": -16.429407119751,
    "C": 16.4510860443115,
    "h": 267.058227539063,
    "CMY_C": 0.62186568975449,
    "CMY_M": 0.54464054107666,
    "CMY_Y": 0.44797855615616,
    "CMYK_C": 0.31500068306923,
    "CMYK_M": 0.17510548233986,
    "CMYK_Y": 0,
    "CMYK_K": 0.44797855615616
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0060",
    "Farbtonhilfsbezeichnung": "No 60 Ode To Joy",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "85",
    "Bcolor": "135",
    "Y": 9.43074035644531,
    "L": 36.8007316589355,
    "a": 7.38852167129517,
    "b": -30.5203037261963,
    "C": 31.4018974304199,
    "h": 283.608642578125,
    "CMY_C": 0.74278295040131,
    "CMY_M": 0.66540324687958,
    "CMY_Y": 0.47199326753616,
    "CMYK_C": 0.51285272836685,
    "CMYK_M": 0.36630210280418,
    "CMYK_Y": 0,
    "CMYK_K": 0.47199326753616
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0062",
    "Farbtonhilfsbezeichnung": "No 62 Stonewashed",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "157",
    "Bcolor": "160",
    "Y": 32.7037200927734,
    "L": 63.9202880859375,
    "a": -2.82137775421143,
    "b": -3.53885722160339,
    "C": 4.5258903503418,
    "h": 231.436157226562,
    "CMY_C": 0.42622071504593,
    "CMY_M": 0.38522213697433,
    "CMY_Y": 0.37348181009293,
    "CMYK_C": 0.08417776972055,
    "CMYK_M": 0.0187390036881,
    "CMYK_Y": 0,
    "CMYK_K": 0.37348181009293
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0063",
    "Farbtonhilfsbezeichnung": "No 63 Anime",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "150",
    "Bcolor": "171",
    "Y": 29.1316184997559,
    "L": 60.8976097106934,
    "a": -3.2274649143219,
    "b": -14.7402324676514,
    "C": 15.0894327163696,
    "h": 257.649627685547,
    "CMY_C": 0.50711739063263,
    "CMY_M": 0.41229748725891,
    "CMY_Y": 0.32823050022125,
    "CMYK_C": 0.266292065382,
    "CMYK_M": 0.12514260411263,
    "CMYK_Y": 0,
    "CMYK_K": 0.32823050022125
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0064",
    "Farbtonhilfsbezeichnung": "No 64 Virtual Reality",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "101",
    "Bcolor": "119",
    "Y": 12.6693086624146,
    "L": 42.2606925964355,
    "a": -0.28733947873116,
    "b": -12.3334035873413,
    "C": 12.3367500305176,
    "h": 268.665374755859,
    "CMY_C": 0.65551507472992,
    "CMY_M": 0.60462117195129,
    "CMY_Y": 0.53364193439484,
    "CMYK_C": 0.26132953166962,
    "CMYK_M": 0.15219901502132,
    "CMYK_Y": 0,
    "CMYK_K": 0.53364193439484
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0065",
    "Farbtonhilfsbezeichnung": "No 65 Skater",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "87",
    "Bcolor": "95",
    "Y": 9.11075210571289,
    "L": 36.196662902832,
    "a": -3.75666737556458,
    "b": -6.89096307754517,
    "C": 7.84843444824219,
    "h": 241.402618408203,
    "CMY_C": 0.71665197610855,
    "CMY_M": 0.65695238113403,
    "CMY_Y": 0.62669038772583,
    "CMYK_C": 0.24098385870457,
    "CMYK_M": 0.08106406033039,
    "CMYK_Y": 0,
    "CMYK_K": 0.62669038772583
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0066",
    "Farbtonhilfsbezeichnung": "No 66 Innocence",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "238",
    "Bcolor": "231",
    "Y": 83.2177963256836,
    "L": 93.1097106933594,
    "a": -4.46578931808472,
    "b": 1.00197172164917,
    "C": 4.57681369781494,
    "h": 167.354202270508,
    "CMY_C": 0.11024159193039,
    "CMY_M": 0.06686502695084,
    "CMY_Y": 0.09276723861694,
    "CMYK_C": 0.04648477211595,
    "CMYK_M": 0,
    "CMYK_Y": 0.02775826863945,
    "CMYK_K": 0.06686502695084
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0067",
    "Farbtonhilfsbezeichnung": "No 67 Pin-up",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "214",
    "Bcolor": "208",
    "Y": 64.4601135253906,
    "L": 84.2047576904297,
    "a": -6.38112926483154,
    "b": 0.13064585626125,
    "C": 6.38246631622314,
    "h": 178.827102661133,
    "CMY_C": 0.22701835632324,
    "CMY_M": 0.16130918264389,
    "CMY_Y": 0.18445706367493,
    "CMYK_C": 0.07834731787443,
    "CMYK_M": 0,
    "CMYK_Y": 0.02760001644492,
    "CMYK_K": 0.16130918264389
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0068",
    "Farbtonhilfsbezeichnung": "No 68 Plage De Pampelonne",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "195",
    "Bcolor": "193",
    "Y": 51.8986930847168,
    "L": 77.2202224731445,
    "a": -6.5591869354248,
    "b": -2.28436374664307,
    "C": 6.94559240341187,
    "h": 199.20166015625,
    "CMY_C": 0.312584400177,
    "CMY_M": 0.2364736199379,
    "CMY_Y": 0.24248313903809,
    "CMYK_C": 0.09968323260546,
    "CMYK_M": 0,
    "CMYK_Y": 0.00787074211985,
    "CMYK_K": 0.2364736199379
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0069",
    "Farbtonhilfsbezeichnung": "No 69 Neon Grey",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "156",
    "Bcolor": "160",
    "Y": 31.7585563659668,
    "L": 63.1428298950195,
    "a": -6.00039100646973,
    "b": -4.63329648971558,
    "C": 7.5810375213623,
    "h": 217.674087524414,
    "CMY_C": 0.46372509002686,
    "CMY_M": 0.38632327318192,
    "CMY_Y": 0.37437909841537,
    "CMYK_C": 0.14281171560287,
    "CMYK_M": 0.01909171231091,
    "CMYK_Y": 0,
    "CMYK_K": 0.37437909841537
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0070",
    "Farbtonhilfsbezeichnung": "No 70 Trippy",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "87",
    "Bcolor": "83",
    "Y": 9.2584867477417,
    "L": 36.4772796630859,
    "a": -1.60321855545044,
    "b": 1.16652178764343,
    "C": 1.98269581794739,
    "h": 143.959899902344,
    "CMY_C": 0.67088437080383,
    "CMY_M": 0.66043174266815,
    "CMY_Y": 0.67377901077271,
    "CMYK_C": 0.03078211285174,
    "CMYK_M": 0,
    "CMYK_Y": 0.03930658474565,
    "CMYK_K": 0.66043174266815
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0071",
    "Farbtonhilfsbezeichnung": "No 71 Bikini",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "236",
    "Bcolor": "208",
    "Y": 80.6847076416016,
    "L": 91.9912109375,
    "a": -7.71074533462524,
    "b": 11.4776287078857,
    "C": 13.8272037506104,
    "h": 123.893455505371,
    "CMY_C": 0.11354404687881,
    "CMY_M": 0.07479739189148,
    "CMY_Y": 0.18357616662979,
    "CMYK_C": 0.0418791025877,
    "CMYK_M": 0,
    "CMYK_Y": 0.11757292598486,
    "CMYK_K": 0.07479739189148
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0072",
    "Farbtonhilfsbezeichnung": "No 72 Benjamin",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "199",
    "Bcolor": "183",
    "Y": 55.7498207092285,
    "L": 79.4712219238281,
    "a": -4.83596467971802,
    "b": 6.39043998718262,
    "C": 8.01400470733643,
    "h": 127.116607666016,
    "CMY_C": 0.24435859918594,
    "CMY_M": 0.21815371513367,
    "CMY_Y": 0.28055518865585,
    "CMYK_C": 0.03351667150855,
    "CMYK_M": 0,
    "CMYK_Y": 0.07981296628714,
    "CMYK_K": 0.21815371513367
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0073",
    "Farbtonhilfsbezeichnung": "No 73 Jukebox",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "207",
    "Bcolor": "187",
    "Y": 58.4795761108398,
    "L": 81.0046920776367,
    "a": -10.8874425888062,
    "b": 6.55624103546143,
    "C": 12.7090797424316,
    "h": 148.9443359375,
    "CMY_C": 0.27557158470154,
    "CMY_M": 0.18836736679077,
    "CMY_Y": 0.2662735581398,
    "CMYK_C": 0.10744296759367,
    "CMYK_M": 0,
    "CMYK_Y": 0.09598701447248,
    "CMYK_K": 0.18836736679077
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0074",
    "Farbtonhilfsbezeichnung": "No 74 Capacandy",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "206",
    "Bcolor": "169",
    "Y": 53.8296775817871,
    "L": 78.3623123168945,
    "a": -25.1144275665283,
    "b": 12.0422840118408,
    "C": 27.8523082733154,
    "h": 154.382431030273,
    "CMY_C": 0.40745317935944,
    "CMY_M": 0.19033575057983,
    "CMY_Y": 0.33600121736526,
    "CMYK_C": 0.26815736293793,
    "CMYK_M": 0,
    "CMYK_Y": 0.1799084842205,
    "CMYK_K": 0.19033575057983
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0075",
    "Farbtonhilfsbezeichnung": "No 75 Balloon Dog",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "148",
    "Bcolor": "137",
    "Y": 28.5523452758789,
    "L": 60.3844985961914,
    "a": -4.94174337387085,
    "b": 4.31688690185547,
    "C": 6.56173324584961,
    "h": 138.860977172852,
    "CMY_C": 0.45197761058807,
    "CMY_M": 0.41934204101563,
    "CMY_Y": 0.46369940042496,
    "CMYK_C": 0.05620446428657,
    "CMYK_M": 0,
    "CMYK_Y": 0.07639154791832,
    "CMYK_K": 0.41934204101563
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0077",
    "Farbtonhilfsbezeichnung": "No 77 Tilia",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "229",
    "Bcolor": "145",
    "Y": 74.2336578369141,
    "L": 89.0327987670898,
    "a": -12.5477752685547,
    "b": 40.134220123291,
    "C": 42.0499992370605,
    "h": 107.361602783203,
    "CMY_C": 0.10991472005844,
    "CMY_M": 0.10310572385788,
    "CMY_Y": 0.43274170160294,
    "CMYK_C": 0.0075917490758,
    "CMYK_M": 0,
    "CMYK_Y": 0.36753046512604,
    "CMYK_K": 0.10310572385788
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0078",
    "Farbtonhilfsbezeichnung": "No 78 Green Trick",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "196",
    "Bcolor": "123",
    "Y": 51.6034202575684,
    "L": 77.043098449707,
    "a": -13.4671154022217,
    "b": 35.1299743652344,
    "C": 37.6228408813477,
    "h": 110.974380493164,
    "CMY_C": 0.26051276922226,
    "CMY_M": 0.23196893930435,
    "CMY_Y": 0.51754665374756,
    "CMYK_C": 0.03716494143009,
    "CMYK_M": 0,
    "CMYK_Y": 0.37183094024658,
    "CMYK_K": 0.23196893930435
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0079",
    "Farbtonhilfsbezeichnung": "No 79 Kingston",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "165",
    "Bcolor": "98",
    "Y": 33.2882232666016,
    "L": 64.3936080932617,
    "a": -20.9502372741699,
    "b": 31.0559558868408,
    "C": 37.4617767333984,
    "h": 124.003463745117,
    "CMY_C": 0.45962136983871,
    "CMY_M": 0.35180085897446,
    "CMY_Y": 0.61430329084396,
    "CMYK_C": 0.16633856296539,
    "CMYK_M": 0,
    "CMYK_Y": 0.40497189760208,
    "CMYK_K": 0.35180085897446
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0080",
    "Farbtonhilfsbezeichnung": "No 80 Youthquake",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "159",
    "Bcolor": "107",
    "Y": 28.2314605712891,
    "L": 60.0972785949707,
    "a": -31.2042140960693,
    "b": 20.4969596862793,
    "C": 37.3340110778809,
    "h": 146.700485229492,
    "CMY_C": 0.62205064296722,
    "CMY_M": 0.37788218259811,
    "CMY_Y": 0.58203333616257,
    "CMYK_C": 0.39247944951057,
    "CMYK_M": 0,
    "CMYK_Y": 0.32815513014793,
    "CMYK_K": 0.37788218259811
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0081",
    "Farbtonhilfsbezeichnung": "No 81 Unbutton",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "211",
    "Bcolor": "176",
    "Y": 64.3495178222656,
    "L": 84.1474151611328,
    "a": -2.87939286231995,
    "b": 17.3208694458008,
    "C": 17.5585708618164,
    "h": 99.4384460449219,
    "CMY_C": 0.14682984352112,
    "CMY_M": 0.17415881156921,
    "CMY_Y": 0.31024050712585,
    "CMYK_C": 0,
    "CMYK_M": 0.03203225880861,
    "CMYK_Y": 0.19153349101543,
    "CMYK_K": 0.14682984352112
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0082",
    "Farbtonhilfsbezeichnung": "No 82 Treehugger",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "188",
    "Bcolor": "164",
    "Y": 49.4981269836426,
    "L": 75.7601776123047,
    "a": -3.13267350196838,
    "b": 11.7088766098023,
    "C": 12.1207027435303,
    "h": 104.978492736816,
    "CMY_C": 0.25562733411789,
    "CMY_M": 0.2633239030838,
    "CMY_Y": 0.35759347677231,
    "CMYK_C": 0,
    "CMYK_M": 0.0103396717459,
    "CMYK_Y": 0.13698264956474,
    "CMYK_K": 0.25562733411789
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0083",
    "Farbtonhilfsbezeichnung": "No 83 Queen Green",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "167",
    "Bcolor": "133",
    "Y": 36.3605690002441,
    "L": 66.7945098876953,
    "a": -10.83043384552,
    "b": 15.7360019683838,
    "C": 19.1028804779053,
    "h": 124.538009643555,
    "CMY_C": 0.3965944647789,
    "CMY_M": 0.34318161010742,
    "CMY_Y": 0.47916823625565,
    "CMYK_C": 0.08132058382034,
    "CMYK_M": 0,
    "CMYK_Y": 0.20703840255737,
    "CMYK_K": 0.34318161010742
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0084",
    "Farbtonhilfsbezeichnung": "No 84 Banana Republic",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "128",
    "Bcolor": "106",
    "Y": 20.9504318237305,
    "L": 52.8952026367188,
    "a": -4.64101696014404,
    "b": 11.0076236724854,
    "C": 11.9459962844849,
    "h": 112.861183166504,
    "CMY_C": 0.50635623931885,
    "CMY_M": 0.4974759221077,
    "CMY_Y": 0.58271253108978,
    "CMYK_C": 0.01767142675817,
    "CMYK_M": 0,
    "CMYK_Y": 0.16961696743965,
    "CMYK_K": 0.4974759221077
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0085",
    "Farbtonhilfsbezeichnung": "No 85 Ivy League",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "92",
    "Bcolor": "69",
    "Y": 9.87419605255127,
    "L": 37.6156883239746,
    "a": -8.63147068023682,
    "b": 11.5808238983154,
    "C": 14.4436063766479,
    "h": 126.698059082031,
    "CMY_C": 0.68007135391235,
    "CMY_M": 0.63885617256165,
    "CMY_Y": 0.72951936721802,
    "CMYK_C": 0.11412400752306,
    "CMYK_M": 0,
    "CMYK_Y": 0.25104457139969,
    "CMYK_K": 0.63885617256165
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0086",
    "Farbtonhilfsbezeichnung": "No 86 Pooch",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "225",
    "Bcolor": "203",
    "Y": 75.7451324462891,
    "L": 89.7408752441406,
    "a": -0.42349037528038,
    "b": 11.2033224105835,
    "C": 11.2113237380981,
    "h": 92.1647796630859,
    "CMY_C": 0.08305770158768,
    "CMY_M": 0.11666411161423,
    "CMY_Y": 0.20485705137253,
    "CMYK_C": 0,
    "CMYK_M": 0.03665051609278,
    "CMYK_Y": 0.13283208012581,
    "CMYK_K": 0.08305770158768
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0087",
    "Farbtonhilfsbezeichnung": "No 87 Lounge Mix",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "211",
    "Bcolor": "192",
    "Y": 64.9532012939453,
    "L": 84.4596176147461,
    "a": -0.92468750476837,
    "b": 9.42677402496338,
    "C": 9.47201728820801,
    "h": 95.6023178100586,
    "CMY_C": 0.15078520774841,
    "CMY_M": 0.17335116863251,
    "CMY_Y": 0.24878114461899,
    "CMYK_C": 0,
    "CMYK_M": 0.02657273598015,
    "CMYK_Y": 0.11539594084024,
    "CMYK_K": 0.15078520774841
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0088",
    "Farbtonhilfsbezeichnung": "No 88 Artcore",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "193",
    "Bcolor": "164",
    "Y": 53.8876533508301,
    "L": 78.3961791992188,
    "a": 0.07024410367012,
    "b": 15.6853170394898,
    "C": 15.685474395752,
    "h": 89.7434158325195,
    "CMY_C": 0.1931871175766,
    "CMY_M": 0.24315416812897,
    "CMY_Y": 0.35821938514709,
    "CMYK_C": 0,
    "CMYK_M": 0.06193139776587,
    "CMYK_Y": 0.2045483738184,
    "CMYK_K": 0.1931871175766
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0089",
    "Farbtonhilfsbezeichnung": "No 89 Funky",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "194",
    "Bcolor": "142",
    "Y": 54.3575477600098,
    "L": 78.6697540283203,
    "a": -1.02972936630249,
    "b": 27.629638671875,
    "C": 27.6488208770752,
    "h": 92.1343688964844,
    "CMY_C": 0.17041891813278,
    "CMY_M": 0.24018281698227,
    "CMY_Y": 0.44262039661407,
    "CMYK_C": 0,
    "CMYK_M": 0.08409533649683,
    "CMYK_Y": 0.32811918854713,
    "CMYK_K": 0.17041891813278
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0090",
    "Farbtonhilfsbezeichnung": "No 90 Camouflage",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "126",
    "Bcolor": "97",
    "Y": 21.1781940460205,
    "L": 53.1439666748047,
    "a": -0.70172500610352,
    "b": 16.6889171600342,
    "C": 16.7036628723145,
    "h": 92.4077224731445,
    "CMY_C": 0.46440321207047,
    "CMY_M": 0.50429975986481,
    "CMY_Y": 0.61786544322968,
    "CMYK_C": 0,
    "CMYK_M": 0.07448989152908,
    "CMYK_Y": 0.28652566671371,
    "CMYK_K": 0.46440321207047
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0091",
    "Farbtonhilfsbezeichnung": "No 91 Popcorn",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "239",
    "Bcolor": "215",
    "Y": 85.5095367431641,
    "L": 94.1022491455078,
    "a": -1.8332234621048,
    "b": 11.2970933914185,
    "C": 11.4448690414429,
    "h": 99.2172698974609,
    "CMY_C": 0.04443693161011,
    "CMY_M": 0.06463271379471,
    "CMY_Y": 0.15826553106308,
    "CMYK_C": 0,
    "CMYK_M": 0.02113495394588,
    "CMYK_Y": 0.11912201344967,
    "CMYK_K": 0.04443693161011
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0092",
    "Farbtonhilfsbezeichnung": "No 92 Serendipity",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "176",
    "Y": 80.6398315429688,
    "L": 91.9711837768555,
    "a": -3.57121443748474,
    "b": 28.45383644104,
    "C": 28.6770706176758,
    "h": 97.1537322998047,
    "CMY_C": 0.03643095493317,
    "CMY_M": 0.08837109804153,
    "CMY_Y": 0.31050711870193,
    "CMYK_C": 0,
    "CMYK_M": 0.05390391498804,
    "CMYK_Y": 0.28443852066994,
    "CMYK_K": 0.03643095493317
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0093",
    "Farbtonhilfsbezeichnung": "No 93 Trial & Error",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "228",
    "Bcolor": "112",
    "Y": 77.6594848632813,
    "L": 90.6242904663086,
    "a": -5.2829794883728,
    "b": 58.2665023803711,
    "C": 58.5055122375488,
    "h": 95.180793762207,
    "CMY_C": 0.00950509309769,
    "CMY_M": 0.10442757606506,
    "CMY_Y": 0.56096267700195,
    "CMYK_C": 0,
    "CMYK_M": 0.09583339095116,
    "CMYK_Y": 0.556749522686,
    "CMYK_K": 0.00950509309769
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0094",
    "Farbtonhilfsbezeichnung": "No 94 Honey Hue",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "209",
    "Bcolor": "160",
    "Y": 65.2286148071289,
    "L": 84.6014022827148,
    "a": 0.51941460371017,
    "b": 26.2840595245361,
    "C": 26.289192199707,
    "h": 88.8678894042969,
    "CMY_C": 0.09594029188156,
    "CMY_M": 0.17905467748642,
    "CMY_Y": 0.37104779481888,
    "CMYK_C": 0,
    "CMYK_M": 0.09193462133408,
    "CMYK_Y": 0.30430236458778,
    "CMYK_K": 0.09594029188156
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0095",
    "Farbtonhilfsbezeichnung": "No 95 Postmodern",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "185",
    "Bcolor": "125",
    "Y": 49.7513160705566,
    "L": 75.9163665771484,
    "a": 1.21419870853424,
    "b": 32.7886619567871,
    "C": 32.8111343383789,
    "h": 87.8792495727539,
    "CMY_C": 0.17611002922058,
    "CMY_M": 0.27592200040817,
    "CMY_Y": 0.50820499658585,
    "CMYK_C": 0,
    "CMYK_M": 0.12114720791578,
    "CMYK_Y": 0.40308168530464,
    "CMYK_K": 0.17611002922058
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0096",
    "Farbtonhilfsbezeichnung": "No 96 Smile",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "198",
    "Y": 81.3240051269531,
    "L": 92.2756729125977,
    "a": -1.62366986274719,
    "b": 17.3007678985596,
    "C": 17.3767910003662,
    "h": 95.3614807128906,
    "CMY_C": 0.04646295309067,
    "CMY_M": 0.08707344532013,
    "CMY_Y": 0.22300499677658,
    "CMYK_C": 0,
    "CMYK_M": 0.04258931800723,
    "CMYK_Y": 0.18514439463615,
    "CMYK_K": 0.04646295309067
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0097",
    "Farbtonhilfsbezeichnung": "No 97 Flower Power",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "212",
    "Bcolor": "128",
    "Y": 68.567985534668,
    "L": 86.2896728515625,
    "a": 2.25576758384705,
    "b": 45.5394096374512,
    "C": 45.5952453613281,
    "h": 87.1641998291016,
    "CMY_C": 0.02892661094666,
    "CMY_M": 0.16824191808701,
    "CMY_Y": 0.49970072507858,
    "CMYK_C": 0,
    "CMYK_M": 0.14346526563168,
    "CMYK_Y": 0.4847976565361,
    "CMYK_K": 0.02892661094666
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0098",
    "Farbtonhilfsbezeichnung": "No 98 Loopy",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "96",
    "Y": 69.5037536621094,
    "L": 86.7528991699219,
    "a": 6.83011722564697,
    "b": 61.5254096984863,
    "C": 61.9033660888672,
    "h": 83.6653671264648,
    "CMY_C": 0,
    "CMY_M": 0.17680895328522,
    "CMY_Y": 0.62524926662445,
    "CMYK_C": 0,
    "CMYK_M": 0.17680895328522,
    "CMYK_Y": 0.62524926662445,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0099",
    "Farbtonhilfsbezeichnung": "No 99 Lilo",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "190",
    "Bcolor": "59",
    "Y": 60.2018966674805,
    "L": 81.9478073120117,
    "a": 16.4443264007568,
    "b": 71.4837417602539,
    "C": 73.3508071899414,
    "h": 77.0448989868164,
    "CMY_C": 0,
    "CMY_M": 0.25536060333252,
    "CMY_Y": 0.76841980218887,
    "CMYK_C": 0,
    "CMYK_M": 0.25536060333252,
    "CMYK_Y": 0.76841980218887,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0100",
    "Farbtonhilfsbezeichnung": "No 100 Psychedelic",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "193",
    "Bcolor": "107",
    "Y": 61.4202690124512,
    "L": 82.6041564941406,
    "a": 15.4919080734253,
    "b": 51.5510330200195,
    "C": 53.8285064697266,
    "h": 73.2736434936523,
    "CMY_C": 0,
    "CMY_M": 0.24319893121719,
    "CMY_Y": 0.58114242553711,
    "CMYK_C": 0,
    "CMYK_M": 0.24319893121719,
    "CMYK_Y": 0.58114242553711,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0101",
    "Farbtonhilfsbezeichnung": "No 101 Minimalist",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "240",
    "Bcolor": "223",
    "Y": 87.0797119140625,
    "L": 94.7720794677734,
    "a": -1.14688074588776,
    "b": 8.04959487915039,
    "C": 8.13088607788086,
    "h": 98.1087493896484,
    "CMY_C": 0.041479408741,
    "CMY_M": 0.05788666009903,
    "CMY_Y": 0.12650310993195,
    "CMYK_C": 0,
    "CMYK_M": 0.01711726561189,
    "CMYK_Y": 0.08870305120945,
    "CMYK_K": 0.041479408741
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0102",
    "Farbtonhilfsbezeichnung": "No 102 Be Happy",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "230",
    "Bcolor": "199",
    "Y": 80.9979934692383,
    "L": 92.1307983398438,
    "a": 2.39518785476685,
    "b": 16.5845565795898,
    "C": 16.7566242218018,
    "h": 81.7820053100586,
    "CMY_C": 0.02031993865967,
    "CMY_M": 0.09817034006119,
    "CMY_Y": 0.21854132413864,
    "CMYK_C": 0,
    "CMYK_M": 0.07946512848139,
    "CMYK_Y": 0.20233277976513,
    "CMYK_K": 0.02031993865967
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0103",
    "Farbtonhilfsbezeichnung": "No 103 Chromance",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "211",
    "Bcolor": "191",
    "Y": 67.9759674072266,
    "L": 85.9944305419922,
    "a": 6.04252862930298,
    "b": 12.2310018539429,
    "C": 13.6421976089478,
    "h": 63.7090682983398,
    "CMY_C": 0.07492291927338,
    "CMY_M": 0.173947930336,
    "CMY_Y": 0.25176823139191,
    "CMYK_C": 0,
    "CMYK_M": 0.1070451438427,
    "CMYK_Y": 0.19116818904877,
    "CMYK_K": 0.07492291927338
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0104",
    "Farbtonhilfsbezeichnung": "No 104 Catwalk",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "183",
    "Bcolor": "166",
    "Y": 49.8027000427246,
    "L": 75.947998046875,
    "a": 5.95438957214355,
    "b": 10.9476690292358,
    "C": 12.4621915817261,
    "h": 61.458423614502,
    "CMY_C": 0.19074904918671,
    "CMY_M": 0.28226447105408,
    "CMY_Y": 0.34877520799637,
    "CMYK_C": 0,
    "CMYK_M": 0.11308658123016,
    "CMYK_Y": 0.19527460634708,
    "CMYK_K": 0.19074904918671
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0105",
    "Farbtonhilfsbezeichnung": "No 105 Harvest Gold",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "132",
    "Bcolor": "117",
    "Y": 31.4351310729981,
    "L": 62.8732528686523,
    "a": 28.3117294311523,
    "b": 20.1387157440186,
    "C": 34.7436599731445,
    "h": 35.4250259399414,
    "CMY_C": 0.17869567871094,
    "CMY_M": 0.48185014724731,
    "CMY_Y": 0.54174876213074,
    "CMYK_C": 0,
    "CMYK_M": 0.36911344528198,
    "CMYK_Y": 0.44204452633858,
    "CMYK_K": 0.17869567871094
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0106",
    "Farbtonhilfsbezeichnung": "No 106 Dolled-up",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "236",
    "Bcolor": "216",
    "Y": 84.8437194824219,
    "L": 93.8157348632812,
    "a": 1.07518303394318,
    "b": 10.1455307006836,
    "C": 10.2023429870606,
    "h": 83.9505996704102,
    "CMY_C": 0.02887600660324,
    "CMY_M": 0.07450497150421,
    "CMY_Y": 0.1523425579071,
    "CMYK_C": 0,
    "CMYK_M": 0.04698572680354,
    "CMYK_Y": 0.12713778018951,
    "CMYK_K": 0.02887600660324
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0107",
    "Farbtonhilfsbezeichnung": "No 107 Eton Mess",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "220",
    "Bcolor": "189",
    "Y": 75.4151077270508,
    "L": 89.5870819091797,
    "a": 7.1089768409729,
    "b": 18.5157108306885,
    "C": 19.8335342407227,
    "h": 68.9960556030273,
    "CMY_C": 0.01079267263412,
    "CMY_M": 0.13857507705688,
    "CMY_Y": 0.25947064161301,
    "CMYK_C": 0,
    "CMYK_M": 0.12917657196522,
    "CMYK_Y": 0.25139114260674,
    "CMYK_K": 0.01079267263412
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0108",
    "Farbtonhilfsbezeichnung": "No 108 Pop Peach",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "188",
    "Bcolor": "169",
    "Y": 57.1766357421875,
    "L": 80.2788467407227,
    "a": 15.5327501296997,
    "b": 16.079309463501,
    "C": 22.3564434051514,
    "h": 45.9905204772949,
    "CMY_C": 0.06560957431793,
    "CMY_M": 0.26147353649139,
    "CMY_Y": 0.33873957395554,
    "CMYK_C": 0,
    "CMYK_M": 0.20961683988571,
    "CMYK_Y": 0.2923082113266,
    "CMYK_K": 0.06560957431793
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0109",
    "Farbtonhilfsbezeichnung": "No 109 Twist",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "170",
    "Bcolor": "138",
    "Y": 53.3012046813965,
    "L": 78.0524978637695,
    "a": 31.0434322357178,
    "b": 29.8436222076416,
    "C": 43.0620079040527,
    "h": 43.8711051940918,
    "CMY_C": 0,
    "CMY_M": 0.33349150419235,
    "CMY_Y": 0.45817732810974,
    "CMYK_C": 0,
    "CMYK_M": 0.33349150419235,
    "CMYK_Y": 0.45817732810974,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0110",
    "Farbtonhilfsbezeichnung": "No 110 Poona",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "107",
    "Bcolor": "53",
    "Y": 31.2359657287598,
    "L": 62.7063217163086,
    "a": 52.7865676879883,
    "b": 55.4154014587402,
    "C": 76.5329208374023,
    "h": 46.3917617797852,
    "CMY_C": 0.01498734951019,
    "CMY_M": 0.5817756652832,
    "CMY_Y": 0.79369699954987,
    "CMYK_C": 0,
    "CMYK_M": 0.57541221380234,
    "CMYK_Y": 0.79055804014206,
    "CMYK_K": 0.01498734951019
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0112",
    "Farbtonhilfsbezeichnung": "No 112 Hipster",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "120",
    "Bcolor": "111",
    "Y": 33.9195289611816,
    "L": 64.8986434936523,
    "a": 46.8950386047363,
    "b": 27.1789779663086,
    "C": 54.2018585205078,
    "h": 30.0953121185303,
    "CMY_C": 0.04271173477173,
    "CMY_M": 0.52783513069153,
    "CMY_Y": 0.56625664234161,
    "CMYK_C": 0,
    "CMYK_M": 0.50676834583282,
    "CMYK_Y": 0.5469041466713,
    "CMYK_K": 0.04271173477173
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0113",
    "Farbtonhilfsbezeichnung": "No 113 For Caroline",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "115",
    "Bcolor": "112",
    "Y": 29.6239261627197,
    "L": 61.328369140625,
    "a": 43.2061767578125,
    "b": 21.4636173248291,
    "C": 48.2437629699707,
    "h": 26.4168968200684,
    "CMY_C": 0.1124467253685,
    "CMY_M": 0.54930740594864,
    "CMY_Y": 0.56265306472778,
    "CMYK_C": 0,
    "CMYK_M": 0.49220785498619,
    "CMYK_Y": 0.50724428892136,
    "CMYK_K": 0.1124467253685
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0114",
    "Farbtonhilfsbezeichnung": "No 114 Hysteria",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "80",
    "Bcolor": "71",
    "Y": 22.4482727050781,
    "L": 54.499439239502,
    "a": 56.3097953796387,
    "b": 35.8323020935059,
    "C": 66.7438888549805,
    "h": 32.4703216552734,
    "CMY_C": 0.11328798532486,
    "CMY_M": 0.68443667888641,
    "CMY_Y": 0.72105777263641,
    "CMYK_C": 0,
    "CMYK_M": 0.64411973953247,
    "CMYK_Y": 0.6854196190834,
    "CMYK_K": 0.11328798532486
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0115",
    "Farbtonhilfsbezeichnung": "No 115 Electrifying",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "105",
    "Bcolor": "76",
    "Y": 40.639762878418,
    "L": 69.9227905273438,
    "a": 69.6727905273438,
    "b": 53.5590591430664,
    "C": 87.8798675537109,
    "h": 37.5503005981445,
    "CMY_C": 0,
    "CMY_M": 0.58875203132629,
    "CMY_Y": 0.70037293434143,
    "CMYK_C": 0,
    "CMYK_M": 0.58875203132629,
    "CMYK_Y": 0.70037293434143,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0116",
    "Farbtonhilfsbezeichnung": "No 116 Strawberries & Cream",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "85",
    "Bcolor": "77",
    "Y": 21.4775390625,
    "L": 53.4682121276855,
    "a": 50.8597564697266,
    "b": 31.0821132659912,
    "C": 59.6054763793945,
    "h": 31.4305095672607,
    "CMY_C": 0.1567884683609,
    "CMY_M": 0.66659337282181,
    "CMY_Y": 0.69996964931488,
    "CMYK_C": 0,
    "CMYK_M": 0.60459905862808,
    "CMYK_Y": 0.64418137073517,
    "CMYK_K": 0.1567884683609
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0117",
    "Farbtonhilfsbezeichnung": "No 117 Next Level",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "64",
    "Bcolor": "65",
    "Y": 16.9621028900146,
    "L": 48.2122535705566,
    "a": 55.7374649047852,
    "b": 30.9363594055176,
    "C": 63.7473411560059,
    "h": 29.0319004058838,
    "CMY_C": 0.19697481393814,
    "CMY_M": 0.75014585256577,
    "CMY_Y": 0.74498605728149,
    "CMYK_C": 0,
    "CMYK_M": 0.68885886669159,
    "CMYK_Y": 0.68243342638016,
    "CMYK_K": 0.19697481393814
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0118",
    "Farbtonhilfsbezeichnung": "No 118 Red Carpet",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "67",
    "Bcolor": "54",
    "Y": 17.5469169616699,
    "L": 48.9418907165527,
    "a": 54.7425079345703,
    "b": 38.0778579711914,
    "C": 66.6833190917969,
    "h": 34.8217506408691,
    "CMY_C": 0.18786942958832,
    "CMY_M": 0.73771810531616,
    "CMY_Y": 0.78719049692154,
    "CMYK_C": 0,
    "CMYK_M": 0.6770446896553,
    "CMYK_Y": 0.73796147108078,
    "CMYK_K": 0.18786942958832
  },
  {
    "Farbtonkarten_Bezeichnung": "Caparol Icons",
    "Farbton_ID": "CPI0120",
    "Farbtonhilfsbezeichnung": "No 120 Burlesque",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 8.78068923950195,
    "L": 35.5585708618164,
    "a": 30.7951698303223,
    "b": 13.0077419281006,
    "C": 33.4296836853027,
    "h": 22.8989772796631,
    "CMY_C": 0.47900646924973,
    "CMY_M": 0.7570828795433,
    "CMY_Y": 0.74996769428253,
    "CMYK_C": 0,
    "CMYK_M": 0.53374254703522,
    "CMYK_Y": 0.52008557319641,
    "CMYK_K": 0.47900646924973
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1000",
    "Farbtonhilfsbezeichnung": "RAL1000 Gruenbeige",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "186",
    "Bcolor": "138",
    "Y": 49,
    "L": 75.9263381958008,
    "a": -0.35833114385605,
    "b": 26.3058471679688,
    "C": 26.3082866668701,
    "h": 90.7804183959961,
    "CMY_C": 0.19905167818069,
    "CMY_M": 0.27096182107925,
    "CMY_Y": 0.46077638864517,
    "CMYK_C": 0,
    "CMYK_M": 0.08978125452995,
    "CMYK_Y": 0.32676854729652,
    "CMYK_K": 0.19905167818069
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1001",
    "Farbtonhilfsbezeichnung": "RAL1001 Beige",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "176",
    "Bcolor": "133",
    "Y": 45,
    "L": 73.5996322631836,
    "a": 5.33188152313232,
    "b": 25.6141357421875,
    "C": 26.1631984710693,
    "h": 78.2411346435547,
    "CMY_C": 0.1883133649826,
    "CMY_M": 0.30903017520905,
    "CMY_Y": 0.47821378707886,
    "CMYK_C": 0,
    "CMYK_M": 0.14872342348099,
    "CMYK_Y": 0.35715806484222,
    "CMYK_K": 0.1883133649826
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1002",
    "Farbtonhilfsbezeichnung": "RAL1002 Sandgelb",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "170",
    "Bcolor": "110",
    "Y": 45,
    "L": 71.9423599243164,
    "a": 7.02137184143066,
    "b": 35.6548805236816,
    "C": 36.3396492004395,
    "h": 78.8595199584961,
    "CMY_C": 0.17877453565598,
    "CMY_M": 0.33249592781067,
    "CMY_Y": 0.56781959533691,
    "CMYK_C": 0,
    "CMYK_M": 0.18718537688255,
    "CMYK_Y": 0.47373721003532,
    "CMYK_K": 0.17877453565598
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1003",
    "Farbtonhilfsbezeichnung": "RAL1003 Signalgelb",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "167",
    "Bcolor": "0",
    "Y": 44,
    "L": 74.388053894043,
    "a": 19.4329338073731,
    "b": 78.5561218261719,
    "C": 80.9240570068359,
    "h": 76.1053237915039,
    "CMY_C": 0.03417903184891,
    "CMY_M": 0.34459567070007,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.32140183448792,
    "CMYK_Y": 1,
    "CMYK_K": 0.03417903184891
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1004",
    "Farbtonhilfsbezeichnung": "RAL1004 Goldgelb",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "159",
    "Bcolor": "0",
    "Y": 40,
    "L": 70.1446228027344,
    "a": 15.6888074874878,
    "b": 74.9969024658203,
    "C": 76.6203231811523,
    "h": 78.1845245361328,
    "CMY_C": 0.1096168756485,
    "CMY_M": 0.3782747387886,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.30173286795616,
    "CMYK_Y": 1,
    "CMYK_K": 0.1096168756485
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1005",
    "Farbtonhilfsbezeichnung": "RAL1005 Honiggelb",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "144",
    "Bcolor": "21",
    "Y": 31,
    "L": 63.9073448181152,
    "a": 13.0794849395752,
    "b": 64.8718032836914,
    "C": 66.1772155761719,
    "h": 78.6008224487305,
    "CMY_C": 0.20538210868835,
    "CMY_M": 0.4347215294838,
    "CMY_Y": 0.91728174686432,
    "CMYK_C": 0,
    "CMYK_M": 0.28861597180367,
    "CMYK_Y": 0.89590185880661,
    "CMYK_K": 0.20538210868835
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1006",
    "Farbtonhilfsbezeichnung": "RAL1006 Maisgelb",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "143",
    "Bcolor": "0",
    "Y": 35,
    "L": 65.9989166259766,
    "a": 22.489725112915,
    "b": 71.9400100708008,
    "C": 75.373420715332,
    "h": 72.6398239135742,
    "CMY_C": 0.12411987781525,
    "CMY_M": 0.43985193967819,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.36047405004501,
    "CMYK_Y": 1,
    "CMYK_K": 0.12411987781525
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1007",
    "Farbtonhilfsbezeichnung": "RAL1007 Narzissengelb",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "141",
    "Bcolor": "0",
    "Y": 35,
    "L": 66.5610733032227,
    "a": 26.8561229705811,
    "b": 72.8265228271484,
    "C": 77.6205749511719,
    "h": 69.7576141357422,
    "CMY_C": 0.09304773807526,
    "CMY_M": 0.44722092151642,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3905091881752,
    "CMYK_Y": 1,
    "CMYK_K": 0.09304773807526
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1011",
    "Farbtonhilfsbezeichnung": "RAL1011 Braunbeige",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "131",
    "Bcolor": "87",
    "Y": 25,
    "L": 57.9488220214844,
    "a": 11.7519788742065,
    "b": 29.8066844940186,
    "C": 32.0397796630859,
    "h": 68.4820098876953,
    "CMY_C": 0.31514984369278,
    "CMY_M": 0.48742944002151,
    "CMY_Y": 0.66008317470551,
    "CMYK_C": 0,
    "CMYK_M": 0.25155809521675,
    "CMYK_Y": 0.50366246700287,
    "CMYK_K": 0.31514984369278
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1012",
    "Farbtonhilfsbezeichnung": "RAL1012 Zitronengelb",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "175",
    "Bcolor": "58",
    "Y": 46,
    "L": 73.6712493896484,
    "a": 4.53090381622314,
    "b": 62.5299339294434,
    "C": 62.6938743591309,
    "h": 85.8556060791016,
    "CMY_C": 0.14165443181992,
    "CMY_M": 0.31177335977554,
    "CMY_Y": 0.77426022291183,
    "CMYK_C": 0,
    "CMYK_M": 0.19819398224354,
    "CMYK_Y": 0.73700594902039,
    "CMYK_K": 0.14165443181992
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1013",
    "Farbtonhilfsbezeichnung": "RAL1013 Perlweiss",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "216",
    "Bcolor": "196",
    "Y": 70,
    "L": 86.7390060424805,
    "a": 0.20114064216614,
    "b": 10.2127895355225,
    "C": 10.2147703170776,
    "h": 88.871711730957,
    "CMY_C": 0.11478024721146,
    "CMY_M": 0.15111649036407,
    "CMY_Y": 0.22987949848175,
    "CMYK_C": 0,
    "CMYK_M": 0.04104771092534,
    "CMYK_Y": 0.13002336025238,
    "CMYK_K": 0.11478024721146
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1014",
    "Farbtonhilfsbezeichnung": "RAL1014 Elfenbein",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "153",
    "Y": 56,
    "L": 79.7566070556641,
    "a": 2.6715931892395,
    "b": 23.6829071044922,
    "C": 23.8331184387207,
    "h": 83.563850402832,
    "CMY_C": 0.14124798774719,
    "CMY_M": 0.23633241653442,
    "CMY_Y": 0.4017745256424,
    "CMYK_C": 0,
    "CMYK_M": 0.11072396486998,
    "CMYK_Y": 0.30337807536125,
    "CMYK_K": 0.14124798774719
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1015",
    "Farbtonhilfsbezeichnung": "RAL1015 Hellelfenbein",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "210",
    "Bcolor": "181",
    "Y": 65,
    "L": 84.9277420043945,
    "a": 2.10718441009521,
    "b": 15.9522161483765,
    "C": 16.0907878875732,
    "h": 82.4751663208008,
    "CMY_C": 0.10545814037323,
    "CMY_M": 0.17697304487228,
    "CMY_Y": 0.2910897731781,
    "CMYK_C": 0,
    "CMYK_M": 0.07994584739208,
    "CMYK_Y": 0.20751586556435,
    "CMYK_K": 0.10545814037323
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1016",
    "Farbtonhilfsbezeichnung": "RAL1016 Schwefelgelb",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "220",
    "Bcolor": "62",
    "Y": 70,
    "L": 86.7026519775391,
    "a": -9.85200595855713,
    "b": 73.8913269042969,
    "C": 74.5452194213867,
    "h": 97.5945129394531,
    "CMY_C": 0.06772327423096,
    "CMY_M": 0.13921064138412,
    "CMY_Y": 0.75621366500854,
    "CMYK_C": 0,
    "CMYK_M": 0.07668041437864,
    "CMYK_Y": 0.73850435018539,
    "CMYK_K": 0.06772327423096
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1017",
    "Farbtonhilfsbezeichnung": "RAL1017 Safrangelb",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "169",
    "Bcolor": "85",
    "Y": 49,
    "L": 74.9709167480469,
    "a": 19.8986759185791,
    "b": 52.9222831726074,
    "C": 56.5395927429199,
    "h": 69.3938369750977,
    "CMY_C": 0.04406988620758,
    "CMY_M": 0.33708715438843,
    "CMY_Y": 0.66765892505646,
    "CMYK_C": 0,
    "CMYK_M": 0.30652582645416,
    "CMYK_Y": 0.6523374915123,
    "CMYK_K": 0.04406988620758
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1018",
    "Farbtonhilfsbezeichnung": "RAL1018 Zinkgelb",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "202",
    "Bcolor": "62",
    "Y": 63,
    "L": 83.0194778442383,
    "a": 2.81833553314209,
    "b": 70.852783203125,
    "C": 70.9088134765625,
    "h": 87.7221298217773,
    "CMY_C": 0.03307259082794,
    "CMY_M": 0.20850521326065,
    "CMY_Y": 0.75771868228912,
    "CMYK_C": 0,
    "CMYK_M": 0.18143308162689,
    "CMYK_Y": 0.74943172931671,
    "CMYK_K": 0.03307259082794
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1019",
    "Farbtonhilfsbezeichnung": "RAL1019 Graubeige",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "143",
    "Bcolor": "123",
    "Y": 29,
    "L": 60.8286094665527,
    "a": 4.53965902328491,
    "b": 13.3027467727661,
    "C": 14.0560159683228,
    "h": 71.1574249267578,
    "CMY_C": 0.35775470733643,
    "CMY_M": 0.43762558698654,
    "CMY_Y": 0.51931631565094,
    "CMYK_C": 0,
    "CMYK_M": 0.12436195462942,
    "CMYK_Y": 0.25155746936798,
    "CMYK_K": 0.35775470733643
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1020",
    "Farbtonhilfsbezeichnung": "RAL1020 Olivgelb",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "142",
    "Bcolor": "100",
    "Y": 27,
    "L": 59.516544342041,
    "a": 0.5785516500473,
    "b": 23.9598903656006,
    "C": 23.9668750762939,
    "h": 88.6167678833008,
    "CMY_C": 0.37549060583115,
    "CMY_M": 0.44416654109955,
    "CMY_Y": 0.60647404193878,
    "CMYK_C": 0,
    "CMYK_M": 0.10996782034636,
    "CMYK_Y": 0.36986383795738,
    "CMYK_K": 0.37549060583115
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1021",
    "Farbtonhilfsbezeichnung": "RAL1021 Rapsgelb",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "183",
    "Bcolor": "0",
    "Y": 51,
    "L": 77.8007583618164,
    "a": 10.1476984024048,
    "b": 85.6617279052734,
    "C": 86.2606964111328,
    "h": 83.2440872192383,
    "CMY_C": 0.04170560836792,
    "CMY_M": 0.28404051065445,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.25288146734238,
    "CMYK_Y": 1,
    "CMYK_K": 0.04170560836792
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1023",
    "Farbtonhilfsbezeichnung": "RAL1023 Verkehrsgelb",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "180",
    "Bcolor": "0",
    "Y": 51,
    "L": 77.1095657348633,
    "a": 11.2186546325684,
    "b": 84.307373046875,
    "C": 85.0505218505859,
    "h": 82.4202651977539,
    "CMY_C": 0.04469525814056,
    "CMY_M": 0.29405683279037,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.26102828979492,
    "CMYK_Y": 1,
    "CMYK_K": 0.04469525814056
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1024",
    "Farbtonhilfsbezeichnung": "RAL1024 Ockergelb",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "144",
    "Bcolor": "77",
    "Y": 30,
    "L": 62.3072853088379,
    "a": 8.45569515228271,
    "b": 40.6348419189453,
    "C": 41.5052909851074,
    "h": 78.2450866699219,
    "CMY_C": 0.27200025320053,
    "CMY_M": 0.43671363592148,
    "CMY_Y": 0.69862288236618,
    "CMYK_C": 0,
    "CMYK_M": 0.2262547314167,
    "CMYK_Y": 0.58602029085159,
    "CMYK_K": 0.27200025320053
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1027",
    "Farbtonhilfsbezeichnung": "RAL1027 Currygelb",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "128",
    "Bcolor": "42",
    "Y": 23,
    "L": 55.9225540161133,
    "a": 6.02239370346069,
    "b": 49.6809272766113,
    "C": 50.0446166992188,
    "h": 83.088249206543,
    "CMY_C": 0.34850907325745,
    "CMY_M": 0.49636405706406,
    "CMY_Y": 0.83622407913208,
    "CMYK_C": 0,
    "CMYK_M": 0.22694864869118,
    "CMYK_Y": 0.74861365556717,
    "CMYK_K": 0.34850907325745
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1028",
    "Farbtonhilfsbezeichnung": "RAL1028 Melonengelb",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "155",
    "Bcolor": "0",
    "Y": 46,
    "L": 73.2881240844727,
    "a": 31.1514434814453,
    "b": 85.7356109619141,
    "C": 91.2195587158203,
    "h": 70.0317306518555,
    "CMY_C": 0,
    "CMY_M": 0.39188724756241,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.39188724756241,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1032",
    "Farbtonhilfsbezeichnung": "RAL1032 Ginstergelb",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "162",
    "Bcolor": "31",
    "Y": 40,
    "L": 70.6586227416992,
    "a": 12.9521856307983,
    "b": 68.7174758911133,
    "C": 69.9274673461914,
    "h": 79.3258590698242,
    "CMY_C": 0.1228883266449,
    "CMY_M": 0.36514139175415,
    "CMY_Y": 0.87774759531021,
    "CMYK_C": 0,
    "CMYK_M": 0.27619409561157,
    "CMYK_Y": 0.86061936616898,
    "CMYK_K": 0.1228883266449
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1033",
    "Farbtonhilfsbezeichnung": "RAL1033 Dahliengelb",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "153",
    "Bcolor": "43",
    "Y": 42,
    "L": 71.2854309082031,
    "a": 27.9945602416992,
    "b": 66.8972396850586,
    "C": 72.5185241699219,
    "h": 67.292106628418,
    "CMY_C": 0.0316578745842,
    "CMY_M": 0.40130716562271,
    "CMY_Y": 0.83270692825317,
    "CMYK_C": 0,
    "CMYK_M": 0.38173419237137,
    "CMYK_Y": 0.82723766565323,
    "CMYK_K": 0.0316578745842
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1034",
    "Farbtonhilfsbezeichnung": "RAL1034 Pastellgelb",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "157",
    "Bcolor": "88",
    "Y": 41,
    "L": 71.0983734130859,
    "a": 22.5477561950684,
    "b": 46.8421669006348,
    "C": 51.9864387512207,
    "h": 64.2958831787109,
    "CMY_C": 0.08136266469955,
    "CMY_M": 0.38447839021683,
    "CMY_Y": 0.65645790100098,
    "CMYK_C": 0,
    "CMYK_M": 0.32996234297752,
    "CMYK_Y": 0.6260307431221,
    "CMYK_K": 0.08136266469955
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1035",
    "Farbtonhilfsbezeichnung": "RAL1035 Perlbeige",
    "Farbtonklasse": "02",
    "Y": 33,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1036",
    "Farbtonhilfsbezeichnung": "RAL1036 Perlgold",
    "Farbtonklasse": "02",
    "Y": 28,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1037",
    "Farbtonhilfsbezeichnung": "RAL1037 Sonnengelb",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "146",
    "Bcolor": "14",
    "Y": 40,
    "L": 68.7673873901367,
    "a": 27.3635425567627,
    "b": 71.7538986206055,
    "C": 76.79443359375,
    "h": 69.1255187988281,
    "CMY_C": 0.06349319219589,
    "CMY_M": 0.42595875263214,
    "CMY_Y": 0.94534879922867,
    "CMYK_C": 0,
    "CMYK_M": 0.38703995943069,
    "CMYK_Y": 0.94164353609085,
    "CMYK_K": 0.06349319219589
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1039",
    "Farbtonhilfsbezeichnung": "RAL1039 Sandbeige",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "165",
    "Bcolor": "139",
    "Y": 39,
    "L": 68.7991943359375,
    "a": 3.84954476356506,
    "b": 15.7149810791016,
    "C": 16.1796054840088,
    "h": 76.2358551025391,
    "CMY_C": 0.27160918712616,
    "CMY_M": 0.35404586791992,
    "CMY_Y": 0.45642322301865,
    "CMYK_C": 0,
    "CMYK_M": 0.11317644268274,
    "CMYK_Y": 0.25372922420502,
    "CMYK_K": 0.27160918712616
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL1040",
    "Farbtonhilfsbezeichnung": "RAL1040 Lehmbeige",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "141",
    "Bcolor": "111",
    "Y": 28,
    "L": 60.0359764099121,
    "a": 3.76052403450012,
    "b": 19.0031223297119,
    "C": 19.3716335296631,
    "h": 78.8063659667969,
    "CMY_C": 0.3591605424881,
    "CMY_M": 0.44511431455612,
    "CMY_Y": 0.56643182039261,
    "CMYK_C": 0,
    "CMYK_M": 0.13412684202194,
    "CMYK_Y": 0.32343712449074,
    "CMYK_K": 0.3591605424881
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2000",
    "Farbtonhilfsbezeichnung": "RAL2000 Gelborange",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "111",
    "Bcolor": "21",
    "Y": 26,
    "L": 58.0612106323242,
    "a": 36.1676406860352,
    "b": 61.3516426086426,
    "C": 71.2188339233398,
    "h": 59.4800605773926,
    "CMY_C": 0.15454059839249,
    "CMY_M": 0.56347358226776,
    "CMY_Y": 0.91944181919098,
    "CMYK_C": 0,
    "CMYK_M": 0.48368141055107,
    "CMYK_Y": 0.90471667051315,
    "CMYK_K": 0.15454059839249
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2001",
    "Farbtonhilfsbezeichnung": "RAL2001 Rotorange",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "75",
    "Bcolor": "40",
    "Y": 16,
    "L": 46.3038635253906,
    "a": 42.8843460083008,
    "b": 41.6508827209473,
    "C": 59.781795501709,
    "h": 44.1640510559082,
    "CMY_C": 0.27443224191666,
    "CMY_M": 0.70613884925842,
    "CMY_Y": 0.84202241897583,
    "CMYK_C": 0,
    "CMYK_M": 0.59499144554138,
    "CMYK_Y": 0.78227037191391,
    "CMYK_K": 0.27443224191666
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2002",
    "Farbtonhilfsbezeichnung": "RAL2002 Blutorange",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "59",
    "Bcolor": "42",
    "Y": 14,
    "L": 44.5811347961426,
    "a": 51.6655235290527,
    "b": 39.4311981201172,
    "C": 64.9934310913086,
    "h": 37.3509254455566,
    "CMY_C": 0.25493723154068,
    "CMY_M": 0.76838934421539,
    "CMY_Y": 0.83653682470322,
    "CMYK_C": 0,
    "CMYK_M": 0.68913942575455,
    "CMYK_Y": 0.78060483932495,
    "CMYK_K": 0.25493723154068
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2003",
    "Farbtonhilfsbezeichnung": "RAL2003 Pastellorange",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "120",
    "Bcolor": "51",
    "Y": 33,
    "L": 64.035041809082,
    "a": 43.1650314331055,
    "b": 57.1252365112305,
    "C": 71.5996704101563,
    "h": 52.9245376586914,
    "CMY_C": 0.04668915271759,
    "CMY_M": 0.52768242359161,
    "CMY_Y": 0.80138731002808,
    "CMYK_C": 0,
    "CMYK_M": 0.5045502781868,
    "CMYK_Y": 0.79166007041931,
    "CMYK_K": 0.04668915271759
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2004",
    "Farbtonhilfsbezeichnung": "RAL2004 Reinorange",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "88",
    "Bcolor": "38",
    "Y": 22,
    "L": 55.0129623413086,
    "a": 51.0027236938477,
    "b": 53.0454902648926,
    "C": 73.5873794555664,
    "h": 46.1247367858887,
    "CMY_C": 0.12219089269638,
    "CMY_M": 0.65491724014282,
    "CMY_Y": 0.84913778305054,
    "CMYK_C": 0,
    "CMYK_M": 0.60688179731369,
    "CMYK_Y": 0.82813781499863,
    "CMYK_K": 0.12219089269638
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2007",
    "Farbtonhilfsbezeichnung": "RAL2007 Leuchthellorange",
    "Farbtonklasse": "04",
    "Y": 61,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2008",
    "Farbtonhilfsbezeichnung": "RAL2008 Hellrotorange",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "107",
    "Bcolor": "44",
    "Y": 28,
    "L": 60.1203269958496,
    "a": 45.8517723083496,
    "b": 55.9046669006348,
    "C": 72.3029479980469,
    "h": 50.6421546936035,
    "CMY_C": 0.08252608776093,
    "CMY_M": 0.57893991470337,
    "CMY_Y": 0.82788640260696,
    "CMYK_C": 0,
    "CMYK_M": 0.54106587171555,
    "CMYK_Y": 0.81240493059158,
    "CMYK_K": 0.08252608776093
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2009",
    "Farbtonhilfsbezeichnung": "RAL2009 Verkehrsorange",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "88",
    "Bcolor": "37",
    "Y": 20,
    "L": 54.3548126220703,
    "a": 49.4548187255859,
    "b": 52.7905426025391,
    "C": 72.3368530273438,
    "h": 46.868595123291,
    "CMY_C": 0.13813805580139,
    "CMY_M": 0.65448808670044,
    "CMY_Y": 0.8543838262558,
    "CMYK_C": 0,
    "CMYK_M": 0.59910988807678,
    "CMYK_Y": 0.83104467391968,
    "CMYK_K": 0.13813805580139
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2010",
    "Farbtonhilfsbezeichnung": "RAL2010 Signalorange",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "93",
    "Bcolor": "44",
    "Y": 20,
    "L": 53.134765625,
    "a": 42.5300140380859,
    "b": 47.8927993774414,
    "C": 64.0509338378906,
    "h": 48.394115447998,
    "CMY_C": 0.19001632928848,
    "CMY_M": 0.63613450527191,
    "CMY_Y": 0.82855021953583,
    "CMYK_C": 0,
    "CMYK_M": 0.55077427625656,
    "CMYK_Y": 0.78832936286926,
    "CMYK_K": 0.19001632928848
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2011",
    "Farbtonhilfsbezeichnung": "RAL2011 Tieforange",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "113",
    "Bcolor": "42",
    "Y": 25,
    "L": 59.5318183898926,
    "a": 38.9777374267578,
    "b": 55.6661720275879,
    "C": 67.9557723999023,
    "h": 55.0000953674316,
    "CMY_C": 0.12508344650269,
    "CMY_M": 0.55812764167786,
    "CMY_Y": 0.83623075485229,
    "CMYK_C": 0,
    "CMYK_M": 0.49495485424995,
    "CMYK_Y": 0.81281727552414,
    "CMYK_K": 0.12508344650269
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2012",
    "Farbtonhilfsbezeichnung": "RAL2012 Lachsorange",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "101",
    "Bcolor": "77",
    "Y": 22,
    "L": 55.5696182250977,
    "a": 41.7627296447754,
    "b": 33.0277099609375,
    "C": 53.2442970275879,
    "h": 38.3384170532227,
    "CMY_C": 0.17575073242188,
    "CMY_M": 0.60572457313538,
    "CMY_Y": 0.69672816991806,
    "CMYK_C": 0,
    "CMYK_M": 0.52165508270264,
    "CMYK_Y": 0.63206297159195,
    "CMYK_K": 0.17575073242188
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2013",
    "Farbtonhilfsbezeichnung": "RAL2013 Perlorange",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "72",
    "Bcolor": "54",
    "Y": 15,
    "L": 40.1940689086914,
    "a": 31.0699558258057,
    "b": 25.7050189971924,
    "C": 40.3248100280762,
    "h": 39.601879119873,
    "CMY_C": 0.41368681192398,
    "CMY_M": 0.71665906906128,
    "CMY_Y": 0.78921723365784,
    "CMYK_C": 0,
    "CMYK_M": 0.516741335392,
    "CMYK_Y": 0.64049458503723,
    "CMYK_K": 0.41368681192398
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL2017",
    "Farbtonhilfsbezeichnung": "RAL2017 Orange",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "90",
    "Bcolor": "16",
    "Y": 28.2,
    "L": 58.3235702514648,
    "a": 55.9754981994629,
    "b": 64.699333190918,
    "C": 85.5526733398438,
    "h": 49.134838104248,
    "CMY_C": 0.05062437057495,
    "CMY_M": 0.64561277627945,
    "CMY_Y": 0.93835091590881,
    "CMYK_C": 0,
    "CMYK_M": 0.62671548128128,
    "CMYK_Y": 0.93506354093552,
    "CMYK_K": 0.05062437057495
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3000",
    "Farbtonhilfsbezeichnung": "RAL3000 Feuerrot",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 12.6,
    "L": 39.2133827209473,
    "a": 46.3977737426758,
    "b": 28.1887054443359,
    "C": 54.2895622253418,
    "h": 31.28053855896,
    "CMY_C": 0.35047245025635,
    "CMY_M": 0.79424893856049,
    "CMY_Y": 0.80898976325989,
    "CMYK_C": 0,
    "CMYK_M": 0.68322968482971,
    "CMYK_Y": 0.70592433214188,
    "CMYK_K": 0.35047245025635
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3001",
    "Farbtonhilfsbezeichnung": "RAL3001 Signalrot",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "45",
    "Bcolor": "44",
    "Y": 11,
    "L": 35.7861862182617,
    "a": 45.3938140869141,
    "b": 26.395471572876,
    "C": 52.510181427002,
    "h": 30.1770286560059,
    "CMY_C": 0.39623486995697,
    "CMY_M": 0.82495057582855,
    "CMY_Y": 0.82701045274734,
    "CMYK_C": 0,
    "CMYK_M": 0.71007031202316,
    "CMYK_Y": 0.71348202228546,
    "CMYK_K": 0.39623486995697
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3002",
    "Farbtonhilfsbezeichnung": "RAL3002 Karminrot",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "42",
    "Bcolor": "43",
    "Y": 8,
    "L": 35.5074310302734,
    "a": 46.3064498901367,
    "b": 26.5441188812256,
    "C": 53.3748779296875,
    "h": 29.8225116729736,
    "CMY_C": 0.39525365829468,
    "CMY_M": 0.83356380462646,
    "CMY_Y": 0.82997649908066,
    "CMYK_C": 0,
    "CMYK_M": 0.72478348016739,
    "CMYK_Y": 0.7188515663147,
    "CMYK_K": 0.39525365829468
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3003",
    "Farbtonhilfsbezeichnung": "RAL3003 Rubinrot",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "42",
    "Bcolor": "46",
    "Y": 6,
    "L": 31.540319442749,
    "a": 39.6350593566895,
    "b": 18.8493461608887,
    "C": 43.8889045715332,
    "h": 25.434476852417,
    "CMY_C": 0.47607868909836,
    "CMY_M": 0.83574175834656,
    "CMY_Y": 0.81795161962509,
    "CMYK_C": 0,
    "CMYK_M": 0.6864829659462,
    "CMYK_Y": 0.65252727270126,
    "CMYK_K": 0.47607868909836
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3004",
    "Farbtonhilfsbezeichnung": "RAL3004 Purpurrot",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "47",
    "Bcolor": "53",
    "Y": 4,
    "L": 28.5190315246582,
    "a": 29.0174922943115,
    "b": 9.78403282165527,
    "C": 30.6225757598877,
    "h": 18.632926940918,
    "CMY_C": 0.5659431219101,
    "CMY_M": 0.81549561023712,
    "CMY_Y": 0.79212337732315,
    "CMYK_C": 0,
    "CMYK_M": 0.57493036985397,
    "CMYK_Y": 0.52108436822891,
    "CMYK_K": 0.5659431219101
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3005",
    "Farbtonhilfsbezeichnung": "RAL3005 Weinrot",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "43",
    "Bcolor": "48",
    "Y": 4,
    "L": 25.1404418945313,
    "a": 24.5908203125,
    "b": 7.84637117385864,
    "C": 25.8122844696045,
    "h": 17.6966991424561,
    "CMY_C": 0.62349915504456,
    "CMY_M": 0.82976877689362,
    "CMY_Y": 0.8103443980217,
    "CMYK_C": 0,
    "CMYK_M": 0.54785966873169,
    "CMYK_Y": 0.49626779556274,
    "CMYK_K": 0.62349915504456
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3007",
    "Farbtonhilfsbezeichnung": "RAL3007 Schwarzrot",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "46",
    "Bcolor": "49",
    "Y": 3,
    "L": 21.3926258087158,
    "a": 10.244794845581,
    "b": 1.74491488933563,
    "C": 10.3923311233521,
    "h": 9.66598033905029,
    "CMY_C": 0.73798990249634,
    "CMY_M": 0.82009100914001,
    "CMY_Y": 0.80928987264633,
    "CMYK_C": 0,
    "CMYK_M": 0.31335091590881,
    "CMYK_Y": 0.27212679386139,
    "CMYK_K": 0.73798990249634
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3009",
    "Farbtonhilfsbezeichnung": "RAL3009 Oxidrot",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "55",
    "Bcolor": "49",
    "Y": 6,
    "L": 30.1286907196045,
    "a": 23.6402454376221,
    "b": 14.6149969100952,
    "C": 27.7931518554688,
    "h": 31.7254028320313,
    "CMY_C": 0.56894791126251,
    "CMY_M": 0.78325974941254,
    "CMY_Y": 0.80818963050842,
    "CMYK_C": 0,
    "CMYK_M": 0.49718314409256,
    "CMYK_Y": 0.55501812696457,
    "CMYK_K": 0.56894791126251
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3011",
    "Farbtonhilfsbezeichnung": "RAL3011 Braunrot",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "44",
    "Bcolor": "44",
    "Y": 5,
    "L": 29.397346496582,
    "a": 33.8768577575684,
    "b": 17.315544128418,
    "C": 38.0456237792969,
    "h": 27.0730266571045,
    "CMY_C": 0.52683186531067,
    "CMY_M": 0.82891666889191,
    "CMY_Y": 0.82818156480789,
    "CMYK_C": 0,
    "CMYK_M": 0.63843017816544,
    "CMYK_Y": 0.63687658309937,
    "CMYK_K": 0.52683186531067
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3012",
    "Farbtonhilfsbezeichnung": "RAL3012 Beigerot",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "134",
    "Bcolor": "111",
    "Y": 30,
    "L": 61.572135925293,
    "a": 21.647985458374,
    "b": 21.5530319213867,
    "C": 30.5478057861328,
    "h": 44.8740653991699,
    "CMY_C": 0.22955453395844,
    "CMY_M": 0.47570937871933,
    "CMY_Y": 0.5655974149704,
    "CMYK_C": 0,
    "CMYK_M": 0.31949678063393,
    "CMYK_Y": 0.43616700172424,
    "CMYK_K": 0.22955453395844
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3013",
    "Farbtonhilfsbezeichnung": "RAL3013 Tomatenrot",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "57",
    "Bcolor": "52",
    "Y": 8,
    "L": 37.8840408325195,
    "a": 40.055004119873,
    "b": 24.3362045288086,
    "C": 46.8684768676758,
    "h": 31.2815933227539,
    "CMY_C": 0.39815092086792,
    "CMY_M": 0.77507501840591,
    "CMY_Y": 0.79782050848007,
    "CMYK_C": 0,
    "CMYK_M": 0.62627679109573,
    "CMYK_Y": 0.66406947374344,
    "CMYK_K": 0.39815092086792
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3014",
    "Farbtonhilfsbezeichnung": "RAL3014 Altrosa",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "114",
    "Bcolor": "116",
    "Y": 26,
    "L": 57.6675300598145,
    "a": 34.8311004638672,
    "b": 13.2012872695923,
    "C": 37.2488861083984,
    "h": 20.7571392059326,
    "CMY_C": 0.21239280700684,
    "CMY_M": 0.55435568094254,
    "CMY_Y": 0.54437631368637,
    "CMYK_C": 0,
    "CMYK_M": 0.43417948484421,
    "CMYK_Y": 0.42150896787643,
    "CMYK_K": 0.21239280700684
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3015",
    "Farbtonhilfsbezeichnung": "RAL3015 Hellrosa",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "161",
    "Bcolor": "167",
    "Y": 44,
    "L": 71.3638534545898,
    "a": 21.1084804534912,
    "b": 4.03827905654907,
    "C": 21.4912929534912,
    "h": 10.8304328918457,
    "CMY_C": 0.15743446350098,
    "CMY_M": 0.36841070652008,
    "CMY_Y": 0.34541875123978,
    "CMYK_C": 0,
    "CMYK_M": 0.25039741396904,
    "CMYK_Y": 0.2231093943119,
    "CMYK_K": 0.15743446350098
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3016",
    "Farbtonhilfsbezeichnung": "RAL3016 Korallenrot",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "63",
    "Bcolor": "50",
    "Y": 11,
    "L": 40.6824264526367,
    "a": 41.4173774719238,
    "b": 28.9622974395752,
    "C": 50.5392303466797,
    "h": 34.964282989502,
    "CMY_C": 0.35600632429123,
    "CMY_M": 0.75418186187744,
    "CMY_Y": 0.80306655168533,
    "CMYK_C": 0,
    "CMYK_M": 0.61829107999802,
    "CMYK_Y": 0.69419974088669,
    "CMYK_K": 0.35600632429123
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3017",
    "Farbtonhilfsbezeichnung": "RAL3017 Rose",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "86",
    "Bcolor": "94",
    "Y": 20,
    "L": 51.9686851501465,
    "a": 47.1235046386719,
    "b": 18.2928371429443,
    "C": 50.5495071411133,
    "h": 21.2156753540039,
    "CMY_C": 0.20645451545715,
    "CMY_M": 0.66170805692673,
    "CMY_Y": 0.63015401363373,
    "CMYK_C": 0,
    "CMYK_M": 0.57369560003281,
    "CMYK_Y": 0.53393220901489,
    "CMYK_K": 0.20645451545715
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3018",
    "Farbtonhilfsbezeichnung": "RAL3018 Erdbeerrot",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "68",
    "Bcolor": "79",
    "Y": 17,
    "L": 47.7456741333008,
    "a": 52.4754447937012,
    "b": 21.7002716064453,
    "C": 56.7853317260742,
    "h": 22.4666557312012,
    "CMY_C": 0.22620910406113,
    "CMY_M": 0.73386234045029,
    "CMY_Y": 0.69007885456085,
    "CMYK_C": 0,
    "CMYK_M": 0.65605998039246,
    "CMYK_Y": 0.59947687387466,
    "CMYK_K": 0.22620910406113
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3020",
    "Farbtonhilfsbezeichnung": "RAL3020 Verkehrsrot",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "44",
    "Bcolor": "39",
    "Y": 11,
    "L": 41.8692436218262,
    "a": 55.7805976867676,
    "b": 37.891170501709,
    "C": 67.4330444335938,
    "h": 34.1878509521484,
    "CMY_C": 0.26982080936432,
    "CMY_M": 0.82718873023987,
    "CMY_Y": 0.84708100557327,
    "CMYK_C": 0,
    "CMYK_M": 0.76333034038544,
    "CMYK_Y": 0.79057335853577,
    "CMYK_K": 0.26982080936432
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3022",
    "Farbtonhilfsbezeichnung": "RAL3022 Lachsrot",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "106",
    "Bcolor": "84",
    "Y": 24,
    "L": 56.1283149719238,
    "a": 38.2776412963867,
    "b": 29.7716426849365,
    "C": 48.492561340332,
    "h": 37.8751182556152,
    "CMY_C": 0.19037288427353,
    "CMY_M": 0.58613169193268,
    "CMY_Y": 0.67010736465454,
    "CMYK_C": 0,
    "CMYK_M": 0.48881614208221,
    "CMYK_Y": 0.59253758192062,
    "CMYK_K": 0.19037288427353
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3027",
    "Farbtonhilfsbezeichnung": "RAL3027 Himbeerrot",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "46",
    "Bcolor": "66",
    "Y": 10,
    "L": 39.4131278991699,
    "a": 51.643310546875,
    "b": 18.1502056121826,
    "C": 54.7399444580078,
    "h": 19.3641872406006,
    "CMY_C": 0.33184725046158,
    "CMY_M": 0.82109004259109,
    "CMY_Y": 0.74273890256882,
    "CMYK_C": 0,
    "CMYK_M": 0.73223197460175,
    "CMYK_Y": 0.61496663093567,
    "CMYK_K": 0.33184725046158
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3028",
    "Farbtonhilfsbezeichnung": "RAL3028 Reinrot",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "51",
    "Bcolor": "47",
    "Y": 17,
    "L": 45.5905342102051,
    "a": 58.2273826599121,
    "b": 38.1628723144531,
    "C": 69.6192016601563,
    "h": 33.2412757873535,
    "CMY_C": 0.21267205476761,
    "CMY_M": 0.79952049255371,
    "CMY_Y": 0.81567794084549,
    "CMYK_C": 0,
    "CMYK_M": 0.74536722898483,
    "CMYK_Y": 0.765889108181,
    "CMYK_K": 0.21267205476761
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3031",
    "Farbtonhilfsbezeichnung": "RAL3031 Orientrot",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "58",
    "Bcolor": "62",
    "Y": 9,
    "L": 40.4236145019531,
    "a": 45.3732452392578,
    "b": 21.431453704834,
    "C": 50.180061340332,
    "h": 25.283088684082,
    "CMY_C": 0.34649276733398,
    "CMY_M": 0.77428734302521,
    "CMY_Y": 0.755899310112,
    "CMYK_C": 0,
    "CMYK_M": 0.65461337566376,
    "CMYK_Y": 0.62647593021393,
    "CMYK_K": 0.34649276733398
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3032",
    "Farbtonhilfsbezeichnung": "RAL3032 Perlrubinrot",
    "Farbtonklasse": "03",
    "Y": 8,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL3033",
    "Farbtonhilfsbezeichnung": "RAL3033 Perlrosa",
    "Farbtonklasse": "04",
    "Y": 17,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4001",
    "Farbtonhilfsbezeichnung": "RAL4001 Rotlila",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "98",
    "Bcolor": "132",
    "Y": 15,
    "L": 45.935718536377,
    "a": 19.2854232788086,
    "b": -14.3365306854248,
    "C": 24.0304737091064,
    "h": 323.373382568359,
    "CMY_C": 0.48970222473145,
    "CMY_M": 0.61433732509613,
    "CMY_Y": 0.48230719566345,
    "CMYK_C": 0.01428458932787,
    "CMYK_M": 0.25503566861153,
    "CMYK_Y": 0,
    "CMYK_K": 0.48230719566345
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4002",
    "Farbtonhilfsbezeichnung": "RAL4002 Rotviolett",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "68",
    "Bcolor": "82",
    "Y": 9,
    "L": 38.7565040588379,
    "a": 32.8868675231934,
    "b": 6.24238872528076,
    "C": 33.4740715026855,
    "h": 10.7476825714111,
    "CMY_C": 0.44320160150528,
    "CMY_M": 0.73239207267761,
    "CMY_Y": 0.67928051948547,
    "CMYK_C": 0,
    "CMYK_M": 0.51938092708588,
    "CMYK_Y": 0.42399352788925,
    "CMYK_K": 0.44320160150528
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4003",
    "Farbtonhilfsbezeichnung": "RAL4003 Erikaviolett",
    "Farbtonklasse": "04",
    "Rcolor": "193",
    "Gcolor": "99",
    "Bcolor": "140",
    "Y": 22,
    "L": 54.2138404846191,
    "a": 42.7651023864746,
    "b": -5.96550893783569,
    "C": 43.1791763305664,
    "h": 352.058776855469,
    "CMY_C": 0.24206250905991,
    "CMY_M": 0.61210656166077,
    "CMY_Y": 0.45050632953644,
    "CMYK_C": 0,
    "CMYK_M": 0.48822501301765,
    "CMYK_Y": 0.27501451969147,
    "CMYK_K": 0.24206250905991
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4004",
    "Farbtonhilfsbezeichnung": "RAL4004 Bordeauxviolett",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "40",
    "Bcolor": "62",
    "Y": 4,
    "L": 25.5793743133545,
    "a": 30.3114109039307,
    "b": -0.40984460711479,
    "C": 30.3141822814941,
    "h": 359.225341796875,
    "CMY_C": 0.60374510288239,
    "CMY_M": 0.84460836648941,
    "CMY_Y": 0.75827342271805,
    "CMYK_C": 0,
    "CMYK_M": 0.60784929990768,
    "CMYK_Y": 0.38997200131416,
    "CMYK_K": 0.60374510288239
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4005",
    "Farbtonhilfsbezeichnung": "RAL4005 Blaulila",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "107",
    "Bcolor": "154",
    "Y": 17,
    "L": 48.2083778381348,
    "a": 15.8253269195557,
    "b": -24.1943359375,
    "C": 28.9103240966797,
    "h": 303.188385009766,
    "CMY_C": 0.52597379684448,
    "CMY_M": 0.57947373390198,
    "CMY_Y": 0.39533412456512,
    "CMYK_C": 0.2160526663065,
    "CMYK_M": 0.30453118681908,
    "CMYK_Y": 0,
    "CMYK_K": 0.39533412456512
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4006",
    "Farbtonhilfsbezeichnung": "RAL4006 Verkehrspurpur",
    "Farbtonklasse": "04",
    "Rcolor": "144",
    "Gcolor": "58",
    "Bcolor": "117",
    "Y": 10,
    "L": 38.3356399536133,
    "a": 43.4903869628906,
    "b": -16.5054988861084,
    "C": 46.5171508789063,
    "h": 339.217224121094,
    "CMY_C": 0.43528306484222,
    "CMY_M": 0.77104419469833,
    "CMY_Y": 0.54134035110474,
    "CMYK_C": 0,
    "CMYK_M": 0.59456539154053,
    "CMYK_Y": 0.18780609965324,
    "CMYK_K": 0.43528306484222
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4007",
    "Farbtonhilfsbezeichnung": "RAL4007 Purpurviolett",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "50",
    "Bcolor": "68",
    "Y": 3,
    "L": 24.4416427612305,
    "a": 15.5212049484253,
    "b": -6.83571863174438,
    "C": 16.9598007202148,
    "h": 336.230743408203,
    "CMY_C": 0.70046555995941,
    "CMY_M": 0.80454105138779,
    "CMY_Y": 0.73317277431488,
    "CMYK_C": 0,
    "CMYK_M": 0.347457498312,
    "CMYK_Y": 0.10919350385666,
    "CMYK_K": 0.70046555995941
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4008",
    "Farbtonhilfsbezeichnung": "RAL4008 Signalviolett",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "78",
    "Bcolor": "131",
    "Y": 11,
    "L": 41.3708534240723,
    "a": 32.2883033752441,
    "b": -20.7398681640625,
    "C": 38.3754692077637,
    "h": 327.286010742188,
    "CMY_C": 0.47634637355804,
    "CMY_M": 0.69474196434021,
    "CMY_Y": 0.48578459024429,
    "CMYK_C": 0,
    "CMYK_M": 0.41706115007401,
    "CMYK_Y": 0.01802377775311,
    "CMYK_K": 0.47634637355804
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4009",
    "Farbtonhilfsbezeichnung": "RAL4009 Pastellviolett",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "132",
    "Bcolor": "144",
    "Y": 25,
    "L": 57.671932220459,
    "a": 11.0175285339356,
    "b": -3.69018697738647,
    "C": 11.6190967559815,
    "h": 341.482360839844,
    "CMY_C": 0.39135193824768,
    "CMY_M": 0.48076367378235,
    "CMY_Y": 0.4348771572113,
    "CMYK_C": 0,
    "CMYK_M": 0.14690218865871,
    "CMYK_Y": 0.07151130586863,
    "CMYK_K": 0.39135193824768
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4010",
    "Farbtonhilfsbezeichnung": "RAL4010 Telemagenta",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "68",
    "Bcolor": "121",
    "Y": 15,
    "L": 47.1585083007813,
    "a": 52.8927192687988,
    "b": -5.04655885696411,
    "C": 53.1329231262207,
    "h": 354.549835205078,
    "CMY_C": 0.26614367961884,
    "CMY_M": 0.73189783096313,
    "CMY_Y": 0.52536344528198,
    "CMYK_C": 0,
    "CMYK_M": 0.63466668128967,
    "CMYK_Y": 0.35322958230972,
    "CMYK_K": 0.26614367961884
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4011",
    "Farbtonhilfsbezeichnung": "RAL4011 Perlviolett",
    "Farbtonklasse": "03",
    "Y": 24,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL4012",
    "Farbtonhilfsbezeichnung": "RAL4012 Perlbrombeer",
    "Farbtonklasse": "03",
    "Y": 24,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5000",
    "Farbtonhilfsbezeichnung": "RAL5000 Violettblau",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "82",
    "Bcolor": "113",
    "Y": 8,
    "L": 33.8478736877441,
    "a": -2.08043098449707,
    "b": -21.6006851196289,
    "C": 21.7006397247314,
    "h": 264.498626708984,
    "CMY_C": 0.80480605363846,
    "CMY_M": 0.67731738090515,
    "CMY_Y": 0.55799561738968,
    "CMYK_C": 0.55838912725449,
    "CMYK_M": 0.26995605230331,
    "CMYK_Y": 0,
    "CMYK_K": 0.55799561738968
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5001",
    "Farbtonhilfsbezeichnung": "RAL5001 Gruenblau",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "77",
    "Bcolor": "100",
    "Y": 6,
    "L": 30.4777545928955,
    "a": -8.99232292175293,
    "b": -19.0615634918213,
    "C": 21.0761737823486,
    "h": 244.744323730469,
    "CMY_C": 0.91361254453659,
    "CMY_M": 0.6972536444664,
    "CMY_Y": 0.60670149326324,
    "CMYK_C": 0.78035140037537,
    "CMYK_M": 0.23023772239685,
    "CMYK_Y": 0,
    "CMYK_K": 0.60670149326324
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5002",
    "Farbtonhilfsbezeichnung": "RAL5002 Ultramarinblau",
    "Farbtonklasse": "04",
    "Rcolor": "14",
    "Gcolor": "61",
    "Bcolor": "123",
    "Y": 5,
    "L": 26.3576850891113,
    "a": 9.91500949859619,
    "b": -39.7811698913574,
    "C": 40.9981575012207,
    "h": 283.995178222656,
    "CMY_C": 0.94447308778763,
    "CMY_M": 0.76015400886536,
    "CMY_Y": 0.5192803144455,
    "CMYK_C": 0.88449209928513,
    "CMYK_M": 0.5010689496994,
    "CMYK_Y": 0,
    "CMYK_K": 0.5192803144455
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5003",
    "Farbtonhilfsbezeichnung": "RAL5003 Saphirblau",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "56",
    "Bcolor": "84",
    "Y": 3,
    "L": 22.777437210083,
    "a": -0.05754501000047,
    "b": -20.371301651001,
    "C": 20.3713836669922,
    "h": 269.838134765625,
    "CMY_C": 0.88311940431595,
    "CMY_M": 0.78056460618973,
    "CMY_Y": 0.67096185684204,
    "CMYK_C": 0.64478099346161,
    "CMYK_M": 0.33310043811798,
    "CMYK_Y": 0,
    "CMYK_K": 0.67096185684204
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5004",
    "Farbtonhilfsbezeichnung": "RAL5004 Schwarzblau",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "42",
    "Bcolor": "51",
    "Y": 1,
    "L": 16.8000926971436,
    "a": 0.17857050895691,
    "b": -6.84142351150513,
    "C": 6.84375381469727,
    "h": 271.495147705078,
    "CMY_C": 0.85747683048248,
    "CMY_M": 0.83598613739014,
    "CMY_Y": 0.80128663778305,
    "CMYK_C": 0.28277006745338,
    "CMYK_M": 0.17462086677551,
    "CMYK_Y": 0,
    "CMYK_K": 0.80128663778305
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5005",
    "Farbtonhilfsbezeichnung": "RAL5005 Signalblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "137",
    "Y": 7,
    "L": 34.084789276123,
    "a": -5.89849185943604,
    "b": -36.1824531555176,
    "C": 36.6600875854492,
    "h": 260.741058349609,
    "CMY_C": 1,
    "CMY_M": 0.66252934932709,
    "CMY_Y": 0.46454256772995,
    "CMYK_C": 1,
    "CMYK_M": 0.36975261569023,
    "CMYK_Y": 0,
    "CMYK_K": 0.46454256772995
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5007",
    "Farbtonhilfsbezeichnung": "RAL5007 Brillantblau",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "106",
    "Bcolor": "139",
    "Y": 12,
    "L": 42.8337936401367,
    "a": -6.88812398910522,
    "b": -23.6875877380371,
    "C": 24.6687679290771,
    "h": 253.786071777344,
    "CMY_C": 0.78639161586761,
    "CMY_M": 0.58273684978485,
    "CMY_Y": 0.45559638738632,
    "CMYK_C": 0.60762864351273,
    "CMYK_M": 0.23354081809521,
    "CMYK_Y": 0,
    "CMYK_K": 0.45559638738632
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5008",
    "Farbtonhilfsbezeichnung": "RAL5008 Graublau",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "63",
    "Bcolor": "73",
    "Y": 7,
    "L": 25.8250522613525,
    "a": -2.7855851650238,
    "b": -8.08137321472168,
    "C": 8.54798698425293,
    "h": 250.981338500977,
    "CMY_C": 0.80721753835678,
    "CMY_M": 0.75294941663742,
    "CMY_Y": 0.71524226665497,
    "CMYK_C": 0.32299482822418,
    "CMYK_M": 0.13241834938526,
    "CMYK_Y": 0,
    "CMYK_K": 0.71524226665497
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5009",
    "Farbtonhilfsbezeichnung": "RAL5009 Azurblau",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "93",
    "Bcolor": "117",
    "Y": 9,
    "L": 36.8896369934082,
    "a": -10.9552507400513,
    "b": -19.8233985900879,
    "C": 22.6491641998291,
    "h": 241.073104858398,
    "CMY_C": 0.87670958042145,
    "CMY_M": 0.63395720720291,
    "CMY_Y": 0.53990817070007,
    "CMYK_C": 0.73203086853027,
    "CMYK_M": 0.20441362261772,
    "CMYK_Y": 0,
    "CMYK_K": 0.53990817070007
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5010",
    "Farbtonhilfsbezeichnung": "RAL5010 Enzianblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "80",
    "Bcolor": "124",
    "Y": 6,
    "L": 31.5579090118408,
    "a": -7.14416980743408,
    "b": -32.4782676696777,
    "C": 33.2547302246094,
    "h": 257.594360351563,
    "CMY_C": 1,
    "CMY_M": 0.68535244464874,
    "CMY_Y": 0.5133461356163,
    "CMYK_C": 1,
    "CMYK_M": 0.3534469306469,
    "CMYK_Y": 0,
    "CMYK_K": 0.5133461356163
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5011",
    "Farbtonhilfsbezeichnung": "RAL5011 Stahlblau",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "50",
    "Bcolor": "66",
    "Y": 2,
    "L": 19.91042137146,
    "a": -1.68031215667725,
    "b": -12.8582038879395,
    "C": 12.9675312042236,
    "h": 262.554779052734,
    "CMY_C": 0.87342494726181,
    "CMY_M": 0.80488646030426,
    "CMY_Y": 0.74056911468506,
    "CMYK_C": 0.5121049284935,
    "CMYK_M": 0.24791707098484,
    "CMYK_Y": 0,
    "CMYK_K": 0.74056911468506
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5012",
    "Farbtonhilfsbezeichnung": "RAL5012 Lichtblau",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "179",
    "Y": 21,
    "L": 52.6944732666016,
    "a": -15.1113138198853,
    "b": -31.9956855773926,
    "C": 35.3846817016602,
    "h": 244.718994140625,
    "CMY_C": 1,
    "CMY_M": 0.46738594770432,
    "CMY_Y": 0.29882168769836,
    "CMYK_C": 1,
    "CMYK_M": 0.24040141701698,
    "CMYK_Y": 0,
    "CMYK_K": 0.29882168769836
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5013",
    "Farbtonhilfsbezeichnung": "RAL5013 Kobaltblau",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "53",
    "Bcolor": "84",
    "Y": 3,
    "L": 22.0421104431152,
    "a": 2.31787180900574,
    "b": -21.845329284668,
    "C": 21.9679527282715,
    "h": 276.056640625,
    "CMY_C": 0.87627148628235,
    "CMY_M": 0.79066514968872,
    "CMY_Y": 0.66903936862946,
    "CMYK_C": 0.6261533498764,
    "CMYK_M": 0.36749321222305,
    "CMYK_Y": 0,
    "CMYK_K": 0.66903936862946
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5014",
    "Farbtonhilfsbezeichnung": "RAL5014 Taubenblau",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "125",
    "Bcolor": "149",
    "Y": 20,
    "L": 51.2536468505859,
    "a": -2.66185712814331,
    "b": -16.6850128173828,
    "C": 16.8960094451904,
    "h": 260.935668945313,
    "CMY_C": 0.60879462957382,
    "CMY_M": 0.51054126024246,
    "CMY_Y": 0.41519618034363,
    "CMYK_C": 0.33104854822159,
    "CMYK_M": 0.16303771734238,
    "CMYK_Y": 0,
    "CMYK_K": 0.41519618034363
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5015",
    "Farbtonhilfsbezeichnung": "RAL5015 Himmelblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "174",
    "Y": 17,
    "L": 47.9950180053711,
    "a": -13.9776802062988,
    "b": -36.3817672729492,
    "C": 38.9744606018066,
    "h": 248.983489990234,
    "CMY_C": 1,
    "CMY_M": 0.5148246884346,
    "CMY_Y": 0.31922268867493,
    "CMYK_C": 1,
    "CMYK_M": 0.2873215675354,
    "CMYK_Y": 0,
    "CMYK_K": 0.31922268867493
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5017",
    "Farbtonhilfsbezeichnung": "RAL5017 Verkehrsblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "140",
    "Y": 11,
    "L": 36.2848167419434,
    "a": -12.360761642456,
    "b": -34.8311233520508,
    "C": 36.9593772888184,
    "h": 250.461395263672,
    "CMY_C": 1,
    "CMY_M": 0.63188028335571,
    "CMY_Y": 0.45106935501099,
    "CMYK_C": 1,
    "CMYK_M": 0.32938757538795,
    "CMYK_Y": 0,
    "CMYK_K": 0.45106935501099
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5018",
    "Farbtonhilfsbezeichnung": "RAL5018 Tuerkisblau",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "140",
    "Bcolor": "140",
    "Y": 20,
    "L": 52.6669731140137,
    "a": -28.8356018066406,
    "b": -9.21192932128906,
    "C": 30.2712993621826,
    "h": 197.716796875,
    "CMY_C": 0.89515924453735,
    "CMY_M": 0.45261061191559,
    "CMY_Y": 0.45284879207611,
    "CMYK_C": 0.80847132205963,
    "CMYK_M": 0,
    "CMYK_Y": 0.00043512016418,
    "CMYK_K": 0.45261061191559
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5019",
    "Farbtonhilfsbezeichnung": "RAL5019 Capriblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "130",
    "Y": 9,
    "L": 36.8479270935059,
    "a": -11.253378868103,
    "b": -27.9016723632813,
    "C": 30.0855751037598,
    "h": 248.03466796875,
    "CMY_C": 1,
    "CMY_M": 0.63103812932968,
    "CMY_Y": 0.48935443162918,
    "CMYK_C": 1,
    "CMYK_M": 0.27745994925499,
    "CMYK_Y": 0,
    "CMYK_K": 0.48935443162918
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5020",
    "Farbtonhilfsbezeichnung": "RAL5020 Ozeanblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "70",
    "Bcolor": "78",
    "Y": 4,
    "L": 26.0474967956543,
    "a": -17.9570140838623,
    "b": -11.5258731842041,
    "C": 21.3377628326416,
    "h": 212.694747924805,
    "CMY_C": 1,
    "CMY_M": 0.72683656215668,
    "CMY_Y": 0.6940506696701,
    "CMYK_C": 1,
    "CMYK_M": 0.10716118663549,
    "CMYK_Y": 0,
    "CMYK_K": 0.6940506696701
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5021",
    "Farbtonhilfsbezeichnung": "RAL5021 Wasserblau",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "118",
    "Y": 14,
    "L": 43.6212730407715,
    "a": -33.1558418273926,
    "b": -10.2889556884766,
    "C": 34.7155952453613,
    "h": 197.240219116211,
    "CMY_C": 1,
    "CMY_M": 0.53825008869171,
    "CMY_Y": 0.53618407249451,
    "CMYK_C": 1,
    "CMYK_M": 0.00445438828319,
    "CMYK_Y": 0,
    "CMYK_K": 0.53618407249451
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5022",
    "Farbtonhilfsbezeichnung": "RAL5022 Nachtblau",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "48",
    "Bcolor": "91",
    "Y": 4,
    "L": 21.3593120574951,
    "a": 10.4311246871948,
    "b": -27.4860763549805,
    "C": 29.3988571166992,
    "h": 290.782043457031,
    "CMY_C": 0.84553492069244,
    "CMY_M": 0.81046426296234,
    "CMY_Y": 0.64193689823151,
    "CMYK_C": 0.56860935688019,
    "CMYK_M": 0.47066387534142,
    "CMYK_Y": 0,
    "CMYK_K": 0.64193689823151
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5023",
    "Farbtonhilfsbezeichnung": "RAL5023 Fernblau",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "109",
    "Bcolor": "142",
    "Y": 13,
    "L": 44.4698486328125,
    "a": -3.2333357334137,
    "b": -23.0906352996826,
    "C": 23.3159160614014,
    "h": 262.02880859375,
    "CMY_C": 0.72079640626907,
    "CMY_M": 0.57393741607666,
    "CMY_Y": 0.44255191087723,
    "CMYK_C": 0.49913975596428,
    "CMYK_M": 0.235691010952,
    "CMYK_Y": 0,
    "CMYK_K": 0.44255191087723
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5024",
    "Farbtonhilfsbezeichnung": "RAL5024 Pastellblau",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "148",
    "Bcolor": "172",
    "Y": 25,
    "L": 58.8364067077637,
    "a": -10.2102527618408,
    "b": -18.1442260742188,
    "C": 20.8197555541992,
    "h": 240.632354736328,
    "CMY_C": 0.61415755748749,
    "CMY_M": 0.41843867301941,
    "CMY_Y": 0.32733732461929,
    "CMYK_C": 0.42639535665512,
    "CMYK_M": 0.13543392717838,
    "CMYK_Y": 0,
    "CMYK_K": 0.32733732461929
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5025",
    "Farbtonhilfsbezeichnung": "RAL5025 Perlenzian",
    "Farbtonklasse": "03",
    "Y": 17,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL5026",
    "Farbtonhilfsbezeichnung": "RAL5026 Perlnachtblau",
    "Farbtonklasse": "03",
    "Y": 6,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6000",
    "Farbtonhilfsbezeichnung": "RAL6000 Patinagruen",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "117",
    "Bcolor": "98",
    "Y": 16,
    "L": 45.127628326416,
    "a": -22.6083927154541,
    "b": 4.63749742507935,
    "C": 23.0791206359863,
    "h": 168.408126831055,
    "CMY_C": 0.75178629159927,
    "CMY_M": 0.54167038202286,
    "CMY_Y": 0.61730146408081,
    "CMYK_C": 0.45843842625618,
    "CMYK_M": 0,
    "CMYK_Y": 0.16501460969448,
    "CMYK_K": 0.54167038202286
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6001",
    "Farbtonhilfsbezeichnung": "RAL6001 Smaragdgruen",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "104",
    "Bcolor": "56",
    "Y": 11,
    "L": 39.5320281982422,
    "a": -27.2819747924805,
    "b": 21.6129951477051,
    "C": 34.8055686950684,
    "h": 141.61344909668,
    "CMY_C": 0.78324401378632,
    "CMY_M": 0.59280687570572,
    "CMY_Y": 0.78079444169998,
    "CMYK_C": 0.46768260002136,
    "CMYK_M": 0,
    "CMYK_Y": 0.46166685223579,
    "CMYK_K": 0.59280687570572
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6002",
    "Farbtonhilfsbezeichnung": "RAL6002 Laubgruen",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "95",
    "Bcolor": "52",
    "Y": 8,
    "L": 36.5120124816895,
    "a": -22.5468864440918,
    "b": 19.9881286621094,
    "C": 30.1311702728271,
    "h": 138.442565917969,
    "CMY_C": 0.77351415157318,
    "CMY_M": 0.62849569320679,
    "CMY_Y": 0.79577875137329,
    "CMYK_C": 0.39035472273827,
    "CMYK_M": 0,
    "CMYK_Y": 0.45028564333916,
    "CMYK_K": 0.62849569320679
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6003",
    "Farbtonhilfsbezeichnung": "RAL6003 Olivgruen",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "85",
    "Bcolor": "63",
    "Y": 8,
    "L": 35.1859436035156,
    "a": -5.30092620849609,
    "b": 12.1231241226196,
    "C": 13.2314004898071,
    "h": 113.617713928223,
    "CMY_C": 0.67946124076843,
    "CMY_M": 0.66772782802582,
    "CMY_Y": 0.75411701202393,
    "CMYK_C": 0.03531265631318,
    "CMYK_M": 0,
    "CMYK_Y": 0.259995251894,
    "CMYK_K": 0.66772782802582
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6004",
    "Farbtonhilfsbezeichnung": "RAL6004 Blaugruen",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "71",
    "Bcolor": "69",
    "Y": 5,
    "L": 27.112491607666,
    "a": -17.0429649353027,
    "b": -4.25085115432739,
    "C": 17.5650901794434,
    "h": 194.004943847656,
    "CMY_C": 0.92295008897781,
    "CMY_M": 0.72013437747955,
    "CMY_Y": 0.72748959064484,
    "CMYK_C": 0.72468960285187,
    "CMYK_M": 0,
    "CMYK_Y": 0.0262812320143,
    "CMYK_K": 0.72013437747955
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6005",
    "Farbtonhilfsbezeichnung": "RAL6005 Moosgruen",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "70",
    "Bcolor": "57",
    "Y": 4,
    "L": 26.6337070465088,
    "a": -18.5910453796387,
    "b": 3.51855325698853,
    "C": 18.9210777282715,
    "h": 169.282913208008,
    "CMY_C": 0.89072412252426,
    "CMY_M": 0.72399079799652,
    "CMY_Y": 0.77799475193024,
    "CMYK_C": 0.60408610105515,
    "CMYK_M": 0,
    "CMYK_Y": 0.19565998017788,
    "CMYK_K": 0.72399079799652
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6006",
    "Farbtonhilfsbezeichnung": "RAL6006 Grauoliv",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "67",
    "Bcolor": "59",
    "Y": 4,
    "L": 28.2124328613281,
    "a": -1.31986784934998,
    "b": 4.29766511917114,
    "C": 4.49577331542969,
    "h": 107.072387695313,
    "CMY_C": 0.73613631725311,
    "CMY_M": 0.73727869987488,
    "CMY_Y": 0.76700127124786,
    "CMYK_C": 0,
    "CMYK_M": 0.00432944251224,
    "CMYK_Y": 0.11697310209274,
    "CMYK_K": 0.73613631725311
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6007",
    "Farbtonhilfsbezeichnung": "RAL6007 Flaschengruen",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "56",
    "Bcolor": "43",
    "Y": 2,
    "L": 22.7277545928955,
    "a": -5.76256418228149,
    "b": 7.13853645324707,
    "C": 9.1741943359375,
    "h": 128.912109375,
    "CMY_C": 0.80518567562103,
    "CMY_M": 0.77845424413681,
    "CMY_Y": 0.83104360103607,
    "CMYK_C": 0.12065874040127,
    "CMYK_M": 0,
    "CMYK_Y": 0.23737469315529,
    "CMYK_K": 0.77845424413681
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6008",
    "Farbtonhilfsbezeichnung": "RAL6008 Braungruen",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "55",
    "Bcolor": "45",
    "Y": 2,
    "L": 22.9498157501221,
    "a": -0.5759225487709,
    "b": 6.08378601074219,
    "C": 6.11098527908325,
    "h": 95.4077987670898,
    "CMY_C": 0.77427494525909,
    "CMY_M": 0.78533232212067,
    "CMY_Y": 0.82240200042725,
    "CMYK_C": 0,
    "CMYK_M": 0.04898604005575,
    "CMYK_Y": 0.21321095526218,
    "CMYK_K": 0.77427494525909
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6009",
    "Farbtonhilfsbezeichnung": "RAL6009 Tannengruen",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "62",
    "Bcolor": "53",
    "Y": 3,
    "L": 24.6995582580566,
    "a": -7.03851652145386,
    "b": 3.27454400062561,
    "C": 7.76294755935669,
    "h": 155.050628662109,
    "CMY_C": 0.80706143379211,
    "CMY_M": 0.75835573673248,
    "CMY_Y": 0.79200381040573,
    "CMYK_C": 0.20155949890614,
    "CMYK_M": 0,
    "CMYK_Y": 0.13924631476402,
    "CMYK_K": 0.75835573673248
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6010",
    "Farbtonhilfsbezeichnung": "RAL6010 Grasgruen",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "112",
    "Bcolor": "60",
    "Y": 12,
    "L": 43.403694152832,
    "a": -22.6084442138672,
    "b": 24.6502323150635,
    "C": 33.4481048583984,
    "h": 132.526107788086,
    "CMY_C": 0.69688653945923,
    "CMY_M": 0.56203985214233,
    "CMY_Y": 0.76610749959946,
    "CMYK_C": 0.30789715051651,
    "CMYK_M": 0,
    "CMYK_Y": 0.46595028042793,
    "CMYK_K": 0.56203985214233
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6011",
    "Farbtonhilfsbezeichnung": "RAL6011 Resedagruen",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "125",
    "Bcolor": "91",
    "Y": 18,
    "L": 50.3653945922852,
    "a": -12.471489906311,
    "b": 16.0627384185791,
    "C": 20.3359203338623,
    "h": 127.826606750488,
    "CMY_C": 0.5739877820015,
    "CMY_M": 0.50870323181152,
    "CMY_Y": 0.64191114902496,
    "CMYK_C": 0.13288210332394,
    "CMYK_M": 0,
    "CMYK_Y": 0.2711353302002,
    "CMYK_K": 0.50870323181152
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6012",
    "Farbtonhilfsbezeichnung": "RAL6012 Schwarzgruen",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "63",
    "Bcolor": "61",
    "Y": 4,
    "L": 25.6129741668701,
    "a": -5.74925327301025,
    "b": -0.44213616847992,
    "C": 5.76622915267944,
    "h": 184.397567749023,
    "CMY_C": 0.80192053318024,
    "CMY_M": 0.7516176700592,
    "CMY_Y": 0.76220011711121,
    "CMYK_C": 0.202521905303,
    "CMYK_M": 0,
    "CMYK_Y": 0.04260547459126,
    "CMYK_K": 0.7516176700592
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6013",
    "Farbtonhilfsbezeichnung": "RAL6013 Schilfgruen",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "118",
    "Bcolor": "91",
    "Y": 18,
    "L": 49.5425682067871,
    "a": -2.15945911407471,
    "b": 15.50048828125,
    "C": 15.6501884460449,
    "h": 97.9311447143555,
    "CMY_C": 0.5128630399704,
    "CMY_M": 0.53674840927124,
    "CMY_Y": 0.64426016807556,
    "CMYK_C": 0,
    "CMYK_M": 0.04903214424849,
    "CMYK_Y": 0.26973342895508,
    "CMYK_K": 0.5128630399704
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6014",
    "Farbtonhilfsbezeichnung": "RAL6014 Gelbolive",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "65",
    "Bcolor": "53",
    "Y": 6,
    "L": 27.8043117523193,
    "a": 0.37659966945648,
    "b": 7.89591455459595,
    "C": 7.90489053726196,
    "h": 87.2693176269531,
    "CMY_C": 0.72163999080658,
    "CMY_M": 0.74483525753021,
    "CMY_Y": 0.79176634550095,
    "CMYK_C": 0,
    "CMYK_M": 0.08332829922438,
    "CMYK_Y": 0.25192683935165,
    "CMYK_K": 0.72163999080658
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6015",
    "Farbtonhilfsbezeichnung": "RAL6015 Schwarzoliv",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "62",
    "Bcolor": "56",
    "Y": 5,
    "L": 26.1201362609863,
    "a": -1.66282284259796,
    "b": 3.60087585449219,
    "C": 3.96626853942871,
    "h": 114.786682128906,
    "CMY_C": 0.75859117507935,
    "CMY_M": 0.75511807203293,
    "CMY_Y": 0.78108131885529,
    "CMYK_C": 0.01418276596814,
    "CMYK_M": 0,
    "CMYK_Y": 0.10602353513241,
    "CMYK_K": 0.75511807203293
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6016",
    "Farbtonhilfsbezeichnung": "RAL6016 Tuerkisgruen",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "108",
    "Bcolor": "80",
    "Y": 10,
    "L": 39.7272567749023,
    "a": -36.8596687316895,
    "b": 7.3609185218811,
    "C": 37.587474822998,
    "h": 168.706527709961,
    "CMY_C": 1,
    "CMY_M": 0.57631826400757,
    "CMY_Y": 0.68680512905121,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.26077798008919,
    "CMYK_K": 0.57631826400757
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6017",
    "Farbtonhilfsbezeichnung": "RAL6017 Maigruen",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "130",
    "Bcolor": "72",
    "Y": 18,
    "L": 50.269344329834,
    "a": -23.7598266601563,
    "b": 26.9069671630859,
    "C": 35.895881652832,
    "h": 131.445663452148,
    "CMY_C": 0.63398265838623,
    "CMY_M": 0.49206328392029,
    "CMY_Y": 0.71929758787155,
    "CMYK_C": 0.27940365672112,
    "CMYK_M": 0,
    "CMYK_Y": 0.44736734032631,
    "CMYK_K": 0.49206328392029
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6018",
    "Farbtonhilfsbezeichnung": "RAL6018 Gelbgruen",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "153",
    "Bcolor": "66",
    "Y": 26,
    "L": 57.9785652160645,
    "a": -34.0910606384277,
    "b": 39.0620994567871,
    "C": 51.8463897705078,
    "h": 131.112503051758,
    "CMY_C": 0.61495125293732,
    "CMY_M": 0.398177921772,
    "CMY_Y": 0.73975872993469,
    "CMYK_C": 0.36019504070282,
    "CMYK_M": 0,
    "CMYK_Y": 0.56757771968842,
    "CMYK_K": 0.398177921772
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6019",
    "Farbtonhilfsbezeichnung": "RAL6019 Weissgruen",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "204",
    "Bcolor": "170",
    "Y": 56,
    "L": 79.8529434204102,
    "a": -12.8176593780518,
    "b": 14.0547733306885,
    "C": 19.0218048095703,
    "h": 132.364166259766,
    "CMY_C": 0.27891284227371,
    "CMY_M": 0.19868844747543,
    "CMY_Y": 0.33319407701492,
    "CMYK_C": 0.1001163572073,
    "CMYK_M": 0,
    "CMYK_Y": 0.16785684227943,
    "CMYK_K": 0.19868844747543
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6020",
    "Farbtonhilfsbezeichnung": "RAL6020 Chromoxidgruen",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "73",
    "Bcolor": "58",
    "Y": 5,
    "L": 29.8840026855469,
    "a": -7.19901323318481,
    "b": 7.49749994277954,
    "C": 10.3941469192505,
    "h": 133.836471557617,
    "CMY_C": 0.75110352039337,
    "CMY_M": 0.71235942840576,
    "CMY_Y": 0.77239292860031,
    "CMYK_C": 0.13469620049,
    "CMYK_M": 0,
    "CMYK_Y": 0.20871013402939,
    "CMYK_K": 0.71235942840576
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6021",
    "Farbtonhilfsbezeichnung": "RAL6021 Blassgruen",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "155",
    "Bcolor": "121",
    "Y": 30,
    "L": 61.7339706420898,
    "a": -11.9196662902832,
    "b": 14.9966239929199,
    "C": 19.1566486358643,
    "h": 128.478500366211,
    "CMY_C": 0.45896065235138,
    "CMY_M": 0.39374947547913,
    "CMY_Y": 0.52463150024414,
    "CMYK_C": 0.10756473243237,
    "CMYK_M": 0,
    "CMYK_Y": 0.21588769555092,
    "CMYK_K": 0.39374947547913
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6022",
    "Farbtonhilfsbezeichnung": "RAL6022 Braunoliv",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "60",
    "Bcolor": "51",
    "Y": 4,
    "L": 25.8351421356201,
    "a": 0.82323902845383,
    "b": 6.29955339431763,
    "C": 6.35311698913574,
    "h": 82.5546569824219,
    "CMY_C": 0.74012303352356,
    "CMY_M": 0.76281750202179,
    "CMY_Y": 0.79909354448318,
    "CMYK_C": 0,
    "CMYK_M": 0.08732774108648,
    "CMYK_Y": 0.22691704332829,
    "CMYK_K": 0.74012303352356
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6024",
    "Farbtonhilfsbezeichnung": "RAL6024 Verkehrsgruen",
    "Farbtonklasse": "04",
    "Rcolor": "13",
    "Gcolor": "134",
    "Bcolor": "87",
    "Y": 16,
    "L": 49.1324234008789,
    "a": -41.8450393676758,
    "b": 16.4792060852051,
    "C": 44.9730110168457,
    "h": 158.504730224609,
    "CMY_C": 0.9472883939743,
    "CMY_M": 0.47618645429611,
    "CMY_Y": 0.66045022010803,
    "CMYK_C": 0.89936953783035,
    "CMYK_M": 0,
    "CMYK_Y": 0.35177358984947,
    "CMYK_K": 0.47618645429611
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6025",
    "Farbtonhilfsbezeichnung": "RAL6025 Farngruen",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "113",
    "Bcolor": "65",
    "Y": 13,
    "L": 45.097583770752,
    "a": -14.6113920211792,
    "b": 23.7940826416016,
    "C": 27.922233581543,
    "h": 121.553123474121,
    "CMY_C": 0.62286376953125,
    "CMY_M": 0.55828523635864,
    "CMY_Y": 0.74335908889771,
    "CMYK_C": 0.14619962871075,
    "CMYK_M": 0,
    "CMYK_Y": 0.4189895093441,
    "CMYK_K": 0.55828523635864
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6026",
    "Farbtonhilfsbezeichnung": "RAL6026 Opalgruen",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "80",
    "Y": 8,
    "L": 35.0691375732422,
    "a": -34.6402778625488,
    "b": 0.3838033080101,
    "C": 34.6424026489258,
    "h": 179.365203857422,
    "CMY_C": 1,
    "CMY_M": 0.62361574172974,
    "CMY_Y": 0.68514561653137,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.16347621381283,
    "CMYK_K": 0.62361574172974
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6027",
    "Farbtonhilfsbezeichnung": "RAL6027 Lichtgruen",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "186",
    "Bcolor": "180",
    "Y": 43,
    "L": 71.4727935791016,
    "a": -20.6480007171631,
    "b": -3.86862301826477,
    "C": 21.007287979126,
    "h": 190.611938476562,
    "CMY_C": 0.50881612300873,
    "CMY_M": 0.26976066827774,
    "CMY_Y": 0.29413866996765,
    "CMYK_C": 0.32736590504646,
    "CMYK_M": 0,
    "CMYK_Y": 0.03338357806206,
    "CMYK_K": 0.26976066827774
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6028",
    "Farbtonhilfsbezeichnung": "RAL6028 Kieferngruen",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "88",
    "Bcolor": "72",
    "Y": 8,
    "L": 34.5863456726074,
    "a": -15.7517690658569,
    "b": 5.04897880554199,
    "C": 16.5411739349365,
    "h": 162.227584838867,
    "CMY_C": 0.78229749202728,
    "CMY_M": 0.65451073646545,
    "CMY_Y": 0.71671509742737,
    "CMYK_C": 0.3698718547821,
    "CMYK_M": 0,
    "CMYK_Y": 0.18004715442657,
    "CMYK_K": 0.65451073646545
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6029",
    "Farbtonhilfsbezeichnung": "RAL6029 Minzgruen",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "68",
    "Y": 11,
    "L": 41.4096527099609,
    "a": -43.1151351928711,
    "b": 16.8621807098389,
    "C": 46.2952270507813,
    "h": 158.639709472656,
    "CMY_C": 1,
    "CMY_M": 0.55356526374817,
    "CMY_Y": 0.73429918289185,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.40483838319778,
    "CMYK_K": 0.55356526374817
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6031",
    "Farbtonhilfsbezeichnung": "RAL6031 Bronzegruen",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "80",
    "Bcolor": "64",
    "Y": 7.64492225646973,
    "L": 33.2321739196777,
    "a": -3.75190114974976,
    "b": 8.47408866882324,
    "C": 9.26752090454102,
    "h": 113.881355285645,
    "CMY_C": 0.69588100910187,
    "CMY_M": 0.68800663948059,
    "CMY_Y": 0.74850261211395,
    "CMYK_C": 0.02523890137672,
    "CMYK_M": 0,
    "CMYK_Y": 0.19390147924423,
    "CMYK_K": 0.68800663948059
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6032",
    "Farbtonhilfsbezeichnung": "RAL6032 Signalgruen",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "128",
    "Bcolor": "86",
    "Y": 16,
    "L": 47.9015121459961,
    "a": -35.7561454772949,
    "b": 15.4897832870483,
    "C": 38.9671058654785,
    "h": 156.577438354492,
    "CMY_C": 0.82932645082474,
    "CMY_M": 0.4966921210289,
    "CMY_Y": 0.66449594497681,
    "CMYK_C": 0.66089630126953,
    "CMYK_M": 0,
    "CMYK_Y": 0.33340194821358,
    "CMYK_K": 0.4966921210289
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6033",
    "Farbtonhilfsbezeichnung": "RAL6033 Minttuerkis",
    "Farbtonklasse": "02",
    "Rcolor": "74",
    "Gcolor": "137",
    "Bcolor": "129",
    "Y": 19,
    "L": 52.8050003051758,
    "a": -21.9442958831787,
    "b": -2.75278186798096,
    "C": 22.1162815093994,
    "h": 187.15007019043,
    "CMY_C": 0.7092912197113,
    "CMY_M": 0.463707447052,
    "CMY_Y": 0.49390000104904,
    "CMYK_C": 0.45792874693871,
    "CMYK_M": 0,
    "CMYK_Y": 0.05629866197705,
    "CMYK_K": 0.463707447052
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6034",
    "Farbtonhilfsbezeichnung": "RAL6034 Pastelltuerkis",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "173",
    "Bcolor": "172",
    "Y": 35,
    "L": 67.3344116210938,
    "a": -16.8256740570068,
    "b": -5.38656616210938,
    "C": 17.6668739318848,
    "h": 197.751922607422,
    "CMY_C": 0.52114009857178,
    "CMY_M": 0.32076716423035,
    "CMY_Y": 0.32667618989944,
    "CMYK_C": 0.29499888420105,
    "CMYK_M": 0,
    "CMYK_Y": 0.00869955867529,
    "CMYK_K": 0.32076716423035
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6035",
    "Farbtonhilfsbezeichnung": "RAL6035 Perlgrün",
    "Farbtonklasse": "03",
    "Y": 10,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6036",
    "Farbtonhilfsbezeichnung": "RAL6036 Perlopalgrün",
    "Farbtonklasse": "03",
    "Y": 13,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6037",
    "Farbtonhilfsbezeichnung": "RAL6037 Reingruen",
    "Farbtonklasse": "04",
    "Rcolor": "13",
    "Gcolor": "142",
    "Bcolor": "51",
    "Y": 21,
    "L": 51.3370208740234,
    "a": -51.0203437805176,
    "b": 37.9979629516602,
    "C": 63.6154136657715,
    "h": 143.322692871094,
    "CMY_C": 0.9497337937355,
    "CMY_M": 0.44458645582199,
    "CMY_Y": 0.79899156093597,
    "CMYK_C": 0.90949767827988,
    "CMYK_M": 0,
    "CMYK_Y": 0.6380922794342,
    "CMYK_K": 0.44458645582199
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6039",
    "Farbtonhilfsbezeichnung": "RAL6039 Fasergruen",
    "Farbtonklasse": "04",
    "Rcolor": "175",
    "Gcolor": "193",
    "Bcolor": "74",
    "Y": 47.6576347351074,
    "L": 74.6084747314453,
    "a": -22.1286201477051,
    "b": 55.3513221740723,
    "C": 59.6107749938965,
    "h": 111.790786743164,
    "CMY_C": 0.3142466545105,
    "CMY_M": 0.24384582042694,
    "CMY_Y": 0.707843542099,
    "CMYK_C": 0.09310381114483,
    "CMYK_M": 0,
    "CMYK_Y": 0.61362844705582,
    "CMYK_K": 0.24384582042694
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL6040",
    "Farbtonhilfsbezeichnung": "RAL6040 Helloliv",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "98",
    "Bcolor": "77",
    "Y": 12,
    "L": 41.798942565918,
    "a": 0.79434466362,
    "b": 12.7100648880005,
    "C": 12.73486328125,
    "h": 86.4238204956055,
    "CMY_C": 0.57693374156952,
    "CMY_M": 0.61743474006653,
    "CMY_Y": 0.69739156961441,
    "CMYK_C": 0,
    "CMYK_M": 0.09573204815388,
    "CMYK_Y": 0.28472566604614,
    "CMYK_K": 0.57693374156952
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7000",
    "Farbtonhilfsbezeichnung": "RAL7000 Fehgrau",
    "Farbtonklasse": "01",
    "Rcolor": "123",
    "Gcolor": "136",
    "Bcolor": "142",
    "Y": 24,
    "L": 55.9976692199707,
    "a": -3.22972893714905,
    "b": -5.37552452087402,
    "C": 6.27115726470947,
    "h": 239.001647949219,
    "CMY_C": 0.51647418737411,
    "CMY_M": 0.46513712406158,
    "CMY_Y": 0.44226104021072,
    "CMYK_C": 0.13306072354317,
    "CMYK_M": 0.04101575538516,
    "CMYK_Y": 0,
    "CMYK_K": 0.44226104021072
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7001",
    "Farbtonhilfsbezeichnung": "RAL7001 Silbergrau",
    "Farbtonklasse": "01",
    "Rcolor": "140",
    "Gcolor": "150",
    "Bcolor": "155",
    "Y": 30,
    "L": 61.3358421325684,
    "a": -2.02492165565491,
    "b": -4.56794166564941,
    "C": 4.99663877487183,
    "h": 246.092788696289,
    "CMY_C": 0.45022016763687,
    "CMY_M": 0.41336846351624,
    "CMY_Y": 0.3930259346962,
    "CMYK_C": 0.09422846138477,
    "CMYK_M": 0.03351465985179,
    "CMYK_Y": 0,
    "CMYK_K": 0.3930259346962
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7002",
    "Farbtonhilfsbezeichnung": "RAL7002 Olivgrau",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "124",
    "Bcolor": "104",
    "Y": 20,
    "L": 52.0959625244141,
    "a": 0.08938348293304,
    "b": 11.4400129318237,
    "C": 11.4403619766235,
    "h": 89.5523452758789,
    "CMY_C": 0.48149818181992,
    "CMY_M": 0.51537150144577,
    "CMY_Y": 0.59258699417114,
    "CMYK_C": 0,
    "CMYK_M": 0.06532922387123,
    "CMYK_Y": 0.21424961090088,
    "CMYK_K": 0.48149818181992
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7003",
    "Farbtonhilfsbezeichnung": "RAL7003 Moosgrau",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "119",
    "Bcolor": "105",
    "Y": 18,
    "L": 49.8220443725586,
    "a": -1.37996327877045,
    "b": 7.48653650283813,
    "C": 7.61265563964844,
    "h": 100.443870544434,
    "CMY_C": 0.52377849817276,
    "CMY_M": 0.53395962715149,
    "CMY_Y": 0.58846938610077,
    "CMYK_C": 0,
    "CMYK_M": 0.02137897722423,
    "CMYK_Y": 0.13584201037884,
    "CMYK_K": 0.52377849817276
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7004",
    "Farbtonhilfsbezeichnung": "RAL7004 Signalgrau",
    "Farbtonklasse": "01",
    "Rcolor": "155",
    "Gcolor": "155",
    "Bcolor": "156",
    "Y": 31,
    "L": 64.0096893310547,
    "a": 0.42912909388542,
    "b": -1.02294909954071,
    "C": 1.10931360721588,
    "h": 292.758148193359,
    "CMY_C": 0.39193224906921,
    "CMY_M": 0.3920561671257,
    "CMY_Y": 0.38947641849518,
    "CMYK_C": 0.00402249908075,
    "CMYK_M": 0.00422546919435,
    "CMYK_Y": 0,
    "CMYK_K": 0.38947641849518
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7005",
    "Farbtonhilfsbezeichnung": "RAL7005 Mausgrau",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "113",
    "Bcolor": "110",
    "Y": 16,
    "L": 47.2060203552246,
    "a": -1.29143381118774,
    "b": 0.75744885206223,
    "C": 1.49717402458191,
    "h": 149.607620239258,
    "CMY_C": 0.56779718399048,
    "CMY_M": 0.55828607082367,
    "CMY_Y": 0.56969875097275,
    "CMYK_C": 0.02153229154646,
    "CMYK_M": 0,
    "CMYK_Y": 0.02583726495504,
    "CMYK_K": 0.55828607082367
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7006",
    "Farbtonhilfsbezeichnung": "RAL7006 Beigegrau",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "106",
    "Bcolor": "93",
    "Y": 14,
    "L": 45.5460357666016,
    "a": 2.62249732017517,
    "b": 8.29504585266113,
    "C": 8.69972896575928,
    "h": 72.4555358886719,
    "CMY_C": 0.53810781240463,
    "CMY_M": 0.58440369367599,
    "CMY_Y": 0.63387137651443,
    "CMYK_C": 0,
    "CMYK_M": 0.10023092478514,
    "CMYK_Y": 0.20732882618904,
    "CMYK_K": 0.53810781240463
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7008",
    "Farbtonhilfsbezeichnung": "RAL7008 Khakigrau",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "98",
    "Bcolor": "67",
    "Y": 12,
    "L": 42.7117004394531,
    "a": 3.85795855522156,
    "b": 20.4622497558594,
    "C": 20.8227634429932,
    "h": 79.3227767944336,
    "CMY_C": 0.53587728738785,
    "CMY_M": 0.61663317680359,
    "CMY_Y": 0.73896545171738,
    "CMYK_C": 0,
    "CMYK_M": 0.1739968508482,
    "CMYK_Y": 0.43757429718971,
    "CMYK_K": 0.53587728738785
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7009",
    "Farbtonhilfsbezeichnung": "RAL7009 Gruengrau",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "85",
    "Y": 10,
    "L": 39.5147018432617,
    "a": -2.52619075775146,
    "b": 4.19948863983154,
    "C": 4.90074920654297,
    "h": 121.02889251709,
    "CMY_C": 0.64011776447296,
    "CMY_M": 0.63073319196701,
    "CMY_Y": 0.66476881504059,
    "CMYK_C": 0.02541407011449,
    "CMYK_M": 0,
    "CMYK_Y": 0.09217081964016,
    "CMYK_K": 0.63073319196701
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7010",
    "Farbtonhilfsbezeichnung": "RAL7010 Zeltgrau",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "93",
    "Bcolor": "88",
    "Y": 10,
    "L": 39.0233192443848,
    "a": -2.28616046905518,
    "b": 2.00727367401123,
    "C": 3.04231452941895,
    "h": 138.716506958008,
    "CMY_C": 0.64928686618805,
    "CMY_M": 0.63536041975021,
    "CMY_Y": 0.65551507472992,
    "CMYK_C": 0.03819236159325,
    "CMYK_M": 0,
    "CMYK_Y": 0.0552728138864,
    "CMYK_K": 0.63536041975021
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7011",
    "Farbtonhilfsbezeichnung": "RAL7011 Eisengrau",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "89",
    "Bcolor": "93",
    "Y": 10,
    "L": 37.3432121276855,
    "a": -1.68962335586548,
    "b": -3.43416738510132,
    "C": 3.82731413841248,
    "h": 243.802642822266,
    "CMY_C": 0.67786741256714,
    "CMY_M": 0.6510306596756,
    "CMY_Y": 0.63715189695358,
    "CMYK_C": 0.11221090704203,
    "CMYK_M": 0.03824951127172,
    "CMYK_Y": 0,
    "CMYK_K": 0.63715189695358
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7012",
    "Farbtonhilfsbezeichnung": "RAL7012 Basaltgrau",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "97",
    "Bcolor": "98",
    "Y": 11,
    "L": 40.7187232971191,
    "a": -1.79748141765594,
    "b": -2.04493260383606,
    "C": 2.72262525558472,
    "h": 228.684753417969,
    "CMY_C": 0.64241969585419,
    "CMY_M": 0.61923813819885,
    "CMY_Y": 0.61399573087692,
    "CMYK_C": 0.07363639771938,
    "CMYK_M": 0.0135812163353,
    "CMYK_Y": 0,
    "CMYK_K": 0.61399573087692
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7013",
    "Farbtonhilfsbezeichnung": "RAL7013 Braungrau",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "82",
    "Bcolor": "70",
    "Y": 8,
    "L": 35.1469802856445,
    "a": 0.89448976516724,
    "b": 7.6719822883606,
    "C": 7.72395133972168,
    "h": 83.3498077392578,
    "CMY_C": 0.65094763040543,
    "CMY_M": 0.67914509773254,
    "CMY_Y": 0.72584390640259,
    "CMYK_C": 0,
    "CMYK_M": 0.08078291267157,
    "CMYK_Y": 0.21457031369209,
    "CMYK_K": 0.65094763040543
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7015",
    "Farbtonhilfsbezeichnung": "RAL7015 Schiefergrau",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "87",
    "Bcolor": "93",
    "Y": 9,
    "L": 36.8235130310059,
    "a": -0.14093552529812,
    "b": -4.23023223876953,
    "C": 4.23257923126221,
    "h": 268.091827392578,
    "CMY_C": 0.67443537712097,
    "CMY_M": 0.65872269868851,
    "CMY_Y": 0.63692367076874,
    "CMYK_C": 0.10331630706787,
    "CMYK_M": 0.06003979220986,
    "CMYK_Y": 0,
    "CMYK_K": 0.63692367076874
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7016",
    "Farbtonhilfsbezeichnung": "RAL7016 Anthrazitgrau",
    "Farbtonklasse": "02",
    "Rcolor": "62",
    "Gcolor": "68",
    "Bcolor": "73",
    "Y": 5,
    "L": 28.545711517334,
    "a": -1.41868460178375,
    "b": -3.84333205223083,
    "C": 4.09681177139282,
    "h": 249.739440917969,
    "CMY_C": 0.75721687078476,
    "CMY_M": 0.73226094245911,
    "CMY_Y": 0.71563416719437,
    "CMYK_C": 0.14622960984707,
    "CMYK_M": 0.05846966430545,
    "CMYK_Y": 0,
    "CMYK_K": 0.71563416719437
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7021",
    "Farbtonhilfsbezeichnung": "RAL7021 Schwarzgrau",
    "Farbtonklasse": "02",
    "Rcolor": "57",
    "Gcolor": "60",
    "Bcolor": "62",
    "Y": 6,
    "L": 25.0424404144287,
    "a": -0.58986836671829,
    "b": -1.85654389858246,
    "C": 1.94799900054932,
    "h": 252.37370300293,
    "CMY_C": 0.77614206075668,
    "CMY_M": 0.76538515090942,
    "CMY_Y": 0.7584068775177,
    "CMYK_C": 0.07340930402279,
    "CMYK_M": 0.02888440340757,
    "CMYK_Y": 0,
    "CMYK_K": 0.7584068775177
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7022",
    "Farbtonhilfsbezeichnung": "RAL7022 Umbragrau",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "80",
    "Bcolor": "76",
    "Y": 7,
    "L": 34.2134742736816,
    "a": -0.18994432687759,
    "b": 2.26875329017639,
    "C": 2.27669072151184,
    "h": 94.7857513427734,
    "CMY_C": 0.67950755357742,
    "CMY_M": 0.68445992469788,
    "CMY_Y": 0.70113384723663,
    "CMYK_C": 0,
    "CMYK_M": 0.01545238029212,
    "CMYK_Y": 0.06747832894325,
    "CMYK_K": 0.67950755357742
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7023",
    "Farbtonhilfsbezeichnung": "RAL7023 Betongrau",
    "Farbtonklasse": "01",
    "Rcolor": "128",
    "Gcolor": "128",
    "Bcolor": "119",
    "Y": 22,
    "L": 53.5077629089355,
    "a": -1.5399317741394,
    "b": 4.37529039382935,
    "C": 4.63837862014771,
    "h": 109.390083312988,
    "CMY_C": 0.49659758806229,
    "CMY_M": 0.49624764919281,
    "CMY_Y": 0.53206706047058,
    "CMYK_C": 0.00069466448622,
    "CMYK_M": 0,
    "CMYK_Y": 0.07110519707203,
    "CMYK_K": 0.49624764919281
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7024",
    "Farbtonhilfsbezeichnung": "RAL7024 Graphitgrau",
    "Farbtonklasse": "02",
    "Rcolor": "71",
    "Gcolor": "76",
    "Bcolor": "81",
    "Y": 7,
    "L": 31.9507160186768,
    "a": -0.39187660813332,
    "b": -4.2149076461792,
    "C": 4.23308563232422,
    "h": 264.688262939453,
    "CMY_C": 0.72084593772888,
    "CMY_M": 0.70327281951904,
    "CMY_Y": 0.68231797218323,
    "CMYK_C": 0.12127839028835,
    "CMYK_M": 0.0659617036581,
    "CMYK_Y": 0,
    "CMYK_K": 0.68231797218323
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7026",
    "Farbtonhilfsbezeichnung": "RAL7026 Granitgrau",
    "Farbtonklasse": "02",
    "Rcolor": "61",
    "Gcolor": "73",
    "Bcolor": "75",
    "Y": 5,
    "L": 29.9388198852539,
    "a": -3.7215940952301,
    "b": -3.47642588615417,
    "C": 5.09272003173828,
    "h": 223.049224853516,
    "CMY_C": 0.75991797447205,
    "CMY_M": 0.71559292078018,
    "CMY_Y": 0.70546245574951,
    "CMYK_C": 0.18488481640816,
    "CMYK_M": 0.03439447656274,
    "CMYK_Y": 0,
    "CMYK_K": 0.70546245574951
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7030",
    "Farbtonhilfsbezeichnung": "RAL7030 Steingrau",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "142",
    "Bcolor": "133",
    "Y": 26,
    "L": 59.1291465759277,
    "a": -0.15005597472191,
    "b": 4.64374256134033,
    "C": 4.64616632461548,
    "h": 91.8507843017578,
    "CMY_C": 0.42907625436783,
    "CMY_M": 0.44244557619095,
    "CMY_Y": 0.4778938293457,
    "CMYK_C": 0,
    "CMYK_M": 0.02341700159013,
    "CMYK_Y": 0.08550629764795,
    "CMYK_K": 0.42907625436783
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7031",
    "Farbtonhilfsbezeichnung": "RAL7031 Blaugrau",
    "Farbtonklasse": "02",
    "Rcolor": "95",
    "Gcolor": "109",
    "Bcolor": "113",
    "Y": 14,
    "L": 44.9368782043457,
    "a": -3.60743451118469,
    "b": -4.88801956176758,
    "C": 6.07505702972412,
    "h": 233.57209777832,
    "CMY_C": 0.62570202350616,
    "CMY_M": 0.5743368268013,
    "CMY_Y": 0.5554906129837,
    "CMYK_C": 0.15795259177685,
    "CMYK_M": 0.04239778593183,
    "CMYK_Y": 0,
    "CMYK_K": 0.5554906129837
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7032",
    "Farbtonhilfsbezeichnung": "RAL7032 Kieselgrau",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "174",
    "Bcolor": "158",
    "Y": 43,
    "L": 71.2323760986328,
    "a": -0.80465841293335,
    "b": 8.30738067626953,
    "C": 8.34625911712646,
    "h": 95.5324478149414,
    "CMY_C": 0.29673719406128,
    "CMY_M": 0.3160103559494,
    "CMY_Y": 0.38007110357285,
    "CMYK_C": 0,
    "CMYK_M": 0.02740534767509,
    "CMYK_Y": 0.11849611252546,
    "CMYK_K": 0.29673719406128
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7033",
    "Farbtonhilfsbezeichnung": "RAL7033 Zementgrau",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "131",
    "Bcolor": "117",
    "Y": 22,
    "L": 54.2324409484863,
    "a": -3.59753346443176,
    "b": 6.68273639678955,
    "C": 7.58954620361328,
    "h": 118.295021057129,
    "CMY_C": 0.49728310108185,
    "CMY_M": 0.48524177074432,
    "CMY_Y": 0.54063320159912,
    "CMYK_C": 0.02339220605791,
    "CMYK_M": 0,
    "CMYK_Y": 0.10760669410229,
    "CMYK_K": 0.48524177074432
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7034",
    "Farbtonhilfsbezeichnung": "RAL7034 Gelbgrau",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "139",
    "Bcolor": "116",
    "Y": 25,
    "L": 58.1973648071289,
    "a": -0.23248529434204,
    "b": 13.3715314865112,
    "C": 13.3735523223877,
    "h": 90.9960784912109,
    "CMY_C": 0.41663444042206,
    "CMY_M": 0.45374578237534,
    "CMY_Y": 0.54645496606827,
    "CMYK_C": 0,
    "CMYK_M": 0.06361592561007,
    "CMYK_Y": 0.2225371748209,
    "CMYK_K": 0.41663444042206
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7035",
    "Farbtonhilfsbezeichnung": "RAL7035 Lichtgrau",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "200",
    "Bcolor": "195",
    "Y": 57,
    "L": 80.3490142822266,
    "a": -1.13360440731049,
    "b": 1.42384719848633,
    "C": 1.8199999332428,
    "h": 128.525253295898,
    "CMY_C": 0.2223801612854,
    "CMY_M": 0.2156475186348,
    "CMY_Y": 0.23482888936996,
    "CMYK_C": 0.00858369562775,
    "CMYK_M": 0,
    "CMYK_Y": 0.02445503883064,
    "CMYK_K": 0.2156475186348
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7036",
    "Farbtonhilfsbezeichnung": "RAL7036 Platingrau",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "149",
    "Bcolor": "147",
    "Y": 30,
    "L": 61.7688789367676,
    "a": 1.36317932605743,
    "b": 0.38260021805763,
    "C": 1.41585338115692,
    "h": 15.6777086257935,
    "CMY_C": 0.40381062030792,
    "CMY_M": 0.41764330863953,
    "CMY_Y": 0.42198133468628,
    "CMYK_C": 0,
    "CMYK_M": 0.02320183627307,
    "CMYK_Y": 0.03047809191048,
    "CMYK_K": 0.40381062030792
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7037",
    "Farbtonhilfsbezeichnung": "RAL7037 Staubgrau",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "127",
    "Bcolor": "126",
    "Y": 21,
    "L": 53.0001907348633,
    "a": -0.56113088130951,
    "b": -0.20873928070068,
    "C": 0.59869855642319,
    "h": 200.405075073242,
    "CMY_C": 0.50849199295044,
    "CMY_M": 0.50224941968918,
    "CMY_Y": 0.50648820400238,
    "CMYK_C": 0.01254156883806,
    "CMYK_M": 0,
    "CMYK_Y": 0.00851588044316,
    "CMYK_K": 0.50224941968918
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7038",
    "Farbtonhilfsbezeichnung": "RAL7038 Achatgrau",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "178",
    "Bcolor": "170",
    "Y": 44,
    "L": 72.2199249267578,
    "a": -1.51783645153046,
    "b": 3.1986231803894,
    "C": 3.54048275947571,
    "h": 115.385650634766,
    "CMY_C": 0.30678248405457,
    "CMY_M": 0.3026437163353,
    "CMY_Y": 0.33383631706238,
    "CMYK_C": 0.0059349401854,
    "CMYK_M": 0,
    "CMYK_Y": 0.04472979158163,
    "CMYK_K": 0.3026437163353
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7039",
    "Farbtonhilfsbezeichnung": "RAL7039 Quarzgrau",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "106",
    "Bcolor": "99",
    "Y": 13,
    "L": 45.0799865722656,
    "a": 0.5135685801506,
    "b": 4.07194185256958,
    "C": 4.10420083999634,
    "h": 82.8115997314453,
    "CMY_C": 0.56675869226456,
    "CMY_M": 0.58349901437759,
    "CMY_Y": 0.61130672693253,
    "CMYK_C": 0,
    "CMYK_M": 0.03863971680403,
    "CMYK_Y": 0.10282499343157,
    "CMYK_K": 0.56675869226456
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7040",
    "Farbtonhilfsbezeichnung": "RAL7040 Fenstergrau",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "159",
    "Bcolor": "162",
    "Y": 34,
    "L": 64.9824752807617,
    "a": -1.27906179428101,
    "b": -3.22341871261597,
    "C": 3.46791386604309,
    "h": 248.356674194336,
    "CMY_C": 0.40220630168915,
    "CMY_M": 0.37759280204773,
    "CMY_Y": 0.36445307731628,
    "CMYK_C": 0.05940273404121,
    "CMYK_M": 0.02067467197776,
    "CMYK_Y": 0,
    "CMYK_K": 0.36445307731628
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7042",
    "Farbtonhilfsbezeichnung": "RAL7042 Verkehrsgrau A",
    "Farbtonklasse": "01",
    "Rcolor": "143",
    "Gcolor": "148",
    "Bcolor": "147",
    "Y": 29,
    "L": 60.8753852844238,
    "a": -1.64201784133911,
    "b": -0.9673228263855,
    "C": 1.90576386451721,
    "h": 210.502593994141,
    "CMY_C": 0.43941193819046,
    "CMY_M": 0.41990834474564,
    "CMY_Y": 0.42226624488831,
    "CMYK_C": 0.03362157195807,
    "CMYK_M": 0,
    "CMYK_Y": 0.00406470289454,
    "CMYK_K": 0.41990834474564
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7043",
    "Farbtonhilfsbezeichnung": "RAL7043 Verkehrsgrau B",
    "Farbtonklasse": "02",
    "Rcolor": "84",
    "Gcolor": "88",
    "Bcolor": "87",
    "Y": 9,
    "L": 37.0981101989746,
    "a": -1.64116489887238,
    "b": -0.49436241388321,
    "C": 1.71400594711304,
    "h": 196.763702392578,
    "CMY_C": 0.67032301425934,
    "CMY_M": 0.65415477752686,
    "CMY_Y": 0.65772211551666,
    "CMYK_C": 0.04674991965294,
    "CMYK_M": 0,
    "CMYK_Y": 0.01031483989209,
    "CMYK_K": 0.65415477752686
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7044",
    "Farbtonhilfsbezeichnung": "RAL7044 Seidengrau",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 44,
    "L": 72.896842956543,
    "a": -0.03216871991754,
    "b": 5.14293718338013,
    "C": 5.14303779602051,
    "h": 90.3583755493164,
    "CMY_C": 0.28253388404846,
    "CMY_M": 0.29929167032242,
    "CMY_Y": 0.34028834104538,
    "CMYK_C": 0,
    "CMYK_M": 0.02335690334439,
    "CMYK_Y": 0.08049781620502,
    "CMYK_K": 0.28253388404846
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7045",
    "Farbtonhilfsbezeichnung": "RAL7045 Telegrau 1",
    "Farbtonklasse": "01",
    "Rcolor": "142",
    "Gcolor": "148",
    "Bcolor": "150",
    "Y": 29,
    "L": 60.788875579834,
    "a": -1.42322361469269,
    "b": -2.45909357070923,
    "C": 2.84125089645386,
    "h": 239.939483642578,
    "CMY_C": 0.44370913505554,
    "CMY_M": 0.42086493968964,
    "CMY_Y": 0.41295528411865,
    "CMYK_C": 0.05238757655025,
    "CMYK_M": 0.01347368489951,
    "CMYK_Y": 0,
    "CMYK_K": 0.41295528411865
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7046",
    "Farbtonhilfsbezeichnung": "RAL7046 Telegrau 2",
    "Farbtonklasse": "01",
    "Rcolor": "127",
    "Gcolor": "134",
    "Bcolor": "138",
    "Y": 24,
    "L": 55.5537338256836,
    "a": -1.69683241844177,
    "b": -3.40322089195251,
    "C": 3.8027822971344,
    "h": 243.499328613281,
    "CMY_C": 0.50194942951202,
    "CMY_M": 0.47335773706436,
    "CMY_Y": 0.45979517698288,
    "CMYK_C": 0.07803383469582,
    "CMYK_M": 0.02510632947087,
    "CMYK_Y": 0,
    "CMYK_K": 0.45979517698288
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7047",
    "Farbtonhilfsbezeichnung": "RAL7047 Telegrau 4",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 57,
    "L": 80.1558380126953,
    "a": -0.15697385370731,
    "b": 0.57123565673828,
    "C": 0.59241116046906,
    "h": 105.365432739258,
    "CMY_C": 0.21976959705353,
    "CMY_M": 0.21975475549698,
    "CMY_Y": 0.23062539100647,
    "CMYK_C": 1.902165604e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.01393233146518,
    "CMYK_K": 0.21975475549698
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7048",
    "Farbtonhilfsbezeichnung": "RAL7048 Perlmausgrau",
    "Farbtonklasse": "01",
    "Y": 32,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL7050",
    "Farbtonhilfsbezeichnung": "RAL7050 Tarngrau",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "106",
    "Bcolor": "99",
    "Y": 15,
    "L": 45.492504119873,
    "a": 2.03950810432434,
    "b": 4.51022052764893,
    "C": 4.94991731643677,
    "h": 65.6676559448242,
    "CMY_C": 0.55154544115067,
    "CMY_M": 0.58282059431076,
    "CMY_Y": 0.61000782251358,
    "CMYK_C": 0,
    "CMYK_M": 0.06973984837532,
    "CMYK_Y": 0.13036412000656,
    "CMYK_K": 0.55154544115067
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8000",
    "Farbtonhilfsbezeichnung": "RAL8000 Gruenbraun",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "109",
    "Bcolor": "70",
    "Y": 15,
    "L": 47.9973907470703,
    "a": 7.29101896286011,
    "b": 25.6693592071533,
    "C": 26.6847324371338,
    "h": 74.1435546875,
    "CMY_C": 0.45390796661377,
    "CMY_M": 0.57435685396194,
    "CMY_Y": 0.72515797615051,
    "CMYK_C": 0,
    "CMYK_M": 0.22056518495083,
    "CMYK_Y": 0.49671116471291,
    "CMYK_K": 0.45390796661377
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8001",
    "Farbtonhilfsbezeichnung": "RAL8001 Ockerbraun",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "102",
    "Bcolor": "57",
    "Y": 16,
    "L": 48.3624114990234,
    "a": 17.6860771179199,
    "b": 33.789005279541,
    "C": 38.1378326416016,
    "h": 62.371223449707,
    "CMY_C": 0.38328832387924,
    "CMY_M": 0.5982551574707,
    "CMY_Y": 0.77568078041077,
    "CMYK_C": 0,
    "CMYK_M": 0.34856942296028,
    "CMYK_Y": 0.63626563549042,
    "CMYK_K": 0.38328832387924
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8002",
    "Farbtonhilfsbezeichnung": "RAL8002 Signalbraun",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "80",
    "Bcolor": "66",
    "Y": 9,
    "L": 38.4116096496582,
    "a": 16.1598243713379,
    "b": 15.0219841003418,
    "C": 22.0635433197021,
    "h": 42.9101753234863,
    "CMY_C": 0.52010917663574,
    "CMY_M": 0.68568110466003,
    "CMY_Y": 0.7400506734848,
    "CMYK_C": 0,
    "CMYK_M": 0.34501999616623,
    "CMYK_Y": 0.45831570029259,
    "CMYK_K": 0.52010917663574
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8003",
    "Farbtonhilfsbezeichnung": "RAL8003 Lehmbraun",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "82",
    "Bcolor": "53",
    "Y": 10,
    "L": 39.5800819396973,
    "a": 16.994722366333,
    "b": 24.574146270752,
    "C": 29.8782405853271,
    "h": 55.3334579467773,
    "CMY_C": 0.49167567491531,
    "CMY_M": 0.67869341373444,
    "CMY_Y": 0.79098254442215,
    "CMYK_C": 0,
    "CMYK_M": 0.36791026592255,
    "CMYK_Y": 0.58881086111069,
    "CMYK_K": 0.49167567491531
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8004",
    "Farbtonhilfsbezeichnung": "RAL8004 Kupferbraun",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "77",
    "Bcolor": "55",
    "Y": 10,
    "L": 40.3264274597168,
    "a": 26.083402633667,
    "b": 24.793815612793,
    "C": 35.9871826171875,
    "h": 43.5480346679688,
    "CMY_C": 0.43755286931992,
    "CMY_M": 0.69842225313187,
    "CMY_Y": 0.78349047899246,
    "CMYK_C": 0,
    "CMYK_M": 0.46381139755249,
    "CMYK_Y": 0.61505800485611,
    "CMYK_K": 0.43755286931992
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8007",
    "Farbtonhilfsbezeichnung": "RAL8007 Rehbraun",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "74",
    "Bcolor": "51",
    "Y": 7,
    "L": 35.3280220031738,
    "a": 14.2628536224365,
    "b": 20.0565547943115,
    "C": 24.6108589172363,
    "h": 54.5821571350098,
    "CMY_C": 0.55522811412811,
    "CMY_M": 0.71017080545425,
    "CMY_Y": 0.79939115047455,
    "CMYK_C": 0,
    "CMYK_M": 0.34836441278458,
    "CMYK_Y": 0.54896241426468,
    "CMYK_K": 0.55522811412811
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8008",
    "Farbtonhilfsbezeichnung": "RAL8008 Olivbraun",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "79",
    "Bcolor": "50",
    "Y": 9,
    "L": 37.0591239929199,
    "a": 11.9327096939087,
    "b": 22.9237861633301,
    "C": 25.8435592651367,
    "h": 62.501293182373,
    "CMY_C": 0.54608362913132,
    "CMY_M": 0.6888073682785,
    "CMY_Y": 0.80342179536819,
    "CMYK_C": 0,
    "CMYK_M": 0.31442737579346,
    "CMYK_Y": 0.56692856550217,
    "CMYK_K": 0.54608362913132
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8011",
    "Farbtonhilfsbezeichnung": "RAL8011 Nussbraun",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "63",
    "Bcolor": "50",
    "Y": 4,
    "L": 29.9353809356689,
    "a": 12.0419797897339,
    "b": 13.2750692367554,
    "C": 17.9230785369873,
    "h": 47.7884407043457,
    "CMY_C": 0.62946766614914,
    "CMY_M": 0.75225341320038,
    "CMY_Y": 0.80401945114136,
    "CMYK_C": 0,
    "CMYK_M": 0.33137661218643,
    "CMYK_Y": 0.47108381986618,
    "CMYK_K": 0.62946766614914
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8012",
    "Farbtonhilfsbezeichnung": "RAL8012 Rotbraun",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "55",
    "Bcolor": "49",
    "Y": 5,
    "L": 29.1606044769287,
    "a": 21.0596599578857,
    "b": 12.8226709365845,
    "C": 24.6562404632568,
    "h": 31.3361320495606,
    "CMY_C": 0.59327745437622,
    "CMY_M": 0.78359913825989,
    "CMY_Y": 0.80618131160736,
    "CMYK_C": 0,
    "CMYK_M": 0.46793985366821,
    "CMYK_Y": 0.52346217632294,
    "CMYK_K": 0.59327745437622
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8014",
    "Farbtonhilfsbezeichnung": "RAL8014 Sepiabraun",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "63",
    "Bcolor": "53",
    "Y": 4,
    "L": 28.2594985961914,
    "a": 6.09014129638672,
    "b": 9.00496673583984,
    "C": 10.8710279464722,
    "h": 55.9291496276855,
    "CMY_C": 0.68334627151489,
    "CMY_M": 0.75265562534332,
    "CMY_Y": 0.79365223646164,
    "CMYK_C": 0,
    "CMYK_M": 0.2188805937767,
    "CMYK_Y": 0.34834885597229,
    "CMYK_K": 0.68334627151489
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8015",
    "Farbtonhilfsbezeichnung": "RAL8015 Kastanienbraun",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "54",
    "Bcolor": "48",
    "Y": 5,
    "L": 27.77512550354,
    "a": 18.8085556030273,
    "b": 11.7160034179688,
    "C": 22.1591186523438,
    "h": 31.919116973877,
    "CMY_C": 0.61945974826813,
    "CMY_M": 0.78911250829697,
    "CMY_Y": 0.81176310777664,
    "CMYK_C": 0,
    "CMYK_M": 0.44582080841064,
    "CMYK_Y": 0.50534301996231,
    "CMYK_K": 0.61945974826813
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8016",
    "Farbtonhilfsbezeichnung": "RAL8016 Mahagonibraun",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "56",
    "Bcolor": "50",
    "Y": 3,
    "L": 26.633918762207,
    "a": 11.3376150131226,
    "b": 8.33240413665771,
    "C": 14.070198059082,
    "h": 36.3134498596191,
    "CMY_C": 0.67229032516479,
    "CMY_M": 0.77882713079453,
    "CMY_Y": 0.80273461341858,
    "CMYK_C": 0,
    "CMYK_M": 0.32509508728981,
    "CMYK_Y": 0.39804834127426,
    "CMYK_K": 0.67229032516479
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8017",
    "Farbtonhilfsbezeichnung": "RAL8017 Schokoladenbraun",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "53",
    "Bcolor": "49",
    "Y": 3,
    "L": 23.9568023681641,
    "a": 7.88490581512451,
    "b": 5.51669406890869,
    "C": 9.62318325042725,
    "h": 34.9786567687988,
    "CMY_C": 0.71989774703979,
    "CMY_M": 0.79358106851578,
    "CMY_Y": 0.80951380729675,
    "CMYK_C": 0,
    "CMYK_M": 0.26305866241455,
    "CMYK_Y": 0.31994050741196,
    "CMYK_K": 0.71989774703979
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8019",
    "Farbtonhilfsbezeichnung": "RAL8019 Graubraun",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "58",
    "Bcolor": "58",
    "Y": 5,
    "L": 25.0268955230713,
    "a": 2.78589534759521,
    "b": 0.86763840913773,
    "C": 2.9178774356842,
    "h": 17.2986621856689,
    "CMY_C": 0.74810421466827,
    "CMY_M": 0.77259558439255,
    "CMY_Y": 0.7740364074707,
    "CMYK_C": 0,
    "CMYK_M": 0.09722818434238,
    "CMYK_Y": 0.10294809937477,
    "CMYK_K": 0.74810421466827
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8022",
    "Farbtonhilfsbezeichnung": "RAL8022 Schwarzbraun",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "38",
    "Bcolor": "39",
    "Y": 2,
    "L": 15.6206960678101,
    "a": 1.42749726772308,
    "b": -0.22253248095512,
    "C": 1.44473838806152,
    "h": 351.139465332031,
    "CMY_C": 0.83950400352478,
    "CMY_M": 0.84954875707626,
    "CMY_Y": 0.84731829166412,
    "CMYK_C": 0,
    "CMYK_M": 0.06258569657803,
    "CMYK_Y": 0.04868836700916,
    "CMYK_K": 0.83950400352478
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8023",
    "Farbtonhilfsbezeichnung": "RAL8023 Orangebraun",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "92",
    "Bcolor": "55",
    "Y": 15,
    "L": 46.8172340393066,
    "a": 26.9625282287598,
    "b": 33.5674476623535,
    "C": 43.0552139282227,
    "h": 51.2273712158203,
    "CMY_C": 0.35264664888382,
    "CMY_M": 0.64044737815857,
    "CMY_Y": 0.78509342670441,
    "CMYK_C": 0,
    "CMYK_M": 0.44458058476448,
    "CMYK_Y": 0.66802275180817,
    "CMYK_K": 0.35264664888382
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8024",
    "Farbtonhilfsbezeichnung": "RAL8024 Beigebraun",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "83",
    "Bcolor": "62",
    "Y": 10,
    "L": 38.893913269043,
    "a": 13.3563175201416,
    "b": 18.5081882476807,
    "C": 22.8242034912109,
    "h": 54.1841354370117,
    "CMY_C": 0.52515780925751,
    "CMY_M": 0.67458605766296,
    "CMY_Y": 0.75846672058105,
    "CMYK_C": 0,
    "CMYK_M": 0.31469032168388,
    "CMYK_Y": 0.49133989214897,
    "CMYK_K": 0.52515780925751
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8025",
    "Farbtonhilfsbezeichnung": "RAL8025 Blassbraun",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "90",
    "Bcolor": "74",
    "Y": 14,
    "L": 40.5193672180176,
    "a": 9.41299343109131,
    "b": 13.2720308303833,
    "C": 16.2711791992188,
    "h": 54.6543846130371,
    "CMY_C": 0.53804528713226,
    "CMY_M": 0.64873337745667,
    "CMY_Y": 0.71122062206268,
    "CMYK_C": 0,
    "CMYK_M": 0.23960809409618,
    "CMYK_Y": 0.3748751282692,
    "CMYK_K": 0.53804528713226
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8027",
    "Farbtonhilfsbezeichnung": "RAL8027 Lederbraun",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "71",
    "Bcolor": "63",
    "Y": 6,
    "L": 31.7083721160889,
    "a": 5.60833120346069,
    "b": 7.00071573257446,
    "C": 8.970139503479,
    "h": 51.3014945983887,
    "CMY_C": 0.65715944766998,
    "CMY_M": 0.72029566764832,
    "CMY_Y": 0.75165766477585,
    "CMYK_C": 0,
    "CMYK_M": 0.18415622413158,
    "CMYK_Y": 0.27563312649727,
    "CMYK_K": 0.65715944766998
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8028",
    "Farbtonhilfsbezeichnung": "RAL8028 Terrabraun",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "66",
    "Bcolor": "54",
    "Y": 5,
    "L": 29.6009826660156,
    "a": 6.61097860336304,
    "b": 9.742919921875,
    "C": 11.7741041183472,
    "h": 55.8414688110352,
    "CMY_C": 0.6665872335434,
    "CMY_M": 0.74198132753372,
    "CMY_Y": 0.78646147251129,
    "CMYK_C": 0,
    "CMYK_M": 0.2261283993721,
    "CMYK_Y": 0.35953703522682,
    "CMYK_K": 0.6665872335434
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8029",
    "Farbtonhilfsbezeichnung": "RAL8029 Perlkupfer",
    "Farbtonklasse": "03",
    "Y": 12,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL8031",
    "Farbtonhilfsbezeichnung": "RAL8031 Sandbraun",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "131",
    "Bcolor": "111",
    "Y": 24,
    "L": 56.2881088256836,
    "a": 6.182457447052,
    "b": 13.5512723922729,
    "C": 14.8949575424194,
    "h": 65.4762420654297,
    "CMY_C": 0.39449143409729,
    "CMY_M": 0.48751926422119,
    "CMY_Y": 0.56527125835419,
    "CMYK_C": 0,
    "CMYK_M": 0.15363585948944,
    "CMYK_Y": 0.28204360604286,
    "CMYK_K": 0.39449143409729
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9001",
    "Farbtonhilfsbezeichnung": "RAL9001 Cremeweiss",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "210",
    "Y": 75,
    "L": 89.4290924072266,
    "a": 0.63705593347549,
    "b": 6.92993974685669,
    "C": 6.95915985107422,
    "h": 84.7476654052734,
    "CMY_C": 0.09123533964157,
    "CMY_M": 0.12153494358063,
    "CMY_Y": 0.17648160457611,
    "CMYK_C": 0,
    "CMYK_M": 0.03334153071046,
    "CMYK_Y": 0.09380455315113,
    "CMYK_K": 0.09123533964157
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9002",
    "Farbtonhilfsbezeichnung": "RAL9002 Grauweiss",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 66,
    "L": 85.2965774536133,
    "a": -0.84123939275742,
    "b": 4.55694913864136,
    "C": 4.63394737243652,
    "h": 100.459381103516,
    "CMY_C": 0.15583109855652,
    "CMY_M": 0.16308009624481,
    "CMY_Y": 0.20416152477264,
    "CMYK_C": 0,
    "CMYK_M": 0.00858714152128,
    "CMYK_Y": 0.05725207924843,
    "CMYK_K": 0.15583109855652
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9003",
    "Farbtonhilfsbezeichnung": "RAL9003 Signalweiss",
    "Farbtonklasse": "00",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 81,
    "L": 92.9213638305664,
    "a": -0.69875210523605,
    "b": 1.57929146289825,
    "C": 1.72696733474731,
    "h": 113.866828918457,
    "CMY_C": 0.07988482713699,
    "CMY_M": 0.0779475569725,
    "CMY_Y": 0.09862929582596,
    "CMYK_C": 0.00210104114376,
    "CMYK_M": 0,
    "CMYK_Y": 0.02243011072278,
    "CMYK_K": 0.0779475569725
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9004",
    "Farbtonhilfsbezeichnung": "RAL9004 Signalschwarz",
    "Farbtonklasse": "02",
    "Rcolor": "50",
    "Gcolor": "51",
    "Bcolor": "53",
    "Y": 1,
    "L": 21.364387512207,
    "a": 0.2244116961956,
    "b": -1.77463710308075,
    "C": 1.78876984119415,
    "h": 277.207092285156,
    "CMY_C": 0.80247664451599,
    "CMY_M": 0.79881680011749,
    "CMY_Y": 0.79069328308105,
    "CMYK_C": 0.05629710108042,
    "CMYK_M": 0.03881154581904,
    "CMYK_Y": 0,
    "CMYK_K": 0.79069328308105
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9005",
    "Farbtonhilfsbezeichnung": "RAL9005 Tiefschwarz",
    "Farbtonklasse": "02",
    "Rcolor": "32",
    "Gcolor": "33",
    "Bcolor": "34",
    "Y": 1,
    "L": 12.4969816207886,
    "a": 0.20537930727005,
    "b": -1.20154058933258,
    "C": 1.21896696090698,
    "h": 279.699829101563,
    "CMY_C": 0.87441521883011,
    "CMY_M": 0.87250149250031,
    "CMY_Y": 0.86742454767227,
    "CMYK_C": 0.05272975564003,
    "CMYK_M": 0.03829475864768,
    "CMYK_Y": 0,
    "CMYK_K": 0.86742454767227
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9006",
    "Farbtonhilfsbezeichnung": "RAL9006 Weissaluminium",
    "Farbtonklasse": "01",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9007",
    "Farbtonhilfsbezeichnung": "RAL9007 Graualuminium",
    "Farbtonklasse": "01",
    "Y": 27,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9010",
    "Farbtonhilfsbezeichnung": "RAL9010 Reinweiss",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "236",
    "Bcolor": "226",
    "Y": 83,
    "L": 93.4733505249023,
    "a": -0.64915347099304,
    "b": 4.46259450912476,
    "C": 4.50956201553345,
    "h": 98.2765045166016,
    "CMY_C": 0.06367230415344,
    "CMY_M": 0.07268464565277,
    "CMY_Y": 0.11397933959961,
    "CMYK_C": 0,
    "CMYK_M": 0.0096252001822,
    "CMYK_Y": 0.05372802168131,
    "CMYK_K": 0.06367230415344
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9011",
    "Farbtonhilfsbezeichnung": "RAL9011 Graphitschwarz",
    "Farbtonklasse": "02",
    "Rcolor": "41",
    "Gcolor": "43",
    "Bcolor": "45",
    "Y": 2,
    "L": 17.3349494934082,
    "a": -0.195337459445,
    "b": -2.08152484893799,
    "C": 2.09067034721375,
    "h": 264.638854980469,
    "CMY_C": 0.83988165855408,
    "CMY_M": 0.83205914497375,
    "CMY_Y": 0.82311141490936,
    "CMYK_C": 0.09480682015419,
    "CMYK_M": 0.05058398842812,
    "CMYK_Y": 0,
    "CMYK_K": 0.82311141490936
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9012",
    "Farbtonhilfsbezeichnung": "RAL9012 Reinraumweiss",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "238",
    "Bcolor": "220",
    "Y": 87.8,
    "L": 94.1260757446289,
    "a": -1.26245248317719,
    "b": 8.75060653686523,
    "C": 8.84120464324951,
    "h": 98.2094345092773,
    "CMY_C": 0.04749095439911,
    "CMY_M": 0.06505739688873,
    "CMY_Y": 0.13887429237366,
    "CMYK_C": 0,
    "CMYK_M": 0.01844228431582,
    "CMYK_Y": 0.09593959897757,
    "CMYK_K": 0.04749095439911
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9016",
    "Farbtonhilfsbezeichnung": "RAL9016 Verkehrsweiss",
    "Farbtonklasse": "00",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 83,
    "L": 94.1434326171875,
    "a": -0.689317882061,
    "b": 2.36566948890686,
    "C": 2.46405172348022,
    "h": 106.245269775391,
    "CMY_C": 0.06343650817871,
    "CMY_M": 0.06448429822922,
    "CMY_Y": 0.09092915058136,
    "CMYK_C": 0,
    "CMYK_M": 0.00111876032315,
    "CMYK_Y": 0.02935480885208,
    "CMYK_K": 0.06343650817871
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9017",
    "Farbtonhilfsbezeichnung": "RAL9017 Verkehrsschwarz",
    "Farbtonklasse": "02",
    "Rcolor": "46",
    "Gcolor": "43",
    "Bcolor": "43",
    "Y": 1,
    "L": 17.9026184082031,
    "a": 1.09319579601288,
    "b": 0.13853415846825,
    "C": 1.10193860530853,
    "h": 7.22225475311279,
    "CMY_C": 0.82148993015289,
    "CMY_M": 0.83013010025024,
    "CMY_Y": 0.83055663108826,
    "CMYK_C": 0,
    "CMYK_M": 0.04840158298612,
    "CMYK_Y": 0.05079097673297,
    "CMYK_K": 0.82148993015289
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9018",
    "Farbtonhilfsbezeichnung": "RAL9018 Papyrusweiss",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "204",
    "Bcolor": "197",
    "Y": 59,
    "L": 81.6858215332031,
    "a": -1.8228657245636,
    "b": 2.26328778266907,
    "C": 2.90608167648315,
    "h": 128.848190307617,
    "CMY_C": 0.21041870117188,
    "CMY_M": 0.19974607229233,
    "CMY_Y": 0.22660708427429,
    "CMYK_C": 0.01333655323833,
    "CMYK_M": 0,
    "CMYK_Y": 0.0335656106472,
    "CMYK_K": 0.19974607229233
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9021",
    "Farbtonhilfsbezeichnung": "RAL9021 Teerschwarz",
    "Farbtonklasse": "02",
    "Rcolor": "60",
    "Gcolor": "60",
    "Bcolor": "59",
    "Y": 4,
    "L": 25.2334175109863,
    "a": 0.15446835756302,
    "b": -0.07939232885838,
    "C": 0.17367675900459,
    "h": 332.798126220703,
    "CMY_C": 0.76466047763824,
    "CMY_M": 0.76550257205963,
    "CMY_Y": 0.76701724529266,
    "CMYK_C": 0,
    "CMYK_M": 0.0035782107152,
    "CMYK_Y": 0.01001433003694,
    "CMYK_K": 0.76466047763824
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9022",
    "Farbtonhilfsbezeichnung": "RAL9022 Perlhellgrau",
    "Farbtonklasse": "01",
    "Y": 39,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "RAL FARBTONKARTE",
    "Farbton_ID": "RAL9023",
    "Farbtonhilfsbezeichnung": "RAL9023 Perldunkelgrau",
    "Farbtonklasse": "01",
    "Y": 32,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0001",
    "Farbtonhilfsbezeichnung": "01.001.01",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "210",
    "Bcolor": "44",
    "Y": 67.0590438842773,
    "L": 85.5337524414063,
    "a": 0.58357936143875,
    "b": 78.909782409668,
    "C": 78.9119415283203,
    "h": 89.5762786865234,
    "CMY_C": 0.00958645343781,
    "CMY_M": 0.1765421628952,
    "CMY_Y": 0.82902133464813,
    "CMYK_C": 0,
    "CMYK_M": 0.16857171058655,
    "CMYK_Y": 0.82736641168594,
    "CMYK_K": 0.00958645343781
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0002",
    "Farbtonhilfsbezeichnung": "01.001.02",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "201",
    "Bcolor": "69",
    "Y": 62.2423515319824,
    "L": 83.0421371459961,
    "a": 4.58184909820557,
    "b": 68.3908157348633,
    "C": 68.5441284179688,
    "h": 86.1671905517578,
    "CMY_C": 0.02409446239471,
    "CMY_M": 0.21233355998993,
    "CMY_Y": 0.73042285442352,
    "CMYK_C": 0,
    "CMYK_M": 0.19288659095764,
    "CMYK_Y": 0.72376716136932,
    "CMYK_K": 0.02409446239471
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0003",
    "Farbtonhilfsbezeichnung": "01.001.03",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "208",
    "Bcolor": "87",
    "Y": 65.5132446289063,
    "L": 84.7475204467773,
    "a": 0.73136466741562,
    "b": 62.5956649780273,
    "C": 62.5999374389648,
    "h": 89.3305892944336,
    "CMY_C": 0.03406572341919,
    "CMY_M": 0.18379086256027,
    "CMY_Y": 0.65834617614746,
    "CMYK_C": 0,
    "CMYK_M": 0.15500551462173,
    "CMYK_Y": 0.64629703760147,
    "CMYK_K": 0.03406572341919
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0004",
    "Farbtonhilfsbezeichnung": "01.001.04",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "202",
    "Bcolor": "77",
    "Y": 61.2611999511719,
    "L": 82.5189590454102,
    "a": 1.29813885688782,
    "b": 64.5239334106445,
    "C": 64.5369873046875,
    "h": 88.8474349975586,
    "CMY_C": 0.05488455295563,
    "CMY_M": 0.20958572626114,
    "CMY_Y": 0.69971138238907,
    "CMYK_C": 0,
    "CMYK_M": 0.16368494927883,
    "CMYK_Y": 0.68227308988571,
    "CMYK_K": 0.05488455295563
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0005",
    "Farbtonhilfsbezeichnung": "01.001.05",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "179",
    "Bcolor": "46",
    "Y": 46.6733207702637,
    "L": 73.9803237915039,
    "a": -0.03401654586196,
    "b": 66.8529434204102,
    "C": 66.8529510498047,
    "h": 90.0291519165039,
    "CMY_C": 0.16205441951752,
    "CMY_M": 0.29810643196106,
    "CMY_Y": 0.82080829143524,
    "CMYK_C": 0,
    "CMYK_M": 0.16236378252506,
    "CMYK_Y": 0.78615349531174,
    "CMYK_K": 0.16205441951752
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0006",
    "Farbtonhilfsbezeichnung": "01.001.06",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "152",
    "Bcolor": "53",
    "Y": 32.4998931884766,
    "L": 63.7539100646973,
    "a": -0.38302353024483,
    "b": 53.402042388916,
    "C": 53.4034156799316,
    "h": 90.4109420776367,
    "CMY_C": 0.29451936483383,
    "CMY_M": 0.402712225914,
    "CMY_Y": 0.79354524612427,
    "CMYK_C": 0,
    "CMYK_M": 0.15336050093174,
    "CMYK_Y": 0.70735591650009,
    "CMYK_K": 0.29451936483383
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0007",
    "Farbtonhilfsbezeichnung": "01.002.01",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "233",
    "Bcolor": "189",
    "Y": 81.9196090698242,
    "L": 92.5393676757812,
    "a": -1.14845931529999,
    "b": 22.4952621459961,
    "C": 22.5245590209961,
    "h": 92.922607421875,
    "CMY_C": 0.02652853727341,
    "CMY_M": 0.0864531993866,
    "CMY_Y": 0.25903308391571,
    "CMYK_C": 0,
    "CMYK_M": 0.06155769899487,
    "CMYK_Y": 0.23884063959122,
    "CMYK_K": 0.02652853727341
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0008",
    "Farbtonhilfsbezeichnung": "01.002.02",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "230",
    "Bcolor": "168",
    "Y": 80.3020629882813,
    "L": 91.8202209472656,
    "a": -1.20597290992737,
    "b": 32.1024131774902,
    "C": 32.125057220459,
    "h": 92.1513900756836,
    "CMY_C": 0.0131259560585,
    "CMY_M": 0.09637278318405,
    "CMY_Y": 0.33934062719345,
    "CMYK_C": 0,
    "CMYK_M": 0.08435405790806,
    "CMYK_Y": 0.33055350184441,
    "CMYK_K": 0.0131259560585
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0009",
    "Farbtonhilfsbezeichnung": "01.002.03",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "227",
    "Bcolor": "142",
    "Y": 77.9156112670898,
    "L": 90.7413787841797,
    "a": -0.87077766656876,
    "b": 43.8748817443848,
    "C": 43.8835220336914,
    "h": 91.1369934082031,
    "CMY_C": 0.00066816806793,
    "CMY_M": 0.11133229732513,
    "CMY_Y": 0.44139486551285,
    "CMYK_C": 0,
    "CMYK_M": 0.11073812097311,
    "CMYK_Y": 0.44102138280869,
    "CMYK_K": 0.00066816806793
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0010",
    "Farbtonhilfsbezeichnung": "01.002.04",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "207",
    "Bcolor": "101",
    "Y": 64.4987258911133,
    "L": 84.2247619628906,
    "a": 0.17633374035358,
    "b": 55.90625,
    "C": 55.9065284729004,
    "h": 89.8192825317383,
    "CMY_C": 0.05197274684906,
    "CMY_M": 0.18732613325119,
    "CMY_Y": 0.60558843612671,
    "CMYK_C": 0,
    "CMYK_M": 0.14277373254299,
    "CMYK_Y": 0.58396601676941,
    "CMYK_K": 0.05197274684906
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0011",
    "Farbtonhilfsbezeichnung": "01.002.05",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "199",
    "Bcolor": "98",
    "Y": 58.9413108825684,
    "L": 81.2593231201172,
    "a": 0.71932250261307,
    "b": 53.6535415649414,
    "C": 53.6583633422852,
    "h": 89.2318954467773,
    "CMY_C": 0.08616924285889,
    "CMY_M": 0.22051632404327,
    "CMY_Y": 0.61696529388428,
    "CMYK_C": 0,
    "CMYK_M": 0.14701527357101,
    "CMYK_Y": 0.58084720373154,
    "CMYK_K": 0.08616924285889
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0012",
    "Farbtonhilfsbezeichnung": "01.002.06",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "172",
    "Bcolor": "57",
    "Y": 43.9505729675293,
    "L": 72.1954498291016,
    "a": 3.28081631660461,
    "b": 61.1868934631348,
    "C": 61.274787902832,
    "h": 86.9307632446289,
    "CMY_C": 0.16781401634216,
    "CMY_M": 0.32418316602707,
    "CMY_Y": 0.77750116586685,
    "CMYK_C": 0,
    "CMYK_M": 0.1879016906023,
    "CMYK_Y": 0.73263329267502,
    "CMYK_K": 0.16781401634216
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0013",
    "Farbtonhilfsbezeichnung": "01.003.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "190",
    "Y": 82.6494369506836,
    "L": 92.8607406616211,
    "a": -1.23483204841614,
    "b": 22.5256576538086,
    "C": 22.5594787597656,
    "h": 93.1377487182617,
    "CMY_C": 0.02341800928116,
    "CMY_M": 0.08266150951385,
    "CMY_Y": 0.2558286190033,
    "CMYK_C": 0,
    "CMYK_M": 0.06066413223743,
    "CMYK_Y": 0.23798371851444,
    "CMYK_K": 0.02341800928116
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0014",
    "Farbtonhilfsbezeichnung": "01.003.02",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "228",
    "Bcolor": "172",
    "Y": 78.5232162475586,
    "L": 91.0181274414062,
    "a": -0.32955569028854,
    "b": 29.0285892486572,
    "C": 29.030460357666,
    "h": 90.6504440307617,
    "CMY_C": 0.0227764248848,
    "CMY_M": 0.10677367448807,
    "CMY_Y": 0.32432776689529,
    "CMYK_C": 0,
    "CMYK_M": 0.08595499396324,
    "CMYK_Y": 0.30857968330383,
    "CMYK_K": 0.0227764248848
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0015",
    "Farbtonhilfsbezeichnung": "01.003.03",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "222",
    "Bcolor": "153",
    "Y": 74.3426818847656,
    "L": 89.0841903686523,
    "a": -0.28034818172455,
    "b": 36.3987121582031,
    "C": 36.3997917175293,
    "h": 90.441291809082,
    "CMY_C": 0.02952581644058,
    "CMY_M": 0.12978649139404,
    "CMY_Y": 0.40064638853073,
    "CMYK_C": 0,
    "CMYK_M": 0.10331101715565,
    "CMYK_Y": 0.38241159915924,
    "CMYK_K": 0.02952581644058
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0016",
    "Farbtonhilfsbezeichnung": "01.003.04",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "203",
    "Bcolor": "119",
    "Y": 64.2456207275391,
    "L": 84.0934906005859,
    "a": 6.82952404022217,
    "b": 47.0115966796875,
    "C": 47.5050811767578,
    "h": 81.7342834472656,
    "CMY_C": 0.02268654108047,
    "CMY_M": 0.20374989509583,
    "CMY_Y": 0.53251498937607,
    "CMYK_C": 0,
    "CMYK_M": 0.18526640534401,
    "CMYK_Y": 0.52166318893433,
    "CMYK_K": 0.02268654108047
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0017",
    "Farbtonhilfsbezeichnung": "01.003.05",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "191",
    "Bcolor": "92",
    "Y": 57.9306373596191,
    "L": 80.7002105712891,
    "a": 9.95184803009033,
    "b": 56.0901870727539,
    "C": 56.9662055969238,
    "h": 79.9389495849609,
    "CMY_C": 0.03171044588089,
    "CMY_M": 0.24969232082367,
    "CMY_Y": 0.63982772827148,
    "CMYK_C": 0,
    "CMYK_M": 0.22512054443359,
    "CMYK_Y": 0.62803244590759,
    "CMYK_K": 0.03171044588089
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0018",
    "Farbtonhilfsbezeichnung": "01.003.06",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "167",
    "Bcolor": "68",
    "Y": 44.2450675964355,
    "L": 72.3919982910156,
    "a": 12.3258857727051,
    "b": 57.3436241149902,
    "C": 58.653377532959,
    "h": 77.8689804077148,
    "CMY_C": 0.11498731374741,
    "CMY_M": 0.344242811203,
    "CMY_Y": 0.7346967458725,
    "CMYK_C": 0,
    "CMYK_M": 0.25904205441475,
    "CMYK_Y": 0.70022660493851,
    "CMYK_K": 0.11498731374741
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0019",
    "Farbtonhilfsbezeichnung": "01.004.01",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "190",
    "Bcolor": "183",
    "Y": 57.3474273681641,
    "L": 80.3746109008789,
    "a": 13.8918657302856,
    "b": 8.30690956115723,
    "C": 16.1860637664795,
    "h": 30.8781280517578,
    "CMY_C": 0.09361571073532,
    "CMY_M": 0.25408953428268,
    "CMY_Y": 0.28195357322693,
    "CMYK_C": 0,
    "CMYK_M": 0.17704832553864,
    "CMYK_Y": 0.20779030025005,
    "CMYK_K": 0.09361571073532
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0020",
    "Farbtonhilfsbezeichnung": "01.004.02",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "167",
    "Bcolor": "158",
    "Y": 45.2403144836426,
    "L": 73.0498504638672,
    "a": 18.0400638580322,
    "b": 11.2837066650391,
    "C": 21.2782974243164,
    "h": 32.0251731872559,
    "CMY_C": 0.14170813560486,
    "CMY_M": 0.34415817260742,
    "CMY_Y": 0.37931418418884,
    "CMYK_C": 0,
    "CMYK_M": 0.2358755171299,
    "CMYK_Y": 0.27683594822884,
    "CMYK_K": 0.14170813560486
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0021",
    "Farbtonhilfsbezeichnung": "01.004.03",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "133",
    "Bcolor": "125",
    "Y": 30.2786655426025,
    "L": 61.8939247131348,
    "a": 24.5135345458984,
    "b": 13.8236055374146,
    "C": 28.1425914764404,
    "h": 29.4194011688232,
    "CMY_C": 0.22218054533005,
    "CMY_M": 0.47891944646835,
    "CMY_Y": 0.50889205932617,
    "CMYK_C": 0,
    "CMYK_M": 0.33007517457008,
    "CMYK_Y": 0.36860933899879,
    "CMYK_K": 0.22218054533005
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0022",
    "Farbtonhilfsbezeichnung": "01.004.04",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "130",
    "Bcolor": "119",
    "Y": 28.0955638885498,
    "L": 59.9749755859375,
    "a": 21.5922107696533,
    "b": 14.377854347229,
    "C": 25.9412078857422,
    "h": 33.6589126586914,
    "CMY_C": 0.25970029830933,
    "CMY_M": 0.49016243219376,
    "CMY_Y": 0.5321489572525,
    "CMYK_C": 0,
    "CMYK_M": 0.311309248209,
    "CMYK_Y": 0.3680248260498,
    "CMYK_K": 0.25970029830933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0023",
    "Farbtonhilfsbezeichnung": "01.004.05",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "113",
    "Bcolor": "104",
    "Y": 22.9007148742676,
    "L": 54.9699211120605,
    "a": 26.6206893920898,
    "b": 16.3258323669434,
    "C": 31.2280941009521,
    "h": 31.5197925567627,
    "CMY_C": 0.28340256214142,
    "CMY_M": 0.5557764172554,
    "CMY_Y": 0.59297347068787,
    "CMYK_C": 0,
    "CMYK_M": 0.38009324669838,
    "CMYK_Y": 0.43200114369392,
    "CMYK_K": 0.28340256214142
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0024",
    "Farbtonhilfsbezeichnung": "01.004.06",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "98",
    "Bcolor": "91",
    "Y": 18.7023582458496,
    "L": 50.3371429443359,
    "a": 30.4295997619629,
    "b": 17.1312274932861,
    "C": 34.9204750061035,
    "h": 29.3786010742188,
    "CMY_C": 0.31328558921814,
    "CMY_M": 0.61404252052307,
    "CMY_Y": 0.64153635501862,
    "CMYK_C": 0,
    "CMYK_M": 0.43796506524086,
    "CMYK_Y": 0.47800186276436,
    "CMYK_K": 0.31328558921814
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0025",
    "Farbtonhilfsbezeichnung": "01.005.01",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "222",
    "Bcolor": "213",
    "Y": 77.1798095703125,
    "L": 90.4043121337891,
    "a": 8.62570953369141,
    "b": 6.70716142654419,
    "C": 10.9265222549438,
    "h": 37.8678512573242,
    "CMY_C": 0.02142429351807,
    "CMY_M": 0.13032972812653,
    "CMY_Y": 0.16298013925552,
    "CMYK_C": 0,
    "CMYK_M": 0.11128973960876,
    "CMYK_Y": 0.14465497434139,
    "CMYK_K": 0.02142429351807
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0026",
    "Farbtonhilfsbezeichnung": "01.005.02",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "197",
    "Bcolor": "186",
    "Y": 64.9008483886719,
    "L": 84.4326171875,
    "a": 19.4887104034424,
    "b": 12.6738710403442,
    "C": 23.2472972869873,
    "h": 33.0367012023926,
    "CMY_C": 0,
    "CMY_M": 0.22641175985336,
    "CMY_Y": 0.26944833993912,
    "CMYK_C": 0,
    "CMYK_M": 0.22641175985336,
    "CMYK_Y": 0.26944833993912,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0027",
    "Farbtonhilfsbezeichnung": "01.005.03",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "153",
    "Bcolor": "140",
    "Y": 43.9422721862793,
    "L": 72.1898956298828,
    "a": 32.8091316223145,
    "b": 20.5429878234863,
    "C": 38.7098617553711,
    "h": 32.0521774291992,
    "CMY_C": 0.04384511709213,
    "CMY_M": 0.39921540021896,
    "CMY_Y": 0.45068669319153,
    "CMYK_C": 0,
    "CMYK_M": 0.37166601419449,
    "CMYK_Y": 0.42549756169319,
    "CMYK_K": 0.04384511709213
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0028",
    "Farbtonhilfsbezeichnung": "01.005.04",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "117",
    "Bcolor": "102",
    "Y": 29.6991138458252,
    "L": 61.3937339782715,
    "a": 41.1370811462402,
    "b": 26.7206993103027,
    "C": 49.053596496582,
    "h": 33.0058441162109,
    "CMY_C": 0.1162776350975,
    "CMY_M": 0.54206466674805,
    "CMY_Y": 0.59845906496048,
    "CMYK_C": 0,
    "CMYK_M": 0.48181086778641,
    "CMYK_Y": 0.54562544822693,
    "CMYK_K": 0.1162776350975
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0029",
    "Farbtonhilfsbezeichnung": "01.005.05",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "92",
    "Bcolor": "82",
    "Y": 19.7501983642578,
    "L": 51.553596496582,
    "a": 40.3294982910156,
    "b": 24.5129261016846,
    "C": 47.1948318481445,
    "h": 31.2919178009033,
    "CMY_C": 0.23896276950836,
    "CMY_M": 0.63915026187897,
    "CMY_Y": 0.67662239074707,
    "CMYK_C": 0,
    "CMYK_M": 0.52584481239319,
    "CMYK_Y": 0.57508307695389,
    "CMYK_K": 0.23896276950836
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0030",
    "Farbtonhilfsbezeichnung": "01.005.06",
    "Farbtonklasse": "04",
    "Rcolor": "163",
    "Gcolor": "77",
    "Bcolor": "71",
    "Y": 13.5133934020996,
    "L": 43.5268325805664,
    "a": 35.1191787719727,
    "b": 19.8885459899902,
    "C": 40.3597679138184,
    "h": 29.5235652923584,
    "CMY_C": 0.36219924688339,
    "CMY_M": 0.69800186157227,
    "CMY_Y": 0.72106993198395,
    "CMYK_C": 0,
    "CMYK_M": 0.52650082111359,
    "CMYK_Y": 0.56266897916794,
    "CMYK_K": 0.36219924688339
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0031",
    "Farbtonhilfsbezeichnung": "01.006.01",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "202",
    "Bcolor": "199",
    "Y": 66.3291778564453,
    "L": 85.1640472412109,
    "a": 16.291051864624,
    "b": 7.05682802200317,
    "C": 17.7537937164307,
    "h": 23.4209117889404,
    "CMY_C": 0.02600920200348,
    "CMY_M": 0.20814925432205,
    "CMY_Y": 0.221251308918,
    "CMYK_C": 0,
    "CMYK_M": 0.18700388073921,
    "CMYK_Y": 0.20045579969883,
    "CMYK_K": 0.02600920200348
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0032",
    "Farbtonhilfsbezeichnung": "01.006.02",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "178",
    "Bcolor": "181",
    "Y": 54.3504943847656,
    "L": 78.6656646728516,
    "a": 24.6056995391846,
    "b": 7.16349267959595,
    "C": 25.6272525787354,
    "h": 16.2319374084473,
    "CMY_C": 0.04487574100494,
    "CMY_M": 0.30174565315247,
    "CMY_Y": 0.29016035795212,
    "CMYK_C": 0,
    "CMYK_M": 0.26893875002861,
    "CMYK_Y": 0.25680911540985,
    "CMYK_K": 0.04487574100494
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0033",
    "Farbtonhilfsbezeichnung": "01.006.03",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "149",
    "Bcolor": "155",
    "Y": 41.8740196228027,
    "L": 70.7839736938477,
    "a": 34.509765625,
    "b": 10.1197919845581,
    "C": 35.9629554748535,
    "h": 16.3434753417969,
    "CMY_C": 0.06848555803299,
    "CMY_M": 0.41675734519958,
    "CMY_Y": 0.39168709516525,
    "CMYK_C": 0,
    "CMYK_M": 0.37387695908546,
    "CMYK_Y": 0.34696352481842,
    "CMYK_K": 0.06848555803299
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0034",
    "Farbtonhilfsbezeichnung": "01.006.04",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "109",
    "Bcolor": "118",
    "Y": 27.4465732574463,
    "L": 59.385425567627,
    "a": 44.161937713623,
    "b": 15.0385751724243,
    "C": 46.6522827148438,
    "h": 18.8053779602051,
    "CMY_C": 0.13896071910858,
    "CMY_M": 0.57145583629608,
    "CMY_Y": 0.53802543878555,
    "CMYK_C": 0,
    "CMYK_M": 0.50229430198669,
    "CMYK_Y": 0.46346867084503,
    "CMYK_K": 0.13896071910858
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0035",
    "Farbtonhilfsbezeichnung": "01.006.05",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "91",
    "Bcolor": "106",
    "Y": 21.1841468811035,
    "L": 53.1504440307617,
    "a": 45.7673454284668,
    "b": 12.7823057174683,
    "C": 47.5188102722168,
    "h": 15.6044521331787,
    "CMY_C": 0.20654541254044,
    "CMY_M": 0.64190322160721,
    "CMY_Y": 0.58321392536163,
    "CMYK_C": 0,
    "CMYK_M": 0.54868650436401,
    "CMYK_Y": 0.47471967339516,
    "CMYK_K": 0.20654541254044
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0036",
    "Farbtonhilfsbezeichnung": "01.006.06",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "76",
    "Bcolor": "87",
    "Y": 13.8787927627563,
    "L": 44.0586051940918,
    "a": 38.5496025085449,
    "b": 10.7366380691528,
    "C": 40.0168380737305,
    "h": 15.5633115768433,
    "CMY_C": 0.35013729333878,
    "CMY_M": 0.70366764068604,
    "CMY_Y": 0.65736210346222,
    "CMYK_C": 0,
    "CMYK_M": 0.54400771856308,
    "CMYK_Y": 0.47275340557098,
    "CMYK_K": 0.35013729333878
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0037",
    "Farbtonhilfsbezeichnung": "01.007.01",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "185",
    "Bcolor": "215",
    "Y": 54.4741401672363,
    "L": 78.7373962402344,
    "a": 16.8806419372559,
    "b": -11.295937538147,
    "C": 20.3114318847656,
    "h": 326.2109375,
    "CMY_C": 0.14765405654907,
    "CMY_M": 0.27367180585861,
    "CMY_Y": 0.15856373310089,
    "CMYK_C": 0,
    "CMYK_M": 0.14784812927246,
    "CMYK_Y": 0.01279958803207,
    "CMYK_K": 0.14765405654907
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0038",
    "Farbtonhilfsbezeichnung": "01.007.02",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "164",
    "Bcolor": "194",
    "Y": 43.4337844848633,
    "L": 71.8484039306641,
    "a": 20.7679328918457,
    "b": -10.1562366485596,
    "C": 23.1183090209961,
    "h": 333.939758300781,
    "CMY_C": 0.19267153739929,
    "CMY_M": 0.3578953742981,
    "CMY_Y": 0.24088299274445,
    "CMYK_C": 0,
    "CMYK_M": 0.20465503633022,
    "CMYK_Y": 0.05971727520227,
    "CMYK_K": 0.19267153739929
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0039",
    "Farbtonhilfsbezeichnung": "01.007.03",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "141",
    "Bcolor": "177",
    "Y": 32.8095092773438,
    "L": 64.0063705444336,
    "a": 23.4091682434082,
    "b": -12.8251256942749,
    "C": 26.6921901702881,
    "h": 331.283081054688,
    "CMY_C": 0.26857590675354,
    "CMY_M": 0.44598734378815,
    "CMY_Y": 0.30561047792435,
    "CMYK_C": 0,
    "CMYK_M": 0.24255618453026,
    "CMYK_Y": 0.05063351243734,
    "CMYK_K": 0.26857590675354
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0040",
    "Farbtonhilfsbezeichnung": "01.007.04",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "112",
    "Bcolor": "152",
    "Y": 21.1500930786133,
    "L": 53.1133766174316,
    "a": 25.6617374420166,
    "b": -14.8756198883057,
    "C": 29.6615715026856,
    "h": 329.899932861328,
    "CMY_C": 0.37665939331055,
    "CMY_M": 0.56185275316238,
    "CMY_Y": 0.40514719486237,
    "CMYK_C": 0,
    "CMYK_M": 0.29709818959236,
    "CMYK_Y": 0.04570182040334,
    "CMYK_K": 0.37665939331055
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0041",
    "Farbtonhilfsbezeichnung": "01.007.05",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "93",
    "Bcolor": "129",
    "Y": 14.4926834106445,
    "L": 44.9313659667969,
    "a": 22.9218940734863,
    "b": -14.2317790985107,
    "C": 26.9806747436523,
    "h": 328.164611816406,
    "CMY_C": 0.47690391540527,
    "CMY_M": 0.63414895534515,
    "CMY_Y": 0.49264413118362,
    "CMYK_C": 0,
    "CMYK_M": 0.30060449242592,
    "CMYK_Y": 0.0300904866308,
    "CMYK_K": 0.47690391540527
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0042",
    "Farbtonhilfsbezeichnung": "01.007.06",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "60",
    "Bcolor": "80",
    "Y": 5.48234415054321,
    "L": 28.0669937133789,
    "a": 12.3371810913086,
    "b": -9.50327968597412,
    "C": 15.5730009078979,
    "h": 322.393096923828,
    "CMY_C": 0.69174009561539,
    "CMY_M": 0.76389896869659,
    "CMY_Y": 0.68503797054291,
    "CMYK_C": 0.02127915248275,
    "CMYK_M": 0.25038254261017,
    "CMYK_Y": 0,
    "CMYK_K": 0.68503797054291
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0043",
    "Farbtonhilfsbezeichnung": "01.008.01",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "195",
    "Bcolor": "222",
    "Y": 56.1230239868164,
    "L": 79.6837844848633,
    "a": 6.47393703460693,
    "b": -13.8667917251587,
    "C": 15.3035869598389,
    "h": 295.026275634766,
    "CMY_C": 0.22545295953751,
    "CMY_M": 0.23613965511322,
    "CMY_Y": 0.13097608089447,
    "CMYK_C": 0.10871608555317,
    "CMYK_M": 0.12101344019175,
    "CMYK_Y": 0,
    "CMYK_K": 0.13097608089447
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0044",
    "Farbtonhilfsbezeichnung": "01.008.02",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "173",
    "Bcolor": "210",
    "Y": 43.9121627807617,
    "L": 72.1697463989258,
    "a": 9.73469829559326,
    "b": -18.9479331970215,
    "C": 21.3023128509521,
    "h": 297.192291259766,
    "CMY_C": 0.30117172002792,
    "CMY_M": 0.32270377874374,
    "CMY_Y": 0.17679643630981,
    "CMYK_C": 0.1510869115591,
    "CMYK_M": 0.17724333703518,
    "CMYK_Y": 0,
    "CMYK_K": 0.17679643630981
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0045",
    "Farbtonhilfsbezeichnung": "01.008.03",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "149",
    "Bcolor": "180",
    "Y": 31.8416709899902,
    "L": 63.2118034362793,
    "a": 8.7353515625,
    "b": -15.9962759017944,
    "C": 18.2260036468506,
    "h": 298.638366699219,
    "CMY_C": 0.3916574716568,
    "CMY_M": 0.41482222080231,
    "CMY_Y": 0.29393285512924,
    "CMYK_C": 0.13840697705746,
    "CMYK_M": 0.17121511697769,
    "CMYK_Y": 0,
    "CMYK_K": 0.29393285512924
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0046",
    "Farbtonhilfsbezeichnung": "01.008.04",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "111",
    "Bcolor": "158",
    "Y": 18.1577892303467,
    "L": 49.686939239502,
    "a": 15.9536209106445,
    "b": -23.8993968963623,
    "C": 28.7349815368652,
    "h": 303.724395751953,
    "CMY_C": 0.50884503126144,
    "CMY_M": 0.56549334526062,
    "CMY_Y": 0.3819380402565,
    "CMYK_C": 0.20533053576946,
    "CMYK_M": 0.29698526859283,
    "CMYK_Y": 0,
    "CMYK_K": 0.3819380402565
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0047",
    "Farbtonhilfsbezeichnung": "01.008.05",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "98",
    "Bcolor": "130",
    "Y": 13.3411293029785,
    "L": 43.2728080749512,
    "a": 9.95965957641602,
    "b": -17.5613021850586,
    "C": 20.1889610290527,
    "h": 299.559173583984,
    "CMY_C": 0.59026944637299,
    "CMY_M": 0.61535501480103,
    "CMY_Y": 0.4891916513443,
    "CMYK_C": 0.19787812232971,
    "CMYK_M": 0.24698767066002,
    "CMYK_Y": 0,
    "CMYK_K": 0.4891916513443
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0048",
    "Farbtonhilfsbezeichnung": "01.008.06",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "78",
    "Bcolor": "110",
    "Y": 8.49874877929688,
    "L": 35.0007209777832,
    "a": 10.4495964050293,
    "b": -18.1239547729492,
    "C": 20.9206066131592,
    "h": 299.966156005859,
    "CMY_C": 0.66864830255508,
    "CMY_M": 0.6938568353653,
    "CMY_Y": 0.56730258464813,
    "CMYK_C": 0.2342184484005,
    "CMYK_M": 0.29247748851776,
    "CMYK_Y": 0,
    "CMYK_K": 0.56730258464813
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0049",
    "Farbtonhilfsbezeichnung": "01.009.01",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "213",
    "Bcolor": "229",
    "Y": 65.135871887207,
    "L": 84.5537033081055,
    "a": -2.24438238143921,
    "b": -10.4475994110107,
    "C": 10.6859531402588,
    "h": 257.875823974609,
    "CMY_C": 0.23032146692276,
    "CMY_M": 0.1636489033699,
    "CMY_Y": 0.10297709703445,
    "CMYK_C": 0.14196334779263,
    "CMYK_M": 0.06763685494661,
    "CMYK_Y": 0,
    "CMYK_K": 0.10297709703445
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0050",
    "Farbtonhilfsbezeichnung": "01.009.02",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "183",
    "Bcolor": "208",
    "Y": 45.7007675170898,
    "L": 73.350944519043,
    "a": -2.00119590759277,
    "b": -15.998348236084,
    "C": 16.1230239868164,
    "h": 262.870025634766,
    "CMY_C": 0.37299853563309,
    "CMY_M": 0.28385818004608,
    "CMY_Y": 0.18606913089752,
    "CMYK_C": 0.22966250777245,
    "CMYK_M": 0.12014417350292,
    "CMYK_Y": 0,
    "CMYK_K": 0.18606913089752
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0051",
    "Farbtonhilfsbezeichnung": "01.009.03",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "133",
    "Bcolor": "166",
    "Y": 22.923511505127,
    "L": 54.9934616088867,
    "a": -0.23459689319134,
    "b": -20.9804840087891,
    "C": 20.9817962646484,
    "h": 269.359375,
    "CMY_C": 0.57222133874893,
    "CMY_M": 0.47663187980652,
    "CMY_Y": 0.34754884243011,
    "CMYK_C": 0.34435144066811,
    "CMYK_M": 0.1978432238102,
    "CMYK_Y": 0,
    "CMYK_K": 0.34754884243011
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0052",
    "Farbtonhilfsbezeichnung": "01.009.04",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "84",
    "Bcolor": "117",
    "Y": 8.50567531585693,
    "L": 35.0145721435547,
    "a": -0.00566081702709,
    "b": -22.7195472717285,
    "C": 22.7195472717285,
    "h": 269.985717773438,
    "CMY_C": 0.77937436103821,
    "CMY_M": 0.67002630233765,
    "CMY_Y": 0.53943079710007,
    "CMYK_C": 0.52097177505493,
    "CMYK_M": 0.28355240821838,
    "CMYK_Y": 0,
    "CMYK_K": 0.53943079710007
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0053",
    "Farbtonhilfsbezeichnung": "01.009.05",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "66",
    "Bcolor": "92",
    "Y": 5.35386562347412,
    "L": 27.7200298309326,
    "a": 0.59773629903793,
    "b": -17.7175941467285,
    "C": 17.7276744842529,
    "h": 271.932250976563,
    "CMY_C": 0.81092000007629,
    "CMY_M": 0.73929351568222,
    "CMY_Y": 0.64034307003021,
    "CMYK_C": 0.47427678108215,
    "CMYK_M": 0.27512454986572,
    "CMYK_Y": 0,
    "CMYK_K": 0.64034307003021
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0054",
    "Farbtonhilfsbezeichnung": "01.009.06",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "64",
    "Bcolor": "92",
    "Y": 5.06193876266479,
    "L": 26.9105033874512,
    "a": 2.71563720703125,
    "b": -18.8915824890137,
    "C": 19.0857696533203,
    "h": 278.180145263672,
    "CMY_C": 0.80659186840057,
    "CMY_M": 0.75010800361633,
    "CMY_Y": 0.64080113172531,
    "CMYK_C": 0.46155697107315,
    "CMYK_M": 0.30430740118027,
    "CMYK_Y": 0,
    "CMYK_K": 0.64080113172531
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0055",
    "Farbtonhilfsbezeichnung": "01.010.01",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "204",
    "Bcolor": "230",
    "Y": 57.2192192077637,
    "L": 80.3027420043945,
    "a": -5.75427913665771,
    "b": -17.7392978668213,
    "C": 18.6492462158203,
    "h": 252.027954101562,
    "CMY_C": 0.34142619371414,
    "CMY_M": 0.2000173330307,
    "CMY_Y": 0.09755665063858,
    "CMYK_C": 0.2702325284481,
    "CMYK_M": 0.11353696882725,
    "CMYK_Y": 0,
    "CMYK_K": 0.09755665063858
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0056",
    "Farbtonhilfsbezeichnung": "01.010.02",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "180",
    "Bcolor": "221",
    "Y": 42.5260200500488,
    "L": 71.2320785522461,
    "a": -6.19016551971436,
    "b": -26.9507579803467,
    "C": 27.6525135040283,
    "h": 257.064422607422,
    "CMY_C": 0.49751937389374,
    "CMY_M": 0.29365402460098,
    "CMY_Y": 0.13204836845398,
    "CMYK_C": 0.42107301950455,
    "CMYK_M": 0.18619200587273,
    "CMYK_Y": 0,
    "CMYK_K": 0.13204836845398
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0057",
    "Farbtonhilfsbezeichnung": "01.010.03",
    "Farbtonklasse": "02",
    "Rcolor": "105",
    "Gcolor": "160",
    "Bcolor": "204",
    "Y": 32.3350257873535,
    "L": 63.6188201904297,
    "a": -5.46979475021362,
    "b": -29.1923274993896,
    "C": 29.7003479003906,
    "h": 259.387481689453,
    "CMY_C": 0.58836126327515,
    "CMY_M": 0.37447291612625,
    "CMY_Y": 0.19971472024918,
    "CMYK_C": 0.48563501238823,
    "CMYK_M": 0.21836987137794,
    "CMYK_Y": 0,
    "CMYK_K": 0.19971472024918
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0058",
    "Farbtonhilfsbezeichnung": "01.010.04",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "113",
    "Bcolor": "145",
    "Y": 15.5386028289795,
    "L": 46.3632392883301,
    "a": -3.18970060348511,
    "b": -21.608455657959,
    "C": 21.8426094055176,
    "h": 261.602996826172,
    "CMY_C": 0.69103169441223,
    "CMY_M": 0.55610030889511,
    "CMY_Y": 0.4328910112381,
    "CMYK_C": 0.45518708229065,
    "CMYK_M": 0.21725858747959,
    "CMYK_Y": 0,
    "CMYK_K": 0.4328910112381
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0059",
    "Farbtonhilfsbezeichnung": "01.010.05",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "89",
    "Bcolor": "117",
    "Y": 9.45330238342285,
    "L": 36.8428039550781,
    "a": -1.27507472038269,
    "b": -19.8593235015869,
    "C": 19.9002151489258,
    "h": 266.326354980469,
    "CMY_C": 0.75499892234802,
    "CMY_M": 0.65158295631409,
    "CMY_Y": 0.53942000865936,
    "CMYK_C": 0.46805965900421,
    "CMYK_M": 0.24352544546127,
    "CMYK_Y": 0,
    "CMYK_K": 0.53942000865936
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0060",
    "Farbtonhilfsbezeichnung": "01.010.06",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "72",
    "Bcolor": "99",
    "Y": 6.12666511535645,
    "L": 29.7298069000244,
    "a": -1.69188582897186,
    "b": -19.1312255859375,
    "C": 19.2058906555176,
    "h": 264.946136474609,
    "CMY_C": 0.82310712337494,
    "CMY_M": 0.7165390253067,
    "CMY_Y": 0.61291867494583,
    "CMYK_C": 0.54300850629807,
    "CMYK_M": 0.26769658923149,
    "CMYK_Y": 0,
    "CMYK_K": 0.61291867494583
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0061",
    "Farbtonhilfsbezeichnung": "01.011.01",
    "Farbtonklasse": "01",
    "Rcolor": "156",
    "Gcolor": "205",
    "Bcolor": "225",
    "Y": 55.9700736999512,
    "L": 79.5967864990234,
    "a": -10.8239488601685,
    "b": -16.2381706237793,
    "C": 19.5150203704834,
    "h": 236.313598632812,
    "CMY_C": 0.39001113176346,
    "CMY_M": 0.19740474224091,
    "CMY_Y": 0.11676633358002,
    "CMYK_C": 0.3093686401844,
    "CMYK_M": 0.09129906445742,
    "CMYK_Y": 0,
    "CMYK_K": 0.11676633358002
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0062",
    "Farbtonhilfsbezeichnung": "01.011.02",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "188",
    "Bcolor": "215",
    "Y": 45.1076011657715,
    "L": 72.9626922607422,
    "a": -13.0173530578613,
    "b": -21.0048732757568,
    "C": 24.7114582061768,
    "h": 238.212265014648,
    "CMY_C": 0.51386725902557,
    "CMY_M": 0.26328510046005,
    "CMY_Y": 0.15586704015732,
    "CMYK_C": 0.42410406470299,
    "CMYK_M": 0.12725253403187,
    "CMYK_Y": 0,
    "CMYK_K": 0.15586704015732
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0063",
    "Farbtonhilfsbezeichnung": "01.011.03",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "167",
    "Bcolor": "202",
    "Y": 34.6788101196289,
    "L": 65.4978332519531,
    "a": -11.2108793258667,
    "b": -24.8827896118164,
    "C": 27.2917022705078,
    "h": 245.746170043945,
    "CMY_C": 0.60264319181442,
    "CMY_M": 0.34492093324661,
    "CMY_Y": 0.20980328321457,
    "CMYK_C": 0.4971419274807,
    "CMYK_M": 0.17099241912365,
    "CMYK_Y": 0,
    "CMYK_K": 0.20980328321457
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0064",
    "Farbtonhilfsbezeichnung": "01.011.04",
    "Farbtonklasse": "02",
    "Rcolor": "73",
    "Gcolor": "140",
    "Bcolor": "173",
    "Y": 23.2797470092773,
    "L": 55.3593292236328,
    "a": -11.2648496627808,
    "b": -24.4691009521484,
    "C": 26.9375896453857,
    "h": 245.280059814453,
    "CMY_C": 0.71285289525986,
    "CMY_M": 0.44993740320206,
    "CMY_Y": 0.32112765312195,
    "CMYK_C": 0.57702344655991,
    "CMYK_M": 0.18974074721336,
    "CMYK_Y": 0,
    "CMYK_K": 0.32112765312195
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0065",
    "Farbtonhilfsbezeichnung": "01.011.05",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "115",
    "Bcolor": "149",
    "Y": 14.9633388519287,
    "L": 45.5839462280273,
    "a": -10.482367515564,
    "b": -25.593936920166,
    "C": 27.6573619842529,
    "h": 247.727737426758,
    "CMY_C": 0.83060073852539,
    "CMY_M": 0.54880917072296,
    "CMY_Y": 0.41538977622986,
    "CMYK_C": 0.71023553609848,
    "CMYK_M": 0.22821940481663,
    "CMYK_Y": 0,
    "CMYK_K": 0.41538977622986
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0066",
    "Farbtonhilfsbezeichnung": "01.011.06",
    "Farbtonklasse": "03",
    "Rcolor": "11",
    "Gcolor": "99",
    "Bcolor": "134",
    "Y": 10.8040790557861,
    "L": 39.2485122680664,
    "a": -10.4109420776367,
    "b": -26.5243721008301,
    "C": 28.4943866729736,
    "h": 248.569763183594,
    "CMY_C": 0.95591968297958,
    "CMY_M": 0.61006426811218,
    "CMY_Y": 0.47389417886734,
    "CMYK_C": 0.91621398925781,
    "CMYK_M": 0.25882643461227,
    "CMYK_Y": 0,
    "CMYK_K": 0.47389417886734
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0067",
    "Farbtonhilfsbezeichnung": "01.012.01",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "205",
    "Bcolor": "225",
    "Y": 54.5217704772949,
    "L": 78.7649993896484,
    "a": -15.7206754684448,
    "b": -17.6897449493408,
    "C": 23.6657295227051,
    "h": 228.372863769531,
    "CMY_C": 0.45906692743301,
    "CMY_M": 0.19604599475861,
    "CMY_Y": 0.11598783731461,
    "CMYK_C": 0.38809317350388,
    "CMYK_M": 0.09056228399277,
    "CMYK_Y": 0,
    "CMYK_K": 0.11598783731461
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0068",
    "Farbtonhilfsbezeichnung": "01.012.02",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "193",
    "Bcolor": "222",
    "Y": 45.9041519165039,
    "L": 73.4832992553711,
    "a": -19.8910503387451,
    "b": -23.7471561431885,
    "C": 30.9771099090576,
    "h": 230.049850463867,
    "CMY_C": 0.61853790283203,
    "CMY_M": 0.24348664283752,
    "CMY_Y": 0.13124018907547,
    "CMYK_C": 0.5609118938446,
    "CMYK_M": 0.12920309603214,
    "CMYK_Y": 0,
    "CMYK_K": 0.13124018907547
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0069",
    "Farbtonhilfsbezeichnung": "01.012.03",
    "Farbtonklasse": "02",
    "Rcolor": "66",
    "Gcolor": "167",
    "Bcolor": "195",
    "Y": 32.6978988647461,
    "L": 63.9155426025391,
    "a": -20.1622104644775,
    "b": -23.706392288208,
    "C": 31.1208572387695,
    "h": 229.618942260742,
    "CMY_C": 0.74222207069397,
    "CMY_M": 0.34532129764557,
    "CMY_Y": 0.23586440086365,
    "CMYK_C": 0.66265422105789,
    "CMYK_M": 0.14324276149273,
    "CMYK_Y": 0,
    "CMYK_K": 0.23586440086365
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0070",
    "Farbtonhilfsbezeichnung": "01.012.04",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "141",
    "Bcolor": "172",
    "Y": 22.4631576538086,
    "L": 54.5150108337402,
    "a": -18.0733528137207,
    "b": -25.1615104675293,
    "C": 30.9797954559326,
    "h": 234.310562133789,
    "CMY_C": 0.85895067453384,
    "CMY_M": 0.44619417190552,
    "CMY_Y": 0.32588642835617,
    "CMYK_C": 0.79076325893402,
    "CMYK_M": 0.1784680634737,
    "CMYK_Y": 0,
    "CMYK_K": 0.32588642835617
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0071",
    "Farbtonhilfsbezeichnung": "01.012.05",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "147",
    "Y": 14.8887176513672,
    "L": 45.4813995361328,
    "a": -17.283203125,
    "b": -24.3738441467285,
    "C": 29.8796482086182,
    "h": 234.660003662109,
    "CMY_C": 1,
    "CMY_M": 0.53876316547394,
    "CMY_Y": 0.42490911483765,
    "CMYK_C": 1,
    "CMYK_M": 0.19797575473785,
    "CMYK_Y": 0,
    "CMYK_K": 0.42490911483765
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0072",
    "Farbtonhilfsbezeichnung": "01.012.06",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "125",
    "Y": 9.58147811889648,
    "L": 37.0805587768555,
    "a": -14.3301830291748,
    "b": -24.2908630371094,
    "C": 28.2028388977051,
    "h": 239.461883544922,
    "CMY_C": 1,
    "CMY_M": 0.62520718574524,
    "CMY_Y": 0.51008224487305,
    "CMYK_C": 1,
    "CMYK_M": 0.23498830199242,
    "CMYK_Y": 0,
    "CMYK_K": 0.51008224487305
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0073",
    "Farbtonhilfsbezeichnung": "01.013.01",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "231",
    "Bcolor": "235",
    "Y": 74.2784652709961,
    "L": 89.0539321899414,
    "a": -11.8282871246338,
    "b": -7.1001672744751,
    "C": 13.7956790924072,
    "h": 210.975128173828,
    "CMY_C": 0.25152146816254,
    "CMY_M": 0.09357613325119,
    "CMY_Y": 0.07871973514557,
    "CMYK_C": 0.18756695091724,
    "CMYK_M": 0.0161258187145,
    "CMYK_Y": 0,
    "CMYK_K": 0.07871973514557
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0074",
    "Farbtonhilfsbezeichnung": "01.013.02",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "215",
    "Bcolor": "224",
    "Y": 62.5898818969727,
    "L": 83.2261276245117,
    "a": -12.0558404922485,
    "b": -10.3326835632324,
    "C": 15.8778982162476,
    "h": 220.598846435547,
    "CMY_C": 0.33215761184692,
    "CMY_M": 0.15683525800705,
    "CMY_Y": 0.1196420788765,
    "CMYK_C": 0.24139674007893,
    "CMYK_M": 0.04224779456854,
    "CMYK_Y": 0,
    "CMYK_K": 0.1196420788765
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0075",
    "Farbtonhilfsbezeichnung": "01.013.03",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "208",
    "Bcolor": "223",
    "Y": 56.4254875183105,
    "L": 79.8553695678711,
    "a": -16.9814701080322,
    "b": -14.4738368988037,
    "C": 22.3128280639648,
    "h": 220.442001342773,
    "CMY_C": 0.44095075130463,
    "CMY_M": 0.18260246515274,
    "CMY_Y": 0.1273113489151,
    "CMYK_C": 0.35939440131187,
    "CMYK_M": 0.06335720419884,
    "CMYK_Y": 0,
    "CMYK_K": 0.1273113489151
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0076",
    "Farbtonhilfsbezeichnung": "01.013.04",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "189",
    "Bcolor": "211",
    "Y": 44.039249420166,
    "L": 72.2547225952148,
    "a": -19.995267868042,
    "b": -19.7366886138916,
    "C": 28.0953311920166,
    "h": 224.627105712891,
    "CMY_C": 0.59830892086029,
    "CMY_M": 0.25789433717728,
    "CMY_Y": 0.17328709363937,
    "CMYK_C": 0.51411056518555,
    "CMYK_M": 0.10234174877405,
    "CMYK_Y": 0,
    "CMYK_K": 0.17328709363937
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0077",
    "Farbtonhilfsbezeichnung": "01.013.05",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "171",
    "Bcolor": "198",
    "Y": 34.3650436401367,
    "L": 65.2512969970703,
    "a": -21.5131397247314,
    "b": -23.315299987793,
    "C": 31.7240982055664,
    "h": 227.302124023438,
    "CMY_C": 0.74491393566132,
    "CMY_M": 0.32892549037933,
    "CMY_Y": 0.22429275512695,
    "CMYK_C": 0.67115676403046,
    "CMYK_M": 0.1348868906498,
    "CMYK_Y": 0,
    "CMYK_K": 0.22429275512695
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0078",
    "Farbtonhilfsbezeichnung": "01.013.06",
    "Farbtonklasse": "03",
    "Rcolor": "16",
    "Gcolor": "145",
    "Bcolor": "174",
    "Y": 23.3925895690918,
    "L": 55.474437713623,
    "a": -20.9094181060791,
    "b": -24.8461227416992,
    "C": 32.4735832214355,
    "h": 229.917495727539,
    "CMY_C": 0.93561410903931,
    "CMY_M": 0.43166148662567,
    "CMY_Y": 0.31811916828156,
    "CMYK_C": 0.90557605028152,
    "CMYK_M": 0.166513428092,
    "CMYK_Y": 0,
    "CMYK_K": 0.31811916828156
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0079",
    "Farbtonhilfsbezeichnung": "01.014.01",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "230",
    "Bcolor": "216",
    "Y": 70.9314804077148,
    "L": 87.4517059326172,
    "a": -19.3881225585938,
    "b": 0.6082871556282,
    "C": 19.3976631164551,
    "h": 178.202987670898,
    "CMY_C": 0.304747402668,
    "CMY_M": 0.09790951013565,
    "CMY_Y": 0.15420061349869,
    "CMYK_C": 0.22928729653358,
    "CMYK_M": 0,
    "CMYK_Y": 0.06240072846413,
    "CMYK_K": 0.09790951013565
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0080",
    "Farbtonhilfsbezeichnung": "01.014.02",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 60.6232833862305,
    "L": 82.1758041381836,
    "a": -28.4108963012695,
    "b": 0.07885667681694,
    "C": 28.4110050201416,
    "h": 179.840972900391,
    "CMY_C": 0.45673841238022,
    "CMY_M": 0.1392120718956,
    "CMY_Y": 0.20884150266647,
    "CMYK_C": 0.36887872219086,
    "CMYK_M": 0,
    "CMYK_Y": 0.08089034259319,
    "CMYK_K": 0.1392120718956
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0081",
    "Farbtonhilfsbezeichnung": "01.014.03",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "211",
    "Bcolor": "199",
    "Y": 54.1847343444824,
    "L": 78.5693283081055,
    "a": -32.2613792419434,
    "b": -3.69057631492615,
    "C": 32.4717864990234,
    "h": 186.52604675293,
    "CMY_C": 0.56721210479736,
    "CMY_M": 0.17135369777679,
    "CMY_Y": 0.22087013721466,
    "CMYK_C": 0.47771698236465,
    "CMYK_M": 0,
    "CMYK_Y": 0.05975582078099,
    "CMYK_K": 0.17135369777679
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0082",
    "Farbtonhilfsbezeichnung": "01.014.04",
    "Farbtonklasse": "02",
    "Rcolor": "51",
    "Gcolor": "194",
    "Bcolor": "185",
    "Y": 42.7322616577148,
    "L": 71.3728713989258,
    "a": -38.3552131652832,
    "b": -6.85929107666016,
    "C": 38.9637298583984,
    "h": 190.139358520508,
    "CMY_C": 0.80010455846786,
    "CMY_M": 0.2395755648613,
    "CMY_Y": 0.27587604522705,
    "CMYK_C": 0.73712646961212,
    "CMYK_M": 0,
    "CMYK_Y": 0.04773712903261,
    "CMYK_K": 0.2395755648613
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0083",
    "Farbtonhilfsbezeichnung": "01.014.05",
    "Farbtonklasse": "03",
    "Rcolor": "8",
    "Gcolor": "176",
    "Bcolor": "169",
    "Y": 34.1722145080566,
    "L": 65.0990371704102,
    "a": -38.1211624145508,
    "b": -7.70872163772583,
    "C": 38.8927688598633,
    "h": 191.431976318359,
    "CMY_C": 0.96810048818588,
    "CMY_M": 0.30786365270615,
    "CMY_Y": 0.33606433868408,
    "CMYK_C": 0.95391154289246,
    "CMYK_M": 0,
    "CMYK_Y": 0.04074440896511,
    "CMYK_K": 0.30786365270615
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0084",
    "Farbtonhilfsbezeichnung": "01.014.06",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "151",
    "Bcolor": "146",
    "Y": 23.7026443481445,
    "L": 55.7888412475586,
    "a": -37.9112091064453,
    "b": -8.30712890625,
    "C": 38.8106689453125,
    "h": 192.359359741211,
    "CMY_C": 1,
    "CMY_M": 0.40709489583969,
    "CMY_Y": 0.42804908752441,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.03534156084061,
    "CMYK_K": 0.40709489583969
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0085",
    "Farbtonhilfsbezeichnung": "01.015.01",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "231",
    "Bcolor": "173",
    "Y": 73.2237014770508,
    "L": 88.5542907714844,
    "a": -17.6106433868408,
    "b": 24.5655765533447,
    "C": 30.2258548736572,
    "h": 125.636100769043,
    "CMY_C": 0.19160163402557,
    "CMY_M": 0.09481811523438,
    "CMY_Y": 0.3199667930603,
    "CMYK_C": 0.10692162811756,
    "CMYK_M": 0,
    "CMYK_Y": 0.24873307347298,
    "CMYK_K": 0.09481811523438
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0086",
    "Farbtonhilfsbezeichnung": "01.015.02",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "215",
    "Bcolor": "164",
    "Y": 58.8498649597168,
    "L": 81.2089996337891,
    "a": -28.0056228637695,
    "b": 18.9739990234375,
    "C": 33.8279113769531,
    "h": 145.882095336914,
    "CMY_C": 0.37781900167465,
    "CMY_M": 0.15502214431763,
    "CMY_Y": 0.35729968547821,
    "CMYK_C": 0.26367181539536,
    "CMYK_M": 0,
    "CMYK_Y": 0.23938797414303,
    "CMYK_K": 0.15502214431763
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0087",
    "Farbtonhilfsbezeichnung": "01.015.03",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "198",
    "Bcolor": "122",
    "Y": 45.5986022949219,
    "L": 73.2843170166016,
    "a": -40.9891891479492,
    "b": 29.9772148132324,
    "C": 50.781364440918,
    "h": 143.820343017578,
    "CMY_C": 0.54956769943237,
    "CMY_M": 0.22203189134598,
    "CMY_Y": 0.52202886343002,
    "CMYK_C": 0.42101442813873,
    "CMYK_M": 0,
    "CMYK_Y": 0.38561603426933,
    "CMYK_K": 0.22203189134598
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0088",
    "Farbtonhilfsbezeichnung": "01.015.04",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "170",
    "Bcolor": "100",
    "Y": 31.830982208252,
    "L": 63.2029495239258,
    "a": -40.1616973876953,
    "b": 27.9410247802734,
    "C": 48.9250717163086,
    "h": 145.173156738281,
    "CMY_C": 0.6561713218689,
    "CMY_M": 0.33231174945831,
    "CMY_Y": 0.60661172866821,
    "CMYK_C": 0.48504608869553,
    "CMYK_M": 0,
    "CMYK_Y": 0.41082042455673,
    "CMYK_K": 0.33231174945831
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0089",
    "Farbtonhilfsbezeichnung": "01.015.05",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "149",
    "Bcolor": "80",
    "Y": 21.9644279479981,
    "L": 53.9892387390137,
    "a": -50.5890960693359,
    "b": 26.6323261260986,
    "C": 57.1711235046387,
    "h": 152.235702514648,
    "CMY_C": 1,
    "CMY_M": 0.41589909791946,
    "CMY_Y": 0.68711256980896,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.46432641148567,
    "CMYK_K": 0.41589909791946
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0090",
    "Farbtonhilfsbezeichnung": "01.015.06",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "101",
    "Bcolor": "67",
    "Y": 9.90282344818115,
    "L": 37.6674537658691,
    "a": -32.373363494873,
    "b": 12.5474433898926,
    "C": 34.7199211120605,
    "h": 158.814392089844,
    "CMY_C": 0.9206138253212,
    "CMY_M": 0.60306072235107,
    "CMY_Y": 0.73834550380707,
    "CMYK_C": 0.80000424385071,
    "CMYK_M": 0,
    "CMYK_Y": 0.34081983566284,
    "CMYK_K": 0.60306072235107
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0091",
    "Farbtonhilfsbezeichnung": "01.016.01",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "231",
    "Bcolor": "184",
    "Y": 76.4045867919922,
    "L": 90.0468521118164,
    "a": -10.3248071670532,
    "b": 21.1223964691162,
    "C": 23.5107898712158,
    "h": 116.049774169922,
    "CMY_C": 0.12720459699631,
    "CMY_M": 0.09298592805862,
    "CMY_Y": 0.27701550722122,
    "CMYK_C": 0.03772672265768,
    "CMYK_M": 0,
    "CMYK_Y": 0.20289605855942,
    "CMYK_K": 0.09298592805862
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0092",
    "Farbtonhilfsbezeichnung": "01.016.02",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "233",
    "Bcolor": "171",
    "Y": 75.7331924438477,
    "L": 89.7353210449219,
    "a": -14.8217163085938,
    "b": 27.7449359893799,
    "C": 31.4557590484619,
    "h": 118.11173248291,
    "CMY_C": 0.14782923460007,
    "CMY_M": 0.08811122179031,
    "CMY_Y": 0.33095365762711,
    "CMYK_C": 0.06548826396465,
    "CMYK_M": 0,
    "CMYK_Y": 0.26630708575249,
    "CMYK_K": 0.08811122179031
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0093",
    "Farbtonhilfsbezeichnung": "01.016.03",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "223",
    "Bcolor": "152",
    "Y": 67.4508056640625,
    "L": 85.7310943603516,
    "a": -18.7823028564453,
    "b": 31.8844985961914,
    "C": 37.0053520202637,
    "h": 120.501205444336,
    "CMY_C": 0.21253538131714,
    "CMY_M": 0.12526667118073,
    "CMY_Y": 0.40503263473511,
    "CMYK_C": 0.09976607561111,
    "CMYK_M": 0,
    "CMYK_Y": 0.31983000040054,
    "CMYK_K": 0.12526667118073
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0094",
    "Farbtonhilfsbezeichnung": "01.016.04",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "208",
    "Bcolor": "131",
    "Y": 56.8382606506348,
    "L": 80.0885391235352,
    "a": -20.1488227844238,
    "b": 34.8684349060059,
    "C": 40.2713661193848,
    "h": 120.021583557129,
    "CMY_C": 0.27778697013855,
    "CMY_M": 0.18529367446899,
    "CMY_Y": 0.48605865240097,
    "CMYK_C": 0.1135296151042,
    "CMYK_M": 0,
    "CMYK_Y": 0.36916980147362,
    "CMYK_K": 0.18529367446899
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0095",
    "Farbtonhilfsbezeichnung": "01.016.05",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "190",
    "Bcolor": "101",
    "Y": 44.7560539245605,
    "L": 72.7309722900391,
    "a": -25.3467311859131,
    "b": 40.2178497314453,
    "C": 47.538745880127,
    "h": 122.220603942871,
    "CMY_C": 0.38566279411316,
    "CMY_M": 0.25626075267792,
    "CMY_Y": 0.60232985019684,
    "CMYK_C": 0.17398844659328,
    "CMYK_M": 0,
    "CMYK_Y": 0.46530970931053,
    "CMYK_K": 0.25626075267792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0096",
    "Farbtonhilfsbezeichnung": "01.016.06",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "161",
    "Bcolor": "72",
    "Y": 29.9076595306396,
    "L": 61.5744590759277,
    "a": -28.5213832855225,
    "b": 40.8620872497559,
    "C": 49.8315124511719,
    "h": 124.914703369141,
    "CMY_C": 0.5269889831543,
    "CMY_M": 0.36958456039429,
    "CMY_Y": 0.71787339448929,
    "CMYK_C": 0.24968364834785,
    "CMYK_M": 0,
    "CMYK_Y": 0.55247509479523,
    "CMYK_K": 0.36958456039429
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0097",
    "Farbtonhilfsbezeichnung": "01.017.01",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "185",
    "Y": 83.1291046142578,
    "L": 93.070930480957,
    "a": -7.25621700286865,
    "b": 24.8989543914795,
    "C": 25.9347381591797,
    "h": 106.247528076172,
    "CMY_C": 0.0597910284996,
    "CMY_M": 0.06681555509567,
    "CMY_Y": 0.27256554365158,
    "CMYK_C": 0,
    "CMYK_M": 0.00747123965994,
    "CMYK_Y": 0.22630555927753,
    "CMYK_K": 0.0597910284996
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0098",
    "Farbtonhilfsbezeichnung": "01.017.02",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "239",
    "Bcolor": "167",
    "Y": 81.7051086425781,
    "L": 92.4445495605469,
    "a": -12.1694374084473,
    "b": 33.1714210510254,
    "C": 35.3332481384277,
    "h": 110.146331787109,
    "CMY_C": 0.08369946479797,
    "CMY_M": 0.06453615427017,
    "CMY_Y": 0.34313923120499,
    "CMYK_C": 0.02048535645008,
    "CMYK_M": 0,
    "CMYK_Y": 0.29782345890999,
    "CMYK_K": 0.06453615427017
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0099",
    "Farbtonhilfsbezeichnung": "01.017.03",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "230",
    "Bcolor": "130",
    "Y": 73.1962585449219,
    "L": 88.5412292480469,
    "a": -17.4044933319092,
    "b": 46.4228134155273,
    "C": 49.5781593322754,
    "h": 110.551651000977,
    "CMY_C": 0.13879162073135,
    "CMY_M": 0.0992488861084,
    "CMY_Y": 0.48855745792389,
    "CMYK_C": 0.0438997335732,
    "CMYK_M": 0,
    "CMYK_Y": 0.43220436573029,
    "CMYK_K": 0.0992488861084
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0100",
    "Farbtonhilfsbezeichnung": "01.017.04",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "218",
    "Bcolor": "87",
    "Y": 64.2893295288086,
    "L": 84.1161804199219,
    "a": -20.3837013244629,
    "b": 60.9521903991699,
    "C": 64.2702484130859,
    "h": 108.491027832031,
    "CMY_C": 0.1864795088768,
    "CMY_M": 0.1441211104393,
    "CMY_Y": 0.65831792354584,
    "CMYK_C": 0.04949111118913,
    "CMYK_M": 0,
    "CMYK_Y": 0.60078221559525,
    "CMYK_K": 0.1441211104393
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0101",
    "Farbtonhilfsbezeichnung": "01.017.05",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "213",
    "Bcolor": "56",
    "Y": 59.8503761291504,
    "L": 81.7567977905273,
    "a": -23.028434753418,
    "b": 70.3348541259766,
    "C": 74.0087890625,
    "h": 108.129035949707,
    "CMY_C": 0.22018277645111,
    "CMY_M": 0.16578513383865,
    "CMY_Y": 0.7822380065918,
    "CMYK_C": 0.06520818918943,
    "CMYK_M": 0,
    "CMYK_Y": 0.7389617562294,
    "CMYK_K": 0.16578513383865
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0102",
    "Farbtonhilfsbezeichnung": "01.017.06",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "188",
    "Bcolor": "45",
    "Y": 44.9874000549316,
    "L": 72.8835983276367,
    "a": -21.8563785552979,
    "b": 64.8629837036133,
    "C": 68.4463882446289,
    "h": 108.621879577637,
    "CMY_C": 0.31917077302933,
    "CMY_M": 0.26383823156357,
    "CMY_Y": 0.82429510354996,
    "CMYK_C": 0.07516356557608,
    "CMYK_M": 0,
    "CMYK_Y": 0.76132297515869,
    "CMYK_K": 0.26383823156357
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0103",
    "Farbtonhilfsbezeichnung": "01.018.01",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "225",
    "Bcolor": "175",
    "Y": 73.9514694213867,
    "L": 88.899543762207,
    "a": -5.63999605178833,
    "b": 24.3132820129395,
    "C": 24.9588718414307,
    "h": 103.060020446777,
    "CMY_C": 0.09628212451935,
    "CMY_M": 0.11693912744522,
    "CMY_Y": 0.31229364871979,
    "CMYK_C": 0,
    "CMYK_M": 0.02285780012608,
    "CMYK_Y": 0.23902539908886,
    "CMYK_K": 0.09628212451935
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0104",
    "Farbtonhilfsbezeichnung": "01.018.02",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "226",
    "Bcolor": "124",
    "Y": 73.5293960571289,
    "L": 88.699592590332,
    "a": -10.3564529418945,
    "b": 50.0164260864258,
    "C": 51.0773811340332,
    "h": 101.69841003418,
    "CMY_C": 0.07967394590378,
    "CMY_M": 0.11316049098969,
    "CMY_Y": 0.5140033364296,
    "CMYK_C": 0,
    "CMYK_M": 0.03638552501798,
    "CMYK_Y": 0.47192990779877,
    "CMYK_K": 0.07967394590378
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0105",
    "Farbtonhilfsbezeichnung": "01.018.03",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "213",
    "Bcolor": "90",
    "Y": 63.5041427612305,
    "L": 83.7069320678711,
    "a": -13.0506391525269,
    "b": 59.6156692504883,
    "C": 61.0274314880371,
    "h": 102.347991943359,
    "CMY_C": 0.14146226644516,
    "CMY_M": 0.16365402936935,
    "CMY_Y": 0.64783477783203,
    "CMYK_C": 0,
    "CMYK_M": 0.02584832534194,
    "CMYK_Y": 0.58980810642242,
    "CMYK_K": 0.14146226644516
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0106",
    "Farbtonhilfsbezeichnung": "01.018.04",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "200",
    "Bcolor": "59",
    "Y": 54.6131248474121,
    "L": 78.8179016113281,
    "a": -13.3145513534546,
    "b": 66.5782928466797,
    "C": 67.8965835571289,
    "h": 101.309013366699,
    "CMY_C": 0.19117885828018,
    "CMY_M": 0.21709221601486,
    "CMY_Y": 0.76872098445892,
    "CMYK_C": 0,
    "CMYK_M": 0.03203842788935,
    "CMYK_Y": 0.71405416727066,
    "CMYK_K": 0.19117885828018
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0107",
    "Farbtonhilfsbezeichnung": "01.018.05",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "202",
    "Bcolor": "49",
    "Y": 56.1107635498047,
    "L": 79.6768188476563,
    "a": -13.4524326324463,
    "b": 70.6832962036133,
    "C": 71.9520416259766,
    "h": 100.775650024414,
    "CMY_C": 0.17780363559723,
    "CMY_M": 0.20787966251373,
    "CMY_Y": 0.80635410547256,
    "CMYK_C": 0,
    "CMYK_M": 0.03658010065556,
    "CMYK_Y": 0.76447731256485,
    "CMYK_K": 0.17780363559723
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0108",
    "Farbtonhilfsbezeichnung": "01.018.06",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "176",
    "Bcolor": "36",
    "Y": 42.3623237609863,
    "L": 71.1200103759766,
    "a": -9.01537132263184,
    "b": 66.3818206787109,
    "C": 66.9912185668945,
    "h": 97.7340698242188,
    "CMY_C": 0.25196593999863,
    "CMY_M": 0.3083980679512,
    "CMY_Y": 0.85769480466843,
    "CMYK_C": 0,
    "CMYK_M": 0.07544058561325,
    "CMYK_Y": 0.80976104736328,
    "CMYK_K": 0.25196593999863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0109",
    "Farbtonhilfsbezeichnung": "01.019.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "236",
    "Bcolor": "199",
    "Y": 84.3607940673828,
    "L": 93.6069793701172,
    "a": -1.13969480991364,
    "b": 18.8331832885742,
    "C": 18.8676357269287,
    "h": 93.4630432128906,
    "CMY_C": 0.02365630865097,
    "CMY_M": 0.07368475198746,
    "CMY_Y": 0.22001796960831,
    "CMYK_C": 0,
    "CMYK_M": 0.05124060809612,
    "CMYK_Y": 0.20111940801144,
    "CMYK_K": 0.02365630865097
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0110",
    "Farbtonhilfsbezeichnung": "01.019.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "236",
    "Bcolor": "192",
    "Y": 84.4170227050781,
    "L": 93.6313247680664,
    "a": -1.57453513145447,
    "b": 22.3368473052979,
    "C": 22.3922729492188,
    "h": 94.0321350097656,
    "CMY_C": 0.0175849199295,
    "CMY_M": 0.0731840133667,
    "CMY_Y": 0.24618595838547,
    "CMYK_C": 0,
    "CMYK_M": 0.05659430101514,
    "CMYK_Y": 0.23269292712212,
    "CMYK_K": 0.0175849199295
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0111",
    "Farbtonhilfsbezeichnung": "01.019.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "232",
    "Bcolor": "184",
    "Y": 81.6543884277344,
    "L": 92.4221038818359,
    "a": -1.01024508476257,
    "b": 24.9609298706055,
    "C": 24.9813652038574,
    "h": 92.3176727294922,
    "CMY_C": 0.02087479829788,
    "CMY_M": 0.0886372923851,
    "CMY_Y": 0.27882516384125,
    "CMYK_C": 0,
    "CMYK_M": 0.06920717656612,
    "CMYK_Y": 0.26344981789589,
    "CMYK_K": 0.02087479829788
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0112",
    "Farbtonhilfsbezeichnung": "01.019.04",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "221",
    "Bcolor": "161",
    "Y": 74.4664077758789,
    "L": 89.1424560546875,
    "a": 1.23572623729706,
    "b": 32.3154907226563,
    "C": 32.3391075134277,
    "h": 87.8101043701172,
    "CMY_C": 0.02642357349396,
    "CMY_M": 0.1320019364357,
    "CMY_Y": 0.36863642930984,
    "CMYK_C": 0,
    "CMYK_M": 0.10844383388758,
    "CMYK_Y": 0.35150074958801,
    "CMYK_K": 0.02642357349396
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0113",
    "Farbtonhilfsbezeichnung": "01.019.05",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "214",
    "Bcolor": "142",
    "Y": 69.1830215454102,
    "L": 86.594596862793,
    "a": 1.44319415092468,
    "b": 38.7758140563965,
    "C": 38.802661895752,
    "h": 87.8684997558594,
    "CMY_C": 0.04212993383408,
    "CMY_M": 0.16179221868515,
    "CMY_Y": 0.44430476427078,
    "CMYK_C": 0,
    "CMYK_M": 0.12492538243532,
    "CMYK_Y": 0.41986367106438,
    "CMYK_K": 0.04212993383408
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0114",
    "Farbtonhilfsbezeichnung": "01.019.06",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "200",
    "Bcolor": "125",
    "Y": 59.9648704528809,
    "L": 81.819091796875,
    "a": 1.75864899158478,
    "b": 40.8304100036621,
    "C": 40.8682670593262,
    "h": 87.5336761474609,
    "CMY_C": 0.09162503480911,
    "CMY_M": 0.21502470970154,
    "CMY_Y": 0.50897085666656,
    "CMYK_C": 0,
    "CMYK_M": 0.13584662973881,
    "CMYK_Y": 0.45944222807884,
    "CMYK_K": 0.09162503480911
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0115",
    "Farbtonhilfsbezeichnung": "01.020.01",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "230",
    "Bcolor": "200",
    "Y": 81.3105850219727,
    "L": 92.2697219848633,
    "a": 2.4097101688385,
    "b": 16.6230888366699,
    "C": 16.796838760376,
    "h": 81.7517623901367,
    "CMY_C": 0.01852935552597,
    "CMY_M": 0.09666550159454,
    "CMY_Y": 0.21732443571091,
    "CMYK_C": 0,
    "CMYK_M": 0.07961129397154,
    "CMYK_Y": 0.20254816114902,
    "CMYK_K": 0.01852935552597
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0116",
    "Farbtonhilfsbezeichnung": "01.020.02",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "226",
    "Bcolor": "188",
    "Y": 78.3626327514648,
    "L": 90.9451293945312,
    "a": 3.24121165275574,
    "b": 20.8663082122803,
    "C": 21.1165409088135,
    "h": 81.1706771850586,
    "CMY_C": 0.01699012517929,
    "CMY_M": 0.11445218324661,
    "CMY_Y": 0.26312208175659,
    "CMYK_C": 0,
    "CMYK_M": 0.09914656728506,
    "CMYK_Y": 0.25038605928421,
    "CMYK_K": 0.01699012517929
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0117",
    "Farbtonhilfsbezeichnung": "01.020.03",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "228",
    "Bcolor": "183",
    "Y": 79.1924209594727,
    "L": 91.3212814331055,
    "a": 1.16967809200287,
    "b": 23.9192276000977,
    "C": 23.9478092193604,
    "h": 87.2003936767578,
    "CMY_C": 0.0202311873436,
    "CMY_M": 0.10591399669647,
    "CMY_Y": 0.28233897686005,
    "CMYK_C": 0,
    "CMYK_M": 0.0874520689249,
    "CMYK_Y": 0.26752004027367,
    "CMYK_K": 0.0202311873436
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0118",
    "Farbtonhilfsbezeichnung": "01.020.04",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "220",
    "Bcolor": "156",
    "Y": 74.4563064575195,
    "L": 89.1377029418945,
    "a": 3.03148603439331,
    "b": 34.7702140808105,
    "C": 34.9021148681641,
    "h": 85.0171966552734,
    "CMY_C": 0.00928002595901,
    "CMY_M": 0.13689732551575,
    "CMY_Y": 0.38693249225616,
    "CMYK_C": 0,
    "CMYK_M": 0.12881268560886,
    "CMYK_Y": 0.3811899125576,
    "CMYK_K": 0.00928002595901
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0119",
    "Farbtonhilfsbezeichnung": "01.020.05",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "211",
    "Bcolor": "142",
    "Y": 69.2580795288086,
    "L": 86.6316833496094,
    "a": 5.71694803237915,
    "b": 39.0494079589844,
    "C": 39.4656791687012,
    "h": 81.6708984375,
    "CMY_C": 0.01264834403992,
    "CMY_M": 0.17191255092621,
    "CMY_Y": 0.44499921798706,
    "CMYK_C": 0,
    "CMYK_M": 0.16130444407463,
    "CMYK_Y": 0.43788945674896,
    "CMYK_K": 0.01264834403992
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0120",
    "Farbtonhilfsbezeichnung": "01.020.06",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "211",
    "Bcolor": "142",
    "Y": 69.2473220825195,
    "L": 86.6263732910156,
    "a": 5.72027158737183,
    "b": 39.0486450195313,
    "C": 39.465404510498,
    "h": 81.6659698486328,
    "CMY_C": 0.01268970966339,
    "CMY_M": 0.17197895050049,
    "CMY_Y": 0.44504743814468,
    "CMYK_C": 0,
    "CMYK_M": 0.161336556077,
    "CMYK_Y": 0.43791472911835,
    "CMYK_K": 0.01268970966339
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0121",
    "Farbtonhilfsbezeichnung": "01.021.01",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "185",
    "Y": 75.2931442260742,
    "L": 89.5301284790039,
    "a": 7.0550422668457,
    "b": 20.2381973266602,
    "C": 21.4326438903809,
    "h": 70.7814254760742,
    "CMY_C": 0.00775694847107,
    "CMY_M": 0.13947641849518,
    "CMY_Y": 0.27288472652435,
    "CMYK_C": 0,
    "CMYK_M": 0.13274919986725,
    "CMYK_Y": 0.26720044016838,
    "CMYK_K": 0.00775694847107
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0122",
    "Farbtonhilfsbezeichnung": "01.021.02",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "207",
    "Bcolor": "165",
    "Y": 68.0265808105469,
    "L": 86.0197372436523,
    "a": 10.333306312561,
    "b": 26.106575012207,
    "C": 28.0772228240967,
    "h": 68.4057235717773,
    "CMY_C": 0.01310580968857,
    "CMY_M": 0.18778103590012,
    "CMY_Y": 0.35297065973282,
    "CMYK_C": 0,
    "CMYK_M": 0.17699488997459,
    "CMYK_Y": 0.34437820315361,
    "CMYK_K": 0.01310580968857
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0123",
    "Farbtonhilfsbezeichnung": "01.021.03",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "143",
    "Y": 64.0547790527344,
    "L": 83.9942779541016,
    "a": 15.4461097717285,
    "b": 34.8627777099609,
    "C": 38.1312942504883,
    "h": 66.1040496826172,
    "CMY_C": 0,
    "CMY_M": 0.22516745328903,
    "CMY_Y": 0.43815296888351,
    "CMYK_C": 0,
    "CMYK_M": 0.22516745328903,
    "CMYK_Y": 0.43815296888351,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0124",
    "Farbtonhilfsbezeichnung": "01.021.04",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "160",
    "Y": 63.8177680969238,
    "L": 83.8708038330078,
    "a": 12.0312232971191,
    "b": 25.6307315826416,
    "C": 28.3140373229981,
    "h": 64.8543472290039,
    "CMY_C": 0.02764409780502,
    "CMY_M": 0.21553409099579,
    "CMY_Y": 0.37157040834427,
    "CMYK_C": 0,
    "CMYK_M": 0.19323171675205,
    "CMYK_Y": 0.35370415449142,
    "CMYK_K": 0.02764409780502
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0125",
    "Farbtonhilfsbezeichnung": "01.021.05",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "182",
    "Bcolor": "138",
    "Y": 54.0767784118652,
    "L": 78.506477355957,
    "a": 16.2713279724121,
    "b": 30.2982711791992,
    "C": 34.3910064697266,
    "h": 61.7625045776367,
    "CMY_C": 0.05411261320114,
    "CMY_M": 0.28567188978195,
    "CMY_Y": 0.46026796102524,
    "CMYK_C": 0,
    "CMYK_M": 0.24480639398098,
    "CMYK_Y": 0.42939081788063,
    "CMYK_K": 0.05411261320114
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0126",
    "Farbtonhilfsbezeichnung": "01.021.06",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "164",
    "Bcolor": "106",
    "Y": 45.5519332885742,
    "L": 73.2538452148438,
    "a": 21.1716175079346,
    "b": 40.1288146972656,
    "C": 45.3713455200195,
    "h": 62.184253692627,
    "CMY_C": 0.0715469121933,
    "CMY_M": 0.35685235261917,
    "CMY_Y": 0.58444595336914,
    "CMYK_C": 0,
    "CMYK_M": 0.3072911798954,
    "CMYK_Y": 0.55242323875427,
    "CMYK_K": 0.0715469121933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0127",
    "Farbtonhilfsbezeichnung": "01.022.01",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "228",
    "Bcolor": "215",
    "Y": 80.1324462890625,
    "L": 91.744255065918,
    "a": 5.30654191970825,
    "b": 7.73326683044434,
    "C": 9.37884902954102,
    "h": 55.5422172546387,
    "CMY_C": 0.0276660323143,
    "CMY_M": 0.1073751449585,
    "CMY_Y": 0.15642696619034,
    "CMYK_C": 0,
    "CMYK_M": 0.08197709172964,
    "CMYK_Y": 0.1324245929718,
    "CMYK_K": 0.0276660323143
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0128",
    "Farbtonhilfsbezeichnung": "01.022.02",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "218",
    "Bcolor": "203",
    "Y": 75.3706359863281,
    "L": 89.5663223266602,
    "a": 10.1556444168091,
    "b": 11.2239389419556,
    "C": 15.1365098953247,
    "h": 47.8605766296387,
    "CMY_C": 0.00772750377655,
    "CMY_M": 0.14474314451218,
    "CMY_Y": 0.20521062612534,
    "CMYK_C": 0,
    "CMYK_M": 0.13808266818523,
    "CMYK_Y": 0.19902105629444,
    "CMYK_K": 0.00772750377655
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0129",
    "Farbtonhilfsbezeichnung": "01.022.03",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "181",
    "Y": 66.3483734130859,
    "L": 85.1738052368164,
    "a": 16.9409141540527,
    "b": 16.7404174804688,
    "C": 23.8167190551758,
    "h": 44.658935546875,
    "CMY_C": 0,
    "CMY_M": 0.21236842870712,
    "CMY_Y": 0.29167896509171,
    "CMYK_C": 0,
    "CMYK_M": 0.21236842870712,
    "CMYK_Y": 0.29167896509171,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0130",
    "Farbtonhilfsbezeichnung": "01.022.04",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "184",
    "Bcolor": "164",
    "Y": 55.1860160827637,
    "L": 79.1482925415039,
    "a": 17.3101406097412,
    "b": 17.002046585083,
    "C": 24.2633590698242,
    "h": 44.4855461120605,
    "CMY_C": 0.06498634815216,
    "CMY_M": 0.27865570783615,
    "CMY_Y": 0.3568959236145,
    "CMYK_C": 0,
    "CMYK_M": 0.22852003574371,
    "CMYK_Y": 0.31219819188118,
    "CMYK_K": 0.06498634815216
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0131",
    "Farbtonhilfsbezeichnung": "01.022.05",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "165",
    "Bcolor": "146",
    "Y": 45.0696220397949,
    "L": 72.9377136230469,
    "a": 20.4423389434814,
    "b": 17.9344043731689,
    "C": 27.1943397521973,
    "h": 41.2610168457031,
    "CMY_C": 0.11428338289261,
    "CMY_M": 0.3536211848259,
    "CMY_Y": 0.4270743727684,
    "CMYK_C": 0,
    "CMYK_M": 0.27021938562393,
    "CMYK_Y": 0.35315018892288,
    "CMYK_K": 0.11428338289261
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0132",
    "Farbtonhilfsbezeichnung": "01.022.06",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "137",
    "Bcolor": "116",
    "Y": 31.1670074462891,
    "L": 62.648365020752,
    "a": 20.838529586792,
    "b": 20.1986274719238,
    "C": 29.0211791992188,
    "h": 44.1066474914551,
    "CMY_C": 0.22434949874878,
    "CMY_M": 0.46214371919632,
    "CMY_Y": 0.54589074850082,
    "CMYK_C": 0,
    "CMYK_M": 0.3065739274025,
    "CMYK_Y": 0.4145439863205,
    "CMYK_K": 0.22434949874878
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0133",
    "Farbtonhilfsbezeichnung": "01.023.01",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 75.8738403320313,
    "L": 89.8007354736328,
    "a": 7.9751091003418,
    "b": 3.02596783638,
    "C": 8.52987957000732,
    "h": 20.7780723571777,
    "CMY_C": 0.04380339384079,
    "CMY_M": 0.1343349814415,
    "CMY_Y": 0.14252495765686,
    "CMYK_C": 0,
    "CMYK_M": 0.09467884153128,
    "CMYK_Y": 0.10324399918318,
    "CMYK_K": 0.04380339384079
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0134",
    "Farbtonhilfsbezeichnung": "01.023.02",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "204",
    "Bcolor": "202",
    "Y": 64.5759963989258,
    "L": 84.2647705078125,
    "a": 9.79147338867188,
    "b": 3.59741473197937,
    "C": 10.4314117431641,
    "h": 20.1734733581543,
    "CMY_C": 0.09118795394897,
    "CMY_M": 0.19997787475586,
    "CMY_Y": 0.20679050683975,
    "CMYK_C": 0,
    "CMYK_M": 0.11970563232899,
    "CMYK_Y": 0.12720182538033,
    "CMYK_K": 0.09118795394897
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0135",
    "Farbtonhilfsbezeichnung": "01.023.03",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "185",
    "Bcolor": "183",
    "Y": 54.1079177856445,
    "L": 78.5246124267578,
    "a": 13.9671182632446,
    "b": 5.3652286529541,
    "C": 14.9621543884277,
    "h": 21.0134220123291,
    "CMY_C": 0.12138378620148,
    "CMY_M": 0.27339708805084,
    "CMY_Y": 0.28047913312912,
    "CMYK_C": 0,
    "CMYK_M": 0.17301444709301,
    "CMYK_Y": 0.18107490241528,
    "CMYK_K": 0.12138378620148
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0136",
    "Farbtonhilfsbezeichnung": "01.023.04",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "161",
    "Bcolor": "161",
    "Y": 42.4708290100098,
    "L": 71.1943283081055,
    "a": 20.1631126403809,
    "b": 6.83557558059692,
    "C": 21.2902851104736,
    "h": 18.7273731231689,
    "CMY_C": 0.15887290239334,
    "CMY_M": 0.36834818124771,
    "CMY_Y": 0.36691677570343,
    "CMYK_C": 0,
    "CMYK_M": 0.24904116988182,
    "CMYK_Y": 0.24733939766884,
    "CMYK_K": 0.15887290239334
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0137",
    "Farbtonhilfsbezeichnung": "01.023.05",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "138",
    "Bcolor": "137",
    "Y": 32.6403312683105,
    "L": 63.8686180114746,
    "a": 25.0762786865234,
    "b": 9.70722961425781,
    "C": 26.8895893096924,
    "h": 21.1618213653564,
    "CMY_C": 0.20441937446594,
    "CMY_M": 0.45927721261978,
    "CMY_Y": 0.4609272480011,
    "CMYK_C": 0,
    "CMYK_M": 0.32034194469452,
    "CMYK_Y": 0.32241594791412,
    "CMYK_K": 0.20441937446594
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0138",
    "Farbtonhilfsbezeichnung": "01.023.06",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "108",
    "Bcolor": "111",
    "Y": 20.0427074432373,
    "L": 51.8854598999023,
    "a": 23.648889541626,
    "b": 7.54805183410645,
    "C": 24.8242435455322,
    "h": 17.7016010284424,
    "CMY_C": 0.34880024194717,
    "CMY_M": 0.57534801959991,
    "CMY_Y": 0.5651730298996,
    "CMYK_C": 0,
    "CMYK_M": 0.34789291024208,
    "CMYK_Y": 0.33226791024208,
    "CMYK_K": 0.34880024194717
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0139",
    "Farbtonhilfsbezeichnung": "01.024.01",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "224",
    "Bcolor": "221",
    "Y": 77.1214599609375,
    "L": 90.3774871826172,
    "a": 5.82201623916626,
    "b": 2.56887030601501,
    "C": 6.36356544494629,
    "h": 23.8086929321289,
    "CMY_C": 0.0547724366188,
    "CMY_M": 0.12241756916046,
    "CMY_Y": 0.13312697410583,
    "CMYK_C": 0,
    "CMYK_M": 0.0715649202466,
    "CMYK_Y": 0.08289489150047,
    "CMYK_K": 0.0547724366188
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0140",
    "Farbtonhilfsbezeichnung": "01.024.02",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "205",
    "Bcolor": "207",
    "Y": 65.0493545532227,
    "L": 84.509162902832,
    "a": 9.67637825012207,
    "b": 1.63408815860748,
    "C": 9.81338596343994,
    "h": 9.58532810211182,
    "CMY_C": 0.0950078368187,
    "CMY_M": 0.19645589590073,
    "CMY_Y": 0.18988007307053,
    "CMYK_C": 0,
    "CMYK_M": 0.11209827661514,
    "CMYK_Y": 0.10483210533857,
    "CMYK_K": 0.0950078368187
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0141",
    "Farbtonhilfsbezeichnung": "01.024.03",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "188",
    "Bcolor": "191",
    "Y": 56.238597869873,
    "L": 79.7494201660156,
    "a": 15.4821262359619,
    "b": 3.19922661781311,
    "C": 15.8092155456543,
    "h": 11.6752729415894,
    "CMY_C": 0.10298782587051,
    "CMY_M": 0.26360964775085,
    "CMY_Y": 0.25166410207748,
    "CMYK_C": 0,
    "CMYK_M": 0.17906314134598,
    "CMYK_Y": 0.16574610769749,
    "CMYK_K": 0.10298782587051
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0142",
    "Farbtonhilfsbezeichnung": "01.024.04",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "164",
    "Bcolor": "170",
    "Y": 44.1375579833984,
    "L": 72.3203430175781,
    "a": 20.383264541626,
    "b": 3.65156173706055,
    "C": 20.7077617645264,
    "h": 10.1565208435059,
    "CMY_C": 0.15235310792923,
    "CMY_M": 0.35620945692062,
    "CMY_Y": 0.33281594514847,
    "CMYK_C": 0,
    "CMYK_M": 0.24049678444862,
    "CMYK_Y": 0.21289859712124,
    "CMYK_K": 0.15235310792923
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0143",
    "Farbtonhilfsbezeichnung": "01.024.05",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "148",
    "Bcolor": "153",
    "Y": 34.966667175293,
    "L": 65.7227096557617,
    "a": 18.4155464172363,
    "b": 3.61742901802063,
    "C": 18.7674751281738,
    "h": 11.1133089065552,
    "CMY_C": 0.23810291290283,
    "CMY_M": 0.41969782114029,
    "CMY_Y": 0.40131908655167,
    "CMYK_C": 0,
    "CMYK_M": 0.23834571242332,
    "CMYK_Y": 0.21422338485718,
    "CMYK_K": 0.23810291290283
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0144",
    "Farbtonhilfsbezeichnung": "01.024.06",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "137",
    "Bcolor": "145",
    "Y": 30.5956115722656,
    "L": 62.1647644042969,
    "a": 20.492826461792,
    "b": 2.69091296195984,
    "C": 20.6687431335449,
    "h": 7.48070907592773,
    "CMY_C": 0.26608508825302,
    "CMY_M": 0.46170824766159,
    "CMY_Y": 0.4310354590416,
    "CMYK_C": 0,
    "CMYK_M": 0.26654747128487,
    "CMYK_Y": 0.22475408017635,
    "CMYK_K": 0.26608508825302
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0145",
    "Farbtonhilfsbezeichnung": "01.025.01",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "207",
    "Bcolor": "212",
    "Y": 65.9503479003906,
    "L": 84.9710845947266,
    "a": 8.72090339660645,
    "b": -0.75700581073761,
    "C": 8.75369739532471,
    "h": 355.038940429688,
    "CMY_C": 0.10411417484283,
    "CMY_M": 0.18829280138016,
    "CMY_Y": 0.16758364439011,
    "CMYK_C": 0,
    "CMYK_M": 0.09396133571863,
    "CMYK_Y": 0.07084549218416,
    "CMYK_K": 0.10411417484283
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0146",
    "Farbtonhilfsbezeichnung": "01.025.02",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "192",
    "Bcolor": "201",
    "Y": 57.2551803588867,
    "L": 80.3229064941406,
    "a": 11.3911190032959,
    "b": -1.64397943019867,
    "C": 11.5091381072998,
    "h": 351.787719726563,
    "CMY_C": 0.13907259702682,
    "CMY_M": 0.24534356594086,
    "CMY_Y": 0.21129435300827,
    "CMYK_C": 0,
    "CMYK_M": 0.12343778461218,
    "CMYK_Y": 0.08388832211494,
    "CMYK_K": 0.13907259702682
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0147",
    "Farbtonhilfsbezeichnung": "01.025.03",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "171",
    "Bcolor": "182",
    "Y": 44.6433944702148,
    "L": 72.6564636230469,
    "a": 12.1869983673096,
    "b": -2.54313111305237,
    "C": 12.4495162963867,
    "h": 348.212921142578,
    "CMY_C": 0.22036945819855,
    "CMY_M": 0.32906723022461,
    "CMY_Y": 0.28689712285995,
    "CMYK_C": 0,
    "CMYK_M": 0.13942216336727,
    "CMYK_Y": 0.08533229678869,
    "CMYK_K": 0.22036945819855
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0148",
    "Farbtonhilfsbezeichnung": "01.025.04",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "143",
    "Bcolor": "156",
    "Y": 31.1480140686035,
    "L": 62.6323852539063,
    "a": 15.0288820266724,
    "b": -2.83080148696899,
    "C": 15.2931594848633,
    "h": 349.332885742188,
    "CMY_C": 0.30996543169022,
    "CMY_M": 0.44066917896271,
    "CMY_Y": 0.3893900513649,
    "CMYK_C": 0,
    "CMYK_M": 0.18941622972488,
    "CMYK_Y": 0.11510238051414,
    "CMYK_K": 0.30996543169022
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0149",
    "Farbtonhilfsbezeichnung": "01.025.05",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "118",
    "Bcolor": "131",
    "Y": 20.7784862518311,
    "L": 52.7062110900879,
    "a": 14.207896232605,
    "b": -3.35402941703796,
    "C": 14.5984182357788,
    "h": 346.717468261719,
    "CMY_C": 0.42109000682831,
    "CMY_M": 0.53847992420197,
    "CMY_Y": 0.48675870895386,
    "CMYK_C": 0,
    "CMYK_M": 0.2027774900198,
    "CMYK_Y": 0.11343508213758,
    "CMYK_K": 0.42109000682831
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0150",
    "Farbtonhilfsbezeichnung": "01.025.06",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "95",
    "Bcolor": "109",
    "Y": 13.5974731445313,
    "L": 43.6500358581543,
    "a": 14.1685914993286,
    "b": -3.66819095611572,
    "C": 14.6357307434082,
    "h": 345.485046386719,
    "CMY_C": 0.51447904109955,
    "CMY_M": 0.62646508216858,
    "CMY_Y": 0.5737464427948,
    "CMYK_C": 0,
    "CMYK_M": 0.23065130412579,
    "CMYK_Y": 0.12206970900297,
    "CMYK_K": 0.51447904109955
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0151",
    "Farbtonhilfsbezeichnung": "01.026.01",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "207",
    "Bcolor": "216",
    "Y": 67.2188568115234,
    "L": 85.6143493652344,
    "a": 11.9699697494507,
    "b": -1.54498314857483,
    "C": 12.0692644119263,
    "h": 352.645416259766,
    "CMY_C": 0.07551395893097,
    "CMY_M": 0.18930542469025,
    "CMY_Y": 0.15435266494751,
    "CMYK_C": 0,
    "CMYK_M": 0.12308619171381,
    "CMYK_Y": 0.08527841418982,
    "CMYK_K": 0.07551395893097
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0152",
    "Farbtonhilfsbezeichnung": "01.026.02",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "188",
    "Bcolor": "203",
    "Y": 55.2474021911621,
    "L": 79.1835632324219,
    "a": 13.813928604126,
    "b": -4.16933584213257,
    "C": 14.4294137954712,
    "h": 343.205078125,
    "CMY_C": 0.14202851057053,
    "CMY_M": 0.26310956478119,
    "CMY_Y": 0.2051590681076,
    "CMYK_C": 0,
    "CMYK_M": 0.1411247998476,
    "CMYK_Y": 0.07358118146658,
    "CMYK_K": 0.14202851057053
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0153",
    "Farbtonhilfsbezeichnung": "01.026.03",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "164",
    "Bcolor": "185",
    "Y": 42.1474533081055,
    "L": 70.9724578857422,
    "a": 16.2305240631104,
    "b": -6.65040302276611,
    "C": 17.5401763916016,
    "h": 337.718811035156,
    "CMY_C": 0.22286123037338,
    "CMY_M": 0.3560254573822,
    "CMY_Y": 0.27541607618332,
    "CMYK_C": 0,
    "CMYK_M": 0.17135192453861,
    "CMYK_Y": 0.06762607395649,
    "CMYK_K": 0.22286123037338
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0154",
    "Farbtonhilfsbezeichnung": "01.026.04",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "141",
    "Bcolor": "165",
    "Y": 31.5503330230713,
    "L": 62.969482421875,
    "a": 19.2224731445313,
    "b": -7.59857177734375,
    "C": 20.6698265075684,
    "h": 338.431304931641,
    "CMY_C": 0.2920560836792,
    "CMY_M": 0.44682520627975,
    "CMY_Y": 0.35279679298401,
    "CMYK_C": 0,
    "CMYK_M": 0.21861776709557,
    "CMYK_Y": 0.08579875528812,
    "CMYK_K": 0.2920560836792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0155",
    "Farbtonhilfsbezeichnung": "01.026.05",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "114",
    "Bcolor": "137",
    "Y": 20.6038303375244,
    "L": 52.5131568908691,
    "a": 19.4541931152344,
    "b": -7.24250173568726,
    "C": 20.7586002349854,
    "h": 339.580474853516,
    "CMY_C": 0.40040826797485,
    "CMY_M": 0.55295264720917,
    "CMY_Y": 0.46240139007568,
    "CMYK_C": 0,
    "CMYK_M": 0.25441375374794,
    "CMYK_Y": 0.10339222103357,
    "CMYK_K": 0.40040826797485
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0156",
    "Farbtonhilfsbezeichnung": "01.026.06",
    "Farbtonklasse": "04",
    "Rcolor": "127",
    "Gcolor": "92",
    "Bcolor": "116",
    "Y": 13.4584217071533,
    "L": 43.4460067749023,
    "a": 18.4374675750732,
    "b": -8.11838817596436,
    "C": 20.145679473877,
    "h": 336.235137939453,
    "CMY_C": 0.50226259231567,
    "CMY_M": 0.63812255859375,
    "CMY_Y": 0.54690259695053,
    "CMYK_C": 0,
    "CMYK_M": 0.27295511960983,
    "CMYK_Y": 0.08968585729599,
    "CMYK_K": 0.50226259231567
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0157",
    "Farbtonhilfsbezeichnung": "01.027.01",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "213",
    "Bcolor": "224",
    "Y": 66.2864227294922,
    "L": 85.1423034667969,
    "a": 0.18995229899883,
    "b": -6.80260896682739,
    "C": 6.80526065826416,
    "h": 271.599487304688,
    "CMY_C": 0.18906086683273,
    "CMY_M": 0.16392374038696,
    "CMY_Y": 0.12276571989059,
    "CMYK_C": 0.07557290792465,
    "CMYK_M": 0.04691793397069,
    "CMYK_Y": 0,
    "CMYK_K": 0.12276571989059
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0158",
    "Farbtonhilfsbezeichnung": "01.027.02",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "198",
    "Bcolor": "213",
    "Y": 56.6619758605957,
    "L": 79.9890899658203,
    "a": 1.50640201568604,
    "b": -8.91980457305908,
    "C": 9.04611301422119,
    "h": 279.585815429688,
    "CMY_C": 0.24259746074677,
    "CMY_M": 0.22262585163116,
    "CMY_Y": 0.16384309530258,
    "CMYK_C": 0.09418611228466,
    "CMYK_M": 0.07030110806227,
    "CMYK_Y": 0,
    "CMYK_K": 0.16384309530258
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0159",
    "Farbtonhilfsbezeichnung": "01.027.03",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "177",
    "Bcolor": "197",
    "Y": 44.5566940307617,
    "L": 72.5990295410156,
    "a": 3.17550253868103,
    "b": -11.4917984008789,
    "C": 11.9224681854248,
    "h": 285.446960449219,
    "CMY_C": 0.31845617294312,
    "CMY_M": 0.30503189563751,
    "CMY_Y": 0.22553962469101,
    "CMYK_C": 0.11997585743666,
    "CMYK_M": 0.10264214128256,
    "CMYK_Y": 0,
    "CMYK_K": 0.22553962469101
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0160",
    "Farbtonhilfsbezeichnung": "01.027.04",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "152",
    "Bcolor": "172",
    "Y": 31.7657146453857,
    "L": 63.1487731933594,
    "a": 3.30518794059753,
    "b": -11.6838893890381,
    "C": 12.1423864364624,
    "h": 285.795379638672,
    "CMY_C": 0.4171684384346,
    "CMY_M": 0.40426635742188,
    "CMY_Y": 0.32482481002808,
    "CMYK_C": 0.13676987588406,
    "CMYK_M": 0.11766064167023,
    "CMYK_Y": 0,
    "CMYK_K": 0.32482481002808
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0161",
    "Farbtonhilfsbezeichnung": "01.027.05",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "127",
    "Bcolor": "152",
    "Y": 21.6110572814941,
    "L": 53.611873626709,
    "a": 4.50252151489258,
    "b": -14.4283390045166,
    "C": 15.1145515441895,
    "h": 287.331115722656,
    "CMY_C": 0.51593255996704,
    "CMY_M": 0.50295865535736,
    "CMY_Y": 0.4052842259407,
    "CMYK_C": 0.18605245649815,
    "CMYK_M": 0.16423715651035,
    "CMYK_Y": 0,
    "CMYK_K": 0.4052842259407
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0162",
    "Farbtonhilfsbezeichnung": "01.027.06",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "106",
    "Bcolor": "130",
    "Y": 14.7674589157104,
    "L": 45.3140335083008,
    "a": 4.01664924621582,
    "b": -14.2839088439941,
    "C": 14.837908744812,
    "h": 285.706024169922,
    "CMY_C": 0.6010080575943,
    "CMY_M": 0.58355110883713,
    "CMY_Y": 0.49042719602585,
    "CMYK_C": 0.21700699627399,
    "CMYK_M": 0.18274898827076,
    "CMYK_Y": 0,
    "CMYK_K": 0.49042719602585
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0163",
    "Farbtonhilfsbezeichnung": "01.028.01",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "222",
    "Bcolor": "227",
    "Y": 72.1529159545898,
    "L": 88.0421447753906,
    "a": -1.64733374118805,
    "b": -4.23188257217407,
    "C": 4.54120445251465,
    "h": 248.730651855469,
    "CMY_C": 0.16248202323914,
    "CMY_M": 0.12840610742569,
    "CMY_Y": 0.10980433225632,
    "CMYK_C": 0.05917540565133,
    "CMYK_M": 0.0208962764591,
    "CMYK_Y": 0,
    "CMYK_K": 0.10980433225632
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0164",
    "Farbtonhilfsbezeichnung": "01.028.02",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "194",
    "Bcolor": "207",
    "Y": 53.0144157409668,
    "L": 77.8835067749023,
    "a": -2.00366425514221,
    "b": -8.8604793548584,
    "C": 9.08420372009277,
    "h": 257.257720947266,
    "CMY_C": 0.29369753599167,
    "CMY_M": 0.23741549253464,
    "CMY_Y": 0.18765062093735,
    "CMYK_C": 0.13054348528385,
    "CMYK_M": 0.06126042827964,
    "CMYK_Y": 0,
    "CMYK_K": 0.18765062093735
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0165",
    "Farbtonhilfsbezeichnung": "01.028.03",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "174",
    "Bcolor": "188",
    "Y": 41.2414207458496,
    "L": 70.3447341918945,
    "a": -2.01953816413879,
    "b": -9.57390880584717,
    "C": 9.78459358215332,
    "h": 258.088531494141,
    "CMY_C": 0.37653380632401,
    "CMY_M": 0.31782048940659,
    "CMY_Y": 0.26383310556412,
    "CMYK_C": 0.15309123694897,
    "CMYK_M": 0.07333579659462,
    "CMYK_Y": 0,
    "CMYK_K": 0.26383310556412
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0166",
    "Farbtonhilfsbezeichnung": "01.028.04",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "152",
    "Bcolor": "171",
    "Y": 30.7578735351563,
    "L": 62.3027038574219,
    "a": -1.29258596897125,
    "b": -12.6500949859619,
    "C": 12.7159614562988,
    "h": 264.165771484375,
    "CMY_C": 0.46676260232925,
    "CMY_M": 0.40256547927856,
    "CMY_Y": 0.3275820016861,
    "CMYK_C": 0.20698523521423,
    "CMYK_M": 0.11151318997145,
    "CMYK_Y": 0,
    "CMYK_K": 0.3275820016861
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0167",
    "Farbtonhilfsbezeichnung": "01.028.05",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "135",
    "Bcolor": "154",
    "Y": 23.4986000061035,
    "L": 55.5822486877441,
    "a": -1.33073008060455,
    "b": -13.0404968261719,
    "C": 13.1082191467285,
    "h": 264.173370361328,
    "CMY_C": 0.53682243824005,
    "CMY_M": 0.47102320194244,
    "CMY_Y": 0.39487677812576,
    "CMYK_C": 0.23457315564156,
    "CMYK_M": 0.12583622336388,
    "CMYK_Y": 0,
    "CMYK_K": 0.39487677812576
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0168",
    "Farbtonhilfsbezeichnung": "01.028.06",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "107",
    "Bcolor": "129",
    "Y": 14.3601570129395,
    "L": 44.7450752258301,
    "a": 0.35153636336327,
    "b": -14.3446655273438,
    "C": 14.3489723205566,
    "h": 271.403839111328,
    "CMY_C": 0.63551366329193,
    "CMY_M": 0.58134615421295,
    "CMY_Y": 0.49606490135193,
    "CMYK_C": 0.2767196893692,
    "CMYK_M": 0.16923062503338,
    "CMYK_Y": 0,
    "CMYK_K": 0.49606490135193
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0169",
    "Farbtonhilfsbezeichnung": "01.029.01",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "228",
    "Bcolor": "232",
    "Y": 74.8062057495117,
    "L": 89.3021392822266,
    "a": -5.85045719146729,
    "b": -5.07846212387085,
    "C": 7.74716901779175,
    "h": 220.959457397461,
    "CMY_C": 0.18707674741745,
    "CMY_M": 0.1045463681221,
    "CMY_Y": 0.09014439582825,
    "CMYK_C": 0.1065359711647,
    "CMYK_M": 0.01582885533571,
    "CMYK_Y": 0,
    "CMYK_K": 0.09014439582825
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0170",
    "Farbtonhilfsbezeichnung": "01.029.02",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "208",
    "Bcolor": "217",
    "Y": 60.4804573059082,
    "L": 82.0986480712891,
    "a": -5.11372137069702,
    "b": -7.65943717956543,
    "C": 9.20962142944336,
    "h": 236.271484375,
    "CMY_C": 0.26970148086548,
    "CMY_M": 0.18499141931534,
    "CMY_Y": 0.15065759420395,
    "CMYK_C": 0.14016006886959,
    "CMYK_M": 0.04042400792241,
    "CMYK_Y": 0,
    "CMYK_K": 0.15065759420395
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0171",
    "Farbtonhilfsbezeichnung": "01.029.03",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "207",
    "Bcolor": "220",
    "Y": 58.9538040161133,
    "L": 81.2661972045898,
    "a": -6.5297703742981,
    "b": -10.5685901641846,
    "C": 12.4230833053589,
    "h": 238.290283203125,
    "CMY_C": 0.3035985827446,
    "CMY_M": 0.19010198116302,
    "CMY_Y": 0.13888645172119,
    "CMYK_C": 0.19127805531025,
    "CMYK_M": 0.059475928545,
    "CMYK_Y": 0,
    "CMYK_K": 0.13888645172119
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0172",
    "Farbtonhilfsbezeichnung": "01.029.04",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "186",
    "Bcolor": "199",
    "Y": 46.2916946411133,
    "L": 73.7344131469727,
    "a": -6.17421102523804,
    "b": -10.7128286361694,
    "C": 12.3646907806397,
    "h": 240.043518066406,
    "CMY_C": 0.38122606277466,
    "CMY_M": 0.27237927913666,
    "CMY_Y": 0.21987056732178,
    "CMYK_C": 0.20683169364929,
    "CMYK_M": 0.06730769574642,
    "CMYK_Y": 0,
    "CMYK_K": 0.21987056732178
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0173",
    "Farbtonhilfsbezeichnung": "01.029.05",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "161",
    "Bcolor": "176",
    "Y": 33.5867118835449,
    "L": 64.633186340332,
    "a": -5.18081760406494,
    "b": -11.7443475723267,
    "C": 12.8362989425659,
    "h": 246.196151733398,
    "CMY_C": 0.47189265489578,
    "CMY_M": 0.37043339014053,
    "CMY_Y": 0.30969232320786,
    "CMYK_C": 0.23496817052364,
    "CMYK_M": 0.08799129724503,
    "CMYK_Y": 0,
    "CMYK_K": 0.30969232320786
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0174",
    "Farbtonhilfsbezeichnung": "01.029.06",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "134",
    "Bcolor": "149",
    "Y": 21.9879035949707,
    "L": 54.0141677856445,
    "a": -6.76918792724609,
    "b": -12.3234367370606,
    "C": 14.0601921081543,
    "h": 241.220275878906,
    "CMY_C": 0.59605503082275,
    "CMY_M": 0.47607308626175,
    "CMY_Y": 0.41632694005966,
    "CMYK_C": 0.30792596936226,
    "CMYK_M": 0.1023623496294,
    "CMYK_Y": 0,
    "CMYK_K": 0.41632694005966
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0175",
    "Farbtonhilfsbezeichnung": "01.030.01",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "232",
    "Bcolor": "234",
    "Y": 77.747802734375,
    "L": 90.6646957397461,
    "a": -5.58892869949341,
    "b": -3.97455286979675,
    "C": 6.85807514190674,
    "h": 215.418441772461,
    "CMY_C": 0.16545778512955,
    "CMY_M": 0.09025692939758,
    "CMY_Y": 0.0831293463707,
    "CMYK_C": 0.08979286253452,
    "CMYK_M": 0.00777381518856,
    "CMYK_Y": 0,
    "CMYK_K": 0.0831293463707
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0176",
    "Farbtonhilfsbezeichnung": "01.030.02",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "203",
    "Bcolor": "209",
    "Y": 56.6359329223633,
    "L": 79.9743881225586,
    "a": -6.75337171554565,
    "b": -6.80666923522949,
    "C": 9.58847141265869,
    "h": 225.225204467773,
    "CMY_C": 0.30302101373672,
    "CMY_M": 0.20485228300095,
    "CMY_Y": 0.18023371696472,
    "CMYK_C": 0.14978329837322,
    "CMYK_M": 0.03003120049834,
    "CMYK_Y": 0,
    "CMYK_K": 0.18023371696472
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0177",
    "Farbtonhilfsbezeichnung": "01.030.03",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "183",
    "Bcolor": "193",
    "Y": 44.7807197570801,
    "L": 72.7472686767578,
    "a": -7.03558111190796,
    "b": -8.83574485778809,
    "C": 11.2946796417236,
    "h": 231.470977783203,
    "CMY_C": 0.39076328277588,
    "CMY_M": 0.28168594837189,
    "CMY_Y": 0.24389308691025,
    "CMYK_C": 0.1942452788353,
    "CMYK_M": 0.04998349025846,
    "CMYK_Y": 0,
    "CMYK_K": 0.24389308691025
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0178",
    "Farbtonhilfsbezeichnung": "01.030.04",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "157",
    "Bcolor": "170",
    "Y": 31.2693004608154,
    "L": 62.7343101501465,
    "a": -7.3737325668335,
    "b": -11.1058263778687,
    "C": 13.3308410644531,
    "h": 236.417755126953,
    "CMY_C": 0.50770211219788,
    "CMY_M": 0.38590085506439,
    "CMY_Y": 0.33429795503616,
    "CMYK_C": 0.26048314571381,
    "CMYK_M": 0.07751651108265,
    "CMYK_Y": 0,
    "CMYK_K": 0.33429795503616
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0179",
    "Farbtonhilfsbezeichnung": "01.030.05",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "133",
    "Bcolor": "147",
    "Y": 21.3328819274902,
    "L": 53.3119087219238,
    "a": -8.99698543548584,
    "b": -12.6199359893799,
    "C": 15.4986619949341,
    "h": 234.514236450195,
    "CMY_C": 0.62530899047852,
    "CMY_M": 0.47878134250641,
    "CMY_Y": 0.4217454791069,
    "CMYK_C": 0.35203099250793,
    "CMYK_M": 0.09863453358412,
    "CMYK_Y": 0,
    "CMYK_K": 0.4217454791069
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0180",
    "Farbtonhilfsbezeichnung": "01.030.06",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "110",
    "Bcolor": "125",
    "Y": 14.0619010925293,
    "L": 44.3215751647949,
    "a": -8.22513675689697,
    "b": -12.9148139953613,
    "C": 15.3116064071655,
    "h": 237.507904052734,
    "CMY_C": 0.70812338590622,
    "CMY_M": 0.56935214996338,
    "CMY_Y": 0.51028233766556,
    "CMYK_C": 0.4039900302887,
    "CMYK_M": 0.1206201389432,
    "CMYK_Y": 0,
    "CMYK_K": 0.51028233766556
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0181",
    "Farbtonhilfsbezeichnung": "01.031.01",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "204",
    "Bcolor": "209",
    "Y": 57.089542388916,
    "L": 80.2299346923828,
    "a": -7.57651996612549,
    "b": -6.27610445022583,
    "C": 9.83835029602051,
    "h": 219.637069702148,
    "CMY_C": 0.30516940355301,
    "CMY_M": 0.20043933391571,
    "CMY_Y": 0.1813787817955,
    "CMYK_C": 0.15121844410896,
    "CMYK_M": 0.02328372560441,
    "CMYK_Y": 0,
    "CMYK_K": 0.1813787817955
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0182",
    "Farbtonhilfsbezeichnung": "01.031.02",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "185",
    "Bcolor": "194",
    "Y": 44.782413482666,
    "L": 72.7483901977539,
    "a": -10.860312461853,
    "b": -9.58579063415527,
    "C": 14.4856405258179,
    "h": 221.433044433594,
    "CMY_C": 0.42864918708801,
    "CMY_M": 0.27351903915405,
    "CMY_Y": 0.23899894952774,
    "CMYK_C": 0.24921153485775,
    "CMYK_M": 0.04536142200232,
    "CMYK_Y": 0,
    "CMYK_K": 0.23899894952774
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0183",
    "Farbtonhilfsbezeichnung": "01.031.03",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "157",
    "Bcolor": "169",
    "Y": 30.8828182220459,
    "L": 62.4085884094238,
    "a": -10.6266250610352,
    "b": -11.2291679382324,
    "C": 15.4602518081665,
    "h": 226.579193115234,
    "CMY_C": 0.54165434837341,
    "CMY_M": 0.38279116153717,
    "CMY_Y": 0.33719974756241,
    "CMYK_C": 0.30847090482712,
    "CMYK_M": 0.06878605484962,
    "CMYK_Y": 0,
    "CMYK_K": 0.33719974756241
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0184",
    "Farbtonhilfsbezeichnung": "01.031.04",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "136",
    "Bcolor": "144",
    "Y": 21.6595115661621,
    "L": 53.6638679504395,
    "a": -13.4511680603027,
    "b": -10.1489067077637,
    "C": 16.8503475189209,
    "h": 217.034545898438,
    "CMY_C": 0.65210628509521,
    "CMY_M": 0.46768271923065,
    "CMY_Y": 0.43507570028305,
    "CMYK_C": 0.38417640328407,
    "CMYK_M": 0.05771927163005,
    "CMYK_Y": 0,
    "CMYK_K": 0.43507570028305
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0185",
    "Farbtonhilfsbezeichnung": "01.031.05",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "111",
    "Bcolor": "121",
    "Y": 13.8743553161621,
    "L": 44.0521965026855,
    "a": -11.7717618942261,
    "b": -11.0975570678711,
    "C": 16.1780757904053,
    "h": 223.311370849609,
    "CMY_C": 0.73590493202209,
    "CMY_M": 0.5662032365799,
    "CMY_Y": 0.52497351169586,
    "CMYK_C": 0.44404137134552,
    "CMYK_M": 0.08679457753897,
    "CMYK_Y": 0,
    "CMYK_K": 0.52497351169586
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0186",
    "Farbtonhilfsbezeichnung": "01.031.06",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "90",
    "Bcolor": "100",
    "Y": 9.06442832946777,
    "L": 36.1080474853516,
    "a": -10.0949726104736,
    "b": -9.8971471786499,
    "C": 14.1372556686401,
    "h": 224.433059692383,
    "CMY_C": 0.78815025091171,
    "CMY_M": 0.64577388763428,
    "CMY_Y": 0.60944384336472,
    "CMYK_C": 0.45756903290749,
    "CMYK_M": 0.09302131086588,
    "CMYK_Y": 0,
    "CMYK_K": 0.60944384336472
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0187",
    "Farbtonhilfsbezeichnung": "01.032.01",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "219",
    "Bcolor": "206",
    "Y": 64.6859359741211,
    "L": 84.3216400146484,
    "a": -14.8529615402222,
    "b": 1.21787023544312,
    "C": 14.9028072357178,
    "h": 175.312515258789,
    "CMY_C": 0.29410892724991,
    "CMY_M": 0.14217877388,
    "CMY_Y": 0.19222897291183,
    "CMYK_C": 0.17711167037487,
    "CMYK_M": 0,
    "CMYK_Y": 0.05834572389722,
    "CMYK_K": 0.14217877388
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0188",
    "Farbtonhilfsbezeichnung": "01.032.02",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "204",
    "Bcolor": "193",
    "Y": 54.7649803161621,
    "L": 78.9057006835938,
    "a": -16.3003368377686,
    "b": 0.40748280286789,
    "C": 16.3054294586182,
    "h": 178.567993164063,
    "CMY_C": 0.36836618185043,
    "CMY_M": 0.19861477613449,
    "CMY_Y": 0.24496650695801,
    "CMYK_C": 0.2118224799633,
    "CMYK_M": 0,
    "CMYK_Y": 0.05783951282501,
    "CMYK_K": 0.19861477613449
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0189",
    "Farbtonhilfsbezeichnung": "01.032.03",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "186",
    "Bcolor": "176",
    "Y": 43.9230728149414,
    "L": 72.1770477294922,
    "a": -17.4129447937012,
    "b": -0.32328400015831,
    "C": 17.4159450531006,
    "h": 181.063613891602,
    "CMY_C": 0.45245736837387,
    "CMY_M": 0.26923161745071,
    "CMY_Y": 0.31141048669815,
    "CMYK_C": 0.25073027610779,
    "CMYK_M": 0,
    "CMYK_Y": 0.05771851912141,
    "CMYK_K": 0.26923161745071
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0190",
    "Farbtonhilfsbezeichnung": "01.032.04",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "166",
    "Bcolor": "157",
    "Y": 33.110221862793,
    "L": 64.2500610351563,
    "a": -18.6813449859619,
    "b": -1.65303015708923,
    "C": 18.754337310791,
    "h": 185.056686401367,
    "CMY_C": 0.5524423122406,
    "CMY_M": 0.35091817378998,
    "CMY_Y": 0.38493311405182,
    "CMYK_C": 0.31047570705414,
    "CMYK_M": 0,
    "CMYK_Y": 0.05240470170975,
    "CMYK_K": 0.35091817378998
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0191",
    "Farbtonhilfsbezeichnung": "01.032.05",
    "Farbtonklasse": "02",
    "Rcolor": "76",
    "Gcolor": "139",
    "Bcolor": "131",
    "Y": 21.5780200958252,
    "L": 53.5763893127441,
    "a": -21.8548946380615,
    "b": -2.78042054176331,
    "C": 22.0310497283936,
    "h": 187.25032043457,
    "CMY_C": 0.70052492618561,
    "CMY_M": 0.45596432685852,
    "CMY_Y": 0.48601305484772,
    "CMYK_C": 0.44953045248985,
    "CMYK_M": 0,
    "CMYK_Y": 0.05523300915956,
    "CMYK_K": 0.45596432685852
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0192",
    "Farbtonhilfsbezeichnung": "01.032.06",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "114",
    "Bcolor": "107",
    "Y": 14.5644874572754,
    "L": 45.0318260192871,
    "a": -15.4286661148071,
    "b": -1.31139945983887,
    "C": 15.4842987060547,
    "h": 184.858322143555,
    "CMY_C": 0.70971143245697,
    "CMY_M": 0.55287039279938,
    "CMY_Y": 0.57888650894165,
    "CMYK_C": 0.35077309608459,
    "CMYK_M": 0,
    "CMYK_Y": 0.05818473175168,
    "CMYK_K": 0.55287039279938
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0193",
    "Farbtonhilfsbezeichnung": "01.033.01",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "238",
    "Bcolor": "210",
    "Y": 82.3744735717773,
    "L": 92.7398834228516,
    "a": -7.35126113891602,
    "b": 11.8566312789917,
    "C": 13.9506540298462,
    "h": 121.799430847168,
    "CMY_C": 0.10114759206772,
    "CMY_M": 0.06730288267136,
    "CMY_Y": 0.1781919002533,
    "CMYK_C": 0.03628692403436,
    "CMYK_M": 0,
    "CMYK_Y": 0.11889070272446,
    "CMYK_K": 0.06730288267136
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0194",
    "Farbtonhilfsbezeichnung": "01.033.02",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "227",
    "Bcolor": "200",
    "Y": 73.6439437866211,
    "L": 88.7539291381836,
    "a": -8.2837028503418,
    "b": 11.2500219345093,
    "C": 13.970781326294,
    "h": 126.365249633789,
    "CMY_C": 0.1546972990036,
    "CMY_M": 0.10962629318237,
    "CMY_Y": 0.21709018945694,
    "CMYK_C": 0.05062032490969,
    "CMYK_M": 0,
    "CMYK_Y": 0.12069527059793,
    "CMYK_K": 0.10962629318237
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0195",
    "Farbtonhilfsbezeichnung": "01.033.03",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "217",
    "Bcolor": "184",
    "Y": 65.6562728881836,
    "L": 84.8207855224609,
    "a": -11.2898149490356,
    "b": 13.8776359558106,
    "C": 17.8899059295654,
    "h": 129.129241943359,
    "CMY_C": 0.21353721618652,
    "CMY_M": 0.1473081111908,
    "CMY_Y": 0.27913129329681,
    "CMYK_C": 0.07767061889172,
    "CMYK_M": 0,
    "CMYK_Y": 0.15459650754929,
    "CMYK_K": 0.1473081111908
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0196",
    "Farbtonhilfsbezeichnung": "01.033.04",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "205",
    "Bcolor": "173",
    "Y": 57.0613441467285,
    "L": 80.2140884399414,
    "a": -12.5175857543945,
    "b": 13.0189123153687,
    "C": 18.060510635376,
    "h": 133.87532043457,
    "CMY_C": 0.27587169408798,
    "CMY_M": 0.19513320922852,
    "CMY_Y": 0.32181876897812,
    "CMYK_C": 0.10031285136938,
    "CMYK_M": 0,
    "CMYK_Y": 0.15739941596985,
    "CMYK_K": 0.19513320922852
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0197",
    "Farbtonhilfsbezeichnung": "01.033.05",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "184",
    "Bcolor": "151",
    "Y": 43.9697303771973,
    "L": 72.2082595825195,
    "a": -14.3106288909912,
    "b": 13.1181030273438,
    "C": 19.4133644104004,
    "h": 137.489501953125,
    "CMY_C": 0.37484788894653,
    "CMY_M": 0.27816140651703,
    "CMY_Y": 0.40610611438751,
    "CMYK_C": 0.13394473493099,
    "CMYK_M": 0,
    "CMYK_Y": 0.1772483587265,
    "CMYK_K": 0.27816140651703
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0198",
    "Farbtonhilfsbezeichnung": "01.033.06",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "172",
    "Bcolor": "141",
    "Y": 37.6081047058105,
    "L": 67.7307815551758,
    "a": -14.7623605728149,
    "b": 12.2399959564209,
    "C": 19.1766738891602,
    "h": 140.336669921875,
    "CMY_C": 0.42779719829559,
    "CMY_M": 0.32478672266006,
    "CMY_Y": 0.44569075107574,
    "CMYK_C": 0.15255990624428,
    "CMYK_M": 0,
    "CMYK_Y": 0.17906050384045,
    "CMYK_K": 0.32478672266006
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0199",
    "Farbtonhilfsbezeichnung": "01.034.01",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "212",
    "Bcolor": "174",
    "Y": 62.7615585327148,
    "L": 83.316764831543,
    "a": -9.0154333114624,
    "b": 17.1462326049805,
    "C": 19.3719215393066,
    "h": 117.735252380371,
    "CMY_C": 0.20250910520554,
    "CMY_M": 0.16952931880951,
    "CMY_Y": 0.31873798370361,
    "CMYK_C": 0.03971216082573,
    "CMYK_M": 0,
    "CMYK_Y": 0.17966759204865,
    "CMYK_K": 0.16952931880951
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0200",
    "Farbtonhilfsbezeichnung": "01.034.02",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "203",
    "Bcolor": "161",
    "Y": 57.2680892944336,
    "L": 80.3301467895508,
    "a": -8.99093341827393,
    "b": 19.6662788391113,
    "C": 21.6240463256836,
    "h": 114.568695068359,
    "CMY_C": 0.22801387310028,
    "CMY_M": 0.20281302928925,
    "CMY_Y": 0.36851584911346,
    "CMYK_C": 0.03161221370101,
    "CMYK_M": 0,
    "CMYK_Y": 0.20785941183567,
    "CMYK_K": 0.20281302928925
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0201",
    "Farbtonhilfsbezeichnung": "01.034.03",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "181",
    "Bcolor": "143",
    "Y": 43.8488655090332,
    "L": 72.1273651123047,
    "a": -9.93242931365967,
    "b": 17.7893180847168,
    "C": 20.3743209838867,
    "h": 119.176231384277,
    "CMY_C": 0.3282727599144,
    "CMY_M": 0.28892004489899,
    "CMY_Y": 0.43962156772614,
    "CMYK_C": 0.05534217879176,
    "CMYK_M": 0,
    "CMYK_Y": 0.2119332998991,
    "CMYK_K": 0.28892004489899
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0202",
    "Farbtonhilfsbezeichnung": "01.034.04",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "156",
    "Bcolor": "118",
    "Y": 31.2077617645264,
    "L": 62.6826362609863,
    "a": -10.2501459121704,
    "b": 18.2814559936523,
    "C": 20.9589385986328,
    "h": 119.278709411621,
    "CMY_C": 0.42819273471832,
    "CMY_M": 0.38783442974091,
    "CMY_Y": 0.53787189722061,
    "CMYK_C": 0.06592710316181,
    "CMYK_M": 0,
    "CMYK_Y": 0.2450929582119,
    "CMYK_K": 0.38783442974091
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0203",
    "Farbtonhilfsbezeichnung": "01.034.05",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "157",
    "Bcolor": "126",
    "Y": 31.4037857055664,
    "L": 62.8470306396484,
    "a": -11.1096200942993,
    "b": 14.144510269165,
    "C": 17.9858512878418,
    "h": 128.147399902344,
    "CMY_C": 0.44386613368988,
    "CMY_M": 0.38360124826431,
    "CMY_Y": 0.5075523853302,
    "CMYK_C": 0.09776932001114,
    "CMYK_M": 0,
    "CMYK_Y": 0.2010892033577,
    "CMYK_K": 0.38360124826431
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0204",
    "Farbtonhilfsbezeichnung": "01.034.06",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "129",
    "Bcolor": "98",
    "Y": 20.2114009857178,
    "L": 52.0753860473633,
    "a": -11.768385887146,
    "b": 14.881814956665,
    "C": 18.9727001190186,
    "h": 128.33659362793,
    "CMY_C": 0.555100440979,
    "CMY_M": 0.49265021085739,
    "CMY_Y": 0.61764001846313,
    "CMYK_C": 0.1230910718441,
    "CMYK_M": 0,
    "CMYK_Y": 0.24635824561119,
    "CMYK_K": 0.49265021085739
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0205",
    "Farbtonhilfsbezeichnung": "01.035.01",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "237",
    "Bcolor": "200",
    "Y": 83.3787231445313,
    "L": 93.1800003051758,
    "a": -5.15300846099854,
    "b": 17.6132354736328,
    "C": 18.3515548706055,
    "h": 106.307601928711,
    "CMY_C": 0.06204909086227,
    "CMY_M": 0.06877619028091,
    "CMY_Y": 0.2161580324173,
    "CMYK_C": 0,
    "CMYK_M": 0.00717212306336,
    "CMYK_Y": 0.1643038392067,
    "CMYK_K": 0.06204909086227
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0206",
    "Farbtonhilfsbezeichnung": "01.035.02",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "229",
    "Bcolor": "174",
    "Y": 75.9213027954102,
    "L": 89.8227920532227,
    "a": -8.38907337188721,
    "b": 26.1764259338379,
    "C": 27.4878482818604,
    "h": 107.769714355469,
    "CMY_C": 0.10173678398132,
    "CMY_M": 0.10085391998291,
    "CMY_Y": 0.31700676679611,
    "CMYK_C": 0.00098189164419,
    "CMYK_M": 0,
    "CMYK_Y": 0.2403979152441,
    "CMYK_K": 0.10085391998291
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0207",
    "Farbtonhilfsbezeichnung": "01.035.03",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "213",
    "Bcolor": "155",
    "Y": 64.0576324462891,
    "L": 83.9957656860352,
    "a": -9.04437828063965,
    "b": 27.8556537628174,
    "C": 29.2871685028076,
    "h": 107.987953186035,
    "CMY_C": 0.1676424741745,
    "CMY_M": 0.16423660516739,
    "CMY_Y": 0.39089101552963,
    "CMYK_C": 0.00407515931875,
    "CMYK_M": 0,
    "CMYK_Y": 0.27119445800781,
    "CMYK_K": 0.16423660516739
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0208",
    "Farbtonhilfsbezeichnung": "01.035.04",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "135",
    "Y": 55.6666564941406,
    "L": 79.4237213134766,
    "a": -10.9784212112427,
    "b": 31.9221534729004,
    "C": 33.7572174072266,
    "h": 108.978721618652,
    "CMY_C": 0.22313046455383,
    "CMY_M": 0.21080738306046,
    "CMY_Y": 0.46876090764999,
    "CMYK_C": 0.01561479549855,
    "CMYK_M": 0,
    "CMYK_Y": 0.32685750722885,
    "CMYK_K": 0.21080738306046
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0209",
    "Farbtonhilfsbezeichnung": "01.035.05",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "182",
    "Bcolor": "111",
    "Y": 43.679515838623,
    "L": 72.0137634277344,
    "a": -12.4749584197998,
    "b": 34.574821472168,
    "C": 36.756534576416,
    "h": 109.839973449707,
    "CMY_C": 0.3092594742775,
    "CMY_M": 0.28794944286346,
    "CMY_Y": 0.56358027458191,
    "CMYK_C": 0.02992769517004,
    "CMYK_M": 0,
    "CMYK_Y": 0.38709446787834,
    "CMYK_K": 0.28794944286346
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0210",
    "Farbtonhilfsbezeichnung": "01.035.06",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "162",
    "Bcolor": "100",
    "Y": 33.8893737792969,
    "L": 64.8746643066406,
    "a": -11.2214031219482,
    "b": 31.0285511016846,
    "C": 32.9953155517578,
    "h": 109.882400512695,
    "CMY_C": 0.38384860754013,
    "CMY_M": 0.36528438329697,
    "CMY_Y": 0.60741567611694,
    "CMYK_C": 0.02924809791148,
    "CMYK_M": 0,
    "CMYK_Y": 0.3814799785614,
    "CMYK_K": 0.36528438329697
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0211",
    "Farbtonhilfsbezeichnung": "01.036.01",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "212",
    "Bcolor": "166",
    "Y": 60.9139633178711,
    "L": 82.3324661254883,
    "a": -15.529899597168,
    "b": 19.8783397674561,
    "C": 25.2255058288574,
    "h": 127.998634338379,
    "CMY_C": 0.25632584095001,
    "CMY_M": 0.16715866327286,
    "CMY_Y": 0.35023987293243,
    "CMYK_C": 0.10706382244825,
    "CMYK_M": 0,
    "CMYK_Y": 0.21982723474503,
    "CMYK_K": 0.16715866327286
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0212",
    "Farbtonhilfsbezeichnung": "01.036.02",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "203",
    "Bcolor": "150",
    "Y": 53.3817939758301,
    "L": 78.0998764038086,
    "a": -19.9887962341309,
    "b": 22.3661212921143,
    "C": 29.9965896606445,
    "h": 131.78742980957,
    "CMY_C": 0.33048892021179,
    "CMY_M": 0.20512479543686,
    "CMY_Y": 0.41323429346085,
    "CMYK_C": 0.15771548449993,
    "CMYK_M": 0,
    "CMYK_Y": 0.261814057827,
    "CMYK_K": 0.20512479543686
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0213",
    "Farbtonhilfsbezeichnung": "01.036.03",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "186",
    "Bcolor": "129",
    "Y": 42.8122215270996,
    "L": 71.4273376464844,
    "a": -23.8642616271973,
    "b": 24.2571029663086,
    "C": 34.028076171875,
    "h": 134.532272338867,
    "CMY_C": 0.42734861373901,
    "CMY_M": 0.27051144838333,
    "CMY_Y": 0.49563974142075,
    "CMYK_C": 0.21499605476856,
    "CMYK_M": 0,
    "CMYK_Y": 0.30861112475395,
    "CMYK_K": 0.27051144838333
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0214",
    "Farbtonhilfsbezeichnung": "01.036.04",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "174",
    "Bcolor": "122",
    "Y": 36.9992179870605,
    "L": 67.2764434814453,
    "a": -22.7121486663818,
    "b": 22.2687530517578,
    "C": 31.8078460693359,
    "h": 135.56477355957,
    "CMY_C": 0.46665221452713,
    "CMY_M": 0.31667596101761,
    "CMY_Y": 0.52263021469116,
    "CMYK_C": 0.2194804251194,
    "CMYK_M": 0,
    "CMYK_Y": 0.30140057206154,
    "CMYK_K": 0.31667596101761
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0215",
    "Farbtonhilfsbezeichnung": "01.036.05",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "155",
    "Bcolor": "107",
    "Y": 28.4989032745361,
    "L": 60.3368148803711,
    "a": -20.7964591979981,
    "b": 20.8618316650391,
    "C": 29.4568958282471,
    "h": 134.910095214844,
    "CMY_C": 0.52581572532654,
    "CMY_M": 0.3928838968277,
    "CMY_Y": 0.5806405544281,
    "CMYK_C": 0.21895618736744,
    "CMYK_M": 0,
    "CMYK_Y": 0.30925989151001,
    "CMYK_K": 0.3928838968277
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0216",
    "Farbtonhilfsbezeichnung": "01.036.06",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "140",
    "Bcolor": "110",
    "Y": 23.673038482666,
    "L": 55.7589340209961,
    "a": -14.4378833770752,
    "b": 12.9954872131348,
    "C": 19.4251174926758,
    "h": 138.009735107422,
    "CMY_C": 0.5440901517868,
    "CMY_M": 0.45006692409515,
    "CMY_Y": 0.56982421875,
    "CMYK_C": 0.1709721237421,
    "CMYK_M": 0,
    "CMYK_Y": 0.21776703000069,
    "CMYK_K": 0.45006692409515
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0217",
    "Farbtonhilfsbezeichnung": "02.001.01",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "50",
    "Y": 64.3273773193359,
    "L": 84.1359329223633,
    "a": 7.2197413444519,
    "b": 76.0898895263672,
    "C": 76.431640625,
    "h": 84.5797576904297,
    "CMY_C": 0,
    "CMY_M": 0.20786279439926,
    "CMY_Y": 0.80321568250656,
    "CMYK_C": 0,
    "CMYK_M": 0.20786279439926,
    "CMYK_Y": 0.80321568250656,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0218",
    "Farbtonhilfsbezeichnung": "02.001.02",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "197",
    "Bcolor": "31",
    "Y": 61.6087036132813,
    "L": 82.7048873901367,
    "a": 9.33927154541016,
    "b": 79.7735366821289,
    "C": 80.318359375,
    "h": 83.3226470947266,
    "CMY_C": 0,
    "CMY_M": 0.22906947135925,
    "CMY_Y": 0.87786626815796,
    "CMYK_C": 0,
    "CMYK_M": 0.22906947135925,
    "CMYK_Y": 0.87786626815796,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0219",
    "Farbtonhilfsbezeichnung": "02.001.03",
    "Farbtonklasse": "04",
    "Rcolor": "249",
    "Gcolor": "184",
    "Bcolor": "0",
    "Y": 54.3208122253418,
    "L": 78.6484298706055,
    "a": 11.2529802322388,
    "b": 84.8979949951172,
    "C": 85.6405258178711,
    "h": 82.4496231079102,
    "CMY_C": 0.02511394023895,
    "CMY_M": 0.27785396575928,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2592508494854,
    "CMYK_Y": 1,
    "CMYK_K": 0.02511394023895
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0220",
    "Farbtonhilfsbezeichnung": "02.001.04",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "191",
    "Bcolor": "36",
    "Y": 57.1412582397461,
    "L": 80.2589797973633,
    "a": 7.22022294998169,
    "b": 76.1794891357422,
    "C": 76.5208892822266,
    "h": 84.5857315063477,
    "CMY_C": 0.03504920005798,
    "CMY_M": 0.249636054039,
    "CMY_Y": 0.85798317193985,
    "CMYK_C": 0,
    "CMYK_M": 0.22238112986088,
    "CMYK_Y": 0.85282480716705,
    "CMYK_K": 0.03504920005798
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0221",
    "Farbtonhilfsbezeichnung": "02.001.05",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "186",
    "Bcolor": "0",
    "Y": 55.2228202819824,
    "L": 79.1694412231445,
    "a": 10.5466957092285,
    "b": 87.7819061279297,
    "C": 88.4132080078125,
    "h": 83.1489486694336,
    "CMY_C": 0.02124208211899,
    "CMY_M": 0.27066141366959,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.25483250617981,
    "CMYK_Y": 1,
    "CMYK_K": 0.02124208211899
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0222",
    "Farbtonhilfsbezeichnung": "02.001.06",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "167",
    "Bcolor": "16",
    "Y": 42.3650054931641,
    "L": 71.1218490600586,
    "a": 7.3298716545105,
    "b": 71.8994750976563,
    "C": 72.2721328735352,
    "h": 84.1790313720703,
    "CMY_C": 0.14785867929459,
    "CMY_M": 0.34623557329178,
    "CMY_Y": 0.93548077344894,
    "CMYK_C": 0,
    "CMYK_M": 0.23279811441898,
    "CMYK_Y": 0.92428576946259,
    "CMYK_K": 0.14785867929459
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0223",
    "Farbtonhilfsbezeichnung": "02.002.01",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "177",
    "Bcolor": "72",
    "Y": 54.9321708679199,
    "L": 79.0021820068359,
    "a": 22.9744262695313,
    "b": 63.5476989746094,
    "C": 67.5731811523438,
    "h": 70.12353515625,
    "CMY_C": 0,
    "CMY_M": 0.30449253320694,
    "CMY_Y": 0.71733379364014,
    "CMYK_C": 0,
    "CMYK_M": 0.30449253320694,
    "CMYK_Y": 0.71733379364014,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0224",
    "Farbtonhilfsbezeichnung": "02.002.02",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "158",
    "Bcolor": "0",
    "Y": 47.150821685791,
    "L": 74.2861404418945,
    "a": 31.219181060791,
    "b": 83.3947372436523,
    "C": 89.0467300415039,
    "h": 69.4763946533203,
    "CMY_C": 0,
    "CMY_M": 0.38148069381714,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.38148069381714,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0225",
    "Farbtonhilfsbezeichnung": "02.002.03",
    "Farbtonklasse": "04",
    "Rcolor": "249",
    "Gcolor": "157",
    "Bcolor": "47",
    "Y": 44.2917213439941,
    "L": 72.4230575561523,
    "a": 26.9802856445313,
    "b": 66.6063232421875,
    "C": 71.8633270263672,
    "h": 67.9485626220703,
    "CMY_C": 0.02338916063309,
    "CMY_M": 0.38627368211746,
    "CMY_Y": 0.81697499752045,
    "CMYK_C": 0,
    "CMYK_M": 0.37157535552979,
    "CMYK_Y": 0.81259167194366,
    "CMYK_K": 0.02338916063309
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0226",
    "Farbtonhilfsbezeichnung": "02.002.04",
    "Farbtonklasse": "04",
    "Rcolor": "241",
    "Gcolor": "150",
    "Bcolor": "33",
    "Y": 40.6195373535156,
    "L": 69.9085311889648,
    "a": 26.8653202056885,
    "b": 68.5564880371094,
    "C": 73.6324462890625,
    "h": 68.6012115478516,
    "CMY_C": 0.05389648675919,
    "CMY_M": 0.41232109069824,
    "CMY_Y": 0.87161791324615,
    "CMYK_C": 0,
    "CMYK_M": 0.37884292006493,
    "CMYK_Y": 0.86430442333221,
    "CMYK_K": 0.05389648675919
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0227",
    "Farbtonhilfsbezeichnung": "02.002.05",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "143",
    "Bcolor": "11",
    "Y": 37.3027839660645,
    "L": 67.5035781860352,
    "a": 27.1239395141602,
    "b": 71.0426864624023,
    "C": 76.0445327758789,
    "h": 69.1032562255859,
    "CMY_C": 0.08083325624466,
    "CMY_M": 0.43820744752884,
    "CMY_Y": 0.95631217956543,
    "CMYK_C": 0,
    "CMYK_M": 0.38880234956741,
    "CMYK_Y": 0.9524701833725,
    "CMYK_K": 0.08083325624466
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0228",
    "Farbtonhilfsbezeichnung": "02.002.06",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "171",
    "Bcolor": "87",
    "Y": 49.1658096313477,
    "L": 75.5543670654297,
    "a": 19.8894195556641,
    "b": 52.3934364318848,
    "C": 56.0416030883789,
    "h": 69.21240234375,
    "CMY_C": 0.03764814138412,
    "CMY_M": 0.33082157373428,
    "CMY_Y": 0.65749287605286,
    "CMYK_C": 0,
    "CMYK_M": 0.30464264750481,
    "CMYK_Y": 0.6440936923027,
    "CMYK_K": 0.03764814138412
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0229",
    "Farbtonhilfsbezeichnung": "02.003.01",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "142",
    "Bcolor": "71",
    "Y": 40.5177726745605,
    "L": 69.8367309570313,
    "a": 36.9039840698242,
    "b": 54.3757019042969,
    "C": 65.7162170410156,
    "h": 55.8358421325684,
    "CMY_C": 0.00970005989075,
    "CMY_M": 0.44404125213623,
    "CMY_Y": 0.72351014614105,
    "CMYK_C": 0,
    "CMYK_M": 0.43859559297562,
    "CMYK_Y": 0.72080188989639,
    "CMYK_K": 0.00970005989075
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0230",
    "Farbtonhilfsbezeichnung": "02.003.02",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "149",
    "Bcolor": "88",
    "Y": 41.751594543457,
    "L": 70.6993179321289,
    "a": 31.0173854827881,
    "b": 46.2921752929688,
    "C": 55.7229194641113,
    "h": 56.1765251159668,
    "CMY_C": 0.03872030973434,
    "CMY_M": 0.41430395841599,
    "CMY_Y": 0.65315592288971,
    "CMYK_C": 0,
    "CMYK_M": 0.39071214199066,
    "CMYK_Y": 0.63918507099152,
    "CMYK_K": 0.03872030973434
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0231",
    "Farbtonhilfsbezeichnung": "02.003.03",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "124",
    "Bcolor": "70",
    "Y": 29.5898113250732,
    "L": 61.2986717224121,
    "a": 32.2849502563477,
    "b": 44.0194320678711,
    "C": 54.5896377563477,
    "h": 53.742748260498,
    "CMY_C": 0.14708119630814,
    "CMY_M": 0.51517331600189,
    "CMY_Y": 0.72589385509491,
    "CMYK_C": 0,
    "CMYK_M": 0.43156760931015,
    "CMYK_Y": 0.67862576246262,
    "CMYK_K": 0.14708119630814
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0232",
    "Farbtonhilfsbezeichnung": "02.003.04",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "127",
    "Bcolor": "18",
    "Y": 35.0797271728516,
    "L": 65.8106918334961,
    "a": 40.9148979187012,
    "b": 69.4465942382813,
    "C": 80.6030883789063,
    "h": 59.4952659606934,
    "CMY_C": 0.02941662073135,
    "CMY_M": 0.50206851959229,
    "CMY_Y": 0.92775148153305,
    "CMYK_C": 0,
    "CMYK_M": 0.48697713017464,
    "CMYK_Y": 0.92556178569794,
    "CMYK_K": 0.02941662073135
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0233",
    "Farbtonhilfsbezeichnung": "02.003.05",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "116",
    "Bcolor": "50",
    "Y": 29.1827735900879,
    "L": 60.9425926208496,
    "a": 39.0604820251465,
    "b": 53.7697944641113,
    "C": 66.4598541259766,
    "h": 54.0038757324219,
    "CMY_C": 0.10846102237701,
    "CMY_M": 0.54375952482224,
    "CMY_Y": 0.80489754676819,
    "CMYK_C": 0,
    "CMYK_M": 0.48825514316559,
    "CMYK_Y": 0.7811621427536,
    "CMYK_K": 0.10846102237701
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0234",
    "Farbtonhilfsbezeichnung": "02.003.06",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "115",
    "Bcolor": "36",
    "Y": 27.5376091003418,
    "L": 59.4686737060547,
    "a": 36.4545135498047,
    "b": 57.7575836181641,
    "C": 68.2998504638672,
    "h": 57.7413482666016,
    "CMY_C": 0.13765341043472,
    "CMY_M": 0.54985892772675,
    "CMY_Y": 0.85929477214813,
    "CMYK_C": 0,
    "CMYK_M": 0.47800445556641,
    "CMYK_Y": 0.83683449029922,
    "CMYK_K": 0.13765341043472
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0235",
    "Farbtonhilfsbezeichnung": "02.004.01",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "104",
    "Bcolor": "68",
    "Y": 28.6334896087646,
    "L": 60.4567947387695,
    "a": 50.2111511230469,
    "b": 44.9023475646973,
    "C": 67.3600845336914,
    "h": 41.8053245544434,
    "CMY_C": 0.06321704387665,
    "CMY_M": 0.59240651130676,
    "CMY_Y": 0.73327934741974,
    "CMYK_C": 0,
    "CMYK_M": 0.56490081548691,
    "CMYK_Y": 0.71528017520905,
    "CMYK_K": 0.06321704387665
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0236",
    "Farbtonhilfsbezeichnung": "02.004.02",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "78",
    "Bcolor": "47",
    "Y": 20.0300197601318,
    "L": 51.8711357116699,
    "a": 52.2682800292969,
    "b": 45.6436920166016,
    "C": 69.3925018310547,
    "h": 41.1293449401855,
    "CMY_C": 0.15909546613693,
    "CMY_M": 0.69358956813812,
    "CMY_Y": 0.81714475154877,
    "CMYK_C": 0,
    "CMYK_M": 0.63561803102493,
    "CMYK_Y": 0.78254932165146,
    "CMYK_K": 0.15909546613693
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0237",
    "Farbtonhilfsbezeichnung": "02.004.03",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "88",
    "Bcolor": "35",
    "Y": 23.4564266204834,
    "L": 55.5393943786621,
    "a": 51.7570877075195,
    "b": 54.9997406005859,
    "C": 75.5232925415039,
    "h": 46.7397766113281,
    "CMY_C": 0.11091923713684,
    "CMY_M": 0.65323621034622,
    "CMY_Y": 0.86117780208588,
    "CMYK_C": 0,
    "CMYK_M": 0.60997492074966,
    "CMYK_Y": 0.84385871887207,
    "CMYK_K": 0.11091923713684
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0238",
    "Farbtonhilfsbezeichnung": "02.004.04",
    "Farbtonklasse": "04",
    "Rcolor": "221",
    "Gcolor": "87",
    "Bcolor": "33",
    "Y": 22.3688926696777,
    "L": 54.4162368774414,
    "a": 50.1589241027832,
    "b": 54.4968147277832,
    "C": 74.0663223266602,
    "h": 47.3735008239746,
    "CMY_C": 0.13308280706406,
    "CMY_M": 0.6573857665062,
    "CMY_Y": 0.86898195743561,
    "CMYK_C": 0,
    "CMYK_M": 0.60479015111923,
    "CMYK_Y": 0.84886902570724,
    "CMYK_K": 0.13308280706406
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0239",
    "Farbtonhilfsbezeichnung": "02.004.05",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "81",
    "Bcolor": "48",
    "Y": 16.7260856628418,
    "L": 47.9130325317383,
    "a": 41.361499786377,
    "b": 39.3393821716309,
    "C": 57.0820503234863,
    "h": 43.5646438598633,
    "CMY_C": 0.2640118598938,
    "CMY_M": 0.68296039104462,
    "CMY_Y": 0.81109839677811,
    "CMYK_C": 0,
    "CMYK_M": 0.56923270225525,
    "CMYK_Y": 0.74333608150482,
    "CMYK_K": 0.2640118598938
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0240",
    "Farbtonhilfsbezeichnung": "02.004.06",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "65",
    "Bcolor": "49",
    "Y": 15.2848663330078,
    "L": 46.0219192504883,
    "a": 50.0920257568359,
    "b": 37.1997680664063,
    "C": 62.3941802978516,
    "h": 36.5986328125,
    "CMY_C": 0.24616247415543,
    "CMY_M": 0.74342048168182,
    "CMY_Y": 0.80886512994766,
    "CMYK_C": 0,
    "CMYK_M": 0.65963554382324,
    "CMYK_Y": 0.74645084142685,
    "CMYK_K": 0.24616247415543
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0241",
    "Farbtonhilfsbezeichnung": "02.005.01",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "69",
    "Bcolor": "58",
    "Y": 12.599648475647,
    "L": 42.1537170410156,
    "a": 39.708137512207,
    "b": 26.0247764587402,
    "C": 47.4765739440918,
    "h": 33.2408981323242,
    "CMY_C": 0.34948223829269,
    "CMY_M": 0.73126983642578,
    "CMY_Y": 0.77160251140594,
    "CMYK_C": 0,
    "CMYK_M": 0.58689802885056,
    "CMYK_Y": 0.64889889955521,
    "CMYK_K": 0.34948223829269
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0242",
    "Farbtonhilfsbezeichnung": "02.005.02",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "62",
    "Bcolor": "55",
    "Y": 10.4998979568481,
    "L": 38.7250747680664,
    "a": 38.3239898681641,
    "b": 23.2542591094971,
    "C": 44.827320098877,
    "h": 31.2485694885254,
    "CMY_C": 0.39761877059937,
    "CMY_M": 0.75876152515411,
    "CMY_Y": 0.78418749570847,
    "CMYK_C": 0,
    "CMYK_M": 0.59952527284622,
    "CMYK_Y": 0.64173436164856,
    "CMYK_K": 0.39761877059937
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0243",
    "Farbtonhilfsbezeichnung": "02.005.03",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "56",
    "Bcolor": "55",
    "Y": 5.47596263885498,
    "L": 28.0498867034912,
    "a": 17.0628356933594,
    "b": 7.23844718933105,
    "C": 18.5347099304199,
    "h": 22.9877738952637,
    "CMY_C": 0.63137125968933,
    "CMY_M": 0.78080558776855,
    "CMY_Y": 0.78326123952866,
    "CMYK_C": 0,
    "CMYK_M": 0.40537893772125,
    "CMYK_Y": 0.41204053163528,
    "CMYK_K": 0.63137125968933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0244",
    "Farbtonhilfsbezeichnung": "02.005.04",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "50",
    "Bcolor": "52",
    "Y": 5.03060245513916,
    "L": 26.8217735290527,
    "a": 21.6123390197754,
    "b": 7.50957584381104,
    "C": 22.8798370361328,
    "h": 19.1606540679932,
    "CMY_C": 0.62100040912628,
    "CMY_M": 0.80500221252441,
    "CMY_Y": 0.79464209079742,
    "CMYK_C": 0,
    "CMYK_M": 0.48549342155457,
    "CMYK_Y": 0.45815795660019,
    "CMYK_K": 0.62100040912628
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0245",
    "Farbtonhilfsbezeichnung": "02.005.05",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "49",
    "Bcolor": "52",
    "Y": 3.88872575759888,
    "L": 23.3001098632813,
    "a": 11.8695821762085,
    "b": 2.11880874633789,
    "C": 12.0572109222412,
    "h": 10.1211185455322,
    "CMY_C": 0.7114349603653,
    "CMY_M": 0.80772495269775,
    "CMY_Y": 0.79501283168793,
    "CMYK_C": 0,
    "CMYK_M": 0.33368557691574,
    "CMYK_Y": 0.28963270783424,
    "CMYK_K": 0.7114349603653
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0246",
    "Farbtonhilfsbezeichnung": "02.005.06",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "54",
    "Bcolor": "54",
    "Y": 4.34392595291138,
    "L": 24.7773303985596,
    "a": 9.6650857925415,
    "b": 3.27896070480347,
    "C": 10.206148147583,
    "h": 18.7399311065674,
    "CMY_C": 0.70703887939453,
    "CMY_M": 0.79000788927078,
    "CMY_Y": 0.78933906555176,
    "CMYK_C": 0,
    "CMYK_M": 0.28320825099945,
    "CMYK_Y": 0.28092527389526,
    "CMYK_K": 0.70703887939453
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0247",
    "Farbtonhilfsbezeichnung": "02.006.01",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "57",
    "Bcolor": "58",
    "Y": 13.4343309402466,
    "L": 43.4105186462402,
    "a": 50.9268188476563,
    "b": 28.6356239318848,
    "C": 58.4255065917969,
    "h": 29.3485984802246,
    "CMY_C": 0.27942264080048,
    "CMY_M": 0.77457773685455,
    "CMY_Y": 0.77398544549942,
    "CMYK_C": 0,
    "CMYK_M": 0.68716436624527,
    "CMYK_Y": 0.68634241819382,
    "CMYK_K": 0.27942264080048
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0248",
    "Farbtonhilfsbezeichnung": "02.006.02",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "49",
    "Bcolor": "45",
    "Y": 12.7624139785767,
    "L": 42.4030609130859,
    "a": 54.2788429260254,
    "b": 35.0246047973633,
    "C": 64.5981063842773,
    "h": 32.8330078125,
    "CMY_C": 0.27176362276077,
    "CMY_M": 0.80898904800415,
    "CMY_Y": 0.82359290122986,
    "CMYK_C": 0,
    "CMYK_M": 0.73770749568939,
    "CMYK_Y": 0.75776118040085,
    "CMYK_K": 0.27176362276077
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0249",
    "Farbtonhilfsbezeichnung": "02.006.03",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "53",
    "Bcolor": "49",
    "Y": 11.0436191558838,
    "L": 39.6538391113281,
    "a": 46.6653633117676,
    "b": 28.4126205444336,
    "C": 54.6345405578613,
    "h": 31.3355140686035,
    "CMY_C": 0.34391492605209,
    "CMY_M": 0.79107707738876,
    "CMY_Y": 0.80656349658966,
    "CMYK_C": 0,
    "CMYK_M": 0.68156123161316,
    "CMYK_Y": 0.70516550540924,
    "CMYK_K": 0.34391492605209
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0250",
    "Farbtonhilfsbezeichnung": "02.006.04",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "49",
    "Bcolor": "50",
    "Y": 9.62271213531494,
    "L": 37.1565933227539,
    "a": 44.7429504394531,
    "b": 24.3544998168945,
    "C": 50.9418601989746,
    "h": 28.5603542327881,
    "CMY_C": 0.38479691743851,
    "CMY_M": 0.80606663227081,
    "CMY_Y": 0.80275136232376,
    "CMYK_C": 0,
    "CMYK_M": 0.68476527929306,
    "CMYK_Y": 0.67937636375427,
    "CMYK_K": 0.38479691743851
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0251",
    "Farbtonhilfsbezeichnung": "02.006.05",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "46",
    "Bcolor": "51",
    "Y": 8,
    "L": 32.6565551757813,
    "a": 38.7956962585449,
    "b": 17.3465061187744,
    "C": 42.4971466064453,
    "h": 24.0905876159668,
    "CMY_C": 0.46872848272324,
    "CMY_M": 0.81979525089264,
    "CMY_Y": 0.79967439174652,
    "CMYK_C": 0,
    "CMYK_M": 0.6608048081398,
    "CMYK_Y": 0.62293177843094,
    "CMYK_K": 0.46872848272324
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0252",
    "Farbtonhilfsbezeichnung": "02.006.06",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "52",
    "Bcolor": "51",
    "Y": 6.98624038696289,
    "L": 31.7755661010742,
    "a": 31.7081966400146,
    "b": 15.9797677993774,
    "C": 35.5072212219238,
    "h": 26.7464275360107,
    "CMY_C": 0.51223826408386,
    "CMY_M": 0.79697370529175,
    "CMY_Y": 0.80063247680664,
    "CMYK_C": 0,
    "CMYK_M": 0.58375930786133,
    "CMYK_Y": 0.59126043319702,
    "CMYK_K": 0.51223826408386
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0253",
    "Farbtonhilfsbezeichnung": "02.007.01",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "63",
    "Bcolor": "83",
    "Y": 13.6785163879395,
    "L": 43.7683143615723,
    "a": 48.3895301818848,
    "b": 13.6014099121094,
    "C": 50.2647476196289,
    "h": 15.6997003555298,
    "CMY_C": 0.30124187469482,
    "CMY_M": 0.75226557254791,
    "CMY_Y": 0.67604577541351,
    "CMYK_C": 0,
    "CMYK_M": 0.64546471834183,
    "CMYK_Y": 0.53638577461243,
    "CMYK_K": 0.30124187469482
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0254",
    "Farbtonhilfsbezeichnung": "02.007.02",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "55",
    "Bcolor": "72",
    "Y": 11.8677864074707,
    "L": 41.0052108764648,
    "a": 48.9905662536621,
    "b": 16.2242851257324,
    "C": 51.6072006225586,
    "h": 18.3234043121338,
    "CMY_C": 0.32757186889648,
    "CMY_M": 0.78611838817596,
    "CMY_Y": 0.71733546257019,
    "CMYK_C": 0,
    "CMYK_M": 0.6819264292717,
    "CMYK_Y": 0.5796360373497,
    "CMYK_K": 0.32757186889648
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0255",
    "Farbtonhilfsbezeichnung": "02.007.03",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "75",
    "Bcolor": "87",
    "Y": 11.7128143310547,
    "L": 40.7559928894043,
    "a": 30.8098621368408,
    "b": 6.03535652160645,
    "C": 31.3954315185547,
    "h": 11.0833492279053,
    "CMY_C": 0.43255752325058,
    "CMY_M": 0.70572853088379,
    "CMY_Y": 0.65990054607391,
    "CMYK_C": 0,
    "CMYK_M": 0.48140740394592,
    "CMYK_Y": 0.40064504742622,
    "CMYK_K": 0.43255752325058
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0256",
    "Farbtonhilfsbezeichnung": "02.007.04",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "54",
    "Bcolor": "72",
    "Y": 8.16493988037109,
    "L": 34.3240585327148,
    "a": 35.7801856994629,
    "b": 6.28377199172974,
    "C": 36.3277778625488,
    "h": 9.96079635620117,
    "CMY_C": 0.47671258449554,
    "CMY_M": 0.78646600246429,
    "CMY_Y": 0.71924436092377,
    "CMYK_C": 0,
    "CMYK_M": 0.59193742275238,
    "CMYK_Y": 0.46347719430923,
    "CMYK_K": 0.47671258449554
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0257",
    "Farbtonhilfsbezeichnung": "02.007.05",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "50",
    "Bcolor": "68",
    "Y": 5.76704072952271,
    "L": 28.816951751709,
    "a": 27.8339653015137,
    "b": 0.01987135596573,
    "C": 27.8339729309082,
    "h": 0.04090486466885,
    "CMY_C": 0.5819593667984,
    "CMY_M": 0.80552554130554,
    "CMY_Y": 0.73252236843109,
    "CMYK_C": 0,
    "CMYK_M": 0.53479534387589,
    "CMYK_Y": 0.36016356945038,
    "CMYK_K": 0.5819593667984
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0258",
    "Farbtonhilfsbezeichnung": "02.007.06",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "55",
    "Bcolor": "71",
    "Y": 4.96569919586182,
    "L": 26.6368160247803,
    "a": 15.5951890945435,
    "b": -5.67409992218018,
    "C": 16.5953407287598,
    "h": 340.006774902344,
    "CMY_C": 0.67679512500763,
    "CMY_M": 0.78590208292007,
    "CMY_Y": 0.7202410697937,
    "CMYK_C": 0,
    "CMYK_M": 0.3375783264637,
    "CMYK_Y": 0.13442230224609,
    "CMYK_K": 0.67679512500763
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0259",
    "Farbtonhilfsbezeichnung": "02.008.01",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "102",
    "Bcolor": "142",
    "Y": 23.112419128418,
    "L": 55.1879425048828,
    "a": 41.8417015075684,
    "b": -5.88259601593018,
    "C": 42.2532005310059,
    "h": 351.997131347656,
    "CMY_C": 0.23609751462936,
    "CMY_M": 0.5986248254776,
    "CMY_Y": 0.44131910800934,
    "CMYK_C": 0,
    "CMYK_M": 0.47457274794579,
    "CMYK_Y": 0.26864895224571,
    "CMYK_K": 0.23609751462936
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0260",
    "Farbtonhilfsbezeichnung": "02.008.02",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "75",
    "Bcolor": "123",
    "Y": 16.9513053894043,
    "L": 48.1986236572266,
    "a": 50.2752456665039,
    "b": -4.76224946975708,
    "C": 50.5002899169922,
    "h": 354.588897705078,
    "CMY_C": 0.26734483242035,
    "CMY_M": 0.70747834444046,
    "CMY_Y": 0.51732724905014,
    "CMYK_C": 0,
    "CMYK_M": 0.60073763132095,
    "CMYK_Y": 0.34120064973831,
    "CMYK_K": 0.26734483242035
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0261",
    "Farbtonhilfsbezeichnung": "02.008.03",
    "Farbtonklasse": "04",
    "Rcolor": "160",
    "Gcolor": "74",
    "Bcolor": "117",
    "Y": 13.6492099761963,
    "L": 43.7255935668945,
    "a": 41.2381629943848,
    "b": -8.06407928466797,
    "C": 42.0192260742188,
    "h": 348.935485839844,
    "CMY_C": 0.37093991041183,
    "CMY_M": 0.71113592386246,
    "CMY_Y": 0.54162633419037,
    "CMYK_C": 0,
    "CMYK_M": 0.54080051183701,
    "CMYK_Y": 0.27133563160896,
    "CMYK_K": 0.37093991041183
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0262",
    "Farbtonhilfsbezeichnung": "02.008.04",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "63",
    "Bcolor": "109",
    "Y": 12.7916173934937,
    "L": 42.4475746154785,
    "a": 47.2275505065918,
    "b": -5.21903705596924,
    "C": 47.5150489807129,
    "h": 353.693939208984,
    "CMY_C": 0.3486505150795,
    "CMY_M": 0.75265645980835,
    "CMY_Y": 0.57110238075256,
    "CMYK_C": 0,
    "CMYK_M": 0.62025988101959,
    "CMYK_Y": 0.34152460098267,
    "CMYK_K": 0.3486505150795
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0263",
    "Farbtonhilfsbezeichnung": "02.008.05",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "60",
    "Bcolor": "97",
    "Y": 8.9820613861084,
    "L": 35.9497337341309,
    "a": 35.7658462524414,
    "b": -7.59581899642944,
    "C": 36.5635375976563,
    "h": 348.009887695313,
    "CMY_C": 0.4820499420166,
    "CMY_M": 0.7654954791069,
    "CMY_Y": 0.62022978067398,
    "CMYK_C": 0,
    "CMYK_M": 0.54724490642548,
    "CMYK_Y": 0.26678216457367,
    "CMYK_K": 0.4820499420166
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0264",
    "Farbtonhilfsbezeichnung": "02.008.06",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "59",
    "Bcolor": "88",
    "Y": 8.94975662231445,
    "L": 35.887378692627,
    "a": 36.0823974609375,
    "b": -2.1186375617981,
    "C": 36.1445426940918,
    "h": 356.6396484375,
    "CMY_C": 0.47112309932709,
    "CMY_M": 0.76958757638931,
    "CMY_Y": 0.65413308143616,
    "CMYK_C": 0,
    "CMYK_M": 0.56433635950089,
    "CMYK_Y": 0.3460351228714,
    "CMYK_K": 0.47112309932709
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0265",
    "Farbtonhilfsbezeichnung": "02.009.01",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "149",
    "Bcolor": "192",
    "Y": 32.2212677001953,
    "L": 63.5253372192383,
    "a": 12.0247755050659,
    "b": -22.0789375305176,
    "C": 25.1410961151123,
    "h": 298.573883056641,
    "CMY_C": 0.38797634840012,
    "CMY_M": 0.41739881038666,
    "CMY_Y": 0.24835133552551,
    "CMYK_C": 0.18575835227966,
    "CMYK_M": 0.2249022424221,
    "CMYK_Y": 0,
    "CMYK_K": 0.24835133552551
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0266",
    "Farbtonhilfsbezeichnung": "02.009.02",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "124",
    "Bcolor": "181",
    "Y": 22.9745178222656,
    "L": 55.0460777282715,
    "a": 17.2494831085205,
    "b": -29.0881786346436,
    "C": 33.8181419372559,
    "h": 300.668212890625,
    "CMY_C": 0.46694874763489,
    "CMY_M": 0.51369482278824,
    "CMY_Y": 0.29078793525696,
    "CMYK_C": 0.24838946759701,
    "CMYK_M": 0.31430217623711,
    "CMYK_Y": 0,
    "CMYK_K": 0.29078793525696
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0267",
    "Farbtonhilfsbezeichnung": "02.009.03",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "158",
    "Y": 14.3101501464844,
    "L": 44.6744804382324,
    "a": 20.9339408874512,
    "b": -31.9935150146484,
    "C": 38.2336883544922,
    "h": 303.197448730469,
    "CMY_C": 0.55895471572876,
    "CMY_M": 0.62348139286041,
    "CMY_Y": 0.38053810596466,
    "CMYK_C": 0.28801870346069,
    "CMYK_M": 0.39218440651894,
    "CMYK_Y": 0,
    "CMYK_K": 0.38053810596466
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0268",
    "Farbtonhilfsbezeichnung": "02.009.04",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "75",
    "Bcolor": "130",
    "Y": 8.80539512634277,
    "L": 35.6068801879883,
    "a": 20.0154361724854,
    "b": -29.2556076049805,
    "C": 35.4472618103027,
    "h": 304.378265380859,
    "CMY_C": 0.64341175556183,
    "CMY_M": 0.70740711688995,
    "CMY_Y": 0.49108755588531,
    "CMYK_C": 0.29931318759918,
    "CMYK_M": 0.42506241798401,
    "CMYK_Y": 0,
    "CMYK_K": 0.49108755588531
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0269",
    "Farbtonhilfsbezeichnung": "02.009.05",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "61",
    "Bcolor": "104",
    "Y": 5.85609197616577,
    "L": 29.0464553833008,
    "a": 17.1121616363525,
    "b": -23.5946712493896,
    "C": 29.1467761993408,
    "h": 305.951690673828,
    "CMY_C": 0.70179450511932,
    "CMY_M": 0.76169443130493,
    "CMY_Y": 0.59102565050125,
    "CMYK_C": 0.27084547281265,
    "CMYK_M": 0.41730925440788,
    "CMYK_Y": 0,
    "CMYK_K": 0.59102565050125
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0270",
    "Farbtonhilfsbezeichnung": "02.009.06",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "62",
    "Bcolor": "101",
    "Y": 5.7606315612793,
    "L": 28.8003463745117,
    "a": 13.688606262207,
    "b": -21.9142570495606,
    "C": 25.8381996154785,
    "h": 301.990692138672,
    "CMY_C": 0.7202450633049,
    "CMY_M": 0.75602829456329,
    "CMY_Y": 0.60382747650146,
    "CMYK_C": 0.29385578632355,
    "CMYK_M": 0.38417813181877,
    "CMYK_Y": 0,
    "CMYK_K": 0.60382747650146
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0271",
    "Farbtonhilfsbezeichnung": "02.010.01",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "196",
    "Bcolor": "225",
    "Y": 54.127628326416,
    "L": 78.5360946655273,
    "a": 0.29690417647362,
    "b": -17.6753959655762,
    "C": 17.6778888702393,
    "h": 270.962341308594,
    "CMY_C": 0.30546921491623,
    "CMY_M": 0.23272651433945,
    "CMY_Y": 0.11693781614304,
    "CMYK_C": 0.21349731087685,
    "CMYK_M": 0.13112179934978,
    "CMYK_Y": 0,
    "CMYK_K": 0.11693781614304
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0272",
    "Farbtonhilfsbezeichnung": "02.010.02",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "177",
    "Bcolor": "219",
    "Y": 42.9864120483398,
    "L": 71.5457458496094,
    "a": 0.76871699094772,
    "b": -25.0983867645264,
    "C": 25.1101570129395,
    "h": 271.754302978516,
    "CMY_C": 0.41334563493729,
    "CMY_M": 0.30606132745743,
    "CMY_Y": 0.14105904102325,
    "CMYK_C": 0.31700268387794,
    "CMYK_M": 0.19209969043732,
    "CMYK_Y": 0,
    "CMYK_K": 0.14105904102325
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0273",
    "Farbtonhilfsbezeichnung": "02.010.03",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "132",
    "Bcolor": "184",
    "Y": 22.6698093414307,
    "L": 54.7305946350098,
    "a": 2.84030413627625,
    "b": -31.6357536315918,
    "C": 31.7630004882813,
    "h": 275.130340576172,
    "CMY_C": 0.61083269119263,
    "CMY_M": 0.48179304599762,
    "CMY_Y": 0.27818143367767,
    "CMYK_C": 0.46085160970688,
    "CMYK_M": 0.28208142518997,
    "CMYK_Y": 0,
    "CMYK_K": 0.27818143367767
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0274",
    "Farbtonhilfsbezeichnung": "02.010.04",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "109",
    "Bcolor": "169",
    "Y": 15.0571765899658,
    "L": 45.7124061584473,
    "a": 5.16687488555908,
    "b": -37.1993942260742,
    "C": 37.556510925293,
    "h": 277.907592773438,
    "CMY_C": 0.72690904140472,
    "CMY_M": 0.57325524091721,
    "CMY_Y": 0.33667129278183,
    "CMYK_C": 0.58830219507217,
    "CMYK_M": 0.35666170716286,
    "CMYK_Y": 0,
    "CMYK_K": 0.33667129278183
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0275",
    "Farbtonhilfsbezeichnung": "02.010.05",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "86",
    "Bcolor": "142",
    "Y": 9.4099235534668,
    "L": 36.7618522644043,
    "a": 7.55841064453125,
    "b": -35.2697372436523,
    "C": 36.0705413818359,
    "h": 282.095703125,
    "CMY_C": 0.77988964319229,
    "CMY_M": 0.6639758348465,
    "CMY_Y": 0.44219076633453,
    "CMYK_C": 0.60540211200714,
    "CMYK_M": 0.39760020375252,
    "CMYK_Y": 0,
    "CMYK_K": 0.44219076633453
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0276",
    "Farbtonhilfsbezeichnung": "02.010.06",
    "Farbtonklasse": "04",
    "Rcolor": "37",
    "Gcolor": "71",
    "Bcolor": "129",
    "Y": 6.52900266647339,
    "L": 30.7096843719482,
    "a": 8.32957172393799,
    "b": -36.6656951904297,
    "C": 37.5999336242676,
    "h": 282.799011230469,
    "CMY_C": 0.85482442378998,
    "CMY_M": 0.72005432844162,
    "CMY_Y": 0.49488204717636,
    "CMYK_C": 0.71259075403214,
    "CMYK_M": 0.44578158855438,
    "CMYK_Y": 0,
    "CMYK_K": 0.49488204717636
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0277",
    "Farbtonhilfsbezeichnung": "02.011.01",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "198",
    "Bcolor": "226",
    "Y": 54.6798782348633,
    "L": 78.8565139770508,
    "a": -1.72061395645142,
    "b": -17.8943367004395,
    "C": 17.9768676757813,
    "h": 264.507659912109,
    "CMY_C": 0.32083714008331,
    "CMY_M": 0.22461307048798,
    "CMY_Y": 0.11203593015671,
    "CMYK_C": 0.23514601588249,
    "CMYK_M": 0.12678119540215,
    "CMYK_Y": 0,
    "CMYK_K": 0.11203593015671
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0278",
    "Farbtonhilfsbezeichnung": "02.011.02",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "159",
    "Bcolor": "208",
    "Y": 32.974250793457,
    "L": 64.1400527954102,
    "a": -1.7092512845993,
    "b": -30.3791999816895,
    "C": 30.42724609375,
    "h": 266.779724121094,
    "CMY_C": 0.54952597618103,
    "CMY_M": 0.37643200159073,
    "CMY_Y": 0.18545138835907,
    "CMYK_C": 0.44696483016014,
    "CMYK_M": 0.23446190357208,
    "CMYK_Y": 0,
    "CMYK_K": 0.18545138835907
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0279",
    "Farbtonhilfsbezeichnung": "02.011.03",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "125",
    "Bcolor": "175",
    "Y": 19.2416515350342,
    "L": 50.9687309265137,
    "a": -1.48074376583099,
    "b": -32.3670845031738,
    "C": 32.400936126709,
    "h": 267.380645751953,
    "CMY_C": 0.7060112953186,
    "CMY_M": 0.51003915071487,
    "CMY_Y": 0.31365960836411,
    "CMYK_C": 0.57165759801865,
    "CMYK_M": 0.28612557053566,
    "CMYK_Y": 0,
    "CMYK_K": 0.31365960836411
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0280",
    "Farbtonhilfsbezeichnung": "02.011.04",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "106",
    "Bcolor": "155",
    "Y": 13.6337385177612,
    "L": 43.7030220031738,
    "a": -0.22045594453812,
    "b": -32.247631072998,
    "C": 32.2483863830566,
    "h": 269.608306884766,
    "CMY_C": 0.77058851718903,
    "CMY_M": 0.58371019363403,
    "CMY_Y": 0.39060980081558,
    "CMYK_C": 0.62353926897049,
    "CMYK_M": 0.31687480211258,
    "CMYK_Y": 0,
    "CMYK_K": 0.39060980081558
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0281",
    "Farbtonhilfsbezeichnung": "02.011.05",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "85",
    "Bcolor": "135",
    "Y": 8.61962604522705,
    "L": 35.2413787841797,
    "a": 1.38020884990692,
    "b": -33.0307693481445,
    "C": 33.0595932006836,
    "h": 272.392730712891,
    "CMY_C": 0.85838091373444,
    "CMY_M": 0.66644620895386,
    "CMY_Y": 0.47230225801468,
    "CMYK_C": 0.73162841796875,
    "CMYK_M": 0.36790749430656,
    "CMYK_Y": 0,
    "CMYK_K": 0.47230225801468
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0282",
    "Farbtonhilfsbezeichnung": "02.011.06",
    "Farbtonklasse": "04",
    "Rcolor": "26",
    "Gcolor": "70",
    "Bcolor": "112",
    "Y": 5.73531150817871,
    "L": 28.7346076965332,
    "a": 0.92524200677872,
    "b": -29.0825805664063,
    "C": 29.0972957611084,
    "h": 271.822204589844,
    "CMY_C": 0.89714860916138,
    "CMY_M": 0.72648185491562,
    "CMY_Y": 0.56178736686707,
    "CMYK_C": 0.76529341936111,
    "CMYK_M": 0.37583234906197,
    "CMYK_Y": 0,
    "CMYK_K": 0.56178736686707
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0283",
    "Farbtonhilfsbezeichnung": "02.012.01",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "160",
    "Bcolor": "211",
    "Y": 31.8472080230713,
    "L": 63.2164001464844,
    "a": -7.66263437271118,
    "b": -33.9974670410156,
    "C": 34.8503036499023,
    "h": 257.298431396484,
    "CMY_C": 0.66355782747269,
    "CMY_M": 0.37239801883698,
    "CMY_Y": 0.17085635662079,
    "CMYK_C": 0.59422934055328,
    "CMYK_M": 0.24307207763195,
    "CMYK_Y": 0,
    "CMYK_K": 0.17085635662079
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0284",
    "Farbtonhilfsbezeichnung": "02.012.02",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "139",
    "Bcolor": "197",
    "Y": 22.8218116760254,
    "L": 54.8883247375488,
    "a": -8.45987987518311,
    "b": -39.1758003234863,
    "C": 40.0788345336914,
    "h": 257.814300537109,
    "CMY_C": 0.88472133874893,
    "CMY_M": 0.45432043075562,
    "CMY_Y": 0.22606986761093,
    "CMYK_C": 0.85104769468307,
    "CMYK_M": 0.29492399096489,
    "CMYK_Y": 0,
    "CMYK_K": 0.22606986761093
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0285",
    "Farbtonhilfsbezeichnung": "02.012.03",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "175",
    "Y": 15.7949075698853,
    "L": 46.7042579650879,
    "a": -8.15496158599854,
    "b": -38.9886856079102,
    "C": 39.8324127197266,
    "h": 258.186187744141,
    "CMY_C": 1,
    "CMY_M": 0.53668314218521,
    "CMY_Y": 0.31519377231598,
    "CMYK_C": 1,
    "CMYK_M": 0.32343363761902,
    "CMYK_Y": 0,
    "CMYK_K": 0.31519377231598
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0286",
    "Farbtonhilfsbezeichnung": "02.012.04",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "90",
    "Bcolor": "137",
    "Y": 8.8837947845459,
    "L": 35.7595901489258,
    "a": -5.96997833251953,
    "b": -34.0670890808105,
    "C": 34.5862274169922,
    "h": 260.060302734375,
    "CMY_C": 1,
    "CMY_M": 0.64771449565887,
    "CMY_Y": 0.46091943979263,
    "CMYK_C": 1,
    "CMYK_M": 0.34650674462318,
    "CMYK_Y": 0,
    "CMYK_K": 0.46091943979263
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0287",
    "Farbtonhilfsbezeichnung": "02.012.05",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "128",
    "Y": 8.20240688323975,
    "L": 34.4009170532227,
    "a": -5.91830968856812,
    "b": -30.0903606414795,
    "C": 30.6668586730957,
    "h": 258.872833251953,
    "CMY_C": 1,
    "CMY_M": 0.66211819648743,
    "CMY_Y": 0.4997666478157,
    "CMYK_C": 1,
    "CMYK_M": 0.32455164194107,
    "CMYK_Y": 0,
    "CMYK_K": 0.4997666478157
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0288",
    "Farbtonhilfsbezeichnung": "02.012.06",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "71",
    "Bcolor": "105",
    "Y": 5.77411270141602,
    "L": 28.8352661132813,
    "a": -2.16216087341309,
    "b": -24.8002586364746,
    "C": 24.8943328857422,
    "h": 265.017395019531,
    "CMY_C": 0.89042222499847,
    "CMY_M": 0.72169190645218,
    "CMY_Y": 0.58711779117584,
    "CMYK_C": 0.73460280895233,
    "CMYK_M": 0.32593828439713,
    "CMYK_Y": 0,
    "CMYK_K": 0.58711779117584
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0289",
    "Farbtonhilfsbezeichnung": "02.013.01",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "188",
    "Bcolor": "208",
    "Y": 45.2840042114258,
    "L": 73.0785064697266,
    "a": -13.8315124511719,
    "b": -16.698787689209,
    "C": 21.6831779479981,
    "h": 230.365234375,
    "CMY_C": 0.49360984563828,
    "CMY_M": 0.26182544231415,
    "CMY_Y": 0.18528896570206,
    "CMYK_C": 0.37844201922417,
    "CMYK_M": 0.09394309669733,
    "CMYK_Y": 0,
    "CMYK_K": 0.18528896570206
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0290",
    "Farbtonhilfsbezeichnung": "02.013.02",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "160",
    "Bcolor": "180",
    "Y": 31.1043567657471,
    "L": 62.5956230163574,
    "a": -13.4420204162598,
    "b": -17.2589874267578,
    "C": 21.8760261535645,
    "h": 232.087051391602,
    "CMY_C": 0.60443133115768,
    "CMY_M": 0.3735870718956,
    "CMY_Y": 0.29400360584259,
    "CMYK_C": 0.43970158696175,
    "CMYK_M": 0.11272503435612,
    "CMYK_Y": 0,
    "CMYK_K": 0.29400360584259
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0291",
    "Farbtonhilfsbezeichnung": "02.013.03",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "139",
    "Bcolor": "161",
    "Y": 22.6811180114746,
    "L": 54.7423477172852,
    "a": -12.664909362793,
    "b": -18.1524810791016,
    "C": 22.1339664459229,
    "h": 235.0966796875,
    "CMY_C": 0.6848908662796,
    "CMY_M": 0.45574676990509,
    "CMY_Y": 0.37029325962067,
    "CMYK_C": 0.49959382414818,
    "CMYK_M": 0.13570366799831,
    "CMYK_Y": 0,
    "CMYK_K": 0.37029325962067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0292",
    "Farbtonhilfsbezeichnung": "02.013.04",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "116",
    "Bcolor": "137",
    "Y": 15.1831369400024,
    "L": 45.8840141296387,
    "a": -11.8659639358521,
    "b": -18.1001796722412,
    "C": 21.6429576873779,
    "h": 236.752288818359,
    "CMY_C": 0.76902973651886,
    "CMY_M": 0.54595136642456,
    "CMY_Y": 0.46134632825851,
    "CMYK_C": 0.57120823860168,
    "CMYK_M": 0.15706759691238,
    "CMYK_Y": 0,
    "CMYK_K": 0.46134632825851
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0293",
    "Farbtonhilfsbezeichnung": "02.013.05",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "100",
    "Bcolor": "124",
    "Y": 11.1643238067627,
    "L": 39.8558654785156,
    "a": -9.51815319061279,
    "b": -19.0548992156982,
    "C": 21.2998695373535,
    "h": 243.457321166992,
    "CMY_C": 0.81148195266724,
    "CMY_M": 0.60834175348282,
    "CMY_Y": 0.51536679267883,
    "CMYK_C": 0.61100882291794,
    "CMYK_M": 0.19184604287148,
    "CMYK_Y": 0,
    "CMYK_K": 0.51536679267883
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0294",
    "Farbtonhilfsbezeichnung": "02.013.06",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "84",
    "Bcolor": "107",
    "Y": 7.82757759094238,
    "L": 33.6211853027344,
    "a": -8.07596111297607,
    "b": -18.1800651550293,
    "C": 19.8931121826172,
    "h": 246.048217773438,
    "CMY_C": 0.85136795043945,
    "CMY_M": 0.67000442743301,
    "CMY_Y": 0.58181470632553,
    "CMYK_C": 0.64457851648331,
    "CMYK_M": 0.21088671684265,
    "CMYK_Y": 0,
    "CMYK_K": 0.58181470632553
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0295",
    "Farbtonhilfsbezeichnung": "02.014.01",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "149",
    "Bcolor": "172",
    "Y": 23.3434944152832,
    "L": 55.4244003295898,
    "a": -31.6028556823731,
    "b": -23.9907913208008,
    "C": 39.677433013916,
    "h": 217.203353881836,
    "CMY_C": 1,
    "CMY_M": 0.41558259725571,
    "CMY_Y": 0.32523113489151,
    "CMYK_C": 1,
    "CMYK_M": 0.13389986753464,
    "CMYK_Y": 0,
    "CMYK_K": 0.32523113489151
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0296",
    "Farbtonhilfsbezeichnung": "02.014.02",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "121",
    "Bcolor": "141",
    "Y": 14.5760135650635,
    "L": 45.0479278564453,
    "a": -29.9991264343262,
    "b": -21.9519443511963,
    "C": 37.1730461120605,
    "h": 216.194900512695,
    "CMY_C": 1,
    "CMY_M": 0.52485847473145,
    "CMY_Y": 0.44601756334305,
    "CMYK_C": 1,
    "CMYK_M": 0.14231662452221,
    "CMYK_Y": 0,
    "CMYK_K": 0.44601756334305
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0297",
    "Farbtonhilfsbezeichnung": "02.014.03",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "113",
    "Y": 9.67121410369873,
    "L": 37.2457542419434,
    "a": -26.241491317749,
    "b": -16.9208202362061,
    "C": 31.2238693237305,
    "h": 212.814392089844,
    "CMY_C": 1,
    "CMY_M": 0.60870707035065,
    "CMY_Y": 0.55573523044586,
    "CMYK_C": 1,
    "CMYK_M": 0.11923484504223,
    "CMYK_Y": 0,
    "CMYK_K": 0.55573523044586
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0298",
    "Farbtonhilfsbezeichnung": "02.014.04",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "99",
    "Bcolor": "124",
    "Y": 9.83261585235596,
    "L": 37.5403251647949,
    "a": -19.8422889709473,
    "b": -22.8242092132568,
    "C": 30.2433624267578,
    "h": 228.997848510742,
    "CMY_C": 1,
    "CMY_M": 0.61296236515045,
    "CMY_Y": 0.51514422893524,
    "CMYK_C": 1,
    "CMYK_M": 0.20174688100815,
    "CMYK_Y": 0,
    "CMYK_K": 0.51514422893524
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0299",
    "Farbtonhilfsbezeichnung": "02.014.05",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "91",
    "Bcolor": "110",
    "Y": 8.85313415527344,
    "L": 35.6999740600586,
    "a": -13.8607654571533,
    "b": -17.4322967529297,
    "C": 22.2711868286133,
    "h": 231.511093139648,
    "CMY_C": 0.91910982131958,
    "CMY_M": 0.64131832122803,
    "CMY_Y": 0.56672728061676,
    "CMYK_C": 0.81330424547195,
    "CMYK_M": 0.17215725779533,
    "CMYK_Y": 0,
    "CMYK_K": 0.56672728061676
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0300",
    "Farbtonhilfsbezeichnung": "02.014.06",
    "Farbtonklasse": "04",
    "Rcolor": "7",
    "Gcolor": "76",
    "Bcolor": "95",
    "Y": 6.0176157951355,
    "L": 29.4568614959717,
    "a": -12.0633859634399,
    "b": -17.1482791900635,
    "C": 20.9663715362549,
    "h": 234.874572753906,
    "CMY_C": 0.97409254312515,
    "CMY_M": 0.70242142677307,
    "CMY_Y": 0.62825286388397,
    "CMYK_C": 0.93030893802643,
    "CMYK_M": 0.19951348006725,
    "CMYK_Y": 0,
    "CMYK_K": 0.62825286388397
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0301",
    "Farbtonhilfsbezeichnung": "02.015.01",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "87",
    "Bcolor": "73",
    "Y": 9.66253471374512,
    "L": 37.2298202514648,
    "a": 1.0857470035553,
    "b": 8.58872032165527,
    "C": 8.65707588195801,
    "h": 82.7951431274414,
    "CMY_C": 0.62800431251526,
    "CMY_M": 0.66035425662994,
    "CMY_Y": 0.71276199817657,
    "CMYK_C": 0,
    "CMYK_M": 0.08696322143078,
    "CMYK_Y": 0.22784587740898,
    "CMYK_K": 0.62800431251526
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0302",
    "Farbtonhilfsbezeichnung": "02.015.02",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "79",
    "Bcolor": "66",
    "Y": 8.33156108856201,
    "L": 34.6640739440918,
    "a": 3.32308793067932,
    "b": 9.28285026550293,
    "C": 9.85972690582275,
    "h": 70.3035736083984,
    "CMY_C": 0.63771283626556,
    "CMY_M": 0.68891263008118,
    "CMY_Y": 0.7397745847702,
    "CMYK_C": 0,
    "CMYK_M": 0.14132378995419,
    "CMYK_Y": 0.28171506524086,
    "CMYK_K": 0.63771283626556
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0303",
    "Farbtonhilfsbezeichnung": "02.015.03",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "67",
    "Bcolor": "60",
    "Y": 5.68989610671997,
    "L": 28.6162185668945,
    "a": 1.49479484558105,
    "b": 4.62720441818237,
    "C": 4.86265707015991,
    "h": 72.0972137451172,
    "CMY_C": 0.71465742588043,
    "CMY_M": 0.7391277551651,
    "CMY_Y": 0.76508712768555,
    "CMYK_C": 0,
    "CMYK_M": 0.08575772494078,
    "CMYK_Y": 0.17673388123512,
    "CMYK_K": 0.71465742588043
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0304",
    "Farbtonhilfsbezeichnung": "02.015.04",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "84",
    "Bcolor": "70",
    "Y": 8.7769193649292,
    "L": 35.5511894226074,
    "a": -2.45235657691956,
    "b": 8.39885330200195,
    "C": 8.74955940246582,
    "h": 106.277122497559,
    "CMY_C": 0.66629099845886,
    "CMY_M": 0.66897165775299,
    "CMY_Y": 0.7271933555603,
    "CMYK_C": 0,
    "CMYK_M": 0.00803292449564,
    "CMYK_Y": 0.18250139057636,
    "CMYK_K": 0.66629099845886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0305",
    "Farbtonhilfsbezeichnung": "02.015.05",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "83",
    "Bcolor": "69",
    "Y": 8.81382465362549,
    "L": 35.6233406066895,
    "a": 0.06244154274464,
    "b": 8.61024188995361,
    "C": 8.6104679107666,
    "h": 89.5844955444336,
    "CMY_C": 0.64948129653931,
    "CMY_M": 0.67325174808502,
    "CMY_Y": 0.72750860452652,
    "CMYK_C": 0,
    "CMYK_M": 0.06781507283449,
    "CMYK_Y": 0.22260525822639,
    "CMYK_K": 0.64948129653931
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0306",
    "Farbtonhilfsbezeichnung": "02.015.06",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "66",
    "Bcolor": "57",
    "Y": 5.4713921546936,
    "L": 28.0376262664795,
    "a": 0.70712870359421,
    "b": 5.98126792907715,
    "C": 6.02292251586914,
    "h": 83.257568359375,
    "CMY_C": 0.72159123420715,
    "CMY_M": 0.7430277466774,
    "CMY_Y": 0.77829122543335,
    "CMYK_C": 0,
    "CMYK_M": 0.07699654251337,
    "CMYK_Y": 0.20365734398365,
    "CMYK_K": 0.72159123420715
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0307",
    "Farbtonhilfsbezeichnung": "02.016.01",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "135",
    "Bcolor": "88",
    "Y": 18.3546733856201,
    "L": 49.9234924316406,
    "a": -40.5754470825195,
    "b": 16.6637935638428,
    "C": 43.8639831542969,
    "h": 157.672698974609,
    "CMY_C": 0.88774824142456,
    "CMY_M": 0.46969205141068,
    "CMY_Y": 0.65411877632141,
    "CMYK_C": 0.78832721710205,
    "CMYK_M": 0,
    "CMYK_Y": 0.34777289628983,
    "CMYK_K": 0.46969205141068
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0308",
    "Farbtonhilfsbezeichnung": "02.016.02",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "132",
    "Bcolor": "88",
    "Y": 17.8382568359375,
    "L": 49.2993392944336,
    "a": -34.7758407592773,
    "b": 15.765869140625,
    "C": 38.1827430725098,
    "h": 155.612503051758,
    "CMY_C": 0.79689025878906,
    "CMY_M": 0.48380362987518,
    "CMY_Y": 0.65313494205475,
    "CMYK_C": 0.60652619600296,
    "CMYK_M": 0,
    "CMYK_Y": 0.3280366063118,
    "CMYK_K": 0.48380362987518
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0309",
    "Farbtonhilfsbezeichnung": "02.016.03",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "70",
    "Y": 12.6168909072876,
    "L": 42.180233001709,
    "a": -42.2657279968262,
    "b": 16.4572124481201,
    "C": 45.3567161560059,
    "h": 158.725311279297,
    "CMY_C": 1,
    "CMY_M": 0.54670608043671,
    "CMY_Y": 0.72451090812683,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.39225062727928,
    "CMYK_K": 0.54670608043671
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0310",
    "Farbtonhilfsbezeichnung": "02.016.04",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "111",
    "Bcolor": "84",
    "Y": 11.9357194900513,
    "L": 41.1137733459473,
    "a": -34.3775634765625,
    "b": 6.72357225418091,
    "C": 35.0288925170898,
    "h": 168.933776855469,
    "CMY_C": 1,
    "CMY_M": 0.56547486782074,
    "CMY_Y": 0.66967594623566,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.23980449140072,
    "CMYK_K": 0.56547486782074
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0311",
    "Farbtonhilfsbezeichnung": "02.016.05",
    "Farbtonklasse": "04",
    "Rcolor": "29",
    "Gcolor": "92",
    "Bcolor": "69",
    "Y": 8.32346057891846,
    "L": 34.6476516723633,
    "a": -25.8747406005859,
    "b": 6.86448764801025,
    "C": 26.7698230743408,
    "h": 165.141891479492,
    "CMY_C": 0.88578635454178,
    "CMY_M": 0.63980042934418,
    "CMY_Y": 0.72857999801636,
    "CMYK_C": 0.68291562795639,
    "CMYK_M": 0,
    "CMYK_Y": 0.24647328257561,
    "CMYK_K": 0.63980042934418
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0312",
    "Farbtonhilfsbezeichnung": "02.016.06",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "77",
    "Bcolor": "65",
    "Y": 6.36435222625732,
    "L": 30.3136920928955,
    "a": -11.9740114212036,
    "b": 3.48929858207703,
    "C": 12.4720544815063,
    "h": 163.753570556641,
    "CMY_C": 0.79460251331329,
    "CMY_M": 0.69987893104553,
    "CMY_Y": 0.74490904808044,
    "CMYK_C": 0.31561788916588,
    "CMYK_M": 0,
    "CMYK_Y": 0.15003983676434,
    "CMYK_K": 0.69987893104553
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0313",
    "Farbtonhilfsbezeichnung": "02.017.01",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "132",
    "Bcolor": "67",
    "Y": 19.8972644805908,
    "L": 51.7208518981934,
    "a": -22.1396427154541,
    "b": 31.4231834411621,
    "C": 38.4393043518066,
    "h": 125.167152404785,
    "CMY_C": 0.59684216976166,
    "CMY_M": 0.48061227798462,
    "CMY_Y": 0.73800587654114,
    "CMYK_C": 0.22378252446651,
    "CMYK_M": 0,
    "CMYK_Y": 0.49557119607925,
    "CMYK_K": 0.48061227798462
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0314",
    "Farbtonhilfsbezeichnung": "02.017.02",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "130",
    "Bcolor": "73",
    "Y": 18.7791996002197,
    "L": 50.4278678894043,
    "a": -23.9206695556641,
    "b": 26.3873996734619,
    "C": 35.6159133911133,
    "h": 132.192886352539,
    "CMY_C": 0.63500118255615,
    "CMY_M": 0.49013364315033,
    "CMY_Y": 0.71417957544327,
    "CMYK_C": 0.28412845730782,
    "CMYK_M": 0,
    "CMYK_Y": 0.4394209086895,
    "CMYK_K": 0.49013364315033
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0315",
    "Farbtonhilfsbezeichnung": "02.017.03",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "115",
    "Bcolor": "67",
    "Y": 14.530047416687,
    "L": 44.9836845397949,
    "a": -21.3382244110107,
    "b": 22.7099018096924,
    "C": 31.1618270874023,
    "h": 133.216369628906,
    "CMY_C": 0.67639231681824,
    "CMY_M": 0.54816710948944,
    "CMY_Y": 0.7381956577301,
    "CMYK_C": 0.28378900885582,
    "CMYK_M": 0,
    "CMYK_Y": 0.42057263851166,
    "CMYK_K": 0.54816710948944
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0316",
    "Farbtonhilfsbezeichnung": "02.017.04",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "111",
    "Bcolor": "68",
    "Y": 13.0195350646973,
    "L": 42.792667388916,
    "a": -25.0618629455566,
    "b": 18.9493026733398,
    "C": 31.4193096160889,
    "h": 142.907043457031,
    "CMY_C": 0.73966574668884,
    "CMY_M": 0.56359440088272,
    "CMY_Y": 0.73325020074844,
    "CMYK_C": 0.40345802903175,
    "CMYK_M": 0,
    "CMYK_Y": 0.38875716924667,
    "CMYK_K": 0.56359440088272
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0317",
    "Farbtonhilfsbezeichnung": "02.017.05",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "99",
    "Bcolor": "61",
    "Y": 10.4778995513916,
    "L": 38.6868286132813,
    "a": -20.6583118438721,
    "b": 17.9097709655762,
    "C": 27.3409175872803,
    "h": 139.076263427734,
    "CMY_C": 0.74323987960815,
    "CMY_M": 0.61006087064743,
    "CMY_Y": 0.76254796981812,
    "CMYK_C": 0.3415379524231,
    "CMYK_M": 0,
    "CMYK_Y": 0.39105358719826,
    "CMYK_K": 0.61006087064743
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0318",
    "Farbtonhilfsbezeichnung": "02.017.06",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "92",
    "Bcolor": "64",
    "Y": 9.43637752532959,
    "L": 36.8112449645996,
    "a": -13.4227161407471,
    "b": 13.688798904419,
    "C": 19.1716594696045,
    "h": 134.437698364258,
    "CMY_C": 0.71596598625183,
    "CMY_M": 0.63868916034698,
    "CMY_Y": 0.75080871582031,
    "CMYK_C": 0.21387906372547,
    "CMYK_M": 0,
    "CMYK_Y": 0.31031328439713,
    "CMYK_K": 0.63868916034698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0319",
    "Farbtonhilfsbezeichnung": "02.018.01",
    "Farbtonklasse": "02",
    "Rcolor": "67",
    "Gcolor": "67",
    "Bcolor": "70",
    "Y": 5.6451153755188,
    "L": 28.4988613128662,
    "a": 0.94772899150848,
    "b": -1.99301421642303,
    "C": 2.20687460899353,
    "h": 295.432281494141,
    "CMY_C": 0.73606890439987,
    "CMY_M": 0.73761409521103,
    "CMY_Y": 0.72681367397308,
    "CMYK_C": 0.03387882187963,
    "CMYK_M": 0.0395350009203,
    "CMYK_Y": 0,
    "CMYK_K": 0.72681367397308
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0320",
    "Farbtonhilfsbezeichnung": "02.018.02",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "61",
    "Bcolor": "59",
    "Y": 4.93276309967041,
    "L": 26.5423431396484,
    "a": 3.55712509155273,
    "b": 2.04796409606934,
    "C": 4.10454559326172,
    "h": 29.9305725097656,
    "CMY_C": 0.72721230983734,
    "CMY_M": 0.7611009478569,
    "CMY_Y": 0.76766723394394,
    "CMYK_C": 0,
    "CMYK_M": 0.12423081696033,
    "CMYK_Y": 0.14830186963081,
    "CMYK_K": 0.72721230983734
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0321",
    "Farbtonhilfsbezeichnung": "02.018.03",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "69",
    "Bcolor": "65",
    "Y": 6.53243064880371,
    "L": 30.7178573608398,
    "a": 5.07318878173828,
    "b": 4.37166023254395,
    "C": 6.6969141960144,
    "h": 40.752082824707,
    "CMY_C": 0.67491137981415,
    "CMY_M": 0.7275367975235,
    "CMY_Y": 0.74460792541504,
    "CMYK_C": 0,
    "CMYK_M": 0.16188022494316,
    "CMYK_Y": 0.21439245343208,
    "CMYK_K": 0.67491137981415
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0322",
    "Farbtonhilfsbezeichnung": "02.018.04",
    "Farbtonklasse": "02",
    "Rcolor": "55",
    "Gcolor": "56",
    "Bcolor": "57",
    "Y": 3.90763282775879,
    "L": 23.3637027740479,
    "a": 0.15138304233551,
    "b": -1.11977827548981,
    "C": 1.12996470928192,
    "h": 277.699157714844,
    "CMY_C": 0.7838693857193,
    "CMY_M": 0.78158664703369,
    "CMY_Y": 0.77722865343094,
    "CMYK_C": 0.02980963326991,
    "CMYK_M": 0.01956262998283,
    "CMYK_Y": 0,
    "CMYK_K": 0.77722865343094
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0323",
    "Farbtonhilfsbezeichnung": "02.018.05",
    "Farbtonklasse": "02",
    "Rcolor": "53",
    "Gcolor": "52",
    "Bcolor": "51",
    "Y": 3.43597865104675,
    "L": 21.7115840911865,
    "a": 0.5457056760788,
    "b": 0.12370137125254,
    "C": 0.55955046415329,
    "h": 12.7720499038696,
    "CMY_C": 0.7923476099968,
    "CMY_M": 0.79686188697815,
    "CMY_Y": 0.79850453138351,
    "CMYK_C": 0,
    "CMYK_M": 0.02173958532512,
    "CMYK_Y": 0.02965013496578,
    "CMYK_K": 0.7923476099968
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0324",
    "Farbtonhilfsbezeichnung": "02.018.06",
    "Farbtonklasse": "02",
    "Rcolor": "43",
    "Gcolor": "43",
    "Bcolor": "43",
    "Y": 2.41258192062378,
    "L": 17.5185585021973,
    "a": -0.09473966807127,
    "b": -0.42489412426949,
    "C": 0.43532818555832,
    "h": 257.430236816406,
    "CMY_C": 0.83315169811249,
    "CMY_M": 0.83107596635818,
    "CMY_Y": 0.83074122667313,
    "CMYK_C": 0.01424133777618,
    "CMYK_M": 0.00197768001817,
    "CMYK_Y": 0,
    "CMYK_K": 0.83074122667313
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0325",
    "Farbtonhilfsbezeichnung": "02.019.01",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "219",
    "Bcolor": "68",
    "Y": 69.41796875,
    "L": 86.7106018066406,
    "a": -9.64174365997314,
    "b": 71.8165054321289,
    "C": 72.4608459472656,
    "h": 97.6465377807617,
    "CMY_C": 0.06840866804123,
    "CMY_M": 0.13938701152802,
    "CMY_Y": 0.73265302181244,
    "CMYK_C": 0,
    "CMYK_M": 0.07619042694569,
    "CMYK_Y": 0.71302115917206,
    "CMYK_K": 0.06840866804123
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0326",
    "Farbtonhilfsbezeichnung": "02.019.02",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "208",
    "Bcolor": "34",
    "Y": 63.4761505126953,
    "L": 83.6922760009766,
    "a": -4.56214666366577,
    "b": 79.1843643188477,
    "C": 79.3156814575195,
    "h": 93.2974090576172,
    "CMY_C": 0.06436330080032,
    "CMY_M": 0.18452560901642,
    "CMY_Y": 0.86710119247437,
    "CMYK_C": 0,
    "CMYK_M": 0.12842838466167,
    "CMYK_Y": 0.85795897245407,
    "CMYK_K": 0.06436330080032
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0327",
    "Farbtonhilfsbezeichnung": "02.019.03",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "230",
    "Bcolor": "132",
    "Y": 78.5775756835938,
    "L": 91.0428161621094,
    "a": -5.67769050598145,
    "b": 49.2837600708008,
    "C": 49.6097297668457,
    "h": 96.5717391967773,
    "CMY_C": 0.02104967832565,
    "CMY_M": 0.09757167100906,
    "CMY_Y": 0.48247146606445,
    "CMYK_C": 0,
    "CMYK_M": 0.0781673938036,
    "CMYK_Y": 0.4713434278965,
    "CMYK_K": 0.02104967832565
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0328",
    "Farbtonhilfsbezeichnung": "02.019.04",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "215",
    "Bcolor": "99",
    "Y": 68.1571807861328,
    "L": 86.0849838256836,
    "a": -4.95865821838379,
    "b": 58.5821228027344,
    "C": 58.7916107177734,
    "h": 94.8382415771484,
    "CMY_C": 0.06038516759872,
    "CMY_M": 0.1553310751915,
    "CMY_Y": 0.61096674203873,
    "CMYK_C": 0,
    "CMYK_M": 0.10104768723249,
    "CMYK_Y": 0.58596515655518,
    "CMYK_K": 0.06038516759872
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0329",
    "Farbtonhilfsbezeichnung": "02.019.05",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "199",
    "Bcolor": "68",
    "Y": 57.666820526123,
    "L": 80.5531997680664,
    "a": -3.28532457351685,
    "b": 65.5819473266602,
    "C": 65.6641845703125,
    "h": 92.8678359985352,
    "CMY_C": 0.10629069805145,
    "CMY_M": 0.22021049261093,
    "CMY_Y": 0.73360401391983,
    "CMYK_C": 0,
    "CMYK_M": 0.12746851146221,
    "CMYK_Y": 0.70192098617554,
    "CMYK_K": 0.10629069805145
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0330",
    "Farbtonhilfsbezeichnung": "02.019.06",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "176",
    "Bcolor": "56",
    "Y": 43.3136024475098,
    "L": 71.7673034667969,
    "a": -5.04052448272705,
    "b": 60.4024810791016,
    "C": 60.6124305725098,
    "h": 94.7702178955078,
    "CMY_C": 0.22506135702133,
    "CMY_M": 0.30958122014999,
    "CMY_Y": 0.77859562635422,
    "CMYK_C": 0,
    "CMYK_M": 0.10906652361155,
    "CMYK_Y": 0.71429431438446,
    "CMYK_K": 0.22506135702133
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0331",
    "Farbtonhilfsbezeichnung": "02.020.01",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "225",
    "Bcolor": "177",
    "Y": 76.5319366455078,
    "L": 90.1057434082031,
    "a": -0.37066915631294,
    "b": 25.070592880249,
    "C": 25.0733337402344,
    "h": 90.847053527832,
    "CMY_C": 0.04246485233307,
    "CMY_M": 0.11598235368729,
    "CMY_Y": 0.30420434474945,
    "CMYK_C": 0,
    "CMYK_M": 0.07677786052227,
    "CMYK_Y": 0.27334713935852,
    "CMYK_K": 0.04246485233307
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0332",
    "Farbtonhilfsbezeichnung": "02.020.02",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "224",
    "Bcolor": "149",
    "Y": 75.3238372802734,
    "L": 89.5444641113281,
    "a": -0.9820739030838,
    "b": 38.7188529968262,
    "C": 38.7313041687012,
    "h": 91.4529571533203,
    "CMY_C": 0.02464836835861,
    "CMY_M": 0.12344247102737,
    "CMY_Y": 0.4138160943985,
    "CMYK_C": 0,
    "CMYK_M": 0.10129075497389,
    "CMYK_Y": 0.39900249242783,
    "CMYK_K": 0.02464836835861
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0333",
    "Farbtonhilfsbezeichnung": "02.020.03",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "214",
    "Bcolor": "133",
    "Y": 68.5604629516602,
    "L": 86.2859268188477,
    "a": -0.35517647862434,
    "b": 42.7699241638184,
    "C": 42.7714004516602,
    "h": 90.4757919311523,
    "CMY_C": 0.05091553926468,
    "CMY_M": 0.16156488656998,
    "CMY_Y": 0.47876584529877,
    "CMYK_C": 0,
    "CMYK_M": 0.11658535152674,
    "CMYK_Y": 0.45080319046974,
    "CMYK_K": 0.05091553926468
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0334",
    "Farbtonhilfsbezeichnung": "02.020.04",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "199",
    "Bcolor": "105",
    "Y": 58.6637153625488,
    "L": 81.1063995361328,
    "a": 0.47125214338303,
    "b": 50.0835800170898,
    "C": 50.0857963562012,
    "h": 89.4608993530273,
    "CMY_C": 0.09433168172836,
    "CMY_M": 0.2210955619812,
    "CMY_Y": 0.58932459354401,
    "CMYK_C": 0,
    "CMYK_M": 0.13996721804142,
    "CMYK_Y": 0.54654985666275,
    "CMYK_K": 0.09433168172836
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0335",
    "Farbtonhilfsbezeichnung": "02.020.05",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "175",
    "Bcolor": "79",
    "Y": 44.3262252807617,
    "L": 72.4460067749023,
    "a": 1.07594668865204,
    "b": 51.6738510131836,
    "C": 51.6850509643555,
    "h": 88.8071670532227,
    "CMY_C": 0.18847519159317,
    "CMY_M": 0.31528609991074,
    "CMY_Y": 0.6896458864212,
    "CMYK_C": 0,
    "CMYK_M": 0.1562625169754,
    "CMYK_Y": 0.61756670475006,
    "CMYK_K": 0.18847519159317
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0336",
    "Farbtonhilfsbezeichnung": "02.020.06",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "147",
    "Bcolor": "60",
    "Y": 30.0517559051514,
    "L": 61.6988525390625,
    "a": -0.09451152384281,
    "b": 47.7481842041016,
    "C": 47.7482795715332,
    "h": 90.113410949707,
    "CMY_C": 0.32168251276016,
    "CMY_M": 0.4238189458847,
    "CMY_Y": 0.76411378383636,
    "CMYK_C": 0,
    "CMYK_M": 0.15057319402695,
    "CMYK_Y": 0.65224808454514,
    "CMYK_K": 0.32168251276016
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0337",
    "Farbtonhilfsbezeichnung": "02.021.01",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "127",
    "Y": 74.0356140136719,
    "L": 88.9393157958984,
    "a": 2.37148141860962,
    "b": 49.157054901123,
    "C": 49.214225769043,
    "h": 87.2380218505859,
    "CMY_C": 0,
    "CMY_M": 0.13996332883835,
    "CMY_Y": 0.50103753805161,
    "CMYK_C": 0,
    "CMYK_M": 0.13996332883835,
    "CMYK_Y": 0.50103753805161,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0338",
    "Farbtonhilfsbezeichnung": "02.021.02",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "208",
    "Bcolor": "104",
    "Y": 67.1001586914063,
    "L": 85.5544967651367,
    "a": 4.81379365921021,
    "b": 56.2811241149902,
    "C": 56.4866142272949,
    "h": 85.1113204956055,
    "CMY_C": 0.00584721565247,
    "CMY_M": 0.18414920568466,
    "CMY_Y": 0.59342640638351,
    "CMYK_C": 0,
    "CMYK_M": 0.17935068905354,
    "CMYK_Y": 0.59103512763977,
    "CMYK_K": 0.00584721565247
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0339",
    "Farbtonhilfsbezeichnung": "02.021.03",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "205",
    "Bcolor": "84",
    "Y": 65.3174438476563,
    "L": 84.6470489501953,
    "a": 5.72753047943115,
    "b": 64.0773086547852,
    "C": 64.3327789306641,
    "h": 84.8922119140625,
    "CMY_C": 0.0019223690033,
    "CMY_M": 0.1972953081131,
    "CMY_Y": 0.67081815004349,
    "CMYK_C": 0,
    "CMYK_M": 0.19574923813343,
    "CMYK_Y": 0.67018413543701,
    "CMYK_K": 0.0019223690033
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0340",
    "Farbtonhilfsbezeichnung": "02.021.04",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "177",
    "Bcolor": "57",
    "Y": 47.0308570861816,
    "L": 74.2095031738281,
    "a": 5.08223581314087,
    "b": 63.2937812805176,
    "C": 63.4974937438965,
    "h": 85.4092254638672,
    "CMY_C": 0.13126331567764,
    "CMY_M": 0.30750566720963,
    "CMY_Y": 0.77581894397736,
    "CMYK_C": 0,
    "CMYK_M": 0.20287200808525,
    "CMYK_Y": 0.74194592237473,
    "CMYK_K": 0.13126331567764
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0341",
    "Farbtonhilfsbezeichnung": "02.021.05",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "144",
    "Bcolor": "39",
    "Y": 30.5635623931885,
    "L": 62.1374626159668,
    "a": 6.45265531539917,
    "b": 57.5333786010742,
    "C": 57.8940963745117,
    "h": 83.6007385253906,
    "CMY_C": 0.26894980669022,
    "CMY_M": 0.43551188707352,
    "CMY_Y": 0.84858554601669,
    "CMYK_C": 0,
    "CMYK_M": 0.22783945500851,
    "CMYK_Y": 0.7928808927536,
    "CMYK_K": 0.26894980669022
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0342",
    "Farbtonhilfsbezeichnung": "02.021.06",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "131",
    "Bcolor": "40",
    "Y": 24.7638187408447,
    "L": 56.8445701599121,
    "a": 6.29179668426514,
    "b": 51.2975044250488,
    "C": 51.6819190979004,
    "h": 83.0074157714844,
    "CMY_C": 0.33524984121323,
    "CMY_M": 0.48794895410538,
    "CMY_Y": 0.84194785356522,
    "CMYK_C": 0,
    "CMYK_M": 0.22970902919769,
    "CMYK_Y": 0.76223826408386,
    "CMYK_K": 0.33524984121323
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0343",
    "Farbtonhilfsbezeichnung": "02.022.01",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "205",
    "Bcolor": "100",
    "Y": 64.5241317749023,
    "L": 84.237922668457,
    "a": 4.50119066238403,
    "b": 56.3048667907715,
    "C": 56.4845008850098,
    "h": 85.429313659668,
    "CMY_C": 0.02348005771637,
    "CMY_M": 0.19772118330002,
    "CMY_Y": 0.60730874538422,
    "CMYK_C": 0,
    "CMYK_M": 0.17843069136143,
    "CMYK_Y": 0.59786665439606,
    "CMYK_K": 0.02348005771637
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0344",
    "Farbtonhilfsbezeichnung": "02.022.02",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "203",
    "Bcolor": "92",
    "Y": 64.609977722168,
    "L": 84.2823486328125,
    "a": 6.99650812149048,
    "b": 60.3700141906738,
    "C": 60.7740859985352,
    "h": 83.3892669677734,
    "CMY_C": 0.00238412618637,
    "CMY_M": 0.20399725437164,
    "CMY_Y": 0.64082980155945,
    "CMYK_C": 0,
    "CMYK_M": 0.20209494233131,
    "CMYK_Y": 0.63997143507004,
    "CMYK_K": 0.00238412618637
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0345",
    "Farbtonhilfsbezeichnung": "02.022.03",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "0",
    "Y": 53.6350479125977,
    "L": 78.2484512329102,
    "a": 17.5785369873047,
    "b": 81.1178741455078,
    "C": 83.0006866455078,
    "h": 77.7728576660156,
    "CMY_C": 0,
    "CMY_M": 0.29885858297348,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.29885858297348,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0346",
    "Farbtonhilfsbezeichnung": "02.022.04",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "161",
    "Bcolor": "21",
    "Y": 42.0392227172852,
    "L": 70.8979568481445,
    "a": 15.2435617446899,
    "b": 71.4231185913086,
    "C": 73.0316925048828,
    "h": 77.9523391723633,
    "CMY_C": 0.10508906841278,
    "CMY_M": 0.36896634101868,
    "CMY_Y": 0.91698676347733,
    "CMYK_C": 0,
    "CMYK_M": 0.29486429691315,
    "CMYK_Y": 0.9072385430336,
    "CMYK_K": 0.10508906841278
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0347",
    "Farbtonhilfsbezeichnung": "02.022.05",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "164",
    "Bcolor": "30",
    "Y": 43.0749778747559,
    "L": 71.605827331543,
    "a": 12.8097839355469,
    "b": 69.8812866210938,
    "C": 71.045654296875,
    "h": 79.6125564575195,
    "CMY_C": 0.1114941239357,
    "CMY_M": 0.35499274730682,
    "CMY_Y": 0.88186579942703,
    "CMYK_C": 0,
    "CMYK_M": 0.27405405044556,
    "CMYK_Y": 0.86704170703888,
    "CMYK_K": 0.1114941239357
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0348",
    "Farbtonhilfsbezeichnung": "02.022.06",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "146",
    "Bcolor": "25",
    "Y": 33.3968086242676,
    "L": 64.4809265136719,
    "a": 12.9326429367065,
    "b": 64.4481048583984,
    "C": 65.7328796386719,
    "h": 78.6532974243164,
    "CMY_C": 0.19967955350876,
    "CMY_M": 0.42844969034195,
    "CMY_Y": 0.90186953544617,
    "CMYK_C": 0,
    "CMYK_M": 0.28584817051888,
    "CMYK_Y": 0.877386033535,
    "CMYK_K": 0.19967955350876
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0349",
    "Farbtonhilfsbezeichnung": "02.023.01",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "186",
    "Bcolor": "154",
    "Y": 58.7797088623047,
    "L": 81.1703567504883,
    "a": 21.4906196594238,
    "b": 25.5322456359863,
    "C": 33.3727760314941,
    "h": 49.9125137329102,
    "CMY_C": 0,
    "CMY_M": 0.27052861452103,
    "CMY_Y": 0.39694237709045,
    "CMYK_C": 0,
    "CMYK_M": 0.27052861452103,
    "CMYK_Y": 0.39694237709045,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0350",
    "Farbtonhilfsbezeichnung": "02.023.02",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "168",
    "Bcolor": "120",
    "Y": 51.2624092102051,
    "L": 76.8376922607422,
    "a": 28.5301380157471,
    "b": 37.7228012084961,
    "C": 47.2967071533203,
    "h": 52.8994102478027,
    "CMY_C": 0,
    "CMY_M": 0.34025174379349,
    "CMY_Y": 0.52882480621338,
    "CMYK_C": 0,
    "CMYK_M": 0.34025174379349,
    "CMYK_Y": 0.52882480621338,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0351",
    "Farbtonhilfsbezeichnung": "02.023.03",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "150",
    "Bcolor": "99",
    "Y": 43.841064453125,
    "L": 72.1221389770508,
    "a": 34.5121231079102,
    "b": 43.0569267272949,
    "C": 55.1813888549805,
    "h": 51.286205291748,
    "CMY_C": 0.00516641139984,
    "CMY_M": 0.41020357608795,
    "CMY_Y": 0.61349642276764,
    "CMYK_C": 0,
    "CMYK_M": 0.40714061260223,
    "CMYK_Y": 0.61148923635483,
    "CMYK_K": 0.00516641139984
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0352",
    "Farbtonhilfsbezeichnung": "02.023.04",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "122",
    "Bcolor": "57",
    "Y": 33.4094123840332,
    "L": 64.4910507202148,
    "a": 42.7632865905762,
    "b": 54.7828025817871,
    "C": 69.4971542358398,
    "h": 52.0245132446289,
    "CMY_C": 0.04458570480347,
    "CMY_M": 0.52108865976334,
    "CMY_Y": 0.77661275863647,
    "CMYK_C": 0,
    "CMYK_M": 0.49873960018158,
    "CMYK_Y": 0.76618808507919,
    "CMYK_K": 0.04458570480347
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0353",
    "Farbtonhilfsbezeichnung": "02.023.05",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "110",
    "Bcolor": "49",
    "Y": 29.0162734985352,
    "L": 60.7959938049316,
    "a": 44.6419525146484,
    "b": 54.2536315917969,
    "C": 70.2592391967773,
    "h": 50.5511512756348,
    "CMY_C": 0.08122736215591,
    "CMY_M": 0.56677794456482,
    "CMY_Y": 0.80728250741959,
    "CMYK_C": 0,
    "CMYK_M": 0.52847743034363,
    "CMYK_Y": 0.79024463891983,
    "CMYK_K": 0.08122736215591
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0354",
    "Farbtonhilfsbezeichnung": "02.023.06",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "96",
    "Bcolor": "53",
    "Y": 22.0622024536133,
    "L": 54.0929412841797,
    "a": 41.714225769043,
    "b": 44.2177619934082,
    "C": 60.7888717651367,
    "h": 46.6687812805176,
    "CMY_C": 0.18478721380234,
    "CMY_M": 0.6225506067276,
    "CMY_Y": 0.79102885723114,
    "CMYK_C": 0,
    "CMYK_M": 0.53699278831482,
    "CMYK_Y": 0.74366062879562,
    "CMYK_K": 0.18478721380234
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0355",
    "Farbtonhilfsbezeichnung": "02.024.01",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "136",
    "Bcolor": "131",
    "Y": 33.6650581359863,
    "L": 64.6958312988281,
    "a": 30.0362033843994,
    "b": 14.7011270523071,
    "C": 33.4409408569336,
    "h": 26.0792942047119,
    "CMY_C": 0.15674006938934,
    "CMY_M": 0.46714168787003,
    "CMY_Y": 0.4859790802002,
    "CMYK_C": 0,
    "CMYK_M": 0.36809718608856,
    "CMYK_Y": 0.39043596386909,
    "CMYK_K": 0.15674006938934
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0356",
    "Farbtonhilfsbezeichnung": "02.024.02",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "118",
    "Bcolor": "120",
    "Y": 26.9331130981445,
    "L": 58.9123611450195,
    "a": 33.4152603149414,
    "b": 12.9324045181274,
    "C": 35.8305282592773,
    "h": 21.1574783325195,
    "CMY_C": 0.20648431777954,
    "CMY_M": 0.53685146570206,
    "CMY_Y": 0.53064346313477,
    "CMYK_C": 0,
    "CMYK_M": 0.41633349657059,
    "CMYK_Y": 0.40851005911827,
    "CMYK_K": 0.20648431777954
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0357",
    "Farbtonhilfsbezeichnung": "02.024.03",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "102",
    "Bcolor": "101",
    "Y": 20.9100208282471,
    "L": 52.8508758544922,
    "a": 34.1677322387695,
    "b": 15.4335117340088,
    "C": 37.4916954040527,
    "h": 24.3086204528809,
    "CMY_C": 0.26742798089981,
    "CMY_M": 0.60123986005783,
    "CMY_Y": 0.60582554340363,
    "CMYK_C": 0,
    "CMYK_M": 0.45567107200623,
    "CMYK_Y": 0.46193078160286,
    "CMYK_K": 0.26742798089981
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0358",
    "Farbtonhilfsbezeichnung": "02.024.04",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "79",
    "Bcolor": "80",
    "Y": 12.976881980896,
    "L": 42.7283897399902,
    "a": 30.9101333618164,
    "b": 12.9418096542358,
    "C": 33.5101013183594,
    "h": 22.7186450958252,
    "CMY_C": 0.40065896511078,
    "CMY_M": 0.68895351886749,
    "CMY_Y": 0.68504363298416,
    "CMYK_C": 0,
    "CMYK_M": 0.48101922869682,
    "CMYK_Y": 0.4744955599308,
    "CMYK_K": 0.40065896511078
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0359",
    "Farbtonhilfsbezeichnung": "02.024.05",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "60",
    "Bcolor": "70",
    "Y": 8.56197929382324,
    "L": 35.1268882751465,
    "a": 31.7543029785156,
    "b": 8.23306083679199,
    "C": 32.8042526245117,
    "h": 14.5352382659912,
    "CMY_C": 0.48498594760895,
    "CMY_M": 0.76344007253647,
    "CMY_Y": 0.72454673051834,
    "CMYK_C": 0,
    "CMYK_M": 0.5406728386879,
    "CMYK_Y": 0.46515387296677,
    "CMYK_K": 0.48498594760895
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0360",
    "Farbtonhilfsbezeichnung": "02.024.06",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "50",
    "Bcolor": "60",
    "Y": 5.57489156723022,
    "L": 28.3135757446289,
    "a": 25.9840850830078,
    "b": 4.97335767745972,
    "C": 26.4557552337646,
    "h": 10.8353748321533,
    "CMY_C": 0.58851504325867,
    "CMY_M": 0.80516636371613,
    "CMY_Y": 0.76624584197998,
    "CMYK_C": 0,
    "CMYK_M": 0.52651089429855,
    "CMYK_Y": 0.43192538619041,
    "CMYK_K": 0.58851504325867
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0361",
    "Farbtonhilfsbezeichnung": "02.025.01",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "155",
    "Bcolor": "200",
    "Y": 42.4500312805176,
    "L": 71.1800918579102,
    "a": 30.36501121521,
    "b": -14.7186517715454,
    "C": 33.7442245483398,
    "h": 334.139404296875,
    "CMY_C": 0.14919769763947,
    "CMY_M": 0.39115923643112,
    "CMY_Y": 0.21487802267075,
    "CMYK_C": 0,
    "CMYK_M": 0.28439220786095,
    "CMYK_Y": 0.07719810307026,
    "CMYK_K": 0.14919769763947
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0362",
    "Farbtonhilfsbezeichnung": "02.025.02",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "131",
    "Bcolor": "183",
    "Y": 31.5745677947998,
    "L": 62.9896965026855,
    "a": 34.096549987793,
    "b": -17.6439971923828,
    "C": 38.3912162780762,
    "h": 332.639709472656,
    "CMY_C": 0.22463947534561,
    "CMY_M": 0.48693960905075,
    "CMY_Y": 0.28209513425827,
    "CMYK_C": 0,
    "CMYK_M": 0.33829441666603,
    "CMYK_Y": 0.0741018652916,
    "CMYK_K": 0.22463947534561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0363",
    "Farbtonhilfsbezeichnung": "02.025.03",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "104",
    "Bcolor": "162",
    "Y": 21.0666999816895,
    "L": 53.0224113464355,
    "a": 36.0092163085938,
    "b": -20.7153778076172,
    "C": 41.5426368713379,
    "h": 330.089050292969,
    "CMY_C": 0.33060544729233,
    "CMY_M": 0.59316265583038,
    "CMY_Y": 0.36622887849808,
    "CMYK_C": 0,
    "CMYK_M": 0.39223086833954,
    "CMYK_Y": 0.05321738868952,
    "CMYK_K": 0.33060544729233
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0364",
    "Farbtonhilfsbezeichnung": "02.025.04",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "77",
    "Bcolor": "136",
    "Y": 12.8084363937378,
    "L": 42.4731788635254,
    "a": 36.7813339233398,
    "b": -22.0403652191162,
    "C": 42.8794136047363,
    "h": 329.068817138672,
    "CMY_C": 0.44239670038223,
    "CMY_M": 0.69942128658295,
    "CMY_Y": 0.46592098474503,
    "CMYK_C": 0,
    "CMYK_M": 0.46094524860382,
    "CMYK_Y": 0.04218820855021,
    "CMYK_K": 0.44239670038223
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0365",
    "Farbtonhilfsbezeichnung": "02.025.05",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "83",
    "Bcolor": "133",
    "Y": 13.0333337783813,
    "L": 42.8134269714355,
    "a": 30.2135314941406,
    "b": -19.5330867767334,
    "C": 35.9777565002441,
    "h": 327.117279052734,
    "CMY_C": 0.47014158964157,
    "CMY_M": 0.67453843355179,
    "CMY_Y": 0.47917622327805,
    "CMYK_C": 0,
    "CMYK_M": 0.38575747609138,
    "CMYK_Y": 0.01705103367567,
    "CMYK_K": 0.47014158964157
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0366",
    "Farbtonhilfsbezeichnung": "02.025.06",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "62",
    "Bcolor": "106",
    "Y": 8.80286979675293,
    "L": 35.6019477844238,
    "a": 33.7290420532227,
    "b": -14.1710510253906,
    "C": 36.5850639343262,
    "h": 337.210601806641,
    "CMY_C": 0.51054108142853,
    "CMY_M": 0.75803726911545,
    "CMY_Y": 0.58354067802429,
    "CMYK_C": 0,
    "CMYK_M": 0.50565260648727,
    "CMYK_Y": 0.14914345741272,
    "CMYK_K": 0.51054108142853
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0367",
    "Farbtonhilfsbezeichnung": "02.026.01",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "166",
    "Bcolor": "209",
    "Y": 42.4779624938965,
    "L": 71.1992111206055,
    "a": 15.5913543701172,
    "b": -19.7650966644287,
    "C": 25.1743793487549,
    "h": 308.267547607422,
    "CMY_C": 0.26981043815613,
    "CMY_M": 0.34743219614029,
    "CMY_Y": 0.18098229169846,
    "CMYK_C": 0.10845693200827,
    "CMYK_M": 0.20323114097118,
    "CMYK_Y": 0,
    "CMYK_K": 0.18098229169846
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0368",
    "Farbtonhilfsbezeichnung": "02.026.02",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "141",
    "Bcolor": "195",
    "Y": 30.8787345886231,
    "L": 62.4051284790039,
    "a": 19.9440593719482,
    "b": -25.506519317627,
    "C": 32.3782043457031,
    "h": 308.022552490234,
    "CMY_C": 0.35418683290482,
    "CMY_M": 0.44795155525208,
    "CMY_Y": 0.23599278926849,
    "CMYK_C": 0.15470278263092,
    "CMYK_M": 0.27743032574654,
    "CMYK_Y": 0,
    "CMYK_K": 0.23599278926849
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0369",
    "Farbtonhilfsbezeichnung": "02.026.03",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "117",
    "Bcolor": "175",
    "Y": 21.7785224914551,
    "L": 53.7912216186523,
    "a": 22.3634586334229,
    "b": -27.5179767608643,
    "C": 35.4593200683594,
    "h": 309.100250244141,
    "CMY_C": 0.43536180257797,
    "CMY_M": 0.54052370786667,
    "CMY_Y": 0.31420689821243,
    "CMYK_C": 0.17666393518448,
    "CMYK_M": 0.33000740408897,
    "CMYK_Y": 0,
    "CMYK_K": 0.31420689821243
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0370",
    "Farbtonhilfsbezeichnung": "02.026.04",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "92",
    "Bcolor": "151",
    "Y": 13.9352054595947,
    "L": 44.1398658752441,
    "a": 23.9874858856201,
    "b": -28.90673828125,
    "C": 37.5632667541504,
    "h": 309.686676025391,
    "CMY_C": 0.52893829345703,
    "CMY_M": 0.63855028152466,
    "CMY_Y": 0.40591472387314,
    "CMYK_C": 0.20708066225052,
    "CMYK_M": 0.391586124897,
    "CMYK_Y": 0,
    "CMYK_K": 0.40591472387314
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0371",
    "Farbtonhilfsbezeichnung": "02.026.05",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "73",
    "Bcolor": "124",
    "Y": 8.62486553192139,
    "L": 35.2517585754395,
    "a": 21.138053894043,
    "b": -26.1483211517334,
    "C": 33.6236839294434,
    "h": 308.951751708984,
    "CMY_C": 0.62569642066956,
    "CMY_M": 0.71522569656372,
    "CMY_Y": 0.5140186548233,
    "CMYK_C": 0.22979846596718,
    "CMYK_M": 0.41402214765549,
    "CMYK_Y": 0,
    "CMYK_K": 0.5140186548233
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0372",
    "Farbtonhilfsbezeichnung": "02.026.06",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "58",
    "Bcolor": "90",
    "Y": 5.34795665740967,
    "L": 27.7039413452148,
    "a": 15.2133760452271,
    "b": -16.5028114318848,
    "C": 22.4452571868896,
    "h": 312.671905517578,
    "CMY_C": 0.69970345497131,
    "CMY_M": 0.77170950174332,
    "CMY_Y": 0.64657765626907,
    "CMYK_C": 0.15031816065311,
    "CMYK_M": 0.3540575504303,
    "CMYK_Y": 0,
    "CMYK_K": 0.64657765626907
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0373",
    "Farbtonhilfsbezeichnung": "02.027.01",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "192",
    "Bcolor": "225",
    "Y": 53.5841827392578,
    "L": 78.2186431884766,
    "a": 4.75237321853638,
    "b": -17.8068370819092,
    "C": 18.4300975799561,
    "h": 284.943084716797,
    "CMY_C": 0.27163380384445,
    "CMY_M": 0.2464861869812,
    "CMY_Y": 0.119011759758,
    "CMYK_C": 0.17323958873749,
    "CMYK_M": 0.14469480514526,
    "CMYK_Y": 0,
    "CMYK_K": 0.119011759758
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0374",
    "Farbtonhilfsbezeichnung": "02.027.02",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "157",
    "Bcolor": "201",
    "Y": 34.8817176818848,
    "L": 65.6564712524414,
    "a": 8.37523555755615,
    "b": -24.065185546875,
    "C": 25.4809284210205,
    "h": 289.189056396484,
    "CMY_C": 0.40369808673859,
    "CMY_M": 0.38578200340271,
    "CMY_Y": 0.21194893121719,
    "CMYK_C": 0.24332071840763,
    "CMYK_M": 0.2205860465765,
    "CMYK_Y": 0,
    "CMYK_K": 0.21194893121719
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0375",
    "Farbtonhilfsbezeichnung": "02.027.03",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "104",
    "Bcolor": "148",
    "Y": 14.6429195404053,
    "L": 45.1411895751953,
    "a": 9.71570587158203,
    "b": -25.5179080963135,
    "C": 27.3049182891846,
    "h": 290.843872070313,
    "CMY_C": 0.60950815677643,
    "CMY_M": 0.5938469171524,
    "CMY_Y": 0.4188472032547,
    "CMYK_C": 0.32807371020317,
    "CMYK_M": 0.30112513899803,
    "CMYK_Y": 0,
    "CMYK_K": 0.4188472032547
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0376",
    "Farbtonhilfsbezeichnung": "02.027.04",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "82",
    "Bcolor": "134",
    "Y": 9.37106609344482,
    "L": 36.6891250610352,
    "a": 13.4589910507202,
    "b": -30.248893737793,
    "C": 33.1080055236816,
    "h": 293.986267089844,
    "CMY_C": 0.68784308433533,
    "CMY_M": 0.68034279346466,
    "CMY_Y": 0.47440195083618,
    "CMYK_C": 0.40609195828438,
    "CMYK_M": 0.39182192087173,
    "CMYK_Y": 0,
    "CMYK_K": 0.47440195083618
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0377",
    "Farbtonhilfsbezeichnung": "02.027.05",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "66",
    "Bcolor": "115",
    "Y": 6.2227087020874,
    "L": 29.967529296875,
    "a": 13.6982326507568,
    "b": -28.8967208862305,
    "C": 31.9790878295898,
    "h": 295.362884521484,
    "CMY_C": 0.74380230903625,
    "CMY_M": 0.74255073070526,
    "CMY_Y": 0.54997044801712,
    "CMYK_C": 0.43070918321609,
    "CMYK_M": 0.42792809009552,
    "CMYK_Y": 0,
    "CMYK_K": 0.54997044801712
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0378",
    "Farbtonhilfsbezeichnung": "02.027.06",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "61",
    "Bcolor": "98",
    "Y": 5.04317569732666,
    "L": 26.8574199676514,
    "a": 8.2105655670166,
    "b": -23.3562278747559,
    "C": 24.7573585510254,
    "h": 289.368438720703,
    "CMY_C": 0.78637200593948,
    "CMY_M": 0.76007431745529,
    "CMY_Y": 0.61419272422791,
    "CMYK_C": 0.44628313183784,
    "CMYK_M": 0.37812039256096,
    "CMYK_Y": 0,
    "CMYK_K": 0.61419272422791
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0379",
    "Farbtonhilfsbezeichnung": "02.028.01",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "228",
    "Bcolor": "236",
    "Y": 73.6898574829102,
    "L": 88.7756958007813,
    "a": -8.37771129608154,
    "b": -7.94962596893311,
    "C": 11.5491380691528,
    "h": 223.498107910156,
    "CMY_C": 0.22703242301941,
    "CMY_M": 0.10392880439758,
    "CMY_Y": 0.07513177394867,
    "CMYK_C": 0.16424031555653,
    "CMYK_M": 0.03113636001945,
    "CMYK_Y": 0,
    "CMYK_K": 0.07513177394867
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0380",
    "Farbtonhilfsbezeichnung": "02.028.02",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "187",
    "Bcolor": "208",
    "Y": 45.6541786193848,
    "L": 73.3205718994141,
    "a": -9.63436794281006,
    "b": -16.4522247314453,
    "C": 19.0655899047852,
    "h": 239.646896362305,
    "CMY_C": 0.44643640518188,
    "CMY_M": 0.26777237653732,
    "CMY_Y": 0.18397909402847,
    "CMYK_C": 0.32163062691689,
    "CMYK_M": 0.10268521308899,
    "CMYK_Y": 0,
    "CMYK_K": 0.18397909402847
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0381",
    "Farbtonhilfsbezeichnung": "02.028.03",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "150",
    "Bcolor": "173",
    "Y": 27.6197872161865,
    "L": 59.5436668395996,
    "a": -9.7191915512085,
    "b": -17.7025451660156,
    "C": 20.1951179504395,
    "h": 241.231979370117,
    "CMY_C": 0.59880709648132,
    "CMY_M": 0.41224092245102,
    "CMY_Y": 0.32286268472672,
    "CMYK_C": 0.40751618146896,
    "CMYK_M": 0.13199426233768,
    "CMYK_Y": 0,
    "CMYK_K": 0.32286268472672
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0382",
    "Farbtonhilfsbezeichnung": "02.028.04",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "111",
    "Bcolor": "143",
    "Y": 14.4584703445435,
    "L": 44.8833808898926,
    "a": -6.17858552932739,
    "b": -22.7094821929932,
    "C": 23.5349845886231,
    "h": 254.779891967773,
    "CMY_C": 0.74690383672714,
    "CMY_M": 0.56447303295135,
    "CMY_Y": 0.44104778766632,
    "CMYK_C": 0.54719537496567,
    "CMYK_M": 0.22081537544727,
    "CMYK_Y": 0,
    "CMYK_K": 0.44104778766632
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0383",
    "Farbtonhilfsbezeichnung": "02.028.05",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "89",
    "Bcolor": "126",
    "Y": 9.08884811401367,
    "L": 36.1547966003418,
    "a": -3.74807906150818,
    "b": -26.5021705627441,
    "C": 26.7658958435059,
    "h": 261.950317382813,
    "CMY_C": 0.84717011451721,
    "CMY_M": 0.65099889039993,
    "CMY_Y": 0.50465643405914,
    "CMYK_C": 0.69146692752838,
    "CMYK_M": 0.29543626308441,
    "CMYK_Y": 0,
    "CMYK_K": 0.50465643405914
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0384",
    "Farbtonhilfsbezeichnung": "02.028.06",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "72",
    "Bcolor": "96",
    "Y": 5.79903030395508,
    "L": 28.8996677398682,
    "a": -4.60144996643066,
    "b": -18.7119464874268,
    "C": 19.2694129943848,
    "h": 256.184539794922,
    "CMY_C": 0.86079174280167,
    "CMY_M": 0.71904337406158,
    "CMY_Y": 0.62356942892075,
    "CMYK_C": 0.63018876314163,
    "CMYK_M": 0.2536296248436,
    "CMYK_Y": 0,
    "CMYK_K": 0.62356942892075
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0385",
    "Farbtonhilfsbezeichnung": "02.029.01",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "207",
    "Bcolor": "231",
    "Y": 56.2412910461426,
    "L": 79.7509460449219,
    "a": -14.4542818069458,
    "b": -19.2557468414307,
    "C": 24.077169418335,
    "h": 233.106353759766,
    "CMY_C": 0.44433963298798,
    "CMY_M": 0.18728560209274,
    "CMY_Y": 0.09361630678177,
    "CMYK_C": 0.38694795966148,
    "CMYK_M": 0.10334397852421,
    "CMYK_Y": 0,
    "CMYK_K": 0.09361630678177
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0386",
    "Farbtonhilfsbezeichnung": "02.029.02",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "189",
    "Bcolor": "225",
    "Y": 44.2246170043945,
    "L": 72.3783721923828,
    "a": -16.7985801696777,
    "b": -27.1959342956543,
    "C": 31.9657802581787,
    "h": 238.296905517578,
    "CMY_C": 0.61927849054337,
    "CMY_M": 0.26008379459381,
    "CMY_Y": 0.11858361959457,
    "CMYK_C": 0.56805711984634,
    "CMYK_M": 0.16053725779057,
    "CMYK_Y": 0,
    "CMYK_K": 0.11858361959457
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0387",
    "Farbtonhilfsbezeichnung": "02.029.03",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "170",
    "Bcolor": "212",
    "Y": 34.8832054138184,
    "L": 65.6576309204102,
    "a": -14.7281942367554,
    "b": -30.5911827087402,
    "C": 33.9520263671875,
    "h": 244.291397094727,
    "CMY_C": 0.70680367946625,
    "CMY_M": 0.33445453643799,
    "CMY_Y": 0.16845095157623,
    "CMYK_C": 0.64740949869156,
    "CMYK_M": 0.19963173568249,
    "CMYK_Y": 0,
    "CMYK_K": 0.16845095157623
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0388",
    "Farbtonhilfsbezeichnung": "02.029.04",
    "Farbtonklasse": "03",
    "Rcolor": "30",
    "Gcolor": "141",
    "Bcolor": "183",
    "Y": 22.6671695709229,
    "L": 54.727840423584,
    "a": -14.3695497512817,
    "b": -31.4400253295898,
    "C": 34.5681800842285,
    "h": 245.437408447266,
    "CMY_C": 0.8836515545845,
    "CMY_M": 0.44822549819946,
    "CMY_Y": 0.28085738420486,
    "CMYK_C": 0.83821225166321,
    "CMYK_M": 0.23273286223412,
    "CMYK_Y": 0,
    "CMYK_K": 0.28085738420486
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0389",
    "Farbtonhilfsbezeichnung": "02.029.05",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "176",
    "Y": 18.3109264373779,
    "L": 49.8710823059082,
    "a": -12.830849647522,
    "b": -34.9451637268066,
    "C": 37.2262687683105,
    "h": 249.838226318359,
    "CMY_C": 1,
    "CMY_M": 0.49865067005157,
    "CMY_Y": 0.30884623527527,
    "CMYK_C": 1,
    "CMYK_M": 0.27461969852448,
    "CMYK_Y": 0,
    "CMYK_K": 0.30884623527527
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0390",
    "Farbtonhilfsbezeichnung": "02.029.06",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "143",
    "Y": 10.2565813064575,
    "L": 38.2990455627441,
    "a": -11.8597793579102,
    "b": -33.2227783203125,
    "C": 35.2761573791504,
    "h": 250.354583740234,
    "CMY_C": 1,
    "CMY_M": 0.61418485641479,
    "CMY_Y": 0.44074982404709,
    "CMYK_C": 1,
    "CMYK_M": 0.31012067198753,
    "CMYK_Y": 0,
    "CMYK_K": 0.44074982404709
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0391",
    "Farbtonhilfsbezeichnung": "02.030.01",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "230",
    "Bcolor": "229",
    "Y": 73.9583587646484,
    "L": 88.9028015136719,
    "a": -11.4821214675903,
    "b": -4.36116647720337,
    "C": 12.2824621200562,
    "h": 200.797897338867,
    "CMY_C": 0.23782789707184,
    "CMY_M": 0.09680944681168,
    "CMY_Y": 0.1005751490593,
    "CMYK_C": 0.15613366663456,
    "CMYK_M": 0,
    "CMYK_Y": 0.00416933326051,
    "CMYK_K": 0.09680944681168
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0392",
    "Farbtonhilfsbezeichnung": "02.030.02",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "219",
    "Bcolor": "220",
    "Y": 64.1795425415039,
    "L": 84.0591659545898,
    "a": -15.2795295715332,
    "b": -6.8609299659729,
    "C": 16.7492198944092,
    "h": 204.181396484375,
    "CMY_C": 0.33700722455978,
    "CMY_M": 0.14196693897247,
    "CMY_Y": 0.13614857196808,
    "CMYK_C": 0.23251527547836,
    "CMYK_M": 0.00673537934199,
    "CMYK_Y": 0,
    "CMYK_K": 0.13614857196808
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0393",
    "Farbtonhilfsbezeichnung": "02.030.03",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 55.0988006591797,
    "L": 79.09814453125,
    "a": -18.3651523590088,
    "b": -9.32169914245605,
    "C": 20.595458984375,
    "h": 206.911224365234,
    "CMY_C": 0.43387913703918,
    "CMY_M": 0.18972730636597,
    "CMY_Y": 0.17297428846359,
    "CMYK_C": 0.31547367572784,
    "CMYK_M": 0.02025694958866,
    "CMYK_Y": 0,
    "CMYK_K": 0.17297428846359
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0394",
    "Farbtonhilfsbezeichnung": "02.030.04",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "186",
    "Bcolor": "193",
    "Y": 43.402587890625,
    "L": 71.8273696899414,
    "a": -17.7163352966309,
    "b": -10.5241546630859,
    "C": 20.6064643859863,
    "h": 210.711868286133,
    "CMY_C": 0.51136672496796,
    "CMY_M": 0.26961666345596,
    "CMY_Y": 0.24298167228699,
    "CMYK_C": 0.35452914237976,
    "CMYK_M": 0.03518407791853,
    "CMYK_Y": 0,
    "CMYK_K": 0.24298167228699
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0395",
    "Farbtonhilfsbezeichnung": "02.030.05",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "163",
    "Bcolor": "175",
    "Y": 31.6770877838135,
    "L": 63.0750961303711,
    "a": -19.2731704711914,
    "b": -13.4988870620728,
    "C": 23.5303001403809,
    "h": 215.007308959961,
    "CMY_C": 0.64183592796326,
    "CMY_M": 0.35896873474121,
    "CMY_Y": 0.31541818380356,
    "CMYK_C": 0.47681334614754,
    "CMYK_M": 0.06361628323793,
    "CMYK_Y": 0,
    "CMYK_K": 0.31541818380356
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0396",
    "Farbtonhilfsbezeichnung": "02.030.06",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "138",
    "Bcolor": "153",
    "Y": 21.3389854431152,
    "L": 53.3185157775879,
    "a": -18.6735401153564,
    "b": -15.89111328125,
    "C": 24.519962310791,
    "h": 220.397659301758,
    "CMY_C": 0.76208627223969,
    "CMY_M": 0.46036696434021,
    "CMY_Y": 0.40070009231567,
    "CMYK_C": 0.60301393270493,
    "CMYK_M": 0.0995609536767,
    "CMYK_Y": 0,
    "CMYK_K": 0.40070009231567
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0397",
    "Farbtonhilfsbezeichnung": "02.031.01",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "186",
    "Bcolor": "181",
    "Y": 42.9198570251465,
    "L": 71.5005416870117,
    "a": -19.8749179840088,
    "b": -4.55591201782227,
    "C": 20.3904075622559,
    "h": 192.91081237793,
    "CMY_C": 0.50419384241104,
    "CMY_M": 0.27072209119797,
    "CMY_Y": 0.28890013694763,
    "CMYK_C": 0.32014098763466,
    "CMYK_M": 0,
    "CMYK_Y": 0.02492608875036,
    "CMYK_K": 0.27072209119797
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0398",
    "Farbtonhilfsbezeichnung": "02.031.02",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "189",
    "Bcolor": "189",
    "Y": 43.474925994873,
    "L": 71.8761291503906,
    "a": -23.3787040710449,
    "b": -8.1052417755127,
    "C": 24.7438621520996,
    "h": 199.12109375,
    "CMY_C": 0.55941921472549,
    "CMY_M": 0.25923693180084,
    "CMY_Y": 0.26017189025879,
    "CMYK_C": 0.40523386001587,
    "CMYK_M": 0,
    "CMYK_Y": 0.00126215582713,
    "CMYK_K": 0.25923693180084
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0399",
    "Farbtonhilfsbezeichnung": "02.031.03",
    "Farbtonklasse": "02",
    "Rcolor": "87",
    "Gcolor": "168",
    "Bcolor": "166",
    "Y": 32.7143211364746,
    "L": 63.9289245605469,
    "a": -24.6737957000732,
    "b": -7.58912324905396,
    "C": 25.8145503997803,
    "h": 197.096771240234,
    "CMY_C": 0.65793371200562,
    "CMY_M": 0.34214526414871,
    "CMY_Y": 0.34782779216766,
    "CMYK_C": 0.48002761602402,
    "CMYK_M": 0,
    "CMYK_Y": 0.00863796751946,
    "CMYK_K": 0.34214526414871
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0400",
    "Farbtonhilfsbezeichnung": "02.031.04",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "143",
    "Bcolor": "142",
    "Y": 22.0280799865723,
    "L": 54.0567855834961,
    "a": -27.7832870483398,
    "b": -8.83667373657227,
    "C": 29.1547222137451,
    "h": 197.643646240234,
    "CMY_C": 0.83839881420135,
    "CMY_M": 0.43999415636063,
    "CMY_Y": 0.44119882583618,
    "CMYK_C": 0.71142947673798,
    "CMYK_M": 0,
    "CMYK_Y": 0.0021511730738,
    "CMYK_K": 0.43999415636063
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0401",
    "Farbtonhilfsbezeichnung": "02.031.05",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "121",
    "Bcolor": "122",
    "Y": 14.7377786636353,
    "L": 45.2729301452637,
    "a": -30.2447643280029,
    "b": -9.90714740753174,
    "C": 31.8260478973389,
    "h": 198.137008666992,
    "CMY_C": 1,
    "CMY_M": 0.52567291259766,
    "CMY_Y": 0.52219355106354,
    "CMYK_C": 1,
    "CMYK_M": 0.00728194741532,
    "CMYK_Y": 0,
    "CMYK_K": 0.52219355106354
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0402",
    "Farbtonhilfsbezeichnung": "02.031.06",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "104",
    "Y": 9.16560935974121,
    "L": 36.3012161254883,
    "a": -29.2548885345459,
    "b": -12.8420600891113,
    "C": 31.9494438171387,
    "h": 203.700088500977,
    "CMY_C": 1,
    "CMY_M": 0.61510622501373,
    "CMY_Y": 0.59068691730499,
    "CMYK_C": 1,
    "CMYK_M": 0.05965923890471,
    "CMYK_Y": 0,
    "CMYK_K": 0.59068691730499
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0403",
    "Farbtonhilfsbezeichnung": "02.032.01",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "209",
    "Bcolor": "188",
    "Y": 52.1110458374023,
    "L": 77.3471908569336,
    "a": -36.2107048034668,
    "b": 0.26558610796928,
    "C": 36.2116775512695,
    "h": 179.579772949219,
    "CMY_C": 0.60692059993744,
    "CMY_M": 0.1791068315506,
    "CMY_Y": 0.26296180486679,
    "CMYK_C": 0.52115643024445,
    "CMYK_M": 0,
    "CMYK_Y": 0.10215089470148,
    "CMYK_K": 0.1791068315506
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0404",
    "Farbtonhilfsbezeichnung": "02.032.02",
    "Farbtonklasse": "02",
    "Rcolor": "40",
    "Gcolor": "193",
    "Bcolor": "173",
    "Y": 41.6772918701172,
    "L": 70.6478576660156,
    "a": -42.4750213623047,
    "b": -1.54370141029358,
    "C": 42.5030632019043,
    "h": 182.081420898438,
    "CMY_C": 0.84489190578461,
    "CMY_M": 0.24242633581161,
    "CMY_Y": 0.32162231206894,
    "CMYK_C": 0.79525673389435,
    "CMYK_M": 0,
    "CMYK_Y": 0.10453897714615,
    "CMYK_K": 0.24242633581161
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0405",
    "Farbtonhilfsbezeichnung": "02.032.03",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "179",
    "Bcolor": "161",
    "Y": 34.2704963684082,
    "L": 65.1767120361328,
    "a": -45.0850868225098,
    "b": -3.27518606185913,
    "C": 45.2038917541504,
    "h": 184.154922485352,
    "CMY_C": 1,
    "CMY_M": 0.29783743619919,
    "CMY_Y": 0.36679983139038,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09821428358555,
    "CMYK_K": 0.29783743619919
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0406",
    "Farbtonhilfsbezeichnung": "02.032.04",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "153",
    "Bcolor": "138",
    "Y": 23.5595188140869,
    "L": 55.6440505981445,
    "a": -45.0443420410156,
    "b": -4.12423706054688,
    "C": 45.2327537536621,
    "h": 185.231384277344,
    "CMY_C": 1,
    "CMY_M": 0.39991408586502,
    "CMY_Y": 0.45841175317764,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09748215228319,
    "CMYK_K": 0.39991408586502
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0407",
    "Farbtonhilfsbezeichnung": "02.032.05",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "115",
    "Y": 15.1410388946533,
    "L": 45.8267669677734,
    "a": -36.9358825683594,
    "b": -5.02410697937012,
    "C": 37.2760124206543,
    "h": 187.745971679688,
    "CMY_C": 1,
    "CMY_M": 0.51227390766144,
    "CMY_Y": 0.54907286167145,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07545004040003,
    "CMYK_K": 0.51227390766144
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0408",
    "Farbtonhilfsbezeichnung": "02.032.06",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "95",
    "Y": 9.52525329589844,
    "L": 36.9765281677246,
    "a": -31.1817741394043,
    "b": -5.76741027832031,
    "C": 31.7106609344482,
    "h": 190.479049682617,
    "CMY_C": 1,
    "CMY_M": 0.60783272981644,
    "CMY_Y": 0.62871158123016,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.05323965847492,
    "CMYK_K": 0.60783272981644
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0409",
    "Farbtonhilfsbezeichnung": "02.033.01",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "225",
    "Bcolor": "187",
    "Y": 64.4239654541016,
    "L": 84.1860198974609,
    "a": -28.9004440307617,
    "b": 10.9033660888672,
    "C": 30.8888168334961,
    "h": 159.329849243164,
    "CMY_C": 0.3867614865303,
    "CMY_M": 0.11850517988205,
    "CMY_Y": 0.26656061410904,
    "CMYK_C": 0.30431976914406,
    "CMYK_M": 0,
    "CMYK_Y": 0.16795951128006,
    "CMYK_K": 0.11850517988205
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0410",
    "Farbtonhilfsbezeichnung": "02.033.02",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "211",
    "Bcolor": "161",
    "Y": 53.2219581604004,
    "L": 78.005859375,
    "a": -36.9598617553711,
    "b": 15.5901546478272,
    "C": 40.1133918762207,
    "h": 157.129348754883,
    "CMY_C": 0.51663267612457,
    "CMY_M": 0.17397570610046,
    "CMY_Y": 0.36718916893005,
    "CMYK_C": 0.41482675075531,
    "CMYK_M": 0,
    "CMYK_Y": 0.23390772938728,
    "CMYK_K": 0.17397570610046
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0411",
    "Farbtonhilfsbezeichnung": "02.033.03",
    "Farbtonklasse": "02",
    "Rcolor": "81",
    "Gcolor": "195",
    "Bcolor": "138",
    "Y": 42.4938011169434,
    "L": 71.2100448608398,
    "a": -45.1186408996582,
    "b": 18.3584117889404,
    "C": 48.7106056213379,
    "h": 157.858993530273,
    "CMY_C": 0.68174457550049,
    "CMY_M": 0.23643153905869,
    "CMY_Y": 0.45827740430832,
    "CMYK_C": 0.58319985866547,
    "CMYK_M": 0,
    "CMYK_Y": 0.29053828120232,
    "CMYK_K": 0.23643153905869
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0412",
    "Farbtonhilfsbezeichnung": "02.033.04",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "181",
    "Bcolor": "123",
    "Y": 34.9006614685059,
    "L": 65.6712493896484,
    "a": -49.7808685302734,
    "b": 18.6425132751465,
    "C": 53.1571083068848,
    "h": 159.469497680664,
    "CMY_C": 0.84720152616501,
    "CMY_M": 0.29032117128372,
    "CMY_Y": 0.51660889387131,
    "CMYK_C": 0.78469347953796,
    "CMYK_M": 0,
    "CMYK_Y": 0.31885933876038,
    "CMYK_K": 0.29032117128372
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0413",
    "Farbtonhilfsbezeichnung": "02.033.05",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "149",
    "Bcolor": "100",
    "Y": 22.951774597168,
    "L": 55.0226287841797,
    "a": -41.790657043457,
    "b": 16.9935989379883,
    "C": 45.1136512756348,
    "h": 157.871551513672,
    "CMY_C": 0.83685433864594,
    "CMY_M": 0.41500419378281,
    "CMY_Y": 0.60809123516083,
    "CMYK_C": 0.72111654281616,
    "CMYK_M": 0,
    "CMYK_Y": 0.33006569743156,
    "CMYK_K": 0.41500419378281
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0414",
    "Farbtonhilfsbezeichnung": "02.033.06",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "80",
    "Y": 14.6284980773926,
    "L": 45.1211090087891,
    "a": -44.1127471923828,
    "b": 14.5658273696899,
    "C": 46.4553298950195,
    "h": 161.727005004883,
    "CMY_C": 1,
    "CMY_M": 0.51432502269745,
    "CMY_Y": 0.68515545129776,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.35173818469048,
    "CMYK_K": 0.51432502269745
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0415",
    "Farbtonhilfsbezeichnung": "02.034.01",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "221",
    "Bcolor": "144",
    "Y": 62.502815246582,
    "L": 83.1800918579102,
    "a": -29.3736190795898,
    "b": 32.1374168395996,
    "C": 43.5387535095215,
    "h": 132.427322387695,
    "CMY_C": 0.32646048069,
    "CMY_M": 0.13305747509003,
    "CMY_Y": 0.43539690971375,
    "CMYK_C": 0.22308631241322,
    "CMYK_M": 0,
    "CMYK_Y": 0.34874218702316,
    "CMYK_K": 0.13305747509003
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0416",
    "Farbtonhilfsbezeichnung": "02.034.02",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "212",
    "Bcolor": "123",
    "Y": 55.2763633728027,
    "L": 79.2001876831055,
    "a": -35.503288269043,
    "b": 37.4130783081055,
    "C": 51.5773391723633,
    "h": 133.49967956543,
    "CMY_C": 0.40847581624985,
    "CMY_M": 0.1670743227005,
    "CMY_Y": 0.51770639419556,
    "CMYK_C": 0.28982356190681,
    "CMYK_M": 0,
    "CMYK_Y": 0.42096441984177,
    "CMYK_K": 0.1670743227005
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0417",
    "Farbtonhilfsbezeichnung": "02.034.03",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "200",
    "Bcolor": "97",
    "Y": 46.5833892822266,
    "L": 73.922492980957,
    "a": -41.0297584533691,
    "b": 43.6619415283203,
    "C": 59.9149932861328,
    "h": 133.219848632813,
    "CMY_C": 0.49932539463043,
    "CMY_M": 0.21688973903656,
    "CMY_Y": 0.62128806114197,
    "CMYK_C": 0.36065885424614,
    "CMYK_M": 0,
    "CMYK_Y": 0.51640021800995,
    "CMYK_K": 0.21688973903656
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0418",
    "Farbtonhilfsbezeichnung": "02.034.04",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "171",
    "Bcolor": "86",
    "Y": 32.5952110290527,
    "L": 63.8318023681641,
    "a": -37.3223266601563,
    "b": 36.5022926330566,
    "C": 52.2051086425781,
    "h": 135.636413574219,
    "CMY_C": 0.59077048301697,
    "CMY_M": 0.33107930421829,
    "CMY_Y": 0.66394329071045,
    "CMYK_C": 0.38822415471077,
    "CMYK_M": 0,
    "CMYK_Y": 0.49761351943016,
    "CMYK_K": 0.33107930421829
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0419",
    "Farbtonhilfsbezeichnung": "02.034.05",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "145",
    "Bcolor": "57",
    "Y": 21.4710197448731,
    "L": 53.4611892700195,
    "a": -42.6690559387207,
    "b": 37.9033279418945,
    "C": 57.0728530883789,
    "h": 138.385009765625,
    "CMY_C": 0.75424540042877,
    "CMY_M": 0.43293428421021,
    "CMY_Y": 0.77591454982758,
    "CMYK_C": 0.56662058830261,
    "CMYK_M": 0,
    "CMYK_Y": 0.60483336448669,
    "CMYK_K": 0.43293428421021
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0420",
    "Farbtonhilfsbezeichnung": "02.034.06",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "114",
    "Bcolor": "64",
    "Y": 12.8966693878174,
    "L": 42.6071395874023,
    "a": -34.2776260375977,
    "b": 21.0778179168701,
    "C": 40.2396583557129,
    "h": 148.412033081055,
    "CMY_C": 0.83435243368149,
    "CMY_M": 0.55294102430344,
    "CMY_Y": 0.75070810317993,
    "CMYK_C": 0.6294726729393,
    "CMYK_M": 0,
    "CMYK_Y": 0.44237357378006,
    "CMYK_K": 0.55294102430344
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0421",
    "Farbtonhilfsbezeichnung": "02.035.01",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "233",
    "Bcolor": "152",
    "Y": 75.5350494384766,
    "L": 89.6430282592773,
    "a": -17.0848617553711,
    "b": 36.8759384155273,
    "C": 40.6414489746094,
    "h": 114.858589172363,
    "CMY_C": 0.14402341842651,
    "CMY_M": 0.08606153726578,
    "CMY_Y": 0.40211015939713,
    "CMYK_C": 0.06341989338398,
    "CMYK_M": 0,
    "CMYK_Y": 0.34580951929092,
    "CMYK_K": 0.08606153726578
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0422",
    "Farbtonhilfsbezeichnung": "02.035.02",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "225",
    "Bcolor": "123",
    "Y": 67.2350997924805,
    "L": 85.6225357055664,
    "a": -23.7778205871582,
    "b": 45.9216918945313,
    "C": 51.7125358581543,
    "h": 117.374694824219,
    "CMY_C": 0.22077590227127,
    "CMY_M": 0.11875373125076,
    "CMY_Y": 0.51628619432449,
    "CMYK_C": 0.11577033251524,
    "CMYK_M": 0,
    "CMYK_Y": 0.45110258460045,
    "CMYK_K": 0.11875373125076
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0423",
    "Farbtonhilfsbezeichnung": "02.035.03",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "208",
    "Bcolor": "100",
    "Y": 55.2262535095215,
    "L": 79.1714096069336,
    "a": -27.3518295288086,
    "b": 48.7217979431152,
    "C": 55.8742904663086,
    "h": 119.30933380127,
    "CMY_C": 0.3143008351326,
    "CMY_M": 0.18358635902405,
    "CMY_Y": 0.60594046115875,
    "CMYK_C": 0.16010814905167,
    "CMYK_M": 0,
    "CMYK_Y": 0.51732856035233,
    "CMYK_K": 0.18358635902405
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0424",
    "Farbtonhilfsbezeichnung": "02.035.04",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "193",
    "Bcolor": "85",
    "Y": 45.882511138916,
    "L": 73.4692306518555,
    "a": -29.5465259552002,
    "b": 49.2174682617188,
    "C": 57.4051933288574,
    "h": 120.977485656738,
    "CMY_C": 0.39275139570236,
    "CMY_M": 0.24187171459198,
    "CMY_Y": 0.66855251789093,
    "CMYK_C": 0.19901603460312,
    "CMYK_M": 0,
    "CMYK_Y": 0.56280815601349,
    "CMYK_K": 0.24187171459198
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0425",
    "Farbtonhilfsbezeichnung": "02.035.05",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "166",
    "Bcolor": "51",
    "Y": 31.9051914215088,
    "L": 63.2644462585449,
    "a": -29.8351249694824,
    "b": 52.1921157836914,
    "C": 60.1178131103516,
    "h": 119.754035949707,
    "CMY_C": 0.49952381849289,
    "CMY_M": 0.3508043885231,
    "CMY_Y": 0.79977685213089,
    "CMYK_C": 0.22908261418343,
    "CMYK_M": 0,
    "CMYK_Y": 0.69158273935318,
    "CMYK_K": 0.3508043885231
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0426",
    "Farbtonhilfsbezeichnung": "02.035.06",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "156",
    "Bcolor": "67",
    "Y": 27.0754642486572,
    "L": 59.0441093444824,
    "a": -34.001091003418,
    "b": 39.9386825561523,
    "C": 52.4516220092773,
    "h": 130.408828735352,
    "CMY_C": 0.60110712051392,
    "CMY_M": 0.38725858926773,
    "CMY_Y": 0.73643565177917,
    "CMYK_C": 0.34900289773941,
    "CMYK_M": 0,
    "CMYK_Y": 0.56986039876938,
    "CMYK_K": 0.38725858926773
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0427",
    "Farbtonhilfsbezeichnung": "02.036.01",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "210",
    "Bcolor": "153",
    "Y": 63.1893463134766,
    "L": 83.5419006347656,
    "a": -5.03848505020142,
    "b": 28.6602191925049,
    "C": 29.0997333526611,
    "h": 99.9707489013672,
    "CMY_C": 0.14186185598373,
    "CMY_M": 0.17827391624451,
    "CMY_Y": 0.40083932876587,
    "CMYK_C": 0,
    "CMYK_M": 0.04243146628141,
    "CMYK_Y": 0.30178996920586,
    "CMYK_K": 0.14186185598373
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0428",
    "Farbtonhilfsbezeichnung": "02.036.02",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "199",
    "Bcolor": "122",
    "Y": 55.2112693786621,
    "L": 79.1628036499023,
    "a": -7.87194538116455,
    "b": 38.4571723937988,
    "C": 39.2545738220215,
    "h": 101.568290710449,
    "CMY_C": 0.19095927476883,
    "CMY_M": 0.22142559289932,
    "CMY_Y": 0.52010363340378,
    "CMYK_C": 0,
    "CMYK_M": 0.03765733540058,
    "CMYK_Y": 0.40683287382126,
    "CMYK_K": 0.19095927476883
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0429",
    "Farbtonhilfsbezeichnung": "02.036.03",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "176",
    "Bcolor": "93",
    "Y": 42.537052154541,
    "L": 71.2396240234375,
    "a": -6.48006820678711,
    "b": 43.2133941650391,
    "C": 43.6965522766113,
    "h": 98.5282516479492,
    "CMY_C": 0.26184850931168,
    "CMY_M": 0.31000846624374,
    "CMY_Y": 0.63570839166641,
    "CMYK_C": 0,
    "CMYK_M": 0.06524400413036,
    "CMYK_Y": 0.50648123025894,
    "CMYK_K": 0.26184850931168
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0430",
    "Farbtonhilfsbezeichnung": "02.036.04",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "146",
    "Bcolor": "67",
    "Y": 28.1243858337402,
    "L": 60.0009422302246,
    "a": -5.36093187332153,
    "b": 42.3008880615234,
    "C": 42.6392402648926,
    "h": 97.2227783203125,
    "CMY_C": 0.37923818826675,
    "CMY_M": 0.42915868759155,
    "CMY_Y": 0.73798489570618,
    "CMYK_C": 0,
    "CMYK_M": 0.08041812479496,
    "CMYK_Y": 0.57791364192963,
    "CMYK_K": 0.37923818826675
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0431",
    "Farbtonhilfsbezeichnung": "02.036.05",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "125",
    "Bcolor": "55",
    "Y": 19.832971572876,
    "L": 51.647834777832,
    "a": -6.07367324829102,
    "b": 38.0616035461426,
    "C": 38.5431594848633,
    "h": 99.0665283203125,
    "CMY_C": 0.47822332382202,
    "CMY_M": 0.51134896278381,
    "CMY_Y": 0.78448575735092,
    "CMYK_C": 0,
    "CMYK_M": 0.0634862408042,
    "CMYK_Y": 0.58696073293686,
    "CMYK_K": 0.47822332382202
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0432",
    "Farbtonhilfsbezeichnung": "02.036.06",
    "Farbtonklasse": "04",
    "Rcolor": "108",
    "Gcolor": "105",
    "Bcolor": "62",
    "Y": 13.6990909576416,
    "L": 43.7982635498047,
    "a": -5.58006763458252,
    "b": 24.5896987915039,
    "C": 25.2148857116699,
    "h": 102.785430908203,
    "CMY_C": 0.57482254505157,
    "CMY_M": 0.58747500181198,
    "CMY_Y": 0.75876116752625,
    "CMYK_C": 0,
    "CMYK_M": 0.02975806221366,
    "CMYK_Y": 0.43261611461639,
    "CMYK_K": 0.57482254505157
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0433",
    "Farbtonhilfsbezeichnung": "03.001.01",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "95",
    "Y": 62.1492729187012,
    "L": 82.9927368164063,
    "a": 12.8304424285889,
    "b": 57.3880233764648,
    "C": 58.8048095703125,
    "h": 77.3974380493164,
    "CMY_C": 0,
    "CMY_M": 0.23268276453018,
    "CMY_Y": 0.62621808052063,
    "CMYK_C": 0,
    "CMYK_M": 0.23268276453018,
    "CMYK_Y": 0.62621808052063,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0434",
    "Farbtonhilfsbezeichnung": "03.001.02",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "168",
    "Bcolor": "0",
    "Y": 49.3121185302734,
    "L": 75.6450881958008,
    "a": 22.9647598266602,
    "b": 80.8101654052734,
    "C": 84.009895324707,
    "h": 74.1358261108398,
    "CMY_C": 0,
    "CMY_M": 0.34170365333557,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.34170365333557,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0435",
    "Farbtonhilfsbezeichnung": "03.001.03",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "169",
    "Bcolor": "32",
    "Y": 48.4328765869141,
    "L": 75.0971374511719,
    "a": 19.2641143798828,
    "b": 73.2933959960938,
    "C": 75.7827682495117,
    "h": 75.2737045288086,
    "CMY_C": 0.02950602769852,
    "CMY_M": 0.33623296022415,
    "CMY_Y": 0.87646639347076,
    "CMYK_C": 0,
    "CMYK_M": 0.31605237722397,
    "CMYK_Y": 0.87271058559418,
    "CMYK_K": 0.02950602769852
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0436",
    "Farbtonhilfsbezeichnung": "03.001.04",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "148",
    "Bcolor": "29",
    "Y": 37.4809646606445,
    "L": 67.6363220214844,
    "a": 21.5493545532227,
    "b": 66.9021148681641,
    "C": 70.2870407104492,
    "h": 72.1461029052734,
    "CMY_C": 0.11212158203125,
    "CMY_M": 0.41989094018936,
    "CMY_Y": 0.88461148738861,
    "CMYK_C": 0,
    "CMYK_M": 0.34663456678391,
    "CMYK_Y": 0.87004017829895,
    "CMYK_K": 0.11212158203125
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0437",
    "Farbtonhilfsbezeichnung": "03.001.05",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "175",
    "Bcolor": "96",
    "Y": 48.5816383361816,
    "L": 75.190315246582,
    "a": 12.1546754837036,
    "b": 47.466495513916,
    "C": 48.9980049133301,
    "h": 75.6369857788086,
    "CMY_C": 0.09355944395065,
    "CMY_M": 0.31301456689835,
    "CMY_Y": 0.62430691719055,
    "CMYK_C": 0,
    "CMYK_M": 0.24210646748543,
    "CMYK_Y": 0.58552926778793,
    "CMYK_K": 0.09355944395065
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0438",
    "Farbtonhilfsbezeichnung": "03.001.06",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "158",
    "Bcolor": "83",
    "Y": 40.200439453125,
    "L": 69.6120529174805,
    "a": 15.4364805221558,
    "b": 47.1811943054199,
    "C": 49.642219543457,
    "h": 71.8832244873047,
    "CMY_C": 0.13975840806961,
    "CMY_M": 0.38022476434708,
    "CMY_Y": 0.67617893218994,
    "CMYK_C": 0,
    "CMYK_M": 0.27953350543976,
    "CMYK_Y": 0.62356960773468,
    "CMYK_K": 0.13975840806961
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0439",
    "Farbtonhilfsbezeichnung": "03.002.01",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "178",
    "Bcolor": "106",
    "Y": 54.9474792480469,
    "L": 79.0110015869141,
    "a": 22.5450248718262,
    "b": 47.5947952270508,
    "C": 52.664436340332,
    "h": 64.6537017822266,
    "CMY_C": 0,
    "CMY_M": 0.30094331502914,
    "CMY_Y": 0.58376950025558,
    "CMYK_C": 0,
    "CMYK_M": 0.30094331502914,
    "CMYK_Y": 0.58376950025558,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0440",
    "Farbtonhilfsbezeichnung": "03.002.02",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "147",
    "Bcolor": "43",
    "Y": 40.9531517028809,
    "L": 70.1430892944336,
    "a": 30.9021224975586,
    "b": 65.9221038818359,
    "C": 72.8056640625,
    "h": 64.8843612670898,
    "CMY_C": 0.0304741859436,
    "CMY_M": 0.42227137088776,
    "CMY_Y": 0.83258324861526,
    "CMYK_C": 0,
    "CMYK_M": 0.40411216020584,
    "CMYK_Y": 0.82732099294662,
    "CMYK_K": 0.0304741859436
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0441",
    "Farbtonhilfsbezeichnung": "03.002.03",
    "Farbtonklasse": "04",
    "Rcolor": "215",
    "Gcolor": "126",
    "Bcolor": "46",
    "Y": 29.588809967041,
    "L": 61.2978057861328,
    "a": 29.1675968170166,
    "b": 55.2645111083984,
    "C": 62.4893188476563,
    "h": 62.1757316589355,
    "CMY_C": 0.15508079528809,
    "CMY_M": 0.50653403997421,
    "CMY_Y": 0.82062768936157,
    "CMYK_C": 0,
    "CMYK_M": 0.41596075892448,
    "CMYK_Y": 0.78770476579666,
    "CMYK_K": 0.15508079528809
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0442",
    "Farbtonhilfsbezeichnung": "03.002.04",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "158",
    "Bcolor": "90",
    "Y": 43.1272163391113,
    "L": 71.641227722168,
    "a": 22.9428539276123,
    "b": 46.352725982666,
    "C": 51.7199172973633,
    "h": 63.6663246154785,
    "CMY_C": 0.07313692569733,
    "CMY_M": 0.37987291812897,
    "CMY_Y": 0.64717882871628,
    "CMYK_C": 0,
    "CMYK_M": 0.33093991875648,
    "CMYK_Y": 0.61933839321136,
    "CMYK_K": 0.07313692569733
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0443",
    "Farbtonhilfsbezeichnung": "03.002.05",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "124",
    "Bcolor": "59",
    "Y": 27.7988662719727,
    "L": 59.7065887451172,
    "a": 26.1941089630127,
    "b": 47.0564002990723,
    "C": 53.8556976318359,
    "h": 60.897346496582,
    "CMY_C": 0.19606626033783,
    "CMY_M": 0.51238292455673,
    "CMY_Y": 0.76721513271332,
    "CMYK_C": 0,
    "CMYK_M": 0.3934611082077,
    "CMYK_Y": 0.71044272184372,
    "CMYK_K": 0.19606626033783
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0444",
    "Farbtonhilfsbezeichnung": "03.002.06",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "109",
    "Bcolor": "56",
    "Y": 20.9190044403076,
    "L": 52.8607292175293,
    "a": 23.1771755218506,
    "b": 40.1505584716797,
    "C": 46.359992980957,
    "h": 60.0040245056152,
    "CMY_C": 0.29764956235886,
    "CMY_M": 0.57073628902435,
    "CMY_Y": 0.77923804521561,
    "CMYK_C": 0,
    "CMYK_M": 0.38881832361221,
    "CMYK_Y": 0.68568116426468,
    "CMYK_K": 0.29764956235886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0445",
    "Farbtonhilfsbezeichnung": "03.003.01",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "218",
    "Bcolor": "193",
    "Y": 74.2045364379883,
    "L": 89.0190582275391,
    "a": 8.15273952484131,
    "b": 15.5879545211792,
    "C": 17.5912342071533,
    "h": 62.3897399902344,
    "CMY_C": 0.01707655191422,
    "CMY_M": 0.14678090810776,
    "CMY_Y": 0.24368941783905,
    "CMYK_C": 0,
    "CMYK_M": 0.1319577395916,
    "CMYK_Y": 0.23054985702038,
    "CMYK_K": 0.01707655191422
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0446",
    "Farbtonhilfsbezeichnung": "03.003.02",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "180",
    "Bcolor": "138",
    "Y": 55.8686180114746,
    "L": 79.5389862060547,
    "a": 22.9779300689697,
    "b": 31.535343170166,
    "C": 39.0187530517578,
    "h": 53.9213981628418,
    "CMY_C": 0,
    "CMY_M": 0.29362559318542,
    "CMY_Y": 0.45730596780777,
    "CMYK_C": 0,
    "CMYK_M": 0.29362559318542,
    "CMYK_Y": 0.45730596780777,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0447",
    "Farbtonhilfsbezeichnung": "03.003.03",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "169",
    "Bcolor": "114",
    "Y": 50.3868026733398,
    "L": 76.3060684204102,
    "a": 25.5989170074463,
    "b": 39.9141578674316,
    "C": 47.4177665710449,
    "h": 57.3259468078613,
    "CMY_C": 0.00944519042969,
    "CMY_M": 0.33743715286255,
    "CMY_Y": 0.55126368999481,
    "CMYK_C": 0,
    "CMYK_M": 0.33111944794655,
    "CMYK_Y": 0.54698485136032,
    "CMYK_K": 0.00944519042969
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0448",
    "Farbtonhilfsbezeichnung": "03.003.04",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "157",
    "Bcolor": "112",
    "Y": 43.2944107055664,
    "L": 71.7543411254883,
    "a": 26.0364055633545,
    "b": 35.2981872558594,
    "C": 43.8617897033691,
    "h": 53.587028503418,
    "CMY_C": 0.06699591875076,
    "CMY_M": 0.38595849275589,
    "CMY_Y": 0.56221270561218,
    "CMYK_C": 0,
    "CMYK_M": 0.3418662250042,
    "CMYK_Y": 0.53077667951584,
    "CMYK_K": 0.06699591875076
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0449",
    "Farbtonhilfsbezeichnung": "03.003.05",
    "Farbtonklasse": "04",
    "Rcolor": "199",
    "Gcolor": "124",
    "Bcolor": "85",
    "Y": 27.1645374298096,
    "L": 59.1263122558594,
    "a": 25.6699142456055,
    "b": 33.0789337158203,
    "C": 41.8707580566406,
    "h": 52.1878242492676,
    "CMY_C": 0.21927279233932,
    "CMY_M": 0.51453459262848,
    "CMY_Y": 0.66848850250244,
    "CMYK_C": 0,
    "CMYK_M": 0.37818819284439,
    "CMYK_Y": 0.57538115978241,
    "CMYK_K": 0.21927279233932
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0450",
    "Farbtonhilfsbezeichnung": "03.003.06",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "107",
    "Bcolor": "68",
    "Y": 19.9783382415771,
    "L": 51.8127174377441,
    "a": 23.2191772460938,
    "b": 32.6360702514648,
    "C": 40.0530052185059,
    "h": 54.569766998291,
    "CMY_C": 0.31647330522537,
    "CMY_M": 0.58008134365082,
    "CMY_Y": 0.73428577184677,
    "CMYK_C": 0,
    "CMYK_M": 0.38565874099731,
    "CMYK_Y": 0.61125993728638,
    "CMYK_K": 0.31647330522537
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0451",
    "Farbtonhilfsbezeichnung": "03.004.01",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "181",
    "Bcolor": "149",
    "Y": 54.0507507324219,
    "L": 78.4913177490234,
    "a": 18.3071365356445,
    "b": 24.1721992492676,
    "C": 30.3223762512207,
    "h": 52.8610458374023,
    "CMY_C": 0.05219435691833,
    "CMY_M": 0.29009789228439,
    "CMY_Y": 0.41531789302826,
    "CMYK_C": 0,
    "CMYK_M": 0.25100454688072,
    "CMYK_Y": 0.38312023878098,
    "CMYK_K": 0.05219435691833
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0452",
    "Farbtonhilfsbezeichnung": "03.004.02",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "161",
    "Bcolor": "128",
    "Y": 45.3294143676758,
    "L": 73.1082763671875,
    "a": 25.9635047912598,
    "b": 28.1876277923584,
    "C": 38.3229179382324,
    "h": 47.3519592285156,
    "CMY_C": 0.06145703792572,
    "CMY_M": 0.37008190155029,
    "CMY_Y": 0.49730348587036,
    "CMYK_C": 0,
    "CMYK_M": 0.32883402705193,
    "CMYK_Y": 0.46438625454903,
    "CMYK_K": 0.06145703792572
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0453",
    "Farbtonhilfsbezeichnung": "03.004.03",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "147",
    "Bcolor": "114",
    "Y": 37.9866905212402,
    "L": 68.0108032226563,
    "a": 25.4794635772705,
    "b": 28.721960067749,
    "C": 38.3947143554688,
    "h": 48.4235305786133,
    "CMY_C": 0.12304794788361,
    "CMY_M": 0.42210572957993,
    "CMY_Y": 0.55188977718353,
    "CMYK_C": 0,
    "CMYK_M": 0.34101954102516,
    "CMYK_Y": 0.48901399970055,
    "CMYK_K": 0.12304794788361
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0454",
    "Farbtonhilfsbezeichnung": "03.004.04",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "123",
    "Bcolor": "86",
    "Y": 29.4584445953369,
    "L": 61.1841163635254,
    "a": 33.4725723266602,
    "b": 35.5132217407227,
    "C": 48.8016586303711,
    "h": 46.6943550109863,
    "CMY_C": 0.15017402172089,
    "CMY_M": 0.51889741420746,
    "CMY_Y": 0.6640704870224,
    "CMYK_C": 0,
    "CMYK_M": 0.43388104438782,
    "CMYK_Y": 0.60470789670944,
    "CMYK_K": 0.15017402172089
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0455",
    "Farbtonhilfsbezeichnung": "03.004.05",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "110",
    "Bcolor": "78",
    "Y": 24.7189636230469,
    "L": 56.8005714416504,
    "a": 34.5977096557617,
    "b": 34.1770095825195,
    "C": 48.6319808959961,
    "h": 44.6495208740234,
    "CMY_C": 0.19727492332458,
    "CMY_M": 0.56703782081604,
    "CMY_Y": 0.69550734758377,
    "CMYK_C": 0,
    "CMYK_M": 0.46063452959061,
    "CMYK_Y": 0.62067627906799,
    "CMYK_K": 0.19727492332458
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0456",
    "Farbtonhilfsbezeichnung": "03.004.06",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "91",
    "Bcolor": "60",
    "Y": 18.6748924255371,
    "L": 50.3046569824219,
    "a": 37.8051147460938,
    "b": 35.6291313171387,
    "C": 51.9486465454102,
    "h": 43.3027229309082,
    "CMY_C": 0.25597250461578,
    "CMY_M": 0.64417839050293,
    "CMY_Y": 0.76440417766571,
    "CMYK_C": 0,
    "CMYK_M": 0.52176284790039,
    "CMYK_Y": 0.68335062265396,
    "CMYK_K": 0.25597250461578
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0457",
    "Farbtonhilfsbezeichnung": "03.005.01",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "180",
    "Bcolor": "156",
    "Y": 55.5638618469238,
    "L": 79.3649520874023,
    "a": 23.7845764160156,
    "b": 21.8260478973389,
    "C": 32.2813034057617,
    "h": 42.5412178039551,
    "CMY_C": 0.01198607683182,
    "CMY_M": 0.29568606615067,
    "CMY_Y": 0.38822263479233,
    "CMYK_C": 0,
    "CMYK_M": 0.28714168071747,
    "CMYK_Y": 0.38080087304115,
    "CMYK_K": 0.01198607683182
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0458",
    "Farbtonhilfsbezeichnung": "03.005.02",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "147",
    "Bcolor": "119",
    "Y": 41.9006271362305,
    "L": 70.8023529052734,
    "a": 34.4798774719238,
    "b": 30.5525093078613,
    "C": 46.0686187744141,
    "h": 41.5440521240234,
    "CMY_C": 0.03602421283722,
    "CMY_M": 0.42157173156738,
    "CMY_Y": 0.53518551588058,
    "CMYK_C": 0,
    "CMYK_M": 0.39995560050011,
    "CMYK_Y": 0.51781517267227,
    "CMYK_K": 0.03602421283722
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0459",
    "Farbtonhilfsbezeichnung": "03.005.03",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "125",
    "Bcolor": "102",
    "Y": 31.4900169372559,
    "L": 62.919132232666,
    "a": 36.1111831665039,
    "b": 29.0821361541748,
    "C": 46.3658065795898,
    "h": 38.8462257385254,
    "CMY_C": 0.122538626194,
    "CMY_M": 0.5088062286377,
    "CMY_Y": 0.60141563415527,
    "CMYK_C": 0,
    "CMYK_M": 0.44021037220955,
    "CMYK_Y": 0.54575282335281,
    "CMYK_K": 0.122538626194
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0460",
    "Farbtonhilfsbezeichnung": "03.005.04",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "108",
    "Bcolor": "89",
    "Y": 24.7999839782715,
    "L": 56.880012512207,
    "a": 37.4318809509277,
    "b": 28.1471080780029,
    "C": 46.8338050842285,
    "h": 36.941535949707,
    "CMY_C": 0.18771070241928,
    "CMY_M": 0.57507407665253,
    "CMY_Y": 0.65215086936951,
    "CMYK_C": 0,
    "CMYK_M": 0.47687858343124,
    "CMYK_Y": 0.57176691293716,
    "CMYK_K": 0.18771070241928
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0461",
    "Farbtonhilfsbezeichnung": "03.005.05",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "103",
    "Bcolor": "82",
    "Y": 24.4677600860596,
    "L": 56.5531120300293,
    "a": 41.6088943481445,
    "b": 31.6000900268555,
    "C": 52.248119354248,
    "h": 37.2150421142578,
    "CMY_C": 0.16617697477341,
    "CMY_M": 0.59476590156555,
    "CMY_Y": 0.67776072025299,
    "CMYK_C": 0,
    "CMYK_M": 0.51400464773178,
    "CMYK_Y": 0.61353993415833,
    "CMYK_K": 0.16617697477341
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0462",
    "Farbtonhilfsbezeichnung": "03.005.06",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "96",
    "Bcolor": "77",
    "Y": 19.7987403869629,
    "L": 51.6088943481445,
    "a": 36.5469589233398,
    "b": 27.8693294525146,
    "C": 45.9606323242188,
    "h": 37.3277740478516,
    "CMY_C": 0.25416380167007,
    "CMY_M": 0.62498551607132,
    "CMY_Y": 0.69958090782166,
    "CMYK_C": 0,
    "CMYK_M": 0.49718922376633,
    "CMYK_Y": 0.59720498323441,
    "CMYK_K": 0.25416380167007
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0463",
    "Farbtonhilfsbezeichnung": "03.006.01",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "153",
    "Bcolor": "133",
    "Y": 38.7085952758789,
    "L": 68.5396499633789,
    "a": 20.5320930480957,
    "b": 18.8864841461182,
    "C": 27.8974208831787,
    "h": 42.6094589233398,
    "CMY_C": 0.16198754310608,
    "CMY_M": 0.40019446611404,
    "CMY_Y": 0.47831863164902,
    "CMYK_C": 0,
    "CMYK_M": 0.28425225615501,
    "CMYK_Y": 0.37747779488564,
    "CMYK_K": 0.16198754310608
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0464",
    "Farbtonhilfsbezeichnung": "03.006.02",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "137",
    "Bcolor": "119",
    "Y": 32.4506034851074,
    "L": 63.7135696411133,
    "a": 24.4830341339111,
    "b": 20.2244129180908,
    "C": 31.7560367584229,
    "h": 39.5586891174316,
    "CMY_C": 0.19100844860077,
    "CMY_M": 0.4617173075676,
    "CMY_Y": 0.53486311435699,
    "CMYK_C": 0,
    "CMYK_M": 0.33462506532669,
    "CMYK_Y": 0.4250411093235,
    "CMYK_K": 0.19100844860077
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0465",
    "Farbtonhilfsbezeichnung": "03.006.03",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 22.7368011474609,
    "L": 54.8001937866211,
    "a": 27.6895923614502,
    "b": 21.6778945922852,
    "C": 35.165958404541,
    "h": 38.0570220947266,
    "CMY_C": 0.27171498537064,
    "CMY_M": 0.56197321414948,
    "CMY_Y": 0.63025069236755,
    "CMYK_C": 0,
    "CMYK_M": 0.39855033159256,
    "CMYK_Y": 0.49230137467384,
    "CMYK_K": 0.27171498537064
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0466",
    "Farbtonhilfsbezeichnung": "03.006.04",
    "Farbtonklasse": "04",
    "Rcolor": "160",
    "Gcolor": "93",
    "Bcolor": "82",
    "Y": 16.0218124389648,
    "L": 47.0030937194824,
    "a": 26.2697010040283,
    "b": 17.7006206512451,
    "C": 31.6766338348389,
    "h": 33.9722328186035,
    "CMY_C": 0.37150675058365,
    "CMY_M": 0.63353735208511,
    "CMY_Y": 0.67717605829239,
    "CMYK_C": 0,
    "CMYK_M": 0.41691872477531,
    "CMYK_Y": 0.48635256290436,
    "CMYK_K": 0.37150675058365
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0467",
    "Farbtonhilfsbezeichnung": "03.006.05",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "76",
    "Bcolor": "61",
    "Y": 13.2194147109985,
    "L": 43.0920066833496,
    "a": 34.4119567871094,
    "b": 25.4757213592529,
    "C": 42.8158264160156,
    "h": 36.5131378173828,
    "CMY_C": 0.36496335268021,
    "CMY_M": 0.70079225301743,
    "CMY_Y": 0.7612601518631,
    "CMYK_C": 0,
    "CMYK_M": 0.52883386611938,
    "CMYK_Y": 0.62405341863632,
    "CMYK_K": 0.36496335268021
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0468",
    "Farbtonhilfsbezeichnung": "03.006.06",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "69",
    "Bcolor": "54",
    "Y": 13.5879335403442,
    "L": 43.6360855102539,
    "a": 42.0865173339844,
    "b": 30.8469371795654,
    "C": 52.1805381774902,
    "h": 36.2392196655273,
    "CMY_C": 0.31701415777206,
    "CMY_M": 0.72775709629059,
    "CMY_Y": 0.78956526517868,
    "CMYK_C": 0,
    "CMYK_M": 0.6013930439949,
    "CMYK_Y": 0.69189006090164,
    "CMYK_K": 0.31701415777206
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0469",
    "Farbtonhilfsbezeichnung": "03.007.01",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "206",
    "Bcolor": "200",
    "Y": 65.3717956542969,
    "L": 84.6749572753906,
    "a": 8.38629055023193,
    "b": 5.2914662361145,
    "C": 9.91612243652344,
    "h": 32.2505416870117,
    "CMY_C": 0.09186774492264,
    "CMY_M": 0.19241768121719,
    "CMY_Y": 0.21489286422729,
    "CMYK_C": 0,
    "CMYK_M": 0.11072168499231,
    "CMYK_Y": 0.13547049462795,
    "CMYK_K": 0.09186774492264
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0470",
    "Farbtonhilfsbezeichnung": "03.007.02",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "193",
    "Bcolor": "188",
    "Y": 56.9350662231445,
    "L": 80.1430587768555,
    "a": 9.48096370697021,
    "b": 5.2801456451416,
    "C": 10.8521251678467,
    "h": 29.1143436431885,
    "CMY_C": 0.13469070196152,
    "CMY_M": 0.24442273378372,
    "CMY_Y": 0.26330977678299,
    "CMYK_C": 0,
    "CMYK_M": 0.12681250274181,
    "CMYK_Y": 0.14863942563534,
    "CMYK_K": 0.13469070196152
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0471",
    "Farbtonhilfsbezeichnung": "03.007.03",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "171",
    "Bcolor": "166",
    "Y": 44.4561920166016,
    "L": 72.5323638916016,
    "a": 11.4388275146484,
    "b": 5.86841154098511,
    "C": 12.8563222885132,
    "h": 27.1589851379395,
    "CMY_C": 0.2036828994751,
    "CMY_M": 0.33086282014847,
    "CMY_Y": 0.34754717350006,
    "CMYK_C": 0,
    "CMYK_M": 0.15971013903618,
    "CMYK_Y": 0.18066203594208,
    "CMYK_K": 0.2036828994751
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0472",
    "Farbtonhilfsbezeichnung": "03.007.04",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "159",
    "Bcolor": "150",
    "Y": 39.2711601257324,
    "L": 68.9472351074219,
    "a": 13.7942695617676,
    "b": 10.0626859664917,
    "C": 17.0745277404785,
    "h": 36.1101188659668,
    "CMY_C": 0.21738892793655,
    "CMY_M": 0.37566560506821,
    "CMY_Y": 0.41366416215897,
    "CMYK_C": 0,
    "CMYK_M": 0.20224180817604,
    "CMYK_Y": 0.25079536437988,
    "CMYK_K": 0.21738892793655
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0473",
    "Farbtonhilfsbezeichnung": "03.007.05",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "125",
    "Bcolor": "112",
    "Y": 25.2013568878174,
    "L": 57.2710876464844,
    "a": 18.1544418334961,
    "b": 14.765097618103,
    "C": 23.4006805419922,
    "h": 39.1216278076172,
    "CMY_C": 0.3089228272438,
    "CMY_M": 0.50802344083786,
    "CMY_Y": 0.56184375286102,
    "CMYK_C": 0,
    "CMYK_M": 0.28810185194016,
    "CMYK_Y": 0.36598071455956,
    "CMYK_K": 0.3089228272438
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0474",
    "Farbtonhilfsbezeichnung": "03.007.06",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "108",
    "Bcolor": "101",
    "Y": 18.3949089050293,
    "L": 49.9716262817383,
    "a": 16.8992824554443,
    "b": 10.6607694625854,
    "C": 19.9809341430664,
    "h": 32.245433807373,
    "CMY_C": 0.40216857194901,
    "CMY_M": 0.57612931728363,
    "CMY_Y": 0.60509634017944,
    "CMYK_C": 0,
    "CMYK_M": 0.29098626971245,
    "CMYK_Y": 0.33943977952003,
    "CMYK_K": 0.40216857194901
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0475",
    "Farbtonhilfsbezeichnung": "03.008.01",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "148",
    "Bcolor": "151",
    "Y": 32.1485328674316,
    "L": 63.4654541015625,
    "a": 9.35934066772461,
    "b": 0.92478007078171,
    "C": 9.40491771697998,
    "h": 5.64297914505005,
    "CMY_C": 0.3286846280098,
    "CMY_M": 0.41895371675491,
    "CMY_Y": 0.40727519989014,
    "CMYK_C": 0,
    "CMYK_M": 0.13446599245071,
    "CMYK_Y": 0.11706952750683,
    "CMYK_K": 0.3286846280098
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0476",
    "Farbtonhilfsbezeichnung": "03.008.02",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "131",
    "Bcolor": "134",
    "Y": 25.1476593017578,
    "L": 57.2190132141113,
    "a": 10.4195756912231,
    "b": 1.49197256565094,
    "C": 10.5258512496948,
    "h": 8.14875602722168,
    "CMY_C": 0.38583552837372,
    "CMY_M": 0.48533207178116,
    "CMY_Y": 0.47433418035507,
    "CMYK_C": 0,
    "CMYK_M": 0.1620030850172,
    "CMYK_Y": 0.14409601688385,
    "CMYK_K": 0.38583552837372
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0477",
    "Farbtonhilfsbezeichnung": "03.008.03",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "120",
    "Bcolor": "126",
    "Y": 22.0173015594482,
    "L": 54.0453567504883,
    "a": 15.2911729812622,
    "b": 1.39253675937653,
    "C": 15.3544502258301,
    "h": 5.20345973968506,
    "CMY_C": 0.388338804245,
    "CMY_M": 0.52931845188141,
    "CMY_Y": 0.50466138124466,
    "CMYK_C": 0,
    "CMYK_M": 0.23048649728298,
    "CMYK_Y": 0.19017484784126,
    "CMYK_K": 0.388338804245
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0478",
    "Farbtonhilfsbezeichnung": "03.008.04",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "92",
    "Bcolor": "100",
    "Y": 13.0645933151245,
    "L": 42.8604125976563,
    "a": 15.873984336853,
    "b": 0.76781761646271,
    "C": 15.8925428390503,
    "h": 2.76921343803406,
    "CMY_C": 0.50176870822906,
    "CMY_M": 0.63962179422379,
    "CMY_Y": 0.60926562547684,
    "CMYK_C": 0,
    "CMYK_M": 0.27668491005898,
    "CMYK_Y": 0.21575705707073,
    "CMYK_K": 0.50176870822906
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0479",
    "Farbtonhilfsbezeichnung": "03.008.05",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "70",
    "Bcolor": "80",
    "Y": 8.01337623596191,
    "L": 34.0107269287109,
    "a": 16.8431434631348,
    "b": -0.06102271750569,
    "C": 16.8432540893555,
    "h": 359.792419433594,
    "CMY_C": 0.58667325973511,
    "CMY_M": 0.72460925579071,
    "CMY_Y": 0.68662399053574,
    "CMYK_C": 0,
    "CMYK_M": 0.33372142910957,
    "CMYK_Y": 0.24182014167309,
    "CMYK_K": 0.58667325973511
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0480",
    "Farbtonhilfsbezeichnung": "03.008.06",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "58",
    "Bcolor": "66",
    "Y": 5.96728944778442,
    "L": 29.3297863006592,
    "a": 18.3190612792969,
    "b": 1.78872752189636,
    "C": 18.4061832427979,
    "h": 5.57685136795044,
    "CMY_C": 0.6213641166687,
    "CMY_M": 0.7715060710907,
    "CMY_Y": 0.73971766233444,
    "CMYK_C": 0,
    "CMYK_M": 0.39653387665749,
    "CMYK_Y": 0.31257879734039,
    "CMYK_K": 0.6213641166687
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0481",
    "Farbtonhilfsbezeichnung": "03.009.01",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "193",
    "Bcolor": "170",
    "Y": 54.111629486084,
    "L": 78.5267791748047,
    "a": 0.5951526761055,
    "b": 12.6343650817871,
    "C": 12.6483745574951,
    "h": 87.3030242919922,
    "CMY_C": 0.19591110944748,
    "CMY_M": 0.24224853515625,
    "CMY_Y": 0.33474361896515,
    "CMYK_C": 0,
    "CMYK_M": 0.05762724205852,
    "CMYK_Y": 0.17265816032887,
    "CMYK_K": 0.19591110944748
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0482",
    "Farbtonhilfsbezeichnung": "03.009.02",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "180",
    "Bcolor": "155",
    "Y": 46.5476379394531,
    "L": 73.8994827270508,
    "a": 0.67393487691879,
    "b": 14.0120391845703,
    "C": 14.0282373428345,
    "h": 87.2463760375977,
    "CMY_C": 0.24225014448166,
    "CMY_M": 0.29238587617874,
    "CMY_Y": 0.3927521109581,
    "CMYK_C": 0,
    "CMYK_M": 0.06616395711899,
    "CMYK_Y": 0.19861695170403,
    "CMYK_K": 0.24225014448166
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0483",
    "Farbtonhilfsbezeichnung": "03.009.03",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "146",
    "Bcolor": "123",
    "Y": 29.4845695495606,
    "L": 61.2069206237793,
    "a": 1.71410930156708,
    "b": 13.4882154464722,
    "C": 13.5966958999634,
    "h": 82.7575531005859,
    "CMY_C": 0.37197601795197,
    "CMY_M": 0.42735862731934,
    "CMY_Y": 0.51730048656464,
    "CMYK_C": 0,
    "CMYK_M": 0.08818550407887,
    "CMYK_Y": 0.23139955103397,
    "CMYK_K": 0.37197601795197
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0484",
    "Farbtonhilfsbezeichnung": "03.009.04",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "129",
    "Bcolor": "110",
    "Y": 22.5926513671875,
    "L": 54.6502571105957,
    "a": 2.30849242210388,
    "b": 11.7047443389893,
    "C": 11.9302215576172,
    "h": 78.8429183959961,
    "CMY_C": 0.44032800197601,
    "CMY_M": 0.49475646018982,
    "CMY_Y": 0.56935751438141,
    "CMYK_C": 0,
    "CMYK_M": 0.0972506403923,
    "CMYK_Y": 0.23054488003254,
    "CMYK_K": 0.44032800197601
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0485",
    "Farbtonhilfsbezeichnung": "03.009.05",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "109",
    "Bcolor": "97",
    "Y": 15.8100337982178,
    "L": 46.7242622375488,
    "a": 2.17837905883789,
    "b": 7.76124811172485,
    "C": 8.06116008758545,
    "h": 74.3219604492188,
    "CMY_C": 0.5304764509201,
    "CMY_M": 0.57189756631851,
    "CMY_Y": 0.61933887004852,
    "CMYK_C": 0,
    "CMYK_M": 0.08821946382523,
    "CMYK_Y": 0.18926084041595,
    "CMYK_K": 0.5304764509201
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0486",
    "Farbtonhilfsbezeichnung": "03.009.06",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "108",
    "Bcolor": "100",
    "Y": 15.1379871368408,
    "L": 45.8226127624512,
    "a": 0.22759540379047,
    "b": 4.32782173156738,
    "C": 4.33380222320557,
    "h": 86.9896545410156,
    "CMY_C": 0.56072294712067,
    "CMY_M": 0.57576113939285,
    "CMY_Y": 0.60592544078827,
    "CMYK_C": 0,
    "CMYK_M": 0.03423395752907,
    "CMYK_Y": 0.10290201753378,
    "CMYK_K": 0.56072294712067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0487",
    "Farbtonhilfsbezeichnung": "03.010.01",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "224",
    "Bcolor": "189",
    "Y": 73.3552703857422,
    "L": 88.6168823242188,
    "a": -4.31677961349487,
    "b": 16.621561050415,
    "C": 17.1729698181152,
    "h": 104.558631896973,
    "CMY_C": 0.10966742038727,
    "CMY_M": 0.1213886141777,
    "CMY_Y": 0.25775140523911,
    "CMYK_C": 0,
    "CMYK_M": 0.01316496077925,
    "CMYK_Y": 0.16632434725761,
    "CMYK_K": 0.10966742038727
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0488",
    "Farbtonhilfsbezeichnung": "03.010.02",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "207",
    "Bcolor": "171",
    "Y": 61.7269821166992,
    "L": 82.7680130004883,
    "a": -3.17112517356873,
    "b": 17.8963794708252,
    "C": 18.1751594543457,
    "h": 100.048156738281,
    "CMY_C": 0.16274625062943,
    "CMY_M": 0.18872553110123,
    "CMY_Y": 0.32905918359756,
    "CMYK_C": 0,
    "CMYK_M": 0.03102915920317,
    "CMYK_Y": 0.19864101707935,
    "CMYK_K": 0.16274625062943
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0489",
    "Farbtonhilfsbezeichnung": "03.010.03",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "197",
    "Bcolor": "150",
    "Y": 54.8806533813477,
    "L": 78.9724731445313,
    "a": -4.26547241210938,
    "b": 23.5928134918213,
    "C": 23.9753017425537,
    "h": 100.248115539551,
    "CMY_C": 0.19855540990829,
    "CMY_M": 0.22875875234604,
    "CMY_Y": 0.41049259901047,
    "CMYK_C": 0,
    "CMYK_M": 0.0376861281693,
    "CMYK_Y": 0.2644439637661,
    "CMYK_K": 0.19855540990829
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0490",
    "Farbtonhilfsbezeichnung": "03.010.04",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "175",
    "Bcolor": "126",
    "Y": 42.2032318115234,
    "L": 71.0108108520508,
    "a": -4.82325315475464,
    "b": 25.293607711792,
    "C": 25.7493762969971,
    "h": 100.796157836914,
    "CMY_C": 0.28559452295303,
    "CMY_M": 0.31312370300293,
    "CMY_Y": 0.50392496585846,
    "CMYK_C": 0,
    "CMYK_M": 0.03853439167142,
    "CMYK_Y": 0.30561137199402,
    "CMYK_K": 0.28559452295303
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0491",
    "Farbtonhilfsbezeichnung": "03.010.05",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "150",
    "Bcolor": "105",
    "Y": 29.9283924102783,
    "L": 61.5923843383789,
    "a": -4.42104959487915,
    "b": 24.2744827270508,
    "C": 24.6737957000732,
    "h": 100.321998596191,
    "CMY_C": 0.38555282354355,
    "CMY_M": 0.41216081380844,
    "CMY_Y": 0.58956050872803,
    "CMYK_C": 0,
    "CMYK_M": 0.04330395162106,
    "CMYK_Y": 0.33201825618744,
    "CMYK_K": 0.38555282354355
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0492",
    "Farbtonhilfsbezeichnung": "03.010.06",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "128",
    "Bcolor": "89",
    "Y": 21.4449138641357,
    "L": 53.433032989502,
    "a": -3.24617123603821,
    "b": 21.8935699462891,
    "C": 22.1329174041748,
    "h": 98.4338302612305,
    "CMY_C": 0.46743613481522,
    "CMY_M": 0.49701207876205,
    "CMY_Y": 0.6509593129158,
    "CMYK_C": 0,
    "CMYK_M": 0.05553501844406,
    "CMYK_Y": 0.34460312128067,
    "CMYK_K": 0.46743613481522
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0493",
    "Farbtonhilfsbezeichnung": "03.011.01",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "183",
    "Y": 75.0034332275391,
    "L": 89.3945999145508,
    "a": -1.61879181861877,
    "b": 20.8785629272461,
    "C": 20.9412250518799,
    "h": 94.4334869384766,
    "CMY_C": 0.06970757246017,
    "CMY_M": 0.12000006437302,
    "CMY_Y": 0.28064602613449,
    "CMYK_C": 0,
    "CMYK_M": 0.05406095087528,
    "CMYK_Y": 0.22674424946308,
    "CMYK_K": 0.06970757246017
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0494",
    "Farbtonhilfsbezeichnung": "03.011.02",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "163",
    "Y": 64.8606262207031,
    "L": 84.411865234375,
    "a": -0.65412366390228,
    "b": 24.8542728424072,
    "C": 24.8628787994385,
    "h": 91.5075836181641,
    "CMY_C": 0.10949230194092,
    "CMY_M": 0.17806720733643,
    "CMY_Y": 0.36264145374298,
    "CMYK_C": 0,
    "CMYK_M": 0.07700652629137,
    "CMYK_Y": 0.28427508473396,
    "CMYK_K": 0.10949230194092
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0495",
    "Farbtonhilfsbezeichnung": "03.011.03",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "202",
    "Bcolor": "149",
    "Y": 59.8397026062012,
    "L": 81.7509841918945,
    "a": -1.05934286117554,
    "b": 28.3752765655518,
    "C": 28.3950443267822,
    "h": 92.1380462646484,
    "CMY_C": 0.13458049297333,
    "CMY_M": 0.20687818527222,
    "CMY_Y": 0.41646534204483,
    "CMYK_C": 0,
    "CMYK_M": 0.08354063332081,
    "CMYK_Y": 0.32572045922279,
    "CMYK_K": 0.13458049297333
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0496",
    "Farbtonhilfsbezeichnung": "03.011.04",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "187",
    "Bcolor": "139",
    "Y": 50.5192108154297,
    "L": 76.3868560791016,
    "a": -0.37022703886032,
    "b": 26.1218242645264,
    "C": 26.1244468688965,
    "h": 90.8120040893555,
    "CMY_C": 0.19441211223602,
    "CMY_M": 0.26596421003342,
    "CMY_Y": 0.45474821329117,
    "CMYK_C": 0,
    "CMYK_M": 0.0888197273016,
    "CMYK_Y": 0.32316288352013,
    "CMYK_K": 0.19441211223602
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0497",
    "Farbtonhilfsbezeichnung": "03.011.05",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "145",
    "Bcolor": "106",
    "Y": 28.7750415802002,
    "L": 60.5825843811035,
    "a": 0.48305371403694,
    "b": 22.4052104949951,
    "C": 22.4104175567627,
    "h": 88.7649002075195,
    "CMY_C": 0.36772346496582,
    "CMY_M": 0.43279480934143,
    "CMY_Y": 0.585324883461,
    "CMYK_C": 0,
    "CMYK_M": 0.10291595757008,
    "CMYK_Y": 0.34415546059608,
    "CMYK_K": 0.36772346496582
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0498",
    "Farbtonhilfsbezeichnung": "03.011.06",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "125",
    "Bcolor": "85",
    "Y": 21.0238437652588,
    "L": 52.9755783081055,
    "a": -0.10402037203312,
    "b": 23.614917755127,
    "C": 23.6151466369629,
    "h": 90.2523803710938,
    "CMY_C": 0.44912213087082,
    "CMY_M": 0.50850033760071,
    "CMY_Y": 0.66648197174072,
    "CMYK_C": 0,
    "CMYK_M": 0.10778833180666,
    "CMYK_Y": 0.39456993341446,
    "CMYK_K": 0.44912213087082
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0499",
    "Farbtonhilfsbezeichnung": "03.012.01",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "221",
    "Bcolor": "196",
    "Y": 73.1901702880859,
    "L": 88.5383377075195,
    "a": 0.24791006743908,
    "b": 13.0485677719116,
    "C": 13.0509223937988,
    "h": 88.9115676879883,
    "CMY_C": 0.08628755807877,
    "CMY_M": 0.13205581903458,
    "CMY_Y": 0.23139369487762,
    "CMYK_C": 0,
    "CMYK_M": 0.05009044334292,
    "CMYK_Y": 0.15880940854549,
    "CMYK_K": 0.08628755807877
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0500",
    "Farbtonhilfsbezeichnung": "03.012.02",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "202",
    "Bcolor": "179",
    "Y": 59.9631195068359,
    "L": 81.8181381225586,
    "a": 0.39289200305939,
    "b": 12.4779376983643,
    "C": 12.4841213226318,
    "h": 88.1965255737305,
    "CMY_C": 0.16158890724182,
    "CMY_M": 0.20605510473251,
    "CMY_Y": 0.29895877838135,
    "CMYK_C": 0,
    "CMYK_M": 0.0530362688005,
    "CMYK_Y": 0.16384547948837,
    "CMYK_K": 0.16158890724182
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0501",
    "Farbtonhilfsbezeichnung": "03.012.03",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "170",
    "Bcolor": "150",
    "Y": 40.6290969848633,
    "L": 69.9152755737305,
    "a": 0.49585542082787,
    "b": 11.0404205322266,
    "C": 11.051549911499,
    "h": 87.4284133911133,
    "CMY_C": 0.29407232999802,
    "CMY_M": 0.33351677656174,
    "CMY_Y": 0.41269642114639,
    "CMYK_C": 0,
    "CMYK_M": 0.05587604641914,
    "CMYK_Y": 0.16804000735283,
    "CMYK_K": 0.29407232999802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0502",
    "Farbtonhilfsbezeichnung": "03.012.04",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "155",
    "Bcolor": "134",
    "Y": 33.4197006225586,
    "L": 64.4993133544922,
    "a": 0.9661266207695,
    "b": 12.1241722106934,
    "C": 12.1626043319702,
    "h": 85.443962097168,
    "CMY_C": 0.34561216831207,
    "CMY_M": 0.39144188165665,
    "CMY_Y": 0.47515910863876,
    "CMYK_C": 0,
    "CMYK_M": 0.07003448158503,
    "CMYK_Y": 0.19796660542488,
    "CMYK_K": 0.34561216831207
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0503",
    "Farbtonhilfsbezeichnung": "03.012.05",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "147",
    "Bcolor": "124",
    "Y": 29.682186126709,
    "L": 61.3790245056152,
    "a": 1.06714415550232,
    "b": 13.4323196411133,
    "C": 13.4746427536011,
    "h": 85.4576187133789,
    "CMY_C": 0.37462544441223,
    "CMY_M": 0.42413491010666,
    "CMY_Y": 0.51531445980072,
    "CMYK_C": 0,
    "CMYK_M": 0.07916770130396,
    "CMYK_Y": 0.2249675989151,
    "CMYK_K": 0.37462544441223
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0504",
    "Farbtonhilfsbezeichnung": "03.012.06",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "124",
    "Bcolor": "102",
    "Y": 20.5031414031982,
    "L": 52.4013671875,
    "a": 1.41374754905701,
    "b": 13.2660913467407,
    "C": 13.3412094116211,
    "h": 83.9170379638672,
    "CMY_C": 0.46567922830582,
    "CMY_M": 0.51556968688965,
    "CMY_Y": 0.60163432359695,
    "CMYK_C": 0,
    "CMYK_M": 0.09337173402309,
    "CMYK_Y": 0.2544447183609,
    "CMYK_K": 0.46567922830582
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0505",
    "Farbtonhilfsbezeichnung": "03.013.01",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "220",
    "Bcolor": "187",
    "Y": 73.5876388549805,
    "L": 88.7272262573242,
    "a": 2.37224268913269,
    "b": 18.2714405059814,
    "C": 18.4247951507568,
    "h": 82.6024780273438,
    "CMY_C": 0.05486106872559,
    "CMY_M": 0.13631999492645,
    "CMY_Y": 0.26768434047699,
    "CMYK_C": 0,
    "CMYK_M": 0.08618725091219,
    "CMYK_Y": 0.22517670691013,
    "CMYK_K": 0.05486106872559
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0506",
    "Farbtonhilfsbezeichnung": "03.013.02",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "202",
    "Bcolor": "162",
    "Y": 61.0106658935547,
    "L": 82.3844757080078,
    "a": 3.44293594360352,
    "b": 22.5442924499512,
    "C": 22.8056774139404,
    "h": 81.3169555664063,
    "CMY_C": 0.10891300439835,
    "CMY_M": 0.20945203304291,
    "CMY_Y": 0.36600583791733,
    "CMYK_C": 0,
    "CMYK_M": 0.11282739788294,
    "CMYK_Y": 0.28851598501205,
    "CMYK_K": 0.10891300439835
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0507",
    "Farbtonhilfsbezeichnung": "03.013.03",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "197",
    "Bcolor": "157",
    "Y": 57.8243980407715,
    "L": 80.6410598754883,
    "a": 2.78638315200806,
    "b": 22.7548236846924,
    "C": 22.9247894287109,
    "h": 83.0187530517578,
    "CMY_C": 0.13256984949112,
    "CMY_M": 0.22684246301651,
    "CMY_Y": 0.38580596446991,
    "CMYK_C": 0,
    "CMYK_M": 0.10868035256863,
    "CMYK_Y": 0.29193833470345,
    "CMYK_K": 0.13256984949112
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0508",
    "Farbtonhilfsbezeichnung": "03.013.04",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "173",
    "Bcolor": "126",
    "Y": 43.9300193786621,
    "L": 72.1816940307617,
    "a": 4.91298389434814,
    "b": 27.6589889526367,
    "C": 28.0919399261475,
    "h": 79.9277725219727,
    "CMY_C": 0.2029904127121,
    "CMY_M": 0.32342797517776,
    "CMY_Y": 0.50736367702484,
    "CMYK_C": 0,
    "CMYK_M": 0.15111181139946,
    "CMYK_Y": 0.3818941116333,
    "CMYK_K": 0.2029904127121
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0509",
    "Farbtonhilfsbezeichnung": "03.013.05",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "143",
    "Bcolor": "102",
    "Y": 28.9594535827637,
    "L": 60.7458267211914,
    "a": 4.19804906845093,
    "b": 25.0372409820557,
    "C": 25.3867492675781,
    "h": 80.4816284179688,
    "CMY_C": 0.33757847547531,
    "CMY_M": 0.44002687931061,
    "CMY_Y": 0.60142803192139,
    "CMYK_C": 0,
    "CMYK_M": 0.15465742349625,
    "CMYK_Y": 0.39831066131592,
    "CMYK_K": 0.33757847547531
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0510",
    "Farbtonhilfsbezeichnung": "03.013.06",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "114",
    "Bcolor": "78",
    "Y": 18.2725391387939,
    "L": 49.8250122070313,
    "a": 5.12321901321411,
    "b": 23.5044593811035,
    "C": 24.0563297271729,
    "h": 77.7036819458008,
    "CMY_C": 0.4504908323288,
    "CMY_M": 0.55116832256317,
    "CMY_Y": 0.6940581202507,
    "CMYK_C": 0,
    "CMYK_M": 0.18321348726749,
    "CMYK_Y": 0.44324517250061,
    "CMYK_K": 0.4504908323288
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0511",
    "Farbtonhilfsbezeichnung": "03.014.01",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "208",
    "Y": 81.950065612793,
    "L": 92.5528182983398,
    "a": 2.07339262962341,
    "b": 12.5213127136231,
    "C": 12.6918172836304,
    "h": 80.5977630615234,
    "CMY_C": 0.0288822054863,
    "CMY_M": 0.09166705608368,
    "CMY_Y": 0.18370896577835,
    "CMYK_C": 0,
    "CMYK_M": 0.06465214490891,
    "CMYK_Y": 0.15943148732185,
    "CMYK_K": 0.0288822054863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0512",
    "Farbtonhilfsbezeichnung": "03.014.02",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "221",
    "Bcolor": "193",
    "Y": 73.7783279418945,
    "L": 88.8176116943359,
    "a": 2.38898301124573,
    "b": 14.9255647659302,
    "C": 15.1155462265015,
    "h": 80.9063873291016,
    "CMY_C": 0.06231939792633,
    "CMY_M": 0.13455945253372,
    "CMY_Y": 0.24192279577255,
    "CMYK_C": 0,
    "CMYK_M": 0.07704121619463,
    "CMYK_Y": 0.19154006242752,
    "CMYK_K": 0.06231939792633
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0513",
    "Farbtonhilfsbezeichnung": "03.014.03",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "211",
    "Bcolor": "183",
    "Y": 66.3712768554688,
    "L": 85.1854476928711,
    "a": 2.31680226325989,
    "b": 15.0467348098755,
    "C": 15.2240533828735,
    "h": 81.246696472168,
    "CMY_C": 0.10339152812958,
    "CMY_M": 0.17443382740021,
    "CMY_Y": 0.2816698551178,
    "CMYK_C": 0,
    "CMYK_M": 0.07923447340727,
    "CMYK_Y": 0.19883631169796,
    "CMYK_K": 0.10339152812958
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0514",
    "Farbtonhilfsbezeichnung": "03.014.04",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "192",
    "Bcolor": "161",
    "Y": 54.6282424926758,
    "L": 78.8266448974609,
    "a": 3.14586901664734,
    "b": 17.839282989502,
    "C": 18.114538192749,
    "h": 79.9989929199219,
    "CMY_C": 0.16154414415359,
    "CMY_M": 0.24623030424118,
    "CMY_Y": 0.36880201101303,
    "CMYK_C": 0,
    "CMYK_M": 0.1010025292635,
    "CMYK_Y": 0.24718995392323,
    "CMYK_K": 0.16154414415359
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0515",
    "Farbtonhilfsbezeichnung": "03.014.05",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "178",
    "Bcolor": "136",
    "Y": 47.1470756530762,
    "L": 74.2837448120117,
    "a": 5.25171804428101,
    "b": 25.0704555511475,
    "C": 25.6146106719971,
    "h": 78.1688537597656,
    "CMY_C": 0.18226671218872,
    "CMY_M": 0.30146431922913,
    "CMY_Y": 0.46737575531006,
    "CMYK_C": 0,
    "CMYK_M": 0.14576587080956,
    "CMYK_Y": 0.34865775704384,
    "CMYK_K": 0.18226671218872
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0516",
    "Farbtonhilfsbezeichnung": "03.014.06",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "141",
    "Bcolor": "106",
    "Y": 28.5760364532471,
    "L": 60.4056243896484,
    "a": 5.14681577682495,
    "b": 21.8761196136475,
    "C": 22.4734134674072,
    "h": 76.7607421875,
    "CMY_C": 0.34096270799637,
    "CMY_M": 0.44511586427689,
    "CMY_Y": 0.58247071504593,
    "CMYK_C": 0,
    "CMYK_M": 0.15803833305836,
    "CMYK_Y": 0.36645576357841,
    "CMYK_K": 0.34096270799637
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0517",
    "Farbtonhilfsbezeichnung": "03.015.01",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "221",
    "Bcolor": "178",
    "Y": 74.4940795898438,
    "L": 89.1554794311523,
    "a": 3.39490365982056,
    "b": 23.5509929656982,
    "C": 23.7944240570068,
    "h": 81.7972564697266,
    "CMY_C": 0.03007656335831,
    "CMY_M": 0.13527745008469,
    "CMY_Y": 0.30221819877625,
    "CMYK_C": 0,
    "CMYK_M": 0.10846308618784,
    "CMYK_Y": 0.28058052062988,
    "CMYK_K": 0.03007656335831
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0518",
    "Farbtonhilfsbezeichnung": "03.015.02",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "202",
    "Bcolor": "156",
    "Y": 62.2125091552734,
    "L": 83.0262985229492,
    "a": 5.09670829772949,
    "b": 26.4960269927979,
    "C": 26.9817695617676,
    "h": 79.1117248535156,
    "CMY_C": 0.08189451694489,
    "CMY_M": 0.20733433961868,
    "CMY_Y": 0.38812577724457,
    "CMYK_C": 0,
    "CMYK_M": 0.13662898540497,
    "CMYK_Y": 0.33354693651199,
    "CMYK_K": 0.08189451694489
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0519",
    "Farbtonhilfsbezeichnung": "03.015.03",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "191",
    "Bcolor": "135",
    "Y": 55.7909660339355,
    "L": 79.4947052001953,
    "a": 6.70136690139771,
    "b": 32.7660331726074,
    "C": 33.4443016052246,
    "h": 78.4411697387695,
    "CMY_C": 0.099589407444,
    "CMY_M": 0.25075620412827,
    "CMY_Y": 0.47056609392166,
    "CMYK_C": 0,
    "CMYK_M": 0.16788651049137,
    "CMYK_Y": 0.41200834512711,
    "CMYK_K": 0.099589407444
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0520",
    "Farbtonhilfsbezeichnung": "03.015.04",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "171",
    "Bcolor": "114",
    "Y": 44.2213478088379,
    "L": 72.3761978149414,
    "a": 7.42107582092285,
    "b": 34.3776359558105,
    "C": 35.169506072998,
    "h": 77.8185272216797,
    "CMY_C": 0.1733415722847,
    "CMY_M": 0.32868909835815,
    "CMY_Y": 0.5539658665657,
    "CMYK_C": 0,
    "CMYK_M": 0.18792226910591,
    "CMYK_Y": 0.46043720841408,
    "CMYK_K": 0.1733415722847
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0521",
    "Farbtonhilfsbezeichnung": "03.015.05",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "147",
    "Bcolor": "85",
    "Y": 32.3153266906738,
    "L": 63.6026420593262,
    "a": 8.55233478546143,
    "b": 38.0309791564941,
    "C": 38.9807357788086,
    "h": 77.3262634277344,
    "CMY_C": 0.26010674238205,
    "CMY_M": 0.42332655191422,
    "CMY_Y": 0.66653883457184,
    "CMYK_C": 0,
    "CMYK_M": 0.22059912979603,
    "CMYK_Y": 0.54931181669235,
    "CMYK_K": 0.26010674238205
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0522",
    "Farbtonhilfsbezeichnung": "03.015.06",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "147",
    "Bcolor": "89",
    "Y": 31.8858737945557,
    "L": 63.2484512329102,
    "a": 7.21999883651733,
    "b": 35.4117965698242,
    "C": 36.1403350830078,
    "h": 78.4760971069336,
    "CMY_C": 0.27554416656494,
    "CMY_M": 0.42331451177597,
    "CMY_Y": 0.65093523263931,
    "CMYK_C": 0,
    "CMYK_M": 0.20397426187992,
    "CMYK_Y": 0.5181697010994,
    "CMYK_K": 0.27554416656494
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0523",
    "Farbtonhilfsbezeichnung": "03.016.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "197",
    "Y": 80.9525680541992,
    "L": 92.1105804443359,
    "a": 1.49170506000519,
    "b": 17.8703002929688,
    "C": 17.9324512481689,
    "h": 85.2283554077148,
    "CMY_C": 0.02381348609924,
    "CMY_M": 0.0965091586113,
    "CMY_Y": 0.22851687669754,
    "CMYK_C": 0,
    "CMYK_M": 0.07446903735399,
    "CMYK_Y": 0.20969700813293,
    "CMYK_K": 0.02381348609924
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0524",
    "Farbtonhilfsbezeichnung": "03.016.02",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "225",
    "Bcolor": "179",
    "Y": 77.2826995849609,
    "L": 90.4515762329102,
    "a": 2.70002961158752,
    "b": 24.9285984039307,
    "C": 25.0743923187256,
    "h": 83.818359375,
    "CMY_C": 0.01698350906372,
    "CMY_M": 0.11952048540115,
    "CMY_Y": 0.29888713359833,
    "CMYK_C": 0,
    "CMYK_M": 0.10430850088596,
    "CMYK_Y": 0.28677406907082,
    "CMYK_K": 0.01698350906372
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0525",
    "Farbtonhilfsbezeichnung": "03.016.03",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "163",
    "Y": 75.8298950195313,
    "L": 89.7803039550781,
    "a": 4.72403001785278,
    "b": 32.4337310791016,
    "C": 32.7759590148926,
    "h": 81.7130432128906,
    "CMY_C": 0,
    "CMY_M": 0.13351374864578,
    "CMY_Y": 0.36210137605667,
    "CMYK_C": 0,
    "CMYK_M": 0.13351374864578,
    "CMYK_Y": 0.36210137605667,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0526",
    "Farbtonhilfsbezeichnung": "03.016.04",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "205",
    "Bcolor": "143",
    "Y": 65.2540054321289,
    "L": 84.6144561767578,
    "a": 7.54956007003784,
    "b": 35.4424324035645,
    "C": 36.2375755310059,
    "h": 77.9751968383789,
    "CMY_C": 0.03029131889343,
    "CMY_M": 0.19790661334991,
    "CMY_Y": 0.43796396255493,
    "CMYK_C": 0,
    "CMYK_M": 0.17285118997097,
    "CMYK_Y": 0.42040732502937,
    "CMYK_K": 0.03029131889343
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0527",
    "Farbtonhilfsbezeichnung": "03.016.06",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "168",
    "Bcolor": "95",
    "Y": 43.7823028564453,
    "L": 72.0827484130859,
    "a": 10.9393224716187,
    "b": 43.926887512207,
    "C": 45.2685356140137,
    "h": 76.0158157348633,
    "CMY_C": 0.14152926206589,
    "CMY_M": 0.34214532375336,
    "CMY_Y": 0.62787872552872,
    "CMYK_C": 0,
    "CMYK_M": 0.2336900383234,
    "CMYK_Y": 0.5665300488472,
    "CMYK_K": 0.14152926206589
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0528",
    "Farbtonhilfsbezeichnung": "03.017.01",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "217",
    "Bcolor": "180",
    "Y": 71.5064849853516,
    "L": 87.7304992675781,
    "a": 3.37202644348145,
    "b": 20.1847152709961,
    "C": 20.4644393920898,
    "h": 80.5158386230469,
    "CMY_C": 0.05435645580292,
    "CMY_M": 0.15020138025284,
    "CMY_Y": 0.29231911897659,
    "CMYK_C": 0,
    "CMYK_M": 0.10135418176651,
    "CMYK_Y": 0.25164097547531,
    "CMYK_K": 0.05435645580292
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0529",
    "Farbtonhilfsbezeichnung": "03.017.02",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "207",
    "Bcolor": "168",
    "Y": 65.351318359375,
    "L": 84.6644439697266,
    "a": 4.45711469650269,
    "b": 22.6031818389893,
    "C": 23.0384387969971,
    "h": 78.8449783325195,
    "CMY_C": 0.07599014043808,
    "CMY_M": 0.18706464767456,
    "CMY_Y": 0.34239393472672,
    "CMYK_C": 0,
    "CMYK_M": 0.12020922452211,
    "CMYK_Y": 0.28831270337105,
    "CMYK_K": 0.07599014043808
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0530",
    "Farbtonhilfsbezeichnung": "03.017.03",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "194",
    "Bcolor": "150",
    "Y": 56.8109321594238,
    "L": 80.0731353759766,
    "a": 4.91151475906372,
    "b": 25.6030883789063,
    "C": 26.0699272155762,
    "h": 79.1407089233398,
    "CMY_C": 0.11846601963043,
    "CMY_M": 0.23871254920959,
    "CMY_Y": 0.41214436292648,
    "CMYK_C": 0,
    "CMYK_M": 0.13640600442886,
    "CMYK_Y": 0.3331446647644,
    "CMYK_K": 0.11846601963043
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0531",
    "Farbtonhilfsbezeichnung": "03.017.04",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "170",
    "Bcolor": "123",
    "Y": 43.9139709472656,
    "L": 72.1709594726563,
    "a": 8.49663162231445,
    "b": 29.0124588012695,
    "C": 30.2310352325439,
    "h": 73.6767272949219,
    "CMY_C": 0.17773807048798,
    "CMY_M": 0.33254778385162,
    "CMY_Y": 0.51652437448502,
    "CMYK_C": 0,
    "CMYK_M": 0.18827299773693,
    "CMYK_Y": 0.41201749444008,
    "CMYK_K": 0.17773807048798
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0532",
    "Farbtonhilfsbezeichnung": "03.017.05",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "168",
    "Bcolor": "109",
    "Y": 44.3471870422363,
    "L": 72.4599456787109,
    "a": 12.1205167770386,
    "b": 37.1704597473145,
    "C": 39.0966758728027,
    "h": 71.9399261474609,
    "CMY_C": 0.13906222581863,
    "CMY_M": 0.34014928340912,
    "CMY_Y": 0.57266801595688,
    "CMYK_C": 0,
    "CMYK_M": 0.23356747627258,
    "CMYK_Y": 0.50364357233047,
    "CMYK_K": 0.13906222581863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0533",
    "Farbtonhilfsbezeichnung": "03.017.06",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "139",
    "Bcolor": "84",
    "Y": 30.183443069458,
    "L": 61.8121757507324,
    "a": 13.9497747421265,
    "b": 36.5053329467773,
    "C": 39.0798606872559,
    "h": 69.0866546630859,
    "CMY_C": 0.25052523612976,
    "CMY_M": 0.45504289865494,
    "CMY_Y": 0.67092990875244,
    "CMYK_C": 0,
    "CMYK_M": 0.2728813290596,
    "CMYK_Y": 0.56093239784241,
    "CMYK_K": 0.25052523612976
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0534",
    "Farbtonhilfsbezeichnung": "03.018.01",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "223",
    "Bcolor": "184",
    "Y": 76.3925399780273,
    "L": 90.0412826538086,
    "a": 4.30406188964844,
    "b": 21.7065563201904,
    "C": 22.1291561126709,
    "h": 78.7846374511719,
    "CMY_C": 0.01779037714005,
    "CMY_M": 0.12729126214981,
    "CMY_Y": 0.27886283397675,
    "CMYK_C": 0,
    "CMYK_M": 0.11148422956467,
    "CMYK_Y": 0.26580116152763,
    "CMYK_K": 0.01779037714005
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0535",
    "Farbtonhilfsbezeichnung": "03.018.02",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "197",
    "Bcolor": "148",
    "Y": 60.5966873168945,
    "L": 82.1614456176758,
    "a": 9.02482032775879,
    "b": 29.5579681396484,
    "C": 30.905029296875,
    "h": 73.0211944580078,
    "CMY_C": 0.05960685014725,
    "CMY_M": 0.22716474533081,
    "CMY_Y": 0.41893166303635,
    "CMYK_C": 0,
    "CMYK_M": 0.17817856371403,
    "CMYK_Y": 0.38210064172745,
    "CMYK_K": 0.05960685014725
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0536",
    "Farbtonhilfsbezeichnung": "03.018.03",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "187",
    "Bcolor": "121",
    "Y": 56.3171806335449,
    "L": 79.7939987182617,
    "a": 13.428168296814,
    "b": 40.5400161743164,
    "C": 42.7060737609863,
    "h": 71.673454284668,
    "CMY_C": 0.04086977243423,
    "CMY_M": 0.26616281270981,
    "CMY_Y": 0.52427971363068,
    "CMYK_C": 0,
    "CMYK_M": 0.23489306867123,
    "CMYK_Y": 0.50400865077972,
    "CMYK_K": 0.04086977243423
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0537",
    "Farbtonhilfsbezeichnung": "03.018.04",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "172",
    "Bcolor": "107",
    "Y": 47.9542236328125,
    "L": 74.7960510253906,
    "a": 16.2134628295898,
    "b": 41.6009140014648,
    "C": 44.6487655639648,
    "h": 68.7072448730469,
    "CMY_C": 0.08103680610657,
    "CMY_M": 0.32706314325333,
    "CMY_Y": 0.58166074752808,
    "CMYK_C": 0,
    "CMYK_M": 0.26772165298462,
    "CMYK_Y": 0.54477041959763,
    "CMYK_K": 0.08103680610657
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0538",
    "Farbtonhilfsbezeichnung": "03.018.05",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "158",
    "Bcolor": "88",
    "Y": 41.1133270263672,
    "L": 70.2552490234375,
    "a": 18.3775768280029,
    "b": 45.6123046875,
    "C": 49.1753768920898,
    "h": 68.0550842285156,
    "CMY_C": 0.11677688360214,
    "CMY_M": 0.3813019990921,
    "CMY_Y": 0.65657240152359,
    "CMYK_C": 0,
    "CMYK_M": 0.29949975013733,
    "CMYK_Y": 0.61116552352905,
    "CMYK_K": 0.11677688360214
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0539",
    "Farbtonhilfsbezeichnung": "03.018.06",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "135",
    "Bcolor": "75",
    "Y": 29.4956436157227,
    "L": 61.2165908813477,
    "a": 16.9269866943359,
    "b": 40.5361289978027,
    "C": 43.9283561706543,
    "h": 67.3356628417969,
    "CMY_C": 0.23565083742142,
    "CMY_M": 0.46959888935089,
    "CMY_Y": 0.70566916465759,
    "CMYK_C": 0,
    "CMYK_M": 0.30607485771179,
    "CMYK_Y": 0.61492621898651,
    "CMYK_K": 0.23565083742142
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0540",
    "Farbtonhilfsbezeichnung": "03.019.01",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "217",
    "Bcolor": "206",
    "Y": 71.8255081176758,
    "L": 87.8845367431641,
    "a": 4.17572927474976,
    "b": 6.73565912246704,
    "C": 7.92501211166382,
    "h": 58.2034149169922,
    "CMY_C": 0.08250457048416,
    "CMY_M": 0.14711606502533,
    "CMY_Y": 0.19132727384567,
    "CMYK_C": 0,
    "CMYK_M": 0.07042159885168,
    "CMYK_Y": 0.11860844492912,
    "CMYK_K": 0.08250457048416
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0541",
    "Farbtonhilfsbezeichnung": "03.019.02",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "208",
    "Bcolor": "198",
    "Y": 65.2898101806641,
    "L": 84.6328582763672,
    "a": 5.46670007705688,
    "b": 6.61560010910034,
    "C": 8.58201503753662,
    "h": 50.4318923950195,
    "CMY_C": 0.10972529649734,
    "CMY_M": 0.18598860502243,
    "CMY_Y": 0.22543483972549,
    "CMYK_C": 0,
    "CMYK_M": 0.08566267043352,
    "CMYK_Y": 0.12997061014175,
    "CMYK_K": 0.10972529649734
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0542",
    "Farbtonhilfsbezeichnung": "03.019.03",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "194",
    "Bcolor": "184",
    "Y": 56.2491645812988,
    "L": 79.7554168701172,
    "a": 6.02064418792725,
    "b": 6.49533605575562,
    "C": 8.8564977645874,
    "h": 47.1720085144043,
    "CMY_C": 0.16019994020462,
    "CMY_M": 0.24035853147507,
    "CMY_Y": 0.27670603990555,
    "CMYK_C": 0,
    "CMYK_M": 0.09544961154461,
    "CMYK_Y": 0.13873076438904,
    "CMYK_K": 0.16019994020462
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0543",
    "Farbtonhilfsbezeichnung": "03.019.04",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "173",
    "Bcolor": "165",
    "Y": 44.2748947143555,
    "L": 72.4118499755859,
    "a": 6.85309600830078,
    "b": 6.52560615539551,
    "C": 9.46300506591797,
    "h": 43.5977668762207,
    "CMY_C": 0.23468112945557,
    "CMY_M": 0.32094305753708,
    "CMY_Y": 0.35412448644638,
    "CMYK_C": 0,
    "CMYK_M": 0.11271370947361,
    "CMYK_Y": 0.15607005357742,
    "CMYK_K": 0.23468112945557
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0544",
    "Farbtonhilfsbezeichnung": "03.019.05",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "144",
    "Bcolor": "136",
    "Y": 29.9184322357178,
    "L": 61.5837783813477,
    "a": 8.16625118255615,
    "b": 7.05243349075317,
    "C": 10.7900171279907,
    "h": 40.8141250610352,
    "CMY_C": 0.34065532684326,
    "CMY_M": 0.43698853254318,
    "CMY_Y": 0.46846735477448,
    "CMYK_C": 0,
    "CMYK_M": 0.14610446989536,
    "CMYK_Y": 0.19384706020355,
    "CMYK_K": 0.34065532684326
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0545",
    "Farbtonhilfsbezeichnung": "03.019.06",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "127",
    "Bcolor": "120",
    "Y": 22.9567756652832,
    "L": 55.0277862548828,
    "a": 7.9576153755188,
    "b": 6.67755937576294,
    "C": 10.3881397247315,
    "h": 40.0013809204102,
    "CMY_C": 0.41168493032455,
    "CMY_M": 0.50275260210037,
    "CMY_Y": 0.53115892410278,
    "CMYK_C": 0,
    "CMYK_M": 0.15479405224323,
    "CMYK_Y": 0.20307825505733,
    "CMYK_K": 0.41168493032455
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0546",
    "Farbtonhilfsbezeichnung": "03.020.01",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "204",
    "Bcolor": "191",
    "Y": 64.4226989746094,
    "L": 84.1853637695313,
    "a": 9.24712085723877,
    "b": 9.78957748413086,
    "C": 13.4664421081543,
    "h": 46.6322174072266,
    "CMY_C": 0.07899701595306,
    "CMY_M": 0.20114815235138,
    "CMY_Y": 0.25278651714325,
    "CMYK_C": 0,
    "CMYK_M": 0.13262838125229,
    "CMYK_Y": 0.18869592249393,
    "CMYK_K": 0.07899701595306
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0547",
    "Farbtonhilfsbezeichnung": "03.020.02",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "187",
    "Bcolor": "172",
    "Y": 54.5086212158203,
    "L": 78.7573776245117,
    "a": 11.5141286849976,
    "b": 11.7570285797119,
    "C": 16.4560890197754,
    "h": 45.5980224609375,
    "CMY_C": 0.11947864294052,
    "CMY_M": 0.26623094081879,
    "CMY_Y": 0.3242455124855,
    "CMYK_C": 0,
    "CMYK_M": 0.16666524112225,
    "CMYK_Y": 0.23255184292793,
    "CMYK_K": 0.11947864294052
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0548",
    "Farbtonhilfsbezeichnung": "03.020.03",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "169",
    "Bcolor": "155",
    "Y": 44.5063400268555,
    "L": 72.5656433105469,
    "a": 13.5138473510742,
    "b": 12.1840963363648,
    "C": 18.1955013275146,
    "h": 42.0378456115723,
    "CMY_C": 0.17438411712646,
    "CMY_M": 0.33746707439423,
    "CMY_Y": 0.39143109321594,
    "CMYK_C": 0,
    "CMYK_M": 0.19752885401249,
    "CMYK_Y": 0.2628909945488,
    "CMYK_K": 0.17438411712646
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0549",
    "Farbtonhilfsbezeichnung": "03.020.04",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "157",
    "Bcolor": "145",
    "Y": 38.2264137268066,
    "L": 68.1871566772461,
    "a": 13.4530811309815,
    "b": 11.6225862503052,
    "C": 17.7783546447754,
    "h": 40.8248825073242,
    "CMY_C": 0.22446882724762,
    "CMY_M": 0.38310384750366,
    "CMY_Y": 0.43236595392227,
    "CMYK_C": 0,
    "CMYK_M": 0.20455014705658,
    "CMYK_Y": 0.26807063817978,
    "CMYK_K": 0.22446882724762
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0550",
    "Farbtonhilfsbezeichnung": "03.020.05",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "143",
    "Bcolor": "129",
    "Y": 31.7212219238281,
    "L": 63.1118049621582,
    "a": 15.0259523391724,
    "b": 12.9902305603027,
    "C": 19.8626613616943,
    "h": 40.8440551757813,
    "CMY_C": 0.26734924316406,
    "CMY_M": 0.4399915933609,
    "CMY_Y": 0.49273926019669,
    "CMYK_C": 0,
    "CMYK_M": 0.23564071953297,
    "CMYK_Y": 0.30763638019562,
    "CMYK_K": 0.26734924316406
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0551",
    "Farbtonhilfsbezeichnung": "03.020.06",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "128",
    "Bcolor": "118",
    "Y": 24.5140132904053,
    "L": 56.5988006591797,
    "a": 11.5080919265747,
    "b": 9.67941951751709,
    "C": 15.0375308990479,
    "h": 40.0670852661133,
    "CMY_C": 0.36612987518311,
    "CMY_M": 0.49633634090424,
    "CMY_Y": 0.53529435396194,
    "CMYK_C": 0,
    "CMYK_M": 0.20541505515575,
    "CMYK_Y": 0.26687562465668,
    "CMYK_K": 0.36612987518311
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0552",
    "Farbtonhilfsbezeichnung": "03.021.01",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "227",
    "Bcolor": "209",
    "Y": 78.8451461791992,
    "L": 91.164176940918,
    "a": 2.96013903617859,
    "b": 10.3003845214844,
    "C": 10.7172918319702,
    "h": 73.9663314819336,
    "CMY_C": 0.04428851604462,
    "CMY_M": 0.10873740911484,
    "CMY_Y": 0.1821728348732,
    "CMYK_C": 0,
    "CMYK_M": 0.06743551045656,
    "CMYK_Y": 0.14427399635315,
    "CMYK_K": 0.04428851604462
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0553",
    "Farbtonhilfsbezeichnung": "03.021.02",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "213",
    "Bcolor": "192",
    "Y": 69.2141876220703,
    "L": 86.6100006103516,
    "a": 4.45536041259766,
    "b": 12.5344848632813,
    "C": 13.3027648925781,
    "h": 70.4323348999023,
    "CMY_C": 0.07857340574265,
    "CMY_M": 0.16335266828537,
    "CMY_Y": 0.247653901577,
    "CMYK_C": 0,
    "CMYK_M": 0.09200870245695,
    "CMYK_Y": 0.18349860608578,
    "CMYK_K": 0.07857340574265
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0554",
    "Farbtonhilfsbezeichnung": "03.021.03",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "198",
    "Bcolor": "175",
    "Y": 60.1198539733887,
    "L": 81.9032897949219,
    "a": 7.57691287994385,
    "b": 14.8684921264648,
    "C": 16.6877708435059,
    "h": 62.9968223571777,
    "CMY_C": 0.10357356071472,
    "CMY_M": 0.22306406497955,
    "CMY_Y": 0.31426322460175,
    "CMYK_C": 0,
    "CMYK_M": 0.13329648971558,
    "CMYK_Y": 0.23503285646439,
    "CMYK_K": 0.10357356071472
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0555",
    "Farbtonhilfsbezeichnung": "03.021.04",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "188",
    "Bcolor": "164",
    "Y": 54.3701820373535,
    "L": 78.6770935058594,
    "a": 9.25663280487061,
    "b": 16.2977867126465,
    "C": 18.7430820465088,
    "h": 60.4047775268555,
    "CMY_C": 0.12501430511475,
    "CMY_M": 0.26246410608292,
    "CMY_Y": 0.35815918445587,
    "CMYK_C": 0,
    "CMYK_M": 0.1570880562067,
    "CMYK_Y": 0.26645565032959,
    "CMYK_K": 0.12501430511475
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0556",
    "Farbtonhilfsbezeichnung": "03.021.05",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "178",
    "Bcolor": "154",
    "Y": 48.5945358276367,
    "L": 75.1983795166016,
    "a": 10.5982332229614,
    "b": 16.5897808074951,
    "C": 19.6861209869385,
    "h": 57.4278907775879,
    "CMY_C": 0.1544029712677,
    "CMY_M": 0.30313628911972,
    "CMY_Y": 0.39609134197235,
    "CMYK_C": 0,
    "CMYK_M": 0.17589148879051,
    "CMYK_Y": 0.28581979870796,
    "CMYK_K": 0.1544029712677
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0557",
    "Farbtonhilfsbezeichnung": "03.021.06",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "166",
    "Bcolor": "143",
    "Y": 42.3359336853027,
    "L": 71.1019134521484,
    "a": 11.6177911758423,
    "b": 16.6558818817139,
    "C": 20.3074245452881,
    "h": 55.1035003662109,
    "CMY_C": 0.19326889514923,
    "CMY_M": 0.34908020496368,
    "CMY_Y": 0.43834948539734,
    "CMYK_C": 0,
    "CMYK_M": 0.19313909113407,
    "CMYK_Y": 0.30379465222359,
    "CMYK_K": 0.19326889514923
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0558",
    "Farbtonhilfsbezeichnung": "03.022.01",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "219",
    "Bcolor": "199",
    "Y": 74.2084732055664,
    "L": 89.0209197998047,
    "a": 5.48502349853516,
    "b": 12.3509531021118,
    "C": 13.5141229629517,
    "h": 66.0541305541992,
    "CMY_C": 0.0443919301033,
    "CMY_M": 0.13925325870514,
    "CMY_Y": 0.22019082307816,
    "CMYK_C": 0,
    "CMYK_M": 0.09926802664995,
    "CMYK_Y": 0.18396547436714,
    "CMYK_K": 0.0443919301033
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0559",
    "Farbtonhilfsbezeichnung": "03.022.02",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "181",
    "Y": 68.0066452026367,
    "L": 86.0097732543945,
    "a": 10.2054224014282,
    "b": 17.6504096984863,
    "C": 20.3884181976318,
    "h": 59.9636116027832,
    "CMY_C": 0.03232657909393,
    "CMY_M": 0.18562614917755,
    "CMY_Y": 0.29067939519882,
    "CMYK_C": 0,
    "CMYK_M": 0.1584207713604,
    "CMYK_Y": 0.2669834792614,
    "CMYK_K": 0.03232657909393
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0560",
    "Farbtonhilfsbezeichnung": "03.022.03",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "198",
    "Bcolor": "170",
    "Y": 61.8604431152344,
    "L": 82.8391494750977,
    "a": 11.3230390548706,
    "b": 18.8977680206299,
    "C": 22.0303611755371,
    "h": 59.0710830688477,
    "CMY_C": 0.05818849802017,
    "CMY_M": 0.22338277101517,
    "CMY_Y": 0.3331064581871,
    "CMYK_C": 0,
    "CMYK_M": 0.17540057003498,
    "CMYK_Y": 0.29190337657928,
    "CMYK_K": 0.05818849802017
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0561",
    "Farbtonhilfsbezeichnung": "03.022.04",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "178",
    "Bcolor": "144",
    "Y": 50.7615089416504,
    "L": 76.5343170166016,
    "a": 14.7335529327393,
    "b": 23.8054847717285,
    "C": 27.9960479736328,
    "h": 58.2460441589355,
    "CMY_C": 0.09800696372986,
    "CMY_M": 0.30126410722733,
    "CMY_Y": 0.43344432115555,
    "CMYK_C": 0,
    "CMYK_M": 0.225342258811,
    "CMYK_Y": 0.37188464403152,
    "CMYK_K": 0.09800696372986
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0562",
    "Farbtonhilfsbezeichnung": "03.022.05",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "162",
    "Bcolor": "127",
    "Y": 42.4895210266113,
    "L": 71.2071228027344,
    "a": 17.4663505554199,
    "b": 26.1522560119629,
    "C": 31.4485912322998,
    "h": 56.2621612548828,
    "CMY_C": 0.13776248693466,
    "CMY_M": 0.36543750762939,
    "CMY_Y": 0.50363683700562,
    "CMYK_C": 0,
    "CMYK_M": 0.26405140757561,
    "CMYK_Y": 0.42433127760887,
    "CMYK_K": 0.13776248693466
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0563",
    "Farbtonhilfsbezeichnung": "03.022.06",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "138",
    "Bcolor": "105",
    "Y": 30.908992767334,
    "L": 62.4307327270508,
    "a": 18.7511920928955,
    "b": 25.7741546630859,
    "C": 31.8734092712402,
    "h": 53.9633903503418,
    "CMY_C": 0.23026674985886,
    "CMY_M": 0.45971935987473,
    "CMY_Y": 0.58717918395996,
    "CMYK_C": 0,
    "CMYK_M": 0.29809367656708,
    "CMYK_Y": 0.46368327736855,
    "CMYK_K": 0.23026674985886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0564",
    "Farbtonhilfsbezeichnung": "03.023.01",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "218",
    "Bcolor": "202",
    "Y": 72.8681182861328,
    "L": 88.3847808837891,
    "a": 4.62857961654663,
    "b": 9.77172660827637,
    "C": 10.8125104904175,
    "h": 64.6544647216797,
    "CMY_C": 0.06484907865524,
    "CMY_M": 0.14350545406342,
    "CMY_Y": 0.20817732810974,
    "CMYK_C": 0,
    "CMYK_M": 0.08411088585854,
    "CMYK_Y": 0.15326750278473,
    "CMYK_K": 0.06484907865524
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0565",
    "Farbtonhilfsbezeichnung": "03.023.02",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "207",
    "Bcolor": "190",
    "Y": 65.0670623779297,
    "L": 84.5182800292969,
    "a": 5.70107412338257,
    "b": 10.6115398406982,
    "C": 12.0460376739502,
    "h": 61.7529830932617,
    "CMY_C": 0.09824573993683,
    "CMY_M": 0.18886542320251,
    "CMY_Y": 0.25577998161316,
    "CMYK_C": 0,
    "CMYK_M": 0.10049265623093,
    "CMYK_Y": 0.17469753324986,
    "CMYK_K": 0.09824573993683
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0566",
    "Farbtonhilfsbezeichnung": "03.023.03",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "187",
    "Bcolor": "169",
    "Y": 53.0947456359863,
    "L": 77.930908203125,
    "a": 8.58105945587158,
    "b": 12.1843576431274,
    "C": 14.9027900695801,
    "h": 54.8441696166992,
    "CMY_C": 0.14763534069061,
    "CMY_M": 0.26778990030289,
    "CMY_Y": 0.33646905422211,
    "CMYK_C": 0,
    "CMYK_M": 0.14096614718437,
    "CMYK_Y": 0.22154098749161,
    "CMYK_K": 0.14763534069061
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0567",
    "Farbtonhilfsbezeichnung": "03.023.04",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "170",
    "Bcolor": "154",
    "Y": 43.743824005127,
    "L": 72.0569381713867,
    "a": 10.4557180404663,
    "b": 12.1015195846558,
    "C": 15.9927740097046,
    "h": 49.1729698181152,
    "CMY_C": 0.20029997825623,
    "CMY_M": 0.33499723672867,
    "CMY_Y": 0.39659541845322,
    "CMYK_C": 0,
    "CMYK_M": 0.16843472421169,
    "CMYK_Y": 0.24546134471893,
    "CMYK_K": 0.20029997825623
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0568",
    "Farbtonhilfsbezeichnung": "03.023.05",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "141",
    "Bcolor": "124",
    "Y": 30.2913341522217,
    "L": 61.90478515625,
    "a": 12.3393697738648,
    "b": 13.9929990768433,
    "C": 18.6564750671387,
    "h": 48.5933609008789,
    "CMY_C": 0.29513025283813,
    "CMY_M": 0.44566601514816,
    "CMY_Y": 0.51209163665771,
    "CMYK_C": 0,
    "CMYK_M": 0.21356536448002,
    "CMYK_Y": 0.30780351161957,
    "CMYK_K": 0.29513025283813
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0569",
    "Farbtonhilfsbezeichnung": "03.023.06",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "118",
    "Bcolor": "105",
    "Y": 21.0912170410156,
    "L": 53.0491828918457,
    "a": 13.1569681167603,
    "b": 12.1877708435059,
    "C": 17.9345359802246,
    "h": 42.8100433349609,
    "CMY_C": 0.38862544298172,
    "CMY_M": 0.53646779060364,
    "CMY_Y": 0.58630627393723,
    "CMYK_C": 0,
    "CMYK_M": 0.24181959033012,
    "CMYK_Y": 0.32333832979202,
    "CMYK_K": 0.38862544298172
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0570",
    "Farbtonhilfsbezeichnung": "03.024.01",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "218",
    "Bcolor": "197",
    "Y": 74.8257141113281,
    "L": 89.3112945556641,
    "a": 9.03990650177002,
    "b": 13.8675222396851,
    "C": 16.5537929534912,
    "h": 56.9006309509277,
    "CMY_C": 0.01177108287811,
    "CMY_M": 0.14538085460663,
    "CMY_Y": 0.22767639160156,
    "CMYK_C": 0,
    "CMYK_M": 0.13520123064518,
    "CMYK_Y": 0.21847702562809,
    "CMYK_K": 0.01177108287811
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0571",
    "Farbtonhilfsbezeichnung": "03.024.02",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "202",
    "Bcolor": "183",
    "Y": 64.1291351318359,
    "L": 84.032958984375,
    "a": 10.7154426574707,
    "b": 13.8753728866577,
    "C": 17.5313053131104,
    "h": 52.3224029541016,
    "CMY_C": 0.0602662563324,
    "CMY_M": 0.20760774612427,
    "CMY_Y": 0.28395241498947,
    "CMYK_C": 0,
    "CMYK_M": 0.15679067373276,
    "CMYK_Y": 0.23803141713142,
    "CMYK_K": 0.0602662563324
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0572",
    "Farbtonhilfsbezeichnung": "03.024.03",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "182",
    "Bcolor": "160",
    "Y": 52.4571113586426,
    "L": 77.5533752441406,
    "a": 13.2837171554565,
    "b": 16.6214904785156,
    "C": 21.2774791717529,
    "h": 51.3685264587402,
    "CMY_C": 0.11018741130829,
    "CMY_M": 0.2849258184433,
    "CMY_Y": 0.3714753985405,
    "CMYK_C": 0,
    "CMYK_M": 0.19637663662434,
    "CMYK_Y": 0.29364383220673,
    "CMYK_K": 0.11018741130829
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0573",
    "Farbtonhilfsbezeichnung": "03.024.04",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "162",
    "Bcolor": "137",
    "Y": 42.2348327636719,
    "L": 71.0325241088867,
    "a": 16.5931301116943,
    "b": 20.0337772369385,
    "C": 26.0131549835205,
    "h": 50.3664855957031,
    "CMY_C": 0.1558825969696,
    "CMY_M": 0.36359471082687,
    "CMY_Y": 0.46203470230103,
    "CMYK_C": 0,
    "CMYK_M": 0.24607017636299,
    "CMYK_Y": 0.36268901824951,
    "CMYK_K": 0.1558825969696
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0574",
    "Farbtonhilfsbezeichnung": "03.024.05",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "151",
    "Bcolor": "128",
    "Y": 36.7261428833008,
    "L": 67.0710601806641,
    "a": 17.0779304504395,
    "b": 19.4592990875244,
    "C": 25.8905391693115,
    "h": 48.729061126709,
    "CMY_C": 0.19852846860886,
    "CMY_M": 0.40609818696976,
    "CMY_Y": 0.49770325422287,
    "CMYK_C": 0,
    "CMYK_M": 0.25898575782776,
    "CMYK_Y": 0.37328186631203,
    "CMYK_K": 0.19852846860886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0575",
    "Farbtonhilfsbezeichnung": "03.024.06",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "135",
    "Bcolor": "112",
    "Y": 29.5267696380615,
    "L": 61.2437477111816,
    "a": 19.0413455963135,
    "b": 20.4366283416748,
    "C": 27.9325733184814,
    "h": 47.0241775512695,
    "CMY_C": 0.25021266937256,
    "CMY_M": 0.47152352333069,
    "CMY_Y": 0.56163519620895,
    "CMYK_C": 0,
    "CMYK_M": 0.2951648235321,
    "CMYK_Y": 0.41534781455994,
    "CMYK_K": 0.25021266937256
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0576",
    "Farbtonhilfsbezeichnung": "03.025.01",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "223",
    "Bcolor": "200",
    "Y": 76.0049819946289,
    "L": 89.8616561889648,
    "a": 2.92599606513977,
    "b": 12.9239044189453,
    "C": 13.2509908676148,
    "h": 77.2431869506836,
    "CMY_C": 0.05196118354797,
    "CMY_M": 0.12379860877991,
    "CMY_Y": 0.21576154232025,
    "CMYK_C": 0,
    "CMYK_M": 0.07577477395535,
    "CMYK_Y": 0.17277811467648,
    "CMYK_K": 0.05196118354797
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0577",
    "Farbtonhilfsbezeichnung": "03.025.02",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "219",
    "Bcolor": "195",
    "Y": 74.4423828125,
    "L": 89.1311492919922,
    "a": 5.7644624710083,
    "b": 14.6044111251831,
    "C": 15.7008867263794,
    "h": 68.4605102539063,
    "CMY_C": 0.03523272275925,
    "CMY_M": 0.13929557800293,
    "CMY_Y": 0.23561358451843,
    "CMYK_C": 0,
    "CMYK_M": 0.10786316543818,
    "CMYK_Y": 0.20769865810871,
    "CMYK_K": 0.03523272275925
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0578",
    "Farbtonhilfsbezeichnung": "03.025.03",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "204",
    "Bcolor": "172",
    "Y": 64.4796981811523,
    "L": 84.2149047851563,
    "a": 7.92022752761841,
    "b": 19.9039363861084,
    "C": 21.421875,
    "h": 68.30126953125,
    "CMY_C": 0.06332784891129,
    "CMY_M": 0.1999619603157,
    "CMY_Y": 0.32662016153336,
    "CMYK_C": 0,
    "CMYK_M": 0.14587186276913,
    "CMYK_Y": 0.28109335899353,
    "CMYK_K": 0.06332784891129
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0579",
    "Farbtonhilfsbezeichnung": "03.025.04",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "188",
    "Bcolor": "152",
    "Y": 55.0989456176758,
    "L": 79.0982284545898,
    "a": 10.6693029403687,
    "b": 23.2132205963135,
    "C": 25.5477523803711,
    "h": 65.3154525756836,
    "CMY_C": 0.09613007307053,
    "CMY_M": 0.26309454441071,
    "CMY_Y": 0.40361881256104,
    "CMYK_C": 0,
    "CMYK_M": 0.1847217977047,
    "CMYK_Y": 0.34019136428833,
    "CMYK_K": 0.09613007307053
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0580",
    "Farbtonhilfsbezeichnung": "03.025.05",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "161",
    "Bcolor": "119",
    "Y": 41.9005470275879,
    "L": 70.8022994995117,
    "a": 16.1349239349365,
    "b": 29.4948692321777,
    "C": 33.6196823120117,
    "h": 61.3194999694824,
    "CMY_C": 0.14511275291443,
    "CMY_M": 0.36674880981445,
    "CMY_Y": 0.5319699048996,
    "CMYK_C": 0,
    "CMYK_M": 0.2592576444149,
    "CMYK_Y": 0.45252418518066,
    "CMYK_K": 0.14511275291443
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0581",
    "Farbtonhilfsbezeichnung": "03.025.06",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "137",
    "Bcolor": "103",
    "Y": 29.7773628234863,
    "L": 61.4616470336914,
    "a": 15.7708292007446,
    "b": 25.50661277771,
    "C": 29.9884376525879,
    "h": 58.2713508605957,
    "CMY_C": 0.25896763801575,
    "CMY_M": 0.46149975061417,
    "CMY_Y": 0.5953516960144,
    "CMYK_C": 0,
    "CMYK_M": 0.27331075072289,
    "CMYK_Y": 0.45393976569176,
    "CMYK_K": 0.25896763801575
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0582",
    "Farbtonhilfsbezeichnung": "03.026.01",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "211",
    "Y": 82.2278137207031,
    "L": 92.6753158569336,
    "a": 2.58177518844604,
    "b": 11.2290563583374,
    "C": 11.5220336914063,
    "h": 77.0516357421875,
    "CMY_C": 0.02734458446503,
    "CMY_M": 0.09120577573776,
    "CMY_Y": 0.17266261577606,
    "CMYK_C": 0,
    "CMYK_M": 0.06565654277802,
    "CMYK_Y": 0.14940340816975,
    "CMYK_K": 0.02734458446503
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0583",
    "Farbtonhilfsbezeichnung": "03.026.02",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "222",
    "Bcolor": "204",
    "Y": 74.9084701538086,
    "L": 89.3501052856445,
    "a": 3.01222562789917,
    "b": 9.98577880859375,
    "C": 10.4302101135254,
    "h": 73.213981628418,
    "CMY_C": 0.06527101993561,
    "CMY_M": 0.12892961502075,
    "CMY_Y": 0.19955044984818,
    "CMYK_C": 0,
    "CMYK_M": 0.06810379773378,
    "CMYK_Y": 0.14365600049496,
    "CMYK_K": 0.06527101993561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0584",
    "Farbtonhilfsbezeichnung": "03.026.03",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "201",
    "Bcolor": "180",
    "Y": 61.1933937072754,
    "L": 82.4825973510742,
    "a": 5.15256881713867,
    "b": 12.7737665176392,
    "C": 13.7738189697266,
    "h": 68.0322799682617,
    "CMY_C": 0.11925703287125,
    "CMY_M": 0.21027332544327,
    "CMY_Y": 0.29330718517303,
    "CMYK_C": 0,
    "CMYK_M": 0.10334035754204,
    "CMYK_Y": 0.19761742651463,
    "CMYK_K": 0.11925703287125
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0585",
    "Farbtonhilfsbezeichnung": "03.026.04",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "192",
    "Bcolor": "168",
    "Y": 55.7886543273926,
    "L": 79.4933853149414,
    "a": 6.41971969604492,
    "b": 15.2185373306274,
    "C": 16.5171623229981,
    "h": 67.1282501220703,
    "CMY_C": 0.13771855831146,
    "CMY_M": 0.2463583946228,
    "CMY_Y": 0.34232187271118,
    "CMYK_C": 0,
    "CMYK_M": 0.12599115073681,
    "CMYK_Y": 0.23728136718273,
    "CMYK_K": 0.13771855831146
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0586",
    "Farbtonhilfsbezeichnung": "03.026.05",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "172",
    "Bcolor": "146",
    "Y": 44.9455680847168,
    "L": 72.8560409545898,
    "a": 9.21443843841553,
    "b": 17.3345375061035,
    "C": 19.631404876709,
    "h": 62.0064392089844,
    "CMY_C": 0.18799042701721,
    "CMY_M": 0.32467728853226,
    "CMY_Y": 0.42569500207901,
    "CMYK_C": 0,
    "CMYK_M": 0.16833159327507,
    "CMYK_Y": 0.29273617267609,
    "CMYK_K": 0.18799042701721
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0587",
    "Farbtonhilfsbezeichnung": "03.026.06",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "157",
    "Bcolor": "132",
    "Y": 36.966136932373,
    "L": 67.2516174316406,
    "a": 9.73829174041748,
    "b": 17.1765213012695,
    "C": 19.7450561523438,
    "h": 60.4487724304199,
    "CMY_C": 0.24675649404526,
    "CMY_M": 0.38473224639893,
    "CMY_Y": 0.4812673330307,
    "CMYK_C": 0,
    "CMYK_M": 0.18317548930645,
    "CMYK_Y": 0.31133469939232,
    "CMYK_K": 0.24675649404526
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0588",
    "Farbtonhilfsbezeichnung": "03.027.01",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "215",
    "Bcolor": "180",
    "Y": 71.5142440795898,
    "L": 87.734245300293,
    "a": 5.99436950683594,
    "b": 20.5281925201416,
    "C": 21.3854885101318,
    "h": 73.7218475341797,
    "CMY_C": 0.03506946563721,
    "CMY_M": 0.15670377016068,
    "CMY_Y": 0.29435414075851,
    "CMYK_C": 0,
    "CMYK_M": 0.12605498731136,
    "CMYK_Y": 0.26870813965797,
    "CMYK_K": 0.03506946563721
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0589",
    "Farbtonhilfsbezeichnung": "03.027.02",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "205",
    "Bcolor": "163",
    "Y": 64.5439910888672,
    "L": 84.2481994628906,
    "a": 6.58747482299805,
    "b": 24.3186264038086,
    "C": 25.19504737854,
    "h": 74.8433380126953,
    "CMY_C": 0.06239598989487,
    "CMY_M": 0.19724661111832,
    "CMY_Y": 0.35901552438736,
    "CMYK_C": 0,
    "CMYK_M": 0.14382471144199,
    "CMYK_Y": 0.31635907292366,
    "CMYK_K": 0.06239598989487
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0590",
    "Farbtonhilfsbezeichnung": "03.027.03",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "181",
    "Bcolor": "135",
    "Y": 50.7277145385742,
    "L": 76.5137786865234,
    "a": 9.39630794525146,
    "b": 28.5512599945068,
    "C": 30.0576953887939,
    "h": 71.7834625244141,
    "CMY_C": 0.12366312742233,
    "CMY_M": 0.28864359855652,
    "CMY_Y": 0.46922332048416,
    "CMYK_C": 0,
    "CMYK_M": 0.18826147913933,
    "CMYK_Y": 0.39432346820831,
    "CMYK_K": 0.12366312742233
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0591",
    "Farbtonhilfsbezeichnung": "03.027.04",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "160",
    "Bcolor": "118",
    "Y": 39.2732315063477,
    "L": 68.94873046875,
    "a": 11.3461694717407,
    "b": 27.4540615081787,
    "C": 29.7062454223633,
    "h": 67.5457458496094,
    "CMY_C": 0.1987789273262,
    "CMY_M": 0.37321549654007,
    "CMY_Y": 0.53675842285156,
    "CMYK_C": 0,
    "CMYK_M": 0.21771340072155,
    "CMYK_Y": 0.42183050513268,
    "CMYK_K": 0.1987789273262
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0592",
    "Farbtonhilfsbezeichnung": "03.027.05",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "147",
    "Bcolor": "106",
    "Y": 33.042423248291,
    "L": 64.1952438354492,
    "a": 11.5769929885864,
    "b": 27.4008312225342,
    "C": 29.7461318969727,
    "h": 67.0956954956055,
    "CMY_C": 0.25058841705322,
    "CMY_M": 0.42302548885345,
    "CMY_Y": 0.5830545425415,
    "CMYK_C": 0,
    "CMYK_M": 0.23009662330151,
    "CMYK_Y": 0.44363623857498,
    "CMYK_K": 0.25058841705322
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0593",
    "Farbtonhilfsbezeichnung": "03.027.06",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "134",
    "Bcolor": "90",
    "Y": 27.215877532959,
    "L": 59.1736106872559,
    "a": 11.614161491394,
    "b": 29.6142864227295,
    "C": 31.8102931976318,
    "h": 68.5858306884766,
    "CMY_C": 0.30270862579346,
    "CMY_M": 0.47469902038574,
    "CMY_Y": 0.64711159467697,
    "CMYK_C": 0,
    "CMYK_M": 0.24665498733521,
    "CMYK_Y": 0.49391543865204,
    "CMYK_K": 0.30270862579346
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0594",
    "Farbtonhilfsbezeichnung": "03.028.01",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "213",
    "Bcolor": "185",
    "Y": 69.171745300293,
    "L": 86.5890274047852,
    "a": 4.79024648666382,
    "b": 15.949667930603,
    "C": 16.6534786224365,
    "h": 73.2831344604492,
    "CMY_C": 0.0676017999649,
    "CMY_M": 0.16524547338486,
    "CMY_Y": 0.27294045686722,
    "CMYK_C": 0,
    "CMYK_M": 0.10472314804792,
    "CMYK_Y": 0.22022634744644,
    "CMYK_K": 0.0676017999649
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0595",
    "Farbtonhilfsbezeichnung": "03.028.02",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "191",
    "Bcolor": "161",
    "Y": 55.3488502502441,
    "L": 79.2417831420898,
    "a": 6.39549493789673,
    "b": 18.448371887207,
    "C": 19.5254898071289,
    "h": 70.8801116943359,
    "CMY_C": 0.13317626714706,
    "CMY_M": 0.24976354837418,
    "CMY_Y": 0.36832875013351,
    "CMYK_C": 0,
    "CMYK_M": 0.13449941575527,
    "CMYK_Y": 0.27128061652184,
    "CMYK_K": 0.13317626714706
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0596",
    "Farbtonhilfsbezeichnung": "03.028.03",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "177",
    "Bcolor": "149",
    "Y": 46.7778968811035,
    "L": 74.047477722168,
    "a": 7.23683214187622,
    "b": 17.6226921081543,
    "C": 19.0507488250732,
    "h": 67.6742935180664,
    "CMY_C": 0.18722826242447,
    "CMY_M": 0.30722206830978,
    "CMY_Y": 0.41589844226837,
    "CMYK_C": 0,
    "CMYK_M": 0.14763531088829,
    "CMYK_Y": 0.2813461124897,
    "CMYK_K": 0.18722826242447
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0597",
    "Farbtonhilfsbezeichnung": "03.028.04",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "164",
    "Bcolor": "138",
    "Y": 39.8604965209961,
    "L": 69.3700561523438,
    "a": 7.56233501434326,
    "b": 17.1666469573975,
    "C": 18.7585353851318,
    "h": 66.2253189086914,
    "CMY_C": 0.23761808872223,
    "CMY_M": 0.35726153850555,
    "CMY_Y": 0.46023857593536,
    "CMYK_C": 0,
    "CMYK_M": 0.15693373978138,
    "CMYK_Y": 0.29200652241707,
    "CMYK_K": 0.23761808872223
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0598",
    "Farbtonhilfsbezeichnung": "03.028.05",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "141",
    "Bcolor": "113",
    "Y": 29.3774127960205,
    "L": 61.11328125,
    "a": 9.32078266143799,
    "b": 19.5541915893555,
    "C": 21.6620273590088,
    "h": 64.5145416259766,
    "CMY_C": 0.31165236234665,
    "CMY_M": 0.44742965698242,
    "CMY_Y": 0.55870187282562,
    "CMYK_C": 0,
    "CMYK_M": 0.19725105166435,
    "CMYK_Y": 0.35890224575996,
    "CMYK_K": 0.31165236234665
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0599",
    "Farbtonhilfsbezeichnung": "03.028.06",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "128",
    "Bcolor": "102",
    "Y": 23.9934673309326,
    "L": 56.0812492370605,
    "a": 9.27344703674316,
    "b": 18.2649326324463,
    "C": 20.4842529296875,
    "h": 63.0822486877441,
    "CMY_C": 0.3684054017067,
    "CMY_M": 0.49793064594269,
    "CMY_Y": 0.59865522384644,
    "CMYK_C": 0,
    "CMYK_M": 0.20507656037807,
    "CMYK_Y": 0.36455318331718,
    "CMYK_K": 0.3684054017067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0600",
    "Farbtonhilfsbezeichnung": "03.029.01",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "97",
    "Bcolor": "62",
    "Y": 17.0853042602539,
    "L": 48.3673439025879,
    "a": 25.5987186431885,
    "b": 31.6792049407959,
    "C": 40.7291831970215,
    "h": 51.0596885681152,
    "CMY_C": 0.34384173154831,
    "CMY_M": 0.62082529067993,
    "CMY_Y": 0.75833904743195,
    "CMYK_C": 0,
    "CMYK_M": 0.42212918400764,
    "CMYK_Y": 0.63170325756073,
    "CMYK_K": 0.34384173154831
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0601",
    "Farbtonhilfsbezeichnung": "03.029.02",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "85",
    "Bcolor": "60",
    "Y": 13.4725065231323,
    "L": 43.4667358398438,
    "a": 25.4159412384033,
    "b": 25.9510536193848,
    "C": 36.3239212036133,
    "h": 45.5968551635742,
    "CMY_C": 0.40516602993011,
    "CMY_M": 0.66661751270294,
    "CMY_Y": 0.7635195851326,
    "CMYK_C": 0,
    "CMYK_M": 0.43953689932823,
    "CMYK_Y": 0.60244297981262,
    "CMYK_K": 0.40516602993011
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0602",
    "Farbtonhilfsbezeichnung": "03.029.03",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "83",
    "Bcolor": "69",
    "Y": 13.4659185409546,
    "L": 43.4570426940918,
    "a": 28.3839855194092,
    "b": 21.1428508758545,
    "C": 35.3930892944336,
    "h": 36.6819343566895,
    "CMY_C": 0.39538490772247,
    "CMY_M": 0.67529881000519,
    "CMY_Y": 0.73137009143829,
    "CMYK_C": 0,
    "CMYK_M": 0.46296215057373,
    "CMYK_Y": 0.55570095777512,
    "CMYK_K": 0.39538490772247
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0603",
    "Farbtonhilfsbezeichnung": "03.029.04",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "75",
    "Bcolor": "56",
    "Y": 9.36081790924072,
    "L": 36.6699104309082,
    "a": 17.6020088195801,
    "b": 18.7669448852539,
    "C": 25.729923248291,
    "h": 46.8346176147461,
    "CMY_C": 0.52581191062927,
    "CMY_M": 0.70644354820251,
    "CMY_Y": 0.77879166603088,
    "CMYK_C": 0,
    "CMYK_M": 0.38092824816704,
    "CMYK_Y": 0.53350085020065,
    "CMYK_K": 0.52581191062927
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0604",
    "Farbtonhilfsbezeichnung": "03.029.05",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "68",
    "Bcolor": "52",
    "Y": 7.69119691848755,
    "L": 33.3313102722168,
    "a": 16.5739078521729,
    "b": 16.561071395874,
    "C": 23.4299697875977,
    "h": 44.9778022766113,
    "CMY_C": 0.56818580627441,
    "CMY_M": 0.73389220237732,
    "CMY_Y": 0.79416275024414,
    "CMYK_C": 0,
    "CMYK_M": 0.38374465703964,
    "CMYK_Y": 0.52331984043121,
    "CMYK_K": 0.56818580627441
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0605",
    "Farbtonhilfsbezeichnung": "03.029.06",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "68",
    "Bcolor": "54",
    "Y": 7.40650129318237,
    "L": 32.7149620056152,
    "a": 14.5217571258545,
    "b": 14.7261514663696,
    "C": 20.6819000244141,
    "h": 45.4003982543945,
    "CMY_C": 0.58717036247253,
    "CMY_M": 0.73374420404434,
    "CMY_Y": 0.78855109214783,
    "CMYK_C": 0,
    "CMYK_M": 0.35504680871964,
    "CMYK_Y": 0.48780590295792,
    "CMYK_K": 0.58717036247253
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0606",
    "Farbtonhilfsbezeichnung": "03.030.01",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "85",
    "Bcolor": "72",
    "Y": 11.3993263244629,
    "L": 40.245059967041,
    "a": 15.2794466018677,
    "b": 14.0022954940796,
    "C": 20.725004196167,
    "h": 42.5025749206543,
    "CMY_C": 0.50736266374588,
    "CMY_M": 0.66599678993225,
    "CMY_Y": 0.71730679273605,
    "CMYK_C": 0,
    "CMYK_M": 0.32200995087624,
    "CMYK_Y": 0.42616364359856,
    "CMYK_K": 0.50736266374588
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0607",
    "Farbtonhilfsbezeichnung": "03.030.02",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "71",
    "Bcolor": "59",
    "Y": 8.53106212615967,
    "L": 35.0652770996094,
    "a": 18.3174533843994,
    "b": 14.7205476760864,
    "C": 23.499439239502,
    "h": 38.7865791320801,
    "CMY_C": 0.54388558864594,
    "CMY_M": 0.72244554758072,
    "CMY_Y": 0.76733148097992,
    "CMYK_C": 0,
    "CMYK_M": 0.39148062467575,
    "CMYK_Y": 0.48989000916481,
    "CMYK_K": 0.54388558864594
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0608",
    "Farbtonhilfsbezeichnung": "03.030.03",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "59",
    "Bcolor": "52",
    "Y": 5.34851932525635,
    "L": 27.7054748535156,
    "a": 10.5628175735474,
    "b": 8.70217227935791,
    "C": 13.6857929229736,
    "h": 39.4833869934082,
    "CMY_C": 0.66544032096863,
    "CMY_M": 0.76761651039124,
    "CMY_Y": 0.79590201377869,
    "CMYK_C": 0,
    "CMYK_M": 0.30540496110916,
    "CMYK_Y": 0.38995042443275,
    "CMYK_K": 0.66544032096863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0609",
    "Farbtonhilfsbezeichnung": "03.030.04",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "82",
    "Bcolor": "66",
    "Y": 10.2809600830078,
    "L": 38.3420333862305,
    "a": 13.0610017776489,
    "b": 14.7722625732422,
    "C": 19.7182540893555,
    "h": 48.5182609558105,
    "CMY_C": 0.53768163919449,
    "CMY_M": 0.67829895019531,
    "CMY_Y": 0.7396764755249,
    "CMYK_C": 0,
    "CMYK_M": 0.30415686964989,
    "CMYK_Y": 0.43691718578339,
    "CMYK_K": 0.53768163919449
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0610",
    "Farbtonhilfsbezeichnung": "03.030.05",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "68",
    "Bcolor": "55",
    "Y": 6.89014339447021,
    "L": 31.5555000305176,
    "a": 10.4932489395142,
    "b": 12.2888250350952,
    "C": 16.1593151092529,
    "h": 49.5064697265625,
    "CMY_C": 0.62296807765961,
    "CMY_M": 0.73378765583038,
    "CMY_Y": 0.78437286615372,
    "CMYK_C": 0,
    "CMYK_M": 0.29392623901367,
    "CMYK_Y": 0.42809316515923,
    "CMYK_K": 0.62296807765961
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0611",
    "Farbtonhilfsbezeichnung": "03.030.06",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "62",
    "Bcolor": "52",
    "Y": 5.74264335632324,
    "L": 28.7536659240723,
    "a": 9.75682830810547,
    "b": 10.3321180343628,
    "C": 14.2108535766602,
    "h": 46.6403388977051,
    "CMY_C": 0.65701949596405,
    "CMY_M": 0.75675761699677,
    "CMY_Y": 0.79677802324295,
    "CMYK_C": 0,
    "CMYK_M": 0.29079821705818,
    "CMYK_Y": 0.4074824154377,
    "CMYK_K": 0.65701949596405
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0612",
    "Farbtonhilfsbezeichnung": "03.031.01",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "59",
    "Bcolor": "54",
    "Y": 7.11287927627563,
    "L": 32.0625114440918,
    "a": 25.0160160064697,
    "b": 13.9632301330566,
    "C": 28.649133682251,
    "h": 29.1690158843994,
    "CMY_C": 0.54292869567871,
    "CMY_M": 0.76992678642273,
    "CMY_Y": 0.78743207454681,
    "CMYK_C": 0,
    "CMYK_M": 0.49663606286049,
    "CMYK_Y": 0.5349348783493,
    "CMYK_K": 0.54292869567871
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0613",
    "Farbtonhilfsbezeichnung": "03.031.02",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "63",
    "Bcolor": "57",
    "Y": 7.38772392272949,
    "L": 32.673755645752,
    "a": 21.4445667266846,
    "b": 13.1259889602661,
    "C": 25.1428127288818,
    "h": 31.4703521728516,
    "CMY_C": 0.55495870113373,
    "CMY_M": 0.75301146507263,
    "CMY_Y": 0.77777540683746,
    "CMYK_C": 0,
    "CMYK_M": 0.44502109289169,
    "CMYK_Y": 0.50066524744034,
    "CMYK_K": 0.55495870113373
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0614",
    "Farbtonhilfsbezeichnung": "03.031.03",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "63",
    "Bcolor": "57",
    "Y": 6.64629030227661,
    "L": 30.9877281188965,
    "a": 16.5808029174805,
    "b": 10.2692193984985,
    "C": 19.5033302307129,
    "h": 31.7717514038086,
    "CMY_C": 0.60019791126251,
    "CMY_M": 0.75389266014099,
    "CMY_Y": 0.77599662542343,
    "CMYK_C": 0,
    "CMYK_M": 0.38442707061768,
    "CMYK_Y": 0.43971434235573,
    "CMYK_K": 0.60019791126251
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0615",
    "Farbtonhilfsbezeichnung": "03.031.04",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "68",
    "Bcolor": "70",
    "Y": 8.4413423538208,
    "L": 34.8856315612793,
    "a": 21.6311817169189,
    "b": 7.61502456665039,
    "C": 22.9324359893799,
    "h": 19.3940677642822,
    "CMY_C": 0.53893953561783,
    "CMY_M": 0.73200076818466,
    "CMY_Y": 0.72468912601471,
    "CMYK_C": 0,
    "CMYK_M": 0.41873300075531,
    "CMYK_Y": 0.40287467837334,
    "CMYK_K": 0.53893953561783
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0616",
    "Farbtonhilfsbezeichnung": "03.031.05",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "72",
    "Bcolor": "70",
    "Y": 8.03414154052734,
    "L": 34.0538864135742,
    "a": 14.3807058334351,
    "b": 6.49401235580444,
    "C": 15.7790021896362,
    "h": 24.3028945922852,
    "CMY_C": 0.58711957931519,
    "CMY_M": 0.71946811676025,
    "CMY_Y": 0.72644436359406,
    "CMYK_C": 0,
    "CMYK_M": 0.32054930925369,
    "CMYK_Y": 0.33744585514069,
    "CMYK_K": 0.58711957931519
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0617",
    "Farbtonhilfsbezeichnung": "03.031.06",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "57",
    "Bcolor": "62",
    "Y": 5.14337301254272,
    "L": 27.1393890380859,
    "a": 12.7764368057251,
    "b": 1.24840605258942,
    "C": 12.8372840881348,
    "h": 5.5807466506958,
    "CMY_C": 0.67237067222595,
    "CMY_M": 0.77627420425415,
    "CMY_Y": 0.75660693645477,
    "CMYK_C": 0,
    "CMYK_M": 0.31713744997978,
    "CMYK_Y": 0.25710844993591,
    "CMYK_K": 0.67237067222595
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0618",
    "Farbtonhilfsbezeichnung": "03.032.01",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "111",
    "Bcolor": "73",
    "Y": 17.6007308959961,
    "L": 49.0082054138184,
    "a": 6.89759159088135,
    "b": 25.171350479126,
    "C": 26.0993041992188,
    "h": 74.6756744384766,
    "CMY_C": 0.4462223649025,
    "CMY_M": 0.56351578235626,
    "CMY_Y": 0.71256935596466,
    "CMYK_C": 0,
    "CMYK_M": 0.21180598437786,
    "CMYK_Y": 0.48096379637718,
    "CMYK_K": 0.4462223649025
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0619",
    "Farbtonhilfsbezeichnung": "03.032.02",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "98",
    "Bcolor": "64",
    "Y": 13.6191453933716,
    "L": 43.6817092895508,
    "a": 7.96915435791016,
    "b": 23.5060596466064,
    "C": 24.820198059082,
    "h": 71.2720260620117,
    "CMY_C": 0.49818539619446,
    "CMY_M": 0.61716496944427,
    "CMY_Y": 0.74956810474396,
    "CMYK_C": 0,
    "CMYK_M": 0.23709866404533,
    "CMYK_Y": 0.50094735622406,
    "CMYK_K": 0.49818539619446
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0620",
    "Farbtonhilfsbezeichnung": "03.032.03",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "81",
    "Bcolor": "61",
    "Y": 8.92025947570801,
    "L": 35.8303108215332,
    "a": 4.30447864532471,
    "b": 14.4966697692871,
    "C": 15.1222343444824,
    "h": 73.4623336791992,
    "CMY_C": 0.6113760471344,
    "CMY_M": 0.68120884895325,
    "CMY_Y": 0.76179158687592,
    "CMYK_C": 0,
    "CMYK_M": 0.17969247698784,
    "CMYK_Y": 0.3870464861393,
    "CMYK_K": 0.6113760471344
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0621",
    "Farbtonhilfsbezeichnung": "03.032.04",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "103",
    "Bcolor": "63",
    "Y": 14.9064302444458,
    "L": 45.5057754516602,
    "a": 6.21109104156494,
    "b": 26.5492153167725,
    "C": 27.2660675048828,
    "h": 76.8326721191406,
    "CMY_C": 0.4849841594696,
    "CMY_M": 0.59608882665634,
    "CMY_Y": 0.75409233570099,
    "CMYK_C": 0,
    "CMYK_M": 0.21573057770729,
    "CMYK_Y": 0.52252405881882,
    "CMYK_K": 0.4849841594696
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0622",
    "Farbtonhilfsbezeichnung": "03.032.05",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "102",
    "Bcolor": "73",
    "Y": 14.034366607666,
    "L": 44.2821807861328,
    "a": 3.60421562194824,
    "b": 18.9051189422607,
    "C": 19.2456207275391,
    "h": 79.2062301635742,
    "CMY_C": 0.52394676208496,
    "CMY_M": 0.6007884144783,
    "CMY_Y": 0.71452182531357,
    "CMYK_C": 0,
    "CMYK_M": 0.16141398251057,
    "CMYK_Y": 0.4003230035305,
    "CMYK_K": 0.52394676208496
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0623",
    "Farbtonhilfsbezeichnung": "03.032.06",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "85",
    "Bcolor": "58",
    "Y": 9.56310558319092,
    "L": 37.0466117858887,
    "a": 2.86740350723267,
    "b": 17.6771659851074,
    "C": 17.9082164764404,
    "h": 80.7863311767578,
    "CMY_C": 0.60246276855469,
    "CMY_M": 0.66740942001343,
    "CMY_Y": 0.77152681350708,
    "CMYK_C": 0,
    "CMYK_M": 0.16337250173092,
    "CMYK_Y": 0.42527851462364,
    "CMYK_K": 0.60246276855469
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0624",
    "Farbtonhilfsbezeichnung": "03.033.01",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "116",
    "Bcolor": "98",
    "Y": 20.3051509857178,
    "L": 52.1804809570313,
    "a": 12.7913846969604,
    "b": 15.150013923645,
    "C": 19.8278198242188,
    "h": 49.8250923156738,
    "CMY_C": 0.39452058076859,
    "CMY_M": 0.5447883605957,
    "CMY_Y": 0.61439138650894,
    "CMYK_C": 0,
    "CMYK_M": 0.24817983806133,
    "CMYK_Y": 0.36313506960869,
    "CMYK_K": 0.39452058076859
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0625",
    "Farbtonhilfsbezeichnung": "03.033.02",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "99",
    "Bcolor": "81",
    "Y": 14.9750709533691,
    "L": 45.6000328063965,
    "a": 13.8810834884644,
    "b": 16.3215007781982,
    "C": 21.4260559082031,
    "h": 49.619556427002,
    "CMY_C": 0.45572227239609,
    "CMY_M": 0.61193370819092,
    "CMY_Y": 0.68359524011612,
    "CMYK_C": 0,
    "CMYK_M": 0.28700685501099,
    "CMYK_Y": 0.41867038607597,
    "CMYK_K": 0.45572227239609
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0626",
    "Farbtonhilfsbezeichnung": "03.033.03",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "89",
    "Bcolor": "69",
    "Y": 11.9060077667236,
    "L": 41.0663414001465,
    "a": 12.3992967605591,
    "b": 16.7877731323242,
    "C": 20.8703594207764,
    "h": 53.5507621765137,
    "CMY_C": 0.51033312082291,
    "CMY_M": 0.65148586034775,
    "CMY_Y": 0.72821366786957,
    "CMYK_C": 0,
    "CMYK_M": 0.28826278448105,
    "CMYK_Y": 0.44495669007301,
    "CMYK_K": 0.51033312082291
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0627",
    "Farbtonhilfsbezeichnung": "03.033.04",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "96",
    "Bcolor": "82",
    "Y": 13.1918106079102,
    "L": 43.0508422851563,
    "a": 8.37162780761719,
    "b": 11.9753589630127,
    "C": 14.6114120483398,
    "h": 55.0437126159668,
    "CMY_C": 0.52072018384933,
    "CMY_M": 0.62202763557434,
    "CMY_Y": 0.67995780706406,
    "CMYK_C": 0,
    "CMYK_M": 0.2113743275404,
    "CMYK_Y": 0.33224353194237,
    "CMYK_K": 0.52072018384933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0628",
    "Farbtonhilfsbezeichnung": "03.033.05",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "77",
    "Bcolor": "70",
    "Y": 8.13924026489258,
    "L": 34.2712020874023,
    "a": 5.54545259475708,
    "b": 6.75014066696167,
    "C": 8.73592853546143,
    "h": 50.5958213806152,
    "CMY_C": 0.63362574577332,
    "CMY_M": 0.69674605131149,
    "CMY_Y": 0.7273576259613,
    "CMYK_C": 0,
    "CMYK_M": 0.1722836792469,
    "CMYK_Y": 0.25583642721176,
    "CMYK_K": 0.63362574577332
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0629",
    "Farbtonhilfsbezeichnung": "03.033.06",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "63",
    "Bcolor": "59",
    "Y": 5.55708360671997,
    "L": 28.2663421630859,
    "a": 6.3466739654541,
    "b": 4.89039611816406,
    "C": 8.01225566864014,
    "h": 37.6158599853516,
    "CMY_C": 0.68948936462402,
    "CMY_M": 0.75231385231018,
    "CMY_Y": 0.76906836032867,
    "CMYK_C": 0,
    "CMYK_M": 0.20232635736465,
    "CMYK_Y": 0.2562842965126,
    "CMYK_K": 0.68948936462402
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0630",
    "Farbtonhilfsbezeichnung": "03.034.01",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "110",
    "Bcolor": "44",
    "Y": 21.0416145324707,
    "L": 52.9950065612793,
    "a": 22.6705226898193,
    "b": 46.3961296081543,
    "C": 51.6386833190918,
    "h": 63.9584922790527,
    "CMY_C": 0.29378032684326,
    "CMY_M": 0.5686981678009,
    "CMY_Y": 0.8278135061264,
    "CMYK_C": 0,
    "CMYK_M": 0.38928091526031,
    "CMYK_Y": 0.7561856508255,
    "CMYK_K": 0.29378032684326
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0631",
    "Farbtonhilfsbezeichnung": "03.034.02",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "111",
    "Bcolor": "66",
    "Y": 20.6554088592529,
    "L": 52.5702781677246,
    "a": 19.8072052001953,
    "b": 34.6684684753418,
    "C": 39.9277839660645,
    "h": 60.2592887878418,
    "CMY_C": 0.32410192489624,
    "CMY_M": 0.56312334537506,
    "CMY_Y": 0.7427659034729,
    "CMYK_C": 0,
    "CMYK_M": 0.35363531112671,
    "CMYK_Y": 0.61941879987717,
    "CMYK_K": 0.32410192489624
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0632",
    "Farbtonhilfsbezeichnung": "03.034.03",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "89",
    "Bcolor": "54",
    "Y": 13.399091720581,
    "L": 43.3585243225098,
    "a": 18.9202861785889,
    "b": 29.2940921783447,
    "C": 34.8729286193848,
    "h": 57.1426429748535,
    "CMY_C": 0.4362233877182,
    "CMY_M": 0.64905118942261,
    "CMY_Y": 0.78882765769958,
    "CMYK_C": 0,
    "CMYK_M": 0.37750378251076,
    "CMYK_Y": 0.62543261051178,
    "CMYK_K": 0.4362233877182
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0633",
    "Farbtonhilfsbezeichnung": "03.034.04",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "111",
    "Bcolor": "76",
    "Y": 19.4917640686035,
    "L": 51.2576522827148,
    "a": 16.5748233795166,
    "b": 27.2155609130859,
    "C": 31.8655223846436,
    "h": 58.6577453613281,
    "CMY_C": 0.36478513479233,
    "CMY_M": 0.56599390506744,
    "CMY_Y": 0.70355159044266,
    "CMYK_C": 0,
    "CMYK_M": 0.3167570233345,
    "CMYK_Y": 0.53330999612808,
    "CMYK_K": 0.36478513479233
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0634",
    "Farbtonhilfsbezeichnung": "03.034.05",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "87",
    "Bcolor": "59",
    "Y": 12.0690765380859,
    "L": 41.3256950378418,
    "a": 16.2437038421631,
    "b": 23.3202362060547,
    "C": 28.4199104309082,
    "h": 55.1408729553223,
    "CMY_C": 0.47844916582108,
    "CMY_M": 0.66007649898529,
    "CMY_Y": 0.76749366521835,
    "CMYK_C": 0,
    "CMYK_M": 0.34824472665787,
    "CMYK_Y": 0.55420196056366,
    "CMYK_K": 0.47844916582108
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0635",
    "Farbtonhilfsbezeichnung": "03.034.06",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "80",
    "Bcolor": "59",
    "Y": 9.88907432556152,
    "L": 37.6426048278809,
    "a": 13.3045158386231,
    "b": 18.3119583129883,
    "C": 22.6348838806152,
    "h": 53.9997978210449,
    "CMY_C": 0.53857964277267,
    "CMY_M": 0.68607008457184,
    "CMY_Y": 0.76827776432037,
    "CMYK_C": 0,
    "CMYK_M": 0.31964442133904,
    "CMYK_Y": 0.49780663847923,
    "CMYK_K": 0.53857964277267
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0636",
    "Farbtonhilfsbezeichnung": "03.035.01",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "106",
    "Bcolor": "63",
    "Y": 17.8206748962402,
    "L": 49.2778816223145,
    "a": 16.5111064910889,
    "b": 31.598653793335,
    "C": 35.6523704528809,
    "h": 62.4117774963379,
    "CMY_C": 0.38174366950989,
    "CMY_M": 0.58587324619293,
    "CMY_Y": 0.7521561384201,
    "CMYK_C": 0,
    "CMYK_M": 0.33016982674599,
    "CMYK_Y": 0.59912443161011,
    "CMYK_K": 0.38174366950989
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0637",
    "Farbtonhilfsbezeichnung": "03.035.02",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "91",
    "Bcolor": "55",
    "Y": 13.3695106506348,
    "L": 43.314811706543,
    "a": 16.1896018981934,
    "b": 28.7104110717773,
    "C": 32.9604454040527,
    "h": 60.5816459655762,
    "CMY_C": 0.45149111747742,
    "CMY_M": 0.64194333553314,
    "CMY_Y": 0.78599059581757,
    "CMYK_C": 0,
    "CMYK_M": 0.34721809625626,
    "CMYK_Y": 0.60983419418335,
    "CMYK_K": 0.45149111747742
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0638",
    "Farbtonhilfsbezeichnung": "03.035.03",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "86",
    "Bcolor": "59",
    "Y": 10.9180555343628,
    "L": 39.4421119689941,
    "a": 10.8620758056641,
    "b": 20.7147254943848,
    "C": 23.3898391723633,
    "h": 62.3290634155273,
    "CMY_C": 0.52990436553955,
    "CMY_M": 0.66366726160049,
    "CMY_Y": 0.76837146282196,
    "CMYK_C": 0,
    "CMYK_M": 0.28454402089119,
    "CMYK_Y": 0.50727355480194,
    "CMYK_K": 0.52990436553955
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0639",
    "Farbtonhilfsbezeichnung": "03.035.04",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "76",
    "Bcolor": "62",
    "Y": 8.32903861999512,
    "L": 34.6589622497559,
    "a": 8.71714973449707,
    "b": 12.1049280166626,
    "C": 14.9170370101929,
    "h": 54.2411193847656,
    "CMY_C": 0.60227954387665,
    "CMY_M": 0.70137405395508,
    "CMY_Y": 0.75643306970596,
    "CMYK_C": 0,
    "CMYK_M": 0.24915617704391,
    "CMYK_Y": 0.38759264349937,
    "CMYK_K": 0.60227954387665
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0640",
    "Farbtonhilfsbezeichnung": "03.035.05",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "71",
    "Bcolor": "59",
    "Y": 7.07119417190552,
    "L": 31.9684391021729,
    "a": 6.24353647232056,
    "b": 10.054594039917,
    "C": 11.8353967666626,
    "h": 58.1612243652344,
    "CMY_C": 0.64547169208527,
    "CMY_M": 0.7199330329895,
    "CMY_Y": 0.76784992218018,
    "CMYK_C": 0,
    "CMYK_M": 0.21002931892872,
    "CMYK_Y": 0.34518605470657,
    "CMYK_K": 0.64547169208527
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0641",
    "Farbtonhilfsbezeichnung": "03.035.06",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "56",
    "Y": 6.04047250747681,
    "L": 29.5143451690674,
    "a": 5.31443405151367,
    "b": 8.67003059387207,
    "C": 10.1692008972168,
    "h": 58.4931182861328,
    "CMY_C": 0.67637652158737,
    "CMY_M": 0.73974478244781,
    "CMY_Y": 0.78095078468323,
    "CMYK_C": 0,
    "CMYK_M": 0.19580860435963,
    "CMYK_Y": 0.32313558459282,
    "CMYK_K": 0.67637652158737
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0642",
    "Farbtonhilfsbezeichnung": "03.036.01",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "84",
    "Bcolor": "66",
    "Y": 12.7421493530273,
    "L": 42.3721351623535,
    "a": 23.5870246887207,
    "b": 20.7897205352783,
    "C": 31.4413776397705,
    "h": 41.3931121826172,
    "CMY_C": 0.43213272094727,
    "CMY_M": 0.67051339149475,
    "CMY_Y": 0.73993873596191,
    "CMYK_C": 0,
    "CMYK_M": 0.4197823703289,
    "CMYK_Y": 0.54203867912292,
    "CMYK_K": 0.43213272094727
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0643",
    "Farbtonhilfsbezeichnung": "03.036.02",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "70",
    "Bcolor": "55",
    "Y": 9.72255229949951,
    "L": 37.3398056030273,
    "a": 25.4046058654785,
    "b": 21.0022315979004,
    "C": 32.9619140625,
    "h": 39.580867767334,
    "CMY_C": 0.47722065448761,
    "CMY_M": 0.72368848323822,
    "CMY_Y": 0.78532934188843,
    "CMYK_C": 0,
    "CMYK_M": 0.4714567065239,
    "CMYK_Y": 0.58936661481857,
    "CMYK_K": 0.47722065448761
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0644",
    "Farbtonhilfsbezeichnung": "03.036.03",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "65",
    "Bcolor": "59",
    "Y": 7.20173406600952,
    "L": 32.2618179321289,
    "a": 17.6782035827637,
    "b": 10.7569389343262,
    "C": 20.693733215332,
    "h": 31.3199253082275,
    "CMY_C": 0.58114314079285,
    "CMY_M": 0.7454651594162,
    "CMY_Y": 0.76766413450241,
    "CMYK_C": 0,
    "CMYK_M": 0.39231067895889,
    "CMYK_Y": 0.44530963897705,
    "CMYK_K": 0.58114314079285
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0645",
    "Farbtonhilfsbezeichnung": "03.036.04",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "91",
    "Bcolor": "85",
    "Y": 12.8931312561035,
    "L": 42.6017799377441,
    "a": 15.2607154846191,
    "b": 9.38165187835693,
    "C": 17.9138164520264,
    "h": 31.5814666748047,
    "CMY_C": 0.49078345298767,
    "CMY_M": 0.64266204833984,
    "CMY_Y": 0.66641682386398,
    "CMYK_C": 0,
    "CMYK_M": 0.29825934767723,
    "CMYK_Y": 0.34490901231766,
    "CMYK_K": 0.49078345298767
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0646",
    "Farbtonhilfsbezeichnung": "03.036.05",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "101",
    "Bcolor": "96",
    "Y": 14.4208984375,
    "L": 44.8306007385254,
    "a": 8.42365074157715,
    "b": 6.00368499755859,
    "C": 10.3441829681397,
    "h": 35.4781455993652,
    "CMY_C": 0.51452976465225,
    "CMY_M": 0.6037831902504,
    "CMY_Y": 0.62501525878906,
    "CMYK_C": 0,
    "CMYK_M": 0.18384942412376,
    "CMYK_Y": 0.22758448123932,
    "CMYK_K": 0.51452976465225
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0647",
    "Farbtonhilfsbezeichnung": "03.036.06",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "80",
    "Bcolor": "79",
    "Y": 9.01405715942383,
    "L": 36.011344909668,
    "a": 8.91340732574463,
    "b": 3.19324588775635,
    "C": 9.46813869476318,
    "h": 19.7101631164551,
    "CMY_C": 0.60484671592712,
    "CMY_M": 0.68745183944702,
    "CMY_Y": 0.68927347660065,
    "CMYK_C": 0,
    "CMYK_M": 0.20904576778412,
    "CMYK_Y": 0.2136557251215,
    "CMYK_K": 0.60484671592712
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0648",
    "Farbtonhilfsbezeichnung": "04.001.01",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "225",
    "Bcolor": "206",
    "Y": 74.9349365234375,
    "L": 89.3625106811523,
    "a": -1.76876771450043,
    "b": 8.91418838500977,
    "C": 9.08797550201416,
    "h": 101.222953796387,
    "CMY_C": 0.10431790351868,
    "CMY_M": 0.11711645126343,
    "CMY_Y": 0.19222986698151,
    "CMYK_C": 0,
    "CMYK_M": 0.01428916305304,
    "CMYK_Y": 0.09815085679293,
    "CMYK_K": 0.10431790351868
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0649",
    "Farbtonhilfsbezeichnung": "04.001.02",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "212",
    "Bcolor": "188",
    "Y": 66.312141418457,
    "L": 85.155387878418,
    "a": -0.2391362786293,
    "b": 12.1175594329834,
    "C": 12.1199188232422,
    "h": 91.1305694580078,
    "CMY_C": 0.13026112318039,
    "CMY_M": 0.16798627376556,
    "CMY_Y": 0.26092010736465,
    "CMYK_C": 0,
    "CMYK_M": 0.04337526112795,
    "CMYK_Y": 0.15022782981396,
    "CMYK_K": 0.13026112318039
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0650",
    "Farbtonhilfsbezeichnung": "04.001.03",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "197",
    "Bcolor": "174",
    "Y": 55.7912483215332,
    "L": 79.4948654174805,
    "a": -0.70336973667145,
    "b": 11.5428562164307,
    "C": 11.564266204834,
    "h": 93.4870300292969,
    "CMY_C": 0.19769096374512,
    "CMY_M": 0.22851383686066,
    "CMY_Y": 0.31689155101776,
    "CMYK_C": 0,
    "CMYK_M": 0.03841770812869,
    "CMYK_Y": 0.14857190847397,
    "CMYK_K": 0.19769096374512
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0651",
    "Farbtonhilfsbezeichnung": "04.001.04",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "173",
    "Bcolor": "146",
    "Y": 41.949146270752,
    "L": 70.8358459472656,
    "a": -0.43504962325096,
    "b": 14.450740814209,
    "C": 14.4572877883911,
    "h": 91.7244033813477,
    "CMY_C": 0.28202414512634,
    "CMY_M": 0.32247507572174,
    "CMY_Y": 0.42749828100204,
    "CMYK_C": 0,
    "CMYK_M": 0.05634023621678,
    "CMYK_Y": 0.20261703431606,
    "CMYK_K": 0.28202414512634
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0652",
    "Farbtonhilfsbezeichnung": "04.001.05",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "138",
    "Bcolor": "116",
    "Y": 25.8582954406738,
    "L": 57.9022979736328,
    "a": -0.04199090972543,
    "b": 13.0215978622437,
    "C": 13.0216655731201,
    "h": 90.1847610473633,
    "CMY_C": 0.41923397779465,
    "CMY_M": 0.45708245038986,
    "CMY_Y": 0.54693186283112,
    "CMYK_C": 0,
    "CMYK_M": 0.06516991555691,
    "CMYK_Y": 0.21987836062908,
    "CMYK_K": 0.41923397779465
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0653",
    "Farbtonhilfsbezeichnung": "04.001.06",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "127",
    "Bcolor": "108",
    "Y": 21.5221729278564,
    "L": 53.5163040161133,
    "a": -0.17954054474831,
    "b": 11.002236366272,
    "C": 11.003701210022,
    "h": 90.9348983764648,
    "CMY_C": 0.46989470720291,
    "CMY_M": 0.50054132938385,
    "CMY_Y": 0.57601273059845,
    "CMYK_C": 0,
    "CMYK_M": 0.0578123293817,
    "CMYK_Y": 0.20018291473389,
    "CMYK_K": 0.46989470720291
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0654",
    "Farbtonhilfsbezeichnung": "04.002.01",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "238",
    "Bcolor": "230",
    "Y": 83.0926895141602,
    "L": 93.0550003051758,
    "a": -5.65050649642944,
    "b": 1.78185021877289,
    "C": 5.92479658126831,
    "h": 162.497665405273,
    "CMY_C": 0.11778724193573,
    "CMY_M": 0.06497895717621,
    "CMY_Y": 0.099345266819,
    "CMYK_C": 0.05647817626595,
    "CMYK_M": 0,
    "CMYK_Y": 0.03675458580256,
    "CMYK_K": 0.06497895717621
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0655",
    "Farbtonhilfsbezeichnung": "04.002.02",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 77.7623672485352,
    "L": 90.6713562011719,
    "a": -7.4244179725647,
    "b": 1.95781826972961,
    "C": 7.67821836471558,
    "h": 165.227401733398,
    "CMY_C": 0.15822726488113,
    "CMY_M": 0.0877326130867,
    "CMY_Y": 0.12723559141159,
    "CMYK_C": 0.07727411389351,
    "CMYK_M": 0,
    "CMYK_Y": 0.04330197349191,
    "CMYK_K": 0.0877326130867
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0656",
    "Farbtonhilfsbezeichnung": "04.002.03",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "217",
    "Bcolor": "208",
    "Y": 65.8403778076172,
    "L": 84.9149322509766,
    "a": -8.7521448135376,
    "b": 1.25158751010895,
    "C": 8.84118270874023,
    "h": 171.861679077148,
    "CMY_C": 0.23485022783279,
    "CMY_M": 0.14858049154282,
    "CMY_Y": 0.18523102998734,
    "CMYK_C": 0.10132459551096,
    "CMYK_M": 0,
    "CMYK_Y": 0.0430463925004,
    "CMYK_K": 0.14858049154282
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0657",
    "Farbtonhilfsbezeichnung": "04.002.04",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "202",
    "Bcolor": "194",
    "Y": 55.5827445983887,
    "L": 79.3757553100586,
    "a": -8.57704162597656,
    "b": 0.66542822122574,
    "C": 8.60281562805176,
    "h": 175.563735961914,
    "CMY_C": 0.29518526792526,
    "CMY_M": 0.20954567193985,
    "CMY_Y": 0.24080234766006,
    "CMYK_C": 0.10834224522114,
    "CMYK_M": 0,
    "CMYK_Y": 0.03954267129302,
    "CMYK_K": 0.20954567193985
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0658",
    "Farbtonhilfsbezeichnung": "04.002.05",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "183",
    "Bcolor": "177",
    "Y": 44.1846542358398,
    "L": 72.3517456054688,
    "a": -9.36157703399658,
    "b": -0.83535343408585,
    "C": 9.39877319335938,
    "h": 185.09912109375,
    "CMY_C": 0.38166892528534,
    "CMY_M": 0.28330636024475,
    "CMY_Y": 0.30496346950531,
    "CMYK_C": 0.13724492490292,
    "CMYK_M": 0,
    "CMYK_Y": 0.0302180852741,
    "CMYK_K": 0.28330636024475
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0659",
    "Farbtonhilfsbezeichnung": "04.002.06",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "160",
    "Bcolor": "155",
    "Y": 32.9650077819824,
    "L": 64.132568359375,
    "a": -8.34350395202637,
    "b": -0.77027398347855,
    "C": 8.37898445129395,
    "h": 185.274612426758,
    "CMY_C": 0.457878947258,
    "CMY_M": 0.3722682595253,
    "CMY_Y": 0.39103752374649,
    "CMYK_C": 0.13638101518154,
    "CMYK_M": 0,
    "CMYK_Y": 0.02990013547242,
    "CMYK_K": 0.3722682595253
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0660",
    "Farbtonhilfsbezeichnung": "04.003.01",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "225",
    "Bcolor": "209",
    "Y": 73.3421478271484,
    "L": 88.6106414794922,
    "a": -5.1216607093811,
    "b": 6.10275411605835,
    "C": 7.96712112426758,
    "h": 130.004638671875,
    "CMY_C": 0.14777022600174,
    "CMY_M": 0.11701154708862,
    "CMY_Y": 0.18013650178909,
    "CMYK_C": 0.03483474627137,
    "CMYK_M": 0,
    "CMYK_Y": 0.07149012386799,
    "CMYK_K": 0.11701154708862
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0661",
    "Farbtonhilfsbezeichnung": "04.003.02",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "214",
    "Bcolor": "196",
    "Y": 65.1018981933594,
    "L": 84.5362167358398,
    "a": -5.31668519973755,
    "b": 6.88309717178345,
    "C": 8.69736576080322,
    "h": 127.683448791504,
    "CMY_C": 0.1915128827095,
    "CMY_M": 0.1618310213089,
    "CMY_Y": 0.23001635074615,
    "CMYK_C": 0.03541273996234,
    "CMYK_M": 0,
    "CMYK_Y": 0.08135033398867,
    "CMYK_K": 0.1618310213089
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0662",
    "Farbtonhilfsbezeichnung": "04.003.03",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "199",
    "Bcolor": "183",
    "Y": 54.8467292785645,
    "L": 78.9528961181641,
    "a": -6.55629682540894,
    "b": 5.72790431976318,
    "C": 8.70596981048584,
    "h": 138.857940673828,
    "CMY_C": 0.26554274559021,
    "CMY_M": 0.21983236074448,
    "CMY_Y": 0.28152894973755,
    "CMYK_C": 0.05859046429396,
    "CMYK_M": 0,
    "CMYK_Y": 0.07908119261265,
    "CMYK_K": 0.21983236074448
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0663",
    "Farbtonhilfsbezeichnung": "04.003.04",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "178",
    "Bcolor": "161",
    "Y": 41.9233093261719,
    "L": 70.8180160522461,
    "a": -8.6867561340332,
    "b": 5.73452186584473,
    "C": 10.4088649749756,
    "h": 146.569381713867,
    "CMY_C": 0.36854887008667,
    "CMY_M": 0.30274683237076,
    "CMY_Y": 0.36732637882233,
    "CMYK_C": 0.09437323361635,
    "CMYK_M": 0,
    "CMYK_Y": 0.09261994063854,
    "CMYK_K": 0.30274683237076
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0664",
    "Farbtonhilfsbezeichnung": "04.003.05",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "166",
    "Bcolor": "150",
    "Y": 36.2698593139648,
    "L": 66.7256011962891,
    "a": -7.33382797241211,
    "b": 5.89365720748901,
    "C": 9.40851879119873,
    "h": 141.213729858398,
    "CMY_C": 0.40003836154938,
    "CMY_M": 0.34885764122009,
    "CMY_Y": 0.41046965122223,
    "CMYK_C": 0.07860142737627,
    "CMYK_M": 0,
    "CMYK_Y": 0.09462141245604,
    "CMYK_K": 0.34885764122009
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0665",
    "Farbtonhilfsbezeichnung": "04.003.06",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "154",
    "Bcolor": "139",
    "Y": 30.6408100128174,
    "L": 62.203239440918,
    "a": -7.60454225540161,
    "b": 5.8736457824707,
    "C": 9.60878658294678,
    "h": 142.317993164063,
    "CMY_C": 0.44864171743393,
    "CMY_M": 0.39547944068909,
    "CMY_Y": 0.45637410879135,
    "CMYK_C": 0.08794122189283,
    "CMYK_M": 0,
    "CMYK_Y": 0.10073217004538,
    "CMYK_K": 0.39547944068909
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0666",
    "Farbtonhilfsbezeichnung": "04.004.01",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "228",
    "Bcolor": "203",
    "Y": 76.536735534668,
    "L": 90.1079635620117,
    "a": -3.48142600059509,
    "b": 11.7317247390747,
    "C": 12.2373895645142,
    "h": 106.528419494629,
    "CMY_C": 0.10067182779312,
    "CMY_M": 0.10555595159531,
    "CMY_Y": 0.20527309179306,
    "CMYK_C": 0,
    "CMYK_M": 0.0054308581166,
    "CMYK_Y": 0.11631044745445,
    "CMYK_K": 0.10067182779312
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0667",
    "Farbtonhilfsbezeichnung": "04.004.02",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "213",
    "Bcolor": "188",
    "Y": 65.6406555175781,
    "L": 84.8127899169922,
    "a": -3.61048460006714,
    "b": 11.5929088592529,
    "C": 12.1421222686768,
    "h": 107.298629760742,
    "CMY_C": 0.16081434488297,
    "CMY_M": 0.16382616758347,
    "CMY_Y": 0.26126271486282,
    "CMYK_C": 0,
    "CMYK_M": 0.00358898262493,
    "CMYK_Y": 0.11969743669033,
    "CMYK_K": 0.16081434488297
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0668",
    "Farbtonhilfsbezeichnung": "04.004.03",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "199",
    "Bcolor": "173",
    "Y": 55.9423141479492,
    "L": 79.5809783935547,
    "a": -3.87888479232788,
    "b": 12.1506795883179,
    "C": 12.7547941207886,
    "h": 107.704742431641,
    "CMY_C": 0.21852576732635,
    "CMY_M": 0.22051119804382,
    "CMY_Y": 0.32087141275406,
    "CMYK_C": 0,
    "CMYK_M": 0.00254062213935,
    "CMYK_Y": 0.13096483051777,
    "CMYK_K": 0.21852576732635
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0669",
    "Farbtonhilfsbezeichnung": "04.004.04",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "179",
    "Bcolor": "152",
    "Y": 44.088264465332,
    "L": 72.2874526977539,
    "a": -4.81846046447754,
    "b": 13.3753204345703,
    "C": 14.2167778015137,
    "h": 109.811561584473,
    "CMY_C": 0.30065715312958,
    "CMY_M": 0.29712575674057,
    "CMY_Y": 0.40568816661835,
    "CMYK_C": 0.00502422219142,
    "CMYK_M": 0,
    "CMYK_Y": 0.15445496141911,
    "CMYK_K": 0.29712575674057
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0670",
    "Farbtonhilfsbezeichnung": "04.004.05",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "153",
    "Bcolor": "133",
    "Y": 31.2835464477539,
    "L": 62.7462692260742,
    "a": -3.39788103103638,
    "b": 9.76775646209717,
    "C": 10.3418884277344,
    "h": 109.181106567383,
    "CMY_C": 0.40054005384445,
    "CMY_M": 0.39950996637344,
    "CMY_Y": 0.47712606191635,
    "CMYK_C": 0.00171541143209,
    "CMYK_M": 0,
    "CMYK_Y": 0.12925459444523,
    "CMYK_K": 0.39950996637344
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0671",
    "Farbtonhilfsbezeichnung": "04.004.06",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "130",
    "Bcolor": "112",
    "Y": 21.6826801300049,
    "L": 53.6886901855469,
    "a": -3.18691086769104,
    "b": 8.62992477416992,
    "C": 9.19956493377686,
    "h": 110.268486022949,
    "CMY_C": 0.4945279955864,
    "CMY_M": 0.49198424816132,
    "CMY_Y": 0.5589103102684,
    "CMYK_C": 0.00500722136348,
    "CMYK_M": 0,
    "CMYK_Y": 0.13174013793468,
    "CMYK_K": 0.49198424816132
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0672",
    "Farbtonhilfsbezeichnung": "04.005.01",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "217",
    "Bcolor": "208",
    "Y": 68.7599029541016,
    "L": 86.3850173950195,
    "a": -1.14795029163361,
    "b": 3.44627547264099,
    "C": 3.63243770599365,
    "h": 108.4228515625,
    "CMY_C": 0.14979857206345,
    "CMY_M": 0.15007621049881,
    "CMY_Y": 0.18426239490509,
    "CMYK_C": 0,
    "CMYK_M": 0.00032655606628,
    "CMYK_Y": 0.04053606837988,
    "CMYK_K": 0.14979857206345
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0673",
    "Farbtonhilfsbezeichnung": "04.005.02",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "204",
    "Bcolor": "198",
    "Y": 59.9183616638184,
    "L": 81.7937927246094,
    "a": -1.94896006584167,
    "b": 2.12839102745056,
    "C": 2.88591289520264,
    "h": 132.480224609375,
    "CMY_C": 0.21067589521408,
    "CMY_M": 0.1982433795929,
    "CMY_Y": 0.22448414564133,
    "CMYK_C": 0.01550659537315,
    "CMYK_M": 0,
    "CMYK_Y": 0.03272909298539,
    "CMYK_K": 0.1982433795929
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0674",
    "Farbtonhilfsbezeichnung": "04.005.03",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "200",
    "Bcolor": "196",
    "Y": 57.3445129394531,
    "L": 80.3729782104492,
    "a": -0.72162193059921,
    "b": 1.15081810951233,
    "C": 1.35835218429565,
    "h": 122.089820861816,
    "CMY_C": 0.21984195709229,
    "CMY_M": 0.21625691652298,
    "CMY_Y": 0.23254555463791,
    "CMYK_C": 0.00457425462082,
    "CMYK_M": 0,
    "CMYK_Y": 0.02078313566744,
    "CMYK_K": 0.21625691652298
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0675",
    "Farbtonhilfsbezeichnung": "04.005.04",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "179",
    "Bcolor": "171",
    "Y": 44.5361366271973,
    "L": 72.5854034423828,
    "a": -1.45346212387085,
    "b": 2.99006366729736,
    "C": 3.32461023330688,
    "h": 115.924263000488,
    "CMY_C": 0.3030771613121,
    "CMY_M": 0.29884541034698,
    "CMY_Y": 0.32852238416672,
    "CMYK_C": 0.00603540381417,
    "CMYK_M": 0,
    "CMYK_Y": 0.04232586547732,
    "CMYK_K": 0.29884541034698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0676",
    "Farbtonhilfsbezeichnung": "04.005.05",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "150",
    "Bcolor": "149",
    "Y": 30.0397548675537,
    "L": 61.6885032653809,
    "a": -1.69974553585052,
    "b": -0.76183092594147,
    "C": 1.86266505718231,
    "h": 204.142059326172,
    "CMY_C": 0.43084383010864,
    "CMY_M": 0.41147118806839,
    "CMY_Y": 0.41536927223206,
    "CMYK_C": 0.03291706740856,
    "CMYK_M": 0,
    "CMYK_Y": 0.00662343809381,
    "CMYK_K": 0.41147118806839
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0677",
    "Farbtonhilfsbezeichnung": "04.005.06",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "132",
    "Bcolor": "129",
    "Y": 22.7549991607666,
    "L": 54.8190803527832,
    "a": -2.12732338905334,
    "b": 0.37207713723183,
    "C": 2.15961718559265,
    "h": 170.0791015625,
    "CMY_C": 0.49983203411102,
    "CMY_M": 0.48085981607437,
    "CMY_Y": 0.49246323108673,
    "CMYK_C": 0.03654546290636,
    "CMYK_M": 0,
    "CMYK_Y": 0.02235121652484,
    "CMYK_K": 0.48085981607437
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0678",
    "Farbtonhilfsbezeichnung": "04.006.01",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "227",
    "Bcolor": "220",
    "Y": 75.2951889038086,
    "L": 89.5310821533203,
    "a": -2.61061453819275,
    "b": 1.65863120555878,
    "C": 3.09295415878296,
    "h": 147.570510864258,
    "CMY_C": 0.1325997710228,
    "CMY_M": 0.11133408546448,
    "CMY_Y": 0.13691031932831,
    "CMYK_C": 0.02392989955842,
    "CMYK_M": 0,
    "CMYK_Y": 0.02878048270941,
    "CMYK_K": 0.11133408546448
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0679",
    "Farbtonhilfsbezeichnung": "04.006.02",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "215",
    "Bcolor": "209",
    "Y": 66.6131591796875,
    "L": 85.3082122802734,
    "a": -3.4966835975647,
    "b": 1.34232974052429,
    "C": 3.7454833984375,
    "h": 158.998886108398,
    "CMY_C": 0.18725001811981,
    "CMY_M": 0.15596520900726,
    "CMY_Y": 0.18090897798538,
    "CMYK_C": 0.03706578165293,
    "CMYK_M": 0,
    "CMYK_Y": 0.02955301105976,
    "CMYK_K": 0.15596520900726
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0680",
    "Farbtonhilfsbezeichnung": "04.006.03",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "200",
    "Bcolor": "195",
    "Y": 56.3417434692383,
    "L": 79.8079223632813,
    "a": -4.32831811904907,
    "b": 0.45466670393944,
    "C": 4.35213279724121,
    "h": 174.003372192383,
    "CMY_C": 0.25668597221375,
    "CMY_M": 0.21405553817749,
    "CMY_Y": 0.23408448696136,
    "CMYK_C": 0.05424102768302,
    "CMYK_M": 0,
    "CMYK_Y": 0.02548392303288,
    "CMYK_K": 0.21405553817749
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0681",
    "Farbtonhilfsbezeichnung": "04.006.04",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "180",
    "Bcolor": "177",
    "Y": 44.1359519958496,
    "L": 72.3192749023438,
    "a": -4.52918577194214,
    "b": -0.49245053529739,
    "C": 4.55587863922119,
    "h": 186.205291748047,
    "CMY_C": 0.34135675430298,
    "CMY_M": 0.29398316144943,
    "CMY_Y": 0.30712199211121,
    "CMYK_C": 0.06709980964661,
    "CMYK_M": 0,
    "CMYK_Y": 0.01860979758203,
    "CMYK_K": 0.29398316144943
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0682",
    "Farbtonhilfsbezeichnung": "04.006.05",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "153",
    "Bcolor": "151",
    "Y": 30.7794055938721,
    "L": 62.320972442627,
    "a": -4.52612781524658,
    "b": -0.8723127245903,
    "C": 4.60942125320435,
    "h": 190.908767700195,
    "CMY_C": 0.446328997612,
    "CMY_M": 0.39892047643661,
    "CMY_Y": 0.40848714113235,
    "CMYK_C": 0.07887229323387,
    "CMYK_M": 0,
    "CMYK_Y": 0.01591580547392,
    "CMYK_K": 0.39892047643661
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0683",
    "Farbtonhilfsbezeichnung": "04.006.06",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "132",
    "Bcolor": "129",
    "Y": 22.3168201446533,
    "L": 54.3615570068359,
    "a": -3.94081854820251,
    "b": -0.34695157408714,
    "C": 3.95606184005737,
    "h": 185.031372070312,
    "CMY_C": 0.52021038532257,
    "CMY_M": 0.48154366016388,
    "CMY_Y": 0.49244338274002,
    "CMYK_C": 0.07458048313856,
    "CMYK_M": 0,
    "CMYK_Y": 0.02102341502905,
    "CMYK_K": 0.48154366016388
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0684",
    "Farbtonhilfsbezeichnung": "04.007.01",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "222",
    "Bcolor": "194",
    "Y": 72.6899490356445,
    "L": 88.2996292114258,
    "a": -1.30278718471527,
    "b": 13.6770610809326,
    "C": 13.7389688491821,
    "h": 95.4412078857422,
    "CMY_C": 0.09876215457916,
    "CMY_M": 0.13119328022003,
    "CMY_Y": 0.23885715007782,
    "CMYK_C": 0,
    "CMYK_M": 0.0359850898385,
    "CMYK_Y": 0.15544730424881,
    "CMYK_K": 0.09876215457916
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0685",
    "Farbtonhilfsbezeichnung": "04.007.02",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "209",
    "Bcolor": "180",
    "Y": 63.7556915283203,
    "L": 83.8384094238281,
    "a": -1.05579447746277,
    "b": 14.8427486419678,
    "C": 14.8802518844604,
    "h": 94.0687103271484,
    "CMY_C": 0.14344239234924,
    "CMY_M": 0.18118137121201,
    "CMY_Y": 0.29503726959229,
    "CMYK_C": 0,
    "CMYK_M": 0.04405889287591,
    "CMYK_Y": 0.17698153853416,
    "CMYK_K": 0.14344239234924
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0686",
    "Farbtonhilfsbezeichnung": "04.007.03",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "199",
    "Bcolor": "171",
    "Y": 56.9699058532715,
    "L": 80.1626663208008,
    "a": -1.71160066127777,
    "b": 14.0559682846069,
    "C": 14.1597957611084,
    "h": 96.9427490234375,
    "CMY_C": 0.19089847803116,
    "CMY_M": 0.2195571064949,
    "CMY_Y": 0.3282173871994,
    "CMYK_C": 0,
    "CMYK_M": 0.03542031347752,
    "CMYK_Y": 0.16971777379513,
    "CMYK_K": 0.19089847803116
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0687",
    "Farbtonhilfsbezeichnung": "04.007.04",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "178",
    "Bcolor": "149",
    "Y": 44.7543601989746,
    "L": 72.7298583984375,
    "a": -0.58681005239487,
    "b": 15.6199083328247,
    "C": 15.6309270858765,
    "h": 92.151481628418,
    "CMY_C": 0.25976645946503,
    "CMY_M": 0.3023174405098,
    "CMY_Y": 0.41644841432571,
    "CMYK_C": 0,
    "CMYK_M": 0.05748318508267,
    "CMYK_Y": 0.21166557073593,
    "CMYK_K": 0.25976645946503
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0688",
    "Farbtonhilfsbezeichnung": "04.007.05",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "148",
    "Bcolor": "125",
    "Y": 29.5602264404297,
    "L": 61.2729072570801,
    "a": -1.0607658624649,
    "b": 12.5092964172363,
    "C": 12.5541915893555,
    "h": 94.8469848632812,
    "CMY_C": 0.39237713813782,
    "CMY_M": 0.42033720016479,
    "CMY_Y": 0.51035350561142,
    "CMYK_C": 0,
    "CMYK_M": 0.04601548612118,
    "CMYK_Y": 0.19416052103043,
    "CMYK_K": 0.39237713813782
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0689",
    "Farbtonhilfsbezeichnung": "04.007.06",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "123",
    "Bcolor": "98",
    "Y": 19.5875110626221,
    "L": 51.367603302002,
    "a": -2.02419447898865,
    "b": 13.9681043624878,
    "C": 14.1140108108521,
    "h": 98.2456436157227,
    "CMY_C": 0.49696010351181,
    "CMY_M": 0.51867270469666,
    "CMY_Y": 0.61674225330353,
    "CMYK_C": 0,
    "CMYK_M": 0.0431627817452,
    "CMYK_Y": 0.23811660706997,
    "CMYK_K": 0.49696010351181
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0690",
    "Farbtonhilfsbezeichnung": "04.008.01",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "215",
    "Y": 72.0484924316406,
    "L": 87.9919281005859,
    "a": -1.99724006652832,
    "b": 2.0987491607666,
    "C": 2.89719104766846,
    "h": 133.580352783203,
    "CMY_C": 0.14322572946548,
    "CMY_M": 0.12996697425842,
    "CMY_Y": 0.15695309638977,
    "CMYK_C": 0.0152393700555,
    "CMYK_M": 0,
    "CMYK_Y": 0.03101735375822,
    "CMYK_K": 0.12996697425842
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0691",
    "Farbtonhilfsbezeichnung": "04.008.02",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "209",
    "Bcolor": "206",
    "Y": 62.3558044433594,
    "L": 83.1022720336914,
    "a": -2.85393571853638,
    "b": -0.65818279981613,
    "C": 2.92884850502014,
    "h": 192.986663818359,
    "CMY_C": 0.21320533752441,
    "CMY_M": 0.18110531568527,
    "CMY_Y": 0.19023269414902,
    "CMYK_C": 0.03919920697808,
    "CMYK_M": 0,
    "CMYK_Y": 0.0111459735781,
    "CMYK_K": 0.18110531568527
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0692",
    "Farbtonhilfsbezeichnung": "04.008.03",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "201",
    "Bcolor": "200",
    "Y": 56.8814163208008,
    "L": 80.1128463745117,
    "a": -3.2881326675415,
    "b": -1.6759649515152,
    "C": 3.69061994552612,
    "h": 207.007995605469,
    "CMY_C": 0.25269502401352,
    "CMY_M": 0.21247071027756,
    "CMY_Y": 0.21530163288116,
    "CMYK_C": 0.05107659474015,
    "CMYK_M": 0,
    "CMYK_Y": 0.00359468860552,
    "CMYK_K": 0.21247071027756
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0693",
    "Farbtonhilfsbezeichnung": "04.008.04",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "185",
    "Bcolor": "187",
    "Y": 47.3122024536133,
    "L": 74.389030456543,
    "a": -3.68384289741516,
    "b": -3.25254845619202,
    "C": 4.91424131393433,
    "h": 221.442016601562,
    "CMY_C": 0.32279992103577,
    "CMY_M": 0.27294385433197,
    "CMY_Y": 0.26550751924515,
    "CMYK_C": 0.07800270617008,
    "CMYK_M": 0.01012445334345,
    "CMYK_Y": 0,
    "CMYK_K": 0.26550751924515
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0694",
    "Farbtonhilfsbezeichnung": "04.008.05",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "164",
    "Bcolor": "170",
    "Y": 35.6094551086426,
    "L": 66.2204360961914,
    "a": -4.06342697143555,
    "b": -5.82681465148926,
    "C": 7.10374593734741,
    "h": 235.109359741211,
    "CMY_C": 0.42107373476028,
    "CMY_M": 0.35794085264206,
    "CMY_Y": 0.33385175466537,
    "CMYK_C": 0.1309347897768,
    "CMYK_M": 0.03616176918149,
    "CMYK_Y": 0,
    "CMYK_K": 0.33385175466537
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0695",
    "Farbtonhilfsbezeichnung": "04.008.06",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "140",
    "Bcolor": "145",
    "Y": 25.1683883666992,
    "L": 57.2391166687012,
    "a": -3.31991863250732,
    "b": -4.89731931686401,
    "C": 5.91655254364014,
    "h": 235.866455078125,
    "CMY_C": 0.5029531121254,
    "CMY_M": 0.45248329639435,
    "CMY_Y": 0.43287700414658,
    "CMYK_C": 0.12356421351433,
    "CMYK_M": 0.03457149863243,
    "CMYK_Y": 0,
    "CMYK_K": 0.43287700414658
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0696",
    "Farbtonhilfsbezeichnung": "04.009.01",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "209",
    "Bcolor": "194",
    "Y": 64.8227844238281,
    "L": 84.392333984375,
    "a": 1.25088047981262,
    "b": 8.0387077331543,
    "C": 8.13544845581055,
    "h": 81.1552963256836,
    "CMY_C": 0.13933378458023,
    "CMY_M": 0.17883878946304,
    "CMY_Y": 0.23903757333755,
    "CMYK_C": 0,
    "CMYK_M": 0.04590049386024,
    "CMYK_Y": 0.11584489792585,
    "CMYK_K": 0.13933378458023
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0697",
    "Farbtonhilfsbezeichnung": "04.009.02",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "196",
    "Bcolor": "178",
    "Y": 56.0401382446289,
    "L": 79.6366577148438,
    "a": 1.12592124938965,
    "b": 9.67556190490723,
    "C": 9.74085235595703,
    "h": 83.3624877929688,
    "CMY_C": 0.1879695057869,
    "CMY_M": 0.2307653427124,
    "CMY_Y": 0.30162853002548,
    "CMYK_C": 0,
    "CMYK_M": 0.05270225182176,
    "CMYK_Y": 0.1399689167738,
    "CMYK_K": 0.1879695057869
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0698",
    "Farbtonhilfsbezeichnung": "04.009.03",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "178",
    "Bcolor": "159",
    "Y": 45.4414176940918,
    "L": 73.1816024780273,
    "a": 2.01906323432922,
    "b": 10.5472507476807,
    "C": 10.7387666702271,
    "h": 79.162956237793,
    "CMY_C": 0.2494934797287,
    "CMY_M": 0.30231887102127,
    "CMY_Y": 0.37531441450119,
    "CMYK_C": 0,
    "CMYK_M": 0.07038632035255,
    "CMYK_Y": 0.16764801740646,
    "CMYK_K": 0.2494934797287
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0699",
    "Farbtonhilfsbezeichnung": "04.009.04",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "146",
    "Bcolor": "129",
    "Y": 29.4769878387451,
    "L": 61.200309753418,
    "a": 1.91533315181732,
    "b": 9.97061157226563,
    "C": 10.1529111862183,
    "h": 79.1260681152344,
    "CMY_C": 0.37915694713593,
    "CMY_M": 0.42709118127823,
    "CMY_Y": 0.49320030212402,
    "CMYK_C": 0,
    "CMYK_M": 0.07720829546452,
    "CMYK_Y": 0.18369111418724,
    "CMYK_K": 0.37915694713593
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0700",
    "Farbtonhilfsbezeichnung": "04.009.05",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "144",
    "Bcolor": "125",
    "Y": 29.4362373352051,
    "L": 61.1647109985352,
    "a": 4.53210639953613,
    "b": 12.3624544143677,
    "C": 13.1670141220093,
    "h": 69.866943359375,
    "CMY_C": 0.35637879371643,
    "CMY_M": 0.43396186828613,
    "CMY_Y": 0.50953978300095,
    "CMYK_C": 0,
    "CMYK_M": 0.12054151296616,
    "CMYK_Y": 0.23796759545803,
    "CMYK_K": 0.35637879371643
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0701",
    "Farbtonhilfsbezeichnung": "04.009.06",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "136",
    "Bcolor": "121",
    "Y": 25.6063423156738,
    "L": 57.661491394043,
    "a": 4.02463102340698,
    "b": 9.76578712463379,
    "C": 10.5625877380371,
    "h": 67.6026840209961,
    "CMY_C": 0.40248322486877,
    "CMY_M": 0.4678555727005,
    "CMY_Y": 0.52658098936081,
    "CMYK_C": 0,
    "CMYK_M": 0.1094067171216,
    "CMYK_Y": 0.20768916606903,
    "CMYK_K": 0.40248322486877
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0702",
    "Farbtonhilfsbezeichnung": "04.010.01",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "225",
    "Y": 85.5053176879883,
    "L": 94.1004333496094,
    "a": 2.20878767967224,
    "b": 5.74409627914429,
    "C": 6.15413570404053,
    "h": 68.9666595458984,
    "CMY_C": 0.03033035993576,
    "CMY_M": 0.07288366556168,
    "CMY_Y": 0.11618590354919,
    "CMYK_C": 0,
    "CMYK_M": 0.0438843332231,
    "CMYK_Y": 0.08854102343321,
    "CMYK_K": 0.03033035993576
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0703",
    "Farbtonhilfsbezeichnung": "04.010.02",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "224",
    "Bcolor": "211",
    "Y": 75.8327865600586,
    "L": 89.7816467285156,
    "a": 1.96342027187347,
    "b": 6.83460426330566,
    "C": 7.11103630065918,
    "h": 73.9718933105469,
    "CMY_C": 0.0775094628334,
    "CMY_M": 0.12077349424362,
    "CMY_Y": 0.17173409461975,
    "CMYK_C": 0,
    "CMYK_M": 0.04689915850759,
    "CMYK_Y": 0.10214156657457,
    "CMYK_K": 0.0775094628334
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0704",
    "Farbtonhilfsbezeichnung": "04.010.03",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "209",
    "Bcolor": "193",
    "Y": 65.318000793457,
    "L": 84.647331237793,
    "a": 3.33961200714111,
    "b": 8.94089794158936,
    "C": 9.5442476272583,
    "h": 69.5182876586914,
    "CMY_C": 0.11849164962769,
    "CMY_M": 0.1812692284584,
    "CMY_Y": 0.24256801605225,
    "CMYK_C": 0,
    "CMYK_M": 0.07121609151363,
    "CMYK_Y": 0.14075461030006,
    "CMYK_K": 0.11849164962769
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0705",
    "Farbtonhilfsbezeichnung": "04.010.04",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "195",
    "Bcolor": "179",
    "Y": 56.0236320495605,
    "L": 79.6272659301758,
    "a": 3.75705695152283,
    "b": 9.17198085784912,
    "C": 9.91164493560791,
    "h": 67.724853515625,
    "CMY_C": 0.17043620347977,
    "CMY_M": 0.23696684837341,
    "CMY_Y": 0.29769289493561,
    "CMYK_C": 0,
    "CMYK_M": 0.08019955456257,
    "CMYK_Y": 0.15340194106102,
    "CMYK_K": 0.17043620347977
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0706",
    "Farbtonhilfsbezeichnung": "04.010.05",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "170",
    "Bcolor": "156",
    "Y": 42.3332595825195,
    "L": 71.1000823974609,
    "a": 5.37971019744873,
    "b": 9.54576396942139,
    "C": 10.9573211669922,
    "h": 60.5956764221191,
    "CMY_C": 0.25120174884796,
    "CMY_M": 0.33202677965164,
    "CMY_Y": 0.38923871517181,
    "CMYK_C": 0,
    "CMYK_M": 0.10793966054916,
    "CMYK_Y": 0.18434466421604,
    "CMYK_K": 0.25120174884796
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0707",
    "Farbtonhilfsbezeichnung": "04.010.06",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "158",
    "Bcolor": "146",
    "Y": 35.8923721313477,
    "L": 66.4376068115234,
    "a": 5.29308462142944,
    "b": 8.42948627471924,
    "C": 9.95354080200195,
    "h": 57.8742637634277,
    "CMY_C": 0.30478501319885,
    "CMY_M": 0.38040089607239,
    "CMY_Y": 0.42924946546555,
    "CMYK_C": 0,
    "CMYK_M": 0.1087661832571,
    "CMYK_Y": 0.17903016507626,
    "CMYK_K": 0.30478501319885
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0708",
    "Farbtonhilfsbezeichnung": "04.011.01",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "220",
    "Bcolor": "212",
    "Y": 72.9600601196289,
    "L": 88.4286651611328,
    "a": 2.1833930015564,
    "b": 4.59701442718506,
    "C": 5.08917951583862,
    "h": 64.5942077636719,
    "CMY_C": 0.09784245491028,
    "CMY_M": 0.13569283485413,
    "CMY_Y": 0.16996604204178,
    "CMYK_C": 0,
    "CMYK_M": 0.0419554002583,
    "CMYK_Y": 0.07994566857815,
    "CMYK_K": 0.09784245491028
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0709",
    "Farbtonhilfsbezeichnung": "04.011.02",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "208",
    "Bcolor": "199",
    "Y": 63.9043083190918,
    "L": 83.9159240722656,
    "a": 2.40180253982544,
    "b": 4.45226335525513,
    "C": 5.05878496170044,
    "h": 61.6550674438477,
    "CMY_C": 0.1467496752739,
    "CMY_M": 0.18583905696869,
    "CMY_Y": 0.2178590297699,
    "CMYK_C": 0,
    "CMYK_M": 0.04581232741475,
    "CMYK_Y": 0.08333937823772,
    "CMYK_K": 0.1467496752739
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0710",
    "Farbtonhilfsbezeichnung": "04.011.03",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "191",
    "Bcolor": "184",
    "Y": 53.112922668457,
    "L": 77.9416198730469,
    "a": 2.57453036308289,
    "b": 4.24892234802246,
    "C": 4.96805286407471,
    "h": 58.7872619628906,
    "CMY_C": 0.21159684658051,
    "CMY_M": 0.2510689496994,
    "CMY_Y": 0.28035897016525,
    "CMYK_C": 0,
    "CMYK_M": 0.05006588622928,
    "CMYK_Y": 0.08721695840359,
    "CMYK_K": 0.21159684658051
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0711",
    "Farbtonhilfsbezeichnung": "04.011.04",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "173",
    "Bcolor": "166",
    "Y": 43.0539436340332,
    "L": 71.5915679931641,
    "a": 3.09329056739807,
    "b": 4.49402284622192,
    "C": 5.45570230484009,
    "h": 55.459888458252,
    "CMY_C": 0.27569967508316,
    "CMY_M": 0.3201607465744,
    "CMY_Y": 0.34890055656433,
    "CMYK_C": 0,
    "CMYK_M": 0.0613848567009,
    "CMYK_Y": 0.10106426477432,
    "CMYK_K": 0.27569967508316
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0712",
    "Farbtonhilfsbezeichnung": "04.011.05",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "158",
    "Bcolor": "153",
    "Y": 35.276252746582,
    "L": 65.9631805419922,
    "a": 2.97832226753235,
    "b": 3.6755211353302,
    "C": 4.73073577880859,
    "h": 50.9817047119141,
    "CMY_C": 0.3387057185173,
    "CMY_M": 0.378757417202,
    "CMY_Y": 0.40147179365158,
    "CMYK_C": 0,
    "CMYK_M": 0.06056562066078,
    "CMYK_Y": 0.09491398185492,
    "CMYK_K": 0.3387057185173
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0713",
    "Farbtonhilfsbezeichnung": "04.011.06",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "146",
    "Bcolor": "140",
    "Y": 29.8638725280762,
    "L": 61.5365867614746,
    "a": 3.53810167312622,
    "b": 4.32369232177734,
    "C": 5.58681297302246,
    "h": 50.7063446044922,
    "CMY_C": 0.37936550378799,
    "CMY_M": 0.42594885826111,
    "CMY_Y": 0.45097243785858,
    "CMYK_C": 0,
    "CMYK_M": 0.07505763322115,
    "CMYK_Y": 0.11537697911263,
    "CMYK_K": 0.37936550378799
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0714",
    "Farbtonhilfsbezeichnung": "04.012.01",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "213",
    "Bcolor": "202",
    "Y": 67.5883178710938,
    "L": 85.800178527832,
    "a": 1.29805135726929,
    "b": 5.85726737976074,
    "C": 5.99937629699707,
    "h": 77.5044174194336,
    "CMY_C": 0.12990409135818,
    "CMY_M": 0.16291874647141,
    "CMY_Y": 0.20791029930115,
    "CMYK_C": 0,
    "CMYK_M": 0.03794369474053,
    "CMYK_Y": 0.08965242654085,
    "CMYK_K": 0.12990409135818
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0715",
    "Farbtonhilfsbezeichnung": "04.012.02",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "201",
    "Bcolor": "189",
    "Y": 58.5081405639648,
    "L": 81.0204849243164,
    "a": 0.41393348574638,
    "b": 5.6667914390564,
    "C": 5.68188953399658,
    "h": 85.8222198486328,
    "CMY_C": 0.18977361917496,
    "CMY_M": 0.21306204795837,
    "CMY_Y": 0.25806087255478,
    "CMYK_C": 0,
    "CMYK_M": 0.02874311432242,
    "CMYK_Y": 0.0842816978693,
    "CMYK_K": 0.18977361917496
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0716",
    "Farbtonhilfsbezeichnung": "04.012.03",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "182",
    "Bcolor": "171",
    "Y": 47.3242225646973,
    "L": 74.3966827392578,
    "a": 0.67587900161743,
    "b": 5.57272243499756,
    "C": 5.61355924606323,
    "h": 83.0847396850586,
    "CMY_C": 0.25996655225754,
    "CMY_M": 0.2850296497345,
    "CMY_Y": 0.32752031087875,
    "CMYK_C": 0,
    "CMYK_M": 0.03386751934886,
    "CMYK_Y": 0.09128473699093,
    "CMYK_K": 0.25996655225754
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0717",
    "Farbtonhilfsbezeichnung": "04.012.04",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "165",
    "Bcolor": "156",
    "Y": 38.0606346130371,
    "L": 68.0652770996094,
    "a": 0.64352476596832,
    "b": 4.83474969863892,
    "C": 4.87738943099976,
    "h": 82.4182662963867,
    "CMY_C": 0.32985734939575,
    "CMY_M": 0.35178530216217,
    "CMY_Y": 0.38821583986282,
    "CMYK_C": 0,
    "CMYK_M": 0.03272132202983,
    "CMYK_Y": 0.08708368241787,
    "CMYK_K": 0.32985734939575
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0718",
    "Farbtonhilfsbezeichnung": "04.012.05",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "154",
    "Bcolor": "146",
    "Y": 32.3179054260254,
    "L": 63.6047592163086,
    "a": 0.27892026305199,
    "b": 3.82714772224426,
    "C": 3.83729791641235,
    "h": 85.8316879272461,
    "CMY_C": 0.38218212127686,
    "CMY_M": 0.39719015359879,
    "CMY_Y": 0.4270196557045,
    "CMYK_C": 0,
    "CMYK_M": 0.02429200150073,
    "CMYK_Y": 0.07257403433323,
    "CMYK_K": 0.38218212127686
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0719",
    "Farbtonhilfsbezeichnung": "04.012.06",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "142",
    "Bcolor": "135",
    "Y": 27.0733680725098,
    "L": 59.0421752929688,
    "a": -0.07871244847775,
    "b": 3.23383665084839,
    "C": 3.23479437828064,
    "h": 91.3943176269531,
    "CMY_C": 0.4335510134697,
    "CMY_M": 0.44313853979111,
    "CMY_Y": 0.46919387578964,
    "CMYK_C": 0,
    "CMYK_M": 0.01692566648126,
    "CMYK_Y": 0.06292334198952,
    "CMYK_K": 0.4335510134697
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0720",
    "Farbtonhilfsbezeichnung": "04.013.01",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 66.1533432006836,
    "L": 85.0745697021484,
    "a": -0.88442367315292,
    "b": 4.34848737716675,
    "C": 4.43751573562622,
    "h": 101.496376037598,
    "CMY_C": 0.15927475690842,
    "CMY_M": 0.1653648018837,
    "CMY_Y": 0.20504826307297,
    "CMYK_C": 0,
    "CMYK_M": 0.00724379951134,
    "CMYK_Y": 0.05444526299834,
    "CMYK_K": 0.15927475690842
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0721",
    "Farbtonhilfsbezeichnung": "04.013.02",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "195",
    "Bcolor": "185",
    "Y": 54.7990798950195,
    "L": 78.9253921508789,
    "a": -0.35032480955124,
    "b": 4.62908744812012,
    "C": 4.64232444763184,
    "h": 94.3278350830078,
    "CMY_C": 0.22153043746948,
    "CMY_M": 0.23374289274216,
    "CMY_Y": 0.27303862571716,
    "CMYK_C": 0,
    "CMYK_M": 0.01568777486682,
    "CMYK_Y": 0.06616596132517,
    "CMYK_K": 0.22153043746948
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0722",
    "Farbtonhilfsbezeichnung": "04.013.04",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "162",
    "Bcolor": "154",
    "Y": 36.1416473388672,
    "L": 66.6280136108398,
    "a": -0.18663181364536,
    "b": 3.60156488418579,
    "C": 3.60639715194702,
    "h": 92.9663925170898,
    "CMY_C": 0.3546621799469,
    "CMY_M": 0.36465895175934,
    "CMY_Y": 0.39455628395081,
    "CMYK_C": 0,
    "CMYK_M": 0.01549075730145,
    "CMYK_Y": 0.06181894615293,
    "CMYK_K": 0.3546621799469
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0723",
    "Farbtonhilfsbezeichnung": "04.013.05",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "146",
    "Bcolor": "138",
    "Y": 28.6185703277588,
    "L": 60.4435119628906,
    "a": -0.21973550319672,
    "b": 4.00084495544434,
    "C": 4.00687456130981,
    "h": 93.1436614990234,
    "CMY_C": 0.41793036460876,
    "CMY_M": 0.42869532108307,
    "CMY_Y": 0.46032047271729,
    "CMYK_C": 0,
    "CMYK_M": 0.01849427632987,
    "CMYK_Y": 0.07282652705908,
    "CMYK_K": 0.41793036460876
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0724",
    "Farbtonhilfsbezeichnung": "04.013.06",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "128",
    "Bcolor": "121",
    "Y": 21.6080169677734,
    "L": 53.6086120605469,
    "a": -0.04388560727239,
    "b": 3.81607174873352,
    "C": 3.81632399559021,
    "h": 90.6588821411133,
    "CMY_C": 0.486741065979,
    "CMY_M": 0.49826794862747,
    "CMY_Y": 0.52715444564819,
    "CMYK_C": 0,
    "CMYK_M": 0.02245822176337,
    "CMYK_Y": 0.07873877137899,
    "CMYK_K": 0.486741065979
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0725",
    "Farbtonhilfsbezeichnung": "04.014.01",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "215",
    "Bcolor": "211",
    "Y": 67.5653533935547,
    "L": 85.7886428833008,
    "a": -0.49820536375046,
    "b": 1.0566486120224,
    "C": 1.16821014881134,
    "h": 115.243675231934,
    "CMY_C": 0.15923964977264,
    "CMY_M": 0.15750360488892,
    "CMY_Y": 0.17317533493042,
    "CMYK_C": 0.00206059613265,
    "CMYK_M": 0,
    "CMYK_Y": 0.01860154047608,
    "CMYK_K": 0.15750360488892
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0726",
    "Farbtonhilfsbezeichnung": "04.014.02",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "196",
    "Bcolor": "194",
    "Y": 55.250846862793,
    "L": 79.1855392456055,
    "a": -0.41359534859657,
    "b": 0.33089491724968,
    "C": 0.52967214584351,
    "h": 141.338623046875,
    "CMY_C": 0.23306655883789,
    "CMY_M": 0.22961837053299,
    "CMY_Y": 0.23935866355896,
    "CMYK_C": 0.0044759484008,
    "CMYK_M": 0,
    "CMYK_Y": 0.01264346484095,
    "CMYK_K": 0.22961837053299
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0727",
    "Farbtonhilfsbezeichnung": "04.014.03",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "185",
    "Bcolor": "183",
    "Y": 48.5134658813477,
    "L": 75.1476364135742,
    "a": -0.52199023962021,
    "b": 0.18286989629269,
    "C": 0.55309599637985,
    "h": 160.693008422852,
    "CMY_C": 0.27782601118088,
    "CMY_M": 0.27282840013504,
    "CMY_Y": 0.28144121170044,
    "CMYK_C": 0.00687267072499,
    "CMYK_M": 0,
    "CMYK_Y": 0.01184426248074,
    "CMYK_K": 0.27282840013504
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0728",
    "Farbtonhilfsbezeichnung": "04.014.04",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "164",
    "Bcolor": "163",
    "Y": 36.9610443115234,
    "L": 67.2477951049805,
    "a": -0.37645348906517,
    "b": -0.49088606238365,
    "C": 0.61861646175385,
    "h": 232.515914916992,
    "CMY_C": 0.36249625682831,
    "CMY_M": 0.35667359828949,
    "CMY_Y": 0.3597314953804,
    "CMYK_C": 0.00905086193234,
    "CMYK_M": 0,
    "CMYK_Y": 0.00475325901061,
    "CMYK_K": 0.35667359828949
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0729",
    "Farbtonhilfsbezeichnung": "04.014.05",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "150",
    "Bcolor": "148",
    "Y": 30.6472816467285,
    "L": 62.2087364196777,
    "a": 1.27796304225922,
    "b": 0.49514842033386,
    "C": 1.37053334712982,
    "h": 21.1789226531982,
    "CMY_C": 0.39953285455704,
    "CMY_M": 0.41295647621155,
    "CMY_Y": 0.41827005147934,
    "CMYK_C": 0,
    "CMYK_M": 0.02235529758036,
    "CMYK_Y": 0.03120436705649,
    "CMYK_K": 0.39953285455704
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0730",
    "Farbtonhilfsbezeichnung": "04.014.06",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "134",
    "Bcolor": "133",
    "Y": 23.5613059997559,
    "L": 55.6458587646484,
    "a": -0.20410817861557,
    "b": -0.71489751338959,
    "C": 0.74346393346786,
    "h": 254.065582275391,
    "CMY_C": 0.48101967573166,
    "CMY_M": 0.47630906105042,
    "CMY_Y": 0.47669112682343,
    "CMYK_C": 0.00899502821267,
    "CMYK_M": 0,
    "CMYK_Y": 0.0007295634714,
    "CMYK_K": 0.47630906105042
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0731",
    "Farbtonhilfsbezeichnung": "04.015.01",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "228",
    "Bcolor": "219",
    "Y": 76.3804473876953,
    "L": 90.0356903076172,
    "a": -3.35247445106506,
    "b": 2.74785494804382,
    "C": 4.33471918106079,
    "h": 140.660247802734,
    "CMY_C": 0.12919718027115,
    "CMY_M": 0.10430258512497,
    "CMY_Y": 0.13951522111893,
    "CMYK_C": 0.02779353223741,
    "CMYK_M": 0,
    "CMYK_Y": 0.0393130928278,
    "CMYK_K": 0.10430258512497
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0732",
    "Farbtonhilfsbezeichnung": "04.015.02",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "202",
    "Bcolor": "195",
    "Y": 57.9424934387207,
    "L": 80.7068099975586,
    "a": -3.45851039886475,
    "b": 2.16598463058472,
    "C": 4.08078241348267,
    "h": 147.942047119141,
    "CMY_C": 0.23416072130203,
    "CMY_M": 0.20668339729309,
    "CMY_Y": 0.23665833473206,
    "CMYK_C": 0.03463601320982,
    "CMYK_M": 0,
    "CMYK_Y": 0.03778433054686,
    "CMYK_K": 0.20668339729309
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0733",
    "Farbtonhilfsbezeichnung": "04.015.03",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "188",
    "Bcolor": "181",
    "Y": 49.0043258666992,
    "L": 75.4540176391602,
    "a": -3.65564680099487,
    "b": 1.77631044387817,
    "C": 4.06436109542847,
    "h": 154.08447265625,
    "CMY_C": 0.29342007637024,
    "CMY_M": 0.26295977830887,
    "CMY_Y": 0.28995072841644,
    "CMYK_C": 0.04132786393166,
    "CMYK_M": 0,
    "CMYK_Y": 0.03662072867155,
    "CMYK_K": 0.26295977830887
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0734",
    "Farbtonhilfsbezeichnung": "04.015.04",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "179",
    "Bcolor": "173",
    "Y": 43.9805374145508,
    "L": 72.2154846191406,
    "a": -3.73229241371155,
    "b": 1.6391806602478,
    "C": 4.07638549804688,
    "h": 156.289474487305,
    "CMY_C": 0.32882553339005,
    "CMY_M": 0.29739218950272,
    "CMY_Y": 0.323166847229,
    "CMYK_C": 0.04473810642958,
    "CMYK_M": 0,
    "CMYK_Y": 0.03668427467346,
    "CMYK_K": 0.29739218950272
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0735",
    "Farbtonhilfsbezeichnung": "04.015.05",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "164",
    "Bcolor": "159",
    "Y": 36.1716041564941,
    "L": 66.6508331298828,
    "a": -3.45172786712646,
    "b": 1.01763987541199,
    "C": 3.59861302375793,
    "h": 163.573394775391,
    "CMY_C": 0.38700664043427,
    "CMY_M": 0.35661286115646,
    "CMY_Y": 0.37680381536484,
    "CMYK_C": 0.04724026471376,
    "CMYK_M": 0,
    "CMYK_Y": 0.03138227760792,
    "CMYK_K": 0.35661286115646
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0736",
    "Farbtonhilfsbezeichnung": "04.015.06",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "151",
    "Bcolor": "145",
    "Y": 30.2441825866699,
    "L": 61.8643417358398,
    "a": -3.71948790550232,
    "b": 2.04509878158569,
    "C": 4.2446460723877,
    "h": 151.196533203125,
    "CMY_C": 0.43497323989868,
    "CMY_M": 0.40608751773834,
    "CMY_Y": 0.43303507566452,
    "CMYK_C": 0.04863632842898,
    "CMYK_M": 0,
    "CMYK_Y": 0.04537294432521,
    "CMYK_K": 0.40608751773834
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0737",
    "Farbtonhilfsbezeichnung": "04.016.01",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "221",
    "Bcolor": "205",
    "Y": 72.0679931640625,
    "L": 88.0013046264648,
    "a": -1.43014276027679,
    "b": 7.51020193099976,
    "C": 7.64515781402588,
    "h": 100.781555175781,
    "CMY_C": 0.12117111682892,
    "CMY_M": 0.13264018297195,
    "CMY_Y": 0.19659727811813,
    "CMYK_C": 0,
    "CMYK_M": 0.0130503969267,
    "CMYK_Y": 0.08582576364279,
    "CMYK_K": 0.12117111682892
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0738",
    "Farbtonhilfsbezeichnung": "04.016.02",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "206",
    "Bcolor": "189",
    "Y": 61.0625915527344,
    "L": 82.4123840332031,
    "a": -1.81010627746582,
    "b": 7.98436403274536,
    "C": 8.18697452545166,
    "h": 102.773406982422,
    "CMY_C": 0.18426960706711,
    "CMY_M": 0.19335108995438,
    "CMY_Y": 0.26031184196472,
    "CMYK_C": 0,
    "CMYK_M": 0.01113294623792,
    "CMYK_Y": 0.09321981668472,
    "CMYK_K": 0.18426960706711
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0739",
    "Farbtonhilfsbezeichnung": "04.016.03",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "186",
    "Bcolor": "170",
    "Y": 48.9077491760254,
    "L": 75.3938980102539,
    "a": -1.25648379325867,
    "b": 7.79345035552979,
    "C": 7.89408779144287,
    "h": 99.1585922241211,
    "CMY_C": 0.25692880153656,
    "CMY_M": 0.27051949501038,
    "CMY_Y": 0.33315098285675,
    "CMYK_C": 0,
    "CMYK_M": 0.01828989386559,
    "CMYK_Y": 0.10257722437382,
    "CMYK_K": 0.25692880153656
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0740",
    "Farbtonhilfsbezeichnung": "04.016.04",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "177",
    "Bcolor": "163",
    "Y": 44.1920738220215,
    "L": 72.356689453125,
    "a": -0.74261659383774,
    "b": 7.3549485206604,
    "C": 7.39234399795532,
    "h": 95.7655181884766,
    "CMY_C": 0.28700792789459,
    "CMY_M": 0.30398744344711,
    "CMY_Y": 0.3616726398468,
    "CMYK_C": 0,
    "CMYK_M": 0.02381445281208,
    "CMYK_Y": 0.10472025722265,
    "CMYK_K": 0.28700792789459
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0741",
    "Farbtonhilfsbezeichnung": "04.016.05",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "153",
    "Bcolor": "141",
    "Y": 31.7691078186035,
    "L": 63.1515922546387,
    "a": -1.01198244094849,
    "b": 5.82145690917969,
    "C": 5.90876197814941,
    "h": 99.8615570068359,
    "CMY_C": 0.39033782482147,
    "CMY_M": 0.39953565597534,
    "CMY_Y": 0.44552338123322,
    "CMYK_C": 0,
    "CMYK_M": 0.01508676726371,
    "CMYK_Y": 0.09051825851202,
    "CMYK_K": 0.39033782482147
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0742",
    "Farbtonhilfsbezeichnung": "04.016.06",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "122",
    "Bcolor": "110",
    "Y": 19.4022541046143,
    "L": 51.1545372009277,
    "a": -1.28280663490295,
    "b": 6.53566026687622,
    "C": 6.66036415100098,
    "h": 101.104736328125,
    "CMY_C": 0.51235675811768,
    "CMY_M": 0.52075457572937,
    "CMY_Y": 0.56932532787323,
    "CMYK_C": 0,
    "CMYK_M": 0.01722123287618,
    "CMYK_Y": 0.11682427674532,
    "CMYK_K": 0.51235675811768
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0743",
    "Farbtonhilfsbezeichnung": "04.017.01",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "224",
    "Bcolor": "200",
    "Y": 73.5892562866211,
    "L": 88.7279968261719,
    "a": -2.30799579620361,
    "b": 11.2592782974243,
    "C": 11.4933977127075,
    "h": 101.584365844727,
    "CMY_C": 0.10849225521088,
    "CMY_M": 0.12349933385849,
    "CMY_Y": 0.21652430295944,
    "CMYK_C": 0,
    "CMYK_M": 0.01683336868882,
    "CMYK_Y": 0.12117903679609,
    "CMYK_K": 0.10849225521088
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0744",
    "Farbtonhilfsbezeichnung": "04.017.02",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "212",
    "Bcolor": "187",
    "Y": 65.1919631958008,
    "L": 84.5825576782227,
    "a": -1.81541395187378,
    "b": 12.0109004974365,
    "C": 12.1473226547241,
    "h": 98.5950393676758,
    "CMY_C": 0.14863473176956,
    "CMY_M": 0.17057919502258,
    "CMY_Y": 0.2665057182312,
    "CMYK_C": 0,
    "CMYK_M": 0.02577561512589,
    "CMYK_Y": 0.13844937086105,
    "CMYK_K": 0.14863473176956
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0745",
    "Farbtonhilfsbezeichnung": "04.017.03",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "194",
    "Bcolor": "171",
    "Y": 53.3890533447266,
    "L": 78.1041412353516,
    "a": -2.72712063789368,
    "b": 11.3270931243897,
    "C": 11.6507606506348,
    "h": 103.536949157715,
    "CMY_C": 0.22834503650665,
    "CMY_M": 0.23889493942261,
    "CMY_Y": 0.33027315139771,
    "CMYK_C": 0,
    "CMYK_M": 0.01367178745568,
    "CMYK_Y": 0.13209027051926,
    "CMYK_K": 0.22834503650665
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0746",
    "Farbtonhilfsbezeichnung": "04.017.04",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "178",
    "Bcolor": "152",
    "Y": 44.2839431762695,
    "L": 72.4178771972656,
    "a": -2.25665521621704,
    "b": 13.5876798629761,
    "C": 13.7737989425659,
    "h": 99.4296646118164,
    "CMY_C": 0.28014320135117,
    "CMY_M": 0.30142432451248,
    "CMY_Y": 0.40545666217804,
    "CMYK_C": 0,
    "CMYK_M": 0.02956299483776,
    "CMYK_Y": 0.17408110201359,
    "CMYK_K": 0.28014320135117
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0747",
    "Farbtonhilfsbezeichnung": "04.017.05",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "148",
    "Bcolor": "125",
    "Y": 29.6218357086182,
    "L": 61.3265495300293,
    "a": -1.93332934379578,
    "b": 12.3978700637817,
    "C": 12.5477066040039,
    "h": 98.8633499145508,
    "CMY_C": 0.39809960126877,
    "CMY_M": 0.41787159442902,
    "CMY_Y": 0.50918942689896,
    "CMYK_C": 0,
    "CMYK_M": 0.032849278301,
    "CMYK_Y": 0.1845651268959,
    "CMYK_K": 0.39809960126877
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0748",
    "Farbtonhilfsbezeichnung": "04.017.06",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "128",
    "Bcolor": "107",
    "Y": 21.3706798553467,
    "L": 53.3528099060059,
    "a": -2.15579891204834,
    "b": 11.3549404144287,
    "C": 11.5577735900879,
    "h": 100.749984741211,
    "CMY_C": 0.48391717672348,
    "CMY_M": 0.49807512760162,
    "CMY_Y": 0.58025145530701,
    "CMYK_C": 0,
    "CMYK_M": 0.02743348665535,
    "CMYK_Y": 0.18666437268257,
    "CMYK_K": 0.48391717672348
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0749",
    "Farbtonhilfsbezeichnung": "04.018.01",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "217",
    "Bcolor": "223",
    "Y": 68.3658599853516,
    "L": 86.1890640258789,
    "a": -1.46767520904541,
    "b": -5.00708627700806,
    "C": 5.21775674819946,
    "h": 253.663101196289,
    "CMY_C": 0.18428421020508,
    "CMY_M": 0.14908409118652,
    "CMY_Y": 0.12455606460571,
    "CMYK_C": 0.06822612136602,
    "CMYK_M": 0.02801781520247,
    "CMYK_Y": 0,
    "CMYK_K": 0.12455606460571
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0750",
    "Farbtonhilfsbezeichnung": "04.018.02",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "206",
    "Bcolor": "214",
    "Y": 60.5273361206055,
    "L": 82.1239852905273,
    "a": -2.08469271659851,
    "b": -6.20533657073975,
    "C": 6.54615497589111,
    "h": 251.430145263672,
    "CMY_C": 0.23820066452026,
    "CMY_M": 0.19194835424423,
    "CMY_Y": 0.16054946184158,
    "CMYK_C": 0.09250241518021,
    "CMYK_M": 0.03740410134196,
    "CMYK_Y": 0,
    "CMYK_K": 0.16054946184158
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0751",
    "Farbtonhilfsbezeichnung": "04.018.03",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "182",
    "Bcolor": "192",
    "Y": 45.6317901611328,
    "L": 73.3059692382813,
    "a": -2.27842307090759,
    "b": -7.26676797866821,
    "C": 7.61558437347412,
    "h": 252.591705322266,
    "CMY_C": 0.33823853731155,
    "CMY_M": 0.28646069765091,
    "CMY_Y": 0.24845516681671,
    "CMYK_C": 0.11946509033442,
    "CMYK_M": 0.05056987702847,
    "CMYK_Y": 0,
    "CMYK_K": 0.24845516681671
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0752",
    "Farbtonhilfsbezeichnung": "04.018.04",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "161",
    "Bcolor": "163",
    "Y": 34.9573707580566,
    "L": 65.715461730957,
    "a": -1.38035035133362,
    "b": -2.86830878257751,
    "C": 3.18316864967346,
    "h": 244.301177978516,
    "CMY_C": 0.39414912462234,
    "CMY_M": 0.36983096599579,
    "CMY_Y": 0.35930210351944,
    "CMYK_C": 0.05438916012645,
    "CMYK_M": 0.01643342711031,
    "CMYK_Y": 0,
    "CMYK_K": 0.35930210351944
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0753",
    "Farbtonhilfsbezeichnung": "04.018.05",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "152",
    "Bcolor": "157",
    "Y": 30.6464920043945,
    "L": 62.208065032959,
    "a": -2.12417435646057,
    "b": -4.57511281967163,
    "C": 5.04418230056763,
    "h": 245.095077514648,
    "CMY_C": 0.4421135187149,
    "CMY_M": 0.40415906906128,
    "CMY_Y": 0.38399302959442,
    "CMYK_C": 0.09435037523508,
    "CMYK_M": 0.03273670747876,
    "CMYK_Y": 0,
    "CMYK_K": 0.38399302959442
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0754",
    "Farbtonhilfsbezeichnung": "04.018.06",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "137",
    "Bcolor": "140",
    "Y": 24.6118278503418,
    "L": 56.6952362060547,
    "a": -1.57254993915558,
    "b": -3.26170969009399,
    "C": 3.62100315093994,
    "h": 244.260147094727,
    "CMY_C": 0.48907089233398,
    "CMY_M": 0.46210849285126,
    "CMY_Y": 0.44920098781586,
    "CMYK_C": 0.07238557934761,
    "CMYK_M": 0.02343414723873,
    "CMYK_Y": 0,
    "CMYK_K": 0.44920098781586
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0755",
    "Farbtonhilfsbezeichnung": "04.019.01",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "239",
    "Bcolor": "209",
    "Y": 86.6997451782227,
    "L": 94.6107330322266,
    "a": -1.32099199295044,
    "b": 14.8973207473755,
    "C": 14.955774307251,
    "h": 95.0673370361328,
    "CMY_C": 0.02432757616043,
    "CMY_M": 0.06104046106339,
    "CMY_Y": 0.17960345745087,
    "CMYK_C": 0,
    "CMYK_M": 0.03762828931212,
    "CMYK_Y": 0.15914756059647,
    "CMYK_K": 0.02432757616043
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0756",
    "Farbtonhilfsbezeichnung": "04.019.02",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "234",
    "Bcolor": "204",
    "Y": 82.9023590087891,
    "L": 92.9716720581055,
    "a": 0.17777208983898,
    "b": 15.0982961654663,
    "C": 15.0993423461914,
    "h": 89.3254089355469,
    "CMY_C": 0.03111505508423,
    "CMY_M": 0.0830505490303,
    "CMY_Y": 0.19869863986969,
    "CMYK_C": 0,
    "CMYK_M": 0.05360336601734,
    "CMYK_Y": 0.17296540737152,
    "CMYK_K": 0.03111505508423
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0757",
    "Farbtonhilfsbezeichnung": "04.019.03",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "232",
    "Bcolor": "211",
    "Y": 81.3378067016602,
    "L": 92.2817993164062,
    "a": 0.82638317346573,
    "b": 10.8595685958862,
    "C": 10.8909664154053,
    "h": 85.6483383178711,
    "CMY_C": 0.04602891206741,
    "CMY_M": 0.09125351905823,
    "CMY_Y": 0.17448204755783,
    "CMYK_C": 0,
    "CMYK_M": 0.04740668460727,
    "CMYK_Y": 0.13465097546577,
    "CMYK_K": 0.04602891206741
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0758",
    "Farbtonhilfsbezeichnung": "04.019.04",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "213",
    "Y": 79.5845565795898,
    "L": 91.4981307983398,
    "a": 0.24451673030853,
    "b": 8.41486740112305,
    "C": 8.41841888427734,
    "h": 88.3355865478516,
    "CMY_C": 0.06651759147644,
    "CMY_M": 0.0979700088501,
    "CMY_Y": 0.16495257616043,
    "CMYK_C": 0,
    "CMYK_M": 0.03369363769889,
    "CMYK_Y": 0.10544921457767,
    "CMYK_K": 0.06651759147644
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0759",
    "Farbtonhilfsbezeichnung": "04.019.05",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "218",
    "Bcolor": "198",
    "Y": 70.6191635131836,
    "L": 87.2996444702148,
    "a": 0.62113308906555,
    "b": 10.0953941345215,
    "C": 10.114483833313,
    "h": 86.4792404174805,
    "CMY_C": 0.10572999715805,
    "CMY_M": 0.14589506387711,
    "CMY_Y": 0.22290873527527,
    "CMYK_C": 0,
    "CMYK_M": 0.04491380229592,
    "CMYK_Y": 0.13103283941746,
    "CMYK_K": 0.10572999715805
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0760",
    "Farbtonhilfsbezeichnung": "04.019.06",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "225",
    "Bcolor": "212",
    "Y": 74.7379150390625,
    "L": 89.2700881958008,
    "a": -1.6477632522583,
    "b": 5.44885206222534,
    "C": 5.69254875183105,
    "h": 106.825607299805,
    "CMY_C": 0.1152526140213,
    "CMY_M": 0.11751353740692,
    "CMY_Y": 0.16761600971222,
    "CMYK_C": 0,
    "CMYK_M": 0.00255544506945,
    "CMYK_Y": 0.05918457359076,
    "CMYK_K": 0.1152526140213
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0761",
    "Farbtonhilfsbezeichnung": "04.020.01",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "225",
    "Y": 83.6813354492188,
    "L": 93.3119201660156,
    "a": 1.25857102870941,
    "b": 4.8256402015686,
    "C": 4.98706388473511,
    "h": 75.3823699951172,
    "CMY_C": 0.04944783449173,
    "CMY_M": 0.07916343212128,
    "CMY_Y": 0.1181880235672,
    "CMYK_C": 0,
    "CMYK_M": 0.03126140683889,
    "CMYK_Y": 0.07231606543064,
    "CMYK_K": 0.04944783449173
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0762",
    "Farbtonhilfsbezeichnung": "04.020.02",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "235",
    "Bcolor": "221",
    "Y": 84.8145446777344,
    "L": 93.8031387329102,
    "a": 2.60851621627808,
    "b": 7.59158134460449,
    "C": 8.0272331237793,
    "h": 71.0369491577148,
    "CMY_C": 0.02498906850815,
    "CMY_M": 0.07769381999969,
    "CMY_Y": 0.13318395614624,
    "CMYK_C": 0,
    "CMYK_M": 0.05405554920435,
    "CMYK_Y": 0.11096787452698,
    "CMYK_K": 0.02498906850815
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0763",
    "Farbtonhilfsbezeichnung": "04.020.03",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "234",
    "Bcolor": "218",
    "Y": 84.1623001098633,
    "L": 93.5209503173828,
    "a": 3.21382689476013,
    "b": 8.59695816040039,
    "C": 9.17803764343262,
    "h": 69.5026016235352,
    "CMY_C": 0.02062058448792,
    "CMY_M": 0.0826056599617,
    "CMY_Y": 0.14369022846222,
    "CMYK_C": 0,
    "CMYK_M": 0.06329015642405,
    "CMYK_Y": 0.12566083669662,
    "CMYK_K": 0.02062058448792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0764",
    "Farbtonhilfsbezeichnung": "04.020.04",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "220",
    "Y": 85.7924880981445,
    "L": 94.2235565185547,
    "a": 1.32556462287903,
    "b": 8.80618476867676,
    "C": 8.90539264678955,
    "h": 81.4397354125977,
    "CMY_C": 0.02633112668991,
    "CMY_M": 0.07018494606018,
    "CMY_Y": 0.13782173395157,
    "CMYK_C": 0,
    "CMYK_M": 0.04503976553679,
    "CMYK_Y": 0.11450567096472,
    "CMYK_K": 0.02633112668991
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0765",
    "Farbtonhilfsbezeichnung": "04.020.05",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "233",
    "Bcolor": "213",
    "Y": 83.2576675415039,
    "L": 93.1271286010742,
    "a": 2.94278621673584,
    "b": 10.8244400024414,
    "C": 11.2173299789429,
    "h": 74.7908782958984,
    "CMY_C": 0.02067023515701,
    "CMY_M": 0.08693414926529,
    "CMY_Y": 0.1646540760994,
    "CMYK_C": 0,
    "CMYK_M": 0.06766251474619,
    "CMYK_Y": 0.1470228433609,
    "CMYK_K": 0.02067023515701
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0766",
    "Farbtonhilfsbezeichnung": "04.020.06",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "222",
    "Y": 82.2269515991211,
    "L": 92.674934387207,
    "a": 0.62664604187012,
    "b": 5.37886476516724,
    "C": 5.41524457931519,
    "h": 83.3549118041992,
    "CMY_C": 0.0597517490387,
    "CMY_M": 0.08492463827133,
    "CMY_Y": 0.12942183017731,
    "CMYK_C": 0,
    "CMYK_M": 0.02677259966731,
    "CMYK_Y": 0.07409753650427,
    "CMYK_K": 0.0597517490387
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0767",
    "Farbtonhilfsbezeichnung": "04.021.01",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 83.4752960205078,
    "L": 93.2221298217773,
    "a": 0.46048274636269,
    "b": 0.61837369203568,
    "C": 0.77099311351776,
    "h": 53.3261451721191,
    "CMY_C": 0.07059401273727,
    "CMY_M": 0.07706552743912,
    "CMY_Y": 0.08798068761826,
    "CMYK_C": 0,
    "CMYK_M": 0.00696306535974,
    "CMYK_Y": 0.01870729774237,
    "CMYK_K": 0.07059401273727
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0768",
    "Farbtonhilfsbezeichnung": "04.021.02",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "230",
    "Bcolor": "225",
    "Y": 79.4878387451172,
    "L": 91.4545669555664,
    "a": 0.18293146789074,
    "b": 2.15147113800049,
    "C": 2.15923404693604,
    "h": 85.1400451660156,
    "CMY_C": 0.08738881349564,
    "CMY_M": 0.09660285711288,
    "CMY_Y": 0.11897712945938,
    "CMYK_C": 0,
    "CMYK_M": 0.01009635161608,
    "CMYK_Y": 0.03461311385036,
    "CMYK_K": 0.08738881349564
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0769",
    "Farbtonhilfsbezeichnung": "04.021.03",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 82.3531799316406,
    "L": 92.7305145263672,
    "a": -0.01339054107666,
    "b": 1.32924211025238,
    "C": 1.32930958271027,
    "h": 90.5771636962891,
    "CMY_C": 0.07743322849274,
    "CMY_M": 0.08164274692535,
    "CMY_Y": 0.09878903627396,
    "CMYK_C": 0,
    "CMYK_M": 0.00456283334643,
    "CMYK_Y": 0.02314825169742,
    "CMYK_K": 0.07743322849274
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0770",
    "Farbtonhilfsbezeichnung": "04.021.04",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 82.6855239868164,
    "L": 92.8765869140625,
    "a": 2.69001412391663,
    "b": 2.05357384681702,
    "C": 3.3842785358429,
    "h": 37.3583450317383,
    "CMY_C": 0.05219811201096,
    "CMY_M": 0.08672600984573,
    "CMY_Y": 0.10217142105103,
    "CMYK_C": 0,
    "CMYK_M": 0.0364294461906,
    "CMYK_Y": 0.05272547900677,
    "CMYK_K": 0.05219811201096
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0771",
    "Farbtonhilfsbezeichnung": "04.021.05",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 83.9703903198242,
    "L": 93.4376373291016,
    "a": 1.68572843074799,
    "b": 2.55989789962769,
    "C": 3.06508684158325,
    "h": 56.6345405578613,
    "CMY_C": 0.05203241109848,
    "CMY_M": 0.07815361022949,
    "CMY_Y": 0.0998660326004,
    "CMYK_C": 0,
    "CMYK_M": 0.02755494974554,
    "CMYK_Y": 0.05045913159847,
    "CMYK_K": 0.05203241109848
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0772",
    "Farbtonhilfsbezeichnung": "04.021.06",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 82.4354019165039,
    "L": 92.7666931152344,
    "a": 5.73623752593994,
    "b": 4.41481876373291,
    "C": 7.23844242095947,
    "h": 37.5832023620605,
    "CMY_C": 0.02272760868073,
    "CMY_M": 0.09613031148911,
    "CMY_Y": 0.12048816680908,
    "CMYK_C": 0,
    "CMYK_M": 0.07510976493359,
    "CMYK_Y": 0.10003409534693,
    "CMYK_K": 0.02272760868073
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0773",
    "Farbtonhilfsbezeichnung": "04.022.01",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "232",
    "Bcolor": "221",
    "Y": 80.5761184692383,
    "L": 91.942741394043,
    "a": -0.40085089206696,
    "b": 4.57422590255737,
    "C": 4.59175586700439,
    "h": 95.0081787109375,
    "CMY_C": 0.0785323381424,
    "CMY_M": 0.0904375910759,
    "CMY_Y": 0.13165414333344,
    "CMYK_C": 0,
    "CMYK_M": 0.01291988138109,
    "CMYK_Y": 0.05764912441373,
    "CMYK_K": 0.0785323381424
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0774",
    "Farbtonhilfsbezeichnung": "04.022.02",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "216",
    "Y": 79.5226135253906,
    "L": 91.4702377319336,
    "a": 0.5962455868721,
    "b": 6.9589672088623,
    "C": 6.98446369171143,
    "h": 85.1028442382813,
    "CMY_C": 0.06858623027802,
    "CMY_M": 0.09873503446579,
    "CMY_Y": 0.15439760684967,
    "CMYK_C": 0,
    "CMYK_M": 0.03236886113882,
    "CMYK_Y": 0.09213024377823,
    "CMYK_K": 0.06858623027802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0775",
    "Farbtonhilfsbezeichnung": "04.022.03",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "240",
    "Bcolor": "223",
    "Y": 87.7515716552734,
    "L": 95.0562362670898,
    "a": 0.57174319028854,
    "b": 8.47078037261963,
    "C": 8.49005317687988,
    "h": 86.1386260986328,
    "CMY_C": 0.02367693185806,
    "CMY_M": 0.0589212179184,
    "CMY_Y": 0.12626147270203,
    "CMYK_C": 0,
    "CMYK_M": 0.03609899803996,
    "CMYK_Y": 0.10507233440876,
    "CMYK_K": 0.02367693185806
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0776",
    "Farbtonhilfsbezeichnung": "04.022.04",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "235",
    "Bcolor": "217",
    "Y": 83.6203308105469,
    "L": 93.2853469848633,
    "a": 0.61295890808105,
    "b": 9.151047706604,
    "C": 9.17155361175537,
    "h": 86.1679153442383,
    "CMY_C": 0.04134821891785,
    "CMY_M": 0.0790718793869,
    "CMY_Y": 0.15080797672272,
    "CMYK_C": 0,
    "CMYK_M": 0.03935074433684,
    "CMYK_Y": 0.1141809374094,
    "CMYK_K": 0.04134821891785
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0777",
    "Farbtonhilfsbezeichnung": "04.022.05",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "237",
    "Bcolor": "216",
    "Y": 85.4277114868164,
    "L": 94.0671157836914,
    "a": 1.26091599464417,
    "b": 10.6671028137207,
    "C": 10.7413682937622,
    "h": 83.2585754394531,
    "CMY_C": 0.02308917045593,
    "CMY_M": 0.07227194309235,
    "CMY_Y": 0.15345442295074,
    "CMYK_C": 0,
    "CMYK_M": 0.05034520104527,
    "CMYK_Y": 0.13344642519951,
    "CMYK_K": 0.02308917045593
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0778",
    "Farbtonhilfsbezeichnung": "04.022.06",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "229",
    "Bcolor": "211",
    "Y": 79.4510269165039,
    "L": 91.4379806518555,
    "a": 0.72648644447327,
    "b": 9.62221145629883,
    "C": 9.64959812164307,
    "h": 85.6823043823242,
    "CMY_C": 0.0599240064621,
    "CMY_M": 0.10010993480682,
    "CMY_Y": 0.17450171709061,
    "CMYK_C": 0,
    "CMYK_M": 0.04274753108621,
    "CMYK_Y": 0.12188132852316,
    "CMYK_K": 0.0599240064621
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0779",
    "Farbtonhilfsbezeichnung": "04.023.01",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "218",
    "Y": 86.4502258300781,
    "L": 94.5045166015625,
    "a": -0.21446107327938,
    "b": 10.3663606643677,
    "C": 10.3685789108276,
    "h": 91.1851806640625,
    "CMY_C": 0.03024274110794,
    "CMY_M": 0.06372994184494,
    "CMY_Y": 0.14663809537888,
    "CMYK_C": 0,
    "CMYK_M": 0.03453152999282,
    "CMYK_Y": 0.12002524733543,
    "CMYK_K": 0.03024274110794
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0780",
    "Farbtonhilfsbezeichnung": "04.023.02",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "238",
    "Bcolor": "219",
    "Y": 85.3164825439453,
    "L": 94.0193252563477,
    "a": -0.62400460243225,
    "b": 9.05987548828125,
    "C": 9.08133983612061,
    "h": 93.940055847168,
    "CMY_C": 0.04281395673752,
    "CMY_M": 0.0678568482399,
    "CMY_Y": 0.14226096868515,
    "CMYK_C": 0,
    "CMYK_M": 0.02616303414106,
    "CMYK_Y": 0.10389517247677,
    "CMYK_K": 0.04281395673752
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0781",
    "Farbtonhilfsbezeichnung": "04.023.03",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "238",
    "Bcolor": "216",
    "Y": 85.4544372558594,
    "L": 94.0785903930664,
    "a": -0.18810273706913,
    "b": 10.4115304946899,
    "C": 10.4132299423218,
    "h": 91.0350341796875,
    "CMY_C": 0.03472912311554,
    "CMY_M": 0.06858676671982,
    "CMY_Y": 0.15164488554001,
    "CMYK_C": 0,
    "CMYK_M": 0.03507579490542,
    "CMYK_Y": 0.12112223356962,
    "CMYK_K": 0.03472912311554
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0782",
    "Farbtonhilfsbezeichnung": "04.023.04",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "208",
    "Y": 81.7641830444336,
    "L": 92.4706726074219,
    "a": 0.06211510673165,
    "b": 12.6345090866089,
    "C": 12.6346616744995,
    "h": 89.7183151245117,
    "CMY_C": 0.04454934597015,
    "CMY_M": 0.08776205778122,
    "CMY_Y": 0.18576949834824,
    "CMYK_C": 0,
    "CMYK_M": 0.04522757232189,
    "CMYK_Y": 0.14780475199223,
    "CMYK_K": 0.04454934597015
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0783",
    "Farbtonhilfsbezeichnung": "04.023.05",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "238",
    "Bcolor": "213",
    "Y": 85.8312759399414,
    "L": 94.2401657104492,
    "a": -0.54008096456528,
    "b": 12.5910263061523,
    "C": 12.6026039123535,
    "h": 92.4561462402344,
    "CMY_C": 0.02919107675552,
    "CMY_M": 0.06648969650269,
    "CMY_Y": 0.16623663902283,
    "CMYK_C": 0,
    "CMYK_M": 0.03842014446855,
    "CMYK_Y": 0.14116635918617,
    "CMYK_K": 0.02919107675552
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0784",
    "Farbtonhilfsbezeichnung": "04.023.06",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "233",
    "Bcolor": "207",
    "Y": 81.6123886108398,
    "L": 92.4035110473633,
    "a": -1.36101746559143,
    "b": 12.9418258666992,
    "C": 13.0131940841675,
    "h": 96.0034027099609,
    "CMY_C": 0.05518239736557,
    "CMY_M": 0.08520323038101,
    "CMY_Y": 0.1890195608139,
    "CMYK_C": 0,
    "CMYK_M": 0.03177421167493,
    "CMYK_Y": 0.14165396988392,
    "CMYK_K": 0.05518239736557
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0785",
    "Farbtonhilfsbezeichnung": "04.024.01",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "237",
    "Bcolor": "228",
    "Y": 84.0171432495117,
    "L": 93.4579467773438,
    "a": -0.79596132040024,
    "b": 3.54151034355164,
    "C": 3.6298553943634,
    "h": 102.666854858398,
    "CMY_C": 0.06803494691849,
    "CMY_M": 0.07225358486176,
    "CMY_Y": 0.1073077917099,
    "CMYK_C": 0,
    "CMYK_M": 0.00452660536394,
    "CMYK_Y": 0.04213982447982,
    "CMYK_K": 0.06803494691849
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0786",
    "Farbtonhilfsbezeichnung": "04.024.02",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "233",
    "Bcolor": "226",
    "Y": 80.9609146118164,
    "L": 92.1142959594727,
    "a": -0.6707808971405,
    "b": 2.66154360771179,
    "C": 2.74476981163025,
    "h": 104.145500183105,
    "CMY_C": 0.08503174781799,
    "CMY_M": 0.08735024929047,
    "CMY_Y": 0.11559855937958,
    "CMYK_C": 0,
    "CMYK_M": 0.00253396923654,
    "CMYK_Y": 0.03340750932693,
    "CMYK_K": 0.08503174781799
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0787",
    "Farbtonhilfsbezeichnung": "04.024.03",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 75.7637557983398,
    "L": 89.7495422363281,
    "a": -0.61364209651947,
    "b": 2.06427001953125,
    "C": 2.15354752540588,
    "h": 106.555549621582,
    "CMY_C": 0.11294734477997,
    "CMY_M": 0.11368370056152,
    "CMY_Y": 0.13722538948059,
    "CMYK_C": 0,
    "CMYK_M": 0.00083011505194,
    "CMYK_Y": 0.02736933901906,
    "CMYK_K": 0.11294734477997
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0788",
    "Farbtonhilfsbezeichnung": "04.024.04",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "210",
    "Y": 75.2897644042969,
    "L": 89.5285491943359,
    "a": 0.68686324357986,
    "b": 7.06575202941895,
    "C": 7.09905862808228,
    "h": 84.4477081298828,
    "CMY_C": 0.08932858705521,
    "CMY_M": 0.12058585882187,
    "CMY_Y": 0.17639309167862,
    "CMYK_C": 0,
    "CMYK_M": 0.03432332724333,
    "CMYK_Y": 0.09560474008322,
    "CMYK_K": 0.08932858705521
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0789",
    "Farbtonhilfsbezeichnung": "04.024.05",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "224",
    "Bcolor": "214",
    "Y": 75.0760650634766,
    "L": 89.4286117553711,
    "a": 1.27085483074188,
    "b": 4.9867959022522,
    "C": 5.14618349075317,
    "h": 75.7028427124023,
    "CMY_C": 0.0924186706543,
    "CMY_M": 0.12252956628799,
    "CMY_Y": 0.16204792261124,
    "CMYK_C": 0,
    "CMYK_M": 0.03317707777023,
    "CMYK_Y": 0.07671957463026,
    "CMYK_K": 0.0924186706543
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0791",
    "Farbtonhilfsbezeichnung": "04.025.01",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "233",
    "Bcolor": "228",
    "Y": 81.2295379638672,
    "L": 92.2337341308594,
    "a": -0.66384798288345,
    "b": 1.39551198482513,
    "C": 1.54536330699921,
    "h": 115.440536499023,
    "CMY_C": 0.08792495727539,
    "CMY_M": 0.08567464351654,
    "CMY_Y": 0.10487532615662,
    "CMYK_C": 0.00246117403731,
    "CMYK_M": 0,
    "CMYK_Y": 0.0209998358041,
    "CMYK_K": 0.08567464351654
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0792",
    "Farbtonhilfsbezeichnung": "04.025.02",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "231",
    "Bcolor": "232",
    "Y": 78.7138214111328,
    "L": 91.1046524047852,
    "a": -2.55437827110291,
    "b": -2.07085418701172,
    "C": 3.28835606575012,
    "h": 219.031951904297,
    "CMY_C": 0.12803673744202,
    "CMY_M": 0.09286201000214,
    "CMY_Y": 0.09194070100784,
    "CMYK_C": 0.03975074738264,
    "CMYK_M": 0.00101459119469,
    "CMYK_Y": 0,
    "CMYK_K": 0.09194070100784
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0793",
    "Farbtonhilfsbezeichnung": "04.025.03",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "228",
    "Bcolor": "225",
    "Y": 77.1507720947266,
    "L": 90.3909683227539,
    "a": -0.99077665805817,
    "b": 0.53109139204025,
    "C": 1.12414252758026,
    "h": 151.807113647461,
    "CMY_C": 0.11403328180313,
    "CMY_M": 0.10522550344467,
    "CMY_Y": 0.11888366937637,
    "CMYK_C": 0.00984357297421,
    "CMYK_M": 0,
    "CMYK_Y": 0.0152643667534,
    "CMYK_K": 0.10522550344467
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0794",
    "Farbtonhilfsbezeichnung": "04.025.04",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "229",
    "Bcolor": "232",
    "Y": 76.8470306396484,
    "L": 90.2511596679688,
    "a": -1.88545346260071,
    "b": -3.81331658363342,
    "C": 4.25397682189941,
    "h": 243.690399169922,
    "CMY_C": 0.13848602771759,
    "CMY_M": 0.1034272313118,
    "CMY_Y": 0.08843690156937,
    "CMYK_C": 0.05490472912788,
    "CMYK_M": 0.01644464209676,
    "CMYK_Y": 0,
    "CMYK_K": 0.08843690156937
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0795",
    "Farbtonhilfsbezeichnung": "04.025.05",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "226",
    "Bcolor": "230",
    "Y": 75.266242980957,
    "L": 89.5175552368164,
    "a": -1.11203181743622,
    "b": -3.82559084892273,
    "C": 3.98393774032593,
    "h": 253.791778564453,
    "CMY_C": 0.14031934738159,
    "CMY_M": 0.11339461803436,
    "CMY_Y": 0.09638720750809,
    "CMYK_C": 0.04861832410097,
    "CMYK_M": 0.01882156915963,
    "CMYK_Y": 0,
    "CMYK_K": 0.09638720750809
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0796",
    "Farbtonhilfsbezeichnung": "04.025.06",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "232",
    "Bcolor": "232",
    "Y": 78.2012252807617,
    "L": 90.8716506958008,
    "a": -4.46187448501587,
    "b": -2.65306186676025,
    "C": 5.19105577468872,
    "h": 210.73600769043,
    "CMY_C": 0.14856171607971,
    "CMY_M": 0.09089666604996,
    "CMY_Y": 0.09046787023544,
    "CMYK_C": 0.06387223303318,
    "CMYK_M": 0.00047144657583,
    "CMYK_Y": 0,
    "CMYK_K": 0.09046787023544
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0797",
    "Farbtonhilfsbezeichnung": "04.026.01",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "213",
    "Y": 81.5036697387695,
    "L": 92.355354309082,
    "a": -0.63541513681412,
    "b": 9.73525810241699,
    "C": 9.75597286224365,
    "h": 93.7343673706055,
    "CMY_C": 0.05962055921555,
    "CMY_M": 0.08664602041245,
    "CMY_Y": 0.16553503274918,
    "CMYK_C": 0,
    "CMYK_M": 0.02873888984323,
    "CMYK_Y": 0.11262951046228,
    "CMYK_K": 0.05962055921555
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0798",
    "Farbtonhilfsbezeichnung": "04.026.02",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "237",
    "Bcolor": "214",
    "Y": 84.7443389892578,
    "L": 93.772834777832,
    "a": -0.92055314779282,
    "b": 11.28382396698,
    "C": 11.3213119506836,
    "h": 94.6639556884766,
    "CMY_C": 0.041199862957,
    "CMY_M": 0.07049286365509,
    "CMY_Y": 0.16162943840027,
    "CMYK_C": 0,
    "CMYK_M": 0.03055172786117,
    "CMYK_Y": 0.12560446560383,
    "CMYK_K": 0.041199862957
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0799",
    "Farbtonhilfsbezeichnung": "04.026.03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "237",
    "Bcolor": "218",
    "Y": 84.7659378051758,
    "L": 93.7821655273438,
    "a": -0.61899989843369,
    "b": 9.21312808990479,
    "C": 9.23389911651611,
    "h": 93.8437423706055,
    "CMY_C": 0.04498654603958,
    "CMY_M": 0.07057017087936,
    "CMY_Y": 0.14600944519043,
    "CMYK_C": 0,
    "CMYK_M": 0.02678875811398,
    "CMYK_Y": 0.10578165203333,
    "CMYK_K": 0.04498654603958
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0800",
    "Farbtonhilfsbezeichnung": "04.026.04",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "212",
    "Y": 82.9956207275391,
    "L": 93.0125198364258,
    "a": -1.01669061183929,
    "b": 10.898365020752,
    "C": 10.9456853866577,
    "h": 95.3296051025391,
    "CMY_C": 0.05166101455688,
    "CMY_M": 0.0786868929863,
    "CMY_Y": 0.16708028316498,
    "CMYK_C": 0,
    "CMYK_M": 0.02849812060595,
    "CMYK_Y": 0.12170676141977,
    "CMYK_K": 0.05166101455688
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0801",
    "Farbtonhilfsbezeichnung": "04.026.05",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "237",
    "Bcolor": "218",
    "Y": 83.8360061645508,
    "L": 93.3792266845703,
    "a": -2.38593363761902,
    "b": 8.64482498168945,
    "C": 8.96803665161133,
    "h": 105.429267883301,
    "CMY_C": 0.06495952606201,
    "CMY_M": 0.0707580447197,
    "CMY_Y": 0.14645874500275,
    "CMYK_C": 0,
    "CMYK_M": 0.00620135571808,
    "CMYK_Y": 0.08716116845608,
    "CMYK_K": 0.06495952606201
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0802",
    "Farbtonhilfsbezeichnung": "04.026.06",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "216",
    "Y": 82.9011917114258,
    "L": 92.9711608886719,
    "a": -1.60029554367065,
    "b": 8.92036819458008,
    "C": 9.06277656555176,
    "h": 100.170555114746,
    "CMY_C": 0.06259095668793,
    "CMY_M": 0.07725566625595,
    "CMY_Y": 0.15287083387375,
    "CMYK_C": 0,
    "CMYK_M": 0.0156438741833,
    "CMYK_Y": 0.09630788117647,
    "CMYK_K": 0.06259095668793
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0803",
    "Farbtonhilfsbezeichnung": "04.027.01",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "231",
    "Y": 83.6659317016602,
    "L": 93.3052139282227,
    "a": -0.75960403680801,
    "b": 1.67482101917267,
    "C": 1.83902788162231,
    "h": 114.396354675293,
    "CMY_C": 0.07574498653412,
    "CMY_M": 0.07352864742279,
    "CMY_Y": 0.09509247541428,
    "CMYK_C": 0.00239223707467,
    "CMYK_M": 0,
    "CMYK_Y": 0.02327522449195,
    "CMYK_K": 0.07352864742279
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0804",
    "Farbtonhilfsbezeichnung": "04.027.02",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 84.9846038818359,
    "L": 93.8764801025391,
    "a": -0.6329904794693,
    "b": 4.63587713241577,
    "C": 4.67889213562012,
    "h": 97.7751846313477,
    "CMY_C": 0.05844902992249,
    "CMY_M": 0.06824827194214,
    "CMY_Y": 0.11081296205521,
    "CMYK_C": 0,
    "CMYK_M": 0.01040755305439,
    "CMYK_Y": 0.05561454966664,
    "CMYK_K": 0.05844902992249
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0805",
    "Farbtonhilfsbezeichnung": "04.027.03",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "241",
    "Bcolor": "225",
    "Y": 87.3968276977539,
    "L": 94.906379699707,
    "a": -1.0838360786438,
    "b": 7.20834922790527,
    "C": 7.28937578201294,
    "h": 98.5508499145508,
    "CMY_C": 0.04211503267288,
    "CMY_M": 0.05630123615265,
    "CMY_Y": 0.11871778964996,
    "CMYK_C": 0,
    "CMYK_M": 0.01480992417783,
    "CMYK_Y": 0.0799707248807,
    "CMYK_K": 0.04211503267288
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0806",
    "Farbtonhilfsbezeichnung": "04.027.04",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "236",
    "Bcolor": "224",
    "Y": 83.5766754150391,
    "L": 93.2663269042969,
    "a": -1.30410695075989,
    "b": 5.07168102264404,
    "C": 5.23666334152222,
    "h": 104.420356750488,
    "CMY_C": 0.06915533542633,
    "CMY_M": 0.07361930608749,
    "CMY_Y": 0.12089866399765,
    "CMYK_C": 0,
    "CMYK_M": 0.00479561276734,
    "CMYK_Y": 0.05558750033379,
    "CMYK_K": 0.06915533542633
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0807",
    "Farbtonhilfsbezeichnung": "04.027.05",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 80.0606689453125,
    "L": 91.7120742797852,
    "a": -0.24217431247234,
    "b": 3.11581540107727,
    "C": 3.12521266937256,
    "h": 94.4443283081055,
    "CMY_C": 0.08464395999908,
    "CMY_M": 0.09298783540726,
    "CMY_Y": 0.12334811687469,
    "CMYK_C": 0,
    "CMYK_M": 0.00911544263363,
    "CMYK_Y": 0.0422831736505,
    "CMYK_K": 0.08464395999908
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0808",
    "Farbtonhilfsbezeichnung": "04.027.06",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "223",
    "Bcolor": "211",
    "Y": 73.8387298583984,
    "L": 88.8462066650391,
    "a": -0.09349574893713,
    "b": 5.29676723480225,
    "C": 5.29759216308594,
    "h": 91.0112533569336,
    "CMY_C": 0.10841298103333,
    "CMY_M": 0.12583023309708,
    "CMY_Y": 0.17089545726776,
    "CMYK_C": 0,
    "CMYK_M": 0.01953511126339,
    "CMYK_Y": 0.07008006423712,
    "CMYK_K": 0.10841298103333
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0809",
    "Farbtonhilfsbezeichnung": "04.028.01",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "232",
    "Bcolor": "229",
    "Y": 80.4110565185547,
    "L": 91.8689804077148,
    "a": -0.26890599727631,
    "b": 0.48335447907448,
    "C": 0.55312025547028,
    "h": 119.088623046875,
    "CMY_C": 0.09199035167694,
    "CMY_M": 0.09042823314667,
    "CMY_Y": 0.10208874940872,
    "CMYK_C": 0.0017174219247,
    "CMYK_M": 0,
    "CMYK_Y": 0.01281978655607,
    "CMYK_K": 0.09042823314667
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0810",
    "Farbtonhilfsbezeichnung": "04.028.02",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "226",
    "Y": 77.8471145629883,
    "L": 90.710090637207,
    "a": -0.396758466959,
    "b": 0.34855529665947,
    "C": 0.52811747789383,
    "h": 138.700439453125,
    "CMY_C": 0.10638982057571,
    "CMY_M": 0.10301822423935,
    "CMY_Y": 0.11392760276794,
    "CMYK_C": 0.00375882373191,
    "CMYK_M": 0,
    "CMYK_Y": 0.01216231938452,
    "CMYK_K": 0.10301822423935
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0811",
    "Farbtonhilfsbezeichnung": "04.028.03",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 72.1872253417969,
    "L": 88.0586318969727,
    "a": -0.36125925183296,
    "b": 0.28097650408745,
    "C": 0.45766368508339,
    "h": 142.125305175781,
    "CMY_C": 0.13576036691666,
    "CMY_M": 0.13253700733185,
    "CMY_Y": 0.14262843132019,
    "CMYK_C": 0.00371584668756,
    "CMYK_M": 0,
    "CMYK_Y": 0.01163326203823,
    "CMYK_K": 0.13253700733185
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0812",
    "Farbtonhilfsbezeichnung": "04.028.04",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "232",
    "Y": 83.4926223754883,
    "L": 93.2296905517578,
    "a": -0.36299353837967,
    "b": 0.89857631921768,
    "C": 0.96912521123886,
    "h": 111.996994018555,
    "CMY_C": 0.07609337568283,
    "CMY_M": 0.07509648799896,
    "CMY_Y": 0.09009689092636,
    "CMYK_C": 0.00107782881241,
    "CMYK_M": 0,
    "CMYK_Y": 0.01621834374964,
    "CMYK_K": 0.07509648799896
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0813",
    "Farbtonhilfsbezeichnung": "04.028.05",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 84.7301940917969,
    "L": 93.766731262207,
    "a": -1.64632976055145,
    "b": 1.65838134288788,
    "C": 2.33679914474487,
    "h": 134.791046142578,
    "CMY_C": 0.07771819829941,
    "CMY_M": 0.06624776124954,
    "CMY_Y": 0.08997255563736,
    "CMYK_C": 0.0122842406854,
    "CMYK_M": 0,
    "CMYK_Y": 0.0254080183804,
    "CMYK_K": 0.06624776124954
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0814",
    "Farbtonhilfsbezeichnung": "04.028.06",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "225",
    "Bcolor": "217",
    "Y": 74.6101760864258,
    "L": 89.210075378418,
    "a": -1.75031435489655,
    "b": 3.01288962364197,
    "C": 3.48440861701965,
    "h": 120.154106140137,
    "CMY_C": 0.12471264600754,
    "CMY_M": 0.11727827787399,
    "CMY_Y": 0.15030896663666,
    "CMYK_C": 0.00842209719121,
    "CMYK_M": 0,
    "CMYK_Y": 0.0374191403389,
    "CMYK_K": 0.11727827787399
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0815",
    "Farbtonhilfsbezeichnung": "04.029.01",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "87",
    "Bcolor": "77",
    "Y": 9.67343044281006,
    "L": 37.2498207092285,
    "a": 0.63887059688568,
    "b": 6.36783742904663,
    "C": 6.39980554580688,
    "h": 84.2708206176758,
    "CMY_C": 0.63557708263397,
    "CMY_M": 0.65880155563354,
    "CMY_Y": 0.69876575469971,
    "CMYK_C": 0,
    "CMYK_M": 0.06372945010662,
    "CMYK_Y": 0.17339380085468,
    "CMYK_K": 0.63557708263397
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0816",
    "Farbtonhilfsbezeichnung": "04.029.02",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "72",
    "Bcolor": "62",
    "Y": 6.58354520797729,
    "L": 30.839391708374,
    "a": 0.52131867408752,
    "b": 6.47308969497681,
    "C": 6.49404811859131,
    "h": 85.3955459594727,
    "CMY_C": 0.69600856304169,
    "CMY_M": 0.71759235858917,
    "CMY_Y": 0.7568171620369,
    "CMYK_C": 0,
    "CMYK_M": 0.07100132852793,
    "CMYK_Y": 0.20003391802311,
    "CMYK_K": 0.69600856304169
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0817",
    "Farbtonhilfsbezeichnung": "04.029.03",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "65",
    "Bcolor": "58",
    "Y": 5.34859800338745,
    "L": 27.7056884765625,
    "a": 0.10027153044939,
    "b": 4.38837957382202,
    "C": 4.38952493667603,
    "h": 88.6910552978516,
    "CMY_C": 0.73178625106812,
    "CMY_M": 0.74449783563614,
    "CMY_Y": 0.77177888154984,
    "CMYK_C": 0,
    "CMYK_M": 0.04739348590374,
    "CMYK_Y": 0.14910730719566,
    "CMYK_K": 0.73178625106812
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0818",
    "Farbtonhilfsbezeichnung": "04.029.04",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "71",
    "Bcolor": "63",
    "Y": 6.27276754379272,
    "L": 30.0904598236084,
    "a": -1.18429493904114,
    "b": 4.50784730911255,
    "C": 4.66082000732422,
    "h": 104.720016479492,
    "CMY_C": 0.71785056591034,
    "CMY_M": 0.7206871509552,
    "CMY_Y": 0.75177162885666,
    "CMYK_C": 0,
    "CMYK_M": 0.01005348470062,
    "CMYK_Y": 0.12022375315428,
    "CMYK_K": 0.71785056591034
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0819",
    "Farbtonhilfsbezeichnung": "04.029.05",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "63",
    "Bcolor": "54",
    "Y": 4.91615915298462,
    "L": 26.494556427002,
    "a": -0.60164386034012,
    "b": 5.11808347702026,
    "C": 5.15332460403442,
    "h": 96.7044982910156,
    "CMY_C": 0.74518394470215,
    "CMY_M": 0.75407016277313,
    "CMY_Y": 0.78666377067566,
    "CMYK_C": 0,
    "CMYK_M": 0.03487306833267,
    "CMYK_Y": 0.16278341412544,
    "CMYK_K": 0.74518394470215
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0820",
    "Farbtonhilfsbezeichnung": "04.029.06",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "70",
    "Bcolor": "64",
    "Y": 5.95611238479614,
    "L": 29.3014678955078,
    "a": -1.60541713237762,
    "b": 2.76650071144104,
    "C": 3.19857621192932,
    "h": 120.126853942871,
    "CMY_C": 0.73203766345978,
    "CMY_M": 0.72665083408356,
    "CMY_Y": 0.74833393096924,
    "CMYK_C": 0.0197067707777,
    "CMYK_M": 0,
    "CMYK_Y": 0.07932380586863,
    "CMYK_K": 0.72665083408356
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0821",
    "Farbtonhilfsbezeichnung": "04.030.01",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "90",
    "Bcolor": "70",
    "Y": 9.77693843841553,
    "L": 37.439079284668,
    "a": -4.65650510787964,
    "b": 10.9794387817383,
    "C": 11.9260683059692,
    "h": 112.982353210449,
    "CMY_C": 0.65676546096802,
    "CMY_M": 0.6476343870163,
    "CMY_Y": 0.72672736644745,
    "CMYK_C": 0.02591363526881,
    "CMYK_M": 0,
    "CMYK_Y": 0.22446282207966,
    "CMYK_K": 0.6476343870163
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0822",
    "Farbtonhilfsbezeichnung": "04.030.02",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "78",
    "Bcolor": "63",
    "Y": 7.01548290252686,
    "L": 31.842134475708,
    "a": -6.4716420173645,
    "b": 7.22232294082642,
    "C": 9.69763374328613,
    "h": 131.862274169922,
    "CMY_C": 0.7293713092804,
    "CMY_M": 0.6956661939621,
    "CMY_Y": 0.75346195697784,
    "CMYK_C": 0.11075048148632,
    "CMYK_M": 0,
    "CMYK_Y": 0.18990911543369,
    "CMYK_K": 0.6956661939621
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0823",
    "Farbtonhilfsbezeichnung": "04.030.03",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "65",
    "Bcolor": "53",
    "Y": 5.03250741958618,
    "L": 26.8271808624268,
    "a": -4.68234062194824,
    "b": 6.16806745529175,
    "C": 7.74398946762085,
    "h": 127.203079223633,
    "CMY_C": 0.76502722501755,
    "CMY_M": 0.74396753311157,
    "CMY_Y": 0.79053461551666,
    "CMYK_C": 0.08225399255753,
    "CMYK_M": 0,
    "CMYK_Y": 0.18187959492207,
    "CMYK_K": 0.74396753311157
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0824",
    "Farbtonhilfsbezeichnung": "04.030.04",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "64",
    "Bcolor": "54",
    "Y": 4.62152719497681,
    "L": 25.6280918121338,
    "a": -6.83989572525024,
    "b": 4.28980398178101,
    "C": 8.07382106781006,
    "h": 147.905136108398,
    "CMY_C": 0.79472374916077,
    "CMY_M": 0.75064218044281,
    "CMY_Y": 0.78997874259949,
    "CMYK_C": 0.17678037285805,
    "CMYK_M": 0,
    "CMYK_Y": 0.15775147080421,
    "CMYK_K": 0.75064218044281
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0825",
    "Farbtonhilfsbezeichnung": "04.030.05",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "62",
    "Bcolor": "56",
    "Y": 4.44496488571167,
    "L": 25.0910682678223,
    "a": -6.52076435089111,
    "b": 2.11467313766479,
    "C": 6.85508632659912,
    "h": 162.032211303711,
    "CMY_C": 0.80360978841782,
    "CMY_M": 0.75550591945648,
    "CMY_Y": 0.78179264068604,
    "CMYK_C": 0.19674859941006,
    "CMYK_M": 0,
    "CMYK_Y": 0.10751475393772,
    "CMYK_K": 0.75550591945648
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0826",
    "Farbtonhilfsbezeichnung": "04.030.06",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "55",
    "Bcolor": "55",
    "Y": 3.52163457870483,
    "L": 22.0223941802979,
    "a": -4.45223188400269,
    "b": -1.67720830440521,
    "C": 4.75766706466675,
    "h": 200.641983032227,
    "CMY_C": 0.82755088806152,
    "CMY_M": 0.78501969575882,
    "CMY_Y": 0.78605955839157,
    "CMYK_C": 0.19783762097359,
    "CMYK_M": 0,
    "CMYK_Y": 0.00483701331541,
    "CMYK_K": 0.78501969575882
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0827",
    "Farbtonhilfsbezeichnung": "04.031.01",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "93",
    "Bcolor": "79",
    "Y": 9.39024066925049,
    "L": 36.7250366210938,
    "a": -14.8516836166382,
    "b": 4.14856815338135,
    "C": 15.4202184677124,
    "h": 164.393188476563,
    "CMY_C": 0.75848174095154,
    "CMY_M": 0.63547778129578,
    "CMY_Y": 0.69159162044525,
    "CMYK_C": 0.33743885159492,
    "CMYK_M": 0,
    "CMYK_Y": 0.15393805503845,
    "CMYK_K": 0.63547778129578
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0828",
    "Farbtonhilfsbezeichnung": "04.031.02",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "74",
    "Bcolor": "61",
    "Y": 5.59777450561523,
    "L": 28.3741207122803,
    "a": -16.3470935821533,
    "b": 3.42668652534485,
    "C": 16.7023849487305,
    "h": 168.161041259766,
    "CMY_C": 0.85089981555939,
    "CMY_M": 0.71114063262939,
    "CMY_Y": 0.76206934452057,
    "CMYK_C": 0.48383122682571,
    "CMYK_M": 0,
    "CMYK_Y": 0.17630970478058,
    "CMYK_K": 0.71114063262939
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0829",
    "Farbtonhilfsbezeichnung": "04.031.03",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "73",
    "Bcolor": "82",
    "Y": 5.3626651763916,
    "L": 27.7439746856689,
    "a": -16.6623039245606,
    "b": -11.28626537323,
    "C": 20.1249141693115,
    "h": 214.111877441406,
    "CMY_C": 1,
    "CMY_M": 0.71314352750778,
    "CMY_Y": 0.67983150482178,
    "CMYK_C": 1,
    "CMYK_M": 0.10404528677464,
    "CMYK_Y": 0,
    "CMYK_K": 0.67983150482178
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0830",
    "Farbtonhilfsbezeichnung": "04.031.04",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "76",
    "Bcolor": "74",
    "Y": 5.88396406173706,
    "L": 29.1178092956543,
    "a": -15.627326965332,
    "b": -4.29840755462646,
    "C": 16.2077026367188,
    "h": 195.379302978516,
    "CMY_C": 0.8813328742981,
    "CMY_M": 0.70372021198273,
    "CMY_Y": 0.70905470848083,
    "CMYK_C": 0.59947615861893,
    "CMYK_M": 0,
    "CMYK_Y": 0.01800492964685,
    "CMYK_K": 0.70372021198273
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0831",
    "Farbtonhilfsbezeichnung": "04.031.05",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "70",
    "Bcolor": "67",
    "Y": 5.68270921707153,
    "L": 28.5974273681641,
    "a": -5.32226848602295,
    "b": -0.26595661044121,
    "C": 5.32890939712524,
    "h": 182.860717773438,
    "CMY_C": 0.77224940061569,
    "CMY_M": 0.72566568851471,
    "CMY_Y": 0.73687255382538,
    "CMYK_C": 0.16980636119843,
    "CMYK_M": 0,
    "CMYK_Y": 0.040851123631,
    "CMYK_K": 0.72566568851471
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0832",
    "Farbtonhilfsbezeichnung": "04.031.06",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "61",
    "Bcolor": "59",
    "Y": 4.21432781219482,
    "L": 24.3677101135254,
    "a": -7.01546621322632,
    "b": -0.93074917793274,
    "C": 7.07693862915039,
    "h": 187.557357788086,
    "CMY_C": 0.82369059324265,
    "CMY_M": 0.76046109199524,
    "CMY_Y": 0.77033293247223,
    "CMYK_C": 0.26396337151527,
    "CMYK_M": 0,
    "CMYK_Y": 0.04121184721589,
    "CMYK_K": 0.76046109199524
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0833",
    "Farbtonhilfsbezeichnung": "04.032.01",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "60",
    "Bcolor": "73",
    "Y": 5.42019462585449,
    "L": 27.8998432159424,
    "a": 11.876106262207,
    "b": -4.61923980712891,
    "C": 12.7428131103516,
    "h": 338.746337890625,
    "CMY_C": 0.68300104141235,
    "CMY_M": 0.76577347517014,
    "CMY_Y": 0.71547031402588,
    "CMYK_C": 0,
    "CMYK_M": 0.26111263036728,
    "CMYK_Y": 0.10242706537247,
    "CMYK_K": 0.68300104141235
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0834",
    "Farbtonhilfsbezeichnung": "04.032.02",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "54",
    "Bcolor": "63",
    "Y": 4.3014178276062,
    "L": 24.6438846588135,
    "a": 9.53348636627197,
    "b": -3.40461492538452,
    "C": 10.12317943573,
    "h": 340.347259521484,
    "CMY_C": 0.72319424152374,
    "CMY_M": 0.78919249773026,
    "CMY_Y": 0.75185376405716,
    "CMYK_C": 0,
    "CMYK_M": 0.23842804133892,
    "CMYK_Y": 0.10353658348322,
    "CMYK_K": 0.72319424152374
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0835",
    "Farbtonhilfsbezeichnung": "04.032.03",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "47",
    "Bcolor": "58",
    "Y": 3.55610060691833,
    "L": 22.1460304260254,
    "a": 10.8925800323486,
    "b": -3.43493247032166,
    "C": 11.4213418960571,
    "h": 342.497528076172,
    "CMY_C": 0.73847001791,
    "CMY_M": 0.81385380029678,
    "CMY_Y": 0.77338647842407,
    "CMYK_C": 0,
    "CMYK_M": 0.28824144601822,
    "CMYK_Y": 0.1335084438324,
    "CMYK_K": 0.73847001791
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0836",
    "Farbtonhilfsbezeichnung": "04.032.04",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "55",
    "Bcolor": "52",
    "Y": 4.21810102462769,
    "L": 24.379753112793,
    "a": 4.61942481994629,
    "b": 3.81960558891296,
    "C": 5.99403619766235,
    "h": 39.5858955383301,
    "CMY_C": 0.73684966564178,
    "CMY_M": 0.78258407115936,
    "CMY_Y": 0.79652893543243,
    "CMYK_C": 0,
    "CMYK_M": 0.17379572987556,
    "CMYK_Y": 0.22678774595261,
    "CMYK_K": 0.73684966564178
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0837",
    "Farbtonhilfsbezeichnung": "04.032.05",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "56",
    "Bcolor": "53",
    "Y": 4.23718118667603,
    "L": 24.440544128418,
    "a": 3.26122188568115,
    "b": 3.46130132675171,
    "C": 4.75564670562744,
    "h": 46.7047653198242,
    "CMY_C": 0.74466651678085,
    "CMY_M": 0.77922374010086,
    "CMY_Y": 0.79410141706467,
    "CMYK_C": 0,
    "CMYK_M": 0.13534152507782,
    "CMYK_Y": 0.19360916316509,
    "CMYK_K": 0.74466651678085
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0838",
    "Farbtonhilfsbezeichnung": "04.032.06",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "48",
    "Bcolor": "48",
    "Y": 2.988853931427,
    "L": 19.9992027282715,
    "a": 1.14141178131104,
    "b": 0.03420888632536,
    "C": 1.14192426204681,
    "h": 1.71667957305908,
    "CMY_C": 0.80370074510574,
    "CMY_M": 0.81255400180817,
    "CMY_Y": 0.81244075298309,
    "CMYK_C": 0,
    "CMYK_M": 0.0451008155942,
    "CMYK_Y": 0.04452389851213,
    "CMYK_K": 0.80370074510574
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0839",
    "Farbtonhilfsbezeichnung": "04.033.01",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "92",
    "Bcolor": "97",
    "Y": 11,
    "L": 38.8396453857422,
    "a": -0.15432666242123,
    "b": -4.12626552581787,
    "C": 4.129150390625,
    "h": 267.858062744141,
    "CMY_C": 0.65535879135132,
    "CMY_M": 0.63978147506714,
    "CMY_Y": 0.61854684352875,
    "CMYK_C": 0.09650450199842,
    "CMYK_M": 0.05566773191094,
    "CMYK_Y": 0,
    "CMYK_K": 0.61854684352875
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0840",
    "Farbtonhilfsbezeichnung": "04.033.02",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "80",
    "Bcolor": "85",
    "Y": 7.96003770828247,
    "L": 33.8995208740234,
    "a": -0.28918591141701,
    "b": -3.79349613189697,
    "C": 3.8045027256012,
    "h": 265.640655517578,
    "CMY_C": 0.70099329948425,
    "CMY_M": 0.68569827079773,
    "CMY_Y": 0.66690397262573,
    "CMYK_C": 0.10234083980322,
    "CMYK_M": 0.05642306432128,
    "CMYK_Y": 0,
    "CMYK_K": 0.66690397262573
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0841",
    "Farbtonhilfsbezeichnung": "04.033.03",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "58",
    "Bcolor": "72",
    "Y": 4.04332637786865,
    "L": 23.8141613006592,
    "a": -0.80335986614227,
    "b": -10.6515951156616,
    "C": 10.6818475723267,
    "h": 265.686828613281,
    "CMY_C": 0.82079041004181,
    "CMY_M": 0.77342641353607,
    "CMY_Y": 0.71819990873337,
    "CMYK_C": 0.36405417323112,
    "CMYK_M": 0.19597759842873,
    "CMYK_Y": 0,
    "CMYK_K": 0.71819990873337
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0842",
    "Farbtonhilfsbezeichnung": "04.033.04",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "64",
    "Bcolor": "63",
    "Y": 5.29559659957886,
    "L": 27.5608463287354,
    "a": 2.69300317764282,
    "b": 1.00750422477722,
    "C": 2.8752965927124,
    "h": 20.5117893218994,
    "CMY_C": 0.72560477256775,
    "CMY_M": 0.75011599063873,
    "CMY_Y": 0.75272035598755,
    "CMYK_C": 0,
    "CMYK_M": 0.08932814747095,
    "CMYK_Y": 0.09881944209337,
    "CMYK_K": 0.72560477256775
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0843",
    "Farbtonhilfsbezeichnung": "04.033.05",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "62",
    "Bcolor": "63",
    "Y": 4.70186471939087,
    "L": 25.8679161071777,
    "a": -0.68020296096802,
    "b": -1.77359795570374,
    "C": 1.89955937862396,
    "h": 249.017395019531,
    "CMY_C": 0.76926410198212,
    "CMY_M": 0.75796914100647,
    "CMY_Y": 0.75164401531219,
    "CMYK_C": 0.07094689458609,
    "CMYK_M": 0.02546798251569,
    "CMYK_Y": 0,
    "CMYK_K": 0.75164401531219
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0844",
    "Farbtonhilfsbezeichnung": "04.033.06",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "52",
    "Bcolor": "53",
    "Y": 3.42500805854797,
    "L": 21.6714096069336,
    "a": -0.45047327876091,
    "b": -0.99971002340317,
    "C": 1.09651553630829,
    "h": 245.74348449707,
    "CMY_C": 0.80186897516251,
    "CMY_M": 0.79513335227966,
    "CMY_Y": 0.79254591464996,
    "CMYK_C": 0.04494035616517,
    "CMYK_M": 0.01247233897448,
    "CMYK_Y": 0,
    "CMYK_K": 0.79254591464996
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0845",
    "Farbtonhilfsbezeichnung": "04.034.01",
    "Farbtonklasse": "02",
    "Rcolor": "99",
    "Gcolor": "111",
    "Bcolor": "116",
    "Y": 15.3299465179443,
    "L": 46.0828323364258,
    "a": -3.13921356201172,
    "b": -4.89536333084106,
    "C": 5.81543159484863,
    "h": 237.329467773438,
    "CMY_C": 0.6111661195755,
    "CMY_M": 0.56409060955048,
    "CMY_Y": 0.54421067237854,
    "CMYK_C": 0.14689998328686,
    "CMYK_M": 0.0436165034771,
    "CMYK_Y": 0,
    "CMYK_K": 0.54421067237854
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0846",
    "Farbtonhilfsbezeichnung": "04.034.02",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "102",
    "Bcolor": "103",
    "Y": 12.9217624664307,
    "L": 42.6451225280762,
    "a": -1.73888862133026,
    "b": -2.07157850265503,
    "C": 2.70465731620789,
    "h": 229.989807128906,
    "CMY_C": 0.62383240461349,
    "CMY_M": 0.60090851783752,
    "CMY_Y": 0.59545338153839,
    "CMYK_C": 0.0701501891017,
    "CMYK_M": 0.01348456740379,
    "CMYK_Y": 0,
    "CMYK_K": 0.59545338153839
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0847",
    "Farbtonhilfsbezeichnung": "04.034.03",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "93",
    "Bcolor": "96",
    "Y": 10.62486743927,
    "L": 38.9413299560547,
    "a": -1.54243242740631,
    "b": -3.16813659667969,
    "C": 3.5236611366272,
    "h": 244.040496826172,
    "CMY_C": 0.66102802753448,
    "CMY_M": 0.63632750511169,
    "CMY_Y": 0.62373739480972,
    "CMYK_C": 0.09910799562931,
    "CMYK_M": 0.03346096724272,
    "CMYK_Y": 0,
    "CMYK_K": 0.62373739480972
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0848",
    "Farbtonhilfsbezeichnung": "04.034.04",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "74",
    "Bcolor": "78",
    "Y": 6.61758279800415,
    "L": 30.9199771881104,
    "a": -1.47028505802155,
    "b": -3.57331085205078,
    "C": 3.86397314071655,
    "h": 247.634658813477,
    "CMY_C": 0.73547303676605,
    "CMY_M": 0.71078217029572,
    "CMY_Y": 0.69573551416397,
    "CMYK_C": 0.13060191273689,
    "CMYK_M": 0.04945255443454,
    "CMYK_Y": 0,
    "CMYK_K": 0.69573551416397
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0849",
    "Farbtonhilfsbezeichnung": "04.034.05",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "68",
    "Bcolor": "77",
    "Y": 5.43474245071411,
    "L": 27.9390830993652,
    "a": -2.69199800491333,
    "b": -7.47570705413818,
    "C": 7.94563102722168,
    "h": 250.196075439453,
    "CMY_C": 0.78534746170044,
    "CMY_M": 0.73444128036499,
    "CMY_Y": 0.6996505856514,
    "CMYK_C": 0.28532391786575,
    "CMYK_M": 0.11583407223225,
    "CMYK_Y": 0,
    "CMYK_K": 0.6996505856514
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0850",
    "Farbtonhilfsbezeichnung": "04.034.06",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "52",
    "Bcolor": "62",
    "Y": 3.33367967605591,
    "L": 21.3335475921631,
    "a": 0.49464017152786,
    "b": -7.82328081130981,
    "C": 7.83890247344971,
    "h": 273.617797851563,
    "CMY_C": 0.8208857178688,
    "CMY_M": 0.79803484678268,
    "CMY_Y": 0.75648868083954,
    "CMYK_C": 0.26445192098618,
    "CMYK_M": 0.17061287164688,
    "CMYK_Y": 0,
    "CMYK_K": 0.75648868083954
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0851",
    "Farbtonhilfsbezeichnung": "04.035.01",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "116",
    "Bcolor": "113",
    "Y": 17.1024780273438,
    "L": 48.3889045715332,
    "a": -1.50901913642883,
    "b": 0.41281715035439,
    "C": 1.56446695327759,
    "h": 164.700134277344,
    "CMY_C": 0.55884873867035,
    "CMY_M": 0.54615306854248,
    "CMY_Y": 0.55600225925446,
    "CMYK_C": 0.02797346189618,
    "CMYK_M": 0,
    "CMYK_Y": 0.02170156873763,
    "CMYK_K": 0.54615306854248
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0852",
    "Farbtonhilfsbezeichnung": "04.035.02",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "90",
    "Bcolor": "89",
    "Y": 9.99849700927734,
    "L": 37.8397331237793,
    "a": -1.35598087310791,
    "b": -0.33765509724617,
    "C": 1.39738869667053,
    "h": 193.982940673828,
    "CMY_C": 0.66097730398178,
    "CMY_M": 0.64778500795364,
    "CMY_Y": 0.65175974369049,
    "CMYK_C": 0.03745523840189,
    "CMYK_M": 0,
    "CMYK_Y": 0.01128497067839,
    "CMYK_K": 0.64778500795364
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0853",
    "Farbtonhilfsbezeichnung": "04.035.03",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "66",
    "Bcolor": "72",
    "Y": 5.1474347114563,
    "L": 27.1507415771484,
    "a": -3.87836265563965,
    "b": -5.92503881454468,
    "C": 7.08151006698608,
    "h": 236.792373657227,
    "CMY_C": 0.79501271247864,
    "CMY_M": 0.73980921506882,
    "CMY_Y": 0.71609139442444,
    "CMYK_C": 0.27798143029213,
    "CMYK_M": 0.08354033529758,
    "CMYK_Y": 0,
    "CMYK_K": 0.71609139442444
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0854",
    "Farbtonhilfsbezeichnung": "04.035.04",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "75",
    "Bcolor": "78",
    "Y": 6.75178623199463,
    "L": 31.2350330352783,
    "a": -3.24084639549255,
    "b": -3.34486365318298,
    "C": 4.65738105773926,
    "h": 225.904876708984,
    "CMY_C": 0.74439752101898,
    "CMY_M": 0.70469808578491,
    "CMY_Y": 0.69442021846771,
    "CMYK_C": 0.16354911029339,
    "CMYK_M": 0.03363398835063,
    "CMYK_Y": 0,
    "CMYK_K": 0.69442021846771
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0855",
    "Farbtonhilfsbezeichnung": "04.035.05",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "65",
    "Bcolor": "67",
    "Y": 4.99091243743896,
    "L": 26.7088584899902,
    "a": -3.77309632301331,
    "b": -3.33696961402893,
    "C": 5.037024974823,
    "h": 221.48991394043,
    "CMY_C": 0.78824359178543,
    "CMY_M": 0.74458158016205,
    "CMY_Y": 0.73531913757324,
    "CMYK_C": 0.19995573163033,
    "CMYK_M": 0.03499475866556,
    "CMYK_Y": 0,
    "CMYK_K": 0.73531913757324
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0856",
    "Farbtonhilfsbezeichnung": "04.035.06",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "53",
    "Bcolor": "55",
    "Y": 3.34441733360291,
    "L": 21.3735885620117,
    "a": -3.3571515083313,
    "b": -3.13725447654724,
    "C": 4.59487009048462,
    "h": 223.060729980469,
    "CMY_C": 0.83037203550339,
    "CMY_M": 0.79212772846222,
    "CMY_Y": 0.78320002555847,
    "CMYK_C": 0.21758309006691,
    "CMYK_M": 0.04117944464087,
    "CMYK_Y": 0,
    "CMYK_K": 0.78320002555847
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0857",
    "Farbtonhilfsbezeichnung": "04.036.01",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "100",
    "Bcolor": "92",
    "Y": 12.3407516479492,
    "L": 41.7526435852051,
    "a": -2.82751560211182,
    "b": 3.44326043128967,
    "C": 4.45543336868286,
    "h": 129.391952514648,
    "CMY_C": 0.6230583190918,
    "CMY_M": 0.60864889621735,
    "CMY_Y": 0.63914310932159,
    "CMYK_C": 0.03681968152523,
    "CMYK_M": 0,
    "CMYK_Y": 0.07792034745216,
    "CMYK_K": 0.60864889621735
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0858",
    "Farbtonhilfsbezeichnung": "04.036.02",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "97",
    "Bcolor": "91",
    "Y": 11.5887832641602,
    "L": 40.5549468994141,
    "a": -2.33221006393433,
    "b": 2.01138114929199,
    "C": 3.079749584198,
    "h": 139.224349975586,
    "CMY_C": 0.63515168428421,
    "CMY_M": 0.62073105573654,
    "CMY_Y": 0.64123749732971,
    "CMYK_C": 0.03802217170596,
    "CMYK_M": 0,
    "CMYK_Y": 0.05406833812594,
    "CMYK_K": 0.62073105573654
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0859",
    "Farbtonhilfsbezeichnung": "04.036.03",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "84",
    "Bcolor": "78",
    "Y": 8.82400989532471,
    "L": 35.6432189941406,
    "a": 0.05721744522452,
    "b": 3.18115496635437,
    "C": 3.18166947364807,
    "h": 88.9695663452148,
    "CMY_C": 0.66223251819611,
    "CMY_M": 0.67191624641418,
    "CMY_Y": 0.69370079040527,
    "CMYK_C": 0,
    "CMYK_M": 0.02866980619729,
    "CMYK_Y": 0.09316548705101,
    "CMYK_K": 0.66223251819611
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0860",
    "Farbtonhilfsbezeichnung": "04.036.04",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 6.37215900421143,
    "L": 30.3326168060303,
    "a": 1.42427039146423,
    "b": 4.32933712005615,
    "C": 4.55759859085083,
    "h": 71.7897720336914,
    "CMY_C": 0.70007252693176,
    "CMY_M": 0.72351133823395,
    "CMY_Y": 0.74823236465454,
    "CMYK_C": 0,
    "CMYK_M": 0.07814826071262,
    "CMYK_Y": 0.16057160496712,
    "CMYK_K": 0.70007252693176
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0861",
    "Farbtonhilfsbezeichnung": "04.036.05",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "75",
    "Bcolor": "73",
    "Y": 6.91745662689209,
    "L": 31.6182537078857,
    "a": -1.11768925189972,
    "b": 0.2882953286171,
    "C": 1.15427184104919,
    "h": 165.536468505859,
    "CMY_C": 0.71479499340057,
    "CMY_M": 0.70602089166641,
    "CMY_Y": 0.71268004179001,
    "CMYK_C": 0.02984600514174,
    "CMYK_M": 0,
    "CMYK_Y": 0.0226517803967,
    "CMYK_K": 0.70602089166641
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0862",
    "Farbtonhilfsbezeichnung": "04.036.06",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "62",
    "Bcolor": "59",
    "Y": 4.61099529266357,
    "L": 25.5964450836182,
    "a": -2.20481538772583,
    "b": 0.39432004094124,
    "C": 2.23979902267456,
    "h": 169.860137939453,
    "CMY_C": 0.7752046585083,
    "CMY_M": 0.75808626413345,
    "CMY_Y": 0.76687455177307,
    "CMYK_C": 0.07076238840818,
    "CMYK_M": 0,
    "CMYK_Y": 0.03632818907499,
    "CMYK_K": 0.75808626413345
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0863",
    "Farbtonhilfsbezeichnung": "03.016.05",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "187",
    "Bcolor": "116",
    "Y": 54.6763114929199,
    "L": 78.8544540405273,
    "a": 9.14957618713379,
    "b": 41.8747406005859,
    "C": 42.8626708984375,
    "h": 77.6746520996094,
    "CMY_C": 0.07670879364014,
    "CMY_M": 0.26537185907364,
    "CMY_Y": 0.54508227109909,
    "CMYK_C": 0,
    "CMYK_M": 0.20433755218983,
    "CMYK_Y": 0.50728684663773,
    "CMYK_K": 0.07670879364014
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0916",
    "Farbtonhilfsbezeichnung": "04.013.03",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "181",
    "Bcolor": "171",
    "Y": 46.4507675170898,
    "L": 73.8370819091797,
    "a": -0.20390705764294,
    "b": 4.74757623672485,
    "C": 4.751953125,
    "h": 92.4593276977539,
    "CMY_C": 0.27493262290955,
    "CMY_M": 0.28878158330917,
    "CMY_Y": 0.32766020298004,
    "CMYK_C": 0,
    "CMYK_M": 0.0191002395004,
    "CMYK_Y": 0.07272093743086,
    "CMYK_K": 0.27493262290955
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0951",
    "Farbtonhilfsbezeichnung": "Kleines Schwarz",
    "Farbtonklasse": "02",
    "Rcolor": "43",
    "Gcolor": "43",
    "Bcolor": "43",
    "Y": 2.41258192062378,
    "L": 17.5185585021973,
    "a": -0.09473966807127,
    "b": -0.42489412426949,
    "C": 0.43532818555832,
    "h": 257.430236816406,
    "CMY_C": 0.83315169811249,
    "CMY_M": 0.83107596635818,
    "CMY_Y": 0.83074122667313,
    "CMYK_C": 0.01424133777618,
    "CMYK_M": 0.00197768001817,
    "CMYK_Y": 0,
    "CMYK_K": 0.83074122667313
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0952",
    "Farbtonhilfsbezeichnung": "Burgunderrot",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "46",
    "Bcolor": "51",
    "Y": 7.37989330291748,
    "L": 32.6565551757813,
    "a": 38.7956962585449,
    "b": 17.3465061187744,
    "C": 42.4971466064453,
    "h": 24.0905876159668,
    "CMY_C": 0.46872848272324,
    "CMY_M": 0.81979525089264,
    "CMY_Y": 0.79967439174652,
    "CMYK_C": 0,
    "CMYK_M": 0.6608048081398,
    "CMYK_Y": 0.62293177843094,
    "CMYK_K": 0.46872848272324
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0953",
    "Farbtonhilfsbezeichnung": "Lidschattenlila",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "166",
    "Bcolor": "209",
    "Y": 42.4779624938965,
    "L": 71.1992111206055,
    "a": 15.5913543701172,
    "b": -19.7650966644287,
    "C": 25.1743793487549,
    "h": 308.267547607422,
    "CMY_C": 0.26981043815613,
    "CMY_M": 0.34743219614029,
    "CMY_Y": 0.18098229169846,
    "CMYK_C": 0.10845693200827,
    "CMYK_M": 0.20323114097118,
    "CMYK_Y": 0,
    "CMYK_K": 0.18098229169846
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0954",
    "Farbtonhilfsbezeichnung": "Oleander-rosa",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "164",
    "Bcolor": "194",
    "Y": 43.4337844848633,
    "L": 71.8484039306641,
    "a": 20.7679328918457,
    "b": -10.1562366485596,
    "C": 23.1183090209961,
    "h": 333.939758300781,
    "CMY_C": 0.19267153739929,
    "CMY_M": 0.3578953742981,
    "CMY_Y": 0.24088299274445,
    "CMYK_C": 0,
    "CMYK_M": 0.20465503633022,
    "CMYK_Y": 0.05971727520227,
    "CMYK_K": 0.19267153739929
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0955",
    "Farbtonhilfsbezeichnung": "Brownie",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "80",
    "Bcolor": "79",
    "Y": 9.01405715942383,
    "L": 36.011344909668,
    "a": 8.91340732574463,
    "b": 3.19324588775635,
    "C": 9.46813869476318,
    "h": 19.7101631164551,
    "CMY_C": 0.60484671592712,
    "CMY_M": 0.68745183944702,
    "CMY_Y": 0.68927347660065,
    "CMYK_C": 0,
    "CMYK_M": 0.20904576778412,
    "CMYK_Y": 0.2136557251215,
    "CMYK_K": 0.60484671592712
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0956",
    "Farbtonhilfsbezeichnung": "Rosenquarz",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "171",
    "Bcolor": "182",
    "Y": 44.6433944702148,
    "L": 72.6564636230469,
    "a": 12.1869983673096,
    "b": -2.54313111305237,
    "C": 12.4495162963867,
    "h": 348.212921142578,
    "CMY_C": 0.22036945819855,
    "CMY_M": 0.32906723022461,
    "CMY_Y": 0.28689712285995,
    "CMYK_C": 0,
    "CMYK_M": 0.13942216336727,
    "CMYK_Y": 0.08533229678869,
    "CMYK_K": 0.22036945819855
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0957",
    "Farbtonhilfsbezeichnung": "Fliederzauber",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "195",
    "Bcolor": "222",
    "Y": 56.1230239868164,
    "L": 79.6837844848633,
    "a": 6.47393703460693,
    "b": -13.8667917251587,
    "C": 15.3035869598389,
    "h": 295.026275634766,
    "CMY_C": 0.22545295953751,
    "CMY_M": 0.23613965511322,
    "CMY_Y": 0.13097608089447,
    "CMYK_C": 0.10871608555317,
    "CMYK_M": 0.12101344019175,
    "CMYK_Y": 0,
    "CMYK_K": 0.13097608089447
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0958",
    "Farbtonhilfsbezeichnung": "Plueschgrau",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "150",
    "Bcolor": "148",
    "Y": 30.6472816467285,
    "L": 62.2087364196777,
    "a": 1.27796304225922,
    "b": 0.49514842033386,
    "C": 1.37053334712982,
    "h": 21.1789226531982,
    "CMY_C": 0.39953285455704,
    "CMY_M": 0.41295647621155,
    "CMY_Y": 0.41827005147934,
    "CMYK_C": 0,
    "CMYK_M": 0.02235529758036,
    "CMYK_Y": 0.03120436705649,
    "CMYK_K": 0.39953285455704
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0959",
    "Farbtonhilfsbezeichnung": "Satinweiß",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "231",
    "Y": 83.6659317016602,
    "L": 93.3052139282227,
    "a": -0.75960403680801,
    "b": 1.67482101917267,
    "C": 1.83902788162231,
    "h": 114.396354675293,
    "CMY_C": 0.07574498653412,
    "CMY_M": 0.07352864742279,
    "CMY_Y": 0.09509247541428,
    "CMYK_C": 0.00239223707467,
    "CMYK_M": 0,
    "CMYK_Y": 0.02327522449195,
    "CMYK_K": 0.07352864742279
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0960",
    "Farbtonhilfsbezeichnung": "Innocent Blue",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "228",
    "Bcolor": "236",
    "Y": 73.6898574829102,
    "L": 88.7756958007813,
    "a": -8.37771129608154,
    "b": -7.94962596893311,
    "C": 11.5491380691528,
    "h": 223.498107910156,
    "CMY_C": 0.22703242301941,
    "CMY_M": 0.10392880439758,
    "CMY_Y": 0.07513177394867,
    "CMYK_C": 0.16424031555653,
    "CMYK_M": 0.03113636001945,
    "CMYK_Y": 0,
    "CMYK_K": 0.07513177394867
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0961",
    "Farbtonhilfsbezeichnung": "Scirocco-blau",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "167",
    "Bcolor": "202",
    "Y": 34.6788101196289,
    "L": 65.4978332519531,
    "a": -11.2108793258667,
    "b": -24.8827896118164,
    "C": 27.2917022705078,
    "h": 245.746170043945,
    "CMY_C": 0.60264319181442,
    "CMY_M": 0.34492093324661,
    "CMY_Y": 0.20980328321457,
    "CMYK_C": 0.4971419274807,
    "CMYK_M": 0.17099241912365,
    "CMYK_Y": 0,
    "CMYK_K": 0.20980328321457
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0962",
    "Farbtonhilfsbezeichnung": "Kornblumenblau",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "86",
    "Bcolor": "142",
    "Y": 9.4099235534668,
    "L": 36.7618522644043,
    "a": 7.55841064453125,
    "b": -35.2697372436523,
    "C": 36.0705413818359,
    "h": 282.095703125,
    "CMY_C": 0.77988964319229,
    "CMY_M": 0.6639758348465,
    "CMY_Y": 0.44219076633453,
    "CMYK_C": 0.60540211200714,
    "CMYK_M": 0.39760020375252,
    "CMYK_Y": 0,
    "CMYK_K": 0.44219076633453
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0963",
    "Farbtonhilfsbezeichnung": "Rokoko-rosa",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "167",
    "Bcolor": "158",
    "Y": 45.2403144836426,
    "L": 73.0498504638672,
    "a": 18.0400638580322,
    "b": 11.2837066650391,
    "C": 21.2782974243164,
    "h": 32.0251731872559,
    "CMY_C": 0.14170813560486,
    "CMY_M": 0.34415817260742,
    "CMY_Y": 0.37931418418884,
    "CMYK_C": 0,
    "CMYK_M": 0.2358755171299,
    "CMYK_Y": 0.27683594822884,
    "CMYK_K": 0.14170813560486
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0964",
    "Farbtonhilfsbezeichnung": "Früchteteerose",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "137",
    "Bcolor": "145",
    "Y": 30.5956115722656,
    "L": 62.1647644042969,
    "a": 20.492826461792,
    "b": 2.69091296195984,
    "C": 20.6687431335449,
    "h": 7.48070907592773,
    "CMY_C": 0.26608508825302,
    "CMY_M": 0.46170824766159,
    "CMY_Y": 0.4310354590416,
    "CMYK_C": 0,
    "CMYK_M": 0.26654747128487,
    "CMYK_Y": 0.22475408017635,
    "CMYK_K": 0.26608508825302
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0965",
    "Farbtonhilfsbezeichnung": "Romantik-rosa",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "205",
    "Bcolor": "207",
    "Y": 65.0493545532227,
    "L": 84.509162902832,
    "a": 9.67637825012207,
    "b": 1.63408815860748,
    "C": 9.81338596343994,
    "h": 9.58532810211182,
    "CMY_C": 0.0950078368187,
    "CMY_M": 0.19645589590073,
    "CMY_Y": 0.18988007307053,
    "CMYK_C": 0,
    "CMYK_M": 0.11209827661514,
    "CMYK_Y": 0.10483210533857,
    "CMYK_K": 0.0950078368187
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0966",
    "Farbtonhilfsbezeichnung": "Wolkenblau",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "206",
    "Bcolor": "214",
    "Y": 60.5273361206055,
    "L": 82.1239852905273,
    "a": -2.08469271659851,
    "b": -6.20533657073975,
    "C": 6.54615497589111,
    "h": 251.430145263672,
    "CMY_C": 0.23820066452026,
    "CMY_M": 0.19194835424423,
    "CMY_Y": 0.16054946184158,
    "CMYK_C": 0.09250241518021,
    "CMYK_M": 0.03740410134196,
    "CMYK_Y": 0,
    "CMYK_K": 0.16054946184158
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0967",
    "Farbtonhilfsbezeichnung": "Avantgarde-blau",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "213",
    "Bcolor": "229",
    "Y": 65.135871887207,
    "L": 84.5537033081055,
    "a": -2.24438238143921,
    "b": -10.4475994110107,
    "C": 10.6859531402588,
    "h": 257.875823974609,
    "CMY_C": 0.23032146692276,
    "CMY_M": 0.1636489033699,
    "CMY_Y": 0.10297709703445,
    "CMYK_C": 0.14196334779263,
    "CMYK_M": 0.06763685494661,
    "CMYK_Y": 0,
    "CMYK_K": 0.10297709703445
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0968",
    "Farbtonhilfsbezeichnung": "Montreal-weiß",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "222",
    "Bcolor": "227",
    "Y": 72.1529159545898,
    "L": 88.0421447753906,
    "a": -1.64733374118805,
    "b": -4.23188257217407,
    "C": 4.54120445251465,
    "h": 248.730651855469,
    "CMY_C": 0.16248202323914,
    "CMY_M": 0.12840610742569,
    "CMY_Y": 0.10980433225632,
    "CMYK_C": 0.05917540565133,
    "CMYK_M": 0.0208962764591,
    "CMYK_Y": 0,
    "CMYK_K": 0.10980433225632
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0969",
    "Farbtonhilfsbezeichnung": "Pfirsichsorbet",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 82.4354019165039,
    "L": 92.7666931152344,
    "a": 5.73623752593994,
    "b": 4.41481876373291,
    "C": 7.23844242095947,
    "h": 37.5832023620605,
    "CMY_C": 0.02272760868073,
    "CMY_M": 0.09613031148911,
    "CMY_Y": 0.12048816680908,
    "CMYK_C": 0,
    "CMYK_M": 0.07510976493359,
    "CMYK_Y": 0.10003409534693,
    "CMYK_K": 0.02272760868073
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0970",
    "Farbtonhilfsbezeichnung": "Apricot Morning",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "161",
    "Bcolor": "119",
    "Y": 41.9005470275879,
    "L": 70.8022994995117,
    "a": 16.1349239349365,
    "b": 29.4948692321777,
    "C": 33.6196823120117,
    "h": 61.3194999694824,
    "CMY_C": 0.14511275291443,
    "CMY_M": 0.36674880981445,
    "CMY_Y": 0.5319699048996,
    "CMYK_C": 0,
    "CMYK_M": 0.2592576444149,
    "CMYK_Y": 0.45252418518066,
    "CMYK_K": 0.14511275291443
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0971",
    "Farbtonhilfsbezeichnung": "Sonnenblumengelb",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "95",
    "Y": 62.1492729187012,
    "L": 82.9927368164063,
    "a": 12.8304424285889,
    "b": 57.3880233764648,
    "C": 58.8048095703125,
    "h": 77.3974380493164,
    "CMY_C": 0,
    "CMY_M": 0.23268276453018,
    "CMY_Y": 0.62621808052063,
    "CMYK_C": 0,
    "CMYK_M": 0.23268276453018,
    "CMYK_Y": 0.62621808052063,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0972",
    "Farbtonhilfsbezeichnung": "Marisol",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "208",
    "Bcolor": "104",
    "Y": 67.1001586914063,
    "L": 85.5544967651367,
    "a": 4.81379365921021,
    "b": 56.2811241149902,
    "C": 56.4866142272949,
    "h": 85.1113204956055,
    "CMY_C": 0.00584721565247,
    "CMY_M": 0.18414920568466,
    "CMY_Y": 0.59342640638351,
    "CMYK_C": 0,
    "CMYK_M": 0.17935068905354,
    "CMYK_Y": 0.59103512763977,
    "CMYK_K": 0.00584721565247
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0973",
    "Farbtonhilfsbezeichnung": "Weizengras",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "199",
    "Bcolor": "105",
    "Y": 58.6637153625488,
    "L": 81.1063995361328,
    "a": 0.47125214338303,
    "b": 50.0835800170898,
    "C": 50.0857963562012,
    "h": 89.4608993530273,
    "CMY_C": 0.09433168172836,
    "CMY_M": 0.2210955619812,
    "CMY_Y": 0.58932459354401,
    "CMYK_C": 0,
    "CMYK_M": 0.13996721804142,
    "CMYK_Y": 0.54654985666275,
    "CMYK_K": 0.09433168172836
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0974",
    "Farbtonhilfsbezeichnung": "Cappucciono",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "128",
    "Bcolor": "102",
    "Y": 23.9934673309326,
    "L": 56.0812492370605,
    "a": 9.27344703674316,
    "b": 18.2649326324463,
    "C": 20.4842529296875,
    "h": 63.0822486877441,
    "CMY_C": 0.3684054017067,
    "CMY_M": 0.49793064594269,
    "CMY_Y": 0.59865522384644,
    "CMYK_C": 0,
    "CMYK_M": 0.20507656037807,
    "CMYK_Y": 0.36455318331718,
    "CMYK_K": 0.3684054017067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0975",
    "Farbtonhilfsbezeichnung": "Pistazie",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "183",
    "Y": 75.0034332275391,
    "L": 89.3945999145508,
    "a": -1.61879181861877,
    "b": 20.8785629272461,
    "C": 20.9412250518799,
    "h": 94.4334869384766,
    "CMY_C": 0.06970757246017,
    "CMY_M": 0.12000006437302,
    "CMY_Y": 0.28064602613449,
    "CMYK_C": 0,
    "CMYK_M": 0.05406095087528,
    "CMYK_Y": 0.22674424946308,
    "CMYK_K": 0.06970757246017
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0976",
    "Farbtonhilfsbezeichnung": "Frische Minze",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "135",
    "Y": 55.6666564941406,
    "L": 79.4237213134766,
    "a": -10.9784212112427,
    "b": 31.9221534729004,
    "C": 33.7572174072266,
    "h": 108.978721618652,
    "CMY_C": 0.22313046455383,
    "CMY_M": 0.21080738306046,
    "CMY_Y": 0.46876090764999,
    "CMYK_C": 0.01561479549855,
    "CMYK_M": 0,
    "CMYK_Y": 0.32685750722885,
    "CMYK_K": 0.21080738306046
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0977",
    "Farbtonhilfsbezeichnung": "Basketballorange",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "123",
    "Bcolor": "86",
    "Y": 29.4584445953369,
    "L": 61.1841163635254,
    "a": 33.4725723266602,
    "b": 35.5132217407227,
    "C": 48.8016586303711,
    "h": 46.6943550109863,
    "CMY_C": 0.15017402172089,
    "CMY_M": 0.51889741420746,
    "CMY_Y": 0.6640704870224,
    "CMYK_C": 0,
    "CMYK_M": 0.43388104438782,
    "CMYK_Y": 0.60470789670944,
    "CMYK_K": 0.15017402172089
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0978",
    "Farbtonhilfsbezeichnung": "Smoothiegrün",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "199",
    "Bcolor": "122",
    "Y": 55.2112693786621,
    "L": 79.1628036499023,
    "a": -7.87194538116455,
    "b": 38.4571723937988,
    "C": 39.2545738220215,
    "h": 101.568290710449,
    "CMY_C": 0.19095927476883,
    "CMY_M": 0.22142559289932,
    "CMY_Y": 0.52010363340378,
    "CMYK_C": 0,
    "CMYK_M": 0.03765733540058,
    "CMYK_Y": 0.40683287382126,
    "CMYK_K": 0.19095927476883
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0979",
    "Farbtonhilfsbezeichnung": "Dünensand",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "173",
    "Bcolor": "126",
    "Y": 43.9300193786621,
    "L": 72.1816940307617,
    "a": 4.91298389434814,
    "b": 27.6589889526367,
    "C": 28.0919399261475,
    "h": 79.9277725219727,
    "CMY_C": 0.2029904127121,
    "CMY_M": 0.32342797517776,
    "CMY_Y": 0.50736367702484,
    "CMYK_C": 0,
    "CMYK_M": 0.15111181139946,
    "CMYK_Y": 0.3818941116333,
    "CMYK_K": 0.2029904127121
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0980",
    "Farbtonhilfsbezeichnung": "Fjordblau",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "84",
    "Bcolor": "117",
    "Y": 8.50567531585693,
    "L": 35.0145721435547,
    "a": -0.00566081702709,
    "b": -22.7195472717285,
    "C": 22.7195472717285,
    "h": 269.985717773438,
    "CMY_C": 0.77937436103821,
    "CMY_M": 0.67002630233765,
    "CMY_Y": 0.53943079710007,
    "CMYK_C": 0.52097177505493,
    "CMYK_M": 0.28355240821838,
    "CMYK_Y": 0,
    "CMYK_K": 0.53943079710007
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0981",
    "Farbtonhilfsbezeichnung": "Frotteeblau",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 55.0988006591797,
    "L": 79.09814453125,
    "a": -18.3651523590088,
    "b": -9.32169914245605,
    "C": 20.595458984375,
    "h": 206.911224365234,
    "CMY_C": 0.43387913703918,
    "CMY_M": 0.18972730636597,
    "CMY_Y": 0.17297428846359,
    "CMYK_C": 0.31547367572784,
    "CMYK_M": 0.02025694958866,
    "CMYK_Y": 0,
    "CMYK_K": 0.17297428846359
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0982",
    "Farbtonhilfsbezeichnung": "Eiswürfelblau",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "231",
    "Bcolor": "235",
    "Y": 74.2784652709961,
    "L": 89.0539321899414,
    "a": -11.8282871246338,
    "b": -7.1001672744751,
    "C": 13.7956790924072,
    "h": 210.975128173828,
    "CMY_C": 0.25152146816254,
    "CMY_M": 0.09357613325119,
    "CMY_Y": 0.07871973514557,
    "CMYK_C": 0.18756695091724,
    "CMYK_M": 0.0161258187145,
    "CMYK_Y": 0,
    "CMYK_K": 0.07871973514557
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0983",
    "Farbtonhilfsbezeichnung": "Picknickgrün",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "188",
    "Bcolor": "45",
    "Y": 44.9874000549316,
    "L": 72.8835983276367,
    "a": -21.8563785552979,
    "b": 64.8629837036133,
    "C": 68.4463882446289,
    "h": 108.621879577637,
    "CMY_C": 0.31917077302933,
    "CMY_M": 0.26383823156357,
    "CMY_Y": 0.82429510354996,
    "CMYK_C": 0.07516356557608,
    "CMYK_M": 0,
    "CMYK_Y": 0.76132297515869,
    "CMYK_K": 0.26383823156357
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0984",
    "Farbtonhilfsbezeichnung": "Kaktusgrün",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "140",
    "Bcolor": "110",
    "Y": 23.673038482666,
    "L": 55.7589340209961,
    "a": -14.4378833770752,
    "b": 12.9954872131348,
    "C": 19.4251174926758,
    "h": 138.009735107422,
    "CMY_C": 0.5440901517868,
    "CMY_M": 0.45006692409515,
    "CMY_Y": 0.56982421875,
    "CMYK_C": 0.1709721237421,
    "CMYK_M": 0,
    "CMYK_Y": 0.21776703000069,
    "CMYK_K": 0.45006692409515
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0985",
    "Farbtonhilfsbezeichnung": "Sommernachtsblau",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "160",
    "Bcolor": "180",
    "Y": 31.1043567657471,
    "L": 62.5956230163574,
    "a": -13.4420204162598,
    "b": -17.2589874267578,
    "C": 21.8760261535645,
    "h": 232.087051391602,
    "CMY_C": 0.60443133115768,
    "CMY_M": 0.3735870718956,
    "CMY_Y": 0.29400360584259,
    "CMYK_C": 0.43970158696175,
    "CMYK_M": 0.11272503435612,
    "CMYK_Y": 0,
    "CMYK_K": 0.29400360584259
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0986",
    "Farbtonhilfsbezeichnung": "Khaki",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "148",
    "Bcolor": "125",
    "Y": 29.5602264404297,
    "L": 61.2729072570801,
    "a": -1.0607658624649,
    "b": 12.5092964172363,
    "C": 12.5541915893555,
    "h": 94.8469848632812,
    "CMY_C": 0.39237713813782,
    "CMY_M": 0.42033720016479,
    "CMY_Y": 0.51035350561142,
    "CMYK_C": 0,
    "CMYK_M": 0.04601548612118,
    "CMYK_Y": 0.19416052103043,
    "CMYK_K": 0.39237713813782
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0987",
    "Farbtonhilfsbezeichnung": "Nougatbraun",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "144",
    "Bcolor": "136",
    "Y": 29.9184322357178,
    "L": 61.5837783813477,
    "a": 8.16625118255615,
    "b": 7.05243349075317,
    "C": 10.7900171279907,
    "h": 40.8141250610352,
    "CMY_C": 0.34065532684326,
    "CMY_M": 0.43698853254318,
    "CMY_Y": 0.46846735477448,
    "CMYK_C": 0,
    "CMYK_M": 0.14610446989536,
    "CMYK_Y": 0.19384706020355,
    "CMYK_K": 0.34065532684326
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0988",
    "Farbtonhilfsbezeichnung": "Rosa-creme",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "206",
    "Bcolor": "200",
    "Y": 65.3717956542969,
    "L": 84.6749572753906,
    "a": 8.38629055023193,
    "b": 5.2914662361145,
    "C": 9.91612243652344,
    "h": 32.2505416870117,
    "CMY_C": 0.09186774492264,
    "CMY_M": 0.19241768121719,
    "CMY_Y": 0.21489286422729,
    "CMYK_C": 0,
    "CMYK_M": 0.11072168499231,
    "CMYK_Y": 0.13547049462795,
    "CMYK_K": 0.09186774492264
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0989",
    "Farbtonhilfsbezeichnung": "Nebelgrau",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "213",
    "Bcolor": "224",
    "Y": 66.2864227294922,
    "L": 85.1423034667969,
    "a": 0.18995229899883,
    "b": -6.80260896682739,
    "C": 6.80526065826416,
    "h": 271.599487304688,
    "CMY_C": 0.18906086683273,
    "CMY_M": 0.16392374038696,
    "CMY_Y": 0.12276571989059,
    "CMYK_C": 0.07557290792465,
    "CMYK_M": 0.04691793397069,
    "CMYK_Y": 0,
    "CMYK_K": 0.12276571989059
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0990",
    "Farbtonhilfsbezeichnung": "Entspanntes Beige",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "208",
    "Y": 81.950065612793,
    "L": 92.5528182983398,
    "a": 2.07339262962341,
    "b": 12.5213127136231,
    "C": 12.6918172836304,
    "h": 80.5977630615234,
    "CMY_C": 0.0288822054863,
    "CMY_M": 0.09166705608368,
    "CMY_Y": 0.18370896577835,
    "CMYK_C": 0,
    "CMYK_M": 0.06465214490891,
    "CMYK_Y": 0.15943148732185,
    "CMYK_K": 0.0288822054863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0991",
    "Farbtonhilfsbezeichnung": "Pastellgrün",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "212",
    "Bcolor": "174",
    "Y": 62.7615585327148,
    "L": 83.316764831543,
    "a": -9.0154333114624,
    "b": 17.1462326049805,
    "C": 19.3719215393066,
    "h": 117.735252380371,
    "CMY_C": 0.20250910520554,
    "CMY_M": 0.16952931880951,
    "CMY_Y": 0.31873798370361,
    "CMYK_C": 0.03971216082573,
    "CMYK_M": 0,
    "CMYK_Y": 0.17966759204865,
    "CMYK_K": 0.16952931880951
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0992",
    "Farbtonhilfsbezeichnung": "Camouflage",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "142",
    "Bcolor": "135",
    "Y": 27.0733680725098,
    "L": 59.0421752929688,
    "a": -0.07871244847775,
    "b": 3.23383665084839,
    "C": 3.23479437828064,
    "h": 91.3943176269531,
    "CMY_C": 0.4335510134697,
    "CMY_M": 0.44313853979111,
    "CMY_Y": 0.46919387578964,
    "CMYK_C": 0,
    "CMYK_M": 0.01692566648126,
    "CMYK_Y": 0.06292334198952,
    "CMYK_K": 0.4335510134697
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0993",
    "Farbtonhilfsbezeichnung": "Schlammgrün",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "108",
    "Bcolor": "100",
    "Y": 15.1379871368408,
    "L": 45.8226127624512,
    "a": 0.22759540379047,
    "b": 4.32782173156738,
    "C": 4.33380222320557,
    "h": 86.9896545410156,
    "CMY_C": 0.56072294712067,
    "CMY_M": 0.57576113939285,
    "CMY_Y": 0.60592544078827,
    "CMYK_C": 0,
    "CMYK_M": 0.03423395752907,
    "CMYK_Y": 0.10290201753378,
    "CMYK_K": 0.56072294712067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0994",
    "Farbtonhilfsbezeichnung": "Quellstein",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "84",
    "Bcolor": "78",
    "Y": 8.82400989532471,
    "L": 35.6432189941406,
    "a": 0.05721744522452,
    "b": 3.18115496635437,
    "C": 3.18166947364807,
    "h": 88.9695663452148,
    "CMY_C": 0.66223251819611,
    "CMY_M": 0.67191624641418,
    "CMY_Y": 0.69370079040527,
    "CMYK_C": 0,
    "CMYK_M": 0.02866980619729,
    "CMYK_Y": 0.09316548705101,
    "CMYK_K": 0.66223251819611
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0995",
    "Farbtonhilfsbezeichnung": "Dschungelgrün",
    "Farbtonklasse": "04",
    "Rcolor": "108",
    "Gcolor": "105",
    "Bcolor": "62",
    "Y": 13.6990909576416,
    "L": 43.7982635498047,
    "a": -5.58006763458252,
    "b": 24.5896987915039,
    "C": 25.2148857116699,
    "h": 102.785430908203,
    "CMY_C": 0.57482254505157,
    "CMY_M": 0.58747500181198,
    "CMY_Y": 0.75876116752625,
    "CMYK_C": 0,
    "CMYK_M": 0.02975806221366,
    "CMYK_Y": 0.43261611461639,
    "CMYK_K": 0.57482254505157
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0996",
    "Farbtonhilfsbezeichnung": "Sommergrün",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "223",
    "Bcolor": "152",
    "Y": 67.4508056640625,
    "L": 85.7310943603516,
    "a": -18.7823028564453,
    "b": 31.8844985961914,
    "C": 37.0053520202637,
    "h": 120.501205444336,
    "CMY_C": 0.21253538131714,
    "CMY_M": 0.12526667118073,
    "CMY_Y": 0.40503263473511,
    "CMYK_C": 0.09976607561111,
    "CMYK_M": 0,
    "CMYK_Y": 0.31983000040054,
    "CMYK_K": 0.12526667118073
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0997",
    "Farbtonhilfsbezeichnung": "Lollipop",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "131",
    "Bcolor": "183",
    "Y": 31.5745677947998,
    "L": 62.9896965026855,
    "a": 34.096549987793,
    "b": -17.6439971923828,
    "C": 38.3912162780762,
    "h": 332.639709472656,
    "CMY_C": 0.22463947534561,
    "CMY_M": 0.48693960905075,
    "CMY_Y": 0.28209513425827,
    "CMYK_C": 0,
    "CMYK_M": 0.33829441666603,
    "CMYK_Y": 0.0741018652916,
    "CMYK_K": 0.22463947534561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0998",
    "Farbtonhilfsbezeichnung": "Neumond-grau",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "66",
    "Bcolor": "72",
    "Y": 5.1474347114563,
    "L": 27.1507415771484,
    "a": -3.87836265563965,
    "b": -5.92503881454468,
    "C": 7.08151006698608,
    "h": 236.792373657227,
    "CMY_C": 0.79501271247864,
    "CMY_M": 0.73980921506882,
    "CMY_Y": 0.71609139442444,
    "CMYK_C": 0.27798143029213,
    "CMYK_M": 0.08354033529758,
    "CMYK_Y": 0,
    "CMYK_K": 0.71609139442444
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF0999",
    "Farbtonhilfsbezeichnung": "Happy Orange",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "104",
    "Bcolor": "68",
    "Y": 28.6334896087646,
    "L": 60.4567947387695,
    "a": 50.2111511230469,
    "b": 44.9023475646973,
    "C": 67.3600845336914,
    "h": 41.8053245544434,
    "CMY_C": 0.06321704387665,
    "CMY_M": 0.59240651130676,
    "CMY_Y": 0.73327934741974,
    "CMYK_C": 0,
    "CMYK_M": 0.56490081548691,
    "CMYK_Y": 0.71528017520905,
    "CMYK_K": 0.06321704387665
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1000",
    "Farbtonhilfsbezeichnung": "Blattgrün",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "190",
    "Bcolor": "101",
    "Y": 44.7560539245605,
    "L": 72.7309722900391,
    "a": -25.3467311859131,
    "b": 40.2178497314453,
    "C": 47.538745880127,
    "h": 122.220603942871,
    "CMY_C": 0.38566279411316,
    "CMY_M": 0.25626075267792,
    "CMY_Y": 0.60232985019684,
    "CMYK_C": 0.17398844659328,
    "CMYK_M": 0,
    "CMYK_Y": 0.46530970931053,
    "CMYK_K": 0.25626075267792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1001",
    "Farbtonhilfsbezeichnung": "Butterblumengelb",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "50",
    "Y": 64.3273773193359,
    "L": 84.1359329223633,
    "a": 7.2197413444519,
    "b": 76.0898895263672,
    "C": 76.431640625,
    "h": 84.5797576904297,
    "CMY_C": 0,
    "CMY_M": 0.20786279439926,
    "CMY_Y": 0.80321568250656,
    "CMYK_C": 0,
    "CMYK_M": 0.20786279439926,
    "CMYK_Y": 0.80321568250656,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1002",
    "Farbtonhilfsbezeichnung": "Engelrosa",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "207",
    "Bcolor": "212",
    "Y": 65.9503479003906,
    "L": 84.9710845947266,
    "a": 8.72090339660645,
    "b": -0.75700581073761,
    "C": 8.75369739532471,
    "h": 355.038940429688,
    "CMY_C": 0.10411417484283,
    "CMY_M": 0.18829280138016,
    "CMY_Y": 0.16758364439011,
    "CMYK_C": 0,
    "CMYK_M": 0.09396133571863,
    "CMYK_Y": 0.07084549218416,
    "CMYK_K": 0.10411417484283
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1003",
    "Farbtonhilfsbezeichnung": "Ibiza-blau",
    "Farbtonklasse": "01",
    "Rcolor": "156",
    "Gcolor": "205",
    "Bcolor": "225",
    "Y": 55.9700736999512,
    "L": 79.5967864990234,
    "a": -10.8239488601685,
    "b": -16.2381706237793,
    "C": 19.5150203704834,
    "h": 236.313598632812,
    "CMY_C": 0.39001113176346,
    "CMY_M": 0.19740474224091,
    "CMY_Y": 0.11676633358002,
    "CMYK_C": 0.3093686401844,
    "CMYK_M": 0.09129906445742,
    "CMYK_Y": 0,
    "CMYK_K": 0.11676633358002
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1004",
    "Farbtonhilfsbezeichnung": "Ruby Red",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "63",
    "Bcolor": "83",
    "Y": 13.6785163879395,
    "L": 43.7683143615723,
    "a": 48.3895301818848,
    "b": 13.6014099121094,
    "C": 50.2647476196289,
    "h": 15.6997003555298,
    "CMY_C": 0.30124187469482,
    "CMY_M": 0.75226557254791,
    "CMY_Y": 0.67604577541351,
    "CMYK_C": 0,
    "CMYK_M": 0.64546471834183,
    "CMYK_Y": 0.53638577461243,
    "CMYK_K": 0.30124187469482
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1005",
    "Farbtonhilfsbezeichnung": "Zartbitterschwarz",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "64",
    "Bcolor": "63",
    "Y": 5.29559659957886,
    "L": 27.5608463287354,
    "a": 2.69300317764282,
    "b": 1.00750422477722,
    "C": 2.8752965927124,
    "h": 20.5117893218994,
    "CMY_C": 0.72560477256775,
    "CMY_M": 0.75011599063873,
    "CMY_Y": 0.75272035598755,
    "CMYK_C": 0,
    "CMYK_M": 0.08932814747095,
    "CMYK_Y": 0.09881944209337,
    "CMYK_K": 0.72560477256775
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1006",
    "Farbtonhilfsbezeichnung": "Orbit-blau",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "66",
    "Bcolor": "115",
    "Y": 6.2227087020874,
    "L": 29.967529296875,
    "a": 13.6982326507568,
    "b": -28.8967208862305,
    "C": 31.9790878295898,
    "h": 295.362884521484,
    "CMY_C": 0.74380230903625,
    "CMY_M": 0.74255073070526,
    "CMY_Y": 0.54997044801712,
    "CMYK_C": 0.43070918321609,
    "CMYK_M": 0.42792809009552,
    "CMYK_Y": 0,
    "CMYK_K": 0.54997044801712
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1007",
    "Farbtonhilfsbezeichnung": "Red Valentine",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "49",
    "Bcolor": "50",
    "Y": 9.62271213531494,
    "L": 37.1565933227539,
    "a": 44.7429504394531,
    "b": 24.3544998168945,
    "C": 50.9418601989746,
    "h": 28.5603542327881,
    "CMY_C": 0.38479691743851,
    "CMY_M": 0.80606663227081,
    "CMY_Y": 0.80275136232376,
    "CMYK_C": 0,
    "CMYK_M": 0.68476527929306,
    "CMYK_Y": 0.67937636375427,
    "CMYK_K": 0.38479691743851
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1008",
    "Farbtonhilfsbezeichnung": "Safari-oliv",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "144",
    "Bcolor": "39",
    "Y": 30.5635623931885,
    "L": 62.1374626159668,
    "a": 6.45265531539917,
    "b": 57.5333786010742,
    "C": 57.8940963745117,
    "h": 83.6007385253906,
    "CMY_C": 0.26894980669022,
    "CMY_M": 0.43551188707352,
    "CMY_Y": 0.84858554601669,
    "CMYK_C": 0,
    "CMYK_M": 0.22783945500851,
    "CMYK_Y": 0.7928808927536,
    "CMYK_K": 0.26894980669022
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1009",
    "Farbtonhilfsbezeichnung": "Emoji-gelb",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "210",
    "Bcolor": "44",
    "Y": 67.0590438842773,
    "L": 85.5337524414063,
    "a": 0.58357936143875,
    "b": 78.909782409668,
    "C": 78.9119415283203,
    "h": 89.5762786865234,
    "CMY_C": 0.00958645343781,
    "CMY_M": 0.1765421628952,
    "CMY_Y": 0.82902133464813,
    "CMYK_C": 0,
    "CMYK_M": 0.16857171058655,
    "CMYK_Y": 0.82736641168594,
    "CMYK_K": 0.00958645343781
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1010",
    "Farbtonhilfsbezeichnung": "Pudding-gelb",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "227",
    "Bcolor": "142",
    "Y": 77.9156112670898,
    "L": 90.7413787841797,
    "a": -0.87077766656876,
    "b": 43.8748817443848,
    "C": 43.8835220336914,
    "h": 91.1369934082031,
    "CMY_C": 0.00066816806793,
    "CMY_M": 0.11133229732513,
    "CMY_Y": 0.44139486551285,
    "CMYK_C": 0,
    "CMYK_M": 0.11073812097311,
    "CMYK_Y": 0.44102138280869,
    "CMYK_K": 0.00066816806793
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1011",
    "Farbtonhilfsbezeichnung": "Paradiesapfel",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "49",
    "Bcolor": "45",
    "Y": 12.7624139785767,
    "L": 42.4030609130859,
    "a": 54.2788429260254,
    "b": 35.0246047973633,
    "C": 64.5981063842773,
    "h": 32.8330078125,
    "CMY_C": 0.27176362276077,
    "CMY_M": 0.80898904800415,
    "CMY_Y": 0.82359290122986,
    "CMYK_C": 0,
    "CMYK_M": 0.73770749568939,
    "CMYK_Y": 0.75776118040085,
    "CMYK_K": 0.27176362276077
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1012",
    "Farbtonhilfsbezeichnung": "Midnight Grey",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "92",
    "Bcolor": "97",
    "Y": 10.5659828186035,
    "L": 38.8396453857422,
    "a": -0.15432666242123,
    "b": -4.12626552581787,
    "C": 4.129150390625,
    "h": 267.858062744141,
    "CMY_C": 0.65535879135132,
    "CMY_M": 0.63978147506714,
    "CMY_Y": 0.61854684352875,
    "CMYK_C": 0.09650450199842,
    "CMYK_M": 0.05566773191094,
    "CMYK_Y": 0,
    "CMYK_K": 0.61854684352875
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1013",
    "Farbtonhilfsbezeichnung": "Swimmingpool",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "193",
    "Bcolor": "222",
    "Y": 45.9041519165039,
    "L": 73.4832992553711,
    "a": -19.8910503387451,
    "b": -23.7471561431885,
    "C": 30.9771099090576,
    "h": 230.049850463867,
    "CMY_C": 0.61853790283203,
    "CMY_M": 0.24348664283752,
    "CMY_Y": 0.13124018907547,
    "CMYK_C": 0.5609118938446,
    "CMYK_M": 0.12920309603214,
    "CMYK_Y": 0,
    "CMYK_K": 0.13124018907547
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1014",
    "Farbtonhilfsbezeichnung": "Bubblegumrot",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "109",
    "Bcolor": "118",
    "Y": 27.4465732574463,
    "L": 59.385425567627,
    "a": 44.161937713623,
    "b": 15.0385751724243,
    "C": 46.6522827148438,
    "h": 18.8053779602051,
    "CMY_C": 0.13896071910858,
    "CMY_M": 0.57145583629608,
    "CMY_Y": 0.53802543878555,
    "CMYK_C": 0,
    "CMYK_M": 0.50229430198669,
    "CMYK_Y": 0.46346867084503,
    "CMYK_K": 0.13896071910858
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1015",
    "Farbtonhilfsbezeichnung": "Mangosorbet",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "157",
    "Bcolor": "112",
    "Y": 43.2944107055664,
    "L": 71.7543411254883,
    "a": 26.0364055633545,
    "b": 35.2981872558594,
    "C": 43.8617897033691,
    "h": 53.587028503418,
    "CMY_C": 0.06699591875076,
    "CMY_M": 0.38595849275589,
    "CMY_Y": 0.56221270561218,
    "CMYK_C": 0,
    "CMYK_M": 0.3418662250042,
    "CMYK_Y": 0.53077667951584,
    "CMYK_K": 0.06699591875076
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1016",
    "Farbtonhilfsbezeichnung": "Applegreen",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "218",
    "Bcolor": "87",
    "Y": 64.2893295288086,
    "L": 84.1161804199219,
    "a": -20.3837013244629,
    "b": 60.9521903991699,
    "C": 64.2702484130859,
    "h": 108.491027832031,
    "CMY_C": 0.1864795088768,
    "CMY_M": 0.1441211104393,
    "CMY_Y": 0.65831792354584,
    "CMYK_C": 0.04949111118913,
    "CMYK_M": 0,
    "CMYK_Y": 0.60078221559525,
    "CMYK_K": 0.1441211104393
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1017",
    "Farbtonhilfsbezeichnung": "Grüner Tee",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "230",
    "Bcolor": "130",
    "Y": 73.1962585449219,
    "L": 88.5412292480469,
    "a": -17.4044933319092,
    "b": 46.4228134155273,
    "C": 49.5781593322754,
    "h": 110.551651000977,
    "CMY_C": 0.13879162073135,
    "CMY_M": 0.0992488861084,
    "CMY_Y": 0.48855745792389,
    "CMYK_C": 0.0438997335732,
    "CMYK_M": 0,
    "CMYK_Y": 0.43220436573029,
    "CMYK_K": 0.0992488861084
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1018",
    "Farbtonhilfsbezeichnung": "Cocktailblau",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "149",
    "Bcolor": "172",
    "Y": 23.3434944152832,
    "L": 55.4244003295898,
    "a": -31.6028556823731,
    "b": -23.9907913208008,
    "C": 39.677433013916,
    "h": 217.203353881836,
    "CMY_C": 1,
    "CMY_M": 0.41558259725571,
    "CMY_Y": 0.32523113489151,
    "CMYK_C": 1,
    "CMYK_M": 0.13389986753464,
    "CMYK_Y": 0,
    "CMYK_K": 0.32523113489151
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1019",
    "Farbtonhilfsbezeichnung": "Electric Lilac",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "158",
    "Y": 14.3101501464844,
    "L": 44.6744804382324,
    "a": 20.9339408874512,
    "b": -31.9935150146484,
    "C": 38.2336883544922,
    "h": 303.197448730469,
    "CMY_C": 0.55895471572876,
    "CMY_M": 0.62348139286041,
    "CMY_Y": 0.38053810596466,
    "CMYK_C": 0.28801870346069,
    "CMYK_M": 0.39218440651894,
    "CMYK_Y": 0,
    "CMYK_K": 0.38053810596466
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1020",
    "Farbtonhilfsbezeichnung": "Turquoise",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 60.6232833862305,
    "L": 82.1758041381836,
    "a": -28.4108963012695,
    "b": 0.07885667681694,
    "C": 28.4110050201416,
    "h": 179.840972900391,
    "CMY_C": 0.45673841238022,
    "CMY_M": 0.1392120718956,
    "CMY_Y": 0.20884150266647,
    "CMYK_C": 0.36887872219086,
    "CMYK_M": 0,
    "CMYK_Y": 0.08089034259319,
    "CMYK_K": 0.1392120718956
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1021",
    "Farbtonhilfsbezeichnung": "Poolparty-blau",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "211",
    "Bcolor": "199",
    "Y": 54.1847343444824,
    "L": 78.5693283081055,
    "a": -32.2613792419434,
    "b": -3.69057631492615,
    "C": 32.4717864990234,
    "h": 186.52604675293,
    "CMY_C": 0.56721210479736,
    "CMY_M": 0.17135369777679,
    "CMY_Y": 0.22087013721466,
    "CMYK_C": 0.47771698236465,
    "CMYK_M": 0,
    "CMYK_Y": 0.05975582078099,
    "CMYK_K": 0.17135369777679
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1022",
    "Farbtonhilfsbezeichnung": "Petrol Dream",
    "Farbtonklasse": "02",
    "Rcolor": "51",
    "Gcolor": "194",
    "Bcolor": "185",
    "Y": 42.7322616577148,
    "L": 71.3728713989258,
    "a": -38.3552131652832,
    "b": -6.85929107666016,
    "C": 38.9637298583984,
    "h": 190.139358520508,
    "CMY_C": 0.80010455846786,
    "CMY_M": 0.2395755648613,
    "CMY_Y": 0.27587604522705,
    "CMYK_C": 0.73712646961212,
    "CMYK_M": 0,
    "CMYK_Y": 0.04773712903261,
    "CMYK_K": 0.2395755648613
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1023",
    "Farbtonhilfsbezeichnung": "Talisman-grün",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "115",
    "Y": 15.1410388946533,
    "L": 45.8267669677734,
    "a": -36.9358825683594,
    "b": -5.02410697937012,
    "C": 37.2760124206543,
    "h": 187.745971679688,
    "CMY_C": 1,
    "CMY_M": 0.51227390766144,
    "CMY_Y": 0.54907286167145,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07545004040003,
    "CMYK_K": 0.51227390766144
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1024",
    "Farbtonhilfsbezeichnung": "Alabasterbeige",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "220",
    "Bcolor": "212",
    "Y": 72.9600601196289,
    "L": 88.4286651611328,
    "a": 2.1833930015564,
    "b": 4.59701442718506,
    "C": 5.08917951583862,
    "h": 64.5942077636719,
    "CMY_C": 0.09784245491028,
    "CMY_M": 0.13569283485413,
    "CMY_Y": 0.16996604204178,
    "CMYK_C": 0,
    "CMYK_M": 0.0419554002583,
    "CMYK_Y": 0.07994566857815,
    "CMYK_K": 0.09784245491028
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1025",
    "Farbtonhilfsbezeichnung": "Weidenkätzchen",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "222",
    "Bcolor": "204",
    "Y": 74.9084701538086,
    "L": 89.3501052856445,
    "a": 3.01222562789917,
    "b": 9.98577880859375,
    "C": 10.4302101135254,
    "h": 73.213981628418,
    "CMY_C": 0.06527101993561,
    "CMY_M": 0.12892961502075,
    "CMY_Y": 0.19955044984818,
    "CMYK_C": 0,
    "CMYK_M": 0.06810379773378,
    "CMYK_Y": 0.14365600049496,
    "CMYK_K": 0.06527101993561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1026",
    "Farbtonhilfsbezeichnung": "Nude",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "191",
    "Bcolor": "161",
    "Y": 55.3488502502441,
    "L": 79.2417831420898,
    "a": 6.39549493789673,
    "b": 18.448371887207,
    "C": 19.5254898071289,
    "h": 70.8801116943359,
    "CMY_C": 0.13317626714706,
    "CMY_M": 0.24976354837418,
    "CMY_Y": 0.36832875013351,
    "CMYK_C": 0,
    "CMYK_M": 0.13449941575527,
    "CMYK_Y": 0.27128061652184,
    "CMYK_K": 0.13317626714706
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1027",
    "Farbtonhilfsbezeichnung": "Exzellent-gelb",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "223",
    "Bcolor": "184",
    "Y": 76.3925399780273,
    "L": 90.0412826538086,
    "a": 4.30406188964844,
    "b": 21.7065563201904,
    "C": 22.1291561126709,
    "h": 78.7846374511719,
    "CMY_C": 0.01779037714005,
    "CMY_M": 0.12729126214981,
    "CMY_Y": 0.27886283397675,
    "CMYK_C": 0,
    "CMYK_M": 0.11148422956467,
    "CMYK_Y": 0.26580116152763,
    "CMYK_K": 0.01779037714005
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1028",
    "Farbtonhilfsbezeichnung": "Kreideweiß",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 75.7637557983398,
    "L": 89.7495422363281,
    "a": -0.61364209651947,
    "b": 2.06427001953125,
    "C": 2.15354752540588,
    "h": 106.555549621582,
    "CMY_C": 0.11294734477997,
    "CMY_M": 0.11368370056152,
    "CMY_Y": 0.13722538948059,
    "CMYK_C": 0,
    "CMYK_M": 0.00083011505194,
    "CMYK_Y": 0.02736933901906,
    "CMYK_K": 0.11294734477997
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1029",
    "Farbtonhilfsbezeichnung": "Pantoffelgrau",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "215",
    "Bcolor": "211",
    "Y": 67.5653533935547,
    "L": 85.7886428833008,
    "a": -0.49820536375046,
    "b": 1.0566486120224,
    "C": 1.16821014881134,
    "h": 115.243675231934,
    "CMY_C": 0.15923964977264,
    "CMY_M": 0.15750360488892,
    "CMY_Y": 0.17317533493042,
    "CMYK_C": 0.00206059613265,
    "CMYK_M": 0,
    "CMYK_Y": 0.01860154047608,
    "CMYK_K": 0.15750360488892
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1030",
    "Farbtonhilfsbezeichnung": "Hermelin-weiß",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "216",
    "Y": 79.5226135253906,
    "L": 91.4702377319336,
    "a": 0.5962455868721,
    "b": 6.9589672088623,
    "C": 6.98446369171143,
    "h": 85.1028442382813,
    "CMY_C": 0.06858623027802,
    "CMY_M": 0.09873503446579,
    "CMY_Y": 0.15439760684967,
    "CMYK_C": 0,
    "CMYK_M": 0.03236886113882,
    "CMYK_Y": 0.09213024377823,
    "CMYK_K": 0.06858623027802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1031",
    "Farbtonhilfsbezeichnung": "Puder",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "173",
    "Bcolor": "165",
    "Y": 44.2748947143555,
    "L": 72.4118499755859,
    "a": 6.85309600830078,
    "b": 6.52560615539551,
    "C": 9.46300506591797,
    "h": 43.5977668762207,
    "CMY_C": 0.23468112945557,
    "CMY_M": 0.32094305753708,
    "CMY_Y": 0.35412448644638,
    "CMYK_C": 0,
    "CMYK_M": 0.11271370947361,
    "CMYK_Y": 0.15607005357742,
    "CMYK_K": 0.23468112945557
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1032",
    "Farbtonhilfsbezeichnung": "Maharadscha-beige",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "158",
    "Bcolor": "146",
    "Y": 35.8923721313477,
    "L": 66.4376068115234,
    "a": 5.29308462142944,
    "b": 8.42948627471924,
    "C": 9.95354080200195,
    "h": 57.8742637634277,
    "CMY_C": 0.30478501319885,
    "CMY_M": 0.38040089607239,
    "CMY_Y": 0.42924946546555,
    "CMYK_C": 0,
    "CMYK_M": 0.1087661832571,
    "CMYK_Y": 0.17903016507626,
    "CMYK_K": 0.30478501319885
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1033",
    "Farbtonhilfsbezeichnung": "Apricot Fizz",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "219",
    "Bcolor": "185",
    "Y": 75.2931442260742,
    "L": 89.5301284790039,
    "a": 7.0550422668457,
    "b": 20.2381973266602,
    "C": 21.4326438903809,
    "h": 70.7814254760742,
    "CMY_C": 0.00775694847107,
    "CMY_M": 0.13947641849518,
    "CMY_Y": 0.27288472652435,
    "CMYK_C": 0,
    "CMYK_M": 0.13274919986725,
    "CMYK_Y": 0.26720044016838,
    "CMYK_K": 0.00775694847107
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1034",
    "Farbtonhilfsbezeichnung": "Hochzeitsblau",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "182",
    "Bcolor": "192",
    "Y": 45.6317901611328,
    "L": 73.3059692382813,
    "a": -2.27842307090759,
    "b": -7.26676797866821,
    "C": 7.61558437347412,
    "h": 252.591705322266,
    "CMY_C": 0.33823853731155,
    "CMY_M": 0.28646069765091,
    "CMY_Y": 0.24845516681671,
    "CMYK_C": 0.11946509033442,
    "CMYK_M": 0.05056987702847,
    "CMYK_Y": 0,
    "CMYK_K": 0.24845516681671
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1035",
    "Farbtonhilfsbezeichnung": "Glory Grey",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "201",
    "Bcolor": "189",
    "Y": 58.5081405639648,
    "L": 81.0204849243164,
    "a": 0.41393348574638,
    "b": 5.6667914390564,
    "C": 5.68188953399658,
    "h": 85.8222198486328,
    "CMY_C": 0.18977361917496,
    "CMY_M": 0.21306204795837,
    "CMY_Y": 0.25806087255478,
    "CMYK_C": 0,
    "CMYK_M": 0.02874311432242,
    "CMYK_Y": 0.0842816978693,
    "CMYK_K": 0.18977361917496
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1036",
    "Farbtonhilfsbezeichnung": "Aventuringrün",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "160",
    "Bcolor": "155",
    "Y": 32.9650077819824,
    "L": 64.132568359375,
    "a": -8.34350395202637,
    "b": -0.77027398347855,
    "C": 8.37898445129395,
    "h": 185.274612426758,
    "CMY_C": 0.457878947258,
    "CMY_M": 0.3722682595253,
    "CMY_Y": 0.39103752374649,
    "CMYK_C": 0.13638101518154,
    "CMYK_M": 0,
    "CMYK_Y": 0.02990013547242,
    "CMYK_K": 0.3722682595253
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1037",
    "Farbtonhilfsbezeichnung": "Royalgrau",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "161",
    "Bcolor": "163",
    "Y": 34.9573707580566,
    "L": 65.715461730957,
    "a": -1.38035035133362,
    "b": -2.86830878257751,
    "C": 3.18316864967346,
    "h": 244.301177978516,
    "CMY_C": 0.39414912462234,
    "CMY_M": 0.36983096599579,
    "CMY_Y": 0.35930210351944,
    "CMYK_C": 0.05438916012645,
    "CMYK_M": 0.01643342711031,
    "CMYK_Y": 0,
    "CMYK_K": 0.35930210351944
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1038",
    "Farbtonhilfsbezeichnung": "Prestige-grau",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "185",
    "Bcolor": "183",
    "Y": 48.5134658813477,
    "L": 75.1476364135742,
    "a": -0.52199023962021,
    "b": 0.18286989629269,
    "C": 0.55309599637985,
    "h": 160.693008422852,
    "CMY_C": 0.27782601118088,
    "CMY_M": 0.27282840013504,
    "CMY_Y": 0.28144121170044,
    "CMYK_C": 0.00687267072499,
    "CMYK_M": 0,
    "CMYK_Y": 0.01184426248074,
    "CMYK_K": 0.27282840013504
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1039",
    "Farbtonhilfsbezeichnung": "Oxford Blue",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "161",
    "Bcolor": "176",
    "Y": 33.5867118835449,
    "L": 64.633186340332,
    "a": -5.18081760406494,
    "b": -11.7443475723267,
    "C": 12.8362989425659,
    "h": 246.196151733398,
    "CMY_C": 0.47189265489578,
    "CMY_M": 0.37043339014053,
    "CMY_Y": 0.30969232320786,
    "CMYK_C": 0.23496817052364,
    "CMYK_M": 0.08799129724503,
    "CMYK_Y": 0,
    "CMYK_K": 0.30969232320786
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen Farbe",
    "Farbton_ID": "SWF1040",
    "Farbtonhilfsbezeichnung": "Seegrün",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "111",
    "Bcolor": "121",
    "Y": 13.8743553161621,
    "L": 44.0521965026855,
    "a": -11.7717618942261,
    "b": -11.0975570678711,
    "C": 16.1780757904053,
    "h": 223.311370849609,
    "CMY_C": 0.73590493202209,
    "CMY_M": 0.5662032365799,
    "CMY_Y": 0.52497351169586,
    "CMYK_C": 0.44404137134552,
    "CMYK_M": 0.08679457753897,
    "CMYK_Y": 0,
    "CMYK_K": 0.52497351169586
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0001",
    "Farbtonhilfsbezeichnung": "D 101",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "222",
    "Bcolor": "185",
    "Y": 75,
    "L": 89.2099188873016,
    "a": 0.90388588187051,
    "b": 19.8151055145247,
    "C": 19.8357106310611,
    "h": 1.52521192545884,
    "CMY_C": 0.05613462,
    "CMY_M": 0.127834,
    "CMY_Y": 0.2742528,
    "CMYK_C": 0,
    "CMYK_M": 0.07596354,
    "CMYK_Y": 0.2310903,
    "CMYK_K": 0.05613462
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0002",
    "Farbtonhilfsbezeichnung": "D 201",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "221",
    "Bcolor": "146",
    "Y": 74,
    "L": 88.7233226785387,
    "a": -1.03398886437917,
    "b": 39.3479204337755,
    "C": 39.361503724253,
    "h": -1.5445242659499,
    "CMY_C": 0.03335561,
    "CMY_M": 0.1325583,
    "CMY_Y": 0.4272239,
    "CMYK_C": 0,
    "CMYK_M": 0.1026259,
    "CMYK_Y": 0.4074594,
    "CMYK_K": 0.03335561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0003",
    "Farbtonhilfsbezeichnung": "D 301",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "211",
    "Bcolor": "139",
    "Y": 67,
    "L": 85.5734816360491,
    "a": 1.46040767786693,
    "b": 38.8017208203376,
    "C": 38.8291942899282,
    "h": 1.53317638031772,
    "CMY_C": 0.05378439,
    "CMY_M": 0.1730814,
    "CMY_Y": 0.4550382,
    "CMYK_C": 0,
    "CMYK_M": 0.126078,
    "CMYK_Y": 0.4240617,
    "CMYK_K": 0.05378439
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0004",
    "Farbtonhilfsbezeichnung": "D 401",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "197",
    "Bcolor": "122",
    "Y": 58,
    "L": 80.7192982652754,
    "a": 1.42713171053949,
    "b": 41.0291181963357,
    "C": 41.0539309310097,
    "h": 1.536026957233,
    "CMY_C": 0.1061376,
    "CMY_M": 0.2262194,
    "CMY_Y": 0.521759,
    "CMYK_C": 0,
    "CMYK_M": 0.1343404,
    "CMYK_Y": 0.4649725,
    "CMYK_K": 0.1061376
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0005",
    "Farbtonhilfsbezeichnung": "D 501",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "206",
    "Bcolor": "103",
    "Y": 65,
    "L": 84.7277318951891,
    "a": 4.9296328132703,
    "b": 55.8039537150444,
    "C": 56.0212685495829,
    "h": 1.48268663010482,
    "CMY_C": 0.01555694,
    "CMY_M": 0.1934334,
    "CMY_Y": 0.5979072,
    "CMYK_C": 0,
    "CMYK_M": 0.1806875,
    "CMYK_Y": 0.591553,
    "CMYK_K": 0.01555694
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0006",
    "Farbtonhilfsbezeichnung": "D 102",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "198",
    "Bcolor": "139",
    "Y": 59,
    "L": 81.1754549198588,
    "a": 3.68601251817091,
    "b": 32.6243097974997,
    "C": 32.8318789905078,
    "h": 1.45828981748976,
    "CMY_C": 0.1005154,
    "CMY_M": 0.2252352,
    "CMY_Y": 0.4530098,
    "CMYK_C": 0,
    "CMYK_M": 0.1386569,
    "CMYK_Y": 0.3918848,
    "CMYK_K": 0.1005154
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0007",
    "Farbtonhilfsbezeichnung": "D 202",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "189",
    "Bcolor": "133",
    "Y": 54,
    "L": 78.5748769985429,
    "a": 6.66980359769187,
    "b": 32.7844220310508,
    "C": 33.4560100421708,
    "h": 1.37009114995591,
    "CMY_C": 0.1102889,
    "CMY_M": 0.2606149,
    "CMY_Y": 0.4800661,
    "CMYK_C": 0,
    "CMYK_M": 0.1689604,
    "CMYK_Y": 0.4156149,
    "CMYK_K": 0.1102889
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0008",
    "Farbtonhilfsbezeichnung": "D 302",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "185",
    "Bcolor": "115",
    "Y": 52,
    "L": 77.2049148924761,
    "a": 5.94720666345983,
    "b": 40.3376193042834,
    "C": 40.7736777619483,
    "h": 1.42441515354983,
    "CMY_C": 0.1183506,
    "CMY_M": 0.2748244,
    "CMY_Y": 0.550784,
    "CMYK_C": 0,
    "CMYK_M": 0.1774784,
    "CMYK_Y": 0.4904823,
    "CMYK_K": 0.1183506
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0009",
    "Farbtonhilfsbezeichnung": "D 402",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "185",
    "Bcolor": "95",
    "Y": 53,
    "L": 77.7653340392443,
    "a": 8.23331810674022,
    "b": 50.7987220286684,
    "C": 51.4616137212262,
    "h": 1.41011630578607,
    "CMY_C": 0.08328956,
    "CMY_M": 0.2760995,
    "CMY_Y": 0.6264459,
    "CMYK_C": 0,
    "CMYK_M": 0.2103281,
    "CMYK_Y": 0.5925059,
    "CMYK_K": 0.08328956
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0010",
    "Farbtonhilfsbezeichnung": "D 502",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "188",
    "Bcolor": "88",
    "Y": 55,
    "L": 79.1952629597256,
    "a": 9.20453736909926,
    "b": 56.1925360343929,
    "C": 56.9414138756292,
    "h": 1.40843466291315,
    "CMY_C": 0.05413818,
    "CMY_M": 0.2639895,
    "CMY_Y": 0.656364,
    "CMYK_C": 0,
    "CMYK_M": 0.2218626,
    "CMYK_Y": 0.6366953,
    "CMYK_K": 0.05413818
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0011",
    "Farbtonhilfsbezeichnung": "D 103",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "221",
    "Bcolor": "168",
    "Y": 74,
    "L": 89.1081098397518,
    "a": 1.92305341721172,
    "b": 28.6446084068059,
    "C": 28.7090878507957,
    "h": 1.50376199878732,
    "CMY_C": 0.02968923,
    "CMY_M": 0.1333462,
    "CMY_Y": 0.3411565,
    "CMYK_C": 0,
    "CMYK_M": 0.1068286,
    "CMYK_Y": 0.3209975,
    "CMYK_K": 0.02968923
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0012",
    "Farbtonhilfsbezeichnung": "D 203",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "158",
    "Y": 74,
    "L": 89.0641611570793,
    "a": 5.01700060134552,
    "b": 33.6295737060279,
    "C": 34.0017429359594,
    "h": 1.4227043359637,
    "CMY_C": 0,
    "CMY_M": 0.1424383,
    "CMY_Y": 0.378606,
    "CMYK_C": 0,
    "CMYK_M": 0.1424383,
    "CMYK_Y": 0.378606,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0013",
    "Farbtonhilfsbezeichnung": "D 303",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "199",
    "Bcolor": "152",
    "Y": 60,
    "L": 81.9990232353531,
    "a": 4.86358281966531,
    "b": 27.2491659729958,
    "C": 27.6798028184381,
    "h": 1.39417068089475,
    "CMY_C": 0.09363265,
    "CMY_M": 0.2181232,
    "CMY_Y": 0.4043858,
    "CMYK_C": 0,
    "CMYK_M": 0.1373511,
    "CMYK_Y": 0.3428557,
    "CMYK_K": 0.09363265
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0014",
    "Farbtonhilfsbezeichnung": "D 403",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "184",
    "Bcolor": "111",
    "Y": 53,
    "L": 77.5845931712519,
    "a": 8.99763614177984,
    "b": 42.8219306526848,
    "C": 43.7570017364445,
    "h": 1.36369161762716,
    "CMY_C": 0.09109593,
    "CMY_M": 0.278779,
    "CMY_Y": 0.5651611,
    "CMYK_C": 0,
    "CMYK_M": 0.2064938,
    "CMYK_Y": 0.5215789,
    "CMYK_K": 0.09109593
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0015",
    "Farbtonhilfsbezeichnung": "D 503",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "188",
    "Bcolor": "99",
    "Y": 56,
    "L": 79.4393033159864,
    "a": 10.637382723147,
    "b": 51.2626434622558,
    "C": 52.354680076733,
    "h": 1.36619255379313,
    "CMY_C": 0.04812925,
    "CMY_M": 0.264393,
    "CMY_Y": 0.6125057,
    "CMYK_C": 0,
    "CMYK_M": 0.2271987,
    "CMYK_Y": 0.592913,
    "CMYK_K": 0.04812925
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0016",
    "Farbtonhilfsbezeichnung": "D 104",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "231",
    "Bcolor": "206",
    "Y": 81,
    "L": 92.3178967728188,
    "a": 2.13727451857026,
    "b": 13.4887103168569,
    "C": 13.6569853327816,
    "h": 1.41365358061544,
    "CMY_C": 0.02840463,
    "CMY_M": 0.09472769,
    "CMY_Y": 0.1934653,
    "CMYK_C": 0,
    "CMYK_M": 0.06826202,
    "CMYK_Y": 0.1698862,
    "CMYK_K": 0.02840463
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0017",
    "Farbtonhilfsbezeichnung": "D 204",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "222",
    "Bcolor": "182",
    "Y": 76,
    "L": 89.9503161122775,
    "a": 5.19996635735215,
    "b": 22.5919443840589,
    "C": 23.1826573362504,
    "h": 1.34456738897937,
    "CMY_C": 0.0104867,
    "CMY_M": 0.1307645,
    "CMY_Y": 0.2862748,
    "CMYK_C": 0,
    "CMYK_M": 0.1215525,
    "CMYK_Y": 0.2787109,
    "CMYK_K": 0.0104867
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0018",
    "Farbtonhilfsbezeichnung": "D 304",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "190",
    "Bcolor": "158",
    "Y": 55,
    "L": 78.8233942906435,
    "a": 5.84295245270894,
    "b": 19.3772760775146,
    "C": 20.2390444821103,
    "h": 1.27793066427234,
    "CMY_C": 0.1395401,
    "CMY_M": 0.253164,
    "CMY_Y": 0.3795069,
    "CMYK_C": 0,
    "CMYK_M": 0.1320502,
    "CMYK_Y": 0.278882,
    "CMYK_K": 0.1395401
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0019",
    "Farbtonhilfsbezeichnung": "D 404",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "176",
    "Bcolor": "146",
    "Y": 46,
    "L": 73.6448246618751,
    "a": 6.72820879923503,
    "b": 18.516005939383,
    "C": 19.7005398299988,
    "h": 1.2222583221318,
    "CMY_C": 0.1931339,
    "CMY_M": 0.3104894,
    "CMY_Y": 0.4264954,
    "CMYK_C": 0,
    "CMYK_M": 0.145446,
    "CMYK_Y": 0.2892196,
    "CMYK_K": 0.1931339
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0020",
    "Farbtonhilfsbezeichnung": "D 504",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "163",
    "Bcolor": "134",
    "Y": 39,
    "L": 69.0441627598002,
    "a": 7.38039207667018,
    "b": 18.5885021354529,
    "C": 20.0000649710223,
    "h": 1.19284366254798,
    "CMY_C": 0.2393974,
    "CMY_M": 0.3605784,
    "CMY_Y": 0.4735917,
    "CMYK_C": 0,
    "CMYK_M": 0.1593224,
    "CMYK_Y": 0.3079062,
    "CMYK_K": 0.2393974
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0021",
    "Farbtonhilfsbezeichnung": "D 105",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "218",
    "Bcolor": "191",
    "Y": 74,
    "L": 88.9872996807853,
    "a": 7.67365606112691,
    "b": 16.5787529936364,
    "C": 18.2685535324633,
    "h": 1.13729891794108,
    "CMY_C": 0.01838892,
    "CMY_M": 0.1462053,
    "CMY_Y": 0.2514431,
    "CMYK_C": 0,
    "CMYK_M": 0.1302108,
    "CMYK_Y": 0.23742,
    "CMYK_K": 0.01838892
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0022",
    "Farbtonhilfsbezeichnung": "D 205",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "168",
    "Y": 61,
    "L": 82.3202446908744,
    "a": 11.0044017855598,
    "b": 19.5020314143857,
    "C": 22.3925453654943,
    "h": 1.05706368244828,
    "CMY_C": 0.06493985,
    "CMY_M": 0.2283779,
    "CMY_Y": 0.3430197,
    "CMYK_C": 0,
    "CMYK_M": 0.1747888,
    "CMYK_Y": 0.2973925,
    "CMYK_K": 0.06493985
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0023",
    "Farbtonhilfsbezeichnung": "D 305",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "180",
    "Bcolor": "147",
    "Y": 52,
    "L": 77.4965148314994,
    "a": 16.0167371808683,
    "b": 23.8048446975926,
    "C": 28.6915754359622,
    "h": 0.97853535722139,
    "CMY_C": 0.07883875,
    "CMY_M": 0.294475,
    "CMY_Y": 0.4233323,
    "CMYK_C": 0,
    "CMYK_M": 0.2340918,
    "CMYK_Y": 0.3739775,
    "CMYK_K": 0.07883875
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0024",
    "Farbtonhilfsbezeichnung": "D 405",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "179",
    "Bcolor": "137",
    "Y": 55,
    "L": 79.1884313626222,
    "a": 22.9388645860067,
    "b": 31.9209530923686,
    "C": 39.3082530115541,
    "h": 0.94768624710329,
    "CMY_C": 0.002311023,
    "CMY_M": 0.2974126,
    "CMY_Y": 0.4637188,
    "CMYK_C": 0,
    "CMYK_M": 0.2957852,
    "CMYK_Y": 0.4624765,
    "CMYK_K": 0.002311023
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0025",
    "Farbtonhilfsbezeichnung": "D 505",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "155",
    "Bcolor": "109",
    "Y": 42,
    "L": 71.2100369578134,
    "a": 25.9172735578822,
    "b": 35.7579390715902,
    "C": 44.1626004139436,
    "h": 0.94362072002113,
    "CMY_C": 0.07353739,
    "CMY_M": 0.3914599,
    "CMY_Y": 0.5709751,
    "CMYK_C": 0,
    "CMYK_M": 0.3431574,
    "CMYK_Y": 0.5369216,
    "CMYK_K": 0.07353739
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0026",
    "Farbtonhilfsbezeichnung": "D 106",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "218",
    "Bcolor": "196",
    "Y": 75,
    "L": 89.3440986555904,
    "a": 9.32850185708012,
    "b": 14.3302240912991,
    "C": 17.0990136968305,
    "h": 0.99374167277921,
    "CMY_C": 0.008212756,
    "CMY_M": 0.1459191,
    "CMY_Y": 0.2306949,
    "CMYK_C": 0,
    "CMYK_M": 0.1388466,
    "CMYK_Y": 0.2243245,
    "CMYK_K": 0.008212756
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0027",
    "Farbtonhilfsbezeichnung": "D 206",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "202",
    "Bcolor": "181",
    "Y": 64,
    "L": 83.9740369333946,
    "a": 10.6597140435443,
    "b": 14.4895540452926,
    "C": 17.9882372655463,
    "h": 0.93652144425377,
    "CMY_C": 0.0598569,
    "CMY_M": 0.2083043,
    "CMY_Y": 0.289069,
    "CMYK_C": 0,
    "CMYK_M": 0.1578987,
    "CMYK_Y": 0.2438056,
    "CMYK_K": 0.0598569
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0028",
    "Farbtonhilfsbezeichnung": "D 306",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "181",
    "Bcolor": "158",
    "Y": 52,
    "L": 77.0887396161936,
    "a": 13.5007326875841,
    "b": 17.0566235462356,
    "C": 21.7531190843888,
    "h": 0.90124487961462,
    "CMY_C": 0.1130996,
    "CMY_M": 0.2906119,
    "CMY_Y": 0.3793825,
    "CMYK_C": 0,
    "CMYK_M": 0.2001491,
    "CMYK_Y": 0.3002399,
    "CMYK_K": 0.1130996
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0029",
    "Farbtonhilfsbezeichnung": "D 406",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "161",
    "Bcolor": "134",
    "Y": 41,
    "L": 70.4830749479967,
    "a": 16.929360131941,
    "b": 20.7841641021337,
    "C": 26.8064304207289,
    "h": 0.88725719892177,
    "CMY_C": 0.1586316,
    "CMY_M": 0.3704766,
    "CMY_Y": 0.4728288,
    "CMYK_C": 0,
    "CMYK_M": 0.2517863,
    "CMYK_Y": 0.3734359,
    "CMYK_K": 0.1586316
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0030",
    "Farbtonhilfsbezeichnung": "D 506",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "133",
    "Bcolor": "108",
    "Y": 29,
    "L": 60.4092299647432,
    "a": 18.7277149268922,
    "b": 21.5131718253241,
    "C": 28.522690412527,
    "h": 0.85450749894599,
    "CMY_C": 0.2596127,
    "CMY_M": 0.4794172,
    "CMY_Y": 0.5772337,
    "CMYK_C": 0,
    "CMYK_M": 0.2968778,
    "CMYK_Y": 0.4289931,
    "CMYK_K": 0.2596127
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0031",
    "Farbtonhilfsbezeichnung": "D 107",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "220",
    "Bcolor": "209",
    "Y": 74,
    "L": 88.8790813315429,
    "a": 5.11669743300303,
    "b": 6.97410535561171,
    "C": 8.64978254825355,
    "h": 0.93782807834023,
    "CMY_C": 0.06367489,
    "CMY_M": 0.1385371,
    "CMY_Y": 0.1821253,
    "CMYK_C": 0,
    "CMYK_M": 0.07995326,
    "CMYK_Y": 0.1265057,
    "CMYK_K": 0.06367489
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0032",
    "Farbtonhilfsbezeichnung": "D 207",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "190",
    "Bcolor": "184",
    "Y": 55,
    "L": 79.2664328806028,
    "a": 9.6515920033905,
    "b": 5.83049091039722,
    "C": 11.2759856534201,
    "h": 0.54342603489651,
    "CMY_C": 0.1417416,
    "CMY_M": 0.2544985,
    "CMY_Y": 0.2765828,
    "CMYK_C": 0,
    "CMYK_M": 0.1313787,
    "CMYK_Y": 0.1571103,
    "CMYK_K": 0.1417416
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0033",
    "Farbtonhilfsbezeichnung": "D 307",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "168",
    "Bcolor": "163",
    "Y": 43,
    "L": 71.7541706376515,
    "a": 11.4409018622043,
    "b": 6.61406634311161,
    "C": 13.2151469538432,
    "h": 0.52416619605731,
    "CMY_C": 0.2103198,
    "CMY_M": 0.3393201,
    "CMY_Y": 0.3609037,
    "CMYK_C": 0,
    "CMYK_M": 0.1633576,
    "CMYK_Y": 0.1906897,
    "CMYK_K": 0.2103198
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0034",
    "Farbtonhilfsbezeichnung": "D 407",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "156",
    "Bcolor": "145",
    "Y": 38,
    "L": 67.8995165410856,
    "a": 14.2333588801452,
    "b": 10.8234747536921,
    "C": 17.8811663700894,
    "h": 0.65014303279487,
    "CMY_C": 0.2244025,
    "CMY_M": 0.3879651,
    "CMY_Y": 0.429599,
    "CMYK_C": 0,
    "CMYK_M": 0.2108859,
    "CMYK_Y": 0.2645657,
    "CMYK_K": 0.2244025
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0035",
    "Farbtonhilfsbezeichnung": "D 507",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "123",
    "Bcolor": "107",
    "Y": 24,
    "L": 56.1407285042051,
    "a": 18.0831187575858,
    "b": 15.6883191133773,
    "C": 23.9399778739269,
    "h": 0.71460468311662,
    "CMY_C": 0.3200545,
    "CMY_M": 0.5194193,
    "CMY_Y": 0.5790406,
    "CMYK_C": 0,
    "CMYK_M": 0.293207,
    "CMYK_Y": 0.3808925,
    "CMYK_K": 0.3200545
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0036",
    "Farbtonhilfsbezeichnung": "D 108",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "221",
    "Bcolor": "217",
    "Y": 76,
    "L": 89.7239759899625,
    "a": 7.3251664244518,
    "b": 3.76050985855414,
    "C": 8.23404502915784,
    "h": 0.47428513973844,
    "CMY_C": 0.04729063,
    "CMY_M": 0.1337958,
    "CMY_Y": 0.1488789,
    "CMYK_C": 0,
    "CMYK_M": 0.09079907,
    "CMYK_Y": 0.1066309,
    "CMYK_K": 0.04729063
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0037",
    "Farbtonhilfsbezeichnung": "D 208",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "185",
    "Bcolor": "182",
    "Y": 54,
    "L": 78.1914406692799,
    "a": 13.4123000425173,
    "b": 5.55348417477073,
    "C": 14.5165760050343,
    "h": 0.39256718744281,
    "CMY_C": 0.1284208,
    "CMY_M": 0.2756185,
    "CMY_Y": 0.2854496,
    "CMYK_C": 0,
    "CMYK_M": 0.1688862,
    "CMYK_Y": 0.1801658,
    "CMYK_K": 0.1284208
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0038",
    "Farbtonhilfsbezeichnung": "D 308",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "160",
    "Bcolor": "159",
    "Y": 42,
    "L": 70.5972238317805,
    "a": 19.8160628576787,
    "b": 7.58404921531535,
    "C": 21.2177790939532,
    "h": 0.36552366093399,
    "CMY_C": 0.1660765,
    "CMY_M": 0.373908,
    "CMY_Y": 0.3783969,
    "CMYK_C": 0,
    "CMYK_M": 0.2492213,
    "CMYK_Y": 0.2546041,
    "CMYK_K": 0.1660765
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0039",
    "Farbtonhilfsbezeichnung": "D 408",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "137",
    "Bcolor": "135",
    "Y": 32,
    "L": 63.3892145327581,
    "a": 24.8747066520524,
    "b": 10.6456817338298,
    "C": 27.0570059430761,
    "h": 0.40438539098954,
    "CMY_C": 0.2091824,
    "CMY_M": 0.463911,
    "CMY_Y": 0.4722044,
    "CMYK_C": 0,
    "CMYK_M": 0.3221079,
    "CMYK_Y": 0.3325951,
    "CMYK_K": 0.2091824
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0040",
    "Farbtonhilfsbezeichnung": "D 508",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "115",
    "Bcolor": "115",
    "Y": 21,
    "L": 52.5403953545403,
    "a": 16.5441211071063,
    "b": 6.14553936738975,
    "C": 17.6486712622435,
    "h": 0.35566669679018,
    "CMY_C": 0.3859333,
    "CMY_M": 0.5488297,
    "CMY_Y": 0.5507003,
    "CMYK_C": 0,
    "CMYK_M": 0.2652749,
    "CMYK_Y": 0.2683211,
    "CMYK_K": 0.3859333
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0041",
    "Farbtonhilfsbezeichnung": "D 109",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 65,
    "L": 84.4500151915283,
    "a": 7.05359399352606,
    "b": -1.10174351482155,
    "C": 7.13911948337877,
    "h": -0.15494407650948,
    "CMY_C": 0.1233986,
    "CMY_M": 0.1897653,
    "CMY_Y": 0.1709942,
    "CMYK_C": 0,
    "CMYK_M": 0.07570907,
    "CMYK_Y": 0.05429567,
    "CMYK_K": 0.1233986
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0042",
    "Farbtonhilfsbezeichnung": "D 209",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "190",
    "Bcolor": "197",
    "Y": 54,
    "L": 78.5659436425142,
    "a": 8.27693751406883,
    "b": -2.09022091926279,
    "C": 8.53678616946235,
    "h": -0.24736363025683,
    "CMY_C": 0.1824055,
    "CMY_M": 0.2563625,
    "CMY_Y": 0.2274748,
    "CMYK_C": 0,
    "CMYK_M": 0.09045683,
    "CMYK_Y": 0.05512423,
    "CMYK_K": 0.1824055
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0043",
    "Farbtonhilfsbezeichnung": "D 309",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "169",
    "Bcolor": "180",
    "Y": 43,
    "L": 71.2518876496398,
    "a": 10.0394149063993,
    "b": -3.77498569543144,
    "C": 10.7256873282575,
    "h": -0.3596615539073,
    "CMY_C": 0.2544697,
    "CMY_M": 0.3381656,
    "CMY_Y": 0.2934145,
    "CMYK_C": 0,
    "CMYK_M": 0.1122636,
    "CMYK_Y": 0.05223772,
    "CMYK_K": 0.2544697
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0044",
    "Farbtonhilfsbezeichnung": "D 409",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "143",
    "Bcolor": "155",
    "Y": 30,
    "L": 61.5080666238739,
    "a": 10.6790925176566,
    "b": -4.07143507540226,
    "C": 11.4288932348625,
    "h": -0.36424137057612,
    "CMY_C": 0.3546554,
    "CMY_M": 0.4408677,
    "CMY_Y": 0.3930849,
    "CMYK_C": 0,
    "CMYK_M": 0.1335911,
    "CMYK_Y": 0.05954878,
    "CMYK_K": 0.3546554
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0045",
    "Farbtonhilfsbezeichnung": "D 509",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "135",
    "Bcolor": "146",
    "Y": 26,
    "L": 58.4793716057604,
    "a": 10.0002987156659,
    "b": -3.70577692575542,
    "C": 10.6648374120758,
    "h": -0.35487822034073,
    "CMY_C": 0.3898591,
    "CMY_M": 0.4701421,
    "CMY_Y": 0.4266821,
    "CMYK_C": 0,
    "CMYK_M": 0.1315811,
    "CMYK_Y": 0.06035164,
    "CMYK_K": 0.3898591
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0046",
    "Farbtonhilfsbezeichnung": "D 110",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "211",
    "Bcolor": "228",
    "Y": 66,
    "L": 85.2465967908989,
    "a": 4.19335367264423,
    "b": -8.68719053372775,
    "C": 9.646320251431,
    "h": -1.12107988640331,
    "CMY_C": 0.1628585,
    "CMY_M": 0.1717237,
    "CMY_Y": 0.1073576,
    "CMYK_C": 0.06217597,
    "CMYK_M": 0.07210741,
    "CMYK_Y": 0,
    "CMYK_K": 0.1073576
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0047",
    "Farbtonhilfsbezeichnung": "D 210",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "194",
    "Bcolor": "219",
    "Y": 55,
    "L": 79.227771401355,
    "a": 5.76181304173917,
    "b": -13.4154666592934,
    "C": 14.6004532537373,
    "h": -1.16512849571126,
    "CMY_C": 0.2343109,
    "CMY_M": 0.2395242,
    "CMY_Y": 0.1393282,
    "CMYK_C": 0.1103588,
    "CMYK_M": 0.1164161,
    "CMYK_Y": 0,
    "CMYK_K": 0.1393282
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0048",
    "Farbtonhilfsbezeichnung": "D 310",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "170",
    "Bcolor": "196",
    "Y": 42,
    "L": 70.8178779152688,
    "a": 6.68280882624817,
    "b": -13.2045567897199,
    "C": 14.7993328843269,
    "h": -1.10228168138983,
    "CMY_C": 0.3165285,
    "CMY_M": 0.3315983,
    "CMY_Y": 0.2322625,
    "CMYK_C": 0.1097589,
    "CMYK_M": 0.1293877,
    "CMYK_Y": 0,
    "CMYK_K": 0.2322625
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0049",
    "Farbtonhilfsbezeichnung": "D 410",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "148",
    "Bcolor": "167",
    "Y": 31,
    "L": 62.1648095704868,
    "a": 4.93535097748205,
    "b": -10.2342783878988,
    "C": 11.3621363920676,
    "h": -1.12145957169539,
    "CMY_C": 0.4093538,
    "CMY_M": 0.4185986,
    "CMY_Y": 0.344896,
    "CMYK_C": 0.09839309,
    "CMYK_M": 0.1125052,
    "CMYK_Y": 0,
    "CMYK_K": 0.344896
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0050",
    "Farbtonhilfsbezeichnung": "D 510",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "123",
    "Bcolor": "145",
    "Y": 21,
    "L": 52.4838301960131,
    "a": 5.64887963361627,
    "b": -12.007297017186,
    "C": 13.2697031908784,
    "h": -1.13106373477956,
    "CMY_C": 0.5091265,
    "CMY_M": 0.5175692,
    "CMY_Y": 0.4327948,
    "CMYK_C": 0.1345751,
    "CMYK_M": 0.1494598,
    "CMYK_Y": 0,
    "CMYK_K": 0.4327948
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0051",
    "Farbtonhilfsbezeichnung": "D 111",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "209",
    "Bcolor": "227",
    "Y": 64,
    "L": 83.9320774392385,
    "a": 2.02467750924967,
    "b": -10.5981842671883,
    "C": 10.7898484131029,
    "h": -1.38203077268343,
    "CMY_C": 0.20213,
    "CMY_M": 0.1803541,
    "CMY_Y": 0.1082496,
    "CMYK_C": 0.1052765,
    "CMYK_M": 0.0808572,
    "CMYK_Y": 0,
    "CMYK_K": 0.1082496
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0052",
    "Farbtonhilfsbezeichnung": "D 211",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "192",
    "Bcolor": "224",
    "Y": 53,
    "L": 78.1230085936275,
    "a": 4.12850510637586,
    "b": -17.5698195915567,
    "C": 18.0483549082242,
    "h": -1.34000607606013,
    "CMY_C": 0.2768351,
    "CMY_M": 0.2461441,
    "CMY_Y": 0.1218407,
    "CMYK_C": 0.1764992,
    "CMYK_M": 0.1415499,
    "CMYK_Y": 0,
    "CMYK_K": 0.1218407
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0053",
    "Farbtonhilfsbezeichnung": "D 311",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "175",
    "Bcolor": "194",
    "Y": 43,
    "L": 71.6849619407522,
    "a": 2.86361854498934,
    "b": -11.1231926614471,
    "C": 11.4858924840378,
    "h": -1.31882227993299,
    "CMY_C": 0.3291864,
    "CMY_M": 0.3141482,
    "CMY_Y": 0.238017,
    "CMYK_C": 0.1196476,
    "CMYK_M": 0.09991195,
    "CMYK_Y": 0,
    "CMYK_K": 0.238017
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0054",
    "Farbtonhilfsbezeichnung": "D 411",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "149",
    "Bcolor": "177",
    "Y": 31,
    "L": 62.149153253705,
    "a": 3.88593987609026,
    "b": -16.1547270762951,
    "C": 16.6155269441018,
    "h": -1.3347360306134,
    "CMY_C": 0.4412142,
    "CMY_M": 0.4144414,
    "CMY_Y": 0.3046181,
    "CMYK_C": 0.1964332,
    "CMYK_M": 0.1579324,
    "CMYK_Y": 0,
    "CMYK_K": 0.3046181
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0055",
    "Farbtonhilfsbezeichnung": "D 511",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "125",
    "Bcolor": "157",
    "Y": 21,
    "L": 52.909359727708,
    "a": 5.89030387278877,
    "b": -18.6219338631163,
    "C": 19.5313107731168,
    "h": -1.26444420256631,
    "CMY_C": 0.529994,
    "CMY_M": 0.5116611,
    "CMY_Y": 0.3844621,
    "CMYK_C": 0.2364305,
    "CMYK_M": 0.2066468,
    "CMYK_Y": 0,
    "CMYK_K": 0.3844621
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0056",
    "Farbtonhilfsbezeichnung": "D 112",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "208",
    "Bcolor": "220",
    "Y": 62,
    "L": 83.0793007412703,
    "a": -1.07153321989589,
    "b": -7.7832801848162,
    "C": 7.8566935715155,
    "h": 1.43398518309394,
    "CMY_C": 0.2256911,
    "CMY_M": 0.1833613,
    "CMY_Y": 0.1385005,
    "CMYK_C": 0.1012078,
    "CMYK_M": 0.05207291,
    "CMYK_Y": 0,
    "CMYK_K": 0.1385005
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0057",
    "Farbtonhilfsbezeichnung": "D 212",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "198",
    "Bcolor": "224",
    "Y": 55,
    "L": 79.2333415783092,
    "a": -0.48341745125396,
    "b": -15.9058248631548,
    "C": 15.9131692949435,
    "h": 1.54041320028827,
    "CMY_C": 0.2966241,
    "CMY_M": 0.2240113,
    "CMY_Y": 0.1220579,
    "CMYK_C": 0.1988357,
    "CMYK_M": 0.1161278,
    "CMYK_Y": 0,
    "CMYK_K": 0.1220579
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0058",
    "Farbtonhilfsbezeichnung": "D 312",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "175",
    "Bcolor": "201",
    "Y": 42,
    "L": 70.8656922911276,
    "a": -0.44058277720832,
    "b": -16.2039643954741,
    "C": 16.2099529707327,
    "h": 1.54361321022117,
    "CMY_C": 0.3866429,
    "CMY_M": 0.3136977,
    "CMY_Y": 0.2114316,
    "CMYK_C": 0.2221891,
    "CMYK_M": 0.1296858,
    "CMYK_Y": 0,
    "CMYK_K": 0.2114316
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0059",
    "Farbtonhilfsbezeichnung": "D 412",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "151",
    "Bcolor": "182",
    "Y": 31,
    "L": 62.0902208919873,
    "a": 0.72854461563859,
    "b": -19.1673509026692,
    "C": 19.1811917743145,
    "h": -1.53280494906542,
    "CMY_C": 0.4819447,
    "CMY_M": 0.4070053,
    "CMY_Y": 0.2848802,
    "CMYK_C": 0.2755685,
    "CMYK_M": 0.1707757,
    "CMYK_Y": 0,
    "CMYK_K": 0.2848802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0060",
    "Farbtonhilfsbezeichnung": "D 512",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "125",
    "Bcolor": "146",
    "Y": 20,
    "L": 51.9235684072963,
    "a": 0.64439693307966,
    "b": -13.588198601378,
    "C": 13.6034697278986,
    "h": -1.52340855105793,
    "CMY_C": 0.5595648,
    "CMY_M": 0.5117089,
    "CMY_Y": 0.428545,
    "CMYK_C": 0.2292741,
    "CMYK_M": 0.14553,
    "CMYK_Y": 0,
    "CMYK_K": 0.428545
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0061",
    "Farbtonhilfsbezeichnung": "D 113",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "213",
    "Bcolor": "224",
    "Y": 64,
    "L": 84.0756419429617,
    "a": -3.75496466263991,
    "b": -8.42693395463499,
    "C": 9.22566937915372,
    "h": 1.15161509701725,
    "CMY_C": 0.2399394,
    "CMY_M": 0.1661279,
    "CMY_Y": 0.1231746,
    "CMYK_C": 0.1331677,
    "CMYK_M": 0.0489873,
    "CMYK_Y": 0,
    "CMYK_K": 0.1231746
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0062",
    "Farbtonhilfsbezeichnung": "D 213",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "199",
    "Bcolor": "214",
    "Y": 55,
    "L": 78.7980423860654,
    "a": -4.53476118203272,
    "b": -11.1756517476048,
    "C": 12.0606488615586,
    "h": 1.18532442570479,
    "CMY_C": 0.3152377,
    "CMY_M": 0.2211889,
    "CMY_Y": 0.1613467,
    "CMYK_C": 0.1834977,
    "CMYK_M": 0.07135507,
    "CMYK_Y": 0,
    "CMYK_K": 0.1613467
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0063",
    "Farbtonhilfsbezeichnung": "D 313",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "179",
    "Bcolor": "202",
    "Y": 43,
    "L": 71.6017604361087,
    "a": -4.1927651878314,
    "b": -15.8722722589813,
    "C": 16.4167081530835,
    "h": 1.31253883620297,
    "CMY_C": 0.4103195,
    "CMY_M": 0.2977886,
    "CMY_Y": 0.206196,
    "CMYK_C": 0.257146,
    "CMYK_M": 0.1153844,
    "CMYK_Y": 0,
    "CMYK_K": 0.206196
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0064",
    "Farbtonhilfsbezeichnung": "D 413",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "158",
    "Bcolor": "185",
    "Y": 32,
    "L": 63.5357787033849,
    "a": -4.15592503101697,
    "b": -18.6798955161173,
    "C": 19.1366195906302,
    "h": 1.35188063137969,
    "CMY_C": 0.5084448,
    "CMY_M": 0.3817885,
    "CMY_Y": 0.2733155,
    "CMYK_C": 0.3235644,
    "CMYK_M": 0.149271,
    "CMYK_Y": 0,
    "CMYK_K": 0.2733155
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0065",
    "Farbtonhilfsbezeichnung": "D 513",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "134",
    "Bcolor": "164",
    "Y": 22,
    "L": 54.4000147298142,
    "a": -4.54524210330121,
    "b": -20.5399523039749,
    "C": 21.0368454485739,
    "h": 1.35301794850871,
    "CMY_C": 0.6164815,
    "CMY_M": 0.4739427,
    "CMY_Y": 0.3571014,
    "CMYK_C": 0.403454,
    "CMYK_M": 0.1817413,
    "CMYK_Y": 0,
    "CMYK_K": 0.3571014
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0066",
    "Farbtonhilfsbezeichnung": "D 114",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "215",
    "Bcolor": "232",
    "Y": 66,
    "L": 84.910520611097,
    "a": -4.09704054080357,
    "b": -11.9528692641772,
    "C": 12.6355381697615,
    "h": 1.24058027898077,
    "CMY_C": 0.248966,
    "CMY_M": 0.1550705,
    "CMY_Y": 0.08824915,
    "CMYK_C": 0.1762728,
    "CMYK_M": 0.07328904,
    "CMYK_Y": 0,
    "CMYK_K": 0.08824915
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0067",
    "Farbtonhilfsbezeichnung": "D 214",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "203",
    "Bcolor": "224",
    "Y": 57,
    "L": 80.2238290826359,
    "a": -4.71208999769535,
    "b": -14.6816099926618,
    "C": 15.4192562765851,
    "h": 1.26023017987562,
    "CMY_C": 0.3175925,
    "CMY_M": 0.2041804,
    "CMY_Y": 0.1204211,
    "CMYK_C": 0.2241657,
    "CMYK_M": 0.09522649,
    "CMYK_Y": 0,
    "CMYK_K": 0.1204211
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0068",
    "Farbtonhilfsbezeichnung": "D 314",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "180",
    "Bcolor": "214",
    "Y": 43,
    "L": 71.7296594571767,
    "a": -5.14641907603219,
    "b": -21.8705003344945,
    "C": 22.467852905591,
    "h": 1.3396875065875,
    "CMY_C": 0.4497562,
    "CMY_M": 0.2923704,
    "CMY_Y": 0.1624792,
    "CMYK_C": 0.3430088,
    "CMYK_M": 0.1550902,
    "CMYK_Y": 0,
    "CMYK_K": 0.1624792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0069",
    "Farbtonhilfsbezeichnung": "D 414",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "157",
    "Bcolor": "194",
    "Y": 31,
    "L": 62.7794158337588,
    "a": -4.96183042631243,
    "b": -24.6572558496675,
    "C": 25.151541249304,
    "h": 1.37221637357459,
    "CMY_C": 0.5597047,
    "CMY_M": 0.3859045,
    "CMY_Y": 0.2401966,
    "CMYK_C": 0.4205141,
    "CMYK_M": 0.1917705,
    "CMYK_Y": 0,
    "CMYK_K": 0.2401966
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0070",
    "Farbtonhilfsbezeichnung": "D 514",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "134",
    "Bcolor": "173",
    "Y": 22,
    "L": 53.7901482056956,
    "a": -5.58216069305362,
    "b": -26.6363796911962,
    "C": 27.2150186672109,
    "h": 1.36421691954182,
    "CMY_C": 0.6763718,
    "CMY_M": 0.4758815,
    "CMY_Y": 0.3226044,
    "CMYK_C": 0.5222463,
    "CMYK_M": 0.2262742,
    "CMYK_Y": 0,
    "CMYK_K": 0.3226044
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0071",
    "Farbtonhilfsbezeichnung": "D 115",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "227",
    "Bcolor": "234",
    "Y": 73,
    "L": 88.4189545270563,
    "a": -8.28307480769308,
    "b": -7.73265468561204,
    "C": 11.3315169662653,
    "h": 0.75104421335611,
    "CMY_C": 0.2291455,
    "CMY_M": 0.1081963,
    "CMY_Y": 0.08069196,
    "CMYK_C": 0.161484,
    "CMYK_M": 0.02991855,
    "CMYK_Y": 0,
    "CMYK_K": 0.08069196
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0072",
    "Farbtonhilfsbezeichnung": "D 215",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "211",
    "Bcolor": "227",
    "Y": 60,
    "L": 81.8925638739355,
    "a": -10.6126274588408,
    "b": -13.6948166155455,
    "C": 17.325584080012,
    "h": 0.91152528372223,
    "CMY_C": 0.3496787,
    "CMY_M": 0.1735227,
    "CMY_Y": 0.1097723,
    "CMYK_C": 0.2694888,
    "CMYK_M": 0.07161134,
    "CMYK_Y": 0,
    "CMYK_K": 0.1097723
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0073",
    "Farbtonhilfsbezeichnung": "D 315",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "185",
    "Bcolor": "206",
    "Y": 44,
    "L": 72.4797312162038,
    "a": -9.92888083612326,
    "b": -16.354221345358,
    "C": 19.1322562828041,
    "h": 1.02516217424321,
    "CMY_C": 0.4577244,
    "CMY_M": 0.2762265,
    "CMY_Y": 0.1938532,
    "CMYK_C": 0.3273239,
    "CMYK_M": 0.1021815,
    "CMYK_Y": 0,
    "CMYK_K": 0.1938532
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0074",
    "Farbtonhilfsbezeichnung": "D 415",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "164",
    "Bcolor": "186",
    "Y": 34,
    "L": 64.9250959490182,
    "a": -10.4356221229172,
    "b": -17.1488746662136,
    "C": 20.0745139769266,
    "h": 1.02412762236675,
    "CMY_C": 0.546874,
    "CMY_M": 0.3550519,
    "CMY_Y": 0.269698,
    "CMYK_C": 0.3795362,
    "CMYK_M": 0.1168748,
    "CMYK_Y": 0,
    "CMYK_K": 0.269698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0075",
    "Farbtonhilfsbezeichnung": "D 515",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "148",
    "Bcolor": "171",
    "Y": 27,
    "L": 58.8653718392503,
    "a": -9.92317047887514,
    "b": -17.9541506058411,
    "C": 20.5139181125899,
    "h": 1.06588632127104,
    "CMY_C": 0.6095851,
    "CMY_M": 0.4187582,
    "CMY_Y": 0.3283018,
    "CMYK_C": 0.4187644,
    "CMYK_M": 0.1346682,
    "CMYK_Y": 0,
    "CMYK_K": 0.3283018
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0076",
    "Farbtonhilfsbezeichnung": "D 116",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 63,
    "L": 83.4888159098592,
    "a": -10.7280751915774,
    "b": -7.34186148541154,
    "C": 12.9997895131847,
    "h": 0.60015176035806,
    "CMY_C": 0.3028654,
    "CMY_M": 0.1576505,
    "CMY_Y": 0.1383765,
    "CMYK_C": 0.1909058,
    "CMYK_M": 0.02236939,
    "CMYK_Y": 0,
    "CMYK_K": 0.1383765
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0077",
    "Farbtonhilfsbezeichnung": "D 216",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "205",
    "Bcolor": "212",
    "Y": 56,
    "L": 79.4682593699766,
    "a": -13.1429751057857,
    "b": -9.39393887950404,
    "C": 16.1549955835079,
    "h": 0.62055672111595,
    "CMY_C": 0.3781887,
    "CMY_M": 0.196139,
    "CMY_Y": 0.1678332,
    "CMYK_C": 0.2527804,
    "CMYK_M": 0.03401464,
    "CMYK_Y": 0,
    "CMYK_K": 0.1678332
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0078",
    "Farbtonhilfsbezeichnung": "D 316",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "182",
    "Bcolor": "192",
    "Y": 43,
    "L": 71.7008652855788,
    "a": -10.9147969879629,
    "b": -9.92612880878441,
    "C": 14.7533327223724,
    "h": 0.73799491734853,
    "CMY_C": 0.4417918,
    "CMY_M": 0.2845382,
    "CMY_Y": 0.2478386,
    "CMYK_C": 0.2578611,
    "CMYK_M": 0.04879221,
    "CMYK_Y": 0,
    "CMYK_K": 0.2478386
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0079",
    "Farbtonhilfsbezeichnung": "D 416",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "155",
    "Bcolor": "167",
    "Y": 30,
    "L": 61.5101419801832,
    "a": -10.8258207468023,
    "b": -11.6995859134127,
    "C": 15.9398464668648,
    "h": 0.82416893141635,
    "CMY_C": 0.5552148,
    "CMY_M": 0.3916121,
    "CMY_Y": 0.3433936,
    "CMYK_C": 0.3225999,
    "CMYK_M": 0.07343587,
    "CMYK_Y": 0,
    "CMYK_K": 0.3433936
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0080",
    "Farbtonhilfsbezeichnung": "D 516",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "132",
    "Bcolor": "141",
    "Y": 20,
    "L": 52.1017221351924,
    "a": -13.9931994632238,
    "b": -10.4691230204818,
    "C": 17.4760455491381,
    "h": 0.64232113553925,
    "CMY_C": 0.6753682,
    "CMY_M": 0.4824367,
    "CMY_Y": 0.4488459,
    "CMYK_C": 0.4109963,
    "CMYK_M": 0.06094633,
    "CMYK_Y": 0,
    "CMYK_K": 0.4488459
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0081",
    "Farbtonhilfsbezeichnung": "D 117",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "228",
    "Bcolor": "227",
    "Y": 73,
    "L": 88.2693911179139,
    "a": -11.5308525426095,
    "b": -3.82116632114224,
    "C": 12.147504781363,
    "h": 0.31999718338136,
    "CMY_C": 0.2428541,
    "CMY_M": 0.1039471,
    "CMY_Y": 0.1115739,
    "CMYK_C": 0.155021,
    "CMYK_M": 0,
    "CMYK_Y": 0.008511508,
    "CMYK_K": 0.1039471
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0082",
    "Farbtonhilfsbezeichnung": "D 217",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "205",
    "Bcolor": "210",
    "Y": 54,
    "L": 78.5506119168494,
    "a": -18.3716341757651,
    "b": -9.4723660398252,
    "C": 20.6698490725156,
    "h": 0.47604749355287,
    "CMY_C": 0.4406716,
    "CMY_M": 0.1956784,
    "CMY_Y": 0.1778584,
    "CMYK_C": 0.319669,
    "CMYK_M": 0.02167512,
    "CMYK_Y": 0,
    "CMYK_K": 0.1778584
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0083",
    "Farbtonhilfsbezeichnung": "D 317",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "185",
    "Bcolor": "191",
    "Y": 42,
    "L": 71.2048116335763,
    "a": -17.8395488186877,
    "b": -10.4813658023837,
    "C": 20.690783724589,
    "h": 0.5312039084357,
    "CMY_C": 0.51904,
    "CMY_M": 0.2760924,
    "CMY_Y": 0.2499719,
    "CMYK_C": 0.358744,
    "CMYK_M": 0.03482595,
    "CMYK_Y": 0,
    "CMYK_K": 0.2499719
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0084",
    "Farbtonhilfsbezeichnung": "D 417",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "160",
    "Bcolor": "172",
    "Y": 30,
    "L": 61.746971457367,
    "a": -19.1208852880576,
    "b": -13.9089987815507,
    "C": 23.6446294389283,
    "h": 0.62889549077185,
    "CMY_C": 0.6573982,
    "CMY_M": 0.3730582,
    "CMY_Y": 0.3265522,
    "CMYK_C": 0.4912719,
    "CMYK_M": 0.06905654,
    "CMYK_Y": 0,
    "CMYK_K": 0.3265522
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0085",
    "Farbtonhilfsbezeichnung": "D 517",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "134",
    "Bcolor": "150",
    "Y": 20,
    "L": 51.8063143182709,
    "a": -19.8284842033506,
    "b": -16.58783395344,
    "C": 25.8519829233546,
    "h": 0.69664299659674,
    "CMY_C": 0.8071922,
    "CMY_M": 0.4736096,
    "CMY_Y": 0.4116789,
    "CMYK_C": 0.6722746,
    "CMYK_M": 0.1052668,
    "CMYK_Y": 0,
    "CMYK_K": 0.4116789
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0086",
    "Farbtonhilfsbezeichnung": "D 119",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "218",
    "Bcolor": "204",
    "Y": 64,
    "L": 84.0422477446712,
    "a": -14.4806141332124,
    "b": 1.97428096528203,
    "C": 14.6145807673319,
    "h": -0.13550410458791,
    "CMY_C": 0.2907399,
    "CMY_M": 0.1462576,
    "CMY_Y": 0.2007389,
    "CMYK_C": 0.169234,
    "CMYK_M": 0,
    "CMYK_Y": 0.06381471,
    "CMYK_K": 0.1462576
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0087",
    "Farbtonhilfsbezeichnung": "D 219",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "202",
    "Bcolor": "189",
    "Y": 53,
    "L": 77.8443696890158,
    "a": -16.6441968418392,
    "b": 0.6766575801824,
    "C": 16.6579456713818,
    "h": -0.04063188927511,
    "CMY_C": 0.3815897,
    "CMY_M": 0.2096046,
    "CMY_Y": 0.2583081,
    "CMYK_C": 0.2175938,
    "CMYK_M": 0,
    "CMYK_Y": 0.06161923,
    "CMYK_K": 0.2096046
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0088",
    "Farbtonhilfsbezeichnung": "D 319",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "184",
    "Bcolor": "172",
    "Y": 43,
    "L": 71.3394053355233,
    "a": -16.7686264846376,
    "b": 0.2550559560507,
    "C": 16.7705661121504,
    "h": -0.01520913413253,
    "CMY_C": 0.4526412,
    "CMY_M": 0.2796307,
    "CMY_Y": 0.3242372,
    "CMYK_C": 0.2401692,
    "CMYK_M": 0,
    "CMYK_Y": 0.06192167,
    "CMYK_K": 0.2796307
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0089",
    "Farbtonhilfsbezeichnung": "D 419",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "163",
    "Bcolor": "154",
    "Y": 32,
    "L": 63.4496357391095,
    "a": -18.1974925905742,
    "b": -1.34531767554085,
    "C": 18.2471536474083,
    "h": 0.07379449388082,
    "CMY_C": 0.5544107,
    "CMY_M": 0.3603089,
    "CMY_Y": 0.3952541,
    "CMYK_C": 0.3034305,
    "CMYK_M": 0,
    "CMYK_Y": 0.05462815,
    "CMYK_K": 0.3603089
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0090",
    "Farbtonhilfsbezeichnung": "D 519",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "137",
    "Bcolor": "129",
    "Y": 21,
    "L": 53.1271314417366,
    "a": -21.5598368741201,
    "b": -2.37912159403701,
    "C": 21.6907073558674,
    "h": 0.10990503572966,
    "CMY_C": 0.6993203,
    "CMY_M": 0.4611449,
    "CMY_Y": 0.4931455,
    "CMYK_C": 0.4420027,
    "CMYK_M": 0,
    "CMYK_Y": 0.05938623,
    "CMYK_K": 0.4611449
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0091",
    "Farbtonhilfsbezeichnung": "D 120",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "229",
    "Bcolor": "210",
    "Y": 74,
    "L": 88.7414107183222,
    "a": -11.5639311739752,
    "b": 5.68396719715394,
    "C": 12.8853400147127,
    "h": -0.45684506436801,
    "CMY_C": 0.2005107,
    "CMY_M": 0.1012012,
    "CMY_Y": 0.1765317,
    "CMYK_C": 0.1104914,
    "CMYK_M": 0,
    "CMYK_Y": 0.08381239,
    "CMYK_K": 0.1012012
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0092",
    "Farbtonhilfsbezeichnung": "D 220",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "215",
    "Bcolor": "190",
    "Y": 61,
    "L": 82.4557130938308,
    "a": -17.5854583104568,
    "b": 7.00313277750342,
    "C": 18.9286083135596,
    "h": -0.37898330053432,
    "CMY_C": 0.3153773,
    "CMY_M": 0.1587125,
    "CMY_Y": 0.2549405,
    "CMYK_C": 0.1862203,
    "CMYK_M": 0,
    "CMYK_Y": 0.1143819,
    "CMYK_K": 0.1587125
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0093",
    "Farbtonhilfsbezeichnung": "D 320",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "198",
    "Bcolor": "171",
    "Y": 50,
    "L": 75.8607229425106,
    "a": -21.2858545062202,
    "b": 7.62319512361627,
    "C": 22.6097480293943,
    "h": -0.3439029745019,
    "CMY_C": 0.4160149,
    "CMY_M": 0.2239116,
    "CMY_Y": 0.3298224,
    "CMYK_C": 0.2475276,
    "CMYK_M": 0,
    "CMYK_Y": 0.1364674,
    "CMYK_K": 0.2239116
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0094",
    "Farbtonhilfsbezeichnung": "D 420",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "183",
    "Bcolor": "159",
    "Y": 42,
    "L": 71.0698256205744,
    "a": -18.6853719455342,
    "b": 7.24958766163688,
    "C": 20.042446108365,
    "h": -0.37010327949963,
    "CMY_C": 0.4439558,
    "CMY_M": 0.2805535,
    "CMY_Y": 0.3767608,
    "CMYK_C": 0.2271222,
    "CMYK_M": 0,
    "CMYK_Y": 0.133724,
    "CMYK_K": 0.2805535
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0095",
    "Farbtonhilfsbezeichnung": "D 520",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "162",
    "Bcolor": "137",
    "Y": 31,
    "L": 62.9138183872404,
    "a": -20.5888952554999,
    "b": 7.37038291639842,
    "C": 21.8683596132926,
    "h": -0.34376490363133,
    "CMY_C": 0.5439637,
    "CMY_M": 0.3636684,
    "CMY_Y": 0.4612233,
    "CMYK_C": 0.2833355,
    "CMYK_M": 0,
    "CMYK_Y": 0.1533083,
    "CMYK_K": 0.3636684
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0096",
    "Farbtonhilfsbezeichnung": "D 121",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "226",
    "Bcolor": "198",
    "Y": 73,
    "L": 88.231408043741,
    "a": -8.51296098285193,
    "b": 11.1734501606203,
    "C": 14.0469389258808,
    "h": -0.91972775401275,
    "CMY_C": 0.1625357,
    "CMY_M": 0.1149384,
    "CMY_Y": 0.2222015,
    "CMYK_C": 0.05377845,
    "CMYK_M": 0,
    "CMYK_Y": 0.1211928,
    "CMYK_K": 0.1149384
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0097",
    "Farbtonhilfsbezeichnung": "D 221",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "215",
    "Bcolor": "182",
    "Y": 64,
    "L": 83.9704767551917,
    "a": -11.3583768153286,
    "b": 13.7914101181634,
    "C": 17.8666089934932,
    "h": -0.88183975273068,
    "CMY_C": 0.2236192,
    "CMY_M": 0.1565469,
    "CMY_Y": 0.287554,
    "CMYK_C": 0.07952107,
    "CMYK_M": 0,
    "CMYK_Y": 0.1553223,
    "CMYK_K": 0.1565469
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0098",
    "Farbtonhilfsbezeichnung": "D 321",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "205",
    "Bcolor": "172",
    "Y": 57,
    "L": 80.2456616433416,
    "a": -12.3455712462638,
    "b": 13.3552279017156,
    "C": 18.1872274331009,
    "h": -0.8246630019916,
    "CMY_C": 0.273113,
    "CMY_M": 0.1952447,
    "CMY_Y": 0.3239072,
    "CMYK_C": 0.09676026,
    "CMYK_M": 0,
    "CMYK_Y": 0.1598777,
    "CMYK_K": 0.1952447
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0099",
    "Farbtonhilfsbezeichnung": "D 421",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "182",
    "Bcolor": "148",
    "Y": 43,
    "L": 71.328656841059,
    "a": -14.600411458215,
    "b": 13.4718541545221,
    "C": 19.8661236558593,
    "h": -0.74521793994741,
    "CMY_C": 0.3852704,
    "CMY_M": 0.2870958,
    "CMY_Y": 0.4176962,
    "CMYK_C": 0.1377109,
    "CMYK_M": 0,
    "CMYK_Y": 0.1831948,
    "CMYK_K": 0.2870958
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0100",
    "Farbtonhilfsbezeichnung": "D 521",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "157",
    "Bcolor": "124",
    "Y": 30,
    "L": 61.8794828845445,
    "a": -15.8241065449771,
    "b": 13.472440450633,
    "C": 20.7824204471626,
    "h": -0.70529880611913,
    "CMY_C": 0.4922336,
    "CMY_M": 0.3844936,
    "CMY_Y": 0.5131981,
    "CMYK_C": 0.1750429,
    "CMYK_M": 0,
    "CMYK_Y": 0.2091036,
    "CMYK_K": 0.3844936
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0101",
    "Farbtonhilfsbezeichnung": "D 122",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "209",
    "Y": 83,
    "L": 92.838327322535,
    "a": -7.18706000625868,
    "b": 12.2251640634821,
    "C": 14.1812717311466,
    "h": -1.03932832295883,
    "CMY_C": 0.09760861,
    "CMY_M": 0.06668933,
    "CMY_Y": 0.179848,
    "CMYK_C": 0.0331286,
    "CMYK_M": 0,
    "CMYK_Y": 0.1212444,
    "CMYK_K": 0.06668933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0102",
    "Farbtonhilfsbezeichnung": "D 222",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "212",
    "Bcolor": "163",
    "Y": 61,
    "L": 82.1283651361461,
    "a": -16.0266560815801,
    "b": 21.02211309345,
    "C": 26.4345029094752,
    "h": -0.91942447581056,
    "CMY_C": 0.2591957,
    "CMY_M": 0.1686425,
    "CMY_Y": 0.3608885,
    "CMYK_C": 0.1089222,
    "CMYK_M": 0,
    "CMYK_Y": 0.2312435,
    "CMYK_K": 0.1686425
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0103",
    "Farbtonhilfsbezeichnung": "D 322",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "200",
    "Bcolor": "146",
    "Y": 52,
    "L": 77.1437794921856,
    "a": -20.7161558949741,
    "b": 22.762230410633,
    "C": 30.7778857027512,
    "h": -0.83242304813535,
    "CMY_C": 0.3454672,
    "CMY_M": 0.2142376,
    "CMY_Y": 0.4260948,
    "CMYK_C": 0.1670091,
    "CMYK_M": 0,
    "CMYK_Y": 0.2696199,
    "CMYK_K": 0.2142376
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0104",
    "Farbtonhilfsbezeichnung": "D 422",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "184",
    "Bcolor": "126",
    "Y": 41,
    "L": 70.5030904715634,
    "a": -24.404330321851,
    "b": 24.1497189494885,
    "C": 34.333369537482,
    "h": -0.7801543363133,
    "CMY_C": 0.4418404,
    "CMY_M": 0.2794628,
    "CMY_Y": 0.5042369,
    "CMYK_C": 0.2253563,
    "CMYK_M": 0,
    "CMYK_Y": 0.3119535,
    "CMYK_K": 0.2794628
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0105",
    "Farbtonhilfsbezeichnung": "D 522",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "153",
    "Bcolor": "105",
    "Y": 27,
    "L": 59.4321295912734,
    "a": -21.5009526061702,
    "b": 20.8522579970499,
    "C": 29.9517549827771,
    "h": -0.77008305784935,
    "CMY_C": 0.540695,
    "CMY_M": 0.4010606,
    "CMY_Y": 0.5894766,
    "CMYK_C": 0.2331361,
    "CMYK_M": 0,
    "CMYK_Y": 0.3145829,
    "CMYK_K": 0.4010606
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0106",
    "Farbtonhilfsbezeichnung": "D 123",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "224",
    "Bcolor": "192",
    "Y": 73,
    "L": 88.3225495468736,
    "a": -5.83850564837579,
    "b": 14.5123795461378,
    "C": 15.6428037223918,
    "h": -1.18829836491812,
    "CMY_C": 0.1305024,
    "CMY_M": 0.1207203,
    "CMY_Y": 0.2455174,
    "CMYK_C": 0.01112518,
    "CMYK_M": 0,
    "CMYK_Y": 0.1419311,
    "CMYK_K": 0.1207203
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0107",
    "Farbtonhilfsbezeichnung": "D 223",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "210",
    "Bcolor": "172",
    "Y": 61,
    "L": 82.5848396455791,
    "a": -8.98027278904573,
    "b": 17.208418076027,
    "C": 19.4106916941414,
    "h": -1.08981917148004,
    "CMY_C": 0.2100756,
    "CMY_M": 0.177678,
    "CMY_Y": 0.3269025,
    "CMYK_C": 0.03939772,
    "CMYK_M": 0,
    "CMYK_Y": 0.1814672,
    "CMYK_K": 0.177678
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0108",
    "Farbtonhilfsbezeichnung": "D 323",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "158",
    "Y": 56,
    "L": 79.3740215068587,
    "a": -9.12800718296303,
    "b": 19.7581056057582,
    "C": 21.7647249525584,
    "h": -1.13801804075317,
    "CMY_C": 0.2392104,
    "CMY_M": 0.2129721,
    "CMY_Y": 0.379156,
    "CMYK_C": 0.03333839,
    "CMYK_M": 0,
    "CMYK_Y": 0.2111537,
    "CMYK_K": 0.2129721
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0109",
    "Farbtonhilfsbezeichnung": "D 423",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "178",
    "Bcolor": "140",
    "Y": 42,
    "L": 71.0406723714023,
    "a": -9.64139586686697,
    "b": 17.7151195151032,
    "C": 20.1688366966474,
    "h": -1.07238094190075,
    "CMY_C": 0.3378263,
    "CMY_M": 0.30111,
    "CMY_Y": 0.4501013,
    "CMYK_C": 0.05253519,
    "CMYK_M": 0,
    "CMYK_Y": 0.2131828,
    "CMYK_K": 0.30111
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0110",
    "Farbtonhilfsbezeichnung": "D 523",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "153",
    "Bcolor": "114",
    "Y": 30,
    "L": 61.5654553440845,
    "a": -10.2131920563895,
    "b": 18.895823034238,
    "C": 21.47932541124,
    "h": -1.07527603952409,
    "CMY_C": 0.4379177,
    "CMY_M": 0.399623,
    "CMY_Y": 0.5531442,
    "CMYK_C": 0.06378447,
    "CMYK_M": 0,
    "CMYK_Y": 0.2557081,
    "CMYK_K": 0.399623
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0111",
    "Farbtonhilfsbezeichnung": "D 124",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "236",
    "Bcolor": "198",
    "Y": 82,
    "L": 92.6323396972381,
    "a": -5.56780871797907,
    "b": 17.690552500527,
    "C": 18.5460546126098,
    "h": -1.26587800473117,
    "CMY_C": 0.07118886,
    "CMY_M": 0.07401287,
    "CMY_Y": 0.2227299,
    "CMYK_C": 0,
    "CMYK_M": 0.003040457,
    "CMYK_Y": 0.1631559,
    "CMYK_K": 0.07118886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0112",
    "Farbtonhilfsbezeichnung": "D 224",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "226",
    "Bcolor": "171",
    "Y": 73,
    "L": 88.6610312566452,
    "a": -8.68359570015065,
    "b": 26.4216151822928,
    "C": 27.8119863210961,
    "h": -1.25326217326959,
    "CMY_C": 0.116385,
    "CMY_M": 0.1132082,
    "CMY_Y": 0.3311936,
    "CMYK_C": 0.003582352,
    "CMYK_M": 0,
    "CMYK_Y": 0.2458135,
    "CMYK_K": 0.1132082
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0113",
    "Farbtonhilfsbezeichnung": "D 324",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "209",
    "Bcolor": "152",
    "Y": 61,
    "L": 82.5799176839638,
    "a": -9.03211787736352,
    "b": 27.7575475042722,
    "C": 29.1900770263204,
    "h": -1.25620881102077,
    "CMY_C": 0.1834873,
    "CMY_M": 0.1798075,
    "CMY_Y": 0.4048526,
    "CMYK_C": 0.00448661,
    "CMYK_M": 0,
    "CMYK_Y": 0.2743808,
    "CMYK_K": 0.1798075
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0114",
    "Farbtonhilfsbezeichnung": "D 424",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "195",
    "Bcolor": "149",
    "Y": 52,
    "L": 77.535034240713,
    "a": -7.37148668473298,
    "b": 22.2091805500964,
    "C": 23.4005665882255,
    "h": -1.25032579520797,
    "CMY_C": 0.2399745,
    "CMY_M": 0.237206,
    "CMY_Y": 0.4157448,
    "CMYK_C": 0.003629423,
    "CMYK_M": 0,
    "CMYK_Y": 0.2340589,
    "CMYK_K": 0.237206
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0115",
    "Farbtonhilfsbezeichnung": "D 524",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "177",
    "Bcolor": "128",
    "Y": 42,
    "L": 70.9560766693448,
    "a": -8.98515805162203,
    "b": 24.2530848006707,
    "C": 25.8639747053919,
    "h": -1.21599879781742,
    "CMY_C": 0.3177765,
    "CMY_M": 0.3046606,
    "CMY_Y": 0.497738,
    "CMYK_C": 0.01886253,
    "CMYK_M": 0,
    "CMYK_Y": 0.2776736,
    "CMYK_K": 0.3046606
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0116",
    "Farbtonhilfsbezeichnung": "D 125",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "205",
    "Y": 84,
    "L": 93.5304349354365,
    "a": -4.6847886717038,
    "b": 15.495921768459,
    "C": 16.1886020506011,
    "h": -1.27720881087561,
    "CMY_C": 0.06052687,
    "CMY_M": 0.06545333,
    "CMY_Y": 0.196402,
    "CMYK_C": 0,
    "CMYK_M": 0.005243854,
    "CMYK_Y": 0.144629,
    "CMYK_K": 0.06052687
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0117",
    "Farbtonhilfsbezeichnung": "D 225",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "225",
    "Bcolor": "175",
    "Y": 74,
    "L": 88.7660223300461,
    "a": -5.83057666250281,
    "b": 24.2398538820111,
    "C": 24.9312282176104,
    "h": -1.33474385232928,
    "CMY_C": 0.09938595,
    "CMY_M": 0.1180049,
    "CMY_Y": 0.3131937,
    "CMYK_C": 0,
    "CMYK_M": 0.02067361,
    "CMYK_Y": 0.2374022,
    "CMYK_K": 0.09938595
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0118",
    "Farbtonhilfsbezeichnung": "D 325",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "211",
    "Bcolor": "154",
    "Y": 64,
    "L": 83.9466631768612,
    "a": -4.85432784570378,
    "b": 28.6454086830521,
    "C": 29.0538110658938,
    "h": -1.40292843949658,
    "CMY_C": 0.1360583,
    "CMY_M": 0.1742857,
    "CMY_Y": 0.3964925,
    "CMYK_C": 0,
    "CMYK_M": 0.04424764,
    "CMYK_Y": 0.3014488,
    "CMYK_K": 0.1360583
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0119",
    "Farbtonhilfsbezeichnung": "D 425",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "200",
    "Bcolor": "124",
    "Y": 56,
    "L": 79.5837378374668,
    "a": -7.70060242978815,
    "b": 38.1690521384149,
    "C": 38.9381024053137,
    "h": -1.37171873897261,
    "CMY_C": 0.1856042,
    "CMY_M": 0.2172216,
    "CMY_Y": 0.5135983,
    "CMYK_C": 0,
    "CMYK_M": 0.03882314,
    "CMYK_Y": 0.4027452,
    "CMYK_K": 0.1856042
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0120",
    "Farbtonhilfsbezeichnung": "D 525",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "176",
    "Bcolor": "92",
    "Y": 43,
    "L": 71.224092599071,
    "a": -6.56026102553497,
    "b": 43.7317549494668,
    "C": 44.2210743388643,
    "h": -1.4218952470312,
    "CMY_C": 0.2617798,
    "CMY_M": 0.310101,
    "CMY_Y": 0.6399471,
    "CMYK_C": 0,
    "CMYK_M": 0.06545641,
    "CMYK_Y": 0.5122689,
    "CMYK_K": 0.2617798
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0121",
    "Farbtonhilfsbezeichnung": "D 127",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "223",
    "Bcolor": "182",
    "Y": 74,
    "L": 88.7561070884329,
    "a": -2.04331569738464,
    "b": 20.6407090390411,
    "C": 20.7416009187702,
    "h": -1.47212336436019,
    "CMY_C": 0.08062925,
    "CMY_M": 0.126067,
    "CMY_Y": 0.2857531,
    "CMYK_C": 0,
    "CMYK_M": 0.04942263,
    "CMYK_Y": 0.2231133,
    "CMYK_K": 0.08062925
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0122",
    "Farbtonhilfsbezeichnung": "D 227",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "224",
    "Bcolor": "177",
    "Y": 76,
    "L": 89.7132240162899,
    "a": -0.6142009332265,
    "b": 24.7363697222987,
    "C": 24.7439938131384,
    "h": -1.54597155404659,
    "CMY_C": 0.04947595,
    "CMY_M": 0.1197261,
    "CMY_Y": 0.3059112,
    "CMYK_C": 0,
    "CMYK_M": 0.07390674,
    "CMYK_Y": 0.269783,
    "CMYK_K": 0.04947595
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0123",
    "Farbtonhilfsbezeichnung": "D 327",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "210",
    "Bcolor": "145",
    "Y": 66,
    "L": 84.9247217234113,
    "a": -0.48438321241089,
    "b": 34.5111307908374,
    "C": 34.5145299194231,
    "h": -1.55676168354469,
    "CMY_C": 0.08234976,
    "CMY_M": 0.1747844,
    "CMY_Y": 0.429527,
    "CMYK_C": 0,
    "CMYK_M": 0.1007297,
    "CMYK_Y": 0.3783328,
    "CMYK_K": 0.08234976
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0124",
    "Farbtonhilfsbezeichnung": "D 427",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "197",
    "Bcolor": "123",
    "Y": 57,
    "L": 80.1016949082766,
    "a": 0.02592275394736,
    "b": 39.4865763664256,
    "C": 39.4865848755085,
    "h": 1.57013983153477,
    "CMY_C": 0.1250035,
    "CMY_M": 0.2293346,
    "CMY_Y": 0.5165587,
    "CMYK_C": 0,
    "CMYK_M": 0.119236,
    "CMYK_Y": 0.4474934,
    "CMYK_K": 0.1250035
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0125",
    "Farbtonhilfsbezeichnung": "D 527",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "171",
    "Bcolor": "99",
    "Y": 42,
    "L": 70.8028847566897,
    "a": -0.38617490755654,
    "b": 39.748018940445,
    "C": 39.7498948520522,
    "h": -1.56108105625118,
    "CMY_C": 0.2323172,
    "CMY_M": 0.3276588,
    "CMY_Y": 0.6116761,
    "CMYK_C": 0,
    "CMYK_M": 0.124194,
    "CMYK_Y": 0.494161,
    "CMYK_K": 0.2323172
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0126",
    "Farbtonhilfsbezeichnung": "E 102",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "138",
    "Bcolor": "107",
    "Y": 28,
    "L": 59.9516658604174,
    "a": 9.18869032946562,
    "b": 21.1174042347912,
    "C": 23.0299108028319,
    "h": 1.16038186904402,
    "CMY_C": 0.3222204,
    "CMY_M": 0.4592768,
    "CMY_Y": 0.5808415,
    "CMYK_C": 0,
    "CMYK_M": 0.2022137,
    "CMYK_Y": 0.381571,
    "CMYK_K": 0.3222204
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0127",
    "Farbtonhilfsbezeichnung": "E 202",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "109",
    "Bcolor": "83",
    "Y": 17,
    "L": 48.5609889880693,
    "a": 9.14823081793348,
    "b": 19.1736046115459,
    "C": 21.2442284138088,
    "h": 1.12561455945063,
    "CMY_C": 0.4470802,
    "CMY_M": 0.5721765,
    "CMY_Y": 0.6758695,
    "CMYK_C": 0,
    "CMYK_M": 0.2262467,
    "CMYK_Y": 0.4137839,
    "CMYK_K": 0.4470802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0128",
    "Farbtonhilfsbezeichnung": "E 302",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "91",
    "Bcolor": "67",
    "Y": 12,
    "L": 41.0460084661977,
    "a": 8.04743975598157,
    "b": 18.0769458070835,
    "C": 19.7873003802536,
    "h": 1.1519604764249,
    "CMY_C": 0.5326539,
    "CMY_M": 0.6414936,
    "CMY_Y": 0.7375474,
    "CMYK_C": 0,
    "CMYK_M": 0.2328888,
    "CMYK_Y": 0.4384193,
    "CMYK_K": 0.5326539
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0129",
    "Farbtonhilfsbezeichnung": "E 402",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "78",
    "Bcolor": "61",
    "Y": 8,
    "L": 34.8255302708951,
    "a": 6.38056339801141,
    "b": 12.810590397977,
    "C": 14.3116321787832,
    "h": 1.10869436987681,
    "CMY_C": 0.6123631,
    "CMY_M": 0.6947147,
    "CMY_Y": 0.7597411,
    "CMYK_C": 0,
    "CMYK_M": 0.2124451,
    "CMYK_Y": 0.380196,
    "CMYK_K": 0.6123631
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0130",
    "Farbtonhilfsbezeichnung": "E 502",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "78",
    "Bcolor": "65",
    "Y": 8,
    "L": 34.0068693714753,
    "a": 2.85285616848768,
    "b": 9.39333420670789,
    "C": 9.81700136686284,
    "h": 1.27593870078766,
    "CMY_C": 0.6465086,
    "CMY_M": 0.6940123,
    "CMY_Y": 0.7463652,
    "CMYK_C": 0,
    "CMYK_M": 0.1343842,
    "CMYK_Y": 0.2824865,
    "CMYK_K": 0.6465086
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0131",
    "Farbtonhilfsbezeichnung": "E 103",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "138",
    "Bcolor": "112",
    "Y": 29,
    "L": 60.6499017276861,
    "a": 11.2517228425806,
    "b": 19.479704612463,
    "C": 22.4957809092074,
    "h": 1.0470008248935,
    "CMY_C": 0.3049721,
    "CMY_M": 0.4569544,
    "CMY_Y": 0.5623513,
    "CMYK_C": 0,
    "CMYK_M": 0.2186708,
    "CMYK_Y": 0.3703149,
    "CMYK_K": 0.3049721
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0132",
    "Farbtonhilfsbezeichnung": "E 203",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "114",
    "Bcolor": "90",
    "Y": 19,
    "L": 50.8794002690269,
    "a": 11.2854105800017,
    "b": 18.3772733453039,
    "C": 21.5658217456982,
    "h": 1.02007652198863,
    "CMY_C": 0.4115714,
    "CMY_M": 0.5545393,
    "CMY_Y": 0.6484896,
    "CMYK_C": 0,
    "CMYK_M": 0.2429656,
    "CMYK_Y": 0.4026287,
    "CMYK_K": 0.4115714
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0133",
    "Farbtonhilfsbezeichnung": "E 303",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "86",
    "Bcolor": "66",
    "Y": 11,
    "L": 39.6193580132274,
    "a": 12.1703998093894,
    "b": 16.9073144571963,
    "C": 20.8320885576772,
    "h": 0.946884945011,
    "CMY_C": 0.5262874,
    "CMY_M": 0.6645777,
    "CMY_Y": 0.7420051,
    "CMYK_C": 0,
    "CMYK_M": 0.2919285,
    "CMYK_Y": 0.4553766,
    "CMYK_K": 0.5262874
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0134",
    "Farbtonhilfsbezeichnung": "E 403",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "72",
    "Bcolor": "58",
    "Y": 8,
    "L": 32.9595327491356,
    "a": 8.78328294371144,
    "b": 12.03229825678,
    "C": 14.8970554341925,
    "h": 0.94023455213378,
    "CMY_C": 0.6187152,
    "CMY_M": 0.7170502,
    "CMY_Y": 0.7708896,
    "CMYK_C": 0,
    "CMYK_M": 0.2579042,
    "CMYK_Y": 0.3991096,
    "CMYK_K": 0.6187152
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0135",
    "Farbtonhilfsbezeichnung": "E 503",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "66",
    "Bcolor": "54",
    "Y": 6,
    "L": 29.619529189792,
    "a": 6.34558816094827,
    "b": 10.1235890394113,
    "C": 11.9479514623744,
    "h": 1.01089498549923,
    "CMY_C": 0.6672115,
    "CMY_M": 0.7413268,
    "CMY_Y": 0.7886385,
    "CMYK_C": 0,
    "CMYK_M": 0.2227099,
    "CMYK_Y": 0.3648774,
    "CMYK_K": 0.6672115
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0136",
    "Farbtonhilfsbezeichnung": "E 105",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "166",
    "Bcolor": "149",
    "Y": 40,
    "L": 69.1742870651758,
    "a": 4.17696226872882,
    "b": 10.450846111963,
    "C": 11.2546522936213,
    "h": 1.19056847457441,
    "CMY_C": 0.2779655,
    "CMY_M": 0.3496961,
    "CMY_Y": 0.4155774,
    "CMYK_C": 0,
    "CMYK_M": 0.09934517,
    "CMYK_Y": 0.1905892,
    "CMYK_K": 0.2779655
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0137",
    "Farbtonhilfsbezeichnung": "E 205",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "142",
    "Bcolor": "123",
    "Y": 29,
    "L": 60.4079906879736,
    "a": 4.36339410254266,
    "b": 12.5915448701473,
    "C": 13.3261476170361,
    "h": 1.23721289411898,
    "CMY_C": 0.3649562,
    "CMY_M": 0.4413856,
    "CMY_Y": 0.5186352,
    "CMYK_C": 0,
    "CMYK_M": 0.1203529,
    "CMYK_Y": 0.2419975,
    "CMYK_K": 0.3649562
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0138",
    "Farbtonhilfsbezeichnung": "E 305",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "143",
    "Bcolor": "123",
    "Y": 19,
    "L": 60.8286094665527,
    "a": 4.53965902328491,
    "b": 13.3027467727661,
    "C": 14.0560159683228,
    "h": 71.1574249267578,
    "CMY_C": 0.35775470733643,
    "CMY_M": 0.43762558698654,
    "CMY_Y": 0.51931631565094,
    "CMYK_C": 0,
    "CMYK_M": 0.12436195462942,
    "CMYK_Y": 0.25155746936798,
    "CMYK_K": 0.35775470733643
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0139",
    "Farbtonhilfsbezeichnung": "E 405",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "93",
    "Bcolor": "79",
    "Y": 12,
    "L": 40.957903193304,
    "a": 5.02413482100689,
    "b": 10.4525584783053,
    "C": 11.5973233740396,
    "h": 1.1227394522381,
    "CMY_C": 0.5642143,
    "CMY_M": 0.6340424,
    "CMY_Y": 0.6899956,
    "CMYK_C": 0,
    "CMYK_M": 0.160235,
    "CMYK_Y": 0.2886311,
    "CMYK_K": 0.5642143
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0140",
    "Farbtonhilfsbezeichnung": "E 505",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "53",
    "Bcolor": "49",
    "Y": 5,
    "L": 23.9568023681641,
    "a": 7.88490581512451,
    "b": 5.51669406890869,
    "C": 9.62318325042725,
    "h": 34.9786567687988,
    "CMY_C": 0.71989774703979,
    "CMY_M": 0.79358106851578,
    "CMY_Y": 0.80951380729675,
    "CMYK_C": 0,
    "CMYK_M": 0.26305866241455,
    "CMYK_Y": 0.31994050741196,
    "CMYK_K": 0.71989774703979
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0141",
    "Farbtonhilfsbezeichnung": "E 106",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "129",
    "Bcolor": "114",
    "Y": 23,
    "L": 55.529625005839,
    "a": 6.14236790881573,
    "b": 10.5444687447848,
    "C": 12.2030530867071,
    "h": 1.04332865105505,
    "CMY_C": 0.4091806,
    "CMY_M": 0.4944056,
    "CMY_Y": 0.5524142,
    "CMYK_C": 0,
    "CMYK_M": 0.1442487,
    "CMYK_Y": 0.242432,
    "CMYK_K": 0.4091806
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0142",
    "Farbtonhilfsbezeichnung": "E 206",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "90",
    "Bcolor": "75",
    "Y": 12,
    "L": 40.7671551851626,
    "a": 9.04324550743041,
    "b": 12.8258527135754,
    "C": 15.6933994767861,
    "h": 0.95666944712561,
    "CMY_C": 0.5384061,
    "CMY_M": 0.6454642,
    "CMY_Y": 0.7061931,
    "CMYK_C": 0,
    "CMYK_M": 0.2319314,
    "CMYK_Y": 0.363495,
    "CMYK_K": 0.5384061
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0143",
    "Farbtonhilfsbezeichnung": "E 306",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "71",
    "Bcolor": "62",
    "Y": 7,
    "L": 31.5175705999458,
    "a": 6.15325503966632,
    "b": 7.58086958627097,
    "C": 9.76381745360016,
    "h": 0.88897272158376,
    "CMY_C": 0.6547868,
    "CMY_M": 0.7233424,
    "CMY_Y": 0.7567769,
    "CMYK_C": 0,
    "CMYK_M": 0.1985891,
    "CMYK_Y": 0.2954411,
    "CMYK_K": 0.6547868
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0144",
    "Farbtonhilfsbezeichnung": "E 406",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "75",
    "Bcolor": "74",
    "Y": 8,
    "L": 32.9818568477627,
    "a": 3.91501435313632,
    "b": 2.10241070820676,
    "C": 4.44381234653826,
    "h": 0.4928171665633,
    "CMY_C": 0.6657696,
    "CMY_M": 0.7040561,
    "CMY_Y": 0.7107781,
    "CMYK_C": 0,
    "CMYK_M": 0.1145512,
    "CMYK_Y": 0.1346631,
    "CMYK_K": 0.6657696
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0145",
    "Farbtonhilfsbezeichnung": "E 506",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "59",
    "Bcolor": "58",
    "Y": 5,
    "L": 25.580644485337,
    "a": 3.55660914389341,
    "b": 1.72819744186443,
    "C": 3.9542553028975,
    "h": 0.4523134548432,
    "CMY_C": 0.7366191,
    "CMY_M": 0.7694954,
    "CMY_Y": 0.7741581,
    "CMYK_C": 0,
    "CMYK_M": 0.1248241,
    "CMYK_Y": 0.1425273,
    "CMYK_K": 0.7366191
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0146",
    "Farbtonhilfsbezeichnung": "E 107",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "137",
    "Bcolor": "119",
    "Y": 28,
    "L": 60.3277245250473,
    "a": 12.208571453193,
    "b": 14.7909001321575,
    "C": 19.1786324759399,
    "h": 0.88075178819529,
    "CMY_C": 0.3114339,
    "CMY_M": 0.4616275,
    "CMY_Y": 0.5331597,
    "CMYK_C": 0,
    "CMYK_M": 0.2181253,
    "CMYK_Y": 0.322011,
    "CMYK_K": 0.3114339
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0147",
    "Farbtonhilfsbezeichnung": "E 207",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "114",
    "Bcolor": "100",
    "Y": 19,
    "L": 51.236455289987,
    "a": 12.9301666735691,
    "b": 12.6863986367633,
    "C": 18.1144671623856,
    "h": 0.77588241934173,
    "CMY_C": 0.4081851,
    "CMY_M": 0.5539433,
    "CMY_Y": 0.6070257,
    "CMYK_C": 0,
    "CMYK_M": 0.2462903,
    "CMYK_Y": 0.3359846,
    "CMYK_K": 0.4081851
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0148",
    "Farbtonhilfsbezeichnung": "E 307",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "80",
    "Bcolor": "66",
    "Y": 11,
    "L": 38.4116096496582,
    "a": 16.1598243713379,
    "b": 15.0219841003418,
    "C": 22.0635433197021,
    "h": 42.9101753234863,
    "CMY_C": 0.52010917663574,
    "CMY_M": 0.68568110466003,
    "CMY_Y": 0.7400506734848,
    "CMYK_C": 0,
    "CMYK_M": 0.34501999616623,
    "CMYK_Y": 0.45831570029259,
    "CMYK_K": 0.52010917663574
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0149",
    "Farbtonhilfsbezeichnung": "E 407",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "54",
    "Bcolor": "48",
    "Y": 6,
    "L": 27.77512550354,
    "a": 18.8085556030273,
    "b": 11.7160034179688,
    "C": 22.1591186523438,
    "h": 31.919116973877,
    "CMY_C": 0.61945974826813,
    "CMY_M": 0.78911250829697,
    "CMY_Y": 0.81176310777664,
    "CMYK_C": 0,
    "CMYK_M": 0.44582080841064,
    "CMYK_Y": 0.50534301996231,
    "CMYK_K": 0.61945974826813
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0150",
    "Farbtonhilfsbezeichnung": "E 507",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "56",
    "Bcolor": "50",
    "Y": 5,
    "L": 26.633918762207,
    "a": 11.3376150131226,
    "b": 8.33240413665771,
    "C": 14.070198059082,
    "h": 36.3134498596191,
    "CMY_C": 0.67229032516479,
    "CMY_M": 0.77882713079453,
    "CMY_Y": 0.80273461341858,
    "CMYK_C": 0,
    "CMYK_M": 0.32509508728981,
    "CMYK_Y": 0.39804834127426,
    "CMYK_K": 0.67229032516479
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0151",
    "Farbtonhilfsbezeichnung": "F 102",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "235",
    "Bcolor": "234",
    "Y": 80,
    "L": 91.8446842840793,
    "a": -4.62267271053307,
    "b": -2.06984920622539,
    "C": 5.06491645787165,
    "h": 0.42098980908882,
    "CMY_C": 0.1369413,
    "CMY_M": 0.07983828,
    "CMY_Y": 0.08400271,
    "CMYK_C": 0.06205755,
    "CMYK_M": 0,
    "CMYK_Y": 0.004525758,
    "CMYK_K": 0.07983828
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0152",
    "Farbtonhilfsbezeichnung": "F 202",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 58,
    "L": 80.1558380126953,
    "a": -0.15697385370731,
    "b": 0.57123565673828,
    "C": 0.59241116046906,
    "h": 105.365432739258,
    "CMY_C": 0.21976959705353,
    "CMY_M": 0.21975475549698,
    "CMY_Y": 0.23062539100647,
    "CMYK_C": 1.902165604e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.01393233146518,
    "CMYK_K": 0.21975475549698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0153",
    "Farbtonhilfsbezeichnung": "F 302",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "177",
    "Bcolor": "181",
    "Y": 44,
    "L": 71.9625794961724,
    "a": -1.20266641014699,
    "b": -3.27366950294816,
    "C": 3.48759494618121,
    "h": 1.2187267290579,
    "CMY_C": 0.3288663,
    "CMY_M": 0.3043403,
    "CMY_Y": 0.2908497,
    "CMYK_C": 0.05360872,
    "CMYK_M": 0.01902362,
    "CMYK_Y": 0,
    "CMYK_K": 0.2908497
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0154",
    "Farbtonhilfsbezeichnung": "F 402",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "196",
    "Bcolor": "207",
    "Y": 54,
    "L": 78.5540706166619,
    "a": -2.01091226265399,
    "b": -7.84503294083339,
    "C": 8.09866099863756,
    "h": 1.31986954874022,
    "CMY_C": 0.2825066,
    "CMY_M": 0.230475,
    "CMY_Y": 0.1876462,
    "CMYK_C": 0.1167722,
    "CMYK_M": 0.05272185,
    "CMYK_Y": 0,
    "CMYK_K": 0.1876462
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0155",
    "Farbtonhilfsbezeichnung": "F 502",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "104",
    "Bcolor": "136",
    "Y": 13,
    "L": 43.4315121432754,
    "a": 0.02015413360584,
    "b": -21.1861011916479,
    "C": 21.1861107778622,
    "h": -1.56984503673242,
    "CMY_C": 0.6864737,
    "CMY_M": 0.5910634,
    "CMY_Y": 0.4651513,
    "CMYK_C": 0.4138039,
    "CMYK_M": 0.2354163,
    "CMYK_Y": 0,
    "CMYK_K": 0.4651513
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0156",
    "Farbtonhilfsbezeichnung": "F 103",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "202",
    "Y": 82,
    "L": 92.4475564171034,
    "a": 0.1494050316404,
    "b": 15.5117932794289,
    "C": 15.5125127754086,
    "h": 1.56116491867098,
    "CMY_C": 0.03615588,
    "CMY_M": 0.08898011,
    "CMY_Y": 0.207479,
    "CMYK_C": 0,
    "CMYK_M": 0.05480578,
    "CMYK_Y": 0.1777498,
    "CMYK_K": 0.03615588
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0157",
    "Farbtonhilfsbezeichnung": "F 203",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "226",
    "Bcolor": "189",
    "Y": 77,
    "L": 90.1113747124462,
    "a": -0.08280443521485,
    "b": 19.1251194801516,
    "C": 19.1252987350411,
    "h": -1.56646673722549,
    "CMY_C": 0.05482399,
    "CMY_M": 0.1153139,
    "CMY_Y": 0.2596464,
    "CMYK_C": 0,
    "CMYK_M": 0.06399859,
    "CMYK_Y": 0.2167029,
    "CMYK_K": 0.05482399
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0158",
    "Farbtonhilfsbezeichnung": "F 303",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "202",
    "Bcolor": "140",
    "Y": 64,
    "L": 83.7485804402064,
    "a": 7.07456434256887,
    "b": 35.9204381027857,
    "C": 36.6104812059771,
    "h": 1.37633425922447,
    "CMY_C": 0.04264115,
    "CMY_M": 0.2062778,
    "CMY_Y": 0.4505943,
    "CMYK_C": 0,
    "CMYK_M": 0.1709251,
    "CMYK_Y": 0.4261236,
    "CMYK_K": 0.04264115
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0159",
    "Farbtonhilfsbezeichnung": "F 403",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "147",
    "Y": 60,
    "L": 81.8803856464943,
    "a": 8.43338525743187,
    "b": 29.8003204393175,
    "C": 30.9706487692181,
    "h": 1.29501117243371,
    "CMY_C": 0.0662829,
    "CMY_M": 0.228805,
    "CMY_Y": 0.4237496,
    "CMYK_C": 0,
    "CMYK_M": 0.1740593,
    "CMYK_Y": 0.3828426,
    "CMYK_K": 0.0662829
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0160",
    "Farbtonhilfsbezeichnung": "F 503",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "186",
    "Bcolor": "119",
    "Y": 55,
    "L": 79.3192149546871,
    "a": 13.4924227194247,
    "b": 40.9385859313953,
    "C": 43.1046782716434,
    "h": 1.25243013282392,
    "CMY_C": 0.04548383,
    "CMY_M": 0.2715485,
    "CMY_Y": 0.5320865,
    "CMYK_C": 0,
    "CMYK_M": 0.2368369,
    "CMYK_Y": 0.5097898,
    "CMYK_K": 0.04548383
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0161",
    "Farbtonhilfsbezeichnung": "F 104",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "171",
    "Bcolor": "163",
    "Y": 42,
    "L": 70.7024791616838,
    "a": 2.96229592763886,
    "b": 4.7540369893216,
    "C": 5.60143417873885,
    "h": 1.01355606425424,
    "CMY_C": 0.2854174,
    "CMY_M": 0.3293487,
    "CMY_Y": 0.36001,
    "CMYK_C": 0,
    "CMYK_M": 0.06147832,
    "CMYK_Y": 0.1043863,
    "CMYK_K": 0.2854174
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0162",
    "Farbtonhilfsbezeichnung": "F 204",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "141",
    "Bcolor": "127",
    "Y": 28,
    "L": 60.0176043447185,
    "a": 6.06505222655451,
    "b": 9.82530528849253,
    "C": 11.5464922172456,
    "h": 1.01776127431212,
    "CMY_C": 0.364329,
    "CMY_M": 0.4486903,
    "CMY_Y": 0.5033543,
    "CMYK_C": 0,
    "CMYK_M": 0.1327122,
    "CMYK_Y": 0.2187064,
    "CMYK_K": 0.364329
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0163",
    "Farbtonhilfsbezeichnung": "F 304",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "106",
    "Bcolor": "89",
    "Y": 19,
    "L": 51.0045934757213,
    "a": 23.2249754861579,
    "b": 19.4298513299035,
    "C": 30.2806639463996,
    "h": 0.69665891763561,
    "CMY_C": 0.3414786,
    "CMY_M": 0.5856634,
    "CMY_Y": 0.6519446,
    "CMYK_C": 0,
    "CMYK_M": 0.3708078,
    "CMYK_Y": 0.4714593,
    "CMYK_K": 0.3414786
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0164",
    "Farbtonhilfsbezeichnung": "F 404",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "62",
    "Bcolor": "60",
    "Y": 8,
    "L": 34.0741172019967,
    "a": 26.696105939206,
    "b": 12.859033654544,
    "C": 29.6316860614783,
    "h": 0.4488861115765,
    "CMY_C": 0.514935,
    "CMY_M": 0.7567042,
    "CMY_Y": 0.7629212,
    "CMYK_C": 0,
    "CMYK_M": 0.4984264,
    "CMYK_Y": 0.5112432,
    "CMYK_K": 0.514935
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0165",
    "Farbtonhilfsbezeichnung": "F 504",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "53",
    "Bcolor": "58",
    "Y": 4,
    "L": 25.1989949692104,
    "a": 13.0348563462484,
    "b": 1.05900902241998,
    "C": 13.0778048646131,
    "h": 0.08106634465667,
    "CMY_C": 0.6896753,
    "CMY_M": 0.7938968,
    "CMY_Y": 0.7724113,
    "CMYK_C": 0,
    "CMYK_M": 0.3358467,
    "CMYK_Y": 0.2666111,
    "CMYK_K": 0.6896753
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0166",
    "Farbtonhilfsbezeichnung": "F 105",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 81,
    "L": 92.3441622265778,
    "a": -0.58386639549118,
    "b": 4.3158204948804,
    "C": 4.35513564792344,
    "h": -1.43632756954274,
    "CMY_C": 0.07631988,
    "CMY_M": 0.08547679,
    "CMY_Y": 0.1253397,
    "CMYK_C": 0,
    "CMYK_M": 0.009913501,
    "CMYK_Y": 0.05307017,
    "CMYK_K": 0.07631988
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0167",
    "Farbtonhilfsbezeichnung": "F 205",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "193",
    "Bcolor": "176",
    "Y": 55,
    "L": 78.9231365340459,
    "a": 3.82997780207917,
    "b": 9.78417020836408,
    "C": 10.5070793577787,
    "h": 1.19768545713899,
    "CMY_C": 0.1760171,
    "CMY_M": 0.2449349,
    "CMY_Y": 0.3095344,
    "CMYK_C": 0,
    "CMYK_M": 0.0836398,
    "CMYK_Y": 0.1620389,
    "CMYK_K": 0.1760171
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0168",
    "Farbtonhilfsbezeichnung": "G 101",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "148",
    "Bcolor": "150",
    "Y": 29,
    "L": 60.7378023310833,
    "a": -1.55828210612047,
    "b": -2.6655171102582,
    "C": 3.08759203706294,
    "h": 1.04177150493087,
    "CMY_C": 0.445975,
    "CMY_M": 0.4210618,
    "CMY_Y": 0.4120886,
    "CMYK_C": 0.05763859,
    "CMYK_M": 0.01526293,
    "CMYK_Y": 0,
    "CMYK_K": 0.4120886
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0169",
    "Farbtonhilfsbezeichnung": "G 201",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "123",
    "Bcolor": "130",
    "Y": 20,
    "L": 51.5274113267384,
    "a": -0.49540700875722,
    "b": -4.89348542955597,
    "C": 4.91849852633935,
    "h": 1.46990201564687,
    "CMY_C": 0.5382307,
    "CMY_M": 0.5158365,
    "CMY_Y": 0.4901378,
    "CMYK_C": 0.09432531,
    "CMYK_M": 0.05040318,
    "CMYK_Y": 0,
    "CMYK_K": 0.4901378
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0170",
    "Farbtonhilfsbezeichnung": "G 301",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "101",
    "Bcolor": "107",
    "Y": 13,
    "L": 42.4125808669092,
    "a": -0.34715717755912,
    "b": -4.60238587685831,
    "C": 4.61546030916046,
    "h": 1.49550906853471,
    "CMY_C": 0.6245762,
    "CMY_M": 0.6052821,
    "CMY_Y": 0.5814184,
    "CMYK_C": 0.1031048,
    "CMYK_M": 0.05701098,
    "CMYK_Y": 0,
    "CMYK_K": 0.5814184
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0171",
    "Farbtonhilfsbezeichnung": "G 401",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "87",
    "Bcolor": "93",
    "Y": 9,
    "L": 36.7571404245061,
    "a": -0.22687302827983,
    "b": -4.61282555381634,
    "C": 4.6184013425537,
    "h": 1.52165283390406,
    "CMY_C": 0.6769481,
    "CMY_M": 0.659084,
    "CMY_Y": 0.6351833,
    "CMYK_C": 0.1144818,
    "CMYK_M": 0.06551444,
    "CMYK_Y": 0,
    "CMYK_K": 0.6351833
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0172",
    "Farbtonhilfsbezeichnung": "G 501",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "76",
    "Bcolor": "81",
    "Y": 7,
    "L": 32.1350149348953,
    "a": -0.44418056991807,
    "b": -4.13780800176396,
    "C": 4.16158040150069,
    "h": 1.46385900112916,
    "CMY_C": 0.7192855,
    "CMY_M": 0.7015187,
    "CMY_Y": 0.6810982,
    "CMYK_C": 0.119746,
    "CMYK_M": 0.06403348,
    "CMYK_Y": 0,
    "CMYK_K": 0.6810982
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0173",
    "Farbtonhilfsbezeichnung": "G 103",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "177",
    "Bcolor": "170",
    "Y": 44,
    "L": 71.9014314384015,
    "a": -1.59960215658272,
    "b": 2.92906705056195,
    "C": 3.33738832712524,
    "h": -1.0709421263538,
    "CMY_C": 0.3116424,
    "CMY_M": 0.3057991,
    "CMY_Y": 0.3352816,
    "CMYK_C": 0.008417421,
    "CMYK_M": 0,
    "CMYK_Y": 0.04246974,
    "CMYK_K": 0.3057991
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0174",
    "Farbtonhilfsbezeichnung": "G 203",
    "Farbtonklasse": "01",
    "Rcolor": "143",
    "Gcolor": "147",
    "Bcolor": "146",
    "Y": 29,
    "L": 60.6454051598387,
    "a": -1.66681655009893,
    "b": -0.65227773623275,
    "C": 1.78990046004481,
    "h": 0.37301122431947,
    "CMY_C": 0.4409054,
    "CMY_M": 0.4223202,
    "CMY_Y": 0.4267625,
    "CMYK_C": 0.032172,
    "CMYK_M": 0,
    "CMYK_Y": 0.007689797,
    "CMYK_K": 0.4223202
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0175",
    "Farbtonhilfsbezeichnung": "G 303",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "128",
    "Bcolor": "124",
    "Y": 21,
    "L": 52.8704964040704,
    "a": -2.3722151951851,
    "b": 0.49067919642618,
    "C": 2.4224308052187,
    "h": -0.20396787422408,
    "CMY_C": 0.5206646,
    "CMY_M": 0.4999591,
    "CMY_Y": 0.5126368,
    "CMYK_C": 0.04140775,
    "CMYK_M": 0,
    "CMYK_Y": 0.02535338,
    "CMYK_K": 0.4999591
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0176",
    "Farbtonhilfsbezeichnung": "G 403",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "112",
    "Bcolor": "109",
    "Y": 16,
    "L": 46.919730131793,
    "a": -1.56199760587195,
    "b": 0.4713311777363,
    "C": 1.63156047998717,
    "h": -0.29306058601788,
    "CMY_C": 0.5733742,
    "CMY_M": 0.5604783,
    "CMY_Y": 0.5706454,
    "CMYK_C": 0.02934075,
    "CMYK_M": 0,
    "CMYK_Y": 0.02313234,
    "CMYK_K": 0.5604783
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0177",
    "Farbtonhilfsbezeichnung": "G 503",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "86",
    "Bcolor": "85",
    "Y": 9,
    "L": 36.3993232376953,
    "a": -1.4836108170134,
    "b": 0.08221559767975,
    "C": 1.48588709559677,
    "h": -0.05535925749608,
    "CMY_C": 0.6739956,
    "CMY_M": 0.6611491,
    "CMY_Y": 0.6677644,
    "CMYK_C": 0.037912,
    "CMYK_M": 0,
    "CMYK_Y": 0.01952274,
    "CMYK_K": 0.6611491
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0178",
    "Farbtonhilfsbezeichnung": "G 104",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "119",
    "Bcolor": "105",
    "Y": 19,
    "L": 49.8220443725586,
    "a": -1.37996327877045,
    "b": 7.48653650283813,
    "C": 7.61265563964844,
    "h": 100.443870544434,
    "CMY_C": 0.52377849817276,
    "CMY_M": 0.53395962715149,
    "CMY_Y": 0.58846938610077,
    "CMYK_C": 0,
    "CMYK_M": 0.02137897722423,
    "CMYK_Y": 0.13584201037884,
    "CMYK_K": 0.52377849817276
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0179",
    "Farbtonhilfsbezeichnung": "G 204",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "85",
    "Y": 13,
    "L": 39.5147018432617,
    "a": -2.52619075775146,
    "b": 4.19948863983154,
    "C": 4.90074920654297,
    "h": 121.02889251709,
    "CMY_C": 0.64011776447296,
    "CMY_M": 0.63073319196701,
    "CMY_Y": 0.66476881504059,
    "CMYK_C": 0.02541407011449,
    "CMYK_M": 0,
    "CMYK_Y": 0.09217081964016,
    "CMYK_K": 0.63073319196701
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0180",
    "Farbtonhilfsbezeichnung": "G 304",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "93",
    "Bcolor": "88",
    "Y": 11,
    "L": 39.0233192443848,
    "a": -2.28616046905518,
    "b": 2.00727367401123,
    "C": 3.04231452941895,
    "h": 138.716506958008,
    "CMY_C": 0.64928686618805,
    "CMY_M": 0.63536041975021,
    "CMY_Y": 0.65551507472992,
    "CMYK_C": 0.03819236159325,
    "CMYK_M": 0,
    "CMYK_Y": 0.0552728138864,
    "CMYK_K": 0.63536041975021
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0181",
    "Farbtonhilfsbezeichnung": "G 404",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "80",
    "Bcolor": "76",
    "Y": 8,
    "L": 34.2134742736816,
    "a": -0.18994432687759,
    "b": 2.26875329017639,
    "C": 2.27669072151184,
    "h": 94.7857513427734,
    "CMY_C": 0.67950755357742,
    "CMY_M": 0.68445992469788,
    "CMY_Y": 0.70113384723663,
    "CMYK_C": 0,
    "CMYK_M": 0.01545238029212,
    "CMYK_Y": 0.06747832894325,
    "CMYK_K": 0.67950755357742
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0182",
    "Farbtonhilfsbezeichnung": "G 504",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "55",
    "Bcolor": "45",
    "Y": 5,
    "L": 22.9498157501221,
    "a": -0.5759225487709,
    "b": 6.08378601074219,
    "C": 6.11098527908325,
    "h": 95.4077987670898,
    "CMY_C": 0.77427494525909,
    "CMY_M": 0.78533232212067,
    "CMY_Y": 0.82240200042725,
    "CMYK_C": 0,
    "CMYK_M": 0.04898604005575,
    "CMYK_Y": 0.21321095526218,
    "CMYK_K": 0.77427494525909
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0183",
    "Farbtonhilfsbezeichnung": "L 101",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "125",
    "Y": 73,
    "L": 88.3689014232486,
    "a": 2.43859161964627,
    "b": 49.5970391785876,
    "C": 49.6569534342348,
    "h": 1.52166780206265,
    "CMY_C": 0,
    "CMY_M": 0.146528,
    "CMY_Y": 0.510437,
    "CMYK_C": 0,
    "CMYK_M": 0.146528,
    "CMYK_Y": 0.510437,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0184",
    "Farbtonhilfsbezeichnung": "L 201",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "204",
    "Bcolor": "83",
    "Y": 65,
    "L": 84.2559767066736,
    "a": 5.78265162205233,
    "b": 63.9170394172368,
    "C": 64.1780880647486,
    "h": 1.48057075268159,
    "CMY_C": 0.00646523,
    "CMY_M": 0.2017145,
    "CMY_Y": 0.6734673,
    "CMYK_C": 0,
    "CMYK_M": 0.1965198,
    "CMYK_Y": 0.6713424,
    "CMYK_K": 0.00646523
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0185",
    "Farbtonhilfsbezeichnung": "L 301",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "52",
    "Y": 64,
    "L": 83.7770516954006,
    "a": 7.0914652725792,
    "b": 75.140273522558,
    "C": 75.4741650153019,
    "h": 1.47669868206921,
    "CMY_C": 0,
    "CMY_M": 0.2113878,
    "CMY_Y": 0.7958071,
    "CMYK_C": 0,
    "CMYK_M": 0.2113878,
    "CMYK_Y": 0.7958071,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0186",
    "Farbtonhilfsbezeichnung": "L 401",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "21",
    "Y": 60,
    "L": 82.051936576713,
    "a": 8.84081805377396,
    "b": 81.0403348433463,
    "C": 81.5211379666748,
    "h": 1.46213444937487,
    "CMY_C": 0,
    "CMY_M": 0.2349751,
    "CMY_Y": 0.9184229,
    "CMYK_C": 0,
    "CMYK_M": 0.2349751,
    "CMYK_Y": 0.9184229,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0187",
    "Farbtonhilfsbezeichnung": "L 501",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "180",
    "Bcolor": "0",
    "Y": 53,
    "L": 77.1095657348633,
    "a": 11.2186546325684,
    "b": 84.307373046875,
    "C": 85.0505218505859,
    "h": 82.4202651977539,
    "CMY_C": 0.04469525814056,
    "CMY_M": 0.29405683279037,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.26102828979492,
    "CMYK_Y": 1,
    "CMYK_K": 0.04469525814056
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0188",
    "Farbtonhilfsbezeichnung": "L 102",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "203",
    "Bcolor": "141",
    "Y": 64,
    "L": 83.9004127607905,
    "a": 7.08591690942884,
    "b": 35.8790637774263,
    "C": 36.572085475017,
    "h": 1.37581108108696,
    "CMY_C": 0.04087709,
    "CMY_M": 0.2046463,
    "CMY_Y": 0.4487186,
    "CMYK_C": 0,
    "CMYK_M": 0.1707489,
    "CMYK_Y": 0.4252234,
    "CMYK_K": 0.04087709
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0189",
    "Farbtonhilfsbezeichnung": "L 202",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "92",
    "Y": 61,
    "L": 82.3687620004613,
    "a": 12.8052575205537,
    "b": 58.2415150478476,
    "C": 59.6326143585568,
    "h": 1.35437500906516,
    "CMY_C": 0,
    "CMY_M": 0.2395224,
    "CMY_Y": 0.6399071,
    "CMYK_C": 0,
    "CMYK_M": 0.2395224,
    "CMYK_Y": 0.6399071,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0190",
    "Farbtonhilfsbezeichnung": "L 302",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "10",
    "Y": 54,
    "L": 78.3416593842818,
    "a": 17.9669744999564,
    "b": 79.8247334481134,
    "C": 81.8217589809975,
    "h": 1.34940546045454,
    "CMY_C": 0,
    "CMY_M": 0.2989128,
    "CMY_Y": 0.9589263,
    "CMYK_C": 0,
    "CMYK_M": 0.2989128,
    "CMYK_Y": 0.9589263,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0191",
    "Farbtonhilfsbezeichnung": "L 402",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "167",
    "Bcolor": "0",
    "Y": 49,
    "L": 75.5151726076277,
    "a": 23.1242230171784,
    "b": 80.2200767128977,
    "C": 83.4864683524905,
    "h": 1.29014485638975,
    "CMY_C": 0,
    "CMY_M": 0.3435656,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3435656,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0192",
    "Farbtonhilfsbezeichnung": "L 502",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "143",
    "Bcolor": "0",
    "Y": 37,
    "L": 65.9989166259766,
    "a": 22.489725112915,
    "b": 71.9400100708008,
    "C": 75.373420715332,
    "h": 72.6398239135742,
    "CMY_C": 0.12411987781525,
    "CMY_M": 0.43985193967819,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.36047405004501,
    "CMYK_Y": 1,
    "CMYK_K": 0.12411987781525
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0193",
    "Farbtonhilfsbezeichnung": "L 103",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "197",
    "Bcolor": "133",
    "Y": 62,
    "L": 82.7371091256212,
    "a": 10.3539370318619,
    "b": 38.2458915846467,
    "C": 39.6226227698812,
    "h": 1.30641330998418,
    "CMY_C": 0.02929521,
    "CMY_M": 0.2260331,
    "CMY_Y": 0.4777608,
    "CMYK_C": 0,
    "CMYK_M": 0.2026753,
    "CMYK_Y": 0.462,
    "CMYK_K": 0.02929521
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0194",
    "Farbtonhilfsbezeichnung": "L 203",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "177",
    "Bcolor": "69",
    "Y": 54,
    "L": 78.7244918728051,
    "a": 21.7355970485423,
    "b": 64.2917529714768,
    "C": 67.866528415722,
    "h": 1.24478208953275,
    "CMY_C": 0,
    "CMY_M": 0.3040127,
    "CMY_Y": 0.7278711,
    "CMYK_C": 0,
    "CMYK_M": 0.3040127,
    "CMYK_Y": 0.7278711,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0195",
    "Farbtonhilfsbezeichnung": "L 303",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "155",
    "Bcolor": "0",
    "Y": 46,
    "L": 73.2881240844727,
    "a": 31.1514434814453,
    "b": 85.7356109619141,
    "C": 91.2195587158203,
    "h": 70.0317306518555,
    "CMY_C": 0,
    "CMY_M": 0.39188724756241,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.39188724756241,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0196",
    "Farbtonhilfsbezeichnung": "L 403",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "153",
    "Bcolor": "43",
    "Y": 43,
    "L": 71.2854309082031,
    "a": 27.9945602416992,
    "b": 66.8972396850586,
    "C": 72.5185241699219,
    "h": 67.292106628418,
    "CMY_C": 0.0316578745842,
    "CMY_M": 0.40130716562271,
    "CMY_Y": 0.83270692825317,
    "CMYK_C": 0,
    "CMYK_M": 0.38173419237137,
    "CMYK_Y": 0.82723766565323,
    "CMYK_K": 0.0316578745842
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0197",
    "Farbtonhilfsbezeichnung": "L 503",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "141",
    "Bcolor": "0",
    "Y": 37,
    "L": 66.5610733032227,
    "a": 26.8561229705811,
    "b": 72.8265228271484,
    "C": 77.6205749511719,
    "h": 69.7576141357422,
    "CMY_C": 0.09304773807526,
    "CMY_M": 0.44722092151642,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3905091881752,
    "CMYK_Y": 1,
    "CMYK_K": 0.09304773807526
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0198",
    "Farbtonhilfsbezeichnung": "L 104",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "175",
    "Bcolor": "103",
    "Y": 53,
    "L": 77.8645159384958,
    "a": 22.7676149272092,
    "b": 47.6162605675877,
    "C": 52.779471008282,
    "h": 1.12478272292032,
    "CMY_C": 0,
    "CMY_M": 0.313892,
    "CMY_Y": 0.5953509,
    "CMYK_C": 0,
    "CMYK_M": 0.313892,
    "CMYK_Y": 0.5953509,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0199",
    "Farbtonhilfsbezeichnung": "L 204",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "147",
    "Bcolor": "45",
    "Y": 40,
    "L": 69.4143160056476,
    "a": 29.3287790160577,
    "b": 64.415691092174,
    "C": 70.7782349133908,
    "h": 1.14353962030909,
    "CMY_C": 0.04907563,
    "CMY_M": 0.4247688,
    "CMY_Y": 0.82546,
    "CMYK_C": 0,
    "CMYK_M": 0.3950821,
    "CMYK_Y": 0.8164522,
    "CMYK_K": 0.04907563
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0200",
    "Farbtonhilfsbezeichnung": "L 304",
    "Farbtonklasse": "04",
    "Rcolor": "249",
    "Gcolor": "129",
    "Bcolor": "28",
    "Y": 36,
    "L": 66.4078958972413,
    "a": 40.8886595872328,
    "b": 67.7148777063122,
    "C": 79.1023839439838,
    "h": 1.02756124168486,
    "CMY_C": 0.02284942,
    "CMY_M": 0.4956976,
    "CMY_Y": 0.8913127,
    "CMYK_C": 0,
    "CMYK_M": 0.4839052,
    "CMYK_Y": 0.8887712,
    "CMYK_K": 0.02284942
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0201",
    "Farbtonhilfsbezeichnung": "L 404",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "113",
    "Bcolor": "42",
    "Y": 28,
    "L": 59.5318183898926,
    "a": 38.9777374267578,
    "b": 55.6661720275879,
    "C": 67.9557723999023,
    "h": 55.0000953674316,
    "CMY_C": 0.12508344650269,
    "CMY_M": 0.55812764167786,
    "CMY_Y": 0.83623075485229,
    "CMYK_C": 0,
    "CMYK_M": 0.49495485424995,
    "CMYK_Y": 0.81281727552414,
    "CMYK_K": 0.12508344650269
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0202",
    "Farbtonhilfsbezeichnung": "L 504",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "93",
    "Bcolor": "44",
    "Y": 22,
    "L": 53.134765625,
    "a": 42.5300140380859,
    "b": 47.8927993774414,
    "C": 64.0509338378906,
    "h": 48.394115447998,
    "CMY_C": 0.19001632928848,
    "CMY_M": 0.63613450527191,
    "CMY_Y": 0.82855021953583,
    "CMYK_C": 0,
    "CMYK_M": 0.55077427625656,
    "CMYK_Y": 0.78832936286926,
    "CMYK_K": 0.19001632928848
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0203",
    "Farbtonhilfsbezeichnung": "L 105",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "144",
    "Bcolor": "73",
    "Y": 42,
    "L": 70.6638084511639,
    "a": 36.3569248633202,
    "b": 54.1891356079481,
    "C": 65.2555622414956,
    "h": 0.979850431527,
    "CMY_C": 0.002592715,
    "CMY_M": 0.4335612,
    "CMY_Y": 0.7140512,
    "CMYK_C": 0,
    "CMYK_M": 0.4320888,
    "CMYK_Y": 0.7133079,
    "CMYK_K": 0.002592715
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0204",
    "Farbtonhilfsbezeichnung": "L 205",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "107",
    "Bcolor": "44",
    "Y": 29,
    "L": 60.1203269958496,
    "a": 45.8517723083496,
    "b": 55.9046669006348,
    "C": 72.3029479980469,
    "h": 50.6421546936035,
    "CMY_C": 0.08252608776093,
    "CMY_M": 0.57893991470337,
    "CMY_Y": 0.82788640260696,
    "CMYK_C": 0,
    "CMYK_M": 0.54106587171555,
    "CMYK_Y": 0.81240493059158,
    "CMYK_K": 0.08252608776093
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0205",
    "Farbtonhilfsbezeichnung": "L 305",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "88",
    "Bcolor": "38",
    "Y": 24,
    "L": 55.0129623413086,
    "a": 51.0027236938477,
    "b": 53.0454902648926,
    "C": 73.5873794555664,
    "h": 46.1247367858887,
    "CMY_C": 0.12219089269638,
    "CMY_M": 0.65491724014282,
    "CMY_Y": 0.84913778305054,
    "CMYK_C": 0,
    "CMYK_M": 0.60688179731369,
    "CMYK_Y": 0.82813781499863,
    "CMYK_K": 0.12219089269638
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0206",
    "Farbtonhilfsbezeichnung": "L 405",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "76",
    "Bcolor": "40",
    "Y": 20,
    "L": 51.4934802047442,
    "a": 52.750869712507,
    "b": 48.6269220744298,
    "C": 71.7442109571118,
    "h": 0.74474157503292,
    "CMY_C": 0.1598575,
    "CMY_M": 0.7007911,
    "CMY_Y": 0.8438954,
    "CMYK_C": 0,
    "CMYK_M": 0.6438594,
    "CMYK_Y": 0.8141928,
    "CMYK_K": 0.1598575
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0207",
    "Farbtonhilfsbezeichnung": "L 505",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "68",
    "Bcolor": "50",
    "Y": 13,
    "L": 42.8200757044676,
    "a": 41.4366254317071,
    "b": 31.6357320266114,
    "C": 52.1326526087745,
    "h": 0.6520680203717,
    "CMY_C": 0.3290795,
    "CMY_M": 0.7333403,
    "CMY_Y": 0.802231,
    "CMYK_C": 0,
    "CMYK_M": 0.6025466,
    "CMYK_Y": 0.7052274,
    "CMYK_K": 0.3290795
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0208",
    "Farbtonhilfsbezeichnung": "L 106",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "111",
    "Bcolor": "99",
    "Y": 29,
    "L": 60.936431969687,
    "a": 46.0559473770654,
    "b": 28.0250321232984,
    "C": 53.912454167019,
    "h": 0.54664588200392,
    "CMY_C": 0.09413521,
    "CMY_M": 0.5663702,
    "CMY_Y": 0.6105309,
    "CMYK_C": 0,
    "CMYK_M": 0.5213085,
    "CMYK_Y": 0.5700583,
    "CMYK_K": 0.09413521
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0209",
    "Farbtonhilfsbezeichnung": "L 206",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "59",
    "Bcolor": "42",
    "Y": 15,
    "L": 44.5811347961426,
    "a": 51.6655235290527,
    "b": 39.4311981201172,
    "C": 64.9934310913086,
    "h": 37.3509254455566,
    "CMY_C": 0.25493723154068,
    "CMY_M": 0.76838934421539,
    "CMY_Y": 0.83653682470322,
    "CMYK_C": 0,
    "CMYK_M": 0.68913942575455,
    "CMYK_Y": 0.78060483932495,
    "CMYK_K": 0.25493723154068
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0210",
    "Farbtonhilfsbezeichnung": "L 306",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "44",
    "Bcolor": "39",
    "Y": 12,
    "L": 41.8692436218262,
    "a": 55.7805976867676,
    "b": 37.891170501709,
    "C": 67.4330444335938,
    "h": 34.1878509521484,
    "CMY_C": 0.26982080936432,
    "CMY_M": 0.82718873023987,
    "CMY_Y": 0.84708100557327,
    "CMYK_C": 0,
    "CMYK_M": 0.76333034038544,
    "CMYK_Y": 0.79057335853577,
    "CMYK_K": 0.26982080936432
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0211",
    "Farbtonhilfsbezeichnung": "L 406",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 11,
    "L": 39.2133827209473,
    "a": 46.3977737426758,
    "b": 28.1887054443359,
    "C": 54.2895622253418,
    "h": 31.28053855896,
    "CMY_C": 0.35047245025635,
    "CMY_M": 0.79424893856049,
    "CMY_Y": 0.80898976325989,
    "CMYK_C": 0,
    "CMYK_M": 0.68322968482971,
    "CMYK_Y": 0.70592433214188,
    "CMYK_K": 0.35047245025635
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0212",
    "Farbtonhilfsbezeichnung": "L 506",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "42",
    "Bcolor": "43",
    "Y": 9,
    "L": 35.5074310302734,
    "a": 46.3064498901367,
    "b": 26.5441188812256,
    "C": 53.3748779296875,
    "h": 29.8225116729736,
    "CMY_C": 0.39525365829468,
    "CMY_M": 0.83356380462646,
    "CMY_Y": 0.82997649908066,
    "CMYK_C": 0,
    "CMYK_M": 0.72478348016739,
    "CMYK_Y": 0.7188515663147,
    "CMYK_K": 0.39525365829468
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0213",
    "Farbtonhilfsbezeichnung": "L 107",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "108",
    "Bcolor": "115",
    "Y": 27,
    "L": 58.5655783402265,
    "a": 43.6839603901522,
    "b": 15.22898880632,
    "C": 46.2624090967105,
    "h": 0.33544257618144,
    "CMY_C": 0.1508919,
    "CMY_M": 0.5782194,
    "CMY_Y": 0.5474111,
    "CMYK_C": 0,
    "CMYK_M": 0.5032663,
    "CMYK_Y": 0.4669832,
    "CMYK_K": 0.1508919
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0214",
    "Farbtonhilfsbezeichnung": "L 207",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "68",
    "Bcolor": "79",
    "Y": 18,
    "L": 47.7456741333008,
    "a": 52.4754447937012,
    "b": 21.7002716064453,
    "C": 56.7853317260742,
    "h": 22.4666557312012,
    "CMY_C": 0.22620910406113,
    "CMY_M": 0.73386234045029,
    "CMY_Y": 0.69007885456085,
    "CMYK_C": 0,
    "CMYK_M": 0.65605998039246,
    "CMYK_Y": 0.59947687387466,
    "CMYK_K": 0.22620910406113
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0215",
    "Farbtonhilfsbezeichnung": "L 307",
    "Farbtonklasse": "04",
    "Rcolor": "176",
    "Gcolor": "59",
    "Bcolor": "79",
    "Y": 13,
    "L": 42.6383524400025,
    "a": 49.3548929788475,
    "b": 14.3532918667815,
    "C": 51.3996347104384,
    "h": 0.28301181092362,
    "CMY_C": 0.3088435,
    "CMY_M": 0.7699228,
    "CMY_Y": 0.6908609,
    "CMYK_C": 0,
    "CMYK_M": 0.6671127,
    "CMYK_Y": 0.5527219,
    "CMYK_K": 0.3088435
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0216",
    "Farbtonhilfsbezeichnung": "L 407",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "51",
    "Bcolor": "61",
    "Y": 10,
    "L": 38.0607389417352,
    "a": 45.5249217296975,
    "b": 19.0395341358394,
    "C": 49.3459457159844,
    "h": 0.39611583492097,
    "CMY_C": 0.3751582,
    "CMY_M": 0.7994253,
    "CMY_Y": 0.7616779,
    "CMYK_C": 0,
    "CMYK_M": 0.6789992,
    "CMYK_Y": 0.6185881,
    "CMYK_K": 0.3751582
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0217",
    "Farbtonhilfsbezeichnung": "L 507",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "46",
    "Bcolor": "64",
    "Y": 7,
    "L": 32.331550905287,
    "a": 38.7164772203936,
    "b": 8.17676765496312,
    "C": 39.5705084329291,
    "h": 0.20813746499053,
    "CMY_C": 0.4820764,
    "CMY_M": 0.8199826,
    "CMY_Y": 0.7477196,
    "CMYK_C": 0,
    "CMYK_M": 0.6524249,
    "CMYK_Y": 0.5129005,
    "CMYK_K": 0.4820764
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0218",
    "Farbtonhilfsbezeichnung": "L 108",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "68",
    "Bcolor": "121",
    "Y": 17,
    "L": 47.1585083007813,
    "a": 52.8927192687988,
    "b": -5.04655885696411,
    "C": 53.1329231262207,
    "h": 354.549835205078,
    "CMY_C": 0.26614367961884,
    "CMY_M": 0.73189783096313,
    "CMY_Y": 0.52536344528198,
    "CMYK_C": 0,
    "CMYK_M": 0.63466668128967,
    "CMYK_Y": 0.35322958230972,
    "CMYK_K": 0.26614367961884
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0219",
    "Farbtonhilfsbezeichnung": "L 208",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "59",
    "Bcolor": "106",
    "Y": 12,
    "L": 41.6748702049707,
    "a": 48.4718420186187,
    "b": -4.57687597964965,
    "C": 48.6874446075272,
    "h": -0.09414426927112,
    "CMY_C": 0.3498977,
    "CMY_M": 0.7675928,
    "CMY_Y": 0.5823777,
    "CMYK_C": 0,
    "CMYK_M": 0.6425068,
    "CMYK_Y": 0.3576052,
    "CMYK_K": 0.3498977
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0220",
    "Farbtonhilfsbezeichnung": "L 308",
    "Farbtonklasse": "04",
    "Rcolor": "144",
    "Gcolor": "58",
    "Bcolor": "117",
    "Y": 11,
    "L": 38.3356399536133,
    "a": 43.4903869628906,
    "b": -16.5054988861084,
    "C": 46.5171508789063,
    "h": 339.217224121094,
    "CMY_C": 0.43528306484222,
    "CMY_M": 0.77104419469833,
    "CMY_Y": 0.54134035110474,
    "CMYK_C": 0,
    "CMYK_M": 0.59456539154053,
    "CMYK_Y": 0.18780609965324,
    "CMYK_K": 0.43528306484222
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0221",
    "Farbtonhilfsbezeichnung": "L 408",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "55",
    "Bcolor": "103",
    "Y": 8,
    "L": 33.7614931516715,
    "a": 36.2784582581526,
    "b": -14.9230486083385,
    "C": 39.2278461472887,
    "h": -0.39025016184498,
    "CMY_C": 0.5178141,
    "CMY_M": 0.7853374,
    "CMY_Y": 0.59639,
    "CMYK_C": 0,
    "CMYK_M": 0.5548137,
    "CMYK_Y": 0.1629578,
    "CMYK_K": 0.5178141
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0222",
    "Farbtonhilfsbezeichnung": "L 508",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "60",
    "Bcolor": "112",
    "Y": 8,
    "L": 33.6449955012269,
    "a": 31.2329267759583,
    "b": -20.9880770431579,
    "C": 37.629710242864,
    "h": -0.59167590796553,
    "CMY_C": 0.5621347,
    "CMY_M": 0.7641351,
    "CMY_Y": 0.5609536,
    "CMYK_C": 0.002690098,
    "CMYK_M": 0.462779,
    "CMYK_Y": 0,
    "CMYK_K": 0.5609536
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0223",
    "Farbtonhilfsbezeichnung": "L 110",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "154",
    "Bcolor": "199",
    "Y": 34,
    "L": 64.6264541062113,
    "a": 8.19218484005851,
    "b": -24.4602794210071,
    "C": 25.7956810688811,
    "h": -1.24762036218301,
    "CMY_C": 0.4179102,
    "CMY_M": 0.3958881,
    "CMY_Y": 0.2203838,
    "CMYK_C": 0.2533637,
    "CMYK_M": 0.2251163,
    "CMYK_Y": 0,
    "CMYK_K": 0.2203838
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0224",
    "Farbtonhilfsbezeichnung": "L 210",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "127",
    "Bcolor": "181",
    "Y": 23,
    "L": 54.9132244054285,
    "a": 11.8406943626195,
    "b": -29.6719214421681,
    "C": 31.9472215546073,
    "h": -1.19110586590834,
    "CMY_C": 0.5144126,
    "CMY_M": 0.5013016,
    "CMY_Y": 0.28875,
    "CMYK_C": 0.3172761,
    "CMYK_M": 0.2988423,
    "CMYK_Y": 0,
    "CMYK_K": 0.28875
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0225",
    "Farbtonhilfsbezeichnung": "L 310",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "101",
    "Bcolor": "157",
    "Y": 14,
    "L": 44.4741752419687,
    "a": 12.5233577892603,
    "b": -31.6147270944699,
    "C": 34.0047858334034,
    "h": -1.19363563438193,
    "CMY_C": 0.6257268,
    "CMY_M": 0.6042586,
    "CMY_Y": 0.3857777,
    "CMYK_C": 0.390655,
    "CMYK_M": 0.3557033,
    "CMYK_Y": 0,
    "CMYK_K": 0.3857777
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0226",
    "Farbtonhilfsbezeichnung": "L 410",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "79",
    "Bcolor": "130",
    "Y": 9,
    "L": 35.4383694487323,
    "a": 12.3308645373657,
    "b": -29.9507442867725,
    "C": 32.3897715887361,
    "h": -1.18024052400965,
    "CMY_C": 0.707836,
    "CMY_M": 0.689338,
    "CMY_Y": 0.4889973,
    "CMYK_C": 0.4282535,
    "CMYK_M": 0.3920541,
    "CMYK_Y": 0,
    "CMYK_K": 0.4889973
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0227",
    "Farbtonhilfsbezeichnung": "L 510",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "63",
    "Bcolor": "113",
    "Y": 6,
    "L": 28.716973314845,
    "a": 13.4533535931379,
    "b": -30.0966163215035,
    "C": 32.9666352075214,
    "h": -1.15043540220031,
    "CMY_C": 0.7650547,
    "CMY_M": 0.7525035,
    "CMY_Y": 0.5549611,
    "CMYK_C": 0.4720793,
    "CMYK_M": 0.4438767,
    "CMYK_Y": 0,
    "CMYK_K": 0.5549611
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0228",
    "Farbtonhilfsbezeichnung": "L 111",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "156",
    "Bcolor": "207",
    "Y": 31,
    "L": 62.6737544535153,
    "a": -2.7175123740511,
    "b": -32.0486070693198,
    "C": 32.1636143582586,
    "h": 1.48620521143123,
    "CMY_C": 0.5889947,
    "CMY_M": 0.3888706,
    "CMY_Y": 0.1899465,
    "CMYK_C": 0.4926196,
    "CMYK_M": 0.2455692,
    "CMYK_Y": 0,
    "CMYK_K": 0.1899465
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0229",
    "Farbtonhilfsbezeichnung": "L 211",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "136",
    "Bcolor": "190",
    "Y": 24,
    "L": 55.6278937594235,
    "a": -0.06118718792258,
    "b": -33.7962219868652,
    "C": 33.7962773757323,
    "h": 1.56898585457427,
    "CMY_C": 0.649538,
    "CMY_M": 0.4657316,
    "CMY_Y": 0.2541203,
    "CMYK_C": 0.530136,
    "CMYK_M": 0.283707,
    "CMYK_Y": 0,
    "CMYK_K": 0.2541203
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0230",
    "Farbtonhilfsbezeichnung": "L 311",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "113",
    "Bcolor": "174",
    "Y": 16,
    "L": 46.5640824722897,
    "a": 2.48818307896498,
    "b": -38.6444801968995,
    "C": 38.7245000577542,
    "h": -1.50649857358824,
    "CMY_C": 0.7679221,
    "CMY_M": 0.5587245,
    "CMY_Y": 0.3182715,
    "CMYK_C": 0.6595743,
    "CMYK_M": 0.3527108,
    "CMYK_Y": 0,
    "CMYK_K": 0.3182715
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0231",
    "Farbtonhilfsbezeichnung": "L 411",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "108",
    "Bcolor": "168",
    "Y": 15,
    "L": 45.0853964693004,
    "a": 4.7312853164963,
    "b": -37.42886564369,
    "C": 37.7267152574869,
    "h": -1.44505583265572,
    "CMY_C": 0.7416679,
    "CMY_M": 0.5782781,
    "CMY_Y": 0.3418075,
    "CMYK_C": 0.6075129,
    "CMYK_M": 0.3592727,
    "CMYK_Y": 0,
    "CMYK_K": 0.3418075
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0232",
    "Farbtonhilfsbezeichnung": "L 511",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "84",
    "Bcolor": "141",
    "Y": 9,
    "L": 35.902487211365,
    "a": 7.9478016285203,
    "b": -36.159408947028,
    "C": 37.0225661742229,
    "h": -1.35443775849862,
    "CMY_C": 0.7932488,
    "CMY_M": 0.6723283,
    "CMY_Y": 0.4453057,
    "CMYK_C": 0.62727,
    "CMYK_M": 0.4092751,
    "CMYK_Y": 0,
    "CMYK_K": 0.4453057
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0233",
    "Farbtonhilfsbezeichnung": "L 112",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "158",
    "Bcolor": "202",
    "Y": 32,
    "L": 63.0930713445129,
    "a": -5.91591409907055,
    "b": -28.7301777786258,
    "C": 29.3329363483955,
    "h": 1.36772180899055,
    "CMY_C": 0.5957555,
    "CMY_M": 0.3792091,
    "CMY_Y": 0.2086791,
    "CMYK_C": 0.4891522,
    "CMYK_M": 0.2155005,
    "CMYK_Y": 0,
    "CMYK_K": 0.2086791
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0234",
    "Farbtonhilfsbezeichnung": "L 212",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "139",
    "Bcolor": "188",
    "Y": 23,
    "L": 55.0050108287079,
    "a": -8.4684190391725,
    "b": -33.7950780015714,
    "C": 34.8399399849557,
    "h": 1.32527050848815,
    "CMY_C": 0.7783639,
    "CMY_M": 0.4553126,
    "CMY_Y": 0.2614642,
    "CMYK_C": 0.6998979,
    "CMYK_M": 0.2624767,
    "CMYK_Y": 0,
    "CMYK_K": 0.2614642
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0235",
    "Farbtonhilfsbezeichnung": "L 312",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "114",
    "Bcolor": "163",
    "Y": 15,
    "L": 45.8481554173006,
    "a": -6.2151061761534,
    "b": -33.2174179676495,
    "C": 33.7938515298033,
    "h": 1.38583111791196,
    "CMY_C": 0.857442,
    "CMY_M": 0.55102,
    "CMY_Y": 0.3622986,
    "CMYK_C": 0.7764503,
    "CMYK_M": 0.29594,
    "CMYK_Y": 0,
    "CMYK_K": 0.3622986
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0236",
    "Farbtonhilfsbezeichnung": "L 412",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "97",
    "Bcolor": "149",
    "Y": 11,
    "L": 39.8504045790515,
    "a": 0.46408150003277,
    "b": -34.620491359754,
    "C": 34.6236016848258,
    "h": -1.55739230830796,
    "CMY_C": 0.8347875,
    "CMY_M": 0.620841,
    "CMY_Y": 0.4150532,
    "CMYK_C": 0.7175599,
    "CMYK_M": 0.3518059,
    "CMYK_Y": 0,
    "CMYK_K": 0.4150532
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0237",
    "Farbtonhilfsbezeichnung": "L 512",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "84",
    "Bcolor": "140",
    "Y": 8,
    "L": 34.272294594673,
    "a": 0.75026254789106,
    "b": -38.0672412832967,
    "C": 38.0746339813201,
    "h": -1.55109000184749,
    "CMY_C": 1,
    "CMY_M": 0.6718825,
    "CMY_Y": 0.4503165,
    "CMYK_C": 1,
    "CMYK_M": 0.4030791,
    "CMYK_Y": 0,
    "CMYK_K": 0.4503165
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0238",
    "Farbtonhilfsbezeichnung": "L 113",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "158",
    "Bcolor": "209",
    "Y": 31,
    "L": 62.2477699236362,
    "a": -8.06773401500094,
    "b": -33.9387870855647,
    "C": 34.8845180699991,
    "h": 1.33741370624424,
    "CMY_C": 0.6806242,
    "CMY_M": 0.3816895,
    "CMY_Y": 0.1819091,
    "CMYK_C": 0.6096085,
    "CMYK_M": 0.2442032,
    "CMYK_Y": 0,
    "CMYK_K": 0.1819091
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0239",
    "Farbtonhilfsbezeichnung": "L 213",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "136",
    "Bcolor": "194",
    "Y": 22,
    "L": 53.55756145444,
    "a": -8.92896215361177,
    "b": -39.1571822465692,
    "C": 40.1623117690163,
    "h": 1.34660098157803,
    "CMY_C": 0.9459571,
    "CMY_M": 0.4669035,
    "CMY_Y": 0.2406469,
    "CMYK_C": 0.9288303,
    "CMYK_M": 0.2979597,
    "CMYK_Y": 0,
    "CMYK_K": 0.2406469
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0240",
    "Farbtonhilfsbezeichnung": "L 313",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "125",
    "Bcolor": "174",
    "Y": 17,
    "L": 48.5642368478398,
    "a": -13.3817690108244,
    "b": -35.5203257094213,
    "C": 37.9574140368181,
    "h": 1.21050495795717,
    "CMY_C": 1,
    "CMY_M": 0.5105105,
    "CMY_Y": 0.3188991,
    "CMYK_C": 1,
    "CMYK_M": 0.281326,
    "CMYK_Y": 0,
    "CMYK_K": 0.3188991
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0241",
    "Farbtonhilfsbezeichnung": "L 413",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "169",
    "Y": 14,
    "L": 44.8954890592818,
    "a": -9.24581884198761,
    "b": -38.7298328992373,
    "C": 39.8181506660178,
    "h": 1.33645628967431,
    "CMY_C": 1,
    "CMY_M": 0.5525761,
    "CMY_Y": 0.3361367,
    "CMYK_C": 1,
    "CMYK_M": 0.32603,
    "CMYK_Y": 0,
    "CMYK_K": 0.3361367
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0242",
    "Farbtonhilfsbezeichnung": "L 513",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "137",
    "Y": 9,
    "L": 34.084789276123,
    "a": -5.89849185943604,
    "b": -36.1824531555176,
    "C": 36.6600875854492,
    "h": 260.741058349609,
    "CMY_C": 1,
    "CMY_M": 0.66252934932709,
    "CMY_Y": 0.46454256772995,
    "CMYK_C": 1,
    "CMYK_M": 0.36975261569023,
    "CMYK_Y": 0,
    "CMYK_K": 0.46454256772995
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0243",
    "Farbtonhilfsbezeichnung": "L 114",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "188",
    "Bcolor": "220",
    "Y": 42,
    "L": 70.8708952575669,
    "a": -23.1901081792698,
    "b": -26.9823948453795,
    "C": 35.5785152719755,
    "h": 0.86083967430365,
    "CMY_C": 0.7516083,
    "CMY_M": 0.2645772,
    "CMY_Y": 0.1372994,
    "CMYK_C": 0.7120765,
    "CMYK_M": 0.1475341,
    "CMYK_Y": 0,
    "CMYK_K": 0.1372994
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0244",
    "Farbtonhilfsbezeichnung": "L 214",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "165",
    "Bcolor": "203",
    "Y": 31,
    "L": 62.0974010272994,
    "a": -25.9022811202939,
    "b": -31.4293248517405,
    "C": 40.7275168389993,
    "h": 0.88150598924362,
    "CMY_C": 1,
    "CMY_M": 0.3520021,
    "CMY_Y": 0.2023325,
    "CMYK_C": 1,
    "CMYK_M": 0.1876341,
    "CMYK_Y": 0,
    "CMYK_K": 0.2023325
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0245",
    "Farbtonhilfsbezeichnung": "L 314",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "184",
    "Y": 22,
    "L": 54.0545598793901,
    "a": -22.8980005939348,
    "b": -32.6813437334764,
    "C": 39.9047448234603,
    "h": 0.95963800758457,
    "CMY_C": 1,
    "CMY_M": 0.4402356,
    "CMY_Y": 0.2802218,
    "CMYK_C": 1,
    "CMYK_M": 0.22231,
    "CMYK_Y": 0,
    "CMYK_K": 0.2802218
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0246",
    "Farbtonhilfsbezeichnung": "L 414",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "117",
    "Bcolor": "156",
    "Y": 14,
    "L": 43.9698665339985,
    "a": -22.5304955361021,
    "b": -32.1759288497062,
    "C": 39.2799392367615,
    "h": 0.95991716618881,
    "CMY_C": 1,
    "CMY_M": 0.5428283,
    "CMY_Y": 0.389753,
    "CMYK_C": 1,
    "CMYK_M": 0.2508415,
    "CMYK_Y": 0,
    "CMYK_K": 0.389753
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0247",
    "Farbtonhilfsbezeichnung": "L 514",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "140",
    "Y": 10,
    "L": 36.2848167419434,
    "a": -12.360761642456,
    "b": -34.8311233520508,
    "C": 36.9593772888184,
    "h": 250.461395263672,
    "CMY_C": 1,
    "CMY_M": 0.63188028335571,
    "CMY_Y": 0.45106935501099,
    "CMYK_C": 1,
    "CMYK_M": 0.32938757538795,
    "CMYK_Y": 0,
    "CMYK_K": 0.45106935501099
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0248",
    "Farbtonhilfsbezeichnung": "L 116",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "192",
    "Bcolor": "183",
    "Y": 42,
    "L": 70.6946519281764,
    "a": -37.384349300609,
    "b": -6.7018327573233,
    "C": 37.9803124649742,
    "h": 0.17738421496495,
    "CMY_C": 0.7837058,
    "CMY_M": 0.2485733,
    "CMY_Y": 0.2841007,
    "CMYK_C": 0.7121552,
    "CMYK_M": 0,
    "CMYK_Y": 0.04728,
    "CMYK_K": 0.2485733
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0249",
    "Farbtonhilfsbezeichnung": "L 216",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "174",
    "Bcolor": "168",
    "Y": 33,
    "L": 64.0997846690271,
    "a": -38.0977810051323,
    "b": -8.50302324381122,
    "C": 39.0351421388448,
    "h": 0.21959047941664,
    "CMY_C": 1,
    "CMY_M": 0.3184382,
    "CMY_Y": 0.340989,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.033087,
    "CMYK_K": 0.3184382
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0250",
    "Farbtonhilfsbezeichnung": "L 316",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "148",
    "Bcolor": "144",
    "Y": 22,
    "L": 54.5356207237716,
    "a": -37.9858526979233,
    "b": -9.04747118281197,
    "C": 39.0484537464948,
    "h": 0.23382341354053,
    "CMY_C": 1,
    "CMY_M": 0.419936,
    "CMY_Y": 0.435804,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02735569,
    "CMYK_K": 0.419936
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0251",
    "Farbtonhilfsbezeichnung": "L 416",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "120",
    "Y": 14,
    "L": 44.1263323350294,
    "a": -31.1288331243791,
    "b": -10.8029236270699,
    "C": 32.9500745155113,
    "h": 0.33403465520869,
    "CMY_C": 1,
    "CMY_M": 0.5357488,
    "CMY_Y": 0.5277481,
    "CMYK_C": 1,
    "CMYK_M": 0.01694158,
    "CMYK_Y": 0,
    "CMYK_K": 0.5277481
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0252",
    "Farbtonhilfsbezeichnung": "L 516",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "103",
    "Y": 9,
    "L": 35.0688852903181,
    "a": -30.4993017277285,
    "b": -13.6148076929718,
    "C": 33.4001556043625,
    "h": 0.41985392997437,
    "CMY_C": 1,
    "CMY_M": 0.6253247,
    "CMY_Y": 0.5977545,
    "CMYK_C": 1,
    "CMYK_M": 0.06854075,
    "CMYK_Y": 0,
    "CMYK_K": 0.5977545
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0253",
    "Farbtonhilfsbezeichnung": "L 117",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "194",
    "Bcolor": "159",
    "Y": 42,
    "L": 71.0435810472763,
    "a": -42.1515844775018,
    "b": 6.75533010417877,
    "C": 42.6894666022005,
    "h": -0.15891147229689,
    "CMY_C": 0.7248017,
    "CMY_M": 0.2404779,
    "CMY_Y": 0.3764071,
    "CMYK_C": 0.6376691,
    "CMYK_M": 0,
    "CMYK_Y": 0.1789667,
    "CMYK_K": 0.2404779
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0254",
    "Farbtonhilfsbezeichnung": "L 217",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "173",
    "Bcolor": "140",
    "Y": 32,
    "L": 63.5861526309021,
    "a": -43.1616835807322,
    "b": 6.67570956743038,
    "C": 43.6748901286761,
    "h": -0.15345158179288,
    "CMY_C": 0.8588212,
    "CMY_M": 0.320027,
    "CMY_Y": 0.4522763,
    "CMYK_C": 0.7923759,
    "CMYK_M": 0,
    "CMYK_Y": 0.194492,
    "CMYK_K": 0.320027
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0255",
    "Farbtonhilfsbezeichnung": "L 317",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "148",
    "Bcolor": "114",
    "Y": 22,
    "L": 53.6620072518555,
    "a": -47.3483454839463,
    "b": 6.83912203800923,
    "C": 47.8397262776233,
    "h": -0.14345053745945,
    "CMY_C": 1,
    "CMY_M": 0.420216,
    "CMY_Y": 0.5524332,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2280456,
    "CMYK_K": 0.420216
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0256",
    "Farbtonhilfsbezeichnung": "L 417",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "90",
    "Y": 15,
    "L": 44.9521815634018,
    "a": -44.1462036746875,
    "b": 8.35945072318243,
    "C": 44.9306990295089,
    "h": -0.18714254602137,
    "CMY_C": 1,
    "CMY_M": 0.5149849,
    "CMY_Y": 0.6455765,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2692527,
    "CMYK_K": 0.5149849
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0257",
    "Farbtonhilfsbezeichnung": "L 517",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "110",
    "Bcolor": "94",
    "Y": 11,
    "L": 40.1402058050119,
    "a": -38.8260245264903,
    "b": -1.00762518030079,
    "C": 38.8390974281793,
    "h": 0.02594648987416,
    "CMY_C": 1,
    "CMY_M": 0.5682356,
    "CMY_Y": 0.6296238,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1421799,
    "CMYK_K": 0.5682356
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0258",
    "Farbtonhilfsbezeichnung": "L 118",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "198",
    "Bcolor": "123",
    "Y": 45,
    "L": 73.0543391188921,
    "a": -40.4223719390659,
    "b": 29.103873179184,
    "C": 49.8096736308341,
    "h": -0.624019230432,
    "CMY_C": 0.5492973,
    "CMY_M": 0.2253272,
    "CMY_Y": 0.5177296,
    "CMYK_C": 0.4182025,
    "CMYK_M": 0,
    "CMYK_Y": 0.3774529,
    "CMYK_K": 0.2253272
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0259",
    "Farbtonhilfsbezeichnung": "L 218",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "168",
    "Bcolor": "99",
    "Y": 31,
    "L": 62.2955789876895,
    "a": -39.4983963299041,
    "b": 27.1970665602698,
    "C": 47.9562690596123,
    "h": -0.60300764998386,
    "CMY_C": 0.6612833,
    "CMY_M": 0.3428876,
    "CMY_Y": 0.6099051,
    "CMYK_C": 0.4845377,
    "CMYK_M": 0,
    "CMYK_Y": 0.4063497,
    "CMYK_K": 0.3428876
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0260",
    "Farbtonhilfsbezeichnung": "L 318",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "146",
    "Bcolor": "81",
    "Y": 21,
    "L": 53.3115524903025,
    "a": -47.8066844228502,
    "b": 25.0735634718038,
    "C": 53.9829849182181,
    "h": -0.4830378540535,
    "CMY_C": 0.9470019,
    "CMY_M": 0.4263007,
    "CMY_Y": 0.6818778,
    "CMYK_C": 0.9076204,
    "CMYK_M": 0,
    "CMYK_Y": 0.4454896,
    "CMYK_K": 0.4263007
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0261",
    "Farbtonhilfsbezeichnung": "L 418",
    "Farbtonklasse": "04",
    "Rcolor": "13",
    "Gcolor": "134",
    "Bcolor": "87",
    "Y": 18,
    "L": 49.1324234008789,
    "a": -41.8450393676758,
    "b": 16.4792060852051,
    "C": 44.9730110168457,
    "h": 158.504730224609,
    "CMY_C": 0.9472883939743,
    "CMY_M": 0.47618645429611,
    "CMY_Y": 0.66045022010803,
    "CMYK_C": 0.89936953783035,
    "CMYK_M": 0,
    "CMYK_Y": 0.35177358984947,
    "CMYK_K": 0.47618645429611
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0262",
    "Farbtonhilfsbezeichnung": "L 518",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "68",
    "Y": 12,
    "L": 41.4096527099609,
    "a": -43.1151351928711,
    "b": 16.8621807098389,
    "C": 46.2952270507813,
    "h": 158.639709472656,
    "CMY_C": 1,
    "CMY_M": 0.55356526374817,
    "CMY_Y": 0.73429918289185,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.40483838319778,
    "CMYK_K": 0.55356526374817
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0263",
    "Farbtonhilfsbezeichnung": "L 119",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "204",
    "Bcolor": "97",
    "Y": 53,
    "L": 77.7736932836709,
    "a": -27.1220227820641,
    "b": 48.8023441922095,
    "C": 55.8325435426839,
    "h": -1.06354737114813,
    "CMY_C": 0.3277019,
    "CMY_M": 0.199354,
    "CMY_Y": 0.620765,
    "CMYK_C": 0.1603054,
    "CMYK_M": 0,
    "CMYK_Y": 0.5263387,
    "CMYK_K": 0.199354
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0264",
    "Farbtonhilfsbezeichnung": "L 219",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "187",
    "Bcolor": "81",
    "Y": 43,
    "L": 71.3307035836584,
    "a": -29.3234996817217,
    "b": 48.3647277003828,
    "C": 56.5598313214962,
    "h": -1.02575787093708,
    "CMY_C": 0.4156844,
    "CMY_M": 0.265296,
    "CMY_Y": 0.6829175,
    "CMYK_C": 0.2046925,
    "CMYK_M": 0,
    "CMYK_Y": 0.5684215,
    "CMYK_K": 0.265296
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0265",
    "Farbtonhilfsbezeichnung": "L 319",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "160",
    "Bcolor": "41",
    "Y": 29,
    "L": 61.1790632283166,
    "a": -30.531606048548,
    "b": 53.7447204973667,
    "C": 61.8116004423425,
    "h": -1.05417386772984,
    "CMY_C": 0.5248029,
    "CMY_M": 0.3717297,
    "CMY_Y": 0.8385858,
    "CMYK_C": 0.2436422,
    "CMYK_M": 0,
    "CMYK_Y": 0.7430816,
    "CMYK_K": 0.3717297
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0266",
    "Farbtonhilfsbezeichnung": "L 419",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "137",
    "Bcolor": "54",
    "Y": 19,
    "L": 50.6985366793719,
    "a": -40.6062345054158,
    "b": 36.061434812241,
    "C": 54.3073969310474,
    "h": -0.72618823286373,
    "CMY_C": 0.7658096,
    "CMY_M": 0.4641564,
    "CMY_Y": 0.7869751,
    "CMYK_C": 0.56295,
    "CMYK_M": 0,
    "CMYK_Y": 0.6024495,
    "CMYK_K": 0.4641564
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0267",
    "Farbtonhilfsbezeichnung": "L 519",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "126",
    "Bcolor": "59",
    "Y": 18,
    "L": 49.0845123228791,
    "a": -21.9934861272882,
    "b": 32.446296718546,
    "C": 39.1979030405856,
    "h": -0.97509631075151,
    "CMY_C": 0.6199274,
    "CMY_M": 0.5075392,
    "CMY_Y": 0.7700112,
    "CMYK_C": 0.2282176,
    "CMYK_M": 0,
    "CMYK_Y": 0.5329806,
    "CMYK_K": 0.5075392
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0268",
    "Farbtonhilfsbezeichnung": "L 120",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "216",
    "Bcolor": "87",
    "Y": 63,
    "L": 83.3211877798605,
    "a": -20.0569049475891,
    "b": 60.1009451420314,
    "C": 63.3593169395165,
    "h": -1.24869755025649,
    "CMY_C": 0.194449,
    "CMY_M": 0.1534697,
    "CMY_Y": 0.6588407,
    "CMYK_C": 0.04840856,
    "CMYK_M": 0,
    "CMYK_Y": 0.5969911,
    "CMYK_K": 0.1534697
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0269",
    "Farbtonhilfsbezeichnung": "L 220",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "209",
    "Bcolor": "62",
    "Y": 57,
    "L": 80.4568244356492,
    "a": -21.9681948019357,
    "b": 66.7929949342116,
    "C": 70.31291314643,
    "h": -1.25304135175418,
    "CMY_C": 0.2318267,
    "CMY_M": 0.1817981,
    "CMY_Y": 0.756738,
    "CMYK_C": 0.06114461,
    "CMYK_M": 0,
    "CMYK_Y": 0.7026871,
    "CMYK_K": 0.1817981
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0270",
    "Farbtonhilfsbezeichnung": "L 320",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "186",
    "Bcolor": "47",
    "Y": 44,
    "L": 72.291625835222,
    "a": -21.4883087214818,
    "b": 63.4503359715167,
    "C": 66.9902421745739,
    "h": -1.24425637611732,
    "CMY_C": 0.3248734,
    "CMY_M": 0.2707763,
    "CMY_Y": 0.8143664,
    "CMYK_C": 0.07418442,
    "CMYK_M": 0,
    "CMYK_Y": 0.7454367,
    "CMYK_K": 0.2707763
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0271",
    "Farbtonhilfsbezeichnung": "L 420",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "163",
    "Bcolor": "32",
    "Y": 33,
    "L": 64.5368386233004,
    "a": -16.6312494550727,
    "b": 60.7277639684254,
    "C": 62.9639561578022,
    "h": -1.30348500376969,
    "CMY_C": 0.381087,
    "CMY_M": 0.361724,
    "CMY_Y": 0.8737242,
    "CMYK_C": 0.03033647,
    "CMYK_M": 0,
    "CMYK_Y": 0.8021612,
    "CMYK_K": 0.361724
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0272",
    "Farbtonhilfsbezeichnung": "L 520",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "137",
    "Bcolor": "42",
    "Y": 23,
    "L": 54.6289837460718,
    "a": -16.2842030921021,
    "b": 47.2152185784368,
    "C": 49.9444905445474,
    "h": -1.23867830898754,
    "CMY_C": 0.5007235,
    "CMY_M": 0.4630266,
    "CMY_Y": 0.8366064,
    "CMYK_C": 0.07020253,
    "CMYK_M": 0,
    "CMYK_Y": 0.6957138,
    "CMYK_K": 0.4630266
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0273",
    "Farbtonhilfsbezeichnung": "L 121",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "215",
    "Bcolor": "101",
    "Y": 68,
    "L": 86.1548706549595,
    "a": -4.22761961810297,
    "b": 57.7341735648003,
    "C": 57.8887516262517,
    "h": -1.4977011835767,
    "CMY_C": 0.05583328,
    "CMY_M": 0.1561776,
    "CMY_Y": 0.6026768,
    "CMYK_C": 0,
    "CMYK_M": 0.1062781,
    "CMYK_Y": 0.5791811,
    "CMYK_K": 0.05583328
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0274",
    "Farbtonhilfsbezeichnung": "L 221",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "220",
    "Bcolor": "62",
    "Y": 71,
    "L": 86.7026519775391,
    "a": -9.85200595855713,
    "b": 73.8913269042969,
    "C": 74.5452194213867,
    "h": 97.5945129394531,
    "CMY_C": 0.06772327423096,
    "CMY_M": 0.13921064138412,
    "CMY_Y": 0.75621366500854,
    "CMYK_C": 0,
    "CMYK_M": 0.07668041437864,
    "CMYK_Y": 0.73850435018539,
    "CMYK_K": 0.06772327423096
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0275",
    "Farbtonhilfsbezeichnung": "L 321",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "208",
    "Bcolor": "41",
    "Y": 64,
    "L": 83.978438199685,
    "a": -3.88473139232082,
    "b": 77.8174145993776,
    "C": 77.9143193060294,
    "h": -1.52091662877443,
    "CMY_C": 0.05773865,
    "CMY_M": 0.182899,
    "CMY_Y": 0.83925,
    "CMYK_C": 0,
    "CMYK_M": 0.1328298,
    "CMYK_Y": 0.8293997,
    "CMYK_K": 0.05773865
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0276",
    "Farbtonhilfsbezeichnung": "L 421",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "204",
    "Bcolor": "54",
    "Y": 57,
    "L": 80.3529045670597,
    "a": -13.1076330811326,
    "b": 69.7749307013578,
    "C": 70.9954294259066,
    "h": -1.38510457677599,
    "CMY_C": 0.1685661,
    "CMY_M": 0.2012214,
    "CMY_Y": 0.7867262,
    "CMYK_C": 0,
    "CMYK_M": 0.0392759,
    "CMYK_Y": 0.7434867,
    "CMYK_K": 0.1685661
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0277",
    "Farbtonhilfsbezeichnung": "L 521",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "176",
    "Bcolor": "19",
    "Y": 42,
    "L": 70.8119930844113,
    "a": -9.44740188841231,
    "b": 70.1569516135743,
    "C": 70.7901918499349,
    "h": -1.43694059332259,
    "CMY_C": 0.2550091,
    "CMY_M": 0.3110695,
    "CMY_Y": 0.9274196,
    "CMYK_C": 0,
    "CMYK_M": 0.0752498,
    "CMYK_Y": 0.9025754,
    "CMYK_K": 0.2550091
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0278",
    "Farbtonhilfsbezeichnung": "M 101",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "224",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.9279681788182,
    "a": 3.71752166845085,
    "b": 3.04018952537422,
    "C": 4.80236605285319,
    "h": 0.68550080438205,
    "CMY_C": 0.07429055,
    "CMY_M": 0.1223947,
    "CMY_Y": 0.1418536,
    "CMYK_C": 0,
    "CMYK_M": 0.05196464,
    "CMYK_Y": 0.0729851,
    "CMYK_K": 0.07429055
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0279",
    "Farbtonhilfsbezeichnung": "M 201",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "206",
    "Bcolor": "202",
    "Y": 64,
    "L": 83.7432104370458,
    "a": 4.38455357194151,
    "b": 2.59270843831347,
    "C": 5.09376551004529,
    "h": 0.53401848308381,
    "CMY_C": 0.1395621,
    "CMY_M": 0.1920137,
    "CMY_Y": 0.2059154,
    "CMYK_C": 0,
    "CMYK_M": 0.06095921,
    "CMYK_Y": 0.07711578,
    "CMYK_K": 0.1395621
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0280",
    "Farbtonhilfsbezeichnung": "M 301",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "193",
    "Bcolor": "190",
    "Y": 55,
    "L": 78.7627643263935,
    "a": 3.97402527953322,
    "b": 1.77240171444721,
    "C": 4.35135435924776,
    "h": 0.41951970234825,
    "CMY_C": 0.199873,
    "CMY_M": 0.2448881,
    "CMY_Y": 0.2536456,
    "CMYK_C": 0,
    "CMYK_M": 0.05626004,
    "CMYK_Y": 0.06720509,
    "CMYK_K": 0.199873
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0281",
    "Farbtonhilfsbezeichnung": "M 401",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "173",
    "Bcolor": "172",
    "Y": 43,
    "L": 71.3420745795003,
    "a": 3.4572868635655,
    "b": 1.05360688092631,
    "C": 3.61426616569918,
    "h": 0.29580853386867,
    "CMY_C": 0.2860035,
    "CMY_M": 0.3227555,
    "CMY_Y": 0.3272525,
    "CMYK_C": 0,
    "CMYK_M": 0.05147358,
    "CMYK_Y": 0.05777199,
    "CMYK_K": 0.2860035
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0282",
    "Farbtonhilfsbezeichnung": "M 501",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "152",
    "Bcolor": "151",
    "Y": 33,
    "L": 63.8770361852768,
    "a": 4.14723699582237,
    "b": 1.3254022633959,
    "C": 4.35387940339793,
    "h": 0.30932809481659,
    "CMY_C": 0.3592057,
    "CMY_M": 0.4024891,
    "CMY_Y": 0.40651,
    "CMYK_C": 0,
    "CMYK_M": 0.06754642,
    "CMYK_Y": 0.07382127,
    "CMYK_K": 0.3592057
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0283",
    "Farbtonhilfsbezeichnung": "M 103",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "214",
    "Bcolor": "219",
    "Y": 66,
    "L": 85.2282775849007,
    "a": -0.88064564094686,
    "b": -4.42105463726445,
    "C": 4.50791091866246,
    "h": 1.37417630387657,
    "CMY_C": 0.1878431,
    "CMY_M": 0.1612295,
    "CMY_Y": 0.1393401,
    "CMYK_C": 0.05635552,
    "CMYK_M": 0.02543322,
    "CMYK_Y": 0,
    "CMYK_K": 0.1393401
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0284",
    "Farbtonhilfsbezeichnung": "M 203",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "196",
    "Bcolor": "202",
    "Y": 55,
    "L": 78.8299947684089,
    "a": -0.88565814193863,
    "b": -4.35271095765648,
    "C": 4.44190083469735,
    "h": 1.3700638089794,
    "CMY_C": 0.2570623,
    "CMY_M": 0.2310775,
    "CMY_Y": 0.2095953,
    "CMYK_C": 0.06005404,
    "CMYK_M": 0.02717878,
    "CMYK_Y": 0,
    "CMYK_K": 0.2095953
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0285",
    "Farbtonhilfsbezeichnung": "M 303",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "173",
    "Bcolor": "180",
    "Y": 41,
    "L": 70.3263180770047,
    "a": -0.91075027080733,
    "b": -5.36104529260149,
    "C": 5.43785552263943,
    "h": 1.40251991935672,
    "CMY_C": 0.351391,
    "CMY_M": 0.3217366,
    "CMY_Y": 0.2934702,
    "CMYK_C": 0.08197922,
    "CMYK_M": 0.04000736,
    "CMYK_Y": 0,
    "CMYK_K": 0.2934702
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0286",
    "Farbtonhilfsbezeichnung": "M 403",
    "Farbtonklasse": "01",
    "Rcolor": "144",
    "Gcolor": "151",
    "Bcolor": "158",
    "Y": 30,
    "L": 62.0266449011854,
    "a": -0.60663705263441,
    "b": -5.61971773149414,
    "C": 5.65236551324299,
    "h": 1.46326475884727,
    "CMY_C": 0.4360522,
    "CMY_M": 0.4090226,
    "CMY_Y": 0.378541,
    "CMYK_C": 0.09254219,
    "CMYK_M": 0.0490485,
    "CMYK_Y": 0,
    "CMYK_K": 0.378541
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0287",
    "Farbtonhilfsbezeichnung": "M 503",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "126",
    "Bcolor": "137",
    "Y": 21,
    "L": 52.6417322703589,
    "a": -0.03429132582721,
    "b": -7.37811995573061,
    "C": 7.37819964328543,
    "h": 1.56614865514882,
    "CMY_C": 0.5327541,
    "CMY_M": 0.5049996,
    "CMY_Y": 0.4624802,
    "CMYK_C": 0.1307373,
    "CMYK_M": 0.07910299,
    "CMYK_Y": 0,
    "CMYK_K": 0.4624802
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0288",
    "Farbtonhilfsbezeichnung": "M 104",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "212",
    "Bcolor": "215",
    "Y": 65,
    "L": 84.7061554903892,
    "a": 0.16990160551744,
    "b": -2.90314143969161,
    "C": 2.90810879686646,
    "h": -1.51233963890328,
    "CMY_C": 0.1796136,
    "CMY_M": 0.1698625,
    "CMY_Y": 0.156004,
    "CMYK_C": 0.02797367,
    "CMYK_M": 0.01642014,
    "CMYK_Y": 0,
    "CMYK_K": 0.156004
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0289",
    "Farbtonhilfsbezeichnung": "M 204",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "196",
    "Bcolor": "204",
    "Y": 55,
    "L": 78.9731565219539,
    "a": 0.9136118820085,
    "b": -5.693677901718,
    "C": 5.76651148611177,
    "h": -1.41169183818138,
    "CMY_C": 0.2461537,
    "CMY_M": 0.233265,
    "CMY_Y": 0.1981863,
    "CMYK_C": 0.05982357,
    "CMYK_M": 0.04374919,
    "CMYK_Y": 0,
    "CMYK_K": 0.1981863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0290",
    "Farbtonhilfsbezeichnung": "M 304",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "177",
    "Bcolor": "185",
    "Y": 44,
    "L": 72.0748741821728,
    "a": 1.01814604160622,
    "b": -5.32034423602474,
    "C": 5.41688878894889,
    "h": -1.38171394009217,
    "CMY_C": 0.31773,
    "CMY_M": 0.3075591,
    "CMY_Y": 0.2749545,
    "CMYK_C": 0.05899706,
    "CMYK_M": 0.04496907,
    "CMYK_Y": 0,
    "CMYK_K": 0.2749545
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0291",
    "Farbtonhilfsbezeichnung": "M 404",
    "Farbtonklasse": "01",
    "Rcolor": "149",
    "Gcolor": "151",
    "Bcolor": "162",
    "Y": 31,
    "L": 62.7178103001422,
    "a": 1.8228712653951,
    "b": -6.80828524398605,
    "C": 7.04809248050004,
    "h": -1.30918925378174,
    "CMY_C": 0.4146883,
    "CMY_M": 0.406896,
    "CMY_Y": 0.3629508,
    "CMYK_C": 0.08121432,
    "CMYK_M": 0.06898244,
    "CMYK_Y": 0,
    "CMYK_K": 0.3629508
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0292",
    "Farbtonhilfsbezeichnung": "M 504",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "125",
    "Bcolor": "136",
    "Y": 21,
    "L": 52.5799018051691,
    "a": 1.2621157085701,
    "b": -6.97123551205232,
    "C": 7.08456495674355,
    "h": -1.39169020544661,
    "CMY_C": 0.5221395,
    "CMY_M": 0.508494,
    "CMY_Y": 0.4656561,
    "CMYK_C": 0.1057062,
    "CMYK_M": 0.08016924,
    "CMYK_Y": 0,
    "CMYK_K": 0.4656561
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0293",
    "Farbtonhilfsbezeichnung": "M 106",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "225",
    "Bcolor": "225",
    "Y": 73,
    "L": 88.3531587661836,
    "a": -4.85012327049911,
    "b": -2.65989588332094,
    "C": 5.53161295185632,
    "h": 0.50162796754703,
    "CMY_C": 0.179562,
    "CMY_M": 0.1180958,
    "CMY_Y": 0.11835,
    "CMYK_C": 0.0696972,
    "CMYK_M": 0,
    "CMYK_Y": 0.0002883112,
    "CMYK_K": 0.1180958
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0294",
    "Farbtonhilfsbezeichnung": "M 206",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "201",
    "Bcolor": "207",
    "Y": 56,
    "L": 79.3881041151962,
    "a": -6.79239755391037,
    "b": -6.76002068776296,
    "C": 9.5830341870073,
    "h": 0.7830091576883,
    "CMY_C": 0.3094414,
    "CMY_M": 0.2111842,
    "CMY_Y": 0.1869549,
    "CMYK_C": 0.1506515,
    "CMYK_M": 0.02980074,
    "CMYK_Y": 0,
    "CMYK_K": 0.1869549
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0295",
    "Farbtonhilfsbezeichnung": "M 306",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "181",
    "Bcolor": "191",
    "Y": 44,
    "L": 71.9125431906264,
    "a": -7.30346395270071,
    "b": -8.9273285080286,
    "C": 11.534200449041,
    "h": 0.88511472052372,
    "CMY_C": 0.4022687,
    "CMY_M": 0.2900272,
    "CMY_Y": 0.252223,
    "CMYK_C": 0.2006556,
    "CMYK_M": 0.05055548,
    "CMYK_Y": 0,
    "CMYK_K": 0.252223
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0296",
    "Farbtonhilfsbezeichnung": "M 406",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "154",
    "Bcolor": "167",
    "Y": 30,
    "L": 61.6900394293416,
    "a": -7.70882537255946,
    "b": -11.3747890595303,
    "C": 13.7408811498181,
    "h": 0.97518622675203,
    "CMY_C": 0.5226587,
    "CMY_M": 0.395991,
    "CMY_Y": 0.3434198,
    "CMYK_C": 0.2729885,
    "CMYK_M": 0.08006815,
    "CMYK_Y": 0,
    "CMYK_K": 0.3434198
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0297",
    "Farbtonhilfsbezeichnung": "M 506",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "129",
    "Bcolor": "144",
    "Y": 20,
    "L": 51.7130954763533,
    "a": -9.61643158270165,
    "b": -13.0028134359905,
    "C": 16.1724739491507,
    "h": 0.93400684484859,
    "CMY_C": 0.6493953,
    "CMY_M": 0.4935998,
    "CMY_Y": 0.4355604,
    "CMYK_C": 0.3788447,
    "CMYK_M": 0.1028266,
    "CMYK_Y": 0,
    "CMYK_K": 0.4355604
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0298",
    "Farbtonhilfsbezeichnung": "M 107",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "225",
    "Bcolor": "217",
    "Y": 74,
    "L": 89.0192152206987,
    "a": -3.01320259011845,
    "b": 2.35895249594751,
    "C": 3.82675407195622,
    "h": -0.66420954864908,
    "CMY_C": 0.1390797,
    "CMY_M": 0.1163165,
    "CMY_Y": 0.1477554,
    "CMYK_C": 0.02575939,
    "CMYK_M": 0,
    "CMYK_Y": 0.03557703,
    "CMYK_K": 0.1163165
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0299",
    "Farbtonhilfsbezeichnung": "M 207",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "213",
    "Bcolor": "206",
    "Y": 65,
    "L": 84.3541166360935,
    "a": -3.66640754345204,
    "b": 1.63387357317668,
    "C": 4.01398643841844,
    "h": -0.41921671090508,
    "CMY_C": 0.1980266,
    "CMY_M": 0.1661856,
    "CMY_Y": 0.193433,
    "CMYK_C": 0.03818717,
    "CMYK_M": 0,
    "CMYK_Y": 0.03267807,
    "CMYK_K": 0.1661856
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0300",
    "Farbtonhilfsbezeichnung": "M 307",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "197",
    "Bcolor": "193",
    "Y": 54,
    "L": 78.5122120838121,
    "a": -4.57254804439328,
    "b": 0.04209097407275,
    "C": 4.57274176707839,
    "h": -0.00920488639352,
    "CMY_C": 0.2740305,
    "CMY_M": 0.2274888,
    "CMY_Y": 0.245059,
    "CMYK_C": 0.06024733,
    "CMYK_M": 0,
    "CMYK_Y": 0.02274431,
    "CMYK_K": 0.2274888
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0301",
    "Farbtonhilfsbezeichnung": "M 407",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "177",
    "Bcolor": "175",
    "Y": 43,
    "L": 71.2935980849613,
    "a": -4.82214981527779,
    "b": -0.92545353779633,
    "C": 4.91015204363402,
    "h": 0.18961170407042,
    "CMY_C": 0.3560206,
    "CMY_M": 0.3041698,
    "CMY_Y": 0.3149173,
    "CMYK_C": 0.07451638,
    "CMYK_M": 0,
    "CMYK_Y": 0.01544561,
    "CMYK_K": 0.3041698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0302",
    "Farbtonhilfsbezeichnung": "M 507",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "151",
    "Bcolor": "149",
    "Y": 30,
    "L": 61.4240037135887,
    "a": -4.4961378811903,
    "b": -1.22850169160171,
    "C": 4.66095186125567,
    "h": 0.26672445288984,
    "CMY_C": 0.4564993,
    "CMY_M": 0.4081734,
    "CMY_Y": 0.4152295,
    "CMYK_C": 0.08165544,
    "CMYK_M": 0,
    "CMYK_Y": 0.01192256,
    "CMYK_K": 0.4081734
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0303",
    "Farbtonhilfsbezeichnung": "M 108",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "228",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.4343148182143,
    "a": -5.0938603384964,
    "b": 3.62782255234428,
    "C": 6.25367968634503,
    "h": -0.61886381435083,
    "CMY_C": 0.1468346,
    "CMY_M": 0.1072783,
    "CMY_Y": 0.1528619,
    "CMYK_C": 0.04430971,
    "CMYK_M": 0,
    "CMYK_Y": 0.05106131,
    "CMYK_K": 0.1072783
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0304",
    "Farbtonhilfsbezeichnung": "M 208",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "208",
    "Bcolor": "195",
    "Y": 61,
    "L": 82.2012684044179,
    "a": -5.79561874831985,
    "b": 4.25975559361689,
    "C": 7.19268478339117,
    "h": -0.63382907938482,
    "CMY_C": 0.2294017,
    "CMY_M": 0.1857327,
    "CMY_Y": 0.2360874,
    "CMYK_C": 0.05362976,
    "CMYK_M": 0,
    "CMYK_Y": 0.06184043,
    "CMYK_K": 0.1857327
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0305",
    "Farbtonhilfsbezeichnung": "M 308",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "199",
    "Bcolor": "187",
    "Y": 55,
    "L": 78.8792641934189,
    "a": -7.39792151638086,
    "b": 3.49629873668063,
    "C": 8.18250252787284,
    "h": -0.44149286460148,
    "CMY_C": 0.2806256,
    "CMY_M": 0.2182522,
    "CMY_Y": 0.2663532,
    "CMYK_C": 0.07978704,
    "CMYK_M": 0,
    "CMYK_Y": 0.06153011,
    "CMYK_K": 0.2182522
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0306",
    "Farbtonhilfsbezeichnung": "M 408",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "181",
    "Bcolor": "169",
    "Y": 44,
    "L": 71.8990100871208,
    "a": -8.79151367728004,
    "b": 3.09587140023739,
    "C": 9.32068304710603,
    "h": -0.33858281526605,
    "CMY_C": 0.3671563,
    "CMY_M": 0.2903692,
    "CMY_Y": 0.3374426,
    "CMYK_C": 0.1082072,
    "CMYK_M": 0,
    "CMYK_Y": 0.06633508,
    "CMYK_K": 0.2903692
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0307",
    "Farbtonhilfsbezeichnung": "M 508",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "153",
    "Bcolor": "143",
    "Y": 30,
    "L": 61.4522383934493,
    "a": -9.13787083631934,
    "b": 2.08874912305106,
    "C": 9.37355622591032,
    "h": -0.22472083341729,
    "CMY_C": 0.4810327,
    "CMY_M": 0.3992781,
    "CMY_Y": 0.4382084,
    "CMYK_C": 0.1360939,
    "CMYK_M": 0,
    "CMYK_Y": 0.06480595,
    "CMYK_K": 0.3992781
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0308",
    "Farbtonhilfsbezeichnung": "N 102",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "123",
    "Bcolor": "123",
    "Y": 20,
    "L": 51.3265932924383,
    "a": -1.09711953264496,
    "b": -1.25686006419936,
    "C": 1.66834303723495,
    "h": 0.85315406408743,
    "CMY_C": 0.5323229,
    "CMY_M": 0.5175525,
    "CMY_Y": 0.5161896,
    "CMYK_C": 0.0333464,
    "CMYK_M": 0.002816965,
    "CMYK_Y": 0,
    "CMYK_K": 0.5161896
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0309",
    "Farbtonhilfsbezeichnung": "N 202",
    "Farbtonklasse": "02",
    "Rcolor": "103",
    "Gcolor": "104",
    "Bcolor": "104",
    "Y": 14,
    "L": 43.945758172031,
    "a": -0.44461416690727,
    "b": -0.55042501113695,
    "C": 0.70756586287056,
    "h": 0.89133841160968,
    "CMY_C": 0.5974493,
    "CMY_M": 0.5913873,
    "CMY_Y": 0.5925643,
    "CMYK_C": 0.01483559,
    "CMYK_M": 0,
    "CMYK_Y": 0.002880641,
    "CMYK_K": 0.5913873
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0310",
    "Farbtonhilfsbezeichnung": "N 302",
    "Farbtonklasse": "02",
    "Rcolor": "85",
    "Gcolor": "87",
    "Bcolor": "90",
    "Y": 9,
    "L": 36.8808719536716,
    "a": 0.192162259879,
    "b": -2.74994848763684,
    "C": 2.75665431615536,
    "h": -1.50103123935023,
    "CMY_C": 0.6668003,
    "CMY_M": 0.6592428,
    "CMY_Y": 0.6455367,
    "CMYK_C": 0.0599882,
    "CMYK_M": 0.03866724,
    "CMYK_Y": 0,
    "CMYK_K": 0.6455367
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0311",
    "Farbtonhilfsbezeichnung": "N 402",
    "Farbtonklasse": "02",
    "Rcolor": "63",
    "Gcolor": "63",
    "Bcolor": "66",
    "Y": 5,
    "L": 26.5912156053436,
    "a": 0.93232478089766,
    "b": -2.54341162664382,
    "C": 2.70890608911104,
    "h": -1.21944146639888,
    "CMY_C": 0.754768,
    "CMY_M": 0.754433,
    "CMY_Y": 0.7405664,
    "CMYK_C": 0.05474054,
    "CMYK_M": 0.05344928,
    "CMYK_Y": 0,
    "CMYK_K": 0.7405664
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0312",
    "Farbtonhilfsbezeichnung": "N 502",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "33",
    "Bcolor": "34",
    "Y": 1,
    "L": 12.4969816207886,
    "a": 0.20537930727005,
    "b": -1.20154058933258,
    "C": 1.21896696090698,
    "h": 279.699829101563,
    "CMY_C": 0.87441521883011,
    "CMY_M": 0.87250149250031,
    "CMY_Y": 0.86742454767227,
    "CMYK_C": 0.05272975564003,
    "CMYK_M": 0.03829475864768,
    "CMYK_Y": 0,
    "CMYK_K": 0.86742454767227
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0313",
    "Farbtonhilfsbezeichnung": "R 101",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "220",
    "Bcolor": "208",
    "Y": 72,
    "L": 87.9573605254027,
    "a": -0.32900151551018,
    "b": 5.97026099542617,
    "C": 5.97931922134243,
    "h": -1.51574528474301,
    "CMY_C": 0.1180046,
    "CMY_M": 0.1353332,
    "CMY_Y": 0.1855754,
    "CMYK_C": 0,
    "CMYK_M": 0.01964713,
    "CMYK_Y": 0.07661138,
    "CMYK_K": 0.1180046
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0314",
    "Farbtonhilfsbezeichnung": "R 201",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 66,
    "L": 85.2965774536133,
    "a": -0.84123939275742,
    "b": 4.55694913864136,
    "C": 4.63394737243652,
    "h": 100.459381103516,
    "CMY_C": 0.15583109855652,
    "CMY_M": 0.16308009624481,
    "CMY_Y": 0.20416152477264,
    "CMYK_C": 0,
    "CMYK_M": 0.00858714152128,
    "CMYK_Y": 0.05725207924843,
    "CMYK_K": 0.15583109855652
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0315",
    "Farbtonhilfsbezeichnung": "R 301",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "192",
    "Bcolor": "182",
    "Y": 53,
    "L": 77.8461478524817,
    "a": -0.52599679049159,
    "b": 4.92570344129908,
    "C": 4.9537084103965,
    "h": -1.46441334951474,
    "CMY_C": 0.2336408,
    "CMY_M": 0.2451049,
    "CMY_Y": 0.2866666,
    "CMYK_C": 0,
    "CMYK_M": 0.0149591,
    "CMYK_Y": 0.06919177,
    "CMYK_K": 0.2336408
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0316",
    "Farbtonhilfsbezeichnung": "R 401",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 44,
    "L": 72.896842956543,
    "a": -0.03216871991754,
    "b": 5.14293718338013,
    "C": 5.14303779602051,
    "h": 90.3583755493164,
    "CMY_C": 0.28253388404846,
    "CMY_M": 0.29929167032242,
    "CMY_Y": 0.34028834104538,
    "CMYK_C": 0,
    "CMYK_M": 0.02335690334439,
    "CMYK_Y": 0.08049781620502,
    "CMYK_K": 0.28253388404846
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0317",
    "Farbtonhilfsbezeichnung": "R 501",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "142",
    "Bcolor": "133",
    "Y": 26,
    "L": 59.1291465759277,
    "a": -0.15005597472191,
    "b": 4.64374256134033,
    "C": 4.64616632461548,
    "h": 91.8507843017578,
    "CMY_C": 0.42907625436783,
    "CMY_M": 0.44244557619095,
    "CMY_Y": 0.4778938293457,
    "CMYK_C": 0,
    "CMYK_M": 0.02341700159013,
    "CMYK_Y": 0.08550629764795,
    "CMYK_K": 0.42907625436783
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0318",
    "Farbtonhilfsbezeichnung": "R 102",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "219",
    "Bcolor": "210",
    "Y": 72,
    "L": 87.916223369714,
    "a": 2.04183272933683,
    "b": 4.97604602320201,
    "C": 5.37867222645288,
    "h": 1.18141459486109,
    "CMY_C": 0.1034701,
    "CMY_M": 0.1411569,
    "CMY_Y": 0.1783633,
    "CMYK_C": 0,
    "CMYK_M": 0.04203639,
    "CMYK_Y": 0.08353683,
    "CMYK_K": 0.1034701
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0319",
    "Farbtonhilfsbezeichnung": "R 202",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "207",
    "Bcolor": "198",
    "Y": 63,
    "L": 83.6180957166191,
    "a": 2.15941734197561,
    "b": 4.77636046047969,
    "C": 5.2418224412182,
    "h": 1.1461931048008,
    "CMY_C": 0.1508753,
    "CMY_M": 0.1886393,
    "CMY_Y": 0.2234656,
    "CMYK_C": 0,
    "CMYK_M": 0.04447408,
    "CMYK_Y": 0.08548842,
    "CMYK_K": 0.1508753
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0320",
    "Farbtonhilfsbezeichnung": "R 302",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "190",
    "Bcolor": "182",
    "Y": 52,
    "L": 77.426183410963,
    "a": 2.46653187320284,
    "b": 4.42784568361692,
    "C": 5.06849059182815,
    "h": 1.06255649081701,
    "CMY_C": 0.2174729,
    "CMY_M": 0.2564419,
    "CMY_Y": 0.2871297,
    "CMYK_C": 0,
    "CMYK_M": 0.04979897,
    "CMYK_Y": 0.0890152,
    "CMYK_K": 0.2174729
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0321",
    "Farbtonhilfsbezeichnung": "R 402",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "173",
    "Bcolor": "166",
    "Y": 43,
    "L": 71.4401750727902,
    "a": 2.753853595931,
    "b": 4.53459483928893,
    "C": 5.30530489079826,
    "h": 1.0250274044832,
    "CMY_C": 0.2796525,
    "CMY_M": 0.3210119,
    "CMY_Y": 0.350814,
    "CMYK_C": 0,
    "CMYK_M": 0.05741584,
    "CMYK_Y": 0.0987877,
    "CMYK_K": 0.2796525
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0322",
    "Farbtonhilfsbezeichnung": "R 502",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "143",
    "Bcolor": "129",
    "Y": 29,
    "L": 60.8059675569595,
    "a": 5.75190478696641,
    "b": 9.3834555657659,
    "C": 11.0060731886096,
    "h": 1.02088468783052,
    "CMY_C": 0.3591227,
    "CMY_M": 0.4398099,
    "CMY_Y": 0.4925384,
    "CMYK_C": 0,
    "CMYK_M": 0.125901,
    "CMYK_Y": 0.2081766,
    "CMYK_K": 0.3591227
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0323",
    "Farbtonhilfsbezeichnung": "R 103",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 74,
    "L": 89.0552420048816,
    "a": 2.47267753659891,
    "b": 2.06589095991039,
    "C": 3.22211726326655,
    "h": 0.6960081907172,
    "CMY_C": 0.09668273,
    "CMY_M": 0.1287786,
    "CMY_Y": 0.1444289,
    "CMYK_C": 0,
    "CMYK_M": 0.0355311,
    "CMYK_Y": 0.05285644,
    "CMYK_K": 0.09668273
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0324",
    "Farbtonhilfsbezeichnung": "R 203",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "207",
    "Bcolor": "206",
    "Y": 63,
    "L": 83.6447168028717,
    "a": 2.96719507309401,
    "b": 0.78377657807045,
    "C": 3.06896600276464,
    "h": 0.25824881749721,
    "CMY_C": 0.1570302,
    "CMY_M": 0.1891699,
    "CMY_Y": 0.1940334,
    "CMYK_C": 0,
    "CMYK_M": 0.03812679,
    "CMYK_Y": 0.04389633,
    "CMYK_K": 0.1570302
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0325",
    "Farbtonhilfsbezeichnung": "R 303",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "186",
    "Bcolor": "187",
    "Y": 50,
    "L": 76.2362995961685,
    "a": 3.55194472121467,
    "b": -0.20261490899999,
    "C": 3.55771894672891,
    "h": -0.05698162188149,
    "CMY_C": 0.2366475,
    "CMY_M": 0.2705094,
    "CMY_Y": 0.2665653,
    "CMYK_C": 0,
    "CMYK_M": 0.04435952,
    "CMYK_Y": 0.03919264,
    "CMYK_K": 0.2366475
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0326",
    "Farbtonhilfsbezeichnung": "R 403",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "174",
    "Bcolor": "175",
    "Y": 43,
    "L": 71.8377411778336,
    "a": 4.04954566000493,
    "b": 0.05632117408458,
    "C": 4.04993729915847,
    "h": 0.01390712632342,
    "CMY_C": 0.2794674,
    "CMY_M": 0.3186214,
    "CMY_Y": 0.314946,
    "CMYK_C": 0,
    "CMYK_M": 0.05434033,
    "CMYK_Y": 0.04923934,
    "CMYK_K": 0.2794674
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0327",
    "Farbtonhilfsbezeichnung": "R 503",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "144",
    "Bcolor": "145",
    "Y": 29,
    "L": 60.5034951188048,
    "a": 3.93328883100258,
    "b": -0.31294892089639,
    "C": 3.94571895288804,
    "h": -0.07939692738902,
    "CMY_C": 0.4006947,
    "CMY_M": 0.4362403,
    "CMY_Y": 0.4298079,
    "CMYK_C": 0,
    "CMYK_M": 0.05931137,
    "CMYK_Y": 0.04857816,
    "CMYK_K": 0.4006947
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0328",
    "Farbtonhilfsbezeichnung": "R 104",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "225",
    "Bcolor": "225",
    "Y": 76,
    "L": 89.7136517693053,
    "a": 0.67702565569793,
    "b": -0.66364568716061,
    "C": 0.94804500766583,
    "h": -0.77541844359971,
    "CMY_C": 0.112473,
    "CMY_M": 0.1163907,
    "CMY_Y": 0.1173066,
    "CMYK_C": 0,
    "CMYK_M": 0.004414148,
    "CMYK_Y": 0.005446092,
    "CMYK_K": 0.112473
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0329",
    "Farbtonhilfsbezeichnung": "R 204",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "209",
    "Bcolor": "211",
    "Y": 64,
    "L": 83.8992037554478,
    "a": 0.89700491501054,
    "b": -1.82534090886339,
    "C": 2.03383560081028,
    "h": -1.11403806285944,
    "CMY_C": 0.1789309,
    "CMY_M": 0.1807312,
    "CMY_Y": 0.1725746,
    "CMYK_C": 0.007682049,
    "CMYK_M": 0.009857809,
    "CMYK_Y": 0,
    "CMYK_K": 0.1725746
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0330",
    "Farbtonhilfsbezeichnung": "R 304",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "187",
    "Bcolor": "192",
    "Y": 50,
    "L": 76.1824347264251,
    "a": 1.82489943885911,
    "b": -3.17116252047596,
    "C": 3.65876067722661,
    "h": -1.04861114148379,
    "CMY_C": 0.2601218,
    "CMY_M": 0.2661943,
    "CMY_Y": 0.2462115,
    "CMYK_C": 0.01845386,
    "CMYK_M": 0.02650985,
    "CMYK_Y": 0,
    "CMYK_K": 0.2462115
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0331",
    "Farbtonhilfsbezeichnung": "R 404",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "177",
    "Bcolor": "181",
    "Y": 44,
    "L": 72.3047098454448,
    "a": 1.74816028266644,
    "b": -2.93456347221941,
    "C": 3.41580549012628,
    "h": -1.03353432277049,
    "CMY_C": 0.3013446,
    "CMY_M": 0.3074807,
    "CMY_Y": 0.2892411,
    "CMYK_C": 0.01702893,
    "CMYK_M": 0.02566217,
    "CMYK_Y": 0,
    "CMYK_K": 0.2892411
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0332",
    "Farbtonhilfsbezeichnung": "R 504",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "145",
    "Bcolor": "152",
    "Y": 29,
    "L": 60.5544691700422,
    "a": 2.32059843540838,
    "b": -4.1331417923645,
    "C": 4.74004622068286,
    "h": -1.05919639281468,
    "CMY_C": 0.4239095,
    "CMY_M": 0.4310202,
    "CMY_Y": 0.4035074,
    "CMYK_C": 0.03420344,
    "CMYK_M": 0.04612427,
    "CMYK_Y": 0,
    "CMYK_K": 0.4035074
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0333",
    "Farbtonhilfsbezeichnung": "R 106",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "228",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.1176607315042,
    "a": -1.20983566719762,
    "b": -0.83558263739371,
    "C": 1.47034032983434,
    "h": 0.60442858531828,
    "CMY_C": 0.1236225,
    "CMY_M": 0.1073919,
    "CMY_Y": 0.111831,
    "CMYK_C": 0.01818331,
    "CMYK_M": 0,
    "CMYK_Y": 0.004973199,
    "CMYK_K": 0.1073919
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0334",
    "Farbtonhilfsbezeichnung": "R 206",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "209",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.4515987845808,
    "a": -1.54692450790112,
    "b": -2.18332021759029,
    "C": 2.67579195859536,
    "h": 0.95437556713389,
    "CMY_C": 0.2044161,
    "CMY_M": 0.1798549,
    "CMY_Y": 0.175175,
    "CMYK_C": 0.03545133,
    "CMYK_M": 0.005673766,
    "CMYK_Y": 0,
    "CMYK_K": 0.175175
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0335",
    "Farbtonhilfsbezeichnung": "R 306",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "192",
    "Bcolor": "197",
    "Y": 52,
    "L": 77.3404014223752,
    "a": -1.4417419227688,
    "b": -3.91289509952073,
    "C": 4.17005609455346,
    "h": 1.21777241303452,
    "CMY_C": 0.2758714,
    "CMY_M": 0.2460402,
    "CMY_Y": 0.2288915,
    "CMYK_C": 0.06092517,
    "CMYK_M": 0.02223902,
    "CMYK_Y": 0,
    "CMYK_K": 0.2288915
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0336",
    "Farbtonhilfsbezeichnung": "R 406",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "176",
    "Bcolor": "180",
    "Y": 43,
    "L": 71.6669898735134,
    "a": -0.95295420574015,
    "b": -3.23228028060369,
    "C": 3.36983048989372,
    "h": 1.2840947797275,
    "CMY_C": 0.3298921,
    "CMY_M": 0.3080488,
    "CMY_Y": 0.2942415,
    "CMYK_C": 0.05051386,
    "CMYK_M": 0.01956382,
    "CMYK_Y": 0,
    "CMYK_K": 0.2942415
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0337",
    "Farbtonhilfsbezeichnung": "R 506",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "155",
    "Bcolor": "159",
    "Y": 32,
    "L": 63.5881941527959,
    "a": -1.32681369050308,
    "b": -3.76625273682292,
    "C": 3.99313088277013,
    "h": 1.23208275542182,
    "CMY_C": 0.418884,
    "CMY_M": 0.3918407,
    "CMY_Y": 0.3751775,
    "CMYK_C": 0.06995024,
    "CMYK_M": 0.02666868,
    "CMYK_Y": 0,
    "CMYK_K": 0.3751775
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0338",
    "Farbtonhilfsbezeichnung": "R 107",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "224",
    "Bcolor": "218",
    "Y": 73,
    "L": 88.3474184409701,
    "a": -3.50964455184993,
    "b": 0.86183377613267,
    "C": 3.61391233125722,
    "h": -0.24079696102402,
    "CMY_C": 0.1556947,
    "CMY_M": 0.1222185,
    "CMY_Y": 0.1441625,
    "CMYK_C": 0.03813724,
    "CMYK_M": 0,
    "CMYK_Y": 0.02499941,
    "CMYK_K": 0.1222185
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0339",
    "Farbtonhilfsbezeichnung": "R 207",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "208",
    "Bcolor": "204",
    "Y": 61,
    "L": 82.5015664460703,
    "a": -3.77086590489117,
    "b": -0.1815512060795,
    "C": 3.7752338355524,
    "h": 0.04810861112741,
    "CMY_C": 0.2253948,
    "CMY_M": 0.185767,
    "CMY_Y": 0.2003337,
    "CMYK_C": 0.04866893,
    "CMYK_M": 0,
    "CMYK_Y": 0.01789005,
    "CMYK_K": 0.185767
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0340",
    "Farbtonhilfsbezeichnung": "R 307",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "189",
    "Bcolor": "189",
    "Y": 50,
    "L": 75.7859494346355,
    "a": -4.1973067883887,
    "b": -2.23786186062906,
    "C": 4.75661749388282,
    "h": 0.48982714974369,
    "CMY_C": 0.3083713,
    "CMY_M": 0.2571232,
    "CMY_Y": 0.2578769,
    "CMYK_C": 0.06898598,
    "CMYK_M": 0,
    "CMYK_Y": 0.001014526,
    "CMYK_K": 0.2571232
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0341",
    "Farbtonhilfsbezeichnung": "R 407",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "174",
    "Bcolor": "174",
    "Y": 41,
    "L": 70.1998078927566,
    "a": -3.57287787759042,
    "b": -1.92635992587995,
    "C": 4.05910321280591,
    "h": 0.49448421626464,
    "CMY_C": 0.3611801,
    "CMY_M": 0.3182007,
    "CMY_Y": 0.3192343,
    "CMYK_C": 0.06303821,
    "CMYK_M": 0,
    "CMYK_Y": 0.001516012,
    "CMYK_K": 0.3182007
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0342",
    "Farbtonhilfsbezeichnung": "R 507",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "151",
    "Bcolor": "151",
    "Y": 30,
    "L": 61.6024031165272,
    "a": -3.05823483781492,
    "b": -2.18210710687228,
    "C": 3.75691252880439,
    "h": 0.61974127543816,
    "CMY_C": 0.4469298,
    "CMY_M": 0.4090986,
    "CMY_Y": 0.4067098,
    "CMYK_C": 0.06779145,
    "CMYK_M": 0.00402628,
    "CMYK_Y": 0,
    "CMYK_K": 0.4067098
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0343",
    "Farbtonhilfsbezeichnung": "R 108",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "227",
    "Bcolor": "216",
    "Y": 76,
    "L": 89.6406284040847,
    "a": -3.67855409479828,
    "b": 3.85472066811339,
    "C": 5.32828599622221,
    "h": -0.80877902714319,
    "CMY_C": 0.13242,
    "CMY_M": 0.1082814,
    "CMY_Y": 0.1520786,
    "CMYK_C": 0.02706981,
    "CMYK_M": 0,
    "CMYK_Y": 0.04911552,
    "CMYK_K": 0.1082814
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0344",
    "Farbtonhilfsbezeichnung": "R 208",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "194",
    "Y": 57,
    "L": 80.3279145977509,
    "a": -3.44138775217151,
    "b": 2.17273650690173,
    "C": 4.06988127458524,
    "h": -0.56315597806571,
    "CMY_C": 0.2381109,
    "CMY_M": 0.2108724,
    "CMY_Y": 0.2407742,
    "CMYK_C": 0.03451734,
    "CMYK_M": 0,
    "CMYK_Y": 0.03789233,
    "CMYK_K": 0.2108724
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0345",
    "Farbtonhilfsbezeichnung": "R 308",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "186",
    "Bcolor": "179",
    "Y": 48,
    "L": 74.5628180120356,
    "a": -3.65704051123167,
    "b": 1.75452279807098,
    "C": 4.05614294000352,
    "h": -0.44732957572416,
    "CMY_C": 0.3029999,
    "CMY_M": 0.2725353,
    "CMY_Y": 0.2992321,
    "CMYK_C": 0.04187772,
    "CMYK_M": 0,
    "CMYK_Y": 0.03669839,
    "CMYK_K": 0.2725353
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0346",
    "Farbtonhilfsbezeichnung": "R 408",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "177",
    "Bcolor": "170",
    "Y": 43,
    "L": 71.3106834828793,
    "a": -3.76016555293823,
    "b": 1.74334236804476,
    "C": 4.14464565406058,
    "h": -0.43413432689659,
    "CMY_C": 0.3382396,
    "CMY_M": 0.3070018,
    "CMY_Y": 0.3333991,
    "CMYK_C": 0.04507633,
    "CMYK_M": 0,
    "CMYK_Y": 0.03809151,
    "CMYK_K": 0.3070018
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0347",
    "Farbtonhilfsbezeichnung": "R 508",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "147",
    "Bcolor": "140",
    "Y": 28,
    "L": 60.1667541801094,
    "a": -3.73556993815516,
    "b": 1.96740957497812,
    "C": 4.22198806234268,
    "h": -0.48475462581873,
    "CMY_C": 0.452667,
    "CMY_M": 0.4235291,
    "CMY_Y": 0.4497263,
    "CMYK_C": 0.05054529,
    "CMYK_M": 0,
    "CMYK_Y": 0.04544409,
    "CMYK_K": 0.4235291
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0348",
    "Farbtonhilfsbezeichnung": "R 109",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 73,
    "L": 88.28273657728,
    "a": -1.91549882104514,
    "b": 5.15745057675381,
    "C": 5.50167539801136,
    "h": -1.21518185680178,
    "CMY_C": 0.1292475,
    "CMY_M": 0.1277973,
    "CMY_Y": 0.1762789,
    "CMYK_C": 0.001662701,
    "CMYK_M": 0,
    "CMYK_Y": 0.05558519,
    "CMYK_K": 0.1277973
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0349",
    "Farbtonhilfsbezeichnung": "R 209",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "201",
    "Bcolor": "190",
    "Y": 58,
    "L": 80.5891950542023,
    "a": -1.53584815476987,
    "b": 4.78819674149586,
    "C": 5.02848462161133,
    "h": -1.26040674877136,
    "CMY_C": 0.211961,
    "CMY_M": 0.2130477,
    "CMY_Y": 0.2566003,
    "CMYK_C": 0,
    "CMYK_M": 0.001378991,
    "CMYK_Y": 0.05664595,
    "CMYK_K": 0.211961
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0350",
    "Farbtonhilfsbezeichnung": "R 309",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "188",
    "Bcolor": "176",
    "Y": 50,
    "L": 76.0267266657078,
    "a": -1.88361727463365,
    "b": 5.19847857612237,
    "C": 5.52921274176546,
    "h": -1.22317067004518,
    "CMY_C": 0.2626309,
    "CMY_M": 0.2616803,
    "CMY_Y": 0.308063,
    "CMYK_C": 0.001287526,
    "CMYK_M": 0,
    "CMYK_Y": 0.06282201,
    "CMYK_K": 0.2616803
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0351",
    "Farbtonhilfsbezeichnung": "R 409",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "175",
    "Bcolor": "164",
    "Y": 43,
    "L": 71.3276838901751,
    "a": -1.89247346732746,
    "b": 5.29292926685381,
    "C": 5.62108139493247,
    "h": -1.22741359035518,
    "CMY_C": 0.3125615,
    "CMY_M": 0.3118463,
    "CMY_Y": 0.357981,
    "CMYK_C": 0.001039309,
    "CMYK_M": 0,
    "CMYK_Y": 0.06704131,
    "CMYK_K": 0.3118463
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0352",
    "Farbtonhilfsbezeichnung": "R 509",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "148",
    "Bcolor": "137",
    "Y": 29,
    "L": 60.8553294462695,
    "a": -2.0567450654258,
    "b": 5.10034493129965,
    "C": 5.49942894147996,
    "h": -1.18748614604523,
    "CMY_C": 0.4236497,
    "CMY_M": 0.4207906,
    "CMY_Y": 0.4639208,
    "CMYK_C": 0.004936258,
    "CMYK_M": 0,
    "CMYK_Y": 0.07446398,
    "CMYK_K": 0.4207906
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0353",
    "Farbtonhilfsbezeichnung": "S 101",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "223",
    "Bcolor": "198",
    "Y": 73,
    "L": 88.3339280405886,
    "a": -2.59001798116199,
    "b": 11.5353938693812,
    "C": 11.8225845255806,
    "h": -1.34993126327301,
    "CMY_C": 0.11423,
    "CMY_M": 0.1273141,
    "CMY_Y": 0.2228642,
    "CMYK_C": 0,
    "CMYK_M": 0.01477139,
    "CMYK_Y": 0.1226438,
    "CMYK_K": 0.11423
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0354",
    "Farbtonhilfsbezeichnung": "S 201",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "209",
    "Bcolor": "184",
    "Y": 64,
    "L": 83.732556585825,
    "a": -1.92434717098872,
    "b": 12.5520783794856,
    "C": 12.6987315775727,
    "h": -1.41867172915129,
    "CMY_C": 0.1573222,
    "CMY_M": 0.1798121,
    "CMY_Y": 0.2795432,
    "CMYK_C": 0,
    "CMYK_M": 0.02668871,
    "CMYK_Y": 0.1450388,
    "CMYK_K": 0.1573222
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0355",
    "Farbtonhilfsbezeichnung": "S 301",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "191",
    "Bcolor": "167",
    "Y": 52,
    "L": 76.9961292927412,
    "a": -2.60612333167443,
    "b": 11.7686900119828,
    "C": 12.0537937355026,
    "h": -1.35286768224119,
    "CMY_C": 0.2382383,
    "CMY_M": 0.2512526,
    "CMY_Y": 0.3450415,
    "CMYK_C": 0,
    "CMYK_M": 0.01708448,
    "CMYK_Y": 0.1402055,
    "CMYK_K": 0.2382383
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0356",
    "Farbtonhilfsbezeichnung": "S 401",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "176",
    "Bcolor": "149",
    "Y": 43,
    "L": 71.5562445118005,
    "a": -2.17960713936521,
    "b": 13.9824931971346,
    "C": 14.151353408416,
    "h": -1.416159663207,
    "CMY_C": 0.2878168,
    "CMY_M": 0.3108605,
    "CMY_Y": 0.417091,
    "CMYK_C": 0,
    "CMYK_M": 0.03235648,
    "CMYK_Y": 0.1815182,
    "CMYK_K": 0.2878168
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0357",
    "Farbtonhilfsbezeichnung": "S 501",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "145",
    "Bcolor": "120",
    "Y": 28,
    "L": 59.9920613382206,
    "a": -2.22102743791047,
    "b": 13.4409381776593,
    "C": 13.623207477522,
    "h": -1.40703268748423,
    "CMY_C": 0.4113553,
    "CMY_M": 0.4311898,
    "CMY_Y": 0.5296044,
    "CMYK_C": 0,
    "CMYK_M": 0.03369514,
    "CMYK_Y": 0.2008836,
    "CMYK_K": 0.4113553
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0358",
    "Farbtonhilfsbezeichnung": "S 102",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "234",
    "Bcolor": "216",
    "Y": 81,
    "L": 92.065240295492,
    "a": -2.91742531977418,
    "b": 7.66715920450876,
    "C": 8.20345663508638,
    "h": -1.20720436250442,
    "CMY_C": 0.08693414,
    "CMY_M": 0.08400787,
    "CMY_Y": 0.1536651,
    "CMYK_C": 0.003194654,
    "CMYK_M": 0,
    "CMYK_Y": 0.0760456,
    "CMYK_K": 0.08400787
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0359",
    "Farbtonhilfsbezeichnung": "S 202",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "203",
    "Y": 74,
    "L": 88.9408317868964,
    "a": -3.29113083410681,
    "b": 10.0150387545581,
    "C": 10.5419421086681,
    "h": -1.25329476297592,
    "CMY_C": 0.1173865,
    "CMY_M": 0.1185746,
    "CMY_Y": 0.2051748,
    "CMYK_C": 0,
    "CMYK_M": 0.001346119,
    "CMYK_Y": 0.09946406,
    "CMYK_K": 0.1173865
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0360",
    "Farbtonhilfsbezeichnung": "S 302",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "209",
    "Bcolor": "189",
    "Y": 62,
    "L": 83.1679679624284,
    "a": -4.59583779639522,
    "b": 9.06937800676857,
    "C": 10.1673665459859,
    "h": -1.10176940873752,
    "CMY_C": 0.1939762,
    "CMY_M": 0.1790559,
    "CMY_Y": 0.2605481,
    "CMYK_C": 0.0181745,
    "CMYK_M": 0,
    "CMYK_Y": 0.09926633,
    "CMYK_K": 0.1790559
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0361",
    "Farbtonhilfsbezeichnung": "S 402",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "174",
    "Bcolor": "158",
    "Y": 43,
    "L": 71.2323760986328,
    "a": -0.80465841293335,
    "b": 8.30738067626953,
    "C": 8.34625911712646,
    "h": 95.5324478149414,
    "CMY_C": 0.29673719406128,
    "CMY_M": 0.3160103559494,
    "CMY_Y": 0.38007110357285,
    "CMYK_C": 0,
    "CMYK_M": 0.02740534767509,
    "CMYK_Y": 0.11849611252546,
    "CMYK_K": 0.29673719406128
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0362",
    "Farbtonhilfsbezeichnung": "S 502",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "139",
    "Bcolor": "116",
    "Y": 25,
    "L": 58.1973648071289,
    "a": -0.23248529434204,
    "b": 13.3715314865112,
    "C": 13.3735523223877,
    "h": 90.9960784912109,
    "CMY_C": 0.41663444042206,
    "CMY_M": 0.45374578237534,
    "CMY_Y": 0.54645496606827,
    "CMYK_C": 0,
    "CMYK_M": 0.06361592561007,
    "CMYK_Y": 0.2225371748209,
    "CMYK_K": 0.41663444042206
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0363",
    "Farbtonhilfsbezeichnung": "S 103",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "208",
    "Y": 82,
    "L": 92.5662611355948,
    "a": -0.21236536328428,
    "b": 12.4875411597154,
    "C": 12.4893467908897,
    "h": -1.55379178671916,
    "CMY_C": 0.04597013,
    "CMY_M": 0.08603559,
    "CMY_Y": 0.1836772,
    "CMYK_C": 0,
    "CMYK_M": 0.04199603,
    "CMYK_Y": 0.1443425,
    "CMYK_K": 0.04597013
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0364",
    "Farbtonhilfsbezeichnung": "S 203",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "220",
    "Bcolor": "193",
    "Y": 72,
    "L": 88.0691673030749,
    "a": -0.0383413645123,
    "b": 13.9839070413606,
    "C": 13.9839596038335,
    "h": -1.56805451305706,
    "CMY_C": 0.0911027,
    "CMY_M": 0.1368332,
    "CMY_Y": 0.2433987,
    "CMYK_C": 0,
    "CMYK_M": 0.05031424,
    "CMYK_Y": 0.1675613,
    "CMYK_K": 0.0911027
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0365",
    "Farbtonhilfsbezeichnung": "S 303",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "201",
    "Bcolor": "177",
    "Y": 59,
    "L": 81.3024891766139,
    "a": 0.23815330370363,
    "b": 12.8487781351541,
    "C": 12.8509850424969,
    "h": 1.55226335546321,
    "CMY_C": 0.167413,
    "CMY_M": 0.2114263,
    "CMY_Y": 0.307133,
    "CMYK_C": 0,
    "CMYK_M": 0.05286334,
    "CMYK_Y": 0.1678144,
    "CMYK_K": 0.167413
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0366",
    "Farbtonhilfsbezeichnung": "S 403",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "168",
    "Bcolor": "148",
    "Y": 40,
    "L": 69.2653753338269,
    "a": 0.33551798029657,
    "b": 11.2337105189765,
    "C": 11.2387198710202,
    "h": 1.5409381363285,
    "CMY_C": 0.3016482,
    "CMY_M": 0.3400701,
    "CMY_Y": 0.4207336,
    "CMYK_C": 0,
    "CMYK_M": 0.05501789,
    "CMYK_Y": 0.1705235,
    "CMYK_K": 0.3016482
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0367",
    "Farbtonhilfsbezeichnung": "S 503",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "145",
    "Bcolor": "121",
    "Y": 29,
    "L": 60.5040540247811,
    "a": 1.03243005352094,
    "b": 13.7192676473965,
    "C": 13.7580600593367,
    "h": 1.49568388390434,
    "CMY_C": 0.3833662,
    "CMY_M": 0.4331094,
    "CMY_Y": 0.5259473,
    "CMYK_C": 0,
    "CMYK_M": 0.08066898,
    "CMYK_Y": 0.231225,
    "CMYK_K": 0.3833662
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0368",
    "Farbtonhilfsbezeichnung": "S 104",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "219",
    "Y": 80,
    "L": 91.6075334693252,
    "a": -0.85286029900139,
    "b": 5.40983477523602,
    "C": 5.47664888275355,
    "h": -1.41443327024797,
    "CMY_C": 0.08312915,
    "CMY_M": 0.09337011,
    "CMY_Y": 0.1416097,
    "CMYK_C": 0,
    "CMYK_M": 0.01116947,
    "CMYK_Y": 0.06378278,
    "CMYK_K": 0.08312915
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0369",
    "Farbtonhilfsbezeichnung": "S 204",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "216",
    "Bcolor": "197",
    "Y": 69,
    "L": 86.6013931775576,
    "a": -0.08988796706954,
    "b": 9.79069862001774,
    "C": 9.79111124002996,
    "h": -1.56161562936612,
    "CMY_C": 0.1197277,
    "CMY_M": 0.1518725,
    "CMY_Y": 0.2283058,
    "CMYK_C": 0,
    "CMYK_M": 0.03651683,
    "CMYK_Y": 0.123346,
    "CMYK_K": 0.1197277
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0370",
    "Farbtonhilfsbezeichnung": "S 304",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "206",
    "Bcolor": "185",
    "Y": 62,
    "L": 83.0025019580734,
    "a": 0.09520249966066,
    "b": 10.8923214788754,
    "C": 10.8927375216293,
    "h": 1.56205621793236,
    "CMY_C": 0.1550861,
    "CMY_M": 0.1920832,
    "CMY_Y": 0.2748885,
    "CMYK_C": 0,
    "CMYK_M": 0.04378792,
    "CMYK_Y": 0.1417924,
    "CMYK_K": 0.1550861
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0371",
    "Farbtonhilfsbezeichnung": "S 404",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "191",
    "Bcolor": "167",
    "Y": 53,
    "L": 77.6488246253688,
    "a": 0.58733064417321,
    "b": 12.6562223381945,
    "C": 12.6698429808502,
    "h": 1.52442312355698,
    "CMY_C": 0.2055317,
    "CMY_M": 0.2517323,
    "CMY_Y": 0.3440986,
    "CMYK_C": 0,
    "CMYK_M": 0.05815283,
    "CMYK_Y": 0.1744146,
    "CMYK_K": 0.2055317
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0372",
    "Farbtonhilfsbezeichnung": "S 504",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "178",
    "Bcolor": "153",
    "Y": 45,
    "L": 73.0747316814185,
    "a": 0.54516660405123,
    "b": 13.9770071250525,
    "C": 13.9876350681572,
    "h": 1.53181155791202,
    "CMY_C": 0.252195,
    "CMY_M": 0.3008912,
    "CMY_Y": 0.4010238,
    "CMYK_C": 0,
    "CMYK_M": 0.06511892,
    "CMYK_Y": 0.1990209,
    "CMYK_K": 0.252195
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0373",
    "Farbtonhilfsbezeichnung": "S 106",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "238",
    "Bcolor": "211",
    "Y": 85,
    "L": 94.0440666915381,
    "a": -1.24051204082576,
    "b": 13.3716024721096,
    "C": 13.4290216618919,
    "h": -1.47828898390149,
    "CMY_C": 0.03449854,
    "CMY_M": 0.06725196,
    "CMY_Y": 0.1743362,
    "CMYK_C": 0,
    "CMYK_M": 0.03392374,
    "CMYK_Y": 0.1448342,
    "CMYK_K": 0.03449854
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0374",
    "Farbtonhilfsbezeichnung": "S 206",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "218",
    "Bcolor": "184",
    "Y": 72,
    "L": 87.8013642311629,
    "a": 2.4759585165503,
    "b": 18.5299598229783,
    "C": 18.6946458007866,
    "h": 1.43796392588373,
    "CMY_C": 0.06397369,
    "CMY_M": 0.146899,
    "CMY_Y": 0.279464,
    "CMYK_C": 0,
    "CMYK_M": 0.08859289,
    "CMYK_Y": 0.2302182,
    "CMYK_K": 0.06397369
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0375",
    "Farbtonhilfsbezeichnung": "S 306",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "199",
    "Bcolor": "158",
    "Y": 59,
    "L": 81.4067821530134,
    "a": 3.10579167166131,
    "b": 23.1955269118467,
    "C": 23.4025300048085,
    "h": 1.43769185286438,
    "CMY_C": 0.120816,
    "CMY_M": 0.2194393,
    "CMY_Y": 0.3810271,
    "CMYK_C": 0,
    "CMYK_M": 0.1121759,
    "CMYK_Y": 0.2959689,
    "CMYK_K": 0.120816
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0376",
    "Farbtonhilfsbezeichnung": "S 406",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "196",
    "Bcolor": "155",
    "Y": 57,
    "L": 79.9858385449613,
    "a": 2.49901373759448,
    "b": 22.6803085960617,
    "C": 22.81756927618,
    "h": 1.46105471526621,
    "CMY_C": 0.1420604,
    "CMY_M": 0.2332685,
    "CMY_Y": 0.3921059,
    "CMYK_C": 0,
    "CMYK_M": 0.1063106,
    "CMYK_Y": 0.2914488,
    "CMYK_K": 0.1420604
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0377",
    "Farbtonhilfsbezeichnung": "S 506",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "169",
    "Bcolor": "121",
    "Y": 42,
    "L": 70.8515950482572,
    "a": 4.5389959803423,
    "b": 28.2545354587918,
    "C": 28.6168002841284,
    "h": 1.41151063617339,
    "CMY_C": 0.2191262,
    "CMY_M": 0.3367064,
    "CMY_Y": 0.5250502,
    "CMYK_C": 0,
    "CMYK_M": 0.1505751,
    "CMYK_Y": 0.3917713,
    "CMYK_K": 0.2191262
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0378",
    "Farbtonhilfsbezeichnung": "S 107",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "210",
    "Y": 82,
    "L": 92.4693468217967,
    "a": 1.66000987090903,
    "b": 11.2710307519617,
    "C": 11.3926189694548,
    "h": 1.42456649931209,
    "CMY_C": 0.03646573,
    "CMY_M": 0.0913131,
    "CMY_Y": 0.1753693,
    "CMYK_C": 0,
    "CMYK_M": 0.05692311,
    "CMYK_Y": 0.1441605,
    "CMYK_K": 0.03646573
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0379",
    "Farbtonhilfsbezeichnung": "S 207",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "220",
    "Bcolor": "192",
    "Y": 73,
    "L": 88.3958812339474,
    "a": 2.28492181311934,
    "b": 15.1124996018599,
    "C": 15.2842569956241,
    "h": 1.42073869320182,
    "CMY_C": 0.06735758,
    "CMY_M": 0.1390554,
    "CMY_Y": 0.2478525,
    "CMYK_C": 0,
    "CMYK_M": 0.07687596,
    "CMYK_Y": 0.1935307,
    "CMYK_K": 0.06735758
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0380",
    "Farbtonhilfsbezeichnung": "S 307",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "213",
    "Bcolor": "184",
    "Y": 69,
    "L": 86.5651569054889,
    "a": 4.14430262589166,
    "b": 16.8128757670626,
    "C": 17.3161206918193,
    "h": 1.32911847952572,
    "CMY_C": 0.07031853,
    "CMY_M": 0.1641703,
    "CMY_Y": 0.2796635,
    "CMYK_C": 0,
    "CMYK_M": 0.1009504,
    "CMYK_Y": 0.2251793,
    "CMYK_K": 0.07031853
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0381",
    "Farbtonhilfsbezeichnung": "S 407",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "213",
    "Bcolor": "178",
    "Y": 70,
    "L": 86.8827637429727,
    "a": 5.55206801344804,
    "b": 20.3164862141894,
    "C": 21.0614593824193,
    "h": 1.30403086567114,
    "CMY_C": 0.04837526,
    "CMY_M": 0.1649669,
    "CMY_Y": 0.3019027,
    "CMYK_C": 0,
    "CMYK_M": 0.1225185,
    "CMYK_Y": 0.2664154,
    "CMYK_K": 0.04837526
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0382",
    "Farbtonhilfsbezeichnung": "S 507",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "202",
    "Bcolor": "160",
    "Y": 63,
    "L": 83.3023347721171,
    "a": 6.22031871326634,
    "b": 24.7598770841362,
    "C": 25.5292749234315,
    "h": 1.32466434888017,
    "CMY_C": 0.07475429,
    "CMY_M": 0.2067803,
    "CMY_Y": 0.3722169,
    "CMYK_C": 0,
    "CMYK_M": 0.1426929,
    "CMYK_Y": 0.3214957,
    "CMYK_K": 0.07475429
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0383",
    "Farbtonhilfsbezeichnung": "S 108",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "233",
    "Bcolor": "206",
    "Y": 81,
    "L": 92.287953569194,
    "a": -1.3091299899613,
    "b": 13.2537650117024,
    "C": 13.3182622108157,
    "h": -1.47234148783119,
    "CMY_C": 0.05521049,
    "CMY_M": 0.08673032,
    "CMY_Y": 0.1925952,
    "CMYK_C": 0,
    "CMYK_M": 0.03336174,
    "CMYK_Y": 0.145413,
    "CMYK_K": 0.05521049
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0384",
    "Farbtonhilfsbezeichnung": "S 208",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "220",
    "Bcolor": "176",
    "Y": 74,
    "L": 89.0213878761801,
    "a": 2.85480771729657,
    "b": 24.3231338927081,
    "C": 24.4900953339374,
    "h": 1.45396080693811,
    "CMY_C": 0.03366566,
    "CMY_M": 0.1356517,
    "CMY_Y": 0.3095073,
    "CMYK_C": 0,
    "CMYK_M": 0.1055391,
    "CMYK_Y": 0.2854515,
    "CMYK_K": 0.03366566
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0385",
    "Farbtonhilfsbezeichnung": "S 308",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "217",
    "Bcolor": "161",
    "Y": 73,
    "L": 88.544536147347,
    "a": 5.01027556641365,
    "b": 31.7804709716814,
    "C": 32.1729886151922,
    "h": 1.41443065380663,
    "CMY_C": 0.008481517,
    "CMY_M": 0.1477884,
    "CMY_Y": 0.3700625,
    "CMYK_C": 0,
    "CMYK_M": 0.1404985,
    "CMYK_Y": 0.364674,
    "CMYK_K": 0.008481517
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0386",
    "Farbtonhilfsbezeichnung": "S 408",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "195",
    "Bcolor": "145",
    "Y": 59,
    "L": 81.3392006990255,
    "a": 8.63669952188267,
    "b": 29.9097430015235,
    "C": 31.1317411181655,
    "h": 1.28968425837592,
    "CMY_C": 0.07096349,
    "CMY_M": 0.2351975,
    "CMY_Y": 0.4300857,
    "CMYK_C": 0,
    "CMYK_M": 0.1767789,
    "CMYK_Y": 0.3865533,
    "CMYK_K": 0.07096349
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0387",
    "Farbtonhilfsbezeichnung": "S 508",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "179",
    "Bcolor": "132",
    "Y": 49,
    "L": 75.7127582453398,
    "a": 9.51236912642661,
    "b": 29.3682808691819,
    "C": 30.8703917631207,
    "h": 1.25756018691249,
    "CMY_C": 0.1305849,
    "CMY_M": 0.297679,
    "CMY_Y": 0.4832834,
    "CMYK_C": 0,
    "CMYK_M": 0.1921915,
    "CMYK_Y": 0.4056733,
    "CMYK_K": 0.1305849
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0388",
    "Farbtonhilfsbezeichnung": "S 109",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "228",
    "Bcolor": "213",
    "Y": 78,
    "L": 90.7551131863682,
    "a": 0.59865756726962,
    "b": 7.10493360932907,
    "C": 7.13011027094413,
    "h": 1.48673546827193,
    "CMY_C": 0.07615722,
    "CMY_M": 0.1067824,
    "CMY_Y": 0.1633064,
    "CMYK_C": 0,
    "CMYK_M": 0.03314973,
    "CMYK_Y": 0.09433329,
    "CMYK_K": 0.07615722
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0389",
    "Farbtonhilfsbezeichnung": "S 209",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "221",
    "Bcolor": "202",
    "Y": 74,
    "L": 88.9208371348483,
    "a": 2.7096774809619,
    "b": 10.3431549784913,
    "C": 10.6922030919695,
    "h": 1.31457655099337,
    "CMY_C": 0.07134122,
    "CMY_M": 0.133079,
    "CMY_Y": 0.2068896,
    "CMYK_C": 0,
    "CMYK_M": 0.06648063,
    "CMYK_Y": 0.1459614,
    "CMYK_K": 0.07134122
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0390",
    "Farbtonhilfsbezeichnung": "S 309",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "200",
    "Bcolor": "178",
    "Y": 60,
    "L": 82.0133739724057,
    "a": 5.16212157784179,
    "b": 13.1667969294742,
    "C": 14.1425613156327,
    "h": 1.19715693916269,
    "CMY_C": 0.1234353,
    "CMY_M": 0.2155332,
    "CMY_Y": 0.301134,
    "CMYK_C": 0,
    "CMYK_M": 0.1050669,
    "CMYK_Y": 0.2027217,
    "CMYK_K": 0.1234353
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0391",
    "Farbtonhilfsbezeichnung": "S 409",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "189",
    "Bcolor": "164",
    "Y": 54,
    "L": 78.3659132257722,
    "a": 6.49141287101579,
    "b": 15.3421517820634,
    "C": 16.6589334102114,
    "h": 1.17052788961553,
    "CMY_C": 0.1495124,
    "CMY_M": 0.2587464,
    "CMY_Y": 0.3549866,
    "CMYK_C": 0,
    "CMYK_M": 0.1284369,
    "CMYK_Y": 0.2415957,
    "CMYK_K": 0.1495124
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0392",
    "Farbtonhilfsbezeichnung": "S 509",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "170",
    "Bcolor": "143",
    "Y": 43,
    "L": 71.8814061436107,
    "a": 8.98861972104953,
    "b": 17.8095468858945,
    "C": 19.9493168998468,
    "h": 1.10338946287762,
    "CMY_C": 0.1992728,
    "CMY_M": 0.3345553,
    "CMY_Y": 0.4390552,
    "CMYK_C": 0,
    "CMYK_M": 0.1689495,
    "CMYK_Y": 0.2994558,
    "CMYK_K": 0.1992728
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0393",
    "Farbtonhilfsbezeichnung": "S 111",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "233",
    "Bcolor": "216",
    "Y": 83,
    "L": 92.98021548191,
    "a": 2.30906476025561,
    "b": 8.965492865848,
    "C": 9.25806904244215,
    "h": 1.31872428448178,
    "CMY_C": 0.03249749,
    "CMY_M": 0.08657771,
    "CMY_Y": 0.1525093,
    "CMYK_C": 0,
    "CMYK_M": 0.05589673,
    "CMYK_Y": 0.1240429,
    "CMYK_K": 0.03249749
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0394",
    "Farbtonhilfsbezeichnung": "S 211",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "217",
    "Bcolor": "200",
    "Y": 72,
    "L": 87.8815433088787,
    "a": 4.47304857299902,
    "b": 9.94413388862096,
    "C": 10.9038508028691,
    "h": 1.1480939165937,
    "CMY_C": 0.0711863,
    "CMY_M": 0.1487628,
    "CMY_Y": 0.2149143,
    "CMYK_C": 0,
    "CMYK_M": 0.0835221,
    "CMYK_Y": 0.1547437,
    "CMYK_K": 0.0711863
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0395",
    "Farbtonhilfsbezeichnung": "S 311",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "205",
    "Bcolor": "188",
    "Y": 64,
    "L": 83.8459148533528,
    "a": 5.21992318428782,
    "b": 10.824749842724,
    "C": 12.017604054362,
    "h": 1.12147270053365,
    "CMY_C": 0.1086602,
    "CMY_M": 0.1951243,
    "CMY_Y": 0.264599,
    "CMYK_C": 0,
    "CMYK_M": 0.09700467,
    "CMYK_Y": 0.1749488,
    "CMYK_K": 0.1086602
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0396",
    "Farbtonhilfsbezeichnung": "S 411",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "185",
    "Bcolor": "167",
    "Y": 52,
    "L": 77.2732003091807,
    "a": 8.11134380267836,
    "b": 12.6674790077922,
    "C": 15.0419055540881,
    "h": 1.00125035119548,
    "CMY_C": 0.1569963,
    "CMY_M": 0.2738335,
    "CMY_Y": 0.3468952,
    "CMYK_C": 0,
    "CMYK_M": 0.1385963,
    "CMYK_Y": 0.2252647,
    "CMYK_K": 0.1569963
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0397",
    "Farbtonhilfsbezeichnung": "S 511",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "167",
    "Bcolor": "150",
    "Y": 42,
    "L": 71.119583679095,
    "a": 10.3143695865496,
    "b": 12.8131144943917,
    "C": 16.448772690214,
    "h": 0.89302291472095,
    "CMY_C": 0.2099416,
    "CMY_M": 0.3447318,
    "CMY_Y": 0.4112714,
    "CMYK_C": 0,
    "CMYK_M": 0.1706079,
    "CMYK_Y": 0.254829,
    "CMYK_K": 0.2099416
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0398",
    "Farbtonhilfsbezeichnung": "S 112",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "217",
    "Bcolor": "205",
    "Y": 72,
    "L": 87.8316174645463,
    "a": 4.22201896608032,
    "b": 7.04514520029698,
    "C": 8.21337415702033,
    "h": 1.03090595211935,
    "CMY_C": 0.08186018,
    "CMY_M": 0.1479325,
    "CMY_Y": 0.1941706,
    "CMYK_C": 0,
    "CMYK_M": 0.07196327,
    "CMYK_Y": 0.1223239,
    "CMYK_K": 0.08186018
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0399",
    "Farbtonhilfsbezeichnung": "S 212",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "206",
    "Bcolor": "195",
    "Y": 64,
    "L": 84.1981310110304,
    "a": 5.20196754899954,
    "b": 7.07750605814943,
    "C": 8.78359598251116,
    "h": 0.93696448321879,
    "CMY_C": 0.1151946,
    "CMY_M": 0.190255,
    "CMY_Y": 0.2335215,
    "CMYK_C": 0,
    "CMYK_M": 0.08483262,
    "CMYK_Y": 0.1337321,
    "CMYK_K": 0.1151946
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0400",
    "Farbtonhilfsbezeichnung": "S 312",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "191",
    "Bcolor": "182",
    "Y": 55,
    "L": 78.7934195537917,
    "a": 5.93127235329471,
    "b": 6.44578156292641,
    "C": 8.75945727119667,
    "h": 0.82694384601649,
    "CMY_C": 0.1715957,
    "CMY_M": 0.2505442,
    "CMY_Y": 0.2865852,
    "CMYK_C": 0,
    "CMYK_M": 0.09530188,
    "CMYK_Y": 0.1388085,
    "CMYK_K": 0.1715957
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0401",
    "Farbtonhilfsbezeichnung": "S 412",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "170",
    "Bcolor": "162",
    "Y": 43,
    "L": 71.3000965471725,
    "a": 6.46791970159655,
    "b": 6.6078313947292,
    "C": 9.24648154745737,
    "h": 0.79609784350637,
    "CMY_C": 0.2491965,
    "CMY_M": 0.3318166,
    "CMY_Y": 0.3663244,
    "CMYK_C": 0,
    "CMYK_M": 0.1100423,
    "CMYK_Y": 0.1560034,
    "CMYK_K": 0.2491965
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0402",
    "Farbtonhilfsbezeichnung": "S 512",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "141",
    "Bcolor": "134",
    "Y": 29,
    "L": 60.5848934571203,
    "a": 7.7929581995439,
    "b": 6.74072733903197,
    "C": 10.3037664258761,
    "h": 0.71312481386071,
    "CMY_C": 0.3544397,
    "CMY_M": 0.446252,
    "CMY_Y": 0.4764283,
    "CMYK_C": 0,
    "CMYK_M": 0.1422212,
    "CMYK_Y": 0.1889655,
    "CMYK_K": 0.3544397
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0403",
    "Farbtonhilfsbezeichnung": "T 101",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "157",
    "Bcolor": "86",
    "Y": 40,
    "L": 69.7816303676251,
    "a": 17.748023404961,
    "b": 45.5405326635316,
    "C": 48.8767066204468,
    "h": 1.19918393922912,
    "CMY_C": 0.1260954,
    "CMY_M": 0.3845495,
    "CMY_Y": 0.6608692,
    "CMYK_C": 0,
    "CMYK_M": 0.2957464,
    "CMYK_Y": 0.6119362,
    "CMYK_K": 0.1260954
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0404",
    "Farbtonhilfsbezeichnung": "T 201",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "134",
    "Bcolor": "75",
    "Y": 29,
    "L": 60.9784119888007,
    "a": 18.0687657974257,
    "b": 40.3715978942222,
    "C": 44.2306026860927,
    "h": 1.14997225548346,
    "CMY_C": 0.2321341,
    "CMY_M": 0.4751511,
    "CMY_Y": 0.7063366,
    "CMYK_C": 0,
    "CMYK_M": 0.3164836,
    "CMYK_Y": 0.617559,
    "CMYK_K": 0.2321341
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0405",
    "Farbtonhilfsbezeichnung": "T 301",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "113",
    "Bcolor": "69",
    "Y": 21,
    "L": 53.0081800260025,
    "a": 19.8059811911451,
    "b": 33.146384416979,
    "C": 38.612947192129,
    "h": 1.03219449069795,
    "CMY_C": 0.3207995,
    "CMY_M": 0.5586189,
    "CMY_Y": 0.7278595,
    "CMYK_C": 0,
    "CMYK_M": 0.3501461,
    "CMYK_Y": 0.5993223,
    "CMYK_K": 0.3207995
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0406",
    "Farbtonhilfsbezeichnung": "T 401",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "88",
    "Bcolor": "54",
    "Y": 13,
    "L": 42.7597616291196,
    "a": 18.761037007343,
    "b": 28.2603442982318,
    "C": 33.9208426995188,
    "h": 0.98473625178656,
    "CMY_C": 0.4445975,
    "CMY_M": 0.6541833,
    "CMY_Y": 0.7871361,
    "CMYK_C": 0,
    "CMYK_M": 0.3773585,
    "CMYK_Y": 0.6167395,
    "CMYK_K": 0.4445975
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0407",
    "Farbtonhilfsbezeichnung": "T 501",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "86",
    "Bcolor": "62",
    "Y": 14,
    "L": 43.5107048939724,
    "a": 23.8134346220297,
    "b": 24.783043907943,
    "C": 34.3697386350364,
    "h": 0.80534777047297,
    "CMY_C": 0.4140724,
    "CMY_M": 0.661122,
    "CMY_Y": 0.7558106,
    "CMYK_C": 0,
    "CMYK_M": 0.4216385,
    "CMYK_Y": 0.5832431,
    "CMYK_K": 0.4140724
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0408",
    "Farbtonhilfsbezeichnung": "T 105",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "46",
    "Bcolor": "66",
    "Y": 12,
    "L": 39.4131278991699,
    "a": 51.643310546875,
    "b": 18.1502056121826,
    "C": 54.7399444580078,
    "h": 19.3641872406006,
    "CMY_C": 0.33184725046158,
    "CMY_M": 0.82109004259109,
    "CMY_Y": 0.74273890256882,
    "CMYK_C": 0,
    "CMYK_M": 0.73223197460175,
    "CMYK_Y": 0.61496663093567,
    "CMYK_K": 0.33184725046158
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0409",
    "Farbtonhilfsbezeichnung": "T 205",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "64",
    "Bcolor": "71",
    "Y": 8,
    "L": 33.7173104766267,
    "a": 23.3500091295676,
    "b": 5.52400749310604,
    "C": 23.9945324008363,
    "h": 0.23230316031364,
    "CMY_C": 0.5454278,
    "CMY_M": 0.7474482,
    "CMY_Y": 0.7221835,
    "CMYK_C": 0,
    "CMYK_M": 0.4444187,
    "CMYK_Y": 0.3888396,
    "CMYK_K": 0.5454278
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0410",
    "Farbtonhilfsbezeichnung": "T 305",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "46",
    "Bcolor": "55",
    "Y": 5,
    "L": 26.6843031408024,
    "a": 25.822070726766,
    "b": 5.37522978749084,
    "C": 26.3756029672581,
    "h": 0.20523325218819,
    "CMY_C": 0.6053067,
    "CMY_M": 0.8195308,
    "CMY_Y": 0.7827172,
    "CMYK_C": 0,
    "CMYK_M": 0.5427608,
    "CMYK_Y": 0.4494893,
    "CMYK_K": 0.6053067
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0411",
    "Farbtonhilfsbezeichnung": "T 405",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "49",
    "Bcolor": "57",
    "Y": 5,
    "L": 25.5073151267965,
    "a": 19.1421642197336,
    "b": 2.29755002622206,
    "C": 19.2795536031891,
    "h": 0.1194541769778,
    "CMY_C": 0.6536934,
    "CMY_M": 0.8079302,
    "CMY_Y": 0.7760807,
    "CMYK_C": 0,
    "CMYK_M": 0.4453762,
    "CMYK_Y": 0.3534074,
    "CMYK_K": 0.6536934
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0412",
    "Farbtonhilfsbezeichnung": "T 505",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "53",
    "Bcolor": "58",
    "Y": 5,
    "L": 25.644589438008,
    "a": 13.9398719415317,
    "b": 1.56470071783926,
    "C": 14.0274130930371,
    "h": 0.11177854443522,
    "CMY_C": 0.6798388,
    "CMY_M": 0.792412,
    "CMY_Y": 0.7713546,
    "CMYK_C": 0,
    "CMYK_M": 0.3516141,
    "CMYK_Y": 0.2858427,
    "CMYK_K": 0.6798388
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0413",
    "Farbtonhilfsbezeichnung": "T 107",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "92",
    "Bcolor": "154",
    "Y": 13,
    "L": 43.1468998868205,
    "a": 21.0452288868476,
    "b": -32.0616109388866,
    "C": 38.3516434445297,
    "h": -0.98993540722902,
    "CMY_C": 0.5739316,
    "CMY_M": 0.6383408,
    "CMY_Y": 0.3959768,
    "CMYK_C": 0.294616,
    "CMYK_M": 0.4012495,
    "CMYK_Y": 0,
    "CMYK_K": 0.3959768
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0414",
    "Farbtonhilfsbezeichnung": "T 207",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "94",
    "Bcolor": "126",
    "Y": 12,
    "L": 41.5707482068182,
    "a": 9.77336237640189,
    "b": -17.4267442262452,
    "C": 19.9802409011363,
    "h": -1.05967980765578,
    "CMY_C": 0.6076535,
    "CMY_M": 0.6311928,
    "CMY_Y": 0.5070643,
    "CMYK_C": 0.2040615,
    "CMYK_M": 0.2518148,
    "CMYK_Y": 0,
    "CMYK_K": 0.5070643
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0415",
    "Farbtonhilfsbezeichnung": "T 407",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "58",
    "Bcolor": "98",
    "Y": 5,
    "L": 26.8074028203312,
    "a": 13.7395974023949,
    "b": -23.1910169027124,
    "C": 26.9555152382919,
    "h": -1.03594425715057,
    "CMY_C": 0.7441577,
    "CMY_M": 0.7731961,
    "CMY_Y": 0.615262,
    "CMYK_C": 0.335022,
    "CMYK_M": 0.4104978,
    "CMYK_Y": 0,
    "CMYK_K": 0.615262
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0416",
    "Farbtonhilfsbezeichnung": "T 307",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "73",
    "Bcolor": "107",
    "Y": 7,
    "L": 32.7385193668924,
    "a": 10.6869452616418,
    "b": -19.3532862064301,
    "C": 22.10792812575,
    "h": -1.06626322532683,
    "CMY_C": 0.693405,
    "CMY_M": 0.7146254,
    "CMY_Y": 0.5816672,
    "CMYK_C": 0.2671025,
    "CMYK_M": 0.3178286,
    "CMYK_Y": 0,
    "CMYK_K": 0.5816672
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0417",
    "Farbtonhilfsbezeichnung": "T 507",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "56",
    "Bcolor": "82",
    "Y": 4,
    "L": 24.8161930776719,
    "a": 8.93720101504974,
    "b": -16.0473835748884,
    "C": 18.3682356687572,
    "h": -1.06265140170847,
    "CMY_C": 0.7647582,
    "CMY_M": 0.7823482,
    "CMY_Y": 0.6767421,
    "CMYK_C": 0.2722781,
    "CMYK_M": 0.3266929,
    "CMYK_Y": 0,
    "CMYK_K": 0.6767421
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0418",
    "Farbtonhilfsbezeichnung": "T 108",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "102",
    "Bcolor": "152",
    "Y": 13,
    "L": 42.0709614600205,
    "a": -0.35219135567554,
    "b": -32.8997910094403,
    "C": 32.9016760548131,
    "h": 1.56009176325502,
    "CMY_C": 0.7985268,
    "CMY_M": 0.5988502,
    "CMY_Y": 0.4032933,
    "CMYK_C": 0.6623582,
    "CMYK_M": 0.327727,
    "CMYK_Y": 0,
    "CMYK_K": 0.4032933
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0419",
    "Farbtonhilfsbezeichnung": "T 208",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "102",
    "Bcolor": "144",
    "Y": 13,
    "L": 42.2375017255469,
    "a": 0.20749853912971,
    "b": -27.9246193163732,
    "C": 27.9253902319754,
    "h": -1.56336579684181,
    "CMY_C": 0.7426199,
    "CMY_M": 0.6003857,
    "CMY_Y": 0.4337698,
    "CMYK_C": 0.5454497,
    "CMYK_M": 0.2942547,
    "CMYK_Y": 0,
    "CMYK_K": 0.4337698
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0420",
    "Farbtonhilfsbezeichnung": "T 308",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "103",
    "Bcolor": "136",
    "Y": 13,
    "L": 42.9676464672381,
    "a": 0.05230033750236,
    "b": -21.5181793958624,
    "C": 21.5182429542428,
    "h": -1.56836581287669,
    "CMY_C": 0.6927109,
    "CMY_M": 0.5954731,
    "CMY_Y": 0.4676938,
    "CMYK_C": 0.4227211,
    "CMYK_M": 0.2400485,
    "CMYK_Y": 0,
    "CMYK_K": 0.4676938
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0421",
    "Farbtonhilfsbezeichnung": "T 408",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "80",
    "Bcolor": "114",
    "Y": 8,
    "L": 33.0281604403653,
    "a": -0.45093880761046,
    "b": -23.7042179994709,
    "C": 23.708506844056,
    "h": 1.55177505295423,
    "CMY_C": 0.8115052,
    "CMY_M": 0.6871375,
    "CMY_Y": 0.5528703,
    "CMYK_C": 0.5784338,
    "CMYK_M": 0.3002869,
    "CMYK_Y": 0,
    "CMYK_K": 0.5528703
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0422",
    "Farbtonhilfsbezeichnung": "T 508",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "53",
    "Bcolor": "84",
    "Y": 4,
    "L": 22.0421104431152,
    "a": 2.31787180900574,
    "b": -21.845329284668,
    "C": 21.9679527282715,
    "h": 276.056640625,
    "CMY_C": 0.87627148628235,
    "CMY_M": 0.79066514968872,
    "CMY_Y": 0.66903936862946,
    "CMYK_C": 0.6261533498764,
    "CMYK_M": 0.36749321222305,
    "CMYK_Y": 0,
    "CMYK_K": 0.66903936862946
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0423",
    "Farbtonhilfsbezeichnung": "T 109",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "109",
    "Bcolor": "148",
    "Y": 14,
    "L": 43.9122889323354,
    "a": -5.94481057840773,
    "b": -27.2920490703637,
    "C": 27.9320016338301,
    "h": 1.35632435482396,
    "CMY_C": 0.7971053,
    "CMY_M": 0.572696,
    "CMY_Y": 0.4211531,
    "CMYK_C": 0.6494846,
    "CMYK_M": 0.2618014,
    "CMYK_Y": 0,
    "CMYK_K": 0.4211531
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0424",
    "Farbtonhilfsbezeichnung": "T 209",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "85",
    "Bcolor": "122",
    "Y": 8,
    "L": 34.1342384812272,
    "a": -5.07420624710189,
    "b": -27.005026399195,
    "C": 27.4776094276657,
    "h": 1.38506335650714,
    "CMY_C": 0.9052076,
    "CMY_M": 0.6672712,
    "CMY_Y": 0.5217193,
    "CMYK_C": 0.801806,
    "CMYK_M": 0.3043232,
    "CMYK_Y": 0,
    "CMYK_K": 0.5217193
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0425",
    "Farbtonhilfsbezeichnung": "T 309",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "80",
    "Bcolor": "124",
    "Y": 7,
    "L": 31.5579090118408,
    "a": -7.14416980743408,
    "b": -32.4782676696777,
    "C": 33.2547302246094,
    "h": 257.594360351563,
    "CMY_C": 1,
    "CMY_M": 0.68535244464874,
    "CMY_Y": 0.5133461356163,
    "CMYK_C": 1,
    "CMYK_M": 0.3534469306469,
    "CMYK_Y": 0,
    "CMYK_K": 0.5133461356163
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0426",
    "Farbtonhilfsbezeichnung": "T 409",
    "Farbtonklasse": "04",
    "Rcolor": "12",
    "Gcolor": "67",
    "Bcolor": "103",
    "Y": 5,
    "L": 26.9303983000557,
    "a": -2.72750259620114,
    "b": -26.2007507080101,
    "C": 26.3423349017428,
    "h": 1.46706976991565,
    "CMY_C": 0.9524733,
    "CMY_M": 0.7371987,
    "CMY_Y": 0.5970756,
    "CMYK_C": 0.8820457,
    "CMYK_M": 0.3477651,
    "CMYK_Y": 0,
    "CMYK_K": 0.5970756
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0427",
    "Farbtonhilfsbezeichnung": "T 509",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "65",
    "Bcolor": "93",
    "Y": 5,
    "L": 26.3837131055981,
    "a": -2.59571736901754,
    "b": -20.9274077654271,
    "C": 21.0877723916083,
    "h": 1.44739224119181,
    "CMY_C": 0.8820673,
    "CMY_M": 0.7442802,
    "CMY_Y": 0.6339836,
    "CMYK_C": 0.677794,
    "CMYK_M": 0.3013434,
    "CMYK_Y": 0,
    "CMYK_K": 0.6339836
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0428",
    "Farbtonhilfsbezeichnung": "T 110",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "134",
    "Y": 10,
    "L": 37.5793463400299,
    "a": -17.3802540424216,
    "b": -29.2438557486864,
    "C": 34.0187643754015,
    "h": 1.03456261001755,
    "CMY_C": 1,
    "CMY_M": 0.6139803,
    "CMY_Y": 0.4738281,
    "CMYK_C": 1,
    "CMYK_M": 0.266362,
    "CMYK_Y": 0,
    "CMYK_K": 0.4738281
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0429",
    "Farbtonhilfsbezeichnung": "T 210",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "92",
    "Bcolor": "121",
    "Y": 9,
    "L": 35.1302962530224,
    "a": -16.8294538503843,
    "b": -25.1932259543695,
    "C": 30.2973456079923,
    "h": 0.98186081467548,
    "CMY_C": 1,
    "CMY_M": 0.6396388,
    "CMY_Y": 0.5239242,
    "CMYK_C": 1,
    "CMYK_M": 0.2430592,
    "CMYK_Y": 0,
    "CMYK_K": 0.5239242
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0430",
    "Farbtonhilfsbezeichnung": "T 310",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "77",
    "Bcolor": "100",
    "Y": 7,
    "L": 30.4777545928955,
    "a": -8.99232292175293,
    "b": -19.0615634918213,
    "C": 21.0761737823486,
    "h": 244.744323730469,
    "CMY_C": 0.91361254453659,
    "CMY_M": 0.6972536444664,
    "CMY_Y": 0.60670149326324,
    "CMYK_C": 0.78035140037537,
    "CMYK_M": 0.23023772239685,
    "CMYK_Y": 0,
    "CMYK_K": 0.60670149326324
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0431",
    "Farbtonhilfsbezeichnung": "T 410",
    "Farbtonklasse": "04",
    "Rcolor": "6",
    "Gcolor": "77",
    "Bcolor": "96",
    "Y": 6,
    "L": 29.8848959031353,
    "a": -12.4586168864292,
    "b": -17.0161610662096,
    "C": 21.0894967259536,
    "h": 0.93880846072802,
    "CMY_C": 0.9755504,
    "CMY_M": 0.6979265,
    "CMY_Y": 0.625026,
    "CMYK_C": 0.9347963,
    "CMYK_M": 0.1944148,
    "CMYK_Y": 0,
    "CMYK_K": 0.625026
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0432",
    "Farbtonhilfsbezeichnung": "T 510",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "71",
    "Bcolor": "91",
    "Y": 5,
    "L": 27.1540636889163,
    "a": -12.0394186618339,
    "b": -18.4572952792251,
    "C": 22.0367726933737,
    "h": 0.99281638731055,
    "CMY_C": 1,
    "CMY_M": 0.7230439,
    "CMY_Y": 0.6421029,
    "CMYK_C": 1,
    "CMYK_M": 0.2261573,
    "CMYK_Y": 0,
    "CMYK_K": 0.6421029
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0433",
    "Farbtonhilfsbezeichnung": "T 111",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "118",
    "Bcolor": "148",
    "Y": 16,
    "L": 46.8116081700047,
    "a": -10.2294155642742,
    "b": -23.2083580997072,
    "C": 25.3627448922797,
    "h": 1.15564930621677,
    "CMY_C": 0.783687,
    "CMY_M": 0.5380021,
    "CMY_Y": 0.4183917,
    "CMYK_C": 0.6280778,
    "CMYK_M": 0.2056546,
    "CMYK_Y": 0,
    "CMYK_K": 0.4183917
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0434",
    "Farbtonhilfsbezeichnung": "T 211",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "130",
    "Y": 11,
    "L": 36.8479270935059,
    "a": -11.253378868103,
    "b": -27.9016723632813,
    "C": 30.0855751037598,
    "h": 248.03466796875,
    "CMY_C": 1,
    "CMY_M": 0.63103812932968,
    "CMY_Y": 0.48935443162918,
    "CMYK_C": 1,
    "CMYK_M": 0.27745994925499,
    "CMYK_Y": 0,
    "CMYK_K": 0.48935443162918
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0435",
    "Farbtonhilfsbezeichnung": "T 311",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "90",
    "Bcolor": "115",
    "Y": 9,
    "L": 36.2361126724393,
    "a": -6.59430539026484,
    "b": -19.3994143798192,
    "C": 20.489561778135,
    "h": 1.24312692337487,
    "CMY_C": 0.8152936,
    "CMY_M": 0.6476925,
    "CMY_Y": 0.5486659,
    "CMYK_C": 0.5907544,
    "CMYK_M": 0.2194086,
    "CMYK_Y": 0,
    "CMYK_K": 0.5486659
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0436",
    "Farbtonhilfsbezeichnung": "T 411",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "65",
    "Bcolor": "89",
    "Y": 5,
    "L": 26.3337022040208,
    "a": -3.65740817093044,
    "b": -17.9807084368773,
    "C": 18.3489103333353,
    "h": 1.37012663043843,
    "CMY_C": 0.8692631,
    "CMY_M": 0.743916,
    "CMY_Y": 0.6521066,
    "CMYK_C": 0.624204,
    "CMYK_M": 0.2639009,
    "CMYK_Y": 0,
    "CMYK_K": 0.6521066
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0437",
    "Farbtonhilfsbezeichnung": "T 511",
    "Farbtonklasse": "04",
    "Rcolor": "37",
    "Gcolor": "62",
    "Bcolor": "74",
    "Y": 4,
    "L": 24.6177164731714,
    "a": -5.54233252437789,
    "b": -11.0454833795149,
    "C": 12.3579995508139,
    "h": 1.10573080375563,
    "CMY_C": 0.8565684,
    "CMY_M": 0.7581173,
    "CMY_Y": 0.7090068,
    "CMYK_C": 0.5070962,
    "CMYK_M": 0.1687684,
    "CMYK_Y": 0,
    "CMYK_K": 0.7090068
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0438",
    "Farbtonhilfsbezeichnung": "T 112",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "142",
    "Y": 14,
    "L": 43.7869002551181,
    "a": -22.9282598051642,
    "b": -24.560356139428,
    "C": 33.5993480798162,
    "h": 0.81975280107664,
    "CMY_C": 1,
    "CMY_M": 0.5467342,
    "CMY_Y": 0.441378,
    "CMYK_C": 1,
    "CMYK_M": 0.1886001,
    "CMYK_Y": 0,
    "CMYK_K": 0.441378
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0439",
    "Farbtonhilfsbezeichnung": "T 212",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "141",
    "Y": 14,
    "L": 44.7668337559387,
    "a": -33.5281721928345,
    "b": -22.5112756630098,
    "C": 40.3843517041982,
    "h": 0.59128184609193,
    "CMY_C": 1,
    "CMY_M": 0.5227467,
    "CMY_Y": 0.4454463,
    "CMYK_C": 1,
    "CMYK_M": 0.1393921,
    "CMYK_Y": 0,
    "CMYK_K": 0.4454463
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0440",
    "Farbtonhilfsbezeichnung": "T 312",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "119",
    "Bcolor": "133",
    "Y": 14,
    "L": 43.9297007593925,
    "a": -33.0367671596204,
    "b": -18.9738760287767,
    "C": 38.0977158884146,
    "h": 0.52132764193585,
    "CMY_C": 1,
    "CMY_M": 0.5329092,
    "CMY_Y": 0.4768965,
    "CMYK_C": 1,
    "CMYK_M": 0.1070777,
    "CMYK_Y": 0,
    "CMYK_K": 0.4768965
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0441",
    "Farbtonhilfsbezeichnung": "T 412",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "109",
    "Y": 8,
    "L": 34.621908392032,
    "a": -28.2586240816027,
    "b": -18.3672198233945,
    "C": 33.7031838114181,
    "h": 0.57635318355702,
    "CMY_C": 1,
    "CMY_M": 0.6310997,
    "CMY_Y": 0.5723029,
    "CMYK_C": 1,
    "CMYK_M": 0.137473,
    "CMYK_Y": 0,
    "CMYK_K": 0.5723029
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0442",
    "Farbtonhilfsbezeichnung": "T 512",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "120",
    "Y": 9,
    "L": 35.2591734258196,
    "a": -21.3486862108815,
    "b": -24.0774653830366,
    "C": 32.179041971476,
    "h": 0.84539673056254,
    "CMY_C": 1,
    "CMY_M": 0.6323056,
    "CMY_Y": 0.5299254,
    "CMYK_C": 1,
    "CMYK_M": 0.2177957,
    "CMYK_Y": 0,
    "CMYK_K": 0.5299254
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0443",
    "Farbtonhilfsbezeichnung": "T 113",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "135",
    "Bcolor": "155",
    "Y": 21,
    "L": 52.7056663524686,
    "a": -16.3864692667935,
    "b": -18.0961608820107,
    "C": 24.4128534526217,
    "h": 0.83493883626999,
    "CMY_C": 0.7560703,
    "CMY_M": 0.4698453,
    "CMY_Y": 0.392079,
    "CMYK_C": 0.5987477,
    "CMYK_M": 0.1279217,
    "CMYK_Y": 0,
    "CMYK_K": 0.392079
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0444",
    "Farbtonhilfsbezeichnung": "T 213",
    "Farbtonklasse": "04",
    "Rcolor": "25",
    "Gcolor": "114",
    "Bcolor": "131",
    "Y": 14,
    "L": 43.905205463642,
    "a": -18.4560275986217,
    "b": -17.3466230636178,
    "C": 25.3284481647085,
    "h": 0.75442141599288,
    "CMY_C": 0.9025131,
    "CMY_M": 0.5547219,
    "CMY_Y": 0.4866547,
    "CMYK_C": 0.810095,
    "CMYK_M": 0.1325954,
    "CMYK_Y": 0,
    "CMYK_K": 0.4866547
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0445",
    "Farbtonhilfsbezeichnung": "T 313",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "104",
    "Y": 8,
    "L": 34.1469049134799,
    "a": -16.6805795501712,
    "b": -16.0514330567431,
    "C": 23.1493031710394,
    "h": 0.76617939312744,
    "CMY_C": 1,
    "CMY_M": 0.6521268,
    "CMY_Y": 0.5905327,
    "CMYK_C": 1,
    "CMYK_M": 0.150425,
    "CMYK_Y": 0,
    "CMYK_K": 0.5905327
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0446",
    "Farbtonhilfsbezeichnung": "T 413",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "71",
    "Bcolor": "85",
    "Y": 5,
    "L": 26.571673838748,
    "a": -16.468792578332,
    "b": -15.2012610272184,
    "C": 22.4120384125531,
    "h": 0.74539648164825,
    "CMY_C": 1,
    "CMY_M": 0.723032,
    "CMY_Y": 0.6672883,
    "CMYK_C": 1,
    "CMYK_M": 0.1675435,
    "CMYK_Y": 0,
    "CMYK_K": 0.6672883
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0447",
    "Farbtonhilfsbezeichnung": "T 513",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "70",
    "Bcolor": "78",
    "Y": 5,
    "L": 26.0474967956543,
    "a": -17.9570140838623,
    "b": -11.5258731842041,
    "C": 21.3377628326416,
    "h": 212.694747924805,
    "CMY_C": 1,
    "CMY_M": 0.72683656215668,
    "CMY_Y": 0.6940506696701,
    "CMYK_C": 1,
    "CMYK_M": 0.10716118663549,
    "CMYK_Y": 0,
    "CMYK_K": 0.6940506696701
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0448",
    "Farbtonhilfsbezeichnung": "T 114",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "160",
    "Bcolor": "164",
    "Y": 32,
    "L": 62.9717440789527,
    "a": -14.2771278327491,
    "b": -7.45013815366995,
    "C": 16.1040658736056,
    "h": 0.48095344859174,
    "CMY_C": 0.5515397,
    "CMY_M": 0.3709929,
    "CMY_Y": 0.3576932,
    "CMYK_C": 0.3017974,
    "CMYK_M": 0.02070617,
    "CMYK_Y": 0,
    "CMYK_K": 0.3576932
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0449",
    "Farbtonhilfsbezeichnung": "T 214",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "132",
    "Bcolor": "136",
    "Y": 21,
    "L": 52.4212113321366,
    "a": -13.0615304855772,
    "b": -7.47266883495248,
    "C": 15.0480682528534,
    "h": 0.51966176855499,
    "CMY_C": 0.6459315,
    "CMY_M": 0.481714,
    "CMY_Y": 0.4654367,
    "CMYK_C": 0.337649,
    "CMYK_M": 0.03044987,
    "CMYK_Y": 0,
    "CMYK_K": 0.4654367
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0450",
    "Farbtonhilfsbezeichnung": "T 314",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "108",
    "Bcolor": "114",
    "Y": 13,
    "L": 42.7628999064825,
    "a": -13.8542356202623,
    "b": -8.49789605478379,
    "C": 16.2528176627825,
    "h": 0.55019890380837,
    "CMY_C": 0.7547554,
    "CMY_M": 0.5759597,
    "CMY_Y": 0.554494,
    "CMYK_C": 0.4495145,
    "CMYK_M": 0.04818297,
    "CMYK_Y": 0,
    "CMYK_K": 0.554494
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0451",
    "Farbtonhilfsbezeichnung": "T 414",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "88",
    "Bcolor": "91",
    "Y": 8,
    "L": 34.6351906009981,
    "a": -13.4417734334319,
    "b": -6.5816953742987,
    "C": 14.9666291139916,
    "h": 0.45532923909699,
    "CMY_C": 0.8172554,
    "CMY_M": 0.6550812,
    "CMY_Y": 0.6441792,
    "CMYK_C": 0.4864139,
    "CMYK_M": 0.03063907,
    "CMYK_Y": 0,
    "CMYK_K": 0.6441792
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0452",
    "Farbtonhilfsbezeichnung": "T 514",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 6,
    "L": 29.7784934642493,
    "a": -15.0934539428706,
    "b": -10.0870697756089,
    "C": 18.1538240760331,
    "h": 0.58913776472982,
    "CMY_C": 0.9208713,
    "CMY_M": 0.6969693,
    "CMY_Y": 0.6681384,
    "CMYK_C": 0.7615613,
    "CMYK_M": 0.08687647,
    "CMYK_Y": 0,
    "CMYK_K": 0.6681384
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0453",
    "Farbtonhilfsbezeichnung": "T 115",
    "Farbtonklasse": "03",
    "Rcolor": "10",
    "Gcolor": "148",
    "Bcolor": "126",
    "Y": 23,
    "L": 54.792401280741,
    "a": -37.9056944179345,
    "b": 1.69893197289681,
    "C": 37.9437483540353,
    "h": -0.04478999123095,
    "CMY_C": 0.9601471,
    "CMY_M": 0.4198945,
    "CMY_Y": 0.5056209,
    "CMYK_C": 0.9313006,
    "CMYK_M": 0,
    "CMYK_Y": 0.1477772,
    "CMYK_K": 0.4198945
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0454",
    "Farbtonhilfsbezeichnung": "T 215",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "119",
    "Bcolor": "101",
    "Y": 14,
    "L": 44.0624967755223,
    "a": -34.7630059639593,
    "b": 0.9509406340983,
    "C": 34.7760100031595,
    "h": -0.02734813977781,
    "CMY_C": 1,
    "CMY_M": 0.5342853,
    "CMY_Y": 0.6047192,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1512383,
    "CMYK_K": 0.5342853
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0455",
    "Farbtonhilfsbezeichnung": "T 315",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "80",
    "Y": 9,
    "L": 35.0691375732422,
    "a": -34.6402778625488,
    "b": 0.3838033080101,
    "C": 34.6424026489258,
    "h": 179.365203857422,
    "CMY_C": 1,
    "CMY_M": 0.62361574172974,
    "CMY_Y": 0.68514561653137,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.16347621381283,
    "CMYK_K": 0.62361574172974
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0456",
    "Farbtonhilfsbezeichnung": "T 415",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "88",
    "Bcolor": "79",
    "Y": 8,
    "L": 33.8155182721018,
    "a": -20.9462472091574,
    "b": -0.40119106868795,
    "C": 20.9500889358668,
    "h": 0.01915102100738,
    "CMY_C": 0.8761688,
    "CMY_M": 0.6530635,
    "CMY_Y": 0.6905416,
    "CMYK_C": 0.6430727,
    "CMYK_M": 0,
    "CMYK_Y": 0.1080257,
    "CMYK_K": 0.6530635
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0457",
    "Farbtonhilfsbezeichnung": "T 515",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "92",
    "Y": 9,
    "L": 35.9929622811836,
    "a": -32.3443217812288,
    "b": -5.69654051508162,
    "C": 32.8421333857537,
    "h": 0.17433393475782,
    "CMY_C": 1,
    "CMY_M": 0.6160257,
    "CMY_Y": 0.6384886,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.05850105,
    "CMYK_K": 0.6160257
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0458",
    "Farbtonhilfsbezeichnung": "T 116",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "119",
    "Bcolor": "77",
    "Y": 13,
    "L": 43.3226041091622,
    "a": -42.9326741003146,
    "b": 14.0133913506306,
    "C": 45.1618162007436,
    "h": -0.31550113492353,
    "CMY_C": 1,
    "CMY_M": 0.5339742,
    "CMY_Y": 0.6979007,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3517543,
    "CMYK_K": 0.5339742
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0459",
    "Farbtonhilfsbezeichnung": "T 216",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "111",
    "Bcolor": "92",
    "Y": 13,
    "L": 42.2317734933605,
    "a": -25.412324198924,
    "b": 3.91507380348982,
    "C": 25.7121376800528,
    "h": -0.15286018906557,
    "CMY_C": 0.8184748,
    "CMY_M": 0.5660309,
    "CMY_Y": 0.6402492,
    "CMYK_C": 0.5817093,
    "CMYK_M": 0,
    "CMYK_Y": 0.171022,
    "CMYK_K": 0.5660309
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0460",
    "Farbtonhilfsbezeichnung": "T 316",
    "Farbtonklasse": "04",
    "Rcolor": "10",
    "Gcolor": "97",
    "Bcolor": "62",
    "Y": 9,
    "L": 35.955193132565,
    "a": -32.8385755377549,
    "b": 12.7946813828831,
    "C": 35.2430974098238,
    "h": -0.37152925475758,
    "CMY_C": 0.9591675,
    "CMY_M": 0.6192588,
    "CMY_Y": 0.7552501,
    "CMYK_C": 0.8927553,
    "CMYK_M": 0,
    "CMYK_Y": 0.3571751,
    "CMYK_K": 0.6192588
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0461",
    "Farbtonhilfsbezeichnung": "T 416",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "87",
    "Bcolor": "64",
    "Y": 7,
    "L": 32.4491402606196,
    "a": -26.493486081837,
    "b": 6.87485059965406,
    "C": 27.3709403480416,
    "h": -0.25389226895205,
    "CMY_C": 0.9224771,
    "CMY_M": 0.6600057,
    "CMY_Y": 0.7482864,
    "CMYK_C": 0.7719877,
    "CMYK_M": 0,
    "CMYK_Y": 0.2596534,
    "CMYK_K": 0.6600057
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0462",
    "Farbtonhilfsbezeichnung": "T 516",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "70",
    "Bcolor": "57",
    "Y": 5,
    "L": 26.6337070465088,
    "a": -18.5910453796387,
    "b": 3.51855325698853,
    "C": 18.9210777282715,
    "h": 169.282913208008,
    "CMY_C": 0.89072412252426,
    "CMY_M": 0.72399079799652,
    "CMY_Y": 0.77799475193024,
    "CMYK_C": 0.60408610105515,
    "CMYK_M": 0,
    "CMYK_Y": 0.19565998017788,
    "CMYK_K": 0.72399079799652
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0463",
    "Farbtonhilfsbezeichnung": "T 117",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "130",
    "Bcolor": "72",
    "Y": 18,
    "L": 50.269344329834,
    "a": -23.7598266601563,
    "b": 26.9069671630859,
    "C": 35.895881652832,
    "h": 131.445663452148,
    "CMY_C": 0.63398265838623,
    "CMY_M": 0.49206328392029,
    "CMY_Y": 0.71929758787155,
    "CMYK_C": 0.27940365672112,
    "CMYK_M": 0,
    "CMYK_Y": 0.44736734032631,
    "CMYK_K": 0.49206328392029
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0464",
    "Farbtonhilfsbezeichnung": "T 217",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "104",
    "Bcolor": "56",
    "Y": 12,
    "L": 39.5320281982422,
    "a": -27.2819747924805,
    "b": 21.6129951477051,
    "C": 34.8055686950684,
    "h": 141.61344909668,
    "CMY_C": 0.78324401378632,
    "CMY_M": 0.59280687570572,
    "CMY_Y": 0.78079444169998,
    "CMYK_C": 0.46768260002136,
    "CMYK_M": 0,
    "CMYK_Y": 0.46166685223579,
    "CMYK_K": 0.59280687570572
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0465",
    "Farbtonhilfsbezeichnung": "T 317",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "95",
    "Bcolor": "52",
    "Y": 9,
    "L": 36.5120124816895,
    "a": -22.5468864440918,
    "b": 19.9881286621094,
    "C": 30.1311702728271,
    "h": 138.442565917969,
    "CMY_C": 0.77351415157318,
    "CMY_M": 0.62849569320679,
    "CMY_Y": 0.79577875137329,
    "CMYK_C": 0.39035472273827,
    "CMYK_M": 0,
    "CMYK_Y": 0.45028564333916,
    "CMYK_K": 0.62849569320679
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0466",
    "Farbtonhilfsbezeichnung": "T 417",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "86",
    "Bcolor": "57",
    "Y": 8,
    "L": 34.3276431352513,
    "a": -13.7500198130155,
    "b": 14.3151621052025,
    "C": 19.8491035302994,
    "h": -0.80553221868136,
    "CMY_C": 0.7394933,
    "CMY_M": 0.6616845,
    "CMY_Y": 0.7767575,
    "CMYK_C": 0.2299889,
    "CMYK_M": 0,
    "CMYK_Y": 0.3401351,
    "CMYK_K": 0.6616845
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0467",
    "Farbtonhilfsbezeichnung": "T 517",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "83",
    "Bcolor": "54",
    "Y": 8,
    "L": 33.837913162395,
    "a": -9.35174057841812,
    "b": 15.8471747603133,
    "C": 18.4007608464961,
    "h": -1.03767293524785,
    "CMY_C": 0.7102272,
    "CMY_M": 0.6737293,
    "CMY_Y": 0.7900726,
    "CMYK_C": 0.1118639,
    "CMYK_M": 0,
    "CMYK_Y": 0.3565853,
    "CMYK_K": 0.6737293
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0468",
    "Farbtonhilfsbezeichnung": "T 118",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "151",
    "Bcolor": "51",
    "Y": 32,
    "L": 63.4238179188075,
    "a": -0.35316688040382,
    "b": 53.6819737531418,
    "C": 53.6831354605748,
    "h": -1.5642175488432,
    "CMY_C": 0.2977983,
    "CMY_M": 0.4062334,
    "CMY_Y": 0.7995824,
    "CMYK_C": 0,
    "CMYK_M": 0.1544215,
    "CMYK_Y": 0.7145869,
    "CMYK_K": 0.2977983
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0469",
    "Farbtonhilfsbezeichnung": "T 218",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "143",
    "Bcolor": "58",
    "Y": 29,
    "L": 60.4651688868018,
    "a": 1.20118279128567,
    "b": 47.1637893509013,
    "C": 47.1790829291358,
    "h": 1.54533350459924,
    "CMY_C": 0.3282641,
    "CMY_M": 0.4392697,
    "CMY_Y": 0.7708454,
    "CMYK_C": 0,
    "CMYK_M": 0.1652519,
    "CMYK_Y": 0.6588621,
    "CMYK_K": 0.3282641
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0470",
    "Farbtonhilfsbezeichnung": "T 318",
    "Farbtonklasse": "04",
    "Rcolor": "138",
    "Gcolor": "118",
    "Bcolor": "58",
    "Y": 19,
    "L": 50.3980823973444,
    "a": 0.05991698532237,
    "b": 35.0706650477092,
    "C": 35.0707162306923,
    "h": 1.56908786398289,
    "CMY_C": 0.4582031,
    "CMY_M": 0.5360644,
    "CMY_Y": 0.7716274,
    "CMYK_C": 0,
    "CMYK_M": 0.1437095,
    "CMYK_Y": 0.5784904,
    "CMYK_K": 0.4582031
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0471",
    "Farbtonhilfsbezeichnung": "T 418",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "98",
    "Bcolor": "63",
    "Y": 12,
    "L": 41.1309730829541,
    "a": -3.65503717307364,
    "b": 20.0216877964072,
    "C": 20.3525742586374,
    "h": -1.39023074503378,
    "CMY_C": 0.5970068,
    "CMY_M": 0.6161294,
    "CMY_Y": 0.7517187,
    "CMYK_C": 0,
    "CMYK_M": 0.04745152,
    "CMYK_Y": 0.383907,
    "CMYK_K": 0.5970068
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0472",
    "Farbtonhilfsbezeichnung": "T 518",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "105",
    "Bcolor": "57",
    "Y": 14,
    "L": 43.6317523923881,
    "a": -5.43204827110694,
    "b": 27.2058657153546,
    "C": 27.7428599416417,
    "h": -1.37372328860608,
    "CMY_C": 0.5714732,
    "CMY_M": 0.5897417,
    "CMY_Y": 0.7782456,
    "CMYK_C": 0,
    "CMYK_M": 0.04263103,
    "CMYK_Y": 0.4825193,
    "CMYK_K": 0.5714732
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0473",
    "Farbtonhilfsbezeichnung": "T 119",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "135",
    "Bcolor": "63",
    "Y": 28,
    "L": 60.0599860617314,
    "a": 12.3981476916423,
    "b": 44.9686386790751,
    "C": 46.6464632189085,
    "h": 1.30177337180251,
    "CMY_C": 0.2699293,
    "CMY_M": 0.4700264,
    "CMY_Y": 0.7525945,
    "CMYK_C": 0,
    "CMYK_M": 0.2740791,
    "CMYK_Y": 0.6611212,
    "CMYK_K": 0.2699293
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0474",
    "Farbtonhilfsbezeichnung": "T 219",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "120",
    "Bcolor": "54",
    "Y": 21,
    "L": 52.7973149869885,
    "a": 8.10492943788765,
    "b": 40.4954072149472,
    "C": 41.29852160426,
    "h": 1.37326191377099,
    "CMY_C": 0.3800062,
    "CMY_M": 0.5313582,
    "CMY_Y": 0.7879614,
    "CMYK_C": 0,
    "CMYK_M": 0.2441187,
    "CMYK_Y": 0.6579989,
    "CMYK_K": 0.3800062
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0475",
    "Farbtonhilfsbezeichnung": "T 319",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "100",
    "Bcolor": "58",
    "Y": 14,
    "L": 44.3263320913007,
    "a": 6.90043137582619,
    "b": 27.7512432008427,
    "C": 28.5962838908275,
    "h": 1.32708577871697,
    "CMY_C": 0.4919197,
    "CMY_M": 0.609193,
    "CMY_Y": 0.7728091,
    "CMYK_C": 0,
    "CMYK_M": 0.2308164,
    "CMYK_Y": 0.5528446,
    "CMYK_K": 0.4919197
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0476",
    "Farbtonhilfsbezeichnung": "T 419",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "85",
    "Bcolor": "61",
    "Y": 10,
    "L": 37.020606064314,
    "a": 3.3148350597316,
    "b": 15.6707962243433,
    "C": 16.0175524278249,
    "h": 1.36233972462252,
    "CMY_C": 0.6034132,
    "CMY_M": 0.6682839,
    "CMY_Y": 0.7588764,
    "CMYK_C": 0,
    "CMYK_M": 0.1635725,
    "CMYK_Y": 0.3920029,
    "CMYK_K": 0.6034132
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0477",
    "Farbtonhilfsbezeichnung": "T 519",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "65",
    "Bcolor": "53",
    "Y": 7,
    "L": 27.8043117523193,
    "a": 0.37659966945648,
    "b": 7.89591455459595,
    "C": 7.90489053726196,
    "h": 87.2693176269531,
    "CMY_C": 0.72163999080658,
    "CMY_M": 0.74483525753021,
    "CMY_Y": 0.79176634550095,
    "CMYK_C": 0,
    "CMYK_M": 0.08332829922438,
    "CMYK_Y": 0.25192683935165,
    "CMYK_K": 0.72163999080658
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0478",
    "Farbtonhilfsbezeichnung": "W 101",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 80,
    "L": 91.8764066537209,
    "a": -2.59459252818639,
    "b": -1.03874622980329,
    "C": 2.79479947710944,
    "h": 0.3808084339256,
    "CMY_C": 0.1160376,
    "CMY_M": 0.08446885,
    "CMY_Y": 0.09103159,
    "CMYK_C": 0.03448135,
    "CMYK_M": 0,
    "CMYK_Y": 0.007168232,
    "CMYK_K": 0.08446885
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0479",
    "Farbtonhilfsbezeichnung": "W 201",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "234",
    "Bcolor": "227",
    "Y": 83,
    "L": 93.0581909971988,
    "a": 1.24982837267462,
    "b": 3.23825996447229,
    "C": 3.47108031578737,
    "h": 1.20245448760436,
    "CMY_C": 0.05749524,
    "CMY_M": 0.08157469,
    "CMY_Y": 0.1091784,
    "CMYK_C": 0,
    "CMYK_M": 0.02554837,
    "CMYK_Y": 0.05483596,
    "CMYK_K": 0.05749524
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0480",
    "Farbtonhilfsbezeichnung": "W 301",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "222",
    "Y": 83,
    "L": 92.9388973018918,
    "a": 0.76470401669404,
    "b": 5.64147640942438,
    "C": 5.69306844427852,
    "h": 1.43606715374866,
    "CMY_C": 0.05489669,
    "CMY_M": 0.08240826,
    "CMY_Y": 0.1284483,
    "CMYK_C": 0,
    "CMYK_M": 0.0291096,
    "CMYK_Y": 0.07782389,
    "CMYK_K": 0.05489669
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0481",
    "Farbtonhilfsbezeichnung": "W 401",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "212",
    "Y": 80,
    "L": 91.5230252730375,
    "a": -0.08594632695657,
    "b": 8.77363532385274,
    "C": 8.7740562778611,
    "h": -1.5610006634498,
    "CMY_C": 0.06768931,
    "CMY_M": 0.0970322,
    "CMY_Y": 0.1673958,
    "CMYK_C": 0,
    "CMYK_M": 0.03147329,
    "CMYK_Y": 0.1069455,
    "CMYK_K": 0.06768931
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0482",
    "Farbtonhilfsbezeichnung": "W 501",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "234",
    "Bcolor": "223",
    "Y": 82,
    "L": 92.764911249506,
    "a": -0.66327907867358,
    "b": 5.08214578822022,
    "C": 5.1252458427797,
    "h": -1.44101823861288,
    "CMY_C": 0.06973611,
    "CMY_M": 0.08079072,
    "CMY_Y": 0.1264127,
    "CMYK_C": 0,
    "CMYK_M": 0.01188331,
    "CMYK_Y": 0.06092532,
    "CMYK_K": 0.06973611
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0483",
    "Farbtonhilfsbezeichnung": "W 102",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "238",
    "Bcolor": "229",
    "Y": 84,
    "L": 93.6104240535283,
    "a": -2.55077579743263,
    "b": 3.21172740567275,
    "C": 4.10142049747614,
    "h": -0.89959780962066,
    "CMY_C": 0.08140162,
    "CMY_M": 0.06634132,
    "CMY_Y": 0.1034135,
    "CMYK_C": 0.01613042,
    "CMYK_M": 0,
    "CMYK_Y": 0.03970632,
    "CMYK_K": 0.06634132
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0484",
    "Farbtonhilfsbezeichnung": "W 202",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 86,
    "L": 94.1434326171875,
    "a": -0.689317882061,
    "b": 2.36566948890686,
    "C": 2.46405172348022,
    "h": 106.245269775391,
    "CMY_C": 0.06343650817871,
    "CMY_M": 0.06448429822922,
    "CMY_Y": 0.09092915058136,
    "CMYK_C": 0,
    "CMYK_M": 0.00111876032315,
    "CMYK_Y": 0.02935480885208,
    "CMYK_K": 0.06343650817871
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0485",
    "Farbtonhilfsbezeichnung": "W 302",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "235",
    "Bcolor": "223",
    "Y": 82,
    "L": 92.5537390423082,
    "a": -3.29726161723726,
    "b": 4.80196828808008,
    "C": 5.8250179066019,
    "h": -0.96908780022279,
    "CMY_C": 0.09381076,
    "CMY_M": 0.07688694,
    "CMY_Y": 0.1270369,
    "CMYK_C": 0.01833342,
    "CMYK_M": 0,
    "CMYK_Y": 0.05432694,
    "CMYK_K": 0.07688694
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0486",
    "Farbtonhilfsbezeichnung": "W 402",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "221",
    "Y": 83,
    "L": 92.9596626836619,
    "a": -1.50300789739632,
    "b": 6.22223985435697,
    "C": 6.40119532156174,
    "h": -1.33378235297301,
    "CMY_C": 0.07045037,
    "CMY_M": 0.07693007,
    "CMY_Y": 0.1328783,
    "CMYK_C": 0,
    "CMYK_M": 0.006970801,
    "CMYK_Y": 0.06715935,
    "CMYK_K": 0.07045037
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0487",
    "Farbtonhilfsbezeichnung": "W 502",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "223",
    "Y": 83,
    "L": 92.9368412134792,
    "a": -0.7192252991231,
    "b": 4.96455838997665,
    "C": 5.01638565487007,
    "h": -1.4269253118182,
    "CMY_C": 0.06862496,
    "CMY_M": 0.07870054,
    "CMY_Y": 0.1236505,
    "CMYK_C": 0,
    "CMYK_M": 0.01081796,
    "CMYK_Y": 0.05907986,
    "CMYK_K": 0.06862496
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0488",
    "Farbtonhilfsbezeichnung": "Z 101",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "233",
    "Bcolor": "206",
    "Y": 81,
    "L": 92.3486538757559,
    "a": -1.36428457754673,
    "b": 13.0453472375559,
    "C": 13.116491793042,
    "h": -1.46659494320803,
    "CMY_C": 0.05554101,
    "CMY_M": 0.08586905,
    "CMY_Y": 0.1903895,
    "CMYK_C": 0,
    "CMYK_M": 0.03211155,
    "CMYK_Y": 0.1427785,
    "CMYK_K": 0.05554101
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0489",
    "Farbtonhilfsbezeichnung": "Z 201",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "202",
    "Y": 82,
    "L": 92.6047901451909,
    "a": -0.41720688603041,
    "b": 15.9383273464586,
    "C": 15.9437868835676,
    "h": -1.54462597491004,
    "CMY_C": 0.03743248,
    "CMY_M": 0.08597065,
    "CMY_Y": 0.2090563,
    "CMYK_C": 0,
    "CMYK_M": 0.05042573,
    "CMYK_Y": 0.178298,
    "CMYK_K": 0.03743248
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0490",
    "Farbtonhilfsbezeichnung": "Z 301",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "227",
    "Bcolor": "190",
    "Y": 77,
    "L": 90.5111559393407,
    "a": -0.09720316151085,
    "b": 19.0875126027673,
    "C": 19.0877601047218,
    "h": -1.56570387062881,
    "CMY_C": 0.05049474,
    "CMY_M": 0.1108273,
    "CMY_Y": 0.2550834,
    "CMYK_C": 0,
    "CMYK_M": 0.0635411,
    "CMYK_Y": 0.2154687,
    "CMYK_K": 0.05049474
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0491",
    "Farbtonhilfsbezeichnung": "Z 401",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "183",
    "Y": 81,
    "L": 92.1116231852685,
    "a": -1.43104192231924,
    "b": 24.9863103848166,
    "C": 25.0272568938314,
    "h": -1.51358578746636,
    "CMY_C": 0.02742854,
    "CMY_M": 0.09114696,
    "CMY_Y": 0.2824118,
    "CMYK_C": 0,
    "CMYK_M": 0.06551541,
    "CMYK_Y": 0.2621743,
    "CMYK_K": 0.02742854
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0492",
    "Farbtonhilfsbezeichnung": "Z 501",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "220",
    "Bcolor": "160",
    "Y": 75,
    "L": 88.7483513772424,
    "a": 1.00121187372043,
    "b": 32.4128014377748,
    "C": 32.4282611661602,
    "h": 1.53991674914475,
    "CMY_C": 0.03240288,
    "CMY_M": 0.1358549,
    "CMY_Y": 0.3735532,
    "CMYK_C": 0,
    "CMYK_M": 0.1069164,
    "CMYK_Y": 0.3525748,
    "CMYK_K": 0.03240288
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0493",
    "Farbtonhilfsbezeichnung": "Z 103",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "222",
    "Y": 83,
    "L": 93.0210701889978,
    "a": 2.81364840848675,
    "b": 5.67037845878526,
    "C": 6.33007181890031,
    "h": 1.11019239979861,
    "CMY_C": 0.0381506,
    "CMY_M": 0.08646075,
    "CMY_Y": 0.1274539,
    "CMYK_C": 0,
    "CMYK_M": 0.05022632,
    "CMYK_Y": 0.09284542,
    "CMYK_K": 0.0381506
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0494",
    "Farbtonhilfsbezeichnung": "Z 203",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "226",
    "Bcolor": "212",
    "Y": 79,
    "L": 91.3517775981321,
    "a": 5.38649567527338,
    "b": 8.64890436150068,
    "C": 10.1891060605985,
    "h": 1.01378409409766,
    "CMY_C": 0.02890428,
    "CMY_M": 0.1122275,
    "CMY_Y": 0.1674985,
    "CMYK_C": 0,
    "CMYK_M": 0.08580331,
    "CMYK_Y": 0.1427194,
    "CMYK_K": 0.02890428
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0495",
    "Farbtonhilfsbezeichnung": "Z 303",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "215",
    "Bcolor": "198",
    "Y": 73,
    "L": 88.4546447617854,
    "a": 10.2544792944347,
    "b": 12.3118343531418,
    "C": 16.0229713455149,
    "h": 0.8763161225198,
    "CMY_C": 0.01696099,
    "CMY_M": 0.1575982,
    "CMY_Y": 0.2252312,
    "CMYK_C": 0,
    "CMYK_M": 0.1430637,
    "CMYK_Y": 0.2118636,
    "CMYK_K": 0.01696099
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0496",
    "Farbtonhilfsbezeichnung": "Z 403",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "197",
    "Bcolor": "176",
    "Y": 64,
    "L": 83.9336595285505,
    "a": 17.0525801666895,
    "b": 17.5029784832792,
    "C": 24.4365452985382,
    "h": 0.79843145909062,
    "CMY_C": 0.01053885,
    "CMY_M": 0.2264208,
    "CMY_Y": 0.3103585,
    "CMYK_C": 0,
    "CMYK_M": 0.2181813,
    "CMYK_Y": 0.3030131,
    "CMYK_K": 0.01053885
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0497",
    "Farbtonhilfsbezeichnung": "Z 503",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "180",
    "Bcolor": "158",
    "Y": 53,
    "L": 77.7155378528914,
    "a": 17.1392607346882,
    "b": 18.173083132249,
    "C": 24.9802964166412,
    "h": 0.81466631918016,
    "CMY_C": 0.08009084,
    "CMY_M": 0.2938785,
    "CMY_Y": 0.3802475,
    "CMYK_C": 0,
    "CMYK_M": 0.2324009,
    "CMYK_Y": 0.3262894,
    "CMYK_K": 0.08009084
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0498",
    "Farbtonhilfsbezeichnung": "Z 104",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "230",
    "Y": 83,
    "L": 92.8988807437709,
    "a": 4.13997372103753,
    "b": 1.67895879225668,
    "C": 4.46746964589322,
    "h": 0.38528011838282,
    "CMY_C": 0.04197868,
    "CMY_M": 0.08995461,
    "CMY_Y": 0.09893309,
    "CMYK_C": 0,
    "CMYK_M": 0.05007815,
    "CMYK_Y": 0.05945005,
    "CMYK_K": 0.04197868
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0499",
    "Farbtonhilfsbezeichnung": "Z 204",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "220",
    "Bcolor": "221",
    "Y": 74,
    "L": 89.1050849610879,
    "a": 6.31479894587006,
    "b": 0.51519430190882,
    "C": 6.33578021205604,
    "h": 0.08140493145507,
    "CMY_C": 0.0718315,
    "CMY_M": 0.137189,
    "CMY_Y": 0.1319174,
    "CMYK_C": 0,
    "CMYK_M": 0.07041556,
    "CMYK_Y": 0.06473596,
    "CMYK_K": 0.0718315
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0500",
    "Farbtonhilfsbezeichnung": "Z 304",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "213",
    "Bcolor": "219",
    "Y": 71,
    "L": 87.344444515671,
    "a": 10.0304231697686,
    "b": -0.96963769922304,
    "C": 10.07718146271,
    "h": -0.09637022054528,
    "CMY_C": 0.06853028,
    "CMY_M": 0.1655409,
    "CMY_Y": 0.1398516,
    "CMYK_C": 0,
    "CMYK_M": 0.1041479,
    "CMYK_Y": 0.07656856,
    "CMYK_K": 0.06853028
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0501",
    "Farbtonhilfsbezeichnung": "Z 404",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "204",
    "Bcolor": "213",
    "Y": 65,
    "L": 84.6818987514915,
    "a": 12.09420433973,
    "b": -1.52311231772322,
    "C": 12.189735425494,
    "h": -0.12527783925871,
    "CMY_C": 0.08502498,
    "CMY_M": 0.199871,
    "CMY_Y": 0.1646951,
    "CMYK_C": 0,
    "CMYK_M": 0.1255182,
    "CMYK_Y": 0.08707359,
    "CMYK_K": 0.08502498
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0502",
    "Farbtonhilfsbezeichnung": "Z 504",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.3123137569314,
    "a": 17.1538333796614,
    "b": -1.70037256975932,
    "C": 17.2379020328222,
    "h": -0.09880217381759,
    "CMY_C": 0.06486049,
    "CMY_M": 0.228121,
    "CMY_Y": 0.1776348,
    "CMYK_C": 0,
    "CMYK_M": 0.1745842,
    "CMYK_Y": 0.1205962,
    "CMYK_K": 0.06486049
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0503",
    "Farbtonhilfsbezeichnung": "Z 105",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 83,
    "L": 92.8417592804361,
    "a": 0.42668130516365,
    "b": 1.51960507904403,
    "C": 1.57837148112622,
    "h": 1.29706045612454,
    "CMY_C": 0.07207622,
    "CMY_M": 0.08153407,
    "CMY_Y": 0.09890975,
    "CMYK_C": 0,
    "CMYK_M": 0.01019248,
    "CMYK_Y": 0.02891781,
    "CMYK_K": 0.07207622
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0504",
    "Farbtonhilfsbezeichnung": "Z 205",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "230",
    "Y": 81,
    "L": 91.9460045013725,
    "a": 0.91821059165531,
    "b": -0.05818451059986,
    "C": 0.92005224194158,
    "h": -0.06328267169597,
    "CMY_C": 0.0835913,
    "CMY_M": 0.09227271,
    "CMY_Y": 0.09705374,
    "CMYK_C": 0,
    "CMYK_M": 0.009473281,
    "CMYK_Y": 0.01469042,
    "CMYK_K": 0.0835913
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0505",
    "Farbtonhilfsbezeichnung": "Z 305",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "219",
    "Bcolor": "226",
    "Y": 72,
    "L": 87.7713913204592,
    "a": 3.05795873841547,
    "b": -3.978920485932,
    "C": 5.01825865009177,
    "h": -0.91553495141572,
    "CMY_C": 0.1268376,
    "CMY_M": 0.142632,
    "CMY_Y": 0.1140388,
    "CMYK_C": 0.01444626,
    "CMYK_M": 0.03227372,
    "CMYK_Y": 0,
    "CMYK_K": 0.1140388
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0506",
    "Farbtonhilfsbezeichnung": "Z 405",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "210",
    "Bcolor": "222",
    "Y": 66,
    "L": 85.2115339312491,
    "a": 4.89321709136886,
    "b": -5.70994747791547,
    "C": 7.51977883343769,
    "h": -0.86227340585668,
    "CMY_C": 0.1469073,
    "CMY_M": 0.1747329,
    "CMY_Y": 0.129372,
    "CMYK_C": 0.02014098,
    "CMYK_M": 0.0521013,
    "CMYK_Y": 0,
    "CMYK_K": 0.129372
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0507",
    "Farbtonhilfsbezeichnung": "Z 505",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "192",
    "Bcolor": "211",
    "Y": 55,
    "L": 78.8173554286323,
    "a": 7.17720239021902,
    "b": -9.19612033172617,
    "C": 11.6653702601226,
    "h": -0.90808421204151,
    "CMY_C": 0.2117794,
    "CMY_M": 0.2487627,
    "CMY_Y": 0.1739578,
    "CMYK_C": 0.04578649,
    "CMYK_M": 0.09055815,
    "CMYK_Y": 0,
    "CMYK_K": 0.1739578
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0508",
    "Farbtonhilfsbezeichnung": "Z 106",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "229",
    "Bcolor": "222",
    "Y": 78,
    "L": 90.5718438800063,
    "a": -1.50760873835315,
    "b": 2.00782418040348,
    "C": 2.51082497346424,
    "h": -0.92674062637275,
    "CMY_C": 0.1110761,
    "CMY_M": 0.102443,
    "CMY_Y": 0.1278847,
    "CMYK_C": 0.009618452,
    "CMYK_M": 0,
    "CMYK_Y": 0.02834556,
    "CMYK_K": 0.102443
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0509",
    "Farbtonhilfsbezeichnung": "Z 206",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "223",
    "Bcolor": "225",
    "Y": 72,
    "L": 88.1929160093256,
    "a": -2.14594777750071,
    "b": -2.97755854103865,
    "C": 3.67027883533015,
    "h": 0.94630769898514,
    "CMY_C": 0.1602278,
    "CMY_M": 0.125975,
    "CMY_Y": 0.1174277,
    "CMYK_C": 0.04849476,
    "CMYK_M": 0.009684561,
    "CMYK_Y": 0,
    "CMYK_K": 0.1174277
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0510",
    "Farbtonhilfsbezeichnung": "Z 306",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 69,
    "L": 86.3265947333006,
    "a": -1.58667783930044,
    "b": -4.02811306401021,
    "C": 4.32934653523795,
    "h": 1.19555872428603,
    "CMY_C": 0.1800793,
    "CMY_M": 0.1476073,
    "CMY_Y": 0.1302227,
    "CMYK_C": 0.05732115,
    "CMYK_M": 0.01998743,
    "CMYK_Y": 0,
    "CMYK_K": 0.1302227
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0511",
    "Farbtonhilfsbezeichnung": "Z 406",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "211",
    "Bcolor": "222",
    "Y": 63,
    "L": 83.6085394065521,
    "a": -2.7096008779241,
    "b": -8.44089401473291,
    "C": 8.86513557062728,
    "h": 1.26017859694232,
    "CMY_C": 0.2362215,
    "CMY_M": 0.1736176,
    "CMY_Y": 0.1280955,
    "CMYK_C": 0.1240113,
    "CMYK_M": 0.05220997,
    "CMYK_Y": 0,
    "CMYK_K": 0.1280955
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0512",
    "Farbtonhilfsbezeichnung": "Z 506",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 64,
    "L": 84.1483024882709,
    "a": -2.86897173528911,
    "b": -9.14466211100737,
    "C": 9.58414544664164,
    "h": 1.26678960015872,
    "CMY_C": 0.2346035,
    "CMY_M": 0.167112,
    "CMY_Y": 0.117036,
    "CMYK_C": 0.1331509,
    "CMYK_M": 0.05671352,
    "CMYK_Y": 0,
    "CMYK_K": 0.117036
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0513",
    "Farbtonhilfsbezeichnung": "Z 107",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 80,
    "L": 91.6836601730711,
    "a": -4.8227864494832,
    "b": -2.30132499257265,
    "C": 5.34372209782266,
    "h": 0.44522344924349,
    "CMY_C": 0.141274,
    "CMY_M": 0.08111586,
    "CMY_Y": 0.08410151,
    "CMYK_C": 0.06546874,
    "CMYK_M": 0,
    "CMYK_Y": 0.003249198,
    "CMYK_K": 0.08111586
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0514",
    "Farbtonhilfsbezeichnung": "Z 207",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "225",
    "Bcolor": "225",
    "Y": 73,
    "L": 88.3200360555223,
    "a": -4.84878688426138,
    "b": -2.60214355846304,
    "C": 5.5028979045441,
    "h": 0.49254268674692,
    "CMY_C": 0.1796939,
    "CMY_M": 0.1184835,
    "CMY_Y": 0.1191406,
    "CMYK_C": 0.06943765,
    "CMYK_M": 0,
    "CMYK_Y": 0.000745452,
    "CMYK_K": 0.1184835
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0515",
    "Farbtonhilfsbezeichnung": "Z 307",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "213",
    "Bcolor": "216",
    "Y": 64,
    "L": 84.0938362714249,
    "a": -4.72156467653451,
    "b": -4.31984367260239,
    "C": 6.39954860520813,
    "h": 0.74099612440402,
    "CMY_C": 0.2313641,
    "CMY_M": 0.1649839,
    "CMY_Y": 0.1530159,
    "CMYK_C": 0.0925025,
    "CMYK_M": 0.01413009,
    "CMYK_Y": 0,
    "CMYK_K": 0.1530159
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0516",
    "Farbtonhilfsbezeichnung": "Z 407",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "208",
    "Bcolor": "214",
    "Y": 61,
    "L": 82.2334745668632,
    "a": -4.67042021356528,
    "b": -6.23078839881335,
    "C": 7.78688314038847,
    "h": 0.92756963697311,
    "CMY_C": 0.2586415,
    "CMY_M": 0.1849468,
    "CMY_Y": 0.1594872,
    "CMYK_C": 0.1179689,
    "CMYK_M": 0.03029059,
    "CMYK_Y": 0,
    "CMYK_K": 0.1594872
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0517",
    "Farbtonhilfsbezeichnung": "Z 507",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "207",
    "Bcolor": "219",
    "Y": 59,
    "L": 81.2354961766638,
    "a": -6.95013705065922,
    "b": -10.0384469686385,
    "C": 12.2096200827509,
    "h": 0.96522183200797,
    "CMY_C": 0.3052894,
    "CMY_M": 0.1897023,
    "CMY_Y": 0.1431111,
    "CMYK_C": 0.1892641,
    "CMYK_M": 0.05437258,
    "CMYK_Y": 0,
    "CMYK_K": 0.1431111
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0518",
    "Farbtonhilfsbezeichnung": "Z 108",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 77,
    "L": 90.4267811001202,
    "a": -5.73140884691442,
    "b": -1.92703839348267,
    "C": 6.04669532393068,
    "h": 0.32435008019895,
    "CMY_C": 0.161333,
    "CMY_M": 0.09321113,
    "CMY_Y": 0.1009438,
    "CMYK_C": 0.07512428,
    "CMYK_M": 0,
    "CMYK_Y": 0.008527579,
    "CMYK_K": 0.09321113
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0519",
    "Farbtonhilfsbezeichnung": "Z 208",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 75,
    "L": 89.2617255661456,
    "a": -6.13510908846832,
    "b": -4.32176636829265,
    "C": 7.50448053295576,
    "h": 0.61369418500669,
    "CMY_C": 0.186924,
    "CMY_M": 0.1046017,
    "CMY_Y": 0.09621367,
    "CMYK_C": 0.100367,
    "CMYK_M": 0.009281011,
    "CMYK_Y": 0,
    "CMYK_K": 0.09621367
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0520",
    "Farbtonhilfsbezeichnung": "Z 308",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "228",
    "Bcolor": "232",
    "Y": 74,
    "L": 88.9511146652661,
    "a": -7.78426942379679,
    "b": -5.64651340994335,
    "C": 9.6165463733571,
    "h": 0.62755386323756,
    "CMY_C": 0.2099903,
    "CMY_M": 0.1039921,
    "CMY_Y": 0.09009477,
    "CMYK_C": 0.131767,
    "CMYK_M": 0.01527337,
    "CMYK_Y": 0,
    "CMYK_K": 0.09009477
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0521",
    "Farbtonhilfsbezeichnung": "Z 408",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "221",
    "Bcolor": "227",
    "Y": 68,
    "L": 86.0580533293681,
    "a": -8.33552764125445,
    "b": -7.1191976837464,
    "C": 10.961933986226,
    "h": 0.70685727339603,
    "CMY_C": 0.2526373,
    "CMY_M": 0.1344859,
    "CMY_Y": 0.1113925,
    "CMYK_C": 0.1589507,
    "CMYK_M": 0.02598833,
    "CMYK_Y": 0,
    "CMYK_K": 0.1113925
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0522",
    "Farbtonhilfsbezeichnung": "Z 508",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "213",
    "Bcolor": "226",
    "Y": 60,
    "L": 81.812835435476,
    "a": -14.5479955758734,
    "b": -13.5078024450267,
    "C": 19.8520755128904,
    "h": 0.74833926743205,
    "CMY_C": 0.3885642,
    "CMY_M": 0.1662889,
    "CMY_Y": 0.1124414,
    "CMYK_C": 0.3111037,
    "CMYK_M": 0.06066921,
    "CMYK_Y": 0,
    "CMYK_K": 0.1124414
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0523",
    "Farbtonhilfsbezeichnung": "Z 109",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "228",
    "Bcolor": "219",
    "Y": 75,
    "L": 89.1610522938132,
    "a": -7.05805851449381,
    "b": 1.43573970727238,
    "C": 7.20260636860416,
    "h": -0.20068041205054,
    "CMY_C": 0.1737255,
    "CMY_M": 0.1052926,
    "CMY_Y": 0.1399409,
    "CMYK_C": 0.07648642,
    "CMYK_M": 0,
    "CMYK_Y": 0.03872583,
    "CMYK_K": 0.1052926
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0524",
    "Farbtonhilfsbezeichnung": "Z 110",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "239",
    "Bcolor": "221",
    "Y": 83,
    "L": 93.2308743260086,
    "a": -5.49874471204193,
    "b": 6.63990881807544,
    "C": 8.62117060036309,
    "h": -0.8791334315047,
    "CMY_C": 0.09774405,
    "CMY_M": 0.06469807,
    "CMY_Y": 0.1335926,
    "CMYK_C": 0.03533188,
    "CMYK_M": 0,
    "CMYK_Y": 0.07366022,
    "CMYK_K": 0.06469807
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0525",
    "Farbtonhilfsbezeichnung": "Z 309",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "229",
    "Bcolor": "226",
    "Y": 72,
    "L": 88.1707650337405,
    "a": -13.6817441542627,
    "b": -3.91011569480695,
    "C": 14.2295160792445,
    "h": 0.27837033554364,
    "CMY_C": 0.2638368,
    "CMY_M": 0.1004376,
    "CMY_Y": 0.1122756,
    "CMYK_C": 0.181643,
    "CMYK_M": 0,
    "CMYK_Y": 0.0131598,
    "CMYK_K": 0.1004376
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0526",
    "Farbtonhilfsbezeichnung": "Z 209",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "227",
    "Bcolor": "221",
    "Y": 72,
    "L": 87.8676570034225,
    "a": -10.8430974053126,
    "b": -1.31797787762054,
    "C": 10.9229037818244,
    "h": 0.12095658593442,
    "CMY_C": 0.2307018,
    "CMY_M": 0.1106147,
    "CMY_Y": 0.1343558,
    "CMYK_C": 0.1350226,
    "CMYK_M": 0,
    "CMYK_Y": 0.02669379,
    "CMYK_K": 0.1106147
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0527",
    "Farbtonhilfsbezeichnung": "Z 409",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "220",
    "Bcolor": "222",
    "Y": 64,
    "L": 83.7862259624177,
    "a": -19.6678987302614,
    "b": -8.32570468265525,
    "C": 21.3575185573279,
    "h": 0.40044206029039,
    "CMY_C": 0.3914706,
    "CMY_M": 0.1357288,
    "CMY_Y": 0.1289632,
    "CMYK_C": 0.3013735,
    "CMYK_M": 0.007767368,
    "CMYK_Y": 0,
    "CMYK_K": 0.1289632
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0528",
    "Farbtonhilfsbezeichnung": "Z 509",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "220",
    "Bcolor": "220",
    "Y": 63,
    "L": 83.5494669534651,
    "a": -21.3410368219756,
    "b": -7.32980822622924,
    "C": 22.5647056544112,
    "h": 0.33083735873065,
    "CMY_C": 0.4061693,
    "CMY_M": 0.1353533,
    "CMY_Y": 0.139026,
    "CMYK_C": 0.3132101,
    "CMYK_M": 0,
    "CMYK_Y": 0.004247666,
    "CMYK_K": 0.1353533
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0529",
    "Farbtonhilfsbezeichnung": "Z 111",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "236",
    "Bcolor": "215",
    "Y": 83,
    "L": 92.8616713672381,
    "a": -2.70283991831444,
    "b": 9.13714797802299,
    "C": 9.52852647560595,
    "h": -1.28318998325902,
    "CMY_C": 0.07172152,
    "CMY_M": 0.07597742,
    "CMY_Y": 0.1558546,
    "CMYK_C": 0,
    "CMYK_M": 0.004584728,
    "CMYK_Y": 0.0906335,
    "CMYK_K": 0.07172152
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0530",
    "Farbtonhilfsbezeichnung": "Z 211",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "236",
    "Bcolor": "184",
    "Y": 82,
    "L": 92.445559746357,
    "a": -7.22887132703914,
    "b": 25.0258526263181,
    "C": 26.0489900060843,
    "h": -1.2895943463797,
    "CMY_C": 0.06635374,
    "CMY_M": 0.07395058,
    "CMY_Y": 0.2802093,
    "CMYK_C": 0,
    "CMYK_M": 0.008136748,
    "CMYK_Y": 0.2290542,
    "CMYK_K": 0.06635374
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0531",
    "Farbtonhilfsbezeichnung": "Z 311",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "236",
    "Bcolor": "165",
    "Y": 80,
    "L": 91.6700064707991,
    "a": -11.8925545374234,
    "b": 33.2831963114871,
    "C": 35.3440802700336,
    "h": -1.22762054437376,
    "CMY_C": 0.09013472,
    "CMY_M": 0.07388383,
    "CMY_Y": 0.3521228,
    "CMYK_C": 0.01754735,
    "CMYK_M": 0,
    "CMYK_Y": 0.3004364,
    "CMYK_K": 0.07388383
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0532",
    "Farbtonhilfsbezeichnung": "Z 411",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "231",
    "Bcolor": "150",
    "Y": 74,
    "L": 88.8581777533358,
    "a": -17.6047928814644,
    "b": 37.020341474072,
    "C": 40.9931020448094,
    "h": -1.12690441349912,
    "CMY_C": 0.1564777,
    "CMY_M": 0.09379868,
    "CMY_Y": 0.4115321,
    "CMYK_C": 0.06916681,
    "CMYK_M": 0,
    "CMYK_Y": 0.3506213,
    "CMYK_K": 0.09379868
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0533",
    "Farbtonhilfsbezeichnung": "Z 511",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "227",
    "Bcolor": "127",
    "Y": 71,
    "L": 87.5035914065253,
    "a": -17.318612760521,
    "b": 46.5242241203891,
    "C": 49.6431040322125,
    "h": -1.21443935257271,
    "CMY_C": 0.1497241,
    "CMY_M": 0.111023,
    "CMY_Y": 0.5000904,
    "CMYK_C": 0.0435344,
    "CMYK_M": 0,
    "CMYK_Y": 0.4376575,
    "CMYK_K": 0.111023
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0534",
    "Farbtonhilfsbezeichnung": "Z 210",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "230",
    "Bcolor": "217",
    "Y": 77,
    "L": 90.2874982991948,
    "a": -5.89259261604153,
    "b": 4.32890047741741,
    "C": 7.31177318316233,
    "h": -0.63359429539139,
    "CMY_C": 0.1414527,
    "CMY_M": 0.09614211,
    "CMY_Y": 0.1488076,
    "CMYK_C": 0.05013019,
    "CMYK_M": 0,
    "CMYK_Y": 0.05826742,
    "CMYK_K": 0.09614211
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0535",
    "Farbtonhilfsbezeichnung": "Z 310",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "227",
    "Bcolor": "213",
    "Y": 72,
    "L": 88.1193437585014,
    "a": -10.3605520972357,
    "b": 3.42503012705102,
    "C": 10.9120058252707,
    "h": -0.31927388827146,
    "CMY_C": 0.2054357,
    "CMY_M": 0.110151,
    "CMY_Y": 0.1664783,
    "CMYK_C": 0.1070796,
    "CMYK_M": 0,
    "CMYK_Y": 0.0632998,
    "CMYK_K": 0.110151
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0536",
    "Farbtonhilfsbezeichnung": "Z 410",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "214",
    "Bcolor": "199",
    "Y": 63,
    "L": 83.2370388814329,
    "a": -12.4252760799684,
    "b": 3.42555274893444,
    "C": 12.8888283912529,
    "h": -0.26900970837884,
    "CMY_C": 0.2758634,
    "CMY_M": 0.1598223,
    "CMY_Y": 0.2197652,
    "CMYK_C": 0.138115,
    "CMYK_M": 0,
    "CMYK_Y": 0.07134555,
    "CMYK_K": 0.1598223
  },
  {
    "Farbtonkarten_Bezeichnung": "Schoener Wohnen",
    "Farbton_ID": "SWN0537",
    "Farbtonhilfsbezeichnung": "Z 510",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "202",
    "Bcolor": "184",
    "Y": 54,
    "L": 78.3283922306643,
    "a": -15.790023185516,
    "b": 4.11142500571107,
    "C": 16.3165145719519,
    "h": -0.25472507732514,
    "CMY_C": 0.3547089,
    "CMY_M": 0.2069084,
    "CMY_Y": 0.277766,
    "CMYK_C": 0.1863599,
    "CMYK_M": 0,
    "CMYK_Y": 0.08934344,
    "CMYK_K": 0.2069084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00001",
    "Farbtonhilfsbezeichnung": "G8.50.30",
    "Farbtonklasse": "01",
    "Y": 46,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00002",
    "Farbtonhilfsbezeichnung": "G0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "164",
    "Bcolor": "122",
    "Y": 39,
    "L": 67.9121645209291,
    "a": 0.16004381953826,
    "b": 23.3120097229281,
    "C": 23.3125590904574,
    "h": 1.56393113983325,
    "CMY_C": 0.2894777,
    "CMY_M": 0.3564451,
    "CMY_Y": 0.5197269,
    "CMYK_C": 0,
    "CMYK_M": 0.09425101,
    "CMYK_Y": 0.3240563,
    "CMYK_K": 0.2894777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00003",
    "Farbtonhilfsbezeichnung": "G0.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "163",
    "Bcolor": "142",
    "Y": 38,
    "L": 67.187722200869,
    "a": -0.0403194079836,
    "b": 11.543056626974,
    "C": 11.5431270437516,
    "h": -1.56730338334742,
    "CMY_C": 0.3255875,
    "CMY_M": 0.3610887,
    "CMY_Y": 0.4441231,
    "CMYK_C": 0,
    "CMYK_M": 0.05264017,
    "CMYK_Y": 0.1757612,
    "CMYK_K": 0.3255875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00004",
    "Farbtonhilfsbezeichnung": "A0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "122",
    "Bcolor": "124",
    "Y": 21,
    "L": 52.4432706927731,
    "a": 5.81920433513872,
    "b": 0.1731572276598,
    "C": 5.82178001298469,
    "h": 0.02974739133492,
    "CMY_C": 0.4688455,
    "CMY_M": 0.5219185,
    "CMY_Y": 0.5137329,
    "CMYK_C": 0,
    "CMYK_M": 0.09992021,
    "CMYK_Y": 0.08450913,
    "CMYK_K": 0.4688455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00005",
    "Farbtonhilfsbezeichnung": "J0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "193",
    "Bcolor": "147",
    "Y": 52,
    "L": 76.0167267483148,
    "a": -12.3270954636959,
    "b": 21.2292693330415,
    "C": 24.5487099250834,
    "h": -1.04471500841937,
    "CMY_C": 0.295692,
    "CMY_M": 0.2429199,
    "CMY_Y": 0.4250642,
    "CMYK_C": 0.06970481,
    "CMYK_M": 0,
    "CMYK_Y": 0.2405879,
    "CMYK_K": 0.2429199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00006",
    "Farbtonhilfsbezeichnung": "F2.10.50",
    "Farbtonklasse": "01",
    "Rcolor": "156",
    "Gcolor": "144",
    "Bcolor": "129",
    "Y": 28,
    "L": 60.3791275024414,
    "a": 2.21159911155701,
    "b": 8.99272918701172,
    "C": 9.26068878173828,
    "h": 76.1833343505859,
    "CMY_C": 0.38817483186722,
    "CMY_M": 0.4359370470047,
    "CMY_Y": 0.49465978145599,
    "CMYK_C": 0,
    "CMYK_M": 0.0780651345849,
    "CMYK_Y": 0.17404472827911,
    "CMYK_K": 0.38817483186722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00007",
    "Farbtonhilfsbezeichnung": "F2.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "164",
    "Bcolor": "147",
    "Y": 38,
    "L": 67.8498306274414,
    "a": 2.20489096641541,
    "b": 9.52956867218018,
    "C": 9.78132057189941,
    "h": 76.9725112915039,
    "CMY_C": 0.30811053514481,
    "CMY_M": 0.35875082015991,
    "CMY_Y": 0.42297208309174,
    "CMYK_C": 0,
    "CMYK_M": 0.07319129258394,
    "CMYK_Y": 0.16601140797138,
    "CMYK_K": 0.30811053514481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00008",
    "Farbtonhilfsbezeichnung": "E8.15.45",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "121",
    "Bcolor": "100",
    "Y": 21,
    "L": 51.9018047843201,
    "a": 4.14324264728372,
    "b": 13.4586171412978,
    "C": 14.0819329280573,
    "h": 1.2721528479967,
    "CMY_C": 0.4530768,
    "CMY_M": 0.5266286,
    "CMY_Y": 0.6072583,
    "CMYK_C": 0,
    "CMYK_M": 0.1344829,
    "CMYK_Y": 0.2819071,
    "CMYK_K": 0.4530768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00009",
    "Farbtonhilfsbezeichnung": "N0.05.60",
    "Farbtonklasse": "01",
    "Y": 42,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00010",
    "Farbtonhilfsbezeichnung": "E8.20.40",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "111",
    "Bcolor": "87",
    "Y": 18,
    "L": 48.1713977012137,
    "a": 5.33518491677698,
    "b": 16.2160267136979,
    "C": 17.0711370586604,
    "h": 1.25294458986871,
    "CMY_C": 0.4787005,
    "CMY_M": 0.5665368,
    "CMY_Y": 0.6605924,
    "CMYK_C": 0,
    "CMYK_M": 0.1684948,
    "CMYK_Y": 0.34892,
    "CMYK_K": 0.4787005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00011",
    "Farbtonhilfsbezeichnung": "D2.10.25",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "80",
    "Bcolor": "74",
    "Y": 8,
    "L": 35.3013648986816,
    "a": 5.6449122428894,
    "b": 5.27271795272827,
    "C": 7.72441530227661,
    "h": 43.047477722168,
    "CMY_C": 0.62627935409546,
    "CMY_M": 0.68716299533844,
    "CMY_Y": 0.70898431539536,
    "CMYK_C": 0,
    "CMYK_M": 0.16291217505932,
    "CMYK_Y": 0.22130155563354,
    "CMYK_K": 0.62627935409546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00012",
    "Farbtonhilfsbezeichnung": "L0.70.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "131",
    "Bcolor": "67",
    "Y": 16,
    "L": 47.5849258403105,
    "a": -47.7251612721248,
    "b": 25.5113275646549,
    "C": 54.1157911571239,
    "h": -0.49090151452692,
    "CMY_C": 1,
    "CMY_M": 0.4862007,
    "CMY_Y": 0.7383013,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.4906597,
    "CMYK_K": 0.4862007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00013",
    "Farbtonhilfsbezeichnung": "E0.20.40",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "105",
    "Bcolor": "82",
    "Y": 17,
    "L": 47.0539926237898,
    "a": 10.0329987425212,
    "b": 17.7311421998231,
    "C": 20.3728855952656,
    "h": 1.05587288238051,
    "CMY_C": 0.4600615,
    "CMY_M": 0.5886678,
    "CMY_Y": 0.680124,
    "CMYK_C": 0,
    "CMYK_M": 0.2381871,
    "CMYK_Y": 0.4075697,
    "CMYK_K": 0.4600615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00014",
    "Farbtonhilfsbezeichnung": "E8.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "158",
    "Bcolor": "124",
    "Y": 37,
    "L": 66.8644638061523,
    "a": 6.66771984100342,
    "b": 21.0488185882568,
    "C": 22.0796566009521,
    "h": 72.4231491088867,
    "CMY_C": 0.26290827989578,
    "CMY_M": 0.38207119703293,
    "CMY_Y": 0.51289796829224,
    "CMYK_C": 0,
    "CMYK_M": 0.16166633367538,
    "CMYK_Y": 0.33915683627129,
    "CMYK_K": 0.26290827989578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00015",
    "Farbtonhilfsbezeichnung": "E8.15.55",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "150",
    "Bcolor": "125",
    "Y": 33,
    "L": 63.6191548541654,
    "a": 5.16605257407648,
    "b": 16.0895878054647,
    "C": 16.898607485467,
    "h": 1.26011357384488,
    "CMY_C": 0.3178843,
    "CMY_M": 0.4110854,
    "CMY_Y": 0.5107663,
    "CMYK_C": 0,
    "CMYK_M": 0.1366352,
    "CMYK_Y": 0.2827701,
    "CMYK_K": 0.3178843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00016",
    "Farbtonhilfsbezeichnung": "E8.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "176",
    "Bcolor": "147",
    "Y": 46,
    "L": 73.3886158375337,
    "a": 5.77199554929581,
    "b": 17.9349495397088,
    "C": 18.8408690779643,
    "h": 1.25943471850705,
    "CMY_C": 0.2036147,
    "CMY_M": 0.3107562,
    "CMY_Y": 0.4251347,
    "CMYK_C": 0,
    "CMYK_M": 0.1345348,
    "CMYK_Y": 0.2781568,
    "CMYK_K": 0.2036147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00018",
    "Farbtonhilfsbezeichnung": "S0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "178",
    "Bcolor": "184",
    "Y": 44,
    "L": 72.042366027832,
    "a": -2.33368587493896,
    "b": -4.78884935379028,
    "C": 5.32720994949341,
    "h": 244.019256591797,
    "CMY_C": 0.34248960018158,
    "CMY_M": 0.30053007602692,
    "CMY_Y": 0.27945798635483,
    "CMYK_C": 0.08747805655003,
    "CMYK_M": 0.02924477495253,
    "CMYK_Y": 0,
    "CMYK_K": 0.27945798635483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00020",
    "Farbtonhilfsbezeichnung": "G0.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "224",
    "Bcolor": "198",
    "Y": 76,
    "L": 89.5980987548828,
    "a": -0.07431584596634,
    "b": 13.4136743545532,
    "C": 13.4138803482056,
    "h": 90.3174362182617,
    "CMY_C": 0.07576662302017,
    "CMY_M": 0.11963075399399,
    "CMY_Y": 0.22272157669067,
    "CMYK_C": 0,
    "CMYK_M": 0.04746001586318,
    "CMYK_Y": 0.15900199115276,
    "CMYK_K": 0.07576662302017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00021",
    "Farbtonhilfsbezeichnung": "G0.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "205",
    "Bcolor": "178",
    "Y": 61,
    "L": 82.7702789306641,
    "a": 0.46490922570229,
    "b": 14.3342323303223,
    "C": 14.3417692184448,
    "h": 88.1423492431641,
    "CMY_C": 0.14555817842484,
    "CMY_M": 0.19629096984863,
    "CMY_Y": 0.30238914489746,
    "CMYK_C": 0,
    "CMYK_M": 0.0593753606081,
    "CMYK_Y": 0.18354785442352,
    "CMYK_K": 0.14555817842484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00022",
    "Farbtonhilfsbezeichnung": "F2.40.70",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "182",
    "Bcolor": "100",
    "Y": 51,
    "L": 77.5221481323242,
    "a": 10.875415802002,
    "b": 48.0867614746094,
    "C": 49.3012313842773,
    "h": 77.2562408447266,
    "CMY_C": 0.07319623231888,
    "CMY_M": 0.28499990701675,
    "CMY_Y": 0.60629522800446,
    "CMYK_C": 0,
    "CMYK_M": 0.22853130102158,
    "CMYK_Y": 0.5752015709877,
    "CMYK_K": 0.07319623231888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00023",
    "Farbtonhilfsbezeichnung": "A0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "172",
    "Bcolor": "175",
    "Y": 45,
    "L": 72.1166085475982,
    "a": 7.83376465008606,
    "b": 0.40570255359042,
    "C": 7.84426307277668,
    "h": 0.05174273712661,
    "CMY_C": 0.2481886,
    "CMY_M": 0.3248252,
    "CMY_Y": 0.3139551,
    "CMYK_C": 0,
    "CMYK_M": 0.1019359,
    "CMYK_Y": 0.08747738,
    "CMYK_K": 0.2481886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00026",
    "Farbtonhilfsbezeichnung": "Z0.20.50",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "127",
    "Bcolor": "154",
    "Y": 27,
    "L": 58.9184074401855,
    "a": 23.8031787872314,
    "b": -7.42973136901855,
    "C": 24.9357624053955,
    "h": 342.665191650391,
    "CMY_C": 0.30564874410629,
    "CMY_M": 0.50092017650604,
    "CMY_Y": 0.39533388614655,
    "CMYK_C": 0,
    "CMYK_M": 0.28122860193253,
    "CMYK_Y": 0.12916393578053,
    "CMYK_K": 0.30564874410629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00027",
    "Farbtonhilfsbezeichnung": "V0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "144",
    "Bcolor": "183",
    "Y": 29,
    "L": 60.3708801269531,
    "a": 5.51132678985596,
    "b": -21.9718475341797,
    "C": 22.6525230407715,
    "h": 284.081298828125,
    "CMY_C": 0.47256135940552,
    "CMY_M": 0.43431586027145,
    "CMY_Y": 0.28348952531815,
    "CMYK_C": 0.26387867331505,
    "CMYK_M": 0.21050122380257,
    "CMYK_Y": 0,
    "CMYK_K": 0.28348952531815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00028",
    "Farbtonhilfsbezeichnung": "G8.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "165",
    "Bcolor": "106",
    "Y": 38,
    "L": 67.2611661724756,
    "a": -6.05027419625887,
    "b": 31.4436153644941,
    "C": 32.0204116937956,
    "h": -1.38070299780914,
    "CMY_C": 0.3222374,
    "CMY_M": 0.3510842,
    "CMY_Y": 0.5859996,
    "CMYK_C": 0,
    "CMYK_M": 0.04256183,
    "CMYK_Y": 0.3891661,
    "CMYK_K": 0.3222374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00029",
    "Farbtonhilfsbezeichnung": "N0.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "174",
    "Bcolor": "166",
    "Y": 40,
    "L": 68.7767766302219,
    "a": -11.1160695342629,
    "b": -0.00943859704389,
    "C": 11.1160735413941,
    "h": 0.00084909461446,
    "CMY_C": 0.4303789,
    "CMY_M": 0.3180278,
    "CMY_Y": 0.3485136,
    "CMYK_C": 0.1647445,
    "CMYK_M": 0,
    "CMYK_Y": 0.04470244,
    "CMYK_K": 0.3180278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00030",
    "Farbtonhilfsbezeichnung": "R0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "5",
    "Gcolor": "99",
    "Bcolor": "115",
    "Y": 11,
    "L": 38.2144838118688,
    "a": -17.7528945209287,
    "b": -16.5378788397876,
    "C": 24.2624545417548,
    "h": 0.74998025153582,
    "CMY_C": 0.9807043,
    "CMY_M": 0.6115445,
    "CMY_Y": 0.5481024,
    "CMYK_C": 0.9573007,
    "CMYK_M": 0.1403905,
    "CMYK_Y": 0,
    "CMYK_K": 0.5481024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00031",
    "Farbtonhilfsbezeichnung": "C0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "68",
    "Bcolor": "64",
    "Y": 10,
    "L": 36.1928737179376,
    "a": 25.1731761731699,
    "b": 13.6875288105501,
    "C": 28.6537474614593,
    "h": 0.49802025955517,
    "CMY_C": 0.498985,
    "CMY_M": 0.7322119,
    "CMY_Y": 0.7496734,
    "CMYK_C": 0,
    "CMYK_M": 0.4655089,
    "CMYK_Y": 0.5003611,
    "CMYK_K": 0.498985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00033",
    "Farbtonhilfsbezeichnung": "F2.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "213",
    "Bcolor": "187",
    "Y": 69,
    "L": 86.0536297837618,
    "a": 3.10695986241893,
    "b": 14.1302131742048,
    "C": 14.4677615385088,
    "h": 1.35435990497081,
    "CMY_C": 0.0903554,
    "CMY_M": 0.1666204,
    "CMY_Y": 0.2655539,
    "CMYK_C": 0,
    "CMYK_M": 0.08384045,
    "CMYK_Y": 0.192601,
    "CMYK_K": 0.0903554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00034",
    "Farbtonhilfsbezeichnung": "V0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "181",
    "Bcolor": "211",
    "Y": 48,
    "L": 74.0607118566847,
    "a": 4.07888950311647,
    "b": -16.7281720432431,
    "C": 17.2182774831565,
    "h": -1.33162975290717,
    "CMY_C": 0.3171692,
    "CMY_M": 0.2898723,
    "CMY_Y": 0.1724872,
    "CMYK_C": 0.1748396,
    "CMYK_M": 0.1418529,
    "CMYK_Y": 0,
    "CMYK_K": 0.1724872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00035",
    "Farbtonhilfsbezeichnung": "C4.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "87",
    "Bcolor": "72",
    "Y": 18,
    "L": 47.7486388344056,
    "a": 35.6832558016426,
    "b": 25.1925963362911,
    "C": 43.6802204065956,
    "h": 0.61474554176488,
    "CMY_C": 0.3058374,
    "CMY_M": 0.65977,
    "CMY_Y": 0.7172416,
    "CMYK_C": 0,
    "CMYK_M": 0.5098699,
    "CMYK_Y": 0.5926626,
    "CMYK_K": 0.3058374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00036",
    "Farbtonhilfsbezeichnung": "Y0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "76",
    "Bcolor": "103",
    "Y": 10,
    "L": 36.5246054394813,
    "a": 18.1170187713088,
    "b": -10.7142474068407,
    "C": 21.0480751294494,
    "h": -0.53406553192815,
    "CMY_C": 0.5802184,
    "CMY_M": 0.7015498,
    "CMY_Y": 0.597679,
    "CMYK_C": 0,
    "CMYK_M": 0.2890345,
    "CMYK_Y": 0.04159448,
    "CMYK_K": 0.5802184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00037",
    "Farbtonhilfsbezeichnung": "A0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "86",
    "Bcolor": "110",
    "Y": 17,
    "L": 46.6616332834118,
    "a": 35.6360549753816,
    "b": 0.52221868873318,
    "C": 35.639881124483,
    "h": 0.01465317393883,
    "CMY_C": 0.3523887,
    "CMY_M": 0.6636398,
    "CMY_Y": 0.5683783,
    "CMYK_C": 0,
    "CMYK_M": 0.4806141,
    "CMYK_Y": 0.3335173,
    "CMYK_K": 0.3523887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00038",
    "Farbtonhilfsbezeichnung": "B2.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "74",
    "Bcolor": "77",
    "Y": 10,
    "L": 36.8180145740984,
    "a": 20.5368152873405,
    "b": 5.89934686549498,
    "C": 21.3673366516692,
    "h": 0.27972549125901,
    "CMY_C": 0.5275812,
    "CMY_M": 0.7105354,
    "CMY_Y": 0.6969034,
    "CMYK_C": 0,
    "CMYK_M": 0.3872713,
    "CMYK_Y": 0.3584155,
    "CMYK_K": 0.5275812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00039",
    "Farbtonhilfsbezeichnung": "G4.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "221",
    "Bcolor": "141",
    "Y": 73,
    "L": 87.6632537841797,
    "a": -4.97975635528564,
    "b": 40.5914459228516,
    "C": 40.8957633972168,
    "h": 96.9940948486328,
    "CMY_C": 0.07058441638947,
    "CMY_M": 0.13524430990219,
    "CMY_Y": 0.44875919818878,
    "CMYK_C": 0,
    "CMYK_M": 0.06957048922777,
    "CMYK_Y": 0.40689525008202,
    "CMYK_K": 0.07058441638947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00040",
    "Farbtonhilfsbezeichnung": "H2.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "194",
    "Bcolor": "144",
    "Y": 52,
    "L": 77.1943195747068,
    "a": -7.8084790371446,
    "b": 24.5138474514306,
    "C": 25.7274379164646,
    "h": -1.26242432330709,
    "CMY_C": 0.2413282,
    "CMY_M": 0.2403997,
    "CMY_Y": 0.4361501,
    "CMYK_C": 0.001222334,
    "CMYK_M": 0,
    "CMYK_Y": 0.2577018,
    "CMYK_K": 0.2403997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00041",
    "Farbtonhilfsbezeichnung": "G0.25.85",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "225",
    "Bcolor": "158",
    "Y": 78,
    "L": 90.4428738975093,
    "a": 0.84778632325793,
    "b": 35.4232943082583,
    "C": 35.4334378983946,
    "h": 1.54686787723185,
    "CMY_C": 0.007905655,
    "CMY_M": 0.1173019,
    "CMY_Y": 0.3787304,
    "CMYK_C": 0,
    "CMYK_M": 0.110268,
    "CMYK_Y": 0.3737797,
    "CMYK_K": 0.007905655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00042",
    "Farbtonhilfsbezeichnung": "Q0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "146",
    "Bcolor": "152",
    "Y": 27,
    "L": 57.3552487079892,
    "a": -15.2714476907669,
    "b": -9.47623709217871,
    "C": 17.9726510008683,
    "h": 0.55537117684208,
    "CMY_C": 0.6297629,
    "CMY_M": 0.4268546,
    "CMY_Y": 0.402044,
    "CMYK_C": 0.3808289,
    "CMYK_M": 0.04149231,
    "CMYK_Y": 0,
    "CMYK_K": 0.402044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00043",
    "Farbtonhilfsbezeichnung": "U0.20.50",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "142",
    "Bcolor": "175",
    "Y": 27,
    "L": 58.4010437462177,
    "a": 0.25819148053812,
    "b": -20.6953490161964,
    "C": 20.6969595289454,
    "h": -1.5583211524895,
    "CMY_C": 0.5316289,
    "CMY_M": 0.4432665,
    "CMY_Y": 0.3135944,
    "CMYK_C": 0.3176467,
    "CMYK_M": 0.1889147,
    "CMYK_Y": 0,
    "CMYK_K": 0.3135944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00044",
    "Farbtonhilfsbezeichnung": "E4.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "161",
    "Bcolor": "145",
    "Y": 38,
    "L": 67.6765823364258,
    "a": 4.82252073287964,
    "b": 10.6282634735107,
    "C": 11.6711902618408,
    "h": 65.5940704345703,
    "CMY_C": 0.28920781612396,
    "CMY_M": 0.36690759658813,
    "CMY_Y": 0.4320102930069,
    "CMYK_C": 0,
    "CMYK_M": 0.10931434482336,
    "CMYK_Y": 0.20090608298779,
    "CMYK_K": 0.28920781612396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00045",
    "Farbtonhilfsbezeichnung": "T0.25.25",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "81",
    "Bcolor": "103",
    "Y": 9,
    "L": 33.4040330248967,
    "a": -3.37310315678949,
    "b": -16.2082018298263,
    "C": 16.5554713452298,
    "h": 1.36561414630213,
    "CMY_C": 0.785517,
    "CMY_M": 0.6808838,
    "CMY_Y": 0.5957186,
    "CMYK_C": 0.469471,
    "CMYK_M": 0.2106581,
    "CMYK_Y": 0,
    "CMYK_K": 0.5957186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00046",
    "Farbtonhilfsbezeichnung": "G8.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "196",
    "Bcolor": "147",
    "Y": 55,
    "L": 78.547484985348,
    "a": -6.08802395322067,
    "b": 24.778248365328,
    "C": 25.5152038539548,
    "h": -1.32986848211053,
    "CMY_C": 0.2135172,
    "CMY_M": 0.2295779,
    "CMY_Y": 0.4238892,
    "CMYK_C": 0,
    "CMYK_M": 0.02042089,
    "CMYK_Y": 0.2674845,
    "CMYK_K": 0.2135172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00047",
    "Farbtonhilfsbezeichnung": "F8.50.80",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "79",
    "Y": 67,
    "L": 86.0623397827148,
    "a": 5.59297275543213,
    "b": 67.6611251831055,
    "C": 67.8918914794922,
    "h": 85.2745819091797,
    "CMY_C": 0,
    "CMY_M": 0.18196171522141,
    "CMY_Y": 0.68950766324997,
    "CMYK_C": 0,
    "CMYK_M": 0.18196171522141,
    "CMYK_Y": 0.68950766324997,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00048",
    "Farbtonhilfsbezeichnung": "E8.25.75",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "192",
    "Bcolor": "141",
    "Y": 60,
    "L": 80.6447525024414,
    "a": 10.7068071365356,
    "b": 31.1344795227051,
    "C": 32.9240264892578,
    "h": 71.0224685668945,
    "CMY_C": 0.06327694654465,
    "CMY_M": 0.24817621707916,
    "CMY_Y": 0.44583076238632,
    "CMYK_C": 0,
    "CMYK_M": 0.19738946855068,
    "CMYK_Y": 0.40839585661888,
    "CMYK_K": 0.06327694654465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00049",
    "Farbtonhilfsbezeichnung": "D6.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "153",
    "Bcolor": "126",
    "Y": 38,
    "L": 67.0951558751976,
    "a": 15.1002707831111,
    "b": 20.6638991669231,
    "C": 25.5932590051374,
    "h": 0.93972548591027,
    "CMY_C": 0.2082059,
    "CMY_M": 0.4008869,
    "CMY_Y": 0.5062871,
    "CMYK_C": 0,
    "CMYK_M": 0.2433474,
    "CMYK_Y": 0.376463,
    "CMYK_K": 0.2082059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00052",
    "Farbtonhilfsbezeichnung": "F2.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "207",
    "Bcolor": "162",
    "Y": 68,
    "L": 85.0449855650823,
    "a": 5.50141966525719,
    "b": 26.1689941585439,
    "C": 26.7410148199948,
    "h": 1.3635870769307,
    "CMY_C": 0.05679842,
    "CMY_M": 0.1862841,
    "CMY_Y": 0.3645925,
    "CMYK_C": 0,
    "CMYK_M": 0.1372831,
    "CMYK_Y": 0.3263291,
    "CMYK_K": 0.05679842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00053",
    "Farbtonhilfsbezeichnung": "F6.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "182",
    "Y": 69,
    "L": 84.9185232897684,
    "a": 1.97026047524562,
    "b": 15.1481098706277,
    "C": 15.275704860756,
    "h": 1.44145600359964,
    "CMY_C": 0.1086256,
    "CMY_M": 0.1765906,
    "CMY_Y": 0.2853107,
    "CMYK_C": 0,
    "CMYK_M": 0.07624744,
    "CMYK_Y": 0.1982165,
    "CMYK_K": 0.1086256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00054",
    "Farbtonhilfsbezeichnung": "E4.40.50",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "127",
    "Bcolor": "70",
    "Y": 27,
    "L": 58.0430716628463,
    "a": 16.9568676096607,
    "b": 39.1299889854926,
    "C": 42.6461181954036,
    "h": 1.16187689989038,
    "CMY_C": 0.2732081,
    "CMY_M": 0.5015532,
    "CMY_Y": 0.7252304,
    "CMYK_C": 0,
    "CMYK_M": 0.3141823,
    "CMYK_Y": 0.6219419,
    "CMYK_K": 0.2732081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00055",
    "Farbtonhilfsbezeichnung": "E4.20.75",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "198",
    "Bcolor": "156",
    "Y": 62,
    "L": 82.8694458007813,
    "a": 11.4310960769653,
    "b": 26.2082920074463,
    "C": 28.5927352905273,
    "h": 66.4349365234375,
    "CMY_C": 0.04202550649643,
    "CMY_M": 0.22497409582138,
    "CMY_Y": 0.38636553287506,
    "CMYK_C": 0,
    "CMYK_M": 0.19097438454628,
    "CMYK_Y": 0.35944592952728,
    "CMYK_K": 0.04202550649643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00056",
    "Farbtonhilfsbezeichnung": "E4.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "216",
    "Bcolor": "192",
    "Y": 74,
    "L": 87.9719506809468,
    "a": 5.53862212621708,
    "b": 14.380172106521,
    "C": 15.4099216373798,
    "h": 1.20315086935248,
    "CMY_C": 0.0506012,
    "CMY_M": 0.151521,
    "CMY_Y": 0.2464527,
    "CMYK_C": 0,
    "CMYK_M": 0.1062987,
    "CMYK_Y": 0.20629,
    "CMYK_K": 0.0506012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00057",
    "Farbtonhilfsbezeichnung": "F2.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "135",
    "Bcolor": "105",
    "Y": 26,
    "L": 57.4616926656785,
    "a": 3.96389101278716,
    "b": 18.7784176892907,
    "C": 19.1922224579312,
    "h": 1.36276270364771,
    "CMY_C": 0.3855853,
    "CMY_M": 0.4716794,
    "CMY_Y": 0.5898273,
    "CMYK_C": 0,
    "CMYK_M": 0.1401238,
    "CMYK_Y": 0.3324172,
    "CMYK_K": 0.3855853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00059",
    "Farbtonhilfsbezeichnung": "G0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "179",
    "Bcolor": "166",
    "Y": 46,
    "L": 72.8819427490234,
    "a": -0.15583038330078,
    "b": 6.31410121917725,
    "C": 6.31602382659912,
    "h": 91.4137573242188,
    "CMY_C": 0.28013080358505,
    "CMY_M": 0.2994681596756,
    "CMY_Y": 0.3487508893013,
    "CMYK_C": 0,
    "CMYK_M": 0.02686231955886,
    "CMYK_Y": 0.09532298892736,
    "CMYK_K": 0.28013080358505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00060",
    "Farbtonhilfsbezeichnung": "N0.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "150",
    "Bcolor": "139",
    "Y": 28,
    "L": 58.1462543357696,
    "a": -20.0921724071699,
    "b": -0.47172697776045,
    "C": 20.0977092819303,
    "h": 0.02347383454662,
    "CMY_C": 0.6225075,
    "CMY_M": 0.4124714,
    "CMY_Y": 0.4554998,
    "CMYK_C": 0.3574909,
    "CMYK_M": 0,
    "CMYK_Y": 0.0732363,
    "CMYK_K": 0.4124714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00061",
    "Farbtonhilfsbezeichnung": "E0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "197",
    "Bcolor": "186",
    "Y": 60,
    "L": 80.6060118882805,
    "a": 3.66130616336824,
    "b": 6.85749458953886,
    "C": 7.77369891798447,
    "h": 1.08038773731094,
    "CMY_C": 0.1668362,
    "CMY_M": 0.2255765,
    "CMY_Y": 0.2706133,
    "CMYK_C": 0,
    "CMYK_M": 0.07050261,
    "CMYK_Y": 0.1245578,
    "CMYK_K": 0.1668362
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00062",
    "Farbtonhilfsbezeichnung": "F6.20.60",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "160",
    "Bcolor": "121",
    "Y": 37,
    "L": 66.8111136570726,
    "a": 2.17454151894797,
    "b": 22.6196548429146,
    "C": 22.7239392718388,
    "h": 1.47495580939334,
    "CMY_C": 0.2895041,
    "CMY_M": 0.3724,
    "CMY_Y": 0.5253721,
    "CMYK_C": 0,
    "CMYK_M": 0.1166734,
    "CMYK_Y": 0.3319766,
    "CMYK_K": 0.2895041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00063",
    "Farbtonhilfsbezeichnung": "F6.35.75",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "196",
    "Bcolor": "117",
    "Y": 60,
    "L": 80.9633939281185,
    "a": 5.16269791347007,
    "b": 44.1949339904197,
    "C": 44.4954563990898,
    "h": 1.45450687205959,
    "CMY_C": 0.07413758,
    "CMY_M": 0.2331287,
    "CMY_Y": 0.542764,
    "CMYK_C": 0,
    "CMYK_M": 0.1717222,
    "CMYK_Y": 0.5061513,
    "CMYK_K": 0.07413758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00064",
    "Farbtonhilfsbezeichnung": "F6.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "162",
    "Bcolor": "140",
    "Y": 38,
    "L": 67.0211394718088,
    "a": 1.30563132857231,
    "b": 12.3750867381371,
    "C": 12.4437713311747,
    "h": 1.46568037794905,
    "CMY_C": 0.3159247,
    "CMY_M": 0.366056,
    "CMY_Y": 0.4514163,
    "CMYK_C": 0,
    "CMYK_M": 0.07328334,
    "CMYK_Y": 0.1980654,
    "CMYK_K": 0.3159247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00065",
    "Farbtonhilfsbezeichnung": "G8.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "115",
    "Bcolor": "98",
    "Y": 18,
    "L": 48.1253177756027,
    "a": -2.00159060187982,
    "b": 9.03652595498898,
    "C": 9.25554786453634,
    "h": -1.3528157105327,
    "CMY_C": 0.5408361,
    "CMY_M": 0.549739,
    "CMY_Y": 0.6149588,
    "CMYK_C": 0,
    "CMYK_M": 0.01938939,
    "CMYK_Y": 0.1614297,
    "CMYK_K": 0.5408361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00066",
    "Farbtonhilfsbezeichnung": "G0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "215",
    "Bcolor": "188",
    "Y": 68,
    "L": 86.3805847167969,
    "a": 0.71691435575485,
    "b": 14.2416257858276,
    "C": 14.2596588134766,
    "h": 87.1182022094727,
    "CMY_C": 0.10374671220779,
    "CMY_M": 0.15728688240051,
    "CMY_Y": 0.26326930522919,
    "CMYK_C": 0,
    "CMYK_M": 0.05973776802421,
    "CMYK_Y": 0.17798829078674,
    "CMYK_K": 0.10374671220779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00067",
    "Farbtonhilfsbezeichnung": "D2.25.30",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "80",
    "Bcolor": "62",
    "Y": 11,
    "L": 38.1885305966324,
    "a": 15.1523061365631,
    "b": 17.1323665186283,
    "C": 22.8716060604572,
    "h": 0.84665271933995,
    "CMY_C": 0.5248079,
    "CMY_M": 0.6855526,
    "CMY_Y": 0.7555794,
    "CMYK_C": 0,
    "CMYK_M": 0.3382731,
    "CMYK_Y": 0.4856384,
    "CMYK_K": 0.5248079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00068",
    "Farbtonhilfsbezeichnung": "T0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "94",
    "Bcolor": "104",
    "Y": 12,
    "L": 39.2132553125105,
    "a": -1.76447727144072,
    "b": -8.0892959812441,
    "C": 8.27949814382508,
    "h": 1.35603521229673,
    "CMY_C": 0.6781126,
    "CMY_M": 0.6320066,
    "CMY_Y": 0.5902835,
    "CMYK_C": 0.2143656,
    "CMYK_M": 0.1018341,
    "CMYK_Y": 0,
    "CMYK_K": 0.5902835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00069",
    "Farbtonhilfsbezeichnung": "G8.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "190",
    "Bcolor": "166",
    "Y": 53,
    "L": 76.7987311667944,
    "a": -2.15512895464737,
    "b": 12.0863607364874,
    "C": 12.2769986830522,
    "h": -1.39434003238038,
    "CMY_C": 0.2361896,
    "CMY_M": 0.2544698,
    "CMY_Y": 0.3493169,
    "CMYK_C": 0,
    "CMYK_M": 0.02393284,
    "CMYK_Y": 0.1481091,
    "CMYK_K": 0.2361896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00070",
    "Farbtonhilfsbezeichnung": "C4.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "125",
    "Bcolor": "114",
    "Y": 26,
    "L": 57.2902669145497,
    "a": 19.1477107708066,
    "b": 13.399977643903,
    "C": 23.3707986303328,
    "h": 0.61060608454505,
    "CMY_C": 0.3053448,
    "CMY_M": 0.5102669,
    "CMY_Y": 0.5522777,
    "CMYK_C": 0,
    "CMYK_M": 0.2949983,
    "CMYK_Y": 0.3554755,
    "CMYK_K": 0.3053448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00071",
    "Farbtonhilfsbezeichnung": "D6.20.40",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "104",
    "Bcolor": "85",
    "Y": 17,
    "L": 47.106301564104,
    "a": 12.036531729671,
    "b": 15.9119561210782,
    "C": 19.9516526553189,
    "h": 0.92318267936646,
    "CMY_C": 0.451037,
    "CMY_M": 0.5927107,
    "CMY_Y": 0.6673154,
    "CMYK_C": 0,
    "CMYK_M": 0.2580752,
    "CMYK_Y": 0.3939763,
    "CMYK_K": 0.451037
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00072",
    "Farbtonhilfsbezeichnung": "E8.30.50",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "129",
    "Bcolor": "85",
    "Y": 25,
    "L": 56.6167799862532,
    "a": 9.46320719142768,
    "b": 28.7009923833342,
    "C": 30.220841386965,
    "h": 1.25230393018075,
    "CMY_C": 0.3446807,
    "CMY_M": 0.4949765,
    "CMY_Y": 0.6654509,
    "CMYK_C": 0,
    "CMYK_M": 0.2293474,
    "CMYK_Y": 0.4894868,
    "CMYK_K": 0.3446807
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00073",
    "Farbtonhilfsbezeichnung": "E4.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "88",
    "Bcolor": "78",
    "Y": 11,
    "L": 38.3571311178551,
    "a": 2.7134569471477,
    "b": 7.44958391924857,
    "C": 7.92837620032948,
    "h": 1.22148985836188,
    "CMY_C": 0.6097479,
    "CMY_M": 0.6529561,
    "CMY_Y": 0.6951527,
    "CMYK_C": 0,
    "CMYK_M": 0.1107184,
    "CMYK_Y": 0.218845,
    "CMYK_K": 0.6097479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00074",
    "Farbtonhilfsbezeichnung": "A0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "164",
    "Bcolor": "176",
    "Y": 45,
    "L": 73.0035659902273,
    "a": 23.9916583155075,
    "b": 1.61065670896672,
    "C": 24.0456624729326,
    "h": 0.0670334446577,
    "CMY_C": 0.1263318,
    "CMY_M": 0.3586507,
    "CMY_Y": 0.3107566,
    "CMYK_C": 0,
    "CMYK_M": 0.2659121,
    "CMYK_Y": 0.2110925,
    "CMYK_K": 0.1263318
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00075",
    "Farbtonhilfsbezeichnung": "K2.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "147",
    "Bcolor": "115",
    "Y": 27,
    "L": 58.4722722251189,
    "a": -14.7482955505308,
    "b": 13.5877143500958,
    "C": 20.053383826816,
    "h": -0.74446322294679,
    "CMY_C": 0.5176903,
    "CMY_M": 0.4218103,
    "CMY_Y": 0.5474439,
    "CMYK_C": 0.165828,
    "CMYK_M": 0,
    "CMYK_Y": 0.2172878,
    "CMYK_K": 0.4218103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00076",
    "Farbtonhilfsbezeichnung": "F2.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "112",
    "Bcolor": "84",
    "Y": 18,
    "L": 48.485818353516,
    "a": 3.85687059052842,
    "b": 17.9896072331205,
    "C": 18.3984080603193,
    "h": 1.35959910610439,
    "CMY_C": 0.4811582,
    "CMY_M": 0.5604841,
    "CMY_Y": 0.6696829,
    "CMYK_C": 0,
    "CMYK_M": 0.1528904,
    "CMYK_Y": 0.3633568,
    "CMYK_K": 0.4811582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00077",
    "Farbtonhilfsbezeichnung": "R0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "146",
    "Bcolor": "158",
    "Y": 28,
    "L": 58.1667996973537,
    "a": -10.969952483448,
    "b": -11.5817474462533,
    "C": 15.9523268333464,
    "h": 0.81252006311016,
    "CMY_C": 0.589958,
    "CMY_M": 0.4259032,
    "CMY_Y": 0.3789911,
    "CMYK_C": 0.3397163,
    "CMYK_M": 0.07554183,
    "CMYK_Y": 0,
    "CMYK_K": 0.3789911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00078",
    "Farbtonhilfsbezeichnung": "F6.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "213",
    "Bcolor": "138",
    "Y": 69,
    "L": 87.1515274047852,
    "a": 4.7387261390686,
    "b": 41.5289115905762,
    "C": 41.798397064209,
    "h": 83.4903259277344,
    "CMY_C": 0.00887727737427,
    "CMY_M": 0.16421210765839,
    "CMY_Y": 0.45894140005112,
    "CMYK_C": 0,
    "CMYK_M": 0.15672613680363,
    "CMYK_Y": 0.45409524440765,
    "CMYK_K": 0.00887727737427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00079",
    "Farbtonhilfsbezeichnung": "N0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "185",
    "Bcolor": "181",
    "Y": 47,
    "L": 74.0735092163086,
    "a": -5.28023195266724,
    "b": -0.361183822155,
    "C": 5.2925705909729,
    "h": 183.913101196289,
    "CMY_C": 0.32837039232254,
    "CMY_M": 0.27364534139633,
    "CMY_Y": 0.28959381580353,
    "CMYK_C": 0.07534205168486,
    "CMYK_M": 0,
    "CMYK_Y": 0.02195687033236,
    "CMYK_K": 0.27364534139633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00080",
    "Farbtonhilfsbezeichnung": "E8.03.60",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "165",
    "Bcolor": "158",
    "Y": 39,
    "L": 67.9571609360454,
    "a": 1.28930636325303,
    "b": 3.54663339122654,
    "C": 3.77371425919979,
    "h": 1.22211958517479,
    "CMY_C": 0.3301428,
    "CMY_M": 0.3540725,
    "CMY_Y": 0.3802611,
    "CMYK_C": 0,
    "CMYK_M": 0.03572349,
    "CMYK_Y": 0.07481937,
    "CMYK_K": 0.3301428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00081",
    "Farbtonhilfsbezeichnung": "N0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "220",
    "Bcolor": "211",
    "Y": 68,
    "L": 85.1115918337917,
    "a": -12.9591075057006,
    "b": -0.10688343650477,
    "C": 12.9595482719617,
    "h": 0.00824755971529,
    "CMY_C": 0.2742251,
    "CMY_M": 0.1370456,
    "CMY_Y": 0.173702,
    "CMYK_C": 0.1589649,
    "CMYK_M": 0,
    "CMYK_Y": 0.04247782,
    "CMYK_K": 0.1370456
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00082",
    "Farbtonhilfsbezeichnung": "U0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "94",
    "Bcolor": "140",
    "Y": 11,
    "L": 38.9594116210938,
    "a": -0.06926617026329,
    "b": -30.4642944335938,
    "C": 30.4643726348877,
    "h": 269.869720458984,
    "CMY_C": 0.80464440584183,
    "CMY_M": 0.62998384237289,
    "CMY_Y": 0.45093458890915,
    "CMYK_C": 0.64420342445374,
    "CMYK_M": 0.32609823346138,
    "CMYK_Y": 0,
    "CMYK_K": 0.45093458890915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00083",
    "Farbtonhilfsbezeichnung": "L8.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "108",
    "Gcolor": "149",
    "Bcolor": "128",
    "Y": 26,
    "L": 58.119083404541,
    "a": -18.2825202941895,
    "b": 5.57324075698853,
    "C": 19.1131248474121,
    "h": 163.046676635742,
    "CMY_C": 0.57838302850723,
    "CMY_M": 0.41733437776566,
    "CMY_Y": 0.49665015935898,
    "CMYK_C": 0.27639979124069,
    "CMYK_M": 0,
    "CMYK_Y": 0.13612572848797,
    "CMYK_K": 0.41733437776566
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00084",
    "Farbtonhilfsbezeichnung": "E4.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "190",
    "Bcolor": "171",
    "Y": 54,
    "L": 78.1719538394366,
    "a": 5.08613002263675,
    "b": 11.3256698767358,
    "C": 12.4152936640245,
    "h": 1.14870786943984,
    "CMY_C": 0.1713436,
    "CMY_M": 0.2564362,
    "CMY_Y": 0.3283343,
    "CMYK_C": 0,
    "CMYK_M": 0.1026875,
    "CMYK_Y": 0.1894522,
    "CMYK_K": 0.1713436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00085",
    "Farbtonhilfsbezeichnung": "G0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "76",
    "Bcolor": "70",
    "Y": 8,
    "L": 32.2741643919112,
    "a": 0.54266235177127,
    "b": 3.18222031581535,
    "C": 3.22815869597793,
    "h": 1.40189161418229,
    "CMY_C": 0.6904057,
    "CMY_M": 0.7039139,
    "CMY_Y": 0.7241271,
    "CMYK_C": 0,
    "CMYK_M": 0.0436319,
    "CMYK_Y": 0.1089212,
    "CMYK_K": 0.6904057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00085",
    "Farbtonhilfsbezeichnung": "G0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "76",
    "Bcolor": "70",
    "Y": 8,
    "L": 32.2741643919112,
    "a": 0.54266235177127,
    "b": 3.18222031581535,
    "C": 3.22815869597793,
    "h": 1.40189161418229,
    "CMY_C": 0.6904057,
    "CMY_M": 0.7039139,
    "CMY_Y": 0.7241271,
    "CMYK_C": 0,
    "CMYK_M": 0.0436319,
    "CMYK_Y": 0.1089212,
    "CMYK_K": 0.6904057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00086",
    "Farbtonhilfsbezeichnung": "W0.10.40",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "111",
    "Bcolor": "130",
    "Y": 17,
    "L": 47.7736162582023,
    "a": 6.23164514295099,
    "b": -10.5687118197877,
    "C": 12.2691104289343,
    "h": -1.03803562666022,
    "CMY_C": 0.5464515,
    "CMY_M": 0.5657288,
    "CMY_Y": 0.4897053,
    "CMYK_C": 0.1112027,
    "CMYK_M": 0.1489796,
    "CMYK_Y": 0,
    "CMYK_K": 0.4897053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00087",
    "Farbtonhilfsbezeichnung": "W0.10.60",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "162",
    "Bcolor": "187",
    "Y": 39,
    "L": 67.9586125480104,
    "a": 7.72493172735961,
    "b": -12.4043548058048,
    "C": 14.6130964665488,
    "h": -1.01380966797573,
    "CMY_C": 0.3357974,
    "CMY_M": 0.364381,
    "CMY_Y": 0.268393,
    "CMYK_C": 0.09213194,
    "CMYK_M": 0.1312016,
    "CMYK_Y": 0,
    "CMYK_K": 0.268393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00088",
    "Farbtonhilfsbezeichnung": "B6.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "145",
    "Bcolor": "142",
    "Y": 37,
    "L": 67.2624125890743,
    "a": 26.833091755207,
    "b": 12.2168513465777,
    "C": 29.4833218950602,
    "h": 0.42724477615489,
    "CMY_C": 0.1508065,
    "CMY_M": 0.4301519,
    "CMY_Y": 0.4435973,
    "CMYK_C": 0,
    "CMYK_M": 0.3289538,
    "CMYK_Y": 0.3447869,
    "CMYK_K": 0.1508065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00089",
    "Farbtonhilfsbezeichnung": "S0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "70",
    "Bcolor": "75",
    "Y": 7,
    "L": 29.1365987872614,
    "a": -2.4928471844673,
    "b": -4.70522935104298,
    "C": 5.3247976798206,
    "h": 1.08359113334017,
    "CMY_C": 0.7625762,
    "CMY_M": 0.7247658,
    "CMY_Y": 0.705259,
    "CMYK_C": 0.1944662,
    "CMYK_M": 0.06618268,
    "CMYK_Y": 0,
    "CMYK_K": 0.705259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00090",
    "Farbtonhilfsbezeichnung": "F2.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "176",
    "Bcolor": "166",
    "Y": 45,
    "L": 72.239631652832,
    "a": 1.4132833480835,
    "b": 5.34428453445435,
    "C": 5.52799654006958,
    "h": 75.1873474121094,
    "CMY_C": 0.27840781211853,
    "CMY_M": 0.30962735414505,
    "CMY_Y": 0.34837287664413,
    "CMYK_C": 0,
    "CMYK_M": 0.04326479882002,
    "CMYK_Y": 0.09695928543806,
    "CMYK_K": 0.27840781211853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00091",
    "Farbtonhilfsbezeichnung": "W0.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "195",
    "Bcolor": "208",
    "Y": 57,
    "L": 79.608448675619,
    "a": 4.84229096182343,
    "b": -6.43609363433635,
    "C": 8.05425868897329,
    "h": -0.92578339748955,
    "CMY_C": 0.2112741,
    "CMY_M": 0.2354295,
    "CMY_Y": 0.1854547,
    "CMYK_C": 0.0316979,
    "CMYK_M": 0.06135301,
    "CMYK_Y": 0,
    "CMYK_K": 0.1854547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00092",
    "Farbtonhilfsbezeichnung": "F6.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "203",
    "Bcolor": "188",
    "Y": 62,
    "L": 82.0426202537039,
    "a": 0.86701877677997,
    "b": 7.97394469133981,
    "C": 8.02094230747456,
    "h": 1.46249033043427,
    "CMY_C": 0.1683223,
    "CMY_M": 0.2036264,
    "CMY_Y": 0.2637885,
    "CMYK_C": 0,
    "CMYK_M": 0.04244929,
    "CMYK_Y": 0.1147874,
    "CMYK_K": 0.1683223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00093",
    "Farbtonhilfsbezeichnung": "E4.20.60",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "161",
    "Bcolor": "132",
    "Y": 39,
    "L": 68.7039108276367,
    "a": 9.56356048583984,
    "b": 19.589412689209,
    "C": 21.7992382049561,
    "h": 63.9783477783203,
    "CMY_C": 0.2270393371582,
    "CMY_M": 0.36968767642975,
    "CMY_Y": 0.48367923498154,
    "CMYK_C": 0,
    "CMYK_M": 0.18454799056053,
    "CMYK_Y": 0.33202195167542,
    "CMYK_K": 0.2270393371582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00094",
    "Farbtonhilfsbezeichnung": "C4.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "91",
    "Bcolor": "78",
    "Y": 16,
    "L": 46.1890240774576,
    "a": 26.4727937821099,
    "b": 19.3223484077131,
    "C": 32.7744101185539,
    "h": 0.63050897497367,
    "CMY_C": 0.3772836,
    "CMY_M": 0.6424733,
    "CMY_Y": 0.6951814,
    "CMYK_C": 0,
    "CMYK_M": 0.4258596,
    "CMYK_Y": 0.5105018,
    "CMYK_K": 0.3772836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00096",
    "Farbtonhilfsbezeichnung": "E4.30.75",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "188",
    "Bcolor": "131",
    "Y": 59,
    "L": 80.7070423600962,
    "a": 16.1043735496507,
    "b": 37.0376772479692,
    "C": 40.387379010669,
    "h": 1.16064547068447,
    "CMY_C": 0.01867234,
    "CMY_M": 0.2629539,
    "CMY_Y": 0.4879126,
    "CMYK_C": 0,
    "CMYK_M": 0.2489297,
    "CMYK_Y": 0.4781688,
    "CMYK_K": 0.01867234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00097",
    "Farbtonhilfsbezeichnung": "U0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "113",
    "Bcolor": "159",
    "Y": 17,
    "L": 46.6720655460784,
    "a": 0.45214585209812,
    "b": -29.6420114933801,
    "C": 29.6454597070993,
    "h": -1.55554396141281,
    "CMY_C": 0.7067417,
    "CMY_M": 0.5573378,
    "CMY_Y": 0.3767613,
    "CMYK_C": 0.5294607,
    "CMYK_M": 0.289739,
    "CMYK_Y": 0,
    "CMYK_K": 0.3767613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00098",
    "Farbtonhilfsbezeichnung": "B2.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "152",
    "Gcolor": "98",
    "Bcolor": "102",
    "Y": 17,
    "L": 47.5852806491583,
    "a": 22.4719884225931,
    "b": 6.66566106398725,
    "C": 23.4397376496648,
    "h": 0.28835381184014,
    "CMY_C": 0.4032172,
    "CMY_M": 0.6138841,
    "CMY_Y": 0.6009859,
    "CMYK_C": 0,
    "CMYK_M": 0.3530044,
    "CMYK_Y": 0.3313914,
    "CMYK_K": 0.4032172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00100",
    "Farbtonhilfsbezeichnung": "G0.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "232",
    "Bcolor": "187",
    "Y": 81,
    "L": 92.5151748657227,
    "a": -0.24146640300751,
    "b": 23.4317989349365,
    "C": 23.4330425262451,
    "h": 90.5904159545898,
    "CMY_C": 0.01790350675583,
    "CMY_M": 0.08909845352173,
    "CMY_Y": 0.26617187261581,
    "CMYK_C": 0,
    "CMYK_M": 0.07249282300472,
    "CMYK_Y": 0.25279426574707,
    "CMYK_K": 0.01790350675583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00102",
    "Farbtonhilfsbezeichnung": "S0.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "122",
    "Bcolor": "146",
    "Y": 19,
    "L": 48.5725349118149,
    "a": -11.3097080468903,
    "b": -19.2317956910509,
    "C": 22.3107924917117,
    "h": 1.03919252224148,
    "CMY_C": 0.7424566,
    "CMY_M": 0.519952,
    "CMY_Y": 0.4265745,
    "CMYK_C": 0.5508685,
    "CMYK_M": 0.1628415,
    "CMYK_Y": 0,
    "CMYK_K": 0.4265745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00105",
    "Farbtonhilfsbezeichnung": "J0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "171",
    "Bcolor": "111",
    "Y": 37,
    "L": 67.3318786621094,
    "a": -16.6706714630127,
    "b": 28.4158039093018,
    "C": 32.9449424743652,
    "h": 120.398834228516,
    "CMY_C": 0.40269386768341,
    "CMY_M": 0.32838016748428,
    "CMY_Y": 0.56538152694702,
    "CMYK_C": 0.11064846068621,
    "CMYK_M": 0,
    "CMYK_Y": 0.35288023948669,
    "CMYK_K": 0.32838016748428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00106",
    "Farbtonhilfsbezeichnung": "D6.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "175",
    "Bcolor": "147",
    "Y": 51,
    "L": 75.9149188109565,
    "a": 16.5407755334992,
    "b": 21.6405265500941,
    "C": 27.2380183679895,
    "h": 0.91817899182576,
    "CMY_C": 0.09770448,
    "CMY_M": 0.31227,
    "CMY_Y": 0.4238269,
    "CMYK_C": 0,
    "CMYK_M": 0.2377996,
    "CMYK_Y": 0.3614364,
    "CMYK_K": 0.09770448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00107",
    "Farbtonhilfsbezeichnung": "H2.10.20",
    "Farbtonklasse": "02",
    "Rcolor": "68",
    "Gcolor": "69",
    "Bcolor": "61",
    "Y": 7,
    "L": 29.0078925271332,
    "a": -2.03312312958995,
    "b": 4.16308504787205,
    "C": 4.63301918578905,
    "h": -1.11649645667657,
    "CMY_C": 0.7338024,
    "CMY_M": 0.7288026,
    "CMY_Y": 0.7593271,
    "CMYK_C": 0.01843632,
    "CMYK_M": 0,
    "CMYK_Y": 0.1125545,
    "CMYK_K": 0.7288026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00108",
    "Farbtonhilfsbezeichnung": "U0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "89",
    "Bcolor": "115",
    "Y": 11,
    "L": 37.1214326587801,
    "a": 0.03371005953239,
    "b": -18.0345543851529,
    "C": 18.034585890426,
    "h": -1.56892713615381,
    "CMY_C": 0.7295185,
    "CMY_M": 0.6521357,
    "CMY_Y": 0.5480224,
    "CMYK_C": 0.4015599,
    "CMYK_M": 0.2303505,
    "CMYK_Y": 0,
    "CMYK_K": 0.5480224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00109",
    "Farbtonhilfsbezeichnung": "S0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "117",
    "Bcolor": "125",
    "Y": 18,
    "L": 48.5779134059575,
    "a": -3.1706724217393,
    "b": -6.13575529290726,
    "C": 6.90656619604979,
    "h": 1.09383600126366,
    "CMY_C": 0.5920026,
    "CMY_M": 0.5392219,
    "CMY_Y": 0.5115964,
    "CMYK_C": 0.1646305,
    "CMYK_M": 0.05656282,
    "CMYK_Y": 0,
    "CMYK_K": 0.5115964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00111",
    "Farbtonhilfsbezeichnung": "H2.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "177",
    "Bcolor": "165",
    "Y": 45,
    "L": 72.0740641554648,
    "a": -1.50753550453292,
    "b": 5.5673955633561,
    "C": 5.76789013906338,
    "h": -1.30635828053411,
    "CMY_C": 0.3009436,
    "CMY_M": 0.3048509,
    "CMY_Y": 0.3520894,
    "CMYK_C": 0,
    "CMYK_M": 0.005589424,
    "CMYK_Y": 0.0731641,
    "CMYK_K": 0.3009436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00112",
    "Farbtonhilfsbezeichnung": "E0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "189",
    "Bcolor": "172",
    "Y": 55,
    "L": 78.5022888183594,
    "a": 7.62269496917725,
    "b": 11.6960563659668,
    "C": 13.9607744216919,
    "h": 56.9064254760742,
    "CMY_C": 0.14907419681549,
    "CMY_M": 0.25914531946182,
    "CMY_Y": 0.32712119817734,
    "CMYK_C": 0,
    "CMYK_M": 0.12935455143452,
    "CMYK_Y": 0.20923915505409,
    "CMYK_K": 0.14907419681549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00113",
    "Farbtonhilfsbezeichnung": "N0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "114",
    "Bcolor": "109",
    "Y": 16,
    "L": 46.2080902221744,
    "a": -8.48649951278557,
    "b": -0.23848974448958,
    "C": 8.48984990083667,
    "h": 0.02809485730912,
    "CMY_C": 0.6342372,
    "CMY_M": 0.5538211,
    "CMY_Y": 0.5737296,
    "CMYK_C": 0.180233,
    "CMYK_M": 0,
    "CMYK_Y": 0.0446199,
    "CMYK_K": 0.5538211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00114",
    "Farbtonhilfsbezeichnung": "F6.15.45",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "128",
    "Bcolor": "105",
    "Y": 23,
    "L": 54.3701224084304,
    "a": 1.5075579824288,
    "b": 14.2493734282693,
    "C": 14.3288999636627,
    "h": 1.4653902443315,
    "CMY_C": 0.4427523,
    "CMY_M": 0.4963575,
    "CMY_Y": 0.5893065,
    "CMYK_C": 0,
    "CMYK_M": 0.09619639,
    "CMYK_Y": 0.2629965,
    "CMYK_K": 0.4427523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00115",
    "Farbtonhilfsbezeichnung": "F0.25.75",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "200",
    "Bcolor": "148",
    "Y": 64,
    "L": 82.7364602773658,
    "a": 6.88522266342118,
    "b": 30.6333414811525,
    "C": 31.3975779547688,
    "h": 1.34970806842796,
    "CMY_C": 0.06510635,
    "CMY_M": 0.2157961,
    "CMY_Y": 0.4214401,
    "CMYK_C": 0,
    "CMYK_M": 0.1611838,
    "CMYK_Y": 0.381149,
    "CMYK_K": 0.06510635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00116",
    "Farbtonhilfsbezeichnung": "F6.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "224",
    "Bcolor": "202",
    "Y": 77,
    "L": 89.5346298217773,
    "a": 1.45467293262482,
    "b": 11.1000709533691,
    "C": 11.1949834823608,
    "h": 82.5338897705078,
    "CMY_C": 0.07159680128098,
    "CMY_M": 0.1234068274498,
    "CMY_Y": 0.20603269338608,
    "CMYK_C": 0,
    "CMYK_M": 0.0558055229485,
    "CMYK_Y": 0.1448033452034,
    "CMYK_K": 0.07159680128098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00117",
    "Farbtonhilfsbezeichnung": "F2.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "122",
    "Bcolor": "87",
    "Y": 21,
    "L": 52.6942960371836,
    "a": 5.16314271056267,
    "b": 22.4620612381169,
    "C": 23.0478250104983,
    "h": 1.34486034595785,
    "CMY_C": 0.4218222,
    "CMY_M": 0.5228195,
    "CMY_Y": 0.66018,
    "CMYK_C": 0,
    "CMYK_M": 0.1746821,
    "CMYK_Y": 0.4122568,
    "CMYK_K": 0.4218222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00118",
    "Farbtonhilfsbezeichnung": "C0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "110",
    "Bcolor": "106",
    "Y": 18,
    "L": 49.1476681175661,
    "a": 10.5885245810332,
    "b": 5.9517460833703,
    "C": 12.1466099897897,
    "h": 0.51208098760952,
    "CMY_C": 0.4576288,
    "CMY_M": 0.5670751,
    "CMY_Y": 0.5831892,
    "CMYK_C": 0,
    "CMYK_M": 0.2017921,
    "CMYK_Y": 0.2315027,
    "CMYK_K": 0.4576288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00119",
    "Farbtonhilfsbezeichnung": "K2.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "73",
    "Bcolor": "65",
    "Y": 7,
    "L": 30.1985545386757,
    "a": -4.33125824254169,
    "b": 3.5848497345458,
    "C": 5.62236121063548,
    "h": -0.69138627831851,
    "CMY_C": 0.7395692,
    "CMY_M": 0.7137472,
    "CMY_Y": 0.7456399,
    "CMYK_C": 0.09020703,
    "CMYK_M": 0,
    "CMYK_Y": 0.1114146,
    "CMYK_K": 0.7137472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00120",
    "Farbtonhilfsbezeichnung": "F6.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "225",
    "Bcolor": "186",
    "Y": 79,
    "L": 90.6341469955153,
    "a": 2.72347683875901,
    "b": 21.6213833079649,
    "C": 21.7922358247427,
    "h": 1.44549405551889,
    "CMY_C": 0.02244407,
    "CMY_M": 0.1168536,
    "CMY_Y": 0.2721841,
    "CMYK_C": 0,
    "CMYK_M": 0.09657706,
    "CMYK_Y": 0.2554739,
    "CMYK_K": 0.02244407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00121",
    "Farbtonhilfsbezeichnung": "E4.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "147",
    "Bcolor": "123",
    "Y": 33,
    "L": 62.8613539086905,
    "a": 6.67485653417699,
    "b": 16.2432503721513,
    "C": 17.5612326561731,
    "h": 1.18090226091517,
    "CMY_C": 0.3159553,
    "CMY_M": 0.4224848,
    "CMY_Y": 0.5190887,
    "CMYK_C": 0,
    "CMYK_M": 0.1557347,
    "CMYK_Y": 0.2969593,
    "CMYK_K": 0.3159553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00122",
    "Farbtonhilfsbezeichnung": "E8.25.65",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "170",
    "Bcolor": "124",
    "Y": 44,
    "L": 71.8691250678069,
    "a": 8.30423548806725,
    "b": 28.3579046814516,
    "C": 29.5487915990413,
    "h": 1.28592424579201,
    "CMY_C": 0.1834987,
    "CMY_M": 0.3351689,
    "CMY_Y": 0.5148423,
    "CMYK_C": 0,
    "CMYK_M": 0.1857562,
    "CMYK_Y": 0.405809,
    "CMYK_K": 0.1834987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00123",
    "Farbtonhilfsbezeichnung": "F2.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "192",
    "Bcolor": "170",
    "Y": 54,
    "L": 78.3626480102539,
    "a": 2.47106957435608,
    "b": 12.1709403991699,
    "C": 12.4192581176758,
    "h": 78.5232238769531,
    "CMY_C": 0.18551325798035,
    "CMY_M": 0.24830424785614,
    "CMY_Y": 0.33282846212387,
    "CMYK_C": 0,
    "CMYK_M": 0.07709270715714,
    "CMYK_Y": 0.18086875975132,
    "CMYK_K": 0.18551325798035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00124",
    "Farbtonhilfsbezeichnung": "F2.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "202",
    "Bcolor": "189",
    "Y": 60,
    "L": 81.6858654290732,
    "a": 1.24749297744853,
    "b": 6.84206431084755,
    "C": 6.95486036973836,
    "h": 1.39045034676695,
    "CMY_C": 0.1727471,
    "CMY_M": 0.2081123,
    "CMY_Y": 0.2593355,
    "CMYK_C": 0,
    "CMYK_M": 0.04275013,
    "CMYK_Y": 0.1046699,
    "CMYK_K": 0.1727471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00125",
    "Farbtonhilfsbezeichnung": "X0.10.60",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "159",
    "Bcolor": "183",
    "Y": 38,
    "L": 67.4857278562437,
    "a": 11.0410652219722,
    "b": -11.0600428442991,
    "C": 15.62784914675,
    "h": -0.78625683607601,
    "CMY_C": 0.3113769,
    "CMY_M": 0.3778454,
    "CMY_Y": 0.282395,
    "CMYK_C": 0.04038703,
    "CMYK_M": 0.1330125,
    "CMYK_Y": 0,
    "CMYK_K": 0.282395
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00126",
    "Farbtonhilfsbezeichnung": "R0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "198",
    "Bcolor": "214",
    "Y": 52,
    "L": 76.5670666559185,
    "a": -14.2748126334236,
    "b": -14.6096484817944,
    "C": 20.4257705969921,
    "h": 0.79698989259072,
    "CMY_C": 0.4484437,
    "CMY_M": 0.2238793,
    "CMY_Y": 0.1621663,
    "CMYK_C": 0.3416876,
    "CMYK_M": 0.07365789,
    "CMYK_Y": 0,
    "CMYK_K": 0.1621663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00128",
    "Farbtonhilfsbezeichnung": "X0.15.50",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "133",
    "Bcolor": "167",
    "Y": 28,
    "L": 58.596479071583,
    "a": 15.0080594225818,
    "b": -15.4542382506061,
    "C": 21.5424076541654,
    "h": -0.80004403582419,
    "CMY_C": 0.3918624,
    "CMY_M": 0.4776253,
    "CMY_Y": 0.3455808,
    "CMYK_C": 0.07072153,
    "CMYK_M": 0.2017735,
    "CMYK_Y": 0,
    "CMYK_K": 0.3455808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00130",
    "Farbtonhilfsbezeichnung": "E4.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "183",
    "Bcolor": "150",
    "Y": 52,
    "L": 77.055549621582,
    "a": 9.78686141967773,
    "b": 21.635913848877,
    "C": 23.7464828491211,
    "h": 65.6606979370117,
    "CMY_C": 0.1282479763031,
    "CMY_M": 0.28240609169006,
    "CMY_Y": 0.41338509321213,
    "CMYK_C": 0,
    "CMYK_M": 0.17683711647987,
    "CMYK_Y": 0.32708510756493,
    "CMYK_K": 0.1282479763031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00131",
    "Farbtonhilfsbezeichnung": "D2.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "215",
    "Bcolor": "203",
    "Y": 73,
    "L": 87.6285554235531,
    "a": 6.5765103604965,
    "b": 7.93806437146345,
    "C": 10.3084118314712,
    "h": 0.87893044364166,
    "CMY_C": 0.06430728,
    "CMY_M": 0.156224,
    "CMY_Y": 0.2025749,
    "CMYK_C": 0,
    "CMYK_M": 0.09823385,
    "CMYK_Y": 0.1477704,
    "CMYK_K": 0.06430728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00135",
    "Farbtonhilfsbezeichnung": "ON.00.65",
    "Farbtonklasse": "01",
    "Y": 45,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00136",
    "Farbtonhilfsbezeichnung": "R0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "151",
    "Bcolor": "176",
    "Y": 26,
    "L": 57.3576038420262,
    "a": -22.7422634081503,
    "b": -23.3712991754431,
    "C": 32.6102463970109,
    "h": 0.7990383317121,
    "CMY_C": 0.9188747,
    "CMY_M": 0.4096271,
    "CMY_Y": 0.3083849,
    "CMYK_C": 0.8827017,
    "CMYK_M": 0.1463852,
    "CMYK_Y": 0,
    "CMYK_K": 0.3083849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00137",
    "Farbtonhilfsbezeichnung": "G4.04.88",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "239",
    "Bcolor": "224",
    "Y": 87,
    "L": 94.5792007446289,
    "a": -0.41887277364731,
    "b": 7.04484224319458,
    "C": 7.05728387832642,
    "h": 93.4026947021484,
    "CMY_C": 0.04114419221878,
    "CMY_M": 0.06152272224426,
    "CMY_Y": 0.12100660800934,
    "CMYK_C": 0,
    "CMYK_M": 0.02125296555459,
    "CMYK_Y": 0.08328928798437,
    "CMYK_K": 0.04114419221878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00138",
    "Farbtonhilfsbezeichnung": "ON.00.70",
    "Farbtonklasse": "01",
    "Y": 53,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00140",
    "Farbtonhilfsbezeichnung": "E0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "154",
    "Bcolor": "126",
    "Y": 36,
    "L": 66.6295125725031,
    "a": 11.9674774372873,
    "b": 20.0741304109945,
    "C": 23.37073443368,
    "h": 1.03320205810967,
    "CMY_C": 0.2338613,
    "CMY_M": 0.3974689,
    "CMY_Y": 0.5073881,
    "CMYK_C": 0,
    "CMYK_M": 0.2135483,
    "CMYK_Y": 0.3570199,
    "CMYK_K": 0.2338613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00141",
    "Farbtonhilfsbezeichnung": "F2.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "225",
    "Bcolor": "209",
    "Y": 78,
    "L": 90.1762619018555,
    "a": 1.89585995674133,
    "b": 8.45414638519287,
    "C": 8.66411399841309,
    "h": 77.3604125976563,
    "CMY_C": 0.06874668598175,
    "CMY_M": 0.11665868759155,
    "CMY_Y": 0.17941719293594,
    "CMYK_C": 0,
    "CMYK_M": 0.05144894495606,
    "CMYK_Y": 0.11884038895369,
    "CMYK_K": 0.06874668598175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00143",
    "Farbtonhilfsbezeichnung": "Q0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "181",
    "Bcolor": "183",
    "Y": 45,
    "L": 72.4980906361289,
    "a": -5.36425996484807,
    "b": -3.75904506948466,
    "C": 6.55024463702607,
    "h": 0.61123413113764,
    "CMY_C": 0.3583149,
    "CMY_M": 0.2893918,
    "CMY_Y": 0.2822556,
    "CMYK_C": 0.1059699,
    "CMYK_M": 0.009942531,
    "CMYK_Y": 0,
    "CMYK_K": 0.2822556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00144",
    "Farbtonhilfsbezeichnung": "Y0.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "98",
    "Bcolor": "131",
    "Y": 17,
    "L": 46.3531944626457,
    "a": 21.2635759097298,
    "b": -13.0499012806123,
    "C": 24.9487391245043,
    "h": -0.55044736862576,
    "CMY_C": 0.4691503,
    "CMY_M": 0.6162259,
    "CMY_Y": 0.4862091,
    "CMYK_C": 0,
    "CMYK_M": 0.2770569,
    "CMYK_Y": 0.03213478,
    "CMYK_K": 0.4691503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00145",
    "Farbtonhilfsbezeichnung": "U0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 7,
    "L": 32.7403144836426,
    "a": -0.10262122750282,
    "b": -5.89333152770996,
    "C": 5.89422512054443,
    "h": 269.002410888672,
    "CMY_C": 0.71740508079529,
    "CMY_M": 0.69616460800171,
    "CMY_Y": 0.66481125354767,
    "CMYK_C": 0.15690809488297,
    "CMYK_M": 0.09353940188885,
    "CMYK_Y": 0,
    "CMYK_K": 0.66481125354767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00146",
    "Farbtonhilfsbezeichnung": "R0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "209",
    "Bcolor": "211",
    "Y": 64,
    "L": 82.6282360222288,
    "a": -4.68210820884901,
    "b": -3.8831020870588,
    "C": 6.08281341961856,
    "h": 0.69238229533921,
    "CMY_C": 0.24521,
    "CMY_M": 0.1812859,
    "CMY_Y": 0.1722093,
    "CMYK_C": 0.08818741,
    "CMYK_M": 0.01096484,
    "CMYK_Y": 0,
    "CMYK_K": 0.1722093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00148",
    "Farbtonhilfsbezeichnung": "C0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "199",
    "Bcolor": "195",
    "Y": 59,
    "L": 81.7333374023438,
    "a": 6.98692846298218,
    "b": 3.63492822647095,
    "C": 7.87590456008911,
    "h": 27.4855670928955,
    "CMY_C": 0.13953763246536,
    "CMY_M": 0.22052836418152,
    "CMY_Y": 0.23477536439896,
    "CMYK_C": 0,
    "CMYK_M": 0.09412466734648,
    "CMYK_Y": 0.11068204045296,
    "CMYK_K": 0.13953763246536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00149",
    "Farbtonhilfsbezeichnung": "ON.00.50",
    "Farbtonklasse": "01",
    "Rcolor": "139",
    "Gcolor": "140",
    "Bcolor": "140",
    "Y": 25,
    "L": 58.3235282897949,
    "a": -0.19914948940277,
    "b": -0.49150538444519,
    "C": 0.53031885623932,
    "h": 247.943054199219,
    "CMY_C": 0.45318561792374,
    "CMY_M": 0.44924253225327,
    "CMY_Y": 0.45123785734177,
    "CMYK_C": 0.00715938676149,
    "CMYK_M": 0,
    "CMYK_Y": 0.00362287438475,
    "CMYK_K": 0.44924253225327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00151",
    "Farbtonhilfsbezeichnung": "E8.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "221",
    "Bcolor": "188",
    "Y": 77,
    "L": 89.549072265625,
    "a": 5.5663013458252,
    "b": 18.7918872833252,
    "C": 19.5989475250244,
    "h": 73.5003051757813,
    "CMY_C": 0.02143996953964,
    "CMY_M": 0.1351951956749,
    "CMY_Y": 0.26220065355301,
    "CMYK_C": 0,
    "CMYK_M": 0.1162475720048,
    "CMYK_Y": 0.24603568017483,
    "CMYK_K": 0.02143996953964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00152",
    "Farbtonhilfsbezeichnung": "CN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "237",
    "Bcolor": "231",
    "Y": 87,
    "L": 94.1979217529297,
    "a": 1.46919214725494,
    "b": 3.02741456031799,
    "C": 3.36508011817932,
    "h": 64.1128921508789,
    "CMY_C": 0.04362338781357,
    "CMY_M": 0.06923794746399,
    "CMY_Y": 0.09495139122009,
    "CMYK_C": 0,
    "CMYK_M": 0.02678292058408,
    "CMYK_Y": 0.0536692366004,
    "CMYK_K": 0.04362338781357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00153",
    "Farbtonhilfsbezeichnung": "E8.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "138",
    "Bcolor": "112",
    "Y": 28,
    "L": 59.0190887451172,
    "a": 5.94961977005005,
    "b": 16.5777626037598,
    "C": 17.6130695343018,
    "h": 70.2573623657227,
    "CMY_C": 0.36091750860214,
    "CMY_M": 0.46003538370132,
    "CMY_Y": 0.55929285287857,
    "CMYK_C": 0,
    "CMYK_M": 0.15509402751923,
    "CMYK_Y": 0.31040647625923,
    "CMYK_K": 0.36091750860214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00154",
    "Farbtonhilfsbezeichnung": "H2.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "167",
    "Bcolor": "143",
    "Y": 39,
    "L": 67.9612880503582,
    "a": -4.09143216654012,
    "b": 11.7215519162805,
    "C": 12.4150955090752,
    "h": -1.23496622224437,
    "CMY_C": 0.3457333,
    "CMY_M": 0.3441143,
    "CMY_Y": 0.4381316,
    "CMYK_C": 0.00246854,
    "CMYK_M": 0,
    "CMYK_Y": 0.143344,
    "CMYK_K": 0.3441143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00156",
    "Farbtonhilfsbezeichnung": "FN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "232",
    "Bcolor": "222",
    "Y": 83,
    "L": 92.1632080078125,
    "a": 0.85812360048294,
    "b": 4.39977836608887,
    "C": 4.4826807975769,
    "h": 78.9636993408203,
    "CMY_C": 0.06683003902435,
    "CMY_M": 0.09093105792999,
    "CMY_Y": 0.12774777412415,
    "CMYK_C": 0,
    "CMYK_M": 0.02582704089582,
    "CMYK_Y": 0.0652804300189,
    "CMYK_K": 0.06683003902435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00157",
    "Farbtonhilfsbezeichnung": "G0.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "112",
    "Bcolor": "57",
    "Y": 17,
    "L": 48.0015197418675,
    "a": 0.09608694270535,
    "b": 32.5614812807775,
    "C": 32.5616230538188,
    "h": 1.56784539643124,
    "CMY_C": 0.4863305,
    "CMY_M": 0.5592956,
    "CMY_Y": 0.7752601,
    "CMYK_C": 0,
    "CMYK_M": 0.1420467,
    "CMYK_Y": 0.5624815,
    "CMYK_K": 0.4863305
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00158",
    "Farbtonhilfsbezeichnung": "F2.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "202",
    "Bcolor": "167",
    "Y": 63,
    "L": 82.5154207384669,
    "a": 4.1412894331993,
    "b": 19.7736026296605,
    "C": 20.2026146606137,
    "h": 1.36434508931764,
    "CMY_C": 0.1088999,
    "CMY_M": 0.2091448,
    "CMY_Y": 0.3441968,
    "CMYK_C": 0,
    "CMYK_M": 0.1124957,
    "CMYK_Y": 0.2640522,
    "CMYK_K": 0.1088999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00159",
    "Farbtonhilfsbezeichnung": "F6.25.85",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "220",
    "Bcolor": "159",
    "Y": 76,
    "L": 89.0842196414405,
    "a": 2.81988344685097,
    "b": 33.2569852418021,
    "C": 33.3763210978572,
    "h": 1.48620794300115,
    "CMY_C": 0.0142975,
    "CMY_M": 0.1367216,
    "CMY_Y": 0.3760459,
    "CMYK_C": 0,
    "CMYK_M": 0.1241999,
    "CMYK_Y": 0.3669955,
    "CMYK_K": 0.0142975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00160",
    "Farbtonhilfsbezeichnung": "U0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "165",
    "Bcolor": "181",
    "Y": 39,
    "L": 67.58719284867,
    "a": 0.14341355857788,
    "b": -9.91142143408499,
    "C": 9.91245894280644,
    "h": -1.55632781164874,
    "CMY_C": 0.3891236,
    "CMY_M": 0.3515657,
    "CMY_Y": 0.2905721,
    "CMYK_C": 0.138917,
    "CMYK_M": 0.08597586,
    "CMYK_Y": 0,
    "CMYK_K": 0.2905721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00161",
    "Farbtonhilfsbezeichnung": "F6.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "232",
    "Bcolor": "206",
    "Y": 84,
    "L": 92.4898293618391,
    "a": 1.4392637701312,
    "b": 13.4300186052547,
    "C": 13.5069197057471,
    "h": 1.46403612530649,
    "CMY_C": 0.03179844,
    "CMY_M": 0.09109937,
    "CMY_Y": 0.1912722,
    "CMYK_C": 0,
    "CMYK_M": 0.06124854,
    "CMYK_Y": 0.1647113,
    "CMYK_K": 0.03179844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00162",
    "Farbtonhilfsbezeichnung": "C0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 16,
    "L": 46.0117642599348,
    "a": 50.5657462973916,
    "b": 28.0855417673291,
    "C": 57.8419601584919,
    "h": 0.5069996737274,
    "CMY_C": 0.2505008,
    "CMY_M": 0.7441719,
    "CMY_Y": 0.7475669,
    "CMYK_C": 0,
    "CMYK_M": 0.658668,
    "CMYK_Y": 0.6631978,
    "CMYK_K": 0.2505008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00163",
    "Farbtonhilfsbezeichnung": "F2.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "206",
    "Bcolor": "140",
    "Y": 68,
    "L": 85.2888139626342,
    "a": 7.19324613481798,
    "b": 38.2337956872876,
    "C": 38.9045745718075,
    "h": 1.38483170472781,
    "CMY_C": 0.01999271,
    "CMY_M": 0.1902102,
    "CMY_Y": 0.4522653,
    "CMYK_C": 0,
    "CMYK_M": 0.1736901,
    "CMYK_Y": 0.4410912,
    "CMYK_K": 0.01999271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00165",
    "Farbtonhilfsbezeichnung": "G0.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "135",
    "Bcolor": "102",
    "Y": 25,
    "L": 56.8547482284371,
    "a": 0.08240563191608,
    "b": 19.3250724517341,
    "C": 19.325248147254,
    "h": 1.56653217033908,
    "CMY_C": 0.4156041,
    "CMY_M": 0.4692523,
    "CMY_Y": 0.6001204,
    "CMYK_C": 0,
    "CMYK_M": 0.09180117,
    "CMYK_Y": 0.3157385,
    "CMYK_K": 0.4156041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00166",
    "Farbtonhilfsbezeichnung": "P0.15.45",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "132",
    "Bcolor": "129",
    "Y": 22,
    "L": 52.6136493930147,
    "a": -11.77236591909,
    "b": -2.76779537161289,
    "C": 12.0933572903505,
    "h": 0.23091575188664,
    "CMY_C": 0.6098245,
    "CMY_M": 0.4833628,
    "CMY_Y": 0.4946353,
    "CMYK_C": 0.2447786,
    "CMYK_M": 0,
    "CMYK_Y": 0.02181904,
    "CMYK_K": 0.4833628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00167",
    "Farbtonhilfsbezeichnung": "U0.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 80,
    "L": 90.3168666662677,
    "a": -0.35496590058176,
    "b": -2.17544369773268,
    "C": 2.20421325478745,
    "h": 1.40905228721536,
    "CMY_C": 0.1193235,
    "CMY_M": 0.1067952,
    "CMY_Y": 0.09961011,
    "CMYK_C": 0.02189427,
    "CMYK_M": 0.007979929,
    "CMYK_Y": 0,
    "CMYK_K": 0.09961011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00169",
    "Farbtonhilfsbezeichnung": "G0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "193",
    "Bcolor": "168",
    "Y": 54,
    "L": 78.1065012322301,
    "a": -0.40136812965796,
    "b": 13.15481124624,
    "C": 13.160932919049,
    "h": -1.54029466141429,
    "CMY_C": 0.2063202,
    "CMY_M": 0.2446321,
    "CMY_Y": 0.3430575,
    "CMYK_C": 0,
    "CMYK_M": 0.04827126,
    "CMYK_Y": 0.1722826,
    "CMYK_K": 0.2063202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00170",
    "Farbtonhilfsbezeichnung": "G0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "138",
    "Bcolor": "90",
    "Y": 26,
    "L": 57.8457717895508,
    "a": -0.68295353651047,
    "b": 27.3083209991455,
    "C": 27.3168601989746,
    "h": 91.4326171875,
    "CMY_C": 0.39527803659439,
    "CMY_M": 0.45893979072571,
    "CMY_Y": 0.64624214172363,
    "CMYK_C": 0,
    "CMYK_M": 0.10527442395687,
    "CMYK_Y": 0.41500741243362,
    "CMYK_K": 0.39527803659439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00171",
    "Farbtonhilfsbezeichnung": "D6.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "93",
    "Bcolor": "57",
    "Y": 16,
    "L": 46.2642643429539,
    "a": 23.9517857658005,
    "b": 31.421793970091,
    "C": 39.5097099162934,
    "h": 0.91949067168631,
    "CMY_C": 0.3761939,
    "CMY_M": 0.6361958,
    "CMY_Y": 0.7760281,
    "CMYK_C": 0,
    "CMYK_M": 0.4167992,
    "CMYK_Y": 0.6409591,
    "CMYK_K": 0.3761939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00172",
    "Farbtonhilfsbezeichnung": "F0.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "182",
    "Bcolor": "121",
    "Y": 54,
    "L": 76.9836929327138,
    "a": 9.59482228428432,
    "b": 37.0402311096803,
    "C": 38.2627669585659,
    "h": 1.31732969478345,
    "CMY_C": 0.1028387,
    "CMY_M": 0.2857499,
    "CMY_Y": 0.5271823,
    "CMYK_C": 0,
    "CMYK_M": 0.2038777,
    "CMYK_Y": 0.4729848,
    "CMYK_K": 0.1028387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00173",
    "Farbtonhilfsbezeichnung": "C8.45.55",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "117",
    "Bcolor": "86",
    "Y": 32,
    "L": 62.575551635519,
    "a": 43.2599266697958,
    "b": 37.8185009281985,
    "C": 57.4600754257446,
    "h": 0.71838554107447,
    "CMY_C": 0.07905101,
    "CMY_M": 0.5402886,
    "CMY_Y": 0.6643002,
    "CMYK_C": 0,
    "CMYK_M": 0.5008286,
    "CMYK_Y": 0.6354849,
    "CMYK_K": 0.07905101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00174",
    "Farbtonhilfsbezeichnung": "D6.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "135",
    "Bcolor": "72",
    "Y": 37,
    "L": 66.6323031809681,
    "a": 35.4023853845142,
    "b": 49.6974415495973,
    "C": 61.0177399408509,
    "h": 0.95182426000333,
    "CMY_C": 0.06104371,
    "CMY_M": 0.4717047,
    "CMY_Y": 0.7175959,
    "CMYK_C": 0,
    "CMYK_M": 0.437359,
    "CMYK_Y": 0.6992362,
    "CMYK_K": 0.06104371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00175",
    "Farbtonhilfsbezeichnung": "E4.50.70",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "165",
    "Bcolor": "80",
    "Y": 49,
    "L": 74.7612055184397,
    "a": 24.9944438654027,
    "b": 55.2354486996953,
    "C": 60.6273619514938,
    "h": 1.14585928381067,
    "CMY_C": 0.01491137,
    "CMY_M": 0.3544481,
    "CMY_Y": 0.6868844,
    "CMYK_C": 0,
    "CMYK_M": 0.3446763,
    "CMYK_Y": 0.6821448,
    "CMYK_K": 0.01491137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00176",
    "Farbtonhilfsbezeichnung": "F2.55.75",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "187",
    "Bcolor": "62",
    "Y": 58,
    "L": 80.544075012207,
    "a": 14.4418773651123,
    "b": 68.9558868408203,
    "C": 70.4519882202148,
    "h": 78.171142578125,
    "CMY_C": 0,
    "CMY_M": 0.26470679044724,
    "CMY_Y": 0.75854289531708,
    "CMYK_C": 0,
    "CMYK_M": 0.26470679044724,
    "CMYK_Y": 0.75854289531708,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00177",
    "Farbtonhilfsbezeichnung": "H2.45.75",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "207",
    "Bcolor": "95",
    "Y": 59,
    "L": 80.3666719212914,
    "a": -18.0276718979319,
    "b": 53.072606715193,
    "C": 56.0508567071462,
    "h": -1.2433452153795,
    "CMY_C": 0.2239975,
    "CMY_M": 0.1891236,
    "CMY_Y": 0.6273058,
    "CMYK_C": 0.04300759,
    "CMYK_M": 0,
    "CMYK_Y": 0.540381,
    "CMYK_K": 0.1891236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00178",
    "Farbtonhilfsbezeichnung": "F8.60.80",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "50",
    "Y": 69,
    "L": 85.2124917313378,
    "a": 4.84980000235979,
    "b": 77.1298617736304,
    "C": 77.2821851223309,
    "h": 1.50800062774877,
    "CMY_C": 0,
    "CMY_M": 0.1903743,
    "CMY_Y": 0.8047172,
    "CMYK_C": 0,
    "CMYK_M": 0.1903743,
    "CMYK_Y": 0.8047172,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00179",
    "Farbtonhilfsbezeichnung": "K2.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "173",
    "Bcolor": "117",
    "Y": 36,
    "L": 66.1926636428124,
    "a": -26.5741299864677,
    "b": 23.5312801659215,
    "C": 35.4951479893348,
    "h": -0.7247436875103,
    "CMY_C": 0.5068206,
    "CMY_M": 0.3216061,
    "CMY_Y": 0.5430829,
    "CMYK_C": 0.273019,
    "CMYK_M": 0,
    "CMYK_Y": 0.3264723,
    "CMYK_K": 0.3216061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00180",
    "Farbtonhilfsbezeichnung": "D2.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "228",
    "Bcolor": "216",
    "Y": 82,
    "L": 91.5074329210706,
    "a": 3.75296948740517,
    "b": 6.73371329571371,
    "C": 7.70893473329913,
    "h": 1.06233507573971,
    "CMY_C": 0.04490829,
    "CMY_M": 0.1059431,
    "CMY_Y": 0.151845,
    "CMYK_C": 0,
    "CMYK_M": 0.06390464,
    "CMYK_Y": 0.1119649,
    "CMYK_K": 0.04490829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00181",
    "Farbtonhilfsbezeichnung": "J0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "219",
    "Bcolor": "192",
    "Y": 70,
    "L": 86.083381652832,
    "a": -7.65233659744263,
    "b": 11.628454208374,
    "C": 13.9204597473145,
    "h": 123.347709655762,
    "CMY_C": 0.17791676521301,
    "CMY_M": 0.14074599742889,
    "CMY_Y": 0.24853706359863,
    "CMYK_C": 0.04325934872031,
    "CMYK_M": 0,
    "CMYK_Y": 0.12544727325439,
    "CMYK_K": 0.14074599742889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00182",
    "Farbtonhilfsbezeichnung": "J0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "212",
    "Y": 80,
    "L": 90.5460891723633,
    "a": -3.07765197753906,
    "b": 7.17932748794556,
    "C": 7.81118965148926,
    "h": 113.203964233398,
    "CMY_C": 0.1066831946373,
    "CMY_M": 0.10044282674789,
    "CMY_Y": 0.16668784618378,
    "CMYK_C": 0.00693715550005,
    "CMYK_M": 0,
    "CMYK_Y": 0.07364181429148,
    "CMYK_K": 0.10044282674789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00183",
    "Farbtonhilfsbezeichnung": "G0.10.65",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "179",
    "Bcolor": "157",
    "Y": 47,
    "L": 72.9740408792203,
    "a": -0.45035610634558,
    "b": 11.2776208428684,
    "C": 11.2866094332188,
    "h": -1.53088392433487,
    "CMY_C": 0.2673593,
    "CMY_M": 0.2990626,
    "CMY_Y": 0.3830288,
    "CMYK_C": 0,
    "CMYK_M": 0.04327258,
    "CMYK_Y": 0.1578802,
    "CMYK_K": 0.2673593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00184",
    "Farbtonhilfsbezeichnung": "U0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "205",
    "Bcolor": "214",
    "Y": 63,
    "L": 82.1789299104752,
    "a": 0.18001097865511,
    "b": -6.24238617735371,
    "C": 6.24498111603654,
    "h": -1.54196743005251,
    "CMY_C": 0.2193421,
    "CMY_M": 0.1965618,
    "CMY_Y": 0.1593973,
    "CMYK_C": 0.0713117,
    "CMYK_M": 0.04421181,
    "CMYK_Y": 0,
    "CMYK_K": 0.1593973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00185",
    "Farbtonhilfsbezeichnung": "F2.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "229",
    "Bcolor": "220",
    "Y": 80,
    "L": 91.2531585693359,
    "a": 1.19396412372589,
    "b": 4.26872158050537,
    "C": 4.43255376815796,
    "h": 74.373664855957,
    "CMY_C": 0.07486146688461,
    "CMY_M": 0.10185581445694,
    "CMY_Y": 0.13674277067184,
    "CMYK_C": 0,
    "CMYK_M": 0.02917870879173,
    "CMYK_Y": 0.06688868999481,
    "CMYK_K": 0.07486146688461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00186",
    "Farbtonhilfsbezeichnung": "GN.02.90",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "243",
    "Bcolor": "229",
    "Y": 89,
    "L": 95.7771224975586,
    "a": -0.54224956035614,
    "b": 6.34507703781128,
    "C": 6.36820507049561,
    "h": 94.8846206665039,
    "CMY_C": 0.03078663349152,
    "CMY_M": 0.04755645990372,
    "CMY_Y": 0.10254335403442,
    "CMYK_C": 0,
    "CMYK_M": 0.01730251312256,
    "CMYK_Y": 0.07403603941202,
    "CMYK_K": 0.03078663349152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00187",
    "Farbtonhilfsbezeichnung": "E0.25.35",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "95",
    "Bcolor": "71",
    "Y": 14,
    "L": 43.3622212037248,
    "a": 10.6378318237404,
    "b": 18.9503271318106,
    "C": 21.7319664161535,
    "h": 1.05927825048599,
    "CMY_C": 0.4931135,
    "CMY_M": 0.6258228,
    "CMY_Y": 0.7218201,
    "CMYK_C": 0,
    "CMYK_M": 0.2618127,
    "CMYK_Y": 0.4511989,
    "CMYK_K": 0.4931135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00188",
    "Farbtonhilfsbezeichnung": "E4.25.35",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "98",
    "Bcolor": "73",
    "Y": 14,
    "L": 43.7074577910256,
    "a": 7.99241088440339,
    "b": 18.3496481691594,
    "C": 20.0147000896108,
    "h": 1.16001362594689,
    "CMY_C": 0.5053448,
    "CMY_M": 0.6161309,
    "CMY_Y": 0.715277,
    "CMYK_C": 0,
    "CMYK_M": 0.2239664,
    "CMYK_Y": 0.424401,
    "CMYK_K": 0.5053448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00189",
    "Farbtonhilfsbezeichnung": "F6.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "205",
    "Bcolor": "185",
    "Y": 64,
    "L": 82.931230710244,
    "a": 1.65354817738761,
    "b": 10.832748410059,
    "C": 10.958223382035,
    "h": 1.41932209807116,
    "CMY_C": 0.1446036,
    "CMY_M": 0.1965173,
    "CMY_Y": 0.2749716,
    "CMYK_C": 0,
    "CMYK_M": 0.06068962,
    "CMYK_Y": 0.1524066,
    "CMYK_K": 0.1446036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00190",
    "Farbtonhilfsbezeichnung": "ON.00.20",
    "Farbtonklasse": "02",
    "Y": 7,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00191",
    "Farbtonhilfsbezeichnung": "F6.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "214",
    "Bcolor": "175",
    "Y": 71,
    "L": 86.5361251831055,
    "a": 2.81542444229126,
    "b": 21.3227157592773,
    "C": 21.5077857971191,
    "h": 82.4782485961914,
    "CMY_C": 0.06915211677551,
    "CMY_M": 0.16225868463516,
    "CMY_Y": 0.3135102391243,
    "CMYK_C": 0,
    "CMYK_M": 0.10002339631319,
    "CMYK_Y": 0.2625113427639,
    "CMYK_K": 0.06915211677551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00194",
    "Farbtonhilfsbezeichnung": "AN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "217",
    "Bcolor": "216",
    "Y": 70,
    "L": 87.1243057250977,
    "a": 1.71911370754242,
    "b": 0.5587711930275,
    "C": 1.80764412879944,
    "h": 18.0059471130371,
    "CMY_C": 0.12889575958252,
    "CMY_M": 0.1478682756424,
    "CMY_Y": 0.15462684631348,
    "CMYK_C": 0,
    "CMYK_M": 0.02177984640002,
    "CMYK_Y": 0.02953846938908,
    "CMYK_K": 0.12889575958252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00195",
    "Farbtonhilfsbezeichnung": "F2.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "230",
    "Bcolor": "210",
    "Y": 82,
    "L": 92.2727661132812,
    "a": 2.77511715888977,
    "b": 11.3543319702148,
    "C": 11.6885471343994,
    "h": 76.2655715942383,
    "CMY_C": 0.03011775016785,
    "CMY_M": 0.09620428085327,
    "CMY_Y": 0.17795586585999,
    "CMYK_C": 0,
    "CMYK_M": 0.06813871860504,
    "CMYK_Y": 0.15242892503738,
    "CMYK_K": 0.03011775016785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00196",
    "Farbtonhilfsbezeichnung": "E4.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "131",
    "Bcolor": "93",
    "Y": 26,
    "L": 57.8651466369629,
    "a": 11.5003776550293,
    "b": 26.3848667144775,
    "C": 28.782283782959,
    "h": 66.4490432739258,
    "CMY_C": 0.32246834039688,
    "CMY_M": 0.4870485663414,
    "CMY_Y": 0.63694405555725,
    "CMYK_C": 0,
    "CMYK_M": 0.24291148781776,
    "CMYK_Y": 0.46414911746979,
    "CMYK_K": 0.32246834039688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00198",
    "Farbtonhilfsbezeichnung": "C8.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "195",
    "Y": 71,
    "L": 86.461446948838,
    "a": 11.9177986353237,
    "b": 10.9899898686952,
    "C": 16.2115329819899,
    "h": 0.74491839651015,
    "CMY_C": 0.0314374,
    "CMY_M": 0.1834758,
    "CMY_Y": 0.2367066,
    "CMYK_C": 0,
    "CMYK_M": 0.1569732,
    "CMYK_Y": 0.2119318,
    "CMYK_K": 0.0314374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00199",
    "Farbtonhilfsbezeichnung": "DN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "219",
    "Bcolor": "212",
    "Y": 74,
    "L": 88.0534290791664,
    "a": 2.73400593522244,
    "b": 3.94493687410309,
    "C": 4.79972034544616,
    "h": 0.96475561400814,
    "CMY_C": 0.09989311,
    "CMY_M": 0.141023,
    "CMY_Y": 0.1691858,
    "CMYK_C": 0,
    "CMYK_M": 0.04569444,
    "CMYK_Y": 0.07698271,
    "CMYK_K": 0.09989311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00200",
    "Farbtonhilfsbezeichnung": "E0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "117",
    "Bcolor": "106",
    "Y": 19,
    "L": 50.4237098693848,
    "a": 5.21826934814453,
    "b": 7.59262943267822,
    "C": 9.21294498443604,
    "h": 55.5,
    "CMY_C": 0.47429984807968,
    "CMY_M": 0.54234516620636,
    "CMY_Y": 0.58243811130524,
    "CMYK_C": 0,
    "CMYK_M": 0.12943750619888,
    "CMYK_Y": 0.20570331811905,
    "CMYK_K": 0.47429984807968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00202",
    "Farbtonhilfsbezeichnung": "W0.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "231",
    "Y": 79,
    "L": 90.5079498291016,
    "a": 2.69997119903564,
    "b": -2.72607636451721,
    "C": 3.83683943748474,
    "h": 314.724334716797,
    "CMY_C": 0.09481018781662,
    "CMY_M": 0.11177313327789,
    "CMY_Y": 0.0930101275444,
    "CMYK_C": 0.00198465306312,
    "CMYK_M": 0.02068711631,
    "CMYK_Y": 0,
    "CMYK_K": 0.0930101275444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00203",
    "Farbtonhilfsbezeichnung": "L0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "180",
    "Bcolor": "171",
    "Y": 45,
    "L": 72.178205949908,
    "a": -5.02611040268713,
    "b": 2.71680141183408,
    "C": 5.71338740952716,
    "h": -0.49554936049792,
    "CMY_C": 0.3356599,
    "CMY_M": 0.2952825,
    "CMY_Y": 0.3313425,
    "CMYK_C": 0.05729588,
    "CMYK_M": 0,
    "CMYK_Y": 0.0511695,
    "CMYK_K": 0.2952825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00204",
    "Farbtonhilfsbezeichnung": "G0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "219",
    "Y": 81,
    "L": 91.5671005249023,
    "a": -0.5872038602829,
    "b": 5.29371881484985,
    "C": 5.32618713378906,
    "h": 96.3296432495117,
    "CMY_C": 0.08187216520309,
    "CMY_M": 0.09438717365265,
    "CMY_Y": 0.14115279912949,
    "CMYK_C": 0,
    "CMYK_M": 0.01363100856543,
    "CMYK_Y": 0.06456686556339,
    "CMYK_K": 0.08187216520309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00205",
    "Farbtonhilfsbezeichnung": "D6.20.80",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "196",
    "Bcolor": "166",
    "Y": 63,
    "L": 83.3096977050277,
    "a": 15.4865409507475,
    "b": 21.9878118357318,
    "C": 26.8941781793519,
    "h": 0.95717432033691,
    "CMY_C": 0.01871876,
    "CMY_M": 0.2300288,
    "CMY_Y": 0.3499858,
    "CMYK_C": 0,
    "CMYK_M": 0.215341,
    "CMYK_Y": 0.3375862,
    "CMYK_K": 0.01871876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00206",
    "Farbtonhilfsbezeichnung": "F6.03.72",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "199",
    "Bcolor": "189",
    "Y": 60,
    "L": 80.2419543672493,
    "a": 0.49008897908653,
    "b": 4.48666600351795,
    "C": 4.51335341343283,
    "h": 1.46199535593945,
    "CMY_C": 0.2013342,
    "CMY_M": 0.2214123,
    "CMY_Y": 0.2578479,
    "CMYK_C": 0,
    "CMYK_M": 0.02513958,
    "CMYK_Y": 0.07076024,
    "CMYK_K": 0.2013342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00207",
    "Farbtonhilfsbezeichnung": "J0.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "140",
    "Bcolor": "104",
    "Y": 25,
    "L": 56.3031029498093,
    "a": -10.6268280766918,
    "b": 17.2937556420723,
    "C": 20.297868340771,
    "h": -1.01979098397631,
    "CMY_C": 0.4984842,
    "CMY_M": 0.4525201,
    "CMY_Y": 0.5933214,
    "CMYK_C": 0.08395569,
    "CMYK_M": 0,
    "CMYK_Y": 0.2571808,
    "CMYK_K": 0.4525201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00208",
    "Farbtonhilfsbezeichnung": "V0.25.35",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "107",
    "Bcolor": "146",
    "Y": 15,
    "L": 45.9953765869141,
    "a": 6.59288692474365,
    "b": -22.9614601135254,
    "C": 23.8892192840576,
    "h": 286.020263671875,
    "CMY_C": 0.61362838745117,
    "CMY_M": 0.57953494787216,
    "CMY_Y": 0.42700034379959,
    "CMYK_C": 0.32570359110832,
    "CMYK_M": 0.2662036716938,
    "CMYK_Y": 0,
    "CMYK_K": 0.42700034379959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00209",
    "Farbtonhilfsbezeichnung": "F6.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "214",
    "Y": 83,
    "L": 91.5715992380438,
    "a": 0.34712508252277,
    "b": 7.88090200035221,
    "C": 7.88854309502533,
    "h": 1.52677841365233,
    "CMY_C": 0.06654169,
    "CMY_M": 0.09728819,
    "CMY_Y": 0.1601693,
    "CMYK_C": 0,
    "CMYK_M": 0.03293827,
    "CMYK_Y": 0.1003018,
    "CMYK_K": 0.06654169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00210",
    "Farbtonhilfsbezeichnung": "Q0.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "156",
    "Bcolor": "157",
    "Y": 33,
    "L": 63.5954902550147,
    "a": -3.44770989012316,
    "b": -2.19600499666754,
    "C": 4.08768166958264,
    "h": 0.56714360850156,
    "CMY_C": 0.4296096,
    "CMY_M": 0.3876465,
    "CMY_Y": 0.3861584,
    "CMYK_C": 0.07078571,
    "CMYK_M": 0.002424189,
    "CMYK_Y": 0,
    "CMYK_K": 0.3861584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00211",
    "Farbtonhilfsbezeichnung": "W0.20.60",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "160",
    "Bcolor": "202",
    "Y": 37,
    "L": 67.863525390625,
    "a": 11.7055177688599,
    "b": -20.9352970123291,
    "C": 23.9855327606201,
    "h": 299.210784912109,
    "CMY_C": 0.33987069129944,
    "CMY_M": 0.37208104133606,
    "CMY_Y": 0.20948618650436,
    "CMYK_C": 0.16493640840054,
    "CMYK_M": 0.20568250119686,
    "CMYK_Y": 0,
    "CMYK_K": 0.20948618650436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00212",
    "Farbtonhilfsbezeichnung": "G4.05.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "210",
    "Bcolor": "196",
    "Y": 64,
    "L": 84.1066589355469,
    "a": -0.61111748218536,
    "b": 6.46558332443237,
    "C": 6.49440002441406,
    "h": 95.3994750976562,
    "CMY_C": 0.16120058298111,
    "CMY_M": 0.17718929052353,
    "CMY_Y": 0.23090898990631,
    "CMYK_C": 0,
    "CMYK_M": 0.01906142011285,
    "CMYK_Y": 0.08310497552156,
    "CMYK_K": 0.16120058298111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00213",
    "Farbtonhilfsbezeichnung": "F2.35.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "117",
    "Y": 66,
    "L": 84.1468707332996,
    "a": 10.5292857564124,
    "b": 48.5233480638535,
    "C": 49.6526048245816,
    "h": 1.3571148459198,
    "CMY_C": 0,
    "CMY_M": 0.212914,
    "CMY_Y": 0.5428369,
    "CMYK_C": 0,
    "CMYK_M": 0.212914,
    "CMYK_Y": 0.5428369,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00214",
    "Farbtonhilfsbezeichnung": "G4.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "220",
    "Bcolor": "205",
    "Y": 73,
    "L": 87.7204513549805,
    "a": -0.71820443868637,
    "b": 7.17587375640869,
    "C": 7.21172523498535,
    "h": 95.7154693603516,
    "CMY_C": 0.11986660957336,
    "CMY_M": 0.13732767105103,
    "CMY_Y": 0.19707763195038,
    "CMYK_C": 0,
    "CMYK_M": 0.01983910799026,
    "CMYK_Y": 0.08772650361061,
    "CMYK_K": 0.11986660957336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00215",
    "Farbtonhilfsbezeichnung": "ON.00.75",
    "Farbtonklasse": "01",
    "Y": 60,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00218",
    "Farbtonhilfsbezeichnung": "F2.07.88",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "234",
    "Bcolor": "216",
    "Y": 86,
    "L": 93.1000693022302,
    "a": 1.71170206084514,
    "b": 9.2896539213043,
    "C": 9.44603588404712,
    "h": 1.38858116320038,
    "CMY_C": 0.03469721,
    "CMY_M": 0.08387125,
    "CMY_Y": 0.1537032,
    "CMYK_C": 0,
    "CMYK_M": 0.05094156,
    "CMYK_Y": 0.1232836,
    "CMYK_K": 0.03469721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00219",
    "Farbtonhilfsbezeichnung": "E8.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "215",
    "Bcolor": "183",
    "Y": 70,
    "L": 87.8408660888672,
    "a": 6.44618558883667,
    "b": 19.1355838775635,
    "C": 20.1921730041504,
    "h": 71.3829193115234,
    "CMY_C": 0.03395241498947,
    "CMY_M": 0.1563333272934,
    "CMY_Y": 0.28282809257507,
    "CMYK_C": 0,
    "CMYK_M": 0.12668207287788,
    "CMYK_Y": 0.25762259960175,
    "CMYK_K": 0.03395241498947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00220",
    "Farbtonhilfsbezeichnung": "E4.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "136",
    "Bcolor": "120",
    "Y": 27,
    "L": 57.870098264713,
    "a": 4.75618278155826,
    "b": 10.7517464921667,
    "C": 11.7567566651441,
    "h": 1.15431083433473,
    "CMY_C": 0.3932303,
    "CMY_M": 0.4676698,
    "CMY_Y": 0.5310895,
    "CMYK_C": 0,
    "CMYK_M": 0.1226816,
    "CMYK_Y": 0.2272018,
    "CMYK_K": 0.3932303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00221",
    "Farbtonhilfsbezeichnung": "B2.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "87",
    "Bcolor": "94",
    "Y": 17,
    "L": 46.5578549995575,
    "a": 33.6831184856671,
    "b": 9.97069291237296,
    "C": 35.1278691080506,
    "h": 0.28779641275835,
    "CMY_C": 0.3483848,
    "CMY_M": 0.660585,
    "CMY_Y": 0.6300485,
    "CMYK_C": 0,
    "CMYK_M": 0.4791175,
    "CMYK_Y": 0.4322546,
    "CMYK_K": 0.3483848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00223",
    "Farbtonhilfsbezeichnung": "B6.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "171",
    "Bcolor": "164",
    "Y": 51,
    "L": 76.6191795560862,
    "a": 26.5714577607762,
    "b": 13.3293520771357,
    "C": 29.7273273997,
    "h": 0.46496013144883,
    "CMY_C": 0.04284412,
    "CMY_M": 0.3311767,
    "CMY_Y": 0.3552802,
    "CMYK_C": 0,
    "CMYK_M": 0.3012389,
    "CMYK_Y": 0.3264213,
    "CMYK_K": 0.04284412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00224",
    "Farbtonhilfsbezeichnung": "E0.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "130",
    "Bcolor": "104",
    "Y": 26,
    "L": 57.1061690648129,
    "a": 10.7459907221035,
    "b": 18.9626898436387,
    "C": 21.7958693954972,
    "h": 1.05522869903415,
    "CMY_C": 0.347295,
    "CMY_M": 0.4914278,
    "CMY_Y": 0.5932667,
    "CMYK_C": 0,
    "CMYK_M": 0.2208239,
    "CMYK_Y": 0.3768498,
    "CMYK_K": 0.347295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00225",
    "Farbtonhilfsbezeichnung": "ON.00.25",
    "Farbtonklasse": "02",
    "Y": 9,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00226",
    "Farbtonhilfsbezeichnung": "ON.00.45",
    "Farbtonklasse": "01",
    "Rcolor": "129",
    "Gcolor": "130",
    "Bcolor": "129",
    "Y": 22,
    "L": 54.1282997131348,
    "a": -0.12377341091633,
    "b": -0.19508451223373,
    "C": 0.23103640973568,
    "h": 237.606491088867,
    "CMY_C": 0.49403887987137,
    "CMY_M": 0.49188339710236,
    "CMY_Y": 0.49531418085098,
    "CMYK_C": 0.00424210261554,
    "CMYK_M": 0,
    "CMYK_Y": 0.00675196154043,
    "CMYK_K": 0.49188339710236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00227",
    "Farbtonhilfsbezeichnung": "ON.00.55",
    "Farbtonklasse": "01",
    "Rcolor": "151",
    "Gcolor": "151",
    "Bcolor": "148",
    "Y": 32,
    "L": 62.2878505137964,
    "a": -0.24521503612223,
    "b": 0.51680109755982,
    "C": 0.57202603820059,
    "h": -1.12776721400622,
    "CMY_C": 0.4097472,
    "CMY_M": 0.408807,
    "CMY_Y": 0.4178068,
    "CMYK_C": 0.001590392,
    "CMYK_M": 0,
    "CMYK_Y": 0.01522307,
    "CMYK_K": 0.408807
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00228",
    "Farbtonhilfsbezeichnung": "ON.00.60",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "164",
    "Bcolor": "162",
    "Y": 38,
    "L": 67.322185306138,
    "a": 0.45438166140932,
    "b": 0.51782299969092,
    "C": 0.68891461969825,
    "h": 0.85056090215668,
    "CMY_C": 0.3522606,
    "CMY_M": 0.3580419,
    "CMY_Y": 0.3658654,
    "CMYK_C": 0,
    "CMYK_M": 0.008925359,
    "CMYK_Y": 0.02100345,
    "CMYK_K": 0.3522606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00229",
    "Farbtonhilfsbezeichnung": "F0.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "206",
    "Bcolor": "164",
    "Y": 69,
    "L": 84.9486342114597,
    "a": 6.93860648414485,
    "b": 25.1653533507452,
    "C": 26.1043917609601,
    "h": 1.30176029743246,
    "CMY_C": 0.05023056,
    "CMY_M": 0.1907017,
    "CMY_Y": 0.3578815,
    "CMYK_C": 0,
    "CMYK_M": 0.1479002,
    "CMYK_Y": 0.3239218,
    "CMYK_K": 0.05023056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00231",
    "Farbtonhilfsbezeichnung": "E8.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "181",
    "Bcolor": "121",
    "Y": 53,
    "L": 77.2280766084932,
    "a": 12.1842554539965,
    "b": 37.3882729624234,
    "C": 39.323517595466,
    "h": 1.25576471286543,
    "CMY_C": 0.08324996,
    "CMY_M": 0.2898659,
    "CMY_Y": 0.5266865,
    "CMYK_C": 0,
    "CMYK_M": 0.2253786,
    "CMYK_Y": 0.483705,
    "CMYK_K": 0.08324996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00232",
    "Farbtonhilfsbezeichnung": "H2.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "219",
    "Bcolor": "191",
    "Y": 71,
    "L": 86.8409514167611,
    "a": -3.19484201620773,
    "b": 13.0472580448034,
    "C": 13.4327196798048,
    "h": -1.33065459309355,
    "CMY_C": 0.1310321,
    "CMY_M": 0.1428092,
    "CMY_Y": 0.2501724,
    "CMYK_C": 0,
    "CMYK_M": 0.01355297,
    "CMYK_Y": 0.1371055,
    "CMYK_K": 0.1310321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00233",
    "Farbtonhilfsbezeichnung": "U0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "186",
    "Bcolor": "219",
    "Y": 49,
    "L": 74.7792901594369,
    "a": -0.62407898895589,
    "b": -20.28569846415,
    "C": 20.2952959269599,
    "h": 1.54004154580558,
    "CMY_C": 0.3664238,
    "CMY_M": 0.2702055,
    "CMY_Y": 0.1397914,
    "CMYK_C": 0.2634622,
    "CMYK_M": 0.1516075,
    "CMYK_Y": 0,
    "CMYK_K": 0.1397914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00234",
    "Farbtonhilfsbezeichnung": "C0.05.85",
    "Farbtonklasse": "01",
    "Y": 76,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00235",
    "Farbtonhilfsbezeichnung": "A0.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "192",
    "Bcolor": "203",
    "Y": 60,
    "L": 82.2984848022461,
    "a": 19.6114616394043,
    "b": 0.70882070064545,
    "C": 19.624267578125,
    "h": 2.06995105743408,
    "CMY_C": 0.05258220434189,
    "CMY_M": 0.2465318441391,
    "CMY_Y": 0.20569431781769,
    "CMYK_C": 0,
    "CMYK_M": 0.20471395552158,
    "CMYK_Y": 0.1616099178791,
    "CMYK_K": 0.05258220434189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00236",
    "Farbtonhilfsbezeichnung": "K2.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "233",
    "Bcolor": "220",
    "Y": 81,
    "L": 91.5849988289517,
    "a": -4.01279747569183,
    "b": 4.82780812147188,
    "C": 6.27776033619224,
    "h": -0.87732777644206,
    "CMY_C": 0.1102313,
    "CMY_M": 0.08607984,
    "CMY_Y": 0.1379937,
    "CMYK_C": 0.02642628,
    "CMYK_M": 0,
    "CMYK_Y": 0.05680348,
    "CMYK_K": 0.08607984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00238",
    "Farbtonhilfsbezeichnung": "Q0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 71,
    "L": 85.9213181341147,
    "a": -10.5058237310111,
    "b": -4.32543314197762,
    "C": 11.3614129461433,
    "h": 0.39056681570691,
    "CMY_C": 0.2613572,
    "CMY_M": 0.1321144,
    "CMY_Y": 0.1336349,
    "CMYK_C": 0.1489168,
    "CMYK_M": 0,
    "CMYK_Y": 0.001752008,
    "CMYK_K": 0.1321144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00240",
    "Farbtonhilfsbezeichnung": "CN.01.90",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "224",
    "Y": 87,
    "L": 92.937650355307,
    "a": 1.3288779956005,
    "b": 4.703429942933,
    "C": 4.88755255268626,
    "h": 1.29543956881292,
    "CMY_C": 0.0535218,
    "CMY_M": 0.08352278,
    "CMY_Y": 0.1213989,
    "CMYK_C": 0,
    "CMYK_M": 0.03169748,
    "CMYK_Y": 0.07171538,
    "CMYK_K": 0.0535218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00241",
    "Farbtonhilfsbezeichnung": "E0.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "180",
    "Bcolor": "144",
    "Y": 52,
    "L": 76.5955726300398,
    "a": 12.9216907139373,
    "b": 23.8434495578356,
    "C": 27.1197377886237,
    "h": 1.07416318745465,
    "CMY_C": 0.1088095,
    "CMY_M": 0.2958986,
    "CMY_Y": 0.4334541,
    "CMYK_C": 0,
    "CMYK_M": 0.2099317,
    "CMYK_Y": 0.364282,
    "CMYK_K": 0.1088095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00243",
    "Farbtonhilfsbezeichnung": "D6.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "146",
    "Bcolor": "108",
    "Y": 38,
    "L": 67.0855421159992,
    "a": 23.4183902935011,
    "b": 30.9867344091097,
    "C": 38.8406837385679,
    "h": 0.92362195851069,
    "CMY_C": 0.14258,
    "CMY_M": 0.4261384,
    "CMY_Y": 0.5776122,
    "CMYK_C": 0,
    "CMYK_M": 0.3307112,
    "CMYK_Y": 0.5073735,
    "CMYK_K": 0.14258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00245",
    "Farbtonhilfsbezeichnung": "L8.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "206",
    "Bcolor": "195",
    "Y": 60,
    "L": 81.2113979174094,
    "a": -6.8335545130323,
    "b": 2.79384784913626,
    "C": 7.38261830834477,
    "h": -0.38810594558528,
    "CMY_C": 0.253486,
    "CMY_M": 0.1938851,
    "CMY_Y": 0.2362362,
    "CMYK_C": 0.07393605,
    "CMYK_M": 0,
    "CMYK_Y": 0.05253736,
    "CMYK_K": 0.1938851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00250",
    "Farbtonhilfsbezeichnung": "Q0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "70",
    "Bcolor": "71",
    "Y": 7,
    "L": 28.723745066844,
    "a": -3.70424969148342,
    "b": -2.28805231861103,
    "C": 4.35392342486134,
    "h": 0.55332039129213,
    "CMY_C": 0.766404,
    "CMY_M": 0.7269042,
    "CMY_Y": 0.7235249,
    "CMYK_C": 0.1550922,
    "CMYK_M": 0.01222252,
    "CMYK_Y": 0,
    "CMYK_K": 0.7235249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00253",
    "Farbtonhilfsbezeichnung": "C4.05.20",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "68",
    "Bcolor": "67",
    "Y": 7,
    "L": 29.8501984054202,
    "a": 3.55591116266954,
    "b": 2.07798608197719,
    "C": 4.11855925703258,
    "h": 0.52885140218321,
    "CMY_C": 0.6970106,
    "CMY_M": 0.7316766,
    "CMY_Y": 0.7387358,
    "CMYK_C": 0,
    "CMYK_M": 0.1144133,
    "CMYK_Y": 0.1377117,
    "CMYK_K": 0.6970106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00273",
    "Farbtonhilfsbezeichnung": "G0.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "97",
    "Bcolor": "77",
    "Y": 11,
    "L": 41.2287979125977,
    "a": 0.03952220454812,
    "b": 11.8878908157349,
    "C": 11.8879566192627,
    "h": 89.8095169067383,
    "CMY_C": 0.58884561061859,
    "CMY_M": 0.62115275859833,
    "CMY_Y": 0.6974470615387,
    "CMYK_C": 0,
    "CMYK_M": 0.07857668399811,
    "CMYK_Y": 0.26413789391518,
    "CMYK_K": 0.58884561061859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00286",
    "Farbtonhilfsbezeichnung": "S0.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "154",
    "Gcolor": "198",
    "Bcolor": "217",
    "Y": 54,
    "L": 77.527564600133,
    "a": -9.79407476219868,
    "b": -14.9278418960357,
    "C": 17.8539733426645,
    "h": 0.99014868125569,
    "CMY_C": 0.395023,
    "CMY_M": 0.2225179,
    "CMY_Y": 0.1488856,
    "CMYK_C": 0.2891943,
    "CMYK_M": 0.08651276,
    "CMYK_Y": 0,
    "CMYK_K": 0.1488856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00289",
    "Farbtonhilfsbezeichnung": "D2.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "180",
    "Bcolor": "153",
    "Y": 54,
    "L": 77.8191501958612,
    "a": 18.0157498489444,
    "b": 21.0038393924726,
    "C": 27.6717999386474,
    "h": 0.86182820724486,
    "CMY_C": 0.06772868,
    "CMY_M": 0.2958268,
    "CMY_Y": 0.3993892,
    "CMYK_C": 0,
    "CMYK_M": 0.2446692,
    "CMYK_Y": 0.3557554,
    "CMYK_K": 0.06772868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00290",
    "Farbtonhilfsbezeichnung": "D2.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "205",
    "Bcolor": "182",
    "Y": 69,
    "L": 85.8241446551633,
    "a": 13.3191954738758,
    "b": 16.6588646541587,
    "C": 21.3288241503579,
    "h": 0.89634447387839,
    "CMY_C": 0.01553322,
    "CMY_M": 0.1955794,
    "CMY_Y": 0.2848212,
    "CMYK_C": 0,
    "CMYK_M": 0.182887,
    "CMYK_Y": 0.2735369,
    "CMYK_K": 0.01553322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00291",
    "Farbtonhilfsbezeichnung": "E0.20.80",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "200",
    "Bcolor": "163",
    "Y": 65,
    "L": 84.0837198199875,
    "a": 13.4355348972073,
    "b": 24.482078548844,
    "C": 27.9264349326198,
    "h": 1.0688821020181,
    "CMY_C": 0.01821787,
    "CMY_M": 0.2167088,
    "CMY_Y": 0.3606055,
    "CMYK_C": 0,
    "CMYK_M": 0.2021741,
    "CMYK_Y": 0.3487409,
    "CMYK_K": 0.01821787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00292",
    "Farbtonhilfsbezeichnung": "J0.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "170",
    "Bcolor": "151",
    "Y": 39,
    "L": 68.8296127319336,
    "a": -4.87867450714111,
    "b": 8.63124084472656,
    "C": 9.91462516784668,
    "h": 119.476631164551,
    "CMY_C": 0.35111558437347,
    "CMY_M": 0.33254283666611,
    "CMY_Y": 0.40769624710083,
    "CMYK_C": 0.02782612666488,
    "CMYK_M": 0,
    "CMYK_Y": 0.11259660124779,
    "CMYK_K": 0.33254283666611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00295",
    "Farbtonhilfsbezeichnung": "YN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "205",
    "Bcolor": "204",
    "Y": 65,
    "L": 83.0524394000324,
    "a": 2.84008949348763,
    "b": 0.6079437433899,
    "C": 2.90442833035104,
    "h": 0.21087556108043,
    "CMY_C": 0.1650817,
    "CMY_M": 0.1952884,
    "CMY_Y": 0.1991984,
    "CMYK_C": 0,
    "CMYK_M": 0.03617924,
    "CMYK_Y": 0.04086237,
    "CMYK_K": 0.1650817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00298",
    "Farbtonhilfsbezeichnung": "G4.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "171",
    "Gcolor": "166",
    "Bcolor": "146",
    "Y": 39,
    "L": 67.9603958129883,
    "a": -1.44277620315552,
    "b": 10.220911026001,
    "C": 10.3222389221191,
    "h": 98.0347442626953,
    "CMY_C": 0.33077895641327,
    "CMY_M": 0.34954065084457,
    "CMY_Y": 0.42722630500793,
    "CMYK_C": 0,
    "CMYK_M": 0.0280351229012,
    "CMYK_Y": 0.14411881566048,
    "CMYK_K": 0.33077895641327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00299",
    "Farbtonhilfsbezeichnung": "G4.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "216",
    "Bcolor": "195",
    "Y": 71,
    "L": 86.4530107015955,
    "a": -0.19773671292661,
    "b": 10.3563717549864,
    "C": 10.3582593004385,
    "h": -1.55170540437269,
    "CMY_C": 0.1205443,
    "CMY_M": 0.1533979,
    "CMY_Y": 0.2340749,
    "CMYK_C": 0,
    "CMYK_M": 0.03735678,
    "CMYK_Y": 0.1290919,
    "CMYK_K": 0.1205443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00303",
    "Farbtonhilfsbezeichnung": "S0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "152",
    "Bcolor": "154",
    "Y": 32,
    "L": 62.4404620311921,
    "a": -2.1278346922895,
    "b": -2.74435755911022,
    "C": 3.47263284698457,
    "h": 0.91126830026428,
    "CMY_C": 0.4331967,
    "CMY_M": 0.4022757,
    "CMY_Y": 0.3941382,
    "CMYK_C": 0.06446771,
    "CMYK_M": 0.01343144,
    "CMYK_Y": 0,
    "CMYK_K": 0.3941382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00304",
    "Farbtonhilfsbezeichnung": "F6.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "237",
    "Bcolor": "227",
    "Y": 86,
    "L": 93.8867111206055,
    "a": 0.28127318620682,
    "b": 4.79519939422607,
    "C": 4.80344152450562,
    "h": 86.6430358886719,
    "CMY_C": 0.05066180229187,
    "CMY_M": 0.07036173343658,
    "CMY_Y": 0.11175447702408,
    "CMYK_C": 0,
    "CMYK_M": 0.02075122483075,
    "CMYK_Y": 0.06435290724039,
    "CMYK_K": 0.05066180229187
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00305",
    "Farbtonhilfsbezeichnung": "E4.10.85",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "222",
    "Bcolor": "195",
    "Y": 78,
    "L": 90.0920517495599,
    "a": 5.24462791815028,
    "b": 15.976143709777,
    "C": 16.8149721925221,
    "h": 1.25360180666506,
    "CMY_C": 0.02451905,
    "CMY_M": 0.1277438,
    "CMY_Y": 0.2355236,
    "CMYK_C": 0,
    "CMYK_M": 0.1058193,
    "CMYK_Y": 0.2163082,
    "CMYK_K": 0.02451905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00307",
    "Farbtonhilfsbezeichnung": "L0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "145",
    "Bcolor": "95",
    "Y": 24,
    "L": 54.6997577006225,
    "a": -33.6967913614615,
    "b": 19.3519750777294,
    "C": 38.8583670200759,
    "h": -0.52130599453453,
    "CMY_C": 0.7081081,
    "CMY_M": 0.4302696,
    "CMY_Y": 0.6264175,
    "CMYK_C": 0.4876666,
    "CMYK_M": 0,
    "CMYK_Y": 0.3442819,
    "CMYK_K": 0.4302696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00308",
    "Farbtonhilfsbezeichnung": "E0.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "142",
    "Bcolor": "109",
    "Y": 32,
    "L": 62.845179022846,
    "a": 13.7290986437912,
    "b": 24.0709024466598,
    "C": 27.7109453856696,
    "h": 1.05245553485898,
    "CMY_C": 0.2579876,
    "CMY_M": 0.4417937,
    "CMY_Y": 0.5723177,
    "CMYK_C": 0,
    "CMYK_M": 0.247713,
    "CMYK_Y": 0.4236184,
    "CMYK_K": 0.2579876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00309",
    "Farbtonhilfsbezeichnung": "F6.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "200",
    "Bcolor": "165",
    "Y": 61,
    "L": 81.5593442884754,
    "a": 2.17928729823991,
    "b": 19.670847025303,
    "C": 19.7911979380011,
    "h": 1.4604586141932,
    "CMY_C": 0.1335343,
    "CMY_M": 0.2147964,
    "CMY_Y": 0.3538005,
    "CMYK_C": 0,
    "CMYK_M": 0.09378573,
    "CMYK_Y": 0.2542122,
    "CMYK_K": 0.1335343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00312",
    "Farbtonhilfsbezeichnung": "A0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "75",
    "Bcolor": "92",
    "Y": 11,
    "L": 38.1037196044703,
    "a": 23.4004314841709,
    "b": -1.42866882518734,
    "C": 23.4440032472579,
    "h": -0.06097740863447,
    "CMY_C": 0.5126459,
    "CMY_M": 0.7048482,
    "CMY_Y": 0.6394337,
    "CMYK_C": 0,
    "CMYK_M": 0.3943792,
    "CMYK_Y": 0.2601554,
    "CMYK_K": 0.5126459
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00313",
    "Farbtonhilfsbezeichnung": "E8.10.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "225",
    "Bcolor": "203",
    "Y": 79,
    "L": 90.7603607177734,
    "a": 3.78106355667114,
    "b": 12.6100540161133,
    "C": 13.1647214889526,
    "h": 73.3088989257813,
    "CMY_C": 0.03636634349823,
    "CMY_M": 0.11583095788956,
    "CMY_Y": 0.20356792211533,
    "CMYK_C": 0,
    "CMYK_M": 0.08246351033449,
    "CMYK_Y": 0.1735115647316,
    "CMYK_K": 0.03636634349823
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00314",
    "Farbtonhilfsbezeichnung": "T0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "218",
    "Bcolor": "230",
    "Y": 71,
    "L": 86.2208781629779,
    "a": -2.50881704164879,
    "b": -8.64003501277337,
    "C": 8.99690880082805,
    "h": 1.28819656626635,
    "CMY_C": 0.2069024,
    "CMY_M": 0.1452581,
    "CMY_Y": 0.09773976,
    "CMYK_C": 0.120988,
    "CMYK_M": 0.05266594,
    "CMYK_Y": 0,
    "CMYK_K": 0.09773976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00316",
    "Farbtonhilfsbezeichnung": "F6.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "211",
    "Bcolor": "163",
    "Y": 69,
    "L": 85.6554430438918,
    "a": 3.11882152862136,
    "b": 26.3883930232649,
    "C": 26.5720592743146,
    "h": 1.45315293324511,
    "CMY_C": 0.06570857,
    "CMY_M": 0.1738034,
    "CMY_Y": 0.3603031,
    "CMYK_C": 0,
    "CMYK_M": 0.1156971,
    "CMYK_Y": 0.3153133,
    "CMYK_K": 0.06570857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00317",
    "Farbtonhilfsbezeichnung": "D2.15.25",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "70",
    "Bcolor": "61",
    "Y": 8,
    "L": 31.7794851008714,
    "a": 8.6372730779338,
    "b": 8.37749586933329,
    "C": 12.0326606892863,
    "h": 0.77013160131947,
    "CMY_C": 0.6370905,
    "CMY_M": 0.7266877,
    "CMY_Y": 0.7589357,
    "CMYK_C": 0,
    "CMYK_M": 0.2468857,
    "CMYK_Y": 0.3357455,
    "CMYK_K": 0.6370905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00318",
    "Farbtonhilfsbezeichnung": "E8.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "213",
    "Bcolor": "191",
    "Y": 72,
    "L": 86.2622701191115,
    "a": 3.62856240552828,
    "b": 12.3935742111668,
    "C": 12.9138354820909,
    "h": 1.2859785765074,
    "CMY_C": 0.08884385,
    "CMY_M": 0.1651619,
    "CMY_Y": 0.2504812,
    "CMYK_C": 0,
    "CMYK_M": 0.0837596,
    "CMYK_Y": 0.1773981,
    "CMYK_K": 0.08884385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00321",
    "Farbtonhilfsbezeichnung": "L0.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "237",
    "Bcolor": "226",
    "Y": 85,
    "L": 92.8721697056104,
    "a": -4.02910174505727,
    "b": 3.32254120029318,
    "C": 5.2223501318534,
    "h": -0.68958325058592,
    "CMY_C": 0.1011574,
    "CMY_M": 0.07121391,
    "CMY_Y": 0.1126158,
    "CMYK_C": 0.03223937,
    "CMYK_M": 0,
    "CMYK_Y": 0.04457634,
    "CMYK_K": 0.07121391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00322",
    "Farbtonhilfsbezeichnung": "K2.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "115",
    "Bcolor": "99",
    "Y": 17,
    "L": 46.9960560677206,
    "a": -7.12073161386051,
    "b": 6.96898557928836,
    "C": 9.96351236868613,
    "h": -0.77462859536687,
    "CMY_C": 0.5928326,
    "CMY_M": 0.550283,
    "CMY_Y": 0.6128738,
    "CMYK_C": 0.09461436,
    "CMYK_M": 0,
    "CMYK_Y": 0.1391784,
    "CMYK_K": 0.550283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00328",
    "Farbtonhilfsbezeichnung": "G0.08.88",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "208",
    "Y": 85,
    "L": 92.7171886714545,
    "a": 0.04055567044786,
    "b": 12.7145983948506,
    "C": 12.714663074763,
    "h": 1.56760664422298,
    "CMY_C": 0.04170753,
    "CMY_M": 0.08501033,
    "CMY_Y": 0.1836869,
    "CMYK_C": 0,
    "CMYK_M": 0.04518746,
    "CMYK_Y": 0.1481587,
    "CMYK_K": 0.04170753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00329",
    "Farbtonhilfsbezeichnung": "G8.06.90",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "241",
    "Bcolor": "222",
    "Y": 87,
    "L": 95.0276870727539,
    "a": -1.28388488292694,
    "b": 9.01651382446289,
    "C": 9.10746288299561,
    "h": 98.1040115356445,
    "CMY_C": 0.03665602207184,
    "CMY_M": 0.05494093894958,
    "CMY_Y": 0.13094562292099,
    "CMYK_C": 0,
    "CMYK_M": 0.01898067258298,
    "CMYK_Y": 0.09787739813328,
    "CMYK_K": 0.03665602207184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00336",
    "Farbtonhilfsbezeichnung": "C0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "122",
    "Bcolor": "114",
    "Y": 26,
    "L": 57.43529734898,
    "a": 23.2315026283927,
    "b": 13.801409577398,
    "C": 27.0218730049586,
    "h": 0.53605641296448,
    "CMY_C": 0.2793057,
    "CMY_M": 0.5204262,
    "CMY_Y": 0.5528329,
    "CMYK_C": 0,
    "CMYK_M": 0.3345669,
    "CMYK_Y": 0.3795329,
    "CMYK_K": 0.2793057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00337",
    "Farbtonhilfsbezeichnung": "C0.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "162",
    "Bcolor": "155",
    "Y": 44,
    "L": 71.6051766310565,
    "a": 20.3877839555259,
    "b": 11.2215915051259,
    "C": 23.2719971322857,
    "h": 0.50315610384666,
    "CMY_C": 0.1432044,
    "CMY_M": 0.3658801,
    "CMY_Y": 0.3933945,
    "CMYK_C": 0,
    "CMYK_M": 0.2598936,
    "CMYK_Y": 0.2920067,
    "CMYK_K": 0.1432044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00338",
    "Farbtonhilfsbezeichnung": "F8.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "184",
    "Bcolor": "117",
    "Y": 52,
    "L": 75.9839046783717,
    "a": 1.8770119842928,
    "b": 37.5009450556976,
    "C": 37.5478901412533,
    "h": 1.52078567034186,
    "CMY_C": 0.1629248,
    "CMY_M": 0.2776023,
    "CMY_Y": 0.5425764,
    "CMYK_C": 0,
    "CMYK_M": 0.1369979,
    "CMYK_Y": 0.4535453,
    "CMYK_K": 0.1629248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00341",
    "Farbtonhilfsbezeichnung": "X0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "185",
    "Bcolor": "208",
    "Y": 52,
    "L": 77.1739337200207,
    "a": 10.8219056756629,
    "b": -10.427668808046,
    "C": 15.028303937013,
    "h": -0.76684759689917,
    "CMY_C": 0.2064503,
    "CMY_M": 0.2750698,
    "CMY_Y": 0.1826058,
    "CMYK_C": 0.0291714,
    "CMYK_M": 0.1131205,
    "CMYK_Y": 0,
    "CMYK_K": 0.1826058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00342",
    "Farbtonhilfsbezeichnung": "G4.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "203",
    "Bcolor": "165",
    "Y": 62,
    "L": 81.7725751508959,
    "a": -2.24074885369496,
    "b": 19.7584040645216,
    "C": 19.8850568669601,
    "h": -1.45787141463691,
    "CMY_C": 0.1623158,
    "CMY_M": 0.2021617,
    "CMY_Y": 0.3529838,
    "CMYK_C": 0,
    "CMYK_M": 0.0475667,
    "CMYK_Y": 0.2276133,
    "CMYK_K": 0.1623158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00343",
    "Farbtonhilfsbezeichnung": "E4.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "106",
    "Bcolor": "69",
    "Y": 18,
    "L": 47.7595916012687,
    "a": 10.976180700118,
    "b": 25.9025085119647,
    "C": 28.1321255857791,
    "h": 1.16998515516572,
    "CMY_C": 0.4353234,
    "CMY_M": 0.5855682,
    "CMY_Y": 0.7280712,
    "CMYK_C": 0,
    "CMYK_M": 0.2660722,
    "CMYK_Y": 0.5184344,
    "CMYK_K": 0.4353234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00346",
    "Farbtonhilfsbezeichnung": "EN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 81,
    "L": 91.9446258544922,
    "a": 1.62956500053406,
    "b": 3.40877795219421,
    "C": 3.77825999259949,
    "h": 64.4498825073242,
    "CMY_C": 0.06649500131607,
    "CMY_M": 0.09495168924332,
    "CMY_Y": 0.12268853187561,
    "CMYK_C": 0,
    "CMYK_M": 0.03048370219767,
    "CMYK_Y": 0.06019628420472,
    "CMYK_K": 0.06649500131607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00354",
    "Farbtonhilfsbezeichnung": "E4.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "218",
    "Bcolor": "199",
    "Y": 73,
    "L": 88.2214897258369,
    "a": 4.46395471829175,
    "b": 11.2853705565987,
    "C": 12.1361641520994,
    "h": 1.1941300109056,
    "CMY_C": 0.06372519,
    "CMY_M": 0.1453342,
    "CMY_Y": 0.2211229,
    "CMYK_C": 0,
    "CMYK_M": 0.08716357,
    "CMYK_Y": 0.1681106,
    "CMYK_K": 0.06372519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00356",
    "Farbtonhilfsbezeichnung": "D6.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "222",
    "Bcolor": "212",
    "Y": 77,
    "L": 89.8520660400391,
    "a": 5.24816226959229,
    "b": 6.72094774246216,
    "C": 8.52727031707764,
    "h": 52.0149192810059,
    "CMY_C": 0.0524594783783,
    "CMY_M": 0.12798088788986,
    "CMY_Y": 0.16963088512421,
    "CMYK_C": 0,
    "CMYK_M": 0.07970256358385,
    "CMYK_Y": 0.12365846335888,
    "CMYK_K": 0.0524594783783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00360",
    "Farbtonhilfsbezeichnung": "W0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "200",
    "Bcolor": "214",
    "Y": 62,
    "L": 81.4045430842299,
    "a": 4.06347392013223,
    "b": -7.24095971836987,
    "C": 8.30321130302305,
    "h": -1.05941098696518,
    "CMY_C": 0.2006435,
    "CMY_M": 0.2138386,
    "CMY_Y": 0.1601573,
    "CMYK_C": 0.04820694,
    "CMYK_M": 0.06391826,
    "CMYK_Y": 0,
    "CMYK_K": 0.1601573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00362",
    "Farbtonhilfsbezeichnung": "NN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "226",
    "Bcolor": "224",
    "Y": 78,
    "L": 89.6877746582031,
    "a": -1.32508766651154,
    "b": -0.053377520293,
    "C": 1.32616233825684,
    "h": 182.306747436523,
    "CMY_C": 0.12654155492783,
    "CMY_M": 0.11210161447525,
    "CMY_Y": 0.12236940860748,
    "CMYK_C": 0.0162630546838,
    "CMYK_M": 0,
    "CMYK_Y": 0.0115641541779,
    "CMYK_K": 0.11210161447525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00364",
    "Farbtonhilfsbezeichnung": "G0.25.75",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "203",
    "Bcolor": "148",
    "Y": 62,
    "L": 82.3933868408203,
    "a": -0.04479327052832,
    "b": 29.8913326263428,
    "C": 29.8913669586182,
    "h": 90.0858612060547,
    "CMY_C": 0.11721014976501,
    "CMY_M": 0.20255267620087,
    "CMY_Y": 0.42090022563934,
    "CMYK_C": 0,
    "CMYK_M": 0.0966736599803,
    "CMYK_Y": 0.34401175379753,
    "CMYK_K": 0.11721014976501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00366",
    "Farbtonhilfsbezeichnung": "F6.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "175",
    "Bcolor": "144",
    "Y": 45,
    "L": 72.0854350326366,
    "a": 1.43090789326195,
    "b": 17.3102447537374,
    "C": 17.3692852712279,
    "h": 1.48832135095361,
    "CMY_C": 0.2487078,
    "CMY_M": 0.3141751,
    "CMY_Y": 0.4347412,
    "CMYK_C": 0,
    "CMYK_M": 0.08713959,
    "CMYK_Y": 0.247618,
    "CMYK_K": 0.2487078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00367",
    "Farbtonhilfsbezeichnung": "D2.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "119",
    "Bcolor": "93",
    "Y": 25,
    "L": 55.7851260782301,
    "a": 21.105732051989,
    "b": 23.4854123761849,
    "C": 31.5755684023236,
    "h": 0.83871424436532,
    "CMY_C": 0.2945571,
    "CMY_M": 0.5330029,
    "CMY_Y": 0.6346148,
    "CMYK_C": 0,
    "CMYK_M": 0.3380086,
    "CMYK_Y": 0.4820485,
    "CMYK_K": 0.2945571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00376",
    "Farbtonhilfsbezeichnung": "N0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 81,
    "L": 91.1601104736328,
    "a": -5.56791734695435,
    "b": -0.66436988115311,
    "C": 5.60741376876831,
    "h": 186.804428100586,
    "CMY_C": 0.14708572626114,
    "CMY_M": 0.08572149276733,
    "CMY_Y": 0.10215073823929,
    "CMYK_C": 0.06711766123772,
    "CMYK_M": 0,
    "CMYK_Y": 0.01796962879598,
    "CMYK_K": 0.08572149276733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00379",
    "Farbtonhilfsbezeichnung": "E4.25.30",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "88",
    "Bcolor": "64",
    "Y": 12,
    "L": 39.8931454111021,
    "a": 8.51289100457786,
    "b": 17.9688818996717,
    "C": 19.8834109241894,
    "h": 1.12836231791217,
    "CMY_C": 0.541945,
    "CMY_M": 0.653415,
    "CMY_Y": 0.7470824,
    "CMYK_C": 0,
    "CMYK_M": 0.243355,
    "CMYK_Y": 0.4478445,
    "CMYK_K": 0.541945
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00383",
    "Farbtonhilfsbezeichnung": "S0.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "142",
    "Bcolor": "161",
    "Y": 26,
    "L": 56.9259645934196,
    "a": -7.95520910009456,
    "b": -14.9374857786571,
    "C": 16.9237653379444,
    "h": 1.08143596732517,
    "CMY_C": 0.59167,
    "CMY_M": 0.4434068,
    "CMY_Y": 0.3688504,
    "CMYK_C": 0.3530379,
    "CMYK_M": 0.118128,
    "CMYK_Y": 0,
    "CMYK_K": 0.3688504
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00386",
    "Farbtonhilfsbezeichnung": "LN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "187",
    "Bcolor": "182",
    "Y": 49,
    "L": 75.2996597290039,
    "a": -2.88933420181274,
    "b": 1.18805277347565,
    "C": 3.1240553855896,
    "h": 157.648239135742,
    "CMY_C": 0.29108744859695,
    "CMY_M": 0.26615709066391,
    "CMY_Y": 0.28729510307312,
    "CMYK_C": 0.03397233784199,
    "CMYK_M": 0,
    "CMYK_Y": 0.02880454622209,
    "CMYK_K": 0.26615709066391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00389",
    "Farbtonhilfsbezeichnung": "E4.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "172",
    "Bcolor": "143",
    "Y": 45,
    "L": 72.3795362619608,
    "a": 8.05576362295696,
    "b": 18.5950014474808,
    "C": 20.2649798021308,
    "h": 1.16198223837315,
    "CMY_C": 0.1982056,
    "CMY_M": 0.3271613,
    "CMY_Y": 0.439734,
    "CMYK_C": 0,
    "CMYK_M": 0.1608338,
    "CMYK_Y": 0.3012348,
    "CMYK_K": 0.1982056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00391",
    "Farbtonhilfsbezeichnung": "E4.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "159",
    "Bcolor": "110",
    "Y": 40,
    "L": 69.058017947635,
    "a": 13.1900829617409,
    "b": 32.029133804748,
    "C": 34.6387600935723,
    "h": 1.18014614145007,
    "CMY_C": 0.1789979,
    "CMY_M": 0.3777142,
    "CMY_Y": 0.5682347,
    "CMYK_C": 0,
    "CMYK_M": 0.2420411,
    "CMYK_Y": 0.4740997,
    "CMYK_K": 0.1789979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00392",
    "Farbtonhilfsbezeichnung": "S0.20.10",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "61",
    "Bcolor": "68",
    "Y": 5,
    "L": 24.5605388318353,
    "a": -3.97773054149753,
    "b": -6.71562843117735,
    "C": 7.80525499176034,
    "h": 1.03605079371923,
    "CMY_C": 0.8216575,
    "CMY_M": 0.7624213,
    "CMY_Y": 0.7346796,
    "CMYK_C": 0.3278221,
    "CMYK_M": 0.1045592,
    "CMYK_Y": 0,
    "CMYK_K": 0.7346796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00393",
    "Farbtonhilfsbezeichnung": "C8.51.39",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "88",
    "Bcolor": "68",
    "Y": 17,
    "L": 48.0072135925293,
    "a": 34.9179763793945,
    "b": 27.9499187469482,
    "C": 44.7265357971191,
    "h": 38.675350189209,
    "CMY_C": 0.30398428440094,
    "CMY_M": 0.65488785505295,
    "CMY_Y": 0.73345196247101,
    "CMYK_C": 0,
    "CMYK_M": 0.50416040420532,
    "CMYK_Y": 0.61703735589981,
    "CMYK_K": 0.30398428440094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00394",
    "Farbtonhilfsbezeichnung": "H2.04.88",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "242",
    "Bcolor": "226",
    "Y": 87,
    "L": 95.3113861083984,
    "a": -2.19761395454407,
    "b": 7.20321416854858,
    "C": 7.53098917007446,
    "h": 106.966316223145,
    "CMY_C": 0.04629415273666,
    "CMY_M": 0.04909855127335,
    "CMY_Y": 0.11437237262726,
    "CMYK_C": 0,
    "CMYK_M": 0.00294052786194,
    "CMYK_Y": 0.07138282805681,
    "CMYK_K": 0.04629415273666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00395",
    "Farbtonhilfsbezeichnung": "P0.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 78,
    "L": 89.8672988050171,
    "a": -7.59900778373362,
    "b": -1.3133085433745,
    "C": 7.71165991388006,
    "h": 0.17113580074234,
    "CMY_C": 0.1808877,
    "CMY_M": 0.09543829,
    "CMY_Y": 0.11192,
    "CMYK_C": 0.09446502,
    "CMYK_M": 0,
    "CMYK_Y": 0.01822065,
    "CMYK_K": 0.09543829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00396",
    "Farbtonhilfsbezeichnung": "H2.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "221",
    "Bcolor": "210",
    "Y": 75,
    "L": 87.8538984742019,
    "a": -1.09277521854501,
    "b": 4.44801202442999,
    "C": 4.58028041147481,
    "h": -1.3298902845096,
    "CMY_C": 0.1298876,
    "CMY_M": 0.1342755,
    "CMY_Y": 0.1756133,
    "CMYK_C": 0,
    "CMYK_M": 0.005042898,
    "CMYK_Y": 0.05255146,
    "CMYK_K": 0.1298876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00399",
    "Farbtonhilfsbezeichnung": "A0.10.60",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "154",
    "Bcolor": "164",
    "Y": 38,
    "L": 67.3308016307982,
    "a": 15.6841182148444,
    "b": -0.36186942280831,
    "C": 15.6882922479273,
    "h": -0.02306825456488,
    "CMY_C": 0.2483453,
    "CMY_M": 0.3946364,
    "CMY_Y": 0.3576114,
    "CMYK_C": 0,
    "CMYK_M": 0.1946254,
    "CMYK_Y": 0.1453675,
    "CMYK_K": 0.2483453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00401",
    "Farbtonhilfsbezeichnung": "U0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "152",
    "Bcolor": "162",
    "Y": 32,
    "L": 62.6438093830713,
    "a": 0.00664314229686,
    "b": -6.43946863560143,
    "C": 6.43947206222949,
    "h": -1.56976469820625,
    "CMY_C": 0.4280035,
    "CMY_M": 0.4037539,
    "CMY_Y": 0.3664594,
    "CMYK_C": 0.097143,
    "CMYK_M": 0.0588668,
    "CMYK_Y": 0,
    "CMYK_K": 0.3664594
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00402",
    "Farbtonhilfsbezeichnung": "E0.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "222",
    "Y": 85,
    "L": 92.8595919563464,
    "a": 2.10236276161008,
    "b": 5.88086725930563,
    "C": 6.24536059030843,
    "h": 1.227462809246,
    "CMY_C": 0.04475702,
    "CMY_M": 0.08659217,
    "CMY_Y": 0.1309045,
    "CMYK_C": 0,
    "CMYK_M": 0.0437953,
    "CMYK_Y": 0.09018385,
    "CMYK_K": 0.04475702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00404",
    "Farbtonhilfsbezeichnung": "N0.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "179",
    "Bcolor": "161",
    "Y": 38,
    "L": 67.1721475592883,
    "a": -30.7722426060746,
    "b": 0.16760401162077,
    "C": 30.772699038463,
    "h": -0.00544654338157,
    "CMY_C": 0.6473712,
    "CMY_M": 0.2992199,
    "CMY_Y": 0.3687212,
    "CMYK_C": 0.4968053,
    "CMYK_M": 0,
    "CMYK_Y": 0.09917711,
    "CMYK_K": 0.2992199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00406",
    "Farbtonhilfsbezeichnung": "C8.40.60",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "129",
    "Bcolor": "99",
    "Y": 36,
    "L": 65.7115330362812,
    "a": 39.3051100066676,
    "b": 34.3970724500747,
    "C": 52.2307406205573,
    "h": 0.71890350116225,
    "CMY_C": 0.06570835,
    "CMY_M": 0.4922785,
    "CMY_Y": 0.6110802,
    "CMYK_C": 0,
    "CMYK_M": 0.4565707,
    "CMYK_Y": 0.5837276,
    "CMYK_K": 0.06570835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00407",
    "Farbtonhilfsbezeichnung": "F2.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "154",
    "Bcolor": "145",
    "Y": 33,
    "L": 63.8237519508505,
    "a": 0.85289929088211,
    "b": 4.59945330556522,
    "C": 4.67786360537179,
    "h": 1.38744405846816,
    "CMY_C": 0.3735616,
    "CMY_M": 0.3964176,
    "CMY_Y": 0.4300274,
    "CMYK_C": 0,
    "CMYK_M": 0.03648552,
    "CMYK_Y": 0.09013773,
    "CMYK_K": 0.3735616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00409",
    "Farbtonhilfsbezeichnung": "G4.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "229",
    "Bcolor": "214",
    "Y": 80,
    "L": 90.8660196893558,
    "a": -0.40697441751125,
    "b": 7.11016115118006,
    "C": 7.12179891405667,
    "h": -1.51362028925346,
    "CMY_C": 0.08261032,
    "CMY_M": 0.1031544,
    "CMY_Y": 0.1622826,
    "CMYK_C": 0,
    "CMYK_M": 0.02239405,
    "CMYK_Y": 0.08684673,
    "CMYK_K": 0.08261032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00412",
    "Farbtonhilfsbezeichnung": "F6.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "187",
    "Bcolor": "164",
    "Y": 52,
    "L": 76.5145344680143,
    "a": 1.70527501692397,
    "b": 12.5671692877217,
    "C": 12.6823383801884,
    "h": 1.43592721264036,
    "CMY_C": 0.2101906,
    "CMY_M": 0.266507,
    "CMY_Y": 0.3551282,
    "CMYK_C": 0,
    "CMYK_M": 0.07130376,
    "CMYK_Y": 0.1835096,
    "CMYK_K": 0.2101906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00414",
    "Farbtonhilfsbezeichnung": "H2.08.90",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "241",
    "Bcolor": "218",
    "Y": 89,
    "L": 94.8500595092773,
    "a": -3.0407772064209,
    "b": 10.5135555267334,
    "C": 10.9444589614868,
    "h": 106.131164550781,
    "CMY_C": 0.04771935939789,
    "CMY_M": 0.05317676067352,
    "CMY_Y": 0.14438432455063,
    "CMYK_C": 0,
    "CMYK_M": 0.00573087483644,
    "CMYK_Y": 0.10150890797377,
    "CMYK_K": 0.04771935939789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00417",
    "Farbtonhilfsbezeichnung": "UN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "210",
    "Bcolor": "213",
    "Y": 66,
    "L": 84.0277154350319,
    "a": 0.24729757293245,
    "b": -2.75176428736486,
    "C": 2.76285410088823,
    "h": -1.48116836536086,
    "CMY_C": 0.1858882,
    "CMY_M": 0.1775319,
    "CMY_Y": 0.164517,
    "CMYK_C": 0.02557942,
    "CMYK_M": 0.01557759,
    "CMYK_Y": 0,
    "CMYK_K": 0.164517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00419",
    "Farbtonhilfsbezeichnung": "C8.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "112",
    "Bcolor": "81",
    "Y": 26,
    "L": 57.8301264100949,
    "a": 36.290588448729,
    "b": 33.6433579388512,
    "C": 49.4861833581524,
    "h": 0.7475629295591,
    "CMY_C": 0.1767586,
    "CMY_M": 0.562508,
    "CMY_Y": 0.6816151,
    "CMYK_C": 0,
    "CMYK_M": 0.4685738,
    "CMYK_Y": 0.6132544,
    "CMYK_K": 0.1767586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00423",
    "Farbtonhilfsbezeichnung": "ON.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 79,
    "L": 92.0832138061523,
    "a": -0.48267707228661,
    "b": 0.48341482877731,
    "C": 0.68313032388687,
    "h": 134.956253051758,
    "CMY_C": 0.09130024909973,
    "CMY_M": 0.08752703666687,
    "CMY_Y": 0.09974539279938,
    "CMYK_C": 0.00413514999673,
    "CMYK_M": 0,
    "CMYK_Y": 0.01339037623256,
    "CMYK_K": 0.08752703666687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00424",
    "Farbtonhilfsbezeichnung": "F8.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "212",
    "Bcolor": "135",
    "Y": 71,
    "L": 86.5770443403673,
    "a": 3.2338974795143,
    "b": 42.2197697486695,
    "C": 42.3434416473045,
    "h": 1.49434884316765,
    "CMY_C": 0.02444031,
    "CMY_M": 0.1669729,
    "CMY_Y": 0.4705909,
    "CMYK_C": 0,
    "CMYK_M": 0.1461034,
    "CMYK_Y": 0.4573279,
    "CMYK_K": 0.02444031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00431",
    "Farbtonhilfsbezeichnung": "T0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "198",
    "Bcolor": "213",
    "Y": 52,
    "L": 78.6919174194336,
    "a": -3.56053972244263,
    "b": -11.0066261291504,
    "C": 11.5682001113892,
    "h": 252.074096679688,
    "CMY_C": 0.30719822645187,
    "CMY_M": 0.22452694177628,
    "CMY_Y": 0.16361039876938,
    "CMYK_C": 0.17167577147484,
    "CMYK_M": 0.07283273339272,
    "CMYK_Y": 0,
    "CMYK_K": 0.16361039876938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00432",
    "Farbtonhilfsbezeichnung": "T0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "168",
    "Bcolor": "182",
    "Y": 37,
    "L": 68.0684585571289,
    "a": -2.99733471870422,
    "b": -9.95917892456055,
    "C": 10.400444984436,
    "h": 253.250198364258,
    "CMY_C": 0.40997749567032,
    "CMY_M": 0.33960455656052,
    "CMY_Y": 0.28548544645309,
    "CMYK_C": 0.17423304915428,
    "CMYK_M": 0.07574249058962,
    "CMYK_Y": 0,
    "CMYK_K": 0.28548544645309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00433",
    "Farbtonhilfsbezeichnung": "C4.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "64",
    "Bcolor": "55",
    "Y": 17,
    "L": 46.9844836904746,
    "a": 52.8205632630547,
    "b": 34.7950804572287,
    "C": 63.2511622616643,
    "h": 0.58249564337626,
    "CMY_C": 0.2230986,
    "CMY_M": 0.7477302,
    "CMY_Y": 0.7827448,
    "CMYK_C": 0,
    "CMYK_M": 0.6752872,
    "CMYK_Y": 0.7203568,
    "CMYK_K": 0.2230986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00434",
    "Farbtonhilfsbezeichnung": "D6.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "125",
    "Bcolor": "91",
    "Y": 26,
    "L": 57.3577430304461,
    "a": 18.1069306520434,
    "b": 26.7324736083996,
    "C": 32.2875530640166,
    "h": 0.97544195025281,
    "CMY_C": 0.2894358,
    "CMY_M": 0.5095382,
    "CMY_Y": 0.6426883,
    "CMYK_C": 0,
    "CMYK_M": 0.3097573,
    "CMYK_Y": 0.4971437,
    "CMYK_K": 0.2894358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00435",
    "Farbtonhilfsbezeichnung": "E4.25.75",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "190",
    "Bcolor": "140",
    "Y": 59,
    "L": 80.811797846079,
    "a": 14.0642053386515,
    "b": 32.1656294771772,
    "C": 35.1059765776542,
    "h": 1.15860138189557,
    "CMY_C": 0.03808143,
    "CMY_M": 0.2554152,
    "CMY_Y": 0.4510132,
    "CMYK_C": 0,
    "CMYK_M": 0.2259378,
    "CMYK_Y": 0.4292793,
    "CMYK_K": 0.03808143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00437",
    "Farbtonhilfsbezeichnung": "D2.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "184",
    "Bcolor": "168",
    "Y": 53,
    "L": 77.4998626708984,
    "a": 11.4518527984619,
    "b": 12.4891805648804,
    "C": 16.9447498321533,
    "h": 47.4809837341309,
    "CMY_C": 0.13225615024567,
    "CMY_M": 0.27974879741669,
    "CMY_Y": 0.34269607067108,
    "CMYK_C": 0,
    "CMYK_M": 0.16997256875038,
    "CMYK_Y": 0.24251386523247,
    "CMYK_K": 0.13225615024567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00438",
    "Farbtonhilfsbezeichnung": "G8.10.85",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "229",
    "Bcolor": "200",
    "Y": 80,
    "L": 90.9063479181988,
    "a": -2.01194401911681,
    "b": 14.5338475751587,
    "C": 14.6724450612025,
    "h": -1.4332389491852,
    "CMY_C": 0.07245524,
    "CMY_M": 0.1008104,
    "CMY_Y": 0.217223,
    "CMYK_C": 0,
    "CMYK_M": 0.0305701,
    "CMYK_Y": 0.1560763,
    "CMYK_K": 0.07245524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00439",
    "Farbtonhilfsbezeichnung": "F6.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "161",
    "Bcolor": "107",
    "Y": 38,
    "L": 67.5276505401332,
    "a": 3.18844411138469,
    "b": 31.2793288117693,
    "C": 31.4414151520921,
    "h": 1.46921265359004,
    "CMY_C": 0.2593316,
    "CMY_M": 0.3688673,
    "CMY_Y": 0.580151,
    "CMYK_C": 0,
    "CMYK_M": 0.1478877,
    "CMYK_Y": 0.4331485,
    "CMYK_K": 0.2593316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00440",
    "Farbtonhilfsbezeichnung": "N0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "150",
    "Bcolor": "129",
    "Y": 25,
    "L": 55.3455133793346,
    "a": -38.6282694558868,
    "b": 0.61568430937604,
    "C": 38.6331757473471,
    "h": -0.01593734820167,
    "CMY_C": 1,
    "CMY_M": 0.4128453,
    "CMY_Y": 0.4928758,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1363022,
    "CMYK_K": 0.4128453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00441",
    "Farbtonhilfsbezeichnung": "C0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "175",
    "Bcolor": "164",
    "Y": 53,
    "L": 78.3144302368164,
    "a": 26.2184467315674,
    "b": 15.8004055023193,
    "C": 30.6114311218262,
    "h": 31.0750427246094,
    "CMY_C": 0.02045339345932,
    "CMY_M": 0.31260126829147,
    "CMY_Y": 0.35532128810883,
    "CMYK_C": 0,
    "CMYK_M": 0.29824805259705,
    "CMYK_Y": 0.34186008572578,
    "CMYK_K": 0.02045339345932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00445",
    "Farbtonhilfsbezeichnung": "D6.25.70",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "178",
    "Bcolor": "140",
    "Y": 55,
    "L": 78.2350004976568,
    "a": 20.5193184801729,
    "b": 28.5614732130645,
    "C": 35.1681700261951,
    "h": 0.94781035286323,
    "CMY_C": 0.03375821,
    "CMY_M": 0.3000098,
    "CMY_Y": 0.4493867,
    "CMYK_C": 0,
    "CMYK_M": 0.2755538,
    "CMYK_Y": 0.4301496,
    "CMYK_K": 0.03375821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00446",
    "Farbtonhilfsbezeichnung": "E0.25.75",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "189",
    "Bcolor": "145",
    "Y": 61,
    "L": 81.1688613891602,
    "a": 17.1976165771484,
    "b": 30.2296333312988,
    "C": 34.7791442871094,
    "h": 60.3644828796387,
    "CMY_C": 0.01735329627991,
    "CMY_M": 0.25957542657852,
    "CMY_Y": 0.43233960866928,
    "CMYK_C": 0,
    "CMYK_M": 0.24649971723557,
    "CMYK_Y": 0.42231488227844,
    "CMYK_K": 0.01735329627991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00448",
    "Farbtonhilfsbezeichnung": "E0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "212",
    "Bcolor": "194",
    "Y": 71,
    "L": 86.7914886474609,
    "a": 6.80353784561157,
    "b": 11.8411302566528,
    "C": 13.6565179824829,
    "h": 60.1196937561035,
    "CMY_C": 0.06151419878006,
    "CMY_M": 0.16698640584946,
    "CMY_Y": 0.24023306369781,
    "CMYK_C": 0,
    "CMYK_M": 0.11238551139832,
    "CMYK_Y": 0.19043320417404,
    "CMYK_K": 0.06151419878006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00450",
    "Farbtonhilfsbezeichnung": "T0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "119",
    "Bcolor": "152",
    "Y": 18,
    "L": 47.9999007024505,
    "a": -6.2709088129454,
    "b": -23.5141109672974,
    "C": 24.3359345808344,
    "h": 1.31017490801097,
    "CMY_C": 0.7215262,
    "CMY_M": 0.5334389,
    "CMY_Y": 0.4038547,
    "CMYK_C": 0.532876,
    "CMYK_M": 0.2173701,
    "CMYK_Y": 0,
    "CMYK_K": 0.4038547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00451",
    "Farbtonhilfsbezeichnung": "E8.35.75",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "187",
    "Bcolor": "119",
    "Y": 59,
    "L": 80.3571903500123,
    "a": 15.6698069439721,
    "b": 42.7767648524928,
    "C": 45.5564974609201,
    "h": 1.21966080947472,
    "CMY_C": 0.0171962,
    "CMY_M": 0.2665496,
    "CMY_Y": 0.5350464,
    "CMYK_C": 0,
    "CMYK_M": 0.2537163,
    "CMYK_Y": 0.5269111,
    "CMYK_K": 0.0171962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00452",
    "Farbtonhilfsbezeichnung": "D2.30.70",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "166",
    "Bcolor": "134",
    "Y": 49,
    "L": 75.3004684448242,
    "a": 26.2436294555664,
    "b": 28.3066387176514,
    "C": 38.6004371643066,
    "h": 47.1658096313477,
    "CMY_C": 0.03383010625839,
    "CMY_M": 0.34775811433792,
    "CMY_Y": 0.47603368759155,
    "CMYK_C": 0,
    "CMYK_M": 0.32492008805275,
    "CMYK_Y": 0.45768719911575,
    "CMYK_K": 0.03383010625839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00455",
    "Farbtonhilfsbezeichnung": "F8.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "217",
    "Bcolor": "175",
    "Y": 73,
    "L": 87.5625674197391,
    "a": 1.06597007074477,
    "b": 22.6299107946577,
    "C": 22.6550028639567,
    "h": 1.52372664429973,
    "CMY_C": 0.06684612,
    "CMY_M": 0.147069,
    "CMY_Y": 0.3126691,
    "CMYK_C": 0,
    "CMYK_M": 0.0859696,
    "CMYK_Y": 0.2634324,
    "CMYK_K": 0.06684612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00456",
    "Farbtonhilfsbezeichnung": "F8.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "217",
    "Bcolor": "168",
    "Y": 73,
    "L": 87.4276449447884,
    "a": 1.55493353748637,
    "b": 26.4050067843913,
    "C": 26.4507504919945,
    "h": 1.51197642595621,
    "CMY_C": 0.05634741,
    "CMY_M": 0.1505441,
    "CMY_Y": 0.3421335,
    "CMYK_C": 0,
    "CMYK_M": 0.0998214,
    "CMYK_Y": 0.3028509,
    "CMYK_K": 0.05634741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00461",
    "Farbtonhilfsbezeichnung": "C8.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "135",
    "Bcolor": "114",
    "Y": 32,
    "L": 62.3679590734327,
    "a": 23.2929081484292,
    "b": 20.884562192607,
    "C": 31.2845730031277,
    "h": 0.73093681953966,
    "CMY_C": 0.2121142,
    "CMY_M": 0.4722229,
    "CMY_Y": 0.5528762,
    "CMYK_C": 0,
    "CMYK_M": 0.3301351,
    "CMYK_Y": 0.4325018,
    "CMYK_K": 0.2121142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00462",
    "Farbtonhilfsbezeichnung": "H2.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "198",
    "Y": 74,
    "L": 88.1733430046762,
    "a": -2.61115355336905,
    "b": 11.6037322478529,
    "C": 11.8938944403897,
    "h": -1.3494561448541,
    "CMY_C": 0.1159783,
    "CMY_M": 0.1290617,
    "CMY_Y": 0.2251045,
    "CMYK_C": 0,
    "CMYK_M": 0.01479991,
    "CMYK_Y": 0.123443,
    "CMYK_K": 0.1159783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00463",
    "Farbtonhilfsbezeichnung": "G8.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "140",
    "Bcolor": "123",
    "Y": 27,
    "L": 58.1686384322668,
    "a": -1.59194667886942,
    "b": 9.10424888891797,
    "C": 9.24238292107222,
    "h": -1.39768887827485,
    "CMY_C": 0.4367768,
    "CMY_M": 0.4501954,
    "CMY_Y": 0.5179256,
    "CMYK_C": 0,
    "CMYK_M": 0.02382476,
    "CMYK_Y": 0.1440794,
    "CMYK_K": 0.4367768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00464",
    "Farbtonhilfsbezeichnung": "E8.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "195",
    "Bcolor": "164",
    "Y": 59,
    "L": 80.4905960493469,
    "a": 6.45543771904233,
    "b": 18.6695868935455,
    "C": 19.7541426268031,
    "h": 1.23789222540812,
    "CMY_C": 0.1182636,
    "CMY_M": 0.2365202,
    "CMY_Y": 0.3569104,
    "CMYK_C": 0,
    "CMYK_M": 0.1341179,
    "CMYK_Y": 0.2706556,
    "CMYK_K": 0.1182636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00466",
    "Farbtonhilfsbezeichnung": "S0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "211",
    "Bcolor": "218",
    "Y": 66,
    "L": 83.51788283895,
    "a": -4.53722063301387,
    "b": -6.01550696844098,
    "C": 7.53476576676467,
    "h": 0.9245781659831,
    "CMY_C": 0.2427704,
    "CMY_M": 0.1712262,
    "CMY_Y": 0.1469622,
    "CMYK_C": 0.1123142,
    "CMYK_M": 0.02844428,
    "CMYK_Y": 0,
    "CMYK_K": 0.1469622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00467",
    "Farbtonhilfsbezeichnung": "T0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "81",
    "Bcolor": "103",
    "Y": 7,
    "L": 33.3110733032227,
    "a": -3.82123041152954,
    "b": -16.1375293731689,
    "C": 16.583776473999,
    "h": 256.67822265625,
    "CMY_C": 0.79030293226242,
    "CMY_M": 0.68095058202744,
    "CMY_Y": 0.59708070755005,
    "CMYK_C": 0.47955566644669,
    "CMYK_M": 0.20815551280975,
    "CMYK_Y": 0,
    "CMYK_K": 0.59708070755005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00468",
    "Farbtonhilfsbezeichnung": "T0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "95",
    "Bcolor": "122",
    "Y": 11,
    "L": 38.4448808564756,
    "a": -5.562238614328,
    "b": -20.036959302991,
    "C": 20.7946684636336,
    "h": 1.30001551343172,
    "CMY_C": 0.7854068,
    "CMY_M": 0.6284609,
    "CMY_Y": 0.52282,
    "CMYK_C": 0.5502887,
    "CMYK_M": 0.2213858,
    "CMYK_Y": 0,
    "CMYK_K": 0.52282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00474",
    "Farbtonhilfsbezeichnung": "B2.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "207",
    "Bcolor": "207",
    "Y": 68,
    "L": 86.6366882324219,
    "a": 15.6338911056519,
    "b": 4.51683902740479,
    "C": 16.2733020782471,
    "h": 16.114709854126,
    "CMY_C": 0.02041101455688,
    "CMY_M": 0.18955010175705,
    "CMY_Y": 0.18688523769379,
    "CMYK_C": 0,
    "CMYK_M": 0.17266331613064,
    "CMYK_Y": 0.16994293034077,
    "CMYK_K": 0.02041101455688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00475",
    "Farbtonhilfsbezeichnung": "B6.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "225",
    "Bcolor": "219",
    "Y": 78,
    "L": 91.0429611206055,
    "a": 7.29185247421265,
    "b": 4.44723176956177,
    "C": 8.54101753234863,
    "h": 31.3786201477051,
    "CMY_C": 0.03054964542389,
    "CMY_M": 0.11923509836197,
    "CMY_Y": 0.13947653770447,
    "CMYK_C": 0,
    "CMYK_M": 0.09148013591766,
    "CMYK_Y": 0.11235943436623,
    "CMYK_K": 0.03054964542389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00476",
    "Farbtonhilfsbezeichnung": "H2.03.90",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "244",
    "Bcolor": "229",
    "Y": 88,
    "L": 95.8569717407227,
    "a": -1.18870627880096,
    "b": 6.13855791091919,
    "C": 6.25259256362915,
    "h": 100.959442138672,
    "CMY_C": 0.03561896085739,
    "CMY_M": 0.04505604505539,
    "CMY_Y": 0.10020679235458,
    "CMYK_C": 0,
    "CMYK_M": 0.00978563819081,
    "CMYK_Y": 0.06697335094213,
    "CMYK_K": 0.03561896085739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00477",
    "Farbtonhilfsbezeichnung": "N0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "198",
    "Bcolor": "184",
    "Y": 51,
    "L": 75.6697019913433,
    "a": -22.3981612198004,
    "b": 0.38316979350723,
    "C": 22.4014384609299,
    "h": -0.01710553010572,
    "CMY_C": 0.4609182,
    "CMY_M": 0.2221275,
    "CMY_Y": 0.2800756,
    "CMYK_C": 0.3069792,
    "CMYK_M": 0,
    "CMYK_Y": 0.07449564,
    "CMYK_K": 0.2221275
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00478",
    "Farbtonhilfsbezeichnung": "G0.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "217",
    "Bcolor": "163",
    "Y": 72,
    "L": 87.2335302410746,
    "a": 0.14458013722296,
    "b": 28.6606367996133,
    "C": 28.6610014684663,
    "h": 1.56575181533305,
    "CMY_C": 0.06354219,
    "CMY_M": 0.1497741,
    "CMY_Y": 0.361329,
    "CMYK_C": 0,
    "CMYK_M": 0.09208308,
    "CMYK_Y": 0.3179928,
    "CMYK_K": 0.06354219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00479",
    "Farbtonhilfsbezeichnung": "D6.30.70",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "169",
    "Bcolor": "128",
    "Y": 50,
    "L": 75.583299497604,
    "a": 23.6876199042925,
    "b": 31.8702415074579,
    "C": 39.7091378711994,
    "h": 0.93162796176207,
    "CMY_C": 0.04042976,
    "CMY_M": 0.3380149,
    "CMY_Y": 0.4996337,
    "CMYK_C": 0,
    "CMYK_M": 0.3101234,
    "CMYK_Y": 0.4785517,
    "CMYK_K": 0.04042976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00480",
    "Farbtonhilfsbezeichnung": "B2.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "145",
    "Bcolor": "146",
    "Y": 37,
    "L": 66.9398454896185,
    "a": 26.1125871457479,
    "b": 9.67217737296953,
    "C": 27.8463323002952,
    "h": 0.35473423608372,
    "CMY_C": 0.1637213,
    "CMY_M": 0.4306654,
    "CMY_Y": 0.4294036,
    "CMYK_C": 0,
    "CMYK_M": 0.3192047,
    "CMYK_Y": 0.3176959,
    "CMYK_K": 0.1637213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00482",
    "Farbtonhilfsbezeichnung": "T0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "166",
    "Bcolor": "194",
    "Y": 37,
    "L": 66.1754299846532,
    "a": -5.94416597855574,
    "b": -19.6204049543242,
    "C": 20.5010585032161,
    "h": 1.27662764265851,
    "CMY_C": 0.5032572,
    "CMY_M": 0.3501955,
    "CMY_Y": 0.2386819,
    "CMYK_C": 0.3475226,
    "CMYK_M": 0.1464745,
    "CMYK_Y": 0,
    "CMYK_K": 0.2386819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00483",
    "Farbtonhilfsbezeichnung": "FN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "224",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.4465255737305,
    "a": 0.98807632923126,
    "b": 4.00719118118286,
    "C": 4.12721157073975,
    "h": 76.1485595703125,
    "CMY_C": 0.09748899936676,
    "CMY_M": 0.12138652801514,
    "CMY_Y": 0.15466398000717,
    "CMYK_C": 0,
    "CMYK_M": 0.02647893317044,
    "CMYK_Y": 0.06335100531578,
    "CMYK_K": 0.09748899936676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00484",
    "Farbtonhilfsbezeichnung": "D6.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "174",
    "Y": 62,
    "L": 82.4100471369808,
    "a": 11.5472213214762,
    "b": 16.3352470357028,
    "C": 20.0044649007313,
    "h": 0.95546121310195,
    "CMY_C": 0.06730224,
    "CMY_M": 0.228053,
    "CMY_Y": 0.3189056,
    "CMYK_C": 0,
    "CMYK_M": 0.1723504,
    "CMYK_Y": 0.2697587,
    "CMYK_K": 0.06730224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00486",
    "Farbtonhilfsbezeichnung": "C8.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "98",
    "Bcolor": "79",
    "Y": 18,
    "L": 48.1479873336195,
    "a": 23.9625195590362,
    "b": 21.3515971747835,
    "C": 32.095062634795,
    "h": 0.72784349815081,
    "CMY_C": 0.3663751,
    "CMY_M": 0.6161903,
    "CMY_Y": 0.6910535,
    "CMYK_C": 0,
    "CMYK_M": 0.3942634,
    "CMYK_Y": 0.5124142,
    "CMYK_K": 0.3663751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00487",
    "Farbtonhilfsbezeichnung": "S0.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "219",
    "Bcolor": "230",
    "Y": 69,
    "L": 85.4937013456275,
    "a": -7.3970665097528,
    "b": -9.87873468776355,
    "C": 12.3412313802525,
    "h": 0.92807209394898,
    "CMY_C": 0.2625964,
    "CMY_M": 0.1419505,
    "CMY_Y": 0.09732527,
    "CMYK_C": 0.1830905,
    "CMYK_M": 0.04943663,
    "CMYK_Y": 0,
    "CMYK_K": 0.09732527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00488",
    "Farbtonhilfsbezeichnung": "E8.20.75",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "201",
    "Bcolor": "157",
    "Y": 64,
    "L": 83.4169006347656,
    "a": 8.0710391998291,
    "b": 26.7717018127441,
    "C": 27.9618606567383,
    "h": 73.2231750488281,
    "CMY_C": 0.05687421560287,
    "CMY_M": 0.21054637432098,
    "CMY_Y": 0.38551354408264,
    "CMYK_C": 0,
    "CMYK_M": 0.16293919086456,
    "CMYK_Y": 0.34845757484436,
    "CMYK_K": 0.05687421560287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00489",
    "Farbtonhilfsbezeichnung": "D2.40.60",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "141",
    "Bcolor": "99",
    "Y": 38,
    "L": 67.7318521403135,
    "a": 32.1826710248279,
    "b": 36.8281648750042,
    "C": 48.9084659578767,
    "h": 0.85261218846549,
    "CMY_C": 0.07796814,
    "CMY_M": 0.4474679,
    "CMY_Y": 0.6110602,
    "CMYK_C": 0,
    "CMYK_M": 0.4007451,
    "CMYK_Y": 0.578171,
    "CMYK_K": 0.07796814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00490",
    "Farbtonhilfsbezeichnung": "K2.20.80",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "224",
    "Bcolor": "175",
    "Y": 69,
    "L": 85.4471425241909,
    "a": -20.9030409522819,
    "b": 19.1132675462677,
    "C": 28.3240907594222,
    "h": -0.74070185161156,
    "CMY_C": 0.2691944,
    "CMY_M": 0.1216641,
    "CMY_Y": 0.3126604,
    "CMYK_C": 0.1679657,
    "CMYK_M": 0,
    "CMYK_Y": 0.2174525,
    "CMYK_K": 0.1216641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00491",
    "Farbtonhilfsbezeichnung": "G0.45.80",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "215",
    "Bcolor": "101",
    "Y": 74,
    "L": 87.3158263653166,
    "a": 0.82453066106269,
    "b": 59.6132097608916,
    "C": 59.6189116707702,
    "h": 1.55696586721754,
    "CMY_C": 0.006440942,
    "CMY_M": 0.1556001,
    "CMY_Y": 0.6049759,
    "CMYK_C": 0,
    "CMYK_M": 0.1501261,
    "CMYK_Y": 0.602415,
    "CMYK_K": 0.006440942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00493",
    "Farbtonhilfsbezeichnung": "PN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "214",
    "Bcolor": "211",
    "Y": 66,
    "L": 84.7517013549805,
    "a": -3.93790793418884,
    "b": -0.64890348911285,
    "C": 3.99101424217224,
    "h": 189.357330322266,
    "CMY_C": 0.20395082235336,
    "CMY_M": 0.16053849458694,
    "CMY_Y": 0.17248958349228,
    "CMYK_C": 0.05171449482441,
    "CMYK_M": 0,
    "CMYK_Y": 0.01423661317676,
    "CMYK_K": 0.16053849458694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00495",
    "Farbtonhilfsbezeichnung": "G0.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "191",
    "Bcolor": "179",
    "Y": 53,
    "L": 77.5274887084961,
    "a": 0.21261900663376,
    "b": 5.98371934890747,
    "C": 5.98749542236328,
    "h": 87.9649658203125,
    "CMY_C": 0.2283548116684,
    "CMY_M": 0.25048524141312,
    "CMY_Y": 0.29752314090729,
    "CMYK_C": 0,
    "CMYK_M": 0.02867954038084,
    "CMYK_Y": 0.08963748067617,
    "CMYK_K": 0.2283548116684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00496",
    "Farbtonhilfsbezeichnung": "P0.03.60",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "167",
    "Bcolor": "165",
    "Y": 39,
    "L": 67.9363803521722,
    "a": -3.02975287340196,
    "b": -0.56344697661974,
    "C": 3.08170001287428,
    "h": 0.18387072699922,
    "CMY_C": 0.3757759,
    "CMY_M": 0.3436316,
    "CMY_Y": 0.3523969,
    "CMYK_C": 0.04897296,
    "CMYK_M": 0,
    "CMYK_Y": 0.01335429,
    "CMYK_K": 0.3436316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00497",
    "Farbtonhilfsbezeichnung": "E4.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "207",
    "Bcolor": "191",
    "Y": 66,
    "L": 84.1751098632813,
    "a": 4.2962327003479,
    "b": 9.4038782119751,
    "C": 10.3387880325317,
    "h": 65.4463500976563,
    "CMY_C": 0.11549180746078,
    "CMY_M": 0.18887293338776,
    "CMY_Y": 0.25086241960526,
    "CMYK_C": 0,
    "CMYK_M": 0.08296263217926,
    "CMYK_Y": 0.15304619073868,
    "CMYK_K": 0.11549180746078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00499",
    "Farbtonhilfsbezeichnung": "L8.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "171",
    "Bcolor": "159",
    "Y": 39,
    "L": 68.0286509744029,
    "a": -10.3317707191187,
    "b": 2.87648863443071,
    "C": 10.7247225165245,
    "h": -0.27153551652152,
    "CMY_C": 0.4206802,
    "CMY_M": 0.3282646,
    "CMY_Y": 0.3763843,
    "CMYK_C": 0.1375774,
    "CMYK_M": 0,
    "CMYK_Y": 0.07163499,
    "CMYK_K": 0.3282646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00500",
    "Farbtonhilfsbezeichnung": "J0.04.88",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "243",
    "Bcolor": "228",
    "Y": 88,
    "L": 95.1927032470703,
    "a": -3.51557326316833,
    "b": 5.96487379074097,
    "C": 6.92379760742188,
    "h": 120.514221191406,
    "CMY_C": 0.06211525201797,
    "CMY_M": 0.0470050573349,
    "CMY_Y": 0.10660529136658,
    "CMYK_C": 0.01585548184812,
    "CMYK_M": 0,
    "CMYK_Y": 0.06253992766142,
    "CMYK_K": 0.0470050573349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00502",
    "Farbtonhilfsbezeichnung": "C0.40.60",
    "Farbtonklasse": "02",
    "Y": 33,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00503",
    "Farbtonhilfsbezeichnung": "J0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "121",
    "Bcolor": "54",
    "Y": 18,
    "L": 48.0585883833505,
    "a": -18.5569076807811,
    "b": 33.6189346679895,
    "C": 38.4004113374268,
    "h": -1.06643587211366,
    "CMY_C": 0.6030433,
    "CMY_M": 0.5235913,
    "CMY_Y": 0.7874432,
    "CMYK_C": 0.1667727,
    "CMYK_M": 0,
    "CMYK_Y": 0.5538353,
    "CMYK_K": 0.5235913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00504",
    "Farbtonhilfsbezeichnung": "K2.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "102",
    "Bcolor": "73",
    "Y": 12,
    "L": 40.4378750829898,
    "a": -15.3203424465761,
    "b": 13.2458032681645,
    "C": 20.2525108788831,
    "h": -0.71290313176944,
    "CMY_C": 0.6977587,
    "CMY_M": 0.600818,
    "CMY_Y": 0.7156606,
    "CMYK_C": 0.2428485,
    "CMYK_M": 0,
    "CMYK_Y": 0.2876948,
    "CMYK_K": 0.600818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00506",
    "Farbtonhilfsbezeichnung": "N0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "120",
    "Bcolor": "112",
    "Y": 18,
    "L": 47.3694912790285,
    "a": -16.4901318623716,
    "b": -0.41034408839333,
    "C": 16.4952366187722,
    "h": 0.02487908677176,
    "CMY_C": 0.6930599,
    "CMY_M": 0.5281478,
    "CMY_Y": 0.5622424,
    "CMYK_C": 0.3494994,
    "CMYK_M": 0,
    "CMYK_Y": 0.0722572,
    "CMYK_K": 0.5281478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00511",
    "Farbtonhilfsbezeichnung": "SN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "184",
    "Bcolor": "186",
    "Y": 48,
    "L": 74.4758911132813,
    "a": -1.16141319274902,
    "b": -2.61190128326416,
    "C": 2.85848021507263,
    "h": 246.027099609375,
    "CMY_C": 0.29954034090042,
    "CMY_M": 0.2777972817421,
    "CMY_Y": 0.26881283521652,
    "CMYK_C": 0.04202413186431,
    "CMYK_M": 0.012287478894,
    "CMYK_Y": 0,
    "CMYK_K": 0.26881283521652
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00512",
    "Farbtonhilfsbezeichnung": "FN.02.17",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "66",
    "Bcolor": "64",
    "Y": 6,
    "L": 28.2517095149555,
    "a": 0.46533469352788,
    "b": 1.43103519215618,
    "C": 1.5047917125603,
    "h": 1.25640752892775,
    "CMY_C": 0.7319171,
    "CMY_M": 0.7397051,
    "CMY_Y": 0.7493986,
    "CMYK_C": 0,
    "CMYK_M": 0.0290507,
    "CMYK_Y": 0.06520945,
    "CMYK_K": 0.7319171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00515",
    "Farbtonhilfsbezeichnung": "D2.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "151",
    "Bcolor": "126",
    "Y": 38,
    "L": 67.0868604457451,
    "a": 17.9069139418711,
    "b": 20.7620623063087,
    "C": 27.4175272067454,
    "h": 0.85910005766001,
    "CMY_C": 0.190997,
    "CMY_M": 0.4085138,
    "CMY_Y": 0.50651,
    "CMYK_C": 0,
    "CMYK_M": 0.2688702,
    "CMYK_Y": 0.3900023,
    "CMYK_K": 0.190997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00516",
    "Farbtonhilfsbezeichnung": "D2.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "101",
    "Bcolor": "84",
    "Y": 17,
    "L": 46.7105304964618,
    "a": 14.4191434973297,
    "b": 15.9590068412762,
    "C": 21.5081751563559,
    "h": 0.83604464728108,
    "CMY_C": 0.4416227,
    "CMY_M": 0.6025681,
    "CMY_Y": 0.6708599,
    "CMYK_C": 0,
    "CMYK_M": 0.2882377,
    "CMYK_Y": 0.4105417,
    "CMYK_K": 0.4416227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00522",
    "Farbtonhilfsbezeichnung": "V0.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "217",
    "Bcolor": "230",
    "Y": 72,
    "L": 86.7646803141986,
    "a": 1.6675559495774,
    "b": -7.56481054416056,
    "C": 7.7464250731556,
    "h": -1.35383026719388,
    "CMY_C": 0.1621841,
    "CMY_M": 0.1493248,
    "CMY_Y": 0.09906543,
    "CMYK_C": 0.07005911,
    "CMYK_M": 0.05578578,
    "CMYK_Y": 0,
    "CMYK_K": 0.09906543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00523",
    "Farbtonhilfsbezeichnung": "D6.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "159",
    "Bcolor": "144",
    "Y": 38,
    "L": 67.5108582533343,
    "a": 7.82552820464899,
    "b": 10.8495029457074,
    "C": 13.377242086868,
    "h": 0.94593087034793,
    "CMY_C": 0.2703256,
    "CMY_M": 0.375906,
    "CMY_Y": 0.4347698,
    "CMYK_C": 0,
    "CMYK_M": 0.1446952,
    "CMYK_Y": 0.2253665,
    "CMYK_K": 0.2703256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00526",
    "Farbtonhilfsbezeichnung": "EN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "237",
    "Bcolor": "228",
    "Y": 86,
    "L": 94.1791076660156,
    "a": 1.5322093963623,
    "b": 4.33506870269775,
    "C": 4.59787845611572,
    "h": 70.5342864990234,
    "CMY_C": 0.03911209106445,
    "CMY_M": 0.06996804475784,
    "CMY_Y": 0.10490465164185,
    "CMYK_C": 0,
    "CMYK_M": 0.03211191669106,
    "CMYK_Y": 0.06847058981657,
    "CMYK_K": 0.03911209106445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00529",
    "Farbtonhilfsbezeichnung": "E4.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "98",
    "Bcolor": "82",
    "Y": 16,
    "L": 43.0625975978658,
    "a": 5.23197176216622,
    "b": 11.7070979009597,
    "C": 12.8230132879429,
    "h": 1.15051838837917,
    "CMY_C": 0.5395922,
    "CMY_M": 0.6147367,
    "CMY_Y": 0.6786339,
    "CMYK_C": 0,
    "CMYK_M": 0.1632128,
    "CMYK_Y": 0.3019968,
    "CMYK_K": 0.5395922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00531",
    "Farbtonhilfsbezeichnung": "G0.30.80",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "214",
    "Bcolor": "138",
    "Y": 69,
    "L": 86.4743576049805,
    "a": 0.55363285541534,
    "b": 40.6712417602539,
    "C": 40.6750106811523,
    "h": 89.2201156616211,
    "CMY_C": 0.04619455337524,
    "CMY_M": 0.16130793094635,
    "CMY_Y": 0.46033829450607,
    "CMYK_C": 0,
    "CMYK_M": 0.12068852782249,
    "CMYK_Y": 0.43420147895813,
    "CMYK_K": 0.04619455337524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00534",
    "Farbtonhilfsbezeichnung": "A0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "130",
    "Bcolor": "139",
    "Y": 26,
    "L": 57.4881640285923,
    "a": 13.4811557664633,
    "b": -0.66079235412945,
    "C": 13.4973407504931,
    "h": -0.04897680343649,
    "CMY_C": 0.3687743,
    "CMY_M": 0.4896639,
    "CMY_Y": 0.4567636,
    "CMYK_C": 0,
    "CMYK_M": 0.1915156,
    "CMYK_Y": 0.1393943,
    "CMYK_K": 0.3687743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00537",
    "Farbtonhilfsbezeichnung": "FN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "211",
    "Bcolor": "202",
    "Y": 63,
    "L": 84.4827194213867,
    "a": 0.05584673583508,
    "b": 3.6736204624176,
    "C": 3.6740448474884,
    "h": 89.1290512084961,
    "CMY_C": 0.16072100400925,
    "CMY_M": 0.17387616634369,
    "CMY_Y": 0.20639580488205,
    "CMYK_C": 0,
    "CMYK_M": 0.0156743619591,
    "CMYK_Y": 0.0544214732945,
    "CMYK_K": 0.16072100400925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00542",
    "Farbtonhilfsbezeichnung": "U0.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "151",
    "Bcolor": "178",
    "Y": 31,
    "L": 61.8643173314984,
    "a": -0.45487067086641,
    "b": -16.7847688450697,
    "C": 16.7909312579629,
    "h": 1.54370275353398,
    "CMY_C": 0.4829838,
    "CMY_M": 0.4075715,
    "CMY_Y": 0.3037545,
    "CMYK_C": 0.2574226,
    "CMYK_M": 0.1491098,
    "CMYK_Y": 0,
    "CMYK_K": 0.3037545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00543",
    "Farbtonhilfsbezeichnung": "G0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "227",
    "Bcolor": "208",
    "Y": 80,
    "L": 90.3940276032413,
    "a": 0.09789490759809,
    "b": 9.18918069915724,
    "C": 9.18970213525431,
    "h": 1.56014345059039,
    "CMY_C": 0.07771899,
    "CMY_M": 0.1101567,
    "CMY_Y": 0.1827635,
    "CMYK_C": 0,
    "CMYK_M": 0.03517118,
    "CMYK_Y": 0.1138964,
    "CMYK_K": 0.07771899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00547",
    "Farbtonhilfsbezeichnung": "ON.00.64",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "178",
    "Bcolor": "177",
    "Y": 44,
    "L": 72.5305252075195,
    "a": -0.06621860712767,
    "b": -0.22927324473858,
    "C": 0.23864434659481,
    "h": 253.890243530273,
    "CMY_C": 0.30361926555634,
    "CMY_M": 0.30168282985687,
    "CMY_Y": 0.30617386102676,
    "CMYK_C": 0.00277300318703,
    "CMYK_M": 0,
    "CMYK_Y": 0.00643121963367,
    "CMYK_K": 0.30168282985687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00551",
    "Farbtonhilfsbezeichnung": "L8.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "233",
    "Bcolor": "219",
    "Y": 80,
    "L": 90.6220901313967,
    "a": -7.88275665793664,
    "b": 3.9144018531962,
    "C": 8.80115869624848,
    "h": -0.46090609228632,
    "CMY_C": 0.1555095,
    "CMY_M": 0.087814,
    "CMY_Y": 0.1423432,
    "CMYK_C": 0.07421238,
    "CMYK_M": 0,
    "CMYK_Y": 0.05977861,
    "CMYK_K": 0.087814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00552",
    "Farbtonhilfsbezeichnung": "L8.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "200",
    "Bcolor": "171",
    "Y": 52,
    "L": 76.0414991517482,
    "a": -24.6849999947738,
    "b": 7.7814614675441,
    "C": 25.8824335662792,
    "h": -0.30537037781101,
    "CMY_C": 0.4454717,
    "CMY_M": 0.2156062,
    "CMY_Y": 0.3295086,
    "CMYK_C": 0.2930486,
    "CMYK_M": 0,
    "CMYK_Y": 0.1452108,
    "CMYK_K": 0.2156062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00556",
    "Farbtonhilfsbezeichnung": "E4.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "207",
    "Bcolor": "167",
    "Y": 70,
    "L": 86.0070781033185,
    "a": 10.5867648064409,
    "b": 24.8499625251684,
    "C": 27.0111130198141,
    "h": 1.16805578827954,
    "CMY_C": 0.01412047,
    "CMY_M": 0.1883485,
    "CMY_Y": 0.3437393,
    "CMYK_C": 0,
    "CMYK_M": 0.1767234,
    "CMYK_Y": 0.3343399,
    "CMYK_K": 0.01412047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00563",
    "Farbtonhilfsbezeichnung": "L8.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "220",
    "Bcolor": "201",
    "Y": 68,
    "L": 84.9219027556416,
    "a": -14.287832864205,
    "b": 5.02297472393316,
    "C": 15.1450468151382,
    "h": -0.33806042214096,
    "CMY_C": 0.2676685,
    "CMY_M": 0.1377125,
    "CMY_Y": 0.2134969,
    "CMYK_C": 0.1507107,
    "CMYK_M": 0,
    "CMYK_Y": 0.08788763,
    "CMYK_K": 0.1377125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00564",
    "Farbtonhilfsbezeichnung": "Q0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "198",
    "Bcolor": "207",
    "Y": 51,
    "L": 76.1688690185547,
    "a": -17.5321998596191,
    "b": -11.4985790252685,
    "C": 20.9665298461914,
    "h": 213.259063720703,
    "CMY_C": 0.46887224912643,
    "CMY_M": 0.22271245718002,
    "CMY_Y": 0.18913626670837,
    "CMYK_C": 0.34498518705368,
    "CMYK_M": 0.04140793159604,
    "CMYK_Y": 0,
    "CMYK_K": 0.18913626670837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00565",
    "Farbtonhilfsbezeichnung": "EN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "238",
    "Bcolor": "230",
    "Y": 86,
    "L": 94.309944152832,
    "a": 1.29643285274506,
    "b": 3.39978528022766,
    "C": 3.63858199119568,
    "h": 69.1267623901367,
    "CMY_C": 0.04249233007431,
    "CMY_M": 0.06766772270203,
    "CMY_Y": 0.09651172161102,
    "CMYK_C": 0,
    "CMYK_M": 0.02629262767732,
    "CMYK_Y": 0.05641666799784,
    "CMYK_K": 0.04249233007431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00567",
    "Farbtonhilfsbezeichnung": "CN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "181",
    "Bcolor": "178",
    "Y": 47,
    "L": 74.4254302978516,
    "a": 3.02493762969971,
    "b": 1.80896520614624,
    "C": 3.52457118034363,
    "h": 30.8801555633545,
    "CMY_C": 0.25376754999161,
    "CMY_M": 0.28916937112808,
    "CMY_Y": 0.30016779899597,
    "CMYK_C": 0,
    "CMYK_M": 0.04744074121118,
    "CMYK_Y": 0.06217934936285,
    "CMYK_K": 0.25376754999161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00568",
    "Farbtonhilfsbezeichnung": "D6.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "211",
    "Bcolor": "202",
    "Y": 67,
    "L": 85.4571762084961,
    "a": 4.08395910263062,
    "b": 5.43580484390259,
    "C": 6.79902172088623,
    "h": 53.0821990966797,
    "CMY_C": 0.11414885520935,
    "CMY_M": 0.17326152324677,
    "CMY_Y": 0.20812994241714,
    "CMYK_C": 0,
    "CMYK_M": 0.066729798913,
    "CMYK_Y": 0.10609128326178,
    "CMYK_K": 0.11414885520935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00570",
    "Farbtonhilfsbezeichnung": "H2.30.80",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "141",
    "Y": 69,
    "L": 86.4188919067383,
    "a": -13.0638113021851,
    "b": 38.4016571044922,
    "C": 40.5629196166992,
    "h": 108.787727355957,
    "CMY_C": 0.14678382873535,
    "CMY_M": 0.13072246313095,
    "CMY_Y": 0.44655650854111,
    "CMYK_C": 0.01847668364644,
    "CMYK_M": 0,
    "CMYK_Y": 0.36332935094833,
    "CMYK_K": 0.13072246313095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00571",
    "Farbtonhilfsbezeichnung": "D2.50.55",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "129",
    "Bcolor": "85",
    "Y": 35,
    "L": 66.2743835449219,
    "a": 41.1484260559082,
    "b": 43.1338386535645,
    "C": 59.613094329834,
    "h": 46.3494529724121,
    "CMY_C": 0.04018247127533,
    "CMY_M": 0.49464631080627,
    "CMY_Y": 0.66852796077728,
    "CMYK_C": 0,
    "CMYK_M": 0.47348982095718,
    "CMYK_Y": 0.65465098619461,
    "CMYK_K": 0.04018247127533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00573",
    "Farbtonhilfsbezeichnung": "G8.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "218",
    "Bcolor": "164",
    "Y": 71,
    "L": 86.2755896275085,
    "a": -5.64461177424147,
    "b": 26.3492075793473,
    "C": 26.9470291895311,
    "h": -1.35976275650512,
    "CMY_C": 0.1208851,
    "CMY_M": 0.1464279,
    "CMY_Y": 0.3551877,
    "CMYK_C": 0,
    "CMYK_M": 0.02905515,
    "CMYK_Y": 0.266521,
    "CMYK_K": 0.1208851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00574",
    "Farbtonhilfsbezeichnung": "G8.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "228",
    "Bcolor": "144",
    "Y": 73,
    "L": 89.3973236083984,
    "a": -9.87499141693115,
    "b": 40.9472045898438,
    "C": 42.1211242675781,
    "h": 103.558776855469,
    "CMY_C": 0.08472943305969,
    "CMY_M": 0.10504651069641,
    "CMY_Y": 0.43466693162918,
    "CMYK_C": 0,
    "CMYK_M": 0.02219789288938,
    "CMYK_Y": 0.38233229517937,
    "CMYK_K": 0.08472943305969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00576",
    "Farbtonhilfsbezeichnung": "C0.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "119",
    "Bcolor": "111",
    "Y": 28,
    "L": 59.6287459374809,
    "a": 34.136088557436,
    "b": 19.2765926207776,
    "C": 39.2028004748198,
    "h": 0.51405784890953,
    "CMY_C": 0.1846477,
    "CMY_M": 0.5336587,
    "CMY_Y": 0.5663165,
    "CMYK_C": 0,
    "CMYK_M": 0.4280493,
    "CMYK_Y": 0.468103,
    "CMYK_K": 0.1846477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00577",
    "Farbtonhilfsbezeichnung": "PN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "228",
    "Bcolor": "225",
    "Y": 75,
    "L": 89.8422470092773,
    "a": -4.0450701713562,
    "b": -0.36553773283958,
    "C": 4.06155252456665,
    "h": 185.16357421875,
    "CMY_C": 0.14795792102814,
    "CMY_M": 0.1039947271347,
    "CMY_Y": 0.11872869729996,
    "CMYK_C": 0.0490657761693,
    "CMYK_M": 0,
    "CMYK_Y": 0.01644406653941,
    "CMYK_K": 0.1039947271347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00580",
    "Farbtonhilfsbezeichnung": "E0.50.65",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "149",
    "Bcolor": "70",
    "Y": 44,
    "L": 71.0768834347327,
    "a": 32.4078944001584,
    "b": 55.6795577820683,
    "C": 64.4242561017083,
    "h": 1.0436851876612,
    "CMY_C": 0.0179816,
    "CMY_M": 0.4162698,
    "CMY_Y": 0.7242194,
    "CMYK_C": 0,
    "CMYK_M": 0.4055812,
    "CMYK_Y": 0.7191696,
    "CMYK_K": 0.0179816
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00583",
    "Farbtonhilfsbezeichnung": "A0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "99",
    "Bcolor": "114",
    "Y": 17,
    "L": 48.4125338779658,
    "a": 24.5538043984189,
    "b": 0.35655525513316,
    "C": 24.5563931000825,
    "h": 0.01452036475384,
    "CMY_C": 0.3950144,
    "CMY_M": 0.6101355,
    "CMY_Y": 0.5519627,
    "CMYK_C": 0,
    "CMYK_M": 0.3555805,
    "CMYK_Y": 0.2594248,
    "CMYK_K": 0.3950144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00586",
    "Farbtonhilfsbezeichnung": "E0.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "161",
    "Bcolor": "148",
    "Y": 38,
    "L": 67.784912109375,
    "a": 5.98822212219238,
    "b": 9.19066619873047,
    "C": 10.9693737030029,
    "h": 56.9135551452637,
    "CMY_C": 0.28371506929398,
    "CMY_M": 0.36818987131119,
    "CMY_Y": 0.42069458961487,
    "CMYK_C": 0,
    "CMYK_M": 0.11793463677168,
    "CMYK_Y": 0.19123607873917,
    "CMYK_K": 0.28371506929398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00592",
    "Farbtonhilfsbezeichnung": "F8.20.75",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "205",
    "Bcolor": "159",
    "Y": 64,
    "L": 83.2587564624336,
    "a": 0.99531912234968,
    "b": 24.9941469421022,
    "C": 25.0139569344539,
    "h": 1.53099526859407,
    "CMY_C": 0.1106179,
    "CMY_M": 0.1946288,
    "CMY_Y": 0.3754006,
    "CMYK_C": 0,
    "CMYK_M": 0.09445982,
    "CMYK_Y": 0.2977153,
    "CMYK_K": 0.1106179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00594",
    "Farbtonhilfsbezeichnung": "Q0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "171",
    "Bcolor": "174",
    "Y": 39,
    "L": 68.2422027507674,
    "a": -8.43611107290082,
    "b": -5.08515044165951,
    "C": 9.85021446713876,
    "h": 0.54246384201342,
    "CMY_C": 0.4336485,
    "CMY_M": 0.3277642,
    "CMY_Y": 0.3182957,
    "CMYK_C": 0.1692123,
    "CMYK_M": 0.01388942,
    "CMYK_Y": 0,
    "CMYK_K": 0.3182957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00595",
    "Farbtonhilfsbezeichnung": "G0.35.75",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "204",
    "Bcolor": "116",
    "Y": 63,
    "L": 82.5890165163137,
    "a": -0.7371543553471,
    "b": 46.5625330457827,
    "C": 46.5683678067335,
    "h": -1.55496615754607,
    "CMY_C": 0.09018508,
    "CMY_M": 0.2016968,
    "CMY_Y": 0.5464477,
    "CMYK_C": 0,
    "CMYK_M": 0.1225652,
    "CMYK_Y": 0.5014895,
    "CMYK_K": 0.09018508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00597",
    "Farbtonhilfsbezeichnung": "C0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "85",
    "Bcolor": "81",
    "Y": 18,
    "L": 48.4090057308274,
    "a": 39.866515047591,
    "b": 21.0888469835384,
    "C": 45.100759296656,
    "h": 0.48656698212336,
    "CMY_C": 0.2815008,
    "CMY_M": 0.6683077,
    "CMY_Y": 0.6832287,
    "CMYK_C": 0,
    "CMYK_M": 0.538354,
    "CMYK_Y": 0.5591208,
    "CMYK_K": 0.2815008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00598",
    "Farbtonhilfsbezeichnung": "C0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "56",
    "Bcolor": "56",
    "Y": 11,
    "L": 38.5119704660864,
    "a": 42.4931215657194,
    "b": 22.3793806670345,
    "C": 48.0260560470985,
    "h": 0.48474657422553,
    "CMY_C": 0.381207,
    "CMY_M": 0.779937,
    "CMY_Y": 0.7793469,
    "CMYK_C": 0,
    "CMYK_M": 0.6443673,
    "CMYK_Y": 0.6434138,
    "CMYK_K": 0.381207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00603",
    "Farbtonhilfsbezeichnung": "B2.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "80",
    "Bcolor": "94",
    "Y": 16,
    "L": 48.4022216796875,
    "a": 44.9616813659668,
    "b": 13.282078742981,
    "C": 46.8824729919434,
    "h": 16.4576072692871,
    "CMY_C": 0.2650705575943,
    "CMY_M": 0.6875102519989,
    "CMY_Y": 0.63171935081482,
    "CMYK_C": 0,
    "CMYK_M": 0.57480305433273,
    "CMYK_Y": 0.49888977408409,
    "CMYK_K": 0.2650705575943
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00604",
    "Farbtonhilfsbezeichnung": "C8.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "78",
    "Bcolor": "67",
    "Y": 10,
    "L": 36.7080053182986,
    "a": 13.8141020712514,
    "b": 12.0245688667137,
    "C": 18.31446620749,
    "h": 0.71625063823893,
    "CMY_C": 0.5544337,
    "CMY_M": 0.6948537,
    "CMY_Y": 0.7368904,
    "CMYK_C": 0,
    "CMYK_M": 0.3151496,
    "CMYK_Y": 0.4094938,
    "CMYK_K": 0.5544337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00605",
    "Farbtonhilfsbezeichnung": "K2.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "126",
    "Bcolor": "87",
    "Y": 17,
    "L": 49.2230377197266,
    "a": -20.4932289123535,
    "b": 16.9237461090088,
    "C": 26.5779151916504,
    "h": 140.44938659668,
    "CMY_C": 0.64471274614334,
    "CMY_M": 0.50639599561691,
    "CMY_Y": 0.65967297554016,
    "CMYK_C": 0.28021803498268,
    "CMYK_M": 0,
    "CMYK_Y": 0.31052622199059,
    "CMYK_K": 0.50639599561691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00606",
    "Farbtonhilfsbezeichnung": "S0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "96",
    "Bcolor": "115",
    "Y": 11,
    "L": 38.2689907887504,
    "a": -10.1604845336322,
    "b": -16.4648718175379,
    "C": 19.3475437698467,
    "h": 1.01789755705275,
    "CMY_C": 0.8141456,
    "CMY_M": 0.6232405,
    "CMY_Y": 0.5474594,
    "CMYK_C": 0.5893089,
    "CMYK_M": 0.1674569,
    "CMYK_Y": 0,
    "CMYK_K": 0.5474594
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00608",
    "Farbtonhilfsbezeichnung": "L0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "122",
    "Bcolor": "102",
    "Y": 18,
    "L": 48.7977382641527,
    "a": -13.5710601094073,
    "b": 7.68384004299216,
    "C": 15.5953541254899,
    "h": -0.51519044302974,
    "CMY_C": 0.6220219,
    "CMY_M": 0.5207627,
    "CMY_Y": 0.60122,
    "CMYK_C": 0.2112923,
    "CMYK_M": 0,
    "CMYK_Y": 0.1678862,
    "CMYK_K": 0.5207627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00611",
    "Farbtonhilfsbezeichnung": "D2.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "145",
    "Bcolor": "111",
    "Y": 38,
    "L": 67.0522361804616,
    "a": 24.7279292185564,
    "b": 29.2271098673375,
    "C": 38.2843889155274,
    "h": 0.86859327699384,
    "CMY_C": 0.1378228,
    "CMY_M": 0.429982,
    "CMY_Y": 0.565077,
    "CMYK_C": 0,
    "CMYK_M": 0.3388621,
    "CMYK_Y": 0.4955527,
    "CMYK_K": 0.1378228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00612",
    "Farbtonhilfsbezeichnung": "CN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "205",
    "Bcolor": "200",
    "Y": 65,
    "L": 83.2837079006221,
    "a": 3.2798740134255,
    "b": 3.39677665548455,
    "C": 4.7218285855364,
    "h": 0.80290554902012,
    "CMY_C": 0.1504094,
    "CMY_M": 0.1945939,
    "CMY_Y": 0.2168831,
    "CMYK_C": 0,
    "CMYK_M": 0.05200676,
    "CMYK_Y": 0.07824201,
    "CMYK_K": 0.1504094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00613",
    "Farbtonhilfsbezeichnung": "C0.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "208",
    "Bcolor": "203",
    "Y": 67,
    "L": 85.0047073364258,
    "a": 6.68096685409546,
    "b": 4.15276670455933,
    "C": 7.8664345741272,
    "h": 31.8643283843994,
    "CMY_C": 0.10385745763779,
    "CMY_M": 0.18423873186111,
    "CMY_Y": 0.20328158140182,
    "CMYK_C": 0,
    "CMYK_M": 0.08969697356224,
    "CMYK_Y": 0.11094677448273,
    "CMYK_K": 0.10385745763779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00615",
    "Farbtonhilfsbezeichnung": "W0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "185",
    "Bcolor": "210",
    "Y": 52,
    "L": 76.2998091918719,
    "a": 7.00288809770377,
    "b": -12.7213846272094,
    "C": 14.5215036598267,
    "h": -1.0675834445697,
    "CMY_C": 0.2534897,
    "CMY_M": 0.2742497,
    "CMY_Y": 0.1762269,
    "CMYK_C": 0.09379136,
    "CMYK_M": 0.1189926,
    "CMYK_Y": 0,
    "CMYK_K": 0.1762269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00616",
    "Farbtonhilfsbezeichnung": "W0.15.65",
    "Farbtonklasse": "04",
    "Rcolor": "176",
    "Gcolor": "169",
    "Bcolor": "207",
    "Y": 44,
    "L": 70.855998035159,
    "a": 10.3415511125129,
    "b": -19.1071468527289,
    "C": 21.7262684385622,
    "h": -1.07470355403242,
    "CMY_C": 0.3111154,
    "CMY_M": 0.33803,
    "CMY_Y": 0.1899334,
    "CMYK_C": 0.1495951,
    "CMYK_M": 0.1828203,
    "CMYK_Y": 0,
    "CMYK_K": 0.1899334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00617",
    "Farbtonhilfsbezeichnung": "W0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "208",
    "Bcolor": "228",
    "Y": 63,
    "L": 84.453369140625,
    "a": 5.51433515548706,
    "b": -10.1016454696655,
    "C": 11.5087413787842,
    "h": 298.629455566406,
    "CMY_C": 0.16639739274979,
    "CMY_M": 0.18314152956009,
    "CMY_Y": 0.10566413402557,
    "CMYK_C": 0.06790877878666,
    "CMYK_M": 0.08663120865822,
    "CMYK_Y": 0,
    "CMYK_K": 0.10566413402557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00622",
    "Farbtonhilfsbezeichnung": "D6.10.30",
    "Farbtonklasse": "02",
    "Rcolor": "108",
    "Gcolor": "94",
    "Bcolor": "87",
    "Y": 11,
    "L": 40.9521064758301,
    "a": 4.84536170959473,
    "b": 5.56166553497314,
    "C": 7.37628984451294,
    "h": 48.9373931884766,
    "CMY_C": 0.57576143741608,
    "CMY_M": 0.63262820243835,
    "CMY_Y": 0.65905612707138,
    "CMYK_C": 0,
    "CMYK_M": 0.13404430449009,
    "CMYK_Y": 0.19633926451206,
    "CMYK_K": 0.57576143741608
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00623",
    "Farbtonhilfsbezeichnung": "N0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "198",
    "Bcolor": "187",
    "Y": 53,
    "L": 77.0854510837119,
    "a": -13.047402766176,
    "b": 0.52479312657021,
    "C": 13.0579526254506,
    "h": -0.04020036820872,
    "CMY_C": 0.3581141,
    "CMY_M": 0.2250771,
    "CMY_Y": 0.2648709,
    "CMYK_C": 0.1716778,
    "CMYK_M": 0,
    "CMYK_Y": 0.05135196,
    "CMYK_K": 0.2250771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00625",
    "Farbtonhilfsbezeichnung": "U0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "144",
    "Bcolor": "195",
    "Y": 27,
    "L": 58.9240913391113,
    "a": 0.53937429189682,
    "b": -31.5968914031982,
    "C": 31.6014938354492,
    "h": 270.977966308594,
    "CMY_C": 0.59011334180832,
    "CMY_M": 0.43444693088531,
    "CMY_Y": 0.2335352897644,
    "CMYK_C": 0.46522435545921,
    "CMYK_M": 0.26212772727013,
    "CMYK_Y": 0,
    "CMYK_K": 0.2335352897644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00626",
    "Farbtonhilfsbezeichnung": "C8.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "134",
    "Bcolor": "125",
    "Y": 27,
    "L": 57.8083175359881,
    "a": 8.23910689357604,
    "b": 7.41997713824907,
    "C": 11.087783508705,
    "h": 0.73313560230282,
    "CMY_C": 0.379112,
    "CMY_M": 0.4756741,
    "CMY_Y": 0.5086507,
    "CMYK_C": 0,
    "CMYK_M": 0.1555226,
    "CMYK_Y": 0.2086346,
    "CMYK_K": 0.379112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00628",
    "Farbtonhilfsbezeichnung": "LN.02.17",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "62",
    "Bcolor": "60",
    "Y": 7,
    "L": 25.9767200764136,
    "a": -0.97795279431489,
    "b": 0.61536584206181,
    "C": 1.15545090223893,
    "h": -0.56164163541697,
    "CMY_C": 0.7633654,
    "CMY_M": 0.7570162,
    "CMY_Y": 0.7647184,
    "CMYK_C": 0.02612993,
    "CMYK_M": 0,
    "CMYK_Y": 0.03169835,
    "CMYK_K": 0.7570162
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00630",
    "Farbtonhilfsbezeichnung": "S0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "75",
    "Bcolor": "86",
    "Y": 7,
    "L": 30.8232499730974,
    "a": -4.89078103802942,
    "b": -9.26095430750317,
    "C": 10.4730613407737,
    "h": 1.08491624482274,
    "CMY_C": 0.7852384,
    "CMY_M": 0.7039626,
    "CMY_Y": 0.6626162,
    "CMYK_C": 0.3634503,
    "CMYK_M": 0.1225499,
    "CMYK_Y": 0,
    "CMYK_K": 0.6626162
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00632",
    "Farbtonhilfsbezeichnung": "C0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "161",
    "Bcolor": "156",
    "Y": 39,
    "L": 69.2529373168945,
    "a": 13.3165130615234,
    "b": 6.89613580703735,
    "C": 14.9962062835693,
    "h": 27.3779888153076,
    "CMY_C": 0.22456288337708,
    "CMY_M": 0.37041747570038,
    "CMY_Y": 0.38849377632141,
    "CMYK_C": 0,
    "CMYK_M": 0.1880933791399,
    "CMYK_Y": 0.21140450239182,
    "CMYK_K": 0.22456288337708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00633",
    "Farbtonhilfsbezeichnung": "C0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "179",
    "Bcolor": "173",
    "Y": 52,
    "L": 76.5238792873427,
    "a": 14.5620964315574,
    "b": 8.3575062946925,
    "C": 16.7899542568704,
    "h": 0.52102369412946,
    "CMY_C": 0.1322418,
    "CMY_M": 0.2972399,
    "CMY_Y": 0.3229015,
    "CMYK_C": 0,
    "CMYK_M": 0.1901429,
    "CMYK_Y": 0.2197153,
    "CMYK_K": 0.1322418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00640",
    "Farbtonhilfsbezeichnung": "ON.00.35",
    "Farbtonklasse": "01",
    "Y": 14,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00642",
    "Farbtonhilfsbezeichnung": "K2.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "208",
    "Bcolor": "194",
    "Y": 64,
    "L": 82.7552869992006,
    "a": -4.40048377411456,
    "b": 5.6873455757001,
    "C": 7.19097748179488,
    "h": -0.9122786597612,
    "CMY_C": 0.2076448,
    "CMY_M": 0.1831536,
    "CMY_Y": 0.2403148,
    "CMYK_C": 0.02998252,
    "CMYK_M": 0,
    "CMYK_Y": 0.06997783,
    "CMYK_K": 0.1831536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00645",
    "Farbtonhilfsbezeichnung": "C4.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "79",
    "Bcolor": "70",
    "Y": 12,
    "L": 39.8720250134061,
    "a": 22.063640628023,
    "b": 14.6758837107934,
    "C": 26.4987886601497,
    "h": 0.58695982268932,
    "CMY_C": 0.474506,
    "CMY_M": 0.6884521,
    "CMY_Y": 0.7236518,
    "CMYK_C": 0,
    "CMYK_M": 0.4071333,
    "CMYK_Y": 0.4741174,
    "CMYK_K": 0.474506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00646",
    "Farbtonhilfsbezeichnung": "C0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "203",
    "Bcolor": "194",
    "Y": 65,
    "L": 85.1938247680664,
    "a": 13.9778575897217,
    "b": 9.72651767730713,
    "C": 17.0289649963379,
    "h": 34.8321952819824,
    "CMY_C": 0.03481161594391,
    "CMY_M": 0.20237553119659,
    "CMY_Y": 0.24075478315353,
    "CMYK_C": 0,
    "CMYK_M": 0.17360746860504,
    "CMYK_Y": 0.21337094902992,
    "CMYK_K": 0.03481161594391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00651",
    "Farbtonhilfsbezeichnung": "E4.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "227",
    "Bcolor": "215",
    "Y": 77,
    "L": 90.9867401123047,
    "a": 2.37363457679749,
    "b": 6.66692686080933,
    "C": 7.07686758041382,
    "h": 70.4026794433594,
    "CMY_C": 0.06137472391129,
    "CMY_M": 0.10832321643829,
    "CMY_Y": 0.15726071596146,
    "CMYK_C": 0,
    "CMYK_M": 0.05001835525036,
    "CMYK_Y": 0.10215577483177,
    "CMYK_K": 0.06137472391129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00652",
    "Farbtonhilfsbezeichnung": "U0.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "93",
    "Bcolor": "131",
    "Y": 12,
    "L": 38.7984473910372,
    "a": -0.0454096268565,
    "b": -25.2879874849376,
    "C": 25.2880282559272,
    "h": 1.56900062921021,
    "CMY_C": 0.7605267,
    "CMY_M": 0.6336004,
    "CMY_Y": 0.4855837,
    "CMYK_C": 0.5344757,
    "CMYK_M": 0.2877373,
    "CMYK_Y": 0,
    "CMYK_K": 0.4855837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00654",
    "Farbtonhilfsbezeichnung": "B6.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "185",
    "Bcolor": "180",
    "Y": 56,
    "L": 78.7605411213726,
    "a": 15.4096108830404,
    "b": 7.72970599422054,
    "C": 17.239618972698,
    "h": 0.46493950168338,
    "CMY_C": 0.1029822,
    "CMY_M": 0.2753645,
    "CMY_Y": 0.294687,
    "CMYK_C": 0,
    "CMYK_M": 0.1921728,
    "CMYK_Y": 0.2137135,
    "CMYK_K": 0.1029822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00656",
    "Farbtonhilfsbezeichnung": "A0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 76,
    "L": 90.0852661132812,
    "a": 8.18254661560059,
    "b": 2.02608966827393,
    "C": 8.42965602874756,
    "h": 13.9073514938354,
    "CMY_C": 0.04208070039749,
    "CMY_M": 0.13141930103302,
    "CMY_Y": 0.13199371099472,
    "CMYK_C": 0,
    "CMYK_M": 0.0932631790638,
    "CMYK_Y": 0.09386282414198,
    "CMYK_K": 0.04208070039749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00659",
    "Farbtonhilfsbezeichnung": "R0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "228",
    "Bcolor": "229",
    "Y": 78,
    "L": 89.7137168707442,
    "a": -4.20777326768435,
    "b": -2.62451922636346,
    "C": 4.95917906934106,
    "h": 0.5576863578909,
    "CMY_C": 0.1591251,
    "CMY_M": 0.1044309,
    "CMY_Y": 0.1034852,
    "CMYK_C": 0.06206252,
    "CMYK_M": 0.001054891,
    "CMYK_Y": 0,
    "CMYK_K": 0.1034852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00660",
    "Farbtonhilfsbezeichnung": "R0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 69,
    "L": 84.9172332732457,
    "a": -7.52980692875832,
    "b": -6.5426144514803,
    "C": 9.97515895838736,
    "h": 0.71536203787819,
    "CMY_C": 0.2554481,
    "CMY_M": 0.1490351,
    "CMY_Y": 0.128103,
    "CMYK_C": 0.1460552,
    "CMYK_M": 0.02400756,
    "CMYK_Y": 0,
    "CMYK_K": 0.128103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00667",
    "Farbtonhilfsbezeichnung": "AN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "216",
    "Bcolor": "214",
    "Y": 70,
    "L": 87.1984984880222,
    "a": 3.23596127182574,
    "b": 1.5357332577191,
    "C": 3.58188804844883,
    "h": 0.44310831155673,
    "CMY_C": 0.1132305,
    "CMY_M": 0.1509997,
    "CMY_Y": 0.160767,
    "CMYK_C": 0,
    "CMYK_M": 0.04259197,
    "CMYK_Y": 0.05360645,
    "CMYK_K": 0.1132305
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00670",
    "Farbtonhilfsbezeichnung": "E4.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "135",
    "Bcolor": "106",
    "Y": 27,
    "L": 58.6191698080447,
    "a": 8.81904894734609,
    "b": 19.6970500392471,
    "C": 21.581228060152,
    "h": 1.14982798462447,
    "CMY_C": 0.3414033,
    "CMY_M": 0.4715976,
    "CMY_Y": 0.5840415,
    "CMYK_C": 0,
    "CMYK_M": 0.1976843,
    "CMYK_Y": 0.3684169,
    "CMYK_K": 0.3414033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00674",
    "Farbtonhilfsbezeichnung": "P0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "151",
    "Bcolor": "147",
    "Y": 26,
    "L": 57.0858150900197,
    "a": -27.7994925429187,
    "b": -6.60375140704648,
    "C": 28.5730873076372,
    "h": 0.23322651589962,
    "CMY_C": 0.7734495,
    "CMY_M": 0.4091282,
    "CMY_Y": 0.4254569,
    "CMYK_C": 0.6165828,
    "CMYK_M": 0,
    "CMYK_Y": 0.02763493,
    "CMYK_K": 0.4091282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00675",
    "Farbtonhilfsbezeichnung": "KN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "244",
    "Bcolor": "234",
    "Y": 87,
    "L": 95.6664581298828,
    "a": -2.68374991416931,
    "b": 3.18281483650208,
    "C": 4.16327095031738,
    "h": 130.137588500977,
    "CMY_C": 0.05949747562408,
    "CMY_M": 0.04285019636154,
    "CMY_Y": 0.08039349317551,
    "CMYK_C": 0.01739255338907,
    "CMYK_M": 0,
    "CMYK_Y": 0.03922405466437,
    "CMYK_K": 0.04285019636154
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00676",
    "Farbtonhilfsbezeichnung": "P0.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "214",
    "Bcolor": "211",
    "Y": 68,
    "L": 84.2972714013812,
    "a": -5.94116758111479,
    "b": -1.13680653810764,
    "C": 6.04895043226291,
    "h": 0.18905876065388,
    "CMY_C": 0.2271108,
    "CMY_M": 0.160936,
    "CMY_Y": 0.1741496,
    "CMYK_C": 0.07886733,
    "CMYK_M": 0,
    "CMYK_Y": 0.01574804,
    "CMYK_K": 0.160936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00677",
    "Farbtonhilfsbezeichnung": "JN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "223",
    "Bcolor": "215",
    "Y": 76,
    "L": 88.4514007568359,
    "a": -2.31769037246704,
    "b": 2.82848691940308,
    "C": 3.65677809715271,
    "h": 129.331527709961,
    "CMY_C": 0.13821560144424,
    "CMY_M": 0.12433117628098,
    "CMY_Y": 0.15733981132507,
    "CMYK_C": 0.01585579477251,
    "CMYK_M": 0,
    "CMYK_Y": 0.03769534081221,
    "CMYK_K": 0.12433117628098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00681",
    "Farbtonhilfsbezeichnung": "F2.35.75",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "196",
    "Bcolor": "119",
    "Y": 60,
    "L": 82.1372222900391,
    "a": 9.3474006652832,
    "b": 44.8554344177246,
    "C": 45.819034576416,
    "h": 78.228630065918,
    "CMY_C": 0.03274750709534,
    "CMY_M": 0.23100990056992,
    "CMY_Y": 0.53483259677887,
    "CMYK_C": 0,
    "CMYK_M": 0.20497480034828,
    "CMYK_Y": 0.51908379793167,
    "CMYK_K": 0.03274750709534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00682",
    "Farbtonhilfsbezeichnung": "S0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "231",
    "Bcolor": "236",
    "Y": 78,
    "L": 90.7505798339844,
    "a": -3.61675000190735,
    "b": -5.17318391799927,
    "C": 6.31210851669312,
    "h": 235.041275024414,
    "CMY_C": 0.15257394313812,
    "CMY_M": 0.09344393014908,
    "CMY_Y": 0.07304656505585,
    "CMYK_C": 0.08579435944557,
    "CMYK_M": 0.02200473472476,
    "CMYK_Y": 0,
    "CMYK_K": 0.07304656505585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00685",
    "Farbtonhilfsbezeichnung": "T0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "122",
    "Bcolor": "143",
    "Y": 18,
    "L": 49.9632225036621,
    "a": -3.52950429916382,
    "b": -15.0550651550293,
    "C": 15.4632596969604,
    "h": 256.805877685547,
    "CMY_C": 0.62092435359955,
    "CMY_M": 0.52215206623077,
    "CMY_Y": 0.43922293186188,
    "CMYK_C": 0.32401719689369,
    "CMYK_M": 0.14788253605366,
    "CMYK_Y": 0,
    "CMYK_K": 0.43922293186188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00686",
    "Farbtonhilfsbezeichnung": "C8.20.40",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "103",
    "Bcolor": "88",
    "Y": 17,
    "L": 47.8317829166719,
    "a": 16.1780787495839,
    "b": 15.1901091924825,
    "C": 22.1916572005625,
    "h": 0.75391266391005,
    "CMY_C": 0.4211388,
    "CMY_M": 0.596133,
    "CMY_Y": 0.6550695,
    "CMYK_C": 0,
    "CMYK_M": 0.3023077,
    "CMYK_Y": 0.4041223,
    "CMYK_K": 0.4211388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00693",
    "Farbtonhilfsbezeichnung": "ON.00.40",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "112",
    "Bcolor": "112",
    "Y": 16,
    "L": 47.263739759824,
    "a": 0.06470428426597,
    "b": -0.22254357990034,
    "C": 0.23175911925366,
    "h": -1.28784830942879,
    "CMY_C": 0.5607339,
    "CMY_M": 0.5602911,
    "CMY_Y": 0.5626136,
    "CMYK_C": 0.001007036,
    "CMYK_M": 0,
    "CMYK_Y": 0.005281935,
    "CMYK_K": 0.5602911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00694",
    "Farbtonhilfsbezeichnung": "F2.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "228",
    "Bcolor": "211",
    "Y": 79,
    "L": 91.0060067038553,
    "a": 1.44755432306326,
    "b": 8.76134740774099,
    "C": 8.88012510707754,
    "h": 1.40705504584729,
    "CMY_C": 0.06189529,
    "CMY_M": 0.1064651,
    "CMY_Y": 0.1727152,
    "CMYK_C": 0,
    "CMYK_M": 0.04751048,
    "CMYK_Y": 0.1181318,
    "CMYK_K": 0.06189529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00695",
    "Farbtonhilfsbezeichnung": "B2.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "160",
    "Bcolor": "160",
    "Y": 40,
    "L": 69.297479793569,
    "a": 14.0599791995172,
    "b": 4.83181336560496,
    "C": 14.86705873705,
    "h": 0.33101309907703,
    "CMY_C": 0.2242591,
    "CMY_M": 0.3713575,
    "CMY_Y": 0.3735196,
    "CMYK_C": 0,
    "CMYK_M": 0.1896231,
    "CMYK_Y": 0.1924102,
    "CMYK_K": 0.2242591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00696",
    "Farbtonhilfsbezeichnung": "E0.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "152",
    "Bcolor": "112",
    "Y": 38,
    "L": 67.3505454685177,
    "a": 16.125215827391,
    "b": 28.8890866567954,
    "C": 33.0847686004266,
    "h": 1.06169708102135,
    "CMY_C": 0.1854582,
    "CMY_M": 0.4026301,
    "CMY_Y": 0.5617456,
    "CMYK_C": 0,
    "CMYK_M": 0.2666184,
    "CMYK_Y": 0.4619621,
    "CMYK_K": 0.1854582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00700",
    "Farbtonhilfsbezeichnung": "E0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "172",
    "Bcolor": "149",
    "Y": 45,
    "L": 72.9526057691111,
    "a": 9.52942839599308,
    "b": 16.1278850711033,
    "C": 18.7328236638547,
    "h": 1.03711963993363,
    "CMY_C": 0.1874689,
    "CMY_M": 0.324206,
    "CMY_Y": 0.4160728,
    "CMYK_C": 0,
    "CMYK_M": 0.1682854,
    "CMYK_Y": 0.2813478,
    "CMYK_K": 0.1874689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00701",
    "Farbtonhilfsbezeichnung": "D6.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "87",
    "Bcolor": "74",
    "Y": 11,
    "L": 39.6468391418457,
    "a": 9.57980251312256,
    "b": 11.5117349624634,
    "C": 14.9764032363892,
    "h": 50.2335472106934,
    "CMY_C": 0.54892694950104,
    "CMY_M": 0.6569806933403,
    "CMY_Y": 0.70794248580933,
    "CMYK_C": 0,
    "CMYK_M": 0.23954822123051,
    "CMYK_Y": 0.35252723097801,
    "CMYK_K": 0.54892694950104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00704",
    "Farbtonhilfsbezeichnung": "H2.25.30",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "92",
    "Bcolor": "65",
    "Y": 11,
    "L": 38.1907312245964,
    "a": -5.23738305321988,
    "b": 15.0124110807181,
    "C": 15.8997694229389,
    "h": -1.2351283534017,
    "CMY_C": 0.6447003,
    "CMY_M": 0.6401881,
    "CMY_Y": 0.7457266,
    "CMYK_C": 0.01254058,
    "CMYK_M": 0,
    "CMYK_Y": 0.2933159,
    "CMYK_K": 0.6401881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00709",
    "Farbtonhilfsbezeichnung": "YN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "216",
    "Bcolor": "217",
    "Y": 74,
    "L": 87.1660414358944,
    "a": 3.62134148609577,
    "b": 0.04425347345733,
    "C": 3.62161186888261,
    "h": 0.01221957967511,
    "CMY_C": 0.1154901,
    "CMY_M": 0.1518628,
    "CMY_Y": 0.1501343,
    "CMYK_C": 0,
    "CMYK_M": 0.04112184,
    "CMYK_Y": 0.03916764,
    "CMYK_K": 0.1154901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00710",
    "Farbtonhilfsbezeichnung": "Y0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "108",
    "Bcolor": "125",
    "Y": 18,
    "L": 48.0505053971554,
    "a": 11.4724752460684,
    "b": -6.99882080091809,
    "C": 13.4387938772427,
    "h": -0.5477788213825,
    "CMY_C": 0.4964538,
    "CMY_M": 0.5763656,
    "CMY_Y": 0.5095705,
    "CMYK_C": 0,
    "CMYK_M": 0.158698,
    "CMYK_Y": 0.02604865,
    "CMYK_K": 0.4964538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00714",
    "Farbtonhilfsbezeichnung": "W0.05.15",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "53",
    "Bcolor": "61",
    "Y": 6,
    "L": 22.8158747995337,
    "a": 2.77035435806378,
    "b": -4.74783211347271,
    "C": 5.49697853797572,
    "h": -1.04259842755408,
    "CMY_C": 0.7828206,
    "CMY_M": 0.7904119,
    "CMY_Y": 0.7608709,
    "CMYK_C": 0.09178996,
    "CMYK_M": 0.1235359,
    "CMYK_Y": 0,
    "CMYK_K": 0.7608709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00716",
    "Farbtonhilfsbezeichnung": "D6.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "118",
    "Bcolor": "76",
    "Y": 27,
    "L": 57.6133546057393,
    "a": 27.4816507646245,
    "b": 35.7656309714825,
    "C": 45.1045617153859,
    "h": 0.91563444738257,
    "CMY_C": 0.2240346,
    "CMY_M": 0.5358513,
    "CMY_Y": 0.7013717,
    "CMYK_C": 0,
    "CMYK_M": 0.4018435,
    "CMYK_Y": 0.6151526,
    "CMYK_K": 0.2240346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00720",
    "Farbtonhilfsbezeichnung": "J0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "143",
    "Bcolor": "126",
    "Y": 26,
    "L": 58.4617576599121,
    "a": -4.78684568405151,
    "b": 7.932457447052,
    "C": 9.26486778259277,
    "h": 121.108901977539,
    "CMY_C": 0.45957559347153,
    "CMY_M": 0.44021254777908,
    "CMY_Y": 0.50751781463623,
    "CMYK_C": 0.03458999469876,
    "CMYK_M": 0,
    "CMYK_Y": 0.12023361027241,
    "CMYK_K": 0.44021254777908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00721",
    "Farbtonhilfsbezeichnung": "D6.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "144",
    "Bcolor": "96",
    "Y": 38,
    "L": 67.9626617431641,
    "a": 28.7980117797852,
    "b": 38.4504508972168,
    "C": 48.039176940918,
    "h": 53.1681022644043,
    "CMY_C": 0.09232711791992,
    "CMY_M": 0.4345371723175,
    "CMY_Y": 0.62165510654449,
    "CMYK_C": 0,
    "CMYK_M": 0.37701913714409,
    "CMYK_Y": 0.58317041397095,
    "CMYK_K": 0.09232711791992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00722",
    "Farbtonhilfsbezeichnung": "B6.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "90",
    "Bcolor": "93",
    "Y": 17,
    "L": 48.3617362976074,
    "a": 34.4816436767578,
    "b": 13.6389598846435,
    "C": 37.0810585021973,
    "h": 21.5809078216553,
    "CMY_C": 0.31886619329453,
    "CMY_M": 0.64655542373657,
    "CMY_Y": 0.6365253329277,
    "CMYK_C": 0,
    "CMYK_M": 0.48109376430511,
    "CMYK_Y": 0.46636819839478,
    "CMYK_K": 0.31886619329453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00724",
    "Farbtonhilfsbezeichnung": "S0.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "211",
    "Bcolor": "214",
    "Y": 67,
    "L": 83.894926936273,
    "a": -2.76513673584194,
    "b": -3.29874080312886,
    "C": 4.30437824245615,
    "h": 0.8731692482289,
    "CMY_C": 0.2135024,
    "CMY_M": 0.1718841,
    "CMY_Y": 0.1623794,
    "CMYK_C": 0.06103362,
    "CMYK_M": 0.01134721,
    "CMYK_Y": 0,
    "CMYK_K": 0.1623794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00726",
    "Farbtonhilfsbezeichnung": "C4.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "93",
    "Bcolor": "79",
    "Y": 25,
    "L": 55.6734029763226,
    "a": 49.3893784724339,
    "b": 32.6938738083463,
    "C": 59.2300606996936,
    "h": 0.58473819783971,
    "CMY_C": 0.1359961,
    "CMY_M": 0.6368884,
    "CMY_Y": 0.6910754,
    "CMYK_C": 0,
    "CMYK_M": 0.5797338,
    "CMYK_Y": 0.6424499,
    "CMYK_K": 0.1359961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00728",
    "Farbtonhilfsbezeichnung": "B2.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "198",
    "Bcolor": "196",
    "Y": 62,
    "L": 81.7077233452141,
    "a": 8.90550915932808,
    "b": 3.0511811269095,
    "C": 9.41370276013031,
    "h": 0.33008268653311,
    "CMY_C": 0.1276856,
    "CMY_M": 0.2254555,
    "CMY_Y": 0.2305536,
    "CMYK_C": 0,
    "CMYK_M": 0.1120811,
    "CMYK_Y": 0.1179254,
    "CMYK_K": 0.1276856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00731",
    "Farbtonhilfsbezeichnung": "E0.25.65",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "167",
    "Bcolor": "129",
    "Y": 45,
    "L": 72.3478955379699,
    "a": 14.2417657320232,
    "b": 26.1084935711773,
    "C": 29.7402307947003,
    "h": 1.07142689812189,
    "CMY_C": 0.1447049,
    "CMY_M": 0.3448584,
    "CMY_Y": 0.4925689,
    "CMYK_C": 0,
    "CMYK_M": 0.2340168,
    "CMYK_Y": 0.4067181,
    "CMYK_K": 0.1447049
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00733",
    "Farbtonhilfsbezeichnung": "G8.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "89",
    "Bcolor": "65",
    "Y": 11,
    "L": 37.4436637149553,
    "a": -2.92819198822794,
    "b": 13.9469754529799,
    "C": 14.2510502281743,
    "h": -1.36385033925777,
    "CMY_C": 0.6395051,
    "CMY_M": 0.6514129,
    "CMY_Y": 0.7452182,
    "CMYK_C": 0,
    "CMYK_M": 0.03303198,
    "CMYK_Y": 0.2932443,
    "CMYK_K": 0.6395051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00734",
    "Farbtonhilfsbezeichnung": "G4.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "180",
    "Bcolor": "148",
    "Y": 47,
    "L": 73.1357454139241,
    "a": -1.62722321908604,
    "b": 16.7719435632731,
    "C": 16.8506957213745,
    "h": -1.47407848493929,
    "CMY_C": 0.259867,
    "CMY_M": 0.2959332,
    "CMY_Y": 0.4206811,
    "CMYK_C": 0,
    "CMYK_M": 0.04872932,
    "CMYK_Y": 0.2172773,
    "CMYK_K": 0.259867
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00736",
    "Farbtonhilfsbezeichnung": "L8.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "181",
    "Bcolor": "145",
    "Y": 39,
    "L": 68.0834200533367,
    "a": -31.6278742790781,
    "b": 10.5987960778643,
    "C": 33.3565122534315,
    "h": -0.32334810793105,
    "CMY_C": 0.5871611,
    "CMY_M": 0.2903335,
    "CMY_Y": 0.4328152,
    "CMYK_C": 0.4182635,
    "CMYK_M": 0,
    "CMYK_Y": 0.2007727,
    "CMYK_K": 0.2903335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00737",
    "Farbtonhilfsbezeichnung": "P0.30.60",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "180",
    "Bcolor": "178",
    "Y": 39,
    "L": 67.6215802382503,
    "a": -30.0993487135991,
    "b": -8.52913590860496,
    "C": 31.2844522459687,
    "h": 0.27612737701396,
    "CMY_C": 0.7024437,
    "CMY_M": 0.2932873,
    "CMY_Y": 0.3030556,
    "CMYK_C": 0.5789572,
    "CMYK_M": 0,
    "CMYK_Y": 0.01382223,
    "CMYK_K": 0.2932873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00738",
    "Farbtonhilfsbezeichnung": "Q0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "174",
    "Bcolor": "181",
    "Y": 39,
    "L": 67.6308155983516,
    "a": -17.1297663260726,
    "b": -10.0351947850162,
    "C": 19.8528090898761,
    "h": 0.52993799414641,
    "CMY_C": 0.5464849,
    "CMY_M": 0.3157538,
    "CMY_Y": 0.2911182,
    "CMYK_C": 0.3602388,
    "CMYK_M": 0.03475276,
    "CMYK_Y": 0,
    "CMYK_K": 0.2911182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00741",
    "Farbtonhilfsbezeichnung": "P0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "159",
    "Bcolor": "154",
    "Y": 27,
    "L": 58.9444732666016,
    "a": -35.7293548583984,
    "b": -8.49771881103516,
    "C": 36.7259864807129,
    "h": 193.37841796875,
    "CMY_C": 1,
    "CMY_M": 0.37695395946503,
    "CMY_Y": 0.3942694067955,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02779160067439,
    "CMYK_K": 0.37695395946503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00742",
    "Farbtonhilfsbezeichnung": "F2.45.75",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "191",
    "Bcolor": "89",
    "Y": 61,
    "L": 81.3515799134622,
    "a": 13.585990179314,
    "b": 58.5119006135761,
    "C": 60.0684746149378,
    "h": 1.34264715092411,
    "CMY_C": 0,
    "CMY_M": 0.252589,
    "CMY_Y": 0.6523834,
    "CMYK_C": 0,
    "CMYK_M": 0.252589,
    "CMYK_Y": 0.6523834,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00744",
    "Farbtonhilfsbezeichnung": "SN.02.57",
    "Farbtonklasse": "01",
    "Rcolor": "153",
    "Gcolor": "158",
    "Bcolor": "160",
    "Y": 35,
    "L": 64.8280788817602,
    "a": -0.93408795115029,
    "b": -2.41671329572766,
    "C": 2.59095029945211,
    "h": 1.20197160329987,
    "CMY_C": 0.3983675,
    "CMY_M": 0.3801962,
    "CMY_Y": 0.3715824,
    "CMYK_C": 0.04262306,
    "CMYK_M": 0.0137072,
    "CMYK_Y": 0,
    "CMYK_K": 0.3715824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00749",
    "Farbtonhilfsbezeichnung": "F2.25.75",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "197",
    "Bcolor": "141",
    "Y": 62,
    "L": 81.371533303048,
    "a": 5.67048241349583,
    "b": 32.0050068509305,
    "C": 32.503458805639,
    "h": 1.3954412142886,
    "CMY_C": 0.08625121,
    "CMY_M": 0.2278461,
    "CMY_Y": 0.4459499,
    "CMYK_C": 0,
    "CMYK_M": 0.1549604,
    "CMYK_Y": 0.3936516,
    "CMYK_K": 0.08625121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00751",
    "Farbtonhilfsbezeichnung": "B6.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "72",
    "Bcolor": "72",
    "Y": 10,
    "L": 36.0839702801303,
    "a": 20.6524527348944,
    "b": 8.22344337411678,
    "C": 22.2294584930526,
    "h": 0.37893850661333,
    "CMY_C": 0.5307326,
    "CMY_M": 0.7182564,
    "CMY_Y": 0.7178185,
    "CMYK_C": 0,
    "CMYK_M": 0.3996096,
    "CMYK_Y": 0.3986766,
    "CMYK_K": 0.5307326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00754",
    "Farbtonhilfsbezeichnung": "C4.60.30",
    "Farbtonklasse": "04",
    "Rcolor": "160",
    "Gcolor": "53",
    "Bcolor": "47",
    "Y": 11,
    "L": 38.2095689933902,
    "a": 44.3833430352271,
    "b": 27.8466666515877,
    "C": 52.3957821068384,
    "h": 0.56033230552087,
    "CMY_C": 0.371717,
    "CMY_M": 0.7939798,
    "CMY_Y": 0.8160674,
    "CMYK_C": 0,
    "CMYK_M": 0.6720902,
    "CMYK_Y": 0.7072456,
    "CMYK_K": 0.371717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00755",
    "Farbtonhilfsbezeichnung": "N0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "129",
    "Bcolor": "111",
    "Y": 17,
    "L": 47.3721550945621,
    "a": -40.7417077128808,
    "b": -0.13347660849136,
    "C": 40.7419263580752,
    "h": 0.0032761545463,
    "CMY_C": 1,
    "CMY_M": 0.4926738,
    "CMY_Y": 0.5663916,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1453067,
    "CMYK_K": 0.4926738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00756",
    "Farbtonhilfsbezeichnung": "T0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "92",
    "Bcolor": "111",
    "Y": 11,
    "L": 37.8396299730693,
    "a": -4.16752365383879,
    "b": -14.5721869681572,
    "C": 15.156414036316,
    "h": 1.29224026441263,
    "CMY_C": 0.741381,
    "CMY_M": 0.6385161,
    "CMY_Y": 0.5630713,
    "CMYK_C": 0.4080981,
    "CMYK_M": 0.1726709,
    "CMYK_Y": 0,
    "CMYK_K": 0.5630713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00757",
    "Farbtonhilfsbezeichnung": "S0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "134",
    "Y": 12,
    "L": 38.4410490357219,
    "a": -15.1753845083,
    "b": -27.6768730292744,
    "C": 31.5642455264391,
    "h": 1.06925492848235,
    "CMY_C": 1,
    "CMY_M": 0.6096535,
    "CMY_Y": 0.4749894,
    "CMYK_C": 1,
    "CMYK_M": 0.2564979,
    "CMYK_Y": 0,
    "CMYK_K": 0.4749894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00758",
    "Farbtonhilfsbezeichnung": "P0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "202",
    "Bcolor": "197",
    "Y": 52,
    "L": 76.4673433545095,
    "a": -23.5685031013492,
    "b": -6.0132647007064,
    "C": 24.3235213486672,
    "h": 0.24981030224245,
    "CMY_C": 0.4992805,
    "CMY_M": 0.2095424,
    "CMY_Y": 0.2258552,
    "CMYK_C": 0.3665447,
    "CMYK_M": 0,
    "CMYK_Y": 0.02063722,
    "CMYK_K": 0.2095424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00759",
    "Farbtonhilfsbezeichnung": "C4.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "168",
    "Bcolor": "152",
    "Y": 49,
    "L": 74.8146216107716,
    "a": 23.1898585800261,
    "b": 17.4941591276468,
    "C": 29.0484964248588,
    "h": 0.64630374131132,
    "CMY_C": 0.07657439,
    "CMY_M": 0.3415225,
    "CMY_Y": 0.4042021,
    "CMYK_C": 0,
    "CMYK_M": 0.2869188,
    "CMYK_Y": 0.354796,
    "CMYK_K": 0.07657439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00760",
    "Farbtonhilfsbezeichnung": "F8.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "213",
    "Bcolor": "109",
    "Y": 71,
    "L": 87.1359786987305,
    "a": 3.18569612503052,
    "b": 55.8781929016113,
    "C": 55.9689292907715,
    "h": 86.7370147705078,
    "CMY_C": 0,
    "CMY_M": 0.16277503967285,
    "CMY_Y": 0.5742701292038,
    "CMYK_C": 0,
    "CMYK_M": 0.16277503967285,
    "CMYK_Y": 0.5742701292038,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00766",
    "Farbtonhilfsbezeichnung": "H2.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "187",
    "Y": 83,
    "L": 92.2500915527344,
    "a": -7.50413465499878,
    "b": 22.8478565216064,
    "C": 24.0486297607422,
    "h": 108.18221282959,
    "CMY_C": 0.07624787092209,
    "CMY_M": 0.07501393556595,
    "CMY_Y": 0.26592016220093,
    "CMYK_C": 0.00133400422055,
    "CMYK_M": 0,
    "CMYK_Y": 0.206388220191,
    "CMYK_K": 0.07501393556595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00767",
    "Farbtonhilfsbezeichnung": "D6.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "97",
    "Bcolor": "66",
    "Y": 17,
    "L": 46.1358753010593,
    "a": 17.9340589642131,
    "b": 25.6595688582532,
    "C": 31.3056535616701,
    "h": 0.96079364859365,
    "CMY_C": 0.4151596,
    "CMY_M": 0.6192263,
    "CMY_Y": 0.7395197,
    "CMYK_C": 0,
    "CMYK_M": 0.3489271,
    "CMYK_Y": 0.554613,
    "CMYK_K": 0.4151596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00768",
    "Farbtonhilfsbezeichnung": "G8.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "220",
    "Bcolor": "187",
    "Y": 73,
    "L": 87.5458502088133,
    "a": -2.9888789817078,
    "b": 16.5592685706431,
    "C": 16.826846797959,
    "h": -1.3922231575149,
    "CMY_C": 0.1118566,
    "CMY_M": 0.1363305,
    "CMY_Y": 0.2685283,
    "CMYK_C": 0,
    "CMYK_M": 0.0275562,
    "CMYK_Y": 0.1764036,
    "CMYK_K": 0.1118566
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00771",
    "Farbtonhilfsbezeichnung": "G0.50.80",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "217",
    "Bcolor": "84",
    "Y": 71,
    "L": 87.5490798950195,
    "a": -0.87455075979233,
    "b": 66.9226531982422,
    "C": 66.9283676147461,
    "h": 90.7487030029297,
    "CMY_C": 0.00606948137283,
    "CMY_M": 0.14980375766754,
    "CMY_Y": 0.6693412065506,
    "CMYK_C": 0,
    "CMYK_M": 0.14461199939251,
    "CMYK_Y": 0.66732203960419,
    "CMYK_K": 0.00606948137283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00775",
    "Farbtonhilfsbezeichnung": "D2.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "145",
    "Bcolor": "128",
    "Y": 32,
    "L": 63.17724609375,
    "a": 12.2460508346558,
    "b": 13.556939125061,
    "C": 18.2689990997314,
    "h": 47.9083404541016,
    "CMY_C": 0.28278994560242,
    "CMY_M": 0.432297706604,
    "CMY_Y": 0.49645739793777,
    "CMYK_C": 0,
    "CMYK_M": 0.2084574252367,
    "CMYK_Y": 0.29791474342346,
    "CMYK_K": 0.28278994560242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00777",
    "Farbtonhilfsbezeichnung": "B2.10.25",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "83",
    "Bcolor": "84",
    "Y": 9,
    "L": 37.3815498352051,
    "a": 9.50124549865723,
    "b": 1.90602838993073,
    "C": 9.69054222106934,
    "h": 11.3434391021729,
    "CMY_C": 0.59095728397369,
    "CMY_M": 0.67579245567322,
    "CMY_Y": 0.66864109039307,
    "CMYK_C": 0,
    "CMYK_M": 0.20739929378033,
    "CMYK_Y": 0.18991611897945,
    "CMYK_K": 0.59095728397369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00780",
    "Farbtonhilfsbezeichnung": "L0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "97",
    "Bcolor": "69",
    "Y": 11,
    "L": 37.5151419592352,
    "a": -19.8949369196494,
    "b": 11.4309851971224,
    "C": 22.9450634693753,
    "h": -0.5215092227066,
    "CMY_C": 0.7681938,
    "CMY_M": 0.6214861,
    "CMY_Y": 0.7310029,
    "CMYK_C": 0.3875889,
    "CMYK_M": 0,
    "CMYK_Y": 0.2893338,
    "CMYK_K": 0.6214861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00784",
    "Farbtonhilfsbezeichnung": "J0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "168",
    "Bcolor": "125",
    "Y": 38,
    "L": 66.991779836907,
    "a": -11.8554433637067,
    "b": 20.403855456148,
    "C": 23.598068879157,
    "h": -1.04443514376132,
    "CMY_C": 0.3898574,
    "CMY_M": 0.3399917,
    "CMY_Y": 0.5103583,
    "CMYK_C": 0.07555316,
    "CMYK_M": 0,
    "CMYK_Y": 0.258128,
    "CMYK_K": 0.3399917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00785",
    "Farbtonhilfsbezeichnung": "T0.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "142",
    "Bcolor": "178",
    "Y": 26,
    "L": 56.6821528513394,
    "a": -6.97022792386709,
    "b": -25.1972143312399,
    "C": 26.1435209443008,
    "h": 1.30091820651732,
    "CMY_C": 0.6503342,
    "CMY_M": 0.4443832,
    "CMY_Y": 0.3018469,
    "CMYK_C": 0.499156,
    "CMYK_M": 0.204162,
    "CMYK_Y": 0,
    "CMYK_K": 0.3018469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00792",
    "Farbtonhilfsbezeichnung": "G4.08.88",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "241",
    "Bcolor": "217",
    "Y": 87,
    "L": 94.9373397827148,
    "a": -1.50082087516785,
    "b": 11.1194772720337,
    "C": 11.2203044891357,
    "h": 97.6868896484375,
    "CMY_C": 0.03296637535095,
    "CMY_M": 0.05598878860474,
    "CMY_Y": 0.14772772789001,
    "CMYK_C": 0,
    "CMYK_M": 0.02380725182593,
    "CMYK_Y": 0.11867359280586,
    "CMYK_K": 0.03296637535095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00794",
    "Farbtonhilfsbezeichnung": "D6.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "212",
    "Bcolor": "195",
    "Y": 72,
    "L": 87.1446914672852,
    "a": 8.30032253265381,
    "b": 11.7473335266113,
    "C": 14.3838520050049,
    "h": 54.7560882568359,
    "CMY_C": 0.04711353778839,
    "CMY_M": 0.16684025526047,
    "CMY_Y": 0.23550462722778,
    "CMYK_C": 0,
    "CMYK_M": 0.12564636766911,
    "CMYK_Y": 0.19770570099354,
    "CMYK_K": 0.04711353778839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00795",
    "Farbtonhilfsbezeichnung": "D6.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "216",
    "Bcolor": "201",
    "Y": 74,
    "L": 87.8351008974538,
    "a": 6.2016131526435,
    "b": 9.48353417787373,
    "C": 11.3312588090618,
    "h": 0.99165995234885,
    "CMY_C": 0.06040221,
    "CMY_M": 0.1534244,
    "CMY_Y": 0.2117566,
    "CMYK_C": 0,
    "CMYK_M": 0.09900208,
    "CMYK_Y": 0.1610842,
    "CMYK_K": 0.06040221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00796",
    "Farbtonhilfsbezeichnung": "G0.55.80",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "213",
    "Bcolor": "64",
    "Y": 71,
    "L": 86.3102795820699,
    "a": -0.83189587005477,
    "b": 73.3899128975623,
    "C": 73.3946276361587,
    "h": -1.55946152327494,
    "CMY_C": 0.01406576,
    "CMY_M": 0.1642121,
    "CMY_Y": 0.7496455,
    "CMYK_C": 0,
    "CMYK_M": 0.1522884,
    "CMYK_Y": 0.7460738,
    "CMYK_K": 0.01406576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00799",
    "Farbtonhilfsbezeichnung": "E0.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "164",
    "Bcolor": "102",
    "Y": 48,
    "L": 74.4866676977258,
    "a": 25.6311669926331,
    "b": 43.7598140877447,
    "C": 50.7136870124646,
    "h": 1.0409401325394,
    "CMY_C": 0.02643059,
    "CMY_M": 0.3575343,
    "CMY_Y": 0.5983326,
    "CMYK_C": 0,
    "CMYK_M": 0.3400925,
    "CMYK_Y": 0.587428,
    "CMYK_K": 0.02643059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00800",
    "Farbtonhilfsbezeichnung": "E8.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "156",
    "Bcolor": "108",
    "Y": 37,
    "L": 67.1743392944336,
    "a": 10.0193681716919,
    "b": 30.4194526672363,
    "C": 32.0270347595215,
    "h": 71.7694778442383,
    "CMY_C": 0.22205173969269,
    "CMY_M": 0.3888778090477,
    "CMY_Y": 0.57584798336029,
    "CMYK_C": 0,
    "CMYK_M": 0.21444365382195,
    "CMYK_Y": 0.45478120446205,
    "CMYK_K": 0.22205173969269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00803",
    "Farbtonhilfsbezeichnung": "E0.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "138",
    "Gcolor": "128",
    "Bcolor": "120",
    "Y": 23,
    "L": 54.1587689224567,
    "a": 2.68965573865215,
    "b": 5.00220195096464,
    "C": 5.67946056863668,
    "h": 1.07744989348112,
    "CMY_C": 0.4592925,
    "CMY_M": 0.4990107,
    "CMY_Y": 0.5292739,
    "CMYK_C": 0,
    "CMYK_M": 0.07345597,
    "CMYK_Y": 0.1294255,
    "CMYK_K": 0.4592925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00804",
    "Farbtonhilfsbezeichnung": "P0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "168",
    "Bcolor": "165",
    "Y": 38,
    "L": 66.804003679595,
    "a": -10.052337013996,
    "b": -2.149545345671,
    "C": 10.2795926298687,
    "h": 0.21066273385092,
    "CMY_C": 0.450177,
    "CMY_M": 0.3404557,
    "CMY_Y": 0.3540086,
    "CMYK_C": 0.1663592,
    "CMYK_M": 0,
    "CMYK_Y": 0.02054901,
    "CMYK_K": 0.3404557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00806",
    "Farbtonhilfsbezeichnung": "FN.02.47",
    "Farbtonklasse": "01",
    "Rcolor": "133",
    "Gcolor": "131",
    "Bcolor": "126",
    "Y": 24,
    "L": 54.9132905182505,
    "a": 0.04971909090012,
    "b": 2.29136056341004,
    "C": 2.29189991481973,
    "h": 1.54910122961073,
    "CMY_C": 0.4773674,
    "CMY_M": 0.4850218,
    "CMY_Y": 0.5040768,
    "CMYK_C": 0,
    "CMYK_M": 0.01464576,
    "CMYK_Y": 0.05110543,
    "CMYK_K": 0.4773674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00807",
    "Farbtonhilfsbezeichnung": "FN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "180",
    "Bcolor": "174",
    "Y": 47,
    "L": 73.4985302299266,
    "a": 0.18517450467503,
    "b": 2.98657934153521,
    "C": 2.99231444879487,
    "h": 1.50887339014963,
    "CMY_C": 0.2810897,
    "CMY_M": 0.292841,
    "CMY_Y": 0.3186812,
    "CMYK_C": 0,
    "CMYK_M": 0.0163461,
    "CMYK_Y": 0.05228966,
    "CMYK_K": 0.2810897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00808",
    "Farbtonhilfsbezeichnung": "W0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "175",
    "Bcolor": "188",
    "Y": 45,
    "L": 72.1643905639648,
    "a": 3.61760330200195,
    "b": -6.92787599563599,
    "C": 7.81553077697754,
    "h": 297.572692871094,
    "CMY_C": 0.30250388383865,
    "CMY_M": 0.31209248304367,
    "CMY_Y": 0.26235038042068,
    "CMYK_C": 0.05443438515067,
    "CMYK_M": 0.06743323802948,
    "CMYK_Y": 0,
    "CMYK_K": 0.26235038042068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00809",
    "Farbtonhilfsbezeichnung": "W0.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "214",
    "Bcolor": "224",
    "Y": 67,
    "L": 86.0307464599609,
    "a": 3.3030149936676,
    "b": -5.58823776245117,
    "C": 6.4914026260376,
    "h": 300.585876464844,
    "CMY_C": 0.14987874031067,
    "CMY_M": 0.16189622879028,
    "CMY_Y": 0.1214365363121,
    "CMYK_C": 0.03237353265285,
    "CMYK_M": 0.04605209827423,
    "CMYK_Y": 0,
    "CMYK_K": 0.1214365363121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00810",
    "Farbtonhilfsbezeichnung": "S9.32.35",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "108",
    "Bcolor": "139",
    "Y": 15,
    "L": 43.5834718017356,
    "a": -6.89435196226185,
    "b": -22.505347627384,
    "C": 23.5376880939684,
    "h": 1.27353062522493,
    "CMY_C": 0.7677618,
    "CMY_M": 0.575874,
    "CMY_Y": 0.4556389,
    "CMYK_C": 0.5733746,
    "CMYK_M": 0.2208738,
    "CMYK_Y": 0,
    "CMYK_K": 0.4556389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00822",
    "Farbtonhilfsbezeichnung": "S0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "181",
    "Bcolor": "196",
    "Y": 45,
    "L": 71.6551260142425,
    "a": -7.50724021019156,
    "b": -12.071380155746,
    "C": 14.21537457959,
    "h": 1.01442641082415,
    "CMY_C": 0.4213023,
    "CMY_M": 0.2913962,
    "CMY_Y": 0.2328114,
    "CMYK_C": 0.2456905,
    "CMYK_M": 0.07636296,
    "CMYK_Y": 0,
    "CMYK_K": 0.2328114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00827",
    "Farbtonhilfsbezeichnung": "B6.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "98",
    "Bcolor": "97",
    "Y": 17,
    "L": 50.0692520141602,
    "a": 30.4588203430176,
    "b": 13.2215423583984,
    "C": 33.2046508789063,
    "h": 23.4646663665771,
    "CMY_C": 0.32169127464294,
    "CMY_M": 0.61582827568054,
    "CMY_Y": 0.61848795413971,
    "CMYK_C": 0,
    "CMYK_M": 0.43363294005394,
    "CMYK_Y": 0.43755397200584,
    "CMYK_K": 0.32169127464294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00832",
    "Farbtonhilfsbezeichnung": "G8.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "229",
    "Bcolor": "209",
    "Y": 80,
    "L": 90.8486159224686,
    "a": -1.77538063322313,
    "b": 9.60992013272657,
    "C": 9.77254016876918,
    "h": -1.38811154194436,
    "CMY_C": 0.08566488,
    "CMY_M": 0.1007742,
    "CMY_Y": 0.1812194,
    "CMYK_C": 0,
    "CMYK_M": 0.0165249,
    "CMYK_Y": 0.1045071,
    "CMYK_K": 0.08566488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00833",
    "Farbtonhilfsbezeichnung": "W0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "115",
    "Gcolor": "109",
    "Bcolor": "150",
    "Y": 18,
    "L": 47.9920405075998,
    "a": 11.8874350506314,
    "b": -21.9675549122159,
    "C": 24.9776816559143,
    "h": -1.07478394281553,
    "CMY_C": 0.5477479,
    "CMY_M": 0.5727698,
    "CMY_Y": 0.4125351,
    "CMYK_C": 0.2301631,
    "CMYK_M": 0.2727563,
    "CMYK_Y": 0,
    "CMYK_K": 0.4125351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00842",
    "Farbtonhilfsbezeichnung": "SN.02.47",
    "Farbtonklasse": "01",
    "Rcolor": "127",
    "Gcolor": "130",
    "Bcolor": "132",
    "Y": 23,
    "L": 54.2854344872001,
    "a": -0.74205185204845,
    "b": -1.87952158145621,
    "C": 2.0207034236345,
    "h": 1.194773028962,
    "CMY_C": 0.5023696,
    "CMY_M": 0.4885687,
    "CMY_Y": 0.482599,
    "CMYK_C": 0.03821138,
    "CMYK_M": 0.01153776,
    "CMYK_Y": 0,
    "CMYK_K": 0.482599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00852",
    "Farbtonhilfsbezeichnung": "B2.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "134",
    "Bcolor": "138",
    "Y": 35,
    "L": 66.0727691650391,
    "a": 36.7607612609863,
    "b": 12.7318525314331,
    "C": 38.9031295776367,
    "h": 19.1031970977783,
    "CMY_C": 0.10545873641968,
    "CMY_M": 0.47433829307556,
    "CMY_Y": 0.45735889673233,
    "CMYK_C": 0,
    "CMYK_M": 0.41236728429794,
    "CMYK_Y": 0.3933861553669,
    "CMYK_K": 0.10545873641968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00855",
    "Farbtonhilfsbezeichnung": "G4.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "223",
    "Bcolor": "195",
    "Y": 74,
    "L": 88.5406209742666,
    "a": -1.79096318349503,
    "b": 13.7742009840273,
    "C": 13.8901462149617,
    "h": -1.44149868728031,
    "CMY_C": 0.09946156,
    "CMY_M": 0.1274369,
    "CMY_Y": 0.2370626,
    "CMYK_C": 0,
    "CMYK_M": 0.03106509,
    "CMYK_Y": 0.1527986,
    "CMYK_K": 0.09946156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00856",
    "Farbtonhilfsbezeichnung": "P0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "129",
    "Bcolor": "126",
    "Y": 18,
    "L": 50.8334197998047,
    "a": -15.6137666702271,
    "b": -3.63840913772583,
    "C": 16.0320835113525,
    "h": 193.117309570312,
    "CMY_C": 0.66668200492859,
    "CMY_M": 0.49418932199478,
    "CMY_Y": 0.50696301460266,
    "CMYK_C": 0.34102222323418,
    "CMYK_M": 0,
    "CMYK_Y": 0.02525390125811,
    "CMYK_K": 0.49418932199478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00858",
    "Farbtonhilfsbezeichnung": "P0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "99",
    "Bcolor": "97",
    "Y": 12,
    "L": 39.1243776972864,
    "a": -13.346217143256,
    "b": -3.50552637739406,
    "C": 13.7989212338337,
    "h": 0.2568586398734,
    "CMY_C": 0.7566679,
    "CMY_M": 0.613295,
    "CMY_Y": 0.6210966,
    "CMYK_C": 0.3707551,
    "CMYK_M": 0,
    "CMYK_Y": 0.02017431,
    "CMYK_K": 0.613295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00879",
    "Farbtonhilfsbezeichnung": "C0.60.30",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "58",
    "Bcolor": "63",
    "Y": 11,
    "L": 41.2163162231445,
    "a": 46.3699264526367,
    "b": 21.9203548431396,
    "C": 51.2900772094727,
    "h": 25.3014049530029,
    "CMY_C": 0.3321641087532,
    "CMY_M": 0.77126801013947,
    "CMY_Y": 0.75172346830368,
    "CMYK_C": 0,
    "CMYK_M": 0.65750271081924,
    "CMYK_Y": 0.6282371878624,
    "CMYK_K": 0.3321641087532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00883",
    "Farbtonhilfsbezeichnung": "A6.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "89",
    "Bcolor": "114",
    "Y": 18,
    "L": 50.3687019348145,
    "a": 41.3592720031738,
    "b": 3.70030331611633,
    "C": 41.524471282959,
    "h": 5.11248779296875,
    "CMY_C": 0.27517902851105,
    "CMY_M": 0.64930486679077,
    "CMY_Y": 0.55190873146057,
    "CMYK_C": 0,
    "CMYK_M": 0.51616311073303,
    "CMYK_Y": 0.38179042935371,
    "CMYK_K": 0.27517902851105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00890",
    "Farbtonhilfsbezeichnung": "S0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "154",
    "Bcolor": "196",
    "Y": 26,
    "L": 58.5804176330566,
    "a": -20.4694957733154,
    "b": -32.874755859375,
    "C": 38.7266044616699,
    "h": 238.091506958008,
    "CMY_C": 1,
    "CMY_M": 0.39743661880493,
    "CMY_Y": 0.2300888299942,
    "CMYK_C": 1,
    "CMYK_M": 0.21735987067223,
    "CMYK_Y": 0,
    "CMYK_K": 0.2300888299942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00893",
    "Farbtonhilfsbezeichnung": "E4.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "178",
    "Bcolor": "169",
    "Y": 45,
    "L": 73.2866363525391,
    "a": 2.6203134059906,
    "b": 5.37365865707397,
    "C": 5.97848224639893,
    "h": 64.0051193237305,
    "CMY_C": 0.25835007429123,
    "CMY_M": 0.30130475759506,
    "CMY_Y": 0.33746546506882,
    "CMYK_C": 0,
    "CMYK_M": 0.05791773274541,
    "CMYK_Y": 0.10667484253645,
    "CMYK_K": 0.25835007429123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00915",
    "Farbtonhilfsbezeichnung": "L8.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "125",
    "Bcolor": "100",
    "Y": 17,
    "L": 48.2481842041016,
    "a": -22.4699115753174,
    "b": 7.49549531936646,
    "C": 23.6871147155762,
    "h": 161.552368164063,
    "CMY_C": 0.70633983612061,
    "CMY_M": 0.5112726688385,
    "CMY_Y": 0.60632759332657,
    "CMYK_C": 0.39913290739059,
    "CMYK_M": 0,
    "CMYK_Y": 0.19449479877949,
    "CMYK_K": 0.5112726688385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00918",
    "Farbtonhilfsbezeichnung": "J0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "205",
    "Bcolor": "188",
    "Y": 62,
    "L": 81.7946079089749,
    "a": -4.18626622554003,
    "b": 7.13457232262167,
    "C": 8.27205821653936,
    "h": -1.04017061619993,
    "CMY_C": 0.211808,
    "CMY_M": 0.1945133,
    "CMY_Y": 0.2610882,
    "CMYK_C": 0.02147121,
    "CMYK_M": 0,
    "CMYK_Y": 0.08265176,
    "CMYK_K": 0.1945133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00925",
    "Farbtonhilfsbezeichnung": "J0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "182",
    "Bcolor": "146",
    "Y": 45,
    "L": 72.387812659103,
    "a": -9.43162852621754,
    "b": 16.3445540488797,
    "C": 18.8706137609064,
    "h": -1.04742261656899,
    "CMY_C": 0.3256787,
    "CMY_M": 0.2869005,
    "CMY_Y": 0.4265504,
    "CMYK_C": 0.05437979,
    "CMYK_M": 0,
    "CMYK_Y": 0.195835,
    "CMYK_K": 0.2869005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00966",
    "Farbtonhilfsbezeichnung": "G0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "156",
    "Gcolor": "151",
    "Bcolor": "140",
    "Y": 32,
    "L": 62.6884745948901,
    "a": 0.21824912455065,
    "b": 5.79059351267612,
    "C": 5.79470498898899,
    "h": 1.53312387285484,
    "CMY_C": 0.3864892,
    "CMY_M": 0.4070368,
    "CMY_Y": 0.4498299,
    "CMYK_C": 0,
    "CMYK_M": 0.03349195,
    "CMYK_Y": 0.1032432,
    "CMYK_K": 0.3864892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00974",
    "Farbtonhilfsbezeichnung": "C0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "201",
    "Bcolor": "194",
    "Y": 64,
    "L": 83.3429558792223,
    "a": 10.2215374772709,
    "b": 6.49382448620008,
    "C": 12.1098961538415,
    "h": 0.56597749036386,
    "CMY_C": 0.09039616,
    "CMY_M": 0.2119676,
    "CMY_Y": 0.2377059,
    "CMYK_C": 0,
    "CMYK_M": 0.1336532,
    "CMYK_Y": 0.1619493,
    "CMYK_K": 0.09039616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI00983",
    "Farbtonhilfsbezeichnung": "D6.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "169",
    "Bcolor": "148",
    "Y": 45,
    "L": 72.3641252721904,
    "a": 11.4974981299062,
    "b": 15.8028168984144,
    "C": 19.5428115984371,
    "h": 0.94181214655065,
    "CMY_C": 0.1818317,
    "CMY_M": 0.3353204,
    "CMY_Y": 0.4194505,
    "CMYK_C": 0,
    "CMYK_M": 0.1876004,
    "CMYK_Y": 0.2904277,
    "CMYK_K": 0.1818317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01008",
    "Farbtonhilfsbezeichnung": "A0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "145",
    "Bcolor": "148",
    "Y": 31,
    "L": 61.8266987000396,
    "a": 7.854922323277,
    "b": 0.08218246889986,
    "C": 7.85535223035287,
    "h": 0.01046216207088,
    "CMY_C": 0.3585586,
    "CMY_M": 0.4319534,
    "CMY_Y": 0.4184894,
    "CMYK_C": 0,
    "CMYK_M": 0.1144217,
    "CMYK_Y": 0.09343143,
    "CMYK_K": 0.3585586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01012",
    "Farbtonhilfsbezeichnung": "W0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "110",
    "Bcolor": "167",
    "Y": 17,
    "L": 49.1408576965332,
    "a": 16.3124885559082,
    "b": -30.4435997009277,
    "C": 34.5385284423828,
    "h": 298.18359375,
    "CMY_C": 0.54133427143097,
    "CMY_M": 0.56896674633026,
    "CMY_Y": 0.3443478345871,
    "CMYK_C": 0.30044350028038,
    "CMYK_M": 0.34258854389191,
    "CMYK_Y": 0,
    "CMYK_K": 0.3443478345871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01039",
    "Farbtonhilfsbezeichnung": "G8.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "121",
    "Y": 53,
    "L": 76.6293063437445,
    "a": -6.95912228224599,
    "b": 35.9995328780353,
    "C": 36.6660026506299,
    "h": -1.37984024874834,
    "CMY_C": 0.2174273,
    "CMY_M": 0.2503987,
    "CMY_Y": 0.5268443,
    "CMYK_C": 0,
    "CMYK_M": 0.04213212,
    "CMYK_Y": 0.3953843,
    "CMYK_K": 0.2174273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01054",
    "Farbtonhilfsbezeichnung": "B2.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "138",
    "Gcolor": "71",
    "Bcolor": "78",
    "Y": 12,
    "L": 38.5617161804632,
    "a": 29.3396642662181,
    "b": 8.25532334081139,
    "C": 30.4789478610358,
    "h": 0.27427934628688,
    "CMY_C": 0.4602467,
    "CMY_M": 0.7223121,
    "CMY_Y": 0.6941041,
    "CMYK_C": 0,
    "CMYK_M": 0.485528,
    "CMYK_Y": 0.4332672,
    "CMYK_K": 0.4602467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01055",
    "Farbtonhilfsbezeichnung": "B2.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "61",
    "Bcolor": "64",
    "Y": 7,
    "L": 30.0558424354229,
    "a": 16.3566089325904,
    "b": 4.49208652189034,
    "C": 16.9622373846685,
    "h": 0.26802622925439,
    "CMY_C": 0.6196344,
    "CMY_M": 0.7603745,
    "CMY_Y": 0.7496136,
    "CMYK_C": 0,
    "CMYK_M": 0.3700126,
    "CMYK_Y": 0.3417218,
    "CMYK_K": 0.6196344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01056",
    "Farbtonhilfsbezeichnung": "D2.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "194",
    "Bcolor": "172",
    "Y": 60,
    "L": 82.3787155151367,
    "a": 15.1478624343872,
    "b": 17.4822559356689,
    "C": 23.1319484710693,
    "h": 49.0920295715332,
    "CMY_C": 0.04106324911118,
    "CMY_M": 0.23809766769409,
    "CMY_Y": 0.32693862915039,
    "CMYK_C": 0,
    "CMYK_M": 0.2054717540741,
    "CMYK_Y": 0.29811704158783,
    "CMYK_K": 0.04106324911118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01057",
    "Farbtonhilfsbezeichnung": "E0.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "146",
    "Bcolor": "126",
    "Y": 32,
    "L": 62.8447036743164,
    "a": 8.29976177215576,
    "b": 14.269814491272,
    "C": 16.5079879760742,
    "h": 59.81640625,
    "CMY_C": 0.30987459421158,
    "CMY_M": 0.42609387636185,
    "CMY_Y": 0.50534737110138,
    "CMYK_C": 0,
    "CMYK_M": 0.16840313374996,
    "CMYK_Y": 0.28324240446091,
    "CMYK_K": 0.30987459421158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01059",
    "Farbtonhilfsbezeichnung": "F6.45.75",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "193",
    "Bcolor": "85",
    "Y": 60,
    "L": 80.3535871133127,
    "a": 5.92913753150337,
    "b": 58.799581012338,
    "C": 59.0977613712566,
    "h": 1.47029963333284,
    "CMY_C": 0.05774096,
    "CMY_M": 0.2436357,
    "CMY_Y": 0.6682647,
    "CMYK_C": 0,
    "CMYK_M": 0.1972863,
    "CMYK_Y": 0.6479362,
    "CMYK_K": 0.05774096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01066",
    "Farbtonhilfsbezeichnung": "F6.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "190",
    "Bcolor": "177",
    "Y": 52,
    "L": 77.1220397949219,
    "a": 0.69271832704544,
    "b": 6.41520118713379,
    "C": 6.45249271392822,
    "h": 83.8370361328125,
    "CMY_C": 0.22791975736618,
    "CMY_M": 0.25607007741928,
    "CMY_Y": 0.30483114719391,
    "CMYK_C": 0,
    "CMYK_M": 0.0364603549242,
    "CMYK_Y": 0.09961579740047,
    "CMYK_K": 0.22791975736618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01067",
    "Farbtonhilfsbezeichnung": "E4.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "151",
    "Bcolor": "144",
    "Y": 32,
    "L": 63.1096839904785,
    "a": 1.87770557403564,
    "b": 4.56887531280518,
    "C": 4.93967628479004,
    "h": 67.6584320068359,
    "CMY_C": 0.37384217977524,
    "CMY_M": 0.40606248378754,
    "CMY_Y": 0.43693733215332,
    "CMYK_C": 0,
    "CMYK_M": 0.05145716294646,
    "CMYK_Y": 0.10076557099819,
    "CMYK_K": 0.37384217977524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01068",
    "Farbtonhilfsbezeichnung": "S0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "143",
    "Bcolor": "152",
    "Y": 27,
    "L": 58.4692268371582,
    "a": -3.79027032852173,
    "b": -7.07716751098633,
    "C": 8.02822780609131,
    "h": 241.828140258789,
    "CMY_C": 0.50279748439789,
    "CMY_M": 0.43835628032684,
    "CMY_Y": 0.40563887357712,
    "CMYK_C": 0.16346730291843,
    "CMYK_M": 0.05504634231329,
    "CMYK_Y": 0,
    "CMYK_K": 0.40563887357712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01069",
    "Farbtonhilfsbezeichnung": "S0.05.25",
    "Farbtonklasse": "02",
    "Rcolor": "76",
    "Gcolor": "82",
    "Bcolor": "85",
    "Y": 9,
    "L": 34.363332156751,
    "a": -1.44425997626155,
    "b": -3.31086647842036,
    "C": 3.61216330153533,
    "h": 1.15946232364838,
    "CMY_C": 0.7031901,
    "CMY_M": 0.6793204,
    "CMY_Y": 0.6656871,
    "CMYK_C": 0.1121791,
    "CMYK_M": 0.04077988,
    "CMYK_Y": 0,
    "CMYK_K": 0.6656871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01070",
    "Farbtonhilfsbezeichnung": "T0.50.30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "144",
    "Y": 11,
    "L": 38.4709100825187,
    "a": -8.7351205903205,
    "b": -33.7019651900484,
    "C": 34.8155825658379,
    "h": 1.31718968041992,
    "CMY_C": 1,
    "CMY_M": 0.6175343,
    "CMY_Y": 0.4357304,
    "CMYK_C": 1,
    "CMYK_M": 0.3221934,
    "CMYK_Y": 0,
    "CMYK_K": 0.4357304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01075",
    "Farbtonhilfsbezeichnung": "H2.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "219",
    "Bcolor": "110",
    "Y": 70,
    "L": 85.393595015592,
    "a": -14.9964302473245,
    "b": 52.1977720123326,
    "C": 54.3093023635391,
    "h": -1.29103106178859,
    "CMY_C": 0.1468342,
    "CMY_M": 0.1400705,
    "CMY_Y": 0.5673586,
    "CMYK_C": 0.007865342,
    "CMYK_M": 0,
    "CMYK_Y": 0.4968873,
    "CMYK_K": 0.1400705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01076",
    "Farbtonhilfsbezeichnung": "J0.30.80",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "222",
    "Bcolor": "141",
    "Y": 69,
    "L": 84.9772436751417,
    "a": -20.7349997474595,
    "b": 36.3417975068089,
    "C": 41.840966295642,
    "h": -1.05230888525018,
    "CMY_C": 0.2253385,
    "CMY_M": 0.1304854,
    "CMY_Y": 0.4472485,
    "CMYK_C": 0.1090874,
    "CMYK_M": 0,
    "CMYK_Y": 0.3642988,
    "CMYK_K": 0.1304854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01077",
    "Farbtonhilfsbezeichnung": "B2.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "110",
    "Bcolor": "118",
    "Y": 27,
    "L": 57.9199604876816,
    "a": 39.4921285034582,
    "b": 12.8141502855356,
    "C": 41.5190397441216,
    "h": 0.31375564999788,
    "CMY_C": 0.1845725,
    "CMY_M": 0.5682546,
    "CMY_Y": 0.5384233,
    "CMYK_C": 0,
    "CMYK_M": 0.4705287,
    "CMYK_Y": 0.4339451,
    "CMYK_K": 0.1845725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01079",
    "Farbtonhilfsbezeichnung": "E4.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "80",
    "Bcolor": "60",
    "Y": 10,
    "L": 35.8388498653062,
    "a": 7.3001466674619,
    "b": 14.9384398416947,
    "C": 16.6267593436119,
    "h": 1.11624404400827,
    "CMY_C": 0.5938904,
    "CMY_M": 0.6878341,
    "CMY_Y": 0.7639663,
    "CMYK_C": 0,
    "CMYK_M": 0.231326,
    "CMYK_Y": 0.418793,
    "CMYK_K": 0.5938904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01080",
    "Farbtonhilfsbezeichnung": "T0.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "174",
    "Bcolor": "217",
    "Y": 37,
    "L": 68.3871536254883,
    "a": -8.54887104034424,
    "b": -28.9436073303223,
    "C": 30.1797218322754,
    "h": 253.544815063477,
    "CMY_C": 0.57032740116119,
    "CMY_M": 0.31827008724213,
    "CMY_Y": 0.14953076839447,
    "CMYK_C": 0.4947817325592,
    "CMYK_M": 0.19840732216835,
    "CMYK_Y": 0,
    "CMYK_K": 0.14953076839447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01085",
    "Farbtonhilfsbezeichnung": "B2.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "178",
    "Bcolor": "177",
    "Y": 52,
    "L": 76.259897088476,
    "a": 16.0533832013695,
    "b": 5.38121348228879,
    "C": 16.9312896954715,
    "h": 0.32343630079527,
    "CMY_C": 0.1325801,
    "CMY_M": 0.303196,
    "CMY_Y": 0.3042645,
    "CMYK_C": 0,
    "CMYK_M": 0.1966936,
    "CMYK_Y": 0.1979253,
    "CMYK_K": 0.1325801
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01090",
    "Farbtonhilfsbezeichnung": "S0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "123",
    "Bcolor": "138",
    "Y": 18,
    "L": 49.6540870666504,
    "a": -7.27825975418091,
    "b": -12.454137802124,
    "C": 14.4249305725098,
    "h": 239.697769165039,
    "CMY_C": 0.64448952674866,
    "CMY_M": 0.51873588562012,
    "CMY_Y": 0.45983165502548,
    "CMYK_C": 0.34185245633125,
    "CMYK_M": 0.10904791206121,
    "CMYK_Y": 0,
    "CMYK_K": 0.45983165502548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01093",
    "Farbtonhilfsbezeichnung": "N0.28.70",
    "Farbtonklasse": "02",
    "Rcolor": "103",
    "Gcolor": "204",
    "Bcolor": "182",
    "Y": 51,
    "L": 75.6248668783986,
    "a": -34.4079312558901,
    "b": 0.85645552050404,
    "C": 34.4185887184333,
    "h": -0.02488608515715,
    "CMY_C": 0.5971126,
    "CMY_M": 0.2013196,
    "CMY_Y": 0.2853361,
    "CMYK_C": 0.4955586,
    "CMYK_M": 0,
    "CMYK_Y": 0.1051942,
    "CMYK_K": 0.2013196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01094",
    "Farbtonhilfsbezeichnung": "B2.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "98",
    "Bcolor": "109",
    "Y": 26,
    "L": 56.8944528341394,
    "a": 48.1206005691514,
    "b": 16.9131986223737,
    "C": 51.0063573172568,
    "h": 0.33798844065295,
    "CMY_C": 0.1448349,
    "CMY_M": 0.6143668,
    "CMY_Y": 0.5739,
    "CMYK_C": 0,
    "CMYK_M": 0.5490541,
    "CMYK_Y": 0.5017337,
    "CMYK_K": 0.1448349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01099",
    "Farbtonhilfsbezeichnung": "S0.30.50",
    "Farbtonklasse": "02",
    "Rcolor": "79",
    "Gcolor": "147",
    "Bcolor": "174",
    "Y": 26,
    "L": 57.5992068107408,
    "a": -13.1468218770798,
    "b": -21.7325687977931,
    "C": 25.3996746439492,
    "h": 1.02675502598534,
    "CMY_C": 0.6886829,
    "CMY_M": 0.4244685,
    "CMY_Y": 0.3162066,
    "CMYK_C": 0.5447205,
    "CMYK_M": 0.1583255,
    "CMYK_Y": 0,
    "CMYK_K": 0.3162066
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01103",
    "Farbtonhilfsbezeichnung": "G8.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "223",
    "Bcolor": "114",
    "Y": 72,
    "L": 87.1639603193601,
    "a": -12.0873872558415,
    "b": 52.7607812257143,
    "C": 54.127672832114,
    "h": -1.34558482861212,
    "CMY_C": 0.1050598,
    "CMY_M": 0.1268081,
    "CMY_Y": 0.5528695,
    "CMYK_C": 0,
    "CMYK_M": 0.02430137,
    "CMYK_Y": 0.5003794,
    "CMYK_K": 0.1050598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01107",
    "Farbtonhilfsbezeichnung": "T0.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "129",
    "Bcolor": "185",
    "Y": 19,
    "L": 50.6409301757813,
    "a": -10.6652297973633,
    "b": -38.5716133117676,
    "C": 40.0189514160156,
    "h": 254.543640136719,
    "CMY_C": 1,
    "CMY_M": 0.49329894781113,
    "CMY_Y": 0.27613359689713,
    "CMYK_C": 1,
    "CMYK_M": 0.30000749230385,
    "CMYK_Y": 0,
    "CMYK_K": 0.27613359689713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01109",
    "Farbtonhilfsbezeichnung": "C0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 7,
    "L": 30.01747147926,
    "a": 27.6415107971878,
    "b": 14.6067880135177,
    "C": 31.2635790533153,
    "h": 0.48613729936877,
    "CMY_C": 0.5513072,
    "CMY_M": 0.7978528,
    "CMY_Y": 0.8082276,
    "CMYK_C": 0,
    "CMYK_M": 0.5494753,
    "CMYK_Y": 0.5725974,
    "CMYK_K": 0.5513072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01110",
    "Farbtonhilfsbezeichnung": "U0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "71",
    "Bcolor": "111",
    "Y": 7,
    "L": 28.9212701261093,
    "a": -1.06275150216104,
    "b": -28.0757249505396,
    "C": 28.0958319373835,
    "h": 1.53296135187483,
    "CMY_C": 0.9165345,
    "CMY_M": 0.7215838,
    "CMY_Y": 0.566237,
    "CMYK_C": 0.8075782,
    "CMYK_M": 0.3581376,
    "CMYK_Y": 0,
    "CMYK_K": 0.566237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01111",
    "Farbtonhilfsbezeichnung": "J0.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "228",
    "Bcolor": "205",
    "Y": 77,
    "L": 89.7148971557617,
    "a": -5.50335884094238,
    "b": 9.94291019439697,
    "C": 11.3643484115601,
    "h": 118.964340209961,
    "CMY_C": 0.12620866298676,
    "CMY_M": 0.1048469543457,
    "CMY_Y": 0.19658136367798,
    "CMYK_C": 0.0238637495786,
    "CMYK_M": 0,
    "CMYK_Y": 0.10247902572155,
    "CMYK_K": 0.1048469543457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01116",
    "Farbtonhilfsbezeichnung": "S8.10.65",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "176",
    "Bcolor": "190",
    "Y": 43,
    "L": 70.8672145684169,
    "a": -3.45502221966004,
    "b": -10.1796976068108,
    "C": 10.7500428791915,
    "h": 1.24359285165973,
    "CMY_C": 0.3855765,
    "CMY_M": 0.3089848,
    "CMY_Y": 0.2541527,
    "CMYK_C": 0.1762075,
    "CMYK_M": 0.07351659,
    "CMYK_Y": 0,
    "CMYK_K": 0.2541527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01117",
    "Farbtonhilfsbezeichnung": "P0.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "181",
    "Bcolor": "179",
    "Y": 46,
    "L": 72.3786661248081,
    "a": -5.90949637205945,
    "b": -1.61785734146827,
    "C": 6.12695762583083,
    "h": 0.2672246161771,
    "CMY_C": 0.3559056,
    "CMY_M": 0.2900915,
    "CMY_Y": 0.2987188,
    "CMYK_C": 0.09270786,
    "CMYK_M": 0,
    "CMYK_Y": 0.01215266,
    "CMYK_K": 0.2900915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01120",
    "Farbtonhilfsbezeichnung": "P0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "124",
    "Bcolor": "123",
    "Y": 18,
    "L": 50.5346908569336,
    "a": -7.32426071166992,
    "b": -2.2099130153656,
    "C": 7.65039300918579,
    "h": 196.789886474609,
    "CMY_C": 0.59067213535309,
    "CMY_M": 0.5127135515213,
    "CMY_Y": 0.51845061779022,
    "CMYK_C": 0.15998512506485,
    "CMYK_M": 0,
    "CMYK_Y": 0.01177349872887,
    "CMYK_K": 0.5127135515213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01121",
    "Farbtonhilfsbezeichnung": "C4.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "107",
    "Bcolor": "90",
    "Y": 24,
    "L": 56.3606452941895,
    "a": 37.4023780822754,
    "b": 26.5944271087646,
    "C": 45.8933715820313,
    "h": 35.4141845703125,
    "CMY_C": 0.19569039344788,
    "CMY_M": 0.57991349697113,
    "CMY_Y": 0.64646029472351,
    "CMYK_C": 0,
    "CMYK_M": 0.47770547866821,
    "CMYK_Y": 0.56044328212738,
    "CMYK_K": 0.19569039344788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01123",
    "Farbtonhilfsbezeichnung": "Q0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "195",
    "Bcolor": "198",
    "Y": 52,
    "L": 76.5878233789443,
    "a": -9.64173667967932,
    "b": -5.68182729493032,
    "C": 11.1913469971085,
    "h": 0.53251099660761,
    "CMY_C": 0.3594227,
    "CMY_M": 0.2358162,
    "CMY_Y": 0.2253432,
    "CMYK_C": 0.1730825,
    "CMYK_M": 0.01351951,
    "CMYK_Y": 0,
    "CMYK_K": 0.2253432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01124",
    "Farbtonhilfsbezeichnung": "L0.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "217",
    "Bcolor": "205",
    "Y": 68,
    "L": 85.4081420898438,
    "a": -5.78394317626953,
    "b": 3.43496608734131,
    "C": 6.72703409194946,
    "h": 149.294784545898,
    "CMY_C": 0.19724953174591,
    "CMY_M": 0.15027362108231,
    "CMY_Y": 0.19544070959091,
    "CMYK_C": 0.05528357252479,
    "CMYK_M": 0,
    "CMYK_Y": 0.05315486341715,
    "CMYK_K": 0.15027362108231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01126",
    "Farbtonhilfsbezeichnung": "C8.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "117",
    "Bcolor": "95",
    "Y": 26,
    "L": 57.1640501066785,
    "a": 28.8324544390967,
    "b": 24.4034086119851,
    "C": 37.7734930985485,
    "h": 0.70239266699126,
    "CMY_C": 0.2350392,
    "CMY_M": 0.5424865,
    "CMY_Y": 0.626025,
    "CMYK_C": 0,
    "CMYK_M": 0.4019125,
    "CMYK_Y": 0.5111187,
    "CMYK_K": 0.2350392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01127",
    "Farbtonhilfsbezeichnung": "G4.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "155",
    "Bcolor": "144",
    "Y": 34,
    "L": 63.8592533367552,
    "a": -0.4577240148817,
    "b": 5.16033602029857,
    "C": 5.18059640545279,
    "h": -1.48232743127986,
    "CMY_C": 0.3809307,
    "CMY_M": 0.3932856,
    "CMY_Y": 0.433711,
    "CMYK_C": 0,
    "CMYK_M": 0.01995722,
    "CMYK_Y": 0.08525744,
    "CMYK_K": 0.3809307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01128",
    "Farbtonhilfsbezeichnung": "S5.48.41",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "172",
    "Y": 19,
    "L": 49.2912538148627,
    "a": -14.4153224306211,
    "b": -33.4170756460456,
    "C": 36.3937146429477,
    "h": 1.16353761945126,
    "CMY_C": 1,
    "CMY_M": 0.5023081,
    "CMY_Y": 0.3253128,
    "CMYK_C": 1,
    "CMYK_M": 0.2623368,
    "CMYK_Y": 0,
    "CMYK_K": 0.3253128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01129",
    "Farbtonhilfsbezeichnung": "U4.15.10",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "48",
    "Bcolor": "62",
    "Y": 4,
    "L": 19.9610011037315,
    "a": 1.10064465682863,
    "b": -9.76224996604841,
    "C": 9.82410011452538,
    "h": -1.45852545479319,
    "CMY_C": 0.8359569,
    "CMY_M": 0.8102984,
    "CMY_Y": 0.7574926,
    "CMYK_C": 0.3235545,
    "CMYK_M": 0.2177495,
    "CMYK_Y": 0,
    "CMYK_K": 0.7574926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01131",
    "Farbtonhilfsbezeichnung": "D6.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "204",
    "Bcolor": "191",
    "Y": 64,
    "L": 83.6527252197266,
    "a": 6.2833046913147,
    "b": 8.82095527648926,
    "C": 10.8300123214722,
    "h": 54.5371360778809,
    "CMY_C": 0.10860097408295,
    "CMY_M": 0.19929337501526,
    "CMY_Y": 0.25190263986588,
    "CMYK_C": 0,
    "CMYK_M": 0.10174164175987,
    "CMYK_Y": 0.16076040267944,
    "CMYK_K": 0.10860097408295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01134",
    "Farbtonhilfsbezeichnung": "F0.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "197",
    "Bcolor": "165",
    "Y": 59,
    "L": 80.6103212626082,
    "a": 3.96077268583117,
    "b": 18.0365183312276,
    "C": 18.4662858686184,
    "h": 1.35463005976944,
    "CMY_C": 0.135567,
    "CMY_M": 0.2289924,
    "CMY_Y": 0.3514935,
    "CMYK_C": 0,
    "CMYK_M": 0.1080771,
    "CMYK_Y": 0.2497897,
    "CMYK_K": 0.135567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01135",
    "Farbtonhilfsbezeichnung": "D2.30.40",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "103",
    "Bcolor": "78",
    "Y": 18,
    "L": 49.0839721084532,
    "a": 20.1272824375637,
    "b": 22.9361570441242,
    "C": 30.5151568613728,
    "h": 0.85053233143346,
    "CMY_C": 0.3746446,
    "CMY_M": 0.5962656,
    "CMY_Y": 0.6938193,
    "CMYK_C": 0,
    "CMYK_M": 0.3543921,
    "CMYK_Y": 0.5103893,
    "CMYK_K": 0.3746446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01136",
    "Farbtonhilfsbezeichnung": "F6.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "217",
    "Bcolor": "199",
    "Y": 72,
    "L": 86.9135062863577,
    "a": 0.02578192136493,
    "b": 9.10131993047814,
    "C": 9.10135644749659,
    "h": 1.5679635670854,
    "CMY_C": 0.1174077,
    "CMY_M": 0.1485261,
    "CMY_Y": 0.2198576,
    "CMYK_C": 0,
    "CMYK_M": 0.03525791,
    "CMYK_Y": 0.1160784,
    "CMYK_K": 0.1174077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01138",
    "Farbtonhilfsbezeichnung": "E8.35.55",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "146",
    "Bcolor": "91",
    "Y": 34,
    "L": 64.0748766876276,
    "a": 11.6838565314653,
    "b": 35.6190778025566,
    "C": 37.4864136315071,
    "h": 1.25383317457948,
    "CMY_C": 0.2393643,
    "CMY_M": 0.4259886,
    "CMY_Y": 0.6433196,
    "CMYK_C": 0,
    "CMYK_M": 0.2453531,
    "CMYK_Y": 0.531076,
    "CMYK_K": 0.2393643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01139",
    "Farbtonhilfsbezeichnung": "L0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "98",
    "Bcolor": "81",
    "Y": 12,
    "L": 39.4977882676111,
    "a": -11.7240354599252,
    "b": 6.85450417530978,
    "C": 13.5807670974405,
    "h": -0.5290592465858,
    "CMY_C": 0.698153,
    "CMY_M": 0.6147035,
    "CMY_Y": 0.6828606,
    "CMYK_C": 0.2165849,
    "CMYK_M": 0,
    "CMYK_Y": 0.1768951,
    "CMYK_K": 0.6147035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01140",
    "Farbtonhilfsbezeichnung": "E4.15.25",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "84",
    "Bcolor": "74",
    "Y": 9,
    "L": 36.800106048584,
    "a": 4.02950525283813,
    "b": 7.81836843490601,
    "C": 8.79566955566406,
    "h": 62.7338943481445,
    "CMY_C": 0.61603653430939,
    "CMY_M": 0.67034494876862,
    "CMY_Y": 0.71141755580902,
    "CMYK_C": 0,
    "CMYK_M": 0.14144161343575,
    "CMYK_Y": 0.24841171503067,
    "CMYK_K": 0.61603653430939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01141",
    "Farbtonhilfsbezeichnung": "E4.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "144",
    "Bcolor": "66",
    "Y": 37,
    "L": 66.8857306260896,
    "a": 24.4348346265439,
    "b": 52.0917100884377,
    "C": 57.537877986283,
    "h": 1.13219467323395,
    "CMY_C": 0.1160452,
    "CMY_M": 0.4345356,
    "CMY_Y": 0.7393122,
    "CMYK_C": 0,
    "CMYK_M": 0.3603016,
    "CMYK_Y": 0.7050892,
    "CMYK_K": 0.1160452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01143",
    "Farbtonhilfsbezeichnung": "K2.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "220",
    "Bcolor": "194",
    "Y": 70,
    "L": 85.7784675079443,
    "a": -10.2705412145161,
    "b": 9.64609078606635,
    "C": 14.0901059006704,
    "h": -0.75405521683707,
    "CMY_C": 0.2084564,
    "CMY_M": 0.1379271,
    "CMY_Y": 0.2376232,
    "CMYK_C": 0.08181366,
    "CMYK_M": 0,
    "CMYK_Y": 0.115647,
    "CMYK_K": 0.1379271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01148",
    "Farbtonhilfsbezeichnung": "J0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "181",
    "Bcolor": "168",
    "Y": 45,
    "L": 72.8850936889648,
    "a": -3.52533626556396,
    "b": 5.11103487014771,
    "C": 6.20891904830933,
    "h": 124.595970153809,
    "CMY_C": 0.30885553359985,
    "CMY_M": 0.29160892963409,
    "CMY_Y": 0.34067386388779,
    "CMYK_C": 0.02434616163373,
    "CMYK_M": 0,
    "CMYK_Y": 0.06926249712706,
    "CMYK_K": 0.29160892963409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01149",
    "Farbtonhilfsbezeichnung": "L0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "121",
    "Bcolor": "86",
    "Y": 17,
    "L": 46.6432666816316,
    "a": -24.9868681924396,
    "b": 13.4699330529278,
    "C": 28.3863114637444,
    "h": -0.49442107137384,
    "CMY_C": 0.7216062,
    "CMY_M": 0.5245622,
    "CMY_Y": 0.6613269,
    "CMYK_C": 0.4144474,
    "CMYK_M": 0,
    "CMYK_Y": 0.2876606,
    "CMYK_K": 0.5245622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01150",
    "Farbtonhilfsbezeichnung": "C8.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "190",
    "Bcolor": "172",
    "Y": 59,
    "L": 81.0208282470703,
    "a": 16.7954139709473,
    "b": 15.2508277893066,
    "C": 22.6864204406738,
    "h": 42.2405548095703,
    "CMY_C": 0.05062532424927,
    "CMY_M": 0.25666600465775,
    "CMY_Y": 0.32473856210709,
    "CMYK_C": 0,
    "CMYK_M": 0.21702778339386,
    "CMYK_Y": 0.28873029351234,
    "CMYK_K": 0.05062532424927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01151",
    "Farbtonhilfsbezeichnung": "D2.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "167",
    "Bcolor": "146",
    "Y": 44,
    "L": 72.2174080679761,
    "a": 14.1707102063224,
    "b": 16.5752981787596,
    "C": 21.8070983275254,
    "h": 0.86344742729143,
    "CMY_C": 0.1646114,
    "CMY_M": 0.3439586,
    "CMY_Y": 0.4259517,
    "CMYK_C": 0,
    "CMYK_M": 0.2146872,
    "CMYK_Y": 0.3128369,
    "CMYK_K": 0.1646114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01152",
    "Farbtonhilfsbezeichnung": "E0.40.60",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "143",
    "Bcolor": "88",
    "Y": 36,
    "L": 65.8637369432226,
    "a": 23.2240282074243,
    "b": 39.7095693210627,
    "C": 46.002232357175,
    "h": 1.04159314719867,
    "CMY_C": 0.1471222,
    "CMY_M": 0.4397238,
    "CMY_Y": 0.652945,
    "CMYK_C": 0,
    "CMYK_M": 0.3430756,
    "CMYK_Y": 0.5930777,
    "CMYK_K": 0.1471222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01153",
    "Farbtonhilfsbezeichnung": "E0.05.25",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "74",
    "Bcolor": "68",
    "Y": 9,
    "L": 31.8950161486921,
    "a": 2.58522570509659,
    "b": 4.3083249996639,
    "C": 5.02444586487118,
    "h": 1.03033745339411,
    "CMY_C": 0.6787216,
    "CMY_M": 0.7117063,
    "CMY_Y": 0.7340927,
    "CMYK_C": 0,
    "CMYK_M": 0.102667,
    "CMYK_Y": 0.1723461,
    "CMYK_K": 0.6787216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01157",
    "Farbtonhilfsbezeichnung": "U0.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "177",
    "Bcolor": "187",
    "Y": 46,
    "L": 72.0000482497923,
    "a": 0.00119197754455,
    "b": -6.708936394987,
    "C": 6.70893650087639,
    "h": -1.57061865667525,
    "CMY_C": 0.3315897,
    "CMY_M": 0.3056405,
    "CMY_Y": 0.2660873,
    "CMYK_C": 0.08925092,
    "CMYK_M": 0.05389355,
    "CMYK_Y": 0,
    "CMYK_K": 0.2660873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01159",
    "Farbtonhilfsbezeichnung": "S0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "91",
    "Bcolor": "104",
    "Y": 11,
    "L": 37.1942744878902,
    "a": -6.43470323175774,
    "b": -10.9528668173937,
    "C": 12.7031766578426,
    "h": 1.03962590376993,
    "CMY_C": 0.7486449,
    "CMY_M": 0.6415699,
    "CMY_Y": 0.5921616,
    "CMYK_C": 0.3836896,
    "CMYK_M": 0.1211469,
    "CMYK_Y": 0,
    "CMYK_K": 0.5921616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01160",
    "Farbtonhilfsbezeichnung": "E0.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "142",
    "Bcolor": "79",
    "Y": 38,
    "L": 68.1322555541992,
    "a": 30.9863204956055,
    "b": 48.0188064575195,
    "C": 57.1485595703125,
    "h": 57.1660308837891,
    "CMY_C": 0.06835049390793,
    "CMY_M": 0.44122534990311,
    "CMY_Y": 0.69157660007477,
    "CMYK_C": 0,
    "CMYK_M": 0.40023082494736,
    "CMYK_Y": 0.66894912719727,
    "CMYK_K": 0.06835049390793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01162",
    "Farbtonhilfsbezeichnung": "E8.55.70",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "171",
    "Bcolor": "67",
    "Y": 51,
    "L": 76.7871246337891,
    "a": 22.9381141662598,
    "b": 63.1477584838867,
    "C": 67.1847915649414,
    "h": 70.0366973876953,
    "CMY_C": 0,
    "CMY_M": 0.32788169384003,
    "CMY_Y": 0.73694294691086,
    "CMYK_C": 0,
    "CMYK_M": 0.32788169384003,
    "CMYK_Y": 0.73694294691086,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01167",
    "Farbtonhilfsbezeichnung": "J0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "149",
    "Bcolor": "96",
    "Y": 27,
    "L": 59.3018112182617,
    "a": -14.965259552002,
    "b": 25.6602764129639,
    "C": 29.7053661346436,
    "h": 120.251052856445,
    "CMY_C": 0.47961550951004,
    "CMY_M": 0.41500520706177,
    "CMY_Y": 0.62348794937134,
    "CMYK_C": 0.110445946455,
    "CMYK_M": 0,
    "CMYK_Y": 0.35638391971588,
    "CMYK_K": 0.41500520706177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01172",
    "Farbtonhilfsbezeichnung": "C8.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "197",
    "Bcolor": "189",
    "Y": 59,
    "L": 81.0320950704747,
    "a": 6.61566767518201,
    "b": 6.06514709100237,
    "C": 8.97513610058046,
    "h": 0.7420117469003,
    "CMY_C": 0.1430291,
    "CMY_M": 0.2279203,
    "CMY_Y": 0.2599045,
    "CMYK_C": 0,
    "CMYK_M": 0.09905962,
    "CMYK_Y": 0.1363821,
    "CMYK_K": 0.1430291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01173",
    "Farbtonhilfsbezeichnung": "J0.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "206",
    "Bcolor": "166",
    "Y": 61,
    "L": 81.1009307465643,
    "a": -10.1385624611604,
    "b": 18.0106110134385,
    "C": 20.6681532280037,
    "h": -1.05808663754021,
    "CMY_C": 0.2328653,
    "CMY_M": 0.1916028,
    "CMY_Y": 0.3485443,
    "CMYK_C": 0.05104226,
    "CMYK_M": 0,
    "CMYK_Y": 0.1941391,
    "CMYK_K": 0.1916028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01179",
    "Farbtonhilfsbezeichnung": "L0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "112",
    "Bcolor": "72",
    "Y": 13,
    "L": 42.7243156433105,
    "a": -28.1456260681152,
    "b": 16.3676509857178,
    "C": 32.5588111877441,
    "h": 149.820526123047,
    "CMY_C": 0.78037911653519,
    "CMY_M": 0.55943763256073,
    "CMY_Y": 0.7171191573143,
    "CMYK_C": 0.50149875879288,
    "CMYK_M": 0,
    "CMYK_Y": 0.35790964961052,
    "CMYK_K": 0.55943763256073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01181",
    "Farbtonhilfsbezeichnung": "B6.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "104",
    "Bcolor": "107",
    "Y": 25,
    "L": 57.8608436584473,
    "a": 45.3436317443848,
    "b": 19.1399192810059,
    "C": 49.2176933288574,
    "h": 22.8850078582764,
    "CMY_C": 0.14512914419174,
    "CMY_M": 0.59317195415497,
    "CMY_Y": 0.58004319667816,
    "CMYK_C": 0,
    "CMYK_M": 0.52410584688187,
    "CMYK_Y": 0.50874823331833,
    "CMYK_K": 0.14512914419174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01183",
    "Farbtonhilfsbezeichnung": "F6.55.75",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "195",
    "Bcolor": "67",
    "Y": 61,
    "L": 81.9909362792969,
    "a": 8.98625564575195,
    "b": 68.2305374145508,
    "C": 68.8197555541992,
    "h": 82.4970779418945,
    "CMY_C": 0.00978499650955,
    "CMY_M": 0.23475521802902,
    "CMY_Y": 0.73804748058319,
    "CMYK_C": 0,
    "CMYK_M": 0.22719331085682,
    "CMYK_Y": 0.73545897006989,
    "CMYK_K": 0.00978499650955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01185",
    "Farbtonhilfsbezeichnung": "L0.40.35",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "115",
    "Bcolor": "78",
    "Y": 15,
    "L": 44.1069137881556,
    "a": -26.5429273185171,
    "b": 14.5483186158746,
    "C": 30.2684747746742,
    "h": -0.5013873678832,
    "CMY_C": 0.7574925,
    "CMY_M": 0.5477286,
    "CMY_Y": 0.6921958,
    "CMYK_C": 0.463801,
    "CMYK_M": 0,
    "CMYK_Y": 0.319426,
    "CMYK_K": 0.5477286
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01186",
    "Farbtonhilfsbezeichnung": "P0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "138",
    "Bcolor": "133",
    "Y": 18,
    "L": 50.9676742553711,
    "a": -37.8521118164063,
    "b": -7.8849458694458,
    "C": 38.6646461486816,
    "h": 191.766967773438,
    "CMY_C": 1,
    "CMY_M": 0.45757812261581,
    "CMY_Y": 0.47953432798386,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04047809541225,
    "CMYK_K": 0.45757812261581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01187",
    "Farbtonhilfsbezeichnung": "C4.55.30",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "53",
    "Bcolor": "44",
    "Y": 10,
    "L": 36.2854655122943,
    "a": 39.9895281892415,
    "b": 26.7572575537352,
    "C": 48.1156232069695,
    "h": 0.58968989185108,
    "CMY_C": 0.4148697,
    "CMY_M": 0.7914094,
    "CMY_Y": 0.8269275,
    "CMYK_C": 0,
    "CMYK_M": 0.6435144,
    "CMYK_Y": 0.7042155,
    "CMYK_K": 0.4148697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01192",
    "Farbtonhilfsbezeichnung": "E8.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "174",
    "Bcolor": "99",
    "Y": 52,
    "L": 75.7080958624377,
    "a": 16.3891346727492,
    "b": 46.8387429608715,
    "C": 49.6232967211581,
    "h": 1.23420567989676,
    "CMY_C": 0.0627109,
    "CMY_M": 0.3187594,
    "CMY_Y": 0.6128597,
    "CMYK_C": 0,
    "CMYK_M": 0.2731799,
    "CMYK_Y": 0.5869573,
    "CMYK_K": 0.0627109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01193",
    "Farbtonhilfsbezeichnung": "D2.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "130",
    "Bcolor": "112",
    "Y": 27,
    "L": 58.5851135253906,
    "a": 15.7133388519287,
    "b": 16.5970249176025,
    "C": 22.8554210662842,
    "h": 46.5666465759277,
    "CMY_C": 0.3057489991188,
    "CMY_M": 0.48867833614349,
    "CMY_Y": 0.5619090795517,
    "CMYK_C": 0,
    "CMYK_M": 0.2634916305542,
    "CMYK_Y": 0.36897328495979,
    "CMYK_K": 0.3057489991188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01194",
    "Farbtonhilfsbezeichnung": "V0.47.19",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "76",
    "Bcolor": "134",
    "Y": 7,
    "L": 32.7424621582031,
    "a": 8.84149360656738,
    "b": -36.4177169799805,
    "C": 37.4756202697754,
    "h": 283.646240234375,
    "CMY_C": 0.82069408893585,
    "CMY_M": 0.70298194885254,
    "CMY_Y": 0.47583490610123,
    "CMYK_C": 0.65792089700699,
    "CMYK_M": 0.43335017561913,
    "CMYK_Y": 0,
    "CMYK_K": 0.47583490610123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01195",
    "Farbtonhilfsbezeichnung": "C2.50.25",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "49",
    "Bcolor": "45",
    "Y": 8,
    "L": 32.317617690403,
    "a": 35.3609387848766,
    "b": 20.5072947880933,
    "C": 40.8771957364195,
    "h": 0.52554041825226,
    "CMY_C": 0.485437,
    "CMY_M": 0.8080631,
    "CMY_Y": 0.822659,
    "CMYK_C": 0,
    "CMYK_M": 0.6269904,
    "CMYK_Y": 0.655356,
    "CMYK_K": 0.485437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01196",
    "Farbtonhilfsbezeichnung": "C8.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "218",
    "Bcolor": "208",
    "Y": 74,
    "L": 88.9266967773438,
    "a": 8.02826976776123,
    "b": 7.53870868682861,
    "C": 11.012957572937,
    "h": 43.1987152099609,
    "CMY_C": 0.04019916057587,
    "CMY_M": 0.14539605379105,
    "CMY_Y": 0.18531954288483,
    "CMYK_C": 0,
    "CMYK_M": 0.10960283875465,
    "CMYK_Y": 0.15119843184948,
    "CMYK_K": 0.04019916057587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01198",
    "Farbtonhilfsbezeichnung": "F6.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "187",
    "Bcolor": "115",
    "Y": 54,
    "L": 77.5814579115633,
    "a": 4.52873220996403,
    "b": 40.794910331507,
    "C": 41.0455128410556,
    "h": 1.46023682450786,
    "CMY_C": 0.122389,
    "CMY_M": 0.2674035,
    "CMY_Y": 0.5508584,
    "CMYK_C": 0,
    "CMYK_M": 0.1652377,
    "CMYK_Y": 0.4882225,
    "CMYK_K": 0.122389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01199",
    "Farbtonhilfsbezeichnung": "F6.35.65",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "173",
    "Bcolor": "105",
    "Y": 45,
    "L": 72.3197979543256,
    "a": 3.85841450244867,
    "b": 38.6918103245744,
    "C": 38.883718297837,
    "h": 1.47140319059623,
    "CMY_C": 0.1898092,
    "CMY_M": 0.3213996,
    "CMY_Y": 0.587581,
    "CMYK_C": 0,
    "CMYK_M": 0.162419,
    "CMYK_Y": 0.4909606,
    "CMYK_K": 0.1898092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01201",
    "Farbtonhilfsbezeichnung": "C8.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "141",
    "Bcolor": "112",
    "Y": 37,
    "L": 66.5156270858552,
    "a": 29.2027945875997,
    "b": 28.1654890469169,
    "C": 40.5721331085456,
    "h": 0.7673186175027,
    "CMY_C": 0.1198921,
    "CMY_M": 0.4489099,
    "CMY_Y": 0.5617478,
    "CMYK_C": 0,
    "CMYK_M": 0.373838,
    "CMYK_Y": 0.5020472,
    "CMYK_K": 0.1198921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01202",
    "Farbtonhilfsbezeichnung": "E8.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "181",
    "Bcolor": "140",
    "Y": 50,
    "L": 75.8247709451461,
    "a": 7.90396079794658,
    "b": 25.24221716728,
    "C": 26.4507490218254,
    "h": 1.26734246971919,
    "CMY_C": 0.1473006,
    "CMY_M": 0.2916324,
    "CMY_Y": 0.4524451,
    "CMYK_C": 0,
    "CMYK_M": 0.1692646,
    "CMYK_Y": 0.3578572,
    "CMYK_K": 0.1473006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01204",
    "Farbtonhilfsbezeichnung": "F6.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "185",
    "Bcolor": "95",
    "Y": 53,
    "L": 76.9396599552257,
    "a": 4.43744352626851,
    "b": 49.7650346840951,
    "C": 49.9624817453858,
    "h": 1.48186363007694,
    "CMY_C": 0.1178742,
    "CMY_M": 0.2753783,
    "CMY_Y": 0.6276384,
    "CMYK_C": 0,
    "CMYK_M": 0.1785506,
    "CMYK_Y": 0.5778815,
    "CMYK_K": 0.1178742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01207",
    "Farbtonhilfsbezeichnung": "E8.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "154",
    "Bcolor": "83",
    "Y": 39,
    "L": 68.5322494506836,
    "a": 16.6750965118408,
    "b": 45.4408493041992,
    "C": 48.4038200378418,
    "h": 69.848747253418,
    "CMY_C": 0.14707410335541,
    "CMY_M": 0.39454168081284,
    "CMY_Y": 0.67267966270447,
    "CMYK_C": 0,
    "CMYK_M": 0.29013958573341,
    "CMYK_Y": 0.61623823642731,
    "CMYK_K": 0.14707410335541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01208",
    "Farbtonhilfsbezeichnung": "G0.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "184",
    "Bcolor": "94",
    "Y": 50,
    "L": 75.5498425863815,
    "a": -0.09338440032996,
    "b": 48.465277094807,
    "C": 48.4653670627041,
    "h": -1.56886949813819,
    "CMY_C": 0.1643082,
    "CMY_M": 0.2792681,
    "CMY_Y": 0.6325536,
    "CMYK_C": 0,
    "CMYK_M": 0.1375626,
    "CMYK_Y": 0.5603087,
    "CMYK_K": 0.1643082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01209",
    "Farbtonhilfsbezeichnung": "B6.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "127",
    "Bcolor": "124",
    "Y": 26,
    "L": 59.1128158569336,
    "a": 23.2049255371094,
    "b": 10.3746557235718,
    "C": 25.4185371398926,
    "h": 24.0888690948486,
    "CMY_C": 0.26710361242294,
    "CMY_M": 0.50251376628876,
    "CMY_Y": 0.51327300071716,
    "CMYK_C": 0,
    "CMYK_M": 0.32120522856712,
    "CMYK_Y": 0.33588567376137,
    "CMYK_K": 0.26710361242294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01214",
    "Farbtonhilfsbezeichnung": "V0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "114",
    "Bcolor": "168",
    "Y": 19,
    "L": 48.5880575640719,
    "a": 6.90027502098628,
    "b": -31.655625209959,
    "C": 32.3989568165186,
    "h": -1.35617412973219,
    "CMY_C": 0.6347502,
    "CMY_M": 0.5515192,
    "CMY_Y": 0.3429039,
    "CMYK_C": 0.4441455,
    "CMYK_M": 0.3174807,
    "CMYK_Y": 0,
    "CMYK_K": 0.3429039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01215",
    "Farbtonhilfsbezeichnung": "Q0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "173",
    "Bcolor": "182",
    "Y": 37,
    "L": 66.0582528976971,
    "a": -23.479695200892,
    "b": -13.249758366417,
    "C": 26.9601962807252,
    "h": 0.5137611417632,
    "CMY_C": 0.6625414,
    "CMY_M": 0.3200167,
    "CMY_Y": 0.2859943,
    "CMYK_C": 0.5273727,
    "CMYK_M": 0.04765006,
    "CMYK_Y": 0,
    "CMYK_K": 0.2859943
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01217",
    "Farbtonhilfsbezeichnung": "G0.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "190",
    "Bcolor": "142",
    "Y": 54,
    "L": 77.6901713647499,
    "a": 0.41751164511111,
    "b": 26.1536059270665,
    "C": 26.1569382566479,
    "h": 1.55483385550321,
    "CMY_C": 0.1745017,
    "CMY_M": 0.2538342,
    "CMY_Y": 0.4415252,
    "CMYK_C": 0,
    "CMYK_M": 0.09610254,
    "CMYK_Y": 0.3234695,
    "CMYK_K": 0.1745017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01219",
    "Farbtonhilfsbezeichnung": "G0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "140",
    "Bcolor": "122",
    "Y": 26,
    "L": 58.4189186096191,
    "a": -0.01092382054776,
    "b": 10.3111581802368,
    "C": 10.3111639022827,
    "h": 90.0606994628906,
    "CMY_C": 0.42025417089462,
    "CMY_M": 0.45131033658981,
    "CMY_Y": 0.5234163403511,
    "CMYK_C": 0,
    "CMYK_M": 0.05356858670712,
    "CMYK_Y": 0.17794379591942,
    "CMYK_K": 0.42025417089462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01222",
    "Farbtonhilfsbezeichnung": "L0.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "227",
    "Bcolor": "208",
    "Y": 76,
    "L": 88.3785848862762,
    "a": -9.27216263443242,
    "b": 6.27895836400536,
    "C": 11.1981390443358,
    "h": -0.59524839964117,
    "CMY_C": 0.1832982,
    "CMY_M": 0.1103927,
    "CMY_Y": 0.1845562,
    "CMYK_C": 0.08195246,
    "CMYK_M": 0,
    "CMYK_Y": 0.08336658,
    "CMYK_K": 0.1103927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01223",
    "Farbtonhilfsbezeichnung": "L0.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "231",
    "Bcolor": "215",
    "Y": 80,
    "L": 90.2291207448296,
    "a": -7.15550489985162,
    "b": 5.16866575525703,
    "C": 8.82702419059601,
    "h": -0.62555861423937,
    "CMY_C": 0.1494649,
    "CMY_M": 0.09416937,
    "CMY_Y": 0.1558457,
    "CMYK_C": 0.06104406,
    "CMYK_M": 0,
    "CMYK_Y": 0.06808818,
    "CMYK_K": 0.09416937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01224",
    "Farbtonhilfsbezeichnung": "C0.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "174",
    "Bcolor": "171",
    "Y": 44,
    "L": 72.6417999267578,
    "a": 7.43169832229614,
    "b": 3.53004384040833,
    "C": 8.2274751663208,
    "h": 25.4076385498047,
    "CMY_C": 0.23634737730026,
    "CMY_M": 0.31911909580231,
    "CMY_Y": 0.33050441741943,
    "CMYK_C": 0,
    "CMYK_M": 0.10838922858238,
    "CMYK_Y": 0.12329825758934,
    "CMYK_K": 0.23634737730026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01226",
    "Farbtonhilfsbezeichnung": "N0.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "78",
    "Bcolor": "75",
    "Y": 7,
    "L": 32.505802154541,
    "a": -3.95563077926636,
    "b": 0.32974991202354,
    "C": 3.96935129165649,
    "h": 175.234725952148,
    "CMY_C": 0.72585773468018,
    "CMY_M": 0.69262778759003,
    "CMY_Y": 0.70521914958954,
    "CMYK_C": 0.10810979455709,
    "CMYK_M": 0,
    "CMYK_Y": 0.04096454381943,
    "CMYK_K": 0.69262778759003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01228",
    "Farbtonhilfsbezeichnung": "C0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "105",
    "Bcolor": "94",
    "Y": 25,
    "L": 57.1030371750301,
    "a": 41.94131760533,
    "b": 25.3826154485836,
    "C": 49.0239868786886,
    "h": 0.54422954841356,
    "CMY_C": 0.1644856,
    "CMY_M": 0.58914,
    "CMY_Y": 0.6300709,
    "CMYK_C": 0,
    "CMYK_M": 0.508255,
    "CMYK_Y": 0.5572439,
    "CMYK_K": 0.1644856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01231",
    "Farbtonhilfsbezeichnung": "E0.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "170",
    "Y": 62,
    "L": 82.3265914916992,
    "a": 10.9847707748413,
    "b": 18.2166423797607,
    "C": 21.2723121643066,
    "h": 58.9097137451172,
    "CMY_C": 0.06780731678009,
    "CMY_M": 0.2279115319252,
    "CMY_Y": 0.33358252048492,
    "CMYK_C": 0,
    "CMYK_M": 0.1717501282692,
    "CMYK_Y": 0.28510758280754,
    "CMYK_K": 0.06780731678009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01235",
    "Farbtonhilfsbezeichnung": "K2.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "142",
    "Bcolor": "124",
    "Y": 26,
    "L": 57.4893800257665,
    "a": -7.89443925206795,
    "b": 7.4260777235061,
    "C": 10.8383025174676,
    "h": -0.75483681195838,
    "CMY_C": 0.4937186,
    "CMY_M": 0.443751,
    "CMY_Y": 0.5141466,
    "CMYK_C": 0.08982959,
    "CMYK_M": 0,
    "CMYK_Y": 0.126554,
    "CMYK_K": 0.443751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01239",
    "Farbtonhilfsbezeichnung": "E4.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "140",
    "Bcolor": "103",
    "Y": 32,
    "L": 61.4228078866715,
    "a": 11.7379476503183,
    "b": 25.601528373012,
    "C": 28.1641202609943,
    "h": 1.14090771996582,
    "CMY_C": 0.2831895,
    "CMY_M": 0.4515136,
    "CMY_Y": 0.5972633,
    "CMYK_C": 0,
    "CMYK_M": 0.2348237,
    "CMYK_Y": 0.4381546,
    "CMYK_K": 0.2831895
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01240",
    "Farbtonhilfsbezeichnung": "D6.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "92",
    "Bcolor": "53",
    "Y": 17,
    "L": 47.2294547159515,
    "a": 27.645444878153,
    "b": 35.3088476279734,
    "C": 44.8440112314502,
    "h": 0.90653181610666,
    "CMY_C": 0.3430229,
    "CMY_M": 0.638949,
    "CMY_Y": 0.7935129,
    "CMYK_C": 0,
    "CMYK_M": 0.450436,
    "CMYK_Y": 0.6857013,
    "CMYK_K": 0.3430229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01241",
    "Farbtonhilfsbezeichnung": "T4.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "90",
    "Bcolor": "130",
    "Y": 10,
    "L": 36.2616371663852,
    "a": -4.8604775809192,
    "b": -28.4136482563311,
    "C": 28.826370731487,
    "h": 1.40137479347027,
    "CMY_C": 0.8923291,
    "CMY_M": 0.6472572,
    "CMY_Y": 0.4915962,
    "CMYK_C": 0.7882177,
    "CMYK_M": 0.3061759,
    "CMYK_Y": 0,
    "CMYK_K": 0.4915962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01242",
    "Farbtonhilfsbezeichnung": "B6.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "150",
    "Gcolor": "102",
    "Bcolor": "101",
    "Y": 18,
    "L": 48.2721449347555,
    "a": 19.2036093456877,
    "b": 7.89448599700258,
    "C": 20.7629843967252,
    "h": 0.39003331986143,
    "CMY_C": 0.4120945,
    "CMY_M": 0.5983117,
    "CMY_Y": 0.6029034,
    "CMYK_C": 0,
    "CMYK_M": 0.3167469,
    "CMYK_Y": 0.324557,
    "CMYK_K": 0.4120945
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01243",
    "Farbtonhilfsbezeichnung": "U0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "69",
    "Bcolor": "100",
    "Y": 7,
    "L": 28.5847169456997,
    "a": 0.26481407271511,
    "b": -21.6477143744336,
    "C": 21.6493340343339,
    "h": -1.5585640485931,
    "CMY_C": 0.8322075,
    "CMY_M": 0.7295444,
    "CMY_Y": 0.6084943,
    "CMYK_C": 0.5714175,
    "CMYK_M": 0.309191,
    "CMYK_Y": 0,
    "CMYK_K": 0.6084943
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01244",
    "Farbtonhilfsbezeichnung": "N0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "141",
    "Bcolor": "135",
    "Y": 26,
    "L": 56.6978367574694,
    "a": -9.89942368923191,
    "b": -0.04454929395392,
    "C": 9.89952392888253,
    "h": 0.00450016027426,
    "CMY_C": 0.5427089,
    "CMY_M": 0.4461372,
    "CMY_Y": 0.4718096,
    "CMYK_C": 0.1743604,
    "CMYK_M": 0,
    "CMYK_Y": 0.04635161,
    "CMYK_K": 0.4461372
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01245",
    "Farbtonhilfsbezeichnung": "S0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "96",
    "Bcolor": "102",
    "Y": 12,
    "L": 39.8746900408135,
    "a": -2.90914624196739,
    "b": -5.70052921739239,
    "C": 6.39993478212843,
    "h": 1.0989195826466,
    "CMY_C": 0.6713576,
    "CMY_M": 0.6241716,
    "CMY_Y": 0.5990919,
    "CMYK_C": 0.180255,
    "CMYK_M": 0.06255718,
    "CMYK_Y": 0,
    "CMYK_K": 0.5990919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01246",
    "Farbtonhilfsbezeichnung": "F6.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "105",
    "Bcolor": "86",
    "Y": 15,
    "L": 44.9336534571915,
    "a": 0.84215922044944,
    "b": 11.5548998069812,
    "C": 11.5855488304164,
    "h": 1.49804166921584,
    "CMY_C": 0.5481549,
    "CMY_M": 0.5872395,
    "CMY_Y": 0.6609948,
    "CMYK_C": 0,
    "CMYK_M": 0.0865001,
    "CMYK_Y": 0.2497313,
    "CMYK_K": 0.5481549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01247",
    "Farbtonhilfsbezeichnung": "G8.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "165",
    "Bcolor": "142",
    "Y": 38,
    "L": 67.3405535791053,
    "a": -2.7063929507295,
    "b": 11.4025324058169,
    "C": 11.7193134640841,
    "h": -1.33775836533322,
    "CMY_C": 0.3431754,
    "CMY_M": 0.3535617,
    "CMY_Y": 0.4419958,
    "CMYK_C": 0,
    "CMYK_M": 0.01581295,
    "CMYK_Y": 0.1504518,
    "CMYK_K": 0.3431754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01248",
    "Farbtonhilfsbezeichnung": "LN.02.37",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "112",
    "Bcolor": "110",
    "Y": 15,
    "L": 46.7382125854492,
    "a": -1.91926801204681,
    "b": -0.12332889437675,
    "C": 1.92322635650635,
    "h": 183.676666259766,
    "CMY_C": 0.57952052354813,
    "CMY_M": 0.56136476993561,
    "CMY_Y": 0.56858813762665,
    "CMYK_C": 0.04139146208763,
    "CMYK_M": 0,
    "CMYK_Y": 0.01646782457829,
    "CMYK_K": 0.56136476993561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01250",
    "Farbtonhilfsbezeichnung": "V0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "89",
    "Bcolor": "148",
    "Y": 11,
    "L": 38.4719238096916,
    "a": 8.80235209993588,
    "b": -35.7714323266213,
    "C": 36.8385229507006,
    "h": -1.32951789713365,
    "CMY_C": 0.7516119,
    "CMY_M": 0.6505576,
    "CMY_Y": 0.4213171,
    "CMYK_C": 0.57077,
    "CMYK_M": 0.3961418,
    "CMYK_Y": 0,
    "CMYK_K": 0.4213171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01252",
    "Farbtonhilfsbezeichnung": "T4.36.27",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "94",
    "Bcolor": "129",
    "Y": 11,
    "L": 38.4177513122559,
    "a": -3.59549927711487,
    "b": -24.8042144775391,
    "C": 25.0634536743164,
    "h": 261.752136230469,
    "CMY_C": 0.80198526382446,
    "CMY_M": 0.63062584400177,
    "CMY_Y": 0.49273759126663,
    "CMYK_C": 0.60964041948318,
    "CMYK_M": 0.27182826399803,
    "CMYK_Y": 0,
    "CMYK_K": 0.49273759126663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01253",
    "Farbtonhilfsbezeichnung": "U0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "120",
    "Bcolor": "171",
    "Y": 17,
    "L": 48.9862594604492,
    "a": -1.56103730201721,
    "b": -33.2840003967285,
    "C": 33.3205871582031,
    "h": 267.314758300781,
    "CMY_C": 0.73830670118332,
    "CMY_M": 0.5291200876236,
    "CMY_Y": 0.32852637767792,
    "CMYK_C": 0.61027020215988,
    "CMYK_M": 0.2987365424633,
    "CMYK_Y": 0,
    "CMYK_K": 0.32852637767792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01254",
    "Farbtonhilfsbezeichnung": "Y0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "182",
    "Bcolor": "204",
    "Y": 51,
    "L": 76.9680633544922,
    "a": 13.8217573165894,
    "b": -8.33538627624512,
    "C": 16.1406211853027,
    "h": 328.907379150391,
    "CMY_C": 0.17956966161728,
    "CMY_M": 0.28558504581451,
    "CMY_Y": 0.19939088821411,
    "CMYK_C": 0,
    "CMYK_M": 0.12921923398972,
    "CMYK_Y": 0.02415954880416,
    "CMYK_K": 0.17956966161728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01256",
    "Farbtonhilfsbezeichnung": "Y0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "125",
    "Bcolor": "159",
    "Y": 26,
    "L": 57.3474227113838,
    "a": 21.9819673046826,
    "b": -12.5351596728648,
    "C": 25.3048832166511,
    "h": -0.51825523864244,
    "CMY_C": 0.3484598,
    "CMY_M": 0.5098859,
    "CMY_Y": 0.3774655,
    "CMYK_C": 0,
    "CMYK_M": 0.2477607,
    "CMYK_Y": 0.04451866,
    "CMYK_K": 0.3484598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01258",
    "Farbtonhilfsbezeichnung": "E8.35.65",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "168",
    "Bcolor": "107",
    "Y": 44,
    "L": 72.7017517089844,
    "a": 13.5647115707398,
    "b": 38.3301773071289,
    "C": 40.659610748291,
    "h": 70.5115814208984,
    "CMY_C": 0.12584376335144,
    "CMY_M": 0.34156268835068,
    "CMY_Y": 0.57854270935059,
    "CMYK_C": 0,
    "CMYK_M": 0.24677388370037,
    "CMYK_Y": 0.51786959171295,
    "CMYK_K": 0.12584376335144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01259",
    "Farbtonhilfsbezeichnung": "C8.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "157",
    "Bcolor": "146",
    "Y": 38,
    "L": 67.0124870776275,
    "a": 9.43978101309256,
    "b": 9.16942591444678,
    "C": 13.1600849988012,
    "h": 0.77087115634134,
    "CMY_C": 0.2690277,
    "CMY_M": 0.3846361,
    "CMY_Y": 0.4278974,
    "CMYK_C": 0,
    "CMYK_M": 0.158157,
    "CMYK_Y": 0.2173402,
    "CMYK_K": 0.2690277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01260",
    "Farbtonhilfsbezeichnung": "D2.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "115",
    "Bcolor": "81",
    "Y": 26,
    "L": 56.9642580457908,
    "a": 30.1396482609534,
    "b": 32.0592285318167,
    "C": 44.0021878018496,
    "h": 0.81625034716184,
    "CMY_C": 0.2211931,
    "CMY_M": 0.5501657,
    "CMY_Y": 0.6804157,
    "CMYK_C": 0,
    "CMYK_M": 0.4224059,
    "CMYK_Y": 0.5896488,
    "CMYK_K": 0.2211931
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01262",
    "Farbtonhilfsbezeichnung": "U0.15.65",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "179",
    "Bcolor": "210",
    "Y": 44,
    "L": 72.3591537475586,
    "a": -0.50068372488022,
    "b": -18.810604095459,
    "C": 18.8172664642334,
    "h": 268.475311279297,
    "CMY_C": 0.38373571634293,
    "CMY_M": 0.29681366682053,
    "CMY_Y": 0.17679286003113,
    "CMYK_C": 0.25138613581657,
    "CMYK_M": 0.1457966119051,
    "CMYK_Y": 0,
    "CMYK_K": 0.17679286003113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01265",
    "Farbtonhilfsbezeichnung": "N0.15.10",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "58",
    "Bcolor": "55",
    "Y": 5,
    "L": 23.350319365986,
    "a": -5.13958205313753,
    "b": 0.07212307445394,
    "C": 5.14008807500436,
    "h": -0.01403194658164,
    "CMY_C": 0.815305,
    "CMY_M": 0.7726981,
    "CMY_Y": 0.7847684,
    "CMYK_C": 0.1874463,
    "CMYK_M": 0,
    "CMYK_Y": 0.05310266,
    "CMYK_K": 0.7726981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01267",
    "Farbtonhilfsbezeichnung": "G8.20.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "228",
    "Bcolor": "173",
    "Y": 78,
    "L": 90.0333928089732,
    "a": -5.43351256475955,
    "b": 27.1930110508062,
    "C": 27.7305410838063,
    "h": -1.37358074208286,
    "CMY_C": 0.07501233,
    "CMY_M": 0.1054413,
    "CMY_Y": 0.3218845,
    "CMYK_C": 0,
    "CMYK_M": 0.03289667,
    "CMYK_Y": 0.2668923,
    "CMYK_K": 0.07501233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01272",
    "Farbtonhilfsbezeichnung": "E0.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "98",
    "Bcolor": "84",
    "Y": 14,
    "L": 43.5646272198329,
    "a": 6.98124534468475,
    "b": 11.5214541017639,
    "C": 13.4715140641925,
    "h": 1.02602472112456,
    "CMY_C": 0.5245368,
    "CMY_M": 0.6138434,
    "CMY_Y": 0.6725222,
    "CMYK_C": 0,
    "CMYK_M": 0.1878307,
    "CMYK_Y": 0.3112448,
    "CMYK_K": 0.5245368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01273",
    "Farbtonhilfsbezeichnung": "G0.60.75",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "201",
    "Bcolor": "40",
    "Y": 60,
    "L": 81.519616470784,
    "a": -2.50950695917318,
    "b": 75.8537051722706,
    "C": 75.8952054713596,
    "h": -1.53772487713021,
    "CMY_C": 0.08023169,
    "CMY_M": 0.2125735,
    "CMY_Y": 0.8439135,
    "CMYK_C": 0,
    "CMYK_M": 0.1438861,
    "CMYK_Y": 0.830298,
    "CMYK_K": 0.08023169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01274",
    "Farbtonhilfsbezeichnung": "K2.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "129",
    "Bcolor": "68",
    "Y": 19,
    "L": 48.8418907336224,
    "a": -31.3678303911087,
    "b": 26.9448674794046,
    "C": 41.3517432151057,
    "h": -0.70969406555039,
    "CMY_C": 0.7148008,
    "CMY_M": 0.4949294,
    "CMY_Y": 0.7341933,
    "CMYK_C": 0.4353282,
    "CMYK_M": 0,
    "CMYK_Y": 0.4737236,
    "CMYK_K": 0.4949294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01275",
    "Farbtonhilfsbezeichnung": "K2.05.50",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "141",
    "Bcolor": "132",
    "Y": 26,
    "L": 57.9729297605141,
    "a": -3.64545302720914,
    "b": 3.5074934971828,
    "C": 5.05883765368765,
    "h": -0.76611346348184,
    "CMY_C": 0.4693714,
    "CMY_M": 0.4465406,
    "CMY_Y": 0.4822392,
    "CMYK_C": 0.04125115,
    "CMYK_M": 0,
    "CMYK_Y": 0.0645009,
    "CMYK_K": 0.4465406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01276",
    "Farbtonhilfsbezeichnung": "L0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "156",
    "Bcolor": "147",
    "Y": 32,
    "L": 63.195629119873,
    "a": -4.90828514099121,
    "b": 2.81004357337952,
    "C": 5.65575885772705,
    "h": 150.208419799805,
    "CMY_C": 0.42783403396606,
    "CMY_M": 0.3900049328804,
    "CMY_Y": 0.42488104104996,
    "CMYK_C": 0.06201542168856,
    "CMYK_M": 0,
    "CMYK_Y": 0.057174410671,
    "CMYK_K": 0.3900049328804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01278",
    "Farbtonhilfsbezeichnung": "F6.25.75",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "205",
    "Bcolor": "148",
    "Y": 65,
    "L": 83.8896098502157,
    "a": 3.29313130860742,
    "b": 31.9935710047154,
    "C": 32.1626071618813,
    "h": 1.46822651162743,
    "CMY_C": 0.07332357,
    "CMY_M": 0.1946647,
    "CMY_Y": 0.4204565,
    "CMYK_C": 0,
    "CMYK_M": 0.1309423,
    "CMYK_Y": 0.3745999,
    "CMYK_K": 0.07332357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01279",
    "Farbtonhilfsbezeichnung": "N0.30.50",
    "Farbtonklasse": "02",
    "Rcolor": "70",
    "Gcolor": "154",
    "Bcolor": "136",
    "Y": 27,
    "L": 58.092007983026,
    "a": -29.5279915262367,
    "b": 0.74629526555114,
    "C": 29.5374210146534,
    "h": -0.02526878330952,
    "CMY_C": 0.7262935,
    "CMY_M": 0.3976718,
    "CMY_Y": 0.4653476,
    "CMYK_C": 0.5455858,
    "CMYK_M": 0,
    "CMYK_Y": 0.1123571,
    "CMYK_K": 0.3976718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01280",
    "Farbtonhilfsbezeichnung": "B6.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "110",
    "Bcolor": "111",
    "Y": 25,
    "L": 56.9715639566164,
    "a": 36.8632092133684,
    "b": 15.4884859007881,
    "C": 39.9848644990512,
    "h": 0.39776491229377,
    "CMY_C": 0.2058087,
    "CMY_M": 0.569183,
    "CMY_Y": 0.5660376,
    "CMYK_C": 0,
    "CMYK_M": 0.45754,
    "CMYK_Y": 0.4535795,
    "CMYK_K": 0.2058087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01282",
    "Farbtonhilfsbezeichnung": "LN.02.57",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "158",
    "Bcolor": "153",
    "Y": 35,
    "L": 64.509491492618,
    "a": -2.58754911921066,
    "b": 1.20102233401218,
    "C": 2.85269435641534,
    "h": -0.43456219001467,
    "CMY_C": 0.4020274,
    "CMY_M": 0.3808918,
    "CMY_Y": 0.4000446,
    "CMYK_C": 0.03413879,
    "CMYK_M": 0,
    "CMYK_Y": 0.03093611,
    "CMYK_K": 0.3808918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01283",
    "Farbtonhilfsbezeichnung": "Q0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "123",
    "Bcolor": "132",
    "Y": 17,
    "L": 47.4061466879589,
    "a": -20.4280156820396,
    "b": -12.4541623544428,
    "C": 23.9250911107247,
    "h": 0.54749283448539,
    "CMY_C": 0.8257602,
    "CMY_M": 0.5182208,
    "CMY_Y": 0.4835987,
    "CMYK_C": 0.6625884,
    "CMYK_M": 0.06704485,
    "CMYK_Y": 0,
    "CMYK_K": 0.4835987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01287",
    "Farbtonhilfsbezeichnung": "G0.20.40",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "116",
    "Bcolor": "86",
    "Y": 18,
    "L": 49.0361593467985,
    "a": -0.27965807728913,
    "b": 17.361487495631,
    "C": 17.3637397095541,
    "h": -1.5546897636996,
    "CMY_C": 0.5021948,
    "CMY_M": 0.5460182,
    "CMY_Y": 0.6610965,
    "CMYK_C": 0,
    "CMYK_M": 0.08803343,
    "CMYK_Y": 0.3192046,
    "CMYK_K": 0.5021948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01288",
    "Farbtonhilfsbezeichnung": "G4.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "197",
    "Bcolor": "149",
    "Y": 56,
    "L": 79.2764379187068,
    "a": -3.27332365937977,
    "b": 24.5927501385459,
    "C": 24.8096353692674,
    "h": -1.43847291580683,
    "CMY_C": 0.1858884,
    "CMY_M": 0.2279349,
    "CMY_Y": 0.414506,
    "CMYK_C": 0,
    "CMYK_M": 0.05164708,
    "CMYK_Y": 0.2808186,
    "CMYK_K": 0.1858884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01289",
    "Farbtonhilfsbezeichnung": "A0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "202",
    "Bcolor": "205",
    "Y": 59,
    "L": 83.1598587036133,
    "a": 8.8528470993042,
    "b": 0.32870915532112,
    "C": 8.85894775390625,
    "h": 2.12643456459045,
    "CMY_C": 0.11997944116592,
    "CMY_M": 0.20871961116791,
    "CMY_Y": 0.19516831636429,
    "CMYK_C": 0,
    "CMYK_M": 0.10083874315023,
    "CMYK_Y": 0.08543990552425,
    "CMYK_K": 0.11997944116592
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01291",
    "Farbtonhilfsbezeichnung": "E8.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "144",
    "Bcolor": "103",
    "Y": 32,
    "L": 62.1042852094143,
    "a": 8.07865675634506,
    "b": 26.1244932139257,
    "C": 27.3450880538222,
    "h": 1.27088702136655,
    "CMY_C": 0.2970119,
    "CMY_M": 0.435587,
    "CMY_Y": 0.5951161,
    "CMYK_C": 0,
    "CMYK_M": 0.197123,
    "CMYK_Y": 0.424053,
    "CMYK_K": 0.2970119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01293",
    "Farbtonhilfsbezeichnung": "C0.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "136",
    "Bcolor": "131",
    "Y": 31,
    "L": 61.4130314380722,
    "a": 18.7079624943223,
    "b": 9.51723716437325,
    "C": 20.9896561175237,
    "h": 0.47060445043149,
    "CMY_C": 0.2704132,
    "CMY_M": 0.4663717,
    "CMY_Y": 0.4853386,
    "CMYK_C": 0,
    "CMYK_M": 0.2685884,
    "CMYK_Y": 0.2945852,
    "CMYK_K": 0.2704132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01296",
    "Farbtonhilfsbezeichnung": "W0.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "151",
    "Bcolor": "164",
    "Y": 31,
    "L": 62.9630966186523,
    "a": 4.03647994995117,
    "b": -7.14720106124878,
    "C": 8.20826721191406,
    "h": 299.456176757813,
    "CMY_C": 0.39671725034714,
    "CMY_M": 0.40924340486526,
    "CMY_Y": 0.35781538486481,
    "CMYK_C": 0.06057738512754,
    "CMYK_M": 0.0800829231739,
    "CMYK_Y": 0,
    "CMYK_K": 0.35781538486481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01297",
    "Farbtonhilfsbezeichnung": "G8.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "168",
    "Bcolor": "125",
    "Y": 40,
    "L": 68.2112733041848,
    "a": -4.78630576616629,
    "b": 22.3426185119478,
    "C": 22.8495366442663,
    "h": -1.35976282690803,
    "CMY_C": 0.3218657,
    "CMY_M": 0.3422075,
    "CMY_Y": 0.510753,
    "CMYK_C": 0,
    "CMYK_M": 0.0299967,
    "CMYK_Y": 0.2785397,
    "CMYK_K": 0.3218657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01300",
    "Farbtonhilfsbezeichnung": "J0.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "223",
    "Bcolor": "167",
    "Y": 72,
    "L": 86.3785275395337,
    "a": -14.1208093670753,
    "b": 25.0830038343155,
    "C": 28.784619826108,
    "h": -1.058055030834,
    "CMY_C": 0.1865771,
    "CMY_M": 0.1264846,
    "CMY_Y": 0.3461852,
    "CMYK_C": 0.06879381,
    "CMYK_M": 0,
    "CMYK_Y": 0.2515132,
    "CMYK_K": 0.1264846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01302",
    "Farbtonhilfsbezeichnung": "L0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "127",
    "Bcolor": "119",
    "Y": 21,
    "L": 52.1293837628799,
    "a": -4.41351360732145,
    "b": 2.21380982567214,
    "C": 4.93761646001936,
    "h": -0.46492523281647,
    "CMY_C": 0.5374469,
    "CMY_M": 0.5036336,
    "CMY_Y": 0.531623,
    "CMYK_C": 0.06812177,
    "CMYK_M": 0,
    "CMYK_Y": 0.05638869,
    "CMYK_K": 0.5036336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01303",
    "Farbtonhilfsbezeichnung": "C8.25.45",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 22,
    "L": 52.914164224888,
    "a": 20.8599087758147,
    "b": 18.81081827009,
    "C": 28.0888354711558,
    "h": 0.73379156927952,
    "CMY_C": 0.3344528,
    "CMY_M": 0.5598903,
    "CMY_Y": 0.6303168,
    "CMYK_C": 0,
    "CMYK_M": 0.338725,
    "CMYK_Y": 0.4445425,
    "CMYK_K": 0.3344528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01308",
    "Farbtonhilfsbezeichnung": "G8.30.85",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "236",
    "Bcolor": "148",
    "Y": 83,
    "L": 92.1241894567516,
    "a": -9.50494241676608,
    "b": 42.4605720764396,
    "C": 43.5114250674988,
    "h": -1.3505735250691,
    "CMY_C": 0.04784897,
    "CMY_M": 0.07573697,
    "CMY_Y": 0.4179575,
    "CMYK_C": 0,
    "CMYK_M": 0.02928947,
    "CMYK_Y": 0.3887078,
    "CMYK_K": 0.04784897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01309",
    "Farbtonhilfsbezeichnung": "C0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "66",
    "Bcolor": "65",
    "Y": 11,
    "L": 38.8189074909916,
    "a": 34.10093283051,
    "b": 17.2555411884829,
    "C": 38.2181543460485,
    "h": 0.46844703379472,
    "CMY_C": 0.422591,
    "CMY_M": 0.7393745,
    "CMY_Y": 0.746708,
    "CMYK_C": 0,
    "CMYK_M": 0.5486293,
    "CMYK_Y": 0.56133,
    "CMYK_K": 0.422591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01310",
    "Farbtonhilfsbezeichnung": "F2.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "116",
    "Bcolor": "104",
    "Y": 18,
    "L": 49.3004455566406,
    "a": 2.02699208259583,
    "b": 7.62290000915527,
    "C": 7.88779449462891,
    "h": 75.1091613769531,
    "CMY_C": 0.50607299804688,
    "CMY_M": 0.54634529352188,
    "CMY_Y": 0.59389293193817,
    "CMYK_C": 0,
    "CMYK_M": 0.08153491467237,
    "CMYK_Y": 0.17779941856861,
    "CMYK_K": 0.50607299804688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01311",
    "Farbtonhilfsbezeichnung": "C4.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "100",
    "Bcolor": "90",
    "Y": 17,
    "L": 46.6734159018901,
    "a": 16.48677178477,
    "b": 12.2257301737606,
    "C": 20.5251582738036,
    "h": 0.63806975092181,
    "CMY_C": 0.4365746,
    "CMY_M": 0.6075209,
    "CMY_Y": 0.6465458,
    "CMYK_C": 0,
    "CMYK_M": 0.3034054,
    "CMYK_Y": 0.372669,
    "CMYK_K": 0.4365746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01315",
    "Farbtonhilfsbezeichnung": "E8.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "191",
    "Bcolor": "170",
    "Y": 55,
    "L": 78.6893768310547,
    "a": 4.97292470932007,
    "b": 12.6206073760986,
    "C": 13.5650177001953,
    "h": 68.4939651489258,
    "CMY_C": 0.1630979180336,
    "CMY_M": 0.25087368488312,
    "CMY_Y": 0.3322389125824,
    "CMYK_C": 0,
    "CMYK_M": 0.10488176345825,
    "CMYK_Y": 0.20210368931293,
    "CMYK_K": 0.1630979180336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01316",
    "Farbtonhilfsbezeichnung": "C8.60.30",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "61",
    "Bcolor": "46",
    "Y": 12,
    "L": 39.4694694930182,
    "a": 39.8054882304808,
    "b": 29.8657191482338,
    "C": 49.76382293904,
    "h": 0.64368763747625,
    "CMY_C": 0.3769547,
    "CMY_M": 0.7593148,
    "CMY_Y": 0.8200537,
    "CMYK_C": 0,
    "CMYK_M": 0.6136956,
    "CMYK_Y": 0.7111827,
    "CMYK_K": 0.3769547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01317",
    "Farbtonhilfsbezeichnung": "CN.02.47",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "131",
    "Bcolor": "130",
    "Y": 23,
    "L": 55.4810485839844,
    "a": 2.70910239219666,
    "b": 1.06235706806183,
    "C": 2.90995502471924,
    "h": 21.4123077392578,
    "CMY_C": 0.45664650201797,
    "CMY_M": 0.4847759604454,
    "CMY_Y": 0.48986583948135,
    "CMYK_C": 0,
    "CMYK_M": 0.05177008733153,
    "CMYK_Y": 0.06113761663437,
    "CMYK_K": 0.45664650201797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01318",
    "Farbtonhilfsbezeichnung": "E8.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "159",
    "Bcolor": "142",
    "Y": 37,
    "L": 66.6345700860736,
    "a": 3.62639210651938,
    "b": 10.7387447018373,
    "C": 11.3345206110124,
    "h": 1.24512778663686,
    "CMY_C": 0.308225,
    "CMY_M": 0.3750369,
    "CMY_Y": 0.4435599,
    "CMYK_C": 0,
    "CMYK_M": 0.09658045,
    "CMYK_Y": 0.1956343,
    "CMYK_K": 0.308225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01319",
    "Farbtonhilfsbezeichnung": "F6.05.60",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "161",
    "Bcolor": "149",
    "Y": 37,
    "L": 66.410736927288,
    "a": 0.60827433908033,
    "b": 6.10851444888645,
    "C": 6.13872514809371,
    "h": 1.47154540211123,
    "CMY_C": 0.3438925,
    "CMY_M": 0.3693604,
    "CMY_Y": 0.4140892,
    "CMYK_C": 0,
    "CMYK_M": 0.03881664,
    "CMYK_Y": 0.1069897,
    "CMYK_K": 0.3438925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01320",
    "Farbtonhilfsbezeichnung": "A0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "184",
    "Bcolor": "196",
    "Y": 53,
    "L": 78.79052734375,
    "a": 18.3202075958252,
    "b": -0.75423502922058,
    "C": 18.3357276916504,
    "h": 357.642486572266,
    "CMY_C": 0.10502636432648,
    "CMY_M": 0.28038370609283,
    "CMY_Y": 0.23321616649628,
    "CMYK_C": 0,
    "CMYK_M": 0.19593575596809,
    "CMYK_Y": 0.14323304593563,
    "CMYK_K": 0.10502636432648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01324",
    "Farbtonhilfsbezeichnung": "W0.20.50",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "133",
    "Bcolor": "180",
    "Y": 27,
    "L": 57.8656014502871,
    "a": 13.9605516063239,
    "b": -24.2717273843282,
    "C": 28.0002455591372,
    "h": -1.04882865726669,
    "CMY_C": 0.441487,
    "CMY_M": 0.4790611,
    "CMY_Y": 0.2936669,
    "CMYK_C": 0.2092782,
    "CMYK_M": 0.2624742,
    "CMYK_Y": 0,
    "CMYK_K": 0.2936669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01325",
    "Farbtonhilfsbezeichnung": "P0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "106",
    "Bcolor": "104",
    "Y": 12,
    "L": 40.057437794842,
    "a": -26.6803915076873,
    "b": -6.85896444105942,
    "C": 27.5479343001828,
    "h": 0.25162993613037,
    "CMY_C": 1,
    "CMY_M": 0.5832783,
    "CMY_Y": 0.5921924,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02139102,
    "CMYK_K": 0.5832783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01327",
    "Farbtonhilfsbezeichnung": "P0.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "155",
    "Bcolor": "154",
    "Y": 32,
    "L": 62.8790868150498,
    "a": -5.19370702726474,
    "b": -1.57741285469568,
    "C": 5.42796683844129,
    "h": 0.29486263659671,
    "CMY_C": 0.4483853,
    "CMY_M": 0.3915762,
    "CMY_Y": 0.3980019,
    "CMYK_C": 0.09337088,
    "CMYK_M": 0,
    "CMYK_Y": 0.01056125,
    "CMYK_K": 0.3915762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01330",
    "Farbtonhilfsbezeichnung": "T0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "13",
    "Gcolor": "78",
    "Bcolor": "109",
    "Y": 8,
    "L": 30.9138326911753,
    "a": -6.95470433147261,
    "b": -24.0746738406727,
    "C": 25.0590868323842,
    "h": 1.2895718478556,
    "CMY_C": 0.9496714,
    "CMY_M": 0.6948555,
    "CMY_Y": 0.5716793,
    "CMYK_C": 0.8824978,
    "CMYK_M": 0.2875793,
    "CMYK_Y": 0,
    "CMYK_K": 0.5716793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01334",
    "Farbtonhilfsbezeichnung": "C4.75.30",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "61",
    "Bcolor": "58",
    "Y": 11,
    "L": 43.0067024230957,
    "a": 47.9802093505859,
    "b": 27.9695129394531,
    "C": 55.5373229980469,
    "h": 30.2395553588867,
    "CMY_C": 0.29859840869904,
    "CMY_M": 0.76235014200211,
    "CMY_Y": 0.77417075634003,
    "CMYK_C": 0,
    "CMYK_M": 0.66117858886719,
    "CMYK_Y": 0.67803144454956,
    "CMYK_K": 0.29859840869904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01338",
    "Farbtonhilfsbezeichnung": "C0.25.65",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "150",
    "Bcolor": "141",
    "Y": 42,
    "L": 70.3266530203947,
    "a": 31.1549489578763,
    "b": 17.0807571711891,
    "C": 35.5300311019989,
    "h": 0.50150004014455,
    "CMY_C": 0.08115223,
    "CMY_M": 0.4127434,
    "CMY_Y": 0.4455787,
    "CMYK_C": 0,
    "CMYK_M": 0.3608771,
    "CMYK_Y": 0.3966125,
    "CMYK_K": 0.08115223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01340",
    "Farbtonhilfsbezeichnung": "L0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "150",
    "Bcolor": "120",
    "Y": 27,
    "L": 58.5264263666919,
    "a": -19.0415351640743,
    "b": 10.8121742297433,
    "C": 21.8971042144618,
    "h": -0.51642196461684,
    "CMY_C": 0.5612572,
    "CMY_M": 0.4128976,
    "CMY_Y": 0.5284794,
    "CMYK_C": 0.252698,
    "CMYK_M": 0,
    "CMYK_Y": 0.1968682,
    "CMYK_K": 0.4128976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01342",
    "Farbtonhilfsbezeichnung": "F6.70.70",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "189",
    "Bcolor": "0",
    "Y": 53,
    "L": 80.132682800293,
    "a": 10.2202739715576,
    "b": 82.8704833984375,
    "C": 83.4983291625977,
    "h": 82.9693145751953,
    "CMY_C": 0.01404029130936,
    "CMY_M": 0.25919514894485,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.24864591658115,
    "CMYK_Y": 1,
    "CMYK_K": 0.01404029130936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01343",
    "Farbtonhilfsbezeichnung": "D6.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "131",
    "Bcolor": "106",
    "Y": 27,
    "L": 58.536997066373,
    "a": 13.9540785209671,
    "b": 19.7892124080604,
    "C": 24.2142362072531,
    "h": 0.95663194838679,
    "CMY_C": 0.3111775,
    "CMY_M": 0.4852979,
    "CMY_Y": 0.5844873,
    "CMYK_C": 0,
    "CMYK_M": 0.2527797,
    "CMYK_Y": 0.3967783,
    "CMYK_K": 0.3111775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01344",
    "Farbtonhilfsbezeichnung": "H2.55.65",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "190",
    "Bcolor": "65",
    "Y": 45,
    "L": 73.8415603637695,
    "a": -20.1903781890869,
    "b": 58.4974746704102,
    "C": 61.8838081359863,
    "h": 109.042091369629,
    "CMY_C": 0.30457544326782,
    "CMY_M": 0.25614297389984,
    "CMY_Y": 0.74442875385284,
    "CMYK_C": 0.06510991603136,
    "CMYK_M": 0,
    "CMYK_Y": 0.65642422437668,
    "CMYK_K": 0.25614297389984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01345",
    "Farbtonhilfsbezeichnung": "K2.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "207",
    "Bcolor": "140",
    "Y": 53,
    "L": 78.1914215087891,
    "a": -29.5502243041992,
    "b": 27.5671558380127,
    "C": 40.4124221801758,
    "h": 136.988464355469,
    "CMY_C": 0.39506024122238,
    "CMY_M": 0.18713849782944,
    "CMY_Y": 0.45233589410782,
    "CMYK_C": 0.25578987598419,
    "CMYK_M": 0,
    "CMYK_Y": 0.32625162601471,
    "CMYK_K": 0.18713849782944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01346",
    "Farbtonhilfsbezeichnung": "P0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "127",
    "Bcolor": "124",
    "Y": 19,
    "L": 48.4527010674245,
    "a": -23.9988718445729,
    "b": -6.24009205495255,
    "C": 24.7968667106656,
    "h": 0.25438309976612,
    "CMY_C": 0.8099089,
    "CMY_M": 0.5037361,
    "CMY_Y": 0.5142154,
    "CMYK_C": 0.6169555,
    "CMYK_M": 0,
    "CMYK_Y": 0.02111631,
    "CMYK_K": 0.5037361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01349",
    "Farbtonhilfsbezeichnung": "F2.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "101",
    "Bcolor": "91",
    "Y": 14,
    "L": 43.0473173176734,
    "a": 0.65952224752591,
    "b": 5.76036872520491,
    "C": 5.79800115947733,
    "h": 1.45679965106619,
    "CMY_C": 0.5812478,
    "CMY_M": 0.603798,
    "CMY_Y": 0.6413249,
    "CMYK_C": 0,
    "CMYK_M": 0.05385086,
    "CMYK_Y": 0.143467,
    "CMYK_K": 0.5812478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01351",
    "Farbtonhilfsbezeichnung": "ON.00.36",
    "Farbtonklasse": "01",
    "Rcolor": "103",
    "Gcolor": "103",
    "Bcolor": "103",
    "Y": 15,
    "L": 43.5189216273987,
    "a": 0.11902421350179,
    "b": -0.56679606941252,
    "C": 0.57915848237007,
    "h": -1.36380913615584,
    "CMY_C": 0.5977082,
    "CMY_M": 0.5966504,
    "CMY_Y": 0.596481,
    "CMYK_C": 0.003041422,
    "CMYK_M": 0.000420035,
    "CMYK_Y": 0,
    "CMYK_K": 0.596481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01353",
    "Farbtonhilfsbezeichnung": "X0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "133",
    "Bcolor": "156",
    "Y": 26,
    "L": 57.6362712693197,
    "a": 10.1193832063964,
    "b": -10.6864183413944,
    "C": 14.7173860941808,
    "h": -0.8126451216592,
    "CMY_C": 0.4198258,
    "CMY_M": 0.4768072,
    "CMY_Y": 0.3882859,
    "CMYK_C": 0.05155986,
    "CMYK_M": 0.1447103,
    "CMYK_Y": 0,
    "CMYK_K": 0.3882859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01355",
    "Farbtonhilfsbezeichnung": "P0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "101",
    "Y": 11,
    "L": 38.0862843229363,
    "a": -31.0845064247498,
    "b": -8.05011983806858,
    "C": 32.1099823898672,
    "h": 0.2534080167629,
    "CMY_C": 1,
    "CMY_M": 0.5965236,
    "CMY_Y": 0.6038397,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.01813267,
    "CMYK_K": 0.5965236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01358",
    "Farbtonhilfsbezeichnung": "K2.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "184",
    "Bcolor": "154",
    "Y": 46,
    "L": 72.2642083051674,
    "a": -12.9885746266191,
    "b": 11.6145506900661,
    "C": 17.4241458488894,
    "h": -0.72960858043023,
    "CMY_C": 0.3684475,
    "CMY_M": 0.279896,
    "CMY_Y": 0.3946265,
    "CMYK_C": 0.1229704,
    "CMYK_M": 0,
    "CMYK_Y": 0.1593249,
    "CMYK_K": 0.279896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01360",
    "Farbtonhilfsbezeichnung": "F2.50.65",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "168",
    "Bcolor": "75",
    "Y": 44,
    "L": 72.1451950073242,
    "a": 11.0514059066773,
    "b": 53.5814514160156,
    "C": 54.7092819213867,
    "h": 78.3459243774414,
    "CMY_C": 0.12913686037064,
    "CMY_M": 0.34308511018753,
    "CMY_Y": 0.70498299598694,
    "CMYK_C": 0,
    "CMYK_M": 0.24567379057407,
    "CMYK_Y": 0.6612361073494,
    "CMYK_K": 0.12913686037064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01362",
    "Farbtonhilfsbezeichnung": "P0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "184",
    "Bcolor": "181",
    "Y": 44,
    "L": 71.2507853168393,
    "a": -16.27540210041,
    "b": -4.49665486983808,
    "C": 16.8851597134427,
    "h": 0.26956078054675,
    "CMY_C": 0.4707866,
    "CMY_M": 0.2802811,
    "CMY_Y": 0.2915617,
    "CMYK_C": 0.2646943,
    "CMYK_M": 0,
    "CMYK_Y": 0.01567362,
    "CMYK_K": 0.2802811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01363",
    "Farbtonhilfsbezeichnung": "Y0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "73",
    "Bcolor": "93",
    "Y": 7,
    "L": 33.9058837890625,
    "a": 13.6827812194824,
    "b": -8.61413288116455,
    "C": 16.1685428619385,
    "h": 327.80712890625,
    "CMY_C": 0.62618565559387,
    "CMY_M": 0.71490061283112,
    "CMY_Y": 0.63592839241028,
    "CMYK_C": 0,
    "CMYK_M": 0.23732358217239,
    "CMYK_Y": 0.02606303617358,
    "CMYK_K": 0.62618565559387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01364",
    "Farbtonhilfsbezeichnung": "H2.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "169",
    "Bcolor": "105",
    "Y": 38,
    "L": 67.536939654014,
    "a": -11.1983584894113,
    "b": 32.0048969044474,
    "C": 33.9074720190355,
    "h": -1.23421491006447,
    "CMY_C": 0.3534715,
    "CMY_M": 0.3375962,
    "CMY_Y": 0.5885092,
    "CMYK_C": 0.02396632,
    "CMYK_M": 0,
    "CMYK_Y": 0.3787916,
    "CMYK_K": 0.3375962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01365",
    "Farbtonhilfsbezeichnung": "E0.15.45",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "122",
    "Bcolor": "104",
    "Y": 22,
    "L": 53.1214093039143,
    "a": 7.29275886250846,
    "b": 13.2348627674115,
    "C": 15.1111192272086,
    "h": 1.06716542990894,
    "CMY_C": 0.4213368,
    "CMY_M": 0.5217223,
    "CMY_Y": 0.5935655,
    "CMYK_C": 0,
    "CMYK_M": 0.1734783,
    "CMYK_Y": 0.2976319,
    "CMYK_K": 0.4213368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01368",
    "Farbtonhilfsbezeichnung": "T0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "145",
    "Bcolor": "195",
    "Y": 26,
    "L": 56.987594037028,
    "a": -10.0934547465281,
    "b": -34.276431997956,
    "C": 35.7316612996193,
    "h": 1.28441863494358,
    "CMY_C": 0.7892168,
    "CMY_M": 0.4318648,
    "CMY_Y": 0.2369386,
    "CMYK_C": 0.7237664,
    "CMYK_M": 0.2554529,
    "CMYK_Y": 0,
    "CMYK_K": 0.2369386
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01370",
    "Farbtonhilfsbezeichnung": "E4.15.45",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "120",
    "Bcolor": "100",
    "Y": 21,
    "L": 52.124417504463,
    "a": 5.96526618954424,
    "b": 14.1215718120655,
    "C": 15.3298138004166,
    "h": 1.17111107816476,
    "CMY_C": 0.4381036,
    "CMY_M": 0.5287093,
    "CMY_Y": 0.6092513,
    "CMYK_C": 0,
    "CMYK_M": 0.1612497,
    "CMYK_Y": 0.3045894,
    "CMYK_K": 0.4381036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01371",
    "Farbtonhilfsbezeichnung": "E0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "121",
    "Bcolor": "69",
    "Y": 27,
    "L": 58.6566505432129,
    "a": 27.4800777435303,
    "b": 40.9605255126953,
    "C": 49.3246307373047,
    "h": 56.1426658630371,
    "CMY_C": 0.20681995153427,
    "CMY_M": 0.52609115839005,
    "CMY_Y": 0.72957527637482,
    "CMYK_C": 0,
    "CMYK_M": 0.40252047777176,
    "CMYK_Y": 0.65906262397766,
    "CMYK_K": 0.20681995153427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01372",
    "Farbtonhilfsbezeichnung": "C0.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "103",
    "Bcolor": "97",
    "Y": 18,
    "L": 48.7090724240086,
    "a": 19.9199883945131,
    "b": 11.3294805256365,
    "C": 22.9164366038508,
    "h": 0.51712406534355,
    "CMY_C": 0.3972501,
    "CMY_M": 0.5968763,
    "CMY_Y": 0.6209556,
    "CMYK_C": 0,
    "CMYK_M": 0.3311924,
    "CMYK_Y": 0.3711415,
    "CMYK_K": 0.3972501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01373",
    "Farbtonhilfsbezeichnung": "SN.02.37",
    "Farbtonklasse": "01",
    "Rcolor": "105",
    "Gcolor": "108",
    "Bcolor": "108",
    "Y": 16,
    "L": 45.2758889985728,
    "a": -0.79893905413153,
    "b": -1.31259913536996,
    "C": 1.5366262077651,
    "h": 1.02402657113948,
    "CMY_C": 0.5894887,
    "CMY_M": 0.5775982,
    "CMY_Y": 0.5749132,
    "CMYK_C": 0.03428834,
    "CMYK_M": 0.006316229,
    "CMYK_Y": 0,
    "CMYK_K": 0.5749132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01378",
    "Farbtonhilfsbezeichnung": "C8.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "84",
    "Bcolor": "58",
    "Y": 18,
    "L": 48.1030728912793,
    "a": 39.1525943611204,
    "b": 34.211981896915,
    "C": 51.9940895729628,
    "h": 0.71815639336389,
    "CMY_C": 0.2763038,
    "CMY_M": 0.6712724,
    "CMY_Y": 0.7738697,
    "CMYK_C": 0,
    "CMYK_M": 0.5457657,
    "CMYK_Y": 0.6875342,
    "CMYK_K": 0.2763038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01380",
    "Farbtonhilfsbezeichnung": "C0.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 7,
    "L": 30.6265031227402,
    "a": 14.3121945557432,
    "b": 7.8644154270564,
    "C": 16.3305830578938,
    "h": 0.50245198194901,
    "CMY_C": 0.6190271,
    "CMY_M": 0.7506928,
    "CMY_Y": 0.7650617,
    "CMYK_C": 0,
    "CMYK_M": 0.345604,
    "CMYK_Y": 0.3833202,
    "CMYK_K": 0.6190271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01381",
    "Farbtonhilfsbezeichnung": "LN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "238",
    "Bcolor": "229",
    "Y": 86,
    "L": 93.4097217725593,
    "a": -3.24538401989471,
    "b": 2.61945915548842,
    "C": 4.17062150091088,
    "h": -0.67907571201829,
    "CMY_C": 0.09126361,
    "CMY_M": 0.06680629,
    "CMY_Y": 0.1013203,
    "CMYK_C": 0.02620819,
    "CMYK_M": 0,
    "CMYK_Y": 0.03698479,
    "CMYK_K": 0.06680629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01382",
    "Farbtonhilfsbezeichnung": "D6.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "72",
    "Bcolor": "65",
    "Y": 8,
    "L": 31.6669196000568,
    "a": 4.1045395933183,
    "b": 5.86774766807281,
    "C": 7.16084547866322,
    "h": 0.96040027875911,
    "CMY_C": 0.6684725,
    "CMY_M": 0.7172526,
    "CMY_Y": 0.7453675,
    "CMYK_C": 0,
    "CMYK_M": 0.1471375,
    "CMYK_Y": 0.2319417,
    "CMYK_K": 0.6684725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01383",
    "Farbtonhilfsbezeichnung": "N0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "177",
    "Bcolor": "163",
    "Y": 40,
    "L": 68.1882114421884,
    "a": -21.116936095929,
    "b": 0.84560656477052,
    "C": 21.1338600483189,
    "h": -0.04002261561177,
    "CMY_C": 0.5239228,
    "CMY_M": 0.3053306,
    "CMY_Y": 0.3618318,
    "CMYK_C": 0.3146709,
    "CMYK_M": 0,
    "CMYK_Y": 0.08133544,
    "CMYK_K": 0.3053306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01384",
    "Farbtonhilfsbezeichnung": "J0.48.70",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "204",
    "Bcolor": "83",
    "Y": 53,
    "L": 77.1342544555664,
    "a": -30.5642604827881,
    "b": 54.0714912414551,
    "C": 62.1119956970215,
    "h": 119.477592468262,
    "CMY_C": 0.35196310281754,
    "CMY_M": 0.2006950378418,
    "CMY_Y": 0.67313480377197,
    "CMYK_C": 0.18924950063229,
    "CMYK_M": 0,
    "CMYK_Y": 0.59106320142746,
    "CMYK_K": 0.2006950378418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01386",
    "Farbtonhilfsbezeichnung": "F6.05.50",
    "Farbtonklasse": "01",
    "Rcolor": "144",
    "Gcolor": "139",
    "Bcolor": "129",
    "Y": 27,
    "L": 57.9912162234698,
    "a": 0.51190677633494,
    "b": 5.48138334807458,
    "C": 5.50523495921899,
    "h": 1.47767635135179,
    "CMY_C": 0.4337609,
    "CMY_M": 0.4556975,
    "CMY_Y": 0.4948486,
    "CMYK_C": 0,
    "CMYK_M": 0.038741,
    "CMYK_Y": 0.1078834,
    "CMYK_K": 0.4337609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01387",
    "Farbtonhilfsbezeichnung": "C0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "76",
    "Bcolor": "75",
    "Y": 9,
    "L": 33.3717815407875,
    "a": 4.00963189296197,
    "b": 2.10188623098203,
    "C": 4.52714851148597,
    "h": 0.48282692789893,
    "CMY_C": 0.6615496,
    "CMY_M": 0.7006896,
    "CMY_Y": 0.7072364,
    "CMYK_C": 0,
    "CMYK_M": 0.1156447,
    "CMYK_Y": 0.1349882,
    "CMYK_K": 0.6615496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01388",
    "Farbtonhilfsbezeichnung": "F2.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "226",
    "Bcolor": "189",
    "Y": 80,
    "L": 91.4021606445312,
    "a": 5.10134840011597,
    "b": 21.1852149963379,
    "C": 21.7907562255859,
    "h": 76.461067199707,
    "CMY_C": 0,
    "CMY_M": 0.11404514312744,
    "CMY_Y": 0.26027411222458,
    "CMYK_C": 0,
    "CMYK_M": 0.11404514312744,
    "CMYK_Y": 0.26027411222458,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01389",
    "Farbtonhilfsbezeichnung": "E4.60.50",
    "Farbtonklasse": "04",
    "Rcolor": "193",
    "Gcolor": "116",
    "Bcolor": "46",
    "Y": 25,
    "L": 56.1182409486892,
    "a": 25.3427400091132,
    "b": 49.1801519731308,
    "C": 55.3257789757157,
    "h": 1.09498043397748,
    "CMY_C": 0.2412739,
    "CMY_M": 0.5461121,
    "CMY_Y": 0.8199311,
    "CMYK_C": 0,
    "CMYK_M": 0.4017763,
    "CMYK_Y": 0.7626694,
    "CMYK_K": 0.2412739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01390",
    "Farbtonhilfsbezeichnung": "D6.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "181",
    "Bcolor": "165",
    "Y": 52,
    "L": 75.9613392485134,
    "a": 8.38447299161904,
    "b": 11.5377556417079,
    "C": 14.2625100383821,
    "h": 0.94237553298678,
    "CMY_C": 0.1724322,
    "CMY_M": 0.2882681,
    "CMY_Y": 0.3524627,
    "CMYK_C": 0,
    "CMYK_M": 0.1399715,
    "CMYK_Y": 0.2175417,
    "CMYK_K": 0.1724322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01393",
    "Farbtonhilfsbezeichnung": "G0.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "210",
    "Bcolor": "108",
    "Y": 69,
    "L": 85.2309088570377,
    "a": 0.01148812988066,
    "b": 53.4509978645584,
    "C": 53.4509990991202,
    "h": 1.57058139853981,
    "CMY_C": 0.04449588,
    "CMY_M": 0.1756623,
    "CMY_Y": 0.5748071,
    "CMYK_C": 0,
    "CMYK_M": 0.1372746,
    "CMYK_Y": 0.5550067,
    "CMYK_K": 0.04449588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01394",
    "Farbtonhilfsbezeichnung": "C4.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "141",
    "Bcolor": "124",
    "Y": 37,
    "L": 67.7656173706055,
    "a": 32.5733413696289,
    "b": 23.2068004608154,
    "C": 39.9947280883789,
    "h": 35.4678802490234,
    "CMY_C": 0.09306609630585,
    "CMY_M": 0.44547837972641,
    "CMY_Y": 0.51382493972778,
    "CMYK_C": 0,
    "CMYK_M": 0.3885754942894,
    "CMYK_Y": 0.46393552422523,
    "CMYK_K": 0.09306609630585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01396",
    "Farbtonhilfsbezeichnung": "Z0.20.60",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "141",
    "Bcolor": "172",
    "Y": 36,
    "L": 65.8380453648572,
    "a": 29.7030608483206,
    "b": -6.75739140876228,
    "C": 30.4620117919065,
    "h": -0.22369094210558,
    "CMY_C": 0.1910879,
    "CMY_M": 0.4478644,
    "CMY_Y": 0.3271606,
    "CMYK_C": 0,
    "CMYK_M": 0.3174343,
    "CMYK_Y": 0.1682168,
    "CMYK_K": 0.1910879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01397",
    "Farbtonhilfsbezeichnung": "B2.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "166",
    "Bcolor": "168",
    "Y": 49,
    "L": 75.6176376342773,
    "a": 29.5857334136963,
    "b": 9.84423732757568,
    "C": 31.1805171966553,
    "h": 18.4041385650635,
    "CMY_C": 0.04278844594955,
    "CMY_M": 0.34993875026703,
    "CMY_Y": 0.34046602249146,
    "CMYK_C": 0,
    "CMYK_M": 0.32088026404381,
    "CMYK_Y": 0.31098410487175,
    "CMYK_K": 0.04278844594955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01400",
    "Farbtonhilfsbezeichnung": "S9.35.56",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "165",
    "Bcolor": "211",
    "Y": 33,
    "L": 64.8564910888672,
    "a": -9.82320880889893,
    "b": -31.3388347625732,
    "C": 32.8423194885254,
    "h": 252.596313476562,
    "CMY_C": 0.64830827713013,
    "CMY_M": 0.35202306509018,
    "CMY_Y": 0.17160046100616,
    "CMYK_C": 0.57545638084412,
    "CMYK_M": 0.2177965939045,
    "CMYK_Y": 0,
    "CMYK_K": 0.17160046100616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01401",
    "Farbtonhilfsbezeichnung": "G0.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "109",
    "Bcolor": "68",
    "Y": 16,
    "L": 46.6089444465209,
    "a": -0.34047084618804,
    "b": 24.5983935439677,
    "C": 24.6007496906297,
    "h": -1.55695602841117,
    "CMY_C": 0.514536,
    "CMY_M": 0.5708146,
    "CMY_Y": 0.7322209,
    "CMYK_C": 0,
    "CMYK_M": 0.1159276,
    "CMYK_Y": 0.448406,
    "CMYK_K": 0.514536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01402",
    "Farbtonhilfsbezeichnung": "L8.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "103",
    "Bcolor": "78",
    "Y": 12,
    "L": 39.1514417077371,
    "a": -26.095069715022,
    "b": 8.14344176376051,
    "C": 27.3362087201502,
    "h": -0.3024914478859,
    "CMY_C": 0.832768,
    "CMY_M": 0.5961211,
    "CMY_Y": 0.6959442,
    "CMYK_C": 0.5859351,
    "CMYK_M": 0,
    "CMYK_Y": 0.247161,
    "CMYK_K": 0.5961211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01403",
    "Farbtonhilfsbezeichnung": "V0.25.25",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "82",
    "Bcolor": "119",
    "Y": 9,
    "L": 35.3622933459407,
    "a": 6.11232893681671,
    "b": -22.8213275250823,
    "C": 23.6256969217614,
    "h": -1.30910435674438,
    "CMY_C": 0.7203231,
    "CMY_M": 0.6791537,
    "CMY_Y": 0.5349042,
    "CMYK_C": 0.3986681,
    "CMYK_M": 0.3101501,
    "CMYK_Y": 0,
    "CMYK_K": 0.5349042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01404",
    "Farbtonhilfsbezeichnung": "F6.10.50",
    "Farbtonklasse": "01",
    "Rcolor": "153",
    "Gcolor": "142",
    "Bcolor": "125",
    "Y": 28,
    "L": 59.5635908162146,
    "a": 1.3976312777495,
    "b": 9.97424881508013,
    "C": 10.0716936318412,
    "h": 1.43157880677796,
    "CMY_C": 0.3997125,
    "CMY_M": 0.4426984,
    "CMY_Y": 0.5095865,
    "CMYK_C": 0,
    "CMYK_M": 0.07160886,
    "CMYK_Y": 0.1830356,
    "CMYK_K": 0.3997125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01405",
    "Farbtonhilfsbezeichnung": "F2.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "151",
    "Bcolor": "105",
    "Y": 32,
    "L": 64.0604305311842,
    "a": 5.52131205733658,
    "b": 27.9257094401992,
    "C": 28.466298223916,
    "h": 1.37559951960545,
    "CMY_C": 0.2883894,
    "CMY_M": 0.4096986,
    "CMY_Y": 0.5894144,
    "CMYK_C": 0,
    "CMYK_M": 0.1704713,
    "CMYK_Y": 0.4230192,
    "CMYK_K": 0.2883894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01406",
    "Farbtonhilfsbezeichnung": "F2.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "186",
    "Bcolor": "144",
    "Y": 53,
    "L": 76.9076738582121,
    "a": 4.86179346914373,
    "b": 24.3264152061949,
    "C": 24.8074890410295,
    "h": 1.37353870137958,
    "CMY_C": 0.1570199,
    "CMY_M": 0.2724129,
    "CMY_Y": 0.4353404,
    "CMYK_C": 0,
    "CMYK_M": 0.1368869,
    "CMYK_Y": 0.3301626,
    "CMYK_K": 0.1570199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01407",
    "Farbtonhilfsbezeichnung": "S0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "145",
    "Bcolor": "183",
    "Y": 25,
    "L": 56.2913311817914,
    "a": -16.4435167383498,
    "b": -29.0483192859448,
    "C": 33.3795460733454,
    "h": 1.05569556472596,
    "CMY_C": 0.8609743,
    "CMY_M": 0.4294377,
    "CMY_Y": 0.2805734,
    "CMYK_C": 0.8067548,
    "CMYK_M": 0.2069208,
    "CMYK_Y": 0,
    "CMYK_K": 0.2805734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01408",
    "Farbtonhilfsbezeichnung": "T0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "104",
    "Bcolor": "139",
    "Y": 11,
    "L": 41.7373046875,
    "a": -6.34638929367065,
    "b": -25.5296878814697,
    "C": 26.3066844940186,
    "h": 256.039886474609,
    "CMY_C": 0.80957853794098,
    "CMY_M": 0.59364223480225,
    "CMY_Y": 0.45480066537857,
    "CMYK_C": 0.65073055028915,
    "CMYK_M": 0.25466203689575,
    "CMYK_Y": 0,
    "CMYK_K": 0.45480066537857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01409",
    "Farbtonhilfsbezeichnung": "B2.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "130",
    "Bcolor": "131",
    "Y": 26,
    "L": 57.388425322605,
    "a": 13.2392361279186,
    "b": 3.79051415634504,
    "C": 13.7711789916564,
    "h": 0.27884952144041,
    "CMY_C": 0.360256,
    "CMY_M": 0.4912843,
    "CMY_Y": 0.4876732,
    "CMYK_C": 0,
    "CMYK_M": 0.2048136,
    "CMYK_Y": 0.1991691,
    "CMYK_K": 0.360256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01410",
    "Farbtonhilfsbezeichnung": "U0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "120",
    "Bcolor": "150",
    "Y": 18,
    "L": 50.0016555786133,
    "a": -0.08870320022106,
    "b": -18.9562530517578,
    "C": 18.9564609527588,
    "h": 269.731903076172,
    "CMY_C": 0.61024057865143,
    "CMY_M": 0.5274663567543,
    "CMY_Y": 0.41278505325317,
    "CMYK_C": 0.33625766634941,
    "CMYK_M": 0.19529697299004,
    "CMYK_Y": 0,
    "CMYK_K": 0.41278505325317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01411",
    "Farbtonhilfsbezeichnung": "E0.60.50",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "117",
    "Bcolor": "55",
    "Y": 27,
    "L": 58.3449974060059,
    "a": 31.5005321502686,
    "b": 47.9786491394043,
    "C": 57.3954200744629,
    "h": 56.7129745483398,
    "CMY_C": 0.1833643913269,
    "CMY_M": 0.54309451580048,
    "CMY_Y": 0.78534615039825,
    "CMYK_C": 0,
    "CMYK_M": 0.44050261378288,
    "CMYK_Y": 0.73714858293533,
    "CMYK_K": 0.1833643913269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01414",
    "Farbtonhilfsbezeichnung": "D2.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "101",
    "Bcolor": "75",
    "Y": 17,
    "L": 49.8199310302734,
    "a": 25.0039615631104,
    "b": 25.8329963684082,
    "C": 35.9519386291504,
    "h": 45.9342842102051,
    "CMY_C": 0.33684605360031,
    "CMY_M": 0.60381197929382,
    "CMY_Y": 0.70532667636871,
    "CMYK_C": 0,
    "CMYK_M": 0.40257006883621,
    "CMYK_Y": 0.55564868450165,
    "CMYK_K": 0.33684605360031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01416",
    "Farbtonhilfsbezeichnung": "G0.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "159",
    "Bcolor": "81",
    "Y": 36,
    "L": 66.2161641993751,
    "a": 0.42955989017767,
    "b": 43.337310192715,
    "C": 43.3394390415802,
    "h": 1.56088464050651,
    "CMY_C": 0.2733836,
    "CMY_M": 0.3779721,
    "CMY_Y": 0.6840664,
    "CMYK_C": 0,
    "CMYK_M": 0.1439391,
    "CMYK_Y": 0.5651988,
    "CMYK_K": 0.2733836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01417",
    "Farbtonhilfsbezeichnung": "E0.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "104",
    "Bcolor": "70",
    "Y": 17,
    "L": 47.849489208177,
    "a": 14.3513819837845,
    "b": 25.6847384962926,
    "C": 29.4222357489609,
    "h": 1.06125907623228,
    "CMY_C": 0.4159789,
    "CMY_M": 0.5931722,
    "CMY_Y": 0.7249739,
    "CMYK_C": 0,
    "CMYK_M": 0.3034022,
    "CMYK_Y": 0.5290819,
    "CMYK_K": 0.4159789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01418",
    "Farbtonhilfsbezeichnung": "K2.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "95",
    "Bcolor": "73",
    "Y": 11,
    "L": 38.4135250566648,
    "a": -11.2878363725303,
    "b": 10.0261360245417,
    "C": 15.0976373501165,
    "h": -0.72627123562704,
    "CMY_C": 0.6954786,
    "CMY_M": 0.6264073,
    "CMY_Y": 0.7128263,
    "CMYK_C": 0.1848839,
    "CMYK_M": 0,
    "CMYK_Y": 0.2313188,
    "CMYK_K": 0.6264073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01422",
    "Farbtonhilfsbezeichnung": "K2.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "125",
    "Bcolor": "77",
    "Y": 18,
    "L": 48.4633097938635,
    "a": -23.9817529708186,
    "b": 21.5326605444444,
    "C": 32.2301093028807,
    "h": -0.73164084536408,
    "CMY_C": 0.6676984,
    "CMY_M": 0.5091509,
    "CMY_Y": 0.6986228,
    "CMYK_C": 0.3230065,
    "CMYK_M": 0,
    "CMYK_Y": 0.3860083,
    "CMYK_K": 0.5091509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01423",
    "Farbtonhilfsbezeichnung": "L8.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "128",
    "Bcolor": "94",
    "Y": 18,
    "L": 48.2555676977325,
    "a": -32.6828410567001,
    "b": 11.14326250353,
    "C": 34.5302823440542,
    "h": -0.32859113126331,
    "CMY_C": 0.807349,
    "CMY_M": 0.4965996,
    "CMY_Y": 0.6316688,
    "CMYK_C": 0.6173007,
    "CMYK_M": 0,
    "CMYK_Y": 0.2683136,
    "CMYK_K": 0.4965996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01424",
    "Farbtonhilfsbezeichnung": "F2.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "156",
    "Bcolor": "88",
    "Y": 38,
    "L": 67.4545516967773,
    "a": 9.68035793304443,
    "b": 41.461254119873,
    "C": 42.576343536377,
    "h": 76.8580322265625,
    "CMY_C": 0.20541375875473,
    "CMY_M": 0.38690900802612,
    "CMY_Y": 0.65474724769592,
    "CMYK_C": 0,
    "CMYK_M": 0.2284147888422,
    "CMYK_Y": 0.56549364328384,
    "CMYK_K": 0.20541375875473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01425",
    "Farbtonhilfsbezeichnung": "F2.35.65",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "169",
    "Bcolor": "104",
    "Y": 44,
    "L": 71.9594421386719,
    "a": 9.25108909606934,
    "b": 39.1726188659668,
    "C": 40.2501754760742,
    "h": 76.7123718261719,
    "CMY_C": 0.15956771373749,
    "CMY_M": 0.33842879533768,
    "CMY_Y": 0.59335219860077,
    "CMYK_C": 0,
    "CMYK_M": 0.21282033622265,
    "CMYK_Y": 0.51614445447922,
    "CMYK_K": 0.15956771373749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01426",
    "Farbtonhilfsbezeichnung": "F6.25.70",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "187",
    "Bcolor": "131",
    "Y": 53,
    "L": 76.87973013469,
    "a": 2.27756920009975,
    "b": 31.4092833905804,
    "C": 31.491751373511,
    "h": 1.49841040703663,
    "CMY_C": 0.1607704,
    "CMY_M": 0.2679048,
    "CMY_Y": 0.4880345,
    "CMYK_C": 0,
    "CMYK_M": 0.127658,
    "CMYK_Y": 0.3899578,
    "CMYK_K": 0.1607704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01427",
    "Farbtonhilfsbezeichnung": "K2.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "206",
    "Bcolor": "124",
    "Y": 53,
    "L": 76.6335935181222,
    "a": -37.037230670389,
    "b": 33.4336730657328,
    "C": 49.8955604277366,
    "h": -0.73430726719833,
    "CMY_C": 0.4620402,
    "CMY_M": 0.1922078,
    "CMY_Y": 0.5135759,
    "CMYK_C": 0.3340369,
    "CMYK_M": 0,
    "CMYK_Y": 0.397835,
    "CMYK_K": 0.1922078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01429",
    "Farbtonhilfsbezeichnung": "G4.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "234",
    "Bcolor": "222",
    "Y": 84,
    "L": 92.7622984203501,
    "a": -0.39662751056618,
    "b": 5.38063127476616,
    "C": 5.39522995776173,
    "h": -1.49721547120551,
    "CMY_C": 0.06672351,
    "CMY_M": 0.08153564,
    "CMY_Y": 0.1286235,
    "CMYK_C": 0,
    "CMYK_M": 0.01587111,
    "CMYK_Y": 0.06632546,
    "CMYK_K": 0.06672351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01430",
    "Farbtonhilfsbezeichnung": "E0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "124",
    "Bcolor": "88",
    "Y": 25,
    "L": 56.2151102436098,
    "a": 15.2396788090083,
    "b": 26.6710109071367,
    "C": 30.7179203887623,
    "h": 1.05167561863901,
    "CMY_C": 0.3185158,
    "CMY_M": 0.5132931,
    "CMY_Y": 0.6537508,
    "CMYK_C": 0,
    "CMYK_M": 0.2858134,
    "CMYK_Y": 0.4919189,
    "CMYK_K": 0.3185158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01431",
    "Farbtonhilfsbezeichnung": "E0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "121",
    "Bcolor": "74",
    "Y": 26,
    "L": 57.0419219573415,
    "a": 22.6581496141934,
    "b": 36.2444497096642,
    "C": 42.7440274037853,
    "h": 1.01209050493115,
    "CMY_C": 0.2562502,
    "CMY_M": 0.5271468,
    "CMY_Y": 0.7116551,
    "CMYK_C": 0,
    "CMYK_M": 0.3642309,
    "CMYK_Y": 0.6123093,
    "CMYK_K": 0.2562502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01432",
    "Farbtonhilfsbezeichnung": "D6.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "62",
    "Bcolor": "47",
    "Y": 7,
    "L": 29.4020659764346,
    "a": 11.8000647631598,
    "b": 14.1634918601203,
    "C": 18.4349133463236,
    "h": 0.87617661269292,
    "CMY_C": 0.6347609,
    "CMY_M": 0.7566044,
    "CMY_Y": 0.8139946,
    "CMYK_C": 0,
    "CMYK_M": 0.3335993,
    "CMYK_Y": 0.4907297,
    "CMYK_K": 0.6347609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01437",
    "Farbtonhilfsbezeichnung": "T0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "119",
    "Bcolor": "129",
    "Y": 18,
    "L": 49.4675445556641,
    "a": -1.71948289871216,
    "b": -7.69984674453735,
    "C": 7.88950300216675,
    "h": 257.411590576172,
    "CMY_C": 0.57812917232513,
    "CMY_M": 0.53292119503021,
    "CMY_Y": 0.49236571788788,
    "CMYK_C": 0.16894732415676,
    "CMYK_M": 0.07989113032818,
    "CMYK_Y": 0,
    "CMYK_K": 0.49236571788788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01439",
    "Farbtonhilfsbezeichnung": "L8.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "98",
    "Bcolor": "79",
    "Y": 12,
    "L": 38.2465390354232,
    "a": -19.1123825370472,
    "b": 5.860892492922,
    "C": 19.9908285735238,
    "h": -0.29755033521468,
    "CMY_C": 0.7761742,
    "CMY_M": 0.6146314,
    "CMY_Y": 0.6889223,
    "CMYK_C": 0.4191906,
    "CMYK_M": 0,
    "CMYK_Y": 0.192779,
    "CMYK_K": 0.6146314
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01440",
    "Farbtonhilfsbezeichnung": "N0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "104",
    "Bcolor": "89",
    "Y": 12,
    "L": 38.4325298946141,
    "a": -32.7441427185161,
    "b": 0.11852002210547,
    "C": 32.7443572141246,
    "h": -0.00361956352125,
    "CMY_C": 1,
    "CMY_M": 0.5928438,
    "CMY_Y": 0.6522534,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1459138,
    "CMYK_K": 0.5928438
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01441",
    "Farbtonhilfsbezeichnung": "D2.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "212",
    "Gcolor": "110",
    "Bcolor": "76",
    "Y": 25,
    "L": 57.7953186035156,
    "a": 37.6042900085449,
    "b": 36.4715538024902,
    "C": 52.3856544494629,
    "h": 44.1239280700684,
    "CMY_C": 0.16755264997482,
    "CMY_M": 0.56800079345703,
    "CMY_Y": 0.70151668787003,
    "CMYK_C": 0,
    "CMYK_M": 0.48104920983315,
    "CMYK_Y": 0.64143878221512,
    "CMYK_K": 0.16755264997482
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01442",
    "Farbtonhilfsbezeichnung": "C8.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "82",
    "Bcolor": "68",
    "Y": 12,
    "L": 39.9898867332583,
    "a": 19.0085905596832,
    "b": 15.9994834278024,
    "C": 24.8457236767658,
    "h": 0.69965425246018,
    "CMY_C": 0.4873516,
    "CMY_M": 0.6788737,
    "CMY_Y": 0.7315676,
    "CMYK_C": 0,
    "CMYK_M": 0.3735935,
    "CMYK_Y": 0.476381,
    "CMYK_K": 0.4873516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01443",
    "Farbtonhilfsbezeichnung": "B6.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "75",
    "Bcolor": "77",
    "Y": 12,
    "L": 39.3271964005502,
    "a": 26.818212335296,
    "b": 10.1766058534113,
    "C": 28.6841388149741,
    "h": 0.36268050570999,
    "CMY_C": 0.4621328,
    "CMY_M": 0.7071927,
    "CMY_Y": 0.6995046,
    "CMYK_C": 0,
    "CMYK_M": 0.4556141,
    "CMYK_Y": 0.4413204,
    "CMYK_K": 0.4621328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01445",
    "Farbtonhilfsbezeichnung": "P0.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "156",
    "Bcolor": "154",
    "Y": 31,
    "L": 61.4105512954032,
    "a": -14.2326144811379,
    "b": -4.29569272609991,
    "C": 14.866751190686,
    "h": 0.29312600520598,
    "CMY_C": 0.5514619,
    "CMY_M": 0.3882211,
    "CMY_Y": 0.395506,
    "CMYK_C": 0.2668299,
    "CMYK_M": 0,
    "CMYK_Y": 0.01190782,
    "CMYK_K": 0.3882211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01446",
    "Farbtonhilfsbezeichnung": "L0.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "158",
    "Bcolor": "132",
    "Y": 32,
    "L": 62.189869288925,
    "a": -15.064572939956,
    "b": 9.31955548787251,
    "C": 17.7142731252171,
    "h": -0.55401314202475,
    "CMY_C": 0.4964111,
    "CMY_M": 0.3818147,
    "CMY_Y": 0.4812558,
    "CMYK_C": 0.1853756,
    "CMYK_M": 0,
    "CMYK_Y": 0.1608597,
    "CMYK_K": 0.3818147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01447",
    "Farbtonhilfsbezeichnung": "K2.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "170",
    "Bcolor": "130",
    "Y": 37,
    "L": 66.7355866860658,
    "a": -17.3256426228665,
    "b": 16.9001905795856,
    "C": 24.2031885073351,
    "h": -0.77296807502671,
    "CMY_C": 0.444235,
    "CMY_M": 0.331376,
    "CMY_Y": 0.4889771,
    "CMYK_C": 0.1687929,
    "CMYK_M": 0,
    "CMYK_Y": 0.2357096,
    "CMYK_K": 0.331376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01448",
    "Farbtonhilfsbezeichnung": "F2.50.70",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "176",
    "Bcolor": "67",
    "Y": 49,
    "L": 75.5983138225898,
    "a": 11.8278279739877,
    "b": 61.1402653349207,
    "C": 62.2738272455351,
    "h": 1.37970286217978,
    "CMY_C": 0.07620714,
    "CMY_M": 0.3096461,
    "CMY_Y": 0.736348,
    "CMYK_C": 0,
    "CMYK_M": 0.2526962,
    "CMYK_Y": 0.7145984,
    "CMYK_K": 0.07620714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01449",
    "Farbtonhilfsbezeichnung": "Y0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "156",
    "Bcolor": "176",
    "Y": 38,
    "L": 67.4667085435839,
    "a": 14.060306425439,
    "b": -7.01939946375443,
    "C": 15.7150941966314,
    "h": -0.46303555755779,
    "CMY_C": 0.2769597,
    "CMY_M": 0.3869708,
    "CMY_Y": 0.3102735,
    "CMYK_C": 0,
    "CMYK_M": 0.1521508,
    "CMYK_Y": 0.04607464,
    "CMYK_K": 0.2769597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01450",
    "Farbtonhilfsbezeichnung": "D6.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "134",
    "Bcolor": "123",
    "Y": 27,
    "L": 57.4869616734739,
    "a": 6.02325813763577,
    "b": 8.23731682671658,
    "C": 10.2045591328731,
    "h": 0.93942573928574,
    "CMY_C": 0.39488,
    "CMY_M": 0.4738906,
    "CMY_Y": 0.5176768,
    "CMYK_C": 0,
    "CMYK_M": 0.13057,
    "CMYK_Y": 0.2029296,
    "CMYK_K": 0.39488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01451",
    "Farbtonhilfsbezeichnung": "C0.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "147",
    "Bcolor": "143",
    "Y": 32,
    "L": 62.3408622712266,
    "a": 6.84284523411949,
    "b": 3.83784530999429,
    "C": 7.84560944232868,
    "h": 0.51113911739447,
    "CMY_C": 0.3496963,
    "CMY_M": 0.4252794,
    "CMY_Y": 0.4390424,
    "CMYK_C": 0,
    "CMYK_M": 0.1162274,
    "CMYK_Y": 0.1373914,
    "CMYK_K": 0.3496963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01452",
    "Farbtonhilfsbezeichnung": "S0.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "173",
    "Bcolor": "203",
    "Y": 38,
    "L": 67.3380487898251,
    "a": -13.8660545293109,
    "b": -22.7235541664285,
    "C": 26.620056013548,
    "h": 1.02290601769432,
    "CMY_C": 0.5981274,
    "CMY_M": 0.3210993,
    "CMY_Y": 0.205175,
    "CMYK_C": 0.4943885,
    "CMYK_M": 0.1458488,
    "CMYK_Y": 0,
    "CMYK_K": 0.205175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01454",
    "Farbtonhilfsbezeichnung": "H2.50.70",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "198",
    "Bcolor": "77",
    "Y": 51,
    "L": 76.9522857666016,
    "a": -19.9413051605225,
    "b": 57.1119384765625,
    "C": 60.4932174682617,
    "h": 109.247253417969,
    "CMY_C": 0.2699156999588,
    "CMY_M": 0.22291070222855,
    "CMY_Y": 0.69856178760529,
    "CMYK_C": 0.06048854067922,
    "CMYK_M": 0,
    "CMYK_Y": 0.61209321022034,
    "CMYK_K": 0.22291070222855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01455",
    "Farbtonhilfsbezeichnung": "G8.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "114",
    "Bcolor": "82",
    "Y": 17,
    "L": 47.3738438556597,
    "a": -3.95997149221439,
    "b": 17.4377319769855,
    "C": 17.8817188972518,
    "h": -1.34749147059697,
    "CMY_C": 0.5421525,
    "CMY_M": 0.5547764,
    "CMY_Y": 0.6777256,
    "CMYK_C": 0,
    "CMYK_M": 0.02757234,
    "CMYK_Y": 0.2961097,
    "CMYK_K": 0.5421525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01459",
    "Farbtonhilfsbezeichnung": "C8.25.15",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "54",
    "Bcolor": "48",
    "Y": 6,
    "L": 26.2403059178886,
    "a": 13.0697868583684,
    "b": 9.65957357162091,
    "C": 16.2519749602544,
    "h": 0.63647339689054,
    "CMY_C": 0.6653802,
    "CMY_M": 0.7868307,
    "CMY_Y": 0.8135976,
    "CMYK_C": 0,
    "CMYK_M": 0.3629507,
    "CMYK_Y": 0.4429427,
    "CMYK_K": 0.6653802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01460",
    "Farbtonhilfsbezeichnung": "L0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "196",
    "Bcolor": "162",
    "Y": 50,
    "L": 75.3047578610643,
    "a": -20.9370270157452,
    "b": 11.8971687256593,
    "C": 24.0811487256079,
    "h": -0.51673596114127,
    "CMY_C": 0.4022621,
    "CMY_M": 0.2315913,
    "CMY_Y": 0.3663003,
    "CMYK_C": 0.2221094,
    "CMYK_M": 0,
    "CMYK_Y": 0.175309,
    "CMYK_K": 0.2315913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01461",
    "Farbtonhilfsbezeichnung": "E8.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "180",
    "Y": 54,
    "L": 77.785132643742,
    "a": 1.75274326345581,
    "b": 5.94901493970208,
    "C": 6.20184550762015,
    "h": 1.2842757113022,
    "CMY_C": 0.2143029,
    "CMY_M": 0.2513051,
    "CMY_Y": 0.2943247,
    "CMYK_C": 0,
    "CMYK_M": 0.04709474,
    "CMYK_Y": 0.1018481,
    "CMYK_K": 0.2143029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01462",
    "Farbtonhilfsbezeichnung": "E8.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "201",
    "Bcolor": "176",
    "Y": 62,
    "L": 82.295177508776,
    "a": 4.70713575586829,
    "b": 14.5359408315049,
    "C": 15.2790936537867,
    "h": 1.25762538019747,
    "CMY_C": 0.1200328,
    "CMY_M": 0.2116937,
    "CMY_Y": 0.3081876,
    "CMYK_C": 0,
    "CMYK_M": 0.104164,
    "CMYK_Y": 0.2138202,
    "CMYK_K": 0.1200328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01463",
    "Farbtonhilfsbezeichnung": "A0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "51",
    "Bcolor": "69",
    "Y": 7,
    "L": 29.4473671718295,
    "a": 28.3832717153218,
    "b": 0.25676760232353,
    "C": 28.3844331080857,
    "h": 0.00904619456083,
    "CMY_C": 0.5724795,
    "CMY_M": 0.8018227,
    "CMY_Y": 0.7282126,
    "CMYK_C": 0,
    "CMYK_M": 0.5364495,
    "CMYK_Y": 0.3642704,
    "CMYK_K": 0.5724795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01464",
    "Farbtonhilfsbezeichnung": "H2.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "141",
    "Bcolor": "103",
    "Y": 27,
    "L": 57.6985790442905,
    "a": -6.17245363383084,
    "b": 19.9736452340606,
    "C": 20.905637703689,
    "h": -1.27107594436382,
    "CMY_C": 0.4469004,
    "CMY_M": 0.4476336,
    "CMY_Y": 0.5975577,
    "CMYK_C": 0,
    "CMYK_M": 0.001325575,
    "CMYK_Y": 0.2723872,
    "CMYK_K": 0.4469004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01465",
    "Farbtonhilfsbezeichnung": "C8.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "83",
    "Bcolor": "76",
    "Y": 10,
    "L": 36.8027682710845,
    "a": 6.92961750516979,
    "b": 6.10929009646719,
    "C": 9.23812882843424,
    "h": 0.72256716013199,
    "CMY_C": 0.6025154,
    "CMY_M": 0.6763114,
    "CMY_Y": 0.7003583,
    "CMYK_C": 0,
    "CMYK_M": 0.1856574,
    "CMYK_Y": 0.2461553,
    "CMYK_K": 0.6025154
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01466",
    "Farbtonhilfsbezeichnung": "P0.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "217",
    "Bcolor": "212",
    "Y": 61,
    "L": 82.868896484375,
    "a": -18.3814373016357,
    "b": -4.13563680648804,
    "C": 18.8409328460693,
    "h": 192.679824829102,
    "CMY_C": 0.36661851406097,
    "CMY_M": 0.1496319770813,
    "CMY_Y": 0.16942316293716,
    "CMYK_C": 0.25516781210899,
    "CMYK_M": 0,
    "CMYK_Y": 0.0232736710459,
    "CMYK_K": 0.1496319770813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01468",
    "Farbtonhilfsbezeichnung": "S0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "170",
    "Bcolor": "190",
    "Y": 38,
    "L": 67.1491660155064,
    "a": -9.2362056430968,
    "b": -15.9905081658099,
    "C": 18.4662894508455,
    "h": 1.04700614086346,
    "CMY_C": 0.5048731,
    "CMY_M": 0.334419,
    "CMY_Y": 0.2538609,
    "CMYK_C": 0.3364147,
    "CMYK_M": 0.1079666,
    "CMYK_Y": 0,
    "CMYK_K": 0.2538609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01469",
    "Farbtonhilfsbezeichnung": "Q0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 18,
    "L": 48.0374809466365,
    "a": -13.4098601921101,
    "b": -7.77365062247524,
    "C": 15.5001288501821,
    "h": 0.52535675048043,
    "CMY_C": 0.6941794,
    "CMY_M": 0.5249511,
    "CMY_Y": 0.507287,
    "CMYK_C": 0.3793129,
    "CMYK_M": 0.03585064,
    "CMYK_Y": 0,
    "CMYK_K": 0.507287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01470",
    "Farbtonhilfsbezeichnung": "B6.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "61",
    "Bcolor": "67",
    "Y": 11,
    "L": 37.8760454135415,
    "a": 37.3395390597142,
    "b": 14.2758627693917,
    "C": 39.9755104407989,
    "h": 0.36517762126151,
    "CMY_C": 0.420668,
    "CMY_M": 0.7608052,
    "CMY_Y": 0.7358688,
    "CMYK_C": 0,
    "CMYK_M": 0.5871198,
    "CMYK_Y": 0.5440763,
    "CMYK_K": 0.420668
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01471",
    "Farbtonhilfsbezeichnung": "C4.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "83",
    "Bcolor": "73",
    "Y": 17,
    "L": 48.9723587036133,
    "a": 42.0345687866211,
    "b": 26.3696136474609,
    "C": 49.6211814880371,
    "h": 32.1013488769531,
    "CMY_C": 0.25864338874817,
    "CMY_M": 0.67259204387665,
    "CMY_Y": 0.71217119693756,
    "CMYK_C": 0,
    "CMYK_M": 0.55836641788483,
    "CMYK_Y": 0.61175394058228,
    "CMYK_K": 0.25864338874817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01472",
    "Farbtonhilfsbezeichnung": "N0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "156",
    "Bcolor": "133",
    "Y": 26,
    "L": 56.8236978451312,
    "a": -45.0397894383274,
    "b": 0.4269265336211,
    "C": 45.0418127845004,
    "h": -0.00947859111502,
    "CMY_C": 1,
    "CMY_M": 0.3884293,
    "CMY_Y": 0.4774466,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1455552,
    "CMYK_K": 0.3884293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01473",
    "Farbtonhilfsbezeichnung": "H2.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "213",
    "Y": 85,
    "L": 92.9348983764648,
    "a": -3.45621132850647,
    "b": 10.4162359237671,
    "C": 10.9746694564819,
    "h": 108.35636138916,
    "CMY_C": 0.0728046298027,
    "CMY_M": 0.07369482517242,
    "CMY_Y": 0.16470867395401,
    "CMYK_C": 0,
    "CMYK_M": 0.00096009473782,
    "CMYK_Y": 0.09912047535181,
    "CMYK_K": 0.0728046298027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01474",
    "Farbtonhilfsbezeichnung": "C4.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "60",
    "Bcolor": "51",
    "Y": 11,
    "L": 37.2383093927725,
    "a": 36.463519170963,
    "b": 23.5044885576339,
    "C": 43.3825911246335,
    "h": 0.57257173218968,
    "CMY_C": 0.4229684,
    "CMY_M": 0.7655818,
    "CMY_Y": 0.7991574,
    "CMYK_C": 0,
    "CMYK_M": 0.5937515,
    "CMYK_Y": 0.6519382,
    "CMYK_K": 0.4229684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01475",
    "Farbtonhilfsbezeichnung": "FN.02.57",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "156",
    "Bcolor": "150",
    "Y": 34,
    "L": 64.3816934291455,
    "a": 0.15700299063786,
    "b": 3.04499568809842,
    "C": 3.04904061626066,
    "h": 1.51928095681192,
    "CMY_C": 0.3773165,
    "CMY_M": 0.3886925,
    "CMY_Y": 0.4137146,
    "CMYK_C": 0,
    "CMYK_M": 0.01826933,
    "CMYK_Y": 0.05845362,
    "CMYK_K": 0.3773165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01476",
    "Farbtonhilfsbezeichnung": "T0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "139",
    "Bcolor": "163",
    "Y": 25,
    "L": 56.4736586587951,
    "a": -5.06468237336022,
    "b": -16.6447529072304,
    "C": 17.3982414883166,
    "h": 1.27541663442332,
    "CMY_C": 0.578189,
    "CMY_M": 0.4531964,
    "CMY_Y": 0.3617513,
    "CMYK_C": 0.3391119,
    "CMYK_M": 0.1432751,
    "CMYK_Y": 0,
    "CMYK_K": 0.3617513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01477",
    "Farbtonhilfsbezeichnung": "F6.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "112",
    "Y": 68,
    "L": 85.672607421875,
    "a": 7.02081632614136,
    "b": 52.5492477416992,
    "C": 53.0161781311035,
    "h": 82.3900909423828,
    "CMY_C": 0,
    "CMY_M": 0.18786609172821,
    "CMY_Y": 0.56063997745514,
    "CMYK_C": 0,
    "CMYK_M": 0.18786609172821,
    "CMYK_Y": 0.56063997745514,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01478",
    "Farbtonhilfsbezeichnung": "C0.48.20",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "61",
    "Bcolor": "61",
    "Y": 7,
    "L": 34.807731628418,
    "a": 29.9111652374268,
    "b": 13.4244976043701,
    "C": 32.7855911254883,
    "h": 24.1711273193359,
    "CMY_C": 0.49086254835129,
    "CMY_M": 0.76107120513916,
    "CMY_Y": 0.75929617881775,
    "CMYK_C": 0,
    "CMYK_M": 0.53071850538254,
    "CMYK_Y": 0.52723217010498,
    "CMYK_K": 0.49086254835129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01479",
    "Farbtonhilfsbezeichnung": "D6.25.65",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "160",
    "Bcolor": "127",
    "Y": 43,
    "L": 70.9163516468677,
    "a": 19.1347780110874,
    "b": 25.8170577256492,
    "C": 32.1350307163864,
    "h": 0.93297167768057,
    "CMY_C": 0.1315095,
    "CMY_M": 0.3730474,
    "CMY_Y": 0.5037937,
    "CMYK_C": 0,
    "CMYK_M": 0.2781124,
    "CMYK_Y": 0.4286566,
    "CMYK_K": 0.1315095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01480",
    "Farbtonhilfsbezeichnung": "L0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "205",
    "Bcolor": "193",
    "Y": 62,
    "L": 81.2939513595404,
    "a": -6.27674599687605,
    "b": 4.08394214738419,
    "C": 7.48839927971797,
    "h": -0.57682949324164,
    "CMY_C": 0.2436486,
    "CMY_M": 0.1945453,
    "CMY_Y": 0.2446193,
    "CMYK_C": 0.06096346,
    "CMYK_M": 0,
    "CMYK_Y": 0.06216856,
    "CMYK_K": 0.1945453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01481",
    "Farbtonhilfsbezeichnung": "G8.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "142",
    "Bcolor": "106",
    "Y": 26,
    "L": 58.4214553833008,
    "a": -4.32211780548096,
    "b": 18.9643573760986,
    "C": 19.4506435394287,
    "h": 102.838836669922,
    "CMY_C": 0.42911279201508,
    "CMY_M": 0.44387590885162,
    "CMY_Y": 0.58328002691269,
    "CMYK_C": 0,
    "CMYK_M": 0.02585995383561,
    "CMYK_Y": 0.27004849910736,
    "CMYK_K": 0.42911279201508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01482",
    "Farbtonhilfsbezeichnung": "F2.30.70",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "183",
    "Bcolor": "122",
    "Y": 53,
    "L": 76.5637512207031,
    "a": 7.04104423522949,
    "b": 35.4398422241211,
    "C": 36.1325149536133,
    "h": 78.7630310058594,
    "CMY_C": 0.12639248371124,
    "CMY_M": 0.28350138664246,
    "CMY_Y": 0.52006196975708,
    "CMYK_C": 0,
    "CMYK_M": 0.17983922362328,
    "CMYK_Y": 0.45062512159348,
    "CMYK_K": 0.12639248371124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01483",
    "Farbtonhilfsbezeichnung": "P0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "214",
    "Bcolor": "210",
    "Y": 67,
    "L": 83.8085191751461,
    "a": -8.75787412096735,
    "b": -1.61923301222249,
    "C": 8.90630533198703,
    "h": 0.1828242633435,
    "CMY_C": 0.2579046,
    "CMY_M": 0.1600002,
    "CMY_Y": 0.176324,
    "CMYK_C": 0.1165529,
    "CMYK_M": 0,
    "CMYK_Y": 0.01943315,
    "CMYK_K": 0.1600002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01484",
    "Farbtonhilfsbezeichnung": "G0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "113",
    "Bcolor": "99",
    "Y": 17,
    "L": 47.7907354949507,
    "a": 0.3363361867707,
    "b": 8.0485337029923,
    "C": 8.05555813080226,
    "h": 1.52903212164918,
    "CMY_C": 0.5311294,
    "CMY_M": 0.5576575,
    "CMY_Y": 0.6113432,
    "CMYK_C": 0,
    "CMYK_M": 0.05657871,
    "CMYK_Y": 0.1710788,
    "CMYK_K": 0.5311294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01485",
    "Farbtonhilfsbezeichnung": "J0.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "72",
    "Bcolor": "63",
    "Y": 8,
    "L": 30.2869054622749,
    "a": -2.24242153210369,
    "b": 4.94044095500065,
    "C": 5.42553326019572,
    "h": -1.14471138352646,
    "CMY_C": 0.7216623,
    "CMY_M": 0.7170277,
    "CMY_Y": 0.7527792,
    "CMYK_C": 0.01637837,
    "CMYK_M": 0,
    "CMYK_Y": 0.1263425,
    "CMYK_K": 0.7170277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01486",
    "Farbtonhilfsbezeichnung": "D6.15.25",
    "Farbtonklasse": "02",
    "Rcolor": "95",
    "Gcolor": "75",
    "Bcolor": "64",
    "Y": 9,
    "L": 33.5996795441903,
    "a": 6.96975941076136,
    "b": 9.14463753464807,
    "C": 11.4979103268373,
    "h": 0.91955242867592,
    "CMY_C": 0.6273697,
    "CMY_M": 0.7065426,
    "CMY_Y": 0.747822,
    "CMYK_C": 0,
    "CMYK_M": 0.2124702,
    "CMYK_Y": 0.3232489,
    "CMYK_K": 0.6273697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01487",
    "Farbtonhilfsbezeichnung": "ON.00.26",
    "Farbtonklasse": "02",
    "Rcolor": "79",
    "Gcolor": "79",
    "Bcolor": "79",
    "Y": 9,
    "L": 33.730650708385,
    "a": -0.00450233296581,
    "b": -0.48904425311219,
    "C": 0.48906497779354,
    "h": 1.56159019515907,
    "CMY_C": 0.6904252,
    "CMY_M": 0.6886433,
    "CMY_Y": 0.6886325,
    "CMYK_C": 0.005757368,
    "CMYK_M": 3.442097e-05,
    "CMYK_Y": 0,
    "CMYK_K": 0.6886325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01488",
    "Farbtonhilfsbezeichnung": "L0.15.20",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "76",
    "Bcolor": "66",
    "Y": 8,
    "L": 30.7607507635468,
    "a": -7.21099239749384,
    "b": 3.70009676738929,
    "C": 8.10488293837479,
    "h": -0.47408759420331,
    "CMY_C": 0.7540061,
    "CMY_M": 0.7036192,
    "CMY_Y": 0.74169,
    "CMYK_C": 0.1700072,
    "CMYK_M": 0,
    "CMYK_Y": 0.1284522,
    "CMYK_K": 0.7036192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01489",
    "Farbtonhilfsbezeichnung": "T0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "73",
    "Bcolor": "89",
    "Y": 7,
    "L": 30.0566624058647,
    "a": -3.15635934537806,
    "b": -12.6038465636092,
    "C": 12.9930578585704,
    "h": 1.32541463747405,
    "CMY_C": 0.794126,
    "CMY_M": 0.7130497,
    "CMY_Y": 0.6494263,
    "CMYK_C": 0.4127511,
    "CMYK_M": 0.1814834,
    "CMYK_Y": 0,
    "CMYK_K": 0.6494263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01490",
    "Farbtonhilfsbezeichnung": "J0.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "234",
    "Bcolor": "190",
    "Y": 81,
    "L": 90.8032415001165,
    "a": -10.4564192489039,
    "b": 19.3098994108338,
    "C": 21.9592558791359,
    "h": -1.07449808785979,
    "CMY_C": 0.12491,
    "CMY_M": 0.08386633,
    "CMY_Y": 0.2553689,
    "CMYK_C": 0.04480096,
    "CMYK_M": 0,
    "CMYK_Y": 0.1872026,
    "CMYK_K": 0.08386633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01491",
    "Farbtonhilfsbezeichnung": "ON.00.31",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "96",
    "Bcolor": "95",
    "Y": 11,
    "L": 40.9386291503906,
    "a": 0.26381200551987,
    "b": 0.45250248908997,
    "C": 0.52378934621811,
    "h": 59.7575225830078,
    "CMY_C": 0.61840319633484,
    "CMY_M": 0.6218878030777,
    "CMY_Y": 0.62746268510818,
    "CMYK_C": 0,
    "CMYK_M": 0.00913164578378,
    "CMYK_Y": 0.02374099753797,
    "CMYK_K": 0.61840319633484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01492",
    "Farbtonhilfsbezeichnung": "N0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "132",
    "Bcolor": "116",
    "Y": 18,
    "L": 49.8915481567383,
    "a": -30.4107933044434,
    "b": 0.44135934114456,
    "C": 30.4139957427979,
    "h": 179.168518066406,
    "CMY_C": 0.83890461921692,
    "CMY_M": 0.48105472326279,
    "CMY_Y": 0.54471105337143,
    "CMYK_C": 0.68957155942917,
    "CMYK_M": 0,
    "CMYK_Y": 0.12266482412815,
    "CMYK_K": 0.48105472326279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01493",
    "Farbtonhilfsbezeichnung": "S0.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "156",
    "Bcolor": "170",
    "Y": 32,
    "L": 62.659076498993,
    "a": -6.89401303686316,
    "b": -11.4535097011003,
    "C": 13.368257187294,
    "h": 1.02897161050885,
    "CMY_C": 0.5058492,
    "CMY_M": 0.3875602,
    "CMY_Y": 0.3326473,
    "CMYK_C": 0.2595357,
    "CMYK_M": 0.0822847,
    "CMYK_Y": 0,
    "CMYK_K": 0.3326473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01494",
    "Farbtonhilfsbezeichnung": "T6.30.10",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "55",
    "Bcolor": "77",
    "Y": 5,
    "L": 22.083369308267,
    "a": -1.68666170107309,
    "b": -16.9863396771714,
    "C": 17.0698729732273,
    "h": 1.47182556183621,
    "CMY_C": 0.8808606,
    "CMY_M": 0.7849044,
    "CMY_Y": 0.6972074,
    "CMYK_C": 0.6065313,
    "CMYK_M": 0.289627,
    "CMYK_Y": 0,
    "CMYK_K": 0.6972074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01495",
    "Farbtonhilfsbezeichnung": "G0.35.85",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "223",
    "Bcolor": "135",
    "Y": 78,
    "L": 89.480174522054,
    "a": -1.55027483887182,
    "b": 46.0324894409656,
    "C": 46.0585869975257,
    "h": -1.53713121003577,
    "CMY_C": 0.01638811,
    "CMY_M": 0.1240932,
    "CMY_Y": 0.4716625,
    "CMYK_C": 0,
    "CMYK_M": 0.1094995,
    "CMYK_Y": 0.4628597,
    "CMYK_K": 0.01638811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01496",
    "Farbtonhilfsbezeichnung": "G4.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "187",
    "Bcolor": "116",
    "Y": 51,
    "L": 75.8208262671791,
    "a": -3.76475720145319,
    "b": 37.4120570287178,
    "C": 37.6010027513353,
    "h": -1.47050442979492,
    "CMY_C": 0.2021708,
    "CMY_M": 0.2663648,
    "CMY_Y": 0.544895,
    "CMYK_C": 0,
    "CMYK_M": 0.08046088,
    "CMYK_Y": 0.4295709,
    "CMYK_K": 0.2021708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01497",
    "Farbtonhilfsbezeichnung": "C2.60.25",
    "Farbtonklasse": "04",
    "Rcolor": "144",
    "Gcolor": "46",
    "Bcolor": "45",
    "Y": 9,
    "L": 34.0862701866459,
    "a": 41.5371199853392,
    "b": 23.4325141691551,
    "C": 47.6908278074947,
    "h": 0.5136300804945,
    "CMY_C": 0.435288,
    "CMY_M": 0.8208047,
    "CMY_Y": 0.8240254,
    "CMYK_C": 0,
    "CMYK_M": 0.6826785,
    "CMYK_Y": 0.6883817,
    "CMYK_K": 0.435288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01498",
    "Farbtonhilfsbezeichnung": "SN.02.27",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "86",
    "Bcolor": "86",
    "Y": 10,
    "L": 36.165600376403,
    "a": -0.73091433331562,
    "b": -1.32608032511573,
    "C": 1.51417462378197,
    "h": 1.06704450564375,
    "CMY_C": 0.6753135,
    "CMY_M": 0.6644561,
    "CMY_Y": 0.6611261,
    "CMYK_C": 0.0418665,
    "CMYK_M": 0.009826623,
    "CMYK_Y": 0,
    "CMYK_K": 0.6611261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01499",
    "Farbtonhilfsbezeichnung": "C8.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "143",
    "Bcolor": "130",
    "Y": 32,
    "L": 62.8166041131306,
    "a": 13.0914596157024,
    "b": 12.2305187931631,
    "C": 17.9156887899819,
    "h": 0.75141150981467,
    "CMY_C": 0.2841756,
    "CMY_M": 0.4378746,
    "CMY_Y": 0.4907941,
    "CMYK_C": 0,
    "CMYK_M": 0.2147161,
    "CMYK_Y": 0.2886441,
    "CMYK_K": 0.2841756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01500",
    "Farbtonhilfsbezeichnung": "E0.25.45",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "118",
    "Bcolor": "89",
    "Y": 23,
    "L": 53.0121659619417,
    "a": 12.965115567885,
    "b": 21.802075049943,
    "C": 25.365817514363,
    "h": 1.03430259977914,
    "CMY_C": 0.3736087,
    "CMY_M": 0.5383782,
    "CMY_Y": 0.6511205,
    "CMYK_C": 0,
    "CMYK_M": 0.2630456,
    "CMYK_Y": 0.4430327,
    "CMYK_K": 0.3736087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01501",
    "Farbtonhilfsbezeichnung": "U0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "114",
    "Bcolor": "129",
    "Y": 17,
    "L": 47.8247263918912,
    "a": 0.35542010989642,
    "b": -9.73285901468843,
    "C": 9.73934638742871,
    "h": -1.53429500198038,
    "CMY_C": 0.586143,
    "CMY_M": 0.5527832,
    "CMY_Y": 0.495248,
    "CMYK_C": 0.1800786,
    "CMYK_M": 0.1139871,
    "CMYK_Y": 0,
    "CMYK_K": 0.495248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01502",
    "Farbtonhilfsbezeichnung": "D6.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "199",
    "Bcolor": "189",
    "Y": 61,
    "L": 81.5441351943259,
    "a": 4.61825698775925,
    "b": 6.74073460337503,
    "C": 8.1710342428682,
    "h": 0.97012237144148,
    "CMY_C": 0.1498616,
    "CMY_M": 0.2176695,
    "CMY_Y": 0.2596159,
    "CMYK_C": 0,
    "CMYK_M": 0.07976104,
    "CMYK_Y": 0.1291016,
    "CMYK_K": 0.1498616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01503",
    "Farbtonhilfsbezeichnung": "E4.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "177",
    "Bcolor": "123",
    "Y": 52,
    "L": 76.6126450221912,
    "a": 15.5755606274856,
    "b": 35.2673375667585,
    "C": 38.5536403976093,
    "h": 1.15491406621717,
    "CMY_C": 0.07258599,
    "CMY_M": 0.3050211,
    "CMY_Y": 0.5162263,
    "CMYK_C": 0,
    "CMYK_M": 0.2506271,
    "CMYK_Y": 0.4783627,
    "CMYK_K": 0.07258599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01504",
    "Farbtonhilfsbezeichnung": "F2.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "131",
    "Gcolor": "126",
    "Bcolor": "118",
    "Y": 22,
    "L": 53.0383031660396,
    "a": 0.69787982424723,
    "b": 4.46163810789844,
    "C": 4.51588871153208,
    "h": 1.41563574282087,
    "CMY_C": 0.4855768,
    "CMY_M": 0.5057338,
    "CMY_Y": 0.5369527,
    "CMYK_C": 0,
    "CMYK_M": 0.03918373,
    "CMYK_Y": 0.09987094,
    "CMYK_K": 0.4855768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01505",
    "Farbtonhilfsbezeichnung": "E8.50.60",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "149",
    "Bcolor": "62",
    "Y": 36,
    "L": 66.3703947368251,
    "a": 16.079113928025,
    "b": 53.2384513931593,
    "C": 55.6135829762136,
    "h": 1.27748671906318,
    "CMY_C": 0.1681593,
    "CMY_M": 0.4163392,
    "CMY_Y": 0.757928,
    "CMYK_C": 0,
    "CMYK_M": 0.2983502,
    "CMYK_Y": 0.7089923,
    "CMYK_K": 0.1681593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01506",
    "Farbtonhilfsbezeichnung": "F6.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "138",
    "Bcolor": "104",
    "Y": 26,
    "L": 58.3791365666019,
    "a": 1.66783356141031,
    "b": 20.2157181622601,
    "C": 20.2844011399031,
    "h": 1.48848092930401,
    "CMY_C": 0.3876789,
    "CMY_M": 0.4574873,
    "CMY_Y": 0.5912583,
    "CMYK_C": 0,
    "CMYK_M": 0.1140062,
    "CMYK_Y": 0.3324716,
    "CMYK_K": 0.3876789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01507",
    "Farbtonhilfsbezeichnung": "C8.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "93",
    "Bcolor": "72",
    "Y": 18,
    "L": 48.4829135946259,
    "a": 30.2064879882497,
    "b": 26.0244047910878,
    "C": 39.8710617028775,
    "h": 0.71116143068785,
    "CMY_C": 0.3245165,
    "CMY_M": 0.6335196,
    "CMY_Y": 0.7175267,
    "CMYK_C": 0,
    "CMYK_M": 0.4574547,
    "CMYK_Y": 0.5818206,
    "CMYK_K": 0.3245165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01508",
    "Farbtonhilfsbezeichnung": "E4.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "231",
    "Bcolor": "219",
    "Y": 81,
    "L": 92.2902069091797,
    "a": 2.58376836776733,
    "b": 6.62206697463989,
    "C": 7.10827875137329,
    "h": 68.6854858398438,
    "CMY_C": 0.04522669315338,
    "CMY_M": 0.09429079294205,
    "CMY_Y": 0.14260387420654,
    "CMYK_C": 0,
    "CMYK_M": 0.05138821899891,
    "CMYK_Y": 0.1019898429513,
    "CMYK_K": 0.04522669315338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01509",
    "Farbtonhilfsbezeichnung": "A0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "202",
    "Bcolor": "206",
    "Y": 66,
    "L": 83.9992143356709,
    "a": 11.3287576322675,
    "b": 1.16651498817879,
    "C": 11.3886569317152,
    "h": 0.10260774603558,
    "CMY_C": 0.09017627,
    "CMY_M": 0.2061467,
    "CMY_Y": 0.1917828,
    "CMYK_C": 0,
    "CMYK_M": 0.1274647,
    "CMYK_Y": 0.1116771,
    "CMYK_K": 0.09017627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01510",
    "Farbtonhilfsbezeichnung": "L0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "214",
    "Bcolor": "195",
    "Y": 66,
    "L": 83.7482245404381,
    "a": -10.1444781599064,
    "b": 6.51589120130469,
    "C": 12.0568352101228,
    "h": -0.57094963771037,
    "CMY_C": 0.2400649,
    "CMY_M": 0.1598355,
    "CMY_Y": 0.2364962,
    "CMYK_C": 0.09549249,
    "CMYK_M": 0,
    "CMYK_Y": 0.09124486,
    "CMYK_K": 0.1598355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01511",
    "Farbtonhilfsbezeichnung": "V0.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "146",
    "Bcolor": "198",
    "Y": 31,
    "L": 61.1776276453085,
    "a": 7.30090192893185,
    "b": -29.1890577831467,
    "C": 30.0882745142316,
    "h": -1.32570037954132,
    "CMY_C": 0.4858634,
    "CMY_M": 0.4274388,
    "CMY_Y": 0.2251211,
    "CMYK_C": 0.3364943,
    "CMYK_M": 0.2610958,
    "CMYK_Y": 0,
    "CMYK_K": 0.2251211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01512",
    "Farbtonhilfsbezeichnung": "T0.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "197",
    "Bcolor": "229",
    "Y": 51,
    "L": 77.7561264038086,
    "a": -5.41068267822266,
    "b": -21.0118999481201,
    "C": 21.697359085083,
    "h": 255.55973815918,
    "CMY_C": 0.38302141427994,
    "CMY_M": 0.22733700275421,
    "CMY_Y": 0.10217815637589,
    "CMYK_C": 0.31280511617661,
    "CMYK_M": 0.1394027620554,
    "CMYK_Y": 0,
    "CMYK_K": 0.10217815637589
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01513",
    "Farbtonhilfsbezeichnung": "F6.15.55",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "153",
    "Bcolor": "125",
    "Y": 33,
    "L": 63.8903750749642,
    "a": 1.64521267623752,
    "b": 16.2243956110617,
    "C": 16.3075975451411,
    "h": 1.46973813156318,
    "CMY_C": 0.3378558,
    "CMY_M": 0.4001986,
    "CMY_Y": 0.5096033,
    "CMYK_C": 0,
    "CMYK_M": 0.09415285,
    "CMYK_Y": 0.2593808,
    "CMYK_K": 0.3378558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01514",
    "Farbtonhilfsbezeichnung": "B2.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "50",
    "Bcolor": "56",
    "Y": 7,
    "L": 28.6223583129102,
    "a": 25.9638244907572,
    "b": 7.65934264620192,
    "C": 27.0700149973873,
    "h": 0.28686386049811,
    "CMY_C": 0.581817,
    "CMY_M": 0.8030636,
    "CMY_Y": 0.7793193,
    "CMYK_C": 0,
    "CMYK_M": 0.5290665,
    "CMYK_Y": 0.4722867,
    "CMYK_K": 0.581817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01515",
    "Farbtonhilfsbezeichnung": "L0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "165",
    "Bcolor": "148",
    "Y": 36,
    "L": 65.7823715209961,
    "a": -9.33963489532471,
    "b": 5.56274032592773,
    "C": 10.8707342147827,
    "h": 149.221725463867,
    "CMY_C": 0.42648184299469,
    "CMY_M": 0.35456866025925,
    "CMY_Y": 0.41808974742889,
    "CMYK_C": 0.11141879856586,
    "CMYK_M": 0,
    "CMYK_Y": 0.09841649234295,
    "CMYK_K": 0.35456866025925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01516",
    "Farbtonhilfsbezeichnung": "B6.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "79",
    "Bcolor": "83",
    "Y": 17,
    "L": 46.8495871531247,
    "a": 41.9144512536083,
    "b": 17.3155638524144,
    "C": 45.3503029253184,
    "h": 0.39176257107452,
    "CMY_C": 0.293412,
    "CMY_M": 0.6914494,
    "CMY_Y": 0.6727108,
    "CMYK_C": 0,
    "CMYK_M": 0.5633232,
    "CMYK_Y": 0.5368034,
    "CMYK_K": 0.293412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01517",
    "Farbtonhilfsbezeichnung": "B6.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "75",
    "Bcolor": "84",
    "Y": 16,
    "L": 48.6820983886719,
    "a": 49.1010093688965,
    "b": 19.6042366027832,
    "C": 52.8699836730957,
    "h": 21.7650184631348,
    "CMY_C": 0.23378247022629,
    "CMY_M": 0.70572644472122,
    "CMY_Y": 0.66883981227875,
    "CMYK_C": 0,
    "CMYK_M": 0.61593991518021,
    "CMYK_Y": 0.56779873371124,
    "CMYK_K": 0.23378247022629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01518",
    "Farbtonhilfsbezeichnung": "C4.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "79",
    "Bcolor": "70",
    "Y": 11,
    "L": 37.3347033693784,
    "a": 14.7276208696159,
    "b": 10.8239468104884,
    "C": 18.2773258721134,
    "h": 0.63379411659829,
    "CMY_C": 0.5450917,
    "CMY_M": 0.6911275,
    "CMY_Y": 0.7236479,
    "CMYK_C": 0,
    "CMYK_M": 0.3210226,
    "CMYK_Y": 0.3925103,
    "CMYK_K": 0.5450917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01519",
    "Farbtonhilfsbezeichnung": "E4.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "176",
    "Bcolor": "104",
    "Y": 53,
    "L": 77.8693466186523,
    "a": 20.9863319396973,
    "b": 47.1962509155273,
    "C": 51.6518363952637,
    "h": 66.0271530151367,
    "CMY_C": 0.00908333063126,
    "CMY_M": 0.30858606100082,
    "CMY_Y": 0.59259963035583,
    "CMYK_C": 0,
    "CMYK_M": 0.30224815011024,
    "CMYK_Y": 0.58886516094208,
    "CMYK_K": 0.00908333063126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01520",
    "Farbtonhilfsbezeichnung": "C8.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "105",
    "Bcolor": "76",
    "Y": 27,
    "L": 57.4622511836842,
    "a": 42.3822141698685,
    "b": 36.3650238452807,
    "C": 55.845026969359,
    "h": 0.70913491332194,
    "CMY_C": 0.1468548,
    "CMY_M": 0.5894846,
    "CMY_Y": 0.7022938,
    "CMYK_C": 0,
    "CMYK_M": 0.5188212,
    "CMYK_Y": 0.6510486,
    "CMYK_K": 0.1468548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01521",
    "Farbtonhilfsbezeichnung": "A0.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "106",
    "Bcolor": "136",
    "Y": 25,
    "L": 56.6990862895169,
    "a": 41.4420478989791,
    "b": 0.11794786689289,
    "C": 41.4422157438594,
    "h": 0.00284608397522,
    "CMY_C": 0.2093658,
    "CMY_M": 0.5839621,
    "CMY_Y": 0.4658145,
    "CMYK_C": 0,
    "CMYK_M": 0.4737922,
    "CMYK_Y": 0.3243581,
    "CMYK_K": 0.2093658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01522",
    "Farbtonhilfsbezeichnung": "E0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "134",
    "Bcolor": "120",
    "Y": 26,
    "L": 57.2585673432725,
    "a": 5.37505851218079,
    "b": 9.66004497959314,
    "C": 11.0547601971789,
    "h": 1.06303621154914,
    "CMY_C": 0.3981201,
    "CMY_M": 0.4750273,
    "CMY_Y": 0.5296304,
    "CMYK_C": 0,
    "CMYK_M": 0.1277784,
    "CMYK_Y": 0.2184992,
    "CMYK_K": 0.3981201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01523",
    "Farbtonhilfsbezeichnung": "J0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "191",
    "Bcolor": "166",
    "Y": 52,
    "L": 76.3068568435731,
    "a": -6.24442297626243,
    "b": 11.0076914146363,
    "C": 12.6555161327514,
    "h": -1.05478457475743,
    "CMY_C": 0.2750232,
    "CMY_M": 0.2504523,
    "CMY_Y": 0.3473333,
    "CMYK_C": 0.03278094,
    "CMYK_M": 0,
    "CMYK_Y": 0.1292526,
    "CMYK_K": 0.2504523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01524",
    "Farbtonhilfsbezeichnung": "D2.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "211",
    "Bcolor": "195",
    "Y": 69,
    "L": 87.1009063720703,
    "a": 10.2345247268677,
    "b": 11.9211568832398,
    "C": 15.7117624282837,
    "h": 49.3533248901367,
    "CMY_C": 0.0335328578949,
    "CMY_M": 0.17229914665222,
    "CMY_Y": 0.23693555593491,
    "CMYK_C": 0,
    "CMYK_M": 0.14358097314835,
    "CMYK_Y": 0.21046002209187,
    "CMYK_K": 0.0335328578949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01525",
    "Farbtonhilfsbezeichnung": "E0.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "179",
    "Bcolor": "132",
    "Y": 54,
    "L": 78.3809127807617,
    "a": 19.7191505432129,
    "b": 33.2810440063477,
    "C": 38.684268951416,
    "h": 59.3530883789063,
    "CMY_C": 0.02943140268326,
    "CMY_M": 0.29709964990616,
    "CMY_Y": 0.48269122838974,
    "CMYK_C": 0,
    "CMYK_M": 0.27578499913216,
    "CMYK_Y": 0.46700441837311,
    "CMYK_K": 0.02943140268326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01526",
    "Farbtonhilfsbezeichnung": "C8.20.50",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "128",
    "Bcolor": "112",
    "Y": 26,
    "L": 57.7836344890387,
    "a": 16.4442559267356,
    "b": 15.5343385952626,
    "C": 22.6214329470138,
    "h": 0.75695188864205,
    "CMY_C": 0.3120537,
    "CMY_M": 0.4984962,
    "CMY_Y": 0.5623666,
    "CMYK_C": 0,
    "CMYK_M": 0.2710131,
    "CMYK_Y": 0.3638553,
    "CMYK_K": 0.3120537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01527",
    "Farbtonhilfsbezeichnung": "G0.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "200",
    "Bcolor": "162",
    "Y": 60,
    "L": 81.0153204723277,
    "a": 0.73980223127245,
    "b": 20.3749457147085,
    "C": 20.3883721816803,
    "h": 1.53450286193104,
    "CMY_C": 0.148045,
    "CMY_M": 0.2174536,
    "CMY_Y": 0.3648799,
    "CMYK_C": 0,
    "CMYK_M": 0.08146968,
    "CMYK_Y": 0.2545145,
    "CMYK_K": 0.148045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01528",
    "Farbtonhilfsbezeichnung": "D6.35.70",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "162",
    "Bcolor": "117",
    "Y": 49,
    "L": 73.9964398996817,
    "a": 26.4076952959894,
    "b": 35.7124539733218,
    "C": 44.4156024347576,
    "h": 0.93407928580596,
    "CMY_C": 0.03771194,
    "CMY_M": 0.3636136,
    "CMY_Y": 0.5429222,
    "CMYK_C": 0,
    "CMYK_M": 0.3386737,
    "CMYK_Y": 0.5250094,
    "CMYK_K": 0.03771194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01529",
    "Farbtonhilfsbezeichnung": "C8.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "184",
    "Bcolor": "173",
    "Y": 52,
    "L": 77.4984588623047,
    "a": 11.4430093765259,
    "b": 9.4040470123291,
    "C": 14.8114337921143,
    "h": 39.4139099121094,
    "CMY_C": 0.13978439569473,
    "CMY_M": 0.27895474433899,
    "CMY_Y": 0.32062220573425,
    "CMYK_C": 0,
    "CMYK_M": 0.16178542375565,
    "CMYK_Y": 0.21022382378578,
    "CMYK_K": 0.13978439569473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01530",
    "Farbtonhilfsbezeichnung": "C0.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "127",
    "Bcolor": "121",
    "Y": 29,
    "L": 60.8167340156857,
    "a": 27.8499327710551,
    "b": 14.869447394152,
    "C": 31.5708603170668,
    "h": 0.49040868951874,
    "CMY_C": 0.2131754,
    "CMY_M": 0.5002386,
    "CMY_Y": 0.5260442,
    "CMYK_C": 0,
    "CMYK_M": 0.3648376,
    "CMYK_Y": 0.3976348,
    "CMYK_K": 0.2131754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01531",
    "Farbtonhilfsbezeichnung": "U0.25.60",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "165",
    "Bcolor": "211",
    "Y": 38,
    "L": 66.4969787597656,
    "a": -1.18767619132996,
    "b": -28.4342136383057,
    "C": 28.4590072631836,
    "h": 267.608184814453,
    "CMY_C": 0.50579017400742,
    "CMY_M": 0.35371381044388,
    "CMY_Y": 0.17320555448532,
    "CMYK_C": 0.40225791931152,
    "CMYK_M": 0.21832302212715,
    "CMYK_Y": 0,
    "CMYK_K": 0.17320555448532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01532",
    "Farbtonhilfsbezeichnung": "C8.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "219",
    "Bcolor": "211",
    "Y": 76,
    "L": 88.394062091517,
    "a": 4.73732353827627,
    "b": 4.79646877970565,
    "C": 6.74153892379162,
    "h": 0.79160183143531,
    "CMY_C": 0.07839373,
    "CMY_M": 0.1423704,
    "CMY_Y": 0.171437,
    "CMYK_C": 0,
    "CMYK_M": 0.06941861,
    "CMYK_Y": 0.1009578,
    "CMYK_K": 0.07839373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01533",
    "Farbtonhilfsbezeichnung": "W0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "69",
    "Bcolor": "98",
    "Y": 8,
    "L": 30.9030996420047,
    "a": 8.71606807261127,
    "b": -16.5387830995918,
    "C": 18.6949508975482,
    "h": -1.08577663471719,
    "CMY_C": 0.7127268,
    "CMY_M": 0.7278119,
    "CMY_Y": 0.6166393,
    "CMYK_C": 0.250645,
    "CMYK_M": 0.2899949,
    "CMYK_Y": 0,
    "CMYK_K": 0.6166393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01534",
    "Farbtonhilfsbezeichnung": "Q0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "119",
    "Bcolor": "121",
    "Y": 18,
    "L": 48.3091826234857,
    "a": -6.89330580396375,
    "b": -4.40651243184569,
    "C": 8.18138232323676,
    "h": 0.56877751433642,
    "CMY_C": 0.6173611,
    "CMY_M": 0.5350704,
    "CMY_Y": 0.5259421,
    "CMYK_C": 0.1928435,
    "CMYK_M": 0.01925549,
    "CMYK_Y": 0,
    "CMYK_K": 0.5259421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01535",
    "Farbtonhilfsbezeichnung": "S0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "121",
    "Bcolor": "154",
    "Y": 18,
    "L": 47.2543384804131,
    "a": -14.1742452600611,
    "b": -25.8660547373027,
    "C": 29.4951185175701,
    "h": 1.06950040879865,
    "CMY_C": 0.8943191,
    "CMY_M": 0.525816,
    "CMY_Y": 0.3966593,
    "CMYK_C": 0.8248404,
    "CMYK_M": 0.2140693,
    "CMYK_Y": 0,
    "CMYK_K": 0.3966593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01536",
    "Farbtonhilfsbezeichnung": "Q0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "143",
    "Bcolor": "146",
    "Y": 27,
    "L": 57.8138844492958,
    "a": -7.00698220225865,
    "b": -5.15203605722603,
    "C": 8.69719926859944,
    "h": 0.63400820044067,
    "CMY_C": 0.5279015,
    "CMY_M": 0.4390726,
    "CMY_Y": 0.4257202,
    "CMYK_C": 0.1779294,
    "CMYK_M": 0.02325065,
    "CMYK_Y": 0,
    "CMYK_K": 0.4257202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01537",
    "Farbtonhilfsbezeichnung": "Z0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "85",
    "Bcolor": "106",
    "Y": 11,
    "L": 40.7675285339355,
    "a": 19.9122486114502,
    "b": -6.25252246856689,
    "C": 20.8708324432373,
    "h": 342.567504882813,
    "CMY_C": 0.51582622528076,
    "CMY_M": 0.66819787025452,
    "CMY_Y": 0.58451038599014,
    "CMYK_C": 0,
    "CMYK_M": 0.3147044479847,
    "CMYK_Y": 0.1418584883213,
    "CMYK_K": 0.51582622528076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01538",
    "Farbtonhilfsbezeichnung": "P0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "229",
    "Bcolor": "224",
    "Y": 72,
    "L": 88.0275192260742,
    "a": -13.8047409057617,
    "b": -2.9971911907196,
    "C": 14.1263589859009,
    "h": 192.249557495117,
    "CMY_C": 0.26247942447662,
    "CMY_M": 0.10201966762543,
    "CMY_Y": 0.12060034275055,
    "CMYK_C": 0.17868961393833,
    "CMYK_M": 0,
    "CMYK_Y": 0.02069162763655,
    "CMYK_K": 0.10201966762543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01539",
    "Farbtonhilfsbezeichnung": "C8.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "57",
    "Bcolor": "45",
    "Y": 8,
    "L": 30.4844584498643,
    "a": 22.2420206546284,
    "b": 17.6259068406642,
    "C": 28.3792190653071,
    "h": 0.67012630765524,
    "CMY_C": 0.5687009,
    "CMY_M": 0.7762656,
    "CMY_Y": 0.8237593,
    "CMYK_C": 0,
    "CMYK_M": 0.4812547,
    "CMYK_Y": 0.5913723,
    "CMYK_K": 0.5687009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01540",
    "Farbtonhilfsbezeichnung": "S0.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "119",
    "Gcolor": "129",
    "Bcolor": "134",
    "Y": 22,
    "L": 53.255672454834,
    "a": -2.07698750495911,
    "b": -4.63431406021118,
    "C": 5.07845878601074,
    "h": 245.859237670898,
    "CMY_C": 0.53209471702576,
    "CMY_M": 0.49534726142883,
    "CMY_Y": 0.47473961114883,
    "CMYK_C": 0.10919366031885,
    "CMYK_M": 0.03923320770264,
    "CMYK_Y": 0,
    "CMYK_K": 0.47473961114883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01541",
    "Farbtonhilfsbezeichnung": "C8.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "73",
    "Bcolor": "57",
    "Y": 11,
    "L": 38.5099850298905,
    "a": 25.1355801329272,
    "b": 21.0508596871234,
    "C": 32.7862178694915,
    "h": 0.69718784718679,
    "CMY_C": 0.465858,
    "CMY_M": 0.7119173,
    "CMY_Y": 0.7754841,
    "CMYK_C": 0,
    "CMYK_M": 0.4606627,
    "CMYK_Y": 0.5796699,
    "CMYK_K": 0.465858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01542",
    "Farbtonhilfsbezeichnung": "N0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "93",
    "Bcolor": "90",
    "Y": 11,
    "L": 38.1841605161895,
    "a": -6.95635212117435,
    "b": -0.45485847836639,
    "C": 6.97120728920814,
    "h": 0.06529455027557,
    "CMY_C": 0.6985053,
    "CMY_M": 0.6340039,
    "CMY_Y": 0.6484368,
    "CMYK_C": 0.176235,
    "CMYK_M": 0,
    "CMYK_Y": 0.03943452,
    "CMYK_K": 0.6340039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01543",
    "Farbtonhilfsbezeichnung": "C8.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "151",
    "Bcolor": "132",
    "Y": 39,
    "L": 68.3896921516494,
    "a": 22.6383443318697,
    "b": 19.5600990232048,
    "C": 29.9180899772341,
    "h": 0.71258024893927,
    "CMY_C": 0.1498109,
    "CMY_M": 0.4079345,
    "CMY_Y": 0.484136,
    "CMYK_C": 0,
    "CMYK_M": 0.3036072,
    "CMYK_Y": 0.3932362,
    "CMYK_K": 0.1498109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01544",
    "Farbtonhilfsbezeichnung": "CN.02.57",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "158",
    "Bcolor": "156",
    "Y": 34,
    "L": 65.4133529663086,
    "a": 2.24346256256104,
    "b": 1.17577493190765,
    "C": 2.53289771080017,
    "h": 27.6585578918457,
    "CMY_C": 0.35712629556656,
    "CMY_M": 0.38214331865311,
    "CMY_Y": 0.38993579149246,
    "CMYK_C": 0,
    "CMYK_M": 0.03891436755657,
    "CMYK_Y": 0.0510356798768,
    "CMYK_K": 0.35712629556656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01545",
    "Farbtonhilfsbezeichnung": "D8.65.50",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "110",
    "Bcolor": "40",
    "Y": 30,
    "L": 59.6797322114303,
    "a": 42.5610116968465,
    "b": 56.7103346893667,
    "C": 70.9048783740519,
    "h": 0.92697636061466,
    "CMY_C": 0.1043216,
    "CMY_M": 0.5704636,
    "CMY_Y": 0.8421453,
    "CMYK_C": 0,
    "CMYK_M": 0.5204346,
    "CMYK_Y": 0.8237596,
    "CMYK_K": 0.1043216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01546",
    "Farbtonhilfsbezeichnung": "C0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "132",
    "Bcolor": "129",
    "Y": 27,
    "L": 57.7806218859105,
    "a": 10.3143056411447,
    "b": 5.22590761658388,
    "C": 11.5626558919661,
    "h": 0.46896614909766,
    "CMY_C": 0.3713,
    "CMY_M": 0.4804238,
    "CMY_Y": 0.4938349,
    "CMYK_C": 0,
    "CMYK_M": 0.1735706,
    "CMYK_Y": 0.194902,
    "CMYK_K": 0.3713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01547",
    "Farbtonhilfsbezeichnung": "M2.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "151",
    "Bcolor": "122",
    "Y": 27,
    "L": 57.308207269839,
    "a": -29.0978306439408,
    "b": 7.84577527297958,
    "C": 30.1370193917308,
    "h": -0.26337101771033,
    "CMY_C": 0.6848679,
    "CMY_M": 0.4080806,
    "CMY_Y": 0.5214902,
    "CMYK_C": 0.4676098,
    "CMYK_M": 0,
    "CMYK_Y": 0.1915964,
    "CMYK_K": 0.4080806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01548",
    "Farbtonhilfsbezeichnung": "T0.45.35",
    "Farbtonklasse": "04",
    "Rcolor": "1",
    "Gcolor": "109",
    "Bcolor": "155",
    "Y": 14,
    "L": 43.3496511677242,
    "a": -8.92067750191397,
    "b": -32.4224020822895,
    "C": 33.6272306900049,
    "h": 1.30230060038927,
    "CMY_C": 0.9945732,
    "CMY_M": 0.5708177,
    "CMY_Y": 0.3937267,
    "CMYK_C": 0.991049,
    "CMYK_M": 0.2920977,
    "CMYK_Y": 0,
    "CMYK_K": 0.3937267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01549",
    "Farbtonhilfsbezeichnung": "L0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "173",
    "Bcolor": "127",
    "Y": 36,
    "L": 65.5435643742506,
    "a": -29.8869685966906,
    "b": 16.7245384115382,
    "C": 34.2482273552747,
    "h": -0.51017843242924,
    "CMY_C": 0.5679776,
    "CMY_M": 0.3216706,
    "CMY_Y": 0.5015206,
    "CMYK_C": 0.3631082,
    "CMYK_M": 0,
    "CMYK_Y": 0.2651366,
    "CMYK_K": 0.3216706
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01550",
    "Farbtonhilfsbezeichnung": "Q0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "144",
    "Y": 19,
    "L": 48.9607233383986,
    "a": -32.6091645778202,
    "b": -17.7720076317194,
    "C": 37.1376072159375,
    "h": 0.498996642142,
    "CMY_C": 1,
    "CMY_M": 0.482774,
    "CMY_Y": 0.4338805,
    "CMYK_C": 1,
    "CMYK_M": 0.08636601,
    "CMYK_Y": 0,
    "CMYK_K": 0.4338805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01551",
    "Farbtonhilfsbezeichnung": "L0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "119",
    "Bcolor": "106",
    "Y": 18,
    "L": 48.4072772353689,
    "a": -8.03749774024337,
    "b": 4.67546794553764,
    "C": 9.2984606486325,
    "h": -0.52686008950787,
    "CMY_C": 0.5928651,
    "CMY_M": 0.5341332,
    "CMY_Y": 0.5844933,
    "CMYK_C": 0.1260702,
    "CMYK_M": 0,
    "CMYK_Y": 0.1080998,
    "CMYK_K": 0.5341332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01552",
    "Farbtonhilfsbezeichnung": "P0.20.50",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "149",
    "Bcolor": "146",
    "Y": 27,
    "L": 57.8784441022112,
    "a": -18.6237849013127,
    "b": -4.73321337278141,
    "C": 19.2158443187553,
    "h": 0.24887962800169,
    "CMY_C": 0.6326501,
    "CMY_M": 0.4167459,
    "CMY_Y": 0.4291472,
    "CMYK_C": 0.3701718,
    "CMYK_M": 0,
    "CMYK_Y": 0.02126226,
    "CMYK_K": 0.4167459
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01553",
    "Farbtonhilfsbezeichnung": "V0.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "123",
    "Bcolor": "169",
    "Y": 22,
    "L": 52.2453034224055,
    "a": 6.75879532990109,
    "b": -26.9913148171287,
    "C": 27.8246723227578,
    "h": -1.32543529834376,
    "CMY_C": 0.5707394,
    "CMY_M": 0.517095,
    "CMY_Y": 0.3354762,
    "CMYK_C": 0.3540328,
    "CMYK_M": 0.2733068,
    "CMYK_Y": 0,
    "CMYK_K": 0.3354762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01554",
    "Farbtonhilfsbezeichnung": "U0.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "165",
    "Bcolor": "204",
    "Y": 39,
    "L": 67.0876967554399,
    "a": 0.06853348853003,
    "b": -23.528121544108,
    "C": 23.5282213571992,
    "h": -1.56788350204702,
    "CMY_C": 0.4584374,
    "CMY_M": 0.3520881,
    "CMY_Y": 0.2009659,
    "CMYK_C": 0.3222285,
    "CMYK_M": 0.1891311,
    "CMYK_Y": 0,
    "CMYK_K": 0.2009659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01555",
    "Farbtonhilfsbezeichnung": "F6.25.80",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "212",
    "Bcolor": "149",
    "Y": 70,
    "L": 86.5025984842353,
    "a": 3.32057630865884,
    "b": 35.102256535943,
    "C": 35.2589653979917,
    "h": 1.47647976135739,
    "CMY_C": 0.03721188,
    "CMY_M": 0.1667312,
    "CMY_Y": 0.4168271,
    "CMYK_C": 0,
    "CMYK_M": 0.1345252,
    "CMYK_Y": 0.3942873,
    "CMYK_K": 0.03721188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01556",
    "Farbtonhilfsbezeichnung": "C0.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "218",
    "Bcolor": "213",
    "Y": 77,
    "L": 88.8489585828681,
    "a": 7.44044399556681,
    "b": 4.68549359280188,
    "C": 8.79284123928971,
    "h": 0.56199562899444,
    "CMY_C": 0.05357158,
    "CMY_M": 0.1440267,
    "CMY_Y": 0.1652526,
    "CMYK_C": 0,
    "CMYK_M": 0.09557528,
    "CMYK_Y": 0.1180026,
    "CMYK_K": 0.05357158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01557",
    "Farbtonhilfsbezeichnung": "E4.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "73",
    "Bcolor": "66",
    "Y": 8,
    "L": 31.5275832116434,
    "a": 2.11122634522748,
    "b": 5.05656983255809,
    "C": 5.47961450763821,
    "h": 1.17527709601458,
    "CMY_C": 0.6832746,
    "CMY_M": 0.7142411,
    "CMY_Y": 0.7419549,
    "CMYK_C": 0,
    "CMYK_M": 0.09777079,
    "CMYK_Y": 0.1852719,
    "CMYK_K": 0.6832746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01558",
    "Farbtonhilfsbezeichnung": "B2.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "122",
    "Bcolor": "125",
    "Y": 27,
    "L": 58.6498491345169,
    "a": 28.4069730544375,
    "b": 9.41781889380897,
    "C": 29.9274360885145,
    "h": 0.32012842543008,
    "CMY_C": 0.2438164,
    "CMY_M": 0.5225475,
    "CMY_Y": 0.5105227,
    "CMYK_C": 0,
    "CMYK_M": 0.3686025,
    "CMYK_Y": 0.3527004,
    "CMYK_K": 0.2438164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01559",
    "Farbtonhilfsbezeichnung": "P0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "174",
    "Bcolor": "170",
    "Y": 38,
    "L": 67.0618543448607,
    "a": -20.9969590194189,
    "b": -5.02305325701535,
    "C": 21.5894268586725,
    "h": 0.23481457149893,
    "CMY_C": 0.5649646,
    "CMY_M": 0.3160523,
    "CMY_Y": 0.3325253,
    "CMYK_C": 0.3639347,
    "CMYK_M": 0,
    "CMYK_Y": 0.02408529,
    "CMYK_K": 0.3160523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01560",
    "Farbtonhilfsbezeichnung": "F2.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "147",
    "Bcolor": "121",
    "Y": 31,
    "L": 61.9082215319959,
    "a": 3.2010208895395,
    "b": 15.5087993080334,
    "C": 15.8356998807165,
    "h": 1.36725427140376,
    "CMY_C": 0.3502026,
    "CMY_M": 0.4239986,
    "CMY_Y": 0.5240364,
    "CMYK_C": 0,
    "CMYK_M": 0.1135677,
    "CMYK_Y": 0.26752,
    "CMYK_K": 0.3502026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01561",
    "Farbtonhilfsbezeichnung": "E4.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "113",
    "Bcolor": "103",
    "Y": 17,
    "L": 48.4661712646484,
    "a": 3.17550468444824,
    "b": 6.79726934432983,
    "C": 7.50244617462158,
    "h": 64.9592590332031,
    "CMY_C": 0.50899863243103,
    "CMY_M": 0.55684179067612,
    "CMY_Y": 0.59631735086441,
    "CMYK_C": 0,
    "CMYK_M": 0.09743996709585,
    "CMYK_Y": 0.17783804237843,
    "CMYK_K": 0.50899863243103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01562",
    "Farbtonhilfsbezeichnung": "E4.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "149",
    "Bcolor": "88",
    "Y": 38,
    "L": 66.8343021971573,
    "a": 18.8228248428458,
    "b": 41.1769137380066,
    "C": 45.2751251798567,
    "h": 1.14203652196643,
    "CMY_C": 0.1592458,
    "CMY_M": 0.4174306,
    "CMY_Y": 0.6558715,
    "CMYK_C": 0,
    "CMYK_M": 0.3070871,
    "CMYK_Y": 0.5906907,
    "CMYK_K": 0.1592458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01563",
    "Farbtonhilfsbezeichnung": "G0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "128",
    "Bcolor": "120",
    "Y": 22,
    "L": 53.7614936828613,
    "a": -0.16559718549252,
    "b": 4.12892770767212,
    "C": 4.13224697113037,
    "h": 92.2967071533203,
    "CMY_C": 0.4851638674736,
    "CMY_M": 0.49655330181122,
    "CMY_Y": 0.52774906158447,
    "CMYK_C": 0,
    "CMYK_M": 0.02212244644761,
    "CMYK_Y": 0.0827160179615,
    "CMYK_K": 0.4851638674736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01564",
    "Farbtonhilfsbezeichnung": "J0.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "212",
    "Bcolor": "190",
    "Y": 65,
    "L": 83.9123916625977,
    "a": -5.88531160354614,
    "b": 9.19884204864502,
    "C": 10.9204206466675,
    "h": 122.610641479492,
    "CMY_C": 0.19541782140732,
    "CMY_M": 0.16800510883331,
    "CMY_Y": 0.25372016429901,
    "CMYK_C": 0.03294817358255,
    "CMYK_M": 0,
    "CMYK_Y": 0.10302353650331,
    "CMYK_K": 0.16800510883331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01565",
    "Farbtonhilfsbezeichnung": "F2.20.60",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "162",
    "Bcolor": "126",
    "Y": 39,
    "L": 67.904065785272,
    "a": 4.41895912157986,
    "b": 21.5145521887941,
    "C": 21.9636780982271,
    "h": 1.36821968546136,
    "CMY_C": 0.2651702,
    "CMY_M": 0.3660105,
    "CMY_Y": 0.5062475,
    "CMYK_C": 0,
    "CMYK_M": 0.1372294,
    "CMYK_Y": 0.3280723,
    "CMYK_K": 0.2651702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01566",
    "Farbtonhilfsbezeichnung": "P0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "147",
    "Bcolor": "145",
    "Y": 27,
    "L": 59.105354309082,
    "a": -8.95529365539551,
    "b": -2.20484733581543,
    "C": 9.22272396087646,
    "h": 193.831466674805,
    "CMY_C": 0.51928108930588,
    "CMY_M": 0.42275106906891,
    "CMY_Y": 0.43275445699692,
    "CMYK_C": 0.16722425818443,
    "CMYK_M": 0,
    "CMYK_Y": 0.01732941716909,
    "CMYK_K": 0.42275106906891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01567",
    "Farbtonhilfsbezeichnung": "C0.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "107",
    "Bcolor": "101",
    "Y": 21,
    "L": 52.2398110847319,
    "a": 25.9926876424399,
    "b": 14.2102214651265,
    "C": 29.623473884158,
    "h": 0.50030665835565,
    "CMY_C": 0.3204475,
    "CMY_M": 0.5805669,
    "CMY_Y": 0.6051805,
    "CMYK_C": 0,
    "CMYK_M": 0.3827805,
    "CMYK_Y": 0.4190007,
    "CMYK_K": 0.3204475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01568",
    "Farbtonhilfsbezeichnung": "L0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "199",
    "Bcolor": "180",
    "Y": 56,
    "L": 78.171218876898,
    "a": -10.7458317841153,
    "b": 6.48607608961913,
    "C": 12.5515769436685,
    "h": -0.54305499057261,
    "CMY_C": 0.3049568,
    "CMY_M": 0.2195721,
    "CMY_Y": 0.2958644,
    "CMYK_C": 0.1094075,
    "CMYK_M": 0,
    "CMYK_Y": 0.09775694,
    "CMYK_K": 0.2195721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01569",
    "Farbtonhilfsbezeichnung": "WN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "209",
    "Bcolor": "215",
    "Y": 60,
    "L": 84.2985916137695,
    "a": 2.05606293678284,
    "b": -3.419109582901,
    "C": 3.98969984054565,
    "h": 301.020355224609,
    "CMY_C": 0.17102402448654,
    "CMY_M": 0.1785945892334,
    "CMY_Y": 0.15645867586136,
    "CMYK_C": 0.01726690493524,
    "CMYK_M": 0.02624164707959,
    "CMYK_Y": 0,
    "CMYK_K": 0.15645867586136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01570",
    "Farbtonhilfsbezeichnung": "W0.10.50",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "135",
    "Bcolor": "156",
    "Y": 26,
    "L": 57.0940878450278,
    "a": 5.21068214640058,
    "b": -11.5637800699253,
    "C": 12.6835412222462,
    "h": -1.14744047229713,
    "CMY_C": 0.4642038,
    "CMY_M": 0.4705047,
    "CMY_Y": 0.3885216,
    "CMYK_C": 0.1237692,
    "CMYK_M": 0.1340737,
    "CMYK_Y": 0,
    "CMYK_K": 0.3885216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01571",
    "Farbtonhilfsbezeichnung": "D6.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "176",
    "Bcolor": "168",
    "Y": 46,
    "L": 72.9977645874023,
    "a": 4.31679153442383,
    "b": 5.41662263870239,
    "C": 6.92636203765869,
    "h": 51.4468154907227,
    "CMY_C": 0.24919325113297,
    "CMY_M": 0.30836910009384,
    "CMY_Y": 0.34054732322693,
    "CMYK_C": 0,
    "CMYK_M": 0.07881635427475,
    "CMYK_Y": 0.12167454510927,
    "CMYK_K": 0.24919325113297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01572",
    "Farbtonhilfsbezeichnung": "C4.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "115",
    "Bcolor": "100",
    "Y": 26,
    "L": 56.6914430875766,
    "a": 29.3581593894263,
    "b": 20.8611254524165,
    "C": 36.015109022137,
    "h": 0.61778697514238,
    "CMY_C": 0.2423013,
    "CMY_M": 0.5481421,
    "CMY_Y": 0.6063724,
    "CMYK_C": 0,
    "CMYK_M": 0.4036444,
    "CMYK_Y": 0.4804958,
    "CMYK_K": 0.2423013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01573",
    "Farbtonhilfsbezeichnung": "F2.60.70",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "174",
    "Bcolor": "54",
    "Y": 51,
    "L": 75.4973338811402,
    "a": 14.4774963758057,
    "b": 66.2338737849341,
    "C": 67.7976691182672,
    "h": 1.35559948274077,
    "CMY_C": 0.05740929,
    "CMY_M": 0.3182615,
    "CMY_Y": 0.7865685,
    "CMYK_C": 0,
    "CMYK_M": 0.2767397,
    "CMYK_Y": 0.7735693,
    "CMYK_K": 0.05740929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01574",
    "Farbtonhilfsbezeichnung": "B2.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "91",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.7477416992188,
    "a": 9.01587390899658,
    "b": 2.38267755508423,
    "C": 9.32540225982666,
    "h": 14.8034515380859,
    "CMY_C": 0.55976790189743,
    "CMY_M": 0.6432147026062,
    "CMY_Y": 0.64033830165863,
    "CMYK_C": 0,
    "CMYK_M": 0.18955183029175,
    "CMYK_Y": 0.18301799893379,
    "CMYK_K": 0.55976790189743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01578",
    "Farbtonhilfsbezeichnung": "J0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "99",
    "Bcolor": "87",
    "Y": 11,
    "L": 41.2693977355957,
    "a": -3.13831901550293,
    "b": 6.08351039886475,
    "C": 6.84530115127563,
    "h": 117.287994384766,
    "CMY_C": 0.62252962589264,
    "CMY_M": 0.613245844841,
    "CMY_Y": 0.66049063205719,
    "CMYK_C": 0.02400434762239,
    "CMYK_M": 0,
    "CMYK_Y": 0.12215715646744,
    "CMYK_K": 0.613245844841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01580",
    "Farbtonhilfsbezeichnung": "L0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "78",
    "Bcolor": "52",
    "Y": 7,
    "L": 29.9247376337903,
    "a": -18.932531425679,
    "b": 10.8941658219516,
    "C": 21.8431590009435,
    "h": -0.52215020448943,
    "CMY_C": 0.830703,
    "CMY_M": 0.6944654,
    "CMY_Y": 0.7942979,
    "CMYK_C": 0.4458992,
    "CMYK_M": 0,
    "CMYK_Y": 0.3267469,
    "CMYK_K": 0.6944654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01581",
    "Farbtonhilfsbezeichnung": "E4.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "203",
    "Bcolor": "190",
    "Y": 62,
    "L": 82.3522051359374,
    "a": 3.06950683670393,
    "b": 7.43993373704959,
    "C": 8.04825982633891,
    "h": 1.17949939185459,
    "CMY_C": 0.1502216,
    "CMY_M": 0.2053354,
    "CMY_Y": 0.2562756,
    "CMYK_C": 0,
    "CMYK_M": 0.06485666,
    "CMYK_Y": 0.1248019,
    "CMYK_K": 0.1502216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01582",
    "Farbtonhilfsbezeichnung": "W0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "81",
    "Bcolor": "91",
    "Y": 10,
    "L": 35.1326214352294,
    "a": 3.02365753203729,
    "b": -5.58468237768948,
    "C": 6.35068359554475,
    "h": -1.07456447078812,
    "CMY_C": 0.6729149,
    "CMY_M": 0.680483,
    "CMY_Y": 0.6440881,
    "CMYK_C": 0.08099402,
    "CMYK_M": 0.1022583,
    "CMYK_Y": 0,
    "CMYK_K": 0.6440881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01584",
    "Farbtonhilfsbezeichnung": "E8.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "109",
    "Bcolor": "96",
    "Y": 17,
    "L": 46.790783960596,
    "a": 3.23605892063816,
    "b": 8.48369854921763,
    "C": 9.07993493433952,
    "h": 1.20638781580369,
    "CMY_C": 0.5214173,
    "CMY_M": 0.573721,
    "CMY_Y": 0.623253,
    "CMYK_C": 0,
    "CMYK_M": 0.1092888,
    "CMYK_Y": 0.2127862,
    "CMYK_K": 0.5214173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01585",
    "Farbtonhilfsbezeichnung": "M2.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "185",
    "Bcolor": "145",
    "Y": 39,
    "L": 67.7490227569081,
    "a": -42.819946145399,
    "b": 9.87428391515455,
    "C": 43.9437057009528,
    "h": -0.22663826404477,
    "CMY_C": 0.7512708,
    "CMY_M": 0.2761058,
    "CMY_Y": 0.4324703,
    "CMYK_C": 0.6564012,
    "CMYK_M": 0,
    "CMYK_Y": 0.2160047,
    "CMYK_K": 0.2761058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01587",
    "Farbtonhilfsbezeichnung": "U0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "137",
    "Bcolor": "155",
    "Y": 26,
    "L": 56.8330432871748,
    "a": 0.23682033216831,
    "b": -11.4993795473204,
    "C": 11.5018178494992,
    "h": -1.55020505405706,
    "CMY_C": 0.5049621,
    "CMY_M": 0.4621838,
    "CMY_Y": 0.3921812,
    "CMYK_C": 0.1855502,
    "CMYK_M": 0.1151701,
    "CMYK_Y": 0,
    "CMYK_K": 0.3921812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01592",
    "Farbtonhilfsbezeichnung": "E4.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "101",
    "Bcolor": "59",
    "Y": 17,
    "L": 46.4845362348124,
    "a": 13.7137662888221,
    "b": 29.950897760864,
    "C": 32.9412152554541,
    "h": 1.14141290783451,
    "CMY_C": 0.4291047,
    "CMY_M": 0.6053824,
    "CMY_Y": 0.7667924,
    "CMYK_C": 0,
    "CMYK_M": 0.3087741,
    "CMYK_Y": 0.5915055,
    "CMYK_K": 0.4291047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01594",
    "Farbtonhilfsbezeichnung": "F2.25.65",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "173",
    "Bcolor": "122",
    "Y": 45,
    "L": 72.5957094782243,
    "a": 5.44090225075816,
    "b": 30.1921266787285,
    "C": 30.6784603702124,
    "h": 1.39250065687887,
    "CMY_C": 0.1904203,
    "CMY_M": 0.3208351,
    "CMY_Y": 0.5215203,
    "CMYK_C": 0,
    "CMYK_M": 0.1610896,
    "CMYK_Y": 0.4089776,
    "CMYK_K": 0.1904203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01596",
    "Farbtonhilfsbezeichnung": "QN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "225",
    "Bcolor": "225",
    "Y": 74.5319366455078,
    "L": 89.1732864379883,
    "a": -1.47371733188629,
    "b": -1.41050469875336,
    "C": 2.03994274139404,
    "h": 223.74446105957,
    "CMY_C": 0.13824015855789,
    "CMY_M": 0.11708384752274,
    "CMY_Y": 0.11805456876755,
    "CMYK_C": 0.02396185696125,
    "CMYK_M": 0,
    "CMYK_Y": 0.00109944900032,
    "CMYK_K": 0.11708384752274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01597",
    "Farbtonhilfsbezeichnung": "D6.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "109",
    "Bcolor": "100",
    "Y": 18,
    "L": 47.6516081771101,
    "a": 5.86882082608453,
    "b": 7.6826850178884,
    "C": 9.66781810817572,
    "h": 0.91845695050222,
    "CMY_C": 0.498082,
    "CMY_M": 0.57102,
    "CMY_Y": 0.6094843,
    "CMYK_C": 0,
    "CMYK_M": 0.1453186,
    "CMYK_Y": 0.2219531,
    "CMYK_K": 0.498082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01609",
    "Farbtonhilfsbezeichnung": "G8.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "143",
    "Bcolor": "89",
    "Y": 27,
    "L": 58.5888250832034,
    "a": -5.92877097582761,
    "b": 28.7367265001226,
    "C": 29.3419456619131,
    "h": -1.3673376515739,
    "CMY_C": 0.4186775,
    "CMY_M": 0.4405465,
    "CMY_Y": 0.6504006,
    "CMYK_C": 0,
    "CMYK_M": 0.0376194,
    "CMYK_Y": 0.3986136,
    "CMYK_K": 0.4186775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01610",
    "Farbtonhilfsbezeichnung": "E4.05.20",
    "Farbtonklasse": "02",
    "Rcolor": "76",
    "Gcolor": "72",
    "Bcolor": "68",
    "Y": 8,
    "L": 30.7691435026917,
    "a": 1.21723383756372,
    "b": 2.40759515336109,
    "C": 2.69780885864768,
    "h": 1.10269406683266,
    "CMY_C": 0.7019643,
    "CMY_M": 0.7187521,
    "CMY_Y": 0.7328182,
    "CMYK_C": 0,
    "CMYK_M": 0.0563282,
    "CMYK_Y": 0.1035244,
    "CMYK_K": 0.7019643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01611",
    "Farbtonhilfsbezeichnung": "P4.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "206",
    "Bcolor": "205",
    "Y": 60,
    "L": 80.8070600598495,
    "a": -9.68164724536769,
    "b": -3.44196612324155,
    "C": 10.2752821945326,
    "h": 0.34157905551606,
    "CMY_C": 0.3054515,
    "CMY_M": 0.1904526,
    "CMY_Y": 0.1958424,
    "CMYK_C": 0.1420532,
    "CMYK_M": 0,
    "CMYK_Y": 0.006657699,
    "CMYK_K": 0.1904526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01612",
    "Farbtonhilfsbezeichnung": "Z0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "100",
    "Bcolor": "126",
    "Y": 17,
    "L": 48.2746772766113,
    "a": 23.7639312744141,
    "b": -7.14159679412842,
    "C": 24.8138427734375,
    "h": 343.273284912109,
    "CMY_C": 0.41815489530563,
    "CMY_M": 0.60672080516815,
    "CMY_Y": 0.50493574142456,
    "CMYK_C": 0,
    "CMYK_M": 0.32408267259598,
    "CMYK_Y": 0.14914767444134,
    "CMYK_K": 0.41815489530563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01616",
    "Farbtonhilfsbezeichnung": "C0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "121",
    "Bcolor": "118",
    "Y": 21,
    "L": 52.0150287363359,
    "a": 5.54238552948905,
    "b": 3.09405798627769,
    "C": 6.34753748944725,
    "h": 0.50915803636786,
    "CMY_C": 0.4671431,
    "CMY_M": 0.5262926,
    "CMY_Y": 0.5372788,
    "CMYK_C": 0,
    "CMYK_M": 0.1110044,
    "CMYK_Y": 0.1316221,
    "CMYK_K": 0.4671431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01617",
    "Farbtonhilfsbezeichnung": "S0.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "106",
    "Bcolor": "110",
    "Y": 15,
    "L": 44.1854730680594,
    "a": -1.70544495874841,
    "b": -3.82122522716031,
    "C": 4.18453160389627,
    "h": 1.15101656643452,
    "CMY_C": 0.6148075,
    "CMY_M": 0.5856811,
    "CMY_Y": 0.569436,
    "CMYK_C": 0.1053772,
    "CMYK_M": 0.0377299,
    "CMYK_Y": 0,
    "CMYK_K": 0.569436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01618",
    "Farbtonhilfsbezeichnung": "E8.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "129",
    "Bcolor": "72",
    "Y": 26,
    "L": 57.6044449687327,
    "a": 12.1262444659496,
    "b": 37.1613897688519,
    "C": 39.0898285286659,
    "h": 1.25537732561101,
    "CMY_C": 0.3075244,
    "CMY_M": 0.493017,
    "CMY_Y": 0.7162417,
    "CMYK_C": 0,
    "CMYK_M": 0.2678687,
    "CMYK_Y": 0.5902262,
    "CMYK_K": 0.3075244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01619",
    "Farbtonhilfsbezeichnung": "W0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "94",
    "Bcolor": "111",
    "Y": 12,
    "L": 40.7375984191895,
    "a": 5.03574848175049,
    "b": -9.72525119781494,
    "C": 10.9516792297363,
    "h": 297.375183105469,
    "CMY_C": 0.6202420592308,
    "CMY_M": 0.63102900981903,
    "CMY_Y": 0.56457161903381,
    "CMYK_C": 0.12785211205482,
    "CMYK_M": 0.15262530744076,
    "CMYK_Y": 0,
    "CMYK_K": 0.56457161903381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01620",
    "Farbtonhilfsbezeichnung": "L0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "107",
    "Bcolor": "73",
    "Y": 11,
    "L": 41.3353614807129,
    "a": -22.2210006713867,
    "b": 13.8276462554932,
    "C": 26.1720581054688,
    "h": 148.106887817383,
    "CMY_C": 0.74493455886841,
    "CMY_M": 0.58135217428207,
    "CMY_Y": 0.71224284172058,
    "CMYK_C": 0.39073982834816,
    "CMYK_M": 0,
    "CMYK_Y": 0.31265100836754,
    "CMYK_K": 0.58135217428207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01621",
    "Farbtonhilfsbezeichnung": "T0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "123",
    "Bcolor": "167",
    "Y": 18,
    "L": 48.7752107998045,
    "a": -9.28993064447259,
    "b": -31.188072997851,
    "C": 32.5422603501722,
    "h": 1.28129659097347,
    "CMY_C": 0.845555,
    "CMY_M": 0.5173385,
    "CMY_Y": 0.3452483,
    "CMYK_C": 0.7641167,
    "CMYK_M": 0.2628327,
    "CMYK_Y": 0,
    "CMYK_K": 0.3452483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01622",
    "Farbtonhilfsbezeichnung": "LN.02.47",
    "Farbtonklasse": "01",
    "Rcolor": "131",
    "Gcolor": "135",
    "Bcolor": "131",
    "Y": 23,
    "L": 55.7401504516602,
    "a": -1.93840646743774,
    "b": 1.01361572742462,
    "C": 2.18742680549622,
    "h": 152.394409179688,
    "CMY_C": 0.48717665672302,
    "CMY_M": 0.47212696075439,
    "CMY_Y": 0.487544298172,
    "CMYK_C": 0.02851006761193,
    "CMYK_M": 0,
    "CMYK_Y": 0.02920652553439,
    "CMYK_K": 0.47212696075439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01628",
    "Farbtonhilfsbezeichnung": "E8.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "206",
    "Bcolor": "164",
    "Y": 68,
    "L": 85.310302734375,
    "a": 8.96072292327881,
    "b": 25.3755683898926,
    "C": 26.9112243652344,
    "h": 70.550651550293,
    "CMY_C": 0.03197938203812,
    "CMY_M": 0.19185876846313,
    "CMY_Y": 0.35525596141815,
    "CMYK_C": 0,
    "CMYK_M": 0.1651611328125,
    "CMYK_Y": 0.33395630121231,
    "CMYK_K": 0.03197938203812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01630",
    "Farbtonhilfsbezeichnung": "B2.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "173",
    "Bcolor": "172",
    "Y": 45,
    "L": 72.6451690492629,
    "a": 8.8408579246394,
    "b": 2.78825543214671,
    "C": 9.27012066796085,
    "h": 0.30550912491245,
    "CMY_C": 0.2285427,
    "CMY_M": 0.3223686,
    "CMY_Y": 0.3250378,
    "CMYK_C": 0,
    "CMYK_M": 0.1216216,
    "CMYK_Y": 0.1250815,
    "CMYK_K": 0.2285427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01632",
    "Farbtonhilfsbezeichnung": "L0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "220",
    "Bcolor": "196",
    "Y": 68,
    "L": 85.2129529051442,
    "a": -13.8566256700697,
    "b": 8.0176419371641,
    "C": 16.0090179958987,
    "h": -0.5245462892603,
    "CMY_C": 0.2498229,
    "CMY_M": 0.1361428,
    "CMY_Y": 0.2322594,
    "CMYK_C": 0.1315959,
    "CMYK_M": 0,
    "CMYK_Y": 0.1112645,
    "CMYK_K": 0.1361428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01633",
    "Farbtonhilfsbezeichnung": "L0.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "210",
    "Bcolor": "176",
    "Y": 59,
    "L": 80.8476881028052,
    "a": -18.4890869593757,
    "b": 12.1350309861712,
    "C": 22.1157254827123,
    "h": -0.58081561666811,
    "CMY_C": 0.3215345,
    "CMY_M": 0.1758275,
    "CMY_Y": 0.3095804,
    "CMYK_C": 0.1767919,
    "CMYK_M": 0,
    "CMYK_Y": 0.1622875,
    "CMYK_K": 0.1758275
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01634",
    "Farbtonhilfsbezeichnung": "G8.20.90",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "238",
    "Bcolor": "177",
    "Y": 86,
    "L": 93.1441576973707,
    "a": -6.70650314051208,
    "b": 29.5324463093453,
    "C": 30.2843617959511,
    "h": -1.34749413193826,
    "CMY_C": 0.0435175,
    "CMY_M": 0.06824925,
    "CMY_Y": 0.3068365,
    "CMYK_C": 0,
    "CMYK_M": 0.02585698,
    "CMYK_Y": 0.2752993,
    "CMYK_K": 0.0435175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01636",
    "Farbtonhilfsbezeichnung": "K2.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "196",
    "Bcolor": "170",
    "Y": 53,
    "L": 77.1709029462137,
    "a": -10.7222286987114,
    "b": 10.1334057912182,
    "C": 14.7530370160508,
    "h": -0.75717238446968,
    "CMY_C": 0.3032684,
    "CMY_M": 0.2313568,
    "CMY_Y": 0.3326617,
    "CMYK_C": 0.09355655,
    "CMYK_M": 0,
    "CMYK_Y": 0.1317971,
    "CMYK_K": 0.2313568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01639",
    "Farbtonhilfsbezeichnung": "C0.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "144",
    "Bcolor": "137",
    "Y": 38,
    "L": 66.3247154556687,
    "a": 24.6059340289223,
    "b": 13.5870027752131,
    "C": 28.1079816751279,
    "h": 0.50451843048824,
    "CMY_C": 0.1722012,
    "CMY_M": 0.4336247,
    "CMY_Y": 0.4629531,
    "CMYK_C": 0,
    "CMYK_M": 0.3158056,
    "CMYK_Y": 0.351235,
    "CMYK_K": 0.1722012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01640",
    "Farbtonhilfsbezeichnung": "C0.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "184",
    "Bcolor": "175",
    "Y": 58,
    "L": 79.647451343781,
    "a": 19.9099285321555,
    "b": 11.8690365860414,
    "C": 23.1792856584565,
    "h": 0.53757390342633,
    "CMY_C": 0.05344976,
    "CMY_M": 0.279195,
    "CMY_Y": 0.3142774,
    "CMYK_C": 0,
    "CMYK_M": 0.2384926,
    "CMYK_Y": 0.2755561,
    "CMYK_K": 0.05344976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01641",
    "Farbtonhilfsbezeichnung": "C4.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "145",
    "Bcolor": "132",
    "Y": 36,
    "L": 65.6405541145643,
    "a": 20.9452561476544,
    "b": 15.3504540788663,
    "C": 25.9680610658216,
    "h": 0.63245691665946,
    "CMY_C": 0.1986291,
    "CMY_M": 0.4306338,
    "CMY_Y": 0.4826916,
    "CMYK_C": 0,
    "CMYK_M": 0.2895097,
    "CMYK_Y": 0.3544707,
    "CMYK_K": 0.1986291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01642",
    "Farbtonhilfsbezeichnung": "C8.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "165",
    "Bcolor": "149",
    "Y": 44,
    "L": 71.8343411098783,
    "a": 16.8283438877716,
    "b": 14.6845331608244,
    "C": 22.3344727306568,
    "h": 0.71747314767929,
    "CMY_C": 0.1558811,
    "CMY_M": 0.3545963,
    "CMY_Y": 0.4160329,
    "CMYK_C": 0,
    "CMYK_M": 0.2354114,
    "CMYK_Y": 0.3081933,
    "CMYK_K": 0.1558811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01643",
    "Farbtonhilfsbezeichnung": "D6.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "142",
    "Bcolor": "122",
    "Y": 31,
    "L": 61.6926892206559,
    "a": 10.48530710464,
    "b": 14.9136039072008,
    "C": 18.2306677491388,
    "h": 0.95801294772321,
    "CMY_C": 0.3071393,
    "CMY_M": 0.4434305,
    "CMY_Y": 0.5208316,
    "CMYK_C": 0,
    "CMYK_M": 0.1967079,
    "CMYK_Y": 0.3084204,
    "CMYK_K": 0.3071393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01644",
    "Farbtonhilfsbezeichnung": "C8.25.65",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "157",
    "Bcolor": "134",
    "Y": 45,
    "L": 71.9528942884578,
    "a": 26.4243231936656,
    "b": 23.2673462698316,
    "C": 35.2081561386497,
    "h": 0.72195212125915,
    "CMY_C": 0.07993401,
    "CMY_M": 0.3826094,
    "CMY_Y": 0.4736928,
    "CMYK_C": 0,
    "CMYK_M": 0.3289714,
    "CMYK_Y": 0.427968,
    "CMYK_K": 0.07993401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01646",
    "Farbtonhilfsbezeichnung": "D6.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "141",
    "Bcolor": "114",
    "Y": 31,
    "L": 63.4936180114746,
    "a": 18.2411499023438,
    "b": 22.2817935943604,
    "C": 28.796142578125,
    "h": 50.6942825317383,
    "CMY_C": 0.22677165269852,
    "CMY_M": 0.4467425942421,
    "CMY_Y": 0.55256652832031,
    "CMYK_C": 0,
    "CMYK_M": 0.28448379039764,
    "CMYK_Y": 0.42134368419647,
    "CMYK_K": 0.22677165269852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01647",
    "Farbtonhilfsbezeichnung": "E4.25.65",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "166",
    "Bcolor": "124",
    "Y": 43,
    "L": 71.4567392043624,
    "a": 12.4402705499477,
    "b": 27.9640055974989,
    "C": 30.6063055662202,
    "h": 1.15221897980801,
    "CMY_C": 0.1628546,
    "CMY_M": 0.3499033,
    "CMY_Y": 0.5152317,
    "CMYK_C": 0,
    "CMYK_M": 0.2234363,
    "CMYK_Y": 0.420927,
    "CMYK_K": 0.1628546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01649",
    "Farbtonhilfsbezeichnung": "F0.25.70",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "176",
    "Bcolor": "129",
    "Y": 49,
    "L": 74.1335697361498,
    "a": 7.68217090670226,
    "b": 28.6842700112206,
    "C": 29.6951695721104,
    "h": 1.30911911688118,
    "CMY_C": 0.1614047,
    "CMY_M": 0.3097506,
    "CMY_Y": 0.4946196,
    "CMYK_C": 0,
    "CMYK_M": 0.1768981,
    "CMYK_Y": 0.3973489,
    "CMYK_K": 0.1614047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01652",
    "Farbtonhilfsbezeichnung": "G0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "174",
    "Bcolor": "142",
    "Y": 43,
    "L": 71.3891793432756,
    "a": 0.51249717856854,
    "b": 17.5587446267076,
    "C": 17.5662223094203,
    "h": 1.54161703583729,
    "CMY_C": 0.2619941,
    "CMY_M": 0.3194889,
    "CMY_Y": 0.4437575,
    "CMYK_C": 0,
    "CMYK_M": 0.07790549,
    "CMYK_Y": 0.2462898,
    "CMYK_K": 0.2619941
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01653",
    "Farbtonhilfsbezeichnung": "G0.25.65",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "176",
    "Bcolor": "121",
    "Y": 46,
    "L": 72.6101455688477,
    "a": 0.3041051030159,
    "b": 30.4959564208984,
    "C": 30.4974727630615,
    "h": 89.4286651611328,
    "CMY_C": 0.22316294908524,
    "CMY_M": 0.30859506130219,
    "CMY_Y": 0.52470111846924,
    "CMYK_C": 0,
    "CMYK_M": 0.10997430235147,
    "CMYK_Y": 0.38816142082214,
    "CMYK_K": 0.22316294908524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01654",
    "Farbtonhilfsbezeichnung": "L0.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "182",
    "Bcolor": "155",
    "Y": 44,
    "L": 71.0541059109307,
    "a": -16.5318236044469,
    "b": 9.65978532243734,
    "C": 19.1471314865732,
    "h": -0.52880624664032,
    "CMY_C": 0.4166403,
    "CMY_M": 0.2854078,
    "CMY_Y": 0.393715,
    "CMYK_C": 0.1836466,
    "CMYK_M": 0,
    "CMYK_Y": 0.151565,
    "CMYK_K": 0.2854078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01656",
    "Farbtonhilfsbezeichnung": "G0.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "186",
    "Bcolor": "116",
    "Y": 51,
    "L": 76.3078116789687,
    "a": 0.52809730551362,
    "b": 38.2047623110364,
    "C": 38.2084120319973,
    "h": 1.55697439353637,
    "CMY_C": 0.1669098,
    "CMY_M": 0.2710919,
    "CMY_Y": 0.5449694,
    "CMYK_C": 0,
    "CMYK_M": 0.1250549,
    "CMYK_Y": 0.4538039,
    "CMYK_K": 0.1669098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01657",
    "Farbtonhilfsbezeichnung": "D2.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "161",
    "Bcolor": "146",
    "Y": 40,
    "L": 68.3682478723711,
    "a": 9.00756475634507,
    "b": 11.1755858188337,
    "C": 14.3537431088155,
    "h": 0.89240523083298,
    "CMY_C": 0.2524365,
    "CMY_M": 0.3699311,
    "CMY_Y": 0.4281244,
    "CMYK_C": 0,
    "CMYK_M": 0.15717,
    "CMYK_Y": 0.235014,
    "CMYK_K": 0.2524365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01658",
    "Farbtonhilfsbezeichnung": "D2.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "115",
    "Bcolor": "108",
    "Y": 17,
    "L": 49.9010620117188,
    "a": 6.53705596923828,
    "b": 5.7767186164856,
    "C": 8.72373676300049,
    "h": 41.4666481018066,
    "CMY_C": 0.4755100607872,
    "CMY_M": 0.55006623268127,
    "CMY_Y": 0.57536232471466,
    "CMYK_C": 0,
    "CMYK_M": 0.14214986562729,
    "CMYK_Y": 0.19037975370884,
    "CMYK_K": 0.4755100607872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01659",
    "Farbtonhilfsbezeichnung": "D2.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "82",
    "Bcolor": "68",
    "Y": 11,
    "L": 38.215368812362,
    "a": 12.7063265309803,
    "b": 13.4273262302061,
    "C": 18.4863144948979,
    "h": 0.81298010380978,
    "CMY_C": 0.5429363,
    "CMY_M": 0.6783599,
    "CMY_Y": 0.7323951,
    "CMYK_C": 0,
    "CMYK_M": 0.2962903,
    "CMYK_Y": 0.4145127,
    "CMYK_K": 0.5429363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01660",
    "Farbtonhilfsbezeichnung": "E4.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "111",
    "Bcolor": "86",
    "Y": 18,
    "L": 49.0874128830451,
    "a": 7.81851113514936,
    "b": 18.1156221184682,
    "C": 19.7308104524266,
    "h": 1.16335763306111,
    "CMY_C": 0.4511071,
    "CMY_M": 0.5636884,
    "CMY_Y": 0.6641842,
    "CMYK_C": 0,
    "CMYK_M": 0.2051062,
    "CMYK_Y": 0.3881943,
    "CMYK_K": 0.4511071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01661",
    "Farbtonhilfsbezeichnung": "F2.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "160",
    "Bcolor": "106",
    "Y": 39,
    "L": 68.0450565614615,
    "a": 6.84011297476927,
    "b": 32.9022679507369,
    "C": 33.60574923744,
    "h": 1.36582410471613,
    "CMY_C": 0.228048,
    "CMY_M": 0.3724537,
    "CMY_Y": 0.5860484,
    "CMYK_C": 0,
    "CMYK_M": 0.1870656,
    "CMYK_Y": 0.46376,
    "CMYK_K": 0.228048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01662",
    "Farbtonhilfsbezeichnung": "J0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "121",
    "Bcolor": "109",
    "Y": 18,
    "L": 50.1785621643066,
    "a": -2.87073993682861,
    "b": 5.60199642181396,
    "C": 6.2947211265564,
    "h": 117.132843017578,
    "CMY_C": 0.5355464220047,
    "CMY_M": 0.52694630622864,
    "CMY_Y": 0.57282471656799,
    "CMYK_C": 0.01817999966443,
    "CMYK_M": 0,
    "CMYK_Y": 0.09698351472616,
    "CMYK_K": 0.52694630622864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01665",
    "Farbtonhilfsbezeichnung": "C8.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "144",
    "Gcolor": "67",
    "Bcolor": "47",
    "Y": 11,
    "L": 38.1117431800818,
    "a": 31.4548496622535,
    "b": 26.7728985949727,
    "C": 41.3061214162218,
    "h": 0.70516322423377,
    "CMY_C": 0.4341712,
    "CMY_M": 0.7381965,
    "CMY_Y": 0.8141559,
    "CMYK_C": 0,
    "CMYK_M": 0.5373097,
    "CMYK_Y": 0.6715543,
    "CMYK_K": 0.4341712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01667",
    "Farbtonhilfsbezeichnung": "U0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "91",
    "Bcolor": "105",
    "Y": 11,
    "L": 38.5987522864573,
    "a": 0.12774869290949,
    "b": -9.17062453060853,
    "C": 9.17151427027942,
    "h": -1.55686702130364,
    "CMY_C": 0.6738307,
    "CMY_M": 0.6412297,
    "CMY_Y": 0.5892156,
    "CMYK_C": 0.2059842,
    "CMYK_M": 0.1266213,
    "CMYK_Y": 0,
    "CMYK_K": 0.5892156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01668",
    "Farbtonhilfsbezeichnung": "F6.50.70",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "183",
    "Bcolor": "68",
    "Y": 54,
    "L": 76.5053772981525,
    "a": 4.05680773322958,
    "b": 61.4438839746749,
    "C": 61.5776628890517,
    "h": 1.50486741792211,
    "CMY_C": 0.1121549,
    "CMY_M": 0.2805171,
    "CMY_Y": 0.7333791,
    "CMYK_C": 0,
    "CMYK_M": 0.1896302,
    "CMYK_Y": 0.6996989,
    "CMYK_K": 0.1121549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01669",
    "Farbtonhilfsbezeichnung": "D6.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "151",
    "Bcolor": "144",
    "Y": 32,
    "L": 63.2019081115723,
    "a": 3.44582891464233,
    "b": 4.70206928253174,
    "C": 5.82951068878174,
    "h": 53.7648277282715,
    "CMY_C": 0.36155623197556,
    "CMY_M": 0.40870279073715,
    "CMY_Y": 0.4366968870163,
    "CMYK_C": 0,
    "CMYK_M": 0.07384606450796,
    "CMYK_Y": 0.11769346147776,
    "CMYK_K": 0.36155623197556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01674",
    "Farbtonhilfsbezeichnung": "H2.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "195",
    "Bcolor": "123",
    "Y": 53,
    "L": 77.0024113207131,
    "a": -11.3940251669202,
    "b": 34.9062035395946,
    "C": 36.718753451772,
    "h": -1.25528211908274,
    "CMY_C": 0.246521,
    "CMY_M": 0.2367091,
    "CMY_Y": 0.5158245,
    "CMYK_C": 0.01285465,
    "CMYK_M": 0,
    "CMYK_Y": 0.3656736,
    "CMYK_K": 0.2367091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01675",
    "Farbtonhilfsbezeichnung": "G8.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "92",
    "Bcolor": "79",
    "Y": 11,
    "L": 38.9527844134047,
    "a": -1.66390172371617,
    "b": 7.66383923902401,
    "C": 7.84238489413709,
    "h": -1.35700357288562,
    "CMY_C": 0.6309243,
    "CMY_M": 0.6384879,
    "CMY_Y": 0.6916659,
    "CMYK_C": 0,
    "CMYK_M": 0.02049358,
    "CMYK_Y": 0.1645777,
    "CMYK_K": 0.6309243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01677",
    "Farbtonhilfsbezeichnung": "K2.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "86",
    "Gcolor": "153",
    "Bcolor": "79",
    "Y": 26,
    "L": 57.4351747099788,
    "a": -36.5152651178487,
    "b": 31.6748808108932,
    "C": 48.3390386852187,
    "h": -0.71453339223285,
    "CMY_C": 0.6638592,
    "CMY_M": 0.3993391,
    "CMY_Y": 0.6889428,
    "CMYK_C": 0.4403817,
    "CMYK_M": 0,
    "CMYK_Y": 0.4821417,
    "CMYK_K": 0.3993391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01680",
    "Farbtonhilfsbezeichnung": "C0.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "65",
    "Y": 7,
    "L": 29.7787151706034,
    "a": 6.93601472230826,
    "b": 2.8578338648183,
    "C": 7.50170078228792,
    "h": 0.39083234315715,
    "CMY_C": 0.6762731,
    "CMY_M": 0.7396732,
    "CMY_Y": 0.743609,
    "CMYK_C": 0,
    "CMYK_M": 0.1958445,
    "CMYK_Y": 0.208002,
    "CMYK_K": 0.6762731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01681",
    "Farbtonhilfsbezeichnung": "ON.00.80",
    "Farbtonklasse": "01",
    "Y": 71,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01682",
    "Farbtonhilfsbezeichnung": "Z0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "155",
    "Bcolor": "167",
    "Y": 38,
    "L": 66.8904951451707,
    "a": 13.8687283869225,
    "b": -2.93185356874246,
    "C": 14.1752387076471,
    "h": -0.20833298653461,
    "CMY_C": 0.272363,
    "CMY_M": 0.3937352,
    "CMY_Y": 0.3446608,
    "CMYK_C": 0,
    "CMYK_M": 0.1668031,
    "CMYK_Y": 0.09935959,
    "CMYK_K": 0.272363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01683",
    "Farbtonhilfsbezeichnung": "G0.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "216",
    "Bcolor": "203",
    "Y": 69,
    "L": 86.6459121704102,
    "a": 0.56574958562851,
    "b": 6.75462961196899,
    "C": 6.77828121185303,
    "h": 85.2122344970703,
    "CMY_C": 0.12332147359848,
    "CMY_M": 0.15210837125778,
    "CMY_Y": 0.20543885231018,
    "CMYK_C": 0,
    "CMYK_M": 0.03283632174134,
    "CMYK_Y": 0.09366874396801,
    "CMYK_K": 0.12332147359848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01684",
    "Farbtonhilfsbezeichnung": "C8.03.78",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "206",
    "Bcolor": "200",
    "Y": 65,
    "L": 83.5149828011564,
    "a": 3.91738803402286,
    "b": 3.35462953672294,
    "C": 5.15746724059004,
    "h": 0.70816524838316,
    "CMY_C": 0.1432264,
    "CMY_M": 0.1935896,
    "CMY_Y": 0.2139879,
    "CMYK_C": 0,
    "CMYK_M": 0.0587824,
    "CMYK_Y": 0.08259065,
    "CMYK_K": 0.1432264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01686",
    "Farbtonhilfsbezeichnung": "ON.00.85",
    "Farbtonklasse": "01",
    "Y": 78,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01687",
    "Farbtonhilfsbezeichnung": "ON.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 72,
    "L": 87.8677825927734,
    "a": -0.48397666215897,
    "b": -0.00110977352597,
    "C": 0.48397794365883,
    "h": 180.131378173828,
    "CMY_C": 0.13981103897095,
    "CMY_M": 0.13428169488907,
    "CMY_Y": 0.14266735315323,
    "CMYK_C": 0.00638700136915,
    "CMYK_M": 0,
    "CMYK_Y": 0.00968635920435,
    "CMYK_K": 0.13428169488907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01688",
    "Farbtonhilfsbezeichnung": "E4.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "212",
    "Bcolor": "204",
    "Y": 69,
    "L": 85.214118096908,
    "a": 1.76337202556576,
    "b": 4.04219303285518,
    "C": 4.41007997834629,
    "h": 1.15944275578008,
    "CMY_C": 0.1384899,
    "CMY_M": 0.1700072,
    "CMY_Y": 0.2009211,
    "CMYK_C": 0,
    "CMYK_M": 0.03658377,
    "CMYK_Y": 0.07246716,
    "CMYK_K": 0.1384899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01689",
    "Farbtonhilfsbezeichnung": "R0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "169",
    "Bcolor": "175",
    "Y": 38,
    "L": 67.7045193773909,
    "a": -6.13847713151272,
    "b": -6.44437715107429,
    "C": 8.90005046948572,
    "h": 0.80970423656014,
    "CMY_C": 0.4253766,
    "CMY_M": 0.3378157,
    "CMY_Y": 0.3142058,
    "CMYK_C": 0.1621052,
    "CMYK_M": 0.03442714,
    "CMYK_Y": 0,
    "CMYK_K": 0.3142058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01690",
    "Farbtonhilfsbezeichnung": "EN.02.90",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "230",
    "Y": 86,
    "L": 94.9346313476562,
    "a": 1.37714993953705,
    "b": 4.2851881980896,
    "C": 4.50104188919067,
    "h": 72.1839218139648,
    "CMY_C": 0.0319402217865,
    "CMY_M": 0.06109404563904,
    "CMY_Y": 0.0961834192276,
    "CMYK_C": 0,
    "CMYK_M": 0.03011572733521,
    "CMYK_Y": 0.06636284291744,
    "CMYK_K": 0.0319402217865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01691",
    "Farbtonhilfsbezeichnung": "QN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "215",
    "Bcolor": "212",
    "Y": 69,
    "L": 85.5474010400975,
    "a": -1.37444841019535,
    "b": -0.08432994106224,
    "C": 1.37703303201052,
    "h": 0.06127866199669,
    "CMY_C": 0.172712,
    "CMY_M": 0.1578296,
    "CMY_Y": 0.1675866,
    "CMYK_C": 0.01767152,
    "CMYK_M": 0,
    "CMYK_Y": 0.01158546,
    "CMYK_K": 0.1578296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01692",
    "Farbtonhilfsbezeichnung": "E4.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "198",
    "Bcolor": "168",
    "Y": 61,
    "L": 82.0354995727539,
    "a": 7.90164995193481,
    "b": 18.571216583252,
    "C": 20.1823234558106,
    "h": 66.9512939453125,
    "CMY_C": 0.09119075536728,
    "CMY_M": 0.22331947088242,
    "CMY_Y": 0.33977299928665,
    "CMYK_C": 0,
    "CMYK_M": 0.14538663625717,
    "CMYK_Y": 0.27352520823479,
    "CMYK_K": 0.09119075536728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01693",
    "Farbtonhilfsbezeichnung": "Q0.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "154",
    "Bcolor": "165",
    "Y": 26,
    "L": 58.2592582702637,
    "a": -27.5324172973633,
    "b": -15.5901050567627,
    "C": 31.6399326324463,
    "h": 209.5205078125,
    "CMY_C": 0.87676203250885,
    "CMY_M": 0.39484333992004,
    "CMY_Y": 0.35230159759521,
    "CMYK_C": 0.80972939729691,
    "CMYK_M": 0.06568140536547,
    "CMYK_Y": 0,
    "CMYK_K": 0.35230159759521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01694",
    "Farbtonhilfsbezeichnung": "HN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 81,
    "L": 92.1641311645508,
    "a": -1.18381237983704,
    "b": 3.84939646720886,
    "C": 4.02731466293335,
    "h": 107.094329833984,
    "CMY_C": 0.08456748723984,
    "CMY_M": 0.08591002225876,
    "CMY_Y": 0.12394458055496,
    "CMYK_C": 0,
    "CMYK_M": 0.00146655819844,
    "CMYK_Y": 0.04301474243402,
    "CMYK_K": 0.08456748723984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01695",
    "Farbtonhilfsbezeichnung": "QN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "237",
    "Bcolor": "232",
    "Y": 87,
    "L": 93.3215470425597,
    "a": -2.32766328609574,
    "b": 1.2294136163447,
    "C": 2.63238944943406,
    "h": -0.48593274453369,
    "CMY_C": 0.08968376,
    "CMY_M": 0.0695506,
    "CMY_Y": 0.09181449,
    "CMYK_C": 0.0216381,
    "CMYK_M": 0,
    "CMYK_Y": 0.0239281,
    "CMYK_K": 0.0695506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01696",
    "Farbtonhilfsbezeichnung": "C4.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "175",
    "Bcolor": "169",
    "Y": 46,
    "L": 72.8982703980056,
    "a": 5.8123388982958,
    "b": 4.638777300716,
    "C": 7.43650040773753,
    "h": 0.67357603697563,
    "CMY_C": 0.2418662,
    "CMY_M": 0.3128155,
    "CMY_Y": 0.3358761,
    "CMYK_C": 0,
    "CMYK_M": 0.09358418,
    "CMYK_Y": 0.1240018,
    "CMYK_K": 0.2418662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01697",
    "Farbtonhilfsbezeichnung": "HN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "240",
    "Bcolor": "232",
    "Y": 85,
    "L": 94.8339767456055,
    "a": -0.71078377962112,
    "b": 3.15447521209717,
    "C": 3.233562707901,
    "h": 102.698135375977,
    "CMY_C": 0.0531884431839,
    "CMY_M": 0.05689263343811,
    "CMY_Y": 0.08915364742279,
    "CMYK_C": 0,
    "CMYK_M": 0.00391227845103,
    "CMYK_Y": 0.0379856005311,
    "CMYK_K": 0.0531884431839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01698",
    "Farbtonhilfsbezeichnung": "G0.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "225",
    "Bcolor": "211",
    "Y": 77,
    "L": 89.7038795990618,
    "a": -0.03240118333863,
    "b": 6.59181388068626,
    "C": 6.59189351205629,
    "h": -1.56588099954471,
    "CMY_C": 0.09433675,
    "CMY_M": 0.1168347,
    "CMY_Y": 0.1710865,
    "CMYK_C": 0,
    "CMYK_M": 0.02484143,
    "CMYK_Y": 0.08474421,
    "CMYK_K": 0.09433675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01699",
    "Farbtonhilfsbezeichnung": "F0.10.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "225",
    "Bcolor": "201",
    "Y": 80,
    "L": 90.7235889447429,
    "a": 3.72258348757815,
    "b": 13.7072389931242,
    "C": 14.2037329120416,
    "h": 1.30561436936463,
    "CMY_C": 0.0342599,
    "CMY_M": 0.1164119,
    "CMY_Y": 0.2121201,
    "CMYK_C": 0,
    "CMYK_M": 0.08506633,
    "CMYK_Y": 0.1841698,
    "CMYK_K": 0.0342599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01701",
    "Farbtonhilfsbezeichnung": "T0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "143",
    "Bcolor": "156",
    "Y": 26,
    "L": 58.726131439209,
    "a": -2.39501333236694,
    "b": -9.02185440063477,
    "C": 9.33434200286865,
    "h": 255.132720947266,
    "CMY_C": 0.49681180715561,
    "CMY_M": 0.4380732178688,
    "CMY_Y": 0.38967269659042,
    "CMYK_C": 0.17554369568825,
    "CMYK_M": 0.07930256426334,
    "CMYK_Y": 0,
    "CMYK_K": 0.38967269659042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01702",
    "Farbtonhilfsbezeichnung": "U0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "194",
    "Bcolor": "216",
    "Y": 54,
    "L": 77.9475402832031,
    "a": -0.19208066165447,
    "b": -13.474383354187,
    "C": 13.4757528305054,
    "h": 269.183288574219,
    "CMY_C": 0.29716455936432,
    "CMY_M": 0.23936682939529,
    "CMY_Y": 0.15365272760391,
    "CMYK_C": 0.16956612467766,
    "CMYK_M": 0.10127533227205,
    "CMYK_Y": 0,
    "CMYK_K": 0.15365272760391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01703",
    "Farbtonhilfsbezeichnung": "C0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "92",
    "Bcolor": "85",
    "Y": 17,
    "L": 47.7125476742978,
    "a": 30.7289993824555,
    "b": 17.5293716112112,
    "C": 35.3772564245857,
    "h": 0.51840845259047,
    "CMY_C": 0.3404921,
    "CMY_M": 0.6410156,
    "CMY_Y": 0.6685618,
    "CMYK_C": 0,
    "CMYK_M": 0.4556785,
    "CMYK_Y": 0.4974462,
    "CMYK_K": 0.3404921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01704",
    "Farbtonhilfsbezeichnung": "ON.00.90",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 84,
    "L": 93.0940475463867,
    "a": 0.54914444684982,
    "b": 0.42636373639107,
    "C": 0.69523066282272,
    "h": 37.8262825012207,
    "CMY_C": 0.07198470830917,
    "CMY_M": 0.07865726947784,
    "CMY_Y": 0.08796262741089,
    "CMYK_C": 0,
    "CMYK_M": 0.00719014136121,
    "CMYK_Y": 0.01721730083227,
    "CMYK_K": 0.07198470830917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01705",
    "Farbtonhilfsbezeichnung": "ON.00.69",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "190",
    "Bcolor": "189",
    "Y": 52,
    "L": 77.0294342041016,
    "a": -0.16673785448074,
    "b": -0.33202433586121,
    "C": 0.37153959274292,
    "h": 243.334854125977,
    "CMY_C": 0.25664383172989,
    "CMY_M": 0.25328290462494,
    "CMY_Y": 0.25767034292221,
    "CMYK_C": 0.00450093764812,
    "CMYK_M": 0,
    "CMYK_Y": 0.00587563682348,
    "CMYK_K": 0.25328290462494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01706",
    "Farbtonhilfsbezeichnung": "G4.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "229",
    "Bcolor": "185",
    "Y": 80,
    "L": 90.8352917764089,
    "a": -2.45764437206114,
    "b": 22.2724807910314,
    "C": 22.4076642345066,
    "h": -1.46089649281083,
    "CMY_C": 0.05606787,
    "CMY_M": 0.1023592,
    "CMY_Y": 0.2758383,
    "CMYK_C": 0,
    "CMYK_M": 0.04904092,
    "CMYK_Y": 0.2328244,
    "CMYK_K": 0.05606787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01707",
    "Farbtonhilfsbezeichnung": "SN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "212",
    "Bcolor": "213",
    "Y": 65,
    "L": 84.369987487793,
    "a": -1.5738537311554,
    "b": -2.46701979637146,
    "C": 2.92629504203796,
    "h": 237.463851928711,
    "CMY_C": 0.19562745094299,
    "CMY_M": 0.1696103811264,
    "CMY_Y": 0.1630882024765,
    "CMYK_C": 0.03888013958931,
    "CMYK_M": 0.00779314944521,
    "CMYK_Y": 0,
    "CMYK_K": 0.1630882024765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01708",
    "Farbtonhilfsbezeichnung": "C8.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "175",
    "Bcolor": "154",
    "Y": 53,
    "L": 77.1463663303716,
    "a": 22.063601451784,
    "b": 19.754101788622,
    "C": 29.6146424340799,
    "h": 0.73022641324304,
    "CMY_C": 0.05238383,
    "CMY_M": 0.3140391,
    "CMY_Y": 0.396555,
    "CMYK_C": 0,
    "CMYK_M": 0.2761195,
    "CMYK_Y": 0.3631968,
    "CMYK_K": 0.05238383
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01709",
    "Farbtonhilfsbezeichnung": "N0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "74",
    "Bcolor": "68",
    "Y": 7,
    "L": 29.31540672685,
    "a": -11.186762862025,
    "b": -0.09499090701152,
    "C": 11.1871661560735,
    "h": 0.00849116274555,
    "CMY_C": 0.8109047,
    "CMY_M": 0.709533,
    "CMY_Y": 0.7320977,
    "CMYK_C": 0.3489956,
    "CMYK_M": 0,
    "CMYK_Y": 0.07768416,
    "CMYK_K": 0.709533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01710",
    "Farbtonhilfsbezeichnung": "N0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "98",
    "Bcolor": "91",
    "Y": 12,
    "L": 38.8276969515281,
    "a": -15.0376182203938,
    "b": -0.16847556470468,
    "C": 15.0385619577878,
    "h": 0.01120313826985,
    "CMY_C": 0.7592877,
    "CMY_M": 0.6141632,
    "CMY_Y": 0.6450729,
    "CMYK_C": 0.3761291,
    "CMYK_M": 0,
    "CMYK_Y": 0.08011062,
    "CMYK_K": 0.6141632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01711",
    "Farbtonhilfsbezeichnung": "N0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "124",
    "Bcolor": "112",
    "Y": 17,
    "L": 47.9729309082031,
    "a": -22.8252086639404,
    "b": 0.22209137678146,
    "C": 22.8262882232666,
    "h": 179.442520141602,
    "CMY_C": 0.75059914588928,
    "CMY_M": 0.5119389295578,
    "CMY_Y": 0.56118619441986,
    "CMYK_C": 0.48899662494659,
    "CMYK_M": 0,
    "CMYK_Y": 0.10090389847755,
    "CMYK_K": 0.5119389295578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01712",
    "Farbtonhilfsbezeichnung": "N0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "101",
    "Bcolor": "90",
    "Y": 12,
    "L": 38.8296625039894,
    "a": -20.5378213999088,
    "b": 0.16632541258063,
    "C": 20.5384948815005,
    "h": -0.00809831643295,
    "CMY_C": 0.8155257,
    "CMY_M": 0.6056915,
    "CMY_Y": 0.6477176,
    "CMYK_C": 0.5321575,
    "CMYK_M": 0,
    "CMYK_Y": 0.1065817,
    "CMYK_K": 0.6056915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01713",
    "Farbtonhilfsbezeichnung": "F6.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "189",
    "Bcolor": "145",
    "Y": 53,
    "L": 77.4890084816306,
    "a": 2.54225452887102,
    "b": 24.2805915487776,
    "C": 24.4133198080092,
    "h": 1.46647328664854,
    "CMY_C": 0.1662147,
    "CMY_M": 0.2606125,
    "CMY_Y": 0.4294984,
    "CMYK_C": 0,
    "CMYK_M": 0.113216,
    "CMYK_Y": 0.3157692,
    "CMYK_K": 0.1662147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01714",
    "Farbtonhilfsbezeichnung": "K2.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "169",
    "Bcolor": "150",
    "Y": 39,
    "L": 67.7355910300588,
    "a": -8.20677250215018,
    "b": 7.40992113364569,
    "C": 11.0570360453829,
    "h": -0.73441676482746,
    "CMY_C": 0.3914742,
    "CMY_M": 0.3368038,
    "CMY_Y": 0.410827,
    "CMYK_C": 0.08243465,
    "CMYK_M": 0,
    "CMYK_Y": 0.1116159,
    "CMYK_K": 0.3368038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01715",
    "Farbtonhilfsbezeichnung": "G0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "207",
    "Bcolor": "193",
    "Y": 62,
    "L": 83.3367462158203,
    "a": -0.11182510852814,
    "b": 7.24998664855957,
    "C": 7.2508487701416,
    "h": 90.883674621582,
    "CMY_C": 0.16352146863937,
    "CMY_M": 0.1869889497757,
    "CMY_Y": 0.24482274055481,
    "CMYK_C": 0,
    "CMYK_M": 0.0280550904572,
    "CMYK_Y": 0.0971946939826,
    "CMYK_K": 0.16352146863937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01716",
    "Farbtonhilfsbezeichnung": "B2.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "183",
    "Bcolor": "180",
    "Y": 51,
    "L": 76.0337652063668,
    "a": 7.65203453622088,
    "b": 3.30391944090807,
    "C": 8.33483750384657,
    "h": 0.40759094914046,
    "CMY_C": 0.198494,
    "CMY_M": 0.2835309,
    "CMY_Y": 0.293124,
    "CMYK_C": 0,
    "CMYK_M": 0.1060964,
    "CMYK_Y": 0.1180652,
    "CMYK_K": 0.198494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01717",
    "Farbtonhilfsbezeichnung": "P0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "209",
    "Bcolor": "205",
    "Y": 63,
    "L": 82.2758370954148,
    "a": -6.48357498192981,
    "b": -0.92862385065621,
    "C": 6.54973944537595,
    "h": 0.14225962530179,
    "CMY_C": 0.2526859,
    "CMY_M": 0.1819949,
    "CMY_Y": 0.1977149,
    "CMYK_C": 0.08641884,
    "CMYK_M": 0,
    "CMYK_Y": 0.01921751,
    "CMYK_K": 0.1819949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01718",
    "Farbtonhilfsbezeichnung": "S0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "224",
    "Bcolor": "235",
    "Y": 72,
    "L": 87.563591003418,
    "a": -6.47378396987915,
    "b": -9.49508953094482,
    "C": 11.4920234680176,
    "h": 235.71369934082,
    "CMY_C": 0.23013442754745,
    "CMY_M": 0.12115687131882,
    "CMY_Y": 0.07702350616455,
    "CMYK_C": 0.16588822007179,
    "CMYK_M": 0.04781634733081,
    "CMYK_Y": 0,
    "CMYK_K": 0.07702350616455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01719",
    "Farbtonhilfsbezeichnung": "S0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "197",
    "Bcolor": "208",
    "Y": 56,
    "L": 78.3189921684433,
    "a": -4.82494542644218,
    "b": -8.5159834859124,
    "C": 9.78785334485954,
    "h": 1.05531652294978,
    "CMY_C": 0.3113742,
    "CMY_M": 0.2265629,
    "CMY_Y": 0.1857204,
    "CMYK_C": 0.1543128,
    "CMYK_M": 0.05015788,
    "CMYK_Y": 0,
    "CMYK_K": 0.1857204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01720",
    "Farbtonhilfsbezeichnung": "S0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "168",
    "Bcolor": "178",
    "Y": 39,
    "L": 67.6656393583223,
    "a": -4.39703441091149,
    "b": -7.96414239425569,
    "C": 9.09733343825104,
    "h": 1.06633924047539,
    "CMY_C": 0.4174975,
    "CMY_M": 0.341458,
    "CMY_Y": 0.3038235,
    "CMYK_C": 0.1632834,
    "CMYK_M": 0.05405889,
    "CMYK_Y": 0,
    "CMYK_K": 0.3038235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01721",
    "Farbtonhilfsbezeichnung": "P0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "195",
    "Bcolor": "192",
    "Y": 52,
    "L": 76.2145386342662,
    "a": -12.4380605146943,
    "b": -3.01008521584212,
    "C": 12.7971075784268,
    "h": 0.23744085842359,
    "CMY_C": 0.3766373,
    "CMY_M": 0.234819,
    "CMY_Y": 0.248794,
    "CMYK_C": 0.1853396,
    "CMYK_M": 0,
    "CMYK_Y": 0.01826357,
    "CMYK_K": 0.234819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01722",
    "Farbtonhilfsbezeichnung": "L0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "145",
    "Bcolor": "131",
    "Y": 28,
    "L": 58.4874150644298,
    "a": -8.50475606818046,
    "b": 4.87331228651819,
    "C": 9.80204307382811,
    "h": -0.52033763403734,
    "CMY_C": 0.4963891,
    "CMY_M": 0.431748,
    "CMY_Y": 0.4869829,
    "CMYK_C": 0.1137544,
    "CMYK_M": 0,
    "CMYK_Y": 0.09720135,
    "CMYK_K": 0.431748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01723",
    "Farbtonhilfsbezeichnung": "ON.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "206",
    "Bcolor": "204",
    "Y": 60,
    "L": 82.4788818359375,
    "a": -0.27842158079147,
    "b": -0.43918877840042,
    "C": 0.52000516653061,
    "h": 237.627548217773,
    "CMY_C": 0.19886040687561,
    "CMY_M": 0.19389480352402,
    "CMY_Y": 0.19824451208115,
    "CMYK_C": 0.00615999428555,
    "CMYK_M": 0,
    "CMYK_Y": 0.00539595633745,
    "CMYK_K": 0.19389480352402
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01725",
    "Farbtonhilfsbezeichnung": "G8.45.80",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "217",
    "Bcolor": "86",
    "Y": 68,
    "L": 84.9785255377042,
    "a": -13.6723338800296,
    "b": 62.5807458442075,
    "C": 64.0568689848661,
    "h": -1.35570100106944,
    "CMY_C": 0.1270766,
    "CMY_M": 0.148737,
    "CMY_Y": 0.661584,
    "CMYK_C": 0,
    "CMYK_M": 0.02481357,
    "CMYK_Y": 0.6123188,
    "CMYK_K": 0.1270766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01726",
    "Farbtonhilfsbezeichnung": "G8.50.60",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "165",
    "Bcolor": "62",
    "Y": 38,
    "L": 66.2611780877516,
    "a": -12.2190130691489,
    "b": 51.5975588889816,
    "C": 53.0246392131616,
    "h": -1.33826620391772,
    "CMY_C": 0.3431765,
    "CMY_M": 0.3514947,
    "CMY_Y": 0.7563862,
    "CMYK_C": 0,
    "CMYK_M": 0.0126643,
    "CMYK_Y": 0.6291032,
    "CMYK_K": 0.3431765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01727",
    "Farbtonhilfsbezeichnung": "D6.25.30",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "83",
    "Bcolor": "66",
    "Y": 12,
    "L": 38.776608700505,
    "a": 12.4356949754911,
    "b": 15.8856135005834,
    "C": 20.1742218143197,
    "h": 0.90661448873272,
    "CMY_C": 0.534971,
    "CMY_M": 0.6729283,
    "CMY_Y": 0.7429678,
    "CMYK_C": 0,
    "CMYK_M": 0.296664,
    "CMYK_Y": 0.447277,
    "CMYK_K": 0.534971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01728",
    "Farbtonhilfsbezeichnung": "T0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "77",
    "Bcolor": "83",
    "Y": 7,
    "L": 32.4766654968262,
    "a": -1.14006757736206,
    "b": -4.99386930465698,
    "C": 5.12235164642334,
    "h": 257.14013671875,
    "CMY_C": 0.72397494316101,
    "CMY_M": 0.6968309879303,
    "CMY_Y": 0.67282378673553,
    "CMYK_C": 0.15634129941463,
    "CMYK_M": 0.07337697595358,
    "CMYK_Y": 0,
    "CMYK_K": 0.67282378673553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01732",
    "Farbtonhilfsbezeichnung": "L8.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "150",
    "Bcolor": "113",
    "Y": 25,
    "L": 56.1303612424151,
    "a": -35.3209301382107,
    "b": 11.2856708782677,
    "C": 37.0801088590762,
    "h": -0.30926560214879,
    "CMY_C": 0.7568675,
    "CMY_M": 0.4115555,
    "CMY_Y": 0.5573038,
    "CMYK_C": 0.5868216,
    "CMYK_M": 0,
    "CMYK_Y": 0.247684,
    "CMYK_K": 0.4115555
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01733",
    "Farbtonhilfsbezeichnung": "Q0.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "150",
    "Bcolor": "158",
    "Y": 27,
    "L": 57.4755272445414,
    "a": -23.2285423575261,
    "b": -12.8838263215721,
    "C": 26.5623447899431,
    "h": 0.50641005328545,
    "CMY_C": 0.7551821,
    "CMY_M": 0.4108118,
    "CMY_Y": 0.3784682,
    "CMYK_C": 0.6061057,
    "CMYK_M": 0.05203851,
    "CMYK_Y": 0,
    "CMYK_K": 0.3784682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01738",
    "Farbtonhilfsbezeichnung": "U0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "81",
    "Bcolor": "100",
    "Y": 7,
    "L": 34.1731147766113,
    "a": 0.32348492741585,
    "b": -13.1965341567993,
    "C": 13.2004985809326,
    "h": 271.404205322266,
    "CMY_C": 0.73043370246887,
    "CMY_M": 0.68168938159943,
    "CMY_Y": 0.6065890789032,
    "CMYK_C": 0.314797103405,
    "CMYK_M": 0.19089531898499,
    "CMYK_Y": 0,
    "CMYK_K": 0.6065890789032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01740",
    "Farbtonhilfsbezeichnung": "J0.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "151",
    "Gcolor": "153",
    "Bcolor": "143",
    "Y": 32,
    "L": 62.8784446716309,
    "a": -2.54354357719421,
    "b": 4.60267114639282,
    "C": 5.25872564315796,
    "h": 118.926063537598,
    "CMY_C": 0.40783834457397,
    "CMY_M": 0.39874744415283,
    "CMY_Y": 0.44012230634689,
    "CMYK_C": 0.01511993631721,
    "CMYK_M": 0,
    "CMYK_Y": 0.06881444901228,
    "CMYK_K": 0.39874744415283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01743",
    "Farbtonhilfsbezeichnung": "G0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "161",
    "Bcolor": "102",
    "Y": 37,
    "L": 66.9362868406611,
    "a": 0.53355721840087,
    "b": 32.9861573153432,
    "C": 32.9904722266577,
    "h": 1.55462255159884,
    "CMY_C": 0.27994,
    "CMY_M": 0.3691973,
    "CMY_Y": 0.5989987,
    "CMYK_C": 0,
    "CMYK_M": 0.1239582,
    "CMYK_Y": 0.4431001,
    "CMYK_K": 0.27994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01744",
    "Farbtonhilfsbezeichnung": "D6.60.50",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "110",
    "Bcolor": "58",
    "Y": 25,
    "L": 57.8053321838379,
    "a": 37.0517616271973,
    "b": 46.1058616638184,
    "C": 59.1488265991211,
    "h": 51.2138175964355,
    "CMY_C": 0.16233056783676,
    "CMY_M": 0.56744647026062,
    "CMY_Y": 0.77303719520569,
    "CMYK_C": 0,
    "CMYK_M": 0.48362264037132,
    "CMYK_Y": 0.72905445098877,
    "CMYK_K": 0.16233056783676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01747",
    "Farbtonhilfsbezeichnung": "A8.20.60",
    "Farbtonklasse": "04",
    "Rcolor": "221",
    "Gcolor": "149",
    "Bcolor": "158",
    "Y": 39,
    "L": 69.1133575439453,
    "a": 28.6280345916748,
    "b": 5.68887138366699,
    "C": 29.1877994537354,
    "h": 11.2392206192017,
    "CMY_C": 0.13197267055511,
    "CMY_M": 0.41441768407822,
    "CMY_Y": 0.37911260128021,
    "CMYK_C": 0,
    "CMYK_M": 0.32538723945618,
    "CMYK_Y": 0.28471446037292,
    "CMYK_K": 0.13197267055511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01748",
    "Farbtonhilfsbezeichnung": "A4.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "195",
    "Bcolor": "196",
    "Y": 60,
    "L": 80.4866760191882,
    "a": 8.53106397743858,
    "b": 1.22093275771185,
    "C": 8.617988708858,
    "h": 0.14215084090534,
    "CMY_C": 0.1492916,
    "CMY_M": 0.2372281,
    "CMY_Y": 0.2305447,
    "CMYK_C": 0,
    "CMYK_M": 0.1033685,
    "CMYK_Y": 0.09551229,
    "CMYK_K": 0.1492916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01752",
    "Farbtonhilfsbezeichnung": "F6.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "114",
    "Bcolor": "106",
    "Y": 18,
    "L": 48.0971690750699,
    "a": 0.63648904562696,
    "b": 4.09856493499023,
    "C": 4.147692470704,
    "h": 1.41673138789613,
    "CMY_C": 0.5362501,
    "CMY_M": 0.5543909,
    "CMY_Y": 0.582593,
    "CMYK_C": 0,
    "CMYK_M": 0.03911775,
    "CMYK_Y": 0.09993099,
    "CMYK_K": 0.5362501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01753",
    "Farbtonhilfsbezeichnung": "J0.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "176",
    "Bcolor": "70",
    "Y": 37,
    "L": 67.2602462768555,
    "a": -28.6983890533447,
    "b": 48.4452857971191,
    "C": 56.3075790405273,
    "h": 120.641975402832,
    "CMY_C": 0.45427983999252,
    "CMY_M": 0.31000119447708,
    "CMY_Y": 0.72438776493073,
    "CMYK_C": 0.20909984409809,
    "CMYK_M": 0,
    "CMYK_Y": 0.60056126117706,
    "CMYK_K": 0.31000119447708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01755",
    "Farbtonhilfsbezeichnung": "L8.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "17",
    "Gcolor": "102",
    "Bcolor": "72",
    "Y": 11,
    "L": 37.8608113742024,
    "a": -31.5931983784441,
    "b": 9.3549334999282,
    "C": 32.9491269166241,
    "h": -0.28788043868877,
    "CMY_C": 0.9344491,
    "CMY_M": 0.6016365,
    "CMY_Y": 0.7160281,
    "CMYK_C": 0.8354495,
    "CMYK_M": 0,
    "CMYK_Y": 0.2871537,
    "CMYK_K": 0.6016365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01757",
    "Farbtonhilfsbezeichnung": "J0.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "115",
    "Bcolor": "85",
    "Y": 18,
    "L": 47.1358916712661,
    "a": -8.52017214298156,
    "b": 15.4276002146126,
    "C": 17.623966117987,
    "h": -1.06621340619021,
    "CMY_C": 0.5792167,
    "CMY_M": 0.5479187,
    "CMY_Y": 0.6673375,
    "CMYK_C": 0.06923079,
    "CMYK_M": 0,
    "CMYK_Y": 0.2641535,
    "CMYK_K": 0.5479187
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01761",
    "Farbtonhilfsbezeichnung": "A0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "83",
    "Bcolor": "86",
    "Y": 9,
    "L": 36.4573860168457,
    "a": 4.58526515960693,
    "b": -0.47528126835823,
    "C": 4.60983180999756,
    "h": 354.082183837891,
    "CMY_C": 0.63546317815781,
    "CMY_M": 0.6728128194809,
    "CMY_Y": 0.66306924819946,
    "CMYK_C": 0,
    "CMYK_M": 0.10245779901743,
    "CMYK_Y": 0.07572916895151,
    "CMYK_K": 0.63546317815781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01762",
    "Farbtonhilfsbezeichnung": "C0.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "80",
    "Bcolor": "75",
    "Y": 11,
    "L": 38.4986249584735,
    "a": 17.2329466822938,
    "b": 9.61359707510863,
    "C": 19.7331117687332,
    "h": 0.50885885073915,
    "CMY_C": 0.521751,
    "CMY_M": 0.6866153,
    "CMY_Y": 0.7051776,
    "CMYK_C": 0,
    "CMYK_M": 0.3447249,
    "CMYK_Y": 0.3835379,
    "CMYK_K": 0.521751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01763",
    "Farbtonhilfsbezeichnung": "H2.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "150",
    "Gcolor": "149",
    "Bcolor": "136",
    "Y": 31,
    "L": 61.4446734883088,
    "a": -1.52961513198502,
    "b": 6.22038064002826,
    "C": 6.40568948348543,
    "h": -1.32967662678269,
    "CMY_C": 0.4105641,
    "CMY_M": 0.4161366,
    "CMY_Y": 0.4655731,
    "CMYK_C": 0,
    "CMYK_M": 0.009453868,
    "CMYK_Y": 0.09332481,
    "CMYK_K": 0.4105641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01764",
    "Farbtonhilfsbezeichnung": "P0.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "114",
    "Bcolor": "112",
    "Y": 15,
    "L": 45.9519081115723,
    "a": -10.0458517074585,
    "b": -2.49425935745239,
    "C": 10.3508682250977,
    "h": 193.94384765625,
    "CMY_C": 0.65820837020874,
    "CMY_M": 0.55292171239853,
    "CMY_Y": 0.56176501512527,
    "CMYK_C": 0.23549938201904,
    "CMYK_M": 0,
    "CMYK_Y": 0.01978021115065,
    "CMYK_K": 0.55292171239853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01767",
    "Farbtonhilfsbezeichnung": "F6.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "111",
    "Bcolor": "97",
    "Y": 17,
    "L": 47.3141830607561,
    "a": 0.90374041205681,
    "b": 8.82388824963614,
    "C": 8.87004794657003,
    "h": 1.46873246249989,
    "CMY_C": 0.5303098,
    "CMY_M": 0.5636815,
    "CMY_Y": 0.6208501,
    "CMYK_C": 0,
    "CMYK_M": 0.07105037,
    "CMYK_Y": 0.1927661,
    "CMYK_K": 0.5303098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01768",
    "Farbtonhilfsbezeichnung": "ON.00.21",
    "Farbtonklasse": "02",
    "Rcolor": "70",
    "Gcolor": "71",
    "Bcolor": "71",
    "Y": 7,
    "L": 29.9603642246431,
    "a": -0.05469389625412,
    "b": -0.44725060853773,
    "C": 0.45058243321819,
    "h": 1.44911136246096,
    "CMY_C": 0.7249546,
    "CMY_M": 0.7229307,
    "CMY_Y": 0.7230507,
    "CMYK_C": 0.007304674,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004331198,
    "CMYK_K": 0.7229307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01769",
    "Farbtonhilfsbezeichnung": "LN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "214",
    "Bcolor": "207",
    "Y": 64,
    "L": 84.7637405395508,
    "a": -3.24419593811035,
    "b": 1.46604585647583,
    "C": 3.56006979942322,
    "h": 155.681884765625,
    "CMY_C": 0.19075793027878,
    "CMY_M": 0.16256844997406,
    "CMY_Y": 0.18770110607147,
    "CMYK_C": 0.03366183117032,
    "CMYK_M": 0,
    "CMYK_Y": 0.0300115942955,
    "CMYK_K": 0.16256844997406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01776",
    "Farbtonhilfsbezeichnung": "D2.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "72",
    "Bcolor": "48",
    "Y": 12,
    "L": 39.0460002867165,
    "a": 28.0370412862007,
    "b": 27.7245859939228,
    "C": 39.4300437815956,
    "h": 0.7797948114617,
    "CMY_C": 0.4394285,
    "CMY_M": 0.717501,
    "CMY_Y": 0.8134069,
    "CMYK_C": 0,
    "CMYK_M": 0.4960518,
    "CMYK_Y": 0.6671377,
    "CMYK_K": 0.4394285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01777",
    "Farbtonhilfsbezeichnung": "G8.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "117",
    "Bcolor": "73",
    "Y": 18,
    "L": 48.4690961533605,
    "a": -6.44381285212869,
    "b": 24.4664203781951,
    "C": 25.3007598738817,
    "h": -1.31327074877187,
    "CMY_C": 0.5337409,
    "CMY_M": 0.5402699,
    "CMY_Y": 0.715525,
    "CMYK_C": 0,
    "CMYK_M": 0.01400289,
    "CMYK_Y": 0.389878,
    "CMYK_K": 0.5337409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01778",
    "Farbtonhilfsbezeichnung": "G8.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "140",
    "Bcolor": "73",
    "Y": 26,
    "L": 57.6340942610816,
    "a": -6.68312993416098,
    "b": 36.203430463194,
    "C": 36.8151137852404,
    "h": -1.3882519744117,
    "CMY_C": 0.4214487,
    "CMY_M": 0.4497896,
    "CMY_Y": 0.7140805,
    "CMYK_C": 0,
    "CMYK_M": 0.0489859,
    "CMYK_Y": 0.505801,
    "CMYK_K": 0.4214487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01779",
    "Farbtonhilfsbezeichnung": "G8.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "165",
    "Bcolor": "83",
    "Y": 37,
    "L": 66.6248020308721,
    "a": -8.36423106020162,
    "b": 42.2036581519042,
    "C": 43.0245176920233,
    "h": -1.37514430813567,
    "CMY_C": 0.3266313,
    "CMY_M": 0.3544543,
    "CMY_Y": 0.6737711,
    "CMYK_C": 0,
    "CMYK_M": 0.04131921,
    "CMYK_Y": 0.5155272,
    "CMYK_K": 0.3266313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01780",
    "Farbtonhilfsbezeichnung": "HN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "223",
    "Bcolor": "213",
    "Y": 73.3845062255859,
    "L": 88.6307754516602,
    "a": -1.17047524452209,
    "b": 4.01241493225098,
    "C": 4.17965126037598,
    "h": 106.262672424316,
    "CMY_C": 0.12328308820724,
    "CMY_M": 0.12533760070801,
    "CMY_Y": 0.16393733024597,
    "CMYK_C": 0,
    "CMYK_M": 0.00234341598116,
    "CMYK_Y": 0.04637100175023,
    "CMYK_K": 0.12328308820724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01784",
    "Farbtonhilfsbezeichnung": "T0.46.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "74",
    "Bcolor": "108",
    "Y": 8,
    "L": 28.5540599326279,
    "a": -9.2885714137059,
    "b": -27.109784271374,
    "C": 28.6569007770895,
    "h": 1.24070401835408,
    "CMY_C": 1,
    "CMY_M": 0.7114866,
    "CMY_Y": 0.5762007,
    "CMYK_C": 1,
    "CMYK_M": 0.3192215,
    "CMYK_Y": 0,
    "CMYK_K": 0.5762007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01785",
    "Farbtonhilfsbezeichnung": "D2.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "131",
    "Bcolor": "121",
    "Y": 26,
    "L": 56.8745950362736,
    "a": 8.30554254714066,
    "b": 8.32039660848314,
    "C": 11.756319012549,
    "h": 0.78629159006352,
    "CMY_C": 0.3863773,
    "CMY_M": 0.4854681,
    "CMY_Y": 0.5239388,
    "CMYK_C": 0,
    "CMYK_M": 0.1614849,
    "CMYK_Y": 0.2241793,
    "CMYK_K": 0.3863773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01787",
    "Farbtonhilfsbezeichnung": "E4.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "236",
    "Gcolor": "141",
    "Bcolor": "50",
    "Y": 37,
    "L": 67.4353159037398,
    "a": 29.9013009103763,
    "b": 60.232293390425,
    "C": 67.2459438420126,
    "h": 1.11000634997809,
    "CMY_C": 0.07309517,
    "CMY_M": 0.4466315,
    "CMY_Y": 0.8037091,
    "CMYK_C": 0,
    "CMYK_M": 0.4029932,
    "CMYK_Y": 0.7882298,
    "CMYK_K": 0.07309517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01788",
    "Farbtonhilfsbezeichnung": "C8.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "69",
    "Bcolor": "63",
    "Y": 8,
    "L": 30.5777408956019,
    "a": 5.94970977154069,
    "b": 5.64233934725215,
    "C": 8.1996975355873,
    "h": 0.75888875023434,
    "CMY_C": 0.6685942,
    "CMY_M": 0.7309703,
    "CMY_Y": 0.7533717,
    "CMYK_C": 0,
    "CMYK_M": 0.1882168,
    "CMYK_Y": 0.2558118,
    "CMYK_K": 0.6685942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01790",
    "Farbtonhilfsbezeichnung": "E0.45.55",
    "Farbtonklasse": "04",
    "Rcolor": "211",
    "Gcolor": "132",
    "Bcolor": "76",
    "Y": 31,
    "L": 62.4692420959473,
    "a": 25.4979267120361,
    "b": 41.7962608337402,
    "C": 48.9598999023438,
    "h": 58.6146011352539,
    "CMY_C": 0.1720529794693,
    "CMY_M": 0.48150616884232,
    "CMY_Y": 0.70037496089935,
    "CMYK_C": 0,
    "CMYK_M": 0.37375965714455,
    "CMYK_Y": 0.63811087608337,
    "CMYK_K": 0.1720529794693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01791",
    "Farbtonhilfsbezeichnung": "E0.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "94",
    "Bcolor": "42",
    "Y": 18,
    "L": 47.904306927172,
    "a": 27.4711383300274,
    "b": 41.7194224162294,
    "C": 49.9517131627263,
    "h": 0.98848731383652,
    "CMY_C": 0.3312658,
    "CMY_M": 0.6327003,
    "CMY_Y": 0.8354011,
    "CMYK_C": 0,
    "CMYK_M": 0.4507537,
    "CMYK_Y": 0.7538649,
    "CMYK_K": 0.3312658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01792",
    "Farbtonhilfsbezeichnung": "C0.45.20",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "43",
    "Bcolor": "43",
    "Y": 7,
    "L": 28.0197976954466,
    "a": 31.0438438718932,
    "b": 15.9504738358473,
    "C": 34.9018317274399,
    "h": 0.47463030414642,
    "CMY_C": 0.5556242,
    "CMY_M": 0.8296802,
    "CMY_Y": 0.8322175,
    "CMYK_C": 0,
    "CMYK_M": 0.6167213,
    "CMYK_Y": 0.6224309,
    "CMYK_K": 0.5556242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01800",
    "Farbtonhilfsbezeichnung": "L0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "77",
    "Bcolor": "57",
    "Y": 7,
    "L": 30.3417574214828,
    "a": -14.1136098066092,
    "b": 8.44194960874123,
    "C": 16.4456831712684,
    "h": -0.53905255933477,
    "CMY_C": 0.7945662,
    "CMY_M": 0.6972323,
    "CMY_Y": 0.7750264,
    "CMYK_C": 0.3214805,
    "CMYK_M": 0,
    "CMYK_Y": 0.2569431,
    "CMYK_K": 0.6972323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01803",
    "Farbtonhilfsbezeichnung": "E8.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "135",
    "Bcolor": "119",
    "Y": 26,
    "L": 57.1926381687859,
    "a": 3.30919130695911,
    "b": 10.3477064797665,
    "C": 10.863966885878,
    "h": 1.26127527325129,
    "CMY_C": 0.4106818,
    "CMY_M": 0.471134,
    "CMY_Y": 0.5352396,
    "CMYK_C": 0,
    "CMYK_M": 0.1025799,
    "CMYK_Y": 0.2113592,
    "CMYK_K": 0.4106818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01804",
    "Farbtonhilfsbezeichnung": "P0.45.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "80",
    "Bcolor": "79",
    "Y": 7,
    "L": 30.0450555469517,
    "a": -21.3158351722635,
    "b": -6.2884162955651,
    "C": 22.2240637282527,
    "h": 0.28687391965837,
    "CMY_C": 1,
    "CMY_M": 0.6867696,
    "CMY_Y": 0.6890983,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.007434534,
    "CMYK_K": 0.6867696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01805",
    "Farbtonhilfsbezeichnung": "K2.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "197",
    "Bcolor": "155",
    "Y": 52,
    "L": 76.3019834445525,
    "a": -18.7819914029497,
    "b": 16.9522726004455,
    "C": 25.3010424168707,
    "h": -0.73423935786565,
    "CMY_C": 0.3561451,
    "CMY_M": 0.2259938,
    "CMY_Y": 0.3921345,
    "CMYK_C": 0.1681528,
    "CMYK_M": 0,
    "CMYK_Y": 0.2146504,
    "CMYK_K": 0.2259938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01806",
    "Farbtonhilfsbezeichnung": "F6.10.30",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "91",
    "Bcolor": "80",
    "Y": 12,
    "L": 38.8610790294748,
    "a": 0.42658992155433,
    "b": 6.5008143221279,
    "C": 6.51479591483532,
    "h": 1.50526927703132,
    "CMY_C": 0.6212609,
    "CMY_M": 0.6432922,
    "CMY_Y": 0.6848981,
    "CMYK_C": 0,
    "CMYK_M": 0.05817011,
    "CMYK_Y": 0.1680238,
    "CMYK_K": 0.6212609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01807",
    "Farbtonhilfsbezeichnung": "F8.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "188",
    "Bcolor": "102",
    "Y": 53,
    "L": 77.44947267375,
    "a": 2.18995227741275,
    "b": 46.9266192481067,
    "C": 46.9776913548775,
    "h": 1.52416257007936,
    "CMY_C": 0.1299694,
    "CMY_M": 0.2641256,
    "CMY_Y": 0.6004939,
    "CMYK_C": 0,
    "CMYK_M": 0.1541971,
    "CMYK_Y": 0.5408137,
    "CMYK_K": 0.1299694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01811",
    "Farbtonhilfsbezeichnung": "L0.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "171",
    "Bcolor": "139",
    "Y": 37,
    "L": 66.5088018026877,
    "a": -19.3532746091793,
    "b": 11.8036582898553,
    "C": 22.6688241230544,
    "h": -0.54767074897438,
    "CMY_C": 0.4798889,
    "CMY_M": 0.3289435,
    "CMY_Y": 0.4556569,
    "CMYK_C": 0.2249369,
    "CMYK_M": 0,
    "CMYK_Y": 0.1888267,
    "CMYK_K": 0.3289435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01813",
    "Farbtonhilfsbezeichnung": "R0.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "175",
    "Bcolor": "196",
    "Y": 38,
    "L": 67.5167043336062,
    "a": -18.5309629238432,
    "b": -18.5491362852212,
    "C": 26.2195927468861,
    "h": 0.78588827427391,
    "CMY_C": 0.6225195,
    "CMY_M": 0.3117831,
    "CMY_Y": 0.2329147,
    "CMYK_C": 0.5079029,
    "CMYK_M": 0.1028156,
    "CMYK_Y": 0,
    "CMYK_K": 0.2329147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01814",
    "Farbtonhilfsbezeichnung": "E0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "101",
    "Bcolor": "60",
    "Y": 17,
    "L": 48.9724273681641,
    "a": 22.3012771606445,
    "b": 33.3672409057617,
    "C": 40.1337738037109,
    "h": 56.2428779602051,
    "CMY_C": 0.3525652885437,
    "CMY_M": 0.6052964925766,
    "CMY_Y": 0.76569253206253,
    "CMYK_C": 0,
    "CMYK_M": 0.39035782217979,
    "CMYK_Y": 0.63809871673584,
    "CMYK_K": 0.3525652885437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01815",
    "Farbtonhilfsbezeichnung": "V0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "97",
    "Bcolor": "140",
    "Y": 12,
    "L": 41.5275192260742,
    "a": 5.95896911621094,
    "b": -26.0785388946533,
    "C": 26.7506923675537,
    "h": 282.871154785156,
    "CMY_C": 0.6801084280014,
    "CMY_M": 0.61979591846466,
    "CMY_Y": 0.45247274637222,
    "CMYK_C": 0.41575223207474,
    "CMYK_M": 0.3055979013443,
    "CMYK_Y": 0,
    "CMYK_K": 0.45247274637222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01817",
    "Farbtonhilfsbezeichnung": "UN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 82.9616775512695,
    "L": 92.9976577758789,
    "a": 0.11277080327272,
    "b": -0.01339441910386,
    "C": 0.11356348544359,
    "h": 353.226379394531,
    "CMY_C": 0.07805103063583,
    "CMY_M": 0.07856726646423,
    "CMY_Y": 0.08582359552383,
    "CMYK_C": 0,
    "CMYK_M": 0.00055993971182,
    "CMYK_Y": 0.00843058060855,
    "CMYK_K": 0.07805103063583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01820",
    "Farbtonhilfsbezeichnung": "X0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "86",
    "Bcolor": "103",
    "Y": 11,
    "L": 38.3967904328692,
    "a": 8.59250519763965,
    "b": -8.55475366925085,
    "C": 12.1249724087532,
    "h": -0.7831965597658,
    "CMY_C": 0.6147732,
    "CMY_M": 0.6613404,
    "CMY_Y": 0.594153,
    "CMYK_C": 0.05080782,
    "CMYK_M": 0.1655485,
    "CMYK_Y": 0,
    "CMYK_K": 0.594153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01821",
    "Farbtonhilfsbezeichnung": "X0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "111",
    "Bcolor": "131",
    "Y": 18,
    "L": 48.7702212968926,
    "a": 9.55069277805692,
    "b": -9.58848173834228,
    "C": 13.5334664660372,
    "h": -0.78737259082888,
    "CMY_C": 0.5101175,
    "CMY_M": 0.5639423,
    "CMY_Y": 0.4857684,
    "CMYK_C": 0.04735044,
    "CMYK_M": 0.1520207,
    "CMYK_Y": 0,
    "CMYK_K": 0.4857684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01822",
    "Farbtonhilfsbezeichnung": "A0.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "122",
    "Bcolor": "140",
    "Y": 27,
    "L": 58.3574738768438,
    "a": 28.0964118224967,
    "b": -0.08041608093958,
    "C": 28.0965269036123,
    "h": -0.00286213990107,
    "CMY_C": 0.2678138,
    "CMY_M": 0.5217664,
    "CMY_Y": 0.4498151,
    "CMYK_C": 0,
    "CMYK_M": 0.3468415,
    "CMYK_Y": 0.2485724,
    "CMYK_K": 0.2678138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01823",
    "Farbtonhilfsbezeichnung": "E4.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "69",
    "Bcolor": "54",
    "Y": 8,
    "L": 30.5236195854221,
    "a": 4.29385097940557,
    "b": 11.2667958159378,
    "C": 12.0572734974113,
    "h": 1.20668264592442,
    "CMY_C": 0.6679384,
    "CMY_M": 0.7290321,
    "CMY_Y": 0.7880959,
    "CMYK_C": 0,
    "CMYK_M": 0.1839833,
    "CMYK_Y": 0.3618532,
    "CMYK_K": 0.6679384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01830",
    "Farbtonhilfsbezeichnung": "D6.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "129",
    "Gcolor": "90",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.8621139526367,
    "a": 13.9057683944702,
    "b": 16.1088886260986,
    "C": 21.2806644439697,
    "h": 49.1980667114258,
    "CMY_C": 0.49489557743073,
    "CMY_M": 0.64762532711029,
    "CMY_Y": 0.71637892723083,
    "CMYK_C": 0,
    "CMYK_M": 0.30237263441086,
    "CMYK_Y": 0.43849021196365,
    "CMYK_K": 0.49489557743073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01835",
    "Farbtonhilfsbezeichnung": "S6.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "183",
    "Bcolor": "204",
    "Y": 45,
    "L": 72.7368316650391,
    "a": -5.2612829208374,
    "b": -14.8252210617065,
    "C": 15.7311248779297,
    "h": 250.460861206055,
    "CMY_C": 0.40288954973221,
    "CMY_M": 0.28371810913086,
    "CMY_Y": 0.20140796899796,
    "CMYK_C": 0.25229600071907,
    "CMYK_M": 0.10306907445192,
    "CMYK_Y": 0,
    "CMYK_K": 0.20140796899796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01836",
    "Farbtonhilfsbezeichnung": "D2.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "59",
    "Bcolor": "53",
    "Y": 5,
    "L": 26.6110111265741,
    "a": 7.61032509996906,
    "b": 6.23988734407982,
    "C": 9.8414044827975,
    "h": 0.68677213735154,
    "CMY_C": 0.6954705,
    "CMY_M": 0.7700068,
    "CMY_Y": 0.7911748,
    "CMYK_C": 0,
    "CMYK_M": 0.2447591,
    "CMYK_Y": 0.3142695,
    "CMYK_K": 0.6954705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01838",
    "Farbtonhilfsbezeichnung": "P0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "105",
    "Bcolor": "104",
    "Y": 12,
    "L": 41.2329254150391,
    "a": -17.0980014801025,
    "b": -4.71859741210938,
    "C": 17.7371597290039,
    "h": 195.428100585938,
    "CMY_C": 0.78217232227325,
    "CMY_M": 0.58653223514557,
    "CMY_Y": 0.59369802474976,
    "CMYK_C": 0.47316890954971,
    "CMYK_M": 0,
    "CMYK_Y": 0.0173309519887,
    "CMYK_K": 0.58653223514557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01839",
    "Farbtonhilfsbezeichnung": "C8.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "63",
    "Bcolor": "57",
    "Y": 7,
    "L": 29.6120863785442,
    "a": 10.8557069917764,
    "b": 8.42417975394822,
    "C": 13.7409307842713,
    "h": 0.65994321095127,
    "CMY_C": 0.6460322,
    "CMY_M": 0.7513483,
    "CMY_Y": 0.7777846,
    "CMYK_C": 0,
    "CMYK_M": 0.2975304,
    "CMYK_Y": 0.3722159,
    "CMYK_K": 0.6460322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01840",
    "Farbtonhilfsbezeichnung": "G4.50.80",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "211",
    "Bcolor": "79",
    "Y": 65,
    "L": 84.166814450031,
    "a": -6.32436172030731,
    "b": 65.0480474334989,
    "C": 65.3547704921379,
    "h": -1.47387495263011,
    "CMY_C": 0.08403546,
    "CMY_M": 0.17403,
    "CMY_Y": 0.6904391,
    "CMYK_C": 0,
    "CMYK_M": 0.09825108,
    "CMYK_Y": 0.6620383,
    "CMYK_K": 0.08403546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01845",
    "Farbtonhilfsbezeichnung": "L8.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "204",
    "Bcolor": "162",
    "Y": 51,
    "L": 75.6759400984399,
    "a": -37.0485783467429,
    "b": 11.8941510158477,
    "C": 38.9110265336516,
    "h": -0.31064790135512,
    "CMY_C": 0.5619302,
    "CMY_M": 0.1988255,
    "CMY_Y": 0.3645913,
    "CMYK_C": 0.4532155,
    "CMYK_M": 0,
    "CMYK_Y": 0.2069035,
    "CMYK_K": 0.1988255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01848",
    "Farbtonhilfsbezeichnung": "T2.47.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "82",
    "Bcolor": "125",
    "Y": 9,
    "L": 32.6221023399274,
    "a": -6.75102065846681,
    "b": -31.3861856948184,
    "C": 32.1040329616182,
    "h": 1.35892909041575,
    "CMY_C": 1,
    "CMY_M": 0.6766535,
    "CMY_Y": 0.5095036,
    "CMYK_C": 1,
    "CMYK_M": 0.3407771,
    "CMYK_Y": 0,
    "CMYK_K": 0.5095036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01852",
    "Farbtonhilfsbezeichnung": "S5.44.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "131",
    "Y": 11,
    "L": 38.1057037263698,
    "a": -11.7406736946101,
    "b": -26.413287467501,
    "C": 28.9051063593295,
    "h": 1.15252663653713,
    "CMY_C": 1,
    "CMY_M": 0.6188166,
    "CMY_Y": 0.4861996,
    "CMYK_C": 1,
    "CMYK_M": 0.2581099,
    "CMYK_Y": 0,
    "CMYK_K": 0.4861996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01854",
    "Farbtonhilfsbezeichnung": "M2.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "157",
    "Bcolor": "123",
    "Y": 27,
    "L": 58.0896451662418,
    "a": -39.4393012856628,
    "b": 8.46163991178925,
    "C": 40.336804978804,
    "h": -0.21134449526559,
    "CMY_C": 0.8279979,
    "CMY_M": 0.384428,
    "CMY_Y": 0.5191849,
    "CMYK_C": 0.7205816,
    "CMYK_M": 0,
    "CMYK_Y": 0.2189133,
    "CMYK_K": 0.384428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01859",
    "Farbtonhilfsbezeichnung": "W0.25.50",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "134",
    "Bcolor": "189",
    "Y": 26,
    "L": 58.6554908752441,
    "a": 15.5995121002197,
    "b": -28.1852130889893,
    "C": 32.2141418457031,
    "h": 298.962951660156,
    "CMY_C": 0.43806678056717,
    "CMY_M": 0.47360676527023,
    "CMY_Y": 0.25843966007233,
    "CMYK_C": 0.24222859740257,
    "CMYK_M": 0.29015454649925,
    "CMYK_Y": 0,
    "CMYK_K": 0.25843966007233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01861",
    "Farbtonhilfsbezeichnung": "F2.30.50",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "135",
    "Bcolor": "89",
    "Y": 27,
    "L": 58.143245629449,
    "a": 5.31391661084696,
    "b": 28.5931085452291,
    "C": 29.0827021788948,
    "h": 1.38704662119011,
    "CMY_C": 0.3529895,
    "CMY_M": 0.4696851,
    "CMY_Y": 0.6511669,
    "CMYK_C": 0,
    "CMYK_M": 0.1803613,
    "CMYK_Y": 0.460854,
    "CMYK_K": 0.3529895
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01865",
    "Farbtonhilfsbezeichnung": "R0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "156",
    "Y": 18,
    "L": 49.0733323098748,
    "a": -25.0862692561276,
    "b": -24.5332751373371,
    "C": 35.0884951822562,
    "h": 0.77425394124532,
    "CMY_C": 1,
    "CMY_M": 0.4904877,
    "CMY_Y": 0.3874285,
    "CMYK_C": 1,
    "CMYK_M": 0.1682403,
    "CMYK_Y": 0,
    "CMYK_K": 0.3874285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01871",
    "Farbtonhilfsbezeichnung": "B6.30.60",
    "Farbtonklasse": "04",
    "Rcolor": "232",
    "Gcolor": "136",
    "Bcolor": "132",
    "Y": 37,
    "L": 66.8276205703153,
    "a": 36.7222072112617,
    "b": 17.4216962697539,
    "C": 40.6452457660474,
    "h": 0.44297381788309,
    "CMY_C": 0.08922146,
    "CMY_M": 0.467687,
    "CMY_Y": 0.4820923,
    "CMYK_C": 0,
    "CMYK_M": 0.4155407,
    "CMYK_Y": 0.4313572,
    "CMYK_K": 0.08922146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01874",
    "Farbtonhilfsbezeichnung": "C4.40.20",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "56",
    "Bcolor": "48",
    "Y": 7,
    "L": 31.6417832411994,
    "a": 27.1858365574782,
    "b": 17.2107025802851,
    "C": 32.1757360853943,
    "h": 0.56438575885339,
    "CMY_C": 0.5335779,
    "CMY_M": 0.7818395,
    "CMY_Y": 0.8102866,
    "CMYK_C": 0,
    "CMYK_M": 0.5322682,
    "CMYK_Y": 0.5932582,
    "CMYK_K": 0.5335779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01878",
    "Farbtonhilfsbezeichnung": "K4.20.45",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "126",
    "Bcolor": "100",
    "Y": 20,
    "L": 50.4216143244716,
    "a": -13.9961889260282,
    "b": 11.1661845491948,
    "C": 17.9046636896578,
    "h": -0.67339913098371,
    "CMY_C": 0.5985905,
    "CMY_M": 0.5044856,
    "CMY_Y": 0.6088421,
    "CMYK_C": 0.1899135,
    "CMYK_M": 0,
    "CMYK_Y": 0.2106025,
    "CMYK_K": 0.5044856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01879",
    "Farbtonhilfsbezeichnung": "R0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "149",
    "Bcolor": "166",
    "Y": 26,
    "L": 57.6060269649457,
    "a": -18.5623816725161,
    "b": -16.855993375061,
    "C": 25.0736221160059,
    "h": 0.73725733581428,
    "CMY_C": 0.7201792,
    "CMY_M": 0.416243,
    "CMY_Y": 0.3497403,
    "CMYK_C": 0.5696784,
    "CMYK_M": 0.1022709,
    "CMYK_Y": 0,
    "CMYK_K": 0.3497403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01880",
    "Farbtonhilfsbezeichnung": "E8.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "108",
    "Bcolor": "71",
    "Y": 18,
    "L": 47.6943036379262,
    "a": 7.63316254697777,
    "b": 24.6999452384222,
    "C": 25.8525137123963,
    "h": 1.27107073774756,
    "CMY_C": 0.4565086,
    "CMY_M": 0.5779766,
    "CMY_Y": 0.7212591,
    "CMYK_C": 0,
    "CMYK_M": 0.2234957,
    "CMYK_Y": 0.4871292,
    "CMYK_K": 0.4565086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01881",
    "Farbtonhilfsbezeichnung": "G0.60.70",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "188",
    "Bcolor": "45",
    "Y": 51,
    "L": 77.3942565917969,
    "a": -0.20878095924854,
    "b": 70.5764312744141,
    "C": 70.5767364501953,
    "h": 90.1694946289062,
    "CMY_C": 0.11955749988556,
    "CMY_M": 0.26174306869507,
    "CMY_Y": 0.82457679510117,
    "CMYK_C": 0,
    "CMYK_M": 0.1614933013916,
    "CMYK_Y": 0.80075562000275,
    "CMYK_K": 0.11955749988556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01882",
    "Farbtonhilfsbezeichnung": "D2.35.25",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "82",
    "Bcolor": "67",
    "Y": 10,
    "L": 39.4940414428711,
    "a": 17.266809463501,
    "b": 16.0082206726074,
    "C": 23.5458240509033,
    "h": 42.8338890075684,
    "CMY_C": 0.50166356563568,
    "CMY_M": 0.67871606349945,
    "CMY_Y": 0.73640596866608,
    "CMYK_C": 0,
    "CMYK_M": 0.35528707504272,
    "CMYK_Y": 0.47105205059052,
    "CMYK_K": 0.50166356563568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01884",
    "Farbtonhilfsbezeichnung": "M2.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "178",
    "Bcolor": "146",
    "Y": 37,
    "L": 66.6631149148969,
    "a": -32.7802719665238,
    "b": 7.98361928843483,
    "C": 33.7384707291533,
    "h": -0.23889846348891,
    "CMY_C": 0.6293894,
    "CMY_M": 0.3031588,
    "CMY_Y": 0.4289984,
    "CMYK_C": 0.4681564,
    "CMYK_M": 0,
    "CMYK_Y": 0.1805859,
    "CMYK_K": 0.3031588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01885",
    "Farbtonhilfsbezeichnung": "D6.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "66",
    "Bcolor": "55",
    "Y": 7,
    "L": 29.8700885194019,
    "a": 7.27839661849802,
    "b": 9.54483318999357,
    "C": 12.0032869648678,
    "h": 0.91931253803056,
    "CMY_C": 0.6607543,
    "CMY_M": 0.7410296,
    "CMY_Y": 0.7828405,
    "CMYK_C": 0,
    "CMYK_M": 0.2366288,
    "CMYK_Y": 0.3598756,
    "CMYK_K": 0.6607543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01887",
    "Farbtonhilfsbezeichnung": "G8.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "69",
    "Bcolor": "51",
    "Y": 7,
    "L": 29.1717391743758,
    "a": -2.41658085038232,
    "b": 11.1221505791396,
    "C": 11.3816561409792,
    "h": -1.35684536392619,
    "CMY_C": 0.7192104,
    "CMY_M": 0.7279191,
    "CMY_Y": 0.7998809,
    "CMYK_C": 0,
    "CMYK_M": 0.03101505,
    "CMYK_Y": 0.2872988,
    "CMYK_K": 0.7192104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01888",
    "Farbtonhilfsbezeichnung": "G8.50.70",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "191",
    "Bcolor": "69",
    "Y": 50,
    "L": 75.6627956022265,
    "a": -12.3782064844902,
    "b": 59.1691923334265,
    "C": 60.4500894719164,
    "h": -1.36457028049238,
    "CMY_C": 0.229651,
    "CMY_M": 0.2523344,
    "CMY_Y": 0.7281821,
    "CMYK_C": 0,
    "CMYK_M": 0.029445699999999998,
    "CMYK_Y": 0.6471496,
    "CMYK_K": 0.229651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01890",
    "Farbtonhilfsbezeichnung": "H2.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "131",
    "Gcolor": "131",
    "Bcolor": "121",
    "Y": 23,
    "L": 54.5549555439993,
    "a": -1.93565350249825,
    "b": 4.73634977152568,
    "C": 5.11661642493994,
    "h": -1.18282928338207,
    "CMY_C": 0.4878477,
    "CMY_M": 0.4850121,
    "CMY_Y": 0.5242237,
    "CMYK_C": 0.005506303,
    "CMYK_M": 0,
    "CMYK_Y": 0.07614107,
    "CMYK_K": 0.4850121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01891",
    "Farbtonhilfsbezeichnung": "D2.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "84",
    "Bcolor": "66",
    "Y": 12,
    "L": 41.7529296875,
    "a": 22.03049659729,
    "b": 19.8395519256592,
    "C": 29.6471004486084,
    "h": 42.0046005249023,
    "CMY_C": 0.44796586036682,
    "CMY_M": 0.67158341407776,
    "CMY_Y": 0.73969751596451,
    "CMYK_C": 0,
    "CMYK_M": 0.405079215765,
    "CMYK_Y": 0.52846670150757,
    "CMYK_K": 0.44796586036682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01892",
    "Farbtonhilfsbezeichnung": "G4.40.80",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "218",
    "Bcolor": "110",
    "Y": 73,
    "L": 86.8012924194336,
    "a": -6.18018817901611,
    "b": 54.492561340332,
    "C": 54.8418998718262,
    "h": 96.4704666137695,
    "CMY_C": 0.0658785700798,
    "CMY_M": 0.14413112401962,
    "CMY_Y": 0.56920969486237,
    "CMYK_C": 0,
    "CMYK_M": 0.08377128839493,
    "CMYK_Y": 0.53882837295532,
    "CMYK_K": 0.0658785700798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01893",
    "Farbtonhilfsbezeichnung": "C8.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "172",
    "Bcolor": "166",
    "Y": 44,
    "L": 71.6467282405204,
    "a": 5.45601295546061,
    "b": 4.61688982268351,
    "C": 7.14728962649147,
    "h": 0.70228507277495,
    "CMY_C": 0.2579623,
    "CMY_M": 0.3252092,
    "CMY_Y": 0.3488539,
    "CMYK_C": 0,
    "CMYK_M": 0.09062465,
    "CMYK_Y": 0.1224893,
    "CMYK_K": 0.2579623
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01895",
    "Farbtonhilfsbezeichnung": "ON.00.10",
    "Farbtonklasse": "02",
    "Rcolor": "65",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 4,
    "L": 27.5078544616699,
    "a": 0.17199710011482,
    "b": 0.11326048523188,
    "C": 0.20593915879726,
    "h": 33.3649978637695,
    "CMY_C": 0.74390745162964,
    "CMY_M": 0.74546837806702,
    "CMY_Y": 0.7481894493103,
    "CMYK_C": 0,
    "CMYK_M": 0.0060951653868,
    "CMYK_Y": 0.01672050915658,
    "CMYK_K": 0.74390745162964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01896",
    "Farbtonhilfsbezeichnung": "A0.05.15",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "70",
    "Bcolor": "71",
    "Y": 5,
    "L": 30.1589050292969,
    "a": 2.95354652404785,
    "b": -0.05173833668232,
    "C": 2.95399975776672,
    "h": 358.996429443359,
    "CMY_C": 0.70311450958252,
    "CMY_M": 0.72715795040131,
    "CMY_Y": 0.72330057621002,
    "CMYK_C": 0,
    "CMYK_M": 0.0809855684638,
    "CMYK_Y": 0.06799276918173,
    "CMYK_K": 0.70311450958252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01897",
    "Farbtonhilfsbezeichnung": "A0.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "100",
    "Bcolor": "103",
    "Y": 14,
    "L": 43.5367075245323,
    "a": 6.24142831282204,
    "b": -0.67030190761372,
    "C": 6.2773188569203,
    "h": -0.10698553546127,
    "CMY_C": 0.5572137,
    "CMY_M": 0.6095797,
    "CMY_Y": 0.5949124,
    "CMYK_C": 0,
    "CMYK_M": 0.1182649,
    "CMYK_Y": 0.08513985,
    "CMYK_K": 0.5572137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01898",
    "Farbtonhilfsbezeichnung": "A0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "71",
    "Y": 7,
    "L": 30.0314712000953,
    "a": 8.46035959193667,
    "b": -0.59619709254141,
    "C": 8.48134042460445,
    "h": -0.0703531713816,
    "CMY_C": 0.6729363,
    "CMY_M": 0.7399585,
    "CMY_Y": 0.720545,
    "CMYK_C": 0,
    "CMYK_M": 0.204921,
    "CMYK_Y": 0.145564,
    "CMYK_K": 0.6729363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01899",
    "Farbtonhilfsbezeichnung": "A0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "80",
    "Bcolor": "86",
    "Y": 10,
    "L": 36.7426004061045,
    "a": 12.1698053758571,
    "b": -0.17345767276946,
    "C": 12.1710414694258,
    "h": -0.01425215299582,
    "CMY_C": 0.5863557,
    "CMY_M": 0.6875682,
    "CMY_Y": 0.6613569,
    "CMYK_C": 0,
    "CMYK_M": 0.2446848,
    "CMYK_Y": 0.1813179,
    "CMYK_K": 0.5863557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01900",
    "Farbtonhilfsbezeichnung": "A0.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "108",
    "Bcolor": "115",
    "Y": 18,
    "L": 48.4584029707251,
    "a": 12.152711588062,
    "b": -0.53979967882307,
    "C": 12.1646941036704,
    "h": -0.04438886688232,
    "CMY_C": 0.4703552,
    "CMY_M": 0.5759349,
    "CMY_Y": 0.5474066,
    "CMYK_C": 0,
    "CMYK_M": 0.1993405,
    "CMYK_Y": 0.1454775,
    "CMYK_K": 0.4703552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01901",
    "Farbtonhilfsbezeichnung": "A0.10.10",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "46",
    "Bcolor": "49",
    "Y": 5,
    "L": 20.7034514864788,
    "a": 7.83999592170442,
    "b": 0.32955353777606,
    "C": 7.84691924175359,
    "h": 0.04201018046683,
    "CMY_C": 0.7595277,
    "CMY_M": 0.820182,
    "CMY_Y": 0.8074129,
    "CMYK_C": 0,
    "CMYK_M": 0.25223,
    "CMYK_Y": 0.1991298,
    "CMYK_K": 0.7595277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01902",
    "Farbtonhilfsbezeichnung": "A0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "55",
    "Bcolor": "67",
    "Y": 7,
    "L": 27.7331896995048,
    "a": 18.1193767899156,
    "b": -0.79449233576818,
    "C": 18.136786742048,
    "h": -0.04381959507859,
    "CMY_C": 0.6427249,
    "CMY_M": 0.7844982,
    "CMY_Y": 0.7387061,
    "CMYK_C": 0,
    "CMYK_M": 0.3968182,
    "CMYK_Y": 0.2686479,
    "CMYK_K": 0.6427249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01903",
    "Farbtonhilfsbezeichnung": "A0.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "139",
    "Bcolor": "158",
    "Y": 36,
    "L": 65.715199718215,
    "a": 30.5713051017236,
    "b": 0.5705564353285,
    "C": 30.5766288244562,
    "h": 0.01866096992789,
    "CMY_C": 0.1696575,
    "CMY_M": 0.4542705,
    "CMY_Y": 0.3786227,
    "CMYK_C": 0,
    "CMYK_M": 0.3427657,
    "CMYK_Y": 0.2516615,
    "CMYK_K": 0.1696575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01904",
    "Farbtonhilfsbezeichnung": "A0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "76",
    "Bcolor": "97",
    "Y": 11,
    "L": 40.8272285461426,
    "a": 30.9805889129639,
    "b": -0.46067655086517,
    "C": 30.9840145111084,
    "h": 359.148071289063,
    "CMY_C": 0.44187796115875,
    "CMY_M": 0.70361268520355,
    "CMY_Y": 0.61871254444122,
    "CMYK_C": 0,
    "CMYK_M": 0.46895608305931,
    "CMYK_Y": 0.31683856248856,
    "CMYK_K": 0.44187796115875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01907",
    "Farbtonhilfsbezeichnung": "A6.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "108",
    "Bcolor": "125",
    "Y": 25,
    "L": 56.3971897339684,
    "a": 37.8343133911732,
    "b": 6.17332970765587,
    "C": 38.334648419686,
    "h": 0.16174214699348,
    "CMY_C": 0.2218514,
    "CMY_M": 0.575801,
    "CMY_Y": 0.5095453,
    "CMYK_C": 0,
    "CMYK_M": 0.4548613,
    "CMYK_Y": 0.369716,
    "CMYK_K": 0.2218514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01908",
    "Farbtonhilfsbezeichnung": "B2.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "147",
    "Bcolor": "146",
    "Y": 32,
    "L": 62.674784101683,
    "a": 7.00126436483184,
    "b": 2.53374672261208,
    "C": 7.44564135320871,
    "h": 0.34723520206271,
    "CMY_C": 0.348632,
    "CMY_M": 0.4218811,
    "CMY_Y": 0.4267017,
    "CMYK_C": 0,
    "CMYK_M": 0.1124542,
    "CMYK_Y": 0.119855,
    "CMYK_K": 0.348632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01909",
    "Farbtonhilfsbezeichnung": "B2.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "65",
    "Bcolor": "65",
    "Y": 7,
    "L": 29.5216315371626,
    "a": 8.85007220337766,
    "b": 2.5433777135261,
    "C": 9.20828693073034,
    "h": 0.27984356912879,
    "CMY_C": 0.668595,
    "CMY_M": 0.746177,
    "CMY_Y": 0.7437633,
    "CMYK_C": 0,
    "CMYK_M": 0.2341001,
    "CMYK_Y": 0.2268171,
    "CMYK_K": 0.668595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01910",
    "Farbtonhilfsbezeichnung": "B2.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "111",
    "Bcolor": "112",
    "Y": 17,
    "L": 49.2574234008789,
    "a": 10.9728670120239,
    "b": 2.43994307518005,
    "C": 11.2408685684204,
    "h": 12.5364122390747,
    "CMY_C": 0.46221953630447,
    "CMY_M": 0.56601750850677,
    "CMY_Y": 0.55916702747345,
    "CMYK_C": 0,
    "CMYK_M": 0.19301179051399,
    "CMYK_Y": 0.1802733540535,
    "CMYK_K": 0.46221953630447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01911",
    "Farbtonhilfsbezeichnung": "J0.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "144",
    "Bcolor": "77",
    "Y": 24,
    "L": 56.4186248779297,
    "a": -20.1504249572754,
    "b": 32.104850769043,
    "C": 37.9046325683594,
    "h": 122.114204406738,
    "CMY_C": 0.5332413315773,
    "CMY_M": 0.43622016906738,
    "CMY_Y": 0.69842725992203,
    "CMYK_C": 0.17209051549435,
    "CMYK_M": 0,
    "CMYK_Y": 0.46508774161339,
    "CMYK_K": 0.43622016906738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01912",
    "Farbtonhilfsbezeichnung": "D2.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "94",
    "Bcolor": "88",
    "Y": 11,
    "L": 41.157543182373,
    "a": 4.72171354293823,
    "b": 5.04740381240845,
    "C": 6.91164684295654,
    "h": 46.9094619750977,
    "CMY_C": 0.57570016384125,
    "CMY_M": 0.63029235601425,
    "CMY_Y": 0.65390658378601,
    "CMYK_C": 0,
    "CMYK_M": 0.12866418063641,
    "CMYK_Y": 0.18431876599789,
    "CMYK_K": 0.57570016384125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01914",
    "Farbtonhilfsbezeichnung": "D2.10.15",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 5,
    "L": 27.7761835895255,
    "a": 3.09965080178445,
    "b": 3.18458058686303,
    "C": 4.44402842106437,
    "h": 0.79891208572649,
    "CMY_C": 0.7161056,
    "CMY_M": 0.7495212,
    "CMY_Y": 0.7636562,
    "CMYK_C": 0,
    "CMYK_M": 0.1177042,
    "CMYK_Y": 0.1674938,
    "CMYK_K": 0.7161056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01915",
    "Farbtonhilfsbezeichnung": "FN.02.37",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "112",
    "Bcolor": "108",
    "Y": 16,
    "L": 47.3619956970215,
    "a": 0.71702605485916,
    "b": 1.79072034358978,
    "C": 1.92893898487091,
    "h": 68.1782379150391,
    "CMY_C": 0.54933905601501,
    "CMY_M": 0.5611811876297,
    "CMY_Y": 0.57465320825577,
    "CMYK_C": 0,
    "CMYK_M": 0.02627725340426,
    "CMYK_Y": 0.05617116764188,
    "CMYK_K": 0.54933905601501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01916",
    "Farbtonhilfsbezeichnung": "E0.48.30",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "78",
    "Bcolor": "40",
    "Y": 12,
    "L": 38.5245875127754,
    "a": 18.9159514321935,
    "b": 31.0400188229077,
    "C": 36.3496353091963,
    "h": 1.02348986382841,
    "CMY_C": 0.4871345,
    "CMY_M": 0.6948161,
    "CMY_Y": 0.8435124,
    "CMYK_C": 0,
    "CMYK_M": 0.4049436,
    "CMYK_Y": 0.694876,
    "CMYK_K": 0.4871345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01917",
    "Farbtonhilfsbezeichnung": "F2.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "212",
    "Gcolor": "149",
    "Bcolor": "43",
    "Y": 37,
    "L": 66.1761009614643,
    "a": 15.172719410448,
    "b": 60.5982407556495,
    "C": 62.4688578172183,
    "h": 1.32545800052785,
    "CMY_C": 0.1696175,
    "CMY_M": 0.4166928,
    "CMY_Y": 0.8306394,
    "CMYK_C": 0,
    "CMYK_M": 0.2975439,
    "CMYK_Y": 0.796045,
    "CMYK_K": 0.1696175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01918",
    "Farbtonhilfsbezeichnung": "F2.50.55",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "143",
    "Bcolor": "57",
    "Y": 33,
    "L": 62.5702170510234,
    "a": 9.3209013331223,
    "b": 50.8159632804315,
    "C": 51.6637331769585,
    "h": 1.38938818653977,
    "CMY_C": 0.2532271,
    "CMY_M": 0.4374783,
    "CMY_Y": 0.7779152,
    "CMYK_C": 0,
    "CMYK_M": 0.2467299,
    "CMYK_Y": 0.7026074,
    "CMYK_K": 0.2532271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01919",
    "Farbtonhilfsbezeichnung": "F6.05.30",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "93",
    "Bcolor": "87",
    "Y": 12,
    "L": 39.6829556805356,
    "a": 0.28510920684232,
    "b": 3.86293930951448,
    "C": 3.87344644584361,
    "h": 1.49712362026641,
    "CMY_C": 0.6208774,
    "CMY_M": 0.6346654,
    "CMY_Y": 0.6607324,
    "CMYK_C": 0,
    "CMYK_M": 0.0363679,
    "CMYK_Y": 0.1051243,
    "CMYK_K": 0.6208774
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01920",
    "Farbtonhilfsbezeichnung": "F6.03.20",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "73",
    "Bcolor": "69",
    "Y": 8,
    "L": 31.0079227070292,
    "a": 0.48490005935877,
    "b": 2.03332727584912,
    "C": 2.09034635366442,
    "h": 1.3366927006617,
    "CMY_C": 0.7052916,
    "CMY_M": 0.7150666,
    "CMY_Y": 0.7285184,
    "CMYK_C": 0,
    "CMYK_M": 0.03316806,
    "CMYK_Y": 0.07881273,
    "CMYK_K": 0.7052916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01921",
    "Farbtonhilfsbezeichnung": "F6.10.25",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "74",
    "Bcolor": "64",
    "Y": 8,
    "L": 31.9607919938353,
    "a": 1.40021935926493,
    "b": 7.13284949815185,
    "C": 7.26898591395976,
    "h": 1.37695544230106,
    "CMY_C": 0.6789455,
    "CMY_M": 0.7093018,
    "CMY_Y": 0.7508227,
    "CMYK_C": 0,
    "CMYK_M": 0.09455161,
    "CMYK_Y": 0.2238785,
    "CMYK_K": 0.6789455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01922",
    "Farbtonhilfsbezeichnung": "F6.05.10",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 5,
    "L": 21.8017446186745,
    "a": 0.43302397878011,
    "b": 2.11947000934709,
    "C": 2.1632528485409,
    "h": 1.36926222877534,
    "CMY_C": 0.7872666,
    "CMY_M": 0.7963188,
    "CMY_Y": 0.8091422,
    "CMYK_C": 0,
    "CMYK_M": 0.04255169,
    "CMYK_Y": 0.102831,
    "CMYK_K": 0.7872666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01923",
    "Farbtonhilfsbezeichnung": "F6.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "69",
    "Bcolor": "59",
    "Y": 8,
    "L": 29.2997582777394,
    "a": 0.45028794830245,
    "b": 6.18202551392532,
    "C": 6.19840291455872,
    "h": 1.49808647600548,
    "CMY_C": 0.711195,
    "CMY_M": 0.7312914,
    "CMY_Y": 0.7685562,
    "CMYK_C": 0,
    "CMYK_M": 0.06958438,
    "CMYK_Y": 0.1986157,
    "CMYK_K": 0.711195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01924",
    "Farbtonhilfsbezeichnung": "F6.10.10",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "52",
    "Bcolor": "46",
    "Y": 5,
    "L": 21.8970004176288,
    "a": 0.37400574491891,
    "b": 4.28433161034368,
    "C": 4.30062526205463,
    "h": 1.48372089770488,
    "CMY_C": 0.7818395,
    "CMY_M": 0.7958294,
    "CMY_Y": 0.8207322,
    "CMYK_C": 0,
    "CMYK_M": 0.06412633,
    "CMYK_Y": 0.1782752,
    "CMYK_K": 0.7818395
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01925",
    "Farbtonhilfsbezeichnung": "M6.30.15",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "67",
    "Bcolor": "59",
    "Y": 6,
    "L": 25.7430195876927,
    "a": -14.2144595230466,
    "b": 0.63083255853111,
    "C": 14.2284506974313,
    "h": -0.04435053571226,
    "CMY_C": 0.8669633,
    "CMY_M": 0.7375833,
    "CMY_Y": 0.768201,
    "CMYK_C": 0.4930328,
    "CMYK_M": 0,
    "CMYK_Y": 0.116676,
    "CMYK_K": 0.7375833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01926",
    "Farbtonhilfsbezeichnung": "E8.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "149",
    "Bcolor": "47",
    "Y": 37,
    "L": 68.4419250488281,
    "a": 23.4838790893555,
    "b": 61.9908447265625,
    "C": 66.2899475097656,
    "h": 69.2518997192383,
    "CMY_C": 0.09483748674393,
    "CMY_M": 0.41672915220261,
    "CMY_Y": 0.81467765569687,
    "CMYK_C": 0,
    "CMYK_M": 0.35561755299568,
    "CMYK_Y": 0.7952606678009,
    "CMYK_K": 0.09483748674393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01927",
    "Farbtonhilfsbezeichnung": "D6.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "76",
    "Bcolor": "45",
    "Y": 12,
    "L": 39.343666765017,
    "a": 24.393582761985,
    "b": 29.6437739470124,
    "C": 38.3901056756475,
    "h": 0.88225271407891,
    "CMY_C": 0.4523028,
    "CMY_M": 0.7031927,
    "CMY_Y": 0.8248885,
    "CMYK_C": 0,
    "CMYK_M": 0.4580813,
    "CMYK_Y": 0.6802768,
    "CMYK_K": 0.4523028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01928",
    "Farbtonhilfsbezeichnung": "C0.10.10",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "53",
    "Bcolor": "50",
    "Y": 4,
    "L": 23.2599444356685,
    "a": 5.40737834012367,
    "b": 3.58140690312745,
    "C": 6.48584735551243,
    "h": 0.58498631484513,
    "CMY_C": 0.7430961,
    "CMY_M": 0.7938736,
    "CMY_Y": 0.8045805,
    "CMYK_C": 0,
    "CMYK_M": 0.1976518,
    "CMYK_Y": 0.2393283,
    "CMYK_K": 0.7430961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01933",
    "Farbtonhilfsbezeichnung": "J0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "153",
    "Bcolor": "67",
    "Y": 26,
    "L": 59.1759986877441,
    "a": -25.9228992462158,
    "b": 40.388069152832,
    "C": 47.9915924072266,
    "h": 122.694198608398,
    "CMY_C": 0.53237819671631,
    "CMY_M": 0.39891093969345,
    "CMY_Y": 0.73666930198669,
    "CMYK_C": 0.22204239666462,
    "CMYK_M": 0,
    "CMYK_Y": 0.56191068887711,
    "CMYK_K": 0.39891093969345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01935",
    "Farbtonhilfsbezeichnung": "C0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "134",
    "Bcolor": "127",
    "Y": 37,
    "L": 66.8389171564379,
    "a": 38.6013514483429,
    "b": 20.6295846889345,
    "C": 43.7680716741828,
    "h": 0.49080801193745,
    "CMY_C": 0.07361832,
    "CMY_M": 0.4748968,
    "CMY_Y": 0.5037789,
    "CMYK_C": 0,
    "CMYK_M": 0.4331675,
    "CMYK_Y": 0.4643449,
    "CMYK_K": 0.07361832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01936",
    "Farbtonhilfsbezeichnung": "C0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "54",
    "Bcolor": "50",
    "Y": 6,
    "L": 28.572613974031,
    "a": 21.0400840198346,
    "b": 11.5178364178767,
    "C": 23.986364695607,
    "h": 0.50086293943993,
    "CMY_C": 0.6009348,
    "CMY_M": 0.7885746,
    "CMY_Y": 0.8034093,
    "CMYK_C": 0,
    "CMYK_M": 0.4701984,
    "CMYK_Y": 0.507372,
    "CMYK_K": 0.6009348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01937",
    "Farbtonhilfsbezeichnung": "L0.40.60",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "182",
    "Bcolor": "121",
    "Y": 39,
    "L": 67.5288797905479,
    "a": -39.6153419015918,
    "b": 22.7872883301314,
    "C": 45.7015954143896,
    "h": -0.5219948839988,
    "CMY_C": 0.6257605,
    "CMY_M": 0.2857775,
    "CMY_Y": 0.5265111,
    "CMYK_C": 0.4760183,
    "CMYK_M": 0,
    "CMYK_Y": 0.337057,
    "CMYK_K": 0.2857775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01938",
    "Farbtonhilfsbezeichnung": "J0.40.70",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "198",
    "Bcolor": "105",
    "Y": 51,
    "L": 75.7366948301995,
    "a": -26.6154725594525,
    "b": 42.1141064015462,
    "C": 49.8194875281121,
    "h": -1.00719003740685,
    "CMY_C": 0.3593097,
    "CMY_M": 0.2216337,
    "CMY_Y": 0.5873716,
    "CMYK_C": 0.1768782,
    "CMYK_M": 0,
    "CMYK_Y": 0.4698789,
    "CMYK_K": 0.2216337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01940",
    "Farbtonhilfsbezeichnung": "P0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "73",
    "Bcolor": "72",
    "Y": 7,
    "L": 28.0437726588282,
    "a": -16.6451940952608,
    "b": -4.40980760430012,
    "C": 17.2194334859149,
    "h": 0.2589801166732,
    "CMY_C": 0.9076728,
    "CMY_M": 0.7121189,
    "CMY_Y": 0.7181594,
    "CMYK_C": 0.6792868,
    "CMYK_M": 0,
    "CMYK_Y": 0.02098255,
    "CMYK_K": 0.7121189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01941",
    "Farbtonhilfsbezeichnung": "K2.40.60",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "178",
    "Bcolor": "105",
    "Y": 37,
    "L": 67.2315086597067,
    "a": -33.2331970279315,
    "b": 30.8730640763042,
    "C": 45.3606819851389,
    "h": -0.7485988327537,
    "CMY_C": 0.5333499,
    "CMY_M": 0.300445,
    "CMY_Y": 0.5875267,
    "CMYK_C": 0.3329329,
    "CMYK_M": 0,
    "CMYK_Y": 0.4103776,
    "CMYK_K": 0.300445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01942",
    "Farbtonhilfsbezeichnung": "F2.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "110",
    "Bcolor": "70",
    "Y": 18,
    "L": 47.9871923813212,
    "a": 5.16943600716091,
    "b": 25.5186313728228,
    "C": 26.0369663320086,
    "h": 1.37092606390418,
    "CMY_C": 0.4664375,
    "CMY_M": 0.5695776,
    "CMY_Y": 0.7247012,
    "CMYK_C": 0,
    "CMYK_M": 0.1933046,
    "CMYK_Y": 0.4840364,
    "CMYK_K": 0.4664375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01943",
    "Farbtonhilfsbezeichnung": "D2.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "88",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.4213523864746,
    "a": 15.7981376647949,
    "b": 15.5014953613281,
    "C": 22.1331768035889,
    "h": 44.4569931030273,
    "CMY_C": 0.49012184143066,
    "CMY_M": 0.65656745433807,
    "CMY_Y": 0.71611940860748,
    "CMYK_C": 0,
    "CMYK_M": 0.32644194364548,
    "CMYK_Y": 0.44323837757111,
    "CMYK_K": 0.49012184143066
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01945",
    "Farbtonhilfsbezeichnung": "L0.30.70",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "207",
    "Bcolor": "151",
    "Y": 53,
    "L": 77.1190066761149,
    "a": -34.3140553956737,
    "b": 19.8752199482186,
    "C": 39.6544923771245,
    "h": -0.52499628941932,
    "CMY_C": 0.4787768,
    "CMY_M": 0.1891468,
    "CMY_Y": 0.407338,
    "CMYK_C": 0.3571917,
    "CMYK_M": 0,
    "CMYK_Y": 0.2690884,
    "CMYK_K": 0.1891468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01947",
    "Farbtonhilfsbezeichnung": "H2.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "179",
    "Bcolor": "48",
    "Y": 38,
    "L": 69.7999801635742,
    "a": -20.7364883422852,
    "b": 60.600658416748,
    "C": 64.0503082275391,
    "h": 108.89005279541,
    "CMY_C": 0.35075676441193,
    "CMY_M": 0.29850167036057,
    "CMY_Y": 0.81076204776764,
    "CMYK_C": 0.07449068874121,
    "CMYK_M": 0,
    "CMYK_Y": 0.73023748397827,
    "CMYK_K": 0.29850167036057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01948",
    "Farbtonhilfsbezeichnung": "G0.50.70",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "182",
    "Bcolor": "68",
    "Y": 51,
    "L": 75.3513205645975,
    "a": 1.49482794852368,
    "b": 60.1983329694338,
    "C": 60.2168896813387,
    "h": 1.54596971209645,
    "CMY_C": 0.142815,
    "CMY_M": 0.2865256,
    "CMY_Y": 0.7350475,
    "CMYK_C": 0,
    "CMYK_M": 0.1676541,
    "CMYK_Y": 0.6909039,
    "CMYK_K": 0.142815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01949",
    "Farbtonhilfsbezeichnung": "C6.65.35",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "52",
    "Bcolor": "41",
    "Y": 13,
    "L": 40.4597950875839,
    "a": 48.5428530132012,
    "b": 34.5475436569565,
    "C": 59.581384268835,
    "h": 0.61852969324064,
    "CMY_C": 0.3218184,
    "CMY_M": 0.7945257,
    "CMY_Y": 0.8395367,
    "CMYK_C": 0,
    "CMYK_M": 0.6970218,
    "CMYK_Y": 0.7633917,
    "CMYK_K": 0.3218184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01950",
    "Farbtonhilfsbezeichnung": "W0.05.07",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "52",
    "Bcolor": "55",
    "Y": 4,
    "L": 22.010756929782,
    "a": 2.13301217015321,
    "b": -1.56491014805858,
    "C": 2.64550272907031,
    "h": -0.63296258264036,
    "CMY_C": 0.78466,
    "CMY_M": 0.7969052,
    "CMY_Y": 0.7861439,
    "CMYK_C": 0,
    "CMYK_M": 0.05686472,
    "CMYK_Y": 0.006891029,
    "CMYK_K": 0.78466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01951",
    "Farbtonhilfsbezeichnung": "W0.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "103",
    "Bcolor": "113",
    "Y": 14,
    "L": 44.0201140693668,
    "a": 3.26809228723207,
    "b": -6.00793424942982,
    "C": 6.83927636108804,
    "h": -1.07260007291456,
    "CMY_C": 0.588309,
    "CMY_M": 0.5969704,
    "CMY_Y": 0.5564853,
    "CMYK_C": 0.07175358,
    "CMYK_M": 0.09128249,
    "CMYK_Y": 0,
    "CMYK_K": 0.5564853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01953",
    "Farbtonhilfsbezeichnung": "C8.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "148",
    "Bcolor": "142",
    "Y": 32,
    "L": 62.4340672939293,
    "a": 5.24594978700604,
    "b": 4.28185412012092,
    "C": 6.77157765028101,
    "h": 0.68455380226375,
    "CMY_C": 0.3583753,
    "CMY_M": 0.4206847,
    "CMY_Y": 0.441359,
    "CMYK_C": 0,
    "CMYK_M": 0.09711187,
    "CMYK_Y": 0.1293337,
    "CMYK_K": 0.3583753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01954",
    "Farbtonhilfsbezeichnung": "E8.25.35",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "97",
    "Bcolor": "70",
    "Y": 15,
    "L": 43.0234028251221,
    "a": 6.09757788767978,
    "b": 18.890387620465,
    "C": 19.8501184013532,
    "h": 1.25856700685821,
    "CMY_C": 0.5222986,
    "CMY_M": 0.6184043,
    "CMY_Y": 0.7253866,
    "CMYK_C": 0,
    "CMYK_M": 0.2011836,
    "CMYK_Y": 0.4251359,
    "CMYK_K": 0.5222986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01956",
    "Farbtonhilfsbezeichnung": "D6.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 26,
    "L": 56.8556714500229,
    "a": 31.1575137905977,
    "b": 40.3048242384664,
    "C": 50.9437878696211,
    "h": 0.91270771133164,
    "CMY_C": 0.2090355,
    "CMY_M": 0.5559545,
    "CMY_Y": 0.7402795,
    "CMYK_C": 0,
    "CMYK_M": 0.4386026,
    "CMYK_Y": 0.6716408,
    "CMYK_K": 0.2090355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01957",
    "Farbtonhilfsbezeichnung": "F6.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "232",
    "Bcolor": "205",
    "Y": 84,
    "L": 92.4194869995117,
    "a": 1.2806499004364,
    "b": 14.1145296096802,
    "C": 14.1725091934204,
    "h": 84.8155975341797,
    "CMY_C": 0.03187340497971,
    "CMY_M": 0.09163528680801,
    "CMY_Y": 0.19716721773148,
    "CMYK_C": 0,
    "CMYK_M": 0.0617294088006,
    "CMYK_Y": 0.17073574662209,
    "CMYK_K": 0.03187340497971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01958",
    "Farbtonhilfsbezeichnung": "K2.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "152",
    "Bcolor": "107",
    "Y": 27,
    "L": 58.9951934814453,
    "a": -21.475378036499,
    "b": 19.0911903381348,
    "C": 28.7343940734863,
    "h": 138.363525390625,
    "CMY_C": 0.55003917217255,
    "CMY_M": 0.40532571077347,
    "CMY_Y": 0.58140420913696,
    "CMYK_C": 0.24334912002087,
    "CMYK_M": 0,
    "CMYK_Y": 0.29609233140945,
    "CMYK_K": 0.40532571077347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01959",
    "Farbtonhilfsbezeichnung": "R0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "126",
    "Bcolor": "147",
    "Y": 18,
    "L": 48.3881309667902,
    "a": -19.75575981255,
    "b": -19.882308827337,
    "C": 28.0284899713982,
    "h": 0.78859076558948,
    "CMY_C": 0.9127901,
    "CMY_M": 0.5072397,
    "CMY_Y": 0.4248423,
    "CMYK_C": 0.8483722,
    "CMYK_M": 0.1432605,
    "CMYK_Y": 0,
    "CMYK_K": 0.4248423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01960",
    "Farbtonhilfsbezeichnung": "Q0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "98",
    "Bcolor": "105",
    "Y": 12,
    "L": 38.1921810168622,
    "a": -16.1757608068031,
    "b": -9.92516585925167,
    "C": 18.9779913323977,
    "h": 0.55034691177709,
    "CMY_C": 0.8398935,
    "CMY_M": 0.6160673,
    "CMY_Y": 0.5898502,
    "CMYK_C": 0.609639,
    "CMYK_M": 0.06392079,
    "CMYK_Y": 0,
    "CMYK_K": 0.5898502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01961",
    "Farbtonhilfsbezeichnung": "S4.43.46",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "139",
    "Bcolor": "181",
    "Y": 23,
    "L": 54.1436479401132,
    "a": -15.0765412423032,
    "b": -30.758431511592,
    "C": 34.254681503178,
    "h": 1.11505196258538,
    "CMY_C": 0.9044577,
    "CMY_M": 0.4531797,
    "CMY_Y": 0.2917585,
    "CMYK_C": 0.8650993,
    "CMYK_M": 0.2279184,
    "CMYK_Y": 0,
    "CMYK_K": 0.2917585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01962",
    "Farbtonhilfsbezeichnung": "E4.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "127",
    "Bcolor": "120",
    "Y": 21,
    "L": 53.9242668151855,
    "a": 2.20467734336853,
    "b": 4.7818398475647,
    "C": 5.26560497283936,
    "h": 65.2478332519531,
    "CMY_C": 0.465516269207,
    "CMY_M": 0.50021237134933,
    "CMY_Y": 0.53017747402191,
    "CMYK_C": 0,
    "CMYK_M": 0.06491517275572,
    "CMYK_Y": 0.12097880989313,
    "CMYK_K": 0.465516269207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01963",
    "Farbtonhilfsbezeichnung": "E8.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "128",
    "Bcolor": "59",
    "Y": 27,
    "L": 57.6715787490728,
    "a": 13.7673350294295,
    "b": 44.1568548881388,
    "C": 46.2532955304236,
    "h": 1.26856524868463,
    "CMY_C": 0.2901849,
    "CMY_M": 0.4974914,
    "CMY_Y": 0.7685281,
    "CMYK_C": 0,
    "CMYK_M": 0.292057,
    "CMYK_Y": 0.6738983,
    "CMYK_K": 0.2901849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01964",
    "Farbtonhilfsbezeichnung": "H2.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "196",
    "Bcolor": "98",
    "Y": 53,
    "L": 76.8316866584556,
    "a": -14.9556732486436,
    "b": 47.540834959201,
    "C": 49.837768318196,
    "h": -1.26601232623924,
    "CMY_C": 0.2506391,
    "CMY_M": 0.2330557,
    "CMY_Y": 0.6166057,
    "CMYK_C": 0.02292662,
    "CMYK_M": 0,
    "CMYK_Y": 0.5001015,
    "CMYK_K": 0.2330557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01965",
    "Farbtonhilfsbezeichnung": "ON.00.88",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 82,
    "L": 92.4003448486328,
    "a": 0.00467238435522,
    "b": 1.12277710437775,
    "C": 1.12278687953949,
    "h": 89.7615661621094,
    "CMY_C": 0.08168858289719,
    "CMY_M": 0.08532118797302,
    "CMY_Y": 0.10091096162796,
    "CMYK_C": 0,
    "CMYK_M": 0.00395574420691,
    "CMYK_Y": 0.02093230932951,
    "CMYK_K": 0.08168858289719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01966",
    "Farbtonhilfsbezeichnung": "E8.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "97",
    "Bcolor": "80",
    "Y": 14,
    "L": 42.2105101430524,
    "a": 3.89721719770114,
    "b": 11.8307549462373,
    "C": 12.4561255807726,
    "h": 1.25257724241706,
    "CMY_C": 0.5558166,
    "CMY_M": 0.6199554,
    "CMY_Y": 0.6874837,
    "CMYK_C": 0,
    "CMYK_M": 0.144397,
    "CMYK_Y": 0.296425,
    "CMYK_K": 0.5558166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01967",
    "Farbtonhilfsbezeichnung": "S0.40.60",
    "Farbtonklasse": "02",
    "Rcolor": "51",
    "Gcolor": "175",
    "Bcolor": "214",
    "Y": 38,
    "L": 66.6762419734048,
    "a": -20.2743175785734,
    "b": -30.0830072051198,
    "C": 36.2772004953544,
    "h": 0.97777121124071,
    "CMY_C": 0.8018841,
    "CMY_M": 0.3136563,
    "CMY_Y": 0.1612898,
    "CMYK_C": 0.763785,
    "CMYK_M": 0.1816676,
    "CMYK_Y": 0,
    "CMYK_K": 0.1612898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01968",
    "Farbtonhilfsbezeichnung": "P0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "129",
    "Bcolor": "128",
    "Y": 22,
    "L": 52.8618494161539,
    "a": -4.1396332798887,
    "b": -1.49557891412182,
    "C": 4.40151337386675,
    "h": 0.34669086996844,
    "CMY_C": 0.5405151,
    "CMY_M": 0.495927,
    "CMY_Y": 0.499752,
    "CMYK_C": 0.08845558,
    "CMYK_M": 0,
    "CMYK_Y": 0.007588234,
    "CMYK_K": 0.495927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01970",
    "Farbtonhilfsbezeichnung": "R6.56.36",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "147",
    "Y": 14,
    "L": 43.2115046009038,
    "a": -21.7500963788162,
    "b": -27.9846663490582,
    "C": 35.4430281318611,
    "h": 0.91010404282889,
    "CMY_C": 1,
    "CMY_M": 0.5530148,
    "CMY_Y": 0.4248992,
    "CMYK_C": 1,
    "CMYK_M": 0.2227707,
    "CMYK_Y": 0,
    "CMYK_K": 0.4248992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01972",
    "Farbtonhilfsbezeichnung": "G8.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "194",
    "Bcolor": "93",
    "Y": 53,
    "L": 77.1739431905578,
    "a": -9.95666376849419,
    "b": 50.6496148034804,
    "C": 51.6189755142407,
    "h": -1.37669209384189,
    "CMY_C": 0.2075788,
    "CMY_M": 0.2402006,
    "CMY_Y": 0.6370862,
    "CMYK_C": 0,
    "CMYK_M": 0.04116719,
    "CMYK_Y": 0.5420191,
    "CMYK_K": 0.2075788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01973",
    "Farbtonhilfsbezeichnung": "S4.50.35",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "147",
    "Y": 13,
    "L": 41.4699591393184,
    "a": -14.4972522482254,
    "b": -30.8576170737905,
    "C": 34.0934429798659,
    "h": 1.13159014010319,
    "CMY_C": 1,
    "CMY_M": 0.5802888,
    "CMY_Y": 0.4236579,
    "CMYK_C": 1,
    "CMYK_M": 0.2717672,
    "CMYK_Y": 0,
    "CMYK_K": 0.4236579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01974",
    "Farbtonhilfsbezeichnung": "L8.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "158",
    "Bcolor": "109",
    "Y": 27,
    "L": 57.5239466280581,
    "a": -46.9929112207887,
    "b": 15.2332073928553,
    "C": 49.4002460771064,
    "h": -0.31347167708361,
    "CMY_C": 1,
    "CMY_M": 0.3812713,
    "CMY_Y": 0.5723702,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3088573,
    "CMYK_K": 0.3812713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01975",
    "Farbtonhilfsbezeichnung": "H2.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "141",
    "Bcolor": "89",
    "Y": 27,
    "L": 57.3364507977914,
    "a": -8.50228986684643,
    "b": 27.1917458598134,
    "C": 28.4899978217717,
    "h": -1.26774832623176,
    "CMY_C": 0.4516336,
    "CMY_M": 0.4478538,
    "CMY_Y": 0.6518917,
    "CMYK_C": 0.006845525,
    "CMYK_M": 0,
    "CMYK_Y": 0.369536,
    "CMYK_K": 0.4478538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01976",
    "Farbtonhilfsbezeichnung": "E0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "102",
    "Bcolor": "58",
    "Y": 19,
    "L": 48.8903719060206,
    "a": 19.4685680054385,
    "b": 34.1100296620718,
    "C": 39.2749190162094,
    "h": 1.05215596144612,
    "CMY_C": 0.3676724,
    "CMY_M": 0.5981477,
    "CMY_Y": 0.7726147,
    "CMYK_C": 0,
    "CMYK_M": 0.3644872,
    "CMYK_Y": 0.6403996,
    "CMYK_K": 0.3676724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01978",
    "Farbtonhilfsbezeichnung": "W0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "86",
    "Bcolor": "137",
    "Y": 12,
    "L": 39.4871149836522,
    "a": 15.7301262610752,
    "b": -27.8395703724005,
    "C": 31.9762185179738,
    "h": -1.05648884728523,
    "CMY_C": 0.6299495,
    "CMY_M": 0.6609794,
    "CMY_Y": 0.4611573,
    "CMYK_C": 0.3132495,
    "CMYK_M": 0.3708357,
    "CMYK_Y": 0,
    "CMYK_K": 0.4611573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01979",
    "Farbtonhilfsbezeichnung": "X0.20.40",
    "Farbtonklasse": "04",
    "Rcolor": "127",
    "Gcolor": "103",
    "Bcolor": "140",
    "Y": 17,
    "L": 46.9872491090259,
    "a": 17.3321486055064,
    "b": -17.6648058513708,
    "C": 24.7477017326858,
    "h": -0.79490319699022,
    "CMY_C": 0.5027449,
    "CMY_M": 0.5977848,
    "CMY_Y": 0.4503512,
    "CMYK_C": 0.095322,
    "CMYK_M": 0.2682323,
    "CMYK_Y": 0,
    "CMYK_K": 0.4503512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01980",
    "Farbtonhilfsbezeichnung": "E0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "89",
    "Bcolor": "81",
    "Y": 12,
    "L": 38.8100699397394,
    "a": 3.73627771244733,
    "b": 6.01524857408587,
    "C": 7.08117126982343,
    "h": 1.01498161154148,
    "CMY_C": 0.6023358,
    "CMY_M": 0.6505633,
    "CMY_Y": 0.6818653,
    "CMYK_C": 0,
    "CMYK_M": 0.1212769,
    "CMYK_Y": 0.1999916,
    "CMYK_K": 0.6023358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01981",
    "Farbtonhilfsbezeichnung": "E4.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "123",
    "Bcolor": "58",
    "Y": 26,
    "L": 57.5437304911399,
    "a": 21.0068366441698,
    "b": 44.6351238201454,
    "C": 49.3313436289196,
    "h": 1.13091573100904,
    "CMY_C": 0.2514069,
    "CMY_M": 0.5185499,
    "CMY_Y": 0.7707278,
    "CMYK_C": 0,
    "CMYK_M": 0.35686,
    "CMYK_Y": 0.6937291,
    "CMYK_K": 0.2514069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01982",
    "Farbtonhilfsbezeichnung": "N0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "9",
    "Gcolor": "101",
    "Bcolor": "89",
    "Y": 11,
    "L": 38.129751440756,
    "a": -27.3981717024487,
    "b": -0.74004437290251,
    "C": 27.4081644462143,
    "h": 0.02700415509676,
    "CMY_C": 0.9643897,
    "CMY_M": 0.6025808,
    "CMY_Y": 0.6491814,
    "CMYK_C": 0.910396,
    "CMYK_M": 0,
    "CMYK_Y": 0.1172578,
    "CMYK_K": 0.6025808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01983",
    "Farbtonhilfsbezeichnung": "S0.10.10",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "55",
    "Bcolor": "58",
    "Y": 4,
    "L": 22.4955278881306,
    "a": -1.96615493736604,
    "b": -3.58977551642562,
    "C": 4.09295168503828,
    "h": 1.06971318978656,
    "CMY_C": 0.8127765,
    "CMY_M": 0.784723,
    "CMY_Y": 0.7707666,
    "CMYK_C": 0.1832628,
    "CMYK_M": 0.06088338,
    "CMYK_Y": 0,
    "CMYK_K": 0.7707666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01986",
    "Farbtonhilfsbezeichnung": "C0.25.60",
    "Farbtonklasse": "02",
    "Y": 37,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01991",
    "Farbtonhilfsbezeichnung": "G4.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "136",
    "Bcolor": "100",
    "Y": 26,
    "L": 56.7712010976941,
    "a": -1.73163851609676,
    "b": 20.3332164487156,
    "C": 20.4068190343509,
    "h": -1.48583828448588,
    "CMY_C": 0.4261985,
    "CMY_M": 0.4663709,
    "CMY_Y": 0.6081743,
    "CMYK_C": 0,
    "CMYK_M": 0.07001108,
    "CMYK_Y": 0.3171407,
    "CMYK_K": 0.4261985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01993",
    "Farbtonhilfsbezeichnung": "P0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "82",
    "Bcolor": "82",
    "Y": 9,
    "L": 34.1813152261274,
    "a": -2.5294713681491,
    "b": -1.27730524298613,
    "C": 2.83367854317421,
    "h": 0.46761509670024,
    "CMY_C": 0.7057979,
    "CMY_M": 0.679448,
    "CMY_Y": 0.6799532,
    "CMYK_C": 0.08220145,
    "CMYK_M": 0,
    "CMYK_Y": 0.001575989,
    "CMYK_K": 0.679448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01995",
    "Farbtonhilfsbezeichnung": "L0.05.15",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "65",
    "Bcolor": "61",
    "Y": 6,
    "L": 27.0688632082592,
    "a": -2.30516116292875,
    "b": 1.58905322023026,
    "C": 2.79979608611042,
    "h": -0.60353966375502,
    "CMY_C": 0.7595744,
    "CMY_M": 0.7451181,
    "CMY_Y": 0.7610464,
    "CMYK_C": 0.05671719,
    "CMYK_M": 0,
    "CMYK_Y": 0.06249239,
    "CMYK_K": 0.7451181
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01996",
    "Farbtonhilfsbezeichnung": "J0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "73",
    "Bcolor": "48",
    "Y": 7,
    "L": 29.6276116189711,
    "a": -8.56796737342974,
    "b": 13.8430716644829,
    "C": 16.2800705778619,
    "h": -1.01656994912866,
    "CMY_C": 0.7476501,
    "CMY_M": 0.7134478,
    "CMY_Y": 0.8136193,
    "CMYK_C": 0.1193581,
    "CMYK_M": 0,
    "CMYK_Y": 0.3495749,
    "CMYK_K": 0.7134478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01997",
    "Farbtonhilfsbezeichnung": "F2.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "87",
    "Bcolor": "48",
    "Y": 11,
    "L": 39.1188924424732,
    "a": 6.6034784815816,
    "b": 26.3887961323276,
    "C": 27.2024721187295,
    "h": 1.32559371490737,
    "CMY_C": 0.5491621,
    "CMY_M": 0.6575834,
    "CMY_Y": 0.809836,
    "CMYK_C": 0,
    "CMYK_M": 0.2404884,
    "CMYK_Y": 0.5781986,
    "CMYK_K": 0.5491621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI01998",
    "Farbtonhilfsbezeichnung": "L0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "150",
    "Bcolor": "110",
    "Y": 26,
    "L": 57.5754638677076,
    "a": -26.495941030423,
    "b": 14.8674486700942,
    "C": 30.3821645220603,
    "h": -0.51134186081215,
    "CMY_C": 0.6230657,
    "CMY_M": 0.4108472,
    "CMY_Y": 0.5666766,
    "CMYK_C": 0.3602096,
    "CMYK_M": 0,
    "CMYK_Y": 0.2644974,
    "CMYK_K": 0.4108472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02002",
    "Farbtonhilfsbezeichnung": "F2.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "88",
    "Bcolor": "66",
    "Y": 11,
    "L": 38.1989532978403,
    "a": 3.01956816528351,
    "b": 14.2347568662782,
    "C": 14.5514980310223,
    "h": 1.36176839015987,
    "CMY_C": 0.5960382,
    "CMY_M": 0.6564109,
    "CMY_Y": 0.7393259,
    "CMYK_C": 0,
    "CMYK_M": 0.1494517,
    "CMYK_Y": 0.3547062,
    "CMYK_K": 0.5960382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02003",
    "Farbtonhilfsbezeichnung": "D6.10.12",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "49",
    "Bcolor": "43",
    "Y": 5,
    "L": 21.1858298598409,
    "a": 3.78673774151156,
    "b": 5.36715600022682,
    "C": 6.56854217111825,
    "h": 0.95636259511199,
    "CMY_C": 0.7669306,
    "CMY_M": 0.8086922,
    "CMY_Y": 0.8324107,
    "CMYK_C": 0,
    "CMYK_M": 0.1791812,
    "CMYK_Y": 0.2809467,
    "CMYK_K": 0.7669306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02004",
    "Farbtonhilfsbezeichnung": "Y0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "133",
    "Bcolor": "153",
    "Y": 27,
    "L": 58.1266926213099,
    "a": 12.8431507220558,
    "b": -8.0957225071884,
    "C": 15.1818063280639,
    "h": -0.56243962451686,
    "CMY_C": 0.3874703,
    "CMY_M": 0.4793744,
    "CMY_Y": 0.4003628,
    "CMYK_C": 0,
    "CMYK_M": 0.1500403,
    "CMYK_Y": 0.02104809,
    "CMYK_K": 0.3874703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02005",
    "Farbtonhilfsbezeichnung": "E4.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "108",
    "Gcolor": "101",
    "Bcolor": "94",
    "Y": 14,
    "L": 43.0788698019734,
    "a": 1.68924449265334,
    "b": 4.16520821687371,
    "C": 4.49471984064323,
    "h": 1.18550550868943,
    "CMY_C": 0.5783052,
    "CMY_M": 0.6052826,
    "CMY_Y": 0.6306958,
    "CMYK_C": 0,
    "CMYK_M": 0.06397384,
    "CMYK_Y": 0.1242382,
    "CMYK_K": 0.5783052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02006",
    "Farbtonhilfsbezeichnung": "P0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "95",
    "Bcolor": "94",
    "Y": 12,
    "L": 38.8626412459874,
    "a": -6.7372582021363,
    "b": -2.17977136459225,
    "C": 7.08110523041066,
    "h": 0.31291065774297,
    "CMY_C": 0.696842,
    "CMY_M": 0.6275466,
    "CMY_Y": 0.6312352,
    "CMYK_C": 0.1860511,
    "CMYK_M": 0,
    "CMYK_Y": 0.009903595,
    "CMYK_K": 0.6275466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02007",
    "Farbtonhilfsbezeichnung": "H2.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "167",
    "Bcolor": "83",
    "Y": 38,
    "L": 66.7336651431847,
    "a": -12.6049720744826,
    "b": 42.3308829474506,
    "C": 44.1677367782101,
    "h": -1.28138437774534,
    "CMY_C": 0.3536102,
    "CMY_M": 0.3446891,
    "CMY_Y": 0.6748793,
    "CMYK_C": 0.01361352,
    "CMYK_M": 0,
    "CMYK_Y": 0.503868,
    "CMYK_K": 0.3446891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02008",
    "Farbtonhilfsbezeichnung": "C0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "88",
    "Bcolor": "85",
    "Y": 12,
    "L": 39.2543157441979,
    "a": 7.90944199537538,
    "b": 4.47558304982436,
    "C": 9.0879104481769,
    "h": 0.51493304700202,
    "CMY_C": 0.5763355,
    "CMY_M": 0.6552626,
    "CMY_Y": 0.667545,
    "CMYK_C": 0,
    "CMYK_M": 0.1862962,
    "CMYK_Y": 0.2152871,
    "CMYK_K": 0.5763355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02009",
    "Farbtonhilfsbezeichnung": "L0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "97",
    "Bcolor": "87",
    "Y": 12,
    "L": 39.9829401643939,
    "a": -6.49792125910256,
    "b": 3.62969545637697,
    "C": 7.44296109055668,
    "h": -0.50941682659037,
    "CMY_C": 0.6649538,
    "CMY_M": 0.618654,
    "CMY_Y": 0.6573132,
    "CMYK_C": 0.1214117,
    "CMYK_M": 0,
    "CMYK_Y": 0.1013757,
    "CMYK_K": 0.618654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02010",
    "Farbtonhilfsbezeichnung": "H6.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "219",
    "Bcolor": "196",
    "Y": 73,
    "L": 86.8004919721609,
    "a": -3.74020070400799,
    "b": 10.5906543891934,
    "C": 11.2316989675473,
    "h": -1.23130870454584,
    "CMY_C": 0.1428389,
    "CMY_M": 0.1413991,
    "CMY_Y": 0.2326013,
    "CMYK_C": 0.001676935,
    "CMYK_M": 0,
    "CMYK_Y": 0.1062219,
    "CMYK_K": 0.1413991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02013",
    "Farbtonhilfsbezeichnung": "S0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "164",
    "Y": 19,
    "L": 48.1645647051783,
    "a": -19.4817325258135,
    "b": -30.5279088405035,
    "C": 36.2145153271645,
    "h": 1.00278857843508,
    "CMY_C": 1,
    "CMY_M": 0.5063014,
    "CMY_Y": 0.3567312,
    "CMYK_C": 1,
    "CMYK_M": 0.2325158,
    "CMYK_Y": 0,
    "CMYK_K": 0.3567312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02014",
    "Farbtonhilfsbezeichnung": "P0.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "103",
    "Bcolor": "103",
    "Y": 14,
    "L": 42.9372818614046,
    "a": -3.6673217840214,
    "b": -1.39924315313711,
    "C": 3.92519177482566,
    "h": 0.36449514657327,
    "CMY_C": 0.6327769,
    "CMY_M": 0.5944907,
    "CMY_Y": 0.5971634,
    "CMYK_C": 0.09441512,
    "CMYK_M": 0,
    "CMYK_Y": 0.006591015,
    "CMYK_K": 0.5944907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02015",
    "Farbtonhilfsbezeichnung": "J0.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "73",
    "Bcolor": "55",
    "Y": 7,
    "L": 29.9386642468963,
    "a": -5.90375159753903,
    "b": 9.35460017217257,
    "C": 11.0617732442252,
    "h": -1.0078176664447,
    "CMY_C": 0.737569,
    "CMY_M": 0.7144311,
    "CMY_Y": 0.7830266,
    "CMYK_C": 0.0810238,
    "CMYK_M": 0,
    "CMYK_Y": 0.2402063,
    "CMYK_K": 0.7144311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02016",
    "Farbtonhilfsbezeichnung": "J0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "120",
    "Bcolor": "77",
    "Y": 17,
    "L": 48.1072227537449,
    "a": -13.4321322286335,
    "b": 21.0934089915172,
    "C": 25.0070805791263,
    "h": -1.00376166277332,
    "CMY_C": 0.5909829,
    "CMY_M": 0.5302947,
    "CMY_Y": 0.6971319,
    "CMYK_C": 0.1292049,
    "CMYK_M": 0,
    "CMYK_Y": 0.3551954,
    "CMYK_K": 0.5302947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02019",
    "Farbtonhilfsbezeichnung": "J0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "93",
    "Bcolor": "69",
    "Y": 11,
    "L": 38.283378915551,
    "a": -6.71238657717368,
    "b": 12.8152401785373,
    "C": 14.4667382085603,
    "h": -1.08830496997081,
    "CMY_C": 0.6580607,
    "CMY_M": 0.6362138,
    "CMY_Y": 0.7310893,
    "CMYK_C": 0.06005424,
    "CMYK_M": 0,
    "CMYK_Y": 0.2608001,
    "CMYK_K": 0.6362138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02020",
    "Farbtonhilfsbezeichnung": "F2.15.45",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "123",
    "Bcolor": "100",
    "Y": 21,
    "L": 52.5504510456669,
    "a": 2.665285586882,
    "b": 14.2406151703982,
    "C": 14.4878869298119,
    "h": 1.38577603220477,
    "CMY_C": 0.4540878,
    "CMY_M": 0.5170572,
    "CMY_Y": 0.6065224,
    "CMYK_C": 0,
    "CMYK_M": 0.1153472,
    "CMYK_Y": 0.2792291,
    "CMYK_K": 0.4540878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02021",
    "Farbtonhilfsbezeichnung": "D6.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "136",
    "Gcolor": "124",
    "Bcolor": "117",
    "Y": 22,
    "L": 52.7606611888483,
    "a": 3.57730272247775,
    "b": 4.90503096507438,
    "C": 6.07094914626907,
    "h": 0.94066690309406,
    "CMY_C": 0.4678255,
    "CMY_M": 0.5149104,
    "CMY_Y": 0.5422242,
    "CMYK_C": 0,
    "CMYK_M": 0.0884764,
    "CMYK_Y": 0.1398014,
    "CMYK_K": 0.4678255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02022",
    "Farbtonhilfsbezeichnung": "D6.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "101",
    "Bcolor": "96",
    "Y": 15,
    "L": 43.512733034353,
    "a": 2.49883144965757,
    "b": 3.44402846584112,
    "C": 4.25505472201259,
    "h": 0.94312456379603,
    "CMY_C": 0.5706942,
    "CMY_M": 0.6026623,
    "CMY_Y": 0.6218844,
    "CMYK_C": 0,
    "CMYK_M": 0.07446449,
    "CMYK_Y": 0.1192394,
    "CMYK_K": 0.5706942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02023",
    "Farbtonhilfsbezeichnung": "L8.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "184",
    "Bcolor": "135",
    "Y": 38,
    "L": 67.4864440145266,
    "a": -43.0399237827724,
    "b": 14.6029592422085,
    "C": 45.4497685126829,
    "h": -0.32710076311899,
    "CMY_C": 0.7197419,
    "CMY_M": 0.2795601,
    "CMY_Y": 0.4687259,
    "CMYK_C": 0.6109903,
    "CMYK_M": 0,
    "CMYK_Y": 0.2625697,
    "CMYK_K": 0.2795601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02026",
    "Farbtonhilfsbezeichnung": "W0.20.10",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "46",
    "Bcolor": "68",
    "Y": 4,
    "L": 19.9354103910033,
    "a": 7.29279823391338,
    "b": -13.8253151800404,
    "C": 15.6308747646453,
    "h": -1.08539466036471,
    "CMY_C": 0.8100682,
    "CMY_M": 0.8213606,
    "CMY_Y": 0.7341782,
    "CMYK_C": 0.2854918,
    "CMYK_M": 0.3279733,
    "CMYK_Y": 0,
    "CMYK_K": 0.7341782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02027",
    "Farbtonhilfsbezeichnung": "K2.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "180",
    "Bcolor": "91",
    "Y": 37,
    "L": 66.6467946562947,
    "a": -42.3582083842056,
    "b": 37.1990255781424,
    "C": 56.3736225683881,
    "h": -0.72064014353181,
    "CMY_C": 0.6098859,
    "CMY_M": 0.293258,
    "CMY_Y": 0.6428413,
    "CMYK_C": 0.4480106,
    "CMYK_M": 0,
    "CMYK_Y": 0.4946406,
    "CMYK_K": 0.293258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02028",
    "Farbtonhilfsbezeichnung": "G8.10.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "79",
    "Bcolor": "67",
    "Y": 9,
    "L": 33.6981808797559,
    "a": -0.86777215118719,
    "b": 7.38487554440528,
    "C": 7.4356852618122,
    "h": -1.45382605438483,
    "CMY_C": 0.6759818,
    "CMY_M": 0.6889828,
    "CMY_Y": 0.737267,
    "CMYK_C": 0,
    "CMYK_M": 0.04012431,
    "CMYK_Y": 0.1891412,
    "CMYK_K": 0.6759818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02029",
    "Farbtonhilfsbezeichnung": "D6.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "79",
    "Bcolor": "56",
    "Y": 11,
    "L": 38.7255877718638,
    "a": 18.3310271191411,
    "b": 22.0845770636163,
    "C": 28.7011341121129,
    "h": 0.87800628841587,
    "CMY_C": 0.4966401,
    "CMY_M": 0.6899655,
    "CMY_Y": 0.7818764,
    "CMYK_C": 0,
    "CMYK_M": 0.3840698,
    "CMYK_Y": 0.5666648,
    "CMYK_K": 0.4966401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02031",
    "Farbtonhilfsbezeichnung": "Y0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "82",
    "Bcolor": "96",
    "Y": 11,
    "L": 36.9609438604818,
    "a": 10.0341655717161,
    "b": -6.16206426977959,
    "C": 11.7752076323735,
    "h": -0.55072870901383,
    "CMY_C": 0.6122493,
    "CMY_M": 0.6787677,
    "CMY_Y": 0.6225566,
    "CMYK_C": 0,
    "CMYK_M": 0.1715495,
    "CMYK_Y": 0.02658221,
    "CMYK_K": 0.6122493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02032",
    "Farbtonhilfsbezeichnung": "Y0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "63",
    "Bcolor": "75",
    "Y": 9,
    "L": 28.1840611670661,
    "a": 7.98008278486514,
    "b": -5.72649653619108,
    "C": 9.82214252759089,
    "h": -0.62243974312725,
    "CMY_C": 0.7059224,
    "CMY_M": 0.7539848,
    "CMY_Y": 0.7067751,
    "CMYK_C": 0,
    "CMYK_M": 0.1634344,
    "CMYK_Y": 0.002899706,
    "CMYK_K": 0.7059224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02036",
    "Farbtonhilfsbezeichnung": "F2.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "89",
    "Bcolor": "59",
    "Y": 11,
    "L": 39.1051088462796,
    "a": 3.93034120730837,
    "b": 19.88179523109,
    "C": 20.2665577643777,
    "h": 1.37562730395145,
    "CMY_C": 0.572659,
    "CMY_M": 0.6508299,
    "CMY_Y": 0.7673799,
    "CMYK_C": 0,
    "CMYK_M": 0.1829238,
    "CMYK_Y": 0.4556569,
    "CMYK_K": 0.572659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02037",
    "Farbtonhilfsbezeichnung": "F2.50.60",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "155",
    "Bcolor": "71",
    "Y": 37,
    "L": 67.2224960327148,
    "a": 10.0408449172974,
    "b": 49.6039047241211,
    "C": 50.6099395751953,
    "h": 78.5567779541016,
    "CMY_C": 0.19663256406784,
    "CMY_M": 0.39131653308868,
    "CMY_Y": 0.7212131023407,
    "CMYK_C": 0,
    "CMYK_M": 0.24233490228653,
    "CMYK_Y": 0.65297710895538,
    "CMYK_K": 0.19663256406784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02039",
    "Farbtonhilfsbezeichnung": "A6.25.05",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "59",
    "Bcolor": "61",
    "Y": 5,
    "L": 27.7908363342285,
    "a": 11.0990543365479,
    "b": 2.81418561935425,
    "C": 11.4502687454224,
    "h": 14.227617263794,
    "CMY_C": 0.67210382223129,
    "CMY_M": 0.76684176921844,
    "CMY_Y": 0.76031279563904,
    "CMYK_C": 0,
    "CMYK_M": 0.28892666101456,
    "CMYK_Y": 0.26901495456696,
    "CMYK_K": 0.67210382223129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02045",
    "Farbtonhilfsbezeichnung": "C8.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "110",
    "Bcolor": "104",
    "Y": 18,
    "L": 48.4921327536675,
    "a": 7.8484904594891,
    "b": 6.43518882682959,
    "C": 10.1494067673753,
    "h": 0.68677396710206,
    "CMY_C": 0.4800893,
    "CMY_M": 0.5670837,
    "CMY_Y": 0.5930381,
    "CMYK_C": 0,
    "CMYK_M": 0.1673257,
    "CMYK_Y": 0.2172466,
    "CMYK_K": 0.4800893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02046",
    "Farbtonhilfsbezeichnung": "C8.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "65",
    "Bcolor": "55",
    "Y": 8,
    "L": 31.4251078456422,
    "a": 15.2664497323581,
    "b": 12.520608850843,
    "C": 19.744116425569,
    "h": 0.68690068118179,
    "CMY_C": 0.5993205,
    "CMY_M": 0.7469522,
    "CMY_Y": 0.7860624,
    "CMYK_C": 0,
    "CMYK_M": 0.3684533,
    "CMYK_Y": 0.4660631,
    "CMYK_K": 0.5993205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02047",
    "Farbtonhilfsbezeichnung": "CN.02.17",
    "Farbtonklasse": "02",
    "Rcolor": "63",
    "Gcolor": "60",
    "Bcolor": "59",
    "Y": 6,
    "L": 25.529638794802,
    "a": 1.4842598213011,
    "b": 0.79593655215286,
    "C": 1.68420373238565,
    "h": 0.49222650008596,
    "CMY_C": 0.7515873,
    "CMY_M": 0.7656404,
    "CMY_Y": 0.7693985,
    "CMYK_C": 0,
    "CMYK_M": 0.05657182,
    "CMYK_Y": 0.07169986,
    "CMYK_K": 0.7515873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02048",
    "Farbtonhilfsbezeichnung": "CN.02.27",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "85",
    "Bcolor": "83",
    "Y": 10,
    "L": 36.2913997530729,
    "a": 1.61067192486219,
    "b": 0.77895963229799,
    "C": 1.78914565038431,
    "h": 0.45046120879307,
    "CMY_C": 0.6525689,
    "CMY_M": 0.6684721,
    "CMY_Y": 0.6727149,
    "CMYK_C": 0,
    "CMYK_M": 0.04577363,
    "CMYK_Y": 0.05798588,
    "CMYK_K": 0.6525689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02049",
    "Farbtonhilfsbezeichnung": "CN.02.37",
    "Farbtonklasse": "01",
    "Rcolor": "111",
    "Gcolor": "106",
    "Bcolor": "105",
    "Y": 16,
    "L": 45.2331366755224,
    "a": 2.08929063018043,
    "b": 0.94271200075168,
    "C": 2.2921259244904,
    "h": 0.42386097017774,
    "CMY_C": 0.5633394,
    "CMY_M": 0.5845959,
    "CMY_Y": 0.5894968,
    "CMYK_C": 0,
    "CMYK_M": 0.04867953,
    "CMYK_Y": 0.05990328,
    "CMYK_K": 0.5633394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02050",
    "Farbtonhilfsbezeichnung": "D6.05.15",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "65",
    "Y": 6,
    "L": 29.3701510102643,
    "a": 1.6465169433787,
    "b": 2.71588948957077,
    "C": 3.17601539108268,
    "h": 1.02579150005157,
    "CMY_C": 0.7113458,
    "CMY_M": 0.732279,
    "CMY_Y": 0.7470361,
    "CMYK_C": 0,
    "CMYK_M": 0.07251999,
    "CMYK_Y": 0.1236438,
    "CMYK_K": 0.7113458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02051",
    "Farbtonhilfsbezeichnung": "D6.05.25",
    "Farbtonklasse": "02",
    "Rcolor": "86",
    "Gcolor": "79",
    "Bcolor": "75",
    "Y": 9,
    "L": 34.0325524536798,
    "a": 2.44371637690727,
    "b": 2.93142669046331,
    "C": 3.81641352218617,
    "h": 0.87588477638523,
    "CMY_C": 0.6629195,
    "CMY_M": 0.6915711,
    "CMY_Y": 0.7065136,
    "CMYK_C": 0,
    "CMYK_M": 0.08499906,
    "CMYK_Y": 0.1293285,
    "CMYK_K": 0.6629195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02052",
    "Farbtonhilfsbezeichnung": "D6.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "92",
    "Bcolor": "44",
    "Y": 17,
    "L": 48.7535052045027,
    "a": 31.8561566884645,
    "b": 42.0291423711396,
    "C": 52.7376860263467,
    "h": 0.92222406121567,
    "CMY_C": 0.2991805,
    "CMY_M": 0.6390315,
    "CMY_Y": 0.827969,
    "CMYK_C": 0,
    "CMYK_M": 0.4849336,
    "CMYK_Y": 0.7545287,
    "CMYK_K": 0.2991805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02055",
    "Farbtonhilfsbezeichnung": "E4.05.25",
    "Farbtonklasse": "02",
    "Rcolor": "83",
    "Gcolor": "77",
    "Bcolor": "73",
    "Y": 9,
    "L": 33.268480637577,
    "a": 1.52407903152088,
    "b": 3.05483477848145,
    "C": 3.41391745918695,
    "h": 1.10802334886948,
    "CMY_C": 0.6754221,
    "CMY_M": 0.6967446,
    "CMY_Y": 0.7142888,
    "CMYK_C": 0,
    "CMYK_M": 0.06569313,
    "CMYK_Y": 0.1197453,
    "CMYK_K": 0.6754221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02056",
    "Farbtonhilfsbezeichnung": "E4.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "68",
    "Bcolor": "49",
    "Y": 8,
    "L": 30.5158337825592,
    "a": 6.04544359026024,
    "b": 14.2623984012757,
    "C": 15.4907519623719,
    "h": 1.16988076493715,
    "CMY_C": 0.6537124,
    "CMY_M": 0.7333802,
    "CMY_Y": 0.8061781,
    "CMYK_C": 0,
    "CMYK_M": 0.2300625,
    "CMYK_Y": 0.4402863,
    "CMYK_K": 0.6537124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02057",
    "Farbtonhilfsbezeichnung": "E4.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "87",
    "Bcolor": "62",
    "Y": 11,
    "L": 39.1767705675001,
    "a": 8.35138374753661,
    "b": 18.329284568661,
    "C": 20.1422015504158,
    "h": 1.14326983138513,
    "CMY_C": 0.5495719,
    "CMY_M": 0.6598188,
    "CMY_Y": 0.7558164,
    "CMYK_C": 0,
    "CMYK_M": 0.2447603,
    "CMYK_Y": 0.4578855,
    "CMYK_K": 0.5495719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02058",
    "Farbtonhilfsbezeichnung": "E4.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "86",
    "Bcolor": "54",
    "Y": 12,
    "L": 39.6172112608301,
    "a": 11.3494716583114,
    "b": 23.8941653981781,
    "C": 26.452630247261,
    "h": 1.12735676293383,
    "CMY_C": 0.5215225,
    "CMY_M": 0.6637525,
    "CMY_Y": 0.7875584,
    "CMYK_C": 0,
    "CMYK_M": 0.2972553,
    "CMYK_Y": 0.5560051,
    "CMYK_K": 0.5215225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02059",
    "Farbtonhilfsbezeichnung": "E8.10.25",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "74",
    "Bcolor": "62",
    "Y": 8,
    "L": 32.1668415976163,
    "a": 3.19485164716415,
    "b": 8.27941203759512,
    "C": 8.8744431225662,
    "h": 1.20252213786568,
    "CMY_C": 0.6641331,
    "CMY_M": 0.711311,
    "CMY_Y": 0.7557396,
    "CMYK_C": 0,
    "CMYK_M": 0.140466,
    "CMYK_Y": 0.2727464,
    "CMYK_K": 0.6641331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02060",
    "Farbtonhilfsbezeichnung": "E8.10.30",
    "Farbtonklasse": "02",
    "Rcolor": "103",
    "Gcolor": "92",
    "Bcolor": "80",
    "Y": 12,
    "L": 39.8043059335691,
    "a": 2.67838347910421,
    "b": 7.86622187066954,
    "C": 8.30970424141186,
    "h": 1.24261711144363,
    "CMY_C": 0.5950577,
    "CMY_M": 0.6393514,
    "CMY_Y": 0.6845315,
    "CMYK_C": 0,
    "CMYK_M": 0.1093827,
    "CMYK_Y": 0.2209544,
    "CMYK_K": 0.5950577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02061",
    "Farbtonhilfsbezeichnung": "E8.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "90",
    "Bcolor": "71",
    "Y": 12,
    "L": 39.3558033314027,
    "a": 4.44212252622386,
    "b": 13.2528908590602,
    "C": 13.9775380042462,
    "h": 1.24738343461093,
    "CMY_C": 0.578146,
    "CMY_M": 0.6484358,
    "CMY_Y": 0.7224608,
    "CMYK_C": 0,
    "CMYK_M": 0.1666212,
    "CMYK_Y": 0.3420964,
    "CMYK_K": 0.578146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02062",
    "Farbtonhilfsbezeichnung": "E8.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "119",
    "Bcolor": "88",
    "Y": 22,
    "L": 52.2059605688158,
    "a": 7.35251191412817,
    "b": 21.0730193327799,
    "C": 22.3188614236281,
    "h": 1.23509606787015,
    "CMY_C": 0.4161898,
    "CMY_M": 0.5324917,
    "CMY_Y": 0.6548997,
    "CMYK_C": 0,
    "CMYK_M": 0.1992119,
    "CMYK_Y": 0.4088826,
    "CMYK_K": 0.4161898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02063",
    "Farbtonhilfsbezeichnung": "E8.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "90",
    "Bcolor": "63",
    "Y": 12,
    "L": 39.9628919059519,
    "a": 6.48620411995932,
    "b": 18.9825098074242,
    "C": 20.0600728432061,
    "h": 1.24154040283975,
    "CMY_C": 0.5510048,
    "CMY_M": 0.6482813,
    "CMY_Y": 0.7534083,
    "CMYK_C": 0,
    "CMYK_M": 0.2166537,
    "CMYK_Y": 0.4507921,
    "CMYK_K": 0.5510048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02064",
    "Farbtonhilfsbezeichnung": "E8.35.45",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "119",
    "Bcolor": "72",
    "Y": 22,
    "L": 52.9556128215708,
    "a": 10.5068035995468,
    "b": 31.0296810621164,
    "C": 32.7602507422656,
    "h": 1.24430884440999,
    "CMY_C": 0.3754035,
    "CMY_M": 0.5343549,
    "CMY_Y": 0.7158965,
    "CMYK_C": 0,
    "CMYK_M": 0.2544866,
    "CMYK_Y": 0.5451407,
    "CMYK_K": 0.3754035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02065",
    "Farbtonhilfsbezeichnung": "E8.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "106",
    "Bcolor": "60",
    "Y": 17,
    "L": 47.7385098632143,
    "a": 10.6705834210025,
    "b": 31.3835937027256,
    "C": 33.1480211210614,
    "h": 1.24305320548337,
    "CMY_C": 0.4305508,
    "CMY_M": 0.5858486,
    "CMY_Y": 0.7663122,
    "CMYK_C": 0,
    "CMYK_M": 0.2727159,
    "CMYK_Y": 0.5896249,
    "CMYK_K": 0.4305508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02066",
    "Farbtonhilfsbezeichnung": "F2.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "84",
    "Bcolor": "79",
    "Y": 10,
    "L": 35.8396260189089,
    "a": 0.69491910119989,
    "b": 2.66528856881922,
    "C": 2.75439207671873,
    "h": 1.31574517084838,
    "CMY_C": 0.6576608,
    "CMY_M": 0.6712618,
    "CMY_Y": 0.6886403,
    "CMYK_C": 0,
    "CMYK_M": 0.03972985,
    "CMYK_Y": 0.09049375,
    "CMYK_K": 0.6576608
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02067",
    "Farbtonhilfsbezeichnung": "F2.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "67",
    "Bcolor": "59",
    "Y": 7,
    "L": 28.9040380716652,
    "a": 0.99615924325263,
    "b": 5.79953638110027,
    "C": 5.88446730585048,
    "h": 1.40069093286868,
    "CMY_C": 0.7123982,
    "CMY_M": 0.735827,
    "CMY_Y": 0.7696423,
    "CMYK_C": 0,
    "CMYK_M": 0.08146265,
    "CMYK_Y": 0.1990395,
    "CMYK_K": 0.7123982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02068",
    "Farbtonhilfsbezeichnung": "F2.10.30",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "88",
    "Bcolor": "76",
    "Y": 11,
    "L": 38.0393820151719,
    "a": 1.87077048594553,
    "b": 8.07515758030001,
    "C": 8.28902600778653,
    "h": 1.34314257232544,
    "CMY_C": 0.6165755,
    "CMY_M": 0.6543066,
    "CMY_Y": 0.7020912,
    "CMYK_C": 0,
    "CMYK_M": 0.09840541,
    "CMYK_Y": 0.2230312,
    "CMYK_K": 0.6165755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02069",
    "Farbtonhilfsbezeichnung": "F2.15.25",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "77",
    "Bcolor": "64",
    "Y": 9,
    "L": 33.473322424235,
    "a": 2.03699764093429,
    "b": 8.72148281654045,
    "C": 8.95620577635319,
    "h": 1.34134855892997,
    "CMY_C": 0.6576901,
    "CMY_M": 0.6970944,
    "CMY_Y": 0.7470759,
    "CMYK_C": 0,
    "CMYK_M": 0.115113,
    "CMYK_Y": 0.2611252,
    "CMYK_K": 0.6576901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02070",
    "Farbtonhilfsbezeichnung": "F2.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "105",
    "Bcolor": "90",
    "Y": 14,
    "L": 45.2212905883789,
    "a": 2.39722013473511,
    "b": 9.88835334777832,
    "C": 10.1747827529907,
    "h": 76.3727645874023,
    "CMY_C": 0.53917157649994,
    "CMY_M": 0.58740067481995,
    "CMY_Y": 0.64726853370667,
    "CMYK_C": 0,
    "CMYK_M": 0.10465738922358,
    "CMYK_Y": 0.23457093536854,
    "CMYK_K": 0.53917157649994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02071",
    "Farbtonhilfsbezeichnung": "F2.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "69",
    "Bcolor": "55",
    "Y": 7,
    "L": 29.8407870079459,
    "a": 1.97079673059294,
    "b": 9.46979003321128,
    "C": 9.67269161228784,
    "h": 1.36561107066673,
    "CMY_C": 0.6906399,
    "CMY_M": 0.7300649,
    "CMY_Y": 0.7834485,
    "CMYK_C": 0,
    "CMYK_M": 0.1274402,
    "CMYK_Y": 0.3000018,
    "CMYK_K": 0.6906399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02072",
    "Farbtonhilfsbezeichnung": "F2.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "68",
    "Bcolor": "46",
    "Y": 8,
    "L": 29.9738901538773,
    "a": 2.89246905527951,
    "b": 15.8939869364052,
    "C": 16.1550363035917,
    "h": 1.39078123952695,
    "CMY_C": 0.6735047,
    "CMY_M": 0.7318315,
    "CMY_Y": 0.8214335,
    "CMYK_C": 0,
    "CMYK_M": 0.178645,
    "CMYK_Y": 0.4530811,
    "CMYK_K": 0.6735047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02073",
    "Farbtonhilfsbezeichnung": "F2.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "109",
    "Bcolor": "53",
    "Y": 18,
    "L": 48.8981864608683,
    "a": 8.93381747420074,
    "b": 36.444966594098,
    "C": 37.5239747988836,
    "h": 1.33040479327331,
    "CMY_C": 0.4221267,
    "CMY_M": 0.5710481,
    "CMY_Y": 0.7929944,
    "CMYK_C": 0,
    "CMYK_M": 0.2577059,
    "CMYK_Y": 0.6417803,
    "CMYK_K": 0.4221267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02074",
    "Farbtonhilfsbezeichnung": "F2.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "133",
    "Bcolor": "64",
    "Y": 26,
    "L": 58.4640731811523,
    "a": 10.0000410079956,
    "b": 42.5748558044434,
    "C": 43.7335014343262,
    "h": 76.7818908691406,
    "CMY_C": 0.3040736913681,
    "CMY_M": 0.47972762584686,
    "CMY_Y": 0.74984335899353,
    "CMYK_C": 0,
    "CMYK_M": 0.25240308046341,
    "CMYK_Y": 0.64054149389267,
    "CMYK_K": 0.3040736913681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02075",
    "Farbtonhilfsbezeichnung": "F6.15.25",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "82",
    "Bcolor": "68",
    "Y": 9,
    "L": 35.0671323544588,
    "a": 0.80874141721154,
    "b": 8.59446270493462,
    "C": 8.63243024104021,
    "h": 1.4769723206638,
    "CMY_C": 0.6502351,
    "CMY_M": 0.6799108,
    "CMY_Y": 0.732285,
    "CMYK_C": 0,
    "CMYK_M": 0.08484458,
    "CMYK_Y": 0.2345858,
    "CMYK_K": 0.6502351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02076",
    "Farbtonhilfsbezeichnung": "F6.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "71",
    "Bcolor": "56",
    "Y": 7,
    "L": 30.5139299502122,
    "a": 0.84495950848562,
    "b": 10.1425014101464,
    "C": 10.1776368291368,
    "h": 1.48767947015751,
    "CMY_C": 0.6895847,
    "CMY_M": 0.7218844,
    "CMY_Y": 0.7818711,
    "CMYK_C": 0,
    "CMYK_M": 0.104053,
    "CMYK_Y": 0.2972996,
    "CMYK_K": 0.6895847
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02077",
    "Farbtonhilfsbezeichnung": "F6.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "85",
    "Bcolor": "63",
    "Y": 10,
    "L": 36.7706839041055,
    "a": 1.81046511246377,
    "b": 14.3534750523797,
    "C": 14.4672053280077,
    "h": 1.44532466789617,
    "CMY_C": 0.6167911,
    "CMY_M": 0.6672263,
    "CMY_Y": 0.7530001,
    "CMYK_C": 0,
    "CMYK_M": 0.1316127,
    "CMYK_Y": 0.3554431,
    "CMYK_K": 0.6167911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02078",
    "Farbtonhilfsbezeichnung": "F6.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "114",
    "Bcolor": "85",
    "Y": 18,
    "L": 48.7824248891086,
    "a": 2.04017401584561,
    "b": 17.7361943349856,
    "C": 17.8531481678529,
    "h": 1.45627082789968,
    "CMY_C": 0.4896495,
    "CMY_M": 0.5535423,
    "CMY_Y": 0.665557,
    "CMYK_C": 0,
    "CMYK_M": 0.1251939,
    "CMYK_Y": 0.3446797,
    "CMYK_K": 0.4896495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02079",
    "Farbtonhilfsbezeichnung": "F6.25.65",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "174",
    "Bcolor": "122",
    "Y": 45,
    "L": 72.5925375949217,
    "a": 3.76284022064738,
    "b": 30.3009007365062,
    "C": 30.5336462278864,
    "h": 1.44724638116307,
    "CMY_C": 0.2010924,
    "CMY_M": 0.316867,
    "CMY_Y": 0.5227093,
    "CMYK_C": 0,
    "CMYK_M": 0.1449161,
    "CMYK_Y": 0.4025708,
    "CMYK_K": 0.2010924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02080",
    "Farbtonhilfsbezeichnung": "F6.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "72",
    "Bcolor": "50",
    "Y": 7,
    "L": 31.2139009811675,
    "a": 1.62130700858357,
    "b": 14.5877168188962,
    "C": 14.677537886321,
    "h": 1.46010866219863,
    "CMY_C": 0.6707654,
    "CMY_M": 0.7178701,
    "CMY_Y": 0.8029893,
    "CMYK_C": 0,
    "CMYK_M": 0.1430733,
    "CMYK_Y": 0.4016099,
    "CMYK_K": 0.6707654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02081",
    "Farbtonhilfsbezeichnung": "F6.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "91",
    "Bcolor": "63",
    "Y": 12,
    "L": 39.6634695937243,
    "a": 2.29665409251298,
    "b": 18.5954324845994,
    "C": 18.7367214130422,
    "h": 1.44791226708595,
    "CMY_C": 0.5784274,
    "CMY_M": 0.6418792,
    "CMY_Y": 0.7543762,
    "CMYK_C": 0,
    "CMYK_M": 0.1505122,
    "CMYK_Y": 0.417363,
    "CMYK_K": 0.5784274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02082",
    "Farbtonhilfsbezeichnung": "F6.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "111",
    "Bcolor": "69",
    "Y": 17,
    "L": 47.6635441998506,
    "a": 2.39484778726096,
    "b": 25.5904450004243,
    "C": 25.7022600415584,
    "h": 1.47748442798219,
    "CMY_C": 0.4859112,
    "CMY_M": 0.5665621,
    "CMY_Y": 0.7287721,
    "CMYK_C": 0,
    "CMYK_M": 0.1568814,
    "CMYK_Y": 0.4724104,
    "CMYK_K": 0.4859112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02083",
    "Farbtonhilfsbezeichnung": "F6.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "134",
    "Bcolor": "86",
    "Y": 25,
    "L": 57.3609699221415,
    "a": 3.16977857676631,
    "b": 29.3244764097495,
    "C": 29.4952947591931,
    "h": 1.46312112164707,
    "CMY_C": 0.3733149,
    "CMY_M": 0.4727581,
    "CMY_Y": 0.6642596,
    "CMYK_C": 0,
    "CMYK_M": 0.1586812,
    "CMYK_Y": 0.4642597,
    "CMYK_K": 0.3733149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02084",
    "Farbtonhilfsbezeichnung": "F6.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "89",
    "Bcolor": "51",
    "Y": 11,
    "L": 38.8049758386514,
    "a": 1.58291970225324,
    "b": 24.284227488945,
    "C": 24.3357625629157,
    "h": 1.50570537220424,
    "CMY_C": 0.5827003,
    "CMY_M": 0.6493036,
    "CMY_Y": 0.7995983,
    "CMYK_C": 0,
    "CMYK_M": 0.1596054,
    "CMYK_Y": 0.5197655,
    "CMYK_K": 0.5827003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02085",
    "Farbtonhilfsbezeichnung": "F6.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "110",
    "Bcolor": "62",
    "Y": 17,
    "L": 47.7177310374918,
    "a": 3.45522556568656,
    "b": 29.9050301653158,
    "C": 30.1039766957493,
    "h": 1.45576643447174,
    "CMY_C": 0.4731762,
    "CMY_M": 0.5689993,
    "CMY_Y": 0.7579824,
    "CMYK_C": 0,
    "CMYK_M": 0.1818884,
    "CMYK_Y": 0.54061,
    "CMYK_K": 0.4731762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02086",
    "Farbtonhilfsbezeichnung": "F6.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "131",
    "Bcolor": "63",
    "Y": 24,
    "L": 56.1251143810562,
    "a": 3.73540906446357,
    "b": 39.6160209046589,
    "C": 39.791737750408,
    "h": 1.47678391567149,
    "CMY_C": 0.3695319,
    "CMY_M": 0.487934,
    "CMY_Y": 0.7512303,
    "CMYK_C": 0,
    "CMYK_M": 0.1878002,
    "CMYK_Y": 0.6054206,
    "CMYK_K": 0.3695319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02087",
    "Farbtonhilfsbezeichnung": "F6.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "159",
    "Bcolor": "79",
    "Y": 38,
    "L": 67.2308743768668,
    "a": 4.78102874652159,
    "b": 45.6984610346941,
    "C": 45.947878915294,
    "h": 1.46655433335229,
    "CMY_C": 0.2323127,
    "CMY_M": 0.37788,
    "CMY_Y": 0.6913842,
    "CMYK_C": 0,
    "CMYK_M": 0.189618,
    "CMYK_Y": 0.5979928,
    "CMYK_K": 0.2323127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02088",
    "Farbtonhilfsbezeichnung": "F6.50.40",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "108",
    "Bcolor": "45",
    "Y": 17,
    "L": 47.2904939352345,
    "a": 4.84195008334481,
    "b": 38.3099205366238,
    "C": 38.6146926976252,
    "h": 1.44507399938272,
    "CMY_C": 0.4602942,
    "CMY_M": 0.577305,
    "CMY_Y": 0.8235027,
    "CMYK_C": 0,
    "CMYK_M": 0.2168047,
    "CMYK_Y": 0.672975,
    "CMYK_K": 0.4602942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02089",
    "Farbtonhilfsbezeichnung": "F6.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "157",
    "Bcolor": "61",
    "Y": 37,
    "L": 66.5192103858829,
    "a": 3.53437330178269,
    "b": 53.3191502654787,
    "C": 53.4361635942275,
    "h": 1.50460603249747,
    "CMY_C": 0.2395892,
    "CMY_M": 0.3832164,
    "CMY_Y": 0.7626925,
    "CMYK_C": 0,
    "CMYK_M": 0.1888811,
    "CMYK_Y": 0.687922,
    "CMYK_K": 0.2395892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02090",
    "Farbtonhilfsbezeichnung": "F6.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "157",
    "Bcolor": "46",
    "Y": 39,
    "L": 67.1338729858398,
    "a": 5.88715744018555,
    "b": 59.9285011291504,
    "C": 60.2169723510742,
    "h": 84.3894729614258,
    "CMY_C": 0.21242809295654,
    "CMY_M": 0.3831073641777,
    "CMY_Y": 0.81867396831512,
    "CMYK_C": 0,
    "CMYK_M": 0.21671579778194,
    "CMYK_Y": 0.76976573467255,
    "CMYK_K": 0.21242809295654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02091",
    "Farbtonhilfsbezeichnung": "F6.60.70",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "181",
    "Bcolor": "44",
    "Y": 53,
    "L": 76.3528747558594,
    "a": 6.25578594207764,
    "b": 70.1937866210938,
    "C": 70.4720001220703,
    "h": 84.9071578979492,
    "CMY_C": 0.09277349710464,
    "CMY_M": 0.28835332393646,
    "CMY_Y": 0.82797908782959,
    "CMYK_C": 0,
    "CMYK_M": 0.21557992696762,
    "CMYK_Y": 0.81038814783096,
    "CMYK_K": 0.09277349710464
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02092",
    "Farbtonhilfsbezeichnung": "F8.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "162",
    "Bcolor": "81",
    "Y": 39,
    "L": 68.2186284217315,
    "a": 2.87558209269984,
    "b": 45.7229452172303,
    "C": 45.8132807350631,
    "h": 1.50798760448953,
    "CMY_C": 0.2327261,
    "CMY_M": 0.3631085,
    "CMY_Y": 0.6824972,
    "CMYK_C": 0,
    "CMYK_M": 0.1699294,
    "CMYK_Y": 0.5861936,
    "CMYK_K": 0.2327261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02093",
    "Farbtonhilfsbezeichnung": "F8.45.55",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "152",
    "Bcolor": "67",
    "Y": 34,
    "L": 64.2851158996738,
    "a": 3.20996744934354,
    "b": 47.9054703746209,
    "C": 48.0128939227738,
    "h": 1.50389005820711,
    "CMY_C": 0.2726097,
    "CMY_M": 0.4048887,
    "CMY_Y": 0.7387122,
    "CMYK_C": 0,
    "CMYK_M": 0.1818542,
    "CMYK_Y": 0.6407874,
    "CMYK_K": 0.2726097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02094",
    "Farbtonhilfsbezeichnung": "FN.02.27",
    "Farbtonklasse": "02",
    "Rcolor": "87",
    "Gcolor": "85",
    "Bcolor": "82",
    "Y": 10,
    "L": 36.0802877165759,
    "a": 0.36077725606148,
    "b": 1.64733584400317,
    "C": 1.68637943874707,
    "h": 1.35519385447394,
    "CMY_C": 0.660267,
    "CMY_M": 0.6681207,
    "CMY_Y": 0.68018,
    "CMYK_C": 0,
    "CMYK_M": 0.02311737,
    "CMYK_Y": 0.0586137,
    "CMYK_K": 0.660267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02098",
    "Farbtonhilfsbezeichnung": "G0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "93",
    "Bcolor": "80",
    "Y": 12,
    "L": 39.7818461948379,
    "a": -0.11296116594977,
    "b": 7.88429556092056,
    "C": 7.88510473722223,
    "h": -1.55646994383224,
    "CMY_C": 0.6126044,
    "CMY_M": 0.6337938,
    "CMY_Y": 0.6852459,
    "CMYK_C": 0,
    "CMYK_M": 0.0546972,
    "CMYK_Y": 0.1875126,
    "CMYK_K": 0.6126044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02099",
    "Farbtonhilfsbezeichnung": "G0.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "68",
    "Bcolor": "52",
    "Y": 7,
    "L": 29.1897728619164,
    "a": -0.29216537625659,
    "b": 10.7928707094357,
    "C": 10.7968244756354,
    "h": -1.54373271697931,
    "CMY_C": 0.7071984,
    "CMY_M": 0.7317023,
    "CMY_Y": 0.7974063,
    "CMYK_C": 0,
    "CMYK_M": 0.08368757,
    "CMYK_Y": 0.3080854,
    "CMYK_K": 0.7071984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02100",
    "Farbtonhilfsbezeichnung": "G0.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "97",
    "Bcolor": "69",
    "Y": 11,
    "L": 41.6648597717285,
    "a": -0.04069277644157,
    "b": 17.4936428070068,
    "C": 17.4936904907227,
    "h": 90.1332778930664,
    "CMY_C": 0.57424962520599,
    "CMY_M": 0.61784714460373,
    "CMY_Y": 0.72968780994415,
    "CMYK_C": 0,
    "CMYK_M": 0.10240159928799,
    "CMYK_Y": 0.36509230732918,
    "CMYK_K": 0.57424962520599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02101",
    "Farbtonhilfsbezeichnung": "G0.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "136",
    "Bcolor": "66",
    "Y": 26,
    "L": 57.2742586336996,
    "a": -1.03615923553985,
    "b": 39.4577739949184,
    "C": 39.4713763960094,
    "h": -1.54454240885061,
    "CMY_C": 0.3856983,
    "CMY_M": 0.4657276,
    "CMY_Y": 0.7405852,
    "CMYK_C": 0,
    "CMYK_M": 0.1302769,
    "CMYK_Y": 0.5777078,
    "CMYK_K": 0.3856983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02102",
    "Farbtonhilfsbezeichnung": "G0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "137",
    "Bcolor": "52",
    "Y": 27,
    "L": 57.3325444526698,
    "a": -1.84602138888146,
    "b": 46.2646144300158,
    "C": 46.3014291715303,
    "h": -1.53091611486411,
    "CMY_C": 0.3820618,
    "CMY_M": 0.4641754,
    "CMY_Y": 0.7951863,
    "CMYK_C": 0,
    "CMYK_M": 0.1328832,
    "CMYK_Y": 0.6685531,
    "CMYK_K": 0.3820618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02103",
    "Farbtonhilfsbezeichnung": "G0.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "160",
    "Bcolor": "60",
    "Y": 36,
    "L": 66.9503555297852,
    "a": 0.26709613204002,
    "b": 53.8562393188477,
    "C": 53.8569030761719,
    "h": 89.7158432006836,
    "CMY_C": 0.25387936830521,
    "CMY_M": 0.37120497226715,
    "CMY_Y": 0.7645308971405,
    "CMYK_C": 0,
    "CMYK_M": 0.15724749863148,
    "CMYK_Y": 0.68440878391266,
    "CMYK_K": 0.25387936830521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02104",
    "Farbtonhilfsbezeichnung": "G0.55.70",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "187",
    "Bcolor": "47",
    "Y": 53,
    "L": 77.3705214491853,
    "a": 1.09401189482633,
    "b": 69.8190625718767,
    "C": 69.8276332152369,
    "h": 1.555128365469,
    "CMY_C": 0.112426,
    "CMY_M": 0.2650369,
    "CMY_Y": 0.8143879,
    "CMYK_C": 0,
    "CMYK_M": 0.1719416,
    "CMYK_Y": 0.790877,
    "CMYK_K": 0.112426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02105",
    "Farbtonhilfsbezeichnung": "G0.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "158",
    "Bcolor": "41",
    "Y": 37,
    "L": 66.3554169350847,
    "a": 1.75972390661344,
    "b": 60.7838814355102,
    "C": 60.8093485460391,
    "h": 1.54185390841991,
    "CMY_C": 0.2452232,
    "CMY_M": 0.3815165,
    "CMY_Y": 0.8394895,
    "CMYK_C": 0,
    "CMYK_M": 0.1805743,
    "CMYK_Y": 0.7873405,
    "CMYK_K": 0.2452232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02118",
    "Farbtonhilfsbezeichnung": "C4.30.70",
    "Farbtonklasse": "02",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02120",
    "Farbtonhilfsbezeichnung": "C4.40.60",
    "Farbtonklasse": "03",
    "Y": 30,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02144",
    "Farbtonhilfsbezeichnung": "H2.12.25",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "82",
    "Bcolor": "70",
    "Y": 8,
    "L": 34.331176995729,
    "a": -2.55956058215479,
    "b": 6.51657367604417,
    "C": 7.00122009717109,
    "h": -1.19653209731092,
    "CMY_C": 0.6827998,
    "CMY_M": 0.6797246,
    "CMY_Y": 0.726488,
    "CMYK_C": 0.009601704,
    "CMYK_M": 0,
    "CMYK_Y": 0.14601,
    "CMYK_K": 0.6797246
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02146",
    "Farbtonhilfsbezeichnung": "H2.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "144",
    "Bcolor": "73",
    "Y": 28,
    "L": 57.9469280576316,
    "a": -11.4862051719376,
    "b": 36.227568785367,
    "C": 38.0048634960098,
    "h": -1.26376526589582,
    "CMY_C": 0.4494244,
    "CMY_M": 0.4370697,
    "CMY_Y": 0.7125269,
    "CMYK_C": 0.02194702,
    "CMYK_M": 0,
    "CMYK_Y": 0.4893273,
    "CMYK_K": 0.4370697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02147",
    "Farbtonhilfsbezeichnung": "H2.45.45",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "135",
    "Bcolor": "66",
    "Y": 22,
    "L": 54.6130332946777,
    "a": -11.8986711502075,
    "b": 35.691951751709,
    "C": 37.623046875,
    "h": 108.436904907227,
    "CMY_C": 0.48776400089264,
    "CMY_M": 0.47004491090775,
    "CMY_Y": 0.74016582965851,
    "CMYK_C": 0.03343508020043,
    "CMYK_M": 0,
    "CMYK_Y": 0.50970530509949,
    "CMYK_K": 0.47004491090775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02148",
    "Farbtonhilfsbezeichnung": "H2.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "144",
    "Bcolor": "57",
    "Y": 26,
    "L": 57.7338752746582,
    "a": -13.5986642837524,
    "b": 43.7894477844238,
    "C": 45.8523635864258,
    "h": 107.251998901367,
    "CMY_C": 0.45453858375549,
    "CMY_M": 0.43607705831528,
    "CMY_Y": 0.77463960647583,
    "CMYK_C": 0.03273767232895,
    "CMYK_M": 0,
    "CMYK_Y": 0.60037022829056,
    "CMYK_K": 0.43607705831528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02149",
    "Farbtonhilfsbezeichnung": "H2.50.60",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "174",
    "Bcolor": "67",
    "Y": 37,
    "L": 68.7469482421875,
    "a": -15.8715591430664,
    "b": 52.0697250366211,
    "C": 54.4349403381348,
    "h": 106.951927185059,
    "CMY_C": 0.33967864513397,
    "CMY_M": 0.31815749406815,
    "CMY_Y": 0.73660588264465,
    "CMYK_C": 0.03156322985888,
    "CMYK_M": 0,
    "CMYK_Y": 0.61370241641998,
    "CMYK_K": 0.31815749406815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02158",
    "Farbtonhilfsbezeichnung": "J0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "96",
    "Bcolor": "51",
    "Y": 11,
    "L": 38.2741794427147,
    "a": -13.9705873719753,
    "b": 23.3363289688833,
    "C": 27.1985580732129,
    "h": -1.03136078922114,
    "CMY_C": 0.6848043,
    "CMY_M": 0.6252842,
    "CMY_Y": 0.8011988,
    "CMYK_C": 0.1588405,
    "CMYK_M": 0,
    "CMYK_Y": 0.4694613,
    "CMYK_K": 0.6252842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02159",
    "Farbtonhilfsbezeichnung": "J0.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "119",
    "Bcolor": "64",
    "Y": 17,
    "L": 47.5535115345062,
    "a": -15.9362928581855,
    "b": 27.8646520245529,
    "C": 32.0999106308923,
    "h": -1.05128142298174,
    "CMY_C": 0.6000466,
    "CMY_M": 0.5323619,
    "CMY_Y": 0.7495614,
    "CMYK_C": 0.1447373,
    "CMYK_M": 0,
    "CMYK_Y": 0.4644607,
    "CMYK_K": 0.5323619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02160",
    "Farbtonhilfsbezeichnung": "J0.40.60",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "178",
    "Bcolor": "91",
    "Y": 38,
    "L": 68.4204330444336,
    "a": -24.8097820281982,
    "b": 39.7909774780273,
    "C": 46.8918685913086,
    "h": 121.943656921387,
    "CMY_C": 0.42826062440872,
    "CMY_M": 0.30342298746109,
    "CMY_Y": 0.64159786701202,
    "CMYK_C": 0.17921584844589,
    "CMYK_M": 0,
    "CMYK_Y": 0.48548096418381,
    "CMYK_K": 0.30342298746109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02162",
    "Farbtonhilfsbezeichnung": "K2.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "80",
    "Bcolor": "75",
    "Y": 9,
    "L": 33.663521741592,
    "a": -2.75369546020809,
    "b": 2.1963361055497,
    "C": 3.5223189770536,
    "h": -0.673273284559,
    "CMY_C": 0.7015889,
    "CMY_M": 0.6846145,
    "CMY_Y": 0.7059854,
    "CMYK_C": 0.05382096,
    "CMYK_M": 0,
    "CMYK_Y": 0.06776106,
    "CMYK_K": 0.6846145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02163",
    "Farbtonhilfsbezeichnung": "K2.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "94",
    "Bcolor": "83",
    "Y": 12,
    "L": 39.0850149964058,
    "a": -5.45390759743172,
    "b": 5.13459171921069,
    "C": 7.49060346062388,
    "h": -0.75525044157888,
    "CMY_C": 0.6615358,
    "CMY_M": 0.6294548,
    "CMY_Y": 0.6750031,
    "CMYK_C": 0.08657785,
    "CMYK_M": 0,
    "CMYK_Y": 0.1229224,
    "CMYK_K": 0.6294548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02164",
    "Farbtonhilfsbezeichnung": "K2.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "119",
    "Bcolor": "92",
    "Y": 18,
    "L": 47.7082291435285,
    "a": -12.6532330833193,
    "b": 11.9413487514584,
    "C": 17.3982791523979,
    "h": -0.7564614800611,
    "CMY_C": 0.6123112,
    "CMY_M": 0.5340581,
    "CMY_Y": 0.6395266,
    "CMYK_C": 0.1679461,
    "CMYK_M": 0,
    "CMYK_Y": 0.2263555,
    "CMYK_K": 0.5340581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02165",
    "Farbtonhilfsbezeichnung": "K2.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "104",
    "Bcolor": "68",
    "Y": 12,
    "L": 40.8444023132324,
    "a": -19.0718612670898,
    "b": 16.5528335571289,
    "C": 25.253360748291,
    "h": 139.044662475586,
    "CMY_C": 0.71401143074036,
    "CMY_M": 0.59140086174011,
    "CMY_Y": 0.73406809568405,
    "CMYK_C": 0.30007544159889,
    "CMYK_M": 0,
    "CMYK_Y": 0.34916186332703,
    "CMYK_K": 0.59140086174011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02166",
    "Farbtonhilfsbezeichnung": "K2.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "151",
    "Bcolor": "88",
    "Y": 26,
    "L": 57.2762699683356,
    "a": -30.5226942277735,
    "b": 26.7661996460214,
    "C": 40.5963582900343,
    "h": -0.71992081851681,
    "CMY_C": 0.6228276,
    "CMY_M": 0.4094611,
    "CMY_Y": 0.6535933,
    "CMYK_C": 0.361308,
    "CMYK_M": 0,
    "CMYK_Y": 0.4134058,
    "CMYK_K": 0.4094611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02168",
    "Farbtonhilfsbezeichnung": "L0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "83",
    "Bcolor": "77",
    "Y": 10,
    "L": 34.7930592936111,
    "a": -2.815778873163,
    "b": 2.29173655197857,
    "C": 3.63051884532029,
    "h": -0.68315374419668,
    "CMY_C": 0.6913798,
    "CMY_M": 0.6740659,
    "CMY_Y": 0.6963147,
    "CMYK_C": 0.05312072,
    "CMYK_M": 0,
    "CMYK_Y": 0.06826162,
    "CMYK_K": 0.6740659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02169",
    "Farbtonhilfsbezeichnung": "L0.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "110",
    "Bcolor": "103",
    "Y": 15,
    "L": 45.7213973999023,
    "a": -3.37411189079285,
    "b": 2.38775968551636,
    "C": 4.13352489471436,
    "h": 144.714080810547,
    "CMY_C": 0.5919371843338,
    "CMY_M": 0.5689839720726,
    "CMY_Y": 0.59480893611908,
    "CMYK_C": 0.05325373262167,
    "CMYK_M": 0,
    "CMYK_Y": 0.05991648137569,
    "CMYK_K": 0.5689839720726
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02170",
    "Farbtonhilfsbezeichnung": "L0.05.56",
    "Farbtonklasse": "01",
    "Y": 45,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02171",
    "Farbtonhilfsbezeichnung": "L0.10.10",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "52",
    "Bcolor": "47",
    "Y": 5,
    "L": 21.0395024409777,
    "a": -3.50747220362069,
    "b": 1.91265765415561,
    "C": 3.99507453762403,
    "h": -0.49923487122043,
    "CMY_C": 0.8184959,
    "CMY_M": 0.7958562,
    "CMY_Y": 0.8148253,
    "CMYK_C": 0.1109008,
    "CMYK_M": 0,
    "CMYK_Y": 0.09292015,
    "CMYK_K": 0.7958562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02172",
    "Farbtonhilfsbezeichnung": "L0.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "72",
    "Bcolor": "64",
    "Y": 8,
    "L": 29.6905688834444,
    "a": -5.11752096069518,
    "b": 3.103012606946,
    "C": 5.98478972245644,
    "h": -0.54507607941075,
    "CMY_C": 0.750753,
    "CMY_M": 0.7168655,
    "CMY_Y": 0.7473241,
    "CMYK_C": 0.119687,
    "CMYK_M": 0,
    "CMYK_Y": 0.1075766,
    "CMYK_K": 0.7168655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02173",
    "Farbtonhilfsbezeichnung": "L0.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "58",
    "Bcolor": "51",
    "Y": 5,
    "L": 23.5585103650064,
    "a": -5.54012121173611,
    "b": 3.15264389163415,
    "C": 6.37433185111871,
    "h": -0.51735636996523,
    "CMY_C": 0.8069513,
    "CMY_M": 0.7708405,
    "CMY_Y": 0.8008701,
    "CMYK_C": 0.1575794,
    "CMYK_M": 0,
    "CMYK_Y": 0.1310426,
    "CMYK_K": 0.7708405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02174",
    "Farbtonhilfsbezeichnung": "L0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "75",
    "Bcolor": "61",
    "Y": 7,
    "L": 30.1171569175035,
    "a": -9.9247342790641,
    "b": 5.62283049972476,
    "C": 11.4068651845573,
    "h": -0.51545858023764,
    "CMY_C": 0.7734419,
    "CMY_M": 0.7053655,
    "CMY_Y": 0.7593293,
    "CMYK_C": 0.2310537,
    "CMYK_M": 0,
    "CMYK_Y": 0.183155,
    "CMYK_K": 0.7053655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02176",
    "Farbtonhilfsbezeichnung": "L0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "124",
    "Bcolor": "83",
    "Y": 17,
    "L": 47.1346251135281,
    "a": -29.8423117135922,
    "b": 16.2423315471877,
    "C": 33.9761225348034,
    "h": -0.49843479908901,
    "CMY_C": 0.755635,
    "CMY_M": 0.5128759,
    "CMY_Y": 0.6759247,
    "CMYK_C": 0.4983518,
    "CMYK_M": 0,
    "CMYK_Y": 0.3347172,
    "CMYK_K": 0.5128759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02177",
    "Farbtonhilfsbezeichnung": "L0.65.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "65",
    "Y": 18,
    "L": 47.5111614924712,
    "a": -50.494392928444,
    "b": 26.5484948662961,
    "C": 57.0482804024613,
    "h": -0.48405133421176,
    "CMY_C": 1,
    "CMY_M": 0.4838784,
    "CMY_Y": 0.7468432,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.5095015,
    "CMYK_K": 0.4838784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02179",
    "Farbtonhilfsbezeichnung": "L8.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "151",
    "Bcolor": "118",
    "Y": 26,
    "L": 57.1525374497334,
    "a": -29.4430785660328,
    "b": 9.89782518082762,
    "C": 31.0622249485739,
    "h": -0.32429971378135,
    "CMY_C": 0.6797058,
    "CMY_M": 0.4095707,
    "CMY_Y": 0.537084,
    "CMYK_C": 0.4575232,
    "CMYK_M": 0,
    "CMYK_Y": 0.2159671,
    "CMYK_K": 0.4095707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02180",
    "Farbtonhilfsbezeichnung": "L8.40.35",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "115",
    "Bcolor": "85",
    "Y": 15,
    "L": 43.4190700117139,
    "a": -30.9882438206454,
    "b": 9.31055373553273,
    "C": 32.356725204353,
    "h": -0.29187360918596,
    "CMY_C": 0.8490652,
    "CMY_M": 0.5474063,
    "CMY_Y": 0.6647135,
    "CMYK_C": 0.6665115,
    "CMYK_M": 0,
    "CMYK_Y": 0.2591889,
    "CMYK_K": 0.5474063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02181",
    "Farbtonhilfsbezeichnung": "L8.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "136",
    "Bcolor": "96",
    "Y": 18,
    "L": 50.6920509338379,
    "a": -37.2565155029297,
    "b": 13.2795143127441,
    "C": 39.5524139404297,
    "h": 160.382171630859,
    "CMY_C": 0.83778285980225,
    "CMY_M": 0.46565365791321,
    "CMY_Y": 0.62347024679184,
    "CMYK_C": 0.69641947746277,
    "CMYK_M": 0,
    "CMYK_Y": 0.29534512758255,
    "CMYK_K": 0.46565365791321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02182",
    "Farbtonhilfsbezeichnung": "LN.02.27",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "92",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.6995468139648,
    "a": -1.20501708984375,
    "b": 0.96531391143799,
    "C": 1.54398739337921,
    "h": 141.302520751953,
    "CMY_C": 0.64801573753357,
    "CMY_M": 0.64029282331467,
    "CMY_Y": 0.65186870098114,
    "CMYK_C": 0.02147000283003,
    "CMYK_M": 0,
    "CMYK_Y": 0.03218139335513,
    "CMYK_K": 0.64029282331467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02183",
    "Farbtonhilfsbezeichnung": "N0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "77",
    "Bcolor": "69",
    "Y": 8,
    "L": 29.7333203159739,
    "a": -17.1874641515159,
    "b": 0.06693637968075,
    "C": 17.1875944924986,
    "h": -0.00389446870607,
    "CMY_C": 0.8651999,
    "CMY_M": 0.6967531,
    "CMY_Y": 0.729921,
    "CMYK_C": 0.5554772,
    "CMYK_M": 0,
    "CMYK_Y": 0.1093759,
    "CMYK_K": 0.6967531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02184",
    "Farbtonhilfsbezeichnung": "N0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "84",
    "Bcolor": "74",
    "Y": 7,
    "L": 31.9596208544079,
    "a": -19.9788088957216,
    "b": 0.10032375723302,
    "C": 19.97906078243,
    "h": -0.00502146622103,
    "CMY_C": 0.8781381,
    "CMY_M": 0.6720556,
    "CMY_Y": 0.7103887,
    "CMYK_C": 0.6284068,
    "CMYK_M": 0,
    "CMYK_Y": 0.1168888,
    "CMYK_K": 0.6720556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02185",
    "Farbtonhilfsbezeichnung": "N0.50.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "76",
    "Bcolor": "65",
    "Y": 7,
    "L": 28.0537502353337,
    "a": -26.3288110431323,
    "b": 0.05316644217874,
    "C": 26.3288647232565,
    "h": -0.00201932285611,
    "CMY_C": 1,
    "CMY_M": 0.7004287,
    "CMY_Y": 0.7455664,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.15067439999999999,
    "CMYK_K": 0.7004287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02186",
    "Farbtonhilfsbezeichnung": "N0.58.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "88",
    "Y": 12,
    "L": 38.8538360209844,
    "a": -40.2737281011964,
    "b": 1.17787026836477,
    "C": 40.2909487793251,
    "h": -0.02923828162859,
    "CMY_C": 1,
    "CMY_M": 0.5798674,
    "CMY_Y": 0.6556928,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1804797,
    "CMYK_K": 0.5798674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02187",
    "Farbtonhilfsbezeichnung": "P0.05.15",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "62",
    "Bcolor": "61",
    "Y": 6,
    "L": 25.6087636171234,
    "a": -2.2287641615176,
    "b": -0.46900028102668,
    "C": 2.27757567410358,
    "h": 0.20740461459276,
    "CMY_C": 0.7777898,
    "CMY_M": 0.7577502,
    "CMY_Y": 0.7617177,
    "CMYK_C": 0.08272275,
    "CMYK_M": 0,
    "CMYK_Y": 0.01637797,
    "CMYK_K": 0.7577502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02188",
    "Farbtonhilfsbezeichnung": "P0.10.10",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "53",
    "Bcolor": "52",
    "Y": 5,
    "L": 21.4709043297693,
    "a": -3.96403233470874,
    "b": -0.75855733697232,
    "C": 4.03595857066087,
    "h": 0.1890742597164,
    "CMY_C": 0.8257892,
    "CMY_M": 0.7908128,
    "CMY_Y": 0.7959895,
    "CMYK_C": 0.167201,
    "CMYK_M": 0,
    "CMYK_Y": 0.02474614,
    "CMYK_K": 0.7908128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02189",
    "Farbtonhilfsbezeichnung": "P0.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "71",
    "Bcolor": "70",
    "Y": 7,
    "L": 28.9910657687409,
    "a": -5.25811100405377,
    "b": -1.86392347486433,
    "C": 5.57870433444018,
    "h": 0.34066510129803,
    "CMY_C": 0.7738022,
    "CMY_M": 0.7218632,
    "CMY_Y": 0.723815,
    "CMYK_C": 0.1867389,
    "CMYK_M": 0,
    "CMYK_Y": 0.007017623,
    "CMYK_K": 0.7218632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02190",
    "Farbtonhilfsbezeichnung": "P0.20.10",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "51",
    "Bcolor": "51",
    "Y": 5,
    "L": 19.8828726924521,
    "a": -7.15378005985701,
    "b": -2.33345999974058,
    "C": 7.52473286670012,
    "h": 0.31530385451371,
    "CMY_C": 0.8681241,
    "CMY_M": 0.7990373,
    "CMY_Y": 0.800872,
    "CMYK_C": 0.3437791,
    "CMYK_M": 0,
    "CMYK_Y": 0.009129666,
    "CMYK_K": 0.7990373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02191",
    "Farbtonhilfsbezeichnung": "P0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "74",
    "Bcolor": "73",
    "Y": 7,
    "L": 29.5778081909875,
    "a": -10.1708046489623,
    "b": -2.8404059822257,
    "C": 10.5599797988072,
    "h": 0.27233213566946,
    "CMY_C": 0.8117909,
    "CMY_M": 0.7081302,
    "CMY_Y": 0.7131662,
    "CMYK_C": 0.3551606,
    "CMYK_M": 0,
    "CMYK_Y": 0.01725435,
    "CMYK_K": 0.7081302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02192",
    "Farbtonhilfsbezeichnung": "P0.25.10",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "156",
    "Bcolor": "160",
    "Y": 5,
    "L": 63.7383150918046,
    "a": -1.42797992840821,
    "b": -4.08336242171334,
    "C": 4.32584966717492,
    "h": 1.23438266354639,
    "CMY_C": 0.4192525,
    "CMY_M": 0.3899758,
    "CMY_Y": 0.3714536,
    "CMYK_C": 0.0760469,
    "CMYK_M": 0.02946847,
    "CMYK_Y": 0,
    "CMYK_K": 0.3714536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02193",
    "Farbtonhilfsbezeichnung": "P0.30.25",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "87",
    "Bcolor": "86",
    "Y": 9,
    "L": 33.5857214493219,
    "a": -17.9555728959131,
    "b": -4.98278557866916,
    "C": 18.6341286392319,
    "h": 0.2706948524263,
    "CMY_C": 0.8724686,
    "CMY_M": 0.6585013,
    "CMY_Y": 0.6641927,
    "CMYK_C": 0.6265537,
    "CMYK_M": 0,
    "CMYK_Y": 0.01666569,
    "CMYK_K": 0.6585013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02194",
    "Farbtonhilfsbezeichnung": "P0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "8",
    "Gcolor": "77",
    "Bcolor": "76",
    "Y": 7,
    "L": 29.055522057969,
    "a": -19.647011736206,
    "b": -5.32858144674729,
    "C": 20.3567888036703,
    "h": 0.2648447461136,
    "CMY_C": 0.968922,
    "CMY_M": 0.6984429,
    "CMY_Y": 0.7037629,
    "CMYK_C": 0.8969417,
    "CMYK_M": 0,
    "CMYK_Y": 0.01764208,
    "CMYK_K": 0.6984429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02195",
    "Farbtonhilfsbezeichnung": "P0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "129",
    "Bcolor": "126",
    "Y": 18,
    "L": 48.2443725250472,
    "a": -30.3294198579197,
    "b": -7.92967308534716,
    "C": 31.3488982925788,
    "h": 0.25572719263024,
    "CMY_C": 1,
    "CMY_M": 0.4959813,
    "CMY_Y": 0.5057402,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.01936213,
    "CMYK_K": 0.4959813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02196",
    "Farbtonhilfsbezeichnung": "Q0.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "95",
    "Bcolor": "97",
    "Y": 11,
    "L": 39.1914965040139,
    "a": -4.68857392398622,
    "b": -3.73614475695601,
    "C": 5.99512327526411,
    "h": 0.67282438293985,
    "CMY_C": 0.6838581,
    "CMY_M": 0.6278049,
    "CMY_Y": 0.6181388,
    "CMYK_C": 0.1721026,
    "CMYK_M": 0.02531328,
    "CMYK_Y": 0,
    "CMYK_K": 0.6181388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02197",
    "Farbtonhilfsbezeichnung": "Q0.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "76",
    "Bcolor": "79",
    "Y": 8,
    "L": 30.6551743309604,
    "a": -8.28382792851487,
    "b": -5.2437753687352,
    "C": 9.8040290323416,
    "h": 0.5643411289508,
    "CMY_C": 0.7967882,
    "CMY_M": 0.7007637,
    "CMY_Y": 0.6887336,
    "CMYK_C": 0.3471448,
    "CMYK_M": 0.03864867,
    "CMYK_Y": 0,
    "CMYK_K": 0.6887336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02198",
    "Farbtonhilfsbezeichnung": "Q0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "94",
    "Bcolor": "99",
    "Y": 11,
    "L": 37.5885844250737,
    "a": -11.7670919139647,
    "b": -7.38501410173897,
    "C": 13.8925478366848,
    "h": 0.56046601448132,
    "CMY_C": 0.7763748,
    "CMY_M": 0.62962,
    "CMY_Y": 0.6111671,
    "CMYK_C": 0.4248808,
    "CMYK_M": 0.04745716,
    "CMYK_Y": 0,
    "CMYK_K": 0.6111671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02199",
    "Farbtonhilfsbezeichnung": "Q0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "78",
    "Bcolor": "83",
    "Y": 8,
    "L": 30.6991333032423,
    "a": -12.3325699134378,
    "b": -7.26839724960485,
    "C": 14.3150927083235,
    "h": 0.53256367913467,
    "CMY_C": 0.8470463,
    "CMY_M": 0.6933548,
    "CMY_Y": 0.6764477,
    "CMYK_C": 0.5272675,
    "CMYK_M": 0.05225452,
    "CMYK_Y": 0,
    "CMYK_K": 0.6764477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02201",
    "Farbtonhilfsbezeichnung": "Q0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "137",
    "Y": 18,
    "L": 48.0224314958051,
    "a": -26.1824717820353,
    "b": -14.773740517556,
    "C": 30.0630210973074,
    "h": 0.51372597822936,
    "CMY_C": 1,
    "CMY_M": 0.5024713,
    "CMY_Y": 0.4626664,
    "CMYK_C": 1,
    "CMYK_M": 0.07407863,
    "CMYK_Y": 0,
    "CMYK_K": 0.4626664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02202",
    "Farbtonhilfsbezeichnung": "Q0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "1",
    "Gcolor": "103",
    "Bcolor": "111",
    "Y": 12,
    "L": 39.2993746989827,
    "a": -21.6789099158368,
    "b": -12.1734425978248,
    "C": 24.8629813140239,
    "h": 0.51165525712825,
    "CMY_C": 0.994955,
    "CMY_M": 0.5964329,
    "CMY_Y": 0.5654166,
    "CMYK_C": 0.9883912,
    "CMYK_M": 0.07137012,
    "CMYK_Y": 0,
    "CMYK_K": 0.5654166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02203",
    "Farbtonhilfsbezeichnung": "Q0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "39",
    "Gcolor": "87",
    "Bcolor": "91",
    "Y": 7,
    "L": 33.9613380432129,
    "a": -14.4540071487427,
    "b": -8.01601505279541,
    "C": 16.5280017852783,
    "h": 209.01220703125,
    "CMY_C": 0.84551745653152,
    "CMY_M": 0.65947687625885,
    "CMY_Y": 0.64173793792725,
    "CMYK_C": 0.56880015134811,
    "CMYK_M": 0.04951386153698,
    "CMYK_Y": 0,
    "CMYK_K": 0.64173793792725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02204",
    "Farbtonhilfsbezeichnung": "Q0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "121",
    "Y": 12,
    "L": 42.6064186096191,
    "a": -25.3900871276856,
    "b": -13.6528797149658,
    "C": 28.8280696868896,
    "h": 208.268020629883,
    "CMY_C": 1,
    "CMY_M": 0.55817461013794,
    "CMY_Y": 0.52390366792679,
    "CMYK_C": 1,
    "CMYK_M": 0.07198321074247,
    "CMYK_Y": 0,
    "CMYK_K": 0.52390366792679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02205",
    "Farbtonhilfsbezeichnung": "R0.20.15",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "69",
    "Bcolor": "74",
    "Y": 5,
    "L": 27.9751781602139,
    "a": -5.24915885490554,
    "b": -5.80944482899389,
    "C": 7.82964353627655,
    "h": 0.83602004268359,
    "CMY_C": 0.7979715,
    "CMY_M": 0.7300812,
    "CMY_Y": 0.7094562,
    "CMYK_C": 0.3046539,
    "CMYK_M": 0.0709876,
    "CMYK_Y": 0,
    "CMYK_K": 0.7094562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02206",
    "Farbtonhilfsbezeichnung": "R0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "99",
    "Bcolor": "112",
    "Y": 12,
    "L": 39.1452218720976,
    "a": -12.3891016887427,
    "b": -13.0649708336724,
    "C": 18.0050910449994,
    "h": 0.81194442134319,
    "CMY_C": 0.8056048,
    "CMY_M": 0.612142,
    "CMY_Y": 0.5605405999999999,
    "CMYK_C": 0.5576492,
    "CMYK_M": 0.1174202,
    "CMYK_Y": 0,
    "CMYK_K": 0.5605405999999999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02207",
    "Farbtonhilfsbezeichnung": "R0.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "123",
    "Bcolor": "139",
    "Y": 18,
    "L": 48.2474784644936,
    "a": -14.6675719935966,
    "b": -15.4717922784541,
    "C": 21.3193345227982,
    "h": 0.8120752190245,
    "CMY_C": 0.7582161,
    "CMY_M": 0.5184795,
    "CMY_Y": 0.4548743,
    "CMYK_C": 0.5564621,
    "CMYK_M": 0.1166798,
    "CMYK_Y": 0,
    "CMYK_K": 0.4548743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02208",
    "Farbtonhilfsbezeichnung": "R0.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "104",
    "Bcolor": "125",
    "Y": 12,
    "L": 39.512140045536,
    "a": -22.6231411711641,
    "b": -20.7931470436003,
    "C": 30.7272107492237,
    "h": 0.74327315402537,
    "CMY_C": 1,
    "CMY_M": 0.5904618,
    "CMY_Y": 0.5086399,
    "CMYK_C": 1,
    "CMYK_M": 0.1665212,
    "CMYK_Y": 0,
    "CMYK_K": 0.5086399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02209",
    "Farbtonhilfsbezeichnung": "S0.05.15",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 6,
    "L": 25.6752544711279,
    "a": -1.16504351424121,
    "b": -2.84378036489208,
    "C": 3.07317639484317,
    "h": 1.18197199939064,
    "CMY_C": 0.7774706,
    "CMY_M": 0.7585313,
    "CMY_Y": 0.7471299,
    "CMYK_C": 0.1199852,
    "CMYK_M": 0.04508774,
    "CMYK_Y": 0,
    "CMYK_K": 0.7471299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02210",
    "Farbtonhilfsbezeichnung": "S0.05.07",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "63",
    "Bcolor": "64",
    "Y": 4,
    "L": 26.6596102427423,
    "a": -0.72028269097446,
    "b": -0.98111080047191,
    "C": 1.21712183355655,
    "h": 0.93751649887881,
    "CMY_C": 0.7602245,
    "CMY_M": 0.7510851,
    "CMY_Y": 0.7493201,
    "CMYK_C": 0.04349921,
    "CMYK_M": 0.007040903,
    "CMYK_Y": 0,
    "CMYK_K": 0.7493201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02211",
    "Farbtonhilfsbezeichnung": "S0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "73",
    "Bcolor": "90",
    "Y": 7,
    "L": 28.9240090559761,
    "a": -8.1291594281121,
    "b": -14.6640186299086,
    "C": 16.7665343880591,
    "h": 1.06461113753526,
    "CMY_C": 0.8698874,
    "CMY_M": 0.7142278,
    "CMY_Y": 0.6480004,
    "CMYK_C": 0.6303616,
    "CMYK_M": 0.1881463,
    "CMYK_Y": 0,
    "CMYK_K": 0.6480004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02212",
    "Farbtonhilfsbezeichnung": "S0.40.20",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "85",
    "Bcolor": "104",
    "Y": 7,
    "L": 34.0348510742188,
    "a": -8.75091743469238,
    "b": -15.7888851165772,
    "C": 18.0517997741699,
    "h": 241.002792358398,
    "CMY_C": 0.83470106124878,
    "CMY_M": 0.66577190160751,
    "CMY_Y": 0.5926570892334,
    "CMYK_C": 0.59420198202133,
    "CMYK_M": 0.17949204146862,
    "CMYK_Y": 0,
    "CMYK_K": 0.5926570892334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02213",
    "Farbtonhilfsbezeichnung": "S0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "122",
    "Y": 11,
    "L": 36.6142701473371,
    "a": -12.7410831342847,
    "b": -23.1689995644347,
    "C": 26.441212911883,
    "h": 1.06801497261841,
    "CMY_C": 1,
    "CMY_M": 0.6325431,
    "CMY_Y": 0.5216927,
    "CMYK_C": 1,
    "CMYK_M": 0.2317558,
    "CMYK_Y": 0,
    "CMYK_K": 0.5216927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02214",
    "Farbtonhilfsbezeichnung": "SN.02.17",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "65",
    "Bcolor": "67",
    "Y": 7,
    "L": 27.5571493469004,
    "a": -0.20820804684207,
    "b": -1.39123505769774,
    "C": 1.40672867907675,
    "h": 1.42224186116238,
    "CMY_C": 0.7501684,
    "CMY_M": 0.7439685,
    "CMY_Y": 0.7389007,
    "CMYK_C": 0.04315471,
    "CMYK_M": 0.0194096,
    "CMYK_Y": 0,
    "CMYK_K": 0.7389007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02216",
    "Farbtonhilfsbezeichnung": "W0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "126",
    "Bcolor": "137",
    "Y": 22,
    "L": 53.5229755518698,
    "a": 4.09653807617266,
    "b": -6.02454863964783,
    "C": 7.28538334756758,
    "h": -0.97363726181974,
    "CMY_C": 0.4887839,
    "CMY_M": 0.5055593,
    "CMY_Y": 0.462115,
    "CMYK_C": 0.04958099,
    "CMYK_M": 0.0807688,
    "CMYK_Y": 0,
    "CMYK_K": 0.462115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02217",
    "Farbtonhilfsbezeichnung": "W0.10.10",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "50",
    "Bcolor": "61",
    "Y": 5,
    "L": 21.4468411606067,
    "a": 4.50366846025863,
    "b": -6.91382879965348,
    "C": 8.251306458425,
    "h": -0.99343751433669,
    "CMY_C": 0.7905685,
    "CMY_M": 0.8049914,
    "CMY_Y": 0.7603253,
    "CMYK_C": 0.1261842,
    "CMYK_M": 0.1863613,
    "CMYK_Y": 0,
    "CMYK_K": 0.7603253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02218",
    "Farbtonhilfsbezeichnung": "W0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "61",
    "Bcolor": "76",
    "Y": 6,
    "L": 26.3688683657473,
    "a": 4.77643696689567,
    "b": -9.15469570032255,
    "C": 10.3258318533778,
    "h": -1.08990269351258,
    "CMY_C": 0.7529278,
    "CMY_M": 0.7622116,
    "CMY_Y": 0.7033384,
    "CMYK_C": 0.1671583,
    "CMYK_M": 0.1984523,
    "CMYK_Y": 0,
    "CMYK_K": 0.7033384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02219",
    "Farbtonhilfsbezeichnung": "W0.15.45",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "122",
    "Bcolor": "153",
    "Y": 22,
    "L": 52.8352353752438,
    "a": 9.09930995541314,
    "b": -16.6423837760968,
    "C": 18.9675085189271,
    "h": -1.07044773400422,
    "CMY_C": 0.4979305,
    "CMY_M": 0.5204718,
    "CMY_Y": 0.3980811,
    "CMYK_C": 0.1658851,
    "CMYK_M": 0.2033341,
    "CMYK_Y": 0,
    "CMYK_K": 0.3980811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02220",
    "Farbtonhilfsbezeichnung": "W0.15.55",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "143",
    "Bcolor": "179",
    "Y": 31,
    "L": 61.1702084184884,
    "a": 10.3533453747528,
    "b": -18.2501725993826,
    "C": 20.98238690798,
    "h": -1.05476712411776,
    "CMY_C": 0.4095707,
    "CMY_M": 0.4388918,
    "CMY_Y": 0.2999595,
    "CMYK_C": 0.1565783,
    "CMYK_M": 0.1984632,
    "CMYK_Y": 0,
    "CMYK_K": 0.2999595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02221",
    "Farbtonhilfsbezeichnung": "W0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "83",
    "Bcolor": "116",
    "Y": 11,
    "L": 36.9830528348599,
    "a": 10.7830785328806,
    "b": -18.4817403403925,
    "C": 21.3974182708093,
    "h": -1.04263858492495,
    "CMY_C": 0.6488968,
    "CMY_M": 0.6762007,
    "CMY_Y": 0.5456679,
    "CMYK_C": 0.2272102,
    "CMYK_M": 0.287307,
    "CMYK_Y": 0,
    "CMYK_K": 0.5456679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02222",
    "Farbtonhilfsbezeichnung": "W0.25.40",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "105",
    "Bcolor": "157",
    "Y": 18,
    "L": 47.1437835857333,
    "a": 15.2846373070233,
    "b": -27.4039401920547,
    "C": 31.3782739432391,
    "h": -1.06202000230015,
    "CMY_C": 0.554965,
    "CMY_M": 0.5871264,
    "CMY_Y": 0.3853547,
    "CMYK_C": 0.2759482,
    "CMYK_M": 0.3282735,
    "CMYK_Y": 0,
    "CMYK_K": 0.3853547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02223",
    "Farbtonhilfsbezeichnung": "W0.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "61",
    "Bcolor": "104",
    "Y": 7,
    "L": 28.34787688268,
    "a": 13.7412326040809,
    "b": -24.7674900358933,
    "C": 28.3240187148209,
    "h": -1.06426829216083,
    "CMY_C": 0.7371788,
    "CMY_M": 0.7589381,
    "CMY_Y": 0.5909443,
    "CMYK_C": 0.3574929,
    "CMYK_M": 0.4106867,
    "CMYK_Y": 0,
    "CMYK_K": 0.5909443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02224",
    "Farbtonhilfsbezeichnung": "X0.10.10",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "50",
    "Bcolor": "62",
    "Y": 4,
    "L": 22.0970593294704,
    "a": 7.19561690319823,
    "b": -6.13568921161528,
    "C": 9.45640442869932,
    "h": -0.70605839443325,
    "CMY_C": 0.7664104,
    "CMY_M": 0.8052328,
    "CMY_Y": 0.7588022,
    "CMYK_C": 0.03154292,
    "CMYK_M": 0.1925,
    "CMYK_Y": 0,
    "CMYK_K": 0.7588022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02225",
    "Farbtonhilfsbezeichnung": "X0.10.20",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "59",
    "Bcolor": "77",
    "Y": 6,
    "L": 26.5480546161555,
    "a": 7.77007505626343,
    "b": -9.7142768568562,
    "C": 12.4395032550186,
    "h": -0.89613990439202,
    "CMY_C": 0.7340026,
    "CMY_M": 0.76679,
    "CMY_Y": 0.6981387,
    "CMYK_C": 0.1188094,
    "CMYK_M": 0.2274266,
    "CMYK_Y": 0,
    "CMYK_K": 0.6981387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02226",
    "Farbtonhilfsbezeichnung": "X0.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "79",
    "Bcolor": "111",
    "Y": 10,
    "L": 36.7139156159202,
    "a": 15.1118321934688,
    "b": -15.6037800341719,
    "C": 21.7220032132946,
    "h": -0.80141300883997,
    "CMY_C": 0.6118011,
    "CMY_M": 0.6902373,
    "CMY_Y": 0.5658444,
    "CMYK_C": 0.1058532,
    "CMYK_M": 0.2865169,
    "CMYK_Y": 0,
    "CMYK_K": 0.5658444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02227",
    "Farbtonhilfsbezeichnung": "X0.20.50",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "126",
    "Bcolor": "170",
    "Y": 25,
    "L": 56.7024360698741,
    "a": 18.7290733826628,
    "b": -19.8629429822653,
    "C": 27.3004522616365,
    "h": -0.81477065046252,
    "CMY_C": 0.4012704,
    "CMY_M": 0.5047776,
    "CMY_Y": 0.335288,
    "CMYK_C": 0.0992647,
    "CMYK_M": 0.2549819,
    "CMYK_Y": 0,
    "CMYK_K": 0.335288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02228",
    "Farbtonhilfsbezeichnung": "Z0.05.20",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "66",
    "Bcolor": "71",
    "Y": 7,
    "L": 28.9970392426857,
    "a": 4.09452393957799,
    "b": -1.95868997397896,
    "C": 4.53889774129611,
    "h": -0.44619288127613,
    "CMY_C": 0.7117541,
    "CMY_M": 0.7394639,
    "CMY_Y": 0.7222132,
    "CMYK_C": 0,
    "CMYK_M": 0.09613249,
    "CMYK_Y": 0.03628543,
    "CMYK_K": 0.7117541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02229",
    "Farbtonhilfsbezeichnung": "Z0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "71",
    "Bcolor": "103",
    "Y": 11,
    "L": 38.3985966025208,
    "a": 30.3027235440554,
    "b": -7.97810041633243,
    "C": 31.3353656503404,
    "h": -0.25743788872995,
    "CMY_C": 0.4859797,
    "CMY_M": 0.721859,
    "CMY_Y": 0.5952297,
    "CMYK_C": 0,
    "CMYK_M": 0.4588911,
    "CMYK_Y": 0.2125404,
    "CMYK_K": 0.4859797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02237",
    "Farbtonhilfsbezeichnung": "G4.30.60",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "164",
    "Bcolor": "101",
    "Y": 39,
    "L": 67.126315847683,
    "a": -3.96073992336315,
    "b": 33.5408785147114,
    "C": 33.773924739052,
    "h": -1.45325372211668,
    "CMY_C": 0.306074,
    "CMY_M": 0.3573224,
    "CMY_Y": 0.6022453,
    "CMYK_C": 0,
    "CMYK_M": 0.07385275,
    "CMYK_Y": 0.4268053,
    "CMYK_K": 0.306074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02242",
    "Farbtonhilfsbezeichnung": "GN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "239",
    "Bcolor": "224",
    "Y": 86.1600799560547,
    "L": 94.3807525634766,
    "a": -0.7860324382782,
    "b": 6.83972835540771,
    "C": 6.88474607467651,
    "h": 96.5557632446289,
    "CMY_C": 0.04688757658005,
    "CMY_M": 0.06282109022141,
    "CMY_Y": 0.12171816825867,
    "CMYK_C": 0,
    "CMYK_M": 0.01671735011041,
    "CMYK_Y": 0.07851181924343,
    "CMYK_K": 0.04688757658005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02243",
    "Farbtonhilfsbezeichnung": "F2.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "109",
    "Bcolor": "58",
    "Y": 17,
    "L": 48.3599921864637,
    "a": 7.4203686356879,
    "b": 32.8479194733615,
    "C": 33.6756244844538,
    "h": 1.3486247324267,
    "CMY_C": 0.4402507,
    "CMY_M": 0.5722157,
    "CMY_Y": 0.7720105,
    "CMYK_C": 0,
    "CMYK_M": 0.2357574,
    "CMYK_Y": 0.5926936,
    "CMYK_K": 0.4402507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02244",
    "Farbtonhilfsbezeichnung": "F2.70.65",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "164",
    "Bcolor": "0",
    "Y": 46,
    "L": 73.3826337221972,
    "a": 19.3789433681587,
    "b": 78.9765942603797,
    "C": 81.3194065831456,
    "h": 1.33017458434228,
    "CMY_C": 0.04674404,
    "CMY_M": 0.355078,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3234535,
    "CMYK_Y": 1,
    "CMYK_K": 0.04674404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02247",
    "Farbtonhilfsbezeichnung": "L0.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "128",
    "Bcolor": "76",
    "Y": 18,
    "L": 47.9595544147266,
    "a": -35.7391038650265,
    "b": 21.0348395619981,
    "C": 41.4698447124432,
    "h": -0.53197010058991,
    "CMY_C": 0.7960097,
    "CMY_M": 0.4969622,
    "CMY_Y": 0.7017009,
    "CMYK_C": 0.5944831,
    "CMYK_M": 0,
    "CMYK_Y": 0.4070044,
    "CMYK_K": 0.4969622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02248",
    "Farbtonhilfsbezeichnung": "J0.15.25",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "91",
    "Bcolor": "76",
    "Y": 9,
    "L": 37.880241394043,
    "a": -4.17696666717529,
    "b": 7.41728830337524,
    "C": 8.51253318786621,
    "h": 119.38557434082,
    "CMY_C": 0.65803617238998,
    "CMY_M": 0.64369857311249,
    "CMY_Y": 0.7002420425415,
    "CMYK_C": 0.0402400828898,
    "CMYK_M": 0,
    "CMYK_Y": 0.15869560837746,
    "CMYK_K": 0.64369857311249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02249",
    "Farbtonhilfsbezeichnung": "J0.60.50",
    "Farbtonklasse": "04",
    "Rcolor": "115",
    "Gcolor": "148",
    "Bcolor": "47",
    "Y": 27,
    "L": 57.1135605578855,
    "a": -26.9301921613238,
    "b": 47.2148612549857,
    "C": 54.3551135880827,
    "h": -1.05244455330568,
    "CMY_C": 0.5498323,
    "CMY_M": 0.4193225,
    "CMY_Y": 0.8153586,
    "CMYK_C": 0.2247543,
    "CMYK_M": 0,
    "CMYK_Y": 0.6820242,
    "CMYK_K": 0.4193225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02250",
    "Farbtonhilfsbezeichnung": "J0.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "194",
    "Bcolor": "122",
    "Y": 50,
    "L": 75.4033434256148,
    "a": -17.7568000645947,
    "b": 33.417438863407,
    "C": 37.8421612586217,
    "h": -1.08237403027474,
    "CMY_C": 0.3136417,
    "CMY_M": 0.2407967,
    "CMY_Y": 0.522103,
    "CMYK_C": 0.09594919,
    "CMYK_M": 0,
    "CMYK_Y": 0.3705283,
    "CMYK_K": 0.2407967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02253",
    "Farbtonhilfsbezeichnung": "G8.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "166",
    "Bcolor": "41",
    "Y": 38,
    "L": 66.8202300732572,
    "a": -11.3620582499233,
    "b": 60.5459657136494,
    "C": 61.602843537235,
    "h": -1.38529377816217,
    "CMY_C": 0.3213991,
    "CMY_M": 0.3482383,
    "CMY_Y": 0.8396049,
    "CMYK_C": 0,
    "CMYK_M": 0.03955076,
    "CMYK_Y": 0.7636385,
    "CMYK_K": 0.3213991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02254",
    "Farbtonhilfsbezeichnung": "G4.25.35",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "110",
    "Bcolor": "78",
    "Y": 16,
    "L": 46.1182899475098,
    "a": -2.65241026878357,
    "b": 17.9790153503418,
    "C": 18.1736145019531,
    "h": 98.392204284668,
    "CMY_C": 0.54523682594299,
    "CMY_M": 0.56973230838776,
    "CMY_Y": 0.69270771741867,
    "CMYK_C": 0,
    "CMYK_M": 0.0538642629981,
    "CMYK_Y": 0.3242806494236,
    "CMYK_K": 0.54523682594299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02255",
    "Farbtonhilfsbezeichnung": "G0.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "104",
    "Bcolor": "98",
    "Y": 15,
    "L": 43.9314293024228,
    "a": -0.11857139133031,
    "b": 3.26447224101627,
    "C": 3.26662489233273,
    "h": -1.53449052259954,
    "CMY_C": 0.5843167,
    "CMY_M": 0.5931176,
    "CMY_Y": 0.6171053,
    "CMYK_C": 0,
    "CMYK_M": 0.02117223,
    "CMYK_Y": 0.07887895,
    "CMYK_K": 0.5843167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02258",
    "Farbtonhilfsbezeichnung": "G4.60.70",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "188",
    "Bcolor": "41",
    "Y": 51,
    "L": 75.4706999576231,
    "a": -8.06411952250463,
    "b": 69.2176506577351,
    "C": 69.6858176837259,
    "h": -1.45481537980148,
    "CMY_C": 0.1929568,
    "CMY_M": 0.2645142,
    "CMY_Y": 0.8376849,
    "CMYK_C": 0,
    "CMYK_M": 0.08866607,
    "CMYK_Y": 0.7988768,
    "CMYK_K": 0.1929568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02259",
    "Farbtonhilfsbezeichnung": "A0.20.12",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "40",
    "Bcolor": "50",
    "Y": 5,
    "L": 20.4563633635113,
    "a": 16.113493543133,
    "b": -0.75720190063391,
    "C": 16.1312748684942,
    "h": -0.04695724596825,
    "CMY_C": 0.721831,
    "CMY_M": 0.8422328,
    "CMY_Y": 0.8024063,
    "CMYK_C": 0,
    "CMYK_M": 0.4328369,
    "CMYK_Y": 0.2896631,
    "CMYK_K": 0.721831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02260",
    "Farbtonhilfsbezeichnung": "C0.20.12",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "43",
    "Bcolor": "40",
    "Y": 5,
    "L": 20.6915755144213,
    "a": 12.0949238435638,
    "b": 7.08074358642036,
    "C": 14.0151386906531,
    "h": 0.52963813190778,
    "CMY_C": 0.7265321,
    "CMY_M": 0.8316725,
    "CMY_Y": 0.8450231,
    "CMYK_C": 0,
    "CMYK_M": 0.384471,
    "CMYK_Y": 0.4332904,
    "CMYK_K": 0.7265321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02262",
    "Farbtonhilfsbezeichnung": "J0.20.75",
    "Farbtonklasse": "99",
    "Y": 62,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02263",
    "Farbtonhilfsbezeichnung": "G8.60.70",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "192",
    "Bcolor": "49",
    "Y": 52,
    "L": 75.6621105944264,
    "a": -14.8741151128125,
    "b": 66.5608792038989,
    "C": 68.2025655000252,
    "h": -1.35094213628046,
    "CMY_C": 0.237988,
    "CMY_M": 0.2479178,
    "CMY_Y": 0.8065609,
    "CMYK_C": 0,
    "CMYK_M": 0.01303101,
    "CMYK_Y": 0.7461469,
    "CMYK_K": 0.237988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02264",
    "Farbtonhilfsbezeichnung": "G8.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "72",
    "Bcolor": "63",
    "Y": 8,
    "L": 30.5483732893633,
    "a": -0.81549761513075,
    "b": 5.45984682263529,
    "C": 5.52041336196164,
    "h": -1.42252968641195,
    "CMY_C": 0.7091203,
    "CMY_M": 0.7174514,
    "CMY_Y": 0.7534295,
    "CMYK_C": 0,
    "CMYK_M": 0.02864116,
    "CMYK_Y": 0.1523284,
    "CMYK_K": 0.7091203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02265",
    "Farbtonhilfsbezeichnung": "G8.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "72",
    "Bcolor": "45",
    "Y": 8,
    "L": 30.1468783110992,
    "a": -3.57550495584436,
    "b": 16.1491600013901,
    "C": 16.5402419704116,
    "h": -1.35290626930089,
    "CMY_C": 0.7079693,
    "CMY_M": 0.7177859,
    "CMY_Y": 0.8227276,
    "CMYK_C": 0,
    "CMYK_M": 0.03361493,
    "CMYK_Y": 0.3929665,
    "CMYK_K": 0.7079693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02266",
    "Farbtonhilfsbezeichnung": "G8.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "94",
    "Bcolor": "52",
    "Y": 12,
    "L": 39.3623278980224,
    "a": -5.76523420421285,
    "b": 24.1183377955246,
    "C": 24.7978253774087,
    "h": -1.33615977936502,
    "CMY_C": 0.6204421,
    "CMY_M": 0.6294898,
    "CMY_Y": 0.7951993,
    "CMYK_C": 0,
    "CMYK_M": 0.02383747,
    "CMYK_Y": 0.460423,
    "CMYK_K": 0.6204421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02267",
    "Farbtonhilfsbezeichnung": "G4.60.60",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "162",
    "Bcolor": "37",
    "Y": 36,
    "L": 66.7755050546171,
    "a": -4.71679658668339,
    "b": 61.9855653958994,
    "C": 62.164768860581,
    "h": -1.4948476133479,
    "CMY_C": 0.2786836,
    "CMY_M": 0.3627672,
    "CMY_Y": 0.8530688,
    "CMYK_C": 0,
    "CMYK_M": 0.1165696,
    "CMYK_Y": 0.7963013,
    "CMYK_K": 0.2786836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02269",
    "Farbtonhilfsbezeichnung": "K2.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "139",
    "Bcolor": "64",
    "Y": 19,
    "L": 51.8099250793457,
    "a": -38.5505447387695,
    "b": 32.7038345336914,
    "C": 50.5537872314453,
    "h": 139.690841674805,
    "CMY_C": 0.74109143018723,
    "CMY_M": 0.4550963640213,
    "CMY_Y": 0.75015765428543,
    "CMYK_C": 0.52485436201096,
    "CMYK_M": 0,
    "CMYK_Y": 0.54149258136749,
    "CMYK_K": 0.4550963640213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02270",
    "Farbtonhilfsbezeichnung": "AN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.2473449707031,
    "a": 4.93874502182007,
    "b": 0.45415869355202,
    "C": 4.95958280563354,
    "h": 5.25404691696167,
    "CMY_C": 0.13652443885803,
    "CMY_M": 0.18720805644989,
    "CMY_Y": 0.18481463193893,
    "CMYK_C": 0,
    "CMYK_M": 0.05869722366333,
    "CMYK_Y": 0.05592537298799,
    "CMYK_K": 0.13652443885803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02271",
    "Farbtonhilfsbezeichnung": "E4.13.75",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "201",
    "Bcolor": "175",
    "Y": 62,
    "L": 82.9700344117626,
    "a": 6.89034798689886,
    "b": 16.5392030758154,
    "C": 17.9170905496295,
    "h": 1.17605603753318,
    "CMY_C": 0.09231411,
    "CMY_M": 0.2102037,
    "CMY_Y": 0.3152959,
    "CMYK_C": 0,
    "CMYK_M": 0.1298793,
    "CMYK_Y": 0.2456597,
    "CMYK_K": 0.09231411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02273",
    "Farbtonhilfsbezeichnung": "C0.15.10",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "42",
    "Bcolor": "41",
    "Y": 5,
    "L": 19.7798637442226,
    "a": 10.8566870829618,
    "b": 4.81091029758491,
    "C": 11.8748689385929,
    "h": 0.41712512994315,
    "CMY_C": 0.7443721,
    "CMY_M": 0.8358815,
    "CMY_Y": 0.8399127,
    "CMYK_C": 0,
    "CMYK_M": 0.3579789,
    "CMYK_Y": 0.3737489,
    "CMYK_K": 0.7443721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02274",
    "Farbtonhilfsbezeichnung": "F2.15.65",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "177",
    "Bcolor": "147",
    "Y": 47,
    "L": 73.4278332447496,
    "a": 3.59482308239073,
    "b": 17.5109580304529,
    "C": 17.8761406387948,
    "h": 1.36831952327359,
    "CMY_C": 0.2188147,
    "CMY_M": 0.3050396,
    "CMY_Y": 0.4220846,
    "CMYK_C": 0,
    "CMYK_M": 0.110377,
    "CMYK_Y": 0.260207,
    "CMYK_K": 0.2188147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02276",
    "Farbtonhilfsbezeichnung": "E6.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "174",
    "Bcolor": "161",
    "Y": 43,
    "L": 71.8688636804249,
    "a": 2.6367718017769,
    "b": 7.50925873523125,
    "C": 7.95873936545812,
    "h": 1.233109753239,
    "CMY_C": 0.2674792,
    "CMY_M": 0.3169644,
    "CMY_Y": 0.367338,
    "CMYK_C": 0,
    "CMYK_M": 0.06755456,
    "CMYK_Y": 0.1363222,
    "CMYK_K": 0.2674792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02277",
    "Farbtonhilfsbezeichnung": "H4.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "212",
    "Bcolor": "192",
    "Y": 64,
    "L": 84.2057467927267,
    "a": -3.50938333763479,
    "b": 8.91479721042223,
    "C": 9.58067746630794,
    "h": -1.19576891502453,
    "CMY_C": 0.174734,
    "CMY_M": 0.1700902,
    "CMY_Y": 0.2481502,
    "CMYK_C": 0.005595554,
    "CMYK_M": 0,
    "CMYK_Y": 0.09405838,
    "CMYK_K": 0.1700902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02279",
    "Farbtonhilfsbezeichnung": "L0.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "153",
    "Bcolor": "90",
    "Y": 25,
    "L": 56.7312747898599,
    "a": -41.8783954612187,
    "b": 24.7561436361228,
    "C": 48.648398268993,
    "h": -0.53388195844376,
    "CMY_C": 0.7639316,
    "CMY_M": 0.398103,
    "CMY_Y": 0.6462825,
    "CMYK_C": 0.6077926,
    "CMYK_M": 0,
    "CMYK_Y": 0.4123288,
    "CMYK_K": 0.398103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02281",
    "Farbtonhilfsbezeichnung": "C5.43.58",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "127",
    "Bcolor": "100",
    "Y": 36,
    "L": 66.1982294112591,
    "a": 43.2788103437742,
    "b": 34.5139665400637,
    "C": 55.3558426103425,
    "h": 0.67320219664398,
    "CMY_C": 0.03816599,
    "CMY_M": 0.5018455,
    "CMY_Y": 0.6060641,
    "CMYK_C": 0,
    "CMYK_M": 0.4820785,
    "CMYK_Y": 0.5904326,
    "CMYK_K": 0.03816599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02282",
    "Farbtonhilfsbezeichnung": "G8.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "143",
    "Bcolor": "59",
    "Y": 25,
    "L": 58.4778785705566,
    "a": -9.04174709320068,
    "b": 43.9641456604004,
    "C": 44.8842887878418,
    "h": 101.621513366699,
    "CMY_C": 0.41681689023972,
    "CMY_M": 0.43736678361893,
    "CMY_Y": 0.7673282623291,
    "CMYK_C": 0,
    "CMYK_M": 0.0352374650538,
    "CMYK_Y": 0.60103142261505,
    "CMYK_K": 0.41681689023972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02283",
    "Farbtonhilfsbezeichnung": "C8.15.68",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "165",
    "Bcolor": "150",
    "Y": 44,
    "L": 71.9490850054299,
    "a": 16.1517976369332,
    "b": 14.0845548697948,
    "C": 21.4302415475118,
    "h": 0.71713494470275,
    "CMY_C": 0.1601439,
    "CMY_M": 0.3514284,
    "CMY_Y": 0.410742,
    "CMYK_C": 0,
    "CMYK_M": 0.2277588,
    "CMYK_Y": 0.2983821,
    "CMYK_K": 0.1601439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02284",
    "Farbtonhilfsbezeichnung": "C8.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "207",
    "Bcolor": "202",
    "Y": 64,
    "L": 83.8722220734239,
    "a": 2.85968212371446,
    "b": 2.86175962124451,
    "C": 4.0456705227289,
    "h": 0.78576127072797,
    "CMY_C": 0.1487271,
    "CMY_M": 0.1870067,
    "CMY_Y": 0.2066925,
    "CMYK_C": 0,
    "CMYK_M": 0.04496745,
    "CMYK_Y": 0.06809266,
    "CMYK_K": 0.1487271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02286",
    "Farbtonhilfsbezeichnung": "G4.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "219",
    "Bcolor": "201",
    "Y": 71,
    "L": 87.4551264048013,
    "a": -0.56930979615454,
    "b": 8.64443539693152,
    "C": 8.66316206565017,
    "h": -1.50503276819839,
    "CMY_C": 0.1172356,
    "CMY_M": 0.1410256,
    "CMY_Y": 0.210736,
    "CMYK_C": 0,
    "CMYK_M": 0.02694952,
    "CMYK_Y": 0.1059178,
    "CMYK_K": 0.1172356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02287",
    "Farbtonhilfsbezeichnung": "E1.28.68",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "172",
    "Bcolor": "126",
    "Y": 49,
    "L": 75.2381278326641,
    "a": 17.9020244721207,
    "b": 32.2767368520625,
    "C": 36.9089450136102,
    "h": 1.06439641040594,
    "CMY_C": 0.07886505,
    "CMY_M": 0.3253841,
    "CMY_Y": 0.5074483,
    "CMYK_C": 0,
    "CMYK_M": 0.2676254,
    "CMYK_Y": 0.4652774,
    "CMYK_K": 0.07886505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02289",
    "Farbtonhilfsbezeichnung": "E7.36.76",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "119",
    "Y": 62,
    "L": 82.7556999365124,
    "a": 14.9681823010083,
    "b": 45.6848174481452,
    "C": 48.0744113501826,
    "h": 1.25417832187259,
    "CMY_C": 0,
    "CMY_M": 0.239288,
    "CMY_Y": 0.5334024,
    "CMYK_C": 0,
    "CMYK_M": 0.239288,
    "CMYK_Y": 0.5334024,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02290",
    "Farbtonhilfsbezeichnung": "F0.24.80",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "212",
    "Bcolor": "158",
    "Y": 70,
    "L": 87.4477767944336,
    "a": 7.9427285194397,
    "b": 31.8446807861328,
    "C": 32.8202781677246,
    "h": 75.994987487793,
    "CMY_C": 0.00129896402359,
    "CMY_M": 0.167196393013,
    "CMY_Y": 0.3813870549202,
    "CMYK_C": 0,
    "CMYK_M": 0.1661131978035,
    "CMYK_Y": 0.38058245182037,
    "CMYK_K": 0.00129896402359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02291",
    "Farbtonhilfsbezeichnung": "S7.05.77",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "209",
    "Bcolor": "212",
    "Y": 63,
    "L": 83.6708575304925,
    "a": 0.503495514098,
    "b": -2.71592854356892,
    "C": 2.76220484151506,
    "h": -1.38749122292781,
    "CMY_C": 0.1876399,
    "CMY_M": 0.1820512,
    "CMY_Y": 0.1686417,
    "CMYK_C": 0.02285197,
    "CMYK_M": 0.0161296,
    "CMYK_Y": 0,
    "CMYK_K": 0.1686417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02292",
    "Farbtonhilfsbezeichnung": "S6.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "211",
    "Bcolor": "214",
    "Y": 64,
    "L": 84.0934829570568,
    "a": -2.01450674660414,
    "b": -3.32413131977358,
    "C": 3.88691220163425,
    "h": 1.02595843874152,
    "CMY_C": 0.2053418,
    "CMY_M": 0.1714111,
    "CMY_Y": 0.1599263,
    "CMYK_C": 0.05406131,
    "CMYK_M": 0.01367122,
    "CMYK_Y": 0,
    "CMYK_K": 0.1599263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02294",
    "Farbtonhilfsbezeichnung": "R8.08.81",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "218",
    "Bcolor": "226",
    "Y": 67,
    "L": 85.6314157368868,
    "a": -5.87450070573786,
    "b": -7.18557432176057,
    "C": 9.2812842255401,
    "h": 0.88545086887752,
    "CMY_C": 0.2360382,
    "CMY_M": 0.1446134,
    "CMY_Y": 0.1153218,
    "CMYK_C": 0.1364523,
    "CMYK_M": 0.03310992,
    "CMYK_Y": 0,
    "CMYK_K": 0.1153218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02295",
    "Farbtonhilfsbezeichnung": "Q4.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "219",
    "Bcolor": "218",
    "Y": 69,
    "L": 86.4172153081994,
    "a": -4.58976536319333,
    "b": -1.9762269458758,
    "C": 4.99714108573841,
    "h": 0.40658115763725,
    "CMY_C": 0.1960125,
    "CMY_M": 0.1403386,
    "CMY_Y": 0.1446462,
    "CMYK_C": 0.06476259,
    "CMYK_M": 0,
    "CMYK_Y": 0.005010882,
    "CMYK_K": 0.1403386
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02296",
    "Farbtonhilfsbezeichnung": "G4.40.70",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "189",
    "Bcolor": "94",
    "Y": 51,
    "L": 76.5919489813273,
    "a": -5.02374831187058,
    "b": 49.2753695785709,
    "C": 49.5307994505012,
    "h": -1.46919485803522,
    "CMY_C": 0.1832639,
    "CMY_M": 0.2570302,
    "CMY_Y": 0.6301633,
    "CMYK_C": 0,
    "CMYK_M": 0.09031833,
    "CMYK_Y": 0.5471771,
    "CMYK_K": 0.1832639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02301",
    "Farbtonhilfsbezeichnung": "F3.40.77",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "109",
    "Y": 65,
    "L": 84.6775511294855,
    "a": 9.28112475649684,
    "b": 52.7194096872857,
    "C": 53.5301357603503,
    "h": 1.39653438546228,
    "CMY_C": 0,
    "CMY_M": 0.2045487,
    "CMY_Y": 0.5714965,
    "CMYK_C": 0,
    "CMYK_M": 0.2045487,
    "CMYK_Y": 0.5714965,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02302",
    "Farbtonhilfsbezeichnung": "G0.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "223",
    "Y": 85,
    "L": 94.8956985473633,
    "a": -0.0370243601501,
    "b": 8.2526969909668,
    "C": 8.25277996063232,
    "h": 90.2570419311523,
    "CMY_C": 0.0308523774147,
    "CMY_M": 0.05920320749283,
    "CMY_Y": 0.12649184465408,
    "CMYK_C": 0,
    "CMYK_M": 0.02925336547196,
    "CMYK_Y": 0.09868410974741,
    "CMYK_K": 0.0308523774147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02303",
    "Farbtonhilfsbezeichnung": "F2.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "237",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.9243220231198,
    "a": 0.03038558012435,
    "b": 5.40375473082328,
    "C": 5.40384015995796,
    "h": 1.56517333659765,
    "CMY_C": 0.05025259,
    "CMY_M": 0.06953929,
    "CMY_Y": 0.1159154,
    "CMYK_C": 0,
    "CMYK_M": 0.02030719,
    "CMYK_Y": 0.0691371,
    "CMYK_K": 0.05025259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02304",
    "Farbtonhilfsbezeichnung": "GN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "243",
    "Bcolor": "234",
    "Y": 86,
    "L": 95.6362609863281,
    "a": -0.71765869855881,
    "b": 3.52197194099426,
    "C": 3.5943455696106,
    "h": 101.517265319824,
    "CMY_C": 0.0429762005806,
    "CMY_M": 0.04794579744339,
    "CMY_Y": 0.08298701047897,
    "CMYK_C": 0,
    "CMYK_M": 0.00519276224077,
    "CMYK_Y": 0.04180753976107,
    "CMYK_K": 0.0429762005806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02307",
    "Farbtonhilfsbezeichnung": "D8.37.65",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "161",
    "Bcolor": "106",
    "Y": 46,
    "L": 73.067147442754,
    "a": 24.768871960353,
    "b": 39.8470776513077,
    "C": 46.9178709612629,
    "h": 1.01464698660061,
    "CMY_C": 0.0530562,
    "CMY_M": 0.3692722,
    "CMY_Y": 0.5831589,
    "CMYK_C": 0,
    "CMYK_M": 0.3339332,
    "CMYK_Y": 0.5598037,
    "CMYK_K": 0.0530562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02314",
    "Farbtonhilfsbezeichnung": "C0.05.15",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "59",
    "Bcolor": "58",
    "Y": 7,
    "L": 25.6819794568808,
    "a": 3.04689973732639,
    "b": 1.83995228828467,
    "C": 3.55935702514985,
    "h": 0.54326526774629,
    "CMY_C": 0.7384146,
    "CMY_M": 0.7676077,
    "CMY_Y": 0.773992,
    "CMYK_C": 0,
    "CMYK_M": 0.1116007,
    "CMYK_Y": 0.1360067,
    "CMYK_K": 0.7384146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02315",
    "Farbtonhilfsbezeichnung": "C0.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "99",
    "Bcolor": "96",
    "Y": 15,
    "L": 43.0960140896221,
    "a": 5.50466225754193,
    "b": 2.84038777104947,
    "C": 6.19428036655865,
    "h": 0.47636294846005,
    "CMY_C": 0.5571427,
    "CMY_M": 0.613045,
    "CMY_Y": 0.6215815,
    "CMYK_C": 0,
    "CMYK_M": 0.1262309,
    "CMYK_Y": 0.145507,
    "CMYK_K": 0.5571427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02316",
    "Farbtonhilfsbezeichnung": "E3.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "213",
    "Bcolor": "185",
    "Y": 69,
    "L": 86.7217211673236,
    "a": 5.62363042357139,
    "b": 16.323915821833,
    "C": 17.2654408255106,
    "h": 1.23902739409749,
    "CMY_C": 0.05927375,
    "CMY_M": 0.1659733,
    "CMY_Y": 0.2741403,
    "CMYK_C": 0,
    "CMYK_M": 0.1134225,
    "CMYK_Y": 0.228405,
    "CMYK_K": 0.05927375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02317",
    "Farbtonhilfsbezeichnung": "SN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 72,
    "L": 88.1825618796093,
    "a": -1.30551381541849,
    "b": -0.98060574644065,
    "C": 1.63277492392582,
    "h": 0.64422154367132,
    "CMY_C": 0.1463131,
    "CMY_M": 0.1286217,
    "CMY_Y": 0.1321178,
    "CMYK_C": 0.02030277,
    "CMYK_M": 0,
    "CMYK_Y": 0.004012147,
    "CMYK_K": 0.1286217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02322",
    "Farbtonhilfsbezeichnung": "E4.25.67",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "176",
    "Bcolor": "129",
    "Y": 49,
    "L": 75.2410680573519,
    "a": 12.0422787797663,
    "b": 30.0861390863624,
    "C": 32.4066697353115,
    "h": 1.19006581038937,
    "CMY_C": 0.1186837,
    "CMY_M": 0.3093048,
    "CMY_Y": 0.4927386,
    "CMYK_C": 0,
    "CMYK_M": 0.2162914,
    "CMYK_Y": 0.4244276,
    "CMYK_K": 0.1186837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02323",
    "Farbtonhilfsbezeichnung": "E3.20.74",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "193",
    "Bcolor": "157",
    "Y": 58,
    "L": 80.8859118133663,
    "a": 11.1300961171738,
    "b": 23.2229047613417,
    "C": 25.7523269847965,
    "h": 1.12386791329435,
    "CMY_C": 0.0727006,
    "CMY_M": 0.2450664,
    "CMY_Y": 0.3851097,
    "CMYK_C": 0,
    "CMYK_M": 0.1858793,
    "CMYK_Y": 0.3369021,
    "CMYK_K": 0.0727006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02324",
    "Farbtonhilfsbezeichnung": "F6.20.83",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "224",
    "Bcolor": "174",
    "Y": 76,
    "L": 90.1797637939453,
    "a": 2.09158301353455,
    "b": 26.8826160430908,
    "C": 26.9638595581055,
    "h": 85.5511016845703,
    "CMY_C": 0.02001810073853,
    "CMY_M": 0.12147432565689,
    "CMY_Y": 0.3165557384491,
    "CMYK_C": 0,
    "CMYK_M": 0.10352867096663,
    "CMYK_Y": 0.30259501934052,
    "CMYK_K": 0.02001810073853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02325",
    "Farbtonhilfsbezeichnung": "Q5.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "223",
    "Bcolor": "226",
    "Y": 69,
    "L": 87.5683670043945,
    "a": -5.79015588760376,
    "b": -4.40618705749512,
    "C": 7.27601480484009,
    "h": 217.270370483398,
    "CMY_C": 0.20285338163376,
    "CMY_M": 0.12415933609009,
    "CMY_Y": 0.11429178714752,
    "CMYK_C": 0.09998958557844,
    "CMYK_M": 0.01114085782319,
    "CMYK_Y": 0,
    "CMYK_K": 0.11429178714752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02326",
    "Farbtonhilfsbezeichnung": "Q0.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 77,
    "L": 91.3023300170898,
    "a": -5.81373405456543,
    "b": -2.98854398727417,
    "C": 6.53688764572144,
    "h": 207.205383300781,
    "CMY_C": 0.15646082162857,
    "CMY_M": 0.08290380239487,
    "CMY_Y": 0.08337354660034,
    "CMYK_C": 0.08020643889904,
    "CMYK_M": 0,
    "CMYK_Y": 0.00051220820751,
    "CMYK_K": 0.08290380239487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02330",
    "Farbtonhilfsbezeichnung": "G4.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "143",
    "Bcolor": "60",
    "Y": 26,
    "L": 58.9382705688477,
    "a": -5.43739795684814,
    "b": 44.4476356506348,
    "C": 44.7789878845215,
    "h": 96.974494934082,
    "CMY_C": 0.38855618238449,
    "CMY_M": 0.44008016586304,
    "CMY_Y": 0.76560312509537,
    "CMYK_C": 0,
    "CMYK_M": 0.08426609635353,
    "CMYK_Y": 0.61665016412735,
    "CMYK_K": 0.38855618238449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02331",
    "Farbtonhilfsbezeichnung": "S1.13.73",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "205",
    "Bcolor": "219",
    "Y": 58,
    "L": 80.5797787818137,
    "a": -6.28257112539582,
    "b": -11.4509851320176,
    "C": 13.0612311992149,
    "h": 1.06899097158247,
    "CMY_C": 0.312786,
    "CMY_M": 0.1978834,
    "CMY_Y": 0.1400213,
    "CMYK_C": 0.2008941,
    "CMYK_M": 0.06728316,
    "CMYK_Y": 0,
    "CMYK_K": 0.1400213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02333",
    "Farbtonhilfsbezeichnung": "S6.14.75",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "210",
    "Bcolor": "232",
    "Y": 60,
    "L": 82.7600326538086,
    "a": -5.15312719345093,
    "b": -14.7766923904419,
    "C": 15.6494522094727,
    "h": 250.774627685547,
    "CMY_C": 0.29468059539795,
    "CMY_M": 0.17543363571167,
    "CMY_Y": 0.09168672561646,
    "CMYK_C": 0.22348442673683,
    "CMYK_M": 0.09220046550035,
    "CMYK_Y": 0,
    "CMYK_K": 0.09168672561646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02335",
    "Farbtonhilfsbezeichnung": "G3.46.83",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "229",
    "Bcolor": "101",
    "Y": 76,
    "L": 90.5648574829102,
    "a": -6.07833576202393,
    "b": 63.2087898254395,
    "C": 63.500373840332,
    "h": 95.4928359985352,
    "CMY_C": 0.00890231132507,
    "CMY_M": 0.10388690233231,
    "CMY_Y": 0.60500347614288,
    "CMYK_C": 0,
    "CMYK_M": 0.09583777189255,
    "CMYK_Y": 0.60145550966263,
    "CMYK_K": 0.00890231132507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02336",
    "Farbtonhilfsbezeichnung": "ON.00.63",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "174",
    "Bcolor": "171",
    "Y": 42,
    "L": 71.0951371094388,
    "a": -0.11802152170009,
    "b": 1.19045916975942,
    "C": 1.19629516192647,
    "h": -1.47197973118127,
    "CMY_C": 0.3146127,
    "CMY_M": 0.3172082,
    "CMY_Y": 0.3312845,
    "CMYK_C": 0,
    "CMYK_M": 0.003786963,
    "CMYK_Y": 0.02432473,
    "CMYK_K": 0.3146127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02337",
    "Farbtonhilfsbezeichnung": "E1.14.79",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "206",
    "Bcolor": "178",
    "Y": 67,
    "L": 85.2016525268555,
    "a": 9.65989875793457,
    "b": 18.0637359619141,
    "C": 20.4844379425049,
    "h": 61.8635787963867,
    "CMY_C": 0.04435235261917,
    "CMY_M": 0.19316840171814,
    "CMY_Y": 0.30238175392151,
    "CMYK_C": 0,
    "CMYK_M": 0.15572272241116,
    "CMYK_Y": 0.2700047492981,
    "CMYK_K": 0.04435235261917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02338",
    "Farbtonhilfsbezeichnung": "E1.21.69",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "178",
    "Bcolor": "141",
    "Y": 50,
    "L": 75.8947278909366,
    "a": 12.2935421707624,
    "b": 24.5085708794722,
    "C": 27.418993884868,
    "h": 1.10586813480101,
    "CMY_C": 0.1195549,
    "CMY_M": 0.3018758,
    "CMY_Y": 0.4455436,
    "CMYK_C": 0,
    "CMYK_M": 0.2070781,
    "CMYK_Y": 0.3702544,
    "CMYK_K": 0.1195549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02339",
    "Farbtonhilfsbezeichnung": "ON.00.83",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "227",
    "Bcolor": "221",
    "Y": 75,
    "L": 89.9196853637695,
    "a": -0.69434839487076,
    "b": 1.84327590465546,
    "C": 1.96971714496613,
    "h": 110.641021728516,
    "CMY_C": 0.11243581771851,
    "CMY_M": 0.11153960227966,
    "CMY_Y": 0.13373333215714,
    "CMYK_C": 0.0010087286355,
    "CMYK_M": 0,
    "CMYK_Y": 0.02497998811305,
    "CMYK_K": 0.11153960227966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02340",
    "Farbtonhilfsbezeichnung": "U0.30.16",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "56",
    "Bcolor": "84",
    "Y": 5,
    "L": 22.777437210083,
    "a": -0.05754501000047,
    "b": -20.371301651001,
    "C": 20.3713836669922,
    "h": 269.838134765625,
    "CMY_C": 0.88311940431595,
    "CMY_M": 0.78056460618973,
    "CMY_Y": 0.67096185684204,
    "CMYK_C": 0.64478099346161,
    "CMYK_M": 0.33310043811798,
    "CMYK_Y": 0,
    "CMYK_K": 0.67096185684204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02341",
    "Farbtonhilfsbezeichnung": "T0.13.64",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "178",
    "Bcolor": "197",
    "Y": 43,
    "L": 71.662852157253,
    "a": -3.18870464417803,
    "b": -12.6245018754698,
    "C": 13.020978646459,
    "h": 1.32339031358288,
    "CMY_C": 0.3856459,
    "CMY_M": 0.3003511,
    "CMY_Y": 0.228353,
    "CMYK_C": 0.2038406,
    "CMYK_M": 0.09330449,
    "CMYK_Y": 0,
    "CMYK_K": 0.228353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02343",
    "Farbtonhilfsbezeichnung": "G5.27.85",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "234",
    "Bcolor": "158",
    "Y": 81,
    "L": 92.1458346955996,
    "a": -5.55353212153337,
    "b": 37.9813310946084,
    "C": 38.3851954631362,
    "h": -1.42560776401268,
    "CMY_C": 0.02813856,
    "CMY_M": 0.08370164,
    "CMY_Y": 0.381935,
    "CMYK_C": 0,
    "CMYK_M": 0.05717182,
    "CMYK_Y": 0.36404,
    "CMYK_K": 0.02813856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02345",
    "Farbtonhilfsbezeichnung": "C3.57.31",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "61",
    "Bcolor": "57",
    "Y": 12,
    "L": 41.0764152803871,
    "a": 43.4914093851606,
    "b": 25.7610478665956,
    "C": 50.5483360506819,
    "h": 0.5347569844756,
    "CMY_C": 0.3441437,
    "CMY_M": 0.759334,
    "CMY_Y": 0.7782052,
    "CMYK_C": 0,
    "CMYK_M": 0.6330507,
    "CMYK_Y": 0.6618241,
    "CMYK_K": 0.3441437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02346",
    "Farbtonhilfsbezeichnung": "E0.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "82",
    "Bcolor": "53",
    "Y": 11,
    "L": 38.9033264058372,
    "a": 14.3920779408828,
    "b": 23.9141311867581,
    "C": 27.910886368475,
    "h": 1.02903734769255,
    "CMY_C": 0.5129868,
    "CMY_M": 0.6780759,
    "CMY_Y": 0.7932209,
    "CMYK_C": 0,
    "CMYK_M": 0.3389828,
    "CMYK_Y": 0.5754137,
    "CMYK_K": 0.5129868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02348",
    "Farbtonhilfsbezeichnung": "G4.50.70",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "190",
    "Bcolor": "67",
    "Y": 50,
    "L": 76.1728591918945,
    "a": -7.95144510269165,
    "b": 60.9189453125,
    "C": 61.4356842041016,
    "h": 97.4364852905273,
    "CMY_C": 0.19253098964691,
    "CMY_M": 0.25642651319504,
    "CMY_Y": 0.73749315738678,
    "CMYK_C": 0,
    "CMYK_M": 0.07913061976433,
    "CMYK_Y": 0.67490166425705,
    "CMYK_K": 0.19253098964691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02349",
    "Farbtonhilfsbezeichnung": "F5.26.81",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "217",
    "Bcolor": "151",
    "Y": 73,
    "L": 88.4936904907227,
    "a": 4.8689227104187,
    "b": 36.6796455383301,
    "C": 37.0013885498047,
    "h": 82.4386596679688,
    "CMY_C": 0.00075334310532,
    "CMY_M": 0.14889979362488,
    "CMY_Y": 0.40778356790543,
    "CMYK_C": 0,
    "CMYK_M": 0.14825813472271,
    "CMYK_Y": 0.40733709931374,
    "CMYK_K": 0.00075334310532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02350",
    "Farbtonhilfsbezeichnung": "ON.00.30",
    "Farbtonklasse": "02",
    "Y": 11,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02351",
    "Farbtonhilfsbezeichnung": "F8.25.81",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "218",
    "Bcolor": "152",
    "Y": 72,
    "L": 88.1211624145508,
    "a": 1.52527856826782,
    "b": 35.4309387207031,
    "C": 35.463752746582,
    "h": 87.5349731445313,
    "CMY_C": 0.0300857424736,
    "CMY_M": 0.14457947015762,
    "CMY_Y": 0.40289962291718,
    "CMYK_C": 0,
    "CMYK_M": 0.11804520338774,
    "CMYK_Y": 0.38437819480896,
    "CMYK_K": 0.0300857424736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02352",
    "Farbtonhilfsbezeichnung": "F2.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "219",
    "Y": 84,
    "L": 93.6153564453125,
    "a": 2.07504749298096,
    "b": 8.11856842041016,
    "C": 8.37955665588379,
    "h": 75.6625595092773,
    "CMY_C": 0.02958339452744,
    "CMY_M": 0.07863837480545,
    "CMY_Y": 0.1392610669136,
    "CMYK_C": 0,
    "CMYK_M": 0.0505504347384,
    "CMYK_Y": 0.11302122473717,
    "CMYK_K": 0.02958339452744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02353",
    "Farbtonhilfsbezeichnung": "H4.16.70",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "194",
    "Bcolor": "155",
    "Y": 52,
    "L": 77.3204193115234,
    "a": -7.73747682571411,
    "b": 18.7276706695557,
    "C": 20.2631244659424,
    "h": 112.448333740234,
    "CMY_C": 0.253801882267,
    "CMY_M": 0.23798489570618,
    "CMY_Y": 0.39270722866058,
    "CMYK_C": 0.02075678855181,
    "CMYK_M": 0,
    "CMYK_Y": 0.20304365456104,
    "CMYK_K": 0.23798489570618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02354",
    "Farbtonhilfsbezeichnung": "UN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "233",
    "Bcolor": "237",
    "Y": 79,
    "L": 92.2909088134766,
    "a": 0.02916941978037,
    "b": -2.87907338142395,
    "C": 2.87922120094299,
    "h": 270.580474853516,
    "CMY_C": 0.09678518772125,
    "CMY_M": 0.08543884754181,
    "CMY_Y": 0.07240813970566,
    "CMYK_C": 0.02627992816269,
    "CMYK_M": 0.01404788903892,
    "CMYK_Y": 0,
    "CMYK_K": 0.07240813970566
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02357",
    "Farbtonhilfsbezeichnung": "B3.49.33",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "57",
    "Bcolor": "71",
    "Y": 12,
    "L": 41.7834423003507,
    "a": 48.9899072260278,
    "b": 17.9617810742913,
    "C": 52.1788902658497,
    "h": 0.35142347345415,
    "CMY_C": 0.3168279,
    "CMY_M": 0.7783459,
    "CMY_Y": 0.7211789,
    "CMYK_C": 0,
    "CMYK_M": 0.6755517,
    "CMYK_Y": 0.5918729,
    "CMYK_K": 0.3168279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02358",
    "Farbtonhilfsbezeichnung": "B8.50.20",
    "Farbtonklasse": "04",
    "Rcolor": "129",
    "Gcolor": "39",
    "Bcolor": "45",
    "Y": 9,
    "L": 30.0562431301225,
    "a": 39.1980608195469,
    "b": 17.4150502894725,
    "C": 42.8925628588192,
    "h": 0.41808989556943,
    "CMY_C": 0.4957096,
    "CMY_M": 0.8483502,
    "CMY_Y": 0.8219115,
    "CMYK_C": 0,
    "CMYK_M": 0.6992809,
    "CMYK_Y": 0.6468533,
    "CMYK_K": 0.4957096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02359",
    "Farbtonhilfsbezeichnung": "B1.16.12",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "49",
    "Bcolor": "51",
    "Y": 4,
    "L": 23.130012228314,
    "a": 10.6894752719314,
    "b": 2.56367896268931,
    "C": 10.9926034865708,
    "h": 0.23538618895161,
    "CMY_C": 0.7182638,
    "CMY_M": 0.8064896,
    "CMY_Y": 0.7991637,
    "CMYK_C": 0,
    "CMYK_M": 0.3131503,
    "CMYK_Y": 0.2871476,
    "CMYK_K": 0.7182638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02360",
    "Farbtonhilfsbezeichnung": "C0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 80,
    "L": 93.0756759643555,
    "a": 5.23835134506226,
    "b": 3.45370817184448,
    "C": 6.27442646026611,
    "h": 33.397346496582,
    "CMY_C": 0.02594739198685,
    "CMY_M": 0.09116780757904,
    "CMY_Y": 0.11000627279282,
    "CMYK_C": 0,
    "CMYK_M": 0.06695779412985,
    "CMYK_Y": 0.08629809319973,
    "CMYK_K": 0.02594739198685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02361",
    "Farbtonhilfsbezeichnung": "C0.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 72,
    "L": 88.373908996582,
    "a": 10.7422332763672,
    "b": 6.66801404953003,
    "C": 12.6434955596924,
    "h": 31.8290672302246,
    "CMY_C": 0.02934432029724,
    "CMY_M": 0.15818983316422,
    "CMY_Y": 0.18450778722763,
    "CMYK_C": 0,
    "CMYK_M": 0.13274069130421,
    "CMYK_Y": 0.15985427796841,
    "CMYK_K": 0.02934432029724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02362",
    "Farbtonhilfsbezeichnung": "C4.35.15",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "45",
    "Bcolor": "37",
    "Y": 5,
    "L": 25.2918092430466,
    "a": 22.4755016806959,
    "b": 15.3257075817508,
    "C": 27.2034095046981,
    "h": 0.59846450919033,
    "CMY_C": 0.6234979,
    "CMY_M": 0.8230575,
    "CMY_Y": 0.8530096,
    "CMYK_C": 0,
    "CMYK_M": 0.5300357,
    "CMYK_Y": 0.6095895,
    "CMYK_K": 0.6234979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02363",
    "Farbtonhilfsbezeichnung": "C4.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "69",
    "Bcolor": "60",
    "Y": 12,
    "L": 40.2658034144285,
    "a": 34.4363919702324,
    "b": 22.2262728574485,
    "C": 40.9862452178928,
    "h": 0.57315569911294,
    "CMY_C": 0.3997885,
    "CMY_M": 0.7277723,
    "CMY_Y": 0.7652299,
    "CMYK_C": 0,
    "CMYK_M": 0.546447,
    "CMYK_Y": 0.6088544,
    "CMYK_K": 0.3997885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02364",
    "Farbtonhilfsbezeichnung": "C4.32.60",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "140",
    "Bcolor": "119",
    "Y": 38,
    "L": 67.9576804139797,
    "a": 34.6801921572418,
    "b": 26.2564616256556,
    "C": 43.4984770441763,
    "h": 0.64803126004387,
    "CMY_C": 0.074503,
    "CMY_M": 0.4511643,
    "CMY_Y": 0.5328255,
    "CMYK_C": 0,
    "CMYK_M": 0.4069827,
    "CMYK_Y": 0.4952177,
    "CMYK_K": 0.074503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02365",
    "Farbtonhilfsbezeichnung": "C2.53.40",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "75",
    "Bcolor": "67",
    "Y": 18,
    "L": 48.3260659563391,
    "a": 48.0662678514384,
    "b": 29.6030198722274,
    "C": 56.4509069078763,
    "h": 0.55201371603815,
    "CMY_C": 0.2336904,
    "CMY_M": 0.7071407,
    "CMY_Y": 0.7376593,
    "CMYK_C": 0,
    "CMYK_M": 0.6178316,
    "CMYK_Y": 0.6576571,
    "CMYK_K": 0.2336904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02367",
    "Farbtonhilfsbezeichnung": "C4.43.54",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "115",
    "Bcolor": "95",
    "Y": 30,
    "L": 61.912867559505,
    "a": 43.9383989047585,
    "b": 31.5061621202032,
    "C": 54.0668211554758,
    "h": 0.62207950123571,
    "CMY_C": 0.08978777,
    "CMY_M": 0.5485353,
    "CMY_Y": 0.6258509,
    "CMYK_C": 0,
    "CMYK_M": 0.5040007,
    "CMYK_Y": 0.5889429,
    "CMYK_K": 0.08978777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02368",
    "Farbtonhilfsbezeichnung": "C4.46.50",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "106",
    "Bcolor": "86",
    "Y": 26,
    "L": 58.4671712164012,
    "a": 44.2081497080693,
    "b": 32.3254896942904,
    "C": 54.7658450549861,
    "h": 0.63136737152639,
    "CMY_C": 0.1290782,
    "CMY_M": 0.5855638,
    "CMY_Y": 0.6640831,
    "CMYK_C": 0,
    "CMYK_M": 0.5241408,
    "CMYK_Y": 0.6142973,
    "CMYK_K": 0.1290782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02369",
    "Farbtonhilfsbezeichnung": "C4.55.40",
    "Farbtonklasse": "04",
    "Rcolor": "193",
    "Gcolor": "66",
    "Bcolor": "48",
    "Y": 17,
    "L": 46.3112913429161,
    "a": 50.2750082292842,
    "b": 38.1173033618925,
    "C": 63.09124557367,
    "h": 0.64871323034576,
    "CMY_C": 0.2412303,
    "CMY_M": 0.7416014,
    "CMY_Y": 0.8126698,
    "CMYK_C": 0,
    "CMYK_M": 0.6594506,
    "CMYK_Y": 0.7531132,
    "CMYK_K": 0.2412303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02370",
    "Farbtonhilfsbezeichnung": "C4.49.33",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "73",
    "Bcolor": "63",
    "Y": 13,
    "L": 42.8741063288985,
    "a": 37.0292528445694,
    "b": 24.0283921387908,
    "C": 44.1421476029718,
    "h": 0.57560363520094,
    "CMY_C": 0.3559946,
    "CMY_M": 0.7127721,
    "CMY_Y": 0.7530634,
    "CMYK_C": 0,
    "CMYK_M": 0.5539977,
    "CMYK_Y": 0.6165613,
    "CMYK_K": 0.3559946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02371",
    "Farbtonhilfsbezeichnung": "C6.49.48",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "93",
    "Bcolor": "70",
    "Y": 22,
    "L": 54.6174240112305,
    "a": 46.1279602050781,
    "b": 36.0231094360352,
    "C": 58.5273704528809,
    "h": 37.9876556396484,
    "CMY_C": 0.16239315271378,
    "CMY_M": 0.63406318426132,
    "CMY_Y": 0.72491532564163,
    "CMYK_C": 0,
    "CMYK_M": 0.56311625242233,
    "CMYK_Y": 0.67158257961273,
    "CMYK_K": 0.16239315271378
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02373",
    "Farbtonhilfsbezeichnung": "D2.35.55",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "132",
    "Bcolor": "95",
    "Y": 31,
    "L": 62.8626828816918,
    "a": 26.9933367774856,
    "b": 32.1787577478358,
    "C": 42.001341414015,
    "h": 0.87280774370721,
    "CMY_C": 0.1697552,
    "CMY_M": 0.4804746,
    "CMY_Y": 0.6261269,
    "CMYK_C": 0,
    "CMYK_M": 0.3742504,
    "CMYK_Y": 0.5496834,
    "CMYK_K": 0.1697552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02374",
    "Farbtonhilfsbezeichnung": "D2.35.45",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "110",
    "Bcolor": "84",
    "Y": 20,
    "L": 53.2958030700684,
    "a": 24.7583808898926,
    "b": 25.2726898193359,
    "C": 35.3791770935059,
    "h": 45.5889701843262,
    "CMY_C": 0.2999033331871,
    "CMY_M": 0.56871509552002,
    "CMY_Y": 0.66937625408173,
    "CMYK_C": 0,
    "CMYK_M": 0.38396379351616,
    "CMYK_Y": 0.52774560451508,
    "CMYK_K": 0.2999033331871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02375",
    "Farbtonhilfsbezeichnung": "D4.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "67",
    "Bcolor": "53",
    "Y": 7,
    "L": 31.9455420541895,
    "a": 13.3507831591303,
    "b": 14.5066138328236,
    "C": 19.7151022279061,
    "h": 0.82686535803799,
    "CMY_C": 0.6011737,
    "CMY_M": 0.7377079,
    "CMY_Y": 0.7940621,
    "CMYK_C": 0,
    "CMYK_M": 0.3423401,
    "CMYK_Y": 0.4836403,
    "CMYK_K": 0.6011737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02376",
    "Farbtonhilfsbezeichnung": "E0.25.73",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "187",
    "Bcolor": "144",
    "Y": 57,
    "L": 80.2572397420908,
    "a": 16.0050420792004,
    "b": 29.2086546093335,
    "C": 33.3062588118857,
    "h": 1.0695241672674,
    "CMY_C": 0.03729068,
    "CMY_M": 0.265994,
    "CMY_Y": 0.4344379,
    "CMYK_C": 0,
    "CMYK_M": 0.2375622,
    "CMYK_Y": 0.4125308,
    "CMYK_K": 0.03729068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02377",
    "Farbtonhilfsbezeichnung": "D7.41.60",
    "Farbtonklasse": "04",
    "Rcolor": "229",
    "Gcolor": "145",
    "Bcolor": "91",
    "Y": 38,
    "L": 67.6710126089083,
    "a": 27.1430592693996,
    "b": 41.1147147536847,
    "C": 49.2662707719896,
    "h": 0.98729884682561,
    "CMY_C": 0.1021554,
    "CMY_M": 0.4329802,
    "CMY_Y": 0.644708,
    "CMYK_C": 0,
    "CMYK_M": 0.3684656,
    "CMYK_Y": 0.6042835,
    "CMYK_K": 0.1021554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02378",
    "Farbtonhilfsbezeichnung": "D6.47.61",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "143",
    "Bcolor": "84",
    "Y": 39,
    "L": 68.9537126027691,
    "a": 33.2233661432236,
    "b": 46.5709169848012,
    "C": 57.2070132649131,
    "h": 0.95113821259031,
    "CMY_C": 0.04739546,
    "CMY_M": 0.4398025,
    "CMY_Y": 0.6715201,
    "CMYK_C": 0,
    "CMYK_M": 0.4119307,
    "CMYK_Y": 0.655177,
    "CMYK_K": 0.04739546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02379",
    "Farbtonhilfsbezeichnung": "D6.58.58",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "126",
    "Bcolor": "65",
    "Y": 35,
    "L": 65.1784973144531,
    "a": 40.4337577819824,
    "b": 51.756591796875,
    "C": 65.6782608032227,
    "h": 52.002010345459,
    "CMY_C": 0.05041354894638,
    "CMY_M": 0.50479531288147,
    "CMY_Y": 0.74596166610718,
    "CMYK_C": 0,
    "CMYK_M": 0.47850489616394,
    "CMYK_Y": 0.73247474431992,
    "CMYK_K": 0.05041354894638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02380",
    "Farbtonhilfsbezeichnung": "D5.63.53",
    "Farbtonklasse": "04",
    "Rcolor": "233",
    "Gcolor": "111",
    "Bcolor": "49",
    "Y": 29,
    "L": 60.7013812275273,
    "a": 44.2344525127263,
    "b": 53.9607953417932,
    "C": 69.7743091905576,
    "h": 0.8841271777018,
    "CMY_C": 0.08467437,
    "CMY_M": 0.5661893,
    "CMY_Y": 0.805917,
    "CMYK_C": 0,
    "CMYK_M": 0.5260586,
    "CMYK_Y": 0.7879629,
    "CMYK_K": 0.08467437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02381",
    "Farbtonhilfsbezeichnung": "D3.71.48",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "90",
    "Bcolor": "42",
    "Y": 23,
    "L": 55.2082359070716,
    "a": 49.7966300964848,
    "b": 51.5888376482656,
    "C": 71.7015518581379,
    "h": 0.80307348658748,
    "CMY_C": 0.1264503,
    "CMY_M": 0.6470661,
    "CMY_Y": 0.8353974,
    "CMYK_C": 0,
    "CMYK_M": 0.5959772,
    "CMYK_Y": 0.8115704,
    "CMYK_K": 0.1264503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02382",
    "Farbtonhilfsbezeichnung": "D1.58.40",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "82",
    "Bcolor": "49",
    "Y": 16,
    "L": 47.4940278130345,
    "a": 39.5859450865646,
    "b": 38.4474803603959,
    "C": 55.183836351413,
    "h": 0.77080974881592,
    "CMY_C": 0.2782511,
    "CMY_M": 0.6798104,
    "CMY_Y": 0.8091333,
    "CMYK_C": 0,
    "CMYK_M": 0.5563698,
    "CMYK_Y": 0.7355496,
    "CMYK_K": 0.2782511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02383",
    "Farbtonhilfsbezeichnung": "D6.35.55",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "135",
    "Bcolor": "95",
    "Y": 31,
    "L": 62.5470594228641,
    "a": 22.8360276056654,
    "b": 31.9128060319445,
    "C": 39.2417041632907,
    "h": 0.94969320098173,
    "CMY_C": 0.1970817,
    "CMY_M": 0.4712738,
    "CMY_Y": 0.628355,
    "CMYK_C": 0,
    "CMYK_M": 0.3414944,
    "CMYK_Y": 0.5371323,
    "CMYK_K": 0.1970817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02384",
    "Farbtonhilfsbezeichnung": "D6.35.45",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "109",
    "Bcolor": "73",
    "Y": 20,
    "L": 52.0160575783675,
    "a": 21.1228606050625,
    "b": 30.1506076837301,
    "C": 36.8135081707666,
    "h": 0.9596823663923,
    "CMY_C": 0.3281012,
    "CMY_M": 0.571643,
    "CMY_Y": 0.7156361,
    "CMYK_C": 0,
    "CMYK_M": 0.3624679,
    "CMYK_Y": 0.5767757,
    "CMYK_K": 0.3281012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02386",
    "Farbtonhilfsbezeichnung": "E0.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "81",
    "Bcolor": "62",
    "Y": 10,
    "L": 37.0153668173662,
    "a": 9.44177675566521,
    "b": 15.7314596189706,
    "C": 18.347369567519,
    "h": 1.03024124449994,
    "CMY_C": 0.5692452,
    "CMY_M": 0.6820425,
    "CMY_Y": 0.7581934,
    "CMYK_C": 0,
    "CMYK_M": 0.2618597,
    "CMYK_Y": 0.4386443,
    "CMYK_K": 0.5692452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02388",
    "Farbtonhilfsbezeichnung": "E0.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "85",
    "Bcolor": "60",
    "Y": 11,
    "L": 39.2839524554055,
    "a": 12.2152550906917,
    "b": 19.7827507391957,
    "C": 23.250154488515,
    "h": 1.01763017722988,
    "CMY_C": 0.5255188,
    "CMY_M": 0.6683397,
    "CMY_Y": 0.763447,
    "CMYK_C": 0,
    "CMYK_M": 0.3010043,
    "CMYK_Y": 0.5014493,
    "CMYK_K": 0.5255188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02389",
    "Farbtonhilfsbezeichnung": "E0.35.65",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "163",
    "Bcolor": "110",
    "Y": 44,
    "L": 72.5474195906796,
    "a": 20.3889664101886,
    "b": 37.1010782467575,
    "C": 42.334382697139,
    "h": 1.06829724546465,
    "CMY_C": 0.0884117,
    "CMY_M": 0.3616027,
    "CMY_Y": 0.5691195,
    "CMYK_C": 0,
    "CMYK_M": 0.2996868,
    "CMYK_Y": 0.5273299,
    "CMYK_K": 0.0884117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02390",
    "Farbtonhilfsbezeichnung": "E0.35.55",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "140",
    "Bcolor": "95",
    "Y": 33,
    "L": 63.7663291402336,
    "a": 19.6382974163832,
    "b": 33.1829910337972,
    "C": 38.5587035487889,
    "h": 1.0364145903688,
    "CMY_C": 0.1996964,
    "CMY_M": 0.4499413,
    "CMY_Y": 0.6265346,
    "CMYK_C": 0,
    "CMYK_M": 0.3126874,
    "CMYK_Y": 0.5333453,
    "CMYK_K": 0.1996964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02391",
    "Farbtonhilfsbezeichnung": "E0.45.30",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "93",
    "Bcolor": "61",
    "Y": 12,
    "L": 44.2094039916992,
    "a": 16.8547248840332,
    "b": 26.4065761566162,
    "C": 31.3271293640137,
    "h": 57.4508247375488,
    "CMY_C": 0.44084841012955,
    "CMY_M": 0.6348482966423,
    "CMY_Y": 0.76217156648636,
    "CMYK_C": 0,
    "CMYK_M": 0.34695401787758,
    "CMYK_Y": 0.57466197013855,
    "CMYK_K": 0.44084841012955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02392",
    "Farbtonhilfsbezeichnung": "E0.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "66",
    "Bcolor": "46",
    "Y": 7,
    "L": 31.0324657808949,
    "a": 11.6881628352343,
    "b": 17.5102408345746,
    "C": 21.0528307965403,
    "h": 0.98221397693019,
    "CMY_C": 0.6149364,
    "CMY_M": 0.7423192,
    "CMY_Y": 0.8207409,
    "CMYK_C": 0,
    "CMYK_M": 0.33081,
    "CMYK_Y": 0.5344691,
    "CMYK_K": 0.6149364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02393",
    "Farbtonhilfsbezeichnung": "E4.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "100",
    "Bcolor": "52",
    "Y": 17,
    "L": 47.6342345976252,
    "a": 18.1567108495271,
    "b": 35.933604144724,
    "C": 40.2602788825793,
    "h": 1.10292966907538,
    "CMY_C": 0.3868479,
    "CMY_M": 0.6069292,
    "CMY_Y": 0.7976843,
    "CMYK_C": 0,
    "CMYK_M": 0.3589343,
    "CMYK_Y": 0.67004,
    "CMYK_K": 0.3868479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02395",
    "Farbtonhilfsbezeichnung": "E6.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "195",
    "Bcolor": "163",
    "Y": 59,
    "L": 81.1073969527098,
    "a": 8.83162754903544,
    "b": 19.925562034165,
    "C": 21.7950835635526,
    "h": 1.1535857100609,
    "CMY_C": 0.09239673,
    "CMY_M": 0.2360673,
    "CMY_Y": 0.3591866,
    "CMYK_C": 0,
    "CMYK_M": 0.1582966,
    "CMYK_Y": 0.2939499,
    "CMYK_K": 0.09239673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02396",
    "Farbtonhilfsbezeichnung": "E3.20.77",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "201",
    "Bcolor": "160",
    "Y": 64,
    "L": 84.1059193216797,
    "a": 11.9302550568451,
    "b": 25.9546938559306,
    "C": 28.5653132115939,
    "h": 1.13994077237363,
    "CMY_C": 0.02496466,
    "CMY_M": 0.2128317,
    "CMY_Y": 0.3715313,
    "CMYK_C": 0,
    "CMYK_M": 0.1926771,
    "CMYK_Y": 0.3554401,
    "CMYK_K": 0.02496466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02398",
    "Farbtonhilfsbezeichnung": "E0.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "230",
    "Bcolor": "221",
    "Y": 79,
    "L": 92.1341781616211,
    "a": 3.09863114356995,
    "b": 5.21195554733276,
    "C": 6.0634970664978,
    "h": 59.2675132751465,
    "CMY_C": 0.04739612340927,
    "CMY_M": 0.09690147638321,
    "CMY_Y": 0.13376897573471,
    "CMYK_C": 0,
    "CMYK_M": 0.05196845531464,
    "CMYK_Y": 0.09067027270794,
    "CMYK_K": 0.04739612340927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02399",
    "Farbtonhilfsbezeichnung": "E6.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "212",
    "Y": 78,
    "L": 91.8651733398438,
    "a": 3.48577117919922,
    "b": 9.56972789764404,
    "C": 10.1848068237305,
    "h": 69.9858627319336,
    "CMY_C": 0.0345321893692,
    "CMY_M": 0.10202372074127,
    "CMY_Y": 0.16902077198029,
    "CMYK_C": 0,
    "CMYK_M": 0.06990551948547,
    "CMYK_Y": 0.13929887115955,
    "CMYK_K": 0.0345321893692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02400",
    "Farbtonhilfsbezeichnung": "E5.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "224",
    "Bcolor": "204",
    "Y": 77,
    "L": 90.3215648708048,
    "a": 4.37034780212242,
    "b": 11.4728249104742,
    "C": 12.2770375635946,
    "h": 1.20683656416255,
    "CMY_C": 0.04014825,
    "CMY_M": 0.1219015,
    "CMY_Y": 0.1998003,
    "CMYK_C": 0,
    "CMYK_M": 0.08517278,
    "CMYK_Y": 0.1663299,
    "CMYK_K": 0.04014825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02401",
    "Farbtonhilfsbezeichnung": "E3.09.72",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "193",
    "Bcolor": "175",
    "Y": 56,
    "L": 79.384947301534,
    "a": 4.77055802473875,
    "b": 11.0650866202419,
    "C": 12.0496624758063,
    "h": 1.16373986916647,
    "CMY_C": 0.1608387,
    "CMY_M": 0.242534,
    "CMY_Y": 0.3137451,
    "CMYK_C": 0,
    "CMYK_M": 0.09735349,
    "CMYK_Y": 0.1822134,
    "CMYK_K": 0.1608387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02402",
    "Farbtonhilfsbezeichnung": "E1.09.78",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "208",
    "Bcolor": "189",
    "Y": 66,
    "L": 84.9601952816438,
    "a": 5.95484088873927,
    "b": 11.5476561037812,
    "C": 12.9926322006511,
    "h": 1.09468727110461,
    "CMY_C": 0.08899651,
    "CMY_M": 0.1849328,
    "CMY_Y": 0.2578513,
    "CMYK_C": 0,
    "CMYK_M": 0.1053083,
    "CMYK_Y": 0.1853503,
    "CMYK_K": 0.08899651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02403",
    "Farbtonhilfsbezeichnung": "E0.11.67",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "178",
    "Bcolor": "161",
    "Y": 48,
    "L": 74.5616226196289,
    "a": 7.37163782119751,
    "b": 11.7451705932617,
    "C": 13.8668699264526,
    "h": 57.8863258361816,
    "CMY_C": 0.19427049160004,
    "CMY_M": 0.30070531368256,
    "CMY_Y": 0.36867034435272,
    "CMYK_C": 0,
    "CMYK_M": 0.13209746778011,
    "CMYK_Y": 0.2164496332407,
    "CMYK_K": 0.19427049160004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02404",
    "Farbtonhilfsbezeichnung": "E8.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "215",
    "Bcolor": "202",
    "Y": 70,
    "L": 86.7969935252579,
    "a": 2.48522133682011,
    "b": 7.54400001106605,
    "C": 7.94281192399459,
    "h": 1.25256270745646,
    "CMY_C": 0.1048754,
    "CMY_M": 0.1552634,
    "CMY_Y": 0.209309,
    "CMYK_C": 0,
    "CMYK_M": 0.05629155,
    "CMYK_Y": 0.1166693,
    "CMYK_K": 0.1048754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02405",
    "Farbtonhilfsbezeichnung": "E8.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "208",
    "Bcolor": "192",
    "Y": 64,
    "L": 84.2368469238281,
    "a": 3.31464886665344,
    "b": 9.04369354248047,
    "C": 9.63199329376221,
    "h": 69.8713607788086,
    "CMY_C": 0.12295436859131,
    "CMY_M": 0.18573004007339,
    "CMY_Y": 0.24772518873215,
    "CMYK_C": 0,
    "CMYK_M": 0.07157628983259,
    "CMYK_Y": 0.1422626376152,
    "CMYK_K": 0.12295436859131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02406",
    "Farbtonhilfsbezeichnung": "G4.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "231",
    "Bcolor": "206",
    "Y": 77,
    "L": 91.4108963012695,
    "a": -1.35290241241455,
    "b": 11.8313636779785,
    "C": 11.9084634780884,
    "h": 96.5233764648438,
    "CMY_C": 0.0695161819458,
    "CMY_M": 0.09603160619736,
    "CMY_Y": 0.1915403008461,
    "CMYK_C": 0,
    "CMYK_M": 0.02849638462067,
    "CMYK_Y": 0.13114050030708,
    "CMYK_K": 0.0695161819458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02407",
    "Farbtonhilfsbezeichnung": "F2.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "211",
    "Bcolor": "175",
    "Y": 68,
    "L": 86.0608357821844,
    "a": 4.37242796119813,
    "b": 20.8252464670442,
    "C": 21.2793095914554,
    "h": 1.36384431923478,
    "CMY_C": 0.06478361,
    "CMY_M": 0.1712024,
    "CMY_Y": 0.3145751,
    "CMYK_C": 0,
    "CMYK_M": 0.1137905,
    "CMYK_Y": 0.2670949,
    "CMYK_K": 0.06478361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02408",
    "Farbtonhilfsbezeichnung": "E6.18.76",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "203",
    "Bcolor": "165",
    "Y": 64,
    "L": 83.8561765801586,
    "a": 7.78569981698535,
    "b": 22.8168259210064,
    "C": 24.1086015096213,
    "h": 1.24195905185952,
    "CMY_C": 0.06195136,
    "CMY_M": 0.2042363,
    "CMY_Y": 0.3518198,
    "CMYK_C": 0,
    "CMYK_M": 0.1516818,
    "CMYK_Y": 0.3090122,
    "CMYK_K": 0.06195136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02409",
    "Farbtonhilfsbezeichnung": "E8.50.70",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "173",
    "Bcolor": "74",
    "Y": 49,
    "L": 75.7554040839473,
    "a": 16.4950903676735,
    "b": 58.438075072426,
    "C": 60.7214675745589,
    "h": 1.29568746382184,
    "CMY_C": 0.04921102,
    "CMY_M": 0.3201217,
    "CMY_Y": 0.7079913,
    "CMYK_C": 0,
    "CMYK_M": 0.2849325,
    "CMYK_Y": 0.6928775,
    "CMYK_K": 0.04921102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02410",
    "Farbtonhilfsbezeichnung": "E8.55.45",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "117",
    "Bcolor": "54",
    "Y": 21,
    "L": 54.5163841247559,
    "a": 18.2181797027588,
    "b": 42.9187965393066,
    "C": 46.6253700256348,
    "h": 66.9997329711914,
    "CMY_C": 0.30278569459915,
    "CMY_M": 0.54061102867126,
    "CMY_Y": 0.78698724508286,
    "CMYK_C": 0,
    "CMYK_M": 0.34110793471336,
    "CMYK_Y": 0.694480240345,
    "CMYK_K": 0.30278569459915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02411",
    "Farbtonhilfsbezeichnung": "G0.16.84",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "229",
    "Bcolor": "185",
    "Y": 79,
    "L": 91.2887213618881,
    "a": 0.00243944008021,
    "b": 22.559750565859,
    "C": 22.5597506977503,
    "h": 1.57068819439053,
    "CMY_C": 0.0322711,
    "CMY_M": 0.103205,
    "CMY_Y": 0.2727032,
    "CMYK_C": 0,
    "CMYK_M": 0.07329934,
    "CMYK_Y": 0.2484499,
    "CMYK_K": 0.0322711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02412",
    "Farbtonhilfsbezeichnung": "E8.49.73",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "182",
    "Bcolor": "82",
    "Y": 56,
    "L": 79.4852421842589,
    "a": 18.5243113275032,
    "b": 59.5051536717736,
    "C": 62.3218534998732,
    "h": 1.26899960075824,
    "CMY_C": 0,
    "CMY_M": 0.2862008,
    "CMY_Y": 0.6781259,
    "CMYK_C": 0,
    "CMYK_M": 0.2862008,
    "CMYK_Y": 0.6781259,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02413",
    "Farbtonhilfsbezeichnung": "E6.58.65",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "159",
    "Bcolor": "55",
    "Y": 44,
    "L": 72.4041909279898,
    "a": 23.2443456274967,
    "b": 63.3759047811918,
    "C": 67.5041103228923,
    "h": 1.21926093501335,
    "CMY_C": 0.04686543,
    "CMY_M": 0.3750217,
    "CMY_Y": 0.7857458,
    "CMYK_C": 0,
    "CMYK_M": 0.3442917,
    "CMYK_Y": 0.775211,
    "CMYK_K": 0.04686543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02414",
    "Farbtonhilfsbezeichnung": "FN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "228",
    "Bcolor": "221",
    "Y": 78,
    "L": 90.8306121826172,
    "a": 0.64831233024597,
    "b": 3.19574093818665,
    "C": 3.26083874702454,
    "h": 78.5321731567383,
    "CMY_C": 0.08728003501892,
    "CMY_M": 0.10496068000793,
    "CMY_Y": 0.13352209329605,
    "CMYK_C": 0,
    "CMYK_M": 0.01937137916684,
    "CMYK_Y": 0.05066401511431,
    "CMYK_K": 0.08728003501892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02415",
    "Farbtonhilfsbezeichnung": "F0.17.80",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "214",
    "Bcolor": "173",
    "Y": 70,
    "L": 87.1082788630069,
    "a": 5.25454487712562,
    "b": 23.1644052133195,
    "C": 23.7528926817891,
    "h": 1.3477340623776,
    "CMY_C": 0.04138782,
    "CMY_M": 0.1623936,
    "CMY_Y": 0.3206685,
    "CMYK_C": 0,
    "CMYK_M": 0.1262302,
    "CMYK_Y": 0.2913385,
    "CMYK_K": 0.04138782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02417",
    "Farbtonhilfsbezeichnung": "F2.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "136",
    "Bcolor": "76",
    "Y": 25,
    "L": 59.0325889587402,
    "a": 7.98636960983276,
    "b": 36.8962669372559,
    "C": 37.7507171630859,
    "h": 77.7864761352539,
    "CMY_C": 0.31585788726807,
    "CMY_M": 0.46829736232758,
    "CMY_Y": 0.70196604728699,
    "CMYK_C": 0,
    "CMYK_M": 0.22281843423843,
    "CMYK_Y": 0.56436836719513,
    "CMYK_K": 0.31585788726807
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02418",
    "Farbtonhilfsbezeichnung": "F6.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "128",
    "Bcolor": "44",
    "Y": 24,
    "L": 55.9616007344681,
    "a": 6.96995781584137,
    "b": 48.7395868205682,
    "C": 49.2354306916708,
    "h": 1.42875531610167,
    "CMY_C": 0.3435183,
    "CMY_M": 0.4981646,
    "CMY_Y": 0.8267134,
    "CMYK_C": 0,
    "CMYK_M": 0.2355683,
    "CMYK_Y": 0.7360374,
    "CMYK_K": 0.3435183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02419",
    "Farbtonhilfsbezeichnung": "G7.18.87",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "237",
    "Bcolor": "183",
    "Y": 83,
    "L": 93.2201145446866,
    "a": -5.20511559054743,
    "b": 26.2697369574873,
    "C": 26.7804463765363,
    "h": -1.37518877096897,
    "CMY_C": 0.0393637,
    "CMY_M": 0.07017531,
    "CMY_Y": 0.2809676,
    "CMYK_C": 0,
    "CMYK_M": 0.03207417,
    "CMYK_Y": 0.251504,
    "CMYK_K": 0.0393637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02420",
    "Farbtonhilfsbezeichnung": "G5.24.85",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "235",
    "Bcolor": "168",
    "Y": 81,
    "L": 92.8859634399414,
    "a": -4.64542245864868,
    "b": 33.7889442443848,
    "C": 34.1067848205566,
    "h": 97.8281478881836,
    "CMY_C": 0.0218334197998,
    "CMY_M": 0.07670587301254,
    "CMY_Y": 0.34166985750198,
    "CMYK_C": 0,
    "CMYK_M": 0.05609724670649,
    "CMYK_Y": 0.32697543501854,
    "CMYK_K": 0.0218334197998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02421",
    "Farbtonhilfsbezeichnung": "G3.34.84",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "228",
    "Bcolor": "135",
    "Y": 78,
    "L": 90.7472251586664,
    "a": -4.12804880996975,
    "b": 47.3918330250094,
    "C": 47.5712794073048,
    "h": -1.48391097797174,
    "CMY_C": 0.01696893,
    "CMY_M": 0.1041968,
    "CMY_Y": 0.4699768,
    "CMYK_C": 0,
    "CMYK_M": 0.08873356,
    "CMYK_Y": 0.4608276,
    "CMYK_K": 0.01696893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02422",
    "Farbtonhilfsbezeichnung": "G4.13.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "235",
    "Bcolor": "198",
    "Y": 81,
    "L": 92.8098449707031,
    "a": -2.36994123458862,
    "b": 18.3317203521729,
    "C": 18.4842796325684,
    "h": 97.3663864135742,
    "CMY_C": 0.04321974515915,
    "CMY_M": 0.07958090305328,
    "CMY_Y": 0.22508072853088,
    "CMYK_C": 0,
    "CMYK_M": 0.03800366818905,
    "CMYK_Y": 0.19007602334023,
    "CMYK_K": 0.04321974515915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02423",
    "Farbtonhilfsbezeichnung": "G3.26.85",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "233",
    "Bcolor": "156",
    "Y": 81,
    "L": 92.400749206543,
    "a": -3.74655199050903,
    "b": 39.1649131774902,
    "C": 39.3437042236328,
    "h": 95.4643402099609,
    "CMY_C": 0.01000392436981,
    "CMY_M": 0.08523285388947,
    "CMY_Y": 0.38801568746567,
    "CMYK_C": 0,
    "CMYK_M": 0.07598911970854,
    "CMYK_Y": 0.38183158636093,
    "CMYK_K": 0.01000392436981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02424",
    "Farbtonhilfsbezeichnung": "G5.36.83",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "227",
    "Bcolor": "127",
    "Y": 76,
    "L": 89.7414415081894,
    "a": -7.34098284284179,
    "b": 49.8212384890523,
    "C": 50.3591683180126,
    "h": -1.42450253863711,
    "CMY_C": 0.04686701,
    "CMY_M": 0.1083544,
    "CMY_Y": 0.5007883,
    "CMYK_C": 0,
    "CMYK_M": 0.06451079,
    "CMYK_Y": 0.4762413,
    "CMYK_K": 0.04686701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02425",
    "Farbtonhilfsbezeichnung": "G2.51.81",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "220",
    "Bcolor": "84",
    "Y": 72,
    "L": 87.7607524985256,
    "a": -4.63628186794979,
    "b": 67.2372964170876,
    "C": 67.3969520010985,
    "h": -1.50195128052579,
    "CMY_C": 0.02778454,
    "CMY_M": 0.1387241,
    "CMY_Y": 0.6717579,
    "CMYK_C": 0,
    "CMYK_M": 0.11411,
    "CMYK_Y": 0.6623772,
    "CMYK_K": 0.02778454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02426",
    "Farbtonhilfsbezeichnung": "G4.34.84",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "231",
    "Bcolor": "138",
    "Y": 79,
    "L": 91.3192479954663,
    "a": -6.21005675728931,
    "b": 46.8576669919405,
    "C": 47.2673858051865,
    "h": -1.43903396582703,
    "CMY_C": 0.02566936,
    "CMY_M": 0.09292726,
    "CMY_Y": 0.460311,
    "CMYK_C": 0,
    "CMYK_M": 0.06902986,
    "CMYK_Y": 0.4460925,
    "CMYK_K": 0.02566936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02427",
    "Farbtonhilfsbezeichnung": "G1.57.79",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "212",
    "Bcolor": "61",
    "Y": 67,
    "L": 85.5155650919159,
    "a": -2.85544693894918,
    "b": 73.4984555781707,
    "C": 73.5539023410552,
    "h": -1.53196542093138,
    "CMY_C": 0.03652982,
    "CMY_M": 0.1681367,
    "CMY_Y": 0.761601,
    "CMYK_C": 0,
    "CMYK_M": 0.1365968,
    "CMYK_Y": 0.7525621,
    "CMYK_K": 0.03652982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02428",
    "Farbtonhilfsbezeichnung": "G0.70.76",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "205",
    "Bcolor": "0",
    "Y": 63,
    "L": 83.2963219586505,
    "a": -1.05066625769717,
    "b": 85.974757814468,
    "C": 85.9811774799664,
    "h": -1.55857629866642,
    "CMY_C": 0.04187488,
    "CMY_M": 0.1975622,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.1624917,
    "CMYK_Y": 1,
    "CMYK_K": 0.04187488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02429",
    "Farbtonhilfsbezeichnung": "GN.00.88",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "243",
    "Bcolor": "238",
    "Y": 87,
    "L": 95.8368225097656,
    "a": -0.09399908781052,
    "b": 1.41814017295837,
    "C": 1.42125201225281,
    "h": 93.7922134399414,
    "CMY_C": 0.0428654551506,
    "CMY_M": 0.04658204317093,
    "CMY_Y": 0.06491321325302,
    "CMYK_C": 0,
    "CMYK_M": 0.00388303608634,
    "CMYK_Y": 0.02303517051041,
    "CMYK_K": 0.0428654551506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02430",
    "Farbtonhilfsbezeichnung": "G0.09.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "206",
    "Y": 80,
    "L": 92.6453475952148,
    "a": -0.32666674256325,
    "b": 13.7134962081909,
    "C": 13.7173862457275,
    "h": 91.3645706176758,
    "CMY_C": 0.04244244098663,
    "CMY_M": 0.08515030145645,
    "CMY_Y": 0.1919818520546,
    "CMYK_C": 0,
    "CMYK_M": 0.04460082948208,
    "CMYK_Y": 0.15616753697395,
    "CMYK_K": 0.04244244098663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02431",
    "Farbtonhilfsbezeichnung": "G1.13.79",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "218",
    "Bcolor": "184",
    "Y": 68,
    "L": 87.1541442871094,
    "a": -0.37344181537628,
    "b": 17.5478687286377,
    "C": 17.5518417358398,
    "h": 91.2191467285156,
    "CMY_C": 0.09433490037918,
    "CMY_M": 0.14696490764618,
    "CMY_Y": 0.27958172559738,
    "CMYK_C": 0,
    "CMYK_M": 0.0581119954586,
    "CMYK_Y": 0.20454230904579,
    "CMYK_K": 0.09433490037918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02432",
    "Farbtonhilfsbezeichnung": "F8.16.48",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "134",
    "Bcolor": "109",
    "Y": 24,
    "L": 56.3967574274288,
    "a": 0.6868292287539,
    "b": 14.5071774262286,
    "C": 14.5234269807627,
    "h": 1.5234875547257,
    "CMY_C": 0.4266052,
    "CMY_M": 0.4742436,
    "CMY_Y": 0.5715877,
    "CMYK_C": 0,
    "CMYK_M": 0.08308124,
    "CMYK_Y": 0.2528493,
    "CMYK_K": 0.4266052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02433",
    "Farbtonhilfsbezeichnung": "G9.13.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "233",
    "Bcolor": "195",
    "Y": 80,
    "L": 91.795295715332,
    "a": -4.80910396575928,
    "b": 18.2886028289795,
    "C": 18.910327911377,
    "h": 104.732765197754,
    "CMY_C": 0.07316666841507,
    "CMY_M": 0.0852370262146,
    "CMY_Y": 0.23611348867416,
    "CMYK_C": 0,
    "CMYK_M": 0.01302322372794,
    "CMYK_Y": 0.17581027746201,
    "CMYK_K": 0.07316666841507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02434",
    "Farbtonhilfsbezeichnung": "G8.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "93",
    "Bcolor": "61",
    "Y": 11,
    "L": 39.1023832958404,
    "a": -4.35284719295251,
    "b": 18.7793376611863,
    "C": 19.2772093851274,
    "h": -1.34302932090572,
    "CMY_C": 0.623242,
    "CMY_M": 0.6338519,
    "CMY_Y": 0.7618016,
    "CMYK_C": 0,
    "CMYK_M": 0.0281612,
    "CMYK_Y": 0.3677683,
    "CMYK_K": 0.623242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02435",
    "Farbtonhilfsbezeichnung": "G4.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "161",
    "Bcolor": "80",
    "Y": 35,
    "L": 66.1054492054405,
    "a": -4.10151769869732,
    "b": 43.38335566609,
    "C": 43.5768057145449,
    "h": -1.47653522381191,
    "CMY_C": 0.3030474,
    "CMY_M": 0.369075,
    "CMY_Y": 0.6868703,
    "CMYK_C": 0,
    "CMYK_M": 0.09473763,
    "CMYK_Y": 0.5507159,
    "CMYK_K": 0.3030474
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02436",
    "Farbtonhilfsbezeichnung": "G4.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "142",
    "Bcolor": "92",
    "Y": 26,
    "L": 59.0090751647949,
    "a": -2.13894176483154,
    "b": 27.7495079040527,
    "C": 27.8318214416504,
    "h": 94.4076614379883,
    "CMY_C": 0.39144384860992,
    "CMY_M": 0.444051861763,
    "CMY_Y": 0.63856160640717,
    "CMYK_C": 0,
    "CMYK_M": 0.08644726127386,
    "CMYK_Y": 0.40607222914696,
    "CMYK_K": 0.39144384860992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02437",
    "Farbtonhilfsbezeichnung": "G4.50.60",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "165",
    "Bcolor": "64",
    "Y": 36,
    "L": 67.3860397338867,
    "a": -5.85005712509155,
    "b": 52.514533996582,
    "C": 52.8393745422363,
    "h": 96.3564758300781,
    "CMY_C": 0.28843867778778,
    "CMY_M": 0.3530125617981,
    "CMY_Y": 0.75060486793518,
    "CMYK_C": 0,
    "CMYK_M": 0.09074956923723,
    "CMYK_Y": 0.64950996637344,
    "CMYK_K": 0.28843867778778
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02438",
    "Farbtonhilfsbezeichnung": "G4.40.50",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "139",
    "Bcolor": "64",
    "Y": 26,
    "L": 57.6450259716187,
    "a": -4.11211532444178,
    "b": 40.710463246701,
    "C": 40.9176161353824,
    "h": -1.47012895559061,
    "CMY_C": 0.3989632,
    "CMY_M": 0.4555662,
    "CMY_Y": 0.7476984,
    "CMYK_C": 0,
    "CMYK_M": 0.09417564,
    "CMYK_Y": 0.5802228,
    "CMYK_K": 0.3989632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02439",
    "Farbtonhilfsbezeichnung": "G8.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "121",
    "Bcolor": "68",
    "Y": 17,
    "L": 50.0372085571289,
    "a": -6.84779024124146,
    "b": 28.8710536956787,
    "C": 29.6720409393311,
    "h": 103.343154907227,
    "CMY_C": 0.51293420791626,
    "CMY_M": 0.52462214231491,
    "CMY_Y": 0.73185527324677,
    "CMYK_C": 0,
    "CMYK_M": 0.02399662323296,
    "CMYK_Y": 0.44946917891502,
    "CMYK_K": 0.51293420791626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02440",
    "Farbtonhilfsbezeichnung": "H1.39.83",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "231",
    "Bcolor": "121",
    "Y": 75,
    "L": 89.1868181641027,
    "a": -16.6551955320479,
    "b": 51.995323756654,
    "C": 54.5977035301854,
    "h": -1.26080220155592,
    "CMY_C": 0.1157551,
    "CMY_M": 0.09446395,
    "CMY_Y": 0.5268782,
    "CMYK_C": 0.02351214,
    "CMYK_M": 0,
    "CMYK_Y": 0.4775229,
    "CMYK_K": 0.09446395
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02441",
    "Farbtonhilfsbezeichnung": "G9.56.76",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "213",
    "Bcolor": "61",
    "Y": 62,
    "L": 82.534825654054,
    "a": -19.2230065050118,
    "b": 69.3033871722233,
    "C": 71.919979509416,
    "h": -1.3002237156114,
    "CMY_C": 0.1855586,
    "CMY_M": 0.1647449,
    "CMY_Y": 0.7588367,
    "CMYK_C": 0.02491895,
    "CMYK_M": 0,
    "CMYK_Y": 0.71127,
    "CMYK_K": 0.1647449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02442",
    "Farbtonhilfsbezeichnung": "G7.57.66",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "185",
    "Bcolor": "54",
    "Y": 46,
    "L": 73.6041144290477,
    "a": -13.4084342142841,
    "b": 62.7975696009733,
    "C": 64.2130894434139,
    "h": -1.36043677221319,
    "CMY_C": 0.2557526,
    "CMY_M": 0.2726034,
    "CMY_Y": 0.7874147,
    "CMYK_C": 0,
    "CMYK_M": 0.02264132,
    "CMYK_Y": 0.7143621,
    "CMYK_K": 0.2557526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02443",
    "Farbtonhilfsbezeichnung": "G9.27.84",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "232",
    "Bcolor": "156",
    "Y": 78,
    "L": 90.8948610062996,
    "a": -9.43663851174692,
    "b": 37.1052643253985,
    "C": 38.2864308477439,
    "h": -1.32175523142189,
    "CMY_C": 0.07230574,
    "CMY_M": 0.08869617,
    "CMY_Y": 0.3891474,
    "CMYK_C": 0,
    "CMYK_M": 0.01766792,
    "CMYK_Y": 0.3415367,
    "CMYK_K": 0.07230574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02444",
    "Farbtonhilfsbezeichnung": "G9.35.84",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "232",
    "Bcolor": "134",
    "Y": 77,
    "L": 90.4113954592811,
    "a": -12.3424983680322,
    "b": 47.1759835697409,
    "C": 48.7638256470649,
    "h": -1.31490514568393,
    "CMY_C": 0.07908422,
    "CMY_M": 0.08935527,
    "CMY_Y": 0.4738828,
    "CMYK_C": 0,
    "CMYK_M": 0.01115308,
    "CMYK_Y": 0.4287021,
    "CMYK_K": 0.07908422
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02445",
    "Farbtonhilfsbezeichnung": "H3.24.78",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "218",
    "Bcolor": "154",
    "Y": 67,
    "L": 85.4147017536564,
    "a": -10.9112434923546,
    "b": 30.5313692556832,
    "C": 32.422519075117,
    "h": -1.22756374825069,
    "CMY_C": 0.1594184,
    "CMY_M": 0.1450839,
    "CMY_Y": 0.3965627,
    "CMYK_C": 0.01676712,
    "CMYK_M": 0,
    "CMYK_Y": 0.2941562,
    "CMYK_K": 0.1450839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02446",
    "Farbtonhilfsbezeichnung": "H2.35.30",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "89",
    "Bcolor": "49",
    "Y": 10,
    "L": 37.126261321623,
    "a": -6.48359203557505,
    "b": 22.8131302267954,
    "C": 23.7165738762684,
    "h": -1.29389315400967,
    "CMY_C": 0.6485521,
    "CMY_M": 0.6490676,
    "CMY_Y": 0.8062337,
    "CMYK_C": 0,
    "CMYK_M": 0.001466807,
    "CMYK_Y": 0.4486628,
    "CMYK_K": 0.6485521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02447",
    "Farbtonhilfsbezeichnung": "H4.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "237",
    "Bcolor": "217",
    "Y": 81,
    "L": 93.0776290893555,
    "a": -3.35579991340637,
    "b": 8.33998489379883,
    "C": 8.98981285095215,
    "h": 111.918609619141,
    "CMY_C": 0.0768911242485,
    "CMY_M": 0.07179123163223,
    "CMY_Y": 0.14764052629471,
    "CMYK_C": 0.00549433799461,
    "CMYK_M": 0,
    "CMYK_Y": 0.08171577006578,
    "CMYK_K": 0.07179123163223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02448",
    "Farbtonhilfsbezeichnung": "H3.12.78",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "216",
    "Bcolor": "183",
    "Y": 66,
    "L": 85.4635467529297,
    "a": -6.23269844055176,
    "b": 15.4717292785645,
    "C": 16.6799564361572,
    "h": 111.941757202148,
    "CMY_C": 0.16239726543427,
    "CMY_M": 0.15166169404984,
    "CMY_Y": 0.28322803974152,
    "CMYK_C": 0.01265482325107,
    "CMYK_M": 0,
    "CMYK_Y": 0.15508712828159,
    "CMYK_K": 0.15166169404984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02449",
    "Farbtonhilfsbezeichnung": "H2.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "192",
    "Bcolor": "165",
    "Y": 52,
    "L": 77.0145664788722,
    "a": -4.49315030013059,
    "b": 12.6717002100727,
    "C": 13.4447159075051,
    "h": -1.23004584951836,
    "CMY_C": 0.2494659,
    "CMY_M": 0.2470548,
    "CMY_Y": 0.3516324,
    "CMYK_C": 0.003202284,
    "CMYK_M": 0,
    "CMYK_Y": 0.1388913,
    "CMYK_K": 0.2470548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02450",
    "Farbtonhilfsbezeichnung": "J0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "128",
    "Bcolor": "118",
    "Y": 21,
    "L": 53.0507699762368,
    "a": -2.26726785649528,
    "b": 4.45104230294118,
    "C": 4.99522583229914,
    "h": -1.09967363316341,
    "CMY_C": 0.5060759,
    "CMY_M": 0.4993418,
    "CMY_Y": 0.5371541,
    "CMYK_C": 0.01345049,
    "CMYK_M": 0,
    "CMYK_Y": 0.07552514,
    "CMYK_K": 0.4993418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02451",
    "Farbtonhilfsbezeichnung": "J0.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "108",
    "Bcolor": "101",
    "Y": 14,
    "L": 45.1715888977051,
    "a": -1.9690181016922,
    "b": 2.97750043869019,
    "C": 3.56966972351074,
    "h": 123.476623535156,
    "CMY_C": 0.58568626642227,
    "CMY_M": 0.57727372646332,
    "CMY_Y": 0.60369729995728,
    "CMYK_C": 0.01990067958832,
    "CMYK_M": 0,
    "CMYK_Y": 0.0625075250864,
    "CMYK_K": 0.57727372646332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02452",
    "Farbtonhilfsbezeichnung": "J0.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "81",
    "Bcolor": "75",
    "Y": 8,
    "L": 34.3408463743399,
    "a": -1.65946129923805,
    "b": 3.01766131713961,
    "C": 3.44384837480247,
    "h": -1.06801734022949,
    "CMY_C": 0.6858648,
    "CMY_M": 0.6806136,
    "CMY_Y": 0.7047525,
    "CMYK_C": 0.01644167,
    "CMYK_M": 0,
    "CMYK_Y": 0.07557923,
    "CMYK_K": 0.6806136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02454",
    "Farbtonhilfsbezeichnung": "L1.09.78",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "219",
    "Bcolor": "198",
    "Y": 66,
    "L": 85.1163377613199,
    "a": -12.172973253549,
    "b": 6.56749456752106,
    "C": 13.8316037655089,
    "h": -0.49475723248275,
    "CMY_C": 0.2418879,
    "CMY_M": 0.1404064,
    "CMY_Y": 0.2224269,
    "CMYK_C": 0.1180576,
    "CMYK_M": 0,
    "CMYK_Y": 0.09541781,
    "CMYK_K": 0.1404064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02455",
    "Farbtonhilfsbezeichnung": "J0.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "95",
    "Bcolor": "61",
    "Y": 11,
    "L": 38.9459709928318,
    "a": -9.36817839870982,
    "b": 18.1683846314568,
    "C": 20.4414521653088,
    "h": -1.09472242784772,
    "CMY_C": 0.6577948,
    "CMY_M": 0.6260323,
    "CMY_Y": 0.7600919,
    "CMYK_C": 0.08493393,
    "CMYK_M": 0,
    "CMYK_Y": 0.3584791,
    "CMYK_K": 0.6260323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02456",
    "Farbtonhilfsbezeichnung": "H7.22.83",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "238",
    "Bcolor": "174",
    "Y": 76,
    "L": 91.9076919555664,
    "a": -14.3158912658691,
    "b": 28.9277763366699,
    "C": 32.2763214111328,
    "h": 116.330078125,
    "CMY_C": 0.11656999588013,
    "CMY_M": 0.06507742404938,
    "CMY_Y": 0.31682246923447,
    "CMYK_C": 0.05507683008909,
    "CMYK_M": 0,
    "CMYK_Y": 0.2692683339119,
    "CMYK_K": 0.06507742404938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02457",
    "Farbtonhilfsbezeichnung": "H7.38.79",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "226",
    "Bcolor": "122",
    "Y": 68,
    "L": 86.0703327260271,
    "a": -23.3329983787712,
    "b": 47.2114012681764,
    "C": 52.6625599743167,
    "h": -1.11178034193825,
    "CMY_C": 0.2097568,
    "CMY_M": 0.1148569,
    "CMY_Y": 0.5219234,
    "CMYK_C": 0.1072142,
    "CMYK_M": 0,
    "CMYK_Y": 0.4598879,
    "CMYK_K": 0.1148569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02458",
    "Farbtonhilfsbezeichnung": "J8.41.70",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "208",
    "Bcolor": "119",
    "Y": 52,
    "L": 77.512292626255,
    "a": -35.264209002986,
    "b": 37.2518940112221,
    "C": 51.2958872038452,
    "h": -0.8128015586799,
    "CMY_C": 0.4248995,
    "CMY_M": 0.1861204,
    "CMY_Y": 0.5335322,
    "CMYK_C": 0.2933838,
    "CMYK_M": 0,
    "CMYK_Y": 0.4268589,
    "CMYK_K": 0.1861204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02459",
    "Farbtonhilfsbezeichnung": "J8.48.64",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "193",
    "Bcolor": "97",
    "Y": 43,
    "L": 71.8819973838438,
    "a": -38.5663843975806,
    "b": 41.0754027918999,
    "C": 56.3431869884795,
    "h": -0.81689154041808,
    "CMY_C": 0.50489,
    "CMY_M": 0.2428619,
    "CMY_Y": 0.6205223,
    "CMYK_C": 0.3460769,
    "CMYK_M": 0,
    "CMYK_Y": 0.4987998,
    "CMYK_K": 0.2428619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02460",
    "Farbtonhilfsbezeichnung": "K0.26.76",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "220",
    "Bcolor": "159",
    "Y": 63,
    "L": 83.1933817028548,
    "a": -25.3766669831159,
    "b": 24.5201992545437,
    "C": 35.2876097044626,
    "h": -0.76823508894795,
    "CMY_C": 0.314599,
    "CMY_M": 0.1390683,
    "CMY_Y": 0.3772694,
    "CMYK_C": 0.2038845,
    "CMYK_M": 0,
    "CMYK_Y": 0.2766783,
    "CMYK_K": 0.1390683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02461",
    "Farbtonhilfsbezeichnung": "K6.50.30",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "102",
    "Bcolor": "55",
    "Y": 10,
    "L": 38.4683371819348,
    "a": -28.6654712677083,
    "b": 20.5650696684633,
    "C": 35.2793329510148,
    "h": -0.62231922005097,
    "CMY_C": 0.8113205,
    "CMY_M": 0.6011754,
    "CMY_Y": 0.7833838,
    "CMYK_C": 0.5269111,
    "CMYK_M": 0,
    "CMYK_Y": 0.4568635,
    "CMYK_K": 0.6011754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02463",
    "Farbtonhilfsbezeichnung": "K6.34.67",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "200",
    "Bcolor": "136",
    "Y": 48,
    "L": 74.8335703228146,
    "a": -34.8651170942393,
    "b": 24.8902707291443,
    "C": 42.8380901414281,
    "h": -0.61999524299393,
    "CMY_C": 0.4891355,
    "CMY_M": 0.2142617,
    "CMY_Y": 0.4676423,
    "CMYK_C": 0.3498287,
    "CMYK_M": 0,
    "CMYK_Y": 0.3224746,
    "CMYK_K": 0.2142617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02464",
    "Farbtonhilfsbezeichnung": "K5.44.64",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "194",
    "Bcolor": "114",
    "Y": 43,
    "L": 71.4539808765037,
    "a": -43.2452614146728,
    "b": 31.5691949211955,
    "C": 53.5421955358185,
    "h": -0.63058008164827,
    "CMY_C": 0.5880073,
    "CMY_M": 0.2388109,
    "CMY_Y": 0.5526717,
    "CMYK_C": 0.4587511,
    "CMYK_M": 0,
    "CMYK_Y": 0.4123297,
    "CMYK_K": 0.2388109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02465",
    "Farbtonhilfsbezeichnung": "K7.48.56",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "176",
    "Bcolor": "101",
    "Y": 32,
    "L": 64.6553344726563,
    "a": -44.7388343811035,
    "b": 29.2210159301758,
    "C": 53.4362335205078,
    "h": 146.849578857422,
    "CMY_C": 0.69089949131012,
    "CMY_M": 0.31015992164612,
    "CMY_Y": 0.60260498523712,
    "CMYK_C": 0.55192440748215,
    "CMYK_M": 0,
    "CMYK_Y": 0.4239316880703,
    "CMYK_K": 0.31015992164612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02466",
    "Farbtonhilfsbezeichnung": "J9.19.80",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "228",
    "Bcolor": "180",
    "Y": 71,
    "L": 87.3842426661069,
    "a": -18.7332691662226,
    "b": 19.4097616676487,
    "C": 26.9754373764184,
    "h": -0.80313198183877,
    "CMY_C": 0.2289761,
    "CMY_M": 0.1045203,
    "CMY_Y": 0.2939796,
    "CMYK_C": 0.1389822,
    "CMYK_M": 0,
    "CMYK_Y": 0.2115729,
    "CMYK_K": 0.1045203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02467",
    "Farbtonhilfsbezeichnung": "K0.28.76",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "220",
    "Bcolor": "154",
    "Y": 62,
    "L": 83.1381422089395,
    "a": -27.2962982590206,
    "b": 26.8226456446753,
    "C": 38.2693378310264,
    "h": -0.77664632001293,
    "CMY_C": 0.3246799,
    "CMY_M": 0.1364744,
    "CMY_Y": 0.3953795,
    "CMYK_C": 0.2179501,
    "CMYK_M": 0,
    "CMYK_Y": 0.2998233,
    "CMYK_K": 0.1364744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02468",
    "Farbtonhilfsbezeichnung": "K2.45.20",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "79",
    "Bcolor": "51",
    "Y": 7,
    "L": 30.8093158223161,
    "a": -17.2564407997055,
    "b": 13.3338457828158,
    "C": 21.8077094724241,
    "h": -0.65786405305653,
    "CMY_C": 0.8005624,
    "CMY_M": 0.689015,
    "CMY_Y": 0.8016149,
    "CMYK_C": 0.3586907,
    "CMYK_M": 0,
    "CMYK_Y": 0.3620751,
    "CMYK_K": 0.689015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02469",
    "Farbtonhilfsbezeichnung": "J9.18.81",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "230",
    "Bcolor": "185",
    "Y": 72,
    "L": 88.1355843895732,
    "a": -17.8563084485384,
    "b": 18.1099984168781,
    "C": 25.4326521241626,
    "h": -0.79245159154557,
    "CMY_C": 0.2175786,
    "CMY_M": 0.09764776,
    "CMY_Y": 0.2761517,
    "CMYK_C": 0.1329091,
    "CMYK_M": 0,
    "CMYK_Y": 0.1978207,
    "CMYK_K": 0.09764776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02471",
    "Farbtonhilfsbezeichnung": "L0.20.15",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "63",
    "Bcolor": "54",
    "Y": 4,
    "L": 25.0528753406776,
    "a": -8.40871986828112,
    "b": 3.36990417714016,
    "C": 9.05885334831801,
    "h": -0.38116400121099,
    "CMY_C": 0.8134898,
    "CMY_M": 0.753048,
    "CMY_Y": 0.7896842,
    "CMYK_C": 0.2447512,
    "CMYK_M": 0,
    "CMYK_Y": 0.1483535,
    "CMYK_K": 0.753048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02472",
    "Farbtonhilfsbezeichnung": "L0.35.20",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "75",
    "Bcolor": "57",
    "Y": 7,
    "L": 29.3812318727653,
    "a": -15.2944678195365,
    "b": 7.3064858628101,
    "C": 16.9500879509896,
    "h": -0.44566594753238,
    "CMY_C": 0.816536,
    "CMY_M": 0.7041159,
    "CMY_Y": 0.7765986,
    "CMYK_C": 0.3799464,
    "CMYK_M": 0,
    "CMYK_Y": 0.2449697,
    "CMYK_K": 0.7041159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02473",
    "Farbtonhilfsbezeichnung": "LN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "237",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.7340314048515,
    "a": -4.33632596621869,
    "b": 2.13238670252014,
    "C": 4.83226612826603,
    "h": -0.45702555815067,
    "CMY_C": 0.1093438,
    "CMY_M": 0.07172379,
    "CMY_Y": 0.1053283,
    "CMYK_C": 0.04052677,
    "CMYK_M": 0,
    "CMYK_Y": 0.03620094,
    "CMYK_K": 0.07172379
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02474",
    "Farbtonhilfsbezeichnung": "N8.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "231",
    "Bcolor": "227",
    "Y": 73,
    "L": 89.0958404541016,
    "a": -12.1242389678955,
    "b": -2.64105987548828,
    "C": 12.4085597991943,
    "h": 192.288940429688,
    "CMY_C": 0.23412376642227,
    "CMY_M": 0.09376281499863,
    "CMY_Y": 0.11121892929077,
    "CMYK_C": 0.15488323569298,
    "CMYK_M": 0,
    "CMYK_Y": 0.01926219090819,
    "CMYK_K": 0.09376281499863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02475",
    "Farbtonhilfsbezeichnung": "T3.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "215",
    "Bcolor": "224",
    "Y": 67,
    "L": 85.2531201658694,
    "a": -1.7214577633029,
    "b": -7.04662775651406,
    "C": 7.2538527397315,
    "h": 1.3311939951454,
    "CMY_C": 0.2044913,
    "CMY_M": 0.1582249,
    "CMY_Y": 0.1200015,
    "CMYK_C": 0.09601123,
    "CMYK_M": 0.04343568,
    "CMYK_Y": 0,
    "CMYK_K": 0.1200015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02476",
    "Farbtonhilfsbezeichnung": "N7.04.73",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "205",
    "Bcolor": "201",
    "Y": 58,
    "L": 81.0931854248047,
    "a": -6.10518264770508,
    "b": -0.79876363277435,
    "C": 6.15721368789673,
    "h": 187.453872680664,
    "CMY_C": 0.26180809736252,
    "CMY_M": 0.19577831029892,
    "CMY_Y": 0.21141046285629,
    "CMYK_C": 0.08210396021605,
    "CMYK_M": 0,
    "CMYK_Y": 0.01943761669099,
    "CMYK_K": 0.19577831029892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02477",
    "Farbtonhilfsbezeichnung": "N1.06.88",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "190",
    "Bcolor": "184",
    "Y": 49,
    "L": 75.2905885077457,
    "a": -7.20537459073905,
    "b": -0.24754301643421,
    "C": 7.20962554768647,
    "h": 0.03434182241215,
    "CMY_C": 0.3306947,
    "CMY_M": 0.2564845,
    "CMY_Y": 0.2777266,
    "CMYK_C": 0.09980992,
    "CMYK_M": 0,
    "CMYK_Y": 0.02856979,
    "CMYK_K": 0.2564845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02478",
    "Farbtonhilfsbezeichnung": "N6.08.70",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "199",
    "Bcolor": "194",
    "Y": 52,
    "L": 78.045166015625,
    "a": -9.81021499633789,
    "b": -1.3370349407196,
    "C": 9.90090847015381,
    "h": 187.761032104492,
    "CMY_C": 0.32745409011841,
    "CMY_M": 0.22085720300674,
    "CMY_Y": 0.24083250761032,
    "CMYK_C": 0.13681302964687,
    "CMYK_M": 0,
    "CMYK_Y": 0.02563753910363,
    "CMYK_K": 0.22085720300674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02479",
    "Farbtonhilfsbezeichnung": "ON.00.78",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "213",
    "Bcolor": "211",
    "Y": 66,
    "L": 85.3186492919922,
    "a": -0.12151286005974,
    "b": 0.2965529859066,
    "C": 0.32048252224922,
    "h": 112.281410217285,
    "CMY_C": 0.16403359174728,
    "CMY_M": 0.16334247589111,
    "CMY_Y": 0.17269510030746,
    "CMYK_C": 0.00082604389172,
    "CMYK_M": 0,
    "CMYK_Y": 0.01117855776101,
    "CMYK_K": 0.16334247589111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02480",
    "Farbtonhilfsbezeichnung": "ON.01.26",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "90",
    "Bcolor": "91",
    "Y": 10,
    "L": 38.3182144165039,
    "a": 0.07576272636652,
    "b": -1.04951548576355,
    "C": 1.05224657058716,
    "h": 274.128936767578,
    "CMY_C": 0.648901283741,
    "CMY_M": 0.64594334363937,
    "CMY_Y": 0.64268052577972,
    "CMYK_C": 0.01740951277316,
    "CMYK_M": 0.00913137383759,
    "CMYK_Y": 0,
    "CMYK_K": 0.64268052577972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02481",
    "Farbtonhilfsbezeichnung": "ON.00.15",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "59",
    "Bcolor": "60",
    "Y": 4,
    "L": 25.1926973016647,
    "a": 0.66896129698748,
    "b": -0.39657448651423,
    "C": 0.77767637242056,
    "h": -0.53512430225341,
    "CMY_C": 0.7626809,
    "CMY_M": 0.7667668,
    "CMY_Y": 0.7654682,
    "CMYK_C": 0,
    "CMYK_M": 0.01721717,
    "CMYK_Y": 0.01174475,
    "CMYK_K": 0.7626809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02482",
    "Farbtonhilfsbezeichnung": "P0.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "229",
    "Bcolor": "225",
    "Y": 75,
    "L": 89.4583891099997,
    "a": -6.33787406659603,
    "b": -1.27540136646511,
    "C": 6.4649281766785,
    "h": 0.19858266794527,
    "CMY_C": 0.1745879,
    "CMY_M": 0.1028347,
    "CMY_Y": 0.1165516,
    "CMYK_C": 0.07997771,
    "CMYK_M": 0,
    "CMYK_Y": 0.01528918,
    "CMYK_K": 0.1028347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02483",
    "Farbtonhilfsbezeichnung": "P0.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "206",
    "Bcolor": "204",
    "Y": 59,
    "L": 81.2290769792314,
    "a": -7.7864752706488,
    "b": -2.16359566818087,
    "C": 8.08148150748341,
    "h": 0.27102862356017,
    "CMY_C": 0.2795668,
    "CMY_M": 0.1902651,
    "CMY_Y": 0.2002792,
    "CMYK_C": 0.1102851,
    "CMYK_M": 0,
    "CMYK_Y": 0.01236706,
    "CMYK_K": 0.1902651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02484",
    "Farbtonhilfsbezeichnung": "P1.09.69",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "194",
    "Bcolor": "192",
    "Y": 50,
    "L": 76.231200692872,
    "a": -10.2636507717634,
    "b": -3.33332486548017,
    "C": 10.7913660777284,
    "h": 0.31402377013485,
    "CMY_C": 0.3586798,
    "CMY_M": 0.2390376,
    "CMY_Y": 0.246042,
    "CMYK_C": 0.1572249,
    "CMYK_M": 0,
    "CMYK_Y": 0.009204666,
    "CMYK_K": 0.2390376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02485",
    "Farbtonhilfsbezeichnung": "P1.11.63",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "179",
    "Bcolor": "177",
    "Y": 41,
    "L": 70.4418639841573,
    "a": -11.6369309978209,
    "b": -3.73445253305102,
    "C": 12.2214687648276,
    "h": 0.31053170451267,
    "CMY_C": 0.4329964,
    "CMY_M": 0.2982857,
    "CMY_Y": 0.3049538,
    "CMYK_C": 0.1919737,
    "CMYK_M": 0,
    "CMYK_Y": 0.009502599,
    "CMYK_K": 0.2982857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02486",
    "Farbtonhilfsbezeichnung": "P1.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "218",
    "Bcolor": "216",
    "Y": 68,
    "L": 86.1826815624811,
    "a": -4.04896458651099,
    "b": -1.07742546757306,
    "C": 4.18986394301714,
    "h": 0.26007234687375,
    "CMY_C": 0.1908072,
    "CMY_M": 0.1444111,
    "CMY_Y": 0.1537309,
    "CMYK_C": 0.05422702,
    "CMYK_M": 0,
    "CMYK_Y": 0.01089281,
    "CMYK_K": 0.1444111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02490",
    "Farbtonhilfsbezeichnung": "Q0.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "225",
    "Bcolor": "227",
    "Y": 71,
    "L": 87.4565368324471,
    "a": -9.2920551102465,
    "b": -5.19508973431493,
    "C": 10.6457148900129,
    "h": 0.50979486119137,
    "CMY_C": 0.2376411,
    "CMY_M": 0.1174479,
    "CMY_Y": 0.1101686,
    "CMYK_C": 0.1432547,
    "CMYK_M": 0.008180561,
    "CMYK_Y": 0,
    "CMYK_K": 0.1101686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02491",
    "Farbtonhilfsbezeichnung": "Q0.20.73",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "215",
    "Bcolor": "222",
    "Y": 58,
    "L": 81.7722549438477,
    "a": -20.1285991668701,
    "b": -11.2443237304688,
    "C": 23.0563507080078,
    "h": 209.188781738281,
    "CMY_C": 0.43498826026917,
    "CMY_M": 0.15626829862595,
    "CMY_Y": 0.12993568181992,
    "CMYK_C": 0.35060921311378,
    "CMYK_M": 0.03026513755322,
    "CMYK_Y": 0,
    "CMYK_K": 0.12993568181992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02492",
    "Farbtonhilfsbezeichnung": "Q0.29.65",
    "Farbtonklasse": "02",
    "Rcolor": "86",
    "Gcolor": "193",
    "Bcolor": "205",
    "Y": 45,
    "L": 72.4658813476563,
    "a": -26.5459709167481,
    "b": -16.4801788330078,
    "C": 31.2455577850342,
    "h": 211.83268737793,
    "CMY_C": 0.66309428215027,
    "CMY_M": 0.24474197626114,
    "CMY_Y": 0.19473278522491,
    "CMYK_C": 0.58162248134613,
    "CMYK_M": 0.06210260465741,
    "CMYK_Y": 0,
    "CMYK_K": 0.19473278522491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02493",
    "Farbtonhilfsbezeichnung": "Q7.15.76",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "220",
    "Bcolor": "230",
    "Y": 63,
    "L": 84.7559051513672,
    "a": -12.8614597320557,
    "b": -11.0484075546265,
    "C": 16.9553661346436,
    "h": 220.663635253906,
    "CMY_C": 0.32694041728973,
    "CMY_M": 0.13802230358124,
    "CMY_Y": 0.0975843667984,
    "CMYK_C": 0.25415790081024,
    "CMYK_M": 0.04481076821685,
    "CMYK_Y": 0,
    "CMYK_K": 0.0975843667984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02494",
    "Farbtonhilfsbezeichnung": "Q5.10.76",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "215",
    "Bcolor": "220",
    "Y": 63,
    "L": 83.7586288452148,
    "a": -9.757568359375,
    "b": -7.32951402664185,
    "C": 12.2037668228149,
    "h": 216.912475585938,
    "CMY_C": 0.29110926389694,
    "CMY_M": 0.15673565864563,
    "CMY_Y": 0.1353839635849,
    "CMYK_C": 0.18010920286179,
    "CMYK_M": 0.02469500154257,
    "CMYK_Y": 0,
    "CMYK_K": 0.1353839635849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02495",
    "Farbtonhilfsbezeichnung": "Q6.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "229",
    "Bcolor": "233",
    "Y": 72,
    "L": 89.0205535888672,
    "a": -8.57896900177002,
    "b": -5.99204063415527,
    "C": 10.4643802642822,
    "h": 214.932647705078,
    "CMY_C": 0.2176610827446,
    "CMY_M": 0.10134041309357,
    "CMY_Y": 0.08687269687653,
    "CMYK_C": 0.14323127269745,
    "CMYK_M": 0.01584414020181,
    "CMYK_Y": 0,
    "CMYK_K": 0.08687269687653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02496",
    "Farbtonhilfsbezeichnung": "Q6.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "227",
    "Bcolor": "233",
    "Y": 70,
    "L": 88.1356506347656,
    "a": -9.79105377197266,
    "b": -7.33768320083618,
    "C": 12.2354536056519,
    "h": 216.848892211914,
    "CMY_C": 0.24400645494461,
    "CMY_M": 0.10815322399139,
    "CMY_Y": 0.08693474531174,
    "CMYK_C": 0.17202681303024,
    "CMYK_M": 0.02323873154819,
    "CMYK_Y": 0,
    "CMYK_K": 0.08693474531174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02497",
    "Farbtonhilfsbezeichnung": "R0.13.77",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "217",
    "Bcolor": "226",
    "Y": 64,
    "L": 84.1958566439568,
    "a": -9.91300919583016,
    "b": -9.55945426111531,
    "C": 13.7713803624389,
    "h": 0.7672434963369,
    "CMY_C": 0.297988,
    "CMY_M": 0.1509275,
    "CMY_Y": 0.1143217,
    "CMYK_C": 0.2073736,
    "CMYK_M": 0.04133086,
    "CMYK_Y": 0,
    "CMYK_K": 0.1143217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02498",
    "Farbtonhilfsbezeichnung": "R2.20.73",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "208",
    "Bcolor": "225",
    "Y": 57,
    "L": 80.3721812743354,
    "a": -13.860763551254,
    "b": -15.1593295124567,
    "C": 20.5408382859856,
    "h": 0.83011546631419,
    "CMY_C": 0.4063933,
    "CMY_M": 0.1830067,
    "CMY_Y": 0.1163189,
    "CMYK_C": 0.3282568,
    "CMYK_M": 0.07546587,
    "CMYK_Y": 0,
    "CMYK_K": 0.1163189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02499",
    "Farbtonhilfsbezeichnung": "R1.23.72",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "209",
    "Bcolor": "228",
    "Y": 55,
    "L": 79.9904403686523,
    "a": -16.5481605529785,
    "b": -17.4852485656738,
    "C": 24.0743751525879,
    "h": 226.577194213867,
    "CMY_C": 0.45360386371613,
    "CMY_M": 0.18103313446045,
    "CMY_Y": 0.10398483276367,
    "CMYK_C": 0.39019319415092,
    "CMYK_M": 0.0859899520874,
    "CMYK_Y": 0,
    "CMYK_K": 0.10398483276367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02500",
    "Farbtonhilfsbezeichnung": "R2.22.66",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "189",
    "Bcolor": "207",
    "Y": 45,
    "L": 73.206118618937,
    "a": -14.5114381208755,
    "b": -16.2936713031491,
    "C": 21.8189266663386,
    "h": 0.84318885767024,
    "CMY_C": 0.4970754,
    "CMY_M": 0.2592431,
    "CMY_Y": 0.1868469,
    "CMYK_C": 0.381513,
    "CMYK_M": 0.08903144,
    "CMYK_Y": 0,
    "CMYK_K": 0.1868469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02501",
    "Farbtonhilfsbezeichnung": "R6.31.52",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "154",
    "Bcolor": "180",
    "Y": 28,
    "L": 60.2598167774114,
    "a": -14.7884803846754,
    "b": -20.7804423746758,
    "C": 25.5054099628912,
    "h": 0.95229177790171,
    "CMY_C": 0.6726585,
    "CMY_M": 0.3942693,
    "CMY_Y": 0.2946932,
    "CMYK_C": 0.5358878,
    "CMYK_M": 0.1411813,
    "CMYK_Y": 0,
    "CMYK_K": 0.2946932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02502",
    "Farbtonhilfsbezeichnung": "R8.40.39",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "121",
    "Bcolor": "150",
    "Y": 16,
    "L": 47.6560516357422,
    "a": -13.4040508270264,
    "b": -22.9685840606689,
    "C": 26.5936908721924,
    "h": 239.732940673828,
    "CMY_C": 0.82251036167145,
    "CMY_M": 0.5241476893425,
    "CMY_Y": 0.41153782606125,
    "CMYK_C": 0.69838392734528,
    "CMYK_M": 0.19136296212673,
    "CMYK_Y": 0,
    "CMYK_K": 0.41153782606125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02503",
    "Farbtonhilfsbezeichnung": "R2.29.68",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "198",
    "Bcolor": "223",
    "Y": 49,
    "L": 75.5386753767941,
    "a": -18.7684386852975,
    "b": -21.1450071883066,
    "C": 28.2730546577003,
    "h": 0.84487100021574,
    "CMY_C": 0.5561844,
    "CMY_M": 0.2241676,
    "CMY_Y": 0.1270723,
    "CMYK_C": 0.491578,
    "CMYK_M": 0.1112294,
    "CMYK_Y": 0,
    "CMYK_K": 0.1270723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02504",
    "Farbtonhilfsbezeichnung": "R2.33.55",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "164",
    "Bcolor": "189",
    "Y": 32,
    "L": 63.0138230744308,
    "a": -19.211590116893,
    "b": -21.9458688625671,
    "C": 29.1668708460899,
    "h": 0.85173526979822,
    "CMY_C": 0.7165979,
    "CMY_M": 0.3570928,
    "CMY_Y": 0.2576821,
    "CMYK_C": 0.6182201,
    "CMYK_M": 0.1339193,
    "CMYK_Y": 0,
    "CMYK_K": 0.2576821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02505",
    "Farbtonhilfsbezeichnung": "R4.42.47",
    "Farbtonklasse": "03",
    "Rcolor": "28",
    "Gcolor": "144",
    "Bcolor": "175",
    "Y": 23,
    "L": 55.305775274465,
    "a": -19.2455592498698,
    "b": -25.6273965972013,
    "C": 32.0492590739707,
    "h": 0.92667088397789,
    "CMY_C": 0.8912149,
    "CMY_M": 0.4359261,
    "CMY_Y": 0.3144819,
    "CMYK_C": 0.8413097,
    "CMYK_M": 0.1771569,
    "CMYK_Y": 0,
    "CMYK_K": 0.3144819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02506",
    "Farbtonhilfsbezeichnung": "R2.23.66",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "190",
    "Bcolor": "209",
    "Y": 46,
    "L": 73.6756096031922,
    "a": -14.4596995024448,
    "b": -16.7213088486472,
    "C": 22.1062226378196,
    "h": 0.85780300054449,
    "CMY_C": 0.4941495,
    "CMY_M": 0.2541491,
    "CMY_Y": 0.178686,
    "CMYK_C": 0.3840961,
    "CMYK_M": 0.09188098,
    "CMYK_Y": 0,
    "CMYK_K": 0.178686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02507",
    "Farbtonhilfsbezeichnung": "R5.37.56",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "166",
    "Bcolor": "198",
    "Y": 33,
    "L": 63.849871822472,
    "a": -18.7880692141186,
    "b": -25.3713123635651,
    "C": 31.5704772824882,
    "h": 0.93338740453569,
    "CMY_C": 0.7385828,
    "CMY_M": 0.347903,
    "CMY_Y": 0.224887,
    "CMYK_C": 0.6627366,
    "CMYK_M": 0.1587072,
    "CMYK_Y": 0,
    "CMYK_K": 0.224887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02508",
    "Farbtonhilfsbezeichnung": "R5.52.49",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "150",
    "Bcolor": "190",
    "Y": 25,
    "L": 56.6065720449555,
    "a": -23.8262739944337,
    "b": -32.10821556875,
    "C": 39.9828568197314,
    "h": 0.93239517948165,
    "CMY_C": 1,
    "CMY_M": 0.4126118,
    "CMY_Y": 0.2568531,
    "CMYK_C": 1,
    "CMYK_M": 0.2095935,
    "CMYK_Y": 0,
    "CMYK_K": 0.2568531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02509",
    "Farbtonhilfsbezeichnung": "R1.17.73",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "207",
    "Bcolor": "220",
    "Y": 57,
    "L": 80.1920946075251,
    "a": -11.8220428720365,
    "b": -12.3708550214316,
    "C": 17.111363231185,
    "h": 0.80807911881194,
    "CMY_C": 0.3728035,
    "CMY_M": 0.1900472,
    "CMY_Y": 0.1382558,
    "CMYK_C": 0.2721778,
    "CMYK_M": 0.06010067,
    "CMYK_Y": 0,
    "CMYK_K": 0.1382558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02510",
    "Farbtonhilfsbezeichnung": "S1.37.25",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "89",
    "Bcolor": "112",
    "Y": 9,
    "L": 35.2459003940125,
    "a": -9.37169467304269,
    "b": -18.8467595100488,
    "C": 21.0482542049062,
    "h": 1.10934503200664,
    "CMY_C": 0.8587123,
    "CMY_M": 0.6524225,
    "CMY_Y": 0.562,
    "CMYK_C": 0.6774252,
    "CMYK_M": 0.2064443,
    "CMYK_Y": 0,
    "CMYK_K": 0.562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02511",
    "Farbtonhilfsbezeichnung": "S3.56.42",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "135",
    "Bcolor": "187",
    "Y": 19,
    "L": 51.7555618286133,
    "a": -16.690673828125,
    "b": -38.0310668945313,
    "C": 41.5324058532715,
    "h": 246.304794311523,
    "CMY_C": 1,
    "CMY_M": 0.47183680534363,
    "CMY_Y": 0.26821011304855,
    "CMYK_C": 1,
    "CMYK_M": 0.2782584130764,
    "CMYK_Y": 0,
    "CMYK_K": 0.26821011304855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02512",
    "Farbtonhilfsbezeichnung": "S5.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "165",
    "Y": 17,
    "L": 48.4750464106623,
    "a": -18.7726559423345,
    "b": -30.8192688855915,
    "C": 36.0865618447041,
    "h": 1.02369737521696,
    "CMY_C": 1,
    "CMY_M": 0.504221,
    "CMY_Y": 0.3514975,
    "CMYK_C": 1,
    "CMYK_M": 0.2355018,
    "CMYK_Y": 0,
    "CMYK_K": 0.3514975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02513",
    "Farbtonhilfsbezeichnung": "S1.38.56",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "165",
    "Bcolor": "205",
    "Y": 32,
    "L": 63.7177256207793,
    "a": -15.1034442513506,
    "b": -29.8273274064756,
    "C": 33.433269186048,
    "h": 1.10207157110895,
    "CMY_C": 0.7295157,
    "CMY_M": 0.354448,
    "CMY_Y": 0.1950161,
    "CMYK_C": 0.6639879,
    "CMYK_M": 0.1980561,
    "CMYK_Y": 0,
    "CMYK_K": 0.1950161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02514",
    "Farbtonhilfsbezeichnung": "S4.43.49",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "147",
    "Bcolor": "193",
    "Y": 25,
    "L": 57.2314799037087,
    "a": -13.9252403060707,
    "b": -32.7814217499527,
    "C": 35.6164839579946,
    "h": 1.16910304369199,
    "CMY_C": 0.8510585,
    "CMY_M": 0.4228813,
    "CMY_Y": 0.2448201,
    "CMYK_C": 0.8027734,
    "CMYK_M": 0.2357865,
    "CMYK_Y": 0,
    "CMYK_K": 0.2448201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02515",
    "Farbtonhilfsbezeichnung": "S0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "205",
    "Bcolor": "209",
    "Y": 59,
    "L": 81.4489974768109,
    "a": -3.18633196521639,
    "b": -4.28821283631662,
    "C": 5.34242273899309,
    "h": 0.9317617699996,
    "CMY_C": 0.2471758,
    "CMY_M": 0.1974158,
    "CMY_Y": 0.1819344,
    "CMYK_C": 0.07975092,
    "CMYK_M": 0.01892447,
    "CMYK_Y": 0,
    "CMYK_K": 0.1819344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02516",
    "Farbtonhilfsbezeichnung": "SN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "234",
    "Bcolor": "236",
    "Y": 80,
    "L": 92.154899597168,
    "a": -1.21617162227631,
    "b": -2.73096776008606,
    "C": 2.98952484130859,
    "h": 245.995330810547,
    "CMY_C": 0.10786700248718,
    "CMY_M": 0.08405864238739,
    "CMY_Y": 0.0751895904541,
    "CMYK_C": 0.03533417358994,
    "CMYK_M": 0.00959013029933,
    "CMYK_Y": 0,
    "CMYK_K": 0.0751895904541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02518",
    "Farbtonhilfsbezeichnung": "S2.07.80",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "220",
    "Bcolor": "228",
    "Y": 69,
    "L": 86.5241725400931,
    "a": -3.95122482002652,
    "b": -6.83528787245131,
    "C": 7.8951464760113,
    "h": 1.04666340858199,
    "CMY_C": 0.2084394,
    "CMY_M": 0.139172,
    "CMY_Y": 0.1077791,
    "CMYK_C": 0.11282,
    "CMYK_M": 0.03518519,
    "CMYK_Y": 0,
    "CMYK_K": 0.1077791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02519",
    "Farbtonhilfsbezeichnung": "S2.10.71",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "197",
    "Bcolor": "209",
    "Y": 53,
    "L": 78.0110953699142,
    "a": -5.0359738649175,
    "b": -9.76123238331279,
    "C": 10.9837466471676,
    "h": 1.09449731216087,
    "CMY_C": 0.3217932,
    "CMY_M": 0.2290586,
    "CMY_Y": 0.1801576,
    "CMYK_C": 0.1727595,
    "CMYK_M": 0.05964686,
    "CMYK_Y": 0,
    "CMYK_K": 0.1801576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02520",
    "Farbtonhilfsbezeichnung": "S7.19.60",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "168",
    "Bcolor": "193",
    "Y": 37,
    "L": 67.0932032639438,
    "a": -5.88425314106567,
    "b": -17.4467186984842,
    "C": 18.4122901446881,
    "h": 1.24550705268666,
    "CMY_C": 0.48112509999999997,
    "CMY_M": 0.3414009,
    "CMY_Y": 0.2439636,
    "CMYK_C": 0.3136906,
    "CMYK_M": 0.1288791,
    "CMYK_Y": 0,
    "CMYK_K": 0.2439636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02521",
    "Farbtonhilfsbezeichnung": "S6.21.66",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "187",
    "Bcolor": "215",
    "Y": 46,
    "L": 73.8477515684727,
    "a": -7.24301794298937,
    "b": -19.6650194040531,
    "C": 20.9564857999677,
    "h": 1.21789500722392,
    "CMY_C": 0.4352486,
    "CMY_M": 0.2660411,
    "CMY_Y": 0.1551269,
    "CMYK_C": 0.3315547,
    "CMYK_M": 0.1312791,
    "CMYK_Y": 0,
    "CMYK_K": 0.1551269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02522",
    "Farbtonhilfsbezeichnung": "S7.27.61",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "175",
    "Bcolor": "210",
    "Y": 40,
    "L": 69.1590417104927,
    "a": -8.21478882251175,
    "b": -23.6641068223457,
    "C": 25.0494053242358,
    "h": 1.23667049936947,
    "CMY_C": 0.5197694,
    "CMY_M": 0.3126749,
    "CMY_Y": 0.1782267,
    "CMYK_C": 0.4156167,
    "CMYK_M": 0.1636074,
    "CMYK_Y": 0,
    "CMYK_K": 0.1782267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02523",
    "Farbtonhilfsbezeichnung": "S8.34.54",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "157",
    "Bcolor": "199",
    "Y": 30,
    "L": 61.7973808311593,
    "a": -9.48456000675735,
    "b": -29.3887611336461,
    "C": 30.8813237976012,
    "h": 1.25862124047924,
    "CMY_C": 0.6606522,
    "CMY_M": 0.3853307,
    "CMY_Y": 0.2184717,
    "CMYK_C": 0.5657895,
    "CMYK_M": 0.2135035,
    "CMYK_Y": 0,
    "CMYK_K": 0.2184717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02524",
    "Farbtonhilfsbezeichnung": "S8.48.28",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "95",
    "Bcolor": "137",
    "Y": 10,
    "L": 37.4013530606806,
    "a": -10.3634235963233,
    "b": -31.3843897404198,
    "C": 33.051179525327,
    "h": 1.25185985356125,
    "CMY_C": 1,
    "CMY_M": 0.6259035,
    "CMY_Y": 0.4615685,
    "CMYK_C": 1,
    "CMYK_M": 0.3052106,
    "CMYK_Y": 0,
    "CMYK_K": 0.4615685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02525",
    "Farbtonhilfsbezeichnung": "S4.26.64",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "183",
    "Bcolor": "215",
    "Y": 43,
    "L": 71.5221581353783,
    "a": -10.0972563016294,
    "b": -23.2848259794152,
    "C": 25.3798681184998,
    "h": 1.16162946078503,
    "CMY_C": 0.5123239,
    "CMY_M": 0.2838212,
    "CMY_Y": 0.1552084,
    "CMYK_C": 0.4227262,
    "CMYK_M": 0.152242,
    "CMYK_Y": 0,
    "CMYK_K": 0.1552084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02526",
    "Farbtonhilfsbezeichnung": "S3.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "203",
    "Bcolor": "216",
    "Y": 58,
    "L": 80.5792110847532,
    "a": -4.51152918114794,
    "b": -9.61300719947056,
    "C": 10.6190302273523,
    "h": 1.13199658865464,
    "CMY_C": 0.2891504,
    "CMY_M": 0.2023496,
    "CMY_Y": 0.1531031,
    "CMYK_C": 0.1606421,
    "CMYK_M": 0.05814933,
    "CMYK_Y": 0,
    "CMYK_K": 0.1531031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02527",
    "Farbtonhilfsbezeichnung": "S7.17.72",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "202",
    "Bcolor": "225",
    "Y": 56,
    "L": 79.4132411148772,
    "a": -5.9123843988072,
    "b": -16.4517429255347,
    "C": 17.4818801782628,
    "h": 1.22579203482288,
    "CMY_C": 0.3459232,
    "CMY_M": 0.2098031,
    "CMY_Y": 0.1167294,
    "CMYK_C": 0.2594832,
    "CMYK_M": 0.1053739,
    "CMYK_Y": 0,
    "CMYK_K": 0.1167294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02528",
    "Farbtonhilfsbezeichnung": "S6.09.77",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "212",
    "Bcolor": "223",
    "Y": 64,
    "L": 83.8290674068524,
    "a": -3.5156536274028,
    "b": -8.39829904937872,
    "C": 9.10446304570819,
    "h": 1.17434627115929,
    "CMY_C": 0.240463,
    "CMY_M": 0.1693856,
    "CMY_Y": 0.126073,
    "CMYK_C": 0.130892,
    "CMYK_M": 0.04956088,
    "CMYK_Y": 0,
    "CMYK_K": 0.126073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02529",
    "Farbtonhilfsbezeichnung": "S8.12.68",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "189",
    "Bcolor": "206",
    "Y": 49,
    "L": 75.5419452722034,
    "a": -3.64373575307209,
    "b": -11.6821380295662,
    "C": 12.2372038955005,
    "h": 1.26845217175634,
    "CMY_C": 0.3444368,
    "CMY_M": 0.2581653,
    "CMY_Y": 0.1931178,
    "CMYK_C": 0.1875354,
    "CMYK_M": 0.08061586,
    "CMYK_Y": 0,
    "CMYK_K": 0.1931178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02530",
    "Farbtonhilfsbezeichnung": "S8.12.55",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "154",
    "Bcolor": "169",
    "Y": 31,
    "L": 62.549587207059,
    "a": -3.337086100344,
    "b": -10.6627745468767,
    "C": 11.1727751556465,
    "h": 1.26748695662392,
    "CMY_C": 0.4726657,
    "CMY_M": 0.3962916,
    "CMY_Y": 0.3388484,
    "CMYK_C": 0.2024004,
    "CMYK_M": 0.08688359,
    "CMYK_Y": 0,
    "CMYK_K": 0.3388484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02531",
    "Farbtonhilfsbezeichnung": "S8.15.41",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "122",
    "Bcolor": "137",
    "Y": 18,
    "L": 50.0725890929259,
    "a": -3.59180630619627,
    "b": -11.2962469768717,
    "C": 11.8535340006141,
    "h": 1.26294083469083,
    "CMY_C": 0.6023973,
    "CMY_M": 0.5221109,
    "CMY_Y": 0.4628725,
    "CMYK_C": 0.2597612,
    "CMYK_M": 0.1102875,
    "CMYK_Y": 0,
    "CMYK_K": 0.4628725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02532",
    "Farbtonhilfsbezeichnung": "S8.14.17",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "69",
    "Bcolor": "78",
    "Y": 6,
    "L": 28.7840956343354,
    "a": -1.82716616499021,
    "b": -7.10521814151781,
    "C": 7.33639291702938,
    "h": 1.31909182426805,
    "CMY_C": 0.7698816,
    "CMY_M": 0.7285261,
    "CMY_Y": 0.6940753,
    "CMYK_C": 0.247794,
    "CMYK_M": 0.1126118,
    "CMYK_Y": 0,
    "CMYK_K": 0.6940753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02533",
    "Farbtonhilfsbezeichnung": "T0.23.48",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "139",
    "Bcolor": "167",
    "Y": 24,
    "L": 56.0604010631081,
    "a": -5.0783457055229,
    "b": -19.6349265449646,
    "C": 20.2810240256984,
    "h": 1.31770408802082,
    "CMY_C": 0.5993721,
    "CMY_M": 0.4563806,
    "CMY_Y": 0.3458867,
    "CMYK_C": 0.3875253,
    "CMYK_M": 0.1689216,
    "CMYK_Y": 0,
    "CMYK_K": 0.3458867
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02534",
    "Farbtonhilfsbezeichnung": "T4.27.36",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "112",
    "Bcolor": "143",
    "Y": 15,
    "L": 45.9625129699707,
    "a": -3.01285791397095,
    "b": -21.3191604614258,
    "C": 21.5309982299805,
    "h": 261.956146240234,
    "CMY_C": 0.691401720047,
    "CMY_M": 0.56046152114868,
    "CMY_Y": 0.43885177373886,
    "CMYK_C": 0.45005923509598,
    "CMYK_M": 0.21671590209007,
    "CMYK_Y": 0,
    "CMYK_K": 0.43885177373886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02535",
    "Farbtonhilfsbezeichnung": "T0.45.20",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "84",
    "Bcolor": "116",
    "Y": 8,
    "L": 33.3384177995099,
    "a": -7.82330532889866,
    "b": -24.785617448296,
    "C": 25.9909780224302,
    "h": 1.26505436988744,
    "CMY_C": 0.945733,
    "CMY_M": 0.6707817,
    "CMY_Y": 0.5436063,
    "CMYK_C": 0.881096,
    "CMYK_M": 0.2786526,
    "CMYK_Y": 0,
    "CMYK_K": 0.5436063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02536",
    "Farbtonhilfsbezeichnung": "T6.39.52",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "151",
    "Bcolor": "208",
    "Y": 28,
    "L": 60.2733703407191,
    "a": -4.74123646562408,
    "b": -36.905449646315,
    "C": 37.2087561847969,
    "h": 1.44302636595164,
    "CMY_C": 0.6871919,
    "CMY_M": 0.4075281,
    "CMY_Y": 0.1826949,
    "CMYK_C": 0.6172689,
    "CMYK_M": 0.2750909,
    "CMYK_Y": 0,
    "CMYK_K": 0.1826949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02537",
    "Farbtonhilfsbezeichnung": "T4.18.59",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "166",
    "Bcolor": "195",
    "Y": 36,
    "L": 66.8630464820281,
    "a": -2.73774884498285,
    "b": -19.2047474246431,
    "C": 19.398906989378,
    "h": 1.42919456430241,
    "CMY_C": 0.4635597,
    "CMY_M": 0.349871,
    "CMY_Y": 0.233861,
    "CMYK_C": 0.2998134,
    "CMYK_M": 0.1514216,
    "CMYK_Y": 0,
    "CMYK_K": 0.233861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02538",
    "Farbtonhilfsbezeichnung": "T3.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "144",
    "Bcolor": "173",
    "Y": 26,
    "L": 58.4760577549492,
    "a": -3.23326511357658,
    "b": -19.2675546403009,
    "C": 19.5369563932474,
    "h": 1.40453659628258,
    "CMY_C": 0.5550219,
    "CMY_M": 0.4356515,
    "CMY_Y": 0.3228391,
    "CMYK_C": 0.3428769,
    "CMYK_M": 0.1665961,
    "CMYK_Y": 0,
    "CMYK_K": 0.3228391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02539",
    "Farbtonhilfsbezeichnung": "T3.14.55",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "156",
    "Bcolor": "176",
    "Y": 32,
    "L": 63.5773391723633,
    "a": -2.34118175506592,
    "b": -13.2217645645142,
    "C": 13.4274415969849,
    "h": 259.958709716797,
    "CMY_C": 0.46503430604935,
    "CMY_M": 0.3869446516037,
    "CMY_Y": 0.3103398680687,
    "CMYK_C": 0.22430531680584,
    "CMYK_M": 0.11107613891363,
    "CMYK_Y": 0,
    "CMYK_K": 0.3103398680687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02540",
    "Farbtonhilfsbezeichnung": "TN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "225",
    "Bcolor": "227",
    "Y": 75,
    "L": 89.17822265625,
    "a": -1.12720596790314,
    "b": -2.68111491203308,
    "C": 2.90843081474304,
    "h": 247.196929931641,
    "CMY_C": 0.139981508255,
    "CMY_M": 0.11746841669083,
    "CMY_Y": 0.10858714580536,
    "CMYK_C": 0.03521865606308,
    "CMYK_M": 0.00996313989162,
    "CMYK_Y": 0,
    "CMYK_K": 0.10858714580536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02541",
    "Farbtonhilfsbezeichnung": "T8.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "201",
    "Bcolor": "220",
    "Y": 58,
    "L": 80.4845658516399,
    "a": -0.76679636264703,
    "b": -11.7273767696275,
    "C": 11.7524185833627,
    "h": 1.50550411085653,
    "CMY_C": 0.2672967,
    "CMY_M": 0.2111408,
    "CMY_Y": 0.1384339,
    "CMYK_C": 0.1495681,
    "CMYK_M": 0.08438916,
    "CMYK_Y": 0,
    "CMYK_K": 0.1384339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02542",
    "Farbtonhilfsbezeichnung": "V0.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "189",
    "Bcolor": "213",
    "Y": 52,
    "L": 76.9371032714844,
    "a": 3.71591377258301,
    "b": -13.3445281982422,
    "C": 13.8522357940674,
    "h": 285.560363769531,
    "CMY_C": 0.2751846909523,
    "CMY_M": 0.259337246418,
    "CMY_Y": 0.16519916057587,
    "CMYK_C": 0.13175062835217,
    "CMYK_M": 0.11276712268591,
    "CMYK_Y": 0,
    "CMYK_K": 0.16519916057587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02543",
    "Farbtonhilfsbezeichnung": "UN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "226",
    "Bcolor": "229",
    "Y": 76,
    "L": 89.7856041573459,
    "a": 0.14791463920216,
    "b": -2.74987930903823,
    "C": 2.75385456311093,
    "h": -1.51705861128021,
    "CMY_C": 0.1232436,
    "CMY_M": 0.1137254,
    "CMY_Y": 0.101187,
    "CMYK_C": 0.02453964,
    "CMYK_M": 0.01394987,
    "CMYK_Y": 0,
    "CMYK_K": 0.101187
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02544",
    "Farbtonhilfsbezeichnung": "U0.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "128",
    "Bcolor": "136",
    "Y": 21,
    "L": 53.2687787052346,
    "a": -0.42971996872609,
    "b": -5.80912529688014,
    "C": 5.82499750784279,
    "h": 1.49695754820036,
    "CMY_C": 0.523758,
    "CMY_M": 0.4983453,
    "CMY_Y": 0.4666197,
    "CMYK_C": 0.1071248,
    "CMYK_M": 0.05948013,
    "CMYK_Y": 0,
    "CMYK_K": 0.4666197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02545",
    "Farbtonhilfsbezeichnung": "U0.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "111",
    "Bcolor": "117",
    "Y": 15,
    "L": 46.6040840148926,
    "a": -0.03226152434945,
    "b": -4.55652570724487,
    "C": 4.55664014816284,
    "h": 269.594329833984,
    "CMY_C": 0.58184486627579,
    "CMY_M": 0.56537795066833,
    "CMY_Y": 0.54096257686615,
    "CMYK_C": 0.0890609100461,
    "CMYK_M": 0.05318819731474,
    "CMYK_Y": 0,
    "CMYK_K": 0.54096257686615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02546",
    "Farbtonhilfsbezeichnung": "U2.21.09",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "53",
    "Bcolor": "69",
    "Y": 4,
    "L": 22.0113560615288,
    "a": 0.42046284608116,
    "b": -11.3164130862462,
    "C": 11.3242215689865,
    "h": -1.5336582761213,
    "CMY_C": 0.8300783,
    "CMY_M": 0.7910729,
    "CMY_Y": 0.7304648,
    "CMYK_C": 0.3695751,
    "CMYK_M": 0.2248614,
    "CMYK_Y": 0,
    "CMYK_K": 0.7304648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02547",
    "Farbtonhilfsbezeichnung": "U2.16.60",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "165",
    "Bcolor": "196",
    "Y": 37,
    "L": 67.3768355960581,
    "a": 1.13382119660682,
    "b": -18.4571807680662,
    "C": 18.4919731886823,
    "h": -1.5094436084642,
    "CMY_C": 0.4202089,
    "CMY_M": 0.3531996,
    "CMY_Y": 0.2331496,
    "CMYK_C": 0.2439319,
    "CMYK_M": 0.1565495,
    "CMYK_Y": 0,
    "CMYK_K": 0.2331496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02548",
    "Farbtonhilfsbezeichnung": "U6.26.46",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "130",
    "Bcolor": "175",
    "Y": 22,
    "L": 54.2970695495605,
    "a": 3.88197064399719,
    "b": -27.0747718811035,
    "C": 27.3516540527344,
    "h": 278.159423828125,
    "CMY_C": 0.57604944705963,
    "CMY_M": 0.49021220207214,
    "CMY_Y": 0.31350386142731,
    "CMYK_C": 0.38244292140007,
    "CMYK_M": 0.25740617513657,
    "CMYK_Y": 0,
    "CMYK_K": 0.31350386142731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02549",
    "Farbtonhilfsbezeichnung": "U3.20.64",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "190",
    "Bcolor": "218",
    "Y": 51,
    "L": 76.5758966336948,
    "a": -0.08268854564524,
    "b": -16.9908495986186,
    "C": 16.9910508055994,
    "h": 1.56592971360008,
    "CMY_C": 0.3266219,
    "CMY_M": 0.2532613,
    "CMY_Y": 0.1435047,
    "CMYK_C": 0.2137982,
    "CMYK_M": 0.1281461,
    "CMYK_Y": 0,
    "CMYK_K": 0.1435047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02550",
    "Farbtonhilfsbezeichnung": "U3.19.64",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "176",
    "Bcolor": "217",
    "Y": 43,
    "L": 71.5419624166812,
    "a": 2.05465162183122,
    "b": -24.1578906570334,
    "C": 24.2451082547444,
    "h": -1.48594956502587,
    "CMY_C": 0.3965834,
    "CMY_M": 0.3093585,
    "CMY_Y": 0.1476346,
    "CMYK_C": 0.2920682,
    "CMYK_M": 0.1897355,
    "CMYK_Y": 0,
    "CMYK_K": 0.1476346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02551",
    "Farbtonhilfsbezeichnung": "U4.30.52",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "145",
    "Bcolor": "201",
    "Y": 28,
    "L": 59.8818023067187,
    "a": 3.92597710971448,
    "b": -33.0130050562916,
    "C": 33.2456282706875,
    "h": -1.45243009799515,
    "CMY_C": 0.5546031,
    "CMY_M": 0.4314731,
    "CMY_Y": 0.2131405,
    "CMYK_C": 0.4339562,
    "CMYK_M": 0.2774734,
    "CMYK_Y": 0,
    "CMYK_K": 0.2131405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02552",
    "Farbtonhilfsbezeichnung": "V0.37.42",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "120",
    "Bcolor": "185",
    "Y": 19,
    "L": 51.2465366883419,
    "a": 9.53437417063424,
    "b": -37.6682976910512,
    "C": 38.8562085356679,
    "h": -1.32288897768367,
    "CMY_C": 0.6223828,
    "CMY_M": 0.5287364,
    "CMY_Y": 0.2742905,
    "CMYK_C": 0.4796578,
    "CMYK_M": 0.3506167,
    "CMYK_Y": 0,
    "CMYK_K": 0.2742905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02553",
    "Farbtonhilfsbezeichnung": "V1.42.30",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "91",
    "Bcolor": "156",
    "Y": 11,
    "L": 39.5961070356754,
    "a": 10.6367381862824,
    "b": -39.1226430310267,
    "C": 40.5428341014372,
    "h": -1.30533130124389,
    "CMY_C": 0.7481407,
    "CMY_M": 0.642522,
    "CMY_Y": 0.3879323,
    "CMYK_C": 0.5885107,
    "CMYK_M": 0.4159503,
    "CMYK_Y": 0,
    "CMYK_K": 0.3879323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02554",
    "Farbtonhilfsbezeichnung": "V3.35.14",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "59",
    "Bcolor": "98",
    "Y": 5,
    "L": 25.8661804940207,
    "a": 7.83038244685236,
    "b": -24.6921302813808,
    "C": 25.9039801400607,
    "h": -1.26370752543899,
    "CMY_C": 0.8068733,
    "CMY_M": 0.767392,
    "CMY_Y": 0.6157064,
    "CMYK_C": 0.4974501,
    "CMYK_M": 0.3947127,
    "CMYK_Y": 0,
    "CMYK_K": 0.6157064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02555",
    "Farbtonhilfsbezeichnung": "VN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "233",
    "Y": 78,
    "L": 90.8579788208008,
    "a": 0.8998236656189,
    "b": -3.21844696998596,
    "C": 3.34186816215515,
    "h": 285.620086669922,
    "CMY_C": 0.10696965456009,
    "CMY_M": 0.10340720415115,
    "CMY_Y": 0.08572441339493,
    "CMYK_C": 0.02323723956943,
    "CMYK_M": 0.01934076659381,
    "CMYK_Y": 0,
    "CMYK_K": 0.08572441339493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02556",
    "Farbtonhilfsbezeichnung": "V2.08.71",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "193",
    "Bcolor": "214",
    "Y": 54,
    "L": 78.4545288085938,
    "a": 3.7501208782196,
    "b": -11.8528337478638,
    "C": 12.4319372177124,
    "h": 287.556854248047,
    "CMY_C": 0.25259405374527,
    "CMY_M": 0.24356120824814,
    "CMY_Y": 0.15927565097809,
    "CMYK_C": 0.1109976246953,
    "CMYK_M": 0.10025350004435,
    "CMYK_Y": 0,
    "CMYK_K": 0.15927565097809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02558",
    "Farbtonhilfsbezeichnung": "W0.08.71",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "190",
    "Bcolor": "211",
    "Y": 53,
    "L": 78.0360767657567,
    "a": 5.95577834548022,
    "b": -10.4957683359245,
    "C": 12.0678270066274,
    "h": -1.05465785507172,
    "CMY_C": 0.2344721,
    "CMY_M": 0.2537996,
    "CMY_Y": 0.1733156,
    "CMYK_C": 0.07397804,
    "CMYK_M": 0.09735765,
    "CMYK_Y": 0,
    "CMYK_K": 0.1733156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02559",
    "Farbtonhilfsbezeichnung": "WN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "225",
    "Bcolor": "230",
    "Y": 75,
    "L": 89.8418731689453,
    "a": 1.95457541942596,
    "b": -3.09579563140869,
    "C": 3.66119050979614,
    "h": 302.266876220703,
    "CMY_C": 0.10942685604095,
    "CMY_M": 0.1172724366188,
    "CMY_Y": 0.09776884317398,
    "CMYK_C": 0.01292131468654,
    "CMYK_M": 0.02161706984043,
    "CMYK_Y": 0,
    "CMYK_K": 0.09776884317398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02560",
    "Farbtonhilfsbezeichnung": "W1.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "219",
    "Bcolor": "227",
    "Y": 72,
    "L": 87.7664641513839,
    "a": 2.82600952460904,
    "b": -4.50437772366785,
    "C": 5.31749457081586,
    "h": -1.01047893361869,
    "CMY_C": 0.1305858,
    "CMY_M": 0.1419694,
    "CMY_Y": 0.1102667,
    "CMYK_C": 0.02283728,
    "CMYK_M": 0.03563171,
    "CMYK_Y": 0,
    "CMYK_K": 0.1102667
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02561",
    "Farbtonhilfsbezeichnung": "X9.04.79",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "213",
    "Bcolor": "219",
    "Y": 69,
    "L": 86.2849970005049,
    "a": 5.5717099126093,
    "b": -2.32087201633826,
    "C": 6.03575995765991,
    "h": -0.39468807529239,
    "CMY_C": 0.1181777,
    "CMY_M": 0.1656258,
    "CMY_Y": 0.1422202,
    "CMYK_C": 0,
    "CMYK_M": 0.05380686,
    "CMYK_Y": 0.0272646,
    "CMYK_K": 0.1181777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02562",
    "Farbtonhilfsbezeichnung": "X9.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "210",
    "Bcolor": "224",
    "Y": 68,
    "L": 86.0382919311523,
    "a": 9.92193126678467,
    "b": -5.62274551391602,
    "C": 11.4043846130371,
    "h": 330.459838867188,
    "CMY_C": 0.09894901514053,
    "CMY_M": 0.17815232276917,
    "CMY_Y": 0.12022972106934,
    "CMYK_C": 0,
    "CMYK_M": 0.08790102601051,
    "CMYK_Y": 0.0236176494509,
    "CMYK_K": 0.09894901514053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02563",
    "Farbtonhilfsbezeichnung": "X7.07.69",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "182",
    "Bcolor": "198",
    "Y": 50,
    "L": 76.1409223446615,
    "a": 9.70478781911188,
    "b": -6.4053323053203,
    "C": 11.6280345955609,
    "h": -0.58338537714222,
    "CMY_C": 0.2123141,
    "CMY_M": 0.2846179,
    "CMY_Y": 0.2226117,
    "CMYK_C": 0,
    "CMYK_M": 0.09179273,
    "CMYK_Y": 0.01307317,
    "CMYK_K": 0.2123141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02564",
    "Farbtonhilfsbezeichnung": "X7.13.58",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "152",
    "Bcolor": "179",
    "Y": 36,
    "L": 66.3129085193031,
    "a": 15.7616186954658,
    "b": -10.7503325949367,
    "C": 19.0787388158394,
    "h": -0.59858234805181,
    "CMY_C": 0.2892498,
    "CMY_M": 0.4021434,
    "CMY_Y": 0.2964222,
    "CMYK_C": 0,
    "CMYK_M": 0.1588372,
    "CMYK_Y": 0.01009123,
    "CMYK_K": 0.2892498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02565",
    "Farbtonhilfsbezeichnung": "X6.04.76",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "203",
    "Bcolor": "213",
    "Y": 62,
    "L": 83.0342313348033,
    "a": 6.35361313606003,
    "b": -4.1053792646909,
    "C": 7.56455806968712,
    "h": -0.57366308178117,
    "CMY_C": 0.1541675,
    "CMY_M": 0.2026035,
    "CMY_Y": 0.1647349,
    "CMYK_C": 0,
    "CMYK_M": 0.05726431,
    "CMYK_Y": 0.01249349,
    "CMYK_K": 0.1541675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02566",
    "Farbtonhilfsbezeichnung": "X9.11.74",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "192",
    "Bcolor": "217",
    "Y": 60,
    "L": 80.9276351928711,
    "a": 15.9885482788086,
    "b": -9.24839782714844,
    "C": 18.4706935882568,
    "h": 329.953247070313,
    "CMY_C": 0.12305390834808,
    "CMY_M": 0.24838382005692,
    "CMY_Y": 0.14937615394592,
    "CMYK_C": 0,
    "CMYK_M": 0.14291632175446,
    "CMYK_Y": 0.03001580759883,
    "CMYK_K": 0.12305390834808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02567",
    "Farbtonhilfsbezeichnung": "X7.16.66",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "167",
    "Bcolor": "203",
    "Y": 45,
    "L": 73.0210499227812,
    "a": 20.8869982587093,
    "b": -13.7733978295905,
    "C": 25.0194561098257,
    "h": -0.58297200476744,
    "CMY_C": 0.1903747,
    "CMY_M": 0.3446271,
    "CMY_Y": 0.2027603,
    "CMYK_C": 0,
    "CMYK_M": 0.1905232,
    "CMYK_Y": 0.01529797,
    "CMYK_K": 0.1903747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02568",
    "Farbtonhilfsbezeichnung": "ZN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "232",
    "Bcolor": "232",
    "Y": 80,
    "L": 92.7510070800781,
    "a": 3.39554071426392,
    "b": 0.35344326496124,
    "C": 3.41388607025146,
    "h": 5.94254112243652,
    "CMY_C": 0.05373412370682,
    "CMY_M": 0.08936131000519,
    "CMY_Y": 0.09083116054535,
    "CMYK_C": 0,
    "CMYK_M": 0.03765029087663,
    "CMYK_Y": 0.03920360654593,
    "CMYK_K": 0.05373412370682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02569",
    "Farbtonhilfsbezeichnung": "Z5.31.48",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "104",
    "Bcolor": "141",
    "Y": 23,
    "L": 55.4941309773142,
    "a": 40.7530495319729,
    "b": -4.66997759984433,
    "C": 41.019748133533,
    "h": -0.11409443397499,
    "CMY_C": 0.2362739,
    "CMY_M": 0.591932,
    "CMY_Y": 0.4463871,
    "CMYK_C": 0,
    "CMYK_M": 0.465688,
    "CMYK_Y": 0.2751158,
    "CMYK_K": 0.2362739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02573",
    "Farbtonhilfsbezeichnung": "F7.09.84",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "227",
    "Bcolor": "202",
    "Y": 78,
    "L": 90.6030332856331,
    "a": 1.25541136841595,
    "b": 12.9571182549433,
    "C": 13.0177944052183,
    "h": 1.47420811295154,
    "CMY_C": 0.0558348,
    "CMY_M": 0.1115657,
    "CMY_Y": 0.2082567,
    "CMYK_C": 0,
    "CMYK_M": 0.05902661,
    "CMYK_Y": 0.1614356,
    "CMYK_K": 0.0558348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02574",
    "Farbtonhilfsbezeichnung": "C9.23.60",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "150",
    "Bcolor": "129",
    "Y": 37,
    "L": 67.5261214216534,
    "a": 21.3674813656762,
    "b": 19.7057146767398,
    "C": 29.0668961334642,
    "h": 0.74496155214813,
    "CMY_C": 0.167002,
    "CMY_M": 0.413323,
    "CMY_Y": 0.4940502,
    "CMYK_C": 0,
    "CMYK_M": 0.2957042,
    "CMYK_Y": 0.3926158,
    "CMYK_K": 0.167002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02575",
    "Farbtonhilfsbezeichnung": "F2.06.65",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 45,
    "L": 73.2144847183376,
    "a": 1.04868646695583,
    "b": 5.55406336187028,
    "C": 5.652199849054,
    "h": 1.3841790369371,
    "CMY_C": 0.2700059,
    "CMY_M": 0.2985117,
    "CMY_Y": 0.3397234,
    "CMYK_C": 0,
    "CMYK_M": 0.03904935,
    "CMYK_Y": 0.09550416,
    "CMYK_K": 0.2700059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02576",
    "Farbtonhilfsbezeichnung": "F0.40.70",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "181",
    "Bcolor": "100",
    "Y": 52,
    "L": 77.544957072788,
    "a": 13.0828811630698,
    "b": 48.3480950550295,
    "C": 50.0869251898854,
    "h": 1.30652752949921,
    "CMY_C": 0.05911186,
    "CMY_M": 0.290608,
    "CMY_Y": 0.6074352,
    "CMYK_C": 0,
    "CMYK_M": 0.24604,
    "CMYK_Y": 0.582772,
    "CMYK_K": 0.05911186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02577",
    "Farbtonhilfsbezeichnung": "ON.00.67",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "188",
    "Bcolor": "186",
    "Y": 50,
    "L": 76.2650293393878,
    "a": -0.11292408604196,
    "b": 0.35131580846445,
    "C": 0.3690184907094,
    "h": -1.25979508548513,
    "CMY_C": 0.2621736,
    "CMY_M": 0.2618424,
    "CMY_Y": 0.2707002,
    "CMYK_C": 0.000448647,
    "CMYK_M": 0,
    "CMYK_Y": 0.01199992,
    "CMYK_K": 0.2618424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02579",
    "Farbtonhilfsbezeichnung": "ON.00.89",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "215",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.7820427951362,
    "a": -0.71598783743059,
    "b": -0.25677573427966,
    "C": 0.76063944222174,
    "h": 0.34434349019863,
    "CMY_C": 0.1655244,
    "CMY_M": 0.1567259,
    "CMY_Y": 0.1636736,
    "CMYK_C": 0.01043381,
    "CMYK_M": 0,
    "CMYK_Y": 0.008238993,
    "CMYK_K": 0.1567259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02580",
    "Farbtonhilfsbezeichnung": "ON.00.62",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "173",
    "Bcolor": "171",
    "Y": 42,
    "L": 70.9625047126818,
    "a": 0.45091740710917,
    "b": 0.5499104230906,
    "C": 0.7111455416845,
    "h": 0.88398861527246,
    "CMY_C": 0.3138192,
    "CMY_M": 0.3197237,
    "CMY_Y": 0.3280966,
    "CMYK_C": 0,
    "CMYK_M": 0.008604995,
    "CMYK_Y": 0.02080706,
    "CMYK_K": 0.3138192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02581",
    "Farbtonhilfsbezeichnung": "ON.00.58",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "162",
    "Bcolor": "162",
    "Y": 35,
    "L": 66.4763717651367,
    "a": 0.1171752139926,
    "b": -0.65801578760147,
    "C": 0.66836726665497,
    "h": 280.097015380859,
    "CMY_C": 0.36740678548813,
    "CMY_M": 0.36579430103302,
    "CMY_Y": 0.36652207374573,
    "CMYK_C": 0.00254252599552,
    "CMYK_M": 0,
    "CMYK_Y": 0.00114753411617,
    "CMYK_K": 0.36579430103302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02582",
    "Farbtonhilfsbezeichnung": "LN.00.85",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 82,
    "L": 92.3745493830345,
    "a": -1.29948638102734,
    "b": 1.46649380459225,
    "C": 1.95940524991207,
    "h": -0.84570406064383,
    "CMY_C": 0.09118434,
    "CMY_M": 0.08264764,
    "CMY_Y": 0.103933,
    "CMYK_C": 0.009305801,
    "CMYK_M": 0,
    "CMYK_Y": 0.023203,
    "CMYK_K": 0.08264764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02584",
    "Farbtonhilfsbezeichnung": "K8.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "199",
    "Bcolor": "184",
    "Y": 54,
    "L": 78.5782589122508,
    "a": -8.09911063377317,
    "b": 4.74001377188922,
    "C": 9.38420607274782,
    "h": -0.52950416019103,
    "CMY_C": 0.2851868,
    "CMY_M": 0.2203315,
    "CMY_Y": 0.2786093,
    "CMYK_C": 0.08318312,
    "CMYK_M": 0,
    "CMYK_Y": 0.07474688,
    "CMYK_K": 0.2203315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02585",
    "Farbtonhilfsbezeichnung": "K7.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "219",
    "Bcolor": "210",
    "Y": 69,
    "L": 86.3655575987593,
    "a": -4.49167930247374,
    "b": 2.31444700779999,
    "C": 5.05290489799534,
    "h": -0.4757922653799,
    "CMY_C": 0.1802819,
    "CMY_M": 0.1423314,
    "CMY_Y": 0.1766449,
    "CMYK_C": 0.04424836,
    "CMYK_M": 0,
    "CMYK_Y": 0.04000779,
    "CMYK_K": 0.1423314
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02587",
    "Farbtonhilfsbezeichnung": "JN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "214",
    "Bcolor": "204",
    "Y": 67,
    "L": 85.4943737610967,
    "a": -1.67825533027677,
    "b": 4.31310436835195,
    "C": 4.62811087225653,
    "h": -1.19971635287808,
    "CMY_C": 0.16092,
    "CMY_M": 0.158924,
    "CMY_Y": 0.2003554,
    "CMYK_C": 0.002373174,
    "CMYK_M": 0,
    "CMYK_Y": 0.04926005,
    "CMYK_K": 0.158924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02588",
    "Farbtonhilfsbezeichnung": "J9.11.77",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "215",
    "Bcolor": "188",
    "Y": 65,
    "L": 84.2763370926294,
    "a": -9.70171973223749,
    "b": 11.061660501497,
    "C": 14.71338502226,
    "h": -0.8508018254632,
    "CMY_C": 0.2156602,
    "CMY_M": 0.1560948,
    "CMY_Y": 0.2640256,
    "CMYK_C": 0.07058311,
    "CMYK_M": 0,
    "CMYK_Y": 0.1278945,
    "CMYK_K": 0.1560948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02589",
    "Farbtonhilfsbezeichnung": "J6.09.75",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "209",
    "Bcolor": "183",
    "Y": 61,
    "L": 82.1123878015743,
    "a": -8.48037611975799,
    "b": 10.3332459710147,
    "C": 13.3676008105438,
    "h": -0.88356713312542,
    "CMY_C": 0.2317882,
    "CMY_M": 0.1823477,
    "CMY_Y": 0.2815863,
    "CMYK_C": 0.06046642,
    "CMYK_M": 0,
    "CMYK_Y": 0.1213702,
    "CMYK_K": 0.1823477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02590",
    "Farbtonhilfsbezeichnung": "J6.09.67",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "187",
    "Bcolor": "166",
    "Y": 48,
    "L": 74.6641645577837,
    "a": -7.20119506690858,
    "b": 8.70741259512686,
    "C": 11.2993913328746,
    "h": -0.8797961735676,
    "CMY_C": 0.3068512,
    "CMY_M": 0.2655116,
    "CMY_Y": 0.34817,
    "CMYK_C": 0.0562836,
    "CMYK_M": 0,
    "CMYK_Y": 0.1125387,
    "CMYK_K": 0.2655116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02591",
    "Farbtonhilfsbezeichnung": "J2.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "201",
    "Bcolor": "169",
    "Y": 56,
    "L": 79.4120861305207,
    "a": -8.34474760427723,
    "b": 14.053186752045,
    "C": 16.3440163505469,
    "h": -1.03494994708124,
    "CMY_C": 0.2486903,
    "CMY_M": 0.2129923,
    "CMY_Y": 0.3371228,
    "CMYK_C": 0.04535914,
    "CMYK_M": 0,
    "CMYK_Y": 0.1577247,
    "CMYK_K": 0.2129923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02592",
    "Farbtonhilfsbezeichnung": "H8.09.66",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "182",
    "Bcolor": "163",
    "Y": 45,
    "L": 73.1027317394639,
    "a": -4.75879107357235,
    "b": 8.5066249075068,
    "C": 9.74724370265394,
    "h": -1.06074830861703,
    "CMY_C": 0.3054496,
    "CMY_M": 0.2874529,
    "CMY_Y": 0.3626591,
    "CMYK_C": 0.02525686,
    "CMYK_M": 0,
    "CMYK_Y": 0.1055456,
    "CMYK_K": 0.2874529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02593",
    "Farbtonhilfsbezeichnung": "H5.14.69",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "190",
    "Bcolor": "154",
    "Y": 50,
    "L": 75.8457466064367,
    "a": -6.95601899134823,
    "b": 17.1706597530514,
    "C": 18.5261371192987,
    "h": -1.18589190286701,
    "CMY_C": 0.2680529,
    "CMY_M": 0.2552672,
    "CMY_Y": 0.396555,
    "CMYK_C": 0.01716817,
    "CMYK_M": 0,
    "CMYK_Y": 0.1897161,
    "CMYK_K": 0.2552672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02594",
    "Farbtonhilfsbezeichnung": "H2.06.65",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 45,
    "L": 72.619985871434,
    "a": -2.13164040395797,
    "b": 5.09208397567049,
    "C": 5.52025452556911,
    "h": -1.17434328506304,
    "CMY_C": 0.3012376,
    "CMY_M": 0.2975329,
    "CMY_Y": 0.3431183,
    "CMYK_C": 0.00527392,
    "CMYK_M": 0,
    "CMYK_Y": 0.06489326,
    "CMYK_K": 0.2975329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02595",
    "Farbtonhilfsbezeichnung": "H0.04.39",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "123",
    "Bcolor": "112",
    "Y": 20,
    "L": 51.314002134496,
    "a": -1.24396857068515,
    "b": 5.2333794532174,
    "C": 5.3791930906234,
    "h": -1.33742824905473,
    "CMY_C": 0.514044,
    "CMY_M": 0.5189709,
    "CMY_Y": 0.5591655,
    "CMYK_C": 0,
    "CMYK_M": 0.01013868,
    "CMYK_Y": 0.09285109,
    "CMYK_K": 0.514044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02596",
    "Farbtonhilfsbezeichnung": "H0.03.32",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "102",
    "Bcolor": "94",
    "Y": 13,
    "L": 42.9458087451346,
    "a": -0.59446494733556,
    "b": 4.12027032489,
    "C": 4.16293359588882,
    "h": -1.4275069708381,
    "CMY_C": 0.5946977,
    "CMY_M": 0.6018281,
    "CMY_Y": 0.6319589,
    "CMYK_C": 0,
    "CMYK_M": 0.01759278,
    "CMYK_Y": 0.09193432,
    "CMYK_K": 0.5946977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02597",
    "Farbtonhilfsbezeichnung": "GN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 75,
    "L": 89.4748257392999,
    "a": -1.22130813507437,
    "b": 3.27279218648917,
    "C": 3.49324523283771,
    "h": -1.21363093084254,
    "CMY_C": 0.1167579,
    "CMY_M": 0.1156749,
    "CMY_Y": 0.1492502,
    "CMYK_C": 0.001224659,
    "CMYK_M": 0,
    "CMYK_Y": 0.03796716,
    "CMYK_K": 0.1156749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02598",
    "Farbtonhilfsbezeichnung": "G6.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "239",
    "Bcolor": "224",
    "Y": 86,
    "L": 94.3795661609779,
    "a": -0.75235212424257,
    "b": 6.73772580868406,
    "C": 6.77960048910403,
    "h": -1.45959435436411,
    "CMY_C": 0.04697444,
    "CMY_M": 0.06292049,
    "CMY_Y": 0.1209646,
    "CMYK_C": 0,
    "CMYK_M": 0.01673203,
    "CMYK_Y": 0.07763712,
    "CMYK_K": 0.04697444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02599",
    "Farbtonhilfsbezeichnung": "G0.11.60",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "170",
    "Bcolor": "148",
    "Y": 41,
    "L": 69.8935570163412,
    "a": 0.38604840055578,
    "b": 11.8187302801342,
    "C": 11.8250335645246,
    "h": 1.53814381829224,
    "CMY_C": 0.2930621,
    "CMY_M": 0.3337062,
    "CMY_Y": 0.4184163,
    "CMYK_C": 0,
    "CMYK_M": 0.05749321,
    "CMYK_Y": 0.17732,
    "CMYK_K": 0.2930621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02600",
    "Farbtonhilfsbezeichnung": "G0.06.70",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "192",
    "Bcolor": "181",
    "Y": 53,
    "L": 77.9301914806316,
    "a": 0.07465902659337,
    "b": 5.49170068403644,
    "C": 5.49220815094422,
    "h": 1.55720228154662,
    "CMY_C": 0.2265069,
    "CMY_M": 0.2457263,
    "CMY_Y": 0.2897497,
    "CMYK_C": 0,
    "CMYK_M": 0.02484749,
    "CMYK_Y": 0.08176249,
    "CMYK_K": 0.2265069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02601",
    "Farbtonhilfsbezeichnung": "G0.06.65",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "182",
    "Bcolor": "170",
    "Y": 47,
    "L": 73.9155145415276,
    "a": -0.84647369927798,
    "b": 5.38075808341332,
    "C": 5.44693264836156,
    "h": -1.41476018231157,
    "CMY_C": 0.2769509,
    "CMY_M": 0.2866777,
    "CMY_Y": 0.3314218,
    "CMYK_C": 0,
    "CMYK_M": 0.01345249,
    "CMYK_Y": 0.07533494,
    "CMYK_K": 0.2769509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02602",
    "Farbtonhilfsbezeichnung": "F9.32.78",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "213",
    "Bcolor": "130",
    "Y": 69,
    "L": 86.3881244907849,
    "a": 1.25557828741052,
    "b": 44.3957659436973,
    "C": 44.4135172055014,
    "h": 1.54252237619802,
    "CMY_C": 0.03625393,
    "CMY_M": 0.1646038,
    "CMY_Y": 0.4899866,
    "CMYK_C": 0,
    "CMYK_M": 0.1331781,
    "CMYK_Y": 0.4708011,
    "CMYK_K": 0.03625393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02603",
    "Farbtonhilfsbezeichnung": "F9.27.75",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "198",
    "Bcolor": "133",
    "Y": 58,
    "L": 80.9726462929864,
    "a": 1.04011448495889,
    "b": 35.7140586579902,
    "C": 35.7292012780609,
    "h": 1.54168116575459,
    "CMY_C": 0.1148611,
    "CMY_M": 0.2216561,
    "CMY_Y": 0.4788477,
    "CMYK_C": 0,
    "CMYK_M": 0.1206534,
    "CMYK_Y": 0.4112198,
    "CMYK_K": 0.1148611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02604",
    "Farbtonhilfsbezeichnung": "F8.30.68",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "181",
    "Bcolor": "117",
    "Y": 48,
    "L": 74.9132236565493,
    "a": 1.91839941294214,
    "b": 36.0646171572045,
    "C": 36.1156042037691,
    "h": 1.51765301804846,
    "CMY_C": 0.1771206,
    "CMY_M": 0.2888795,
    "CMY_Y": 0.5425099,
    "CMYK_C": 0,
    "CMYK_M": 0.1358145,
    "CMYK_Y": 0.4440376,
    "CMYK_K": 0.1771206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02605",
    "Farbtonhilfsbezeichnung": "F8.07.44",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "128",
    "Bcolor": "114",
    "Y": 22,
    "L": 53.798604254847,
    "a": 0.42514910432922,
    "b": 7.91467048683725,
    "C": 7.926081041481,
    "h": 1.5171313140915,
    "CMY_C": 0.4706134,
    "CMY_M": 0.4983554,
    "CMY_Y": 0.5525473,
    "CMYK_C": 0,
    "CMYK_M": 0.05240407,
    "CMYK_Y": 0.1547714,
    "CMYK_K": 0.4706134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02606",
    "Farbtonhilfsbezeichnung": "F7.31.77",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "198",
    "Bcolor": "123",
    "Y": 59,
    "L": 81.5123509728955,
    "a": 4.21943856346679,
    "b": 41.6689402031477,
    "C": 41.882027642467,
    "h": 1.4698793157332,
    "CMY_C": 0.07771292,
    "CMY_M": 0.2244747,
    "CMY_Y": 0.5179107,
    "CMYK_C": 0,
    "CMYK_M": 0.1591281,
    "CMYK_Y": 0.4772893,
    "CMYK_K": 0.07771292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02607",
    "Farbtonhilfsbezeichnung": "F7.25.76",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "204",
    "Bcolor": "144",
    "Y": 63,
    "L": 83.4758124416801,
    "a": 3.18690427196267,
    "b": 33.6456888994652,
    "C": 33.7962829370073,
    "h": 1.47635853678637,
    "CMY_C": 0.07565723,
    "CMY_M": 0.1992314,
    "CMY_Y": 0.4371444,
    "CMYK_C": 0,
    "CMYK_M": 0.1336887,
    "CMYK_Y": 0.3910748,
    "CMYK_K": 0.07565723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02608",
    "Farbtonhilfsbezeichnung": "F7.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "219",
    "Bcolor": "200",
    "Y": 73,
    "L": 88.2114941791373,
    "a": 2.15026791211476,
    "b": 10.4308725641247,
    "C": 10.6501997419241,
    "h": 1.36749955240585,
    "CMY_C": 0.08320373,
    "CMY_M": 0.1395978,
    "CMY_Y": 0.2152974,
    "CMYK_C": 0,
    "CMYK_M": 0.06151205,
    "CMYK_Y": 0.1440818,
    "CMYK_K": 0.08320373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02609",
    "Farbtonhilfsbezeichnung": "F6.16.75",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "198",
    "Bcolor": "166",
    "Y": 58,
    "L": 80.5295808126594,
    "a": 2.01374942871868,
    "b": 17.4738278884444,
    "C": 17.589481170195,
    "h": 1.45605873956099,
    "CMY_C": 0.1514257,
    "CMY_M": 0.2250808,
    "CMY_Y": 0.3485801,
    "CMYK_C": 0,
    "CMYK_M": 0.08679872,
    "CMYK_Y": 0.232336,
    "CMYK_K": 0.1514257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02610",
    "Farbtonhilfsbezeichnung": "F6.16.65",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "176",
    "Bcolor": "144",
    "Y": 44,
    "L": 72.4652073962225,
    "a": 1.35537745953673,
    "b": 17.8658564188185,
    "C": 17.9171949153783,
    "h": 1.49507724903169,
    "CMY_C": 0.2438049,
    "CMY_M": 0.3100963,
    "CMY_Y": 0.4348406,
    "CMYK_C": 0,
    "CMYK_M": 0.08766434,
    "CMYK_Y": 0.2526274,
    "CMYK_K": 0.2438049
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02611",
    "Farbtonhilfsbezeichnung": "F6.11.80",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "212",
    "Bcolor": "189",
    "Y": 67,
    "L": 85.5553517660295,
    "a": 1.13211574957162,
    "b": 12.5423256464356,
    "C": 12.5933164294266,
    "h": 1.48077665428031,
    "CMY_C": 0.1145426,
    "CMY_M": 0.1669684,
    "CMY_Y": 0.2595413,
    "CMYK_C": 0,
    "CMYK_M": 0.05920758,
    "CMYK_Y": 0.1637557,
    "CMYK_K": 0.1145426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02612",
    "Farbtonhilfsbezeichnung": "F6.08.77",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "208",
    "Bcolor": "192",
    "Y": 64,
    "L": 84.1131511075466,
    "a": 1.85563491903118,
    "b": 8.80355671325592,
    "C": 8.99699904169392,
    "h": 1.36305488552791,
    "CMY_C": 0.1357384,
    "CMY_M": 0.1835625,
    "CMY_Y": 0.2475233,
    "CMYK_C": 0,
    "CMYK_M": 0.05533524,
    "CMYK_Y": 0.1293415,
    "CMYK_K": 0.1357384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02613",
    "Farbtonhilfsbezeichnung": "F6.07.74",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "201",
    "Bcolor": "188",
    "Y": 59,
    "L": 81.1421513171379,
    "a": 0.23252811992186,
    "b": 6.60193732317862,
    "C": 6.60603101307686,
    "h": 1.53558968560036,
    "CMY_C": 0.1869874,
    "CMY_M": 0.2115907,
    "CMY_Y": 0.2635534,
    "CMYK_C": 0,
    "CMYK_M": 0.03026191,
    "CMYK_Y": 0.09417557,
    "CMYK_K": 0.1869874
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02614",
    "Farbtonhilfsbezeichnung": "F6.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "202",
    "Bcolor": "195",
    "Y": 59,
    "L": 81.1370819923947,
    "a": -0.38198903080233,
    "b": 2.58258174325057,
    "C": 2.61067885428761,
    "h": -1.4239512535588,
    "CMY_C": 0.2042284,
    "CMY_M": 0.2091501,
    "CMY_Y": 0.2346236,
    "CMYK_C": 0,
    "CMYK_M": 0.006184776,
    "CMYK_Y": 0.03819586,
    "CMYK_K": 0.2042284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02616",
    "Farbtonhilfsbezeichnung": "F5.16.78",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "208",
    "Bcolor": "171",
    "Y": 65,
    "L": 84.6537283123362,
    "a": 3.28146889120468,
    "b": 20.6764974108913,
    "C": 20.9352712728194,
    "h": 1.4134037412756,
    "CMY_C": 0.08869817,
    "CMY_M": 0.1839307,
    "CMY_Y": 0.3285174,
    "CMYK_C": 0,
    "CMYK_M": 0.1045016,
    "CMYK_Y": 0.2631612,
    "CMYK_K": 0.08869817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02617",
    "Farbtonhilfsbezeichnung": "F4.36.73",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "192",
    "Bcolor": "112",
    "Y": 57,
    "L": 80.0621271875316,
    "a": 7.00549848201254,
    "b": 45.3502289730312,
    "C": 45.8881278424806,
    "h": 1.41753227934815,
    "CMY_C": 0.07121368,
    "CMY_M": 0.2475959,
    "CMY_Y": 0.5603701,
    "CMYK_C": 0,
    "CMYK_M": 0.1899062,
    "CMYK_Y": 0.526662,
    "CMYK_K": 0.07121368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02618",
    "Farbtonhilfsbezeichnung": "F3.18.70",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "188",
    "Bcolor": "147",
    "Y": 53,
    "L": 77.722238767716,
    "a": 4.35858417616786,
    "b": 23.6606433813585,
    "C": 24.0587468759402,
    "h": 1.38862619295901,
    "CMY_C": 0.1526451,
    "CMY_M": 0.2623242,
    "CMY_Y": 0.4222465,
    "CMYK_C": 0,
    "CMYK_M": 0.1294371,
    "CMYK_Y": 0.3181683,
    "CMYK_K": 0.1526451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02619",
    "Farbtonhilfsbezeichnung": "F3.09.69",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "165",
    "Bcolor": "115",
    "Y": 41,
    "L": 70.0474953755393,
    "a": 6.99078663402658,
    "b": 30.362971869251,
    "C": 31.157361224844,
    "h": 1.34449950873633,
    "CMY_C": 0.2088012,
    "CMY_M": 0.3514524,
    "CMY_Y": 0.547792,
    "CMYK_C": 0,
    "CMYK_M": 0.1802975,
    "CMYK_Y": 0.4284522,
    "CMYK_K": 0.2088012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02620",
    "Farbtonhilfsbezeichnung": "F2.32.68",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "181",
    "Bcolor": "116",
    "Y": 50,
    "L": 76.1234871331733,
    "a": 8.22169869830558,
    "b": 38.371116583413,
    "C": 39.2420554678727,
    "h": 1.3597200226569,
    "CMY_C": 0.119361,
    "CMY_M": 0.2916839,
    "CMY_Y": 0.5461552,
    "CMYK_C": 0,
    "CMYK_M": 0.1956794,
    "CMYK_Y": 0.4846416,
    "CMYK_K": 0.119361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02621",
    "Farbtonhilfsbezeichnung": "F2.16.65",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "175",
    "Bcolor": "146",
    "Y": 44,
    "L": 72.4923201189961,
    "a": 3.08395396004596,
    "b": 16.9185997195268,
    "C": 17.1973773726477,
    "h": 1.39049401547977,
    "CMY_C": 0.2338857,
    "CMY_M": 0.3136286,
    "CMY_Y": 0.4275168,
    "CMYK_C": 0,
    "CMYK_M": 0.1040875,
    "CMYK_Y": 0.2527444,
    "CMYK_K": 0.2338857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02622",
    "Farbtonhilfsbezeichnung": "F2.11.50",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "147",
    "Bcolor": "130",
    "Y": 30,
    "L": 61.5882310913064,
    "a": 2.37133645059173,
    "b": 10.3922736562844,
    "C": 10.659389678073,
    "h": 1.34645467333588,
    "CMY_C": 0.3709777,
    "CMY_M": 0.4242623,
    "CMY_Y": 0.4921508,
    "CMYK_C": 0,
    "CMYK_M": 0.08471018,
    "CMYK_Y": 0.1926373,
    "CMYK_K": 0.3709777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02623",
    "Farbtonhilfsbezeichnung": "F2.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "188",
    "Bcolor": "168",
    "Y": 52,
    "L": 76.9981443403665,
    "a": 2.04711128537266,
    "b": 11.2426683253684,
    "C": 11.4275218524815,
    "h": 1.39068541805112,
    "CMY_C": 0.205953,
    "CMY_M": 0.2617961,
    "CMY_Y": 0.340523,
    "CMYK_C": 0,
    "CMYK_M": 0.07032729,
    "CMYK_Y": 0.1694736,
    "CMYK_K": 0.205953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02624",
    "Farbtonhilfsbezeichnung": "F2.04.70",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "205",
    "Bcolor": "194",
    "Y": 61,
    "L": 82.5976817680234,
    "a": 1.11420441659338,
    "b": 5.51784500207531,
    "C": 5.62921530489673,
    "h": 1.37154813047913,
    "CMY_C": 0.1676913,
    "CMY_M": 0.1975121,
    "CMY_Y": 0.2399836,
    "CMYK_C": 0,
    "CMYK_M": 0.03582903,
    "CMYK_Y": 0.08685759,
    "CMYK_K": 0.1676913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02625",
    "Farbtonhilfsbezeichnung": "F1.17.81",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "209",
    "Bcolor": "164",
    "Y": 67,
    "L": 85.6490912151929,
    "a": 5.6775617970381,
    "b": 25.7523237132512,
    "C": 26.3707581345563,
    "h": 1.35379972699754,
    "CMY_C": 0.04955888,
    "CMY_M": 0.1800206,
    "CMY_Y": 0.3551445,
    "CMYK_C": 0,
    "CMYK_M": 0.1372644,
    "CMYK_Y": 0.3215198,
    "CMYK_K": 0.04955888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02626",
    "Farbtonhilfsbezeichnung": "F1.14.81",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "217",
    "Bcolor": "181",
    "Y": 72,
    "L": 87.9978109356593,
    "a": 4.16148173998898,
    "b": 20.4493519864087,
    "C": 20.868491247244,
    "h": 1.37003584561449,
    "CMY_C": 0.0451168,
    "CMY_M": 0.1492868,
    "CMY_Y": 0.2912998,
    "CMYK_C": 0,
    "CMYK_M": 0.1090918,
    "CMYK_Y": 0.2578147,
    "CMYK_K": 0.0451168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02627",
    "Farbtonhilfsbezeichnung": "F1.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "222",
    "Bcolor": "204",
    "Y": 75,
    "L": 89.206952189727,
    "a": 2.29859063157284,
    "b": 10.0722066271172,
    "C": 10.3311599170131,
    "h": 1.34642750252731,
    "CMY_C": 0.07194278,
    "CMY_M": 0.1288449,
    "CMY_Y": 0.201853,
    "CMYK_C": 0,
    "CMYK_M": 0.06131314,
    "CMYK_Y": 0.1399808,
    "CMYK_K": 0.07194278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02629",
    "Farbtonhilfsbezeichnung": "F0.21.78",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "206",
    "Bcolor": "158",
    "Y": 65,
    "L": 84.4554337777424,
    "a": 5.85299023550406,
    "b": 27.4537284840222,
    "C": 28.0707089752168,
    "h": 1.36074631367545,
    "CMY_C": 0.05851381,
    "CMY_M": 0.1938661,
    "CMY_Y": 0.3802085,
    "CMYK_C": 0,
    "CMYK_M": 0.1437646,
    "CMYK_Y": 0.3416882,
    "CMYK_K": 0.05851381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02630",
    "Farbtonhilfsbezeichnung": "F0.21.69",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "183",
    "Bcolor": "135",
    "Y": 50,
    "L": 76.3636152895448,
    "a": 6.57536050794583,
    "b": 28.2306295821975,
    "C": 28.9862693773569,
    "h": 1.34196037676411,
    "CMY_C": 0.1442276,
    "CMY_M": 0.2831956,
    "CMY_Y": 0.4689963,
    "CMYK_C": 0,
    "CMYK_M": 0.1623889,
    "CMYK_Y": 0.3795037,
    "CMYK_K": 0.1442276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02631",
    "Farbtonhilfsbezeichnung": "F0.12.47",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "139",
    "Bcolor": "116",
    "Y": 27,
    "L": 58.739708195258,
    "a": 3.06282517382128,
    "b": 13.8255472216927,
    "C": 14.1607434135588,
    "h": 1.352783560226,
    "CMY_C": 0.3882087,
    "CMY_M": 0.4556701,
    "CMY_Y": 0.5437076,
    "CMYK_C": 0,
    "CMYK_M": 0.1102687,
    "CMYK_Y": 0.2541698,
    "CMYK_K": 0.3882087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02632",
    "Farbtonhilfsbezeichnung": "E9.24.73",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "196",
    "Bcolor": "141",
    "Y": 59,
    "L": 81.3835168148486,
    "a": 7.68574927264326,
    "b": 32.2508175323539,
    "C": 33.1539737194069,
    "h": 1.33684824457235,
    "CMY_C": 0.07241692,
    "CMY_M": 0.2327785,
    "CMY_Y": 0.4472165,
    "CMYK_C": 0,
    "CMYK_M": 0.1728811,
    "CMYK_Y": 0.4040604,
    "CMYK_K": 0.07241692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02633",
    "Farbtonhilfsbezeichnung": "E8.39.62",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "156",
    "Bcolor": "94",
    "Y": 37,
    "L": 67.6388331638906,
    "a": 10.5781457639649,
    "b": 38.5612754784127,
    "C": 39.9858616804205,
    "h": 1.30306201416007,
    "CMY_C": 0.2016738,
    "CMY_M": 0.3868663,
    "CMY_Y": 0.6308241,
    "CMYK_C": 0,
    "CMYK_M": 0.231976,
    "CMYK_Y": 0.5375626,
    "CMYK_K": 0.2016738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02634",
    "Farbtonhilfsbezeichnung": "E8.33.65",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "172",
    "Bcolor": "104",
    "Y": 46,
    "L": 73.557008317904,
    "a": 11.3009655869887,
    "b": 41.1245824087517,
    "C": 42.6490691749834,
    "h": 1.30261763872479,
    "CMY_C": 0.1259223,
    "CMY_M": 0.327165,
    "CMY_Y": 0.591732,
    "CMYK_C": 0,
    "CMYK_M": 0.2302343,
    "CMYK_Y": 0.5329157,
    "CMYK_K": 0.1259223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02635",
    "Farbtonhilfsbezeichnung": "E8.21.70",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "182",
    "Bcolor": "142",
    "Y": 50,
    "L": 76.1207773284846,
    "a": 6.67806219169259,
    "b": 24.4959890863852,
    "C": 25.3899585654726,
    "h": 1.30464543189354,
    "CMY_C": 0.1534632,
    "CMY_M": 0.2852913,
    "CMY_Y": 0.4442581,
    "CMYK_C": 0,
    "CMYK_M": 0.1557263,
    "CMYK_Y": 0.3435112,
    "CMYK_K": 0.1534632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02636",
    "Farbtonhilfsbezeichnung": "E8.16.75",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "195",
    "Bcolor": "166",
    "Y": 57,
    "L": 80.2862483856159,
    "a": 5.7342673335139,
    "b": 17.3283352355212,
    "C": 18.2524799379923,
    "h": 1.25122066183184,
    "CMY_C": 0.1285925,
    "CMY_M": 0.2366477,
    "CMY_Y": 0.3494278,
    "CMYK_C": 0,
    "CMYK_M": 0.1240008,
    "CMYK_Y": 0.2534238,
    "CMYK_K": 0.1285925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02637",
    "Farbtonhilfsbezeichnung": "E8.14.79",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "204",
    "Bcolor": "171",
    "Y": 64,
    "L": 83.9604549148625,
    "a": 6.62812669738017,
    "b": 19.8564032002042,
    "C": 20.9334376432922,
    "h": 1.24862314375736,
    "CMY_C": 0.07520135,
    "CMY_M": 0.1995356,
    "CMY_Y": 0.3291835,
    "CMYK_C": 0,
    "CMYK_M": 0.1344447,
    "CMYK_Y": 0.2746351,
    "CMYK_K": 0.07520135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02638",
    "Farbtonhilfsbezeichnung": "E8.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "210",
    "Bcolor": "186",
    "Y": 68,
    "L": 85.8333909517141,
    "a": 5.89334354157783,
    "b": 14.5207350004854,
    "C": 15.6710957834281,
    "h": 1.18525093696643,
    "CMY_C": 0.07192481,
    "CMY_M": 0.175956,
    "CMY_Y": 0.2703119,
    "CMYK_C": 0,
    "CMYK_M": 0.1120935,
    "CMYK_Y": 0.2137619,
    "CMYK_K": 0.07192481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02639",
    "Farbtonhilfsbezeichnung": "E8.06.70",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "190",
    "Bcolor": "181",
    "Y": 52,
    "L": 77.1560008943863,
    "a": 0.68797970310974,
    "b": 4.54288976193071,
    "C": 4.59468861414415,
    "h": 1.42049740107405,
    "CMY_C": 0.2332084,
    "CMY_M": 0.2552341,
    "CMY_Y": 0.2910709,
    "CMYK_C": 0,
    "CMYK_M": 0.02872453,
    "CMYK_Y": 0.07546055,
    "CMYK_K": 0.2332084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02640",
    "Farbtonhilfsbezeichnung": "E7.40.56",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "135",
    "Bcolor": "64",
    "Y": 29,
    "L": 60.6288824665941,
    "a": 14.1588538560486,
    "b": 45.5038970849646,
    "C": 47.6558264269543,
    "h": 1.26913548687759,
    "CMY_C": 0.2529377,
    "CMY_M": 0.4689026,
    "CMY_Y": 0.7507312,
    "CMYK_C": 0,
    "CMYK_M": 0.2890855,
    "CMYK_Y": 0.6663347,
    "CMYK_K": 0.2529377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02641",
    "Farbtonhilfsbezeichnung": "E7.18.76",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "202",
    "Bcolor": "160",
    "Y": 63,
    "L": 83.511694368299,
    "a": 7.25980834090123,
    "b": 25.0550403226086,
    "C": 26.0856255956065,
    "h": 1.28876546097631,
    "CMY_C": 0.06472748,
    "CMY_M": 0.2071558,
    "CMY_Y": 0.3720103,
    "CMYK_C": 0,
    "CMYK_M": 0.1522854,
    "CMYK_Y": 0.328549,
    "CMYK_K": 0.06472748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02642",
    "Farbtonhilfsbezeichnung": "E7.08.50",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "143",
    "Bcolor": "129",
    "Y": 28,
    "L": 60.1162291611348,
    "a": 2.66988235702503,
    "b": 8.79054043757113,
    "C": 9.18704919900436,
    "h": 1.27592817004031,
    "CMY_C": 0.3883362,
    "CMY_M": 0.439633,
    "CMY_Y": 0.4958337,
    "CMYK_C": 0,
    "CMYK_M": 0.0838644,
    "CMYK_Y": 0.175746,
    "CMYK_K": 0.3883362
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02643",
    "Farbtonhilfsbezeichnung": "E6.33.54",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "137",
    "Bcolor": "84",
    "Y": 29,
    "L": 60.7542284310009,
    "a": 13.2639472764563,
    "b": 35.1465619076166,
    "C": 37.5661165317702,
    "h": 1.20993230399347,
    "CMY_C": 0.2681163,
    "CMY_M": 0.4638479,
    "CMY_Y": 0.671293,
    "CMYK_C": 0,
    "CMYK_M": 0.2674353,
    "CMYK_Y": 0.5508753,
    "CMYK_K": 0.2681163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02644",
    "Farbtonhilfsbezeichnung": "E5.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "189",
    "Bcolor": "150",
    "Y": 56,
    "L": 79.4034063543351,
    "a": 9.59266840074319,
    "b": 24.9965913896777,
    "C": 26.7740334680662,
    "h": 1.20436868092806,
    "CMY_C": 0.0961959,
    "CMY_M": 0.2574936,
    "CMY_Y": 0.4136841,
    "CMYK_C": 0,
    "CMYK_M": 0.1784654,
    "CMYK_Y": 0.3512799,
    "CMYK_K": 0.0961959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02645",
    "Farbtonhilfsbezeichnung": "E5.12.80",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "207",
    "Bcolor": "180",
    "Y": 66,
    "L": 85.1185426888983,
    "a": 7.44471199628244,
    "b": 17.0078228811444,
    "C": 18.5658227898462,
    "h": 1.15819888754844,
    "CMY_C": 0.06304453,
    "CMY_M": 0.1882575,
    "CMY_Y": 0.2959031,
    "CMYK_C": 0,
    "CMYK_M": 0.1336381,
    "CMYK_Y": 0.2485269,
    "CMYK_K": 0.06304453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02646",
    "Farbtonhilfsbezeichnung": "D3.27.51",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "142",
    "Bcolor": "112",
    "Y": 33,
    "L": 64.1580642891664,
    "a": 18.7621633309992,
    "b": 24.2631159619059,
    "C": 30.6711194617996,
    "h": 0.91256222348064,
    "CMY_C": 0.2130609,
    "CMY_M": 0.4418118,
    "CMY_Y": 0.559774,
    "CMYK_C": 0,
    "CMYK_M": 0.2906844,
    "CMYK_Y": 0.4405844,
    "CMYK_K": 0.2130609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02647",
    "Farbtonhilfsbezeichnung": "D3.24.63",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "158",
    "Bcolor": "130",
    "Y": 41,
    "L": 70.3502129140024,
    "a": 20.476700085883,
    "b": 23.0272433686328,
    "C": 30.8147559387617,
    "h": 0.84395899323139,
    "CMY_C": 0.1345089,
    "CMY_M": 0.3821209,
    "CMY_Y": 0.4893405,
    "CMYK_C": 0,
    "CMYK_M": 0.2860942,
    "CMYK_Y": 0.4099771,
    "CMYK_K": 0.1345089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02648",
    "Farbtonhilfsbezeichnung": "D3.10.76",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "200",
    "Bcolor": "188",
    "Y": 62,
    "L": 83.0619612563644,
    "a": 10.3036576489636,
    "b": 9.59333393009392,
    "C": 14.07826043378,
    "h": 0.74971326204828,
    "CMY_C": 0.08478177,
    "CMY_M": 0.2160667,
    "CMY_Y": 0.2632033,
    "CMYK_C": 0,
    "CMYK_M": 0.1434466,
    "CMYK_Y": 0.1949497,
    "CMYK_K": 0.08478177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02649",
    "Farbtonhilfsbezeichnung": "D2.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "217",
    "Bcolor": "208",
    "Y": 73,
    "L": 88.2479892278935,
    "a": 6.83730661482668,
    "b": 6.35584528900794,
    "C": 9.33517707828604,
    "h": 0.74892107514959,
    "CMY_C": 0.05991768,
    "CMY_M": 0.1496149,
    "CMY_Y": 0.1841819,
    "CMYK_C": 0,
    "CMYK_M": 0.09541416,
    "CMYK_Y": 0.1321844,
    "CMYK_K": 0.05991768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02650",
    "Farbtonhilfsbezeichnung": "D1.31.43",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "103",
    "Bcolor": "74",
    "Y": 18,
    "L": 50.0660285548822,
    "a": 23.6937678559103,
    "b": 26.8684972655787,
    "C": 35.82332732341,
    "h": 0.84810435798976,
    "CMY_C": 0.339857,
    "CMY_M": 0.5977094,
    "CMY_Y": 0.7103977,
    "CMYK_C": 0,
    "CMYK_M": 0.3906009,
    "CMYK_Y": 0.5613037,
    "CMYK_K": 0.339857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02651",
    "Farbtonhilfsbezeichnung": "D1.20.68",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "178",
    "Bcolor": "155",
    "Y": 51,
    "L": 76.9581234505516,
    "a": 17.4796160355261,
    "b": 18.8947732401115,
    "C": 25.7400355971909,
    "h": 0.82428387049183,
    "CMY_C": 0.08513024,
    "CMY_M": 0.3030669,
    "CMY_Y": 0.3932016,
    "CMYK_C": 0,
    "CMYK_M": 0.2382161,
    "CMYK_Y": 0.336738,
    "CMYK_K": 0.08513024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02653",
    "Farbtonhilfsbezeichnung": "D0.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "202",
    "Bcolor": "189",
    "Y": 64,
    "L": 83.8091329052735,
    "a": 9.58351163030691,
    "b": 10.0418856427624,
    "C": 13.8810360719417,
    "h": 0.80875008254997,
    "CMY_C": 0.08023324,
    "CMY_M": 0.206213,
    "CMY_Y": 0.2585957,
    "CMYK_C": 0,
    "CMYK_M": 0.1369692,
    "CMYK_Y": 0.1939214,
    "CMYK_K": 0.08023324
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02654",
    "Farbtonhilfsbezeichnung": "C8.30.41",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "91",
    "Bcolor": "69",
    "Y": 15,
    "L": 45.8590663137013,
    "a": 25.3320136206937,
    "b": 24.2788882295388,
    "C": 35.0881080672847,
    "h": 0.76417365003772,
    "CMY_C": 0.3809435,
    "CMY_M": 0.6431053,
    "CMY_Y": 0.7309805,
    "CMYK_C": 0,
    "CMYK_M": 0.423486,
    "CMYK_Y": 0.5654363,
    "CMYK_K": 0.3809435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02655",
    "Farbtonhilfsbezeichnung": "C8.25.41",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "114",
    "Bcolor": "93",
    "Y": 22,
    "L": 54.0833868329471,
    "a": 21.8483831099061,
    "b": 21.4600315288746,
    "C": 30.624904860873,
    "h": 0.77643128765832,
    "CMY_C": 0.3121786,
    "CMY_M": 0.5516641,
    "CMY_Y": 0.6368366,
    "CMYK_C": 0,
    "CMYK_M": 0.3481797,
    "CMYK_Y": 0.4720092,
    "CMYK_K": 0.3121786
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02656",
    "Farbtonhilfsbezeichnung": "C8.22.41",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "107",
    "Bcolor": "90",
    "Y": 18,
    "L": 50.0535411615841,
    "a": 18.2182235825499,
    "b": 17.3083038137574,
    "C": 25.129286727106,
    "h": 0.75979135783371,
    "CMY_C": 0.3826082,
    "CMY_M": 0.5803952,
    "CMY_Y": 0.6478133,
    "CMYK_C": 0,
    "CMYK_M": 0.320359,
    "CMYK_Y": 0.4295571,
    "CMYK_K": 0.3826082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02657",
    "Farbtonhilfsbezeichnung": "C8.19.55",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "147",
    "Bcolor": "129",
    "Y": 35,
    "L": 65.3819348885421,
    "a": 17.0032563082314,
    "b": 16.3153348853869,
    "C": 23.5648228829697,
    "h": 0.76475432246592,
    "CMY_C": 0.2236607,
    "CMY_M": 0.4227045,
    "CMY_Y": 0.4926831,
    "CMYK_C": 0,
    "CMYK_M": 0.2563876,
    "CMYK_Y": 0.3465268,
    "CMYK_K": 0.2236607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02658",
    "Farbtonhilfsbezeichnung": "C7.09.77",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "205",
    "Bcolor": "194",
    "Y": 66,
    "L": 84.9123055250943,
    "a": 10.3388239987419,
    "b": 9.02152584778688,
    "C": 13.7214871752025,
    "h": 0.71746184287665,
    "CMY_C": 0.06513699,
    "CMY_M": 0.1958306,
    "CMY_Y": 0.2392205,
    "CMYK_C": 0,
    "CMYK_M": 0.1397997,
    "CMYK_Y": 0.1862129,
    "CMYK_K": 0.06513699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02660",
    "Farbtonhilfsbezeichnung": "C5.10.73",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "195",
    "Bcolor": "185",
    "Y": 60,
    "L": 81.9985618692432,
    "a": 12.9641501792462,
    "b": 9.811574368885,
    "C": 16.2584187873917,
    "h": 0.64785390668601,
    "CMY_C": 0.07786455,
    "CMY_M": 0.2345441,
    "CMY_Y": 0.2756954,
    "CMYK_C": 0,
    "CMYK_M": 0.1699094,
    "CMYK_Y": 0.2145355,
    "CMYK_K": 0.07786455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02661",
    "Farbtonhilfsbezeichnung": "C3.30.32",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "75",
    "Bcolor": "63",
    "Y": 11,
    "L": 38.9237274327405,
    "a": 24.0269695947511,
    "b": 18.1173163536936,
    "C": 30.0920657278111,
    "h": 0.64608223476352,
    "CMY_C": 0.4702283,
    "CMY_M": 0.7039996,
    "CMY_Y": 0.7534493,
    "CMYK_C": 0,
    "CMYK_M": 0.4412681,
    "CMYK_Y": 0.5346096,
    "CMYK_K": 0.4702283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02663",
    "Farbtonhilfsbezeichnung": "C3.14.75",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "185",
    "Bcolor": "173",
    "Y": 57,
    "L": 80.1208142893254,
    "a": 19.7419628347352,
    "b": 13.618118463557,
    "C": 23.9832909971826,
    "h": 0.60385133465254,
    "CMY_C": 0.04527045,
    "CMY_M": 0.2740933,
    "CMY_Y": 0.3219041,
    "CMYK_C": 0,
    "CMYK_M": 0.2396729,
    "CMYK_Y": 0.2897508,
    "CMYK_K": 0.04527045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02664",
    "Farbtonhilfsbezeichnung": "C2.28.36",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "83",
    "Bcolor": "73",
    "Y": 13,
    "L": 42.1333363196764,
    "a": 24.4696702410201,
    "b": 16.6005725107212,
    "C": 29.5693045130923,
    "h": 0.59609149747626,
    "CMY_C": 0.4353572,
    "CMY_M": 0.6746656,
    "CMY_Y": 0.7149848,
    "CMYK_C": 0,
    "CMYK_M": 0.4238226,
    "CMYK_Y": 0.4952292,
    "CMYK_K": 0.4353572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02665",
    "Farbtonhilfsbezeichnung": "C2.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "134",
    "Bcolor": "122",
    "Y": 32,
    "L": 63.0840665003878,
    "a": 27.1004685583681,
    "b": 17.4231499463505,
    "C": 32.218031444148,
    "h": 0.57137455866757,
    "CMY_C": 0.1875565,
    "CMY_M": 0.4753989,
    "CMY_Y": 0.521255,
    "CMYK_C": 0,
    "CMYK_M": 0.3542921,
    "CMYK_Y": 0.4107344,
    "CMYK_K": 0.1875565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02666",
    "Farbtonhilfsbezeichnung": "C2.25.41",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "105",
    "Bcolor": "90",
    "Y": 19,
    "L": 50.9266407292101,
    "a": 24.4175258146485,
    "b": 18.4403420075251,
    "C": 30.5983950602563,
    "h": 0.64682671801558,
    "CMY_C": 0.3372393,
    "CMY_M": 0.5897481,
    "CMY_Y": 0.6458688,
    "CMYK_C": 0,
    "CMYK_M": 0.3809955,
    "CMYK_Y": 0.4656726,
    "CMYK_K": 0.3372393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02667",
    "Farbtonhilfsbezeichnung": "C1.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "218",
    "Bcolor": "212",
    "Y": 74,
    "L": 88.9266187615722,
    "a": 7.43660821129843,
    "b": 5.22762283772022,
    "C": 9.09016953757219,
    "h": 0.61270840595548,
    "CMY_C": 0.0511347,
    "CMY_M": 0.1433101,
    "CMY_Y": 0.168395,
    "CMYK_C": 0,
    "CMYK_M": 0.09714277,
    "CMYK_Y": 0.1235795,
    "CMYK_K": 0.0511347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02673",
    "Farbtonhilfsbezeichnung": "D5.23.40",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "110",
    "Bcolor": "82",
    "Y": 19,
    "L": 50.3111626717366,
    "a": 13.7832378186928,
    "b": 22.2975940553668,
    "C": 26.2137434454634,
    "h": 1.01713867296985,
    "CMY_C": 0.3972619,
    "CMY_M": 0.5671411,
    "CMY_Y": 0.6795647,
    "CMYK_C": 0,
    "CMYK_M": 0.2818457,
    "CMYK_Y": 0.4683672,
    "CMYK_K": 0.3972619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02674",
    "Farbtonhilfsbezeichnung": "Q9.12.74",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "209",
    "Bcolor": "218",
    "Y": 60,
    "L": 81.6265618229236,
    "a": -9.27860953936138,
    "b": -8.97969640954892,
    "C": 12.9123019865396,
    "h": 0.76902827508845,
    "CMY_C": 0.3171774,
    "CMY_M": 0.1807241,
    "CMY_Y": 0.146758,
    "CMYK_C": 0.1997316,
    "CMYK_M": 0.03980831,
    "CMYK_Y": 0,
    "CMYK_K": 0.146758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02675",
    "Farbtonhilfsbezeichnung": "R7.22.69",
    "Farbtonklasse": "01",
    "Rcolor": "142",
    "Gcolor": "197",
    "Bcolor": "220",
    "Y": 51,
    "L": 76.6977643334976,
    "a": -12.1440430489075,
    "b": -17.9246067468445,
    "C": 21.6510810030987,
    "h": 0.97532651105612,
    "CMY_C": 0.4443612,
    "CMY_M": 0.225711,
    "CMY_Y": 0.1367419,
    "CMYK_C": 0.3563469,
    "CMYK_M": 0.103062,
    "CMYK_Y": 0,
    "CMYK_K": 0.1367419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02676",
    "Farbtonhilfsbezeichnung": "D7.28.63",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "159",
    "Bcolor": "121",
    "Y": 42,
    "L": 70.7264308241853,
    "a": 19.1390192371529,
    "b": 28.5538390910222,
    "C": 34.3747550419795,
    "h": 0.98029751543892,
    "CMY_C": 0.1293074,
    "CMY_M": 0.3756061,
    "CMY_Y": 0.5252759,
    "CMYK_C": 0,
    "CMYK_M": 0.2828768,
    "CMYK_Y": 0.4547742,
    "CMYK_K": 0.1293074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02677",
    "Farbtonhilfsbezeichnung": "G0.10.20",
    "Farbtonklasse": "02",
    "Rcolor": "73",
    "Gcolor": "69",
    "Bcolor": "61",
    "Y": 6,
    "L": 29.4987019573041,
    "a": 0.0169502190298,
    "b": 5.4278366057174,
    "C": 5.42786307199167,
    "h": 1.56767350546451,
    "CMY_C": 0.7136725,
    "CMY_M": 0.7285141,
    "CMY_Y": 0.7623484,
    "CMYK_C": 0,
    "CMYK_M": 0.05183445,
    "CMYK_Y": 0.1700008,
    "CMYK_K": 0.7136725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02679",
    "Farbtonhilfsbezeichnung": "E9.29.79",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "141",
    "Y": 68,
    "L": 85.7161864205989,
    "a": 10.140016082271,
    "b": 38.1837191635341,
    "C": 39.5071681509616,
    "h": 1.31122869583471,
    "CMY_C": 0,
    "CMY_M": 0.1930643,
    "CMY_Y": 0.4467704,
    "CMYK_C": 0,
    "CMYK_M": 0.1930643,
    "CMYK_Y": 0.4467704,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02680",
    "Farbtonhilfsbezeichnung": "E4.21.58",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "160",
    "Bcolor": "127",
    "Y": 38,
    "L": 68.2093311536334,
    "a": 8.89631385813999,
    "b": 21.6543214287918,
    "C": 23.4105539619199,
    "h": 1.18098602148926,
    "CMY_C": 0.2327462,
    "CMY_M": 0.373668,
    "CMY_Y": 0.5033439,
    "CMYK_C": 0,
    "CMYK_M": 0.1836704,
    "CMYK_Y": 0.3526833,
    "CMYK_K": 0.2327462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02682",
    "Farbtonhilfsbezeichnung": "D9.24.72",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "181",
    "Bcolor": "143",
    "Y": 54,
    "L": 78.1844784815118,
    "a": 16.8861324481022,
    "b": 27.0728962241001,
    "C": 31.9074157370311,
    "h": 1.01311199086262,
    "CMY_C": 0.05951852,
    "CMY_M": 0.2901751,
    "CMY_Y": 0.4398384,
    "CMYK_C": 0,
    "CMYK_M": 0.2452537,
    "CMYK_Y": 0.4043885,
    "CMYK_K": 0.05951852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02683",
    "Farbtonhilfsbezeichnung": "E4.22.70",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "178",
    "Bcolor": "147",
    "Y": 48,
    "L": 74.5563873675568,
    "a": 7.34558488217774,
    "b": 19.4961044051736,
    "C": 20.8340035576148,
    "h": 1.21047308943911,
    "CMY_C": 0.176814,
    "CMY_M": 0.3025363,
    "CMY_Y": 0.4240724,
    "CMYK_C": 0,
    "CMYK_M": 0.1527266,
    "CMYK_Y": 0.3003677,
    "CMYK_K": 0.176814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02685",
    "Farbtonhilfsbezeichnung": "P9.14.77",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "224",
    "Bcolor": "229",
    "Y": 65,
    "L": 85.7134170532227,
    "a": -15.825514793396,
    "b": -8.93751335144043,
    "C": 18.1748752593994,
    "h": 209.45573425293,
    "CMY_C": 0.33481270074844,
    "CMY_M": 0.12187987565994,
    "CMY_Y": 0.10276430845261,
    "CMYK_C": 0.25862589478493,
    "CMYK_M": 0.021304955706,
    "CMYK_Y": 0,
    "CMYK_K": 0.10276430845261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02687",
    "Farbtonhilfsbezeichnung": "D6.18.66",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "169",
    "Bcolor": "142",
    "Y": 45,
    "L": 72.7304051862682,
    "a": 13.6929365113421,
    "b": 19.5041015756289,
    "C": 23.8307886687809,
    "h": 0.95869303191506,
    "CMY_C": 0.1560139,
    "CMY_M": 0.3379707,
    "CMY_Y": 0.4416013,
    "CMYK_C": 0,
    "CMYK_M": 0.2155922,
    "CMYK_Y": 0.3383793,
    "CMYK_K": 0.1560139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02688",
    "Farbtonhilfsbezeichnung": "D4.23.60",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "160",
    "Bcolor": "131",
    "Y": 41,
    "L": 70.0707822335288,
    "a": 16.190516883729,
    "b": 22.1749848744154,
    "C": 27.4565618958905,
    "h": 0.94013685162041,
    "CMY_C": 0.1653462,
    "CMY_M": 0.3731113,
    "CMY_Y": 0.4869705,
    "CMYK_C": 0,
    "CMYK_M": 0.2489237,
    "CMYK_Y": 0.3853387,
    "CMYK_K": 0.1653462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02690",
    "Farbtonhilfsbezeichnung": "YN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "225",
    "Y": 77,
    "L": 90.1919564305449,
    "a": 2.12738125332018,
    "b": 0.24158269543883,
    "C": 2.14105422530903,
    "h": 0.11307432869324,
    "CMY_C": 0.09267886,
    "CMY_M": 0.114808,
    "CMY_Y": 0.1185091,
    "CMYK_C": 0,
    "CMYK_M": 0.02438951,
    "CMYK_Y": 0.02846866,
    "CMYK_K": 0.09267886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02691",
    "Farbtonhilfsbezeichnung": "ON.00.68",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "186",
    "Bcolor": "185",
    "Y": 49,
    "L": 75.6037607470718,
    "a": -0.12136601667295,
    "b": -0.35359001412536,
    "C": 0.37383901360375,
    "h": 1.24015698242953,
    "CMY_C": 0.2716801,
    "CMY_M": 0.2687263,
    "CMY_Y": 0.2727199,
    "CMYK_C": 0.004039329,
    "CMYK_M": 0,
    "CMYK_Y": 0.005461134,
    "CMYK_K": 0.2687263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02693",
    "Farbtonhilfsbezeichnung": "K5.21.77",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "221",
    "Bcolor": "172",
    "Y": 63,
    "L": 83.4277648925781,
    "a": -25.5397796630859,
    "b": 18.111011505127,
    "C": 31.3095684051514,
    "h": 144.658416748047,
    "CMY_C": 0.33476412296295,
    "CMY_M": 0.1348540186882,
    "CMY_Y": 0.32727193832397,
    "CMYK_C": 0.23107095062733,
    "CMYK_M": 0,
    "CMYK_Y": 0.22241093218327,
    "CMYK_K": 0.1348540186882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02695",
    "Farbtonhilfsbezeichnung": "E0.34.60",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "156",
    "Bcolor": "114",
    "Y": 39,
    "L": 68.5001537024764,
    "a": 15.0793119971483,
    "b": 29.475850931077,
    "C": 33.1090839259925,
    "h": 1.09792618159307,
    "CMY_C": 0.1777911,
    "CMY_M": 0.3880146,
    "CMY_Y": 0.5548676,
    "CMYK_C": 0,
    "CMYK_M": 0.2556813,
    "CMYK_Y": 0.4586139,
    "CMYK_K": 0.1777911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02701",
    "Farbtonhilfsbezeichnung": "Q0.50.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "77",
    "Bcolor": "84",
    "Y": 6,
    "L": 28.7328389115395,
    "a": -20.2960516672607,
    "b": -11.6627792326837,
    "C": 23.4083346846894,
    "h": 0.52155835823491,
    "CMY_C": 1,
    "CMY_M": 0.6989993,
    "CMY_Y": 0.668696,
    "CMYK_C": 1,
    "CMYK_M": 0.09146651,
    "CMYK_Y": 0,
    "CMYK_K": 0.668696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02702",
    "Farbtonhilfsbezeichnung": "NN.00.83",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "228",
    "Bcolor": "224",
    "Y": 77,
    "L": 90.162029124789,
    "a": -1.30369129246732,
    "b": 0.28465040083651,
    "C": 1.33440504973247,
    "h": -0.21496817883202,
    "CMY_C": 0.1199418,
    "CMY_M": 0.1069992,
    "CMY_Y": 0.1196319,
    "CMYK_C": 0.01449334,
    "CMYK_M": 0,
    "CMYK_Y": 0.01414628,
    "CMYK_K": 0.1069992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02703",
    "Farbtonhilfsbezeichnung": "L4.07.69",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "193",
    "Bcolor": "179",
    "Y": 50,
    "L": 76.1287729820959,
    "a": -8.80970617882026,
    "b": 3.67504537969785,
    "C": 9.54551630347895,
    "h": -0.39521027471809,
    "CMY_C": 0.3207095,
    "CMY_M": 0.2450683,
    "CMY_Y": 0.2970472,
    "CMYK_C": 0.1001961,
    "CMYK_M": 0,
    "CMYK_Y": 0.06885246,
    "CMYK_K": 0.2450683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02706",
    "Farbtonhilfsbezeichnung": "U7.27.36",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "109",
    "Bcolor": "152",
    "Y": 15,
    "L": 46.2817344665527,
    "a": 4.46393156051636,
    "b": -25.781400680542,
    "C": 26.1650009155273,
    "h": 279.823120117188,
    "CMY_C": 0.64444422721863,
    "CMY_M": 0.57103204727173,
    "CMY_Y": 0.40582209825516,
    "CMYK_C": 0.40160048007965,
    "CMYK_M": 0.2780479490757,
    "CMYK_Y": 0,
    "CMYK_K": 0.40582209825516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02708",
    "Farbtonhilfsbezeichnung": "ON.00.33",
    "Farbtonklasse": "02",
    "Rcolor": "105",
    "Gcolor": "105",
    "Bcolor": "104",
    "Y": 13,
    "L": 44.2578315734863,
    "a": 0.26676613092422,
    "b": -0.25810468196869,
    "C": 0.37119024991989,
    "h": 315.945404052734,
    "CMY_C": 0.58863377571106,
    "CMY_M": 0.58989197015762,
    "CMY_Y": 0.59136080741882,
    "CMYK_C": 0,
    "CMYK_M": 0.00305857509375,
    "CMYK_Y": 0.00662920670584,
    "CMYK_K": 0.58863377571106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02709",
    "Farbtonhilfsbezeichnung": "ON.00.53",
    "Farbtonklasse": "01",
    "Rcolor": "146",
    "Gcolor": "146",
    "Bcolor": "146",
    "Y": 29,
    "L": 60.5750879672528,
    "a": 0.23424593542925,
    "b": -0.40949583437193,
    "C": 0.47176052890538,
    "h": -1.05119320422648,
    "CMY_C": 0.4267893,
    "CMY_M": 0.4272227,
    "CMY_Y": 0.4288941,
    "CMYK_C": 0,
    "CMYK_M": 0.0007559533,
    "CMYK_Y": 0.003671857,
    "CMYK_K": 0.4267893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02710",
    "Farbtonhilfsbezeichnung": "AN.02.25",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "80",
    "Bcolor": "82",
    "Y": 8,
    "L": 34.5610386092516,
    "a": 2.03192058112589,
    "b": -0.67734870442229,
    "C": 2.14184558626096,
    "h": -0.32176908829505,
    "CMY_C": 0.670027,
    "CMY_M": 0.6850097,
    "CMY_Y": 0.679633,
    "CMYK_C": 0,
    "CMYK_M": 0.04540588,
    "CMYK_Y": 0.02911154,
    "CMYK_K": 0.670027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02711",
    "Farbtonhilfsbezeichnung": "AN.02.35",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "105",
    "Bcolor": "105",
    "Y": 13,
    "L": 44.7809677124023,
    "a": 2.79165554046631,
    "b": -0.2005557268858,
    "C": 2.79885029792786,
    "h": 355.890869140625,
    "CMY_C": 0.56629520654678,
    "CMY_M": 0.59015953540802,
    "CMY_Y": 0.58640396595001,
    "CMYK_C": 0,
    "CMYK_M": 0.05502435937524,
    "CMYK_Y": 0.04636508598924,
    "CMYK_K": 0.56629520654678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02712",
    "Farbtonhilfsbezeichnung": "AN.02.55",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "150",
    "Bcolor": "150",
    "Y": 31,
    "L": 62.6057570690935,
    "a": 2.97544797534982,
    "b": 0.01761467117218,
    "C": 2.97550011437638,
    "h": 0.00591993728173,
    "CMY_C": 0.3846996,
    "CMY_M": 0.4125747,
    "CMY_Y": 0.4107204,
    "CMYK_C": 0,
    "CMYK_M": 0.04530323,
    "CMYK_Y": 0.04228957,
    "CMYK_K": 0.3846996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02713",
    "Farbtonhilfsbezeichnung": "AN.02.65",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "175",
    "Bcolor": "175",
    "Y": 44,
    "L": 72.1434230652663,
    "a": 3.52618422551909,
    "b": 0.53074615612462,
    "C": 3.56590334621408,
    "h": 0.14939428065204,
    "CMY_C": 0.278549,
    "CMY_M": 0.3142883,
    "CMY_Y": 0.315139,
    "CMYK_C": 0,
    "CMYK_M": 0.04953804,
    "CMYK_Y": 0.05071723,
    "CMYK_K": 0.278549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02714",
    "Farbtonhilfsbezeichnung": "AN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "216",
    "Bcolor": "215",
    "Y": 70,
    "L": 87.128568427084,
    "a": 3.87270451479232,
    "b": 0.96642922803009,
    "C": 3.99146911696479,
    "h": 0.24455407193429,
    "CMY_C": 0.1109884,
    "CMY_M": 0.1531508,
    "CMY_Y": 0.1572689,
    "CMYK_C": 0,
    "CMYK_M": 0.04742605,
    "CMYK_Y": 0.05205837,
    "CMYK_K": 0.1109884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02715",
    "Farbtonhilfsbezeichnung": "A0.41.28",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "63",
    "Bcolor": "92",
    "Y": 9,
    "L": 39.8702430725098,
    "a": 40.692798614502,
    "b": 1.37666833400726,
    "C": 40.7160797119141,
    "h": 1.93762075901031,
    "CMY_C": 0.39930129051208,
    "CMY_M": 0.75120890140533,
    "CMY_Y": 0.63763701915741,
    "CMYK_C": 0,
    "CMYK_M": 0.58583045005798,
    "CMYK_Y": 0.3967641890049,
    "CMYK_K": 0.39930129051208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02718",
    "Farbtonhilfsbezeichnung": "B0.35.25",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "69",
    "Bcolor": "79",
    "Y": 10.3705596923828,
    "L": 38.499439239502,
    "a": 30.8526439666748,
    "b": 7.56711339950562,
    "C": 31.7670707702637,
    "h": 13.7806930541992,
    "CMY_C": 0.4542675614357,
    "CMY_M": 0.72790849208832,
    "CMY_Y": 0.69015634059906,
    "CMYK_C": 0,
    "CMYK_M": 0.50141960382462,
    "CMYK_Y": 0.43224254250526,
    "CMYK_K": 0.4542675614357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02719",
    "Farbtonhilfsbezeichnung": "B0.39.30",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "70",
    "Bcolor": "81",
    "Y": 10,
    "L": 40.8040771484375,
    "a": 36.4182662963867,
    "b": 9.5657901763916,
    "C": 37.6536102294922,
    "h": 14.7171277999878,
    "CMY_C": 0.39854729175568,
    "CMY_M": 0.72696304321289,
    "CMY_Y": 0.6804530620575,
    "CMYK_C": 0,
    "CMYK_M": 0.54603755474091,
    "CMYK_Y": 0.46870812773705,
    "CMYK_K": 0.39854729175568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02721",
    "Farbtonhilfsbezeichnung": "B3.37.51",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "106",
    "Bcolor": "115",
    "Y": 27,
    "L": 59.1825561523438,
    "a": 47.0213737487793,
    "b": 16.3875560760498,
    "C": 49.7951965332031,
    "h": 19.2141056060791,
    "CMY_C": 0.12419205904007,
    "CMY_M": 0.58551061153412,
    "CMY_Y": 0.54844492673874,
    "CMYK_C": 0,
    "CMYK_M": 0.52673482894897,
    "CMYK_Y": 0.48441311717033,
    "CMYK_K": 0.12419205904007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02722",
    "Farbtonhilfsbezeichnung": "B3.19.67",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "166",
    "Bcolor": "166",
    "Y": 49,
    "L": 75.4713556360166,
    "a": 28.7357475789761,
    "b": 10.8499742990976,
    "C": 30.7158775100714,
    "h": 0.36102855740007,
    "CMY_C": 0.04770123,
    "CMY_M": 0.3492412,
    "CMY_Y": 0.3492614,
    "CMYK_C": 0,
    "CMYK_M": 0.3166443,
    "CMYK_Y": 0.3166655,
    "CMYK_K": 0.04770123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02725",
    "Farbtonhilfsbezeichnung": "B0.35.35",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "72",
    "Bcolor": "85",
    "Y": 13,
    "L": 42.8212311119539,
    "a": 38.5276401962309,
    "b": 10.1074425777349,
    "C": 39.8313878060059,
    "h": 0.25656110242245,
    "CMY_C": 0.3649199,
    "CMY_M": 0.7157437,
    "CMY_Y": 0.6648675,
    "CMYK_C": 0,
    "CMYK_M": 0.5524087,
    "CMYK_Y": 0.4722989,
    "CMYK_K": 0.3649199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02726",
    "Farbtonhilfsbezeichnung": "B3.25.60",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "141",
    "Bcolor": "143",
    "Y": 38,
    "L": 68.1121617698376,
    "a": 35.2629252939359,
    "b": 12.972756296723,
    "C": 37.5734787612203,
    "h": 0.35251969237621,
    "CMY_C": 0.08996823,
    "CMY_M": 0.4481521,
    "CMY_Y": 0.4386714,
    "CMYK_C": 0,
    "CMYK_M": 0.3935949,
    "CMYK_Y": 0.3831769,
    "CMYK_K": 0.08996823
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02727",
    "Farbtonhilfsbezeichnung": "B3.14.73",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "185",
    "Bcolor": "182",
    "Y": 58,
    "L": 80.5717817809973,
    "a": 21.775464650315,
    "b": 9.1076872792391,
    "C": 23.6034071335799,
    "h": 0.39614335024654,
    "CMY_C": 0.03691211,
    "CMY_M": 0.2737365,
    "CMY_Y": 0.2843424,
    "CMYK_C": 0,
    "CMYK_M": 0.2459011,
    "CMYK_Y": 0.2569135,
    "CMYK_K": 0.03691211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02731",
    "Farbtonhilfsbezeichnung": "B7.28.19",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "67",
    "Bcolor": "66",
    "Y": 5,
    "L": 32.8720092773438,
    "a": 16.293176651001,
    "b": 7.09679174423218,
    "C": 17.7716636657715,
    "h": 23.5364170074463,
    "CMY_C": 0.58773422241211,
    "CMY_M": 0.7353630065918,
    "CMY_Y": 0.74034905433655,
    "CMYK_C": 0,
    "CMYK_M": 0.35809129476547,
    "CMYK_Y": 0.37018555402756,
    "CMYK_K": 0.58773422241211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02732",
    "Farbtonhilfsbezeichnung": "B6.15.65",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "163",
    "Bcolor": "160",
    "Y": 44,
    "L": 72.3597717285156,
    "a": 21.4599781036377,
    "b": 9.26219463348389,
    "C": 23.3734664916992,
    "h": 23.3451805114746,
    "CMY_C": 0.13211894035339,
    "CMY_M": 0.3603703379631,
    "CMY_Y": 0.37164783477783,
    "CMYK_C": 0,
    "CMYK_M": 0.26299849152565,
    "CMYK_Y": 0.27599278092384,
    "CMYK_K": 0.13211894035339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02733",
    "Farbtonhilfsbezeichnung": "B3.07.78",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "205",
    "Bcolor": "203",
    "Y": 66,
    "L": 85.2008633961119,
    "a": 12.8270223593669,
    "b": 4.85090284037846,
    "C": 13.7136341271922,
    "h": 0.36155430003576,
    "CMY_C": 0.05553928,
    "CMY_M": 0.1979723,
    "CMY_Y": 0.2053271,
    "CMYK_C": 0,
    "CMYK_M": 0.1508088,
    "CMYK_Y": 0.1585961,
    "CMYK_K": 0.05553928
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02734",
    "Farbtonhilfsbezeichnung": "B1.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "98",
    "Bcolor": "99",
    "Y": 13,
    "L": 42.8821492307956,
    "a": 5.33673515561067,
    "b": 0.84549263459252,
    "C": 5.40329528309171,
    "h": 0.15712292258029,
    "CMY_C": 0.5653815,
    "CMY_M": 0.6142231,
    "CMY_Y": 0.6109273,
    "CMYK_C": 0,
    "CMYK_M": 0.1123782,
    "CMYK_Y": 0.1047949,
    "CMYK_K": 0.5653815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02735",
    "Farbtonhilfsbezeichnung": "B1.05.45",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "121",
    "Bcolor": "121",
    "Y": 20,
    "L": 52.2947507595701,
    "a": 6.72597008429393,
    "b": 1.65819035090422,
    "C": 6.92735655316288,
    "h": 0.2417153020485,
    "CMY_C": 0.4603145,
    "CMY_M": 0.5258644,
    "CMY_Y": 0.5248907,
    "CMYK_C": 0,
    "CMYK_M": 0.1214593,
    "CMYK_Y": 0.1196551,
    "CMYK_K": 0.4603145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02736",
    "Farbtonhilfsbezeichnung": "B3.05.40",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "110",
    "Bcolor": "110",
    "Y": 16,
    "L": 47.5527923336581,
    "a": 5.73552707229319,
    "b": 1.29074599490593,
    "C": 5.87897065993476,
    "h": 0.22135632849894,
    "CMY_C": 0.5155171,
    "CMY_M": 0.570136,
    "CMY_Y": 0.5689247,
    "CMYK_C": 0,
    "CMYK_M": 0.1127365,
    "CMYK_Y": 0.1102363,
    "CMYK_K": 0.5155171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02737",
    "Farbtonhilfsbezeichnung": "C0.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "199",
    "Y": 69,
    "L": 86.368155288082,
    "a": 12.8169417664682,
    "b": 8.7710622531912,
    "C": 15.5307929383658,
    "h": 0.60013395051909,
    "CMY_C": 0.03191241,
    "CMY_M": 0.1862559,
    "CMY_Y": 0.2213269,
    "CMYK_C": 0,
    "CMYK_M": 0.1594313,
    "CMYK_Y": 0.1956585,
    "CMYK_K": 0.03191241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02739",
    "Farbtonhilfsbezeichnung": "B8.35.45",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "98",
    "Bcolor": "97",
    "Y": 20.9915332794189,
    "L": 52.9402313232422,
    "a": 38.3823585510254,
    "b": 18.0033664703369,
    "C": 42.394889831543,
    "h": 25.1290740966797,
    "CMY_C": 0.24062567949295,
    "CMY_M": 0.61612218618393,
    "CMY_Y": 0.62103766202927,
    "CMYK_C": 0,
    "CMYK_M": 0.49448144435883,
    "CMYK_Y": 0.50095450878143,
    "CMYK_K": 0.24062567949295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02741",
    "Farbtonhilfsbezeichnung": "C0.28.58",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "136",
    "Bcolor": "126",
    "Y": 35,
    "L": 65.9403228759766,
    "a": 33.8957443237305,
    "b": 19.3188762664795,
    "C": 39.0146179199219,
    "h": 29.6809730529785,
    "CMY_C": 0.11271756887436,
    "CMY_M": 0.46784698963165,
    "CMY_Y": 0.50463664531708,
    "CMYK_C": 0,
    "CMYK_M": 0.40024393796921,
    "CMYK_Y": 0.44170725345612,
    "CMYK_K": 0.11271756887436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02742",
    "Farbtonhilfsbezeichnung": "C3.20.73",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "164",
    "Y": 57,
    "L": 80.3162191653761,
    "a": 25.5882983366337,
    "b": 18.6666647821301,
    "C": 31.6734176534991,
    "h": 0.63025152962283,
    "CMY_C": 0,
    "CMY_M": 0.2900394,
    "CMY_Y": 0.3551752,
    "CMYK_C": 0,
    "CMYK_M": 0.2900394,
    "CMYK_Y": 0.3551752,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02744",
    "Farbtonhilfsbezeichnung": "C2.38.50",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "111",
    "Bcolor": "96",
    "Y": 27,
    "L": 58.6201080094644,
    "a": 39.755131301156,
    "b": 26.3215903962998,
    "C": 47.6791000938853,
    "h": 0.58482946582851,
    "CMY_C": 0.1570062,
    "CMY_M": 0.5654913,
    "CMY_Y": 0.6226055,
    "CMYK_C": 0,
    "CMYK_M": 0.4845647,
    "CMYK_Y": 0.5523164,
    "CMYK_K": 0.1570062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02745",
    "Farbtonhilfsbezeichnung": "C8.34.63",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "146",
    "Bcolor": "114",
    "Y": 41,
    "L": 70.181801253531,
    "a": 34.4542777952456,
    "b": 32.2167223529922,
    "C": 47.170058909882,
    "h": 0.75184960534698,
    "CMY_C": 0.04145638,
    "CMY_M": 0.4284291,
    "CMY_Y": 0.5532302,
    "CMYK_C": 0,
    "CMYK_M": 0.403709,
    "CMYK_Y": 0.5339077,
    "CMYK_K": 0.04145638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02747",
    "Farbtonhilfsbezeichnung": "C7.26.67",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "169",
    "Bcolor": "145",
    "Y": 52,
    "L": 77.0167052234007,
    "a": 28.6965948309423,
    "b": 24.8659720205459,
    "C": 37.9711880169404,
    "h": 0.71400292905101,
    "CMY_C": 0.004313139,
    "CMY_M": 0.3362258,
    "CMY_Y": 0.4332637,
    "CMYK_C": 0,
    "CMYK_M": 0.3333505,
    "CMYK_Y": 0.4308087,
    "CMYK_K": 0.004313139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02748",
    "Farbtonhilfsbezeichnung": "C7.22.72",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "175",
    "Bcolor": "152",
    "Y": 53,
    "L": 77.8884525547552,
    "a": 24.9444110291305,
    "b": 21.9867198819003,
    "C": 33.2511577656381,
    "h": 0.72245945633793,
    "CMY_C": 0.02179981,
    "CMY_M": 0.3149879,
    "CMY_Y": 0.4043849,
    "CMYK_C": 0,
    "CMYK_M": 0.299722,
    "CMYK_Y": 0.3911113,
    "CMYK_K": 0.02179981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02749",
    "Farbtonhilfsbezeichnung": "C8.19.74",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "186",
    "Bcolor": "163",
    "Y": 59,
    "L": 81.0320930333556,
    "a": 22.0515378660853,
    "b": 20.5432563948226,
    "C": 30.1379446141042,
    "h": 0.75000295663383,
    "CMY_C": 0.005792488,
    "CMY_M": 0.2725185,
    "CMY_Y": 0.3619715,
    "CMYK_C": 0,
    "CMYK_M": 0.2682801,
    "CMYK_Y": 0.3582542,
    "CMYK_K": 0.005792488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02750",
    "Farbtonhilfsbezeichnung": "C6.22.23",
    "Farbtonklasse": "04",
    "Rcolor": "104",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 8,
    "L": 33.6640516231787,
    "a": 12.894125448677,
    "b": 9.53388581650995,
    "C": 16.0360047969708,
    "h": 0.63668098961556,
    "CMY_C": 0.5937892,
    "CMY_M": 0.7199847,
    "CMY_Y": 0.7487044,
    "CMYK_C": 0,
    "CMYK_M": 0.3106651,
    "CMYK_Y": 0.3813664,
    "CMYK_K": 0.5937892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02751",
    "Farbtonhilfsbezeichnung": "C8.25.18",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "57",
    "Bcolor": "48",
    "Y": 5,
    "L": 27.5339624162912,
    "a": 13.0183245687733,
    "b": 11.3766217320884,
    "C": 17.2888489094257,
    "h": 0.71820263940996,
    "CMY_C": 0.6506804,
    "CMY_M": 0.7756661,
    "CMY_Y": 0.812838,
    "CMYK_C": 0,
    "CMYK_M": 0.3577977,
    "CMYK_Y": 0.46421,
    "CMYK_K": 0.6506804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02752",
    "Farbtonhilfsbezeichnung": "C9.21.31",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "83",
    "Bcolor": "72",
    "Y": 11,
    "L": 39.0590450310499,
    "a": 13.845138569502,
    "b": 12.4649235815167,
    "C": 18.6296049851242,
    "h": 0.73298662040728,
    "CMY_C": 0.5296916,
    "CMY_M": 0.6731504,
    "CMY_Y": 0.7185537,
    "CMYK_C": 0,
    "CMYK_M": 0.3050313,
    "CMYK_Y": 0.4015707,
    "CMYK_K": 0.5296916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02753",
    "Farbtonhilfsbezeichnung": "C8.16.48",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "124",
    "Bcolor": "111",
    "Y": 23,
    "L": 55.3069209351581,
    "a": 13.5634733408168,
    "b": 12.4989730004871,
    "C": 18.4442981740687,
    "h": 0.74457663163695,
    "CMY_C": 0.3615975,
    "CMY_M": 0.5151445,
    "CMY_Y": 0.5664919,
    "CMYK_C": 0,
    "CMYK_M": 0.2405176,
    "CMYK_Y": 0.3209487,
    "CMYK_K": 0.3615975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02754",
    "Farbtonhilfsbezeichnung": "D3.18.43",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "114",
    "Bcolor": "98",
    "Y": 19,
    "L": 50.7671226127248,
    "a": 11.3527195133196,
    "b": 13.2877078593363,
    "C": 17.4770541139854,
    "h": 0.86376634281945,
    "CMY_C": 0.4213151,
    "CMY_M": 0.5547585,
    "CMY_Y": 0.6157397,
    "CMYK_C": 0,
    "CMYK_M": 0.2305977,
    "CMYK_Y": 0.3359766,
    "CMYK_K": 0.4213151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02755",
    "Farbtonhilfsbezeichnung": "D4.23.71",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "171",
    "Bcolor": "138",
    "Y": 49.7027320861816,
    "L": 75.8864364624023,
    "a": 21.5976848602295,
    "b": 26.4193305969238,
    "C": 34.1239051818848,
    "h": 50.7341537475586,
    "CMY_C": 0.05808615684509,
    "CMY_M": 0.32758384943008,
    "CMY_Y": 0.45750093460083,
    "CMYK_C": 0,
    "CMYK_M": 0.28611713647842,
    "CMYK_Y": 0.42404597997665,
    "CMYK_K": 0.05808615684509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02756",
    "Farbtonhilfsbezeichnung": "D3.65.43",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "94",
    "Bcolor": "55",
    "Y": 19,
    "L": 53.4509239196777,
    "a": 42.6097869873047,
    "b": 42.4880027770996,
    "C": 60.1732864379883,
    "h": 44.9180030822754,
    "CMY_C": 0.18925523757935,
    "CMY_M": 0.63244378566742,
    "CMY_Y": 0.78349006175995,
    "CMYK_C": 0,
    "CMYK_M": 0.54664373397827,
    "CMYK_Y": 0.73294931650162,
    "CMYK_K": 0.18925523757935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02757",
    "Farbtonhilfsbezeichnung": "D9.25.74",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "188",
    "Bcolor": "144",
    "Y": 59,
    "L": 81.3475725167709,
    "a": 18.9412220301348,
    "b": 30.9207911369997,
    "C": 36.2610702618224,
    "h": 1.02118369477737,
    "CMY_C": 0.003148533,
    "CMY_M": 0.2626603,
    "CMY_Y": 0.4352157,
    "CMYK_C": 0,
    "CMYK_M": 0.2603314,
    "CMYK_Y": 0.4334319,
    "CMYK_K": 0.003148533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02758",
    "Farbtonhilfsbezeichnung": "D9.40.68",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "164",
    "Bcolor": "104",
    "Y": 48,
    "L": 75.0731301514146,
    "a": 26.9590580926619,
    "b": 43.9380968438426,
    "C": 51.5494633095477,
    "h": 1.02045925185678,
    "CMY_C": 0.01147096,
    "CMY_M": 0.3553625,
    "CMY_Y": 0.5934658,
    "CMYK_C": 0,
    "CMYK_M": 0.3478821,
    "CMYK_Y": 0.5887484,
    "CMYK_K": 0.01147096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02761",
    "Farbtonhilfsbezeichnung": "E5.27.77",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "147",
    "Y": 66,
    "L": 85.1829340299671,
    "a": 13.7431261664782,
    "b": 34.4116773103104,
    "C": 37.0545145985839,
    "h": 1.19082979770034,
    "CMY_C": 0,
    "CMY_M": 0.2076324,
    "CMY_Y": 0.42291,
    "CMYK_C": 0,
    "CMYK_M": 0.2076324,
    "CMYK_Y": 0.42291,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02762",
    "Farbtonhilfsbezeichnung": "E1.22.47",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "131",
    "Bcolor": "102",
    "Y": 25,
    "L": 57.5523869688086,
    "a": 10.5078774852361,
    "b": 20.5090516521,
    "C": 23.0442333114651,
    "h": 1.09731509642971,
    "CMY_C": 0.3412204,
    "CMY_M": 0.4866591,
    "CMY_Y": 0.5995822,
    "CMYK_C": 0,
    "CMYK_M": 0.2207699,
    "CMYK_Y": 0.3921825,
    "CMYK_K": 0.3412204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02763",
    "Farbtonhilfsbezeichnung": "E6.19.80",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "212",
    "Bcolor": "169",
    "Y": 71,
    "L": 87.3351097867356,
    "a": 9.17551093389923,
    "b": 25.5885157937858,
    "C": 27.1838581041568,
    "h": 1.22649905683582,
    "CMY_C": 0.006735831,
    "CMY_M": 0.1703164,
    "CMY_Y": 0.3355358,
    "CMYK_C": 0,
    "CMYK_M": 0.1646899,
    "CMYK_Y": 0.3310298,
    "CMYK_K": 0.006735831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02764",
    "Farbtonhilfsbezeichnung": "E1.26.54",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "146",
    "Bcolor": "108",
    "Y": 33,
    "L": 64.400893754836,
    "a": 13.5324883386951,
    "b": 26.6016499254068,
    "C": 29.8458710610164,
    "h": 1.10020612641279,
    "CMY_C": 0.2377815,
    "CMY_M": 0.4258166,
    "CMY_Y": 0.5749671,
    "CMYK_C": 0,
    "CMYK_M": 0.2466945,
    "CMYK_Y": 0.4423741,
    "CMYK_K": 0.2377815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02765",
    "Farbtonhilfsbezeichnung": "E0.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "142",
    "Bcolor": "128",
    "Y": 30,
    "L": 60.2635599682823,
    "a": 5.09139154996946,
    "b": 9.15635075485966,
    "C": 10.4766896995721,
    "h": 1.06331984522583,
    "CMY_C": 0.3697317,
    "CMY_M": 0.4437547,
    "CMY_Y": 0.4964969,
    "CMYK_C": 0,
    "CMYK_M": 0.1174468,
    "CMYK_Y": 0.201129,
    "CMYK_K": 0.3697317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02766",
    "Farbtonhilfsbezeichnung": "E5.05.77",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "199",
    "Bcolor": "185",
    "Y": 58.7201347351074,
    "L": 81.1375198364258,
    "a": 3.35589742660522,
    "b": 8.26314353942871,
    "C": 8.91860866546631,
    "h": 67.8965301513672,
    "CMY_C": 0.15919804573059,
    "CMY_M": 0.21941143274307,
    "CMY_Y": 0.27515816688538,
    "CMYK_C": 0,
    "CMYK_M": 0.07161423563957,
    "CMYK_Y": 0.13791608810425,
    "CMYK_K": 0.15919804573059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02767",
    "Farbtonhilfsbezeichnung": "E5.21.49",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "137",
    "Bcolor": "106",
    "Y": 27,
    "L": 59.3894939875503,
    "a": 8.6643206211503,
    "b": 20.7229180924689,
    "C": 22.4612952897482,
    "h": 1.17478171069668,
    "CMY_C": 0.3322082,
    "CMY_M": 0.463626,
    "CMY_Y": 0.5836695,
    "CMYK_C": 0,
    "CMYK_M": 0.1967946,
    "CMYK_Y": 0.3765564,
    "CMYK_K": 0.3322082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02768",
    "Farbtonhilfsbezeichnung": "E8.25.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "149",
    "Y": 68.130485534668,
    "L": 86.0716552734375,
    "a": 11.1382293701172,
    "b": 34.8415756225586,
    "C": 36.5786209106445,
    "h": 72.2718505859375,
    "CMY_C": 0,
    "CMY_M": 0.19109332561493,
    "CMY_Y": 0.4175518155098,
    "CMYK_C": 0,
    "CMYK_M": 0.19109332561493,
    "CMYK_Y": 0.4175518155098,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02769",
    "Farbtonhilfsbezeichnung": "E9.44.73",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "184",
    "Bcolor": "93",
    "Y": 56,
    "L": 79.3623199462891,
    "a": 15.5520324707031,
    "b": 53.9623413085938,
    "C": 56.1587028503418,
    "h": 73.9229354858398,
    "CMY_C": 0.0159814953804,
    "CMY_M": 0.27854555845261,
    "CMY_Y": 0.63361632823944,
    "CMYK_C": 0,
    "CMYK_M": 0.26682838797569,
    "CMYK_Y": 0.62766587734222,
    "CMYK_K": 0.0159814953804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02770",
    "Farbtonhilfsbezeichnung": "E6.63.53",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "128",
    "Bcolor": "38",
    "Y": 28,
    "L": 60.2139097430617,
    "a": 22.7009107757176,
    "b": 56.603306924918,
    "C": 60.9857828094677,
    "h": 1.18938275329288,
    "CMY_C": 0.2017673,
    "CMY_M": 0.4979826,
    "CMY_Y": 0.849252,
    "CMYK_C": 0,
    "CMYK_M": 0.3710889,
    "CMYK_Y": 0.8111479,
    "CMYK_K": 0.2017673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02772",
    "Farbtonhilfsbezeichnung": "F5.08.62",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "169",
    "Bcolor": "152",
    "Y": 40,
    "L": 69.6706544696371,
    "a": 1.38764747186976,
    "b": 9.28736708560438,
    "C": 9.39046073890702,
    "h": 1.42248113377492,
    "CMY_C": 0.2950532,
    "CMY_M": 0.3377346,
    "CMY_Y": 0.4027468,
    "CMYK_C": 0,
    "CMYK_M": 0.06054564,
    "CMYK_Y": 0.1527684,
    "CMYK_K": 0.2950532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02773",
    "Farbtonhilfsbezeichnung": "F3.33.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "134",
    "Y": 73,
    "L": 88.3566186760142,
    "a": 8.47027803605055,
    "b": 45.2270890441178,
    "C": 46.0134240566007,
    "h": 1.3856577349932,
    "CMY_C": 0,
    "CMY_M": 0.1610736,
    "CMY_Y": 0.4742859,
    "CMYK_C": 0,
    "CMYK_M": 0.1610736,
    "CMYK_Y": 0.4742859,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02774",
    "Farbtonhilfsbezeichnung": "F5.20.80",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "217",
    "Bcolor": "165",
    "Y": 72,
    "L": 87.9423889460594,
    "a": 3.38557603317435,
    "b": 28.5855583461226,
    "C": 28.7853482007077,
    "h": 1.45290890184295,
    "CMY_C": 0.03304744,
    "CMY_M": 0.1497691,
    "CMY_Y": 0.3526823,
    "CMYK_C": 0,
    "CMYK_M": 0.1207109,
    "CMYK_Y": 0.330559,
    "CMYK_K": 0.03304744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02775",
    "Farbtonhilfsbezeichnung": "F1.22.52",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "134",
    "Bcolor": "100",
    "Y": 26,
    "L": 57.5868927092318,
    "a": 4.65263093695772,
    "b": 21.6755662155924,
    "C": 22.1692838269996,
    "h": 1.35935602136935,
    "CMY_C": 0.3745332,
    "CMY_M": 0.4725511,
    "CMY_Y": 0.608396,
    "CMYK_C": 0,
    "CMYK_M": 0.1567116,
    "CMYK_Y": 0.3739012,
    "CMYK_K": 0.3745332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02777",
    "Farbtonhilfsbezeichnung": "F8.41.46",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "128",
    "Bcolor": "70",
    "Y": 21,
    "L": 54.5669555664063,
    "a": 1.44057631492615,
    "b": 33.9520454406738,
    "C": 33.982593536377,
    "h": 87.5704116821289,
    "CMY_C": 0.40705984830856,
    "CMY_M": 0.49757522344589,
    "CMY_Y": 0.72422158718109,
    "CMYK_C": 0,
    "CMYK_M": 0.15265516936779,
    "CMYK_Y": 0.53489673137665,
    "CMYK_K": 0.40705984830856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02778",
    "Farbtonhilfsbezeichnung": "F6.55.54",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "144",
    "Bcolor": "56",
    "Y": 30,
    "L": 61.9372100830078,
    "a": 5.81990337371826,
    "b": 50.0171012878418,
    "C": 50.3545608520508,
    "h": 83.3630065917969,
    "CMY_C": 0.28152078390121,
    "CMY_M": 0.43527668714523,
    "CMY_Y": 0.77879524230957,
    "CMYK_C": 0,
    "CMYK_M": 0.21400187909603,
    "CMYK_Y": 0.69212085008621,
    "CMYK_K": 0.28152078390121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02780",
    "Farbtonhilfsbezeichnung": "G4.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "189",
    "Bcolor": "164",
    "Y": 51,
    "L": 76.7153781477035,
    "a": -1.49120376876166,
    "b": 13.0959414936969,
    "C": 13.1805679804135,
    "h": -1.45741703699077,
    "CMY_C": 0.2295208,
    "CMY_M": 0.2571081,
    "CMY_Y": 0.3573353,
    "CMYK_C": 0,
    "CMYK_M": 0.03580527,
    "CMYK_Y": 0.1658895,
    "CMYK_K": 0.2295208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02781",
    "Farbtonhilfsbezeichnung": "H3.18.60",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "167",
    "Bcolor": "129",
    "Y": 37,
    "L": 67.4842685842815,
    "a": -6.89822140521801,
    "b": 18.8887101134931,
    "C": 20.1089240962062,
    "h": -1.22064198379472,
    "CMY_C": 0.3524508,
    "CMY_M": 0.3446769,
    "CMY_Y": 0.4938629,
    "CMYK_C": 0.0118626,
    "CMYK_M": 0,
    "CMYK_Y": 0.2276525,
    "CMYK_K": 0.3446769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02782",
    "Farbtonhilfsbezeichnung": "H3.10.43",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "123",
    "Bcolor": "106",
    "Y": 19,
    "L": 50.9962487933001,
    "a": -3.54659731003754,
    "b": 8.58496436149998,
    "C": 9.28870096234077,
    "h": -1.17903332486584,
    "CMY_C": 0.5240347,
    "CMY_M": 0.5181388,
    "CMY_Y": 0.5847307,
    "CMYK_C": 0.0122357,
    "CMYK_M": 0,
    "CMYK_Y": 0.1381974,
    "CMYK_K": 0.5181388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02783",
    "Farbtonhilfsbezeichnung": "H3.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "196",
    "Bcolor": "184",
    "Y": 53,
    "L": 78.9251022338867,
    "a": -2.1823616027832,
    "b": 5.2653341293335,
    "C": 5.69968843460083,
    "h": 112.512901306152,
    "CMY_C": 0.23342883586884,
    "CMY_M": 0.22973215579987,
    "CMY_Y": 0.27787840366364,
    "CMYK_C": 0.00479921372607,
    "CMYK_M": 0,
    "CMYK_Y": 0.06250584870577,
    "CMYK_K": 0.22973215579987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02784",
    "Farbtonhilfsbezeichnung": "H9.21.83",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "234",
    "Bcolor": "173",
    "Y": 77,
    "L": 90.1713441837123,
    "a": -15.2601932695222,
    "b": 27.0749459644236,
    "C": 31.0793532365078,
    "h": -1.05755052378437,
    "CMY_C": 0.1481746,
    "CMY_M": 0.08219082,
    "CMY_Y": 0.3213522,
    "CMYK_C": 0.07189267,
    "CMYK_M": 0,
    "CMYK_Y": 0.2605786,
    "CMYK_K": 0.08219082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02785",
    "Farbtonhilfsbezeichnung": "J4.44.25",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "88",
    "Bcolor": "52",
    "Y": 8,
    "L": 34.7845041397831,
    "a": -15.8379448041235,
    "b": 17.6653447911114,
    "C": 23.7256170037221,
    "h": -0.83988806701475,
    "CMY_C": 0.7423854,
    "CMY_M": 0.6545983,
    "CMY_Y": 0.7945505,
    "CMYK_C": 0.2541597,
    "CMYK_M": 0,
    "CMYK_Y": 0.4051868,
    "CMYK_K": 0.6545983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02787",
    "Farbtonhilfsbezeichnung": "J1.21.83",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "231",
    "Bcolor": "174",
    "Y": 74,
    "L": 88.8565699975677,
    "a": -16.2889338247471,
    "b": 24.9362533196135,
    "C": 29.7849978137808,
    "h": -0.9921587232107,
    "CMY_C": 0.176669,
    "CMY_M": 0.09429491,
    "CMY_Y": 0.3193252,
    "CMYK_C": 0.09095023,
    "CMYK_M": 0,
    "CMYK_Y": 0.2484587,
    "CMYK_K": 0.09429491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02788",
    "Farbtonhilfsbezeichnung": "J6.51.43",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "138",
    "Bcolor": "71",
    "Y": 19,
    "L": 52.7004432678223,
    "a": -28.9506301879883,
    "b": 30.3834552764893,
    "C": 41.9677658081055,
    "h": 133.616668701172,
    "CMY_C": 0.64455735683441,
    "CMY_M": 0.4596426486969,
    "CMY_Y": 0.72266918420792,
    "CMYK_C": 0.34220817685127,
    "CMYK_M": 0,
    "CMYK_Y": 0.48676404356956,
    "CMYK_K": 0.4596426486969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02789",
    "Farbtonhilfsbezeichnung": "J6.45.53",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "160",
    "Bcolor": "81",
    "Y": 29,
    "L": 61.0206570654943,
    "a": -30.1605657119466,
    "b": 35.6537000228686,
    "C": 46.6995294343032,
    "h": -0.86866934704238,
    "CMY_C": 0.5575832,
    "CMY_M": 0.3720858,
    "CMY_Y": 0.6831521,
    "CMYK_C": 0.2954184,
    "CMYK_M": 0,
    "CMYK_Y": 0.4953963,
    "CMYK_K": 0.3720858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02790",
    "Farbtonhilfsbezeichnung": "J6.39.63",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "188",
    "Bcolor": "106",
    "Y": 42,
    "L": 71.0636953860264,
    "a": -30.6855975812865,
    "b": 35.7908061937034,
    "C": 47.1443284703037,
    "h": -0.86204502072515,
    "CMY_C": 0.457153,
    "CMY_M": 0.2641854,
    "CMY_Y": 0.5860586,
    "CMYK_C": 0.2622503,
    "CMYK_M": 0,
    "CMYK_Y": 0.4374379,
    "CMYK_K": 0.2641854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02793",
    "Farbtonhilfsbezeichnung": "K0.19.78",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "225",
    "Bcolor": "180",
    "Y": 69,
    "L": 86.4181518554688,
    "a": -18.1803798675537,
    "b": 17.8703556060791,
    "C": 25.4926624298096,
    "h": 135.492721557617,
    "CMY_C": 0.23974585533142,
    "CMY_M": 0.11606884002686,
    "CMY_Y": 0.29270958900452,
    "CMYK_C": 0.13991701602936,
    "CMYK_M": 0,
    "CMYK_Y": 0.19983541965485,
    "CMYK_K": 0.11606884002686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02794",
    "Farbtonhilfsbezeichnung": "K4.54.23",
    "Farbtonklasse": "04",
    "Rcolor": "37",
    "Gcolor": "84",
    "Bcolor": "43",
    "Y": 7,
    "L": 31.5651131263376,
    "a": -25.8249683482605,
    "b": 18.8435472467608,
    "C": 31.9688639621361,
    "h": -0.63035846764585,
    "CMY_C": 0.8544403,
    "CMY_M": 0.6709811,
    "CMY_Y": 0.8316071,
    "CMYK_C": 0.5575947,
    "CMYK_M": 0,
    "CMYK_Y": 0.4881969,
    "CMYK_K": 0.6709811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02795",
    "Farbtonhilfsbezeichnung": "K7.60.30",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "102",
    "Bcolor": "51",
    "Y": 10,
    "L": 37.564733241615,
    "a": -35.1563275670538,
    "b": 21.6104557519418,
    "C": 41.2671681341066,
    "h": -0.55115539880187,
    "CMY_C": 0.9049909,
    "CMY_M": 0.6018689,
    "CMY_Y": 0.7994555,
    "CMYK_C": 0.7613622,
    "CMYK_M": 0,
    "CMYK_Y": 0.4962852,
    "CMYK_K": 0.6018689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02796",
    "Farbtonhilfsbezeichnung": "K7.58.44",
    "Farbtonklasse": "04",
    "Rcolor": "26",
    "Gcolor": "138",
    "Bcolor": "66",
    "Y": 19,
    "L": 50.3792726894733,
    "a": -46.2275537335452,
    "b": 29.5496887231176,
    "C": 54.8650237202259,
    "h": -0.56876136397603,
    "CMY_C": 0.8978846,
    "CMY_M": 0.4595149,
    "CMY_Y": 0.7414668,
    "CMYK_C": 0.8110672,
    "CMYK_M": 0,
    "CMYK_Y": 0.5216644,
    "CMYK_K": 0.4595149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02798",
    "Farbtonhilfsbezeichnung": "K2.21.72",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "208",
    "Bcolor": "160",
    "Y": 56,
    "L": 79.6140845347771,
    "a": -22.3934741028682,
    "b": 18.7786612770473,
    "C": 29.225088567084,
    "h": -0.69782516380352,
    "CMY_C": 0.3455957,
    "CMY_M": 0.1831794,
    "CMY_Y": 0.3716401,
    "CMYK_C": 0.1988396,
    "CMYK_M": 0,
    "CMYK_Y": 0.2307247,
    "CMYK_K": 0.1831794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02799",
    "Farbtonhilfsbezeichnung": "K0.09.85",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "238",
    "Bcolor": "210",
    "Y": 81.6559295654297,
    "L": 92.4227905273438,
    "a": -9.87402820587158,
    "b": 11.3219146728516,
    "C": 15.0227222442627,
    "h": 131.092224121094,
    "CMY_C": 0.12663608789444,
    "CMY_M": 0.06508189439774,
    "CMY_Y": 0.17803931236267,
    "CMYK_C": 0.06583912670612,
    "CMYK_M": 0,
    "CMYK_Y": 0.1208206564188,
    "CMYK_K": 0.06508189439774
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02800",
    "Farbtonhilfsbezeichnung": "K2.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "219",
    "Bcolor": "195",
    "Y": 67,
    "L": 85.4908045930116,
    "a": -9.85622319655444,
    "b": 9.17123601602055,
    "C": 13.4631610612757,
    "h": -0.74941377423238,
    "CMY_C": 0.2098084,
    "CMY_M": 0.1418904,
    "CMY_Y": 0.237167,
    "CMYK_C": 0.07914843,
    "CMYK_M": 0,
    "CMYK_Y": 0.1110308,
    "CMYK_K": 0.1418904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02801",
    "Farbtonhilfsbezeichnung": "K3.06.34",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "105",
    "Bcolor": "99",
    "Y": 12,
    "L": 43.9860954284668,
    "a": -2.83333230018616,
    "b": 2.24243402481079,
    "C": 3.61334776878357,
    "h": 141.640228271484,
    "CMY_C": 0.60526013374329,
    "CMY_M": 0.58686453104019,
    "CMY_Y": 0.61036825180054,
    "CMYK_C": 0.04452680423856,
    "CMYK_M": 0,
    "CMYK_Y": 0.05689107626677,
    "CMYK_K": 0.58686453104019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02802",
    "Farbtonhilfsbezeichnung": "K2.05.43",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "123",
    "Bcolor": "116",
    "Y": 19,
    "L": 50.9115674120373,
    "a": -3.79186221074207,
    "b": 2.33528248518562,
    "C": 4.45328679863182,
    "h": -0.55200473033082,
    "CMY_C": 0.5445254,
    "CMY_M": 0.5170552,
    "CMY_Y": 0.5442858,
    "CMYK_C": 0.05688071,
    "CMYK_M": 0,
    "CMYK_Y": 0.05638466,
    "CMYK_K": 0.5170552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02803",
    "Farbtonhilfsbezeichnung": "L3.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "233",
    "Bcolor": "212",
    "Y": 75,
    "L": 89.5182028778715,
    "a": -13.7259659662365,
    "b": 5.88347388875365,
    "C": 14.9337673313176,
    "h": -0.40494822873053,
    "CMY_C": 0.2096931,
    "CMY_M": 0.08793263,
    "CMY_Y": 0.1698347,
    "CMYK_C": 0.1334995,
    "CMYK_M": 0,
    "CMYK_Y": 0.08979823,
    "CMYK_K": 0.08793263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02804",
    "Farbtonhilfsbezeichnung": "K8.23.45",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "132",
    "Bcolor": "102",
    "Y": 20,
    "L": 51.8874720641587,
    "a": -18.719158190288,
    "b": 11.5795390550298,
    "C": 22.0111927909413,
    "h": -0.55397871701239,
    "CMY_C": 0.6212229,
    "CMY_M": 0.4815574,
    "CMY_Y": 0.5982238,
    "CMYK_C": 0.2693943,
    "CMYK_M": 0,
    "CMYK_Y": 0.2250324,
    "CMYK_K": 0.4815574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02806",
    "Farbtonhilfsbezeichnung": "L6.59.23",
    "Farbtonklasse": "04",
    "Rcolor": "10",
    "Gcolor": "88",
    "Bcolor": "58",
    "Y": 7,
    "L": 32.5584403748857,
    "a": -30.0329788208795,
    "b": 10.7811097588902,
    "C": 31.9094366056287,
    "h": -0.34464850838652,
    "CMY_C": 0.9625378,
    "CMY_M": 0.6551916,
    "CMY_Y": 0.7720588,
    "CMYK_C": 0.8913534,
    "CMYK_M": 0,
    "CMYK_Y": 0.3389337,
    "CMYK_K": 0.6551916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02808",
    "Farbtonhilfsbezeichnung": "L5.60.43",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "140",
    "Bcolor": "87",
    "Y": 19,
    "L": 50.6991591058074,
    "a": -48.4916662202191,
    "b": 18.2537400788055,
    "C": 51.813518696164,
    "h": -0.3600241794433,
    "CMY_C": 1,
    "CMY_M": 0.4518862,
    "CMY_Y": 0.6587272,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3773687,
    "CMYK_K": 0.4518862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02809",
    "Farbtonhilfsbezeichnung": "L5.47.52",
    "Farbtonklasse": "03",
    "Rcolor": "26",
    "Gcolor": "161",
    "Bcolor": "107",
    "Y": 27,
    "L": 58.7017855209163,
    "a": -46.7513675313873,
    "b": 17.8352416786375,
    "C": 50.037847793348,
    "h": -0.36444952429739,
    "CMY_C": 0.8963038,
    "CMY_M": 0.3694794,
    "CMY_Y": 0.5790604,
    "CMYK_C": 0.8355387,
    "CMYK_M": 0,
    "CMYK_Y": 0.3323936,
    "CMYK_K": 0.3694794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02810",
    "Farbtonhilfsbezeichnung": "L4.32.66",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "196",
    "Bcolor": "148",
    "Y": 44,
    "L": 72.4504939952409,
    "a": -38.3020090339439,
    "b": 14.6786118469592,
    "C": 41.018356156604,
    "h": -0.36596944430245,
    "CMY_C": 0.5971639,
    "CMY_M": 0.2327861,
    "CMY_Y": 0.4181607,
    "CMYK_C": 0.4749364,
    "CMYK_M": 0,
    "CMYK_Y": 0.2416204,
    "CMYK_K": 0.2327861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02811",
    "Farbtonhilfsbezeichnung": "L5.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "214",
    "Bcolor": "179",
    "Y": 57,
    "L": 80.9756927490234,
    "a": -26.3131523132324,
    "b": 10.4927434921265,
    "C": 28.3280715942383,
    "h": 158.259643554688,
    "CMY_C": 0.39746010303497,
    "CMY_M": 0.15893453359604,
    "CMY_Y": 0.29734170436859,
    "CMYK_C": 0.2835992872715,
    "CMYK_M": 0,
    "CMYK_Y": 0.16456170380116,
    "CMYK_K": 0.15893453359604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02812",
    "Farbtonhilfsbezeichnung": "L9.13.79",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "226",
    "Bcolor": "203",
    "Y": 68,
    "L": 86.1914392602457,
    "a": -18.3905785278912,
    "b": 5.62695537619999,
    "C": 19.2321607053466,
    "h": -0.29692432546787,
    "CMY_C": 0.2878404,
    "CMY_M": 0.1153133,
    "CMY_Y": 0.2047506,
    "CMYK_C": 0.195015,
    "CMYK_M": 0,
    "CMYK_Y": 0.1010949,
    "CMYK_K": 0.1153133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02815",
    "Farbtonhilfsbezeichnung": "L9.17.79",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "230",
    "Bcolor": "203",
    "Y": 70,
    "L": 87.0180649040764,
    "a": -23.342673673364,
    "b": 6.41832211091908,
    "C": 24.208991572155,
    "h": -0.26832984163234,
    "CMY_C": 0.3215671,
    "CMY_M": 0.09638906,
    "CMY_Y": 0.2022894,
    "CMYK_C": 0.249198,
    "CMYK_M": 0,
    "CMYK_Y": 0.1171969,
    "CMYK_K": 0.09638906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02817",
    "Farbtonhilfsbezeichnung": "M5.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "233",
    "Bcolor": "218",
    "Y": 76,
    "L": 89.8512007016253,
    "a": -12.6674374221087,
    "b": 2.90226814881946,
    "C": 12.9956581691999,
    "h": -0.22522530662253,
    "CMY_C": 0.2082342,
    "CMY_M": 0.08568771,
    "CMY_Y": 0.143963,
    "CMYK_C": 0.1340314,
    "CMYK_M": 0,
    "CMYK_Y": 0.06373671,
    "CMYK_K": 0.08568771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02819",
    "Farbtonhilfsbezeichnung": "N1.37.55",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "167",
    "Bcolor": "152",
    "Y": 30,
    "L": 62.06809061646,
    "a": -37.1097444912349,
    "b": -2.33179031523265,
    "C": 37.1829313298314,
    "h": 0.06275248664182,
    "CMY_C": 0.8512372,
    "CMY_M": 0.3432342,
    "CMY_Y": 0.4046335,
    "CMYK_C": 0.7734919,
    "CMYK_M": 0,
    "CMYK_Y": 0.09348735,
    "CMYK_K": 0.3432342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02820",
    "Farbtonhilfsbezeichnung": "N1.21.65",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "191",
    "Bcolor": "179",
    "Y": 45,
    "L": 72.7264556884766,
    "a": -23.6584339141846,
    "b": -1.41972362995148,
    "C": 23.7009944915771,
    "h": 183.434158325195,
    "CMY_C": 0.51416212320328,
    "CMY_M": 0.25130927562714,
    "CMY_Y": 0.29856556653976,
    "CMYK_C": 0.35108333826065,
    "CMYK_M": 0,
    "CMYK_Y": 0.06311857700348,
    "CMYK_K": 0.25130927562714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02821",
    "Farbtonhilfsbezeichnung": "N0.12.78",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "221",
    "Bcolor": "208",
    "Y": 66,
    "L": 84.8180541992188,
    "a": -15.7020826339722,
    "b": 0.79246181249619,
    "C": 15.7220668792725,
    "h": 177.110824584961,
    "CMY_C": 0.29817265272141,
    "CMY_M": 0.13481253385544,
    "CMY_Y": 0.18383151292801,
    "CMYK_C": 0.18881471455097,
    "CMYK_M": 0,
    "CMYK_Y": 0.0566570609808,
    "CMYK_K": 0.13481253385544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02825",
    "Farbtonhilfsbezeichnung": "M8.06.34",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "100",
    "Bcolor": "98",
    "Y": 12,
    "L": 41.4665366152229,
    "a": -5.17927282131669,
    "b": -0.65684107604069,
    "C": 5.22075733556005,
    "h": 0.12614767383181,
    "CMY_C": 0.6552936,
    "CMY_M": 0.6059267,
    "CMY_Y": 0.6160691,
    "CMYK_C": 0.1252734,
    "CMYK_M": 0,
    "CMYK_Y": 0.02573724,
    "CMYK_K": 0.6059267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02826",
    "Farbtonhilfsbezeichnung": "N0.05.44",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "127",
    "Bcolor": "124",
    "Y": 20,
    "L": 52.3134603603871,
    "a": -4.8620903992615,
    "b": -0.2775167324994,
    "C": 4.87000396174459,
    "h": 0.0570157951271,
    "CMY_C": 0.5471896,
    "CMY_M": 0.5002774,
    "CMY_Y": 0.5133543,
    "CMYK_C": 0.09387643,
    "CMYK_M": 0,
    "CMYK_Y": 0.02616831,
    "CMYK_K": 0.5002774
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02828",
    "Farbtonhilfsbezeichnung": "P0.03.55",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "153",
    "Bcolor": "152",
    "Y": 31,
    "L": 62.4653782149405,
    "a": -2.8992917821154,
    "b": -1.3003572318995,
    "C": 3.1775496484548,
    "h": 0.42161296566999,
    "CMY_C": 0.433816,
    "CMY_M": 0.4007618,
    "CMY_Y": 0.4038726,
    "CMYK_C": 0.05516032,
    "CMYK_M": 0,
    "CMYK_Y": 0.00519129,
    "CMYK_K": 0.4007618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02829",
    "Farbtonhilfsbezeichnung": "P4.48.27",
    "Farbtonklasse": "04",
    "Rcolor": "4",
    "Gcolor": "103",
    "Bcolor": "107",
    "Y": 9,
    "L": 39.2529792785645,
    "a": -22.8616428375244,
    "b": -9.9304838180542,
    "C": 24.925271987915,
    "h": 203.47883605957,
    "CMY_C": 0.98284965753555,
    "CMY_M": 0.59577131271362,
    "CMY_Y": 0.58015149831772,
    "CMYK_C": 0.95915108919144,
    "CMYK_M": 0.0372034534812,
    "CMYK_Y": 0,
    "CMYK_K": 0.58015149831772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02830",
    "Farbtonhilfsbezeichnung": "P2.46.33",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "117",
    "Y": 13,
    "L": 42.4389138450689,
    "a": -28.7366771178113,
    "b": -11.1333594924638,
    "C": 30.8179867181776,
    "h": 0.36962066288444,
    "CMY_C": 1,
    "CMY_M": 0.5558057,
    "CMY_Y": 0.5419938,
    "CMYK_C": 1,
    "CMYK_M": 0.03015643,
    "CMYK_Y": 0,
    "CMYK_K": 0.5419938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02831",
    "Farbtonhilfsbezeichnung": "P3.40.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "140",
    "Y": 19,
    "L": 50.9858419900635,
    "a": -31.617718932126,
    "b": -12.3638313546535,
    "C": 33.9491454419287,
    "h": 0.37275951269747,
    "CMY_C": 1,
    "CMY_M": 0.4649377,
    "CMY_Y": 0.4490901,
    "CMYK_C": 1,
    "CMYK_M": 0.02876626,
    "CMYK_Y": 0,
    "CMYK_K": 0.4490901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02832",
    "Farbtonhilfsbezeichnung": "P2.32.63",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "192",
    "Bcolor": "192",
    "Y": 43,
    "L": 71.6187973022461,
    "a": -31.9918403625488,
    "b": -10.3727588653565,
    "C": 33.6314125061035,
    "h": 197.964324951172,
    "CMY_C": 0.70367425680161,
    "CMY_M": 0.24634808301926,
    "CMY_Y": 0.24772787094116,
    "CMYK_C": 0.60681354999542,
    "CMYK_M": 0,
    "CMYK_Y": 0.00183080264833,
    "CMYK_K": 0.24634808301926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02833",
    "Farbtonhilfsbezeichnung": "P2.20.73",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "214",
    "Bcolor": "213",
    "Y": 59,
    "L": 80.7272491455078,
    "a": -23.5520095825195,
    "b": -8.15788173675537,
    "C": 24.9248504638672,
    "h": 199.104919433594,
    "CMY_C": 0.4658870100975,
    "CMY_M": 0.16212946176529,
    "CMY_Y": 0.1641731262207,
    "CMYK_C": 0.36253517866135,
    "CMYK_M": 0,
    "CMYK_Y": 0.00243911729194,
    "CMYK_K": 0.16212946176529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02834",
    "Farbtonhilfsbezeichnung": "P2.11.80",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "228",
    "Bcolor": "226",
    "Y": 72,
    "L": 87.7635135387839,
    "a": -13.3130856499025,
    "b": -4.45971676855941,
    "C": 14.04020381538,
    "h": 0.3232385303899,
    "CMY_C": 0.2673211,
    "CMY_M": 0.105605,
    "CMY_Y": 0.112682,
    "CMYK_C": 0.1808105,
    "CMYK_M": 0,
    "CMYK_Y": 0.007912596,
    "CMYK_K": 0.105605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02835",
    "Farbtonhilfsbezeichnung": "P9.38.49",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "154",
    "Bcolor": "165",
    "Y": 26,
    "L": 58.2495574951172,
    "a": -27.9456787109375,
    "b": -15.6598453521729,
    "C": 32.0342254638672,
    "h": 209.264846801758,
    "CMY_C": 0.89334827661514,
    "CMY_M": 0.39426511526108,
    "CMY_Y": 0.35196244716644,
    "CMYK_C": 0.8354235291481,
    "CMYK_M": 0.06527811288834,
    "CMYK_Y": 0,
    "CMYK_K": 0.35196244716644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02838",
    "Farbtonhilfsbezeichnung": "Q5.05.44",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "125",
    "Bcolor": "127",
    "Y": 20,
    "L": 51.65147458445,
    "a": -3.57824805113355,
    "b": -3.12797907941649,
    "C": 4.75269526024005,
    "h": 0.71835686321602,
    "CMY_C": 0.5539367,
    "CMY_M": 0.5087354,
    "CMY_Y": 0.5009086,
    "CMYK_C": 0.1062492,
    "CMYK_M": 0.01568207,
    "CMYK_Y": 0,
    "CMYK_K": 0.5009086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02839",
    "Farbtonhilfsbezeichnung": "Q9.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "120",
    "Bcolor": "125",
    "Y": 18,
    "L": 49.3123849415711,
    "a": -4.98317067858317,
    "b": -5.51255499521903,
    "C": 7.43103307671318,
    "h": 0.83579354329439,
    "CMY_C": 0.5966996,
    "CMY_M": 0.5285454,
    "CMY_Y": 0.5085905,
    "CMYK_C": 0.1792988,
    "CMYK_M": 0.04060761,
    "CMYK_Y": 0,
    "CMYK_K": 0.5085905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02840",
    "Farbtonhilfsbezeichnung": "Q9.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "141",
    "Bcolor": "148",
    "Y": 25,
    "L": 57.4002610232895,
    "a": -5.75522367327935,
    "b": -6.62189540662941,
    "C": 8.77337439676518,
    "h": 0.85530614625561,
    "CMY_C": 0.5277175,
    "CMY_M": 0.4453978,
    "CMY_Y": 0.4198777,
    "CMYK_C": 0.1858914,
    "CMYK_M": 0.04399079,
    "CMYK_Y": 0,
    "CMYK_K": 0.4198777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02842",
    "Farbtonhilfsbezeichnung": "R0.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "171",
    "Bcolor": "186",
    "Y": 37,
    "L": 67.1157963178901,
    "a": -12.8740232150162,
    "b": -13.7971379358409,
    "C": 18.8706515245605,
    "h": 0.81999532153073,
    "CMY_C": 0.5293004,
    "CMY_M": 0.3282457,
    "CMY_Y": 0.2698897,
    "CMYK_C": 0.3553035,
    "CMYK_M": 0.07992774,
    "CMYK_Y": 0,
    "CMYK_K": 0.2698897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02843",
    "Farbtonhilfsbezeichnung": "R0.28.19",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "74",
    "Bcolor": "83",
    "Y": 6,
    "L": 29.4784996573727,
    "a": -8.32285064409818,
    "b": -9.67437468508988,
    "C": 12.761793306251,
    "h": 0.86035371697991,
    "CMY_C": 0.831166,
    "CMY_M": 0.7103021,
    "CMY_Y": 0.6728685,
    "CMYK_C": 0.4838954,
    "CMYK_M": 0.1144297,
    "CMYK_Y": 0,
    "CMYK_K": 0.6728685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02844",
    "Farbtonhilfsbezeichnung": "R1.35.23",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "83",
    "Bcolor": "97",
    "Y": 7,
    "L": 32.4983133979013,
    "a": -12.1557124483747,
    "b": -13.8204255058255,
    "C": 18.405583562866,
    "h": 0.84939688568878,
    "CMY_C": 0.8801115,
    "CMY_M": 0.675161,
    "CMY_Y": 0.6197085,
    "CMYK_C": 0.6847458,
    "CMYK_M": 0.1458157,
    "CMYK_Y": 0,
    "CMYK_K": 0.6197085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02845",
    "Farbtonhilfsbezeichnung": "R9.35.22",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "81",
    "Bcolor": "99",
    "Y": 7,
    "L": 31.9781481766941,
    "a": -9.3355881568058,
    "b": -16.1943144932059,
    "C": 18.6924858736967,
    "h": 1.04785560944048,
    "CMY_C": 0.8677911,
    "CMY_M": 0.6837889,
    "CMY_Y": 0.609907,
    "CMYK_C": 0.6610836,
    "CMYK_M": 0.1893956,
    "CMYK_Y": 0,
    "CMYK_K": 0.609907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02846",
    "Farbtonhilfsbezeichnung": "R7.43.26",
    "Farbtonklasse": "04",
    "Rcolor": "23",
    "Gcolor": "93",
    "Bcolor": "116",
    "Y": 9,
    "L": 36.4789391458904,
    "a": -12.4888732904441,
    "b": -19.4237991804622,
    "C": 23.0923348899086,
    "h": 0.9993807026483,
    "CMY_C": 0.9081667,
    "CMY_M": 0.6354802,
    "CMY_Y": 0.5465602,
    "CMYK_C": 0.7974741,
    "CMYK_M": 0.1961011,
    "CMYK_Y": 0,
    "CMYK_K": 0.5465602
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02849",
    "Farbtonhilfsbezeichnung": "R8.33.36",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "111",
    "Bcolor": "134",
    "Y": 14,
    "L": 43.8323005518083,
    "a": -11.6471361818168,
    "b": -19.0127440626126,
    "C": 22.2966414069069,
    "h": 1.02116630636837,
    "CMY_C": 0.796722,
    "CMY_M": 0.5661761,
    "CMY_Y": 0.476086,
    "CMYK_C": 0.6120011,
    "CMYK_M": 0.1719559,
    "CMYK_Y": 0,
    "CMYK_K": 0.476086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02850",
    "Farbtonhilfsbezeichnung": "R7.31.62",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "181",
    "Bcolor": "213",
    "Y": 41,
    "L": 70.0584887086424,
    "a": -15.0341516090019,
    "b": -24.3353329286896,
    "C": 28.6047923144466,
    "h": 1.01739775750945,
    "CMY_C": 0.5957277,
    "CMY_M": 0.2893527,
    "CMY_Y": 0.1642746,
    "CMYK_C": 0.5162619,
    "CMYK_M": 0.1496642,
    "CMYK_Y": 0,
    "CMYK_K": 0.1642746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02851",
    "Farbtonhilfsbezeichnung": "R7.33.47",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "143",
    "Bcolor": "170",
    "Y": 23,
    "L": 56.2981491088867,
    "a": -13.4082012176514,
    "b": -20.9778861999512,
    "C": 24.8968181610107,
    "h": 237.414962768555,
    "CMY_C": 0.70008325576782,
    "CMY_M": 0.43758904933929,
    "CMY_Y": 0.33504515886307,
    "CMYK_C": 0.54896676540375,
    "CMYK_M": 0.15421180427074,
    "CMYK_Y": 0,
    "CMYK_K": 0.33504515886307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02852",
    "Farbtonhilfsbezeichnung": "R7.44.41",
    "Farbtonklasse": "04",
    "Rcolor": "14",
    "Gcolor": "127",
    "Bcolor": "160",
    "Y": 18,
    "L": 49.3534485857427,
    "a": -16.4516087901984,
    "b": -26.2555323939573,
    "C": 30.98400253479,
    "h": 1.01105022539698,
    "CMY_C": 0.9446422,
    "CMY_M": 0.5008715,
    "CMY_Y": 0.3724824,
    "CMYK_C": 0.9117828,
    "CMYK_M": 0.2045984,
    "CMYK_Y": 0,
    "CMYK_K": 0.3724824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02854",
    "Farbtonhilfsbezeichnung": "S0.11.78",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "212",
    "Bcolor": "224",
    "Y": 62.3599548339844,
    "L": 83.1044692993164,
    "a": -7.08301544189453,
    "b": -10.3205032348633,
    "C": 12.5172634124756,
    "h": 235.537979125977,
    "CMY_C": 0.28761619329453,
    "CMY_M": 0.16881960630417,
    "CMY_Y": 0.1205005645752,
    "CMYK_C": 0.19001220166683,
    "CMYK_M": 0.05493925139308,
    "CMYK_Y": 0,
    "CMYK_K": 0.1205005645752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02855",
    "Farbtonhilfsbezeichnung": "S8.10.35",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "104",
    "Bcolor": "114",
    "Y": 13,
    "L": 43.3063196402264,
    "a": -1.94720528088871,
    "b": -7.44282720739298,
    "C": 7.69332731950422,
    "h": 1.31490983259374,
    "CMY_C": 0.6383229,
    "CMY_M": 0.5927042,
    "CMY_Y": 0.5548058,
    "CMYK_C": 0.1875972,
    "CMYK_M": 0.08512785,
    "CMYK_Y": 0,
    "CMYK_K": 0.5548058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02856",
    "Farbtonhilfsbezeichnung": "S8.22.29",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "90",
    "Bcolor": "109",
    "Y": 9,
    "L": 36.7884660691248,
    "a": -4.5137178235217,
    "b": -14.9912252400345,
    "C": 15.6560046879089,
    "h": 1.2783392322027,
    "CMY_C": 0.756986,
    "CMY_M": 0.6476521,
    "CMY_Y": 0.5706879,
    "CMYK_C": 0.4339457,
    "CMYK_M": 0.1792733,
    "CMYK_Y": 0,
    "CMYK_K": 0.5706879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02857",
    "Farbtonhilfsbezeichnung": "S6.29.43",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "127",
    "Bcolor": "158",
    "Y": 20,
    "L": 50.8772290876595,
    "a": -7.9019129423879,
    "b": -22.3624881961856,
    "C": 23.7175274106222,
    "h": 1.23113514241251,
    "CMY_C": 0.7013026,
    "CMY_M": 0.5021811,
    "CMY_Y": 0.38186,
    "CMYK_C": 0.5167804,
    "CMYK_M": 0.1946501,
    "CMYK_Y": 0,
    "CMYK_K": 0.38186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02859",
    "Farbtonhilfsbezeichnung": "S8.16.73",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "206",
    "Bcolor": "231",
    "Y": 58,
    "L": 80.9085006713867,
    "a": -5.49936246871948,
    "b": -17.3235301971436,
    "C": 18.1754684448242,
    "h": 252.387939453125,
    "CMY_C": 0.33038783073425,
    "CMY_M": 0.19410133361816,
    "CMY_Y": 0.09381157159805,
    "CMYK_C": 0.26106739044189,
    "CMYK_M": 0.11067208647728,
    "CMYK_Y": 0,
    "CMYK_K": 0.09381157159805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02860",
    "Farbtonhilfsbezeichnung": "S9.25.65",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "185",
    "Bcolor": "222",
    "Y": 45,
    "L": 72.7596205095307,
    "a": -7.37911687837556,
    "b": -24.7860434051141,
    "C": 25.8611545292341,
    "h": 1.2814394036138,
    "CMY_C": 0.4793834,
    "CMY_M": 0.2756483,
    "CMY_Y": 0.130671,
    "CMYK_C": 0.4011282,
    "CMYK_M": 0.1667691,
    "CMYK_Y": 0,
    "CMYK_K": 0.130671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02861",
    "Farbtonhilfsbezeichnung": "S9.18.69",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "192",
    "Bcolor": "218",
    "Y": 50,
    "L": 75.9620257864931,
    "a": -5.76146889543033,
    "b": -17.7682321877651,
    "C": 18.6789881661546,
    "h": 1.25723683537231,
    "CMY_C": 0.3881719,
    "CMY_M": 0.2470798,
    "CMY_Y": 0.1452966,
    "CMYK_C": 0.2841633,
    "CMYK_M": 0.119086,
    "CMYK_Y": 0,
    "CMYK_K": 0.1452966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02862",
    "Farbtonhilfsbezeichnung": "T0.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "204",
    "Bcolor": "225",
    "Y": 58,
    "L": 81.1089706420898,
    "a": -3.2362813949585,
    "b": -13.8755254745483,
    "C": 14.2479372024536,
    "h": 256.871246337891,
    "CMY_C": 0.29118490219116,
    "CMY_M": 0.19804930686951,
    "CMY_Y": 0.1163050532341,
    "CMYK_C": 0.19789616763592,
    "CMYK_M": 0.09250279515982,
    "CMYK_Y": 0,
    "CMYK_K": 0.1163050532341
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02863",
    "Farbtonhilfsbezeichnung": "T3.23.65",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "184",
    "Bcolor": "221",
    "Y": 45,
    "L": 72.9595722916598,
    "a": -4.78150382119885,
    "b": -24.1106828474307,
    "C": 24.5802320200914,
    "h": 1.37502173232836,
    "CMY_C": 0.4461662,
    "CMY_M": 0.2792348,
    "CMY_Y": 0.1330208,
    "CMYK_C": 0.3611914,
    "CMYK_M": 0.1686476,
    "CMYK_Y": 0,
    "CMYK_K": 0.1330208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02864",
    "Farbtonhilfsbezeichnung": "T2.17.69",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "193",
    "Bcolor": "220",
    "Y": 51,
    "L": 76.6254806518555,
    "a": -4.29032754898071,
    "b": -18.0794429779053,
    "C": 18.5815277099609,
    "h": 256.650390625,
    "CMY_C": 0.36897528171539,
    "CMY_M": 0.24299103021622,
    "CMY_Y": 0.13561475276947,
    "CMYK_C": 0.26997283101082,
    "CMYK_M": 0.12422271072865,
    "CMYK_Y": 0,
    "CMYK_K": 0.13561475276947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02865",
    "Farbtonhilfsbezeichnung": "T3.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "220",
    "Bcolor": "229",
    "Y": 70.1075134277344,
    "L": 87.0495681762695,
    "a": -1.98766899108887,
    "b": -6.69591426849365,
    "C": 6.98470449447632,
    "h": 253.466583251953,
    "CMY_C": 0.18565863370895,
    "CMY_M": 0.1378692984581,
    "CMY_Y": 0.10273855924606,
    "CMYK_C": 0.09241461753845,
    "CMYK_M": 0.03915329277515,
    "CMYK_Y": 0,
    "CMYK_K": 0.10273855924606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02866",
    "Farbtonhilfsbezeichnung": "S8.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "180",
    "Bcolor": "187",
    "Y": 45,
    "L": 72.6484663901914,
    "a": -1.88961868698578,
    "b": -5.79144944138965,
    "C": 6.09192460675429,
    "h": 1.2554095564225,
    "CMY_C": 0.336339,
    "CMY_M": 0.2947889,
    "CMY_Y": 0.2658728,
    "CMYK_C": 0.09598635,
    "CMYK_M": 0.03938843,
    "CMYK_Y": 0,
    "CMYK_K": 0.2658728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02868",
    "Farbtonhilfsbezeichnung": "S7.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "234",
    "Bcolor": "240",
    "Y": 80.9752197265625,
    "L": 92.1206588745117,
    "a": -1.87523257732391,
    "b": -4.8654146194458,
    "C": 5.21428394317627,
    "h": 248.922286987305,
    "CMY_C": 0.12166994810104,
    "CMY_M": 0.08225923776627,
    "CMY_Y": 0.05981427431107,
    "CMYK_C": 0.0657909065485,
    "CMYK_M": 0.0238729044795,
    "CMYK_Y": 0,
    "CMYK_K": 0.05981427431107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02870",
    "Farbtonhilfsbezeichnung": "T9.07.67",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "184",
    "Bcolor": "197",
    "Y": 47,
    "L": 74.3159835658993,
    "a": -0.04053535122655,
    "b": -8.88363919484012,
    "C": 8.8837316741783,
    "h": 1.56623343662993,
    "CMY_C": 0.3157508,
    "CMY_M": 0.2802078,
    "CMY_Y": 0.2258749,
    "CMYK_C": 0.1161,
    "CMYK_M": 0.07018616,
    "CMYK_Y": 0,
    "CMYK_K": 0.2258749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02871",
    "Farbtonhilfsbezeichnung": "T9.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "222",
    "Bcolor": "237",
    "Y": 72.3123931884766,
    "L": 88.1187362670898,
    "a": -0.33737325668335,
    "b": -9.25656795501709,
    "C": 9.26271438598633,
    "h": 267.912658691406,
    "CMY_C": 0.17035746574402,
    "CMY_M": 0.12907510995865,
    "CMY_Y": 0.07184368371964,
    "CMYK_C": 0.10613921284676,
    "CMYK_M": 0.06166140735149,
    "CMYK_Y": 0,
    "CMYK_K": 0.07184368371964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02872",
    "Farbtonhilfsbezeichnung": "U3.14.67",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "184",
    "Bcolor": "213",
    "Y": 47,
    "L": 74.3033338973079,
    "a": 1.18025540264893,
    "b": -17.7244944540541,
    "C": 17.7637469714944,
    "h": -1.50430554026826,
    "CMY_C": 0.3433585,
    "CMY_M": 0.2802536,
    "CMY_Y": 0.1630675,
    "CMYK_C": 0.2154188,
    "CMYK_M": 0.1400186,
    "CMYK_Y": 0,
    "CMYK_K": 0.1630675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02877",
    "Farbtonhilfsbezeichnung": "U3.07.78",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "213",
    "Bcolor": "227",
    "Y": 66.1743011474609,
    "L": 85.0852508544922,
    "a": 0.37260979413986,
    "b": -8.70914840698242,
    "C": 8.71711540222168,
    "h": 272.449829101563,
    "CMY_C": 0.19558191299438,
    "CMY_M": 0.16438984870911,
    "CMY_Y": 0.10945850610733,
    "CMYK_C": 0.09670903533697,
    "CMYK_M": 0.06168308109045,
    "CMYK_Y": 0,
    "CMYK_K": 0.10945850610733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02878",
    "Farbtonhilfsbezeichnung": "U6.25.25",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "88",
    "Bcolor": "119",
    "Y": 9,
    "L": 37.4589042663574,
    "a": 3.21605014801025,
    "b": -19.9457721710205,
    "C": 20.2033863067627,
    "h": 279.159515380859,
    "CMY_C": 0.70916044712067,
    "CMY_M": 0.65468508005142,
    "CMY_Y": 0.53244817256927,
    "CMYK_C": 0.37795227766037,
    "CMYK_M": 0.26144033670425,
    "CMYK_Y": 0,
    "CMYK_K": 0.53244817256927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02879",
    "Farbtonhilfsbezeichnung": "U6.18.63",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "174",
    "Bcolor": "215",
    "Y": 43,
    "L": 71.2558105736563,
    "a": 3.79359760652204,
    "b": -23.4174434961037,
    "C": 23.722732614381,
    "h": -1.41019277242705,
    "CMY_C": 0.3803914,
    "CMY_M": 0.316637,
    "CMY_Y": 0.1558436,
    "CMYK_C": 0.2660027,
    "CMYK_M": 0.1904783,
    "CMYK_Y": 0,
    "CMYK_K": 0.1558436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02880",
    "Farbtonhilfsbezeichnung": "U4.10.72",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "198",
    "Bcolor": "221",
    "Y": 56,
    "L": 79.8879440528768,
    "a": 1.6145587283608,
    "b": -13.2823317451765,
    "C": 13.3801022595588,
    "h": -1.44983291118004,
    "CMY_C": 0.2603694,
    "CMY_M": 0.2226067,
    "CMY_Y": 0.1335054,
    "CMYK_C": 0.1464107,
    "CMYK_M": 0.1028297,
    "CMYK_Y": 0,
    "CMYK_K": 0.1335054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02881",
    "Farbtonhilfsbezeichnung": "U6.06.73",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "199",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.3765182495117,
    "a": 1.61720359325409,
    "b": -9.0510778427124,
    "C": 9.19441986083984,
    "h": 280.130432128906,
    "CMY_C": 0.23802089691162,
    "CMY_M": 0.21863889694214,
    "CMY_Y": 0.15864497423172,
    "CMYK_C": 0.09434296190739,
    "CMYK_M": 0.07130631059408,
    "CMYK_Y": 0,
    "CMYK_K": 0.15864497423172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02883",
    "Farbtonhilfsbezeichnung": "U9.05.75",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "202",
    "Bcolor": "214",
    "Y": 60,
    "L": 81.5075531005859,
    "a": 1.74977946281433,
    "b": -6.77800559997559,
    "C": 7.00022077560425,
    "h": 284.475189208984,
    "CMY_C": 0.2160649895668,
    "CMY_M": 0.20735311508179,
    "CMY_Y": 0.16266709566116,
    "CMYK_C": 0.06377140432596,
    "CMYK_M": 0.05336708948016,
    "CMYK_Y": 0,
    "CMYK_K": 0.16266709566116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02884",
    "Farbtonhilfsbezeichnung": "U9.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "75",
    "Bcolor": "110",
    "Y": 7.22570562362671,
    "L": 32.3153076171875,
    "a": 4.97906494140625,
    "b": -22.0835037231445,
    "C": 22.6378498077393,
    "h": 282.705749511719,
    "CMY_C": 0.75482821464539,
    "CMY_M": 0.70496940612793,
    "CMY_Y": 0.56944978237152,
    "CMYK_C": 0.4305616915226,
    "CMYK_M": 0.3147591650486,
    "CMYK_Y": 0,
    "CMYK_K": 0.56944978237152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02885",
    "Farbtonhilfsbezeichnung": "V0.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "163",
    "Bcolor": "207",
    "Y": 38,
    "L": 67.4529113769531,
    "a": 6.24256324768066,
    "b": -24.641658782959,
    "C": 25.4200897216797,
    "h": 284.215881347656,
    "CMY_C": 0.40550923347473,
    "CMY_M": 0.36183166503906,
    "CMY_Y": 0.18860191106796,
    "CMYK_C": 0.26732540130615,
    "CMYK_M": 0.21349538862705,
    "CMYK_Y": 0,
    "CMYK_K": 0.18860191106796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02886",
    "Farbtonhilfsbezeichnung": "V5.25.45",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "122",
    "Bcolor": "171",
    "Y": 21,
    "L": 52.7482541552705,
    "a": 11.3325587621317,
    "b": -27.1508230460743,
    "C": 29.4209802721868,
    "h": -1.17538662725044,
    "CMY_C": 0.5280105,
    "CMY_M": 0.5226637,
    "CMY_Y": 0.328709,
    "CMYK_C": 0.2968928,
    "CMYK_M": 0.2889278,
    "CMYK_Y": 0,
    "CMYK_K": 0.328709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02888",
    "Farbtonhilfsbezeichnung": "V5.14.60",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "163",
    "Bcolor": "197",
    "Y": 38,
    "L": 68.2103460690094,
    "a": 7.71182186374275,
    "b": -18.1105004637542,
    "C": 19.6840652179813,
    "h": -1.16823093711311,
    "CMY_C": 0.3557719,
    "CMY_M": 0.3597769,
    "CMY_Y": 0.2258902,
    "CMYK_C": 0.167782,
    "CMYK_M": 0.1729556,
    "CMYK_Y": 0,
    "CMYK_K": 0.2258902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02889",
    "Farbtonhilfsbezeichnung": "V7.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "221",
    "Bcolor": "226",
    "Y": 73,
    "L": 88.3252940723643,
    "a": 1.98964075968727,
    "b": -3.31463182087228,
    "C": 3.86593513403265,
    "h": -1.03018570239102,
    "CMY_C": 0.1267768,
    "CMY_M": 0.1341401,
    "CMY_Y": 0.1129399,
    "CMYK_C": 0.01559863,
    "CMYK_M": 0.02389947,
    "CMYK_Y": 0,
    "CMYK_K": 0.1129399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02890",
    "Farbtonhilfsbezeichnung": "V9.26.33",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "94",
    "Bcolor": "139",
    "Y": 13,
    "L": 42.1908698336814,
    "a": 13.9926126135253,
    "b": -24.7415587048419,
    "C": 28.424249064792,
    "h": -1.05609223463836,
    "CMY_C": 0.6018699,
    "CMY_M": 0.6325269,
    "CMY_Y": 0.4536592,
    "CMYK_C": 0.2712788,
    "CMYK_M": 0.3273922,
    "CMYK_Y": 0,
    "CMYK_K": 0.4536592
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02891",
    "Farbtonhilfsbezeichnung": "V9.26.39",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "107",
    "Bcolor": "156",
    "Y": 16,
    "L": 47.2726212373423,
    "a": 13.691035092643,
    "b": -26.6780812461866,
    "C": 29.9860711145378,
    "h": -1.0966492026009,
    "CMY_C": 0.5624884,
    "CMY_M": 0.5822423,
    "CMY_Y": 0.3889182,
    "CMYK_C": 0.2840376,
    "CMYK_M": 0.3163637,
    "CMYK_Y": 0,
    "CMYK_K": 0.3889182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02892",
    "Farbtonhilfsbezeichnung": "V8.23.44",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "119",
    "Bcolor": "166",
    "Y": 20,
    "L": 52.11933357726,
    "a": 12.971891109934,
    "b": -25.041626954599,
    "C": 28.2020041752582,
    "h": -1.09284229260115,
    "CMY_C": 0.5114717,
    "CMY_M": 0.5337035,
    "CMY_Y": 0.3492604,
    "CMYK_C": 0.2492722,
    "CMYK_M": 0.2834361,
    "CMYK_Y": 0,
    "CMYK_K": 0.3492604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02894",
    "Farbtonhilfsbezeichnung": "V6.20.55",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "147",
    "Bcolor": "192",
    "Y": 31,
    "L": 62.6012802124023,
    "a": 10.3038415908813,
    "b": -23.6849632263184,
    "C": 25.8291816711426,
    "h": 293.510833740234,
    "CMY_C": 0.41824924945831,
    "CMY_M": 0.42208647727966,
    "CMY_Y": 0.24738717079163,
    "CMYK_C": 0.22702519595623,
    "CMYK_M": 0.23212374746799,
    "CMYK_Y": 0,
    "CMYK_K": 0.24738717079163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02895",
    "Farbtonhilfsbezeichnung": "V9.11.69",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "184",
    "Bcolor": "214",
    "Y": 50.1930465698242,
    "L": 76.1875991821289,
    "a": 8.1183910369873,
    "b": -14.8817806243897,
    "C": 16.9521579742432,
    "h": 298.613586425781,
    "CMY_C": 0.25433140993118,
    "CMY_M": 0.27741307020187,
    "CMY_Y": 0.16191279888153,
    "CMYK_C": 0.11027326434851,
    "CMYK_M": 0.13781414926052,
    "CMYK_Y": 0,
    "CMYK_K": 0.16191279888153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02896",
    "Farbtonhilfsbezeichnung": "V9.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "197",
    "Bcolor": "219",
    "Y": 58,
    "L": 80.5092196088104,
    "a": 6.14324966199659,
    "b": -10.9266635707359,
    "C": 12.5352101377547,
    "h": -1.05861535947169,
    "CMY_C": 0.2077503,
    "CMY_M": 0.2273988,
    "CMY_Y": 0.1431154,
    "CMYK_C": 0.07543009,
    "CMYK_M": 0.09836029,
    "CMYK_Y": 0,
    "CMYK_K": 0.1431154
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02898",
    "Farbtonhilfsbezeichnung": "W7.08.24",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "82",
    "Bcolor": "93",
    "Y": 8,
    "L": 35.7892761230469,
    "a": 5.34652662277222,
    "b": -5.99860095977783,
    "C": 8.03545665740967,
    "h": 311.710479736328,
    "CMY_C": 0.65270745754242,
    "CMY_M": 0.6791672706604,
    "CMY_Y": 0.63512963056564,
    "CMYK_C": 0.04817553982139,
    "CMYK_M": 0.12069393694401,
    "CMYK_Y": 0,
    "CMYK_K": 0.63512963056564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02899",
    "Farbtonhilfsbezeichnung": "W7.07.34",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "103",
    "Bcolor": "115",
    "Y": 13,
    "L": 44.5643196105957,
    "a": 5.81227684020996,
    "b": -6.59000635147095,
    "C": 8.78696441650391,
    "h": 311.411773681641,
    "CMY_C": 0.56739842891693,
    "CMY_M": 0.59709197282791,
    "CMY_Y": 0.54716724157333,
    "CMYK_C": 0.04467695206404,
    "CMYK_M": 0.11024982482195,
    "CMYK_Y": 0,
    "CMYK_K": 0.54716724157333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02900",
    "Farbtonhilfsbezeichnung": "W7.07.44",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "123",
    "Bcolor": "137",
    "Y": 20,
    "L": 52.8356056213379,
    "a": 6.28433227539063,
    "b": -7.16828298568726,
    "C": 9.53294849395752,
    "h": 311.240600585938,
    "CMY_C": 0.48398131132126,
    "CMY_M": 0.51699006557465,
    "CMY_Y": 0.46120864152908,
    "CMYK_C": 0.04226621240377,
    "CMYK_M": 0.10353066027164,
    "CMYK_Y": 0,
    "CMYK_K": 0.46120864152908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02901",
    "Farbtonhilfsbezeichnung": "W6.07.53",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "144",
    "Bcolor": "159",
    "Y": 29,
    "L": 60.7570407359255,
    "a": 5.80212276270747,
    "b": -7.46096679690287,
    "C": 9.45148951742609,
    "h": -0.90982426466993,
    "CMY_C": 0.4076303,
    "CMY_M": 0.4358906,
    "CMY_Y": 0.3783625,
    "CMYK_C": 0.04708169,
    "CMYK_M": 0.0925428,
    "CMYK_Y": 0,
    "CMYK_K": 0.3783625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02902",
    "Farbtonhilfsbezeichnung": "W8.05.63",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "169",
    "Bcolor": "183",
    "Y": 41,
    "L": 70.2880218168306,
    "a": 6.38151632493161,
    "b": -6.71032088874881,
    "C": 9.26024605695482,
    "h": -0.81050811937259,
    "CMY_C": 0.3008793,
    "CMY_M": 0.3385301,
    "CMY_Y": 0.2835245,
    "CMYK_C": 0.02422258,
    "CMYK_M": 0.07677258,
    "CMYK_Y": 0,
    "CMYK_K": 0.2835245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02903",
    "Farbtonhilfsbezeichnung": "W6.05.72",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "195",
    "Bcolor": "210",
    "Y": 57,
    "L": 80.086221192578,
    "a": 6.22162492968226,
    "b": -7.16180569833709,
    "C": 9.48683707177357,
    "h": -0.85553255258481,
    "CMY_C": 0.1980314,
    "CMY_M": 0.2333679,
    "CMY_Y": 0.1748555,
    "CMYK_C": 0.0280871,
    "CMYK_M": 0.07091171,
    "CMYK_Y": 0,
    "CMYK_K": 0.1748555
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02904",
    "Farbtonhilfsbezeichnung": "XN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "227",
    "Bcolor": "230",
    "Y": 78,
    "L": 90.7677702074478,
    "a": 2.58792330373014,
    "b": -1.73403657005748,
    "C": 3.11516128832622,
    "h": -0.59034087116114,
    "CMY_C": 0.08936137,
    "CMY_M": 0.1089376,
    "CMY_Y": 0.0974764,
    "CMYK_C": 0,
    "CMYK_M": 0.02149723,
    "CMYK_Y": 0.008911358,
    "CMYK_K": 0.08936137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02905",
    "Farbtonhilfsbezeichnung": "X0.08.15",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "61",
    "Bcolor": "71",
    "Y": 5,
    "L": 26.60647822699,
    "a": 4.93573487434543,
    "b": -5.49142133898352,
    "C": 7.38357549376135,
    "h": -0.83864003361486,
    "CMY_C": 0.7381078,
    "CMY_M": 0.7614965,
    "CMY_Y": 0.7227058,
    "CMYK_C": 0.05554391,
    "CMYK_M": 0.1398901,
    "CMYK_Y": 0,
    "CMYK_K": 0.7227058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02906",
    "Farbtonhilfsbezeichnung": "XN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "222",
    "Bcolor": "220",
    "Y": 73.9850082397461,
    "L": 88.915397644043,
    "a": 2.25943875312805,
    "b": 0.62140434980392,
    "C": 2.34333252906799,
    "h": 15.3776350021362,
    "CMY_C": 0.10460704565048,
    "CMY_M": 0.12937134504318,
    "CMY_Y": 0.13535594940186,
    "CMYK_C": 0,
    "CMYK_M": 0.02765746600926,
    "CMYK_Y": 0.03434123843908,
    "CMYK_K": 0.10460704565048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02908",
    "Farbtonhilfsbezeichnung": "ZN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.2618152915042,
    "a": 2.14692266667027,
    "b": -0.17173719701388,
    "C": 2.15378053698625,
    "h": -0.0798222953273,
    "CMY_C": 0.09313719,
    "CMY_M": 0.1139588,
    "CMY_Y": 0.1146821,
    "CMYK_C": 0,
    "CMYK_M": 0.02296004,
    "CMYK_Y": 0.02375767,
    "CMYK_K": 0.09313719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02909",
    "Farbtonhilfsbezeichnung": "X9.24.33",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "88",
    "Bcolor": "124",
    "Y": 12,
    "L": 43.0652084350586,
    "a": 23.6685371398926,
    "b": -14.1271228790283,
    "C": 27.5640201568604,
    "h": 329.168151855469,
    "CMY_C": 0.49112159013748,
    "CMY_M": 0.65423655509949,
    "CMY_Y": 0.51182281970978,
    "CMYK_C": 0,
    "CMYK_M": 0.32053819298744,
    "CMYK_Y": 0.04068011045456,
    "CMYK_K": 0.49112159013748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02910",
    "Farbtonhilfsbezeichnung": "X9.21.44",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "112",
    "Bcolor": "149",
    "Y": 21,
    "L": 52.5110634354982,
    "a": 22.5672110586352,
    "b": -14.0159534428498,
    "C": 26.5655033055488,
    "h": -0.55577259339164,
    "CMY_C": 0.4000646,
    "CMY_M": 0.5592694,
    "CMY_Y": 0.4173699,
    "CMYK_C": 0,
    "CMYK_M": 0.2653699,
    "CMYK_Y": 0.02884535,
    "CMYK_K": 0.4000646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02911",
    "Farbtonhilfsbezeichnung": "X7.18.54",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "137",
    "Bcolor": "175",
    "Y": 30,
    "L": 61.9999296602826,
    "a": 21.800959586832,
    "b": -14.5324310457817,
    "C": 26.2006372252104,
    "h": -0.58795363406577,
    "CMY_C": 0.3062096,
    "CMY_M": 0.4614648,
    "CMY_Y": 0.3153114,
    "CMYK_C": 0,
    "CMYK_M": 0.2237782,
    "CMYK_Y": 0.01311899,
    "CMYK_K": 0.3062096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02912",
    "Farbtonhilfsbezeichnung": "Y0.30.18",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "55",
    "Bcolor": "87",
    "Y": 6,
    "L": 28.8808757127455,
    "a": 22.9744863888533,
    "b": -12.1795815887255,
    "C": 26.0032542676494,
    "h": -0.48746404460853,
    "CMY_C": 0.6311089,
    "CMY_M": 0.7845339,
    "CMY_Y": 0.660548,
    "CMYK_C": 0,
    "CMYK_M": 0.4159085,
    "CMYK_Y": 0.07980429,
    "CMYK_K": 0.6311089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02913",
    "Farbtonhilfsbezeichnung": "Y0.12.63",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "164",
    "Bcolor": "189",
    "Y": 42,
    "L": 70.8338917262833,
    "a": 16.0996058968138,
    "b": -9.36185095854991,
    "C": 18.6236828635698,
    "h": -0.5267022380737,
    "CMY_C": 0.2336721,
    "CMY_M": 0.3562906,
    "CMY_Y": 0.2579205,
    "CMYK_C": 0,
    "CMYK_M": 0.1600079,
    "CMYK_Y": 0.03164238,
    "CMYK_K": 0.2336721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02914",
    "Farbtonhilfsbezeichnung": "Y1.08.73",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "193",
    "Bcolor": "211",
    "Y": 58,
    "L": 80.492603805144,
    "a": 12.2135177207468,
    "b": -6.72963547584979,
    "C": 13.9448201405688,
    "h": -0.50360983783099,
    "CMY_C": 0.147209,
    "CMY_M": 0.2440834,
    "CMY_Y": 0.1727597,
    "CMYK_C": 0,
    "CMYK_M": 0.1135969,
    "CMYK_Y": 0.02996135,
    "CMYK_K": 0.147209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02916",
    "Farbtonhilfsbezeichnung": "Z0.10.30",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "86",
    "Bcolor": "96",
    "Y": 11,
    "L": 38.7360720145589,
    "a": 10.2853183361652,
    "b": -3.54995653103917,
    "C": 10.8807152636453,
    "h": -0.33234575734968,
    "CMY_C": 0.5864256,
    "CMY_M": 0.6635571,
    "CMY_Y": 0.6219594,
    "CMYK_C": 0,
    "CMYK_M": 0.1864997,
    "CMYK_Y": 0.08591873,
    "CMYK_K": 0.5864256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02920",
    "Farbtonhilfsbezeichnung": "Z2.06.81",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "216",
    "Bcolor": "224",
    "Y": 73.8255386352539,
    "L": 88.8399658203125,
    "a": 12.1018266677856,
    "b": -1.43141257762909,
    "C": 12.1861867904663,
    "h": 353.254364013672,
    "CMY_C": 0.03781598806381,
    "CMY_M": 0.1542227268219,
    "CMY_Y": 0.11970436573029,
    "CMYK_C": 0,
    "CMYK_M": 0.12098178267479,
    "CMYK_Y": 0.0851067751646,
    "CMYK_K": 0.03781598806381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02922",
    "Farbtonhilfsbezeichnung": "Z1.14.71",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "181",
    "Bcolor": "204",
    "Y": 54,
    "L": 78.7120458169549,
    "a": 22.3946138075153,
    "b": -5.1670360003133,
    "C": 22.9829717098614,
    "h": -0.2267584952685,
    "CMY_C": 0.09043688,
    "CMY_M": 0.2911767,
    "CMY_Y": 0.201949,
    "CMYK_C": 0,
    "CMYK_M": 0.2206992,
    "CMYK_Y": 0.1225997,
    "CMYK_K": 0.09043688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02925",
    "Farbtonhilfsbezeichnung": "Z2.32.33",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "83",
    "Bcolor": "114",
    "Y": 13,
    "L": 44.1851997375488,
    "a": 32.3312797546387,
    "b": -5.93748044967651,
    "C": 32.8719520568848,
    "h": 349.593872070313,
    "CMY_C": 0.40965384244919,
    "CMY_M": 0.6738908290863,
    "CMY_Y": 0.55179959535599,
    "CMYK_C": 0,
    "CMYK_M": 0.4475966989994,
    "CMYK_Y": 0.24078373610973,
    "CMYK_K": 0.40965384244919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02926",
    "Farbtonhilfsbezeichnung": "Z9.35.38",
    "Farbtonklasse": "04",
    "Rcolor": "176",
    "Gcolor": "84",
    "Bcolor": "116",
    "Y": 15,
    "L": 48.1320266723633,
    "a": 41.2332649230957,
    "b": -0.49498525261879,
    "C": 41.2362365722656,
    "h": 359.312225341797,
    "CMY_C": 0.30811363458633,
    "CMY_M": 0.66990578174591,
    "CMY_Y": 0.54671615362167,
    "CMYK_C": 0,
    "CMYK_M": 0.52290689945221,
    "CMYK_Y": 0.34485796093941,
    "CMYK_K": 0.30811363458633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02927",
    "Farbtonhilfsbezeichnung": "Z3.37.43",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "93",
    "Bcolor": "139",
    "Y": 20,
    "L": 53.2906799316406,
    "a": 45.7854919433594,
    "b": -6.63593721389771,
    "C": 46.2638854980469,
    "h": 351.753234863281,
    "CMY_C": 0.23713260889053,
    "CMY_M": 0.63345527648926,
    "CMY_Y": 0.45499664545059,
    "CMYK_C": 0,
    "CMYK_M": 0.51951712369919,
    "CMYK_Y": 0.28558573126793,
    "CMYK_K": 0.23713260889053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02929",
    "Farbtonhilfsbezeichnung": "Z6.23.60",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "127",
    "Bcolor": "156",
    "Y": 32.5641975402832,
    "L": 63.8064765930176,
    "a": 39.6817398071289,
    "b": -0.52364617586136,
    "C": 39.6851959228516,
    "h": 359.243957519531,
    "CMY_C": 0.13952910900116,
    "CMY_M": 0.5039102435112,
    "CMY_Y": 0.3894430398941,
    "CMYK_C": 0,
    "CMYK_M": 0.42346712946892,
    "CMYK_Y": 0.29043856263161,
    "CMYK_K": 0.13952910900116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02933",
    "Farbtonhilfsbezeichnung": "Z3.23.24",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "73",
    "Bcolor": "89",
    "Y": 8,
    "L": 35.8917083740234,
    "a": 20.1765804290771,
    "b": -2.79078006744385,
    "C": 20.368673324585,
    "h": 352.124938964844,
    "CMY_C": 0.55544006824493,
    "CMY_M": 0.71563315391541,
    "CMY_Y": 0.6521623134613,
    "CMYK_C": 0,
    "CMYK_M": 0.36034080386162,
    "CMYK_Y": 0.21756851673126,
    "CMYK_K": 0.55544006824493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02935",
    "Farbtonhilfsbezeichnung": "Z9.32.49",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "107",
    "Bcolor": "140",
    "Y": 26,
    "L": 57.8743743896484,
    "a": 43.6568145751953,
    "b": -0.30029076337814,
    "C": 43.6578483581543,
    "h": 359.605895996094,
    "CMY_C": 0.18441981077194,
    "CMY_M": 0.58012008666992,
    "CMY_Y": 0.45084238052368,
    "CMYK_C": 0,
    "CMYK_M": 0.48517641425133,
    "CMYK_Y": 0.32666629552841,
    "CMYK_K": 0.18441981077194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02936",
    "Farbtonhilfsbezeichnung": "Z8.23.57",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "131",
    "Bcolor": "158",
    "Y": 35,
    "L": 64.223622318083,
    "a": 35.8778565568425,
    "b": -1.32113342963944,
    "C": 35.9021724224632,
    "h": -0.03680645712792,
    "CMY_C": 0.1588107,
    "CMY_M": 0.4862698,
    "CMY_Y": 0.380297,
    "CMYK_C": 0,
    "CMYK_M": 0.3892811,
    "CMYK_Y": 0.2633014,
    "CMYK_K": 0.1588107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02937",
    "Farbtonhilfsbezeichnung": "Z8.18.63",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "157",
    "Bcolor": "176",
    "Y": 44,
    "L": 71.9122792603823,
    "a": 28.9188172441662,
    "b": -0.25263396202552,
    "C": 28.9199207246537,
    "h": -0.00873574923257,
    "CMY_C": 0.111751,
    "CMY_M": 0.3841634,
    "CMY_Y": 0.3084572,
    "CMYK_C": 0,
    "CMYK_M": 0.3066848,
    "CMYK_Y": 0.2214539,
    "CMYK_K": 0.111751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02938",
    "Farbtonhilfsbezeichnung": "Z9.16.68",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "168",
    "Bcolor": "186",
    "Y": 50,
    "L": 75.1969528198242,
    "a": 25.6287708282471,
    "b": -0.98219656944275,
    "C": 25.6475849151611,
    "h": 357.805267333984,
    "CMY_C": 0.09738314151764,
    "CMY_M": 0.33930933475494,
    "CMY_Y": 0.2689967751503,
    "CMYK_C": 0,
    "CMYK_M": 0.26802757382393,
    "CMYK_Y": 0.19012899696827,
    "CMYK_K": 0.09738314151764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02939",
    "Farbtonhilfsbezeichnung": "Z8.11.75",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "194",
    "Bcolor": "206",
    "Y": 62,
    "L": 82.9097126635649,
    "a": 18.8268210431429,
    "b": -0.53526767493081,
    "C": 18.8344286367905,
    "h": -0.02842346668736,
    "CMY_C": 0.05446,
    "CMY_M": 0.2374101,
    "CMY_Y": 0.1901994,
    "CMYK_C": 0,
    "CMYK_M": 0.1934875,
    "CMYK_Y": 0.1435576,
    "CMYK_K": 0.05446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02942",
    "Farbtonhilfsbezeichnung": "M8.19.72",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "212",
    "Bcolor": "196",
    "Y": 57,
    "L": 80.3331985473633,
    "a": -24.1994304656982,
    "b": 0.40471947193146,
    "C": 24.2028141021729,
    "h": 179.041854858398,
    "CMY_C": 0.42965936660767,
    "CMY_M": 0.16757172346115,
    "CMY_Y": 0.23058205842972,
    "CMYK_C": 0.31484711170197,
    "CMYK_M": 0,
    "CMYK_Y": 0.0756946131587,
    "CMYK_K": 0.16757172346115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02943",
    "Farbtonhilfsbezeichnung": "E4.22.60",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "155",
    "Bcolor": "126",
    "Y": 35,
    "L": 66.1159217739217,
    "a": 8.50404272035121,
    "b": 18.8984013450312,
    "C": 20.7236173480268,
    "h": 1.14795286854332,
    "CMY_C": 0.2636052,
    "CMY_M": 0.3938901,
    "CMY_Y": 0.5049083,
    "CMYK_C": 0,
    "CMYK_M": 0.1769226,
    "CMYK_Y": 0.3276817,
    "CMYK_K": 0.2636052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02944",
    "Farbtonhilfsbezeichnung": "N1.06.68",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "189",
    "Bcolor": "185",
    "Y": 48,
    "L": 75.0389793897606,
    "a": -7.4456078914274,
    "b": -0.96658665421653,
    "C": 7.50808674916556,
    "h": 0.12909770582855,
    "CMY_C": 0.3380199,
    "CMY_M": 0.2584852,
    "CMY_Y": 0.275311,
    "CMYK_C": 0.1072598,
    "CMYK_M": 0,
    "CMYK_Y": 0.02269115,
    "CMYK_K": 0.2584852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02945",
    "Farbtonhilfsbezeichnung": "Z8.23.27",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "73",
    "Bcolor": "88",
    "Y": 10,
    "L": 37.0966002814306,
    "a": 22.8930435157504,
    "b": -0.51908472427396,
    "C": 22.8989277121226,
    "h": -0.0226704585198,
    "CMY_C": 0.5238774,
    "CMY_M": 0.7130318,
    "CMY_Y": 0.6545215,
    "CMYK_C": 0,
    "CMYK_M": 0.397281,
    "CMYK_Y": 0.2743918,
    "CMYK_K": 0.5238774
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02947",
    "Farbtonhilfsbezeichnung": "E0.25.61",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "162",
    "Bcolor": "125",
    "Y": 41,
    "L": 70.4717022887275,
    "a": 13.7738906134239,
    "b": 25.7522773836721,
    "C": 29.2044492000133,
    "h": 1.07965034146571,
    "CMY_C": 0.169488,
    "CMY_M": 0.3632663,
    "CMY_Y": 0.5089108,
    "CMYK_C": 0,
    "CMYK_M": 0.2333239,
    "CMYK_Y": 0.408691,
    "CMYK_K": 0.169488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02949",
    "Farbtonhilfsbezeichnung": "M8.11.81",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "232",
    "Bcolor": "219",
    "Y": 74,
    "L": 88.9255065917969,
    "a": -16.052267074585,
    "b": 0.92628443241119,
    "C": 16.0789699554443,
    "h": 176.697448730469,
    "CMY_C": 0.25636374950409,
    "CMY_M": 0.08834451436996,
    "CMY_Y": 0.13995534181595,
    "CMYK_C": 0.18430124223232,
    "CMYK_M": 0,
    "CMYK_Y": 0.05661220476031,
    "CMYK_K": 0.08834451436996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02951",
    "Farbtonhilfsbezeichnung": "M8.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 81,
    "L": 91.4319839477539,
    "a": -8.2727632522583,
    "b": 0.97406709194183,
    "C": 8.32991123199463,
    "h": 173.284683227539,
    "CMY_C": 0.16061848402023,
    "CMY_M": 0.07704937458038,
    "CMY_Y": 0.11166018247604,
    "CMYK_C": 0.09054558724165,
    "CMYK_M": 0,
    "CMYK_Y": 0.03750017285347,
    "CMYK_K": 0.07704937458038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02952",
    "Farbtonhilfsbezeichnung": "P5.08.58",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "166",
    "Bcolor": "166",
    "Y": 36,
    "L": 66.4209801751149,
    "a": -7.21859346579568,
    "b": -3.13396081414195,
    "C": 7.86954903466554,
    "h": 0.40959616873532,
    "CMY_C": 0.434297,
    "CMY_M": 0.3499959,
    "CMY_Y": 0.3508193,
    "CMYK_C": 0.1296932,
    "CMYK_M": 0,
    "CMYK_Y": 0.001266782,
    "CMYK_K": 0.3499959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02953",
    "Farbtonhilfsbezeichnung": "E4.15.78",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "195",
    "Bcolor": "167",
    "Y": 59,
    "L": 81.0248989965601,
    "a": 8.59540954505728,
    "b": 17.6425009743678,
    "C": 19.6249562006602,
    "h": 1.11744182848171,
    "CMY_C": 0.1000078,
    "CMY_M": 0.2358363,
    "CMY_Y": 0.3434804,
    "CMYK_C": 0,
    "CMYK_M": 0.1509219,
    "CMYK_Y": 0.2705274,
    "CMYK_K": 0.1000078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02954",
    "Farbtonhilfsbezeichnung": "E0.26.55",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "150",
    "Bcolor": "114",
    "Y": 35,
    "L": 65.6036219775119,
    "a": 12.3830305859827,
    "b": 25.0086878751176,
    "C": 27.9065210251732,
    "h": 1.11103692132848,
    "CMY_C": 0.2339239,
    "CMY_M": 0.4101552,
    "CMY_Y": 0.5521747,
    "CMYK_C": 0,
    "CMYK_M": 0.2300441,
    "CMYK_Y": 0.4154297,
    "CMYK_K": 0.2339239
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02955",
    "Farbtonhilfsbezeichnung": "G0.31.84",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "139",
    "Y": 76.8813705444336,
    "L": 90.2669906616211,
    "a": 0.30839157104492,
    "b": 44.9276390075684,
    "C": 44.9286956787109,
    "h": 89.6067199707031,
    "CMY_C": 0,
    "CMY_M": 0.11959892511368,
    "CMY_Y": 0.45429879426956,
    "CMYK_C": 0,
    "CMYK_M": 0.11959892511368,
    "CMYK_Y": 0.45429879426956,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02956",
    "Farbtonhilfsbezeichnung": "AN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 74,
    "L": 89.0173797607422,
    "a": 3.31325387954712,
    "b": 0.70908719301224,
    "C": 3.38828206062317,
    "h": 12.07994556427,
    "CMY_C": 0.09504526853561,
    "CMY_M": 0.13081109523773,
    "CMY_Y": 0.13473254442215,
    "CMYK_C": 0,
    "CMYK_M": 0.03952222689986,
    "CMYK_Y": 0.0438555367291,
    "CMYK_K": 0.09504526853561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02957",
    "Farbtonhilfsbezeichnung": "A6.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 75,
    "L": 89.9405059814453,
    "a": 8.31433010101318,
    "b": 2.13729047775269,
    "C": 8.58464336395264,
    "h": 14.4163761138916,
    "CMY_C": 0.04239916801453,
    "CMY_M": 0.13338893651962,
    "CMY_Y": 0.13438719511032,
    "CMYK_C": 0,
    "CMYK_M": 0.09501847624779,
    "CMYK_Y": 0.09606093168259,
    "CMYK_K": 0.04239916801453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02958",
    "Farbtonhilfsbezeichnung": "A2.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "174",
    "Bcolor": "176",
    "Y": 45,
    "L": 72.6493621935559,
    "a": 7.19546670940724,
    "b": 0.4635664791204,
    "C": 7.21038383491142,
    "h": 0.06433588502944,
    "CMY_C": 0.2468026,
    "CMY_M": 0.3176492,
    "CMY_Y": 0.3088352,
    "CMYK_C": 0,
    "CMYK_M": 0.09406113,
    "CMYK_Y": 0.082359,
    "CMYK_K": 0.2468026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02959",
    "Farbtonhilfsbezeichnung": "Z9.05.54",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 32,
    "L": 63.3340718226397,
    "a": 7.78846806198652,
    "b": -0.57192219993234,
    "C": 7.8094385044867,
    "h": -0.07330036234128,
    "CMY_C": 0.345046,
    "CMY_M": 0.4161261,
    "CMY_Y": 0.398577,
    "CMYK_C": 0,
    "CMYK_M": 0.1085269,
    "CMYK_Y": 0.08173247,
    "CMYK_K": 0.345046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02960",
    "Farbtonhilfsbezeichnung": "Z9.04.44",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "122",
    "Bcolor": "125",
    "Y": 21,
    "L": 52.4670625028155,
    "a": 5.42223390554286,
    "b": -0.1640678701797,
    "C": 5.42471554944993,
    "h": -0.03024912402599,
    "CMY_C": 0.4722112,
    "CMY_M": 0.5206892,
    "CMY_Y": 0.5113196,
    "CMYK_C": 0,
    "CMYK_M": 0.09185118,
    "CMYK_Y": 0.0740986,
    "CMYK_K": 0.4722112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02961",
    "Farbtonhilfsbezeichnung": "Z9.05.36",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "101",
    "Bcolor": "104",
    "Y": 14,
    "L": 44.0545878573848,
    "a": 5.92908070898923,
    "b": -0.28309260139993,
    "C": 5.93583519605082,
    "h": -0.04771022435122,
    "CMY_C": 0.5530924,
    "CMY_M": 0.6040131,
    "CMY_Y": 0.5924623,
    "CMYK_C": 0,
    "CMYK_M": 0.1139402,
    "CMYK_Y": 0.08809403,
    "CMYK_K": 0.5530924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02962",
    "Farbtonhilfsbezeichnung": "B8.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "222",
    "Bcolor": "217",
    "Y": 77,
    "L": 90.1598487317726,
    "a": 7.14646020237236,
    "b": 4.2366832430061,
    "C": 8.30791058724519,
    "h": 0.53513565243757,
    "CMY_C": 0.04226521,
    "CMY_M": 0.128651,
    "CMY_Y": 0.147638,
    "CMYK_C": 0,
    "CMYK_M": 0.09019806,
    "CMYK_Y": 0.110023,
    "CMYK_K": 0.04226521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02963",
    "Farbtonhilfsbezeichnung": "B5.09.77",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "202",
    "Bcolor": "199",
    "Y": 66,
    "L": 84.908761005214,
    "a": 14.6314813443995,
    "b": 6.44368385413989,
    "C": 15.9875360185243,
    "h": 0.41484077060632,
    "CMY_C": 0.04197187,
    "CMY_M": 0.2063681,
    "CMY_Y": 0.2198031,
    "CMYK_C": 0,
    "CMYK_M": 0.1715986,
    "CMYK_Y": 0.1856221,
    "CMYK_K": 0.04197187
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02964",
    "Farbtonhilfsbezeichnung": "B1.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "180",
    "Bcolor": "180",
    "Y": 51,
    "L": 76.7485667956778,
    "a": 15.411879305569,
    "b": 4.63524894921181,
    "C": 16.093835979983,
    "h": 0.29215223787345,
    "CMY_C": 0.1333264,
    "CMY_M": 0.2960654,
    "CMY_Y": 0.2938873,
    "CMYK_C": 0,
    "CMYK_M": 0.1877742,
    "CMYK_Y": 0.1852611,
    "CMYK_K": 0.1333264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02965",
    "Farbtonhilfsbezeichnung": "B2.09.62",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "161",
    "Bcolor": "161",
    "Y": 40,
    "L": 69.4900676494061,
    "a": 13.1242715227762,
    "b": 4.29757629866798,
    "C": 13.809984252215,
    "h": 0.31644855337207,
    "CMY_C": 0.2297022,
    "CMY_M": 0.3667814,
    "CMY_Y": 0.3679354,
    "CMYK_C": 0,
    "CMYK_M": 0.177956,
    "CMYK_Y": 0.1794541,
    "CMYK_K": 0.2297022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02966",
    "Farbtonhilfsbezeichnung": "B0.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "131",
    "Bcolor": "132",
    "Y": 26,
    "L": 57.7163280397995,
    "a": 12.5644432127548,
    "b": 3.51509181151446,
    "C": 13.046880994702,
    "h": 0.27279080064717,
    "CMY_C": 0.3617344,
    "CMY_M": 0.4862041,
    "CMY_Y": 0.4826434,
    "CMYK_C": 0,
    "CMYK_M": 0.1950124,
    "CMYK_Y": 0.1894336,
    "CMYK_K": 0.3617344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02967",
    "Farbtonhilfsbezeichnung": "B0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "107",
    "Bcolor": "108",
    "Y": 17,
    "L": 47.7461337252354,
    "a": 11.3917579833067,
    "b": 2.65999861373563,
    "C": 11.6981939877618,
    "h": 0.22939191355203,
    "CMY_C": 0.474546,
    "CMY_M": 0.5818647,
    "CMY_Y": 0.5751799,
    "CMYK_C": 0,
    "CMYK_M": 0.20424,
    "CMYK_Y": 0.1915182,
    "CMYK_K": 0.474546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02968",
    "Farbtonhilfsbezeichnung": "B0.11.25",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "76",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.5824619418386,
    "a": 9.72177547954523,
    "b": 2.67211710239185,
    "C": 10.0823176047763,
    "h": 0.26823508286545,
    "CMY_C": 0.6151414,
    "CMY_M": 0.7023805,
    "CMY_Y": 0.6989994,
    "CMYK_C": 0,
    "CMYK_M": 0.2266783,
    "CMYK_Y": 0.2178931,
    "CMYK_K": 0.6151414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02969",
    "Farbtonhilfsbezeichnung": "B7.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "224",
    "Bcolor": "219",
    "Y": 77,
    "L": 90.5399856567383,
    "a": 6.76064443588257,
    "b": 3.95085287094116,
    "C": 7.83042478561401,
    "h": 30.3015880584717,
    "CMY_C": 0.04167932271957,
    "CMY_M": 0.12334686517715,
    "CMY_Y": 0.1414116024971,
    "CMYK_C": 0,
    "CMYK_M": 0.08521942794323,
    "CMYK_Y": 0.10406984388828,
    "CMYK_K": 0.04167932271957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02970",
    "Farbtonhilfsbezeichnung": "B7.04.74",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "197",
    "Bcolor": "193",
    "Y": 58,
    "L": 80.9624253835789,
    "a": 6.52206387021087,
    "b": 3.45233583847595,
    "C": 7.37942679811484,
    "h": 0.48683677446109,
    "CMY_C": 0.151987,
    "CMY_M": 0.2277326,
    "CMY_Y": 0.241804,
    "CMYK_C": 0,
    "CMYK_M": 0.08932134,
    "CMYK_Y": 0.1059146,
    "CMYK_K": 0.151987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02971",
    "Farbtonhilfsbezeichnung": "B7.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "173",
    "Bcolor": "170",
    "Y": 44,
    "L": 72.2371831758856,
    "a": 7.04213762961242,
    "b": 3.40624057977235,
    "C": 7.822670725634,
    "h": 0.45051802062828,
    "CMY_C": 0.2438237,
    "CMY_M": 0.322455,
    "CMY_Y": 0.3339285,
    "CMYK_C": 0,
    "CMYK_M": 0.1039854,
    "CMYK_Y": 0.1191584,
    "CMYK_K": 0.2438237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02972",
    "Farbtonhilfsbezeichnung": "B9.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "148",
    "Bcolor": "146",
    "Y": 31,
    "L": 62.7850144559073,
    "a": 6.72804633166046,
    "b": 2.95193720854834,
    "C": 7.34714507303224,
    "h": 0.41345999774942,
    "CMY_C": 0.3481885,
    "CMY_M": 0.4202109,
    "CMY_Y": 0.4284794,
    "CMYK_C": 0,
    "CMYK_M": 0.1104958,
    "CMYK_Y": 0.1231812,
    "CMYK_K": 0.3481885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02973",
    "Farbtonhilfsbezeichnung": "B8.05.45",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "122",
    "Bcolor": "120",
    "Y": 20,
    "L": 52.2791561567125,
    "a": 5.38702959269993,
    "b": 2.48865065830965,
    "C": 5.93409385936302,
    "h": 0.43276417656469,
    "CMY_C": 0.4670777,
    "CMY_M": 0.5231659,
    "CMY_Y": 0.5307079,
    "CMYK_C": 0,
    "CMYK_M": 0.1052466,
    "CMYK_Y": 0.1193987,
    "CMYK_K": 0.4670777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02974",
    "Farbtonhilfsbezeichnung": "B8.05.36",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "100",
    "Bcolor": "99",
    "Y": 14,
    "L": 43.72039550865,
    "a": 5.40562830617475,
    "b": 2.3964103003479,
    "C": 5.9130025970002,
    "h": 0.41728298355997,
    "CMY_C": 0.5527371,
    "CMY_M": 0.6067347,
    "CMY_Y": 0.6128418,
    "CMYK_C": 0,
    "CMYK_M": 0.1207291,
    "CMYK_Y": 0.1343835,
    "CMYK_K": 0.5527371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02975",
    "Farbtonhilfsbezeichnung": "C1.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "77",
    "Bcolor": "76",
    "Y": 8,
    "L": 33.4922468093678,
    "a": 3.49314169335641,
    "b": 1.71663249351659,
    "C": 3.8921544172427,
    "h": 0.45676764343397,
    "CMY_C": 0.6645137,
    "CMY_M": 0.6984168,
    "CMY_Y": 0.7038596,
    "CMYK_C": 0,
    "CMYK_M": 0.1010566,
    "CMYK_Y": 0.1172802,
    "CMYK_K": 0.6645137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02976",
    "Farbtonhilfsbezeichnung": "B9.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "224",
    "Bcolor": "218",
    "Y": 78,
    "L": 90.6843898860769,
    "a": 6.66336175341897,
    "b": 4.45884155695637,
    "C": 8.01758429247662,
    "h": 0.58972536243086,
    "CMY_C": 0.03925626,
    "CMY_M": 0.1216816,
    "CMY_Y": 0.1435949,
    "CMYK_C": 0,
    "CMYK_M": 0.08579323,
    "CMYK_Y": 0.1086019,
    "CMYK_K": 0.03925626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02977",
    "Farbtonhilfsbezeichnung": "C1.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "203",
    "Bcolor": "194",
    "Y": 66,
    "L": 84.9678503257423,
    "a": 14.1022275140223,
    "b": 9.15867229909786,
    "C": 16.8152936084836,
    "h": 0.57598751461736,
    "CMY_C": 0.03797258,
    "CMY_M": 0.205066,
    "CMY_Y": 0.2390225,
    "CMYK_C": 0,
    "CMYK_M": 0.1736888,
    "CMYK_Y": 0.2089857,
    "CMYK_K": 0.03797258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02978",
    "Farbtonhilfsbezeichnung": "C0.14.74",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "188",
    "Bcolor": "180",
    "Y": 59,
    "L": 81.3175331485545,
    "a": 19.904663182895,
    "b": 11.5572961507211,
    "C": 23.0166615898129,
    "h": 0.5260570178982,
    "CMY_C": 0.03501858,
    "CMY_M": 0.2611019,
    "CMY_Y": 0.2943909,
    "CMYK_C": 0,
    "CMYK_M": 0.2342877,
    "CMYK_Y": 0.2687848,
    "CMYK_K": 0.03501858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02979",
    "Farbtonhilfsbezeichnung": "B8.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "163",
    "Bcolor": "157",
    "Y": 44,
    "L": 72.2621188131692,
    "a": 20.8946480256177,
    "b": 11.158147598292,
    "C": 23.6873505048522,
    "h": 0.49049131634964,
    "CMY_C": 0.13273,
    "CMY_M": 0.3603663,
    "CMY_Y": 0.3860883,
    "CMYK_C": 0,
    "CMYK_M": 0.2624745,
    "CMYK_Y": 0.2921331,
    "CMYK_K": 0.13273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02980",
    "Farbtonhilfsbezeichnung": "B9.20.62",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "152",
    "Bcolor": "145",
    "Y": 40,
    "L": 69.6611723945037,
    "a": 26.8630109423608,
    "b": 14.0371074160311,
    "C": 30.3094332097879,
    "h": 0.48151979023876,
    "CMY_C": 0.1198396,
    "CMY_M": 0.4057159,
    "CMY_Y": 0.4318778,
    "CMYK_C": 0,
    "CMYK_M": 0.3248001,
    "CMYK_Y": 0.3545242,
    "CMYK_K": 0.1198396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02981",
    "Farbtonhilfsbezeichnung": "C0.21.50",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "123",
    "Bcolor": "115",
    "Y": 26,
    "L": 57.7446389997851,
    "a": 23.2705139866182,
    "b": 13.4616828642572,
    "C": 26.8837074589654,
    "h": 0.5244506799583,
    "CMY_C": 0.2762491,
    "CMY_M": 0.5173423,
    "CMY_Y": 0.5475192,
    "CMYK_C": 0,
    "CMYK_M": 0.3331164,
    "CMYK_Y": 0.3748115,
    "CMYK_K": 0.2762491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02982",
    "Farbtonhilfsbezeichnung": "B9.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "101",
    "Bcolor": "96",
    "Y": 17,
    "L": 47.9485120225911,
    "a": 20.0416540762646,
    "b": 10.3288738041308,
    "C": 22.5466967020517,
    "h": 0.47586812472613,
    "CMY_C": 0.4064057,
    "CMY_M": 0.6043795,
    "CMY_Y": 0.6216318,
    "CMYK_C": 0,
    "CMYK_M": 0.333517,
    "CMYK_Y": 0.3625812,
    "CMYK_K": 0.4064057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02983",
    "Farbtonhilfsbezeichnung": "B8.18.33",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "88",
    "Bcolor": "85",
    "Y": 12,
    "L": 41.5919003234112,
    "a": 16.0717462855599,
    "b": 8.20568636523219,
    "C": 18.0453406006084,
    "h": 0.472064593769,
    "CMY_C": 0.4987588,
    "CMY_M": 0.6541166,
    "CMY_Y": 0.6681823,
    "CMYK_C": 0,
    "CMYK_M": 0.3099463,
    "CMYK_Y": 0.3380079,
    "CMYK_K": 0.4987588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02984",
    "Farbtonhilfsbezeichnung": "DN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "237",
    "Bcolor": "231",
    "Y": 87,
    "L": 94.1381488770642,
    "a": 1.48778275347938,
    "b": 2.81171157819922,
    "C": 3.18107207094247,
    "h": 1.08411114267409,
    "CMY_C": 0.04487193,
    "CMY_M": 0.06992655,
    "CMY_Y": 0.09400364,
    "CMYK_C": 0,
    "CMYK_M": 0.02623169,
    "CMYK_Y": 0.05143992,
    "CMYK_K": 0.04487193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02985",
    "Farbtonhilfsbezeichnung": "C8.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "220",
    "Bcolor": "212",
    "Y": 75,
    "L": 89.4434157533419,
    "a": 6.88532059255309,
    "b": 5.94691866677461,
    "C": 9.09799325628833,
    "h": 0.71239964245954,
    "CMY_C": 0.04725292,
    "CMY_M": 0.1364098,
    "CMY_Y": 0.1681341,
    "CMYK_C": 0,
    "CMYK_M": 0.09357877,
    "CMYK_Y": 0.1268765,
    "CMYK_K": 0.04725292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02986",
    "Farbtonhilfsbezeichnung": "C1.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "214",
    "Bcolor": "207",
    "Y": 73,
    "L": 88.2667588179637,
    "a": 10.7940921201717,
    "b": 6.99225521704903,
    "C": 12.8609508870496,
    "h": 0.57481680405133,
    "CMY_C": 0.02931321,
    "CMY_M": 0.1596373,
    "CMY_Y": 0.1880478,
    "CMYK_C": 0,
    "CMYK_M": 0.1342597,
    "CMYK_Y": 0.1635281,
    "CMYK_K": 0.02931321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02987",
    "Farbtonhilfsbezeichnung": "C1.19.71",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "174",
    "Bcolor": "163",
    "Y": 53,
    "L": 77.782859939628,
    "a": 26.236032706538,
    "b": 16.0092198474933,
    "C": 30.7347447086177,
    "h": 0.54788555969717,
    "CMY_C": 0.02613747,
    "CMY_M": 0.3184574,
    "CMY_Y": 0.3623475,
    "CMYK_C": 0,
    "CMYK_M": 0.3001654,
    "CMYK_Y": 0.3452336,
    "CMYK_K": 0.02613747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02989",
    "Farbtonhilfsbezeichnung": "B9.21.63",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "153",
    "Bcolor": "145",
    "Y": 41,
    "L": 70.4642985340744,
    "a": 27.0986920485521,
    "b": 15.3039869112898,
    "C": 31.1215540441539,
    "h": 0.51409703191723,
    "CMY_C": 0.1068632,
    "CMY_M": 0.3983414,
    "CMY_Y": 0.4325161,
    "CMYK_C": 0,
    "CMYK_M": 0.3263534,
    "CMYK_Y": 0.3646171,
    "CMYK_K": 0.1068632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02990",
    "Farbtonhilfsbezeichnung": "C0.29.52",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "121",
    "Bcolor": "112",
    "Y": 28,
    "L": 59.9357486552965,
    "a": 32.6950749387828,
    "b": 18.8067492860825,
    "C": 37.7181885031902,
    "h": 0.5219970324269,
    "CMY_C": 0.1897511,
    "CMY_M": 0.5256066,
    "CMY_Y": 0.5604478,
    "CMYK_C": 0,
    "CMYK_M": 0.4145091,
    "CMYK_Y": 0.4575096,
    "CMYK_K": 0.1897511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02991",
    "Farbtonhilfsbezeichnung": "B9.32.43",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "97",
    "Bcolor": "91",
    "Y": 19,
    "L": 50.5546869776548,
    "a": 32.5902285792102,
    "b": 17.5888894720125,
    "C": 37.0336607926335,
    "h": 0.49489961237781,
    "CMY_C": 0.2987978,
    "CMY_M": 0.6193001,
    "CMY_Y": 0.642046,
    "CMYK_C": 0,
    "CMYK_M": 0.4570754,
    "CMYK_Y": 0.4895138,
    "CMYK_K": 0.2987978
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02992",
    "Farbtonhilfsbezeichnung": "C0.32.40",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "90",
    "Bcolor": "84",
    "Y": 16,
    "L": 47.2747921030121,
    "a": 31.1514670552876,
    "b": 17.3819758098026,
    "C": 35.6727764934162,
    "h": 0.50895120274018,
    "CMY_C": 0.3433632,
    "CMY_M": 0.6466923,
    "CMY_Y": 0.6715687,
    "CMYK_C": 0,
    "CMYK_M": 0.4619434,
    "CMYK_Y": 0.4998281,
    "CMYK_K": 0.3433632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02993",
    "Farbtonhilfsbezeichnung": "C2.11.77",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "207",
    "Bcolor": "197",
    "Y": 69,
    "L": 86.539439738266,
    "a": 14.7675346072575,
    "b": 9.68847043668573,
    "C": 17.6620083166972,
    "h": 0.58062740337587,
    "CMY_C": 0.01409241,
    "CMY_M": 0.18979,
    "CMY_Y": 0.2258759,
    "CMYK_C": 0,
    "CMYK_M": 0.178209,
    "CMYK_Y": 0.2148107,
    "CMYK_K": 0.01409241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02994",
    "Farbtonhilfsbezeichnung": "C3.17.74",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "185",
    "Bcolor": "169",
    "Y": 58,
    "L": 80.7871998953229,
    "a": 22.1212749407572,
    "b": 16.6993908189123,
    "C": 27.7167901952471,
    "h": 0.6466309023837,
    "CMY_C": 0.01578081,
    "CMY_M": 0.2744092,
    "CMY_Y": 0.3367012,
    "CMYK_C": 0,
    "CMYK_M": 0.2627752,
    "CMYK_Y": 0.326066,
    "CMYK_K": 0.01578081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02995",
    "Farbtonhilfsbezeichnung": "C4.29.59",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "141",
    "Bcolor": "122",
    "Y": 37,
    "L": 67.4892442094104,
    "a": 32.4504525935864,
    "b": 24.078968090153,
    "C": 40.4082736307208,
    "h": 0.63837597049703,
    "CMY_C": 0.09574191,
    "CMY_M": 0.4482308,
    "CMY_Y": 0.5226961,
    "CMYK_C": 0,
    "CMYK_M": 0.3898101,
    "CMYK_Y": 0.4721597,
    "CMYK_K": 0.09574191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02996",
    "Farbtonhilfsbezeichnung": "C3.33.50",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "115",
    "Bcolor": "100",
    "Y": 26,
    "L": 57.7143493085996,
    "a": 32.6605252102845,
    "b": 22.500315865102,
    "C": 39.6607377773156,
    "h": 0.60324735561281,
    "CMY_C": 0.21036,
    "CMY_M": 0.5489258,
    "CMY_Y": 0.6069508,
    "CMYK_C": 0,
    "CMYK_M": 0.4287596,
    "CMYK_Y": 0.5022425,
    "CMYK_K": 0.21036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02997",
    "Farbtonhilfsbezeichnung": "C5.40.48",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "104",
    "Bcolor": "85",
    "Y": 24,
    "L": 55.6052925054737,
    "a": 38.3876721855745,
    "b": 28.2862272759823,
    "C": 47.6835823878163,
    "h": 0.63503642786211,
    "CMY_C": 0.1975264,
    "CMY_M": 0.5916228,
    "CMY_Y": 0.6648128,
    "CMYK_C": 0,
    "CMYK_M": 0.491102,
    "CMYK_Y": 0.5823075,
    "CMYK_K": 0.1975264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02998",
    "Farbtonhilfsbezeichnung": "C3.45.34",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "72",
    "Bcolor": "59",
    "Y": 13,
    "L": 42.0579975134338,
    "a": 36.2379374037006,
    "b": 25.258409690288,
    "C": 44.172110741473,
    "h": 0.60872023913627,
    "CMY_C": 0.3679979,
    "CMY_M": 0.7179211,
    "CMY_Y": 0.7684759,
    "CMYK_C": 0,
    "CMYK_M": 0.5536743,
    "CMYK_Y": 0.6336657,
    "CMYK_K": 0.3679979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI02999",
    "Farbtonhilfsbezeichnung": "C2.30.36",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "86",
    "Bcolor": "76",
    "Y": 14,
    "L": 44.0277896963016,
    "a": 26.4691318130016,
    "b": 17.3383055919031,
    "C": 31.6422467554419,
    "h": 0.57990921064462,
    "CMY_C": 0.4035174,
    "CMY_M": 0.662901,
    "CMY_Y": 0.7020929,
    "CMYK_C": 0,
    "CMYK_M": 0.4348553,
    "CMYK_Y": 0.5005602,
    "CMYK_K": 0.4035174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03000",
    "Farbtonhilfsbezeichnung": "C2.24.33",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "84",
    "Bcolor": "75",
    "Y": 12,
    "L": 40.9651143418104,
    "a": 19.7596519960775,
    "b": 13.4802953914524,
    "C": 23.9199124339305,
    "h": 0.59868850274842,
    "CMY_C": 0.4767191,
    "CMY_M": 0.6712565,
    "CMY_Y": 0.7066554,
    "CMYK_C": 0,
    "CMYK_M": 0.3717646,
    "CMYK_Y": 0.4394127,
    "CMYK_K": 0.4767191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03001",
    "Farbtonhilfsbezeichnung": "C9.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "217",
    "Bcolor": "207",
    "Y": 74,
    "L": 88.7653576519758,
    "a": 8.33335039303618,
    "b": 7.85847063922807,
    "C": 11.4542694904881,
    "h": 0.75607819582817,
    "CMY_C": 0.03894047,
    "CMY_M": 0.1480777,
    "CMY_Y": 0.1893815,
    "CMYK_C": 0,
    "CMYK_M": 0.1135593,
    "CMYK_Y": 0.1565366,
    "CMYK_K": 0.03894047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03002",
    "Farbtonhilfsbezeichnung": "C3.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "213",
    "Bcolor": "205",
    "Y": 71,
    "L": 87.8087844848633,
    "a": 10.8004159927368,
    "b": 7.41016578674316,
    "C": 13.0980739593506,
    "h": 34.4540176391602,
    "CMY_C": 0.03332436084747,
    "CMY_M": 0.16476964950562,
    "CMY_Y": 0.19608873128891,
    "CMYK_C": 0,
    "CMYK_M": 0.13597662746906,
    "CMYK_Y": 0.16837537288666,
    "CMYK_K": 0.03332436084747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03003",
    "Farbtonhilfsbezeichnung": "C4.10.76",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 63,
    "L": 83.4403117855324,
    "a": 13.0113272189779,
    "b": 10.2459622213262,
    "C": 16.5612311692144,
    "h": 0.66705065588571,
    "CMY_C": 0.06012473,
    "CMY_M": 0.219129,
    "CMY_Y": 0.2634678,
    "CMYK_C": 0,
    "CMYK_M": 0.1691759,
    "CMYK_Y": 0.2163512,
    "CMYK_K": 0.06012473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03004",
    "Farbtonhilfsbezeichnung": "C1.19.59",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "147",
    "Bcolor": "135",
    "Y": 36,
    "L": 66.5898208670581,
    "a": 22.4189097296864,
    "b": 14.8286642292823,
    "C": 26.8793005171754,
    "h": 0.58437232292062,
    "CMY_C": 0.180038,
    "CMY_M": 0.4248645,
    "CMY_Y": 0.4692781,
    "CMYK_C": 0,
    "CMYK_M": 0.2985828,
    "CMYK_Y": 0.3527482,
    "CMYK_K": 0.180038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03005",
    "Farbtonhilfsbezeichnung": "C4.14.71",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "183",
    "Bcolor": "171",
    "Y": 54,
    "L": 78.688244438807,
    "a": 17.4273585823632,
    "b": 12.7544006883578,
    "C": 21.5960080588392,
    "h": 0.63179059366933,
    "CMY_C": 0.07863988,
    "CMY_M": 0.2828971,
    "CMY_Y": 0.3311436,
    "CMYK_C": 0,
    "CMYK_M": 0.2216909,
    "CMYK_Y": 0.2740554,
    "CMYK_K": 0.07863988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03006",
    "Farbtonhilfsbezeichnung": "C1.23.43",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "108",
    "Bcolor": "100",
    "Y": 20,
    "L": 51.4766669166614,
    "a": 22.2923190004189,
    "b": 13.5389681843648,
    "C": 26.0816246793347,
    "h": 0.54579748623045,
    "CMY_C": 0.3504293,
    "CMY_M": 0.5769914,
    "CMY_Y": 0.6087168,
    "CMYK_C": 0,
    "CMYK_M": 0.3487873,
    "CMYK_Y": 0.3976279,
    "CMYK_K": 0.3504293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03007",
    "Farbtonhilfsbezeichnung": "C4.31.38",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "93",
    "Bcolor": "81",
    "Y": 16,
    "L": 46.7313367271168,
    "a": 25.9518214648293,
    "b": 18.2292547504385,
    "C": 31.7143936738314,
    "h": 0.61235282897325,
    "CMY_C": 0.3754705,
    "CMY_M": 0.6353587,
    "CMY_Y": 0.683192,
    "CMYK_C": 0,
    "CMYK_M": 0.4161344,
    "CMYK_Y": 0.4927253,
    "CMYK_K": 0.3754705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03008",
    "Farbtonhilfsbezeichnung": "DN.02.89",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "232",
    "Y": 88,
    "L": 95.0611270662584,
    "a": 1.5737282538717,
    "b": 3.41503626556989,
    "C": 3.76019857350534,
    "h": 1.13897829050125,
    "CMY_C": 0.03180844,
    "CMY_M": 0.05993923,
    "CMY_Y": 0.08824837,
    "CMYK_C": 0,
    "CMYK_M": 0.02905498,
    "CMYK_Y": 0.05829418,
    "CMYK_K": 0.03180844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03009",
    "Farbtonhilfsbezeichnung": "C7.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "224",
    "Bcolor": "217",
    "Y": 77,
    "L": 90.1753768920898,
    "a": 4.53298425674438,
    "b": 4.36290311813354,
    "C": 6.29149198532104,
    "h": 43.9046897888184,
    "CMY_C": 0.06121933460236,
    "CMY_M": 0.12198144197464,
    "CMY_Y": 0.14878588914871,
    "CMYK_C": 0,
    "CMYK_M": 0.06472449749708,
    "CMYK_Y": 0.09327690303326,
    "CMYK_K": 0.06121933460236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03010",
    "Farbtonhilfsbezeichnung": "C8.09.75",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "197",
    "Bcolor": "185",
    "Y": 61,
    "L": 82.3988033531998,
    "a": 11.2370063905465,
    "b": 9.94920652722224,
    "C": 15.0085649927801,
    "h": 0.72468805329248,
    "CMY_C": 0.08487229,
    "CMY_M": 0.2257599,
    "CMY_Y": 0.2727084,
    "CMYK_C": 0,
    "CMYK_M": 0.153954,
    "CMYK_Y": 0.2052567,
    "CMYK_K": 0.08487229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03011",
    "Farbtonhilfsbezeichnung": "D1.15.70",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "178",
    "Bcolor": "159",
    "Y": 50,
    "L": 76.2292435683228,
    "a": 14.667226095158,
    "b": 15.419336644536,
    "C": 21.2810588055203,
    "h": 0.81039117928959,
    "CMY_C": 0.1187069,
    "CMY_M": 0.3024614,
    "CMY_Y": 0.3763527,
    "CMYK_C": 0,
    "CMYK_M": 0.2085056,
    "CMYK_Y": 0.2923498,
    "CMYK_K": 0.1187069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03012",
    "Farbtonhilfsbezeichnung": "D3.22.63",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "158",
    "Bcolor": "132",
    "Y": 41,
    "L": 70.0679154624705,
    "a": 18.2598321796313,
    "b": 21.4046209449564,
    "C": 28.1350185538514,
    "h": 0.86451747033121,
    "CMY_C": 0.1540289,
    "CMY_M": 0.3785747,
    "CMY_Y": 0.4811353,
    "CMYK_C": 0,
    "CMYK_M": 0.2654296,
    "CMYK_Y": 0.3866638,
    "CMYK_K": 0.1540289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03013",
    "Farbtonhilfsbezeichnung": "D0.25.59",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "145",
    "Bcolor": "119",
    "Y": 35,
    "L": 66.1327092984852,
    "a": 22.7148009267105,
    "b": 23.2526199722836,
    "C": 32.5060996847596,
    "h": 0.79709763437858,
    "CMY_C": 0.1689872,
    "CMY_M": 0.4323851,
    "CMY_Y": 0.5324427,
    "CMYK_C": 0,
    "CMYK_M": 0.31696,
    "CMYK_Y": 0.4373645,
    "CMYK_K": 0.1689872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03014",
    "Farbtonhilfsbezeichnung": "C8.28.55",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "132",
    "Bcolor": "110",
    "Y": 31,
    "L": 62.4709601342119,
    "a": 27.0239790706162,
    "b": 23.5477797145364,
    "C": 35.844014483501,
    "h": 0.71676816114956,
    "CMY_C": 0.1855565,
    "CMY_M": 0.4828434,
    "CMY_Y": 0.5694769,
    "CMYK_C": 0,
    "CMYK_M": 0.3650185,
    "CMYK_Y": 0.4713899,
    "CMYK_K": 0.1855565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03015",
    "Farbtonhilfsbezeichnung": "C7.32.49",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "116",
    "Bcolor": "95",
    "Y": 24,
    "L": 56.4977664433254,
    "a": 27.948026530296,
    "b": 23.5349968059704,
    "C": 36.5374911781743,
    "h": 0.69988902961668,
    "CMY_C": 0.2486055,
    "CMY_M": 0.54623,
    "CMY_Y": 0.6266502,
    "CMYK_C": 0,
    "CMYK_M": 0.3960961,
    "CMYK_Y": 0.5031241,
    "CMYK_K": 0.2486055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03016",
    "Farbtonhilfsbezeichnung": "D1.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "210",
    "Bcolor": "194",
    "Y": 69,
    "L": 86.6228384955618,
    "a": 10.4511881776743,
    "b": 11.6739741136893,
    "C": 15.6687270042032,
    "h": 0.84060875266267,
    "CMY_C": 0.03809913,
    "CMY_M": 0.1780856,
    "CMY_Y": 0.2402245,
    "CMYK_C": 0,
    "CMYK_M": 0.1455311,
    "CMYK_Y": 0.2101312,
    "CMYK_K": 0.03809913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03017",
    "Farbtonhilfsbezeichnung": "D3.14.79",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "186",
    "Y": 70,
    "L": 86.7974181691653,
    "a": 14.2197583959863,
    "b": 16.2243267943142,
    "C": 21.5738338912889,
    "h": 0.85114751946278,
    "CMY_C": 0,
    "CMY_M": 0.1872052,
    "CMY_Y": 0.2711077,
    "CMYK_C": 0,
    "CMYK_M": 0.1872052,
    "CMYK_Y": 0.2711077,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03018",
    "Farbtonhilfsbezeichnung": "D2.20.72",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "183",
    "Bcolor": "157",
    "Y": 55,
    "L": 79.249948307755,
    "a": 18.8170650629139,
    "b": 21.1187631866239,
    "C": 28.2857578317187,
    "h": 0.84296938981106,
    "CMY_C": 0.04591563,
    "CMY_M": 0.2827322,
    "CMY_Y": 0.385279,
    "CMYK_C": 0,
    "CMYK_M": 0.2482135,
    "CMYK_Y": 0.3556953,
    "CMYK_K": 0.04591563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03019",
    "Farbtonhilfsbezeichnung": "D2.28.68",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "165",
    "Bcolor": "131",
    "Y": 48,
    "L": 74.8491246272469,
    "a": 25.8616364720394,
    "b": 28.8830714685987,
    "C": 38.7692669323537,
    "h": 0.84053358843058,
    "CMY_C": 0.04055596,
    "CMY_M": 0.3515905,
    "CMY_Y": 0.4848372,
    "CMYK_C": 0,
    "CMYK_M": 0.324182,
    "CMYK_Y": 0.4630611,
    "CMYK_K": 0.04055596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03020",
    "Farbtonhilfsbezeichnung": "D2.36.62",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "147",
    "Bcolor": "106",
    "Y": 41,
    "L": 70.279442787256,
    "a": 32.8936325248994,
    "b": 36.4874828976145,
    "C": 49.1256294502862,
    "h": 0.83715059330899,
    "CMY_C": 0.04387664,
    "CMY_M": 0.4231258,
    "CMY_Y": 0.5835257,
    "CMYK_C": 0,
    "CMYK_M": 0.396653,
    "CMYK_Y": 0.5644136,
    "CMYK_K": 0.04387664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03021",
    "Farbtonhilfsbezeichnung": "D3.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "145",
    "Bcolor": "113",
    "Y": 37,
    "L": 67.0610540140486,
    "a": 24.9234306207435,
    "b": 28.2754801389011,
    "C": 37.691911214376,
    "h": 0.84832471349262,
    "CMY_C": 0.1379282,
    "CMY_M": 0.4302782,
    "CMY_Y": 0.5581899,
    "CMYK_C": 0,
    "CMYK_M": 0.3391249,
    "CMYK_Y": 0.487502,
    "CMYK_K": 0.1379282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03022",
    "Farbtonhilfsbezeichnung": "D2.41.49",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "115",
    "Bcolor": "79",
    "Y": 25,
    "L": 56.9420352385289,
    "a": 30.1918165370141,
    "b": 33.3277135089712,
    "C": 44.9697929007993,
    "h": 0.83472713326738,
    "CMY_C": 0.2198263,
    "CMY_M": 0.550785,
    "CMY_Y": 0.6895185,
    "CMYK_C": 0,
    "CMYK_M": 0.4242116,
    "CMYK_Y": 0.6020354,
    "CMYK_K": 0.2198263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03023",
    "Farbtonhilfsbezeichnung": "D6.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "212",
    "Bcolor": "194",
    "Y": 70,
    "L": 87.1270830782071,
    "a": 8.34540501202158,
    "b": 12.094818752595,
    "C": 14.6945712925828,
    "h": 0.96681446471865,
    "CMY_C": 0.04610717,
    "CMY_M": 0.1672792,
    "CMY_Y": 0.2382399,
    "CMYK_C": 0,
    "CMYK_M": 0.127029,
    "CMYK_Y": 0.2014196,
    "CMYK_K": 0.04610717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03024",
    "Farbtonhilfsbezeichnung": "D2.16.75",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "193",
    "Bcolor": "170",
    "Y": 61,
    "L": 82.1168069705054,
    "a": 15.5771779400435,
    "b": 17.8009865540593,
    "C": 23.6542510951748,
    "h": 0.85192449889802,
    "CMY_C": 0.04056562,
    "CMY_M": 0.2422121,
    "CMY_Y": 0.3319316,
    "CMYK_C": 0,
    "CMYK_M": 0.2101723,
    "CMYK_Y": 0.3036852,
    "CMYK_K": 0.04056562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03025",
    "Farbtonhilfsbezeichnung": "D0.20.69",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "173",
    "Bcolor": "150",
    "Y": 50,
    "L": 76.3368691829961,
    "a": 21.3267673536574,
    "b": 20.7610102315587,
    "C": 29.7632416176719,
    "h": 0.77195665896065,
    "CMY_C": 0.06446592,
    "CMY_M": 0.3208106,
    "CMY_Y": 0.4122511,
    "CMYK_C": 0,
    "CMYK_M": 0.2740089,
    "CMYK_Y": 0.3717505,
    "CMYK_K": 0.06446592
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03026",
    "Farbtonhilfsbezeichnung": "C9.31.59",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "141",
    "Bcolor": "113",
    "Y": 36,
    "L": 66.2086376150534,
    "a": 28.1459872682321,
    "b": 26.7544349615016,
    "C": 38.8329291891907,
    "h": 0.76005674782395,
    "CMY_C": 0.1314443,
    "CMY_M": 0.4485163,
    "CMY_Y": 0.5550659,
    "CMYK_C": 0,
    "CMYK_M": 0.3650566,
    "CMYK_Y": 0.4877311,
    "CMYK_K": 0.1314443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03027",
    "Farbtonhilfsbezeichnung": "C9.42.50",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "114",
    "Bcolor": "84",
    "Y": 27,
    "L": 58.8716505385859,
    "a": 36.567889137956,
    "b": 33.3524902284169,
    "C": 49.493425022345,
    "h": 0.73944396226638,
    "CMY_C": 0.1632614,
    "CMY_M": 0.5528314,
    "CMY_Y": 0.6697062,
    "CMYK_C": 0,
    "CMYK_M": 0.4655815,
    "CMYK_Y": 0.6052604,
    "CMYK_K": 0.1632614
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03028",
    "Farbtonhilfsbezeichnung": "C9.34.49",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "116",
    "Bcolor": "91",
    "Y": 25,
    "L": 56.7530209552645,
    "a": 28.2066506183146,
    "b": 26.4698034979661,
    "C": 38.6815929910417,
    "h": 0.75364293529925,
    "CMY_C": 0.2405241,
    "CMY_M": 0.5450748,
    "CMY_Y": 0.6442057,
    "CMYK_C": 0,
    "CMYK_M": 0.4010012,
    "CMYK_Y": 0.5315265,
    "CMYK_K": 0.2405241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03029",
    "Farbtonhilfsbezeichnung": "C7.34.44",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "104",
    "Bcolor": "84",
    "Y": 20,
    "L": 52.2763803780824,
    "a": 29.5598529589499,
    "b": 24.2739171928597,
    "C": 38.2492870893112,
    "h": 0.68752194850564,
    "CMY_C": 0.286911,
    "CMY_M": 0.5936359,
    "CMY_Y": 0.6709934,
    "CMYK_C": 0,
    "CMYK_M": 0.4301354,
    "CMYK_Y": 0.5386178,
    "CMYK_K": 0.286911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03030",
    "Farbtonhilfsbezeichnung": "C9.30.38",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "95",
    "Bcolor": "76",
    "Y": 16,
    "L": 46.3839413767022,
    "a": 21.5162568998564,
    "b": 20.4652764185005,
    "C": 29.6947276442511,
    "h": 0.760369039294,
    "CMY_C": 0.3998271,
    "CMY_M": 0.6259362,
    "CMY_Y": 0.7019494,
    "CMYK_C": 0,
    "CMYK_M": 0.37674,
    "CMYK_Y": 0.5033922,
    "CMYK_K": 0.3998271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03031",
    "Farbtonhilfsbezeichnung": "D1.06.81",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "216",
    "Bcolor": "205",
    "Y": 72,
    "L": 87.8171484471172,
    "a": 6.62371083657204,
    "b": 7.51780123494348,
    "C": 10.0195249715064,
    "h": 0.84853864759965,
    "CMY_C": 0.06302147,
    "CMY_M": 0.1541499,
    "CMY_Y": 0.1974355,
    "CMYK_C": 0,
    "CMYK_M": 0.09725772,
    "CMYK_Y": 0.1434548,
    "CMYK_K": 0.06302147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03032",
    "Farbtonhilfsbezeichnung": "C8.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "202",
    "Bcolor": "192",
    "Y": 63,
    "L": 83.4016398073764,
    "a": 8.27629480873199,
    "b": 7.91344315367173,
    "C": 11.4507483732478,
    "h": 0.76298946730916,
    "CMY_C": 0.09966727,
    "CMY_M": 0.2067896,
    "CMY_Y": 0.2476851,
    "CMYK_C": 0,
    "CMYK_M": 0.1189809,
    "CMYK_Y": 0.1644035,
    "CMYK_K": 0.09966727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03033",
    "Farbtonhilfsbezeichnung": "C7.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "166",
    "Bcolor": "151",
    "Y": 44,
    "L": 72.001507254837,
    "a": 15.9598498287207,
    "b": 13.9645460873049,
    "C": 21.2067289787882,
    "h": 0.71881855440361,
    "CMY_C": 0.1610339,
    "CMY_M": 0.3503349,
    "CMY_Y": 0.4093907,
    "CMYK_C": 0,
    "CMYK_M": 0.2256361,
    "CMYK_Y": 0.2960272,
    "CMYK_K": 0.1610339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03035",
    "Farbtonhilfsbezeichnung": "C6.14.63",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "162",
    "Bcolor": "150",
    "Y": 41,
    "L": 70.4960157408048,
    "a": 15.4242614857385,
    "b": 11.9904908141819,
    "C": 19.5366248964711,
    "h": 0.66079440285145,
    "CMY_C": 0.1854947,
    "CMY_M": 0.3642469,
    "CMY_Y": 0.4110268,
    "CMYK_C": 0,
    "CMYK_M": 0.2194611,
    "CMYK_Y": 0.2768945,
    "CMYK_K": 0.1854947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03036",
    "Farbtonhilfsbezeichnung": "C8.23.49",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "123",
    "Bcolor": "105",
    "Y": 25,
    "L": 57.2266543999361,
    "a": 20.568322323041,
    "b": 18.6943526500959,
    "C": 27.7945085257979,
    "h": 0.7377053199947,
    "CMY_C": 0.2887822,
    "CMY_M": 0.5160522,
    "CMY_Y": 0.5883886,
    "CMYK_C": 0,
    "CMYK_M": 0.3195505,
    "CMYK_Y": 0.4212583,
    "CMYK_K": 0.2887822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03037",
    "Farbtonhilfsbezeichnung": "C8.26.45",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 21,
    "L": 52.743401542088,
    "a": 21.2583303090652,
    "b": 18.904580984274,
    "C": 28.4481948411545,
    "h": 0.72686007197521,
    "CMY_C": 0.3339638,
    "CMY_M": 0.5627283,
    "CMY_Y": 0.6324788,
    "CMYK_C": 0,
    "CMYK_M": 0.3434716,
    "CMYK_Y": 0.4481963,
    "CMYK_K": 0.3339638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03038",
    "Farbtonhilfsbezeichnung": "C7.25.44",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "106",
    "Bcolor": "90",
    "Y": 19,
    "L": 50.4405770833773,
    "a": 20.6364782270856,
    "b": 17.8948714820381,
    "C": 27.3146601475405,
    "h": 0.71436524790706,
    "CMY_C": 0.3640887,
    "CMY_M": 0.5834295,
    "CMY_Y": 0.6475862,
    "CMYK_C": 0,
    "CMYK_M": 0.3449236,
    "CMYK_Y": 0.4458129,
    "CMYK_K": 0.3640887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03039",
    "Farbtonhilfsbezeichnung": "C7.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "80",
    "Bcolor": "67",
    "Y": 11,
    "L": 39.3786233589809,
    "a": 19.6880656205698,
    "b": 15.8080818075547,
    "C": 25.2490668800691,
    "h": 0.67652322414252,
    "CMY_C": 0.4904926,
    "CMY_M": 0.6864793,
    "CMY_Y": 0.7356941,
    "CMYK_C": 0,
    "CMYK_M": 0.3846591,
    "CMYK_Y": 0.4812521,
    "CMYK_K": 0.4904926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03040",
    "Farbtonhilfsbezeichnung": "C5.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "206",
    "Bcolor": "201",
    "Y": 63,
    "L": 83.5895190853869,
    "a": 3.80673992059494,
    "b": 3.12686490061427,
    "C": 4.92631230534003,
    "h": 0.68765556498686,
    "CMY_C": 0.1439267,
    "CMY_M": 0.1924454,
    "CMY_Y": 0.211543,
    "CMYK_C": 0,
    "CMYK_M": 0.05667587,
    "CMYK_Y": 0.07898417,
    "CMYK_K": 0.1439267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03041",
    "Farbtonhilfsbezeichnung": "CN.02.75",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "201",
    "Bcolor": "196",
    "Y": 60,
    "L": 81.5982890665664,
    "a": 2.99107032324275,
    "b": 2.85393413208335,
    "C": 4.1341796899571,
    "h": 0.76194034786489,
    "CMY_C": 0.1727984,
    "CMY_M": 0.2121231,
    "CMY_Y": 0.2311536,
    "CMYK_C": 0,
    "CMYK_M": 0.04753948,
    "CMYK_Y": 0.07054538,
    "CMYK_K": 0.1727984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03042",
    "Farbtonhilfsbezeichnung": "C7.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "172",
    "Bcolor": "166",
    "Y": 43,
    "L": 71.6416608461524,
    "a": 5.29534562350076,
    "b": 4.51039479555788,
    "C": 6.95588574403895,
    "h": 0.70551836336689,
    "CMY_C": 0.2594495,
    "CMY_M": 0.3248516,
    "CMY_Y": 0.3481802,
    "CMYK_C": 0,
    "CMYK_M": 0.08831553,
    "CMYK_Y": 0.1198172,
    "CMYK_K": 0.2594495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03043",
    "Farbtonhilfsbezeichnung": "C7.05.56",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "151",
    "Bcolor": "146",
    "Y": 32,
    "L": 63.3266667109313,
    "a": 4.4977884686288,
    "b": 3.7434858187432,
    "C": 5.85181913456505,
    "h": 0.69412504039432,
    "CMY_C": 0.3556229,
    "CMY_M": 0.4096182,
    "CMY_Y": 0.4286994,
    "CMYK_C": 0,
    "CMYK_M": 0.0837945,
    "CMYK_Y": 0.1134065,
    "CMYK_K": 0.3556229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03044",
    "Farbtonhilfsbezeichnung": "C9.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "135",
    "Bcolor": "127",
    "Y": 26,
    "L": 58.4036043558051,
    "a": 8.65504245464349,
    "b": 7.54286875261883,
    "C": 11.4806197093587,
    "h": 0.71684420801913,
    "CMY_C": 0.3698901,
    "CMY_M": 0.4706819,
    "CMY_Y": 0.5035109,
    "CMYK_C": 0,
    "CMYK_M": 0.159959,
    "CMYK_Y": 0.2120595,
    "CMYK_K": 0.3698901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03045",
    "Farbtonhilfsbezeichnung": "C6.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "110",
    "Bcolor": "103",
    "Y": 17,
    "L": 48.3971411365572,
    "a": 7.61206382509677,
    "b": 6.46448275909612,
    "C": 9.98664373150449,
    "h": 0.70405372341128,
    "CMY_C": 0.4824534,
    "CMY_M": 0.5674677,
    "CMY_Y": 0.5941737,
    "CMYK_C": 0,
    "CMYK_M": 0.1642641,
    "CMYK_Y": 0.2158651,
    "CMYK_K": 0.4824534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03046",
    "Farbtonhilfsbezeichnung": "C8.10.28",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "84",
    "Bcolor": "78",
    "Y": 10,
    "L": 37.1660302707035,
    "a": 6.75718164098843,
    "b": 5.50146428789837,
    "C": 8.71353045787597,
    "h": 0.68331896684215,
    "CMY_C": 0.6012815,
    "CMY_M": 0.6724138,
    "CMY_Y": 0.6932985,
    "CMYK_C": 0,
    "CMYK_M": 0.1784023,
    "CMYK_Y": 0.230782,
    "CMYK_K": 0.6012815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03047",
    "Farbtonhilfsbezeichnung": "DN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "220",
    "Bcolor": "214",
    "Y": 73,
    "L": 88.3035642211092,
    "a": 2.48868464371638,
    "b": 2.9857813972884,
    "C": 3.8869579118204,
    "h": 0.87595261334681,
    "CMY_C": 0.1019927,
    "CMY_M": 0.1373988,
    "CMY_Y": 0.1594347,
    "CMYK_C": 0,
    "CMYK_M": 0.03942741,
    "CMYK_Y": 0.06396605,
    "CMYK_K": 0.1019927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03048",
    "Farbtonhilfsbezeichnung": "D5.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "201",
    "Bcolor": "191",
    "Y": 60,
    "L": 82.035340243738,
    "a": 4.2364184146983,
    "b": 6.18932091851574,
    "C": 7.50032895390404,
    "h": 0.97056786678083,
    "CMY_C": 0.1487934,
    "CMY_M": 0.2112599,
    "CMY_Y": 0.2504254,
    "CMYK_C": 0,
    "CMYK_M": 0.0733858,
    "CMYK_Y": 0.1193975,
    "CMYK_K": 0.1487934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03049",
    "Farbtonhilfsbezeichnung": "D4.05.66",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "176",
    "Bcolor": "167",
    "Y": 45,
    "L": 72.6718667269962,
    "a": 4.21505885671652,
    "b": 5.48296611438301,
    "C": 6.91589752505463,
    "h": 0.91539953031703,
    "CMY_C": 0.2532579,
    "CMY_M": 0.3116347,
    "CMY_Y": 0.344438,
    "CMYK_C": 0,
    "CMYK_M": 0.07817535,
    "CMYK_Y": 0.1221038,
    "CMYK_K": 0.2532579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03050",
    "Farbtonhilfsbezeichnung": "D5.05.45",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "127",
    "Bcolor": "122",
    "Y": 21,
    "L": 53.9500007629395,
    "a": 3.29022979736328,
    "b": 3.51118397712708,
    "C": 4.81186294555664,
    "h": 46.8606834411621,
    "CMY_C": 0.4613510966301,
    "CMY_M": 0.50204300880432,
    "CMY_Y": 0.52131676673889,
    "CMYK_C": 0,
    "CMYK_M": 0.07554440945387,
    "CMYK_Y": 0.11132607609034,
    "CMYK_K": 0.4613510966301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03051",
    "Farbtonhilfsbezeichnung": "D6.05.36",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "102",
    "Bcolor": "97",
    "Y": 14,
    "L": 43.7988252025832,
    "a": 2.89660933242586,
    "b": 3.33098102413385,
    "C": 4.41427006512247,
    "h": 0.85503494257725,
    "CMY_C": 0.5656222,
    "CMY_M": 0.6007361,
    "CMY_Y": 0.6184004,
    "CMYK_C": 0,
    "CMYK_M": 0.08083725,
    "CMYK_Y": 0.121503,
    "CMYK_K": 0.5656222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03053",
    "Farbtonhilfsbezeichnung": "D7.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "232",
    "Bcolor": "223",
    "Y": 82,
    "L": 92.8829040527344,
    "a": 3.11132884025574,
    "b": 5.13091945648193,
    "C": 6.00055837631226,
    "h": 58.7678756713867,
    "CMY_C": 0.0390972495079,
    "CMY_M": 0.08854812383652,
    "CMY_Y": 0.1249190568924,
    "CMYK_C": 0,
    "CMYK_M": 0.05146293342113,
    "CMYK_Y": 0.0893137305975,
    "CMYK_K": 0.0390972495079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03054",
    "Farbtonhilfsbezeichnung": "D6.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "222",
    "Bcolor": "212",
    "Y": 75,
    "L": 89.4067916870117,
    "a": 3.22004079818726,
    "b": 5.80262660980225,
    "C": 6.63619899749756,
    "h": 60.9728736877441,
    "CMY_C": 0.07535535097122,
    "CMY_M": 0.12769424915314,
    "CMY_Y": 0.16801905632019,
    "CMYK_C": 0,
    "CMYK_M": 0.0566043369472,
    "CMYK_Y": 0.10021547973156,
    "CMYK_K": 0.07535535097122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03055",
    "Farbtonhilfsbezeichnung": "D5.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "169",
    "Bcolor": "148",
    "Y": 44,
    "L": 71.9415087232836,
    "a": 11.2383547738673,
    "b": 15.0737787661121,
    "C": 18.8021122300926,
    "h": 0.9301450846788,
    "CMY_C": 0.1897857,
    "CMY_M": 0.3389476,
    "CMY_Y": 0.4186586,
    "CMYK_C": 0,
    "CMYK_M": 0.1841018,
    "CMYK_Y": 0.2824844,
    "CMYK_K": 0.1897857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03056",
    "Farbtonhilfsbezeichnung": "D5.25.55",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "138",
    "Bcolor": "110",
    "Y": 31,
    "L": 62.4910689654645,
    "a": 18.2130972079327,
    "b": 23.4459792694462,
    "C": 29.6889011889782,
    "h": 0.91035574783928,
    "CMY_C": 0.2363134,
    "CMY_M": 0.4572125,
    "CMY_Y": 0.5704725,
    "CMYK_C": 0,
    "CMYK_M": 0.2892536,
    "CMYK_Y": 0.4375606,
    "CMYK_K": 0.2363134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03057",
    "Farbtonhilfsbezeichnung": "D7.29.49",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "123",
    "Bcolor": "92",
    "Y": 24,
    "L": 56.470792443253,
    "a": 17.93612145477,
    "b": 24.7884184435416,
    "C": 30.5968975841077,
    "h": 0.94442700534851,
    "CMY_C": 0.3029781,
    "CMY_M": 0.517598,
    "CMY_Y": 0.6377303,
    "CMYK_C": 0,
    "CMYK_M": 0.3079098,
    "CMYK_Y": 0.4802607,
    "CMYK_K": 0.3029781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03058",
    "Farbtonhilfsbezeichnung": "D8.30.46",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "114",
    "Bcolor": "81",
    "Y": 21,
    "L": 52.5536073630149,
    "a": 15.8351343448974,
    "b": 25.917498147767,
    "C": 30.3721614305017,
    "h": 1.02234066756538,
    "CMY_C": 0.3563941,
    "CMY_M": 0.5510938,
    "CMY_Y": 0.6828007,
    "CMYK_C": 0,
    "CMYK_M": 0.3025138,
    "CMYK_Y": 0.5071529,
    "CMYK_K": 0.3563941
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03059",
    "Farbtonhilfsbezeichnung": "D9.22.42",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "111",
    "Bcolor": "87",
    "Y": 18,
    "L": 49.7012336074726,
    "a": 11.1761165089993,
    "b": 18.5350282522746,
    "C": 21.6437716799856,
    "h": 1.02819386511144,
    "CMY_C": 0.4244025,
    "CMY_M": 0.5658492,
    "CMY_Y": 0.6606065,
    "CMYK_C": 0,
    "CMYK_M": 0.245739,
    "CMYK_Y": 0.4103631,
    "CMYK_K": 0.4244025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03060",
    "Farbtonhilfsbezeichnung": "D2.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "198",
    "Bcolor": "181",
    "Y": 61,
    "L": 82.3528223322026,
    "a": 10.6015905518362,
    "b": 12.058574202473,
    "C": 16.0562428365209,
    "h": 0.84960691251956,
    "CMY_C": 0.08451016,
    "CMY_M": 0.2251733,
    "CMY_Y": 0.2885981,
    "CMYK_C": 0,
    "CMYK_M": 0.153648,
    "CMYK_Y": 0.2229276,
    "CMYK_K": 0.08451016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03061",
    "Farbtonhilfsbezeichnung": "D2.11.70",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "183",
    "Bcolor": "167",
    "Y": 52,
    "L": 77.2957262035218,
    "a": 11.4584116922606,
    "b": 12.4797113496386,
    "C": 16.9422074677308,
    "h": 0.82803645483063,
    "CMY_C": 0.1345299,
    "CMY_M": 0.2819913,
    "CMY_Y": 0.3447625,
    "CMYK_C": 0,
    "CMYK_M": 0.170383,
    "CMYK_Y": 0.2429115,
    "CMYK_K": 0.1345299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03062",
    "Farbtonhilfsbezeichnung": "D2.16.65",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "167",
    "Bcolor": "148",
    "Y": 44,
    "L": 72.210123793844,
    "a": 14.5281348520051,
    "b": 15.5334212471262,
    "C": 21.2686125057259,
    "h": 0.8188266362015,
    "CMY_C": 0.164562,
    "CMY_M": 0.344727,
    "CMY_Y": 0.418588,
    "CMYK_C": 0,
    "CMYK_M": 0.2156534,
    "CMYK_Y": 0.3040632,
    "CMYK_K": 0.164562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03063",
    "Farbtonhilfsbezeichnung": "D2.21.60",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "151",
    "Bcolor": "127",
    "Y": 37,
    "L": 67.0416538652477,
    "a": 17.289123385751,
    "b": 19.7960991724156,
    "C": 26.2830616536932,
    "h": 0.85289586858934,
    "CMY_C": 0.1969714,
    "CMY_M": 0.4070948,
    "CMY_Y": 0.5003145,
    "CMYK_C": 0,
    "CMYK_M": 0.2616636,
    "CMYK_Y": 0.3777488,
    "CMYK_K": 0.1969714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03064",
    "Farbtonhilfsbezeichnung": "D2.28.48",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "118",
    "Bcolor": "93",
    "Y": 23,
    "L": 55.5622594428146,
    "a": 21.6967626516126,
    "b": 23.0925513301948,
    "C": 31.6862026203534,
    "h": 0.8165515116675,
    "CMY_C": 0.2942852,
    "CMY_M": 0.5368333,
    "CMY_Y": 0.6339228,
    "CMYK_C": 0,
    "CMYK_M": 0.3436913,
    "CMYK_Y": 0.4812675,
    "CMYK_K": 0.2942852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03065",
    "Farbtonhilfsbezeichnung": "D2.31.41",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "102",
    "Bcolor": "80",
    "Y": 18,
    "L": 48.9469641273172,
    "a": 20.7876985232626,
    "b": 21.8446215486677,
    "C": 30.1548652873557,
    "h": 0.81018467670595,
    "CMY_C": 0.3739985,
    "CMY_M": 0.599259,
    "CMY_Y": 0.6876584,
    "CMYK_C": 0,
    "CMYK_M": 0.3598403,
    "CMYK_Y": 0.5010529,
    "CMYK_K": 0.3739985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03066",
    "Farbtonhilfsbezeichnung": "D2.22.32",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "85",
    "Bcolor": "70",
    "Y": 11,
    "L": 39.7233915164322,
    "a": 13.1855991536053,
    "b": 14.2088434438263,
    "C": 19.3843043994548,
    "h": 0.82273306483752,
    "CMY_C": 0.5237512,
    "CMY_M": 0.6656164,
    "CMY_Y": 0.7237035,
    "CMYK_C": 0,
    "CMYK_M": 0.2978804,
    "CMYK_Y": 0.4198484,
    "CMYK_K": 0.5237512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03067",
    "Farbtonhilfsbezeichnung": "D7.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "219",
    "Bcolor": "204",
    "Y": 74,
    "L": 88.8597015718206,
    "a": 6.09865230540763,
    "b": 9.27108692424439,
    "C": 11.0971443488471,
    "h": 0.98894744344501,
    "CMY_C": 0.05016069,
    "CMY_M": 0.1418003,
    "CMY_Y": 0.1991125,
    "CMYK_C": 0,
    "CMYK_M": 0.09647904,
    "CMYK_Y": 0.1568179,
    "CMYK_K": 0.05016069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03068",
    "Farbtonhilfsbezeichnung": "D5.18.76",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "197",
    "Bcolor": "166",
    "Y": 64,
    "L": 83.858116954252,
    "a": 16.6913778591685,
    "b": 22.5130559596283,
    "C": 28.0256986260628,
    "h": 0.9328162962307,
    "CMY_C": 0.003445083,
    "CMY_M": 0.2274557,
    "CMY_Y": 0.3478593,
    "CMYK_C": 0,
    "CMYK_M": 0.2247851,
    "CMYK_Y": 0.3456048,
    "CMYK_K": 0.003445083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03069",
    "Farbtonhilfsbezeichnung": "D4.21.71",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "180",
    "Bcolor": "149",
    "Y": 54,
    "L": 78.233130885353,
    "a": 19.0910643263343,
    "b": 23.7190726046461,
    "C": 30.4477116108372,
    "h": 0.89308538745302,
    "CMY_C": 0.05108577,
    "CMY_M": 0.2949823,
    "CMY_Y": 0.4145302,
    "CMYK_C": 0,
    "CMYK_M": 0.257027,
    "CMYK_Y": 0.3830108,
    "CMYK_K": 0.05108577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03070",
    "Farbtonhilfsbezeichnung": "D6.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "187",
    "Bcolor": "154",
    "Y": 57,
    "L": 80.4289666142984,
    "a": 16.6428465815726,
    "b": 24.0737345182447,
    "C": 29.2665173191599,
    "h": 0.96591424325059,
    "CMY_C": 0.04052423,
    "CMY_M": 0.2647722,
    "CMY_Y": 0.3949633,
    "CMYK_C": 0,
    "CMYK_M": 0.2337193,
    "CMYK_Y": 0.3694091,
    "CMYK_K": 0.04052423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03071",
    "Farbtonhilfsbezeichnung": "D6.24.71",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "178",
    "Bcolor": "141",
    "Y": 53,
    "L": 77.7608106133214,
    "a": 19.3647693949975,
    "b": 27.4854218586591,
    "C": 33.6220568744669,
    "h": 0.9570252505138,
    "CMY_C": 0.04824404,
    "CMY_M": 0.3016139,
    "CMY_Y": 0.4466365,
    "CMYK_C": 0,
    "CMYK_M": 0.2662131,
    "CMYK_Y": 0.4185868,
    "CMYK_K": 0.04824404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03072",
    "Farbtonhilfsbezeichnung": "D6.26.65",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "162",
    "Bcolor": "128",
    "Y": 43,
    "L": 71.8329412978186,
    "a": 19.739029634362,
    "b": 26.2029115679157,
    "C": 32.8058206046158,
    "h": 0.9251773981332,
    "CMY_C": 0.1166929,
    "CMY_M": 0.3651896,
    "CMY_Y": 0.4972444,
    "CMYK_C": 0,
    "CMYK_M": 0.2813254,
    "CMYK_Y": 0.4308258,
    "CMYK_K": 0.1166929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03073",
    "Farbtonhilfsbezeichnung": "D6.34.55",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "134",
    "Bcolor": "95",
    "Y": 31,
    "L": 62.4590253284754,
    "a": 24.063570898025,
    "b": 31.7022108976835,
    "C": 39.8005731135304,
    "h": 0.92152817913325,
    "CMY_C": 0.1914336,
    "CMY_M": 0.4757213,
    "CMY_Y": 0.627386,
    "CMYK_C": 0,
    "CMYK_M": 0.3515947,
    "CMYK_Y": 0.5391671,
    "CMYK_K": 0.1914336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03074",
    "Farbtonhilfsbezeichnung": "D6.35.44",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "113",
    "Bcolor": "78",
    "Y": 21,
    "L": 53.0895754547036,
    "a": 19.9855145887107,
    "b": 28.374336700819,
    "C": 34.7062498202703,
    "h": 0.95715567128756,
    "CMY_C": 0.3243812,
    "CMY_M": 0.5575337,
    "CMY_Y": 0.6936926,
    "CMYK_C": 0,
    "CMYK_M": 0.3450949,
    "CMYK_Y": 0.5466269,
    "CMYK_K": 0.3243812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03075",
    "Farbtonhilfsbezeichnung": "D9.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "213",
    "Bcolor": "193",
    "Y": 70,
    "L": 86.9715587223482,
    "a": 6.86324127252058,
    "b": 12.3052642906168,
    "C": 14.0898406671885,
    "h": 1.06202373050163,
    "CMY_C": 0.05784937,
    "CMY_M": 0.1653142,
    "CMY_Y": 0.241699,
    "CMYK_C": 0,
    "CMYK_M": 0.1140633,
    "CMYK_Y": 0.1951382,
    "CMYK_K": 0.05784937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03076",
    "Farbtonhilfsbezeichnung": "E0.20.77",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "200",
    "Bcolor": "163",
    "Y": 65,
    "L": 84.5492078677713,
    "a": 14.3456805229253,
    "b": 24.9445392671978,
    "C": 28.7754859023894,
    "h": 1.04888460834527,
    "CMY_C": 0.00593507,
    "CMY_M": 0.2141649,
    "CMY_Y": 0.3589671,
    "CMYK_C": 0,
    "CMYK_M": 0.209473,
    "CMYK_Y": 0.3551398,
    "CMYK_K": 0.00593507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03077",
    "Farbtonhilfsbezeichnung": "E0.29.71",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "178",
    "Bcolor": "131",
    "Y": 53,
    "L": 77.9250540560328,
    "a": 19.7223689751091,
    "b": 33.3731945207303,
    "C": 38.7652157289089,
    "h": 1.0370471613632,
    "CMY_C": 0.03463825,
    "CMY_M": 0.3020564,
    "CMY_Y": 0.4879855,
    "CMYK_C": 0,
    "CMYK_M": 0.2770135,
    "CMYK_Y": 0.4696138,
    "CMYK_K": 0.03463825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03078",
    "Farbtonhilfsbezeichnung": "E0.40.67",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "164",
    "Bcolor": "102",
    "Y": 47,
    "L": 74.465202072203,
    "a": 25.756721653201,
    "b": 43.7636472435177,
    "C": 50.7805625251978,
    "h": 1.03884481623042,
    "CMY_C": 0.02595559,
    "CMY_M": 0.3581372,
    "CMY_Y": 0.5985352,
    "CMYK_C": 0,
    "CMYK_M": 0.3410334,
    "CMYK_Y": 0.5878373,
    "CMYK_K": 0.02595559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03079",
    "Farbtonhilfsbezeichnung": "D9.40.64",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "157",
    "Bcolor": "98",
    "Y": 44,
    "L": 72.0584314377661,
    "a": 26.1204896333784,
    "b": 43.0207699835575,
    "C": 50.3295800565193,
    "h": 1.02512876490387,
    "CMY_C": 0.05355374,
    "CMY_M": 0.3844414,
    "CMY_Y": 0.6165243,
    "CMYK_C": 0,
    "CMYK_M": 0.3496107,
    "CMYK_Y": 0.5948257,
    "CMYK_K": 0.05355374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03080",
    "Farbtonhilfsbezeichnung": "E0.47.55",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "131",
    "Bcolor": "71",
    "Y": 31,
    "L": 62.150812942805,
    "a": 26.0499066283822,
    "b": 44.0584578125612,
    "C": 51.1834479120806,
    "h": 1.03682971689305,
    "CMY_C": 0.1706145,
    "CMY_M": 0.4868157,
    "CMY_Y": 0.7204019,
    "CMYK_C": 0,
    "CMYK_M": 0.3812476,
    "CMYK_Y": 0.6628852,
    "CMYK_K": 0.1706145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03081",
    "Farbtonhilfsbezeichnung": "E6.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "227",
    "Bcolor": "206",
    "Y": 79,
    "L": 91.3107527150816,
    "a": 4.27980816142864,
    "b": 11.6427346020964,
    "C": 12.4044357757007,
    "h": 1.21853367981289,
    "CMY_C": 0.02912161,
    "CMY_M": 0.1107297,
    "CMY_Y": 0.1903332,
    "CMYK_C": 0,
    "CMYK_M": 0.08405591,
    "CMYK_Y": 0.1660471,
    "CMYK_K": 0.02912161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03082",
    "Farbtonhilfsbezeichnung": "E0.33.68",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "167",
    "Bcolor": "117",
    "Y": 47,
    "L": 74.3876502099667,
    "a": 21.0475737330486,
    "b": 35.8394735271537,
    "C": 41.5628226032793,
    "h": 1.03978709211487,
    "CMY_C": 0.06460644,
    "CMY_M": 0.3438421,
    "CMY_Y": 0.541356,
    "CMYK_C": 0,
    "CMYK_M": 0.2985221,
    "CMYK_Y": 0.509678,
    "CMYK_K": 0.06460644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03083",
    "Farbtonhilfsbezeichnung": "E0.39.59",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "142",
    "Bcolor": "90",
    "Y": 34,
    "L": 65.3430193843135,
    "a": 23.0056186252878,
    "b": 38.1182773434736,
    "C": 44.5225960155758,
    "h": 1.02778345899507,
    "CMY_C": 0.1562536,
    "CMY_M": 0.4441884,
    "CMY_Y": 0.6462756,
    "CMYK_C": 0,
    "CMYK_M": 0.3412575,
    "CMYK_Y": 0.5807693,
    "CMYK_K": 0.1562536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03084",
    "Farbtonhilfsbezeichnung": "E0.34.56",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "139",
    "Bcolor": "94",
    "Y": 32,
    "L": 63.4091082989683,
    "a": 19.5519495247054,
    "b": 33.3435380931478,
    "C": 38.6532050777917,
    "h": 1.04045249831603,
    "CMY_C": 0.204076,
    "CMY_M": 0.4533846,
    "CMY_Y": 0.6311524,
    "CMYK_C": 0,
    "CMYK_M": 0.3132316,
    "CMYK_Y": 0.5365793,
    "CMYK_K": 0.204076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03085",
    "Farbtonhilfsbezeichnung": "D9.41.49",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "122",
    "Bcolor": "81",
    "Y": 25,
    "L": 57.5103569030762,
    "a": 22.0343818664551,
    "b": 32.8967895507813,
    "C": 39.594352722168,
    "h": 56.1856880187988,
    "CMY_C": 0.25798839330673,
    "CMY_M": 0.52004897594452,
    "CMY_Y": 0.68344956636429,
    "CMYK_C": 0,
    "CMYK_M": 0.35317584872246,
    "CMYK_Y": 0.57338881492615,
    "CMYK_K": 0.25798839330673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03086",
    "Farbtonhilfsbezeichnung": "E0.33.39",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "102",
    "Bcolor": "70",
    "Y": 16,
    "L": 46.9733620895772,
    "a": 13.971722097312,
    "b": 24.2812171435749,
    "C": 28.0140415566542,
    "h": 1.04865190454933,
    "CMY_C": 0.4292693,
    "CMY_M": 0.6004337,
    "CMY_Y": 0.7235866,
    "CMYK_C": 0,
    "CMYK_M": 0.299904,
    "CMYK_Y": 0.5156851,
    "CMYK_K": 0.4292693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03087",
    "Farbtonhilfsbezeichnung": "E0.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "219",
    "Bcolor": "196",
    "Y": 74,
    "L": 89.1167273992908,
    "a": 6.77437834872091,
    "b": 14.232100793788,
    "C": 15.7621348495742,
    "h": 1.12653821817719,
    "CMY_C": 0.02914803,
    "CMY_M": 0.1419273,
    "CMY_Y": 0.2328473,
    "CMYK_C": 0,
    "CMYK_M": 0.1161653,
    "CMYK_Y": 0.209815,
    "CMYK_K": 0.02914803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03088",
    "Farbtonhilfsbezeichnung": "E2.19.74",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "194",
    "Bcolor": "158",
    "Y": 60,
    "L": 81.5798081260502,
    "a": 11.4410238330884,
    "b": 23.6540912683444,
    "C": 26.2757123610468,
    "h": 1.12028930660877,
    "CMY_C": 0.06184173,
    "CMY_M": 0.2384656,
    "CMY_Y": 0.3810005,
    "CMYK_C": 0,
    "CMYK_M": 0.1882666,
    "CMYK_Y": 0.3401971,
    "CMYK_K": 0.06184173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03090",
    "Farbtonhilfsbezeichnung": "E0.27.60",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "152",
    "Bcolor": "116",
    "Y": 37,
    "L": 67.3949890136719,
    "a": 16.2403354644775,
    "b": 26.5486793518066,
    "C": 31.1220321655273,
    "h": 58.5450744628906,
    "CMY_C": 0.18790489435196,
    "CMY_M": 0.40197545289993,
    "CMY_Y": 0.5446103811264,
    "CMYK_C": 0,
    "CMYK_M": 0.26360282301903,
    "CMYK_Y": 0.43924102187157,
    "CMYK_K": 0.18790489435196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03091",
    "Farbtonhilfsbezeichnung": "E0.30.48",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "124",
    "Bcolor": "90",
    "Y": 24,
    "L": 56.0500031628668,
    "a": 14.6495627870855,
    "b": 25.5629251654497,
    "C": 29.4630757536809,
    "h": 1.05040730492183,
    "CMY_C": 0.3252841,
    "CMY_M": 0.5131992,
    "CMY_Y": 0.647786,
    "CMYK_C": 0,
    "CMYK_M": 0.2785099,
    "CMYK_Y": 0.4779817,
    "CMYK_K": 0.3252841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03092",
    "Farbtonhilfsbezeichnung": "E0.26.45",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "119",
    "Bcolor": "91",
    "Y": 22,
    "L": 53.5407479571983,
    "a": 12.5691552759141,
    "b": 21.2242988591524,
    "C": 24.6668710300406,
    "h": 1.03612748396853,
    "CMY_C": 0.3711041,
    "CMY_M": 0.5320304,
    "CMY_Y": 0.642302,
    "CMYK_C": 0,
    "CMYK_M": 0.255887,
    "CMYK_Y": 0.4312285,
    "CMYK_K": 0.3711041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03093",
    "Farbtonhilfsbezeichnung": "E0.22.39",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "106",
    "Bcolor": "84",
    "Y": 16,
    "L": 47.2224346833738,
    "a": 9.23963489470336,
    "b": 16.3329616477043,
    "C": 18.7653001354308,
    "h": 1.05597568944333,
    "CMY_C": 0.4652242,
    "CMY_M": 0.5848613,
    "CMY_Y": 0.6695074,
    "CMYK_C": 0,
    "CMYK_M": 0.2237145,
    "CMYK_Y": 0.381998,
    "CMYK_K": 0.4652242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03094",
    "Farbtonhilfsbezeichnung": "E4.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.9305132694119,
    "a": 2.50980920534033,
    "b": 5.83045257159254,
    "C": 6.34770190201155,
    "h": 1.16430539888905,
    "CMY_C": 0.02969101,
    "CMY_M": 0.075582,
    "CMY_Y": 0.1186618,
    "CMYK_C": 0,
    "CMYK_M": 0.04729523,
    "CMYK_Y": 0.0916932,
    "CMYK_K": 0.02969101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03095",
    "Farbtonhilfsbezeichnung": "E0.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "200",
    "Bcolor": "179",
    "Y": 61,
    "L": 82.4448710382233,
    "a": 7.07703930786568,
    "b": 13.4244428020432,
    "C": 15.1756433112539,
    "h": 1.08564529963686,
    "CMY_C": 0.1045155,
    "CMY_M": 0.2156236,
    "CMY_Y": 0.2981249,
    "CMYK_C": 0,
    "CMYK_M": 0.124076,
    "CMYK_Y": 0.2162063,
    "CMYK_K": 0.1045155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03096",
    "Farbtonhilfsbezeichnung": "D9.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "171",
    "Bcolor": "149",
    "Y": 44,
    "L": 72.4514749340914,
    "a": 9.4333279708636,
    "b": 15.4927635886181,
    "C": 18.1387265324413,
    "h": 1.0238685566113,
    "CMY_C": 0.1950463,
    "CMY_M": 0.3291164,
    "CMY_Y": 0.4167151,
    "CMYK_C": 0,
    "CMYK_M": 0.1665563,
    "CMYK_Y": 0.2753808,
    "CMYK_K": 0.1950463
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03097",
    "Farbtonhilfsbezeichnung": "E0.19.59",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "153",
    "Bcolor": "126",
    "Y": 36,
    "L": 66.3704717611349,
    "a": 11.8073045483016,
    "b": 19.5927359988553,
    "C": 22.8754834837908,
    "h": 1.02844022741368,
    "CMY_C": 0.2386315,
    "CMY_M": 0.3996431,
    "CMY_Y": 0.5066244,
    "CMYK_C": 0,
    "CMYK_M": 0.2114766,
    "CMYK_Y": 0.3519885,
    "CMYK_K": 0.2386315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03098",
    "Farbtonhilfsbezeichnung": "E0.15.56",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "145",
    "Bcolor": "125",
    "Y": 31,
    "L": 62.487312767412,
    "a": 8.25519469490016,
    "b": 14.4344152846564,
    "C": 16.6283067105653,
    "h": 1.05128693408255,
    "CMY_C": 0.3136612,
    "CMY_M": 0.4297236,
    "CMY_Y": 0.5100413,
    "CMYK_C": 0,
    "CMYK_M": 0.1691036,
    "CMYK_Y": 0.286127,
    "CMYK_K": 0.3136612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03099",
    "Farbtonhilfsbezeichnung": "D9.16.35",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "99",
    "Bcolor": "85",
    "Y": 14,
    "L": 43.6234815600597,
    "a": 6.40992598279333,
    "b": 10.873045857333,
    "C": 12.6218175125675,
    "h": 1.03811507279839,
    "CMY_C": 0.5285935,
    "CMY_M": 0.6118452,
    "CMY_Y": 0.6678975,
    "CMYK_C": 0,
    "CMYK_M": 0.1766028,
    "CMYK_Y": 0.2955072,
    "CMYK_K": 0.5285935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03100",
    "Farbtonhilfsbezeichnung": "E3.10.29",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "86",
    "Bcolor": "77",
    "Y": 10,
    "L": 37.1898496373267,
    "a": 2.84475858366307,
    "b": 6.03674071220804,
    "C": 6.67344662267968,
    "h": 1.13041961734774,
    "CMY_C": 0.6232997,
    "CMY_M": 0.6638486,
    "CMY_Y": 0.6969493,
    "CMYK_C": 0,
    "CMYK_M": 0.1076424,
    "CMYK_Y": 0.1955125,
    "CMYK_K": 0.6232997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03101",
    "Farbtonhilfsbezeichnung": "E3.09.39",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "110",
    "Bcolor": "100",
    "Y": 16,
    "L": 47.3024685023203,
    "a": 3.29253668343688,
    "b": 6.96617320493524,
    "C": 7.70508708146347,
    "h": 1.1292700680354,
    "CMY_C": 0.5194846,
    "CMY_M": 0.5685248,
    "CMY_Y": 0.6085168,
    "CMYK_C": 0,
    "CMYK_M": 0.1020576,
    "CMYK_Y": 0.1852847,
    "CMYK_K": 0.5194846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03102",
    "Farbtonhilfsbezeichnung": "E3.11.50",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "136",
    "Bcolor": "122",
    "Y": 26,
    "L": 58.039183929226,
    "a": 4.87355187079347,
    "b": 9.67864059207284,
    "C": 10.8364012267835,
    "h": 1.10432326944179,
    "CMY_C": 0.3932013,
    "CMY_M": 0.4659823,
    "CMY_Y": 0.5221376,
    "CMYK_C": 0,
    "CMYK_M": 0.1199425,
    "CMYK_Y": 0.2124861,
    "CMYK_K": 0.3932013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03103",
    "Farbtonhilfsbezeichnung": "E4.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "197",
    "Bcolor": "188",
    "Y": 57,
    "L": 80.190671153768,
    "a": 2.58499443731985,
    "b": 5.18861028394491,
    "C": 5.79688475990626,
    "h": 1.1085853084144,
    "CMY_C": 0.1841589,
    "CMY_M": 0.2270728,
    "CMY_Y": 0.2631582,
    "CMYK_C": 0,
    "CMYK_M": 0.0526008,
    "CMYK_Y": 0.09683166,
    "CMYK_K": 0.1841589
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03104",
    "Farbtonhilfsbezeichnung": "E1.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "213",
    "Bcolor": "206",
    "Y": 68,
    "L": 85.897371486328,
    "a": 1.9541177664234,
    "b": 3.79494319291536,
    "C": 4.26850911706959,
    "h": 1.0952787502986,
    "CMY_C": 0.1302522,
    "CMY_M": 0.1628843,
    "CMY_Y": 0.1916742,
    "CMYK_C": 0,
    "CMYK_M": 0.03751914,
    "CMYK_Y": 0.07062058,
    "CMYK_K": 0.1302522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03105",
    "Farbtonhilfsbezeichnung": "E4.11.72",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "191",
    "Bcolor": "169",
    "Y": 55,
    "L": 78.8523663056797,
    "a": 6.21750393066411,
    "b": 13.5072445688704,
    "C": 14.8695329775721,
    "h": 1.13940272242623,
    "CMY_C": 0.1504221,
    "CMY_M": 0.2523992,
    "CMY_Y": 0.3367172,
    "CMYK_C": 0,
    "CMYK_M": 0.1200327,
    "CMYK_Y": 0.2192796,
    "CMYK_K": 0.1504221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03106",
    "Farbtonhilfsbezeichnung": "E3.16.65",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "172",
    "Bcolor": "146",
    "Y": 44,
    "L": 72.5098333197214,
    "a": 7.85150215778235,
    "b": 17.0848045518937,
    "C": 18.802569843244,
    "h": 1.14002034970164,
    "CMY_C": 0.2013497,
    "CMY_M": 0.3249431,
    "CMY_Y": 0.4276972,
    "CMYK_C": 0,
    "CMYK_M": 0.1547529,
    "CMYK_Y": 0.2834126,
    "CMYK_K": 0.2013497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03107",
    "Farbtonhilfsbezeichnung": "E5.21.58",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "153",
    "Bcolor": "120",
    "Y": 35,
    "L": 65.9765577776871,
    "a": 9.36142387744149,
    "b": 22.4919255896855,
    "C": 24.362326936175,
    "h": 1.17639212675473,
    "CMY_C": 0.2528739,
    "CMY_M": 0.3981904,
    "CMY_Y": 0.5313603,
    "CMYK_C": 0,
    "CMYK_M": 0.1945006,
    "CMYK_Y": 0.3727435,
    "CMYK_K": 0.2528739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03108",
    "Farbtonhilfsbezeichnung": "E4.15.56",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "145",
    "Bcolor": "122",
    "Y": 30,
    "L": 61.9258235822964,
    "a": 6.46617714553011,
    "b": 15.3736917759673,
    "C": 16.6781847243583,
    "h": 1.17265828215498,
    "CMY_C": 0.3291423,
    "CMY_M": 0.4313965,
    "CMY_Y": 0.5223796,
    "CMYK_C": 0,
    "CMYK_M": 0.152423,
    "CMYK_Y": 0.2880452,
    "CMYK_K": 0.3291423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03109",
    "Farbtonhilfsbezeichnung": "E4.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "134",
    "Bcolor": "107",
    "Y": 26,
    "L": 58.2486777606728,
    "a": 8.50915759607679,
    "b": 18.7318943514091,
    "C": 20.5740037179744,
    "h": 1.14440511281665,
    "CMY_C": 0.3490451,
    "CMY_M": 0.474398,
    "CMY_Y": 0.5810698,
    "CMYK_C": 0,
    "CMYK_M": 0.1925677,
    "CMYK_Y": 0.3564374,
    "CMYK_K": 0.3490451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03110",
    "Farbtonhilfsbezeichnung": "E2.22.47",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "124",
    "Bcolor": "98",
    "Y": 23,
    "L": 54.6973375348802,
    "a": 9.88314125255035,
    "b": 18.8873807298436,
    "C": 21.3168860730626,
    "h": 1.08870891859094,
    "CMY_C": 0.3784001,
    "CMY_M": 0.5134075,
    "CMY_Y": 0.6160182,
    "CMYK_C": 0,
    "CMYK_M": 0.2171934,
    "CMYK_Y": 0.3822685,
    "CMYK_K": 0.3784001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03111",
    "Farbtonhilfsbezeichnung": "E4.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 74,
    "L": 88.9406433105469,
    "a": 4.89180326461792,
    "b": 10.6441535949707,
    "C": 11.7144250869751,
    "h": 65.3175964355469,
    "CMY_C": 0.05423271656036,
    "CMY_M": 0.13823544979095,
    "CMY_Y": 0.2085525393486,
    "CMYK_C": 0,
    "CMYK_M": 0.08881966769695,
    "CMYK_Y": 0.16316892206669,
    "CMYK_K": 0.05423271656036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03112",
    "Farbtonhilfsbezeichnung": "E5.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "219",
    "Bcolor": "194",
    "Y": 74,
    "L": 88.8087916272259,
    "a": 5.79785762717927,
    "b": 14.4063707288172,
    "C": 15.5292842926248,
    "h": 1.18817884662989,
    "CMY_C": 0.03917964,
    "CMY_M": 0.1429335,
    "CMY_Y": 0.2376122,
    "CMYK_C": 0,
    "CMYK_M": 0.1079847,
    "CMYK_Y": 0.2065241,
    "CMYK_K": 0.03917964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03113",
    "Farbtonhilfsbezeichnung": "E3.11.77",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "207",
    "Bcolor": "184",
    "Y": 66,
    "L": 84.8292488432069,
    "a": 6.47341767274229,
    "b": 14.0687271110233,
    "C": 15.486581898218,
    "h": 1.13955180472832,
    "CMY_C": 0.08030257,
    "CMY_M": 0.1882824,
    "CMY_Y": 0.2776051,
    "CMYK_C": 0,
    "CMYK_M": 0.117408,
    "CMYK_Y": 0.2145298,
    "CMYK_K": 0.08030257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03114",
    "Farbtonhilfsbezeichnung": "E2.16.76",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "201",
    "Bcolor": "171",
    "Y": 63,
    "L": 83.6563157049768,
    "a": 10.083364550464,
    "b": 19.3937276547234,
    "C": 21.8584288777382,
    "h": 1.09133279750412,
    "CMY_C": 0.0561308,
    "CMY_M": 0.2114687,
    "CMY_Y": 0.3283674,
    "CMYK_C": 0,
    "CMYK_M": 0.1645757,
    "CMYK_Y": 0.2884262,
    "CMYK_K": 0.0561308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03115",
    "Farbtonhilfsbezeichnung": "E2.19.65",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "170",
    "Bcolor": "138",
    "Y": 44,
    "L": 72.5409244722605,
    "a": 10.3264292899072,
    "b": 21.800524331019,
    "C": 24.1225621148916,
    "h": 1.12842715652823,
    "CMY_C": 0.1751672,
    "CMY_M": 0.3318234,
    "CMY_Y": 0.4605385,
    "CMYK_C": 0,
    "CMYK_M": 0.1899248,
    "CMYK_Y": 0.3459747,
    "CMYK_K": 0.1751672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03117",
    "Farbtonhilfsbezeichnung": "E6.18.78",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "205",
    "Bcolor": "166",
    "Y": 65,
    "L": 84.6288331161448,
    "a": 8.47112718076443,
    "b": 23.6250741012442,
    "C": 25.0978907879121,
    "h": 1.22651159473238,
    "CMY_C": 0.04676003,
    "CMY_M": 0.19772,
    "CMY_Y": 0.3495521,
    "CMYK_C": 0,
    "CMYK_M": 0.1583651,
    "CMYK_Y": 0.3176452,
    "CMYK_K": 0.04676003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03118",
    "Farbtonhilfsbezeichnung": "E4.21.75",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "197",
    "Bcolor": "156",
    "Y": 62,
    "L": 82.7624349690833,
    "a": 11.5955686226744,
    "b": 26.1831890695668,
    "C": 28.6359320004751,
    "h": 1.15389326505115,
    "CMY_C": 0.0422385,
    "CMY_M": 0.2266056,
    "CMY_Y": 0.3872592,
    "CMYK_C": 0,
    "CMYK_M": 0.1924979,
    "CMYK_Y": 0.3602365,
    "CMYK_K": 0.0422385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03119",
    "Farbtonhilfsbezeichnung": "E5.27.73",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "189",
    "Bcolor": "137",
    "Y": 57,
    "L": 80.3577569383981,
    "a": 12.8246361913861,
    "b": 33.1193988825016,
    "C": 35.5157130827984,
    "h": 1.20135176307759,
    "CMY_C": 0.04963935,
    "CMY_M": 0.2572138,
    "CMY_Y": 0.4630106,
    "CMYK_C": 0,
    "CMYK_M": 0.2184165,
    "CMYK_Y": 0.4349625,
    "CMYK_K": 0.04963935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03120",
    "Farbtonhilfsbezeichnung": "E4.30.69",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "179",
    "Bcolor": "125",
    "Y": 52,
    "L": 77.288893399696,
    "a": 16.0656144413855,
    "b": 35.0846907787709,
    "C": 38.5880745104135,
    "h": 1.14138433033798,
    "CMY_C": 0.06195533,
    "CMY_M": 0.2991039,
    "CMY_Y": 0.5079452,
    "CMYK_C": 0,
    "CMYK_M": 0.2528116,
    "CMYK_Y": 0.4754463,
    "CMYK_K": 0.06195533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03121",
    "Farbtonhilfsbezeichnung": "E4.29.62",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "160",
    "Bcolor": "114",
    "Y": 39,
    "L": 69.4383163452148,
    "a": 13.3522481918335,
    "b": 30.3811893463135,
    "C": 33.1858291625977,
    "h": 66.2749557495117,
    "CMY_C": 0.17620527744293,
    "CMY_M": 0.37382173538208,
    "CMY_Y": 0.55251771211624,
    "CMYK_C": 0,
    "CMYK_M": 0.23988555371761,
    "CMYK_Y": 0.45680364966393,
    "CMYK_K": 0.17620527744293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03122",
    "Farbtonhilfsbezeichnung": "E4.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "128",
    "Bcolor": "88",
    "Y": 25,
    "L": 56.9950379477185,
    "a": 11.616061877352,
    "b": 27.8548546831889,
    "C": 30.179891036252,
    "h": 1.17570325077712,
    "CMY_C": 0.3291756,
    "CMY_M": 0.496379,
    "CMY_Y": 0.6554425,
    "CMYK_C": 0,
    "CMYK_M": 0.2492506,
    "CMYK_Y": 0.4863672,
    "CMYK_K": 0.3291756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03123",
    "Farbtonhilfsbezeichnung": "E4.21.41",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "111",
    "Bcolor": "88",
    "Y": 18,
    "L": 49.038897474685,
    "a": 7.40113608476939,
    "b": 16.8528051023309,
    "C": 18.406353662864,
    "h": 1.15699052855068,
    "CMY_C": 0.4562716,
    "CMY_M": 0.5629424,
    "CMY_Y": 0.6563299,
    "CMYK_C": 0,
    "CMYK_M": 0.1961841,
    "CMYK_Y": 0.3679379,
    "CMYK_K": 0.4562716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03124",
    "Farbtonhilfsbezeichnung": "E9.18.79",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "206",
    "Bcolor": "164",
    "Y": 66,
    "L": 84.8735284946595,
    "a": 6.52347597192282,
    "b": 24.723216238168,
    "C": 25.5693793416162,
    "h": 1.31281578560136,
    "CMY_C": 0.05484026,
    "CMY_M": 0.1903893,
    "CMY_Y": 0.3554761,
    "CMYK_C": 0,
    "CMYK_M": 0.1434139,
    "CMYK_Y": 0.3180794,
    "CMYK_K": 0.05484026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03125",
    "Farbtonhilfsbezeichnung": "E9.20.76",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "201",
    "Bcolor": "157",
    "Y": 63,
    "L": 83.2598197017499,
    "a": 7.95781052280037,
    "b": 26.4477558249131,
    "C": 27.6190249011621,
    "h": 1.27852511617269,
    "CMY_C": 0.06008947,
    "CMY_M": 0.2119462,
    "CMY_Y": 0.3847755,
    "CMYK_C": 0,
    "CMYK_M": 0.1615651,
    "CMYK_Y": 0.3454435,
    "CMYK_K": 0.06008947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03126",
    "Farbtonhilfsbezeichnung": "E9.27.75",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "197",
    "Bcolor": "137",
    "Y": 61,
    "L": 82.3495846065652,
    "a": 10.0668138365919,
    "b": 35.6127456681573,
    "C": 37.0082206387372,
    "h": 1.29530931894138,
    "CMY_C": 0.03996366,
    "CMY_M": 0.2290099,
    "CMY_Y": 0.4619254,
    "CMYK_C": 0,
    "CMYK_M": 0.1969157,
    "CMYK_Y": 0.4395269,
    "CMYK_K": 0.03996366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03127",
    "Farbtonhilfsbezeichnung": "E9.29.73",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "190",
    "Bcolor": "130",
    "Y": 57,
    "L": 80.0481137701561,
    "a": 9.79847439390319,
    "b": 36.1641501569174,
    "C": 37.4680644952477,
    "h": 1.30620445952992,
    "CMY_C": 0.06750487,
    "CMY_M": 0.2532693,
    "CMY_Y": 0.4895957,
    "CMYK_C": 0,
    "CMYK_M": 0.1992122,
    "CMYK_Y": 0.4526466,
    "CMYK_K": 0.06750487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03128",
    "Farbtonhilfsbezeichnung": "E8.31.71",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "181",
    "Bcolor": "121",
    "Y": 52,
    "L": 77.3927502146933,
    "a": 12.3202239500803,
    "b": 37.3059512231832,
    "C": 39.2876814643809,
    "h": 1.25182494035227,
    "CMY_C": 0.08061384,
    "CMY_M": 0.2884485,
    "CMY_Y": 0.5243795,
    "CMYK_C": 0,
    "CMYK_M": 0.2260581,
    "CMYK_Y": 0.482676,
    "CMYK_K": 0.08061384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03129",
    "Farbtonhilfsbezeichnung": "E8.35.56",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "144",
    "Bcolor": "89",
    "Y": 32,
    "L": 62.961921670417,
    "a": 10.9350649367342,
    "b": 34.9293681741929,
    "C": 36.6010437859211,
    "h": 1.26739935583743,
    "CMY_C": 0.2572322,
    "CMY_M": 0.435384,
    "CMY_Y": 0.6491931,
    "CMYK_C": 0,
    "CMYK_M": 0.2398486,
    "CMYK_Y": 0.5277032,
    "CMYK_K": 0.2572322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03130",
    "Farbtonhilfsbezeichnung": "E7.37.54",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "137",
    "Bcolor": "80",
    "Y": 29,
    "L": 60.9158971801136,
    "a": 12.8973484552934,
    "b": 37.1686534517598,
    "C": 39.3427299077514,
    "h": 1.23680079443861,
    "CMY_C": 0.2659262,
    "CMY_M": 0.4615717,
    "CMY_Y": 0.6846656,
    "CMYK_C": 0,
    "CMYK_M": 0.2665201,
    "CMYK_Y": 0.5704322,
    "CMYK_K": 0.2659262
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03131",
    "Farbtonhilfsbezeichnung": "E7.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "218",
    "Bcolor": "204",
    "Y": 72,
    "L": 87.8621597290039,
    "a": 2.71609926223755,
    "b": 7.8666090965271,
    "C": 8.32230377197266,
    "h": 70.951774597168,
    "CMY_C": 0.09029233455658,
    "CMY_M": 0.14411956071854,
    "CMY_Y": 0.20010775327682,
    "CMYK_C": 0,
    "CMYK_M": 0.05916980654001,
    "CMYK_Y": 0.12071506679058,
    "CMYK_K": 0.09029233455658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03132",
    "Farbtonhilfsbezeichnung": "E7.11.78",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "208",
    "Bcolor": "182",
    "Y": 66,
    "L": 84.9808894545967,
    "a": 4.89935061116453,
    "b": 15.6645882552678,
    "C": 16.4128901055905,
    "h": 1.26766914220224,
    "CMY_C": 0.08570664,
    "CMY_M": 0.183127,
    "CMY_Y": 0.2879467,
    "CMYK_C": 0,
    "CMYK_M": 0.1065526,
    "CMYK_Y": 0.2211983,
    "CMYK_K": 0.08570664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03133",
    "Farbtonhilfsbezeichnung": "E7.14.73",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "197",
    "Bcolor": "167",
    "Y": 59,
    "L": 81.4297066847839,
    "a": 6.48202767444678,
    "b": 18.5452038391946,
    "C": 19.6453879628164,
    "h": 1.23454399733239,
    "CMY_C": 0.1078009,
    "CMY_M": 0.2263907,
    "CMY_Y": 0.3461832,
    "CMYK_C": 0,
    "CMYK_M": 0.1329185,
    "CMYK_Y": 0.2671851,
    "CMYK_K": 0.1078009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03134",
    "Farbtonhilfsbezeichnung": "E8.29.40",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "113",
    "Bcolor": "81",
    "Y": 17,
    "L": 49.4932098388672,
    "a": 7.14094972610474,
    "b": 21.1721572875977,
    "C": 22.3439788818359,
    "h": 71.3617706298828,
    "CMY_C": 0.44578838348389,
    "CMY_M": 0.55866539478302,
    "CMY_Y": 0.68096429109573,
    "CMYK_C": 0,
    "CMYK_M": 0.20367132127285,
    "CMYK_Y": 0.4243431687355,
    "CMYK_K": 0.44578838348389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03135",
    "Farbtonhilfsbezeichnung": "E7.29.59",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "155",
    "Bcolor": "107",
    "Y": 36,
    "L": 66.7190792735116,
    "a": 10.0065592513486,
    "b": 30.6308635634732,
    "C": 32.223920163364,
    "h": 1.2550436485407,
    "CMY_C": 0.2269088,
    "CMY_M": 0.3936466,
    "CMY_Y": 0.5818365,
    "CMYK_C": 0,
    "CMYK_M": 0.2156767,
    "CMYK_Y": 0.4591019,
    "CMYK_K": 0.2269088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03136",
    "Farbtonhilfsbezeichnung": "E8.24.65",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "169",
    "Bcolor": "125",
    "Y": 43,
    "L": 71.7331959079788,
    "a": 8.73906049286982,
    "b": 27.4648740103609,
    "C": 28.8217015927761,
    "h": 1.2627357117382,
    "CMY_C": 0.1838359,
    "CMY_M": 0.33751,
    "CMY_Y": 0.5096556,
    "CMYK_C": 0,
    "CMYK_M": 0.1882882,
    "CMYK_Y": 0.3992086,
    "CMYK_K": 0.1838359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03137",
    "Farbtonhilfsbezeichnung": "E8.20.68",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "179",
    "Bcolor": "140",
    "Y": 49,
    "L": 75.3022095574348,
    "a": 7.7357063891002,
    "b": 24.53613111913,
    "C": 25.7266959330869,
    "h": 1.26538246702762,
    "CMY_C": 0.1556455,
    "CMY_M": 0.2966376,
    "CMY_Y": 0.4526812,
    "CMYK_C": 0,
    "CMYK_M": 0.1669821,
    "CMYK_Y": 0.3517902,
    "CMYK_K": 0.1556455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03138",
    "Farbtonhilfsbezeichnung": "E7.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "230",
    "Bcolor": "215",
    "Y": 81,
    "L": 92.0073839835476,
    "a": 2.7276315833244,
    "b": 8.32688595485405,
    "C": 8.76224878438716,
    "h": 1.25424240891337,
    "CMY_C": 0.04223556,
    "CMY_M": 0.09829213,
    "CMY_Y": 0.1583502,
    "CMYK_C": 0,
    "CMYK_M": 0.05852855,
    "CMYK_Y": 0.1212351,
    "CMYK_K": 0.04223556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03139",
    "Farbtonhilfsbezeichnung": "E8.09.84",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "225",
    "Bcolor": "202",
    "Y": 78,
    "L": 90.7960927725874,
    "a": 4.5510590797031,
    "b": 13.2689739682081,
    "C": 14.0277513848775,
    "h": 1.24038456521228,
    "CMY_C": 0.02856973,
    "CMY_M": 0.1175371,
    "CMY_Y": 0.207946,
    "CMYK_C": 0,
    "CMYK_M": 0.09158385,
    "CMYK_Y": 0.1846517,
    "CMYK_K": 0.02856973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03140",
    "Farbtonhilfsbezeichnung": "E9.15.78",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "205",
    "Bcolor": "170",
    "Y": 65,
    "L": 84.3834717454821,
    "a": 6.39453998836897,
    "b": 21.2116978493853,
    "C": 22.1545992361962,
    "h": 1.2779979614286,
    "CMY_C": 0.068947,
    "CMY_M": 0.194646,
    "CMY_Y": 0.334736,
    "CMYK_C": 0,
    "CMYK_M": 0.1350073,
    "CMYK_Y": 0.2854714,
    "CMYK_K": 0.068947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03141",
    "Farbtonhilfsbezeichnung": "E9.12.74",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "199",
    "Bcolor": "170",
    "Y": 59,
    "L": 81.4343112498481,
    "a": 4.37104342122535,
    "b": 16.5974234305972,
    "C": 17.1633471422323,
    "h": 1.31328664893822,
    "CMY_C": 0.1269386,
    "CMY_M": 0.2207198,
    "CMY_Y": 0.3323181,
    "CMYK_C": 0,
    "CMYK_M": 0.1074165,
    "CMYK_Y": 0.2352406,
    "CMYK_K": 0.1269386
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03142",
    "Farbtonhilfsbezeichnung": "E8.15.66",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "175",
    "Bcolor": "148",
    "Y": 45,
    "L": 73.2727508544922,
    "a": 5.7906608581543,
    "b": 17.1954975128174,
    "C": 18.1443347930908,
    "h": 71.3888168334961,
    "CMY_C": 0.20640063285828,
    "CMY_M": 0.31182903051376,
    "CMY_Y": 0.42104071378708,
    "CMYK_C": 0,
    "CMYK_M": 0.13284838199615,
    "CMYK_Y": 0.27046403288841,
    "CMYK_K": 0.20640063285828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03143",
    "Farbtonhilfsbezeichnung": "E8.15.56",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "150",
    "Bcolor": "127",
    "Y": 31,
    "L": 63.5559349060059,
    "a": 5.34020280838013,
    "b": 14.8000812530518,
    "C": 15.7340450286865,
    "h": 70.1594161987305,
    "CMY_C": 0.32021141052246,
    "CMY_M": 0.4118338227272,
    "CMY_Y": 0.50242930650711,
    "CMYK_C": 0,
    "CMYK_M": 0.13478074967861,
    "CMYK_Y": 0.26805081963539,
    "CMYK_K": 0.32021141052246
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03144",
    "Farbtonhilfsbezeichnung": "E8.15.44",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "123",
    "Bcolor": "105",
    "Y": 20,
    "L": 52.6913566589355,
    "a": 4.40859270095825,
    "b": 11.732816696167,
    "C": 12.5337419509888,
    "h": 69.4063491821289,
    "CMY_C": 0.44694238901138,
    "CMY_M": 0.51900279521942,
    "CMY_Y": 0.58814370632172,
    "CMYK_C": 0,
    "CMYK_M": 0.13029457628727,
    "CMYK_Y": 0.25531032681465,
    "CMYK_K": 0.44694238901138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03145",
    "Farbtonhilfsbezeichnung": "E8.15.34",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "100",
    "Bcolor": "86",
    "Y": 12,
    "L": 43.4087562561035,
    "a": 3.2780749797821,
    "b": 9.60155391693115,
    "C": 10.1457185745239,
    "h": 71.1495361328125,
    "CMY_C": 0.55229192972183,
    "CMY_M": 0.60668444633484,
    "CMY_Y": 0.66219806671143,
    "CMYK_C": 0,
    "CMYK_M": 0.12149103730917,
    "CMYK_Y": 0.24548617005348,
    "CMYK_K": 0.55229192972183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03146",
    "Farbtonhilfsbezeichnung": "FN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "228",
    "Bcolor": "220",
    "Y": 78,
    "L": 90.6269190213252,
    "a": 0.63543274074073,
    "b": 3.16781690337464,
    "C": 3.2309191728224,
    "h": 1.37283341804004,
    "CMY_C": 0.08976046,
    "CMY_M": 0.1072226,
    "CMY_Y": 0.1355584,
    "CMYK_C": 0,
    "CMYK_M": 0.01918412,
    "CMYK_Y": 0.05031415,
    "CMYK_K": 0.08976046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03147",
    "Farbtonhilfsbezeichnung": "FN.02.75",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "211",
    "Bcolor": "203",
    "Y": 66,
    "L": 84.7610416426592,
    "a": 0.12894086314913,
    "b": 3.57216696772391,
    "C": 3.57449333353519,
    "h": 1.53471601246805,
    "CMY_C": 0.1574334,
    "CMY_M": 0.1709945,
    "CMY_Y": 0.2026323,
    "CMYK_C": 0,
    "CMYK_M": 0.01609492,
    "CMYK_Y": 0.05364428,
    "CMYK_K": 0.1574334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03148",
    "Farbtonhilfsbezeichnung": "F2.04.74",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "203",
    "Bcolor": "193",
    "Y": 60,
    "L": 82.1323776245117,
    "a": 1.55874073505402,
    "b": 5.19061899185181,
    "C": 5.41961240768433,
    "h": 73.2850036621094,
    "CMY_C": 0.17045921087265,
    "CMY_M": 0.20351564884186,
    "CMY_Y": 0.24253922700882,
    "CMYK_C": 0,
    "CMYK_M": 0.03984908014536,
    "CMYK_Y": 0.08689146488905,
    "CMYK_K": 0.17045921087265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03149",
    "Farbtonhilfsbezeichnung": "F1.04.56",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "154",
    "Bcolor": "148",
    "Y": 30,
    "L": 64.0148239135742,
    "a": 1.00530290603638,
    "b": 3.61642956733704,
    "C": 3.75355792045593,
    "h": 74.4650192260742,
    "CMY_C": 0.37332993745804,
    "CMY_M": 0.39450639486313,
    "CMY_Y": 0.42128747701645,
    "CMYK_C": 0,
    "CMYK_M": 0.03379203751683,
    "CMYK_Y": 0.07652757316828,
    "CMYK_K": 0.37332993745804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03151",
    "Farbtonhilfsbezeichnung": "F1.06.35",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "97",
    "Bcolor": "90",
    "Y": 14.3,
    "L": 41.5744088492851,
    "a": 1.09566250423324,
    "b": 4.50344117359767,
    "C": 4.63480945964744,
    "h": 1.33213860393991,
    "CMY_C": 0.5958501,
    "CMY_M": 0.6185082,
    "CMY_Y": 0.647051,
    "CMYK_C": 0,
    "CMYK_M": 0.05606378,
    "CMYK_Y": 0.1266882,
    "CMYK_K": 0.5958501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03152",
    "Farbtonhilfsbezeichnung": "F2.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "217",
    "Bcolor": "200",
    "Y": 71,
    "L": 87.3314947275373,
    "a": 1.94169554685142,
    "b": 9.24468661021807,
    "C": 9.44639677960903,
    "h": 1.36377187558936,
    "CMY_C": 0.09799854,
    "CMY_M": 0.1485096,
    "CMY_Y": 0.216105,
    "CMYK_C": 0,
    "CMYK_M": 0.05599888,
    "CMYK_Y": 0.1309382,
    "CMYK_K": 0.09799854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03153",
    "Farbtonhilfsbezeichnung": "F2.07.71",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "192",
    "Bcolor": "176",
    "Y": 54,
    "L": 78.2473078859403,
    "a": 1.76580655790842,
    "b": 8.98303060418872,
    "C": 9.15493919344873,
    "h": 1.37669969775933,
    "CMY_C": 0.2004744,
    "CMY_M": 0.2471323,
    "CMY_Y": 0.3112171,
    "CMYK_C": 0,
    "CMYK_M": 0.05835706,
    "CMYK_Y": 0.1385106,
    "CMYK_K": 0.2004744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03154",
    "Farbtonhilfsbezeichnung": "F2.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "163",
    "Bcolor": "146",
    "Y": 37,
    "L": 67.5541914071188,
    "a": 2.31743868792356,
    "b": 9.72050611013875,
    "C": 9.99293556016097,
    "h": 1.33675793668768,
    "CMY_C": 0.3099919,
    "CMY_M": 0.3621756,
    "CMY_Y": 0.4273061,
    "CMYK_C": 0,
    "CMYK_M": 0.0756276,
    "CMYK_Y": 0.1700186,
    "CMYK_K": 0.3099919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03155",
    "Farbtonhilfsbezeichnung": "F1.08.55",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "148",
    "Bcolor": "133",
    "Y": 30,
    "L": 61.7474604972329,
    "a": 2.04052702408342,
    "b": 8.65426550780195,
    "C": 8.89157252771102,
    "h": 1.33924265577884,
    "CMY_C": 0.3759278,
    "CMY_M": 0.4214766,
    "CMY_Y": 0.4786912,
    "CMYK_C": 0,
    "CMYK_M": 0.07298642,
    "CMYK_Y": 0.1646658,
    "CMYK_K": 0.3759278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03156",
    "Farbtonhilfsbezeichnung": "F1.08.48",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "130",
    "Bcolor": "118",
    "Y": 23,
    "L": 55.1502351176822,
    "a": 2.04130384185164,
    "b": 7.5520400149431,
    "C": 7.82305757118404,
    "h": 1.30680644909431,
    "CMY_C": 0.4469404,
    "CMY_M": 0.4882428,
    "CMY_Y": 0.5366658,
    "CMYK_C": 0,
    "CMYK_M": 0.07467988,
    "CMYK_Y": 0.1622345,
    "CMYK_K": 0.4469404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03157",
    "Farbtonhilfsbezeichnung": "F2.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "88",
    "Bcolor": "77",
    "Y": 10,
    "L": 37.806501453324,
    "a": 1.64340362125986,
    "b": 7.14325914079903,
    "C": 7.32986538859882,
    "h": 1.34466757392017,
    "CMY_C": 0.6222685,
    "CMY_M": 0.655824,
    "CMY_Y": 0.6984044,
    "CMYK_C": 0,
    "CMYK_M": 0.0888342,
    "CMYK_Y": 0.2015608,
    "CMYK_K": 0.6222685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03158",
    "Farbtonhilfsbezeichnung": "F1.09.71",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "191",
    "Bcolor": "169",
    "Y": 53,
    "L": 78.0242909602801,
    "a": 2.70602430844319,
    "b": 12.2261800121737,
    "C": 12.5220623400445,
    "h": 1.35297747365821,
    "CMY_C": 0.1874294,
    "CMY_M": 0.2525514,
    "CMY_Y": 0.3367374,
    "CMYK_C": 0,
    "CMYK_M": 0.08014328,
    "CMYK_Y": 0.1837477,
    "CMYK_K": 0.1874294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03160",
    "Farbtonhilfsbezeichnung": "F0.12.54",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "145",
    "Bcolor": "124",
    "Y": 29,
    "L": 61.0497468423574,
    "a": 3.28832594630707,
    "b": 12.7129692046117,
    "C": 13.1313622113839,
    "h": 1.31768461559602,
    "CMY_C": 0.3649835,
    "CMY_M": 0.4323874,
    "CMY_Y": 0.5132833,
    "CMYK_C": 0,
    "CMYK_M": 0.1061451,
    "CMYK_Y": 0.2335368,
    "CMYK_K": 0.3649835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03161",
    "Farbtonhilfsbezeichnung": "F2.16.54",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "149",
    "Bcolor": "125",
    "Y": 30,
    "L": 62.7349967956543,
    "a": 3.57581114768982,
    "b": 14.5046882629395,
    "C": 14.9389562606812,
    "h": 76.1511383056641,
    "CMY_C": 0.34118264913559,
    "CMY_M": 0.41611874103546,
    "CMY_Y": 0.50884538888931,
    "CMYK_C": 0,
    "CMYK_M": 0.11374334990978,
    "CMYK_Y": 0.25449046492577,
    "CMYK_K": 0.34118264913559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03162",
    "Farbtonhilfsbezeichnung": "F1.19.50",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "132",
    "Bcolor": "104",
    "Y": 24,
    "L": 56.3594357167623,
    "a": 4.02002865644874,
    "b": 17.6494873748824,
    "C": 18.1015202398805,
    "h": 1.34684666292079,
    "CMY_C": 0.3990429,
    "CMY_M": 0.4826958,
    "CMY_Y": 0.592741,
    "CMYK_C": 0,
    "CMYK_M": 0.1391995,
    "CMYK_Y": 0.322316,
    "CMYK_K": 0.3990429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03164",
    "Farbtonhilfsbezeichnung": "F2.16.35",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "99",
    "Bcolor": "82",
    "Y": 13,
    "L": 42.5378793523495,
    "a": 2.54354975113141,
    "b": 10.8467758691855,
    "C": 11.1410139616116,
    "h": 1.34045992870883,
    "CMY_C": 0.5627754,
    "CMY_M": 0.6137183,
    "CMY_Y": 0.6783686,
    "CMYK_C": 0,
    "CMYK_M": 0.1165142,
    "CMYK_Y": 0.2643793,
    "CMYK_K": 0.5627754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03165",
    "Farbtonhilfsbezeichnung": "F2.06.88",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "239",
    "Bcolor": "219",
    "Y": 87,
    "L": 94.8359301233254,
    "a": 1.70558190543518,
    "b": 10.0748779524051,
    "C": 10.2182276052164,
    "h": 1.40309574656226,
    "CMY_C": 0.01273549,
    "CMY_M": 0.06460589,
    "CMY_Y": 0.1405174,
    "CMYK_C": 0,
    "CMYK_M": 0.05253952,
    "CMYK_Y": 0.1294302,
    "CMYK_K": 0.01273549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03166",
    "Farbtonhilfsbezeichnung": "F0.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "230",
    "Bcolor": "213",
    "Y": 80,
    "L": 91.8911547069302,
    "a": 1.81532344054119,
    "b": 9.1899444593609,
    "C": 9.36752253052622,
    "h": 1.37577336059081,
    "CMY_C": 0.04787565,
    "CMY_M": 0.09760111,
    "CMY_Y": 0.1661748,
    "CMYK_C": 0,
    "CMYK_M": 0.05222581,
    "CMYK_Y": 0.1242476,
    "CMYK_K": 0.04787565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03167",
    "Farbtonhilfsbezeichnung": "F1.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "216",
    "Bcolor": "194",
    "Y": 70,
    "L": 87.1322523602165,
    "a": 2.73039888595272,
    "b": 12.3110890507262,
    "C": 12.6102336097045,
    "h": 1.35254530518224,
    "CMY_C": 0.08582922,
    "CMY_M": 0.1533882,
    "CMY_Y": 0.2406832,
    "CMYK_C": 0,
    "CMYK_M": 0.07390193,
    "CMYK_Y": 0.1693928,
    "CMYK_K": 0.08582922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03168",
    "Farbtonhilfsbezeichnung": "F1.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "215",
    "Bcolor": "193",
    "Y": 70,
    "L": 86.9316457484385,
    "a": 2.69029025889495,
    "b": 12.1170170298277,
    "C": 12.4120813475517,
    "h": 1.35231457859984,
    "CMY_C": 0.08890252,
    "CMY_M": 0.1554531,
    "CMY_Y": 0.2414169,
    "CMYK_C": 0,
    "CMYK_M": 0.07304446,
    "CMYK_Y": 0.1673964,
    "CMYK_K": 0.08890252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03169",
    "Farbtonhilfsbezeichnung": "F2.15.76",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "203",
    "Bcolor": "170",
    "Y": 62,
    "L": 83.1366424560547,
    "a": 4.12334156036377,
    "b": 19.2328090667725,
    "C": 19.6698474884033,
    "h": 77.8994750976563,
    "CMY_C": 0.10328370332718,
    "CMY_M": 0.20217561721802,
    "CMY_Y": 0.33371937274933,
    "CMYK_C": 0,
    "CMYK_M": 0.11028227210045,
    "CMYK_Y": 0.25697723031044,
    "CMYK_K": 0.10328370332718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03170",
    "Farbtonhilfsbezeichnung": "F2.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "186",
    "Bcolor": "145",
    "Y": 51,
    "L": 76.8311372998847,
    "a": 4.54442669406752,
    "b": 23.6011315355788,
    "C": 24.0346671234998,
    "h": 1.38057320584353,
    "CMY_C": 0.1614891,
    "CMY_M": 0.2723158,
    "CMY_Y": 0.4309157,
    "CMYK_C": 0,
    "CMYK_M": 0.1321708,
    "CMYK_Y": 0.3213155,
    "CMYK_K": 0.1614891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03171",
    "Farbtonhilfsbezeichnung": "F3.25.65",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "172",
    "Bcolor": "123",
    "Y": 44,
    "L": 72.155400169877,
    "a": 4.80197875245997,
    "b": 28.9887301467995,
    "C": 29.383762105337,
    "h": 1.40663714896324,
    "CMY_C": 0.2015934,
    "CMY_M": 0.323727,
    "CMY_Y": 0.5172985,
    "CMYK_C": 0,
    "CMYK_M": 0.1529717,
    "CMYK_Y": 0.395419,
    "CMYK_K": 0.2015934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03172",
    "Farbtonhilfsbezeichnung": "F2.26.56",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "147",
    "Bcolor": "105",
    "Y": 31,
    "L": 62.9112376170338,
    "a": 5.82979257495253,
    "b": 26.1927029350242,
    "C": 26.8336387489546,
    "h": 1.35179298586282,
    "CMY_C": 0.3019565,
    "CMY_M": 0.4219356,
    "CMY_Y": 0.5882354,
    "CMYK_C": 0,
    "CMYK_M": 0.1718792,
    "CMYK_Y": 0.4101161,
    "CMYK_K": 0.3019565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03173",
    "Farbtonhilfsbezeichnung": "F1.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "213",
    "Bcolor": "190",
    "Y": 68,
    "L": 86.3402481079102,
    "a": 2.99708342552185,
    "b": 13.0375528335571,
    "C": 13.3776044845581,
    "h": 77.0537185668945,
    "CMY_C": 0.09080988168716,
    "CMY_M": 0.16289782524109,
    "CMY_Y": 0.25447702407837,
    "CMYK_C": 0,
    "CMYK_M": 0.07928808778524,
    "CMYK_Y": 0.18001420795918,
    "CMYK_K": 0.09080988168716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03174",
    "Farbtonhilfsbezeichnung": "F1.19.76",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "204",
    "Bcolor": "161",
    "Y": 64,
    "L": 83.8473390398448,
    "a": 6.39822460370104,
    "b": 25.0327771809035,
    "C": 25.8375155823498,
    "h": 1.3205598059976,
    "CMY_C": 0.06676291,
    "CMY_M": 0.2013439,
    "CMY_Y": 0.3685134,
    "CMYK_C": 0,
    "CMYK_M": 0.1442088,
    "CMYK_Y": 0.3233374,
    "CMYK_K": 0.06676291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03175",
    "Farbtonhilfsbezeichnung": "F1.23.77",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "200",
    "Bcolor": "149",
    "Y": 62,
    "L": 82.8626417939351,
    "a": 7.64603162515937,
    "b": 30.1643619406816,
    "C": 31.1183311072651,
    "h": 1.32254602158718,
    "CMY_C": 0.05950029,
    "CMY_M": 0.2162397,
    "CMY_Y": 0.416489,
    "CMYK_C": 0,
    "CMYK_M": 0.1666555,
    "CMYK_Y": 0.3795734,
    "CMYK_K": 0.05950029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03176",
    "Farbtonhilfsbezeichnung": "E9.35.72",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "188",
    "Bcolor": "115",
    "Y": 56,
    "L": 79.8644549741539,
    "a": 12.6134097700434,
    "b": 43.9367036586094,
    "C": 45.7113993923998,
    "h": 1.29123320208427,
    "CMY_C": 0.04032824,
    "CMY_M": 0.263876,
    "CMY_Y": 0.5497976,
    "CMYK_C": 0,
    "CMYK_M": 0.2329419,
    "CMYK_Y": 0.5308788,
    "CMYK_K": 0.04032824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03177",
    "Farbtonhilfsbezeichnung": "F0.40.71",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "183",
    "Bcolor": "102",
    "Y": 54,
    "L": 78.4452012346608,
    "a": 13.7081514584758,
    "b": 48.4937114916883,
    "C": 50.3939824844952,
    "h": 1.29530516576505,
    "CMY_C": 0.04446227,
    "CMY_M": 0.2826778,
    "CMY_Y": 0.5993499,
    "CMYK_C": 0,
    "CMYK_M": 0.2493,
    "CMYK_Y": 0.5807071,
    "CMYK_K": 0.04446227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03178",
    "Farbtonhilfsbezeichnung": "F0.33.63",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "163",
    "Bcolor": "102",
    "Y": 41,
    "L": 70.2033191858755,
    "a": 10.4126217491229,
    "b": 37.6186182592498,
    "C": 39.0331030207114,
    "h": 1.30076267069196,
    "CMY_C": 0.1747248,
    "CMY_M": 0.359577,
    "CMY_Y": 0.5987253,
    "CMYK_C": 0,
    "CMYK_M": 0.2239886,
    "CMYK_Y": 0.5137686,
    "CMYK_K": 0.1747248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03179",
    "Farbtonhilfsbezeichnung": "E8.45.65",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "164",
    "Bcolor": "84",
    "Y": 44,
    "L": 72.1373538291627,
    "a": 16.4331588505282,
    "b": 49.876483598817,
    "C": 52.5139250674499,
    "h": 1.25252039396653,
    "CMY_C": 0.1013135,
    "CMY_M": 0.3569546,
    "CMY_Y": 0.6724162,
    "CMYK_C": 0,
    "CMYK_M": 0.2844608,
    "CMYK_Y": 0.635486,
    "CMYK_K": 0.1013135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03180",
    "Farbtonhilfsbezeichnung": "F1.38.55",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "143",
    "Bcolor": "80",
    "Y": 31,
    "L": 62.3330821395342,
    "a": 9.72699341513705,
    "b": 38.9077592826048,
    "C": 40.1052132931773,
    "h": 1.32581636722091,
    "CMY_C": 0.2663251,
    "CMY_M": 0.4393865,
    "CMY_Y": 0.684958,
    "CMYK_C": 0,
    "CMYK_M": 0.2358829,
    "CMYK_Y": 0.5705972,
    "CMYK_K": 0.2663251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03182",
    "Farbtonhilfsbezeichnung": "F1.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "212",
    "Bcolor": "177",
    "Y": 69,
    "L": 86.6095467997372,
    "a": 5.27212961975171,
    "b": 20.5621535896647,
    "C": 21.2272822323637,
    "h": 1.31980356324682,
    "CMY_C": 0.05287064,
    "CMY_M": 0.1673326,
    "CMY_Y": 0.3066641,
    "CMYK_C": 0,
    "CMYK_M": 0.1208514,
    "CMYK_Y": 0.2679607,
    "CMYK_K": 0.05287064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03183",
    "Farbtonhilfsbezeichnung": "F2.19.78",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "207",
    "Bcolor": "162",
    "Y": 66,
    "L": 84.948656116461,
    "a": 5.40639843853408,
    "b": 25.8040566637071,
    "C": 26.364341152018,
    "h": 1.36426640938162,
    "CMY_C": 0.05931202,
    "CMY_M": 0.1870251,
    "CMY_Y": 0.3629114,
    "CMYK_C": 0,
    "CMYK_M": 0.1357656,
    "CMYK_Y": 0.3227419,
    "CMYK_K": 0.05931202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03184",
    "Farbtonhilfsbezeichnung": "F3.28.79",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "209",
    "Bcolor": "143",
    "Y": 69,
    "L": 86.3134150597737,
    "a": 7.22466148113998,
    "b": 37.8800105450314,
    "C": 38.5628180039887,
    "h": 1.38233482392609,
    "CMY_C": 0.008420388,
    "CMY_M": 0.1790222,
    "CMY_Y": 0.4389955,
    "CMYK_C": 0,
    "CMYK_M": 0.1720506,
    "CMYK_Y": 0.4342315,
    "CMYK_K": 0.008420388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03185",
    "Farbtonhilfsbezeichnung": "F2.41.70",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "180",
    "Bcolor": "97",
    "Y": 51,
    "L": 76.6963658940278,
    "a": 10.5335685679238,
    "b": 48.8425025419721,
    "C": 49.9654492758516,
    "h": 1.35838560834687,
    "CMY_C": 0.08408011,
    "CMY_M": 0.2930777,
    "CMY_Y": 0.6206958,
    "CMYK_C": 0,
    "CMYK_M": 0.2281833,
    "CMYK_Y": 0.5858762,
    "CMYK_K": 0.08408011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03186",
    "Farbtonhilfsbezeichnung": "F2.38.67",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "174",
    "Bcolor": "100",
    "Y": 47,
    "L": 74.13445804466,
    "a": 9.27329542933131,
    "b": 43.8831565620285,
    "C": 44.8522623506013,
    "h": 1.36254225545658,
    "CMY_C": 0.1279876,
    "CMY_M": 0.316319,
    "CMY_Y": 0.6077116,
    "CMYK_C": 0,
    "CMYK_M": 0.2159733,
    "CMYK_Y": 0.5501344,
    "CMYK_K": 0.1279876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03187",
    "Farbtonhilfsbezeichnung": "F1.35.65",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "170",
    "Bcolor": "105",
    "Y": 43,
    "L": 72.5023193359375,
    "a": 10.1081218719482,
    "b": 39.3428535461426,
    "C": 40.6206130981445,
    "h": 75.5909957885742,
    "CMY_C": 0.14783453941345,
    "CMY_M": 0.33490580320358,
    "CMY_Y": 0.5890349149704,
    "CMYK_C": 0,
    "CMYK_M": 0.21952457726002,
    "CMYK_Y": 0.51774024963379,
    "CMYK_K": 0.14783453941345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03188",
    "Farbtonhilfsbezeichnung": "F8.13.85",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "234",
    "Bcolor": "196",
    "Y": 83,
    "L": 93.1175950356513,
    "a": 0.63382888230484,
    "b": 19.7259895812828,
    "C": 19.7361699428465,
    "h": 1.53867571333702,
    "CMY_C": 0.01385161,
    "CMY_M": 0.08366404,
    "CMY_Y": 0.2316986,
    "CMYK_C": 0,
    "CMYK_M": 0.07079302,
    "CMYK_Y": 0.2209069,
    "CMYK_K": 0.01385161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03190",
    "Farbtonhilfsbezeichnung": "F7.31.80",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "212",
    "Bcolor": "135",
    "Y": 70,
    "L": 86.7966690063477,
    "a": 4.08535575866699,
    "b": 42.7455406188965,
    "C": 42.9403228759766,
    "h": 84.5406036376953,
    "CMY_C": 0.01535588502884,
    "CMY_M": 0.16669863462448,
    "CMY_Y": 0.47218811511993,
    "CMYK_C": 0,
    "CMYK_M": 0.15370298922062,
    "CMYK_Y": 0.46395668387413,
    "CMYK_K": 0.01535588502884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03191",
    "Farbtonhilfsbezeichnung": "F8.41.80",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "110",
    "Y": 71,
    "L": 87.2705364359742,
    "a": 3.22978647022054,
    "b": 55.2572094365814,
    "C": 55.3515195397691,
    "h": 1.51241270708481,
    "CMY_C": 0,
    "CMY_M": 0.1613701,
    "CMY_Y": 0.5676901,
    "CMYK_C": 0,
    "CMYK_M": 0.1613701,
    "CMYK_Y": 0.5676901,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03192",
    "Farbtonhilfsbezeichnung": "F7.52.78",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "79",
    "Y": 68,
    "L": 86.2429665250926,
    "a": 5.36095600473629,
    "b": 68.0032545501429,
    "C": 68.2142395596128,
    "h": 1.49212521663686,
    "CMY_C": 0,
    "CMY_M": 0.1795013,
    "CMY_Y": 0.6909763,
    "CMYK_C": 0,
    "CMYK_M": 0.1795013,
    "CMYK_Y": 0.6909763,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03193",
    "Farbtonhilfsbezeichnung": "F5.54.75",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "194",
    "Bcolor": "66",
    "Y": 59,
    "L": 81.5371902055611,
    "a": 8.62445503464443,
    "b": 68.1888680493887,
    "C": 68.7321100396427,
    "h": 1.44498542154731,
    "CMY_C": 0.0175477,
    "CMY_M": 0.2387641,
    "CMY_Y": 0.7428709,
    "CMYK_C": 0,
    "CMYK_M": 0.2251676,
    "CMYK_Y": 0.7382783,
    "CMYK_K": 0.0175477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03194",
    "Farbtonhilfsbezeichnung": "F6.47.74",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "196",
    "Bcolor": "91",
    "Y": 60,
    "L": 81.7488719749697,
    "a": 6.47185956638918,
    "b": 57.8105948972601,
    "C": 58.1717272274271,
    "h": 1.45931114767433,
    "CMY_C": 0.03886569,
    "CMY_M": 0.2298341,
    "CMY_Y": 0.6450483,
    "CMYK_C": 0,
    "CMYK_M": 0.1986907,
    "CMYK_Y": 0.630695,
    "CMYK_K": 0.03886569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03195",
    "Farbtonhilfsbezeichnung": "G0.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "238",
    "Bcolor": "213",
    "Y": 86,
    "L": 94.4032671551946,
    "a": 0.2257038913917,
    "b": 12.853666895279,
    "C": 12.8556483656555,
    "h": 1.55323863683857,
    "CMY_C": 0.02079731,
    "CMY_M": 0.06659895,
    "CMY_Y": 0.166298,
    "CMYK_C": 0,
    "CMYK_M": 0.04677442,
    "CMYK_Y": 0.148591,
    "CMYK_K": 0.02079731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03196",
    "Farbtonhilfsbezeichnung": "F7.44.74",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "200",
    "Bcolor": "98",
    "Y": 61,
    "L": 82.3468351074848,
    "a": 3.63681623375112,
    "b": 55.0235841976636,
    "C": 55.1436419750768,
    "h": 1.50479673478868,
    "CMY_C": 0.05298347,
    "CMY_M": 0.2159984,
    "CMY_Y": 0.6162787,
    "CMYK_C": 0,
    "CMYK_M": 0.1721352,
    "CMYK_Y": 0.5948104,
    "CMYK_K": 0.05298347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03197",
    "Farbtonhilfsbezeichnung": "F9.47.76",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "203",
    "Bcolor": "87",
    "Y": 62,
    "L": 83.0375800506901,
    "a": 0.71511524226208,
    "b": 60.5780546229481,
    "C": 60.5822753923175,
    "h": 1.55899201859646,
    "CMY_C": 0.0568083,
    "CMY_M": 0.2021569,
    "CMY_Y": 0.6581686,
    "CMYK_C": 0,
    "CMYK_M": 0.1541029,
    "CMYK_Y": 0.6375802,
    "CMYK_K": 0.0568083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03198",
    "Farbtonhilfsbezeichnung": "F8.35.77",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "205",
    "Bcolor": "121",
    "Y": 64,
    "L": 83.8796492749201,
    "a": 2.63200227982407,
    "b": 45.855194881118,
    "C": 45.9306687692038,
    "h": 1.51346110948307,
    "CMY_C": 0.05411258,
    "CMY_M": 0.195582,
    "CMY_Y": 0.5267736,
    "CMYK_C": 0,
    "CMYK_M": 0.1495626,
    "CMYK_Y": 0.4997012,
    "CMYK_K": 0.05411258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03199",
    "Farbtonhilfsbezeichnung": "G0.20.79",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "215",
    "Bcolor": "164",
    "Y": 69,
    "L": 86.5712546617808,
    "a": -0.20546979960062,
    "b": 26.9774207785571,
    "C": 26.9782032333859,
    "h": -1.56318011216878,
    "CMY_C": 0.07719357,
    "CMY_M": 0.1558924,
    "CMY_Y": 0.355744,
    "CMYK_C": 0,
    "CMYK_M": 0.08528203,
    "CMYK_Y": 0.3018514,
    "CMYK_K": 0.07719357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03200",
    "Farbtonhilfsbezeichnung": "F9.20.81",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "218",
    "Bcolor": "166",
    "Y": 71,
    "L": 87.5084012193195,
    "a": 0.03433550326764,
    "b": 27.3143626756531,
    "C": 27.3143842563565,
    "h": 1.56953927805501,
    "CMY_C": 0.06411019,
    "CMY_M": 0.1462052,
    "CMY_Y": 0.3483792,
    "CMYK_C": 0,
    "CMYK_M": 0.0877187,
    "CMYK_Y": 0.303742,
    "CMYK_K": 0.06411019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03201",
    "Farbtonhilfsbezeichnung": "F8.16.82",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "217",
    "Bcolor": "176",
    "Y": 71,
    "L": 87.2570049435448,
    "a": 0.29003984666092,
    "b": 21.9382973093793,
    "C": 21.9402144918268,
    "h": 1.55757638789397,
    "CMY_C": 0.07748017,
    "CMY_M": 0.1484348,
    "CMY_Y": 0.3109044,
    "CMYK_C": 0,
    "CMYK_M": 0.07691392,
    "CMYK_Y": 0.253029,
    "CMYK_K": 0.07748017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03202",
    "Farbtonhilfsbezeichnung": "F9.16.84",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "230",
    "Bcolor": "186",
    "Y": 80,
    "L": 91.9081998410156,
    "a": 0.58161161009773,
    "b": 23.0869388431252,
    "C": 23.0942637295758,
    "h": 1.54560941824951,
    "CMY_C": 0.01973419,
    "CMY_M": 0.09781165,
    "CMY_Y": 0.2699279,
    "CMYK_C": 0,
    "CMYK_M": 0.07964928,
    "CMYK_Y": 0.2552305,
    "CMYK_K": 0.01973419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03203",
    "Farbtonhilfsbezeichnung": "F5.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "234",
    "Bcolor": "208",
    "Y": 86,
    "L": 93.4098129272461,
    "a": 1.42819941043854,
    "b": 13.9207258224487,
    "C": 13.9937973022461,
    "h": 84.1422271728516,
    "CMY_C": 0.02005726099014,
    "CMY_M": 0.08087188005447,
    "CMY_Y": 0.18492668867111,
    "CMYK_C": 0,
    "CMYK_M": 0.06205936148763,
    "CMYK_Y": 0.16824394464493,
    "CMYK_K": 0.02005726099014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03205",
    "Farbtonhilfsbezeichnung": "F5.21.82",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "220",
    "Bcolor": "168",
    "Y": 75,
    "L": 89.3786929666548,
    "a": 3.95604241309339,
    "b": 29.0626478067197,
    "C": 29.3306626094881,
    "h": 1.43550663383213,
    "CMY_C": 0.01156933,
    "CMY_M": 0.1354124,
    "CMY_Y": 0.3410423,
    "CMYK_C": 0,
    "CMYK_M": 0.1252926,
    "CMYK_Y": 0.3333294,
    "CMYK_K": 0.01156933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03206",
    "Farbtonhilfsbezeichnung": "F6.24.77",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "206",
    "Bcolor": "149",
    "Y": 64,
    "L": 84.1633366134762,
    "a": 3.70640249926402,
    "b": 31.5410888257012,
    "C": 31.7581124092305,
    "h": 1.45382248590174,
    "CMY_C": 0.06827024,
    "CMY_M": 0.1925961,
    "CMY_Y": 0.4141497,
    "CMYK_C": 0,
    "CMYK_M": 0.1334356,
    "CMYK_Y": 0.371223,
    "CMYK_K": 0.06827024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03207",
    "Farbtonhilfsbezeichnung": "F6.32.76",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "204",
    "Bcolor": "127",
    "Y": 64,
    "L": 83.7134469930327,
    "a": 4.184405132024,
    "b": 42.6047973833039,
    "C": 42.809788674803,
    "h": 1.4728958937763,
    "CMY_C": 0.05092035,
    "CMY_M": 0.2006546,
    "CMY_Y": 0.5027112,
    "CMYK_C": 0,
    "CMYK_M": 0.1577678,
    "CMYK_Y": 0.4760305,
    "CMYK_K": 0.05092035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03208",
    "Farbtonhilfsbezeichnung": "F5.14.84",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "227",
    "Bcolor": "189",
    "Y": 80,
    "L": 91.3827133178711,
    "a": 2.63059163093567,
    "b": 21.0795783996582,
    "C": 21.2430839538574,
    "h": 82.8866424560547,
    "CMY_C": 0.01583790779114,
    "CMY_M": 0.1081405878067,
    "CMY_Y": 0.26013833284378,
    "CMYK_C": 0,
    "CMYK_M": 0.09378808736801,
    "CMYK_Y": 0.24823190271854,
    "CMYK_K": 0.01583790779114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03209",
    "Farbtonhilfsbezeichnung": "F8.31.69",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "184",
    "Bcolor": "116",
    "Y": 50,
    "L": 75.8123092651367,
    "a": 1.88215208053589,
    "b": 37.4433555603027,
    "C": 37.4906311035156,
    "h": 87.1223526000977,
    "CMY_C": 0.16491878032684,
    "CMY_M": 0.27939856052399,
    "CMY_Y": 0.54386103153229,
    "CMYK_C": 0,
    "CMYK_M": 0.13708819448948,
    "CMYK_Y": 0.45377892255783,
    "CMYK_K": 0.16491878032684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03210",
    "Farbtonhilfsbezeichnung": "F9.28.76",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "205",
    "Bcolor": "137",
    "Y": 63,
    "L": 83.3312419993466,
    "a": 0.93263398178039,
    "b": 36.8808856892681,
    "C": 36.8926759041525,
    "h": 1.54551398219767,
    "CMY_C": 0.08654874,
    "CMY_M": 0.1959802,
    "CMY_Y": 0.4635711,
    "CMYK_C": 0,
    "CMYK_M": 0.1198,
    "CMYK_Y": 0.412745,
    "CMYK_K": 0.08654874
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03211",
    "Farbtonhilfsbezeichnung": "F9.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "227",
    "Bcolor": "210",
    "Y": 77,
    "L": 90.4904640603744,
    "a": 0.00918074128142,
    "b": 8.48010476843881,
    "C": 8.48010973806997,
    "h": 1.56971370600833,
    "CMY_C": 0.07943904,
    "CMY_M": 0.1086871,
    "CMY_Y": 0.1764728,
    "CMYK_C": 0,
    "CMYK_M": 0.03177203,
    "CMYK_Y": 0.1054072,
    "CMYK_K": 0.07943904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03212",
    "Farbtonhilfsbezeichnung": "F8.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "223",
    "Bcolor": "197",
    "Y": 74,
    "L": 89.1055298235201,
    "a": 0.18389593514534,
    "b": 13.5196766198354,
    "C": 13.5209272470451,
    "h": 1.55719506988003,
    "CMY_C": 0.07910022,
    "CMY_M": 0.1257704,
    "CMY_Y": 0.2287785,
    "CMYK_C": 0,
    "CMYK_M": 0.05067884,
    "CMYK_Y": 0.1625348,
    "CMYK_K": 0.07910022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03213",
    "Farbtonhilfsbezeichnung": "F8.12.79",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "213",
    "Bcolor": "181",
    "Y": 68,
    "L": 85.8918634922167,
    "a": 0.85758862580898,
    "b": 17.1653495389971,
    "C": 17.1867589453935,
    "h": 1.52087738028889,
    "CMY_C": 0.1005606,
    "CMY_M": 0.1637293,
    "CMY_Y": 0.2899814,
    "CMYK_C": 0,
    "CMYK_M": 0.0702312,
    "CMYK_Y": 0.2105987,
    "CMYK_K": 0.1005606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03214",
    "Farbtonhilfsbezeichnung": "F9.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "205",
    "Bcolor": "177",
    "Y": 62,
    "L": 82.9031066894531,
    "a": 0.73540961742401,
    "b": 14.8847875595093,
    "C": 14.902943611145,
    "h": 87.171501159668,
    "CMY_C": 0.14068132638931,
    "CMY_M": 0.19560825824738,
    "CMY_Y": 0.30495828390121,
    "CMYK_C": 0,
    "CMYK_M": 0.06391916424036,
    "CMYK_Y": 0.19117116928101,
    "CMYK_K": 0.14068132638931
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03215",
    "Farbtonhilfsbezeichnung": "F9.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "204",
    "Bcolor": "166",
    "Y": 61,
    "L": 82.5274124145508,
    "a": 0.3906854391098,
    "b": 20.2347888946533,
    "C": 20.2385597229004,
    "h": 88.8938980102539,
    "CMY_C": 0.13396668434143,
    "CMY_M": 0.2001188993454,
    "CMY_Y": 0.34811413288116,
    "CMYK_C": 0,
    "CMYK_M": 0.0763852968812,
    "CMYK_Y": 0.24727392196655,
    "CMYK_K": 0.13396668434143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03216",
    "Farbtonhilfsbezeichnung": "F8.18.76",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "205",
    "Bcolor": "159",
    "Y": 63,
    "L": 83.1113204956055,
    "a": 0.68266749382019,
    "b": 24.8187427520752,
    "C": 24.8281288146973,
    "h": 88.4244155883789,
    "CMY_C": 0.11483269929886,
    "CMY_M": 0.19542354345322,
    "CMY_Y": 0.3756987452507,
    "CMYK_C": 0,
    "CMYK_M": 0.09104588627815,
    "CMYK_Y": 0.29470819234848,
    "CMYK_K": 0.11483269929886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03217",
    "Farbtonhilfsbezeichnung": "F9.20.70",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "192",
    "Bcolor": "147",
    "Y": 52,
    "L": 78.0660247802734,
    "a": 0.17412497103214,
    "b": 24.3732738494873,
    "C": 24.3738956451416,
    "h": 89.5906829833984,
    "CMY_C": 0.17575621604919,
    "CMY_M": 0.2488312125206,
    "CMY_Y": 0.42470276355743,
    "CMYK_C": 0,
    "CMYK_M": 0.08865702152252,
    "CMYK_Y": 0.30203023552895,
    "CMYK_K": 0.17575621604919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03218",
    "Farbtonhilfsbezeichnung": "F9.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "175",
    "Bcolor": "142",
    "Y": 43,
    "L": 71.7371510063726,
    "a": -0.23370644371656,
    "b": 18.1231596789602,
    "C": 18.1246664921295,
    "h": -1.55790158357244,
    "CMY_C": 0.2620507,
    "CMY_M": 0.3142265,
    "CMY_Y": 0.4443639,
    "CMYK_C": 0,
    "CMYK_M": 0.07070372,
    "CMYK_Y": 0.2470537,
    "CMYK_K": 0.2620507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03219",
    "Farbtonhilfsbezeichnung": "F6.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "218",
    "Bcolor": "197",
    "Y": 71,
    "L": 87.6573787411696,
    "a": 1.04136870552807,
    "b": 11.3884714886786,
    "C": 11.4359840691258,
    "h": 1.47960930900401,
    "CMY_C": 0.09492758,
    "CMY_M": 0.1433067,
    "CMY_Y": 0.2285077,
    "CMYK_C": 0,
    "CMYK_M": 0.05345329,
    "CMYK_Y": 0.1475905,
    "CMYK_K": 0.09492758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03220",
    "Farbtonhilfsbezeichnung": "F6.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "219",
    "Bcolor": "191",
    "Y": 72,
    "L": 88.0283134124249,
    "a": 0.97922725931587,
    "b": 14.7393700144903,
    "C": 14.7718622539422,
    "h": 1.50445764550173,
    "CMY_C": 0.08202095,
    "CMY_M": 0.13989,
    "CMY_Y": 0.2492534,
    "CMYK_C": 0,
    "CMYK_M": 0.06303964,
    "CMYK_Y": 0.1821746,
    "CMYK_K": 0.08202095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03221",
    "Farbtonhilfsbezeichnung": "F6.10.74",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "201",
    "Bcolor": "176",
    "Y": 59,
    "L": 81.4202365185131,
    "a": 1.13197510484658,
    "b": 13.4678036098322,
    "C": 13.5152914031109,
    "h": 1.48694295512747,
    "CMY_C": 0.1579886,
    "CMY_M": 0.2123908,
    "CMY_Y": 0.3102438,
    "CMYK_C": 0,
    "CMYK_M": 0.06460986,
    "CMYK_Y": 0.1808232,
    "CMYK_K": 0.1579886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03223",
    "Farbtonhilfsbezeichnung": "F6.12.69",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "189",
    "Bcolor": "161",
    "Y": 52,
    "L": 77.1884608790658,
    "a": 1.42317180386103,
    "b": 15.2008997035086,
    "C": 15.2673759952204,
    "h": 1.47744426868083,
    "CMY_C": 0.1980927,
    "CMY_M": 0.2592288,
    "CMY_Y": 0.3670793,
    "CMYK_C": 0,
    "CMYK_M": 0.07623831,
    "CMYK_Y": 0.2107308,
    "CMYK_K": 0.1980927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03224",
    "Farbtonhilfsbezeichnung": "F6.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "177",
    "Bcolor": "147",
    "Y": 45,
    "L": 72.8205434457253,
    "a": 1.51680350028977,
    "b": 16.7794443839004,
    "C": 16.8478617839445,
    "h": 1.4806448254338,
    "CMY_C": 0.2413628,
    "CMY_M": 0.3064617,
    "CMY_Y": 0.4234349,
    "CMYK_C": 0,
    "CMYK_M": 0.0858103,
    "CMYK_Y": 0.2399989,
    "CMYK_K": 0.2413628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03225",
    "Farbtonhilfsbezeichnung": "F6.11.60",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "163",
    "Bcolor": "142",
    "Y": 37,
    "L": 67.5204583351906,
    "a": 1.02600590715241,
    "b": 11.6606110662258,
    "C": 11.7056626706607,
    "h": 1.48303331590484,
    "CMY_C": 0.3143315,
    "CMY_M": 0.3600387,
    "CMY_Y": 0.4414017,
    "CMYK_C": 0,
    "CMYK_M": 0.06666075,
    "CMYK_Y": 0.1853232,
    "CMYK_K": 0.3143315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03226",
    "Farbtonhilfsbezeichnung": "F4.10.52",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "140",
    "Bcolor": "124",
    "Y": 27,
    "L": 58.838556774279,
    "a": 1.34175689412414,
    "b": 9.53990013748083,
    "C": 9.63379500487925,
    "h": 1.43106602726277,
    "CMY_C": 0.4086923,
    "CMY_M": 0.4498621,
    "CMY_Y": 0.5138245,
    "CMYK_C": 0,
    "CMYK_M": 0.06962497,
    "CMYK_Y": 0.1777959,
    "CMYK_K": 0.4086923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03227",
    "Farbtonhilfsbezeichnung": "G2.03.89",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "243",
    "Bcolor": "228",
    "Y": 90,
    "L": 95.8079147338867,
    "a": -0.26138210296631,
    "b": 6.60825109481812,
    "C": 6.61341857910156,
    "h": 92.2650909423828,
    "CMY_C": 0.02740627527237,
    "CMY_M": 0.0479542016983,
    "CMY_Y": 0.10413253307343,
    "CMYK_C": 0,
    "CMYK_M": 0.02112693712115,
    "CMYK_Y": 0.07888828963041,
    "CMYK_K": 0.02740627527237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03228",
    "Farbtonhilfsbezeichnung": "G3.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "221",
    "Y": 82,
    "L": 92.8506011962891,
    "a": -0.59747344255447,
    "b": 6.18722867965698,
    "C": 6.21600961685181,
    "h": 95.5157012939453,
    "CMY_C": 0.06470942497253,
    "CMY_M": 0.08025568723679,
    "CMY_Y": 0.13368362188339,
    "CMYK_C": 0,
    "CMYK_M": 0.01662185229361,
    "CMYK_Y": 0.07374627888203,
    "CMYK_K": 0.06470942497253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03229",
    "Farbtonhilfsbezeichnung": "G5.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "222",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.2900599262158,
    "a": -1.17111490206007,
    "b": 5.75492839271277,
    "C": 5.87287926992193,
    "h": -1.37003983206945,
    "CMY_C": 0.1214741,
    "CMY_M": 0.1296139,
    "CMY_Y": 0.1804921,
    "CMYK_C": 0,
    "CMYK_M": 0.009265236,
    "CMYK_Y": 0.06717841,
    "CMYK_K": 0.1214741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03230",
    "Farbtonhilfsbezeichnung": "G2.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "187",
    "Y": 54,
    "L": 78.7345233705447,
    "a": -0.4695374732066,
    "b": 3.62344648883755,
    "C": 3.65374190333887,
    "h": -1.44193130397884,
    "CMY_C": 0.2276617,
    "CMY_M": 0.2352941,
    "CMY_Y": 0.2678599,
    "CMYK_C": 0,
    "CMYK_M": 0.009882319,
    "CMYK_Y": 0.05204747,
    "CMYK_K": 0.2276617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03231",
    "Farbtonhilfsbezeichnung": "G2.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "176",
    "Bcolor": "163",
    "Y": 43,
    "L": 71.7993613989832,
    "a": -0.21862870496247,
    "b": 6.69216727039073,
    "C": 6.69573754604543,
    "h": -1.53813859931724,
    "CMY_C": 0.2910669,
    "CMY_M": 0.3109479,
    "CMY_Y": 0.3627085,
    "CMYK_C": 0,
    "CMYK_M": 0.02804346,
    "CMYK_Y": 0.1010555,
    "CMYK_K": 0.2910669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03232",
    "Farbtonhilfsbezeichnung": "G4.04.57",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "154",
    "Bcolor": "145",
    "Y": 32,
    "L": 63.5771423489048,
    "a": -0.7535616997828,
    "b": 4.66264176829179,
    "C": 4.72314339130189,
    "h": -1.41056492473005,
    "CMY_C": 0.3874428,
    "CMY_M": 0.395434,
    "CMY_Y": 0.4331929,
    "CMYK_C": 0,
    "CMYK_M": 0.01304567,
    "CMYK_Y": 0.07468709,
    "CMYK_K": 0.3874428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03233",
    "Farbtonhilfsbezeichnung": "G3.09.44",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "127",
    "Bcolor": "113",
    "Y": 21,
    "L": 53.1319173138409,
    "a": -0.62882948484466,
    "b": 7.31569389248745,
    "C": 7.34267006269437,
    "h": -1.48505085592148,
    "CMY_C": 0.4860273,
    "CMY_M": 0.5026332,
    "CMY_Y": 0.5552017,
    "CMYK_C": 0,
    "CMYK_M": 0.0323089,
    "CMYK_Y": 0.1345878,
    "CMYK_K": 0.4860273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03234",
    "Farbtonhilfsbezeichnung": "F8.10.39",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "112",
    "Bcolor": "99",
    "Y": 16,
    "L": 47.350034759883,
    "a": 0.12164414992299,
    "b": 7.53020385531566,
    "C": 7.53118632101354,
    "h": 1.5546435675047,
    "CMY_C": 0.5381779,
    "CMY_M": 0.5614015,
    "CMY_Y": 0.6121839,
    "CMYK_C": 0,
    "CMYK_M": 0.05028686,
    "CMYK_Y": 0.160248,
    "CMYK_K": 0.5381779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03235",
    "Farbtonhilfsbezeichnung": "G3.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "241",
    "Bcolor": "230",
    "Y": 87,
    "L": 95.1826782226562,
    "a": -0.50649440288544,
    "b": 4.75163841247559,
    "C": 4.77855682373047,
    "h": 96.0843887329102,
    "CMY_C": 0.04236513376236,
    "CMY_M": 0.05390053987503,
    "CMY_Y": 0.09719574451447,
    "CMYK_C": 0,
    "CMYK_M": 0.01204572524875,
    "CMYK_Y": 0.05725628137589,
    "CMYK_K": 0.04236513376236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03236",
    "Farbtonhilfsbezeichnung": "G3.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "219",
    "Y": 82,
    "L": 92.928466796875,
    "a": -0.77485144138336,
    "b": 7.36931705474854,
    "C": 7.40994119644165,
    "h": 96.0023422241211,
    "CMY_C": 0.06148910522461,
    "CMY_M": 0.07927948236465,
    "CMY_Y": 0.14165639877319,
    "CMYK_C": 0,
    "CMYK_M": 0.01895596273243,
    "CMYK_Y": 0.08541966974735,
    "CMYK_K": 0.06148910522461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03237",
    "Farbtonhilfsbezeichnung": "G3.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "226",
    "Bcolor": "213",
    "Y": 76,
    "L": 89.8051416693648,
    "a": -0.42218319667647,
    "b": 5.88381951502717,
    "C": 5.89894657858253,
    "h": -1.49916583494908,
    "CMY_C": 0.0984197,
    "CMY_M": 0.1145965,
    "CMY_Y": 0.1648054,
    "CMYK_C": 0,
    "CMYK_M": 0.01794276,
    "CMYK_Y": 0.07363257,
    "CMYK_K": 0.0984197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03238",
    "Farbtonhilfsbezeichnung": "G4.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "219",
    "Bcolor": "203",
    "Y": 71,
    "L": 87.2610306515008,
    "a": -0.73107000497901,
    "b": 7.19087064501367,
    "C": 7.22793774084277,
    "h": -1.46947803684714,
    "CMY_C": 0.1250323,
    "CMY_M": 0.1424115,
    "CMY_Y": 0.2021719,
    "CMYK_C": 0,
    "CMYK_M": 0.01986267,
    "CMYK_Y": 0.08816285,
    "CMYK_K": 0.1250323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03239",
    "Farbtonhilfsbezeichnung": "G2.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "209",
    "Bcolor": "190",
    "Y": 64,
    "L": 84.0004361747756,
    "a": -0.88235508140815,
    "b": 9.34703529715828,
    "C": 9.38858984810869,
    "h": -1.47667578333688,
    "CMY_C": 0.1557818,
    "CMY_M": 0.1784953,
    "CMY_Y": 0.2531122,
    "CMYK_C": 0,
    "CMYK_M": 0.0269048,
    "CMYK_Y": 0.1152905,
    "CMYK_K": 0.1557818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03240",
    "Farbtonhilfsbezeichnung": "G2.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 55,
    "L": 79.1197982524441,
    "a": -0.53475978990152,
    "b": 8.49245360041677,
    "C": 8.5092735405631,
    "h": -1.50791053375282,
    "CMY_C": 0.2092025,
    "CMY_M": 0.2322388,
    "CMY_Y": 0.2988144,
    "CMYK_C": 0,
    "CMYK_M": 0.02913042,
    "CMYK_Y": 0.1133184,
    "CMYK_K": 0.2092025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03241",
    "Farbtonhilfsbezeichnung": "G3.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "173",
    "Bcolor": "154",
    "Y": 42,
    "L": 70.5998375524948,
    "a": -0.68343832314871,
    "b": 9.42707576053849,
    "C": 9.45181703888098,
    "h": -1.4984255569198,
    "CMY_C": 0.2994923,
    "CMY_M": 0.3232727,
    "CMY_Y": 0.3944789,
    "CMYK_C": 0,
    "CMYK_M": 0.03394738,
    "CMYK_Y": 0.1355967,
    "CMYK_K": 0.2994923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03242",
    "Farbtonhilfsbezeichnung": "F9.11.50",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "138",
    "Bcolor": "119",
    "Y": 25,
    "L": 57.503065930496,
    "a": -0.10501948704683,
    "b": 10.634061339583,
    "C": 10.6345799008082,
    "h": -1.56092088319117,
    "CMY_C": 0.4295326,
    "CMY_M": 0.4605008,
    "CMY_Y": 0.5346442,
    "CMYK_C": 0,
    "CMYK_M": 0.05428555,
    "CMYK_Y": 0.1842553,
    "CMYK_K": 0.4295326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03243",
    "Farbtonhilfsbezeichnung": "G5.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "236",
    "Bcolor": "213",
    "Y": 84,
    "L": 93.428506106459,
    "a": -1.05718890082812,
    "b": 11.290515876898,
    "C": 11.3399028716528,
    "h": -1.47743341789807,
    "CMY_C": 0.04612755,
    "CMY_M": 0.07406488,
    "CMY_Y": 0.1654676,
    "CMYK_C": 0,
    "CMYK_M": 0.02928833,
    "CMYK_Y": 0.1251111,
    "CMYK_K": 0.04612755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03244",
    "Farbtonhilfsbezeichnung": "G5.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "224",
    "Bcolor": "197",
    "Y": 74,
    "L": 89.0575104300038,
    "a": -1.5215664948226,
    "b": 13.4182973350768,
    "C": 13.5042907244585,
    "h": -1.45788373621046,
    "CMY_C": 0.09265687,
    "CMY_M": 0.1222489,
    "CMY_Y": 0.2288191,
    "CMYK_C": 0,
    "CMYK_M": 0.0326139,
    "CMYK_Y": 0.150067,
    "CMYK_K": 0.09265687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03245",
    "Farbtonhilfsbezeichnung": "G2.16.75",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "204",
    "Bcolor": "164",
    "Y": 60,
    "L": 82.0630858816674,
    "a": -1.26140482157239,
    "b": 20.8152834938419,
    "C": 20.8534689932609,
    "h": -1.51027041045055,
    "CMY_C": 0.149503,
    "CMY_M": 0.2014851,
    "CMY_Y": 0.3575217,
    "CMYK_C": 0,
    "CMYK_M": 0.06111969,
    "CMYK_Y": 0.2445849,
    "CMYK_K": 0.149503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03246",
    "Farbtonhilfsbezeichnung": "G2.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "189",
    "Bcolor": "145",
    "Y": 51,
    "L": 76.776664038423,
    "a": -1.54955127610124,
    "b": 23.5902311264765,
    "C": 23.6410683717519,
    "h": -1.50520441211374,
    "CMY_C": 0.2036658,
    "CMY_M": 0.2586062,
    "CMY_Y": 0.4325379,
    "CMYK_C": 0,
    "CMYK_M": 0.06899165,
    "CMYK_Y": 0.287407,
    "CMYK_K": 0.2036658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03247",
    "Farbtonhilfsbezeichnung": "G0.21.60",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "162",
    "Bcolor": "120",
    "Y": 37,
    "L": 67.1388277314386,
    "a": -0.49948287456869,
    "b": 23.3066218887967,
    "C": 23.3119734687848,
    "h": -1.5493686643204,
    "CMY_C": 0.3022339,
    "CMY_M": 0.3630439,
    "CMY_Y": 0.5274985,
    "CMYK_C": 0,
    "CMYK_M": 0.08714961,
    "CMYK_Y": 0.3228369,
    "CMYK_K": 0.3022339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03248",
    "Farbtonhilfsbezeichnung": "G0.21.52",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "141",
    "Bcolor": "106",
    "Y": 27,
    "L": 59.0048251357897,
    "a": -0.09594808477214,
    "b": 20.1839861936612,
    "C": 20.1842142453174,
    "h": -1.56604268887941,
    "CMY_C": 0.392522,
    "CMY_M": 0.4472233,
    "CMY_Y": 0.5853056,
    "CMYK_C": 0,
    "CMYK_M": 0.09004658,
    "CMYK_Y": 0.3173507,
    "CMYK_K": 0.392522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03249",
    "Farbtonhilfsbezeichnung": "F8.23.43",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "120",
    "Bcolor": "87",
    "Y": 19,
    "L": 51.0151609115026,
    "a": 0.46110521548375,
    "b": 20.0692852778259,
    "C": 20.074581678892,
    "h": 1.54782470132241,
    "CMY_C": 0.4722258,
    "CMY_M": 0.5285804,
    "CMY_Y": 0.6606082,
    "CMYK_C": 0,
    "CMYK_M": 0.106778,
    "CMYK_Y": 0.3569375,
    "CMYK_K": 0.4722258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03250",
    "Farbtonhilfsbezeichnung": "G1.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "238",
    "Bcolor": "222",
    "Y": 86,
    "L": 94.3099852714821,
    "a": -0.39596414448162,
    "b": 7.7639457073742,
    "C": 7.77403631010103,
    "h": -1.51984010064323,
    "CMY_C": 0.04177205,
    "CMY_M": 0.06482876,
    "CMY_Y": 0.1293462,
    "CMYK_C": 0,
    "CMYK_M": 0.02406182,
    "CMYK_Y": 0.0913918,
    "CMYK_K": 0.04177205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03251",
    "Farbtonhilfsbezeichnung": "G3.27.84",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "233",
    "Bcolor": "157",
    "Y": 82,
    "L": 92.6872531672862,
    "a": -2.70932222753811,
    "b": 39.0608013607633,
    "C": 39.1546501692665,
    "h": -1.50154557550447,
    "CMY_C": 0,
    "CMY_M": 0.08449562,
    "CMY_Y": 0.3839638,
    "CMYK_C": 0,
    "CMYK_M": 0.08449562,
    "CMYK_Y": 0.3839638,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03252",
    "Farbtonhilfsbezeichnung": "G2.32.82",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "228",
    "Bcolor": "136",
    "Y": 78,
    "L": 90.7859169896135,
    "a": -3.35099769111535,
    "b": 46.9446784332841,
    "C": 47.0641266649059,
    "h": -1.49953535285184,
    "CMY_C": 0.01192046,
    "CMY_M": 0.1055129,
    "CMY_Y": 0.4658094,
    "CMYK_C": 0,
    "CMYK_M": 0.09472153,
    "CMYK_Y": 0.4593648,
    "CMYK_K": 0.01192046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03253",
    "Farbtonhilfsbezeichnung": "G4.29.81",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "220",
    "Bcolor": "141",
    "Y": 71,
    "L": 87.398087484841,
    "a": -4.50744668057296,
    "b": 39.8767013596926,
    "C": 40.1306414963469,
    "h": -1.45823948483862,
    "CMY_C": 0.07167651,
    "CMY_M": 0.1391723,
    "CMY_Y": 0.4458646,
    "CMYK_C": 0,
    "CMYK_M": 0.07270719,
    "CMYK_Y": 0.4030794,
    "CMYK_K": 0.07167651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03254",
    "Farbtonhilfsbezeichnung": "G3.31.70",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "191",
    "Bcolor": "118",
    "Y": 52,
    "L": 76.985256682136,
    "a": -4.56919181793131,
    "b": 38.1668287613049,
    "C": 38.4393591461125,
    "h": -1.45164707522542,
    "CMY_C": 0.1932437,
    "CMY_M": 0.2521949,
    "CMY_Y": 0.5391034,
    "CMYK_C": 0,
    "CMYK_M": 0.07307192,
    "CMYK_Y": 0.4287041,
    "CMYK_K": 0.1932437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03255",
    "Farbtonhilfsbezeichnung": "G4.31.60",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "165",
    "Bcolor": "102",
    "Y": 37,
    "L": 67.4008309441293,
    "a": -4.75626915778177,
    "b": 33.7243268114958,
    "C": 34.0580726875412,
    "h": -1.43068662593737,
    "CMY_C": 0.3080177,
    "CMY_M": 0.3527585,
    "CMY_Y": 0.6010904,
    "CMYK_C": 0,
    "CMYK_M": 0.06465591,
    "CMYK_Y": 0.4235263,
    "CMYK_K": 0.3080177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03256",
    "Farbtonhilfsbezeichnung": "G3.30.51",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "138",
    "Bcolor": "85",
    "Y": 25,
    "L": 57.4318040551581,
    "a": -2.95741727236098,
    "b": 29.3513952417105,
    "C": 29.5000121958952,
    "h": -1.47037624444323,
    "CMY_C": 0.4106281,
    "CMY_M": 0.4586021,
    "CMY_Y": 0.6651545,
    "CMYK_C": 0,
    "CMYK_M": 0.08139842,
    "CMYK_Y": 0.4318604,
    "CMYK_K": 0.4106281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03257",
    "Farbtonhilfsbezeichnung": "G8.11.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "237",
    "Bcolor": "201",
    "Y": 84,
    "L": 93.488595974147,
    "a": -3.67834948734053,
    "b": 17.2826669764487,
    "C": 17.6697717237617,
    "h": -1.36109081352409,
    "CMY_C": 0.04826462,
    "CMY_M": 0.06869235,
    "CMY_Y": 0.2100908,
    "CMYK_C": 0,
    "CMYK_M": 0.02146366,
    "CMYK_Y": 0.1700327,
    "CMYK_K": 0.04826462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03258",
    "Farbtonhilfsbezeichnung": "G9.20.87",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "240",
    "Bcolor": "179",
    "Y": 85,
    "L": 94.0523345115174,
    "a": -7.01585228291179,
    "b": 29.8224085602803,
    "C": 30.6365506477462,
    "h": -1.33974331148979,
    "CMY_C": 0.03476153,
    "CMY_M": 0.05740311,
    "CMY_Y": 0.2994334,
    "CMYK_C": 0,
    "CMYK_M": 0.02345698,
    "CMYK_Y": 0.2742036,
    "CMYK_K": 0.03476153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03259",
    "Farbtonhilfsbezeichnung": "G8.30.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "237",
    "Bcolor": "149",
    "Y": 81,
    "L": 92.3027212373626,
    "a": -10.2780363491332,
    "b": 42.471304287997,
    "C": 43.6972507043377,
    "h": -1.33336156111401,
    "CMY_C": 0.05136133,
    "CMY_M": 0.07201075,
    "CMY_Y": 0.4163539,
    "CMYK_C": 0,
    "CMYK_M": 0.02176742,
    "CMYK_Y": 0.3847541,
    "CMYK_K": 0.05136133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03260",
    "Farbtonhilfsbezeichnung": "G8.39.82",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "115",
    "Y": 73,
    "L": 88.2736713379214,
    "a": -12.4965217304246,
    "b": 53.6260160873265,
    "C": 55.0628064736731,
    "h": -1.34185117844103,
    "CMY_C": 0.09376016,
    "CMY_M": 0.1137451,
    "CMY_Y": 0.5486643,
    "CMYK_C": 0,
    "CMYK_M": 0.02205264,
    "CMYK_Y": 0.5019689,
    "CMYK_K": 0.09376016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03261",
    "Farbtonhilfsbezeichnung": "G7.42.70",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "200",
    "Bcolor": "99",
    "Y": 53,
    "L": 79.2709655761719,
    "a": -10.1325712203979,
    "b": 50.3692741394043,
    "C": 51.3783302307129,
    "h": 101.374137878418,
    "CMY_C": 0.18543416261673,
    "CMY_M": 0.21710097789764,
    "CMY_Y": 0.6135436296463,
    "CMYK_C": 0,
    "CMYK_M": 0.03887569904327,
    "CMYK_Y": 0.52556765079498,
    "CMYK_K": 0.18543416261673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03262",
    "Farbtonhilfsbezeichnung": "G7.41.60",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "164",
    "Bcolor": "79",
    "Y": 36,
    "L": 66.2818705581462,
    "a": -9.79199243603024,
    "b": 43.991323968102,
    "C": 45.0679453751087,
    "h": -1.35177772527962,
    "CMY_C": 0.3371704,
    "CMY_M": 0.3553204,
    "CMY_Y": 0.6916408,
    "CMYK_C": 0,
    "CMYK_M": 0.02738266,
    "CMYK_Y": 0.5347835,
    "CMYK_K": 0.3371704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03263",
    "Farbtonhilfsbezeichnung": "G7.31.51",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "141",
    "Bcolor": "87",
    "Y": 26,
    "L": 57.9183369404154,
    "a": -6.09311397002144,
    "b": 29.2050869179103,
    "C": 29.833925985937,
    "h": -1.36511476831643,
    "CMY_C": 0.4259563,
    "CMY_M": 0.447109,
    "CMY_Y": 0.6601697,
    "CMYK_C": 0,
    "CMYK_M": 0.03684863,
    "CMYK_Y": 0.4080063,
    "CMYK_K": 0.4259563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03264",
    "Farbtonhilfsbezeichnung": "G5.26.37",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "102",
    "Bcolor": "66",
    "Y": 13,
    "L": 42.9186484120344,
    "a": -3.13100921324883,
    "b": 20.8745740823437,
    "C": 21.1080804862192,
    "h": -1.42191466709929,
    "CMY_C": 0.5746963,
    "CMY_M": 0.6001912,
    "CMY_Y": 0.7411939,
    "CMYK_C": 0,
    "CMYK_M": 0.05994527,
    "CMYK_Y": 0.3914794,
    "CMYK_K": 0.5746963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03265",
    "Farbtonhilfsbezeichnung": "G7.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "242",
    "Bcolor": "222",
    "Y": 89,
    "L": 95.4015467191913,
    "a": -1.066166423277,
    "b": 9.19795487716037,
    "C": 9.25954020264514,
    "h": -1.4553978942634,
    "CMY_C": 0.03019344,
    "CMY_M": 0.05133308,
    "CMY_Y": 0.1281536,
    "CMYK_C": 0,
    "CMYK_M": 0.02179779,
    "CMYK_Y": 0.10101,
    "CMYK_K": 0.03019344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03266",
    "Farbtonhilfsbezeichnung": "G7.19.84",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "232",
    "Bcolor": "177",
    "Y": 80,
    "L": 91.491591967661,
    "a": -5.4262735913122,
    "b": 27.0068964785325,
    "C": 27.546631418196,
    "h": -1.37251460166294,
    "CMY_C": 0.0588703,
    "CMY_M": 0.08916228,
    "CMY_Y": 0.3050107,
    "CMYK_C": 0,
    "CMYK_M": 0.03218684,
    "CMYK_Y": 0.2615372,
    "CMYK_K": 0.0588703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03267",
    "Farbtonhilfsbezeichnung": "G8.19.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "218",
    "Bcolor": "164",
    "Y": 68,
    "L": 86.2369452157623,
    "a": -5.72408204016617,
    "b": 26.6308502503517,
    "C": 27.2390767145146,
    "h": -1.35907582645243,
    "CMY_C": 0.1212355,
    "CMY_M": 0.1467317,
    "CMY_Y": 0.3577128,
    "CMYK_C": 0,
    "CMYK_M": 0.02901366,
    "CMYK_Y": 0.269102,
    "CMYK_K": 0.1212355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03268",
    "Farbtonhilfsbezeichnung": "G9.19.72",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "195",
    "Bcolor": "147",
    "Y": 53,
    "L": 77.9742085198843,
    "a": -6.47058872671979,
    "b": 23.911933910861,
    "C": 24.7719418259397,
    "h": -1.30652458846733,
    "CMY_C": 0.2245705,
    "CMY_M": 0.2347661,
    "CMY_Y": 0.423504,
    "CMYK_C": 0,
    "CMYK_M": 0.01314838,
    "CMYK_Y": 0.2565462,
    "CMYK_K": 0.2245705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03269",
    "Farbtonhilfsbezeichnung": "G7.20.61",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "168",
    "Bcolor": "126",
    "Y": 38,
    "L": 68.2422562909393,
    "a": -4.86842654951991,
    "b": 21.7234709696528,
    "C": 22.2623172207526,
    "h": -1.35033006039111,
    "CMY_C": 0.3234856,
    "CMY_M": 0.3415856,
    "CMY_Y": 0.5060478,
    "CMYK_C": 0,
    "CMYK_M": 0.02675476,
    "CMYK_Y": 0.2698571,
    "CMYK_K": 0.3234856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03270",
    "Farbtonhilfsbezeichnung": "G8.21.50",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "138",
    "Bcolor": "103",
    "Y": 25,
    "L": 56.9637979324552,
    "a": -4.61276575154729,
    "b": 18.9094287593877,
    "C": 19.4639179993394,
    "h": -1.33152929011946,
    "CMY_C": 0.4462377,
    "CMY_M": 0.4581046,
    "CMY_Y": 0.5970399,
    "CMYK_C": 0,
    "CMYK_M": 0.0214297,
    "CMYK_Y": 0.2723229,
    "CMYK_K": 0.4462377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03271",
    "Farbtonhilfsbezeichnung": "G9.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "115",
    "Bcolor": "85",
    "Y": 17,
    "L": 47.9112590387701,
    "a": -4.1558850986938,
    "b": 16.6261507324774,
    "C": 17.1376856410836,
    "h": -1.32585460563905,
    "CMY_C": 0.5397547,
    "CMY_M": 0.5489728,
    "CMY_Y": 0.6673622,
    "CMYK_C": 0,
    "CMYK_M": 0.02002876,
    "CMYK_Y": 0.2772598,
    "CMYK_K": 0.5397547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03272",
    "Farbtonhilfsbezeichnung": "G9.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "244",
    "Bcolor": "230",
    "Y": 89,
    "L": 95.860466003418,
    "a": -1.13262164592743,
    "b": 5.91874027252197,
    "C": 6.02613639831543,
    "h": 100.83325958252,
    "CMY_C": 0.03584825992584,
    "CMY_M": 0.04509043693542,
    "CMY_Y": 0.09851205348969,
    "CMYK_C": 0,
    "CMYK_M": 0.00958581175655,
    "CMYK_Y": 0.06499370187521,
    "CMYK_K": 0.03584825992584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03273",
    "Farbtonhilfsbezeichnung": "H3.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "241",
    "Bcolor": "225",
    "Y": 87,
    "L": 94.8772054957668,
    "a": -2.32886423719758,
    "b": 7.08961707207796,
    "C": 7.46232395866041,
    "h": -1.25341160629104,
    "CMY_C": 0.05259764,
    "CMY_M": 0.05367987,
    "CMY_Y": 0.1183378,
    "CMYK_C": 0,
    "CMYK_M": 0.001142316,
    "CMYK_Y": 0.06938993,
    "CMYK_K": 0.05259764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03274",
    "Farbtonhilfsbezeichnung": "H1.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "239",
    "Bcolor": "215",
    "Y": 85,
    "L": 93.8689427120346,
    "a": -3.17471231011862,
    "b": 10.9640525977478,
    "C": 11.4144315503752,
    "h": -1.28894808090653,
    "CMY_C": 0.05845525,
    "CMY_M": 0.06404296,
    "CMY_Y": 0.1585381,
    "CMYK_C": 0,
    "CMYK_M": 0.005934623,
    "CMYK_Y": 0.1062964,
    "CMYK_K": 0.05845525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03275",
    "Farbtonhilfsbezeichnung": "H1.17.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "232",
    "Bcolor": "181",
    "Y": 78,
    "L": 90.9509329654163,
    "a": -7.18327909538519,
    "b": 24.0177219086785,
    "C": 25.0689143012778,
    "h": -1.28018153437504,
    "CMY_C": 0.08544582,
    "CMY_M": 0.09055873,
    "CMY_Y": 0.288553,
    "CMYK_C": 0,
    "CMYK_M": 0.005590604,
    "CMYK_Y": 0.2220833,
    "CMYK_K": 0.08544582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03276",
    "Farbtonhilfsbezeichnung": "H1.17.78",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "215",
    "Bcolor": "168",
    "Y": 66,
    "L": 85.1110901480659,
    "a": -7.14179807403681,
    "b": 22.6493650946397,
    "C": 23.7486635186193,
    "h": -1.26534440374719,
    "CMY_C": 0.1539092,
    "CMY_M": 0.155136,
    "CMY_Y": 0.3401437,
    "CMYK_C": 0,
    "CMYK_M": 0.001449968,
    "CMYK_Y": 0.2201117,
    "CMYK_K": 0.1539092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03277",
    "Farbtonhilfsbezeichnung": "G9.18.68",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "186",
    "Bcolor": "146",
    "Y": 48,
    "L": 74.8301647624097,
    "a": -5.35337334361241,
    "b": 19.9029356575066,
    "C": 20.6103239650169,
    "h": -1.30804097286031,
    "CMY_C": 0.2603742,
    "CMY_M": 0.270237,
    "CMY_Y": 0.4264328,
    "CMYK_C": 0,
    "CMYK_M": 0.01333492,
    "CMYK_Y": 0.2245172,
    "CMYK_K": 0.2603742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03278",
    "Farbtonhilfsbezeichnung": "G9.18.59",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "164",
    "Bcolor": "126",
    "Y": 36,
    "L": 66.5584898048995,
    "a": -5.72866353754586,
    "b": 19.2388733002961,
    "C": 20.0736601493413,
    "h": -1.28139122974827,
    "CMY_C": 0.3531042,
    "CMY_M": 0.356924,
    "CMY_Y": 0.5053956,
    "CMYK_C": 0,
    "CMYK_M": 0.005904769,
    "CMYK_Y": 0.2354187,
    "CMYK_K": 0.3531042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03279",
    "Farbtonhilfsbezeichnung": "H1.21.50",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "140",
    "Bcolor": "104",
    "Y": 25,
    "L": 57.3466847174827,
    "a": -6.55471608253355,
    "b": 18.7907826635359,
    "C": 19.9012013715471,
    "h": -1.23516764975784,
    "CMY_C": 0.4557531,
    "CMY_M": 0.4502204,
    "CMY_Y": 0.5928623,
    "CMYK_C": 0.01006348,
    "CMYK_M": 0,
    "CMYK_Y": 0.2594529,
    "CMYK_K": 0.4502204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03280",
    "Farbtonhilfsbezeichnung": "HN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "231",
    "Bcolor": "222",
    "Y": 80,
    "L": 91.5376558125835,
    "a": -1.19424088447373,
    "b": 3.715345636081,
    "C": 3.90256383492887,
    "h": -1.25979252212214,
    "CMY_C": 0.09210661,
    "CMY_M": 0.09288017,
    "CMY_Y": 0.1298543,
    "CMYK_C": 0,
    "CMYK_M": 0.0008520284,
    "CMYK_Y": 0.0415772,
    "CMYK_K": 0.09210661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03281",
    "Farbtonhilfsbezeichnung": "H4.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "222",
    "Bcolor": "198",
    "Y": 72,
    "L": 87.8316111003781,
    "a": -4.07225788480786,
    "b": 10.720545517479,
    "C": 11.4679283426746,
    "h": -1.20777561383129,
    "CMY_C": 0.1335839,
    "CMY_M": 0.1292609,
    "CMY_Y": 0.2224968,
    "CMYK_C": 0.004964826,
    "CMYK_M": 0,
    "CMYK_Y": 0.1070768,
    "CMYK_K": 0.1292609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03282",
    "Farbtonhilfsbezeichnung": "H1.09.75",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "206",
    "Bcolor": "180",
    "Y": 61,
    "L": 82.1256954627421,
    "a": -4.0275381551404,
    "b": 11.956353593502,
    "C": 12.6164755317783,
    "h": -1.24588108032488,
    "CMY_C": 0.1924389,
    "CMY_M": 0.1924494,
    "CMY_Y": 0.292595,
    "CMYK_C": 0,
    "CMYK_M": 1.292731e-05,
    "CMYK_Y": 0.1240229,
    "CMYK_K": 0.1924389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03283",
    "Farbtonhilfsbezeichnung": "H3.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "192",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.9213069739057,
    "a": -4.14643902468476,
    "b": 11.8855329830802,
    "C": 12.5880439654982,
    "h": -1.23513355889761,
    "CMY_C": 0.2501126,
    "CMY_M": 0.2486444,
    "CMY_Y": 0.3468997,
    "CMYK_C": 0.001953959,
    "CMYK_M": 0,
    "CMYK_Y": 0.1307707,
    "CMYK_K": 0.2486444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03284",
    "Farbtonhilfsbezeichnung": "H3.10.61",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "168",
    "Bcolor": "146",
    "Y": 38,
    "L": 68.2701271886316,
    "a": -4.1338666426054,
    "b": 10.864135356346,
    "C": 11.6240393349237,
    "h": -1.20720740251275,
    "CMY_C": 0.3451457,
    "CMY_M": 0.3405799,
    "CMY_Y": 0.4289777,
    "CMYK_C": 0.006923958,
    "CMYK_M": 0,
    "CMYK_Y": 0.1340539,
    "CMYK_K": 0.3405799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03285",
    "Farbtonhilfsbezeichnung": "H5.09.54",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "148",
    "Bcolor": "131",
    "Y": 29,
    "L": 60.6546719143074,
    "a": -3.96175454598613,
    "b": 8.20337732470575,
    "C": 9.10993406200826,
    "h": -1.1208880945713,
    "CMY_C": 0.4304912,
    "CMY_M": 0.4195445,
    "CMY_Y": 0.4874097,
    "CMYK_C": 0.01885886,
    "CMYK_M": 0,
    "CMYK_Y": 0.1169172,
    "CMYK_K": 0.4195445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03286",
    "Farbtonhilfsbezeichnung": "H5.10.46",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "129",
    "Bcolor": "112",
    "Y": 21,
    "L": 53.231806135611,
    "a": -3.92700166000781,
    "b": 8.27556782678902,
    "C": 9.16004175173289,
    "h": -1.12773188726565,
    "CMY_C": 0.5052241,
    "CMY_M": 0.4949871,
    "CMY_Y": 0.561092,
    "CMYK_C": 0.02027075,
    "CMYK_M": 0,
    "CMYK_Y": 0.1308975,
    "CMYK_K": 0.4949871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03287",
    "Farbtonhilfsbezeichnung": "HN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "224",
    "Bcolor": "213",
    "Y": 74,
    "L": 88.7032066897153,
    "a": -1.88487243594909,
    "b": 4.00255593993528,
    "C": 4.42416072855766,
    "h": -1.13068445576194,
    "CMY_C": 0.1281162,
    "CMY_M": 0.122893,
    "CMY_Y": 0.1631753,
    "CMYK_C": 0.005955026,
    "CMYK_M": 0,
    "CMYK_Y": 0.04592632,
    "CMYK_K": 0.122893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03288",
    "Farbtonhilfsbezeichnung": "G8.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "215",
    "Bcolor": "204",
    "Y": 66,
    "L": 85.8612747192383,
    "a": -1.27744054794312,
    "b": 4.80067348480225,
    "C": 4.96772766113281,
    "h": 104.900894165039,
    "CMY_C": 0.15219324827194,
    "CMY_M": 0.15591484308243,
    "CMY_Y": 0.1998884677887,
    "CMYK_C": 0,
    "CMYK_M": 0.00438967347145,
    "CMYK_Y": 0.05625718459487,
    "CMYK_K": 0.15219324827194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03289",
    "Farbtonhilfsbezeichnung": "G9.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "199",
    "Bcolor": "188",
    "Y": 57,
    "L": 80.1368092905768,
    "a": -1.28492691533472,
    "b": 5.0500157226516,
    "C": 5.21092083770037,
    "h": -1.32164305532678,
    "CMY_C": 0.2141453,
    "CMY_M": 0.2186064,
    "CMY_Y": 0.2632886,
    "CMYK_C": 0,
    "CMYK_M": 0.005676684,
    "CMYK_Y": 0.06253489,
    "CMYK_K": 0.2141453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03290",
    "Farbtonhilfsbezeichnung": "H0.04.65",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "179",
    "Bcolor": "168",
    "Y": 44,
    "L": 72.7059173583984,
    "a": -1.46967697143555,
    "b": 4.83924150466919,
    "C": 5.05749034881592,
    "h": 106.893524169922,
    "CMY_C": 0.29614293575287,
    "CMY_M": 0.29800599813461,
    "CMY_Y": 0.34033805131912,
    "CMYK_C": 0,
    "CMYK_M": 0.00264693284407,
    "CMYK_Y": 0.06278990209103,
    "CMYK_K": 0.29614293575287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03291",
    "Farbtonhilfsbezeichnung": "G8.05.54",
    "Farbtonklasse": "01",
    "Rcolor": "151",
    "Gcolor": "150",
    "Bcolor": "140",
    "Y": 30,
    "L": 61.9902116957394,
    "a": -1.42209498410523,
    "b": 4.91530734086041,
    "C": 5.11689362786969,
    "h": -1.28916659311439,
    "CMY_C": 0.4079404,
    "CMY_M": 0.4104341,
    "CMY_Y": 0.4511155,
    "CMYK_C": 0,
    "CMYK_M": 0.004211725,
    "CMYK_Y": 0.07292348,
    "CMYK_K": 0.4079404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03292",
    "Farbtonhilfsbezeichnung": "G6.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "126",
    "Gcolor": "125",
    "Bcolor": "117",
    "Y": 20,
    "L": 52.340334142417,
    "a": -1.29966934106879,
    "b": 4.10251534561665,
    "C": 4.30346053277293,
    "h": -1.2640004964534,
    "CMY_C": 0.5073754,
    "CMY_M": 0.5083725,
    "CMY_Y": 0.5416739,
    "CMYK_C": 0,
    "CMYK_M": 0.002024152,
    "CMYK_Y": 0.06962399,
    "CMYK_K": 0.5073754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03293",
    "Farbtonhilfsbezeichnung": "G7.05.36",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "104",
    "Bcolor": "97",
    "Y": 14,
    "L": 43.7660436377306,
    "a": -0.8008808023549,
    "b": 3.19085681775007,
    "C": 3.28982937110159,
    "h": -1.32488386093225,
    "CMY_C": 0.5907015,
    "CMY_M": 0.5933005,
    "CMY_Y": 0.6182878,
    "CMYK_C": 0,
    "CMYK_M": 0.006350006,
    "CMYK_Y": 0.06739919,
    "CMYK_K": 0.5907015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03294",
    "Farbtonhilfsbezeichnung": "H0.04.25",
    "Farbtonklasse": "02",
    "Rcolor": "79",
    "Gcolor": "79",
    "Bcolor": "75",
    "Y": 8,
    "L": 33.5519072126451,
    "a": -1.09555973439179,
    "b": 2.31422250470179,
    "C": 2.5604446748346,
    "h": -1.12865185540137,
    "CMY_C": 0.69135,
    "CMY_M": 0.6888196,
    "CMY_Y": 0.707522,
    "CMYK_C": 0.008131414,
    "CMYK_M": 0,
    "CMYK_Y": 0.06010122,
    "CMYK_K": 0.6888196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03295",
    "Farbtonhilfsbezeichnung": "H8.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "240",
    "Bcolor": "224",
    "Y": 86,
    "L": 94.3470252018906,
    "a": -3.0561477870461,
    "b": 6.72378182108679,
    "C": 7.38574852495291,
    "h": -1.14418321527143,
    "CMY_C": 0.06548477,
    "CMY_M": 0.05783736,
    "CMY_Y": 0.1215613,
    "CMYK_C": 0.008116866,
    "CMYK_M": 0,
    "CMYK_Y": 0.06763581,
    "CMYK_K": 0.05783736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03296",
    "Farbtonhilfsbezeichnung": "H5.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "228",
    "Bcolor": "211",
    "Y": 76,
    "L": 90.0795281364272,
    "a": -3.03863651635583,
    "b": 7.31861569986738,
    "C": 7.92435786930881,
    "h": -1.17726170625557,
    "CMY_C": 0.1111409,
    "CMY_M": 0.1057988,
    "CMY_Y": 0.1728083,
    "CMYK_C": 0.005974144,
    "CMYK_M": 0,
    "CMYK_Y": 0.07493778,
    "CMYK_K": 0.1057988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03297",
    "Farbtonhilfsbezeichnung": "H9.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "206",
    "Bcolor": "191",
    "Y": 61,
    "L": 82.1943321569051,
    "a": -3.80399664972708,
    "b": 6.21038226679471,
    "C": 7.2828042957952,
    "h": -1.02122021186355,
    "CMY_C": 0.207427,
    "CMY_M": 0.190769,
    "CMY_Y": 0.2500469,
    "CMYK_C": 0.02058497,
    "CMYK_M": 0,
    "CMYK_Y": 0.07325208,
    "CMYK_K": 0.190769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03298",
    "Farbtonhilfsbezeichnung": "H8.08.70",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "193",
    "Bcolor": "173",
    "Y": 52,
    "L": 77.1408669516186,
    "a": -4.47039105811581,
    "b": 8.84938501787778,
    "C": 9.91443449759599,
    "h": -1.10302602771332,
    "CMY_C": 0.2590509,
    "CMY_M": 0.2448296,
    "CMY_Y": 0.3228375,
    "CMYK_C": 0.01883193,
    "CMYK_M": 0,
    "CMYK_Y": 0.1032985,
    "CMYK_K": 0.2448296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03299",
    "Farbtonhilfsbezeichnung": "H9.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "168",
    "Bcolor": "148",
    "Y": 38,
    "L": 67.9535008792917,
    "a": -4.85338788887413,
    "b": 8.86333751902961,
    "C": 10.1051534365445,
    "h": -1.06981284691616,
    "CMY_C": 0.3594463,
    "CMY_M": 0.3419009,
    "CMY_Y": 0.418295,
    "CMYK_C": 0.02666064,
    "CMYK_M": 0,
    "CMYK_Y": 0.1160828,
    "CMYK_K": 0.3419009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03300",
    "Farbtonhilfsbezeichnung": "J0.10.61",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "140",
    "Bcolor": "122",
    "Y": 25,
    "L": 57.2157215432152,
    "a": -5.17499806435312,
    "b": 8.39018794430491,
    "C": 9.85778163213296,
    "h": -1.01812141502623,
    "CMY_C": 0.4737088,
    "CMY_M": 0.4522359,
    "CMY_Y": 0.5230085,
    "CMYK_C": 0.03920096,
    "CMYK_M": 0,
    "CMYK_Y": 0.1292028,
    "CMYK_K": 0.4522359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03301",
    "Farbtonhilfsbezeichnung": "H8.08.41",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "118",
    "Bcolor": "106",
    "Y": 18,
    "L": 49.223007797439,
    "a": -3.26446559948762,
    "b": 6.03639091588417,
    "C": 6.8625615435934,
    "h": -1.07504575605724,
    "CMY_C": 0.5465025,
    "CMY_M": 0.5357114,
    "CMY_Y": 0.5849528,
    "CMYK_C": 0.02324232,
    "CMYK_M": 0,
    "CMYK_Y": 0.1060578,
    "CMYK_K": 0.5357114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03302",
    "Farbtonhilfsbezeichnung": "H9.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "98",
    "Bcolor": "86",
    "Y": 12,
    "L": 40.9478344039069,
    "a": -3.51050599266892,
    "b": 5.94942181808329,
    "C": 6.90791374396423,
    "h": -1.03771893816957,
    "CMY_C": 0.628454,
    "CMY_M": 0.6155804,
    "CMY_Y": 0.6626744,
    "CMYK_C": 0.03348826,
    "CMYK_M": 0,
    "CMYK_Y": 0.1225065,
    "CMYK_K": 0.6155804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03303",
    "Farbtonhilfsbezeichnung": "H6.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "237",
    "Bcolor": "209",
    "Y": 82,
    "L": 92.7253446574857,
    "a": -5.47978395998788,
    "b": 12.0127252560529,
    "C": 13.2035449908557,
    "h": -1.14282748585594,
    "CMY_C": 0.08607675,
    "CMY_M": 0.07179889,
    "CMY_Y": 0.1792281,
    "CMYK_C": 0.0153823,
    "CMYK_M": 0,
    "CMYK_Y": 0.1157392,
    "CMYK_K": 0.07179889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03304",
    "Farbtonhilfsbezeichnung": "H7.11.78",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "216",
    "Bcolor": "186",
    "Y": 66,
    "L": 85.0939700807394,
    "a": -6.8165229620788,
    "b": 13.1903166872264,
    "C": 14.8475398501527,
    "h": -1.09381314809879,
    "CMY_C": 0.1775635,
    "CMY_M": 0.153925,
    "CMY_Y": 0.2704771,
    "CMYK_C": 0.02793907,
    "CMYK_M": 0,
    "CMYK_Y": 0.1377562,
    "CMYK_K": 0.153925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03305",
    "Farbtonhilfsbezeichnung": "H7.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "201",
    "Bcolor": "171",
    "Y": 57,
    "L": 79.9496031492023,
    "a": -6.44817026066702,
    "b": 13.6470965488384,
    "C": 15.0937783183624,
    "h": -1.12939470482667,
    "CMY_C": 0.2295882,
    "CMY_M": 0.2111821,
    "CMY_Y": 0.3282381,
    "CMYK_C": 0.02333381,
    "CMYK_M": 0,
    "CMYK_Y": 0.1483942,
    "CMYK_K": 0.2111821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03306",
    "Farbtonhilfsbezeichnung": "J0.19.69",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "194",
    "Bcolor": "148",
    "Y": 51,
    "L": 76.4102715230152,
    "a": -12.4493664009488,
    "b": 21.0882348627036,
    "C": 24.4887805619149,
    "h": -1.03750520050937,
    "CMY_C": 0.2927734,
    "CMY_M": 0.2383858,
    "CMY_Y": 0.4200201,
    "CMYK_C": 0.07141091,
    "CMYK_M": 0,
    "CMYK_Y": 0.2384859,
    "CMYK_K": 0.2383858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03307",
    "Farbtonhilfsbezeichnung": "H9.21.60",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "169",
    "Bcolor": "124",
    "Y": 37,
    "L": 67.0858952347483,
    "a": -11.8109533934783,
    "b": 20.8169740150991,
    "C": 23.9341811476438,
    "h": -1.05471412420244,
    "CMY_C": 0.3875031,
    "CMY_M": 0.339168,
    "CMY_Y": 0.5123476,
    "CMYK_C": 0.07314274,
    "CMYK_M": 0,
    "CMYK_Y": 0.2620629,
    "CMYK_K": 0.339168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03308",
    "Farbtonhilfsbezeichnung": "H9.30.51",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "146",
    "Bcolor": "92",
    "Y": 26,
    "L": 58.1343940236524,
    "a": -15.1114741664819,
    "b": 26.0556492561206,
    "C": 30.1206492234518,
    "h": -1.04523557732876,
    "CMY_C": 0.4917325,
    "CMY_M": 0.4268208,
    "CMY_Y": 0.6375191,
    "CMYK_C": 0.1132485,
    "CMYK_M": 0,
    "CMYK_Y": 0.3675959,
    "CMYK_K": 0.4268208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03310",
    "Farbtonhilfsbezeichnung": "H8.22.39",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "121",
    "Bcolor": "93",
    "Y": 17.7593955993652,
    "L": 49.2029685974121,
    "a": -8.42183589935303,
    "b": 13.492262840271,
    "C": 15.9049825668335,
    "h": 121.972305297852,
    "CMY_C": 0.56298053264618,
    "CMY_M": 0.52733212709427,
    "CMY_Y": 0.6350879073143,
    "CMYK_C": 0.07541956752539,
    "CMYK_M": 0,
    "CMYK_Y": 0.22797356545925,
    "CMYK_K": 0.52733212709427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03311",
    "Farbtonhilfsbezeichnung": "K0.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "240",
    "Bcolor": "238",
    "Y": 87,
    "L": 94.6482312632782,
    "a": -0.98470483761403,
    "b": -0.37385586141303,
    "C": 1.05328620152994,
    "h": 0.36285238295791,
    "CMY_C": 0.06964037,
    "CMY_M": 0.05735493,
    "CMY_Y": 0.06490654,
    "CMYK_C": 0.01303294,
    "CMYK_M": 0,
    "CMYK_Y": 0.008011092,
    "CMYK_K": 0.05735493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03312",
    "Farbtonhilfsbezeichnung": "K1.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "225",
    "Bcolor": "199",
    "Y": 71,
    "L": 87.6022448789943,
    "a": -10.8143460431652,
    "b": 9.86528122866195,
    "C": 14.6380959848579,
    "h": -0.73953663379939,
    "CMY_C": 0.1922288,
    "CMY_M": 0.11657,
    "CMY_Y": 0.219669,
    "CMYK_C": 0.08564211,
    "CMYK_M": 0,
    "CMYK_Y": 0.1167031,
    "CMYK_K": 0.11657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03313",
    "Farbtonhilfsbezeichnung": "J9.13.76",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "216",
    "Bcolor": "183",
    "Y": 64,
    "L": 83.9199710661112,
    "a": -12.5908842516558,
    "b": 12.7724145768206,
    "C": 17.9350199431384,
    "h": -0.79255524603177,
    "CMY_C": 0.2372725,
    "CMY_M": 0.1542472,
    "CMY_Y": 0.2808006,
    "CMYK_C": 0.09816731,
    "CMYK_M": 0,
    "CMYK_Y": 0.149634,
    "CMYK_K": 0.1542472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03314",
    "Farbtonhilfsbezeichnung": "K0.13.66",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "187",
    "Bcolor": "159",
    "Y": 46,
    "L": 73.5318481584846,
    "a": -12.2553373165849,
    "b": 11.0744494999395,
    "C": 16.5177699605603,
    "h": -0.7348241544423,
    "CMY_C": 0.351003,
    "CMY_M": 0.2676645,
    "CMY_Y": 0.377569,
    "CMYK_C": 0.1137982,
    "CMYK_M": 0,
    "CMYK_Y": 0.150074,
    "CMYK_K": 0.2676645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03315",
    "Farbtonhilfsbezeichnung": "J9.20.62",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "178",
    "Bcolor": "140",
    "Y": 40,
    "L": 69.7383046867911,
    "a": -16.6697845972609,
    "b": 16.0835405994951,
    "C": 23.1638079066177,
    "h": -0.76750131163911,
    "CMY_C": 0.4103806,
    "CMY_M": 0.3005787,
    "CMY_Y": 0.4528004,
    "CMYK_C": 0.1569896,
    "CMYK_M": 0,
    "CMYK_Y": 0.2176395,
    "CMYK_K": 0.3005787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03316",
    "Farbtonhilfsbezeichnung": "K0.21.60",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "170",
    "Bcolor": "131",
    "Y": 36,
    "L": 66.5446091164556,
    "a": -17.9567314586142,
    "b": 16.4893816919194,
    "C": 24.3791696589238,
    "h": -0.74282548873052,
    "CMY_C": 0.4525318,
    "CMY_M": 0.3321252,
    "CMY_Y": 0.488086,
    "CMYK_C": 0.1802831,
    "CMYK_M": 0,
    "CMYK_Y": 0.2335179,
    "CMYK_K": 0.3321252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03317",
    "Farbtonhilfsbezeichnung": "K1.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "148",
    "Bcolor": "118",
    "Y": 27,
    "L": 58.9323035910686,
    "a": -14.0979591957437,
    "b": 12.8133709356514,
    "C": 19.0508511153558,
    "h": -0.73770026360753,
    "CMY_C": 0.510321,
    "CMY_M": 0.4181307,
    "CMY_Y": 0.537518,
    "CMYK_C": 0.1584381,
    "CMYK_M": 0,
    "CMYK_Y": 0.2051789,
    "CMYK_K": 0.4181307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03318",
    "Farbtonhilfsbezeichnung": "K3.19.43",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "125",
    "Bcolor": "99",
    "Y": 18,
    "L": 49.8703601234676,
    "a": -13.8032354831853,
    "b": 10.823803937102,
    "C": 17.5409247610578,
    "h": -0.66500116760941,
    "CMY_C": 0.6034856,
    "CMY_M": 0.5102791,
    "CMY_Y": 0.6117952,
    "CMYK_C": 0.1903259,
    "CMYK_M": 0,
    "CMYK_Y": 0.207294,
    "CMYK_K": 0.5102791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03319",
    "Farbtonhilfsbezeichnung": "J6.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "227",
    "Bcolor": "216",
    "Y": 76,
    "L": 89.7463605283074,
    "a": -2.95183040215019,
    "b": 4.15929557687429,
    "C": 5.10029826763731,
    "h": -0.95359338278115,
    "CMY_C": 0.1244469,
    "CMY_M": 0.108865,
    "CMY_Y": 0.153068,
    "CMYK_C": 0.01748541,
    "CMYK_M": 0,
    "CMYK_Y": 0.04960296,
    "CMYK_K": 0.108865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03320",
    "Farbtonhilfsbezeichnung": "J7.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "226",
    "Bcolor": "212",
    "Y": 75,
    "L": 89.2261276086058,
    "a": -4.25068831516884,
    "b": 5.60502582113056,
    "C": 7.03453378755502,
    "h": -0.92195935087743,
    "CMY_C": 0.1357068,
    "CMY_M": 0.1120508,
    "CMY_Y": 0.1696257,
    "CMYK_C": 0.02664123,
    "CMYK_M": 0,
    "CMYK_Y": 0.06484035,
    "CMYK_K": 0.1120508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03321",
    "Farbtonhilfsbezeichnung": "J8.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "222",
    "Bcolor": "202",
    "Y": 71,
    "L": 87.2429496362176,
    "a": -6.44578762040265,
    "b": 8.0389331290089,
    "C": 10.3040100883109,
    "h": -0.89494583654089,
    "CMY_C": 0.1670284,
    "CMY_M": 0.1297306,
    "CMY_Y": 0.2094474,
    "CMYK_C": 0.04285777,
    "CMYK_M": 0,
    "CMYK_Y": 0.09160019,
    "CMYK_K": 0.1297306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03322",
    "Farbtonhilfsbezeichnung": "J9.09.73",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "203",
    "Bcolor": "180",
    "Y": 57,
    "L": 80.1225466502449,
    "a": -8.90650669831161,
    "b": 9.26493457599888,
    "C": 12.8516486983036,
    "h": -0.80512039670453,
    "CMY_C": 0.2600391,
    "CMY_M": 0.2029181,
    "CMY_Y": 0.2950087,
    "CMYK_C": 0.07166272,
    "CMYK_M": 0,
    "CMYK_Y": 0.1155347,
    "CMYK_K": 0.2029181
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03323",
    "Farbtonhilfsbezeichnung": "J9.07.69",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "192",
    "Bcolor": "177",
    "Y": 51,
    "L": 76.6018504776378,
    "a": -6.49340452569341,
    "b": 5.91661324393162,
    "C": 8.78468067789392,
    "h": -0.73895370996465,
    "CMY_C": 0.2896084,
    "CMY_M": 0.2454903,
    "CMY_Y": 0.3077751,
    "CMYK_C": 0.0584726,
    "CMYK_M": 0,
    "CMYK_Y": 0.08255016,
    "CMYK_K": 0.2454903
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03324",
    "Farbtonhilfsbezeichnung": "K2.09.60",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "171",
    "Bcolor": "154",
    "Y": 39,
    "L": 68.3992144802768,
    "a": -8.22293700370535,
    "b": 6.52280763187432,
    "C": 10.4958902609233,
    "h": -0.67060874236357,
    "CMY_C": 0.3875453,
    "CMY_M": 0.3295577,
    "CMY_Y": 0.3978032,
    "CMYK_C": 0.08649149,
    "CMYK_M": 0,
    "CMYK_Y": 0.1017917,
    "CMYK_K": 0.3295577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03325",
    "Farbtonhilfsbezeichnung": "K1.11.50",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "142",
    "Bcolor": "124",
    "Y": 25,
    "L": 57.3246125884605,
    "a": -8.12186011889426,
    "b": 7.11149912969216,
    "C": 10.7952782114449,
    "h": -0.71916961076251,
    "CMY_C": 0.4980382,
    "CMY_M": 0.4449108,
    "CMY_Y": 0.5136767,
    "CMYK_C": 0.0957097,
    "CMYK_M": 0,
    "CMYK_Y": 0.1238826,
    "CMYK_K": 0.4449108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03326",
    "Farbtonhilfsbezeichnung": "K0.11.39",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "115",
    "Bcolor": "100",
    "Y": 16,
    "L": 47.1434340365991,
    "a": -6.74247057037719,
    "b": 6.1236605712139,
    "C": 9.10824506608393,
    "h": -0.73733915453932,
    "CMY_C": 0.5911487,
    "CMY_M": 0.5493746,
    "CMY_Y": 0.6059044,
    "CMYK_C": 0.0927024,
    "CMYK_M": 0,
    "CMYK_Y": 0.1254473,
    "CMYK_K": 0.5493746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03327",
    "Farbtonhilfsbezeichnung": "HN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "213",
    "Bcolor": "204",
    "Y": 65,
    "L": 84.8375549316406,
    "a": -1.58978259563446,
    "b": 3.2899854183197,
    "C": 3.65395855903625,
    "h": 115.790710449219,
    "CMY_C": 0.17077565193176,
    "CMY_M": 0.16604912281036,
    "CMY_Y": 0.19998544454575,
    "CMYK_C": 0.005667634774,
    "CMYK_M": 0,
    "CMYK_Y": 0.04069342836738,
    "CMYK_K": 0.16604912281036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03328",
    "Farbtonhilfsbezeichnung": "KN.02.69",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "186",
    "Bcolor": "181",
    "Y": 48,
    "L": 75.0171172273309,
    "a": -2.73842814379732,
    "b": 1.42117286989987,
    "C": 3.08524245803805,
    "h": -0.47871129362308,
    "CMY_C": 0.2921535,
    "CMY_M": 0.2696095,
    "CMY_Y": 0.2919304,
    "CMYK_C": 0.03086575,
    "CMYK_M": 0,
    "CMYK_Y": 0.03056025,
    "CMYK_K": 0.2696095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03329",
    "Farbtonhilfsbezeichnung": "K0.04.63",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "174",
    "Bcolor": "165",
    "Y": 42,
    "L": 70.5821867471334,
    "a": -3.17600761657588,
    "b": 3.38037933086943,
    "C": 4.63831745368051,
    "h": -0.81655946633933,
    "CMY_C": 0.3360617,
    "CMY_M": 0.31643,
    "CMY_Y": 0.3524559,
    "CMYK_C": 0.02871923,
    "CMYK_M": 0,
    "CMYK_Y": 0.05270251,
    "CMYK_K": 0.31643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03330",
    "Farbtonhilfsbezeichnung": "K1.04.55",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "153",
    "Bcolor": "145",
    "Y": 31,
    "L": 62.5864055095602,
    "a": -3.39605007259258,
    "b": 2.92351043745864,
    "C": 4.48107904120042,
    "h": -0.71076292668198,
    "CMY_C": 0.4223447,
    "CMY_M": 0.3995508,
    "CMY_Y": 0.4316704,
    "CMYK_C": 0.03796128,
    "CMYK_M": 0,
    "CMYK_Y": 0.05349264,
    "CMYK_K": 0.3995508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03331",
    "Farbtonhilfsbezeichnung": "K0.05.47",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "134",
    "Bcolor": "126",
    "Y": 23,
    "L": 55.1571998596191,
    "a": -3.60790324211121,
    "b": 3.08769059181213,
    "C": 4.74876832962036,
    "h": 139.442657470703,
    "CMY_C": 0.49871170520782,
    "CMY_M": 0.47505766153336,
    "CMY_Y": 0.50745499134064,
    "CMYK_C": 0.04506026953459,
    "CMYK_M": 0,
    "CMYK_Y": 0.06171597912908,
    "CMYK_K": 0.47505766153336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03332",
    "Farbtonhilfsbezeichnung": "H7.06.25",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "90",
    "Bcolor": "84",
    "Y": 7,
    "L": 37.6784324645996,
    "a": -1.99442577362061,
    "b": 2.28723835945129,
    "C": 3.03466534614563,
    "h": 131.087783813477,
    "CMY_C": 0.65911221504211,
    "CMY_M": 0.64867359399796,
    "CMY_Y": 0.66970783472061,
    "CMYK_C": 0.02971203066409,
    "CMYK_M": 0,
    "CMYK_Y": 0.05987093597651,
    "CMYK_K": 0.64867359399796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03333",
    "Farbtonhilfsbezeichnung": "K6.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 84,
    "L": 93.2788916158701,
    "a": -3.84187435160788,
    "b": 3.3879214751853,
    "C": 5.12230518961572,
    "h": -0.72269131415738,
    "CMY_C": 0.09488398,
    "CMY_M": 0.06710129,
    "CMY_Y": 0.1085792,
    "CMYK_C": 0.02978103,
    "CMYK_M": 0,
    "CMYK_Y": 0.04446128,
    "CMYK_K": 0.06710129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03334",
    "Farbtonhilfsbezeichnung": "K9.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "239",
    "Bcolor": "228",
    "Y": 84,
    "L": 93.2746075222875,
    "a": -5.03208629447183,
    "b": 2.9297527783618,
    "C": 5.8228295370318,
    "h": -0.52723914190426,
    "CMY_C": 0.10619,
    "CMY_M": 0.06427433,
    "CMY_Y": 0.1053799,
    "CMYK_C": 0.0447948,
    "CMYK_M": 0,
    "CMYK_Y": 0.04392905,
    "CMYK_K": 0.06427433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03335",
    "Farbtonhilfsbezeichnung": "K9.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "218",
    "Bcolor": "206",
    "Y": 67,
    "L": 85.7368117561273,
    "a": -5.71854630941715,
    "b": 3.51311461834836,
    "C": 6.71146379075395,
    "h": -0.55089477317547,
    "CMY_C": 0.1928755,
    "CMY_M": 0.1468375,
    "CMY_Y": 0.1924366,
    "CMYK_C": 0.0539616,
    "CMYK_M": 0,
    "CMYK_Y": 0.05344712,
    "CMYK_K": 0.1468375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03336",
    "Farbtonhilfsbezeichnung": "L6.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "208",
    "Bcolor": "198",
    "Y": 60,
    "L": 81.8747596593821,
    "a": -7.00148730241784,
    "b": 2.24397748013763,
    "C": 7.3522961976027,
    "h": -0.31015653815144,
    "CMY_C": 0.2496467,
    "CMY_M": 0.1861161,
    "CMY_Y": 0.2251355,
    "CMYK_C": 0.07805851,
    "CMYK_M": 0,
    "CMYK_Y": 0.04794217,
    "CMYK_K": 0.1861161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03337",
    "Farbtonhilfsbezeichnung": "K9.06.69",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "194",
    "Bcolor": "181",
    "Y": 51,
    "L": 76.9099731567934,
    "a": -7.08771995832458,
    "b": 3.79673666471159,
    "C": 8.0405835303663,
    "h": -0.49178109235325,
    "CMY_C": 0.2981237,
    "CMY_M": 0.2403385,
    "CMY_Y": 0.2894121,
    "CMYK_C": 0.07606707,
    "CMYK_M": 0,
    "CMYK_Y": 0.06459927,
    "CMYK_K": 0.2403385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03338",
    "Farbtonhilfsbezeichnung": "K9.09.58",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "164",
    "Bcolor": "149",
    "Y": 35,
    "L": 65.7161250365573,
    "a": -9.26418420631342,
    "b": 5.24769988064218,
    "C": 10.6472279512462,
    "h": -0.51538521252181,
    "CMY_C": 0.427633,
    "CMY_M": 0.3553569,
    "CMY_Y": 0.416568,
    "CMYK_C": 0.1121181,
    "CMYK_M": 0,
    "CMYK_Y": 0.09495357,
    "CMYK_K": 0.3553569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03339",
    "Farbtonhilfsbezeichnung": "L0.09.51",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "145",
    "Bcolor": "132",
    "Y": 26,
    "L": 58.4109373760351,
    "a": -8.97784816065183,
    "b": 3.83621612195819,
    "C": 9.76310973666134,
    "h": -0.40381542128112,
    "CMY_C": 0.5042919,
    "CMY_M": 0.4313536,
    "CMY_Y": 0.480768,
    "CMYK_C": 0.1282665,
    "CMYK_M": 0,
    "CMYK_Y": 0.08689819,
    "CMYK_K": 0.4313536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03340",
    "Farbtonhilfsbezeichnung": "K8.11.40",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "119",
    "Bcolor": "106",
    "Y": 17,
    "L": 48.5531197473775,
    "a": -8.1777259792768,
    "b": 4.78291720179753,
    "C": 9.47372678260194,
    "h": -0.52922117670489,
    "CMY_C": 0.5921634,
    "CMY_M": 0.5324492,
    "CMY_Y": 0.5838115,
    "CMYK_C": 0.127717,
    "CMYK_M": 0,
    "CMYK_Y": 0.109854,
    "CMYK_K": 0.5324492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03341",
    "Farbtonhilfsbezeichnung": "KN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 85,
    "L": 93.9952433802274,
    "a": -2.22977005672859,
    "b": 1.90225796379109,
    "C": 2.93094862914552,
    "h": -0.70630169865432,
    "CMY_C": 0.07901698,
    "CMY_M": 0.06240578,
    "CMY_Y": 0.08933572,
    "CMYK_C": 0.01771684,
    "CMYK_M": 0,
    "CMYK_Y": 0.02872239,
    "CMYK_K": 0.06240578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03342",
    "Farbtonhilfsbezeichnung": "L0.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "219",
    "Bcolor": "199",
    "Y": 67,
    "L": 85.3010769682083,
    "a": -10.8851095322669,
    "b": 6.27603415709534,
    "C": 12.5648006060771,
    "h": -0.52301382787651,
    "CMY_C": 0.2301862,
    "CMY_M": 0.1410404,
    "CMY_Y": 0.2181171,
    "CMYK_C": 0.1037835,
    "CMYK_M": 0,
    "CMYK_Y": 0.08973267,
    "CMYK_K": 0.1410404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03343",
    "Farbtonhilfsbezeichnung": "K9.16.75",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "214",
    "Bcolor": "181",
    "Y": 60,
    "L": 82.0260860213382,
    "a": -19.154017824816,
    "b": 11.4115092045075,
    "C": 22.2957157579192,
    "h": -0.53730802502703,
    "CMY_C": 0.3172811,
    "CMY_M": 0.1613585,
    "CMY_Y": 0.2919204,
    "CMYK_C": 0.1859228,
    "CMYK_M": 0,
    "CMYK_Y": 0.1556826,
    "CMYK_K": 0.1613585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03344",
    "Farbtonhilfsbezeichnung": "K9.15.65",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "185",
    "Bcolor": "158",
    "Y": 44,
    "L": 72.1990432749408,
    "a": -16.525057764294,
    "b": 9.66126335513178,
    "C": 19.1420360393158,
    "h": -0.52905123284894,
    "CMY_C": 0.4046772,
    "CMY_M": 0.2731433,
    "CMY_Y": 0.3819014,
    "CMYK_C": 0.1809626,
    "CMYK_M": 0,
    "CMYK_Y": 0.1496279,
    "CMYK_K": 0.2731433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03345",
    "Farbtonhilfsbezeichnung": "L1.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "149",
    "Bcolor": "121",
    "Y": 26,
    "L": 58.4432093974726,
    "a": -18.8249316916042,
    "b": 10.3991035693745,
    "C": 21.5062643952905,
    "h": -0.50469255398612,
    "CMY_C": 0.5616941,
    "CMY_M": 0.4140584,
    "CMY_Y": 0.5264423,
    "CMYK_C": 0.2519632,
    "CMYK_M": 0,
    "CMYK_Y": 0.1918005,
    "CMYK_K": 0.4140584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03346",
    "Farbtonhilfsbezeichnung": "K9.18.41",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "126",
    "Bcolor": "105",
    "Y": 17,
    "L": 50.4342918395996,
    "a": -13.0473251342773,
    "b": 8.08137798309326,
    "C": 15.3473567962647,
    "h": 148.226364135742,
    "CMY_C": 0.6007467508316,
    "CMY_M": 0.50543165206909,
    "CMY_Y": 0.58808583021164,
    "CMYK_C": 0.19272381067276,
    "CMYK_M": 0,
    "CMYK_Y": 0.16712386906147,
    "CMYK_K": 0.50543165206909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03347",
    "Farbtonhilfsbezeichnung": "LN.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "239",
    "Bcolor": "232",
    "Y": 84,
    "L": 93.6184522024273,
    "a": -3.59387447174914,
    "b": 1.49230633541135,
    "C": 3.89138945845812,
    "h": -0.39357153655121,
    "CMY_C": 0.09570681,
    "CMY_M": 0.06333484,
    "CMY_Y": 0.09065327,
    "CMYK_C": 0.03456087,
    "CMYK_M": 0,
    "CMYK_Y": 0.02916563,
    "CMYK_K": 0.06333484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03348",
    "Farbtonhilfsbezeichnung": "N2.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 79,
    "L": 91.2907389774845,
    "a": -5.62065188992905,
    "b": -0.31892976122316,
    "C": 5.62969305205505,
    "h": 0.05668170527198,
    "CMY_C": 0.1448055,
    "CMY_M": 0.08426316,
    "CMY_Y": 0.1032728,
    "CMYK_C": 0.06611329,
    "CMYK_M": 0,
    "CMYK_Y": 0.02075882,
    "CMYK_K": 0.08426316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03349",
    "Farbtonhilfsbezeichnung": "M6.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 80,
    "L": 91.422492980957,
    "a": -8.21328067779541,
    "b": 0.66760987043381,
    "C": 8.24036884307861,
    "h": 175.352981567383,
    "CMY_C": 0.1613792181015,
    "CMY_M": 0.07720327377319,
    "CMY_Y": 0.10948222875595,
    "CMYK_C": 0.09121829271317,
    "CMYK_M": 0,
    "CMYK_Y": 0.03497948497534,
    "CMYK_K": 0.07720327377319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03350",
    "Farbtonhilfsbezeichnung": "M9.11.76",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "214",
    "Bcolor": "204",
    "Y": 61,
    "L": 82.502469153029,
    "a": -15.3825268767668,
    "b": -0.45668767226092,
    "C": 15.3893046218615,
    "h": 0.02968001088867,
    "CMY_C": 0.3254337,
    "CMY_M": 0.1607568,
    "CMY_Y": 0.1998205,
    "CMYK_C": 0.1962208,
    "CMYK_M": 0,
    "CMYK_Y": 0.04654633,
    "CMYK_K": 0.1607568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03351",
    "Farbtonhilfsbezeichnung": "M8.10.70",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "199",
    "Bcolor": "191",
    "Y": 53,
    "L": 77.768261645156,
    "a": -12.5579175604092,
    "b": -0.16621583793685,
    "C": 12.5590175236288,
    "h": 0.01323516671464,
    "CMY_C": 0.3494186,
    "CMY_M": 0.2184775,
    "CMY_Y": 0.2525544,
    "CMYK_C": 0.1675461,
    "CMYK_M": 0,
    "CMYK_Y": 0.04360315,
    "CMYK_K": 0.2184775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03352",
    "Farbtonhilfsbezeichnung": "M9.09.62",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "175",
    "Bcolor": "168",
    "Y": 40,
    "L": 69.2018325090482,
    "a": -11.1459361846643,
    "b": -0.17491786517875,
    "C": 11.1473086299863,
    "h": 0.01569213250557,
    "CMY_C": 0.4268934,
    "CMY_M": 0.3134151,
    "CMY_Y": 0.3429198,
    "CMYK_C": 0.1652793,
    "CMYK_M": 0,
    "CMYK_Y": 0.04297316,
    "CMYK_K": 0.3134151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03353",
    "Farbtonhilfsbezeichnung": "M9.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "142",
    "Bcolor": "136",
    "Y": 25,
    "L": 57.2361329568834,
    "a": -9.43686344367067,
    "b": -0.15875612551863,
    "C": 9.43819872443241,
    "h": 0.01682138905071,
    "CMY_C": 0.5340062,
    "CMY_M": 0.4415057,
    "CMY_Y": 0.4655747,
    "CMYK_C": 0.1656248,
    "CMYK_M": 0,
    "CMYK_Y": 0.0430962,
    "CMYK_K": 0.4415057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03354",
    "Farbtonhilfsbezeichnung": "N0.10.39",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "115",
    "Bcolor": "110",
    "Y": 16,
    "L": 46.6963414848158,
    "a": -8.35749629615129,
    "b": -0.38651229362622,
    "C": 8.36642911242943,
    "h": 0.04621444903458,
    "CMY_C": 0.6290957,
    "CMY_M": 0.5492276,
    "CMY_Y": 0.568032,
    "CMYK_C": 0.1771805,
    "CMYK_M": 0,
    "CMYK_Y": 0.04171588,
    "CMYK_K": 0.5492276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03355",
    "Farbtonhilfsbezeichnung": "N3.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.0196926695567,
    "a": -4.61234777123026,
    "b": 0.3432056596365,
    "C": 4.62509914354053,
    "h": -0.07427330800323,
    "CMY_C": 0.114851,
    "CMY_M": 0.06737875,
    "CMY_Y": 0.08888222,
    "CMYK_C": 0.05090191,
    "CMYK_M": 0,
    "CMYK_Y": 0.02305703,
    "CMYK_K": 0.06737875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03356",
    "Farbtonhilfsbezeichnung": "N9.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "218",
    "Bcolor": "215",
    "Y": 68,
    "L": 85.7613585574777,
    "a": -6.29083281430637,
    "b": -1.32773765416749,
    "C": 6.42942180727381,
    "h": 0.2080063659105,
    "CMY_C": 0.2148228,
    "CMY_M": 0.1439576,
    "CMY_Y": 0.1568061,
    "CMYK_C": 0.0827824,
    "CMYK_M": 0,
    "CMYK_Y": 0.01500915,
    "CMYK_K": 0.1439576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03357",
    "Farbtonhilfsbezeichnung": "N9.07.78",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "218",
    "Bcolor": "214",
    "Y": 66,
    "L": 84.9437713623047,
    "a": -9.73311519622803,
    "b": -2.0347261428833,
    "C": 9.94352245330811,
    "h": 191.807739257812,
    "CMY_C": 0.25565642118454,
    "CMY_M": 0.14523029327393,
    "CMY_Y": 0.1610227227211,
    "CMYK_C": 0.12918816506863,
    "CMYK_M": 0,
    "CMYK_Y": 0.01847565360367,
    "CMYK_K": 0.14523029327393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03358",
    "Farbtonhilfsbezeichnung": "N9.10.70",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "199",
    "Bcolor": "196",
    "Y": 52,
    "L": 77.6104507446289,
    "a": -12.4552631378174,
    "b": -3.1928448677063,
    "C": 12.8579874038696,
    "h": 194.377883911133,
    "CMY_C": 0.36282503604889,
    "CMY_M": 0.21956980228424,
    "CMY_Y": 0.23250430822372,
    "CMYK_C": 0.18355931341648,
    "CMYK_M": 0,
    "CMYK_Y": 0.01657355949283,
    "CMYK_K": 0.21956980228424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03359",
    "Farbtonhilfsbezeichnung": "N8.10.60",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "171",
    "Bcolor": "168",
    "Y": 38,
    "L": 67.7969716140385,
    "a": -9.86859023134307,
    "b": -2.65313246229697,
    "C": 10.2190109607855,
    "h": 0.26263607020849,
    "CMY_C": 0.4404424,
    "CMY_M": 0.3302158,
    "CMY_Y": 0.3401143,
    "CMYK_C": 0.1645703,
    "CMYK_M": 0,
    "CMYK_Y": 0.01477864,
    "CMYK_K": 0.3302158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03360",
    "Farbtonhilfsbezeichnung": "N8.10.51",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "146",
    "Bcolor": "144",
    "Y": 27,
    "L": 58.620093969905,
    "a": -9.49119038411589,
    "b": -2.36850061922169,
    "C": 9.782253834919,
    "h": 0.24455251594039,
    "CMY_C": 0.5292661,
    "CMY_M": 0.4266561,
    "CMY_Y": 0.4366386,
    "CMYK_C": 0.1789675,
    "CMYK_M": 0,
    "CMYK_Y": 0.017411,
    "CMYK_K": 0.4266561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03361",
    "Farbtonhilfsbezeichnung": "N8.10.41",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "122",
    "Bcolor": "121",
    "Y": 18,
    "L": 49.7138103372237,
    "a": -7.90849876280503,
    "b": -2.16203518697062,
    "C": 8.19870409461079,
    "h": 0.26686063932606,
    "CMY_C": 0.6031539,
    "CMY_M": 0.5197918,
    "CMY_Y": 0.5269238,
    "CMYK_C": 0.1735956,
    "CMYK_M": 0,
    "CMYK_Y": 0.01485177,
    "CMYK_K": 0.5197918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03363",
    "Farbtonhilfsbezeichnung": "PN.00.83",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "227",
    "Bcolor": "225",
    "Y": 76,
    "L": 90.0231935852702,
    "a": -1.43193291480809,
    "b": 0.02976439960455,
    "C": 1.43224222532175,
    "h": -0.02078317614677,
    "CMY_C": 0.1233993,
    "CMY_M": 0.1081717,
    "CMY_Y": 0.1192981,
    "CMYK_C": 0.0170746,
    "CMYK_M": 0,
    "CMYK_Y": 0.01247601,
    "CMYK_K": 0.1081717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03364",
    "Farbtonhilfsbezeichnung": "P4.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 70,
    "L": 87.2172927558587,
    "a": -4.55382005394056,
    "b": -1.40468342896414,
    "C": 4.76554431511004,
    "h": 0.29920250275076,
    "CMY_C": 0.1848311,
    "CMY_M": 0.1317287,
    "CMY_Y": 0.1400484,
    "CMYK_C": 0.06115879,
    "CMYK_M": 0,
    "CMYK_Y": 0.009581884,
    "CMYK_K": 0.1317287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03365",
    "Farbtonhilfsbezeichnung": "N8.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "210",
    "Bcolor": "207",
    "Y": 62,
    "L": 82.7124093658572,
    "a": -6.97720620416475,
    "b": -1.73297077725414,
    "C": 7.18919982545011,
    "h": 0.24344963767751,
    "CMY_C": 0.2551386,
    "CMY_M": 0.1758998,
    "CMY_Y": 0.1871985,
    "CMYK_C": 0.09615192,
    "CMYK_M": 0,
    "CMYK_Y": 0.01371041,
    "CMYK_K": 0.1758998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03366",
    "Farbtonhilfsbezeichnung": "N8.05.56",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "157",
    "Bcolor": "156",
    "Y": 32,
    "L": 63.6966383278854,
    "a": -5.0735069428543,
    "b": -1.8849065124166,
    "C": 5.41233270039281,
    "h": 0.35571574353838,
    "CMY_C": 0.4401992,
    "CMY_M": 0.3832553,
    "CMY_Y": 0.3874533,
    "CMYK_C": 0.09232982,
    "CMYK_M": 0,
    "CMYK_Y": 0.00680672,
    "CMYK_K": 0.3832553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03367",
    "Farbtonhilfsbezeichnung": "N8.05.45",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "131",
    "Bcolor": "130",
    "Y": 22,
    "L": 53.7527171572952,
    "a": -4.4580900374564,
    "b": -1.47981572972564,
    "C": 4.69727808161401,
    "h": 0.32049548971686,
    "CMY_C": 0.5340788,
    "CMY_M": 0.4863445,
    "CMY_Y": 0.4910235,
    "CMYK_C": 0.09293046,
    "CMYK_M": 0,
    "CMYK_Y": 0.009109066,
    "CMYK_K": 0.4863445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03368",
    "Farbtonhilfsbezeichnung": "N6.04.26",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "86",
    "Bcolor": "85",
    "Y": 9,
    "L": 35.8413327430912,
    "a": -2.92614918234935,
    "b": -0.85446884731631,
    "C": 3.04835464609973,
    "h": 0.28411176331834,
    "CMY_C": 0.6920034,
    "CMY_M": 0.6633749,
    "CMY_Y": 0.6672907,
    "CMYK_C": 0.08504554,
    "CMYK_M": 0,
    "CMYK_Y": 0.01163255,
    "CMYK_K": 0.6633749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03369",
    "Farbtonhilfsbezeichnung": "QN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "236",
    "Y": 84,
    "L": 93.3047702546616,
    "a": -2.58794408757823,
    "b": -0.93684708854824,
    "C": 2.75229668963076,
    "h": 0.3473288595211,
    "CMY_C": 0.09971489,
    "CMY_M": 0.06850854,
    "CMY_Y": 0.07590622,
    "CMYK_C": 0.03350149,
    "CMYK_M": 0,
    "CMYK_Y": 0.00794177,
    "CMYK_K": 0.06850854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03370",
    "Farbtonhilfsbezeichnung": "Q8.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "216",
    "Bcolor": "216",
    "Y": 67,
    "L": 85.2690227966443,
    "a": -4.80061126310988,
    "b": -2.49959286515213,
    "C": 5.41237775760496,
    "h": 0.48005614338928,
    "CMY_C": 0.2122501,
    "CMY_M": 0.1523919,
    "CMY_Y": 0.1534334,
    "CMYK_C": 0.07062008,
    "CMYK_M": 0,
    "CMYK_Y": 0.001228793,
    "CMYK_K": 0.1523919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03371",
    "Farbtonhilfsbezeichnung": "P8.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "206",
    "Bcolor": "207",
    "Y": 59,
    "L": 81.3703239839467,
    "a": -6.40059724110481,
    "b": -3.66607358878335,
    "C": 7.37616028847078,
    "h": 0.52015717324094,
    "CMY_C": 0.2722764,
    "CMY_M": 0.1913151,
    "CMY_Y": 0.1876963,
    "CMYK_C": 0.1041237,
    "CMYK_M": 0.00445493,
    "CMYK_Y": 0,
    "CMYK_K": 0.1876963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03372",
    "Farbtonhilfsbezeichnung": "P9.09.70",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "199",
    "Bcolor": "201",
    "Y": 54,
    "L": 78.2933817871946,
    "a": -9.50389473162294,
    "b": -5.00871951245021,
    "C": 10.7429644988788,
    "h": 0.48502732100371,
    "CMY_C": 0.3372541,
    "CMY_M": 0.2177981,
    "CMY_Y": 0.2117465,
    "CMYK_C": 0.1592224,
    "CMYK_M": 0.007677173,
    "CMYK_Y": 0,
    "CMYK_K": 0.2117465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03373",
    "Farbtonhilfsbezeichnung": "Q0.10.61",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "172",
    "Bcolor": "175",
    "Y": 39,
    "L": 68.5383968389628,
    "a": -8.597987671699,
    "b": -5.35577280823114,
    "C": 10.1296443361095,
    "h": 0.55709500784905,
    "CMY_C": 0.4331134,
    "CMY_M": 0.3242242,
    "CMY_Y": 0.3133046,
    "CMYK_C": 0.1744715,
    "CMYK_M": 0.01590165,
    "CMYK_Y": 0,
    "CMYK_K": 0.3133046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03374",
    "Farbtonhilfsbezeichnung": "Q2.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "144",
    "Bcolor": "146",
    "Y": 26,
    "L": 58.0320295808208,
    "a": -7.40042052812878,
    "b": -4.66157125411277,
    "C": 8.74622607473191,
    "h": 0.56211963889014,
    "CMY_C": 0.5269842,
    "CMY_M": 0.436192,
    "CMY_Y": 0.4268564,
    "CMYK_C": 0.1746992,
    "CMYK_M": 0.01628836,
    "CMYK_Y": 0,
    "CMYK_K": 0.4268564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03375",
    "Farbtonhilfsbezeichnung": "Q0.10.41",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "119",
    "Bcolor": "122",
    "Y": 17,
    "L": 48.2933541343725,
    "a": -6.83025800661036,
    "b": -4.85690193519712,
    "C": 8.38104533128096,
    "h": 0.61812765415876,
    "CMY_C": 0.6188214,
    "CMY_M": 0.5352281,
    "CMY_Y": 0.5231501,
    "CMYK_C": 0.2006318,
    "CMYK_M": 0.02532874,
    "CMYK_Y": 0,
    "CMYK_K": 0.5231501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03376",
    "Farbtonhilfsbezeichnung": "PN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "237",
    "Bcolor": "235",
    "Y": 83,
    "L": 92.8801878700395,
    "a": -3.19429196583915,
    "b": -1.38042973721422,
    "C": 3.47981140615549,
    "h": 0.40791548395551,
    "CMY_C": 0.111041,
    "CMY_M": 0.07173015,
    "CMY_Y": 0.07741453,
    "CMYK_C": 0.04234852,
    "CMYK_M": 0,
    "CMYK_Y": 0.006123629,
    "CMYK_K": 0.07173015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03377",
    "Farbtonhilfsbezeichnung": "Q8.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "232",
    "Bcolor": "234",
    "Y": 77,
    "L": 91.132438659668,
    "a": -4.23414039611816,
    "b": -3.52153778076172,
    "C": 5.50719308853149,
    "h": 219.75032043457,
    "CMY_C": 0.1471061706543,
    "CMY_M": 0.08824962377548,
    "CMY_Y": 0.08110642433167,
    "CMYK_C": 0.07182523608208,
    "CMYK_M": 0.00777369597927,
    "CMYK_Y": 0,
    "CMYK_K": 0.08110642433167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03378",
    "Farbtonhilfsbezeichnung": "R0.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 72,
    "L": 88.0393773950958,
    "a": -6.91002020406423,
    "b": -6.26318342768299,
    "C": 9.32608416589614,
    "h": 0.73633510381085,
    "CMY_C": 0.2149157,
    "CMY_M": 0.1158993,
    "CMY_Y": 0.09556147,
    "CMYK_C": 0.131965,
    "CMYK_M": 0.02248672,
    "CMYK_Y": 0,
    "CMYK_K": 0.09556147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03379",
    "Farbtonhilfsbezeichnung": "R0.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "210",
    "Bcolor": "220",
    "Y": 60,
    "L": 82.0932164460993,
    "a": -9.41847316611621,
    "b": -9.64500940800814,
    "C": 13.4808695291297,
    "h": 0.79728085999917,
    "CMY_C": 0.3165053,
    "CMY_M": 0.1751051,
    "CMY_Y": 0.136822,
    "CMYK_C": 0.2081649,
    "CMYK_M": 0.04435138,
    "CMYK_Y": 0,
    "CMYK_K": 0.136822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03380",
    "Farbtonhilfsbezeichnung": "R2.14.70",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "198",
    "Bcolor": "206",
    "Y": 52,
    "L": 77.3617488333174,
    "a": -10.2003418411808,
    "b": -9.41049570938093,
    "C": 13.8781988447068,
    "h": 0.74514391824718,
    "CMY_C": 0.3730811,
    "CMY_M": 0.2251697,
    "CMY_Y": 0.1903303,
    "CMYK_C": 0.2257103,
    "CMYK_M": 0.04302919,
    "CMYK_Y": 0,
    "CMYK_K": 0.1903303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03381",
    "Farbtonhilfsbezeichnung": "R3.15.59",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "168",
    "Bcolor": "180",
    "Y": 36,
    "L": 66.7089250398874,
    "a": -8.93076456385722,
    "b": -10.8892813409425,
    "C": 14.0831460908863,
    "h": 0.88389335851469,
    "CMY_C": 0.4799953,
    "CMY_M": 0.3412505,
    "CMY_Y": 0.2940724,
    "CMYK_C": 0.263374,
    "CMYK_M": 0.06683141,
    "CMYK_Y": 0,
    "CMYK_K": 0.2940724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03382",
    "Farbtonhilfsbezeichnung": "R5.15.49",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "142",
    "Bcolor": "153",
    "Y": 25,
    "L": 57.1338877624415,
    "a": -7.01695397147306,
    "b": -9.959143032585,
    "C": 12.182863907196,
    "h": 0.957007106871,
    "CMY_C": 0.5557424,
    "CMY_M": 0.4446357,
    "CMY_Y": 0.4002229,
    "CMYK_C": 0.2592955,
    "CMYK_M": 0.07404901,
    "CMYK_Y": 0,
    "CMYK_K": 0.4002229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03383",
    "Farbtonhilfsbezeichnung": "R4.15.39",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "115",
    "Bcolor": "124",
    "Y": 16,
    "L": 46.8508405894424,
    "a": -6.72733803795156,
    "b": -8.60375332909495,
    "C": 10.9216138196139,
    "h": 0.90718525624145,
    "CMY_C": 0.6480302,
    "CMY_M": 0.5486191,
    "CMY_Y": 0.5129833,
    "CMYK_C": 0.2772941,
    "CMYK_M": 0.07317156,
    "CMYK_Y": 0,
    "CMYK_K": 0.5129833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03384",
    "Farbtonhilfsbezeichnung": "RN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "225",
    "Bcolor": "224",
    "Y": 74,
    "L": 89.0386893395418,
    "a": -1.62730339438477,
    "b": -1.20850411654136,
    "C": 2.02696781846028,
    "h": 0.63877543976064,
    "CMY_C": 0.1402545,
    "CMY_M": 0.118307,
    "CMY_Y": 0.12105,
    "CMYK_C": 0.02489249,
    "CMYK_M": 0,
    "CMYK_Y": 0.003111043,
    "CMYK_K": 0.118307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03385",
    "Farbtonhilfsbezeichnung": "R2.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "229",
    "Bcolor": "231",
    "Y": 76,
    "L": 89.9408227712622,
    "a": -3.58833598072533,
    "b": -3.36958210910194,
    "C": 4.92242203600503,
    "h": 0.75396895769754,
    "CMY_C": 0.1543087,
    "CMY_M": 0.1031024,
    "CMY_Y": 0.09538373,
    "CMYK_C": 0.06513808,
    "CMYK_M": 0.00853255,
    "CMYK_Y": 0,
    "CMYK_K": 0.09538373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03386",
    "Farbtonhilfsbezeichnung": "R1.06.76",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "211",
    "Bcolor": "214",
    "Y": 63,
    "L": 83.4092749759245,
    "a": -4.67114526143458,
    "b": -4.40341168543985,
    "C": 6.41947291643878,
    "h": 0.75590295682729,
    "CMY_C": 0.2386893,
    "CMY_M": 0.1725937,
    "CMY_Y": 0.1598954,
    "CMYK_C": 0.0937906,
    "CMYK_M": 0.01511511,
    "CMYK_Y": 0,
    "CMYK_K": 0.1598954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03387",
    "Farbtonhilfsbezeichnung": "R1.09.60",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "171",
    "Bcolor": "177",
    "Y": 38,
    "L": 68.3796813961803,
    "a": -6.40064417976244,
    "b": -6.71518826979451,
    "C": 9.2769606776526,
    "h": 0.80937558229604,
    "CMY_C": 0.4217252,
    "CMY_M": 0.3300689,
    "CMY_Y": 0.305225,
    "CMYK_C": 0.1676806,
    "CMYK_M": 0.03575828,
    "CMYK_Y": 0,
    "CMYK_K": 0.305225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03388",
    "Farbtonhilfsbezeichnung": "R1.09.44",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "128",
    "Bcolor": "133",
    "Y": 20,
    "L": 52.3562575580323,
    "a": -4.18680172142799,
    "b": -5.48022328957418,
    "C": 6.89653216900666,
    "h": 0.91840550221498,
    "CMY_C": 0.5605033,
    "CMY_M": 0.4998331,
    "CMY_Y": 0.4783804,
    "CMYK_C": 0.1574384,
    "CMYK_M": 0.04112719,
    "CMYK_Y": 0,
    "CMYK_K": 0.4783804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03389",
    "Farbtonhilfsbezeichnung": "R1.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "95",
    "Bcolor": "99",
    "Y": 11,
    "L": 39.2407322108619,
    "a": -4.09518878034565,
    "b": -4.70622044246024,
    "C": 6.23851600941278,
    "h": 0.85471124791564,
    "CMY_C": 0.6825213,
    "CMY_M": 0.6282011,
    "CMY_Y": 0.6115145,
    "CMYK_C": 0.1827785,
    "CMYK_M": 0.04295282,
    "CMYK_Y": 0,
    "CMYK_K": 0.6115145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03390",
    "Farbtonhilfsbezeichnung": "ON.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "236",
    "Bcolor": "234",
    "Y": 84,
    "L": 93.5583613939689,
    "a": 0.32190705396517,
    "b": 0.54150921885547,
    "C": 0.62996538436489,
    "h": 1.03445828927817,
    "CMY_C": 0.06819994,
    "CMY_M": 0.07297485,
    "CMY_Y": 0.08369154,
    "CMYK_C": 0,
    "CMYK_M": 0.005124392,
    "CMYK_Y": 0.01662545,
    "CMYK_K": 0.06819994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03391",
    "Farbtonhilfsbezeichnung": "ON.00.49",
    "Farbtonklasse": "01",
    "Rcolor": "136",
    "Gcolor": "137",
    "Bcolor": "137",
    "Y": 23,
    "L": 57.0346412658691,
    "a": -0.05644103512168,
    "b": -0.64117258787155,
    "C": 0.64365196228027,
    "h": 264.969329833984,
    "CMY_C": 0.46569693088531,
    "CMY_M": 0.46260303258896,
    "CMY_Y": 0.46321558952332,
    "CMYK_C": 0.00575719354674,
    "CMYK_M": 0,
    "CMYK_Y": 0.00113985931966,
    "CMYK_K": 0.46260303258896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03392",
    "Farbtonhilfsbezeichnung": "ON.00.39",
    "Farbtonklasse": "01",
    "Rcolor": "111",
    "Gcolor": "111",
    "Bcolor": "111",
    "Y": 16.2,
    "L": 46.7855875976965,
    "a": 0.08016763968426,
    "b": -0.55380672696645,
    "C": 0.55957907509649,
    "h": -1.42703748617917,
    "CMY_C": 0.5663044,
    "CMY_M": 0.5649091,
    "CMY_Y": 0.5651022,
    "CMYK_C": 0.003207033,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004436553,
    "CMYK_K": 0.5649091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03393",
    "Farbtonhilfsbezeichnung": "DN.00.25",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "81",
    "Bcolor": "81",
    "Y": 8,
    "L": 34.6373546852179,
    "a": 0.13967287646365,
    "b": -0.1753161875205,
    "C": 0.22415235449657,
    "h": -0.89807616036831,
    "CMY_C": 0.6802109,
    "CMY_M": 0.6806367,
    "CMY_Y": 0.6822284,
    "CMYK_C": 0,
    "CMYK_M": 0.001331455,
    "CMYK_Y": 0.006308777,
    "CMYK_K": 0.6802109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03394",
    "Farbtonhilfsbezeichnung": "TN.00.55",
    "Farbtonklasse": "01",
    "Rcolor": "157",
    "Gcolor": "157",
    "Bcolor": "158",
    "Y": 34,
    "L": 64.7804743407811,
    "a": 0.16697341254684,
    "b": -1.03590121024966,
    "C": 1.04927186081313,
    "h": -1.41098428054687,
    "CMY_C": 0.3859368,
    "CMY_M": 0.3834937,
    "CMY_Y": 0.3814656,
    "CMYK_C": 0.007228745,
    "CMYK_M": 0.003278911,
    "CMYK_Y": 0,
    "CMYK_K": 0.3814656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03395",
    "Farbtonhilfsbezeichnung": "JN.00.55",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "153",
    "Bcolor": "151",
    "Y": 32,
    "L": 63.1573890450248,
    "a": -0.34104251995575,
    "b": 0.1492580180906,
    "C": 0.37227403398855,
    "h": -0.41253820464999,
    "CMY_C": 0.4026561,
    "CMY_M": 0.3995197,
    "CMY_Y": 0.4063968,
    "CMYK_C": 0.00522311,
    "CMYK_M": 0,
    "CMYK_Y": 0.01145263,
    "CMYK_K": 0.3995197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03396",
    "Farbtonhilfsbezeichnung": "TN.00.46",
    "Farbtonklasse": "01",
    "Rcolor": "124",
    "Gcolor": "126",
    "Bcolor": "127",
    "Y": 21,
    "L": 52.85004717632,
    "a": -0.34265156678448,
    "b": -1.36779438607644,
    "C": 1.41006084223415,
    "h": 1.32533400981641,
    "CMY_C": 0.5121144,
    "CMY_M": 0.5039267,
    "CMY_Y": 0.500266,
    "CMYK_C": 0.02370954,
    "CMYK_M": 0.007325399,
    "CMYK_Y": 0,
    "CMYK_K": 0.500266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03397",
    "Farbtonhilfsbezeichnung": "ON.00.24",
    "Farbtonklasse": "02",
    "Rcolor": "78",
    "Gcolor": "78",
    "Bcolor": "78",
    "Y": 8,
    "L": 33.0525838922019,
    "a": 0.03223905326391,
    "b": -0.3017674882171,
    "C": 0.30348471707849,
    "h": -1.46436593264331,
    "CMY_C": 0.6958669,
    "CMY_M": 0.6949914,
    "CMY_Y": 0.695962,
    "CMYK_C": 0.002870658,
    "CMYK_M": 0,
    "CMYK_Y": 0.003182273,
    "CMYK_K": 0.6949914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03398",
    "Farbtonhilfsbezeichnung": "RN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "224",
    "Bcolor": "224",
    "Y": 73,
    "L": 88.7347946166992,
    "a": -1.36664795875549,
    "b": -1.46916794776917,
    "C": 2.00653457641602,
    "h": 227.070449829102,
    "CMY_C": 0.1424343585968,
    "CMY_M": 0.12218600511551,
    "CMY_Y": 0.12244606018066,
    "CMYK_C": 0.02306679263711,
    "CMYK_M": 0,
    "CMYK_Y": 0.0002962530416,
    "CMYK_K": 0.12218600511551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03399",
    "Farbtonhilfsbezeichnung": "SN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 54,
    "L": 78.5642846651718,
    "a": -1.15043121615227,
    "b": -2.51732035371437,
    "C": 2.76774163287006,
    "h": 1.14213127223871,
    "CMY_C": 0.2553809,
    "CMY_M": 0.2338814,
    "CMY_Y": 0.2256758,
    "CMYK_C": 0.03836262,
    "CMYK_M": 0.01059707,
    "CMYK_Y": 0,
    "CMYK_K": 0.2256758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03400",
    "Farbtonhilfsbezeichnung": "SN.02.58",
    "Farbtonklasse": "01",
    "Rcolor": "157",
    "Gcolor": "160",
    "Bcolor": "163",
    "Y": 35,
    "L": 65.8363571166992,
    "a": -0.43492713570595,
    "b": -2.71640586853027,
    "C": 2.7510039806366,
    "h": 260.903503417969,
    "CMY_C": 0.38514453172684,
    "CMY_M": 0.37068629264832,
    "CMY_Y": 0.35897940397263,
    "CMYK_C": 0.04081792011857,
    "CMYK_M": 0.01826288923621,
    "CMYK_Y": 0,
    "CMYK_K": 0.35897940397263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03401",
    "Farbtonhilfsbezeichnung": "RN.01.38",
    "Farbtonklasse": "01",
    "Rcolor": "110",
    "Gcolor": "113",
    "Bcolor": "114",
    "Y": 15,
    "L": 47.4311141967773,
    "a": -0.45155185461044,
    "b": -1.61214065551758,
    "C": 1.67418539524078,
    "h": 254.352737426758,
    "CMY_C": 0.56706345081329,
    "CMY_M": 0.55721116065979,
    "CMY_Y": 0.55202329158783,
    "CMYK_C": 0.03357353061438,
    "CMYK_M": 0.01158066652715,
    "CMYK_Y": 0,
    "CMYK_K": 0.55202329158783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03402",
    "Farbtonhilfsbezeichnung": "SN.02.28",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "92",
    "Bcolor": "94",
    "Y": 9,
    "L": 39.050609588623,
    "a": -0.64315629005432,
    "b": -1.62475645542145,
    "C": 1.74742197990417,
    "h": 248.40397644043,
    "CMY_C": 0.64869832992554,
    "CMY_M": 0.63745880126953,
    "CMY_Y": 0.63228344917297,
    "CMYK_C": 0.04464003816247,
    "CMYK_M": 0.01407429762185,
    "CMYK_Y": 0,
    "CMYK_K": 0.63228344917297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03403",
    "Farbtonhilfsbezeichnung": "SN.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "230",
    "Bcolor": "231",
    "Y": 79,
    "L": 91.0509677589111,
    "a": -1.16245714919549,
    "b": -1.61659950871669,
    "C": 1.99115559294063,
    "h": 0.9473823853227,
    "CMY_C": 0.1156707,
    "CMY_M": 0.09687438,
    "CMY_Y": 0.09571409,
    "CMYK_C": 0.02206889,
    "CMYK_M": 0.001283097,
    "CMYK_Y": 0,
    "CMYK_K": 0.09571409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03404",
    "Farbtonhilfsbezeichnung": "R7.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "217",
    "Bcolor": "219",
    "Y": 67,
    "L": 85.8120651245117,
    "a": -3.1388463973999,
    "b": -3.45132946968079,
    "C": 4.66519355773926,
    "h": 227.714721679688,
    "CMY_C": 0.1962171792984,
    "CMY_M": 0.14986550807953,
    "CMY_Y": 0.14030289649963,
    "CMYK_C": 0.0650395154953,
    "CMYK_M": 0.01112323347479,
    "CMYK_Y": 0,
    "CMYK_K": 0.14030289649963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03405",
    "Farbtonhilfsbezeichnung": "R6.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "206",
    "Bcolor": "210",
    "Y": 60,
    "L": 81.9866101901767,
    "a": -3.35175309399172,
    "b": -4.34844050046277,
    "C": 5.49028082971608,
    "h": 0.91411915829002,
    "CMY_C": 0.2429534,
    "CMY_M": 0.191154,
    "CMY_Y": 0.1756632,
    "CMYK_C": 0.08162952,
    "CMYK_M": 0.01879181,
    "CMYK_Y": 0,
    "CMYK_K": 0.1756632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03406",
    "Farbtonhilfsbezeichnung": "S0.04.54",
    "Farbtonklasse": "01",
    "Rcolor": "142",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 30,
    "L": 61.3652698815809,
    "a": -1.85272650595397,
    "b": -3.54800896856267,
    "C": 4.00261953561234,
    "h": 1.08955655144523,
    "CMY_C": 0.4449218,
    "CMY_M": 0.4137348,
    "CMY_Y": 0.3996678,
    "CMYK_C": 0.07538164,
    "CMYK_M": 0.0234321,
    "CMYK_Y": 0,
    "CMYK_K": 0.3996678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03407",
    "Farbtonhilfsbezeichnung": "S3.05.45",
    "Farbtonklasse": "01",
    "Rcolor": "119",
    "Gcolor": "129",
    "Bcolor": "134",
    "Y": 21,
    "L": 53.2300960454032,
    "a": -2.06275339196549,
    "b": -4.57045109178049,
    "C": 5.01437680459124,
    "h": 1.14684206620185,
    "CMY_C": 0.5320172,
    "CMY_M": 0.4956652,
    "CMY_Y": 0.4754195,
    "CMYK_C": 0.1078914,
    "CMYK_M": 0.038594,
    "CMYK_Y": 0,
    "CMYK_K": 0.4754195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03408",
    "Farbtonhilfsbezeichnung": "S1.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "103",
    "Bcolor": "107",
    "Y": 13,
    "L": 43.2537999146451,
    "a": -1.95923939560544,
    "b": -3.45140301951192,
    "C": 3.96872798417684,
    "h": 1.05449225064139,
    "CMY_C": 0.6242799,
    "CMY_M": 0.5942687,
    "CMY_Y": 0.5808289,
    "CMYK_C": 0.1036594,
    "CMYK_M": 0.03206297,
    "CMYK_Y": 0,
    "CMYK_K": 0.5808289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03409",
    "Farbtonhilfsbezeichnung": "S1.05.25",
    "Farbtonklasse": "01",
    "Rcolor": "76",
    "Gcolor": "83",
    "Bcolor": "86",
    "Y": 8,
    "L": 34.6767607859142,
    "a": -1.72723175465433,
    "b": -3.04774630933256,
    "C": 3.50315387905477,
    "h": 1.05520373005964,
    "CMY_C": 0.7014305,
    "CMY_M": 0.6759434,
    "CMY_Y": 0.6644283,
    "CMYK_C": 0.1102661,
    "CMYK_M": 0.03431505,
    "CMYK_Y": 0,
    "CMYK_K": 0.6644283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03410",
    "Farbtonhilfsbezeichnung": "R9.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "231",
    "Bcolor": "235",
    "Y": 76,
    "L": 90.760871887207,
    "a": -3.94010901451111,
    "b": -4.53178310394287,
    "C": 6.00512409210205,
    "h": 228.995025634766,
    "CMY_C": 0.15266472101212,
    "CMY_M": 0.09277749061584,
    "CMY_Y": 0.07772141695023,
    "CMYK_C": 0.0812588557601,
    "CMYK_M": 0.01632486470044,
    "CMYK_Y": 0,
    "CMYK_K": 0.07772141695023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03411",
    "Farbtonhilfsbezeichnung": "R8.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 67,
    "L": 85.5094425037737,
    "a": -4.1454189384616,
    "b": -5.43234257223761,
    "C": 6.83336256886032,
    "h": 0.91896399520578,
    "CMY_C": 0.2155279,
    "CMY_M": 0.1503606,
    "CMY_Y": 0.1292742,
    "CMYK_C": 0.09905949,
    "CMYK_M": 0.02421695,
    "CMYK_Y": 0,
    "CMYK_K": 0.1292742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03412",
    "Farbtonhilfsbezeichnung": "R9.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "215",
    "Bcolor": "223",
    "Y": 65,
    "L": 84.7307543764644,
    "a": -4.49022005568839,
    "b": -7.0380743975796,
    "C": 8.34844700374696,
    "h": 1.00291047759095,
    "CMY_C": 0.233361,
    "CMY_M": 0.1576874,
    "CMY_Y": 0.1261681,
    "CMYK_C": 0.12267,
    "CMYK_M": 0.03607022,
    "CMYK_Y": 0,
    "CMYK_K": 0.1261681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03413",
    "Farbtonhilfsbezeichnung": "R6.09.74",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "204",
    "Bcolor": "214",
    "Y": 58,
    "L": 80.7523725630472,
    "a": -5.16948245937171,
    "b": -8.07151720205843,
    "C": 9.58503723732344,
    "h": 1.00115699733778,
    "CMY_C": 0.2863994,
    "CMY_M": 0.1994761,
    "CMY_Y": 0.1624227,
    "CMYK_C": 0.1480182,
    "CMYK_M": 0.04423879,
    "CMYK_Y": 0,
    "CMYK_K": 0.1624227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03414",
    "Farbtonhilfsbezeichnung": "S0.09.71",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "199",
    "Bcolor": "210",
    "Y": 54,
    "L": 78.816047668457,
    "a": -4.90206575393677,
    "b": -9.0287914276123,
    "C": 10.2737197875977,
    "h": 241.500823974609,
    "CMY_C": 0.30888724327087,
    "CMY_M": 0.22082847356796,
    "CMY_Y": 0.17663133144379,
    "CMYK_C": 0.16062781214714,
    "CMYK_M": 0.05367843434215,
    "CMYK_Y": 0,
    "CMYK_K": 0.17663133144379
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03415",
    "Farbtonhilfsbezeichnung": "S1.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "168",
    "Bcolor": "178",
    "Y": 37,
    "L": 67.5979815545597,
    "a": -4.32772635650003,
    "b": -8.30088111445597,
    "C": 9.36129492608137,
    "h": 1.09020909303593,
    "CMY_C": 0.4190177,
    "CMY_M": 0.3422178,
    "CMY_Y": 0.302184,
    "CMYK_C": 0.1674278,
    "CMYK_M": 0.05737023,
    "CMYK_Y": 0,
    "CMYK_K": 0.302184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03416",
    "Farbtonhilfsbezeichnung": "S1.09.41",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "120",
    "Bcolor": "127",
    "Y": 17,
    "L": 49.5318717956543,
    "a": -2.79963803291321,
    "b": -6.14175224304199,
    "C": 6.74974775314331,
    "h": 245.494750976562,
    "CMY_C": 0.57985484600067,
    "CMY_M": 0.53053224086761,
    "CMY_Y": 0.50205314159393,
    "CMYK_C": 0.15624499320984,
    "CMYK_M": 0.05719304829836,
    "CMYK_Y": 0,
    "CMYK_K": 0.50205314159393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03417",
    "Farbtonhilfsbezeichnung": "R9.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "225",
    "Bcolor": "236",
    "Y": 72,
    "L": 87.9358430097174,
    "a": -6.33402990890225,
    "b": -9.25644036896271,
    "C": 11.2161322741412,
    "h": 0.97069637389403,
    "CMY_C": 0.2238014,
    "CMY_M": 0.1174262,
    "CMY_Y": 0.07461546,
    "CMYK_C": 0.1612151,
    "CMYK_M": 0.04626262,
    "CMYK_Y": 0,
    "CMYK_K": 0.07461546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03418",
    "Farbtonhilfsbezeichnung": "R8.12.79",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "220",
    "Bcolor": "234",
    "Y": 68,
    "L": 85.8307753097478,
    "a": -7.40177859525248,
    "b": -11.2217018200494,
    "C": 13.4429504987275,
    "h": 0.98770547296011,
    "CMY_C": 0.2650992,
    "CMY_M": 0.1377961,
    "CMY_Y": 0.08375037,
    "CMYK_C": 0.1979251,
    "CMYK_M": 0.05898577,
    "CMYK_Y": 0,
    "CMYK_K": 0.08375037
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03419",
    "Farbtonhilfsbezeichnung": "R9.12.76",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "213",
    "Bcolor": "225",
    "Y": 63,
    "L": 83.6368298424644,
    "a": -7.07177041663998,
    "b": -10.0955367937875,
    "C": 12.3259806904108,
    "h": 0.95974504447005,
    "CMY_C": 0.2807678,
    "CMY_M": 0.1630767,
    "CMY_Y": 0.1162586,
    "CMYK_C": 0.1861508,
    "CMYK_M": 0.05297714,
    "CMYK_Y": 0,
    "CMYK_K": 0.1162586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03420",
    "Farbtonhilfsbezeichnung": "R9.15.65",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "183",
    "Bcolor": "199",
    "Y": 44,
    "L": 72.4741866700351,
    "a": -7.11079708429091,
    "b": -12.8318158764274,
    "C": 14.6703419817159,
    "h": 1.064769758377,
    "CMY_C": 0.4127694,
    "CMY_M": 0.2832456,
    "CMY_Y": 0.2185633,
    "CMYK_C": 0.2485244,
    "CMYK_M": 0.08277355,
    "CMYK_Y": 0,
    "CMYK_K": 0.2185633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03421",
    "Farbtonhilfsbezeichnung": "R9.15.56",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "159",
    "Bcolor": "173",
    "Y": 33,
    "L": 63.7806191158842,
    "a": -7.11898663300847,
    "b": -11.5653945791964,
    "C": 13.5808071355667,
    "h": 1.01902716498754,
    "CMY_C": 0.4969335,
    "CMY_M": 0.375401,
    "CMY_Y": 0.320118,
    "CMYK_C": 0.2600679,
    "CMYK_M": 0.08131266,
    "CMYK_Y": 0,
    "CMYK_K": 0.320118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03422",
    "Farbtonhilfsbezeichnung": "S1.20.49",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "142",
    "Bcolor": "161",
    "Y": 25,
    "L": 57.1578408701736,
    "a": -7.68268509533193,
    "b": -14.5153587368506,
    "C": 16.4231327563745,
    "h": 1.0840002335336,
    "CMY_C": 0.5844123,
    "CMY_M": 0.4417043,
    "CMY_Y": 0.3692688,
    "CMYK_C": 0.3411017,
    "CMYK_M": 0.1148436,
    "CMYK_Y": 0,
    "CMYK_K": 0.3692688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03423",
    "Farbtonhilfsbezeichnung": "R9.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "120",
    "Bcolor": "136",
    "Y": 17,
    "L": 48.5832445617401,
    "a": -7.58420061087595,
    "b": -13.1719824618442,
    "C": 15.1993822532741,
    "h": 1.04837396997024,
    "CMY_C": 0.6617118,
    "CMY_M": 0.5285757,
    "CMY_Y": 0.4659455,
    "CMYK_C": 0.366566,
    "CMYK_M": 0.117273,
    "CMYK_Y": 0,
    "CMYK_K": 0.4659455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03424",
    "Farbtonhilfsbezeichnung": "S8.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "211",
    "Bcolor": "231",
    "Y": 62,
    "L": 82.8543311893869,
    "a": -5.36063391321134,
    "b": -14.5592051663794,
    "C": 15.514730130692,
    "h": 1.2180045445538,
    "CMY_C": 0.2945186,
    "CMY_M": 0.1740276,
    "CMY_Y": 0.09224433,
    "CMYK_C": 0.222829,
    "CMYK_M": 0.09009396,
    "CMYK_Y": 0,
    "CMYK_K": 0.09224433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03425",
    "Farbtonhilfsbezeichnung": "S7.26.61",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "175",
    "Bcolor": "209",
    "Y": 39,
    "L": 68.8410469556544,
    "a": -8.4698883625044,
    "b": -23.9620040639977,
    "C": 25.4148902739384,
    "h": 1.23103210538393,
    "CMY_C": 0.5279519,
    "CMY_M": 0.3154209,
    "CMY_Y": 0.179626,
    "CMYK_C": 0.424594,
    "CMYK_M": 0.165528,
    "CMYK_Y": 0,
    "CMYK_K": 0.179626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03426",
    "Farbtonhilfsbezeichnung": "S9.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "142",
    "Bcolor": "177",
    "Y": 24,
    "L": 56.5313170126201,
    "a": -7.45997061017917,
    "b": -24.9973611505885,
    "C": 26.0867634251106,
    "h": 1.28078022261432,
    "CMY_C": 0.6561497,
    "CMY_M": 0.4450365,
    "CMY_Y": 0.3048436,
    "CMYK_C": 0.5053627,
    "CMYK_M": 0.201671,
    "CMYK_Y": 0,
    "CMYK_K": 0.3048436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03427",
    "Farbtonhilfsbezeichnung": "S9.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "124",
    "Bcolor": "154",
    "Y": 17,
    "L": 49.9648513793945,
    "a": -6.479811668396,
    "b": -21.8089275360107,
    "C": 22.7512035369873,
    "h": 253.452407836914,
    "CMY_C": 0.69049298763275,
    "CMY_M": 0.51416122913361,
    "CMY_Y": 0.3948563337326,
    "CMYK_C": 0.48853960633278,
    "CMYK_M": 0.19715136289597,
    "CMYK_Y": 0,
    "CMYK_K": 0.3948563337326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03428",
    "Farbtonhilfsbezeichnung": "S9.31.35",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "109",
    "Bcolor": "140",
    "Y": 14,
    "L": 43.7880246954406,
    "a": -6.658995838352,
    "b": -22.6163646752228,
    "C": 23.5763054081393,
    "h": 1.28445500080865,
    "CMY_C": 0.763591,
    "CMY_M": 0.5742802,
    "CMY_Y": 0.4528272,
    "CMYK_C": 0.5679444,
    "CMYK_M": 0.2219645,
    "CMYK_Y": 0,
    "CMYK_K": 0.4528272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03429",
    "Farbtonhilfsbezeichnung": "S8.33.21",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "76",
    "Bcolor": "100",
    "Y": 6,
    "L": 30.4713216215897,
    "a": -5.51818402726681,
    "b": -18.9243744247349,
    "C": 19.7124910228602,
    "h": 1.28707162397205,
    "CMY_C": 0.8578954,
    "CMY_M": 0.7031287,
    "CMY_Y": 0.6073604,
    "CMYK_C": 0.6380787,
    "CMYK_M": 0.2439089,
    "CMYK_Y": 0,
    "CMYK_K": 0.6073604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03430",
    "Farbtonhilfsbezeichnung": "T4.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "224",
    "Y": 73,
    "L": 88.3291943074119,
    "a": -0.87790701549772,
    "b": -2.44881009307534,
    "C": 2.60142107314594,
    "h": 1.22656617330359,
    "CMY_C": 0.1465174,
    "CMY_M": 0.1275691,
    "CMY_Y": 0.1196454,
    "CMYK_C": 0.03052411,
    "CMYK_M": 0.009000598,
    "CMYK_Y": 0,
    "CMYK_K": 0.1196454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03432",
    "Farbtonhilfsbezeichnung": "S8.11.60",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "168",
    "Bcolor": "182",
    "Y": 38,
    "L": 67.996648424472,
    "a": -3.2164625236672,
    "b": -9.81872932444086,
    "C": 10.3321380513808,
    "h": 1.25422870780534,
    "CMY_C": 0.41197,
    "CMY_M": 0.3399469,
    "CMY_Y": 0.2872528,
    "CMYK_C": 0.174981,
    "CMYK_M": 0.07393093,
    "CMYK_Y": 0,
    "CMYK_K": 0.2872528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03433",
    "Farbtonhilfsbezeichnung": "T0.11.31",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "99",
    "Bcolor": "109",
    "Y": 11,
    "L": 41.4815483093262,
    "a": -1.74691247940063,
    "b": -7.5634126663208,
    "C": 7.76253271102905,
    "h": 256.994537353516,
    "CMY_C": 0.65456807613373,
    "CMY_M": 0.61058360338211,
    "CMY_Y": 0.57173562049866,
    "CMYK_C": 0.19341430068016,
    "CMYK_M": 0.09071028232574,
    "CMYK_Y": 0,
    "CMYK_K": 0.57173562049866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03434",
    "Farbtonhilfsbezeichnung": "TN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "231",
    "Bcolor": "233",
    "Y": 79,
    "L": 91.2579574584961,
    "a": -0.80431914329529,
    "b": -2.65559458732605,
    "C": 2.77472734451294,
    "h": 253.149627685547,
    "CMY_C": 0.11422032117844,
    "CMY_M": 0.0950739979744,
    "CMY_Y": 0.08567303419113,
    "CMYK_C": 0.03122218698263,
    "CMYK_M": 0.0102818403393,
    "CMYK_Y": 0,
    "CMYK_K": 0.08567303419113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03435",
    "Farbtonhilfsbezeichnung": "UN.02.73",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "201",
    "Bcolor": "207",
    "Y": 59,
    "L": 81.0609089620555,
    "a": 0.75141337268463,
    "b": -4.18654360499144,
    "C": 4.2534420665085,
    "h": -1.39320421623468,
    "CMY_C": 0.2193629,
    "CMY_M": 0.2106861,
    "CMY_Y": 0.18639,
    "CMYK_C": 0.04052668,
    "CMYK_M": 0.02986209,
    "CMYK_Y": 0,
    "CMYK_K": 0.18639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03436",
    "Farbtonhilfsbezeichnung": "U0.05.66",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "180",
    "Bcolor": "190",
    "Y": 45,
    "L": 73.1940170541431,
    "a": 0.05876496871515,
    "b": -6.69117649855944,
    "C": 6.69143454398399,
    "h": -1.56201409575973,
    "CMY_C": 0.3184344,
    "CMY_M": 0.2930726,
    "CMY_Y": 0.2534474,
    "CMYK_C": 0.08704945,
    "CMYK_M": 0.05307752,
    "CMYK_Y": 0,
    "CMYK_K": 0.2534474
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03438",
    "Farbtonhilfsbezeichnung": "U0.05.56",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "152",
    "Bcolor": "162",
    "Y": 31,
    "L": 62.7210418915838,
    "a": -0.31973748686359,
    "b": -6.36673291584682,
    "C": 6.37475647238647,
    "h": 1.52061845707209,
    "CMY_C": 0.429465,
    "CMY_M": 0.402264,
    "CMY_Y": 0.3661942,
    "CMYK_C": 0.09982689,
    "CMYK_M": 0.05690995,
    "CMYK_Y": 0,
    "CMYK_K": 0.3661942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03439",
    "Farbtonhilfsbezeichnung": "U1.07.44",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "125",
    "Bcolor": "136",
    "Y": 20,
    "L": 52.2437076975743,
    "a": 0.33849244719863,
    "b": -7.5944465498385,
    "C": 7.60198628880402,
    "h": -1.52625475756898,
    "CMY_C": 0.5346805,
    "CMY_M": 0.5096956,
    "CMY_Y": 0.4650163,
    "CMYK_C": 0.1302175,
    "CMYK_M": 0.0835154,
    "CMYK_Y": 0,
    "CMYK_K": 0.4650163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03440",
    "Farbtonhilfsbezeichnung": "U1.09.36",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "107",
    "Bcolor": "120",
    "Y": 15,
    "L": 44.9632882473929,
    "a": 0.15112892999169,
    "b": -8.55302762473089,
    "C": 8.55436271751965,
    "h": -1.55312852408615,
    "CMY_C": 0.6108214,
    "CMY_M": 0.5805991,
    "CMY_Y": 0.5312458,
    "CMYK_C": 0.1697597,
    "CMYK_M": 0.1052862,
    "CMYK_Y": 0,
    "CMYK_K": 0.5312458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03441",
    "Farbtonhilfsbezeichnung": "U7.10.26",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "82",
    "Bcolor": "95",
    "Y": 8,
    "L": 34.7876978129948,
    "a": 0.9781150836243,
    "b": -8.95161866583936,
    "C": 9.00489788145412,
    "h": -1.46196125254054,
    "CMY_C": 0.7021304,
    "CMY_M": 0.6785833,
    "CMY_Y": 0.626821,
    "CMYK_C": 0.2018048,
    "CMYK_M": 0.1387061,
    "CMYK_Y": 0,
    "CMYK_K": 0.626821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03442",
    "Farbtonhilfsbezeichnung": "UN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "233",
    "Bcolor": "235",
    "Y": 81,
    "L": 92.4261093139648,
    "a": 0.26293447613716,
    "b": -1.694011926651,
    "C": 1.7142961025238,
    "h": 278.822723388672,
    "CMY_C": 0.08914077281952,
    "CMY_M": 0.08483308553696,
    "CMY_Y": 0.07966977357864,
    "CMYK_C": 0.01029087044299,
    "CMYK_M": 0.00561028206721,
    "CMYK_Y": 0,
    "CMYK_K": 0.07966977357864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03443",
    "Farbtonhilfsbezeichnung": "U6.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "226",
    "Bcolor": "232",
    "Y": 76,
    "L": 89.9426295524988,
    "a": 0.52057065408778,
    "b": -3.96322718263855,
    "C": 3.99726950643843,
    "h": -1.44019379902111,
    "CMY_C": 0.1229037,
    "CMY_M": 0.1125011,
    "CMY_Y": 0.09044007,
    "CMYK_C": 0.0356916,
    "CMYK_M": 0.02425466,
    "CMYK_Y": 0,
    "CMYK_K": 0.09044007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03444",
    "Farbtonhilfsbezeichnung": "U5.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "224",
    "Bcolor": "229",
    "Y": 74,
    "L": 88.9530715942383,
    "a": 0.40544754266739,
    "b": -3.66801524162292,
    "C": 3.6903555393219,
    "h": 276.307647705078,
    "CMY_C": 0.13370710611343,
    "CMY_M": 0.12328028678894,
    "CMY_Y": 0.10360449552536,
    "CMYK_C": 0.03358184173703,
    "CMYK_M": 0.02194990031421,
    "CMYK_Y": 0,
    "CMYK_K": 0.10360449552536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03445",
    "Farbtonhilfsbezeichnung": "U0.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "216",
    "Bcolor": "229",
    "Y": 68,
    "L": 86.18017578125,
    "a": 0.2536124587059,
    "b": -7.8435754776001,
    "C": 7.84767436981201,
    "h": 271.851928710938,
    "CMY_C": 0.18118113279343,
    "CMY_M": 0.15232509374619,
    "CMY_Y": 0.10367870330811,
    "CMYK_C": 0.08646724373102,
    "CMYK_M": 0.05427338555455,
    "CMYK_Y": 0,
    "CMYK_K": 0.10367870330811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03446",
    "Farbtonhilfsbezeichnung": "T9.10.71",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "195",
    "Bcolor": "216",
    "Y": 54,
    "L": 78.1910923001831,
    "a": -0.60178916467973,
    "b": -13.2551840327889,
    "C": 13.2688377012393,
    "h": 1.52542719368494,
    "CMY_C": 0.2970821,
    "CMY_M": 0.2358945,
    "CMY_Y": 0.1526024,
    "CMYK_C": 0.170498,
    "CMYK_M": 0.09829166,
    "CMYK_Y": 0,
    "CMYK_K": 0.1526024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03447",
    "Farbtonhilfsbezeichnung": "U1.09.60",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "167",
    "Bcolor": "184",
    "Y": 38,
    "L": 68.1859817504883,
    "a": 0.18276762962341,
    "b": -10.775562286377,
    "C": 10.7771120071411,
    "h": 270.971710205078,
    "CMY_C": 0.3860279917717,
    "CMY_M": 0.34508240222931,
    "CMY_Y": 0.27818244695663,
    "CMYK_C": 0.14940831065178,
    "CMYK_M": 0.09268263727427,
    "CMYK_Y": 0,
    "CMYK_K": 0.27818244695663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03448",
    "Farbtonhilfsbezeichnung": "U0.10.49",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "139",
    "Bcolor": "156",
    "Y": 25,
    "L": 57.4657307668506,
    "a": -0.57179832400766,
    "b": -10.9387631542216,
    "C": 10.9536976709919,
    "h": 1.51857119236591,
    "CMY_C": 0.5027365,
    "CMY_M": 0.4542085,
    "CMY_Y": 0.3895194,
    "CMYK_C": 0.1854558,
    "CMYK_M": 0.1059642,
    "CMYK_Y": 0,
    "CMYK_K": 0.3895194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03449",
    "Farbtonhilfsbezeichnung": "U2.09.41",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "118",
    "Bcolor": "133",
    "Y": 18,
    "L": 49.2221895219919,
    "a": 0.10862758486124,
    "b": -9.89852092118591,
    "C": 9.89911694947321,
    "h": -1.55982264443183,
    "CMY_C": 0.5750503,
    "CMY_M": 0.5384833,
    "CMY_Y": 0.4802233,
    "CMYK_C": 0.1824379,
    "CMYK_M": 0.1120865,
    "CMYK_Y": 0,
    "CMYK_K": 0.4802233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03450",
    "Farbtonhilfsbezeichnung": "XN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "217",
    "Bcolor": "218",
    "Y": 70,
    "L": 86.7599813891156,
    "a": 1.47834816175302,
    "b": -1.22550750009949,
    "C": 1.9202556913491,
    "h": -0.69215815311013,
    "CMY_C": 0.1408392,
    "CMY_M": 0.1508319,
    "CMY_Y": 0.1455773,
    "CMYK_C": 0,
    "CMYK_M": 0.01163069,
    "CMYK_Y": 0.005514783,
    "CMYK_K": 0.1408392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03451",
    "Farbtonhilfsbezeichnung": "W0.05.36",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "102",
    "Bcolor": "113",
    "Y": 14,
    "L": 43.8851921980034,
    "a": 3.18971567810561,
    "b": -6.01794908900093,
    "C": 6.81102028663546,
    "h": -1.08341145670436,
    "CMY_C": 0.590193,
    "CMY_M": 0.5980986,
    "CMY_Y": 0.557743,
    "CMYK_C": 0.07337379,
    "CMYK_M": 0.09124932,
    "CMYK_Y": 0,
    "CMYK_K": 0.557743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03452",
    "Farbtonhilfsbezeichnung": "Y3.04.72",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "195",
    "Bcolor": "205",
    "Y": 57,
    "L": 80.1698092425905,
    "a": 6.59362104097455,
    "b": -3.91399191784212,
    "C": 7.66780093409549,
    "h": -0.53570239922949,
    "CMY_C": 0.183189,
    "CMY_M": 0.2343648,
    "CMY_Y": 0.1972717,
    "CMYK_C": 0,
    "CMYK_M": 0.06265311,
    "CMYK_Y": 0.01724097,
    "CMYK_K": 0.183189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03453",
    "Farbtonhilfsbezeichnung": "Y7.08.64",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "171",
    "Bcolor": "183",
    "Y": 44,
    "L": 72.5524600614028,
    "a": 12.4554996298349,
    "b": -3.22149540836045,
    "C": 12.8653606127036,
    "h": -0.25309412689192,
    "CMY_C": 0.2216464,
    "CMY_M": 0.3306818,
    "CMY_Y": 0.28319,
    "CMYK_C": 0,
    "CMYK_M": 0.1400847,
    "CMYK_Y": 0.0790689,
    "CMYK_K": 0.2216464
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03454",
    "Farbtonhilfsbezeichnung": "Z0.09.60",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "157",
    "Bcolor": "170",
    "Y": 38,
    "L": 67.8668699725819,
    "a": 14.277977971244,
    "b": -3.2859960648884,
    "C": 14.6512260608384,
    "h": -0.22620548821974,
    "CMY_C": 0.2600648,
    "CMY_M": 0.3845221,
    "CMY_Y": 0.3319357,
    "CMYK_C": 0,
    "CMYK_M": 0.1682002,
    "CMYK_Y": 0.09713133,
    "CMYK_K": 0.2600648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03455",
    "Farbtonhilfsbezeichnung": "Y9.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "131",
    "Bcolor": "144",
    "Y": 26,
    "L": 57.6081482428492,
    "a": 13.6826900113419,
    "b": -3.67413834265344,
    "C": 14.1674026733001,
    "h": -0.26233613768189,
    "CMY_C": 0.3743225,
    "CMY_M": 0.488084,
    "CMY_Y": 0.4352941,
    "CMYK_C": 0,
    "CMYK_M": 0.1818214,
    "CMYK_Y": 0.09744896,
    "CMYK_K": 0.3743225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03456",
    "Farbtonhilfsbezeichnung": "Z0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "108",
    "Bcolor": "120",
    "Y": 17,
    "L": 48.5535885867921,
    "a": 12.3138664428086,
    "b": -3.23802543265963,
    "C": 12.7324826908926,
    "h": -0.25713643405682,
    "CMY_C": 0.4753745,
    "CMY_M": 0.5746384,
    "CMY_Y": 0.528927,
    "CMYK_C": 0,
    "CMYK_M": 0.1892091,
    "CMYK_Y": 0.1020776,
    "CMYK_K": 0.4753745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03457",
    "Farbtonhilfsbezeichnung": "Y3.09.31",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "87",
    "Bcolor": "99",
    "Y": 11,
    "L": 39.0383642574458,
    "a": 9.71034186224826,
    "b": -4.65474707536697,
    "C": 10.7683522145855,
    "h": -0.44699948830098,
    "CMY_C": 0.5900146,
    "CMY_M": 0.6590622,
    "CMY_Y": 0.6122622,
    "CMYK_C": 0,
    "CMYK_M": 0.1684149,
    "CMYK_Y": 0.05426462,
    "CMYK_K": 0.5900146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03460",
    "Farbtonhilfsbezeichnung": "F5.34.74",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "196",
    "Bcolor": "119",
    "Y": 59,
    "L": 81.2164979043775,
    "a": 5.29592514337845,
    "b": 43.5086147805545,
    "C": 43.8297431346221,
    "h": 1.44967088291584,
    "CMY_C": 0.07135872,
    "CMY_M": 0.230614,
    "CMY_Y": 0.5348341,
    "CMYK_C": 0,
    "CMYK_M": 0.1714928,
    "CMYK_Y": 0.4990898,
    "CMYK_K": 0.07135872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03461",
    "Farbtonhilfsbezeichnung": "G0.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "222",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.5900573730469,
    "a": 0.32458844780922,
    "b": 6.39042234420776,
    "C": 6.39866065979004,
    "h": 87.0922775268555,
    "CMY_C": 0.10464304685593,
    "CMY_M": 0.12995272874832,
    "CMY_Y": 0.18168783187866,
    "CMYK_C": 0,
    "CMYK_M": 0.02826770022511,
    "CMYK_Y": 0.08604923635721,
    "CMYK_K": 0.10464304685593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03462",
    "Farbtonhilfsbezeichnung": "T6.20.64",
    "Farbtonklasse": "01",
    "Rcolor": "147",
    "Gcolor": "179",
    "Bcolor": "214",
    "Y": 43,
    "L": 71.7063239114685,
    "a": -2.14683923019526,
    "b": -22.0358878234637,
    "C": 22.1402184011039,
    "h": 1.47367814490501,
    "CMY_C": 0.4221722,
    "CMY_M": 0.299023,
    "CMY_Y": 0.161268,
    "CMYK_C": 0.3110698,
    "CMYK_M": 0.164242,
    "CMYK_Y": 0,
    "CMYK_K": 0.161268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03463",
    "Farbtonhilfsbezeichnung": "F9.10.88",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "237",
    "Bcolor": "207",
    "Y": 85,
    "L": 94.0969451883195,
    "a": 0.24497130605466,
    "b": 15.4634539414654,
    "C": 15.4653942316584,
    "h": 1.55495569915819,
    "CMY_C": 0.01683071,
    "CMY_M": 0.07073472,
    "CMY_Y": 0.1891895,
    "CMYK_C": 0,
    "CMYK_M": 0.05482679,
    "CMYK_Y": 0.1753094,
    "CMYK_K": 0.01683071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03464",
    "Farbtonhilfsbezeichnung": "P3.35.53",
    "Farbtonklasse": "03",
    "Rcolor": "35",
    "Gcolor": "162",
    "Bcolor": "166",
    "Y": 29,
    "L": 60.7438499039064,
    "a": -30.8559363139531,
    "b": -12.1365627883365,
    "C": 33.1569745623144,
    "h": 0.37474311127986,
    "CMY_C": 0.8642057,
    "CMY_M": 0.3644178,
    "CMY_Y": 0.350292,
    "CMYK_C": 0.7909917,
    "CMYK_M": 0.02174168,
    "CMYK_Y": 0,
    "CMYK_K": 0.350292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03465",
    "Farbtonhilfsbezeichnung": "D1.40.44",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "101",
    "Bcolor": "71",
    "Y": 19,
    "L": 51.0997697822957,
    "a": 28.7886121127564,
    "b": 30.1885477034442,
    "C": 41.7148966176577,
    "h": 0.80913061773894,
    "CMY_C": 0.2977693,
    "CMY_M": 0.6039113,
    "CMY_Y": 0.7222114,
    "CMYK_C": 0,
    "CMYK_M": 0.4359564,
    "CMYK_Y": 0.6044196,
    "CMYK_K": 0.2977693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03466",
    "Farbtonhilfsbezeichnung": "B9.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "59",
    "Bcolor": "56",
    "Y": 6,
    "L": 30.4485558032116,
    "a": 20.2524586055156,
    "b": 10.0506492167313,
    "C": 22.6092376971429,
    "h": 0.46065763712867,
    "CMY_C": 0.5876203,
    "CMY_M": 0.7690468,
    "CMY_Y": 0.7787167,
    "CMYK_C": 0,
    "CMYK_M": 0.4399503,
    "CMYK_Y": 0.4633994,
    "CMYK_K": 0.5876203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03467",
    "Farbtonhilfsbezeichnung": "YN.00.85",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "233",
    "Y": 82,
    "L": 92.7807632489335,
    "a": 0.31572449001038,
    "b": -0.25840605560425,
    "C": 0.40798975865242,
    "h": -0.68589268781908,
    "CMY_C": 0.0797253,
    "CMY_M": 0.08144025,
    "CMY_Y": 0.0863846,
    "CMYK_C": 0,
    "CMYK_M": 0.001863525,
    "CMYK_Y": 0.007236216,
    "CMYK_K": 0.0797253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03468",
    "Farbtonhilfsbezeichnung": "F4.09.84",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "227",
    "Bcolor": "202",
    "Y": 79,
    "L": 91.0756913140562,
    "a": 1.85527899950994,
    "b": 13.5320044696773,
    "C": 13.6585945519072,
    "h": 1.43454277580452,
    "CMY_C": 0.04445973,
    "CMY_M": 0.1078992,
    "CMY_Y": 0.2073112,
    "CMYK_C": 0,
    "CMYK_M": 0.06639116,
    "CMYK_Y": 0.1704286,
    "CMYK_K": 0.04445973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03469",
    "Farbtonhilfsbezeichnung": "E4.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "226",
    "Bcolor": "203",
    "Y": 79,
    "L": 91.3232840229516,
    "a": 5.07428834864027,
    "b": 13.4077605990487,
    "C": 14.3358448138416,
    "h": 1.20899651818804,
    "CMY_C": 0.01839223,
    "CMY_M": 0.1130093,
    "CMY_Y": 0.2031784,
    "CMYK_C": 0,
    "CMYK_M": 0.0963899,
    "CMYK_Y": 0.1882485,
    "CMYK_K": 0.01839223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03470",
    "Farbtonhilfsbezeichnung": "D1.58.49",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "105",
    "Bcolor": "65",
    "Y": 26,
    "L": 58.8060722351074,
    "a": 44.9720687866211,
    "b": 43.9515838623047,
    "C": 62.8826599121094,
    "h": 44.3425025939941,
    "CMY_C": 0.11104959249496,
    "CMY_M": 0.58723092079163,
    "CMY_Y": 0.74381613731384,
    "CMYK_C": 0,
    "CMYK_M": 0.53566694259644,
    "CMYK_Y": 0.71181309223175,
    "CMYK_K": 0.11104959249496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03471",
    "Farbtonhilfsbezeichnung": "E4.40.71",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "175",
    "Bcolor": "102",
    "Y": 52,
    "L": 77.5684431729877,
    "a": 21.4418821025735,
    "b": 47.6639327975346,
    "C": 52.2647567470524,
    "h": 1.14806257728425,
    "CMY_C": 0.00946106,
    "CMY_M": 0.3132296,
    "CMY_Y": 0.5991156,
    "CMYK_C": 0,
    "CMYK_M": 0.30667,
    "CMYK_Y": 0.5952865,
    "CMYK_K": 0.00946106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03472",
    "Farbtonhilfsbezeichnung": "E4.31.69",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "177",
    "Bcolor": "123",
    "Y": 51,
    "L": 76.5820489550186,
    "a": 15.9624722864383,
    "b": 35.5852811134467,
    "C": 39.0014455298562,
    "h": 1.14913262985318,
    "CMY_C": 0.07008419,
    "CMY_M": 0.3064475,
    "CMY_Y": 0.5187965,
    "CMYK_C": 0,
    "CMYK_M": 0.2541772,
    "CMYK_Y": 0.4825301,
    "CMYK_K": 0.07008419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03473",
    "Farbtonhilfsbezeichnung": "B9.45.33",
    "Farbtonklasse": "04",
    "Rcolor": "163",
    "Gcolor": "67",
    "Bcolor": "66",
    "Y": 12,
    "L": 41.5049265231971,
    "a": 40.0558350682847,
    "b": 20.2941943294347,
    "C": 44.9034992678576,
    "h": 0.46895156808206,
    "CMY_C": 0.3605022,
    "CMY_M": 0.7380158,
    "CMY_Y": 0.7405528,
    "CMYK_C": 0,
    "CMYK_M": 0.5903282,
    "CMYK_Y": 0.5942953,
    "CMYK_K": 0.3605022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03474",
    "Farbtonhilfsbezeichnung": "L4.55.45",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "90",
    "Y": 20,
    "L": 52.2798683943445,
    "a": -46.3163706123114,
    "b": 18.5516901621303,
    "C": 49.8936007376564,
    "h": -0.38097424643019,
    "CMY_C": 1,
    "CMY_M": 0.4380725,
    "CMY_Y": 0.645597,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3693082,
    "CMYK_K": 0.4380725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03475",
    "Farbtonhilfsbezeichnung": "F8.12.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "228",
    "Bcolor": "192",
    "Y": 78,
    "L": 90.9976579832029,
    "a": 0.765163185238,
    "b": 18.9885736914104,
    "C": 19.0039839384843,
    "h": 1.53052213600881,
    "CMY_C": 0.03892692,
    "CMY_M": 0.107458,
    "CMY_Y": 0.2489747,
    "CMYK_C": 0,
    "CMYK_M": 0.07130679,
    "CMYK_Y": 0.2185555,
    "CMYK_K": 0.03892692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03476",
    "Farbtonhilfsbezeichnung": "E2.25.34",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "94",
    "Bcolor": "74",
    "Y": 13,
    "L": 42.3354087409876,
    "a": 8.48739995265008,
    "b": 15.8490972283303,
    "C": 17.9785939636366,
    "h": 1.07914344914572,
    "CMY_C": 0.5205739,
    "CMY_M": 0.6298992,
    "CMY_Y": 0.7114164,
    "CMYK_C": 0,
    "CMYK_M": 0.2280338,
    "CMYK_Y": 0.3980645,
    "CMYK_K": 0.5205739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03477",
    "Farbtonhilfsbezeichnung": "E0.32.31",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "86",
    "Bcolor": "63",
    "Y": 11,
    "L": 39.8209892433587,
    "a": 12.3978010834951,
    "b": 19.0694322554197,
    "C": 22.7453010147141,
    "h": 0.99432267959016,
    "CMY_C": 0.519954,
    "CMY_M": 0.6636407,
    "CMY_Y": 0.7540404,
    "CMYK_C": 0,
    "CMYK_M": 0.2993188,
    "CMYK_Y": 0.4876332,
    "CMYK_K": 0.519954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03478",
    "Farbtonhilfsbezeichnung": "E1.36.29",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "82",
    "Bcolor": "53",
    "Y": 10,
    "L": 38.2753529506008,
    "a": 12.5326583973046,
    "b": 22.5902826714275,
    "C": 25.8338614550463,
    "h": 1.06428993545066,
    "CMY_C": 0.53076,
    "CMY_M": 0.6789969,
    "CMY_Y": 0.7904854,
    "CMYK_C": 0,
    "CMYK_M": 0.3159085,
    "CMYK_Y": 0.5535022,
    "CMYK_K": 0.53076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03479",
    "Farbtonhilfsbezeichnung": "E3.35.29",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "85",
    "Bcolor": "58",
    "Y": 11,
    "L": 39.3717373044196,
    "a": 11.4470277485131,
    "b": 21.0471262704565,
    "C": 23.9586303556729,
    "h": 1.07266696531584,
    "CMY_C": 0.527068,
    "CMY_M": 0.6658369,
    "CMY_Y": 0.7710282,
    "CMYK_C": 0,
    "CMYK_M": 0.2934225,
    "CMYK_Y": 0.5158463,
    "CMYK_K": 0.527068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03480",
    "Farbtonhilfsbezeichnung": "E1.21.50",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "128",
    "Bcolor": "102",
    "Y": 24,
    "L": 56.5501525190177,
    "a": 10.6311167582669,
    "b": 19.3115922291066,
    "C": 22.0444604821981,
    "h": 1.06756593253579,
    "CMY_C": 0.3533498,
    "CMY_M": 0.496798,
    "CMY_Y": 0.6010156,
    "CMYK_C": 0,
    "CMYK_M": 0.2218328,
    "CMYK_Y": 0.382998,
    "CMYK_K": 0.3533498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03481",
    "Farbtonhilfsbezeichnung": "E0.23.20",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "65",
    "Bcolor": "52",
    "Y": 6,
    "L": 29.4478169244338,
    "a": 7.18124827706787,
    "b": 10.9746390499564,
    "C": 13.1153737687386,
    "h": 0.9913696184171,
    "CMY_C": 0.6629521,
    "CMY_M": 0.7448589,
    "CMY_Y": 0.7951155,
    "CMYK_C": 0,
    "CMYK_M": 0.2430125,
    "CMYK_Y": 0.3921206,
    "CMYK_K": 0.6629521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03482",
    "Farbtonhilfsbezeichnung": "E5.12.55",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "147",
    "Bcolor": "128",
    "Y": 30,
    "L": 62.040980562255,
    "a": 4.34734288330224,
    "b": 12.2135046965158,
    "C": 12.9641462162694,
    "h": 1.22883463678599,
    "CMY_C": 0.3486797,
    "CMY_M": 0.4245505,
    "CMY_Y": 0.4998353,
    "CMYK_C": 0,
    "CMYK_M": 0.1164878,
    "CMYK_Y": 0.2320757,
    "CMYK_K": 0.3486797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03483",
    "Farbtonhilfsbezeichnung": "F8.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "182",
    "Y": 74,
    "L": 88.8617432431298,
    "a": 0.49802241959934,
    "b": 21.0080085298657,
    "C": 21.0139108383312,
    "h": 1.54709445348693,
    "CMY_C": 0.06006933,
    "CMY_M": 0.1309904,
    "CMY_Y": 0.2869143,
    "CMYK_C": 0,
    "CMYK_M": 0.07545349,
    "CMYK_Y": 0.2413422,
    "CMYK_K": 0.06006933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03484",
    "Farbtonhilfsbezeichnung": "A5.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "227",
    "Bcolor": "227",
    "Y": 80,
    "L": 91.7842260756491,
    "a": 6.58322068079925,
    "b": 1.71646350628638,
    "C": 6.80331106892195,
    "h": 0.25505461203525,
    "CMY_C": 0.0358278,
    "CMY_M": 0.1084682,
    "CMY_Y": 0.1111977,
    "CMYK_C": 0,
    "CMYK_M": 0.0753397,
    "CMYK_Y": 0.07817061,
    "CMYK_K": 0.0358278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03485",
    "Farbtonhilfsbezeichnung": "AN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "226",
    "Bcolor": "225",
    "Y": 78,
    "L": 90.7091859545,
    "a": 4.46565956920159,
    "b": 1.02148912089794,
    "C": 4.58099939010196,
    "h": 0.22487437555224,
    "CMY_C": 0.06625684,
    "CMY_M": 0.1149731,
    "CMY_Y": 0.1182338,
    "CMYK_C": 0,
    "CMYK_M": 0.05217313,
    "CMYK_Y": 0.05566516,
    "CMYK_K": 0.06625684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03486",
    "Farbtonhilfsbezeichnung": "B3.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "232",
    "Bcolor": "229",
    "Y": 84,
    "L": 93.2510735970832,
    "a": 5.5174939852351,
    "b": 2.69246455045755,
    "C": 6.13938964658345,
    "h": 0.4539909911016,
    "CMY_C": 0.02423321,
    "CMY_M": 0.08972272,
    "CMY_Y": 0.1023652,
    "CMYK_C": 0,
    "CMYK_M": 0.06711595,
    "CMYK_Y": 0.08007237,
    "CMYK_K": 0.02423321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03487",
    "Farbtonhilfsbezeichnung": "BN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "216",
    "Bcolor": "214",
    "Y": 70,
    "L": 87.007825724057,
    "a": 3.01856588312077,
    "b": 1.4268374619673,
    "C": 3.3388029492041,
    "h": 0.44155961029349,
    "CMY_C": 0.1173603,
    "CMY_M": 0.1525468,
    "CMY_Y": 0.1620843,
    "CMYK_C": 0,
    "CMYK_M": 0.03986508,
    "CMYK_Y": 0.05067066,
    "CMYK_K": 0.1173603
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03488",
    "Farbtonhilfsbezeichnung": "BN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "231",
    "Bcolor": "227",
    "Y": 82,
    "L": 92.4288929680691,
    "a": 3.93583994061658,
    "b": 2.67764918618345,
    "C": 4.76031944331697,
    "h": 0.59739866715268,
    "CMY_C": 0.04564348,
    "CMY_M": 0.09498813,
    "CMY_Y": 0.1115822,
    "CMYK_C": 0,
    "CMYK_M": 0.05170462,
    "CMYK_Y": 0.0690923,
    "CMYK_K": 0.04564348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03489",
    "Farbtonhilfsbezeichnung": "BN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "228",
    "Y": 81,
    "L": 92.3399610834221,
    "a": 2.23975493778078,
    "b": 1.98928994037397,
    "C": 2.9956262530874,
    "h": 0.72624230762224,
    "CMY_C": 0.06195143,
    "CMY_M": 0.09164525,
    "CMY_Y": 0.1076989,
    "CMYK_C": 0,
    "CMYK_M": 0.03165488,
    "CMYK_Y": 0.04876871,
    "CMYK_K": 0.06195143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03490",
    "Farbtonhilfsbezeichnung": "C0.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "223",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.8458845053906,
    "a": 4.73241032885802,
    "b": 2.96143742139872,
    "C": 5.58263549961331,
    "h": 0.55915845143104,
    "CMY_C": 0.06776326,
    "CMY_M": 0.1257707,
    "CMY_Y": 0.1420269,
    "CMYK_C": 0,
    "CMYK_M": 0.0622239,
    "CMYK_Y": 0.07966182,
    "CMYK_K": 0.06776326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03491",
    "Farbtonhilfsbezeichnung": "B3.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 76,
    "L": 90.0202763954154,
    "a": 6.35150241176496,
    "b": 2.20692286049706,
    "C": 6.72399370901258,
    "h": 0.33441441444681,
    "CMY_C": 0.05595089,
    "CMY_M": 0.1276318,
    "CMY_Y": 0.1343089,
    "CMYK_C": 0,
    "CMYK_M": 0.07592918,
    "CMYK_Y": 0.08300201,
    "CMYK_K": 0.05595089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03492",
    "Farbtonhilfsbezeichnung": "BN.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 82,
    "L": 93.2354431152344,
    "a": 3.72491216659546,
    "b": 2.09537220001221,
    "C": 4.27382230758667,
    "h": 29.3590278625488,
    "CMY_C": 0.04001730680466,
    "CMY_M": 0.08525490760803,
    "CMY_Y": 0.09835743904114,
    "CMYK_C": 0,
    "CMYK_M": 0.04712335020304,
    "CMYK_Y": 0.06077206507325,
    "CMYK_K": 0.04001730680466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03493",
    "Farbtonhilfsbezeichnung": "BN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "221",
    "Y": 75,
    "L": 89.6155817423099,
    "a": 2.77574710893075,
    "b": 1.57392713962248,
    "C": 3.19092755379648,
    "h": 0.51582269247204,
    "CMY_C": 0.08969069,
    "CMY_M": 0.123157,
    "CMY_Y": 0.1346026,
    "CMYK_C": 0,
    "CMYK_M": 0.03676367,
    "CMYK_Y": 0.04933698,
    "CMYK_K": 0.08969069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03494",
    "Farbtonhilfsbezeichnung": "BN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "230",
    "Bcolor": "227",
    "Y": 80,
    "L": 91.9248352050781,
    "a": 3.05264663696289,
    "b": 1.66163325309753,
    "C": 3.47558283805847,
    "h": 28.5605773925781,
    "CMY_C": 0.06137657165527,
    "CMY_M": 0.0981273651123,
    "CMY_Y": 0.10974299907684,
    "CMYK_C": 0,
    "CMYK_M": 0.0391539260745,
    "CMYK_Y": 0.05152910575271,
    "CMYK_K": 0.06137657165527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03495",
    "Farbtonhilfsbezeichnung": "BN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "231",
    "Y": 82,
    "L": 92.5247853501515,
    "a": 2.31312327561617,
    "b": 0.57099802226239,
    "C": 2.38255703596469,
    "h": 0.24201321013216,
    "CMY_C": 0.06400374,
    "CMY_M": 0.08935061,
    "CMY_Y": 0.09511008,
    "CMYK_C": 0,
    "CMYK_M": 0.0270801,
    "CMYK_Y": 0.0332334,
    "CMYK_K": 0.06400374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03496",
    "Farbtonhilfsbezeichnung": "C8.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "228",
    "Bcolor": "219",
    "Y": 81,
    "L": 92.3314187346502,
    "a": 6.8148179746223,
    "b": 6.50705199883381,
    "C": 9.42249806276246,
    "h": 0.76229996167026,
    "CMY_C": 0.01339188,
    "CMY_M": 0.1043109,
    "CMY_Y": 0.1406561,
    "CMYK_C": 0,
    "CMYK_M": 0.09215309,
    "CMYK_Y": 0.1289916,
    "CMYK_K": 0.01339188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03497",
    "Farbtonhilfsbezeichnung": "C4.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "217",
    "Bcolor": "211",
    "Y": 72,
    "L": 88.1559369206141,
    "a": 5.91882042113018,
    "b": 4.66178616726807,
    "C": 7.53423423095669,
    "h": 0.66714694682931,
    "CMY_C": 0.07268137,
    "CMY_M": 0.1478779,
    "CMY_Y": 0.1728698,
    "CMYK_C": 0,
    "CMYK_M": 0.08109029,
    "CMYK_Y": 0.108041,
    "CMYK_K": 0.07268137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03498",
    "Farbtonhilfsbezeichnung": "C0.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 83,
    "L": 93.1099714919365,
    "a": 5.04813502954676,
    "b": 3.41012622464694,
    "C": 6.09201347212577,
    "h": 0.59410818239275,
    "CMY_C": 0.02715133,
    "CMY_M": 0.09033708,
    "CMY_Y": 0.1093314,
    "CMYK_C": 0,
    "CMYK_M": 0.06494922,
    "CMYK_Y": 0.08447362,
    "CMYK_K": 0.02715133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03499",
    "Farbtonhilfsbezeichnung": "C9.04.80",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "216",
    "Bcolor": "209",
    "Y": 70,
    "L": 87.1928376001742,
    "a": 4.21384905308164,
    "b": 4.36802656354027,
    "C": 6.06928166276294,
    "h": 0.80336171043448,
    "CMY_C": 0.09704875,
    "CMY_M": 0.1542291,
    "CMY_Y": 0.1814585,
    "CMYK_C": 0,
    "CMYK_M": 0.06332608,
    "CMYK_Y": 0.09348206,
    "CMYK_K": 0.09704875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03500",
    "Farbtonhilfsbezeichnung": "C2.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "227",
    "Bcolor": "221",
    "Y": 79,
    "L": 91.0517849275589,
    "a": 4.36070633395302,
    "b": 3.36593551775237,
    "C": 5.50865515717266,
    "h": 0.65735695089915,
    "CMY_C": 0.05575252,
    "CMY_M": 0.1115748,
    "CMY_Y": 0.1318121,
    "CMYK_C": 0,
    "CMYK_M": 0.0591183,
    "CMYK_Y": 0.08055048,
    "CMYK_K": 0.05575252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03501",
    "Farbtonhilfsbezeichnung": "DN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "234",
    "Bcolor": "227",
    "Y": 84,
    "L": 93.2437806526927,
    "a": 3.16262831830211,
    "b": 3.64539536917163,
    "C": 4.82608798897248,
    "h": 0.85619114496143,
    "CMY_C": 0.03930033,
    "CMY_M": 0.08425891,
    "CMY_Y": 0.1098774,
    "CMYK_C": 0,
    "CMYK_M": 0.04679776,
    "CMYK_Y": 0.07346426,
    "CMYK_K": 0.03930033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03502",
    "Farbtonhilfsbezeichnung": "CN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 82,
    "L": 92.3611739047238,
    "a": 2.86072424228279,
    "b": 3.76584779796572,
    "C": 4.72920213438035,
    "h": 0.92114811383825,
    "CMY_C": 0.05119238,
    "CMY_M": 0.09342027,
    "CMY_Y": 0.120566,
    "CMYK_C": 0,
    "CMYK_M": 0.04450627,
    "CMYK_Y": 0.07311666,
    "CMYK_K": 0.05119238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03503",
    "Farbtonhilfsbezeichnung": "CN.00.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "231",
    "Y": 81,
    "L": 92.7887268066406,
    "a": 0.74786168336868,
    "b": 0.71397560834885,
    "C": 1.0339527130127,
    "h": 43.6720962524414,
    "CMY_C": 0.07285124063492,
    "CMY_M": 0.08263427019119,
    "CMY_Y": 0.09346330165863,
    "CMYK_C": 0,
    "CMYK_M": 0.0105517366901,
    "CMYK_Y": 0.02223166450858,
    "CMYK_K": 0.07285124063492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03504",
    "Farbtonhilfsbezeichnung": "C6.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "222",
    "Bcolor": "213",
    "Y": 76,
    "L": 90.0003976441258,
    "a": 7.25046732359896,
    "b": 6.1413338115107,
    "C": 9.50185547116882,
    "h": 0.70276492609178,
    "CMY_C": 0.0377023,
    "CMY_M": 0.1312114,
    "CMY_Y": 0.1634278,
    "CMYK_C": 0,
    "CMYK_M": 0.09717274,
    "CMYK_Y": 0.1306514,
    "CMYK_K": 0.0377023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03505",
    "Farbtonhilfsbezeichnung": "C2.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "231",
    "Bcolor": "225",
    "Y": 84,
    "L": 93.2697447684616,
    "a": 6.42903319216004,
    "b": 4.78274841689452,
    "C": 8.01293642837646,
    "h": 0.63960475181385,
    "CMY_C": 0.01070799,
    "CMY_M": 0.09238933,
    "CMY_Y": 0.1175679,
    "CMYK_C": 0,
    "CMYK_M": 0.08256545,
    "CMYK_Y": 0.1080165,
    "CMYK_K": 0.01070799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03506",
    "Farbtonhilfsbezeichnung": "D0.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "226",
    "Bcolor": "218",
    "Y": 79,
    "L": 91.2177390108678,
    "a": 5.02814162662118,
    "b": 5.42074804135975,
    "C": 7.39369444494877,
    "h": 0.82295448013719,
    "CMY_C": 0.0425479,
    "CMY_M": 0.1119502,
    "CMY_Y": 0.1451011,
    "CMYK_C": 0,
    "CMYK_M": 0.0724864,
    "CMYK_Y": 0.1071105,
    "CMYK_K": 0.0425479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03507",
    "Farbtonhilfsbezeichnung": "D2.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "225",
    "Bcolor": "218",
    "Y": 77,
    "L": 90.5159887684752,
    "a": 4.35619858047481,
    "b": 4.58877169878398,
    "C": 6.3271867189211,
    "h": 0.81139274181052,
    "CMY_C": 0.05803785,
    "CMY_M": 0.1178632,
    "CMY_Y": 0.1467455,
    "CMYK_C": 0,
    "CMYK_M": 0.06351139,
    "CMYK_Y": 0.09417322,
    "CMYK_K": 0.05803785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03508",
    "Farbtonhilfsbezeichnung": "DN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 82,
    "L": 92.730973149933,
    "a": 3.01959007800146,
    "b": 3.12448044672342,
    "C": 4.3451469826833,
    "h": 0.80246830933808,
    "CMY_C": 0.04784569,
    "CMY_M": 0.08949622,
    "CMY_Y": 0.1116945,
    "CMYK_C": 0,
    "CMYK_M": 0.04374346,
    "CMYK_Y": 0.06705725,
    "CMYK_K": 0.04784569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03509",
    "Farbtonhilfsbezeichnung": "DN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 83,
    "L": 93.0485801470276,
    "a": 1.15543157100928,
    "b": 2.29862866975064,
    "C": 2.57268650960131,
    "h": 1.10502198123442,
    "CMY_C": 0.06142497,
    "CMY_M": 0.08118962,
    "CMY_Y": 0.1023083,
    "CMYK_C": 0,
    "CMYK_M": 0.02105814,
    "CMYK_Y": 0.04355897,
    "CMYK_K": 0.06142497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03510",
    "Farbtonhilfsbezeichnung": "D4.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 75,
    "L": 89.4075302579713,
    "a": 4.57624564231052,
    "b": 6.74661166190735,
    "C": 8.15222626620178,
    "h": 0.9747811365328,
    "CMY_C": 0.06239624,
    "CMY_M": 0.1312943,
    "CMY_Y": 0.1747726,
    "CMYK_C": 0,
    "CMYK_M": 0.07348315,
    "CMYK_Y": 0.1198548,
    "CMYK_K": 0.06239624
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03511",
    "Farbtonhilfsbezeichnung": "C9.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "223",
    "Bcolor": "215",
    "Y": 77,
    "L": 90.2586916361095,
    "a": 5.72022486797885,
    "b": 5.62452378038381,
    "C": 8.02223412126239,
    "h": 0.77696264661463,
    "CMY_C": 0.04760681,
    "CMY_M": 0.1243785,
    "CMY_Y": 0.1570168,
    "CMYK_C": 0,
    "CMYK_M": 0.08060926,
    "CMYK_Y": 0.114879,
    "CMYK_K": 0.04760681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03512",
    "Farbtonhilfsbezeichnung": "D9.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "222",
    "Bcolor": "213",
    "Y": 74,
    "L": 89.157708145942,
    "a": 3.18474100347987,
    "b": 5.148851229634,
    "C": 6.05419228668445,
    "h": 1.01686003258845,
    "CMY_C": 0.08041646,
    "CMY_M": 0.1302253,
    "CMY_Y": 0.1659237,
    "CMYK_C": 0,
    "CMYK_M": 0.05416451,
    "CMYK_Y": 0.09298474,
    "CMYK_K": 0.08041646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03513",
    "Farbtonhilfsbezeichnung": "D4.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 83,
    "L": 93.0059183511323,
    "a": 2.55365930599988,
    "b": 5.28461360856081,
    "C": 5.86926885079444,
    "h": 1.12065826161377,
    "CMY_C": 0.0415035,
    "CMY_M": 0.08588959,
    "CMY_Y": 0.1247894,
    "CMYK_C": 0,
    "CMYK_M": 0.04630803,
    "CMYK_Y": 0.08689219,
    "CMYK_K": 0.0415035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03514",
    "Farbtonhilfsbezeichnung": "DN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "236",
    "Bcolor": "227",
    "Y": 85,
    "L": 93.7807582795594,
    "a": 1.48701706642751,
    "b": 4.47901578370649,
    "C": 4.71940696979382,
    "h": 1.2502495045214,
    "CMY_C": 0.04351087,
    "CMY_M": 0.07440065,
    "CMY_Y": 0.1103925,
    "CMYK_C": 0,
    "CMYK_M": 0.03229496,
    "CMYK_Y": 0.06992411,
    "CMYK_K": 0.04351087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03515",
    "Farbtonhilfsbezeichnung": "E3.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "212",
    "Y": 81,
    "L": 91.9520628489826,
    "a": 3.50916337811513,
    "b": 9.55644646173195,
    "C": 10.1803681952203,
    "h": 1.21887814514055,
    "CMY_C": 0.0334237,
    "CMY_M": 0.1011467,
    "CMY_Y": 0.1679699,
    "CMYK_C": 0,
    "CMYK_M": 0.07006487,
    "CMYK_Y": 0.1391987,
    "CMYK_K": 0.0334237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03516",
    "Farbtonhilfsbezeichnung": "E0.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "221",
    "Y": 84,
    "L": 93.0184631347656,
    "a": 3.91033744812012,
    "b": 6.50172662734985,
    "C": 7.58704090118408,
    "h": 58.9760131835938,
    "CMY_C": 0.02731102705002,
    "CMY_M": 0.08937114477158,
    "CMY_Y": 0.13350307941437,
    "CMYK_C": 0,
    "CMYK_M": 0.06380262970924,
    "CMYK_Y": 0.10917370021343,
    "CMYK_K": 0.02731102705002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03517",
    "Farbtonhilfsbezeichnung": "E2.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "229",
    "Bcolor": "217",
    "Y": 80,
    "L": 91.6641870329374,
    "a": 3.31559461949266,
    "b": 6.54044301098722,
    "C": 7.33284136339933,
    "h": 1.10161428004117,
    "CMY_C": 0.04701328,
    "CMY_M": 0.1030727,
    "CMY_Y": 0.1487589,
    "CMYK_C": 0,
    "CMYK_M": 0.05882501,
    "CMYK_Y": 0.106765,
    "CMYK_K": 0.04701328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03518",
    "Farbtonhilfsbezeichnung": "F2.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "212",
    "Y": 82,
    "L": 92.5477378827826,
    "a": 1.98299325071738,
    "b": 10.421223174679,
    "C": 10.6082116630871,
    "h": 1.38276017675497,
    "CMY_C": 0.03559879,
    "CMY_M": 0.09100072,
    "CMY_Y": 0.1681339,
    "CMYK_C": 0,
    "CMYK_M": 0.05744698,
    "CMYK_Y": 0.1374274,
    "CMYK_K": 0.03559879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03519",
    "Farbtonhilfsbezeichnung": "F2.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "214",
    "Y": 82,
    "L": 92.4759900238468,
    "a": 1.85383895432722,
    "b": 9.10081806723768,
    "C": 9.28771276265265,
    "h": 1.36984537511417,
    "CMY_C": 0.0412403,
    "CMY_M": 0.09114248,
    "CMY_Y": 0.1591099,
    "CMYK_C": 0,
    "CMYK_M": 0.05204868,
    "CMYK_Y": 0.1229397,
    "CMYK_K": 0.0412403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03520",
    "Farbtonhilfsbezeichnung": "D7.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "216",
    "Y": 81,
    "L": 92.0525138720055,
    "a": 3.69073193119951,
    "b": 7.8692123580675,
    "C": 8.69172050426945,
    "h": 1.13224739203038,
    "CMY_C": 0.03584127,
    "CMY_M": 0.1000229,
    "CMY_Y": 0.1543085,
    "CMYK_C": 0,
    "CMYK_M": 0.06656751,
    "CMYK_Y": 0.1228711,
    "CMYK_K": 0.03584127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03521",
    "Farbtonhilfsbezeichnung": "E9.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "228",
    "Bcolor": "215",
    "Y": 79,
    "L": 91.2292958917452,
    "a": 2.0835544792332,
    "b": 7.19648139570961,
    "C": 7.49203201719849,
    "h": 1.28897798335098,
    "CMY_C": 0.05925251,
    "CMY_M": 0.1050977,
    "CMY_Y": 0.1585747,
    "CMYK_C": 0,
    "CMYK_M": 0.04873273,
    "CMYK_Y": 0.105578,
    "CMYK_K": 0.05925251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03522",
    "Farbtonhilfsbezeichnung": "E1.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 80,
    "L": 91.8702737619848,
    "a": 1.40255526678673,
    "b": 2.96528251218571,
    "C": 3.28025329105323,
    "h": 1.12898751324232,
    "CMY_C": 0.0705393,
    "CMY_M": 0.09514382,
    "CMY_Y": 0.1202513,
    "CMYK_C": 0,
    "CMYK_M": 0.02647183,
    "CMYK_Y": 0.05348481,
    "CMYK_K": 0.0705393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03523",
    "Farbtonhilfsbezeichnung": "EN.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "224",
    "Y": 82,
    "L": 92.6614033514467,
    "a": 1.21169086506812,
    "b": 4.18723713260472,
    "C": 4.35903080479518,
    "h": 1.28911350652058,
    "CMY_C": 0.05918624,
    "CMY_M": 0.08618712,
    "CMY_Y": 0.1206248,
    "CMYK_C": 0,
    "CMYK_M": 0.02869949,
    "CMYK_Y": 0.06530359,
    "CMYK_K": 0.05918624
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03524",
    "Farbtonhilfsbezeichnung": "EN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "229",
    "Bcolor": "220",
    "Y": 79,
    "L": 91.1542716656229,
    "a": 1.04970395618431,
    "b": 4.193198626173,
    "C": 4.32259101861003,
    "h": 1.32550248909301,
    "CMY_C": 0.07733782,
    "CMY_M": 0.1026241,
    "CMY_Y": 0.1372918,
    "CMYK_C": 0,
    "CMYK_M": 0.02740578,
    "CMYK_Y": 0.06497932,
    "CMYK_K": 0.07733782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03525",
    "Farbtonhilfsbezeichnung": "F0.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "223",
    "Bcolor": "209",
    "Y": 75,
    "L": 89.281762007164,
    "a": 1.99372834565775,
    "b": 7.09482283054612,
    "C": 7.36963117890697,
    "h": 1.29684970545681,
    "CMY_C": 0.08211209,
    "CMY_M": 0.1264966,
    "CMY_Y": 0.179102,
    "CMYK_C": 0,
    "CMYK_M": 0.04835506,
    "CMYK_Y": 0.1056664,
    "CMYK_K": 0.08211209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03526",
    "Farbtonhilfsbezeichnung": "F4.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "215",
    "Y": 82,
    "L": 92.5546390757137,
    "a": 1.57255309925808,
    "b": 8.64745457659854,
    "C": 8.78927721171208,
    "h": 1.39091051773076,
    "CMY_C": 0.04382537,
    "CMY_M": 0.08946259,
    "CMY_Y": 0.1549183,
    "CMYK_C": 0,
    "CMYK_M": 0.04772896,
    "CMYK_Y": 0.1161847,
    "CMYK_K": 0.04382537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03527",
    "Farbtonhilfsbezeichnung": "F3.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "218",
    "Y": 82,
    "L": 92.7468884458765,
    "a": 1.3893293675159,
    "b": 7.71193085372228,
    "C": 7.83607769129657,
    "h": 1.39255495697212,
    "CMY_C": 0.04586164,
    "CMY_M": 0.08662143,
    "CMY_Y": 0.1458757,
    "CMYK_C": 0,
    "CMYK_M": 0.04271894,
    "CMYK_Y": 0.1048213,
    "CMYK_K": 0.04586164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03528",
    "Farbtonhilfsbezeichnung": "FN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "228",
    "Y": 81,
    "L": 93.0038833618164,
    "a": 0.5495463013649,
    "b": 2.58098077774048,
    "C": 2.6388373374939,
    "h": 77.9799957275391,
    "CMY_C": 0.0657274723053,
    "CMY_M": 0.08028197288513,
    "CMY_Y": 0.1049896478653,
    "CMYK_C": 0,
    "CMYK_M": 0.0155784310773,
    "CMYK_Y": 0.0420243293047,
    "CMYK_K": 0.0657274723053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03529",
    "Farbtonhilfsbezeichnung": "F3.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "240",
    "Bcolor": "229",
    "Y": 88,
    "L": 94.9414367675781,
    "a": 0.70040214061737,
    "b": 5.11222219467163,
    "C": 5.15997838973999,
    "h": 82.1987380981445,
    "CMY_C": 0.0344762802124,
    "CMY_M": 0.0596114397049,
    "CMY_Y": 0.10238867998123,
    "CMYK_C": 0,
    "CMYK_M": 0.02603266946971,
    "CMYK_Y": 0.07033737003803,
    "CMYK_K": 0.0344762802124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03530",
    "Farbtonhilfsbezeichnung": "F4.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "211",
    "Y": 81,
    "L": 92.2768252506742,
    "a": 1.72275045307307,
    "b": 10.5064679207465,
    "C": 10.6467712144687,
    "h": 1.40827212009074,
    "CMY_C": 0.04037325,
    "CMY_M": 0.09341717,
    "CMY_Y": 0.1717678,
    "CMYK_C": 0,
    "CMYK_M": 0.05527557,
    "CMYK_Y": 0.1369226,
    "CMYK_K": 0.04037325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03531",
    "Farbtonhilfsbezeichnung": "F6.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "235",
    "Bcolor": "213",
    "Y": 84,
    "L": 93.6208288503916,
    "a": 1.31108976382666,
    "b": 11.4175663598054,
    "C": 11.4925966582566,
    "h": 1.45646616642766,
    "CMY_C": 0.02561275,
    "CMY_M": 0.07762618,
    "CMY_Y": 0.1639404,
    "CMYK_C": 0,
    "CMYK_M": 0.05338065,
    "CMYK_Y": 0.1419637,
    "CMYK_K": 0.02561275
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03532",
    "Farbtonhilfsbezeichnung": "F7.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "217",
    "Y": 83,
    "L": 92.8108606492939,
    "a": 0.72007622280662,
    "b": 8.24312695984966,
    "C": 8.27451822421413,
    "h": 1.48366277070895,
    "CMY_C": 0.04863697,
    "CMY_M": 0.08443484,
    "CMY_Y": 0.14923,
    "CMYK_C": 0,
    "CMYK_M": 0.03762799,
    "CMYK_Y": 0.1057357,
    "CMYK_K": 0.04863697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03533",
    "Farbtonhilfsbezeichnung": "F9.04.88",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "224",
    "Y": 87,
    "L": 94.9328628382387,
    "a": 0.1819858086447,
    "b": 7.47180099216984,
    "C": 7.47401691870833,
    "h": 1.54644479025814,
    "CMY_C": 0.03116713,
    "CMY_M": 0.05913706,
    "CMY_Y": 0.1202066,
    "CMYK_C": 0,
    "CMYK_M": 0.02886972,
    "CMYK_Y": 0.09190384,
    "CMYK_K": 0.03116713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03534",
    "Farbtonhilfsbezeichnung": "F2.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "235",
    "Bcolor": "219",
    "Y": 85,
    "L": 93.6189498901367,
    "a": 2.0867908000946,
    "b": 8.43388175964355,
    "C": 8.68821334838867,
    "h": 76.1024627685547,
    "CMY_C": 0.02850925922394,
    "CMY_M": 0.07871103286743,
    "CMY_Y": 0.14157128334045,
    "CMYK_C": 0,
    "CMYK_M": 0.05167498812079,
    "CMYK_Y": 0.1163799315691,
    "CMYK_K": 0.02850925922394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03535",
    "Farbtonhilfsbezeichnung": "F9.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "236",
    "Bcolor": "222",
    "Y": 85,
    "L": 93.679297274707,
    "a": 0.13252356744791,
    "b": 6.9292970655749,
    "C": 6.93056421360585,
    "h": 1.55167354824584,
    "CMY_C": 0.04739909,
    "CMY_M": 0.07294708,
    "CMY_Y": 0.1299823,
    "CMYK_C": 0,
    "CMYK_M": 0.02681919,
    "CMYK_Y": 0.08669233,
    "CMYK_K": 0.04739909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03536",
    "Farbtonhilfsbezeichnung": "F5.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 86,
    "L": 94.1559870424547,
    "a": 0.21771021180461,
    "b": 4.78733069215602,
    "C": 4.79227846565525,
    "h": 1.52535131163713,
    "CMY_C": 0.04816237,
    "CMY_M": 0.06721867,
    "CMY_Y": 0.1087279,
    "CMYK_C": 0,
    "CMYK_M": 0.02002054,
    "CMYK_Y": 0.06363008,
    "CMYK_K": 0.04816237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03537",
    "Farbtonhilfsbezeichnung": "G2.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "235",
    "Bcolor": "214",
    "Y": 84,
    "L": 93.3759486635988,
    "a": -0.23094857022076,
    "b": 10.7879141033184,
    "C": 10.7903859033244,
    "h": -1.54939151248154,
    "CMY_C": 0.04190089,
    "CMY_M": 0.07649498,
    "CMY_Y": 0.1621599,
    "CMYK_C": 0,
    "CMYK_M": 0.03610701,
    "CMYK_Y": 0.1255184,
    "CMYK_K": 0.04190089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03538",
    "Farbtonhilfsbezeichnung": "F7.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "222",
    "Y": 84,
    "L": 93.3494186852063,
    "a": 0.36030637536632,
    "b": 6.30846378977008,
    "C": 6.31874481768095,
    "h": 1.51374355328207,
    "CMY_C": 0.05130002,
    "CMY_M": 0.07702243,
    "CMY_Y": 0.1289532,
    "CMYK_C": 0,
    "CMYK_M": 0.02711333,
    "CMYK_Y": 0.08185222,
    "CMYK_K": 0.05130002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03539",
    "Farbtonhilfsbezeichnung": "GN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "239",
    "Bcolor": "231",
    "Y": 86,
    "L": 94.2144851109897,
    "a": -0.6587504971009,
    "b": 3.04462454307721,
    "C": 3.11507477048927,
    "h": -1.35771574612805,
    "CMY_C": 0.06012426,
    "CMY_M": 0.06398164,
    "CMY_Y": 0.09520237,
    "CMYK_C": 0,
    "CMYK_M": 0.004104146,
    "CMYK_Y": 0.03732207,
    "CMYK_K": 0.06012426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03540",
    "Farbtonhilfsbezeichnung": "GN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "231",
    "Y": 85,
    "L": 94.0630684235391,
    "a": -0.17107942823224,
    "b": 2.42261923422453,
    "C": 2.4286523268675,
    "h": -1.50029581565265,
    "CMY_C": 0.0600513,
    "CMY_M": 0.0666702,
    "CMY_Y": 0.09217272,
    "CMYK_C": 0,
    "CMYK_M": 0.007041768,
    "CMYK_Y": 0.03417359,
    "CMYK_K": 0.0600513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03541",
    "Farbtonhilfsbezeichnung": "GN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "242",
    "Bcolor": "238",
    "Y": 89,
    "L": 95.5378491777994,
    "a": -0.35790321222528,
    "b": 1.34569503177264,
    "C": 1.3924761498348,
    "h": -1.31085230190803,
    "CMY_C": 0.04860426,
    "CMY_M": 0.04933053,
    "CMY_Y": 0.06774466,
    "CMYK_C": 0,
    "CMYK_M": 0.0007633623,
    "CMYK_Y": 0.02011822,
    "CMYK_K": 0.04860426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03542",
    "Farbtonhilfsbezeichnung": "G5.07.88",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "216",
    "Y": 87,
    "L": 94.9008253445896,
    "a": -1.29906536502389,
    "b": 11.6696112055513,
    "C": 11.7416947887149,
    "h": -1.45993240952586,
    "CMY_C": 0.03020475,
    "CMY_M": 0.05705523,
    "CMY_Y": 0.1522207,
    "CMYK_C": 0,
    "CMYK_M": 0.02768675,
    "CMYK_Y": 0.1258162,
    "CMYK_K": 0.03020475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03543",
    "Farbtonhilfsbezeichnung": "G4.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "235",
    "Bcolor": "213",
    "Y": 83,
    "L": 92.898534857717,
    "a": -1.18894714599477,
    "b": 10.5435100542292,
    "C": 10.610334564923,
    "h": -1.45850491285089,
    "CMY_C": 0.05533344,
    "CMY_M": 0.07949717,
    "CMY_Y": 0.1657064,
    "CMYK_C": 0,
    "CMYK_M": 0.02557911,
    "CMYK_Y": 0.116838,
    "CMYK_K": 0.05533344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03544",
    "Farbtonhilfsbezeichnung": "G2.07.89",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "240",
    "Bcolor": "217",
    "Y": 88,
    "L": 94.9163055419922,
    "a": -0.31526321172714,
    "b": 11.3880348205566,
    "C": 11.3923978805542,
    "h": 91.5857543945312,
    "CMY_C": 0.02331829071045,
    "CMY_M": 0.05912500619888,
    "CMY_Y": 0.14978522062302,
    "CMYK_C": 0,
    "CMYK_M": 0.03666160255671,
    "CMYK_Y": 0.12948632240295,
    "CMYK_K": 0.02331829071045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03545",
    "Farbtonhilfsbezeichnung": "G4.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "238",
    "Bcolor": "221",
    "Y": 85,
    "L": 93.9258182293665,
    "a": -0.75075959037601,
    "b": 7.64235853652335,
    "C": 7.67914604388489,
    "h": -1.47287388278618,
    "CMY_C": 0.04923384,
    "CMY_M": 0.0682623,
    "CMY_Y": 0.1327219,
    "CMYK_C": 0,
    "CMYK_M": 0.02001381,
    "CMYK_Y": 0.08781131,
    "CMYK_K": 0.04923384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03546",
    "Farbtonhilfsbezeichnung": "G4.03.89",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "243",
    "Bcolor": "231",
    "Y": 89,
    "L": 95.6890556433026,
    "a": -0.52646703394915,
    "b": 5.3447230436596,
    "C": 5.37058953479608,
    "h": -1.47261085313378,
    "CMY_C": 0.03488965,
    "CMY_M": 0.04834661,
    "CMY_Y": 0.09602284,
    "CMYK_C": 0,
    "CMYK_M": 0.01394344,
    "CMYK_Y": 0.06334321,
    "CMYK_K": 0.03488965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03547",
    "Farbtonhilfsbezeichnung": "G2.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "220",
    "Y": 83,
    "L": 92.9081603243077,
    "a": -0.51382960085466,
    "b": 6.93372143658588,
    "C": 6.95273426925588,
    "h": -1.49682564650616,
    "CMY_C": 0.06107109,
    "CMY_M": 0.08004419,
    "CMY_Y": 0.1385968,
    "CMYK_C": 0,
    "CMYK_M": 0.02020718,
    "CMYK_Y": 0.08256825,
    "CMYK_K": 0.06107109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03550",
    "Farbtonhilfsbezeichnung": "G4.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "234",
    "Bcolor": "220",
    "Y": 83,
    "L": 92.8919084611193,
    "a": -0.3988522647132,
    "b": 6.82617723650865,
    "C": 6.8378197397486,
    "h": -1.51243287111309,
    "CMY_C": 0.06070041,
    "CMY_M": 0.08047108,
    "CMY_Y": 0.1379575,
    "CMYK_C": 0,
    "CMYK_M": 0.02104832,
    "CMYK_Y": 0.08224967,
    "CMYK_K": 0.06070041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03551",
    "Farbtonhilfsbezeichnung": "G9.06.88",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "243",
    "Bcolor": "221",
    "Y": 89,
    "L": 95.6410991562304,
    "a": -2.19746916972696,
    "b": 10.0468106970027,
    "C": 10.2843218509199,
    "h": -1.35546433786043,
    "CMY_C": 0.03366097,
    "CMY_M": 0.04616705,
    "CMY_Y": 0.1320549,
    "CMYK_C": 0,
    "CMYK_M": 0.01294172,
    "CMYK_Y": 0.1018213,
    "CMYK_K": 0.03366097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03552",
    "Farbtonhilfsbezeichnung": "G7.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "230",
    "Bcolor": "211",
    "Y": 79,
    "L": 91.1110628233322,
    "a": -1.95711539128329,
    "b": 9.06665605608561,
    "C": 9.27548126482674,
    "h": -1.3581996776998,
    "CMY_C": 0.08578023,
    "CMY_M": 0.09728029,
    "CMY_Y": 0.1743535,
    "CMYK_C": 0,
    "CMYK_M": 0.0125791,
    "CMYK_Y": 0.09688397,
    "CMYK_K": 0.08578023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03553",
    "Farbtonhilfsbezeichnung": "G7.05.89",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "241",
    "Bcolor": "223",
    "Y": 88,
    "L": 95.1630800460607,
    "a": -1.36260890423817,
    "b": 8.45330735473302,
    "C": 8.5624242045984,
    "h": -1.41097864442504,
    "CMY_C": 0.03749591,
    "CMY_M": 0.05311468,
    "CMY_Y": 0.1252479,
    "CMYK_C": 0,
    "CMYK_M": 0.01622722,
    "CMYK_Y": 0.09117054,
    "CMYK_K": 0.03749591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03554",
    "Farbtonhilfsbezeichnung": "H1.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "238",
    "Bcolor": "225",
    "Y": 85,
    "L": 93.757933310804,
    "a": -1.45114550739439,
    "b": 5.4893218758161,
    "C": 5.67789379435228,
    "h": -1.31235067530175,
    "CMY_C": 0.06344625,
    "CMY_M": 0.06790248,
    "CMY_Y": 0.1186086,
    "CMYK_C": 0,
    "CMYK_M": 0.004758124,
    "CMYK_Y": 0.05889926,
    "CMYK_K": 0.06344625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03555",
    "Farbtonhilfsbezeichnung": "HN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "239",
    "Bcolor": "226",
    "Y": 85,
    "L": 94.0047956127191,
    "a": -1.88039107961524,
    "b": 5.03539024995197,
    "C": 5.37503726327622,
    "h": -1.21339839557252,
    "CMY_C": 0.06554265,
    "CMY_M": 0.06399202,
    "CMY_Y": 0.1125572,
    "CMYK_C": 0.001656631,
    "CMYK_M": 0,
    "CMYK_Y": 0.05188544,
    "CMYK_K": 0.06399202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03556",
    "Farbtonhilfsbezeichnung": "HN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 81,
    "L": 92.0427547760531,
    "a": -1.98829574775311,
    "b": 4.05285654916057,
    "C": 4.51430683367965,
    "h": -1.11470405122644,
    "CMY_C": 0.09161559,
    "CMY_M": 0.08546072,
    "CMY_Y": 0.1269098,
    "CMYK_C": 0.006730017,
    "CMYK_M": 0,
    "CMYK_Y": 0.04532233,
    "CMYK_K": 0.08546072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03557",
    "Farbtonhilfsbezeichnung": "H6.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "237",
    "Bcolor": "217",
    "Y": 83,
    "L": 93.0167764704506,
    "a": -4.02728221301102,
    "b": 8.48882657239041,
    "C": 9.39570000581949,
    "h": -1.12782006398707,
    "CMY_C": 0.08239634,
    "CMY_M": 0.07098194,
    "CMY_Y": 0.1495193,
    "CMYK_C": 0.01228652,
    "CMYK_M": 0,
    "CMYK_Y": 0.08453804,
    "CMYK_K": 0.07098194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03558",
    "Farbtonhilfsbezeichnung": "H5.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "242",
    "Bcolor": "222",
    "Y": 87,
    "L": 94.754177417453,
    "a": -3.41508292516829,
    "b": 8.49113820636982,
    "C": 9.15217020304197,
    "h": -1.18840019655409,
    "CMY_C": 0.05806386,
    "CMY_M": 0.05288442,
    "CMY_Y": 0.1303478,
    "CMYK_C": 0.005468647,
    "CMYK_M": 0,
    "CMYK_Y": 0.0817887,
    "CMYK_K": 0.05288442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03559",
    "Farbtonhilfsbezeichnung": "JN.02.89",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "245",
    "Bcolor": "234",
    "Y": 90,
    "L": 95.9476278379902,
    "a": -2.78449432553191,
    "b": 3.6438433107272,
    "C": 4.5859571216978,
    "h": -0.91829163799634,
    "CMY_C": 0.05558369,
    "CMY_M": 0.03959914,
    "CMY_Y": 0.08073413,
    "CMYK_C": 0.01664362,
    "CMYK_M": 0,
    "CMYK_Y": 0.04283106,
    "CMYK_K": 0.03959914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03560",
    "Farbtonhilfsbezeichnung": "H0.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "237",
    "Bcolor": "221",
    "Y": 84,
    "L": 93.410421450256,
    "a": -1.71742669211866,
    "b": 6.88094963978492,
    "C": 7.0920393673511,
    "h": -1.32620215066061,
    "CMY_C": 0.06496289,
    "CMY_M": 0.07154788,
    "CMY_Y": 0.1328579,
    "CMYK_C": 0,
    "CMYK_M": 0.007042492,
    "CMYK_Y": 0.07261214,
    "CMYK_K": 0.06496289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03561",
    "Farbtonhilfsbezeichnung": "JN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "241",
    "Bcolor": "234",
    "Y": 87,
    "L": 94.9281158447266,
    "a": -1.08659613132477,
    "b": 2.61698317527771,
    "C": 2.83360052108765,
    "h": 112.548683166504,
    "CMY_C": 0.05692929029465,
    "CMY_M": 0.05478805303574,
    "CMY_Y": 0.08414435386658,
    "CMYK_C": 0.0022653513588,
    "CMYK_M": 0,
    "CMYK_Y": 0.03105790354311,
    "CMYK_K": 0.05478805303574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03562",
    "Farbtonhilfsbezeichnung": "HN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 85,
    "L": 93.8224341386689,
    "a": -0.89617125969687,
    "b": 1.8537607724441,
    "C": 2.05901722386172,
    "h": -1.12048901051418,
    "CMY_C": 0.07043827,
    "CMY_M": 0.06748372,
    "CMY_Y": 0.09070531,
    "CMYK_C": 0.003168353,
    "CMYK_M": 0,
    "CMYK_Y": 0.02490208,
    "CMYK_K": 0.06748372
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03563",
    "Farbtonhilfsbezeichnung": "K7.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "240",
    "Bcolor": "221",
    "Y": 85,
    "L": 93.2154769897461,
    "a": -7.41556596755981,
    "b": 6.48303174972534,
    "C": 9.84988975524902,
    "h": 138.83854675293,
    "CMY_C": 0.1139652132988,
    "CMY_M": 0.06043833494186,
    "CMY_Y": 0.13286930322647,
    "CMYK_C": 0.05697005242109,
    "CMYK_M": 0,
    "CMYK_Y": 0.07709016650915,
    "CMYK_K": 0.06043833494186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03564",
    "Farbtonhilfsbezeichnung": "K3.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "241",
    "Bcolor": "229",
    "Y": 86,
    "L": 94.107995243362,
    "a": -4.52981058615593,
    "b": 3.78488310065515,
    "C": 5.90292504035713,
    "h": -0.69604503007928,
    "CMY_C": 0.08982355,
    "CMY_M": 0.0562981,
    "CMY_Y": 0.1024605,
    "CMYK_C": 0.03552547,
    "CMYK_M": 0,
    "CMYK_Y": 0.04891632,
    "CMYK_K": 0.0562981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03565",
    "Farbtonhilfsbezeichnung": "K5.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "240",
    "Bcolor": "226",
    "Y": 84,
    "L": 93.4652065165122,
    "a": -6.06128553160534,
    "b": 4.18383375144948,
    "C": 7.36502865951085,
    "h": -0.60415583386468,
    "CMY_C": 0.1080813,
    "CMY_M": 0.0601177,
    "CMY_Y": 0.1127673,
    "CMYK_C": 0.05103148,
    "CMYK_M": 0,
    "CMYK_Y": 0.05601727,
    "CMYK_K": 0.0601177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03566",
    "Farbtonhilfsbezeichnung": "J7.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "236",
    "Bcolor": "224",
    "Y": 83,
    "L": 92.8029718167395,
    "a": -3.64706458955988,
    "b": 4.45147249169628,
    "C": 5.7547100243844,
    "h": -0.88440098633508,
    "CMY_C": 0.09500136,
    "CMY_M": 0.07318498,
    "CMY_Y": 0.1217305,
    "CMYK_C": 0.02353908,
    "CMYK_M": 0,
    "CMYK_Y": 0.05237882,
    "CMYK_K": 0.07318498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03567",
    "Farbtonhilfsbezeichnung": "J9.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "237",
    "Bcolor": "227",
    "Y": 83,
    "L": 93.2021817864218,
    "a": -3.40923444890218,
    "b": 3.52541392931791,
    "C": 4.90422500509612,
    "h": -0.80215007440941,
    "CMY_C": 0.09178294,
    "CMY_M": 0.06900557,
    "CMY_Y": 0.1103906,
    "CMYK_C": 0.02446564,
    "CMYK_M": 0,
    "CMYK_Y": 0.04445253,
    "CMYK_K": 0.06900557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03568",
    "Farbtonhilfsbezeichnung": "J1.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "221",
    "Y": 82,
    "L": 92.4715938812085,
    "a": -3.2566757215759,
    "b": 5.48263378197926,
    "C": 6.37692793928253,
    "h": -1.03480145059616,
    "CMY_C": 0.09214365,
    "CMY_M": 0.07808596,
    "CMY_Y": 0.1330004,
    "CMYK_C": 0.01524837,
    "CMYK_M": 0,
    "CMYK_Y": 0.05956566,
    "CMYK_K": 0.07808596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03569",
    "Farbtonhilfsbezeichnung": "KN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "243",
    "Bcolor": "232",
    "Y": 88,
    "L": 95.1669782311112,
    "a": -3.33149617680445,
    "b": 3.52777248300249,
    "C": 4.85222067386596,
    "h": -0.81400511431359,
    "CMY_C": 0.06915829,
    "CMY_M": 0.04708891,
    "CMY_Y": 0.08862162,
    "CMYK_C": 0.02315996,
    "CMYK_M": 0,
    "CMYK_Y": 0.04358509,
    "CMYK_K": 0.04708891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03570",
    "Farbtonhilfsbezeichnung": "L4.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "234",
    "Bcolor": "221",
    "Y": 79,
    "L": 91.1542519743039,
    "a": -7.81697615139715,
    "b": 3.38433569224481,
    "C": 8.51814793422337,
    "h": -0.40858245243488,
    "CMY_C": 0.1509946,
    "CMY_M": 0.08186296,
    "CMY_Y": 0.1325518,
    "CMYK_C": 0.07529561,
    "CMYK_M": 0,
    "CMYK_Y": 0.05520836,
    "CMYK_K": 0.08186296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03572",
    "Farbtonhilfsbezeichnung": "M3.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "236",
    "Bcolor": "230",
    "Y": 81,
    "L": 92.4417495727539,
    "a": -4.62025690078735,
    "b": 0.85992187261581,
    "C": 4.6995997428894,
    "h": 169.456741333008,
    "CMY_C": 0.11944776773453,
    "CMY_M": 0.07396441698074,
    "CMY_Y": 0.0991393327713,
    "CMYK_C": 0.04911620169878,
    "CMYK_M": 0,
    "CMYK_Y": 0.02718568965793,
    "CMYK_K": 0.07396441698074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03573",
    "Farbtonhilfsbezeichnung": "L2.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "240",
    "Bcolor": "230",
    "Y": 85,
    "L": 93.8940200805664,
    "a": -4.64837598800659,
    "b": 2.7802267074585,
    "C": 5.41636943817139,
    "h": 149.116058349609,
    "CMY_C": 0.09666693210602,
    "CMY_M": 0.0581259727478,
    "CMY_Y": 0.09734845161438,
    "CMYK_C": 0.04091944172978,
    "CMYK_M": 0,
    "CMYK_Y": 0.04164301976562,
    "CMYK_K": 0.0581259727478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03574",
    "Farbtonhilfsbezeichnung": "JN.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "236",
    "Bcolor": "228",
    "Y": 83,
    "L": 92.923989464442,
    "a": -2.35936799124992,
    "b": 2.53840565447563,
    "C": 3.46556208785942,
    "h": -0.82193680176976,
    "CMY_C": 0.0898433,
    "CMY_M": 0.07430361,
    "CMY_Y": 0.1059703,
    "CMYK_C": 0.01678702,
    "CMYK_M": 0,
    "CMYK_Y": 0.03420851,
    "CMYK_K": 0.07430361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03575",
    "Farbtonhilfsbezeichnung": "KN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "227",
    "Y": 82,
    "L": 92.7125258372226,
    "a": -2.47687258401713,
    "b": 2.91213626780604,
    "C": 3.8230139209434,
    "h": -0.86599199585232,
    "CMY_C": 0.09186739,
    "CMY_M": 0.07650261,
    "CMY_Y": 0.1111068,
    "CMYK_C": 0.01663759,
    "CMYK_M": 0,
    "CMYK_Y": 0.03747081,
    "CMYK_K": 0.07650261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03576",
    "Farbtonhilfsbezeichnung": "M9.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "230",
    "Bcolor": "225",
    "Y": 77,
    "L": 90.2606358563237,
    "a": -4.87564702897725,
    "b": 0.02928129488497,
    "C": 4.87573495438429,
    "h": -0.00600555017297,
    "CMY_C": 0.1487311,
    "CMY_M": 0.0975684,
    "CMY_Y": 0.1171414,
    "CMYK_C": 0.05669432,
    "CMYK_M": 0,
    "CMYK_Y": 0.02168917,
    "CMYK_K": 0.0975684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03577",
    "Farbtonhilfsbezeichnung": "M6.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "235",
    "Bcolor": "229",
    "Y": 81,
    "L": 91.9342299609778,
    "a": -5.5425240992904,
    "b": 0.58544841300904,
    "C": 5.57335834443737,
    "h": -0.10523824658822,
    "CMY_C": 0.1336954,
    "CMY_M": 0.07749109,
    "CMY_Y": 0.1028485,
    "CMYK_C": 0.06092547,
    "CMYK_M": 0,
    "CMYK_Y": 0.02748743,
    "CMYK_K": 0.07749109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03578",
    "Farbtonhilfsbezeichnung": "MN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "237",
    "Bcolor": "230",
    "Y": 82,
    "L": 92.7767053199414,
    "a": -3.8071593344568,
    "b": 1.18183045840192,
    "C": 3.98637497362554,
    "h": -0.30099169000262,
    "CMY_C": 0.1079278,
    "CMY_M": 0.07220174,
    "CMY_Y": 0.09770935,
    "CMYK_C": 0.03850629,
    "CMYK_M": 0,
    "CMYK_Y": 0.02749262,
    "CMYK_K": 0.07220174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03579",
    "Farbtonhilfsbezeichnung": "MN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "243",
    "Bcolor": "238",
    "Y": 87,
    "L": 95.1859512329102,
    "a": -3.72734642028809,
    "b": 0.76810157299042,
    "C": 3.80566573143005,
    "h": 168.355941772461,
    "CMY_C": 0.08185482025146,
    "CMY_M": 0.04514634609222,
    "CMY_Y": 0.06781935691833,
    "CMYK_C": 0.038444083184,
    "CMYK_M": 0,
    "CMYK_Y": 0.02374501153827,
    "CMYK_K": 0.04514634609222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03580",
    "Farbtonhilfsbezeichnung": "NN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 80,
    "L": 91.812260458456,
    "a": -3.76198575328318,
    "b": 0.19292896210922,
    "C": 3.76692957092725,
    "h": -0.05123892137963,
    "CMY_C": 0.1218248,
    "CMY_M": 0.08283158,
    "CMY_Y": 0.1010426,
    "CMYK_C": 0.04251476,
    "CMYK_M": 0,
    "CMYK_Y": 0.01985572,
    "CMYK_K": 0.08283158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03581",
    "Farbtonhilfsbezeichnung": "NN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "237",
    "Bcolor": "232",
    "Y": 83,
    "L": 93.0361383987549,
    "a": -2.60077802643505,
    "b": 0.49171503846436,
    "C": 2.64685285232092,
    "h": -0.18685897628488,
    "CMY_C": 0.09768104,
    "CMY_M": 0.07190315,
    "CMY_Y": 0.08952917,
    "CMYK_C": 0.027775,
    "CMYK_M": 0,
    "CMYK_Y": 0.01899157,
    "CMYK_K": 0.07190315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03582",
    "Farbtonhilfsbezeichnung": "MN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "229",
    "Y": 82,
    "L": 93.0069122314453,
    "a": -1.51622974872589,
    "b": 1.96427893638611,
    "C": 2.48139977455139,
    "h": 127.664596557617,
    "CMY_C": 0.08412647247314,
    "CMY_M": 0.07516479492188,
    "CMY_Y": 0.10066038370132,
    "CMYK_C": 0.00969002675265,
    "CMYK_M": 0,
    "CMYK_Y": 0.02756771072745,
    "CMYK_K": 0.07516479492188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03583",
    "Farbtonhilfsbezeichnung": "N9.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "231",
    "Bcolor": "227",
    "Y": 76,
    "L": 89.9762191772461,
    "a": -6.92970609664917,
    "b": -1.36895596981049,
    "C": 7.06363010406494,
    "h": 191.174835205078,
    "CMY_C": 0.17422413825989,
    "CMY_M": 0.09567940235138,
    "CMY_Y": 0.11021608114243,
    "CMYK_C": 0.08685496449471,
    "CMYK_M": 0,
    "CMYK_Y": 0.01607469655573,
    "CMYK_K": 0.09567940235138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03584",
    "Farbtonhilfsbezeichnung": "NN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "229",
    "Bcolor": "225",
    "Y": 77,
    "L": 90.3487752238352,
    "a": -3.21871097068255,
    "b": 0.15049730325644,
    "C": 3.22222745179164,
    "h": -0.04672298163984,
    "CMY_C": 0.1337708,
    "CMY_M": 0.1004231,
    "CMY_Y": 0.1168404,
    "CMYK_C": 0.03707043,
    "CMYK_M": 0,
    "CMYK_Y": 0.01825002,
    "CMYK_K": 0.1004231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03585",
    "Farbtonhilfsbezeichnung": "MN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "229",
    "Bcolor": "225",
    "Y": 77,
    "L": 90.5125771958184,
    "a": -2.42972691112103,
    "b": 0.61786300265438,
    "C": 2.50705555436549,
    "h": -0.24901521131986,
    "CMY_C": 0.1239178,
    "CMY_M": 0.1005585,
    "CMY_Y": 0.1183816,
    "CMYK_C": 0.02597093,
    "CMYK_M": 0,
    "CMYK_Y": 0.01981578,
    "CMYK_K": 0.1005585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03586",
    "Farbtonhilfsbezeichnung": "N7.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "238",
    "Bcolor": "235",
    "Y": 81,
    "L": 93.0318603515625,
    "a": -4.19947290420532,
    "b": -0.77864933013916,
    "C": 4.27104997634888,
    "h": 190.504272460938,
    "CMY_C": 0.11541187763214,
    "CMY_M": 0.06784683465958,
    "CMY_Y": 0.08033955097198,
    "CMYK_C": 0.05102706700563,
    "CMYK_M": 0,
    "CMYK_Y": 0.0134019991383,
    "CMYK_K": 0.06784683465958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03587",
    "Farbtonhilfsbezeichnung": "NN.01.89",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "239",
    "Bcolor": "236",
    "Y": 85,
    "L": 93.7739029054154,
    "a": -3.02393390487038,
    "b": -0.43944969030198,
    "C": 3.05569833120535,
    "h": 0.14431357966378,
    "CMY_C": 0.09624417,
    "CMY_M": 0.06236509,
    "CMY_Y": 0.07444601,
    "CMYK_C": 0.03613248,
    "CMYK_M": 0,
    "CMYK_Y": 0.01288446,
    "CMYK_K": 0.06236509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03588",
    "Farbtonhilfsbezeichnung": "N7.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "232",
    "Bcolor": "229",
    "Y": 78,
    "L": 90.9685704927685,
    "a": -4.25571902054517,
    "b": -0.98500558965872,
    "C": 4.36822394040059,
    "h": 0.22744943165591,
    "CMY_C": 0.1395319,
    "CMY_M": 0.09079322,
    "CMY_Y": 0.1017208,
    "CMYK_C": 0.05360565,
    "CMYK_M": 0,
    "CMYK_Y": 0.01201881,
    "CMYK_K": 0.09079322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03589",
    "Farbtonhilfsbezeichnung": "NN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "223",
    "Bcolor": "221",
    "Y": 73,
    "L": 88.4155539950531,
    "a": -1.44774549721371,
    "b": -0.34747065832525,
    "C": 1.48885959146575,
    "h": 0.23555264756113,
    "CMY_C": 0.1426433,
    "CMY_M": 0.1258886,
    "CMY_Y": 0.1342316,
    "CMYK_C": 0.01916769,
    "CMYK_M": 0,
    "CMYK_Y": 0.00954453,
    "CMYK_K": 0.1258886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03590",
    "Farbtonhilfsbezeichnung": "P3.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "221",
    "Bcolor": "220",
    "Y": 71,
    "L": 87.2698634538764,
    "a": -4.1319889406215,
    "b": -1.66007854504857,
    "C": 4.45299824625487,
    "h": 0.38202492012453,
    "CMY_C": 0.1817352,
    "CMY_M": 0.1320308,
    "CMY_Y": 0.1375398,
    "CMYK_C": 0.0572651,
    "CMYK_M": 0,
    "CMYK_Y": 0.006346955,
    "CMYK_K": 0.1320308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03591",
    "Farbtonhilfsbezeichnung": "P7.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 80,
    "L": 91.4784824885931,
    "a": -3.80251240092178,
    "b": -1.63293928945458,
    "C": 4.13830778002414,
    "h": 0.40562276494686,
    "CMY_C": 0.1325501,
    "CMY_M": 0.08594876,
    "CMY_Y": 0.09120347,
    "CMYK_C": 0.05098328,
    "CMYK_M": 0,
    "CMYK_Y": 0.005748812,
    "CMYK_K": 0.08594876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03592",
    "Farbtonhilfsbezeichnung": "P8.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "237",
    "Bcolor": "236",
    "Y": 83,
    "L": 92.915081089493,
    "a": -4.23323870386305,
    "b": -1.58755886900286,
    "C": 4.52113404871319,
    "h": 0.35879021125063,
    "CMY_C": 0.1200128,
    "CMY_M": 0.06887297,
    "CMY_Y": 0.07562447,
    "CMYK_C": 0.05492249,
    "CMYK_M": 0,
    "CMYK_Y": 0.007250897,
    "CMYK_K": 0.06887297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03593",
    "Farbtonhilfsbezeichnung": "PN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "240",
    "Bcolor": "236",
    "Y": 86,
    "L": 94.1550475012794,
    "a": -2.05859003840192,
    "b": 0.38323890288121,
    "C": 2.09395916934624,
    "h": -0.18405867719598,
    "CMY_C": 0.08117057,
    "CMY_M": 0.06058021,
    "CMY_Y": 0.07620339,
    "CMYK_C": 0.02191818,
    "CMYK_M": 0,
    "CMYK_Y": 0.01663068,
    "CMYK_K": 0.06058021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03594",
    "Farbtonhilfsbezeichnung": "PN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "237",
    "Bcolor": "235",
    "Y": 84,
    "L": 93.3611701932168,
    "a": -2.07607404150922,
    "b": -0.59336931293516,
    "C": 2.1592060039194,
    "h": 0.27839108238036,
    "CMY_C": 0.09367017,
    "CMY_M": 0.06917434,
    "CMY_Y": 0.07776598,
    "CMYK_C": 0.02631624,
    "CMYK_M": 0,
    "CMYK_Y": 0.009230126,
    "CMYK_K": 0.06917434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03595",
    "Farbtonhilfsbezeichnung": "QN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "229",
    "Bcolor": "225",
    "Y": 77,
    "L": 90.3087758830056,
    "a": -2.37813443082713,
    "b": 0.1630082701632,
    "C": 2.38371455237977,
    "h": -0.06843755117227,
    "CMY_C": 0.1273672,
    "CMY_M": 0.1028211,
    "CMY_Y": 0.11726,
    "CMYK_C": 0.02735918,
    "CMYK_M": 0,
    "CMYK_Y": 0.01609367,
    "CMYK_K": 0.1028211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03596",
    "Farbtonhilfsbezeichnung": "QN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "236",
    "Bcolor": "235",
    "Y": 82,
    "L": 92.6785332468528,
    "a": -2.1544999448796,
    "b": -1.37707221940953,
    "C": 2.5569900097489,
    "h": 0.56871772054295,
    "CMY_C": 0.1047537,
    "CMY_M": 0.07641795,
    "CMY_Y": 0.0795437,
    "CMYK_C": 0.0306803,
    "CMYK_M": 0,
    "CMYK_Y": 0.003384388,
    "CMYK_K": 0.07641795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03597",
    "Farbtonhilfsbezeichnung": "Q6.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "229",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.2297100605611,
    "a": -3.06449241521256,
    "b": -2.40136513131963,
    "C": 3.89328502126586,
    "h": 0.66466647626816,
    "CMY_C": 0.1431447,
    "CMY_M": 0.1013728,
    "CMY_Y": 0.09926727,
    "CMYK_C": 0.04871299,
    "CMYK_M": 0.002337572,
    "CMYK_Y": 0,
    "CMYK_K": 0.09926727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03598",
    "Farbtonhilfsbezeichnung": "R7.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "225",
    "Bcolor": "226",
    "Y": 74,
    "L": 88.8286209106445,
    "a": -3.4183452129364,
    "b": -2.73195743560791,
    "C": 4.37591981887817,
    "h": 218.63200378418,
    "CMY_C": 0.16273272037506,
    "CMY_M": 0.11603182554245,
    "CMY_Y": 0.11238020658493,
    "CMYK_C": 0.05672756955028,
    "CMYK_M": 0.00411394471303,
    "CMYK_Y": 0,
    "CMYK_K": 0.11238020658493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03599",
    "Farbtonhilfsbezeichnung": "RN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "228",
    "Bcolor": "228",
    "Y": 77,
    "L": 90.170059980192,
    "a": -1.8738896271735,
    "b": -1.8314263775961,
    "C": 2.62022611836902,
    "h": 0.77393857649087,
    "CMY_C": 0.1319797,
    "CMY_M": 0.104967,
    "CMY_Y": 0.1039822,
    "CMYK_C": 0.03124661,
    "CMYK_M": 0.001099098,
    "CMYK_Y": 0,
    "CMYK_K": 0.1039822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03600",
    "Farbtonhilfsbezeichnung": "RN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "233",
    "Bcolor": "234",
    "Y": 80,
    "L": 91.6534208605797,
    "a": -1.99297387251068,
    "b": -2.35315280454835,
    "C": 3.08371091026121,
    "h": 0.86808276222878,
    "CMY_C": 0.1184077,
    "CMY_M": 0.08798381,
    "CMY_Y": 0.0836775,
    "CMYK_C": 0.03790172,
    "CMYK_M": 0.004699556,
    "CMYK_Y": 0,
    "CMYK_K": 0.0836775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03601",
    "Farbtonhilfsbezeichnung": "RN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "232",
    "Bcolor": "234",
    "Y": 80,
    "L": 91.6242923143859,
    "a": -2.00650099893901,
    "b": -2.39637132223938,
    "C": 3.12548264637552,
    "h": 0.87371689688546,
    "CMY_C": 0.1190009,
    "CMY_M": 0.08826511,
    "CMY_Y": 0.08368269,
    "CMYK_C": 0.03854369,
    "CMYK_M": 0.005000909,
    "CMYK_Y": 0,
    "CMYK_K": 0.08368269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03603",
    "Farbtonhilfsbezeichnung": "R9.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "222",
    "Bcolor": "224",
    "Y": 72,
    "L": 88.022127108697,
    "a": -1.81003791880208,
    "b": -2.53501519195916,
    "C": 3.11488993239971,
    "h": 0.95072636964208,
    "CMY_C": 0.1577471,
    "CMY_M": 0.1287761,
    "CMY_Y": 0.1225224,
    "CMYK_C": 0.04014321,
    "CMYK_M": 0.007126899,
    "CMYK_Y": 0,
    "CMYK_K": 0.1225224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03604",
    "Farbtonhilfsbezeichnung": "RN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "238",
    "Bcolor": "236",
    "Y": 85,
    "L": 93.6763239904347,
    "a": -1.53958199968429,
    "b": -0.56821673778317,
    "C": 1.64109201291361,
    "h": 0.35356349229528,
    "CMY_C": 0.08570462,
    "CMY_M": 0.06690696,
    "CMY_Y": 0.07437041,
    "CMYK_C": 0.02014554,
    "CMYK_M": 0,
    "CMYK_Y": 0.007998617,
    "CMYK_K": 0.06690696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03605",
    "Farbtonhilfsbezeichnung": "SN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "230",
    "Bcolor": "231",
    "Y": 78,
    "L": 91.0832672119141,
    "a": -0.29430598020554,
    "b": -1.82181990146637,
    "C": 1.84543859958649,
    "h": 260.823425292969,
    "CMY_C": 0.10903924703598,
    "CMY_M": 0.09847223758698,
    "CMY_Y": 0.09371888637543,
    "CMYK_C": 0.0169046446681,
    "CMYK_M": 0.00524489721283,
    "CMYK_Y": 0,
    "CMYK_K": 0.09371888637543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03606",
    "Farbtonhilfsbezeichnung": "SN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "227",
    "Bcolor": "225",
    "Y": 76,
    "L": 89.8489718244244,
    "a": -1.44229415264868,
    "b": -0.43813114512503,
    "C": 1.50737232397744,
    "h": 0.29491537094039,
    "CMY_C": 0.1270605,
    "CMY_M": 0.1099524,
    "CMY_Y": 0.1177665,
    "CMYK_C": 0.01922159,
    "CMYK_M": 0,
    "CMYK_Y": 0.008779378,
    "CMYK_K": 0.1099524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03607",
    "Farbtonhilfsbezeichnung": "T5.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "224",
    "Bcolor": "231",
    "Y": 72,
    "L": 88.7012786865234,
    "a": -0.65021574497223,
    "b": -5.42354488372803,
    "C": 5.46238231658936,
    "h": 263.16357421875,
    "CMY_C": 0.15156066417694,
    "CMY_M": 0.12306368350983,
    "CMY_Y": 0.0936062335968,
    "CMYK_C": 0.06393957138062,
    "CMYK_M": 0.03249961510301,
    "CMYK_Y": 0,
    "CMYK_K": 0.0936062335968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03608",
    "Farbtonhilfsbezeichnung": "T2.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "227",
    "Bcolor": "233",
    "Y": 76,
    "L": 89.9116298230418,
    "a": -1.19743871017136,
    "b": -4.63664347018891,
    "C": 4.78877041987422,
    "h": 1.31806299370586,
    "CMY_C": 0.1397095,
    "CMY_M": 0.1085958,
    "CMY_Y": 0.08603767,
    "CMYK_C": 0.05872428,
    "CMYK_M": 0.0246817,
    "CMYK_Y": 0,
    "CMYK_K": 0.08603767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03609",
    "Farbtonhilfsbezeichnung": "T2.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "220",
    "Bcolor": "225",
    "Y": 71,
    "L": 87.6131515743014,
    "a": -0.73264640109299,
    "b": -3.56976025832709,
    "C": 3.64416781322787,
    "h": 1.36837042914411,
    "CMY_C": 0.1573238,
    "CMY_M": 0.1355095,
    "CMY_Y": 0.1192898,
    "CMYK_C": 0.0431856,
    "CMYK_M": 0.01841663,
    "CMYK_Y": 0,
    "CMYK_K": 0.1192898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03610",
    "Farbtonhilfsbezeichnung": "SN.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "225",
    "Bcolor": "226",
    "Y": 74,
    "L": 89.0343707602937,
    "a": -1.13832693826421,
    "b": -2.34856718275485,
    "C": 2.60989578916305,
    "h": 1.11947159380267,
    "CMY_C": 0.1404655,
    "CMY_M": 0.1191652,
    "CMY_Y": 0.1126305,
    "CMYK_C": 0.03136805,
    "CMYK_M": 0.007364184,
    "CMYK_Y": 0,
    "CMYK_K": 0.1126305
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03611",
    "Farbtonhilfsbezeichnung": "TN.00.84",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "229",
    "Bcolor": "229",
    "Y": 78,
    "L": 90.7366147726639,
    "a": -0.1434069742307,
    "b": -1.14059796327417,
    "C": 1.14957786777721,
    "h": 1.44572297958839,
    "CMY_C": 0.1092828,
    "CMY_M": 0.1029222,
    "CMY_Y": 0.102583,
    "CMYK_C": 0.00746565,
    "CMYK_M": 0.0003780367,
    "CMYK_Y": 0,
    "CMYK_K": 0.102583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03612",
    "Farbtonhilfsbezeichnung": "UN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "230",
    "Bcolor": "230",
    "Y": 79,
    "L": 91.0577296529429,
    "a": -0.16628947268648,
    "b": -1.30207297985965,
    "C": 1.31264855677631,
    "h": 1.44377261140535,
    "CMY_C": 0.1064628,
    "CMY_M": 0.09924124,
    "CMY_Y": 0.09783298,
    "CMYK_C": 0.009565631,
    "CMYK_M": 0.001560977,
    "CMYK_Y": 0,
    "CMYK_K": 0.09783298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03613",
    "Farbtonhilfsbezeichnung": "TN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "219",
    "Bcolor": "221",
    "Y": 70,
    "L": 87.0604886064986,
    "a": -0.56401927163768,
    "b": -2.64564219893269,
    "C": 2.70509526330443,
    "h": 1.36075271415568,
    "CMY_C": 0.1586907,
    "CMY_M": 0.1422869,
    "CMY_Y": 0.1321398,
    "CMYK_C": 0.03059345,
    "CMYK_M": 0.01169207,
    "CMYK_Y": 0,
    "CMYK_K": 0.1321398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03614",
    "Farbtonhilfsbezeichnung": "U7.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "217",
    "Bcolor": "223",
    "Y": 69,
    "L": 86.5290121362307,
    "a": 0.86245067423385,
    "b": -4.45545345522012,
    "C": 4.53815895018225,
    "h": -1.37958918533161,
    "CMY_C": 0.1596788,
    "CMY_M": 0.1509679,
    "CMY_Y": 0.1245458,
    "CMYK_C": 0.0401311,
    "CMYK_M": 0.03018097,
    "CMYK_Y": 0,
    "CMYK_K": 0.1245458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03615",
    "Farbtonhilfsbezeichnung": "U5.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "222",
    "Bcolor": "228",
    "Y": 73,
    "L": 88.3542001012413,
    "a": 0.39431100089859,
    "b": -4.41637541205,
    "C": 4.43394327270765,
    "h": -1.48174859346265,
    "CMY_C": 0.1431673,
    "CMY_M": 0.1296986,
    "CMY_Y": 0.1047293,
    "CMYK_C": 0.04293441,
    "CMYK_M": 0.02789015,
    "CMYK_Y": 0,
    "CMYK_K": 0.1047293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03616",
    "Farbtonhilfsbezeichnung": "UN.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "226",
    "Bcolor": "230",
    "Y": 75,
    "L": 89.6851425170898,
    "a": 0.47380539774895,
    "b": -3.35647630691528,
    "C": 3.38975286483765,
    "h": 278.034881591797,
    "CMY_C": 0.12391728162766,
    "CMY_M": 0.11540520191193,
    "CMY_Y": 0.097780585289,
    "CMYK_C": 0.02896933443844,
    "CMYK_M": 0.01953473500907,
    "CMYK_Y": 0,
    "CMYK_K": 0.097780585289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03617",
    "Farbtonhilfsbezeichnung": "VN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "224",
    "Bcolor": "228",
    "Y": 75,
    "L": 89.411191146278,
    "a": 1.01019879296088,
    "b": -2.81567900184725,
    "C": 2.99141268345629,
    "h": -1.22632450413235,
    "CMY_C": 0.1207381,
    "CMY_M": 0.1199123,
    "CMY_Y": 0.1047329,
    "CMYK_C": 0.01787759,
    "CMYK_M": 0.01695517,
    "CMYK_Y": 0,
    "CMYK_K": 0.1047329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03618",
    "Farbtonhilfsbezeichnung": "VN.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "230",
    "Y": 76,
    "L": 89.6646598915056,
    "a": 1.30091409783001,
    "b": -3.59451057935705,
    "C": 3.82268018477123,
    "h": -1.22354481842833,
    "CMY_C": 0.1183921,
    "CMY_M": 0.1175581,
    "CMY_Y": 0.09614226,
    "CMYK_C": 0.02461649,
    "CMYK_M": 0.02369379,
    "CMYK_Y": 0,
    "CMYK_K": 0.09614226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03619",
    "Farbtonhilfsbezeichnung": "WN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "231",
    "Y": 78,
    "L": 90.6081189601279,
    "a": 2.39979873536561,
    "b": -2.59237428064019,
    "C": 3.53262485712637,
    "h": -0.82395454114416,
    "CMY_C": 0.09560722,
    "CMY_M": 0.110005,
    "CMY_Y": 0.09292757,
    "CMYK_C": 0.002954176,
    "CMYK_M": 0.01882699,
    "CMYK_Y": 0,
    "CMYK_K": 0.09292757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03620",
    "Farbtonhilfsbezeichnung": "WN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "226",
    "Bcolor": "227",
    "Y": 77,
    "L": 90.1490196010808,
    "a": 1.14112610701772,
    "b": -1.11540773446721,
    "C": 1.59571401141517,
    "h": -0.7740013659845,
    "CMY_C": 0.1055252,
    "CMY_M": 0.1125256,
    "CMY_Y": 0.1090972,
    "CMYK_C": 0,
    "CMYK_M": 0.007826366,
    "CMYK_Y": 0.003993497,
    "CMYK_K": 0.1055252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03621",
    "Farbtonhilfsbezeichnung": "WN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "219",
    "Bcolor": "222",
    "Y": 72,
    "L": 87.848718958598,
    "a": 1.85356283745147,
    "b": -1.63707844013921,
    "C": 2.47299838486598,
    "h": -0.72345897672561,
    "CMY_C": 0.1272691,
    "CMY_M": 0.139583,
    "CMY_Y": 0.1305412,
    "CMYK_C": 0,
    "CMYK_M": 0.0141096,
    "CMYK_Y": 0.003749228,
    "CMYK_K": 0.1272691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03622",
    "Farbtonhilfsbezeichnung": "WN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "231",
    "Bcolor": "228",
    "Y": 80,
    "L": 91.5953912953974,
    "a": 0.75250470771476,
    "b": 0.44080634849359,
    "C": 0.87210869277007,
    "h": 0.52990209367685,
    "CMY_C": 0.08711358,
    "CMY_M": 0.09593453,
    "CMY_Y": 0.1046612,
    "CMYK_C": 0,
    "CMYK_M": 0.0096627,
    "CMYK_Y": 0.01922208,
    "CMYK_K": 0.08711358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03623",
    "Farbtonhilfsbezeichnung": "XN.00.84",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "231",
    "Bcolor": "230",
    "Y": 81,
    "L": 91.9263328762749,
    "a": 0.8635171209605,
    "b": -0.11855201923955,
    "C": 0.87161711746482,
    "h": -0.13643677334576,
    "CMY_C": 0.08445124,
    "CMY_M": 0.09234395,
    "CMY_Y": 0.09683165,
    "CMYK_C": 0,
    "CMYK_M": 0.008620741,
    "CMYK_Y": 0.0135224,
    "CMYK_K": 0.08445124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03624",
    "Farbtonhilfsbezeichnung": "VN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "230",
    "Bcolor": "234",
    "Y": 80,
    "L": 91.4726901547272,
    "a": 0.96238716506041,
    "b": -3.00044241530089,
    "C": 3.15100678244425,
    "h": -1.2604146289162,
    "CMY_C": 0.09884978,
    "CMY_M": 0.09679738,
    "CMY_Y": 0.08049448,
    "CMYK_C": 0.01996214,
    "CMYK_M": 0.01773008,
    "CMYK_Y": 0,
    "CMYK_K": 0.08049448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03625",
    "Farbtonhilfsbezeichnung": "XN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.3454439495952,
    "a": 2.8118702430423,
    "b": -2.28262966602786,
    "C": 3.62174163296296,
    "h": -0.68188477444776,
    "CMY_C": 0.09421261,
    "CMY_M": 0.1140148,
    "CMY_Y": 0.09807382,
    "CMYK_C": 0,
    "CMYK_M": 0.0218618,
    "CMYK_Y": 0.004262824,
    "CMYK_K": 0.09421261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03626",
    "Farbtonhilfsbezeichnung": "YN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 79,
    "L": 91.0663920083517,
    "a": 3.16774215302956,
    "b": -1.36146502706145,
    "C": 3.44792363140366,
    "h": -0.40592111499766,
    "CMY_C": 0.08020103,
    "CMY_M": 0.1071295,
    "CMY_Y": 0.09684145,
    "CMYK_C": 0,
    "CMYK_M": 0.02927649,
    "CMYK_Y": 0.01809137,
    "CMYK_K": 0.08020103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03627",
    "Farbtonhilfsbezeichnung": "BN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "224",
    "Bcolor": "222",
    "Y": 75,
    "L": 89.5474215264417,
    "a": 2.24225941513911,
    "b": 0.74002198032481,
    "C": 2.3612199846994,
    "h": 0.31877827602598,
    "CMY_C": 0.09731513,
    "CMY_M": 0.1223871,
    "CMY_Y": 0.1292775,
    "CMYK_C": 0,
    "CMYK_M": 0.02777484,
    "CMYK_Y": 0.03540815,
    "CMYK_K": 0.09731513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03628",
    "Farbtonhilfsbezeichnung": "YN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "231",
    "Bcolor": "231",
    "Y": 81,
    "L": 91.9913143400565,
    "a": 2.05767935515772,
    "b": -0.37696710474699,
    "C": 2.09192459871373,
    "h": -0.18119088985487,
    "CMY_C": 0.07519128,
    "CMY_M": 0.09441546,
    "CMY_Y": 0.09402871,
    "CMYK_C": 0,
    "CMYK_M": 0.0207872,
    "CMYK_Y": 0.020369,
    "CMYK_K": 0.07519128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03629",
    "Farbtonhilfsbezeichnung": "ZN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "229",
    "Bcolor": "225",
    "Y": 79,
    "L": 91.0776443481445,
    "a": 1.16876626014709,
    "b": 1.60030257701874,
    "C": 1.98166167736053,
    "h": 53.8578224182129,
    "CMY_C": 0.08571535348892,
    "CMY_M": 0.10300433635712,
    "CMY_Y": 0.11891484260559,
    "CMYK_C": 0,
    "CMYK_M": 0.01890984736383,
    "CMYK_Y": 0.03631198406219,
    "CMYK_K": 0.08571535348892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03630",
    "Farbtonhilfsbezeichnung": "EN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "226",
    "Y": 82,
    "L": 92.601727867291,
    "a": 0.31446792115819,
    "b": 3.00754978428199,
    "C": 3.0239453993702,
    "h": 1.46661537910489,
    "CMY_C": 0.07068597,
    "CMY_M": 0.08437228,
    "CMY_Y": 0.1126438,
    "CMYK_C": 0,
    "CMYK_M": 0.01472733,
    "CMYK_Y": 0.04514926,
    "CMYK_K": 0.07068597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03631",
    "Farbtonhilfsbezeichnung": "TN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "226",
    "Bcolor": "227",
    "Y": 76,
    "L": 89.7730941055505,
    "a": -0.51980407801999,
    "b": -1.74447773302659,
    "C": 1.82027438606157,
    "h": 1.28120187839827,
    "CMY_C": 0.1251379,
    "CMY_M": 0.1125836,
    "CMY_Y": 0.1088355,
    "CMYK_C": 0.01829332,
    "CMYK_M": 0.00420584,
    "CMYK_Y": 0,
    "CMYK_K": 0.1088355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03632",
    "Farbtonhilfsbezeichnung": "KN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "232",
    "Bcolor": "224",
    "Y": 80,
    "L": 91.5016642129399,
    "a": -2.36398582070008,
    "b": 2.45251288080766,
    "C": 3.40635412002312,
    "h": -0.80377605546973,
    "CMY_C": 0.1060346,
    "CMY_M": 0.09018734,
    "CMY_Y": 0.1210492,
    "CMYK_C": 0.01741813,
    "CMYK_M": 0,
    "CMYK_Y": 0.03392106,
    "CMYK_K": 0.09018734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03633",
    "Farbtonhilfsbezeichnung": "AN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "230",
    "Bcolor": "228",
    "Y": 80,
    "L": 91.6060239009364,
    "a": 2.06812088485475,
    "b": 0.9067658203824,
    "C": 2.25817365306262,
    "h": 0.41320681785937,
    "CMY_C": 0.07510148,
    "CMY_M": 0.0991118,
    "CMY_Y": 0.1078129,
    "CMYK_C": 0,
    "CMYK_M": 0.02595994,
    "CMYK_Y": 0.03536762,
    "CMYK_K": 0.07510148
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03634",
    "Farbtonhilfsbezeichnung": "KN.00.84",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "231",
    "Bcolor": "227",
    "Y": 80,
    "L": 91.5902472434559,
    "a": -0.89827670503722,
    "b": 0.91957534899633,
    "C": 1.28550373834317,
    "h": -0.79711400650581,
    "CMY_C": 0.09861875,
    "CMY_M": 0.09220727,
    "CMY_Y": 0.1084971,
    "CMYK_C": 0.007062724,
    "CMYK_M": 0,
    "CMYK_Y": 0.01794441,
    "CMYK_K": 0.09220727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03635",
    "Farbtonhilfsbezeichnung": "E5.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "217",
    "Bcolor": "198",
    "Y": 72,
    "L": 87.8150735479852,
    "a": 4.31024044852246,
    "b": 10.9092484937721,
    "C": 11.7298710744385,
    "h": 1.19452149970274,
    "CMY_C": 0.07045569,
    "CMY_M": 0.1493467,
    "CMY_Y": 0.2227619,
    "CMYK_C": 0,
    "CMYK_M": 0.08487065,
    "CMYK_Y": 0.1638505,
    "CMYK_K": 0.07045569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03636",
    "Farbtonhilfsbezeichnung": "HN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "228",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.3008285018974,
    "a": -0.75292782480379,
    "b": 1.78395552884643,
    "C": 1.93633613772648,
    "h": -1.17142253736089,
    "CMY_C": 0.1088731,
    "CMY_M": 0.1071732,
    "CMY_Y": 0.1291083,
    "CMYK_C": 0.001903921,
    "CMYK_M": 0,
    "CMYK_Y": 0.02456812,
    "CMYK_K": 0.1071732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03637",
    "Farbtonhilfsbezeichnung": "JN.00.83",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "228",
    "Bcolor": "223",
    "Y": 77,
    "L": 90.2922839068015,
    "a": -0.7480540800131,
    "b": 1.07469708303394,
    "C": 1.30941159568178,
    "h": -0.96271928667335,
    "CMY_C": 0.111343,
    "CMY_M": 0.1070795,
    "CMY_Y": 0.1239581,
    "CMYK_C": 0.004774751,
    "CMYK_M": 0,
    "CMYK_Y": 0.01890268,
    "CMYK_K": 0.1070795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03638",
    "Farbtonhilfsbezeichnung": "SN.00.80",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "220",
    "Bcolor": "220",
    "Y": 71,
    "L": 87.618029990624,
    "a": -0.56932044244334,
    "b": -0.89527012260444,
    "C": 1.06095916915405,
    "h": 1.00438272580625,
    "CMY_C": 0.1463681,
    "CMY_M": 0.136618,
    "CMY_Y": 0.138854,
    "CMYK_C": 0.01129297,
    "CMYK_M": 0,
    "CMYK_Y": 0.002589851,
    "CMYK_K": 0.136618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03639",
    "Farbtonhilfsbezeichnung": "GN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "224",
    "Bcolor": "221",
    "Y": 73,
    "L": 89.2324295043945,
    "a": -0.35402980446815,
    "b": 0.97792112827301,
    "C": 1.04003214836121,
    "h": 109.901412963867,
    "CMY_C": 0.12031728029251,
    "CMY_M": 0.11973547935486,
    "CMY_Y": 0.13485944271088,
    "CMYK_C": 0.00066093873465,
    "CMYK_M": 0,
    "CMYK_Y": 0.0171811580658,
    "CMYK_K": 0.11973547935486
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03640",
    "Farbtonhilfsbezeichnung": "JN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "224",
    "Y": 78,
    "L": 90.635202643396,
    "a": -0.85284861273654,
    "b": 1.37824657751386,
    "C": 1.62077585886369,
    "h": -1.01667330727013,
    "CMY_C": 0.1073221,
    "CMY_M": 0.1030989,
    "CMY_Y": 0.1224365,
    "CMYK_C": 0.004708621,
    "CMYK_M": 0,
    "CMYK_Y": 0.02156042,
    "CMYK_K": 0.1030989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03641",
    "Farbtonhilfsbezeichnung": "NN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "218",
    "Bcolor": "215",
    "Y": 69,
    "L": 86.5165168264061,
    "a": -1.59552742313979,
    "b": 0.0638103727345,
    "C": 1.59680290632864,
    "h": -0.03997197645037,
    "CMY_C": 0.1633084,
    "CMY_M": 0.1466741,
    "CMY_Y": 0.1581071,
    "CMYK_C": 0.01949353,
    "CMYK_M": 0,
    "CMYK_Y": 0.01339819,
    "CMYK_K": 0.1466741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03642",
    "Farbtonhilfsbezeichnung": "WN.00.82",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "224",
    "Bcolor": "224",
    "Y": 74,
    "L": 89.0912255721391,
    "a": 0.6990337080503,
    "b": -1.23161458521102,
    "C": 1.41616475436125,
    "h": -1.05455999790006,
    "CMY_C": 0.1211815,
    "CMY_M": 0.1231894,
    "CMY_Y": 0.1199857,
    "CMYK_C": 0.001358862,
    "CMYK_M": 0.003640502,
    "CMYK_Y": 0,
    "CMYK_K": 0.1199857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03643",
    "Farbtonhilfsbezeichnung": "XN.00.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 73,
    "L": 88.482289091523,
    "a": 0.76060597282079,
    "b": -0.28772919857431,
    "C": 0.8132094057516,
    "h": -0.36165142917202,
    "CMY_C": 0.1241922,
    "CMY_M": 0.1303601,
    "CMY_Y": 0.133636,
    "CMYK_C": 0,
    "CMYK_M": 0.007042558,
    "CMYK_Y": 0.01078291,
    "CMYK_K": 0.1241922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03644",
    "Farbtonhilfsbezeichnung": "UN.00.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "222",
    "Bcolor": "222",
    "Y": 73,
    "L": 88.5794301766097,
    "a": 0.10885699884011,
    "b": -0.60246741370568,
    "C": 0.61222286038149,
    "h": -1.39203968538111,
    "CMY_C": 0.12934,
    "CMY_M": 0.1276503,
    "CMY_Y": 0.1303398,
    "CMYK_C": 0.001936953,
    "CMYK_M": 0,
    "CMYK_Y": 0.003083113,
    "CMYK_K": 0.1276503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03645",
    "Farbtonhilfsbezeichnung": "GN.00.78",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "212",
    "Bcolor": "209",
    "Y": 66,
    "L": 84.8236910109314,
    "a": -0.16503285430902,
    "b": 0.38745535684006,
    "C": 0.42113833421506,
    "h": -1.1681294990717,
    "CMY_C": 0.1695148,
    "CMY_M": 0.1687352,
    "CMY_Y": 0.1787596,
    "CMYK_C": 0.0009378709,
    "CMYK_M": 0,
    "CMYK_Y": 0.01205919,
    "CMYK_K": 0.1687352
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03646",
    "Farbtonhilfsbezeichnung": "GN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "210",
    "Bcolor": "205",
    "Y": 65,
    "L": 84.2358268219003,
    "a": -0.34842098567894,
    "b": 1.66971309765553,
    "C": 1.70567846083133,
    "h": -1.36507717587962,
    "CMY_C": 0.1730922,
    "CMY_M": 0.1751195,
    "CMY_Y": 0.1945233,
    "CMYK_C": 0,
    "CMYK_M": 0.00245166,
    "CMYK_Y": 0.02591717,
    "CMYK_K": 0.1730922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03647",
    "Farbtonhilfsbezeichnung": "LN.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "207",
    "Bcolor": "204",
    "Y": 62,
    "L": 82.6893905204071,
    "a": -1.40271679648102,
    "b": 0.25722744447564,
    "C": 1.42610671736776,
    "h": -0.18136301843778,
    "CMY_C": 0.2030006,
    "CMY_M": 0.1892221,
    "CMY_Y": 0.2011662,
    "CMYK_C": 0.01699416,
    "CMYK_M": 0,
    "CMYK_Y": 0.0147317,
    "CMYK_K": 0.1892221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03648",
    "Farbtonhilfsbezeichnung": "TN.00.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "218",
    "Bcolor": "215",
    "Y": 70,
    "L": 87.0154208277638,
    "a": 0.00120921057,
    "b": 0.87814811210553,
    "C": 0.87814894464704,
    "h": 1.5694193269596,
    "CMY_C": 0.1424207,
    "CMY_M": 0.1451234,
    "CMY_Y": 0.1583987,
    "CMYK_C": 0,
    "CMYK_M": 0.003151552,
    "CMYK_Y": 0.01863156,
    "CMYK_K": 0.1424207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03649",
    "Farbtonhilfsbezeichnung": "WN.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.3276029126432,
    "a": 0.61476641099822,
    "b": -0.94631857475513,
    "C": 1.12847533646874,
    "h": -0.99467421441964,
    "CMY_C": 0.1843663,
    "CMY_M": 0.1865805,
    "CMY_Y": 0.185228,
    "CMYK_C": 0,
    "CMYK_M": 0.002714652,
    "CMYK_Y": 0.001056473,
    "CMYK_K": 0.1843663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03650",
    "Farbtonhilfsbezeichnung": "JN.00.70",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "190",
    "Bcolor": "187",
    "Y": 51,
    "L": 76.7840180907795,
    "a": -0.38858869868557,
    "b": 0.76743578865063,
    "C": 0.86020861798053,
    "h": -1.1020841341626,
    "CMY_C": 0.2573281,
    "CMY_M": 0.2557472,
    "CMY_Y": 0.2681774,
    "CMYK_C": 0.002124162,
    "CMYK_M": 0,
    "CMYK_Y": 0.01670163,
    "CMYK_K": 0.2557472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03651",
    "Farbtonhilfsbezeichnung": "RN.00.72",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "198",
    "Bcolor": "198",
    "Y": 56,
    "L": 79.7476944498411,
    "a": -0.70347856029912,
    "b": -0.97100224987305,
    "C": 1.19905273197598,
    "h": 0.94382443613933,
    "CMY_C": 0.2336815,
    "CMY_M": 0.2225212,
    "CMY_Y": 0.2239831,
    "CMYK_C": 0.01435454,
    "CMYK_M": 0,
    "CMYK_Y": 0.001880411,
    "CMYK_K": 0.2225212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03653",
    "Farbtonhilfsbezeichnung": "FN.00.73",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "202",
    "Bcolor": "200",
    "Y": 59,
    "L": 81.2544019650715,
    "a": -0.63056580611015,
    "b": 0.35875925935378,
    "C": 0.72548014583957,
    "h": -0.5172742728173,
    "CMY_C": 0.2122334,
    "CMY_M": 0.2066859,
    "CMY_Y": 0.2173169,
    "CMYK_C": 0.006992851,
    "CMYK_M": 0,
    "CMYK_Y": 0.0134007,
    "CMYK_K": 0.2066859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03654",
    "Farbtonhilfsbezeichnung": "NN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "196",
    "Bcolor": "194",
    "Y": 55,
    "L": 78.8858962744508,
    "a": -1.4749955533187,
    "b": -0.20568552863773,
    "C": 1.48926774590768,
    "h": 0.13855474362808,
    "CMY_C": 0.2463789,
    "CMY_M": 0.2303149,
    "CMY_Y": 0.2388611,
    "CMYK_C": 0.0208709,
    "CMYK_M": 0,
    "CMYK_Y": 0.01110351,
    "CMYK_K": 0.2303149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03655",
    "Farbtonhilfsbezeichnung": "VN.01.72",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "195",
    "Bcolor": "196",
    "Y": 54,
    "L": 78.7501689877348,
    "a": 0.6199207940315,
    "b": -1.44176167858241,
    "C": 1.56938794716329,
    "h": -1.16471976772514,
    "CMY_C": 0.2358002,
    "CMY_M": 0.2362389,
    "CMY_Y": 0.2311649,
    "CMYK_C": 0.006028957,
    "CMYK_M": 0.006599564,
    "CMYK_Y": 0,
    "CMYK_K": 0.2311649
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03656",
    "Farbtonhilfsbezeichnung": "BN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "192",
    "Bcolor": "191",
    "Y": 53,
    "L": 78.1225940540931,
    "a": 1.36664179367457,
    "b": 0.65281082845096,
    "C": 1.51455332357791,
    "h": 0.44562875744159,
    "CMY_C": 0.2298976,
    "CMY_M": 0.2453389,
    "CMY_Y": 0.2528239,
    "CMYK_C": 0,
    "CMYK_M": 0.02005087,
    "CMYK_Y": 0.0297704,
    "CMYK_K": 0.2298976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03657",
    "Farbtonhilfsbezeichnung": "GN.00.65",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "177",
    "Bcolor": "174",
    "Y": 44,
    "L": 72.2997422169752,
    "a": -0.2576301916809,
    "b": 0.81896495370343,
    "C": 0.85853183462234,
    "h": -1.2660174171521,
    "CMY_C": 0.3040867,
    "CMY_M": 0.3040141,
    "CMY_Y": 0.3160314,
    "CMYK_C": 0.0001043352,
    "CMYK_M": 0,
    "CMYK_Y": 0.01726657,
    "CMYK_K": 0.3040141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03658",
    "Farbtonhilfsbezeichnung": "VN.00.70",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "189",
    "Bcolor": "188",
    "Y": 50,
    "L": 76.3601035637759,
    "a": -0.38226200749458,
    "b": -0.44475789598452,
    "C": 0.58645871842302,
    "h": 0.86082238729537,
    "CMY_C": 0.2658827,
    "CMY_M": 0.2599853,
    "CMY_Y": 0.2640423,
    "CMYK_C": 0.007969304,
    "CMYK_M": 0,
    "CMYK_Y": 0.005482372,
    "CMYK_K": 0.2599853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03659",
    "Farbtonhilfsbezeichnung": "GN.01.68",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "186",
    "Bcolor": "182",
    "Y": 49,
    "L": 75.4677340309032,
    "a": -0.1748117844329,
    "b": 1.22970653233212,
    "C": 1.24206977084096,
    "h": -1.42958516615396,
    "CMY_C": 0.2683137,
    "CMY_M": 0.2704988,
    "CMY_Y": 0.2854463,
    "CMYK_C": 0,
    "CMYK_M": 0.0029863,
    "CMYK_Y": 0.02341513,
    "CMYK_K": 0.2683137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03660",
    "Farbtonhilfsbezeichnung": "FN.00.63",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "175",
    "Bcolor": "173",
    "Y": 43,
    "L": 71.379746332611,
    "a": 0.07762363269331,
    "b": 0.3470366299219,
    "C": 0.3556119385792,
    "h": 1.35074280719105,
    "CMY_C": 0.3128579,
    "CMY_M": 0.314406,
    "CMY_Y": 0.3223377,
    "CMYK_C": 0,
    "CMYK_M": 0.002252972,
    "CMYK_Y": 0.01379604,
    "CMYK_K": 0.3128579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03661",
    "Farbtonhilfsbezeichnung": "CN.00.62",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "169",
    "Bcolor": "168",
    "Y": 40,
    "L": 69.4234120055169,
    "a": 1.0044577323039,
    "b": 0.20923231242493,
    "C": 1.02601827300871,
    "h": 0.20536703634322,
    "CMY_C": 0.3270646,
    "CMY_M": 0.3371329,
    "CMY_Y": 0.3417527,
    "CMYK_C": 0,
    "CMYK_M": 0.01496181,
    "CMYK_Y": 0.02182697,
    "CMYK_K": 0.3270646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03662",
    "Farbtonhilfsbezeichnung": "BN.00.68",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "185",
    "Bcolor": "183",
    "Y": 49,
    "L": 75.3050254468122,
    "a": 1.10278750605664,
    "b": 0.36750007862693,
    "C": 1.16240982071962,
    "h": 0.32167240398495,
    "CMY_C": 0.2631956,
    "CMY_M": 0.2749335,
    "CMY_Y": 0.2808667,
    "CMYK_C": 0,
    "CMYK_M": 0.0159308,
    "CMYK_Y": 0.02398338,
    "CMYK_K": 0.2631956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03663",
    "Farbtonhilfsbezeichnung": "GN.00.56",
    "Farbtonklasse": "01",
    "Rcolor": "155",
    "Gcolor": "155",
    "Bcolor": "154",
    "Y": 33,
    "L": 64.0065624957801,
    "a": -0.10210919111947,
    "b": -0.03134687953743,
    "C": 0.10681251690605,
    "h": 0.29786062907,
    "CMY_C": 0.3926893,
    "CMY_M": 0.3912036,
    "CMY_Y": 0.3964022,
    "CMYK_C": 0.002440214,
    "CMYK_M": 0,
    "CMYK_Y": 0.008539076,
    "CMYK_K": 0.3912036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03664",
    "Farbtonhilfsbezeichnung": "HN.00.59",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "163",
    "Bcolor": "161",
    "Y": 36,
    "L": 66.8526316656973,
    "a": -0.39400563804459,
    "b": 0.30269451473081,
    "C": 0.49685451800205,
    "h": -0.6550786576651,
    "CMY_C": 0.3641715,
    "CMY_M": 0.3610072,
    "CMY_Y": 0.3693527,
    "CMYK_C": 0.00495204,
    "CMYK_M": 0,
    "CMYK_Y": 0.01306045,
    "CMYK_K": 0.3610072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03665",
    "Farbtonhilfsbezeichnung": "FN.01.60",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "165",
    "Bcolor": "162",
    "Y": 38,
    "L": 67.6509730371418,
    "a": 0.14902391832782,
    "b": 1.03929325894165,
    "C": 1.0499231430516,
    "h": 1.42837743369931,
    "CMY_C": 0.3494138,
    "CMY_M": 0.3540541,
    "CMY_Y": 0.3661207,
    "CMYK_C": 0,
    "CMYK_M": 0.007132511,
    "CMYK_Y": 0.02567982,
    "CMYK_K": 0.3494138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03666",
    "Farbtonhilfsbezeichnung": "BN.01.52",
    "Farbtonklasse": "01",
    "Rcolor": "144",
    "Gcolor": "141",
    "Bcolor": "140",
    "Y": 27,
    "L": 58.7743958698737,
    "a": 1.58156778407553,
    "b": 0.22702760700159,
    "C": 1.59777914305027,
    "h": 0.14257199374059,
    "CMY_C": 0.4335075,
    "CMY_M": 0.4487521,
    "CMY_Y": 0.4513143,
    "CMYK_C": 0,
    "CMYK_M": 0.02691054,
    "CMYK_Y": 0.03143335,
    "CMYK_K": 0.4335075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03667",
    "Farbtonhilfsbezeichnung": "CN.01.59",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "163",
    "Bcolor": "161",
    "Y": 37,
    "L": 67.0200314544206,
    "a": 1.04860983856758,
    "b": 0.60126808148215,
    "C": 1.20876213514072,
    "h": 0.52062756115051,
    "CMY_C": 0.3507798,
    "CMY_M": 0.3625603,
    "CMY_Y": 0.3695025,
    "CMYK_C": 0,
    "CMYK_M": 0.01814561,
    "CMYK_Y": 0.02883865,
    "CMYK_K": 0.3507798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03668",
    "Farbtonhilfsbezeichnung": "AN.00.60",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "161",
    "Bcolor": "161",
    "Y": 36,
    "L": 66.4288781627152,
    "a": 0.63798357650291,
    "b": -0.19289005801168,
    "C": 0.66650552763438,
    "h": -0.29360521940378,
    "CMY_C": 0.3625299,
    "CMY_M": 0.3676007,
    "CMY_Y": 0.3701739,
    "CMYK_C": 0,
    "CMYK_M": 0.007954644,
    "CMYK_Y": 0.0119912,
    "CMYK_K": 0.3625299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03669",
    "Farbtonhilfsbezeichnung": "SN.00.48",
    "Farbtonklasse": "01",
    "Rcolor": "134",
    "Gcolor": "134",
    "Bcolor": "134",
    "Y": 24,
    "L": 55.997442060531,
    "a": -0.12682786953738,
    "b": -0.47737090486008,
    "C": 0.49393146214665,
    "h": 1.31111538647091,
    "CMY_C": 0.476171,
    "CMY_M": 0.4730069,
    "CMY_Y": 0.4747486,
    "CMYK_C": 0.006003977,
    "CMYK_M": 0,
    "CMYK_Y": 0.003305079,
    "CMYK_K": 0.4730069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03670",
    "Farbtonhilfsbezeichnung": "HN.00.45",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "126",
    "Bcolor": "125",
    "Y": 21,
    "L": 52.5278258321438,
    "a": -0.21005870173707,
    "b": -0.32752098636779,
    "C": 0.38909466031647,
    "h": 1.0005192606485,
    "CMY_C": 0.5110667,
    "CMY_M": 0.5076951,
    "CMY_Y": 0.5103399,
    "CMYK_C": 0.006848516,
    "CMYK_M": 0,
    "CMYK_Y": 0.005372301,
    "CMYK_K": 0.5076951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03671",
    "Farbtonhilfsbezeichnung": "LN.00.50",
    "Farbtonklasse": "01",
    "Rcolor": "136",
    "Gcolor": "138",
    "Bcolor": "137",
    "Y": 25,
    "L": 57.2526703299479,
    "a": -0.40631346420461,
    "b": -0.67671579673898,
    "C": 0.7893255986917,
    "h": 1.03006831489297,
    "CMY_C": 0.4661582,
    "CMY_M": 0.4596492,
    "CMY_Y": 0.4608239,
    "CMYK_C": 0.01204588,
    "CMYK_M": 0,
    "CMYK_Y": 0.002174084,
    "CMYK_K": 0.4596492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03672",
    "Farbtonhilfsbezeichnung": "DN.00.52",
    "Farbtonklasse": "01",
    "Rcolor": "142",
    "Gcolor": "142",
    "Bcolor": "142",
    "Y": 27,
    "L": 59.1219591050247,
    "a": 0.16606635154053,
    "b": -0.23431817498458,
    "C": 0.28719860766043,
    "h": -0.95424089251872,
    "CMY_C": 0.441587,
    "CMY_M": 0.4419841,
    "CMY_Y": 0.4448527,
    "CMYK_C": 0,
    "CMYK_M": 0.000711207,
    "CMYK_Y": 0.005848131,
    "CMYK_K": 0.441587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03673",
    "Farbtonhilfsbezeichnung": "CN.00.37",
    "Farbtonklasse": "01",
    "Rcolor": "105",
    "Gcolor": "105",
    "Bcolor": "104",
    "Y": 14,
    "L": 44.3010456473641,
    "a": 0.20463356595545,
    "b": -0.18380817402057,
    "C": 0.2750642491354,
    "h": -0.73183678929319,
    "CMY_C": 0.5884274,
    "CMY_M": 0.5893806,
    "CMY_Y": 0.591431,
    "CMYK_C": 0,
    "CMYK_M": 0.002315888,
    "CMYK_Y": 0.007297741,
    "CMYK_K": 0.5884274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03674",
    "Farbtonhilfsbezeichnung": "LN.00.43",
    "Farbtonklasse": "01",
    "Rcolor": "120",
    "Gcolor": "121",
    "Bcolor": "120",
    "Y": 19,
    "L": 50.6355711243116,
    "a": 0.0330301268645,
    "b": -0.12932585297962,
    "C": 0.13347720977602,
    "h": -1.32073959689628,
    "CMY_C": 0.5275122,
    "CMY_M": 0.5270685,
    "CMY_Y": 0.5302891,
    "CMYK_C": 0.0009382115,
    "CMYK_M": 0,
    "CMYK_Y": 0.006809993,
    "CMYK_K": 0.5270685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03675",
    "Farbtonhilfsbezeichnung": "JN.00.46",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "126",
    "Bcolor": "125",
    "Y": 21,
    "L": 52.7557782487051,
    "a": -0.53285867683045,
    "b": -0.12359171517448,
    "C": 0.54700391363615,
    "h": 0.22791097910963,
    "CMY_C": 0.5104655,
    "CMY_M": 0.5047902,
    "CMY_Y": 0.5094728,
    "CMYK_C": 0.01146036,
    "CMYK_M": 0,
    "CMYK_Y": 0.009455622,
    "CMYK_K": 0.5047902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03676",
    "Farbtonhilfsbezeichnung": "GN.00.44",
    "Farbtonklasse": "01",
    "Rcolor": "125",
    "Gcolor": "125",
    "Bcolor": "124",
    "Y": 20,
    "L": 52.3830570156162,
    "a": 0.06829084554654,
    "b": 0.05144709024977,
    "C": 0.08550112677989,
    "h": 0.64564336140317,
    "CMY_C": 0.5093511,
    "CMY_M": 0.5098267,
    "CMY_Y": 0.5142475,
    "CMYK_C": 0,
    "CMYK_M": 0.000969248,
    "CMYK_Y": 0.009979386,
    "CMYK_K": 0.5093511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03677",
    "Farbtonhilfsbezeichnung": "EN.00.39",
    "Farbtonklasse": "01",
    "Rcolor": "113",
    "Gcolor": "113",
    "Bcolor": "112",
    "Y": 16,
    "L": 47.5192155916282,
    "a": 0.11628362502896,
    "b": 0.0756532319533,
    "C": 0.1387274052048,
    "h": 0.57679149291714,
    "CMY_C": 0.5569724,
    "CMY_M": 0.5579754,
    "CMY_Y": 0.5620641,
    "CMYK_C": 0,
    "CMYK_M": 0.002263855,
    "CMYK_Y": 0.01149291,
    "CMYK_K": 0.5569724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03678",
    "Farbtonhilfsbezeichnung": "ON.00.18",
    "Farbtonklasse": "02",
    "Rcolor": "75",
    "Gcolor": "75",
    "Bcolor": "75",
    "Y": 5,
    "L": 31.9614410400391,
    "a": 0.18976628780365,
    "b": -0.07333539426327,
    "C": 0.20344366133213,
    "h": 338.870910644531,
    "CMY_C": 0.70416164398193,
    "CMY_M": 0.70532208681107,
    "CMY_Y": 0.70724165439606,
    "CMYK_C": 0,
    "CMYK_M": 0.00392255699262,
    "CMYK_Y": 0.01041112560779,
    "CMYK_K": 0.70416164398193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03679",
    "Farbtonhilfsbezeichnung": "RN.01.26",
    "Farbtonklasse": "01",
    "Rcolor": "81",
    "Gcolor": "83",
    "Bcolor": "84",
    "Y": 9,
    "L": 35.0644433839469,
    "a": -0.28551805676554,
    "b": -1.2603465875307,
    "C": 1.29228250837016,
    "h": 1.34801722300997,
    "CMY_C": 0.6822898,
    "CMY_M": 0.6755831,
    "CMY_Y": 0.6716759,
    "CMYK_C": 0.03232751,
    "CMYK_M": 0.01190049,
    "CMYK_Y": 0,
    "CMYK_K": 0.6716759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03680",
    "Farbtonhilfsbezeichnung": "ON.00.28",
    "Farbtonklasse": "01",
    "Rcolor": "86",
    "Gcolor": "86",
    "Bcolor": "86",
    "Y": 9,
    "L": 36.5156328464894,
    "a": 0.10663774547384,
    "b": -0.21800348155786,
    "C": 0.24268730236889,
    "h": -1.11586136328848,
    "CMY_C": 0.6631128,
    "CMY_M": 0.6631145,
    "CMY_Y": 0.6646453,
    "CMYK_C": 0,
    "CMYK_M": 5.052234e-06,
    "CMYK_Y": 0.004549163,
    "CMYK_K": 0.6631128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03681",
    "Farbtonhilfsbezeichnung": "EN.00.30",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "91",
    "Bcolor": "90",
    "Y": 10,
    "L": 38.5759730224846,
    "a": 0.15699332302315,
    "b": -0.05925621432896,
    "C": 0.16780405957679,
    "h": -0.3609117794763,
    "CMY_C": 0.6430017,
    "CMY_M": 0.6439362,
    "CMY_Y": 0.6464501,
    "CMYK_C": 0,
    "CMYK_M": 0.002617754,
    "CMYK_Y": 0.00965937,
    "CMYK_K": 0.6430017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03682",
    "Farbtonhilfsbezeichnung": "EN.00.32",
    "Farbtonklasse": "01",
    "Rcolor": "95",
    "Gcolor": "95",
    "Bcolor": "93",
    "Y": 11,
    "L": 40.2498672821131,
    "a": 0.18198909496866,
    "b": 0.42301625197729,
    "C": 0.46050274714102,
    "h": 1.16451452253152,
    "CMY_C": 0.6255985,
    "CMY_M": 0.6282759,
    "CMY_Y": 0.6337762,
    "CMYK_C": 0,
    "CMYK_M": 0.007151279,
    "CMYK_Y": 0.02184221,
    "CMYK_K": 0.6255985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03683",
    "Farbtonhilfsbezeichnung": "ON.00.04",
    "Farbtonklasse": "02",
    "Rcolor": "36",
    "Gcolor": "37",
    "Bcolor": "38",
    "Y": 2,
    "L": 14.7831335512415,
    "a": -0.19571725282735,
    "b": -0.81859838337982,
    "C": 0.84167009946079,
    "h": 1.33611362012113,
    "CMY_C": 0.85732,
    "CMY_M": 0.8534073,
    "CMY_Y": 0.8510688,
    "CMYK_C": 0.04197375,
    "CMYK_M": 0.0157022,
    "CMYK_Y": 0,
    "CMYK_K": 0.8510688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03684",
    "Farbtonhilfsbezeichnung": "DN.00.11",
    "Farbtonklasse": "02",
    "Rcolor": "69",
    "Gcolor": "69",
    "Bcolor": "68",
    "Y": 4,
    "L": 29.2949047088623,
    "a": 0.21222814917564,
    "b": 0.0792258232832,
    "C": 0.22653369605541,
    "h": 20.470853805542,
    "CMY_C": 0.72774946689606,
    "CMY_M": 0.72955012321472,
    "CMY_Y": 0.73212218284607,
    "CMYK_C": 0,
    "CMYK_M": 0.00661396794021,
    "CMYK_Y": 0.01606136746705,
    "CMYK_K": 0.72774946689606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03685",
    "Farbtonhilfsbezeichnung": "YN.00.14",
    "Farbtonklasse": "02",
    "Rcolor": "56",
    "Gcolor": "56",
    "Bcolor": "56",
    "Y": 4,
    "L": 23.6335392408173,
    "a": 0.07495353969358,
    "b": -0.22488782586135,
    "C": 0.23704971489804,
    "h": -1.24908206663913,
    "CMY_C": 0.7795347,
    "CMY_M": 0.779314,
    "CMY_Y": 0.7800668,
    "CMYK_C": 0.001000094,
    "CMYK_M": 0,
    "CMYK_Y": 0.003410981,
    "CMYK_K": 0.779314
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03686",
    "Farbtonhilfsbezeichnung": "XN.00.10",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "49",
    "Bcolor": "49",
    "Y": 3,
    "L": 20.3518510900593,
    "a": 0.29947363332186,
    "b": -0.52323072513766,
    "C": 0.60287216620365,
    "h": -1.05095223385392,
    "CMY_C": 0.8071889,
    "CMY_M": 0.8078951,
    "CMY_Y": 0.8064067,
    "CMYK_C": 0.004040689,
    "CMYK_M": 0.007688469,
    "CMYK_Y": 0,
    "CMYK_K": 0.8064067
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03687",
    "Farbtonhilfsbezeichnung": "SN.00.21",
    "Farbtonklasse": "02",
    "Rcolor": "67",
    "Gcolor": "67",
    "Bcolor": "68",
    "Y": 6,
    "L": 28.553833905292,
    "a": -0.12118290401771,
    "b": -0.86287203771736,
    "C": 0.87134003104453,
    "h": 1.43126755692002,
    "CMY_C": 0.7391956,
    "CMY_M": 0.7353542,
    "CMY_Y": 0.7331548,
    "CMYK_C": 0.02263781,
    "CMYK_M": 0.008242292,
    "CMYK_Y": 0,
    "CMYK_K": 0.7331548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03688",
    "Farbtonhilfsbezeichnung": "FN.00.21",
    "Farbtonklasse": "02",
    "Rcolor": "71",
    "Gcolor": "71",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.145869623328,
    "a": -0.05201417715042,
    "b": 0.2823613108717,
    "C": 0.28711214621088,
    "h": -1.38862715497714,
    "CMY_C": 0.7212116,
    "CMY_M": 0.721431,
    "CMY_Y": 0.7257626,
    "CMYK_C": 0,
    "CMYK_M": 0.0007869363,
    "CMYK_Y": 0.01632439,
    "CMYK_K": 0.7212116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03689",
    "Farbtonhilfsbezeichnung": "WN.00.20",
    "Farbtonklasse": "02",
    "Rcolor": "71",
    "Gcolor": "71",
    "Bcolor": "71",
    "Y": 6,
    "L": 30.0295210600851,
    "a": 0.54526931854159,
    "b": -0.74238302208764,
    "C": 0.92111409783305,
    "h": -0.93729887783903,
    "CMY_C": 0.7213008,
    "CMY_M": 0.7233939,
    "CMY_Y": 0.7205951,
    "CMYK_C": 0.00252582,
    "CMYK_M": 0.01001689,
    "CMYK_Y": 0,
    "CMYK_K": 0.7205951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03690",
    "Farbtonhilfsbezeichnung": "CN.00.14",
    "Farbtonklasse": "02",
    "Rcolor": "59",
    "Gcolor": "58",
    "Bcolor": "58",
    "Y": 4,
    "L": 24.5258640659717,
    "a": 0.36410748723611,
    "b": -0.00774821743106,
    "C": 0.36418991904603,
    "h": -0.02127681647262,
    "CMY_C": 0.7693731,
    "CMY_M": 0.7721217,
    "CMY_Y": 0.7735668,
    "CMYK_C": 0,
    "CMYK_M": 0.01191783,
    "CMYK_Y": 0.01818422,
    "CMYK_K": 0.7693731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03691",
    "Farbtonhilfsbezeichnung": "A5.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "217",
    "Bcolor": "217",
    "Y": 72,
    "L": 88.1492993769387,
    "a": 7.30992721854645,
    "b": 1.28161712021897,
    "C": 7.42142697756197,
    "h": 0.17356153989183,
    "CMY_C": 0.07268997,
    "CMY_M": 0.1504565,
    "CMY_Y": 0.1479106,
    "CMYK_C": 0,
    "CMYK_M": 0.08386254,
    "CMYK_Y": 0.08111698,
    "CMYK_K": 0.07268997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03692",
    "Farbtonhilfsbezeichnung": "A0.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "213",
    "Bcolor": "218",
    "Y": 71,
    "L": 87.4698505286952,
    "a": 9.68581870460472,
    "b": 0.1520707698875,
    "C": 9.68701241340822,
    "h": 0.0156990628433,
    "CMY_C": 0.06619772,
    "CMY_M": 0.1636153,
    "CMY_Y": 0.1467392,
    "CMYK_C": 0,
    "CMYK_M": 0.1043236,
    "CMYK_Y": 0.08625115,
    "CMYK_K": 0.06619772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03693",
    "Farbtonhilfsbezeichnung": "A1.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "212",
    "Bcolor": "215",
    "Y": 70,
    "L": 87.0835039996669,
    "a": 10.3302297520924,
    "b": 0.86749503898813,
    "C": 10.366590296413,
    "h": 0.08377978467202,
    "CMY_C": 0.06364297,
    "CMY_M": 0.169723,
    "CMY_Y": 0.156119,
    "CMYK_C": 0,
    "CMYK_M": 0.1132902,
    "CMYK_Y": 0.09876146,
    "CMYK_K": 0.06364297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03694",
    "Farbtonhilfsbezeichnung": "A1.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "212",
    "Bcolor": "217",
    "Y": 72,
    "L": 87.9386296094389,
    "a": 12.9517404289239,
    "b": 1.29907973326913,
    "C": 13.0167272496436,
    "h": 0.09996721503776,
    "CMY_C": 0.0336686,
    "CMY_M": 0.1672395,
    "CMY_Y": 0.1495309,
    "CMYK_C": 0,
    "CMYK_M": 0.1382247,
    "CMYK_Y": 0.1198991,
    "CMYK_K": 0.0336686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03695",
    "Farbtonhilfsbezeichnung": "A1.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "204",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.9055811779351,
    "a": 17.0379789289994,
    "b": 0.67415297401529,
    "C": 17.0513110410138,
    "h": 0.03954703131271,
    "CMY_C": 0.02950061,
    "CMY_M": 0.2002551,
    "CMY_Y": 0.1666084,
    "CMYK_C": 0,
    "CMYK_M": 0.1759449,
    "CMYK_Y": 0.1412755,
    "CMYK_K": 0.02950061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03696",
    "Farbtonhilfsbezeichnung": "A5.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "187",
    "Bcolor": "193",
    "Y": 58,
    "L": 80.7550098625218,
    "a": 20.7999716355322,
    "b": 3.68302778369469,
    "C": 21.1235298587715,
    "h": 0.17525236685149,
    "CMY_C": 0.05434152,
    "CMY_M": 0.2674632,
    "CMY_Y": 0.2435576,
    "CMYK_C": 0,
    "CMYK_M": 0.2253686,
    "CMYK_Y": 0.2000893,
    "CMYK_K": 0.05434152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03697",
    "Farbtonhilfsbezeichnung": "A3.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "223",
    "Bcolor": "224",
    "Y": 77,
    "L": 90.1908569335938,
    "a": 6.06959533691406,
    "b": 0.7507455945015,
    "C": 6.11584901809692,
    "h": 7.05107688903809,
    "CMY_C": 0.06072419881821,
    "CMY_M": 0.12458020448685,
    "CMY_Y": 0.12172502279282,
    "CMYK_C": 0,
    "CMYK_M": 0.06798429787159,
    "CMYK_Y": 0.06494452804327,
    "CMYK_K": 0.06072419881821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03698",
    "Farbtonhilfsbezeichnung": "A2.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "212",
    "Bcolor": "214",
    "Y": 69,
    "L": 86.5856437939692,
    "a": 8.3408875168533,
    "b": 0.86920943103061,
    "C": 8.38605566424358,
    "h": 0.10383586585557,
    "CMY_C": 0.08385,
    "CMY_M": 0.170144,
    "CMY_Y": 0.1618635,
    "CMYK_C": 0,
    "CMYK_M": 0.09419196,
    "CMYK_Y": 0.08515365,
    "CMYK_K": 0.08385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03699",
    "Farbtonhilfsbezeichnung": "A2.08.77",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "200",
    "Bcolor": "205",
    "Y": 64,
    "L": 84.0063028674898,
    "a": 15.0816102725389,
    "b": 1.63705410448665,
    "C": 15.1701982371282,
    "h": 0.1081230531044,
    "CMY_C": 0.06208706,
    "CMY_M": 0.2160229,
    "CMY_Y": 0.1945733,
    "CMYK_C": 0,
    "CMYK_M": 0.164126,
    "CMYK_Y": 0.1412564,
    "CMYK_K": 0.06208706
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03700",
    "Farbtonhilfsbezeichnung": "A0.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "205",
    "Bcolor": "210",
    "Y": 66,
    "L": 85.1860342751656,
    "a": 12.0976198880353,
    "b": 0.61077164680316,
    "C": 12.11302806733,
    "h": 0.05044409616464,
    "CMY_C": 0.07294734,
    "CMY_M": 0.1950081,
    "CMY_Y": 0.1747185,
    "CMYK_C": 0,
    "CMYK_M": 0.1316655,
    "CMYK_Y": 0.1097793,
    "CMYK_K": 0.07294734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03701",
    "Farbtonhilfsbezeichnung": "A1.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "205",
    "Bcolor": "214",
    "Y": 69,
    "L": 86.4142603642282,
    "a": 16.9101971674011,
    "b": 0.85015523343907,
    "C": 16.9315543338857,
    "h": 0.05023241541214,
    "CMY_C": 0.0241088,
    "CMY_M": 0.1943937,
    "CMY_Y": 0.1623526,
    "CMYK_C": 0,
    "CMYK_M": 0.1744916,
    "CMYK_Y": 0.141659,
    "CMYK_K": 0.0241088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03702",
    "Farbtonhilfsbezeichnung": "A1.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "193",
    "Bcolor": "202",
    "Y": 61,
    "L": 82.3037261417524,
    "a": 19.0274214514488,
    "b": 1.11859390261946,
    "C": 19.0602733298877,
    "h": 0.05872093165379,
    "CMY_C": 0.0554273,
    "CMY_M": 0.2450366,
    "CMY_Y": 0.2086816,
    "CMYK_C": 0,
    "CMYK_M": 0.2007356,
    "CMYK_Y": 0.1622472,
    "CMYK_K": 0.0554273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03703",
    "Farbtonhilfsbezeichnung": "A4.20.65",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "158",
    "Bcolor": "173",
    "Y": 46,
    "L": 73.3527281730014,
    "a": 32.0326480585942,
    "b": 4.11255882319239,
    "C": 32.295567524352,
    "h": 0.12768797007072,
    "CMY_C": 0.065939,
    "CMY_M": 0.37996,
    "CMY_Y": 0.3233946,
    "CMYK_C": 0,
    "CMYK_M": 0.336189,
    "CMYK_Y": 0.2756304,
    "CMYK_K": 0.065939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03704",
    "Farbtonhilfsbezeichnung": "A5.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "207",
    "Bcolor": "209",
    "Y": 67,
    "L": 85.6309071552073,
    "a": 11.3039273301179,
    "b": 2.0476981851633,
    "C": 11.4878997620151,
    "h": 0.17920591710507,
    "CMY_C": 0.06944617,
    "CMY_M": 0.1885086,
    "CMY_Y": 0.1804569,
    "CMYK_C": 0,
    "CMYK_M": 0.1279479,
    "CMYK_Y": 0.1192953,
    "CMYK_K": 0.06944617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03705",
    "Farbtonhilfsbezeichnung": "A6.07.75",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 60,
    "L": 81.5678736533648,
    "a": 12.935147155475,
    "b": 2.47637244343648,
    "C": 13.170058937317,
    "h": 0.18915646753522,
    "CMY_C": 0.1022607,
    "CMY_M": 0.2371066,
    "CMY_Y": 0.2273197,
    "CMYK_C": 0,
    "CMYK_M": 0.1502061,
    "CMYK_Y": 0.1393044,
    "CMYK_K": 0.1022607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03706",
    "Farbtonhilfsbezeichnung": "A5.12.70",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "179",
    "Bcolor": "185",
    "Y": 53,
    "L": 77.786781845052,
    "a": 20.9779176018153,
    "b": 3.57521010516191,
    "C": 21.2803936571814,
    "h": 0.16880543721532,
    "CMY_C": 0.08714542,
    "CMY_M": 0.2998232,
    "CMY_Y": 0.2744657,
    "CMYK_C": 0,
    "CMYK_M": 0.232981,
    "CMYK_Y": 0.2052027,
    "CMYK_K": 0.08714542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03707",
    "Farbtonhilfsbezeichnung": "A0.16.69",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "171",
    "Bcolor": "186",
    "Y": 51,
    "L": 76.4998049295755,
    "a": 26.5481831419489,
    "b": 1.32702262941895,
    "C": 26.5813283565259,
    "h": 0.04994387254169,
    "CMY_C": 0.07089649,
    "CMY_M": 0.3289205,
    "CMY_Y": 0.2713281,
    "CMYK_C": 0,
    "CMYK_M": 0.2777129,
    "CMYK_Y": 0.2157258,
    "CMYK_K": 0.07089649
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03708",
    "Farbtonhilfsbezeichnung": "A3.30.54",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "119",
    "Bcolor": "144",
    "Y": 31,
    "L": 62.2712359315082,
    "a": 42.9233532743741,
    "b": 4.25564003028467,
    "C": 43.1338003007396,
    "h": 0.09882214257367,
    "CMY_C": 0.1294608,
    "CMY_M": 0.5334085,
    "CMY_Y": 0.4369885,
    "CMYK_C": 0,
    "CMYK_M": 0.46402,
    "CMYK_Y": 0.3532612,
    "CMYK_K": 0.1294608
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03709",
    "Farbtonhilfsbezeichnung": "AN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "213",
    "Bcolor": "212",
    "Y": 67,
    "L": 85.7503143366143,
    "a": 3.11432640924669,
    "b": 0.61145282401065,
    "C": 3.17378378900044,
    "h": 0.1938695292341,
    "CMY_C": 0.1332185,
    "CMY_M": 0.166389,
    "CMY_Y": 0.1698405,
    "CMYK_C": 0,
    "CMYK_M": 0.0382686,
    "CMYK_Y": 0.04225057,
    "CMYK_K": 0.1332185
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03710",
    "Farbtonhilfsbezeichnung": "A4.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "196",
    "Bcolor": "198",
    "Y": 59,
    "L": 81.1189713662364,
    "a": 8.20466419621391,
    "b": 1.13147416148471,
    "C": 8.2823153979272,
    "h": 0.1370418153496,
    "CMY_C": 0.1449303,
    "CMY_M": 0.2295422,
    "CMY_Y": 0.2231369,
    "CMYK_C": 0,
    "CMYK_M": 0.09895327,
    "CMYK_Y": 0.09146225,
    "CMYK_K": 0.1449303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03711",
    "Farbtonhilfsbezeichnung": "A1.05.72",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "192",
    "Bcolor": "196",
    "Y": 56,
    "L": 79.6916864911956,
    "a": 9.83075198599681,
    "b": 0.33185331659437,
    "C": 9.83635152045284,
    "h": 0.03374384308709,
    "CMY_C": 0.1513615,
    "CMY_M": 0.2488196,
    "CMY_Y": 0.2325188,
    "CMYK_C": 0,
    "CMYK_M": 0.1148406,
    "CMYK_Y": 0.09563241,
    "CMYK_K": 0.1513615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03712",
    "Farbtonhilfsbezeichnung": "A4.09.75",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "195",
    "Bcolor": "200",
    "Y": 61,
    "L": 82.4913042290446,
    "a": 16.4969987704353,
    "b": 2.35145679747397,
    "C": 16.6637426018926,
    "h": 0.1415847313678,
    "CMY_C": 0.0673859,
    "CMY_M": 0.236486,
    "CMY_Y": 0.2159336,
    "CMYK_C": 0,
    "CMYK_M": 0.1813184,
    "CMYK_Y": 0.159281,
    "CMYK_K": 0.0673859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03713",
    "Farbtonhilfsbezeichnung": "A4.15.69",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "173",
    "Bcolor": "184",
    "Y": 51,
    "L": 76.9033399086216,
    "a": 24.7873964721263,
    "b": 3.0734713673747,
    "C": 24.9772146187771,
    "h": 0.12336367087628,
    "CMY_C": 0.07346596,
    "CMY_M": 0.3199844,
    "CMY_Y": 0.2797011,
    "CMYK_C": 0,
    "CMYK_M": 0.2660652,
    "CMYK_Y": 0.2225877,
    "CMYK_K": 0.07346596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03714",
    "Farbtonhilfsbezeichnung": "A1.25.58",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "136",
    "Bcolor": "158",
    "Y": 36,
    "L": 66.6022407382806,
    "a": 36.6237041636109,
    "b": 2.45011615696966,
    "C": 36.7055687307299,
    "h": 0.0668001986997,
    "CMY_C": 0.1193242,
    "CMY_M": 0.4653128,
    "CMY_Y": 0.3814083,
    "CMYK_C": 0,
    "CMYK_M": 0.3928671,
    "CMYK_Y": 0.2975942,
    "CMYK_K": 0.1193242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03715",
    "Farbtonhilfsbezeichnung": "A2.35.50",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "101",
    "Bcolor": "131",
    "Y": 25,
    "L": 57.4949478056723,
    "a": 47.6554775517424,
    "b": 4.27432139029149,
    "C": 47.8467800800862,
    "h": 0.08945277164901,
    "CMY_C": 0.158789,
    "CMY_M": 0.6019629,
    "CMY_Y": 0.4843519,
    "CMYK_C": 0,
    "CMYK_M": 0.5268284,
    "CMYK_Y": 0.387017,
    "CMYK_K": 0.158789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03716",
    "Farbtonhilfsbezeichnung": "AN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "204",
    "Bcolor": "201",
    "Y": 61,
    "L": 82.6452073633238,
    "a": 2.99048049206285,
    "b": 1.92631566550816,
    "C": 3.55719912523753,
    "h": 0.57225118952094,
    "CMY_C": 0.1642023,
    "CMY_M": 0.2004622,
    "CMY_Y": 0.2131484,
    "CMYK_C": 0,
    "CMYK_M": 0.04338361,
    "CMYK_Y": 0.05856211,
    "CMYK_K": 0.1642023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03717",
    "Farbtonhilfsbezeichnung": "A0.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "196",
    "Bcolor": "197",
    "Y": 57,
    "L": 80.3174522179944,
    "a": 6.26932428512683,
    "b": 0.2266536622016,
    "C": 6.27342003014866,
    "h": 0.03613706707516,
    "CMY_C": 0.1706882,
    "CMY_M": 0.2331912,
    "CMY_Y": 0.2255242,
    "CMYK_C": 0,
    "CMYK_M": 0.07536728,
    "CMYK_Y": 0.06612233,
    "CMYK_K": 0.1706882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03718",
    "Farbtonhilfsbezeichnung": "A2.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "184",
    "Bcolor": "189",
    "Y": 52,
    "L": 77.0815945788188,
    "a": 9.86363698689358,
    "b": 0.07258121628734,
    "C": 9.86390402640723,
    "h": 0.00735833105052,
    "CMY_C": 0.180658,
    "CMY_M": 0.276894,
    "CMY_Y": 0.2586383,
    "CMYK_C": 0,
    "CMYK_M": 0.1174552,
    "CMYK_Y": 0.09517426,
    "CMYK_K": 0.180658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03719",
    "Farbtonhilfsbezeichnung": "A0.09.69",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "179",
    "Bcolor": "186",
    "Y": 50,
    "L": 76.1447930915466,
    "a": 14.6336175894657,
    "b": 0.31658536115446,
    "C": 14.6370417108656,
    "h": 0.02163074045658,
    "CMY_C": 0.1568878,
    "CMY_M": 0.2992164,
    "CMY_Y": 0.2696976,
    "CMYK_C": 0,
    "CMYK_M": 0.1688134,
    "CMYK_Y": 0.1338017,
    "CMYK_K": 0.1568878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03720",
    "Farbtonhilfsbezeichnung": "A0.11.66",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "173",
    "Bcolor": "184",
    "Y": 48,
    "L": 75.1145682741992,
    "a": 18.8485771455596,
    "b": 0.06275168720355,
    "C": 18.8486816034002,
    "h": 0.00332924097535,
    "CMY_C": 0.1403913,
    "CMY_M": 0.3213919,
    "CMY_Y": 0.2782557,
    "CMYK_C": 0,
    "CMYK_M": 0.2105616,
    "CMYK_Y": 0.1603804,
    "CMYK_K": 0.1403913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03721",
    "Farbtonhilfsbezeichnung": "A1.15.66",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "163",
    "Bcolor": "176",
    "Y": 45,
    "L": 72.9557206922102,
    "a": 24.2760125917297,
    "b": 1.3933138567316,
    "C": 24.3159641153128,
    "h": 0.05733177722527,
    "CMY_C": 0.1255691,
    "CMY_M": 0.3599107,
    "CMY_Y": 0.3096912,
    "CMYK_C": 0,
    "CMYK_M": 0.2679932,
    "CMYK_Y": 0.2105622,
    "CMYK_K": 0.1255691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03722",
    "Farbtonhilfsbezeichnung": "A0.25.56",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "130",
    "Bcolor": "152",
    "Y": 32,
    "L": 63.6671166047943,
    "a": 35.3300724311804,
    "b": 1.54764165872991,
    "C": 35.363953578415,
    "h": 0.04377723476331,
    "CMY_C": 0.1623159,
    "CMY_M": 0.4911488,
    "CMY_Y": 0.4056444,
    "CMYK_C": 0,
    "CMYK_M": 0.3925501,
    "CMYK_Y": 0.2904776,
    "CMYK_K": 0.1623159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03723",
    "Farbtonhilfsbezeichnung": "A0.35.45",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "91",
    "Bcolor": "123",
    "Y": 21,
    "L": 52.5021456231563,
    "a": 45.6254031268402,
    "b": 1.91139373531375,
    "C": 45.6654227671011,
    "h": 0.04186870887539,
    "CMY_C": 0.2312478,
    "CMY_M": 0.6443922,
    "CMY_Y": 0.5186951,
    "CMYK_C": 0,
    "CMYK_M": 0.5374221,
    "CMYK_Y": 0.3739141,
    "CMYK_K": 0.2312478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03724",
    "Farbtonhilfsbezeichnung": "AN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "190",
    "Y": 53,
    "L": 77.8741331103626,
    "a": 3.42959135040832,
    "b": 0.70990099435395,
    "C": 3.50229299924782,
    "h": 0.20411035290173,
    "CMY_C": 0.2169108,
    "CMY_M": 0.2528768,
    "CMY_Y": 0.2556099,
    "CMYK_C": 0,
    "CMYK_M": 0.04592834,
    "CMYK_Y": 0.04941844,
    "CMYK_K": 0.2169108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03725",
    "Farbtonhilfsbezeichnung": "AN.02.73",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "196",
    "Bcolor": "197",
    "Y": 56,
    "L": 79.8931370432084,
    "a": 4.27768358488406,
    "b": -0.05552261232193,
    "C": 4.27804390029668,
    "h": -0.01297886895356,
    "CMY_C": 0.1910106,
    "CMY_M": 0.2328836,
    "CMY_Y": 0.2283368,
    "CMYK_C": 0,
    "CMYK_M": 0.05175967,
    "CMYK_Y": 0.04613925,
    "CMYK_K": 0.1910106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03728",
    "Farbtonhilfsbezeichnung": "A5.14.58",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "149",
    "Bcolor": "156",
    "Y": 36,
    "L": 66.3937742893701,
    "a": 20.2403683264325,
    "b": 2.96626343426301,
    "C": 20.4565693299511,
    "h": 0.1455159804243,
    "CMY_C": 0.2206851,
    "CMY_M": 0.4176057,
    "CMY_Y": 0.3896551,
    "CMYK_C": 0,
    "CMYK_M": 0.2526843,
    "CMYK_Y": 0.2168187,
    "CMYK_K": 0.2206851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03729",
    "Farbtonhilfsbezeichnung": "A5.18.60",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "148",
    "Bcolor": "159",
    "Y": 39,
    "L": 68.4930797569611,
    "a": 28.0787335139642,
    "b": 4.46686336686175,
    "C": 28.4318157015416,
    "h": 0.15776151708401,
    "CMY_C": 0.1449897,
    "CMY_M": 0.4189221,
    "CMY_Y": 0.3771432,
    "CMYK_C": 0,
    "CMYK_M": 0.3203849,
    "CMYK_Y": 0.2715213,
    "CMYK_K": 0.1449897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03730",
    "Farbtonhilfsbezeichnung": "A5.27.50",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "110",
    "Bcolor": "126",
    "Y": 25,
    "L": 57.284729670915,
    "a": 38.4907275137709,
    "b": 7.03488026352317,
    "C": 39.128322796428,
    "h": 0.18077294527331,
    "CMY_C": 0.2066489,
    "CMY_M": 0.5693849,
    "CMY_Y": 0.5063654,
    "CMYK_C": 0,
    "CMYK_M": 0.4572201,
    "CMYK_Y": 0.3777854,
    "CMYK_K": 0.2066489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03731",
    "Farbtonhilfsbezeichnung": "A0.41.42",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "77",
    "Bcolor": "118",
    "Y": 19,
    "L": 50.4084216916319,
    "a": 52.4810028724992,
    "b": 1.49709052289615,
    "C": 52.5023517810109,
    "h": 0.02851859820727,
    "CMY_C": 0.2201029,
    "CMY_M": 0.6978216,
    "CMY_Y": 0.5354175,
    "CMYK_C": 0,
    "CMYK_M": 0.6125406,
    "CMYK_Y": 0.4043028,
    "CMYK_K": 0.2201029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03732",
    "Farbtonhilfsbezeichnung": "A1.03.63",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "171",
    "Bcolor": "172",
    "Y": 42,
    "L": 70.8115594738531,
    "a": 4.48464768008694,
    "b": -0.00894743173536,
    "C": 4.48465660569946,
    "h": -0.00199512213708,
    "CMY_C": 0.2874697,
    "CMY_M": 0.3304735,
    "CMY_Y": 0.3252195,
    "CMYK_C": 0,
    "CMYK_M": 0.0603537,
    "CMYK_Y": 0.05297987,
    "CMYK_K": 0.2874697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03733",
    "Farbtonhilfsbezeichnung": "A5.05.60",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "160",
    "Bcolor": "162",
    "Y": 37,
    "L": 67.5506138788932,
    "a": 7.64927050547337,
    "b": 0.67742784909241,
    "C": 7.67920879756703,
    "h": 0.08833065827159,
    "CMY_C": 0.2977098,
    "CMY_M": 0.3724247,
    "CMY_Y": 0.3636422,
    "CMYK_C": 0,
    "CMYK_M": 0.1063875,
    "CMYK_Y": 0.09388202,
    "CMYK_K": 0.2977098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03734",
    "Farbtonhilfsbezeichnung": "A1.10.55",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "145",
    "Bcolor": "152",
    "Y": 32,
    "L": 63.4901840067367,
    "a": 13.9721697419855,
    "b": 0.62877539768946,
    "C": 13.986310657196,
    "h": 0.04497164459367,
    "CMY_C": 0.2984799,
    "CMY_M": 0.4301865,
    "CMY_Y": 0.4043581,
    "CMYK_C": 0,
    "CMYK_M": 0.1877446,
    "CMYK_Y": 0.1509268,
    "CMYK_K": 0.2984799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03735",
    "Farbtonhilfsbezeichnung": "A5.17.53",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "132",
    "Bcolor": "141",
    "Y": 29,
    "L": 61.0492901882979,
    "a": 23.9831782782729,
    "b": 3.68565964113468,
    "C": 24.264725988927,
    "h": 0.15248394915282,
    "CMY_C": 0.2546724,
    "CMY_M": 0.4833173,
    "CMY_Y": 0.4485769,
    "CMYK_C": 0,
    "CMYK_M": 0.3067709,
    "CMYK_Y": 0.2601601,
    "CMYK_K": 0.2546724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03736",
    "Farbtonhilfsbezeichnung": "A0.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "103",
    "Bcolor": "124",
    "Y": 20,
    "L": 52.1997040528797,
    "a": 31.6619191574652,
    "b": 0.56790006141529,
    "C": 31.6670117821941,
    "h": 0.01793445210827,
    "CMY_C": 0.3134359,
    "CMY_M": 0.5950724,
    "CMY_Y": 0.5151314,
    "CMYK_C": 0,
    "CMYK_M": 0.4102115,
    "CMYK_Y": 0.2937751,
    "CMYK_K": 0.3134359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03737",
    "Farbtonhilfsbezeichnung": "A0.29.39",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "87",
    "Bcolor": "113",
    "Y": 16,
    "L": 47.1366111944444,
    "a": 35.8262912859791,
    "b": -0.56098877478969,
    "C": 35.8306831600134,
    "h": -0.01565729835791,
    "CMY_C": 0.3481407,
    "CMY_M": 0.6592637,
    "CMY_Y": 0.5568193,
    "CMYK_C": 0,
    "CMYK_M": 0.4772854,
    "CMYK_Y": 0.3201281,
    "CMYK_K": 0.3481407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03738",
    "Farbtonhilfsbezeichnung": "A5.38.43",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "84",
    "Bcolor": "109",
    "Y": 19,
    "L": 51.0415553670423,
    "a": 47.6284491108221,
    "b": 7.97708325282476,
    "C": 48.2918525418592,
    "h": 0.16594545061324,
    "CMY_C": 0.2281013,
    "CMY_M": 0.6704551,
    "CMY_Y": 0.5719163,
    "CMYK_C": 0,
    "CMYK_M": 0.5730724,
    "CMYK_Y": 0.4454147,
    "CMYK_K": 0.2281013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03739",
    "Farbtonhilfsbezeichnung": "A4.04.51",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "140",
    "Bcolor": "141",
    "Y": 28,
    "L": 59.6851293234994,
    "a": 7.00726852842459,
    "b": 1.09300685710629,
    "C": 7.09200086147281,
    "h": 0.15473499253591,
    "CMY_C": 0.3838783,
    "CMY_M": 0.4520922,
    "CMY_Y": 0.4472547,
    "CMYK_C": 0,
    "CMYK_M": 0.1107149,
    "CMYK_Y": 0.1028635,
    "CMYK_K": 0.3838783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03740",
    "Farbtonhilfsbezeichnung": "A2.05.60",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "162",
    "Bcolor": "165",
    "Y": 38,
    "L": 68.1323773639731,
    "a": 7.02678219493874,
    "b": 0.03725640837888,
    "C": 7.02688096206798,
    "h": 0.00530200854901,
    "CMY_C": 0.2977367,
    "CMY_M": 0.3646714,
    "CMY_Y": 0.3532243,
    "CMYK_C": 0,
    "CMYK_M": 0.09531285,
    "CMYK_Y": 0.07901251,
    "CMYK_K": 0.2977367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03741",
    "Farbtonhilfsbezeichnung": "A4.10.46",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "121",
    "Bcolor": "127",
    "Y": 22,
    "L": 54.2142474592228,
    "a": 13.920704489275,
    "b": 1.43946643700446,
    "C": 13.9949304071504,
    "h": 0.10303850562299,
    "CMY_C": 0.3950056,
    "CMY_M": 0.5241699,
    "CMY_Y": 0.5034875,
    "CMYK_C": 0,
    "CMYK_M": 0.2134968,
    "CMYK_Y": 0.1793107,
    "CMYK_K": 0.3950056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03742",
    "Farbtonhilfsbezeichnung": "A5.15.49",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "125",
    "Bcolor": "132",
    "Y": 25,
    "L": 57.2400197071642,
    "a": 20.0845586054988,
    "b": 2.94485268785611,
    "C": 20.2993017547621,
    "h": 0.14558536272862,
    "CMY_C": 0.3213891,
    "CMY_M": 0.5106419,
    "CMY_Y": 0.4824883,
    "CMYK_C": 0,
    "CMYK_M": 0.2788826,
    "CMYK_Y": 0.2373956,
    "CMYK_K": 0.3213891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03743",
    "Farbtonhilfsbezeichnung": "A5.17.40",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "101",
    "Bcolor": "109",
    "Y": 17,
    "L": 47.9543156650505,
    "a": 20.157227763989,
    "b": 2.65297729814722,
    "C": 20.3310629253321,
    "h": 0.13086204332718,
    "CMY_C": 0.4203173,
    "CMY_M": 0.6026501,
    "CMY_Y": 0.5718834,
    "CMYK_C": 0,
    "CMYK_M": 0.314539,
    "CMYK_Y": 0.2614638,
    "CMYK_K": 0.4203173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03744",
    "Farbtonhilfsbezeichnung": "A0.24.35",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "90",
    "Bcolor": "107",
    "Y": 14,
    "L": 45.3842315673828,
    "a": 26.874662399292,
    "b": -0.01938005723059,
    "C": 26.8746700286865,
    "h": 359.958679199219,
    "CMY_C": 0.41486322879791,
    "CMY_M": 0.6464564204216,
    "CMY_Y": 0.57856023311615,
    "CMYK_C": 0,
    "CMYK_M": 0.39579325914383,
    "CMYK_Y": 0.27975854277611,
    "CMYK_K": 0.41486322879791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03745",
    "Farbtonhilfsbezeichnung": "A4.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "84",
    "Bcolor": "109",
    "Y": 17,
    "L": 48.5421303788447,
    "a": 42.3388688179588,
    "b": 4.23215929681893,
    "C": 42.5498646895378,
    "h": 0.09962825256711,
    "CMY_C": 0.2897911,
    "CMY_M": 0.6720285,
    "CMY_Y": 0.5728641,
    "CMYK_C": 0,
    "CMYK_M": 0.5382043,
    "CMYK_Y": 0.3985772,
    "CMYK_K": 0.2897911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03746",
    "Farbtonhilfsbezeichnung": "AN.02.45",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "123",
    "Bcolor": "124",
    "Y": 20,
    "L": 52.262861057507,
    "a": 3.40263904773769,
    "b": -0.11723574804489,
    "C": 3.40465809000095,
    "h": -0.03444073529904,
    "CMY_C": 0.4878328,
    "CMY_M": 0.5182055,
    "CMY_Y": 0.5139052,
    "CMYK_C": 0,
    "CMYK_M": 0.0593022,
    "CMYK_Y": 0.05090608,
    "CMYK_K": 0.4878328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03747",
    "Farbtonhilfsbezeichnung": "A3.05.43",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "118",
    "Bcolor": "121",
    "Y": 19,
    "L": 51.0780570250112,
    "a": 7.07874208174603,
    "b": 0.14758255949689,
    "C": 7.08028036674747,
    "h": 0.02084567854258,
    "CMY_C": 0.4744005,
    "CMY_M": 0.5383216,
    "CMY_Y": 0.5268728,
    "CMYK_C": 0,
    "CMYK_M": 0.1216157,
    "CMYK_Y": 0.09983333,
    "CMYK_K": 0.4744005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03748",
    "Farbtonhilfsbezeichnung": "A2.07.35",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "99",
    "Y": 13,
    "L": 42.2227378837558,
    "a": 7.50097997714949,
    "b": 0.13975195123863,
    "C": 7.50228173461065,
    "h": 0.0186290037828,
    "CMY_C": 0.5600101,
    "CMY_M": 0.6251875,
    "CMY_Y": 0.6124396,
    "CMYK_C": 0,
    "CMYK_M": 0.1481337,
    "CMYK_Y": 0.1191607,
    "CMYK_K": 0.5600101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03749",
    "Farbtonhilfsbezeichnung": "A5.13.37",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "99",
    "Bcolor": "104",
    "Y": 15,
    "L": 45.3547955389433,
    "a": 14.810949917584,
    "b": 1.95332291900501,
    "C": 14.9392003764288,
    "h": 0.13112695337068,
    "CMY_C": 0.479978,
    "CMY_M": 0.6133512,
    "CMY_Y": 0.5931537,
    "CMYK_C": 0,
    "CMYK_M": 0.256476,
    "CMYK_Y": 0.2176364,
    "CMYK_K": 0.479978
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03750",
    "Farbtonhilfsbezeichnung": "A5.15.43",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "111",
    "Bcolor": "117",
    "Y": 19,
    "L": 51.1009628590953,
    "a": 17.7152808684823,
    "b": 2.60414547148271,
    "C": 17.9056625089903,
    "h": 0.14595463380253,
    "CMY_C": 0.4017244,
    "CMY_M": 0.5651984,
    "CMY_Y": 0.5413161,
    "CMYK_C": 0,
    "CMYK_M": 0.2732419,
    "CMYK_Y": 0.2333233,
    "CMYK_K": 0.4017244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03751",
    "Farbtonhilfsbezeichnung": "A4.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "93",
    "Bcolor": "103",
    "Y": 14,
    "L": 44.6429975571487,
    "a": 20.7021151669302,
    "b": 1.57725518973446,
    "C": 20.7621122797846,
    "h": 0.07604121453264,
    "CMY_C": 0.4540199,
    "CMY_M": 0.6358795,
    "CMY_Y": 0.5967373,
    "CMYK_C": 0,
    "CMYK_M": 0.3330883,
    "CMYK_Y": 0.2613966,
    "CMYK_K": 0.4540199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03752",
    "Farbtonhilfsbezeichnung": "A5.33.33",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "74",
    "Bcolor": "90",
    "Y": 13,
    "L": 42.1569398282339,
    "a": 35.4612621979739,
    "b": 6.00192612209104,
    "C": 35.9655979214651,
    "h": 0.16766408004474,
    "CMY_C": 0.3935797,
    "CMY_M": 0.7090295,
    "CMY_Y": 0.645869,
    "CMYK_C": 0,
    "CMYK_M": 0.5201835,
    "CMYK_Y": 0.4160305,
    "CMYK_K": 0.3935797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03754",
    "Farbtonhilfsbezeichnung": "A3.05.30",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "87",
    "Bcolor": "90",
    "Y": 10,
    "L": 38.4114464983443,
    "a": 5.75890343832819,
    "b": -0.16328909401874,
    "C": 5.76121793896167,
    "h": -0.02834660409409,
    "CMY_C": 0.6086718,
    "CMY_M": 0.6572177,
    "CMY_Y": 0.646672,
    "CMYK_C": 0,
    "CMYK_M": 0.124054,
    "CMYK_Y": 0.0971055,
    "CMYK_K": 0.6086718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03755",
    "Farbtonhilfsbezeichnung": "A1.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "70",
    "Y": 6,
    "L": 29.7114708255281,
    "a": 8.40979096411992,
    "b": -0.49654115599665,
    "C": 8.4244369057992,
    "h": -0.05897475505401,
    "CMY_C": 0.6759836,
    "CMY_M": 0.7427366,
    "CMY_Y": 0.7240171,
    "CMYK_C": 0,
    "CMYK_M": 0.2060174,
    "CMYK_Y": 0.1482438,
    "CMYK_K": 0.6759836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03756",
    "Farbtonhilfsbezeichnung": "A2.14.30",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "83",
    "Bcolor": "91",
    "Y": 11,
    "L": 38.9574119364844,
    "a": 15.0415404189269,
    "b": 0.34778086090512,
    "C": 15.0455604648489,
    "h": 0.02311724044615,
    "CMY_C": 0.5467883,
    "CMY_M": 0.6742523,
    "CMY_Y": 0.6435723,
    "CMYK_C": 0,
    "CMYK_M": 0.2812459,
    "CMYK_Y": 0.2135514,
    "CMYK_K": 0.5467883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03757",
    "Farbtonhilfsbezeichnung": "A3.19.25",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "67",
    "Bcolor": "77",
    "Y": 8,
    "L": 33.3563861938491,
    "a": 19.1874969318978,
    "b": 0.85567696848782,
    "C": 19.2065671473584,
    "h": 0.0445660213624,
    "CMY_C": 0.5787388,
    "CMY_M": 0.7372743,
    "CMY_Y": 0.6978368,
    "CMYK_C": 0,
    "CMYK_M": 0.3763354,
    "CMYK_Y": 0.2827177,
    "CMYK_K": 0.5787388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03758",
    "Farbtonhilfsbezeichnung": "A2.24.30",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "76",
    "Bcolor": "90",
    "Y": 11,
    "L": 39.3239322270386,
    "a": 25.4531518739655,
    "b": 1.9898901897175,
    "C": 25.5308167375485,
    "h": 0.07801984638208,
    "CMY_C": 0.4825096,
    "CMY_M": 0.7006583,
    "CMY_Y": 0.6489009,
    "CMYK_C": 0,
    "CMYK_M": 0.421551,
    "CMYK_Y": 0.3215349,
    "CMYK_K": 0.4825096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03759",
    "Farbtonhilfsbezeichnung": "ZN.01.17",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "63",
    "Bcolor": "64",
    "Y": 5,
    "L": 27.0089899336196,
    "a": 1.01706717142416,
    "b": -0.6540657991757,
    "C": 1.20922607515721,
    "h": -0.57150227773883,
    "CMY_C": 0.7451429,
    "CMY_M": 0.7513497,
    "CMY_Y": 0.7479747,
    "CMYK_C": 0,
    "CMYK_M": 0.02435402,
    "CMYK_Y": 0.01111124,
    "CMYK_K": 0.7451429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03760",
    "Farbtonhilfsbezeichnung": "A1.05.14",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "61",
    "Bcolor": "62",
    "Y": 5,
    "L": 26.3382551304408,
    "a": 3.51167222236573,
    "b": -0.25036328763052,
    "C": 3.52058568609375,
    "h": -0.0711741781546,
    "CMY_C": 0.7348517,
    "CMY_M": 0.7622912,
    "CMY_Y": 0.755978,
    "CMYK_C": 0,
    "CMYK_M": 0.1034874,
    "CMYK_Y": 0.07967753,
    "CMYK_K": 0.7348517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03761",
    "Farbtonhilfsbezeichnung": "A1.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "75",
    "Bcolor": "78",
    "Y": 8,
    "L": 33.0612119542412,
    "a": 5.00188157328704,
    "b": -0.48590352091875,
    "C": 5.02542749473413,
    "h": -0.09684028347333,
    "CMY_C": 0.664866,
    "CMY_M": 0.7050022,
    "CMY_Y": 0.6941917,
    "CMYK_C": 0,
    "CMYK_M": 0.1197616,
    "CMYK_Y": 0.08750433,
    "CMYK_K": 0.664866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03762",
    "Farbtonhilfsbezeichnung": "A2.10.14",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "57",
    "Bcolor": "60",
    "Y": 5,
    "L": 25.4638544362897,
    "a": 7.17208887255116,
    "b": -0.09746255382355,
    "C": 7.1727510583576,
    "h": -0.01358830835997,
    "CMY_C": 0.7212405,
    "CMY_M": 0.7776654,
    "CMY_Y": 0.7641106,
    "CMYK_C": 0,
    "CMYK_M": 0.2024143,
    "CMYK_Y": 0.153789,
    "CMYK_K": 0.7212405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03763",
    "Farbtonhilfsbezeichnung": "A4.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "79",
    "Bcolor": "84",
    "Y": 10,
    "L": 36.9309605187071,
    "a": 14.4193491187153,
    "b": 1.50152190175457,
    "C": 14.4973168906817,
    "h": 0.10375847385081,
    "CMY_C": 0.5679994,
    "CMY_M": 0.6918597,
    "CMY_Y": 0.6696535,
    "CMYK_C": 0,
    "CMYK_M": 0.2867134,
    "CMYK_Y": 0.2353101,
    "CMYK_K": 0.5679994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03764",
    "Farbtonhilfsbezeichnung": "A3.23.20",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "58",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.6863865834165,
    "a": 20.3840084543642,
    "b": 1.5530148108364,
    "C": 20.4430833210225,
    "h": 0.07604099859632,
    "CMY_C": 0.6077094,
    "CMY_M": 0.7741632,
    "CMY_Y": 0.7348686,
    "CMYK_C": 0,
    "CMYK_M": 0.4243126,
    "CMYK_Y": 0.3241453,
    "CMYK_K": 0.6077094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03765",
    "Farbtonhilfsbezeichnung": "A0.33.24",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "57",
    "Bcolor": "79",
    "Y": 8,
    "L": 33.5945334712209,
    "a": 31.8896954574397,
    "b": 0.56174805189327,
    "C": 31.8946427671177,
    "h": 0.01761352534395,
    "CMY_C": 0.5118155,
    "CMY_M": 0.7761282,
    "CMY_Y": 0.692078,
    "CMYK_C": 0,
    "CMYK_M": 0.5414197,
    "CMYK_Y": 0.3692507,
    "CMYK_K": 0.5118155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03766",
    "Farbtonhilfsbezeichnung": "A1.36.22",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "49",
    "Bcolor": "72",
    "Y": 7,
    "L": 30.6879389875228,
    "a": 33.0581234489093,
    "b": 0.42713601013055,
    "C": 33.06088279424,
    "h": 0.01292003896179,
    "CMY_C": 0.5367506,
    "CMY_M": 0.8081685,
    "CMY_Y": 0.7174131,
    "CMYK_C": 0,
    "CMYK_M": 0.5859002,
    "CMYK_Y": 0.3899898,
    "CMYK_K": 0.5367506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03767",
    "Farbtonhilfsbezeichnung": "AN.01.13",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "59",
    "Bcolor": "60",
    "Y": 4,
    "L": 24.8852394750652,
    "a": 0.97159081052919,
    "b": -1.20733964936833,
    "C": 1.54972827684134,
    "h": -0.89317367552924,
    "CMY_C": 0.7657248,
    "CMY_M": 0.769847,
    "CMY_Y": 0.7634007,
    "CMYK_C": 0.009823325,
    "CMYK_M": 0.02724586,
    "CMYK_Y": 0,
    "CMYK_K": 0.7634007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03768",
    "Farbtonhilfsbezeichnung": "A2.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "60",
    "Bcolor": "61",
    "Y": 5,
    "L": 25.8931144524031,
    "a": 3.29133468957216,
    "b": -0.18877463030244,
    "C": 3.29674383290951,
    "h": -0.05729227136893,
    "CMY_C": 0.7399961,
    "CMY_M": 0.7657782,
    "CMY_Y": 0.7602679,
    "CMYK_C": 0,
    "CMYK_M": 0.09916058,
    "CMYK_Y": 0.07796714,
    "CMYK_K": 0.7399961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03769",
    "Farbtonhilfsbezeichnung": "A1.10.11",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "50",
    "Bcolor": "53",
    "Y": 4,
    "L": 22.0775152835293,
    "a": 6.16881997113056,
    "b": -0.35233560568726,
    "C": 6.17887370118974,
    "h": -0.05705357382167,
    "CMY_C": 0.7578498,
    "CMY_M": 0.8047351,
    "CMY_Y": 0.7920475,
    "CMYK_C": 0,
    "CMYK_M": 0.193621,
    "CMYK_Y": 0.1412253,
    "CMYK_K": 0.7578498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03770",
    "Farbtonhilfsbezeichnung": "A2.14.10",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "44",
    "Bcolor": "49",
    "Y": 3,
    "L": 20.3345166847104,
    "a": 9.5468753189305,
    "b": 0.1148836933592,
    "C": 9.54756652860844,
    "h": 0.01203306261179,
    "CMY_C": 0.7543074,
    "CMY_M": 0.827069,
    "CMY_Y": 0.8091223,
    "CMYK_C": 0,
    "CMYK_M": 0.296149,
    "CMYK_Y": 0.2231037,
    "CMYK_K": 0.7543074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03771",
    "Farbtonhilfsbezeichnung": "A2.16.14",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "52",
    "Bcolor": "57",
    "Y": 4,
    "L": 24.7016899257057,
    "a": 11.9143119611266,
    "b": 1.02245528105462,
    "C": 11.9581037087324,
    "h": 0.08560765549643,
    "CMY_C": 0.7002404,
    "CMY_M": 0.7954625,
    "CMY_Y": 0.7766537,
    "CMYK_C": 0,
    "CMYK_M": 0.3176619,
    "CMYK_Y": 0.2549155,
    "CMYK_K": 0.7002404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03772",
    "Farbtonhilfsbezeichnung": "A1.23.16",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "50",
    "Bcolor": "60",
    "Y": 5,
    "L": 26.1480085869455,
    "a": 20.0641832299401,
    "b": 1.35581013986554,
    "C": 20.1099395777305,
    "h": 0.06747108152965,
    "CMY_C": 0.6444637,
    "CMY_M": 0.804724,
    "CMY_Y": 0.7649357,
    "CMYK_C": 0,
    "CMYK_M": 0.4507565,
    "CMYK_Y": 0.3388458,
    "CMYK_K": 0.6444637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03773",
    "Farbtonhilfsbezeichnung": "A0.34.17",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "49",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.0426512777542,
    "a": 29.2697282560829,
    "b": 0.26622322491233,
    "C": 29.2709389495865,
    "h": 0.00909526325432,
    "CMY_C": 0.5723018,
    "CMY_M": 0.8087989,
    "CMY_Y": 0.7317499,
    "CMYK_C": 0,
    "CMYK_M": 0.5529532,
    "CMYK_Y": 0.3728051,
    "CMYK_K": 0.5723018
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03774",
    "Farbtonhilfsbezeichnung": "A8.06.78",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "205",
    "Bcolor": "206",
    "Y": 66,
    "L": 84.9833167130916,
    "a": 11.4208545899713,
    "b": 2.52070948528191,
    "C": 11.6957212635416,
    "h": 0.21722848416028,
    "CMY_C": 0.07452841,
    "CMY_M": 0.1960322,
    "CMY_Y": 0.1909278,
    "CMYK_C": 0,
    "CMYK_M": 0.1312885,
    "CMYK_Y": 0.125773,
    "CMYK_K": 0.07452841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03775",
    "Farbtonhilfsbezeichnung": "A8.07.78",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "202",
    "Bcolor": "204",
    "Y": 65,
    "L": 84.2400741577148,
    "a": 13.3212404251099,
    "b": 2.63976359367371,
    "C": 13.5802726745606,
    "h": 11.2086372375488,
    "CMY_C": 0.06902766227722,
    "CMY_M": 0.20907908678055,
    "CMY_Y": 0.1995764374733,
    "CMYK_C": 0,
    "CMYK_M": 0.15043564140797,
    "CMYK_Y": 0.14022842049599,
    "CMYK_K": 0.06902766227722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03776",
    "Farbtonhilfsbezeichnung": "A7.10.76",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "197",
    "Bcolor": "200",
    "Y": 63,
    "L": 83.64757180055,
    "a": 17.3658299681411,
    "b": 3.89208522643598,
    "C": 17.7966395112175,
    "h": 0.22047972635195,
    "CMY_C": 0.04415563,
    "CMY_M": 0.226728,
    "CMY_Y": 0.2144637,
    "CMYK_C": 0,
    "CMYK_M": 0.1910063,
    "CMYK_Y": 0.1781756,
    "CMYK_K": 0.04415563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03777",
    "Farbtonhilfsbezeichnung": "A7.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "185",
    "Bcolor": "191",
    "Y": 56,
    "L": 79.9850311279297,
    "a": 19.7817611694336,
    "b": 3.32685828208923,
    "C": 20.0595626831055,
    "h": 9.54655838012695,
    "CMY_C": 0.07081484794617,
    "CMY_M": 0.27277249097824,
    "CMY_Y": 0.24940741062164,
    "CMYK_C": 0,
    "CMYK_M": 0.21734918653965,
    "CMYK_Y": 0.19220341742039,
    "CMYK_K": 0.07081484794617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03778",
    "Farbtonhilfsbezeichnung": "A8.17.69",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "168",
    "Bcolor": "173",
    "Y": 49,
    "L": 75.6735940648179,
    "a": 27.0571737159875,
    "b": 6.94674949576404,
    "C": 27.9347091993818,
    "h": 0.25131520910831,
    "CMY_C": 0.0641023,
    "CMY_M": 0.3409202,
    "CMY_Y": 0.3197989,
    "CMYK_C": 0,
    "CMYK_M": 0.295778,
    "CMYK_Y": 0.27321,
    "CMYK_K": 0.0641023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03779",
    "Farbtonhilfsbezeichnung": "A8.20.65",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "158",
    "Bcolor": "166",
    "Y": 46,
    "L": 73.3951861141834,
    "a": 31.4431726717754,
    "b": 7.68254350351221,
    "C": 32.3681105773945,
    "h": 0.2396361085365,
    "CMY_C": 0.06152841,
    "CMY_M": 0.3787318,
    "CMY_Y": 0.3481109,
    "CMYK_C": 0,
    "CMYK_M": 0.338,
    "CMYK_Y": 0.3053715,
    "CMYK_K": 0.06152841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03780",
    "Farbtonhilfsbezeichnung": "A6.06.76",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "200",
    "Bcolor": "201",
    "Y": 62,
    "L": 82.9654594861638,
    "a": 10.8441422368048,
    "b": 2.12019680841427,
    "C": 11.0494640303711,
    "h": 0.19307974930138,
    "CMY_C": 0.1024531,
    "CMY_M": 0.2164396,
    "CMY_Y": 0.2099707,
    "CMYK_C": 0,
    "CMYK_M": 0.1269979,
    "CMYK_Y": 0.1197905,
    "CMYK_K": 0.1024531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03781",
    "Farbtonhilfsbezeichnung": "A9.07.73",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "192",
    "Bcolor": "193",
    "Y": 58,
    "L": 80.5183031468605,
    "a": 12.6398081743939,
    "b": 2.96142649755922,
    "C": 12.9820952694825,
    "h": 0.23014244976343,
    "CMY_C": 0.114727,
    "CMY_M": 0.2478313,
    "CMY_Y": 0.2421388,
    "CMYK_C": 0,
    "CMYK_M": 0.150354,
    "CMYK_Y": 0.1439238,
    "CMYK_K": 0.114727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03782",
    "Farbtonhilfsbezeichnung": "A8.08.72",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "189",
    "Bcolor": "191",
    "Y": 56,
    "L": 79.7805988047159,
    "a": 13.152657630657,
    "b": 2.97290202206619,
    "C": 13.484455835594,
    "h": 0.22229508782118,
    "CMY_C": 0.1193588,
    "CMY_M": 0.2571263,
    "CMY_Y": 0.2500525,
    "CMYK_C": 0,
    "CMYK_M": 0.15644,
    "CMYK_Y": 0.1484075,
    "CMYK_K": 0.1193588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03783",
    "Farbtonhilfsbezeichnung": "A8.12.69",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "176",
    "Bcolor": "179",
    "Y": 51,
    "L": 76.6905270168329,
    "a": 20.066152888676,
    "b": 5.25719262337982,
    "C": 20.7433981312378,
    "h": 0.2562340028003,
    "CMY_C": 0.1014248,
    "CMY_M": 0.3094839,
    "CMY_Y": 0.2982105,
    "CMYK_C": 0,
    "CMYK_M": 0.2315434,
    "CMYK_Y": 0.2189975,
    "CMYK_K": 0.1014248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03784",
    "Farbtonhilfsbezeichnung": "A6.16.63",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "156",
    "Bcolor": "165",
    "Y": 41,
    "L": 70.4703883372922,
    "a": 24.1229954052077,
    "b": 3.81806263782161,
    "C": 24.423278027857,
    "h": 0.15697268838047,
    "CMY_C": 0.1487677,
    "CMY_M": 0.3863475,
    "CMY_Y": 0.3527325,
    "CMYK_C": 0,
    "CMYK_M": 0.2791011,
    "CMYK_Y": 0.2396112,
    "CMYK_K": 0.1487677
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03785",
    "Farbtonhilfsbezeichnung": "A6.18.63",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "154",
    "Bcolor": "165",
    "Y": 42,
    "L": 70.8613306909995,
    "a": 28.1004268087506,
    "b": 4.59392365136591,
    "C": 28.4734634589564,
    "h": 0.16204882707738,
    "CMY_C": 0.1177267,
    "CMY_M": 0.394235,
    "CMY_Y": 0.3534465,
    "CMYK_C": 0,
    "CMYK_M": 0.3134044,
    "CMYK_Y": 0.2671732,
    "CMYK_K": 0.1177267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03786",
    "Farbtonhilfsbezeichnung": "A6.22.63",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "148",
    "Bcolor": "161",
    "Y": 41,
    "L": 70.2224073900745,
    "a": 33.5624162730018,
    "b": 5.9983224824276,
    "C": 34.0942173789845,
    "h": 0.1768542025014,
    "CMY_C": 0.08872498,
    "CMY_M": 0.4184327,
    "CMY_Y": 0.3689707,
    "CMYK_C": 0,
    "CMYK_M": 0.3618093,
    "CMYK_Y": 0.3075314,
    "CMYK_K": 0.08872498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03787",
    "Farbtonhilfsbezeichnung": "A9.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "211",
    "Bcolor": "211",
    "Y": 69,
    "L": 86.674357332563,
    "a": 9.96348558971721,
    "b": 2.59021283777785,
    "C": 10.2946708369667,
    "h": 0.25434047397321,
    "CMY_C": 0.06580193,
    "CMY_M": 0.1737819,
    "CMY_Y": 0.1732453,
    "CMYK_C": 0,
    "CMYK_M": 0.1155857,
    "CMYK_Y": 0.1150113,
    "CMYK_K": 0.06580193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03788",
    "Farbtonhilfsbezeichnung": "A8.06.75",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "198",
    "Bcolor": "199",
    "Y": 61,
    "L": 82.2974614061017,
    "a": 10.2413014581074,
    "b": 2.58033491267224,
    "C": 10.5613627822071,
    "h": 0.24681669524403,
    "CMY_C": 0.1129017,
    "CMY_M": 0.222295,
    "CMY_Y": 0.2206026,
    "CMYK_C": 0,
    "CMYK_M": 0.1233159,
    "CMYK_Y": 0.1214081,
    "CMYK_K": 0.1129017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03789",
    "Farbtonhilfsbezeichnung": "A7.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "189",
    "Bcolor": "192",
    "Y": 57,
    "L": 79.9030889187306,
    "a": 13.9207084886277,
    "b": 2.62174209082797,
    "C": 14.1654388006927,
    "h": 0.18615346047471,
    "CMY_C": 0.113614,
    "CMY_M": 0.2577103,
    "CMY_Y": 0.2461053,
    "CMYK_C": 0,
    "CMYK_M": 0.1625661,
    "CMYK_Y": 0.1494736,
    "CMYK_K": 0.113614
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03790",
    "Farbtonhilfsbezeichnung": "A6.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "177",
    "Bcolor": "181",
    "Y": 50,
    "L": 76.1550077418491,
    "a": 16.3045111460144,
    "b": 3.35966726346535,
    "C": 16.6470552300312,
    "h": 0.20321326328179,
    "CMY_C": 0.1372271,
    "CMY_M": 0.3044133,
    "CMY_Y": 0.290967,
    "CMYK_C": 0,
    "CMYK_M": 0.1937778,
    "CMYK_Y": 0.1781928,
    "CMYK_K": 0.1372271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03791",
    "Farbtonhilfsbezeichnung": "A8.13.65",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "163",
    "Bcolor": "168",
    "Y": 43,
    "L": 71.8861206827475,
    "a": 19.8392622135652,
    "b": 4.32595462529159,
    "C": 20.305423132717,
    "h": 0.2146897370033,
    "CMY_C": 0.1591113,
    "CMY_M": 0.3595189,
    "CMY_Y": 0.3421754,
    "CMYK_C": 0,
    "CMYK_M": 0.2383284,
    "CMYK_Y": 0.2177031,
    "CMYK_K": 0.1591113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03792",
    "Farbtonhilfsbezeichnung": "A7.19.60",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "148",
    "Bcolor": "157",
    "Y": 39,
    "L": 68.8349380493164,
    "a": 28.9442481994629,
    "b": 5.88945388793945,
    "C": 29.5373516082764,
    "h": 11.5012922286987,
    "CMY_C": 0.13278305530548,
    "CMY_M": 0.41835165023804,
    "CMY_Y": 0.38332796096802,
    "CMYK_C": 0,
    "CMYK_M": 0.32929313182831,
    "CMYK_Y": 0.28890684247017,
    "CMYK_K": 0.13278305530548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03793",
    "Farbtonhilfsbezeichnung": "A6.23.61",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "145",
    "Bcolor": "157",
    "Y": 39,
    "L": 69.0230076176479,
    "a": 33.7588468736412,
    "b": 6.22889130794775,
    "C": 34.3286881363705,
    "h": 0.1824592712665,
    "CMY_C": 0.1008944,
    "CMY_M": 0.4317204,
    "CMY_Y": 0.3829426,
    "CMYK_C": 0,
    "CMYK_M": 0.3679501,
    "CMYK_Y": 0.3136987,
    "CMYK_K": 0.1008944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03794",
    "Farbtonhilfsbezeichnung": "A8.28.56",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "127",
    "Bcolor": "139",
    "Y": 32,
    "L": 63.4744491820184,
    "a": 37.3523849767941,
    "b": 8.81068265542999,
    "C": 38.3774516130153,
    "h": 0.23164579510533,
    "CMY_C": 0.1389661,
    "CMY_M": 0.5022866,
    "CMY_Y": 0.4566505,
    "CMYK_C": 0,
    "CMYK_M": 0.4219584,
    "CMYK_Y": 0.3689569,
    "CMYK_K": 0.1389661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03795",
    "Farbtonhilfsbezeichnung": "A8.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "195",
    "Bcolor": "194",
    "Y": 57,
    "L": 80.2081257319335,
    "a": 6.77241248756844,
    "b": 1.9561018529699,
    "C": 7.04924856711445,
    "h": 0.28118138553332,
    "CMY_C": 0.1629293,
    "CMY_M": 0.2360978,
    "CMY_Y": 0.239081,
    "CMYK_C": 0,
    "CMYK_M": 0.08741016,
    "CMYK_Y": 0.09097403,
    "CMYK_K": 0.1629293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03796",
    "Farbtonhilfsbezeichnung": "A8.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "192",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.9884050263642,
    "a": 9.52028171927316,
    "b": 2.01030149709027,
    "C": 9.73021459802044,
    "h": 0.20810281957056,
    "CMY_C": 0.1453752,
    "CMY_M": 0.2453174,
    "CMY_Y": 0.2414373,
    "CMYK_C": 0,
    "CMYK_M": 0.1169428,
    "CMYK_Y": 0.1124027,
    "CMYK_K": 0.1453752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03797",
    "Farbtonhilfsbezeichnung": "A7.12.67",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "172",
    "Bcolor": "177",
    "Y": 48,
    "L": 75.1106906322478,
    "a": 19.6631917999189,
    "b": 3.82437570994885,
    "C": 20.031648991814,
    "h": 0.19209590830796,
    "CMY_C": 0.1253813,
    "CMY_M": 0.32478,
    "CMY_Y": 0.3048,
    "CMYK_C": 0,
    "CMYK_M": 0.2279837,
    "CMYK_Y": 0.2051393,
    "CMYK_K": 0.1253813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03798",
    "Farbtonhilfsbezeichnung": "A6.12.63",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "161",
    "Bcolor": "167",
    "Y": 42,
    "L": 70.8592050178812,
    "a": 19.2382834538278,
    "b": 3.02810288317499,
    "C": 19.4751369012112,
    "h": 0.15611898878107,
    "CMY_C": 0.1775957,
    "CMY_M": 0.3682906,
    "CMY_Y": 0.3439049,
    "CMYK_C": 0,
    "CMYK_M": 0.2318749,
    "CMYK_Y": 0.2022231,
    "CMYK_K": 0.1775957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03799",
    "Farbtonhilfsbezeichnung": "A6.18.61",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "151",
    "Bcolor": "160",
    "Y": 40,
    "L": 69.2899411248793,
    "a": 27.395857178433,
    "b": 5.13099446557435,
    "C": 27.8722100800574,
    "h": 0.18514593392475,
    "CMY_C": 0.1387352,
    "CMY_M": 0.4087364,
    "CMY_Y": 0.373613,
    "CMYK_C": 0,
    "CMYK_M": 0.3134938,
    "CMYK_Y": 0.2727126,
    "CMYK_K": 0.1387352
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03800",
    "Farbtonhilfsbezeichnung": "A7.24.57",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "132",
    "Bcolor": "144",
    "Y": 34,
    "L": 64.7284957872063,
    "a": 34.9557689907227,
    "b": 7.59859544188559,
    "C": 35.7721181707516,
    "h": 0.21404744114991,
    "CMY_C": 0.1405326,
    "CMY_M": 0.4808033,
    "CMY_Y": 0.4361233,
    "CMYK_C": 0,
    "CMYK_M": 0.3959088,
    "CMYK_Y": 0.3439231,
    "CMYK_K": 0.1405326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03801",
    "Farbtonhilfsbezeichnung": "A6.30.54",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "118",
    "Bcolor": "137",
    "Y": 30,
    "L": 61.6695018679798,
    "a": 41.9887699512911,
    "b": 7.22680474032387,
    "C": 42.6061440261521,
    "h": 0.17044289225763,
    "CMY_C": 0.1364414,
    "CMY_M": 0.5371394,
    "CMY_Y": 0.4632741,
    "CMYK_C": 0,
    "CMYK_M": 0.4640079,
    "CMYK_Y": 0.378472,
    "CMYK_K": 0.1364414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03802",
    "Farbtonhilfsbezeichnung": "A6.32.51",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "111",
    "Bcolor": "130",
    "Y": 27,
    "L": 59.3967529447813,
    "a": 42.800727896088,
    "b": 7.76931964160574,
    "C": 43.5001682310357,
    "h": 0.17956781933835,
    "CMY_C": 0.1573846,
    "CMY_M": 0.5639282,
    "CMY_Y": 0.489518,
    "CMYK_C": 0,
    "CMYK_M": 0.4824783,
    "CMYK_Y": 0.3941697,
    "CMYK_K": 0.1573846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03803",
    "Farbtonhilfsbezeichnung": "A8.05.69",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "186",
    "Bcolor": "188",
    "Y": 52,
    "L": 77.4615823108548,
    "a": 8.11732989099417,
    "b": 1.4517622087677,
    "C": 8.2461298843781,
    "h": 0.17697615080451,
    "CMY_C": 0.1849016,
    "CMY_M": 0.2688649,
    "CMY_Y": 0.2646709,
    "CMYK_C": 0,
    "CMYK_M": 0.1030101,
    "CMYK_Y": 0.09786464,
    "CMYK_K": 0.1849016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03805",
    "Farbtonhilfsbezeichnung": "A6.09.63",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "164",
    "Bcolor": "168",
    "Y": 42,
    "L": 70.8683079408472,
    "a": 14.3441381577541,
    "b": 2.40748618546955,
    "C": 14.544768448551,
    "h": 0.16628777851449,
    "CMY_C": 0.2113613,
    "CMY_M": 0.354949,
    "CMY_Y": 0.3401893,
    "CMYK_C": 0,
    "CMYK_M": 0.1820704,
    "CMYK_Y": 0.1633549,
    "CMYK_K": 0.2113613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03806",
    "Farbtonhilfsbezeichnung": "A7.15.59",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "151",
    "Bcolor": "157",
    "Y": 38,
    "L": 67.7520980368639,
    "a": 21.3079680380772,
    "b": 4.4395885656902,
    "C": 21.7655564721954,
    "h": 0.20541466504213,
    "CMY_C": 0.1954696,
    "CMY_M": 0.4069005,
    "CMY_Y": 0.3856688,
    "CMYK_C": 0,
    "CMYK_M": 0.2628004,
    "CMYK_Y": 0.2364102,
    "CMYK_K": 0.1954696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03807",
    "Farbtonhilfsbezeichnung": "A8.20.55",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "132",
    "Bcolor": "140",
    "Y": 32,
    "L": 62.9529326043029,
    "a": 29.2319570420352,
    "b": 7.08229501539863,
    "C": 30.0776697101443,
    "h": 0.23769892652323,
    "CMY_C": 0.1951709,
    "CMY_M": 0.4805638,
    "CMY_Y": 0.4515533,
    "CMYK_C": 0,
    "CMYK_M": 0.3546006,
    "CMYK_Y": 0.3185551,
    "CMYK_K": 0.1951709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03808",
    "Farbtonhilfsbezeichnung": "A6.24.53",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "123",
    "Bcolor": "137",
    "Y": 29,
    "L": 60.7053076800569,
    "a": 33.5364870407095,
    "b": 5.56169438341665,
    "C": 33.9945349644057,
    "h": 0.16434434329929,
    "CMY_C": 0.1983842,
    "CMY_M": 0.5169154,
    "CMY_Y": 0.4631976,
    "CMYK_C": 0,
    "CMYK_M": 0.3973615,
    "CMYK_Y": 0.3303495,
    "CMYK_K": 0.1983842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03809",
    "Farbtonhilfsbezeichnung": "A6.34.45",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "101",
    "Bcolor": "121",
    "Y": 22,
    "L": 55.329891204834,
    "a": 42.8278350830078,
    "b": 7.26544570922852,
    "C": 43.4397315979004,
    "h": 9.6281681060791,
    "CMY_C": 0.20500493049622,
    "CMY_M": 0.6056969165802,
    "CMY_Y": 0.52640700340271,
    "CMYK_C": 0,
    "CMYK_M": 0.50401818752289,
    "CMYK_Y": 0.40428185462952,
    "CMYK_K": 0.20500493049622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03810",
    "Farbtonhilfsbezeichnung": "A8.35.50",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "105",
    "Bcolor": "121",
    "Y": 26,
    "L": 58.0219308777784,
    "a": 45.1678123864055,
    "b": 11.2810904239072,
    "C": 46.5552819444356,
    "h": 0.24475230125994,
    "CMY_C": 0.1550123,
    "CMY_M": 0.5885801,
    "CMY_Y": 0.5261028,
    "CMYK_C": 0,
    "CMYK_M": 0.5131054,
    "CMYK_Y": 0.4391668,
    "CMYK_K": 0.1550123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03811",
    "Farbtonhilfsbezeichnung": "A5.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "174",
    "Bcolor": "176",
    "Y": 45,
    "L": 73.1104580360774,
    "a": 8.35347315029067,
    "b": 1.15295500413171,
    "C": 8.43266380891468,
    "h": 0.13715449276659,
    "CMY_C": 0.2315662,
    "CMY_M": 0.3157833,
    "CMY_Y": 0.3086749,
    "CMYK_C": 0,
    "CMYK_M": 0.1095958,
    "CMYK_Y": 0.1003452,
    "CMYK_K": 0.2315662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03812",
    "Farbtonhilfsbezeichnung": "A6.08.64",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "166",
    "Bcolor": "169",
    "Y": 42,
    "L": 70.9405489818121,
    "a": 12.8961559045191,
    "b": 2.2123448905959,
    "C": 13.0845445862135,
    "h": 0.16989693744916,
    "CMY_C": 0.2208366,
    "CMY_M": 0.3503946,
    "CMY_Y": 0.3382762,
    "CMYK_C": 0,
    "CMYK_M": 0.1662783,
    "CMYK_Y": 0.1507252,
    "CMYK_K": 0.2208366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03813",
    "Farbtonhilfsbezeichnung": "A5.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "154",
    "Bcolor": "157",
    "Y": 36,
    "L": 66.8488668261373,
    "a": 14.6257572399027,
    "b": 2.48268445664512,
    "C": 14.8349754617873,
    "h": 0.16814465476672,
    "CMY_C": 0.2531527,
    "CMY_M": 0.3976976,
    "CMY_Y": 0.3824455,
    "CMYK_C": 0,
    "CMYK_M": 0.1935401,
    "CMYK_Y": 0.1731182,
    "CMYK_K": 0.2531527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03814",
    "Farbtonhilfsbezeichnung": "A6.21.52",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "125",
    "Bcolor": "136",
    "Y": 28,
    "L": 59.8973319719491,
    "a": 28.75503489189,
    "b": 4.67217299153422,
    "C": 29.1321340120601,
    "h": 0.16107427989292,
    "CMY_C": 0.2369451,
    "CMY_M": 0.5096162,
    "CMY_Y": 0.4661081,
    "CMYK_C": 0,
    "CMYK_M": 0.3573413,
    "CMYK_Y": 0.3003231,
    "CMYK_K": 0.2369451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03815",
    "Farbtonhilfsbezeichnung": "A6.29.50",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "111",
    "Bcolor": "128",
    "Y": 26,
    "L": 57.9549263502823,
    "a": 39.4151682578119,
    "b": 6.6784494215651,
    "C": 39.9769580567109,
    "h": 0.16784443816691,
    "CMY_C": 0.1944918,
    "CMY_M": 0.5657746,
    "CMY_Y": 0.497183,
    "CMYK_C": 0,
    "CMYK_M": 0.4609299,
    "CMYK_Y": 0.3757767,
    "CMYK_K": 0.1944918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03816",
    "Farbtonhilfsbezeichnung": "A8.40.45",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "85",
    "Bcolor": "106",
    "Y": 21,
    "L": 52.5087448011361,
    "a": 49.6748670179408,
    "b": 12.1561476136063,
    "C": 51.1406329453781,
    "h": 0.23999768183196,
    "CMY_C": 0.1947089,
    "CMY_M": 0.6658962,
    "CMY_Y": 0.5844923,
    "CMYK_C": 0,
    "CMYK_M": 0.5851143,
    "CMYK_Y": 0.4840279,
    "CMYK_K": 0.1947089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03817",
    "Farbtonhilfsbezeichnung": "A7.40.42",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "83",
    "Bcolor": "106",
    "Y": 20,
    "L": 51.3567335674065,
    "a": 49.2860364826014,
    "b": 10.6610691609523,
    "C": 50.4259039365575,
    "h": 0.21302807120696,
    "CMY_C": 0.2121833,
    "CMY_M": 0.6757041,
    "CMY_Y": 0.5859184,
    "CMYK_C": 0,
    "CMYK_M": 0.5883613,
    "CMYK_Y": 0.4743934,
    "CMYK_K": 0.2121833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03818",
    "Farbtonhilfsbezeichnung": "A8.45.40",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "70",
    "Bcolor": "94",
    "Y": 17,
    "L": 48.4294308041098,
    "a": 52.7802523205757,
    "b": 13.2757585306721,
    "C": 54.4242666426324,
    "h": 0.24641710443167,
    "CMY_C": 0.2256262,
    "CMY_M": 0.7254109,
    "CMY_Y": 0.6297616,
    "CMYK_C": 0,
    "CMYK_M": 0.6454049,
    "CMYK_Y": 0.5218866,
    "CMYK_K": 0.2256262
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03819",
    "Farbtonhilfsbezeichnung": "A9.05.59",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "157",
    "Bcolor": "157",
    "Y": 36,
    "L": 66.2277204807191,
    "a": 7.48849324712747,
    "b": 1.77692252073052,
    "C": 7.69642675252308,
    "h": 0.23297821756711,
    "CMY_C": 0.3097875,
    "CMY_M": 0.386117,
    "CMY_Y": 0.3849842,
    "CMYK_C": 0,
    "CMYK_M": 0.1105884,
    "CMYK_Y": 0.1089472,
    "CMYK_K": 0.3097875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03820",
    "Farbtonhilfsbezeichnung": "A7.06.56",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "145",
    "Bcolor": "147",
    "Y": 31,
    "L": 62.1665762685078,
    "a": 8.51485888233494,
    "b": 1.30356501326774,
    "C": 8.61406428638038,
    "h": 0.15191347349942,
    "CMY_C": 0.3470897,
    "CMY_M": 0.4303876,
    "CMY_Y": 0.4232661,
    "CMYK_C": 0,
    "CMYK_M": 0.1275794,
    "CMYK_Y": 0.1166721,
    "CMYK_K": 0.3470897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03821",
    "Farbtonhilfsbezeichnung": "A6.09.55",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "142",
    "Bcolor": "146",
    "Y": 30,
    "L": 62.0750650859482,
    "a": 13.7523697787602,
    "b": 2.15286750692445,
    "C": 13.9198603812727,
    "h": 0.15528489575915,
    "CMY_C": 0.3111533,
    "CMY_M": 0.4445641,
    "CMY_Y": 0.4292641,
    "CMYK_C": 0,
    "CMYK_M": 0.1936726,
    "CMYK_Y": 0.1714616,
    "CMYK_K": 0.3111533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03822",
    "Farbtonhilfsbezeichnung": "A7.10.54",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "141",
    "Bcolor": "144",
    "Y": 30,
    "L": 61.9754174286604,
    "a": 14.6856825657878,
    "b": 2.89971107663975,
    "C": 14.9692216481376,
    "h": 0.19494394964238,
    "CMY_C": 0.3043365,
    "CMY_M": 0.4481915,
    "CMY_Y": 0.4352332,
    "CMYK_C": 0,
    "CMYK_M": 0.2067882,
    "CMYK_Y": 0.1881609,
    "CMYK_K": 0.3043365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03823",
    "Farbtonhilfsbezeichnung": "A7.27.46",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "104",
    "Bcolor": "116",
    "Y": 22,
    "L": 53.6027484207342,
    "a": 34.7482201454412,
    "b": 7.2367170051697,
    "C": 35.4937864462072,
    "h": 0.20532655826226,
    "CMY_C": 0.2685387,
    "CMY_M": 0.5935102,
    "CMY_Y": 0.5445603,
    "CMYK_C": 0,
    "CMYK_M": 0.444277,
    "CMYK_Y": 0.3773565,
    "CMYK_K": 0.2685387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03824",
    "Farbtonhilfsbezeichnung": "A8.29.45",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "103",
    "Bcolor": "115",
    "Y": 22,
    "L": 53.7335005897641,
    "a": 35.9439812173024,
    "b": 8.09730967552811,
    "C": 36.844758239554,
    "h": 0.22157695185333,
    "CMY_C": 0.2591003,
    "CMY_M": 0.5966265,
    "CMY_Y": 0.5487308,
    "CMYK_C": 0,
    "CMYK_M": 0.4555626,
    "CMYK_Y": 0.3909172,
    "CMYK_K": 0.2591003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03825",
    "Farbtonhilfsbezeichnung": "A7.37.38",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "78",
    "Bcolor": "96",
    "Y": 15,
    "L": 45.8412730411894,
    "a": 41.249930469639,
    "b": 7.98715399943968,
    "C": 42.0160849289985,
    "h": 0.19126148787487,
    "CMY_C": 0.3202259,
    "CMY_M": 0.6960768,
    "CMY_Y": 0.6227739,
    "CMYK_C": 0,
    "CMYK_M": 0.5529056,
    "CMYK_Y": 0.4450713,
    "CMYK_K": 0.3202259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03826",
    "Farbtonhilfsbezeichnung": "A6.44.34",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "62",
    "Bcolor": "88",
    "Y": 13,
    "L": 43.0336465834056,
    "a": 47.7745003497094,
    "b": 8.83198467668941,
    "C": 48.5840183290108,
    "h": 0.18280430034362,
    "CMY_C": 0.3183967,
    "CMY_M": 0.7552882,
    "CMY_Y": 0.6531262,
    "CMYK_C": 0,
    "CMYK_M": 0.6409763,
    "CMYK_Y": 0.4910914,
    "CMYK_K": 0.3183967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03827",
    "Farbtonhilfsbezeichnung": "A9.05.49",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "132",
    "Bcolor": "133",
    "Y": 25,
    "L": 56.7354734467379,
    "a": 6.78559655048461,
    "b": 1.45328397587121,
    "C": 6.9394779962525,
    "h": 0.21098449480962,
    "CMY_C": 0.4149627,
    "CMY_M": 0.481546,
    "CMY_Y": 0.479412,
    "CMYK_C": 0,
    "CMYK_M": 0.1138103,
    "CMYK_Y": 0.1101626,
    "CMYK_K": 0.4149627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03828",
    "Farbtonhilfsbezeichnung": "A8.09.45",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "122",
    "Bcolor": "124",
    "Y": 22,
    "L": 53.8525868329435,
    "a": 11.2787243735274,
    "b": 2.20013315508907,
    "C": 11.4913101687373,
    "h": 0.19265006247219,
    "CMY_C": 0.4135645,
    "CMY_M": 0.5213755,
    "CMY_Y": 0.5124822,
    "CMYK_C": 0,
    "CMYK_M": 0.1838412,
    "CMYK_Y": 0.1686762,
    "CMYK_K": 0.4135645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03829",
    "Farbtonhilfsbezeichnung": "A8.15.50",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "124",
    "Bcolor": "129",
    "Y": 25,
    "L": 57.0071337761637,
    "a": 19.8829218244232,
    "b": 4.27686233158,
    "C": 20.3377022222132,
    "h": 0.21187394367499,
    "CMY_C": 0.3221868,
    "CMY_M": 0.5127992,
    "CMY_Y": 0.4937544,
    "CMYK_C": 0,
    "CMYK_M": 0.2812167,
    "CMYK_Y": 0.2531192,
    "CMYK_K": 0.3221868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03830",
    "Farbtonhilfsbezeichnung": "A8.20.45",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "109",
    "Bcolor": "116",
    "Y": 21,
    "L": 52.5081440693059,
    "a": 24.9227652073452,
    "b": 5.34074970229694,
    "C": 25.4885824039518,
    "h": 0.21109936217085,
    "CMY_C": 0.3389791,
    "CMY_M": 0.572387,
    "CMY_Y": 0.5444188,
    "CMYK_C": 0,
    "CMYK_M": 0.3531021,
    "CMYK_Y": 0.3107915,
    "CMYK_K": 0.3389791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03831",
    "Farbtonhilfsbezeichnung": "A7.23.42",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "101",
    "Bcolor": "111",
    "Y": 18,
    "L": 50.0119788212835,
    "a": 27.1277863312819,
    "b": 4.84278078469929,
    "C": 27.5566564910248,
    "h": 0.17665645736104,
    "CMY_C": 0.3545007,
    "CMY_M": 0.6035708,
    "CMY_Y": 0.5651036,
    "CMYK_C": 0,
    "CMYK_M": 0.3858566,
    "CMYK_Y": 0.3262635,
    "CMYK_K": 0.3545007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03832",
    "Farbtonhilfsbezeichnung": "A6.29.40",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "92",
    "Bcolor": "107",
    "Y": 17,
    "L": 48.811397718633,
    "a": 34.1710157013482,
    "b": 5.81312921441333,
    "C": 34.661950108516,
    "h": 0.16850553348335,
    "CMY_C": 0.3274101,
    "CMY_M": 0.6388587,
    "CMY_Y": 0.5818225,
    "CMYK_C": 0,
    "CMYK_M": 0.4630587,
    "CMYK_Y": 0.3782578,
    "CMYK_K": 0.3274101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03833",
    "Farbtonhilfsbezeichnung": "A8.39.35",
    "Farbtonklasse": "04",
    "Rcolor": "174",
    "Gcolor": "78",
    "Bcolor": "95",
    "Y": 14,
    "L": 46.0249710083008,
    "a": 41.3757972717285,
    "b": 8.93596839904785,
    "C": 42.3297538757324,
    "h": 12.1870403289795,
    "CMY_C": 0.31616961956024,
    "CMY_M": 0.694973051548,
    "CMY_Y": 0.62704122066498,
    "CMYK_C": 0,
    "CMYK_M": 0.55394357442856,
    "CMYK_Y": 0.45460337400436,
    "CMYK_K": 0.31616961956024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03834",
    "Farbtonhilfsbezeichnung": "A8.48.32",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "47",
    "Bcolor": "75",
    "Y": 11,
    "L": 39.923603939735,
    "a": 52.1687592719622,
    "b": 12.7825311349829,
    "C": 53.7119404433758,
    "h": 0.24028870321635,
    "CMY_C": 0.3286425,
    "CMY_M": 0.8167259,
    "CMY_Y": 0.7050982,
    "CMYK_C": 0,
    "CMYK_M": 0.7270096,
    "CMYK_Y": 0.560738,
    "CMYK_K": 0.3286425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03835",
    "Farbtonhilfsbezeichnung": "A8.05.40",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "109",
    "Bcolor": "111",
    "Y": 16,
    "L": 47.5340391917251,
    "a": 6.00684340661845,
    "b": 0.77867231127182,
    "C": 6.05710312608073,
    "h": 0.1289119873836,
    "CMY_C": 0.5153041,
    "CMY_M": 0.5707989,
    "CMY_Y": 0.5657501,
    "CMYK_C": 0,
    "CMYK_M": 0.114494,
    "CMYK_Y": 0.1040775,
    "CMYK_K": 0.5153041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03836",
    "Farbtonhilfsbezeichnung": "A8.10.35",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "95",
    "Bcolor": "97",
    "Y": 13,
    "L": 42.9002685891437,
    "a": 11.1261555372993,
    "b": 2.07841104186965,
    "C": 11.3186187098577,
    "h": 0.18467556236544,
    "CMY_C": 0.5264375,
    "CMY_M": 0.627733,
    "CMY_Y": 0.6178414,
    "CMYK_C": 0,
    "CMYK_M": 0.2139009,
    "CMYK_Y": 0.1930133,
    "CMYK_K": 0.5264375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03837",
    "Farbtonhilfsbezeichnung": "A8.15.40",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "102",
    "Bcolor": "107",
    "Y": 17,
    "L": 47.6335387403876,
    "a": 17.3847396376253,
    "b": 3.6926145211287,
    "C": 17.7725792801628,
    "h": 0.20929498545331,
    "CMY_C": 0.4375997,
    "CMY_M": 0.5985097,
    "CMY_Y": 0.5820994,
    "CMYK_C": 0,
    "CMYK_M": 0.2861128,
    "CMYK_Y": 0.256934,
    "CMYK_K": 0.4375997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03838",
    "Farbtonhilfsbezeichnung": "A8.20.35",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "91",
    "Bcolor": "96",
    "Y": 14,
    "L": 44.0449473472896,
    "a": 20.7636470969602,
    "b": 4.76051459715208,
    "C": 21.3023834346488,
    "h": 0.22537647466742,
    "CMY_C": 0.4536286,
    "CMY_M": 0.6426671,
    "CMY_Y": 0.6226753,
    "CMYK_C": 0,
    "CMYK_M": 0.3459891,
    "CMYK_Y": 0.3093989,
    "CMYK_K": 0.4536286
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03840",
    "Farbtonhilfsbezeichnung": "A6.32.35",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "79",
    "Bcolor": "93",
    "Y": 14,
    "L": 43.5652006780483,
    "a": 34.2554772029658,
    "b": 6.38397504362658,
    "C": 34.8452702064507,
    "h": 0.18424994713397,
    "CMY_C": 0.3837717,
    "CMY_M": 0.6909167,
    "CMY_Y": 0.6352946,
    "CMYK_C": 0,
    "CMYK_M": 0.4984273,
    "CMYK_Y": 0.408165,
    "CMYK_K": 0.3837717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03841",
    "Farbtonhilfsbezeichnung": "A6.37.31",
    "Farbtonklasse": "04",
    "Rcolor": "150",
    "Gcolor": "63",
    "Bcolor": "81",
    "Y": 11,
    "L": 38.9435395240986,
    "a": 38.2368909116791,
    "b": 6.9379366268173,
    "C": 38.861224777783,
    "h": 0.17949334899389,
    "CMY_C": 0.4135823,
    "CMY_M": 0.7518905,
    "CMY_Y": 0.6809122,
    "CMYK_C": 0,
    "CMYK_M": 0.5769066,
    "CMYK_Y": 0.4558694,
    "CMYK_K": 0.4135823
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03842",
    "Farbtonhilfsbezeichnung": "A9.46.28",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "46",
    "Bcolor": "69",
    "Y": 10,
    "L": 37.0185913255836,
    "a": 47.4850512592296,
    "b": 12.6141081641624,
    "C": 49.1319225948756,
    "h": 0.25964716479952,
    "CMY_C": 0.384156,
    "CMY_M": 0.8198307,
    "CMY_Y": 0.7311081,
    "CMYK_C": 0,
    "CMYK_M": 0.7074433,
    "CMYK_Y": 0.5633767,
    "CMYK_K": 0.384156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03843",
    "Farbtonhilfsbezeichnung": "A7.05.31",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "88",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.6159873469199,
    "a": 6.06812540141591,
    "b": 1.1172388298912,
    "C": 6.17011900130991,
    "h": 0.18207686160121,
    "CMY_C": 0.6015293,
    "CMY_M": 0.656303,
    "CMY_Y": 0.6527144,
    "CMYK_C": 0,
    "CMYK_M": 0.1374598,
    "CMYK_Y": 0.1284539,
    "CMYK_K": 0.6015293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03844",
    "Farbtonhilfsbezeichnung": "A5.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "86",
    "Bcolor": "89",
    "Y": 11,
    "L": 38.8452002546131,
    "a": 10.4859968005117,
    "b": 0.95837811853906,
    "C": 10.5297016823097,
    "h": 0.09114277973631,
    "CMY_C": 0.5730157,
    "CMY_M": 0.6642291,
    "CMY_Y": 0.6490223,
    "CMYK_C": 0,
    "CMYK_M": 0.2136223,
    "CMYK_Y": 0.178008,
    "CMYK_K": 0.5730157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03845",
    "Farbtonhilfsbezeichnung": "A8.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "86",
    "Bcolor": "89",
    "Y": 11,
    "L": 39.9544596375257,
    "a": 14.022775002729,
    "b": 2.80166491901765,
    "C": 14.2999141639247,
    "h": 0.19719737977105,
    "CMY_C": 0.5373899,
    "CMY_M": 0.6629561,
    "CMY_Y": 0.6497131,
    "CMYK_C": 0,
    "CMYK_M": 0.2714298,
    "CMYK_Y": 0.2428032,
    "CMYK_K": 0.5373899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03846",
    "Farbtonhilfsbezeichnung": "A8.18.26",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "71",
    "Bcolor": "75",
    "Y": 8,
    "L": 34.5319536169801,
    "a": 16.547268179108,
    "b": 3.61865431284779,
    "C": 16.9383217358512,
    "h": 0.21529653062346,
    "CMY_C": 0.5759365,
    "CMY_M": 0.7200572,
    "CMY_Y": 0.7042968,
    "CMYK_C": 0,
    "CMYK_M": 0.3398564,
    "CMYK_Y": 0.3026913,
    "CMYK_K": 0.5759365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03847",
    "Farbtonhilfsbezeichnung": "A7.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "82",
    "Bcolor": "88",
    "Y": 11,
    "L": 39.9718272648102,
    "a": 20.2044719655513,
    "b": 3.84135478260994,
    "C": 20.5663972044845,
    "h": 0.18788161163868,
    "CMY_C": 0.5006514,
    "CMY_M": 0.6795439,
    "CMY_Y": 0.6551667,
    "CMYK_C": 0,
    "CMYK_M": 0.3582518,
    "CMYK_Y": 0.3094338,
    "CMYK_K": 0.5006514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03848",
    "Farbtonhilfsbezeichnung": "A6.28.24",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "62",
    "Bcolor": "72",
    "Y": 8,
    "L": 33.7185200179962,
    "a": 26.3998927045992,
    "b": 4.78188739558103,
    "C": 26.8294759896343,
    "h": 0.17919000363588,
    "CMY_C": 0.5312061,
    "CMY_M": 0.756943,
    "CMY_Y": 0.7172066,
    "CMYK_C": 0,
    "CMYK_M": 0.4815271,
    "CMYK_Y": 0.396764,
    "CMYK_K": 0.5312061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03849",
    "Farbtonhilfsbezeichnung": "A7.32.30",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "70",
    "Bcolor": "83",
    "Y": 11,
    "L": 39.0900146320412,
    "a": 31.6431756743621,
    "b": 6.15132441391388,
    "C": 32.2355294481688,
    "h": 0.19200187429345,
    "CMY_C": 0.4460295,
    "CMY_M": 0.7247168,
    "CMY_Y": 0.6758666,
    "CMYK_C": 0,
    "CMYK_M": 0.5030724,
    "CMYK_Y": 0.4148905,
    "CMYK_K": 0.4460295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03850",
    "Farbtonhilfsbezeichnung": "A8.45.26",
    "Farbtonklasse": "04",
    "Rcolor": "146",
    "Gcolor": "47",
    "Bcolor": "68",
    "Y": 9,
    "L": 35.2039204103258,
    "a": 43.1726009363845,
    "b": 10.0475532934989,
    "C": 44.3263668576392,
    "h": 0.22865954116814,
    "CMY_C": 0.4274908,
    "CMY_M": 0.8139063,
    "CMY_Y": 0.7326348,
    "CMYK_C": 0,
    "CMYK_M": 0.6749507,
    "CMYK_Y": 0.5329941,
    "CMYK_K": 0.4274908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03851",
    "Farbtonhilfsbezeichnung": "B0.05.21",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "66",
    "Bcolor": "67",
    "Y": 6,
    "L": 29.0273035826788,
    "a": 4.0112469249948,
    "b": 0.77484398660719,
    "C": 4.08539901317626,
    "h": 0.19081764719491,
    "CMY_C": 0.7049772,
    "CMY_M": 0.7396877,
    "CMY_Y": 0.7382164,
    "CMYK_C": 0,
    "CMYK_M": 0.1176537,
    "CMYK_Y": 0.1126666,
    "CMYK_K": 0.7049772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03852",
    "Farbtonhilfsbezeichnung": "A6.11.23",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "73",
    "Bcolor": "76",
    "Y": 8,
    "L": 33.1295072344419,
    "a": 9.70481871136186,
    "b": 1.23221442612037,
    "C": 9.78273267611553,
    "h": 0.12629356465929,
    "CMY_C": 0.6323408,
    "CMY_M": 0.7152687,
    "CMY_Y": 0.7034289,
    "CMYK_C": 0,
    "CMYK_M": 0.2255562,
    "CMYK_Y": 0.1933532,
    "CMYK_K": 0.6323408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03853",
    "Farbtonhilfsbezeichnung": "A5.13.21",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "63",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.6343831567204,
    "a": 12.7755390128378,
    "b": 1.21670342219534,
    "C": 12.8333457946913,
    "h": 0.09495057543302,
    "CMY_C": 0.6487111,
    "CMY_M": 0.7541405,
    "CMY_Y": 0.7343605,
    "CMYK_C": 0,
    "CMYK_M": 0.3001215,
    "CMYK_Y": 0.2438146,
    "CMYK_K": 0.6487111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03854",
    "Farbtonhilfsbezeichnung": "A8.14.21",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "66",
    "Bcolor": "70",
    "Y": 7,
    "L": 30.8920711063136,
    "a": 11.526117608571,
    "b": 1.79188092376061,
    "C": 11.6645713325243,
    "h": 0.15422807559401,
    "CMY_C": 0.6423322,
    "CMY_M": 0.7399671,
    "CMY_Y": 0.7267286,
    "CMYK_C": 0,
    "CMYK_M": 0.2729765,
    "CMYK_Y": 0.2359631,
    "CMYK_K": 0.6423322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03855",
    "Farbtonhilfsbezeichnung": "A6.26.14",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "53",
    "Bcolor": "60",
    "Y": 5,
    "L": 26.6686609212543,
    "a": 17.3184079275104,
    "b": 2.22143588546563,
    "C": 17.4602986955232,
    "h": 0.12757359068291,
    "CMY_C": 0.651638,
    "CMY_M": 0.7925304,
    "CMY_Y": 0.7658046,
    "CMYK_C": 0,
    "CMYK_M": 0.4044427,
    "CMYK_Y": 0.3277243,
    "CMYK_K": 0.651638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03856",
    "Farbtonhilfsbezeichnung": "A6.32.23",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "58",
    "Bcolor": "71",
    "Y": 8,
    "L": 33.0984380576454,
    "a": 28.9689046576955,
    "b": 4.47812596923464,
    "C": 29.3129843117855,
    "h": 0.15336992698526,
    "CMY_C": 0.5253637,
    "CMY_M": 0.7713822,
    "CMY_Y": 0.7205347,
    "CMYK_C": 0,
    "CMYK_M": 0.5183305,
    "CMYK_Y": 0.4112012,
    "CMYK_K": 0.5253637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03857",
    "Farbtonhilfsbezeichnung": "A6.38.23",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "53",
    "Bcolor": "70",
    "Y": 8,
    "L": 33.760578702855,
    "a": 35.7878896801053,
    "b": 6.31132138530136,
    "C": 36.3401406902058,
    "h": 0.1745586930276,
    "CMY_C": 0.4827171,
    "CMY_M": 0.7920418,
    "CMY_Y": 0.724453,
    "CMYK_C": 0,
    "CMYK_M": 0.5979798,
    "CMYK_Y": 0.4673185,
    "CMYK_K": 0.4827171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03858",
    "Farbtonhilfsbezeichnung": "A9.43.25",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "49",
    "Bcolor": "64",
    "Y": 8,
    "L": 33.6240989910356,
    "a": 38.7504073637204,
    "b": 10.1753337380276,
    "C": 40.0640922464808,
    "h": 0.2567892500164,
    "CMY_C": 0.4654882,
    "CMY_M": 0.8078835,
    "CMY_Y": 0.7482596,
    "CMYK_C": 0,
    "CMYK_M": 0.6405758,
    "CMYK_Y": 0.5290274,
    "CMYK_K": 0.4654882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03859",
    "Farbtonhilfsbezeichnung": "A8.38.20",
    "Farbtonklasse": "04",
    "Rcolor": "116",
    "Gcolor": "44",
    "Bcolor": "57",
    "Y": 6,
    "L": 28.9080521052588,
    "a": 32.7892920296453,
    "b": 7.53985687757825,
    "C": 33.6450161768385,
    "h": 0.22601971705296,
    "CMY_C": 0.5470415,
    "CMY_M": 0.826323,
    "CMY_Y": 0.7749346,
    "CMYK_C": 0,
    "CMYK_M": 0.6165718,
    "CMYK_Y": 0.5031213,
    "CMYK_K": 0.5470415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03860",
    "Farbtonhilfsbezeichnung": "A9.36.15",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "46",
    "Bcolor": "54",
    "Y": 5,
    "L": 26.1155038769674,
    "a": 24.5946001040875,
    "b": 5.24834517430471,
    "C": 25.1483494756341,
    "h": 0.21024080933123,
    "CMY_C": 0.6170151,
    "CMY_M": 0.8204052,
    "CMY_Y": 0.7870689,
    "CMYK_C": 0,
    "CMYK_M": 0.5310655,
    "CMYK_Y": 0.4440221,
    "CMYK_K": 0.6170151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03861",
    "Farbtonhilfsbezeichnung": "A8.29.13",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "49",
    "Bcolor": "55",
    "Y": 4,
    "L": 25.2088864601241,
    "a": 18.5213679611306,
    "b": 3.26620090490697,
    "C": 18.8071566033468,
    "h": 0.17455303348623,
    "CMY_C": 0.6580777,
    "CMY_M": 0.8090169,
    "CMY_Y": 0.7843364,
    "CMYK_C": 0,
    "CMYK_M": 0.4414431,
    "CMYK_Y": 0.3692615,
    "CMYK_K": 0.6580777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03862",
    "Farbtonhilfsbezeichnung": "A7.22.12",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "48",
    "Bcolor": "52",
    "Y": 4,
    "L": 23.4789615680394,
    "a": 14.4530021948355,
    "b": 2.6316552000346,
    "C": 14.6906392487117,
    "h": 0.18011044805192,
    "CMY_C": 0.6957974,
    "CMY_M": 0.812812,
    "CMY_Y": 0.7960788,
    "CMYK_C": 0,
    "CMYK_M": 0.3846603,
    "CMYK_Y": 0.3296534,
    "CMYK_K": 0.6957974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03863",
    "Farbtonhilfsbezeichnung": "A7.19.09",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "45",
    "Bcolor": "48",
    "Y": 3,
    "L": 20.8424670062814,
    "a": 9.69644176943313,
    "b": 1.66354304490177,
    "C": 9.83810746283291,
    "h": 0.169908101025,
    "CMY_C": 0.7459536,
    "CMY_M": 0.8234885,
    "CMY_Y": 0.8135368,
    "CMYK_C": 0,
    "CMYK_M": 0.3051998,
    "CMYK_Y": 0.2660272,
    "CMYK_K": 0.7459536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03864",
    "Farbtonhilfsbezeichnung": "A6.17.14",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "53",
    "Bcolor": "56",
    "Y": 4,
    "L": 25.2036033257496,
    "a": 11.6328569154218,
    "b": 2.21164856551528,
    "C": 11.8412309069633,
    "h": 0.18787857668019,
    "CMY_C": 0.694756,
    "CMY_M": 0.7907087,
    "CMY_Y": 0.7792285,
    "CMYK_C": 0,
    "CMYK_M": 0.3143474,
    "CMYK_Y": 0.2767378,
    "CMYK_K": 0.694756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03865",
    "Farbtonhilfsbezeichnung": "A6.10.15",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "58",
    "Bcolor": "59",
    "Y": 5,
    "L": 26.0264056726866,
    "a": 7.20758819009973,
    "b": 1.19464626076893,
    "C": 7.30592274845787,
    "h": 0.16425510274805,
    "CMY_C": 0.7130457,
    "CMY_M": 0.7731311,
    "CMY_Y": 0.7667276,
    "CMYK_C": 0,
    "CMYK_M": 0.2093902,
    "CMYK_Y": 0.1870751,
    "CMYK_K": 0.7130457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03866",
    "Farbtonhilfsbezeichnung": "A9.05.13",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "51",
    "Bcolor": "51",
    "Y": 4,
    "L": 21.9448211215491,
    "a": 2.9577696928203,
    "b": 0.88465923605455,
    "C": 3.08723557891245,
    "h": 0.29062789830359,
    "CMY_C": 0.7742627,
    "CMY_M": 0.7996333,
    "CMY_Y": 0.800594,
    "CMYK_C": 0,
    "CMYK_M": 0.1123897,
    "CMYK_Y": 0.1166455,
    "CMYK_K": 0.7742627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03868",
    "Farbtonhilfsbezeichnung": "B3.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 76,
    "L": 89.8368488719328,
    "a": 11.1648949230122,
    "b": 4.94674338657974,
    "C": 12.2116808333077,
    "h": 0.41706952818133,
    "CMY_C": 0.0144759,
    "CMY_M": 0.1426893,
    "CMY_Y": 0.1558105,
    "CMYK_C": 0,
    "CMYK_M": 0.1300966,
    "CMYK_Y": 0.1434106,
    "CMYK_K": 0.0144759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03869",
    "Farbtonhilfsbezeichnung": "B1.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "206",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.4666533332439,
    "a": 15.5680019053766,
    "b": 5.36063952987174,
    "C": 16.4650885055329,
    "h": 0.33162097591243,
    "CMY_C": 0.02056422,
    "CMY_M": 0.1915259,
    "CMY_Y": 0.1949056,
    "CMYK_C": 0,
    "CMYK_M": 0.1745511,
    "CMYK_Y": 0.1780018,
    "CMYK_K": 0.02056422
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03870",
    "Farbtonhilfsbezeichnung": "B2.19.69",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "168",
    "Bcolor": "169",
    "Y": 50,
    "L": 76.1211265645611,
    "a": 28.9187122437748,
    "b": 10.0889873638572,
    "C": 30.6280848873435,
    "h": 0.33567136628334,
    "CMY_C": 0.04059606,
    "CMY_M": 0.3426694,
    "CMY_Y": 0.3370502,
    "CMYK_C": 0,
    "CMYK_M": 0.3148552,
    "CMYK_Y": 0.3089983,
    "CMYK_K": 0.04059606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03871",
    "Farbtonhilfsbezeichnung": "B3.26.65",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "151",
    "Bcolor": "153",
    "Y": 45,
    "L": 72.6129041273277,
    "a": 37.3406936059485,
    "b": 13.9760102345673,
    "C": 39.8704936143265,
    "h": 0.35814246928868,
    "CMY_C": 0.02332811,
    "CMY_M": 0.4080258,
    "CMY_Y": 0.399306,
    "CMYK_C": 0,
    "CMYK_M": 0.3938863,
    "CMYK_Y": 0.3849583,
    "CMYK_K": 0.02332811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03872",
    "Farbtonhilfsbezeichnung": "B3.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "224",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.372407541019,
    "a": 5.90710403409633,
    "b": 1.96779684890527,
    "C": 6.22624304923914,
    "h": 0.32156194823139,
    "CMY_C": 0.05607625,
    "CMY_M": 0.1225499,
    "CMY_Y": 0.1287322,
    "CMYK_C": 0,
    "CMYK_M": 0.0704227,
    "CMYK_Y": 0.0769723,
    "CMYK_K": 0.05607625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03873",
    "Farbtonhilfsbezeichnung": "B1.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "212",
    "Bcolor": "210",
    "Y": 70,
    "L": 86.9929015227117,
    "a": 9.76642467166139,
    "b": 3.45699770953645,
    "C": 10.3602067561886,
    "h": 0.34020503017811,
    "CMY_C": 0.06110971,
    "CMY_M": 0.1700269,
    "CMY_Y": 0.1761435,
    "CMYK_C": 0,
    "CMYK_M": 0.1160063,
    "CMYK_Y": 0.122521,
    "CMYK_K": 0.06110971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03874",
    "Farbtonhilfsbezeichnung": "B0.08.77",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "202",
    "Bcolor": "203",
    "Y": 66,
    "L": 84.7969172942836,
    "a": 14.357503963913,
    "b": 3.90440857889198,
    "C": 14.878922219862,
    "h": 0.26552101116325,
    "CMY_C": 0.05194584,
    "CMY_M": 0.2061417,
    "CMY_Y": 0.2025798,
    "CMYK_C": 0,
    "CMYK_M": 0.1626446,
    "CMYK_Y": 0.1588875,
    "CMYK_K": 0.05194584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03875",
    "Farbtonhilfsbezeichnung": "B1.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "187",
    "Bcolor": "188",
    "Y": 57,
    "L": 80.2438916558664,
    "a": 18.088034969641,
    "b": 5.61842188091362,
    "C": 18.9405299158942,
    "h": 0.30116700044444,
    "CMY_C": 0.07346503,
    "CMY_M": 0.266038,
    "CMY_Y": 0.2633509,
    "CMYK_C": 0,
    "CMYK_M": 0.2078421,
    "CMYK_Y": 0.204942,
    "CMYK_K": 0.07346503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03876",
    "Farbtonhilfsbezeichnung": "B2.28.58",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "133",
    "Bcolor": "136",
    "Y": 35,
    "L": 65.8308306646368,
    "a": 37.6716664669487,
    "b": 13.6358382829802,
    "C": 40.0635812188154,
    "h": 0.3472943615165,
    "CMY_C": 0.1015719,
    "CMY_M": 0.4803144,
    "CMY_Y": 0.4658311,
    "CMYK_C": 0,
    "CMYK_M": 0.4215613,
    "CMYK_Y": 0.4054406,
    "CMYK_K": 0.1015719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03878",
    "Farbtonhilfsbezeichnung": "BN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "214",
    "Bcolor": "213",
    "Y": 69,
    "L": 86.7273342343907,
    "a": 4.8203391354103,
    "b": 1.37973204630133,
    "C": 5.01391363108291,
    "h": 0.27877760896316,
    "CMY_C": 0.1069542,
    "CMY_M": 0.1599984,
    "CMY_Y": 0.1645508,
    "CMYK_C": 0,
    "CMYK_M": 0.059397,
    "CMYK_Y": 0.06449456,
    "CMYK_K": 0.1069542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03879",
    "Farbtonhilfsbezeichnung": "B6.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "221",
    "Bcolor": "217",
    "Y": 76,
    "L": 89.7424435363656,
    "a": 7.47568243701036,
    "b": 3.72874079255161,
    "C": 8.35400118488521,
    "h": 0.46267326514684,
    "CMY_C": 0.04606221,
    "CMY_M": 0.1339607,
    "CMY_Y": 0.1484199,
    "CMYK_C": 0,
    "CMYK_M": 0.09214281,
    "CMYK_Y": 0.1073002,
    "CMYK_K": 0.04606221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03880",
    "Farbtonhilfsbezeichnung": "B2.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "201",
    "Bcolor": "200",
    "Y": 64,
    "L": 83.7154531089251,
    "a": 12.3072312477078,
    "b": 4.30270068294454,
    "C": 13.0376828520856,
    "h": 0.33632513489808,
    "CMY_C": 0.07748382,
    "CMY_M": 0.2126703,
    "CMY_Y": 0.2174759,
    "CMYK_C": 0,
    "CMYK_M": 0.1465411,
    "CMYK_Y": 0.1517503,
    "CMYK_K": 0.07748382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03881",
    "Farbtonhilfsbezeichnung": "B0.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "189",
    "Bcolor": "191",
    "Y": 59,
    "L": 81.4481085086214,
    "a": 19.8096727820334,
    "b": 5.65021001931074,
    "C": 20.5997089540982,
    "h": 0.27784706001306,
    "CMY_C": 0.04813993,
    "CMY_M": 0.257791,
    "CMY_Y": 0.2504378,
    "CMYK_C": 0,
    "CMYK_M": 0.2202541,
    "CMYK_Y": 0.212529,
    "CMYK_K": 0.04813993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03882",
    "Farbtonhilfsbezeichnung": "B3.31.54",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 31,
    "L": 62.6982853645631,
    "a": 40.7887408705915,
    "b": 15.04610808996,
    "C": 43.4753579681988,
    "h": 0.35339350498591,
    "CMY_C": 0.11848,
    "CMY_M": 0.5243673,
    "CMY_Y": 0.5061275,
    "CMYK_C": 0,
    "CMYK_M": 0.4604402,
    "CMYK_Y": 0.4397489,
    "CMYK_K": 0.11848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03883",
    "Farbtonhilfsbezeichnung": "BN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "215",
    "Bcolor": "214",
    "Y": 69,
    "L": 86.3816471858835,
    "a": 1.69851428991818,
    "b": 0.41969358826887,
    "C": 1.74959809701836,
    "h": 0.24224223817105,
    "CMY_C": 0.1377497,
    "CMY_M": 0.1559993,
    "CMY_Y": 0.1617378,
    "CMYK_C": 0,
    "CMYK_M": 0.02116506,
    "CMYK_Y": 0.02782032,
    "CMYK_K": 0.1377497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03884",
    "Farbtonhilfsbezeichnung": "B1.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "207",
    "Bcolor": "206",
    "Y": 65,
    "L": 84.4008953714027,
    "a": 5.96336252041002,
    "b": 1.91239234804346,
    "C": 6.26250245849741,
    "h": 0.31032897276942,
    "CMY_C": 0.1226234,
    "CMY_M": 0.1884837,
    "CMY_Y": 0.1936134,
    "CMYK_C": 0,
    "CMYK_M": 0.07506508,
    "CMYK_Y": 0.08091173,
    "CMYK_K": 0.1226234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03885",
    "Farbtonhilfsbezeichnung": "B1.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "200",
    "Bcolor": "199",
    "Y": 61,
    "L": 82.3396308440684,
    "a": 8.08407536357492,
    "b": 2.39236695470262,
    "C": 8.43064019691933,
    "h": 0.28772397209163,
    "CMY_C": 0.1285178,
    "CMY_M": 0.2163506,
    "CMY_Y": 0.2191003,
    "CMYK_C": 0,
    "CMYK_M": 0.1007855,
    "CMYK_Y": 0.1039406,
    "CMYK_K": 0.1285178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03886",
    "Farbtonhilfsbezeichnung": "B3.20.61",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "152",
    "Bcolor": "153",
    "Y": 41,
    "L": 70.2192356635947,
    "a": 28.3542881154679,
    "b": 10.063085535657,
    "C": 30.0870627518359,
    "h": 0.34103804584939,
    "CMY_C": 0.1120812,
    "CMY_M": 0.4033156,
    "CMY_Y": 0.3981831,
    "CMYK_C": 0,
    "CMYK_M": 0.3279967,
    "CMYK_Y": 0.3222163,
    "CMYK_K": 0.1120812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03887",
    "Farbtonhilfsbezeichnung": "B1.22.58",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "139",
    "Bcolor": "144",
    "Y": 36,
    "L": 66.1643714255303,
    "a": 31.6837964773383,
    "b": 9.39364918536252,
    "C": 33.0469908499254,
    "h": 0.28822539568208,
    "CMY_C": 0.1398545,
    "CMY_M": 0.4557795,
    "CMY_Y": 0.4344106,
    "CMYK_C": 0,
    "CMYK_M": 0.3672925,
    "CMYK_Y": 0.3424491,
    "CMYK_K": 0.1398545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03888",
    "Farbtonhilfsbezeichnung": "B0.04.69",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "184",
    "Bcolor": "185",
    "Y": 50,
    "L": 76.3659744262695,
    "a": 6.95654726028442,
    "b": 1.44287049770355,
    "C": 7.10460567474365,
    "h": 11.717679977417,
    "CMY_C": 0.20524340867996,
    "CMY_M": 0.27772372961044,
    "CMY_Y": 0.27644151449203,
    "CMYK_C": 0,
    "CMYK_M": 0.09119813889265,
    "CMYK_Y": 0.08958479762077,
    "CMYK_K": 0.20524340867996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03889",
    "Farbtonhilfsbezeichnung": "B2.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "191",
    "Bcolor": "190",
    "Y": 56,
    "L": 79.6085213733846,
    "a": 10.0202300933094,
    "b": 3.32778855144129,
    "C": 10.5583705071363,
    "h": 0.32064644827093,
    "CMY_C": 0.1422642,
    "CMY_M": 0.2510502,
    "CMY_Y": 0.2549031,
    "CMYK_C": 0,
    "CMYK_M": 0.1268292,
    "CMYK_Y": 0.1313212,
    "CMYK_K": 0.1422642
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03890",
    "Farbtonhilfsbezeichnung": "B3.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "172",
    "Bcolor": "173",
    "Y": 49,
    "L": 75.4559991274248,
    "a": 20.729121803833,
    "b": 6.92571555958854,
    "C": 21.8554804744821,
    "h": 0.32244542816768,
    "CMY_C": 0.1070852,
    "CMY_M": 0.3249519,
    "CMY_Y": 0.3229639,
    "CMYK_C": 0,
    "CMYK_M": 0.2439949,
    "CMYK_Y": 0.2417685,
    "CMYK_K": 0.1070852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03891",
    "Farbtonhilfsbezeichnung": "B3.18.60",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "146",
    "Bcolor": "147",
    "Y": 37,
    "L": 67.3214233829615,
    "a": 26.0356418183207,
    "b": 9.44569404713322,
    "C": 27.6961329597461,
    "h": 0.3480308699146,
    "CMY_C": 0.160326,
    "CMY_M": 0.4264129,
    "CMY_Y": 0.4239634,
    "CMYK_C": 0,
    "CMYK_M": 0.3168931,
    "CMYK_Y": 0.3139759,
    "CMYK_K": 0.160326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03892",
    "Farbtonhilfsbezeichnung": "B0.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "127",
    "Bcolor": "133",
    "Y": 31,
    "L": 62.4396924876641,
    "a": 34.0812272447054,
    "b": 10.3686588179558,
    "C": 35.6235755671497,
    "h": 0.2953364083727,
    "CMY_C": 0.1667812,
    "CMY_M": 0.5023313,
    "CMY_Y": 0.4782157,
    "CMYK_C": 0,
    "CMYK_M": 0.4027154,
    "CMYK_Y": 0.3737727,
    "CMYK_K": 0.1667812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03894",
    "Farbtonhilfsbezeichnung": "B1.05.66",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "174",
    "Bcolor": "173",
    "Y": 45,
    "L": 72.8543567244833,
    "a": 8.65090706905702,
    "b": 2.40421488728007,
    "C": 8.97877732999766,
    "h": 0.2710740290441,
    "CMY_C": 0.2286748,
    "CMY_M": 0.3195787,
    "CMY_Y": 0.3201586,
    "CMYK_C": 0,
    "CMYK_M": 0.1178541,
    "CMYK_Y": 0.118606,
    "CMYK_K": 0.2286748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03895",
    "Farbtonhilfsbezeichnung": "B1.10.54",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "141",
    "Bcolor": "141",
    "Y": 30,
    "L": 61.5939401074142,
    "a": 13.1136575970283,
    "b": 4.26766129715674,
    "C": 13.7906108827473,
    "h": 0.31462654200067,
    "CMY_C": 0.3151871,
    "CMY_M": 0.4484303,
    "CMY_Y": 0.448647,
    "CMYK_C": 0,
    "CMYK_M": 0.1945688,
    "CMYK_Y": 0.1948852,
    "CMYK_K": 0.3151871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03896",
    "Farbtonhilfsbezeichnung": "B2.16.49",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "126",
    "Bcolor": "128",
    "Y": 26,
    "L": 57.6317047350516,
    "a": 19.5638947457151,
    "b": 5.94657055453889,
    "C": 20.447681506262,
    "h": 0.29508253355488,
    "CMY_C": 0.3137926,
    "CMY_M": 0.5060928,
    "CMY_Y": 0.4987715,
    "CMYK_C": 0,
    "CMYK_M": 0.2802362,
    "CMYK_Y": 0.269567,
    "CMYK_K": 0.3137926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03897",
    "Farbtonhilfsbezeichnung": "B2.21.51",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "126",
    "Bcolor": "128",
    "Y": 28,
    "L": 59.7021941730825,
    "a": 27.0628641255597,
    "b": 8.8083197669155,
    "C": 28.4602373812085,
    "h": 0.31466259852136,
    "CMY_C": 0.2409711,
    "CMY_M": 0.5075899,
    "CMY_Y": 0.4962062,
    "CMYK_C": 0,
    "CMYK_M": 0.3512631,
    "CMYK_Y": 0.3362654,
    "CMYK_K": 0.2409711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03898",
    "Farbtonhilfsbezeichnung": "B2.21.53",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "128",
    "Bcolor": "131",
    "Y": 29,
    "L": 61.1206288331744,
    "a": 28.0616386538945,
    "b": 9.57294611565807,
    "C": 29.6495676406089,
    "h": 0.32875998182266,
    "CMY_C": 0.2178701,
    "CMY_M": 0.4964064,
    "CMY_Y": 0.4870656,
    "CMYK_C": 0,
    "CMYK_M": 0.3561254,
    "CMYK_Y": 0.3441827,
    "CMYK_K": 0.2178701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03899",
    "Farbtonhilfsbezeichnung": "B3.33.50",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "111",
    "Bcolor": "117",
    "Y": 27,
    "L": 58.7628553984433,
    "a": 41.0545095203738,
    "b": 14.4546617295784,
    "C": 43.5248204783776,
    "h": 0.33853074091224,
    "CMY_C": 0.1638715,
    "CMY_M": 0.5658662,
    "CMY_Y": 0.5408376,
    "CMYK_C": 0,
    "CMYK_M": 0.480781,
    "CMYK_Y": 0.4508471,
    "CMYK_K": 0.1638715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03900",
    "Farbtonhilfsbezeichnung": "B2.44.44",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "81",
    "Bcolor": "95",
    "Y": 21,
    "L": 52.7977552058522,
    "a": 53.0798347621954,
    "b": 19.0603062475047,
    "C": 56.3982635604203,
    "h": 0.34474755575793,
    "CMY_C": 0.1656199,
    "CMY_M": 0.6815983,
    "CMY_Y": 0.6259613,
    "CMYK_C": 0,
    "CMYK_M": 0.6183973,
    "CMYK_Y": 0.5517167,
    "CMYK_K": 0.1656199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03901",
    "Farbtonhilfsbezeichnung": "B3.03.63",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "170",
    "Bcolor": "169",
    "Y": 42,
    "L": 70.5681730887707,
    "a": 4.7829190101506,
    "b": 1.58540299153345,
    "C": 5.03883090639319,
    "h": 0.3200742808751,
    "CMY_C": 0.2830865,
    "CMY_M": 0.3341838,
    "CMY_Y": 0.3389154,
    "CMYK_C": 0,
    "CMYK_M": 0.071274,
    "CMYK_Y": 0.077874,
    "CMYK_K": 0.2830865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03902",
    "Farbtonhilfsbezeichnung": "B2.05.56",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "148",
    "Bcolor": "149",
    "Y": 31,
    "L": 62.883173710139,
    "a": 6.55788432131305,
    "b": 1.49689365216334,
    "C": 6.72655464391767,
    "h": 0.22441387476863,
    "CMY_C": 0.3523559,
    "CMY_M": 0.4184102,
    "CMY_Y": 0.4175371,
    "CMYK_C": 0,
    "CMYK_M": 0.1019918,
    "CMYK_Y": 0.1006436,
    "CMYK_K": 0.3523559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03903",
    "Farbtonhilfsbezeichnung": "B2.12.45",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "118",
    "Bcolor": "119",
    "Y": 21,
    "L": 53.4058412600012,
    "a": 14.8637567560747,
    "b": 4.68019687793428,
    "C": 15.583180282599,
    "h": 0.30504535772559,
    "CMY_C": 0.3901095,
    "CMY_M": 0.5354918,
    "CMY_Y": 0.5328034,
    "CMYK_C": 0,
    "CMYK_M": 0.2383744,
    "CMYK_Y": 0.2339663,
    "CMYK_K": 0.3901095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03904",
    "Farbtonhilfsbezeichnung": "B2.23.43",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "104",
    "Bcolor": "108",
    "Y": 20,
    "L": 51.4666924693991,
    "a": 27.7442198840522,
    "b": 8.91109381185411,
    "C": 29.1401669504192,
    "h": 0.31077967627138,
    "CMY_C": 0.3279567,
    "CMY_M": 0.5922624,
    "CMY_Y": 0.5774689,
    "CMYK_C": 0,
    "CMYK_M": 0.3932866,
    "CMYK_Y": 0.371274,
    "CMYK_K": 0.3279567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03905",
    "Farbtonhilfsbezeichnung": "B2.31.51",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "112",
    "Bcolor": "120",
    "Y": 27,
    "L": 59.1100892270128,
    "a": 41.0266379699843,
    "b": 13.4278704072765,
    "C": 43.1681911457356,
    "h": 0.31630749915983,
    "CMY_C": 0.1615038,
    "CMY_M": 0.5618936,
    "CMY_Y": 0.5305607,
    "CMYK_C": 0,
    "CMYK_M": 0.4775093,
    "CMYK_Y": 0.4401414,
    "CMYK_K": 0.1615038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03906",
    "Farbtonhilfsbezeichnung": "B0.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "77",
    "Bcolor": "94",
    "Y": 17,
    "L": 48.2048553492508,
    "a": 46.8210979294456,
    "b": 13.0224593135524,
    "C": 48.598350361837,
    "h": 0.27127594010506,
    "CMY_C": 0.2583093,
    "CMY_M": 0.6979655,
    "CMY_Y": 0.6315216,
    "CMYK_C": 0,
    "CMYK_M": 0.5927757,
    "CMYK_Y": 0.5031914,
    "CMYK_K": 0.2583093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03907",
    "Farbtonhilfsbezeichnung": "B3.43.42",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "78",
    "Bcolor": "89",
    "Y": 19,
    "L": 50.8688140290578,
    "a": 51.1762554764063,
    "b": 19.9096012638535,
    "C": 54.9126701870528,
    "h": 0.37102238659206,
    "CMY_C": 0.1972496,
    "CMY_M": 0.6929771,
    "CMY_Y": 0.6500277,
    "CMYK_C": 0,
    "CMYK_M": 0.6175364,
    "CMYK_Y": 0.5640335,
    "CMYK_K": 0.1972496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03908",
    "Farbtonhilfsbezeichnung": "B3.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "127",
    "Bcolor": "127",
    "Y": 22,
    "L": 54.4369077830153,
    "a": 5.45853207678965,
    "b": 1.57989402914269,
    "C": 5.68257314749773,
    "h": 0.28173681553741,
    "CMY_C": 0.447096,
    "CMY_M": 0.5015937,
    "CMY_Y": 0.503354,
    "CMYK_C": 0,
    "CMYK_M": 0.09856629,
    "CMYK_Y": 0.1017501,
    "CMYK_K": 0.447096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03909",
    "Farbtonhilfsbezeichnung": "B1.19.39",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "96",
    "Bcolor": "99",
    "Y": 16,
    "L": 46.4935441935504,
    "a": 22.6729885065683,
    "b": 6.62649269471127,
    "C": 23.6214904959878,
    "h": 0.28434429488528,
    "CMY_C": 0.4137757,
    "CMY_M": 0.6250476,
    "CMY_Y": 0.6110991,
    "CMYK_C": 0,
    "CMYK_M": 0.3603944,
    "CMYK_Y": 0.3366006,
    "CMYK_K": 0.4137757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03910",
    "Farbtonhilfsbezeichnung": "B3.19.39",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "100",
    "Bcolor": "102",
    "Y": 17,
    "L": 47.9094028766565,
    "a": 21.0903041716594,
    "b": 7.03261674400366,
    "C": 22.2319281287331,
    "h": 0.32185788983772,
    "CMY_C": 0.4068551,
    "CMY_M": 0.6068791,
    "CMY_Y": 0.6004823,
    "CMYK_C": 0,
    "CMYK_M": 0.3372263,
    "CMYK_Y": 0.3264418,
    "CMYK_K": 0.4068551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03911",
    "Farbtonhilfsbezeichnung": "B3.30.37",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "85",
    "Bcolor": "88",
    "Y": 15,
    "L": 45.2657606207904,
    "a": 32.208681591013,
    "b": 11.9290498486582,
    "C": 34.3467815103982,
    "h": 0.35470315435277,
    "CMY_C": 0.367503,
    "CMY_M": 0.6686051,
    "CMY_Y": 0.6549279,
    "CMYK_C": 0,
    "CMYK_M": 0.4760531,
    "CMYK_Y": 0.4544289,
    "CMYK_K": 0.367503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03912",
    "Farbtonhilfsbezeichnung": "B3.37.39",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "81",
    "Bcolor": "88",
    "Y": 16,
    "L": 47.4169867891938,
    "a": 41.2390404505451,
    "b": 15.1459107057336,
    "C": 43.9324147798383,
    "h": 0.3519775542317,
    "CMY_C": 0.2928947,
    "CMY_M": 0.6823053,
    "CMY_Y": 0.6536768,
    "CMYK_C": 0,
    "CMYK_M": 0.5507109,
    "CMYK_Y": 0.510224,
    "CMYK_K": 0.2928947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03913",
    "Farbtonhilfsbezeichnung": "B0.41.39",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "77",
    "Bcolor": "92",
    "Y": 17,
    "L": 48.3123805090837,
    "a": 47.1392982899891,
    "b": 14.5261387082897,
    "C": 49.3266879999564,
    "h": 0.29892016206823,
    "CMY_C": 0.2536218,
    "CMY_M": 0.6988002,
    "CMY_Y": 0.6400795,
    "CMYK_C": 0,
    "CMYK_M": 0.5964515,
    "CMYK_Y": 0.5177773,
    "CMYK_K": 0.2536218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03914",
    "Farbtonhilfsbezeichnung": "BN.01.44",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "123",
    "Bcolor": "124",
    "Y": 20,
    "L": 52.0608722204823,
    "a": 1.73687839988912,
    "b": -0.2304431811599,
    "C": 1.75209892293343,
    "h": -0.13190624905896,
    "CMY_C": 0.5016966,
    "CMY_M": 0.5165389,
    "CMY_Y": 0.5153624,
    "CMYK_C": 0,
    "CMYK_M": 0.02978546,
    "CMYK_Y": 0.02742466,
    "CMYK_K": 0.5016966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03915",
    "Farbtonhilfsbezeichnung": "B2.13.37",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "99",
    "Bcolor": "100",
    "Y": 15,
    "L": 45.4207669774836,
    "a": 14.164882733926,
    "b": 4.04461355987877,
    "C": 14.7310149587403,
    "h": 0.27813675343211,
    "CMY_C": 0.4785571,
    "CMY_M": 0.6116184,
    "CMY_Y": 0.6060207,
    "CMYK_C": 0,
    "CMYK_M": 0.255179,
    "CMYK_Y": 0.244444,
    "CMYK_K": 0.4785571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03916",
    "Farbtonhilfsbezeichnung": "B3.26.34",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "85",
    "Bcolor": "87",
    "Y": 13,
    "L": 43.325337678085,
    "a": 26.5039056774307,
    "b": 9.78929755517811,
    "C": 28.2539795919435,
    "h": 0.35381072392708,
    "CMY_C": 0.4215844,
    "CMY_M": 0.6679736,
    "CMY_Y": 0.6603979,
    "CMYK_C": 0,
    "CMYK_M": 0.4259727,
    "CMYK_Y": 0.4128753,
    "CMYK_K": 0.4215844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03917",
    "Farbtonhilfsbezeichnung": "B1.29.39",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "88",
    "Bcolor": "96",
    "Y": 16,
    "L": 47.1960396344257,
    "a": 33.9124503497842,
    "b": 10.0728388447493,
    "C": 35.3767772856555,
    "h": 0.28872502472097,
    "CMY_C": 0.3399611,
    "CMY_M": 0.6551445,
    "CMY_Y": 0.6246464,
    "CMYK_C": 0,
    "CMYK_M": 0.4775224,
    "CMYK_Y": 0.431316,
    "CMYK_K": 0.3399611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03918",
    "Farbtonhilfsbezeichnung": "B3.43.32",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "63",
    "Bcolor": "75",
    "Y": 12,
    "L": 41.363589421756,
    "a": 42.9937722447252,
    "b": 14.8694840337852,
    "C": 45.4924829753476,
    "h": 0.3329747675401,
    "CMY_C": 0.3535802,
    "CMY_M": 0.7511722,
    "CMY_Y": 0.7070609,
    "CMYK_C": 0,
    "CMYK_M": 0.6150678,
    "CMYK_Y": 0.5468284,
    "CMYK_K": 0.3535802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03919",
    "Farbtonhilfsbezeichnung": "BN.02.35",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "101",
    "Bcolor": "101",
    "Y": 13,
    "L": 43.1410005111526,
    "a": 1.99246422527005,
    "b": 0.25895319145492,
    "C": 2.00922135274979,
    "h": 0.12924185815335,
    "CMY_C": 0.5862494,
    "CMY_M": 0.6043839,
    "CMY_Y": 0.605139,
    "CMYK_C": 0,
    "CMYK_M": 0.04382965,
    "CMYK_Y": 0.04565464,
    "CMYK_K": 0.5862494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03921",
    "Farbtonhilfsbezeichnung": "B1.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "85",
    "Bcolor": "86",
    "Y": 10,
    "L": 38.588546436766,
    "a": 9.6966556025323,
    "b": 2.59517491313567,
    "C": 10.0379311964114,
    "h": 0.26150722884881,
    "CMY_C": 0.5764686,
    "CMY_M": 0.6651836,
    "CMY_Y": 0.6617212,
    "CMYK_C": 0,
    "CMYK_M": 0.209465,
    "CMYK_Y": 0.2012899,
    "CMYK_K": 0.5764686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03922",
    "Farbtonhilfsbezeichnung": "B1.21.28",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "77",
    "Bcolor": "81",
    "Y": 10,
    "L": 37.3516411368011,
    "a": 18.427755755632,
    "b": 4.31806805873004,
    "C": 18.9269092550541,
    "h": 0.23017137709191,
    "CMY_C": 0.5361751,
    "CMY_M": 0.6992617,
    "CMY_Y": 0.682599,
    "CMYK_C": 0,
    "CMYK_M": 0.3516124,
    "CMYK_Y": 0.3156879,
    "CMYK_K": 0.5361751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03923",
    "Farbtonhilfsbezeichnung": "B2.22.28",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "74",
    "Bcolor": "77",
    "Y": 10,
    "L": 37.0226840505311,
    "a": 20.9720302057216,
    "b": 6.63578285936508,
    "C": 21.9968103393729,
    "h": 0.30644401519105,
    "CMY_C": 0.5219626,
    "CMY_M": 0.7100704,
    "CMY_Y": 0.699509,
    "CMYK_C": 0,
    "CMYK_M": 0.3935,
    "CMYK_Y": 0.3714069,
    "CMYK_K": 0.5219626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03924",
    "Farbtonhilfsbezeichnung": "A9.34.27",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "59",
    "Bcolor": "70",
    "Y": 9,
    "L": 35.8081147929466,
    "a": 34.6274994661492,
    "b": 9.20224260653819,
    "C": 35.8293872159119,
    "h": 0.25974597270879,
    "CMY_C": 0.4624416,
    "CMY_M": 0.7683607,
    "CMY_Y": 0.7238104,
    "CMYK_C": 0,
    "CMYK_M": 0.56909,
    "CMYK_Y": 0.4862148,
    "CMYK_K": 0.4624416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03925",
    "Farbtonhilfsbezeichnung": "B0.44.30",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "66",
    "Bcolor": "83",
    "Y": 11,
    "L": 41.470874786377,
    "a": 41.2791900634766,
    "b": 10.0283575057983,
    "C": 42.4798698425293,
    "h": 13.6548900604248,
    "CMY_C": 0.36646384000778,
    "CMY_M": 0.74073493480682,
    "CMY_Y": 0.67628192901611,
    "CMYK_C": 0,
    "CMYK_M": 0.59076517820358,
    "CMYK_Y": 0.48902985453606,
    "CMYK_K": 0.36646384000778
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03926",
    "Farbtonhilfsbezeichnung": "BN.02.27",
    "Farbtonklasse": "02",
    "Rcolor": "88",
    "Gcolor": "83",
    "Bcolor": "83",
    "Y": 9,
    "L": 35.6598258050361,
    "a": 2.26728548331095,
    "b": 0.20236541205508,
    "C": 2.27629857945499,
    "h": 0.08901860633174,
    "CMY_C": 0.6558419,
    "CMY_M": 0.6755429,
    "CMY_Y": 0.6749004,
    "CMYK_C": 0,
    "CMYK_M": 0.05724382,
    "CMYK_Y": 0.05537718,
    "CMYK_K": 0.6558419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03927",
    "Farbtonhilfsbezeichnung": "B2.11.21",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "72",
    "Bcolor": "73",
    "Y": 7,
    "L": 32.5054649885974,
    "a": 8.12764064231172,
    "b": 1.87331551686298,
    "C": 8.34073458613071,
    "h": 0.22653087176603,
    "CMY_C": 0.6459214,
    "CMY_M": 0.7174926,
    "CMY_Y": 0.7131607,
    "CMYK_C": 0,
    "CMYK_M": 0.2021337,
    "CMYK_Y": 0.1898994,
    "CMYK_K": 0.6459214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03928",
    "Farbtonhilfsbezeichnung": "B2.16.27",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "76",
    "Bcolor": "78",
    "Y": 9,
    "L": 36.2541297957619,
    "a": 14.9326352645113,
    "b": 4.53309480257742,
    "C": 15.6055292903535,
    "h": 0.29472847314064,
    "CMY_C": 0.5658299,
    "CMY_M": 0.7002127,
    "CMY_Y": 0.6944724,
    "CMYK_C": 0,
    "CMYK_M": 0.3095165,
    "CMYK_Y": 0.2962951,
    "CMYK_K": 0.5658299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03929",
    "Farbtonhilfsbezeichnung": "B2.23.26",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "70",
    "Bcolor": "74",
    "Y": 9,
    "L": 35.34539100352,
    "a": 20.989844955993,
    "b": 5.7243432039926,
    "C": 21.756417361177,
    "h": 0.26624495564666,
    "CMY_C": 0.5405642,
    "CMY_M": 0.7254412,
    "CMY_Y": 0.7091162,
    "CMYK_C": 0,
    "CMYK_M": 0.4024,
    "CMYK_Y": 0.3668674,
    "CMYK_K": 0.5405642
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03930",
    "Farbtonhilfsbezeichnung": "B1.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "115",
    "Gcolor": "67",
    "Bcolor": "70",
    "Y": 8,
    "L": 34.1229373748256,
    "a": 21.7576596599826,
    "b": 6.44558565298989,
    "C": 22.6923187067709,
    "h": 0.28800777314716,
    "CMY_C": 0.5479329,
    "CMY_M": 0.7391462,
    "CMY_Y": 0.7243851,
    "CMYK_C": 0,
    "CMYK_M": 0.4229755,
    "CMYK_Y": 0.3903231,
    "CMYK_K": 0.5479329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03931",
    "Farbtonhilfsbezeichnung": "B0.29.30",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "73",
    "Bcolor": "75",
    "Y": 10,
    "L": 38.5943380324877,
    "a": 27.1390685167117,
    "b": 10.1140352644394,
    "C": 28.962436867175,
    "h": 0.35673020456965,
    "CMY_C": 0.468391,
    "CMY_M": 0.7151496,
    "CMY_Y": 0.7057074,
    "CMYK_C": 0,
    "CMYK_M": 0.4641731,
    "CMYK_Y": 0.4464116,
    "CMYK_K": 0.468391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03932",
    "Farbtonhilfsbezeichnung": "B3.45.23",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "48",
    "Bcolor": "59",
    "Y": 8,
    "L": 33.9056103651939,
    "a": 40.0539517649427,
    "b": 14.1375397484223,
    "C": 42.47574698727,
    "h": 0.33931150479258,
    "CMY_C": 0.4521093,
    "CMY_M": 0.8125751,
    "CMY_Y": 0.7693078,
    "CMYK_C": 0,
    "CMYK_M": 0.6579156,
    "CMYK_Y": 0.5789449,
    "CMYK_K": 0.4521093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03933",
    "Farbtonhilfsbezeichnung": "A8.08.21",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "68",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.6270375089597,
    "a": 7.83410342851834,
    "b": 1.1734140354522,
    "C": 7.9214946207972,
    "h": 0.14867753134748,
    "CMY_C": 0.6668996,
    "CMY_M": 0.7336464,
    "CMY_Y": 0.7258648,
    "CMYK_C": 0,
    "CMYK_M": 0.2003804,
    "CMYK_Y": 0.1770191,
    "CMYK_K": 0.6668996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03934",
    "Farbtonhilfsbezeichnung": "B3.11.14",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "54",
    "Bcolor": "54",
    "Y": 4,
    "L": 24.6143234529001,
    "a": 7.72338689458346,
    "b": 2.70483611459551,
    "C": 8.1833271674939,
    "h": 0.33686520996673,
    "CMY_C": 0.7200016,
    "CMY_M": 0.7869331,
    "CMY_Y": 0.787666,
    "CMYK_C": 0,
    "CMYK_M": 0.2390423,
    "CMYK_Y": 0.24166,
    "CMYK_K": 0.7200016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03935",
    "Farbtonhilfsbezeichnung": "B1.17.11",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "49",
    "Bcolor": "51",
    "Y": 4,
    "L": 22.8945355819255,
    "a": 11.0077926465665,
    "b": 2.45176544763672,
    "C": 11.2775286636758,
    "h": 0.21915275811438,
    "CMY_C": 0.7190039,
    "CMY_M": 0.809241,
    "CMY_Y": 0.8004856,
    "CMYK_C": 0,
    "CMYK_M": 0.3211328,
    "CMYK_Y": 0.2899742,
    "CMYK_K": 0.7190039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03936",
    "Farbtonhilfsbezeichnung": "B2.20.21",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 6,
    "L": 30.5997277405694,
    "a": 16.9972552425166,
    "b": 5.26280509533643,
    "C": 17.793364022881,
    "h": 0.30026511911048,
    "CMY_C": 0.6096756,
    "CMY_M": 0.7573995,
    "CMY_Y": 0.7493172,
    "CMYK_C": 0,
    "CMYK_M": 0.3784643,
    "CMYK_Y": 0.3577576,
    "CMYK_K": 0.6096756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03937",
    "Farbtonhilfsbezeichnung": "B0.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "63",
    "Bcolor": "68",
    "Y": 8,
    "L": 33.0767222441215,
    "a": 23.145556951307,
    "b": 6.3255088564827,
    "C": 23.9943507701216,
    "h": 0.26677813946756,
    "CMY_C": 0.5517873,
    "CMY_M": 0.7529182,
    "CMY_Y": 0.7327806,
    "CMYK_C": 0,
    "CMYK_M": 0.44874,
    "CMYK_Y": 0.4038114,
    "CMYK_K": 0.5517873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03938",
    "Farbtonhilfsbezeichnung": "B1.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "56",
    "Bcolor": "62",
    "Y": 6,
    "L": 30.0054481120172,
    "a": 22.9689092946162,
    "b": 5.96976431263154,
    "C": 23.7320222512258,
    "h": 0.25428029297482,
    "CMY_C": 0.5845048,
    "CMY_M": 0.7802808,
    "CMY_Y": 0.757821,
    "CMYK_C": 0,
    "CMYK_M": 0.4711871,
    "CMYK_Y": 0.4171317,
    "CMYK_K": 0.5845048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03939",
    "Farbtonhilfsbezeichnung": "B3.31.15",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "50",
    "Bcolor": "54",
    "Y": 5,
    "L": 27.0660780889195,
    "a": 21.3881151648477,
    "b": 6.92695303086169,
    "C": 22.4818626585199,
    "h": 0.31320884372104,
    "CMY_C": 0.6204284,
    "CMY_M": 0.8020313,
    "CMY_Y": 0.7891904,
    "CMYK_C": 0,
    "CMYK_M": 0.4784417,
    "CMYK_Y": 0.4446118,
    "CMYK_K": 0.6204284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03940",
    "Farbtonhilfsbezeichnung": "B3.31.21",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "54",
    "Bcolor": "57",
    "Y": 7,
    "L": 31.0724663142082,
    "a": 28.2928754214498,
    "b": 10.6623034578785,
    "C": 30.2352693826525,
    "h": 0.36039572802347,
    "CMY_C": 0.5415522,
    "CMY_M": 0.7895088,
    "CMY_Y": 0.7754921,
    "CMYK_C": 0,
    "CMYK_M": 0.5408611,
    "CMYK_Y": 0.5102869,
    "CMYK_K": 0.5415522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03942",
    "Farbtonhilfsbezeichnung": "B9.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "220",
    "Bcolor": "215",
    "Y": 76,
    "L": 89.8174418759858,
    "a": 8.27762953578126,
    "b": 5.13233770146932,
    "C": 9.73961195395185,
    "h": 0.55501382464188,
    "CMY_C": 0.03516406,
    "CMY_M": 0.135551,
    "CMY_Y": 0.1578286,
    "CMYK_C": 0,
    "CMYK_M": 0.1040457,
    "CMYK_Y": 0.1271352,
    "CMYK_K": 0.03516406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03943",
    "Farbtonhilfsbezeichnung": "B7.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "221",
    "Bcolor": "215",
    "Y": 77,
    "L": 90.2682390941838,
    "a": 9.90655059869816,
    "b": 5.81416767954674,
    "C": 11.486700595491,
    "h": 0.53073244355756,
    "CMY_C": 0.0162077,
    "CMY_M": 0.1349078,
    "CMY_Y": 0.1576782,
    "CMYK_C": 0,
    "CMYK_M": 0.1206557,
    "CMYK_Y": 0.1438012,
    "CMYK_K": 0.0162077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03944",
    "Farbtonhilfsbezeichnung": "B6.10.78",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "203",
    "Bcolor": "197",
    "Y": 67,
    "L": 85.4319067312137,
    "a": 15.5334240648948,
    "b": 8.15195369752564,
    "C": 17.5425657264396,
    "h": 0.48329084624867,
    "CMY_C": 0.02537452,
    "CMY_M": 0.2035379,
    "CMY_Y": 0.2264639,
    "CMYK_C": 0,
    "CMYK_M": 0.1828019,
    "CMYK_Y": 0.2063248,
    "CMYK_K": 0.02537452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03945",
    "Farbtonhilfsbezeichnung": "B7.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "192",
    "Bcolor": "186",
    "Y": 59,
    "L": 81.1724446171427,
    "a": 15.1753645726586,
    "b": 7.91169963917102,
    "C": 17.1139323679147,
    "h": 0.48058257038448,
    "CMY_C": 0.07687967,
    "CMY_M": 0.2488053,
    "CMY_Y": 0.2704139,
    "CMYK_C": 0,
    "CMYK_M": 0.186244,
    "CMYK_Y": 0.2096522,
    "CMYK_K": 0.07687967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03946",
    "Farbtonhilfsbezeichnung": "B6.14.73",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "187",
    "Bcolor": "181",
    "Y": 58,
    "L": 80.7544855005782,
    "a": 20.3226451974775,
    "b": 9.985283121938,
    "C": 22.6432282779602,
    "h": 0.45669384067044,
    "CMY_C": 0.04231795,
    "CMY_M": 0.2679203,
    "CMY_Y": 0.2889589,
    "CMYK_C": 0,
    "CMYK_M": 0.2355712,
    "CMYK_Y": 0.2575395,
    "CMYK_K": 0.04231795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03947",
    "Farbtonhilfsbezeichnung": "B6.17.70",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "173",
    "Bcolor": "167",
    "Y": 52,
    "L": 77.1371890232766,
    "a": 24.689776091888,
    "b": 12.6259577421698,
    "C": 27.7308465859704,
    "h": 0.47271331933583,
    "CMY_C": 0.05007336,
    "CMY_M": 0.3199137,
    "CMY_Y": 0.3452016,
    "CMYK_C": 0,
    "CMYK_M": 0.2840644,
    "CMYK_Y": 0.3106853,
    "CMYK_K": 0.05007336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03948",
    "Farbtonhilfsbezeichnung": "B5.24.63",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "149",
    "Bcolor": "148",
    "Y": 41,
    "L": 70.405000302693,
    "a": 32.428454521611,
    "b": 13.3303239169065,
    "C": 35.0614061097076,
    "h": 0.3900118258838,
    "CMY_C": 0.07931864,
    "CMY_M": 0.4149794,
    "CMY_Y": 0.418336,
    "CMYK_C": 0,
    "CMYK_M": 0.3645787,
    "CMYK_Y": 0.3682244,
    "CMYK_K": 0.07931864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03949",
    "Farbtonhilfsbezeichnung": "B7.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "208",
    "Bcolor": "205",
    "Y": 66,
    "L": 84.6192092895508,
    "a": 4.81560754776001,
    "b": 2.53255200386047,
    "C": 5.44094610214233,
    "h": 27.7401065826416,
    "CMY_C": 0.12681502103806,
    "CMY_M": 0.18342691659927,
    "CMY_Y": 0.19592308998108,
    "CMYK_C": 0,
    "CMYK_M": 0.06483379751444,
    "CMYK_Y": 0.07914482057095,
    "CMYK_K": 0.12681502103806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03950",
    "Farbtonhilfsbezeichnung": "B6.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "212",
    "Bcolor": "208",
    "Y": 71,
    "L": 87.2584364649865,
    "a": 10.8319108491081,
    "b": 5.10282304434395,
    "C": 11.973683462699,
    "h": 0.4402546688175,
    "CMY_C": 0.04572528,
    "CMY_M": 0.1703071,
    "CMY_Y": 0.1851447,
    "CMYK_C": 0,
    "CMYK_M": 0.1305513,
    "CMYK_Y": 0.1460998,
    "CMYK_K": 0.04572528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03951",
    "Farbtonhilfsbezeichnung": "B5.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "210",
    "Bcolor": "205",
    "Y": 71,
    "L": 87.4953330571685,
    "a": 14.5318642469334,
    "b": 6.97419935245887,
    "C": 16.1187634482034,
    "h": 0.44745870457929,
    "CMY_C": 0.01176167,
    "CMY_M": 0.1779261,
    "CMY_Y": 0.1957083,
    "CMYK_C": 0,
    "CMYK_M": 0.168142,
    "CMYK_Y": 0.1861359,
    "CMYK_K": 0.01176167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03952",
    "Farbtonhilfsbezeichnung": "B1.15.65",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "165",
    "Bcolor": "166",
    "Y": 45,
    "L": 72.9335220860096,
    "a": 21.5665001948916,
    "b": 6.94771973509321,
    "C": 22.6579950607653,
    "h": 0.31165502784313,
    "CMY_C": 0.1301271,
    "CMY_M": 0.3540337,
    "CMY_Y": 0.3493885,
    "CMYK_C": 0,
    "CMYK_M": 0.2574015,
    "CMYK_Y": 0.2520615,
    "CMYK_K": 0.1301271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03953",
    "Farbtonhilfsbezeichnung": "B6.18.69",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "170",
    "Bcolor": "166",
    "Y": 51,
    "L": 76.270133972168,
    "a": 26.6822147369385,
    "b": 12.2036714553833,
    "C": 29.3405895233154,
    "h": 24.5779838562012,
    "CMY_C": 0.04845505952835,
    "CMY_M": 0.33486360311508,
    "CMY_Y": 0.35089296102524,
    "CMYK_C": 0,
    "CMYK_M": 0.3009931743145,
    "CMYK_Y": 0.31783878803253,
    "CMYK_K": 0.04845505952835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03954",
    "Farbtonhilfsbezeichnung": "B7.25.62",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "145",
    "Bcolor": "140",
    "Y": 39,
    "L": 69.0912474211143,
    "a": 33.5669762236843,
    "b": 15.8663550085416,
    "C": 37.1279290300235,
    "h": 0.44155169467409,
    "CMY_C": 0.0834657,
    "CMY_M": 0.4331091,
    "CMY_Y": 0.449149,
    "CMYK_C": 0,
    "CMYK_M": 0.3814842,
    "CMYK_Y": 0.3989848,
    "CMYK_K": 0.0834657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03955",
    "Farbtonhilfsbezeichnung": "B5.04.74",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "197",
    "Bcolor": "194",
    "Y": 58,
    "L": 80.9366144402532,
    "a": 6.86764013623475,
    "b": 3.09021723082625,
    "C": 7.53086472953259,
    "h": 0.42282718550349,
    "CMY_C": 0.1508293,
    "CMY_M": 0.2287615,
    "CMY_Y": 0.2394186,
    "CMYK_C": 0,
    "CMYK_M": 0.09177441,
    "CMYK_Y": 0.1043244,
    "CMYK_K": 0.1508293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03956",
    "Farbtonhilfsbezeichnung": "B6.07.74",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "199",
    "Bcolor": "195",
    "Y": 60,
    "L": 82.6174697875977,
    "a": 10.5048398971558,
    "b": 5.35998964309692,
    "C": 11.793267250061,
    "h": 27.0324935913086,
    "CMY_C": 0.09962075948715,
    "CMY_M": 0.22023040056229,
    "CMY_Y": 0.23723536729813,
    "CMYK_C": 0,
    "CMYK_M": 0.13395427167416,
    "CMYK_Y": 0.15284071862698,
    "CMYK_K": 0.09962075948715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03957",
    "Farbtonhilfsbezeichnung": "B4.09.73",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "188",
    "Bcolor": "186",
    "Y": 56,
    "L": 79.8697473599234,
    "a": 15.3988394516848,
    "b": 5.96272102140811,
    "C": 16.5129736400779,
    "h": 0.36943982723604,
    "CMY_C": 0.09499678,
    "CMY_M": 0.2629191,
    "CMY_Y": 0.2702317,
    "CMYK_C": 0,
    "CMYK_M": 0.1855488,
    "CMYK_Y": 0.193629,
    "CMYK_K": 0.09499678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03958",
    "Farbtonhilfsbezeichnung": "B5.14.62",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "159",
    "Bcolor": "159",
    "Y": 41,
    "L": 70.8160171508789,
    "a": 21.0641860961914,
    "b": 7.86537551879883,
    "C": 22.4847526550293,
    "h": 20.4756526947021,
    "CMY_C": 0.15506798028946,
    "CMY_M": 0.37511420249939,
    "CMY_Y": 0.3779000043869,
    "CMYK_C": 0,
    "CMYK_M": 0.2604306936264,
    "CMYK_Y": 0.26372775435448,
    "CMYK_K": 0.15506798028946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03959",
    "Farbtonhilfsbezeichnung": "B4.22.56",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "134",
    "Bcolor": "134",
    "Y": 32,
    "L": 63.4531459574782,
    "a": 28.9149259861948,
    "b": 11.1779211927656,
    "C": 31.0003043046161,
    "h": 0.36888382183178,
    "CMY_C": 0.1836457,
    "CMY_M": 0.4755806,
    "CMY_Y": 0.474494,
    "CMYK_C": 0,
    "CMYK_M": 0.3576081,
    "CMYK_Y": 0.356277,
    "CMYK_K": 0.1836457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03960",
    "Farbtonhilfsbezeichnung": "B4.25.57",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "134",
    "Bcolor": "136",
    "Y": 34,
    "L": 65.1385682526887,
    "a": 33.8642430520183,
    "b": 12.8301997924957,
    "C": 36.2132708299254,
    "h": 0.36216061779128,
    "CMY_C": 0.1327548,
    "CMY_M": 0.4744355,
    "CMY_Y": 0.4679819,
    "CMYK_C": 0,
    "CMYK_M": 0.393984,
    "CMYK_Y": 0.3865425,
    "CMYK_K": 0.1327548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03961",
    "Farbtonhilfsbezeichnung": "B6.28.59",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "136",
    "Bcolor": "133",
    "Y": 37,
    "L": 67.1486511230469,
    "a": 37.0232162475586,
    "b": 17.3244152069092,
    "C": 40.8760795593262,
    "h": 25.0764827728271,
    "CMY_C": 0.08388793468475,
    "CMY_M": 0.46526300907135,
    "CMY_Y": 0.47814244031906,
    "CMYK_C": 0,
    "CMYK_M": 0.41629740595818,
    "CMYK_Y": 0.43035620450974,
    "CMYK_K": 0.08388793468475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03962",
    "Farbtonhilfsbezeichnung": "B5.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "196",
    "Bcolor": "194",
    "Y": 57,
    "L": 80.1105792166087,
    "a": 4.32880113633427,
    "b": 1.77538806789217,
    "C": 4.67873081823936,
    "h": 0.38921185142397,
    "CMY_C": 0.1824995,
    "CMY_M": 0.231169,
    "CMY_Y": 0.2391715,
    "CMYK_C": 0,
    "CMYK_M": 0.05953452,
    "CMYK_Y": 0.06932348,
    "CMYK_K": 0.1824995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03963",
    "Farbtonhilfsbezeichnung": "B4.05.69",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "184",
    "Bcolor": "182",
    "Y": 51,
    "L": 76.454179543269,
    "a": 8.12864522006329,
    "b": 2.91479260649303,
    "C": 8.63544376697134,
    "h": 0.34430043745315,
    "CMY_C": 0.1916196,
    "CMY_M": 0.2801,
    "CMY_Y": 0.285827,
    "CMYK_C": 0,
    "CMYK_M": 0.1094539,
    "CMYK_Y": 0.1165384,
    "CMYK_K": 0.1916196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03964",
    "Farbtonhilfsbezeichnung": "B5.07.71",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "186",
    "Bcolor": "183",
    "Y": 53,
    "L": 77.8731231717309,
    "a": 10.659951971825,
    "b": 4.59412973334694,
    "C": 11.6077820469044,
    "h": 0.40691721405543,
    "CMY_C": 0.1535079,
    "CMY_M": 0.2716931,
    "CMY_Y": 0.2823817,
    "CMYK_C": 0,
    "CMYK_M": 0.1396176,
    "CMYK_Y": 0.1522445,
    "CMYK_K": 0.1535079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03965",
    "Farbtonhilfsbezeichnung": "B7.10.72",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "187",
    "Bcolor": "182",
    "Y": 56,
    "L": 79.3844803031261,
    "a": 15.0037246719525,
    "b": 7.64331744815161,
    "C": 16.8384101281854,
    "h": 0.47116153034046,
    "CMY_C": 0.09890299,
    "CMY_M": 0.2675566,
    "CMY_Y": 0.2875191,
    "CMYK_C": 0,
    "CMYK_M": 0.1871648,
    "CMYK_Y": 0.2093183,
    "CMYK_K": 0.09890299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03966",
    "Farbtonhilfsbezeichnung": "B7.24.53",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "126",
    "Bcolor": "123",
    "Y": 30,
    "L": 61.2458202016487,
    "a": 30.972330729193,
    "b": 14.5878364346305,
    "C": 34.2358035197371,
    "h": 0.44017616920837,
    "CMY_C": 0.1909665,
    "CMY_M": 0.5055794,
    "CMY_Y": 0.5193064,
    "CMYK_C": 0,
    "CMYK_M": 0.3888749,
    "CMYK_Y": 0.4058422,
    "CMYK_K": 0.1909665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03967",
    "Farbtonhilfsbezeichnung": "B5.39.47",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "96",
    "Bcolor": "100",
    "Y": 23,
    "L": 55.5556812612199,
    "a": 46.4823978253144,
    "b": 19.9975542255083,
    "C": 50.601536365934,
    "h": 0.40628184395863,
    "CMY_C": 0.1654035,
    "CMY_M": 0.622196,
    "CMY_Y": 0.6075765,
    "CMYK_C": 0,
    "CMYK_M": 0.5473213,
    "CMYK_Y": 0.5298046,
    "CMYK_K": 0.1654035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03968",
    "Farbtonhilfsbezeichnung": "B7.04.68",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "181",
    "Bcolor": "178",
    "Y": 49,
    "L": 75.1535598284782,
    "a": 5.94483700965021,
    "b": 2.94259596816995,
    "C": 6.63324642261968,
    "h": 0.4596263262262,
    "CMY_C": 0.2213108,
    "CMY_M": 0.2886788,
    "CMY_Y": 0.3001118,
    "CMYK_C": 0,
    "CMYK_M": 0.08651463,
    "CMYK_Y": 0.1011971,
    "CMYK_K": 0.2213108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03969",
    "Farbtonhilfsbezeichnung": "B6.05.67",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "176",
    "Bcolor": "172",
    "Y": 46,
    "L": 73.4919296375269,
    "a": 7.74059160215318,
    "b": 3.96628518729611,
    "C": 8.69759602064208,
    "h": 0.47351894715393,
    "CMY_C": 0.2237384,
    "CMY_M": 0.3110097,
    "CMY_Y": 0.3246199,
    "CMYK_C": 0,
    "CMYK_M": 0.1124251,
    "CMYK_Y": 0.1299582,
    "CMYK_K": 0.2237384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03970",
    "Farbtonhilfsbezeichnung": "B4.09.63",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "164",
    "Bcolor": "163",
    "Y": 41,
    "L": 70.4990816169304,
    "a": 13.0746307614975,
    "b": 5.04081238480663,
    "C": 14.0126999200124,
    "h": 0.36798032930282,
    "CMY_C": 0.217113,
    "CMY_M": 0.3562758,
    "CMY_Y": 0.3626623,
    "CMYK_C": 0,
    "CMYK_M": 0.1777559,
    "CMYK_Y": 0.1859135,
    "CMYK_K": 0.217113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03971",
    "Farbtonhilfsbezeichnung": "B4.16.58",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "144",
    "Bcolor": "143",
    "Y": 34,
    "L": 65.3084967368215,
    "a": 21.6845065168085,
    "b": 8.58850866781657,
    "C": 23.3233853463572,
    "h": 0.37711091864246,
    "CMY_C": 0.2111654,
    "CMY_M": 0.4344249,
    "CMY_Y": 0.4392551,
    "CMYK_C": 0,
    "CMYK_M": 0.2830245,
    "CMYK_Y": 0.2891477,
    "CMYK_K": 0.2111654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03972",
    "Farbtonhilfsbezeichnung": "B4.27.51",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "118",
    "Bcolor": "119",
    "Y": 27,
    "L": 58.6804145990934,
    "a": 33.3818183241841,
    "b": 13.0573302161334,
    "C": 35.8446602299698,
    "h": 0.37285469317763,
    "CMY_C": 0.209118,
    "CMY_M": 0.5391995,
    "CMY_Y": 0.5337677,
    "CMYK_C": 0,
    "CMYK_M": 0.4173588,
    "CMYK_Y": 0.4104907,
    "CMYK_K": 0.209118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03973",
    "Farbtonhilfsbezeichnung": "B5.37.50",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "106",
    "Bcolor": "108",
    "Y": 27,
    "L": 58.6713417653703,
    "a": 45.1768943228542,
    "b": 19.5660568860461,
    "C": 49.2319242232753,
    "h": 0.40871032232739,
    "CMY_C": 0.1358795,
    "CMY_M": 0.5842822,
    "CMY_Y": 0.575121,
    "CMYK_C": 0,
    "CMYK_M": 0.5189123,
    "CMYK_Y": 0.5083104,
    "CMYK_K": 0.1358795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03974",
    "Farbtonhilfsbezeichnung": "B6.47.41",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "79",
    "Bcolor": "87",
    "Y": 18,
    "L": 50.9230308532715,
    "a": 50.350471496582,
    "b": 21.2064266204834,
    "C": 54.6340789794922,
    "h": 22.8396739959717,
    "CMY_C": 0.19934290647507,
    "CMY_M": 0.68858361244202,
    "CMY_Y": 0.65816807746887,
    "CMYK_C": 0,
    "CMYK_M": 0.61104899644852,
    "CMYK_Y": 0.5730607509613,
    "CMYK_K": 0.19934290647507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03975",
    "Farbtonhilfsbezeichnung": "B6.06.58",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "154",
    "Bcolor": "152",
    "Y": 35,
    "L": 65.3805865762814,
    "a": 7.62650939385762,
    "b": 3.01045648499381,
    "C": 8.19917640880105,
    "h": 0.37596007473826,
    "CMY_C": 0.3144323,
    "CMY_M": 0.3955739,
    "CMY_Y": 0.402211,
    "CMYK_C": 0,
    "CMYK_M": 0.1183568,
    "CMYK_Y": 0.1280381,
    "CMYK_K": 0.3144323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03976",
    "Farbtonhilfsbezeichnung": "B7.12.47",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "120",
    "Bcolor": "115",
    "Y": 22,
    "L": 54.0306004247862,
    "a": 14.5011360280398,
    "b": 7.91671937879093,
    "C": 16.5214222095508,
    "h": 0.49971914787895,
    "CMY_C": 0.3787354,
    "CMY_M": 0.5291757,
    "CMY_Y": 0.5481963,
    "CMYK_C": 0,
    "CMYK_M": 0.2421518,
    "CMYK_Y": 0.2727677,
    "CMYK_K": 0.3787354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03977",
    "Farbtonhilfsbezeichnung": "B6.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "138",
    "Bcolor": "135",
    "Y": 31,
    "L": 62.1641626281106,
    "a": 18.4638644377142,
    "b": 8.19797324098697,
    "C": 20.2020062180524,
    "h": 0.41785392293007,
    "CMY_C": 0.2664447,
    "CMY_M": 0.4576995,
    "CMY_Y": 0.4688607,
    "CMYK_C": 0,
    "CMYK_M": 0.2607231,
    "CMYK_Y": 0.2759383,
    "CMYK_K": 0.2664447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03978",
    "Farbtonhilfsbezeichnung": "B4.28.47",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "108",
    "Bcolor": "109",
    "Y": 23,
    "L": 55.2300756908329,
    "a": 34.2040450448387,
    "b": 13.5776950644013,
    "C": 36.8004144092321,
    "h": 0.3778843916779,
    "CMY_C": 0.2429889,
    "CMY_M": 0.5770473,
    "CMY_Y": 0.5707023,
    "CMYK_C": 0,
    "CMYK_M": 0.4412859,
    "CMYK_Y": 0.4329044,
    "CMYK_K": 0.2429889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03979",
    "Farbtonhilfsbezeichnung": "B5.38.49",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "101",
    "Bcolor": "104",
    "Y": 25,
    "L": 57.3726126551034,
    "a": 46.4982261499673,
    "b": 20.2628047406221,
    "C": 50.7214578955503,
    "h": 0.41096238333332,
    "CMY_C": 0.1434574,
    "CMY_M": 0.603422,
    "CMY_Y": 0.5919817,
    "CMYK_C": 0,
    "CMYK_M": 0.5370014,
    "CMYK_Y": 0.523645,
    "CMYK_K": 0.1434574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03980",
    "Farbtonhilfsbezeichnung": "B5.40.45",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "90",
    "Bcolor": "94",
    "Y": 20,
    "L": 52.3367637369302,
    "a": 44.9119593468479,
    "b": 18.7051499274859,
    "C": 48.6514822608998,
    "h": 0.39463617524705,
    "CMY_C": 0.2129406,
    "CMY_M": 0.6484866,
    "CMY_Y": 0.6298958,
    "CMYK_C": 0,
    "CMYK_M": 0.5533838,
    "CMYK_Y": 0.5297633,
    "CMYK_K": 0.2129406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03981",
    "Farbtonhilfsbezeichnung": "B6.51.39",
    "Farbtonklasse": "04",
    "Rcolor": "200",
    "Gcolor": "69",
    "Bcolor": "76",
    "Y": 17,
    "L": 48.4202347773243,
    "a": 52.7205902086503,
    "b": 24.7412047454254,
    "C": 58.2373406347122,
    "h": 0.43877855230236,
    "CMY_C": 0.2141238,
    "CMY_M": 0.7288603,
    "CMY_Y": 0.7035158,
    "CMYK_C": 0,
    "CMYK_M": 0.6549842,
    "CMYK_Y": 0.6227342,
    "CMYK_K": 0.2141238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03982",
    "Farbtonhilfsbezeichnung": "B5.05.50",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "136",
    "Bcolor": "135",
    "Y": 26,
    "L": 58.223606616878,
    "a": 6.29440658482727,
    "b": 2.56448317733671,
    "C": 6.79677336844181,
    "h": 0.38688870409135,
    "CMY_C": 0.3998454,
    "CMY_M": 0.4656546,
    "CMY_Y": 0.4720335,
    "CMYK_C": 0,
    "CMYK_M": 0.1096537,
    "CMYK_Y": 0.1202825,
    "CMYK_K": 0.3998454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03983",
    "Farbtonhilfsbezeichnung": "B4.09.51",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "135",
    "Bcolor": "134",
    "Y": 27,
    "L": 59.1921338720772,
    "a": 11.6414356701767,
    "b": 4.38627408936854,
    "C": 12.440354691484,
    "h": 0.36033135415072,
    "CMY_C": 0.3499219,
    "CMY_M": 0.469202,
    "CMY_Y": 0.4738653,
    "CMYK_C": 0,
    "CMYK_M": 0.1834858,
    "CMYK_Y": 0.1906592,
    "CMYK_K": 0.3499219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03984",
    "Farbtonhilfsbezeichnung": "B3.14.45",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "117",
    "Bcolor": "118",
    "Y": 22,
    "L": 53.6819532209636,
    "a": 17.23359469202,
    "b": 5.74528855228087,
    "C": 18.1660432278961,
    "h": 0.32179008651289,
    "CMY_C": 0.3705546,
    "CMY_M": 0.5392385,
    "CMY_Y": 0.5367887,
    "CMYK_C": 0,
    "CMYK_M": 0.2679881,
    "CMYK_Y": 0.2640962,
    "CMYK_K": 0.3705546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03985",
    "Farbtonhilfsbezeichnung": "B7.19.42",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "104",
    "Bcolor": "100",
    "Y": 18,
    "L": 49.1174704529344,
    "a": 19.7420100482479,
    "b": 9.92407801775093,
    "C": 22.0960241954866,
    "h": 0.46579595771292,
    "CMY_C": 0.396358,
    "CMY_M": 0.5920592,
    "CMY_Y": 0.6079511,
    "CMYK_C": 0,
    "CMYK_M": 0.3242007,
    "CMYK_Y": 0.3505275,
    "CMYK_K": 0.396358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03986",
    "Farbtonhilfsbezeichnung": "B6.24.45",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "105",
    "Bcolor": "103",
    "Y": 20,
    "L": 52.1948923064741,
    "a": 28.3249889602125,
    "b": 12.6466961674123,
    "C": 31.0200567947095,
    "h": 0.41992740408612,
    "CMY_C": 0.3105789,
    "CMY_M": 0.5878448,
    "CMY_Y": 0.5948738,
    "CMYK_C": 0,
    "CMYK_M": 0.4021721,
    "CMYK_Y": 0.4123676,
    "CMYK_K": 0.3105789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03987",
    "Farbtonhilfsbezeichnung": "B5.40.39",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "81",
    "Bcolor": "86",
    "Y": 17,
    "L": 47.9118508387457,
    "a": 41.8675651700137,
    "b": 17.4028107990471,
    "C": 45.3403885842719,
    "h": 0.39393588573644,
    "CMY_C": 0.2813289,
    "CMY_M": 0.6805261,
    "CMY_Y": 0.6634633,
    "CMYK_C": 0,
    "CMYK_M": 0.5554658,
    "CMYK_Y": 0.5317236,
    "CMYK_K": 0.2813289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03988",
    "Farbtonhilfsbezeichnung": "B5.49.39",
    "Farbtonklasse": "04",
    "Rcolor": "196",
    "Gcolor": "68",
    "Bcolor": "78",
    "Y": 16,
    "L": 47.5934857091766,
    "a": 51.8269849433189,
    "b": 22.1302615797311,
    "C": 56.3541022987886,
    "h": 0.40356571362685,
    "CMY_C": 0.2307711,
    "CMY_M": 0.7322422,
    "CMY_Y": 0.6944057,
    "CMYK_C": 0,
    "CMYK_M": 0.6519141,
    "CMYK_Y": 0.6027265,
    "CMYK_K": 0.2307711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03990",
    "Farbtonhilfsbezeichnung": "B4.04.43",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "118",
    "Bcolor": "117",
    "Y": 19,
    "L": 50.7270213278257,
    "a": 4.57374261631743,
    "b": 1.45344803220926,
    "C": 4.79912832737896,
    "h": 0.30768867553866,
    "CMY_C": 0.4909285,
    "CMY_M": 0.5364327,
    "CMY_Y": 0.539224,
    "CMYK_C": 0,
    "CMYK_M": 0.08938662,
    "CMYK_Y": 0.0948697,
    "CMYK_K": 0.4909285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03991",
    "Farbtonhilfsbezeichnung": "B7.10.35",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "97",
    "Bcolor": "96",
    "Y": 14,
    "L": 43.5493208518294,
    "a": 9.53227336496737,
    "b": 4.21033202088166,
    "C": 10.4207068488912,
    "h": 0.41592382542575,
    "CMY_C": 0.5246761,
    "CMY_M": 0.6182666,
    "CMY_Y": 0.6254867,
    "CMYK_C": 0,
    "CMYK_M": 0.1968985,
    "CMYK_Y": 0.2120883,
    "CMYK_K": 0.5246761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03992",
    "Farbtonhilfsbezeichnung": "B5.18.40",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "102",
    "Bcolor": "101",
    "Y": 17,
    "L": 48.2177727223061,
    "a": 19.6879388630348,
    "b": 8.16363416751305,
    "C": 21.3133727855443,
    "h": 0.39307286102687,
    "CMY_C": 0.4094197,
    "CMY_M": 0.6002443,
    "CMY_Y": 0.6050895,
    "CMYK_C": 0,
    "CMYK_M": 0.3231137,
    "CMYK_Y": 0.3313179,
    "CMYK_K": 0.4094197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03993",
    "Farbtonhilfsbezeichnung": "B4.24.35",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "87",
    "Bcolor": "89",
    "Y": 14,
    "L": 43.647043479013,
    "a": 24.5076013032223,
    "b": 8.91652808730029,
    "C": 26.0792445206781,
    "h": 0.34893940257802,
    "CMY_C": 0.4301269,
    "CMY_M": 0.6585072,
    "CMY_Y": 0.6522143,
    "CMYK_C": 0,
    "CMYK_M": 0.4007563,
    "CMYK_Y": 0.3897138,
    "CMYK_K": 0.4301269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03994",
    "Farbtonhilfsbezeichnung": "B5.34.39",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "85",
    "Bcolor": "88",
    "Y": 16,
    "L": 46.6832026916863,
    "a": 35.2420981678465,
    "b": 14.1968065409782,
    "C": 37.994141643602,
    "h": 0.38294931625818,
    "CMY_C": 0.3329906,
    "CMY_M": 0.6661006,
    "CMY_Y": 0.655658,
    "CMYK_C": 0,
    "CMYK_M": 0.4994082,
    "CMYK_Y": 0.4837524,
    "CMYK_K": 0.3329906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03995",
    "Farbtonhilfsbezeichnung": "B7.45.31",
    "Farbtonklasse": "04",
    "Rcolor": "169",
    "Gcolor": "62",
    "Bcolor": "65",
    "Y": 12,
    "L": 41.6409965658785,
    "a": 44.0464191857466,
    "b": 21.5126219405071,
    "C": 49.0191793672813,
    "h": 0.45433104980533,
    "CMY_C": 0.3386436,
    "CMY_M": 0.7551735,
    "CMY_Y": 0.7460229,
    "CMYK_C": 0,
    "CMYK_M": 0.6298115,
    "CMYK_Y": 0.6159754,
    "CMYK_K": 0.3386436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03996",
    "Farbtonhilfsbezeichnung": "B4.51.32",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "52",
    "Bcolor": "68",
    "Y": 12,
    "L": 40.8499990242331,
    "a": 50.0833491161146,
    "b": 18.8168393287157,
    "C": 53.5015448469417,
    "h": 0.35939341466853,
    "CMY_C": 0.32174,
    "CMY_M": 0.7952064,
    "CMY_Y": 0.7345527,
    "CMYK_C": 0,
    "CMYK_M": 0.6980603,
    "CMYK_Y": 0.6086349,
    "CMYK_K": 0.32174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03997",
    "Farbtonhilfsbezeichnung": "B4.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "114",
    "Bcolor": "113",
    "Y": 18,
    "L": 49.0556656278143,
    "a": 5.20687778079965,
    "b": 1.4869802974548,
    "C": 5.41504262487414,
    "h": 0.27817552866293,
    "CMY_C": 0.5034244,
    "CMY_M": 0.554306,
    "CMY_Y": 0.5556818,
    "CMYK_C": 0,
    "CMYK_M": 0.1024649,
    "CMYK_Y": 0.1052356,
    "CMYK_K": 0.5034244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03998",
    "Farbtonhilfsbezeichnung": "B4.14.30",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "85",
    "Bcolor": "85",
    "Y": 11,
    "L": 39.2038933796012,
    "a": 13.2169806960988,
    "b": 4.34430798209207,
    "C": 13.9126413942255,
    "h": 0.31756701922541,
    "CMY_C": 0.5463211,
    "CMY_M": 0.6683698,
    "CMY_Y": 0.666449,
    "CMYK_C": 0,
    "CMYK_M": 0.2690199,
    "CMYK_Y": 0.2647861,
    "CMYK_K": 0.5463211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI03999",
    "Farbtonhilfsbezeichnung": "B4.22.28",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "75",
    "Bcolor": "75",
    "Y": 10,
    "L": 37.2452638479006,
    "a": 20.1134962890642,
    "b": 8.07227774894178,
    "C": 21.6728955385814,
    "h": 0.38165789593336,
    "CMY_C": 0.5218413,
    "CMY_M": 0.7058958,
    "CMY_Y": 0.7064929,
    "CMYK_C": 0,
    "CMYK_M": 0.3849233,
    "CMYK_Y": 0.3861721,
    "CMYK_K": 0.5218413
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04000",
    "Farbtonhilfsbezeichnung": "B5.30.31",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "73",
    "Bcolor": "75",
    "Y": 11,
    "L": 38.7564968618968,
    "a": 27.2369795332138,
    "b": 10.210867100161,
    "C": 29.0880535792593,
    "h": 0.35867409460899,
    "CMY_C": 0.4660297,
    "CMY_M": 0.7139607,
    "CMY_Y": 0.7048215,
    "CMYK_C": 0,
    "CMYK_M": 0.4643161,
    "CMYK_Y": 0.4472005,
    "CMYK_K": 0.4660297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04001",
    "Farbtonhilfsbezeichnung": "B5.32.26",
    "Farbtonklasse": "04",
    "Rcolor": "126",
    "Gcolor": "61",
    "Bcolor": "63",
    "Y": 8,
    "L": 34.2755197302373,
    "a": 28.5742000938283,
    "b": 11.3314828120269,
    "C": 30.7390210273749,
    "h": 0.37754031099745,
    "CMY_C": 0.5055469,
    "CMY_M": 0.7608715,
    "CMY_Y": 0.7514948,
    "CMYK_C": 0,
    "CMYK_M": 0.5163779,
    "CMYK_Y": 0.497414,
    "CMYK_K": 0.5055469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04002",
    "Farbtonhilfsbezeichnung": "B4.34.36",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "79",
    "Bcolor": "81",
    "Y": 14,
    "L": 44.0476323233943,
    "a": 34.5715672727444,
    "b": 14.3265085173356,
    "C": 37.4224813446567,
    "h": 0.39285946564844,
    "CMY_C": 0.3656811,
    "CMY_M": 0.6895805,
    "CMY_Y": 0.6809866,
    "CMYK_C": 0,
    "CMYK_M": 0.5106255,
    "CMYK_Y": 0.4970772,
    "CMYK_K": 0.3656811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04003",
    "Farbtonhilfsbezeichnung": "B7.43.31",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "75",
    "Bcolor": "76",
    "Y": 12,
    "L": 42.9286193847656,
    "a": 36.1182174682617,
    "b": 16.2620754241943,
    "C": 39.6103630065918,
    "h": 24.2394542694092,
    "CMY_C": 0.36804276704788,
    "CMY_M": 0.70679461956024,
    "CMY_Y": 0.7031557559967,
    "CMYK_C": 0,
    "CMYK_M": 0.53603601455688,
    "CMYK_Y": 0.530277967453,
    "CMYK_K": 0.36804276704788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04004",
    "Farbtonhilfsbezeichnung": "B6.51.30",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "63",
    "Bcolor": "72",
    "Y": 11,
    "L": 41.5329895019531,
    "a": 43.223316192627,
    "b": 16.9764213562012,
    "C": 46.4376335144043,
    "h": 21.4429512023926,
    "CMY_C": 0.34827375411987,
    "CMY_M": 0.75103557109833,
    "CMY_Y": 0.71865117549896,
    "CMYK_C": 0,
    "CMYK_M": 0.6179923415184,
    "CMYK_Y": 0.56830215454102,
    "CMYK_K": 0.34827375411987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04005",
    "Farbtonhilfsbezeichnung": "B4.04.31",
    "Farbtonklasse": "02",
    "Rcolor": "99",
    "Gcolor": "90",
    "Bcolor": "89",
    "Y": 11,
    "L": 38.9888257420608,
    "a": 3.80483776415721,
    "b": 1.48019068721519,
    "C": 4.08261618108725,
    "h": 0.3710126358401,
    "CMY_C": 0.6111476,
    "CMY_M": 0.6479793,
    "CMY_Y": 0.6517897,
    "CMYK_C": 0,
    "CMYK_M": 0.09471899,
    "CMYK_Y": 0.104518,
    "CMYK_K": 0.6111476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04006",
    "Farbtonhilfsbezeichnung": "B5.09.26",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "77",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.7390195250644,
    "a": 7.95099759511764,
    "b": 2.51439007938568,
    "C": 8.33909588797728,
    "h": 0.30628467209876,
    "CMY_C": 0.6242112,
    "CMY_M": 0.6968393,
    "CMY_Y": 0.6968414,
    "CMYK_C": 0,
    "CMYK_M": 0.1932685,
    "CMYK_Y": 0.1932739,
    "CMYK_K": 0.6242112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04007",
    "Farbtonhilfsbezeichnung": "B4.19.26",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "72",
    "Bcolor": "73",
    "Y": 8,
    "L": 34.8720833500609,
    "a": 16.9808183875024,
    "b": 5.81198995557647,
    "C": 17.947908523086,
    "h": 0.3297700446933,
    "CMY_C": 0.566279,
    "CMY_M": 0.7186393,
    "CMY_Y": 0.7145395,
    "CMYK_C": 0,
    "CMYK_M": 0.3512864,
    "CMYK_Y": 0.3418339,
    "CMYK_K": 0.566279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04008",
    "Farbtonhilfsbezeichnung": "B6.23.26",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "68",
    "Bcolor": "67",
    "Y": 8,
    "L": 34.0986065095703,
    "a": 19.109885546346,
    "b": 8.19622243746491,
    "C": 20.7934073167158,
    "h": 0.40516900915479,
    "CMY_C": 0.5590345,
    "CMY_M": 0.7321529,
    "CMY_Y": 0.7356734,
    "CMYK_C": 0,
    "CMYK_M": 0.3925894,
    "CMYK_Y": 0.4005732,
    "CMYK_K": 0.5590345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04009",
    "Farbtonhilfsbezeichnung": "B5.39.24",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "57",
    "Bcolor": "61",
    "Y": 8,
    "L": 34.1567450130124,
    "a": 32.0457734358903,
    "b": 12.9648967223386,
    "C": 34.5690633677761,
    "h": 0.38444351842154,
    "CMY_C": 0.4881648,
    "CMY_M": 0.7750801,
    "CMY_Y": 0.7617615,
    "CMYK_C": 0,
    "CMYK_M": 0.5605619,
    "CMYK_Y": 0.5345407,
    "CMYK_K": 0.4881648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04010",
    "Farbtonhilfsbezeichnung": "B4.40.31",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "65",
    "Bcolor": "70",
    "Y": 11,
    "L": 39.2700443271437,
    "a": 36.9719331544129,
    "b": 14.8740321685959,
    "C": 39.8517336401668,
    "h": 0.38249276396457,
    "CMY_C": 0.4062857,
    "CMY_M": 0.7457672,
    "CMY_Y": 0.7272236,
    "CMYK_C": 0,
    "CMYK_M": 0.5717927,
    "CMYK_Y": 0.5405595,
    "CMYK_K": 0.4062857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04011",
    "Farbtonhilfsbezeichnung": "B5.43.26",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "55",
    "Bcolor": "62",
    "Y": 10,
    "L": 35.2984725907129,
    "a": 36.5498946130471,
    "b": 14.0775753359581,
    "C": 39.1672429916177,
    "h": 0.36764860732943,
    "CMY_C": 0.4531313,
    "CMY_M": 0.7826312,
    "CMY_Y": 0.757574,
    "CMYK_C": 0,
    "CMYK_M": 0.602521,
    "CMYK_Y": 0.5567015,
    "CMYK_K": 0.4531313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04012",
    "Farbtonhilfsbezeichnung": "B5.48.30",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "56",
    "Bcolor": "64",
    "Y": 11,
    "L": 39.4863051377496,
    "a": 44.6858899807444,
    "b": 18.8918128767795,
    "C": 48.5152487074161,
    "h": 0.39997952697117,
    "CMY_C": 0.3628541,
    "CMY_M": 0.7799448,
    "CMY_Y": 0.7484634,
    "CMYK_C": 0,
    "CMYK_M": 0.6546235,
    "CMYK_Y": 0.6052135,
    "CMYK_K": 0.3628541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04013",
    "Farbtonhilfsbezeichnung": "B7.08.21",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "69",
    "Bcolor": "69",
    "Y": 7,
    "L": 30.7464648656045,
    "a": 6.04587363563991,
    "b": 2.0297942023362,
    "C": 6.37751146780336,
    "h": 0.32390794063734,
    "CMY_C": 0.6741723,
    "CMY_M": 0.7288487,
    "CMY_Y": 0.7301564,
    "CMYK_C": 0,
    "CMYK_M": 0.1678077,
    "CMYK_Y": 0.1718211,
    "CMYK_K": 0.6741723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04014",
    "Farbtonhilfsbezeichnung": "B7.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "63",
    "Bcolor": "61",
    "Y": 6,
    "L": 30.0301651211917,
    "a": 13.3940464856686,
    "b": 5.99047837457744,
    "C": 14.6726382227782,
    "h": 0.420564117238,
    "CMY_C": 0.6327367,
    "CMY_M": 0.7532922,
    "CMY_Y": 0.7592066,
    "CMYK_C": 0,
    "CMYK_M": 0.3282534,
    "CMYK_Y": 0.3443574,
    "CMYK_K": 0.6327367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04015",
    "Farbtonhilfsbezeichnung": "B4.27.17",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "50",
    "Bcolor": "51",
    "Y": 5,
    "L": 26.4810009697511,
    "a": 19.7144752135498,
    "b": 7.67448049798263,
    "C": 21.1555709887393,
    "h": 0.37123227909522,
    "CMY_C": 0.633282,
    "CMY_M": 0.8023677,
    "CMY_Y": 0.7988271,
    "CMYK_C": 0,
    "CMYK_M": 0.4610785,
    "CMYK_Y": 0.4514235,
    "CMYK_K": 0.633282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04016",
    "Farbtonhilfsbezeichnung": "B4.29.18",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "55",
    "Bcolor": "57",
    "Y": 6,
    "L": 28.8940365453388,
    "a": 20.6753130605058,
    "b": 7.09644015173492,
    "C": 21.8592779610187,
    "h": 0.33063322382686,
    "CMY_C": 0.6053399,
    "CMY_M": 0.7835867,
    "CMY_Y": 0.7745453,
    "CMYK_C": 0,
    "CMYK_M": 0.4516462,
    "CMYK_Y": 0.428737,
    "CMYK_K": 0.6053399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04017",
    "Farbtonhilfsbezeichnung": "B5.36.22",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "53",
    "Bcolor": "56",
    "Y": 7,
    "L": 30.9753449786025,
    "a": 28.9602963495454,
    "b": 11.3722026529007,
    "C": 31.1131123134947,
    "h": 0.3741823465569,
    "CMY_C": 0.5385764,
    "CMY_M": 0.7929987,
    "CMY_Y": 0.7804376,
    "CMYK_C": 0,
    "CMYK_M": 0.5513855,
    "CMYK_Y": 0.5241631,
    "CMYK_K": 0.5385764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04018",
    "Farbtonhilfsbezeichnung": "B7.53.22",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "59",
    "Bcolor": "63",
    "Y": 7,
    "L": 36.3418464660645,
    "a": 35.1941032409668,
    "b": 14.8423614501953,
    "C": 38.1958198547363,
    "h": 22.8665466308594,
    "CMY_C": 0.44725811481476,
    "CMY_M": 0.76696741580963,
    "CMY_Y": 0.75338262319565,
    "CMYK_C": 0,
    "CMYK_M": 0.57840615510941,
    "CMYK_Y": 0.5538290143013,
    "CMYK_K": 0.44725811481476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04019",
    "Farbtonhilfsbezeichnung": "B6.07.14",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "54",
    "Bcolor": "53",
    "Y": 4,
    "L": 23.6405172639361,
    "a": 4.23562906146127,
    "b": 1.98681427492063,
    "C": 4.67845962997691,
    "h": 0.43860038141419,
    "CMY_C": 0.749519,
    "CMY_M": 0.7878258,
    "CMY_Y": 0.7922976,
    "CMYK_C": 0,
    "CMYK_M": 0.1529329,
    "CMYK_Y": 0.1707859,
    "CMYK_K": 0.749519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04020",
    "Farbtonhilfsbezeichnung": "B7.15.13",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "47",
    "Bcolor": "46",
    "Y": 3,
    "L": 21.885145824298,
    "a": 9.08058899223266,
    "b": 4.55017813186778,
    "C": 10.1568310745815,
    "h": 0.46451797827378,
    "CMY_C": 0.7344157,
    "CMY_M": 0.813866,
    "CMY_Y": 0.8212216,
    "CMYK_C": 0,
    "CMYK_M": 0.299153,
    "CMYK_Y": 0.326849,
    "CMYK_K": 0.7344157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04021",
    "Farbtonhilfsbezeichnung": "B4.21.13",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "49",
    "Bcolor": "47",
    "Y": 4,
    "L": 24.2197344775893,
    "a": 15.0204473274284,
    "b": 6.83670985193081,
    "C": 16.503164530342,
    "h": 0.42713685827763,
    "CMY_C": 0.6792977,
    "CMY_M": 0.8088683,
    "CMY_Y": 0.813868,
    "CMYK_C": 0,
    "CMYK_M": 0.4040213,
    "CMYK_Y": 0.4196111,
    "CMYK_K": 0.6792977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04022",
    "Farbtonhilfsbezeichnung": "B4.28.12",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "47",
    "Bcolor": "50",
    "Y": 4,
    "L": 24.6514454286423,
    "a": 18.5396504944508,
    "b": 5.89116733965712,
    "C": 19.4531358161155,
    "h": 0.30767008681578,
    "CMY_C": 0.6594451,
    "CMY_M": 0.8146062,
    "CMY_Y": 0.8042229,
    "CMYK_C": 0,
    "CMYK_M": 0.4556127,
    "CMYK_Y": 0.4251231,
    "CMYK_K": 0.6594451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04023",
    "Farbtonhilfsbezeichnung": "B4.38.17",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "45",
    "Bcolor": "48",
    "Y": 5,
    "L": 26.5186286886291,
    "a": 26.0106957874524,
    "b": 10.138964924299,
    "C": 27.9169286470334,
    "h": 0.37168232275559,
    "CMY_C": 0.6001823,
    "CMY_M": 0.8229376,
    "CMY_Y": 0.8117434,
    "CMYK_C": 0,
    "CMYK_M": 0.5571421,
    "CMYK_Y": 0.529144,
    "CMYK_K": 0.6001823
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04024",
    "Farbtonhilfsbezeichnung": "B5.39.18",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "49",
    "Bcolor": "54",
    "Y": 6,
    "L": 29.4465508198661,
    "a": 29.3532283179856,
    "b": 10.7840951620196,
    "C": 31.2715321203053,
    "h": 0.35208263358519,
    "CMY_C": 0.5535126,
    "CMY_M": 0.8084888,
    "CMY_Y": 0.7900118,
    "CMYK_C": 0,
    "CMYK_M": 0.5710714,
    "CMYK_Y": 0.5296883,
    "CMYK_K": 0.5535126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04025",
    "Farbtonhilfsbezeichnung": "B5.42.18",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "43",
    "Bcolor": "47",
    "Y": 5,
    "L": 26.7230323641227,
    "a": 29.2393059728896,
    "b": 10.9133655993101,
    "C": 31.2095908733271,
    "h": 0.35722937721148,
    "CMY_C": 0.5824335,
    "CMY_M": 0.8332837,
    "CMY_Y": 0.8138974,
    "CMYK_C": 0,
    "CMYK_M": 0.6007432,
    "CMYK_Y": 0.5543161,
    "CMYK_K": 0.5824335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04026",
    "Farbtonhilfsbezeichnung": "B7.49.18",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "44",
    "Bcolor": "49",
    "Y": 6,
    "L": 30.0724511465418,
    "a": 34.993186922404,
    "b": 15.130940045991,
    "C": 38.1243816692374,
    "h": 0.4081190362348,
    "CMY_C": 0.5164272,
    "CMY_M": 0.826913,
    "CMY_Y": 0.8092318,
    "CMYK_C": 0,
    "CMYK_M": 0.6420663,
    "CMYK_Y": 0.6055025,
    "CMYK_K": 0.5164272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04027",
    "Farbtonhilfsbezeichnung": "B8.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "227",
    "Bcolor": "224",
    "Y": 79,
    "L": 91.3455226321275,
    "a": 4.91245992564732,
    "b": 2.21267029506478,
    "C": 5.38777990973582,
    "h": 0.42320315971756,
    "CMY_C": 0.05187895,
    "CMY_M": 0.1093384,
    "CMY_Y": 0.1199588,
    "CMYK_C": 0,
    "CMYK_M": 0.0606035,
    "CMYK_Y": 0.07180505,
    "CMYK_K": 0.05187895
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04028",
    "Farbtonhilfsbezeichnung": "B8.07.78",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "207",
    "Bcolor": "202",
    "Y": 67,
    "L": 85.6926708545482,
    "a": 11.2455700932346,
    "b": 5.90821151774112,
    "C": 12.7031417397517,
    "h": 0.4837458169833,
    "CMY_C": 0.05826225,
    "CMY_M": 0.1887789,
    "CMY_Y": 0.2079551,
    "CMYK_C": 0,
    "CMYK_M": 0.1385912,
    "CMYK_Y": 0.1589538,
    "CMYK_K": 0.05826225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04029",
    "Farbtonhilfsbezeichnung": "B9.15.73",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "184",
    "Bcolor": "176",
    "Y": 57,
    "L": 80.3858203136513,
    "a": 22.2066939359344,
    "b": 12.2458487728707,
    "C": 25.3593782994041,
    "h": 0.50395464738853,
    "CMY_C": 0.02923853,
    "CMY_M": 0.2778192,
    "CMY_Y": 0.3088063,
    "CMYK_C": 0,
    "CMYK_M": 0.2560678,
    "CMYK_Y": 0.2879881,
    "CMYK_K": 0.02923853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04030",
    "Farbtonhilfsbezeichnung": "B8.21.68",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "166",
    "Bcolor": "158",
    "Y": 49,
    "L": 75.7117782114557,
    "a": 28.952536023044,
    "b": 15.6230037542005,
    "C": 32.8987475212875,
    "h": 0.49482927805437,
    "CMY_C": 0.03425899,
    "CMY_M": 0.3486345,
    "CMY_Y": 0.3805686,
    "CMYK_C": 0,
    "CMYK_M": 0.3255278,
    "CMYK_Y": 0.3585947,
    "CMYK_K": 0.03425899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04031",
    "Farbtonhilfsbezeichnung": "B9.24.65",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "152",
    "Bcolor": "143",
    "Y": 43,
    "L": 71.3491604875085,
    "a": 31.2966531962747,
    "b": 17.7985128852128,
    "C": 36.0037159500652,
    "h": 0.51708933792279,
    "CMY_C": 0.067174,
    "CMY_M": 0.4026326,
    "CMY_Y": 0.440206,
    "CMYK_C": 0,
    "CMYK_M": 0.3596154,
    "CMYK_Y": 0.3998945,
    "CMYK_K": 0.067174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04032",
    "Farbtonhilfsbezeichnung": "B9.27.62",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "145",
    "Bcolor": "137",
    "Y": 41,
    "L": 70.0371921669347,
    "a": 35.9637043620209,
    "b": 19.2778186854488,
    "C": 40.8046850828172,
    "h": 0.49205865136228,
    "CMY_C": 0.05289948,
    "CMY_M": 0.4319943,
    "CMY_Y": 0.4629063,
    "CMYK_C": 0,
    "CMYK_M": 0.4002688,
    "CMYK_Y": 0.4329074,
    "CMYK_K": 0.05289948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04033",
    "Farbtonhilfsbezeichnung": "B8.31.60",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "137",
    "Bcolor": "131",
    "Y": 38,
    "L": 67.7129069451083,
    "a": 37.886302303878,
    "b": 19.5955319066522,
    "C": 42.6539186120742,
    "h": 0.47732807040582,
    "CMY_C": 0.06885432,
    "CMY_M": 0.4630018,
    "CMY_Y": 0.48805,
    "CMYK_C": 0,
    "CMYK_M": 0.423293,
    "CMYK_Y": 0.4501934,
    "CMYK_K": 0.06885432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04034",
    "Farbtonhilfsbezeichnung": "B9.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "217",
    "Bcolor": "211",
    "Y": 74,
    "L": 89.102972352265,
    "a": 9.7670427535192,
    "b": 5.88648848597471,
    "C": 11.4037656431805,
    "h": 0.54239430487364,
    "CMY_C": 0.03026526,
    "CMY_M": 0.1474607,
    "CMY_Y": 0.170967,
    "CMYK_C": 0,
    "CMYK_M": 0.1208531,
    "CMYK_Y": 0.145093,
    "CMYK_K": 0.03026526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04035",
    "Farbtonhilfsbezeichnung": "B9.12.72",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "186",
    "Bcolor": "179",
    "Y": 57,
    "L": 79.9694183454268,
    "a": 17.540738843811,
    "b": 9.78772077184667,
    "C": 20.0867368453519,
    "h": 0.50896399027143,
    "CMY_C": 0.07010575,
    "CMY_M": 0.2686552,
    "CMY_Y": 0.296316,
    "CMYK_C": 0,
    "CMYK_M": 0.2135182,
    "CMYK_Y": 0.2432645,
    "CMYK_K": 0.07010575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04036",
    "Farbtonhilfsbezeichnung": "B9.16.66",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "168",
    "Bcolor": "160",
    "Y": 47,
    "L": 74.0979013135495,
    "a": 21.2053033159527,
    "b": 11.8400562307591,
    "C": 24.2868651799505,
    "h": 0.50923404901505,
    "CMY_C": 0.1085205,
    "CMY_M": 0.342029,
    "CMY_Y": 0.3718554,
    "CMYK_C": 0,
    "CMYK_M": 0.2619337,
    "CMYK_Y": 0.2953908,
    "CMYK_K": 0.1085205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04037",
    "Farbtonhilfsbezeichnung": "B8.28.61",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "141",
    "Bcolor": "133",
    "Y": 39,
    "L": 68.4700818457602,
    "a": 35.2760172794664,
    "b": 19.002815790903,
    "C": 40.0687459634589,
    "h": 0.49411797967507,
    "CMY_C": 0.07573073,
    "CMY_M": 0.4460568,
    "CMY_Y": 0.4768928,
    "CMYK_C": 0,
    "CMYK_M": 0.400669,
    "CMYK_Y": 0.4340315,
    "CMYK_K": 0.07573073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04038",
    "Farbtonhilfsbezeichnung": "B8.35.55",
    "Farbtonklasse": "04",
    "Rcolor": "232",
    "Gcolor": "119",
    "Bcolor": "113",
    "Y": 32,
    "L": 63.0503304979502,
    "a": 43.4867210797067,
    "b": 22.9517337213931,
    "C": 49.1719126237931,
    "h": 0.48562944412665,
    "CMY_C": 0.08852968,
    "CMY_M": 0.5329185,
    "CMY_Y": 0.5559836,
    "CMYK_C": 0,
    "CMYK_M": 0.4875516,
    "CMYK_Y": 0.512857,
    "CMYK_K": 0.08852968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04039",
    "Farbtonhilfsbezeichnung": "B7.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "192",
    "Y": 58,
    "L": 80.7874578881522,
    "a": 7.99824758979589,
    "b": 3.9314274865166,
    "C": 8.91224363386763,
    "h": 0.45685359761049,
    "CMY_C": 0.1418794,
    "CMY_M": 0.2334088,
    "CMY_Y": 0.2469213,
    "CMYK_C": 0,
    "CMYK_M": 0.1066626,
    "CMYK_Y": 0.1224092,
    "CMYK_K": 0.1418794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04040",
    "Farbtonhilfsbezeichnung": "B9.09.72",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "191",
    "Bcolor": "185",
    "Y": 57,
    "L": 80.2893345560944,
    "a": 12.8387505559949,
    "b": 7.02929667326331,
    "C": 14.6370942321149,
    "h": 0.50092663777543,
    "CMY_C": 0.1050347,
    "CMY_M": 0.2519547,
    "CMY_Y": 0.273829,
    "CMYK_C": 0,
    "CMYK_M": 0.1641628,
    "CMYK_Y": 0.1886043,
    "CMYK_K": 0.1050347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04041",
    "Farbtonhilfsbezeichnung": "B8.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "182",
    "Bcolor": "176",
    "Y": 52,
    "L": 77.2921749106475,
    "a": 14.0731470203536,
    "b": 7.77294415063166,
    "C": 16.0770683840471,
    "h": 0.50462611805565,
    "CMY_C": 0.1283553,
    "CMY_M": 0.2875869,
    "CMY_Y": 0.3107218,
    "CMYK_C": 0,
    "CMYK_M": 0.1826795,
    "CMYK_Y": 0.2092211,
    "CMYK_K": 0.1283553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04042",
    "Farbtonhilfsbezeichnung": "B9.14.62",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "159",
    "Bcolor": "152",
    "Y": 40,
    "L": 69.7093434503432,
    "a": 17.4985802649054,
    "b": 9.90118295533227,
    "C": 20.1055647819776,
    "h": 0.51491379894198,
    "CMY_C": 0.1855716,
    "CMY_M": 0.3774953,
    "CMY_Y": 0.4041206,
    "CMYK_C": 0,
    "CMYK_M": 0.2356544,
    "CMYK_Y": 0.2683464,
    "CMYK_K": 0.1855716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04043",
    "Farbtonhilfsbezeichnung": "B8.28.57",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "131",
    "Bcolor": "124",
    "Y": 34,
    "L": 64.9988750980997,
    "a": 36.4876973901888,
    "b": 19.3688630095098,
    "C": 41.3098646223774,
    "h": 0.48800844714679,
    "CMY_C": 0.1090026,
    "CMY_M": 0.4864147,
    "CMY_Y": 0.5137814,
    "CMYK_C": 0,
    "CMYK_M": 0.4235838,
    "CMYK_Y": 0.4542985,
    "CMYK_K": 0.1090026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04044",
    "Farbtonhilfsbezeichnung": "B8.35.52",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "112",
    "Bcolor": "107",
    "Y": 27,
    "L": 59.2306557947319,
    "a": 40.4435945797585,
    "b": 20.9421427532223,
    "C": 45.5440192081048,
    "h": 0.47779475878724,
    "CMY_C": 0.1527451,
    "CMY_M": 0.5604969,
    "CMY_Y": 0.5800642,
    "CMYK_C": 0,
    "CMYK_M": 0.4812622,
    "CMYK_Y": 0.5043572,
    "CMYK_K": 0.1527451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04046",
    "Farbtonhilfsbezeichnung": "B8.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "194",
    "Bcolor": "191",
    "Y": 56,
    "L": 79.7904437212885,
    "a": 5.98887348246008,
    "b": 3.11592889643875,
    "C": 6.75097166906924,
    "h": 0.47974463701323,
    "CMY_C": 0.1697739,
    "CMY_M": 0.2390214,
    "CMY_Y": 0.2520171,
    "CMYK_C": 0,
    "CMYK_M": 0.08340801,
    "CMYK_Y": 0.0990612,
    "CMYK_K": 0.1697739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04047",
    "Farbtonhilfsbezeichnung": "B8.06.62",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "165",
    "Bcolor": "162",
    "Y": 40,
    "L": 69.7187907052452,
    "a": 8.46986161141977,
    "b": 4.19026994657266,
    "C": 9.44970464838729,
    "h": 0.45942038632659,
    "CMY_C": 0.2589648,
    "CMY_M": 0.3526857,
    "CMY_Y": 0.3654921,
    "CMYK_C": 0,
    "CMYK_M": 0.126473,
    "CMYK_Y": 0.1437547,
    "CMYK_K": 0.2589648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04048",
    "Farbtonhilfsbezeichnung": "B8.10.65",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "167",
    "Bcolor": "163",
    "Y": 43,
    "L": 71.8082537303403,
    "a": 13.5881117006783,
    "b": 6.97319464770996,
    "C": 15.2729245131691,
    "h": 0.47413869408393,
    "CMY_C": 0.1945043,
    "CMY_M": 0.3443483,
    "CMY_Y": 0.362538,
    "CMYK_C": 0,
    "CMYK_M": 0.1860271,
    "CMYK_Y": 0.2086091,
    "CMYK_K": 0.1945043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04049",
    "Farbtonhilfsbezeichnung": "B9.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "147",
    "Bcolor": "140",
    "Y": 37,
    "L": 67.2274945381359,
    "a": 25.0383988394617,
    "b": 13.2963096889119,
    "C": 28.3498371739135,
    "h": 0.48816761612513,
    "CMY_C": 0.1599313,
    "CMY_M": 0.4254611,
    "CMY_Y": 0.4517488,
    "CMYK_C": 0,
    "CMYK_M": 0.3160811,
    "CMYK_Y": 0.3473734,
    "CMYK_K": 0.1599313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04050",
    "Farbtonhilfsbezeichnung": "B9.25.54",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "127",
    "Bcolor": "120",
    "Y": 29,
    "L": 61.121403913973,
    "a": 28.8940494816782,
    "b": 15.611951467486,
    "C": 32.8420328858127,
    "h": 0.49537880584383,
    "CMY_C": 0.2025291,
    "CMY_M": 0.5005472,
    "CMY_Y": 0.5278919,
    "CMYK_C": 0,
    "CMYK_M": 0.373704,
    "CMYK_Y": 0.4079933,
    "CMYK_K": 0.2025291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04051",
    "Farbtonhilfsbezeichnung": "B9.29.52",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "121",
    "Bcolor": "114",
    "Y": 28,
    "L": 60.1857591477063,
    "a": 33.0962604731357,
    "b": 18.1279925162775,
    "C": 37.7357465803429,
    "h": 0.50110286991657,
    "CMY_C": 0.1856505,
    "CMY_M": 0.5242169,
    "CMY_Y": 0.5533216,
    "CMYK_C": 0,
    "CMYK_M": 0.4157507,
    "CMYK_Y": 0.4514905,
    "CMYK_K": 0.1856505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04052",
    "Farbtonhilfsbezeichnung": "B9.43.50",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "97",
    "Bcolor": "92",
    "Y": 25,
    "L": 57.0792046475539,
    "a": 49.4231786019158,
    "b": 26.7771395184805,
    "C": 56.2109044928921,
    "h": 0.49652053781309,
    "CMY_C": 0.1244769,
    "CMY_M": 0.6208372,
    "CMY_Y": 0.6377547,
    "CMYK_C": 0,
    "CMYK_M": 0.5669299,
    "CMYK_Y": 0.5862528,
    "CMYK_K": 0.1244769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04053",
    "Farbtonhilfsbezeichnung": "B8.05.60",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "161",
    "Bcolor": "160",
    "Y": 38,
    "L": 67.8479650839512,
    "a": 6.81055462317237,
    "b": 2.58301593383463,
    "C": 7.28392926857875,
    "h": 0.36250599894116,
    "CMY_C": 0.2949491,
    "CMY_M": 0.3678258,
    "CMY_Y": 0.3739176,
    "CMYK_C": 0,
    "CMYK_M": 0.1033637,
    "CMYK_Y": 0.112004,
    "CMYK_K": 0.2949491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04054",
    "Farbtonhilfsbezeichnung": "B9.10.61",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "160",
    "Bcolor": "156",
    "Y": 39,
    "L": 69.0522789395869,
    "a": 12.9369222124064,
    "b": 6.78832148527468,
    "C": 14.6097660801703,
    "h": 0.48323109214897,
    "CMY_C": 0.2295263,
    "CMY_M": 0.371551,
    "CMY_Y": 0.3898694,
    "CMYK_C": 0,
    "CMYK_M": 0.1843343,
    "CMYK_Y": 0.2081098,
    "CMYK_K": 0.2295263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04055",
    "Farbtonhilfsbezeichnung": "B9.17.58",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "145",
    "Bcolor": "139",
    "Y": 35,
    "L": 65.5677066109116,
    "a": 20.8068141841802,
    "b": 11.453122569839,
    "C": 23.7507375273855,
    "h": 0.5031890663561,
    "CMY_C": 0.2077996,
    "CMY_M": 0.4300309,
    "CMY_Y": 0.4565155,
    "CMYK_C": 0,
    "CMYK_M": 0.2805241,
    "CMYK_Y": 0.3139558,
    "CMYK_K": 0.2077996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04056",
    "Farbtonhilfsbezeichnung": "B8.23.53",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "130",
    "Bcolor": "124",
    "Y": 30,
    "L": 61.3041284345975,
    "a": 26.3970659982922,
    "b": 13.6072011087089,
    "C": 29.6978284615398,
    "h": 0.47595602068211,
    "CMY_C": 0.218213,
    "CMY_M": 0.4905355,
    "CMY_Y": 0.5129192,
    "CMYK_C": 0,
    "CMYK_M": 0.3483334,
    "CMYK_Y": 0.3769649,
    "CMYK_K": 0.218213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04057",
    "Farbtonhilfsbezeichnung": "B9.30.48",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "112",
    "Bcolor": "105",
    "Y": 24,
    "L": 56.5159629253716,
    "a": 33.2633129500943,
    "b": 17.8349288891592,
    "C": 37.742981823079,
    "h": 0.49216643331393,
    "CMY_C": 0.2272138,
    "CMY_M": 0.5619673,
    "CMY_Y": 0.58687,
    "CMYK_C": 0,
    "CMYK_M": 0.4331773,
    "CMYK_Y": 0.4654019,
    "CMYK_K": 0.2272138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04058",
    "Farbtonhilfsbezeichnung": "B9.40.43",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "93",
    "Bcolor": "89",
    "Y": 20,
    "L": 51.3664920330522,
    "a": 39.4921259682887,
    "b": 20.5344085356251,
    "C": 44.5116832685884,
    "h": 0.47948945409474,
    "CMY_C": 0.2498991,
    "CMY_M": 0.636925,
    "CMY_Y": 0.6522671,
    "CMYK_C": 0,
    "CMYK_M": 0.5159652,
    "CMYK_Y": 0.5364185,
    "CMYK_K": 0.2498991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04059",
    "Farbtonhilfsbezeichnung": "B9.45.45",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "90",
    "Bcolor": "86",
    "Y": 22,
    "L": 53.7012876118742,
    "a": 47.0559367028778,
    "b": 25.8275395998587,
    "C": 53.6779561902976,
    "h": 0.5019743791948,
    "CMY_C": 0.1780525,
    "CMY_M": 0.6454821,
    "CMY_Y": 0.6636651,
    "CMYK_C": 0,
    "CMYK_M": 0.5686855,
    "CMYK_Y": 0.5908073,
    "CMYK_K": 0.1780525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04060",
    "Farbtonhilfsbezeichnung": "B6.05.51",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "140",
    "Bcolor": "138",
    "Y": 28,
    "L": 59.5303098291118,
    "a": 5.29005475188887,
    "b": 2.44944644086016,
    "C": 5.82961981132771,
    "h": 0.43363550256483,
    "CMY_C": 0.3934011,
    "CMY_M": 0.4500204,
    "CMY_Y": 0.4582427,
    "CMYK_C": 0,
    "CMYK_M": 0.09333899,
    "CMYK_Y": 0.1068936,
    "CMYK_K": 0.3934011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04062",
    "Farbtonhilfsbezeichnung": "B9.08.55",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "146",
    "Bcolor": "142",
    "Y": 31,
    "L": 62.6686698555881,
    "a": 9.47670469995893,
    "b": 4.69233926342409,
    "C": 10.5747803633596,
    "h": 0.45975575893525,
    "CMY_C": 0.326396,
    "CMY_M": 0.4284749,
    "CMY_Y": 0.4411865,
    "CMYK_C": 0,
    "CMYK_M": 0.1515414,
    "CMYK_Y": 0.1704124,
    "CMYK_K": 0.326396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04063",
    "Farbtonhilfsbezeichnung": "B8.14.52",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "135",
    "Bcolor": "130",
    "Y": 29,
    "L": 60.4842272033011,
    "a": 16.3219682372765,
    "b": 8.77525769073733,
    "C": 18.5313732539579,
    "h": 0.49330021499843,
    "CMY_C": 0.2966925,
    "CMY_M": 0.4692325,
    "CMY_Y": 0.489957,
    "CMYK_C": 0,
    "CMYK_M": 0.2453266,
    "CMYK_Y": 0.2747938,
    "CMYK_K": 0.2966925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04064",
    "Farbtonhilfsbezeichnung": "B8.18.49",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "123",
    "Bcolor": "118",
    "Y": 25,
    "L": 57.0621224673929,
    "a": 20.790473605043,
    "b": 10.8420855774293,
    "C": 23.4476995116854,
    "h": 0.48069376103874,
    "CMY_C": 0.3029177,
    "CMY_M": 0.5164937,
    "CMY_Y": 0.5370327,
    "CMYK_C": 0,
    "CMYK_M": 0.3063856,
    "CMYK_Y": 0.3358499,
    "CMYK_K": 0.3029177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04065",
    "Farbtonhilfsbezeichnung": "B8.39.41",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "87",
    "Bcolor": "83",
    "Y": 18,
    "L": 49.7152713971416,
    "a": 40.4942142088415,
    "b": 21.3658888352907,
    "C": 45.7851787166277,
    "h": 0.48550508584183,
    "CMY_C": 0.262927,
    "CMY_M": 0.6577207,
    "CMY_Y": 0.6728373,
    "CMYK_C": 0,
    "CMYK_M": 0.5356236,
    "CMYK_Y": 0.5561326,
    "CMYK_K": 0.262927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04066",
    "Farbtonhilfsbezeichnung": "B9.49.43",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "78",
    "Bcolor": "75",
    "Y": 19,
    "L": 50.6253120026051,
    "a": 50.5934775347852,
    "b": 28.0291071455569,
    "C": 57.838834846839,
    "h": 0.50591388872293,
    "CMY_C": 0.1951161,
    "CMY_M": 0.6948913,
    "CMY_Y": 0.7056335,
    "CMYK_C": 0,
    "CMYK_M": 0.6209283,
    "CMYK_Y": 0.6342745,
    "CMYK_K": 0.1951161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04067",
    "Farbtonhilfsbezeichnung": "B8.09.50",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "131",
    "Bcolor": "128",
    "Y": 25,
    "L": 57.4254788736025,
    "a": 10.6726310734505,
    "b": 5.43912775406847,
    "C": 11.9786962877877,
    "h": 0.47132448332872,
    "CMY_C": 0.3722326,
    "CMY_M": 0.4849395,
    "CMY_Y": 0.4987528,
    "CMYK_C": 0,
    "CMYK_M": 0.179536,
    "CMYK_Y": 0.2015399,
    "CMYK_K": 0.3722326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04068",
    "Farbtonhilfsbezeichnung": "B9.16.42",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "110",
    "Bcolor": "105",
    "Y": 19,
    "L": 50.4631575746149,
    "a": 15.9556481921575,
    "b": 8.59574512327572,
    "C": 18.123728740417,
    "h": 0.49414746221916,
    "CMY_C": 0.4063771,
    "CMY_M": 0.568363,
    "CMY_Y": 0.5870122,
    "CMYK_C": 0,
    "CMYK_M": 0.2728767,
    "CMYK_Y": 0.3042926,
    "CMYK_K": 0.4063771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04069",
    "Farbtonhilfsbezeichnung": "B9.24.42",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "104",
    "Bcolor": "98",
    "Y": 19,
    "L": 50.6512787064423,
    "a": 25.3239589003599,
    "b": 13.5984381687349,
    "C": 28.7440500802518,
    "h": 0.49279147428925,
    "CMY_C": 0.3425476,
    "CMY_M": 0.594072,
    "CMY_Y": 0.6164,
    "CMYK_C": 0,
    "CMYK_M": 0.3825743,
    "CMYK_Y": 0.4165357,
    "CMYK_K": 0.3425476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04070",
    "Farbtonhilfsbezeichnung": "B9.26.44",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "104",
    "Bcolor": "99",
    "Y": 20,
    "L": 51.7173002382887,
    "a": 27.6346712181212,
    "b": 14.4309336213216,
    "C": 31.1757421486105,
    "h": 0.48125254987154,
    "CMY_C": 0.3168744,
    "CMY_M": 0.590853,
    "CMY_Y": 0.6113022,
    "CMYK_C": 0,
    "CMYK_M": 0.4010662,
    "CMYK_Y": 0.431001,
    "CMYK_K": 0.3168744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04071",
    "Farbtonhilfsbezeichnung": "B8.33.40",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "89",
    "Bcolor": "84",
    "Y": 16,
    "L": 47.5131321846017,
    "a": 32.7175115940258,
    "b": 17.464135682644,
    "C": 37.0868116727093,
    "h": 0.49030935006271,
    "CMY_C": 0.3324768,
    "CMY_M": 0.649742,
    "CMY_Y": 0.6695617,
    "CMYK_C": 0,
    "CMYK_M": 0.4752872,
    "CMYK_Y": 0.5049786,
    "CMYK_K": 0.3324768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04072",
    "Farbtonhilfsbezeichnung": "B9.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "182",
    "Gcolor": "84",
    "Bcolor": "80",
    "Y": 17,
    "L": 48.1239647312637,
    "a": 39.391786514486,
    "b": 21.3862872958909,
    "C": 44.8228304450447,
    "h": 0.49738535464614,
    "CMY_C": 0.286852,
    "CMY_M": 0.6693563,
    "CMY_Y": 0.6879018,
    "CMYK_C": 0,
    "CMYK_M": 0.5363603,
    "CMYK_Y": 0.5623655,
    "CMYK_K": 0.286852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04073",
    "Farbtonhilfsbezeichnung": "B9.51.40",
    "Farbtonklasse": "04",
    "Rcolor": "199",
    "Gcolor": "69",
    "Bcolor": "67",
    "Y": 17,
    "L": 47.9313376547507,
    "a": 51.9022210261941,
    "b": 29.1070722705824,
    "C": 59.5068248490609,
    "h": 0.5111016232768,
    "CMY_C": 0.2202331,
    "CMY_M": 0.7308918,
    "CMY_Y": 0.7367001,
    "CMYK_C": 0,
    "CMYK_M": 0.6548863,
    "CMYK_Y": 0.6623351,
    "CMYK_K": 0.2202331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04074",
    "Farbtonhilfsbezeichnung": "B9.08.42",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "116",
    "Bcolor": "113",
    "Y": 19,
    "L": 50.7704478934822,
    "a": 8.6821903616538,
    "b": 4.1654184663479,
    "C": 9.62970095463957,
    "h": 0.44732965639487,
    "CMY_C": 0.4569491,
    "CMY_M": 0.5461434,
    "CMY_Y": 0.5560601,
    "CMYK_C": 0,
    "CMYK_M": 0.1642466,
    "CMYK_Y": 0.1825078,
    "CMYK_K": 0.4569491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04075",
    "Farbtonhilfsbezeichnung": "B8.14.38",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "99",
    "Bcolor": "95",
    "Y": 15,
    "L": 45.448583009371,
    "a": 14.5748152673942,
    "b": 7.4540174077575,
    "C": 16.3703272903696,
    "h": 0.47275080942912,
    "CMY_C": 0.4689336,
    "CMY_M": 0.6132445,
    "CMY_Y": 0.6275821,
    "CMYK_C": 0,
    "CMYK_M": 0.2717379,
    "CMYK_Y": 0.2987358,
    "CMYK_K": 0.4689336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04076",
    "Farbtonhilfsbezeichnung": "B9.28.37",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "87",
    "Bcolor": "81",
    "Y": 14,
    "L": 44.2009203970139,
    "a": 26.090981135249,
    "b": 14.5577114699026,
    "C": 29.8775209788372,
    "h": 0.50893362585564,
    "CMY_C": 0.4073219,
    "CMY_M": 0.6594245,
    "CMY_Y": 0.6827494,
    "CMYK_C": 0,
    "CMYK_M": 0.4253618,
    "CMYK_Y": 0.4647168,
    "CMYK_K": 0.4073219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04077",
    "Farbtonhilfsbezeichnung": "B9.36.33",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "75",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.6145438532322,
    "a": 32.6819171825429,
    "b": 16.5070419164965,
    "C": 36.6140702948957,
    "h": 0.46770478834184,
    "CMY_C": 0.3994933,
    "CMY_M": 0.7069007,
    "CMY_Y": 0.717341,
    "CMYK_C": 0,
    "CMYK_M": 0.5119134,
    "CMYK_Y": 0.5292992,
    "CMYK_K": 0.3994933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04078",
    "Farbtonhilfsbezeichnung": "B8.55.34",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "57",
    "Bcolor": "61",
    "Y": 13,
    "L": 43.2397172104514,
    "a": 51.2897549982968,
    "b": 26.4222509856507,
    "C": 57.6955311521961,
    "h": 0.47569916310345,
    "CMY_C": 0.2814381,
    "CMY_M": 0.7781508,
    "CMY_Y": 0.7610898,
    "CMYK_C": 0,
    "CMYK_M": 0.6912595,
    "CMYK_Y": 0.6675162,
    "CMYK_K": 0.2814381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04079",
    "Farbtonhilfsbezeichnung": "B8.08.37",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "99",
    "Bcolor": "96",
    "Y": 14,
    "L": 43.7804590023942,
    "a": 8.0962591989362,
    "b": 4.42221365497295,
    "C": 9.22525807913189,
    "h": 0.49992457245465,
    "CMY_C": 0.5305814,
    "CMY_M": 0.6127498,
    "CMY_Y": 0.6248548,
    "CMYK_C": 0,
    "CMYK_M": 0.1750428,
    "CMYK_Y": 0.2008301,
    "CMYK_K": 0.5305814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04080",
    "Farbtonhilfsbezeichnung": "B9.08.33",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "92",
    "Bcolor": "90",
    "Y": 12,
    "L": 40.9666840413266,
    "a": 7.53332868243695,
    "b": 4.04136789313416,
    "C": 8.54890025004871,
    "h": 0.4923923782824,
    "CMY_C": 0.5627394,
    "CMY_M": 0.6381586,
    "CMY_Y": 0.6489466,
    "CMYK_C": 0,
    "CMYK_M": 0.1724811,
    "CMYK_Y": 0.1971528,
    "CMYK_K": 0.5627394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04081",
    "Farbtonhilfsbezeichnung": "B8.16.29",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "80",
    "Bcolor": "77",
    "Y": 10,
    "L": 37.3970027121502,
    "a": 13.9795689078914,
    "b": 6.77761102932486,
    "C": 15.5359054488404,
    "h": 0.45143213816808,
    "CMY_C": 0.5554662,
    "CMY_M": 0.6877309,
    "CMY_Y": 0.6980664,
    "CMYK_C": 0,
    "CMYK_M": 0.2975358,
    "CMYK_Y": 0.3207858,
    "CMYK_K": 0.5554662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04082",
    "Farbtonhilfsbezeichnung": "B8.23.30",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "80",
    "Bcolor": "75",
    "Y": 11,
    "L": 39.107361475995,
    "a": 19.7012560194108,
    "b": 10.4494167844535,
    "C": 22.3008923560828,
    "h": 0.48766568187348,
    "CMY_C": 0.5010099,
    "CMY_M": 0.6878986,
    "CMY_Y": 0.7044566,
    "CMYK_C": 0,
    "CMYK_M": 0.3745339,
    "CMYK_Y": 0.407717,
    "CMYK_K": 0.5010099
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04083",
    "Farbtonhilfsbezeichnung": "B9.27.33",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "84",
    "Bcolor": "80",
    "Y": 13,
    "L": 42.2400332246053,
    "a": 24.1166648514582,
    "b": 12.2818795665817,
    "C": 27.0639629257353,
    "h": 0.4710356053833,
    "CMY_C": 0.4420141,
    "CMY_M": 0.6716029,
    "CMY_Y": 0.6866306,
    "CMYK_C": 0,
    "CMYK_M": 0.4114598,
    "CMYK_Y": 0.4383918,
    "CMYK_K": 0.4420141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04084",
    "Farbtonhilfsbezeichnung": "B9.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "148",
    "Gcolor": "67",
    "Bcolor": "64",
    "Y": 11,
    "L": 39.0566812664512,
    "a": 34.3563814455908,
    "b": 17.8705932771705,
    "C": 38.7262062447768,
    "h": 0.47964014045572,
    "CMY_C": 0.4180604,
    "CMY_M": 0.738204,
    "CMY_Y": 0.7483913,
    "CMYK_C": 0,
    "CMYK_M": 0.550132,
    "CMYK_Y": 0.5676379,
    "CMYK_K": 0.4180604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04085",
    "Farbtonhilfsbezeichnung": "B9.43.31",
    "Farbtonklasse": "04",
    "Rcolor": "150",
    "Gcolor": "63",
    "Bcolor": "59",
    "Y": 10,
    "L": 38.5115312337138,
    "a": 36.6878113267184,
    "b": 20.4212630826139,
    "C": 41.9883732220507,
    "h": 0.50791347961488,
    "CMY_C": 0.4103682,
    "CMY_M": 0.753398,
    "CMY_Y": 0.7686122,
    "CMYK_C": 0,
    "CMYK_M": 0.5817695,
    "CMYK_Y": 0.6075723,
    "CMYK_K": 0.4103682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04086",
    "Farbtonhilfsbezeichnung": "B9.52.33",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "57",
    "Bcolor": "59",
    "Y": 12,
    "L": 41.251097939908,
    "a": 47.3068364577958,
    "b": 24.5156927037455,
    "C": 53.2818539879115,
    "h": 0.47812286863972,
    "CMY_C": 0.3251528,
    "CMY_M": 0.7766904,
    "CMY_Y": 0.767576,
    "CMYK_C": 0,
    "CMYK_M": 0.6690961,
    "CMYK_Y": 0.6555902,
    "CMYK_K": 0.3251528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04087",
    "Farbtonhilfsbezeichnung": "B9.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "75",
    "Bcolor": "73",
    "Y": 8,
    "L": 33.5758242441753,
    "a": 6.82126504471209,
    "b": 3.21233911696035,
    "C": 7.53981295607289,
    "h": 0.44012243999765,
    "CMY_C": 0.6403571,
    "CMY_M": 0.7051403,
    "CMY_Y": 0.7118015,
    "CMYK_C": 0,
    "CMYK_M": 0.180132,
    "CMYK_Y": 0.1986536,
    "CMYK_K": 0.6403571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04088",
    "Farbtonhilfsbezeichnung": "B9.19.26",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "73",
    "Bcolor": "69",
    "Y": 8,
    "L": 34.7051997837059,
    "a": 15.026680522497,
    "b": 7.84533192371176,
    "C": 16.95141175591,
    "h": 0.48116576989617,
    "CMY_C": 0.5748684,
    "CMY_M": 0.715504,
    "CMY_Y": 0.7287743,
    "CMYK_C": 0,
    "CMYK_M": 0.3308048,
    "CMYK_Y": 0.3620194,
    "CMYK_K": 0.5748684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04089",
    "Farbtonhilfsbezeichnung": "B9.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "83",
    "Bcolor": "78",
    "Y": 11,
    "L": 39.3971208031696,
    "a": 16.3322522278883,
    "b": 8.90977679070174,
    "C": 18.6044775604017,
    "h": 0.49940691267837,
    "CMY_C": 0.5185875,
    "CMY_M": 0.6756455,
    "CMY_Y": 0.6927472,
    "CMYK_C": 0,
    "CMYK_M": 0.3262441,
    "CMYK_Y": 0.3617682,
    "CMYK_K": 0.5185875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04090",
    "Farbtonhilfsbezeichnung": "B7.29.30",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "75",
    "Bcolor": "74",
    "Y": 11,
    "L": 39.3701686304996,
    "a": 26.1106190135506,
    "b": 12.0628287844307,
    "C": 28.7624106005266,
    "h": 0.43277944756368,
    "CMY_C": 0.4626358,
    "CMY_M": 0.7049817,
    "CMY_Y": 0.7110052,
    "CMYK_C": 0,
    "CMYK_M": 0.4509902,
    "CMYK_Y": 0.4621993,
    "CMYK_K": 0.4626358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04091",
    "Farbtonhilfsbezeichnung": "B8.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "129",
    "Gcolor": "57",
    "Bcolor": "56",
    "Y": 8,
    "L": 33.803593822363,
    "a": 31.2653442433987,
    "b": 15.3660299586149,
    "C": 34.8372878873668,
    "h": 0.45680167241108,
    "CMY_C": 0.4930489,
    "CMY_M": 0.7760438,
    "CMY_Y": 0.7795941,
    "CMYK_C": 0,
    "CMYK_M": 0.5582293,
    "CMYK_Y": 0.5652325,
    "CMYK_K": 0.4930489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04092",
    "Farbtonhilfsbezeichnung": "B9.43.25",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "55",
    "Bcolor": "53",
    "Y": 8,
    "L": 34.2383590215792,
    "a": 34.0785363671413,
    "b": 18.4576044548642,
    "C": 38.7560292488639,
    "h": 0.49638639054844,
    "CMY_C": 0.4719967,
    "CMY_M": 0.7836566,
    "CMY_Y": 0.7940974,
    "CMYK_C": 0,
    "CMYK_M": 0.5902613,
    "CMYK_Y": 0.6100354,
    "CMYK_K": 0.4719967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04093",
    "Farbtonhilfsbezeichnung": "B9.60.29",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "48",
    "Bcolor": "54",
    "Y": 10,
    "L": 38.6618057887608,
    "a": 48.4459724042298,
    "b": 24.4339295977986,
    "C": 54.2589085568588,
    "h": 0.46712489769137,
    "CMY_C": 0.3502269,
    "CMY_M": 0.8113047,
    "CMY_Y": 0.7891918,
    "CMYK_C": 0,
    "CMYK_M": 0.7095981,
    "CMYK_Y": 0.6755665,
    "CMYK_K": 0.3502269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04094",
    "Farbtonhilfsbezeichnung": "B5.05.30",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "88",
    "Bcolor": "86",
    "Y": 10,
    "L": 38.5460824145579,
    "a": 4.50791318089758,
    "b": 2.30777472015474,
    "C": 5.06429712847651,
    "h": 0.47315280235888,
    "CMY_C": 0.6088986,
    "CMY_M": 0.6538455,
    "CMY_Y": 0.6609964,
    "CMYK_C": 0,
    "CMYK_M": 0.114924,
    "CMYK_Y": 0.133208,
    "CMYK_K": 0.6088986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04095",
    "Farbtonhilfsbezeichnung": "B9.08.16",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "57",
    "Bcolor": "57",
    "Y": 4,
    "L": 25.242628881125,
    "a": 5.06678682871278,
    "b": 1.95876582197768,
    "C": 5.43222719636847,
    "h": 0.36889228316781,
    "CMY_C": 0.7305076,
    "CMY_M": 0.7756009,
    "CMY_Y": 0.7782488,
    "CMYK_C": 0,
    "CMYK_M": 0.1673269,
    "CMYK_Y": 0.1771525,
    "CMYK_K": 0.7305076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04096",
    "Farbtonhilfsbezeichnung": "B8.14.21",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "67",
    "Bcolor": "66",
    "Y": 7,
    "L": 31.0252613625939,
    "a": 10.0663657709859,
    "b": 4.17798346608009,
    "C": 10.8989570913054,
    "h": 0.3934075905386,
    "CMY_C": 0.6443106,
    "CMY_M": 0.7358801,
    "CMY_Y": 0.7400485,
    "CMYK_C": 0,
    "CMYK_M": 0.2574424,
    "CMYK_Y": 0.2691617,
    "CMYK_K": 0.6443106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04097",
    "Farbtonhilfsbezeichnung": "B9.31.28",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "70",
    "Bcolor": "66",
    "Y": 9,
    "L": 36.6756273094337,
    "a": 24.6654104359516,
    "b": 13.141566759282,
    "C": 27.9478666245318,
    "h": 0.48953683303167,
    "CMY_C": 0.4971109,
    "CMY_M": 0.7259796,
    "CMY_Y": 0.7421225,
    "CMYK_C": 0,
    "CMYK_M": 0.4551077,
    "CMYK_Y": 0.4872081,
    "CMYK_K": 0.4971109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04098",
    "Farbtonhilfsbezeichnung": "B9.47.22",
    "Farbtonklasse": "04",
    "Rcolor": "135",
    "Gcolor": "49",
    "Bcolor": "50",
    "Y": 8,
    "L": 33.0882655088709,
    "a": 36.7627605416128,
    "b": 18.7307759686871,
    "C": 41.2594538382309,
    "h": 0.47122192159268,
    "CMY_C": 0.4720145,
    "CMY_M": 0.8063855,
    "CMY_Y": 0.804913,
    "CMYK_C": 0,
    "CMYK_M": 0.6332958,
    "CMYK_Y": 0.6305069,
    "CMYK_K": 0.4720145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04099",
    "Farbtonhilfsbezeichnung": "B9.47.21",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "47",
    "Bcolor": "47",
    "Y": 6,
    "L": 30.0031552733837,
    "a": 32.624937130967,
    "b": 16.0876113955345,
    "C": 36.3757853965145,
    "h": 0.45811867294144,
    "CMY_C": 0.5270479,
    "CMY_M": 0.8175418,
    "CMY_Y": 0.8160762,
    "CMYK_C": 0,
    "CMYK_M": 0.6142142,
    "CMYK_Y": 0.6111153,
    "CMYK_K": 0.5270479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04100",
    "Farbtonhilfsbezeichnung": "B9.54.22",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "60",
    "Bcolor": "63",
    "Y": 8,
    "L": 36.5717697143555,
    "a": 34.9785919189453,
    "b": 15.0241975784302,
    "C": 38.068733215332,
    "h": 23.2447566986084,
    "CMY_C": 0.44556146860123,
    "CMY_M": 0.76391851902008,
    "CMY_Y": 0.75252324342728,
    "CMYK_C": 0,
    "CMYK_M": 0.57419717311859,
    "CMYK_Y": 0.55364435911179,
    "CMYK_K": 0.44556146860123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04101",
    "Farbtonhilfsbezeichnung": "B9.15.12",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "54",
    "Bcolor": "52",
    "Y": 4,
    "L": 24.5641701076625,
    "a": 7.6145014341871,
    "b": 4.14772129254969,
    "C": 8.67088369267559,
    "h": 0.4987753755678,
    "CMY_C": 0.7182471,
    "CMY_M": 0.7874488,
    "CMY_Y": 0.7964683,
    "CMYK_C": 0,
    "CMYK_M": 0.2456115,
    "CMYK_Y": 0.2776233,
    "CMYK_K": 0.7182471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04102",
    "Farbtonhilfsbezeichnung": "B5.04.21",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "69",
    "Bcolor": "69",
    "Y": 6,
    "L": 29.940340205954,
    "a": 2.96308123006198,
    "b": 0.44877583662766,
    "C": 2.99687339196811,
    "h": 0.15031340742116,
    "CMY_C": 0.7037688,
    "CMY_M": 0.7292773,
    "CMY_Y": 0.7282543,
    "CMYK_C": 0,
    "CMYK_M": 0.08611,
    "CMYK_Y": 0.08265683,
    "CMYK_K": 0.7037688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04103",
    "Farbtonhilfsbezeichnung": "B8.16.16",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "57",
    "Bcolor": "55",
    "Y": 5,
    "L": 26.4600238258056,
    "a": 9.68793855012384,
    "b": 4.67120077657349,
    "C": 10.7552903283006,
    "h": 0.44927940924397,
    "CMY_C": 0.6886649,
    "CMY_M": 0.775701,
    "CMY_Y": 0.7829749,
    "CMYK_C": 0,
    "CMYK_M": 0.2795577,
    "CMYK_Y": 0.3029213,
    "CMYK_K": 0.6886649
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04104",
    "Farbtonhilfsbezeichnung": "B9.34.22",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "60",
    "Bcolor": "58",
    "Y": 8,
    "L": 32.937724320865,
    "a": 25.6642922623069,
    "b": 13.067236362825,
    "C": 28.7994542220342,
    "h": 0.47094889194006,
    "CMY_C": 0.5316727,
    "CMY_M": 0.7638476,
    "CMY_Y": 0.7742994,
    "CMYK_C": 0,
    "CMYK_M": 0.4957537,
    "CMYK_Y": 0.518071,
    "CMYK_K": 0.5316727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04105",
    "Farbtonhilfsbezeichnung": "B9.42.20",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "63",
    "Bcolor": "62",
    "Y": 7,
    "L": 33.897762298584,
    "a": 24.8530349731445,
    "b": 11.7626895904541,
    "C": 27.4960765838623,
    "h": 25.3277187347412,
    "CMY_C": 0.52717489004135,
    "CMY_M": 0.75200772285461,
    "CMY_Y": 0.75814580917358,
    "CMYK_C": 0,
    "CMYK_M": 0.47550949454308,
    "CMYK_Y": 0.48849123716354,
    "CMYK_K": 0.52717489004135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04106",
    "Farbtonhilfsbezeichnung": "B8.48.19",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "47",
    "Bcolor": "48",
    "Y": 6,
    "L": 29.8412400073197,
    "a": 32.2330263809645,
    "b": 14.8820884341711,
    "C": 35.5027399764925,
    "h": 0.43254349933456,
    "CMY_C": 0.531723,
    "CMY_M": 0.8171618,
    "CMY_Y": 0.8103403,
    "CMYK_C": 0,
    "CMYK_M": 0.6095511,
    "CMYK_Y": 0.594984,
    "CMYK_K": 0.531723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04107",
    "Farbtonhilfsbezeichnung": "B8.51.20",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "41",
    "Bcolor": "46",
    "Y": 7,
    "L": 30.7909301206961,
    "a": 38.9178878027668,
    "b": 18.1433037498542,
    "C": 42.9392764492861,
    "h": 0.43623932999801,
    "CMY_C": 0.4882152,
    "CMY_M": 0.8395559,
    "CMY_Y": 0.8201872,
    "CMYK_C": 0,
    "CMYK_M": 0.6865008,
    "CMYK_Y": 0.6486554,
    "CMYK_K": 0.4882152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04108",
    "Farbtonhilfsbezeichnung": "CN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 84,
    "L": 93.2748639148629,
    "a": 1.68651304555839,
    "b": 2.14548302037827,
    "C": 2.72899682,
    "h": 0.90460338556505,
    "CMY_C": 0.05523461,
    "CMY_M": 0.07989438,
    "CMY_Y": 0.0985859,
    "CMYK_C": 0,
    "CMYK_M": 0.02610147,
    "CMYK_Y": 0.04588576,
    "CMYK_K": 0.05523461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04109",
    "Farbtonhilfsbezeichnung": "C1.23.64",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "154",
    "Bcolor": "142",
    "Y": 43,
    "L": 71.5308962849693,
    "a": 29.405786677408,
    "b": 18.650293277675,
    "C": 34.8214550164193,
    "h": 0.56521543693668,
    "CMY_C": 0.07480769,
    "CMY_M": 0.395024,
    "CMY_Y": 0.4447233,
    "CMYK_C": 0,
    "CMYK_M": 0.3461078,
    "CMYK_Y": 0.3998256,
    "CMYK_K": 0.07480769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04110",
    "Farbtonhilfsbezeichnung": "C1.35.55",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "122",
    "Bcolor": "109",
    "Y": 31,
    "L": 62.8815014574278,
    "a": 39.3395732229848,
    "b": 24.7982447137579,
    "C": 46.5032790483639,
    "h": 0.5624471685795,
    "CMY_C": 0.1106908,
    "CMY_M": 0.5197067,
    "CMY_Y": 0.5712923,
    "CMYK_C": 0,
    "CMYK_M": 0.4599254,
    "CMYK_Y": 0.5179318,
    "CMYK_K": 0.1106908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04111",
    "Farbtonhilfsbezeichnung": "C2.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "225",
    "Bcolor": "218",
    "Y": 79,
    "L": 91.2864998163894,
    "a": 7.72355166602717,
    "b": 5.52379800748117,
    "C": 9.49555658006649,
    "h": 0.62084725060092,
    "CMY_C": 0.02142739,
    "CMY_M": 0.1179603,
    "CMY_Y": 0.1447037,
    "CMYK_C": 0,
    "CMYK_M": 0.09864664,
    "CMYK_Y": 0.1259756,
    "CMYK_K": 0.02142739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04112",
    "Farbtonhilfsbezeichnung": "C0.06.81",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "214",
    "Bcolor": "207",
    "Y": 72,
    "L": 87.9319529430415,
    "a": 9.8263809009147,
    "b": 6.51685541071285,
    "C": 11.7909781635791,
    "h": 0.58559873355601,
    "CMY_C": 0.04135888,
    "CMY_M": 0.1607056,
    "CMY_Y": 0.1883451,
    "CMYK_C": 0,
    "CMYK_M": 0.1244957,
    "CMYK_Y": 0.1533277,
    "CMYK_K": 0.04135888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04113",
    "Farbtonhilfsbezeichnung": "C1.19.64",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "160",
    "Bcolor": "148",
    "Y": 44,
    "L": 72.0630681099567,
    "a": 23.4025368979002,
    "b": 15.6336708016044,
    "C": 28.1441005539441,
    "h": 0.58894804454809,
    "CMY_C": 0.1103866,
    "CMY_M": 0.3707423,
    "CMY_Y": 0.419203,
    "CMYK_C": 0,
    "CMYK_M": 0.2926617,
    "CMYK_Y": 0.3471356,
    "CMYK_K": 0.1103866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04114",
    "Farbtonhilfsbezeichnung": "C2.35.53",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "118",
    "Bcolor": "103",
    "Y": 29,
    "L": 60.6129738899572,
    "a": 37.5873817708352,
    "b": 25.2065038563465,
    "C": 45.2568128025662,
    "h": 0.59072818350144,
    "CMY_C": 0.1464656,
    "CMY_M": 0.5369247,
    "CMY_Y": 0.5964463,
    "CMYK_C": 0,
    "CMYK_M": 0.4574614,
    "CMYK_Y": 0.5271969,
    "CMYK_K": 0.1464656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04115",
    "Farbtonhilfsbezeichnung": "CN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "224",
    "Bcolor": "219",
    "Y": 76,
    "L": 89.4454727172852,
    "a": 1.33169448375702,
    "b": 1.9357146024704,
    "C": 2.34955334663391,
    "h": 55.473575592041,
    "CMY_C": 0.10155600309372,
    "CMY_M": 0.12164187431335,
    "CMY_Y": 0.13934487104416,
    "CMYK_C": 0,
    "CMYK_M": 0.02235628664494,
    "CMYK_Y": 0.04206034913659,
    "CMYK_K": 0.10155600309372
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04116",
    "Farbtonhilfsbezeichnung": "C1.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "172",
    "Bcolor": "163",
    "Y": 52,
    "L": 77.018102227433,
    "a": 25.4923717144756,
    "b": 14.6961743509628,
    "C": 29.4251347691543,
    "h": 0.52295559988093,
    "CMY_C": 0.04222715,
    "CMY_M": 0.3240851,
    "CMY_Y": 0.3610608,
    "CMYK_C": 0,
    "CMYK_M": 0.2942848,
    "CMYK_Y": 0.3328907,
    "CMYK_K": 0.04222715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04117",
    "Farbtonhilfsbezeichnung": "C1.39.51",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "107",
    "Bcolor": "95",
    "Y": 25,
    "L": 57.5397669549044,
    "a": 41.112242109079,
    "b": 25.3034081927667,
    "C": 48.2750341005089,
    "h": 0.55171790896124,
    "CMY_C": 0.1637678,
    "CMY_M": 0.5814467,
    "CMY_Y": 0.6256036,
    "CMYK_C": 0,
    "CMYK_M": 0.4994772,
    "CMYK_Y": 0.5522817,
    "CMYK_K": 0.1637678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04118",
    "Farbtonhilfsbezeichnung": "CN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "211",
    "Bcolor": "207",
    "Y": 66,
    "L": 84.9816981419573,
    "a": 2.45452024909998,
    "b": 2.12768099510579,
    "C": 3.24833743169889,
    "h": 0.7141907594487,
    "CMY_C": 0.1418591,
    "CMY_M": 0.1736773,
    "CMY_Y": 0.1893715,
    "CMYK_C": 0,
    "CMYK_M": 0.03707803,
    "CMYK_Y": 0.05536666,
    "CMYK_K": 0.1418591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04119",
    "Farbtonhilfsbezeichnung": "C0.04.76",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "203",
    "Bcolor": "198",
    "Y": 62,
    "L": 82.9305544131503,
    "a": 5.69255182870754,
    "b": 3.58740742741472,
    "C": 6.72864313014087,
    "h": 0.56232503486933,
    "CMY_C": 0.135865,
    "CMY_M": 0.2043444,
    "CMY_Y": 0.2217301,
    "CMYK_C": 0,
    "CMYK_M": 0.07924618,
    "CMYK_Y": 0.09936541,
    "CMYK_K": 0.135865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04120",
    "Farbtonhilfsbezeichnung": "C0.07.71",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "186",
    "Bcolor": "181",
    "Y": 53,
    "L": 77.8454377606295,
    "a": 10.0550498591995,
    "b": 5.39553486039515,
    "C": 11.4112148389524,
    "h": 0.4924967504788,
    "CMY_C": 0.1558586,
    "CMY_M": 0.2706794,
    "CMY_Y": 0.2884976,
    "CMYK_C": 0,
    "CMYK_M": 0.1360208,
    "CMYK_Y": 0.1571289,
    "CMYK_K": 0.1558586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04121",
    "Farbtonhilfsbezeichnung": "C0.10.68",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "177",
    "Bcolor": "171",
    "Y": 49,
    "L": 75.5638141990941,
    "a": 13.6916646666403,
    "b": 7.87027181629225,
    "C": 15.7924937804658,
    "h": 0.52170059383291,
    "CMY_C": 0.1499792,
    "CMY_M": 0.3050667,
    "CMY_Y": 0.3296517,
    "CMYK_C": 0,
    "CMYK_M": 0.1824514,
    "CMYK_Y": 0.2113742,
    "CMYK_K": 0.1499792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04122",
    "Farbtonhilfsbezeichnung": "B9.17.66",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "166",
    "Bcolor": "158",
    "Y": 46,
    "L": 73.7587802714101,
    "a": 21.7807513766337,
    "b": 12.8323224091538,
    "C": 25.2798265212245,
    "h": 0.53240992742891,
    "CMY_C": 0.1066767,
    "CMY_M": 0.3475013,
    "CMY_Y": 0.3822843,
    "CMYK_C": 0,
    "CMYK_M": 0.2695828,
    "CMYK_Y": 0.3085195,
    "CMYK_K": 0.1066767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04123",
    "Farbtonhilfsbezeichnung": "C1.57.43",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "73",
    "Bcolor": "67",
    "Y": 20,
    "L": 51.7436527469676,
    "a": 55.970115837521,
    "b": 34.3648834485152,
    "C": 65.6779954116716,
    "h": 0.55064010921986,
    "CMY_C": 0.1500596,
    "CMY_M": 0.7128719,
    "CMY_Y": 0.736173,
    "CMYK_C": 0,
    "CMYK_M": 0.6621786,
    "CMYK_Y": 0.6895936,
    "CMYK_K": 0.1500596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04124",
    "Farbtonhilfsbezeichnung": "CN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "188",
    "Y": 53,
    "L": 78.0848768496496,
    "a": 2.5953801876904,
    "b": 2.21033969760098,
    "C": 3.40904677255192,
    "h": 0.70544765737583,
    "CMY_C": 0.2161263,
    "CMY_M": 0.2490519,
    "CMY_Y": 0.2642211,
    "CMYK_C": 0,
    "CMYK_M": 0.04200371,
    "CMYK_Y": 0.06135527,
    "CMYK_K": 0.2161263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04125",
    "Farbtonhilfsbezeichnung": "C0.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "192",
    "Bcolor": "187",
    "Y": 56,
    "L": 79.6016208336619,
    "a": 7.86150318049328,
    "b": 4.72187301204905,
    "C": 9.17056797580298,
    "h": 0.54088432278386,
    "CMY_C": 0.153739,
    "CMY_M": 0.2461064,
    "CMY_Y": 0.2653124,
    "CMYK_C": 0,
    "CMYK_M": 0.1091476,
    "CMYK_Y": 0.1318428,
    "CMYK_K": 0.153739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04126",
    "Farbtonhilfsbezeichnung": "B9.07.66",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "174",
    "Bcolor": "169",
    "Y": 46,
    "L": 73.2728637016269,
    "a": 9.40240498884282,
    "b": 5.38287397613308,
    "C": 10.8342305595343,
    "h": 0.51995320307794,
    "CMY_C": 0.2107374,
    "CMY_M": 0.3178164,
    "CMY_Y": 0.3366861,
    "CMYK_C": 0,
    "CMYK_M": 0.1356696,
    "CMYK_Y": 0.1595777,
    "CMYK_K": 0.2107374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04127",
    "Farbtonhilfsbezeichnung": "C1.11.63",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "164",
    "Bcolor": "157",
    "Y": 42,
    "L": 71.0123656889299,
    "a": 14.7145474169482,
    "b": 9.09676392823948,
    "C": 17.299393620926,
    "h": 0.55370582079444,
    "CMY_C": 0.1908434,
    "CMY_M": 0.3562193,
    "CMY_Y": 0.3855226,
    "CMYK_C": 0,
    "CMYK_M": 0.2043805,
    "CMYK_Y": 0.2405951,
    "CMYK_K": 0.1908434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04128",
    "Farbtonhilfsbezeichnung": "C1.31.46",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "107",
    "Bcolor": "98",
    "Y": 22,
    "L": 54.292619879603,
    "a": 32.4855730291272,
    "b": 19.111263267313,
    "C": 37.6902220569647,
    "h": 0.53177215284106,
    "CMY_C": 0.2549907,
    "CMY_M": 0.5820362,
    "CMY_Y": 0.6168287,
    "CMYK_C": 0,
    "CMYK_M": 0.4389818,
    "CMYK_Y": 0.4856825,
    "CMYK_K": 0.2549907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04129",
    "Farbtonhilfsbezeichnung": "C0.53.38",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "65",
    "Bcolor": "66",
    "Y": 15,
    "L": 46.173846045033,
    "a": 51.0561584763181,
    "b": 27.3186462993119,
    "C": 57.9054380346597,
    "h": 0.4913088472744,
    "CMY_C": 0.2468354,
    "CMY_M": 0.7448934,
    "CMY_Y": 0.7409711,
    "CMYK_C": 0,
    "CMYK_M": 0.661287,
    "CMYK_Y": 0.6560793,
    "CMYK_K": 0.2468354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04130",
    "Farbtonhilfsbezeichnung": "CN.02.70",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "189",
    "Bcolor": "184",
    "Y": 52,
    "L": 77.3039206002706,
    "a": 3.17693669093594,
    "b": 2.80813646324376,
    "C": 4.24011286812205,
    "h": 0.7238559737615,
    "CMY_C": 0.2184632,
    "CMY_M": 0.2589948,
    "CMY_Y": 0.2767397,
    "CMYK_C": 0,
    "CMYK_M": 0.05186145,
    "CMYK_Y": 0.07456657,
    "CMYK_K": 0.2184632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04131",
    "Farbtonhilfsbezeichnung": "C0.12.55",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "140",
    "Bcolor": "134",
    "Y": 30,
    "L": 61.7471115107281,
    "a": 14.5051654340103,
    "b": 8.53176865745347,
    "C": 16.8282768188639,
    "h": 0.53168915622712,
    "CMY_C": 0.2948415,
    "CMY_M": 0.4515467,
    "CMY_Y": 0.475954,
    "CMYK_C": 0,
    "CMYK_M": 0.2222268,
    "CMYK_Y": 0.2568393,
    "CMYK_K": 0.2948415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04132",
    "Farbtonhilfsbezeichnung": "C1.24.51",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "127",
    "Bcolor": "117",
    "Y": 28,
    "L": 59.7119108354128,
    "a": 25.2715364790244,
    "b": 15.68775894906,
    "C": 29.7448539558438,
    "h": 0.55555022643708,
    "CMY_C": 0.2390306,
    "CMY_M": 0.503875,
    "CMY_Y": 0.5429431,
    "CMYK_C": 0,
    "CMYK_M": 0.3480355,
    "CMYK_Y": 0.3993754,
    "CMYK_K": 0.2390306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04133",
    "Farbtonhilfsbezeichnung": "C1.37.41",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "91",
    "Bcolor": "82",
    "Y": 19,
    "L": 50.1318311478424,
    "a": 37.9108065487081,
    "b": 22.8327037358683,
    "C": 44.2556393362869,
    "h": 0.54209008756186,
    "CMY_C": 0.2696408,
    "CMY_M": 0.6438463,
    "CMY_Y": 0.6792583,
    "CMYK_C": 0,
    "CMYK_M": 0.5123581,
    "CMYK_Y": 0.5608439,
    "CMYK_K": 0.2696408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04134",
    "Farbtonhilfsbezeichnung": "C1.54.38",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "67",
    "Bcolor": "63",
    "Y": 15,
    "L": 45.9524842975525,
    "a": 49.0424360992385,
    "b": 28.7824260573035,
    "C": 56.8646514830789,
    "h": 0.53072266564977,
    "CMY_C": 0.2579498,
    "CMY_M": 0.7369006,
    "CMY_Y": 0.7531413,
    "CMYK_C": 0,
    "CMYK_M": 0.6454426,
    "CMYK_Y": 0.6673288,
    "CMYK_K": 0.2579498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04135",
    "Farbtonhilfsbezeichnung": "C0.06.53",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "137",
    "Bcolor": "133",
    "Y": 27,
    "L": 58.9250173776251,
    "a": 7.0511941152403,
    "b": 4.80777158887138,
    "C": 8.53428415870706,
    "h": 0.59843237344783,
    "CMY_C": 0.3816001,
    "CMY_M": 0.4608943,
    "CMY_Y": 0.4800508,
    "CMYK_C": 0,
    "CMYK_M": 0.1282249,
    "CMYK_Y": 0.1592024,
    "CMYK_K": 0.3816001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04136",
    "Farbtonhilfsbezeichnung": "B9.14.44",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "115",
    "Bcolor": "110",
    "Y": 20,
    "L": 52.2037828181756,
    "a": 14.4500876366965,
    "b": 8.42369384429425,
    "C": 16.7261367533155,
    "h": 0.52778917835946,
    "CMY_C": 0.3972858,
    "CMY_M": 0.5472783,
    "CMY_Y": 0.5693258,
    "CMYK_C": 0,
    "CMYK_M": 0.2488616,
    "CMYK_Y": 0.2854421,
    "CMYK_K": 0.3972858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04137",
    "Farbtonhilfsbezeichnung": "C0.49.34",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "64",
    "Bcolor": "59",
    "Y": 13,
    "L": 42.2068212415362,
    "a": 43.9937439617439,
    "b": 25.9210393942747,
    "C": 51.0622149054565,
    "h": 0.53243921676959,
    "CMY_C": 0.3284934,
    "CMY_M": 0.7501847,
    "CMY_Y": 0.7691857,
    "CMYK_C": 0,
    "CMYK_M": 0.6279778,
    "CMYK_Y": 0.656274,
    "CMYK_K": 0.3284934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04138",
    "Farbtonhilfsbezeichnung": "C1.60.37",
    "Farbtonklasse": "04",
    "Rcolor": "196",
    "Gcolor": "59",
    "Bcolor": "55",
    "Y": 15,
    "L": 45.8683710224967,
    "a": 54.4691364335285,
    "b": 33.4729587549338,
    "C": 63.9321968308914,
    "h": 0.5510354124352,
    "CMY_C": 0.2297458,
    "CMY_M": 0.7697745,
    "CMY_Y": 0.783025,
    "CMYK_C": 0,
    "CMYK_M": 0.7011045,
    "CMYK_Y": 0.7183074,
    "CMYK_K": 0.2297458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04139",
    "Farbtonhilfsbezeichnung": "CN.01.55",
    "Farbtonklasse": "01",
    "Rcolor": "151",
    "Gcolor": "148",
    "Bcolor": "146",
    "Y": 30,
    "L": 61.4836222881885,
    "a": 1.05329196021126,
    "b": 0.52022016686501,
    "C": 1.17475656008329,
    "h": 0.45875515280132,
    "CMY_C": 0.4085735,
    "CMY_M": 0.4199467,
    "CMY_Y": 0.4258715,
    "CMYK_C": 0,
    "CMYK_M": 0.01923016,
    "CMYK_Y": 0.02924795,
    "CMYK_K": 0.4085735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04140",
    "Farbtonhilfsbezeichnung": "C1.07.43",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "115",
    "Bcolor": "110",
    "Y": 19,
    "L": 50.1184455373468,
    "a": 7.63986128141558,
    "b": 5.0319296623488,
    "C": 9.14810343875159,
    "h": 0.5824261187569,
    "CMY_C": 0.4681058,
    "CMY_M": 0.5503261,
    "CMY_Y": 0.5682219,
    "CMYK_C": 0,
    "CMYK_M": 0.1545802,
    "CMYK_Y": 0.1882257,
    "CMYK_K": 0.4681058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04141",
    "Farbtonhilfsbezeichnung": "C0.11.41",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "110",
    "Bcolor": "106",
    "Y": 18,
    "L": 48.9895240402021,
    "a": 10.4708341489051,
    "b": 5.8217229809532,
    "C": 11.980435144052,
    "h": 0.50743362706789,
    "CMY_C": 0.4602584,
    "CMY_M": 0.5683042,
    "CMY_Y": 0.5838799,
    "CMYK_C": 0,
    "CMYK_M": 0.2001807,
    "CMYK_Y": 0.2290384,
    "CMYK_K": 0.4602584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04142",
    "Farbtonhilfsbezeichnung": "C0.39.34",
    "Farbtonklasse": "04",
    "Rcolor": "160",
    "Gcolor": "77",
    "Bcolor": "72",
    "Y": 13,
    "L": 43.1094108638551,
    "a": 34.572590451081,
    "b": 18.8946432746787,
    "C": 39.3988775852249,
    "h": 0.50016819395583,
    "CMY_C": 0.3707041,
    "CMY_M": 0.6998776,
    "CMY_Y": 0.7186059,
    "CMYK_C": 0,
    "CMYK_M": 0.5230821,
    "CMYK_Y": 0.552843,
    "CMYK_K": 0.3707041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04143",
    "Farbtonhilfsbezeichnung": "C0.52.29",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "55",
    "Bcolor": "55",
    "Y": 10,
    "L": 38.0100945552817,
    "a": 42.2468893890439,
    "b": 22.3532352229742,
    "C": 47.7960959491853,
    "h": 0.48666319600986,
    "CMY_C": 0.3881248,
    "CMY_M": 0.783854,
    "CMY_Y": 0.7836016,
    "CMYK_C": 0,
    "CMYK_M": 0.6467482,
    "CMYK_Y": 0.6463358,
    "CMYK_K": 0.3881248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04144",
    "Farbtonhilfsbezeichnung": "C1.61.32",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "52",
    "Bcolor": "50",
    "Y": 12,
    "L": 41.6760774115823,
    "a": 51.3651440305622,
    "b": 31.1189175158185,
    "C": 60.0563489452757,
    "h": 0.5447005435716,
    "CMY_C": 0.2963824,
    "CMY_M": 0.7973459,
    "CMY_Y": 0.805079,
    "CMYK_C": 0,
    "CMYK_M": 0.7119825,
    "CMYK_Y": 0.7229731,
    "CMYK_K": 0.2963824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04145",
    "Farbtonhilfsbezeichnung": "C2.04.30",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "95",
    "Bcolor": "93",
    "Y": 10,
    "L": 40.9346008300781,
    "a": 3.38584995269775,
    "b": 1.71733462810516,
    "C": 3.79647445678711,
    "h": 26.8945484161377,
    "CMY_C": 0.59447729587555,
    "CMY_M": 0.62873828411102,
    "CMY_Y": 0.63511264324188,
    "CMYK_C": 0,
    "CMYK_M": 0.08448599278927,
    "CMYK_Y": 0.10020486265421,
    "CMYK_K": 0.59447729587555
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04146",
    "Farbtonhilfsbezeichnung": "CN.02.38",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "111",
    "Bcolor": "110",
    "Y": 15,
    "L": 47.2448043823242,
    "a": 2.16860961914063,
    "b": 0.81496065855026,
    "C": 2.31668472290039,
    "h": 20.5961532592773,
    "CMY_C": 0.54343855381012,
    "CMY_M": 0.56516420841217,
    "CMY_Y": 0.56927096843719,
    "CMYK_C": 0,
    "CMYK_M": 0.04758539050817,
    "CMYK_Y": 0.05658036842942,
    "CMYK_K": 0.54343855381012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04147",
    "Farbtonhilfsbezeichnung": "C1.11.29",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "88",
    "Bcolor": "85",
    "Y": 11,
    "L": 39.2735778728947,
    "a": 7.81581097962494,
    "b": 4.07447584258995,
    "C": 8.81409409191182,
    "h": 0.48055146169311,
    "CMY_C": 0.5775909,
    "CMY_M": 0.6547731,
    "CMY_Y": 0.6648668,
    "CMYK_C": 0,
    "CMYK_M": 0.182719,
    "CMYK_Y": 0.2066146,
    "CMYK_K": 0.5775909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04148",
    "Farbtonhilfsbezeichnung": "C0.14.35",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "93",
    "Bcolor": "89",
    "Y": 13,
    "L": 42.4283265865173,
    "a": 12.6852244909447,
    "b": 6.77043825980888,
    "C": 14.3789344047306,
    "h": 0.49026323933723,
    "CMY_C": 0.5120459,
    "CMY_M": 0.6372021,
    "CMY_Y": 0.6518428,
    "CMYK_C": 0,
    "CMYK_M": 0.2564917,
    "CMYK_Y": 0.2864961,
    "CMYK_K": 0.5120459
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04149",
    "Farbtonhilfsbezeichnung": "C0.27.26",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "74",
    "Bcolor": "70",
    "Y": 10,
    "L": 37.086761633477,
    "a": 20.1512754211727,
    "b": 10.8221983942416,
    "C": 22.87343173169,
    "h": 0.49284476073784,
    "CMY_C": 0.5190328,
    "CMY_M": 0.7081232,
    "CMY_Y": 0.7249286,
    "CMYK_C": 0,
    "CMYK_M": 0.3931462,
    "CMYK_Y": 0.4280871,
    "CMYK_K": 0.5190328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04150",
    "Farbtonhilfsbezeichnung": "C1.46.26",
    "Farbtonklasse": "04",
    "Rcolor": "147",
    "Gcolor": "63",
    "Bcolor": "57",
    "Y": 10,
    "L": 37.8356047260717,
    "a": 35.414343168076,
    "b": 20.56031126622,
    "C": 40.949995132968,
    "h": 0.52600611110884,
    "CMY_C": 0.4238662,
    "CMY_M": 0.7548201,
    "CMY_Y": 0.7757117,
    "CMYK_C": 0,
    "CMYK_M": 0.5744393,
    "CMYK_Y": 0.6107009,
    "CMYK_K": 0.4238662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04151",
    "Farbtonhilfsbezeichnung": "C0.46.25",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "56",
    "Bcolor": "54",
    "Y": 9,
    "L": 35.6279504689972,
    "a": 36.7433312083774,
    "b": 19.5432216175496,
    "C": 41.617423027876,
    "h": 0.4888289448111,
    "CMY_C": 0.4431632,
    "CMY_M": 0.781624,
    "CMY_Y": 0.7881662,
    "CMYK_C": 0,
    "CMYK_M": 0.6078277,
    "CMYK_Y": 0.6195765,
    "CMYK_K": 0.4431632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04152",
    "Farbtonhilfsbezeichnung": "C0.67.25",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "35",
    "Bcolor": "45",
    "Y": 9,
    "L": 35.3838678878487,
    "a": 50.4795370610837,
    "b": 25.6093197953568,
    "C": 56.6040716051608,
    "h": 0.46948709313825,
    "CMY_C": 0.3786006,
    "CMY_M": 0.8638809,
    "CMY_Y": 0.8237187,
    "CMYK_C": 0,
    "CMYK_M": 0.7809476,
    "CMYK_Y": 0.7163157,
    "CMYK_K": 0.3786006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04153",
    "Farbtonhilfsbezeichnung": "C1.11.26",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "76",
    "Bcolor": "73",
    "Y": 8,
    "L": 34.1892236658484,
    "a": 8.33695754749128,
    "b": 4.78191023186126,
    "C": 9.61101069681286,
    "h": 0.52076628777807,
    "CMY_C": 0.6224133,
    "CMY_M": 0.7032915,
    "CMY_Y": 0.7156468,
    "CMYK_C": 0,
    "CMYK_M": 0.2141979,
    "CMYK_Y": 0.2469195,
    "CMYK_K": 0.6224133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04154",
    "Farbtonhilfsbezeichnung": "C0.13.26",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "76",
    "Bcolor": "73",
    "Y": 8,
    "L": 34.6357259644857,
    "a": 10.0643824242941,
    "b": 5.07564067880782,
    "C": 11.271819812382,
    "h": 0.46709536296207,
    "CMY_C": 0.607725,
    "CMY_M": 0.7032651,
    "CMY_Y": 0.7131774,
    "CMYK_C": 0,
    "CMYK_M": 0.2435538,
    "CMYK_Y": 0.2688226,
    "CMYK_K": 0.607725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04155",
    "Farbtonhilfsbezeichnung": "B9.32.25",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "63",
    "Bcolor": "60",
    "Y": 8,
    "L": 34.1661030713216,
    "a": 25.6268698709205,
    "b": 13.4181661898111,
    "C": 28.9272128501604,
    "h": 0.48234694249132,
    "CMY_C": 0.5184997,
    "CMY_M": 0.7524498,
    "CMY_Y": 0.7657411,
    "CMYK_C": 0,
    "CMYK_M": 0.4858774,
    "CMYK_Y": 0.5134811,
    "CMYK_K": 0.5184997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04156",
    "Farbtonhilfsbezeichnung": "C0.39.26",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "60",
    "Bcolor": "55",
    "Y": 8,
    "L": 34.6170514498537,
    "a": 30.6948797006453,
    "b": 17.1196153581567,
    "C": 35.1462212741046,
    "h": 0.50876255260603,
    "CMY_C": 0.4851219,
    "CMY_M": 0.7666373,
    "CMY_Y": 0.7834201,
    "CMYK_C": 0,
    "CMYK_M": 0.5467613,
    "CMYK_Y": 0.579357,
    "CMYK_K": 0.4851219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04157",
    "Farbtonhilfsbezeichnung": "C1.48.25",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "54",
    "Bcolor": "50",
    "Y": 8,
    "L": 33.6439615033682,
    "a": 33.2804295729901,
    "b": 19.2287300341683,
    "C": 38.4360644615142,
    "h": 0.52392019003011,
    "CMY_C": 0.4815295,
    "CMY_M": 0.7862886,
    "CMY_Y": 0.8041219,
    "CMYK_C": 0,
    "CMYK_M": 0.5878041,
    "CMYK_Y": 0.6222,
    "CMYK_K": 0.4815295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04158",
    "Farbtonhilfsbezeichnung": "C1.55.25",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "50",
    "Bcolor": "48",
    "Y": 10,
    "L": 34.3974886250668,
    "a": 39.219967629728,
    "b": 21.7967511373252,
    "C": 44.8698587140566,
    "h": 0.50725202754341,
    "CMY_C": 0.4435648,
    "CMY_M": 0.8055868,
    "CMY_Y": 0.8119501,
    "CMYK_C": 0,
    "CMYK_M": 0.6506094,
    "CMYK_Y": 0.6620452,
    "CMYK_K": 0.4435648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04159",
    "Farbtonhilfsbezeichnung": "CN.01.23",
    "Farbtonklasse": "02",
    "Rcolor": "85",
    "Gcolor": "82",
    "Bcolor": "82",
    "Y": 8,
    "L": 35.1829452514648,
    "a": 1.14662325382233,
    "b": 0.009387107566,
    "C": 1.14666163921356,
    "h": 0.46905523538589,
    "CMY_C": 0.6680394411087,
    "CMY_M": 0.67762464284897,
    "CMY_Y": 0.67823314666748,
    "CMYK_C": 0,
    "CMYK_M": 0.02887452021241,
    "CMYK_Y": 0.03070758096874,
    "CMYK_K": 0.6680394411087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04160",
    "Farbtonhilfsbezeichnung": "CN.02.18",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 5,
    "L": 27.7913166752817,
    "a": 1.296138603403,
    "b": 0.41273710079581,
    "C": 1.3602673243171,
    "h": 0.30828351422144,
    "CMY_C": 0.7335557,
    "CMY_M": 0.7451873,
    "CMY_Y": 0.7473322,
    "CMYK_C": 0,
    "CMYK_M": 0.04365485,
    "CMYK_Y": 0.05170474,
    "CMYK_K": 0.7335557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04161",
    "Farbtonhilfsbezeichnung": "C1.15.18",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "63",
    "Bcolor": "61",
    "Y": 6,
    "L": 28.5957671022253,
    "a": 8.33110850598345,
    "b": 4.25273383391606,
    "C": 9.35377538754295,
    "h": 0.47198399592634,
    "CMY_C": 0.6767205,
    "CMY_M": 0.7536472,
    "CMY_Y": 0.7621423,
    "CMYK_C": 0,
    "CMYK_M": 0.2379573,
    "CMYK_Y": 0.2642351,
    "CMYK_K": 0.6767205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04162",
    "Farbtonhilfsbezeichnung": "C0.18.25",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "74",
    "Bcolor": "69",
    "Y": 8,
    "L": 34.7044808581591,
    "a": 13.4783373953771,
    "b": 7.71199952917254,
    "C": 15.5286997421413,
    "h": 0.519710404736,
    "CMY_C": 0.5833951,
    "CMY_M": 0.7115336,
    "CMY_Y": 0.7282055,
    "CMYK_C": 0,
    "CMYK_M": 0.307578,
    "CMYK_Y": 0.3475965,
    "CMYK_K": 0.5833951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04163",
    "Farbtonhilfsbezeichnung": "C0.24.21",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "63",
    "Bcolor": "60",
    "Y": 7,
    "L": 31.0985568222259,
    "a": 16.3516832841498,
    "b": 8.7800874061669,
    "C": 18.5598351578099,
    "h": 0.49277126475699,
    "CMY_C": 0.6024534,
    "CMY_M": 0.7519875,
    "CMY_Y": 0.7661101,
    "CMYK_C": 0,
    "CMYK_M": 0.3761425,
    "CMYK_Y": 0.4116667,
    "CMYK_K": 0.6024534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04164",
    "Farbtonhilfsbezeichnung": "C0.39.21",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "59",
    "Bcolor": "57",
    "Y": 7,
    "L": 32.2493097211677,
    "a": 25.1968405535613,
    "b": 12.3741481528565,
    "C": 28.0713433307071,
    "h": 0.45650164556426,
    "CMY_C": 0.5419853,
    "CMY_M": 0.768494,
    "CMY_Y": 0.7761697,
    "CMYK_C": 0,
    "CMYK_M": 0.4945447,
    "CMYK_Y": 0.5113032,
    "CMYK_K": 0.5419853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04165",
    "Farbtonhilfsbezeichnung": "C1.56.23",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "51",
    "Bcolor": "52",
    "Y": 9,
    "L": 35.9224728580359,
    "a": 41.3891806759973,
    "b": 21.4114333413196,
    "C": 46.5995038037973,
    "h": 0.47740707107901,
    "CMY_C": 0.4166782,
    "CMY_M": 0.800694,
    "CMY_Y": 0.7959515,
    "CMYK_C": 0,
    "CMYK_M": 0.6583257,
    "CMYK_Y": 0.6501955,
    "CMYK_K": 0.4166782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04166",
    "Farbtonhilfsbezeichnung": "C1.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "61",
    "Bcolor": "60",
    "Y": 5,
    "L": 26.3244329384196,
    "a": 2.85553360275931,
    "b": 1.1442910475348,
    "C": 3.07627602109366,
    "h": 0.38113343699167,
    "CMY_C": 0.7354317,
    "CMY_M": 0.7614201,
    "CMY_Y": 0.7643495,
    "CMYK_C": 0,
    "CMYK_M": 0.09822941,
    "CMYK_Y": 0.1093021,
    "CMYK_K": 0.7354317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04167",
    "Farbtonhilfsbezeichnung": "C0.47.21",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "53",
    "Bcolor": "52",
    "Y": 8,
    "L": 31.9924986131519,
    "a": 31.1805010040951,
    "b": 15.4500531385352,
    "C": 34.7983876760108,
    "h": 0.46004409131528,
    "CMY_C": 0.5128903,
    "CMY_M": 0.7928127,
    "CMY_Y": 0.7957028,
    "CMYK_C": 0,
    "CMYK_M": 0.5746598,
    "CMYK_Y": 0.580593,
    "CMYK_K": 0.5128903
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04168",
    "Farbtonhilfsbezeichnung": "C1.44.19",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "50",
    "Bcolor": "48",
    "Y": 6,
    "L": 29.0608603131164,
    "a": 26.9778281758757,
    "b": 13.6667769119737,
    "C": 30.2420899451201,
    "h": 0.46890802850483,
    "CMY_C": 0.5654412,
    "CMY_M": 0.8040594,
    "CMY_Y": 0.8108544,
    "CMYK_C": 0,
    "CMYK_M": 0.5491044,
    "CMYK_Y": 0.5647411,
    "CMYK_K": 0.5654412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04169",
    "Farbtonhilfsbezeichnung": "C1.40.15",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "50",
    "Bcolor": "49",
    "Y": 5,
    "L": 27.7700390694422,
    "a": 23.2829206424453,
    "b": 11.1470445077293,
    "C": 25.8137752934301,
    "h": 0.44651564844333,
    "CMY_C": 0.5988981,
    "CMY_M": 0.8026935,
    "CMY_Y": 0.8075992,
    "CMYK_C": 0,
    "CMYK_M": 0.5080887,
    "CMYK_Y": 0.5203195,
    "CMYK_K": 0.5988981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04170",
    "Farbtonhilfsbezeichnung": "C1.24.15",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "51",
    "Bcolor": "48",
    "Y": 4,
    "L": 25.0143560499654,
    "a": 14.3082900507955,
    "b": 7.59475792893608,
    "C": 16.1989972583747,
    "h": 0.48797843895776,
    "CMY_C": 0.6740432,
    "CMY_M": 0.8002667,
    "CMY_Y": 0.8116718,
    "CMYK_C": 0,
    "CMYK_M": 0.3872401,
    "CMYK_Y": 0.4222295,
    "CMYK_K": 0.6740432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04171",
    "Farbtonhilfsbezeichnung": "C0.19.13",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "52",
    "Bcolor": "49",
    "Y": 4,
    "L": 24.3527188753386,
    "a": 10.7617605468896,
    "b": 5.66812997080639,
    "C": 12.1631898544149,
    "h": 0.48477225251449,
    "CMY_C": 0.7010984,
    "CMY_M": 0.7968062,
    "CMY_Y": 0.8066338,
    "CMYK_C": 0,
    "CMYK_M": 0.3201981,
    "CMYK_Y": 0.3530775,
    "CMYK_K": 0.7010984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04172",
    "Farbtonhilfsbezeichnung": "C1.10.10",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "52",
    "Bcolor": "50",
    "Y": 4,
    "L": 22.6857870186964,
    "a": 4.34299050689049,
    "b": 2.29347540829895,
    "C": 4.91137414492248,
    "h": 0.48586366080085,
    "CMY_C": 0.7567511,
    "CMY_M": 0.7963468,
    "CMY_Y": 0.8021892,
    "CMYK_C": 0,
    "CMYK_M": 0.1627786,
    "CMYK_Y": 0.1867969,
    "CMYK_K": 0.7567511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04173",
    "Farbtonhilfsbezeichnung": "C5.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "216",
    "Bcolor": "206",
    "Y": 74,
    "L": 88.8376719618805,
    "a": 10.2423218610712,
    "b": 8.26372310847678,
    "C": 13.1603296584603,
    "h": 0.67888643408339,
    "CMY_C": 0.02329369,
    "CMY_M": 0.1522663,
    "CMY_Y": 0.1912804,
    "CMYK_C": 0,
    "CMYK_M": 0.1320485,
    "CMYK_Y": 0.171993,
    "CMYK_K": 0.02329369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04174",
    "Farbtonhilfsbezeichnung": "C2.11.79",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "207",
    "Bcolor": "196",
    "Y": 69,
    "L": 86.5415093405262,
    "a": 14.8301031869389,
    "b": 10.4367583762032,
    "C": 18.1344392231605,
    "h": 0.61324161515481,
    "CMY_C": 0.01177158,
    "CMY_M": 0.1901363,
    "CMY_Y": 0.231318,
    "CMYK_C": 0,
    "CMYK_M": 0.1804894,
    "CMYK_Y": 0.2221616,
    "CMYK_K": 0.01177158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04175",
    "Farbtonhilfsbezeichnung": "C2.30.63",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "144",
    "Bcolor": "127",
    "Y": 41,
    "L": 69.9887971316987,
    "a": 36.8580180515067,
    "b": 24.5866997969313,
    "C": 44.3059736558132,
    "h": 0.58827843446461,
    "CMY_C": 0.04038704,
    "CMY_M": 0.4368343,
    "CMY_Y": 0.5004224,
    "CMYK_C": 0,
    "CMYK_M": 0.4131324,
    "CMYK_Y": 0.4793967,
    "CMYK_K": 0.04038704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04176",
    "Farbtonhilfsbezeichnung": "C2.38.59",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "127",
    "Bcolor": "111",
    "Y": 35,
    "L": 65.9917113859366,
    "a": 42.6219655490874,
    "b": 28.6044379407071,
    "C": 51.3307492364115,
    "h": 0.59107909484782,
    "CMY_C": 0.05092782,
    "CMY_M": 0.5002451,
    "CMY_Y": 0.566623,
    "CMYK_C": 0,
    "CMYK_M": 0.4734279,
    "CMYK_Y": 0.5433677,
    "CMYK_K": 0.05092782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04177",
    "Farbtonhilfsbezeichnung": "C5.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "213",
    "Bcolor": "204",
    "Y": 70,
    "L": 87.179704474382,
    "a": 8.26232213771072,
    "b": 6.77017565110034,
    "C": 10.6818184525883,
    "h": 0.68646087045065,
    "CMY_C": 0.06042884,
    "CMY_M": 0.1650791,
    "CMY_Y": 0.1986104,
    "CMYK_C": 0,
    "CMYK_M": 0.1113808,
    "CMYK_Y": 0.1470688,
    "CMYK_K": 0.06042884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04178",
    "Farbtonhilfsbezeichnung": "C2.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "202",
    "Bcolor": "193",
    "Y": 66,
    "L": 84.8928867290776,
    "a": 14.2837571642963,
    "b": 9.43874619304159,
    "C": 17.1206205619201,
    "h": 0.5839319832111,
    "CMY_C": 0.03687336,
    "CMY_M": 0.2064411,
    "CMY_Y": 0.2418388,
    "CMYK_C": 0,
    "CMYK_M": 0.1760597,
    "CMYK_Y": 0.2128125,
    "CMYK_K": 0.03687336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04179",
    "Farbtonhilfsbezeichnung": "C4.19.68",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "170",
    "Bcolor": "156",
    "Y": 49,
    "L": 75.8846664428711,
    "a": 24.1211090087891,
    "b": 17.0904731750488,
    "C": 29.5620059967041,
    "h": 35.3186264038086,
    "CMY_C": 0.05921065807343,
    "CMY_M": 0.33269691467285,
    "CMY_Y": 0.39012968540192,
    "CMYK_C": 0,
    "CMYK_M": 0.29069870710373,
    "CMYK_Y": 0.35174614191055,
    "CMYK_K": 0.05921065807343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04180",
    "Farbtonhilfsbezeichnung": "Y0.05.64",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "173",
    "Bcolor": "183",
    "Y": 44,
    "L": 72.1197838689752,
    "a": 7.59884338352396,
    "b": -4.25894032316489,
    "C": 8.71096971890074,
    "h": -0.51084770514566,
    "CMY_C": 0.264219,
    "CMY_M": 0.3228638,
    "CMY_Y": 0.2811231,
    "CMYK_C": 0,
    "CMYK_M": 0.07970412,
    "CMYK_Y": 0.02297437,
    "CMYK_K": 0.264219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04181",
    "Farbtonhilfsbezeichnung": "C3.24.68",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "165",
    "Bcolor": "148",
    "Y": 49,
    "L": 75.6346042374852,
    "a": 29.7877728091604,
    "b": 21.133366647256,
    "C": 36.523014590495,
    "h": 0.61704975936993,
    "CMY_C": 0.02026538,
    "CMY_M": 0.3534189,
    "CMY_Y": 0.4204186,
    "CMYK_C": 0,
    "CMYK_M": 0.3400446,
    "CMYK_Y": 0.4084302,
    "CMYK_K": 0.02026538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04182",
    "Farbtonhilfsbezeichnung": "C2.10.72",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "189",
    "Bcolor": "180",
    "Y": 56,
    "L": 79.7785592889286,
    "a": 13.2259459204525,
    "b": 9.19522570968272,
    "C": 16.108315285676,
    "h": 0.60752515640023,
    "CMY_C": 0.102655,
    "CMY_M": 0.2590532,
    "CMY_Y": 0.2947758,
    "CMYK_C": 0,
    "CMYK_M": 0.17429,
    "CMYK_Y": 0.2140991,
    "CMYK_K": 0.102655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04183",
    "Farbtonhilfsbezeichnung": "C4.18.67",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "168",
    "Bcolor": "153",
    "Y": 47,
    "L": 74.209057602292,
    "a": 20.8961395024119,
    "b": 16.171070357549,
    "C": 26.4225691902407,
    "h": 0.65860894206598,
    "CMY_C": 0.1003581,
    "CMY_M": 0.3410836,
    "CMY_Y": 0.401453,
    "CMYK_C": 0,
    "CMYK_M": 0.2675792,
    "CMYK_Y": 0.3346831,
    "CMYK_K": 0.1003581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04184",
    "Farbtonhilfsbezeichnung": "C2.25.62",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "152",
    "Bcolor": "137",
    "Y": 41,
    "L": 70.2828927021101,
    "a": 28.5274182094319,
    "b": 19.362438766716,
    "C": 34.4777845096034,
    "h": 0.59630829061104,
    "CMY_C": 0.0933078,
    "CMY_M": 0.4055936,
    "CMY_Y": 0.4625353,
    "CMYK_C": 0,
    "CMYK_M": 0.3444231,
    "CMYK_Y": 0.4072247,
    "CMYK_K": 0.0933078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04185",
    "Farbtonhilfsbezeichnung": "C3.47.53",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "107",
    "Bcolor": "86",
    "Y": 29,
    "L": 60.5901042595211,
    "a": 48.2650428290276,
    "b": 35.1365671734713,
    "C": 59.7000227137623,
    "h": 0.62926659735301,
    "CMY_C": 0.07961363,
    "CMY_M": 0.5807742,
    "CMY_Y": 0.66245,
    "CMYK_C": 0,
    "CMYK_M": 0.5445111,
    "CMYK_Y": 0.6332518,
    "CMYK_K": 0.07961363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04186",
    "Farbtonhilfsbezeichnung": "C4.04.76",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "203",
    "Bcolor": "197",
    "Y": 62,
    "L": 83.1173116673956,
    "a": 5.63757720756353,
    "b": 4.78576235108343,
    "C": 7.39498465531115,
    "h": 0.70385748804374,
    "CMY_C": 0.1306547,
    "CMY_M": 0.2025037,
    "CMY_Y": 0.2284216,
    "CMYK_C": 0,
    "CMYK_M": 0.08264723,
    "CMYK_Y": 0.1124604,
    "CMYK_K": 0.1306547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04187",
    "Farbtonhilfsbezeichnung": "C2.08.75",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "195",
    "Bcolor": "188",
    "Y": 59,
    "L": 81.447397739167,
    "a": 10.773095442411,
    "b": 7.25514317882576,
    "C": 12.988328913165,
    "h": 0.59268419762104,
    "CMY_C": 0.1057553,
    "CMY_M": 0.2341688,
    "CMY_Y": 0.2634326,
    "CMYK_C": 0,
    "CMYK_M": 0.1435999,
    "CMYK_Y": 0.1763246,
    "CMYK_K": 0.1057553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04188",
    "Farbtonhilfsbezeichnung": "C4.11.72",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "188",
    "Bcolor": "178",
    "Y": 56,
    "L": 79.6278875155031,
    "a": 13.8589827922194,
    "b": 9.93200810998409,
    "C": 17.0504014360901,
    "h": 0.62181175543392,
    "CMY_C": 0.0982613,
    "CMY_M": 0.2625286,
    "CMY_Y": 0.3015671,
    "CMYK_C": 0,
    "CMYK_M": 0.1821673,
    "CMYK_Y": 0.2254598,
    "CMYK_K": 0.0982613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04189",
    "Farbtonhilfsbezeichnung": "C4.19.59",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "147",
    "Bcolor": "134",
    "Y": 36,
    "L": 66.5131283082073,
    "a": 22.0204695894544,
    "b": 15.5920167890369,
    "C": 26.9816987695307,
    "h": 0.6161210453852,
    "CMY_C": 0.1818886,
    "CMY_M": 0.4247095,
    "CMY_Y": 0.4754172,
    "CMYK_C": 0,
    "CMYK_M": 0.2968066,
    "CMYK_Y": 0.358788,
    "CMYK_K": 0.1818886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04190",
    "Farbtonhilfsbezeichnung": "C2.31.59",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "138",
    "Bcolor": "121",
    "Y": 37,
    "L": 67.1069578595132,
    "a": 34.2435724864017,
    "b": 23.8069433657654,
    "C": 41.7060284497602,
    "h": 0.60751319976761,
    "CMY_C": 0.09043947,
    "CMY_M": 0.4580203,
    "CMY_Y": 0.5241761,
    "CMYK_C": 0,
    "CMYK_M": 0.4041301,
    "CMYK_Y": 0.476864,
    "CMYK_K": 0.09043947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04191",
    "Farbtonhilfsbezeichnung": "C2.38.53",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "115",
    "Bcolor": "99",
    "Y": 29,
    "L": 60.7274337667774,
    "a": 40.6991800104046,
    "b": 27.8875096798336,
    "C": 49.3369683874286,
    "h": 0.6007310803252,
    "CMY_C": 0.1251978,
    "CMY_M": 0.5476691,
    "CMY_Y": 0.612994,
    "CMYK_C": 0,
    "CMYK_M": 0.4829335,
    "CMYK_Y": 0.5576074,
    "CMYK_K": 0.1251978
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04192",
    "Farbtonhilfsbezeichnung": "C3.48.48",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "94",
    "Bcolor": "78",
    "Y": 24,
    "L": 55.6283889586342,
    "a": 48.3025341255267,
    "b": 32.795122825077,
    "C": 58.3836867974227,
    "h": 0.59645997161146,
    "CMY_C": 0.1419452,
    "CMY_M": 0.6324937,
    "CMY_Y": 0.692531,
    "CMYK_C": 0,
    "CMYK_M": 0.5716984,
    "CMYK_Y": 0.6416675,
    "CMYK_K": 0.1419452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04193",
    "Farbtonhilfsbezeichnung": "C2.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "196",
    "Bcolor": "189",
    "Y": 58,
    "L": 80.7592474915223,
    "a": 7.04879975967809,
    "b": 5.38738889896078,
    "C": 8.87183956125694,
    "h": 0.65258968313784,
    "CMY_C": 0.1448565,
    "CMY_M": 0.2317609,
    "CMY_Y": 0.2578638,
    "CMYK_C": 0,
    "CMYK_M": 0.1016255,
    "CMYK_Y": 0.1321501,
    "CMYK_K": 0.1448565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04195",
    "Farbtonhilfsbezeichnung": "C3.10.69",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "179",
    "Bcolor": "171",
    "Y": 50,
    "L": 76.0009455386689,
    "a": 12.6967130343993,
    "b": 8.65504281975682,
    "C": 15.3660758845487,
    "h": 0.59832173312716,
    "CMY_C": 0.1498598,
    "CMY_M": 0.2980329,
    "CMY_Y": 0.3308064,
    "CMYK_C": 0,
    "CMYK_M": 0.1742925,
    "CMYK_Y": 0.2128432,
    "CMYK_K": 0.1498598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04196",
    "Farbtonhilfsbezeichnung": "C3.20.59",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "147",
    "Bcolor": "133",
    "Y": 36,
    "L": 66.4453155558784,
    "a": 21.6418836398599,
    "b": 15.9513110826244,
    "C": 26.885227407182,
    "h": 0.63516627461421,
    "CMY_C": 0.1842729,
    "CMY_M": 0.4244237,
    "CMY_Y": 0.4786613,
    "CMYK_C": 0,
    "CMYK_M": 0.2944009,
    "CMYK_Y": 0.3608907,
    "CMYK_K": 0.1842729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04197",
    "Farbtonhilfsbezeichnung": "C2.26.54",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "131",
    "Bcolor": "116",
    "Y": 30,
    "L": 62.0704229327408,
    "a": 27.2559660864687,
    "b": 19.3464694589377,
    "C": 33.4241464787411,
    "h": 0.61727741625289,
    "CMY_C": 0.1951203,
    "CMY_M": 0.4867044,
    "CMY_Y": 0.5443994,
    "CMYK_C": 0,
    "CMYK_M": 0.3622704,
    "CMYK_Y": 0.4339519,
    "CMYK_K": 0.1951203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04198",
    "Farbtonhilfsbezeichnung": "C5.58.46",
    "Farbtonklasse": "04",
    "Rcolor": "223",
    "Gcolor": "82",
    "Bcolor": "60",
    "Y": 22,
    "L": 54.1136522688536,
    "a": 54.0829001309082,
    "b": 41.555426372001,
    "C": 68.2042047642855,
    "h": 0.65515169541185,
    "CMY_C": 0.1249619,
    "CMY_M": 0.6781751,
    "CMY_Y": 0.7656265,
    "CMYK_C": 0,
    "CMYK_M": 0.6322161,
    "CMYK_Y": 0.7321563,
    "CMYK_K": 0.1249619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04199",
    "Farbtonhilfsbezeichnung": "C4.05.66",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "175",
    "Bcolor": "170",
    "Y": 45,
    "L": 73.0329450819372,
    "a": 6.06916939390972,
    "b": 4.28444250770512,
    "C": 7.42908236148995,
    "h": 0.61469846478096,
    "CMY_C": 0.2395898,
    "CMY_M": 0.3119097,
    "CMY_Y": 0.3319251,
    "CMYK_C": 0,
    "CMYK_M": 0.09510645,
    "CMYK_Y": 0.1214283,
    "CMYK_K": 0.2395898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04200",
    "Farbtonhilfsbezeichnung": "C2.08.70",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "184",
    "Bcolor": "177",
    "Y": 52,
    "L": 77.484121399302,
    "a": 10.901431734638,
    "b": 7.19094959610589,
    "C": 13.0595164519483,
    "h": 0.58311767168323,
    "CMY_C": 0.149263,
    "CMY_M": 0.2771834,
    "CMY_Y": 0.3050318,
    "CMYK_C": 0,
    "CMYK_M": 0.1503642,
    "CMYK_Y": 0.1830986,
    "CMYK_K": 0.149263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04201",
    "Farbtonhilfsbezeichnung": "C3.19.50",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "124",
    "Bcolor": "115",
    "Y": 25,
    "L": 57.1177874464607,
    "a": 19.6913878634918,
    "b": 12.8553111535769,
    "C": 23.5161599936246,
    "h": 0.57836859921563,
    "CMY_C": 0.3050303,
    "CMY_M": 0.5133684,
    "CMY_Y": 0.5502002,
    "CMYK_C": 0,
    "CMYK_M": 0.2997801,
    "CMYK_Y": 0.3527778,
    "CMYK_K": 0.3050303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04202",
    "Farbtonhilfsbezeichnung": "C3.20.49",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "124",
    "Bcolor": "113",
    "Y": 26,
    "L": 57.6032515562672,
    "a": 21.3488421262031,
    "b": 14.6773957794881,
    "C": 25.9075086991644,
    "h": 0.60228947141092,
    "CMY_C": 0.2868088,
    "CMY_M": 0.5135549,
    "CMY_Y": 0.5574392,
    "CMYK_C": 0,
    "CMYK_M": 0.3179316,
    "CMYK_Y": 0.379464,
    "CMYK_K": 0.2868088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04203",
    "Farbtonhilfsbezeichnung": "C4.30.49",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "121",
    "Bcolor": "106",
    "Y": 26,
    "L": 58.8628807067871,
    "a": 29.1587047576904,
    "b": 20.4887065887451,
    "C": 35.6372985839844,
    "h": 35.0942459106445,
    "CMY_C": 0.21921414136887,
    "CMY_M": 0.52544033527374,
    "CMY_Y": 0.5830180644989,
    "CMYK_C": 0,
    "CMYK_M": 0.39220252633095,
    "CMYK_Y": 0.4659458398819,
    "CMYK_K": 0.21921414136887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04204",
    "Farbtonhilfsbezeichnung": "C2.46.47",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "95",
    "Bcolor": "80",
    "Y": 24,
    "L": 56.022698282543,
    "a": 47.7848276224196,
    "b": 32.2991842002538,
    "C": 57.6769195684572,
    "h": 0.59438808612071,
    "CMY_C": 0.1402409,
    "CMY_M": 0.6259729,
    "CMY_Y": 0.6856362,
    "CMYK_C": 0,
    "CMYK_M": 0.5649629,
    "CMYK_Y": 0.6343583,
    "CMYK_K": 0.1402409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04205",
    "Farbtonhilfsbezeichnung": "C3.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "66",
    "Bcolor": "58",
    "Y": 17,
    "L": 47.9225463045309,
    "a": 53.3090705676109,
    "b": 34.5164280204482,
    "C": 63.5078011591749,
    "h": 0.57459994627315,
    "CMY_C": 0.2095487,
    "CMY_M": 0.7401105,
    "CMY_Y": 0.7723711,
    "CMYK_C": 0,
    "CMYK_M": 0.6712138,
    "CMYK_Y": 0.7120266,
    "CMYK_K": 0.2095487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04206",
    "Farbtonhilfsbezeichnung": "C4.06.59",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "159",
    "Bcolor": "154",
    "Y": 37,
    "L": 67.0302088740387,
    "a": 6.70911862896145,
    "b": 4.72908083998991,
    "C": 8.20831763326915,
    "h": 0.61398937718609,
    "CMY_C": 0.2984764,
    "CMY_M": 0.3766855,
    "CMY_Y": 0.3972842,
    "CMYK_C": 0,
    "CMYK_M": 0.1114846,
    "CMYK_Y": 0.1408474,
    "CMYK_K": 0.2984764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04207",
    "Farbtonhilfsbezeichnung": "C5.13.55",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "142",
    "Bcolor": "131",
    "Y": 31,
    "L": 62.5602780495437,
    "a": 13.5330386763666,
    "b": 11.0164255172494,
    "C": 17.4500649567025,
    "h": 0.68324306678708,
    "CMY_C": 0.2867542,
    "CMY_M": 0.4413399,
    "CMY_Y": 0.4849542,
    "CMYK_C": 0,
    "CMYK_M": 0.2167355,
    "CMYK_Y": 0.2778846,
    "CMYK_K": 0.2867542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04208",
    "Farbtonhilfsbezeichnung": "C2.21.43",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "105",
    "Bcolor": "95",
    "Y": 18,
    "L": 49.8261232286537,
    "a": 20.7260310347898,
    "b": 14.1544919233173,
    "C": 25.0981673446952,
    "h": 0.59917957618546,
    "CMY_C": 0.3760517,
    "CMY_M": 0.5888799,
    "CMY_Y": 0.628712,
    "CMYK_C": 0,
    "CMYK_M": 0.3410991,
    "CMYK_Y": 0.404938,
    "CMYK_K": 0.3760517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04209",
    "Farbtonhilfsbezeichnung": "C3.27.46",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "111",
    "Bcolor": "98",
    "Y": 22,
    "L": 54.1389938913725,
    "a": 27.1500045375513,
    "b": 18.6248859458086,
    "C": 32.9242938099428,
    "h": 0.60126763511939,
    "CMY_C": 0.286355,
    "CMY_M": 0.5662811,
    "CMY_Y": 0.6161667,
    "CMYK_C": 0,
    "CMYK_M": 0.3922484,
    "CMYK_Y": 0.4621509,
    "CMYK_K": 0.286355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04210",
    "Farbtonhilfsbezeichnung": "C4.41.40",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "94",
    "Bcolor": "82",
    "Y": 17,
    "L": 49.8812103271484,
    "a": 34.2592544555664,
    "b": 22.5182571411133,
    "C": 40.9971771240234,
    "h": 33.3165092468262,
    "CMY_C": 0.2916207909584,
    "CMY_M": 0.63284349441528,
    "CMY_Y": 0.68038618564606,
    "CMYK_C": 0,
    "CMYK_M": 0.48169496655464,
    "CMYK_Y": 0.54880970716476,
    "CMYK_K": 0.2916207909584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04211",
    "Farbtonhilfsbezeichnung": "C3.42.43",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "91",
    "Bcolor": "75",
    "Y": 19,
    "L": 51.1248066482117,
    "a": 40.2846154431909,
    "b": 28.4594194065422,
    "C": 49.323308834295,
    "h": 0.61504756145917,
    "CMY_C": 0.2402031,
    "CMY_M": 0.6442596,
    "CMY_Y": 0.7069546,
    "CMYK_C": 0,
    "CMYK_M": 0.5317953,
    "CMYK_Y": 0.6143109,
    "CMYK_K": 0.2402031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04212",
    "Farbtonhilfsbezeichnung": "C4.61.36",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "65",
    "Bcolor": "52",
    "Y": 15,
    "L": 45.6617169963691,
    "a": 50.1044395992272,
    "b": 35.0108062861943,
    "C": 61.1245566393903,
    "h": 0.60989095908918,
    "CMY_C": 0.2518601,
    "CMY_M": 0.7470446,
    "CMY_Y": 0.7969279,
    "CMYK_C": 0,
    "CMYK_M": 0.6618876,
    "CMYK_Y": 0.728564,
    "CMYK_K": 0.2518601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04213",
    "Farbtonhilfsbezeichnung": "C3.09.49",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "129",
    "Bcolor": "123",
    "Y": 24,
    "L": 56.2503617449476,
    "a": 9.28414642441638,
    "b": 6.41808515475359,
    "C": 11.2865934578894,
    "h": 0.60485984308855,
    "CMY_C": 0.391096,
    "CMY_M": 0.4936306,
    "CMY_Y": 0.517179,
    "CMYK_C": 0,
    "CMYK_M": 0.168392,
    "CMYK_Y": 0.2070654,
    "CMYK_K": 0.391096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04214",
    "Farbtonhilfsbezeichnung": "C3.15.47",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "121",
    "Bcolor": "111",
    "Y": 22,
    "L": 54.4943023574046,
    "a": 15.0520689832797,
    "b": 10.906008237221,
    "C": 18.587786214279,
    "h": 0.62701454719106,
    "CMY_C": 0.3644544,
    "CMY_M": 0.5267093,
    "CMY_Y": 0.5634851,
    "CMYK_C": 0,
    "CMYK_M": 0.2553001,
    "CMYK_Y": 0.3131651,
    "CMYK_K": 0.3644544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04215",
    "Farbtonhilfsbezeichnung": "C2.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "89",
    "Bcolor": "76",
    "Y": 16,
    "L": 47.2548356686363,
    "a": 32.0203396871038,
    "b": 21.8530985660018,
    "C": 38.7667392311102,
    "h": 0.59886750169144,
    "CMY_C": 0.3336787,
    "CMY_M": 0.6508557,
    "CMY_Y": 0.7006907,
    "CMYK_C": 0,
    "CMYK_M": 0.4760121,
    "CMYK_Y": 0.5508034,
    "CMYK_K": 0.3336787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04216",
    "Farbtonhilfsbezeichnung": "C3.51.39",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "77",
    "Bcolor": "65",
    "Y": 16,
    "L": 47.3307119753821,
    "a": 43.834897884777,
    "b": 29.1748466937266,
    "C": 52.6561482846142,
    "h": 0.58723751372112,
    "CMY_C": 0.2665091,
    "CMY_M": 0.6977314,
    "CMY_Y": 0.7450761,
    "CMYK_C": 0,
    "CMYK_M": 0.5879041,
    "CMYK_Y": 0.6524512,
    "CMYK_K": 0.2665091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04217",
    "Farbtonhilfsbezeichnung": "C4.52.36",
    "Farbtonklasse": "04",
    "Rcolor": "182",
    "Gcolor": "72",
    "Bcolor": "57",
    "Y": 15,
    "L": 45.3782853581682,
    "a": 44.0117456757644,
    "b": 31.0558488119876,
    "C": 53.8655688066245,
    "h": 0.61449208614195,
    "CMY_C": 0.2871506,
    "CMY_M": 0.7188808,
    "CMY_Y": 0.7749522,
    "CMYK_C": 0,
    "CMYK_M": 0.6056401,
    "CMYK_Y": 0.6842983,
    "CMYK_K": 0.2871506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04218",
    "Farbtonhilfsbezeichnung": "C4.71.33",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "47",
    "Bcolor": "43",
    "Y": 13,
    "L": 43.1723498417657,
    "a": 56.2960101184544,
    "b": 37.3553068286039,
    "C": 67.5622653817666,
    "h": 0.58584290789216,
    "CMY_C": 0.2518003,
    "CMY_M": 0.8149678,
    "CMY_Y": 0.8319386,
    "CMYK_C": 0,
    "CMYK_M": 0.7526967,
    "CMYK_Y": 0.775379,
    "CMYK_K": 0.2518003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04219",
    "Farbtonhilfsbezeichnung": "C4.16.39",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "101",
    "Bcolor": "93",
    "Y": 16,
    "L": 46.8177307393849,
    "a": 15.0546623971085,
    "b": 10.7095230535209,
    "C": 18.4753009156768,
    "h": 0.61832002179076,
    "CMY_C": 0.4458499,
    "CMY_M": 0.602035,
    "CMY_Y": 0.6356072,
    "CMYK_C": 0,
    "CMYK_M": 0.2818463,
    "CMYK_Y": 0.3424294,
    "CMYK_K": 0.4458499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04220",
    "Farbtonhilfsbezeichnung": "C5.20.39",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "99",
    "Bcolor": "90",
    "Y": 16,
    "L": 46.3380237899138,
    "a": 16.975125034039,
    "b": 11.7863132509275,
    "C": 20.6657216174574,
    "h": 0.60690944394948,
    "CMY_C": 0.4381123,
    "CMY_M": 0.6119583,
    "CMY_Y": 0.6467568,
    "CMYK_C": 0,
    "CMYK_M": 0.3093964,
    "CMYK_Y": 0.3713278,
    "CMYK_K": 0.4381123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04221",
    "Farbtonhilfsbezeichnung": "C4.56.34",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "64",
    "Bcolor": "51",
    "Y": 12,
    "L": 41.5271753301441,
    "a": 42.3906104988078,
    "b": 29.9085980610538,
    "C": 51.8795537417132,
    "h": 0.61443956219175,
    "CMY_C": 0.3409049,
    "CMY_M": 0.750414,
    "CMY_Y": 0.8016406,
    "CMYK_C": 0,
    "CMYK_M": 0.6213201,
    "CMYK_Y": 0.6990428,
    "CMYK_K": 0.3409049
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04222",
    "Farbtonhilfsbezeichnung": "C5.61.33",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "56",
    "Bcolor": "45",
    "Y": 13,
    "L": 42.3321318134543,
    "a": 49.640677034641,
    "b": 34.4241098856073,
    "C": 60.408742396063,
    "h": 0.60632709394818,
    "CMY_C": 0.294434,
    "CMY_M": 0.7804265,
    "CMY_Y": 0.8221263,
    "CMYK_C": 0,
    "CMYK_M": 0.6887981,
    "CMYK_Y": 0.7478992,
    "CMYK_K": 0.294434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04223",
    "Farbtonhilfsbezeichnung": "C3.62.32",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "53",
    "Bcolor": "49",
    "Y": 13,
    "L": 42.1783930703068,
    "a": 51.1311678857163,
    "b": 32.3655896280699,
    "C": 60.5138638770482,
    "h": 0.56432531271729,
    "CMY_C": 0.2906438,
    "CMY_M": 0.7905421,
    "CMY_Y": 0.8090538,
    "CMYK_C": 0,
    "CMYK_M": 0.7047211,
    "CMYK_Y": 0.7308177,
    "CMYK_K": 0.2906438
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04224",
    "Farbtonhilfsbezeichnung": "C4.09.36",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "100",
    "Bcolor": "96",
    "Y": 14,
    "L": 44.2997011413639,
    "a": 7.45050271726799,
    "b": 4.78620206065848,
    "C": 8.85537807806472,
    "h": 0.57101386278865,
    "CMY_C": 0.5285163,
    "CMY_M": 0.6063699,
    "CMY_Y": 0.6223639,
    "CMYK_C": 0,
    "CMYK_M": 0.1651247,
    "CMYK_Y": 0.1990474,
    "CMYK_K": 0.5285163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04225",
    "Farbtonhilfsbezeichnung": "C3.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "78",
    "Bcolor": "71",
    "Y": 10,
    "L": 37.0345620234774,
    "a": 14.7329831273009,
    "b": 10.1201371849399,
    "C": 17.87394663949,
    "h": 0.60188216030614,
    "CMY_C": 0.549243,
    "CMY_M": 0.6937734,
    "CMY_Y": 0.7219667,
    "CMYK_C": 0,
    "CMYK_M": 0.3206392,
    "CMYK_Y": 0.3831858,
    "CMYK_K": 0.549243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04226",
    "Farbtonhilfsbezeichnung": "C3.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "77",
    "Bcolor": "67",
    "Y": 12,
    "L": 39.0230313506211,
    "a": 22.6052771672557,
    "b": 15.5857542506911,
    "C": 27.457499729061,
    "h": 0.60362664758605,
    "CMY_C": 0.4795131,
    "CMY_M": 0.6982363,
    "CMY_Y": 0.7368854,
    "CMYK_C": 0,
    "CMYK_M": 0.420228,
    "CMYK_Y": 0.4944838,
    "CMYK_K": 0.4795131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04227",
    "Farbtonhilfsbezeichnung": "C4.42.28",
    "Farbtonklasse": "04",
    "Rcolor": "138",
    "Gcolor": "69",
    "Bcolor": "58",
    "Y": 10,
    "L": 37.7052662608888,
    "a": 28.5749693472119,
    "b": 19.7050569001325,
    "C": 34.7104903542367,
    "h": 0.60370620458827,
    "CMY_C": 0.4590959,
    "CMY_M": 0.7305308,
    "CMY_Y": 0.7731632,
    "CMYK_C": 0,
    "CMYK_M": 0.5018171,
    "CMYK_Y": 0.580634,
    "CMYK_K": 0.4590959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04229",
    "Farbtonhilfsbezeichnung": "C3.56.32",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "66",
    "Bcolor": "62",
    "Y": 12,
    "L": 41.784309387207,
    "a": 41.0867118835449,
    "b": 23.1708221435547,
    "C": 47.1699562072754,
    "h": 29.4207935333252,
    "CMY_C": 0.34962558746338,
    "CMY_M": 0.7403359413147,
    "CMY_Y": 0.75609409809113,
    "CMYK_C": 0,
    "CMYK_M": 0.60074681043625,
    "CMYK_Y": 0.62497615814209,
    "CMYK_K": 0.34962558746338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04230",
    "Farbtonhilfsbezeichnung": "C5.57.31",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "60",
    "Bcolor": "47",
    "Y": 10,
    "L": 38.6250998241217,
    "a": 38.9125393439627,
    "b": 27.8982192516921,
    "C": 47.8800204219978,
    "h": 0.62200931719441,
    "CMY_C": 0.3922681,
    "CMY_M": 0.7633669,
    "CMY_Y": 0.8146957,
    "CMYK_C": 0,
    "CMYK_M": 0.6106291,
    "CMYK_Y": 0.6950887,
    "CMYK_K": 0.3922681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04231",
    "Farbtonhilfsbezeichnung": "C3.66.32",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "47",
    "Bcolor": "44",
    "Y": 12,
    "L": 40.5765338434,
    "a": 51.8903442821996,
    "b": 33.3868736043294,
    "C": 61.7032507960211,
    "h": 0.57173003370913,
    "CMY_C": 0.3057417,
    "CMY_M": 0.8138923,
    "CMY_Y": 0.8292782,
    "CMYK_C": 0,
    "CMYK_M": 0.7319331,
    "CMYK_Y": 0.7540947,
    "CMYK_K": 0.3057417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04232",
    "Farbtonhilfsbezeichnung": "C5.11.23",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "71",
    "Bcolor": "67",
    "Y": 7,
    "L": 31.9431219370624,
    "a": 6.82645403272614,
    "b": 5.12873029213696,
    "C": 8.53840436325232,
    "h": 0.64433402962879,
    "CMY_C": 0.6517686,
    "CMY_M": 0.7204454,
    "CMY_Y": 0.7380705,
    "CMYK_C": 0,
    "CMYK_M": 0.1972159,
    "CMYK_Y": 0.2478292,
    "CMYK_K": 0.6517686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04233",
    "Farbtonhilfsbezeichnung": "C4.20.29",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "78",
    "Bcolor": "70",
    "Y": 9,
    "L": 36.8799636471699,
    "a": 14.8574061748599,
    "b": 10.665182176215,
    "C": 18.2890302940484,
    "h": 0.6225964570137,
    "CMY_C": 0.5492601,
    "CMY_M": 0.6956448,
    "CMY_Y": 0.7267196,
    "CMYK_C": 0,
    "CMYK_M": 0.3247653,
    "CMYK_Y": 0.393707,
    "CMYK_K": 0.5492601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04234",
    "Farbtonhilfsbezeichnung": "C3.30.22",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "59",
    "Bcolor": "51",
    "Y": 6,
    "L": 30.4105426260585,
    "a": 19.5681064330292,
    "b": 13.5089438742194,
    "C": 23.7781907211455,
    "h": 0.60422356700588,
    "CMY_C": 0.5869203,
    "CMY_M": 0.7681315,
    "CMY_Y": 0.7999493,
    "CMYK_C": 0,
    "CMYK_M": 0.4386835,
    "CMYK_Y": 0.5157093,
    "CMYK_K": 0.5869203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04235",
    "Farbtonhilfsbezeichnung": "C3.36.24",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "61",
    "Bcolor": "52",
    "Y": 7,
    "L": 32.8291245007995,
    "a": 24.343294734601,
    "b": 16.1689019380861,
    "C": 29.2237812135784,
    "h": 0.58629540579593,
    "CMY_C": 0.5356349,
    "CMY_M": 0.7612261,
    "CMY_Y": 0.7944183,
    "CMYK_C": 0,
    "CMYK_M": 0.4858057,
    "CMYK_Y": 0.5572842,
    "CMYK_K": 0.5356349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04236",
    "Farbtonhilfsbezeichnung": "C4.46.24",
    "Farbtonklasse": "04",
    "Rcolor": "126",
    "Gcolor": "57",
    "Bcolor": "47",
    "Y": 8,
    "L": 33.035328565,
    "a": 29.5857234258263,
    "b": 20.4098621968942,
    "C": 35.9426975271153,
    "h": 0.6038848076236,
    "CMY_C": 0.504327,
    "CMY_M": 0.7781052,
    "CMY_Y": 0.8175438,
    "CMYK_C": 0,
    "CMYK_M": 0.5523363,
    "CMYK_Y": 0.6319021,
    "CMYK_K": 0.504327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04237",
    "Farbtonhilfsbezeichnung": "C4.51.27",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "58",
    "Bcolor": "47",
    "Y": 10,
    "L": 37.0517775824806,
    "a": 37.9284648431193,
    "b": 25.6114234056154,
    "C": 45.7658546759201,
    "h": 0.59392551439121,
    "CMY_C": 0.4165261,
    "CMY_M": 0.7741337,
    "CMY_Y": 0.8137308,
    "CMYK_C": 0,
    "CMYK_M": 0.6128939,
    "CMYK_Y": 0.6807583,
    "CMYK_K": 0.4165261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04238",
    "Farbtonhilfsbezeichnung": "C2.56.28",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "51",
    "Bcolor": "47",
    "Y": 9,
    "L": 36.3007625968502,
    "a": 41.9635496890225,
    "b": 25.3685966325388,
    "C": 49.0357542779502,
    "h": 0.54375021791458,
    "CMY_C": 0.4066418,
    "CMY_M": 0.8006572,
    "CMY_Y": 0.8173077,
    "CMYK_C": 0,
    "CMYK_M": 0.6640431,
    "CMYK_Y": 0.6921045,
    "CMYK_K": 0.4066418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04239",
    "Farbtonhilfsbezeichnung": "C4.62.29",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "53",
    "Bcolor": "48",
    "Y": 10,
    "L": 38.0062831376331,
    "a": 43.8881222216462,
    "b": 27.0863199721346,
    "C": 51.5735979138067,
    "h": 0.55294707423476,
    "CMY_C": 0.3768944,
    "CMY_M": 0.7933266,
    "CMY_Y": 0.8130879,
    "CMYK_C": 0,
    "CMYK_M": 0.6683171,
    "CMYK_Y": 0.7000314,
    "CMYK_K": 0.3768944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04240",
    "Farbtonhilfsbezeichnung": "C2.05.21",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "68",
    "Bcolor": "67",
    "Y": 6,
    "L": 29.6883725951428,
    "a": 3.12734567185027,
    "b": 1.42950715472264,
    "C": 3.43857261907377,
    "h": 0.42874190288816,
    "CMY_C": 0.702625,
    "CMY_M": 0.7321049,
    "CMY_Y": 0.736348,
    "CMYK_C": 0,
    "CMYK_M": 0.09913372,
    "CMYK_Y": 0.1134021,
    "CMYK_K": 0.702625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04241",
    "Farbtonhilfsbezeichnung": "C3.23.20",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 6,
    "L": 30.4295011792633,
    "a": 13.227014280777,
    "b": 7.27447448850364,
    "C": 15.0954259915966,
    "h": 0.50282095840438,
    "CMY_C": 0.627561,
    "CMY_M": 0.7495832,
    "CMY_Y": 0.7634152,
    "CMYK_C": 0,
    "CMYK_M": 0.32763,
    "CMYK_Y": 0.3647691,
    "CMYK_K": 0.627561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04242",
    "Farbtonhilfsbezeichnung": "C3.25.17",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "58",
    "Bcolor": "52",
    "Y": 6,
    "L": 28.1571008124031,
    "a": 14.0931689895373,
    "b": 9.26961074538955,
    "C": 16.8684052458641,
    "h": 0.58179561921157,
    "CMY_C": 0.6421906,
    "CMY_M": 0.7724622,
    "CMY_Y": 0.7948354,
    "CMYK_C": 0,
    "CMYK_M": 0.3640808,
    "CMYK_Y": 0.4266093,
    "CMYK_K": 0.6421906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04243",
    "Farbtonhilfsbezeichnung": "C3.34.18",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "55",
    "Bcolor": "49",
    "Y": 6,
    "L": 28.5838296714996,
    "a": 20.1397608542304,
    "b": 12.1071837560597,
    "C": 23.498805624299,
    "h": 0.54127073284093,
    "CMY_C": 0.6044239,
    "CMY_M": 0.7859056,
    "CMY_Y": 0.8069881,
    "CMYK_C": 0,
    "CMYK_M": 0.45877829999999997,
    "CMYK_Y": 0.5120741,
    "CMYK_K": 0.6044239
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04244",
    "Farbtonhilfsbezeichnung": "C3.41.22",
    "Farbtonklasse": "04",
    "Rcolor": "117",
    "Gcolor": "55",
    "Bcolor": "48",
    "Y": 7,
    "L": 31.1515553625927,
    "a": 27.1026843643652,
    "b": 16.9239128135199,
    "C": 31.9526888488907,
    "h": 0.55819419695822,
    "CMY_C": 0.5394636,
    "CMY_M": 0.7860093,
    "CMY_Y": 0.8127177,
    "CMYK_C": 0,
    "CMYK_M": 0.5353447,
    "CMYK_Y": 0.5933389,
    "CMYK_K": 0.5394636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04245",
    "Farbtonhilfsbezeichnung": "C2.50.23",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "51",
    "Bcolor": "49",
    "Y": 7,
    "L": 32.5913097605211,
    "a": 34.0982100067713,
    "b": 18.254882266552,
    "C": 38.6772368743109,
    "h": 0.49153532445652,
    "CMY_C": 0.4901658,
    "CMY_M": 0.7994993,
    "CMY_Y": 0.8069142,
    "CMYK_C": 0,
    "CMYK_M": 0.6067334,
    "CMYK_Y": 0.6212773,
    "CMYK_K": 0.4901658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04246",
    "Farbtonhilfsbezeichnung": "C4.53.28",
    "Farbtonklasse": "04",
    "Rcolor": "145",
    "Gcolor": "54",
    "Bcolor": "45",
    "Y": 9,
    "L": 35.6940490624002,
    "a": 38.4239597910061,
    "b": 25.5415549956759,
    "C": 46.1386141709739,
    "h": 0.58666056708803,
    "CMY_C": 0.4296814,
    "CMY_M": 0.7897591,
    "CMY_Y": 0.8246868,
    "CMYK_C": 0,
    "CMYK_M": 0.6313623,
    "CMYK_Y": 0.6926048,
    "CMYK_K": 0.4296814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04247",
    "Farbtonhilfsbezeichnung": "C3.61.27",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "51",
    "Bcolor": "48",
    "Y": 11,
    "L": 37.442523589581,
    "a": 44.0957449896384,
    "b": 26.2837169232756,
    "C": 51.3348663336538,
    "h": 0.53751752494313,
    "CMY_C": 0.3830453,
    "CMY_M": 0.8001283,
    "CMY_Y": 0.8127055,
    "CMYK_C": 0,
    "CMYK_M": 0.6760351,
    "CMYK_Y": 0.6964209,
    "CMYK_K": 0.3830453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04248",
    "Farbtonhilfsbezeichnung": "C7.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "211",
    "Bcolor": "197",
    "Y": 72,
    "L": 87.7420549357213,
    "a": 12.5825338982219,
    "b": 11.4510444395802,
    "C": 17.013129578568,
    "h": 0.73835337557929,
    "CMY_C": 0.01101273,
    "CMY_M": 0.1712756,
    "CMY_Y": 0.2261955,
    "CMYK_C": 0,
    "CMYK_M": 0.1620475,
    "CMYK_Y": 0.2175789,
    "CMYK_K": 0.01101273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04249",
    "Farbtonhilfsbezeichnung": "C6.12.78",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "203",
    "Bcolor": "190",
    "Y": 67,
    "L": 85.4787767245879,
    "a": 14.974175683531,
    "b": 12.0701937261382,
    "C": 19.2331878269765,
    "h": 0.67842959620454,
    "CMY_C": 0.01899207,
    "CMY_M": 0.2025833,
    "CMY_Y": 0.2546404,
    "CMYK_C": 0,
    "CMYK_M": 0.1871455,
    "CMYK_Y": 0.2402104,
    "CMYK_K": 0.01899207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04250",
    "Farbtonhilfsbezeichnung": "C6.13.74",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "191",
    "Bcolor": "177",
    "Y": 59,
    "L": 81.3168691989996,
    "a": 16.3670311650315,
    "b": 13.0310528311046,
    "C": 20.920995364565,
    "h": 0.67240545839417,
    "CMY_C": 0.05502715,
    "CMY_M": 0.2517962,
    "CMY_Y": 0.3056438,
    "CMYK_C": 0,
    "CMYK_M": 0.2082272,
    "CMYK_Y": 0.2652104,
    "CMYK_K": 0.05502715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04251",
    "Farbtonhilfsbezeichnung": "C7.46.55",
    "Farbtonklasse": "04",
    "Rcolor": "233",
    "Gcolor": "119",
    "Bcolor": "87",
    "Y": 31,
    "L": 62.7053868312132,
    "a": 42.0763211182165,
    "b": 37.1360025331447,
    "C": 56.1204016645017,
    "h": 0.72311078573736,
    "CMY_C": 0.08437747,
    "CMY_M": 0.5342802,
    "CMY_Y": 0.6585653,
    "CMYK_C": 0,
    "CMYK_M": 0.4913627,
    "CMYK_Y": 0.6271011,
    "CMYK_K": 0.08437747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04252",
    "Farbtonhilfsbezeichnung": "C7.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "220",
    "Bcolor": "211",
    "Y": 75,
    "L": 89.4329147338867,
    "a": 6.86068296432495,
    "b": 6.36609888076782,
    "C": 9.35928344726563,
    "h": 42.8585586547852,
    "CMY_C": 0.04632568359375,
    "CMY_M": 0.13654059171677,
    "CMY_Y": 0.17134249210358,
    "CMYK_C": 0,
    "CMYK_M": 0.09459719061852,
    "CMYK_Y": 0.13108962774277,
    "CMYK_K": 0.04632568359375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04253",
    "Farbtonhilfsbezeichnung": "C6.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "210",
    "Bcolor": "201",
    "Y": 68,
    "L": 85.7840701782171,
    "a": 7.21080047595191,
    "b": 6.22117144819365,
    "C": 9.52358218801141,
    "h": 0.71185392363425,
    "CMY_C": 0.08529708,
    "CMY_M": 0.1776206,
    "CMY_Y": 0.2098657,
    "CMYK_C": 0,
    "CMYK_M": 0.1009328,
    "CMYK_Y": 0.1361848,
    "CMYK_K": 0.08529708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04254",
    "Farbtonhilfsbezeichnung": "C6.15.73",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "189",
    "Bcolor": "174",
    "Y": 59,
    "L": 81.253150202912,
    "a": 18.331789321216,
    "b": 14.8247171967983,
    "C": 23.5759780217597,
    "h": 0.68001672942139,
    "CMY_C": 0.03882617,
    "CMY_M": 0.2582951,
    "CMY_Y": 0.3189421,
    "CMYK_C": 0,
    "CMYK_M": 0.2283342,
    "CMYK_Y": 0.2914311,
    "CMYK_K": 0.03882617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04255",
    "Farbtonhilfsbezeichnung": "C6.19.74",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "185",
    "Bcolor": "166",
    "Y": 59,
    "L": 81.0830816236608,
    "a": 22.844431470624,
    "b": 18.9135461388146,
    "C": 29.6578872605772,
    "h": 0.69153979509381,
    "CMY_C": 0.003324183,
    "CMY_M": 0.2738439,
    "CMY_Y": 0.3494791,
    "CMYK_C": 0,
    "CMYK_M": 0.271422,
    "CMYK_Y": 0.3473094,
    "CMYK_K": 0.003324183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04256",
    "Farbtonhilfsbezeichnung": "C7.25.65",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "158",
    "Bcolor": "136",
    "Y": 44,
    "L": 72.5272523647139,
    "a": 27.3848094041493,
    "b": 23.047868708726,
    "C": 35.7929048571956,
    "h": 0.69961455308656,
    "CMY_C": 0.0678789,
    "CMY_M": 0.3794055,
    "CMY_Y": 0.4661382,
    "CMYK_C": 0,
    "CMYK_M": 0.3342126,
    "CMYK_Y": 0.4272614,
    "CMYK_K": 0.0678789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04257",
    "Farbtonhilfsbezeichnung": "C6.39.59",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "131",
    "Bcolor": "103",
    "Y": 37,
    "L": 66.9766948798432,
    "a": 40.8403464952291,
    "b": 34.0593975561292,
    "C": 53.1787219077032,
    "h": 0.69511062945182,
    "CMY_C": 0.04243092,
    "CMY_M": 0.4845422,
    "CMY_Y": 0.5959964,
    "CMYK_C": 0,
    "CMYK_M": 0.4617017,
    "CMYK_Y": 0.5780946,
    "CMYK_K": 0.04243092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04258",
    "Farbtonhilfsbezeichnung": "C7.48.55",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "114",
    "Bcolor": "80",
    "Y": 32,
    "L": 62.9699096986371,
    "a": 47.3548738913472,
    "b": 41.3138116102156,
    "C": 62.8435765295848,
    "h": 0.7173725569901,
    "CMY_C": 0.04962879,
    "CMY_M": 0.55317,
    "CMY_Y": 0.684384,
    "CMYK_C": 0,
    "CMYK_M": 0.5298364,
    "CMYK_Y": 0.6679025,
    "CMYK_K": 0.04962879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04259",
    "Farbtonhilfsbezeichnung": "C6.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "202",
    "Bcolor": "194",
    "Y": 62,
    "L": 82.8207856414677,
    "a": 6.42389962667272,
    "b": 5.67719402960056,
    "C": 8.57304021122602,
    "h": 0.72377067231604,
    "CMY_C": 0.1256522,
    "CMY_M": 0.2079091,
    "CMY_Y": 0.237963,
    "CMYK_C": 0,
    "CMYK_M": 0.09407801,
    "CMYK_Y": 0.128451,
    "CMYK_K": 0.1256522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04260",
    "Farbtonhilfsbezeichnung": "C7.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "195",
    "Bcolor": "186",
    "Y": 58,
    "L": 80.8230806895623,
    "a": 8.38742557553795,
    "b": 7.10520715445524,
    "C": 10.9924008520846,
    "h": 0.70282325186435,
    "CMY_C": 0.1298711,
    "CMY_M": 0.234857,
    "CMY_Y": 0.2693758,
    "CMYK_C": 0,
    "CMYK_M": 0.1206555,
    "CMYK_Y": 0.1603264,
    "CMYK_K": 0.1298711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04261",
    "Farbtonhilfsbezeichnung": "C7.09.71",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "184",
    "Bcolor": "173",
    "Y": 52,
    "L": 77.5317739416538,
    "a": 10.7149629853847,
    "b": 9.32167121881888,
    "C": 14.2022528526259,
    "h": 0.7159727036946,
    "CMY_C": 0.1445859,
    "CMY_M": 0.2767597,
    "CMY_Y": 0.3197985,
    "CMYK_C": 0,
    "CMYK_M": 0.1545145,
    "CMYK_Y": 0.2048278,
    "CMYK_K": 0.1445859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04262",
    "Farbtonhilfsbezeichnung": "C7.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "174",
    "Bcolor": "153",
    "Y": 51,
    "L": 76.7219836969298,
    "a": 21.7350239700879,
    "b": 19.3846889747386,
    "C": 29.1234859456702,
    "h": 0.72830193733692,
    "CMY_C": 0.0600404,
    "CMY_M": 0.3175407,
    "CMY_Y": 0.3983442,
    "CMYK_C": 0,
    "CMYK_M": 0.2739483,
    "CMYK_Y": 0.3599131,
    "CMYK_K": 0.0600404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04263",
    "Farbtonhilfsbezeichnung": "C6.22.61",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "153",
    "Bcolor": "136",
    "Y": 39,
    "L": 69.0137786865234,
    "a": 22.8354473114014,
    "b": 18.0262413024902,
    "C": 29.0930061340332,
    "h": 38.287467956543,
    "CMY_C": 0.14420825242996,
    "CMY_M": 0.40158420801163,
    "CMY_Y": 0.46707779169083,
    "CMYK_C": 0,
    "CMYK_M": 0.30074602365494,
    "CMYK_Y": 0.37727582454681,
    "CMYK_K": 0.14420825242996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04264",
    "Farbtonhilfsbezeichnung": "C7.27.63",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "154",
    "Bcolor": "130",
    "Y": 42,
    "L": 71.1718480923964,
    "a": 27.7430285147107,
    "b": 24.735472800875,
    "C": 37.1687939789668,
    "h": 0.72815054054161,
    "CMY_C": 0.0789097,
    "CMY_M": 0.395128,
    "CMY_Y": 0.4916764,
    "CMYK_C": 0,
    "CMYK_M": 0.3433087,
    "CMYK_Y": 0.4481284,
    "CMYK_K": 0.0789097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04265",
    "Farbtonhilfsbezeichnung": "C6.46.57",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "121",
    "Bcolor": "89",
    "Y": 34,
    "L": 64.7340411108282,
    "a": 45.3960743668385,
    "b": 38.650484075058,
    "C": 59.6209987098157,
    "h": 0.70530967671842,
    "CMY_C": 0.04059252,
    "CMY_M": 0.526227,
    "CMY_Y": 0.6490366,
    "CMYK_C": 0,
    "CMYK_M": 0.5061817,
    "CMYK_Y": 0.6341873,
    "CMYK_K": 0.04059252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04266",
    "Farbtonhilfsbezeichnung": "C7.49.50",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "108",
    "Bcolor": "80",
    "Y": 27,
    "L": 59.0956382751465,
    "a": 43.4781494140625,
    "b": 36.4268379211426,
    "C": 56.7209320068359,
    "h": 39.9569282531738,
    "CMY_C": 0.12141305208206,
    "CMY_M": 0.57687950134277,
    "CMY_Y": 0.68711709976196,
    "CMYK_C": 0,
    "CMYK_M": 0.51840794086456,
    "CMYK_Y": 0.64387941360474,
    "CMYK_K": 0.12141305208206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04267",
    "Farbtonhilfsbezeichnung": "C7.05.72",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "193",
    "Bcolor": "184",
    "Y": 56,
    "L": 79.4179170953209,
    "a": 6.37774466017327,
    "b": 6.01897695499496,
    "C": 8.76947606959099,
    "h": 0.75646570817778,
    "CMY_C": 0.1627139,
    "CMY_M": 0.2447845,
    "CMY_Y": 0.2768161,
    "CMYK_C": 0,
    "CMYK_M": 0.09801975,
    "CMYK_Y": 0.1362763,
    "CMYK_K": 0.1627139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04268",
    "Farbtonhilfsbezeichnung": "C6.06.67",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "180",
    "Bcolor": "173",
    "Y": 48,
    "L": 74.8302175880199,
    "a": 6.81650330697003,
    "b": 5.24915044410996,
    "C": 8.6033887346111,
    "h": 0.65621950667268,
    "CMY_C": 0.2120872,
    "CMY_M": 0.294863,
    "CMY_Y": 0.3197789,
    "CMYK_C": 0,
    "CMYK_M": 0.1050571,
    "CMYK_Y": 0.1366798,
    "CMYK_K": 0.2120872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04269",
    "Farbtonhilfsbezeichnung": "C6.12.63",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "164",
    "Bcolor": "152",
    "Y": 41,
    "L": 70.4952630945414,
    "a": 13.0377348255696,
    "b": 10.9872403879466,
    "C": 17.0499847719696,
    "h": 0.70025604682331,
    "CMY_C": 0.2031427,
    "CMY_M": 0.3577732,
    "CMY_Y": 0.4043874,
    "CMYK_C": 0,
    "CMYK_M": 0.1940504,
    "CMYK_Y": 0.252548,
    "CMYK_K": 0.2031427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04270",
    "Farbtonhilfsbezeichnung": "C7.55.49",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "100",
    "Bcolor": "69",
    "Y": 26,
    "L": 58.0447784764702,
    "a": 47.8924422792719,
    "b": 40.9682471485417,
    "C": 63.0244658993425,
    "h": 0.70763338526043,
    "CMY_C": 0.1077784,
    "CMY_M": 0.6070299,
    "CMY_Y": 0.7278086,
    "CMYK_C": 0,
    "CMYK_M": 0.5595599,
    "CMYK_Y": 0.6949285,
    "CMYK_K": 0.1077784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04271",
    "Farbtonhilfsbezeichnung": "C7.40.55",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "122",
    "Bcolor": "92",
    "Y": 31,
    "L": 62.7327138612969,
    "a": 38.5828705701036,
    "b": 34.4480274146655,
    "C": 51.7233457366295,
    "h": 0.72884082155997,
    "CMY_C": 0.1053707,
    "CMY_M": 0.520597,
    "CMY_Y": 0.6402404,
    "CMYK_C": 0,
    "CMYK_M": 0.4641323,
    "CMYK_Y": 0.5978674,
    "CMYK_K": 0.1053707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04272",
    "Farbtonhilfsbezeichnung": "C7.39.59",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "133",
    "Bcolor": "102",
    "Y": 36,
    "L": 66.5734452978367,
    "a": 38.1622455461594,
    "b": 34.0814102649051,
    "C": 51.1654132277865,
    "h": 0.72897101891615,
    "CMY_C": 0.06191204,
    "CMY_M": 0.479179,
    "CMY_Y": 0.6008195,
    "CMYK_C": 0,
    "CMYK_M": 0.4448058,
    "CMYK_Y": 0.5744743,
    "CMYK_K": 0.06191204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04273",
    "Farbtonhilfsbezeichnung": "C6.30.52",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "123",
    "Bcolor": "104",
    "Y": 28,
    "L": 59.9325333253651,
    "a": 29.3152575796293,
    "b": 23.3409165805651,
    "C": 37.4724260461063,
    "h": 0.67242183526228,
    "CMY_C": 0.2021061,
    "CMY_M": 0.5157777,
    "CMY_Y": 0.5921347,
    "CMYK_C": 0,
    "CMYK_M": 0.3931244,
    "CMYK_Y": 0.4888226,
    "CMYK_K": 0.2021061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04274",
    "Farbtonhilfsbezeichnung": "C5.19.54",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "135",
    "Bcolor": "121",
    "Y": 30,
    "L": 61.4060749877076,
    "a": 19.1008679890619,
    "b": 15.116269593747,
    "C": 24.3586691829912,
    "h": 0.66946993215945,
    "CMY_C": 0.2572756,
    "CMY_M": 0.4688891,
    "CMY_Y": 0.5235309,
    "CMYK_C": 0,
    "CMYK_M": 0.2849153,
    "CMYK_Y": 0.3584847,
    "CMYK_K": 0.2572756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04275",
    "Farbtonhilfsbezeichnung": "C6.11.64",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "167",
    "Bcolor": "158",
    "Y": 43,
    "L": 71.487748736374,
    "a": 11.6166753768194,
    "b": 9.08762944958501,
    "C": 14.7489713479743,
    "h": 0.66384958173418,
    "CMY_C": 0.2059848,
    "CMY_M": 0.3432187,
    "CMY_Y": 0.3810388,
    "CMYK_C": 0,
    "CMYK_M": 0.1728353,
    "CMYK_Y": 0.2204668,
    "CMYK_K": 0.2059848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04276",
    "Farbtonhilfsbezeichnung": "C6.07.63",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "167",
    "Bcolor": "160",
    "Y": 41,
    "L": 70.4664260495923,
    "a": 7.94130225301409,
    "b": 6.39010822099408,
    "C": 10.1930252893703,
    "h": 0.67758053579118,
    "CMY_C": 0.2486572,
    "CMY_M": 0.3441179,
    "CMY_Y": 0.3732225,
    "CMYK_C": 0,
    "CMYK_M": 0.1270534,
    "CMYK_Y": 0.1657903,
    "CMYK_K": 0.2486572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04277",
    "Farbtonhilfsbezeichnung": "C7.11.57",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "148",
    "Bcolor": "138",
    "Y": 33,
    "L": 64.1599177730772,
    "a": 11.1091676533861,
    "b": 9.25069852410381,
    "C": 14.4564528545178,
    "h": 0.6943694189277,
    "CMY_C": 0.2887647,
    "CMY_M": 0.4183347,
    "CMY_Y": 0.4571369,
    "CMYK_C": 0,
    "CMYK_M": 0.1821759,
    "CMYK_Y": 0.236732,
    "CMYK_K": 0.2887647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04278",
    "Farbtonhilfsbezeichnung": "C6.16.52",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "133",
    "Bcolor": "122",
    "Y": 27,
    "L": 59.2971388875698,
    "a": 14.9173821323318,
    "b": 11.8013459193993,
    "C": 19.0210424317736,
    "h": 0.66929895270419,
    "CMY_C": 0.3119068,
    "CMY_M": 0.4783368,
    "CMY_Y": 0.5225024,
    "CMYK_C": 0,
    "CMYK_M": 0.2418714,
    "CMYK_Y": 0.3060569,
    "CMYK_K": 0.3119068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04279",
    "Farbtonhilfsbezeichnung": "C5.24.49",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "119",
    "Bcolor": "104",
    "Y": 24,
    "L": 56.0715299481671,
    "a": 22.8021457703954,
    "b": 17.8734485077427,
    "C": 28.9723663737239,
    "h": 0.66481514611165,
    "CMY_C": 0.290155,
    "CMY_M": 0.5338176,
    "CMY_Y": 0.5935211,
    "CMYK_C": 0,
    "CMYK_M": 0.3432617,
    "CMYK_Y": 0.4273694,
    "CMYK_K": 0.290155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04280",
    "Farbtonhilfsbezeichnung": "C7.35.50",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "115",
    "Bcolor": "91",
    "Y": 26,
    "L": 57.7886820605635,
    "a": 32.355956057358,
    "b": 27.6281822379699,
    "C": 42.5467313216909,
    "h": 0.70674369851173,
    "CMY_C": 0.2047411,
    "CMY_M": 0.5482584,
    "CMY_Y": 0.6413267,
    "CMYK_C": 0,
    "CMYK_M": 0.4319565,
    "CMYK_Y": 0.5489855,
    "CMYK_K": 0.2047411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04281",
    "Farbtonhilfsbezeichnung": "C7.43.45",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "101",
    "Bcolor": "75",
    "Y": 22,
    "L": 53.6535553868652,
    "a": 36.0538975968783,
    "b": 31.5086388287394,
    "C": 47.8819157173784,
    "h": 0.71822454271675,
    "CMY_C": 0.2292385,
    "CMY_M": 0.6034745,
    "CMY_Y": 0.7056925,
    "CMYK_C": 0,
    "CMYK_M": 0.4855406,
    "CMYK_Y": 0.6181601,
    "CMYK_K": 0.2292385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04282",
    "Farbtonhilfsbezeichnung": "C6.52.44",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "87",
    "Bcolor": "65",
    "Y": 20,
    "L": 51.713292659656,
    "a": 44.6056969432322,
    "b": 35.260253513181,
    "C": 56.8590685608309,
    "h": 0.66891376856193,
    "CMY_C": 0.2056055,
    "CMY_M": 0.6574325,
    "CMY_Y": 0.7466474,
    "CMYK_C": 0,
    "CMYK_M": 0.568769,
    "CMYK_Y": 0.6810746,
    "CMYK_K": 0.2056055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04283",
    "Farbtonhilfsbezeichnung": "C7.73.42",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "65",
    "Bcolor": "37",
    "Y": 20,
    "L": 51.7617429596115,
    "a": 60.4434680791824,
    "b": 50.7771557034666,
    "C": 78.9413223525755,
    "h": 0.6987048556091,
    "CMY_C": 0.118616,
    "CMY_M": 0.7435509,
    "CMY_Y": 0.8539929,
    "CMYK_C": 0,
    "CMYK_M": 0.7090381,
    "CMYK_Y": 0.8343434,
    "CMYK_K": 0.118616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04284",
    "Farbtonhilfsbezeichnung": "C6.09.44",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "119",
    "Bcolor": "112",
    "Y": 20,
    "L": 51.9376376044675,
    "a": 8.19340286525899,
    "b": 6.39191463548494,
    "C": 10.3917478423873,
    "h": 0.6625067546294,
    "CMY_C": 0.4428028,
    "CMY_M": 0.5340161,
    "CMY_Y": 0.5594386,
    "CMYK_C": 0,
    "CMYK_M": 0.1637002,
    "CMYK_Y": 0.2093259,
    "CMYK_K": 0.4428028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04285",
    "Farbtonhilfsbezeichnung": "C7.29.46",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "112",
    "Bcolor": "92",
    "Y": 22,
    "L": 54.4128613683317,
    "a": 25.4683839025723,
    "b": 22.1923288070407,
    "C": 33.7807346943285,
    "h": 0.71676909883691,
    "CMY_C": 0.287518,
    "CMY_M": 0.5591894,
    "CMY_Y": 0.6378748,
    "CMYK_C": 0,
    "CMYK_M": 0.3813028,
    "CMYK_Y": 0.4917413,
    "CMYK_K": 0.287518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04286",
    "Farbtonhilfsbezeichnung": "C6.44.43",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "93",
    "Bcolor": "72",
    "Y": 19,
    "L": 51.1595618066117,
    "a": 37.8970571499648,
    "b": 29.8882811112034,
    "C": 48.2648556240461,
    "h": 0.66779427009359,
    "CMY_C": 0.250525,
    "CMY_M": 0.6349892,
    "CMY_Y": 0.7169836,
    "CMYK_C": 0,
    "CMYK_M": 0.5129781,
    "CMYK_Y": 0.6223804,
    "CMYK_K": 0.250525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04287",
    "Farbtonhilfsbezeichnung": "C6.61.41",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "74",
    "Bcolor": "52",
    "Y": 18,
    "L": 49.8100993413973,
    "a": 51.6278629473023,
    "b": 40.0479411438788,
    "C": 65.339680305072,
    "h": 0.65974976288019,
    "CMY_C": 0.1909229,
    "CMY_M": 0.7115411,
    "CMY_Y": 0.7947028,
    "CMYK_C": 0,
    "CMYK_M": 0.6434717,
    "CMYK_Y": 0.7462575,
    "CMYK_K": 0.1909229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04288",
    "Farbtonhilfsbezeichnung": "C7.70.38",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "65",
    "Bcolor": "45",
    "Y": 17,
    "L": 47.7408408275432,
    "a": 53.4414873408927,
    "b": 41.4685291743345,
    "C": 67.6434141738087,
    "h": 0.6599104039327,
    "CMY_C": 0.2068073,
    "CMY_M": 0.7443349,
    "CMY_Y": 0.8225224,
    "CMYK_C": 0,
    "CMYK_M": 0.677676,
    "CMYK_Y": 0.7762491,
    "CMYK_K": 0.2068073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04289",
    "Farbtonhilfsbezeichnung": "C7.09.50",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "134",
    "Bcolor": "127",
    "Y": 26,
    "L": 57.7147887575706,
    "a": 7.9437598170608,
    "b": 6.30805735742863,
    "C": 10.1437127155573,
    "h": 0.67112665828884,
    "CMY_C": 0.3846636,
    "CMY_M": 0.4756407,
    "CMY_Y": 0.502125,
    "CMYK_C": 0,
    "CMYK_M": 0.1478493,
    "CMYK_Y": 0.1908896,
    "CMYK_K": 0.3846636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04290",
    "Farbtonhilfsbezeichnung": "C6.17.42",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "110",
    "Bcolor": "99",
    "Y": 18,
    "L": 50.0234463561409,
    "a": 14.463266545456,
    "b": 11.4984726977477,
    "C": 18.4770385491224,
    "h": 0.67169216448672,
    "CMY_C": 0.4141927,
    "CMY_M": 0.5694865,
    "CMY_Y": 0.6105043,
    "CMYK_C": 0,
    "CMYK_M": 0.2650937,
    "CMYK_Y": 0.3351129,
    "CMYK_K": 0.4141927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04291",
    "Farbtonhilfsbezeichnung": "C6.18.34",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "92",
    "Bcolor": "83",
    "Y": 13,
    "L": 42.4327328916105,
    "a": 13.3523530782681,
    "b": 10.4116828411209,
    "C": 16.9318774006554,
    "h": 0.66227948195143,
    "CMY_C": 0.5013896,
    "CMY_M": 0.6396617,
    "CMY_Y": 0.6748461,
    "CMYK_C": 0,
    "CMYK_M": 0.2773149,
    "CMYK_Y": 0.3478799,
    "CMYK_K": 0.5013896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04292",
    "Farbtonhilfsbezeichnung": "C7.27.35",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "88",
    "Bcolor": "73",
    "Y": 13,
    "L": 42.4483409755018,
    "a": 19.3334751032073,
    "b": 16.6030089611931,
    "C": 25.4841748175568,
    "h": 0.70956353458529,
    "CMY_C": 0.4588631,
    "CMY_M": 0.656669,
    "CMY_Y": 0.7131856,
    "CMYK_C": 0,
    "CMYK_M": 0.3655376,
    "CMYK_Y": 0.4699781,
    "CMYK_K": 0.4588631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04293",
    "Farbtonhilfsbezeichnung": "C6.38.42",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "91",
    "Bcolor": "72",
    "Y": 17,
    "L": 48.397695093331,
    "a": 32.327337930753,
    "b": 26.2129559816981,
    "C": 41.61941661037,
    "h": 0.68132810341887,
    "CMY_C": 0.3144071,
    "CMY_M": 0.6415837,
    "CMY_Y": 0.7190046,
    "CMYK_C": 0,
    "CMYK_M": 0.4772171,
    "CMYK_Y": 0.5901424,
    "CMYK_K": 0.3144071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04294",
    "Farbtonhilfsbezeichnung": "C6.48.40",
    "Farbtonklasse": "04",
    "Y": 19,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04295",
    "Farbtonhilfsbezeichnung": "C6.55.38",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "72",
    "Bcolor": "55",
    "Y": 16,
    "L": 46.9957889765931,
    "a": 46.7880894898548,
    "b": 34.8935143423977,
    "C": 58.3667941664931,
    "h": 0.64079336348404,
    "CMY_C": 0.2517414,
    "CMY_M": 0.7159909,
    "CMY_Y": 0.7856458,
    "CMYK_C": 0,
    "CMYK_M": 0.6204399,
    "CMYK_Y": 0.7135292,
    "CMYK_K": 0.2517414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04296",
    "Farbtonhilfsbezeichnung": "C7.68.38",
    "Farbtonklasse": "04",
    "Rcolor": "199",
    "Gcolor": "76",
    "Bcolor": "59",
    "Y": 17,
    "L": 49.1271057128906,
    "a": 48.244010925293,
    "b": 35.2664680480957,
    "C": 59.7595863342285,
    "h": 36.166877746582,
    "CMY_C": 0.21881753206253,
    "CMY_M": 0.70070326328278,
    "CMY_Y": 0.76867610216141,
    "CMYK_C": 0,
    "CMYK_M": 0.61686706542969,
    "CMYK_Y": 0.70387983322144,
    "CMYK_K": 0.21881753206253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04297",
    "Farbtonhilfsbezeichnung": "C7.04.43",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "118",
    "Bcolor": "115",
    "Y": 19,
    "L": 50.3633269016821,
    "a": 3.6272916682511,
    "b": 2.67464651040517,
    "C": 4.50677032942509,
    "h": 0.63536708061387,
    "CMY_C": 0.4975583,
    "CMY_M": 0.5382264,
    "CMY_Y": 0.5509229,
    "CMYK_C": 0,
    "CMYK_M": 0.08094089,
    "CMYK_Y": 0.1062105,
    "CMYK_K": 0.4975583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04298",
    "Farbtonhilfsbezeichnung": "C5.23.30",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "79",
    "Bcolor": "69",
    "Y": 10,
    "L": 38.1176276034142,
    "a": 16.7232526704121,
    "b": 12.9082733375734,
    "C": 21.1255934931058,
    "h": 0.65735522514591,
    "CMY_C": 0.5232411,
    "CMY_M": 0.6895242,
    "CMY_Y": 0.7292924,
    "CMYK_C": 0,
    "CMYK_M": 0.3487781,
    "CMYK_Y": 0.4321918,
    "CMYK_K": 0.5232411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04299",
    "Farbtonhilfsbezeichnung": "C6.39.32",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "76",
    "Bcolor": "61",
    "Y": 12,
    "L": 40.9455304444167,
    "a": 28.8366146075213,
    "b": 22.0773988380332,
    "C": 36.3175148031401,
    "h": 0.6534124752849,
    "CMY_C": 0.4198264,
    "CMY_M": 0.7011209,
    "CMY_Y": 0.7597043,
    "CMYK_C": 0,
    "CMYK_M": 0.4848453,
    "CMYK_Y": 0.585821,
    "CMYK_K": 0.4198264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04300",
    "Farbtonhilfsbezeichnung": "C7.49.33",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "73",
    "Bcolor": "55",
    "Y": 12,
    "L": 41.9959370061365,
    "a": 34.4932437099052,
    "b": 27.4653879647428,
    "C": 44.0923054249237,
    "h": 0.67245270154706,
    "CMY_C": 0.3752271,
    "CMY_M": 0.7122268,
    "CMY_Y": 0.7839708,
    "CMYK_C": 0,
    "CMYK_M": 0.5393956,
    "CMYK_Y": 0.6542277,
    "CMYK_K": 0.3752271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04301",
    "Farbtonhilfsbezeichnung": "C7.64.37",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "65",
    "Bcolor": "46",
    "Y": 15,
    "L": 46.2061730739306,
    "a": 50.7615322757428,
    "b": 39.1005615943982,
    "C": 64.0748552552295,
    "h": 0.65635408491964,
    "CMY_C": 0.2396151,
    "CMY_M": 0.7455708,
    "CMY_Y": 0.820339,
    "CMYK_C": 0,
    "CMYK_M": 0.6653942,
    "CMYK_Y": 0.7637236,
    "CMYK_K": 0.2396151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04302",
    "Farbtonhilfsbezeichnung": "C6.71.36",
    "Farbtonklasse": "04",
    "Rcolor": "202",
    "Gcolor": "56",
    "Bcolor": "44",
    "Y": 16,
    "L": 46.473707899063,
    "a": 56.8840515270361,
    "b": 40.6158706153097,
    "C": 69.8959531301353,
    "h": 0.620067930705,
    "CMY_C": 0.2066887,
    "CMY_M": 0.7801139,
    "CMY_Y": 0.8258319,
    "CMYK_C": 0,
    "CMYK_M": 0.7228249,
    "CMYK_Y": 0.7804543,
    "CMYK_K": 0.2066887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04303",
    "Farbtonhilfsbezeichnung": "C7.05.34",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "94",
    "Bcolor": "90",
    "Y": 12,
    "L": 40.6980604420842,
    "a": 3.54445982342555,
    "b": 3.10541767558926,
    "C": 4.71241067604895,
    "h": 0.7194712518943,
    "CMY_C": 0.5922054,
    "CMY_M": 0.6316718,
    "CMY_Y": 0.646077,
    "CMYK_C": 0,
    "CMYK_M": 0.09678002,
    "CMYK_Y": 0.1321048,
    "CMYK_K": 0.5922054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04304",
    "Farbtonhilfsbezeichnung": "C6.06.29",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "86",
    "Bcolor": "83",
    "Y": 10,
    "L": 37.3071188273445,
    "a": 4.09405257981263,
    "b": 2.76476023345169,
    "C": 4.94015846656221,
    "h": 0.5939635400706,
    "CMY_C": 0.6222026,
    "CMY_M": 0.6646574,
    "CMY_Y": 0.6753557,
    "CMYK_C": 0,
    "CMYK_M": 0.1123747,
    "CMYK_Y": 0.140692,
    "CMYK_K": 0.6222026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04305",
    "Farbtonhilfsbezeichnung": "C6.16.22",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "69",
    "Bcolor": "64",
    "Y": 7,
    "L": 31.5116594130386,
    "a": 8.84570660024264,
    "b": 6.21075884581609,
    "C": 10.8083324661327,
    "h": 0.61214822428396,
    "CMY_C": 0.6424721,
    "CMY_M": 0.7291247,
    "CMY_Y": 0.7481532,
    "CMYK_C": 0,
    "CMYK_M": 0.2423659,
    "CMYK_Y": 0.2955882,
    "CMYK_K": 0.6424721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04306",
    "Farbtonhilfsbezeichnung": "C6.28.25",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "69",
    "Bcolor": "60",
    "Y": 8,
    "L": 34.332001864396,
    "a": 18.2278669856189,
    "b": 13.4973891829687,
    "C": 22.681151857918,
    "h": 0.63738106196394,
    "CMY_C": 0.5535064,
    "CMY_M": 0.7287164,
    "CMY_Y": 0.7662128,
    "CMYK_C": 0,
    "CMYK_M": 0.3924133,
    "CMYK_Y": 0.476393,
    "CMYK_K": 0.5535064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04307",
    "Farbtonhilfsbezeichnung": "C7.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "72",
    "Bcolor": "55",
    "Y": 10,
    "L": 38.5580863823104,
    "a": 27.3535273967215,
    "b": 22.4104745439976,
    "C": 35.3616293506161,
    "h": 0.68639302980086,
    "CMY_C": 0.4530094,
    "CMY_M": 0.7188976,
    "CMY_Y": 0.783209,
    "CMYK_C": 0,
    "CMYK_M": 0.4860928,
    "CMYK_Y": 0.6036659,
    "CMYK_K": 0.4530094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04308",
    "Farbtonhilfsbezeichnung": "C7.58.31",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "63",
    "Bcolor": "48",
    "Y": 11,
    "L": 39.6669419479441,
    "a": 38.7466283306747,
    "b": 28.9477270771134,
    "C": 48.3660222669436,
    "h": 0.64164452882058,
    "CMY_C": 0.3803172,
    "CMY_M": 0.7525182,
    "CMY_Y": 0.8126568,
    "CMYK_C": 0,
    "CMYK_M": 0.6006315,
    "CMYK_Y": 0.6976787,
    "CMYK_K": 0.3803172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04309",
    "Farbtonhilfsbezeichnung": "C6.64.35",
    "Farbtonklasse": "04",
    "Rcolor": "185",
    "Gcolor": "62",
    "Bcolor": "46",
    "Y": 14,
    "L": 44.1963033277913,
    "a": 48.8903264185977,
    "b": 36.2460240037723,
    "C": 60.8608106534827,
    "h": 0.63795766675823,
    "CMY_C": 0.2744486,
    "CMY_M": 0.7564577,
    "CMY_Y": 0.81875,
    "CMYK_C": 0,
    "CMYK_M": 0.664335,
    "CMYK_Y": 0.75019,
    "CMYK_K": 0.2744486
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04310",
    "Farbtonhilfsbezeichnung": "C7.05.24",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "76",
    "Bcolor": "73",
    "Y": 7,
    "L": 32.8997563015564,
    "a": 3.34050217749016,
    "b": 2.35078606101177,
    "C": 4.08474600219692,
    "h": 0.61321982324638,
    "CMY_C": 0.669421,
    "CMY_M": 0.703667,
    "CMY_Y": 0.7131011,
    "CMYK_C": 0,
    "CMYK_M": 0.103594,
    "CMYK_Y": 0.1321324,
    "CMYK_K": 0.669421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04311",
    "Farbtonhilfsbezeichnung": "C5.09.26",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "78",
    "Bcolor": "75",
    "Y": 8,
    "L": 34.6019495091505,
    "a": 5.37280655902991,
    "b": 3.71155678028484,
    "C": 6.53013813437612,
    "h": 0.60452751739141,
    "CMY_C": 0.6380067,
    "CMY_M": 0.6926813,
    "CMY_Y": 0.7057598,
    "CMYK_C": 0,
    "CMYK_M": 0.1510376,
    "CMYK_Y": 0.1871667,
    "CMYK_K": 0.6380067
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04312",
    "Farbtonhilfsbezeichnung": "C7.19.20",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "66",
    "Bcolor": "59",
    "Y": 6,
    "L": 30.4895439940673,
    "a": 10.6634458457699,
    "b": 8.20739215613098,
    "C": 13.4562388248049,
    "h": 0.65597491907605,
    "CMY_C": 0.6389289,
    "CMY_M": 0.7429925,
    "CMY_Y": 0.768886,
    "CMYK_C": 0,
    "CMYK_M": 0.2882079,
    "CMYK_Y": 0.3599209,
    "CMYK_K": 0.6389289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04313",
    "Farbtonhilfsbezeichnung": "C6.26.16",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "57",
    "Bcolor": "49",
    "Y": 5,
    "L": 26.8669920485838,
    "a": 11.7106089852397,
    "b": 9.31452748499542,
    "C": 14.9632478116855,
    "h": 0.67192500911808,
    "CMY_C": 0.6666698,
    "CMY_M": 0.7779045,
    "CMY_Y": 0.806486,
    "CMYK_C": 0,
    "CMYK_M": 0.3337073,
    "CMYK_Y": 0.4194525,
    "CMYK_K": 0.6666698
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04314",
    "Farbtonhilfsbezeichnung": "C4.29.21",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "61",
    "Bcolor": "55",
    "Y": 7,
    "L": 31.1145695785524,
    "a": 18.7940848668131,
    "b": 12.1564884110385,
    "C": 22.3829809558219,
    "h": 0.57414016309829,
    "CMY_C": 0.5852686,
    "CMY_M": 0.7592902,
    "CMY_Y": 0.7858873,
    "CMYK_C": 0,
    "CMYK_M": 0.4196008,
    "CMYK_Y": 0.4837317,
    "CMYK_K": 0.5852686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04316",
    "Farbtonhilfsbezeichnung": "C5.36.25",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "64",
    "Bcolor": "54",
    "Y": 8,
    "L": 34.3476083906265,
    "a": 24.3467850276103,
    "b": 16.9783270340986,
    "C": 29.6821416016007,
    "h": 0.60894789241528,
    "CMY_C": 0.5186927,
    "CMY_M": 0.7474144,
    "CMY_Y": 0.7863102,
    "CMYK_C": 0,
    "CMYK_M": 0.4752093,
    "CMYK_Y": 0.5560222,
    "CMYK_K": 0.5186927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04317",
    "Farbtonhilfsbezeichnung": "C7.49.30",
    "Farbtonklasse": "04",
    "Rcolor": "152",
    "Gcolor": "67",
    "Bcolor": "52",
    "Y": 11,
    "L": 39.5071398794175,
    "a": 34.5363950211848,
    "b": 25.8143277306001,
    "C": 43.1177700866145,
    "h": 0.64186895436287,
    "CMY_C": 0.404595,
    "CMY_M": 0.7362332,
    "CMY_Y": 0.7949045,
    "CMYK_C": 0,
    "CMYK_M": 0.556996,
    "CMYK_Y": 0.6555362,
    "CMYK_K": 0.404595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04318",
    "Farbtonhilfsbezeichnung": "C6.63.33",
    "Farbtonklasse": "04",
    "Rcolor": "175",
    "Gcolor": "61",
    "Bcolor": "46",
    "Y": 13,
    "L": 42.2371912049954,
    "a": 45.601936063327,
    "b": 33.9764664618558,
    "C": 56.8677135636502,
    "h": 0.64033606561256,
    "CMY_C": 0.3146811,
    "CMY_M": 0.7595044,
    "CMY_Y": 0.8215671,
    "CMYK_C": 0,
    "CMYK_M": 0.649075,
    "CMYK_Y": 0.7396352,
    "CMYK_K": 0.3146811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04319",
    "Farbtonhilfsbezeichnung": "C6.08.17",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "58",
    "Bcolor": "55",
    "Y": 5,
    "L": 25.4319166862969,
    "a": 4.37559495074033,
    "b": 3.43349885606068,
    "C": 5.56190125474323,
    "h": 0.66533748461719,
    "CMY_C": 0.7295123,
    "CMY_M": 0.7728413,
    "CMY_Y": 0.7852956,
    "CMYK_C": 0,
    "CMYK_M": 0.1601884,
    "CMYK_Y": 0.2062325,
    "CMYK_K": 0.7295123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04320",
    "Farbtonhilfsbezeichnung": "C6.14.15",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "61",
    "Bcolor": "57",
    "Y": 5,
    "L": 27.255074320402,
    "a": 6.69915604739024,
    "b": 4.46038457301059,
    "C": 8.04821236588822,
    "h": 0.58741130733689,
    "CMY_C": 0.6977856,
    "CMY_M": 0.7619569,
    "CMY_Y": 0.7752672,
    "CMYK_C": 0,
    "CMYK_M": 0.2123368,
    "CMYK_Y": 0.2563794,
    "CMYK_K": 0.6977856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04321",
    "Farbtonhilfsbezeichnung": "C7.14.16",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "60",
    "Bcolor": "55",
    "Y": 5,
    "L": 27.0411563936442,
    "a": 7.2456395236852,
    "b": 5.61327658011871,
    "C": 9.16559687484118,
    "h": 0.65912948334157,
    "CMY_C": 0.694574,
    "CMY_M": 0.7652854,
    "CMY_Y": 0.7838381,
    "CMYK_C": 0,
    "CMYK_M": 0.2315175,
    "CMYK_Y": 0.2922609,
    "CMYK_K": 0.694574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04322",
    "Farbtonhilfsbezeichnung": "C6.24.16",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "55",
    "Bcolor": "48",
    "Y": 5,
    "L": 25.9365878472456,
    "a": 11.4924771292869,
    "b": 8.79285797527139,
    "C": 14.4703621910606,
    "h": 0.65309328273683,
    "CMY_C": 0.6774712,
    "CMY_M": 0.7854253,
    "CMY_Y": 0.8113285,
    "CMYK_C": 0,
    "CMYK_M": 0.3347114,
    "CMYK_Y": 0.4150243,
    "CMYK_K": 0.6774712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04323",
    "Farbtonhilfsbezeichnung": "C7.29.21",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "61",
    "Bcolor": "52",
    "Y": 6,
    "L": 30.2417313632152,
    "a": 16.0823666346601,
    "b": 12.5116307409272,
    "C": 20.3760501660391,
    "h": 0.66116416530856,
    "CMY_C": 0.6070827,
    "CMY_M": 0.7597497,
    "CMY_Y": 0.7960373,
    "CMYK_C": 0,
    "CMYK_M": 0.3885474,
    "CMYK_Y": 0.4809018,
    "CMYK_K": 0.6070827
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04324",
    "Farbtonhilfsbezeichnung": "C6.38.21",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "60",
    "Bcolor": "52",
    "Y": 7,
    "L": 31.2016924357867,
    "a": 20.3110475163317,
    "b": 14.3343321126805,
    "C": 24.8598416794498,
    "h": 0.61456837566113,
    "CMY_C": 0.5742063,
    "CMY_M": 0.7633216,
    "CMY_Y": 0.7980317,
    "CMYK_C": 0,
    "CMYK_M": 0.4441477,
    "CMYK_Y": 0.5256664,
    "CMYK_K": 0.5742063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04325",
    "Farbtonhilfsbezeichnung": "C6.46.36",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "77",
    "Bcolor": "57",
    "Y": 14,
    "L": 43.8249867023475,
    "a": 35.2903386140596,
    "b": 28.7274276745113,
    "C": 45.5046492161984,
    "h": 0.68323803312059,
    "CMY_C": 0.3494056,
    "CMY_M": 0.6976291,
    "CMY_Y": 0.7759678,
    "CMYK_C": 0,
    "CMYK_M": 0.535239,
    "CMYK_Y": 0.65565,
    "CMYK_K": 0.3494056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04326",
    "Farbtonhilfsbezeichnung": "C9.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "215",
    "Bcolor": "201",
    "Y": 73,
    "L": 88.2486056014438,
    "a": 9.27931803425536,
    "b": 9.9888627303266,
    "C": 13.6338960618806,
    "h": 0.82220621692604,
    "CMY_C": 0.03224171,
    "CMY_M": 0.1567572,
    "CMY_Y": 0.2105137,
    "CMYK_C": 0,
    "CMYK_M": 0.1286638,
    "CMYK_Y": 0.1842113,
    "CMYK_K": 0.03224171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04327",
    "Farbtonhilfsbezeichnung": "C8.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "212",
    "Bcolor": "200",
    "Y": 71,
    "L": 87.5039603285555,
    "a": 10.5673259807079,
    "b": 9.82703415220327,
    "C": 14.4304878161174,
    "h": 0.74911524288918,
    "CMY_C": 0.03201094,
    "CMY_M": 0.1682189,
    "CMY_Y": 0.217166,
    "CMYK_C": 0,
    "CMYK_M": 0.1407122,
    "CMYK_Y": 0.191278,
    "CMYK_K": 0.03201094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04328",
    "Farbtonhilfsbezeichnung": "C7.12.76",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "199",
    "Bcolor": "182",
    "Y": 64,
    "L": 83.7224664177141,
    "a": 14.2882184287408,
    "b": 13.629061212176,
    "C": 19.7459994781892,
    "h": 0.7617914661729,
    "CMY_C": 0.04006768,
    "CMY_M": 0.220307,
    "CMY_Y": 0.2848512,
    "CMYK_C": 0,
    "CMYK_M": 0.1877626,
    "CMYK_Y": 0.2550008,
    "CMYK_K": 0.04006768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04329",
    "Farbtonhilfsbezeichnung": "C8.33.65",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "154",
    "Bcolor": "123",
    "Y": 45,
    "L": 72.9697137899317,
    "a": 34.1599907041891,
    "b": 30.9764834826626,
    "C": 46.1134198890297,
    "h": 0.73656260598881,
    "CMY_C": 0.0113465,
    "CMY_M": 0.3978463,
    "CMY_Y": 0.516772,
    "CMYK_C": 0,
    "CMYK_M": 0.3909355,
    "CMYK_Y": 0.5112261,
    "CMYK_K": 0.0113465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04331",
    "Farbtonhilfsbezeichnung": "C8.06.81",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "217",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.8796157836914,
    "a": 8.55090713500977,
    "b": 6.98392105102539,
    "C": 11.0405235290527,
    "h": 39.2401008605957,
    "CMY_C": 0.03850013017654,
    "CMY_M": 0.14708822965622,
    "CMY_Y": 0.18166613578796,
    "CMYK_C": 0,
    "CMYK_M": 0.11293615400791,
    "CMYK_Y": 0.14889861643314,
    "CMYK_K": 0.03850013017654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04332",
    "Farbtonhilfsbezeichnung": "C7.10.74",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "194",
    "Bcolor": "182",
    "Y": 59,
    "L": 81.2487998935698,
    "a": 10.9523452106112,
    "b": 10.2609930399761,
    "C": 15.0080592942205,
    "h": 0.75281924780905,
    "CMY_C": 0.09900328,
    "CMY_M": 0.2375749,
    "CMY_Y": 0.2872387,
    "CMYK_C": 0,
    "CMYK_M": 0.1537982,
    "CMYK_Y": 0.2089191,
    "CMYK_K": 0.09900328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04333",
    "Farbtonhilfsbezeichnung": "C8.15.74",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "189",
    "Bcolor": "171",
    "Y": 58,
    "L": 80.8849251087563,
    "a": 16.4937107209749,
    "b": 15.7020186486343,
    "C": 22.772700388607,
    "h": 0.7608131461992,
    "CMY_C": 0.05319193,
    "CMY_M": 0.2574793,
    "CMY_Y": 0.3294842,
    "CMYK_C": 0,
    "CMYK_M": 0.2157643,
    "CMYK_Y": 0.2918144,
    "CMYK_K": 0.05319193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04334",
    "Farbtonhilfsbezeichnung": "C8.35.60",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "139",
    "Bcolor": "110",
    "Y": 37,
    "L": 67.6135816869394,
    "a": 34.8795653396928,
    "b": 30.9303546421897,
    "C": 46.6183538595854,
    "h": 0.72546068915838,
    "CMY_C": 0.07135095,
    "CMY_M": 0.4564325,
    "CMY_Y": 0.569158,
    "CMYK_C": 0,
    "CMYK_M": 0.4146685,
    "CMYK_Y": 0.5360551,
    "CMYK_K": 0.07135095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04335",
    "Farbtonhilfsbezeichnung": "C9.55.53",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "106",
    "Bcolor": "65",
    "Y": 29,
    "L": 60.5709912598692,
    "a": 48.7661457644781,
    "b": 46.340111151462,
    "C": 67.2721552668872,
    "h": 0.75989501884984,
    "CMY_C": 0.06814355,
    "CMY_M": 0.5852418,
    "CMY_Y": 0.7436348,
    "CMYK_C": 0,
    "CMYK_M": 0.5549119,
    "CMYK_Y": 0.7248877,
    "CMYK_K": 0.06814355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04336",
    "Farbtonhilfsbezeichnung": "C8.12.72",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "189",
    "Bcolor": "175",
    "Y": 57,
    "L": 80.0419424573458,
    "a": 13.5732694465482,
    "b": 12.3387585231324,
    "C": 18.3433531656775,
    "h": 0.7377917713003,
    "CMY_C": 0.08976313,
    "CMY_M": 0.2579428,
    "CMY_Y": 0.3145714,
    "CMYK_C": 0,
    "CMYK_M": 0.1847647,
    "CMYK_Y": 0.2469778,
    "CMYK_K": 0.08976313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04337",
    "Farbtonhilfsbezeichnung": "C8.21.60",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "151",
    "Bcolor": "129",
    "Y": 38,
    "L": 68.0506704629528,
    "a": 21.949145163432,
    "b": 20.3612679435563,
    "C": 29.9390414955907,
    "h": 0.74788653790298,
    "CMY_C": 0.156423,
    "CMY_M": 0.409674,
    "CMY_Y": 0.4932816,
    "CMYK_C": 0,
    "CMYK_M": 0.3002109,
    "CMYK_Y": 0.3993217,
    "CMYK_K": 0.156423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04338",
    "Farbtonhilfsbezeichnung": "C7.34.54",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "127",
    "Bcolor": "101",
    "Y": 30,
    "L": 61.9716379765892,
    "a": 31.0337223778351,
    "b": 27.9369745443165,
    "C": 41.756035148399,
    "h": 0.73293302200825,
    "CMY_C": 0.1629525,
    "CMY_M": 0.5014393,
    "CMY_Y": 0.6038408,
    "CMYK_C": 0,
    "CMYK_M": 0.4043819,
    "CMYK_Y": 0.5267184,
    "CMYK_K": 0.1629525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04339",
    "Farbtonhilfsbezeichnung": "C8.60.50",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "98",
    "Bcolor": "64",
    "Y": 27,
    "L": 59.0983560043685,
    "a": 52.1013760331282,
    "b": 45.3598805413104,
    "C": 69.0801863580823,
    "h": 0.71633713717487,
    "CMY_C": 0.07024409,
    "CMY_M": 0.6156234,
    "CMY_Y": 0.7485468,
    "CMYK_C": 0,
    "CMYK_M": 0.5865833,
    "CMYK_Y": 0.7295492,
    "CMYK_K": 0.07024409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04340",
    "Farbtonhilfsbezeichnung": "C8.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "197",
    "Bcolor": "191",
    "Y": 57,
    "L": 80.3499372964801,
    "a": 3.90326117844692,
    "b": 3.52873326724519,
    "C": 5.26188239117273,
    "h": 0.73504676022981,
    "CMY_C": 0.177664,
    "CMY_M": 0.2280399,
    "CMY_Y": 0.2492976,
    "CMYK_C": 0,
    "CMYK_M": 0.06125952,
    "CMYK_Y": 0.08710989,
    "CMYK_K": 0.177664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04341",
    "Farbtonhilfsbezeichnung": "C9.11.72",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "187",
    "Bcolor": "173",
    "Y": 55,
    "L": 78.9355432407256,
    "a": 11.9261075280989,
    "b": 11.5222356061213,
    "C": 16.5829416610789,
    "h": 0.76817596612505,
    "CMY_C": 0.1152663,
    "CMY_M": 0.2653588,
    "CMY_Y": 0.3206173,
    "CMYK_C": 0,
    "CMYK_M": 0.169647,
    "CMYK_Y": 0.2321049,
    "CMYK_K": 0.1152663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04342",
    "Farbtonhilfsbezeichnung": "C9.15.57",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "146",
    "Bcolor": "131",
    "Y": 33,
    "L": 64.2029899510643,
    "a": 14.0907859019657,
    "b": 13.6552960792177,
    "C": 19.6218591969807,
    "h": 0.7697039090755,
    "CMY_C": 0.259873,
    "CMY_M": 0.4265472,
    "CMY_Y": 0.4865772,
    "CMYK_C": 0,
    "CMYK_M": 0.2251967,
    "CMYK_Y": 0.3063045,
    "CMYK_K": 0.259873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04343",
    "Farbtonhilfsbezeichnung": "D0.24.54",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "136",
    "Bcolor": "113",
    "Y": 31,
    "L": 62.1272282044781,
    "a": 20.7635528961404,
    "b": 21.2658076578829,
    "C": 29.7213678052153,
    "h": 0.79734768746951,
    "CMY_C": 0.2289188,
    "CMY_M": 0.4675381,
    "CMY_Y": 0.5583807,
    "CMYK_C": 0,
    "CMYK_M": 0.3094606,
    "CMYK_Y": 0.4272726,
    "CMYK_K": 0.2289188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04344",
    "Farbtonhilfsbezeichnung": "C9.72.45",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "79",
    "Bcolor": "45",
    "Y": 23,
    "L": 54.8732950168462,
    "a": 57.3542606256215,
    "b": 50.5746470656643,
    "C": 76.4676803475052,
    "h": 0.72266503867726,
    "CMY_C": 0.09417465,
    "CMY_M": 0.6891537,
    "CMY_Y": 0.8253816,
    "CMYK_C": 0,
    "CMYK_M": 0.6568363,
    "CMYK_Y": 0.8072273,
    "CMYK_K": 0.09417465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04345",
    "Farbtonhilfsbezeichnung": "C8.07.59",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "158",
    "Bcolor": "151",
    "Y": 37,
    "L": 66.906208065659,
    "a": 7.06949161556952,
    "b": 6.16622012790364,
    "C": 9.38083057987787,
    "h": 0.71725879040016,
    "CMY_C": 0.293536,
    "CMY_M": 0.3792131,
    "CMY_Y": 0.4084823,
    "CMYK_C": 0,
    "CMYK_M": 0.1212759,
    "CMYK_Y": 0.1627065,
    "CMYK_K": 0.293536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04346",
    "Farbtonhilfsbezeichnung": "D1.09.58",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "153",
    "Bcolor": "144",
    "Y": 34,
    "L": 65.1353422540427,
    "a": 7.49362848268836,
    "b": 7.23180883260197,
    "C": 10.414102305425,
    "h": 0.76761994330923,
    "CMY_C": 0.3068906,
    "CMY_M": 0.3988901,
    "CMY_Y": 0.433882,
    "CMYK_C": 0,
    "CMYK_M": 0.1327345,
    "CMYK_Y": 0.1832198,
    "CMYK_K": 0.3068906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04347",
    "Farbtonhilfsbezeichnung": "C8.22.51",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "128",
    "Bcolor": "110",
    "Y": 27,
    "L": 58.7918702990491,
    "a": 20.1633467250483,
    "b": 17.9761278332744,
    "C": 27.0129917453202,
    "h": 0.72811300476889,
    "CMY_C": 0.2749639,
    "CMY_M": 0.4989985,
    "CMY_Y": 0.5684426,
    "CMYK_C": 0,
    "CMYK_M": 0.3089978,
    "CMYK_Y": 0.4047781,
    "CMYK_K": 0.2749639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04348",
    "Farbtonhilfsbezeichnung": "C9.27.50",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "126",
    "Bcolor": "105",
    "Y": 27,
    "L": 58.6221726019639,
    "a": 22.0243554585381,
    "b": 20.7066045558967,
    "C": 30.2297156056474,
    "h": 0.75456961630751,
    "CMY_C": 0.2617891,
    "CMY_M": 0.5065639,
    "CMY_Y": 0.5883212,
    "CMYK_C": 0,
    "CMYK_M": 0.3315785,
    "CMYK_Y": 0.4423291,
    "CMYK_K": 0.2617891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04349",
    "Farbtonhilfsbezeichnung": "C9.47.42",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "90",
    "Bcolor": "59",
    "Y": 18,
    "L": 49.7471046326581,
    "a": 37.4396037052008,
    "b": 35.6404640124844,
    "C": 51.6910688671427,
    "h": 0.76078438832581,
    "CMY_C": 0.2643572,
    "CMY_M": 0.6484451,
    "CMY_Y": 0.7696607,
    "CMYK_C": 0,
    "CMYK_M": 0.522112,
    "CMYK_Y": 0.686887,
    "CMYK_K": 0.2643572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04350",
    "Farbtonhilfsbezeichnung": "C7.52.44",
    "Farbtonklasse": "04",
    "Rcolor": "209",
    "Gcolor": "86",
    "Bcolor": "58",
    "Y": 21,
    "L": 52.4405433596639,
    "a": 47.5117033754729,
    "b": 39.8570867473525,
    "C": 62.0157183432145,
    "h": 0.69800859615008,
    "CMY_C": 0.1790059,
    "CMY_M": 0.6636345,
    "CMY_Y": 0.771387,
    "CMYK_C": 0,
    "CMYK_M": 0.5902949,
    "CMYK_Y": 0.7215413,
    "CMYK_K": 0.1790059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04351",
    "Farbtonhilfsbezeichnung": "C9.04.57",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "155",
    "Bcolor": "151",
    "Y": 34,
    "L": 64.7786019094096,
    "a": 3.20887983674045,
    "b": 2.85426358773904,
    "C": 4.29461644794181,
    "h": 0.72697752237238,
    "CMY_C": 0.3519132,
    "CMY_M": 0.3914038,
    "CMY_Y": 0.4079206,
    "CMYK_C": 0,
    "CMYK_M": 0.06093422,
    "CMYK_Y": 0.08641967,
    "CMYK_K": 0.3519132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04352",
    "Farbtonhilfsbezeichnung": "C9.08.53",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "138",
    "Bcolor": "128",
    "Y": 27,
    "L": 59.240709196893,
    "a": 7.72641458739992,
    "b": 7.93988886291062,
    "C": 11.078777799548,
    "h": 0.79902365362499,
    "CMY_C": 0.3661425,
    "CMY_M": 0.4600691,
    "CMY_Y": 0.4980146,
    "CMYK_C": 0,
    "CMYK_M": 0.1481824,
    "CMYK_Y": 0.2080468,
    "CMYK_K": 0.3661425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04353",
    "Farbtonhilfsbezeichnung": "C8.14.56",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "143",
    "Bcolor": "130",
    "Y": 31,
    "L": 62.5234582929334,
    "a": 12.9856593660966,
    "b": 11.6090631900271,
    "C": 17.4183149966446,
    "h": 0.72948530051635,
    "CMY_C": 0.2893269,
    "CMY_M": 0.440459,
    "CMY_Y": 0.4894749,
    "CMYK_C": 0,
    "CMYK_M": 0.2126605,
    "CMYK_Y": 0.2816315,
    "CMYK_K": 0.2893269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04354",
    "Farbtonhilfsbezeichnung": "C8.32.43",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "108",
    "Bcolor": "89",
    "Y": 20,
    "L": 52.3717107292565,
    "a": 24.5033124282603,
    "b": 21.5005961561695,
    "C": 32.5988949970337,
    "h": 0.72021972347492,
    "CMY_C": 0.3165253,
    "CMY_M": 0.5764011,
    "CMY_Y": 0.6526598,
    "CMYK_C": 0,
    "CMYK_M": 0.3802273,
    "CMYK_Y": 0.4918025,
    "CMYK_K": 0.3165253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04355",
    "Farbtonhilfsbezeichnung": "C9.50.39",
    "Farbtonklasse": "04",
    "Rcolor": "175",
    "Gcolor": "84",
    "Bcolor": "61",
    "Y": 16,
    "L": 46.6679898553009,
    "a": 35.4398180179217,
    "b": 30.2603769201804,
    "C": 46.6011921789003,
    "h": 0.70672638662416,
    "CMY_C": 0.3146748,
    "CMY_M": 0.6705362,
    "CMY_Y": 0.760904,
    "CMYK_C": 0,
    "CMYK_M": 0.5192592,
    "CMYK_Y": 0.6511204,
    "CMYK_K": 0.3146748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04356",
    "Farbtonhilfsbezeichnung": "C8.53.40",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "81",
    "Bcolor": "56",
    "Y": 18,
    "L": 47.4280745340999,
    "a": 40.0012592209693,
    "b": 34.4096190866714,
    "C": 52.7647858420083,
    "h": 0.71039366481409,
    "CMY_C": 0.2799149,
    "CMY_M": 0.6814825,
    "CMY_Y": 0.7809786,
    "CMYK_C": 0,
    "CMYK_M": 0.5576668,
    "CMYK_Y": 0.6958396,
    "CMYK_K": 0.2799149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04357",
    "Farbtonhilfsbezeichnung": "C9.04.47",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "127",
    "Bcolor": "123",
    "Y": 22,
    "L": 53.9713600001029,
    "a": 3.32551697964611,
    "b": 3.1274824556508,
    "C": 4.5651078511157,
    "h": 0.75471903635476,
    "CMY_C": 0.4619462,
    "CMY_M": 0.5018345,
    "CMY_Y": 0.5185483,
    "CMYK_C": 0,
    "CMYK_M": 0.07413428,
    "CMYK_Y": 0.1051978,
    "CMYK_K": 0.4619462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04358",
    "Farbtonhilfsbezeichnung": "C8.18.41",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "106",
    "Bcolor": "93",
    "Y": 17,
    "L": 48.4406588737344,
    "a": 14.4538308922411,
    "b": 12.760015267478,
    "C": 19.2803323904899,
    "h": 0.72323740007024,
    "CMY_C": 0.4286147,
    "CMY_M": 0.5851997,
    "CMY_Y": 0.633769,
    "CMYK_C": 0,
    "CMYK_M": 0.2740446,
    "CMYK_Y": 0.3590474,
    "CMYK_K": 0.4286147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04359",
    "Farbtonhilfsbezeichnung": "C8.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "101",
    "Bcolor": "88",
    "Y": 16,
    "L": 47.1641124619703,
    "a": 16.0467218653801,
    "b": 14.1272272097846,
    "C": 21.3793318712664,
    "h": 0.72186946642165,
    "CMY_C": 0.4306797,
    "CMY_M": 0.6020313,
    "CMY_Y": 0.6543907,
    "CMYK_C": 0,
    "CMYK_M": 0.3009757,
    "CMYK_Y": 0.3929439,
    "CMYK_K": 0.4306797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04360",
    "Farbtonhilfsbezeichnung": "C8.33.38",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "92",
    "Bcolor": "73",
    "Y": 15,
    "L": 45.582226945028,
    "a": 23.8201591872976,
    "b": 21.2728530214317,
    "C": 31.9364096194239,
    "h": 0.72896809526215,
    "CMY_C": 0.3953817,
    "CMY_M": 0.6406029,
    "CMY_Y": 0.7140505,
    "CMYK_C": 0,
    "CMYK_M": 0.4055803,
    "CMYK_Y": 0.5270578,
    "CMYK_K": 0.3953817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04361",
    "Farbtonhilfsbezeichnung": "C9.34.40",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "97",
    "Bcolor": "77",
    "Y": 17,
    "L": 48.1764775023334,
    "a": 24.5213320397263,
    "b": 22.6099827644731,
    "C": 33.3542657783421,
    "h": 0.74486667149003,
    "CMY_C": 0.3615205,
    "CMY_M": 0.6178401,
    "CMY_Y": 0.6989946,
    "CMYK_C": 0,
    "CMYK_M": 0.4014531,
    "CMYK_Y": 0.528559,
    "CMYK_K": 0.3615205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04362",
    "Farbtonhilfsbezeichnung": "C9.66.37",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "70",
    "Bcolor": "46",
    "Y": 15,
    "L": 45.8597622781663,
    "a": 45.8799576690073,
    "b": 38.1782802856355,
    "C": 59.6871141979443,
    "h": 0.69403015305811,
    "CMY_C": 0.26753,
    "CMY_M": 0.7240296,
    "CMY_Y": 0.819037,
    "CMYK_C": 0,
    "CMYK_M": 0.6232331,
    "CMYK_Y": 0.7529415,
    "CMYK_K": 0.26753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04363",
    "Farbtonhilfsbezeichnung": "C9.04.39",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "108",
    "Bcolor": "104",
    "Y": 16,
    "L": 46.5224063109472,
    "a": 3.66930901672613,
    "b": 3.0839143480738,
    "C": 4.79315724408068,
    "h": 0.69893056416616,
    "CMY_C": 0.5344667,
    "CMY_M": 0.5760261,
    "CMY_Y": 0.5907394,
    "CMYK_C": 0,
    "CMYK_M": 0.08927276,
    "CMYK_Y": 0.120878,
    "CMYK_K": 0.5344667
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04364",
    "Farbtonhilfsbezeichnung": "C9.11.35",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "100",
    "Bcolor": "93",
    "Y": 14,
    "L": 44.1168595478862,
    "a": 6.8747850735621,
    "b": 6.56167839418316,
    "C": 9.50359369693182,
    "h": 0.76209962026985,
    "CMY_C": 0.5298613,
    "CMY_M": 0.6072258,
    "CMY_Y": 0.6355469,
    "CMYK_C": 0,
    "CMYK_M": 0.1645567,
    "CMYK_Y": 0.2247967,
    "CMYK_K": 0.5298613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04365",
    "Farbtonhilfsbezeichnung": "C9.14.32",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "89",
    "Bcolor": "80",
    "Y": 11,
    "L": 39.8748938455527,
    "a": 8.62728881879196,
    "b": 8.10561307292322,
    "C": 11.8376972275353,
    "h": 0.75423161334388,
    "CMY_C": 0.5584468,
    "CMY_M": 0.6519099,
    "CMY_Y": 0.684523,
    "CMYK_C": 0,
    "CMYK_M": 0.211669,
    "CMYK_Y": 0.2855289,
    "CMYK_K": 0.5584468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04366",
    "Farbtonhilfsbezeichnung": "C7.23.35",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "93",
    "Bcolor": "80",
    "Y": 14,
    "L": 43.6242341301048,
    "a": 16.0635515605386,
    "b": 13.7977554876819,
    "C": 21.1758292691441,
    "h": 0.70966595623483,
    "CMY_C": 0.4683083,
    "CMY_M": 0.6360306,
    "CMY_Y": 0.6850603,
    "CMYK_C": 0,
    "CMYK_M": 0.3154504,
    "CMYK_Y": 0.407665,
    "CMYK_K": 0.4683083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04367",
    "Farbtonhilfsbezeichnung": "C9.39.33",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "85",
    "Bcolor": "68",
    "Y": 13,
    "L": 43.0234166100971,
    "a": 24.5003453909513,
    "b": 20.7088888860637,
    "C": 32.0799782289708,
    "h": 0.70172930464039,
    "CMY_C": 0.4204647,
    "CMY_M": 0.6671101,
    "CMY_Y": 0.7333617,
    "CMYK_C": 0,
    "CMYK_M": 0.4255918,
    "CMYK_Y": 0.5399102,
    "CMYK_K": 0.4204647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04368",
    "Farbtonhilfsbezeichnung": "C8.44.32",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "76",
    "Bcolor": "58",
    "Y": 12,
    "L": 40.8098810971674,
    "a": 28.6412206900021,
    "b": 24.0320471109747,
    "C": 37.3879500769634,
    "h": 0.69811550200388,
    "CMY_C": 0.420317,
    "CMY_M": 0.702132,
    "CMY_Y": 0.7735921,
    "CMYK_C": 0,
    "CMYK_M": 0.4861536,
    "CMYK_Y": 0.609428,
    "CMYK_K": 0.420317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04370",
    "Farbtonhilfsbezeichnung": "C9.13.32",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "93",
    "Bcolor": "85",
    "Y": 12,
    "L": 41.5021848440922,
    "a": 8.66222106105138,
    "b": 7.68816808792358,
    "C": 11.5819688420704,
    "h": 0.72589480239031,
    "CMY_C": 0.5428821,
    "CMY_M": 0.6365321,
    "CMY_Y": 0.6668745,
    "CMYK_C": 0,
    "CMYK_M": 0.2048705,
    "CMYK_Y": 0.271248,
    "CMYK_K": 0.5428821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04371",
    "Farbtonhilfsbezeichnung": "C8.14.28",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "84",
    "Bcolor": "77",
    "Y": 10,
    "L": 38.0229160220873,
    "a": 8.50086731680302,
    "b": 7.39959209289965,
    "C": 11.2702576846846,
    "h": 0.71624800259125,
    "CMY_C": 0.5788761,
    "CMY_M": 0.6688122,
    "CMY_Y": 0.6970535,
    "CMYK_C": 0,
    "CMYK_M": 0.2135621,
    "CMYK_Y": 0.2806237,
    "CMYK_K": 0.5788761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04372",
    "Farbtonhilfsbezeichnung": "C8.22.28",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "77",
    "Bcolor": "68",
    "Y": 9,
    "L": 36.2881156852225,
    "a": 13.9930075371063,
    "b": 11.0172321828764,
    "C": 17.8096508922808,
    "h": 0.66697263035952,
    "CMY_C": 0.5593029,
    "CMY_M": 0.6989797,
    "CMY_Y": 0.7343457,
    "CMYK_C": 0,
    "CMYK_M": 0.3169452,
    "CMYK_Y": 0.3971953,
    "CMYK_K": 0.5593029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04373",
    "Farbtonhilfsbezeichnung": "C8.24.27",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "76",
    "Bcolor": "64",
    "Y": 9,
    "L": 36.3372943856047,
    "a": 15.0022759755914,
    "b": 13.2935409631785,
    "C": 20.0446131363893,
    "h": 0.72508315484972,
    "CMY_C": 0.5499764,
    "CMY_M": 0.7015862,
    "CMY_Y": 0.7478795,
    "CMYK_C": 0,
    "CMYK_M": 0.3368931,
    "CMYK_Y": 0.4397615,
    "CMYK_K": 0.5499764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04374",
    "Farbtonhilfsbezeichnung": "C7.33.24",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "66",
    "Bcolor": "56",
    "Y": 8,
    "L": 33.8314649195749,
    "a": 20.2760391284773,
    "b": 15.358569085222,
    "C": 25.4362616570337,
    "h": 0.64826722779726,
    "CMY_C": 0.546001,
    "CMY_M": 0.739485,
    "CMY_Y": 0.7816409,
    "CMYK_C": 0,
    "CMYK_M": 0.426177,
    "CMYK_Y": 0.5190317,
    "CMYK_K": 0.546001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04375",
    "Farbtonhilfsbezeichnung": "C8.41.29",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "73",
    "Bcolor": "57",
    "Y": 10,
    "L": 38.2506431504949,
    "a": 25.1336347362327,
    "b": 20.9863380651638,
    "C": 32.7433349010101,
    "h": 0.69571528793567,
    "CMY_C": 0.4687396,
    "CMY_M": 0.714335,
    "CMY_Y": 0.7773442,
    "CMYK_C": 0,
    "CMYK_M": 0.4622881,
    "CMYK_Y": 0.5808913,
    "CMYK_K": 0.4687396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04376",
    "Farbtonhilfsbezeichnung": "C6.58.32",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "65",
    "Bcolor": "49",
    "Y": 12,
    "L": 41.2175791204771,
    "a": 40.8311257909954,
    "b": 30.491175700092,
    "C": 50.9597157462045,
    "h": 0.64142623477089,
    "CMY_C": 0.3514467,
    "CMY_M": 0.7465324,
    "CMY_Y": 0.8087385,
    "CMYK_C": 0,
    "CMYK_M": 0.60918,
    "CMYK_Y": 0.7050951,
    "CMYK_K": 0.3514467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04377",
    "Farbtonhilfsbezeichnung": "C6.04.21",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "67",
    "Y": 6,
    "L": 29.508718467912,
    "a": 2.36139137641719,
    "b": 1.27322312518323,
    "C": 2.68277214073779,
    "h": 0.49450083942254,
    "CMY_C": 0.7092916,
    "CMY_M": 0.7321348,
    "CMY_Y": 0.7371028,
    "CMYK_C": 0,
    "CMYK_M": 0.07857744,
    "CMYK_Y": 0.09566706,
    "CMYK_K": 0.7092916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04378",
    "Farbtonhilfsbezeichnung": "C8.11.21",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "67",
    "Bcolor": "62",
    "Y": 6,
    "L": 30.0065942477474,
    "a": 5.99660627183049,
    "b": 5.13941604221204,
    "C": 7.89765053888201,
    "h": 0.70857510889047,
    "CMY_C": 0.6747048,
    "CMY_M": 0.736095,
    "CMY_Y": 0.7553712,
    "CMYK_C": 0,
    "CMYK_M": 0.1887213,
    "CMYK_Y": 0.247979,
    "CMYK_K": 0.6747048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04379",
    "Farbtonhilfsbezeichnung": "C9.15.20",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "64",
    "Bcolor": "58",
    "Y": 6,
    "L": 28.8581759955354,
    "a": 7.85982469721347,
    "b": 6.62352143940337,
    "C": 10.2785154827515,
    "h": 0.7002442509072,
    "CMY_C": 0.67234,
    "CMY_M": 0.7507687,
    "CMY_Y": 0.774017,
    "CMYK_C": 0,
    "CMYK_M": 0.2393598,
    "CMYK_Y": 0.3103125,
    "CMYK_K": 0.67234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04381",
    "Farbtonhilfsbezeichnung": "C8.19.21",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "66",
    "Bcolor": "58",
    "Y": 6,
    "L": 30.3392326499779,
    "a": 9.90195312916201,
    "b": 8.80547106701114,
    "C": 13.2508488967346,
    "h": 0.72685300930544,
    "CMY_C": 0.6434292,
    "CMY_M": 0.7426674,
    "CMY_Y": 0.7739112,
    "CMYK_C": 0,
    "CMYK_M": 0.2783127,
    "CMYK_Y": 0.3659356,
    "CMYK_K": 0.6434292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04382",
    "Farbtonhilfsbezeichnung": "C8.24.23",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "70",
    "Bcolor": "61",
    "Y": 8,
    "L": 33.1928823647179,
    "a": 12.710058671286,
    "b": 10.9898305286599,
    "C": 16.8024393013692,
    "h": 0.71294142376022,
    "CMY_C": 0.5971285,
    "CMY_M": 0.7241202,
    "CMY_Y": 0.7617903,
    "CMYK_C": 0,
    "CMYK_M": 0.3152164,
    "CMYK_Y": 0.4087203,
    "CMYK_K": 0.5971285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04383",
    "Farbtonhilfsbezeichnung": "C9.33.23",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "66",
    "Bcolor": "54",
    "Y": 8,
    "L": 33.291171665082,
    "a": 18.677518072942,
    "b": 15.3141259473322,
    "C": 24.1530978322828,
    "h": 0.68677158387708,
    "CMY_C": 0.5595962,
    "CMY_M": 0.739846,
    "CMY_Y": 0.7863715,
    "CMYK_C": 0,
    "CMYK_M": 0.4092831,
    "CMYK_Y": 0.5149259,
    "CMYK_K": 0.5595962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04384",
    "Farbtonhilfsbezeichnung": "C8.39.28",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "71",
    "Bcolor": "55",
    "Y": 9,
    "L": 36.7889751149621,
    "a": 23.6982067201672,
    "b": 20.088566197558,
    "C": 31.0669517916619,
    "h": 0.70314736853137,
    "CMY_C": 0.4925036,
    "CMY_M": 0.723343,
    "CMY_Y": 0.7847399,
    "CMYK_C": 0,
    "CMYK_M": 0.4548593,
    "CMYK_Y": 0.5758392,
    "CMYK_K": 0.4925036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04385",
    "Farbtonhilfsbezeichnung": "C8.52.31",
    "Farbtonklasse": "04",
    "Rcolor": "154",
    "Gcolor": "71",
    "Bcolor": "52",
    "Y": 12,
    "L": 40.7096440596266,
    "a": 33.5325249752604,
    "b": 27.599323419039,
    "C": 43.4298616668897,
    "h": 0.68864538424199,
    "CMY_C": 0.3943367,
    "CMY_M": 0.7211043,
    "CMY_Y": 0.7964085,
    "CMYK_C": 0,
    "CMYK_M": 0.5395201,
    "CMYK_Y": 0.6638537,
    "CMYK_K": 0.3943367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04386",
    "Farbtonhilfsbezeichnung": "C8.07.13",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "50",
    "Bcolor": "46",
    "Y": 3,
    "L": 21.3681960015129,
    "a": 2.97972172136235,
    "b": 3.0702148743348,
    "C": 4.27842972495111,
    "h": 0.80035475074058,
    "CMY_C": 0.7743141,
    "CMY_M": 0.8050784,
    "CMY_Y": 0.8179132,
    "CMYK_C": 0,
    "CMYK_M": 0.1363147,
    "CMYK_Y": 0.193185,
    "CMYK_K": 0.7743141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04387",
    "Farbtonhilfsbezeichnung": "C9.08.18",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "62",
    "Bcolor": "59",
    "Y": 5,
    "L": 27.2202669475915,
    "a": 3.97047727553518,
    "b": 3.26035701536933,
    "C": 5.13756923682876,
    "h": 0.68750483659008,
    "CMY_C": 0.7159501,
    "CMY_M": 0.7562394,
    "CMY_Y": 0.7688459,
    "CMYK_C": 0,
    "CMYK_M": 0.1418385,
    "CMYK_Y": 0.18622,
    "CMYK_K": 0.7159501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04388",
    "Farbtonhilfsbezeichnung": "C8.11.09",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "54",
    "Bcolor": "51",
    "Y": 4,
    "L": 23.2966061705184,
    "a": 3.63221520629334,
    "b": 2.65573924868656,
    "C": 4.49954867312743,
    "h": 0.63133564976412,
    "CMY_C": 0.7545186,
    "CMY_M": 0.7897269,
    "CMY_Y": 0.799161,
    "CMYK_C": 0,
    "CMYK_M": 0.1434252,
    "CMYK_Y": 0.1818562,
    "CMYK_K": 0.7545186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04389",
    "Farbtonhilfsbezeichnung": "C9.15.13",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "52",
    "Bcolor": "47",
    "Y": 4,
    "L": 23.2189314101908,
    "a": 5.85012586973546,
    "b": 5.52767900688698,
    "C": 8.04855315537688,
    "h": 0.75706575807088,
    "CMY_C": 0.7373673,
    "CMY_M": 0.7955613,
    "CMY_Y": 0.8160776,
    "CMYK_C": 0,
    "CMYK_M": 0.2215792,
    "CMYK_Y": 0.2996974,
    "CMYK_K": 0.7373673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04390",
    "Farbtonhilfsbezeichnung": "C8.27.18",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "61",
    "Bcolor": "53",
    "Y": 6,
    "L": 29.3659245147513,
    "a": 13.3923936130682,
    "b": 10.5719200834362,
    "C": 17.062288854017,
    "h": 0.66824239462056,
    "CMY_C": 0.6320012,
    "CMY_M": 0.760204,
    "CMY_Y": 0.7923596,
    "CMYK_C": 0,
    "CMYK_M": 0.3483784,
    "CMYK_Y": 0.4357578,
    "CMYK_K": 0.6320012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04391",
    "Farbtonhilfsbezeichnung": "C7.30.16",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "56",
    "Bcolor": "49",
    "Y": 5,
    "L": 27.261185389062,
    "a": 14.3334279911845,
    "b": 10.1795205878073,
    "C": 17.5803810361455,
    "h": 0.61753514032897,
    "CMY_C": 0.6484439,
    "CMY_M": 0.7811841,
    "CMY_Y": 0.8078168,
    "CMYK_C": 0,
    "CMYK_M": 0.3775789,
    "CMYK_Y": 0.4533355,
    "CMYK_K": 0.6484439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04392",
    "Farbtonhilfsbezeichnung": "C9.47.28",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "68",
    "Bcolor": "51",
    "Y": 10,
    "L": 37.1205921183894,
    "a": 27.4267100267375,
    "b": 23.1058335319196,
    "C": 35.862291701668,
    "h": 0.70009883795648,
    "CMY_C": 0.4676799,
    "CMY_M": 0.7328045,
    "CMY_Y": 0.8001357,
    "CMYK_C": 0,
    "CMYK_M": 0.4980548,
    "CMYK_Y": 0.6245411,
    "CMYK_K": 0.4676799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04393",
    "Farbtonhilfsbezeichnung": "D1.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "210",
    "Y": 76,
    "L": 89.7333931238364,
    "a": 6.54084550283057,
    "b": 7.40690665482839,
    "C": 9.88154472161312,
    "h": 0.84741178800769,
    "CMY_C": 0.04229579,
    "CMY_M": 0.1327362,
    "CMY_Y": 0.1757928,
    "CMYK_C": 0,
    "CMYK_M": 0.09443461,
    "CMYK_Y": 0.1393927,
    "CMYK_K": 0.04229579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04394",
    "Farbtonhilfsbezeichnung": "D0.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "180",
    "Bcolor": "154",
    "Y": 55,
    "L": 79.2328174633789,
    "a": 22.1203906996779,
    "b": 22.4865507122352,
    "C": 31.5429334025914,
    "h": 0.79360656722954,
    "CMY_C": 0.02272058,
    "CMY_M": 0.2925237,
    "CMY_Y": 0.3946993,
    "CMYK_C": 0,
    "CMYK_M": 0.2760757,
    "CMYK_Y": 0.3806268,
    "CMYK_K": 0.02272058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04395",
    "Farbtonhilfsbezeichnung": "D0.25.69",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "169",
    "Bcolor": "141",
    "Y": 50,
    "L": 75.9655529897906,
    "a": 25.2189826041618,
    "b": 25.2598423600118,
    "C": 35.6939311317998,
    "h": 0.78620760670273,
    "CMY_C": 0.03704061,
    "CMY_M": 0.3370473,
    "CMY_Y": 0.447561,
    "CMYK_C": 0,
    "CMYK_M": 0.3115466,
    "CMYK_Y": 0.4263113,
    "CMYK_K": 0.03704061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04396",
    "Farbtonhilfsbezeichnung": "D1.34.65",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "156",
    "Bcolor": "118",
    "Y": 46,
    "L": 73.2975913107339,
    "a": 32.1557125500086,
    "b": 34.2449507106118,
    "C": 46.9755947143941,
    "h": 0.81685190233984,
    "CMY_C": 0.01462835,
    "CMY_M": 0.3885571,
    "CMY_Y": 0.5376415,
    "CMYK_C": 0,
    "CMYK_M": 0.3794799,
    "CMYK_Y": 0.5307775,
    "CMYK_K": 0.01462835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04397",
    "Farbtonhilfsbezeichnung": "D1.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 77,
    "L": 90.134534290779,
    "a": 7.08572531329743,
    "b": 8.0675903233913,
    "C": 10.7374818668802,
    "h": 0.85010310213063,
    "CMY_C": 0.03188736,
    "CMY_M": 0.1298367,
    "CMY_Y": 0.1762148,
    "CMYK_C": 0,
    "CMYK_M": 0.1011756,
    "CMYK_Y": 0.1490812,
    "CMYK_K": 0.03188736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04398",
    "Farbtonhilfsbezeichnung": "D1.16.77",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "195",
    "Bcolor": "171",
    "Y": 62,
    "L": 82.8406867520622,
    "a": 16.4616746668571,
    "b": 18.2813360838089,
    "C": 24.6006906782435,
    "h": 0.83772524315624,
    "CMY_C": 0.02539493,
    "CMY_M": 0.2368724,
    "CMY_Y": 0.3276585,
    "CMYK_C": 0,
    "CMYK_M": 0.2169879,
    "CMYK_Y": 0.3101395,
    "CMYK_K": 0.02539493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04399",
    "Farbtonhilfsbezeichnung": "C9.29.64",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "154",
    "Bcolor": "125",
    "Y": 43,
    "L": 71.4613186038618,
    "a": 28.9991134633906,
    "b": 27.9419357750153,
    "C": 40.2703409039169,
    "h": 0.76683411765432,
    "CMY_C": 0.06334888,
    "CMY_M": 0.3966455,
    "CMY_Y": 0.5113173,
    "CMYK_C": 0,
    "CMYK_M": 0.3558385,
    "CMYK_Y": 0.478266,
    "CMYK_K": 0.06334888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04400",
    "Farbtonhilfsbezeichnung": "D1.42.63",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "143",
    "Bcolor": "99",
    "Y": 41,
    "L": 70.4951449802629,
    "a": 38.2474038188927,
    "b": 40.934304007116,
    "C": 56.0221486863227,
    "h": 0.8193184926908,
    "CMY_C": 0.006463934,
    "CMY_M": 0.4397244,
    "CMY_Y": 0.6124048,
    "CMYK_C": 0,
    "CMYK_M": 0.4360793,
    "CMYK_Y": 0.6098831,
    "CMYK_K": 0.006463934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04401",
    "Farbtonhilfsbezeichnung": "DN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "225",
    "Bcolor": "219",
    "Y": 77,
    "L": 90.1997451439643,
    "a": 2.68793618369018,
    "b": 3.14370164403497,
    "C": 4.13616500569055,
    "h": 0.86339355946202,
    "CMY_C": 0.07877607,
    "CMY_M": 0.1169018,
    "CMY_Y": 0.1397811,
    "CMYK_C": 0,
    "CMYK_M": 0.04138594,
    "CMYK_Y": 0.06622172,
    "CMYK_K": 0.07877607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04402",
    "Farbtonhilfsbezeichnung": "D1.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "217",
    "Bcolor": "204",
    "Y": 73,
    "L": 88.2526402376449,
    "a": 7.105432491333,
    "b": 8.71487481096585,
    "C": 11.2443858818389,
    "h": 0.88678204841982,
    "CMY_C": 0.05125728,
    "CMY_M": 0.1508723,
    "CMY_Y": 0.2014405,
    "CMYK_C": 0,
    "CMYK_M": 0.1049969,
    "CMYK_Y": 0.1582971,
    "CMYK_K": 0.05125728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04403",
    "Farbtonhilfsbezeichnung": "D1.13.77",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "202",
    "Bcolor": "182",
    "Y": 66,
    "L": 84.7628829801523,
    "a": 13.9239272807586,
    "b": 15.3803263672863,
    "C": 20.7468115642885,
    "h": 0.83505654300037,
    "CMY_C": 0.02655792,
    "CMY_M": 0.2084518,
    "CMY_Y": 0.2866337,
    "CMYK_C": 0,
    "CMYK_M": 0.1868564,
    "CMYK_Y": 0.2671713,
    "CMYK_K": 0.02655792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04404",
    "Farbtonhilfsbezeichnung": "D0.20.64",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "162",
    "Bcolor": "140",
    "Y": 43,
    "L": 71.3751947695182,
    "a": 18.8636703245925,
    "b": 19.0132460491158,
    "C": 26.783233252151,
    "h": 0.78934713710831,
    "CMY_C": 0.1398277,
    "CMY_M": 0.3659904,
    "CMY_Y": 0.4509111,
    "CMYK_C": 0,
    "CMYK_M": 0.2629272,
    "CMYK_Y": 0.3616525,
    "CMYK_K": 0.1398277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04405",
    "Farbtonhilfsbezeichnung": "D1.36.60",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "143",
    "Bcolor": "107",
    "Y": 38,
    "L": 68.0557366415592,
    "a": 31.3497706081848,
    "b": 32.9981167751995,
    "C": 45.5157536232842,
    "h": 0.81100872862769,
    "CMY_C": 0.08332976,
    "CMY_M": 0.4406853,
    "CMY_Y": 0.5805057,
    "CMYK_C": 0,
    "CMYK_M": 0.3898409,
    "CMYK_Y": 0.5423717,
    "CMYK_K": 0.08332976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04406",
    "Farbtonhilfsbezeichnung": "D0.45.58",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "130",
    "Bcolor": "89",
    "Y": 37,
    "L": 66.9458860019275,
    "a": 41.5553186816394,
    "b": 41.7412465637978,
    "C": 58.8997128637514,
    "h": 0.78763027912545,
    "CMY_C": 0.03105994,
    "CMY_M": 0.488971,
    "CMY_Y": 0.6516357,
    "CMYK_C": 0,
    "CMYK_M": 0.4725897,
    "CMYK_Y": 0.6404687,
    "CMYK_K": 0.03105994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04407",
    "Farbtonhilfsbezeichnung": "L0.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "196",
    "Bcolor": "188",
    "Y": 54,
    "L": 78.3203140109291,
    "a": -4.20052410125749,
    "b": 2.03508663342171,
    "C": 4.66754542889266,
    "h": -0.45115792211147,
    "CMY_C": 0.2661741,
    "CMY_M": 0.2309313,
    "CMY_Y": 0.2613792,
    "CMYK_C": 0.04582531,
    "CMYK_M": 0,
    "CMYK_Y": 0.03959056,
    "CMYK_K": 0.2309313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04408",
    "Farbtonhilfsbezeichnung": "DN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 72,
    "L": 88.1149398339186,
    "a": 0.84344253242585,
    "b": 1.78312830948786,
    "C": 1.97254705231636,
    "h": 1.12897060722491,
    "CMY_C": 0.120659,
    "CMY_M": 0.1352137,
    "CMY_Y": 0.1528887,
    "CMYK_C": 0,
    "CMYK_M": 0.01655182,
    "CMYK_Y": 0.03665214,
    "CMYK_K": 0.120659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04409",
    "Farbtonhilfsbezeichnung": "D1.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "207",
    "Bcolor": "196",
    "Y": 66,
    "L": 84.7749473506437,
    "a": 6.75996273738394,
    "b": 7.4950155593164,
    "C": 10.093183563436,
    "h": 0.8369171740713,
    "CMY_C": 0.09628468,
    "CMY_M": 0.1878975,
    "CMY_Y": 0.2301217,
    "CMYK_C": 0,
    "CMYK_M": 0.1013735,
    "CMYK_Y": 0.1480964,
    "CMYK_K": 0.09628468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04410",
    "Farbtonhilfsbezeichnung": "D1.14.73",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "188",
    "Bcolor": "169",
    "Y": 56,
    "L": 79.7674632239642,
    "a": 13.8902139167384,
    "b": 14.8781993383302,
    "C": 20.3543326641736,
    "h": 0.81972738656989,
    "CMY_C": 0.08493786,
    "CMY_M": 0.2623716,
    "CMY_Y": 0.3357155,
    "CMYK_C": 0,
    "CMYK_M": 0.1939035,
    "CMYK_Y": 0.2740554,
    "CMYK_K": 0.08493786
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04411",
    "Farbtonhilfsbezeichnung": "D1.43.56",
    "Farbtonklasse": "04",
    "Rcolor": "230",
    "Gcolor": "126",
    "Bcolor": "86",
    "Y": 33,
    "L": 63.7606223443616,
    "a": 36.7614023236358,
    "b": 39.1020758579337,
    "C": 53.6691069163613,
    "h": 0.81624213833899,
    "CMY_C": 0.09809225,
    "CMY_M": 0.5044036,
    "CMY_Y": 0.6644115,
    "CMYK_C": 0,
    "CMYK_M": 0.4505021,
    "CMYK_Y": 0.6279127,
    "CMYK_K": 0.09809225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04412",
    "Farbtonhilfsbezeichnung": "D0.52.52",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "109",
    "Bcolor": "70",
    "Y": 28,
    "L": 59.6857206891417,
    "a": 43.744189894183,
    "b": 42.6989519174808,
    "C": 61.1290000273984,
    "h": 0.77330712854186,
    "CMY_C": 0.1075552,
    "CMY_M": 0.5730608,
    "CMY_Y": 0.726784,
    "CMYK_C": 0,
    "CMYK_M": 0.5216072,
    "CMYK_Y": 0.6938567,
    "CMYK_K": 0.1075552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04413",
    "Farbtonhilfsbezeichnung": "DN.01.75",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "206",
    "Bcolor": "203",
    "Y": 62,
    "L": 82.9051424274157,
    "a": 0.9668971135538,
    "b": 1.21966546953032,
    "C": 1.55642985250325,
    "h": 0.9004880952114,
    "CMY_C": 0.1790101,
    "CMY_M": 0.1926371,
    "CMY_Y": 0.2054919,
    "CMYK_C": 0,
    "CMYK_M": 0.01659821,
    "CMYK_Y": 0.03225591,
    "CMYK_K": 0.1790101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04414",
    "Farbtonhilfsbezeichnung": "DN.02.79",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "216",
    "Bcolor": "212",
    "Y": 70,
    "L": 86.7750686376622,
    "a": 2.02830094520806,
    "b": 2.12363146722938,
    "C": 2.93663333307697,
    "h": 0.80835464861035,
    "CMY_C": 0.1252714,
    "CMY_M": 0.1529323,
    "CMY_Y": 0.1698726,
    "CMYK_C": 0,
    "CMYK_M": 0.03162225,
    "CMYK_Y": 0.05098864,
    "CMYK_K": 0.1252714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04415",
    "Farbtonhilfsbezeichnung": "D0.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "193",
    "Bcolor": "184",
    "Y": 56,
    "L": 79.7445630156597,
    "a": 6.93896700481922,
    "b": 6.91181704212946,
    "C": 9.79400213997532,
    "h": 0.78343799075847,
    "CMY_C": 0.1526287,
    "CMY_M": 0.242873,
    "CMY_Y": 0.2796825,
    "CMYK_C": 0,
    "CMYK_M": 0.1064991,
    "CMYK_Y": 0.1499388,
    "CMYK_K": 0.1526287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04416",
    "Farbtonhilfsbezeichnung": "D1.14.64",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "166",
    "Bcolor": "149",
    "Y": 43,
    "L": 71.7060243102662,
    "a": 14.0912949677183,
    "b": 14.5642109380667,
    "C": 20.2652617578886,
    "h": 0.80190015933553,
    "CMY_C": 0.1750375,
    "CMY_M": 0.3486596,
    "CMY_Y": 0.4169751,
    "CMYK_C": 0,
    "CMYK_M": 0.2104605,
    "CMYK_Y": 0.293271,
    "CMYK_K": 0.1750375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04417",
    "Farbtonhilfsbezeichnung": "D0.18.65",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "165",
    "Bcolor": "145",
    "Y": 44,
    "L": 72.3258770439831,
    "a": 18.5532049026356,
    "b": 17.3537648944146,
    "C": 25.4042234317406,
    "h": 0.75200647960543,
    "CMY_C": 0.1341322,
    "CMY_M": 0.3547495,
    "CMY_Y": 0.4295596,
    "CMYK_C": 0,
    "CMYK_M": 0.2547933,
    "CMYK_Y": 0.3411923,
    "CMYK_K": 0.1341322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04418",
    "Farbtonhilfsbezeichnung": "D0.29.54",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "128",
    "Bcolor": "101",
    "Y": 29,
    "L": 60.3692217806576,
    "a": 24.9736433658291,
    "b": 25.3365458068283,
    "C": 35.5756014198654,
    "h": 0.79261133736919,
    "CMY_C": 0.2186298,
    "CMY_M": 0.4984589,
    "CMY_Y": 0.6026561,
    "CMYK_C": 0,
    "CMYK_M": 0.3581262,
    "CMYK_Y": 0.491478,
    "CMYK_K": 0.2186298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04419",
    "Farbtonhilfsbezeichnung": "D0.35.55",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "128",
    "Bcolor": "97",
    "Y": 31,
    "L": 62.5148870753694,
    "a": 31.9521445381932,
    "b": 30.791082915793,
    "C": 44.3737571963073,
    "h": 0.76689530392154,
    "CMY_C": 0.1480351,
    "CMY_M": 0.49943,
    "CMY_Y": 0.6183542,
    "CMYK_C": 0,
    "CMYK_M": 0.4124523,
    "CMYK_Y": 0.5520405,
    "CMYK_K": 0.1480351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04420",
    "Farbtonhilfsbezeichnung": "D1.50.49",
    "Farbtonklasse": "04",
    "Rcolor": "209",
    "Gcolor": "103",
    "Bcolor": "64",
    "Y": 24,
    "L": 55.7423650595841,
    "a": 38.8807226377831,
    "b": 40.5838681734802,
    "C": 56.2028553434667,
    "h": 0.80682764290139,
    "CMY_C": 0.1819577,
    "CMY_M": 0.5943518,
    "CMY_Y": 0.749814,
    "CMYK_C": 0,
    "CMYK_M": 0.5041232,
    "CMYK_Y": 0.6941649,
    "CMYK_K": 0.1819577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04421",
    "Farbtonhilfsbezeichnung": "C9.04.69",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "184",
    "Bcolor": "177",
    "Y": 50,
    "L": 75.9370488967649,
    "a": 4.49622864657701,
    "b": 4.65492075225533,
    "C": 6.47181267127511,
    "h": 0.80273764660813,
    "CMY_C": 0.2182304,
    "CMY_M": 0.27729,
    "CMY_Y": 0.3042235,
    "CMYK_C": 0,
    "CMYK_M": 0.07554606,
    "CMYK_Y": 0.1099981,
    "CMYK_K": 0.2182304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04422",
    "Farbtonhilfsbezeichnung": "D0.07.67",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "178",
    "Bcolor": "170",
    "Y": 47,
    "L": 74.4541244506836,
    "a": 7.44948244094849,
    "b": 6.72144031524658,
    "C": 10.0335712432861,
    "h": 42.0589714050293,
    "CMY_C": 0.20775401592255,
    "CMY_M": 0.30076861381531,
    "CMY_Y": 0.33408343791962,
    "CMYK_C": 0,
    "CMYK_M": 0.11740621179342,
    "CMYK_Y": 0.15945732593536,
    "CMYK_K": 0.20775401592255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04423",
    "Farbtonhilfsbezeichnung": "C9.14.59",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "152",
    "Bcolor": "137",
    "Y": 35,
    "L": 66.0095448170801,
    "a": 13.0004322474421,
    "b": 12.9187618546329,
    "C": 18.3277288957757,
    "h": 0.78224721193656,
    "CMY_C": 0.2484729,
    "CMY_M": 0.4049146,
    "CMY_Y": 0.4635219,
    "CMYK_C": 0,
    "CMYK_M": 0.2081651,
    "CMYK_Y": 0.2861494,
    "CMYK_K": 0.2484729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04424",
    "Farbtonhilfsbezeichnung": "D0.19.55",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "138",
    "Bcolor": "120",
    "Y": 30,
    "L": 61.7564295702448,
    "a": 15.9660368200751,
    "b": 16.4737758922431,
    "C": 22.9412210635756,
    "h": 0.80104861185646,
    "CMY_C": 0.2697414,
    "CMY_M": 0.4571758,
    "CMY_Y": 0.5299463,
    "CMYK_C": 0,
    "CMYK_M": 0.2566686,
    "CMYK_Y": 0.3563188,
    "CMYK_K": 0.2697414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04425",
    "Farbtonhilfsbezeichnung": "D0.22.59",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "149",
    "Bcolor": "128",
    "Y": 37,
    "L": 66.9965900692921,
    "a": 20.8649446539033,
    "b": 19.6908481011293,
    "C": 28.6892909349846,
    "h": 0.75645609051672,
    "CMY_C": 0.1760436,
    "CMY_M": 0.4173944,
    "CMY_Y": 0.4993327,
    "CMYK_C": 0,
    "CMYK_M": 0.292917,
    "CMYK_Y": 0.3923619,
    "CMYK_K": 0.1760436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04426",
    "Farbtonhilfsbezeichnung": "C9.43.49",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "109",
    "Bcolor": "76",
    "Y": 25,
    "L": 57.1761724992487,
    "a": 37.341975763848,
    "b": 35.6481595373182,
    "C": 51.6257148361735,
    "h": 0.76219622981066,
    "CMY_C": 0.1770601,
    "CMY_M": 0.5732836,
    "CMY_Y": 0.7015342,
    "CMYK_C": 0,
    "CMYK_M": 0.4814732,
    "CMYK_Y": 0.6373176,
    "CMYK_K": 0.1770601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04427",
    "Farbtonhilfsbezeichnung": "D0.64.45",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "86",
    "Bcolor": "45",
    "Y": 22,
    "L": 53.7254446367611,
    "a": 50.2314199186354,
    "b": 48.6534045457874,
    "C": 69.9310326031179,
    "h": 0.76944140310947,
    "CMY_C": 0.1443511,
    "CMY_M": 0.6643267,
    "CMY_Y": 0.8248238,
    "CMYK_C": 0,
    "CMYK_M": 0.6076974,
    "CMYK_Y": 0.7952709,
    "CMYK_K": 0.1443511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04428",
    "Farbtonhilfsbezeichnung": "D0.04.63",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "167",
    "Bcolor": "161",
    "Y": 40,
    "L": 69.5069339301491,
    "a": 3.8611413968565,
    "b": 4.17605750134906,
    "C": 5.68751871566967,
    "h": 0.82456045090648,
    "CMY_C": 0.2934419,
    "CMY_M": 0.3438862,
    "CMY_Y": 0.3682489,
    "CMYK_C": 0,
    "CMYK_M": 0.07139452,
    "CMYK_Y": 0.1058753,
    "CMYK_K": 0.2934419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04429",
    "Farbtonhilfsbezeichnung": "D0.04.55",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "147",
    "Bcolor": "143",
    "Y": 30,
    "L": 61.8468178074906,
    "a": 3.61076853813985,
    "b": 3.1972000682124,
    "C": 4.8228350285074,
    "h": 0.72472501859674,
    "CMY_C": 0.3787785,
    "CMY_M": 0.4226674,
    "CMY_Y": 0.440124,
    "CMYK_C": 0,
    "CMYK_M": 0.07064938,
    "CMYK_Y": 0.09874985,
    "CMYK_K": 0.3787785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04430",
    "Farbtonhilfsbezeichnung": "C9.09.54",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "144",
    "Bcolor": "135",
    "Y": 30,
    "L": 61.7471493624455,
    "a": 8.2101335213971,
    "b": 7.69569558240013,
    "C": 11.2530006192189,
    "h": 0.75306670353909,
    "CMY_C": 0.3370812,
    "CMY_M": 0.4356129,
    "CMY_Y": 0.4712142,
    "CMYK_C": 0,
    "CMYK_M": 0.1486332,
    "CMYK_Y": 0.202337,
    "CMYK_K": 0.3370812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04431",
    "Farbtonhilfsbezeichnung": "D0.17.50",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "128",
    "Bcolor": "112",
    "Y": 25,
    "L": 57.1400142438019,
    "a": 14.3056478256041,
    "b": 14.2226361512153,
    "C": 20.1726284554112,
    "h": 0.78248836902733,
    "CMY_C": 0.3341893,
    "CMY_M": 0.4990744,
    "CMY_Y": 0.5601408,
    "CMYK_C": 0,
    "CMYK_M": 0.2476457,
    "CMYK_Y": 0.339363,
    "CMYK_K": 0.3341893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04432",
    "Farbtonhilfsbezeichnung": "C9.24.49",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "123",
    "Bcolor": "103",
    "Y": 25,
    "L": 57.3252927032417,
    "a": 21.1781162891805,
    "b": 19.7229082970665,
    "C": 28.9396911049954,
    "h": 0.74983439822461,
    "CMY_C": 0.2825822,
    "CMY_M": 0.5170025,
    "CMY_Y": 0.5942941,
    "CMYK_C": 0,
    "CMYK_M": 0.3267557,
    "CMYK_Y": 0.4344915,
    "CMYK_K": 0.2825822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04433",
    "Farbtonhilfsbezeichnung": "D1.32.48",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "116",
    "Bcolor": "89",
    "Y": 24,
    "L": 55.704335002281,
    "a": 24.6397227916918,
    "b": 26.1256525423749,
    "C": 35.9119152930655,
    "h": 0.81466034446232,
    "CMY_C": 0.2723537,
    "CMY_M": 0.5446067,
    "CMY_Y": 0.6526116,
    "CMYK_C": 0,
    "CMYK_M": 0.3741557,
    "CMYK_Y": 0.5225862,
    "CMYK_K": 0.2723537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04434",
    "Farbtonhilfsbezeichnung": "C9.47.44",
    "Farbtonklasse": "04",
    "Rcolor": "197",
    "Gcolor": "96",
    "Bcolor": "65",
    "Y": 21,
    "L": 52.4599434649058,
    "a": 38.1812962606311,
    "b": 35.4761272410312,
    "C": 52.1187776925353,
    "h": 0.74868830297261,
    "CMY_C": 0.2287827,
    "CMY_M": 0.6240339,
    "CMY_Y": 0.7435859,
    "CMYK_C": 0,
    "CMYK_M": 0.5125031,
    "CMYK_Y": 0.6675203,
    "CMYK_K": 0.2287827
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04435",
    "Farbtonhilfsbezeichnung": "D1.64.44",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "84",
    "Bcolor": "43",
    "Y": 20,
    "L": 52.0773699360406,
    "a": 48.1446403670934,
    "b": 47.353597821651,
    "C": 67.5297684190567,
    "h": 0.77711503201042,
    "CMY_C": 0.1756458,
    "CMY_M": 0.6715719,
    "CMY_Y": 0.8309168,
    "CMYK_C": 0,
    "CMYK_M": 0.6015935,
    "CMYK_Y": 0.7948902,
    "CMYK_K": 0.1756458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04436",
    "Farbtonhilfsbezeichnung": "C9.04.49",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "134",
    "Bcolor": "130",
    "Y": 25,
    "L": 56.7764829471273,
    "a": 3.48259040463955,
    "b": 3.18379011524865,
    "C": 4.71857557155149,
    "h": 0.74060617591821,
    "CMY_C": 0.4321081,
    "CMY_M": 0.4740126,
    "CMY_Y": 0.4910649,
    "CMYK_C": 0,
    "CMYK_M": 0.07378957,
    "CMYK_Y": 0.1038169,
    "CMYK_K": 0.4321081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04437",
    "Farbtonhilfsbezeichnung": "D0.06.52",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "142",
    "Bcolor": "135",
    "Y": 28,
    "L": 60.3099086455329,
    "a": 5.62047422499912,
    "b": 5.27597026032334,
    "C": 7.70879969266913,
    "h": 0.75379251008787,
    "CMY_C": 0.3754551,
    "CMY_M": 0.4435651,
    "CMY_Y": 0.4695375,
    "CMYK_C": 0,
    "CMYK_M": 0.1090556,
    "CMYK_Y": 0.1506417,
    "CMYK_K": 0.3754551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04438",
    "Farbtonhilfsbezeichnung": "D0.10.49",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "133",
    "Bcolor": "124",
    "Y": 25,
    "L": 57.4171687320464,
    "a": 7.83149437238584,
    "b": 7.87808480731373,
    "C": 11.1083988196292,
    "h": 0.7883638888188,
    "CMY_C": 0.3847573,
    "CMY_M": 0.478763,
    "CMY_Y": 0.5156738,
    "CMYK_C": 0,
    "CMYK_M": 0.1527944,
    "CMYK_Y": 0.2127883,
    "CMYK_K": 0.3847573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04440",
    "Farbtonhilfsbezeichnung": "D1.27.44",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "109",
    "Bcolor": "86",
    "Y": 19,
    "L": 50.9170193035471,
    "a": 18.8769124428568,
    "b": 20.5047840087546,
    "C": 27.8708448135495,
    "h": 0.82671038483945,
    "CMY_C": 0.3648222,
    "CMY_M": 0.5743882,
    "CMY_Y": 0.6608297,
    "CMYK_C": 0,
    "CMYK_M": 0.3299329,
    "CMYK_Y": 0.466023,
    "CMYK_K": 0.3648222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04441",
    "Farbtonhilfsbezeichnung": "D1.43.41",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "92",
    "Bcolor": "62",
    "Y": 17,
    "L": 47.8399823560291,
    "a": 29.8921222654853,
    "b": 30.9168598027734,
    "C": 43.0045485222095,
    "h": 0.80224831475412,
    "CMY_C": 0.328533,
    "CMY_M": 0.639654,
    "CMY_Y": 0.7565448,
    "CMYK_C": 0,
    "CMYK_M": 0.4633451,
    "CMYK_Y": 0.637428,
    "CMYK_K": 0.328533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04442",
    "Farbtonhilfsbezeichnung": "D0.61.42",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "80",
    "Bcolor": "47",
    "Y": 19,
    "L": 50.5385483313655,
    "a": 47.684849478665,
    "b": 43.7550061304934,
    "C": 64.7174275700329,
    "h": 0.74244723727676,
    "CMY_C": 0.1988232,
    "CMY_M": 0.6849205,
    "CMY_Y": 0.8172562,
    "CMYK_C": 0,
    "CMYK_M": 0.6067292,
    "CMYK_Y": 0.7719057,
    "CMYK_K": 0.1988232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04443",
    "Farbtonhilfsbezeichnung": "DN.02.49",
    "Farbtonklasse": "01",
    "Rcolor": "137",
    "Gcolor": "134",
    "Bcolor": "131",
    "Y": 24,
    "L": 56.1517059548377,
    "a": 0.80609369487194,
    "b": 1.71928294275663,
    "C": 1.89887358246045,
    "h": 1.13237402372999,
    "CMY_C": 0.4612128,
    "CMY_M": 0.474032,
    "CMY_Y": 0.487819,
    "CMYK_C": 0,
    "CMYK_M": 0.02379271,
    "CMYK_Y": 0.04938158,
    "CMYK_K": 0.4612128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04444",
    "Farbtonhilfsbezeichnung": "C9.09.44",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "119",
    "Bcolor": "113",
    "Y": 20,
    "L": 51.9513499681523,
    "a": 7.14798116586507,
    "b": 6.25203032875086,
    "C": 9.49639499911321,
    "h": 0.7186355874607,
    "CMY_C": 0.4495976,
    "CMY_M": 0.531397,
    "CMY_Y": 0.5585327,
    "CMYK_C": 0,
    "CMYK_M": 0.1486174,
    "CMYK_Y": 0.1979189,
    "CMYK_K": 0.4495976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04445",
    "Farbtonhilfsbezeichnung": "D0.12.40",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "111",
    "Bcolor": "103",
    "Y": 17,
    "L": 48.7532950885286,
    "a": 7.89722035107648,
    "b": 7.3709707023033,
    "C": 10.8026523765078,
    "h": 0.75094474292923,
    "CMY_C": 0.475034,
    "CMY_M": 0.5648667,
    "CMY_Y": 0.5966352,
    "CMYK_C": 0,
    "CMYK_M": 0.171121,
    "CMYK_Y": 0.2316365,
    "CMYK_K": 0.475034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04446",
    "Farbtonhilfsbezeichnung": "C9.14.39",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "104",
    "Bcolor": "95",
    "Y": 16,
    "L": 46.6563150412663,
    "a": 10.4049397501285,
    "b": 9.39346329127109,
    "C": 14.0178430512066,
    "h": 0.73435375208588,
    "CMY_C": 0.4770525,
    "CMY_M": 0.5916788,
    "CMY_Y": 0.6293475,
    "CMYK_C": 0,
    "CMYK_M": 0.2191928,
    "CMYK_Y": 0.2912242,
    "CMYK_K": 0.4770525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04447",
    "Farbtonhilfsbezeichnung": "C9.23.39",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "100",
    "Bcolor": "84",
    "Y": 16,
    "L": 46.9823184053376,
    "a": 17.640184028241,
    "b": 16.1279525352398,
    "C": 23.9016096848968,
    "h": 0.74064527101281,
    "CMY_C": 0.4205475,
    "CMY_M": 0.6084639,
    "CMY_Y": 0.6688355,
    "CMYK_C": 0,
    "CMYK_M": 0.3242999,
    "CMYK_Y": 0.4284872,
    "CMYK_K": 0.4205475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04448",
    "Farbtonhilfsbezeichnung": "D1.35.40",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "98",
    "Bcolor": "74",
    "Y": 17,
    "L": 48.03460522113,
    "a": 23.479914245406,
    "b": 24.2154155878149,
    "C": 33.7297009334831,
    "h": 0.80081776636706,
    "CMY_C": 0.3666514,
    "CMY_M": 0.6164083,
    "CMY_Y": 0.7112204,
    "CMYK_C": 0,
    "CMYK_M": 0.3943435,
    "CMYK_Y": 0.5440432,
    "CMYK_K": 0.3666514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04449",
    "Farbtonhilfsbezeichnung": "C9.47.35",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "79",
    "Bcolor": "56",
    "Y": 13,
    "L": 43.38123340053,
    "a": 32.2264775565532,
    "b": 28.8760978271295,
    "C": 43.2709473136997,
    "h": 0.73062096205848,
    "CMY_C": 0.3693651,
    "CMY_M": 0.6907084,
    "CMY_Y": 0.781828,
    "CMYK_C": 0,
    "CMYK_M": 0.5095552,
    "CMYK_Y": 0.6540439,
    "CMYK_K": 0.3693651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04450",
    "Farbtonhilfsbezeichnung": "D0.58.39",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "81",
    "Bcolor": "47",
    "Y": 17,
    "L": 47.8568749104977,
    "a": 40.7227630307033,
    "b": 39.8036963590165,
    "C": 56.9445139824338,
    "h": 0.77398543303072,
    "CMY_C": 0.2674918,
    "CMY_M": 0.681033,
    "CMY_Y": 0.815285,
    "CMYK_C": 0,
    "CMYK_M": 0.564555,
    "CMYK_Y": 0.7478322,
    "CMYK_K": 0.2674918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04451",
    "Farbtonhilfsbezeichnung": "C8.04.30",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "87",
    "Bcolor": "85",
    "Y": 10,
    "L": 37.6963520666698,
    "a": 3.67389357091283,
    "b": 2.1319763549715,
    "C": 4.24768373923391,
    "h": 0.52581148879996,
    "CMY_C": 0.6226652,
    "CMY_M": 0.6599789,
    "CMY_Y": 0.6678796,
    "CMYK_C": 0,
    "CMYK_M": 0.09888764,
    "CMYK_Y": 0.1198256,
    "CMYK_K": 0.6226652
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04452",
    "Farbtonhilfsbezeichnung": "D0.09.40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "110",
    "Bcolor": "104",
    "Y": 17,
    "L": 48.0750135849685,
    "a": 6.52278059264738,
    "b": 5.81918656503868,
    "C": 8.74125842991408,
    "h": 0.72845154472785,
    "CMY_C": 0.4939948,
    "CMY_M": 0.5679475,
    "CMY_Y": 0.593213,
    "CMYK_C": 0,
    "CMYK_M": 0.1461502,
    "CMYK_Y": 0.1960814,
    "CMYK_K": 0.4939948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04453",
    "Farbtonhilfsbezeichnung": "D1.14.30",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "82",
    "Bcolor": "73",
    "Y": 10,
    "L": 37.0934509747061,
    "a": 8.349094501021,
    "b": 8.73066115571121,
    "C": 12.08022446823,
    "h": 0.80773473558594,
    "CMY_C": 0.5863182,
    "CMY_M": 0.6774022,
    "CMY_Y": 0.7138086,
    "CMYK_C": 0,
    "CMYK_M": 0.2201788,
    "CMYK_Y": 0.3081846,
    "CMYK_K": 0.5863182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04454",
    "Farbtonhilfsbezeichnung": "C9.28.35",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "89",
    "Bcolor": "73",
    "Y": 13,
    "L": 43.0367593148143,
    "a": 19.0705024617912,
    "b": 17.4015984877298,
    "C": 25.8166553618655,
    "h": 0.73967168775857,
    "CMY_C": 0.4529108,
    "CMY_M": 0.6505026,
    "CMY_Y": 0.7130366,
    "CMYK_C": 0,
    "CMYK_M": 0.3611694,
    "CMYK_Y": 0.4754724,
    "CMYK_K": 0.4529108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04456",
    "Farbtonhilfsbezeichnung": "C9.38.35",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "82",
    "Bcolor": "62",
    "Y": 13,
    "L": 42.6069303980653,
    "a": 26.7163694247335,
    "b": 23.6018035539933,
    "C": 35.6484154800761,
    "h": 0.72357959565243,
    "CMY_C": 0.4105199,
    "CMY_M": 0.6785809,
    "CMY_Y": 0.755372,
    "CMYK_C": 0,
    "CMYK_M": 0.4547414,
    "CMYK_Y": 0.5850106,
    "CMYK_K": 0.4105199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04457",
    "Farbtonhilfsbezeichnung": "D0.60.34",
    "Farbtonklasse": "04",
    "Rcolor": "168",
    "Gcolor": "71",
    "Bcolor": "44",
    "Y": 13,
    "L": 42.7398668820281,
    "a": 38.3104431091665,
    "b": 35.0628463679064,
    "C": 51.933546447745,
    "h": 0.74116573895851,
    "CMY_C": 0.342524,
    "CMY_M": 0.7213444,
    "CMY_Y": 0.82766,
    "CMYK_C": 0,
    "CMYK_M": 0.5761737,
    "CMYK_Y": 0.7378764,
    "CMYK_K": 0.342524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04458",
    "Farbtonhilfsbezeichnung": "D3.04.17",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "62",
    "Bcolor": "59",
    "Y": 5,
    "L": 26.634098301792,
    "a": 1.78454553926349,
    "b": 2.13346089649884,
    "C": 2.7814129823877,
    "h": 0.87421816656813,
    "CMY_C": 0.7366374,
    "CMY_M": 0.7567922,
    "CMY_Y": 0.7675822,
    "CMYK_C": 0,
    "CMYK_M": 0.07652868,
    "CMYK_Y": 0.1174989,
    "CMYK_K": 0.7366374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04459",
    "Farbtonhilfsbezeichnung": "D1.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "88",
    "Bcolor": "82",
    "Y": 10,
    "L": 38.642033505614,
    "a": 5.39963396720736,
    "b": 5.50150865507459,
    "C": 7.70860846467637,
    "h": 0.79474321334395,
    "CMY_C": 0.5950347,
    "CMY_M": 0.6556264,
    "CMY_Y": 0.679962,
    "CMYK_C": 0,
    "CMYK_M": 0.1496221,
    "CMYK_Y": 0.2097153,
    "CMYK_K": 0.5950347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04460",
    "Farbtonhilfsbezeichnung": "D1.13.23",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 7,
    "L": 31.6299834267524,
    "a": 6.18682048954985,
    "b": 6.14083796901786,
    "C": 8.71703153210113,
    "h": 0.7816681519411,
    "CMY_C": 0.6563261,
    "CMY_M": 0.7220975,
    "CMY_Y": 0.7470608,
    "CMYK_C": 0,
    "CMYK_M": 0.1913772,
    "CMYK_Y": 0.2640138,
    "CMYK_K": 0.6563261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04461",
    "Farbtonhilfsbezeichnung": "D0.14.25",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "75",
    "Bcolor": "68",
    "Y": 8,
    "L": 33.8985494847081,
    "a": 7.22223704198208,
    "b": 7.0610004161437,
    "C": 10.1004175541093,
    "h": 0.77411012187308,
    "CMY_C": 0.62699,
    "CMY_M": 0.7039409,
    "CMY_Y": 0.7323568,
    "CMYK_C": 0,
    "CMYK_M": 0.2062971,
    "CMYK_Y": 0.2824772,
    "CMYK_K": 0.62699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04462",
    "Farbtonhilfsbezeichnung": "D0.16.22",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "72",
    "Bcolor": "66",
    "Y": 7,
    "L": 32.7359896752084,
    "a": 8.18829744153654,
    "b": 7.09301510147181,
    "C": 10.8332395072195,
    "h": 0.71384589871734,
    "CMY_C": 0.6326951,
    "CMY_M": 0.7167249,
    "CMY_Y": 0.7427576,
    "CMYK_C": 0,
    "CMYK_M": 0.2287739,
    "CMYK_Y": 0.2996488,
    "CMYK_K": 0.6326951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04463",
    "Farbtonhilfsbezeichnung": "D1.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "76",
    "Bcolor": "56",
    "Y": 11,
    "L": 38.8489439256487,
    "a": 22.6144560727077,
    "b": 22.1737060893471,
    "C": 31.6715466183952,
    "h": 0.77555771147014,
    "CMY_C": 0.4735709,
    "CMY_M": 0.701176,
    "CMY_Y": 0.7803326,
    "CMYK_C": 0,
    "CMYK_M": 0.4323566,
    "CMYK_Y": 0.5827216,
    "CMYK_K": 0.4735709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04464",
    "Farbtonhilfsbezeichnung": "D1.50.31",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "74",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.5740972247879,
    "a": 27.3515740582184,
    "b": 25.3462092823567,
    "C": 37.2899306575814,
    "h": 0.74736245313453,
    "CMY_C": 0.4390487,
    "CMY_M": 0.709817,
    "CMY_Y": 0.7933419,
    "CMYK_C": 0,
    "CMYK_M": 0.4826949,
    "CMYK_Y": 0.6315936,
    "CMYK_K": 0.4390487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04465",
    "Farbtonhilfsbezeichnung": "C9.51.30",
    "Farbtonklasse": "04",
    "Rcolor": "149",
    "Gcolor": "69",
    "Bcolor": "50",
    "Y": 11,
    "L": 39.5149153912751,
    "a": 32.39771880166,
    "b": 26.9064847181898,
    "C": 42.1137875694127,
    "h": 0.69306708776444,
    "CMY_C": 0.4138384,
    "CMY_M": 0.728264,
    "CMY_Y": 0.8026009,
    "CMYK_C": 0,
    "CMYK_M": 0.5364146,
    "CMYK_Y": 0.6632343,
    "CMYK_K": 0.4138384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04466",
    "Farbtonhilfsbezeichnung": "DN.02.09",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "51",
    "Bcolor": "51",
    "Y": 3,
    "L": 21.3316510814591,
    "a": 0.41979050206106,
    "b": -0.13716982586006,
    "C": 0.44163290949289,
    "h": -0.3158209573008,
    "CMY_C": 0.797062,
    "CMY_M": 0.799838,
    "CMY_Y": 0.8002674,
    "CMYK_C": 0,
    "CMYK_M": 0.01367872,
    "CMYK_Y": 0.01579464,
    "CMYK_K": 0.797062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04467",
    "Farbtonhilfsbezeichnung": "D1.13.21",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "64",
    "Bcolor": "57",
    "Y": 6,
    "L": 28.8064487569787,
    "a": 6.41777261488036,
    "b": 6.72373905629836,
    "C": 9.29497026533707,
    "h": 0.80867639666091,
    "CMY_C": 0.6805227,
    "CMY_M": 0.7480686,
    "CMY_Y": 0.7752699,
    "CMYK_C": 0,
    "CMYK_M": 0.2114264,
    "CMYK_Y": 0.2965695,
    "CMYK_K": 0.6805227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04468",
    "Farbtonhilfsbezeichnung": "D1.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "56",
    "Bcolor": "49",
    "Y": 5,
    "L": 25.5927808547036,
    "a": 7.36510408921928,
    "b": 7.61557698796163,
    "C": 10.5944216975069,
    "h": 0.80211633272013,
    "CMY_C": 0.7038613,
    "CMY_M": 0.7786619,
    "CMY_Y": 0.807968,
    "CMYK_C": 0,
    "CMYK_M": 0.2525864,
    "CMYK_Y": 0.351547,
    "CMYK_K": 0.7038613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04469",
    "Farbtonhilfsbezeichnung": "D1.20.13",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "53",
    "Bcolor": "47",
    "Y": 4,
    "L": 24.2423270050638,
    "a": 7.72665827899521,
    "b": 6.77749152315555,
    "C": 10.277919999047,
    "h": 0.72005029437683,
    "CMY_C": 0.7159147,
    "CMY_M": 0.7910357,
    "CMY_Y": 0.8144326,
    "CMYK_C": 0,
    "CMYK_M": 0.264431,
    "CMYK_Y": 0.3467897,
    "CMYK_K": 0.7159147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04470",
    "Farbtonhilfsbezeichnung": "D1.22.21",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "65",
    "Bcolor": "56",
    "Y": 6,
    "L": 30.3261821504908,
    "a": 11.1237887356863,
    "b": 10.0911189691251,
    "C": 15.0189666051036,
    "h": 0.73675994485494,
    "CMY_C": 0.6350384,
    "CMY_M": 0.7459427,
    "CMY_Y": 0.7815735,
    "CMYK_C": 0,
    "CMYK_M": 0.3038793,
    "CMYK_Y": 0.4015082,
    "CMYK_K": 0.6350384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04471",
    "Farbtonhilfsbezeichnung": "D0.31.20",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "62",
    "Bcolor": "51",
    "Y": 7,
    "L": 30.7345161258977,
    "a": 15.9432031399154,
    "b": 13.6151495874606,
    "C": 20.9656391424048,
    "h": 0.70679914569016,
    "CMY_C": 0.6013919,
    "CMY_M": 0.75517,
    "CMY_Y": 0.7985222,
    "CMYK_C": 0,
    "CMYK_M": 0.3857877,
    "CMYK_Y": 0.4945465,
    "CMYK_K": 0.6013919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04472",
    "Farbtonhilfsbezeichnung": "D1.34.28",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "73",
    "Bcolor": "56",
    "Y": 9,
    "L": 36.4214564941377,
    "a": 19.2987573241808,
    "b": 18.7481198677598,
    "C": 26.906022241006,
    "h": 0.77092656790637,
    "CMY_C": 0.5198363,
    "CMY_M": 0.7134945,
    "CMY_Y": 0.780471,
    "CMYK_C": 0,
    "CMYK_M": 0.4033172,
    "CMYK_Y": 0.5428039,
    "CMYK_K": 0.5198363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04473",
    "Farbtonhilfsbezeichnung": "D0.37.25",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "66",
    "Bcolor": "49",
    "Y": 8,
    "L": 34.1794272740476,
    "a": 21.6920847121726,
    "b": 20.2887747422152,
    "C": 29.7015305952475,
    "h": 0.7519832296139,
    "CMY_C": 0.5298685,
    "CMY_M": 0.7413972,
    "CMY_Y": 0.8090196,
    "CMYK_C": 0,
    "CMYK_M": 0.4499352,
    "CMYK_Y": 0.5937724,
    "CMYK_K": 0.5298685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04474",
    "Farbtonhilfsbezeichnung": "D5.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "235",
    "Bcolor": "225",
    "Y": 85,
    "L": 94.0907030121493,
    "a": 3.92540347494053,
    "b": 5.78991574383663,
    "C": 6.99513522112349,
    "h": 0.97500741660529,
    "CMY_C": 0.0172078,
    "CMY_M": 0.07725088,
    "CMY_Y": 0.1163787,
    "CMYK_C": 0,
    "CMYK_M": 0.06109437,
    "CMYK_Y": 0.1009072,
    "CMYK_K": 0.0172078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04475",
    "Farbtonhilfsbezeichnung": "D1.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 79,
    "L": 91.0593547807679,
    "a": 5.01605967491031,
    "b": 5.86968893936484,
    "C": 7.72101696068356,
    "h": 0.8636551575815,
    "CMY_C": 0.04308262,
    "CMY_M": 0.1138059,
    "CMY_Y": 0.1501645,
    "CMYK_C": 0,
    "CMYK_M": 0.07390736,
    "CMYK_Y": 0.1119029,
    "CMYK_K": 0.04308262
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04476",
    "Farbtonhilfsbezeichnung": "D1.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "218",
    "Bcolor": "209",
    "Y": 73,
    "L": 88.3749811131777,
    "a": 5.93544938363627,
    "b": 6.02045610260191,
    "C": 8.45431552930601,
    "h": 0.79250806290915,
    "CMY_C": 0.06608529,
    "CMY_M": 0.1458752,
    "CMY_Y": 0.1804695,
    "CMYK_C": 0,
    "CMYK_M": 0.085436,
    "CMYK_Y": 0.1224782,
    "CMYK_K": 0.06608529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04477",
    "Farbtonhilfsbezeichnung": "D3.11.80",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "209",
    "Bcolor": "192",
    "Y": 69,
    "L": 86.5185682919224,
    "a": 10.7552839727602,
    "b": 12.4195822860967,
    "C": 16.4293078824349,
    "h": 0.85708988254326,
    "CMY_C": 0.03528751,
    "CMY_M": 0.1802067,
    "CMY_Y": 0.2467604,
    "CMYK_C": 0,
    "CMYK_M": 0.1502201,
    "CMYK_Y": 0.2192082,
    "CMYK_K": 0.03528751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04478",
    "Farbtonhilfsbezeichnung": "D3.22.73",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "185",
    "Bcolor": "153",
    "Y": 57,
    "L": 80.3241438004891,
    "a": 20.0311272624435,
    "b": 24.7579334380184,
    "C": 31.8465277153657,
    "h": 0.89054379533144,
    "CMY_C": 0.01897343,
    "CMY_M": 0.2754034,
    "CMY_Y": 0.4003423,
    "CMYK_C": 0,
    "CMYK_M": 0.2613894,
    "CMYK_Y": 0.3887447,
    "CMYK_K": 0.01897343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04479",
    "Farbtonhilfsbezeichnung": "D1.25.63",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "156",
    "Bcolor": "129",
    "Y": 42,
    "L": 70.7687824866741,
    "a": 23.3633328561715,
    "b": 24.576320210217,
    "C": 33.9093031073094,
    "h": 0.81069514658627,
    "CMY_C": 0.1097972,
    "CMY_M": 0.3863085,
    "CMY_Y": 0.4955308,
    "CMYK_C": 0,
    "CMYK_M": 0.3106161,
    "CMYK_Y": 0.4333098,
    "CMYK_K": 0.1097972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04480",
    "Farbtonhilfsbezeichnung": "D3.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "231",
    "Bcolor": "223",
    "Y": 81,
    "L": 92.2803682480196,
    "a": 3.34463788161538,
    "b": 4.30742771344756,
    "C": 5.45348843087731,
    "h": 0.91056135354724,
    "CMY_C": 0.04669567,
    "CMY_M": 0.0956559,
    "CMY_Y": 0.1254077,
    "CMYK_C": 0,
    "CMYK_M": 0.05135844,
    "CMYK_Y": 0.08256756,
    "CMYK_K": 0.04669567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04481",
    "Farbtonhilfsbezeichnung": "D3.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "228",
    "Bcolor": "218",
    "Y": 80,
    "L": 91.6378057981672,
    "a": 4.75459508340603,
    "b": 6.04667842861737,
    "C": 7.69210598121577,
    "h": 0.90445566226329,
    "CMY_C": 0.03797095,
    "CMY_M": 0.1067705,
    "CMY_Y": 0.1451697,
    "CMYK_C": 0,
    "CMYK_M": 0.07151501,
    "CMYK_Y": 0.1114299,
    "CMYK_K": 0.03797095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04482",
    "Farbtonhilfsbezeichnung": "D2.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "195",
    "Bcolor": "177",
    "Y": 60,
    "L": 81.7880704984771,
    "a": 12.5477155521697,
    "b": 13.6970919188183,
    "C": 18.5756693718078,
    "h": 0.82916462638701,
    "CMY_C": 0.07370105,
    "CMY_M": 0.2367408,
    "CMY_Y": 0.3061368,
    "CMYK_C": 0,
    "CMYK_M": 0.1760121,
    "CMYK_Y": 0.2509295,
    "CMYK_K": 0.07370105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04483",
    "Farbtonhilfsbezeichnung": "D2.30.63",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "154",
    "Bcolor": "119",
    "Y": 42,
    "L": 70.5633858991667,
    "a": 26.061981831445,
    "b": 29.5074547438476,
    "C": 39.3689824918397,
    "h": 0.84732191233958,
    "CMY_C": 0.08877092,
    "CMY_M": 0.3974495,
    "CMY_Y": 0.5321316,
    "CMYK_C": 0,
    "CMYK_M": 0.3387497,
    "CMYK_Y": 0.4865524,
    "CMYK_K": 0.08877092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04484",
    "Farbtonhilfsbezeichnung": "D2.44.62",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "141",
    "Bcolor": "92",
    "Y": 41,
    "L": 69.9307668960695,
    "a": 38.7725851701746,
    "b": 43.5830820199128,
    "C": 58.3335100875379,
    "h": 0.84374311100049,
    "CMY_C": 0.007812662,
    "CMY_M": 0.4479701,
    "CMY_Y": 0.6374103,
    "CMYK_C": 0,
    "CMYK_M": 0.4436233,
    "CMYK_Y": 0.6345552,
    "CMYK_K": 0.007812662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04485",
    "Farbtonhilfsbezeichnung": "D3.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "205",
    "Bcolor": "194",
    "Y": 64,
    "L": 84.1554547160715,
    "a": 6.95497034305276,
    "b": 7.90171302350209,
    "C": 10.5265702476412,
    "h": 0.84903714892279,
    "CMY_C": 0.1006913,
    "CMY_M": 0.195263,
    "CMY_Y": 0.2397162,
    "CMYK_C": 0,
    "CMYK_M": 0.1051604,
    "CMYK_Y": 0.1545909,
    "CMYK_K": 0.1006913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04486",
    "Farbtonhilfsbezeichnung": "D3.14.72",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "189",
    "Bcolor": "169",
    "Y": 57,
    "L": 80.1370716566771,
    "a": 13.3944046103062,
    "b": 15.7357725607345,
    "C": 20.6645738632026,
    "h": 0.86560177514326,
    "CMY_C": 0.08211986,
    "CMY_M": 0.2572978,
    "CMY_Y": 0.3381203,
    "CMYK_C": 0,
    "CMYK_M": 0.1908506,
    "CMYK_Y": 0.2789039,
    "CMYK_K": 0.08211986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04487",
    "Farbtonhilfsbezeichnung": "D2.19.71",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "183",
    "Bcolor": "157",
    "Y": 54,
    "L": 78.8853530883789,
    "a": 17.8431186676025,
    "b": 20.3711261749268,
    "C": 27.0806140899658,
    "h": 48.7848052978516,
    "CMY_C": 0.05777156352997,
    "CMY_M": 0.283735871315,
    "CMY_Y": 0.38383668661118,
    "CMYK_C": 0,
    "CMYK_M": 0.23981903493404,
    "CMYK_Y": 0.34605741500854,
    "CMYK_K": 0.05777156352997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04488",
    "Farbtonhilfsbezeichnung": "D2.28.66",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "161",
    "Bcolor": "126",
    "Y": 45,
    "L": 73.1410953220454,
    "a": 24.8799748195737,
    "b": 29.2156620406087,
    "C": 38.3740544573242,
    "h": 0.8653757594025,
    "CMY_C": 0.06596489,
    "CMY_M": 0.3667993,
    "CMY_Y": 0.5046197,
    "CMYK_C": 0,
    "CMYK_M": 0.3220804,
    "CMYK_Y": 0.4696341,
    "CMYK_K": 0.06596489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04489",
    "Farbtonhilfsbezeichnung": "D2.43.59",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "136",
    "Bcolor": "90",
    "Y": 36,
    "L": 66.8973148723256,
    "a": 35.6791669893444,
    "b": 40.7335744724145,
    "C": 54.1500419792382,
    "h": 0.85144808050299,
    "CMY_C": 0.06450975,
    "CMY_M": 0.4684651,
    "CMY_Y": 0.6466324,
    "CMYK_C": 0,
    "CMYK_M": 0.4318114,
    "CMYK_Y": 0.6222647,
    "CMYK_K": 0.06450975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04490",
    "Farbtonhilfsbezeichnung": "D3.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "219",
    "Bcolor": "207",
    "Y": 73,
    "L": 88.4593682546896,
    "a": 4.62017889187521,
    "b": 7.18983759576024,
    "C": 8.54633357916344,
    "h": 0.99964187562242,
    "CMY_C": 0.07144176,
    "CMY_M": 0.1420136,
    "CMY_Y": 0.1883553,
    "CMYK_C": 0,
    "CMYK_M": 0.07600154,
    "CMYK_Y": 0.1259087,
    "CMYK_K": 0.07144176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04491",
    "Farbtonhilfsbezeichnung": "D3.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "206",
    "Bcolor": "199",
    "Y": 64,
    "L": 83.8898788670398,
    "a": 4.30647656343808,
    "b": 4.91938123736946,
    "C": 6.53804650870763,
    "h": 0.85173404291423,
    "CMY_C": 0.1314672,
    "CMY_M": 0.1908628,
    "CMY_Y": 0.221263,
    "CMYK_C": 0,
    "CMYK_M": 0.06838615,
    "CMYK_Y": 0.1033879,
    "CMYK_K": 0.1314672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04492",
    "Farbtonhilfsbezeichnung": "D0.20.66",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "169",
    "Bcolor": "148",
    "Y": 47,
    "L": 74.1303316156292,
    "a": 19.137801988683,
    "b": 18.7610218472135,
    "C": 26.7998396582827,
    "h": 0.77545675385868,
    "CMY_C": 0.1072329,
    "CMY_M": 0.337639,
    "CMY_Y": 0.4210011,
    "CMYK_C": 0,
    "CMYK_M": 0.2580808,
    "CMYK_Y": 0.3514558,
    "CMYK_K": 0.1072329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04493",
    "Farbtonhilfsbezeichnung": "D3.22.69",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "176",
    "Bcolor": "146",
    "Y": 51,
    "L": 76.795961375314,
    "a": 19.2403212718112,
    "b": 23.4640480158743,
    "C": 30.3438875547245,
    "h": 0.88398372534396,
    "CMY_C": 0.06724073,
    "CMY_M": 0.3106876,
    "CMY_Y": 0.4273973,
    "CMYK_C": 0,
    "CMYK_M": 0.2609965,
    "CMYK_Y": 0.3861195,
    "CMYK_K": 0.06724073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04494",
    "Farbtonhilfsbezeichnung": "D3.39.61",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "142",
    "Bcolor": "100",
    "Y": 38,
    "L": 68.2669941673423,
    "a": 32.7859629806544,
    "b": 37.0368252668229,
    "C": 49.4635804851813,
    "h": 0.84620384236283,
    "CMY_C": 0.067967,
    "CMY_M": 0.4439007,
    "CMY_Y": 0.6072012,
    "CMYK_C": 0,
    "CMYK_M": 0.4033481,
    "CMYK_Y": 0.578557,
    "CMYK_K": 0.067967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04495",
    "Farbtonhilfsbezeichnung": "D2.51.58",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "124",
    "Bcolor": "74",
    "Y": 34,
    "L": 65.2531458529779,
    "a": 42.7763110331416,
    "b": 47.3226421924456,
    "C": 63.7906360657918,
    "h": 0.83581471481682,
    "CMY_C": 0.04051489,
    "CMY_M": 0.5121917,
    "CMY_Y": 0.7092852,
    "CMYK_C": 0,
    "CMYK_M": 0.4915937,
    "CMYK_Y": 0.6970096,
    "CMYK_K": 0.04051489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04496",
    "Farbtonhilfsbezeichnung": "E7.14.81",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "215",
    "Bcolor": "183",
    "Y": 72,
    "L": 87.8185056366609,
    "a": 6.49073225909064,
    "b": 19.2859879185362,
    "C": 20.3489295849468,
    "h": 1.24615203327821,
    "CMY_C": 0.03355299,
    "CMY_M": 0.1567691,
    "CMY_Y": 0.2841719,
    "CMYK_C": 0,
    "CMYK_M": 0.1274939,
    "CMYK_Y": 0.2593198,
    "CMYK_K": 0.03355299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04497",
    "Farbtonhilfsbezeichnung": "J1.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "220",
    "Bcolor": "192",
    "Y": 69,
    "L": 86.3868505188529,
    "a": -7.67032948334967,
    "b": 11.7774365812627,
    "C": 14.0549623552967,
    "h": -0.99352654277965,
    "CMY_C": 0.1742781,
    "CMY_M": 0.1374118,
    "CMY_Y": 0.2463816,
    "CMYK_C": 0.04273915,
    "CMYK_M": 0,
    "CMYK_Y": 0.126329,
    "CMYK_K": 0.1374118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04498",
    "Farbtonhilfsbezeichnung": "D3.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "215",
    "Bcolor": "208",
    "Y": 69,
    "L": 86.6599911433667,
    "a": 3.32157265723287,
    "b": 4.19529027309939,
    "C": 5.35100975450797,
    "h": 0.90111324971508,
    "CMY_C": 0.1102108,
    "CMY_M": 0.1578855,
    "CMY_Y": 0.1861198,
    "CMYK_C": 0,
    "CMYK_M": 0.05357983,
    "CMYK_Y": 0.08531124,
    "CMYK_K": 0.1102108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04499",
    "Farbtonhilfsbezeichnung": "D3.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "196",
    "Bcolor": "186",
    "Y": 58,
    "L": 80.5162847377027,
    "a": 6.05125139634721,
    "b": 6.66984990750736,
    "C": 9.00580597450723,
    "h": 0.83398763656781,
    "CMY_C": 0.1510942,
    "CMY_M": 0.2322849,
    "CMY_Y": 0.2698579,
    "CMYK_C": 0,
    "CMYK_M": 0.09564161,
    "CMYK_Y": 0.1399021,
    "CMYK_K": 0.1510942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04500",
    "Farbtonhilfsbezeichnung": "D3.14.63",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "165",
    "Bcolor": "147",
    "Y": 42,
    "L": 70.8837192419306,
    "a": 12.0201413489913,
    "b": 14.1588823517862,
    "C": 18.5730381871532,
    "h": 0.86691387424614,
    "CMY_C": 0.198414,
    "CMY_M": 0.351857,
    "CMY_Y": 0.4228831,
    "CMYK_C": 0,
    "CMYK_M": 0.1914242,
    "CMYK_Y": 0.2800311,
    "CMYK_K": 0.198414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04501",
    "Farbtonhilfsbezeichnung": "D2.23.61",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "154",
    "Bcolor": "127",
    "Y": 39,
    "L": 68.7009056941013,
    "a": 19.7409770170625,
    "b": 22.5545864990747,
    "C": 29.9735807959681,
    "h": 0.85182286431444,
    "CMY_C": 0.1585648,
    "CMY_M": 0.39718,
    "CMY_Y": 0.5026522,
    "CMYK_C": 0,
    "CMYK_M": 0.2835812,
    "CMYK_Y": 0.4089291,
    "CMYK_K": 0.1585648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04502",
    "Farbtonhilfsbezeichnung": "D2.48.57",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "127",
    "Bcolor": "79",
    "Y": 35,
    "L": 65.4310760498208,
    "a": 40.7482724215818,
    "b": 44.7643049928737,
    "C": 60.5331703022274,
    "h": 0.83232791284974,
    "CMY_C": 0.05122598,
    "CMY_M": 0.5023398,
    "CMY_Y": 0.6889452,
    "CMYK_C": 0,
    "CMYK_M": 0.4754703,
    "CMYK_Y": 0.6721508,
    "CMYK_K": 0.05122598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04503",
    "Farbtonhilfsbezeichnung": "D3.65.52",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "104",
    "Bcolor": "44",
    "Y": 28,
    "L": 60.0067911909339,
    "a": 48.9612809291532,
    "b": 56.000287477212,
    "C": 74.3857461329377,
    "h": 0.85236060131466,
    "CMY_C": 0.06815798,
    "CMY_M": 0.593464,
    "CMY_Y": 0.8277953,
    "CMYK_C": 0,
    "CMYK_M": 0.5637286,
    "CMYK_Y": 0.8151997,
    "CMYK_K": 0.06815798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04504",
    "Farbtonhilfsbezeichnung": "E8.16.81",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "217",
    "Bcolor": "180",
    "Y": 74,
    "L": 88.6924639848009,
    "a": 6.53809920773418,
    "b": 21.9323592870497,
    "C": 22.8861339056296,
    "h": 1.28108092780001,
    "CMY_C": 0.01709714,
    "CMY_M": 0.147865,
    "CMY_Y": 0.2944966,
    "CMYK_C": 0,
    "CMYK_M": 0.1330425,
    "CMYK_Y": 0.2822247,
    "CMYK_K": 0.01709714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04505",
    "Farbtonhilfsbezeichnung": "V7.34.39",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "103",
    "Bcolor": "165",
    "Y": 15,
    "L": 46.0113685624062,
    "a": 16.4421456689408,
    "b": -34.3389511355901,
    "C": 38.0724010182063,
    "h": -1.12423656308967,
    "CMY_C": 0.5926169,
    "CMY_M": 0.5978453,
    "CMY_Y": 0.3515348,
    "CMYK_C": 0.3717734,
    "CMYK_M": 0.379836,
    "CMYK_Y": 0,
    "CMYK_K": 0.3515348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04506",
    "Farbtonhilfsbezeichnung": "W0.37.33",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "91",
    "Bcolor": "158",
    "Y": 13,
    "L": 42.0296951734646,
    "a": 19.5221616902134,
    "b": -35.9757760211299,
    "C": 40.9312992388629,
    "h": -1.07361561865505,
    "CMY_C": 0.6171804,
    "CMY_M": 0.6429207,
    "CMY_Y": 0.3823101,
    "CMYK_C": 0.3802399,
    "CMYK_M": 0.4219117,
    "CMYK_Y": 0,
    "CMYK_K": 0.3823101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04507",
    "Farbtonhilfsbezeichnung": "G1.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "226",
    "Bcolor": "204",
    "Y": 76,
    "L": 89.8949263526735,
    "a": -0.68439452543767,
    "b": 10.6761401823023,
    "C": 10.698054265081,
    "h": -1.50677887088174,
    "CMY_C": 0.08485033,
    "CMY_M": 0.1142343,
    "CMY_Y": 0.1993236,
    "CMYK_C": 0,
    "CMYK_M": 0.03210838,
    "CMYK_Y": 0.1250869,
    "CMYK_K": 0.08485033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04508",
    "Farbtonhilfsbezeichnung": "D3.05.71",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "189",
    "Bcolor": "181",
    "Y": 53,
    "L": 78.0606555025811,
    "a": 5.36231787603575,
    "b": 5.79484679653504,
    "C": 7.89523289073634,
    "h": 0.82414568120469,
    "CMY_C": 0.185549,
    "CMY_M": 0.2568825,
    "CMY_Y": 0.2897719,
    "CMYK_C": 0,
    "CMYK_M": 0.08758479,
    "CMYK_Y": 0.1279671,
    "CMYK_K": 0.185549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04509",
    "Farbtonhilfsbezeichnung": "D3.11.61",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "160",
    "Bcolor": "147",
    "Y": 38,
    "L": 68.283940494786,
    "a": 9.12324990268815,
    "b": 10.5868998128046,
    "C": 13.9755549597596,
    "h": 0.85952080766093,
    "CMY_C": 0.2539684,
    "CMY_M": 0.3709533,
    "CMY_Y": 0.4248538,
    "CMYK_C": 0,
    "CMYK_M": 0.1568096,
    "CMYK_Y": 0.2290593,
    "CMYK_K": 0.2539684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04510",
    "Farbtonhilfsbezeichnung": "D3.14.59",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "153",
    "Bcolor": "135",
    "Y": 35,
    "L": 66.097575031045,
    "a": 11.8099037488865,
    "b": 14.0033434507323,
    "C": 18.3185003304619,
    "h": 0.87016794106234,
    "CMY_C": 0.2527782,
    "CMY_M": 0.4012246,
    "CMY_Y": 0.4703683,
    "CMYK_C": 0,
    "CMYK_M": 0.1986644,
    "CMYK_Y": 0.2911989,
    "CMYK_K": 0.2527782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04511",
    "Farbtonhilfsbezeichnung": "D2.52.52",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "111",
    "Bcolor": "65",
    "Y": 28,
    "L": 59.9264703076791,
    "a": 41.8905521483973,
    "b": 45.4329760868293,
    "C": 61.7978452326939,
    "h": 0.82594259311883,
    "CMY_C": 0.1120734,
    "CMY_M": 0.5637673,
    "CMY_Y": 0.7457756,
    "CMYK_C": 0,
    "CMYK_M": 0.5087063,
    "CMYK_Y": 0.7136877,
    "CMYK_K": 0.1120734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04512",
    "Farbtonhilfsbezeichnung": "D2.07.65",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "174",
    "Bcolor": "165",
    "Y": 44,
    "L": 72.4365547155926,
    "a": 6.35130659571931,
    "b": 6.48681274941521,
    "C": 9.07842690771938,
    "h": 0.79595275618837,
    "CMY_C": 0.2380146,
    "CMY_M": 0.3194909,
    "CMY_Y": 0.3536685,
    "CMYK_C": 0,
    "CMYK_M": 0.1069264,
    "CMYK_Y": 0.1517796,
    "CMYK_K": 0.2380146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04513",
    "Farbtonhilfsbezeichnung": "D2.25.52",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "131",
    "Bcolor": "107",
    "Y": 28,
    "L": 59.9750903828662,
    "a": 19.3214186816867,
    "b": 21.4160394760013,
    "C": 28.8437855821784,
    "h": 0.83677048548039,
    "CMY_C": 0.2611472,
    "CMY_M": 0.4854339,
    "CMY_Y": 0.5806537,
    "CMYK_C": 0,
    "CMYK_M": 0.3035607,
    "CMYK_Y": 0.432436,
    "CMYK_K": 0.2611472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04514",
    "Farbtonhilfsbezeichnung": "D1.25.54",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "135",
    "Bcolor": "111",
    "Y": 30,
    "L": 61.3677795812491,
    "a": 19.2282653437019,
    "b": 21.1152686862392,
    "C": 28.5583746004544,
    "h": 0.83213747602679,
    "CMY_C": 0.2466381,
    "CMY_M": 0.4709687,
    "CMY_Y": 0.5650663,
    "CMYK_C": 0,
    "CMYK_M": 0.2977727,
    "CMYK_Y": 0.4226763,
    "CMYK_K": 0.2466381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04515",
    "Farbtonhilfsbezeichnung": "D2.38.51",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "121",
    "Bcolor": "87",
    "Y": 27,
    "L": 59.2393304652914,
    "a": 29.5677814805225,
    "b": 32.1053963677591,
    "C": 43.6464222773281,
    "h": 0.82652113390118,
    "CMY_C": 0.1978015,
    "CMY_M": 0.5253696,
    "CMY_Y": 0.6594648,
    "CMYK_C": 0,
    "CMYK_M": 0.4083379,
    "CMYK_Y": 0.5754975,
    "CMYK_K": 0.1978015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04516",
    "Farbtonhilfsbezeichnung": "D2.46.47",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "107",
    "Bcolor": "70",
    "Y": 24,
    "L": 56.1389171455368,
    "a": 36.0175709010359,
    "b": 37.7251858345939,
    "C": 52.1579817464767,
    "h": 0.80855040084432,
    "CMY_C": 0.1943784,
    "CMY_M": 0.5794056,
    "CMY_Y": 0.7264335,
    "CMYK_C": 0,
    "CMYK_M": 0.4779256,
    "CMYK_Y": 0.660428,
    "CMYK_K": 0.1943784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04517",
    "Farbtonhilfsbezeichnung": "D2.57.52",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "108",
    "Bcolor": "59",
    "Y": 27,
    "L": 59.1049632758737,
    "a": 43.0582404955924,
    "b": 47.3005530866895,
    "C": 63.9636959288862,
    "h": 0.83231334977609,
    "CMY_C": 0.1147662,
    "CMY_M": 0.5770797,
    "CMY_Y": 0.7673746,
    "CMYK_C": 0,
    "CMYK_M": 0.5222502,
    "CMYK_Y": 0.7372159,
    "CMYK_K": 0.1147662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04518",
    "Farbtonhilfsbezeichnung": "D3.73.47",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "91",
    "Bcolor": "39",
    "Y": 24,
    "L": 55.7066149141016,
    "a": 49.8807503952073,
    "b": 53.5668064103246,
    "C": 73.1948905934709,
    "h": 0.82101521727611,
    "CMY_C": 0.1187791,
    "CMY_M": 0.6424839,
    "CMY_Y": 0.847787,
    "CMYK_C": 0,
    "CMYK_M": 0.5942946,
    "CMYK_Y": 0.8272703,
    "CMYK_K": 0.1187791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04519",
    "Farbtonhilfsbezeichnung": "D3.08.59",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "159",
    "Bcolor": "149",
    "Y": 37,
    "L": 67.2945910881455,
    "a": 6.89196643272011,
    "b": 7.76239684903122,
    "C": 10.3804627137518,
    "h": 0.84472581357027,
    "CMY_C": 0.2864727,
    "CMY_M": 0.3751453,
    "CMY_Y": 0.4156235,
    "CMYK_C": 0,
    "CMYK_M": 0.1242735,
    "CMYK_Y": 0.1810033,
    "CMYK_K": 0.2864727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04520",
    "Farbtonhilfsbezeichnung": "D3.16.52",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "138",
    "Bcolor": "121",
    "Y": 29,
    "L": 60.5257913319231,
    "a": 12.1819350705074,
    "b": 14.1610536588979,
    "C": 18.6798014655468,
    "h": 0.86038614441818,
    "CMY_C": 0.3107038,
    "CMY_M": 0.459404,
    "CMY_Y": 0.5269083,
    "CMYK_C": 0,
    "CMYK_M": 0.2157276,
    "CMYK_Y": 0.3136598,
    "CMYK_K": 0.3107038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04521",
    "Farbtonhilfsbezeichnung": "D2.21.50",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "129",
    "Bcolor": "109",
    "Y": 26,
    "L": 57.8295150280741,
    "a": 15.547540031202,
    "b": 17.142601413815,
    "C": 23.1429208237586,
    "h": 0.83415284237964,
    "CMY_C": 0.3140094,
    "CMY_M": 0.4960202,
    "CMY_Y": 0.5729924,
    "CMYK_C": 0,
    "CMYK_M": 0.2653255,
    "CMYK_Y": 0.3775314,
    "CMYK_K": 0.3140094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04522",
    "Farbtonhilfsbezeichnung": "D2.35.44",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "106",
    "Bcolor": "78",
    "Y": 20,
    "L": 51.6723429656879,
    "a": 24.5165069099521,
    "b": 26.8599758377517,
    "C": 36.3664325040322,
    "h": 0.83098021866222,
    "CMY_C": 0.3175091,
    "CMY_M": 0.5843879,
    "CMY_Y": 0.6953207,
    "CMYK_C": 0,
    "CMYK_M": 0.3910363,
    "CMYK_Y": 0.5535774,
    "CMYK_K": 0.3175091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04523",
    "Farbtonhilfsbezeichnung": "D3.50.40",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "87",
    "Bcolor": "51",
    "Y": 16,
    "L": 46.9561860707091,
    "a": 32.4543961944466,
    "b": 36.1315259173224,
    "C": 48.5672214303047,
    "h": 0.83896035935601,
    "CMY_C": 0.3213634,
    "CMY_M": 0.657892,
    "CMY_Y": 0.8001089,
    "CMYK_C": 0,
    "CMYK_M": 0.4958892,
    "CMYK_Y": 0.7054519,
    "CMYK_K": 0.3213634
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04524",
    "Farbtonhilfsbezeichnung": "D2.57.42",
    "Farbtonklasse": "04",
    "Rcolor": "193",
    "Gcolor": "93",
    "Bcolor": "54",
    "Y": 19,
    "L": 51.2460782513349,
    "a": 37.5675226444266,
    "b": 40.1995285499279,
    "C": 55.021094620845,
    "h": 0.81922999316176,
    "CMY_C": 0.2425336,
    "CMY_M": 0.6346785,
    "CMY_Y": 0.7888345,
    "CMYK_C": 0,
    "CMYK_M": 0.517706,
    "CMYK_Y": 0.7212213,
    "CMYK_K": 0.2425336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04525",
    "Farbtonhilfsbezeichnung": "D3.67.47",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "94",
    "Bcolor": "38",
    "Y": 23,
    "L": 55.1333415213821,
    "a": 46.1098271539172,
    "b": 53.0549360676965,
    "C": 70.2918373732788,
    "h": 0.8553200451648,
    "CMY_C": 0.1448365,
    "CMY_M": 0.6314793,
    "CMY_Y": 0.8514521,
    "CMYK_C": 0,
    "CMYK_M": 0.569064,
    "CMYK_Y": 0.826293,
    "CMYK_K": 0.1448365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04526",
    "Farbtonhilfsbezeichnung": "D2.05.39",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "111",
    "Bcolor": "108",
    "Y": 17,
    "L": 47.8285319003053,
    "a": 3.51019923948065,
    "b": 3.04662120352517,
    "C": 4.64794572457765,
    "h": 0.71481396551871,
    "CMY_C": 0.5226488,
    "CMY_M": 0.5629442,
    "CMY_Y": 0.5779542,
    "CMYK_C": 0,
    "CMYK_M": 0.08441464,
    "CMYK_Y": 0.1158589,
    "CMYK_K": 0.5226488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04528",
    "Farbtonhilfsbezeichnung": "D3.18.49",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "123",
    "Bcolor": "104",
    "Y": 23,
    "L": 55.302527177016,
    "a": 13.7549543810812,
    "b": 16.4924457921442,
    "C": 21.4755567618733,
    "h": 0.87565563275524,
    "CMY_C": 0.3531123,
    "CMY_M": 0.5165617,
    "CMY_Y": 0.5933299,
    "CMYK_C": 0,
    "CMYK_M": 0.2526705,
    "CMYK_Y": 0.3713436,
    "CMYK_K": 0.3531123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04529",
    "Farbtonhilfsbezeichnung": "D2.22.39",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "102",
    "Bcolor": "86",
    "Y": 16,
    "L": 47.175221176459,
    "a": 14.6739139723775,
    "b": 15.5463022659269,
    "C": 21.3778218116884,
    "h": 0.81425785369441,
    "CMY_C": 0.4359598,
    "CMY_M": 0.5986456,
    "CMY_Y": 0.6637977,
    "CMYK_C": 0,
    "CMYK_M": 0.2884294,
    "CMYK_Y": 0.4039391,
    "CMYK_K": 0.4359598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04530",
    "Farbtonhilfsbezeichnung": "D2.40.39",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "97",
    "Bcolor": "71",
    "Y": 17,
    "L": 48.428759418584,
    "a": 25.244822298556,
    "b": 26.441811294614,
    "C": 36.5577684962532,
    "h": 0.80855260376365,
    "CMY_C": 0.3504278,
    "CMY_M": 0.6183025,
    "CMY_Y": 0.7221064,
    "CMYK_C": 0,
    "CMYK_M": 0.4123863,
    "CMYK_Y": 0.5721898,
    "CMYK_K": 0.3504278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04531",
    "Farbtonhilfsbezeichnung": "D3.59.39",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "84",
    "Bcolor": "44",
    "Y": 17,
    "L": 47.8089315470676,
    "a": 38.0814006942239,
    "b": 41.1122260039164,
    "C": 56.0393451588359,
    "h": 0.82365057094684,
    "CMY_C": 0.2801102,
    "CMY_M": 0.671084,
    "CMY_Y": 0.8266743,
    "CMYK_C": 0,
    "CMYK_M": 0.5431023,
    "CMYK_Y": 0.759233,
    "CMYK_K": 0.2801102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04532",
    "Farbtonhilfsbezeichnung": "D3.11.33",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "95",
    "Bcolor": "87",
    "Y": 12,
    "L": 41.5636328913062,
    "a": 5.63319539722293,
    "b": 6.19308694494585,
    "C": 8.37181081313668,
    "h": 0.83270582841661,
    "CMY_C": 0.5635369,
    "CMY_M": 0.6287261,
    "CMY_Y": 0.6572595,
    "CMYK_C": 0,
    "CMYK_M": 0.1493579,
    "CMYK_Y": 0.214732,
    "CMYK_K": 0.5635369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04533",
    "Farbtonhilfsbezeichnung": "D3.10.37",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "104",
    "Bcolor": "97",
    "Y": 15,
    "L": 45.5045251163869,
    "a": 6.21739871331012,
    "b": 6.08063585588883,
    "C": 8.6965613418288,
    "h": 0.77427791330853,
    "CMY_C": 0.5211168,
    "CMY_M": 0.5922645,
    "CMY_Y": 0.6194485,
    "CMYK_C": 0,
    "CMYK_M": 0.1485699,
    "CMYK_Y": 0.2053353,
    "CMYK_K": 0.5211168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04534",
    "Farbtonhilfsbezeichnung": "D2.20.41",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "105",
    "Bcolor": "89",
    "Y": 17,
    "L": 48.0781990011481,
    "a": 13.6397778833593,
    "b": 15.0649741161415,
    "C": 20.3223272738973,
    "h": 0.83500760990255,
    "CMY_C": 0.433108,
    "CMY_M": 0.587139,
    "CMY_Y": 0.6524082,
    "CMYK_C": 0,
    "CMYK_M": 0.2717114,
    "CMYK_Y": 0.3868465,
    "CMYK_K": 0.433108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04535",
    "Farbtonhilfsbezeichnung": "D2.30.35",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "89",
    "Bcolor": "70",
    "Y": 13,
    "L": 42.7006102746358,
    "a": 18.4112186665487,
    "b": 19.0608623587432,
    "C": 26.5007442658961,
    "h": 0.80273316588393,
    "CMY_C": 0.4577443,
    "CMY_M": 0.6522028,
    "CMY_Y": 0.7269316,
    "CMYK_C": 0,
    "CMYK_M": 0.3586103,
    "CMYK_Y": 0.4964214,
    "CMYK_K": 0.4577443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04536",
    "Farbtonhilfsbezeichnung": "D3.41.33",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "81",
    "Bcolor": "54",
    "Y": 12,
    "L": 41.2775422151577,
    "a": 23.1736611070406,
    "b": 26.6006327609391,
    "C": 35.2790622379098,
    "h": 0.85413991174776,
    "CMY_C": 0.4399104,
    "CMY_M": 0.6807383,
    "CMY_Y": 0.7878446,
    "CMYK_C": 0,
    "CMYK_M": 0.4299811,
    "CMYK_Y": 0.6212117,
    "CMYK_K": 0.4399104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04537",
    "Farbtonhilfsbezeichnung": "D2.47.36",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "83",
    "Bcolor": "56",
    "Y": 13,
    "L": 42.9112401119662,
    "a": 26.6598725008287,
    "b": 27.874980514442,
    "C": 38.5715353653567,
    "h": 0.80767578813524,
    "CMY_C": 0.4031765,
    "CMY_M": 0.6762456,
    "CMY_Y": 0.7809384,
    "CMYK_C": 0,
    "CMYK_M": 0.4575375,
    "CMYK_Y": 0.632954,
    "CMYK_K": 0.4031765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04538",
    "Farbtonhilfsbezeichnung": "D3.64.41",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "88",
    "Bcolor": "37",
    "Y": 20,
    "L": 51.7554360488564,
    "a": 43.95197743257,
    "b": 49.5049969488416,
    "C": 66.2006121054628,
    "h": 0.84474631158517,
    "CMY_C": 0.1989255,
    "CMY_M": 0.6564716,
    "CMY_Y": 0.8543732,
    "CMYK_C": 0,
    "CMYK_M": 0.5711655,
    "CMYK_Y": 0.8182106,
    "CMYK_K": 0.1989255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04539",
    "Farbtonhilfsbezeichnung": "D3.09.20",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "67",
    "Bcolor": "63",
    "Y": 6,
    "L": 29.3776380267473,
    "a": 4.18104286811219,
    "b": 4.00943160610186,
    "C": 5.79281117152979,
    "h": 0.76444868651438,
    "CMY_C": 0.6933042,
    "CMY_M": 0.7376377,
    "CMY_Y": 0.7543814,
    "CMYK_C": 0,
    "CMYK_M": 0.1445519,
    "CMYK_Y": 0.1991456,
    "CMYK_K": 0.6933042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04540",
    "Farbtonhilfsbezeichnung": "D2.19.25",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "74",
    "Bcolor": "64",
    "Y": 8,
    "L": 33.9532083039374,
    "a": 9.31072130982979,
    "b": 10.1685124628894,
    "C": 13.787246897668,
    "h": 0.82940591725517,
    "CMY_C": 0.6091946,
    "CMY_M": 0.7088525,
    "CMY_Y": 0.7506168,
    "CMYK_C": 0,
    "CMYK_M": 0.2550063,
    "CMYK_Y": 0.3618737,
    "CMYK_K": 0.6091946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04541",
    "Farbtonhilfsbezeichnung": "D3.20.32",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "91",
    "Bcolor": "77",
    "Y": 12,
    "L": 41.3487249273943,
    "a": 11.11720017625,
    "b": 12.4195083698951,
    "C": 16.6684230780451,
    "h": 0.84067274080696,
    "CMY_C": 0.5215131,
    "CMY_M": 0.64484,
    "CMY_Y": 0.6979558,
    "CMYK_C": 0,
    "CMYK_M": 0.2577434,
    "CMYK_Y": 0.3687513,
    "CMYK_K": 0.5215131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04542",
    "Farbtonhilfsbezeichnung": "D2.25.23",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "68",
    "Bcolor": "57",
    "Y": 7,
    "L": 32.1440357264743,
    "a": 12.3242012287973,
    "b": 12.100198364212,
    "C": 17.2713849004986,
    "h": 0.77622714637464,
    "CMY_C": 0.6078733,
    "CMY_M": 0.7328981,
    "CMY_Y": 0.7778006,
    "CMYK_C": 0,
    "CMYK_M": 0.3188379,
    "CMYK_Y": 0.4333479,
    "CMYK_K": 0.6078733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04543",
    "Farbtonhilfsbezeichnung": "D3.27.30",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "82",
    "Bcolor": "66",
    "Y": 10,
    "L": 38.4836317908289,
    "a": 13.7605855234422,
    "b": 15.1909151936512,
    "C": 20.4967709254084,
    "h": 0.8347623630199,
    "CMY_C": 0.5318705,
    "CMY_M": 0.6788557,
    "CMY_Y": 0.7409292,
    "CMYK_C": 0,
    "CMYK_M": 0.313984,
    "CMYK_Y": 0.446583,
    "CMYK_K": 0.5318705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04544",
    "Farbtonhilfsbezeichnung": "D3.31.30",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "80",
    "Bcolor": "64",
    "Y": 10,
    "L": 38.5781154266184,
    "a": 16.2318529709161,
    "b": 16.9295982799755,
    "C": 23.4538770524361,
    "h": 0.80643591482393,
    "CMY_C": 0.5153796,
    "CMY_M": 0.6847239,
    "CMY_Y": 0.7506208,
    "CMYK_C": 0,
    "CMYK_M": 0.3494369,
    "CMYK_Y": 0.4854134,
    "CMYK_K": 0.5153796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04545",
    "Farbtonhilfsbezeichnung": "D2.42.29",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "75",
    "Bcolor": "55",
    "Y": 10,
    "L": 38.3132874965711,
    "a": 21.959989222128,
    "b": 22.286209033374,
    "C": 31.2876371705378,
    "h": 0.79277086237144,
    "CMY_C": 0.4824791,
    "CMY_M": 0.7042546,
    "CMY_Y": 0.7859071,
    "CMYK_C": 0,
    "CMYK_M": 0.4285344,
    "CMYK_Y": 0.5863106,
    "CMYK_K": 0.4824791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04546",
    "Farbtonhilfsbezeichnung": "D2.54.34",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "78",
    "Bcolor": "47",
    "Y": 13,
    "L": 43.3037058711873,
    "a": 32.6033951672611,
    "b": 33.5036793743877,
    "C": 46.7490952645541,
    "h": 0.79901589738898,
    "CMY_C": 0.3646443,
    "CMY_M": 0.693579,
    "CMY_Y": 0.8139791,
    "CMYK_C": 0,
    "CMYK_M": 0.5177175,
    "CMYK_Y": 0.7072177,
    "CMYK_K": 0.3646443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04547",
    "Farbtonhilfsbezeichnung": "D2.07.19",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "65",
    "Bcolor": "61",
    "Y": 6,
    "L": 28.3068277325478,
    "a": 3.19525834354784,
    "b": 3.38873114181819,
    "C": 4.65759322327965,
    "h": 0.8147750540673,
    "CMY_C": 0.7102491,
    "CMY_M": 0.7450394,
    "CMY_Y": 0.7602108,
    "CMYK_C": 0,
    "CMYK_M": 0.1200696,
    "CMYK_Y": 0.1724298,
    "CMYK_K": 0.7102491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04548",
    "Farbtonhilfsbezeichnung": "D2.20.19",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "65",
    "Bcolor": "55",
    "Y": 6,
    "L": 29.4895281903085,
    "a": 8.30826087505601,
    "b": 9.18938450649479,
    "C": 12.3883811039293,
    "h": 0.83571236052642,
    "CMY_C": 0.6594484,
    "CMY_M": 0.746673,
    "CMY_Y": 0.78383,
    "CMYK_C": 0,
    "CMYK_M": 0.2561275,
    "CMYK_Y": 0.3652358,
    "CMYK_K": 0.6594484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04549",
    "Farbtonhilfsbezeichnung": "D2.20.15",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "58",
    "Bcolor": "51",
    "Y": 5,
    "L": 26.5473320370765,
    "a": 8.01396858019415,
    "b": 7.37765190117972,
    "C": 10.8928159802376,
    "h": 0.74407993230183,
    "CMY_C": 0.6919233,
    "CMY_M": 0.7716979,
    "CMY_Y": 0.7983578,
    "CMYK_C": 0,
    "CMYK_M": 0.2589442,
    "CMYK_Y": 0.3454807,
    "CMYK_K": 0.6919233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04550",
    "Farbtonhilfsbezeichnung": "D3.22.16",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "60",
    "Bcolor": "53",
    "Y": 5,
    "L": 27.2335022368979,
    "a": 7.66676476599631,
    "b": 7.30133686460392,
    "C": 10.5871999125145,
    "h": 0.76098923472654,
    "CMY_C": 0.6874639,
    "CMY_M": 0.7648708,
    "CMY_Y": 0.7920892,
    "CMYK_C": 0,
    "CMYK_M": 0.2476732,
    "CMYK_Y": 0.3347624,
    "CMYK_K": 0.6874639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04551",
    "Farbtonhilfsbezeichnung": "D2.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "65",
    "Bcolor": "51",
    "Y": 7,
    "L": 30.9202206309127,
    "a": 13.094381485709,
    "b": 13.9376154980159,
    "C": 19.1238059042601,
    "h": 0.81658197369465,
    "CMY_C": 0.6134695,
    "CMY_M": 0.7461925,
    "CMY_Y": 0.7994335,
    "CMYK_C": 0,
    "CMYK_M": 0.3433699,
    "CMYK_Y": 0.4811109,
    "CMYK_K": 0.6134695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04552",
    "Farbtonhilfsbezeichnung": "D2.37.24",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "67",
    "Bcolor": "51",
    "Y": 8,
    "L": 33.4407337001354,
    "a": 17.6440071866654,
    "b": 18.0021144547206,
    "C": 25.2068862504665,
    "h": 0.79544400302567,
    "CMY_C": 0.5600032,
    "CMY_M": 0.7361046,
    "CMY_Y": 0.8019588,
    "CMYK_C": 0,
    "CMYK_M": 0.4002335,
    "CMYK_Y": 0.5499032,
    "CMYK_K": 0.5600032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04553",
    "Farbtonhilfsbezeichnung": "D3.49.30",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "73",
    "Bcolor": "48",
    "Y": 10,
    "L": 38.3116681989667,
    "a": 25.016197421678,
    "b": 26.0877852797406,
    "C": 36.1439161442451,
    "h": 0.8063638648466,
    "CMY_C": 0.4636571,
    "CMY_M": 0.7142864,
    "CMY_Y": 0.8098528,
    "CMYK_C": 0,
    "CMYK_M": 0.4672932,
    "CMYK_Y": 0.6454746,
    "CMYK_K": 0.4636571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04554",
    "Farbtonhilfsbezeichnung": "D2.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "115",
    "Gcolor": "65",
    "Bcolor": "47",
    "Y": 8,
    "L": 33.3049012369435,
    "a": 19.8520433576624,
    "b": 20.1798659763792,
    "C": 28.3077836698519,
    "h": 0.79358701315526,
    "CMY_C": 0.5481504,
    "CMY_M": 0.7439574,
    "CMY_Y": 0.8162557,
    "CMYK_C": 0,
    "CMYK_M": 0.4333456,
    "CMYK_Y": 0.5933507,
    "CMYK_K": 0.5481504
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04555",
    "Farbtonhilfsbezeichnung": "D4.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "226",
    "Bcolor": "213",
    "Y": 79,
    "L": 91.433324950528,
    "a": 6.06664925475153,
    "b": 8.22794899118788,
    "C": 10.222689361502,
    "h": 0.93545852168935,
    "CMY_C": 0.0241626,
    "CMY_M": 0.1129032,
    "CMY_Y": 0.1633807,
    "CMYK_C": 0,
    "CMYK_M": 0.09093785,
    "CMYK_Y": 0.1426653,
    "CMYK_K": 0.0241626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04556",
    "Farbtonhilfsbezeichnung": "D5.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "226",
    "Bcolor": "211",
    "Y": 79,
    "L": 91.4027364151712,
    "a": 6.54837016805726,
    "b": 9.3931581575259,
    "C": 11.450439818199,
    "h": 0.96199069409659,
    "CMY_C": 0.01768497,
    "CMY_M": 0.114763,
    "CMY_Y": 0.1722787,
    "CMYK_C": 0,
    "CMYK_M": 0.09882574,
    "CMYK_Y": 0.1573769,
    "CMYK_K": 0.01768497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04557",
    "Farbtonhilfsbezeichnung": "D5.15.78",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "201",
    "Bcolor": "175",
    "Y": 65,
    "L": 84.5593574930119,
    "a": 13.7523223775002,
    "b": 18.6475837598238,
    "C": 23.1702125768051,
    "h": 0.93535273466931,
    "CMY_C": 0.0227509,
    "CMY_M": 0.2110185,
    "CMY_Y": 0.3127184,
    "CMYK_C": 0,
    "CMYK_M": 0.1926506,
    "CMYK_Y": 0.2967181,
    "CMYK_K": 0.0227509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04558",
    "Farbtonhilfsbezeichnung": "D4.36.67",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "158",
    "Bcolor": "108",
    "Y": 46,
    "L": 73.7519249452262,
    "a": 30.4505536201992,
    "b": 40.1198411487272,
    "C": 50.3670315739942,
    "h": 0.92156647489041,
    "CMY_C": 0.01171246,
    "CMY_M": 0.3794554,
    "CMY_Y": 0.5767733,
    "CMYK_C": 0,
    "CMYK_M": 0.3721012,
    "CMYK_Y": 0.5717576,
    "CMYK_K": 0.01171246
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04559",
    "Farbtonhilfsbezeichnung": "D5.44.64",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "151",
    "Bcolor": "96",
    "Y": 44,
    "L": 72.3220858115561,
    "a": 34.4081481271504,
    "b": 44.7225147192355,
    "C": 56.4271564085251,
    "h": 0.91501341723116,
    "CMY_C": 0.001590247,
    "CMY_M": 0.4081201,
    "CMY_Y": 0.6241302,
    "CMYK_C": 0,
    "CMYK_M": 0.4071774,
    "CMYK_Y": 0.6235315,
    "CMYK_K": 0.001590247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04560",
    "Farbtonhilfsbezeichnung": "D5.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "214",
    "Bcolor": "206",
    "Y": 69,
    "L": 86.3195130518881,
    "a": 3.5079715771818,
    "b": 4.66972328980251,
    "C": 5.84056334522958,
    "h": 0.9265173327098,
    "CMY_C": 0.1111534,
    "CMY_M": 0.1622146,
    "CMY_Y": 0.1932666,
    "CMYK_C": 0,
    "CMYK_M": 0.05744661,
    "CMYK_Y": 0.09238176,
    "CMYK_K": 0.1111534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04561",
    "Farbtonhilfsbezeichnung": "D4.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "211",
    "Bcolor": "193",
    "Y": 69,
    "L": 86.6979211314948,
    "a": 8.91437923452953,
    "b": 12.0918149188725,
    "C": 15.0225878319709,
    "h": 0.93552196023295,
    "CMY_C": 0.04697063,
    "CMY_M": 0.1734376,
    "CMY_Y": 0.2427349,
    "CMYK_C": 0,
    "CMYK_M": 0.1327,
    "CMYK_Y": 0.2054127,
    "CMYK_K": 0.04697063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04562",
    "Farbtonhilfsbezeichnung": "D4.15.77",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "200",
    "Bcolor": "177",
    "Y": 64,
    "L": 84.1890716477467,
    "a": 14.4393824606854,
    "b": 17.2137991377439,
    "C": 22.4679916013992,
    "h": 0.87282521468601,
    "CMY_C": 0.02556412,
    "CMY_M": 0.2165289,
    "CMY_Y": 0.3060201,
    "CMYK_C": 0,
    "CMYK_M": 0.1959747,
    "CMYK_Y": 0.2878137,
    "CMYK_K": 0.02556412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04563",
    "Farbtonhilfsbezeichnung": "D5.18.73",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "188",
    "Bcolor": "161",
    "Y": 57,
    "L": 80.0476025811238,
    "a": 14.3892127465848,
    "b": 19.8062546178228,
    "C": 24.481363635478,
    "h": 0.94250666374349,
    "CMY_C": 0.06788026,
    "CMY_M": 0.2618583,
    "CMY_Y": 0.3683371,
    "CMYK_C": 0,
    "CMYK_M": 0.2081042,
    "CMYK_Y": 0.3223372,
    "CMYK_K": 0.06788026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04564",
    "Farbtonhilfsbezeichnung": "D4.26.68",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "171",
    "Bcolor": "137",
    "Y": 49,
    "L": 75.6895618546233,
    "a": 21.9860916100731,
    "b": 26.9929943893117,
    "C": 34.8139335667192,
    "h": 0.88726961491497,
    "CMY_C": 0.05706903,
    "CMY_M": 0.3309647,
    "CMY_Y": 0.4635586,
    "CMYK_C": 0,
    "CMYK_M": 0.2904726,
    "CMYK_Y": 0.4310915,
    "CMYK_K": 0.05706903
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04565",
    "Farbtonhilfsbezeichnung": "D5.37.66",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "162",
    "Bcolor": "117",
    "Y": 48,
    "L": 74.8418566145922,
    "a": 29.6560191568829,
    "b": 36.9883171892458,
    "C": 47.4090189808401,
    "h": 0.8949787578594,
    "CMY_C": 0.00701848,
    "CMY_M": 0.3648593,
    "CMY_Y": 0.5430197,
    "CMYK_C": 0,
    "CMYK_M": 0.36037,
    "CMYK_Y": 0.5397897,
    "CMYK_K": 0.00701848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04566",
    "Farbtonhilfsbezeichnung": "D5.47.61",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "141",
    "Bcolor": "85",
    "Y": 39,
    "L": 68.8549496851686,
    "a": 35.2271152129154,
    "b": 45.7902568121818,
    "C": 57.7728073158088,
    "h": 0.91504800683129,
    "CMY_C": 0.0383068,
    "CMY_M": 0.4473866,
    "CMY_Y": 0.6657681,
    "CMYK_C": 0,
    "CMYK_M": 0.4253745,
    "CMYK_Y": 0.6524548,
    "CMYK_K": 0.0383068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04567",
    "Farbtonhilfsbezeichnung": "D5.08.72",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "194",
    "Bcolor": "181",
    "Y": 57,
    "L": 80.2439716989641,
    "a": 6.9212955036615,
    "b": 9.17648872135146,
    "C": 11.4940104707667,
    "h": 0.92458570174497,
    "CMY_C": 0.141107,
    "CMY_M": 0.2380254,
    "CMY_Y": 0.2907039,
    "CMYK_C": 0,
    "CMYK_M": 0.1128411,
    "CMYK_Y": 0.1741741,
    "CMYK_K": 0.141107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04568",
    "Farbtonhilfsbezeichnung": "D5.08.77",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "204",
    "Bcolor": "188",
    "Y": 64,
    "L": 83.7317032634485,
    "a": 7.29562683452673,
    "b": 10.3861116695293,
    "C": 12.6924184661789,
    "h": 0.95843423249614,
    "CMY_C": 0.09632006,
    "CMY_M": 0.2013871,
    "CMY_Y": 0.2622936,
    "CMYK_C": 0,
    "CMYK_M": 0.1162658,
    "CMYK_Y": 0.1836641,
    "CMYK_K": 0.09632006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04569",
    "Farbtonhilfsbezeichnung": "D5.13.75",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "197",
    "Bcolor": "176",
    "Y": 62,
    "L": 82.787332885168,
    "a": 12.246330229373,
    "b": 15.8284343820912,
    "C": 20.0127943844687,
    "h": 0.91230406855811,
    "CMY_C": 0.05944416,
    "CMY_M": 0.2256505,
    "CMY_Y": 0.3111159,
    "CMYK_C": 0,
    "CMYK_M": 0.1767107,
    "CMYK_Y": 0.2675776,
    "CMYK_K": 0.05944416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04570",
    "Farbtonhilfsbezeichnung": "D4.16.71",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "184",
    "Bcolor": "160",
    "Y": 54,
    "L": 78.5974217028957,
    "a": 15.265609300141,
    "b": 18.0757054823993,
    "C": 23.6594580662997,
    "h": 0.86948214473915,
    "CMY_C": 0.0823194,
    "CMY_M": 0.279367,
    "CMY_Y": 0.3707411,
    "CMYK_C": 0,
    "CMYK_M": 0.2147235,
    "CMYK_Y": 0.3142942,
    "CMYK_K": 0.0823194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04571",
    "Farbtonhilfsbezeichnung": "D3.31.67",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "161",
    "Bcolor": "121",
    "Y": 47,
    "L": 73.8978334553993,
    "a": 27.4216544483104,
    "b": 33.2070176437381,
    "C": 43.0656841751536,
    "h": 0.88053300166039,
    "CMY_C": 0.03632335,
    "CMY_M": 0.3672339,
    "CMY_Y": 0.5253361,
    "CMYK_C": 0,
    "CMYK_M": 0.3433834,
    "CMYK_Y": 0.5074449,
    "CMYK_K": 0.03632335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04572",
    "Farbtonhilfsbezeichnung": "D5.45.58",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "135",
    "Bcolor": "82",
    "Y": 36,
    "L": 66.2346569283646,
    "a": 34.1717505991265,
    "b": 43.9197312837495,
    "C": 55.6475636038602,
    "h": 0.90958351282896,
    "CMY_C": 0.07764848,
    "CMY_M": 0.4707845,
    "CMY_Y": 0.6772728,
    "CMYK_C": 0,
    "CMYK_M": 0.4262322,
    "CMYK_Y": 0.6501039,
    "CMYK_K": 0.07764848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04573",
    "Farbtonhilfsbezeichnung": "D5.53.58",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "133",
    "Bcolor": "72",
    "Y": 37,
    "L": 67.1767792263805,
    "a": 38.7031261343692,
    "b": 50.5784763861585,
    "C": 63.6876302441697,
    "h": 0.917632043989,
    "CMY_C": 0.03586833,
    "CMY_M": 0.4776667,
    "CMY_Y": 0.717905,
    "CMYK_C": 0,
    "CMYK_M": 0.4582345,
    "CMYK_Y": 0.7074103,
    "CMYK_K": 0.03586833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04574",
    "Farbtonhilfsbezeichnung": "D4.03.75",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "201",
    "Bcolor": "194",
    "Y": 60,
    "L": 81.8102025890283,
    "a": 3.13983262243589,
    "b": 4.03044223491464,
    "C": 5.10911083319753,
    "h": 0.9089738315989,
    "CMY_C": 0.1657518,
    "CMY_M": 0.2104947,
    "CMY_Y": 0.2373668,
    "CMYK_C": 0,
    "CMYK_M": 0.05363262,
    "CMYK_Y": 0.08584376,
    "CMYK_K": 0.1657518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04575",
    "Farbtonhilfsbezeichnung": "D4.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "195",
    "Bcolor": "183",
    "Y": 57,
    "L": 80.1635049460776,
    "a": 6.06543496538498,
    "b": 7.70672397224299,
    "C": 9.80729808375678,
    "h": 0.90401314635132,
    "CMY_C": 0.1520273,
    "CMY_M": 0.2364108,
    "CMY_Y": 0.2810888,
    "CMYK_C": 0,
    "CMYK_M": 0.09951202,
    "CMYK_Y": 0.1522001,
    "CMYK_K": 0.1520273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04576",
    "Farbtonhilfsbezeichnung": "D5.10.69",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "184",
    "Bcolor": "168",
    "Y": 51,
    "L": 76.9288452315117,
    "a": 8.78335704838712,
    "b": 11.5387420088773,
    "C": 14.5013767686686,
    "h": 0.92016201180616,
    "CMY_C": 0.1589833,
    "CMY_M": 0.2789162,
    "CMY_Y": 0.3422995,
    "CMYK_C": 0,
    "CMYK_M": 0.1426047,
    "CMYK_Y": 0.2179697,
    "CMYK_K": 0.1589833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04577",
    "Farbtonhilfsbezeichnung": "D4.19.69",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "177",
    "Bcolor": "150",
    "Y": 50,
    "L": 76.3650419656595,
    "a": 16.341337598616,
    "b": 20.7536367099485,
    "C": 26.4150099602567,
    "h": 0.90378793026762,
    "CMY_C": 0.09552016,
    "CMY_M": 0.3067388,
    "CMY_Y": 0.4128757,
    "CMYK_C": 0,
    "CMYK_M": 0.233525,
    "CMYK_Y": 0.3508707,
    "CMYK_K": 0.09552016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04578",
    "Farbtonhilfsbezeichnung": "D5.26.61",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "155",
    "Bcolor": "122",
    "Y": 39,
    "L": 69.0301531937797,
    "a": 19.4386224840185,
    "b": 25.8613284570732,
    "C": 32.3522542281185,
    "h": 0.92624116720673,
    "CMY_C": 0.1511971,
    "CMY_M": 0.3936094,
    "CMY_Y": 0.5228444,
    "CMYK_C": 0,
    "CMYK_M": 0.2855932,
    "CMYK_Y": 0.4378487,
    "CMYK_K": 0.1511971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04579",
    "Farbtonhilfsbezeichnung": "D5.32.58",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "142",
    "Bcolor": "103",
    "Y": 35,
    "L": 65.4376025132221,
    "a": 23.8290204209439,
    "b": 31.270414964298,
    "C": 39.3148962387179,
    "h": 0.91963984238885,
    "CMY_C": 0.1589214,
    "CMY_M": 0.4444104,
    "CMY_Y": 0.5956007,
    "CMYK_C": 0,
    "CMYK_M": 0.339432,
    "CMYK_Y": 0.5191896,
    "CMYK_K": 0.1589214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04580",
    "Farbtonhilfsbezeichnung": "D4.46.58",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "132",
    "Bcolor": "82",
    "Y": 35,
    "L": 65.8238096146314,
    "a": 36.5404486962139,
    "b": 43.4310066497933,
    "C": 56.7578781274902,
    "h": 0.8713486017529,
    "CMY_C": 0.0702238,
    "CMY_M": 0.483027,
    "CMY_Y": 0.6767071,
    "CMYK_C": 0,
    "CMYK_M": 0.4439813,
    "CMYK_Y": 0.6522895,
    "CMYK_K": 0.0702238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04581",
    "Farbtonhilfsbezeichnung": "D5.55.55",
    "Farbtonklasse": "04",
    "Rcolor": "234",
    "Gcolor": "122",
    "Bcolor": "62",
    "Y": 32,
    "L": 63.1728946186955,
    "a": 39.1438552186307,
    "b": 50.7353742478927,
    "C": 64.0805711698238,
    "h": 0.91365790645779,
    "CMY_C": 0.08269038,
    "CMY_M": 0.5208007,
    "CMY_Y": 0.7576958,
    "CMYK_C": 0,
    "CMYK_M": 0.4776035,
    "CMYK_Y": 0.7358534,
    "CMYK_K": 0.08269038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04582",
    "Farbtonhilfsbezeichnung": "D4.04.71",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "193",
    "Bcolor": "186",
    "Y": 54,
    "L": 78.9850921630859,
    "a": 4.0518593788147,
    "b": 4.29816198348999,
    "C": 5.90692472457886,
    "h": 46.6895790100098,
    "CMY_C": 0.18922227621078,
    "CMY_M": 0.24333435297012,
    "CMY_Y": 0.2693954706192,
    "CMYK_C": 0,
    "CMYK_M": 0.06674095243216,
    "CMYK_Y": 0.09888430684805,
    "CMYK_K": 0.18922227621078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04583",
    "Farbtonhilfsbezeichnung": "D5.08.69",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "183",
    "Bcolor": "170",
    "Y": 50,
    "L": 76.064774654729,
    "a": 7.33303661732376,
    "b": 9.21527905116704,
    "C": 11.7768753929847,
    "h": 0.89865366684344,
    "CMY_C": 0.1843524,
    "CMY_M": 0.2839817,
    "CMY_Y": 0.334971,
    "CMYK_C": 0,
    "CMYK_M": 0.1221475,
    "CMYK_Y": 0.1846614,
    "CMYK_K": 0.1843524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04584",
    "Farbtonhilfsbezeichnung": "D5.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "155",
    "Bcolor": "129",
    "Y": 38,
    "L": 67.7168239886516,
    "a": 14.7521702445187,
    "b": 19.9072839549344,
    "C": 24.7775398574123,
    "h": 0.93305184137726,
    "CMY_C": 0.2047893,
    "CMY_M": 0.3933508,
    "CMY_Y": 0.4948362,
    "CMYK_C": 0,
    "CMYK_M": 0.2371215,
    "CMYK_Y": 0.3647422,
    "CMYK_K": 0.2047893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04585",
    "Farbtonhilfsbezeichnung": "D5.31.60",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "147",
    "Bcolor": "110",
    "Y": 37,
    "L": 67.2454296851883,
    "a": 23.0482490193228,
    "b": 30.1711079360345,
    "C": 37.9673219617154,
    "h": 0.91844711337251,
    "CMY_C": 0.1439962,
    "CMY_M": 0.4232503,
    "CMY_Y": 0.5703102,
    "CMYK_C": 0,
    "CMYK_M": 0.32623,
    "CMYK_Y": 0.4980281,
    "CMYK_K": 0.1439962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04586",
    "Farbtonhilfsbezeichnung": "D4.49.53",
    "Farbtonklasse": "04",
    "Rcolor": "221",
    "Gcolor": "117",
    "Bcolor": "68",
    "Y": 29,
    "L": 60.4547944758353,
    "a": 36.9934994695193,
    "b": 44.0081114671451,
    "C": 57.4911547797224,
    "h": 0.87178108260394,
    "CMY_C": 0.1322943,
    "CMY_M": 0.5400068,
    "CMY_Y": 0.7319814,
    "CMYK_C": 0,
    "CMYK_M": 0.4698741,
    "CMYK_Y": 0.6911181,
    "CMYK_K": 0.1322943
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04587",
    "Farbtonhilfsbezeichnung": "D3.53.49",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "110",
    "Bcolor": "63",
    "Y": 26,
    "L": 57.8368455724429,
    "a": 37.5783789015399,
    "b": 43.5211761322236,
    "C": 57.4998028935729,
    "h": 0.85854522912673,
    "CMY_C": 0.161191,
    "CMY_M": 0.5687333,
    "CMY_Y": 0.7526841,
    "CMYK_C": 0,
    "CMYK_M": 0.4858583,
    "CMYK_Y": 0.7051582,
    "CMYK_K": 0.161191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04588",
    "Farbtonhilfsbezeichnung": "D5.65.53",
    "Farbtonklasse": "04",
    "Rcolor": "236",
    "Gcolor": "113",
    "Bcolor": "49",
    "Y": 30,
    "L": 61.4732868179757,
    "a": 44.2086440184714,
    "b": 55.2321808914391,
    "C": 70.7460105728696,
    "h": 0.89580263034071,
    "CMY_C": 0.07443042,
    "CMY_M": 0.5582466,
    "CMY_Y": 0.8094351,
    "CMYK_C": 0,
    "CMYK_M": 0.5227227,
    "CMYK_Y": 0.7941106,
    "CMYK_K": 0.07443042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04589",
    "Farbtonhilfsbezeichnung": "D5.03.70",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "190",
    "Bcolor": "183",
    "Y": 53,
    "L": 77.7214450885215,
    "a": 3.36144523157089,
    "b": 4.40785857209274,
    "C": 5.54333214199024,
    "h": 0.91927810538157,
    "CMY_C": 0.2077581,
    "CMY_M": 0.255372,
    "CMY_Y": 0.2837247,
    "CMYK_C": 0,
    "CMYK_M": 0.06010014,
    "CMYK_Y": 0.09588813,
    "CMYK_K": 0.2077581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04590",
    "Farbtonhilfsbezeichnung": "D4.07.63",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "169",
    "Bcolor": "158",
    "Y": 42,
    "L": 70.6437258303048,
    "a": 6.09326099428259,
    "b": 7.43343361033084,
    "C": 9.61164735014981,
    "h": 0.88415201429924,
    "CMY_C": 0.2567013,
    "CMY_M": 0.3380478,
    "CMY_Y": 0.3789867,
    "CMYK_C": 0,
    "CMYK_M": 0.1094399,
    "CMYK_Y": 0.1645172,
    "CMYK_K": 0.2567013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04591",
    "Farbtonhilfsbezeichnung": "D5.16.64",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "165",
    "Bcolor": "143",
    "Y": 42,
    "L": 71.095078427443,
    "a": 12.7599078431618,
    "b": 17.0520115033022,
    "C": 21.2975666327102,
    "h": 0.92838833030358,
    "CMY_C": 0.1851994,
    "CMY_M": 0.3522134,
    "CMY_Y": 0.4410166,
    "CMYK_C": 0,
    "CMYK_M": 0.2049753,
    "CMYK_Y": 0.3139628,
    "CMYK_K": 0.1851994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04592",
    "Farbtonhilfsbezeichnung": "D5.35.49",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "119",
    "Bcolor": "83",
    "Y": 24,
    "L": 56.4084747228013,
    "a": 23.3375794774686,
    "b": 30.1170145377809,
    "C": 38.1008816241313,
    "h": 0.91155070980628,
    "CMY_C": 0.2666069,
    "CMY_M": 0.5344529,
    "CMY_Y": 0.6739016,
    "CMYK_C": 0,
    "CMYK_M": 0.3652147,
    "CMYK_Y": 0.5553566,
    "CMYK_K": 0.2666069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04593",
    "Farbtonhilfsbezeichnung": "D5.39.54",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "128",
    "Bcolor": "85",
    "Y": 31,
    "L": 61.5637943781008,
    "a": 28.174626532123,
    "b": 36.3695326117623,
    "C": 46.0060048539606,
    "h": 0.91168832475308,
    "CMY_C": 0.173586,
    "CMY_M": 0.4981239,
    "CMY_Y": 0.6681997,
    "CMYK_C": 0,
    "CMYK_M": 0.3927062,
    "CMYK_Y": 0.5985059,
    "CMYK_K": 0.173586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04594",
    "Farbtonhilfsbezeichnung": "D5.49.49",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "112",
    "Bcolor": "62",
    "Y": 25,
    "L": 56.6715919304507,
    "a": 32.0946491571449,
    "b": 42.430843456211,
    "C": 53.2019076812637,
    "h": 0.92321239719823,
    "CMY_C": 0.2044961,
    "CMY_M": 0.5612351,
    "CMY_Y": 0.7575389,
    "CMYK_C": 0,
    "CMYK_M": 0.448444,
    "CMYK_Y": 0.6952106,
    "CMYK_K": 0.2044961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04595",
    "Farbtonhilfsbezeichnung": "D4.73.50",
    "Farbtonklasse": "04",
    "Rcolor": "237",
    "Gcolor": "98",
    "Bcolor": "28",
    "Y": 27,
    "L": 58.860240458924,
    "a": 51.1870781683935,
    "b": 61.0255714473237,
    "C": 79.6507209125545,
    "h": 0.87285174809602,
    "CMY_C": 0.06899174,
    "CMY_M": 0.6161859,
    "CMY_Y": 0.8884344,
    "CMYK_C": 0,
    "CMYK_M": 0.5877436,
    "CMYK_Y": 0.8801669,
    "CMYK_K": 0.06899174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04596",
    "Farbtonhilfsbezeichnung": "D5.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "160",
    "Bcolor": "146",
    "Y": 38,
    "L": 67.8298631967443,
    "a": 7.81047292791182,
    "b": 10.430123270782,
    "C": 13.0303859805207,
    "h": 0.92803929580935,
    "CMY_C": 0.2679724,
    "CMY_M": 0.3724408,
    "CMY_Y": 0.4285988,
    "CMYK_C": 0,
    "CMYK_M": 0.142711,
    "CMYK_Y": 0.2194266,
    "CMYK_K": 0.2679724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04597",
    "Farbtonhilfsbezeichnung": "D4.16.56",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "144",
    "Bcolor": "125",
    "Y": 32,
    "L": 63.1501133242422,
    "a": 12.8294544068426,
    "b": 15.5788109928519,
    "C": 20.1815324573794,
    "h": 0.8818778536906,
    "CMY_C": 0.2753796,
    "CMY_M": 0.4345623,
    "CMY_Y": 0.5105615,
    "CMYK_C": 0,
    "CMYK_M": 0.2196773,
    "CMYK_Y": 0.3245587,
    "CMYK_K": 0.2753796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04598",
    "Farbtonhilfsbezeichnung": "D5.27.53",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "134",
    "Bcolor": "103",
    "Y": 29,
    "L": 60.8946174724086,
    "a": 18.5556337696926,
    "b": 24.6493506065101,
    "C": 30.8529095859307,
    "h": 0.9255159147997,
    "CMY_C": 0.2503455,
    "CMY_M": 0.474654,
    "CMY_Y": 0.5942571,
    "CMYK_C": 0,
    "CMYK_M": 0.2992158,
    "CMYK_Y": 0.4587602,
    "CMYK_K": 0.2503455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04599",
    "Farbtonhilfsbezeichnung": "D5.28.45",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "111",
    "Bcolor": "84",
    "Y": 20,
    "L": 51.8702181466157,
    "a": 18.0591679868591,
    "b": 23.2465960500897,
    "C": 29.4370137122237,
    "h": 0.91033015763023,
    "CMY_C": 0.3550982,
    "CMY_M": 0.5633098,
    "CMY_Y": 0.6705118,
    "CMYK_C": 0,
    "CMYK_M": 0.3228579,
    "CMYK_Y": 0.4890879,
    "CMYK_K": 0.3550982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04600",
    "Farbtonhilfsbezeichnung": "D5.42.50",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "118",
    "Bcolor": "77",
    "Y": 25,
    "L": 57.339890053768,
    "a": 27.1427565300119,
    "b": 34.8203162006521,
    "C": 44.1495600471953,
    "h": 0.90867525884797,
    "CMY_C": 0.230006,
    "CMY_M": 0.5373917,
    "CMY_Y": 0.6972739,
    "CMYK_C": 0,
    "CMYK_M": 0.3992052,
    "CMYK_Y": 0.606846,
    "CMYK_K": 0.230006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04601",
    "Farbtonhilfsbezeichnung": "D5.59.50",
    "Farbtonklasse": "04",
    "Rcolor": "216",
    "Gcolor": "106",
    "Bcolor": "50",
    "Y": 25,
    "L": 57.213043872052,
    "a": 39.9855656102235,
    "b": 49.5946288599151,
    "C": 63.7061431019193,
    "h": 0.89225728051366,
    "CMY_C": 0.1520695,
    "CMY_M": 0.5848942,
    "CMY_Y": 0.8051916,
    "CMYK_C": 0,
    "CMYK_M": 0.5104483,
    "CMYK_Y": 0.7702543,
    "CMYK_K": 0.1520695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04602",
    "Farbtonhilfsbezeichnung": "D4.72.46",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "91",
    "Bcolor": "36",
    "Y": 23,
    "L": 54.9590036508374,
    "a": 48.1045103906553,
    "b": 53.9443963877069,
    "C": 72.277533311249,
    "h": 0.84256216203577,
    "CMY_C": 0.1366813,
    "CMY_M": 0.6422243,
    "CMY_Y": 0.859915,
    "CMYK_C": 0,
    "CMYK_M": 0.5855809,
    "CMYK_Y": 0.8377366,
    "CMYK_K": 0.1366813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04603",
    "Farbtonhilfsbezeichnung": "D4.08.53",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "142",
    "Bcolor": "132",
    "Y": 29,
    "L": 60.4450087752711,
    "a": 6.13437709652315,
    "b": 7.30597974632481,
    "C": 9.53980725256313,
    "h": 0.87234887231369,
    "CMY_C": 0.3654537,
    "CMY_M": 0.4438913,
    "CMY_Y": 0.4819227,
    "CMYK_C": 0,
    "CMYK_M": 0.1236122,
    "CMYK_Y": 0.1835469,
    "CMYK_K": 0.3654537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04604",
    "Farbtonhilfsbezeichnung": "D3.14.49",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "128",
    "Bcolor": "113",
    "Y": 24,
    "L": 56.0637109661068,
    "a": 9.98754030154014,
    "b": 11.782694109784,
    "C": 15.4461270796154,
    "h": 0.86767112270216,
    "CMY_C": 0.3767879,
    "CMY_M": 0.4984864,
    "CMY_Y": 0.5549132,
    "CMYK_C": 0,
    "CMYK_M": 0.1952762,
    "CMYK_Y": 0.2858181,
    "CMYK_K": 0.3767879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04605",
    "Farbtonhilfsbezeichnung": "D4.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "139",
    "Bcolor": "116",
    "Y": 30,
    "L": 61.3767066029652,
    "a": 13.9337993704607,
    "b": 18.0345849815175,
    "C": 22.7902834636129,
    "h": 0.91297772800984,
    "CMY_C": 0.2833489,
    "CMY_M": 0.4560749,
    "CMY_Y": 0.5447842,
    "CMYK_C": 0,
    "CMYK_M": 0.2410182,
    "CMYK_Y": 0.3648013,
    "CMYK_K": 0.2833489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04606",
    "Farbtonhilfsbezeichnung": "D5.24.49",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "126",
    "Bcolor": "101",
    "Y": 25,
    "L": 57.005485210664,
    "a": 16.040681371248,
    "b": 20.4485872340531,
    "C": 25.98938588583,
    "h": 0.90561571799488,
    "CMY_C": 0.3145544,
    "CMY_M": 0.5062994,
    "CMY_Y": 0.6033361,
    "CMYK_C": 0,
    "CMYK_M": 0.2797377,
    "CMYK_Y": 0.421305,
    "CMYK_K": 0.3145544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04607",
    "Farbtonhilfsbezeichnung": "D5.42.45",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "105",
    "Bcolor": "66",
    "Y": 20,
    "L": 52.0234059898205,
    "a": 27.0629138728278,
    "b": 34.1932167316082,
    "C": 43.6070794452326,
    "h": 0.9012781340547,
    "CMY_C": 0.2922573,
    "CMY_M": 0.5899903,
    "CMY_Y": 0.742172,
    "CMYK_C": 0,
    "CMYK_M": 0.4206797,
    "CMYK_Y": 0.6357037,
    "CMYK_K": 0.2922573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04608",
    "Farbtonhilfsbezeichnung": "D3.48.45",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "101",
    "Bcolor": "60",
    "Y": 21,
    "L": 52.7512610338101,
    "a": 33.562686509414,
    "b": 38.7869589281526,
    "C": 51.2921252106344,
    "h": 0.85748173394902,
    "CMY_C": 0.2461228,
    "CMY_M": 0.6049405,
    "CMY_Y": 0.7662609,
    "CMYK_C": 0,
    "CMYK_M": 0.4759631,
    "CMYK_Y": 0.6899507,
    "CMYK_K": 0.2461228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04609",
    "Farbtonhilfsbezeichnung": "D3.58.45",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "95",
    "Bcolor": "46",
    "Y": 21,
    "L": 52.7892779765433,
    "a": 39.1791190426246,
    "b": 45.9782604526599,
    "C": 60.4069847220401,
    "h": 0.86507122094429,
    "CMY_C": 0.2120755,
    "CMY_M": 0.6261563,
    "CMY_Y": 0.818097,
    "CMYK_C": 0,
    "CMYK_M": 0.5255337,
    "CMYK_Y": 0.7691365,
    "CMYK_K": 0.2120755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04610",
    "Farbtonhilfsbezeichnung": "D4.61.45",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "98",
    "Bcolor": "49",
    "Y": 22,
    "L": 54.2741984432592,
    "a": 40.6078983207203,
    "b": 46.6470983772689,
    "C": 61.8462059713008,
    "h": 0.85450118753138,
    "CMY_C": 0.1865476,
    "CMY_M": 0.616779,
    "CMY_Y": 0.8088045,
    "CMYK_C": 0,
    "CMYK_M": 0.5288956,
    "CMYK_Y": 0.764958,
    "CMYK_K": 0.1865476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04611",
    "Farbtonhilfsbezeichnung": "D4.13.44",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "117",
    "Bcolor": "104",
    "Y": 20,
    "L": 51.5130628795002,
    "a": 8.76995243643314,
    "b": 10.6010748009159,
    "C": 13.7584465937079,
    "h": 0.87964702629884,
    "CMY_C": 0.4343745,
    "CMY_M": 0.5405607,
    "CMY_Y": 0.5912693,
    "CMYK_C": 0,
    "CMYK_M": 0.1877324,
    "CMYK_Y": 0.2773829,
    "CMYK_K": 0.4343745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04612",
    "Farbtonhilfsbezeichnung": "D5.18.43",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "113",
    "Bcolor": "97",
    "Y": 19,
    "L": 50.5036944647917,
    "a": 10.7726745649224,
    "b": 13.5458714967959,
    "C": 17.3072572029607,
    "h": 0.89894396164428,
    "CMY_C": 0.4270294,
    "CMY_M": 0.5559773,
    "CMY_Y": 0.6200479,
    "CMYK_C": 0,
    "CMYK_M": 0.2250516,
    "CMYK_Y": 0.3368734,
    "CMYK_K": 0.4270294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04613",
    "Farbtonhilfsbezeichnung": "D5.31.37",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "93",
    "Bcolor": "68",
    "Y": 14,
    "L": 44.3869978120343,
    "a": 17.5003807806873,
    "b": 22.5523024927221,
    "C": 28.5459222165319,
    "h": 0.91086750488078,
    "CMY_C": 0.4400986,
    "CMY_M": 0.6342859,
    "CMY_Y": 0.7347312,
    "CMYK_C": 0,
    "CMYK_M": 0.346824,
    "CMYK_Y": 0.5262223,
    "CMYK_K": 0.4400986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04615",
    "Farbtonhilfsbezeichnung": "D5.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "96",
    "Bcolor": "64",
    "Y": 16,
    "L": 47.4286529230253,
    "a": 24.2105271543617,
    "b": 29.2838385973504,
    "C": 37.9959580493473,
    "h": 0.87995359275647,
    "CMY_C": 0.3639516,
    "CMY_M": 0.6253731,
    "CMY_Y": 0.7507387,
    "CMYK_C": 0,
    "CMYK_M": 0.4110087,
    "CMYK_Y": 0.6081095,
    "CMYK_K": 0.3639516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04616",
    "Farbtonhilfsbezeichnung": "D5.47.37",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "87",
    "Bcolor": "53",
    "Y": 14,
    "L": 44.4214653692479,
    "a": 25.8750860064883,
    "b": 31.7396863306399,
    "C": 40.9503084751577,
    "h": 0.88683865092243,
    "CMY_C": 0.3867482,
    "CMY_M": 0.6599022,
    "CMY_Y": 0.7941107,
    "CMYK_C": 0,
    "CMYK_M": 0.4454189,
    "CMYK_Y": 0.6642662,
    "CMYK_K": 0.3867482
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04617",
    "Farbtonhilfsbezeichnung": "D5.69.45",
    "Farbtonklasse": "04",
    "Rcolor": "209",
    "Gcolor": "95",
    "Bcolor": "42",
    "Y": 22,
    "L": 53.9144782240087,
    "a": 42.6509539629152,
    "b": 49.7069514987948,
    "C": 65.4972129273472,
    "h": 0.86164845752844,
    "CMY_C": 0.1788524,
    "CMY_M": 0.6290206,
    "CMY_Y": 0.836198,
    "CMYK_C": 0,
    "CMYK_M": 0.5482184,
    "CMYK_Y": 0.8005207,
    "CMYK_K": 0.1788524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04618",
    "Farbtonhilfsbezeichnung": "D4.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "111",
    "Bcolor": "107",
    "Y": 17,
    "L": 47.6316786148112,
    "a": 2.65813179546903,
    "b": 3.2549787539031,
    "C": 4.20244587477864,
    "h": 0.88599366867434,
    "CMY_C": 0.529656,
    "CMY_M": 0.5630631,
    "CMY_Y": 0.5813181,
    "CMYK_C": 0,
    "CMYK_M": 0.07102702,
    "CMYK_Y": 0.1098391,
    "CMYK_K": 0.529656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04619",
    "Farbtonhilfsbezeichnung": "D5.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "111",
    "Bcolor": "102",
    "Y": 17,
    "L": 48.2256805679697,
    "a": 5.55279274018877,
    "b": 7.14459540209458,
    "C": 9.04868778747085,
    "h": 0.91011210749851,
    "CMY_C": 0.4954886,
    "CMY_M": 0.5645823,
    "CMY_Y": 0.600547,
    "CMYK_C": 0,
    "CMYK_M": 0.1369519,
    "CMYK_Y": 0.2082379,
    "CMYK_K": 0.4954886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04620",
    "Farbtonhilfsbezeichnung": "D3.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "94",
    "Bcolor": "78",
    "Y": 13,
    "L": 42.5963025277343,
    "a": 10.5475753520543,
    "b": 13.7802233503092,
    "C": 17.3535558716843,
    "h": 0.91750304697027,
    "CMY_C": 0.5096914,
    "CMY_M": 0.63191,
    "CMY_Y": 0.6953531,
    "CMYK_C": 0,
    "CMYK_M": 0.2492689,
    "CMYK_Y": 0.3786629,
    "CMYK_K": 0.5096914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04621",
    "Farbtonhilfsbezeichnung": "D5.21.39",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "103",
    "Bcolor": "85",
    "Y": 16,
    "L": 46.6267779715427,
    "a": 11.9637593233584,
    "b": 14.9389767185013,
    "C": 19.1390846840482,
    "h": 0.89554220808937,
    "CMY_C": 0.4580899,
    "CMY_M": 0.5969711,
    "CMY_Y": 0.6654233,
    "CMYK_C": 0,
    "CMYK_M": 0.2562808,
    "CMYK_Y": 0.3825974,
    "CMYK_K": 0.4580899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04622",
    "Farbtonhilfsbezeichnung": "D5.24.33",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "89",
    "Bcolor": "72",
    "Y": 12,
    "L": 41.0097836107128,
    "a": 11.6815027447437,
    "b": 14.7708653486504,
    "C": 18.8317808378129,
    "h": 0.9016611126964,
    "CMY_C": 0.5179527,
    "CMY_M": 0.6498914,
    "CMY_Y": 0.7159381,
    "CMYK_C": 0,
    "CMYK_M": 0.273705,
    "CMYK_Y": 0.4107178,
    "CMYK_K": 0.5179527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04623",
    "Farbtonhilfsbezeichnung": "D3.37.34",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "85",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.4775858082554,
    "a": 22.2707364466691,
    "b": 24.6548791649183,
    "C": 33.2242196072943,
    "h": 0.83616136456415,
    "CMY_C": 0.4333925,
    "CMY_M": 0.6663349,
    "CMY_Y": 0.7645677,
    "CMYK_C": 0,
    "CMYK_M": 0.4111177,
    "CMYK_Y": 0.5844878,
    "CMYK_K": 0.4333925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04624",
    "Farbtonhilfsbezeichnung": "D5.42.31",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "81",
    "Bcolor": "55",
    "Y": 12,
    "L": 40.5464857047336,
    "a": 21.3929371483196,
    "b": 25.2592758098119,
    "C": 33.1011899222384,
    "h": 0.86808498295384,
    "CMY_C": 0.4581867,
    "CMY_M": 0.6821333,
    "CMY_Y": 0.7858697,
    "CMYK_C": 0,
    "CMYK_M": 0.413328,
    "CMYK_Y": 0.6047896,
    "CMYK_K": 0.4581867
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04625",
    "Farbtonhilfsbezeichnung": "D4.56.42",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "92",
    "Bcolor": "49",
    "Y": 18,
    "L": 50.0281369868163,
    "a": 35.6632952424483,
    "b": 40.9750030134058,
    "C": 54.3214644454533,
    "h": 0.85459629309901,
    "CMY_C": 0.2659175,
    "CMY_M": 0.6398541,
    "CMY_Y": 0.8065269,
    "CMYK_C": 0,
    "CMYK_M": 0.5093932,
    "CMYK_Y": 0.7364423,
    "CMYK_K": 0.2659175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04626",
    "Farbtonhilfsbezeichnung": "D3.04.30",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "90",
    "Bcolor": "87",
    "Y": 11,
    "L": 38.8689778129827,
    "a": 2.4256931046889,
    "b": 2.28149954654364,
    "C": 3.33004913162165,
    "h": 0.75477513762452,
    "CMY_C": 0.6189743,
    "CMY_M": 0.646388,
    "CMY_Y": 0.6580948,
    "CMYK_C": 0,
    "CMYK_M": 0.07194719,
    "CMYK_Y": 0.1026715,
    "CMYK_K": 0.6189743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04627",
    "Farbtonhilfsbezeichnung": "D5.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "76",
    "Bcolor": "72",
    "Y": 8,
    "L": 33.133148148166,
    "a": 2.63106620207249,
    "b": 3.13894689216165,
    "C": 4.09579014983671,
    "h": 0.87319261356272,
    "CMY_C": 0.6696646,
    "CMY_M": 0.7002507,
    "CMY_Y": 0.7158835,
    "CMYK_C": 0,
    "CMYK_M": 0.09259133,
    "CMYK_Y": 0.1399153,
    "CMYK_K": 0.6696646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04628",
    "Farbtonhilfsbezeichnung": "D3.12.30",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "87",
    "Bcolor": "78",
    "Y": 10,
    "L": 38.3884425281069,
    "a": 6.30253198322619,
    "b": 7.56604826434115,
    "C": 9.84718212170004,
    "h": 0.87625372902383,
    "CMY_C": 0.5877339,
    "CMY_M": 0.6604525,
    "CMY_Y": 0.6950825,
    "CMYK_C": 0,
    "CMYK_M": 0.1763874,
    "CMYK_Y": 0.2603867,
    "CMYK_K": 0.5877339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04629",
    "Farbtonhilfsbezeichnung": "D5.25.30",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "83",
    "Bcolor": "66",
    "Y": 10,
    "L": 38.6134169810358,
    "a": 11.9294262598975,
    "b": 15.0534153827963,
    "C": 19.207199836971,
    "h": 0.90066185876685,
    "CMY_C": 0.5406089,
    "CMY_M": 0.6730431,
    "CMY_Y": 0.7392412,
    "CMYK_C": 0,
    "CMYK_M": 0.288282,
    "CMYK_Y": 0.4323819,
    "CMYK_K": 0.5406089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04630",
    "Farbtonhilfsbezeichnung": "D4.28.25",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "72",
    "Bcolor": "56",
    "Y": 8,
    "L": 33.9323085169929,
    "a": 12.8543962873799,
    "b": 15.1090497059077,
    "C": 19.8373104761859,
    "h": 0.86585271741141,
    "CMY_C": 0.5829825,
    "CMY_M": 0.7185405,
    "CMY_Y": 0.7806864,
    "CMYK_C": 0,
    "CMYK_M": 0.3250656,
    "CMYK_Y": 0.4740902,
    "CMYK_K": 0.5829825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04631",
    "Farbtonhilfsbezeichnung": "D4.30.21",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "68",
    "Bcolor": "53",
    "Y": 7,
    "L": 32.3090009234812,
    "a": 12.2505533693473,
    "b": 14.3591321039927,
    "C": 18.874870400486,
    "h": 0.86447395465886,
    "CMY_C": 0.6033992,
    "CMY_M": 0.7316505,
    "CMY_Y": 0.7902306,
    "CMYK_C": 0,
    "CMYK_M": 0.3233765,
    "CMYK_Y": 0.4710818,
    "CMYK_K": 0.6033992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04632",
    "Farbtonhilfsbezeichnung": "D5.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "79",
    "Bcolor": "54",
    "Y": 11,
    "L": 38.944662046596,
    "a": 19.5277380437307,
    "b": 23.2757637022534,
    "C": 30.3824575870305,
    "h": 0.87273892211731,
    "CMY_C": 0.4869183,
    "CMY_M": 0.6914703,
    "CMY_Y": 0.7874011,
    "CMYK_C": 0,
    "CMYK_M": 0.3986733,
    "CMYK_Y": 0.5856432,
    "CMYK_K": 0.4869183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04633",
    "Farbtonhilfsbezeichnung": "D5.50.31",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "80",
    "Bcolor": "47",
    "Y": 12,
    "L": 40.9421866026167,
    "a": 24.0307868032639,
    "b": 30.3111922439049,
    "C": 38.6813532549067,
    "h": 0.90045958286337,
    "CMY_C": 0.4359122,
    "CMY_M": 0.6870991,
    "CMY_Y": 0.8156007,
    "CMYK_C": 0,
    "CMYK_M": 0.4452975,
    "CMYK_Y": 0.6731018,
    "CMYK_K": 0.4359122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04634",
    "Farbtonhilfsbezeichnung": "D5.04.22",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "71",
    "Bcolor": "69",
    "Y": 7,
    "L": 30.649332041414,
    "a": 1.2903797902,
    "b": 1.38461484568603,
    "C": 1.89268018266445,
    "h": 0.82061173005693,
    "CMY_C": 0.7052053,
    "CMY_M": 0.7197496,
    "CMY_Y": 0.7277235,
    "CMYK_C": 0,
    "CMYK_M": 0.04933719,
    "CMYK_Y": 0.07638583,
    "CMYK_K": 0.7052053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04635",
    "Farbtonhilfsbezeichnung": "D4.13.14",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "57",
    "Bcolor": "52",
    "Y": 4,
    "L": 24.9893232691845,
    "a": 4.04040219505267,
    "b": 4.941052405566,
    "C": 6.38269917608029,
    "h": 0.88534292733325,
    "CMY_C": 0.7322906,
    "CMY_M": 0.7763376,
    "CMY_Y": 0.797925,
    "CMYK_C": 0,
    "CMYK_M": 0.1645329,
    "CMYK_Y": 0.2451702,
    "CMYK_K": 0.7322906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04636",
    "Farbtonhilfsbezeichnung": "D4.13.22",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 7,
    "L": 31.6956829047776,
    "a": 5.44615020779179,
    "b": 6.46940806095144,
    "C": 8.45658280542053,
    "h": 0.8710637707134,
    "CMY_C": 0.6592562,
    "CMY_M": 0.7199686,
    "CMY_Y": 0.7485731,
    "CMYK_C": 0,
    "CMYK_M": 0.178176,
    "CMYK_Y": 0.2621235,
    "CMYK_K": 0.6592562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04637",
    "Farbtonhilfsbezeichnung": "D5.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "80",
    "Bcolor": "66",
    "Y": 9,
    "L": 36.8038197784843,
    "a": 10.0152170162668,
    "b": 12.9511175568646,
    "C": 16.3718055771087,
    "h": 0.91254352571017,
    "CMY_C": 0.5725501,
    "CMY_M": 0.6848364,
    "CMY_Y": 0.7424798,
    "CMYK_C": 0,
    "CMYK_M": 0.2626889,
    "CMYK_Y": 0.397543,
    "CMYK_K": 0.5725501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04638",
    "Farbtonhilfsbezeichnung": "D4.28.20",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "63",
    "Bcolor": "51",
    "Y": 6,
    "L": 29.9088690449248,
    "a": 11.5330261198419,
    "b": 12.5460318773698,
    "C": 17.0415259689071,
    "h": 0.82744336122908,
    "CMY_C": 0.6333491,
    "CMY_M": 0.7511389,
    "CMY_Y": 0.799921,
    "CMYK_C": 0,
    "CMYK_M": 0.3212587,
    "CMYK_Y": 0.4543066,
    "CMYK_K": 0.6333491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04639",
    "Farbtonhilfsbezeichnung": "D5.32.21",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "66",
    "Bcolor": "52",
    "Y": 7,
    "L": 30.8616238871327,
    "a": 11.0950501960668,
    "b": 13.0430883208413,
    "C": 17.1237347502964,
    "h": 0.86592737745999,
    "CMY_C": 0.6255473,
    "CMY_M": 0.7416375,
    "CMY_Y": 0.7948495,
    "CMYK_C": 0,
    "CMYK_M": 0.3100264,
    "CMYK_Y": 0.4521324,
    "CMYK_K": 0.6255473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04640",
    "Farbtonhilfsbezeichnung": "D5.36.26",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "73",
    "Bcolor": "51",
    "Y": 9,
    "L": 35.9468184029522,
    "a": 17.15532639721,
    "b": 20.8355497046548,
    "C": 26.9893563333761,
    "h": 0.8819680845082,
    "CMY_C": 0.5332289,
    "CMY_M": 0.7122964,
    "CMY_Y": 0.798342,
    "CMYK_C": 0,
    "CMYK_M": 0.3836303,
    "CMYK_Y": 0.5679725,
    "CMYK_K": 0.5332289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04641",
    "Farbtonhilfsbezeichnung": "D5.48.31",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "79",
    "Bcolor": "49",
    "Y": 12,
    "L": 40.4381034630034,
    "a": 23.9814906073904,
    "b": 28.5041872265877,
    "C": 37.2505111535495,
    "h": 0.87135593904305,
    "CMY_C": 0.4432911,
    "CMY_M": 0.6914355,
    "CMY_Y": 0.8077355,
    "CMYK_C": 0,
    "CMYK_M": 0.4457345,
    "CMYK_Y": 0.6546409,
    "CMYK_K": 0.4432911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04642",
    "Farbtonhilfsbezeichnung": "D8.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "220",
    "Bcolor": "206",
    "Y": 74,
    "L": 89.083764378638,
    "a": 5.71204328405134,
    "b": 8.63476102959506,
    "C": 10.3530930893666,
    "h": 0.98636718869655,
    "CMY_C": 0.05223139,
    "CMY_M": 0.1381924,
    "CMY_Y": 0.1920491,
    "CMYK_C": 0,
    "CMYK_M": 0.09069827,
    "CMYK_Y": 0.1475231,
    "CMYK_K": 0.05223139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04643",
    "Farbtonhilfsbezeichnung": "D6.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "221",
    "Bcolor": "204",
    "Y": 76,
    "L": 89.8747353280782,
    "a": 7.34433684477137,
    "b": 11.052124737057,
    "C": 13.2698434389006,
    "h": 0.98428267331176,
    "CMY_C": 0.02476076,
    "CMY_M": 0.13416,
    "CMY_Y": 0.2010555,
    "CMYK_C": 0,
    "CMYK_M": 0.1121768,
    "CMYK_Y": 0.1807708,
    "CMYK_K": 0.02476076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04644",
    "Farbtonhilfsbezeichnung": "D7.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "216",
    "Bcolor": "196",
    "Y": 73,
    "L": 88.4254913330078,
    "a": 8.83480548858643,
    "b": 13.2219381332398,
    "C": 15.9019947052002,
    "h": 56.2494354248047,
    "CMY_C": 0.02497434616089,
    "CMY_M": 0.15447103977203,
    "CMY_Y": 0.23248720169067,
    "CMYK_C": 0,
    "CMYK_M": 0.13281363248825,
    "CMYK_Y": 0.21282809972763,
    "CMYK_K": 0.02497434616089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04645",
    "Farbtonhilfsbezeichnung": "D5.12.81",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "213",
    "Bcolor": "192",
    "Y": 73,
    "L": 88.322389736861,
    "a": 11.4474261428268,
    "b": 15.1345832618367,
    "C": 18.9762792929736,
    "h": 0.92322744639871,
    "CMY_C": 0.003180982,
    "CMY_M": 0.1628705,
    "CMY_Y": 0.247256,
    "CMYK_C": 0,
    "CMYK_M": 0.1601991,
    "CMYK_Y": 0.2448538,
    "CMYK_K": 0.003180982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04646",
    "Farbtonhilfsbezeichnung": "D6.24.75",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "190",
    "Bcolor": "151",
    "Y": 60,
    "L": 82.2884368896484,
    "a": 19.8313655853271,
    "b": 28.5124912261963,
    "C": 34.7310409545898,
    "h": 55.1801300048828,
    "CMY_C": 0,
    "CMY_M": 0.25442582368851,
    "CMY_Y": 0.40758776664734,
    "CMYK_C": 0,
    "CMYK_M": 0.25442582368851,
    "CMYK_Y": 0.40758776664734,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04647",
    "Farbtonhilfsbezeichnung": "D6.26.72",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "180",
    "Bcolor": "142",
    "Y": 55,
    "L": 78.9347856953322,
    "a": 20.9769043424762,
    "b": 28.6057073668565,
    "C": 35.4727643376101,
    "h": 0.93806145883955,
    "CMY_C": 0.02266023,
    "CMY_M": 0.2938232,
    "CMY_Y": 0.4424663,
    "CMYK_C": 0,
    "CMYK_M": 0.27745,
    "CMYK_Y": 0.4295396,
    "CMYK_K": 0.02266023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04648",
    "Farbtonhilfsbezeichnung": "D7.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 76,
    "L": 89.694919445824,
    "a": 5.92135826623658,
    "b": 9.26621523823643,
    "C": 10.9966007728958,
    "h": 1.00217397244146,
    "CMY_C": 0.04201498,
    "CMY_M": 0.1321152,
    "CMY_Y": 0.1900365,
    "CMYK_C": 0,
    "CMYK_M": 0.09405182,
    "CMYK_Y": 0.1545134,
    "CMYK_K": 0.04201498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04649",
    "Farbtonhilfsbezeichnung": "D6.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 76,
    "L": 89.6737405436581,
    "a": 8.02303329525278,
    "b": 11.945402662466,
    "C": 14.3896389122586,
    "h": 0.97935721510626,
    "CMY_C": 0.01980926,
    "CMY_M": 0.1383339,
    "CMY_Y": 0.2097255,
    "CMYK_C": 0,
    "CMYK_M": 0.1209199,
    "CMYK_Y": 0.1937544,
    "CMYK_K": 0.01980926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04650",
    "Farbtonhilfsbezeichnung": "D6.12.81",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "213",
    "Bcolor": "191",
    "Y": 72,
    "L": 87.8217571855017,
    "a": 9.75421486611877,
    "b": 14.7265850957446,
    "C": 17.6640034034366,
    "h": 0.98578525181296,
    "CMY_C": 0.02167758,
    "CMY_M": 0.1638985,
    "CMY_Y": 0.2499083,
    "CMYK_C": 0,
    "CMYK_M": 0.1453722,
    "CMYK_Y": 0.2332878,
    "CMYK_K": 0.02167758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04651",
    "Farbtonhilfsbezeichnung": "D6.15.79",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "206",
    "Bcolor": "178",
    "Y": 68,
    "L": 86.0760317344207,
    "a": 13.4903466900918,
    "b": 19.2118988081971,
    "C": 23.4752318334724,
    "h": 0.95860404634324,
    "CMY_C": 0.005785808,
    "CMY_M": 0.1938992,
    "CMY_Y": 0.3008649,
    "CMYK_C": 0,
    "CMYK_M": 0.1892081,
    "CMYK_Y": 0.2967963,
    "CMYK_K": 0.005785808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04652",
    "Farbtonhilfsbezeichnung": "D6.30.69",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "172",
    "Bcolor": "131",
    "Y": 51,
    "L": 76.9247878233467,
    "a": 24.3036836450721,
    "b": 32.1084341407906,
    "C": 40.269350400686,
    "h": 0.92287778865767,
    "CMY_C": 0.02054065,
    "CMY_M": 0.3256054,
    "CMY_Y": 0.4877093,
    "CMYK_C": 0,
    "CMYK_M": 0.3114624,
    "CMYK_Y": 0.4769658,
    "CMYK_K": 0.02054065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04653",
    "Farbtonhilfsbezeichnung": "D6.41.67",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "160",
    "Bcolor": "104",
    "Y": 48,
    "L": 74.8446235761889,
    "a": 31.1862076516797,
    "b": 43.4015223126145,
    "C": 53.4440987083332,
    "h": 0.9477282176968,
    "CMY_C": 0,
    "CMY_M": 0.3708095,
    "CMY_Y": 0.5903384,
    "CMYK_C": 0,
    "CMYK_M": 0.3708095,
    "CMYK_Y": 0.5903384,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04654",
    "Farbtonhilfsbezeichnung": "D5.12.76",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "202",
    "Bcolor": "181",
    "Y": 64,
    "L": 83.830186316219,
    "a": 10.499981229617,
    "b": 14.525647025703,
    "C": 17.9232817122765,
    "h": 0.9448935304912,
    "CMY_C": 0.06250095,
    "CMY_M": 0.20947,
    "CMY_Y": 0.2908863,
    "CMYK_C": 0,
    "CMYK_M": 0.1567671,
    "CMYK_Y": 0.2436112,
    "CMYK_K": 0.06250095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04655",
    "Farbtonhilfsbezeichnung": "D6.31.67",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "165",
    "Bcolor": "120",
    "Y": 47,
    "L": 74.479081854777,
    "a": 24.9412365209392,
    "b": 34.4123995143523,
    "C": 42.5003355225441,
    "h": 0.94363582776688,
    "CMY_C": 0.04237232,
    "CMY_M": 0.3538915,
    "CMY_Y": 0.5289617,
    "CMYK_C": 0,
    "CMYK_M": 0.325303,
    "CMYK_Y": 0.5081196,
    "CMYK_K": 0.04237232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04656",
    "Farbtonhilfsbezeichnung": "D6.33.67",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "167",
    "Bcolor": "123",
    "Y": 49,
    "L": 75.6316604614258,
    "a": 25.9269580841064,
    "b": 34.2204055786133,
    "C": 42.9330101013184,
    "h": 52.8507499694824,
    "CMY_C": 0.02313077449799,
    "CMY_M": 0.34450936317444,
    "CMY_Y": 0.51577669382095,
    "CMYK_C": 0,
    "CMYK_M": 0.32898834347725,
    "CMYK_Y": 0.50431102514267,
    "CMYK_K": 0.02313077449799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04658",
    "Farbtonhilfsbezeichnung": "D6.53.61",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "139",
    "Bcolor": "70",
    "Y": 40,
    "L": 69.6244319724692,
    "a": 39.0735071194355,
    "b": 54.4840903370174,
    "C": 67.0466632910606,
    "h": 0.94864985747776,
    "CMY_C": 0.0005015446,
    "CMY_M": 0.45396,
    "CMY_Y": 0.7254842,
    "CMYK_C": 0,
    "CMYK_M": 0.453686,
    "CMYK_Y": 0.7253464,
    "CMYK_K": 0.0005015446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04659",
    "Farbtonhilfsbezeichnung": "D6.11.81",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "214",
    "Bcolor": "192",
    "Y": 72,
    "L": 87.960480471785,
    "a": 9.49665413820594,
    "b": 14.6195660789359,
    "C": 17.4332484682883,
    "h": 0.9947127423533,
    "CMY_C": 0.02215301,
    "CMY_M": 0.1616838,
    "CMY_Y": 0.2476757,
    "CMYK_C": 0,
    "CMYK_M": 0.1426919,
    "CMYK_Y": 0.2306319,
    "CMYK_K": 0.02215301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04660",
    "Farbtonhilfsbezeichnung": "D7.12.76",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "199",
    "Bcolor": "178",
    "Y": 62,
    "L": 82.7029445657123,
    "a": 9.44734698604682,
    "b": 14.1178029077921,
    "C": 16.9871929410963,
    "h": 0.98105595455355,
    "CMY_C": 0.08348199,
    "CMY_M": 0.2189449,
    "CMY_Y": 0.3000403,
    "CMYK_C": 0,
    "CMYK_M": 0.1478017,
    "CMYK_Y": 0.2362837,
    "CMYK_K": 0.08348199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04661",
    "Farbtonhilfsbezeichnung": "D6.16.70",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "183",
    "Bcolor": "159",
    "Y": 53,
    "L": 77.7419636065541,
    "a": 12.6436523009961,
    "b": 17.4088432973163,
    "C": 21.5158027612032,
    "h": 0.94265123916058,
    "CMY_C": 0.1105769,
    "CMY_M": 0.2814709,
    "CMY_Y": 0.3752943,
    "CMYK_C": 0,
    "CMYK_M": 0.1921403,
    "CMYK_Y": 0.2976283,
    "CMYK_K": 0.1105769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04662",
    "Farbtonhilfsbezeichnung": "D6.38.63",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "151",
    "Bcolor": "102",
    "Y": 42,
    "L": 70.8211741449075,
    "a": 29.127294012999,
    "b": 39.3462833289429,
    "C": 48.9543590328903,
    "h": 0.93354464674337,
    "CMY_C": 0.05536821,
    "CMY_M": 0.4059851,
    "CMY_Y": 0.6002716,
    "CMYK_C": 0,
    "CMYK_M": 0.3711678,
    "CMYK_Y": 0.5768422,
    "CMYK_K": 0.05536821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04663",
    "Farbtonhilfsbezeichnung": "D6.41.60",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "143",
    "Bcolor": "94",
    "Y": 38,
    "L": 67.7381332124832,
    "a": 29.1060639584487,
    "b": 39.3866635812562,
    "C": 48.9741996077155,
    "h": 0.93438364194529,
    "CMY_C": 0.09222803,
    "CMY_M": 0.4380603,
    "CMY_Y": 0.6306329,
    "CMYK_C": 0,
    "CMYK_M": 0.3809682,
    "CMYK_Y": 0.5931058,
    "CMYK_K": 0.09222803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04664",
    "Farbtonhilfsbezeichnung": "D6.59.58",
    "Farbtonklasse": "04",
    "Rcolor": "242",
    "Gcolor": "124",
    "Bcolor": "57",
    "Y": 34,
    "L": 64.6743142351646,
    "a": 41.2666433795781,
    "b": 55.1045486126833,
    "C": 68.8436426522076,
    "h": 0.92801299623482,
    "CMY_C": 0.04993999,
    "CMY_M": 0.5136719,
    "CMY_Y": 0.778381,
    "CMYK_C": 0,
    "CMYK_M": 0.488108,
    "CMYK_Y": 0.7667316,
    "CMYK_K": 0.04993999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04665",
    "Farbtonhilfsbezeichnung": "F6.09.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "203",
    "Y": 81,
    "L": 91.9767608131484,
    "a": 0.8151308233521,
    "b": 14.1429832489681,
    "C": 14.166453806079,
    "h": 1.5132250182294,
    "CMY_C": 0.04028905,
    "CMY_M": 0.09549887,
    "CMY_Y": 0.202261,
    "CMYK_C": 0,
    "CMYK_M": 0.05752755,
    "CMYK_Y": 0.1687716,
    "CMYK_K": 0.04028905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04666",
    "Farbtonhilfsbezeichnung": "F9.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "213",
    "Y": 85,
    "L": 93.6756961584182,
    "a": 0.25507675062119,
    "b": 11.5418714211503,
    "C": 11.5446896905493,
    "h": 1.54869980313057,
    "CMY_C": 0.03260888,
    "CMY_M": 0.07449557,
    "CMY_Y": 0.164436,
    "CMYK_C": 0,
    "CMYK_M": 0.04329861,
    "CMYK_Y": 0.1362708,
    "CMYK_K": 0.03260888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04667",
    "Farbtonhilfsbezeichnung": "D6.49.39",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "98",
    "Bcolor": "65",
    "Y": 17,
    "L": 49.0137977600098,
    "a": 25.8217582702637,
    "b": 30.560245513916,
    "C": 40.0086479187012,
    "h": 49.8039932250977,
    "CMY_C": 0.33649462461472,
    "CMY_M": 0.61502814292908,
    "CMY_Y": 0.74466520547867,
    "CMYK_C": 0,
    "CMYK_M": 0.41979089379311,
    "CMYK_Y": 0.61517298221588,
    "CMYK_K": 0.33649462461472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04668",
    "Farbtonhilfsbezeichnung": "D6.35.28",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "77",
    "Bcolor": "56",
    "Y": 10,
    "L": 36.9510805853238,
    "a": 15.8846959369485,
    "b": 19.4344806432242,
    "C": 25.1002510521541,
    "h": 0.88556765597127,
    "CMY_C": 0.5308773,
    "CMY_M": 0.6993761,
    "CMY_Y": 0.7809513,
    "CMYK_C": 0,
    "CMYK_M": 0.3591785,
    "CMYK_Y": 0.5330675,
    "CMYK_K": 0.5308773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04669",
    "Farbtonhilfsbezeichnung": "D5.39.26",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "72",
    "Bcolor": "50",
    "Y": 9,
    "L": 35.4272943934009,
    "a": 17.8609247670269,
    "b": 21.3106558354856,
    "C": 27.8056952020968,
    "h": 0.8732387299481,
    "CMY_C": 0.5345935,
    "CMY_M": 0.7190896,
    "CMY_Y": 0.8057011,
    "CMYK_C": 0,
    "CMYK_M": 0.3964194,
    "CMYK_Y": 0.582518,
    "CMYK_K": 0.5345935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04670",
    "Farbtonhilfsbezeichnung": "D6.22.16",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "59",
    "Bcolor": "50",
    "Y": 5,
    "L": 26.5074199984195,
    "a": 6.56702055526384,
    "b": 8.25464062060801,
    "C": 10.5482155243742,
    "h": 0.89877163810489,
    "CMY_C": 0.6984824,
    "CMY_M": 0.7690316,
    "CMY_Y": 0.804085,
    "CMYK_C": 0,
    "CMYK_M": 0.2339805,
    "CMYK_Y": 0.3502369,
    "CMYK_K": 0.6984824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04671",
    "Farbtonhilfsbezeichnung": "D7.20.16",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "60",
    "Bcolor": "51",
    "Y": 5,
    "L": 26.7895144787039,
    "a": 6.29640582216928,
    "b": 7.95111868111804,
    "C": 10.1422391294364,
    "h": 0.90102053583141,
    "CMY_C": 0.6978229,
    "CMY_M": 0.7659067,
    "CMY_Y": 0.7999297,
    "CMYK_C": 0,
    "CMYK_M": 0.2253108,
    "CMYK_Y": 0.3379037,
    "CMYK_K": 0.6978229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04672",
    "Farbtonhilfsbezeichnung": "D7.13.15",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "60",
    "Bcolor": "55",
    "Y": 5,
    "L": 26.3989962156975,
    "a": 3.83466402717567,
    "b": 5.00421920078924,
    "C": 6.30451092558834,
    "h": 0.91695327961851,
    "CMY_C": 0.7205126,
    "CMY_M": 0.7635779,
    "CMY_Y": 0.7862441,
    "CMYK_C": 0,
    "CMYK_M": 0.1540868,
    "CMYK_Y": 0.235186,
    "CMYK_K": 0.7205126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04673",
    "Farbtonhilfsbezeichnung": "D6.10.13",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "57",
    "Bcolor": "53",
    "Y": 4,
    "L": 24.6871997178527,
    "a": 2.95973377888473,
    "b": 3.78979065155221,
    "C": 4.80858994139277,
    "h": 0.90776379517352,
    "CMY_C": 0.7434692,
    "CMY_M": 0.7765557,
    "CMY_Y": 0.7939391,
    "CMYK_C": 0,
    "CMYK_M": 0.1289769,
    "CMYK_Y": 0.1967403,
    "CMYK_K": 0.7434692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04674",
    "Farbtonhilfsbezeichnung": "D6.06.16",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "64",
    "Bcolor": "62",
    "Y": 5,
    "L": 27.7036251527247,
    "a": 1.70809944502487,
    "b": 1.75640213916531,
    "C": 2.45001065070313,
    "h": 0.79933943707562,
    "CMY_C": 0.7284057,
    "CMY_M": 0.7470779,
    "CMY_Y": 0.7560079,
    "CMYK_C": 0,
    "CMYK_M": 0.06875044,
    "CMYK_Y": 0.1016302,
    "CMYK_K": 0.7284057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04675",
    "Farbtonhilfsbezeichnung": "D5.42.35",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "88",
    "Bcolor": "56",
    "Y": 14,
    "L": 43.9109528800048,
    "a": 23.2080142947175,
    "b": 28.9811372870316,
    "C": 37.1284021465183,
    "h": 0.89556946123997,
    "CMY_C": 0.4084791,
    "CMY_M": 0.6561761,
    "CMY_Y": 0.7805308,
    "CMYK_C": 0,
    "CMYK_M": 0.4187459,
    "CMYK_Y": 0.6289747,
    "CMYK_K": 0.4084791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04676",
    "Farbtonhilfsbezeichnung": "D6.40.35",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "95",
    "Bcolor": "68",
    "Y": 13,
    "L": 45.1996040344238,
    "a": 18.1758441925049,
    "b": 23.5830020904541,
    "C": 29.7744731903076,
    "h": 52.3779106140137,
    "CMY_C": 0.42648589611053,
    "CMY_M": 0.62848442792892,
    "CMY_Y": 0.73405504226685,
    "CMYK_C": 0,
    "CMYK_M": 0.3522119820118,
    "CMYK_Y": 0.53628873825073,
    "CMYK_K": 0.42648589611053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04677",
    "Farbtonhilfsbezeichnung": "D6.30.31",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "84",
    "Bcolor": "64",
    "Y": 11,
    "L": 39.7283009329492,
    "a": 14.9238638312515,
    "b": 18.4049676211902,
    "C": 23.695243083598,
    "h": 0.88946803760246,
    "CMY_C": 0.5083413,
    "CMY_M": 0.6708093,
    "CMY_Y": 0.7500718,
    "CMYK_C": 0,
    "CMYK_M": 0.3304488,
    "CMYK_Y": 0.4916633,
    "CMYK_K": 0.5083413
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04678",
    "Farbtonhilfsbezeichnung": "D6.21.20",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "68",
    "Bcolor": "58",
    "Y": 7,
    "L": 30.7020483731299,
    "a": 7.2372182111213,
    "b": 9.03730901670321,
    "C": 11.5780085376878,
    "h": 0.89555825395837,
    "CMY_C": 0.653911,
    "CMY_M": 0.7333756,
    "CMY_Y": 0.7725656,
    "CMYK_C": 0,
    "CMYK_M": 0.2296074,
    "CMYK_Y": 0.3428442,
    "CMYK_K": 0.653911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04679",
    "Farbtonhilfsbezeichnung": "D6.16.25",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "74",
    "Bcolor": "64",
    "Y": 8,
    "L": 33.3280746598434,
    "a": 6.87677391256658,
    "b": 8.9324305667972,
    "C": 11.2729026996249,
    "h": 0.91470178521903,
    "CMY_C": 0.630897,
    "CMY_M": 0.7087714,
    "CMY_Y": 0.7489383,
    "CMYK_C": 0,
    "CMYK_M": 0.2109828,
    "CMYK_Y": 0.3198059,
    "CMYK_K": 0.630897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04680",
    "Farbtonhilfsbezeichnung": "D6.11.22",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "70",
    "Bcolor": "63",
    "Y": 7,
    "L": 30.9120043141905,
    "a": 4.19106235600869,
    "b": 5.8777076230539,
    "C": 7.21889538461799,
    "h": 0.95136974284734,
    "CMY_C": 0.6750201,
    "CMY_M": 0.7242642,
    "CMY_Y": 0.7520853,
    "CMYK_C": 0,
    "CMYK_M": 0.1515297,
    "CMYK_Y": 0.2371385,
    "CMYK_K": 0.6750201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04681",
    "Farbtonhilfsbezeichnung": "D6.62.42",
    "Farbtonklasse": "04",
    "Rcolor": "191",
    "Gcolor": "94",
    "Bcolor": "38",
    "Y": 19,
    "L": 50.9720901089544,
    "a": 35.6755169565977,
    "b": 47.4544634288964,
    "C": 59.3689195576688,
    "h": 0.92615429236004,
    "CMY_C": 0.2504461,
    "CMY_M": 0.6313798,
    "CMY_Y": 0.8493146,
    "CMYK_C": 0,
    "CMYK_M": 0.5082139,
    "CMYK_Y": 0.7989665,
    "CMYK_K": 0.2504461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04682",
    "Farbtonhilfsbezeichnung": "D6.52.42",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "95",
    "Bcolor": "51",
    "Y": 18,
    "L": 49.5771950532928,
    "a": 31.0920121016242,
    "b": 39.4906601558018,
    "C": 50.2615703701006,
    "h": 0.90383153018394,
    "CMY_C": 0.2952408,
    "CMY_M": 0.627985,
    "CMY_Y": 0.8014492,
    "CMYK_C": 0,
    "CMYK_M": 0.4721388,
    "CMYK_Y": 0.7182714,
    "CMYK_K": 0.2952408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04683",
    "Farbtonhilfsbezeichnung": "D6.44.38",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "94",
    "Bcolor": "58",
    "Y": 16,
    "L": 46.7398681109783,
    "a": 24.1211615344822,
    "b": 31.5480280024051,
    "C": 39.7128254423319,
    "h": 0.91802572650413,
    "CMY_C": 0.369884,
    "CMY_M": 0.6321345,
    "CMY_Y": 0.7725753,
    "CMYK_C": 0,
    "CMYK_M": 0.416194,
    "CMYK_Y": 0.6390749,
    "CMYK_K": 0.369884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04684",
    "Farbtonhilfsbezeichnung": "D6.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "100",
    "Bcolor": "74",
    "Y": 16,
    "L": 47.0253990112157,
    "a": 16.7240585086026,
    "b": 22.1199476615128,
    "C": 27.7306007426314,
    "h": 0.92342662249015,
    "CMY_C": 0.4165174,
    "CMY_M": 0.6067593,
    "CMY_Y": 0.7080541,
    "CMYK_C": 0,
    "CMYK_M": 0.3260455,
    "CMYK_Y": 0.4996493,
    "CMYK_K": 0.4165174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04685",
    "Farbtonhilfsbezeichnung": "D7.27.23",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "74",
    "Bcolor": "59",
    "Y": 8,
    "L": 33.7681070869724,
    "a": 9.48779452822435,
    "b": 12.908333218684,
    "C": 16.0200908703536,
    "h": 0.93695600690038,
    "CMY_C": 0.6056081,
    "CMY_M": 0.7114897,
    "CMY_Y": 0.7690999,
    "CMYK_C": 0,
    "CMYK_M": 0.2684679,
    "CMYK_Y": 0.4145415,
    "CMYK_K": 0.6056081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04686",
    "Farbtonhilfsbezeichnung": "D6.16.28",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "84",
    "Bcolor": "73",
    "Y": 10,
    "L": 37.5262098887957,
    "a": 7.22242807041473,
    "b": 9.3157188238954,
    "C": 11.7875393716498,
    "h": 0.91130212627233,
    "CMY_C": 0.5873898,
    "CMY_M": 0.6709341,
    "CMY_Y": 0.7137203,
    "CMYK_C": 0,
    "CMYK_M": 0.2024778,
    "CMYK_Y": 0.306174,
    "CMYK_K": 0.5873898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04687",
    "Farbtonhilfsbezeichnung": "D6.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "87",
    "Bcolor": "79",
    "Y": 10,
    "L": 38.2920054316744,
    "a": 4.93308541688209,
    "b": 6.64251382109293,
    "C": 8.27395441090083,
    "h": 0.93201365154299,
    "CMY_C": 0.5987331,
    "CMY_M": 0.6581399,
    "CMY_Y": 0.6903785,
    "CMYK_C": 0,
    "CMYK_M": 0.148048,
    "CMYK_Y": 0.22839,
    "CMYK_K": 0.5987331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04688",
    "Farbtonhilfsbezeichnung": "D7.07.39",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "108",
    "Bcolor": "100",
    "Y": 16,
    "L": 46.5039825584866,
    "a": 3.83865520389026,
    "b": 5.69093283783788,
    "C": 6.86454589460478,
    "h": 0.97737562087801,
    "CMY_C": 0.5270157,
    "CMY_M": 0.5771958,
    "CMY_Y": 0.6077679,
    "CMYK_C": 0,
    "CMYK_M": 0.1060926,
    "CMYK_Y": 0.170729,
    "CMYK_K": 0.5270157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04689",
    "Farbtonhilfsbezeichnung": "D7.63.48",
    "Farbtonklasse": "04",
    "Rcolor": "213",
    "Gcolor": "108",
    "Bcolor": "51",
    "Y": 25,
    "L": 57.0629942532539,
    "a": 37.6948310991054,
    "b": 48.4142714566928,
    "C": 61.3583080949306,
    "h": 0.9092477497446,
    "CMY_C": 0.1663773,
    "CMY_M": 0.5777187,
    "CMY_Y": 0.7981374,
    "CMYK_C": 0,
    "CMYK_M": 0.4934383,
    "CMYK_Y": 0.757849,
    "CMYK_K": 0.1663773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04690",
    "Farbtonhilfsbezeichnung": "D6.59.46",
    "Farbtonklasse": "04",
    "Rcolor": "205",
    "Gcolor": "103",
    "Bcolor": "48",
    "Y": 23,
    "L": 54.886206337668,
    "a": 36.885002884233,
    "b": 47.3432742137623,
    "C": 60.0157400275075,
    "h": 0.90893170671289,
    "CMY_C": 0.1975076,
    "CMY_M": 0.5966168,
    "CMY_Y": 0.8105159,
    "CMYK_C": 0,
    "CMYK_M": 0.4973371,
    "CMYK_Y": 0.7638806,
    "CMYK_K": 0.1975076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04691",
    "Farbtonhilfsbezeichnung": "D7.45.42",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "101",
    "Bcolor": "62",
    "Y": 18,
    "L": 50.0435521268634,
    "a": 24.6740912173019,
    "b": 33.8420459368193,
    "C": 41.8819155553984,
    "h": 0.9408087310875,
    "CMY_C": 0.3276331,
    "CMY_M": 0.6020331,
    "CMY_Y": 0.7585556,
    "CMYK_C": 0,
    "CMYK_M": 0.4081106,
    "CMYK_Y": 0.6409038,
    "CMYK_K": 0.3276331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04692",
    "Farbtonhilfsbezeichnung": "D6.21.42",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "109",
    "Bcolor": "89",
    "Y": 18,
    "L": 48.9707735242747,
    "a": 11.6379651291714,
    "b": 16.3051290879649,
    "C": 20.0324603312476,
    "h": 0.95089437761618,
    "CMY_C": 0.4331283,
    "CMY_M": 0.5736833,
    "CMY_Y": 0.6525756,
    "CMYK_C": 0,
    "CMYK_M": 0.2479486,
    "CMYK_Y": 0.3871198,
    "CMYK_K": 0.4331283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04693",
    "Farbtonhilfsbezeichnung": "D6.19.31",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "85",
    "Bcolor": "72",
    "Y": 10,
    "L": 38.6050425087846,
    "a": 9.12352149822393,
    "b": 11.8464867906754,
    "C": 14.9525213195033,
    "h": 0.91452611314067,
    "CMY_C": 0.5613444,
    "CMY_M": 0.665761,
    "CMY_Y": 0.7195553,
    "CMYK_C": 0,
    "CMYK_M": 0.2380376,
    "CMYK_Y": 0.3606721,
    "CMYK_K": 0.5613444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04694",
    "Farbtonhilfsbezeichnung": "D6.12.37",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "100",
    "Bcolor": "89",
    "Y": 14,
    "L": 44.0441477818881,
    "a": 6.54347866531951,
    "b": 8.94404862276849,
    "C": 11.0821080490103,
    "h": 0.93917466703988,
    "CMY_C": 0.5274863,
    "CMY_M": 0.6077045,
    "CMY_Y": 0.6515648,
    "CMYK_C": 0,
    "CMYK_M": 0.1697692,
    "CMYK_Y": 0.2625924,
    "CMYK_K": 0.5274863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04695",
    "Farbtonhilfsbezeichnung": "D6.09.50",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "135",
    "Bcolor": "124",
    "Y": 26,
    "L": 57.7135891962934,
    "a": 5.85594492683367,
    "b": 7.77854456674478,
    "C": 9.73641856962527,
    "h": 0.92548457162001,
    "CMY_C": 0.3947117,
    "CMY_M": 0.4711015,
    "CMY_Y": 0.5123631,
    "CMYK_C": 0,
    "CMYK_M": 0.1262039,
    "CMYK_Y": 0.1943725,
    "CMYK_K": 0.3947117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04696",
    "Farbtonhilfsbezeichnung": "D7.70.51",
    "Farbtonklasse": "04",
    "Rcolor": "224",
    "Gcolor": "107",
    "Bcolor": "36",
    "Y": 27,
    "L": 58.5209350519527,
    "a": 41.7649607674868,
    "b": 57.1616791648347,
    "C": 70.7938522249864,
    "h": 0.9397971784492,
    "CMY_C": 0.1224987,
    "CMY_M": 0.5793101,
    "CMY_Y": 0.8592269,
    "CMYK_C": 0,
    "CMYK_M": 0.520582,
    "CMYK_Y": 0.8395751,
    "CMYK_K": 0.1224987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04697",
    "Farbtonhilfsbezeichnung": "D6.51.50",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "113",
    "Bcolor": "63",
    "Y": 25,
    "L": 57.4671555432893,
    "a": 33.1556453383079,
    "b": 42.9788786987568,
    "C": 54.2814962211076,
    "h": 0.91371394692885,
    "CMY_C": 0.1890582,
    "CMY_M": 0.5568758,
    "CMY_Y": 0.7538165,
    "CMYK_C": 0,
    "CMYK_M": 0.4535685,
    "CMYK_Y": 0.6964227,
    "CMYK_K": 0.1890582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04698",
    "Farbtonhilfsbezeichnung": "D7.42.48",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "116",
    "Bcolor": "72",
    "Y": 23,
    "L": 55.3581573156484,
    "a": 23.7212441498432,
    "b": 34.9400866290096,
    "C": 42.2315886234365,
    "h": 0.97436402653224,
    "CMY_C": 0.2711168,
    "CMY_M": 0.5468794,
    "CMY_Y": 0.717674,
    "CMYK_C": 0,
    "CMYK_M": 0.3783358,
    "CMYK_Y": 0.6126594,
    "CMYK_K": 0.2711168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04699",
    "Farbtonhilfsbezeichnung": "D5.42.44",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "106",
    "Bcolor": "67",
    "Y": 20,
    "L": 52.0927868420322,
    "a": 25.5803266292314,
    "b": 33.2838368598505,
    "C": 41.9781717869098,
    "h": 0.91552789783562,
    "CMY_C": 0.3001444,
    "CMY_M": 0.5845725,
    "CMY_Y": 0.7355683,
    "CMYK_C": 0,
    "CMYK_M": 0.4064097,
    "CMYK_Y": 0.6221625,
    "CMYK_K": 0.3001444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04701",
    "Farbtonhilfsbezeichnung": "D6.64.53",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "111",
    "Bcolor": "45",
    "Y": 28,
    "L": 59.8916312079126,
    "a": 41.4087587779911,
    "b": 54.6385081293275,
    "C": 68.5569243339609,
    "h": 0.92227889630343,
    "CMY_C": 0.108781,
    "CMY_M": 0.5635639,
    "CMY_Y": 0.8215981,
    "CMYK_C": 0,
    "CMYK_M": 0.5102932,
    "CMYK_Y": 0.7998226,
    "CMYK_K": 0.108781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04702",
    "Farbtonhilfsbezeichnung": "D5.54.54",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "120",
    "Bcolor": "64",
    "Y": 30,
    "L": 61.8818936261041,
    "a": 37.8876150036947,
    "b": 48.2015367048384,
    "C": 61.3095385023903,
    "h": 0.90463497772284,
    "CMY_C": 0.1069751,
    "CMY_M": 0.5291968,
    "CMY_Y": 0.7504172,
    "CMYK_C": 0,
    "CMYK_M": 0.4727995,
    "CMYK_Y": 0.7205198,
    "CMYK_K": 0.1069751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04703",
    "Farbtonhilfsbezeichnung": "D5.44.54",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "126",
    "Bcolor": "78",
    "Y": 30,
    "L": 61.4086731931891,
    "a": 29.8481588917009,
    "b": 39.9599453284251,
    "C": 49.8769467777945,
    "h": 0.92924882887739,
    "CMY_C": 0.1626194,
    "CMY_M": 0.5055768,
    "CMY_Y": 0.6953338,
    "CMYK_C": 0,
    "CMYK_M": 0.4095599,
    "CMYK_Y": 0.6361676,
    "CMYK_K": 0.1626194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04704",
    "Farbtonhilfsbezeichnung": "D6.36.50",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "121",
    "Bcolor": "83",
    "Y": 25,
    "L": 57.4031627346318,
    "a": 23.6366439689598,
    "b": 31.5700197356046,
    "C": 39.4380157236875,
    "h": 0.92812428278442,
    "CMY_C": 0.251938,
    "CMY_M": 0.5256186,
    "CMY_Y": 0.6746475,
    "CMYK_C": 0,
    "CMYK_M": 0.3658528,
    "CMYK_Y": 0.5650728,
    "CMYK_K": 0.251938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04705",
    "Farbtonhilfsbezeichnung": "D6.22.51",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "131",
    "Bcolor": "106",
    "Y": 26,
    "L": 58.2758302773678,
    "a": 14.0582288519226,
    "b": 19.1823050995591,
    "C": 23.7822334398097,
    "h": 0.93834570775068,
    "CMY_C": 0.3144428,
    "CMY_M": 0.4880759,
    "CMY_Y": 0.5828434,
    "CMYK_C": 0,
    "CMYK_M": 0.253273,
    "CMYK_Y": 0.3915073,
    "CMYK_K": 0.3144428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04706",
    "Farbtonhilfsbezeichnung": "D7.19.58",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "150",
    "Bcolor": "124",
    "Y": 35,
    "L": 65.4168246934409,
    "a": 13.021506218286,
    "b": 19.2805280643562,
    "C": 23.2658201367003,
    "h": 0.97679194817498,
    "CMY_C": 0.2422038,
    "CMY_M": 0.4125436,
    "CMY_Y": 0.5136999,
    "CMYK_C": 0,
    "CMYK_M": 0.2247831,
    "CMYK_Y": 0.3582705,
    "CMYK_K": 0.2422038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04707",
    "Farbtonhilfsbezeichnung": "D7.10.59",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "159",
    "Bcolor": "143",
    "Y": 37,
    "L": 67.3312820530063,
    "a": 7.60129532929205,
    "b": 11.1152814871062,
    "C": 13.4658521163989,
    "h": 0.97098497261125,
    "CMY_C": 0.2731273,
    "CMY_M": 0.3772972,
    "CMY_Y": 0.4384841,
    "CMYK_C": 0,
    "CMYK_M": 0.1433125,
    "CMYK_Y": 0.2274908,
    "CMYK_K": 0.2731273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04708",
    "Farbtonhilfsbezeichnung": "D6.07.66",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "175",
    "Bcolor": "166",
    "Y": 45,
    "L": 73.0448254309571,
    "a": 6.21072393989153,
    "b": 6.97442994949287,
    "C": 9.33893810761828,
    "h": 0.84325517999789,
    "CMY_C": 0.2310797,
    "CMY_M": 0.3128318,
    "CMY_Y": 0.3507933,
    "CMYK_C": 0,
    "CMYK_M": 0.1063206,
    "CMYK_Y": 0.1556905,
    "CMYK_K": 0.2310797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04709",
    "Farbtonhilfsbezeichnung": "D7.74.55",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "116",
    "Bcolor": "29",
    "Y": 33,
    "L": 63.8856007025029,
    "a": 46.6819167106697,
    "b": 65.2700486222415,
    "C": 80.2457512578185,
    "h": 0.94993381190128,
    "CMY_C": 0.02597072,
    "CMY_M": 0.5442652,
    "CMY_Y": 0.8846355,
    "CMYK_C": 0,
    "CMYK_M": 0.5321139,
    "CMYK_Y": 0.8815595,
    "CMYK_K": 0.02597072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04710",
    "Farbtonhilfsbezeichnung": "D6.30.59",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "149",
    "Bcolor": "113",
    "Y": 38,
    "L": 68.2736437717647,
    "a": 23.6751955460149,
    "b": 29.7993848938061,
    "C": 38.059403886441,
    "h": 0.89942660518743,
    "CMY_C": 0.1289611,
    "CMY_M": 0.4143326,
    "CMY_Y": 0.5574098,
    "CMYK_C": 0,
    "CMYK_M": 0.327622,
    "CMYK_Y": 0.4918825,
    "CMYK_K": 0.1289611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04711",
    "Farbtonhilfsbezeichnung": "D7.18.64",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "165",
    "Bcolor": "138",
    "Y": 43,
    "L": 71.3448691706759,
    "a": 13.2077082661669,
    "b": 19.7543604569746,
    "C": 23.7629609836033,
    "h": 0.98145845454678,
    "CMY_C": 0.1741645,
    "CMY_M": 0.3513572,
    "CMY_Y": 0.4575363,
    "CMYK_C": 0,
    "CMYK_M": 0.2145617,
    "CMYK_Y": 0.3431334,
    "CMYK_K": 0.1741645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04712",
    "Farbtonhilfsbezeichnung": "D7.12.71",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "185",
    "Bcolor": "164",
    "Y": 53,
    "L": 77.9698854701073,
    "a": 10.4736453892842,
    "b": 15.0000858215757,
    "C": 18.2948031526746,
    "h": 0.96125319879144,
    "CMY_C": 0.1277403,
    "CMY_M": 0.2728715,
    "CMY_Y": 0.3559771,
    "CMYK_C": 0,
    "CMYK_M": 0.1663853,
    "CMYK_Y": 0.2616615,
    "CMYK_K": 0.1277403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04713",
    "Farbtonhilfsbezeichnung": "D6.06.71",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "189",
    "Bcolor": "177",
    "Y": 53,
    "L": 77.9434065092705,
    "a": 5.65793272580262,
    "b": 7.92907564179604,
    "C": 9.74076194468541,
    "h": 0.9510224059967,
    "CMY_C": 0.178817,
    "CMY_M": 0.2594196,
    "CMY_Y": 0.3062681,
    "CMYK_C": 0,
    "CMYK_M": 0.09815425,
    "CMYK_Y": 0.1552042,
    "CMYK_K": 0.178817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04714",
    "Farbtonhilfsbezeichnung": "D6.05.69",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "184",
    "Bcolor": "174",
    "Y": 50,
    "L": 75.8794682035817,
    "a": 4.42869506963933,
    "b": 6.21898308220059,
    "C": 7.63472924186214,
    "h": 0.95197886085161,
    "CMY_C": 0.2148862,
    "CMY_M": 0.278158,
    "CMY_Y": 0.3159879,
    "CMYK_C": 0,
    "CMYK_M": 0.08058942,
    "CMYK_Y": 0.1287733,
    "CMYK_K": 0.2148862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04715",
    "Farbtonhilfsbezeichnung": "D6.66.57",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "122",
    "Bcolor": "43",
    "Y": 34,
    "L": 65.2876123788627,
    "a": 45.0125975596369,
    "b": 61.8961221504512,
    "C": 76.5327634175678,
    "h": 0.94202924813229,
    "CMY_C": 0.01856023,
    "CMY_M": 0.5225057,
    "CMY_Y": 0.8325358,
    "CMYK_C": 0,
    "CMYK_M": 0.5134757,
    "CMYK_Y": 0.8293688,
    "CMYK_K": 0.01856023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04716",
    "Farbtonhilfsbezeichnung": "D7.51.61",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "136",
    "Bcolor": "75",
    "Y": 37,
    "L": 67.4471939152387,
    "a": 36.3183595456182,
    "b": 49.3199643405846,
    "C": 61.2493438547821,
    "h": 0.93606752191797,
    "CMY_C": 0.04642981,
    "CMY_M": 0.4663214,
    "CMY_Y": 0.7063271,
    "CMYK_C": 0,
    "CMYK_M": 0.4403364,
    "CMYK_Y": 0.6920281,
    "CMYK_K": 0.04642981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04717",
    "Farbtonhilfsbezeichnung": "D7.35.62",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "149",
    "Bcolor": "101",
    "Y": 39,
    "L": 68.6827721325332,
    "a": 25.738479620688,
    "b": 36.9059835071946,
    "C": 44.9946769275866,
    "h": 0.96181296346898,
    "CMY_C": 0.1029674,
    "CMY_M": 0.4175103,
    "CMY_Y": 0.6042035,
    "CMYK_C": 0,
    "CMYK_M": 0.3506482,
    "CMYK_Y": 0.5587713,
    "CMYK_K": 0.1029674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04718",
    "Farbtonhilfsbezeichnung": "D6.15.72",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "188",
    "Bcolor": "163",
    "Y": 56,
    "L": 79.5177288807201,
    "a": 12.4902172646431,
    "b": 17.9629149542558,
    "C": 21.8785703594137,
    "h": 0.96320908470231,
    "CMY_C": 0.09027483,
    "CMY_M": 0.2621401,
    "CMY_Y": 0.3608544,
    "CMYK_C": 0,
    "CMYK_M": 0.18892,
    "CMYK_Y": 0.2974299,
    "CMYK_K": 0.09027483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04719",
    "Farbtonhilfsbezeichnung": "D5.10.74",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "195",
    "Bcolor": "179",
    "Y": 59,
    "L": 81.0258739678419,
    "a": 8.34534890531313,
    "b": 11.1371597046042,
    "C": 13.9169384074685,
    "h": 0.92772754719092,
    "CMY_C": 0.1173342,
    "CMY_M": 0.2336078,
    "CMY_Y": 0.296357,
    "CMYK_C": 0,
    "CMYK_M": 0.13173,
    "CMYK_Y": 0.2028206,
    "CMYK_K": 0.1173342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04720",
    "Farbtonhilfsbezeichnung": "D6.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "194",
    "Bcolor": "186",
    "Y": 55,
    "L": 79.2993426617593,
    "a": 3.31041357095557,
    "b": 4.89051825160112,
    "C": 5.90559114568647,
    "h": 0.97573947638675,
    "CMY_C": 0.1894688,
    "CMY_M": 0.2383619,
    "CMY_Y": 0.2704124,
    "CMYK_C": 0,
    "CMYK_M": 0.0603222,
    "CMYK_Y": 0.09986485,
    "CMYK_K": 0.1894688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04722",
    "Farbtonhilfsbezeichnung": "D8.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "229",
    "Bcolor": "221",
    "Y": 80,
    "L": 91.5288483113762,
    "a": 2.59484269167121,
    "b": 4.40985227592698,
    "C": 5.11664007821714,
    "h": 1.03893548230951,
    "CMY_C": 0.06056792,
    "CMY_M": 0.1022385,
    "CMY_Y": 0.1345528,
    "CMYK_C": 0,
    "CMYK_M": 0.04435715,
    "CMYK_Y": 0.0787549,
    "CMYK_K": 0.06056792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04723",
    "Farbtonhilfsbezeichnung": "D9.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "218",
    "Bcolor": "197",
    "Y": 75,
    "L": 89.1715952478213,
    "a": 8.33815723733466,
    "b": 13.459648619317,
    "C": 15.8330984671352,
    "h": 1.01616695267943,
    "CMY_C": 0.01937775,
    "CMY_M": 0.1450754,
    "CMY_Y": 0.2262866,
    "CMYK_C": 0,
    "CMYK_M": 0.1281815,
    "CMYK_Y": 0.2109975,
    "CMYK_K": 0.01937775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04724",
    "Farbtonhilfsbezeichnung": "D8.17.77",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "203",
    "Bcolor": "173",
    "Y": 66,
    "L": 85.2208633422852,
    "a": 13.3297500610352,
    "b": 20.5455436706543,
    "C": 24.4908466339111,
    "h": 57.0248832702637,
    "CMY_C": 0.01384890079498,
    "CMY_M": 0.20308643579483,
    "CMY_Y": 0.31973683834076,
    "CMYK_C": 0,
    "CMYK_M": 0.1918950676918,
    "CMYK_Y": 0.31018364429474,
    "CMYK_K": 0.01384890079498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04725",
    "Farbtonhilfsbezeichnung": "D8.17.74",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "193",
    "Bcolor": "163",
    "Y": 59,
    "L": 81.3174854682581,
    "a": 13.009947471506,
    "b": 20.4352840164152,
    "C": 24.2251845409462,
    "h": 1.00386944412129,
    "CMY_C": 0.0610908,
    "CMY_M": 0.2446666,
    "CMY_Y": 0.3599358,
    "CMYK_C": 0,
    "CMYK_M": 0.1955203,
    "CMYK_Y": 0.3182895,
    "CMYK_K": 0.0610908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04726",
    "Farbtonhilfsbezeichnung": "D9.34.72",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "178",
    "Bcolor": "125",
    "Y": 55,
    "L": 79.2026320133585,
    "a": 24.0089602985786,
    "b": 38.4035663904336,
    "C": 45.2908830353656,
    "h": 1.01207097869416,
    "CMY_C": 0,
    "CMY_M": 0.3016418,
    "CMY_Y": 0.5113395,
    "CMYK_C": 0,
    "CMYK_M": 0.3016418,
    "CMYK_Y": 0.5113395,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04727",
    "Farbtonhilfsbezeichnung": "D9.54.62",
    "Farbtonklasse": "04",
    "Rcolor": "253",
    "Gcolor": "145",
    "Bcolor": "67",
    "Y": 41,
    "L": 70.4907373346796,
    "a": 35.4047689730643,
    "b": 56.7203751903066,
    "C": 66.8632831063896,
    "h": 1.01277363115859,
    "CMY_C": 0.007959223,
    "CMY_M": 0.4324808,
    "CMY_Y": 0.7374913,
    "CMYK_C": 0,
    "CMYK_M": 0.4279276,
    "CMYK_Y": 0.7353851,
    "CMYK_K": 0.007959223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04729",
    "Farbtonhilfsbezeichnung": "D7.10.74",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 58,
    "L": 80.9004115517128,
    "a": 6.88579005722789,
    "b": 11.1741778899406,
    "C": 13.125408802329,
    "h": 1.01853317244491,
    "CMY_C": 0.1288343,
    "CMY_M": 0.2313446,
    "CMY_Y": 0.2981872,
    "CMYK_C": 0,
    "CMYK_M": 0.1176704,
    "CMYK_Y": 0.1943981,
    "CMYK_K": 0.1288343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04730",
    "Farbtonhilfsbezeichnung": "D8.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "197",
    "Bcolor": "170",
    "Y": 61,
    "L": 82.5135029286891,
    "a": 10.9891124626876,
    "b": 18.186185117956,
    "C": 21.2484804600743,
    "h": 1.02725325003803,
    "CMY_C": 0.06572714,
    "CMY_M": 0.2259331,
    "CMY_Y": 0.3313971,
    "CMYK_C": 0,
    "CMYK_M": 0.1714766,
    "CMYK_Y": 0.2843601,
    "CMYK_K": 0.06572714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04731",
    "Farbtonhilfsbezeichnung": "D9.29.72",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "182",
    "Bcolor": "133",
    "Y": 56,
    "L": 79.7434832161589,
    "a": 20.3539242719299,
    "b": 34.5088048199618,
    "C": 40.0641965271946,
    "h": 1.03789701654463,
    "CMY_C": 0.007603293,
    "CMY_M": 0.2845906,
    "CMY_Y": 0.4777975,
    "CMYK_C": 0,
    "CMYK_M": 0.2791094,
    "CMYK_Y": 0.4737966,
    "CMYK_K": 0.007603293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04732",
    "Farbtonhilfsbezeichnung": "D9.33.71",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "124",
    "Y": 55,
    "L": 78.9486606529512,
    "a": 22.4716780577812,
    "b": 38.3876975285705,
    "C": 44.4813627969915,
    "h": 1.04119061054759,
    "CMY_C": 0,
    "CMY_M": 0.2998858,
    "CMY_Y": 0.5141899,
    "CMYK_C": 0,
    "CMYK_M": 0.2998858,
    "CMYK_Y": 0.5141899,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04733",
    "Farbtonhilfsbezeichnung": "D9.46.67",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "160",
    "Bcolor": "90",
    "Y": 48,
    "L": 74.7064638474139,
    "a": 30.8442697816886,
    "b": 50.6549149294101,
    "C": 59.3067397929726,
    "h": 1.02385130915812,
    "CMY_C": 0,
    "CMY_M": 0.3723595,
    "CMY_Y": 0.647848,
    "CMYK_C": 0,
    "CMYK_M": 0.3723595,
    "CMYK_Y": 0.647848,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04734",
    "Farbtonhilfsbezeichnung": "D9.68.59",
    "Farbtonklasse": "04",
    "Rcolor": "251",
    "Gcolor": "133",
    "Bcolor": "41",
    "Y": 38,
    "L": 67.6636887539031,
    "a": 39.6828889309258,
    "b": 64.4543701836713,
    "C": 75.6908020150265,
    "h": 1.01893137287615,
    "CMY_C": 0.0151218,
    "CMY_M": 0.4778776,
    "CMY_Y": 0.8375321,
    "CMYK_C": 0,
    "CMYK_M": 0.4698609,
    "CMYK_Y": 0.8350376,
    "CMYK_K": 0.0151218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04735",
    "Farbtonhilfsbezeichnung": "D8.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "215",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.5893283996502,
    "a": 3.03636425054743,
    "b": 5.45981978132724,
    "C": 6.24733062247986,
    "h": 1.06325971202975,
    "CMY_C": 0.109285,
    "CMY_M": 0.1583204,
    "CMY_Y": 0.1961943,
    "CMYK_C": 0,
    "CMYK_M": 0.05505162,
    "CMYK_Y": 0.09757248,
    "CMYK_K": 0.109285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04736",
    "Farbtonhilfsbezeichnung": "D9.10.71",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "189",
    "Bcolor": "171",
    "Y": 54,
    "L": 78.2442046434251,
    "a": 6.98989700233316,
    "b": 11.6491428669912,
    "C": 13.5853299422133,
    "h": 1.03035086679233,
    "CMY_C": 0.1564462,
    "CMY_M": 0.2603845,
    "CMY_Y": 0.3295968,
    "CMYK_C": 0,
    "CMYK_M": 0.1232148,
    "CMYK_Y": 0.2052632,
    "CMYK_K": 0.1564462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04737",
    "Farbtonhilfsbezeichnung": "D9.14.71",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "188",
    "Bcolor": "164",
    "Y": 55,
    "L": 78.7766657412546,
    "a": 9.32375498581306,
    "b": 16.0499909274162,
    "C": 18.5616436719817,
    "h": 1.0445246590422,
    "CMY_C": 0.1240182,
    "CMY_M": 0.2615453,
    "CMY_Y": 0.3553222,
    "CMYK_C": 0,
    "CMYK_M": 0.1569977,
    "CMYK_Y": 0.2640511,
    "CMYK_K": 0.1240182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04738",
    "Farbtonhilfsbezeichnung": "D8.33.70",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "171",
    "Bcolor": "121",
    "Y": 51,
    "L": 76.5183570034492,
    "a": 24.2857375561799,
    "b": 36.4522418595016,
    "C": 43.8014039184961,
    "h": 0.98309304312082,
    "CMY_C": 0.0192623,
    "CMY_M": 0.3307256,
    "CMY_Y": 0.5237451,
    "CMYK_C": 0,
    "CMYK_M": 0.3175807,
    "CMYK_Y": 0.5143911,
    "CMYK_K": 0.0192623
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04739",
    "Farbtonhilfsbezeichnung": "D8.47.61",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "144",
    "Bcolor": "79",
    "Y": 39,
    "L": 68.6825088512125,
    "a": 31.4331292548022,
    "b": 48.6624255803909,
    "C": 57.9316258887681,
    "h": 0.99727876317026,
    "CMY_C": 0.05863743,
    "CMY_M": 0.4371138,
    "CMY_Y": 0.6910972,
    "CMYK_C": 0,
    "CMYK_M": 0.4020517,
    "CMYK_Y": 0.6718556,
    "CMYK_K": 0.05863743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04740",
    "Farbtonhilfsbezeichnung": "D9.72.56",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "120",
    "Bcolor": "21",
    "Y": 33,
    "L": 64.2019612436058,
    "a": 43.8409281839563,
    "b": 67.5763728204979,
    "C": 80.5518041238416,
    "h": 0.99529246599231,
    "CMY_C": 0.03548714,
    "CMY_M": 0.5298406,
    "CMY_Y": 0.9164485,
    "CMYK_C": 0,
    "CMYK_M": 0.5125422,
    "CMYK_Y": 0.9133745,
    "CMYK_K": 0.03548714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04741",
    "Farbtonhilfsbezeichnung": "D9.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "200",
    "Bcolor": "189",
    "Y": 59,
    "L": 81.5157739835731,
    "a": 3.95719907286451,
    "b": 6.46994378241581,
    "C": 7.58416752517379,
    "h": 1.02187063590267,
    "CMY_C": 0.1557618,
    "CMY_M": 0.2163104,
    "CMY_Y": 0.2580579,
    "CMYK_C": 0,
    "CMYK_M": 0.07171988,
    "CMYK_Y": 0.1211697,
    "CMYK_K": 0.1557618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04742",
    "Farbtonhilfsbezeichnung": "D8.06.67",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "180",
    "Bcolor": "170",
    "Y": 47,
    "L": 74.2642300036609,
    "a": 4.17496885888752,
    "b": 6.40735624839381,
    "C": 7.64752110598668,
    "h": 0.99330421144052,
    "CMY_C": 0.2337273,
    "CMY_M": 0.2948512,
    "CMY_Y": 0.3343305,
    "CMYK_C": 0,
    "CMYK_M": 0.07976784,
    "CMYK_Y": 0.1312891,
    "CMYK_K": 0.2337273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04743",
    "Farbtonhilfsbezeichnung": "D9.09.68",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "184",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.441982027094,
    "a": 6.69860454671467,
    "b": 10.9781663559591,
    "C": 12.8604603110611,
    "h": 1.02292865579404,
    "CMY_C": 0.1800878,
    "CMY_M": 0.278836,
    "CMY_Y": 0.3437146,
    "CMYK_C": 0,
    "CMYK_M": 0.1204376,
    "CMYK_Y": 0.1995663,
    "CMYK_K": 0.1800878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04744",
    "Farbtonhilfsbezeichnung": "D8.16.70",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "184",
    "Bcolor": "156",
    "Y": 53,
    "L": 77.9196061042722,
    "a": 12.6093832326328,
    "b": 19.3733019741239,
    "C": 23.1153925964496,
    "h": 0.99381402201822,
    "CMY_C": 0.1046484,
    "CMY_M": 0.2799369,
    "CMY_Y": 0.3876135,
    "CMYK_C": 0,
    "CMYK_M": 0.1957762,
    "CMYK_Y": 0.3160379,
    "CMYK_K": 0.1046484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04745",
    "Farbtonhilfsbezeichnung": "D9.31.63",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "157",
    "Bcolor": "111",
    "Y": 41,
    "L": 70.0960625548383,
    "a": 20.01767084155,
    "b": 33.0097226488957,
    "C": 38.6050376929962,
    "h": 1.02567149203116,
    "CMY_C": 0.1247772,
    "CMY_M": 0.385503,
    "CMY_Y": 0.5634622,
    "CMYK_C": 0,
    "CMYK_M": 0.2978965,
    "CMYK_Y": 0.5012267,
    "CMYK_K": 0.1247772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04746",
    "Farbtonhilfsbezeichnung": "D9.57.58",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "135",
    "Bcolor": "60",
    "Y": 36,
    "L": 66.5349033041274,
    "a": 34.9629010833786,
    "b": 55.436914195608,
    "C": 65.5412534797537,
    "h": 1.00812361057461,
    "CMY_C": 0.06016831,
    "CMY_M": 0.4719998,
    "CMY_Y": 0.7661635,
    "CMYK_C": 0,
    "CMYK_M": 0.4381971,
    "CMYK_Y": 0.7511932,
    "CMYK_K": 0.06016831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04747",
    "Farbtonhilfsbezeichnung": "D8.70.54",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "116",
    "Bcolor": "31",
    "Y": 31,
    "L": 62.3276322337045,
    "a": 42.490866514346,
    "b": 62.8521404932066,
    "C": 75.8674192372309,
    "h": 0.97632919939683,
    "CMY_C": 0.0683705,
    "CMY_M": 0.5435581,
    "CMY_Y": 0.8781974,
    "CMYK_C": 0,
    "CMYK_M": 0.5100607,
    "CMYK_Y": 0.8692585,
    "CMYK_K": 0.0683705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04748",
    "Farbtonhilfsbezeichnung": "D8.04.70",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "191",
    "Bcolor": "182",
    "Y": 53,
    "L": 78.035726639353,
    "a": 3.5048100053765,
    "b": 5.49140152802567,
    "C": 6.51453635462954,
    "h": 1.0027355751059,
    "CMY_C": 0.2001054,
    "CMY_M": 0.2526171,
    "CMY_Y": 0.2881331,
    "CMYK_C": 0,
    "CMYK_M": 0.06564826,
    "CMYK_Y": 0.1100491,
    "CMYK_K": 0.2001054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04749",
    "Farbtonhilfsbezeichnung": "D9.08.64",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "170",
    "Bcolor": "158",
    "Y": 42,
    "L": 70.9563450489269,
    "a": 5.31842709230662,
    "b": 8.27571900830419,
    "C": 9.83733662332384,
    "h": 0.99960232933551,
    "CMY_C": 0.2564693,
    "CMY_M": 0.3331131,
    "CMY_Y": 0.3817922,
    "CMYK_C": 0,
    "CMYK_M": 0.1030808,
    "CMYK_Y": 0.168551,
    "CMYK_K": 0.2564693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04750",
    "Farbtonhilfsbezeichnung": "D8.20.63",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "163",
    "Bcolor": "135",
    "Y": 41,
    "L": 70.4111796242556,
    "a": 13.2320274584753,
    "b": 20.4645272306921,
    "C": 24.3697235404422,
    "h": 0.99682655181043,
    "CMY_C": 0.1831053,
    "CMY_M": 0.3613782,
    "CMY_Y": 0.4720011,
    "CMYK_C": 0,
    "CMYK_M": 0.2182324,
    "CMYK_Y": 0.3536513,
    "CMYK_K": 0.1831053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04751",
    "Farbtonhilfsbezeichnung": "D9.35.59",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "145",
    "Bcolor": "96",
    "Y": 35,
    "L": 65.921054653243,
    "a": 21.3678668269618,
    "b": 35.510927817914,
    "C": 41.4440795195631,
    "h": 1.02910829739333,
    "CMY_C": 0.1619917,
    "CMY_M": 0.4330826,
    "CMY_Y": 0.6220838,
    "CMYK_C": 0,
    "CMYK_M": 0.3234943,
    "CMYK_Y": 0.5490304,
    "CMYK_K": 0.1619917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04752",
    "Farbtonhilfsbezeichnung": "D9.41.56",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "138",
    "Bcolor": "84",
    "Y": 33,
    "L": 64.3705544230629,
    "a": 25.0548637223865,
    "b": 40.3926332097508,
    "C": 47.5322102764517,
    "h": 1.01559620437018,
    "CMY_C": 0.1536127,
    "CMY_M": 0.4605834,
    "CMY_Y": 0.6718276,
    "CMYK_C": 0,
    "CMYK_M": 0.3626835,
    "CMYK_Y": 0.6122669,
    "CMYK_K": 0.1536127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04753",
    "Farbtonhilfsbezeichnung": "D9.73.53",
    "Farbtonklasse": "04",
    "Rcolor": "232",
    "Gcolor": "115",
    "Bcolor": "16",
    "Y": 29,
    "L": 61.1283959624044,
    "a": 40.7226638320375,
    "b": 65.7021238917015,
    "C": 77.2987996896306,
    "h": 1.01593971937192,
    "CMY_C": 0.09112089,
    "CMY_M": 0.5494434,
    "CMY_Y": 0.9374292,
    "CMYK_C": 0,
    "CMYK_M": 0.5042723,
    "CMYK_Y": 0.9311562,
    "CMYK_K": 0.09112089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04754",
    "Farbtonhilfsbezeichnung": "D8.58.54",
    "Farbtonklasse": "04",
    "Rcolor": "226",
    "Gcolor": "122",
    "Bcolor": "51",
    "Y": 30,
    "L": 61.8779930946529,
    "a": 36.0063326443296,
    "b": 54.0452739938635,
    "C": 64.941108949308,
    "h": 0.98309929879618,
    "CMY_C": 0.1127412,
    "CMY_M": 0.5233564,
    "CMY_Y": 0.7997841,
    "CMYK_C": 0,
    "CMYK_M": 0.4627908,
    "CMYK_Y": 0.7743433,
    "CMYK_K": 0.1127412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04755",
    "Farbtonhilfsbezeichnung": "D9.49.51",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "122",
    "Bcolor": "63",
    "Y": 28,
    "L": 59.6590164487452,
    "a": 28.4315368479409,
    "b": 45.1003006857685,
    "C": 53.3140638995242,
    "h": 1.00831841032124,
    "CMY_C": 0.18627,
    "CMY_M": 0.5196081,
    "CMY_Y": 0.7512872,
    "CMYK_C": 0,
    "CMYK_M": 0.4096421,
    "CMYK_Y": 0.6943546,
    "CMYK_K": 0.18627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04756",
    "Farbtonhilfsbezeichnung": "D9.29.54",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "136",
    "Bcolor": "99",
    "Y": 30,
    "L": 61.2228832911611,
    "a": 15.9935268911702,
    "b": 27.4099135059007,
    "C": 31.7347799869409,
    "h": 1.04260182548616,
    "CMY_C": 0.257495,
    "CMY_M": 0.4649251,
    "CMY_Y": 0.6109339,
    "CMYK_C": 0,
    "CMYK_M": 0.2793652,
    "CMYK_Y": 0.4760088,
    "CMYK_K": 0.257495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04757",
    "Farbtonhilfsbezeichnung": "D9.27.61",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "157",
    "Bcolor": "118",
    "Y": 39,
    "L": 69.0478741942655,
    "a": 16.4413344915117,
    "b": 27.9317860079275,
    "C": 32.4114509001746,
    "h": 1.03878313133983,
    "CMY_C": 0.1657457,
    "CMY_M": 0.3856503,
    "CMY_Y": 0.538084,
    "CMYK_C": 0,
    "CMYK_M": 0.2635942,
    "CMYK_Y": 0.4463128,
    "CMYK_K": 0.1657457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04758",
    "Farbtonhilfsbezeichnung": "D7.15.59",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "155",
    "Bcolor": "133",
    "Y": 36,
    "L": 66.5417445901663,
    "a": 9.80319162606269,
    "b": 15.4787839373915,
    "C": 18.3219900184929,
    "h": 1.00622869455625,
    "CMY_C": 0.2576354,
    "CMY_M": 0.3919263,
    "CMY_Y": 0.4765195,
    "CMYK_C": 0,
    "CMYK_M": 0.1808961,
    "CMYK_Y": 0.2948472,
    "CMYK_K": 0.2576354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04759",
    "Farbtonhilfsbezeichnung": "D9.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "160",
    "Bcolor": "146",
    "Y": 37,
    "L": 67.3479251089475,
    "a": 5.98137995486336,
    "b": 9.55544559913155,
    "C": 11.273129413007,
    "h": 1.01150296999418,
    "CMY_C": 0.2875575,
    "CMY_M": 0.3728549,
    "CMY_Y": 0.4276991,
    "CMYK_C": 0,
    "CMYK_M": 0.1197252,
    "CMYK_Y": 0.1967058,
    "CMYK_K": 0.2875575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04760",
    "Farbtonhilfsbezeichnung": "D8.05.59",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "159",
    "Bcolor": "151",
    "Y": 36,
    "L": 66.1912234516621,
    "a": 3.08971265932506,
    "b": 4.73036517278296,
    "C": 5.65001583936465,
    "h": 0.99219881995229,
    "CMY_C": 0.3325254,
    "CMY_M": 0.3769372,
    "CMY_Y": 0.4064249,
    "CMYK_C": 0,
    "CMYK_M": 0.06653696,
    "CMYK_Y": 0.1107151,
    "CMYK_K": 0.3325254
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04761",
    "Farbtonhilfsbezeichnung": "D8.64.53",
    "Farbtonklasse": "04",
    "Rcolor": "231",
    "Gcolor": "117",
    "Bcolor": "42",
    "Y": 30,
    "L": 61.5245061472201,
    "a": 39.7324883523167,
    "b": 57.8687685236561,
    "C": 70.1959044468513,
    "h": 0.96912282218821,
    "CMY_C": 0.09531043,
    "CMY_M": 0.5408508,
    "CMY_Y": 0.8362216,
    "CMYK_C": 0,
    "CMYK_M": 0.4924787,
    "CMYK_Y": 0.8189673,
    "CMYK_K": 0.09531043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04762",
    "Farbtonhilfsbezeichnung": "D7.49.54",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "126",
    "Bcolor": "66",
    "Y": 30,
    "L": 62.0354132608831,
    "a": 31.5639753670814,
    "b": 47.0320780609952,
    "C": 56.6418653268876,
    "h": 0.97971980718665,
    "CMY_C": 0.1395711,
    "CMY_M": 0.5057966,
    "CMY_Y": 0.7424474,
    "CMYK_C": 0,
    "CMYK_M": 0.4256313,
    "CMYK_Y": 0.7006695,
    "CMYK_K": 0.1395711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04763",
    "Farbtonhilfsbezeichnung": "D9.10.54",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "143",
    "Bcolor": "128",
    "Y": 29,
    "L": 60.8317070320075,
    "a": 6.07009608166359,
    "b": 10.3998431197081,
    "C": 12.0417109812172,
    "h": 1.04246931427799,
    "CMY_C": 0.354364,
    "CMY_M": 0.4405321,
    "CMY_Y": 0.4991752,
    "CMYK_C": 0,
    "CMYK_M": 0.1334624,
    "CMYK_Y": 0.2242923,
    "CMYK_K": 0.354364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04764",
    "Farbtonhilfsbezeichnung": "D7.14.49",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "132",
    "Bcolor": "114",
    "Y": 25,
    "L": 57.0454198804771,
    "a": 8.10272139266244,
    "b": 12.6401055723103,
    "C": 15.0142053684589,
    "h": 1.00075083815699,
    "CMY_C": 0.3763692,
    "CMY_M": 0.4842628,
    "CMY_Y": 0.5514199,
    "CMYK_C": 0,
    "CMYK_M": 0.1730088,
    "CMYK_Y": 0.280696,
    "CMYK_K": 0.3763692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04765",
    "Farbtonhilfsbezeichnung": "D9.18.54",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "142",
    "Bcolor": "120",
    "Y": 30,
    "L": 61.5626028076001,
    "a": 10.1649241289138,
    "b": 16.2471161472311,
    "C": 19.1649280105142,
    "h": 1.01173345187879,
    "CMY_C": 0.3078818,
    "CMY_M": 0.4442601,
    "CMY_Y": 0.5313395,
    "CMYK_C": 0,
    "CMYK_M": 0.1970448,
    "CMYK_Y": 0.3228606,
    "CMYK_K": 0.3078818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04766",
    "Farbtonhilfsbezeichnung": "D8.24.49",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "127",
    "Bcolor": "99",
    "Y": 25,
    "L": 56.8780417401666,
    "a": 13.9807016787793,
    "b": 21.197725754843,
    "C": 25.3929832160098,
    "h": 0.98774533533644,
    "CMY_C": 0.3267713,
    "CMY_M": 0.5023437,
    "CMY_Y": 0.6100826,
    "CMYK_C": 0,
    "CMYK_M": 0.2607916,
    "CMYK_Y": 0.4208248,
    "CMYK_K": 0.3267713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04767",
    "Farbtonhilfsbezeichnung": "D8.35.51",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "124",
    "Bcolor": "83",
    "Y": 26,
    "L": 57.8560210498641,
    "a": 20.5845414820084,
    "b": 32.0405132220041,
    "C": 38.0830386859288,
    "h": 0.99974447370591,
    "CMY_C": 0.2631028,
    "CMY_M": 0.5123522,
    "CMY_Y": 0.6745167,
    "CMYK_C": 0,
    "CMYK_M": 0.3382417,
    "CMYK_Y": 0.5583056,
    "CMYK_K": 0.2631028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04768",
    "Farbtonhilfsbezeichnung": "D9.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "118",
    "Bcolor": "62",
    "Y": 26,
    "L": 57.7635433450696,
    "a": 28.1119537597757,
    "b": 43.3758176836181,
    "C": 51.6889108408587,
    "h": 0.99575654126887,
    "CMY_C": 0.211804,
    "CMY_M": 0.5374717,
    "CMY_Y": 0.756033,
    "CMYK_C": 0,
    "CMYK_M": 0.413181,
    "CMYK_Y": 0.6904742,
    "CMYK_K": 0.211804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04770",
    "Farbtonhilfsbezeichnung": "D9.60.48",
    "Farbtonklasse": "04",
    "Rcolor": "201",
    "Gcolor": "111",
    "Bcolor": "47",
    "Y": 24,
    "L": 56.0940295497078,
    "a": 31.4002437437529,
    "b": 49.2518025659984,
    "C": 58.4098909703415,
    "h": 1.00322665891361,
    "CMY_C": 0.2098785,
    "CMY_M": 0.5656258,
    "CMY_Y": 0.8176258,
    "CMYK_C": 0,
    "CMYK_M": 0.4502438,
    "CMYK_Y": 0.7691821,
    "CMYK_K": 0.2098785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04771",
    "Farbtonhilfsbezeichnung": "D8.04.49",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "131",
    "Bcolor": "125",
    "Y": 23,
    "L": 55.5491928997378,
    "a": 2.61731986122349,
    "b": 4.31323419903911,
    "C": 5.04523066982229,
    "h": 1.02538346069125,
    "CMY_C": 0.4474611,
    "CMY_M": 0.4847312,
    "CMY_Y": 0.5109566,
    "CMYK_C": 0,
    "CMYK_M": 0.06745239,
    "CMYK_Y": 0.1149159,
    "CMYK_K": 0.4474611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04772",
    "Farbtonhilfsbezeichnung": "D8.12.46",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "123",
    "Bcolor": "110",
    "Y": 21,
    "L": 53.0980222338571,
    "a": 6.09768518459969,
    "b": 9.7227778530961,
    "C": 11.4766795629721,
    "h": 1.010649112003,
    "CMY_C": 0.436497,
    "CMY_M": 0.5183986,
    "CMY_Y": 0.5705703,
    "CMYK_C": 0,
    "CMYK_M": 0.1453437,
    "CMYK_Y": 0.2379283,
    "CMYK_K": 0.436497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04773",
    "Farbtonhilfsbezeichnung": "D7.19.44",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "117",
    "Bcolor": "97",
    "Y": 20,
    "L": 51.9797216581341,
    "a": 10.0692886321148,
    "b": 15.3560753285982,
    "C": 18.362996026096,
    "h": 0.99041038776324,
    "CMY_C": 0.41238,
    "CMY_M": 0.5401096,
    "CMY_Y": 0.6181571,
    "CMYK_C": 0,
    "CMYK_M": 0.2173678,
    "CMYK_Y": 0.3501874,
    "CMYK_K": 0.41238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04774",
    "Farbtonhilfsbezeichnung": "D9.42.49",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "117",
    "Bcolor": "68",
    "Y": 24,
    "L": 55.5871015485087,
    "a": 23.0676845172265,
    "b": 37.39476677867,
    "C": 43.9373036430026,
    "h": 1.01806516595316,
    "CMY_C": 0.269535,
    "CMY_M": 0.543051,
    "CMY_Y": 0.7334909,
    "CMYK_C": 0,
    "CMYK_M": 0.3744409,
    "CMYK_Y": 0.6351514,
    "CMYK_K": 0.269535
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04775",
    "Farbtonhilfsbezeichnung": "D9.54.44",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "103",
    "Bcolor": "52",
    "Y": 20,
    "L": 51.652030937576,
    "a": 27.1323105455902,
    "b": 41.1515138796964,
    "C": 49.2910678534478,
    "h": 0.98789215077578,
    "CMY_C": 0.2901059,
    "CMY_M": 0.5948898,
    "CMY_Y": 0.7965034,
    "CMYK_C": 0,
    "CMYK_M": 0.4293371,
    "CMYK_Y": 0.7133423,
    "CMYK_K": 0.2901059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04776",
    "Farbtonhilfsbezeichnung": "D9.65.45",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "102",
    "Bcolor": "40",
    "Y": 21,
    "L": 52.4386199758653,
    "a": 31.0900419230806,
    "b": 47.9155901420687,
    "C": 57.1182500208263,
    "h": 0.99522980155806,
    "CMY_C": 0.255805,
    "CMY_M": 0.6008353,
    "CMY_Y": 0.8417513,
    "CMYK_C": 0,
    "CMYK_M": 0.4636289,
    "CMYK_Y": 0.7873559,
    "CMYK_K": 0.255805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04777",
    "Farbtonhilfsbezeichnung": "D8.04.39",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "111",
    "Bcolor": "106",
    "Y": 16,
    "L": 47.2003878576009,
    "a": 2.02076152879832,
    "b": 3.32431303565346,
    "C": 3.89031288141286,
    "h": 1.02460765213503,
    "CMY_C": 0.5379516,
    "CMY_M": 0.5659173,
    "CMY_Y": 0.5860022,
    "CMYK_C": 0,
    "CMYK_M": 0.06052555,
    "CMYK_Y": 0.1039947,
    "CMYK_K": 0.5379516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04778",
    "Farbtonhilfsbezeichnung": "D9.10.41",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "114",
    "Bcolor": "102",
    "Y": 18,
    "L": 49.1873816956515,
    "a": 5.2176053892134,
    "b": 8.20767018954727,
    "C": 9.72570079418093,
    "h": 1.00454051966915,
    "CMY_C": 0.4854434,
    "CMY_M": 0.5546586,
    "CMY_Y": 0.5983492,
    "CMYK_C": 0,
    "CMYK_M": 0.1345144,
    "CMYK_Y": 0.2194235,
    "CMYK_K": 0.4854434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04779",
    "Farbtonhilfsbezeichnung": "D9.32.37",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "98",
    "Bcolor": "68",
    "Y": 15,
    "L": 45.6992029803943,
    "a": 14.9062312035386,
    "b": 24.1431688255863,
    "C": 28.3740784807914,
    "h": 1.01767369620429,
    "CMY_C": 0.4379838,
    "CMY_M": 0.6150987,
    "CMY_Y": 0.7340291,
    "CMYK_C": 0,
    "CMYK_M": 0.315142,
    "CMYK_Y": 0.5267559,
    "CMYK_K": 0.4379838
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04780",
    "Farbtonhilfsbezeichnung": "D8.37.42",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "103",
    "Bcolor": "65",
    "Y": 18,
    "L": 49.0596813717828,
    "a": 19.4165771746321,
    "b": 30.151291808992,
    "C": 35.8622903190724,
    "h": 0.9986706414718,
    "CMY_C": 0.3701401,
    "CMY_M": 0.5957586,
    "CMY_Y": 0.7432323,
    "CMYK_C": 0,
    "CMYK_M": 0.3582043,
    "CMYK_Y": 0.5923414,
    "CMYK_K": 0.3701401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04781",
    "Farbtonhilfsbezeichnung": "D7.44.39",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "98",
    "Bcolor": "58",
    "Y": 17,
    "L": 47.9970432005236,
    "a": 22.6834286945265,
    "b": 32.9036496760149,
    "C": 39.9648357852448,
    "h": 0.96722709566629,
    "CMY_C": 0.361957,
    "CMY_M": 0.6158767,
    "CMY_Y": 0.7711521,
    "CMYK_C": 0,
    "CMYK_M": 0.3979664,
    "CMYK_Y": 0.6413285,
    "CMYK_K": 0.361957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04782",
    "Farbtonhilfsbezeichnung": "D9.47.44",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "108",
    "Bcolor": "62",
    "Y": 20,
    "L": 51.9837973237055,
    "a": 22.6024610759733,
    "b": 36.1306112419784,
    "C": 42.6179811278041,
    "h": 1.01178256198918,
    "CMY_C": 0.3143508,
    "CMY_M": 0.5771739,
    "CMY_Y": 0.7578328,
    "CMYK_C": 0,
    "CMYK_M": 0.3833202,
    "CMYK_Y": 0.6468059,
    "CMYK_K": 0.3143508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04783",
    "Farbtonhilfsbezeichnung": "D9.59.42",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "101",
    "Bcolor": "46",
    "Y": 20,
    "L": 51.2863244321946,
    "a": 28.6459139891248,
    "b": 43.7122452214605,
    "C": 52.2623073598309,
    "h": 0.99068380952157,
    "CMY_C": 0.2846546,
    "CMY_M": 0.6036499,
    "CMY_Y": 0.8191927,
    "CMYK_C": 0,
    "CMYK_M": 0.4459318,
    "CMYK_Y": 0.7472447,
    "CMYK_K": 0.2846546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04784",
    "Farbtonhilfsbezeichnung": "D9.06.33",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "97",
    "Bcolor": "92",
    "Y": 12,
    "L": 41.630683849605,
    "a": 2.51600520005926,
    "b": 3.46080700173022,
    "C": 4.27872262129133,
    "h": 0.94217872360403,
    "CMY_C": 0.5888253,
    "CMY_M": 0.6207049,
    "CMY_Y": 0.6397223,
    "CMYK_C": 0,
    "CMYK_M": 0.07753273,
    "CMYK_Y": 0.1237841,
    "CMYK_K": 0.5888253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04785",
    "Farbtonhilfsbezeichnung": "D9.23.38",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "107",
    "Bcolor": "86",
    "Y": 17,
    "L": 47.8456103483301,
    "a": 10.4854529893568,
    "b": 16.3916012952345,
    "C": 19.458399662201,
    "h": 1.0017070026458,
    "CMY_C": 0.4514232,
    "CMY_M": 0.5818261,
    "CMY_Y": 0.6638677,
    "CMYK_C": 0,
    "CMYK_M": 0.2377113,
    "CMYK_Y": 0.3872648,
    "CMYK_K": 0.4514232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04786",
    "Farbtonhilfsbezeichnung": "D8.26.33",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "89",
    "Bcolor": "68",
    "Y": 12,
    "L": 40.8775889789659,
    "a": 11.3390765603619,
    "b": 17.3701153976251,
    "C": 20.7435668622482,
    "h": 0.99246069877264,
    "CMY_C": 0.5172186,
    "CMY_M": 0.6507925,
    "CMY_Y": 0.7338611,
    "CMYK_C": 0,
    "CMYK_M": 0.2766757,
    "CMYK_Y": 0.4487382,
    "CMYK_K": 0.5172186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04787",
    "Farbtonhilfsbezeichnung": "D9.32.33",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "94",
    "Bcolor": "69",
    "Y": 14,
    "L": 43.5279448585639,
    "a": 13.1770990204388,
    "b": 20.5803116497026,
    "C": 24.4373723258728,
    "h": 1.00128669148369,
    "CMY_C": 0.4750805,
    "CMY_M": 0.630821,
    "CMY_Y": 0.7304657,
    "CMYK_C": 0,
    "CMYK_M": 0.296694,
    "CMYK_Y": 0.4865224,
    "CMYK_K": 0.4750805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04788",
    "Farbtonhilfsbezeichnung": "D8.43.34",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "87",
    "Bcolor": "53",
    "Y": 13,
    "L": 42.4098192321393,
    "a": 19.3735196356296,
    "b": 28.8246828259547,
    "C": 34.7303268497291,
    "h": 0.97903085039948,
    "CMY_C": 0.4446863,
    "CMY_M": 0.6592996,
    "CMY_Y": 0.7939091,
    "CMYK_C": 0,
    "CMYK_M": 0.3864722,
    "CMYK_Y": 0.6288748,
    "CMYK_K": 0.4446863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04789",
    "Farbtonhilfsbezeichnung": "D9.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "96",
    "Bcolor": "51",
    "Y": 17,
    "L": 47.6944711716683,
    "a": 23.5007079950518,
    "b": 36.8064886675587,
    "C": 43.6692212468212,
    "h": 1.00255252820114,
    "CMY_C": 0.3576424,
    "CMY_M": 0.6217963,
    "CMY_Y": 0.8016525,
    "CMYK_C": 0,
    "CMYK_M": 0.4112257,
    "CMYK_Y": 0.6912195,
    "CMYK_K": 0.3576424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04790",
    "Farbtonhilfsbezeichnung": "D9.60.40",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "92",
    "Bcolor": "41",
    "Y": 17,
    "L": 47.8417915637316,
    "a": 28.7082667102589,
    "b": 42.1496775107692,
    "C": 50.9976459434081,
    "h": 0.97286589839121,
    "CMY_C": 0.3254692,
    "CMY_M": 0.6373709,
    "CMY_Y": 0.8388059,
    "CMYK_C": 0,
    "CMYK_M": 0.462398,
    "CMYK_Y": 0.7610278,
    "CMYK_K": 0.3254692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04792",
    "Farbtonhilfsbezeichnung": "D8.13.29",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "86",
    "Bcolor": "76",
    "Y": 10,
    "L": 37.8840164016928,
    "a": 5.14018786839837,
    "b": 7.67778765011515,
    "C": 9.23958627443299,
    "h": 0.98084292981836,
    "CMY_C": 0.5992702,
    "CMY_M": 0.6626298,
    "CMY_Y": 0.7005472,
    "CMYK_C": 0,
    "CMYK_M": 0.1581106,
    "CMYK_Y": 0.2527313,
    "CMYK_K": 0.5992702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04793",
    "Farbtonhilfsbezeichnung": "D8.18.25",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "76",
    "Bcolor": "64",
    "Y": 8,
    "L": 34.1866314120667,
    "a": 6.821274323566,
    "b": 10.0330618768801,
    "C": 12.1322757149121,
    "h": 0.97370198819037,
    "CMY_C": 0.6209182,
    "CMY_M": 0.7010218,
    "CMY_Y": 0.748112,
    "CMYK_C": 0,
    "CMYK_M": 0.2113094,
    "CMYK_Y": 0.3355313,
    "CMYK_K": 0.6209182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04794",
    "Farbtonhilfsbezeichnung": "D8.39.31",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "82",
    "Bcolor": "52",
    "Y": 11,
    "L": 39.4234510806076,
    "a": 16.1898164275256,
    "b": 24.969379579988,
    "C": 29.7586974272481,
    "h": 0.9955559934844,
    "CMY_C": 0.4970557,
    "CMY_M": 0.6780987,
    "CMY_Y": 0.795178,
    "CMYK_C": 0,
    "CMYK_M": 0.3599664,
    "CMYK_Y": 0.5927541,
    "CMYK_K": 0.4970557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04795",
    "Farbtonhilfsbezeichnung": "D8.49.38",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "91",
    "Bcolor": "49",
    "Y": 15,
    "L": 45.3646301580672,
    "a": 22.9807932666316,
    "b": 34.5035723172806,
    "C": 41.456161928204,
    "h": 0.98322701308834,
    "CMY_C": 0.3884556,
    "CMY_M": 0.6423917,
    "CMY_Y": 0.8061491,
    "CMYK_C": 0,
    "CMYK_M": 0.4152373,
    "CMYK_Y": 0.6830143,
    "CMYK_K": 0.3884556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04796",
    "Farbtonhilfsbezeichnung": "D9.57.39",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "96",
    "Bcolor": "50",
    "Y": 17,
    "L": 48.1810387581189,
    "a": 26.0858570796546,
    "b": 37.8196217848532,
    "C": 45.943397039504,
    "h": 0.9669868015871,
    "CMY_C": 0.3380449,
    "CMY_M": 0.6251185,
    "CMY_Y": 0.8037323,
    "CMYK_C": 0,
    "CMYK_M": 0.4336753,
    "CMYK_Y": 0.7035031,
    "CMYK_K": 0.3380449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04797",
    "Farbtonhilfsbezeichnung": "D9.06.24",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "77",
    "Bcolor": "73",
    "Y": 8,
    "L": 33.3952597530507,
    "a": 2.20487176066422,
    "b": 3.40015320994203,
    "C": 4.05246854794132,
    "h": 0.99550272792892,
    "CMY_C": 0.6691998,
    "CMY_M": 0.6970381,
    "CMY_Y": 0.7151681,
    "CMYK_C": 0,
    "CMYK_M": 0.08415454,
    "CMYK_Y": 0.138961,
    "CMYK_K": 0.6691998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04798",
    "Farbtonhilfsbezeichnung": "D9.11.20",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "67",
    "Bcolor": "60",
    "Y": 6,
    "L": 29.3078216090315,
    "a": 3.35173039084827,
    "b": 5.50936614159742,
    "C": 6.44881476669286,
    "h": 1.02424549026037,
    "CMY_C": 0.6955391,
    "CMY_M": 0.7368696,
    "CMY_Y": 0.7640696,
    "CMYK_C": 0,
    "CMYK_M": 0.1357499,
    "CMYK_Y": 0.2250881,
    "CMYK_K": 0.6955391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04799",
    "Farbtonhilfsbezeichnung": "D9.12.17",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "65",
    "Bcolor": "59",
    "Y": 6,
    "L": 28.346391767135,
    "a": 3.38668808085871,
    "b": 4.98829336540553,
    "C": 6.02932225514437,
    "h": 0.97435361872047,
    "CMY_C": 0.7052875,
    "CMY_M": 0.745418,
    "CMY_Y": 0.7693471,
    "CMYK_C": 0,
    "CMYK_M": 0.1361683,
    "CMYK_Y": 0.2173631,
    "CMYK_K": 0.7052875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04800",
    "Farbtonhilfsbezeichnung": "D9.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "66",
    "Bcolor": "55",
    "Y": 6,
    "L": 29.7968374950061,
    "a": 6.25459908959866,
    "b": 9.93960333185706,
    "C": 11.7437525589682,
    "h": 1.00913919444979,
    "CMY_C": 0.6663329,
    "CMY_M": 0.7395075,
    "CMY_Y": 0.786014,
    "CMYK_C": 0,
    "CMYK_M": 0.2193043,
    "CMYK_Y": 0.358684,
    "CMYK_K": 0.6663329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04801",
    "Farbtonhilfsbezeichnung": "D9.36.26",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "76",
    "Bcolor": "55",
    "Y": 9,
    "L": 35.7566541298575,
    "a": 12.3934972489897,
    "b": 18.2573403437417,
    "C": 22.0664734492835,
    "h": 0.97442514915095,
    "CMY_C": 0.5627289,
    "CMY_M": 0.7012393,
    "CMY_Y": 0.7846422,
    "CMYK_C": 0,
    "CMYK_M": 0.316761,
    "CMYK_Y": 0.5074959,
    "CMYK_K": 0.5627289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04802",
    "Farbtonhilfsbezeichnung": "D8.40.27",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "74",
    "Bcolor": "48",
    "Y": 9,
    "L": 36.0774328018064,
    "a": 16.007851985956,
    "b": 22.8763857654038,
    "C": 27.9209661525501,
    "h": 0.96023520218038,
    "CMY_C": 0.5354344,
    "CMY_M": 0.7083359,
    "CMY_Y": 0.8106259,
    "CMYK_C": 0,
    "CMYK_M": 0.3721791,
    "CMYK_Y": 0.5923631,
    "CMYK_K": 0.5354344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04803",
    "Farbtonhilfsbezeichnung": "D8.53.34",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "85",
    "Bcolor": "49",
    "Y": 13,
    "L": 43.007217641161,
    "a": 23.088711199888,
    "b": 31.9530243076344,
    "C": 39.4218765062765,
    "h": 0.94507424351486,
    "CMY_C": 0.4163617,
    "CMY_M": 0.6648878,
    "CMY_Y": 0.8090704,
    "CMYK_C": 0,
    "CMYK_M": 0.4258222,
    "CMYK_Y": 0.6728631,
    "CMYK_K": 0.4163617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04804",
    "Farbtonhilfsbezeichnung": "F2.15.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "219",
    "Bcolor": "179",
    "Y": 73,
    "L": 88.4302628085745,
    "a": 3.43308331046732,
    "b": 21.869416793484,
    "C": 22.1372412893687,
    "h": 1.41508606836887,
    "CMY_C": 0.04198893,
    "CMY_M": 0.1430516,
    "CMY_Y": 0.2973835,
    "CMYK_C": 0,
    "CMYK_M": 0.1054922,
    "CMYK_Y": 0.2665883,
    "CMYK_K": 0.04198893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04805",
    "Farbtonhilfsbezeichnung": "E0.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "224",
    "Bcolor": "205",
    "Y": 78,
    "L": 90.6609949810537,
    "a": 6.4908265136247,
    "b": 11.5820050304265,
    "C": 13.2768094568989,
    "h": 1.05998575088634,
    "CMY_C": 0.02054989,
    "CMY_M": 0.1234348,
    "CMY_Y": 0.196585,
    "CMYK_C": 0,
    "CMYK_M": 0.1050436,
    "CMYK_Y": 0.1797285,
    "CMYK_K": 0.02054989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04806",
    "Farbtonhilfsbezeichnung": "E0.14.80",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "210",
    "Bcolor": "183",
    "Y": 69,
    "L": 86.7503259570589,
    "a": 9.80212816655651,
    "b": 17.4453703134412,
    "C": 20.0105637593421,
    "h": 1.05888130360931,
    "CMY_C": 0.0271057,
    "CMY_M": 0.1764671,
    "CMY_Y": 0.2813691,
    "CMYK_C": 0,
    "CMYK_M": 0.1535227,
    "CMYK_Y": 0.2613474,
    "CMYK_K": 0.0271057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04807",
    "Farbtonhilfsbezeichnung": "E0.26.76",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "194",
    "Bcolor": "147",
    "Y": 63,
    "L": 83.3059307173697,
    "a": 17.9020217723502,
    "b": 32.0102934765886,
    "C": 36.676167629607,
    "h": 1.06087282780156,
    "CMY_C": 0,
    "CMY_M": 0.2388341,
    "CMY_Y": 0.4233842,
    "CMYK_C": 0,
    "CMYK_M": 0.2388341,
    "CMYK_Y": 0.4233842,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04810",
    "Farbtonhilfsbezeichnung": "E0.52.65",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "150",
    "Bcolor": "73",
    "Y": 43,
    "L": 71.5175175644164,
    "a": 32.7823413562009,
    "b": 54.8128777683268,
    "C": 63.868094335435,
    "h": 1.031791729919,
    "CMY_C": 0.01119222,
    "CMY_M": 0.4127594,
    "CMY_Y": 0.7123805,
    "CMYK_C": 0,
    "CMYK_M": 0.4061124,
    "CMYK_Y": 0.709125,
    "CMYK_K": 0.01119222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04811",
    "Farbtonhilfsbezeichnung": "E0.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "216",
    "Bcolor": "204",
    "Y": 70,
    "L": 87.1914691958562,
    "a": 4.06150618576895,
    "b": 6.84994641321466,
    "C": 7.96351670814796,
    "h": 1.035595089082,
    "CMY_C": 0.09079278,
    "CMY_M": 0.1545487,
    "CMY_Y": 0.1997059,
    "CMYK_C": 0,
    "CMYK_M": 0.07012253,
    "CMYK_Y": 0.1197891,
    "CMYK_K": 0.09079278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04812",
    "Farbtonhilfsbezeichnung": "E0.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "226",
    "Bcolor": "215",
    "Y": 77,
    "L": 90.4924269595915,
    "a": 2.9350589733429,
    "b": 5.68134025505795,
    "C": 6.39470079602968,
    "h": 1.0939461606163,
    "CMY_C": 0.0656954,
    "CMY_M": 0.1149519,
    "CMY_Y": 0.1552937,
    "CMYK_C": 0,
    "CMYK_M": 0.05271993,
    "CMYK_Y": 0.09589837,
    "CMYK_K": 0.0656954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04813",
    "Farbtonhilfsbezeichnung": "E0.18.79",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "204",
    "Bcolor": "170",
    "Y": 67,
    "L": 85.5934937395658,
    "a": 13.0857280839442,
    "b": 22.8404733710496,
    "C": 26.3234401874176,
    "h": 1.05052781119418,
    "CMY_C": 0.006364374,
    "CMY_M": 0.1989541,
    "CMY_Y": 0.3327512,
    "CMYK_C": 0,
    "CMYK_M": 0.1938232,
    "CMYK_Y": 0.3284774,
    "CMYK_K": 0.006364374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04814",
    "Farbtonhilfsbezeichnung": "E1.29.74",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "186",
    "Bcolor": "135",
    "Y": 58,
    "L": 81.0051741035598,
    "a": 19.5596897195897,
    "b": 35.2746455789792,
    "C": 40.3346263482038,
    "h": 1.06450698303501,
    "CMY_C": 0,
    "CMY_M": 0.2689455,
    "CMY_Y": 0.4708493,
    "CMYK_C": 0,
    "CMYK_M": 0.2689455,
    "CMYK_Y": 0.4708493,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04815",
    "Farbtonhilfsbezeichnung": "E0.56.63",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "144",
    "Bcolor": "65",
    "Y": 40,
    "L": 69.6952051922732,
    "a": 33.6544623210216,
    "b": 56.511106225963,
    "C": 65.7733073594383,
    "h": 1.03366480651466,
    "CMY_C": 0.02751727,
    "CMY_M": 0.4349073,
    "CMY_Y": 0.7445334,
    "CMYK_C": 0,
    "CMYK_M": 0.4189175,
    "CMYK_Y": 0.7373047,
    "CMYK_K": 0.02751727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04816",
    "Farbtonhilfsbezeichnung": "EN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "224",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.5861623320892,
    "a": 1.74020394643459,
    "b": 3.91253728462659,
    "C": 4.28208568092463,
    "h": 1.15229489578545,
    "CMY_C": 0.09046219,
    "CMY_M": 0.1216439,
    "CMY_Y": 0.1523276,
    "CMYK_C": 0,
    "CMYK_M": 0.03428299,
    "CMYK_Y": 0.06801852,
    "CMYK_K": 0.09046219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04817",
    "Farbtonhilfsbezeichnung": "E0.14.76",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "201",
    "Bcolor": "174",
    "Y": 64,
    "L": 83.7219319015439,
    "a": 10.3655422994825,
    "b": 17.8589903174142,
    "C": 20.6491646881867,
    "h": 1.04490555349117,
    "CMY_C": 0.05690407,
    "CMY_M": 0.211116,
    "CMY_Y": 0.3163967,
    "CMYK_C": 0,
    "CMYK_M": 0.1635167,
    "CMYK_Y": 0.2751497,
    "CMYK_K": 0.05690407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04818",
    "Farbtonhilfsbezeichnung": "E1.26.72",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "184",
    "Bcolor": "138",
    "Y": 55,
    "L": 79.0900594691751,
    "a": 16.1852319366206,
    "b": 30.8532950849838,
    "C": 34.8408890593121,
    "h": 1.08767328474515,
    "CMY_C": 0.04694636,
    "CMY_M": 0.2793517,
    "CMY_Y": 0.4584222,
    "CMYK_C": 0,
    "CMYK_M": 0.2438534,
    "CMYK_Y": 0.4317447,
    "CMYK_K": 0.04694636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04819",
    "Farbtonhilfsbezeichnung": "E0.45.64",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "154",
    "Bcolor": "87",
    "Y": 43,
    "L": 71.6240510078979,
    "a": 27.7961547635168,
    "b": 48.1571967513911,
    "C": 55.6034335143935,
    "h": 1.04731305167156,
    "CMY_C": 0.04380728,
    "CMY_M": 0.3948975,
    "CMY_Y": 0.6597146,
    "CMYK_C": 0,
    "CMYK_M": 0.3671752,
    "CMYK_Y": 0.6441246,
    "CMYK_K": 0.04380728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04820",
    "Farbtonhilfsbezeichnung": "E1.62.62",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "137",
    "Bcolor": "41",
    "Y": 37,
    "L": 67.5899114533982,
    "a": 35.4884994209719,
    "b": 64.3745099954973,
    "C": 73.5085786035392,
    "h": 1.06696949726734,
    "CMY_C": 0.03842299,
    "CMY_M": 0.4638947,
    "CMY_Y": 0.8409056,
    "CMYK_C": 0,
    "CMYK_M": 0.4424728,
    "CMYK_Y": 0.8345485,
    "CMYK_K": 0.03842299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04821",
    "Farbtonhilfsbezeichnung": "EN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "207",
    "Bcolor": "200",
    "Y": 63,
    "L": 83.2669940553986,
    "a": 1.12357769240917,
    "b": 3.1314096971258,
    "C": 3.32688345484674,
    "h": 1.22629558363345,
    "CMY_C": 0.1676766,
    "CMY_M": 0.1895795,
    "CMY_Y": 0.2154419,
    "CMYK_C": 0,
    "CMYK_M": 0.02631545,
    "CMYK_Y": 0.05738791,
    "CMYK_K": 0.1676766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04822",
    "Farbtonhilfsbezeichnung": "E0.04.75",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "202",
    "Bcolor": "194",
    "Y": 60,
    "L": 82.105464166186,
    "a": 2.70659134088058,
    "b": 4.6369059349457,
    "C": 5.36903467450755,
    "h": 1.04244362631447,
    "CMY_C": 0.1638855,
    "CMY_M": 0.2064116,
    "CMY_Y": 0.2386497,
    "CMYK_C": 0,
    "CMYK_M": 0.0508616,
    "CMYK_Y": 0.08941856,
    "CMYK_K": 0.1638855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04823",
    "Farbtonhilfsbezeichnung": "E0.09.77",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "206",
    "Bcolor": "188",
    "Y": 65,
    "L": 84.5229453145479,
    "a": 6.50735504971911,
    "b": 11.6108814500866,
    "C": 13.3100803074613,
    "h": 1.05996310567352,
    "CMY_C": 0.08981193,
    "CMY_M": 0.1911002,
    "CMY_Y": 0.2628985,
    "CMYK_C": 0,
    "CMYK_M": 0.1112828,
    "CMYK_Y": 0.1901657,
    "CMYK_K": 0.08981193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04824",
    "Farbtonhilfsbezeichnung": "E1.24.66",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "168",
    "Bcolor": "131",
    "Y": 45,
    "L": 72.92158251318,
    "a": 14.5994336013003,
    "b": 25.8461265814376,
    "C": 29.6844356648812,
    "h": 1.05661619226488,
    "CMY_C": 0.1364075,
    "CMY_M": 0.3397014,
    "CMY_Y": 0.4848377,
    "CMYK_C": 0,
    "CMYK_M": 0.2354049,
    "CMYK_Y": 0.4034659,
    "CMYK_K": 0.1364075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04825",
    "Farbtonhilfsbezeichnung": "E0.34.65",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "163",
    "Bcolor": "112",
    "Y": 44,
    "L": 72.5852432250977,
    "a": 20.9688339233398,
    "b": 36.102481842041,
    "C": 41.7502250671387,
    "h": 59.8513717651367,
    "CMY_C": 0.08586472272873,
    "CMY_M": 0.36260783672333,
    "CMY_Y": 0.56122362613678,
    "CMYK_C": 0,
    "CMYK_M": 0.30273759365082,
    "CMYK_Y": 0.52000933885574,
    "CMYK_K": 0.08586472272873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04826",
    "Farbtonhilfsbezeichnung": "E0.51.60",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "141",
    "Bcolor": "73",
    "Y": 38,
    "L": 67.8997839284673,
    "a": 31.4922449985058,
    "b": 50.3226392041471,
    "C": 59.3643791470666,
    "h": 1.01161711970296,
    "CMY_C": 0.06635462,
    "CMY_M": 0.4456753,
    "CMY_Y": 0.7118843,
    "CMYK_C": 0,
    "CMYK_M": 0.4062792,
    "CMYK_Y": 0.6914078,
    "CMYK_K": 0.06635462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04827",
    "Farbtonhilfsbezeichnung": "D9.69.60",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "129",
    "Bcolor": "27",
    "Y": 36,
    "L": 66.6531969372447,
    "a": 40.752534837888,
    "b": 68.1573379211628,
    "C": 79.4115344783921,
    "h": 1.03190872968818,
    "CMY_C": 0.02023987,
    "CMY_M": 0.492687,
    "CMY_Y": 0.8944435,
    "CMYK_C": 0,
    "CMYK_M": 0.4822069,
    "CMYK_Y": 0.8922629,
    "CMYK_K": 0.02023987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04828",
    "Farbtonhilfsbezeichnung": "EN.02.69",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "187",
    "Bcolor": "182",
    "Y": 50,
    "L": 75.9840828040683,
    "a": 1.09836117053957,
    "b": 2.06584834769703,
    "C": 2.3396851618608,
    "h": 1.08213050758565,
    "CMY_C": 0.2504843,
    "CMY_M": 0.2681108,
    "CMY_Y": 0.2857504,
    "CMYK_C": 0,
    "CMYK_M": 0.02351724,
    "CMYK_Y": 0.04705191,
    "CMYK_K": 0.2504843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04829",
    "Farbtonhilfsbezeichnung": "E0.09.73",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "196",
    "Bcolor": "178",
    "Y": 58,
    "L": 80.7385842241855,
    "a": 6.55856656766718,
    "b": 11.1890123690186,
    "C": 12.9695332690338,
    "h": 1.04061445445634,
    "CMY_C": 0.1328957,
    "CMY_M": 0.2322933,
    "CMY_Y": 0.3000594,
    "CMYK_C": 0,
    "CMYK_M": 0.1146317,
    "CMYK_Y": 0.1927839,
    "CMYK_K": 0.1328957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04830",
    "Farbtonhilfsbezeichnung": "E1.22.69",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "177",
    "Bcolor": "140",
    "Y": 49,
    "L": 75.5610635926072,
    "a": 12.7216534891405,
    "b": 24.6822361379639,
    "C": 27.7678455820392,
    "h": 1.09489102393215,
    "CMY_C": 0.1202924,
    "CMY_M": 0.306575,
    "CMY_Y": 0.4501111,
    "CMYK_C": 0,
    "CMYK_M": 0.2117552,
    "CMYK_Y": 0.3749186,
    "CMYK_K": 0.1202924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04831",
    "Farbtonhilfsbezeichnung": "E0.76.57",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "125",
    "Bcolor": "7",
    "Y": 34,
    "L": 65.2026414166818,
    "a": 40.9187100388828,
    "b": 70.8019236419863,
    "C": 81.7756273143277,
    "h": 1.04676122847952,
    "CMY_C": 0.03648488,
    "CMY_M": 0.5086108,
    "CMY_Y": 0.9709607,
    "CMYK_C": 0,
    "CMYK_M": 0.4900036,
    "CMYK_Y": 0.9698611,
    "CMYK_K": 0.03648488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04832",
    "Farbtonhilfsbezeichnung": "EN.02.66",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "179",
    "Bcolor": "173",
    "Y": 45,
    "L": 73.1580794275489,
    "a": 1.07384360144008,
    "b": 2.98399489270542,
    "C": 3.17133498704345,
    "h": 1.2253578062139,
    "CMY_C": 0.278145,
    "CMY_M": 0.2984971,
    "CMY_Y": 0.3221206,
    "CMYK_C": 0,
    "CMYK_M": 0.02819412,
    "CMYK_Y": 0.06092018,
    "CMYK_K": 0.278145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04833",
    "Farbtonhilfsbezeichnung": "E1.04.64",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "172",
    "Bcolor": "164",
    "Y": 42,
    "L": 70.7536410268041,
    "a": 2.3173084366081,
    "b": 4.11758321007887,
    "C": 4.72487141436658,
    "h": 1.05819143279823,
    "CMY_C": 0.2913519,
    "CMY_M": 0.3271492,
    "CMY_Y": 0.3550967,
    "CMYK_C": 0,
    "CMYK_M": 0.05051493,
    "CMYK_Y": 0.0899527,
    "CMYK_K": 0.2913519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04834",
    "Farbtonhilfsbezeichnung": "E1.11.61",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "163",
    "Bcolor": "146",
    "Y": 39,
    "L": 68.5285457030018,
    "a": 6.32183602069303,
    "b": 11.464513547617,
    "C": 13.0920083087365,
    "h": 1.06685861147277,
    "CMY_C": 0.2678907,
    "CMY_M": 0.3617959,
    "CMY_Y": 0.4289393,
    "CMYK_C": 0,
    "CMYK_M": 0.1282666,
    "CMYK_Y": 0.2199789,
    "CMYK_K": 0.2678907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04836",
    "Farbtonhilfsbezeichnung": "E0.24.56",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "141",
    "Bcolor": "108",
    "Y": 31,
    "L": 62.264162717239,
    "a": 13.6172316798228,
    "b": 23.6927598953397,
    "C": 27.3272001873625,
    "h": 1.04915572538041,
    "CMY_C": 0.2657147,
    "CMY_M": 0.4473698,
    "CMY_Y": 0.5753612,
    "CMYK_C": 0,
    "CMYK_M": 0.2473904,
    "CMYK_Y": 0.4216978,
    "CMYK_K": 0.2657147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04837",
    "Farbtonhilfsbezeichnung": "E0.72.53",
    "Farbtonklasse": "04",
    "Rcolor": "227",
    "Gcolor": "118",
    "Bcolor": "25",
    "Y": 29,
    "L": 61.0553633931531,
    "a": 37.752298636084,
    "b": 63.1199330883659,
    "C": 73.5483650762399,
    "h": 1.0317719449635,
    "CMY_C": 0.1085349,
    "CMY_M": 0.538972,
    "CMY_Y": 0.9023497,
    "CMYK_C": 0,
    "CMYK_M": 0.4828423,
    "CMYK_Y": 0.8904609,
    "CMYK_K": 0.1085349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04838",
    "Farbtonhilfsbezeichnung": "E0.05.47",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "127",
    "Bcolor": "121",
    "Y": 22,
    "L": 53.88692370348,
    "a": 2.47603716576283,
    "b": 4.05848154739457,
    "C": 4.75415949635485,
    "h": 1.02299105347894,
    "CMY_C": 0.4660135,
    "CMY_M": 0.5010284,
    "CMY_Y": 0.5256919,
    "CMYK_C": 0,
    "CMYK_M": 0.06557277,
    "CMYK_Y": 0.1117601,
    "CMYK_K": 0.4660135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04839",
    "Farbtonhilfsbezeichnung": "E0.19.56",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "147",
    "Bcolor": "120",
    "Y": 33,
    "L": 63.9735009908989,
    "a": 11.1695128590049,
    "b": 19.4513689549953,
    "C": 22.4301977639705,
    "h": 1.04954272186667,
    "CMY_C": 0.2692388,
    "CMY_M": 0.4227443,
    "CMY_Y": 0.5295357,
    "CMYK_C": 0,
    "CMYK_M": 0.2100624,
    "CMYK_Y": 0.3561996,
    "CMYK_K": 0.2692388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04840",
    "Farbtonhilfsbezeichnung": "E0.35.44",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "113",
    "Bcolor": "76",
    "Y": 20,
    "L": 52.3688395726012,
    "a": 17.6421122594298,
    "b": 28.4600857818916,
    "C": 33.4846324108082,
    "h": 1.01588032202497,
    "CMY_C": 0.3451369,
    "CMY_M": 0.5581945,
    "CMY_Y": 0.7015675,
    "CMYK_C": 0,
    "CMYK_M": 0.3253467,
    "CMYK_Y": 0.5442826,
    "CMYK_K": 0.3451369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04841",
    "Farbtonhilfsbezeichnung": "E0.54.53",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "125",
    "Bcolor": "60",
    "Y": 29,
    "L": 60.9231943766724,
    "a": 29.5502673596322,
    "b": 48.5123215642315,
    "C": 56.8037291432274,
    "h": 1.0236912705261,
    "CMY_C": 0.1624674,
    "CMY_M": 0.5108078,
    "CMY_Y": 0.7657961,
    "CMYK_C": 0,
    "CMYK_M": 0.4159127,
    "CMYK_Y": 0.7203645,
    "CMYK_K": 0.1624674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04842",
    "Farbtonhilfsbezeichnung": "E1.69.51",
    "Farbtonklasse": "04",
    "Rcolor": "211",
    "Gcolor": "113",
    "Bcolor": "28",
    "Y": 26,
    "L": 57.7630961491247,
    "a": 33.7789493580373,
    "b": 58.5371900724955,
    "C": 67.5841700497706,
    "h": 1.04742196438619,
    "CMY_C": 0.1718746,
    "CMY_M": 0.557927,
    "CMY_Y": 0.8892114,
    "CMYK_C": 0,
    "CMYK_M": 0.4661762,
    "CMYK_Y": 0.8662176,
    "CMYK_K": 0.1718746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04843",
    "Farbtonhilfsbezeichnung": "EN.00.41",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "113",
    "Bcolor": "112",
    "Y": 17,
    "L": 47.6651920361358,
    "a": 0.24686251052114,
    "b": -0.11004438783657,
    "C": 0.27027923781734,
    "h": -0.41933233617433,
    "CMY_C": 0.5551969,
    "CMY_M": 0.5567723,
    "CMY_Y": 0.5594234,
    "CMYK_C": 0,
    "CMYK_M": 0.003541664,
    "CMYK_Y": 0.009501842,
    "CMYK_K": 0.5551969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04844",
    "Farbtonhilfsbezeichnung": "E0.10.49",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "134",
    "Bcolor": "122",
    "Y": 25,
    "L": 57.2983356893113,
    "a": 5.40988893862454,
    "b": 8.69959372428841,
    "C": 10.2445023937686,
    "h": 1.01446152625716,
    "CMY_C": 0.3997403,
    "CMY_M": 0.4744824,
    "CMY_Y": 0.5227506,
    "CMYK_C": 0,
    "CMYK_M": 0.1245164,
    "CMYK_Y": 0.2049284,
    "CMYK_K": 0.3997403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04845",
    "Farbtonhilfsbezeichnung": "E1.15.56",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "148",
    "Bcolor": "127",
    "Y": 31.8126049041748,
    "L": 63.1876983642578,
    "a": 7.87104034423828,
    "b": 14.3400535583496,
    "C": 16.358190536499,
    "h": 61.2382736206055,
    "CMY_C": 0.30878227949142,
    "CMY_M": 0.42154914140701,
    "CMY_Y": 0.50249135494232,
    "CMYK_C": 0,
    "CMYK_M": 0.16314232349396,
    "CMYK_Y": 0.2802432179451,
    "CMYK_K": 0.30878227949142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04846",
    "Farbtonhilfsbezeichnung": "E0.41.41",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "105",
    "Bcolor": "63",
    "Y": 18,
    "L": 49.6628455208089,
    "a": 18.8894643782408,
    "b": 32.2640699553803,
    "C": 37.3869238448753,
    "h": 1.04113333397736,
    "CMY_C": 0.3640186,
    "CMY_M": 0.5887447,
    "CMY_Y": 0.7526404,
    "CMYK_C": 0,
    "CMYK_M": 0.3533533,
    "CMYK_Y": 0.6110585,
    "CMYK_K": 0.3640186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04847",
    "Farbtonhilfsbezeichnung": "E0.44.45",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "108",
    "Bcolor": "58",
    "Y": 20,
    "L": 51.6840890399636,
    "a": 21.3585875811431,
    "b": 37.9527378456533,
    "C": 43.5499664000128,
    "h": 1.05820328103069,
    "CMY_C": 0.3226441,
    "CMY_M": 0.5767683,
    "CMY_Y": 0.7743513,
    "CMYK_C": 0,
    "CMYK_M": 0.3751707,
    "CMYK_Y": 0.6668683,
    "CMYK_K": 0.3226441
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04848",
    "Farbtonhilfsbezeichnung": "E0.61.50",
    "Farbtonklasse": "04",
    "Rcolor": "204",
    "Gcolor": "113",
    "Bcolor": "46",
    "Y": 25,
    "L": 56.939736605149,
    "a": 30.9305235823921,
    "b": 50.4397603980327,
    "C": 59.1681224823964,
    "h": 1.02071501199973,
    "CMY_C": 0.2014097,
    "CMY_M": 0.555734,
    "CMY_Y": 0.8198353,
    "CMYK_C": 0,
    "CMYK_M": 0.4436872,
    "CMYK_Y": 0.7743965,
    "CMYK_K": 0.2014097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04849",
    "Farbtonhilfsbezeichnung": "E1.06.47",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "128",
    "Bcolor": "119",
    "Y": 22,
    "L": 54.4488255255805,
    "a": 3.35226395551752,
    "b": 5.7992335781291,
    "C": 6.69841650848632,
    "h": 1.04667071671814,
    "CMY_C": 0.4498329,
    "CMY_M": 0.4977724,
    "CMY_Y": 0.5316462,
    "CMYK_C": 0,
    "CMYK_M": 0.08713628,
    "CMYK_Y": 0.1487063,
    "CMYK_K": 0.4498329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04850",
    "Farbtonhilfsbezeichnung": "E1.43.36",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "92",
    "Bcolor": "53",
    "Y": 14,
    "L": 43.7174793311097,
    "a": 17.1714234231084,
    "b": 29.8851515954576,
    "C": 34.4670867387884,
    "h": 1.04927741789393,
    "CMY_C": 0.4408088,
    "CMY_M": 0.6409626,
    "CMY_Y": 0.7902088,
    "CMYK_C": 0,
    "CMYK_M": 0.3579345,
    "CMYK_Y": 0.6248309,
    "CMYK_K": 0.4408088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04851",
    "Farbtonhilfsbezeichnung": "D9.63.44",
    "Farbtonklasse": "04",
    "Rcolor": "188",
    "Gcolor": "102",
    "Bcolor": "41",
    "Y": 20,
    "L": 52.2554579067436,
    "a": 30.1484436344385,
    "b": 47.4594276561112,
    "C": 56.2256696449635,
    "h": 1.00486252491767,
    "CMY_C": 0.2630564,
    "CMY_M": 0.5994583,
    "CMY_Y": 0.8401225,
    "CMYK_C": 0,
    "CMYK_M": 0.4564825,
    "CMYK_Y": 0.7830533,
    "CMYK_K": 0.2630564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04852",
    "Farbtonhilfsbezeichnung": "E0.12.37",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "105",
    "Bcolor": "94",
    "Y": 15,
    "L": 45.7312549703625,
    "a": 4.88368940428963,
    "b": 8.27554612654771,
    "C": 9.60911472978596,
    "h": 1.03766208241058,
    "CMY_C": 0.5221721,
    "CMY_M": 0.5875794,
    "CMY_Y": 0.631671,
    "CMYK_C": 0,
    "CMYK_M": 0.1368847,
    "CMYK_Y": 0.2291597,
    "CMYK_K": 0.5221721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04853",
    "Farbtonhilfsbezeichnung": "E0.26.35",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "95",
    "Bcolor": "72",
    "Y": 13,
    "L": 43.115620024072,
    "a": 10.5072167447821,
    "b": 18.2426728111192,
    "C": 21.0522377674056,
    "h": 1.0482340103919,
    "CMY_C": 0.4974503,
    "CMY_M": 0.6277271,
    "CMY_Y": 0.7194682,
    "CMYK_C": 0,
    "CMYK_M": 0.2592316,
    "CMYK_Y": 0.441783,
    "CMYK_K": 0.4974503
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04854",
    "Farbtonhilfsbezeichnung": "E0.42.33",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "90",
    "Bcolor": "56",
    "Y": 13,
    "L": 42.8664872446106,
    "a": 17.0984064238722,
    "b": 27.3584049508857,
    "C": 32.262018282999,
    "h": 1.01221269477001,
    "CMY_C": 0.4530041,
    "CMY_M": 0.6484748,
    "CMY_Y": 0.7805265,
    "CMYK_C": 0,
    "CMYK_M": 0.3573531,
    "CMYK_Y": 0.5987659,
    "CMYK_K": 0.4530041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04855",
    "Farbtonhilfsbezeichnung": "E0.54.45",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "108",
    "Bcolor": "50",
    "Y": 21,
    "L": 53.3726390481812,
    "a": 27.1354283724972,
    "b": 44.3262364769673,
    "C": 51.9725573083618,
    "h": 1.02147244537411,
    "CMY_C": 0.2676361,
    "CMY_M": 0.5783289,
    "CMY_Y": 0.8051839,
    "CMYK_C": 0,
    "CMYK_M": 0.4242328,
    "CMYK_Y": 0.7339901,
    "CMYK_K": 0.2676361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04856",
    "Farbtonhilfsbezeichnung": "EN.02.18",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "66",
    "Bcolor": "64",
    "Y": 5,
    "L": 27.8552527953148,
    "a": 0.03456950451821,
    "b": 0.82546353313047,
    "C": 0.82618708242799,
    "h": 1.528941884348,
    "CMY_C": 0.7397532,
    "CMY_M": 0.7422844,
    "CMY_Y": 0.7493539,
    "CMYK_C": 0,
    "CMYK_M": 0.009726053,
    "CMYK_Y": 0.03689083,
    "CMYK_K": 0.7397532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04857",
    "Farbtonhilfsbezeichnung": "E2.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "68",
    "Bcolor": "62",
    "Y": 6,
    "L": 29.4329414962307,
    "a": 2.56201564050665,
    "b": 4.27105955205147,
    "C": 4.98054955194412,
    "h": 1.0304835865123,
    "CMY_C": 0.7016805,
    "CMY_M": 0.7338821,
    "CMY_Y": 0.755667,
    "CMYK_C": 0,
    "CMYK_M": 0.1079434,
    "CMYK_Y": 0.1809687,
    "CMYK_K": 0.7016805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04858",
    "Farbtonhilfsbezeichnung": "E1.13.16",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "56",
    "Bcolor": "49",
    "Y": 4,
    "L": 24.4128286086128,
    "a": 4.08303110301508,
    "b": 5.64944251362676,
    "C": 6.97046223022275,
    "h": 0.94497654864643,
    "CMY_C": 0.7358801,
    "CMY_M": 0.7815876,
    "CMY_Y": 0.8069457,
    "CMYK_C": 0,
    "CMYK_M": 0.1730561,
    "CMYK_Y": 0.2690658,
    "CMYK_K": 0.7358801
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04859",
    "Farbtonhilfsbezeichnung": "E1.20.17",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "60",
    "Bcolor": "49",
    "Y": 5,
    "L": 26.7417011480923,
    "a": 5.5126820259481,
    "b": 8.94105905850608,
    "C": 10.5039135662335,
    "h": 1.01829066508931,
    "CMY_C": 0.7007756,
    "CMY_M": 0.764837,
    "CMY_Y": 0.8063143,
    "CMYK_C": 0,
    "CMYK_M": 0.2140916,
    "CMYK_Y": 0.3527079,
    "CMYK_K": 0.7007756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04860",
    "Farbtonhilfsbezeichnung": "E0.21.16",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "62",
    "Bcolor": "53",
    "Y": 5,
    "L": 27.5961603561816,
    "a": 5.37267181280762,
    "b": 7.46979596587028,
    "C": 9.20127459539544,
    "h": 0.94726553199939,
    "CMY_C": 0.6961847,
    "CMY_M": 0.7567164,
    "CMY_Y": 0.790309,
    "CMYK_C": 0,
    "CMYK_M": 0.1992385,
    "CMYK_Y": 0.3098077,
    "CMYK_K": 0.6961847
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04861",
    "Farbtonhilfsbezeichnung": "E1.31.22",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "68",
    "Bcolor": "47",
    "Y": 7,
    "L": 31.4837753861061,
    "a": 9.79554269352312,
    "b": 17.0049696722419,
    "C": 19.62451656002,
    "h": 1.0481808122479,
    "CMY_C": 0.6207633,
    "CMY_M": 0.7336367,
    "CMY_Y": 0.8141511,
    "CMYK_C": 0,
    "CMYK_M": 0.2976332,
    "CMYK_Y": 0.5099396,
    "CMYK_K": 0.6207633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04862",
    "Farbtonhilfsbezeichnung": "E0.48.31",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "81",
    "Bcolor": "46",
    "Y": 11,
    "L": 39.9440362013615,
    "a": 19.8837724742593,
    "b": 29.5271880483808,
    "C": 35.5980230048321,
    "h": 0.97814283765777,
    "CMY_C": 0.468226,
    "CMY_M": 0.6840907,
    "CMY_Y": 0.8202815,
    "CMYK_C": 0,
    "CMYK_M": 0.4059332,
    "CMYK_Y": 0.6620397,
    "CMYK_K": 0.468226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04863",
    "Farbtonhilfsbezeichnung": "E2.22.77",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "201",
    "Bcolor": "160",
    "Y": 65,
    "L": 84.4144282256742,
    "a": 13.4182634767319,
    "b": 26.828243946264,
    "C": 29.9967409558314,
    "h": 1.10702522859751,
    "CMY_C": 0.009925899,
    "CMY_M": 0.2135782,
    "CMY_Y": 0.3744676,
    "CMYK_C": 0,
    "CMYK_M": 0.205694,
    "CMYK_Y": 0.3681964,
    "CMYK_K": 0.009925899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04864",
    "Farbtonhilfsbezeichnung": "E3.36.72",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "181",
    "Bcolor": "116",
    "Y": 55,
    "L": 79.0137830959943,
    "a": 19.7136642257831,
    "b": 42.2813290450016,
    "C": 46.651252319939,
    "h": 1.13451148060852,
    "CMY_C": 0.009148599,
    "CMY_M": 0.2920235,
    "CMY_Y": 0.5436667,
    "CMYK_C": 0,
    "CMYK_M": 0.2854867,
    "CMYK_Y": 0.5394534,
    "CMYK_K": 0.009148599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04865",
    "Farbtonhilfsbezeichnung": "E2.46.69",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "169",
    "Bcolor": "90",
    "Y": 51,
    "L": 76.702733457277,
    "a": 25.8368540578603,
    "b": 52.9984149474115,
    "C": 58.9607921804413,
    "h": 1.11719669802215,
    "CMY_C": 0,
    "CMY_M": 0.3361136,
    "CMY_Y": 0.6486612,
    "CMYK_C": 0,
    "CMYK_M": 0.3361136,
    "CMYK_Y": 0.6486612,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04866",
    "Farbtonhilfsbezeichnung": "E3.54.67",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "161",
    "Bcolor": "68",
    "Y": 48,
    "L": 74.7783205691283,
    "a": 28.9254216711323,
    "b": 60.991399809996,
    "C": 67.5028211976032,
    "h": 1.1279567504366,
    "CMY_C": 0,
    "CMY_M": 0.3669772,
    "CMY_Y": 0.7348551,
    "CMYK_C": 0,
    "CMYK_M": 0.3669772,
    "CMYK_Y": 0.7348551,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04867",
    "Farbtonhilfsbezeichnung": "E2.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "226",
    "Bcolor": "211",
    "Y": 78,
    "L": 90.9484050026762,
    "a": 4.45534675656883,
    "b": 8.63788952621476,
    "C": 9.71922065745804,
    "h": 1.09459577138867,
    "CMY_C": 0.04039781,
    "CMY_M": 0.1144044,
    "CMY_Y": 0.1719654,
    "CMYK_C": 0,
    "CMYK_M": 0.07712215,
    "CMYK_Y": 0.1371064,
    "CMYK_K": 0.04039781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04868",
    "Farbtonhilfsbezeichnung": "E3.26.74",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "192",
    "Bcolor": "144",
    "Y": 59,
    "L": 81.5205637252418,
    "a": 14.3950692247358,
    "b": 31.0555725091616,
    "C": 34.2296158590296,
    "h": 1.13675117957852,
    "CMY_C": 0.02961209,
    "CMY_M": 0.248431,
    "CMY_Y": 0.4354539,
    "CMYK_C": 0,
    "CMYK_M": 0.2254963,
    "CMYK_Y": 0.4182264,
    "CMYK_K": 0.02961209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04869",
    "Farbtonhilfsbezeichnung": "E3.41.71",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "179",
    "Bcolor": "108",
    "Y": 55,
    "L": 79.2163735190846,
    "a": 21.7195671912407,
    "b": 47.0063061069511,
    "C": 51.7815837223545,
    "h": 1.13796160613559,
    "CMY_C": 0,
    "CMY_M": 0.2963396,
    "CMY_Y": 0.5773857,
    "CMYK_C": 0,
    "CMYK_M": 0.2963396,
    "CMYK_Y": 0.5773857,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04870",
    "Farbtonhilfsbezeichnung": "E2.56.66",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "157",
    "Bcolor": "68",
    "Y": 46,
    "L": 73.5663403353822,
    "a": 30.8195741406986,
    "b": 59.7409048942052,
    "C": 67.2221828550107,
    "h": 1.09451980899783,
    "CMY_C": 0,
    "CMY_M": 0.3855565,
    "CMY_Y": 0.7350969,
    "CMYK_C": 0,
    "CMYK_M": 0.3855565,
    "CMYK_Y": 0.7350969,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04871",
    "Farbtonhilfsbezeichnung": "E1.60.64",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "150",
    "Bcolor": "55",
    "Y": 44,
    "L": 71.9832961861093,
    "a": 33.1528441554635,
    "b": 63.5204436134561,
    "C": 71.6516422173749,
    "h": 1.08976374232654,
    "CMY_C": 0,
    "CMY_M": 0.4101769,
    "CMY_Y": 0.785484,
    "CMYK_C": 0,
    "CMYK_M": 0.4101769,
    "CMYK_Y": 0.785484,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04872",
    "Farbtonhilfsbezeichnung": "E2.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "225",
    "Bcolor": "216",
    "Y": 77,
    "L": 90.1513222189818,
    "a": 2.12021993738354,
    "b": 4.89012482809705,
    "C": 5.32997686835974,
    "h": 1.16168779756654,
    "CMY_C": 0.0781567,
    "CMY_M": 0.116552,
    "CMY_Y": 0.1533,
    "CMYK_C": 0,
    "CMYK_M": 0.0416506,
    "CMYK_Y": 0.08151419,
    "CMYK_K": 0.0781567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04873",
    "Farbtonhilfsbezeichnung": "E3.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 74,
    "L": 89.0799199885718,
    "a": 3.39626430747353,
    "b": 7.81478371766327,
    "C": 8.52088351053302,
    "h": 1.16082695388518,
    "CMY_C": 0.07172967,
    "CMY_M": 0.1323223,
    "CMY_Y": 0.1863993,
    "CMYK_C": 0,
    "CMYK_M": 0.06527472,
    "CMYK_Y": 0.1235304,
    "CMYK_K": 0.07172967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04874",
    "Farbtonhilfsbezeichnung": "E2.10.73",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "197",
    "Bcolor": "176",
    "Y": 59,
    "L": 81.2841785862401,
    "a": 6.39768856023243,
    "b": 13.1298351531992,
    "C": 14.6055807848889,
    "h": 1.11738978907658,
    "CMY_C": 0.1229994,
    "CMY_M": 0.2264697,
    "CMY_Y": 0.3083725,
    "CMYK_C": 0,
    "CMYK_M": 0.1179821,
    "CMYK_Y": 0.2113717,
    "CMYK_K": 0.1229994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04875",
    "Farbtonhilfsbezeichnung": "E3.17.72",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "190",
    "Bcolor": "159",
    "Y": 56,
    "L": 79.5805888751911,
    "a": 9.13863688797473,
    "b": 20.0351195832241,
    "C": 22.0209150782691,
    "h": 1.14285566354048,
    "CMY_C": 0.1073804,
    "CMY_M": 0.25335,
    "CMY_Y": 0.3758222,
    "CMYK_C": 0,
    "CMYK_M": 0.1635294,
    "CMYK_Y": 0.3007348,
    "CMYK_K": 0.1073804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04876",
    "Farbtonhilfsbezeichnung": "E3.24.72",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "183",
    "Bcolor": "138",
    "Y": 53,
    "L": 78.04143938081,
    "a": 12.9705035313788,
    "b": 29.3930372584099,
    "C": 32.1276298710593,
    "h": 1.15521916558937,
    "CMY_C": 0.08186044,
    "CMY_M": 0.2817287,
    "CMY_Y": 0.4590902,
    "CMYK_C": 0,
    "CMYK_M": 0.2176884,
    "CMYK_Y": 0.4108632,
    "CMYK_K": 0.08186044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04877",
    "Farbtonhilfsbezeichnung": "E3.34.70",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "179",
    "Bcolor": "119",
    "Y": 53,
    "L": 78.1288377905785,
    "a": 18.2349425243153,
    "b": 39.7679317165694,
    "C": 43.7493031016359,
    "h": 1.14086836002795,
    "CMY_C": 0.03201398,
    "CMY_M": 0.2969205,
    "CMY_Y": 0.5339361,
    "CMYK_C": 0,
    "CMYK_M": 0.2736677,
    "CMYK_Y": 0.5185221,
    "CMYK_K": 0.03201398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04878",
    "Farbtonhilfsbezeichnung": "E2.48.65",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "157",
    "Bcolor": "80",
    "Y": 44,
    "L": 72.2480507216177,
    "a": 25.8728183056234,
    "b": 52.1033223102876,
    "C": 58.1735242429536,
    "h": 1.10989845852562,
    "CMY_C": 0.04334864,
    "CMY_M": 0.3830797,
    "CMY_Y": 0.6857611,
    "CMYK_C": 0,
    "CMYK_M": 0.3551252,
    "CMYK_Y": 0.671522,
    "CMYK_K": 0.04334864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04879",
    "Farbtonhilfsbezeichnung": "E3.67.64",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "147",
    "Bcolor": "27",
    "Y": 42,
    "L": 71.0250544430318,
    "a": 34.4036292096311,
    "b": 71.7145363594088,
    "C": 79.5398291929191,
    "h": 1.12349564915696,
    "CMY_C": 0,
    "CMY_M": 0.4251971,
    "CMY_Y": 0.8938107,
    "CMYK_C": 0,
    "CMYK_M": 0.4251971,
    "CMYK_Y": 0.8938107,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04880",
    "Farbtonhilfsbezeichnung": "E2.04.79",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "213",
    "Bcolor": "201",
    "Y": 68,
    "L": 86.0171317231898,
    "a": 3.14471200297534,
    "b": 6.5242391949784,
    "C": 7.24257624433112,
    "h": 1.12164856166814,
    "CMY_C": 0.111669,
    "CMY_M": 0.1651645,
    "CMY_Y": 0.2101722,
    "CMYK_C": 0,
    "CMYK_M": 0.06022025,
    "CMYK_Y": 0.1108857,
    "CMYK_K": 0.111669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04881",
    "Farbtonhilfsbezeichnung": "E2.09.74",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "196",
    "Bcolor": "178",
    "Y": 57,
    "L": 80.4522660691706,
    "a": 5.34542989800402,
    "b": 11.2468534247819,
    "C": 12.4525231480613,
    "h": 1.12711771787474,
    "CMY_C": 0.1444732,
    "CMY_M": 0.2324358,
    "CMY_Y": 0.303699,
    "CMYK_C": 0,
    "CMYK_M": 0.1028169,
    "CMYK_Y": 0.1861143,
    "CMYK_K": 0.1444732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04882",
    "Farbtonhilfsbezeichnung": "E2.11.68",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "182",
    "Bcolor": "163",
    "Y": 49,
    "L": 75.6495017337957,
    "a": 6.23843938035018,
    "b": 12.1806995251823,
    "C": 13.6853047764776,
    "h": 1.09746990894986,
    "CMY_C": 0.1889921,
    "CMY_M": 0.286482,
    "CMY_Y": 0.3606493,
    "CMYK_C": 0,
    "CMYK_M": 0.1202084,
    "CMYK_Y": 0.2116591,
    "CMYK_K": 0.1889921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04883",
    "Farbtonhilfsbezeichnung": "E2.21.67",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "173",
    "Bcolor": "138",
    "Y": 47,
    "L": 74.163789220961,
    "a": 12.3485817600235,
    "b": 23.7429653372297,
    "C": 26.7622098207318,
    "h": 1.09120278179404,
    "CMY_C": 0.1402707,
    "CMY_M": 0.3202425,
    "CMY_Y": 0.4576158,
    "CMYK_C": 0,
    "CMYK_M": 0.2093355,
    "CMYK_Y": 0.3691221,
    "CMYK_K": 0.1402707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04884",
    "Farbtonhilfsbezeichnung": "E2.30.65",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "164",
    "Bcolor": "117",
    "Y": 44,
    "L": 72.074336010516,
    "a": 17.140549292592,
    "b": 32.7179630970033,
    "C": 36.9359383158008,
    "h": 1.0882214287071,
    "CMY_C": 0.1194973,
    "CMY_M": 0.3567823,
    "CMY_Y": 0.5424613,
    "CMYK_C": 0,
    "CMYK_M": 0.2694881,
    "CMYK_Y": 0.4803666,
    "CMYK_K": 0.1194973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04885",
    "Farbtonhilfsbezeichnung": "E3.41.67",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "165",
    "Bcolor": "98",
    "Y": 47,
    "L": 73.8698954454614,
    "a": 21.8834033032987,
    "b": 45.1029447058021,
    "C": 50.1314169086558,
    "h": 1.11906845416402,
    "CMY_C": 0.05409184,
    "CMY_M": 0.3532717,
    "CMY_Y": 0.6158907,
    "CMYK_C": 0,
    "CMYK_M": 0.3162885,
    "CMYK_Y": 0.5939254,
    "CMYK_K": 0.05409184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04886",
    "Farbtonhilfsbezeichnung": "E3.42.64",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "161",
    "Bcolor": "92",
    "Y": 44,
    "L": 72.1268121880632,
    "a": 21.1687685824579,
    "b": 45.7808948356599,
    "C": 50.4381511878797,
    "h": 1.13768424818268,
    "CMY_C": 0.07824107,
    "CMY_M": 0.3696535,
    "CMY_Y": 0.6385603,
    "CMYK_C": 0,
    "CMYK_M": 0.3161482,
    "CMYK_Y": 0.6078804,
    "CMYK_K": 0.07824107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04887",
    "Farbtonhilfsbezeichnung": "E3.78.60",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "140",
    "Bcolor": "0",
    "Y": 40,
    "L": 69.8221915512901,
    "a": 37.990497194663,
    "b": 77.1377501118682,
    "C": 85.9855241852879,
    "h": 1.11316507940334,
    "CMY_C": 0,
    "CMY_M": 0.4505306,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.4505306,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04888",
    "Farbtonhilfsbezeichnung": "E2.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "195",
    "Bcolor": "181",
    "Y": 56,
    "L": 79.7847216531197,
    "a": 4.09657293093313,
    "b": 8.28853898617819,
    "C": 9.24563617626444,
    "h": 1.11176292201743,
    "CMY_C": 0.1687048,
    "CMY_M": 0.2358859,
    "CMY_Y": 0.2896043,
    "CMYK_C": 0,
    "CMYK_M": 0.080815,
    "CMYK_Y": 0.1454351,
    "CMYK_K": 0.1687048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04889",
    "Farbtonhilfsbezeichnung": "E3.35.61",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "155",
    "Bcolor": "100",
    "Y": 39,
    "L": 68.7223660833236,
    "a": 17.1892605452929,
    "b": 37.1053220054804,
    "C": 40.8934664613353,
    "h": 1.13697361051895,
    "CMY_C": 0.1518379,
    "CMY_M": 0.3927269,
    "CMY_Y": 0.6076347,
    "CMYK_C": 0,
    "CMYK_M": 0.2840129,
    "CMYK_Y": 0.5373934,
    "CMYK_K": 0.1518379
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04890",
    "Farbtonhilfsbezeichnung": "E2.42.57",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "143",
    "Bcolor": "82",
    "Y": 34,
    "L": 65.2753962725138,
    "a": 20.9762706562761,
    "b": 42.4193609810734,
    "C": 47.3223638112887,
    "h": 1.11156034821125,
    "CMY_C": 0.1637632,
    "CMY_M": 0.4397224,
    "CMY_Y": 0.6796575,
    "CMYK_C": 0,
    "CMYK_M": 0.3300013,
    "CMYK_Y": 0.6169236,
    "CMYK_K": 0.1637632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04891",
    "Farbtonhilfsbezeichnung": "E2.57.60",
    "Farbtonklasse": "04",
    "Rcolor": "238",
    "Gcolor": "143",
    "Bcolor": "57",
    "Y": 38,
    "L": 68.1500544620198,
    "a": 29.5407579160502,
    "b": 58.0840346142756,
    "C": 65.1644953584929,
    "h": 1.10030310894608,
    "CMY_C": 0.06782378,
    "CMY_M": 0.4378481,
    "CMY_Y": 0.7762693,
    "CMYK_C": 0,
    "CMYK_M": 0.3969467,
    "CMYK_Y": 0.7599909,
    "CMYK_K": 0.06782378
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04892",
    "Farbtonhilfsbezeichnung": "E2.64.59",
    "Farbtonklasse": "04",
    "Rcolor": "240",
    "Gcolor": "136",
    "Bcolor": "45",
    "Y": 37,
    "L": 66.7492828369141,
    "a": 34.0407981872559,
    "b": 61.6309051513672,
    "C": 70.4069900512695,
    "h": 61.086669921875,
    "CMY_C": 0.05828505754471,
    "CMY_M": 0.46731752157211,
    "CMY_Y": 0.8222029209137,
    "CMYK_C": 0,
    "CMYK_M": 0.43434849381447,
    "CMYK_Y": 0.81119859218597,
    "CMYK_K": 0.05828505754471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04893",
    "Farbtonhilfsbezeichnung": "E3.09.71",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "189",
    "Bcolor": "172",
    "Y": 53,
    "L": 78.042110973969,
    "a": 4.94257785689717,
    "b": 10.4869397289729,
    "C": 11.5933162102395,
    "h": 1.13036469546971,
    "CMY_C": 0.1759647,
    "CMY_M": 0.2572776,
    "CMY_Y": 0.3236945,
    "CMYK_C": 0,
    "CMYK_M": 0.09867652,
    "CMYK_Y": 0.1792761,
    "CMYK_K": 0.1759647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04894",
    "Farbtonhilfsbezeichnung": "E3.19.61",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "160",
    "Bcolor": "131",
    "Y": 39,
    "L": 68.4792565393059,
    "a": 9.34898211668611,
    "b": 19.738742482373,
    "C": 21.8408200716812,
    "h": 1.128461352575,
    "CMY_C": 0.2306024,
    "CMY_M": 0.3715706,
    "CMY_Y": 0.487028,
    "CMYK_C": 0,
    "CMYK_M": 0.183219,
    "CMYK_Y": 0.333281,
    "CMYK_K": 0.2306024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04895",
    "Farbtonhilfsbezeichnung": "E3.26.55",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "142",
    "Bcolor": "106",
    "Y": 31,
    "L": 62.1829565373811,
    "a": 11.8788008801285,
    "b": 25.0736416341752,
    "C": 27.7451512006835,
    "h": 1.12836305784027,
    "CMY_C": 0.2748039,
    "CMY_M": 0.4440159,
    "CMY_Y": 0.5861676,
    "CMYK_C": 0,
    "CMYK_M": 0.2333327,
    "CMYK_Y": 0.4293511,
    "CMYK_K": 0.2748039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04896",
    "Farbtonhilfsbezeichnung": "E3.36.52",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "132",
    "Bcolor": "84",
    "Y": 28,
    "L": 59.8295997725792,
    "a": 16.3454159299021,
    "b": 33.9634747548457,
    "C": 37.6920447753175,
    "h": 1.12224911466496,
    "CMY_C": 0.2623118,
    "CMY_M": 0.4811274,
    "CMY_Y": 0.6706955,
    "CMYK_C": 0,
    "CMYK_M": 0.2966234,
    "CMYK_Y": 0.5535993,
    "CMYK_K": 0.2623118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04897",
    "Farbtonhilfsbezeichnung": "E2.50.55",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "134",
    "Bcolor": "64",
    "Y": 31,
    "L": 62.8476330454791,
    "a": 24.0952520741005,
    "b": 48.4358593614299,
    "C": 54.0981852245956,
    "h": 1.10917699770517,
    "CMY_C": 0.1691598,
    "CMY_M": 0.4744536,
    "CMY_Y": 0.7489232,
    "CMYK_C": 0,
    "CMYK_M": 0.3674519,
    "CMYK_Y": 0.6978037,
    "CMYK_K": 0.1691598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04898",
    "Farbtonhilfsbezeichnung": "E3.61.60",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "144",
    "Bcolor": "53",
    "Y": 39,
    "L": 68.4688639653129,
    "a": 29.5740216834806,
    "b": 60.2051055692932,
    "C": 67.0766538755827,
    "h": 1.11419642328223,
    "CMY_C": 0.06221403,
    "CMY_M": 0.4348947,
    "CMY_Y": 0.792762,
    "CMYK_C": 0,
    "CMYK_M": 0.3974048,
    "CMYK_Y": 0.7790135,
    "CMYK_K": 0.06221403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04899",
    "Farbtonhilfsbezeichnung": "E2.69.55",
    "Farbtonklasse": "04",
    "Rcolor": "230",
    "Gcolor": "126",
    "Bcolor": "15",
    "Y": 32,
    "L": 63.0992105713096,
    "a": 34.7140966411473,
    "b": 67.1145635020749,
    "C": 75.5607910207732,
    "h": 1.09345485597602,
    "CMY_C": 0.09697517,
    "CMY_M": 0.5077636,
    "CMY_Y": 0.9406908,
    "CMYK_C": 0,
    "CMYK_M": 0.4549027,
    "CMYK_Y": 0.9343216,
    "CMYK_K": 0.09697517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04900",
    "Farbtonhilfsbezeichnung": "E1.05.59",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "160",
    "Bcolor": "151",
    "Y": 36,
    "L": 66.3499741257721,
    "a": 2.42384831652565,
    "b": 5.02531933671799,
    "C": 5.57932568484006,
    "h": 1.12138663404606,
    "CMY_C": 0.3347118,
    "CMY_M": 0.3738326,
    "CMY_Y": 0.4069358,
    "CMYK_C": 0,
    "CMYK_M": 0.05880272,
    "CMYK_Y": 0.1085605,
    "CMYK_K": 0.3347118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04901",
    "Farbtonhilfsbezeichnung": "E3.12.60",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "160",
    "Bcolor": "140",
    "Y": 37,
    "L": 67.5057954867434,
    "a": 6.13269729485022,
    "b": 13.3198527754023,
    "C": 14.6638485422025,
    "h": 1.13931280851259,
    "CMY_C": 0.2758521,
    "CMY_M": 0.3724623,
    "CMY_Y": 0.4523376,
    "CMYK_C": 0,
    "CMYK_M": 0.1334122,
    "CMYK_Y": 0.2437147,
    "CMYK_K": 0.2758521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04902",
    "Farbtonhilfsbezeichnung": "E2.20.54",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "142",
    "Bcolor": "113",
    "Y": 30,
    "L": 61.405588316084,
    "a": 9.37266427928951,
    "b": 19.9616347541654,
    "C": 22.0525213467978,
    "h": 1.13181727297605,
    "CMY_C": 0.3074186,
    "CMY_M": 0.4446944,
    "CMY_Y": 0.5586532,
    "CMYK_C": 0,
    "CMYK_M": 0.1982089,
    "CMYK_Y": 0.3627509,
    "CMYK_K": 0.3074186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04903",
    "Farbtonhilfsbezeichnung": "E2.30.48",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "123",
    "Bcolor": "84",
    "Y": 23,
    "L": 55.2783782462441,
    "a": 13.7055654177074,
    "b": 27.7650951779136,
    "C": 30.9635759184507,
    "h": 1.11226112329498,
    "CMY_C": 0.3360761,
    "CMY_M": 0.5188426,
    "CMY_Y": 0.6705334,
    "CMYK_C": 0,
    "CMYK_M": 0.2752823,
    "CMYK_Y": 0.5037585,
    "CMYK_K": 0.3360761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04904",
    "Farbtonhilfsbezeichnung": "E2.44.50",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "121",
    "Bcolor": "66",
    "Y": 24,
    "L": 56.5195809660301,
    "a": 20.4856668939725,
    "b": 39.5044798087498,
    "C": 44.5001850900726,
    "h": 1.09240673858103,
    "CMY_C": 0.2707691,
    "CMY_M": 0.5266164,
    "CMY_Y": 0.7412023,
    "CMYK_C": 0,
    "CMYK_M": 0.3508454,
    "CMYK_Y": 0.6451088,
    "CMYK_K": 0.2707691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04905",
    "Farbtonhilfsbezeichnung": "E3.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "122",
    "Bcolor": "60",
    "Y": 25,
    "L": 57.4015810881482,
    "a": 21.7038887430998,
    "b": 43.7480735492203,
    "C": 48.8359777811486,
    "h": 1.11026497099726,
    "CMY_C": 0.2500562,
    "CMY_M": 0.5218571,
    "CMY_Y": 0.7648296,
    "CMYK_C": 0,
    "CMYK_M": 0.3624284,
    "CMYK_Y": 0.6864159,
    "CMYK_K": 0.2500562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04906",
    "Farbtonhilfsbezeichnung": "E1.58.55",
    "Farbtonklasse": "04",
    "Rcolor": "218",
    "Gcolor": "129",
    "Bcolor": "50",
    "Y": 31,
    "L": 62.2920703937605,
    "a": 28.9425879860404,
    "b": 54.6656046900012,
    "C": 61.8546824052405,
    "h": 1.08386889394736,
    "CMY_C": 0.1447001,
    "CMY_M": 0.4957174,
    "CMY_Y": 0.8051346,
    "CMYK_C": 0,
    "CMYK_M": 0.4104027,
    "CMYK_Y": 0.7721671,
    "CMYK_K": 0.1447001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04907",
    "Farbtonhilfsbezeichnung": "E2.60.51",
    "Farbtonklasse": "04",
    "Rcolor": "208",
    "Gcolor": "122",
    "Bcolor": "42",
    "Y": 28,
    "L": 59.5384111387249,
    "a": 27.7641083816458,
    "b": 54.8351742846954,
    "C": 61.4633390978776,
    "h": 1.10210604785809,
    "CMY_C": 0.1839828,
    "CMY_M": 0.5199265,
    "CMY_Y": 0.8355459,
    "CMYK_C": 0,
    "CMYK_M": 0.411687,
    "CMYK_Y": 0.7984673,
    "CMYK_K": 0.1839828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04908",
    "Farbtonhilfsbezeichnung": "E2.06.54",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "147",
    "Bcolor": "138",
    "Y": 30,
    "L": 61.7424100296685,
    "a": 3.23455285094615,
    "b": 5.76969028131917,
    "C": 6.61450361613876,
    "h": 1.05984285851167,
    "CMY_C": 0.3753836,
    "CMY_M": 0.4235331,
    "CMY_Y": 0.4588202,
    "CMYK_C": 0,
    "CMYK_M": 0.07708665,
    "CMYK_Y": 0.1335806,
    "CMYK_K": 0.3753836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04909",
    "Farbtonhilfsbezeichnung": "E3.15.39",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "108",
    "Bcolor": "91",
    "Y": 16,
    "L": 47.2566755834863,
    "a": 5.70740136924308,
    "b": 12.028382978209,
    "C": 13.3137683418372,
    "h": 1.12776052722381,
    "CMY_C": 0.4938319,
    "CMY_M": 0.5754459,
    "CMY_Y": 0.6415837,
    "CMYK_C": 0,
    "CMYK_M": 0.1612388,
    "CMYK_Y": 0.2919027,
    "CMYK_K": 0.4938319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04910",
    "Farbtonhilfsbezeichnung": "E2.38.45",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "112",
    "Bcolor": "69",
    "Y": 20,
    "L": 51.4635845739921,
    "a": 15.5467272763994,
    "b": 31.0664434877248,
    "C": 34.7393816868225,
    "h": 1.10680099382242,
    "CMY_C": 0.3635382,
    "CMY_M": 0.5619106,
    "CMY_Y": 0.7286314,
    "CMYK_C": 0,
    "CMYK_M": 0.3116799,
    "CMYK_Y": 0.5736293,
    "CMYK_K": 0.3635382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04911",
    "Farbtonhilfsbezeichnung": "E2.47.44",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "113",
    "Bcolor": "61",
    "Y": 21,
    "L": 53.2744170764965,
    "a": 19.3305991145153,
    "b": 38.1158911652129,
    "C": 42.737491988235,
    "h": 1.10144248551981,
    "CMY_C": 0.3153064,
    "CMY_M": 0.5553914,
    "CMY_Y": 0.7615415,
    "CMYK_C": 0,
    "CMYK_M": 0.350646,
    "CMYK_Y": 0.6517297,
    "CMYK_K": 0.3153064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04912",
    "Farbtonhilfsbezeichnung": "E2.54.47",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "112",
    "Bcolor": "51",
    "Y": 22,
    "L": 54.1639462456168,
    "a": 24.435990391439,
    "b": 44.6155235945469,
    "C": 50.8690728441759,
    "h": 1.06971949114315,
    "CMY_C": 0.2723088,
    "CMY_M": 0.562242,
    "CMY_Y": 0.8012168,
    "CMYK_C": 0,
    "CMYK_M": 0.3984288,
    "CMYK_Y": 0.7268302,
    "CMYK_K": 0.2723088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04913",
    "Farbtonhilfsbezeichnung": "E3.65.48",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "113",
    "Bcolor": "38",
    "Y": 23,
    "L": 55.4181273852247,
    "a": 26.2771563965375,
    "b": 51.7491399118903,
    "C": 58.0384564742076,
    "h": 1.10094444236704,
    "CMY_C": 0.2428781,
    "CMY_M": 0.5562313,
    "CMY_Y": 0.8494926,
    "CMYK_C": 0,
    "CMYK_M": 0.4138741,
    "CMYK_Y": 0.8012112,
    "CMYK_K": 0.2428781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04914",
    "Farbtonhilfsbezeichnung": "E3.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "99",
    "Bcolor": "85",
    "Y": 13,
    "L": 43.4269090346315,
    "a": 4.77608672255603,
    "b": 10.0745552032983,
    "C": 11.1493348198752,
    "h": 1.12810362910405,
    "CMY_C": 0.5419778,
    "CMY_M": 0.6099042,
    "CMY_Y": 0.6648425,
    "CMYK_C": 0,
    "CMYK_M": 0.1483036,
    "CMYK_Y": 0.2682504,
    "CMYK_K": 0.5419778
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04915",
    "Farbtonhilfsbezeichnung": "E2.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "98",
    "Bcolor": "79",
    "Y": 13,
    "L": 43.1664324145386,
    "a": 6.7572118855635,
    "b": 13.4893546213322,
    "C": 15.0871667508004,
    "h": 1.10640561832201,
    "CMY_C": 0.5261893,
    "CMY_M": 0.6175357,
    "CMY_Y": 0.6889027,
    "CMYK_C": 0,
    "CMYK_M": 0.1927909,
    "CMYK_Y": 0.3434143,
    "CMYK_K": 0.5261893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04916",
    "Farbtonhilfsbezeichnung": "E3.24.42",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "111",
    "Bcolor": "84",
    "Y": 18,
    "L": 49.0108347404448,
    "a": 8.6757194062122,
    "b": 18.7676110799404,
    "C": 20.6758635336769,
    "h": 1.1377849508751,
    "CMY_C": 0.4457864,
    "CMY_M": 0.5665861,
    "CMY_Y": 0.6690742,
    "CMYK_C": 0,
    "CMYK_M": 0.2179661,
    "CMYK_Y": 0.4028913,
    "CMYK_K": 0.4457864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04917",
    "Farbtonhilfsbezeichnung": "E3.45.40",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "106",
    "Bcolor": "61",
    "Y": 18,
    "L": 49.5840042017706,
    "a": 17.4412023395996,
    "b": 33.1775067252611,
    "C": 37.4825624998559,
    "h": 1.08680576138812,
    "CMY_C": 0.3716962,
    "CMY_M": 0.5856759,
    "CMY_Y": 0.7602562,
    "CMYK_C": 0,
    "CMYK_M": 0.3405673,
    "CMYK_Y": 0.6184269,
    "CMYK_K": 0.3716962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04918",
    "Farbtonhilfsbezeichnung": "E2.49.41",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "102",
    "Bcolor": "51",
    "Y": 17,
    "L": 48.5703377505909,
    "a": 19.1765975412489,
    "b": 37.361438998404,
    "C": 41.9954642466362,
    "h": 1.09658721888361,
    "CMY_C": 0.3697709,
    "CMY_M": 0.6008834,
    "CMY_Y": 0.7993355,
    "CMYK_C": 0,
    "CMYK_M": 0.3667119,
    "CMYK_Y": 0.6816008,
    "CMYK_K": 0.3697709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04919",
    "Farbtonhilfsbezeichnung": "E2.59.40",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "101",
    "Bcolor": "46",
    "Y": 18,
    "L": 49.5832649779267,
    "a": 22.9999549975463,
    "b": 41.6780765581138,
    "C": 47.6031511086519,
    "h": 1.06653556385775,
    "CMY_C": 0.3348471,
    "CMY_M": 0.6025892,
    "CMY_Y": 0.8214923,
    "CMYK_C": 0,
    "CMYK_M": 0.4025271,
    "CMYK_Y": 0.7316291,
    "CMYK_K": 0.3348471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04920",
    "Farbtonhilfsbezeichnung": "E3.05.42",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "114",
    "Bcolor": "108",
    "Y": 17,
    "L": 48.6472070500649,
    "a": 2.22098577820501,
    "b": 4.07019554469241,
    "C": 4.63673048591601,
    "h": 1.07128315736988,
    "CMY_C": 0.5203094,
    "CMY_M": 0.5523753,
    "CMY_Y": 0.576896,
    "CMYK_C": 0,
    "CMYK_M": 0.06684702,
    "CMYK_Y": 0.1179647,
    "CMYK_K": 0.5203094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04921",
    "Farbtonhilfsbezeichnung": "E3.09.25",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "79",
    "Bcolor": "72",
    "Y": 8,
    "L": 34.1471773387357,
    "a": 2.79894936703035,
    "b": 5.01576742821295,
    "C": 5.74386981512651,
    "h": 1.06180885807374,
    "CMY_C": 0.6547605,
    "CMY_M": 0.6917112,
    "CMY_Y": 0.7182046,
    "CMYK_C": 0,
    "CMYK_M": 0.1070291,
    "CMYK_Y": 0.1837682,
    "CMYK_K": 0.6547605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04922",
    "Farbtonhilfsbezeichnung": "E3.16.28",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "86",
    "Bcolor": "73",
    "Y": 10,
    "L": 37.7536972050575,
    "a": 4.7404890340611,
    "b": 9.77563920414385,
    "C": 10.8644078592277,
    "h": 1.11927820511768,
    "CMY_C": 0.5986598,
    "CMY_M": 0.6634126,
    "CMY_Y": 0.7149222,
    "CMYK_C": 0,
    "CMYK_M": 0.1613415,
    "CMYK_Y": 0.2896853,
    "CMYK_K": 0.5986598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04923",
    "Farbtonhilfsbezeichnung": "E3.26.31",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "90",
    "Bcolor": "68",
    "Y": 11,
    "L": 40.1656682013201,
    "a": 7.86819196480223,
    "b": 15.9017022405621,
    "C": 17.7418313300086,
    "h": 1.11131586428789,
    "CMY_C": 0.5459737,
    "CMY_M": 0.6489878,
    "CMY_Y": 0.7314807,
    "CMYK_C": 0,
    "CMYK_M": 0.2268902,
    "CMYK_Y": 0.4085822,
    "CMYK_K": 0.5459737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04924",
    "Farbtonhilfsbezeichnung": "E2.33.39",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "101",
    "Bcolor": "67",
    "Y": 15,
    "L": 46.1130021852253,
    "a": 12.7274321438371,
    "b": 24.845657633544,
    "C": 27.9158419579145,
    "h": 1.0973890328169,
    "CMY_C": 0.4445488,
    "CMY_M": 0.6056588,
    "CMY_Y": 0.7354983,
    "CMYK_C": 0,
    "CMYK_M": 0.2900526,
    "CMYK_Y": 0.5238075,
    "CMYK_K": 0.4445488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04925",
    "Farbtonhilfsbezeichnung": "E2.43.38",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "98",
    "Bcolor": "59",
    "Y": 15,
    "L": 45.9582632655654,
    "a": 15.8791555615559,
    "b": 29.4647220216631,
    "C": 33.4711431708266,
    "h": 1.07649888795972,
    "CMY_C": 0.423732,
    "CMY_M": 0.6160135,
    "CMY_Y": 0.7675768,
    "CMYK_C": 0,
    "CMYK_M": 0.3336667,
    "CMYK_Y": 0.5966752,
    "CMYK_K": 0.423732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04926",
    "Farbtonhilfsbezeichnung": "E3.49.40",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "101",
    "Bcolor": "51",
    "Y": 17,
    "L": 48.1213345018788,
    "a": 18.5450311815313,
    "b": 36.8174302977465,
    "C": 41.2242811368906,
    "h": 1.10419111755049,
    "CMY_C": 0.3785879,
    "CMY_M": 0.6034065,
    "CMY_Y": 0.7996249,
    "CMYK_C": 0,
    "CMYK_M": 0.3617866,
    "CMYK_Y": 0.6775488,
    "CMYK_K": 0.3785879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04927",
    "Farbtonhilfsbezeichnung": "E1.05.30",
    "Farbtonklasse": "02",
    "Rcolor": "96",
    "Gcolor": "90",
    "Bcolor": "85",
    "Y": 10,
    "L": 38.5563916052335,
    "a": 1.84107516074128,
    "b": 3.18153000830523,
    "C": 3.67582520548043,
    "h": 1.04620379993725,
    "CMY_C": 0.6233671,
    "CMY_M": 0.6483233,
    "CMY_Y": 0.6667026,
    "CMYK_C": 0,
    "CMYK_M": 0.06626119,
    "CMYK_Y": 0.1150604,
    "CMYK_K": 0.6233671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04928",
    "Farbtonhilfsbezeichnung": "E3.06.25",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "86",
    "Bcolor": "82",
    "Y": 8,
    "L": 36.9297714233398,
    "a": 1.40696740150452,
    "b": 2.54239916801453,
    "C": 2.9057445526123,
    "h": 61.039794921875,
    "CMY_C": 0.64318591356277,
    "CMY_M": 0.66250669956207,
    "CMY_Y": 0.67778635025024,
    "CMYK_C": 0,
    "CMYK_M": 0.05414804816246,
    "CMYK_Y": 0.09697049111128,
    "CMYK_K": 0.64318591356277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04929",
    "Farbtonhilfsbezeichnung": "E2.16.24",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "80",
    "Bcolor": "69",
    "Y": 9,
    "L": 35.2131888802905,
    "a": 4.12969891850648,
    "b": 8.49471444091713,
    "C": 9.44534735148685,
    "h": 1.11829060151787,
    "CMY_C": 0.6293184000000001,
    "CMY_M": 0.6854169,
    "CMY_Y": 0.7298807,
    "CMYK_C": 0,
    "CMYK_M": 0.1513387,
    "CMYK_Y": 0.2712902,
    "CMYK_K": 0.6293184000000001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04930",
    "Farbtonhilfsbezeichnung": "E2.19.25",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "77",
    "Bcolor": "63",
    "Y": 8,
    "L": 34.0265129109752,
    "a": 5.34879429393664,
    "b": 10.6291660247539,
    "C": 11.8991079825604,
    "h": 1.10457713560182,
    "CMY_C": 0.6296731,
    "CMY_M": 0.6993681,
    "CMY_Y": 0.7534353,
    "CMYK_C": 0,
    "CMYK_M": 0.1881984,
    "CMYK_Y": 0.3341972,
    "CMYK_K": 0.6296731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04931",
    "Farbtonhilfsbezeichnung": "E3.22.28",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "85",
    "Bcolor": "68",
    "Y": 10,
    "L": 37.6731092939186,
    "a": 6.11510817405278,
    "b": 12.8781638388465,
    "C": 14.256284643642,
    "h": 1.1274759552636,
    "CMY_C": 0.585789,
    "CMY_M": 0.6677927,
    "CMY_Y": 0.7349259,
    "CMYK_C": 0,
    "CMYK_M": 0.1979756,
    "CMYK_Y": 0.3600505,
    "CMYK_K": 0.585789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04932",
    "Farbtonhilfsbezeichnung": "E3.33.35",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "95",
    "Bcolor": "65",
    "Y": 14,
    "L": 43.5763999869327,
    "a": 11.731325869888,
    "b": 22.9197550030852,
    "C": 25.7476052491673,
    "h": 1.09771893209236,
    "CMY_C": 0.4793188,
    "CMY_M": 0.6271463,
    "CMY_Y": 0.7457727,
    "CMYK_C": 0,
    "CMYK_M": 0.2839117,
    "CMYK_Y": 0.511741,
    "CMYK_K": 0.4793188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04933",
    "Farbtonhilfsbezeichnung": "E3.39.31",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "84",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.3315317466076,
    "a": 12.2337870342563,
    "b": 24.0908873805167,
    "C": 27.0191857756721,
    "h": 1.10091387041754,
    "CMY_C": 0.5195904,
    "CMY_M": 0.6686374,
    "CMY_Y": 0.7911597,
    "CMYK_C": 0,
    "CMYK_M": 0.3102499,
    "CMYK_Y": 0.565287,
    "CMYK_K": 0.5195904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04934",
    "Farbtonhilfsbezeichnung": "E2.54.39",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "98",
    "Bcolor": "43",
    "Y": 16,
    "L": 47.2650964666492,
    "a": 20.086540516707,
    "b": 40.09869507746,
    "C": 44.8483495442634,
    "h": 1.10640696443627,
    "CMY_C": 0.3774097,
    "CMY_M": 0.6164098,
    "CMY_Y": 0.8318226,
    "CMYK_C": 0,
    "CMYK_M": 0.3838802,
    "CMYK_Y": 0.7298747,
    "CMYK_K": 0.3774097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04935",
    "Farbtonhilfsbezeichnung": "E2.04.21",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "80",
    "Bcolor": "77",
    "Y": 6,
    "L": 34.2915077209473,
    "a": 1.26720499992371,
    "b": 2.07288813591003,
    "C": 2.42954182624817,
    "h": 58.5615768432617,
    "CMY_C": 0.6700040102005,
    "CMY_M": 0.68658858537674,
    "CMY_Y": 0.69904744625092,
    "CMYK_C": 0,
    "CMYK_M": 0.05025690048933,
    "CMYK_Y": 0.08801148086786,
    "CMYK_K": 0.6700040102005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04936",
    "Farbtonhilfsbezeichnung": "E2.07.14",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "57",
    "Bcolor": "53",
    "Y": 4,
    "L": 24.3554858511612,
    "a": 1.47298030503829,
    "b": 2.6872956987213,
    "C": 3.06451124184538,
    "h": 1.06939197776945,
    "CMY_C": 0.7574663,
    "CMY_M": 0.7763062,
    "CMY_Y": 0.7905548,
    "CMYK_C": 0,
    "CMYK_M": 0.0776799,
    "CMYK_Y": 0.1364285,
    "CMYK_K": 0.7574663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04937",
    "Farbtonhilfsbezeichnung": "E2.14.22",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "70",
    "Bcolor": "59",
    "Y": 7,
    "L": 30.6934672146882,
    "a": 3.69128434698818,
    "b": 8.09070483564244,
    "C": 8.89297952700937,
    "h": 1.14276727304791,
    "CMY_C": 0.6754974,
    "CMY_M": 0.7256424,
    "CMY_Y": 0.7674432,
    "CMYK_C": 0,
    "CMYK_M": 0.154529,
    "CMYK_Y": 0.283344,
    "CMYK_K": 0.6754974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04938",
    "Farbtonhilfsbezeichnung": "E2.20.16",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "60",
    "Bcolor": "50",
    "Y": 5,
    "L": 26.8110996043633,
    "a": 4.87377746194181,
    "b": 8.50798033211482,
    "C": 9.80507195691009,
    "h": 1.05058101794389,
    "CMY_C": 0.7043347,
    "CMY_M": 0.7627946,
    "CMY_Y": 0.8032531,
    "CMYK_C": 0,
    "CMYK_M": 0.1977234,
    "CMYK_Y": 0.3345622,
    "CMYK_K": 0.7043347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04939",
    "Farbtonhilfsbezeichnung": "E2.23.21",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "67",
    "Bcolor": "52",
    "Y": 6,
    "L": 29.9019392811881,
    "a": 6.22145259164802,
    "b": 11.4948689581227,
    "C": 13.0705196803546,
    "h": 1.07470554913378,
    "CMY_C": 0.6629356,
    "CMY_M": 0.7387833,
    "CMY_Y": 0.7945216,
    "CMYK_C": 0,
    "CMYK_M": 0.2250245,
    "CMYK_Y": 0.3903882,
    "CMYK_K": 0.6629356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04940",
    "Farbtonhilfsbezeichnung": "E2.43.30",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "84",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.8918627726029,
    "a": 14.6043701040681,
    "b": 25.3506575217708,
    "C": 29.2565114619415,
    "h": 1.04814001655547,
    "CMY_C": 0.4998884,
    "CMY_M": 0.6696072,
    "CMY_Y": 0.7940066,
    "CMYK_C": 0,
    "CMYK_M": 0.3393618,
    "CMYK_Y": 0.5881051,
    "CMYK_K": 0.4998884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04941",
    "Farbtonhilfsbezeichnung": "E2.53.35",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "92",
    "Bcolor": "47",
    "Y": 14,
    "L": 44.8876897486013,
    "a": 19.8408887294834,
    "b": 34.9620119966417,
    "C": 40.1995416445145,
    "h": 1.05461791098575,
    "CMY_C": 0.4094385,
    "CMY_M": 0.6378968,
    "CMY_Y": 0.8148476,
    "CMYK_C": 0,
    "CMYK_M": 0.3868493,
    "CMYK_Y": 0.6864808,
    "CMYK_K": 0.4094385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04942",
    "Farbtonhilfsbezeichnung": "E5.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "236",
    "Bcolor": "224",
    "Y": 85,
    "L": 93.7771894533985,
    "a": 1.97933291777219,
    "b": 5.73432013480848,
    "C": 6.06631570294907,
    "h": 1.23842811781679,
    "CMY_C": 0.03579165,
    "CMY_M": 0.07598168,
    "CMY_Y": 0.1197165,
    "CMYK_C": 0,
    "CMYK_M": 0.04168189,
    "CMYK_Y": 0.08704013,
    "CMYK_K": 0.03579165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04943",
    "Farbtonhilfsbezeichnung": "E3.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "232",
    "Bcolor": "212",
    "Y": 83,
    "L": 92.943229675293,
    "a": 3.68814516067505,
    "b": 11.2097978591919,
    "C": 11.8009309768677,
    "h": 71.7882308959961,
    "CMY_C": 0.01612359285355,
    "CMY_M": 0.09091997146606,
    "CMY_Y": 0.16941785812378,
    "CMYK_C": 0,
    "CMYK_M": 0.07602212578058,
    "CMYK_Y": 0.15580642223358,
    "CMYK_K": 0.01612359285355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04945",
    "Farbtonhilfsbezeichnung": "E4.12.81",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "216",
    "Bcolor": "190",
    "Y": 72,
    "L": 88.1886576151246,
    "a": 7.20018546378631,
    "b": 16.1297519997481,
    "C": 17.6638492488557,
    "h": 1.15094721508361,
    "CMY_C": 0.03194745,
    "CMY_M": 0.1537132,
    "CMY_Y": 0.2567631,
    "CMYK_C": 0,
    "CMYK_M": 0.1257843,
    "CMYK_Y": 0.2322349,
    "CMYK_K": 0.03194745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04946",
    "Farbtonhilfsbezeichnung": "E4.14.82",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "216",
    "Bcolor": "184",
    "Y": 73,
    "L": 88.656387491137,
    "a": 7.92918326087333,
    "b": 19.9792565533396,
    "C": 21.4951771243848,
    "h": 1.1929904549697,
    "CMY_C": 0.01231796,
    "CMY_M": 0.1513212,
    "CMY_Y": 0.2801253,
    "CMYK_C": 0,
    "CMYK_M": 0.1407368,
    "CMYK_Y": 0.2711473,
    "CMYK_K": 0.01231796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04947",
    "Farbtonhilfsbezeichnung": "E4.19.80",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "212",
    "Bcolor": "172",
    "Y": 71,
    "L": 87.6233054834061,
    "a": 10.3369260988069,
    "b": 24.7513112894501,
    "C": 26.8231141316488,
    "h": 1.17518342225665,
    "CMY_C": 0,
    "CMY_M": 0.1699577,
    "CMY_Y": 0.3260467,
    "CMYK_C": 0,
    "CMYK_M": 0.1699577,
    "CMYK_Y": 0.3260467,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04948",
    "Farbtonhilfsbezeichnung": "E4.30.74",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "188",
    "Bcolor": "132",
    "Y": 58,
    "L": 80.6530209750995,
    "a": 15.544853529375,
    "b": 36.3266221740472,
    "C": 39.5128580316041,
    "h": 1.16645582089944,
    "CMY_C": 0.02388982,
    "CMY_M": 0.2618887,
    "CMY_Y": 0.483272,
    "CMYK_C": 0,
    "CMYK_M": 0.2438238,
    "CMYK_Y": 0.4706253,
    "CMYK_K": 0.02388982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04949",
    "Farbtonhilfsbezeichnung": "E4.14.81",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "214",
    "Bcolor": "183",
    "Y": 72,
    "L": 87.9726123312845,
    "a": 8.06257921031844,
    "b": 19.5205585519013,
    "C": 21.1200707787845,
    "h": 1.17910777392048,
    "CMY_C": 0.02030024,
    "CMY_M": 0.1590877,
    "CMY_Y": 0.283986,
    "CMYK_C": 0,
    "CMYK_M": 0.1416632,
    "CMYK_Y": 0.2691495,
    "CMYK_K": 0.02030024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04950",
    "Farbtonhilfsbezeichnung": "E4.18.80",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "209",
    "Bcolor": "172",
    "Y": 69,
    "L": 86.7013003782672,
    "a": 9.96136458342262,
    "b": 23.5823892301888,
    "C": 25.5999583235596,
    "h": 1.17112408346189,
    "CMY_C": 0.01294704,
    "CMY_M": 0.1788467,
    "CMY_Y": 0.3271695,
    "CMYK_C": 0,
    "CMYK_M": 0.1680757,
    "CMYK_Y": 0.3183441,
    "CMYK_K": 0.01294704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04951",
    "Farbtonhilfsbezeichnung": "E3.21.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "165",
    "Y": 70,
    "L": 86.8750852915783,
    "a": 12.2745182589734,
    "b": 27.1552213345972,
    "C": 29.8005007377533,
    "h": 1.1462694909028,
    "CMY_C": 0,
    "CMY_M": 0.1837536,
    "CMY_Y": 0.3514026,
    "CMYK_C": 0,
    "CMYK_M": 0.1837536,
    "CMYK_Y": 0.3514026,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04952",
    "Farbtonhilfsbezeichnung": "E4.49.68",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "166",
    "Bcolor": "80",
    "Y": 48,
    "L": 75.0529808773898,
    "a": 24.6245924989907,
    "b": 55.6433797831874,
    "C": 60.8486340802928,
    "h": 1.15416085697672,
    "CMY_C": 0.01309981,
    "CMY_M": 0.3503234,
    "CMY_Y": 0.6875281,
    "CMYK_C": 0,
    "CMYK_M": 0.3416998,
    "CMYK_Y": 0.6833804,
    "CMYK_K": 0.01309981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04953",
    "Farbtonhilfsbezeichnung": "E4.12.80",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "214",
    "Bcolor": "188",
    "Y": 71,
    "L": 87.4342177501894,
    "a": 7.05497147671774,
    "b": 16.0010888568601,
    "C": 17.4873516331785,
    "h": 1.15553089856833,
    "CMY_C": 0.04188301,
    "CMY_M": 0.1616271,
    "CMY_Y": 0.2639101,
    "CMYK_C": 0,
    "CMYK_M": 0.1249786,
    "CMYK_Y": 0.2317328,
    "CMYK_K": 0.04188301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04954",
    "Farbtonhilfsbezeichnung": "E4.17.79",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "211",
    "Bcolor": "176",
    "Y": 71,
    "L": 87.3212111580484,
    "a": 9.89843127135603,
    "b": 22.1579264753259,
    "C": 24.2683466128146,
    "h": 1.15067180319495,
    "CMY_C": 0.009273978,
    "CMY_M": 0.171558,
    "CMY_Y": 0.3100852,
    "CMYK_C": 0,
    "CMYK_M": 0.1638031,
    "CMYK_Y": 0.303627,
    "CMYK_K": 0.009273978
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04955",
    "Farbtonhilfsbezeichnung": "E4.34.74",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "191",
    "Bcolor": "126",
    "Y": 61,
    "L": 82.6343765258789,
    "a": 18.3442401885986,
    "b": 41.9015274047852,
    "C": 45.7411117553711,
    "h": 66.3564834594727,
    "CMY_C": 0,
    "CMY_M": 0.24914360046387,
    "CMY_Y": 0.50453752279282,
    "CMYK_C": 0,
    "CMYK_M": 0.24914360046387,
    "CMYK_Y": 0.50453752279282,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04956",
    "Farbtonhilfsbezeichnung": "E4.51.67",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "165",
    "Bcolor": "81",
    "Y": 48,
    "L": 74.9492694831379,
    "a": 24.5796473893568,
    "b": 54.88824344207,
    "C": 60.1404883081361,
    "h": 1.14976292671409,
    "CMY_C": 0.01532218,
    "CMY_M": 0.351184,
    "CMY_Y": 0.682269,
    "CMYK_C": 0,
    "CMYK_M": 0.341088,
    "CMYK_Y": 0.677325,
    "CMYK_K": 0.01532218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04957",
    "Farbtonhilfsbezeichnung": "E5.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "215",
    "Bcolor": "202",
    "Y": 70,
    "L": 86.9093717368746,
    "a": 2.90762554017859,
    "b": 7.32403453435544,
    "C": 7.88008681058337,
    "h": 1.1928807361556,
    "CMY_C": 0.1011224,
    "CMY_M": 0.1549847,
    "CMY_Y": 0.2064151,
    "CMYK_C": 0,
    "CMYK_M": 0.05992167,
    "CMYK_Y": 0.117138,
    "CMYK_K": 0.1011224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04958",
    "Farbtonhilfsbezeichnung": "E4.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "214",
    "Bcolor": "199",
    "Y": 69,
    "L": 86.4460316863926,
    "a": 3.60004960246924,
    "b": 8.45232474682052,
    "C": 9.1870643170685,
    "h": 1.16814313949751,
    "CMY_C": 0.09790508,
    "CMY_M": 0.1620603,
    "CMY_Y": 0.2195941,
    "CMYK_C": 0,
    "CMYK_M": 0.07111806,
    "CMYK_Y": 0.134896,
    "CMYK_K": 0.09790508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04959",
    "Farbtonhilfsbezeichnung": "E5.13.79",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "210",
    "Bcolor": "178",
    "Y": 68,
    "L": 86.142922948129,
    "a": 7.58257396953649,
    "b": 19.1696775803001,
    "C": 20.6148482055084,
    "h": 1.19413167232964,
    "CMY_C": 0.04536319,
    "CMY_M": 0.1778973,
    "CMY_Y": 0.3009149,
    "CMYK_C": 0,
    "CMYK_M": 0.138832,
    "CMYK_Y": 0.2676953,
    "CMYK_K": 0.04536319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04960",
    "Farbtonhilfsbezeichnung": "E5.15.77",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "203",
    "Bcolor": "172",
    "Y": 64,
    "L": 83.9470019852222,
    "a": 7.82719587428116,
    "b": 19.3636698877884,
    "C": 20.8858015593754,
    "h": 1.18665673337196,
    "CMY_C": 0.06824166,
    "CMY_M": 0.2025679,
    "CMY_Y": 0.325495,
    "CMYK_C": 0,
    "CMYK_M": 0.1441643,
    "CMYK_Y": 0.2760945,
    "CMYK_K": 0.06824166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04962",
    "Farbtonhilfsbezeichnung": "E4.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "204",
    "Bcolor": "194",
    "Y": 61,
    "L": 82.9087524414063,
    "a": 2.93088746070862,
    "b": 5.88836336135864,
    "C": 6.57745599746704,
    "h": 63.5385322570801,
    "CMY_C": 0.14960867166519,
    "CMY_M": 0.19849365949631,
    "CMY_Y": 0.23906749486923,
    "CMYK_C": 0,
    "CMYK_M": 0.0574852861464,
    "CMYK_Y": 0.10519724339247,
    "CMYK_K": 0.14960867166519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04963",
    "Farbtonhilfsbezeichnung": "E5.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "209",
    "Bcolor": "195",
    "Y": 65,
    "L": 84.6772766113281,
    "a": 3.55088949203491,
    "b": 7.88544321060181,
    "C": 8.6480655670166,
    "h": 65.7575073242188,
    "CMY_C": 0.11961126327515,
    "CMY_M": 0.18117600679398,
    "CMY_Y": 0.23450917005539,
    "CMYK_C": 0,
    "CMYK_M": 0.069929048419,
    "CMYK_Y": 0.13050815463066,
    "CMYK_K": 0.11961126327515
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04964",
    "Farbtonhilfsbezeichnung": "E4.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "193",
    "Bcolor": "179",
    "Y": 55,
    "L": 78.9108851240996,
    "a": 3.77937172593068,
    "b": 8.13153914499931,
    "C": 8.96691583039678,
    "h": 1.13572006622209,
    "CMY_C": 0.1810359,
    "CMY_M": 0.2445254,
    "CMY_Y": 0.2977796,
    "CMYK_C": 0,
    "CMYK_M": 0.07752418,
    "CMYK_Y": 0.1425504,
    "CMYK_K": 0.1810359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04965",
    "Farbtonhilfsbezeichnung": "E4.18.69",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "183",
    "Bcolor": "149",
    "Y": 51,
    "L": 76.8724438866533,
    "a": 9.63438702703406,
    "b": 21.7179626063239,
    "C": 23.7590259302936,
    "h": 1.15326587628836,
    "CMY_C": 0.1311566,
    "CMY_M": 0.2840392,
    "CMY_Y": 0.4158891,
    "CMYK_C": 0,
    "CMYK_M": 0.175961,
    "CMYK_Y": 0.3277144,
    "CMYK_K": 0.1311566
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04966",
    "Farbtonhilfsbezeichnung": "E4.45.65",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "159",
    "Bcolor": "84",
    "Y": 43,
    "L": 71.6129320025762,
    "a": 21.8029506860431,
    "b": 49.3078186597144,
    "C": 53.9131675900916,
    "h": 1.15446418365969,
    "CMY_C": 0.07695965,
    "CMY_M": 0.3773684,
    "CMY_Y": 0.6710927,
    "CMYK_C": 0,
    "CMYK_M": 0.3254557,
    "CMYK_Y": 0.6436697,
    "CMYK_K": 0.07695965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04967",
    "Farbtonhilfsbezeichnung": "E5.79.65",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "150",
    "Bcolor": "0",
    "Y": 45,
    "L": 72.6728211037408,
    "a": 35.4280778096016,
    "b": 80.6226388275523,
    "C": 88.0633782499918,
    "h": 1.15676635479246,
    "CMY_C": 0,
    "CMY_M": 0.4121554,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.4121554,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04968",
    "Farbtonhilfsbezeichnung": "E4.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "189",
    "Bcolor": "179",
    "Y": 52,
    "L": 77.2772068327555,
    "a": 2.69035391921524,
    "b": 5.99981171894819,
    "C": 6.57538933246274,
    "h": 1.14926843730095,
    "CMY_C": 0.2128289,
    "CMY_M": 0.2589858,
    "CMY_Y": 0.2999275,
    "CMYK_C": 0,
    "CMYK_M": 0.0586363,
    "CMYK_Y": 0.1106475,
    "CMYK_K": 0.2128289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04969",
    "Farbtonhilfsbezeichnung": "E3.07.66",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "178",
    "Bcolor": "166",
    "Y": 46,
    "L": 73.6407070880842,
    "a": 3.50966065076025,
    "b": 7.60785722061839,
    "C": 8.37837749046975,
    "h": 1.13856823482081,
    "CMY_C": 0.2418925,
    "CMY_M": 0.3002248,
    "CMY_Y": 0.3494652,
    "CMYK_C": 0,
    "CMYK_M": 0.07694462,
    "CMYK_Y": 0.1418964,
    "CMYK_K": 0.2418925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04970",
    "Farbtonhilfsbezeichnung": "E4.15.72",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "191",
    "Bcolor": "162",
    "Y": 56,
    "L": 79.6655751578837,
    "a": 8.07540586483846,
    "b": 18.7022271606997,
    "C": 20.3711924209724,
    "h": 1.16318987227568,
    "CMY_C": 0.1164725,
    "CMY_M": 0.2494588,
    "CMY_Y": 0.3654605,
    "CMYK_C": 0,
    "CMYK_M": 0.1505174,
    "CMYK_Y": 0.2818112,
    "CMYK_K": 0.1164725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04971",
    "Farbtonhilfsbezeichnung": "E4.28.63",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "164",
    "Bcolor": "117",
    "Y": 42,
    "L": 70.9979128353316,
    "a": 13.5199954107519,
    "b": 30.9810756097612,
    "C": 33.8026230024313,
    "h": 1.15931349497711,
    "CMY_C": 0.1565109,
    "CMY_M": 0.3581011,
    "CMY_Y": 0.5413734,
    "CMYK_C": 0,
    "CMYK_M": 0.2389956,
    "CMYK_Y": 0.4562744,
    "CMYK_K": 0.1565109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04972",
    "Farbtonhilfsbezeichnung": "E4.35.65",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "163",
    "Bcolor": "103",
    "Y": 43,
    "L": 71.5669867490585,
    "a": 16.6544132982698,
    "b": 39.146333876585,
    "C": 42.5418022453992,
    "h": 1.16855311902383,
    "CMY_C": 0.1193479,
    "CMY_M": 0.3619162,
    "CMY_Y": 0.5950161,
    "CMYK_C": 0,
    "CMYK_M": 0.2754417,
    "CMYK_Y": 0.5401317,
    "CMYK_K": 0.1193479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04973",
    "Farbtonhilfsbezeichnung": "E4.52.59",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "146",
    "Bcolor": "69",
    "Y": 37,
    "L": 67.4265768420529,
    "a": 23.8415531896161,
    "b": 51.4881634687954,
    "C": 56.7402029947258,
    "h": 1.1371438247341,
    "CMY_C": 0.1133999,
    "CMY_M": 0.4271204,
    "CMY_Y": 0.7292185,
    "CMYK_C": 0,
    "CMYK_M": 0.3538467,
    "CMYK_Y": 0.6945845,
    "CMYK_K": 0.1133999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04974",
    "Farbtonhilfsbezeichnung": "E4.77.62",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "138",
    "Bcolor": "0",
    "Y": 39,
    "L": 68.6232216129068,
    "a": 37.0857961499391,
    "b": 76.8549975457497,
    "C": 85.3349103464228,
    "h": 1.12121206961138,
    "CMY_C": 0.01058609,
    "CMY_M": 0.459823,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.4540434,
    "CMYK_Y": 1,
    "CMYK_K": 0.01058609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04975",
    "Farbtonhilfsbezeichnung": "E4.06.61",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "166",
    "Bcolor": "155",
    "Y": 39,
    "L": 68.9726875355172,
    "a": 2.99378566158026,
    "b": 6.50667454793765,
    "C": 7.16237155279333,
    "h": 1.13956684708229,
    "CMY_C": 0.2987353,
    "CMY_M": 0.3480817,
    "CMY_Y": 0.3902044,
    "CMYK_C": 0,
    "CMYK_M": 0.07036773,
    "CMYK_Y": 0.1304344,
    "CMYK_K": 0.2987353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04976",
    "Farbtonhilfsbezeichnung": "E5.12.68",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "184",
    "Bcolor": "160",
    "Y": 50,
    "L": 76.2572699632267,
    "a": 6.13931863640466,
    "b": 14.8151069289023,
    "C": 16.0367897858054,
    "h": 1.1779416739766,
    "CMY_C": 0.1765817,
    "CMY_M": 0.2803764,
    "CMY_Y": 0.3731984,
    "CMYK_C": 0,
    "CMYK_M": 0.1260535,
    "CMYK_Y": 0.238781,
    "CMYK_K": 0.1765817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04977",
    "Farbtonhilfsbezeichnung": "E4.41.60",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "150",
    "Bcolor": "88",
    "Y": 37,
    "L": 67.4662559566827,
    "a": 19.7860998716953,
    "b": 41.8993098057151,
    "C": 46.3361835969256,
    "h": 1.12961070530262,
    "CMY_C": 0.1455104,
    "CMY_M": 0.4136949,
    "CMY_Y": 0.6548914,
    "CMYK_C": 0,
    "CMYK_M": 0.3138534,
    "CMYK_Y": 0.5961231,
    "CMYK_K": 0.1455104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04978",
    "Farbtonhilfsbezeichnung": "E4.54.55",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "133",
    "Bcolor": "54",
    "Y": 31,
    "L": 62.262391144562,
    "a": 23.1560573727199,
    "b": 52.2155899727966,
    "C": 57.119793673086,
    "h": 1.15338584772291,
    "CMY_C": 0.178128,
    "CMY_M": 0.4781056,
    "CMY_Y": 0.7867349,
    "CMYK_C": 0,
    "CMYK_M": 0.3649931,
    "CMYK_Y": 0.740513,
    "CMYK_K": 0.178128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04979",
    "Farbtonhilfsbezeichnung": "E4.71.57",
    "Farbtonklasse": "04",
    "Rcolor": "232",
    "Gcolor": "130",
    "Bcolor": "24",
    "Y": 33,
    "L": 64.3386287737097,
    "a": 33.5128005959144,
    "b": 66.2368885973739,
    "C": 74.232292264502,
    "h": 1.10239708866179,
    "CMY_C": 0.08834273,
    "CMY_M": 0.490914,
    "CMY_Y": 0.9074222,
    "CMYK_C": 0,
    "CMYK_M": 0.4415818,
    "CMYK_Y": 0.8984511,
    "CMYK_K": 0.08834273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04980",
    "Farbtonhilfsbezeichnung": "E4.03.61",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "165",
    "Bcolor": "160",
    "Y": 38,
    "L": 68.1397988131307,
    "a": 1.04500126047313,
    "b": 2.72795818941622,
    "C": 2.92126402736786,
    "h": 1.20496868607714,
    "CMY_C": 0.3324488,
    "CMY_M": 0.3513905,
    "CMY_Y": 0.3726969,
    "CMYK_C": 0,
    "CMYK_M": 0.02837486,
    "CMYK_Y": 0.06029219,
    "CMYK_K": 0.3324488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04981",
    "Farbtonhilfsbezeichnung": "E4.28.55",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "144",
    "Bcolor": "104",
    "Y": 32,
    "L": 63.587272644043,
    "a": 13.2118110656738,
    "b": 28.1256198883057,
    "C": 31.0741443634033,
    "h": 64.8385391235352,
    "CMY_C": 0.24641627073288,
    "CMY_M": 0.43358153104782,
    "CMY_Y": 0.59374219179153,
    "CMYK_C": 0,
    "CMYK_M": 0.24836690723896,
    "CMYK_Y": 0.46089890599251,
    "CMYK_K": 0.24641627073288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04982",
    "Farbtonhilfsbezeichnung": "E4.41.51",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "128",
    "Bcolor": "74",
    "Y": 26,
    "L": 58.3117706770221,
    "a": 17.0024204684242,
    "b": 37.2683470952745,
    "C": 40.9635447318582,
    "h": 1.14278511818702,
    "CMY_C": 0.2719106,
    "CMY_M": 0.4987069,
    "CMY_Y": 0.7088968,
    "CMYK_C": 0,
    "CMYK_M": 0.3114951,
    "CMYK_Y": 0.6001821,
    "CMYK_K": 0.2719106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04983",
    "Farbtonhilfsbezeichnung": "E4.52.49",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "121",
    "Bcolor": "58",
    "Y": 25,
    "L": 56.8858969347442,
    "a": 21.1685279889054,
    "b": 43.8721097444862,
    "C": 48.7120990170749,
    "h": 1.12124212896875,
    "CMY_C": 0.2588089,
    "CMY_M": 0.5254927,
    "CMY_Y": 0.7709001,
    "CMYK_C": 0,
    "CMYK_M": 0.3598043,
    "CMYK_Y": 0.6909031,
    "CMYK_K": 0.2588089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04984",
    "Farbtonhilfsbezeichnung": "E3.62.55",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "132",
    "Bcolor": "41",
    "Y": 32,
    "L": 63.1881817458301,
    "a": 28.013426789603,
    "b": 59.2657148050237,
    "C": 65.5528567786855,
    "h": 1.12924662072209,
    "CMY_C": 0.1357561,
    "CMY_M": 0.4841703,
    "CMY_Y": 0.8408049,
    "CMYK_C": 0,
    "CMYK_M": 0.4031434,
    "CMYK_Y": 0.8157984,
    "CMYK_K": 0.1357561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04985",
    "Farbtonhilfsbezeichnung": "E4.21.52",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "134",
    "Bcolor": "104",
    "Y": 26,
    "L": 58.3366500170993,
    "a": 8.88443849262327,
    "b": 20.5796420570564,
    "C": 22.4155061179928,
    "h": 1.16325595475092,
    "CMY_C": 0.3424647,
    "CMY_M": 0.4747866,
    "CMY_Y": 0.5928219,
    "CMYK_C": 0,
    "CMYK_M": 0.2012394,
    "CMYK_Y": 0.380751,
    "CMYK_K": 0.3424647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04986",
    "Farbtonhilfsbezeichnung": "E3.44.45",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "114",
    "Bcolor": "62",
    "Y": 21,
    "L": 52.7748812789226,
    "a": 16.9519364826735,
    "b": 36.8952846690147,
    "C": 40.6033272198255,
    "h": 1.14010272034009,
    "CMY_C": 0.3349991,
    "CMY_M": 0.5536211,
    "CMY_Y": 0.7579444,
    "CMYK_C": 0,
    "CMYK_M": 0.3287544,
    "CMYK_Y": 0.6360072,
    "CMYK_K": 0.3349991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04987",
    "Farbtonhilfsbezeichnung": "E4.59.49",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "117",
    "Bcolor": "45",
    "Y": 24,
    "L": 56.1755249862433,
    "a": 24.2529191971643,
    "b": 49.7534343150788,
    "C": 55.3498718673227,
    "h": 1.11722916221035,
    "CMY_C": 0.2459427,
    "CMY_M": 0.5423179,
    "CMY_Y": 0.8249343,
    "CMYK_C": 0,
    "CMYK_M": 0.3930406,
    "CMYK_Y": 0.767835,
    "CMYK_K": 0.2459427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04988",
    "Farbtonhilfsbezeichnung": "E5.14.46",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "122",
    "Bcolor": "102",
    "Y": 21,
    "L": 52.6944445239409,
    "a": 4.92705143219074,
    "b": 13.2803331544485,
    "C": 14.1648538470609,
    "h": 1.2155339432856,
    "CMY_C": 0.4403671,
    "CMY_M": 0.5205036,
    "CMY_Y": 0.5983551,
    "CMYK_C": 0,
    "CMYK_M": 0.1431947,
    "CMYK_Y": 0.2823063,
    "CMYK_K": 0.4403671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04989",
    "Farbtonhilfsbezeichnung": "E4.16.44",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "120",
    "Bcolor": "101",
    "Y": 20,
    "L": 51.8487964618799,
    "a": 5.64463603146648,
    "b": 12.6558612142239,
    "C": 13.8575877771503,
    "h": 1.15126574257592,
    "CMY_C": 0.4459193,
    "CMY_M": 0.5303926,
    "CMY_Y": 0.6021778,
    "CMYK_C": 0,
    "CMYK_M": 0.1524567,
    "CMYK_Y": 0.282014,
    "CMYK_K": 0.4459193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04990",
    "Farbtonhilfsbezeichnung": "E4.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "107",
    "Bcolor": "73",
    "Y": 17,
    "L": 48.2847553742211,
    "a": 10.8574068746073,
    "b": 24.4849831450474,
    "C": 26.7842805326935,
    "h": 1.15341837830356,
    "CMY_C": 0.4323026,
    "CMY_M": 0.5799469,
    "CMY_Y": 0.713671,
    "CMYK_C": 0,
    "CMYK_M": 0.2600758,
    "CMYK_Y": 0.4956309,
    "CMYK_K": 0.4323026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04991",
    "Farbtonhilfsbezeichnung": "E4.34.45",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "119",
    "Bcolor": "82",
    "Y": 21,
    "L": 53.6829032897949,
    "a": 12.8157405853272,
    "b": 26.6736869812012,
    "C": 29.5927143096924,
    "h": 64.33740234375,
    "CMY_C": 0.36009019613266,
    "CMY_M": 0.53219485282898,
    "CMY_Y": 0.67814886569977,
    "CMYK_C": 0,
    "CMYK_M": 0.26895141601563,
    "CMYK_Y": 0.49703672528267,
    "CMYK_K": 0.36009019613266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04992",
    "Farbtonhilfsbezeichnung": "E4.39.39",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "102",
    "Bcolor": "61",
    "Y": 16,
    "L": 47.0131252021873,
    "a": 14.1498925041497,
    "b": 30.0066368949587,
    "C": 33.1755590099834,
    "h": 1.13015947508528,
    "CMY_C": 0.4209696,
    "CMY_M": 0.601418,
    "CMY_Y": 0.7622771,
    "CMYK_C": 0,
    "CMYK_M": 0.3116389,
    "CMYK_Y": 0.5894466,
    "CMYK_K": 0.4209696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04993",
    "Farbtonhilfsbezeichnung": "E4.44.49",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "125",
    "Bcolor": "73",
    "Y": 25,
    "L": 57.0906917143178,
    "a": 16.869681602202,
    "b": 36.5491936063902,
    "C": 40.2545613643606,
    "h": 1.13836998776625,
    "CMY_C": 0.2872622,
    "CMY_M": 0.5104887,
    "CMY_Y": 0.7151662,
    "CMYK_C": 0,
    "CMYK_M": 0.3131958,
    "CMYK_Y": 0.6003667,
    "CMYK_K": 0.2872622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04994",
    "Farbtonhilfsbezeichnung": "E4.06.35",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "108",
    "Bcolor": "103",
    "Y": 14,
    "L": 46.000659942627,
    "a": 1.61157155036926,
    "b": 3.10547089576721,
    "C": 3.49873018264771,
    "h": 62.5731239318848,
    "CMY_C": 0.55305230617523,
    "CMY_M": 0.57665085792542,
    "CMY_Y": 0.59614545106888,
    "CMYK_C": 0,
    "CMYK_M": 0.05279935896397,
    "CMYK_Y": 0.09641652554274,
    "CMYK_K": 0.55305230617523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04995",
    "Farbtonhilfsbezeichnung": "E5.17.29",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "86",
    "Bcolor": "70",
    "Y": 10,
    "L": 37.6933418065965,
    "a": 4.32796992184398,
    "b": 11.1640095903487,
    "C": 11.9735723064499,
    "h": 1.20096281356572,
    "CMY_C": 0.5989856,
    "CMY_M": 0.663359,
    "CMY_Y": 0.7242456,
    "CMYK_C": 0,
    "CMYK_M": 0.1605264,
    "CMYK_Y": 0.3123578,
    "CMYK_K": 0.5989856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04996",
    "Farbtonhilfsbezeichnung": "E4.18.35",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "99",
    "Bcolor": "82",
    "Y": 13,
    "L": 43.3787085534344,
    "a": 5.34326222860287,
    "b": 12.4110715064238,
    "C": 13.5124071571715,
    "h": 1.16425625172579,
    "CMY_C": 0.534403,
    "CMY_M": 0.6121044,
    "CMY_Y": 0.6802317,
    "CMYK_C": 0,
    "CMYK_M": 0.1668855,
    "CMYK_Y": 0.313208,
    "CMYK_K": 0.534403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04998",
    "Farbtonhilfsbezeichnung": "E5.31.30",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "91",
    "Bcolor": "69",
    "Y": 11,
    "L": 41.2412872314453,
    "a": 9.04850578308105,
    "b": 17.3702030181885,
    "C": 19.585693359375,
    "h": 62.4840393066406,
    "CMY_C": 0.52614784240723,
    "CMY_M": 0.64183562994003,
    "CMY_Y": 0.73102957010269,
    "CMYK_C": 0,
    "CMYK_M": 0.24414321780205,
    "CMYK_Y": 0.43237480521202,
    "CMYK_K": 0.52614784240723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI04999",
    "Farbtonhilfsbezeichnung": "E5.38.29",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "83",
    "Bcolor": "51",
    "Y": 10,
    "L": 38.311078741938,
    "a": 10.6205959294744,
    "b": 23.9618318345212,
    "C": 26.2100446921221,
    "h": 1.15358681487042,
    "CMY_C": 0.53884,
    "CMY_M": 0.6741762,
    "CMY_Y": 0.7996458,
    "CMYK_C": 0,
    "CMYK_M": 0.2934691,
    "CMYK_Y": 0.5655431,
    "CMYK_K": 0.53884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05000",
    "Farbtonhilfsbezeichnung": "E3.54.45",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "110",
    "Bcolor": "49",
    "Y": 20,
    "L": 52.1308735733497,
    "a": 20.016608810476,
    "b": 42.7029386095234,
    "C": 47.1614842234673,
    "h": 1.13246732491459,
    "CMY_C": 0.3205627,
    "CMY_M": 0.5691718,
    "CMY_Y": 0.8070294,
    "CMYK_C": 0,
    "CMYK_M": 0.3659044,
    "CMYK_Y": 0.7159847,
    "CMYK_K": 0.3205627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05001",
    "Farbtonhilfsbezeichnung": "E5.05.12",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "61",
    "Bcolor": "58",
    "Y": 5,
    "L": 25.7279217028608,
    "a": 0.72054617676958,
    "b": 1.41439790785042,
    "C": 1.58735888651209,
    "h": 1.09962790338944,
    "CMY_C": 0.7528983,
    "CMY_M": 0.7625697,
    "CMY_Y": 0.7713757,
    "CMYK_C": 0,
    "CMYK_M": 0.03913945,
    "CMYK_Y": 0.07477622,
    "CMYK_K": 0.7528983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05002",
    "Farbtonhilfsbezeichnung": "E4.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "70",
    "Bcolor": "63",
    "Y": 6,
    "L": 30.2930164713604,
    "a": 2.10731804930561,
    "b": 5.18533268949071,
    "C": 5.59718361871666,
    "h": 1.18478510437005,
    "CMY_C": 0.6944255,
    "CMY_M": 0.7254261,
    "CMY_Y": 0.7536446,
    "CMYK_C": 0,
    "CMYK_M": 0.1014503,
    "CMYK_Y": 0.1937962,
    "CMYK_K": 0.6944255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05003",
    "Farbtonhilfsbezeichnung": "E4.13.16",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "61",
    "Bcolor": "54",
    "Y": 5,
    "L": 26.6299199476331,
    "a": 2.92593980506592,
    "b": 5.88203595569715,
    "C": 6.56958680032339,
    "h": 1.109201561848,
    "CMY_C": 0.7217616,
    "CMY_M": 0.7598796,
    "CMY_Y": 0.7895504,
    "CMYK_C": 0,
    "CMYK_M": 0.1369978,
    "CMYK_Y": 0.2436358,
    "CMYK_K": 0.7217616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05004",
    "Farbtonhilfsbezeichnung": "E4.21.16",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "61",
    "Bcolor": "48",
    "Y": 5,
    "L": 26.9302362418502,
    "a": 4.66632603252218,
    "b": 9.88240502953357,
    "C": 10.9287020185173,
    "h": 1.12964706589003,
    "CMY_C": 0.70199,
    "CMY_M": 0.7615648,
    "CMY_Y": 0.8104368,
    "CMYK_C": 0,
    "CMYK_M": 0.1999086,
    "CMYK_Y": 0.363903,
    "CMYK_K": 0.70199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05005",
    "Farbtonhilfsbezeichnung": "E4.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "70",
    "Bcolor": "58",
    "Y": 7,
    "L": 30.9981611961195,
    "a": 4.4860537122394,
    "b": 9.47738191657519,
    "C": 10.4854873945718,
    "h": 1.12870070749492,
    "CMY_C": 0.6655324,
    "CMY_M": 0.7248294,
    "CMY_Y": 0.7730732,
    "CMYK_C": 0,
    "CMYK_M": 0.1772878,
    "CMYK_Y": 0.3215286,
    "CMYK_K": 0.6655324
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05006",
    "Farbtonhilfsbezeichnung": "E4.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "71",
    "Bcolor": "54",
    "Y": 7,
    "L": 32.1327567786283,
    "a": 6.75083912476579,
    "b": 13.9289520143348,
    "C": 15.4786799536042,
    "h": 1.11949392364558,
    "CMY_C": 0.6347813,
    "CMY_M": 0.7202969,
    "CMY_Y": 0.7901039,
    "CMYK_C": 0,
    "CMYK_M": 0.2341491,
    "CMYK_Y": 0.4252865,
    "CMYK_K": 0.6347813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05007",
    "Farbtonhilfsbezeichnung": "E4.36.25",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "78",
    "Bcolor": "53",
    "Y": 9,
    "L": 35.3383737048765,
    "a": 8.19915998766768,
    "b": 18.4696268630021,
    "C": 20.2077544759901,
    "h": 1.15300444691146,
    "CMY_C": 0.5888527,
    "CMY_M": 0.6950949,
    "CMY_Y": 0.7904944,
    "CMYK_C": 0,
    "CMYK_M": 0.2584043,
    "CMYK_Y": 0.4904366,
    "CMYK_K": 0.5888527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05008",
    "Farbtonhilfsbezeichnung": "E3.42.36",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "95",
    "Bcolor": "55",
    "Y": 14,
    "L": 44.2215601253369,
    "a": 13.8017788266379,
    "b": 29.7428991417222,
    "C": 32.789162052942,
    "h": 1.13633148282026,
    "CMY_C": 0.4532465,
    "CMY_M": 0.6272624,
    "CMY_Y": 0.7856829,
    "CMYK_C": 0,
    "CMYK_M": 0.3182712,
    "CMYK_Y": 0.6080187,
    "CMYK_K": 0.4532465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05009",
    "Farbtonhilfsbezeichnung": "E6.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "233",
    "Bcolor": "220",
    "Y": 82,
    "L": 92.970588684082,
    "a": 1.88975870609283,
    "b": 7.00933408737183,
    "C": 7.25961112976074,
    "h": 74.9114685058594,
    "CMY_C": 0.04164510965347,
    "CMY_M": 0.08510661125183,
    "CMY_Y": 0.13811248540878,
    "CMYK_C": 0,
    "CMYK_M": 0.04535011202097,
    "CMYK_Y": 0.10065934807062,
    "CMYK_K": 0.04164510965347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05010",
    "Farbtonhilfsbezeichnung": "E7.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "227",
    "Bcolor": "205",
    "Y": 79,
    "L": 91.2417171303843,
    "a": 3.08001060796448,
    "b": 12.1074197513147,
    "C": 12.4930411981911,
    "h": 1.32168986801378,
    "CMY_C": 0.0374567,
    "CMY_M": 0.1086706,
    "CMY_Y": 0.1947269,
    "CMYK_C": 0,
    "CMYK_M": 0.07398511,
    "CMYK_Y": 0.1633902,
    "CMYK_K": 0.0374567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05011",
    "Farbtonhilfsbezeichnung": "E7.10.83",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "223",
    "Bcolor": "196",
    "Y": 76,
    "L": 90.0291133665507,
    "a": 4.33322791805435,
    "b": 15.3407564191093,
    "C": 15.9410059814382,
    "h": 1.29550322614146,
    "CMY_C": 0.03341953,
    "CMY_M": 0.1260293,
    "CMY_Y": 0.2316404,
    "CMYK_C": 0,
    "CMYK_M": 0.09581172,
    "CMYK_Y": 0.2050744,
    "CMYK_K": 0.03341953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05012",
    "Farbtonhilfsbezeichnung": "E6.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "222",
    "Bcolor": "190",
    "Y": 77,
    "L": 90.4126488133289,
    "a": 6.93256779166779,
    "b": 19.3000646200563,
    "C": 20.5073886812636,
    "h": 1.22594984965258,
    "CMY_C": 0.0006936148,
    "CMY_M": 0.1292206,
    "CMY_Y": 0.2564884,
    "CMYK_C": 0,
    "CMYK_M": 0.1286162,
    "CMYK_Y": 0.2559723,
    "CMYK_K": 0.0006936148
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05013",
    "Farbtonhilfsbezeichnung": "E7.18.80",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "216",
    "Bcolor": "173",
    "Y": 73,
    "L": 88.6727981567383,
    "a": 8.35103225708008,
    "b": 25.3252792358398,
    "C": 26.6666374206543,
    "h": 71.7499847412109,
    "CMY_C": 0,
    "CMY_M": 0.15338402986526,
    "CMY_Y": 0.31962412595749,
    "CMYK_C": 0,
    "CMYK_M": 0.15338402986526,
    "CMYK_Y": 0.31962412595749,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05014",
    "Farbtonhilfsbezeichnung": "E6.34.74",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "190",
    "Bcolor": "122",
    "Y": 59,
    "L": 81.5317600650667,
    "a": 15.8953398229768,
    "b": 42.6722963279698,
    "C": 45.5366522923016,
    "h": 1.21422110038782,
    "CMY_C": 0.002012359,
    "CMY_M": 0.2545052,
    "CMY_Y": 0.5222991,
    "CMYK_C": 0,
    "CMYK_M": 0.253002,
    "CMYK_Y": 0.5213358,
    "CMYK_K": 0.002012359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05015",
    "Farbtonhilfsbezeichnung": "E6.57.71",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "175",
    "Bcolor": "62",
    "Y": 55,
    "L": 78.8729099025378,
    "a": 24.8263607402472,
    "b": 67.675749996811,
    "C": 72.0857498069886,
    "h": 1.21919629355107,
    "CMY_C": 0,
    "CMY_M": 0.3118773,
    "CMY_Y": 0.7575408,
    "CMYK_C": 0,
    "CMYK_M": 0.3118773,
    "CMYK_Y": 0.7575408,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05016",
    "Farbtonhilfsbezeichnung": "E6.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "229",
    "Bcolor": "217",
    "Y": 80,
    "L": 91.6294085847315,
    "a": 2.47959655650493,
    "b": 6.47091201359884,
    "C": 6.92972592320713,
    "h": 1.2048637380222,
    "CMY_C": 0.05394292,
    "CMY_M": 0.1014037,
    "CMY_Y": 0.1487501,
    "CMYK_C": 0,
    "CMYK_M": 0.05016689,
    "CMYK_Y": 0.100213,
    "CMYK_K": 0.05394292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05017",
    "Farbtonhilfsbezeichnung": "E7.11.83",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "224",
    "Bcolor": "197",
    "Y": 78,
    "L": 90.8270721435547,
    "a": 5.51286125183105,
    "b": 15.897274017334,
    "C": 16.826021194458,
    "h": 70.8744583129883,
    "CMY_C": 0.0143935084343,
    "CMY_M": 0.12019610404968,
    "CMY_Y": 0.22697150707245,
    "CMYK_C": 0,
    "CMYK_M": 0.10734770447016,
    "CMYK_Y": 0.21568243205547,
    "CMYK_K": 0.0143935084343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05018",
    "Farbtonhilfsbezeichnung": "E7.11.82",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "219",
    "Bcolor": "188",
    "Y": 74,
    "L": 88.9258167036096,
    "a": 4.8284518902979,
    "b": 18.1464740816694,
    "C": 18.7778717977735,
    "h": 1.31073977380059,
    "CMY_C": 0.03536837,
    "CMY_M": 0.1401459,
    "CMY_Y": 0.2642086,
    "CMYK_C": 0,
    "CMYK_M": 0.1086192,
    "CMYK_Y": 0.2372307,
    "CMYK_K": 0.03536837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05019",
    "Farbtonhilfsbezeichnung": "E7.19.78",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "207",
    "Bcolor": "164",
    "Y": 67,
    "L": 85.5224354476709,
    "a": 8.72758216916053,
    "b": 26.038193854571,
    "C": 27.4619414777555,
    "h": 1.24738122935611,
    "CMY_C": 0.02975828,
    "CMY_M": 0.1891352,
    "CMY_Y": 0.3579922,
    "CMYK_C": 0,
    "CMYK_M": 0.1642652,
    "CMYK_Y": 0.3383012,
    "CMYK_K": 0.02975828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05020",
    "Farbtonhilfsbezeichnung": "E7.28.78",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "144",
    "Y": 67,
    "L": 85.4308610391485,
    "a": 12.6390125022421,
    "b": 36.3333644259279,
    "C": 38.4689226199424,
    "h": 1.23602706760642,
    "CMY_C": 0,
    "CMY_M": 0.2023692,
    "CMY_Y": 0.4350853,
    "CMYK_C": 0,
    "CMYK_M": 0.2023692,
    "CMYK_Y": 0.4350853,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05021",
    "Farbtonhilfsbezeichnung": "E6.44.73",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "187",
    "Bcolor": "99",
    "Y": 59,
    "L": 81.4724642984714,
    "a": 19.4675503846913,
    "b": 54.3185183022418,
    "C": 57.7017066344789,
    "h": 1.22666126862352,
    "CMY_C": 0,
    "CMY_M": 0.2668501,
    "CMY_Y": 0.6137156,
    "CMYK_C": 0,
    "CMYK_M": 0.2668501,
    "CMYK_Y": 0.6137156,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05022",
    "Farbtonhilfsbezeichnung": "E6.62.69",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "168",
    "Bcolor": "51",
    "Y": 50,
    "L": 75.8529349286977,
    "a": 24.4048656128366,
    "b": 68.4201499642664,
    "C": 72.6423732177943,
    "h": 1.22817300554585,
    "CMY_C": 0,
    "CMY_M": 0.3427277,
    "CMY_Y": 0.799498,
    "CMYK_C": 0,
    "CMYK_M": 0.3427277,
    "CMYK_Y": 0.799498,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05023",
    "Farbtonhilfsbezeichnung": "E7.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "227",
    "Bcolor": "203",
    "Y": 79,
    "L": 91.1518584223976,
    "a": 3.0508079094696,
    "b": 13.252166670375,
    "C": 13.5987995926067,
    "h": 1.34452659116261,
    "CMY_C": 0.035548,
    "CMY_M": 0.1098897,
    "CMY_Y": 0.2042115,
    "CMYK_C": 0,
    "CMYK_M": 0.07708182,
    "CMYK_Y": 0.1748802,
    "CMYK_K": 0.035548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05024",
    "Farbtonhilfsbezeichnung": "E4.16.77",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "204",
    "Bcolor": "168",
    "Y": 65,
    "L": 84.5475603318755,
    "a": 9.47889204419539,
    "b": 22.6371003357512,
    "C": 24.5415506029342,
    "h": 1.17424617103897,
    "CMY_C": 0.04298471,
    "CMY_M": 0.2009522,
    "CMY_Y": 0.3429302,
    "CMYK_C": 0,
    "CMYK_M": 0.1650627,
    "CMYK_Y": 0.3134176,
    "CMYK_K": 0.04298471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05025",
    "Farbtonhilfsbezeichnung": "E7.48.72",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "181",
    "Bcolor": "84",
    "Y": 56,
    "L": 79.7445029856901,
    "a": 20.3760532749346,
    "b": 59.1858101118065,
    "C": 62.5950770081305,
    "h": 1.23923294369854,
    "CMY_C": 0,
    "CMY_M": 0.2886085,
    "CMY_Y": 0.671883,
    "CMYK_C": 0,
    "CMYK_M": 0.2886085,
    "CMYK_Y": 0.671883,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05026",
    "Farbtonhilfsbezeichnung": "E7.56.69",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "170",
    "Bcolor": "66",
    "Y": 50,
    "L": 76.3560091014315,
    "a": 22.9120977647608,
    "b": 63.3165190245779,
    "C": 67.3345810514307,
    "h": 1.22358978532135,
    "CMY_C": 0.00033979,
    "CMY_M": 0.3324597,
    "CMY_Y": 0.7431043,
    "CMYK_C": 0,
    "CMYK_M": 0.3322328,
    "CMYK_Y": 0.743017,
    "CMYK_K": 0.00033979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05027",
    "Farbtonhilfsbezeichnung": "E6.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "218",
    "Bcolor": "200",
    "Y": 72,
    "L": 87.9866245454771,
    "a": 3.67534433101541,
    "b": 10.2121409546948,
    "C": 10.8533855929882,
    "h": 1.2253297266293,
    "CMY_C": 0.07509981,
    "CMY_M": 0.1457217,
    "CMY_Y": 0.215877,
    "CMYK_C": 0,
    "CMYK_M": 0.07635621,
    "CMYK_Y": 0.152208,
    "CMYK_K": 0.07509981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05028",
    "Farbtonhilfsbezeichnung": "E6.11.74",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "199",
    "Bcolor": "174",
    "Y": 60,
    "L": 81.7764928649337,
    "a": 5.29294299491445,
    "b": 14.8692569626318,
    "C": 15.7832204625098,
    "h": 1.22881691729835,
    "CMY_C": 0.1208909,
    "CMY_M": 0.21884,
    "CMY_Y": 0.31599,
    "CMYK_C": 0,
    "CMYK_M": 0.1114186,
    "CMYK_Y": 0.2219283,
    "CMYK_K": 0.1208909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05029",
    "Farbtonhilfsbezeichnung": "E6.30.75",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "132",
    "Y": 62,
    "L": 83.0069197696575,
    "a": 14.3089242160289,
    "b": 39.4985707521798,
    "C": 42.0105034924007,
    "h": 1.22323763178194,
    "CMY_C": 0,
    "CMY_M": 0.2337366,
    "CMY_Y": 0.4835143,
    "CMYK_C": 0,
    "CMYK_M": 0.2337366,
    "CMYK_Y": 0.4835143,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05030",
    "Farbtonhilfsbezeichnung": "E6.35.69",
    "Farbtonklasse": "03",
    "Rcolor": "240",
    "Gcolor": "177",
    "Bcolor": "111",
    "Y": 51,
    "L": 76.7740801646139,
    "a": 16.0677017145717,
    "b": 42.2136189827881,
    "C": 45.1681377301794,
    "h": 1.20710033386687,
    "CMY_C": 0.05786263,
    "CMY_M": 0.3058397,
    "CMY_Y": 0.5666409,
    "CMYK_C": 0,
    "CMYK_M": 0.2632069,
    "CMYK_Y": 0.5400255,
    "CMYK_K": 0.05786263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05031",
    "Farbtonhilfsbezeichnung": "E7.50.68",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "171",
    "Bcolor": "76",
    "Y": 49,
    "L": 75.6938185875456,
    "a": 20.31731252298,
    "b": 58.0169999399332,
    "C": 61.4716639614273,
    "h": 1.23394704276104,
    "CMY_C": 0.02799856,
    "CMY_M": 0.3313602,
    "CMY_Y": 0.7032166,
    "CMYK_C": 0,
    "CMYK_M": 0.3121,
    "CMYK_Y": 0.6946677,
    "CMYK_K": 0.02799856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05032",
    "Farbtonhilfsbezeichnung": "E7.77.66",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "154",
    "Bcolor": "0",
    "Y": 44,
    "L": 72.4359614128934,
    "a": 30.1179261627473,
    "b": 82.438720756787,
    "C": 87.7680588617534,
    "h": 1.22052400211884,
    "CMY_C": 0,
    "CMY_M": 0.3973532,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3973532,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05033",
    "Farbtonhilfsbezeichnung": "E6.06.75",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "204",
    "Bcolor": "190",
    "Y": 62,
    "L": 82.8426593733005,
    "a": 2.85484672729619,
    "b": 7.96999828673717,
    "C": 8.46587399663774,
    "h": 1.22683588441426,
    "CMY_C": 0.1448502,
    "CMY_M": 0.1996139,
    "CMY_Y": 0.2549103,
    "CMYK_C": 0,
    "CMYK_M": 0.06403994,
    "CMYK_Y": 0.1287027,
    "CMYK_K": 0.1448502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05034",
    "Farbtonhilfsbezeichnung": "E7.10.75",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "203",
    "Bcolor": "179",
    "Y": 62,
    "L": 83.1669311867212,
    "a": 4.68212619706387,
    "b": 14.1533022103623,
    "C": 14.907658071712,
    "h": 1.25131388493829,
    "CMY_C": 0.1114196,
    "CMY_M": 0.2020476,
    "CMY_Y": 0.2961787,
    "CMYK_C": 0,
    "CMYK_M": 0.1019919,
    "CMYK_Y": 0.2079261,
    "CMYK_K": 0.1114196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05035",
    "Farbtonhilfsbezeichnung": "E7.20.76",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "199",
    "Bcolor": "156",
    "Y": 62,
    "L": 82.7535419845314,
    "a": 8.95616061156806,
    "b": 26.3706549749414,
    "C": 27.8500315387183,
    "h": 1.2433930852951,
    "CMY_C": 0.05939712,
    "CMY_M": 0.2199573,
    "CMY_Y": 0.3892644,
    "CMYK_C": 0,
    "CMYK_M": 0.1706993,
    "CMYK_Y": 0.3506978,
    "CMYK_K": 0.05939712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05036",
    "Farbtonhilfsbezeichnung": "E7.25.74",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "192",
    "Bcolor": "141",
    "Y": 58,
    "L": 80.6748604751456,
    "a": 10.7619292163107,
    "b": 31.3066180642002,
    "C": 33.1047346322937,
    "h": 1.23969227270138,
    "CMY_C": 0.06228014,
    "CMY_M": 0.2480757,
    "CMY_Y": 0.4467862,
    "CMYK_C": 0,
    "CMYK_M": 0.1981355,
    "CMYK_Y": 0.4100436,
    "CMYK_K": 0.06228014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05037",
    "Farbtonhilfsbezeichnung": "E7.41.69",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "181",
    "Bcolor": "103",
    "Y": 54,
    "L": 78.3736419677734,
    "a": 16.5042476654053,
    "b": 47.9023666381836,
    "C": 50.6658363342285,
    "h": 70.9891510009766,
    "CMY_C": 0.02905821800232,
    "CMY_M": 0.29082274436951,
    "CMY_Y": 0.59450817108154,
    "CMYK_C": 0,
    "CMYK_M": 0.26959857344627,
    "CMYK_Y": 0.58237266540527,
    "CMYK_K": 0.02905821800232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05038",
    "Farbtonhilfsbezeichnung": "E7.58.65",
    "Farbtonklasse": "04",
    "Rcolor": "245",
    "Gcolor": "160",
    "Bcolor": "49",
    "Y": 45,
    "L": 72.7276074716298,
    "a": 23.3625282395994,
    "b": 65.7067361532773,
    "C": 69.7365248751504,
    "h": 1.22917903697484,
    "CMY_C": 0.04053868,
    "CMY_M": 0.3722293,
    "CMY_Y": 0.8062885,
    "CMYK_C": 0,
    "CMYK_M": 0.3457051,
    "CMYK_Y": 0.7981039,
    "CMYK_K": 0.04053868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05039",
    "Farbtonhilfsbezeichnung": "E6.61.65",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "154",
    "Bcolor": "47",
    "Y": 42,
    "L": 71.156017196384,
    "a": 26.246347336596,
    "b": 65.2080315920612,
    "C": 70.2919492731884,
    "h": 1.18813512420116,
    "CMY_C": 0.04406961,
    "CMY_M": 0.3972013,
    "CMY_Y": 0.8166283,
    "CMYK_C": 0,
    "CMYK_M": 0.3694115,
    "CMYK_Y": 0.8081746,
    "CMYK_K": 0.04406961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05040",
    "Farbtonhilfsbezeichnung": "E6.04.71",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "182",
    "Y": 53,
    "L": 77.9202964329888,
    "a": 1.98882310686127,
    "b": 5.01504439358649,
    "C": 5.39500580352131,
    "h": 1.19324914122873,
    "CMY_C": 0.2138615,
    "CMY_M": 0.2501563,
    "CMY_Y": 0.2861616,
    "CMYK_C": 0,
    "CMYK_M": 0.04616843,
    "CMYK_Y": 0.09196865,
    "CMYK_K": 0.2138615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05041",
    "Farbtonhilfsbezeichnung": "E7.10.71",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "191",
    "Bcolor": "169",
    "Y": 54,
    "L": 78.4705353589344,
    "a": 4.58023552693448,
    "b": 12.8893993764082,
    "C": 13.6790048529396,
    "h": 1.22936419765515,
    "CMY_C": 0.1675984,
    "CMY_M": 0.2523836,
    "CMY_Y": 0.3365344,
    "CMYK_C": 0,
    "CMYK_M": 0.1018562,
    "CMYK_Y": 0.20295,
    "CMYK_K": 0.1675984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05042",
    "Farbtonhilfsbezeichnung": "E6.15.70",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "185",
    "Bcolor": "155",
    "Y": 52,
    "L": 77.1894945698683,
    "a": 6.90425966067376,
    "b": 18.6819220890005,
    "C": 19.916902731135,
    "h": 1.21679554324309,
    "CMY_C": 0.1521765,
    "CMY_M": 0.2731618,
    "CMY_Y": 0.3912103,
    "CMYK_C": 0,
    "CMYK_M": 0.142701,
    "CMYK_Y": 0.2819382,
    "CMYK_K": 0.1521765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05043",
    "Farbtonhilfsbezeichnung": "E6.25.69",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "180",
    "Bcolor": "135",
    "Y": 51,
    "L": 76.710090637207,
    "a": 12.0588397979736,
    "b": 29.0246391296387,
    "C": 31.4300060272217,
    "h": 67.4386215209961,
    "CMY_C": 0.10357302427292,
    "CMY_M": 0.29345571994781,
    "CMY_Y": 0.47012174129486,
    "CMYK_C": 0,
    "CMYK_M": 0.21182170510292,
    "CMYK_Y": 0.40889969468117,
    "CMYK_K": 0.10357302427292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05044",
    "Farbtonhilfsbezeichnung": "E6.30.65",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "166",
    "Bcolor": "114",
    "Y": 43,
    "L": 71.823784822618,
    "a": 13.4785850949049,
    "b": 33.6186253568571,
    "C": 36.2199423942848,
    "h": 1.18949182360854,
    "CMY_C": 0.1432805,
    "CMY_M": 0.3498055,
    "CMY_Y": 0.5524154,
    "CMYK_C": 0,
    "CMYK_M": 0.2410649,
    "CMYK_Y": 0.47756,
    "CMYK_K": 0.1432805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05045",
    "Farbtonhilfsbezeichnung": "E7.43.60",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "152",
    "Bcolor": "80",
    "Y": 37,
    "L": 67.367853124227,
    "a": 16.1730549032643,
    "b": 45.8508809959357,
    "C": 48.6196564468267,
    "h": 1.23169008085429,
    "CMY_C": 0.1631443,
    "CMY_M": 0.4053575,
    "CMY_Y": 0.6874259,
    "CMYK_C": 0,
    "CMYK_M": 0.2894324,
    "CMYK_Y": 0.6264898,
    "CMYK_K": 0.1631443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05046",
    "Farbtonhilfsbezeichnung": "E7.50.62",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "154",
    "Bcolor": "67",
    "Y": 40,
    "L": 69.2309496875246,
    "a": 18.7398152767477,
    "b": 54.5090993346239,
    "C": 57.6404596345182,
    "h": 1.23966231168365,
    "CMY_C": 0.1179794,
    "CMY_M": 0.3942095,
    "CMY_Y": 0.7389943,
    "CMYK_C": 0,
    "CMYK_M": 0.3131787,
    "CMYK_Y": 0.7040821,
    "CMYK_K": 0.1179794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05048",
    "Farbtonhilfsbezeichnung": "E5.05.60",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "162",
    "Bcolor": "153",
    "Y": 37,
    "L": 67.0559209589603,
    "a": 2.10028511337973,
    "b": 5.32735618641125,
    "C": 5.72642309774424,
    "h": 1.19526072498133,
    "CMY_C": 0.3286921,
    "CMY_M": 0.3658045,
    "CMY_Y": 0.4018332,
    "CMYK_C": 0,
    "CMYK_M": 0.05528362,
    "CMYK_Y": 0.1089531,
    "CMYK_K": 0.3286921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05049",
    "Farbtonhilfsbezeichnung": "E7.13.62",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "164",
    "Bcolor": "140",
    "Y": 39,
    "L": 68.6440270500902,
    "a": 4.4590391462021,
    "b": 14.5739910415171,
    "C": 15.2408741542467,
    "h": 1.27388185297967,
    "CMY_C": 0.2718252,
    "CMY_M": 0.3568807,
    "CMY_Y": 0.4498704,
    "CMYK_C": 0,
    "CMYK_M": 0.1168065,
    "CMYK_Y": 0.2445089,
    "CMYK_K": 0.2718252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05050",
    "Farbtonhilfsbezeichnung": "E6.19.67",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "175",
    "Bcolor": "140",
    "Y": 47,
    "L": 73.8721889951734,
    "a": 8.00787342960613,
    "b": 22.1161639531733,
    "C": 23.5212828066038,
    "h": 1.22339849822996,
    "CMY_C": 0.1746709,
    "CMY_M": 0.3120036,
    "CMY_Y": 0.4497296,
    "CMYK_C": 0,
    "CMYK_M": 0.1663976,
    "CMYK_Y": 0.3332715,
    "CMYK_K": 0.1746709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05051",
    "Farbtonhilfsbezeichnung": "E7.36.63",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "163",
    "Bcolor": "98",
    "Y": 42,
    "L": 70.9622594887644,
    "a": 13.780357549497,
    "b": 40.7494324726247,
    "C": 43.016444541977,
    "h": 1.24469642081975,
    "CMY_C": 0.1414551,
    "CMY_M": 0.3608336,
    "CMY_Y": 0.6138213,
    "CMYK_C": 0,
    "CMYK_M": 0.2555237,
    "CMYK_Y": 0.550194,
    "CMYK_K": 0.1414551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05052",
    "Farbtonhilfsbezeichnung": "E7.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "151",
    "Bcolor": "85",
    "Y": 36,
    "L": 66.709994921625,
    "a": 14.2907664900232,
    "b": 42.1079995761151,
    "C": 44.4669499198503,
    "h": 1.24361040886344,
    "CMY_C": 0.1859008,
    "CMY_M": 0.4066051,
    "CMY_Y": 0.6655267,
    "CMYK_C": 0,
    "CMYK_M": 0.2711024,
    "CMYK_Y": 0.5891493,
    "CMYK_K": 0.1859008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05053",
    "Farbtonhilfsbezeichnung": "E7.52.57",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "143",
    "Bcolor": "58",
    "Y": 34,
    "L": 65.2490275955079,
    "a": 19.8694795126122,
    "b": 53.7592520383472,
    "C": 57.3136405738167,
    "h": 1.21676730611727,
    "CMY_C": 0.1595937,
    "CMY_M": 0.4383622,
    "CMY_Y": 0.7719726,
    "CMYK_C": 0,
    "CMYK_M": 0.3317068,
    "CMYK_Y": 0.72867,
    "CMYK_K": 0.1595937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05054",
    "Farbtonhilfsbezeichnung": "E7.61.60",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "146",
    "Bcolor": "36",
    "Y": 37,
    "L": 67.4743024716669,
    "a": 23.5120731881342,
    "b": 64.8050705082347,
    "C": 68.9384852544749,
    "h": 1.22275338604114,
    "CMY_C": 0.1045755,
    "CMY_M": 0.4271479,
    "CMY_Y": 0.8572391,
    "CMYK_C": 0,
    "CMYK_M": 0.3602453,
    "CMYK_Y": 0.8405662,
    "CMYK_K": 0.1045755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05055",
    "Farbtonhilfsbezeichnung": "E6.65.61",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "147",
    "Bcolor": "29",
    "Y": 39,
    "L": 68.4670164225748,
    "a": 25.865943085295,
    "b": 68.2457852016746,
    "C": 72.9831090697349,
    "h": 1.20851329904156,
    "CMY_C": 0.07736678,
    "CMY_M": 0.4242541,
    "CMY_Y": 0.8879571,
    "CMYK_C": 0,
    "CMYK_M": 0.3759754,
    "CMYK_Y": 0.8785618,
    "CMYK_K": 0.07736678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05056",
    "Farbtonhilfsbezeichnung": "E7.10.59",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "161",
    "Bcolor": "143",
    "Y": 37,
    "L": 67.2306404231039,
    "a": 3.80989144132976,
    "b": 10.8397010165239,
    "C": 11.4897515605145,
    "h": 1.23280746303762,
    "CMY_C": 0.3003548,
    "CMY_M": 0.3692722,
    "CMY_Y": 0.4381813,
    "CMYK_C": 0,
    "CMYK_M": 0.09850328,
    "CMYK_Y": 0.1969948,
    "CMYK_K": 0.3003548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05057",
    "Farbtonhilfsbezeichnung": "E7.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "134",
    "Bcolor": "118",
    "Y": 25,
    "L": 56.9458622832972,
    "a": 2.98945530208533,
    "b": 10.2204742482668,
    "C": 10.6487058773661,
    "h": 1.28623740152582,
    "CMY_C": 0.4156433,
    "CMY_M": 0.4728786,
    "CMY_Y": 0.5368524,
    "CMYK_C": 0,
    "CMYK_M": 0.09794585,
    "CMYK_Y": 0.2074232,
    "CMYK_K": 0.4156433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05058",
    "Farbtonhilfsbezeichnung": "E6.20.55",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "143",
    "Bcolor": "112",
    "Y": 30,
    "L": 61.7066682812098,
    "a": 8.26666129275477,
    "b": 20.397936740078,
    "C": 22.0093959976496,
    "h": 1.18575556165842,
    "CMY_C": 0.3102026,
    "CMY_M": 0.4390093,
    "CMY_Y": 0.5589406,
    "CMYK_C": 0,
    "CMYK_M": 0.1867312,
    "CMYK_Y": 0.3605957,
    "CMYK_K": 0.3102026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05059",
    "Farbtonhilfsbezeichnung": "E6.56.53",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "134",
    "Bcolor": "55",
    "Y": 30,
    "L": 61.5254136650952,
    "a": 19.4516839342471,
    "b": 50.9284985607742,
    "C": 54.5167861629116,
    "h": 1.20595428681113,
    "CMY_C": 0.2081735,
    "CMY_M": 0.4748162,
    "CMY_Y": 0.7846853,
    "CMYK_C": 0,
    "CMYK_M": 0.3367438,
    "CMYK_Y": 0.7280785,
    "CMYK_K": 0.2081735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05060",
    "Farbtonhilfsbezeichnung": "E7.64.54",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "136",
    "Bcolor": "41",
    "Y": 32,
    "L": 62.9487457715865,
    "a": 21.9668075825584,
    "b": 58.6444890731508,
    "C": 62.623611633473,
    "h": 1.21239759221907,
    "CMY_C": 0.1717473,
    "CMY_M": 0.4683629,
    "CMY_Y": 0.8411454,
    "CMYK_C": 0,
    "CMYK_M": 0.3581221,
    "CMYK_Y": 0.8082051,
    "CMYK_K": 0.1717473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05061",
    "Farbtonhilfsbezeichnung": "E7.72.60",
    "Farbtonklasse": "04",
    "Rcolor": "229",
    "Gcolor": "141",
    "Bcolor": "6",
    "Y": 36,
    "L": 66.3359477275745,
    "a": 25.9094053522684,
    "b": 70.6838653473889,
    "C": 75.2828407152385,
    "h": 1.21945145227256,
    "CMY_C": 0.1020311,
    "CMY_M": 0.4465422,
    "CMY_Y": 0.9778551,
    "CMYK_C": 0,
    "CMYK_M": 0.383656,
    "CMYK_Y": 0.9753389,
    "CMYK_K": 0.1020311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05062",
    "Farbtonhilfsbezeichnung": "E7.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "112",
    "Bcolor": "99",
    "Y": 17,
    "L": 48.0331852848634,
    "a": 2.97638740454648,
    "b": 8.31656932507723,
    "C": 8.83313122968058,
    "h": 1.22711307292203,
    "CMY_C": 0.5110198,
    "CMY_M": 0.5610059,
    "CMY_Y": 0.6104071,
    "CMYK_C": 0,
    "CMYK_M": 0.1022253,
    "CMYK_Y": 0.2032542,
    "CMYK_K": 0.5110198
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05063",
    "Farbtonhilfsbezeichnung": "E5.07.47",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "129",
    "Bcolor": "120",
    "Y": 23,
    "L": 54.7984214229969,
    "a": 2.45770764413084,
    "b": 5.71991905221323,
    "C": 6.22557634503754,
    "h": 1.16497237521593,
    "CMY_C": 0.4524527,
    "CMY_M": 0.4922614,
    "CMY_Y": 0.5278027,
    "CMYK_C": 0,
    "CMYK_M": 0.07270373,
    "CMYK_Y": 0.1376137,
    "CMYK_K": 0.4524527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05064",
    "Farbtonhilfsbezeichnung": "E7.19.51",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "136",
    "Bcolor": "109",
    "Y": 26,
    "L": 58.3272478687113,
    "a": 5.77067518829283,
    "b": 17.6659172137959,
    "C": 18.5845452764782,
    "h": 1.25506749852719,
    "CMY_C": 0.3672339,
    "CMY_M": 0.4668818,
    "CMY_Y": 0.5735072,
    "CMYK_C": 0,
    "CMYK_M": 0.1574798,
    "CMYK_Y": 0.3259867,
    "CMYK_K": 0.3672339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05065",
    "Farbtonhilfsbezeichnung": "E6.20.45",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "121",
    "Bcolor": "95",
    "Y": 21,
    "L": 52.4592224446887,
    "a": 5.92311927974354,
    "b": 17.0852508601136,
    "C": 18.0828410089532,
    "h": 1.23708201170396,
    "CMY_C": 0.429158,
    "CMY_M": 0.5258951,
    "CMY_Y": 0.6258993,
    "CMYK_C": 0,
    "CMYK_M": 0.1694639,
    "CMYK_Y": 0.344651,
    "CMYK_K": 0.429158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05066",
    "Farbtonhilfsbezeichnung": "E7.32.48",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "125",
    "Bcolor": "82",
    "Y": 23,
    "L": 55.3193115013347,
    "a": 10.1670692931484,
    "b": 28.9840357113729,
    "C": 30.7155274109012,
    "h": 1.23342528604933,
    "CMY_C": 0.3543153,
    "CMY_M": 0.5097252,
    "CMY_Y": 0.6794991,
    "CMYK_C": 0,
    "CMYK_M": 0.2406902,
    "CMYK_Y": 0.5036264,
    "CMYK_K": 0.3543153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05067",
    "Farbtonhilfsbezeichnung": "E7.46.52",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "129",
    "Bcolor": "62",
    "Y": 27,
    "L": 58.6005969783554,
    "a": 16.0483132312595,
    "b": 43.6749119991615,
    "C": 46.53005798087,
    "h": 1.21866187755774,
    "CMY_C": 0.2673426,
    "CMY_M": 0.4941253,
    "CMY_Y": 0.7549927,
    "CMYK_C": 0,
    "CMYK_M": 0.3095344,
    "CMYK_Y": 0.6655909,
    "CMYK_K": 0.2673426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05068",
    "Farbtonhilfsbezeichnung": "E7.56.48",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "122",
    "Bcolor": "49",
    "Y": 24,
    "L": 56.2392581892389,
    "a": 17.9855349276709,
    "b": 47.6796388927748,
    "C": 50.9590760471565,
    "h": 1.21008405367193,
    "CMY_C": 0.280302,
    "CMY_M": 0.523479,
    "CMY_Y": 0.8094881,
    "CMYK_C": 0,
    "CMYK_M": 0.3378876,
    "CMYK_Y": 0.7352891,
    "CMYK_K": 0.280302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05069",
    "Farbtonhilfsbezeichnung": "E6.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "112",
    "Bcolor": "106",
    "Y": 17,
    "L": 47.825052683126,
    "a": 1.72831152507241,
    "b": 4.13388755174535,
    "C": 4.48063466689411,
    "h": 1.17479829429688,
    "CMY_C": 0.5315635,
    "CMY_M": 0.5593835,
    "CMY_Y": 0.5852975,
    "CMYK_C": 0,
    "CMYK_M": 0.05938904,
    "CMYK_Y": 0.1147092,
    "CMYK_K": 0.5315635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05070",
    "Farbtonhilfsbezeichnung": "E6.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "102",
    "Bcolor": "83",
    "Y": 14,
    "L": 44.6042462929194,
    "a": 5.51088393643062,
    "b": 13.313077372954,
    "C": 14.4086040579603,
    "h": 1.17832636302642,
    "CMY_C": 0.519361,
    "CMY_M": 0.6009067,
    "CMY_Y": 0.6747149,
    "CMYK_C": 0,
    "CMYK_M": 0.1696611,
    "CMYK_Y": 0.3232236,
    "CMYK_K": 0.519361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05071",
    "Farbtonhilfsbezeichnung": "E7.25.43",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "117",
    "Bcolor": "86",
    "Y": 20,
    "L": 51.3190279226887,
    "a": 7.56728074504526,
    "b": 20.9622389012352,
    "C": 22.2863006716411,
    "h": 1.22435945220711,
    "CMY_C": 0.4244521,
    "CMY_M": 0.5417308,
    "CMY_Y": 0.6624332,
    "CMYK_C": 0,
    "CMYK_M": 0.2037688,
    "CMYK_Y": 0.4134862,
    "CMYK_K": 0.4244521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05072",
    "Farbtonhilfsbezeichnung": "E6.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "145",
    "Gcolor": "106",
    "Bcolor": "69",
    "Y": 17,
    "L": 48.0388442475012,
    "a": 10.8137009198919,
    "b": 26.5793407728164,
    "C": 28.6949034412449,
    "h": 1.18440211401984,
    "CMY_C": 0.4323691,
    "CMY_M": 0.5825691,
    "CMY_Y": 0.7301754,
    "CMYK_C": 0,
    "CMYK_M": 0.2646087,
    "CMYK_Y": 0.5246478,
    "CMYK_K": 0.4323691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05073",
    "Farbtonhilfsbezeichnung": "E6.50.42",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "104",
    "Bcolor": "47",
    "Y": 17,
    "L": 48.2570610943585,
    "a": 15.4933173928251,
    "b": 38.9738211382968,
    "C": 41.9404532397394,
    "h": 1.19241986935607,
    "CMY_C": 0.3912844,
    "CMY_M": 0.5941122,
    "CMY_Y": 0.8157701,
    "CMYK_C": 0,
    "CMYK_M": 0.3332062,
    "CMYK_Y": 0.6973466,
    "CMYK_K": 0.3912844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05074",
    "Farbtonhilfsbezeichnung": "E6.44.33",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "91",
    "Bcolor": "50",
    "Y": 13,
    "L": 42.164760439475,
    "a": 11.7409882435779,
    "b": 29.7102439534077,
    "C": 31.9460388891461,
    "h": 1.1944492781039,
    "CMY_C": 0.4861973,
    "CMY_M": 0.6415913,
    "CMY_Y": 0.8043875,
    "CMYK_C": 0,
    "CMYK_M": 0.3024391,
    "CMYK_Y": 0.6192848,
    "CMYK_K": 0.4861973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05075",
    "Farbtonhilfsbezeichnung": "E7.31.23",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "74",
    "Bcolor": "53",
    "Y": 8,
    "L": 33.4024305272172,
    "a": 6.26388316770735,
    "b": 16.0045304247648,
    "C": 17.1866583853845,
    "h": 1.19774137192942,
    "CMY_C": 0.6219223,
    "CMY_M": 0.7080396,
    "CMY_Y": 0.7921125,
    "CMYK_C": 0,
    "CMYK_M": 0.2277766,
    "CMYK_Y": 0.4501461,
    "CMYK_K": 0.6219223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05076",
    "Farbtonhilfsbezeichnung": "E7.31.31",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "87",
    "Bcolor": "60",
    "Y": 11,
    "L": 39.1473779316438,
    "a": 7.06828924798511,
    "b": 19.5731634355317,
    "C": 20.81032051092,
    "h": 1.22424831224481,
    "CMY_C": 0.5551492,
    "CMY_M": 0.6573517,
    "CMY_Y": 0.764368,
    "CMYK_C": 0,
    "CMYK_M": 0.2297455,
    "CMYK_Y": 0.4703122,
    "CMYK_K": 0.5551492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05077",
    "Farbtonhilfsbezeichnung": "E7.24.21",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "67",
    "Bcolor": "51",
    "Y": 6,
    "L": 29.4130517252363,
    "a": 4.15967924318961,
    "b": 11.4609359181518,
    "C": 12.1924560087869,
    "h": 1.22263686123073,
    "CMY_C": 0.6788479,
    "CMY_M": 0.7387459,
    "CMY_Y": 0.7988453,
    "CMYK_C": 0,
    "CMYK_M": 0.1865095,
    "CMYK_Y": 0.3736466,
    "CMYK_K": 0.6788479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05078",
    "Farbtonhilfsbezeichnung": "E7.19.18",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "65",
    "Bcolor": "52",
    "Y": 6,
    "L": 28.453992348811,
    "a": 3.04796243204802,
    "b": 9.78510589219342,
    "C": 10.2488229718644,
    "h": 1.26883188401353,
    "CMY_C": 0.6968701,
    "CMY_M": 0.7447064,
    "CMY_Y": 0.7971222,
    "CMYK_C": 0,
    "CMYK_M": 0.1578076,
    "CMYK_Y": 0.3307232,
    "CMYK_K": 0.6968701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05079",
    "Farbtonhilfsbezeichnung": "E7.16.16",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "62",
    "Bcolor": "53",
    "Y": 5,
    "L": 26.8144933371283,
    "a": 2.51118630064612,
    "b": 6.61402940530074,
    "C": 7.07470434793819,
    "h": 1.20793271984837,
    "CMY_C": 0.720963,
    "CMY_M": 0.7575645,
    "CMY_Y": 0.792347,
    "CMYK_C": 0,
    "CMYK_M": 0.1311707,
    "CMYK_Y": 0.2558226,
    "CMYK_K": 0.720963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05080",
    "Farbtonhilfsbezeichnung": "E7.08.16",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "64",
    "Bcolor": "60",
    "Y": 5,
    "L": 27.5011935448759,
    "a": 0.8246029562893,
    "b": 2.86515470663102,
    "C": 2.98145627646138,
    "h": 1.29056574537972,
    "CMY_C": 0.7328644,
    "CMY_M": 0.7473999,
    "CMY_Y": 0.7644466,
    "CMYK_C": 0,
    "CMYK_M": 0.05441273,
    "CMYK_Y": 0.1182256,
    "CMYK_K": 0.7328644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05081",
    "Farbtonhilfsbezeichnung": "E6.59.43",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "108",
    "Bcolor": "39",
    "Y": 19,
    "L": 50.6168555386872,
    "a": 17.7690591316013,
    "b": 45.8468738865092,
    "C": 49.169861781256,
    "h": 1.20104764681722,
    "CMY_C": 0.3472354,
    "CMY_M": 0.5780935,
    "CMY_Y": 0.8485852,
    "CMYK_C": 0,
    "CMYK_M": 0.3536621,
    "CMYK_Y": 0.7680407,
    "CMYK_K": 0.3472354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05082",
    "Farbtonhilfsbezeichnung": "E6.45.37",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "96",
    "Bcolor": "50",
    "Y": 14,
    "L": 44.8254807579387,
    "a": 13.6841062670513,
    "b": 33.0416432279579,
    "C": 35.7631787112332,
    "h": 1.17815383236536,
    "CMY_C": 0.4439915,
    "CMY_M": 0.6216487,
    "CMY_Y": 0.8035774,
    "CMYK_C": 0,
    "CMYK_M": 0.3195226,
    "CMYK_Y": 0.6467274,
    "CMYK_K": 0.4439915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05083",
    "Farbtonhilfsbezeichnung": "E6.32.30",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "85",
    "Bcolor": "57",
    "Y": 10,
    "L": 38.1675134843708,
    "a": 7.57983524338068,
    "b": 20.0242792248376,
    "C": 21.4108771607111,
    "h": 1.20893250121357,
    "CMY_C": 0.5616163,
    "CMY_M": 0.6677455,
    "CMY_Y": 0.7758407,
    "CMYK_C": 0,
    "CMYK_M": 0.2420921,
    "CMYK_Y": 0.4886687,
    "CMYK_K": 0.5616163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05084",
    "Farbtonhilfsbezeichnung": "E6.28.33",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "92",
    "Bcolor": "66",
    "Y": 12,
    "L": 41.4412591206379,
    "a": 7.98618569814183,
    "b": 19.0631308483472,
    "C": 20.6683845461229,
    "h": 1.17407518964132,
    "CMY_C": 0.5274842,
    "CMY_M": 0.6377874,
    "CMY_Y": 0.740411,
    "CMYK_C": 0,
    "CMYK_M": 0.2334381,
    "CMYK_Y": 0.4506236,
    "CMYK_K": 0.5274842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05085",
    "Farbtonhilfsbezeichnung": "E7.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "88",
    "Bcolor": "71",
    "Y": 11,
    "L": 38.7972968868972,
    "a": 4.49606450282269,
    "b": 12.3529775006979,
    "C": 13.1457464278866,
    "h": 1.22173416575728,
    "CMY_C": 0.5849769,
    "CMY_M": 0.6536257,
    "CMY_Y": 0.7217783,
    "CMYK_C": 0,
    "CMYK_M": 0.1654098,
    "CMYK_Y": 0.3296236,
    "CMYK_K": 0.5849769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05087",
    "Farbtonhilfsbezeichnung": "E6.14.23",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "81",
    "Bcolor": "73",
    "Y": 7,
    "L": 35.3203964233398,
    "a": 2.51369571685791,
    "b": 5.97897386550903,
    "C": 6.48589181900024,
    "h": 67.1970138549805,
    "CMY_C": 0.64322865009308,
    "CMY_M": 0.68049454689026,
    "CMY_Y": 0.71359395980835,
    "CMYK_C": 0,
    "CMYK_M": 0.10445316880941,
    "CMYK_Y": 0.19722802937031,
    "CMYK_K": 0.64322865009308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05088",
    "Farbtonhilfsbezeichnung": "E7.05.30",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "91",
    "Bcolor": "86",
    "Y": 10,
    "L": 38.7215878160891,
    "a": 1.01515327081525,
    "b": 3.05593254741531,
    "C": 3.22013352170358,
    "h": 1.25007422980383,
    "CMY_C": 0.6274054,
    "CMY_M": 0.6450422,
    "CMY_Y": 0.6644903,
    "CMYK_C": 0,
    "CMYK_M": 0.04733501,
    "CMYK_Y": 0.09953159,
    "CMYK_K": 0.6274054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05089",
    "Farbtonhilfsbezeichnung": "E6.63.47",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "118",
    "Bcolor": "39",
    "Y": 24,
    "L": 55.6330137770111,
    "a": 20.250511963665,
    "b": 51.216235516619,
    "C": 55.0743680425325,
    "h": 1.19426829020332,
    "CMY_C": 0.2724989,
    "CMY_M": 0.5362095,
    "CMY_Y": 0.8458849,
    "CMYK_C": 0,
    "CMYK_M": 0.3624882,
    "CMYK_Y": 0.7881583,
    "CMYK_K": 0.2724989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05090",
    "Farbtonhilfsbezeichnung": "E6.53.45",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "115",
    "Bcolor": "47",
    "Y": 22,
    "L": 53.5533024747205,
    "a": 17.9937147585681,
    "b": 45.3607931513321,
    "C": 48.799337353397,
    "h": 1.19315538006742,
    "CMY_C": 0.3129451,
    "CMY_M": 0.5498544,
    "CMY_Y": 0.8159687,
    "CMYK_C": 0,
    "CMYK_M": 0.3448186,
    "CMYK_Y": 0.7321447,
    "CMYK_K": 0.3129451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05091",
    "Farbtonhilfsbezeichnung": "E6.38.46",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "117",
    "Bcolor": "70",
    "Y": 21,
    "L": 52.8737565120085,
    "a": 13.0563113756205,
    "b": 32.3677884986863,
    "C": 34.9018767265149,
    "h": 1.18738506115825,
    "CMY_C": 0.3603018,
    "CMY_M": 0.5417659,
    "CMY_Y": 0.7254682,
    "CMYK_C": 0,
    "CMYK_M": 0.2836715,
    "CMYK_Y": 0.5708417,
    "CMYK_K": 0.3603018
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05092",
    "Farbtonhilfsbezeichnung": "E8.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "230",
    "Bcolor": "220",
    "Y": 81,
    "L": 91.8689041137695,
    "a": 1.53192794322968,
    "b": 5.46244049072266,
    "C": 5.67318773269653,
    "h": 74.3339767456055,
    "CMY_C": 0.06157720088959,
    "CMY_M": 0.09612941741943,
    "CMY_Y": 0.13877749443054,
    "CMYK_C": 0,
    "CMYK_M": 0.03681945428252,
    "CMYK_Y": 0.08226600289345,
    "CMYK_K": 0.06157720088959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05093",
    "Farbtonhilfsbezeichnung": "E9.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "223",
    "Bcolor": "200",
    "Y": 76,
    "L": 89.9809543652809,
    "a": 3.54067235625127,
    "b": 12.894030869261,
    "C": 13.3713272636556,
    "h": 1.30280408753946,
    "CMY_C": 0.04620145,
    "CMY_M": 0.1240059,
    "CMY_Y": 0.2141513,
    "CMYK_C": 0,
    "CMYK_M": 0.08157328,
    "CMYK_Y": 0.1760853,
    "CMYK_K": 0.04620145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05094",
    "Farbtonhilfsbezeichnung": "E9.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "220",
    "Bcolor": "187",
    "Y": 75,
    "L": 89.3550484474247,
    "a": 5.58447362492637,
    "b": 19.106504884607,
    "C": 19.9059004964108,
    "h": 1.28643588737488,
    "CMY_C": 0.02278385,
    "CMY_M": 0.1375037,
    "CMY_Y": 0.2666103,
    "CMYK_C": 0,
    "CMYK_M": 0.1173946,
    "CMYK_Y": 0.2495113,
    "CMYK_K": 0.02278385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05095",
    "Farbtonhilfsbezeichnung": "E7.25.80",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "150",
    "Y": 69,
    "L": 86.4334486620701,
    "a": 10.956944007586,
    "b": 34.3528280077766,
    "C": 36.0578897623981,
    "h": 1.26204324612915,
    "CMY_C": 0,
    "CMY_M": 0.1866209,
    "CMY_Y": 0.4101598,
    "CMYK_C": 0,
    "CMYK_M": 0.1866209,
    "CMYK_Y": 0.4101598,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05096",
    "Farbtonhilfsbezeichnung": "E9.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "223",
    "Bcolor": "209",
    "Y": 75,
    "L": 89.3154788012285,
    "a": 1.85380365052479,
    "b": 7.08417378860071,
    "C": 7.32271167272045,
    "h": 1.31485303703874,
    "CMY_C": 0.08282233,
    "CMY_M": 0.1257831,
    "CMY_Y": 0.1786771,
    "CMYK_C": 0,
    "CMYK_M": 0.04684015,
    "CMYK_Y": 0.1045105,
    "CMYK_K": 0.08282233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05097",
    "Farbtonhilfsbezeichnung": "E8.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "226",
    "Bcolor": "207",
    "Y": 78,
    "L": 90.7059936523438,
    "a": 2.58389759063721,
    "b": 10.3236808776856,
    "C": 10.642128944397,
    "h": 75.9482040405273,
    "CMY_C": 0.05219960212708,
    "CMY_M": 0.11292469501495,
    "CMY_Y": 0.18739128112793,
    "CMYK_C": 0,
    "CMYK_M": 0.06406949460506,
    "CMYK_Y": 0.14263728260994,
    "CMYK_K": 0.05219960212708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05098",
    "Farbtonhilfsbezeichnung": "E8.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "222",
    "Bcolor": "195",
    "Y": 76,
    "L": 89.9464608132669,
    "a": 5.18607995216724,
    "b": 15.8478144120237,
    "C": 16.6747907605528,
    "h": 1.25453741402516,
    "CMY_C": 0.02692491,
    "CMY_M": 0.1291805,
    "CMY_Y": 0.2361484,
    "CMYK_C": 0,
    "CMYK_M": 0.105085,
    "CMYK_Y": 0.2150127,
    "CMYK_K": 0.02692491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05099",
    "Farbtonhilfsbezeichnung": "E8.20.81",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "206",
    "Bcolor": "161",
    "Y": 66,
    "L": 85.14925262255,
    "a": 7.67733544039972,
    "b": 26.9185087789375,
    "C": 27.991920161828,
    "h": 1.29296613231583,
    "CMY_C": 0.03932991,
    "CMY_M": 0.1907403,
    "CMY_Y": 0.3686343,
    "CMYK_C": 0,
    "CMYK_M": 0.1576092,
    "CMYK_Y": 0.3427862,
    "CMYK_K": 0.03932991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05100",
    "Farbtonhilfsbezeichnung": "E8.29.76",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "198",
    "Bcolor": "131",
    "Y": 63,
    "L": 83.4025726318359,
    "a": 12.3877277374268,
    "b": 40.1584587097168,
    "C": 42.0256767272949,
    "h": 72.8565139770508,
    "CMY_C": 0.00551265478134,
    "CMY_M": 0.22441107034683,
    "CMY_Y": 0.48498523235321,
    "CMYK_C": 0,
    "CMYK_M": 0.22011181712151,
    "CMYK_Y": 0.48213040828705,
    "CMYK_K": 0.00551265478134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05101",
    "Farbtonhilfsbezeichnung": "E8.34.77",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "200",
    "Bcolor": "125",
    "Y": 65,
    "L": 84.7368670485343,
    "a": 14.2325755826196,
    "b": 45.2132108378969,
    "C": 47.4004287110053,
    "h": 1.26582838973795,
    "CMY_C": 0,
    "CMY_M": 0.215756,
    "CMY_Y": 0.5097646,
    "CMYK_C": 0,
    "CMYK_M": 0.215756,
    "CMYK_Y": 0.5097646,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05102",
    "Farbtonhilfsbezeichnung": "E8.49.72",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "180",
    "Bcolor": "83",
    "Y": 56,
    "L": 78.9343532971594,
    "a": 18.9900805146433,
    "b": 58.6369876965892,
    "C": 61.6353752652046,
    "h": 1.25759731985279,
    "CMY_C": 0,
    "CMY_M": 0.293276,
    "CMY_Y": 0.676037,
    "CMYK_C": 0,
    "CMYK_M": 0.293276,
    "CMYK_Y": 0.676037,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05103",
    "Farbtonhilfsbezeichnung": "E8.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "224",
    "Bcolor": "208",
    "Y": 76,
    "L": 89.9342034207896,
    "a": 3.11979813362379,
    "b": 8.98739722124864,
    "C": 9.51348775197983,
    "h": 1.23668029319128,
    "CMY_C": 0.06076591,
    "CMY_M": 0.1224891,
    "CMY_Y": 0.1858098,
    "CMYK_C": 0,
    "CMYK_M": 0.06571648,
    "CMYK_Y": 0.1331338,
    "CMYK_K": 0.06076591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05104",
    "Farbtonhilfsbezeichnung": "E9.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "214",
    "Bcolor": "200",
    "Y": 69,
    "L": 86.4808653467998,
    "a": 2.59688535581176,
    "b": 7.98874013541624,
    "C": 8.40022514593745,
    "h": 1.25650274667516,
    "CMY_C": 0.1062704,
    "CMY_M": 0.159131,
    "CMY_Y": 0.2159717,
    "CMYK_C": 0,
    "CMYK_M": 0.05914603,
    "CMYK_Y": 0.1227454,
    "CMYK_K": 0.1062704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05105",
    "Farbtonhilfsbezeichnung": "E9.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "223",
    "Bcolor": "203",
    "Y": 76,
    "L": 89.6742909841565,
    "a": 3.3179329408316,
    "b": 11.0989954865951,
    "C": 11.5843161132332,
    "h": 1.28031235654949,
    "CMY_C": 0.05623625,
    "CMY_M": 0.126405,
    "CMY_Y": 0.2042181,
    "CMYK_C": 0,
    "CMYK_M": 0.07434992,
    "CMYK_Y": 0.1567997,
    "CMYK_K": 0.05623625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05106",
    "Farbtonhilfsbezeichnung": "E8.13.83",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "220",
    "Bcolor": "188",
    "Y": 75,
    "L": 89.3969765523997,
    "a": 5.37413597074388,
    "b": 18.4406828345093,
    "C": 19.2078140566543,
    "h": 1.28722195429216,
    "CMY_C": 0.02540231,
    "CMY_M": 0.1363586,
    "CMY_Y": 0.2612549,
    "CMYK_C": 0,
    "CMYK_M": 0.1138483,
    "CMYK_Y": 0.242,
    "CMYK_K": 0.02540231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05107",
    "Farbtonhilfsbezeichnung": "E8.40.74",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "191",
    "Bcolor": "106",
    "Y": 61,
    "L": 82.1635090612416,
    "a": 16.3563350894014,
    "b": 51.3407853930923,
    "C": 53.8832621723699,
    "h": 1.2623786926755,
    "CMY_C": 0,
    "CMY_M": 0.2503371,
    "CMY_Y": 0.583641,
    "CMYK_C": 0,
    "CMYK_M": 0.2503371,
    "CMYK_Y": 0.583641,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05108",
    "Farbtonhilfsbezeichnung": "E8.75.68",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "167",
    "Bcolor": "0",
    "Y": 50,
    "L": 76.3678121359563,
    "a": 27.0673712150771,
    "b": 84.0617582117294,
    "C": 88.3120703989101,
    "h": 1.25928576351971,
    "CMY_C": 0,
    "CMY_M": 0.3466892,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3466892,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05109",
    "Farbtonhilfsbezeichnung": "E9.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "214",
    "Bcolor": "194",
    "Y": 69,
    "L": 86.515018742791,
    "a": 3.51594160376439,
    "b": 11.3888695767219,
    "C": 11.9192363680171,
    "h": 1.27136127771887,
    "CMY_C": 0.08954288,
    "CMY_M": 0.1618553,
    "CMY_Y": 0.24041,
    "CMYK_C": 0,
    "CMYK_M": 0.07942428,
    "CMYK_Y": 0.1657048,
    "CMYK_K": 0.08954288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05110",
    "Farbtonhilfsbezeichnung": "E8.16.78",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "209",
    "Bcolor": "175",
    "Y": 67,
    "L": 85.4846878051758,
    "a": 5.22573518753052,
    "b": 20.1421985626221,
    "C": 20.8090476989746,
    "h": 75.4557266235352,
    "CMY_C": 0.06694382429123,
    "CMY_M": 0.17942261695862,
    "CMY_Y": 0.31546777486801,
    "CMYK_C": 0,
    "CMYK_M": 0.1205487921834,
    "CMYK_Y": 0.26635476946831,
    "CMYK_K": 0.06694382429123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05112",
    "Farbtonhilfsbezeichnung": "E8.71.67",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "164",
    "Bcolor": "19",
    "Y": 48,
    "L": 75.1188379576665,
    "a": 26.4850395845153,
    "b": 76.5576214803619,
    "C": 81.0094237019602,
    "h": 1.23773488305364,
    "CMY_C": 0,
    "CMY_M": 0.3574811,
    "CMY_Y": 0.9269607,
    "CMYK_C": 0,
    "CMYK_M": 0.3574811,
    "CMYK_Y": 0.9269607,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05113",
    "Farbtonhilfsbezeichnung": "E8.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "196",
    "Bcolor": "180",
    "Y": 57,
    "L": 79.9875536701646,
    "a": 2.33784946149923,
    "b": 9.04921396441651,
    "C": 9.34632620222636,
    "h": 1.31797596136205,
    "CMY_C": 0.1770636,
    "CMY_M": 0.2296918,
    "CMY_Y": 0.2932088,
    "CMYK_C": 0,
    "CMYK_M": 0.06395175,
    "CMYK_Y": 0.1411352,
    "CMYK_K": 0.1770636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05114",
    "Farbtonhilfsbezeichnung": "E9.12.76",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "202",
    "Bcolor": "175",
    "Y": 62,
    "L": 82.7253503927637,
    "a": 4.6230830519261,
    "b": 16.1265715689026,
    "C": 16.7761499597478,
    "h": 1.29160879197648,
    "CMY_C": 0.1118648,
    "CMY_M": 0.2071885,
    "CMY_Y": 0.3152533,
    "CMYK_C": 0,
    "CMYK_M": 0.1073301,
    "CMYK_Y": 0.2290062,
    "CMYK_K": 0.1118648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05115",
    "Farbtonhilfsbezeichnung": "E8.16.73",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "191",
    "Bcolor": "157",
    "Y": 56,
    "L": 79.332234106199,
    "a": 6.50498046938269,
    "b": 20.5809853212064,
    "C": 21.5845251904869,
    "h": 1.26466466551483,
    "CMY_C": 0.1266905,
    "CMY_M": 0.2495771,
    "CMY_Y": 0.382845,
    "CMYK_C": 0,
    "CMYK_M": 0.1407136,
    "CMYK_Y": 0.2933147,
    "CMYK_K": 0.1266905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05116",
    "Farbtonhilfsbezeichnung": "E9.51.69",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "175",
    "Bcolor": "78",
    "Y": 51,
    "L": 76.7971997354309,
    "a": 18.665864278062,
    "b": 58.3972707621052,
    "C": 61.3078765062831,
    "h": 1.26142369529128,
    "CMY_C": 0.02391035,
    "CMY_M": 0.3150744,
    "CMY_Y": 0.6959853,
    "CMYK_C": 0,
    "CMYK_M": 0.2982964,
    "CMYK_Y": 0.6885381,
    "CMYK_K": 0.02391035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05117",
    "Farbtonhilfsbezeichnung": "E9.68.63",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "154",
    "Bcolor": "23",
    "Y": 42,
    "L": 70.5308314582507,
    "a": 23.3712300805255,
    "b": 71.2693514818372,
    "C": 75.003565622699,
    "h": 1.2539182556634,
    "CMY_C": 0.06393277,
    "CMY_M": 0.3956909,
    "CMY_Y": 0.9088456,
    "CMYK_C": 0,
    "CMYK_M": 0.354417,
    "CMYK_Y": 0.9026198,
    "CMYK_K": 0.06393277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05118",
    "Farbtonhilfsbezeichnung": "E9.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "193",
    "Bcolor": "185",
    "Y": 54,
    "L": 78.2691556658382,
    "a": 1.10566280273111,
    "b": 4.0386039502871,
    "C": 4.18722009221127,
    "h": 1.30357072557454,
    "CMY_C": 0.2195718,
    "CMY_M": 0.2440729,
    "CMY_Y": 0.2755767,
    "CMYK_C": 0,
    "CMYK_M": 0.03139436,
    "CMYK_Y": 0.07176168,
    "CMYK_K": 0.2195718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05119",
    "Farbtonhilfsbezeichnung": "E9.07.71",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "190",
    "Bcolor": "173",
    "Y": 52,
    "L": 77.5536740892008,
    "a": 2.63717013373477,
    "b": 9.31736797213951,
    "C": 9.68338846904914,
    "h": 1.29497262187601,
    "CMY_C": 0.2008501,
    "CMY_M": 0.2567366,
    "CMY_Y": 0.320792,
    "CMYK_C": 0,
    "CMYK_M": 0.06993248,
    "CMYK_Y": 0.1500869,
    "CMYK_K": 0.2008501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05120",
    "Farbtonhilfsbezeichnung": "E9.11.74",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "195",
    "Bcolor": "170",
    "Y": 56,
    "L": 79.8834533691406,
    "a": 4.41708087921143,
    "b": 14.340124130249,
    "C": 15.0049915313721,
    "h": 72.8799896240234,
    "CMY_C": 0.14943051338196,
    "CMY_M": 0.23705810308456,
    "CMY_Y": 0.33221310377121,
    "CMYK_C": 0,
    "CMYK_M": 0.10302225500345,
    "CMYK_Y": 0.21489436924458,
    "CMYK_K": 0.14943051338196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05121",
    "Farbtonhilfsbezeichnung": "E9.24.67",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "178",
    "Bcolor": "132",
    "Y": 48,
    "L": 74.7243499755859,
    "a": 7.91349267959595,
    "b": 27.7471656799316,
    "C": 28.8535709381104,
    "h": 74.0818481445313,
    "CMY_C": 0.15493607521057,
    "CMY_M": 0.3038284778595,
    "CMY_Y": 0.48179280757904,
    "CMYK_C": 0,
    "CMYK_M": 0.17619070410728,
    "CMYK_Y": 0.3867834508419,
    "CMYK_K": 0.15493607521057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05122",
    "Farbtonhilfsbezeichnung": "E9.51.63",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "159",
    "Bcolor": "66",
    "Y": 42,
    "L": 70.5762173365876,
    "a": 16.8254886897327,
    "b": 56.3747417747109,
    "C": 58.8320370190737,
    "h": 1.28075487592255,
    "CMY_C": 0.1112567,
    "CMY_M": 0.3751654,
    "CMY_Y": 0.742573,
    "CMYK_C": 0,
    "CMYK_M": 0.296946,
    "CMYK_Y": 0.7103471,
    "CMYK_K": 0.1112567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05123",
    "Farbtonhilfsbezeichnung": "E9.60.63",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "157",
    "Bcolor": "42",
    "Y": 41,
    "L": 70.2987237299083,
    "a": 19.0561182824851,
    "b": 65.6595619828772,
    "C": 68.3689529229412,
    "h": 1.28833036182213,
    "CMY_C": 0.09453563,
    "CMY_M": 0.3852079,
    "CMY_Y": 0.8370444,
    "CMYK_C": 0,
    "CMYK_M": 0.3210201,
    "CMYK_Y": 0.8200309,
    "CMYK_K": 0.09453563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05124",
    "Farbtonhilfsbezeichnung": "E8.11.70",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "188",
    "Bcolor": "166",
    "Y": 52,
    "L": 77.4623529621249,
    "a": 4.70458173366278,
    "b": 13.225641632594,
    "C": 14.0374743412951,
    "h": 1.22903777528179,
    "CMY_C": 0.1770241,
    "CMY_M": 0.2636073,
    "CMY_Y": 0.3494816,
    "CMYK_C": 0,
    "CMYK_M": 0.1052074,
    "CMYK_Y": 0.2095535,
    "CMYK_K": 0.1770241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05125",
    "Farbtonhilfsbezeichnung": "E8.27.64",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "168",
    "Bcolor": "116",
    "Y": 43,
    "L": 71.4844227996341,
    "a": 9.45022799839101,
    "b": 32.2071314105498,
    "C": 33.5649537898982,
    "h": 1.28538677942973,
    "CMY_C": 0.1741951,
    "CMY_M": 0.3427891,
    "CMY_Y": 0.5464084,
    "CMYK_C": 0,
    "CMYK_M": 0.2041571,
    "CMYK_Y": 0.4507279,
    "CMYK_K": 0.1741951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05126",
    "Farbtonhilfsbezeichnung": "E9.49.59",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "150",
    "Bcolor": "64",
    "Y": 36,
    "L": 66.7096498066748,
    "a": 16.0752048480938,
    "b": 52.5268048724444,
    "C": 54.9315705311256,
    "h": 1.27380921571111,
    "CMY_C": 0.1648267,
    "CMY_M": 0.4127501,
    "CMY_Y": 0.7483987,
    "CMYK_C": 0,
    "CMYK_M": 0.2968527,
    "CMYK_Y": 0.6987436,
    "CMYK_K": 0.1648267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05127",
    "Farbtonhilfsbezeichnung": "E9.70.59",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "149",
    "Bcolor": "32",
    "Y": 37,
    "L": 68.1777114868164,
    "a": 21.5410499572754,
    "b": 66.8223266601563,
    "C": 70.2085494995117,
    "h": 72.1325988769531,
    "CMY_C": 0.10562521219254,
    "CMY_M": 0.41427600383759,
    "CMY_Y": 0.87617379426956,
    "CMYK_C": 0,
    "CMYK_M": 0.34510228037834,
    "CMYK_Y": 0.86154997348785,
    "CMYK_K": 0.10562521219254
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05128",
    "Farbtonhilfsbezeichnung": "E7.05.65",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "174",
    "Bcolor": "164",
    "Y": 43,
    "L": 71.7530815649951,
    "a": 2.2248885057593,
    "b": 5.90739390697408,
    "C": 6.31248220870478,
    "h": 1.21059934780765,
    "CMY_C": 0.2761507,
    "CMY_M": 0.3168287,
    "CMY_Y": 0.3573017,
    "CMYK_C": 0,
    "CMYK_M": 0.0561967,
    "CMYK_Y": 0.1121104,
    "CMYK_K": 0.2761507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05130",
    "Farbtonhilfsbezeichnung": "E8.20.59",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "155",
    "Bcolor": "121",
    "Y": 35,
    "L": 65.7796866523097,
    "a": 6.72348562101216,
    "b": 21.2309576656558,
    "C": 22.2701329654052,
    "h": 1.264105066213,
    "CMY_C": 0.2740572,
    "CMY_M": 0.3935368,
    "CMY_Y": 0.5249445,
    "CMYK_C": 0,
    "CMYK_M": 0.1645854,
    "CMYK_Y": 0.345602,
    "CMYK_K": 0.2740572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05131",
    "Farbtonhilfsbezeichnung": "E9.21.58",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "152",
    "Bcolor": "116",
    "Y": 34,
    "L": 64.8876955968443,
    "a": 6.67659178308466,
    "b": 22.8089399777638,
    "C": 23.7660392313735,
    "h": 1.28603340148031,
    "CMY_C": 0.2811081,
    "CMY_M": 0.4029667,
    "CMY_Y": 0.5448653,
    "CMYK_C": 0,
    "CMYK_M": 0.169509,
    "CMYK_Y": 0.3668942,
    "CMYK_K": 0.2811081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05132",
    "Farbtonhilfsbezeichnung": "E8.29.56",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "145",
    "Bcolor": "99",
    "Y": 31,
    "L": 62.9201663490046,
    "a": 9.42916270388677,
    "b": 29.7257336915279,
    "C": 31.1853868469834,
    "h": 1.26363046597514,
    "CMY_C": 0.2741165,
    "CMY_M": 0.4311882,
    "CMY_Y": 0.6124439,
    "CMYK_C": 0,
    "CMYK_M": 0.2163869,
    "CMYK_Y": 0.4660904,
    "CMYK_K": 0.2741165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05133",
    "Farbtonhilfsbezeichnung": "E9.66.53",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "132",
    "Bcolor": "22",
    "Y": 29,
    "L": 60.5770820314915,
    "a": 18.3156677162829,
    "b": 61.915357248594,
    "C": 64.5676013734002,
    "h": 1.2831807719494,
    "CMY_C": 0.2178161,
    "CMY_M": 0.4823388,
    "CMY_Y": 0.913578,
    "CMYK_C": 0,
    "CMYK_M": 0.3381848,
    "CMYK_Y": 0.8895119,
    "CMYK_K": 0.2178161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05134",
    "Farbtonhilfsbezeichnung": "E9.06.54",
    "Farbtonklasse": "01",
    "Rcolor": "157",
    "Gcolor": "148",
    "Bcolor": "137",
    "Y": 30,
    "L": 61.7185131921823,
    "a": 1.96031466678215,
    "b": 6.30963130646041,
    "C": 6.60713862547672,
    "h": 1.26956484275606,
    "CMY_C": 0.3829616,
    "CMY_M": 0.4210303,
    "CMY_Y": 0.462936,
    "CMYK_C": 0,
    "CMYK_M": 0.06169599,
    "CMYK_Y": 0.1296102,
    "CMYK_K": 0.3829616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05135",
    "Farbtonhilfsbezeichnung": "E8.23.52",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "137",
    "Bcolor": "105",
    "Y": 26,
    "L": 59.0047874450684,
    "a": 6.64674139022827,
    "b": 20.7321186065674,
    "C": 21.7715396881104,
    "h": 72.2240905761719,
    "CMY_C": 0.34874296188354,
    "CMY_M": 0.4626579284668,
    "CMY_Y": 0.58784127235413,
    "CMYK_C": 0,
    "CMYK_M": 0.17491552233696,
    "CMYK_Y": 0.36713355779648,
    "CMYK_K": 0.34874296188354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05136",
    "Farbtonhilfsbezeichnung": "E8.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "128",
    "Bcolor": "87",
    "Y": 24,
    "L": 56.1628422577003,
    "a": 8.80052871364134,
    "b": 27.1365188800716,
    "C": 28.527880442965,
    "h": 1.25719249432249,
    "CMY_C": 0.3557892,
    "CMY_M": 0.497648,
    "CMY_Y": 0.6589442,
    "CMYK_C": 0,
    "CMYK_M": 0.2202056,
    "CMYK_Y": 0.4705834,
    "CMYK_K": 0.3557892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05137",
    "Farbtonhilfsbezeichnung": "E8.42.49",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "127",
    "Bcolor": "68",
    "Y": 25,
    "L": 56.7309243517466,
    "a": 12.6176217130259,
    "b": 38.3675177863241,
    "C": 40.3889935350823,
    "h": 1.25307528348754,
    "CMY_C": 0.3131543,
    "CMY_M": 0.5031884,
    "CMY_Y": 0.7332804,
    "CMYK_C": 0,
    "CMYK_M": 0.2766766,
    "CMYK_Y": 0.6116746,
    "CMYK_K": 0.3131543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05138",
    "Farbtonhilfsbezeichnung": "E9.57.52",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "132",
    "Bcolor": "42",
    "Y": 28,
    "L": 59.7218421837119,
    "a": 16.002535340935,
    "b": 54.4649120432291,
    "C": 56.7671364542422,
    "h": 1.28502468911901,
    "CMY_C": 0.2455156,
    "CMY_M": 0.4839572,
    "CMY_Y": 0.8372136,
    "CMYK_C": 0,
    "CMYK_M": 0.3160325,
    "CMYK_Y": 0.7842415,
    "CMYK_K": 0.2455156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05139",
    "Farbtonhilfsbezeichnung": "E8.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "124",
    "Bcolor": "116",
    "Y": 20,
    "L": 52.2049597077409,
    "a": 1.06565667324143,
    "b": 4.71558366414273,
    "C": 4.83449619285751,
    "h": 1.34854343581615,
    "CMY_C": 0.490762,
    "CMY_M": 0.5148913,
    "CMY_Y": 0.5467453,
    "CMYK_C": 0,
    "CMYK_M": 0.0473831,
    "CMYK_Y": 0.1099355,
    "CMYK_K": 0.490762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05140",
    "Farbtonhilfsbezeichnung": "E8.19.40",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "111",
    "Bcolor": "89",
    "Y": 17,
    "L": 48.3126628033402,
    "a": 5.11707222015784,
    "b": 14.9860865734236,
    "C": 15.8356313070385,
    "h": 1.2417542857107,
    "CMY_C": 0.4808646,
    "CMY_M": 0.5644255,
    "CMY_Y": 0.6511878,
    "CMYK_C": 0,
    "CMYK_M": 0.1609616,
    "CMYK_Y": 0.3280901,
    "CMYK_K": 0.4808646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05142",
    "Farbtonhilfsbezeichnung": "E9.34.41",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "108",
    "Bcolor": "67",
    "Y": 17,
    "L": 47.7000934738243,
    "a": 7.59804495217448,
    "b": 26.8889619497634,
    "C": 27.9418424917021,
    "h": 1.29540499041186,
    "CMY_C": 0.4536427,
    "CMY_M": 0.5781833,
    "CMY_Y": 0.7361549,
    "CMYK_C": 0,
    "CMYK_M": 0.2279471,
    "CMYK_Y": 0.5170832,
    "CMYK_K": 0.4536427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05143",
    "Farbtonhilfsbezeichnung": "E9.51.43",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "110",
    "Bcolor": "44",
    "Y": 19,
    "L": 50.1586585564226,
    "a": 12.8584742994466,
    "b": 42.4021675124526,
    "C": 44.308962649374,
    "h": 1.27636018725625,
    "CMY_C": 0.3812859,
    "CMY_M": 0.5692049,
    "CMY_Y": 0.8262078,
    "CMYK_C": 0,
    "CMYK_M": 0.3037251,
    "CMYK_Y": 0.7191074,
    "CMYK_K": 0.3812859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05144",
    "Farbtonhilfsbezeichnung": "E8.07.38",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "112",
    "Bcolor": "104",
    "Y": 16,
    "L": 47.5870377831312,
    "a": 1.65446962026189,
    "b": 4.56810681756181,
    "C": 4.85848429255712,
    "h": 1.22331361585779,
    "CMY_C": 0.5332687,
    "CMY_M": 0.5616549,
    "CMY_Y": 0.5904201,
    "CMYK_C": 0,
    "CMYK_M": 0.0608191,
    "CMYK_Y": 0.1224502,
    "CMYK_K": 0.5332687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05145",
    "Farbtonhilfsbezeichnung": "E8.08.29",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "87",
    "Bcolor": "80",
    "Y": 10,
    "L": 37.5702839110993,
    "a": 1.46907854801318,
    "b": 4.57159449397456,
    "C": 4.80184006372255,
    "h": 1.25986992442728,
    "CMY_C": 0.6316339,
    "CMY_M": 0.6571215,
    "CMY_Y": 0.6845218,
    "CMYK_C": 0,
    "CMYK_M": 0.06919095,
    "CMYK_Y": 0.1435742,
    "CMYK_K": 0.6316339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05146",
    "Farbtonhilfsbezeichnung": "E8.12.31",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "95",
    "Bcolor": "85",
    "Y": 11,
    "L": 40.9074516296387,
    "a": 2.43832945823669,
    "b": 6.66787099838257,
    "C": 7.09971523284912,
    "h": 69.9133758544922,
    "CMY_C": 0.58853614330292,
    "CMY_M": 0.62812507152557,
    "CMY_Y": 0.666807949543,
    "CMYK_C": 0,
    "CMYK_M": 0.09621483832598,
    "CMYK_Y": 0.19022765755653,
    "CMYK_K": 0.58853614330292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05148",
    "Farbtonhilfsbezeichnung": "E9.26.35",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "95",
    "Bcolor": "66",
    "Y": 13,
    "L": 42.0959031844938,
    "a": 5.78652335916752,
    "b": 19.8636277535161,
    "C": 20.6893102861465,
    "h": 1.28732863476579,
    "CMY_C": 0.5320051,
    "CMY_M": 0.6266949,
    "CMY_Y": 0.7401922,
    "CMYK_C": 0,
    "CMYK_M": 0.2023308,
    "CMYK_Y": 0.4448491,
    "CMYK_K": 0.5320051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05149",
    "Farbtonhilfsbezeichnung": "E8.41.40",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "106",
    "Bcolor": "59",
    "Y": 17,
    "L": 47.7741308432149,
    "a": 10.2897275009493,
    "b": 31.6373019094714,
    "C": 33.2685642033863,
    "h": 1.25634704457322,
    "CMY_C": 0.4319773,
    "CMY_M": 0.5846065,
    "CMY_Y": 0.7678913,
    "CMYK_C": 0,
    "CMYK_M": 0.2687027,
    "CMYK_Y": 0.5913743,
    "CMYK_K": 0.4319773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05150",
    "Farbtonhilfsbezeichnung": "E9.61.42",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "112",
    "Bcolor": "39",
    "Y": 20,
    "L": 51.343031520019,
    "a": 14.1547720202712,
    "b": 46.3074298377827,
    "C": 48.4224702914568,
    "h": 1.27414624537215,
    "CMY_C": 0.3578817,
    "CMY_M": 0.561402,
    "CMY_Y": 0.8473507,
    "CMYK_C": 0,
    "CMYK_M": 0.3169513,
    "CMYK_Y": 0.7622724,
    "CMYK_K": 0.3578817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05151",
    "Farbtonhilfsbezeichnung": "E7.04.25",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "79",
    "Bcolor": "73",
    "Y": 8,
    "L": 33.6388550815317,
    "a": 0.43906260718371,
    "b": 3.18115348656132,
    "C": 3.21131024320108,
    "h": 1.43364290976478,
    "CMY_C": 0.6784556,
    "CMY_M": 0.6912083,
    "CMY_Y": 0.7118519,
    "CMYK_C": 0,
    "CMYK_M": 0.03966077,
    "CMYK_Y": 0.1038622,
    "CMYK_K": 0.6784556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05152",
    "Farbtonhilfsbezeichnung": "E8.11.20",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "78",
    "Bcolor": "71",
    "Y": 6,
    "L": 33.4514198303223,
    "a": 1.56342101097107,
    "b": 4.54896831512451,
    "C": 4.81013488769531,
    "h": 71.032829284668,
    "CMY_C": 0.66986513137817,
    "CMY_M": 0.6954602599144,
    "CMY_Y": 0.72176229953766,
    "CMYK_C": 0,
    "CMYK_M": 0.07752931118011,
    "CMYK_Y": 0.15719990432262,
    "CMYK_K": 0.66986513137817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05153",
    "Farbtonhilfsbezeichnung": "E9.14.25",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "79",
    "Bcolor": "67",
    "Y": 8,
    "L": 34.5544736034319,
    "a": 2.99930313046745,
    "b": 8.73988333296253,
    "C": 9.24020454006447,
    "h": 1.24021522496459,
    "CMY_C": 0.6417408,
    "CMY_M": 0.689155,
    "CMY_Y": 0.737444,
    "CMYK_C": 0,
    "CMYK_M": 0.1323462,
    "CMYK_Y": 0.2671339,
    "CMYK_K": 0.6417408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05154",
    "Farbtonhilfsbezeichnung": "E9.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "70",
    "Bcolor": "56",
    "Y": 6,
    "L": 30.4835122476623,
    "a": 2.28153011396079,
    "b": 9.69744033159654,
    "C": 9.96221504715619,
    "h": 1.33972720996623,
    "CMY_C": 0.6824425,
    "CMY_M": 0.7249496,
    "CMY_Y": 0.7792147,
    "CMYK_C": 0,
    "CMYK_M": 0.1338564,
    "CMYK_Y": 0.3047391,
    "CMYK_K": 0.6824425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05155",
    "Farbtonhilfsbezeichnung": "E8.23.25",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "76",
    "Bcolor": "56",
    "Y": 8,
    "L": 33.4796396820787,
    "a": 4.61320378597904,
    "b": 13.9614157524288,
    "C": 14.7038355194534,
    "h": 1.25166535934639,
    "CMY_C": 0.6333788,
    "CMY_M": 0.7033942,
    "CMY_Y": 0.7789928,
    "CMYK_C": 0,
    "CMYK_M": 0.1909749,
    "CMYK_Y": 0.3971785,
    "CMYK_K": 0.6333788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05156",
    "Farbtonhilfsbezeichnung": "E9.33.33",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "92",
    "Bcolor": "59",
    "Y": 12,
    "L": 41.0393611781701,
    "a": 6.55246401987944,
    "b": 22.9321203185327,
    "C": 23.849883166076,
    "h": 1.29247934643939,
    "CMY_C": 0.5340899,
    "CMY_M": 0.6389232,
    "CMY_Y": 0.7697029,
    "CMYK_C": 0,
    "CMYK_M": 0.2250075,
    "CMYK_Y": 0.5057049,
    "CMYK_K": 0.5340899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05157",
    "Farbtonhilfsbezeichnung": "E9.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "86",
    "Bcolor": "53",
    "Y": 11,
    "L": 38.8977364590864,
    "a": 7.82357007730039,
    "b": 23.2946067366629,
    "C": 24.5732975355407,
    "h": 1.24677953757672,
    "CMY_C": 0.5485669,
    "CMY_M": 0.662001,
    "CMY_Y": 0.7907521,
    "CMYK_C": 0,
    "CMYK_M": 0.2512755,
    "CMYK_Y": 0.5364807,
    "CMYK_K": 0.5485669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05158",
    "Farbtonhilfsbezeichnung": "E9.49.36",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "98",
    "Bcolor": "53",
    "Y": 14,
    "L": 44.6091106651035,
    "a": 10.260442386351,
    "b": 31.2576914965187,
    "C": 32.8986315164502,
    "h": 1.25362469102502,
    "CMY_C": 0.4664705,
    "CMY_M": 0.6149319,
    "CMY_Y": 0.7938368,
    "CMYK_C": 0,
    "CMYK_M": 0.2782627,
    "CMYK_Y": 0.6135862,
    "CMYK_K": 0.4664705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05159",
    "Farbtonhilfsbezeichnung": "F0.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "228",
    "Bcolor": "209",
    "Y": 79,
    "L": 91.1146281088584,
    "a": 2.03604678445418,
    "b": 10.0281306050215,
    "C": 10.2327361902794,
    "h": 1.37048561732955,
    "CMY_C": 0.05253841,
    "CMY_M": 0.1070089,
    "CMY_Y": 0.1808373,
    "CMYK_C": 0,
    "CMYK_M": 0.05749094,
    "CMYK_Y": 0.1354133,
    "CMYK_K": 0.05253841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05160",
    "Farbtonhilfsbezeichnung": "F0.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "228",
    "Bcolor": "206",
    "Y": 80,
    "L": 91.5877856616432,
    "a": 3.31088841038757,
    "b": 12.0191817638872,
    "C": 12.4668645753212,
    "h": 1.30199596541743,
    "CMY_C": 0.03207157,
    "CMY_M": 0.1053601,
    "CMY_Y": 0.1902735,
    "CMYK_C": 0,
    "CMYK_M": 0.07571692,
    "CMYK_Y": 0.1634438,
    "CMYK_K": 0.03207157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05161",
    "Farbtonhilfsbezeichnung": "F1.14.84",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "189",
    "Y": 79,
    "L": 91.258918762207,
    "a": 5.31054973602295,
    "b": 20.9336547851563,
    "C": 21.5967559814453,
    "h": 75.7652282714844,
    "CMY_C": 0,
    "CMY_M": 0.11610013246536,
    "CMY_Y": 0.25989109277725,
    "CMYK_C": 0,
    "CMYK_M": 0.11610013246536,
    "CMYK_Y": 0.25989109277725,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05162",
    "Farbtonhilfsbezeichnung": "F1.27.79",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "144",
    "Y": 69,
    "L": 86.3451939942975,
    "a": 9.12110461338006,
    "b": 37.3469189334826,
    "C": 38.444595240324,
    "h": 1.33125895194153,
    "CMY_C": 0,
    "CMY_M": 0.1834072,
    "CMY_Y": 0.4341597,
    "CMYK_C": 0,
    "CMYK_M": 0.1834072,
    "CMYK_Y": 0.4341597,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05163",
    "Farbtonhilfsbezeichnung": "F1.49.75",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "85",
    "Y": 63,
    "L": 83.3880890716766,
    "a": 14.0593918190708,
    "b": 62.557735310864,
    "C": 64.1181467725501,
    "h": 1.34972683813666,
    "CMY_C": 0,
    "CMY_M": 0.2324171,
    "CMY_Y": 0.6665911,
    "CMYK_C": 0,
    "CMYK_M": 0.2324171,
    "CMYK_Y": 0.6665911,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05164",
    "Farbtonhilfsbezeichnung": "F0.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "214",
    "Y": 82,
    "L": 92.7477301203567,
    "a": 1.86327899035849,
    "b": 9.72838728794256,
    "C": 9.90521720206648,
    "h": 1.38155800762862,
    "CMY_C": 0.03625034,
    "CMY_M": 0.08829429,
    "CMY_Y": 0.1608065,
    "CMYK_C": 0,
    "CMYK_M": 0.05400153,
    "CMYK_Y": 0.1292412,
    "CMYK_K": 0.03625034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05165",
    "Farbtonhilfsbezeichnung": "F1.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "230",
    "Bcolor": "209",
    "Y": 81,
    "L": 92.1235669202334,
    "a": 2.14881197181221,
    "b": 11.4169032579299,
    "C": 11.617360840188,
    "h": 1.38475948139729,
    "CMY_C": 0.03631097,
    "CMY_M": 0.0963969,
    "CMY_Y": 0.1801478,
    "CMYK_C": 0,
    "CMYK_M": 0.06234992,
    "CMYK_Y": 0.1492565,
    "CMYK_K": 0.03631097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05166",
    "Farbtonhilfsbezeichnung": "F1.11.84",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "225",
    "Bcolor": "196",
    "Y": 78,
    "L": 90.6216803593008,
    "a": 3.92576606197925,
    "b": 16.3461036706543,
    "C": 16.8109114680069,
    "h": 1.33509510266379,
    "CMY_C": 0.02702546,
    "CMY_M": 0.1186962,
    "CMY_Y": 0.2327922,
    "CMYK_C": 0,
    "CMYK_M": 0.09421703,
    "CMYK_Y": 0.2114822,
    "CMYK_K": 0.02702546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05167",
    "Farbtonhilfsbezeichnung": "F1.22.79",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "206",
    "Bcolor": "152",
    "Y": 66,
    "L": 84.9142800990839,
    "a": 7.32276528297787,
    "b": 31.0583320296579,
    "C": 31.9099182050669,
    "h": 1.33925044777939,
    "CMY_C": 0.03630988,
    "CMY_M": 0.1932634,
    "CMY_Y": 0.4019884,
    "CMYK_C": 0,
    "CMYK_M": 0.1628672,
    "CMYK_Y": 0.3794565,
    "CMYK_K": 0.03630988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05168",
    "Farbtonhilfsbezeichnung": "F1.46.75",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "94",
    "Y": 62,
    "L": 83.1756651627622,
    "a": 13.7155292747316,
    "b": 58.2475932709055,
    "C": 59.8406038166299,
    "h": 1.33953952299054,
    "CMY_C": 0,
    "CMY_M": 0.2332384,
    "CMY_Y": 0.6312992,
    "CMYK_C": 0,
    "CMYK_M": 0.2332384,
    "CMYK_Y": 0.6312992,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05169",
    "Farbtonhilfsbezeichnung": "F0.64.69",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "177",
    "Bcolor": "30",
    "Y": 54,
    "L": 78.2853722712675,
    "a": 20.8247928761686,
    "b": 76.7065987127685,
    "C": 79.483169818629,
    "h": 1.30569967355212,
    "CMY_C": 0,
    "CMY_M": 0.3073241,
    "CMY_Y": 0.8815982,
    "CMYK_C": 0,
    "CMYK_M": 0.3073241,
    "CMYK_Y": 0.8815982,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05170",
    "Farbtonhilfsbezeichnung": "E9.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "211",
    "Y": 81,
    "L": 92.2692944227504,
    "a": 2.58576884783723,
    "b": 10.4777508354219,
    "C": 10.7921018853433,
    "h": 1.32884428843689,
    "CMY_C": 0.03407487,
    "CMY_M": 0.09559119,
    "CMY_Y": 0.1715008,
    "CMYK_C": 0,
    "CMYK_M": 0.06368643,
    "CMYK_Y": 0.1422739,
    "CMYK_K": 0.03407487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05171",
    "Farbtonhilfsbezeichnung": "F0.50.70",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "181",
    "Bcolor": "77",
    "Y": 54,
    "L": 78.4986128968149,
    "a": 16.0381082815397,
    "b": 60.5915699671878,
    "C": 62.678220047629,
    "h": 1.31203833966023,
    "CMY_C": 0.01673766,
    "CMY_M": 0.2900047,
    "CMY_Y": 0.6990343,
    "CMYK_C": 0,
    "CMYK_M": 0.2779187,
    "CMYK_Y": 0.6939111,
    "CMYK_K": 0.01673766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05172",
    "Farbtonhilfsbezeichnung": "F9.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "229",
    "Bcolor": "215",
    "Y": 79,
    "L": 91.4099931022647,
    "a": 2.06445435368202,
    "b": 7.17742608361884,
    "C": 7.46842801158643,
    "h": 1.29072498067084,
    "CMY_C": 0.05742021,
    "CMY_M": 0.1030332,
    "CMY_Y": 0.1564582,
    "CMYK_C": 0,
    "CMYK_M": 0.0483917,
    "CMYK_Y": 0.1050712,
    "CMYK_K": 0.05742021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05173",
    "Farbtonhilfsbezeichnung": "F0.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "229",
    "Bcolor": "210",
    "Y": 80,
    "L": 91.6886652341467,
    "a": 2.49353948333625,
    "b": 10.2225680958921,
    "C": 10.5222924132581,
    "h": 1.33154347329958,
    "CMY_C": 0.04207009,
    "CMY_M": 0.1017757,
    "CMY_Y": 0.1759531,
    "CMYK_C": 0,
    "CMYK_M": 0.06232773,
    "CMYK_Y": 0.1397628,
    "CMYK_K": 0.04207009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05174",
    "Farbtonhilfsbezeichnung": "F0.23.75",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "198",
    "Bcolor": "147",
    "Y": 61,
    "L": 82.1697109933842,
    "a": 8.33947287602316,
    "b": 30.0238931933602,
    "C": 31.1605675547835,
    "h": 1.29986485830887,
    "CMY_C": 0.06315748,
    "CMY_M": 0.2254778,
    "CMY_Y": 0.4224464,
    "CMYK_C": 0,
    "CMYK_M": 0.1732631,
    "CMYK_Y": 0.3835104,
    "CMYK_K": 0.06315748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05175",
    "Farbtonhilfsbezeichnung": "F0.72.69",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "167",
    "Bcolor": "13",
    "Y": 48,
    "L": 75.1007256330439,
    "a": 22.2251437575467,
    "b": 77.0795545740191,
    "C": 80.2197902538569,
    "h": 1.29007050857696,
    "CMY_C": 0.01032277,
    "CMY_M": 0.345052,
    "CMY_Y": 0.9501464,
    "CMYK_C": 0,
    "CMYK_M": 0.3382206,
    "CMYK_Y": 0.9496264,
    "CMYK_K": 0.01032277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05176",
    "Farbtonhilfsbezeichnung": "FN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "221",
    "Bcolor": "212",
    "Y": 73,
    "L": 88.2119648533046,
    "a": 0.49025178563094,
    "b": 4.02040525295773,
    "C": 4.05018582429552,
    "h": 1.44945450660288,
    "CMY_C": 0.1150422,
    "CMY_M": 0.1339232,
    "CMY_Y": 0.1683338,
    "CMYK_C": 0,
    "CMYK_M": 0.02133549,
    "CMYK_Y": 0.06021936,
    "CMYK_K": 0.1150422
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05177",
    "Farbtonhilfsbezeichnung": "F1.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "219",
    "Bcolor": "200",
    "Y": 72,
    "L": 87.9563693659585,
    "a": 2.47862950542793,
    "b": 9.85649072478045,
    "C": 10.1633662549797,
    "h": 1.32443291663884,
    "CMY_C": 0.08526517,
    "CMY_M": 0.143061,
    "CMY_Y": 0.2137715,
    "CMYK_C": 0,
    "CMYK_M": 0.06318317,
    "CMYK_Y": 0.1404848,
    "CMYK_K": 0.08526517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05178",
    "Farbtonhilfsbezeichnung": "F1.11.78",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "212",
    "Bcolor": "185",
    "Y": 68,
    "L": 86.1578402170134,
    "a": 3.61971918540976,
    "b": 15.5249860619251,
    "C": 15.9413788363552,
    "h": 1.34173407173344,
    "CMY_C": 0.08189836,
    "CMY_M": 0.1670585,
    "CMY_Y": 0.2746107,
    "CMYK_C": 0,
    "CMYK_M": 0.09275679,
    "CMYK_Y": 0.209903,
    "CMYK_K": 0.08189836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05179",
    "Farbtonhilfsbezeichnung": "F1.19.74",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "196",
    "Bcolor": "154",
    "Y": 59,
    "L": 81.1355835950607,
    "a": 6.20500053937056,
    "b": 24.93467059517,
    "C": 25.6951324064155,
    "h": 1.32690001600608,
    "CMY_C": 0.09912576,
    "CMY_M": 0.2303005,
    "CMY_Y": 0.3960117,
    "CMYK_C": 0,
    "CMYK_M": 0.1456083,
    "CMYK_Y": 0.3295532,
    "CMYK_K": 0.09912576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05180",
    "Farbtonhilfsbezeichnung": "F1.60.68",
    "Farbtonklasse": "03",
    "Rcolor": "244",
    "Gcolor": "173",
    "Bcolor": "36",
    "Y": 49,
    "L": 75.6739818926752,
    "a": 15.9724025109628,
    "b": 72.5350453704507,
    "C": 74.2728109665008,
    "h": 1.35405282356086,
    "CMY_C": 0.04188091,
    "CMY_M": 0.3210364,
    "CMY_Y": 0.8601781,
    "CMYK_C": 0,
    "CMYK_M": 0.2913578,
    "CMYK_Y": 0.8540662,
    "CMYK_K": 0.04188091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05181",
    "Farbtonhilfsbezeichnung": "F0.06.75",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "202",
    "Bcolor": "187",
    "Y": 60,
    "L": 82.0851272051694,
    "a": 2.21613897415412,
    "b": 8.42782974436829,
    "C": 8.71433222644304,
    "h": 1.31366248575087,
    "CMY_C": 0.1565983,
    "CMY_M": 0.2064659,
    "CMY_Y": 0.2664253,
    "CMYK_C": 0,
    "CMYK_M": 0.05912678,
    "CMYK_Y": 0.1302191,
    "CMYK_K": 0.1565983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05182",
    "Farbtonhilfsbezeichnung": "F0.12.74",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "200",
    "Bcolor": "173",
    "Y": 60,
    "L": 82.0411024110984,
    "a": 4.4287031738463,
    "b": 16.0304379461805,
    "C": 16.6309456300109,
    "h": 1.30125129291462,
    "CMY_C": 0.121128,
    "CMY_M": 0.2141363,
    "CMY_Y": 0.3217979,
    "CMYK_C": 0,
    "CMYK_M": 0.1058269,
    "CMYK_Y": 0.2283267,
    "CMYK_K": 0.121128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05183",
    "Farbtonhilfsbezeichnung": "F1.14.74",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "198",
    "Bcolor": "167",
    "Y": 59,
    "L": 81.0761662048369,
    "a": 4.54090866537959,
    "b": 18.0271200474128,
    "C": 18.5902369191775,
    "h": 1.32403663877271,
    "CMY_C": 0.1263537,
    "CMY_M": 0.2253475,
    "CMY_Y": 0.3464513,
    "CMYK_C": 0,
    "CMYK_M": 0.1133111,
    "CMYK_Y": 0.2519298,
    "CMYK_K": 0.1263537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05184",
    "Farbtonhilfsbezeichnung": "F1.22.71",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "191",
    "Bcolor": "145",
    "Y": 56,
    "L": 79.4276803653514,
    "a": 6.93897863555459,
    "b": 27.2535123780835,
    "C": 28.1230041326853,
    "h": 1.32148488315947,
    "CMY_C": 0.1089924,
    "CMY_M": 0.2510376,
    "CMY_Y": 0.4304913,
    "CMYK_C": 0,
    "CMYK_M": 0.1594209,
    "CMYK_Y": 0.3608262,
    "CMYK_K": 0.1089924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05185",
    "Farbtonhilfsbezeichnung": "F2.24.71",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "188",
    "Bcolor": "139",
    "Y": 53,
    "L": 78.1437150037297,
    "a": 5.21690334791214,
    "b": 28.8294911064605,
    "C": 29.2977070433668,
    "h": 1.39177640502078,
    "CMY_C": 0.1318987,
    "CMY_M": 0.2609229,
    "CMY_Y": 0.4555569,
    "CMYK_C": 0,
    "CMYK_M": 0.1486281,
    "CMYK_Y": 0.3728347,
    "CMYK_K": 0.1318987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05186",
    "Farbtonhilfsbezeichnung": "F1.44.62",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "159",
    "Bcolor": "77",
    "Y": 40,
    "L": 69.142760827583,
    "a": 11.4322541320916,
    "b": 49.2790200345348,
    "C": 50.5877282560188,
    "h": 1.34283846937574,
    "CMY_C": 0.1665084,
    "CMY_M": 0.3749404,
    "CMY_Y": 0.6990511,
    "CMYK_C": 0,
    "CMYK_M": 0.250071,
    "CMYK_Y": 0.6389299,
    "CMYK_K": 0.1665084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05187",
    "Farbtonhilfsbezeichnung": "F1.69.66",
    "Farbtonklasse": "04",
    "Rcolor": "247",
    "Gcolor": "167",
    "Bcolor": "0",
    "Y": 48,
    "L": 74.5553509355915,
    "a": 19.5277791735931,
    "b": 79.1610440716584,
    "C": 81.534072987725,
    "h": 1.32894083901472,
    "CMY_C": 0.03123846,
    "CMY_M": 0.3432187,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3220402,
    "CMYK_Y": 1,
    "CMYK_K": 0.03123846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05188",
    "Farbtonhilfsbezeichnung": "FN.02.66",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "181",
    "Bcolor": "175",
    "Y": 46,
    "L": 73.7381481274272,
    "a": 0.36440312804419,
    "b": 2.82333916474515,
    "C": 2.84675845110052,
    "h": 1.44243780723871,
    "CMY_C": 0.2777007,
    "CMY_M": 0.2906515,
    "CMY_Y": 0.314978,
    "CMYK_C": 0,
    "CMYK_M": 0.01792988,
    "CMYK_Y": 0.05160918,
    "CMYK_K": 0.2777007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05189",
    "Farbtonhilfsbezeichnung": "F1.21.67",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "178",
    "Bcolor": "136",
    "Y": 48,
    "L": 74.6017211508568,
    "a": 6.73638501889812,
    "b": 25.6151695707445,
    "C": 26.4861434576804,
    "h": 1.31363505867902,
    "CMY_C": 0.1679419,
    "CMY_M": 0.301846,
    "CMY_Y": 0.4678029,
    "CMYK_C": 0,
    "CMYK_M": 0.1609311,
    "CMYK_Y": 0.3603847,
    "CMYK_K": 0.1679419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05190",
    "Farbtonhilfsbezeichnung": "F1.23.70",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "187",
    "Bcolor": "139",
    "Y": 53,
    "L": 77.9700169375542,
    "a": 7.36081284443951,
    "b": 28.3440681866638,
    "C": 29.2842580083757,
    "h": 1.31671397510521,
    "CMY_C": 0.120699,
    "CMY_M": 0.2679684,
    "CMY_Y": 0.4533189,
    "CMYK_C": 0,
    "CMYK_M": 0.1674846,
    "CMYK_Y": 0.3782776,
    "CMYK_K": 0.120699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05191",
    "Farbtonhilfsbezeichnung": "F1.60.60",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "152",
    "Bcolor": "40",
    "Y": 37,
    "L": 67.6341449093908,
    "a": 16.0313500666637,
    "b": 63.1849408262498,
    "C": 65.1869690365843,
    "h": 1.32231856887923,
    "CMY_C": 0.1454965,
    "CMY_M": 0.4042385,
    "CMY_Y": 0.8420775,
    "CMYK_C": 0,
    "CMYK_M": 0.3027981,
    "CMYK_Y": 0.815188,
    "CMYK_K": 0.1454965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05192",
    "Farbtonhilfsbezeichnung": "F0.71.64",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "160",
    "Bcolor": "0",
    "Y": 44,
    "L": 72.3263057170436,
    "a": 21.8870251586847,
    "b": 76.289720174872,
    "C": 79.3672682826943,
    "h": 1.29140678680644,
    "CMY_C": 0.04717457,
    "CMY_M": 0.3730775,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3420384,
    "CMYK_Y": 1,
    "CMYK_K": 0.04717457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05193",
    "Farbtonhilfsbezeichnung": "F0.08.63",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "171",
    "Bcolor": "155",
    "Y": 41,
    "L": 70.4867670248195,
    "a": 2.19201404051833,
    "b": 8.74168350456781,
    "C": 9.01232245583027,
    "h": 1.32510793434573,
    "CMY_C": 0.282113,
    "CMY_M": 0.3308486,
    "CMY_Y": 0.3903891,
    "CMYK_C": 0,
    "CMYK_M": 0.06788756,
    "CMYK_Y": 0.1508261,
    "CMYK_K": 0.282113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05194",
    "Farbtonhilfsbezeichnung": "F0.11.59",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "158",
    "Bcolor": "139",
    "Y": 35,
    "L": 66.086836922773,
    "a": 3.30147842901279,
    "b": 11.6463768084345,
    "C": 12.1052820116376,
    "h": 1.29456644348611,
    "CMY_C": 0.3140424,
    "CMY_M": 0.3801984,
    "CMY_Y": 0.4554761,
    "CMYK_C": 0,
    "CMYK_M": 0.09644331,
    "CMYK_Y": 0.2061844,
    "CMYK_K": 0.3140424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05195",
    "Farbtonhilfsbezeichnung": "F1.17.61",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "162",
    "Bcolor": "132",
    "Y": 38,
    "L": 68.1662047068763,
    "a": 4.50129992396409,
    "b": 18.5555936406981,
    "C": 19.093762237029,
    "h": 1.33280901640696,
    "CMY_C": 0.2678922,
    "CMY_M": 0.3628526,
    "CMY_Y": 0.4827037,
    "CMYK_C": 0,
    "CMYK_M": 0.1297083,
    "CMYK_Y": 0.2934152,
    "CMYK_K": 0.2678922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05196",
    "Farbtonhilfsbezeichnung": "F0.25.60",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "157",
    "Bcolor": "113",
    "Y": 36,
    "L": 66.7735900878906,
    "a": 7.34114933013916,
    "b": 26.9568710327148,
    "C": 27.9386005401611,
    "h": 74.7660980224609,
    "CMY_C": 0.24879223108292,
    "CMY_M": 0.38579761981964,
    "CMY_Y": 0.55554592609406,
    "CMYK_C": 0,
    "CMYK_M": 0.18238015472889,
    "CMYK_Y": 0.40834733843803,
    "CMYK_K": 0.24879223108292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05197",
    "Farbtonhilfsbezeichnung": "F1.52.60",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "152",
    "Bcolor": "60",
    "Y": 36,
    "L": 66.3600491739439,
    "a": 11.3478164634303,
    "b": 53.7452730042327,
    "C": 54.9302039754742,
    "h": 1.36271182989778,
    "CMY_C": 0.1949872,
    "CMY_M": 0.404078,
    "CMY_Y": 0.7646266,
    "CMYK_C": 0,
    "CMYK_M": 0.2597361,
    "CMYK_Y": 0.7076153,
    "CMYK_K": 0.1949872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05198",
    "Farbtonhilfsbezeichnung": "F0.66.63",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "158",
    "Bcolor": "31",
    "Y": 42,
    "L": 71.0882775091993,
    "a": 19.4687766378879,
    "b": 69.692463678347,
    "C": 72.3607128028303,
    "h": 1.29838798240678,
    "CMY_C": 0.07990281,
    "CMY_M": 0.3785262,
    "CMY_Y": 0.8793582,
    "CMYK_C": 0,
    "CMYK_M": 0.3245564,
    "CMYK_Y": 0.8688814,
    "CMYK_K": 0.07990281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05199",
    "Farbtonhilfsbezeichnung": "F0.46.54",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "132",
    "Bcolor": "61",
    "Y": 27,
    "L": 58.9431980237119,
    "a": 12.1629352717706,
    "b": 44.66890507854,
    "C": 46.2952273494892,
    "h": 1.30495050772799,
    "CMY_C": 0.2842581,
    "CMY_M": 0.4806519,
    "CMY_Y": 0.7610296,
    "CMYK_C": 0,
    "CMYK_M": 0.274392,
    "CMYK_Y": 0.6661221,
    "CMYK_K": 0.2842581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05200",
    "Farbtonhilfsbezeichnung": "F1.65.56",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "149",
    "Bcolor": "35",
    "Y": 36,
    "L": 66.8768635730162,
    "a": 17.3178159413407,
    "b": 64.3629548822462,
    "C": 66.6520570586701,
    "h": 1.30795620348592,
    "CMY_C": 0.146518,
    "CMY_M": 0.4156518,
    "CMY_Y": 0.8644266,
    "CMYK_C": 0,
    "CMYK_M": 0.3153362,
    "CMYK_Y": 0.8411525,
    "CMYK_K": 0.146518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05201",
    "Farbtonhilfsbezeichnung": "F1.13.48",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "127",
    "Bcolor": "108",
    "Y": 22,
    "L": 53.8799941186614,
    "a": 2.47025570161408,
    "b": 11.7927022069117,
    "C": 12.0486509025806,
    "h": 1.36430868389367,
    "CMY_C": 0.4470027,
    "CMY_M": 0.5028648,
    "CMY_Y": 0.5773824,
    "CMYK_C": 0,
    "CMYK_M": 0.101017,
    "CMYK_Y": 0.2357693,
    "CMYK_K": 0.4470027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05202",
    "Farbtonhilfsbezeichnung": "F1.25.44",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "123",
    "Bcolor": "90",
    "Y": 21,
    "L": 53.2602939254987,
    "a": 4.86393988798045,
    "b": 21.5246322936365,
    "C": 22.0673448019952,
    "h": 1.34855798866806,
    "CMY_C": 0.4192573,
    "CMY_M": 0.5163488,
    "CMY_Y": 0.6485205,
    "CMYK_C": 0,
    "CMYK_M": 0.1671851,
    "CMYK_Y": 0.3947758,
    "CMYK_K": 0.4192573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05203",
    "Farbtonhilfsbezeichnung": "F0.32.49",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "130",
    "Bcolor": "84",
    "Y": 25,
    "L": 56.633182151713,
    "a": 7.59630299883651,
    "b": 29.2150164598601,
    "C": 30.1864374512798,
    "h": 1.3164154847031,
    "CMY_C": 0.3547605,
    "CMY_M": 0.4903801,
    "CMY_Y": 0.6693505,
    "CMYK_C": 0,
    "CMYK_M": 0.2101849,
    "CMYK_Y": 0.4875554,
    "CMYK_K": 0.3547605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05204",
    "Farbtonhilfsbezeichnung": "F0.40.47",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "121",
    "Bcolor": "62",
    "Y": 22,
    "L": 53.9128818226107,
    "a": 10.1801339667933,
    "b": 37.7818060239572,
    "C": 39.1292728531184,
    "h": 1.3076014780025,
    "CMY_C": 0.3588631,
    "CMY_M": 0.5250368,
    "CMY_Y": 0.7560968,
    "CMYK_C": 0,
    "CMYK_M": 0.2591858,
    "CMYK_Y": 0.619577,
    "CMYK_K": 0.3588631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05205",
    "Farbtonhilfsbezeichnung": "F0.56.51",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "129",
    "Bcolor": "41",
    "Y": 26,
    "L": 58.2466133675804,
    "a": 14.6831159354902,
    "b": 52.9250430866873,
    "C": 54.9240755889688,
    "h": 1.30017024380417,
    "CMY_C": 0.2710703,
    "CMY_M": 0.4951074,
    "CMY_Y": 0.8384276,
    "CMYK_C": 0,
    "CMYK_M": 0.3073508,
    "CMYK_Y": 0.778343,
    "CMYK_K": 0.2710703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05206",
    "Farbtonhilfsbezeichnung": "F1.03.27",
    "Farbtonklasse": "02",
    "Rcolor": "92",
    "Gcolor": "89",
    "Bcolor": "87",
    "Y": 9,
    "L": 38.1152458190918,
    "a": 0.49747231602669,
    "b": 1.4083878993988,
    "C": 1.49366497993469,
    "h": 70.5457077026367,
    "CMY_C": 0.64091825485229,
    "CMY_M": 0.64929497241974,
    "CMY_Y": 0.6598749756813,
    "CMYK_C": 0,
    "CMYK_M": 0.02332816272974,
    "CMYK_Y": 0.05279221385717,
    "CMYK_K": 0.64091825485229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05207",
    "Farbtonhilfsbezeichnung": "F0.09.40",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "110",
    "Bcolor": "98",
    "Y": 16,
    "L": 47.0442489982073,
    "a": 2.17924872142033,
    "b": 7.43730939503442,
    "C": 7.75001264691093,
    "h": 1.28575936226845,
    "CMY_C": 0.5280667,
    "CMY_M": 0.5687328,
    "CMY_Y": 0.6141961,
    "CMYK_C": 0,
    "CMYK_M": 0.08616915,
    "CMYK_Y": 0.1825032,
    "CMYK_K": 0.5280667
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05208",
    "Farbtonhilfsbezeichnung": "F0.14.38",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "104",
    "Bcolor": "87",
    "Y": 14,
    "L": 44.9276082168816,
    "a": 2.90216662730991,
    "b": 11.2593877069696,
    "C": 11.6273979319764,
    "h": 1.3185320007401,
    "CMY_C": 0.5360203,
    "CMY_M": 0.59163,
    "CMY_Y": 0.6588171,
    "CMYK_C": 0,
    "CMYK_M": 0.1198538,
    "CMYK_Y": 0.2646599,
    "CMYK_K": 0.5360203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05209",
    "Farbtonhilfsbezeichnung": "F1.24.44",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "116",
    "Bcolor": "84",
    "Y": 19,
    "L": 50.2560148125436,
    "a": 5.22292901141103,
    "b": 20.6540467617202,
    "C": 21.30419289937,
    "h": 1.32311193625865,
    "CMY_C": 0.4500215,
    "CMY_M": 0.5467001,
    "CMY_Y": 0.6707539,
    "CMYK_C": 0,
    "CMYK_M": 0.1757862,
    "CMYK_Y": 0.4013473,
    "CMYK_K": 0.4500215
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05210",
    "Farbtonhilfsbezeichnung": "F0.29.35",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "96",
    "Bcolor": "64",
    "Y": 13,
    "L": 42.3463137180375,
    "a": 5.38979698773295,
    "b": 21.6735341834142,
    "C": 22.3336516398148,
    "h": 1.32705942397397,
    "CMY_C": 0.5290143,
    "CMY_M": 0.6237223,
    "CMY_Y": 0.7499401,
    "CMYK_C": 0,
    "CMYK_M": 0.2010845,
    "CMYK_Y": 0.4690711,
    "CMYK_K": 0.5290143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05211",
    "Farbtonhilfsbezeichnung": "F1.41.41",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "110",
    "Bcolor": "59",
    "Y": 17,
    "L": 48.6855033439771,
    "a": 7.87676726671988,
    "b": 32.6779944466735,
    "C": 33.6139075924073,
    "h": 1.33426638379067,
    "CMY_C": 0.4344008,
    "CMY_M": 0.5701045,
    "CMY_Y": 0.7676833,
    "CMYK_C": 0,
    "CMYK_M": 0.2399291,
    "CMYK_Y": 0.5892555,
    "CMYK_K": 0.4344008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05212",
    "Farbtonhilfsbezeichnung": "F1.56.44",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "115",
    "Bcolor": "43",
    "Y": 20,
    "L": 52.1822959635185,
    "a": 13.1405103847385,
    "b": 45.2892425310114,
    "C": 47.1570620607793,
    "h": 1.28840387320481,
    "CMY_C": 0.3547035,
    "CMY_M": 0.5504497,
    "CMY_Y": 0.8307905,
    "CMYK_C": 0,
    "CMYK_M": 0.3033431,
    "CMYK_Y": 0.7377803,
    "CMYK_K": 0.3547035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05213",
    "Farbtonhilfsbezeichnung": "FN.01.21",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "67",
    "Bcolor": "66",
    "Y": 6,
    "L": 28.2931465868953,
    "a": 0.13563540797409,
    "b": 0.24860053971215,
    "C": 0.28319461901927,
    "h": 1.07134075395948,
    "CMY_C": 0.7367625,
    "CMY_M": 0.7384352,
    "CMY_Y": 0.7420483,
    "CMYK_C": 0,
    "CMYK_M": 0.006354216,
    "CMYK_Y": 0.02007986,
    "CMYK_K": 0.7367625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05214",
    "Farbtonhilfsbezeichnung": "F1.03.21",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "73",
    "Bcolor": "70",
    "Y": 7,
    "L": 31.0179879692758,
    "a": 0.53355849327482,
    "b": 1.56770796218352,
    "C": 1.6560171860338,
    "h": 1.24275035867575,
    "CMY_C": 0.7061062,
    "CMY_M": 0.7149653,
    "CMY_Y": 0.7256151,
    "CMYK_C": 0,
    "CMYK_M": 0.0301439,
    "CMYK_Y": 0.0663807,
    "CMYK_K": 0.7061062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05215",
    "Farbtonhilfsbezeichnung": "F1.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "61",
    "Y": 6,
    "L": 29.3637184816853,
    "a": 1.27238387276785,
    "b": 5.10442725799795,
    "C": 5.26062147962312,
    "h": 1.32650423355282,
    "CMY_C": 0.7080961,
    "CMY_M": 0.7321067,
    "CMY_Y": 0.7614292,
    "CMYK_C": 0,
    "CMYK_M": 0.08225515,
    "CMYK_Y": 0.1827075,
    "CMYK_K": 0.7080961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05216",
    "Farbtonhilfsbezeichnung": "F0.14.12",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "53",
    "Bcolor": "48",
    "Y": 4,
    "L": 22.4978258510907,
    "a": 1.88952612081442,
    "b": 3.97243512760551,
    "C": 4.39892598304111,
    "h": 1.12681011430834,
    "CMY_C": 0.7685951,
    "CMY_M": 0.7934651,
    "CMY_Y": 0.8137106,
    "CMYK_C": 0,
    "CMYK_M": 0.1074741,
    "CMYK_Y": 0.1949636,
    "CMYK_K": 0.7685951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05217",
    "Farbtonhilfsbezeichnung": "F1.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "72",
    "Bcolor": "59",
    "Y": 7,
    "L": 31.4484982436443,
    "a": 2.27011384203485,
    "b": 9.16828946490619,
    "C": 9.44515476676312,
    "h": 1.32807309686591,
    "CMY_C": 0.6744869,
    "CMY_M": 0.7161056,
    "CMY_Y": 0.7675948,
    "CMYK_C": 0,
    "CMYK_M": 0.1278556,
    "CMYK_Y": 0.2860341,
    "CMYK_K": 0.6744869
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05218",
    "Farbtonhilfsbezeichnung": "F0.16.24",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "81",
    "Bcolor": "68",
    "Y": 8,
    "L": 34.8877201935206,
    "a": 1.97059848664924,
    "b": 8.7878165735805,
    "C": 9.00605232754509,
    "h": 1.35020337681658,
    "CMY_C": 0.644558,
    "CMY_M": 0.6839668,
    "CMY_Y": 0.734918,
    "CMYK_C": 0,
    "CMYK_M": 0.1108726,
    "CMYK_Y": 0.2542188,
    "CMYK_K": 0.644558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05219",
    "Farbtonhilfsbezeichnung": "F1.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "71",
    "Bcolor": "52",
    "Y": 7,
    "L": 31.2099453066073,
    "a": 3.57189617699472,
    "b": 13.8279650545142,
    "C": 14.2818437131939,
    "h": 1.31801227984733,
    "CMY_C": 0.6611712,
    "CMY_M": 0.7217799,
    "CMY_Y": 0.7979903,
    "CMYK_C": 0,
    "CMYK_M": 0.1788772,
    "CMYK_Y": 0.4038,
    "CMYK_K": 0.6611712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05220",
    "Farbtonhilfsbezeichnung": "F1.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "88",
    "Bcolor": "52",
    "Y": 11,
    "L": 39.7007371199274,
    "a": 7.07859481119966,
    "b": 24.9660740821246,
    "C": 25.9501707041645,
    "h": 1.29451860593986,
    "CMY_C": 0.5423094,
    "CMY_M": 0.6530191,
    "CMY_Y": 0.7949944,
    "CMYK_C": 0,
    "CMYK_M": 0.2418876,
    "CMYK_Y": 0.5520868,
    "CMYK_K": 0.5423094
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05221",
    "Farbtonhilfsbezeichnung": "F1.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "232",
    "Bcolor": "209",
    "Y": 83,
    "L": 92.9250259399414,
    "a": 3.26858472824097,
    "b": 12.872462272644,
    "C": 13.2809610366821,
    "h": 75.7525253295898,
    "CMY_C": 0.01481199264526,
    "CMY_M": 0.09051924943924,
    "CMY_Y": 0.18207997083664,
    "CMYK_C": 0,
    "CMYK_M": 0.07684548944235,
    "CMYK_Y": 0.16978280246258,
    "CMYK_K": 0.01481199264526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05222",
    "Farbtonhilfsbezeichnung": "F1.17.82",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "218",
    "Bcolor": "175",
    "Y": 74,
    "L": 88.7208938598633,
    "a": 5.33469724655151,
    "b": 24.5306339263916,
    "C": 25.10400390625,
    "h": 77.7308807373047,
    "CMY_C": 0.01930642127991,
    "CMY_M": 0.14508301019669,
    "CMY_Y": 0.31376898288727,
    "CMYK_C": 0,
    "CMYK_M": 0.12825268507004,
    "CMYK_Y": 0.30025950074196,
    "CMYK_K": 0.01930642127991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05223",
    "Farbtonhilfsbezeichnung": "F3.21.82",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "219",
    "Bcolor": "168",
    "Y": 74,
    "L": 89.1351122668789,
    "a": 5.55721399490217,
    "b": 29.0406977047116,
    "C": 29.5676301140551,
    "h": 1.38172255602672,
    "CMY_C": 0.0034125,
    "CMY_M": 0.1420742,
    "CMY_Y": 0.3431183,
    "CMYK_C": 0,
    "CMYK_M": 0.1391365,
    "CMYK_Y": 0.340869,
    "CMYK_K": 0.0034125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05224",
    "Farbtonhilfsbezeichnung": "F2.37.78",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "201",
    "Bcolor": "118",
    "Y": 65,
    "L": 84.4310038200248,
    "a": 11.096951177648,
    "b": 48.1211936399515,
    "C": 49.3841229827241,
    "h": 1.34415413510435,
    "CMY_C": 0,
    "CMY_M": 0.2112442,
    "CMY_Y": 0.5365856,
    "CMYK_C": 0,
    "CMYK_M": 0.2112442,
    "CMYK_Y": 0.5365856,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05225",
    "Farbtonhilfsbezeichnung": "F2.41.78",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "104",
    "Y": 66,
    "L": 85.1778653367688,
    "a": 10.8491087905838,
    "b": 55.8745541693676,
    "C": 56.9180899642242,
    "h": 1.3790136901029,
    "CMY_C": 0,
    "CMY_M": 0.2036266,
    "CMY_Y": 0.5917972,
    "CMYK_C": 0,
    "CMYK_M": 0.2036266,
    "CMYK_Y": 0.5917972,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05226",
    "Farbtonhilfsbezeichnung": "F3.11.83",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "223",
    "Bcolor": "196",
    "Y": 76,
    "L": 89.7007110091684,
    "a": 2.62022610470702,
    "b": 14.9200299478774,
    "C": 15.1483622377254,
    "h": 1.39695106863709,
    "CMY_C": 0.05067335,
    "CMY_M": 0.1253739,
    "CMY_Y": 0.2323431,
    "CMYK_C": 0,
    "CMYK_M": 0.07868791,
    "CMYK_Y": 0.1913669,
    "CMYK_K": 0.05067335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05227",
    "Farbtonhilfsbezeichnung": "F2.59.75",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "193",
    "Bcolor": "49",
    "Y": 62,
    "L": 82.9416066558327,
    "a": 15.9349801710249,
    "b": 75.7211808865843,
    "C": 77.3797184532858,
    "h": 1.36338003706809,
    "CMY_C": 0,
    "CMY_M": 0.2437612,
    "CMY_Y": 0.8067459,
    "CMYK_C": 0,
    "CMYK_M": 0.2437612,
    "CMYK_Y": 0.8067459,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05228",
    "Farbtonhilfsbezeichnung": "F3.11.84",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "229",
    "Bcolor": "200",
    "Y": 80,
    "L": 91.6771771230687,
    "a": 2.61902253649715,
    "b": 15.610439744403,
    "C": 15.8286167450071,
    "h": 1.40457064849135,
    "CMY_C": 0.0264215,
    "CMY_M": 0.1035736,
    "CMY_Y": 0.2161438,
    "CMYK_C": 0,
    "CMYK_M": 0.07924588,
    "CMYK_Y": 0.1948711,
    "CMYK_K": 0.0264215
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05229",
    "Farbtonhilfsbezeichnung": "F2.13.81",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "221",
    "Bcolor": "188",
    "Y": 75,
    "L": 89.1908702894004,
    "a": 3.58865214313631,
    "b": 18.123160599568,
    "C": 18.4750473428939,
    "h": 1.37531043952821,
    "CMY_C": 0.04124899,
    "CMY_M": 0.1341574,
    "CMY_Y": 0.2614153,
    "CMYK_C": 0,
    "CMYK_M": 0.0969057,
    "CMYK_Y": 0.2296387,
    "CMYK_K": 0.04124899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05230",
    "Farbtonhilfsbezeichnung": "F2.50.75",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "195",
    "Bcolor": "81",
    "Y": 62,
    "L": 83.0598100146587,
    "a": 13.5871029782473,
    "b": 63.7510170658604,
    "C": 65.1828316681097,
    "h": 1.36081050044072,
    "CMY_C": 0,
    "CMY_M": 0.2348399,
    "CMY_Y": 0.6810595,
    "CMYK_C": 0,
    "CMYK_M": 0.2348399,
    "CMYK_Y": 0.6810595,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05231",
    "Farbtonhilfsbezeichnung": "F2.56.73",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "188",
    "Bcolor": "59",
    "Y": 58,
    "L": 80.8420977266235,
    "a": 15.2114997985823,
    "b": 70.2424669739624,
    "C": 71.8706747756723,
    "h": 1.3575324107508,
    "CMY_C": 0,
    "CMY_M": 0.2637901,
    "CMY_Y": 0.7684092,
    "CMYK_C": 0,
    "CMYK_M": 0.2637901,
    "CMYK_Y": 0.7684092,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05232",
    "Farbtonhilfsbezeichnung": "F3.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "226",
    "Bcolor": "210",
    "Y": 77,
    "L": 90.4170837402344,
    "a": 1.71511840820313,
    "b": 8.60772514343262,
    "C": 8.77693367004395,
    "h": 78.7312088012695,
    "CMY_C": 0.06694561243057,
    "CMY_M": 0.11358678340912,
    "CMY_Y": 0.17795753479004,
    "CMYK_C": 0,
    "CMYK_M": 0.0499876216054,
    "CMYK_Y": 0.11897690594196,
    "CMYK_K": 0.06694561243057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05233",
    "Farbtonhilfsbezeichnung": "F3.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "222",
    "Bcolor": "201",
    "Y": 74,
    "L": 89.0370390400646,
    "a": 1.86519565777249,
    "b": 11.3742064348638,
    "C": 11.5261236703703,
    "h": 1.40825827466496,
    "CMY_C": 0.07338027,
    "CMY_M": 0.1300161,
    "CMY_Y": 0.2133806,
    "CMYK_C": 0,
    "CMYK_M": 0.06112085,
    "CMYK_Y": 0.1510872,
    "CMYK_K": 0.07338027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05234",
    "Farbtonhilfsbezeichnung": "F3.17.78",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "210",
    "Bcolor": "170",
    "Y": 67,
    "L": 85.479098720246,
    "a": 4.26053960213224,
    "b": 22.7469745097398,
    "C": 23.1425376103851,
    "h": 1.38564026297253,
    "CMY_C": 0.06778833,
    "CMY_M": 0.1777378,
    "CMY_Y": 0.3349326,
    "CMYK_C": 0,
    "CMYK_M": 0.1179447,
    "CMYK_Y": 0.2865704,
    "CMYK_K": 0.06778833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05235",
    "Farbtonhilfsbezeichnung": "F3.24.75",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "198",
    "Bcolor": "144",
    "Y": 60,
    "L": 81.9861907958984,
    "a": 5.96682500839233,
    "b": 31.3529777526856,
    "C": 31.9157047271729,
    "h": 79.2248153686523,
    "CMY_C": 0.07844471931458,
    "CMY_M": 0.22175043821335,
    "CMY_Y": 0.43471789360046,
    "CMYK_C": 0,
    "CMYK_M": 0.15550419688225,
    "CMYK_Y": 0.38659989833832,
    "CMYK_K": 0.07844471931458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05236",
    "Farbtonhilfsbezeichnung": "F2.42.73",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "191",
    "Bcolor": "98",
    "Y": 58,
    "L": 80.5973112812906,
    "a": 10.6746412798695,
    "b": 53.2648611238459,
    "C": 54.3239670587162,
    "h": 1.37300962729922,
    "CMY_C": 0.03175053,
    "CMY_M": 0.2523391,
    "CMY_Y": 0.6170911,
    "CMYK_C": 0,
    "CMYK_M": 0.227822,
    "CMYK_Y": 0.6045348,
    "CMYK_K": 0.03175053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05237",
    "Farbtonhilfsbezeichnung": "F2.52.71",
    "Farbtonklasse": "03",
    "Rcolor": "252",
    "Gcolor": "186",
    "Bcolor": "75",
    "Y": 56,
    "L": 79.7469253540039,
    "a": 13.7102060317993,
    "b": 62.7779350280762,
    "C": 64.2575988769531,
    "h": 77.6804885864258,
    "CMY_C": 0.01343733072281,
    "CMY_M": 0.27059650421143,
    "CMY_Y": 0.70696699619293,
    "CMYK_C": 0,
    "CMYK_M": 0.2606617808342,
    "CMYK_Y": 0.70297580957413,
    "CMYK_K": 0.01343733072281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05238",
    "Farbtonhilfsbezeichnung": "F2.68.73",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "184",
    "Bcolor": "9",
    "Y": 57,
    "L": 79.9584244441712,
    "a": 16.527722378307,
    "b": 81.2653297595205,
    "C": 82.9290023329474,
    "h": 1.37015313041208,
    "CMY_C": 0,
    "CMY_M": 0.277839,
    "CMY_Y": 0.964909,
    "CMYK_C": 0,
    "CMYK_M": 0.277839,
    "CMYK_Y": 0.964909,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05239",
    "Farbtonhilfsbezeichnung": "F3.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "220",
    "Bcolor": "211",
    "Y": 72,
    "L": 87.9536315486102,
    "a": 0.30641374145357,
    "b": 4.05705360154305,
    "C": 4.0686082763944,
    "h": 1.49541326755886,
    "CMY_C": 0.1192117,
    "CMY_M": 0.1363568,
    "CMY_Y": 0.1714495,
    "CMYK_C": 0,
    "CMYK_M": 0.01946568,
    "CMYK_Y": 0.05930797,
    "CMYK_K": 0.1192117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05240",
    "Farbtonhilfsbezeichnung": "F3.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "205",
    "Bcolor": "188",
    "Y": 62,
    "L": 82.849098479784,
    "a": 1.6208770375904,
    "b": 8.97394312688915,
    "C": 9.11915004896996,
    "h": 1.39210254097708,
    "CMY_C": 0.1509748,
    "CMY_M": 0.1968658,
    "CMY_Y": 0.2623268,
    "CMYK_C": 0,
    "CMYK_M": 0.05405137,
    "CMYK_Y": 0.1311528,
    "CMYK_K": 0.1509748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05241",
    "Farbtonhilfsbezeichnung": "F2.19.76",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "202",
    "Bcolor": "158",
    "Y": 63,
    "L": 83.2449283085166,
    "a": 5.61658877744975,
    "b": 25.7396550521782,
    "C": 26.3453204896068,
    "h": 1.35595630052592,
    "CMY_C": 0.07745519,
    "CMY_M": 0.206119,
    "CMY_Y": 0.3801626,
    "CMYK_C": 0,
    "CMYK_M": 0.1394662,
    "CMYK_Y": 0.3281222,
    "CMYK_K": 0.07745519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05242",
    "Farbtonhilfsbezeichnung": "F3.29.70",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "183",
    "Bcolor": "123",
    "Y": 51,
    "L": 76.7219327156207,
    "a": 6.62449446361862,
    "b": 35.5273684642353,
    "C": 36.1396989042805,
    "h": 1.38645157646194,
    "CMY_C": 0.1271159,
    "CMY_M": 0.2808416,
    "CMY_Y": 0.519223,
    "CMYK_C": 0,
    "CMYK_M": 0.1761124,
    "CMYK_Y": 0.4492086,
    "CMYK_K": 0.1271159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05243",
    "Farbtonhilfsbezeichnung": "F2.52.69",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "177",
    "Bcolor": "69",
    "Y": 50,
    "L": 76.012734911603,
    "a": 12.1229562624717,
    "b": 60.8584188212692,
    "C": 62.0541151735066,
    "h": 1.3741707602196,
    "CMY_C": 0.06974426,
    "CMY_M": 0.3059969,
    "CMY_Y": 0.729224,
    "CMYK_C": 0,
    "CMYK_M": 0.2539653,
    "CMYK_Y": 0.708923,
    "CMYK_K": 0.06974426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05244",
    "Farbtonhilfsbezeichnung": "F2.73.73",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "185",
    "Bcolor": "0",
    "Y": 58,
    "L": 80.7598769528579,
    "a": 18.5987130410175,
    "b": 88.0313014885739,
    "C": 89.9745640086925,
    "h": 1.36258438824238,
    "CMY_C": 0,
    "CMY_M": 0.2755544,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2755544,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05245",
    "Farbtonhilfsbezeichnung": "F3.12.73",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "197",
    "Bcolor": "170",
    "Y": 57,
    "L": 80.3207618165474,
    "a": 2.77424476355781,
    "b": 15.0626700529596,
    "C": 15.31601982019,
    "h": 1.38865740010209,
    "CMY_C": 0.154337,
    "CMY_M": 0.2285918,
    "CMY_Y": 0.333129,
    "CMYK_C": 0,
    "CMYK_M": 0.08780655,
    "CMYK_Y": 0.2114223,
    "CMYK_K": 0.154337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05246",
    "Farbtonhilfsbezeichnung": "F2.17.74",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "195",
    "Bcolor": "158",
    "Y": 57,
    "L": 80.0471450004348,
    "a": 4.16191541379607,
    "b": 21.1652213542585,
    "C": 21.5705385859128,
    "h": 1.37663423763348,
    "CMY_C": 0.1333158,
    "CMY_M": 0.2362704,
    "CMY_Y": 0.3801064,
    "CMYK_C": 0,
    "CMYK_M": 0.1187914,
    "CMYK_Y": 0.2847526,
    "CMYK_K": 0.1333158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05247",
    "Farbtonhilfsbezeichnung": "F3.27.66",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "175",
    "Bcolor": "119",
    "Y": 46,
    "L": 73.4933520214112,
    "a": 5.6373349521805,
    "b": 32.9813200365467,
    "C": 33.4596326446689,
    "h": 1.40150720567792,
    "CMY_C": 0.1742963,
    "CMY_M": 0.3123158,
    "CMY_Y": 0.5329517,
    "CMYK_C": 0,
    "CMYK_M": 0.1671538,
    "CMYK_Y": 0.4343634,
    "CMYK_K": 0.1742963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05248",
    "Farbtonhilfsbezeichnung": "F2.59.69",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "174",
    "Bcolor": "46",
    "Y": 50,
    "L": 75.9602678661683,
    "a": 15.9131863872467,
    "b": 69.5905107069118,
    "C": 71.3867542436554,
    "h": 1.34599251680199,
    "CMY_C": 0.04081088,
    "CMY_M": 0.3175791,
    "CMY_Y": 0.8179367,
    "CMYK_C": 0,
    "CMYK_M": 0.2885439,
    "CMYK_Y": 0.8101904,
    "CMYK_K": 0.04081088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05249",
    "Farbtonhilfsbezeichnung": "F2.73.67",
    "Farbtonklasse": "04",
    "Rcolor": "244",
    "Gcolor": "169",
    "Bcolor": "0",
    "Y": 48,
    "L": 74.5628784906541,
    "a": 17.4327987372914,
    "b": 80.4610309258116,
    "C": 82.3278808755535,
    "h": 1.35743272547117,
    "CMY_C": 0.04237105,
    "CMY_M": 0.33738,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3080619,
    "CMYK_Y": 1,
    "CMYK_K": 0.04237105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05250",
    "Farbtonhilfsbezeichnung": "F2.14.66",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "178",
    "Bcolor": "150",
    "Y": 45,
    "L": 73.5071640014648,
    "a": 3.39299988746643,
    "b": 16.2144947052002,
    "C": 16.5656967163086,
    "h": 78.1809921264648,
    "CMY_C": 0.22230875492096,
    "CMY_M": 0.30339670181274,
    "CMY_Y": 0.41205132007599,
    "CMYK_C": 0,
    "CMYK_M": 0.10426753014326,
    "CMYK_Y": 0.24398186802864,
    "CMYK_K": 0.22230875492096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05251",
    "Farbtonhilfsbezeichnung": "F2.29.61",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "161",
    "Bcolor": "109",
    "Y": 37,
    "L": 68.3067932128906,
    "a": 6.55561685562134,
    "b": 31.2300796508789,
    "C": 31.9107189178467,
    "h": 78.1449661254883,
    "CMY_C": 0.2295441031456,
    "CMY_M": 0.36870867013931,
    "CMY_Y": 0.57137274742126,
    "CMYK_C": 0,
    "CMYK_M": 0.18062625825405,
    "CMYK_Y": 0.44367063045502,
    "CMYK_K": 0.2295441031456
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05252",
    "Farbtonhilfsbezeichnung": "F2.50.64",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "165",
    "Bcolor": "69",
    "Y": 43,
    "L": 71.5103089572756,
    "a": 11.58474820539,
    "b": 55.7317323942011,
    "C": 56.9230391549953,
    "h": 1.36584859906859,
    "CMY_C": 0.1313285,
    "CMY_M": 0.3514222,
    "CMY_Y": 0.7297446,
    "CMYK_C": 0,
    "CMYK_M": 0.2533681,
    "CMYK_Y": 0.6888865,
    "CMYK_K": 0.1313285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05253",
    "Farbtonhilfsbezeichnung": "F3.65.64",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "162",
    "Bcolor": "24",
    "Y": 42,
    "L": 70.9066605618576,
    "a": 13.1656428530333,
    "b": 70.6649303112546,
    "C": 71.880919078905,
    "h": 1.38659739273221,
    "CMY_C": 0.117376,
    "CMY_M": 0.3633394,
    "CMY_Y": 0.9053652,
    "CMYK_C": 0,
    "CMYK_M": 0.2786729,
    "CMYK_Y": 0.8927802,
    "CMYK_K": 0.117376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05254",
    "Farbtonhilfsbezeichnung": "F2.74.62",
    "Farbtonklasse": "04",
    "Rcolor": "225",
    "Gcolor": "158",
    "Bcolor": "0",
    "Y": 41,
    "L": 69.8460732615008,
    "a": 15.0813878358658,
    "b": 75.5706677757517,
    "C": 77.0608466546329,
    "h": 1.37381744833206,
    "CMY_C": 0.1163893,
    "CMY_M": 0.3798341,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2981458,
    "CMYK_Y": 1,
    "CMYK_K": 0.1163893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05255",
    "Farbtonhilfsbezeichnung": "F2.12.61",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "165",
    "Bcolor": "142",
    "Y": 39,
    "L": 68.7082866820653,
    "a": 2.97277492128634,
    "b": 13.8027518925788,
    "C": 14.1192546028718,
    "h": 1.35866126215033,
    "CMY_C": 0.2829816,
    "CMY_M": 0.3525559,
    "CMY_Y": 0.4440436,
    "CMYK_C": 0,
    "CMYK_M": 0.09703282,
    "CMYK_Y": 0.2246274,
    "CMYK_K": 0.2829816
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05256",
    "Farbtonhilfsbezeichnung": "F2.19.61",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "162",
    "Bcolor": "127",
    "Y": 38,
    "L": 67.8290852596663,
    "a": 4.39056455968839,
    "b": 20.8446321025841,
    "C": 21.3020126899989,
    "h": 1.36319807623979,
    "CMY_C": 0.2675253,
    "CMY_M": 0.36659,
    "CMY_Y": 0.5022616,
    "CMYK_C": 0,
    "CMYK_M": 0.1352466,
    "CMYK_Y": 0.3204702,
    "CMYK_K": 0.2675253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05257",
    "Farbtonhilfsbezeichnung": "F2.21.59",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "160",
    "Bcolor": "123",
    "Y": 37,
    "L": 67.5608000450538,
    "a": 4.84844923062078,
    "b": 22.8583600013236,
    "C": 23.3669014182886,
    "h": 1.36178568365749,
    "CMY_C": 0.2634845,
    "CMY_M": 0.3708762,
    "CMY_Y": 0.5191076,
    "CMYK_C": 0,
    "CMYK_M": 0.1458104,
    "CMYK_Y": 0.3470709,
    "CMYK_K": 0.2634845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05258",
    "Farbtonhilfsbezeichnung": "F2.29.58",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "153",
    "Bcolor": "105",
    "Y": 35,
    "L": 65.5414699330721,
    "a": 7.14176988567872,
    "b": 29.7905122114261,
    "C": 30.6346126941261,
    "h": 1.33550378733031,
    "CMY_C": 0.2589619,
    "CMY_M": 0.3986289,
    "CMY_Y": 0.5879555,
    "CMYK_C": 0,
    "CMYK_M": 0.1884748,
    "CMYK_Y": 0.4439632,
    "CMYK_K": 0.2589619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05259",
    "Farbtonhilfsbezeichnung": "F2.64.59",
    "Farbtonklasse": "03",
    "Rcolor": "215",
    "Gcolor": "152",
    "Bcolor": "37",
    "Y": 37,
    "L": 67.2858856852274,
    "a": 14.6531603039755,
    "b": 63.8405812367548,
    "C": 65.5006482375609,
    "h": 1.34517687520426,
    "CMY_C": 0.1570015,
    "CMY_M": 0.4041937,
    "CMY_Y": 0.8550823,
    "CMYK_C": 0,
    "CMYK_M": 0.2932298,
    "CMYK_Y": 0.8280926,
    "CMYK_K": 0.1570015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05260",
    "Farbtonhilfsbezeichnung": "U5.44.35",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "107",
    "Bcolor": "179",
    "Y": 14,
    "L": 44.7908145258178,
    "a": 6.17579104539029,
    "b": -44.6152401729126,
    "C": 45.0406488710254,
    "h": -1.43324705974787,
    "CMY_C": 0.8108199,
    "CMY_M": 0.5807432,
    "CMY_Y": 0.2973167,
    "CMYK_C": 0.7307748,
    "CMYK_M": 0.4033489,
    "CMYK_Y": 0,
    "CMYK_K": 0.2973167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05261",
    "Farbtonhilfsbezeichnung": "F3.68.57",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "147",
    "Bcolor": "17",
    "Y": 34,
    "L": 65.0556173188869,
    "a": 13.7189322718337,
    "b": 66.9168025237484,
    "C": 68.3086199734814,
    "h": 1.36858356433008,
    "CMY_C": 0.1868664,
    "CMY_M": 0.4248863,
    "CMY_Y": 0.9351855,
    "CMYK_C": 0,
    "CMYK_M": 0.2927192,
    "CMYK_Y": 0.9202904,
    "CMYK_K": 0.1868664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05262",
    "Farbtonhilfsbezeichnung": "F3.12.56",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "150",
    "Bcolor": "127",
    "Y": 31,
    "L": 62.9048492447193,
    "a": 1.94210231188113,
    "b": 13.6937680165106,
    "C": 13.8308005509378,
    "h": 1.42991208753374,
    "CMY_C": 0.3520946,
    "CMY_M": 0.410495,
    "CMY_Y": 0.5018194,
    "CMYK_C": 0,
    "CMYK_M": 0.09013731,
    "CMYK_Y": 0.2310907,
    "CMYK_K": 0.3520946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05263",
    "Farbtonhilfsbezeichnung": "F3.29.50",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "134",
    "Bcolor": "90",
    "Y": 26,
    "L": 57.691554262475,
    "a": 5.28111660359909,
    "b": 27.2043886087465,
    "C": 27.7122527441655,
    "h": 1.37905384398035,
    "CMY_C": 0.3602236,
    "CMY_M": 0.4739353,
    "CMY_Y": 0.6456963,
    "CMYK_C": 0,
    "CMYK_M": 0.1777366,
    "CMYK_Y": 0.4462071,
    "CMYK_K": 0.3602236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05264",
    "Farbtonhilfsbezeichnung": "F2.43.50",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "132",
    "Bcolor": "67",
    "Y": 26,
    "L": 57.739646005674,
    "a": 7.5747332483157,
    "b": 39.8040758629644,
    "C": 40.5184037085343,
    "h": 1.38274442188287,
    "CMY_C": 0.329145,
    "CMY_M": 0.4807696,
    "CMY_Y": 0.7361646,
    "CMYK_C": 0,
    "CMYK_M": 0.226017,
    "CMYK_Y": 0.6067178,
    "CMYK_K": 0.329145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05265",
    "Farbtonhilfsbezeichnung": "F3.51.56",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "145",
    "Bcolor": "62",
    "Y": 32,
    "L": 63.3885930110172,
    "a": 10.2979123020308,
    "b": 49.1604216343402,
    "C": 50.2274233168139,
    "h": 1.36430636836492,
    "CMY_C": 0.2397697,
    "CMY_M": 0.4313793,
    "CMY_Y": 0.7552615,
    "CMYK_C": 0,
    "CMYK_M": 0.2520414,
    "CMYK_Y": 0.6780731,
    "CMYK_K": 0.2397697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05266",
    "Farbtonhilfsbezeichnung": "F3.64.53",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "136",
    "Bcolor": "29",
    "Y": 29,
    "L": 60.5762020853804,
    "a": 12.2484086120943,
    "b": 59.5518221992003,
    "C": 60.7983802479473,
    "h": 1.36794862786258,
    "CMY_C": 0.2527285,
    "CMY_M": 0.4659656,
    "CMY_Y": 0.886572,
    "CMYK_C": 0,
    "CMYK_M": 0.2853543,
    "CMYK_Y": 0.8482105,
    "CMYK_K": 0.2527285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05267",
    "Farbtonhilfsbezeichnung": "F3.04.45",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "128",
    "Bcolor": "121",
    "Y": 19,
    "L": 53.8570899963379,
    "a": 0.78627723455429,
    "b": 3.7569146156311,
    "C": 3.83831214904785,
    "h": 78.1792984008789,
    "CMY_C": 0.47866761684418,
    "CMY_M": 0.49754762649536,
    "CMY_Y": 0.52420341968536,
    "CMYK_C": 0,
    "CMYK_M": 0.03621491789818,
    "CMYK_Y": 0.08734504878521,
    "CMYK_K": 0.47866761684418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05268",
    "Farbtonhilfsbezeichnung": "F2.10.51",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "141",
    "Bcolor": "126",
    "Y": 27,
    "L": 59.2975992021501,
    "a": 2.17192447053505,
    "b": 9.14473647296359,
    "C": 9.39912022827985,
    "h": 1.33761139620091,
    "CMY_C": 0.3993209,
    "CMY_M": 0.4469461,
    "CMY_Y": 0.5064623,
    "CMYK_C": 0,
    "CMYK_M": 0.07928554,
    "CMYK_Y": 0.1783671,
    "CMYK_K": 0.3993209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05269",
    "Farbtonhilfsbezeichnung": "F2.16.44",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "121",
    "Bcolor": "100",
    "Y": 20,
    "L": 51.6130155232504,
    "a": 3.01866855457567,
    "b": 13.1471620479892,
    "C": 13.4892634994825,
    "h": 1.34510208414304,
    "CMY_C": 0.4637713,
    "CMY_M": 0.5269141,
    "CMY_Y": 0.6081241,
    "CMYK_C": 0,
    "CMYK_M": 0.1177536,
    "CMYK_Y": 0.2692002,
    "CMYK_K": 0.4637713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05270",
    "Farbtonhilfsbezeichnung": "F2.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "112",
    "Bcolor": "86",
    "Y": 17,
    "L": 48.1973916968903,
    "a": 3.68735455155522,
    "b": 16.4089929294749,
    "C": 16.8181934983646,
    "h": 1.34975272108944,
    "CMY_C": 0.488035,
    "CMY_M": 0.562629,
    "CMY_Y": 0.6619145,
    "CMYK_C": 0,
    "CMYK_M": 0.1457014,
    "CMYK_Y": 0.3396316,
    "CMYK_K": 0.488035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05271",
    "Farbtonhilfsbezeichnung": "F2.31.40",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "109",
    "Bcolor": "72",
    "Y": 17,
    "L": 47.8484972319369,
    "a": 5.26533963294268,
    "b": 24.4672704895441,
    "C": 25.0274075097433,
    "h": 1.35882967429637,
    "CMY_C": 0.4688585,
    "CMY_M": 0.5709776,
    "CMY_Y": 0.7187869,
    "CMYK_C": 0,
    "CMYK_M": 0.1922635,
    "CMYK_Y": 0.4705496,
    "CMYK_K": 0.4688585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05273",
    "Farbtonhilfsbezeichnung": "F2.44.45",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "119",
    "Bcolor": "60",
    "Y": 21,
    "L": 52.4599317353666,
    "a": 8.08318760800381,
    "b": 37.1034854328157,
    "C": 37.9737613776849,
    "h": 1.35629271470096,
    "CMY_C": 0.3873927,
    "CMY_M": 0.5342122,
    "CMY_Y": 0.7652298,
    "CMYK_C": 0,
    "CMYK_M": 0.2396632,
    "CMYK_Y": 0.6167689,
    "CMYK_K": 0.3873927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05274",
    "Farbtonhilfsbezeichnung": "F3.03.38",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "107",
    "Bcolor": "103",
    "Y": 15,
    "L": 45.2931267230763,
    "a": 0.49026644530064,
    "b": 1.76156803735028,
    "C": 1.82851938398308,
    "h": 1.29935310505102,
    "CMY_C": 0.5711902,
    "CMY_M": 0.5808533,
    "CMY_Y": 0.5943925,
    "CMYK_C": 0,
    "CMYK_M": 0.02253472,
    "CMYK_Y": 0.05410856,
    "CMYK_K": 0.5711902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05275",
    "Farbtonhilfsbezeichnung": "F3.27.35",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "98",
    "Bcolor": "69",
    "Y": 13,
    "L": 42.7154417356685,
    "a": 3.84670032334056,
    "b": 19.0899581120083,
    "C": 19.4736643725782,
    "h": 1.37195516294203,
    "CMY_C": 0.5380842,
    "CMY_M": 0.6163682,
    "CMY_Y": 0.7299123,
    "CMYK_C": 0,
    "CMYK_M": 0.1694767,
    "CMYK_Y": 0.4152882,
    "CMYK_K": 0.5380842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05276",
    "Farbtonhilfsbezeichnung": "F2.46.37",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "101",
    "Bcolor": "53",
    "Y": 15,
    "L": 45.073007816218,
    "a": 6.67431353890147,
    "b": 31.4542330121898,
    "C": 32.1545523309017,
    "h": 1.36170634698697,
    "CMY_C": 0.4809525,
    "CMY_M": 0.6020255,
    "CMY_Y": 0.7920847,
    "CMYK_C": 0,
    "CMYK_M": 0.2332599,
    "CMYK_Y": 0.5994291,
    "CMYK_K": 0.4809525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05277",
    "Farbtonhilfsbezeichnung": "F2.52.40",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "106",
    "Bcolor": "47",
    "Y": 16,
    "L": 47.5549005613787,
    "a": 8.6331758639378,
    "b": 37.9526606947413,
    "C": 38.9221810707961,
    "h": 1.34713004236092,
    "CMY_C": 0.4368567,
    "CMY_M": 0.5835319,
    "CMY_Y": 0.8169186,
    "CMYK_C": 0,
    "CMYK_M": 0.260458,
    "CMYK_Y": 0.6748937,
    "CMYK_K": 0.4368567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05278",
    "Farbtonhilfsbezeichnung": "F3.61.46",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "124",
    "Bcolor": "42",
    "Y": 23,
    "L": 54.9098069977523,
    "a": 9.00585899435236,
    "b": 48.6802180978062,
    "C": 49.5062534461672,
    "h": 1.38786419020001,
    "CMY_C": 0.3439539,
    "CMY_M": 0.5135361,
    "CMY_Y": 0.8357595,
    "CMYK_C": 0,
    "CMYK_M": 0.2584912,
    "CMYK_Y": 0.749651,
    "CMYK_K": 0.3439539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05279",
    "Farbtonhilfsbezeichnung": "F2.08.14",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "57",
    "Bcolor": "52",
    "Y": 4,
    "L": 24.2067770315299,
    "a": 0.77106051202702,
    "b": 3.43555058128828,
    "C": 3.52101435807888,
    "h": 1.35001897159715,
    "CMY_C": 0.7611775,
    "CMY_M": 0.7764185,
    "CMY_Y": 0.7962551,
    "CMYK_C": 0,
    "CMYK_M": 0.06381757,
    "CMYK_Y": 0.1468773,
    "CMYK_K": 0.7611775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05280",
    "Farbtonhilfsbezeichnung": "F2.06.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "80",
    "Bcolor": "76",
    "Y": 8,
    "L": 34.1207166240573,
    "a": 0.41714839418777,
    "b": 2.47246891347751,
    "C": 2.50741207440781,
    "h": 1.40365305933634,
    "CMY_C": 0.6759493,
    "CMY_M": 0.6865711,
    "CMY_Y": 0.7031525,
    "CMYK_C": 0,
    "CMYK_M": 0.03277816,
    "CMYK_Y": 0.08394749,
    "CMYK_K": 0.6759493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05281",
    "Farbtonhilfsbezeichnung": "F3.13.23",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "74",
    "Bcolor": "64",
    "Y": 7,
    "L": 31.9387979241164,
    "a": 1.15075384442695,
    "b": 6.64685221512312,
    "C": 6.74573041116754,
    "h": 1.39936795795072,
    "CMY_C": 0.6816885,
    "CMY_M": 0.7089058,
    "CMY_Y": 0.7480932,
    "CMYK_C": 0,
    "CMYK_M": 0.08550536,
    "CMYK_Y": 0.2086156,
    "CMYK_K": 0.6816885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05282",
    "Farbtonhilfsbezeichnung": "F2.22.29",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "88",
    "Bcolor": "69",
    "Y": 10,
    "L": 38.3827470459322,
    "a": 2.87530564158467,
    "b": 12.7555403944528,
    "C": 13.0755953320316,
    "h": 1.34908575993092,
    "CMY_C": 0.5977773,
    "CMY_M": 0.6541128,
    "CMY_Y": 0.7283208,
    "CMYK_C": 0,
    "CMYK_M": 0.1400604,
    "CMYK_Y": 0.3245552,
    "CMYK_K": 0.5977773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05283",
    "Farbtonhilfsbezeichnung": "F2.34.23",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "75",
    "Bcolor": "51",
    "Y": 7,
    "L": 32.7872621312776,
    "a": 3.48298406894682,
    "b": 16.3823256658386,
    "C": 16.7484856702369,
    "h": 1.36130932081544,
    "CMY_C": 0.6425465,
    "CMY_M": 0.7077131,
    "CMY_Y": 0.8003124,
    "CMYK_C": 0,
    "CMYK_M": 0.1823077,
    "CMYK_Y": 0.4413606,
    "CMYK_K": 0.6425465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05284",
    "Farbtonhilfsbezeichnung": "F2.42.29",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "88",
    "Bcolor": "52",
    "Y": 11,
    "L": 38.8214695472202,
    "a": 4.92989593334098,
    "b": 23.7570637891549,
    "C": 24.2631810320813,
    "h": 1.36618742297428,
    "CMY_C": 0.5645571,
    "CMY_M": 0.656256,
    "CMY_Y": 0.7951589,
    "CMYK_C": 0,
    "CMYK_M": 0.2105877,
    "CMYK_Y": 0.5295801,
    "CMYK_K": 0.5645571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05285",
    "Farbtonhilfsbezeichnung": "F3.54.39",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "107",
    "Bcolor": "47",
    "Y": 16,
    "L": 47.3324670678919,
    "a": 6.9957129821977,
    "b": 37.2069357748509,
    "C": 37.8588968392262,
    "h": 1.38494439932694,
    "CMY_C": 0.4489861,
    "CMY_M": 0.5817266,
    "CMY_Y": 0.8138196,
    "CMYK_C": 0,
    "CMYK_M": 0.2409023,
    "CMYK_Y": 0.6621132,
    "CMYK_K": 0.4489861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05286",
    "Farbtonhilfsbezeichnung": "F4.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "218",
    "Y": 85,
    "L": 94.0658645629883,
    "a": 0.95516681671143,
    "b": 9.74790477752686,
    "C": 9.79458999633789,
    "h": 84.4036331176758,
    "CMY_C": 0.02812820672989,
    "CMY_M": 0.07130634784698,
    "CMY_Y": 0.14664703607559,
    "CMYK_C": 0,
    "CMYK_M": 0.04442781582475,
    "CMYK_Y": 0.12194903939962,
    "CMYK_K": 0.02812820672989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05287",
    "Farbtonhilfsbezeichnung": "F4.16.83",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "224",
    "Bcolor": "182",
    "Y": 77,
    "L": 90.4569584256139,
    "a": 3.92728782725649,
    "b": 23.4480167314971,
    "C": 23.7746309817563,
    "h": 1.40484752562597,
    "CMY_C": 0.01165196,
    "CMY_M": 0.122188,
    "CMY_Y": 0.2875111,
    "CMYK_C": 0,
    "CMYK_M": 0.1118392,
    "CMYK_Y": 0.2791114,
    "CMYK_K": 0.01165196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05288",
    "Farbtonhilfsbezeichnung": "F5.30.81",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "214",
    "Bcolor": "141",
    "Y": 71,
    "L": 87.6404719050349,
    "a": 5.07377160930433,
    "b": 40.8821624593282,
    "C": 41.1958051953629,
    "h": 1.44732047164494,
    "CMY_C": 0.002021146,
    "CMY_M": 0.1596085,
    "CMY_Y": 0.4488144,
    "CMYK_C": 0,
    "CMYK_M": 0.1579065,
    "CMYK_Y": 0.4476981,
    "CMYK_K": 0.002021146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05289",
    "Farbtonhilfsbezeichnung": "F4.33.79",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "213",
    "Bcolor": "133",
    "Y": 71,
    "L": 87.4180969581885,
    "a": 6.48890100051941,
    "b": 44.244565614956,
    "C": 44.7178646924323,
    "h": 1.42517462722526,
    "CMY_C": 0,
    "CMY_M": 0.1661733,
    "CMY_Y": 0.4768223,
    "CMYK_C": 0,
    "CMYK_M": 0.1661733,
    "CMYK_Y": 0.4768223,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05290",
    "Farbtonhilfsbezeichnung": "F4.51.77",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "80",
    "Y": 65,
    "L": 84.6847019866765,
    "a": 9.3147942567437,
    "b": 65.9819394820726,
    "C": 66.636189340788,
    "h": 1.4305512208069,
    "CMY_C": 0,
    "CMY_M": 0.2062826,
    "CMY_Y": 0.6865293,
    "CMYK_C": 0,
    "CMYK_M": 0.2062826,
    "CMYK_Y": 0.6865293,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05291",
    "Farbtonhilfsbezeichnung": "F4.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 84,
    "L": 93.2824387523963,
    "a": 0.91263978211308,
    "b": 5.26849539635881,
    "C": 5.34695755671853,
    "h": 1.39927257374691,
    "CMY_C": 0.05106346,
    "CMY_M": 0.07881589,
    "CMY_Y": 0.1218626,
    "CMYK_C": 0,
    "CMYK_M": 0.02924583,
    "CMYK_Y": 0.07460891,
    "CMYK_K": 0.05106346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05292",
    "Farbtonhilfsbezeichnung": "F5.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "234",
    "Bcolor": "212",
    "Y": 84,
    "L": 93.3200972445437,
    "a": 1.72354522095336,
    "b": 11.5181896076323,
    "C": 11.6464286356823,
    "h": 1.42226159010334,
    "CMY_C": 0.02563646,
    "CMY_M": 0.08201945,
    "CMY_Y": 0.1679138,
    "CMYK_C": 0,
    "CMYK_M": 0.05786647,
    "CMYK_Y": 0.1460208,
    "CMYK_K": 0.02563646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05293",
    "Farbtonhilfsbezeichnung": "F6.16.84",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "228",
    "Bcolor": "183",
    "Y": 80,
    "L": 91.6041577386801,
    "a": 2.61134201066465,
    "b": 24.446067597387,
    "C": 24.5851444590565,
    "h": 1.4643793293787,
    "CMY_C": 0.005487421,
    "CMY_M": 0.1064299,
    "CMY_Y": 0.2830085,
    "CMYK_C": 0,
    "CMYK_M": 0.1014995,
    "CMYK_Y": 0.2790523,
    "CMYK_K": 0.005487421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05294",
    "Farbtonhilfsbezeichnung": "F4.27.81",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "152",
    "Y": 75,
    "L": 89.1729554665518,
    "a": 5.42281860419741,
    "b": 37.1813770508619,
    "C": 37.5747489813623,
    "h": 1.4259697537623,
    "CMY_C": 0,
    "CMY_M": 0.142931,
    "CMY_Y": 0.4044132,
    "CMYK_C": 0,
    "CMYK_M": 0.142931,
    "CMYK_Y": 0.4044132,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05295",
    "Farbtonhilfsbezeichnung": "F4.47.79",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "207",
    "Bcolor": "89",
    "Y": 69,
    "L": 86.3649199907896,
    "a": 9.85956413312705,
    "b": 64.1685154519775,
    "C": 64.9215632914513,
    "h": 1.41833753042747,
    "CMY_C": 0,
    "CMY_M": 0.189206,
    "CMY_Y": 0.6516511,
    "CMYK_C": 0,
    "CMYK_M": 0.189206,
    "CMYK_Y": 0.6516511,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05296",
    "Farbtonhilfsbezeichnung": "F4.52.75",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "78",
    "Y": 62,
    "L": 82.6632617657506,
    "a": 10.5679238511457,
    "b": 64.5009649309121,
    "C": 65.3609630554995,
    "h": 1.40839787916229,
    "CMY_C": 0,
    "CMY_M": 0.2312363,
    "CMY_Y": 0.6936057,
    "CMYK_C": 0,
    "CMYK_M": 0.2312363,
    "CMYK_Y": 0.6936057,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05297",
    "Farbtonhilfsbezeichnung": "F5.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "231",
    "Bcolor": "217",
    "Y": 82,
    "L": 92.0801086425781,
    "a": 0.72110116481781,
    "b": 7.10129833221436,
    "C": 7.13781642913818,
    "h": 84.201774597168,
    "CMY_C": 0.0603358745575,
    "CMY_M": 0.09226566553116,
    "CMY_Y": 0.14875072240829,
    "CMYK_C": 0,
    "CMYK_M": 0.03398000448942,
    "CMYK_Y": 0.09409196674824,
    "CMYK_K": 0.0603358745575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05298",
    "Farbtonhilfsbezeichnung": "F5.12.83",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "221",
    "Bcolor": "189",
    "Y": 76,
    "L": 89.1734771728516,
    "a": 2.5197913646698,
    "b": 17.7618560791016,
    "C": 17.9397010803223,
    "h": 81.9255981445313,
    "CMY_C": 0.05001878738403,
    "CMY_M": 0.13161909580231,
    "CMY_Y": 0.25910371541977,
    "CMYK_C": 0,
    "CMYK_M": 0.0858967602253,
    "CMYK_Y": 0.22009375691414,
    "CMYK_K": 0.05001878738403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05299",
    "Farbtonhilfsbezeichnung": "F5.13.84",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "229",
    "Bcolor": "194",
    "Y": 80,
    "L": 91.8626276089982,
    "a": 2.70625570288185,
    "b": 18.7166506000687,
    "C": 18.9112884176206,
    "h": 1.42720069061125,
    "CMY_C": 0.01565734,
    "CMY_M": 0.1024706,
    "CMY_Y": 0.2373049,
    "CMYK_C": 0,
    "CMYK_M": 0.08819415,
    "CMYK_Y": 0.2251732,
    "CMYK_K": 0.01565734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05300",
    "Farbtonhilfsbezeichnung": "F5.31.80",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "212",
    "Bcolor": "137",
    "Y": 69,
    "L": 86.7394767491884,
    "a": 5.33422962918856,
    "b": 41.3697899095499,
    "C": 41.7122706514187,
    "h": 1.44256363530814,
    "CMY_C": 0.01003752,
    "CMY_M": 0.1702326,
    "CMY_Y": 0.4618156,
    "CMYK_C": 0,
    "CMYK_M": 0.1618194,
    "CMYK_Y": 0.4563588,
    "CMYK_K": 0.01003752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05301",
    "Farbtonhilfsbezeichnung": "F5.40.79",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "208",
    "Bcolor": "113",
    "Y": 68,
    "L": 86.0591132160208,
    "a": 7.25647285268977,
    "b": 52.7064689845382,
    "C": 53.2036490391393,
    "h": 1.43397937228545,
    "CMY_C": 0,
    "CMY_M": 0.1843186,
    "CMY_Y": 0.5578775,
    "CMYK_C": 0,
    "CMYK_M": 0.1843186,
    "CMYK_Y": 0.5578775,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05302",
    "Farbtonhilfsbezeichnung": "F5.69.76",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "198",
    "Bcolor": "22",
    "Y": 63,
    "L": 83.1873958732988,
    "a": 9.14931089554333,
    "b": 81.8512446666069,
    "C": 82.3610110630999,
    "h": 1.45947867872549,
    "CMY_C": 0,
    "CMY_M": 0.2236089,
    "CMY_Y": 0.9128851,
    "CMYK_C": 0,
    "CMYK_M": 0.2236089,
    "CMYK_Y": 0.9128851,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05303",
    "Farbtonhilfsbezeichnung": "F5.04.84",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "228",
    "Bcolor": "215",
    "Y": 78,
    "L": 90.946728496515,
    "a": 0.8926758060907,
    "b": 6.54160719899322,
    "C": 6.60223407951426,
    "h": 1.43517279581945,
    "CMY_C": 0.07349298,
    "CMY_M": 0.1052009,
    "CMY_Y": 0.1569921,
    "CMYK_C": 0,
    "CMYK_M": 0.03422312,
    "CMYK_Y": 0.09012253,
    "CMYK_K": 0.07349298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05304",
    "Farbtonhilfsbezeichnung": "F5.15.79",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "214",
    "Bcolor": "176",
    "Y": 69,
    "L": 86.4528393683147,
    "a": 2.3819724065004,
    "b": 20.6549573120806,
    "C": 20.7918506658066,
    "h": 1.45598144670364,
    "CMY_C": 0.07474622,
    "CMY_M": 0.162015,
    "CMY_Y": 0.3095281,
    "CMYK_C": 0,
    "CMYK_M": 0.09431873,
    "CMYK_Y": 0.2537486,
    "CMYK_K": 0.07474622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05305",
    "Farbtonhilfsbezeichnung": "F4.16.82",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "218",
    "Bcolor": "174",
    "Y": 72,
    "L": 88.1076419940552,
    "a": 2.27748282569473,
    "b": 24.2226949769783,
    "C": 24.3295269162609,
    "h": 1.47704924301104,
    "CMY_C": 0.04839458,
    "CMY_M": 0.1443219,
    "CMY_Y": 0.3185387,
    "CMYK_C": 0,
    "CMYK_M": 0.1008058,
    "CMYK_Y": 0.2838824,
    "CMYK_K": 0.04839458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05306",
    "Farbtonhilfsbezeichnung": "F4.22.80",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "214",
    "Bcolor": "158",
    "Y": 71,
    "L": 87.3831067251218,
    "a": 5.0498165956,
    "b": 31.7027806836503,
    "C": 32.1024446222531,
    "h": 1.41283709005233,
    "CMY_C": 0.02180985,
    "CMY_M": 0.1606601,
    "CMY_Y": 0.3816132,
    "CMYK_C": 0,
    "CMYK_M": 0.1419461,
    "CMYK_Y": 0.3678255,
    "CMYK_K": 0.02180985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05307",
    "Farbtonhilfsbezeichnung": "F4.29.79",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "213",
    "Bcolor": "143",
    "Y": 71,
    "L": 87.3209334861742,
    "a": 5.53699729339757,
    "b": 39.1459466770522,
    "C": 39.5355976339008,
    "h": 1.43028347336666,
    "CMY_C": 0.005633814,
    "CMY_M": 0.1639653,
    "CMY_Y": 0.4386572,
    "CMYK_C": 0,
    "CMYK_M": 0.1592285,
    "CMYK_Y": 0.4354768,
    "CMYK_K": 0.005633814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05308",
    "Farbtonhilfsbezeichnung": "F4.64.76",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "22",
    "Y": 62,
    "L": 83.1684404883574,
    "a": 11.3244436558319,
    "b": 82.0870881996904,
    "C": 82.8645465396261,
    "h": 1.43370520704885,
    "CMY_C": 0,
    "CMY_M": 0.2295004,
    "CMY_Y": 0.9152685,
    "CMYK_C": 0,
    "CMYK_M": 0.2295004,
    "CMYK_Y": 0.9152685,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05309",
    "Farbtonhilfsbezeichnung": "F4.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "216",
    "Bcolor": "197",
    "Y": 70,
    "L": 86.7888506273971,
    "a": 1.21664788096842,
    "b": 10.0315411217226,
    "C": 10.1050506848346,
    "h": 1.45010354517449,
    "CMY_C": 0.1071876,
    "CMY_M": 0.1529632,
    "CMY_Y": 0.2278545,
    "CMYK_C": 0,
    "CMYK_M": 0.05127124,
    "CMYK_Y": 0.1351536,
    "CMYK_K": 0.1071876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05310",
    "Farbtonhilfsbezeichnung": "F4.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "212",
    "Bcolor": "188",
    "Y": 67,
    "L": 85.6082659310842,
    "a": 1.84656615741552,
    "b": 13.2707383355975,
    "C": 13.398593304732,
    "h": 1.43253836232913,
    "CMY_C": 0.106757,
    "CMY_M": 0.1682701,
    "CMY_Y": 0.2642055,
    "CMYK_C": 0,
    "CMYK_M": 0.06886491,
    "CMYK_Y": 0.1762662,
    "CMYK_K": 0.106757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05311",
    "Farbtonhilfsbezeichnung": "F4.12.79",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "212",
    "Bcolor": "182",
    "Y": 68,
    "L": 85.9139937717112,
    "a": 2.5733662441822,
    "b": 16.891539411463,
    "C": 17.0864366535478,
    "h": 1.41961234583575,
    "CMY_C": 0.08867127,
    "CMY_M": 0.1675297,
    "CMY_Y": 0.2874389,
    "CMYK_C": 0,
    "CMYK_M": 0.08653128,
    "CMYK_Y": 0.2181075,
    "CMYK_K": 0.08867127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05312",
    "Farbtonhilfsbezeichnung": "F4.27.79",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "210",
    "Bcolor": "146",
    "Y": 69,
    "L": 86.5103291756284,
    "a": 6.439673452246,
    "b": 36.5350410364564,
    "C": 37.0982293068971,
    "h": 1.3963281743454,
    "CMY_C": 0.01364908,
    "CMY_M": 0.17464,
    "CMY_Y": 0.4269107,
    "CMYK_C": 0,
    "CMYK_M": 0.1632187,
    "CMYK_Y": 0.4189804,
    "CMYK_K": 0.01364908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05313",
    "Farbtonhilfsbezeichnung": "F4.44.74",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "192",
    "Bcolor": "90",
    "Y": 58,
    "L": 80.7216653530301,
    "a": 8.79912308243419,
    "b": 57.0663715499379,
    "C": 57.7407596840862,
    "h": 1.41781010560806,
    "CMY_C": 0.03748161,
    "CMY_M": 0.2466859,
    "CMY_Y": 0.6483383,
    "CMYK_C": 0,
    "CMYK_M": 0.2173509,
    "CMYK_Y": 0.6346442,
    "CMYK_K": 0.03748161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05314",
    "Farbtonhilfsbezeichnung": "F4.60.73",
    "Farbtonklasse": "04",
    "Rcolor": "246",
    "Gcolor": "187",
    "Bcolor": "43",
    "Y": 55,
    "L": 79.2170453352591,
    "a": 9.59028296781289,
    "b": 73.3570707394816,
    "C": 73.9813040901552,
    "h": 1.44079932524947,
    "CMY_C": 0.03560799,
    "CMY_M": 0.2666187,
    "CMY_Y": 0.8294871,
    "CMYK_C": 0,
    "CMYK_M": 0.2395403,
    "CMYK_Y": 0.8231913,
    "CMYK_K": 0.03560799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05315",
    "Farbtonhilfsbezeichnung": "F4.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "209",
    "Bcolor": "190",
    "Y": 63,
    "L": 84.2491226196289,
    "a": 1.58934485912323,
    "b": 10.2647790908813,
    "C": 10.3870935440063,
    "h": 81.1985092163086,
    "CMY_C": 0.13202983140945,
    "CMY_M": 0.18178045749664,
    "CMY_Y": 0.25677186250687,
    "CMYK_C": 0,
    "CMYK_M": 0.05731835961342,
    "CMYK_Y": 0.1437169611454,
    "CMYK_K": 0.13202983140945
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05316",
    "Farbtonhilfsbezeichnung": "F4.11.78",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "211",
    "Bcolor": "181",
    "Y": 66,
    "L": 85.2415324655808,
    "a": 2.34911463103193,
    "b": 16.4472441588779,
    "C": 16.61415601141,
    "h": 1.42892856863964,
    "CMY_C": 0.09895658,
    "CMY_M": 0.1742663,
    "CMY_Y": 0.2913536,
    "CMYK_C": 0,
    "CMYK_M": 0.08358059,
    "CMYK_Y": 0.2135268,
    "CMYK_K": 0.09895658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05317",
    "Farbtonhilfsbezeichnung": "F4.12.75",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "201",
    "Bcolor": "170",
    "Y": 60,
    "L": 81.6806677587204,
    "a": 2.49624465610693,
    "b": 16.8405719534376,
    "C": 17.0245734484613,
    "h": 1.423639814679,
    "CMY_C": 0.1367615,
    "CMY_M": 0.2135903,
    "CMY_Y": 0.3318196,
    "CMYK_C": 0,
    "CMYK_M": 0.08900069,
    "CMYK_Y": 0.2259609,
    "CMYK_K": 0.1367615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05318",
    "Farbtonhilfsbezeichnung": "F5.19.79",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "212",
    "Bcolor": "165",
    "Y": 68,
    "L": 85.9765058943183,
    "a": 3.10932338326314,
    "b": 25.9200704278386,
    "C": 26.1058986224535,
    "h": 1.45140866880484,
    "CMY_C": 0.06312165,
    "CMY_M": 0.17016,
    "CMY_Y": 0.3534582,
    "CMYK_C": 0,
    "CMYK_M": 0.11425,
    "CMYK_Y": 0.3098978,
    "CMYK_K": 0.06312165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05319",
    "Farbtonhilfsbezeichnung": "F4.27.75",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "198",
    "Bcolor": "136",
    "Y": 60,
    "L": 81.7943607503373,
    "a": 5.99301539193531,
    "b": 35.483034875602,
    "C": 35.9855804103694,
    "h": 1.40347736260465,
    "CMY_C": 0.07307832,
    "CMY_M": 0.2247137,
    "CMY_Y": 0.4675792,
    "CMYK_C": 0,
    "CMYK_M": 0.1635903,
    "CMYK_Y": 0.4256033,
    "CMYK_K": 0.07307832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05320",
    "Farbtonhilfsbezeichnung": "F5.47.70",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "187",
    "Bcolor": "85",
    "Y": 54,
    "L": 78.2684754402766,
    "a": 6.82955397937468,
    "b": 56.2529630238554,
    "C": 56.6660273578485,
    "h": 1.44997972102728,
    "CMY_C": 0.07968824,
    "CMY_M": 0.2679203,
    "CMY_Y": 0.6672699,
    "CMYK_C": 0,
    "CMYK_M": 0.2045308,
    "CMYK_Y": 0.6384594,
    "CMYK_K": 0.07968824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05321",
    "Farbtonhilfsbezeichnung": "F5.56.68",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "177",
    "Bcolor": "54",
    "Y": 48,
    "L": 75.1051412871729,
    "a": 8.17541096464924,
    "b": 65.6948672904005,
    "C": 66.2016082338204,
    "h": 1.44698763312719,
    "CMY_C": 0.09989513,
    "CMY_M": 0.3059869,
    "CMY_Y": 0.789175,
    "CMYK_C": 0,
    "CMYK_M": 0.2289641,
    "CMYK_Y": 0.7657772,
    "CMYK_K": 0.09989513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05322",
    "Farbtonhilfsbezeichnung": "F5.72.71",
    "Farbtonklasse": "04",
    "Rcolor": "250",
    "Gcolor": "187",
    "Bcolor": "0",
    "Y": 53,
    "L": 79.5104446411133,
    "a": 10.2877521514893,
    "b": 82.8606719970703,
    "C": 83.4968795776367,
    "h": 82.9225311279297,
    "CMY_C": 0.02133947610855,
    "CMY_M": 0.2660139799118,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.25000956654549,
    "CMYK_Y": 1,
    "CMYK_K": 0.02133947610855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05323",
    "Farbtonhilfsbezeichnung": "F5.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "204",
    "Bcolor": "189",
    "Y": 61,
    "L": 82.3014801161463,
    "a": 0.86275858080603,
    "b": 7.46834592928363,
    "C": 7.5180145841972,
    "h": 1.45578410134223,
    "CMY_C": 0.1669885,
    "CMY_M": 0.2006642,
    "CMY_Y": 0.2573537,
    "CMYK_C": 0,
    "CMYK_M": 0.04042641,
    "CMYK_Y": 0.1084801,
    "CMYK_K": 0.1669885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05324",
    "Farbtonhilfsbezeichnung": "F4.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "188",
    "Bcolor": "166",
    "Y": 52,
    "L": 76.8774108886719,
    "a": 2.22710967063904,
    "b": 12.4477310180664,
    "C": 12.6453952789307,
    "h": 79.8561477661133,
    "CMY_C": 0.20282077789307,
    "CMY_M": 0.26377463340759,
    "CMY_Y": 0.35040152072906,
    "CMYK_C": 0,
    "CMYK_M": 0.07646191865206,
    "CMYK_Y": 0.18512868881226,
    "CMYK_K": 0.20282077789307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05325",
    "Farbtonhilfsbezeichnung": "F5.15.74",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "200",
    "Bcolor": "166",
    "Y": 60,
    "L": 81.6845156456953,
    "a": 2.44923811032927,
    "b": 19.1331471378968,
    "C": 19.2892738775076,
    "h": 1.44347854326225,
    "CMY_C": 0.131514,
    "CMY_M": 0.2139599,
    "CMY_Y": 0.348515,
    "CMYK_C": 0,
    "CMYK_M": 0.09493058,
    "CMYK_Y": 0.2498612,
    "CMYK_K": 0.131514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05326",
    "Farbtonhilfsbezeichnung": "F4.20.67",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "181",
    "Bcolor": "141",
    "Y": 48,
    "L": 75.0837692778668,
    "a": 3.85847538599726,
    "b": 23.6147410177033,
    "C": 23.9278880312815,
    "h": 1.40883484926192,
    "CMY_C": 0.1855258,
    "CMY_M": 0.2893451,
    "CMY_Y": 0.4489889,
    "CMYK_C": 0,
    "CMYK_M": 0.1274678,
    "CMYK_Y": 0.3234763,
    "CMYK_K": 0.1855258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05327",
    "Farbtonhilfsbezeichnung": "F5.33.71",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "189",
    "Bcolor": "117",
    "Y": 54,
    "L": 78.5977559105313,
    "a": 5.40945566881829,
    "b": 40.7361696044898,
    "C": 41.0937674675694,
    "h": 1.4387762700266,
    "CMY_C": 0.1051419,
    "CMY_M": 0.2586485,
    "CMY_Y": 0.5399504,
    "CMYK_C": 0,
    "CMYK_M": 0.1715429,
    "CMYK_Y": 0.4858966,
    "CMYK_K": 0.1051419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05328",
    "Farbtonhilfsbezeichnung": "F5.38.66",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "173",
    "Bcolor": "95",
    "Y": 45,
    "L": 72.9782932604351,
    "a": 6.14331727072437,
    "b": 44.6146029140359,
    "C": 45.0355763842974,
    "h": 1.43395937847379,
    "CMY_C": 0.1596764,
    "CMY_M": 0.3208616,
    "CMY_Y": 0.6257906,
    "CMYK_C": 0,
    "CMYK_M": 0.1918132,
    "CMYK_Y": 0.5546842,
    "CMYK_K": 0.1596764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05329",
    "Farbtonhilfsbezeichnung": "F4.49.64",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "170",
    "Bcolor": "70",
    "Y": 45,
    "L": 72.60277218201,
    "a": 8.80772309531658,
    "b": 56.5422290543478,
    "C": 57.2241177525535,
    "h": 1.41626576100472,
    "CMY_C": 0.1341723,
    "CMY_M": 0.3329771,
    "CMY_Y": 0.7269551,
    "CMYK_C": 0,
    "CMYK_M": 0.2296124,
    "CMYK_Y": 0.6846429,
    "CMYK_K": 0.1341723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05330",
    "Farbtonhilfsbezeichnung": "F4.69.64",
    "Farbtonklasse": "04",
    "Rcolor": "228",
    "Gcolor": "165",
    "Bcolor": "0",
    "Y": 43,
    "L": 71.8657424925268,
    "a": 12.24299572872,
    "b": 77.4129284455993,
    "C": 78.3750753424641,
    "h": 1.41394362740315,
    "CMY_C": 0.1069493,
    "CMY_M": 0.3514408,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2737711,
    "CMYK_Y": 1,
    "CMYK_K": 0.1069493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05331",
    "Farbtonhilfsbezeichnung": "F5.04.64",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "177",
    "Bcolor": "167",
    "Y": 44,
    "L": 72.302482239164,
    "a": 0.67966381199996,
    "b": 4.70688598183007,
    "C": 4.75570379053308,
    "h": 1.42738979002222,
    "CMY_C": 0.2849734,
    "CMY_M": 0.307143,
    "CMY_Y": 0.34332,
    "CMYK_C": 0,
    "CMYK_M": 0.03100525,
    "CMYK_Y": 0.08160063,
    "CMYK_K": 0.2849734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05332",
    "Farbtonhilfsbezeichnung": "F4.12.69",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "185",
    "Bcolor": "159",
    "Y": 50,
    "L": 76.0965220370568,
    "a": 2.1671981169914,
    "b": 14.9535707798127,
    "C": 15.1097990306013,
    "h": 1.42686996397225,
    "CMY_C": 0.2054648,
    "CMY_M": 0.2726306,
    "CMY_Y": 0.3765185,
    "CMYK_C": 0,
    "CMYK_M": 0.08453478,
    "CMYK_Y": 0.2152878,
    "CMYK_K": 0.2054648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05333",
    "Farbtonhilfsbezeichnung": "F4.13.61",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "167",
    "Bcolor": "141",
    "Y": 40,
    "L": 69.2362800521028,
    "a": 2.03559425051425,
    "b": 14.9854893978625,
    "C": 15.1231126573261,
    "h": 1.43578499487037,
    "CMY_C": 0.2808663,
    "CMY_M": 0.3451136,
    "CMY_Y": 0.4471583,
    "CMYK_C": 0,
    "CMYK_M": 0.08933996,
    "CMYK_Y": 0.2312394,
    "CMYK_K": 0.2808663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05334",
    "Farbtonhilfsbezeichnung": "F4.25.59",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "157",
    "Bcolor": "112",
    "Y": 36,
    "L": 66.165490099839,
    "a": 4.45087276839823,
    "b": 27.0266923794037,
    "C": 27.3907351009678,
    "h": 1.40757702569973,
    "CMY_C": 0.2735942,
    "CMY_M": 0.3852431,
    "CMY_Y": 0.5626329,
    "CMYK_C": 0,
    "CMYK_M": 0.1537004,
    "CMYK_Y": 0.3979025,
    "CMYK_K": 0.2735942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05335",
    "Farbtonhilfsbezeichnung": "F5.26.65",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "175",
    "Bcolor": "122",
    "Y": 45,
    "L": 72.9180306639641,
    "a": 4.09254408915016,
    "b": 30.3884315492276,
    "C": 30.6627736700992,
    "h": 1.43692737498549,
    "CMY_C": 0.1951638,
    "CMY_M": 0.3142239,
    "CMY_Y": 0.5200214,
    "CMYK_C": 0,
    "CMYK_M": 0.1479308,
    "CMYK_Y": 0.4036319,
    "CMYK_K": 0.1951638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05336",
    "Farbtonhilfsbezeichnung": "F5.43.60",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "159",
    "Bcolor": "79",
    "Y": 37,
    "L": 67.5511053201127,
    "a": 6.29694429801275,
    "b": 45.8507327334617,
    "C": 46.281110614241,
    "h": 1.43431438020579,
    "CMY_C": 0.2193184,
    "CMY_M": 0.37822,
    "CMY_Y": 0.6889557,
    "CMYK_C": 0,
    "CMYK_M": 0.203542,
    "CMYK_Y": 0.6015735,
    "CMYK_K": 0.2193184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05337",
    "Farbtonhilfsbezeichnung": "F5.55.59",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "157",
    "Bcolor": "50",
    "Y": 37,
    "L": 67.4119110847275,
    "a": 7.04362791379615,
    "b": 58.8701121086663,
    "C": 59.2899889852827,
    "h": 1.45171547776663,
    "CMY_C": 0.2032901,
    "CMY_M": 0.3829859,
    "CMY_Y": 0.8040455,
    "CMYK_C": 0,
    "CMYK_M": 0.2255474,
    "CMYK_Y": 0.7540453,
    "CMYK_K": 0.2032901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05338",
    "Farbtonhilfsbezeichnung": "F5.65.58",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "151",
    "Bcolor": "21",
    "Y": 35,
    "L": 65.4225183152693,
    "a": 9.21419189774603,
    "b": 66.1136596163558,
    "C": 66.7526577762702,
    "h": 1.43231934949938,
    "CMY_C": 0.2085571,
    "CMY_M": 0.4095088,
    "CMY_Y": 0.9193913,
    "CMYK_C": 0,
    "CMYK_M": 0.2539055,
    "CMYK_Y": 0.8981497,
    "CMYK_K": 0.2085571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05339",
    "Farbtonhilfsbezeichnung": "F5.05.50",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "136",
    "Bcolor": "126",
    "Y": 25,
    "L": 56.9972850182,
    "a": 0.61566563173537,
    "b": 5.47970369449211,
    "C": 5.51418142152855,
    "h": 1.45891172169208,
    "CMY_C": 0.4432123,
    "CMY_M": 0.4660019,
    "CMY_Y": 0.5047082,
    "CMYK_C": 0,
    "CMYK_M": 0.04093055,
    "CMYK_Y": 0.1104475,
    "CMYK_K": 0.4432123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05340",
    "Farbtonhilfsbezeichnung": "F5.05.60",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "163",
    "Bcolor": "152",
    "Y": 37,
    "L": 67.1047331693141,
    "a": 0.35258253328418,
    "b": 5.5449609101776,
    "C": 5.55615927941007,
    "h": 1.50729569949167,
    "CMY_C": 0.3400277,
    "CMY_M": 0.361396,
    "CMY_Y": 0.403092,
    "CMYK_C": 0,
    "CMYK_M": 0.03237768,
    "CMYK_Y": 0.09555607,
    "CMYK_K": 0.3400277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05341",
    "Farbtonhilfsbezeichnung": "F5.15.56",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "151",
    "Bcolor": "125",
    "Y": 32,
    "L": 63.0286913334829,
    "a": 1.53134261546584,
    "b": 15.0975621139474,
    "C": 15.1750252714927,
    "h": 1.46971223797717,
    "CMY_C": 0.3502968,
    "CMY_M": 0.4085957,
    "CMY_Y": 0.5103661,
    "CMYK_C": 0,
    "CMYK_M": 0.08973157,
    "CMYK_Y": 0.2463729,
    "CMYK_K": 0.3502968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05342",
    "Farbtonhilfsbezeichnung": "F5.22.52",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "137",
    "Bcolor": "100",
    "Y": 26,
    "L": 58.0777648994058,
    "a": 2.90343162828954,
    "b": 22.1877442197564,
    "C": 22.3769057016712,
    "h": 1.44067821551238,
    "CMY_C": 0.3793052,
    "CMY_M": 0.4636872,
    "CMY_Y": 0.6075522,
    "CMYK_C": 0,
    "CMYK_M": 0.1359476,
    "CMYK_Y": 0.3677283,
    "CMYK_K": 0.3793052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05343",
    "Farbtonhilfsbezeichnung": "F4.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "132",
    "Bcolor": "85",
    "Y": 24,
    "L": 56.5734593711923,
    "a": 4.10875716498826,
    "b": 28.6815466624315,
    "C": 28.9743508018744,
    "h": 1.42851000212791,
    "CMY_C": 0.3770525,
    "CMY_M": 0.482726,
    "CMY_Y": 0.666957,
    "CMYK_C": 0,
    "CMYK_M": 0.1696348,
    "CMYK_Y": 0.4653755,
    "CMYK_K": 0.3770525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05344",
    "Farbtonhilfsbezeichnung": "F5.39.55",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "150",
    "Bcolor": "80",
    "Y": 33,
    "L": 63.9651221997777,
    "a": 5.01237048790976,
    "b": 40.7825840984679,
    "C": 41.0894514888758,
    "h": 1.44850494484405,
    "CMY_C": 0.2737632,
    "CMY_M": 0.4114981,
    "CMY_Y": 0.6848116,
    "CMYK_C": 0,
    "CMYK_M": 0.1896557,
    "CMYK_Y": 0.5659977,
    "CMYK_K": 0.2737632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05345",
    "Farbtonhilfsbezeichnung": "F4.48.53",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "135",
    "Bcolor": "60",
    "Y": 26,
    "L": 58.2933615471202,
    "a": 5.79551632055075,
    "b": 44.1717750158682,
    "C": 44.550350363092,
    "h": 1.44033745371671,
    "CMY_C": 0.3285432,
    "CMY_M": 0.4715031,
    "CMY_Y": 0.7656364,
    "CMYK_C": 0,
    "CMYK_M": 0.2129099,
    "CMYK_Y": 0.6509626,
    "CMYK_K": 0.3285432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05346",
    "Farbtonhilfsbezeichnung": "F4.57.51",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "130",
    "Bcolor": "40",
    "Y": 24,
    "L": 56.2804766347997,
    "a": 5.33274571606646,
    "b": 50.5569047156598,
    "C": 50.8373759285482,
    "h": 1.46570486051485,
    "CMY_C": 0.3476776,
    "CMY_M": 0.4912936,
    "CMY_Y": 0.8411854,
    "CMYK_C": 0,
    "CMYK_M": 0.220161,
    "CMYK_Y": 0.7565397,
    "CMYK_K": 0.3476776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05347",
    "Farbtonhilfsbezeichnung": "F4.15.50",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "134",
    "Bcolor": "111",
    "Y": 24,
    "L": 56.5440423996864,
    "a": 2.12350615454693,
    "b": 13.931777087184,
    "C": 14.0926821859923,
    "h": 1.4195387433253,
    "CMY_C": 0.4169809,
    "CMY_M": 0.475807,
    "CMY_Y": 0.566022,
    "CMYK_C": 0,
    "CMYK_M": 0.1008992,
    "CMYK_Y": 0.2556367,
    "CMYK_K": 0.4169809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05348",
    "Farbtonhilfsbezeichnung": "F4.24.44",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "117",
    "Bcolor": "83",
    "Y": 19,
    "L": 50.193573289142,
    "a": 3.21200942549127,
    "b": 21.2407161540979,
    "C": 21.4822025706956,
    "h": 1.42071397641627,
    "CMY_C": 0.4617546,
    "CMY_M": 0.5428942,
    "CMY_Y": 0.6756829,
    "CMYK_C": 0,
    "CMYK_M": 0.1507485,
    "CMYK_Y": 0.397455,
    "CMYK_K": 0.4617546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05350",
    "Farbtonhilfsbezeichnung": "F4.40.47",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "123",
    "Bcolor": "69",
    "Y": 21,
    "L": 53.2705052699239,
    "a": 4.56981875001278,
    "b": 33.0686621050616,
    "C": 33.3829246296172,
    "h": 1.43347424040019,
    "CMY_C": 0.403616,
    "CMY_M": 0.5174251,
    "CMY_Y": 0.7290882,
    "CMYK_C": 0,
    "CMYK_M": 0.1908319,
    "CMYK_Y": 0.5457427,
    "CMYK_K": 0.403616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05351",
    "Farbtonhilfsbezeichnung": "F4.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "130",
    "Bcolor": "60",
    "Y": 25,
    "L": 56.9794843355156,
    "a": 7.4761367618883,
    "b": 42.4042499471337,
    "C": 43.0582516419495,
    "h": 1.39628345078308,
    "CMY_C": 0.3353225,
    "CMY_M": 0.4884913,
    "CMY_Y": 0.7635466,
    "CMYK_C": 0,
    "CMYK_M": 0.2304409,
    "CMYK_Y": 0.6442585,
    "CMYK_K": 0.3353225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05352",
    "Farbtonhilfsbezeichnung": "F5.59.49",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "130",
    "Bcolor": "41",
    "Y": 24,
    "L": 56.5703572060273,
    "a": 6.31487295714184,
    "b": 50.8565571270316,
    "C": 51.2471172192141,
    "h": 1.44725837021385,
    "CMY_C": 0.3385831,
    "CMY_M": 0.4907403,
    "CMY_Y": 0.8405375,
    "CMYK_C": 0,
    "CMYK_M": 0.2300474,
    "CMYK_Y": 0.7589079,
    "CMYK_K": 0.3385831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05353",
    "Farbtonhilfsbezeichnung": "F5.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "113",
    "Bcolor": "105",
    "Y": 18.7,
    "L": 47.8589796205344,
    "a": 0.30223728330208,
    "b": 4.40671549490388,
    "C": 4.41706789946043,
    "h": 1.5023179532663,
    "CMY_C": 0.5400159,
    "CMY_M": 0.5560927,
    "CMY_Y": 0.586937,
    "CMYK_C": 0,
    "CMYK_M": 0.03495085,
    "CMYK_Y": 0.102006,
    "CMYK_K": 0.5400159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05354",
    "Farbtonhilfsbezeichnung": "F5.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "90",
    "Bcolor": "84",
    "Y": 10,
    "L": 38.2713277547029,
    "a": 0.25515183506197,
    "b": 3.31352607034293,
    "C": 3.3233352942154,
    "h": 1.49394486694393,
    "CMY_C": 0.6359102,
    "CMY_M": 0.647795,
    "CMY_Y": 0.670365,
    "CMYK_C": 0,
    "CMYK_M": 0.03264252,
    "CMYK_Y": 0.09463291,
    "CMYK_K": 0.6359102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05355",
    "Farbtonhilfsbezeichnung": "F5.11.39",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "109",
    "Bcolor": "95",
    "Y": 15,
    "L": 46.2776907099233,
    "a": 0.94482219934133,
    "b": 8.08328141287382,
    "C": 8.13831231817013,
    "h": 1.4544383456296,
    "CMY_C": 0.5420766,
    "CMY_M": 0.5737039,
    "CMY_Y": 0.6258357,
    "CMYK_C": 0,
    "CMYK_M": 0.0690667,
    "CMYK_Y": 0.1829106,
    "CMYK_K": 0.5420766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05356",
    "Farbtonhilfsbezeichnung": "F5.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "99",
    "Bcolor": "75",
    "Y": 13,
    "L": 42.6292010066726,
    "a": 1.88866723722425,
    "b": 14.9994160983413,
    "C": 15.1178552455084,
    "h": 1.44553947660476,
    "CMY_C": 0.5576442,
    "CMY_M": 0.6122539,
    "CMY_Y": 0.7043995,
    "CMYK_C": 0,
    "CMYK_M": 0.123452,
    "CMYK_Y": 0.3317586,
    "CMYK_K": 0.5576442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05357",
    "Farbtonhilfsbezeichnung": "F5.23.28",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "85",
    "Bcolor": "65",
    "Y": 9,
    "L": 36.6659996255714,
    "a": 1.5209115368979,
    "b": 13.2044893849583,
    "C": 13.2917911441816,
    "h": 1.45612027416393,
    "CMY_C": 0.6215771,
    "CMY_M": 0.6673989,
    "CMY_Y": 0.7467231,
    "CMYK_C": 0,
    "CMYK_M": 0.1210862,
    "CMYK_Y": 0.3307041,
    "CMYK_K": 0.6215771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05358",
    "Farbtonhilfsbezeichnung": "F5.32.22",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "74",
    "Bcolor": "51",
    "Y": 7,
    "L": 32.6124127837148,
    "a": 2.84601744383861,
    "b": 16.1029689364038,
    "C": 16.352535701151,
    "h": 1.3958641464977,
    "CMY_C": 0.648183,
    "CMY_M": 0.7079306,
    "CMY_Y": 0.8001856,
    "CMYK_C": 0,
    "CMYK_M": 0.1698258,
    "CMYK_Y": 0.4320503,
    "CMYK_K": 0.648183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05359",
    "Farbtonhilfsbezeichnung": "F4.38.35",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "99",
    "Bcolor": "54",
    "Y": 13,
    "L": 43.3440693910866,
    "a": 3.56168712933014,
    "b": 28.4260205256872,
    "C": 28.6482854309647,
    "h": 1.44614918802825,
    "CMY_C": 0.519996,
    "CMY_M": 0.6111638,
    "CMY_Y": 0.7871395,
    "CMYK_C": 0,
    "CMYK_M": 0.1899313,
    "CMYK_Y": 0.5565442,
    "CMYK_K": 0.519996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05360",
    "Farbtonhilfsbezeichnung": "F5.51.44",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "119",
    "Bcolor": "53",
    "Y": 20,
    "L": 52.0511683759381,
    "a": 5.63758503957307,
    "b": 40.0092292149658,
    "C": 40.4044649445342,
    "h": 1.4308108195738,
    "CMY_C": 0.4026166,
    "CMY_M": 0.5328367,
    "CMY_Y": 0.7920443,
    "CMYK_C": 0,
    "CMYK_M": 0.217984,
    "CMYK_Y": 0.6518891,
    "CMYK_K": 0.4026166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05361",
    "Farbtonhilfsbezeichnung": "F4.05.23",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "85",
    "Bcolor": "80",
    "Y": 7,
    "L": 36.050350189209,
    "a": 0.31807696819305,
    "b": 2.50021481513977,
    "C": 2.52036643028259,
    "h": 82.7497863769531,
    "CMY_C": 0.65853333473206,
    "CMY_M": 0.66849672794342,
    "CMY_Y": 0.68573534488678,
    "CMYK_C": 0,
    "CMYK_M": 0.02917823009193,
    "CMYK_Y": 0.07966227084398,
    "CMYK_K": 0.65853333473206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05362",
    "Farbtonhilfsbezeichnung": "F5.06.11",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "53",
    "Bcolor": "50",
    "Y": 4,
    "L": 22.2866266250431,
    "a": 0.01087372856506,
    "b": 2.25619217210805,
    "C": 2.25621837494835,
    "h": 1.56597685950378,
    "CMY_C": 0.785243,
    "CMY_M": 0.7913966,
    "CMY_Y": 0.8058707,
    "CMYK_C": 0,
    "CMYK_M": 0.02865381,
    "CMYK_Y": 0.09605144,
    "CMYK_K": 0.785243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05363",
    "Farbtonhilfsbezeichnung": "F5.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "86",
    "Bcolor": "75",
    "Y": 9,
    "L": 36.8965639532309,
    "a": 0.72841520868502,
    "b": 7.05605046368584,
    "C": 7.09354896101555,
    "h": 1.46792800673642,
    "CMY_C": 0.636788,
    "CMY_M": 0.6624426,
    "CMY_Y": 0.7062581,
    "CMYK_C": 0,
    "CMYK_M": 0.07063236,
    "CMYK_Y": 0.191266,
    "CMYK_K": 0.636788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05364",
    "Farbtonhilfsbezeichnung": "F4.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "65",
    "Bcolor": "54",
    "Y": 5,
    "L": 27.6298930568158,
    "a": 0.70686222893443,
    "b": 6.79989660279282,
    "C": 6.83653772163714,
    "h": 1.46721644401846,
    "CMY_C": 0.7235569,
    "CMY_M": 0.7468296,
    "CMY_Y": 0.7866877,
    "CMYK_C": 0,
    "CMYK_M": 0.08418624,
    "CMYK_Y": 0.2283683,
    "CMYK_K": 0.7235569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05365",
    "Farbtonhilfsbezeichnung": "F4.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "70",
    "Bcolor": "55",
    "Y": 6,
    "L": 30.4023192055124,
    "a": 1.81241364621665,
    "b": 10.3967459501992,
    "C": 10.5535382492307,
    "h": 1.39820559291187,
    "CMY_C": 0.6845784,
    "CMY_M": 0.7248634,
    "CMY_Y": 0.7842378,
    "CMYK_C": 0,
    "CMYK_M": 0.127718,
    "CMYK_Y": 0.3159562,
    "CMYK_K": 0.6845784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05366",
    "Farbtonhilfsbezeichnung": "F5.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "71",
    "Bcolor": "51",
    "Y": 7,
    "L": 31.0454769946192,
    "a": 2.02150916928062,
    "b": 14.0548883709869,
    "C": 14.1995206412889,
    "h": 1.42794638048676,
    "CMY_C": 0.6709857,
    "CMY_M": 0.7201143,
    "CMY_Y": 0.80107,
    "CMYK_C": 0,
    "CMYK_M": 0.1493205,
    "CMYK_Y": 0.3953757,
    "CMYK_K": 0.6709857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05367",
    "Farbtonhilfsbezeichnung": "F5.40.31",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "90",
    "Bcolor": "50",
    "Y": 11,
    "L": 39.1258253309401,
    "a": 2.47691597965372,
    "b": 25.4670906581096,
    "C": 25.5872589262437,
    "h": 1.47384179080244,
    "CMY_C": 0.5729032,
    "CMY_M": 0.6483396,
    "CMY_Y": 0.8045443,
    "CMYK_C": 0,
    "CMYK_M": 0.176626,
    "CMYK_Y": 0.542362,
    "CMYK_K": 0.5729032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05368",
    "Farbtonhilfsbezeichnung": "F5.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "108",
    "Bcolor": "44",
    "Y": 16,
    "L": 47.3832512776216,
    "a": 5.10228825012038,
    "b": 38.7037596280324,
    "C": 39.0386264452507,
    "h": 1.43972287939438,
    "CMY_C": 0.4574627,
    "CMY_M": 0.5770423,
    "CMY_Y": 0.8256422,
    "CMYK_C": 0,
    "CMYK_M": 0.2204081,
    "CMYK_Y": 0.6786253,
    "CMYK_K": 0.4574627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05369",
    "Farbtonhilfsbezeichnung": "F6.13.86",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "233",
    "Bcolor": "198",
    "Y": 84,
    "L": 93.2603408918416,
    "a": 1.88569824698609,
    "b": 18.7700425199613,
    "C": 18.8645263412533,
    "h": 1.47066909673368,
    "CMY_C": 0.005505387,
    "CMY_M": 0.0848791,
    "CMY_Y": 0.2227697,
    "CMYK_C": 0,
    "CMYK_M": 0.07981312,
    "CMYK_Y": 0.218467,
    "CMYK_K": 0.005505387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05370",
    "Farbtonhilfsbezeichnung": "F7.14.85",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "229",
    "Bcolor": "191",
    "Y": 79,
    "L": 91.4098842098103,
    "a": 0.97099175992454,
    "b": 20.1000715397362,
    "C": 20.1235111474205,
    "h": 1.52252597635115,
    "CMY_C": 0.02993196,
    "CMY_M": 0.1036232,
    "CMY_Y": 0.2528167,
    "CMYK_C": 0,
    "CMYK_M": 0.075965,
    "CMYK_Y": 0.229762,
    "CMYK_K": 0.02993196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05371",
    "Farbtonhilfsbezeichnung": "F6.19.84",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "227",
    "Bcolor": "177",
    "Y": 79,
    "L": 91.3466064613812,
    "a": 1.96393946543472,
    "b": 27.1463909232941,
    "C": 27.217340031388,
    "h": 1.49857590585523,
    "CMY_C": 0.006926714,
    "CMY_M": 0.1083014,
    "CMY_Y": 0.3061897,
    "CMYK_C": 0,
    "CMYK_M": 0.1020818,
    "CMYK_Y": 0.3013504,
    "CMYK_K": 0.006926714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05372",
    "Farbtonhilfsbezeichnung": "F7.60.79",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "210",
    "Bcolor": "43",
    "Y": 69,
    "L": 86.5799584992508,
    "a": 5.43481025446008,
    "b": 80.4248513132513,
    "C": 80.6082742109057,
    "h": 1.50332265440377,
    "CMY_C": 0,
    "CMY_M": 0.1772533,
    "CMY_Y": 0.832118,
    "CMYK_C": 0,
    "CMYK_M": 0.1772533,
    "CMYK_Y": 0.832118,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05373",
    "Farbtonhilfsbezeichnung": "F6.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "227",
    "Bcolor": "207",
    "Y": 78,
    "L": 90.7353539680313,
    "a": 0.84895861816031,
    "b": 10.4416051194092,
    "C": 10.476060719804,
    "h": 1.48966940281913,
    "CMY_C": 0.06452435,
    "CMY_M": 0.1084774,
    "CMY_Y": 0.1882181,
    "CMYK_C": 0,
    "CMYK_M": 0.04698472,
    "CMYK_Y": 0.1322255,
    "CMYK_K": 0.06452435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05374",
    "Farbtonhilfsbezeichnung": "F7.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "208",
    "Y": 81,
    "L": 92.3007558222671,
    "a": 0.66217964839931,
    "b": 12.3199940576695,
    "C": 12.3377767635732,
    "h": 1.51709962092976,
    "CMY_C": 0.04286738,
    "CMY_M": 0.09105624,
    "CMY_Y": 0.1851796,
    "CMYK_C": 0,
    "CMYK_M": 0.0503471,
    "CMYK_Y": 0.148686,
    "CMYK_K": 0.04286738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05375",
    "Farbtonhilfsbezeichnung": "F6.14.86",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "229",
    "Bcolor": "192",
    "Y": 80,
    "L": 91.6255114047675,
    "a": 1.64715711058699,
    "b": 19.6738655669094,
    "C": 19.7426977105911,
    "h": 1.48726802392764,
    "CMY_C": 0.02363299,
    "CMY_M": 0.1027578,
    "CMY_Y": 0.2471953,
    "CMYK_C": 0,
    "CMYK_M": 0.08103998,
    "CMYK_Y": 0.2289736,
    "CMYK_K": 0.02363299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05376",
    "Farbtonhilfsbezeichnung": "F7.20.83",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "224",
    "Bcolor": "174",
    "Y": 77,
    "L": 90.2105028100539,
    "a": 2.47625436867016,
    "b": 27.0879255153106,
    "C": 27.2008739642934,
    "h": 1.47963427342979,
    "CMY_C": 0.01652008,
    "CMY_M": 0.1221557,
    "CMY_Y": 0.3176994,
    "CMYK_C": 0,
    "CMYK_M": 0.10741,
    "CMYK_Y": 0.3062384,
    "CMYK_K": 0.01652008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05377",
    "Farbtonhilfsbezeichnung": "F6.26.80",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "214",
    "Bcolor": "151",
    "Y": 70,
    "L": 87.1408163673271,
    "a": 3.36378353456779,
    "b": 34.8010951303932,
    "C": 34.9632844844718,
    "h": 1.4744382581893,
    "CMY_C": 0.03010419,
    "CMY_M": 0.1597696,
    "CMY_Y": 0.4079081,
    "CMYK_C": 0,
    "CMYK_M": 0.1336901,
    "CMYK_Y": 0.3895304,
    "CMYK_K": 0.03010419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05378",
    "Farbtonhilfsbezeichnung": "F7.68.77",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "6",
    "Y": 64,
    "L": 84.2101344620324,
    "a": 6.99779279470386,
    "b": 84.443349096939,
    "C": 84.7328053985298,
    "h": 1.48811557441931,
    "CMY_C": 0,
    "CMY_M": 0.207265,
    "CMY_Y": 0.9751379,
    "CMYK_C": 0,
    "CMYK_M": 0.207265,
    "CMYK_Y": 0.9751379,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05379",
    "Farbtonhilfsbezeichnung": "F7.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "217",
    "Y": 82,
    "L": 92.397342186915,
    "a": 0.2436085733205,
    "b": 7.62369644342189,
    "C": 7.62758760018126,
    "h": 1.53885306772303,
    "CMY_C": 0.05883513,
    "CMY_M": 0.08775111,
    "CMY_Y": 0.1492276,
    "CMYK_C": 0,
    "CMYK_M": 0.0307236,
    "CMYK_Y": 0.09604315,
    "CMYK_K": 0.05883513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05380",
    "Farbtonhilfsbezeichnung": "F6.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "227",
    "Bcolor": "209",
    "Y": 78,
    "L": 90.6731463108427,
    "a": 0.70339265463426,
    "b": 9.11325831720051,
    "C": 9.14036314281975,
    "h": 1.49376560608914,
    "CMY_C": 0.07022133,
    "CMY_M": 0.1084762,
    "CMY_Y": 0.179068,
    "CMYK_C": 0,
    "CMYK_M": 0.04114404,
    "CMYK_Y": 0.1170673,
    "CMYK_K": 0.07022133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05381",
    "Farbtonhilfsbezeichnung": "F7.12.84",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "229",
    "Bcolor": "195",
    "Y": 79,
    "L": 91.3452379674831,
    "a": 0.87746418390893,
    "b": 17.6788856227778,
    "C": 17.700648018005,
    "h": 1.52120356810512,
    "CMY_C": 0.03752611,
    "CMY_M": 0.1035494,
    "CMY_Y": 0.2354434,
    "CMYK_C": 0,
    "CMYK_M": 0.06859745,
    "CMYK_Y": 0.205634,
    "CMYK_K": 0.03752611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05382",
    "Farbtonhilfsbezeichnung": "F6.24.83",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "223",
    "Bcolor": "162",
    "Y": 78,
    "L": 90.0469589233398,
    "a": 2.92372107505798,
    "b": 32.9977149963379,
    "C": 33.1269874572754,
    "h": 84.9365997314453,
    "CMY_C": 0.00293415784836,
    "CMY_M": 0.1262298822403,
    "CMY_Y": 0.36396074295044,
    "CMYK_C": 0,
    "CMYK_M": 0.12365856021643,
    "CMYK_Y": 0.36208900809288,
    "CMYK_K": 0.00293415784836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05384",
    "Farbtonhilfsbezeichnung": "F6.51.77",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "203",
    "Bcolor": "83",
    "Y": 65,
    "L": 84.334040503096,
    "a": 6.83885774354082,
    "b": 64.2542793329806,
    "C": 64.6171988547715,
    "h": 1.46476124519518,
    "CMY_C": 0,
    "CMY_M": 0.2035621,
    "CMY_Y": 0.6752796,
    "CMYK_C": 0,
    "CMYK_M": 0.2035621,
    "CMYK_Y": 0.6752796,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05385",
    "Farbtonhilfsbezeichnung": "F6.74.76",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "0",
    "Y": 65,
    "L": 84.296690179356,
    "a": 8.00579032123244,
    "b": 91.0670466188207,
    "C": 91.4182676413309,
    "h": 1.48311080369166,
    "CMY_C": 0,
    "CMY_M": 0.2093792,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2093792,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05386",
    "Farbtonhilfsbezeichnung": "F6.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "225",
    "Bcolor": "213",
    "Y": 76,
    "L": 89.8717422485352,
    "a": 0.76560294628143,
    "b": 6.17028045654297,
    "C": 6.21759653091431,
    "h": 82.9269409179688,
    "CMY_C": 0.0876430273056,
    "CMY_M": 0.11672240495682,
    "CMY_Y": 0.16601943969727,
    "CMYK_C": 0,
    "CMYK_M": 0.03187280520797,
    "CMYK_Y": 0.08590542525053,
    "CMYK_K": 0.0876430273056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05387",
    "Farbtonhilfsbezeichnung": "F6.16.79",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "215",
    "Bcolor": "173",
    "Y": 70,
    "L": 86.9447255594613,
    "a": 1.93826209343789,
    "b": 23.1919401190209,
    "C": 23.2727941259126,
    "h": 1.48741528392019,
    "CMY_C": 0.06637269,
    "CMY_M": 0.1560969,
    "CMY_Y": 0.3232162,
    "CMYK_C": 0,
    "CMYK_M": 0.09610286,
    "CMYK_Y": 0.2751029,
    "CMYK_K": 0.06637269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05388",
    "Farbtonhilfsbezeichnung": "F6.20.77",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "209",
    "Bcolor": "161",
    "Y": 66,
    "L": 84.8799822795434,
    "a": 2.82635015917815,
    "b": 26.6018259379424,
    "C": 26.7515494589542,
    "h": 1.46494694969402,
    "CMY_C": 0.07610163,
    "CMY_M": 0.1816338,
    "CMY_Y": 0.3700535,
    "CMYK_C": 0,
    "CMYK_M": 0.1142248,
    "CMYK_Y": 0.3181648,
    "CMYK_K": 0.07610163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05389",
    "Farbtonhilfsbezeichnung": "F7.51.74",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "198",
    "Bcolor": "74",
    "Y": 60,
    "L": 82.0881817208454,
    "a": 4.68256407787848,
    "b": 65.1326044032227,
    "C": 65.3007087456954,
    "h": 1.4990270238935,
    "CMY_C": 0.03814118,
    "CMY_M": 0.2225933,
    "CMY_Y": 0.7085643,
    "CMYK_C": 0,
    "CMYK_M": 0.1917663,
    "CMYK_Y": 0.6970078,
    "CMYK_K": 0.03814118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05390",
    "Farbtonhilfsbezeichnung": "F7.60.76",
    "Farbtonklasse": "03",
    "Rcolor": "254",
    "Gcolor": "203",
    "Bcolor": "54",
    "Y": 64,
    "L": 83.9910221690456,
    "a": 4.83741219185807,
    "b": 74.6522073628672,
    "C": 74.8087736890698,
    "h": 1.50608747647932,
    "CMY_C": 0.005368437,
    "CMY_M": 0.2033682,
    "CMY_Y": 0.7887475,
    "CMYK_C": 0,
    "CMYK_M": 0.1990684,
    "CMYK_Y": 0.7876073,
    "CMYK_K": 0.005368437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05391",
    "Farbtonhilfsbezeichnung": "F7.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "225",
    "Bcolor": "206",
    "Y": 76,
    "L": 89.8649001868617,
    "a": 0.91895592915602,
    "b": 9.87688591508895,
    "C": 9.91954411147073,
    "h": 1.47802235578389,
    "CMY_C": 0.07542712,
    "CMY_M": 0.1181768,
    "CMY_Y": 0.1934836,
    "CMYK_C": 0,
    "CMYK_M": 0.04623723,
    "CMYK_Y": 0.1276876,
    "CMYK_K": 0.07542712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05392",
    "Farbtonhilfsbezeichnung": "F7.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "221",
    "Bcolor": "200",
    "Y": 73,
    "L": 88.6461640814124,
    "a": 1.05038527879259,
    "b": 11.1053665163423,
    "C": 11.1549305105949,
    "h": 1.47649329627302,
    "CMY_C": 0.08458311,
    "CMY_M": 0.1323214,
    "CMY_Y": 0.2157484,
    "CMYK_C": 0,
    "CMYK_M": 0.05214925,
    "CMYK_Y": 0.1432848,
    "CMYK_K": 0.08458311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05393",
    "Farbtonhilfsbezeichnung": "F7.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "215",
    "Bcolor": "188",
    "Y": 69,
    "L": 86.3933017462973,
    "a": 0.81617901017144,
    "b": 14.4242331042379,
    "C": 14.4473059364726,
    "h": 1.51427272440639,
    "CMY_C": 0.1024004,
    "CMY_M": 0.1574616,
    "CMY_Y": 0.2644618,
    "CMYK_C": 0,
    "CMYK_M": 0.06134276,
    "CMYK_Y": 0.1805498,
    "CMYK_K": 0.1024004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05394",
    "Farbtonhilfsbezeichnung": "F7.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "202",
    "Bcolor": "172",
    "Y": 60,
    "L": 81.9992199680687,
    "a": 1.32010193747145,
    "b": 16.5077636675022,
    "C": 16.5604628687553,
    "h": 1.49099759036391,
    "CMY_C": 0.1423877,
    "CMY_M": 0.2072544,
    "CMY_Y": 0.3262421,
    "CMYK_C": 0,
    "CMYK_M": 0.07563645,
    "CMYK_Y": 0.2143794,
    "CMYK_K": 0.1423877
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05395",
    "Farbtonhilfsbezeichnung": "F6.35.77",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "206",
    "Bcolor": "120",
    "Y": 65,
    "L": 84.5731466299935,
    "a": 3.72279598156106,
    "b": 47.2197324718596,
    "C": 47.3662574480433,
    "h": 1.49211923269482,
    "CMY_C": 0.03684301,
    "CMY_M": 0.1908957,
    "CMY_Y": 0.530143,
    "CMYK_C": 0,
    "CMYK_M": 0.1599455,
    "CMYK_Y": 0.5121698,
    "CMYK_K": 0.03684301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05397",
    "Farbtonhilfsbezeichnung": "F6.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "215",
    "Bcolor": "201",
    "Y": 68,
    "L": 86.1678329474408,
    "a": 0.37727887388389,
    "b": 6.85155702793376,
    "C": 6.86193653830372,
    "h": 1.51578718854122,
    "CMY_C": 0.1297701,
    "CMY_M": 0.1569887,
    "CMY_Y": 0.211351,
    "CMYK_C": 0,
    "CMYK_M": 0.03127752,
    "CMYK_Y": 0.09374636,
    "CMYK_K": 0.1297701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05398",
    "Farbtonhilfsbezeichnung": "F7.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "208",
    "Bcolor": "190",
    "Y": 64,
    "L": 83.7728323050413,
    "a": 0.56878395088633,
    "b": 9.13309518557879,
    "C": 9.15078919283076,
    "h": 1.50859941418512,
    "CMY_C": 0.1480865,
    "CMY_M": 0.1843276,
    "CMY_Y": 0.253768,
    "CMYK_C": 0,
    "CMYK_M": 0.04254085,
    "CMYK_Y": 0.124052,
    "CMYK_K": 0.1480865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05399",
    "Farbtonhilfsbezeichnung": "F5.16.74",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "199",
    "Bcolor": "161",
    "Y": 59,
    "L": 81.2537088733922,
    "a": 1.87792178661195,
    "b": 21.0041458837659,
    "C": 21.0879286451551,
    "h": 1.48162622458717,
    "CMY_C": 0.1359539,
    "CMY_M": 0.2176928,
    "CMY_Y": 0.3667926,
    "CMYK_C": 0,
    "CMYK_M": 0.09460016,
    "CMYK_Y": 0.2671601,
    "CMYK_K": 0.1359539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05400",
    "Farbtonhilfsbezeichnung": "F7.25.70",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "187",
    "Bcolor": "130",
    "Y": 52,
    "L": 76.7998123168945,
    "a": 2.01901817321777,
    "b": 31.4233798980713,
    "C": 31.4881763458252,
    "h": 86.3236770629883,
    "CMY_C": 0.16334670782089,
    "CMY_M": 0.2681143283844,
    "CMY_Y": 0.48900258541107,
    "CMYK_C": 0,
    "CMYK_M": 0.12522226572037,
    "CMYK_Y": 0.38923636078835,
    "CMYK_K": 0.16334670782089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05401",
    "Farbtonhilfsbezeichnung": "F6.41.70",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "187",
    "Bcolor": "99",
    "Y": 53,
    "L": 78.1224488330385,
    "a": 5.38025520913016,
    "b": 49.5344312245475,
    "C": 49.8257666559662,
    "h": 1.46260399126622,
    "CMY_C": 0.09847381,
    "CMY_M": 0.265005,
    "CMY_Y": 0.6135637,
    "CMYK_C": 0,
    "CMYK_M": 0.1847214,
    "CMYK_Y": 0.5713531,
    "CMYK_K": 0.09847381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05402",
    "Farbtonhilfsbezeichnung": "F7.69.72",
    "Farbtonklasse": "04",
    "Rcolor": "243",
    "Gcolor": "192",
    "Bcolor": "0",
    "Y": 57,
    "L": 80.1659026926765,
    "a": 4.94871846971212,
    "b": 83.11843139941,
    "C": 83.2656198727355,
    "h": 1.51132836766241,
    "CMY_C": 0.04515343,
    "CMY_M": 0.2455673,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2098912,
    "CMYK_Y": 1,
    "CMYK_K": 0.04515343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05403",
    "Farbtonhilfsbezeichnung": "F6.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "200",
    "Bcolor": "191",
    "Y": 58,
    "L": 80.7076610798443,
    "a": 0.38911890265902,
    "b": 4.3134015475889,
    "C": 4.33091750454207,
    "h": 1.48082824581338,
    "CMY_C": 0.1975514,
    "CMY_M": 0.2160746,
    "CMY_Y": 0.2516297,
    "CMYK_C": 0,
    "CMYK_M": 0.02308338,
    "CMYK_Y": 0.06739159,
    "CMYK_K": 0.1975514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05404",
    "Farbtonhilfsbezeichnung": "F7.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "195",
    "Bcolor": "178",
    "Y": 55,
    "L": 78.9269667788386,
    "a": 0.42551384194017,
    "b": 8.65315791017311,
    "C": 8.66361378687175,
    "h": 1.52166150668386,
    "CMY_C": 0.2037607,
    "CMY_M": 0.2365846,
    "CMY_Y": 0.3018684,
    "CMYK_C": 0,
    "CMYK_M": 0.04122371,
    "CMYK_Y": 0.1232138,
    "CMYK_K": 0.2037607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05405",
    "Farbtonhilfsbezeichnung": "F6.19.70",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "188",
    "Bcolor": "147",
    "Y": 52,
    "L": 77.3635140094127,
    "a": 2.25663777718788,
    "b": 23.4026726422379,
    "C": 23.5112207436615,
    "h": 1.47466703214674,
    "CMY_C": 0.1714137,
    "CMY_M": 0.2611029,
    "CMY_Y": 0.4244486,
    "CMYK_C": 0,
    "CMYK_M": 0.1082437,
    "CMYK_Y": 0.3053815,
    "CMYK_K": 0.1714137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05406",
    "Farbtonhilfsbezeichnung": "F7.28.66",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "179",
    "Bcolor": "119",
    "Y": 47,
    "L": 73.9550391897801,
    "a": 2.22258740668912,
    "b": 33.457779167374,
    "C": 33.5315207169782,
    "h": 1.50446416896236,
    "CMY_C": 0.1903268,
    "CMY_M": 0.2993423,
    "CMY_Y": 0.5326308,
    "CMYK_C": 0,
    "CMYK_M": 0.1346414,
    "CMYK_Y": 0.4227681,
    "CMYK_K": 0.1903268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05407",
    "Farbtonhilfsbezeichnung": "F6.37.65",
    "Farbtonklasse": "03",
    "Rcolor": "211",
    "Gcolor": "176",
    "Bcolor": "101",
    "Y": 46,
    "L": 73.3035056031555,
    "a": 3.82859294715721,
    "b": 42.2491322663191,
    "C": 42.422250072479,
    "h": 1.4804237181596,
    "CMY_C": 0.1736403,
    "CMY_M": 0.311479,
    "CMY_Y": 0.6049178,
    "CMYK_C": 0,
    "CMYK_M": 0.1668023,
    "CMYK_Y": 0.5219004,
    "CMYK_K": 0.1736403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05408",
    "Farbtonhilfsbezeichnung": "F7.52.70",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "185",
    "Bcolor": "71",
    "Y": 52,
    "L": 77.1134367890195,
    "a": 4.0673460469956,
    "b": 60.7145257084972,
    "C": 60.8506116310574,
    "h": 1.5039049560237,
    "CMY_C": 0.1056415,
    "CMY_M": 0.2739841,
    "CMY_Y": 0.7200998,
    "CMYK_C": 0,
    "CMYK_M": 0.1882272,
    "CMYK_Y": 0.687038,
    "CMYK_K": 0.1056415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05409",
    "Farbtonhilfsbezeichnung": "F6.63.70",
    "Farbtonklasse": "04",
    "Rcolor": "236",
    "Gcolor": "183",
    "Bcolor": "38",
    "Y": 52,
    "L": 77.1917966943095,
    "a": 7.21872729620376,
    "b": 72.7974016203387,
    "C": 73.1544373667781,
    "h": 1.47195756350439,
    "CMY_C": 0.07485942,
    "CMY_M": 0.2821251,
    "CMY_Y": 0.851238,
    "CMYK_C": 0,
    "CMYK_M": 0.2240369,
    "CMYK_Y": 0.8392006,
    "CMYK_K": 0.07485942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05410",
    "Farbtonhilfsbezeichnung": "F7.26.63",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "169",
    "Bcolor": "119",
    "Y": 41,
    "L": 70.37639276631,
    "a": 2.28121901351536,
    "b": 28.9063114441209,
    "C": 28.9961859818173,
    "h": 1.4920418711942,
    "CMY_C": 0.2378289,
    "CMY_M": 0.3365051,
    "CMY_Y": 0.5349776,
    "CMYK_C": 0,
    "CMYK_M": 0.1294673,
    "CMYK_Y": 0.3898713,
    "CMYK_K": 0.2378289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05411",
    "Farbtonhilfsbezeichnung": "F6.33.65",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "173",
    "Bcolor": "108",
    "Y": 44,
    "L": 72.3877087889611,
    "a": 3.58657528467377,
    "b": 37.3638499988593,
    "C": 37.5355938944609,
    "h": 1.47509901495562,
    "CMY_C": 0.1927913,
    "CMY_M": 0.3198235,
    "CMY_Y": 0.576995,
    "CMYK_C": 0,
    "CMYK_M": 0.1573722,
    "CMYK_Y": 0.4759657,
    "CMYK_K": 0.1927913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05412",
    "Farbtonhilfsbezeichnung": "F7.44.62",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "166",
    "Bcolor": "80",
    "Y": 41,
    "L": 69.9624249204322,
    "a": 4.01237383272623,
    "b": 48.4238996403733,
    "C": 48.5898466776187,
    "h": 1.48812580763631,
    "CMY_C": 0.2026293,
    "CMY_M": 0.3479342,
    "CMY_Y": 0.6866014,
    "CMYK_C": 0,
    "CMYK_M": 0.18223,
    "CMYK_Y": 0.6069599,
    "CMYK_K": 0.2026293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05413",
    "Farbtonhilfsbezeichnung": "F6.62.70",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "181",
    "Bcolor": "45",
    "Y": 50,
    "L": 76.3142191130816,
    "a": 6.11909777143821,
    "b": 69.8929624513242,
    "C": 70.1603132672498,
    "h": 1.48346943542088,
    "CMY_C": 0.09431065,
    "CMY_M": 0.288447,
    "CMY_Y": 0.824772,
    "CMYK_C": 0,
    "CMYK_M": 0.214352,
    "CMYK_Y": 0.8065253,
    "CMYK_K": 0.09431065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05414",
    "Farbtonhilfsbezeichnung": "F6.75.68",
    "Farbtonklasse": "04",
    "Rcolor": "235",
    "Gcolor": "178",
    "Bcolor": "0",
    "Y": 50,
    "L": 75.8106855227127,
    "a": 8.78041126599216,
    "b": 78.2504766086785,
    "C": 78.7415564456616,
    "h": 1.45905469208355,
    "CMY_C": 0.0785533,
    "CMY_M": 0.3011493,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.2415723,
    "CMYK_Y": 1,
    "CMYK_K": 0.0785533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05415",
    "Farbtonhilfsbezeichnung": "F6.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "146",
    "Bcolor": "132",
    "Y": 29,
    "L": 61.0308994319213,
    "a": 0.61027501518828,
    "b": 8.1748515803366,
    "C": 8.19759927995354,
    "h": 1.49628181221741,
    "CMY_C": 0.3944637,
    "CMY_M": 0.4255282,
    "CMY_Y": 0.4827962,
    "CMYK_C": 0,
    "CMYK_M": 0.05130092,
    "CMYK_Y": 0.1458748,
    "CMYK_K": 0.3944637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05416",
    "Farbtonhilfsbezeichnung": "F6.19.50",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "137",
    "Bcolor": "106",
    "Y": 26,
    "L": 57.7381548820295,
    "a": 1.91157270557796,
    "b": 18.0272982801948,
    "C": 18.1283643358088,
    "h": 1.46515342570044,
    "CMY_C": 0.3972199,
    "CMY_M": 0.4641029,
    "CMY_Y": 0.5823747,
    "CMYK_C": 0,
    "CMYK_M": 0.1109575,
    "CMYK_Y": 0.3071681,
    "CMYK_K": 0.3972199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05417",
    "Farbtonhilfsbezeichnung": "F7.22.60",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "163",
    "Bcolor": "122",
    "Y": 38,
    "L": 67.740284210517,
    "a": 1.44198107688964,
    "b": 23.5191799638408,
    "C": 23.5633430479981,
    "h": 1.50956212003957,
    "CMY_C": 0.2824414,
    "CMY_M": 0.361199,
    "CMY_Y": 0.5226681,
    "CMYK_C": 0,
    "CMYK_M": 0.1097577,
    "CMYK_Y": 0.3347833,
    "CMYK_K": 0.2824414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05418",
    "Farbtonhilfsbezeichnung": "F6.28.60",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "162",
    "Bcolor": "110",
    "Y": 38,
    "L": 67.8412532022476,
    "a": 3.11107069883243,
    "b": 30.1933129628267,
    "C": 30.353169662563,
    "h": 1.46812026993831,
    "CMY_C": 0.2581946,
    "CMY_M": 0.3652293,
    "CMY_Y": 0.5692083,
    "CMYK_C": 0,
    "CMYK_M": 0.1442895,
    "CMYK_Y": 0.4192659,
    "CMYK_K": 0.2581946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05419",
    "Farbtonhilfsbezeichnung": "F6.29.57",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "154",
    "Bcolor": "102",
    "Y": 34,
    "L": 64.9629235193362,
    "a": 2.87242870589877,
    "b": 30.5916666831207,
    "C": 30.7262252338556,
    "h": 1.47717502794221,
    "CMY_C": 0.2906768,
    "CMY_M": 0.3946413,
    "CMY_Y": 0.6003222,
    "CMYK_C": 0,
    "CMYK_M": 0.1465685,
    "CMYK_Y": 0.4365364,
    "CMYK_K": 0.2906768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05420",
    "Farbtonhilfsbezeichnung": "F6.42.60",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "159",
    "Bcolor": "81",
    "Y": 37,
    "L": 67.4235000610352,
    "a": 4.55820083618164,
    "b": 44.8814239501953,
    "C": 45.1122970581055,
    "h": 84.2008743286133,
    "CMY_C": 0.23246216773987,
    "CMY_M": 0.37520217895508,
    "CMY_Y": 0.68310236930847,
    "CMYK_C": 0,
    "CMYK_M": 0.18597130477428,
    "CMYK_Y": 0.58712440729141,
    "CMYK_K": 0.23246216773987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05421",
    "Farbtonhilfsbezeichnung": "F6.61.60",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "157",
    "Bcolor": "39",
    "Y": 37,
    "L": 67.0336026618139,
    "a": 5.61571986926424,
    "b": 62.2409576938989,
    "C": 62.493784685389,
    "h": 1.48081449542726,
    "CMY_C": 0.2133147,
    "CMY_M": 0.3837477,
    "CMY_Y": 0.845743,
    "CMYK_C": 0,
    "CMYK_M": 0.216647,
    "CMYK_Y": 0.8039153,
    "CMYK_K": 0.2133147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05422",
    "Farbtonhilfsbezeichnung": "F6.09.43",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "121",
    "Bcolor": "109",
    "Y": 19,
    "L": 51.2149878456502,
    "a": 0.54193854771983,
    "b": 6.95390866063577,
    "C": 6.97499412544339,
    "h": 1.49302059049166,
    "CMY_C": 0.49834,
    "CMY_M": 0.5241221,
    "CMY_Y": 0.5712529,
    "CMYK_C": 0,
    "CMYK_M": 0.05139358,
    "CMYK_Y": 0.1453432,
    "CMYK_K": 0.49834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05423",
    "Farbtonhilfsbezeichnung": "F6.15.37",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "104",
    "Bcolor": "88",
    "Y": 14,
    "L": 44.50824735104,
    "a": 1.00837131812542,
    "b": 10.1767671210069,
    "C": 10.2266026494837,
    "h": 1.47203307902682,
    "CMY_C": 0.554325,
    "CMY_M": 0.5914158,
    "CMY_Y": 0.6560071,
    "CMYK_C": 0,
    "CMYK_M": 0.08322367,
    "CMYK_Y": 0.2281528,
    "CMYK_K": 0.554325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05424",
    "Farbtonhilfsbezeichnung": "F6.15.47",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "128",
    "Bcolor": "106",
    "Y": 22,
    "L": 54.2559627515603,
    "a": 1.26303718024345,
    "b": 13.1345357073762,
    "C": 13.195123764748,
    "h": 1.47492955636906,
    "CMY_C": 0.4479597,
    "CMY_M": 0.4967341,
    "CMY_Y": 0.5829448,
    "CMYK_C": 0,
    "CMYK_M": 0.0883529,
    "CMYK_Y": 0.2445202,
    "CMYK_K": 0.4479597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05425",
    "Farbtonhilfsbezeichnung": "F6.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "133",
    "Bcolor": "86",
    "Y": 25,
    "L": 56.7823456102267,
    "a": 2.89018121832157,
    "b": 28.4196170565747,
    "C": 28.5661999768449,
    "h": 1.46944805884935,
    "CMY_C": 0.382622,
    "CMY_M": 0.4778084,
    "CMY_Y": 0.6634067,
    "CMYK_C": 0,
    "CMYK_M": 0.1541785,
    "CMYK_Y": 0.4548018,
    "CMYK_K": 0.382622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05426",
    "Farbtonhilfsbezeichnung": "F6.37.53",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "144",
    "Bcolor": "82",
    "Y": 29,
    "L": 61.0126922218298,
    "a": 3.10344823434183,
    "b": 35.9383696526339,
    "C": 36.0721194862819,
    "h": 1.48465529382088,
    "CMY_C": 0.3244494,
    "CMY_M": 0.4365828,
    "CMY_Y": 0.6773499,
    "CMYK_C": 0,
    "CMYK_M": 0.1659882,
    "CMYK_Y": 0.5223894,
    "CMYK_K": 0.3244494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05427",
    "Farbtonhilfsbezeichnung": "F7.51.59",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "158",
    "Bcolor": "62",
    "Y": 36,
    "L": 66.8903401385887,
    "a": 3.53616322534345,
    "b": 52.9686361809831,
    "C": 53.0865413191481,
    "h": 1.50413567414452,
    "CMY_C": 0.235683,
    "CMY_M": 0.3793392,
    "CMY_Y": 0.7558119,
    "CMYK_C": 0,
    "CMYK_M": 0.1879537,
    "CMYK_Y": 0.6805147,
    "CMYK_K": 0.235683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05428",
    "Farbtonhilfsbezeichnung": "F7.68.56",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "154",
    "Bcolor": "28",
    "Y": 34,
    "L": 65.3004070128788,
    "a": 3.69966012729861,
    "b": 63.7077786096967,
    "C": 63.8151121634966,
    "h": 1.5127891305769,
    "CMY_C": 0.2436363,
    "CMY_M": 0.3971786,
    "CMY_Y": 0.8884072,
    "CMYK_C": 0,
    "CMYK_M": 0.2030007,
    "CMYK_Y": 0.8524614,
    "CMYK_K": 0.2436363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05429",
    "Farbtonhilfsbezeichnung": "F6.04.27",
    "Farbtonklasse": "02",
    "Rcolor": "86",
    "Gcolor": "83",
    "Bcolor": "79",
    "Y": 9,
    "L": 35.5643712182014,
    "a": 0.34626437086204,
    "b": 2.22794534447446,
    "C": 2.25469276676311,
    "h": 1.41661117510488,
    "CMY_C": 0.6636189,
    "CMY_M": 0.6730213,
    "CMY_Y": 0.6885005,
    "CMYK_C": 0,
    "CMYK_M": 0.02795132,
    "CMYK_Y": 0.07396828,
    "CMYK_K": 0.6636189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05430",
    "Farbtonhilfsbezeichnung": "F6.16.25",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "82",
    "Bcolor": "69",
    "Y": 9,
    "L": 35.3105392541001,
    "a": 0.64528826931489,
    "b": 8.24352446673842,
    "C": 8.26874189851336,
    "h": 1.49267742266664,
    "CMY_C": 0.6496799,
    "CMY_M": 0.6772602,
    "CMY_Y": 0.727954,
    "CMYK_C": 0,
    "CMYK_M": 0.07872901,
    "CMYK_Y": 0.2234361,
    "CMYK_K": 0.6496799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05431",
    "Farbtonhilfsbezeichnung": "F7.16.29",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "90",
    "Bcolor": "75",
    "Y": 10,
    "L": 38.4395272946682,
    "a": 0.68614781690559,
    "b": 9.45160882366415,
    "C": 9.47648184624496,
    "h": 1.49832758025245,
    "CMY_C": 0.6170083,
    "CMY_M": 0.6483947,
    "CMY_Y": 0.7072787,
    "CMYK_C": 0,
    "CMYK_M": 0.08195074,
    "CMYK_Y": 0.2356981,
    "CMYK_K": 0.6170083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05432",
    "Farbtonhilfsbezeichnung": "F7.25.34",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "99",
    "Bcolor": "71",
    "Y": 13,
    "L": 42.5422469043044,
    "a": 1.16132371672778,
    "b": 17.7061739816971,
    "C": 17.744217927121,
    "h": 1.50530150472067,
    "CMY_C": 0.5579662,
    "CMY_M": 0.6120311,
    "CMY_Y": 0.7229226,
    "CMYK_C": 0,
    "CMYK_M": 0.1223093,
    "CMYK_Y": 0.3731761,
    "CMYK_K": 0.5579662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05433",
    "Farbtonhilfsbezeichnung": "F6.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "110",
    "Bcolor": "71",
    "Y": 16,
    "L": 47.4882674533428,
    "a": 1.87308325358682,
    "b": 24.1178617375647,
    "C": 24.1904877104029,
    "h": 1.49328817482333,
    "CMY_C": 0.4930431,
    "CMY_M": 0.5669051,
    "CMY_Y": 0.7204406,
    "CMYK_C": 0,
    "CMYK_M": 0.1456967,
    "CMYK_Y": 0.4485539,
    "CMYK_K": 0.4930431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05434",
    "Farbtonhilfsbezeichnung": "F6.43.48",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "130",
    "Bcolor": "66",
    "Y": 24,
    "L": 55.761137649547,
    "a": 2.95543653550251,
    "b": 37.729344338295,
    "C": 37.8449207861903,
    "h": 1.49262338474685,
    "CMY_C": 0.3803363,
    "CMY_M": 0.4895616,
    "CMY_Y": 0.7405685,
    "CMYK_C": 0,
    "CMYK_M": 0.1762656,
    "CMYK_Y": 0.5813349,
    "CMYK_K": 0.3803363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05435",
    "Farbtonhilfsbezeichnung": "F7.47.57",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "155",
    "Bcolor": "69",
    "Y": 35,
    "L": 65.5760898228392,
    "a": 3.74509943412249,
    "b": 48.2650132266564,
    "C": 48.4100947276576,
    "h": 1.4933569991379,
    "CMY_C": 0.2543914,
    "CMY_M": 0.3928798,
    "CMY_Y": 0.7287644,
    "CMYK_C": 0,
    "CMYK_M": 0.1857387,
    "CMYK_Y": 0.6362225,
    "CMYK_K": 0.2543914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05436",
    "Farbtonhilfsbezeichnung": "F6.07.15",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "60",
    "Bcolor": "56",
    "Y": 5,
    "L": 25.5088289494082,
    "a": -0.09986142221013,
    "b": 2.70305248303155,
    "C": 2.70489649148888,
    "h": -1.53386917577484,
    "CMY_C": 0.7566184,
    "CMY_M": 0.7632246,
    "CMY_Y": 0.7809087,
    "CMYK_C": 0,
    "CMYK_M": 0.0271433,
    "CMYK_Y": 0.09980327,
    "CMYK_K": 0.7566184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05437",
    "Farbtonhilfsbezeichnung": "F6.11.11",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "55",
    "Bcolor": "51",
    "Y": 4,
    "L": 23.1452776746967,
    "a": -0.07510595445364,
    "b": 2.21121590036096,
    "C": 2.21249105363243,
    "h": -1.53684347234936,
    "CMY_C": 0.7784102,
    "CMY_M": 0.7838067,
    "CMY_Y": 0.7983262,
    "CMYK_C": 0,
    "CMYK_M": 0.02435386,
    "CMYK_Y": 0.08987777,
    "CMYK_K": 0.7784102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05438",
    "Farbtonhilfsbezeichnung": "F6.21.21",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "72",
    "Bcolor": "57",
    "Y": 7,
    "L": 30.7626059036831,
    "a": 0.83246999615657,
    "b": 9.84388898042201,
    "C": 9.87902609336441,
    "h": 1.48642987670743,
    "CMY_C": 0.6879191,
    "CMY_M": 0.7195588,
    "CMY_Y": 0.7778982,
    "CMYK_C": 0,
    "CMYK_M": 0.1013832,
    "CMYK_Y": 0.2883198,
    "CMYK_K": 0.6879191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05439",
    "Farbtonhilfsbezeichnung": "F7.21.18",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "56",
    "Y": 6,
    "L": 29.0487945007382,
    "a": 0.70452474689244,
    "b": 8.02606643918263,
    "C": 8.05692854660867,
    "h": 1.4832411641405,
    "CMY_C": 0.7080996,
    "CMY_M": 0.7343946,
    "CMY_Y": 0.7817753,
    "CMYK_C": 0,
    "CMYK_M": 0.09008212,
    "CMYK_Y": 0.2524,
    "CMYK_K": 0.7080996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05440",
    "Farbtonhilfsbezeichnung": "F6.31.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "92",
    "Bcolor": "62",
    "Y": 11,
    "L": 40.0121747745482,
    "a": 2.48592215646323,
    "b": 19.4622479987251,
    "C": 19.6203696736803,
    "h": 1.44375377546835,
    "CMY_C": 0.57249,
    "CMY_M": 0.6391342,
    "CMY_Y": 0.7568722,
    "CMYK_C": 0,
    "CMYK_M": 0.1558893,
    "CMYK_Y": 0.4312934,
    "CMYK_K": 0.57249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05441",
    "Farbtonhilfsbezeichnung": "F7.39.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "90",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.3106804089135,
    "a": 2.39413125070029,
    "b": 23.8935709178531,
    "C": 24.0132171033382,
    "h": 1.47092984717866,
    "CMY_C": 0.5735745,
    "CMY_M": 0.6462113,
    "CMY_Y": 0.7923428,
    "CMYK_C": 0,
    "CMYK_M": 0.1703389,
    "CMYK_Y": 0.5130283,
    "CMYK_K": 0.5735745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05442",
    "Farbtonhilfsbezeichnung": "F6.46.36",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "103",
    "Bcolor": "54",
    "Y": 14,
    "L": 44.6767361978199,
    "a": 2.73017523225288,
    "b": 30.2679261185439,
    "C": 30.3908079576118,
    "h": 1.48083949124797,
    "CMY_C": 0.5086223,
    "CMY_M": 0.5968341,
    "CMY_Y": 0.7883113,
    "CMYK_C": 0,
    "CMYK_M": 0.1795193,
    "CMYK_Y": 0.5691935,
    "CMYK_K": 0.5086223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05443",
    "Farbtonhilfsbezeichnung": "F8.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "235",
    "Bcolor": "217",
    "Y": 84,
    "L": 93.3204377692404,
    "a": 0.14064189019125,
    "b": 9.06975964648615,
    "C": 9.0708500255657,
    "h": 1.55529088624162,
    "CMY_C": 0.0448171,
    "CMY_M": 0.07755861,
    "CMY_Y": 0.1498899,
    "CMYK_C": 0,
    "CMYK_M": 0.03427773,
    "CMYK_Y": 0.1100028,
    "CMYK_K": 0.0448171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05444",
    "Farbtonhilfsbezeichnung": "F9.18.86",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "233",
    "Bcolor": "182",
    "Y": 83,
    "L": 92.9871716547494,
    "a": 1.18094242213662,
    "b": 26.9950177205277,
    "C": 27.0208365291678,
    "h": 1.52707752109986,
    "CMY_C": 0,
    "CMY_M": 0.08807851,
    "CMY_Y": 0.2877329,
    "CMYK_C": 0,
    "CMYK_M": 0.08807851,
    "CMYK_Y": 0.2877329,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05445",
    "Farbtonhilfsbezeichnung": "F9.25.84",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "228",
    "Bcolor": "162",
    "Y": 79,
    "L": 91.525260925293,
    "a": 0.89926147460938,
    "b": 35.0644226074219,
    "C": 35.0759506225586,
    "h": 88.5309143066406,
    "CMY_C": 0,
    "CMY_M": 0.1052907705307,
    "CMY_Y": 0.36460810899734,
    "CMYK_C": 0,
    "CMYK_M": 0.1052907705307,
    "CMYK_Y": 0.36460810899734,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05446",
    "Farbtonhilfsbezeichnung": "F9.28.83",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "222",
    "Bcolor": "148",
    "Y": 75,
    "L": 89.5000186010398,
    "a": 0.48952371785099,
    "b": 39.2165760482432,
    "C": 39.2196311866645,
    "h": 1.5583144034713,
    "CMY_C": 0.01413733,
    "CMY_M": 0.1275856,
    "CMY_Y": 0.4177744,
    "CMYK_C": 0,
    "CMYK_M": 0.1150752,
    "CMYK_Y": 0.4094253,
    "CMYK_K": 0.01413733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05447",
    "Farbtonhilfsbezeichnung": "F9.44.81",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "219",
    "Bcolor": "107",
    "Y": 73,
    "L": 88.417839050293,
    "a": 0.43711945414543,
    "b": 57.9035758972168,
    "C": 57.9052276611328,
    "h": 89.5674743652344,
    "CMY_C": 0,
    "CMY_M": 0.1422798037529,
    "CMY_Y": 0.57896959781647,
    "CMYK_C": 0,
    "CMYK_M": 0.1422798037529,
    "CMYK_Y": 0.57896959781647,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05448",
    "Farbtonhilfsbezeichnung": "F9.11.86",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "201",
    "Y": 83,
    "L": 93.0681048108863,
    "a": 0.2293496994683,
    "b": 16.7993987222275,
    "C": 16.8009642197412,
    "h": 1.55714491844348,
    "CMY_C": 0.02503764,
    "CMY_M": 0.0825472,
    "CMY_Y": 0.2103701,
    "CMYK_C": 0,
    "CMYK_M": 0.05898645,
    "CMYK_Y": 0.1900919,
    "CMYK_K": 0.02503764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05449",
    "Farbtonhilfsbezeichnung": "F8.23.83",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "222",
    "Bcolor": "160",
    "Y": 76,
    "L": 89.6965265951899,
    "a": 1.93237425621301,
    "b": 33.4591556681295,
    "C": 33.5149096416834,
    "h": 1.51310718101259,
    "CMY_C": 0.01292178,
    "CMY_M": 0.127824,
    "CMY_Y": 0.3713547,
    "CMYK_C": 0,
    "CMYK_M": 0.1164064,
    "CMYK_Y": 0.3631251,
    "CMYK_K": 0.01292178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05451",
    "Farbtonhilfsbezeichnung": "F9.51.80",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "214",
    "Bcolor": "79",
    "Y": 70,
    "L": 86.9410616912139,
    "a": 0.88256702266631,
    "b": 68.5791011060817,
    "C": 68.5847798937029,
    "h": 1.55792770807872,
    "CMY_C": 0.0002820081,
    "CMY_M": 0.1609192,
    "CMY_Y": 0.6911744,
    "CMYK_C": 0,
    "CMYK_M": 0.1606825,
    "CMYK_Y": 0.6910874,
    "CMYK_K": 0.0002820081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05452",
    "Farbtonhilfsbezeichnung": "F9.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "228",
    "Bcolor": "214",
    "Y": 76,
    "L": 90.6663970947266,
    "a": -0.09565950185061,
    "b": 6.51390647888184,
    "C": 6.51460886001587,
    "h": 90.8413543701172,
    "CMY_C": 0.08429104089737,
    "CMY_M": 0.10592502355576,
    "CMY_Y": 0.16000133752823,
    "CMYK_C": 0,
    "CMYK_M": 0.02362539060414,
    "CMYK_Y": 0.08267943561077,
    "CMYK_K": 0.08429104089737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05453",
    "Farbtonhilfsbezeichnung": "F9.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "235",
    "Bcolor": "210",
    "Y": 83,
    "L": 93.385009765625,
    "a": 0.07030498236418,
    "b": 12.6631021499634,
    "C": 12.6632976531982,
    "h": 89.6819000244141,
    "CMY_C": 0.03405594825745,
    "CMY_M": 0.07755869626999,
    "CMY_Y": 0.17601782083511,
    "CMYK_C": 0,
    "CMYK_M": 0.04503650963306,
    "CMYK_Y": 0.14696697890759,
    "CMYK_K": 0.03405594825745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05454",
    "Farbtonhilfsbezeichnung": "F9.12.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "224",
    "Bcolor": "191",
    "Y": 76,
    "L": 89.6756804416064,
    "a": 0.97573141154988,
    "b": 17.3792274837949,
    "C": 17.4065964427564,
    "h": 1.51471166210801,
    "CMY_C": 0.05651592,
    "CMY_M": 0.1222735,
    "CMY_Y": 0.2511431,
    "CMYK_C": 0,
    "CMYK_M": 0.06969655,
    "CMYK_Y": 0.2062856,
    "CMYK_K": 0.05651592
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05455",
    "Farbtonhilfsbezeichnung": "F9.21.83",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "225",
    "Bcolor": "168",
    "Y": 76,
    "L": 90.0753867079087,
    "a": 0.46968116652301,
    "b": 29.9896726135951,
    "C": 29.9933503275109,
    "h": 1.55513617681493,
    "CMY_C": 0.02588802,
    "CMY_M": 0.119399,
    "CMY_Y": 0.3413922,
    "CMYK_C": 0,
    "CMYK_M": 0.09599613,
    "CMYK_Y": 0.3238891,
    "CMYK_K": 0.02588802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05456",
    "Farbtonhilfsbezeichnung": "F8.55.77",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "206",
    "Bcolor": "73",
    "Y": 64,
    "L": 84.6808929443359,
    "a": 3.80148363113403,
    "b": 68.3291549682617,
    "C": 68.4348220825195,
    "h": 86.8156356811523,
    "CMY_C": 0.00926232337952,
    "CMY_M": 0.19262492656708,
    "CMY_Y": 0.71207737922668,
    "CMYK_C": 0,
    "CMYK_M": 0.18507684767246,
    "CMYK_Y": 0.70938563346863,
    "CMYK_K": 0.00926232337952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05457",
    "Farbtonhilfsbezeichnung": "F9.06.81",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "221",
    "Bcolor": "205",
    "Y": 72,
    "L": 88.3495483398438,
    "a": 0.32301411032677,
    "b": 8.04531764984131,
    "C": 8.05179977416992,
    "h": 87.7008438110352,
    "CMY_C": 0.10229521989822,
    "CMY_M": 0.1330503821373,
    "CMY_Y": 0.19649875164032,
    "CMYK_C": 0,
    "CMYK_M": 0.03425977379084,
    "CMYK_Y": 0.10493820905685,
    "CMYK_K": 0.10229521989822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05458",
    "Farbtonhilfsbezeichnung": "F9.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "225",
    "Bcolor": "196",
    "Y": 76,
    "L": 89.7203522809707,
    "a": -0.23093050842809,
    "b": 14.9925056538425,
    "C": 14.9942840669444,
    "h": -1.55539448181516,
    "CMY_C": 0.07122064,
    "CMY_M": 0.1183231,
    "CMY_Y": 0.2331392,
    "CMYK_C": 0,
    "CMYK_M": 0.05071441,
    "CMYK_Y": 0.1743347,
    "CMYK_K": 0.07122064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05459",
    "Farbtonhilfsbezeichnung": "F8.29.80",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "213",
    "Bcolor": "138",
    "Y": 69,
    "L": 86.4941951163267,
    "a": 1.37359579847729,
    "b": 40.3601454552941,
    "C": 40.383512806467,
    "h": 1.53677598775981,
    "CMY_C": 0.04098897,
    "CMY_M": 0.1630468,
    "CMY_Y": 0.4575363,
    "CMYK_C": 0,
    "CMYK_M": 0.1272747,
    "CMYK_Y": 0.434351,
    "CMYK_K": 0.04098897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05460",
    "Farbtonhilfsbezeichnung": "F9.70.73",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "196",
    "Bcolor": "0",
    "Y": 58,
    "L": 80.9623824669622,
    "a": 1.88299867499708,
    "b": 85.9352883526822,
    "C": 85.9559158421843,
    "h": 1.5488880113892,
    "CMY_C": 0.05230474,
    "CMY_M": 0.2297387,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.1872268,
    "CMYK_Y": 1,
    "CMYK_K": 0.05230474
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05462",
    "Farbtonhilfsbezeichnung": "F8.18.81",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "217",
    "Bcolor": "168",
    "Y": 71,
    "L": 87.7175187234271,
    "a": 1.90338931652173,
    "b": 26.4428675656768,
    "C": 26.5112831825653,
    "h": 1.49893906114603,
    "CMY_C": 0.05051683,
    "CMY_M": 0.1481968,
    "CMY_Y": 0.3392985,
    "CMYK_C": 0,
    "CMYK_M": 0.102877,
    "CMYK_Y": 0.3041462,
    "CMYK_K": 0.05051683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05463",
    "Farbtonhilfsbezeichnung": "F8.23.76",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "207",
    "Bcolor": "150",
    "Y": 64,
    "L": 84.0398525873949,
    "a": 1.80719284571157,
    "b": 31.1969919772212,
    "C": 31.2492920625155,
    "h": 1.51293256096445,
    "CMY_C": 0.08323731,
    "CMY_M": 0.1892861,
    "CMY_Y": 0.4132523,
    "CMYK_C": 0,
    "CMYK_M": 0.1156775,
    "CMYK_Y": 0.3599787,
    "CMYK_K": 0.08323731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05464",
    "Farbtonhilfsbezeichnung": "F9.48.73",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "195",
    "Bcolor": "82",
    "Y": 56,
    "L": 79.8750378183436,
    "a": 0.71793700229977,
    "b": 59.2135593681356,
    "C": 59.2179115351343,
    "h": 1.55867238367956,
    "CMY_C": 0.09567872,
    "CMY_M": 0.2361903,
    "CMY_Y": 0.6789981,
    "CMYK_C": 0,
    "CMYK_M": 0.1553779,
    "CMYK_Y": 0.6450356,
    "CMYK_K": 0.09567872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05465",
    "Farbtonhilfsbezeichnung": "F9.63.72",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "194",
    "Bcolor": "34",
    "Y": 56,
    "L": 79.5299066873427,
    "a": 0.29975441469487,
    "b": 75.5438052524686,
    "C": 75.544399956132,
    "h": 1.5668283926866,
    "CMY_C": 0.08679199,
    "CMY_M": 0.2405513,
    "CMY_Y": 0.8660734,
    "CMYK_C": 0,
    "CMYK_M": 0.1683727,
    "CMYK_Y": 0.8533449,
    "CMYK_K": 0.08679199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05466",
    "Farbtonhilfsbezeichnung": "F8.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "211",
    "Bcolor": "199",
    "Y": 65,
    "L": 84.4741126544596,
    "a": -0.19652366851474,
    "b": 5.40324855681047,
    "C": 5.40682129526776,
    "h": -1.53444096090447,
    "CMY_C": 0.1572988,
    "CMY_M": 0.1738753,
    "CMY_Y": 0.2191408,
    "CMYK_C": 0,
    "CMYK_M": 0.01967069,
    "CMYK_Y": 0.07338545,
    "CMYK_K": 0.1572988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05467",
    "Farbtonhilfsbezeichnung": "F9.06.75",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "204",
    "Bcolor": "187",
    "Y": 61,
    "L": 82.2167063140438,
    "a": 0.36466347497127,
    "b": 8.72983488808165,
    "C": 8.73744794680608,
    "h": 1.52904850452214,
    "CMY_C": 0.1679333,
    "CMY_M": 0.2007454,
    "CMY_Y": 0.2674933,
    "CMYK_C": 0,
    "CMYK_M": 0.03943452,
    "CMYK_Y": 0.1196539,
    "CMYK_K": 0.1679333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05468",
    "Farbtonhilfsbezeichnung": "F8.38.70",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "187",
    "Bcolor": "99",
    "Y": 52,
    "L": 77.4968713195095,
    "a": 2.78753973993739,
    "b": 48.2127785420257,
    "C": 48.2932955237489,
    "h": 1.51304317662178,
    "CMY_C": 0.1238618,
    "CMY_M": 0.2652277,
    "CMY_Y": 0.610074,
    "CMYK_C": 0,
    "CMYK_M": 0.1613512,
    "CMYK_Y": 0.5549492,
    "CMYK_K": 0.1238618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05469",
    "Farbtonhilfsbezeichnung": "F8.44.65",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "171",
    "Bcolor": "83",
    "Y": 43,
    "L": 71.4933485621269,
    "a": 2.18052023475879,
    "b": 48.9656899613991,
    "C": 49.014216936416,
    "h": 1.5262941339438,
    "CMY_C": 0.1957721,
    "CMY_M": 0.3276075,
    "CMY_Y": 0.6764144,
    "CMYK_C": 0,
    "CMYK_M": 0.1639279,
    "CMYK_Y": 0.5976444,
    "CMYK_K": 0.1957721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05470",
    "Farbtonhilfsbezeichnung": "F9.57.70",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "186",
    "Bcolor": "47",
    "Y": 51,
    "L": 76.478268312995,
    "a": 0.1042963213465,
    "b": 68.9041885122184,
    "C": 68.9042674458555,
    "h": 1.5692826852595,
    "CMY_C": 0.1299371,
    "CMY_M": 0.2721369,
    "CMY_Y": 0.8149258,
    "CMYK_C": 0,
    "CMYK_M": 0.1634363,
    "CMYK_Y": 0.7872864,
    "CMYK_K": 0.1299371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05471",
    "Farbtonhilfsbezeichnung": "F9.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "201",
    "Bcolor": "187",
    "Y": 58,
    "L": 80.9021676655666,
    "a": -0.07065641204245,
    "b": 6.48366765172645,
    "C": 6.48405263293002,
    "h": -1.55989915885848,
    "CMY_C": 0.1922376,
    "CMY_M": 0.2134648,
    "CMY_Y": 0.2653033,
    "CMYK_C": 0,
    "CMYK_M": 0.0262791,
    "CMYK_Y": 0.09045456,
    "CMYK_K": 0.1922376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05472",
    "Farbtonhilfsbezeichnung": "F9.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "196",
    "Bcolor": "178",
    "Y": 55,
    "L": 79.1786644908824,
    "a": -0.1874821815021,
    "b": 9.05766064815376,
    "C": 9.05960076303002,
    "h": -1.55010054000855,
    "CMY_C": 0.2043642,
    "CMY_M": 0.2325446,
    "CMY_Y": 0.3022138,
    "CMYK_C": 0,
    "CMYK_M": 0.03541869,
    "CMYK_Y": 0.1229829,
    "CMYK_K": 0.2043642
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05473",
    "Farbtonhilfsbezeichnung": "F9.30.69",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "186",
    "Bcolor": "120",
    "Y": 50,
    "L": 76.2160603835429,
    "a": 0.0963334363187,
    "b": 36.0130353759794,
    "C": 36.013164219803,
    "h": 1.56812137297483,
    "CMY_C": 0.1744646,
    "CMY_M": 0.2707058,
    "CMY_Y": 0.5294834,
    "CMYK_C": 0,
    "CMYK_M": 0.1165803,
    "CMYK_Y": 0.4300468,
    "CMYK_K": 0.1744646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05474",
    "Farbtonhilfsbezeichnung": "F9.60.63",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "171",
    "Bcolor": "42",
    "Y": 42,
    "L": 71.1248009164219,
    "a": 0.66425913101109,
    "b": 65.2853797349999,
    "C": 65.2887589661212,
    "h": 1.56062197822308,
    "CMY_C": 0.1926211,
    "CMY_M": 0.3297117,
    "CMY_Y": 0.8362486,
    "CMYK_C": 0,
    "CMYK_M": 0.1697971,
    "CMYK_Y": 0.7971815,
    "CMYK_K": 0.1926211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05475",
    "Farbtonhilfsbezeichnung": "F8.68.67",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "178",
    "Bcolor": "0",
    "Y": 47,
    "L": 74.3921550471471,
    "a": 2.84576234666656,
    "b": 79.3517163269268,
    "C": 79.4027282110808,
    "h": 1.53494904569148,
    "CMY_C": 0.1304111,
    "CMY_M": 0.3015801,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.196839,
    "CMYK_Y": 1,
    "CMYK_K": 0.1304111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05476",
    "Farbtonhilfsbezeichnung": "F9.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "190",
    "Bcolor": "178",
    "Y": 51,
    "L": 76.9570300084056,
    "a": 0.11194304630352,
    "b": 5.95260158896993,
    "C": 5.95365408153875,
    "h": 1.55199280853494,
    "CMY_C": 0.2353837,
    "CMY_M": 0.2564151,
    "CMY_Y": 0.3033473,
    "CMYK_C": 0,
    "CMYK_M": 0.02750577,
    "CMYK_Y": 0.0888859,
    "CMYK_K": 0.2353837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05477",
    "Farbtonhilfsbezeichnung": "F9.11.70",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "190",
    "Bcolor": "165",
    "Y": 52,
    "L": 77.2581611531492,
    "a": 0.11798752448699,
    "b": 13.3992045746543,
    "C": 13.3997240378066,
    "h": 1.56199099253277,
    "CMY_C": 0.211211,
    "CMY_M": 0.2550269,
    "CMY_Y": 0.3535996,
    "CMYK_C": 0,
    "CMYK_M": 0.05554829,
    "CMYK_Y": 0.1805154,
    "CMYK_K": 0.211211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05478",
    "Farbtonhilfsbezeichnung": "F8.14.62",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "168",
    "Bcolor": "141",
    "Y": 40,
    "L": 69.3423700411557,
    "a": 0.31150916627048,
    "b": 14.9949843752694,
    "C": 14.99821970686,
    "h": 1.55002509038858,
    "CMY_C": 0.291541,
    "CMY_M": 0.3400613,
    "CMY_Y": 0.4464308,
    "CMYK_C": 0,
    "CMYK_M": 0.068487,
    "CMYK_Y": 0.2186292,
    "CMYK_K": 0.291541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05479",
    "Farbtonhilfsbezeichnung": "F8.20.68",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "183",
    "Bcolor": "139",
    "Y": 48,
    "L": 75.1228934988512,
    "a": 1.2382397204993,
    "b": 24.6522421692048,
    "C": 24.6833199058502,
    "h": 1.52061022301924,
    "CMY_C": 0.2005516,
    "CMY_M": 0.2829578,
    "CMY_Y": 0.4566067,
    "CMYK_C": 0,
    "CMYK_M": 0.1030788,
    "CMYK_Y": 0.3202897,
    "CMYK_K": 0.2005516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05480",
    "Farbtonhilfsbezeichnung": "F9.30.58",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "158",
    "Bcolor": "99",
    "Y": 35,
    "L": 65.6261594267871,
    "a": 0.19253433888305,
    "b": 32.8667387797091,
    "C": 32.8673027108292,
    "h": 1.56493836389052,
    "CMY_C": 0.2966783,
    "CMY_M": 0.382026,
    "CMY_Y": 0.6109939,
    "CMYK_C": 0,
    "CMYK_M": 0.1213495,
    "CMYK_Y": 0.4469016,
    "CMYK_K": 0.2966783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05481",
    "Farbtonhilfsbezeichnung": "F9.40.59",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "159",
    "Bcolor": "81",
    "Y": 36,
    "L": 66.2738784111185,
    "a": 0.43343550182584,
    "b": 43.1703060918111,
    "C": 43.172481911455,
    "h": 1.56075653375422,
    "CMY_C": 0.2729327,
    "CMY_M": 0.3773599,
    "CMY_Y": 0.6821963,
    "CMYK_C": 0,
    "CMYK_M": 0.1436279,
    "CMYK_Y": 0.5628963,
    "CMYK_K": 0.2729327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05482",
    "Farbtonhilfsbezeichnung": "F8.42.61",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "162",
    "Bcolor": "81",
    "Y": 38,
    "L": 67.9092104996742,
    "a": 2.15125121376442,
    "b": 45.4488905651679,
    "C": 45.4997751136127,
    "h": 1.52349821343207,
    "CMY_C": 0.2410273,
    "CMY_M": 0.3646061,
    "CMY_Y": 0.6835927,
    "CMYK_C": 0,
    "CMYK_M": 0.1628238,
    "CMYK_Y": 0.5831111,
    "CMYK_K": 0.2410273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05483",
    "Farbtonhilfsbezeichnung": "F9.67.63",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "166",
    "Bcolor": "0",
    "Y": 40,
    "L": 69.6806396553293,
    "a": 1.49018997175887,
    "b": 72.4527116318597,
    "C": 72.4680349461841,
    "h": 1.55023146650922,
    "CMY_C": 0.1992072,
    "CMY_M": 0.3473175,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.1849546,
    "CMYK_Y": 1,
    "CMYK_K": 0.1992072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05484",
    "Farbtonhilfsbezeichnung": "F8.05.55",
    "Farbtonklasse": "01",
    "Rcolor": "158",
    "Gcolor": "153",
    "Bcolor": "143",
    "Y": 31,
    "L": 63.3870811462402,
    "a": -0.03245080262423,
    "b": 5.37071228027344,
    "C": 5.37081050872803,
    "h": 90.3461837768555,
    "CMY_C": 0.38218820095062,
    "CMY_M": 0.39913994073868,
    "CMY_Y": 0.43989771604538,
    "CMYK_C": 0,
    "CMYK_M": 0.02743835560977,
    "CMYK_Y": 0.09340953826904,
    "CMYK_K": 0.38218820095062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05485",
    "Farbtonhilfsbezeichnung": "F9.10.60",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "164",
    "Bcolor": "145",
    "Y": 37,
    "L": 67.5635299682617,
    "a": 0.05382980778813,
    "b": 10.3719635009766,
    "C": 10.3721027374268,
    "h": 89.7026443481445,
    "CMY_C": 0.32398176193237,
    "CMY_M": 0.35706931352615,
    "CMY_Y": 0.43210291862488,
    "CMYK_C": 0,
    "CMYK_M": 0.04894476011395,
    "CMYK_Y": 0.15993823111057,
    "CMYK_K": 0.32398176193237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05486",
    "Farbtonhilfsbezeichnung": "F8.19.55",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "147",
    "Bcolor": "112",
    "Y": 30,
    "L": 61.4688556700972,
    "a": 0.89838637316147,
    "b": 19.879879923156,
    "C": 19.9001689398503,
    "h": 1.52563631764949,
    "CMY_C": 0.3606586,
    "CMY_M": 0.4241925,
    "CMY_Y": 0.5590267,
    "CMYK_C": 0,
    "CMYK_M": 0.09937399,
    "CMYK_Y": 0.3102694,
    "CMYK_K": 0.3606586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05487",
    "Farbtonhilfsbezeichnung": "F9.20.61",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "166",
    "Bcolor": "127",
    "Y": 38,
    "L": 68.6351013183594,
    "a": 0.36715084314346,
    "b": 22.0473690032959,
    "C": 22.0504264831543,
    "h": 89.0459518432617,
    "CMY_C": 0.28287148475647,
    "CMY_M": 0.34906351566315,
    "CMY_Y": 0.50347626209259,
    "CMYK_C": 0,
    "CMYK_M": 0.09230148792267,
    "CMYK_Y": 0.3076223731041,
    "CMYK_K": 0.28287148475647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05488",
    "Farbtonhilfsbezeichnung": "F8.30.49",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "135",
    "Bcolor": "88",
    "Y": 25,
    "L": 57.0868449072085,
    "a": 0.9919313200396,
    "b": 27.6394772682351,
    "C": 27.6572708596666,
    "h": 1.53492351407504,
    "CMY_C": 0.3923064,
    "CMY_M": 0.4703678,
    "CMY_Y": 0.6554373,
    "CMYK_C": 0,
    "CMYK_M": 0.1284552,
    "CMYK_Y": 0.4329993,
    "CMYK_K": 0.3923064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05489",
    "Farbtonhilfsbezeichnung": "F9.39.56",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "150",
    "Bcolor": "80",
    "Y": 32,
    "L": 63.0214714944282,
    "a": 0.20743686295843,
    "b": 39.7809984048197,
    "C": 39.7815392378976,
    "h": 1.56558190304515,
    "CMY_C": 0.3148951,
    "CMY_M": 0.4099835,
    "CMY_Y": 0.6876718,
    "CMYK_C": 0,
    "CMYK_M": 0.1387939,
    "CMYK_Y": 0.5441163,
    "CMYK_K": 0.3148951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05490",
    "Farbtonhilfsbezeichnung": "F9.55.61",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "164",
    "Bcolor": "55",
    "Y": 39,
    "L": 68.4119759320939,
    "a": 1.12972420947227,
    "b": 57.5098208244318,
    "C": 57.5209159180182,
    "h": 1.55115483058803,
    "CMY_C": 0.2282703,
    "CMY_M": 0.3584035,
    "CMY_Y": 0.7830334,
    "CMYK_C": 0,
    "CMYK_M": 0.1686254,
    "CMYK_Y": 0.7188567,
    "CMYK_K": 0.2282703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05491",
    "Farbtonhilfsbezeichnung": "F9.60.60",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "160",
    "Bcolor": "39",
    "Y": 37,
    "L": 67.0510324527202,
    "a": 0.82731681144715,
    "b": 62.1414951125598,
    "C": 62.1470020832123,
    "h": 1.55748367741013,
    "CMY_C": 0.2416365,
    "CMY_M": 0.3722892,
    "CMY_Y": 0.8477247,
    "CMYK_C": 0,
    "CMYK_M": 0.1722825,
    "CMYK_Y": 0.7992054,
    "CMYK_K": 0.2416365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05492",
    "Farbtonhilfsbezeichnung": "F9.13.38",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "108",
    "Bcolor": "91",
    "Y": 15,
    "L": 45.6014362809336,
    "a": -0.28820429958031,
    "b": 9.5333937357996,
    "C": 9.53774909714444,
    "h": -1.54057450258509,
    "CMY_C": 0.5532876,
    "CMY_M": 0.5780011,
    "CMY_Y": 0.6417993,
    "CMYK_C": 0,
    "CMYK_M": 0.05532299,
    "CMYK_Y": 0.1981401,
    "CMYK_K": 0.5532876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05493",
    "Farbtonhilfsbezeichnung": "F8.16.49",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "132",
    "Bcolor": "109",
    "Y": 24,
    "L": 55.7234269395239,
    "a": 0.74811411593733,
    "b": 13.5057955060637,
    "C": 13.5264994356291,
    "h": 1.51546079477981,
    "CMY_C": 0.4353941,
    "CMY_M": 0.4809553,
    "CMY_Y": 0.5713291,
    "CMYK_C": 0,
    "CMYK_M": 0.08069564,
    "CMYK_Y": 0.2407609,
    "CMYK_K": 0.4353941
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05494",
    "Farbtonhilfsbezeichnung": "F9.48.52",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "141",
    "Bcolor": "62",
    "Y": 27,
    "L": 59.2675114947527,
    "a": -0.02449771472529,
    "b": 44.1899281904172,
    "C": 44.1899349808557,
    "h": -1.57024195358772,
    "CMY_C": 0.352151,
    "CMY_M": 0.4483548,
    "CMY_Y": 0.7584414,
    "CMYK_C": 0,
    "CMYK_M": 0.1484973,
    "CMYK_Y": 0.6271375,
    "CMYK_K": 0.352151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05495",
    "Farbtonhilfsbezeichnung": "F8.59.54",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "145",
    "Bcolor": "35",
    "Y": 30,
    "L": 61.6550168302688,
    "a": 2.43658146924663,
    "b": 58.0463710350017,
    "C": 58.097488066089,
    "h": 1.52884449014766,
    "CMY_C": 0.2974138,
    "CMY_M": 0.4310615,
    "CMY_Y": 0.8626015,
    "CMYK_C": 0,
    "CMYK_M": 0.1902225,
    "CMYK_Y": 0.8044389,
    "CMYK_K": 0.2974138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05496",
    "Farbtonhilfsbezeichnung": "F9.04.36",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "101",
    "Bcolor": "96",
    "Y": 13,
    "L": 42.7663006383888,
    "a": -0.16803673969428,
    "b": 2.71944398338444,
    "C": 2.72463060333927,
    "h": -1.50908394423337,
    "CMY_C": 0.5973921,
    "CMY_M": 0.6040961,
    "CMY_Y": 0.6246551,
    "CMYK_C": 0,
    "CMYK_M": 0.01665141,
    "CMYK_Y": 0.06771594,
    "CMYK_K": 0.5973921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05497",
    "Farbtonhilfsbezeichnung": "F9.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "72",
    "Bcolor": "64",
    "Y": 7,
    "L": 30.6660925175313,
    "a": 0.25440776665469,
    "b": 4.7647503136537,
    "C": 4.77153736894067,
    "h": 1.5174532553247,
    "CMY_C": 0.7031083,
    "CMY_M": 0.7183047,
    "CMY_Y": 0.7480586,
    "CMYK_C": 0,
    "CMYK_M": 0.05118504,
    "CMYK_Y": 0.151403,
    "CMYK_K": 0.7031083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05498",
    "Farbtonhilfsbezeichnung": "F9.16.23",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "78",
    "Bcolor": "66",
    "Y": 8,
    "L": 33.4402753878829,
    "a": -0.36312396084223,
    "b": 7.84520484530906,
    "C": 7.85360414560083,
    "h": -1.52454323570317,
    "CMY_C": 0.6742531,
    "CMY_M": 0.6924285,
    "CMY_Y": 0.7423223,
    "CMYK_C": 0,
    "CMYK_M": 0.05579612,
    "CMYK_Y": 0.2089634,
    "CMYK_K": 0.6742531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05499",
    "Farbtonhilfsbezeichnung": "F9.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "91",
    "Bcolor": "70",
    "Y": 11,
    "L": 38.930804956963,
    "a": 0.03875415101822,
    "b": 13.1470770606836,
    "C": 13.1471341791195,
    "h": 1.56784859639118,
    "CMY_C": 0.6086366,
    "CMY_M": 0.6431608,
    "CMY_Y": 0.7263339,
    "CMYK_C": 0,
    "CMYK_M": 0.08821535,
    "CMYK_Y": 0.3007366,
    "CMYK_K": 0.6086366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05500",
    "Farbtonhilfsbezeichnung": "F8.29.35",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "99",
    "Bcolor": "65",
    "Y": 13,
    "L": 42.432948580674,
    "a": 0.53422072682662,
    "b": 20.8446235638179,
    "C": 20.8514681330175,
    "h": 1.54517322992784,
    "CMY_C": 0.5575069,
    "CMY_M": 0.6122808,
    "CMY_Y": 0.7446605,
    "CMYK_C": 0,
    "CMYK_M": 0.1237847,
    "CMYK_Y": 0.4229526,
    "CMYK_K": 0.5575069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05501",
    "Farbtonhilfsbezeichnung": "F8.35.41",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 17,
    "L": 48.5722183202613,
    "a": 1.28612252085841,
    "b": 28.4755737888401,
    "C": 28.504603378092,
    "h": 1.52566118546382,
    "CMY_C": 0.4788435,
    "CMY_M": 0.5557203,
    "CMY_Y": 0.7406697,
    "CMYK_C": 0,
    "CMYK_M": 0.1475119,
    "CMYK_Y": 0.5023946,
    "CMYK_K": 0.4788435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05502",
    "Farbtonhilfsbezeichnung": "F9.44.40",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "113",
    "Bcolor": "56",
    "Y": 17,
    "L": 48.0758969838456,
    "a": -0.36058795994958,
    "b": 33.1381674483528,
    "C": 33.1401292319739,
    "h": -1.55991540738779,
    "CMY_C": 0.4875056,
    "CMY_M": 0.5576754,
    "CMY_Y": 0.7789024,
    "CMYK_C": 0,
    "CMYK_M": 0.1369182,
    "CMYK_Y": 0.5685853,
    "CMYK_K": 0.4875056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05503",
    "Farbtonhilfsbezeichnung": "F8.58.50",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "135",
    "Bcolor": "41",
    "Y": 25,
    "L": 57.4004486228322,
    "a": 1.470264888352,
    "b": 51.449269700465,
    "C": 51.4702732803421,
    "h": 1.5422271193938,
    "CMY_C": 0.3566421,
    "CMY_M": 0.4713064,
    "CMY_Y": 0.8401592,
    "CMYK_C": 0,
    "CMYK_M": 0.1782278,
    "CMYK_Y": 0.7515523,
    "CMYK_K": 0.3566421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05504",
    "Farbtonhilfsbezeichnung": "F7.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "57",
    "Bcolor": "49",
    "Y": 4,
    "L": 24.0820808859483,
    "a": 0.17992688603624,
    "b": 5.1455625122462,
    "C": 5.14870733793951,
    "h": 1.53584317909483,
    "CMY_C": 0.7619255,
    "CMY_M": 0.7767332,
    "CMY_Y": 0.8073259,
    "CMYK_C": 0,
    "CMYK_M": 0.06219753,
    "CMYK_Y": 0.1906982,
    "CMYK_K": 0.7619255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05505",
    "Farbtonhilfsbezeichnung": "F9.17.15",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "61",
    "Bcolor": "51",
    "Y": 5,
    "L": 26.0509771988301,
    "a": -0.23434124336871,
    "b": 6.55673529324596,
    "C": 6.5609216977526,
    "h": -1.53507099583534,
    "CMY_C": 0.7438117,
    "CMY_M": 0.7589676,
    "CMY_Y": 0.7989088,
    "CMYK_C": 0,
    "CMYK_M": 0.05915939,
    "CMYK_Y": 0.215065,
    "CMYK_K": 0.7438117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05506",
    "Farbtonhilfsbezeichnung": "F9.21.20",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "68",
    "Bcolor": "52",
    "Y": 6,
    "L": 28.9174578662848,
    "a": 0.22367721338154,
    "b": 10.1131173202825,
    "C": 10.115590612,
    "h": 1.54868239853727,
    "CMY_C": 0.708003,
    "CMY_M": 0.7350185,
    "CMY_Y": 0.7955505,
    "CMYK_C": 0,
    "CMYK_M": 0.09251969,
    "CMYK_Y": 0.2998234,
    "CMYK_K": 0.708003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05507",
    "Farbtonhilfsbezeichnung": "F9.29.25",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "77",
    "Bcolor": "53",
    "Y": 8,
    "L": 33.1968838482143,
    "a": 0.26518786247864,
    "b": 15.6444632028493,
    "C": 15.6467106290016,
    "h": 1.55384704165052,
    "CMY_C": 0.6578785,
    "CMY_M": 0.6972865,
    "CMY_Y": 0.792725,
    "CMYK_C": 0,
    "CMYK_M": 0.1151873,
    "CMYK_Y": 0.394148,
    "CMYK_K": 0.6578785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05508",
    "Farbtonhilfsbezeichnung": "F8.33.30",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "89",
    "Bcolor": "56",
    "Y": 10,
    "L": 38.2508068893733,
    "a": 0.98923531309957,
    "b": 20.8196581405907,
    "C": 20.8431463938569,
    "h": 1.5233175511099,
    "CMY_C": 0.5965028,
    "CMY_M": 0.6527643,
    "CMY_Y": 0.7816425,
    "CMYK_C": 0,
    "CMYK_M": 0.1394347,
    "CMYK_Y": 0.4588376,
    "CMYK_K": 0.5965028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05509",
    "Farbtonhilfsbezeichnung": "F9.45.35",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "102",
    "Bcolor": "51",
    "Y": 14,
    "L": 43.6541500040163,
    "a": 0.01640919731454,
    "b": 30.4449943403448,
    "C": 30.4449987624467,
    "h": 1.5702573483493,
    "CMY_C": 0.5345007,
    "CMY_M": 0.6008803,
    "CMY_Y": 0.7995062,
    "CMYK_C": 0,
    "CMYK_M": 0.1425988,
    "CMYK_Y": 0.5692931,
    "CMYK_K": 0.5345007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05510",
    "Farbtonhilfsbezeichnung": "F8.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "120",
    "Bcolor": "47",
    "Y": 20,
    "L": 51.7750488025131,
    "a": 2.31581734558017,
    "b": 42.6981650472049,
    "C": 42.7609203406152,
    "h": 1.51661248605903,
    "CMY_C": 0.4218674,
    "CMY_M": 0.5283161,
    "CMY_Y": 0.8175033,
    "CMYK_C": 0,
    "CMYK_M": 0.1841252,
    "CMYK_Y": 0.6843343,
    "CMYK_K": 0.4218674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05511",
    "Farbtonhilfsbezeichnung": "GN.01.89",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "244",
    "Bcolor": "236",
    "Y": 90,
    "L": 96.0431442260742,
    "a": -0.26014319062233,
    "b": 2.80338549613953,
    "C": 2.8154296875,
    "h": 95.301643371582,
    "CMY_C": 0.03716081380844,
    "CMY_M": 0.04425144195557,
    "CMY_Y": 0.07301020622253,
    "CMYK_C": 0,
    "CMYK_M": 0.00736429123208,
    "CMYK_Y": 0.03723300248384,
    "CMYK_K": 0.03716081380844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05512",
    "Farbtonhilfsbezeichnung": "G0.13.86",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "235",
    "Bcolor": "197",
    "Y": 84,
    "L": 93.3582239582753,
    "a": 0.07639605732351,
    "b": 19.6406244012686,
    "C": 19.6407729794243,
    "h": 1.56690665045456,
    "CMY_C": 0.01541312,
    "CMY_M": 0.07960869,
    "CMY_Y": 0.2285586,
    "CMYK_C": 0,
    "CMYK_M": 0.06520052,
    "CMYK_Y": 0.2164822,
    "CMYK_K": 0.01541312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05513",
    "Farbtonhilfsbezeichnung": "F8.33.83",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "225",
    "Bcolor": "140",
    "Y": 77,
    "L": 90.3883523429177,
    "a": 0.0614562423376,
    "b": 44.6879661200843,
    "C": 44.6880083783057,
    "h": 1.56942109742265,
    "CMY_C": 0,
    "CMY_M": 0.1176637,
    "CMY_Y": 0.4512171,
    "CMYK_C": 0,
    "CMYK_M": 0.1176637,
    "CMYK_Y": 0.4512171,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05514",
    "Farbtonhilfsbezeichnung": "G0.50.81",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "218",
    "Bcolor": "84",
    "Y": 72,
    "L": 87.9398292738916,
    "a": -0.56599038776389,
    "b": 67.5657611509268,
    "C": 67.5681317265997,
    "h": -1.56241964103335,
    "CMY_C": 0,
    "CMY_M": 0.1463681,
    "CMY_Y": 0.6711168,
    "CMYK_C": 0,
    "CMYK_M": 0.1463681,
    "CMYK_Y": 0.6711168,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05515",
    "Farbtonhilfsbezeichnung": "GN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "239",
    "Bcolor": "228",
    "Y": 86,
    "L": 94.3434358301375,
    "a": -0.7774289690709,
    "b": 4.62524817683698,
    "C": 4.69012968896218,
    "h": -1.40426920198738,
    "CMY_C": 0.05437954,
    "CMY_M": 0.06269006,
    "CMY_Y": 0.105589,
    "CMYK_C": 0,
    "CMYK_M": 0.008788427,
    "CMYK_Y": 0.0541544,
    "CMYK_K": 0.05437954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05516",
    "Farbtonhilfsbezeichnung": "G0.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "206",
    "Y": 80,
    "L": 91.824276368249,
    "a": -0.29154989909041,
    "b": 12.6617337188653,
    "C": 12.6650898974745,
    "h": -1.5477743303293,
    "CMY_C": 0.05444927,
    "CMY_M": 0.09417945,
    "CMY_Y": 0.1930599,
    "CMYK_C": 0,
    "CMYK_M": 0.04201803,
    "CMYK_Y": 0.1465925,
    "CMYK_K": 0.05444927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05517",
    "Farbtonhilfsbezeichnung": "G0.19.84",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "230",
    "Bcolor": "176",
    "Y": 80,
    "L": 91.8719841474788,
    "a": -0.30208746619858,
    "b": 28.2052637818111,
    "C": 28.2068814624868,
    "h": -1.56008641397822,
    "CMY_C": 0.01461138,
    "CMY_M": 0.09720026,
    "CMY_Y": 0.3090444,
    "CMYK_C": 0,
    "CMYK_M": 0.08381351,
    "CMYK_Y": 0.2987988,
    "CMYK_K": 0.01461138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05518",
    "Farbtonhilfsbezeichnung": "G0.46.82",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "221",
    "Bcolor": "92",
    "Y": 75,
    "L": 89.3157004004471,
    "a": -0.26998422306234,
    "b": 65.6825142640608,
    "C": 65.6830691390807,
    "h": -1.56668590706485,
    "CMY_C": 0,
    "CMY_M": 0.1317152,
    "CMY_Y": 0.638462,
    "CMYK_C": 0,
    "CMYK_M": 0.1317152,
    "CMYK_Y": 0.638462,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05519",
    "Farbtonhilfsbezeichnung": "G1.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 85,
    "L": 94.3600463867188,
    "a": -0.72459554672241,
    "b": 11.2071170806885,
    "C": 11.2305173873901,
    "h": 93.6993103027344,
    "CMY_C": 0.03328466415405,
    "CMY_M": 0.06434959173203,
    "CMY_Y": 0.15459430217743,
    "CMYK_C": 0,
    "CMYK_M": 0.03213451430202,
    "CMYK_Y": 0.12548640370369,
    "CMYK_K": 0.03328466415405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05520",
    "Farbtonhilfsbezeichnung": "G1.33.83",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "226",
    "Bcolor": "137",
    "Y": 77,
    "L": 90.206102532847,
    "a": -1.75104956207478,
    "b": 45.8736110249897,
    "C": 45.9070186686186,
    "h": -1.53264367613554,
    "CMY_C": 0.009538637,
    "CMY_M": 0.1155495,
    "CMY_Y": 0.4629254,
    "CMYK_C": 0,
    "CMYK_M": 0.1070318,
    "CMYK_Y": 0.4577531,
    "CMYK_K": 0.009538637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05521",
    "Farbtonhilfsbezeichnung": "G0.39.79",
    "Farbtonklasse": "03",
    "Rcolor": "247",
    "Gcolor": "214",
    "Bcolor": "112",
    "Y": 69,
    "L": 86.6140954534158,
    "a": -0.26047280314373,
    "b": 53.3811701815317,
    "C": 53.3818056647659,
    "h": -1.56591687707408,
    "CMY_C": 0.03011202,
    "CMY_M": 0.1598561,
    "CMY_Y": 0.5600718,
    "CMYK_C": 0,
    "CMYK_M": 0.1337722,
    "CMYK_Y": 0.5464134,
    "CMYK_K": 0.03011202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05522",
    "Farbtonhilfsbezeichnung": "G0.60.77",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "207",
    "Bcolor": "45",
    "Y": 64,
    "L": 84.1716590899764,
    "a": -0.97110962971463,
    "b": 77.2482757855517,
    "C": 77.2543795894677,
    "h": -1.5582257099418,
    "CMY_C": 0.03735345,
    "CMY_M": 0.1875581,
    "CMY_Y": 0.825365,
    "CMYK_C": 0,
    "CMYK_M": 0.156033,
    "CMYK_Y": 0.8185887,
    "CMYK_K": 0.03735345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05523",
    "Farbtonhilfsbezeichnung": "G0.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "217",
    "Y": 82,
    "L": 92.5678523292811,
    "a": 0.07377561920102,
    "b": 7.62067417034549,
    "C": 7.62103127224652,
    "h": 1.56111564593965,
    "CMY_C": 0.05823006,
    "CMY_M": 0.08543772,
    "CMY_Y": 0.1473602,
    "CMYK_C": 0,
    "CMYK_M": 0.02888991,
    "CMYK_Y": 0.09464104,
    "CMYK_K": 0.05823006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05524",
    "Farbtonhilfsbezeichnung": "G0.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "230",
    "Bcolor": "212",
    "Y": 80,
    "L": 91.5533010251254,
    "a": -0.04215057827056,
    "b": 8.72376455643085,
    "C": 8.72386638522666,
    "h": -1.56596466839826,
    "CMY_C": 0.06716517,
    "CMY_M": 0.09678571,
    "CMY_Y": 0.1666879,
    "CMYK_C": 0,
    "CMYK_M": 0.03175325,
    "CMYK_Y": 0.1066885,
    "CMYK_K": 0.06716517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05525",
    "Farbtonhilfsbezeichnung": "G0.10.84",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "229",
    "Bcolor": "198",
    "Y": 79,
    "L": 91.3486023447611,
    "a": 0.03426599312661,
    "b": 15.9786748424206,
    "C": 15.9787115837946,
    "h": 1.56865184729725,
    "CMY_C": 0.04820016,
    "CMY_M": 0.101081,
    "CMY_Y": 0.2228701,
    "CMYK_C": 0,
    "CMYK_M": 0.05555873,
    "CMYK_Y": 0.1835154,
    "CMYK_K": 0.04820016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05526",
    "Farbtonhilfsbezeichnung": "G0.16.79",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "215",
    "Bcolor": "173",
    "Y": 69,
    "L": 86.3613506000292,
    "a": -0.22870217384829,
    "b": 22.0977839787341,
    "C": 22.0989674296135,
    "h": -1.56044714386703,
    "CMY_C": 0.09092139,
    "CMY_M": 0.1571084,
    "CMY_Y": 0.3216493,
    "CMYK_C": 0,
    "CMYK_M": 0.07280664,
    "CMYK_Y": 0.2538041,
    "CMYK_K": 0.09092139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05527",
    "Farbtonhilfsbezeichnung": "G0.30.79",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "214",
    "Bcolor": "136",
    "Y": 69,
    "L": 86.362140574712,
    "a": 0.55855413604682,
    "b": 41.3524740540703,
    "C": 41.3562461197272,
    "h": 1.55728999653494,
    "CMY_C": 0.04629605,
    "CMY_M": 0.1627102,
    "CMY_Y": 0.4667584,
    "CMYK_C": 0,
    "CMYK_M": 0.1220653,
    "CMYK_Y": 0.440873,
    "CMYK_K": 0.04629605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05528",
    "Farbtonhilfsbezeichnung": "G1.58.79",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "214",
    "Bcolor": "62",
    "Y": 68,
    "L": 86.1440346145228,
    "a": -2.49452330551275,
    "b": 73.844768875897,
    "C": 73.886890155537,
    "h": -1.53702853074147,
    "CMY_C": 0.02630778,
    "CMY_M": 0.162145,
    "CMY_Y": 0.7578341,
    "CMYK_C": 0,
    "CMYK_M": 0.1395074,
    "CMYK_Y": 0.7512912,
    "CMYK_K": 0.02630778
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05529",
    "Farbtonhilfsbezeichnung": "G0.68.75",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "204",
    "Bcolor": "23",
    "Y": 62,
    "L": 82.8796691894531,
    "a": -1.15854942798615,
    "b": 80.7231521606445,
    "C": 80.7314682006836,
    "h": 90.8222579956055,
    "CMY_C": 0.05139702558517,
    "CMY_M": 0.20137757062912,
    "CMY_Y": 0.9094500541687,
    "CMYK_C": 0,
    "CMYK_M": 0.15810675919056,
    "CMYK_Y": 0.90454387664795,
    "CMYK_K": 0.05139702558517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05530",
    "Farbtonhilfsbezeichnung": "G0.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "223",
    "Bcolor": "201",
    "Y": 74,
    "L": 88.803315147496,
    "a": -0.68540818948825,
    "b": 10.9205277873838,
    "C": 10.9420158810541,
    "h": -1.50811526132343,
    "CMY_C": 0.09636278,
    "CMY_M": 0.1264119,
    "CMY_Y": 0.2129553,
    "CMYK_C": 0,
    "CMYK_M": 0.03325348,
    "CMYK_Y": 0.1290258,
    "CMYK_K": 0.09636278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05531",
    "Farbtonhilfsbezeichnung": "G1.11.81",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "223",
    "Bcolor": "190",
    "Y": 74,
    "L": 88.9847303511554,
    "a": -0.62209800866536,
    "b": 16.9710564914008,
    "C": 16.9824546036991,
    "h": -1.53415632166136,
    "CMY_C": 0.07709146,
    "CMY_M": 0.1260314,
    "CMY_Y": 0.2557906,
    "CMYK_C": 0,
    "CMYK_M": 0.05302795,
    "CMYK_Y": 0.193626,
    "CMYK_K": 0.07709146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05532",
    "Farbtonhilfsbezeichnung": "G1.12.79",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "218",
    "Bcolor": "185",
    "Y": 71,
    "L": 87.4180912180626,
    "a": -0.40813951784513,
    "b": 17.4133856878278,
    "C": 17.4181680718459,
    "h": -1.54736235408333,
    "CMY_C": 0.09198375,
    "CMY_M": 0.1439732,
    "CMY_Y": 0.2757801,
    "CMYK_C": 0,
    "CMYK_M": 0.05725608,
    "CMYK_Y": 0.2024153,
    "CMYK_K": 0.09198375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05533",
    "Farbtonhilfsbezeichnung": "G1.53.78",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "213",
    "Bcolor": "79",
    "Y": 68,
    "L": 86.0055009476905,
    "a": -2.56242796901152,
    "b": 67.1764112724367,
    "C": 67.2252651057616,
    "h": -1.53267005289166,
    "CMY_C": 0.03523142,
    "CMY_M": 0.1628123,
    "CMY_Y": 0.6893256,
    "CMYK_C": 0,
    "CMYK_M": 0.1322399,
    "CMYK_Y": 0.6779804,
    "CMYK_K": 0.03523142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05534",
    "Farbtonhilfsbezeichnung": "G1.61.75",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "201",
    "Bcolor": "39",
    "Y": 59,
    "L": 81.4093280154774,
    "a": -3.40561733289974,
    "b": 75.8574241979835,
    "C": 75.9338332719412,
    "h": -1.52593147595461,
    "CMY_C": 0.08722616,
    "CMY_M": 0.2116957,
    "CMY_Y": 0.8464116,
    "CMYK_C": 0,
    "CMYK_M": 0.136364,
    "CMYK_Y": 0.8317345,
    "CMYK_K": 0.08722616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05535",
    "Farbtonhilfsbezeichnung": "G1.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "221",
    "Bcolor": "201",
    "Y": 70,
    "L": 88.1571655273438,
    "a": -0.63461136817932,
    "b": 9.9076509475708,
    "C": 9.92795467376709,
    "h": 93.6649398803711,
    "CMY_C": 0.10614621639252,
    "CMY_M": 0.13339948654175,
    "CMY_Y": 0.21245759725571,
    "CMYK_C": 0,
    "CMYK_M": 0.03048962913454,
    "CMYK_Y": 0.11893598735332,
    "CMYK_K": 0.10614621639252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05536",
    "Farbtonhilfsbezeichnung": "F9.07.76",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "207",
    "Bcolor": "189",
    "Y": 63,
    "L": 83.3961489815885,
    "a": 0.16804348965254,
    "b": 9.52856803832383,
    "C": 9.53004971001626,
    "h": 1.55316239999636,
    "CMY_C": 0.1540831,
    "CMY_M": 0.1876086,
    "CMY_Y": 0.2607408,
    "CMYK_C": 0,
    "CMYK_M": 0.03963214,
    "CMYK_Y": 0.1260853,
    "CMYK_K": 0.1540831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05537",
    "Farbtonhilfsbezeichnung": "G0.12.75",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "205",
    "Bcolor": "176",
    "Y": 61,
    "L": 82.5831649986859,
    "a": -0.32067560755155,
    "b": 15.1853523055637,
    "C": 15.1887378504393,
    "h": -1.54968203547872,
    "CMY_C": 0.1511006,
    "CMY_M": 0.1967281,
    "CMY_Y": 0.3107081,
    "CMYK_C": 0,
    "CMYK_M": 0.05374899,
    "CMYK_Y": 0.188017,
    "CMYK_K": 0.1511006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05538",
    "Farbtonhilfsbezeichnung": "G0.24.75",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "204",
    "Bcolor": "146",
    "Y": 62,
    "L": 82.6926599195073,
    "a": 0.23534497719179,
    "b": 31.3526161542312,
    "C": 31.3534994374288,
    "h": 1.56329007736607,
    "CMY_C": 0.1089821,
    "CMY_M": 0.2002709,
    "CMY_Y": 0.4286596,
    "CMYK_C": 0,
    "CMYK_M": 0.1024545,
    "CMYK_Y": 0.3587779,
    "CMYK_K": 0.1089821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05540",
    "Farbtonhilfsbezeichnung": "G1.43.74",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "199",
    "Bcolor": "95",
    "Y": 58,
    "L": 80.6870682028425,
    "a": -2.55486601793337,
    "b": 54.1920253776265,
    "C": 54.2522161289187,
    "h": -1.52368652259277,
    "CMY_C": 0.1133622,
    "CMY_M": 0.2191608,
    "CMY_Y": 0.6284298,
    "CMYK_C": 0,
    "CMYK_M": 0.1193255,
    "CMYK_Y": 0.5809222,
    "CMYK_K": 0.1133622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05541",
    "Farbtonhilfsbezeichnung": "G0.61.74",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "198",
    "Bcolor": "39",
    "Y": 58,
    "L": 80.9206483109448,
    "a": -0.40899705130048,
    "b": 75.6348190402737,
    "C": 75.6359248627458,
    "h": -1.56538885613491,
    "CMY_C": 0.07440457,
    "CMY_M": 0.2239303,
    "CMY_Y": 0.8473333,
    "CMYK_C": 0,
    "CMYK_M": 0.1615455,
    "CMYK_Y": 0.835061,
    "CMYK_K": 0.07440457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05542",
    "Farbtonhilfsbezeichnung": "GN.01.72",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "199",
    "Bcolor": "195",
    "Y": 57,
    "L": 80.169847415254,
    "a": -0.23342712711305,
    "b": 1.42940989755589,
    "C": 1.44834418523464,
    "h": -1.40892204249991,
    "CMY_C": 0.2173729,
    "CMY_M": 0.2196906,
    "CMY_Y": 0.2366724,
    "CMYK_C": 0,
    "CMYK_M": 0.002961376,
    "CMYK_Y": 0.02465984,
    "CMYK_K": 0.2173729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05543",
    "Farbtonhilfsbezeichnung": "G1.12.70",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "191",
    "Bcolor": "163",
    "Y": 53,
    "L": 77.6056751706056,
    "a": -0.71881357364611,
    "b": 14.8207731583364,
    "C": 14.8381942959554,
    "h": -1.52233389228856,
    "CMY_C": 0.2097126,
    "CMY_M": 0.2496901,
    "CMY_Y": 0.3603478,
    "CMYK_C": 0,
    "CMYK_M": 0.05058598,
    "CMYK_Y": 0.1906082,
    "CMYK_K": 0.2097126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05544",
    "Farbtonhilfsbezeichnung": "G0.16.75",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "203",
    "Bcolor": "163",
    "Y": 60,
    "L": 82.0085559447371,
    "a": -0.38534301809872,
    "b": 21.2055417693252,
    "C": 21.2090426698659,
    "h": -1.55262651932676,
    "CMY_C": 0.1429568,
    "CMY_M": 0.2042008,
    "CMY_Y": 0.3607985,
    "CMYK_C": 0,
    "CMYK_M": 0.07145971,
    "CMYK_Y": 0.2541783,
    "CMYK_K": 0.1429568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05545",
    "Farbtonhilfsbezeichnung": "G1.28.67",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "181",
    "Bcolor": "118",
    "Y": 46,
    "L": 73.7898084251522,
    "a": -1.87003079384696,
    "b": 33.4985123693107,
    "C": 33.5506683409854,
    "h": -1.51502991426058,
    "CMY_C": 0.2190481,
    "CMY_M": 0.2916648,
    "CMY_Y": 0.5355056,
    "CMYK_C": 0,
    "CMYK_M": 0.09298483,
    "CMYK_Y": 0.4052202,
    "CMYK_K": 0.2190481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05546",
    "Farbtonhilfsbezeichnung": "G0.40.69",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "184",
    "Bcolor": "95",
    "Y": 49,
    "L": 75.4709727901351,
    "a": -0.59863999808418,
    "b": 47.8669940264443,
    "C": 47.8707372721056,
    "h": -1.55829065764898,
    "CMY_C": 0.1692542,
    "CMY_M": 0.2788582,
    "CMY_Y": 0.6286918,
    "CMYK_C": 0,
    "CMYK_M": 0.1319344,
    "CMYK_Y": 0.5530424,
    "CMYK_K": 0.1692542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05547",
    "Farbtonhilfsbezeichnung": "G0.52.71",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "193",
    "Bcolor": "71",
    "Y": 54,
    "L": 78.7200300504216,
    "a": -1.15595079898223,
    "b": 62.5533133458252,
    "C": 62.5639931013891,
    "h": -1.55231898031694,
    "CMY_C": 0.117483,
    "CMY_M": 0.2445882,
    "CMY_Y": 0.7227805,
    "CMYK_C": 0,
    "CMYK_M": 0.1440258,
    "CMYK_Y": 0.6858763,
    "CMYK_K": 0.117483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05548",
    "Farbtonhilfsbezeichnung": "G0.61.70",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "188",
    "Bcolor": "40",
    "Y": 52,
    "L": 77.3740932698903,
    "a": 0.78919653767028,
    "b": 72.1148175623154,
    "C": 72.1191357631322,
    "h": 1.5598531522686,
    "CMY_C": 0.1123449,
    "CMY_M": 0.264483,
    "CMY_Y": 0.8447483,
    "CMYK_C": 0,
    "CMYK_M": 0.1713933,
    "CMYK_Y": 0.8250991,
    "CMYK_K": 0.1123449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05549",
    "Farbtonhilfsbezeichnung": "G0.10.71",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "194",
    "Bcolor": "169",
    "Y": 54,
    "L": 78.4775161743164,
    "a": -0.1998233050108,
    "b": 13.0036754608154,
    "C": 13.0052108764648,
    "h": 90.8803787231445,
    "CMY_C": 0.20119839906693,
    "CMY_M": 0.24102658033371,
    "CMY_Y": 0.33804965019226,
    "CMYK_C": 0,
    "CMYK_M": 0.04985991492867,
    "CMYK_Y": 0.17132070660591,
    "CMYK_K": 0.20119839906693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05550",
    "Farbtonhilfsbezeichnung": "G0.11.70",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "189",
    "Bcolor": "161",
    "Y": 51,
    "L": 76.8591063017748,
    "a": -0.55469921730461,
    "b": 14.6817553180741,
    "C": 14.6922302745864,
    "h": -1.53303275581499,
    "CMY_C": 0.2170521,
    "CMY_M": 0.2580689,
    "CMY_Y": 0.3670909,
    "CMYK_C": 0,
    "CMYK_M": 0.05238765,
    "CMYK_Y": 0.1916332,
    "CMYK_K": 0.2170521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05551",
    "Farbtonhilfsbezeichnung": "G0.26.65",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "175",
    "Bcolor": "117",
    "Y": 44,
    "L": 71.9449270572989,
    "a": -0.07077648595787,
    "b": 31.6452442111647,
    "C": 31.6453233589929,
    "h": -1.56855977056947,
    "CMY_C": 0.2309234,
    "CMY_M": 0.3150152,
    "CMY_Y": 0.5398506,
    "CMYK_C": 0,
    "CMYK_M": 0.1093412,
    "CMYK_Y": 0.4016858,
    "CMYK_K": 0.2309234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05552",
    "Farbtonhilfsbezeichnung": "G1.37.66",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "179",
    "Bcolor": "99",
    "Y": 46,
    "L": 73.3161594272168,
    "a": -1.40625360696367,
    "b": 42.7833907528202,
    "C": 42.806495693009,
    "h": -1.53793900809218,
    "CMY_C": 0.2061303,
    "CMY_M": 0.2992126,
    "CMY_Y": 0.6103628,
    "CMYK_C": 0,
    "CMYK_M": 0.1172513,
    "CMYK_Y": 0.5091925,
    "CMYK_K": 0.2061303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05553",
    "Farbtonhilfsbezeichnung": "G0.51.69",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "186",
    "Bcolor": "72",
    "Y": 51,
    "L": 76.5962478301667,
    "a": 0.4204773376028,
    "b": 59.5435924181829,
    "C": 59.5450770362599,
    "h": 1.56373477186697,
    "CMY_C": 0.1356404,
    "CMY_M": 0.2706708,
    "CMY_Y": 0.7163411,
    "CMYK_C": 0,
    "CMYK_M": 0.1562201,
    "CMYK_Y": 0.6718276,
    "CMYK_K": 0.1356404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05554",
    "Farbtonhilfsbezeichnung": "G0.62.69",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "186",
    "Bcolor": "40",
    "Y": 51,
    "L": 76.5541500677404,
    "a": 0.3663255700172,
    "b": 71.2544480519428,
    "C": 71.2553897021851,
    "h": 1.56565528153167,
    "CMY_C": 0.1254302,
    "CMY_M": 0.2721527,
    "CMY_Y": 0.8442304,
    "CMYK_C": 0,
    "CMYK_M": 0.1677654,
    "CMYK_Y": 0.82189,
    "CMYK_K": 0.1254302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05555",
    "Farbtonhilfsbezeichnung": "GN.02.61",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "166",
    "Bcolor": "161",
    "Y": 38,
    "L": 68.1425414328103,
    "a": 0.05468500855937,
    "b": 2.08515737985286,
    "C": 2.08587433679884,
    "h": 1.54457649470737,
    "CMY_C": 0.3416568,
    "CMY_M": 0.3489645,
    "CMY_Y": 0.3683195,
    "CMYK_C": 0,
    "CMYK_M": 0.01110016,
    "CMYK_Y": 0.04049967,
    "CMYK_K": 0.3416568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05556",
    "Farbtonhilfsbezeichnung": "G1.04.52",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "143",
    "Bcolor": "135",
    "Y": 27,
    "L": 59.2594518258815,
    "a": -0.35748312737687,
    "b": 3.8206155643782,
    "C": 3.83730341217998,
    "h": -1.47750106049105,
    "CMY_C": 0.4315968,
    "CMY_M": 0.4404834,
    "CMY_Y": 0.4710291,
    "CMYK_C": 0,
    "CMYK_M": 0.01563434,
    "CMYK_Y": 0.06937393,
    "CMYK_K": 0.4315968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05557",
    "Farbtonhilfsbezeichnung": "G0.09.66",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "179",
    "Bcolor": "158",
    "Y": 45,
    "L": 72.8842958522966,
    "a": -0.54978932210575,
    "b": 10.6703309254332,
    "C": 10.6844854979993,
    "h": -1.51931680221795,
    "CMY_C": 0.2706766,
    "CMY_M": 0.2996475,
    "CMY_Y": 0.379661,
    "CMYK_C": 0,
    "CMYK_M": 0.03972302,
    "CMYK_Y": 0.1494322,
    "CMYK_K": 0.2706766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05558",
    "Farbtonhilfsbezeichnung": "G1.12.62",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "168",
    "Bcolor": "142",
    "Y": 40,
    "L": 69.1376472513773,
    "a": -0.76493364665913,
    "b": 14.2006920614735,
    "C": 14.2212790742812,
    "h": -1.5169823929219,
    "CMY_C": 0.3031627,
    "CMY_M": 0.3396136,
    "CMY_Y": 0.4430845,
    "CMYK_C": 0,
    "CMYK_M": 0.05230916,
    "CMYK_Y": 0.2007956,
    "CMYK_K": 0.3031627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05559",
    "Farbtonhilfsbezeichnung": "G1.45.63",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "171",
    "Bcolor": "78",
    "Y": 41,
    "L": 70.3546458336089,
    "a": -1.4234833983261,
    "b": 49.696424029981,
    "C": 49.7168066789591,
    "h": -1.54216057851955,
    "CMY_C": 0.230381,
    "CMY_M": 0.3313713,
    "CMY_Y": 0.6950019,
    "CMYK_C": 0,
    "CMYK_M": 0.1312212,
    "CMYK_Y": 0.6037025,
    "CMYK_K": 0.230381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05560",
    "Farbtonhilfsbezeichnung": "G1.54.61",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "164",
    "Bcolor": "55",
    "Y": 37,
    "L": 67.5424536170905,
    "a": -3.3959834474403,
    "b": 56.5483644988259,
    "C": 56.6502447573474,
    "h": -1.51081387278023,
    "CMY_C": 0.266937,
    "CMY_M": 0.3571626,
    "CMY_Y": 0.7851641,
    "CMYK_C": 0,
    "CMYK_M": 0.1230802,
    "CMYK_Y": 0.7069339,
    "CMYK_K": 0.266937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05561",
    "Farbtonhilfsbezeichnung": "G0.64.65",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "171",
    "Bcolor": "13",
    "Y": 42,
    "L": 70.9116372351173,
    "a": -1.09230148649658,
    "b": 71.6359631434406,
    "C": 71.6442903379313,
    "h": -1.55554955970985,
    "CMY_C": 0.2008249,
    "CMY_M": 0.3284328,
    "CMY_Y": 0.9487879,
    "CMYK_C": 0,
    "CMYK_M": 0.1596745,
    "CMYK_Y": 0.9359187,
    "CMYK_K": 0.2008249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05562",
    "Farbtonhilfsbezeichnung": "G1.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "125",
    "Bcolor": "117",
    "Y": 21,
    "L": 52.4056842909606,
    "a": -0.23560041800979,
    "b": 4.34296353508572,
    "C": 4.34934935640386,
    "h": -1.51660068252182,
    "CMY_C": 0.4986632,
    "CMY_M": 0.510021,
    "CMY_Y": 0.5424877,
    "CMYK_C": 0,
    "CMYK_M": 0.02265522,
    "CMYK_Y": 0.08741535,
    "CMYK_K": 0.4986632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05563",
    "Farbtonhilfsbezeichnung": "G0.13.53",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "147",
    "Bcolor": "124",
    "Y": 29,
    "L": 61.1281675445306,
    "a": -0.0308944664869,
    "b": 12.7725381284879,
    "C": 12.7725754925049,
    "h": -1.56837751184011,
    "CMY_C": 0.3862333,
    "CMY_M": 0.4241585,
    "CMY_Y": 0.5134391,
    "CMYK_C": 0,
    "CMYK_M": 0.06179089,
    "CMYK_Y": 0.2072544,
    "CMYK_K": 0.3862333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05564",
    "Farbtonhilfsbezeichnung": "G1.42.50",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "137",
    "Bcolor": "69",
    "Y": 25,
    "L": 57.4409146859611,
    "a": -0.84250569898924,
    "b": 38.1575942835246,
    "C": 38.1668942587538,
    "h": -1.54872028020984,
    "CMY_C": 0.3843819,
    "CMY_M": 0.4643008,
    "CMY_Y": 0.729027,
    "CMYK_C": 0,
    "CMYK_M": 0.1298191,
    "CMYK_Y": 0.5598359,
    "CMYK_K": 0.3843819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05565",
    "Farbtonhilfsbezeichnung": "G0.52.59",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "161",
    "Bcolor": "61",
    "Y": 37,
    "L": 67.0164425400421,
    "a": 0.09192033038957,
    "b": 53.5965382200534,
    "C": 53.596617043623,
    "h": 1.56908128617253,
    "CMY_C": 0.254474,
    "CMY_M": 0.3701286,
    "CMY_Y": 0.7615893,
    "CMYK_C": 0,
    "CMYK_M": 0.1551316,
    "CMYK_Y": 0.6802114,
    "CMYK_K": 0.254474
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05566",
    "Farbtonhilfsbezeichnung": "G0.68.57",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "158",
    "Bcolor": "0",
    "Y": 35,
    "L": 66.0129297582816,
    "a": -0.84556082609327,
    "b": 69.200550028139,
    "C": 69.2057157849523,
    "h": -1.55857794489291,
    "CMY_C": 0.2583501,
    "CMY_M": 0.3797912,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.1637445,
    "CMYK_Y": 1,
    "CMYK_K": 0.2583501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05567",
    "Farbtonhilfsbezeichnung": "GN.02.32",
    "Farbtonklasse": "02",
    "Rcolor": "94",
    "Gcolor": "94",
    "Bcolor": "92",
    "Y": 11,
    "L": 40.0211343766314,
    "a": -0.30502902094339,
    "b": 0.81430171589137,
    "C": 0.86955735182984,
    "h": -1.21238543574599,
    "CMY_C": 0.6299123,
    "CMY_M": 0.6295577,
    "CMY_Y": 0.6384491,
    "CMYK_C": 0.0009571787,
    "CMYK_M": 0,
    "CMYK_Y": 0.02400227,
    "CMYK_K": 0.6295577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05568",
    "Farbtonhilfsbezeichnung": "G0.04.44",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "121",
    "Bcolor": "115",
    "Y": 19,
    "L": 50.8207418776508,
    "a": -0.17231678071866,
    "b": 3.23538258343554,
    "C": 3.23996813782409,
    "h": -1.51758650705723,
    "CMY_C": 0.5171565,
    "CMY_M": 0.5256393,
    "CMY_Y": 0.5506456,
    "CMYK_C": 0,
    "CMYK_M": 0.01756836,
    "CMYK_Y": 0.06935804,
    "CMYK_K": 0.5171565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05569",
    "Farbtonhilfsbezeichnung": "G0.13.46",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "127",
    "Bcolor": "107",
    "Y": 21,
    "L": 53.4754233373851,
    "a": -0.12566256494756,
    "b": 11.4080903288511,
    "C": 11.4087824079283,
    "h": -1.55978155751496,
    "CMY_C": 0.4689981,
    "CMY_M": 0.5011736,
    "CMY_Y": 0.5791169,
    "CMYK_C": 0,
    "CMYK_M": 0.06059401,
    "CMYK_Y": 0.2073793,
    "CMYK_K": 0.4689981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05570",
    "Farbtonhilfsbezeichnung": "G0.21.41",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "116",
    "Bcolor": "88",
    "Y": 18,
    "L": 49.0732037475287,
    "a": -0.35210261465717,
    "b": 16.4366872378795,
    "C": 16.4404581325193,
    "h": -1.54937785204796,
    "CMY_C": 0.5041101,
    "CMY_M": 0.5453306,
    "CMY_Y": 0.6546006,
    "CMYK_C": 0,
    "CMYK_M": 0.08312427,
    "CMYK_Y": 0.3034755,
    "CMYK_K": 0.5041101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05571",
    "Farbtonhilfsbezeichnung": "G0.20.49",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "137",
    "Bcolor": "106",
    "Y": 25,
    "L": 57.2748832702637,
    "a": 0.12517175078392,
    "b": 17.3283538818359,
    "C": 17.3288059234619,
    "h": 89.5861282348633,
    "CMY_C": 0.41505336761475,
    "CMY_M": 0.4646869301796,
    "CMY_Y": 0.58238458633423,
    "CMYK_C": 0,
    "CMYK_M": 0.08485143631697,
    "CMYK_Y": 0.28606235980988,
    "CMYK_K": 0.41505336761475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05572",
    "Farbtonhilfsbezeichnung": "G1.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "135",
    "Bcolor": "85",
    "Y": 25,
    "L": 56.6659927585681,
    "a": -0.762848190755,
    "b": 28.6802010780253,
    "C": 28.6903445646458,
    "h": -1.54420417125118,
    "CMY_C": 0.4060014,
    "CMY_M": 0.4709383,
    "CMY_Y": 0.6671624,
    "CMYK_C": 0,
    "CMYK_M": 0.1093217,
    "CMYK_Y": 0.439666,
    "CMYK_K": 0.4060014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05573",
    "Farbtonhilfsbezeichnung": "G1.45.52",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "143",
    "Bcolor": "63",
    "Y": 28,
    "L": 59.879966380621,
    "a": -2.11192059591514,
    "b": 44.0139213303024,
    "C": 44.064560357202,
    "h": -1.52285008705519,
    "CMY_C": 0.3583027,
    "CMY_M": 0.4375389,
    "CMY_Y": 0.7518024,
    "CMYK_C": 0,
    "CMYK_M": 0.123479,
    "CMYK_Y": 0.6132169,
    "CMYK_K": 0.3583027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05574",
    "Farbtonhilfsbezeichnung": "G1.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "138",
    "Bcolor": "56",
    "Y": 26,
    "L": 57.8172075265259,
    "a": -2.03537696099854,
    "b": 44.9415266178572,
    "C": 44.9875935577458,
    "h": -1.52553780502696,
    "CMY_C": 0.3793423,
    "CMY_M": 0.4587313,
    "CMY_Y": 0.7793809,
    "CMYK_C": 0,
    "CMYK_M": 0.127911,
    "CMYK_Y": 0.6445398,
    "CMYK_K": 0.3793423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05575",
    "Farbtonhilfsbezeichnung": "F8.05.16",
    "Farbtonklasse": "02",
    "Rcolor": "54",
    "Gcolor": "52",
    "Bcolor": "47",
    "Y": 3,
    "L": 21.6136314142349,
    "a": 0.1303397289098,
    "b": 2.63896754798626,
    "C": 2.64218435470671,
    "h": 1.5214460042899,
    "CMY_C": 0.789444,
    "CMY_M": 0.7974824,
    "CMY_Y": 0.8137301,
    "CMYK_C": 0,
    "CMYK_M": 0.03817713,
    "CMYK_Y": 0.1153428,
    "CMYK_K": 0.789444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05576",
    "Farbtonhilfsbezeichnung": "G2.04.26",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "88",
    "Bcolor": "85",
    "Y": 8,
    "L": 37.4707794189453,
    "a": -0.26399061083794,
    "b": 1.83709263801575,
    "C": 1.85596346855164,
    "h": 98.1774291992188,
    "CMY_C": 0.65080320835114,
    "CMY_M": 0.65391796827316,
    "CMY_Y": 0.66861301660538,
    "CMYK_C": 0,
    "CMYK_M": 0.0089197838679,
    "CMYK_Y": 0.05100221186876,
    "CMYK_K": 0.65080320835114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05577",
    "Farbtonhilfsbezeichnung": "G0.08.30",
    "Farbtonklasse": "02",
    "Rcolor": "92",
    "Gcolor": "88",
    "Bcolor": "79",
    "Y": 10,
    "L": 37.6502454403184,
    "a": -0.15292429119509,
    "b": 5.67857983270457,
    "C": 5.68063858692282,
    "h": -1.54387281008063,
    "CMY_C": 0.6384258,
    "CMY_M": 0.6533284,
    "CMY_Y": 0.6909132,
    "CMYK_C": 0,
    "CMYK_M": 0.04121579,
    "CMYK_Y": 0.1451637,
    "CMYK_K": 0.6384258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05578",
    "Farbtonhilfsbezeichnung": "G0.11.31",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "98",
    "Bcolor": "86",
    "Y": 10,
    "L": 41.3830261230469,
    "a": -0.53307628631592,
    "b": 6.85109281539917,
    "C": 6.87180042266846,
    "h": 94.4491577148438,
    "CMY_C": 0.60235190391541,
    "CMY_M": 0.61749756336212,
    "CMY_Y": 0.66397058963776,
    "CMYK_C": 0,
    "CMYK_M": 0.03808809816837,
    "CMYK_Y": 0.15495783090591,
    "CMYK_K": 0.60235190391541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05579",
    "Farbtonhilfsbezeichnung": "G0.32.30",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "91",
    "Bcolor": "60",
    "Y": 11,
    "L": 39.016155583748,
    "a": 0.13506329966442,
    "b": 19.4999009083642,
    "C": 19.5003686511548,
    "h": 1.56387007929757,
    "CMY_C": 0.5959491,
    "CMY_M": 0.6436276,
    "CMY_Y": 0.7664261,
    "CMYK_C": 0,
    "CMYK_M": 0.1180013,
    "CMYK_Y": 0.4219196,
    "CMYK_K": 0.5959491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05580",
    "Farbtonhilfsbezeichnung": "G0.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "112",
    "Bcolor": "71",
    "Y": 16,
    "L": 47.3573188255629,
    "a": -1.04976045012245,
    "b": 24.2525568273398,
    "C": 24.275265388168,
    "h": -1.52753880138902,
    "CMY_C": 0.5117322,
    "CMY_M": 0.5619963,
    "CMY_Y": 0.7231703,
    "CMYK_C": 0,
    "CMYK_M": 0.1029438,
    "CMYK_Y": 0.4330371,
    "CMYK_K": 0.5117322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05581",
    "Farbtonhilfsbezeichnung": "G0.53.42",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "117",
    "Bcolor": "49",
    "Y": 18,
    "L": 49.8434573132775,
    "a": -0.77374724121648,
    "b": 39.3277398412748,
    "C": 39.335350587179,
    "h": -1.55112452684905,
    "CMY_C": 0.4640281,
    "CMY_M": 0.540237,
    "CMY_Y": 0.8096448,
    "CMYK_C": 0,
    "CMYK_M": 0.1421882,
    "CMYK_Y": 0.6448411,
    "CMYK_K": 0.4640281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05582",
    "Farbtonhilfsbezeichnung": "G1.58.50",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "140",
    "Bcolor": "48",
    "Y": 27,
    "L": 58.6330958310749,
    "a": -1.86863516995484,
    "b": 49.6245254828213,
    "C": 49.659695194328,
    "h": -1.5331586325019,
    "CMY_C": 0.3644271,
    "CMY_M": 0.4513336,
    "CMY_Y": 0.8118504,
    "CMYK_C": 0,
    "CMYK_M": 0.1367373,
    "CMYK_Y": 0.7039686,
    "CMYK_K": 0.3644271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05583",
    "Farbtonhilfsbezeichnung": "G1.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "219",
    "Y": 87,
    "L": 94.5457692793332,
    "a": -0.36232974737254,
    "b": 9.57020363599566,
    "C": 9.57706011677151,
    "h": -1.53295420875443,
    "CMY_C": 0.03331279,
    "CMY_M": 0.06273922,
    "CMY_Y": 0.1402516,
    "CMYK_C": 0,
    "CMYK_M": 0.03044049,
    "CMYK_Y": 0.110624,
    "CMYK_K": 0.03331279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05584",
    "Farbtonhilfsbezeichnung": "G2.09.88",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "239",
    "Bcolor": "211",
    "Y": 87,
    "L": 94.6936641329932,
    "a": -0.81193929974232,
    "b": 14.3191218577694,
    "C": 14.3421231414361,
    "h": -1.51415383240676,
    "CMY_C": 0.02117727,
    "CMY_M": 0.06121596,
    "CMY_Y": 0.1742776,
    "CMYK_C": 0,
    "CMYK_M": 0.04090494,
    "CMYK_Y": 0.1564128,
    "CMYK_K": 0.02117727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05585",
    "Farbtonhilfsbezeichnung": "G3.16.88",
    "Farbtonklasse": "01",
    "Rcolor": "250",
    "Gcolor": "236",
    "Bcolor": "187",
    "Y": 86,
    "L": 93.4442520141602,
    "a": -2.35205936431885,
    "b": 25.0091114044189,
    "C": 25.1194705963135,
    "h": 95.3727493286133,
    "CMY_C": 0.01884281635284,
    "CMY_M": 0.07402914762497,
    "CMY_Y": 0.26850134134293,
    "CMYK_C": 0,
    "CMYK_M": 0.05624616891146,
    "CMYK_Y": 0.25445315241814,
    "CMYK_K": 0.01884281635284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05586",
    "Farbtonhilfsbezeichnung": "G2.31.85",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "231",
    "Bcolor": "142",
    "Y": 81,
    "L": 92.1633386640972,
    "a": -2.33272522892669,
    "b": 45.686678167021,
    "C": 45.7461929446661,
    "h": -1.51978142887055,
    "CMY_C": 0,
    "CMY_M": 0.09238285,
    "CMY_Y": 0.4412139,
    "CMYK_C": 0,
    "CMYK_M": 0.09238285,
    "CMYK_Y": 0.4412139,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05587",
    "Farbtonhilfsbezeichnung": "G2.40.83",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "226",
    "Bcolor": "117",
    "Y": 77,
    "L": 90.3970345818377,
    "a": -2.92899432630422,
    "b": 55.7195252786864,
    "C": 55.7964560258597,
    "h": -1.51827791578724,
    "CMY_C": 0,
    "CMY_M": 0.1121393,
    "CMY_Y": 0.5410876,
    "CMYK_C": 0,
    "CMYK_M": 0.1121393,
    "CMYK_Y": 0.5410876,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05588",
    "Farbtonhilfsbezeichnung": "G3.10.86",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "239",
    "Bcolor": "207",
    "Y": 85,
    "L": 94.4873809814453,
    "a": -1.41308546066284,
    "b": 15.9151258468628,
    "C": 15.9777355194092,
    "h": 95.0739212036133,
    "CMY_C": 0.02357995510101,
    "CMY_M": 0.06245672702789,
    "CMY_Y": 0.18860220909119,
    "CMYK_C": 0,
    "CMYK_M": 0.03981562331319,
    "CMYK_Y": 0.16900743544102,
    "CMYK_K": 0.02357995510101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05589",
    "Farbtonhilfsbezeichnung": "G3.19.87",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "236",
    "Bcolor": "180",
    "Y": 84,
    "L": 93.6215637836133,
    "a": -1.86458144298612,
    "b": 28.6447680461442,
    "C": 28.7053897443483,
    "h": -1.50579476624171,
    "CMY_C": 0.004723718,
    "CMY_M": 0.07401342,
    "CMY_Y": 0.2940588,
    "CMYK_C": 0,
    "CMYK_M": 0.06961856,
    "CMYK_Y": 0.2907083,
    "CMYK_K": 0.004723718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05590",
    "Farbtonhilfsbezeichnung": "G3.20.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "173",
    "Y": 80,
    "L": 91.681660556007,
    "a": -3.28955428278116,
    "b": 29.6112335378912,
    "C": 29.7933938821158,
    "h": -1.460158546594,
    "CMY_C": 0.03507738,
    "CMY_M": 0.09253607,
    "CMY_Y": 0.3222973,
    "CMYK_C": 0,
    "CMYK_M": 0.05954746,
    "CMYK_Y": 0.2976611,
    "CMYK_K": 0.03507738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05591",
    "Farbtonhilfsbezeichnung": "G1.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "235",
    "Bcolor": "215",
    "Y": 83,
    "L": 93.1131504568823,
    "a": -0.54829475092427,
    "b": 9.8022970842282,
    "C": 9.8176196331575,
    "h": -1.51491922069803,
    "CMY_C": 0.05022583,
    "CMY_M": 0.07842527,
    "CMY_Y": 0.157731,
    "CMYK_C": 0,
    "CMYK_M": 0.02969067,
    "CMYK_Y": 0.1131903,
    "CMYK_K": 0.05022583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05592",
    "Farbtonhilfsbezeichnung": "G2.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "239",
    "Bcolor": "211",
    "Y": 86,
    "L": 94.3471096055215,
    "a": -1.01830179207357,
    "b": 13.8015246592442,
    "C": 13.8390397592992,
    "h": -1.49714794136758,
    "CMY_C": 0.02814522,
    "CMY_M": 0.06448685,
    "CMY_Y": 0.1742132,
    "CMYK_C": 0,
    "CMYK_M": 0.0373941,
    "CMYK_Y": 0.1502981,
    "CMYK_K": 0.02814522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05593",
    "Farbtonhilfsbezeichnung": "G3.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "188",
    "Y": 81,
    "L": 92.1867839601528,
    "a": -2.04174119134976,
    "b": 22.548810189467,
    "C": 22.6410588986705,
    "h": -1.48049495512358,
    "CMY_C": 0.03697326,
    "CMY_M": 0.08832424,
    "CMY_Y": 0.2633772,
    "CMYK_C": 0,
    "CMYK_M": 0.05332248,
    "CMYK_Y": 0.2350963,
    "CMYK_K": 0.03697326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05594",
    "Farbtonhilfsbezeichnung": "G2.36.82",
    "Farbtonklasse": "02",
    "Rcolor": "254",
    "Gcolor": "228",
    "Bcolor": "129",
    "Y": 78,
    "L": 90.8377896747136,
    "a": -3.23048876582843,
    "b": 50.6627119581727,
    "C": 50.7656029277987,
    "h": -1.50711791360717,
    "CMY_C": 0.004413915,
    "CMY_M": 0.1058001,
    "CMY_Y": 0.4950566,
    "CMYK_C": 0,
    "CMYK_M": 0.1018356,
    "CMYK_Y": 0.492818,
    "CMYK_K": 0.004413915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05595",
    "Farbtonhilfsbezeichnung": "G2.50.81",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "219",
    "Bcolor": "87",
    "Y": 72,
    "L": 87.7942343450406,
    "a": -3.86281920561898,
    "b": 65.9092389615717,
    "C": 66.0223382856807,
    "h": -1.51225513380004,
    "CMY_C": 0.02382064,
    "CMY_M": 0.1400003,
    "CMY_Y": 0.6584264,
    "CMYK_C": 0,
    "CMYK_M": 0.1190146,
    "CMYK_Y": 0.6500914,
    "CMYK_K": 0.02382064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05596",
    "Farbtonhilfsbezeichnung": "G2.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "226",
    "Bcolor": "188",
    "Y": 76,
    "L": 89.8918192608115,
    "a": -1.28049904630606,
    "b": 19.3549177937749,
    "C": 19.3972297148684,
    "h": -1.50473375262744,
    "CMY_C": 0.06549228,
    "CMY_M": 0.114965,
    "CMY_Y": 0.263917,
    "CMYK_C": 0,
    "CMYK_M": 0.05293989,
    "CMYK_Y": 0.2123307,
    "CMYK_K": 0.06549228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05597",
    "Farbtonhilfsbezeichnung": "G2.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "226",
    "Bcolor": "186",
    "Y": 76,
    "L": 89.9531490298693,
    "a": -0.79483887812292,
    "b": 20.3388464452191,
    "C": 20.3543716081921,
    "h": -1.53173636261895,
    "CMY_C": 0.05873913,
    "CMY_M": 0.1156579,
    "CMY_Y": 0.2705133,
    "CMYK_C": 0,
    "CMYK_M": 0.0604708,
    "CMYK_Y": 0.2249898,
    "CMYK_K": 0.05873913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05598",
    "Farbtonhilfsbezeichnung": "G2.19.84",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "230",
    "Bcolor": "175",
    "Y": 78,
    "L": 91.5337547403727,
    "a": -2.11158215098484,
    "b": 28.5395933495151,
    "C": 28.6176024106851,
    "h": -1.49694307810539,
    "CMY_C": 0.0307013,
    "CMY_M": 0.09673552,
    "CMY_Y": 0.3155167,
    "CMYK_C": 0,
    "CMYK_M": 0.06812577,
    "CMYK_Y": 0.2938366,
    "CMYK_K": 0.0307013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05599",
    "Farbtonhilfsbezeichnung": "G2.28.82",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "226",
    "Bcolor": "147",
    "Y": 76,
    "L": 89.9925241391262,
    "a": -2.80600023076394,
    "b": 40.3939281721699,
    "C": 40.4912715344119,
    "h": -1.50144184903771,
    "CMY_C": 0.02898167,
    "CMY_M": 0.1145039,
    "CMY_Y": 0.4225198,
    "CMYK_C": 0,
    "CMYK_M": 0.08807476,
    "CMYK_Y": 0.405284,
    "CMYK_K": 0.02898167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05600",
    "Farbtonhilfsbezeichnung": "G2.58.80",
    "Farbtonklasse": "03",
    "Rcolor": "251",
    "Gcolor": "218",
    "Bcolor": "53",
    "Y": 71,
    "L": 87.4308178812684,
    "a": -3.83482603912771,
    "b": 77.978705882385,
    "C": 78.0729432123695,
    "h": -1.52165805226872,
    "CMY_C": 0.01555167,
    "CMY_M": 0.1452989,
    "CMY_Y": 0.7935943,
    "CMYK_C": 0,
    "CMYK_M": 0.1317969,
    "CMYK_Y": 0.7903336,
    "CMYK_K": 0.01555167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05601",
    "Farbtonhilfsbezeichnung": "G3.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "225",
    "Bcolor": "203",
    "Y": 76,
    "L": 89.6201858520508,
    "a": -0.75539064407349,
    "b": 10.7642908096313,
    "C": 10.7907629013062,
    "h": 94.0141830444336,
    "CMY_C": 0.08819490671158,
    "CMY_M": 0.1171088218689,
    "CMY_Y": 0.20296609401703,
    "CMYK_C": 0,
    "CMYK_M": 0.0317106321454,
    "CMYK_Y": 0.12587250769138,
    "CMYK_K": 0.08819490671158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05602",
    "Farbtonhilfsbezeichnung": "G2.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "221",
    "Bcolor": "193",
    "Y": 72,
    "L": 88.0647277832031,
    "a": -1.10712933540344,
    "b": 13.9459638595581,
    "C": 13.9898405075073,
    "h": 94.5390243530273,
    "CMY_C": 0.09918159246445,
    "CMY_M": 0.13431841135025,
    "CMY_Y": 0.24333792924881,
    "CMYK_C": 0,
    "CMYK_M": 0.0390054397285,
    "CMYK_Y": 0.1600281894207,
    "CMYK_K": 0.09918159246445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05603",
    "Farbtonhilfsbezeichnung": "G3.12.80",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "221",
    "Bcolor": "186",
    "Y": 72,
    "L": 88.0687920823008,
    "a": -1.71366343413454,
    "b": 17.6866842757388,
    "C": 17.7695088011784,
    "h": -1.47420778761881,
    "CMY_C": 0.09354428,
    "CMY_M": 0.133775,
    "CMY_Y": 0.2710802,
    "CMYK_C": 0,
    "CMYK_M": 0.0443824,
    "CMYK_Y": 0.1958573,
    "CMYK_K": 0.09354428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05604",
    "Farbtonhilfsbezeichnung": "G2.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "218",
    "Bcolor": "165",
    "Y": 70,
    "L": 87.2389607410395,
    "a": -2.12515400734492,
    "b": 27.2915566761582,
    "C": 27.3741729621717,
    "h": -1.49308459003454,
    "CMY_C": 0.08252014,
    "CMY_M": 0.1440835,
    "CMY_Y": 0.351457,
    "CMYK_C": 0,
    "CMYK_M": 0.06710052,
    "CMYK_Y": 0.2931256,
    "CMYK_K": 0.08252014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05605",
    "Farbtonhilfsbezeichnung": "R5.10.54",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "154",
    "Bcolor": "161",
    "Y": 31,
    "L": 62.1765252756618,
    "a": -5.53915050159687,
    "b": -7.13245412146626,
    "C": 9.03073031787362,
    "h": 0.91047984656516,
    "CMY_C": 0.4798822,
    "CMY_M": 0.3966067,
    "CMY_Y": 0.367192,
    "CMYK_C": 0.1780796,
    "CMYK_M": 0.04648275,
    "CMYK_Y": 0,
    "CMYK_K": 0.367192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05606",
    "Farbtonhilfsbezeichnung": "S4.08.60",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "166",
    "Bcolor": "175",
    "Y": 37,
    "L": 67.2094785636122,
    "a": -3.0719637227441,
    "b": -7.25807393469131,
    "C": 7.88140839922036,
    "h": 1.1704107561035,
    "CMY_C": 0.4084538,
    "CMY_M": 0.3492942,
    "CMY_Y": 0.3134015,
    "CMYK_C": 0.1384393,
    "CMYK_M": 0.05227614,
    "CMYK_Y": 0,
    "CMYK_K": 0.3134015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05607",
    "Farbtonhilfsbezeichnung": "Z6.15.26",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "71",
    "Bcolor": "83",
    "Y": 8,
    "L": 34.1020175660274,
    "a": 15.5327670084171,
    "b": -1.76148501122393,
    "C": 15.6323280538293,
    "h": -0.11292202567179,
    "CMY_C": 0.5966218,
    "CMY_M": 0.7198861,
    "CMY_Y": 0.6756204,
    "CMYK_C": 0,
    "CMYK_M": 0.3055802,
    "CMYK_Y": 0.1958426,
    "CMYK_K": 0.5966218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05608",
    "Farbtonhilfsbezeichnung": "C8.30.39",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "101",
    "Bcolor": "83",
    "Y": 18,
    "L": 49.0102803724463,
    "a": 23.1042344392339,
    "b": 19.7865529271015,
    "C": 30.4189632591262,
    "h": 0.70820004077692,
    "CMY_C": 0.3635558,
    "CMY_M": 0.6049231,
    "CMY_Y": 0.6729322,
    "CMYK_C": 0,
    "CMYK_M": 0.3792435,
    "CMYK_Y": 0.4861014,
    "CMYK_K": 0.3635558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05609",
    "Farbtonhilfsbezeichnung": "Z3.40.33",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "66",
    "Bcolor": "112",
    "Y": 12,
    "L": 41.8655273375716,
    "a": 43.9179860100123,
    "b": -8.0993948844095,
    "C": 44.658590356943,
    "h": -0.18237178042998,
    "CMY_C": 0.3773283,
    "CMY_M": 0.7415967,
    "CMY_Y": 0.5591978,
    "CMYK_C": 0,
    "CMYK_M": 0.5850087,
    "CMYK_Y": 0.2920794,
    "CMYK_K": 0.3773283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05610",
    "Farbtonhilfsbezeichnung": "U6.44.33",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "101",
    "Bcolor": "172",
    "Y": 13,
    "L": 42.7413104691512,
    "a": 7.97743993070443,
    "b": -43.7898107051755,
    "C": 44.5105276248564,
    "h": -1.39059675986079,
    "CMY_C": 0.7968478,
    "CMY_M": 0.6046187,
    "CMY_Y": 0.3245176,
    "CMYK_C": 0.6992486,
    "CMYK_M": 0.4146682,
    "CMYK_Y": 0,
    "CMYK_K": 0.3245176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05611",
    "Farbtonhilfsbezeichnung": "Z8.15.49",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "126",
    "Bcolor": "140",
    "Y": 25,
    "L": 57.4126586914063,
    "a": 19.4321937561035,
    "b": -1.60430598258972,
    "C": 19.4983062744141,
    "h": 355.280426025391,
    "CMY_C": 0.33422893285751,
    "CMY_M": 0.50574839115143,
    "CMY_Y": 0.45039248466492,
    "CMYK_C": 0,
    "CMYK_M": 0.25762528181076,
    "CMYK_Y": 0.17447972297668,
    "CMYK_K": 0.33422893285751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05612",
    "Farbtonhilfsbezeichnung": "X8.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "193",
    "Bcolor": "208",
    "Y": 57,
    "L": 80.1233303131992,
    "a": 10.0226824156462,
    "b": -5.89082136311228,
    "C": 11.6256586539001,
    "h": -0.53136269257429,
    "CMY_C": 0.1646739,
    "CMY_M": 0.2427672,
    "CMY_Y": 0.1831049,
    "CMYK_C": 0,
    "CMYK_M": 0.09348845,
    "CMYK_Y": 0.02206445,
    "CMYK_K": 0.1646739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05613",
    "Farbtonhilfsbezeichnung": "H7.50.75",
    "Farbtonklasse": "04",
    "Rcolor": "182",
    "Gcolor": "216",
    "Bcolor": "83",
    "Y": 60,
    "L": 81.6584182623869,
    "a": -29.5524070883532,
    "b": 59.5265399719662,
    "C": 66.4586617812143,
    "h": -1.10998659862574,
    "CMY_C": 0.2846513,
    "CMY_M": 0.1534128,
    "CMY_Y": 0.6746033,
    "CMYK_C": 0.1550206,
    "CMYK_M": 0,
    "CMYK_Y": 0.6156372,
    "CMYK_K": 0.1534128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05614",
    "Farbtonhilfsbezeichnung": "T6.30.55",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "157",
    "Bcolor": "205",
    "Y": 32,
    "L": 63.1145666648804,
    "a": -2.93224800714387,
    "b": -30.5124232604902,
    "C": 30.6529941702715,
    "h": 1.47499039866014,
    "CMY_C": 0.5749605,
    "CMY_M": 0.3844542,
    "CMY_Y": 0.195821,
    "CMYK_C": 0.4714615,
    "CMYK_M": 0.2345662,
    "CMYK_Y": 0,
    "CMYK_K": 0.195821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05615",
    "Farbtonhilfsbezeichnung": "Z4.30.43",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "96",
    "Bcolor": "132",
    "Y": 19,
    "L": 51.2398103769641,
    "a": 38.2365650622142,
    "b": -5.75147486799545,
    "C": 38.6667088192688,
    "h": -0.14929890923739,
    "CMY_C": 0.3000167,
    "CMY_M": 0.6252648,
    "CMY_Y": 0.4824761,
    "CMYK_C": 0,
    "CMYK_M": 0.4646513,
    "CMYK_Y": 0.2606625,
    "CMYK_K": 0.3000167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05616",
    "Farbtonhilfsbezeichnung": "HN.01.72",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "197",
    "Bcolor": "191",
    "Y": 55,
    "L": 79.2332394645809,
    "a": -1.12582817466872,
    "b": 1.811622064624,
    "C": 2.13294715919322,
    "h": -1.01475562953423,
    "CMY_C": 0.2331298,
    "CMY_M": 0.227904,
    "CMY_Y": 0.2495937,
    "CMYK_C": 0.006768316,
    "CMYK_M": 0,
    "CMYK_Y": 0.02809196,
    "CMYK_K": 0.227904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05617",
    "Farbtonhilfsbezeichnung": "G7.04.63",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "175",
    "Bcolor": "165",
    "Y": 42,
    "L": 71.1735803439957,
    "a": -1.1009024748565,
    "b": 4.11937283536008,
    "C": 4.26394404464314,
    "h": -1.30964938920334,
    "CMY_C": 0.3119038,
    "CMY_M": 0.3149435,
    "CMY_Y": 0.3512084,
    "CMYK_C": 0,
    "CMYK_M": 0.004417522,
    "CMYK_Y": 0.05712068,
    "CMYK_K": 0.3119038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05618",
    "Farbtonhilfsbezeichnung": "Y2.34.31",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "66",
    "Bcolor": "118",
    "Y": 10,
    "L": 38.3102354458399,
    "a": 36.1188326439236,
    "b": -17.6276585435442,
    "C": 40.1908499199451,
    "h": -0.45403890850818,
    "CMY_C": 0.4779046,
    "CMY_M": 0.7395453,
    "CMY_Y": 0.5354393,
    "CMYK_C": 0,
    "CMYK_M": 0.5011358,
    "CMYK_Y": 0.1101994,
    "CMYK_K": 0.4779046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05619",
    "Farbtonhilfsbezeichnung": "PN.01.72",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "199",
    "Bcolor": "197",
    "Y": 56,
    "L": 79.7459360339303,
    "a": -1.8438938775085,
    "b": -0.55223380273075,
    "C": 1.92481344664666,
    "h": 0.29099183767831,
    "CMY_C": 0.2411904,
    "CMY_M": 0.2200558,
    "CMY_Y": 0.2271685,
    "CMYK_C": 0.0270975,
    "CMYK_M": 0,
    "CMYK_Y": 0.009119387,
    "CMYK_K": 0.2200558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05620",
    "Farbtonhilfsbezeichnung": "Z1.07.73",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "192",
    "Bcolor": "203",
    "Y": 58,
    "L": 80.4923393488816,
    "a": 12.6644016304738,
    "b": -2.65354573258691,
    "C": 12.9394116409085,
    "h": -0.20654001078523,
    "CMY_C": 0.1311197,
    "CMY_M": 0.2465179,
    "CMY_Y": 0.2020246,
    "CMYK_C": 0,
    "CMYK_M": 0.1328126,
    "CMYK_Y": 0.08160495,
    "CMYK_K": 0.1311197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05621",
    "Farbtonhilfsbezeichnung": "E4.25.50",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "139",
    "Bcolor": "106",
    "Y": 28,
    "L": 60.1511598614507,
    "a": 8.76927170474307,
    "b": 21.9969982242277,
    "C": 23.6805417401774,
    "h": 1.19144767997382,
    "CMY_C": 0.3210757,
    "CMY_M": 0.4563993,
    "CMY_Y": 0.5850753,
    "CMYK_C": 0,
    "CMYK_M": 0.1993205,
    "CMYK_Y": 0.3888498,
    "CMYK_K": 0.3210757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05622",
    "Farbtonhilfsbezeichnung": "S4.42.49",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "146",
    "Bcolor": "192",
    "Y": 25,
    "L": 56.8224387307702,
    "a": -14.3163293299957,
    "b": -33.1526212055401,
    "C": 36.1116820195753,
    "h": 1.16315402377661,
    "CMY_C": 0.8814708,
    "CMY_M": 0.4262362,
    "CMY_Y": 0.2467176,
    "CMYK_C": 0.8426497,
    "CMYK_M": 0.2383151,
    "CMYK_Y": 0,
    "CMYK_K": 0.2467176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05623",
    "Farbtonhilfsbezeichnung": "Q1.20.69",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "198",
    "Bcolor": "207",
    "Y": 50,
    "L": 76.0623930051201,
    "a": -18.0776544817324,
    "b": -12.0043366842769,
    "C": 21.700361535937,
    "h": 0.58618389474321,
    "CMY_C": 0.4788792,
    "CMY_M": 0.2226668,
    "CMY_Y": 0.1867313,
    "CMYK_C": 0.3592267,
    "CMYK_M": 0.04418658,
    "CMYK_Y": 0,
    "CMYK_K": 0.1867313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05624",
    "Farbtonhilfsbezeichnung": "K9.39.21",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "80",
    "Bcolor": "56",
    "Y": 7,
    "L": 30.9403310431011,
    "a": -18.6781603520644,
    "b": 9.92711258342375,
    "C": 21.1523341118989,
    "h": -0.48851514291556,
    "CMY_C": 0.82277,
    "CMY_M": 0.6852313,
    "CMY_Y": 0.7795094,
    "CMYK_C": 0.4369517,
    "CMYK_M": 0,
    "CMYK_Y": 0.2995156,
    "CMYK_K": 0.6852313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05625",
    "Farbtonhilfsbezeichnung": "K6.05.21",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "70",
    "Bcolor": "66",
    "Y": 6,
    "L": 29.0228985607046,
    "a": -3.04191465131215,
    "b": 0.93284705145597,
    "C": 3.18173669043773,
    "h": -0.2975596889892,
    "CMY_C": 0.7489959,
    "CMY_M": 0.7261349,
    "CMY_Y": 0.7400024,
    "CMYK_C": 0.08347552,
    "CMYK_M": 0,
    "CMYK_Y": 0.05063628,
    "CMYK_K": 0.7261349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05626",
    "Farbtonhilfsbezeichnung": "U3.29.14",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "60",
    "Bcolor": "88",
    "Y": 4,
    "L": 24.9942324220622,
    "a": 1.03545873467065,
    "b": -19.3454192267235,
    "C": 19.3731107426992,
    "h": -1.51732260308723,
    "CMY_C": 0.8425438,
    "CMY_M": 0.7636288,
    "CMY_Y": 0.6562345,
    "CMYK_C": 0.5419661,
    "CMYK_M": 0.3124056,
    "CMYK_Y": 0,
    "CMYK_K": 0.6562345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05627",
    "Farbtonhilfsbezeichnung": "G8.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "92",
    "Bcolor": "68",
    "Y": 10,
    "L": 38.5123609796018,
    "a": -3.19549373622541,
    "b": 13.2902247339881,
    "C": 13.6689887591645,
    "h": -1.33483591317729,
    "CMY_C": 0.6322969,
    "CMY_M": 0.6407326,
    "CMY_Y": 0.7315197,
    "CMYK_C": 0,
    "CMYK_M": 0.02294176,
    "CMYK_Y": 0.2698449,
    "CMYK_K": 0.6322969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05628",
    "Farbtonhilfsbezeichnung": "S6.06.73",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "203",
    "Bcolor": "211",
    "Y": 58,
    "L": 80.8589641022483,
    "a": -2.24047512479825,
    "b": -6.43402742970745,
    "C": 6.8129610120026,
    "h": 1.23570562477505,
    "CMY_C": 0.2540524,
    "CMY_M": 0.2053504,
    "CMY_Y": 0.1727335,
    "CMYK_C": 0.09829831,
    "CMYK_M": 0.03942727,
    "CMYK_Y": 0,
    "CMYK_K": 0.1727335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05629",
    "Farbtonhilfsbezeichnung": "KN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "196",
    "Bcolor": "191",
    "Y": 55,
    "L": 78.7948845611222,
    "a": -1.45097441508324,
    "b": 1.13312401270147,
    "C": 1.84100428608595,
    "h": -0.66301048188806,
    "CMY_C": 0.242633,
    "CMY_M": 0.2317247,
    "CMY_Y": 0.2494543,
    "CMYK_C": 0.01419842,
    "CMYK_M": 0,
    "CMYK_Y": 0.02307715,
    "CMYK_K": 0.2317247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05630",
    "Farbtonhilfsbezeichnung": "S8.22.30",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "95",
    "Bcolor": "113",
    "Y": 11,
    "L": 39.0347076431187,
    "a": -3.6313843454219,
    "b": -13.9966886873249,
    "C": 14.4600915098786,
    "h": 1.31694729582734,
    "CMY_C": 0.7220835,
    "CMY_M": 0.6283836,
    "CMY_Y": 0.5550009,
    "CMYK_C": 0.3754673,
    "CMYK_M": 0.1649053,
    "CMYK_Y": 0,
    "CMYK_K": 0.5550009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05631",
    "Farbtonhilfsbezeichnung": "A5.06.63",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "168",
    "Bcolor": "170",
    "Y": 42,
    "L": 70.998324649103,
    "a": 9.32046814175408,
    "b": 1.29065202115208,
    "C": 9.40940534896636,
    "h": 0.13759996531168,
    "CMY_C": 0.2472762,
    "CMY_M": 0.3405277,
    "CMY_Y": 0.3317167,
    "CMYK_C": 0,
    "CMYK_M": 0.1238855,
    "CMYK_Y": 0.11218,
    "CMYK_K": 0.2472762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05632",
    "Farbtonhilfsbezeichnung": "A5.37.33",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "70",
    "Bcolor": "92",
    "Y": 13,
    "L": 43.0188693999432,
    "a": 41.3266188217913,
    "b": 6.50044734852795,
    "C": 41.8347372284399,
    "h": 0.15601612747187,
    "CMY_C": 0.353635,
    "CMY_M": 0.7243011,
    "CMY_Y": 0.6399037,
    "CMYK_C": 0,
    "CMYK_M": 0.5734625,
    "CMYK_Y": 0.4428901,
    "CMYK_K": 0.353635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05633",
    "Farbtonhilfsbezeichnung": "AN.01.08",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "57",
    "Bcolor": "59",
    "Y": 4,
    "L": 24.0705134208367,
    "a": 0.14327687388612,
    "b": -1.72728095109704,
    "C": 1.7332131278678,
    "h": -1.48803641818728,
    "CMY_C": 0.7795238,
    "CMY_M": 0.7752874,
    "CMY_Y": 0.7675813,
    "CMYK_C": 0.05138384,
    "CMYK_M": 0.03315635,
    "CMYK_Y": 0,
    "CMYK_K": 0.7675813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05634",
    "Farbtonhilfsbezeichnung": "A6.17.68",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "166",
    "Bcolor": "175",
    "Y": 48,
    "L": 75.0445356303938,
    "a": 27.8112120046915,
    "b": 5.24993548207293,
    "C": 28.3023909897349,
    "h": 0.18657498621823,
    "CMY_C": 0.07032687,
    "CMY_M": 0.349369,
    "CMY_Y": 0.3142969,
    "CMYK_C": 0,
    "CMYK_M": 0.3001508,
    "CMYK_Y": 0.2624256,
    "CMYK_K": 0.07032687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05635",
    "Farbtonhilfsbezeichnung": "A7.06.70",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "185",
    "Bcolor": "186",
    "Y": 52,
    "L": 77.3253823250606,
    "a": 9.93503812218577,
    "b": 1.89123812867682,
    "C": 10.1134447221827,
    "h": 0.18810979530337,
    "CMY_C": 0.1721837,
    "CMY_M": 0.2749817,
    "CMY_Y": 0.2690035,
    "CMYK_C": 0,
    "CMYK_M": 0.1241797,
    "CMYK_Y": 0.1169581,
    "CMYK_K": 0.1721837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05636",
    "Farbtonhilfsbezeichnung": "A7.25.32",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "84",
    "Bcolor": "94",
    "Y": 12,
    "L": 42.5708770751953,
    "a": 25.0344333648682,
    "b": 4.06244516372681,
    "C": 25.3619060516357,
    "h": 9.21728610992432,
    "CMY_C": 0.44696927070618,
    "CMY_M": 0.66906440258026,
    "CMY_Y": 0.63150322437286,
    "CMYK_C": 0,
    "CMYK_M": 0.40159636735916,
    "CMYK_Y": 0.33367758989334,
    "CMYK_K": 0.44696927070618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05637",
    "Farbtonhilfsbezeichnung": "B7.57.33",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "44",
    "Bcolor": "57",
    "Y": 12,
    "L": 41.099014740101,
    "a": 54.8726681621622,
    "b": 25.7734817630211,
    "C": 60.6241047226559,
    "h": 0.4391119961442,
    "CMY_C": 0.290784,
    "CMY_M": 0.8265922,
    "CMY_Y": 0.7745224,
    "CMYK_C": 0,
    "CMYK_M": 0.7554937,
    "CMYK_Y": 0.6820749,
    "CMYK_K": 0.290784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05638",
    "Farbtonhilfsbezeichnung": "B6.45.21",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "45",
    "Bcolor": "49",
    "Y": 6,
    "L": 29.2981316660109,
    "a": 32.9350360825409,
    "b": 13.7826679301212,
    "C": 35.7026404770049,
    "h": 0.39633557567568,
    "CMY_C": 0.5354263,
    "CMY_M": 0.8249823,
    "CMY_Y": 0.8082464,
    "CMYK_C": 0,
    "CMYK_M": 0.6232725,
    "CMYK_Y": 0.5872483,
    "CMYK_K": 0.5354263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05639",
    "Farbtonhilfsbezeichnung": "B9.37.52",
    "Farbtonklasse": "04",
    "Rcolor": "219",
    "Gcolor": "112",
    "Bcolor": "105",
    "Y": 28,
    "L": 59.5857530647129,
    "a": 41.5308600026543,
    "b": 22.8520261786671,
    "C": 47.4028209395871,
    "h": 0.50302903855747,
    "CMY_C": 0.1403133,
    "CMY_M": 0.5613974,
    "CMY_Y": 0.589326,
    "CMYK_C": 0,
    "CMYK_M": 0.4898111,
    "CMYK_Y": 0.522298,
    "CMYK_K": 0.1403133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05640",
    "Farbtonhilfsbezeichnung": "TN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "197",
    "Bcolor": "200",
    "Y": 55,
    "L": 79.1267703754196,
    "a": -0.86677971375648,
    "b": -2.99230158323143,
    "C": 3.11531312024796,
    "h": 1.28884341977652,
    "CMY_C": 0.2487796,
    "CMY_M": 0.228302,
    "CMY_Y": 0.2161608,
    "CMYK_C": 0.04161412,
    "CMYK_M": 0.01548931,
    "CMYK_Y": 0,
    "CMYK_K": 0.2161608
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05641",
    "Farbtonhilfsbezeichnung": "D6.15.54",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "142",
    "Bcolor": "124",
    "Y": 30,
    "L": 61.7503758048407,
    "a": 10.6152163034879,
    "b": 14.0008013329181,
    "C": 17.5700101062486,
    "h": 0.92207651529794,
    "CMY_C": 0.3075655,
    "CMY_M": 0.4429579,
    "CMY_Y": 0.5139705,
    "CMYK_C": 0,
    "CMYK_M": 0.195531,
    "CMYK_Y": 0.2980859,
    "CMYK_K": 0.3075655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05642",
    "Farbtonhilfsbezeichnung": "D4.35.43",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "102",
    "Bcolor": "71",
    "Y": 18,
    "L": 49.4268646140455,
    "a": 22.8139116956902,
    "b": 27.7800201478949,
    "C": 35.9472403151646,
    "h": 0.88324094707649,
    "CMY_C": 0.3506145,
    "CMY_M": 0.6015186,
    "CMY_Y": 0.7226804,
    "CMYK_C": 0,
    "CMYK_M": 0.3863716,
    "CMYK_Y": 0.5729507,
    "CMYK_K": 0.3506145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05643",
    "Farbtonhilfsbezeichnung": "D2.31.56",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "133",
    "Bcolor": "102",
    "Y": 31,
    "L": 62.345114311508,
    "a": 24.9080353957299,
    "b": 27.7080867453725,
    "C": 37.2578622355607,
    "h": 0.83856461624866,
    "CMY_C": 0.1931725,
    "CMY_M": 0.4786234,
    "CMY_Y": 0.6001248,
    "CMYK_C": 0,
    "CMYK_M": 0.3537942,
    "CMYK_Y": 0.5043858,
    "CMYK_K": 0.1931725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05644",
    "Farbtonhilfsbezeichnung": "C9.19.44",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "112",
    "Bcolor": "98",
    "Y": 20,
    "L": 51.2926708704797,
    "a": 15.0713239012881,
    "b": 14.0476730104606,
    "C": 20.6029590386032,
    "h": 0.75025857642091,
    "CMY_C": 0.3926179,
    "CMY_M": 0.5591695,
    "CMY_Y": 0.6151227,
    "CMYK_C": 0,
    "CMYK_M": 0.2742121,
    "CMYK_Y": 0.3663342,
    "CMYK_K": 0.3926179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05645",
    "Farbtonhilfsbezeichnung": "D1.22.30",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "86",
    "Bcolor": "74",
    "Y": 11,
    "L": 39.3567032442228,
    "a": 11.6141205187756,
    "b": 11.5430216107653,
    "C": 16.3746494109412,
    "h": 0.78232789314534,
    "CMY_C": 0.5404233,
    "CMY_M": 0.6646195,
    "CMY_Y": 0.7104344,
    "CMYK_C": 0,
    "CMYK_M": 0.2702405,
    "CMYK_Y": 0.3699297,
    "CMYK_K": 0.5404233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05646",
    "Farbtonhilfsbezeichnung": "D0.38.32",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "81",
    "Bcolor": "62",
    "Y": 12,
    "L": 41.3160392629443,
    "a": 23.9192169401346,
    "b": 21.9058149028974,
    "C": 32.4344518311813,
    "h": 0.74148967335466,
    "CMY_C": 0.4406253,
    "CMY_M": 0.6818151,
    "CMY_Y": 0.7565119,
    "CMYK_C": 0,
    "CMYK_M": 0.4311777,
    "CMYK_Y": 0.5647137,
    "CMYK_K": 0.4406253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05647",
    "Farbtonhilfsbezeichnung": "C9.19.50",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "129",
    "Bcolor": "113",
    "Y": 26,
    "L": 57.9714318913547,
    "a": 16.1468487381778,
    "b": 14.9370074884309,
    "C": 21.9962477909992,
    "h": 0.74649594798774,
    "CMY_C": 0.3128598,
    "CMY_M": 0.4956819,
    "CMY_Y": 0.5565455,
    "CMYK_C": 0,
    "CMYK_M": 0.2660623,
    "CMYK_Y": 0.3546375,
    "CMYK_K": 0.3128598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05648",
    "Farbtonhilfsbezeichnung": "C8.47.36",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "78",
    "Bcolor": "55",
    "Y": 14,
    "L": 44.0681323199644,
    "a": 35.1475515220793,
    "b": 30.5443550063669,
    "C": 46.5650942311104,
    "h": 0.71544000965397,
    "CMY_C": 0.3457925,
    "CMY_M": 0.6950365,
    "CMY_Y": 0.7860523,
    "CMYK_C": 0,
    "CMYK_M": 0.5338429,
    "CMYK_Y": 0.6729667,
    "CMYK_K": 0.3457925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05649",
    "Farbtonhilfsbezeichnung": "C8.55.40",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "82",
    "Bcolor": "54",
    "Y": 17,
    "L": 48.5221377407003,
    "a": 41.6580438132462,
    "b": 36.7290000118007,
    "C": 55.5374833442532,
    "h": 0.7225999961415,
    "CMY_C": 0.2571329,
    "CMY_M": 0.677713,
    "CMY_Y": 0.786796,
    "CMYK_C": 0,
    "CMYK_M": 0.5661579,
    "CMYK_Y": 0.7129984,
    "CMYK_K": 0.2571329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05650",
    "Farbtonhilfsbezeichnung": "C9.10.44",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "116",
    "Bcolor": "107",
    "Y": 19,
    "L": 50.6520920135384,
    "a": 7.93495188701521,
    "b": 7.62924946931431,
    "C": 11.0076750003931,
    "h": 0.76575930701717,
    "CMY_C": 0.4548096,
    "CMY_M": 0.5463901,
    "CMY_Y": 0.580079,
    "CMYK_C": 0,
    "CMYK_M": 0.1679789,
    "CMYK_Y": 0.2297717,
    "CMYK_K": 0.4548096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05651",
    "Farbtonhilfsbezeichnung": "C8.16.42",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "112",
    "Bcolor": "101",
    "Y": 19,
    "L": 50.5715431700513,
    "a": 13.0877212531378,
    "b": 11.4727108653062,
    "C": 17.4043541161041,
    "h": 0.71973609890589,
    "CMY_C": 0.4165371,
    "CMY_M": 0.5606042,
    "CMY_Y": 0.6053381,
    "CMYK_C": 0,
    "CMYK_M": 0.2469173,
    "CMYK_Y": 0.3235869,
    "CMYK_K": 0.4165371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05653",
    "Farbtonhilfsbezeichnung": "C9.61.36",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "71",
    "Bcolor": "41",
    "Y": 14,
    "L": 44.8263380748303,
    "a": 42.6070079868477,
    "b": 39.2355781872201,
    "C": 57.9205293939616,
    "h": 0.74422736412283,
    "CMY_C": 0.2948251,
    "CMY_M": 0.7196115,
    "CMY_Y": 0.8373323,
    "CMYK_C": 0,
    "CMYK_M": 0.6023845,
    "CMYK_Y": 0.7693229,
    "CMYK_K": 0.2948251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05654",
    "Farbtonhilfsbezeichnung": "C5.24.59",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "144",
    "Bcolor": "126",
    "Y": 36,
    "L": 66.74335034803,
    "a": 26.4555206311021,
    "b": 20.247554265019,
    "C": 33.3145317478358,
    "h": 0.65324869216849,
    "CMY_C": 0.1448816,
    "CMY_M": 0.436396,
    "CMY_Y": 0.5046244,
    "CMYK_C": 0,
    "CMYK_M": 0.3409053,
    "CMYK_Y": 0.4206936,
    "CMYK_K": 0.1448816
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05655",
    "Farbtonhilfsbezeichnung": "C7.55.45",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "87",
    "Bcolor": "59",
    "Y": 21,
    "L": 53.4549581146529,
    "a": 48.450454626757,
    "b": 40.6929086078036,
    "C": 63.2721057378565,
    "h": 0.69859358832771,
    "CMY_C": 0.1614141,
    "CMY_M": 0.6574904,
    "CMY_Y": 0.7677939,
    "CMYK_C": 0,
    "CMYK_M": 0.5915629,
    "CMYK_Y": 0.723098,
    "CMYK_K": 0.1614141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05656",
    "Farbtonhilfsbezeichnung": "C6.57.44",
    "Farbtonklasse": "04",
    "Rcolor": "212",
    "Gcolor": "85",
    "Bcolor": "63",
    "Y": 21,
    "L": 52.7585153669151,
    "a": 48.8975804778656,
    "b": 37.9003786399194,
    "C": 61.8660818028635,
    "h": 0.65937080356803,
    "CMY_C": 0.1696951,
    "CMY_M": 0.6663437,
    "CMY_Y": 0.7540404,
    "CMYK_C": 0,
    "CMYK_M": 0.5981521,
    "CMYK_Y": 0.7037719,
    "CMYK_K": 0.1696951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05657",
    "Farbtonhilfsbezeichnung": "C3.46.30",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "75",
    "Bcolor": "67",
    "Y": 12,
    "L": 41.9392700195313,
    "a": 33.2328605651855,
    "b": 20.2875823974609,
    "C": 38.9359588623047,
    "h": 31.4027099609375,
    "CMY_C": 0.38891124725342,
    "CMY_M": 0.70656037330627,
    "CMY_Y": 0.73831695318222,
    "CMYK_C": 0,
    "CMYK_M": 0.51980847120285,
    "CMYK_Y": 0.57177573442459,
    "CMYK_K": 0.38891124725342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05658",
    "Farbtonhilfsbezeichnung": "B9.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "139",
    "Bcolor": "134",
    "Y": 31,
    "L": 62.4864857149864,
    "a": 18.7132364640635,
    "b": 9.6377476673214,
    "C": 21.0492612473434,
    "h": 0.47559367156924,
    "CMY_C": 0.2583687,
    "CMY_M": 0.4554545,
    "CMY_Y": 0.475411,
    "CMYK_C": 0,
    "CMYK_M": 0.2657463,
    "CMYK_Y": 0.2926553,
    "CMYK_K": 0.2583687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05659",
    "Farbtonhilfsbezeichnung": "D7.53.49",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "112",
    "Bcolor": "56",
    "Y": 25,
    "L": 57.1397575068933,
    "a": 32.9745914521158,
    "b": 46.1874809418868,
    "C": 56.7503927492234,
    "h": 0.95078294898011,
    "CMY_C": 0.1914035,
    "CMY_M": 0.5600163,
    "CMY_Y": 0.7817895,
    "CMYK_C": 0,
    "CMYK_M": 0.4558674,
    "CMYK_Y": 0.7301367,
    "CMYK_K": 0.1914035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05661",
    "Farbtonhilfsbezeichnung": "D8.31.23",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "72",
    "Bcolor": "53",
    "Y": 8,
    "L": 33.2844909233921,
    "a": 10.660303285406,
    "b": 15.808356621497,
    "C": 19.0668876644634,
    "h": 0.97749603436009,
    "CMY_C": 0.5999602,
    "CMY_M": 0.7191963,
    "CMY_Y": 0.7910727,
    "CMYK_C": 0,
    "CMYK_M": 0.2980606,
    "CMYK_Y": 0.4777338,
    "CMYK_K": 0.5999602
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05662",
    "Farbtonhilfsbezeichnung": "D9.24.28",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "82",
    "Bcolor": "64",
    "Y": 10,
    "L": 37.4333528496037,
    "a": 9.00692280165844,
    "b": 14.5450028195875,
    "C": 17.1079445105729,
    "h": 1.01634602071526,
    "CMY_C": 0.5692525,
    "CMY_M": 0.6769275,
    "CMY_Y": 0.7470748,
    "CMYK_C": 0,
    "CMYK_M": 0.2499725,
    "CMYK_Y": 0.4128226,
    "CMYK_K": 0.5692525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05663",
    "Farbtonhilfsbezeichnung": "D9.07.31",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "90",
    "Bcolor": "83",
    "Y": 11,
    "L": 38.8087820664539,
    "a": 3.06680322437819,
    "b": 4.74504967012874,
    "C": 5.64984764299404,
    "h": 0.99701502105718,
    "CMY_C": 0.6094087,
    "CMY_M": 0.6488696,
    "CMY_Y": 0.6740033,
    "CMYK_C": 0,
    "CMYK_M": 0.1010286,
    "CMYK_Y": 0.1653764,
    "CMYK_K": 0.6094087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05664",
    "Farbtonhilfsbezeichnung": "X9.18.29",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "82",
    "Bcolor": "107",
    "Y": 11,
    "L": 38.7902604263477,
    "a": 16.9541104205713,
    "b": -10.2563670937681,
    "C": 19.815017691515,
    "h": -0.54405030884087,
    "CMY_C": 0.563606,
    "CMY_M": 0.6775309,
    "CMY_Y": 0.5788465,
    "CMYK_C": 0,
    "CMYK_M": 0.2610597,
    "CMYK_Y": 0.03492378,
    "CMYK_K": 0.563606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05665",
    "Farbtonhilfsbezeichnung": "H2.38.76",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "214",
    "Bcolor": "113",
    "Y": 62,
    "L": 82.914529042951,
    "a": -17.4722522580615,
    "b": 47.5129999219519,
    "C": 50.6237568790853,
    "h": -1.21840903619094,
    "CMY_C": 0.2007284,
    "CMY_M": 0.1615947,
    "CMY_Y": 0.5552609,
    "CMYK_C": 0.04667633,
    "CMYK_M": 0,
    "CMYK_Y": 0.4695416,
    "CMYK_K": 0.1615947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05666",
    "Farbtonhilfsbezeichnung": "F3.35.40",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "109",
    "Bcolor": "66",
    "Y": 16,
    "L": 47.5803466753123,
    "a": 5.27249511832129,
    "b": 27.1639600422745,
    "C": 27.6709221015674,
    "h": 1.37908127436015,
    "CMY_C": 0.467802,
    "CMY_M": 0.574018,
    "CMY_Y": 0.7396897,
    "CMYK_C": 0,
    "CMYK_M": 0.1995798,
    "CMYK_Y": 0.510877,
    "CMYK_K": 0.467802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05667",
    "Farbtonhilfsbezeichnung": "E8.41.69",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "176",
    "Bcolor": "95",
    "Y": 51,
    "L": 76.5583130521834,
    "a": 16.8102888911751,
    "b": 49.6001907491766,
    "C": 52.3714114279868,
    "h": 1.244029984469,
    "CMY_C": 0.04687665,
    "CMY_M": 0.3112969,
    "CMY_Y": 0.626037,
    "CMYK_C": 0,
    "CMYK_M": 0.2774249,
    "CMYK_Y": 0.6076447,
    "CMYK_K": 0.04687665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05668",
    "Farbtonhilfsbezeichnung": "E8.08.63",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "169",
    "Bcolor": "154",
    "Y": 41,
    "L": 69.9333059238444,
    "a": 3.10554926683915,
    "b": 8.69749176354568,
    "C": 9.23530179397025,
    "h": 1.22784354155485,
    "CMY_C": 0.2817567,
    "CMY_M": 0.3387873,
    "CMY_Y": 0.3956448,
    "CMYK_C": 0,
    "CMYK_M": 0.07940283,
    "CMYK_Y": 0.1585648,
    "CMYK_K": 0.2817567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05670",
    "Farbtonhilfsbezeichnung": "E8.24.35",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "96",
    "Bcolor": "70",
    "Y": 13,
    "L": 42.5789796333053,
    "a": 6.23501643914814,
    "b": 18.1220979757082,
    "C": 19.164703625092,
    "h": 1.23942661798884,
    "CMY_C": 0.5272518,
    "CMY_M": 0.6228148,
    "CMY_Y": 0.7243658,
    "CMYK_C": 0,
    "CMYK_M": 0.2021437,
    "CMYK_Y": 0.4169535,
    "CMYK_K": 0.5272518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05671",
    "Farbtonhilfsbezeichnung": "E9.16.29",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "87",
    "Bcolor": "72",
    "Y": 10,
    "L": 37.9317078971622,
    "a": 3.40261517687662,
    "b": 10.2787502356434,
    "C": 10.827303286075,
    "h": 1.25111665301372,
    "CMY_C": 0.6038178,
    "CMY_M": 0.6589762,
    "CMY_Y": 0.7166762,
    "CMYK_C": 0,
    "CMYK_M": 0.139225,
    "CMYK_Y": 0.2848649,
    "CMYK_K": 0.6038178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05672",
    "Farbtonhilfsbezeichnung": "E7.74.62",
    "Farbtonklasse": "04",
    "Rcolor": "239",
    "Gcolor": "148",
    "Bcolor": "0",
    "Y": 40,
    "L": 69.1824147340091,
    "a": 26.2416510888113,
    "b": 75.0129344775394,
    "C": 79.4705265541794,
    "h": 1.23427443328289,
    "CMY_C": 0.06279416,
    "CMY_M": 0.4185639,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.3796068,
    "CMYK_Y": 1,
    "CMYK_K": 0.06279416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05673",
    "Farbtonhilfsbezeichnung": "E6.11.28",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "86",
    "Bcolor": "76",
    "Y": 10,
    "L": 37.252247697281,
    "a": 2.66247063419239,
    "b": 7.04727992249127,
    "C": 7.53345234164824,
    "h": 1.20957209649631,
    "CMY_C": 0.6215569,
    "CMY_M": 0.663101,
    "CMY_Y": 0.7027063,
    "CMYK_C": 0,
    "CMYK_M": 0.109776,
    "CMYK_Y": 0.2144294,
    "CMYK_K": 0.6215569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05674",
    "Farbtonhilfsbezeichnung": "E7.19.27",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "87",
    "Bcolor": "73",
    "Y": 10,
    "L": 38.238580279482,
    "a": 3.88044286159622,
    "b": 10.0712045421988,
    "C": 10.7929142372632,
    "h": 1.20302556788823,
    "CMY_C": 0.5984188,
    "CMY_M": 0.6570841,
    "CMY_Y": 0.7125244,
    "CMYK_C": 0,
    "CMYK_M": 0.1460857,
    "CMYK_Y": 0.2841408,
    "CMYK_K": 0.5984188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05675",
    "Farbtonhilfsbezeichnung": "S3.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "216",
    "Bcolor": "222",
    "Y": 67,
    "L": 85.6381454299908,
    "a": -2.57238322452036,
    "b": -4.9658834182071,
    "C": 5.59259810615942,
    "h": 1.09284380077493,
    "CMY_C": 0.199232,
    "CMY_M": 0.1526561,
    "CMY_Y": 0.1310682,
    "CMYK_C": 0.07844547,
    "CMYK_M": 0.02484411,
    "CMYK_Y": 0,
    "CMYK_K": 0.1310682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05676",
    "Farbtonhilfsbezeichnung": "Q6.07.60",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "167",
    "Bcolor": "171",
    "Y": 37,
    "L": 67.1827779729717,
    "a": -5.3426893384157,
    "b": -5.1787534891254,
    "C": 7.44068659922922,
    "h": 0.76981830542501,
    "CMY_C": 0.4190435,
    "CMY_M": 0.3453377,
    "CMY_Y": 0.3284141,
    "CMYK_C": 0.1349484,
    "CMYK_M": 0.0251994,
    "CMYK_Y": 0,
    "CMYK_K": 0.3284141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05677",
    "Farbtonhilfsbezeichnung": "E4.54.65",
    "Farbtonklasse": "04",
    "Rcolor": "248",
    "Gcolor": "158",
    "Bcolor": "68",
    "Y": 44,
    "L": 72.6998672485352,
    "a": 26.8177032470703,
    "b": 58.3884010314941,
    "C": 64.2525863647461,
    "h": 65.3307495117188,
    "CMY_C": 0.02699410915375,
    "CMY_M": 0.38195276260376,
    "CMY_Y": 0.73395818471909,
    "CMYK_C": 0,
    "CMYK_M": 0.3648062646389,
    "CMYK_Y": 0.72657740116119,
    "CMYK_K": 0.02699410915375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05678",
    "Farbtonhilfsbezeichnung": "E5.31.24",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "79",
    "Bcolor": "60",
    "Y": 9,
    "L": 35.5396034222768,
    "a": 7.19397096050833,
    "b": 14.8711992206844,
    "C": 16.5198603033416,
    "h": 1.12023147974266,
    "CMY_C": 0.5975374,
    "CMY_M": 0.6903404,
    "CMY_Y": 0.7661955,
    "CMYK_C": 0,
    "CMYK_M": 0.2305879,
    "CMYK_Y": 0.4190654,
    "CMYK_K": 0.5975374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05679",
    "Farbtonhilfsbezeichnung": "F4.29.35",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "99",
    "Bcolor": "66",
    "Y": 13,
    "L": 43.0053739802585,
    "a": 3.37086024882521,
    "b": 21.2621630962516,
    "C": 21.5277095472024,
    "h": 1.41356692174947,
    "CMY_C": 0.534487,
    "CMY_M": 0.6129224,
    "CMY_Y": 0.7417043,
    "CMYK_C": 0,
    "CMYK_M": 0.1684923,
    "CMYK_Y": 0.4451375,
    "CMYK_K": 0.534487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05680",
    "Farbtonhilfsbezeichnung": "F7.42.78",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "210",
    "Bcolor": "107",
    "Y": 68,
    "L": 86.0433207957313,
    "a": 4.04325559256891,
    "b": 55.3412679817279,
    "C": 55.4887723563269,
    "h": 1.49786549901386,
    "CMY_C": 0.006181741,
    "CMY_M": 0.1768234,
    "CMY_Y": 0.5807889,
    "CMYK_C": 0,
    "CMYK_M": 0.1717031,
    "CMYK_Y": 0.5781813,
    "CMYK_K": 0.006181741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05681",
    "Farbtonhilfsbezeichnung": "F6.64.75",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "197",
    "Bcolor": "23",
    "Y": 61,
    "L": 82.3792012117882,
    "a": 7.04652056241889,
    "b": 80.8062837047975,
    "C": 81.1129394006703,
    "h": 1.48381373075424,
    "CMY_C": 0.006784101,
    "CMY_M": 0.2268616,
    "CMY_Y": 0.9087108,
    "CMYK_C": 0,
    "CMYK_M": 0.2215807,
    "CMYK_Y": 0.9080873,
    "CMYK_K": 0.006784101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05682",
    "Farbtonhilfsbezeichnung": "F6.21.41",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "114",
    "Bcolor": "87",
    "Y": 17,
    "L": 48.5607583388065,
    "a": 1.60017659030437,
    "b": 16.5823550944616,
    "C": 16.6593837100589,
    "h": 1.4745954436139,
    "CMY_C": 0.4968082,
    "CMY_M": 0.5545462,
    "CMY_Y": 0.6600315,
    "CMYK_C": 0,
    "CMYK_M": 0.1147436,
    "CMYK_Y": 0.3243759,
    "CMYK_K": 0.4968082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05683",
    "Farbtonhilfsbezeichnung": "F9.35.81",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "219",
    "Bcolor": "131",
    "Y": 73,
    "L": 88.491296710097,
    "a": 0.7714970302341,
    "b": 46.5370206207702,
    "C": 46.5434151725639,
    "h": 1.55421970986547,
    "CMY_C": 0.01146398,
    "CMY_M": 0.1406506,
    "CMY_Y": 0.4852727,
    "CMYK_C": 0,
    "CMYK_M": 0.1306847,
    "CMYK_Y": 0.4793034,
    "CMYK_K": 0.01146398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05684",
    "Farbtonhilfsbezeichnung": "F9.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "108",
    "Bcolor": "101",
    "Y": 13,
    "L": 45.4784469604492,
    "a": -0.10609543323517,
    "b": 3.46068787574768,
    "C": 3.46231389045715,
    "h": 91.7559814453125,
    "CMY_C": 0.56866180896759,
    "CMY_M": 0.57820820808411,
    "CMY_Y": 0.60365045070648,
    "CMYK_C": 0,
    "CMYK_M": 0.02213205210865,
    "CMYK_Y": 0.08111649751663,
    "CMYK_K": 0.56866180896759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05685",
    "Farbtonhilfsbezeichnung": "G0.24.85",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "231",
    "Bcolor": "162",
    "Y": 81,
    "L": 92.287129950523,
    "a": -0.58511244716447,
    "b": 36.3180791837815,
    "C": 36.3227921858336,
    "h": -1.55468694422759,
    "CMY_C": 0,
    "CMY_M": 0.09351046,
    "CMY_Y": 0.3665296,
    "CMYK_C": 0,
    "CMYK_M": 0.09351046,
    "CMYK_Y": 0.3665296,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05686",
    "Farbtonhilfsbezeichnung": "G1.35.76",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "203",
    "Bcolor": "119",
    "Y": 61,
    "L": 82.3853886436967,
    "a": -0.95022722741455,
    "b": 44.7802044892514,
    "C": 44.7902851730471,
    "h": -1.54957970543389,
    "CMY_C": 0.0967053,
    "CMY_M": 0.2031389,
    "CMY_Y": 0.5345469,
    "CMYK_C": 0,
    "CMYK_M": 0.1178282,
    "CMYK_Y": 0.4847162,
    "CMYK_K": 0.0967053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05687",
    "Farbtonhilfsbezeichnung": "G2.11.88",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "240",
    "Bcolor": "207",
    "Y": 87,
    "L": 94.8441646908637,
    "a": -0.92398310374336,
    "b": 16.5438658110831,
    "C": 16.5696481782543,
    "h": -1.515003793881,
    "CMY_C": 0.01411818,
    "CMY_M": 0.05980405,
    "CMY_Y": 0.1893607,
    "CMYK_C": 0,
    "CMYK_M": 0.04634011,
    "CMYK_Y": 0.177752,
    "CMYK_K": 0.01411818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05688",
    "Farbtonhilfsbezeichnung": "G2.12.84",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "230",
    "Bcolor": "196",
    "Y": 80,
    "L": 91.4916057493926,
    "a": -0.96820231801703,
    "b": 17.223411374703,
    "C": 17.2506033259959,
    "h": -1.51464111047072,
    "CMY_C": 0.05067915,
    "CMY_M": 0.09739755,
    "CMY_Y": 0.2307794,
    "CMYK_C": 0,
    "CMYK_M": 0.04921244,
    "CMYK_Y": 0.1897149,
    "CMYK_K": 0.05067915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05689",
    "Farbtonhilfsbezeichnung": "G3.50.77",
    "Farbtonklasse": "02",
    "Rcolor": "239",
    "Gcolor": "215",
    "Bcolor": "76",
    "Y": 68,
    "L": 85.8187841657396,
    "a": -6.68862697051492,
    "b": 67.9497022223618,
    "C": 68.278106028641,
    "h": -1.47267744682824,
    "CMY_C": 0.06362359,
    "CMY_M": 0.1554402,
    "CMY_Y": 0.7009543,
    "CMYK_C": 0,
    "CMYK_M": 0.09805527,
    "CMYK_Y": 0.6806352,
    "CMYK_K": 0.06362359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05690",
    "Farbtonhilfsbezeichnung": "G2.43.80",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "218",
    "Bcolor": "102",
    "Y": 71,
    "L": 87.3259595299023,
    "a": -3.14759965975248,
    "b": 58.7299818389241,
    "C": 58.8142682554024,
    "h": -1.51725312684667,
    "CMY_C": 0.03354567,
    "CMY_M": 0.1459457,
    "CMY_Y": 0.5986664,
    "CMYK_C": 0,
    "CMYK_M": 0.1163014,
    "CMYK_Y": 0.584736,
    "CMYK_K": 0.03354567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05691",
    "Farbtonhilfsbezeichnung": "G2.27.78",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "213",
    "Bcolor": "142",
    "Y": 67,
    "L": 85.6953211593305,
    "a": -2.14714508412495,
    "b": 37.4223603984012,
    "C": 37.4839070775727,
    "h": -1.51348317051377,
    "CMY_C": 0.07943725,
    "CMY_M": 0.1629581,
    "CMY_Y": 0.4440685,
    "CMYK_C": 0,
    "CMYK_M": 0.09072806,
    "CMYK_Y": 0.396096,
    "CMYK_K": 0.07943725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05692",
    "Farbtonhilfsbezeichnung": "G3.62.70",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "195",
    "Bcolor": "42",
    "Y": 52,
    "L": 78.3475341796875,
    "a": -7.09159183502197,
    "b": 71.8896102905273,
    "C": 72.2385406494141,
    "h": 95.6337509155273,
    "CMY_C": 0.15057420730591,
    "CMY_M": 0.23601335287094,
    "CMY_Y": 0.83490377664566,
    "CMYK_C": 0,
    "CMYK_M": 0.10058458894491,
    "CMYK_Y": 0.8056378364563,
    "CMYK_K": 0.15057420730591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05693",
    "Farbtonhilfsbezeichnung": "G3.60.76",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "209",
    "Bcolor": "54",
    "Y": 63,
    "L": 83.3635985431917,
    "a": -8.16709034400004,
    "b": 73.2432670438939,
    "C": 73.6972016561702,
    "h": -1.45974869054104,
    "CMY_C": 0.09696739,
    "CMY_M": 0.1794901,
    "CMY_Y": 0.7883522,
    "CMYK_C": 0,
    "CMYK_M": 0.09138402,
    "CMYK_Y": 0.7656255,
    "CMYK_K": 0.09696739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05694",
    "Farbtonhilfsbezeichnung": "G2.35.76",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "204",
    "Bcolor": "118",
    "Y": 61,
    "L": 82.3352167616447,
    "a": -3.29627198082533,
    "b": 44.9709695179961,
    "C": 45.0916123947692,
    "h": -1.49762939647058,
    "CMY_C": 0.1126432,
    "CMY_M": 0.1982753,
    "CMY_Y": 0.5371825,
    "CMYK_C": 0,
    "CMYK_M": 0.09650238,
    "CMYK_Y": 0.4784314,
    "CMYK_K": 0.1126432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05695",
    "Farbtonhilfsbezeichnung": "G3.16.80",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "217",
    "Bcolor": "173",
    "Y": 70,
    "L": 86.7739678093431,
    "a": -1.51917311770589,
    "b": 22.7869687687742,
    "C": 22.8375531226673,
    "h": -1.50422633385084,
    "CMY_C": 0.09388243,
    "CMY_M": 0.1496786,
    "CMY_Y": 0.3226421,
    "CMYK_C": 0,
    "CMYK_M": 0.0615772,
    "CMYK_Y": 0.2524614,
    "CMYK_K": 0.09388243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05696",
    "Farbtonhilfsbezeichnung": "G3.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "212",
    "Bcolor": "199",
    "Y": 65,
    "L": 84.7268884698635,
    "a": -0.5647157965069,
    "b": 5.85124328177682,
    "C": 5.87843107243445,
    "h": -1.47458221653626,
    "CMY_C": 0.1559255,
    "CMY_M": 0.1703601,
    "CMY_Y": 0.2197362,
    "CMYK_C": 0,
    "CMYK_M": 0.01710102,
    "CMYK_Y": 0.07559843,
    "CMYK_K": 0.1559255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05697",
    "Farbtonhilfsbezeichnung": "G2.66.66",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "185",
    "Bcolor": "24",
    "Y": 49,
    "L": 75.5806852941904,
    "a": -3.67862165334032,
    "b": 73.788177482863,
    "C": 73.8798172271082,
    "h": -1.52098375929031,
    "CMY_C": 0.1600427,
    "CMY_M": 0.2734156,
    "CMY_Y": 0.9051507,
    "CMYK_C": 0,
    "CMYK_M": 0.1349746,
    "CMYK_Y": 0.8870784,
    "CMYK_K": 0.1600427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05698",
    "Farbtonhilfsbezeichnung": "G3.51.70",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "192",
    "Bcolor": "73",
    "Y": 52,
    "L": 77.4053118330273,
    "a": -6.13299933635647,
    "b": 59.8967990282475,
    "C": 60.2099677353345,
    "h": -1.46875915784137,
    "CMY_C": 0.1676534,
    "CMY_M": 0.2471217,
    "CMY_Y": 0.7139215,
    "CMYK_C": 0,
    "CMYK_M": 0.09547499,
    "CMYK_Y": 0.6562989,
    "CMYK_K": 0.1676534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05699",
    "Farbtonhilfsbezeichnung": "G3.41.70",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "191",
    "Bcolor": "96",
    "Y": 51,
    "L": 76.8789609887127,
    "a": -5.56507504297748,
    "b": 48.7350584119813,
    "C": 49.051768353987,
    "h": -1.4570984216964,
    "CMY_C": 0.1843352,
    "CMY_M": 0.2526765,
    "CMY_Y": 0.6230488,
    "CMYK_C": 0,
    "CMYK_M": 0.08378608,
    "CMYK_Y": 0.5378602,
    "CMYK_K": 0.1843352
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05700",
    "Farbtonhilfsbezeichnung": "G3.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "206",
    "Bcolor": "177",
    "Y": 62,
    "L": 82.7095179576264,
    "a": -1.30368085681865,
    "b": 14.6653902133091,
    "C": 14.7232215864958,
    "h": -1.48213431449229,
    "CMY_C": 0.1582452,
    "CMY_M": 0.1929419,
    "CMY_Y": 0.3057365,
    "CMYK_C": 0,
    "CMYK_M": 0.04121954,
    "CMYK_Y": 0.1752188,
    "CMYK_K": 0.1582452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05701",
    "Farbtonhilfsbezeichnung": "G2.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "209",
    "Bcolor": "194",
    "Y": 64,
    "L": 83.784247648406,
    "a": -0.78067907524326,
    "b": 6.8738869113611,
    "C": 6.91807640090106,
    "h": -1.45770917730486,
    "CMY_C": 0.1647965,
    "CMY_M": 0.1804648,
    "CMY_Y": 0.2373781,
    "CMYK_C": 0,
    "CMYK_M": 0.0187599,
    "CMYK_Y": 0.08690292,
    "CMYK_K": 0.1647965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05702",
    "Farbtonhilfsbezeichnung": "G3.65.57",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "159",
    "Bcolor": "30",
    "Y": 34,
    "L": 65.035729015517,
    "a": -7.65886953365996,
    "b": 62.4562001960539,
    "C": 62.9240433019302,
    "h": -1.44877766573704,
    "CMY_C": 0.3162872,
    "CMY_M": 0.3745962,
    "CMY_Y": 0.8840345,
    "CMYK_C": 0,
    "CMYK_M": 0.08528291,
    "CMYK_Y": 0.8303887,
    "CMYK_K": 0.3162872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05703",
    "Farbtonhilfsbezeichnung": "G3.61.60",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "165",
    "Bcolor": "41",
    "Y": 37,
    "L": 67.4136481200261,
    "a": -7.00798040474915,
    "b": 61.3212156462175,
    "C": 61.7203635576076,
    "h": -1.45700687149951,
    "CMY_C": 0.2862803,
    "CMY_M": 0.3511478,
    "CMY_Y": 0.8388931,
    "CMYK_C": 0,
    "CMYK_M": 0.09088657,
    "CMYK_Y": 0.7742715,
    "CMYK_K": 0.2862803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05704",
    "Farbtonhilfsbezeichnung": "G2.44.62",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "170",
    "Bcolor": "76",
    "Y": 40,
    "L": 69.5753819296882,
    "a": -4.1786925053931,
    "b": 49.3291898729796,
    "C": 49.5058627293687,
    "h": -1.48628774031807,
    "CMY_C": 0.2570793,
    "CMY_M": 0.3333777,
    "CMY_Y": 0.7006804,
    "CMYK_C": 0,
    "CMYK_M": 0.1027006,
    "CMYK_Y": 0.5971041,
    "CMYK_K": 0.2570793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05705",
    "Farbtonhilfsbezeichnung": "G3.34.63",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "171",
    "Bcolor": "103",
    "Y": 41,
    "L": 70.1259213480923,
    "a": -2.31245216018355,
    "b": 36.8042601069348,
    "C": 36.8768355070232,
    "h": -1.50804771158483,
    "CMY_C": 0.2569158,
    "CMY_M": 0.3299953,
    "CMY_Y": 0.5966246,
    "CMYK_C": 0,
    "CMYK_M": 0.09834612,
    "CMYK_Y": 0.4571606,
    "CMYK_K": 0.2569158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05706",
    "Farbtonhilfsbezeichnung": "G3.24.63",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "172",
    "Bcolor": "122",
    "Y": 42,
    "L": 70.5810116442667,
    "a": -1.7829216669944,
    "b": 27.3238894622658,
    "C": 27.3819967317352,
    "h": -1.50563731250115,
    "CMY_C": 0.2654129,
    "CMY_M": 0.3247806,
    "CMY_Y": 0.5223092,
    "CMYK_C": 0,
    "CMYK_M": 0.08081781,
    "CMYK_Y": 0.3497153,
    "CMYK_K": 0.2654129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05707",
    "Farbtonhilfsbezeichnung": "G3.14.66",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "178",
    "Bcolor": "147",
    "Y": 45,
    "L": 72.6629060155022,
    "a": -1.91950661681989,
    "b": 16.371086521826,
    "C": 16.4832332858917,
    "h": -1.45407943598638,
    "CMY_C": 0.2680266,
    "CMY_M": 0.3002198,
    "CMY_Y": 0.4227093,
    "CMYK_C": 0,
    "CMYK_M": 0.04398136,
    "CMYK_Y": 0.2113227,
    "CMYK_K": 0.2680266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05708",
    "Farbtonhilfsbezeichnung": "G3.64.53",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "144",
    "Bcolor": "30",
    "Y": 28,
    "L": 59.8951824353343,
    "a": -4.40704884812593,
    "b": 57.501572123773,
    "C": 57.6702078742156,
    "h": -1.49430363411336,
    "CMY_C": 0.3584118,
    "CMY_M": 0.4338084,
    "CMY_Y": 0.8821416,
    "CMYK_C": 0,
    "CMYK_M": 0.1175156,
    "CMYK_Y": 0.8163021,
    "CMYK_K": 0.3584118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05709",
    "Farbtonhilfsbezeichnung": "G3.50.59",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "162",
    "Bcolor": "60",
    "Y": 36,
    "L": 66.4529820168717,
    "a": -5.70858903762073,
    "b": 52.9815878223818,
    "C": 53.2882410760685,
    "h": -1.46346374399265,
    "CMY_C": 0.2974821,
    "CMY_M": 0.3631229,
    "CMY_Y": 0.7642546,
    "CMYK_C": 0,
    "CMYK_M": 0.09343648,
    "CMYK_Y": 0.6644278,
    "CMYK_K": 0.2974821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05710",
    "Farbtonhilfsbezeichnung": "G3.42.59",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "166",
    "Bcolor": "81",
    "Y": 37,
    "L": 68.2062530517578,
    "a": -3.70111107826233,
    "b": 45.3328971862793,
    "C": 45.4837303161621,
    "h": 94.6674499511719,
    "CMY_C": 0.27454078197479,
    "CMY_M": 0.34824907779694,
    "CMY_Y": 0.68157732486725,
    "CMYK_C": 0,
    "CMYK_M": 0.10160225629807,
    "CMYK_Y": 0.56107431650162,
    "CMYK_K": 0.27454078197479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05711",
    "Farbtonhilfsbezeichnung": "G2.38.56",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "153",
    "Bcolor": "81",
    "Y": 32,
    "L": 63.2527387853026,
    "a": -2.44638057564689,
    "b": 39.0864765401032,
    "C": 39.1629598758947,
    "h": -1.50828893761407,
    "CMY_C": 0.3298856,
    "CMY_M": 0.4016394,
    "CMY_Y": 0.6808948,
    "CMYK_C": 0,
    "CMYK_M": 0.1070769,
    "CMYK_Y": 0.5238049,
    "CMYK_K": 0.3298856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05712",
    "Farbtonhilfsbezeichnung": "G3.29.58",
    "Farbtonklasse": "03",
    "Rcolor": "170",
    "Gcolor": "156",
    "Bcolor": "101",
    "Y": 33,
    "L": 64.4687399716262,
    "a": -2.9211351453135,
    "b": 30.3126953548972,
    "C": 30.4531202049313,
    "h": -1.47472625631873,
    "CMY_C": 0.3336643,
    "CMY_M": 0.3867212,
    "CMY_Y": 0.6043951,
    "CMYK_C": 0,
    "CMYK_M": 0.07962493,
    "CMYK_Y": 0.406298,
    "CMYK_K": 0.3336643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05713",
    "Farbtonhilfsbezeichnung": "G3.16.63",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "172",
    "Bcolor": "139",
    "Y": 42,
    "L": 70.5668297503955,
    "a": -1.31799040598801,
    "b": 18.0002742588173,
    "C": 18.048461765561,
    "h": -1.49770618522022,
    "CMY_C": 0.282483,
    "CMY_M": 0.3241332,
    "CMY_Y": 0.455558,
    "CMYK_C": 0,
    "CMYK_M": 0.05804761,
    "CMYK_Y": 0.2412137,
    "CMYK_K": 0.282483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05714",
    "Farbtonhilfsbezeichnung": "G3.55.52",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "143",
    "Bcolor": "49",
    "Y": 27,
    "L": 59.2469317327768,
    "a": -4.33267125598491,
    "b": 49.8915565367241,
    "C": 50.0793316036624,
    "h": -1.48417187626258,
    "CMY_C": 0.3722988,
    "CMY_M": 0.4398623,
    "CMY_Y": 0.8091395,
    "CMYK_C": 0,
    "CMYK_M": 0.1076365,
    "CMYK_Y": 0.6959373,
    "CMYK_K": 0.3722988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05715",
    "Farbtonhilfsbezeichnung": "G3.51.44",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "123",
    "Bcolor": "49",
    "Y": 20,
    "L": 51.7202655713141,
    "a": -2.96189443758399,
    "b": 41.4042766233331,
    "C": 41.510082406096,
    "h": -1.4993820251111,
    "CMY_C": 0.4546719,
    "CMY_M": 0.51737,
    "CMY_Y": 0.8093508,
    "CMYK_C": 0,
    "CMYK_M": 0.1149732,
    "CMYK_Y": 0.6503955,
    "CMYK_K": 0.4546719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05716",
    "Farbtonhilfsbezeichnung": "G3.42.50",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "140",
    "Bcolor": "68",
    "Y": 26,
    "L": 57.9094892670322,
    "a": -4.19224972986149,
    "b": 39.2751261603155,
    "C": 39.498234045413,
    "h": -1.46445838305347,
    "CMY_C": 0.3984857,
    "CMY_M": 0.4525424,
    "CMY_Y": 0.7340693,
    "CMYK_C": 0,
    "CMYK_M": 0.0898677,
    "CMYK_Y": 0.5578979,
    "CMYK_K": 0.3984857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05717",
    "Farbtonhilfsbezeichnung": "G3.21.49",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "134",
    "Bcolor": "100",
    "Y": 24,
    "L": 56.0144149773527,
    "a": -2.08147886622356,
    "b": 19.4859789716805,
    "C": 19.5968347126598,
    "h": -1.46438053828761,
    "CMY_C": 0.4380458,
    "CMY_M": 0.4731139,
    "CMY_Y": 0.6096809,
    "CMYK_C": 0,
    "CMYK_M": 0.06240395,
    "CMYK_Y": 0.3054254,
    "CMYK_K": 0.4380458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05718",
    "Farbtonhilfsbezeichnung": "G3.18.53",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "145",
    "Bcolor": "113",
    "Y": 29,
    "L": 60.3438601650198,
    "a": -1.75955225805907,
    "b": 18.1645240202632,
    "C": 18.2495467623599,
    "h": -1.47423009930846,
    "CMY_C": 0.3936762,
    "CMY_M": 0.4295461,
    "CMY_Y": 0.5586026,
    "CMYK_C": 0,
    "CMYK_M": 0.05915958,
    "CMYK_Y": 0.2720104,
    "CMYK_K": 0.3936762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05719",
    "Farbtonhilfsbezeichnung": "G2.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "145",
    "Bcolor": "128",
    "Y": 28,
    "L": 60.2114148775635,
    "a": -0.36316679205117,
    "b": 9.02834740210616,
    "C": 9.03564867245102,
    "h": -1.53059283327531,
    "CMY_C": 0.407441,
    "CMY_M": 0.4319854,
    "CMY_Y": 0.4969546,
    "CMYK_C": 0,
    "CMYK_M": 0.04142101,
    "CMYK_Y": 0.1510627,
    "CMYK_K": 0.407441
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05720",
    "Farbtonhilfsbezeichnung": "G3.03.60",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "162",
    "Bcolor": "154",
    "Y": 36,
    "L": 66.6119275842824,
    "a": -0.4838148100299,
    "b": 3.91870650439359,
    "C": 3.94846013503757,
    "h": -1.44795508466417,
    "CMY_C": 0.3560513,
    "CMY_M": 0.3642714,
    "CMY_Y": 0.3969658,
    "CMYK_C": 0,
    "CMYK_M": 0.01276518,
    "CMYK_Y": 0.06353695,
    "CMYK_K": 0.3560513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05721",
    "Farbtonhilfsbezeichnung": "G2.58.43",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "123",
    "Bcolor": "38",
    "Y": 20,
    "L": 51.5765349814764,
    "a": -3.06704476375647,
    "b": 46.1555902723115,
    "C": 46.2573807837018,
    "h": -1.50444374918511,
    "CMY_C": 0.4519517,
    "CMY_M": 0.5190506,
    "CMY_Y": 0.8519733,
    "CMYK_C": 0,
    "CMYK_M": 0.1224325,
    "CMYK_Y": 0.7299021,
    "CMYK_K": 0.4519517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05722",
    "Farbtonhilfsbezeichnung": "G2.43.43",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "123",
    "Bcolor": "63",
    "Y": 20,
    "L": 51.8733895341954,
    "a": -2.31383303704302,
    "b": 34.4019304194786,
    "C": 34.479655449409,
    "h": -1.50363865910957,
    "CMY_C": 0.4576759,
    "CMY_M": 0.5163807,
    "CMY_Y": 0.7536559,
    "CMYK_C": 0,
    "CMYK_M": 0.1082467,
    "CMYK_Y": 0.5457622,
    "CMYK_K": 0.4576759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05723",
    "Farbtonhilfsbezeichnung": "G2.41.46",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "130",
    "Bcolor": "66",
    "Y": 22,
    "L": 54.2544018077341,
    "a": -2.65706859713605,
    "b": 35.6696926354541,
    "C": 35.7685194862418,
    "h": -1.49644272020464,
    "CMY_C": 0.432889,
    "CMY_M": 0.4921149,
    "CMY_Y": 0.7409097,
    "CMYK_C": 0,
    "CMYK_M": 0.1044344,
    "CMYK_Y": 0.5431401,
    "CMYK_K": 0.432889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05724",
    "Farbtonhilfsbezeichnung": "G3.31.43",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "123",
    "Bcolor": "78",
    "Y": 20,
    "L": 51.6972110703316,
    "a": -1.90535646404438,
    "b": 25.6115003830032,
    "C": 25.6822766732945,
    "h": -1.4965385533523,
    "CMY_C": 0.470183,
    "CMY_M": 0.5177305,
    "CMY_Y": 0.6925884,
    "CMYK_C": 0,
    "CMYK_M": 0.0897434,
    "CMYK_Y": 0.4197779,
    "CMYK_K": 0.470183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05725",
    "Farbtonhilfsbezeichnung": "G3.20.43",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "123",
    "Bcolor": "94",
    "Y": 20,
    "L": 51.5874713126696,
    "a": -1.43281895131475,
    "b": 16.5475016551103,
    "C": 16.6094184477701,
    "h": -1.48442352322162,
    "CMY_C": 0.4853016,
    "CMY_M": 0.518244,
    "CMY_Y": 0.6318297,
    "CMYK_C": 0,
    "CMYK_M": 0.06400323,
    "CMYK_Y": 0.2846874,
    "CMYK_K": 0.4853016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05726",
    "Farbtonhilfsbezeichnung": "G3.11.34",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "100",
    "Bcolor": "86",
    "Y": 13,
    "L": 42.1418272250126,
    "a": -1.01725218657392,
    "b": 7.61615654440706,
    "C": 7.68379089512487,
    "h": -1.43801715065717,
    "CMY_C": 0.5963088,
    "CMY_M": 0.6094475,
    "CMY_Y": 0.6618701,
    "CMYK_C": 0,
    "CMYK_M": 0.03254652,
    "CMYK_Y": 0.1624046,
    "CMYK_K": 0.5963088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05727",
    "Farbtonhilfsbezeichnung": "G2.07.39",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "107",
    "Bcolor": "97",
    "Y": 15,
    "L": 45.5023984576998,
    "a": -0.08097845763227,
    "b": 5.99908832570417,
    "C": 5.99963484307175,
    "h": -1.55729868591112,
    "CMY_C": 0.5615447,
    "CMY_M": 0.578627,
    "CMY_Y": 0.6198135,
    "CMYK_C": 0,
    "CMYK_M": 0.03896014,
    "CMYK_Y": 0.1328957,
    "CMYK_K": 0.5615447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05728",
    "Farbtonhilfsbezeichnung": "G3.51.38",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "109",
    "Bcolor": "41",
    "Y": 15,
    "L": 45.854836892683,
    "a": -3.39386093413463,
    "b": 38.2608231422121,
    "C": 38.411051528953,
    "h": -1.48232459074092,
    "CMY_C": 0.5224898,
    "CMY_M": 0.5735851,
    "CMY_Y": 0.8394499,
    "CMYK_C": 0,
    "CMYK_M": 0.1070036,
    "CMYK_Y": 0.6637768,
    "CMYK_K": 0.5224898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05729",
    "Farbtonhilfsbezeichnung": "G3.43.30",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "95",
    "Bcolor": "51",
    "Y": 11,
    "L": 40.106035462984,
    "a": -3.0865048654623,
    "b": 26.1394590266293,
    "C": 26.3210529897524,
    "h": -1.45326217488155,
    "CMY_C": 0.5941027,
    "CMY_M": 0.6278476,
    "CMY_Y": 0.8018003,
    "CMYK_C": 0,
    "CMYK_M": 0.08313642,
    "CMYK_Y": 0.5116998,
    "CMYK_K": 0.5941027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05730",
    "Farbtonhilfsbezeichnung": "G2.12.12",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "48",
    "Bcolor": "38",
    "Y": 3,
    "L": 19.5715212343938,
    "a": -0.87606429759767,
    "b": 6.07376171088028,
    "C": 6.1366171441667,
    "h": -1.42754676941242,
    "CMY_C": 0.805304,
    "CMY_M": 0.8137223,
    "CMY_Y": 0.8503181,
    "CMYK_C": 0,
    "CMYK_M": 0.04323845,
    "CMYK_Y": 0.2312024,
    "CMYK_K": 0.805304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05731",
    "Farbtonhilfsbezeichnung": "G2.12.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "80",
    "Bcolor": "68",
    "Y": 8,
    "L": 33.9363238676542,
    "a": -0.81190201149805,
    "b": 7.02861736665669,
    "C": 7.07535490015466,
    "h": -1.4557922765689,
    "CMY_C": 0.6742322,
    "CMY_M": 0.6868278,
    "CMY_Y": 0.7329433,
    "CMYK_C": 0,
    "CMYK_M": 0.0386643,
    "CMYK_Y": 0.1802238,
    "CMYK_K": 0.6742322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05732",
    "Farbtonhilfsbezeichnung": "G2.18.23",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "77",
    "Bcolor": "62",
    "Y": 7,
    "L": 32.4844578803482,
    "a": -1.09070678293011,
    "b": 8.85262130731803,
    "C": 8.91955970309695,
    "h": -1.44820692744512,
    "CMY_C": 0.6853908,
    "CMY_M": 0.6999693,
    "CMY_Y": 0.7570614,
    "CMYK_C": 0,
    "CMYK_M": 0.04633838,
    "CMYK_Y": 0.2278082,
    "CMYK_K": 0.6853908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05733",
    "Farbtonhilfsbezeichnung": "G2.25.33",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "97",
    "Bcolor": "68",
    "Y": 12,
    "L": 41.1838022705952,
    "a": -0.93632746054717,
    "b": 17.231315526942,
    "C": 17.2567361891641,
    "h": -1.51651100394552,
    "CMY_C": 0.5848759,
    "CMY_M": 0.6205749,
    "CMY_Y": 0.7324794,
    "CMYK_C": 0,
    "CMYK_M": 0.0859959,
    "CMYK_Y": 0.3555647,
    "CMYK_K": 0.5848759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05734",
    "Farbtonhilfsbezeichnung": "G3.36.33",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "99",
    "Bcolor": "59",
    "Y": 12,
    "L": 41.7815765075398,
    "a": -2.31907590809663,
    "b": 23.205704832256,
    "C": 23.3212960580948,
    "h": -1.47119144253661,
    "CMY_C": 0.5772309,
    "CMY_M": 0.6130368,
    "CMY_Y": 0.7668183,
    "CMYK_C": 0,
    "CMYK_M": 0.08469351,
    "CMYK_Y": 0.4484421,
    "CMYK_K": 0.5772309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05735",
    "Farbtonhilfsbezeichnung": "G3.43.36",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "104",
    "Bcolor": "51",
    "Y": 14,
    "L": 43.7939390090407,
    "a": -3.46266505690418,
    "b": 30.51522952804,
    "C": 30.7110612393201,
    "h": -1.45780629211787,
    "CMY_C": 0.5533218,
    "CMY_M": 0.5924611,
    "CMY_Y": 0.7996733,
    "CMYK_C": 0,
    "CMYK_M": 0.08762288,
    "CMYK_Y": 0.5515189,
    "CMYK_K": 0.5533218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05736",
    "Farbtonhilfsbezeichnung": "W6.22.34",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "92",
    "Bcolor": "133",
    "Y": 13,
    "L": 42.4003760078741,
    "a": 16.2325180209851,
    "b": -20.4208206542273,
    "C": 26.0864822751885,
    "h": -0.89917265577819,
    "CMY_C": 0.5660185,
    "CMY_M": 0.6378854,
    "CMY_Y": 0.4790439,
    "CMYK_C": 0.1669519,
    "CMYK_M": 0.3049039,
    "CMYK_Y": 0,
    "CMYK_K": 0.4790439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05737",
    "Farbtonhilfsbezeichnung": "W4.17.49",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "132",
    "Bcolor": "169",
    "Y": 26,
    "L": 57.6258103615649,
    "a": 13.7358294675647,
    "b": -18.4263701705945,
    "C": 22.9826919403666,
    "h": -0.93021735715118,
    "CMY_C": 0.4218923,
    "CMY_M": 0.48314,
    "CMY_Y": 0.3358015,
    "CMYK_C": 0.1296161,
    "CMYK_M": 0.221829,
    "CMYK_Y": 0,
    "CMYK_K": 0.3358015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05738",
    "Farbtonhilfsbezeichnung": "G5.37.84",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "231",
    "Bcolor": "125",
    "Y": 79,
    "L": 91.1262311422066,
    "a": -6.99162558341931,
    "b": 52.5216342003374,
    "C": 52.9849496307468,
    "h": -1.43845542434547,
    "CMY_C": 0.02391897,
    "CMY_M": 0.09415277,
    "CMY_Y": 0.5082719,
    "CMYK_C": 0,
    "CMYK_M": 0.07195489,
    "CMYK_Y": 0.496222,
    "CMYK_K": 0.02391897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05739",
    "Farbtonhilfsbezeichnung": "G5.13.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "237",
    "Bcolor": "199",
    "Y": 84,
    "L": 93.5517297897896,
    "a": -2.39883704152272,
    "b": 18.9062610877633,
    "C": 19.0578363795698,
    "h": -1.44459013206481,
    "CMY_C": 0.03349461,
    "CMY_M": 0.07137164,
    "CMY_Y": 0.2213805,
    "CMYK_C": 0,
    "CMYK_M": 0.03918967,
    "CMYK_Y": 0.1943972,
    "CMYK_K": 0.03349461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05740",
    "Farbtonhilfsbezeichnung": "G4.41.84",
    "Farbtonklasse": "02",
    "Rcolor": "252",
    "Gcolor": "229",
    "Bcolor": "115",
    "Y": 78,
    "L": 90.7378567701009,
    "a": -5.74075639753296,
    "b": 57.1925267285139,
    "C": 57.4799216910357,
    "h": -1.47075542246951,
    "CMY_C": 0.0128148,
    "CMY_M": 0.1020048,
    "CMY_Y": 0.5508065,
    "CMYK_C": 0,
    "CMYK_M": 0.09034782,
    "CMYK_Y": 0.5449754,
    "CMYK_K": 0.0128148
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05741",
    "Farbtonhilfsbezeichnung": "G5.57.45",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "123",
    "Bcolor": "41",
    "Y": 19,
    "L": 50.9989265320583,
    "a": -7.31107328463221,
    "b": 43.6860753038526,
    "C": 44.2936222048631,
    "h": -1.40497821378001,
    "CMY_C": 0.4860475,
    "CMY_M": 0.5159485,
    "CMY_Y": 0.8372668,
    "CMYK_C": 0,
    "CMYK_M": 0.05817861,
    "CMYK_Y": 0.6833692,
    "CMYK_K": 0.4860475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05742",
    "Farbtonhilfsbezeichnung": "G5.51.38",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "111",
    "Bcolor": "47",
    "Y": 16,
    "L": 46.5169826989163,
    "a": -5.26834105862212,
    "b": 35.8894051449095,
    "C": 36.2740240277449,
    "h": -1.42504352242002,
    "CMY_C": 0.5294336,
    "CMY_M": 0.5631704,
    "CMY_Y": 0.8152474,
    "CMYK_C": 0,
    "CMYK_M": 0.07169396,
    "CMYK_Y": 0.6073824,
    "CMYK_K": 0.5294336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05743",
    "Farbtonhilfsbezeichnung": "G5.45.30",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "92",
    "Bcolor": "45",
    "Y": 11,
    "L": 38.9392038468668,
    "a": -3.79171313396279,
    "b": 27.980206724105,
    "C": 28.2359532655428,
    "h": -1.43610271394293,
    "CMY_C": 0.6073387,
    "CMY_M": 0.6377279,
    "CMY_Y": 0.82507,
    "CMYK_C": 0,
    "CMYK_M": 0.07739311,
    "CMYK_Y": 0.5545017,
    "CMYK_K": 0.6073387
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05745",
    "Farbtonhilfsbezeichnung": "G4.31.22",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "73",
    "Bcolor": "47",
    "Y": 7,
    "L": 30.8856846725548,
    "a": -1.93477198556283,
    "b": 16.0214324006445,
    "C": 16.137832531184,
    "h": -1.4506167922091,
    "CMY_C": 0.6917516,
    "CMY_M": 0.7141268,
    "CMY_Y": 0.8153471,
    "CMYK_C": 0,
    "CMYK_M": 0.07258812,
    "CMYK_Y": 0.4009607,
    "CMYK_K": 0.6917516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05746",
    "Farbtonhilfsbezeichnung": "G5.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "60",
    "Bcolor": "50",
    "Y": 4,
    "L": 24.9914810797026,
    "a": -1.17974488611816,
    "b": 5.67497593694177,
    "C": 5.79630484715824,
    "h": -1.36583023535073,
    "CMY_C": 0.7607427,
    "CMY_M": 0.7663642,
    "CMY_Y": 0.8028717,
    "CMYK_C": 0,
    "CMYK_M": 0.02349563,
    "CMYK_Y": 0.1760824,
    "CMYK_K": 0.7607427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05747",
    "Farbtonhilfsbezeichnung": "G5.09.20",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "64",
    "Bcolor": "56",
    "Y": 5,
    "L": 26.9421592566166,
    "a": -1.31181453846982,
    "b": 4.99065032278109,
    "C": 5.16017906933623,
    "h": -1.31375644469675,
    "CMY_C": 0.7457899,
    "CMY_M": 0.7487668,
    "CMY_Y": 0.7821419,
    "CMYK_C": 0,
    "CMYK_M": 0.01171029,
    "CMYK_Y": 0.1429997,
    "CMYK_K": 0.7457899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05748",
    "Farbtonhilfsbezeichnung": "G5.08.31",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "90",
    "Bcolor": "80",
    "Y": 10,
    "L": 38.3019673769542,
    "a": -0.92422911589606,
    "b": 6.02803190427211,
    "C": 6.09847260366008,
    "h": -1.41865920170033,
    "CMY_C": 0.6363264,
    "CMY_M": 0.6457444,
    "CMY_Y": 0.6872371,
    "CMYK_C": 0,
    "CMYK_M": 0.02589688,
    "CMYK_Y": 0.1399901,
    "CMYK_K": 0.6363264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05749",
    "Farbtonhilfsbezeichnung": "G4.61.47",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "134",
    "Bcolor": "42",
    "Y": 23,
    "L": 55.3226826175862,
    "a": -6.7155900766514,
    "b": 48.3083990480866,
    "C": 48.7729491487525,
    "h": -1.43266662177424,
    "CMY_C": 0.4313039,
    "CMY_M": 0.4744385,
    "CMY_Y": 0.8355993,
    "CMYK_C": 0,
    "CMYK_M": 0.07584829,
    "CMYK_Y": 0.7109165,
    "CMYK_K": 0.4313039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05750",
    "Farbtonhilfsbezeichnung": "G4.50.44",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "122",
    "Bcolor": "52",
    "Y": 19,
    "L": 51.1213933754195,
    "a": -4.39582444312148,
    "b": 39.1378010581932,
    "C": 39.3838893991623,
    "h": -1.45894848356149,
    "CMY_C": 0.4722223,
    "CMY_M": 0.5200968,
    "CMY_Y": 0.7973284,
    "CMYK_C": 0,
    "CMYK_M": 0.09070961,
    "CMYK_Y": 0.6159906,
    "CMYK_K": 0.4722223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05751",
    "Farbtonhilfsbezeichnung": "G5.49.43",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "119",
    "Bcolor": "49",
    "Y": 18,
    "L": 49.2940728845642,
    "a": -6.90923486708611,
    "b": 38.098313148721,
    "C": 38.7197493693666,
    "h": -1.39139337628604,
    "CMY_C": 0.5079145,
    "CMY_M": 0.5330015,
    "CMY_Y": 0.8071167,
    "CMYK_C": 0,
    "CMYK_M": 0.0509808,
    "CMYK_Y": 0.6080289,
    "CMYK_K": 0.5079145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05752",
    "Farbtonhilfsbezeichnung": "G5.31.40",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "115",
    "Bcolor": "71",
    "Y": 17,
    "L": 48.0516532365881,
    "a": -3.46261861432379,
    "b": 25.1386092050975,
    "C": 25.3759610741126,
    "h": -1.43391658749626,
    "CMY_C": 0.5180237,
    "CMY_M": 0.5503931,
    "CMY_Y": 0.7233729,
    "CMYK_C": 0,
    "CMYK_M": 0.06715981,
    "CMYK_Y": 0.4260567,
    "CMYK_K": 0.5180237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05753",
    "Farbtonhilfsbezeichnung": "G5.22.35",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "96",
    "Bcolor": "66",
    "Y": 12,
    "L": 40.4102409234059,
    "a": -2.97117083885193,
    "b": 17.1926764116067,
    "C": 17.4475206934355,
    "h": -1.39967047395374,
    "CMY_C": 0.6049451,
    "CMY_M": 0.6238717,
    "CMY_Y": 0.7395442,
    "CMYK_C": 0,
    "CMYK_M": 0.04790878,
    "CMYK_Y": 0.3407097,
    "CMYK_K": 0.6049451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05754",
    "Farbtonhilfsbezeichnung": "G4.13.24",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "76",
    "Bcolor": "64",
    "Y": 7,
    "L": 32.1267207981099,
    "a": -1.3834766575449,
    "b": 7.2370990400371,
    "C": 7.36814835472777,
    "h": -1.38191066271023,
    "CMY_C": 0.6940531,
    "CMY_M": 0.7023671,
    "CMY_Y": 0.7503719,
    "CMYK_C": 0,
    "CMYK_M": 0.02717471,
    "CMYK_Y": 0.1840804,
    "CMYK_K": 0.6940531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05755",
    "Farbtonhilfsbezeichnung": "G4.07.40",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "111",
    "Bcolor": "100",
    "Y": 16,
    "L": 46.8740025634152,
    "a": -1.15756031770087,
    "b": 5.99725308301022,
    "C": 6.10794486147275,
    "h": -1.38012596309094,
    "CMY_C": 0.5552779,
    "CMY_M": 0.5630559,
    "CMY_Y": 0.6069118,
    "CMYK_C": 0,
    "CMYK_M": 0.01748963,
    "CMYK_Y": 0.1161037,
    "CMYK_K": 0.5552779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05756",
    "Farbtonhilfsbezeichnung": "G4.56.51",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "141",
    "Bcolor": "48",
    "Y": 26,
    "L": 58.053654670996,
    "a": -6.73494006187236,
    "b": 48.9286001352505,
    "C": 49.3899516990273,
    "h": -1.4340075902684,
    "CMY_C": 0.4011347,
    "CMY_M": 0.4468863,
    "CMY_Y": 0.8135043,
    "CMYK_C": 0,
    "CMYK_M": 0.07639708,
    "CMYK_Y": 0.6885849,
    "CMYK_K": 0.4011347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05757",
    "Farbtonhilfsbezeichnung": "G5.56.48",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "137",
    "Bcolor": "44",
    "Y": 24,
    "L": 56.2053878402156,
    "a": -8.24019970853129,
    "b": 48.2656868474587,
    "C": 48.9640420930853,
    "h": -1.40170080639481,
    "CMY_C": 0.4312109,
    "CMY_M": 0.462481,
    "CMY_Y": 0.8268567,
    "CMYK_C": 0,
    "CMYK_M": 0.05497666,
    "CMYK_Y": 0.6955932,
    "CMYK_K": 0.4312109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05758",
    "Farbtonhilfsbezeichnung": "G4.51.50",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "140",
    "Bcolor": "56",
    "Y": 26,
    "L": 57.8571148622124,
    "a": -5.26918615843075,
    "b": 45.1744519126834,
    "C": 45.4807149062495,
    "h": -1.45468017677326,
    "CMY_C": 0.3983929,
    "CMY_M": 0.4515127,
    "CMY_Y": 0.7821102,
    "CMYK_C": 0,
    "CMYK_M": 0.08829644,
    "CMYK_Y": 0.6378205,
    "CMYK_K": 0.3983929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05759",
    "Farbtonhilfsbezeichnung": "G4.45.52",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "144",
    "Bcolor": "66",
    "Y": 27,
    "L": 59.1674942498091,
    "a": -6.29479867503391,
    "b": 41.4343780904218,
    "C": 41.9098100460886,
    "h": -1.42002708464348,
    "CMY_C": 0.3952635,
    "CMY_M": 0.4356449,
    "CMY_Y": 0.7394546,
    "CMYK_C": 0,
    "CMYK_M": 0.06677514,
    "CMYK_Y": 0.5691588,
    "CMYK_K": 0.3952635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05760",
    "Farbtonhilfsbezeichnung": "G4.38.45",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "127",
    "Bcolor": "69",
    "Y": 21,
    "L": 52.7587423467809,
    "a": -4.74583888631969,
    "b": 32.2236111299703,
    "C": 32.5712158353116,
    "h": -1.42456923873199,
    "CMY_C": 0.466415,
    "CMY_M": 0.5022677,
    "CMY_Y": 0.7301244,
    "CMYK_C": 0,
    "CMYK_M": 0.06719212,
    "CMYK_Y": 0.4942219,
    "CMYK_K": 0.466415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05761",
    "Farbtonhilfsbezeichnung": "G5.28.50",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "136",
    "Bcolor": "90",
    "Y": 24,
    "L": 56.3985429487444,
    "a": -4.3827766842186,
    "b": 25.5631344326878,
    "C": 25.936124874148,
    "h": -1.40099809927117,
    "CMY_C": 0.43724,
    "CMY_M": 0.465469,
    "CMY_Y": 0.6485136,
    "CMYK_C": 0,
    "CMYK_M": 0.05016174,
    "CMYK_Y": 0.3754239,
    "CMYK_K": 0.43724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05762",
    "Farbtonhilfsbezeichnung": "G5.10.49",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "134",
    "Bcolor": "117",
    "Y": 24,
    "L": 55.7270078006765,
    "a": -1.86071114201802,
    "b": 9.07030478486064,
    "C": 9.25919407099213,
    "h": -1.36846033090812,
    "CMY_C": 0.4636277,
    "CMY_M": 0.4743596,
    "CMY_Y": 0.5417699,
    "CMYK_C": 0,
    "CMYK_M": 0.0200082,
    "CMYK_Y": 0.1456865,
    "CMYK_K": 0.4636277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05764",
    "Farbtonhilfsbezeichnung": "G4.53.59",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "165",
    "Bcolor": "61",
    "Y": 37,
    "L": 67.0739082428626,
    "a": -7.22860331303121,
    "b": 53.1017386094478,
    "C": 53.5914857902194,
    "h": -1.43550051242899,
    "CMY_C": 0.3000302,
    "CMY_M": 0.3534308,
    "CMY_Y": 0.7596021,
    "CMYK_C": 0,
    "CMYK_M": 0.07628995,
    "CMYK_Y": 0.6565596,
    "CMYK_K": 0.3000302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05765",
    "Farbtonhilfsbezeichnung": "G5.43.63",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "176",
    "Bcolor": "84",
    "Y": 43,
    "L": 71.2695767561938,
    "a": -6.87098155826771,
    "b": 47.7712420139408,
    "C": 48.26284234407,
    "h": -1.42794510363038,
    "CMY_C": 0.2575153,
    "CMY_M": 0.3094806,
    "CMY_Y": 0.6718571,
    "CMYK_C": 0,
    "CMYK_M": 0.06998833,
    "CMYK_Y": 0.5580476,
    "CMYK_K": 0.2575153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05766",
    "Farbtonhilfsbezeichnung": "G5.34.55",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "151",
    "Bcolor": "87",
    "Y": 30,
    "L": 61.692188686773,
    "a": -5.84770942499013,
    "b": 33.7639406166509,
    "C": 34.2665929366175,
    "h": -1.3993036028935,
    "CMY_C": 0.3766637,
    "CMY_M": 0.4096921,
    "CMY_Y": 0.6570469,
    "CMYK_C": 0,
    "CMYK_M": 0.0529866,
    "CMYK_Y": 0.4498105,
    "CMYK_K": 0.3766637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05767",
    "Farbtonhilfsbezeichnung": "G4.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "163",
    "Bcolor": "122",
    "Y": 37,
    "L": 66.9543191622454,
    "a": -2.75931926773937,
    "b": 21.9215017096437,
    "C": 22.0944807593939,
    "h": -1.4455821212824,
    "CMY_C": 0.3223208,
    "CMY_M": 0.3597019,
    "CMY_Y": 0.5199133,
    "CMYK_C": 0,
    "CMYK_M": 0.05516043,
    "CMYK_Y": 0.2915723,
    "CMYK_K": 0.3223208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05768",
    "Farbtonhilfsbezeichnung": "G4.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "164",
    "Bcolor": "143",
    "Y": 37,
    "L": 67.1754464245051,
    "a": -1.2597282796869,
    "b": 10.8122687303232,
    "C": 10.8854063054793,
    "h": -1.45481010052955,
    "CMY_C": 0.336201,
    "CMY_M": 0.3583341,
    "CMY_Y": 0.4393274,
    "CMYK_C": 0,
    "CMYK_M": 0.0333431,
    "CMYK_Y": 0.155358,
    "CMYK_K": 0.336201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05770",
    "Farbtonhilfsbezeichnung": "G5.05.64",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "174",
    "Bcolor": "161",
    "Y": 42,
    "L": 70.9631161409949,
    "a": -0.61798912242189,
    "b": 6.06765649534111,
    "C": 6.09904631076753,
    "h": -1.46929660455968,
    "CMY_C": 0.3047148,
    "CMY_M": 0.3187512,
    "CMY_Y": 0.3670492,
    "CMYK_C": 0,
    "CMYK_M": 0.02018799,
    "CMYK_Y": 0.08965297,
    "CMYK_K": 0.3047148
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05771",
    "Farbtonhilfsbezeichnung": "G4.65.67",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "182",
    "Bcolor": "0",
    "Y": 46,
    "L": 73.2672487508906,
    "a": -9.70246843273209,
    "b": 74.7614191673305,
    "C": 75.3883790089789,
    "h": -1.44173857430526,
    "CMY_C": 0.2244552,
    "CMY_M": 0.2848964,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.07793386,
    "CMYK_Y": 1,
    "CMYK_K": 0.2244552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05772",
    "Farbtonhilfsbezeichnung": "G5.60.68",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "185",
    "Bcolor": "33",
    "Y": 47,
    "L": 74.2450190759725,
    "a": -10.42958543263,
    "b": 70.1518484943742,
    "C": 70.9229025031701,
    "h": -1.42320583003357,
    "CMY_C": 0.2215851,
    "CMY_M": 0.2726072,
    "CMY_Y": 0.8701321,
    "CMYK_C": 0,
    "CMYK_M": 0.06554616,
    "CMYK_Y": 0.8331636,
    "CMYK_K": 0.2215851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05773",
    "Farbtonhilfsbezeichnung": "G4.51.70",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "186",
    "Bcolor": "64",
    "Y": 48,
    "L": 74.8472620178078,
    "a": -8.56101637158085,
    "b": 60.5021469190909,
    "C": 61.1048343679429,
    "h": -1.43023013046312,
    "CMY_C": 0.2122103,
    "CMY_M": 0.2692767,
    "CMY_Y": 0.7479628,
    "CMYK_C": 0,
    "CMYK_M": 0.0724386,
    "CMYK_Y": 0.6800705,
    "CMYK_K": 0.2122103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05774",
    "Farbtonhilfsbezeichnung": "G4.28.67",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "181",
    "Bcolor": "119",
    "Y": 46,
    "L": 73.5317581047004,
    "a": -4.03730332088303,
    "b": 32.6360398320014,
    "C": 32.8848128171774,
    "h": -1.44771474022709,
    "CMY_C": 0.2380281,
    "CMY_M": 0.2894138,
    "CMY_Y": 0.5321729,
    "CMYK_C": 0,
    "CMYK_M": 0.06743776,
    "CMYK_Y": 0.386031,
    "CMYK_K": 0.2380281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05775",
    "Farbtonhilfsbezeichnung": "G5.19.72",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "198",
    "Bcolor": "148",
    "Y": 56,
    "L": 79.5171453566258,
    "a": -3.48859414006597,
    "b": 25.6537342879813,
    "C": 25.8898507526105,
    "h": -1.43563763522263,
    "CMY_C": 0.1823645,
    "CMY_M": 0.2250539,
    "CMY_Y": 0.4198602,
    "CMYK_C": 0,
    "CMYK_M": 0.0522108,
    "CMYK_Y": 0.2904665,
    "CMYK_K": 0.1823645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05776",
    "Farbtonhilfsbezeichnung": "G4.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 55,
    "L": 78.9369033060342,
    "a": -0.90243756878416,
    "b": 8.20494634137181,
    "C": 8.2544253603957,
    "h": -1.46124962829834,
    "CMY_C": 0.2147609,
    "CMY_M": 0.2333005,
    "CMY_Y": 0.2987328,
    "CMYK_C": 0,
    "CMYK_M": 0.02361011,
    "CMYK_Y": 0.106938,
    "CMYK_K": 0.2147609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05777",
    "Farbtonhilfsbezeichnung": "G5.04.68",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "184",
    "Bcolor": "173",
    "Y": 48,
    "L": 74.627779397983,
    "a": -0.6585833146977,
    "b": 4.95577172111481,
    "C": 4.99934048992459,
    "h": -1.43867826571392,
    "CMY_C": 0.2692125,
    "CMY_M": 0.2793828,
    "CMY_Y": 0.3208969,
    "CMYK_C": 0,
    "CMYK_M": 0.01391691,
    "CMYK_Y": 0.07072432,
    "CMYK_K": 0.2692125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05778",
    "Farbtonhilfsbezeichnung": "G4.65.72",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "201",
    "Bcolor": "10",
    "Y": 56,
    "L": 79.7505092953884,
    "a": -10.9192679784015,
    "b": 79.0709728767226,
    "C": 79.821357823928,
    "h": -1.43356972358808,
    "CMY_C": 0.1526058,
    "CMY_M": 0.2131749,
    "CMY_Y": 0.962509,
    "CMYK_C": 0,
    "CMYK_M": 0.07147697,
    "CMYK_Y": 0.9557574,
    "CMYK_K": 0.1526058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05779",
    "Farbtonhilfsbezeichnung": "G5.51.70",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "193",
    "Bcolor": "72",
    "Y": 51,
    "L": 76.9326171624199,
    "a": -10.5054888246692,
    "b": 59.725950630467,
    "C": 60.6428435527081,
    "h": -1.39668250535022,
    "CMY_C": 0.2019987,
    "CMY_M": 0.2426925,
    "CMY_Y": 0.7191745,
    "CMYK_C": 0,
    "CMYK_M": 0.05099467,
    "CMYK_Y": 0.6480889,
    "CMYK_K": 0.2019987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05780",
    "Farbtonhilfsbezeichnung": "G4.43.72",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "200",
    "Bcolor": "94",
    "Y": 57,
    "L": 80.3324514729389,
    "a": -6.60138626828094,
    "b": 54.149926808256,
    "C": 54.5508283530373,
    "h": -1.44948551162228,
    "CMY_C": 0.1441569,
    "CMY_M": 0.2138357,
    "CMY_Y": 0.6330733,
    "CMYK_C": 0,
    "CMYK_M": 0.08141539,
    "CMYK_Y": 0.5712687,
    "CMYK_K": 0.1441569
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05781",
    "Farbtonhilfsbezeichnung": "G4.37.66",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "182",
    "Bcolor": "99",
    "Y": 46,
    "L": 73.7469409853688,
    "a": -4.67593091313878,
    "b": 43.4842032729791,
    "C": 43.7348861229821,
    "h": -1.46367622632355,
    "CMY_C": 0.2215699,
    "CMY_M": 0.2874029,
    "CMY_Y": 0.6124264,
    "CMYK_C": 0,
    "CMYK_M": 0.08457144,
    "CMYK_Y": 0.5021087,
    "CMYK_K": 0.2215699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05782",
    "Farbtonhilfsbezeichnung": "G5.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "220",
    "Bcolor": "194",
    "Y": 71,
    "L": 87.5700580407384,
    "a": -1.25317619829374,
    "b": 12.8473800496767,
    "C": 12.9083548419154,
    "h": -1.47356061039804,
    "CMY_C": 0.1088841,
    "CMY_M": 0.1392116,
    "CMY_Y": 0.2405652,
    "CMYK_C": 0,
    "CMYK_M": 0.03403312,
    "CMYK_Y": 0.1477709,
    "CMYK_K": 0.1088841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05783",
    "Farbtonhilfsbezeichnung": "G4.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "207",
    "Bcolor": "185",
    "Y": 62,
    "L": 83.1446004363457,
    "a": -0.8716224382736,
    "b": 11.1033379260538,
    "C": 11.137496970821,
    "h": -1.49245604685671,
    "CMY_C": 0.1600761,
    "CMY_M": 0.1883286,
    "CMY_Y": 0.2750626,
    "CMYK_C": 0,
    "CMYK_M": 0.03363696,
    "CMYK_Y": 0.136901,
    "CMYK_K": 0.1600761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05784",
    "Farbtonhilfsbezeichnung": "G4.06.76",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "207",
    "Bcolor": "190",
    "Y": 62,
    "L": 83.1024530594242,
    "a": -1.19187861147574,
    "b": 8.36639690259067,
    "C": 8.45086810666053,
    "h": -1.42928829363675,
    "CMY_C": 0.1708967,
    "CMY_M": 0.1873596,
    "CMY_Y": 0.255621,
    "CMYK_C": 0,
    "CMYK_M": 0.01985637,
    "CMYK_Y": 0.1021879,
    "CMYK_K": 0.1708967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05785",
    "Farbtonhilfsbezeichnung": "G4.61.70",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "191",
    "Bcolor": "34",
    "Y": 51,
    "L": 76.545390066523,
    "a": -8.24667044910793,
    "b": 72.2427482486586,
    "C": 72.7119126967188,
    "h": -1.45713608991512,
    "CMY_C": 0.1788616,
    "CMY_M": 0.2528838,
    "CMY_Y": 0.8667241,
    "CMYK_C": 0,
    "CMYK_M": 0.09014579,
    "CMYK_Y": 0.8376938,
    "CMYK_K": 0.1788616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05786",
    "Farbtonhilfsbezeichnung": "G4.45.75",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "205",
    "Bcolor": "90",
    "Y": 60,
    "L": 81.9882722304782,
    "a": -6.44740167765495,
    "b": 57.7490939652908,
    "C": 58.1078896726169,
    "h": -1.45961168870919,
    "CMY_C": 0.119226,
    "CMY_M": 0.1966531,
    "CMY_Y": 0.6468652,
    "CMYK_C": 0,
    "CMYK_M": 0.08790809,
    "CMYK_Y": 0.5990631,
    "CMYK_K": 0.119226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05787",
    "Farbtonhilfsbezeichnung": "G5.36.76",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "209",
    "Bcolor": "117",
    "Y": 63,
    "L": 83.3289023285671,
    "a": -6.75839820437141,
    "b": 46.589127746571,
    "C": 47.0767752769363,
    "h": -1.42673737118486,
    "CMY_C": 0.1221029,
    "CMY_M": 0.1798378,
    "CMY_Y": 0.5407633,
    "CMYK_C": 0,
    "CMYK_M": 0.06576497,
    "CMYK_Y": 0.47689,
    "CMYK_K": 0.1221029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05788",
    "Farbtonhilfsbezeichnung": "G4.26.75",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "204",
    "Bcolor": "141",
    "Y": 60,
    "L": 82.0722884191864,
    "a": -3.6620764914681,
    "b": 33.0715351281303,
    "C": 33.273671873728,
    "h": -1.46051363098674,
    "CMY_C": 0.1394337,
    "CMY_M": 0.198313,
    "CMY_Y": 0.4487442,
    "CMYK_C": 0,
    "CMYK_M": 0.06841923,
    "CMYK_Y": 0.3594267,
    "CMYK_K": 0.1394337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05789",
    "Farbtonhilfsbezeichnung": "G4.18.80",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "220",
    "Bcolor": "171",
    "Y": 71,
    "L": 87.5863874298494,
    "a": -2.52336463727854,
    "b": 25.0766589891827,
    "C": 25.2032973071466,
    "h": -1.47050788121406,
    "CMY_C": 0.08652342,
    "CMY_M": 0.1388576,
    "CMY_Y": 0.3313123,
    "CMYK_C": 0,
    "CMYK_M": 0.05729121,
    "CMYK_Y": 0.267975,
    "CMYK_K": 0.08652342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05790",
    "Farbtonhilfsbezeichnung": "G5.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "218",
    "Bcolor": "200",
    "Y": 70,
    "L": 87.1749913007814,
    "a": -0.93708862709385,
    "b": 8.88117032348499,
    "C": 8.93047151105579,
    "h": -1.46567120990818,
    "CMY_C": 0.1224298,
    "CMY_M": 0.143319,
    "CMY_Y": 0.2155614,
    "CMYK_C": 0,
    "CMYK_M": 0.02380337,
    "CMYK_Y": 0.1061243,
    "CMYK_K": 0.1224298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05791",
    "Farbtonhilfsbezeichnung": "G5.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "217",
    "Bcolor": "205",
    "Y": 69,
    "L": 86.5576390119091,
    "a": -0.79180585712401,
    "b": 5.58168198303002,
    "C": 5.63756421471701,
    "h": -1.42987863658641,
    "CMY_C": 0.1382946,
    "CMY_M": 0.1496085,
    "CMY_Y": 0.1979912,
    "CMYK_C": 0,
    "CMYK_M": 0.01312967,
    "CMYK_Y": 0.06927723,
    "CMYK_K": 0.1382946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05792",
    "Farbtonhilfsbezeichnung": "G4.55.74",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "203",
    "Bcolor": "62",
    "Y": 59,
    "L": 81.2618632588224,
    "a": -7.70822697486973,
    "b": 68.2859413517682,
    "C": 68.7196227390201,
    "h": -1.45839054011665,
    "CMY_C": 0.1237768,
    "CMY_M": 0.2028875,
    "CMY_Y": 0.7561175,
    "CMYK_C": 0,
    "CMYK_M": 0.09028599,
    "CMYK_Y": 0.7216662,
    "CMYK_K": 0.1237768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05793",
    "Farbtonhilfsbezeichnung": "G4.41.79",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "218",
    "Bcolor": "110",
    "Y": 69,
    "L": 86.6279711361909,
    "a": -5.90964225997181,
    "b": 54.2800416741109,
    "C": 54.6007948274021,
    "h": -1.46235025687463,
    "CMY_C": 0.06638834,
    "CMY_M": 0.1466643,
    "CMY_Y": 0.5691469,
    "CMYK_C": 0,
    "CMYK_M": 0.08598429,
    "CMYK_Y": 0.5385094,
    "CMYK_K": 0.06638834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05794",
    "Farbtonhilfsbezeichnung": "G4.21.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "218",
    "Bcolor": "163",
    "Y": 70,
    "L": 87.0512786268881,
    "a": -3.06508427884894,
    "b": 28.4131874107465,
    "C": 28.5780328307365,
    "h": -1.46333647027159,
    "CMY_C": 0.08884127,
    "CMY_M": 0.1441956,
    "CMY_Y": 0.3620151,
    "CMYK_C": 0,
    "CMYK_M": 0.06075163,
    "CMYK_Y": 0.2998092,
    "CMYK_K": 0.08884127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05795",
    "Farbtonhilfsbezeichnung": "G3.17.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "224",
    "Bcolor": "177",
    "Y": 75,
    "L": 89.351579542743,
    "a": -2.26161480568754,
    "b": 24.4348162153079,
    "C": 24.5392572219532,
    "h": -1.47850222048745,
    "CMY_C": 0.0661777,
    "CMY_M": 0.1197865,
    "CMY_Y": 0.3077943,
    "CMYK_C": 0,
    "CMYK_M": 0.05740796,
    "CMYK_Y": 0.2587394,
    "CMYK_K": 0.0661777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05796",
    "Farbtonhilfsbezeichnung": "G4.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "225",
    "Bcolor": "200",
    "Y": 75,
    "L": 89.3961569245749,
    "a": -1.45522974745355,
    "b": 12.1613766809254,
    "C": 12.2481335881526,
    "h": -1.45170263526729,
    "CMY_C": 0.09194937,
    "CMY_M": 0.1183342,
    "CMY_Y": 0.2158451,
    "CMYK_C": 0,
    "CMYK_M": 0.02905656,
    "CMYK_Y": 0.1364415,
    "CMYK_K": 0.09194937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05797",
    "Farbtonhilfsbezeichnung": "G4.54.81",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "220",
    "Bcolor": "67",
    "Y": 70,
    "L": 87.2108401532088,
    "a": -8.6817370988016,
    "b": 72.6591793262934,
    "C": 73.1760131424442,
    "h": -1.45187437386171,
    "CMY_C": 0.05517069,
    "CMY_M": 0.1361415,
    "CMY_Y": 0.7355385,
    "CMYK_C": 0,
    "CMYK_M": 0.08569892,
    "CMYK_Y": 0.7200961,
    "CMYK_K": 0.05517069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05798",
    "Farbtonhilfsbezeichnung": "G4.42.80",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "218",
    "Bcolor": "104",
    "Y": 69,
    "L": 86.34311566274,
    "a": -7.57412425053422,
    "b": 56.7640149832311,
    "C": 57.2671001114865,
    "h": -1.438148056705,
    "CMY_C": 0.07742916,
    "CMY_M": 0.1463647,
    "CMY_Y": 0.5935627,
    "CMYK_C": 0,
    "CMYK_M": 0.07472118,
    "CMYK_Y": 0.5594513,
    "CMYK_K": 0.07742916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05799",
    "Farbtonhilfsbezeichnung": "G5.35.82",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "225",
    "Bcolor": "131",
    "Y": 75,
    "L": 89.2669863936216,
    "a": -6.06889540264638,
    "b": 47.4581962603302,
    "C": 47.8446641088876,
    "h": -1.44360787002562,
    "CMY_C": 0.04749707,
    "CMY_M": 0.1161556,
    "CMY_Y": 0.4863886,
    "CMYK_C": 0,
    "CMYK_M": 0.07208226,
    "CMYK_Y": 0.460777,
    "CMYK_K": 0.04749707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05800",
    "Farbtonhilfsbezeichnung": "G3.22.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "225",
    "Bcolor": "163",
    "Y": 76,
    "L": 89.6511258226435,
    "a": -2.65958622661489,
    "b": 31.6959399059652,
    "C": 31.8073262852972,
    "h": -1.48708306207532,
    "CMY_C": 0.04922264,
    "CMY_M": 0.1170226,
    "CMY_Y": 0.3594096,
    "CMYK_C": 0,
    "CMYK_M": 0.07130999,
    "CMYK_Y": 0.3262456,
    "CMYK_K": 0.04922264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05801",
    "Farbtonhilfsbezeichnung": "G4.15.84",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "229",
    "Bcolor": "185",
    "Y": 78,
    "L": 90.7792053222656,
    "a": -2.33718776702881,
    "b": 22.0130081176758,
    "C": 22.1367340087891,
    "h": 96.0605621337891,
    "CMY_C": 0.05645579099655,
    "CMY_M": 0.10317307710648,
    "CMY_Y": 0.27447146177292,
    "CMYK_C": 0,
    "CMYK_M": 0.04951255768538,
    "CMYK_Y": 0.23106037080288,
    "CMYK_K": 0.05645579099655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05802",
    "Farbtonhilfsbezeichnung": "G4.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "226",
    "Bcolor": "191",
    "Y": 76,
    "L": 89.8582548566272,
    "a": -1.7322312881346,
    "b": 17.7430098368388,
    "C": 17.8273672567138,
    "h": -1.47347580285899,
    "CMY_C": 0.07340917,
    "CMY_M": 0.1138997,
    "CMY_Y": 0.2523485,
    "CMYK_C": 0,
    "CMYK_M": 0.04369837,
    "CMYK_Y": 0.1931157,
    "CMYK_K": 0.07340917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05803",
    "Farbtonhilfsbezeichnung": "G5.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "228",
    "Bcolor": "206",
    "Y": 77,
    "L": 90.4764569427733,
    "a": -1.26205187596606,
    "b": 10.3964786492432,
    "C": 10.4728001624111,
    "h": -1.44999514707322,
    "CMY_C": 0.08354731,
    "CMY_M": 0.10633,
    "CMY_Y": 0.1910256,
    "CMYK_C": 0,
    "CMYK_M": 0.02485963,
    "CMYK_Y": 0.1172764,
    "CMYK_K": 0.08354731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05804",
    "Farbtonhilfsbezeichnung": "G4.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "228",
    "Bcolor": "215",
    "Y": 77,
    "L": 90.4878239637427,
    "a": -0.6152439582226,
    "b": 5.93182699959685,
    "C": 5.96364793404805,
    "h": -1.46744673568208,
    "CMY_C": 0.09213893,
    "CMY_M": 0.1065581,
    "CMY_Y": 0.1577222,
    "CMYK_C": 0,
    "CMYK_M": 0.01588255,
    "CMYK_Y": 0.07223932,
    "CMYK_K": 0.09213893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05805",
    "Farbtonhilfsbezeichnung": "G5.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "222",
    "Y": 84,
    "L": 93.5288882607571,
    "a": -1.19620989140184,
    "b": 6.73531187009857,
    "C": 6.84071225032732,
    "h": -1.39502637467928,
    "CMY_C": 0.06002254,
    "CMY_M": 0.07141362,
    "CMY_Y": 0.1303901,
    "CMYK_C": 0,
    "CMYK_M": 0.01211847,
    "CMYK_Y": 0.07486092,
    "CMYK_K": 0.06002254
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05806",
    "Farbtonhilfsbezeichnung": "G5.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "229",
    "Bcolor": "211",
    "Y": 78,
    "L": 90.7378990757005,
    "a": -1.14835749362058,
    "b": 8.40942639939728,
    "C": 8.48747178493304,
    "h": -1.4350797818315,
    "CMY_C": 0.0857418,
    "CMY_M": 0.1031717,
    "CMY_Y": 0.1734255,
    "CMYK_C": 0,
    "CMYK_M": 0.01906457,
    "CMYK_Y": 0.09590695,
    "CMYK_K": 0.0857418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05807",
    "Farbtonhilfsbezeichnung": "G4.27.81",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "147",
    "Y": 73,
    "L": 88.5125985423536,
    "a": -4.05097490216599,
    "b": 38.4221020103607,
    "C": 38.6350659447159,
    "h": -1.46575096179079,
    "CMY_C": 0.05845005,
    "CMY_M": 0.1276543,
    "CMY_Y": 0.4229765,
    "CMYK_C": 0,
    "CMYK_M": 0.07350038,
    "CMYK_Y": 0.3871557,
    "CMYK_K": 0.05845005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05809",
    "Farbtonhilfsbezeichnung": "G4.51.79",
    "Farbtonklasse": "03",
    "Rcolor": "239",
    "Gcolor": "216",
    "Bcolor": "79",
    "Y": 68,
    "L": 86.0254777625825,
    "a": -6.70675640922813,
    "b": 67.2126053645881,
    "C": 67.5463907357646,
    "h": -1.4713413370318,
    "CMY_C": 0.06212134,
    "CMY_M": 0.1530528,
    "CMY_Y": 0.6913953,
    "CMYK_C": 0,
    "CMYK_M": 0.09695442,
    "CMYK_Y": 0.6709546,
    "CMYK_K": 0.06212134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05810",
    "Farbtonhilfsbezeichnung": "G5.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "230",
    "Bcolor": "204",
    "Y": 79,
    "L": 91.1558211958046,
    "a": -1.52768874479914,
    "b": 12.5957467235968,
    "C": 12.6880521919634,
    "h": -1.45009977096581,
    "CMY_C": 0.07150607,
    "CMY_M": 0.09869004,
    "CMY_Y": 0.2000239,
    "CMYK_C": 0,
    "CMYK_M": 0.02927749,
    "CMYK_Y": 0.1384153,
    "CMYK_K": 0.07150607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05811",
    "Farbtonhilfsbezeichnung": "G4.19.84",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "230",
    "Bcolor": "176",
    "Y": 79,
    "L": 91.2675343936825,
    "a": -2.79205605254179,
    "b": 27.5033508520064,
    "C": 27.6447080847148,
    "h": -1.46962597894882,
    "CMY_C": 0.04102221,
    "CMY_M": 0.09788575,
    "CMY_Y": 0.3106405,
    "CMYK_C": 0,
    "CMYK_M": 0.059296,
    "CMYK_Y": 0.2811518,
    "CMYK_K": 0.04102221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05812",
    "Farbtonhilfsbezeichnung": "G5.26.83",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "159",
    "Y": 80,
    "L": 91.5444725670551,
    "a": -5.08263639739315,
    "b": 36.4278466683567,
    "C": 36.7807178510889,
    "h": -1.43216517816373,
    "CMY_C": 0.03486149,
    "CMY_M": 0.0912182,
    "CMY_Y": 0.3761669,
    "CMYK_C": 0,
    "CMYK_M": 0.05839236,
    "CMYK_Y": 0.3536336,
    "CMYK_K": 0.03486149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05813",
    "Farbtonhilfsbezeichnung": "G6.50.78",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "214",
    "Bcolor": "82",
    "Y": 65,
    "L": 84.6399180657609,
    "a": -10.7700558059344,
    "b": 64.0664103872637,
    "C": 64.9653680199861,
    "h": -1.40424590794559,
    "CMY_C": 0.109318,
    "CMY_M": 0.158879,
    "CMY_Y": 0.6779194,
    "CMYK_C": 0,
    "CMYK_M": 0.05564389,
    "CMYK_Y": 0.6383888,
    "CMYK_K": 0.109318
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05814",
    "Farbtonhilfsbezeichnung": "G6.34.83",
    "Farbtonklasse": "02",
    "Rcolor": "242",
    "Gcolor": "229",
    "Bcolor": "132",
    "Y": 76,
    "L": 90.0584827050548,
    "a": -8.00819628885657,
    "b": 48.1495395894564,
    "C": 48.8109554349993,
    "h": -1.40598567570468,
    "CMY_C": 0.05065388,
    "CMY_M": 0.1030669,
    "CMY_Y": 0.4842207,
    "CMYK_C": 0,
    "CMYK_M": 0.05520964,
    "CMYK_Y": 0.4567005,
    "CMYK_K": 0.05065388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05816",
    "Farbtonhilfsbezeichnung": "G7.15.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "187",
    "Y": 80,
    "L": 91.7431887458535,
    "a": -4.35049075966815,
    "b": 22.063410635349,
    "C": 22.4882382305504,
    "h": -1.37611257243143,
    "CMY_C": 0.06031214,
    "CMY_M": 0.08777051,
    "CMY_Y": 0.2648944,
    "CMYK_C": 0,
    "CMYK_M": 0.02922074,
    "CMYK_Y": 0.217713,
    "CMYK_K": 0.06031214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05817",
    "Farbtonhilfsbezeichnung": "G6.09.84",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "231",
    "Bcolor": "201",
    "Y": 79,
    "L": 91.2743425444248,
    "a": -2.32538273054211,
    "b": 14.3232715544103,
    "C": 14.5108067613377,
    "h": -1.40985059433111,
    "CMY_C": 0.07127685,
    "CMY_M": 0.09591962,
    "CMY_Y": 0.211725,
    "CMYK_C": 0,
    "CMYK_M": 0.02653404,
    "CMYK_Y": 0.1512271,
    "CMYK_K": 0.07127685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05818",
    "Farbtonhilfsbezeichnung": "G6.60.76",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "211",
    "Bcolor": "43",
    "Y": 63,
    "L": 83.2550929942925,
    "a": -12.871843364718,
    "b": 76.085655423951,
    "C": 77.1667759654247,
    "h": -1.40320743378438,
    "CMY_C": 0.1266191,
    "CMY_M": 0.1706733,
    "CMY_Y": 0.8315455,
    "CMYK_C": 0,
    "CMYK_M": 0.05044094,
    "CMYK_Y": 0.8071237,
    "CMYK_K": 0.1266191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05819",
    "Farbtonhilfsbezeichnung": "G7.41.80",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "223",
    "Bcolor": "108",
    "Y": 71,
    "L": 87.6718675150387,
    "a": -10.5057332205195,
    "b": 56.1062882843827,
    "C": 57.0813981569389,
    "h": -1.38569281176087,
    "CMY_C": 0.08299673,
    "CMY_M": 0.1250992,
    "CMY_Y": 0.5751171,
    "CMYK_C": 0,
    "CMYK_M": 0.04591315,
    "CMYK_Y": 0.5366615,
    "CMYK_K": 0.08299673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05820",
    "Farbtonhilfsbezeichnung": "G6.28.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "228",
    "Bcolor": "149",
    "Y": 76,
    "L": 90.0483739241248,
    "a": -6.31362743505331,
    "b": 39.5958684855936,
    "C": 40.0960682925032,
    "h": -1.41267575146363,
    "CMY_C": 0.05448104,
    "CMY_M": 0.1056223,
    "CMY_Y": 0.4165639,
    "CMYK_C": 0,
    "CMYK_M": 0.05408805,
    "CMYK_Y": 0.3829461,
    "CMYK_K": 0.05448104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05821",
    "Farbtonhilfsbezeichnung": "G7.27.83",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "230",
    "Bcolor": "157",
    "Y": 77,
    "L": 90.402159377596,
    "a": -7.24225150172858,
    "b": 36.0986730967493,
    "C": 36.8179902515097,
    "h": -1.37280107041324,
    "CMY_C": 0.06413127,
    "CMY_M": 0.09894571,
    "CMY_Y": 0.3860888,
    "CMYK_C": 0,
    "CMYK_M": 0.03720013,
    "CMYK_Y": 0.34402,
    "CMYK_K": 0.06413127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05822",
    "Farbtonhilfsbezeichnung": "G6.19.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "177",
    "Y": 79,
    "L": 91.15046531858,
    "a": -4.26715549160517,
    "b": 26.9122500065811,
    "C": 27.2484461282889,
    "h": -1.41354727917861,
    "CMY_C": 0.05446632,
    "CMY_M": 0.09562646,
    "CMY_Y": 0.3077018,
    "CMYK_C": 0,
    "CMYK_M": 0.04353112,
    "CMYK_Y": 0.2678228,
    "CMYK_K": 0.05446632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05823",
    "Farbtonhilfsbezeichnung": "G7.11.81",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "221",
    "Bcolor": "188",
    "Y": 71,
    "L": 87.6727106401766,
    "a": -3.33627409104648,
    "b": 15.9113541714218,
    "C": 16.2573649887985,
    "h": -1.36411175919964,
    "CMY_C": 0.1148036,
    "CMY_M": 0.1339724,
    "CMY_Y": 0.2624353,
    "CMYK_C": 0,
    "CMYK_M": 0.02165482,
    "CMYK_Y": 0.1667784,
    "CMYK_K": 0.1148036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05824",
    "Farbtonhilfsbezeichnung": "G7.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 84,
    "L": 92.9568099975586,
    "a": -0.67990094423294,
    "b": 4.62086725234985,
    "C": 4.67061853408813,
    "h": 98.3702774047852,
    "CMY_C": 0.06919628381729,
    "CMY_M": 0.07844388484955,
    "CMY_Y": 0.12086570262909,
    "CMYK_C": 0,
    "CMYK_M": 0.00993507076055,
    "CMYK_Y": 0.0555105432868,
    "CMYK_K": 0.06919628381729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05825",
    "Farbtonhilfsbezeichnung": "G7.57.73",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "204",
    "Bcolor": "55",
    "Y": 57,
    "L": 80.1749378802014,
    "a": -15.0017933813584,
    "b": 69.4331781035354,
    "C": 71.0353435003607,
    "h": -1.35800638312528,
    "CMY_C": 0.1837394,
    "CMY_M": 0.1991609,
    "CMY_Y": 0.7860026,
    "CMYK_C": 0,
    "CMYK_M": 0.01889283,
    "CMYK_Y": 0.7378321,
    "CMYK_K": 0.1837394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05826",
    "Farbtonhilfsbezeichnung": "G6.53.73",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "205",
    "Bcolor": "62",
    "Y": 59,
    "L": 81.2858245973663,
    "a": -11.5591775063969,
    "b": 68.3386182657069,
    "C": 69.3093163369139,
    "h": -1.40323667505823,
    "CMY_C": 0.1488644,
    "CMY_M": 0.1942432,
    "CMY_Y": 0.7585306,
    "CMYK_C": 0,
    "CMYK_M": 0.05331555,
    "CMYK_Y": 0.7162974,
    "CMYK_K": 0.1488644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05827",
    "Farbtonhilfsbezeichnung": "G6.42.74",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "205",
    "Bcolor": "101",
    "Y": 59,
    "L": 81.2472233414114,
    "a": -9.13218570237734,
    "b": 51.5753119346368,
    "C": 52.3775678784134,
    "h": -1.39554766857626,
    "CMY_C": 0.1543348,
    "CMY_M": 0.1979985,
    "CMY_Y": 0.6030293,
    "CMYK_C": 0,
    "CMYK_M": 0.0516323,
    "CMYK_Y": 0.5305817,
    "CMYK_K": 0.1543348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05828",
    "Farbtonhilfsbezeichnung": "G6.27.77",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "213",
    "Bcolor": "142",
    "Y": 65,
    "L": 84.7131431566846,
    "a": -5.95277634856539,
    "b": 35.966563021884,
    "C": 36.4558527792616,
    "h": -1.40677460494597,
    "CMY_C": 0.1198916,
    "CMY_M": 0.1647568,
    "CMY_Y": 0.443953,
    "CMYK_C": 0,
    "CMYK_M": 0.05097686,
    "CMYK_Y": 0.3682062,
    "CMYK_K": 0.1198916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05829",
    "Farbtonhilfsbezeichnung": "G6.21.83",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "227",
    "Bcolor": "167",
    "Y": 76,
    "L": 89.730257911341,
    "a": -4.89248066544445,
    "b": 29.8508190311285,
    "C": 30.2490952573946,
    "h": -1.408342980137,
    "CMY_C": 0.0683729,
    "CMY_M": 0.1105944,
    "CMY_Y": 0.3450502,
    "CMYK_C": 0,
    "CMYK_M": 0.04532021,
    "CMYK_Y": 0.2969828,
    "CMYK_K": 0.0683729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05830",
    "Farbtonhilfsbezeichnung": "G6.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "218",
    "Bcolor": "177",
    "Y": 69,
    "L": 86.6692174128954,
    "a": -3.38649865806556,
    "b": 20.388199209878,
    "C": 20.66753590012,
    "h": -1.40619815546536,
    "CMY_C": 0.1145514,
    "CMY_M": 0.1459713,
    "CMY_Y": 0.3062775,
    "CMYK_C": 0,
    "CMYK_M": 0.03548482,
    "CMYK_Y": 0.21653,
    "CMYK_K": 0.1145514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05831",
    "Farbtonhilfsbezeichnung": "G6.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "223",
    "Bcolor": "202",
    "Y": 73,
    "L": 88.6075665452031,
    "a": -1.99995635036337,
    "b": 9.76554789560806,
    "C": 9.96823711118339,
    "h": -1.36879240935078,
    "CMY_C": 0.111938,
    "CMY_M": 0.1252061,
    "CMY_Y": 0.2067444,
    "CMYK_C": 0,
    "CMYK_M": 0.01494054,
    "CMYK_Y": 0.1067565,
    "CMYK_K": 0.111938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05832",
    "Farbtonhilfsbezeichnung": "G7.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "236",
    "Bcolor": "223",
    "Y": 83,
    "L": 93.1557783354403,
    "a": -1.60559073317168,
    "b": 5.74143602004582,
    "C": 5.9617119332224,
    "h": -1.29811250691079,
    "CMY_C": 0.07060258,
    "CMY_M": 0.07436007,
    "CMY_Y": 0.1271521,
    "CMYK_C": 0,
    "CMYK_M": 0.004042923,
    "CMYK_Y": 0.06084534,
    "CMYK_K": 0.07060258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05833",
    "Farbtonhilfsbezeichnung": "G6.63.72",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "205",
    "Bcolor": "33",
    "Y": 57,
    "L": 80.2790691383405,
    "a": -15.3296490336401,
    "b": 75.4688429434124,
    "C": 77.0100278841141,
    "h": -1.37039725999643,
    "CMY_C": 0.1786795,
    "CMY_M": 0.1978691,
    "CMY_Y": 0.8690291,
    "CMYK_C": 0,
    "CMYK_M": 0.02336429,
    "CMYK_Y": 0.8405362,
    "CMYK_K": 0.1786795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05834",
    "Farbtonhilfsbezeichnung": "G7.60.73",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "205",
    "Bcolor": "42",
    "Y": 58,
    "L": 80.5964682674719,
    "a": -13.9735870810908,
    "b": 73.7180642154625,
    "C": 75.0307545449723,
    "h": -1.38346444192799,
    "CMY_C": 0.1675449,
    "CMY_M": 0.197103,
    "CMY_Y": 0.8353773,
    "CMYK_C": 0,
    "CMYK_M": 0.03550713,
    "CMYK_Y": 0.8022444,
    "CMYK_K": 0.1675449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05835",
    "Farbtonhilfsbezeichnung": "G6.46.73",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "202",
    "Bcolor": "85",
    "Y": 57,
    "L": 79.9662917117717,
    "a": -10.568723322617,
    "b": 57.4917599592366,
    "C": 58.4551141978229,
    "h": -1.38899585853674,
    "CMY_C": 0.1704525,
    "CMY_M": 0.2095425,
    "CMY_Y": 0.6671087,
    "CMYK_C": 0,
    "CMYK_M": 0.04712201,
    "CMYK_Y": 0.5987073,
    "CMYK_K": 0.1704525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05836",
    "Farbtonhilfsbezeichnung": "G6.30.73",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "200",
    "Bcolor": "126",
    "Y": 57,
    "L": 80.1787543512556,
    "a": -6.3523758873934,
    "b": 38.2358732298426,
    "C": 38.7599623459999,
    "h": -1.40616348737845,
    "CMY_C": 0.1694742,
    "CMY_M": 0.2137479,
    "CMY_Y": 0.5077537,
    "CMYK_C": 0,
    "CMYK_M": 0.05330798,
    "CMYK_Y": 0.4073076,
    "CMYK_K": 0.1694742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05837",
    "Farbtonhilfsbezeichnung": "G6.19.78",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "216",
    "Bcolor": "164",
    "Y": 68,
    "L": 85.9384721861233,
    "a": -4.48999646076914,
    "b": 26.1127712694833,
    "C": 26.495978781507,
    "h": -1.40051507161458,
    "CMY_C": 0.1168467,
    "CMY_M": 0.1527203,
    "CMY_Y": 0.3567404,
    "CMYK_C": 0,
    "CMYK_M": 0.04061993,
    "CMYK_Y": 0.2716331,
    "CMYK_K": 0.1168467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05838",
    "Farbtonhilfsbezeichnung": "G6.15.74",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "203",
    "Bcolor": "166",
    "Y": 59,
    "L": 81.1977324295113,
    "a": -3.41743596756588,
    "b": 18.5068601720077,
    "C": 18.8197434100112,
    "h": -1.38819546267741,
    "CMY_C": 0.1803203,
    "CMY_M": 0.205463,
    "CMY_Y": 0.3500437,
    "CMYK_C": 0,
    "CMYK_M": 0.03067388,
    "CMYK_Y": 0.2070607,
    "CMYK_K": 0.1803203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05839",
    "Farbtonhilfsbezeichnung": "G7.11.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "218",
    "Bcolor": "186",
    "Y": 69,
    "L": 86.5490883707788,
    "a": -3.32812115118081,
    "b": 15.1697916109184,
    "C": 15.5305816992033,
    "h": -1.35482664153985,
    "CMY_C": 0.1293005,
    "CMY_M": 0.1462346,
    "CMY_Y": 0.2689643,
    "CMYK_C": 0,
    "CMYK_M": 0.01944883,
    "CMYK_Y": 0.1604041,
    "CMYK_K": 0.1293005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05840",
    "Farbtonhilfsbezeichnung": "G7.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "223",
    "Bcolor": "206",
    "Y": 73,
    "L": 88.6419924733635,
    "a": -1.67603827625973,
    "b": 7.85416636330338,
    "C": 8.03100451786288,
    "h": -1.3605549479003,
    "CMY_C": 0.1148906,
    "CMY_M": 0.1250867,
    "CMY_Y": 0.1922142,
    "CMYK_C": 0,
    "CMYK_M": 0.01151959,
    "CMYK_Y": 0.08736055,
    "CMYK_K": 0.1148906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05841",
    "Farbtonhilfsbezeichnung": "G7.59.69",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "196",
    "Bcolor": "34",
    "Y": 51,
    "L": 76.8790823347213,
    "a": -15.9497547362081,
    "b": 72.02301930743,
    "C": 73.7679468760221,
    "h": -1.35285998054412,
    "CMY_C": 0.2256864,
    "CMY_M": 0.2331016,
    "CMY_Y": 0.8653335,
    "CMYK_C": 0,
    "CMYK_M": 0.009576389,
    "CMYK_Y": 0.8260828,
    "CMYK_K": 0.2256864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05842",
    "Farbtonhilfsbezeichnung": "G6.55.71",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "200",
    "Bcolor": "65",
    "Y": 55,
    "L": 79.1908218368569,
    "a": -12.2627824466217,
    "b": 64.897485600933,
    "C": 66.0458891276094,
    "h": -1.38404200187987,
    "CMY_C": 0.181705,
    "CMY_M": 0.2151358,
    "CMY_Y": 0.7461874,
    "CMYK_C": 0,
    "CMYK_M": 0.04085419,
    "CMYK_Y": 0.6898274,
    "CMYK_K": 0.181705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05843",
    "Farbtonhilfsbezeichnung": "G7.38.73",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "200",
    "Bcolor": "107",
    "Y": 56,
    "L": 79.758759687122,
    "a": -8.86004846037708,
    "b": 47.0932080506946,
    "C": 47.9194188531772,
    "h": -1.38483157286668,
    "CMY_C": 0.1762889,
    "CMY_M": 0.2141478,
    "CMY_Y": 0.5816893,
    "CMYK_C": 0,
    "CMYK_M": 0.04596137,
    "CMYK_Y": 0.4921633,
    "CMYK_K": 0.1762889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05847",
    "Farbtonhilfsbezeichnung": "G6.03.76",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "207",
    "Bcolor": "196",
    "Y": 62,
    "L": 82.8079515941938,
    "a": -1.39956731809587,
    "b": 4.40169707714593,
    "C": 4.61884464307223,
    "h": -1.2629442179773,
    "CMY_C": 0.1879492,
    "CMY_M": 0.1890659,
    "CMY_Y": 0.2299778,
    "CMYK_C": 0,
    "CMYK_M": 0.001375183,
    "CMYK_Y": 0.05175622,
    "CMYK_K": 0.1879492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05848",
    "Farbtonhilfsbezeichnung": "G7.58.66",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "189",
    "Bcolor": "57",
    "Y": 45,
    "L": 74.7616119384766,
    "a": -13.328275680542,
    "b": 62.9592361450195,
    "C": 64.3545532226563,
    "h": 101.952865600586,
    "CMY_C": 0.24184519052505,
    "CMY_M": 0.26038008928299,
    "CMY_Y": 0.77603954076767,
    "CMYK_C": 0,
    "CMYK_M": 0.02444737963378,
    "CMYK_Y": 0.70459800958633,
    "CMYK_K": 0.24184519052505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05849",
    "Farbtonhilfsbezeichnung": "G6.52.65",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "182",
    "Bcolor": "71",
    "Y": 45,
    "L": 72.6820586936322,
    "a": -10.7769412093787,
    "b": 55.2786215966534,
    "C": 56.3193436348152,
    "h": -1.37825470142204,
    "CMY_C": 0.2575242,
    "CMY_M": 0.287106,
    "CMY_Y": 0.7229121,
    "CMYK_C": 0,
    "CMYK_M": 0.03984217,
    "CMYK_Y": 0.6268055,
    "CMYK_K": 0.2575242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05850",
    "Farbtonhilfsbezeichnung": "G7.51.69",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "196",
    "Bcolor": "69",
    "Y": 51,
    "L": 77.4399032592773,
    "a": -13.195481300354,
    "b": 61.3327980041504,
    "C": 62.7362174987793,
    "h": 102.14185333252,
    "CMY_C": 0.21224600076675,
    "CMY_M": 0.23170727491379,
    "CMY_Y": 0.73022556304932,
    "CMYK_C": 0,
    "CMYK_M": 0.02470475994051,
    "CMYK_Y": 0.65753972530365,
    "CMYK_K": 0.21224600076675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05851",
    "Farbtonhilfsbezeichnung": "G6.30.70",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "192",
    "Bcolor": "117",
    "Y": 51,
    "L": 76.8904133786109,
    "a": -7.68903744819049,
    "b": 37.9966280613365,
    "C": 38.7668033362466,
    "h": -1.37113156338389,
    "CMY_C": 0.2158832,
    "CMY_M": 0.246324,
    "CMY_Y": 0.5395014,
    "CMYK_C": 0,
    "CMYK_M": 0.03882186,
    "CMYK_Y": 0.4127168,
    "CMYK_K": 0.2158832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05852",
    "Farbtonhilfsbezeichnung": "G7.26.66",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "182",
    "Bcolor": "123",
    "Y": 46,
    "L": 73.4358965607331,
    "a": -5.91512307588765,
    "b": 30.590192749478,
    "C": 31.156838309641,
    "h": -1.37978704860681,
    "CMY_C": 0.255841,
    "CMY_M": 0.2859608,
    "CMY_Y": 0.5184296,
    "CMYK_C": 0,
    "CMYK_M": 0.04047493,
    "CMYK_Y": 0.3528663,
    "CMYK_K": 0.255841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05853",
    "Farbtonhilfsbezeichnung": "G6.13.70",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "191",
    "Bcolor": "159",
    "Y": 52,
    "L": 77.1841998576375,
    "a": -3.0490720532258,
    "b": 16.5412152250125,
    "C": 16.8198882726952,
    "h": -1.38851072087456,
    "CMY_C": 0.2266513,
    "CMY_M": 0.2493286,
    "CMY_Y": 0.3775229,
    "CMYK_C": 0,
    "CMYK_M": 0.02932349,
    "CMYK_Y": 0.1950887,
    "CMYK_K": 0.2266513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05854",
    "Farbtonhilfsbezeichnung": "G6.11.71",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "192",
    "Bcolor": "164",
    "Y": 52,
    "L": 77.4604389826492,
    "a": -2.5432059007684,
    "b": 14.0621757394206,
    "C": 14.2903003040542,
    "h": -1.39187595715982,
    "CMY_C": 0.2264762,
    "CMY_M": 0.2469282,
    "CMY_Y": 0.3566867,
    "CMYK_C": 0,
    "CMYK_M": 0.02644001,
    "CMYK_Y": 0.1683341,
    "CMYK_K": 0.2264762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05855",
    "Farbtonhilfsbezeichnung": "G6.08.73",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "198",
    "Bcolor": "176",
    "Y": 56,
    "L": 79.5158573400683,
    "a": -1.89626495516526,
    "b": 10.6764448734965,
    "C": 10.8435370574825,
    "h": -1.39501738410205,
    "CMY_C": 0.2086885,
    "CMY_M": 0.2253718,
    "CMY_Y": 0.3105938,
    "CMYK_C": 0,
    "CMYK_M": 0.02108312,
    "CMYK_Y": 0.1287803,
    "CMYK_K": 0.2086885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05856",
    "Farbtonhilfsbezeichnung": "G6.66.64",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "181",
    "Bcolor": "1",
    "Y": 44,
    "L": 72.0147462370021,
    "a": -13.2765950599177,
    "b": 73.1652092878948,
    "C": 74.3600418674336,
    "h": -1.3912890900799,
    "CMY_C": 0.2632526,
    "CMY_M": 0.290639,
    "CMY_Y": 0.9945272,
    "CMYK_C": 0,
    "CMYK_M": 0.03717201,
    "CMYK_Y": 0.9925717,
    "CMYK_K": 0.2632526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05857",
    "Farbtonhilfsbezeichnung": "G7.41.61",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "169",
    "Bcolor": "79",
    "Y": 38,
    "L": 67.8781682514121,
    "a": -9.80378724140069,
    "b": 45.6336337485715,
    "C": 46.674862328382,
    "h": -1.35917609029194,
    "CMY_C": 0.3174028,
    "CMY_M": 0.3387776,
    "CMY_Y": 0.6890929,
    "CMYK_C": 0,
    "CMYK_M": 0.03131386,
    "CMYK_Y": 0.5445233,
    "CMYK_K": 0.3174028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05858",
    "Farbtonhilfsbezeichnung": "G6.36.64",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "177",
    "Bcolor": "99",
    "Y": 43,
    "L": 71.5914254000971,
    "a": -7.16794111815461,
    "b": 40.6408489753418,
    "C": 41.2681231134864,
    "h": -1.3962189454208,
    "CMY_C": 0.2665496,
    "CMY_M": 0.3044718,
    "CMY_Y": 0.6124703,
    "CMYK_C": 0,
    "CMYK_M": 0.05170383,
    "CMYK_Y": 0.4716347,
    "CMYK_K": 0.2665496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05859",
    "Farbtonhilfsbezeichnung": "G7.29.60",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "166",
    "Bcolor": "105",
    "Y": 37,
    "L": 67.321160191028,
    "a": -6.68317462773044,
    "b": 31.6476067940519,
    "C": 32.3455690767013,
    "h": -1.36267929209635,
    "CMY_C": 0.3254756,
    "CMY_M": 0.3491467,
    "CMY_Y": 0.5870396,
    "CMYK_C": 0,
    "CMYK_M": 0.03509307,
    "CMYK_Y": 0.3877754,
    "CMYK_K": 0.3254756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05860",
    "Farbtonhilfsbezeichnung": "G6.20.69",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "189",
    "Bcolor": "141",
    "Y": 50,
    "L": 76.3109713825326,
    "a": -3.52970518892559,
    "b": 24.6175892213188,
    "C": 24.8693489619314,
    "h": -1.42838550682599,
    "CMY_C": 0.2203167,
    "CMY_M": 0.2593406,
    "CMY_Y": 0.4451501,
    "CMYK_C": 0,
    "CMYK_M": 0.05005096,
    "CMYK_Y": 0.288365,
    "CMYK_K": 0.2203167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05861",
    "Farbtonhilfsbezeichnung": "G7.09.70",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "190",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.8377324322289,
    "a": -1.90829241357193,
    "b": 11.2985039740167,
    "C": 11.4585239881307,
    "h": -1.40347760987172,
    "CMY_C": 0.2361394,
    "CMY_M": 0.2544205,
    "CMY_Y": 0.3432141,
    "CMYK_C": 0,
    "CMYK_M": 0.02393246,
    "CMYK_Y": 0.1401756,
    "CMYK_K": 0.2361394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05862",
    "Farbtonhilfsbezeichnung": "G7.06.64",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "176",
    "Bcolor": "161",
    "Y": 43,
    "L": 71.7900564829579,
    "a": -1.59071651975995,
    "b": 7.68104768843405,
    "C": 7.84403420685015,
    "h": -1.36658681056668,
    "CMY_C": 0.298325,
    "CMY_M": 0.3082092,
    "CMY_Y": 0.3699869,
    "CMYK_C": 0,
    "CMYK_M": 0.01408654,
    "CMYK_Y": 0.1021298,
    "CMYK_K": 0.298325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05863",
    "Farbtonhilfsbezeichnung": "G7.61.61",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "172",
    "Bcolor": "46",
    "Y": 37,
    "L": 68.8339309692383,
    "a": -12.7710313796997,
    "b": 60.9060554504395,
    "C": 62.2305946350098,
    "h": 101.842445373535,
    "CMY_C": 0.3075333237648,
    "CMY_M": 0.32426834106445,
    "CMY_Y": 0.82094305753708,
    "CMYK_C": 0,
    "CMYK_M": 0.0241672527045,
    "CMYK_Y": 0.74142158031464,
    "CMYK_K": 0.3075333237648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05864",
    "Farbtonhilfsbezeichnung": "G6.55.59",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "165",
    "Bcolor": "51",
    "Y": 36,
    "L": 66.6650725054967,
    "a": -10.370769045892,
    "b": 56.8205272736778,
    "C": 57.759199875535,
    "h": -1.39026548569889,
    "CMY_C": 0.3206039,
    "CMY_M": 0.35154,
    "CMY_Y": 0.8006048,
    "CMYK_C": 0,
    "CMYK_M": 0.04553474,
    "CMYK_Y": 0.7065111,
    "CMYK_K": 0.3206039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05865",
    "Farbtonhilfsbezeichnung": "G6.43.52",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "145",
    "Bcolor": "67",
    "Y": 27,
    "L": 59.119857302053,
    "a": -8.37287070421161,
    "b": 41.1105615784781,
    "C": 41.95453774179,
    "h": -1.36987716553406,
    "CMY_C": 0.4094334,
    "CMY_M": 0.4318545,
    "CMY_Y": 0.7379906,
    "CMYK_C": 0,
    "CMYK_M": 0.03796544,
    "CMYK_Y": 0.5563424,
    "CMYK_K": 0.4094334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05866",
    "Farbtonhilfsbezeichnung": "G7.27.58",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "159",
    "Bcolor": "105",
    "Y": 34,
    "L": 64.8227297488185,
    "a": -5.78927147624925,
    "b": 28.7004164121917,
    "C": 29.2784829944947,
    "h": -1.37175337919789,
    "CMY_C": 0.3518085,
    "CMY_M": 0.3766358,
    "CMY_Y": 0.5899117,
    "CMYK_C": 0,
    "CMYK_M": 0.03830256,
    "CMYK_Y": 0.3673347,
    "CMYK_K": 0.3518085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05867",
    "Farbtonhilfsbezeichnung": "G7.26.57",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "155",
    "Bcolor": "103",
    "Y": 32,
    "L": 63.2908924896469,
    "a": -6.39671743061565,
    "b": 27.6508699633237,
    "C": 28.381131119386,
    "h": -1.3434568319755,
    "CMY_C": 0.3742068,
    "CMY_M": 0.3910833,
    "CMY_Y": 0.5974268,
    "CMYK_C": 0,
    "CMYK_M": 0.0269683,
    "CMYK_Y": 0.3566993,
    "CMYK_K": 0.3742068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05868",
    "Farbtonhilfsbezeichnung": "G6.10.62",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "169",
    "Bcolor": "148",
    "Y": 39,
    "L": 69.0670547851504,
    "a": -1.85038023573803,
    "b": 10.9351172396739,
    "C": 11.0905678872735,
    "h": -1.40316971953518,
    "CMY_C": 0.3200505,
    "CMY_M": 0.3371979,
    "CMY_Y": 0.4209962,
    "CMYK_C": 0,
    "CMYK_M": 0.02521863,
    "CMYK_Y": 0.1484606,
    "CMYK_K": 0.3200505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05869",
    "Farbtonhilfsbezeichnung": "G6.51.59",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "162",
    "Bcolor": "57",
    "Y": 34,
    "L": 65.1963059435025,
    "a": -11.1013870909545,
    "b": 52.7555355308888,
    "C": 53.9109202712593,
    "h": -1.36339160875603,
    "CMY_C": 0.3462064,
    "CMY_M": 0.3649744,
    "CMY_Y": 0.7773455,
    "CMYK_C": 0,
    "CMYK_M": 0.02870635,
    "CMYK_Y": 0.6594423,
    "CMYK_K": 0.3462064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05872",
    "Farbtonhilfsbezeichnung": "G7.35.55",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "152",
    "Bcolor": "84",
    "Y": 30,
    "L": 61.8926408572452,
    "a": -7.55052267907835,
    "b": 35.6626645340431,
    "C": 36.4532033488824,
    "h": -1.36215672547835,
    "CMY_C": 0.3825596,
    "CMY_M": 0.4043734,
    "CMY_Y": 0.6695747,
    "CMYK_C": 0,
    "CMYK_M": 0.03532938,
    "CMYK_Y": 0.4648467,
    "CMYK_K": 0.3825596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05873",
    "Farbtonhilfsbezeichnung": "G7.20.52",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "144",
    "Bcolor": "109",
    "Y": 27,
    "L": 59.3940867039365,
    "a": -3.95998890216587,
    "b": 19.0086164709873,
    "C": 19.4167199147119,
    "h": -1.36540797259576,
    "CMY_C": 0.4164985,
    "CMY_M": 0.4347372,
    "CMY_Y": 0.5740811,
    "CMYK_C": 0,
    "CMYK_M": 0.03125741,
    "CMYK_Y": 0.2700637,
    "CMYK_K": 0.4164985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05874",
    "Farbtonhilfsbezeichnung": "G6.11.43",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "123",
    "Bcolor": "104",
    "Y": 19,
    "L": 51.2161377414394,
    "a": -1.93286358871547,
    "b": 9.7784117840674,
    "C": 9.9676124860154,
    "h": -1.37564560359615,
    "CMY_C": 0.5077929,
    "CMY_M": 0.5195241,
    "CMY_Y": 0.5902967,
    "CMYK_C": 0,
    "CMYK_M": 0.02383372,
    "CMYK_Y": 0.16762,
    "CMYK_K": 0.5077929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05875",
    "Farbtonhilfsbezeichnung": "G6.09.51",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "141",
    "Bcolor": "125",
    "Y": 26,
    "L": 58.470434586077,
    "a": -1.53768264985421,
    "b": 8.16483927504017,
    "C": 8.30837338586207,
    "h": -1.38464686724257,
    "CMY_C": 0.4358055,
    "CMY_M": 0.447025,
    "CMY_Y": 0.5085522,
    "CMYK_C": 0,
    "CMYK_M": 0.01988582,
    "CMYK_Y": 0.128939,
    "CMYK_K": 0.4358055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05876",
    "Farbtonhilfsbezeichnung": "G7.07.55",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "151",
    "Bcolor": "136",
    "Y": 31,
    "L": 62.3488005027587,
    "a": -1.71080109316596,
    "b": 7.70917909237252,
    "C": 7.89672607215493,
    "h": -1.35241786335994,
    "CMY_C": 0.3983196,
    "CMY_M": 0.406784,
    "CMY_Y": 0.4667089,
    "CMYK_C": 0,
    "CMYK_M": 0.01406796,
    "CMYK_Y": 0.1136638,
    "CMYK_K": 0.3983196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05877",
    "Farbtonhilfsbezeichnung": "G6.59.51",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "145",
    "Bcolor": "35",
    "Y": 27,
    "L": 59.1275583698659,
    "a": -10.1300276166401,
    "b": 54.9547616883202,
    "C": 55.8806164222797,
    "h": -1.38850865791593,
    "CMY_C": 0.4044199,
    "CMY_M": 0.429674,
    "CMY_Y": 0.8645813,
    "CMYK_C": 0,
    "CMYK_M": 0.04240248,
    "CMYK_Y": 0.7726273,
    "CMYK_K": 0.4044199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05878",
    "Farbtonhilfsbezeichnung": "G7.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "140",
    "Bcolor": "51",
    "Y": 25,
    "L": 57.0807361592761,
    "a": -9.52228041970826,
    "b": 46.1278887721015,
    "C": 47.1004877571658,
    "h": -1.36722370245872,
    "CMY_C": 0.4322252,
    "CMY_M": 0.4508679,
    "CMY_Y": 0.7994474,
    "CMYK_C": 0,
    "CMYK_M": 0.03283468,
    "CMYK_Y": 0.6467743,
    "CMYK_K": 0.4322252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05879",
    "Farbtonhilfsbezeichnung": "G7.35.46",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "129",
    "Bcolor": "73",
    "Y": 21,
    "L": 53.1911924999088,
    "a": -6.81832747730321,
    "b": 30.6827637646635,
    "C": 31.4312198590175,
    "h": -1.35212938323491,
    "CMY_C": 0.4773995,
    "CMY_M": 0.4935607,
    "CMY_Y": 0.7154716,
    "CMYK_C": 0,
    "CMYK_M": 0.03092458,
    "CMYK_Y": 0.4555526,
    "CMYK_K": 0.4773995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05880",
    "Farbtonhilfsbezeichnung": "G6.27.40",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "115",
    "Bcolor": "80",
    "Y": 17,
    "L": 48.2590736908864,
    "a": -3.66587705516619,
    "b": 19.9614549141943,
    "C": 20.2952786843395,
    "h": -1.38917233946193,
    "CMY_C": 0.5264221,
    "CMY_M": 0.5471232,
    "CMY_Y": 0.6863367,
    "CMYK_C": 0,
    "CMYK_M": 0.04371214,
    "CMYK_Y": 0.3376733,
    "CMYK_K": 0.5264221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05881",
    "Farbtonhilfsbezeichnung": "G7.21.43",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "120",
    "Bcolor": "89",
    "Y": 19,
    "L": 50.1729887777904,
    "a": -3.53792453399404,
    "b": 17.4341356249821,
    "C": 17.7894911393921,
    "h": -1.37058420531906,
    "CMY_C": 0.5114,
    "CMY_M": 0.5280781,
    "CMY_Y": 0.6514834,
    "CMYK_C": 0,
    "CMYK_M": 0.03413443,
    "CMYK_Y": 0.2867035,
    "CMYK_K": 0.5114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05885",
    "Farbtonhilfsbezeichnung": "G6.53.43",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "122",
    "Bcolor": "42",
    "Y": 19,
    "L": 50.4819313887603,
    "a": -7.99420518992627,
    "b": 43.0609402812947,
    "C": 43.7967110012598,
    "h": -1.38723745420953,
    "CMY_C": 0.4963586,
    "CMY_M": 0.5196701,
    "CMY_Y": 0.8371408,
    "CMYK_C": 0,
    "CMYK_M": 0.0462858,
    "CMYK_Y": 0.6766366,
    "CMYK_K": 0.4963586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05886",
    "Farbtonhilfsbezeichnung": "G7.41.41",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "118",
    "Bcolor": "60",
    "Y": 17,
    "L": 48.6755503515539,
    "a": -7.17211313580229,
    "b": 31.4630565095482,
    "C": 32.2701585331676,
    "h": -1.34667250665523,
    "CMY_C": 0.5248821,
    "CMY_M": 0.5377944,
    "CMY_Y": 0.7630082,
    "CMYK_C": 0,
    "CMYK_M": 0.02717691,
    "CMYK_Y": 0.5011937,
    "CMYK_K": 0.5248821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05887",
    "Farbtonhilfsbezeichnung": "G6.40.35",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "101",
    "Bcolor": "51",
    "Y": 13,
    "L": 42.1715910215019,
    "a": -5.70193252121723,
    "b": 28.5755021251314,
    "C": 29.1388290118169,
    "h": -1.37384389362083,
    "CMY_C": 0.5857153,
    "CMY_M": 0.6034271,
    "CMY_Y": 0.8010066,
    "CMYK_C": 0,
    "CMYK_M": 0.04275279,
    "CMYK_Y": 0.51967,
    "CMYK_K": 0.5857153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05888",
    "Farbtonhilfsbezeichnung": "G7.31.31",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "93",
    "Bcolor": "59",
    "Y": 11,
    "L": 38.9565203635949,
    "a": -4.14972752146051,
    "b": 19.3415459348908,
    "C": 19.7816995643412,
    "h": -1.35945038161126,
    "CMY_C": 0.6224131,
    "CMY_M": 0.6357043,
    "CMY_Y": 0.7667313,
    "CMYK_C": 0,
    "CMYK_M": 0.03520054,
    "CMYK_Y": 0.3822119,
    "CMYK_K": 0.6224131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05889",
    "Farbtonhilfsbezeichnung": "G7.24.33",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "99",
    "Bcolor": "71",
    "Y": 12,
    "L": 41.6032035753428,
    "a": -3.46917872514055,
    "b": 16.3013770760384,
    "C": 16.6664361998046,
    "h": -1.36110949457453,
    "CMY_C": 0.5981344,
    "CMY_M": 0.6113806,
    "CMY_Y": 0.7230796,
    "CMYK_C": 0,
    "CMYK_M": 0.0329617,
    "CMYK_Y": 0.310913,
    "CMYK_K": 0.5981344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05890",
    "Farbtonhilfsbezeichnung": "G6.16.28",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "86",
    "Bcolor": "69",
    "Y": 9,
    "L": 36.2862850517114,
    "a": -2.11906073344986,
    "b": 9.69881885618084,
    "C": 9.92761328804955,
    "h": -1.35569013269554,
    "CMY_C": 0.6543567,
    "CMY_M": 0.6630291,
    "CMY_Y": 0.7286638,
    "CMYK_C": 0,
    "CMYK_M": 0.02509059,
    "CMYK_Y": 0.2149819,
    "CMYK_K": 0.6543567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05891",
    "Farbtonhilfsbezeichnung": "G7.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "91",
    "Bcolor": "79",
    "Y": 10,
    "L": 38.3612829701322,
    "a": -1.54658245578482,
    "b": 6.82581550037554,
    "C": 6.99883379840588,
    "h": -1.34798003531876,
    "CMY_C": 0.6378087,
    "CMY_M": 0.6441242,
    "CMY_Y": 0.6917854,
    "CMYK_C": 0,
    "CMYK_M": 0.01743694,
    "CMYK_Y": 0.1490282,
    "CMYK_K": 0.6378087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05892",
    "Farbtonhilfsbezeichnung": "G7.05.33",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "97",
    "Bcolor": "90",
    "Y": 12,
    "L": 41.0911546174915,
    "a": -0.73848540347182,
    "b": 3.55213928940815,
    "C": 3.62809236686416,
    "h": -1.36581745650904,
    "CMY_C": 0.6149809,
    "CMY_M": 0.6191531,
    "CMY_Y": 0.6457724,
    "CMYK_C": 0,
    "CMYK_M": 0.01083622,
    "CMYK_Y": 0.07997385,
    "CMYK_K": 0.6149809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05894",
    "Farbtonhilfsbezeichnung": "G7.46.28",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "91",
    "Bcolor": "51",
    "Y": 10,
    "L": 37.9591956229744,
    "a": -5.63712614199929,
    "b": 23.2495869404531,
    "C": 23.9232206034743,
    "h": -1.33292535564343,
    "CMY_C": 0.6346735,
    "CMY_M": 0.6428595,
    "CMY_Y": 0.8016781,
    "CMYK_C": 0,
    "CMYK_M": 0.02240732,
    "CMYK_Y": 0.4571379,
    "CMYK_K": 0.6346735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05895",
    "Farbtonhilfsbezeichnung": "G7.40.30",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "94",
    "Bcolor": "53",
    "Y": 11,
    "L": 39.5058468157694,
    "a": -4.92493270605565,
    "b": 23.6727869978412,
    "C": 24.1796568711042,
    "h": -1.36568021895585,
    "CMY_C": 0.6146338,
    "CMY_M": 0.629656,
    "CMY_Y": 0.7907427,
    "CMYK_C": 0,
    "CMYK_M": 0.03898178,
    "CMYK_Y": 0.4569911,
    "CMYK_K": 0.6146338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05896",
    "Farbtonhilfsbezeichnung": "G7.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "75",
    "Bcolor": "53",
    "Y": 7,
    "L": 31.3809064023778,
    "a": -2.80512845072192,
    "b": 12.857752493071,
    "C": 13.1601878709281,
    "h": -1.35599572737294,
    "CMY_C": 0.6978717,
    "CMY_M": 0.7074987,
    "CMY_Y": 0.7915808,
    "CMYK_C": 0,
    "CMYK_M": 0.03186402,
    "CMYK_Y": 0.3101632,
    "CMYK_K": 0.6978717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05900",
    "Farbtonhilfsbezeichnung": "G7.07.15",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "63",
    "Bcolor": "58",
    "Y": 5,
    "L": 26.6559175565596,
    "a": -0.7822808515121,
    "b": 2.63159130773066,
    "C": 2.74540272848376,
    "h": -1.28185029080006,
    "CMY_C": 0.7508248,
    "CMY_M": 0.7518061,
    "CMY_Y": 0.770627,
    "CMYK_C": 0,
    "CMYK_M": 0.003938077,
    "CMYK_Y": 0.0794709,
    "CMYK_K": 0.7508248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05901",
    "Farbtonhilfsbezeichnung": "G8.34.82",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "228",
    "Bcolor": "131",
    "Y": 75,
    "L": 89.2441664197805,
    "a": -10.552768599065,
    "b": 47.2922914326182,
    "C": 48.4553583626528,
    "h": -1.35125363381497,
    "CMY_C": 0.07949442,
    "CMY_M": 0.1063048,
    "CMY_Y": 0.4864772,
    "CMYK_C": 0,
    "CMYK_M": 0.0291257,
    "CMYK_Y": 0.4421296,
    "CMYK_K": 0.07949442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05902",
    "Farbtonhilfsbezeichnung": "G9.26.84",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "156",
    "Y": 79,
    "L": 91.2592311605641,
    "a": -9.37908700994716,
    "b": 37.4086814160515,
    "C": 38.5665232867547,
    "h": -1.32514057401479,
    "CMY_C": 0.06708935,
    "CMY_M": 0.08480959,
    "CMY_Y": 0.3876563,
    "CMYK_C": 0,
    "CMYK_M": 0.01899458,
    "CMYK_Y": 0.3436202,
    "CMYK_K": 0.06708935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05903",
    "Farbtonhilfsbezeichnung": "G8.19.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "239",
    "Bcolor": "182",
    "Y": 84,
    "L": 93.593184340234,
    "a": -6.16719427039364,
    "b": 27.2167848687472,
    "C": 27.9067673470154,
    "h": -1.34796401879886,
    "CMY_C": 0.03994654,
    "CMY_M": 0.06397026,
    "CMY_Y": 0.2843415,
    "CMYK_C": 0,
    "CMYK_M": 0.02502332,
    "CMYK_Y": 0.2545639,
    "CMYK_K": 0.03994654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05904",
    "Farbtonhilfsbezeichnung": "G8.32.81",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "223",
    "Bcolor": "132",
    "Y": 71,
    "L": 87.5742132851808,
    "a": -10.1018639297978,
    "b": 44.484585259624,
    "C": 45.617167608006,
    "h": -1.34749648926585,
    "CMY_C": 0.100487,
    "CMY_M": 0.1253885,
    "CMY_Y": 0.4813523,
    "CMYK_C": 0,
    "CMYK_M": 0.02768331,
    "CMYK_Y": 0.4234127,
    "CMYK_K": 0.100487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05905",
    "Farbtonhilfsbezeichnung": "G8.30.81",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "228",
    "Bcolor": "144",
    "Y": 75,
    "L": 89.2782539670396,
    "a": -9.2957645726795,
    "b": 40.8783291406924,
    "C": 41.9219397490797,
    "h": -1.34719795081436,
    "CMY_C": 0.08207364,
    "CMY_M": 0.1076796,
    "CMY_Y": 0.435236,
    "CMYK_C": 0,
    "CMYK_M": 0.02789545,
    "CMYK_Y": 0.3847393,
    "CMYK_K": 0.08207364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05906",
    "Farbtonhilfsbezeichnung": "G9.17.81",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "173",
    "Y": 74,
    "L": 89.1327837025055,
    "a": -6.07645177665611,
    "b": 25.8497356132403,
    "C": 26.5543235174322,
    "h": -1.33991970157712,
    "CMY_C": 0.09312893,
    "CMY_M": 0.1137108,
    "CMY_Y": 0.3214285,
    "CMYK_C": 0,
    "CMYK_M": 0.02269542,
    "CMYK_Y": 0.2517442,
    "CMYK_K": 0.09312893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05907",
    "Farbtonhilfsbezeichnung": "G9.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "195",
    "Y": 72,
    "L": 87.9958364420819,
    "a": -3.11610497473291,
    "b": 12.6061642624636,
    "C": 12.9855876888869,
    "h": -1.32846506775833,
    "CMY_C": 0.1188699,
    "CMY_M": 0.1301075,
    "CMY_Y": 0.2344995,
    "CMYK_C": 0,
    "CMYK_M": 0.01275363,
    "CMYK_Y": 0.1312287,
    "CMYK_K": 0.1188699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05909",
    "Farbtonhilfsbezeichnung": "G8.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "239",
    "Bcolor": "212",
    "Y": 83,
    "L": 93.9215545654297,
    "a": -2.89626407623291,
    "b": 12.4664945602417,
    "C": 12.798508644104,
    "h": 103.079162597656,
    "CMY_C": 0.05118328332901,
    "CMY_M": 0.06445300579071,
    "CMY_Y": 0.16916066408157,
    "CMYK_C": 0,
    "CMYK_M": 0.01398554909974,
    "CMYK_Y": 0.12434159219265,
    "CMYK_K": 0.05118328332901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05910",
    "Farbtonhilfsbezeichnung": "G8.48.79",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "220",
    "Bcolor": "90",
    "Y": 68,
    "L": 86.0545650785095,
    "a": -13.5093701824814,
    "b": 62.2134773467809,
    "C": 63.6633320389825,
    "h": -1.35697046649948,
    "CMY_C": 0.1139389,
    "CMY_M": 0.1371914,
    "CMY_Y": 0.646697,
    "CMYK_C": 0,
    "CMYK_M": 0.02624256,
    "CMYK_Y": 0.6012656,
    "CMYK_K": 0.1139389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05911",
    "Farbtonhilfsbezeichnung": "G9.40.78",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "110",
    "Y": 69,
    "L": 86.5669495825207,
    "a": -13.2437989886444,
    "b": 53.9462622223906,
    "C": 55.5481540595054,
    "h": -1.33005756819498,
    "CMY_C": 0.1181822,
    "CMY_M": 0.1310742,
    "CMY_Y": 0.5692577,
    "CMYK_C": 0,
    "CMYK_M": 0.01461981,
    "CMYK_Y": 0.5115291,
    "CMYK_K": 0.1181822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05912",
    "Farbtonhilfsbezeichnung": "G8.20.81",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "215",
    "Bcolor": "162",
    "Y": 67,
    "L": 85.2550699385845,
    "a": -6.69324109561886,
    "b": 25.9912435052471,
    "C": 26.8392290372345,
    "h": -1.31875349881497,
    "CMY_C": 0.1407993,
    "CMY_M": 0.1552432,
    "CMY_Y": 0.3634027,
    "CMYK_C": 0,
    "CMYK_M": 0.0168109,
    "CMYK_Y": 0.259082,
    "CMYK_K": 0.1407993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05913",
    "Farbtonhilfsbezeichnung": "G9.13.79",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "214",
    "Bcolor": "179",
    "Y": 66,
    "L": 85.1715688476471,
    "a": -4.04321344369707,
    "b": 17.2677461215753,
    "C": 17.734785904275,
    "h": -1.34079164333657,
    "CMY_C": 0.1442241,
    "CMY_M": 0.1602662,
    "CMY_Y": 0.2992016,
    "CMYK_C": 0,
    "CMYK_M": 0.01874559,
    "CMYK_Y": 0.1810958,
    "CMYK_K": 0.1442241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05914",
    "Farbtonhilfsbezeichnung": "G9.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "226",
    "Bcolor": "195",
    "Y": 75,
    "L": 89.3471049401264,
    "a": -3.80638664536059,
    "b": 14.718233153233,
    "C": 15.2024658015371,
    "h": -1.31772404751679,
    "CMY_C": 0.1029861,
    "CMY_M": 0.1140329,
    "CMY_Y": 0.2357032,
    "CMYK_C": 0,
    "CMYK_M": 0.01231516,
    "CMYK_Y": 0.1479544,
    "CMYK_K": 0.1029861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05915",
    "Farbtonhilfsbezeichnung": "G8.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "209",
    "Y": 81,
    "L": 92.1651298813928,
    "a": -2.60811509357567,
    "b": 11.1988329027381,
    "C": 11.4985269806522,
    "h": -1.3419832765631,
    "CMY_C": 0.07252302,
    "CMY_M": 0.08452714,
    "CMY_Y": 0.1788179,
    "CMYK_C": 0,
    "CMYK_M": 0.01294277,
    "CMYK_Y": 0.1146065,
    "CMYK_K": 0.07252302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05916",
    "Farbtonhilfsbezeichnung": "G9.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "216",
    "Y": 84,
    "L": 93.5109304233526,
    "a": -1.97284188922375,
    "b": 9.7336626907196,
    "C": 9.93158066455601,
    "h": -1.37082289396136,
    "CMY_C": 0.05691881,
    "CMY_M": 0.07057009,
    "CMY_Y": 0.1530799,
    "CMYK_C": 0,
    "CMYK_M": 0.01447519,
    "CMYK_Y": 0.1019649,
    "CMYK_K": 0.05691881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05917",
    "Farbtonhilfsbezeichnung": "G8.48.76",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "214",
    "Bcolor": "82",
    "Y": 63,
    "L": 83.5922927565965,
    "a": -14.9490646686188,
    "b": 62.6631984493026,
    "C": 64.4216654112825,
    "h": -1.33661136990857,
    "CMY_C": 0.1518382,
    "CMY_M": 0.161274,
    "CMY_Y": 0.6776608,
    "CMYK_C": 0,
    "CMYK_M": 0.01112507,
    "CMYK_Y": 0.6199555,
    "CMYK_K": 0.1518382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05918",
    "Farbtonhilfsbezeichnung": "G9.31.76",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "212",
    "Bcolor": "130",
    "Y": 63,
    "L": 83.5583283874758,
    "a": -10.9684679788612,
    "b": 40.3888706984202,
    "C": 41.8517402995026,
    "h": -1.30562030958433,
    "CMY_C": 0.1598397,
    "CMY_M": 0.167116,
    "CMY_Y": 0.4908886,
    "CMYK_C": 0,
    "CMYK_M": 0.008660574,
    "CMYK_Y": 0.3940306,
    "CMYK_K": 0.1598397
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05919",
    "Farbtonhilfsbezeichnung": "G8.26.77",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "212",
    "Bcolor": "145",
    "Y": 64,
    "L": 83.842061298862,
    "a": -8.14171393369195,
    "b": 33.2038804857048,
    "C": 34.1875004217483,
    "h": -1.33033690959531,
    "CMY_C": 0.1508946,
    "CMY_M": 0.1689417,
    "CMY_Y": 0.4324614,
    "CMYK_C": 0,
    "CMYK_M": 0.02125426,
    "CMYK_Y": 0.3316041,
    "CMYK_K": 0.1508946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05920",
    "Farbtonhilfsbezeichnung": "G9.18.79",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "218",
    "Bcolor": "169",
    "Y": 68,
    "L": 86.1453789649578,
    "a": -6.50576285212484,
    "b": 23.6129170250172,
    "C": 24.4927499623549,
    "h": -1.30194941876141,
    "CMY_C": 0.1352743,
    "CMY_M": 0.1453568,
    "CMY_Y": 0.3363097,
    "CMYK_C": 0,
    "CMYK_M": 0.01165975,
    "CMYK_Y": 0.2324846,
    "CMYK_K": 0.1352743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05921",
    "Farbtonhilfsbezeichnung": "G9.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "219",
    "Bcolor": "190",
    "Y": 70,
    "L": 86.7878294812009,
    "a": -3.84397987130697,
    "b": 13.6264195548123,
    "C": 14.1582305086047,
    "h": -1.29584360702998,
    "CMY_C": 0.1348752,
    "CMY_M": 0.142046,
    "CMY_Y": 0.2551131,
    "CMYK_C": 0,
    "CMYK_M": 0.008288695,
    "CMYK_Y": 0.1389833,
    "CMYK_K": 0.1348752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05922",
    "Farbtonhilfsbezeichnung": "G9.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "223",
    "Bcolor": "199",
    "Y": 73,
    "L": 88.5456710366995,
    "a": -2.99759348067485,
    "b": 11.273148243617,
    "C": 11.6648805393776,
    "h": -1.31090458969427,
    "CMY_C": 0.1157539,
    "CMY_M": 0.1239562,
    "CMY_Y": 0.2187039,
    "CMYK_C": 0,
    "CMYK_M": 0.009275995,
    "CMYK_Y": 0.1164268,
    "CMYK_K": 0.1157539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05923",
    "Farbtonhilfsbezeichnung": "G9.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "229",
    "Bcolor": "207",
    "Y": 78,
    "L": 90.6012143118478,
    "a": -2.93134727474781,
    "b": 10.2761127214244,
    "C": 10.6860324493515,
    "h": -1.29291821562462,
    "CMY_C": 0.09531175,
    "CMY_M": 0.1010007,
    "CMY_Y": 0.1890329,
    "CMYK_C": 0,
    "CMYK_M": 0.006288293,
    "CMYK_Y": 0.1035949,
    "CMYK_K": 0.09531175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05924",
    "Farbtonhilfsbezeichnung": "G9.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "229",
    "Bcolor": "213",
    "Y": 78,
    "L": 90.5656988794245,
    "a": -2.18542816585443,
    "b": 7.00785421542458,
    "C": 7.34071638007858,
    "h": -1.26849998960507,
    "CMY_C": 0.1000547,
    "CMY_M": 0.1022869,
    "CMY_Y": 0.1650716,
    "CMYK_C": 0,
    "CMYK_M": 0.00248033,
    "CMYK_Y": 0.07224538,
    "CMYK_K": 0.1000547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05925",
    "Farbtonhilfsbezeichnung": "G9.41.72",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "200",
    "Bcolor": "97",
    "Y": 54,
    "L": 78.7389816961361,
    "a": -13.8425170732894,
    "b": 50.2397192902136,
    "C": 52.1118477247139,
    "h": -1.30193805239017,
    "CMY_C": 0.2172096,
    "CMY_M": 0.2150488,
    "CMY_Y": 0.6190028,
    "CMYK_C": 0.002752748,
    "CMYK_M": 0,
    "CMYK_Y": 0.514623,
    "CMYK_K": 0.2150488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05926",
    "Farbtonhilfsbezeichnung": "G8.40.72",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "201",
    "Bcolor": "100",
    "Y": 55,
    "L": 79.2104779753787,
    "a": -12.1759406022561,
    "b": 49.3156407296105,
    "C": 50.7965151375731,
    "h": -1.3287391731778,
    "CMY_C": 0.2017734,
    "CMY_M": 0.2133001,
    "CMY_Y": 0.6061435,
    "CMYK_C": 0,
    "CMYK_M": 0.01444039,
    "CMYK_Y": 0.5065856,
    "CMYK_K": 0.2017734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05927",
    "Farbtonhilfsbezeichnung": "G9.35.74",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "206",
    "Bcolor": "116",
    "Y": 60,
    "L": 81.6900695291379,
    "a": -8.74865020164589,
    "b": 44.8206489228593,
    "C": 45.6665024959978,
    "h": -1.37802770041693,
    "CMY_C": 0.1573727,
    "CMY_M": 0.1930624,
    "CMY_Y": 0.5440082,
    "CMYK_C": 0,
    "CMYK_M": 0.04235526,
    "CMYK_Y": 0.4588453,
    "CMYK_K": 0.1573727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05928",
    "Farbtonhilfsbezeichnung": "G8.25.74",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "206",
    "Bcolor": "142",
    "Y": 60,
    "L": 82.0270495116385,
    "a": -7.23511548162575,
    "b": 32.1784720189305,
    "C": 32.9818276859478,
    "h": -1.3496309901378,
    "CMY_C": 0.1668727,
    "CMY_M": 0.1906251,
    "CMY_Y": 0.4432498,
    "CMYK_C": 0,
    "CMYK_M": 0.02850994,
    "CMYK_Y": 0.3317345,
    "CMYK_K": 0.1668727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05929",
    "Farbtonhilfsbezeichnung": "G9.22.73",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "201",
    "Bcolor": "146",
    "Y": 57,
    "L": 79.9918777851899,
    "a": -7.06106499999853,
    "b": 27.0082782003683,
    "C": 27.9160478987032,
    "h": -1.31507920309617,
    "CMY_C": 0.1994984,
    "CMY_M": 0.212209,
    "CMY_Y": 0.4256376,
    "CMYK_C": 0,
    "CMYK_M": 0.01587834,
    "CMYK_Y": 0.2824969,
    "CMYK_K": 0.1994984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05930",
    "Farbtonhilfsbezeichnung": "G8.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "206",
    "Bcolor": "165",
    "Y": 60,
    "L": 82.0105435673783,
    "a": -4.71439615672931,
    "b": 20.0531081207848,
    "C": 20.599822242594,
    "h": -1.33989383432216,
    "CMY_C": 0.1768939,
    "CMY_M": 0.1940117,
    "CMY_Y": 0.3530817,
    "CMYK_C": 0,
    "CMYK_M": 0.02079656,
    "CMYK_Y": 0.2140523,
    "CMYK_K": 0.1768939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05931",
    "Farbtonhilfsbezeichnung": "G8.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "202",
    "Bcolor": "170",
    "Y": 58,
    "L": 80.6655182174869,
    "a": -4.22834427716334,
    "b": 15.3716500325447,
    "C": 15.9426007931345,
    "h": -1.30236113756938,
    "CMY_C": 0.2003571,
    "CMY_M": 0.2087206,
    "CMY_Y": 0.3328975,
    "CMYK_C": 0,
    "CMYK_M": 0.010459,
    "CMYK_Y": 0.1657495,
    "CMYK_K": 0.2003571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05933",
    "Farbtonhilfsbezeichnung": "G8.49.69",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "194",
    "Bcolor": "73",
    "Y": 51,
    "L": 76.5916768956088,
    "a": -13.8180214396122,
    "b": 58.6894011508814,
    "C": 60.2941417050999,
    "h": -1.3395643860829,
    "CMY_C": 0.2293921,
    "CMY_M": 0.2393115,
    "CMY_Y": 0.7144713,
    "CMYK_C": 0,
    "CMYK_M": 0.01287229,
    "CMYK_Y": 0.629476,
    "CMYK_K": 0.2293921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05934",
    "Farbtonhilfsbezeichnung": "G8.26.66",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "184",
    "Bcolor": "124",
    "Y": 46,
    "L": 73.6173961910316,
    "a": -7.7319518451206,
    "b": 30.3404338705794,
    "C": 31.3101422352289,
    "h": -1.32126771650342,
    "CMY_C": 0.2669685,
    "CMY_M": 0.2800607,
    "CMY_Y": 0.5151423,
    "CMYK_C": 0,
    "CMYK_M": 0.01786045,
    "CMYK_Y": 0.3385582,
    "CMYK_K": 0.2669685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05935",
    "Farbtonhilfsbezeichnung": "G8.22.68",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "188",
    "Bcolor": "136",
    "Y": 49,
    "L": 75.6341429173351,
    "a": -5.68816731244165,
    "b": 26.2976826117464,
    "C": 26.9058238699817,
    "h": -1.35777871544519,
    "CMY_C": 0.2391796,
    "CMY_M": 0.2621531,
    "CMY_Y": 0.464715,
    "CMYK_C": 0,
    "CMYK_M": 0.03019573,
    "CMYK_Y": 0.296437,
    "CMYK_K": 0.2391796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05936",
    "Farbtonhilfsbezeichnung": "G9.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "193",
    "Bcolor": "145",
    "Y": 52,
    "L": 77.2929828716781,
    "a": -5.93120333980612,
    "b": 23.9727607662707,
    "C": 24.6955953930043,
    "h": -1.32825275939334,
    "CMY_C": 0.2280101,
    "CMY_M": 0.2433178,
    "CMY_Y": 0.4308417,
    "CMYK_C": 0,
    "CMYK_M": 0.0198289,
    "CMYK_Y": 0.2627386,
    "CMYK_K": 0.2280101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05937",
    "Farbtonhilfsbezeichnung": "G9.12.72",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "197",
    "Bcolor": "166",
    "Y": 55,
    "L": 79.1822744720502,
    "a": -3.29604365892372,
    "b": 15.6107979006118,
    "C": 15.9549652113465,
    "h": -1.36271377321439,
    "CMY_C": 0.2090761,
    "CMY_M": 0.226977,
    "CMY_Y": 0.3500242,
    "CMYK_C": 0,
    "CMYK_M": 0.02263286,
    "CMYK_Y": 0.1782069,
    "CMYK_K": 0.2090761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05938",
    "Farbtonhilfsbezeichnung": "G8.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "199",
    "Bcolor": "181",
    "Y": 56,
    "L": 79.8210511397338,
    "a": -2.2368056179477,
    "b": 8.48516579440128,
    "C": 8.77504062275269,
    "h": -1.31304641207781,
    "CMY_C": 0.2142868,
    "CMY_M": 0.2207445,
    "CMY_Y": 0.2915869,
    "CMYK_C": 0,
    "CMYK_M": 0.008218827,
    "CMYK_Y": 0.098382,
    "CMYK_K": 0.2142868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05939",
    "Farbtonhilfsbezeichnung": "G9.06.76",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "208",
    "Bcolor": "191",
    "Y": 63,
    "L": 83.299109047962,
    "a": -2.10776812322294,
    "b": 7.99953524700123,
    "C": 8.27256010128001,
    "h": -1.31316548020814,
    "CMY_C": 0.1767714,
    "CMY_M": 0.1830031,
    "CMY_Y": 0.25098,
    "CMYK_C": 0,
    "CMYK_M": 0.007569888,
    "CMYK_Y": 0.09014337,
    "CMYK_K": 0.1767714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05940",
    "Farbtonhilfsbezeichnung": "G9.56.63",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "180",
    "Bcolor": "47",
    "Y": 42,
    "L": 70.8098518041165,
    "a": -17.4736654907038,
    "b": 62.1230136053341,
    "C": 64.5336951141769,
    "h": -1.29660548705508,
    "CMY_C": 0.3153453,
    "CMY_M": 0.294176,
    "CMY_Y": 0.8143306,
    "CMYK_C": 0.02999238,
    "CMYK_M": 0,
    "CMYK_Y": 0.7369466,
    "CMYK_K": 0.294176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05941",
    "Farbtonhilfsbezeichnung": "G8.33.63",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "177",
    "Bcolor": "103",
    "Y": 42,
    "L": 71.1539847224166,
    "a": -9.01528215777564,
    "b": 37.8473761074542,
    "C": 38.9062872888612,
    "h": -1.33695307729068,
    "CMY_C": 0.2885151,
    "CMY_M": 0.3047813,
    "CMY_Y": 0.5959473,
    "CMYK_C": 0,
    "CMYK_M": 0.02286241,
    "CMYK_Y": 0.4320995,
    "CMYK_K": 0.2885151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05942",
    "Farbtonhilfsbezeichnung": "G8.25.65",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "180",
    "Bcolor": "123",
    "Y": 44,
    "L": 72.3516281601839,
    "a": -6.75574121686134,
    "b": 28.7587314050999,
    "C": 29.5415753036273,
    "h": -1.34006874770889,
    "CMY_C": 0.2771905,
    "CMY_M": 0.2953711,
    "CMY_Y": 0.5160354,
    "CMYK_C": 0,
    "CMYK_M": 0.02515271,
    "CMYK_Y": 0.3304396,
    "CMYK_K": 0.2771905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05943",
    "Farbtonhilfsbezeichnung": "G8.19.69",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "191",
    "Bcolor": "144",
    "Y": 51,
    "L": 76.7554597197397,
    "a": -5.67997923372093,
    "b": 23.8343921901059,
    "C": 24.5018451380153,
    "h": -1.33684970774562,
    "CMY_C": 0.2324129,
    "CMY_M": 0.2496359,
    "CMY_Y": 0.4352923,
    "CMYK_C": 0,
    "CMYK_M": 0.02243787,
    "CMYK_Y": 0.264308,
    "CMYK_K": 0.2324129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05944",
    "Farbtonhilfsbezeichnung": "G8.51.35",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "107",
    "Bcolor": "48",
    "Y": 14,
    "L": 44.1928747021483,
    "a": -8.64002119027796,
    "b": 32.4408249496521,
    "C": 33.5716709381946,
    "h": -1.31050665675092,
    "CMY_C": 0.5780889,
    "CMY_M": 0.5788893,
    "CMY_Y": 0.8114864,
    "CMYK_C": 0,
    "CMYK_M": 0.00189721,
    "CMYK_Y": 0.5531912,
    "CMYK_K": 0.5780889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05945",
    "Farbtonhilfsbezeichnung": "G8.43.35",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "105",
    "Bcolor": "51",
    "Y": 13,
    "L": 43.3582678226856,
    "a": -8.0007871663437,
    "b": 29.7496798200928,
    "C": 30.806753231705,
    "h": -1.30807560738792,
    "CMY_C": 0.5862707,
    "CMY_M": 0.5878286,
    "CMY_Y": 0.7992702,
    "CMYK_C": 0,
    "CMYK_M": 0.003765268,
    "CMYK_Y": 0.5148281,
    "CMYK_K": 0.5862707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05946",
    "Farbtonhilfsbezeichnung": "G9.23.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "82",
    "Bcolor": "60",
    "Y": 8,
    "L": 34.3227862415124,
    "a": -3.63872227837841,
    "b": 12.7013651342876,
    "C": 13.2123039661395,
    "h": -1.29178632576614,
    "CMY_C": 0.6758742,
    "CMY_M": 0.6789213,
    "CMY_Y": 0.7651019,
    "CMYK_C": 0,
    "CMYK_M": 0.009400967,
    "CMYK_Y": 0.2752874,
    "CMYK_K": 0.6758742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05947",
    "Farbtonhilfsbezeichnung": "G8.14.25",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "79",
    "Bcolor": "65",
    "Y": 8,
    "L": 33.442608378516,
    "a": -2.31100350432792,
    "b": 8.15394613682752,
    "C": 8.47511503162643,
    "h": -1.29461771044726,
    "CMY_C": 0.6855853,
    "CMY_M": 0.6887161,
    "CMY_Y": 0.7444693,
    "CMYK_C": 0,
    "CMYK_M": 0.009957319,
    "CMYK_Y": 0.1872813,
    "CMYK_K": 0.6855853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05948",
    "Farbtonhilfsbezeichnung": "H0.14.16",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "62",
    "Bcolor": "52",
    "Y": 5,
    "L": 25.7841028317636,
    "a": -2.03501561015859,
    "b": 5.44973099475178,
    "C": 5.81728944172003,
    "h": -1.21341527495244,
    "CMY_C": 0.7594112,
    "CMY_M": 0.7577863,
    "CMY_Y": 0.7948962,
    "CMYK_C": 0.006708722,
    "CMYK_M": 0,
    "CMYK_Y": 0.1532116,
    "CMYK_K": 0.7577863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05949",
    "Farbtonhilfsbezeichnung": "G7.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "71",
    "Bcolor": "63",
    "Y": 6,
    "L": 29.9192409015458,
    "a": -1.30764632814878,
    "b": 4.77001598694033,
    "C": 4.94600762587234,
    "h": -1.30323096827199,
    "CMY_C": 0.7195373,
    "CMY_M": 0.7220668,
    "CMY_Y": 0.754873,
    "CMYK_C": 0,
    "CMYK_M": 0.009019118,
    "CMYK_Y": 0.1259912,
    "CMYK_K": 0.7195373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05950",
    "Farbtonhilfsbezeichnung": "G9.10.11",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "55",
    "Bcolor": "51",
    "Y": 4,
    "L": 22.722974169099,
    "a": -1.22179810448894,
    "b": 1.75403804743136,
    "C": 2.1376248688602,
    "h": -0.96238076196232,
    "CMY_C": 0.7901945,
    "CMY_M": 0.7852806,
    "CMY_Y": 0.7994207,
    "CMYK_C": 0.02288485,
    "CMYK_M": 0,
    "CMYK_Y": 0.06585367,
    "CMYK_K": 0.7852806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05951",
    "Farbtonhilfsbezeichnung": "G8.57.44",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "128",
    "Bcolor": "36",
    "Y": 20,
    "L": 52.0003957301371,
    "a": -11.6192728085422,
    "b": 46.7896438108486,
    "C": 48.2107692175246,
    "h": -1.32739003363865,
    "CMY_C": 0.4988039,
    "CMY_M": 0.4980008,
    "CMY_Y": 0.8576083,
    "CMYK_C": 0.00159971,
    "CMYK_M": 0,
    "CMYK_Y": 0.7163507,
    "CMYK_K": 0.4980008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05952",
    "Farbtonhilfsbezeichnung": "G8.55.42",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "122",
    "Bcolor": "47",
    "Y": 18,
    "L": 49.7260372292951,
    "a": -10.1571737484988,
    "b": 39.4053241805529,
    "C": 40.6933379354859,
    "h": -1.3185262088727,
    "CMY_C": 0.5219676,
    "CMY_M": 0.5226396,
    "CMY_Y": 0.8145346,
    "CMYK_C": 0,
    "CMYK_M": 0.001405761,
    "CMYK_Y": 0.6120234,
    "CMYK_K": 0.5219676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05953",
    "Farbtonhilfsbezeichnung": "G8.30.41",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "117",
    "Bcolor": "73",
    "Y": 17,
    "L": 48.4493954532376,
    "a": -5.88982863232518,
    "b": 24.3254180262395,
    "C": 25.0283048461029,
    "h": -1.33324162219925,
    "CMY_C": 0.5306478,
    "CMY_M": 0.5415269,
    "CMY_Y": 0.7146269,
    "CMYK_C": 0,
    "CMYK_M": 0.02317882,
    "CMYK_Y": 0.3919851,
    "CMYK_K": 0.5306478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05954",
    "Farbtonhilfsbezeichnung": "G8.25.32",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "95",
    "Bcolor": "65",
    "Y": 11,
    "L": 40.0269131977379,
    "a": -3.66626733139161,
    "b": 17.4712129320593,
    "C": 17.8517449416741,
    "h": -1.36395145812224,
    "CMY_C": 0.6124415,
    "CMY_M": 0.6262047,
    "CMY_Y": 0.7449132,
    "CMYK_C": 0,
    "CMYK_M": 0.03551263,
    "CMYK_Y": 0.3418108,
    "CMYK_K": 0.6124415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05955",
    "Farbtonhilfsbezeichnung": "G8.11.40",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "116",
    "Bcolor": "101",
    "Y": 17,
    "L": 48.5703256788803,
    "a": -2.19065564785387,
    "b": 8.08964117683983,
    "C": 8.38100629623297,
    "h": -1.30634120917845,
    "CMY_C": 0.5401012,
    "CMY_M": 0.544777,
    "CMY_Y": 0.6045372,
    "CMYK_C": 0,
    "CMYK_M": 0.01016698,
    "CMYK_Y": 0.1401092,
    "CMYK_K": 0.5401012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05956",
    "Farbtonhilfsbezeichnung": "G9.54.46",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "136",
    "Bcolor": "51",
    "Y": 23,
    "L": 55.0992180498327,
    "a": -11.9029439109409,
    "b": 43.7419926531624,
    "C": 45.3325710170548,
    "h": -1.30511230148173,
    "CMY_C": 0.4714237,
    "CMY_M": 0.46606,
    "CMY_Y": 0.7993469,
    "CMYK_C": 0.01004562,
    "CMYK_M": 0,
    "CMYK_Y": 0.6242029,
    "CMYK_K": 0.46606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05957",
    "Farbtonhilfsbezeichnung": "G8.44.45",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "129",
    "Bcolor": "60",
    "Y": 21,
    "L": 52.7261121535389,
    "a": -9.80941908727528,
    "b": 36.4901630041395,
    "C": 37.7856679032999,
    "h": -1.30818123034075,
    "CMY_C": 0.4925549,
    "CMY_M": 0.4931158,
    "CMY_Y": 0.763384,
    "CMYK_C": 0,
    "CMYK_M": 0.001105265,
    "CMYK_Y": 0.5337111,
    "CMYK_K": 0.4925549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05958",
    "Farbtonhilfsbezeichnung": "G8.37.41",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "118",
    "Bcolor": "64",
    "Y": 17,
    "L": 48.7908330125067,
    "a": -7.38967708587429,
    "b": 29.8641530280095,
    "C": 30.7648332274671,
    "h": -1.32822564971225,
    "CMY_C": 0.5275057,
    "CMY_M": 0.536029,
    "CMY_Y": 0.7505161,
    "CMYK_C": 0,
    "CMYK_M": 0.01803909,
    "CMYK_Y": 0.4719855,
    "CMYK_K": 0.5275057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05959",
    "Farbtonhilfsbezeichnung": "G9.24.48",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "135",
    "Bcolor": "95",
    "Y": 24,
    "L": 55.6798824240622,
    "a": -5.91596893737484,
    "b": 21.510038558862,
    "C": 22.3087527054229,
    "h": -1.30239950103702,
    "CMY_C": 0.4626524,
    "CMY_M": 0.4689052,
    "CMY_Y": 0.627484,
    "CMYK_C": 0,
    "CMYK_M": 0.01163653,
    "CMYK_Y": 0.3067505,
    "CMYK_K": 0.4626524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05960",
    "Farbtonhilfsbezeichnung": "G8.20.44",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "124",
    "Bcolor": "93",
    "Y": 20,
    "L": 51.3223767889627,
    "a": -4.50888093293556,
    "b": 16.4790736559683,
    "C": 17.0847849218601,
    "h": -1.30372049848576,
    "CMY_C": 0.5082601,
    "CMY_M": 0.5145349,
    "CMY_Y": 0.6343926,
    "CMYK_C": 0,
    "CMYK_M": 0.01276038,
    "CMYK_Y": 0.2565024,
    "CMYK_K": 0.5082601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05961",
    "Farbtonhilfsbezeichnung": "G9.14.44",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "124",
    "Bcolor": "103",
    "Y": 20,
    "L": 51.7155175166564,
    "a": -3.21043813312832,
    "b": 11.5825122388352,
    "C": 12.0192138998111,
    "h": -1.30040472818276,
    "CMY_C": 0.5069609,
    "CMY_M": 0.5123035,
    "CMY_Y": 0.5976872,
    "CMYK_C": 0,
    "CMYK_M": 0.01083602,
    "CMYK_Y": 0.1840143,
    "CMYK_K": 0.5069609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05962",
    "Farbtonhilfsbezeichnung": "G8.12.46",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "129",
    "Bcolor": "110",
    "Y": 22,
    "L": 53.7545718070682,
    "a": -2.3067371370053,
    "b": 10.2260586057602,
    "C": 10.483001041099,
    "h": -1.3489352200061,
    "CMY_C": 0.4836896,
    "CMY_M": 0.4935157,
    "CMY_Y": 0.568826,
    "CMYK_C": 0,
    "CMYK_M": 0.01903152,
    "CMYK_Y": 0.1648939,
    "CMYK_K": 0.4836896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05963",
    "Farbtonhilfsbezeichnung": "G8.57.52",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "151",
    "Bcolor": "40",
    "Y": 29,
    "L": 60.3700979755641,
    "a": -13.7919619947243,
    "b": 53.9564312593662,
    "C": 55.691244284094,
    "h": -1.32054191380821,
    "CMY_C": 0.4152369,
    "CMY_M": 0.4097206,
    "CMY_Y": 0.8416101,
    "CMYK_C": 0.009345238,
    "CMYK_M": 0,
    "CMYK_Y": 0.7316697,
    "CMYK_K": 0.4097206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05964",
    "Farbtonhilfsbezeichnung": "G7.50.51",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "147",
    "Bcolor": "58",
    "Y": 28,
    "L": 59.5915509744161,
    "a": -10.4205470269661,
    "b": 45.8742705486089,
    "C": 47.0429218768157,
    "h": -1.34743214817836,
    "CMY_C": 0.4112715,
    "CMY_M": 0.4234851,
    "CMY_Y": 0.7728285,
    "CMYK_C": 0,
    "CMYK_M": 0.02074574,
    "CMYK_Y": 0.614132,
    "CMYK_K": 0.4112715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05965",
    "Farbtonhilfsbezeichnung": "G8.31.46",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "130",
    "Bcolor": "83",
    "Y": 22,
    "L": 53.5864262725449,
    "a": -5.99852859303385,
    "b": 25.5092436073124,
    "C": 26.2050349112275,
    "h": -1.33984110847306,
    "CMY_C": 0.4769193,
    "CMY_M": 0.490474,
    "CMY_Y": 0.6750371,
    "CMYK_C": 0,
    "CMYK_M": 0.02591321,
    "CMYK_Y": 0.3787519,
    "CMYK_K": 0.4769193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05966",
    "Farbtonhilfsbezeichnung": "G8.29.52",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "146",
    "Bcolor": "92",
    "Y": 28,
    "L": 59.4661016356964,
    "a": -7.16293366951248,
    "b": 28.0438987970348,
    "C": 28.9442201223693,
    "h": -1.32072433269889,
    "CMY_C": 0.4188958,
    "CMY_M": 0.4289492,
    "CMY_Y": 0.6373267,
    "CMYK_C": 0,
    "CMYK_M": 0.01730064,
    "CMYK_Y": 0.3758893,
    "CMYK_K": 0.4188958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05967",
    "Farbtonhilfsbezeichnung": "G8.11.54",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "149",
    "Bcolor": "127",
    "Y": 30,
    "L": 61.3129917258197,
    "a": -3.05901662806268,
    "b": 11.3232828034272,
    "C": 11.7292078239391,
    "h": -1.30694207401185,
    "CMY_C": 0.4088327,
    "CMY_M": 0.415386,
    "CMY_Y": 0.5021075,
    "CMYK_C": 0,
    "CMYK_M": 0.01108539,
    "CMYK_Y": 0.1577807,
    "CMYK_K": 0.4088327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05968",
    "Farbtonhilfsbezeichnung": "G9.62.62",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "177",
    "Bcolor": "26",
    "Y": 40,
    "L": 69.4936012937675,
    "a": -19.1154261706567,
    "b": 66.8027711712018,
    "C": 69.4838812519694,
    "h": -1.29209646863763,
    "CMY_C": 0.3363676,
    "CMY_M": 0.3053621,
    "CMY_Y": 0.8964365,
    "CMYK_C": 0.04463542,
    "CMYK_M": 0,
    "CMYK_Y": 0.8509101,
    "CMYK_K": 0.3053621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05969",
    "Farbtonhilfsbezeichnung": "G8.51.59",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "166",
    "Bcolor": "57",
    "Y": 36,
    "L": 66.5253442814466,
    "a": -12.7035948365806,
    "b": 53.9712038104471,
    "C": 55.4461194541224,
    "h": -1.33962686684635,
    "CMY_C": 0.3405657,
    "CMY_M": 0.3480057,
    "CMY_Y": 0.7755269,
    "CMYK_C": 0,
    "CMYK_M": 0.01128232,
    "CMYK_Y": 0.6595975,
    "CMYK_K": 0.3405657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05970",
    "Farbtonhilfsbezeichnung": "G8.26.56",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "153",
    "Bcolor": "102",
    "Y": 31,
    "L": 62.502621099655,
    "a": -6.37436945962483,
    "b": 26.6833606671251,
    "C": 27.4341816444318,
    "h": -1.33630181464106,
    "CMY_C": 0.3842827,
    "CMY_M": 0.3991215,
    "CMY_Y": 0.5981725,
    "CMYK_C": 0,
    "CMYK_M": 0.0240999,
    "CMYK_Y": 0.3473832,
    "CMYK_K": 0.3842827
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05971",
    "Farbtonhilfsbezeichnung": "G8.24.63",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "173",
    "Bcolor": "122",
    "Y": 41,
    "L": 70.1249835213534,
    "a": -6.15035717473311,
    "b": 26.3790746899391,
    "C": 27.0865737012671,
    "h": -1.34173553847464,
    "CMY_C": 0.3020476,
    "CMY_M": 0.3198597,
    "CMY_Y": 0.5208825,
    "CMYK_C": 0,
    "CMYK_M": 0.02552038,
    "CMYK_Y": 0.3135385,
    "CMYK_K": 0.3020476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05972",
    "Farbtonhilfsbezeichnung": "G8.19.59",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "162",
    "Bcolor": "124",
    "Y": 35,
    "L": 65.8088537220994,
    "a": -4.85531879929146,
    "b": 19.3838114819276,
    "C": 19.9826491789668,
    "h": -1.32536295489427,
    "CMY_C": 0.3545777,
    "CMY_M": 0.366645,
    "CMY_Y": 0.5137379,
    "CMYK_C": 0,
    "CMYK_M": 0.01869683,
    "CMYK_Y": 0.2465987,
    "CMYK_K": 0.3545777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05973",
    "Farbtonhilfsbezeichnung": "G9.11.62",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "171",
    "Bcolor": "146",
    "Y": 40,
    "L": 69.481106807877,
    "a": -3.45568931680101,
    "b": 12.2211610904821,
    "C": 12.7003372811027,
    "h": -1.29522755340519,
    "CMY_C": 0.3237297,
    "CMY_M": 0.3296017,
    "CMY_Y": 0.4260595,
    "CMYK_C": 0,
    "CMYK_M": 0.008682878,
    "CMYK_Y": 0.1513149,
    "CMYK_K": 0.3237297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05974",
    "Farbtonhilfsbezeichnung": "G9.05.64",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "177",
    "Bcolor": "165",
    "Y": 44,
    "L": 72.0945783749266,
    "a": -1.40354763275624,
    "b": 5.82311168523275,
    "C": 5.98987275792315,
    "h": -1.33427718011102,
    "CMY_C": 0.2991851,
    "CMY_M": 0.3049302,
    "CMY_Y": 0.3536674,
    "CMYK_C": 0,
    "CMYK_M": 0.008197749,
    "CMYK_Y": 0.07774145,
    "CMYK_K": 0.2991851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05975",
    "Farbtonhilfsbezeichnung": "G9.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "192",
    "Bcolor": "166",
    "Y": 52,
    "L": 77.2183833739312,
    "a": -3.51663553775583,
    "b": 12.4734062329567,
    "C": 12.9596523316704,
    "h": -1.29599823063524,
    "CMY_C": 0.2405806,
    "CMY_M": 0.2469824,
    "CMY_Y": 0.3479258,
    "CMYK_C": 0,
    "CMYK_M": 0.00842984,
    "CMYK_Y": 0.1413516,
    "CMYK_K": 0.2405806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05976",
    "Farbtonhilfsbezeichnung": "G8.15.64",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "178",
    "Bcolor": "145",
    "Y": 44,
    "L": 72.0018466596105,
    "a": -4.3781945855137,
    "b": 16.7334750522194,
    "C": 17.2967562031692,
    "h": -1.31489003249754,
    "CMY_C": 0.2917245,
    "CMY_M": 0.3018866,
    "CMY_Y": 0.4324545,
    "CMYK_C": 0,
    "CMYK_M": 0.01434774,
    "CMYK_Y": 0.198694,
    "CMYK_K": 0.2917245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05977",
    "Farbtonhilfsbezeichnung": "H1.40.83",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "233",
    "Bcolor": "124",
    "Y": 77,
    "L": 90.1376184365166,
    "a": -15.4335816138976,
    "b": 51.6530380769348,
    "C": 53.9094776825942,
    "h": -1.28044696545045,
    "CMY_C": 0.09657113,
    "CMY_M": 0.08639847,
    "CMY_Y": 0.5138309,
    "CMYK_C": 0.01113468,
    "CMYK_M": 0,
    "CMYK_Y": 0.4678544,
    "CMYK_K": 0.08639847
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05978",
    "Farbtonhilfsbezeichnung": "H0.35.84",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "234",
    "Bcolor": "135",
    "Y": 79,
    "L": 91.1786742301133,
    "a": -12.3418716765611,
    "b": 47.732599989865,
    "C": 49.3023619948696,
    "h": -1.31777499531759,
    "CMY_C": 0.06923877,
    "CMY_M": 0.08087378,
    "CMY_Y": 0.4703537,
    "CMYK_C": 0,
    "CMYK_M": 0.01250052,
    "CMYK_Y": 0.4309537,
    "CMYK_K": 0.06923877
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05979",
    "Farbtonhilfsbezeichnung": "H0.18.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "237",
    "Bcolor": "183",
    "Y": 83,
    "L": 92.7998638643513,
    "a": -6.74778324299946,
    "b": 25.9270684438419,
    "C": 26.7907718587234,
    "h": -1.31618458746583,
    "CMY_C": 0.05646954,
    "CMY_M": 0.07126735,
    "CMY_Y": 0.28315,
    "CMYK_C": 0,
    "CMYK_M": 0.01568345,
    "CMYK_Y": 0.2402471,
    "CMYK_K": 0.05646954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05980",
    "Farbtonhilfsbezeichnung": "H1.07.89",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "242",
    "Bcolor": "219",
    "Y": 88,
    "L": 94.9603042602539,
    "a": -3.26496505737305,
    "b": 10.4794654846191,
    "C": 10.9763011932373,
    "h": 107.304862976074,
    "CMY_C": 0.04832988977432,
    "CMY_M": 0.05140066146851,
    "CMY_Y": 0.14295238256454,
    "CMYK_C": 0,
    "CMYK_M": 0.0032267186325,
    "CMYK_Y": 0.09942782670259,
    "CMYK_K": 0.04832988977432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05981",
    "Farbtonhilfsbezeichnung": "H1.06.88",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 85,
    "L": 93.8400548159352,
    "a": -3.27302932768858,
    "b": 10.1736704025625,
    "C": 10.6872021801726,
    "h": -1.25953784148966,
    "CMY_C": 0.06196616,
    "CMY_M": 0.0639345,
    "CMY_Y": 0.1529592,
    "CMYK_C": 0,
    "CMYK_M": 0.002098373,
    "CMYK_Y": 0.09700402,
    "CMYK_K": 0.06196616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05982",
    "Farbtonhilfsbezeichnung": "H1.41.80",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "224",
    "Bcolor": "109",
    "Y": 69,
    "L": 86.589320282437,
    "a": -17.849684913658,
    "b": 54.1518149372441,
    "C": 57.0178069774207,
    "h": -1.25238876076353,
    "CMY_C": 0.1504716,
    "CMY_M": 0.1211419,
    "CMY_Y": 0.5721389,
    "CMYK_C": 0.0333725,
    "CMYK_M": 0,
    "CMYK_Y": 0.5131625,
    "CMYK_K": 0.1211419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05983",
    "Farbtonhilfsbezeichnung": "H0.25.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "227",
    "Bcolor": "157",
    "Y": 74,
    "L": 88.8382305470126,
    "a": -9.62698667851181,
    "b": 33.4729089260907,
    "C": 34.8297933453904,
    "h": -1.29074922785531,
    "CMY_C": 0.1048925,
    "CMY_M": 0.1105212,
    "CMY_Y": 0.3828726,
    "CMYK_C": 0,
    "CMYK_M": 0.006288307,
    "CMYK_Y": 0.310555,
    "CMYK_K": 0.1048925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05984",
    "Farbtonhilfsbezeichnung": "H1.11.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "241",
    "Bcolor": "205",
    "Y": 86,
    "L": 94.4318389892578,
    "a": -4.55042839050293,
    "b": 16.7445659637451,
    "C": 17.3518562316895,
    "h": 105.203285217285,
    "CMY_C": 0.04574078321457,
    "CMY_M": 0.05590176582336,
    "CMY_Y": 0.19595623016357,
    "CMYK_C": 0,
    "CMYK_M": 0.01064803171903,
    "CMYK_Y": 0.15741576254368,
    "CMYK_K": 0.04574078321457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05985",
    "Farbtonhilfsbezeichnung": "H1.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "238",
    "Bcolor": "220",
    "Y": 85,
    "L": 93.8912390286331,
    "a": -2.33941333698306,
    "b": 8.33285341602943,
    "C": 8.65501593379744,
    "h": -1.29709620669129,
    "CMY_C": 0.05982956,
    "CMY_M": 0.06507091,
    "CMY_Y": 0.1384983,
    "CMYK_C": 0,
    "CMYK_M": 0.005574892,
    "CMYK_Y": 0.083675,
    "CMYK_K": 0.05982956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05986",
    "Farbtonhilfsbezeichnung": "H0.57.76",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "215",
    "Bcolor": "69",
    "Y": 63,
    "L": 83.2326866129729,
    "a": -18.7609610923069,
    "b": 67.4900766217629,
    "C": 70.0491549093812,
    "h": -1.29966079266528,
    "CMY_C": 0.1764249,
    "CMY_M": 0.1578479,
    "CMY_Y": 0.730953,
    "CMYK_C": 0.02205897,
    "CMYK_M": 0,
    "CMYK_Y": 0.6805245,
    "CMYK_K": 0.1578479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05987",
    "Farbtonhilfsbezeichnung": "H0.33.81",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "225",
    "Bcolor": "134",
    "Y": 73,
    "L": 87.9829940795898,
    "a": -11.4341859817505,
    "b": 43.997875213623,
    "C": 45.4593620300293,
    "h": 104.567802429199,
    "CMY_C": 0.10621750354767,
    "CMY_M": 0.11782687902451,
    "CMY_Y": 0.47361463308334,
    "CMYK_C": 0,
    "CMYK_M": 0.01298903860152,
    "CMYK_Y": 0.41105875372887,
    "CMYK_K": 0.10621750354767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05988",
    "Farbtonhilfsbezeichnung": "H1.21.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "230",
    "Bcolor": "169",
    "Y": 76,
    "L": 90.0834229726541,
    "a": -8.75717956840011,
    "b": 28.989751391898,
    "C": 30.2835579111381,
    "h": -1.2774337772349,
    "CMY_C": 0.09471782,
    "CMY_M": 0.097728,
    "CMY_Y": 0.3355593,
    "CMYK_C": 0,
    "CMYK_M": 0.003325128,
    "CMYK_Y": 0.2660403,
    "CMYK_K": 0.09471782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05989",
    "Farbtonhilfsbezeichnung": "H1.13.84",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "232",
    "Bcolor": "193",
    "Y": 79,
    "L": 91.0935277416056,
    "a": -5.54792347459138,
    "b": 18.2399749455342,
    "C": 19.0650502462919,
    "h": -1.27552475740508,
    "CMY_C": 0.08681025,
    "CMY_M": 0.0914027,
    "CMY_Y": 0.2434279,
    "CMYK_C": 0,
    "CMYK_M": 0.005029023,
    "CMYK_Y": 0.1715062,
    "CMYK_K": 0.08681025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05990",
    "Farbtonhilfsbezeichnung": "H1.08.85",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "233",
    "Bcolor": "207",
    "Y": 80,
    "L": 91.8811818957812,
    "a": -3.49910549873506,
    "b": 11.9170178170535,
    "C": 12.4201068007988,
    "h": -1.28520059844798,
    "CMY_C": 0.08042752,
    "CMY_M": 0.08580454,
    "CMY_Y": 0.1874,
    "CMYK_C": 0,
    "CMYK_M": 0.005847307,
    "CMYK_Y": 0.1163285,
    "CMYK_K": 0.08042752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05991",
    "Farbtonhilfsbezeichnung": "HN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "219",
    "Y": 75,
    "L": 89.5623001173716,
    "a": -0.75439272386751,
    "b": 2.2338175206279,
    "C": 2.35776357960005,
    "h": -1.24510785549116,
    "CMY_C": 0.1155796,
    "CMY_M": 0.1155111,
    "CMY_Y": 0.1405549,
    "CMYK_C": 7.743522e-05,
    "CMYK_M": 0,
    "CMYK_Y": 0.0283145,
    "CMYK_K": 0.1155111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05992",
    "Farbtonhilfsbezeichnung": "H0.40.74",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "207",
    "Bcolor": "102",
    "Y": 59,
    "L": 81.2098157746757,
    "a": -14.3793315673442,
    "b": 50.9672001348715,
    "C": 52.9567811135805,
    "h": -1.29581438031647,
    "CMY_C": 0.191963,
    "CMY_M": 0.187134,
    "CMY_Y": 0.599973,
    "CMYK_C": 0.005940706,
    "CMYK_M": 0,
    "CMYK_Y": 0.5078807,
    "CMYK_K": 0.187134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05993",
    "Farbtonhilfsbezeichnung": "H0.33.73",
    "Farbtonklasse": "03",
    "Rcolor": "205",
    "Gcolor": "204",
    "Bcolor": "121",
    "Y": 58,
    "L": 80.4764609205979,
    "a": -11.2834402872305,
    "b": 40.834302426497,
    "C": 42.3645639582672,
    "h": -1.30120092893302,
    "CMY_C": 0.1957938,
    "CMY_M": 0.2002075,
    "CMY_Y": 0.5258557,
    "CMYK_C": 0,
    "CMYK_M": 0.00548819,
    "CMYK_Y": 0.4104194,
    "CMYK_K": 0.1957938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05994",
    "Farbtonhilfsbezeichnung": "H0.31.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "224",
    "Bcolor": "138",
    "Y": 71,
    "L": 87.5132090141063,
    "a": -11.6542606043675,
    "b": 41.2769211379442,
    "C": 42.8906284503104,
    "h": -1.29561604117767,
    "CMY_C": 0.1183705,
    "CMY_M": 0.1221494,
    "CMY_Y": 0.4572072,
    "CMYK_C": 0,
    "CMYK_M": 0.004286302,
    "CMYK_Y": 0.3843301,
    "CMYK_K": 0.1183705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05995",
    "Farbtonhilfsbezeichnung": "H1.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "221",
    "Bcolor": "193",
    "Y": 71,
    "L": 87.3963874104877,
    "a": -4.2358362317807,
    "b": 12.9453682315618,
    "C": 13.6207513461334,
    "h": -1.25456809419695,
    "CMY_C": 0.1330671,
    "CMY_M": 0.134255,
    "CMY_Y": 0.2436243,
    "CMYK_C": 0,
    "CMYK_M": 0.001370239,
    "CMYK_Y": 0.1275268,
    "CMYK_K": 0.1330671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05996",
    "Farbtonhilfsbezeichnung": "H0.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "223",
    "Bcolor": "207",
    "Y": 73,
    "L": 88.5635375675157,
    "a": -2.08223158039345,
    "b": 7.22205012167019,
    "C": 7.51622886255495,
    "h": -1.2900930965773,
    "CMY_C": 0.1208609,
    "CMY_M": 0.1248441,
    "CMY_Y": 0.188464,
    "CMYK_C": 0,
    "CMYK_M": 0.004530809,
    "CMYK_Y": 0.07689688,
    "CMYK_K": 0.1208609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05997",
    "Farbtonhilfsbezeichnung": "H1.47.74",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "210",
    "Bcolor": "90",
    "Y": 59,
    "L": 81.532892890776,
    "a": -18.7332559906086,
    "b": 56.9427556554264,
    "C": 59.9450773762389,
    "h": -1.25296525915549,
    "CMY_C": 0.2099427,
    "CMY_M": 0.1754102,
    "CMY_Y": 0.6488661,
    "CMYK_C": 0.04187842,
    "CMYK_M": 0,
    "CMYK_Y": 0.5741714,
    "CMYK_K": 0.1754102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05998",
    "Farbtonhilfsbezeichnung": "H1.40.70",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "198",
    "Bcolor": "99",
    "Y": 52,
    "L": 77.5754235543831,
    "a": -14.739980440659,
    "b": 47.7557547393624,
    "C": 49.9787868411903,
    "h": -1.27141957817555,
    "CMY_C": 0.2404857,
    "CMY_M": 0.2254808,
    "CMY_Y": 0.6107713,
    "CMYK_C": 0.01937319,
    "CMYK_M": 0,
    "CMYK_Y": 0.4974577,
    "CMYK_K": 0.2254808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI05999",
    "Farbtonhilfsbezeichnung": "H1.30.70",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "196",
    "Bcolor": "124",
    "Y": 53,
    "L": 77.610654085788,
    "a": -11.5610941814735,
    "b": 35.6649345651975,
    "C": 37.4919518858744,
    "h": -1.25732566066497,
    "CMY_C": 0.239502,
    "CMY_M": 0.2299069,
    "CMY_Y": 0.5154378,
    "CMYK_C": 0.01245968,
    "CMYK_M": 0,
    "CMYK_Y": 0.3707746,
    "CMYK_K": 0.2299069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06000",
    "Farbtonhilfsbezeichnung": "H0.25.76",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "211",
    "Bcolor": "145",
    "Y": 63,
    "L": 83.3058542207832,
    "a": -8.52237790927879,
    "b": 32.5247335867289,
    "C": 33.6227485508882,
    "h": -1.31452999391903,
    "CMY_C": 0.1610703,
    "CMY_M": 0.1738616,
    "CMY_Y": 0.4329498,
    "CMYK_C": 0,
    "CMYK_M": 0.01524713,
    "CMYK_Y": 0.324079,
    "CMYK_K": 0.1610703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06002",
    "Farbtonhilfsbezeichnung": "H0.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "221",
    "Bcolor": "194",
    "Y": 71,
    "L": 87.5866241455078,
    "a": -3.31784749031067,
    "b": 12.6146440505981,
    "C": 13.0436706542969,
    "h": 104.735939025879,
    "CMY_C": 0.12491595745087,
    "CMY_M": 0.13414466381073,
    "CMY_Y": 0.23899477720261,
    "CMYK_C": 0,
    "CMYK_M": 0.01054607983679,
    "CMYK_Y": 0.13036327064037,
    "CMYK_K": 0.12491595745087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06003",
    "Farbtonhilfsbezeichnung": "HN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "216",
    "Bcolor": "210",
    "Y": 68,
    "L": 86.147865768978,
    "a": -0.8238810945112,
    "b": 1.89455652260646,
    "C": 2.06594396711132,
    "h": -1.16059757745526,
    "CMY_C": 0.1550308,
    "CMY_M": 0.1530481,
    "CMY_Y": 0.175435,
    "CMYK_C": 0.002341038,
    "CMYK_M": 0,
    "CMYK_Y": 0.02643232,
    "CMYK_K": 0.1530481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06004",
    "Farbtonhilfsbezeichnung": "H0.53.70",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "201",
    "Bcolor": "65",
    "Y": 53,
    "L": 78.1378697264667,
    "a": -19.1867188668627,
    "b": 63.4967467675187,
    "C": 66.3322472929602,
    "h": -1.27735124115967,
    "CMY_C": 0.2427416,
    "CMY_M": 0.2122265,
    "CMY_Y": 0.7468407,
    "CMYK_C": 0.03873592,
    "CMYK_M": 0,
    "CMYK_Y": 0.6786395,
    "CMYK_K": 0.2122265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06005",
    "Farbtonhilfsbezeichnung": "H0.46.68",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "193",
    "Bcolor": "80",
    "Y": 50,
    "L": 75.9645623634427,
    "a": -15.8242371463438,
    "b": 54.836737304072,
    "C": 57.0742870250653,
    "h": -1.2898584776435,
    "CMY_C": 0.2553437,
    "CMY_M": 0.2415458,
    "CMY_Y": 0.6870003,
    "CMYK_C": 0.01819216,
    "CMYK_M": 0,
    "CMYK_Y": 0.587319,
    "CMYK_K": 0.2415458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06006",
    "Farbtonhilfsbezeichnung": "H1.38.70",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "199",
    "Bcolor": "105",
    "Y": 53,
    "L": 77.8510349963435,
    "a": -15.1343010610389,
    "b": 45.4847011703846,
    "C": 47.9364695108573,
    "h": -1.24958537817852,
    "CMY_C": 0.2440179,
    "CMY_M": 0.2213801,
    "CMY_Y": 0.5898641,
    "CMYK_C": 0.02907429,
    "CMYK_M": 0,
    "CMYK_Y": 0.4732527,
    "CMYK_K": 0.2213801
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06007",
    "Farbtonhilfsbezeichnung": "H1.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "195",
    "Bcolor": "145",
    "Y": 53,
    "L": 77.7116928100586,
    "a": -8.24499893188477,
    "b": 24.4120674133301,
    "C": 25.7668209075928,
    "h": 108.66202545166,
    "CMY_C": 0.23908412456512,
    "CMY_M": 0.23382067680359,
    "CMY_Y": 0.43018120527267,
    "CMYK_C": 0.00686973333359,
    "CMYK_M": 0,
    "CMYK_Y": 0.25628533959389,
    "CMYK_K": 0.23382067680359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06008",
    "Farbtonhilfsbezeichnung": "H0.16.74",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "206",
    "Bcolor": "165",
    "Y": 60,
    "L": 82.0694920915351,
    "a": -5.48834253961483,
    "b": 20.2626097998556,
    "C": 20.9927430254683,
    "h": -1.30628254608597,
    "CMY_C": 0.1813862,
    "CMY_M": 0.1916783,
    "CMY_Y": 0.3541357,
    "CMYK_C": 0,
    "CMYK_M": 0.01257264,
    "CMYK_Y": 0.2110268,
    "CMYK_K": 0.1813862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06009",
    "Farbtonhilfsbezeichnung": "HN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "219",
    "Bcolor": "211",
    "Y": 70,
    "L": 87.1503147671533,
    "a": -1.75566799296711,
    "b": 2.77180090511095,
    "C": 3.2810440958791,
    "h": -1.00617695882422,
    "CMY_C": 0.1483537,
    "CMY_M": 0.1400563,
    "CMY_Y": 0.1710633,
    "CMYK_C": 0.009648832,
    "CMYK_M": 0,
    "CMYK_Y": 0.03605707,
    "CMYK_K": 0.1400563
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06010",
    "Farbtonhilfsbezeichnung": "HN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "212",
    "Bcolor": "203",
    "Y": 66,
    "L": 84.8727236108374,
    "a": -0.94014468000797,
    "b": 4.11837315147081,
    "C": 4.22431881302807,
    "h": -1.34636156774724,
    "CMY_C": 0.1626756,
    "CMY_M": 0.1674206,
    "CMY_Y": 0.2055614,
    "CMYK_C": 0,
    "CMYK_M": 0.005666841,
    "CMYK_Y": 0.05121755,
    "CMYK_K": 0.1626756
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06011",
    "Farbtonhilfsbezeichnung": "H0.50.65",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "181",
    "Bcolor": "64",
    "Y": 42,
    "L": 71.1496812676004,
    "a": -17.1849472647537,
    "b": 56.1837108124813,
    "C": 58.7531426661833,
    "h": -1.2739623694423,
    "CMY_C": 0.3166941,
    "CMY_M": 0.2905582,
    "CMY_Y": 0.7497215,
    "CMYK_C": 0.0368401,
    "CMYK_M": 0,
    "CMYK_Y": 0.6472176,
    "CMYK_K": 0.2905582
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06012",
    "Farbtonhilfsbezeichnung": "H1.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "168",
    "Bcolor": "85",
    "Y": 37,
    "L": 67.1564966270739,
    "a": -12.4696178137206,
    "b": 41.91696990906,
    "C": 43.7324105758795,
    "h": -1.28164960515763,
    "CMY_C": 0.3487651,
    "CMY_M": 0.3404663,
    "CMY_Y": 0.667452,
    "CMYK_C": 0.01258278,
    "CMYK_M": 0,
    "CMYK_Y": 0.4957832,
    "CMYK_K": 0.3404663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06013",
    "Farbtonhilfsbezeichnung": "H0.40.65",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "182",
    "Bcolor": "92",
    "Y": 44,
    "L": 72.069354622427,
    "a": -12.8287978039363,
    "b": 44.5247842523397,
    "C": 46.3361032652906,
    "h": -1.29026735982,
    "CMY_C": 0.2934169,
    "CMY_M": 0.2880998,
    "CMY_Y": 0.639562,
    "CMYK_C": 0.007468877,
    "CMYK_M": 0,
    "CMYK_Y": 0.4936959,
    "CMYK_K": 0.2880998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06014",
    "Farbtonhilfsbezeichnung": "H0.25.69",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "192",
    "Bcolor": "130",
    "Y": 51,
    "L": 76.5637570200754,
    "a": -8.59806409891117,
    "b": 31.1132313653829,
    "C": 32.279403220085,
    "h": -1.301177776189,
    "CMY_C": 0.2392392,
    "CMY_M": 0.2467278,
    "CMY_Y": 0.4913229,
    "CMYK_C": 0,
    "CMYK_M": 0.009843552,
    "CMYK_Y": 0.3313574,
    "CMYK_K": 0.2392392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06015",
    "Farbtonhilfsbezeichnung": "H0.15.70",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "190",
    "Bcolor": "153",
    "Y": 50,
    "L": 76.228456182282,
    "a": -5.61616869119586,
    "b": 18.1574204670154,
    "C": 19.0061376608704,
    "h": -1.27082546312312,
    "CMY_C": 0.2515137,
    "CMY_M": 0.2542768,
    "CMY_Y": 0.3995058,
    "CMYK_C": 0,
    "CMYK_M": 0.00369167,
    "CMYK_Y": 0.1977219,
    "CMYK_K": 0.2515137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06016",
    "Farbtonhilfsbezeichnung": "H1.13.74",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "205",
    "Bcolor": "169",
    "Y": 59,
    "L": 81.5423511731924,
    "a": -5.26495665752519,
    "b": 17.3987135879415,
    "C": 18.1778712483293,
    "h": -1.27695034401311,
    "CMY_C": 0.1929849,
    "CMY_M": 0.1973038,
    "CMY_Y": 0.3386441,
    "CMYK_C": 0,
    "CMYK_M": 0.005351718,
    "CMYK_Y": 0.1804913,
    "CMYK_K": 0.1929849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06017",
    "Farbtonhilfsbezeichnung": "H0.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "199",
    "Bcolor": "180",
    "Y": 57,
    "L": 80.0048157946666,
    "a": -2.73798651015289,
    "b": 8.92026139787074,
    "C": 9.33100388683458,
    "h": -1.27298463240848,
    "CMY_C": 0.2147642,
    "CMY_M": 0.2177214,
    "CMY_Y": 0.2928571,
    "CMYK_C": 0,
    "CMYK_M": 0.003766031,
    "CMYK_Y": 0.09945159,
    "CMYK_K": 0.2147642
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06018",
    "Farbtonhilfsbezeichnung": "H1.51.60",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "169",
    "Bcolor": "63",
    "Y": 37,
    "L": 66.9336768893468,
    "a": -15.7066680931671,
    "b": 51.7485178333312,
    "C": 54.0796497819236,
    "h": -1.27611405516545,
    "CMY_C": 0.3589007,
    "CMY_M": 0.3375781,
    "CMY_Y": 0.7521939,
    "CMYK_C": 0.03218893,
    "CMYK_M": 0,
    "CMYK_Y": 0.625909,
    "CMYK_K": 0.3375781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06019",
    "Farbtonhilfsbezeichnung": "H0.45.60",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "167",
    "Bcolor": "71",
    "Y": 36,
    "L": 66.5044055630928,
    "a": -13.4342468449381,
    "b": 47.676230409135,
    "C": 49.5328369298152,
    "h": -1.29613704337527,
    "CMY_C": 0.3537761,
    "CMY_M": 0.346095,
    "CMY_Y": 0.7205983,
    "CMYK_C": 0.01174653,
    "CMYK_M": 0,
    "CMYK_Y": 0.5727182,
    "CMYK_K": 0.346095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06020",
    "Farbtonhilfsbezeichnung": "H0.40.55",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "156",
    "Bcolor": "80",
    "Y": 31,
    "L": 62.7537815931186,
    "a": -11.7193292306802,
    "b": 38.6135385844295,
    "C": 40.352794694151,
    "h": -1.27612877233304,
    "CMY_C": 0.3963097,
    "CMY_M": 0.3874746,
    "CMY_Y": 0.684581,
    "CMYK_C": 0.01442407,
    "CMYK_M": 0,
    "CMYK_Y": 0.4850516,
    "CMYK_K": 0.3874746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06021",
    "Farbtonhilfsbezeichnung": "H0.39.60",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "170",
    "Bcolor": "88",
    "Y": 38,
    "L": 67.7500497524358,
    "a": -12.2005777640997,
    "b": 41.264470041645,
    "C": 43.030344939306,
    "h": -1.28331869144851,
    "CMY_C": 0.3415481,
    "CMY_M": 0.334679,
    "CMY_Y": 0.6564701,
    "CMYK_C": 0.01032438,
    "CMYK_M": 0,
    "CMYK_Y": 0.4836628,
    "CMYK_K": 0.334679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06022",
    "Farbtonhilfsbezeichnung": "H0.20.65",
    "Farbtonklasse": "03",
    "Rcolor": "180",
    "Gcolor": "177",
    "Bcolor": "132",
    "Y": 43,
    "L": 71.503196610229,
    "a": -6.31822725458142,
    "b": 23.1640307285208,
    "C": 24.0102543766698,
    "h": -1.30451356590765,
    "CMY_C": 0.2954332,
    "CMY_M": 0.3042932,
    "CMY_Y": 0.4839002,
    "CMYK_C": 0,
    "CMYK_M": 0.01257516,
    "CMYK_Y": 0.2674935,
    "CMYK_K": 0.2954332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06023",
    "Farbtonhilfsbezeichnung": "H1.09.70",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "192",
    "Bcolor": "169",
    "Y": 52,
    "L": 77.3497476885152,
    "a": -3.43261380116305,
    "b": 11.1987443503355,
    "C": 11.7130146645561,
    "h": -1.27337073326522,
    "CMY_C": 0.2421269,
    "CMY_M": 0.2454517,
    "CMY_Y": 0.3373697,
    "CMYK_C": 0,
    "CMYK_M": 0.004386999,
    "CMYK_Y": 0.1256711,
    "CMYK_K": 0.2421269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06024",
    "Farbtonhilfsbezeichnung": "H0.05.71",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 54,
    "L": 78.6402195166258,
    "a": -2.31232344515525,
    "b": 7.5807563725514,
    "C": 7.92557296950784,
    "h": -1.27473545004899,
    "CMY_C": 0.2303839,
    "CMY_M": 0.2331413,
    "CMY_Y": 0.2975851,
    "CMYK_C": 0,
    "CMYK_M": 0.0035828,
    "CMYK_Y": 0.08731782,
    "CMYK_K": 0.2303839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06025",
    "Farbtonhilfsbezeichnung": "H0.48.56",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "157",
    "Bcolor": "63",
    "Y": 31,
    "L": 62.5478597747012,
    "a": -13.963664739679,
    "b": 46.6943705520954,
    "C": 48.7375437852438,
    "h": -1.28021695703895,
    "CMY_C": 0.4015865,
    "CMY_M": 0.3861946,
    "CMY_Y": 0.7517887,
    "CMYK_C": 0.02507624,
    "CMYK_M": 0,
    "CMYK_Y": 0.5956188,
    "CMYK_K": 0.3861946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06026",
    "Farbtonhilfsbezeichnung": "H0.42.50",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "145",
    "Bcolor": "69",
    "Y": 27,
    "L": 58.5682482070107,
    "a": -10.3889624483921,
    "b": 39.0950850418157,
    "C": 40.4519000194169,
    "h": -1.31106323256698,
    "CMY_C": 0.4312331,
    "CMY_M": 0.4332283,
    "CMY_Y": 0.7281564,
    "CMYK_C": 0,
    "CMYK_M": 0.003507968,
    "CMYK_Y": 0.5220474,
    "CMYK_K": 0.4312331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06027",
    "Farbtonhilfsbezeichnung": "H1.33.54",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "152",
    "Bcolor": "90",
    "Y": 30,
    "L": 61.4418963339371,
    "a": -10.2184245073876,
    "b": 32.0796030282458,
    "C": 33.6677461357754,
    "h": -1.26242433277149,
    "CMY_C": 0.4112491,
    "CMY_M": 0.4031074,
    "CMY_Y": 0.6481157,
    "CMYK_C": 0.01364023,
    "CMYK_M": 0,
    "CMYK_Y": 0.410473,
    "CMYK_K": 0.4031074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06028",
    "Farbtonhilfsbezeichnung": "H1.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "144",
    "Bcolor": "92",
    "Y": 25,
    "L": 58.4994888305664,
    "a": -8.26333332061768,
    "b": 26.7133140563965,
    "C": 27.9621849060059,
    "h": 107.188613891602,
    "CMY_C": 0.43887263536453,
    "CMY_M": 0.43637651205063,
    "CMY_Y": 0.63735389709473,
    "CMYK_C": 0.0044287070632,
    "CMYK_M": 0,
    "CMYK_Y": 0.35658091306686,
    "CMYK_K": 0.43637651205063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06029",
    "Farbtonhilfsbezeichnung": "H0.26.55",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "156",
    "Bcolor": "106",
    "Y": 32,
    "L": 63.4892199716636,
    "a": -7.41724418867895,
    "b": 25.9951815556599,
    "C": 27.0326649715897,
    "h": -1.29285059827216,
    "CMY_C": 0.382327,
    "CMY_M": 0.3866298,
    "CMY_Y": 0.5838674,
    "CMYK_C": 0,
    "CMYK_M": 0.006966109,
    "CMYK_Y": 0.3262897,
    "CMYK_K": 0.382327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06030",
    "Farbtonhilfsbezeichnung": "H1.17.59",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "162",
    "Bcolor": "128",
    "Y": 35,
    "L": 65.7506948884871,
    "a": -6.1659540629373,
    "b": 17.077668639337,
    "C": 18.1567000212386,
    "h": -1.22430832338538,
    "CMY_C": 0.3699312,
    "CMY_M": 0.3640151,
    "CMY_Y": 0.4983186,
    "CMYK_C": 0.009302313,
    "CMYK_M": 0,
    "CMYK_Y": 0.2111741,
    "CMYK_K": 0.3640151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06031",
    "Farbtonhilfsbezeichnung": "H1.10.62",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "170",
    "Bcolor": "148",
    "Y": 40,
    "L": 69.1560464327359,
    "a": -3.345702026255,
    "b": 10.9802147791028,
    "C": 11.4786252941593,
    "h": -1.27503065427573,
    "CMY_C": 0.3297525,
    "CMY_M": 0.3329862,
    "CMY_Y": 0.4206288,
    "CMYK_C": 0,
    "CMYK_M": 0.004824596,
    "CMYK_Y": 0.1355862,
    "CMYK_K": 0.3297525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06032",
    "Farbtonhilfsbezeichnung": "H1.50.49",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "141",
    "Bcolor": "49",
    "Y": 25,
    "L": 56.6942576626368,
    "a": -13.6761802611122,
    "b": 46.4288123149632,
    "C": 48.4011623777004,
    "h": -1.28433563378786,
    "CMY_C": 0.4626828,
    "CMY_M": 0.4468132,
    "CMY_Y": 0.8075064,
    "CMYK_C": 0.02868759,
    "CMYK_M": 0,
    "CMYK_Y": 0.652028,
    "CMYK_K": 0.4468132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06033",
    "Farbtonhilfsbezeichnung": "H1.46.45",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "131",
    "Bcolor": "58",
    "Y": 21,
    "L": 52.9486967153483,
    "a": -12.4565586988601,
    "b": 37.9833953151944,
    "C": 39.9737935939095,
    "h": -1.25390084874868,
    "CMY_C": 0.5052566,
    "CMY_M": 0.4860467,
    "CMY_Y": 0.77352,
    "CMYK_C": 0.03737673,
    "CMYK_M": 0,
    "CMYK_Y": 0.5593374,
    "CMYK_K": 0.4860467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06034",
    "Farbtonhilfsbezeichnung": "H1.40.51",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "145",
    "Bcolor": "73",
    "Y": 26,
    "L": 58.4020625001037,
    "a": -12.2337130874058,
    "b": 36.7898994766595,
    "C": 38.7706130904281,
    "h": -1.24976973429977,
    "CMY_C": 0.4487409,
    "CMY_M": 0.4310485,
    "CMY_Y": 0.7126249,
    "CMYK_C": 0.03109635,
    "CMYK_M": 0,
    "CMYK_Y": 0.494904,
    "CMYK_K": 0.4310485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06035",
    "Farbtonhilfsbezeichnung": "H1.28.47",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "132",
    "Bcolor": "88",
    "Y": 22,
    "L": 54.1022065864884,
    "a": -8.00705571456978,
    "b": 23.5004980703774,
    "C": 24.8271293300703,
    "h": -1.24241386491286,
    "CMY_C": 0.4887366,
    "CMY_M": 0.4809769,
    "CMY_Y": 0.6566095,
    "CMYK_C": 0.01495051,
    "CMYK_M": 0,
    "CMYK_Y": 0.3383906,
    "CMYK_K": 0.4809769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06036",
    "Farbtonhilfsbezeichnung": "H1.12.39",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "113",
    "Bcolor": "96",
    "Y": 16,
    "L": 47.0841160724222,
    "a": -3.004331532522,
    "b": 8.75742347539774,
    "C": 9.25842718201928,
    "h": -1.2403164591087,
    "CMY_C": 0.5585083,
    "CMY_M": 0.5578498,
    "CMY_Y": 0.6231539,
    "CMYK_C": 0.001489509,
    "CMYK_M": 0,
    "CMYK_Y": 0.1476966,
    "CMYK_K": 0.5578498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06037",
    "Farbtonhilfsbezeichnung": "H1.05.54",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "152",
    "Bcolor": "140",
    "Y": 30,
    "L": 62.4465293884277,
    "a": -2.02109122276306,
    "b": 5.28673887252808,
    "C": 5.65989542007446,
    "h": 110.921585083008,
    "CMY_C": 0.4064547419548,
    "CMY_M": 0.40450233221054,
    "CMY_Y": 0.44912767410278,
    "CMYK_C": 0.00327861867845,
    "CMYK_M": 0,
    "CMYK_Y": 0.07493789494038,
    "CMYK_K": 0.40450233221054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06038",
    "Farbtonhilfsbezeichnung": "HN.01.48",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "133",
    "Bcolor": "130",
    "Y": 23,
    "L": 55.4107469327594,
    "a": -0.43581935873288,
    "b": 0.73914623734017,
    "C": 0.85806507539957,
    "h": -1.03804017199689,
    "CMY_C": 0.4804951,
    "CMY_M": 0.4785806,
    "CMY_Y": 0.4888063,
    "CMYK_C": 0.003671676,
    "CMYK_M": 0,
    "CMYK_Y": 0.01961125,
    "CMYK_K": 0.4785806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06039",
    "Farbtonhilfsbezeichnung": "H0.46.41",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "119",
    "Bcolor": "56",
    "Y": 17,
    "L": 48.577282598227,
    "a": -10.649956032584,
    "b": 33.3287562748137,
    "C": 34.9889633787842,
    "h": -1.261508388417,
    "CMY_C": 0.5451877,
    "CMY_M": 0.532391,
    "CMY_Y": 0.7784582,
    "CMYK_C": 0.02736618,
    "CMYK_M": 0,
    "CMYK_Y": 0.5262242,
    "CMYK_K": 0.532391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06040",
    "Farbtonhilfsbezeichnung": "H0.35.44",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "126",
    "Bcolor": "71",
    "Y": 20,
    "L": 51.4311340971037,
    "a": -8.82098466238557,
    "b": 29.3167524175803,
    "C": 30.6150574509953,
    "h": -1.27852737787064,
    "CMY_C": 0.5106557,
    "CMY_M": 0.5070258,
    "CMY_Y": 0.7225534,
    "CMYK_C": 0.007363278,
    "CMYK_M": 0,
    "CMYK_Y": 0.4371985,
    "CMYK_K": 0.5070258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06041",
    "Farbtonhilfsbezeichnung": "H1.39.35",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "104",
    "Bcolor": "54",
    "Y": 13,
    "L": 42.6484251928094,
    "a": -8.96772123467901,
    "b": 27.0339156382278,
    "C": 28.4824967107473,
    "h": -1.25049745014244,
    "CMY_C": 0.6034826,
    "CMY_M": 0.5925494,
    "CMY_Y": 0.7866849,
    "CMYK_C": 0.02683307,
    "CMYK_M": 0,
    "CMYK_Y": 0.4764638,
    "CMYK_K": 0.5925494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06042",
    "Farbtonhilfsbezeichnung": "H1.29.39",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "114",
    "Bcolor": "76",
    "Y": 16,
    "L": 47.1911415032249,
    "a": -7.07556230452933,
    "b": 20.8108106293033,
    "C": 21.9807511467192,
    "h": -1.24306270057019,
    "CMY_C": 0.5574366,
    "CMY_M": 0.5510336,
    "CMY_Y": 0.7025418,
    "CMYK_C": 0.01426171,
    "CMYK_M": 0,
    "CMYK_Y": 0.3374599,
    "CMYK_K": 0.5510336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06043",
    "Farbtonhilfsbezeichnung": "H1.24.30",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "91",
    "Bcolor": "66",
    "Y": 10,
    "L": 38.0715944761942,
    "a": -5.09776631199058,
    "b": 14.1272801388779,
    "C": 15.0188969466469,
    "h": -1.22449239991927,
    "CMY_C": 0.6467686,
    "CMY_M": 0.6414232,
    "CMY_Y": 0.7411069,
    "CMYK_C": 0.01490749,
    "CMYK_M": 0,
    "CMYK_Y": 0.2779984,
    "CMYK_K": 0.6414232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06044",
    "Farbtonhilfsbezeichnung": "H1.12.26",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "85",
    "Bcolor": "73",
    "Y": 9,
    "L": 35.7246172045893,
    "a": -2.32084699584062,
    "b": 6.78439544196183,
    "C": 7.17038020547132,
    "h": -1.24118912521248,
    "CMY_C": 0.6676694,
    "CMY_M": 0.6673024,
    "CMY_Y": 0.715582,
    "CMYK_C": 0.001102931,
    "CMYK_M": 0,
    "CMYK_Y": 0.1451156,
    "CMYK_K": 0.6673024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06045",
    "Farbtonhilfsbezeichnung": "H1.05.46",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "129",
    "Bcolor": "119",
    "Y": 22,
    "L": 53.6287718598609,
    "a": -1.89621573528004,
    "b": 4.84692970649223,
    "C": 5.20464808554819,
    "h": -1.19788177332657,
    "CMY_C": 0.4965464,
    "CMY_M": 0.4944197,
    "CMY_Y": 0.5340682,
    "CMYK_C": 0.00420629,
    "CMYK_M": 0,
    "CMYK_Y": 0.07842179,
    "CMYK_K": 0.4944197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06046",
    "Farbtonhilfsbezeichnung": "H0.36.24",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "81",
    "Bcolor": "51",
    "Y": 8,
    "L": 33.6985195240062,
    "a": -5.37653357785753,
    "b": 17.358788951675,
    "C": 18.1723599783469,
    "h": -1.27043722023445,
    "CMY_C": 0.6835341,
    "CMY_M": 0.6822296,
    "CMY_Y": 0.8002317,
    "CMYK_C": 0.004105199,
    "CMYK_M": 0,
    "CMYK_Y": 0.3713438,
    "CMYK_K": 0.6822296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06047",
    "Farbtonhilfsbezeichnung": "H0.35.28",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "92",
    "Bcolor": "56",
    "Y": 10,
    "L": 37.987388630869,
    "a": -6.20705129367796,
    "b": 20.3268945599913,
    "C": 21.2534733212093,
    "h": -1.27442799955388,
    "CMY_C": 0.6427054,
    "CMY_M": 0.6411325,
    "CMY_Y": 0.7821456,
    "CMYK_C": 0.004382881,
    "CMYK_M": 0,
    "CMYK_Y": 0.3929392,
    "CMYK_K": 0.6411325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06048",
    "Farbtonhilfsbezeichnung": "H0.35.29",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "99",
    "Bcolor": "62",
    "Y": 11,
    "L": 41.193904876709,
    "a": -6.43860483169556,
    "b": 20.6199626922607,
    "C": 21.6018161773682,
    "h": 107.341026306152,
    "CMY_C": 0.61263692378998,
    "CMY_M": 0.61028760671616,
    "CMY_Y": 0.75563341379166,
    "CMYK_C": 0.00602833554149,
    "CMYK_M": 0,
    "CMYK_Y": 0.37295660376549,
    "CMYK_K": 0.61028760671616
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06049",
    "Farbtonhilfsbezeichnung": "H1.29.25",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "83",
    "Bcolor": "56",
    "Y": 8,
    "L": 34.4982780886342,
    "a": -5.84581562189498,
    "b": 15.2411586903842,
    "C": 16.3238009823284,
    "h": -1.20454695849004,
    "CMY_C": 0.6828938,
    "CMY_M": 0.6736556,
    "CMY_Y": 0.7798983,
    "CMYK_C": 0.02830788,
    "CMYK_M": 0,
    "CMYK_Y": 0.325554,
    "CMYK_K": 0.6736556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06050",
    "Farbtonhilfsbezeichnung": "H1.25.22",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "76",
    "Bcolor": "54",
    "Y": 7,
    "L": 31.8583982103987,
    "a": -4.42176801525543,
    "b": 12.8881142840051,
    "C": 13.6255466744756,
    "h": -1.24029167232054,
    "CMY_C": 0.7032104,
    "CMY_M": 0.7001746,
    "CMY_Y": 0.7878922,
    "CMYK_C": 0.01012497,
    "CMYK_M": 0,
    "CMYK_Y": 0.2925622,
    "CMYK_K": 0.7001746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06051",
    "Farbtonhilfsbezeichnung": "H0.11.18",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "70",
    "Bcolor": "62",
    "Y": 6,
    "L": 29.2261823248403,
    "a": -1.99944733714413,
    "b": 4.29633092633439,
    "C": 4.73880249457498,
    "h": -1.13522226799139,
    "CMY_C": 0.7312953,
    "CMY_M": 0.7269276,
    "CMY_Y": 0.7582055,
    "CMYK_C": 0.01599489,
    "CMYK_M": 0,
    "CMYK_Y": 0.1145409,
    "CMYK_K": 0.7269276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06052",
    "Farbtonhilfsbezeichnung": "H0.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "71",
    "Bcolor": "62",
    "Y": 6,
    "L": 29.7079464264576,
    "a": -1.8002185526734,
    "b": 4.99168177181588,
    "C": 5.30638047528336,
    "h": -1.22467102086756,
    "CMY_C": 0.7239859,
    "CMY_M": 0.7230961,
    "CMY_Y": 0.7581249,
    "CMYK_C": 0.003213476,
    "CMYK_M": 0,
    "CMYK_Y": 0.1265017,
    "CMYK_K": 0.7230961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06053",
    "Farbtonhilfsbezeichnung": "HN.02.39",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "109",
    "Bcolor": "107",
    "Y": 15,
    "L": 46.045491311551,
    "a": -0.52836816581242,
    "b": 0.84061049688004,
    "C": 0.99287407364121,
    "h": -1.00964619558155,
    "CMY_C": 0.5735224,
    "CMY_M": 0.5712125,
    "CMY_Y": 0.5813498,
    "CMYK_C": 0.005387252,
    "CMYK_M": 0,
    "CMYK_Y": 0.02364179,
    "CMYK_K": 0.5712125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06054",
    "Farbtonhilfsbezeichnung": "H2.30.79",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "140",
    "Y": 68,
    "L": 85.8821550422354,
    "a": -13.2382940872744,
    "b": 38.1804135570975,
    "C": 40.4103502797509,
    "h": -1.23703762921304,
    "CMY_C": 0.1545637,
    "CMY_M": 0.1362795,
    "CMY_Y": 0.4504401,
    "CMYK_C": 0.02116914,
    "CMYK_M": 0,
    "CMYK_Y": 0.3637294,
    "CMYK_K": 0.1362795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06055",
    "Farbtonhilfsbezeichnung": "H4.16.85",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "236",
    "Bcolor": "186",
    "Y": 81,
    "L": 91.9099980534326,
    "a": -9.1696808754339,
    "b": 22.9004400696167,
    "C": 24.6680603765153,
    "h": -1.18993219842489,
    "CMY_C": 0.09264933,
    "CMY_M": 0.07511995,
    "CMY_Y": 0.2702517,
    "CMYK_C": 0.01895313,
    "CMYK_M": 0,
    "CMYK_Y": 0.2109806,
    "CMYK_K": 0.07511995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06056",
    "Farbtonhilfsbezeichnung": "H2.16.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "237",
    "Bcolor": "188",
    "Y": 81,
    "L": 92.5778656005859,
    "a": -7.83347845077515,
    "b": 23.1315593719482,
    "C": 24.4219665527344,
    "h": 108.708618164063,
    "CMY_C": 0.07430768013,
    "CMY_M": 0.07065600156784,
    "CMY_Y": 0.26460403203964,
    "CMYK_C": 0.0039293076843,
    "CMYK_M": 0,
    "CMYK_Y": 0.20869347453117,
    "CMYK_K": 0.07065600156784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06057",
    "Farbtonhilfsbezeichnung": "H3.13.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "236",
    "Bcolor": "196",
    "Y": 82,
    "L": 92.4537793525902,
    "a": -6.47679476412094,
    "b": 18.3121972681435,
    "C": 19.4238368816243,
    "h": -1.23084023861948,
    "CMY_C": 0.07842493,
    "CMY_M": 0.07407776,
    "CMY_Y": 0.2294703,
    "CMYK_C": 0.004694958,
    "CMYK_M": 0,
    "CMYK_Y": 0.1678246,
    "CMYK_K": 0.07407776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06058",
    "Farbtonhilfsbezeichnung": "H2.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "208",
    "Y": 82,
    "L": 92.7188307745094,
    "a": -3.98046877050301,
    "b": 12.526041230152,
    "C": 13.1432811935383,
    "h": -1.26311257115166,
    "CMY_C": 0.0729284,
    "CMY_M": 0.07546163,
    "CMY_Y": 0.1828988,
    "CMYK_C": 0,
    "CMYK_M": 0.002732507,
    "CMYK_Y": 0.1186212,
    "CMYK_K": 0.0729284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06059",
    "Farbtonhilfsbezeichnung": "H2.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "241",
    "Bcolor": "221",
    "Y": 87,
    "L": 94.7545495534623,
    "a": -2.99315661904975,
    "b": 8.79541314786729,
    "C": 9.29076310040452,
    "h": -1.24278103159169,
    "CMY_C": 0.05377827,
    "CMY_M": 0.05394934,
    "CMY_Y": 0.1325581,
    "CMYK_C": 0,
    "CMYK_M": 0.0001807954,
    "CMYK_Y": 0.08325725,
    "CMYK_K": 0.05377827
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06060",
    "Farbtonhilfsbezeichnung": "H2.44.74",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "210",
    "Bcolor": "99",
    "Y": 57,
    "L": 81.249267578125,
    "a": -18.805290222168,
    "b": 52.2341766357422,
    "C": 55.5161972045898,
    "h": 109.799835205078,
    "CMY_C": 0.22099471092224,
    "CMY_M": 0.17777216434479,
    "CMY_Y": 0.61142468452454,
    "CMYK_C": 0.05256760492921,
    "CMYK_M": 0,
    "CMYK_Y": 0.5274116396904,
    "CMYK_K": 0.17777216434479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06061",
    "Farbtonhilfsbezeichnung": "H2.30.78",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "220",
    "Bcolor": "140",
    "Y": 67,
    "L": 85.6402463847615,
    "a": -13.552192582796,
    "b": 38.0874751414875,
    "C": 40.4266952205423,
    "h": -1.22894825349161,
    "CMY_C": 0.1597763,
    "CMY_M": 0.1382694,
    "CMY_Y": 0.4522923,
    "CMYK_C": 0.02495776,
    "CMYK_M": 0,
    "CMYK_Y": 0.3644096,
    "CMYK_K": 0.1382694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06063",
    "Farbtonhilfsbezeichnung": "H4.24.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "228",
    "Bcolor": "162",
    "Y": 74,
    "L": 88.9981644236264,
    "a": -11.571706475121,
    "b": 31.1231133855636,
    "C": 33.2047071596334,
    "h": -1.21483033116311,
    "CMY_C": 0.1228879,
    "CMY_M": 0.1040254,
    "CMY_Y": 0.3637071,
    "CMYK_C": 0.02105249,
    "CMYK_M": 0,
    "CMYK_Y": 0.2898315,
    "CMYK_K": 0.1040254
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06064",
    "Farbtonhilfsbezeichnung": "H6.11.86",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "237",
    "Bcolor": "201",
    "Y": 82,
    "L": 92.5903523891673,
    "a": -6.82710472627718,
    "b": 16.2370042752551,
    "C": 17.6139054947563,
    "h": -1.17277246128968,
    "CMY_C": 0.08550709,
    "CMY_M": 0.07126222,
    "CMY_Y": 0.2125,
    "CMYK_C": 0.01533789,
    "CMYK_M": 0,
    "CMYK_Y": 0.152075,
    "CMYK_K": 0.07126222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06065",
    "Farbtonhilfsbezeichnung": "H5.08.85",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "208",
    "Y": 81,
    "L": 92.0692749023438,
    "a": -4.98044919967651,
    "b": 11.6349601745606,
    "C": 12.6561117172241,
    "h": 113.173782348633,
    "CMY_C": 0.09065526723862,
    "CMY_M": 0.08017325401306,
    "CMY_Y": 0.18347984552383,
    "CMYK_C": 0.01139563880861,
    "CMYK_M": 0,
    "CMYK_Y": 0.11231092363596,
    "CMYK_K": 0.08017325401306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06066",
    "Farbtonhilfsbezeichnung": "H3.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "240",
    "Bcolor": "222",
    "Y": 86,
    "L": 94.333336033246,
    "a": -3.05020048373528,
    "b": 7.94041648133796,
    "C": 8.50611173733819,
    "h": -1.20404009604607,
    "CMY_C": 0.0616754,
    "CMY_M": 0.05832914,
    "CMY_Y": 0.1308073,
    "CMYK_C": 0.00355353,
    "CMYK_M": 0,
    "CMYK_Y": 0.0769676,
    "CMYK_K": 0.05832914
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06067",
    "Farbtonhilfsbezeichnung": "H3.53.73",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "207",
    "Bcolor": "70",
    "Y": 56,
    "L": 79.6574237324739,
    "a": -22.2710181376362,
    "b": 62.9033591603901,
    "C": 66.7295350092293,
    "h": -1.23051687147912,
    "CMY_C": 0.2480911,
    "CMY_M": 0.1895625,
    "CMY_Y": 0.7255281,
    "CMYK_C": 0.0722185,
    "CMYK_M": 0,
    "CMYK_Y": 0.6613288,
    "CMYK_K": 0.1895625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06068",
    "Farbtonhilfsbezeichnung": "H5.36.75",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "216",
    "Bcolor": "123",
    "Y": 63,
    "L": 83.1917978386479,
    "a": -19.7861324957378,
    "b": 43.2449021799215,
    "C": 47.5564149583405,
    "h": -1.14169253230796,
    "CMY_C": 0.2228463,
    "CMY_M": 0.1532329,
    "CMY_Y": 0.5190219,
    "CMYK_C": 0.08221079,
    "CMYK_M": 0,
    "CMYK_Y": 0.431983,
    "CMYK_K": 0.1532329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06069",
    "Farbtonhilfsbezeichnung": "H2.20.79",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "222",
    "Bcolor": "163",
    "Y": 70,
    "L": 87.2325213698482,
    "a": -9.35963247306709,
    "b": 28.1165141779763,
    "C": 29.633445455283,
    "h": -1.24944719260873,
    "CMY_C": 0.1332986,
    "CMY_M": 0.1279048,
    "CMY_Y": 0.3590965,
    "CMYK_C": 0.006184904,
    "CMYK_M": 0,
    "CMYK_Y": 0.2650992,
    "CMYK_K": 0.1279048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06070",
    "Farbtonhilfsbezeichnung": "H2.09.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "235",
    "Bcolor": "207",
    "Y": 82,
    "L": 92.5192514388762,
    "a": -4.19906531651509,
    "b": 13.0820255058371,
    "C": 13.7394155941121,
    "h": -1.26020488964466,
    "CMY_C": 0.07520666,
    "CMY_M": 0.07732877,
    "CMY_Y": 0.1892577,
    "CMYK_C": 0,
    "CMYK_M": 0.002294693,
    "CMYK_Y": 0.123326,
    "CMYK_K": 0.07520666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06071",
    "Farbtonhilfsbezeichnung": "H2.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "229",
    "Bcolor": "207",
    "Y": 77,
    "L": 90.3104841490479,
    "a": -3.64486467183922,
    "b": 9.90907652019886,
    "C": 10.558164421867,
    "h": -1.21832564841185,
    "CMY_C": 0.1051967,
    "CMY_M": 0.1024928,
    "CMY_Y": 0.1895796,
    "CMYK_C": 0.003012731,
    "CMYK_M": 0,
    "CMYK_Y": 0.09703194,
    "CMYK_K": 0.1024928
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06072",
    "Farbtonhilfsbezeichnung": "H3.58.68",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "193",
    "Bcolor": "51",
    "Y": 47,
    "L": 74.2608788407615,
    "a": -25.2924510903424,
    "b": 64.2091150214049,
    "C": 69.0110029921995,
    "h": -1.19555312547078,
    "CMY_C": 0.328974,
    "CMY_M": 0.2425545,
    "CMY_Y": 0.8018608,
    "CMYK_C": 0.1140933,
    "CMYK_M": 0,
    "CMYK_Y": 0.7384112,
    "CMYK_K": 0.2425545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06073",
    "Farbtonhilfsbezeichnung": "H5.43.71",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "203",
    "Bcolor": "96",
    "Y": 54,
    "L": 78.3982497764118,
    "a": -22.0908725823789,
    "b": 49.8717848228982,
    "C": 54.545408357371,
    "h": -1.15381785313772,
    "CMY_C": 0.2807874,
    "CMY_M": 0.2021792,
    "CMY_Y": 0.6218442,
    "CMYK_C": 0.09852857,
    "CMYK_M": 0,
    "CMYK_Y": 0.526014,
    "CMYK_K": 0.2021792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06074",
    "Farbtonhilfsbezeichnung": "H3.31.72",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "204",
    "Bcolor": "129",
    "Y": 56,
    "L": 79.8321273120822,
    "a": -13.5700919197764,
    "b": 36.006094809235,
    "C": 38.478386896059,
    "h": -1.21037566251123,
    "CMY_C": 0.2288183,
    "CMY_M": 0.2016371,
    "CMY_Y": 0.495925,
    "CMYK_C": 0.0340461,
    "CMYK_M": 0,
    "CMYK_Y": 0.3686142,
    "CMYK_K": 0.2016371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06075",
    "Farbtonhilfsbezeichnung": "H4.16.79",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "219",
    "Bcolor": "175",
    "Y": 68,
    "L": 86.1383251299606,
    "a": -8.46710548690655,
    "b": 20.7791698278062,
    "C": 22.4380430086765,
    "h": -1.18385796528531,
    "CMY_C": 0.1573242,
    "CMY_M": 0.1404633,
    "CMY_Y": 0.3156707,
    "CMYK_C": 0.01961628,
    "CMYK_M": 0,
    "CMYK_Y": 0.2038394,
    "CMYK_K": 0.1404633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06076",
    "Farbtonhilfsbezeichnung": "H2.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "232",
    "Bcolor": "189",
    "Y": 78,
    "L": 90.9025226033512,
    "a": -6.65325861297994,
    "b": 19.9440089488511,
    "C": 21.0244938850628,
    "h": -1.24880862383697,
    "CMY_C": 0.0927023,
    "CMY_M": 0.0914051,
    "CMY_Y": 0.2584118,
    "CMYK_C": 0.001427694,
    "CMYK_M": 0,
    "CMYK_Y": 0.1838076,
    "CMYK_K": 0.0914051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06077",
    "Farbtonhilfsbezeichnung": "H2.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "226",
    "Bcolor": "197",
    "Y": 75,
    "L": 89.2123686809327,
    "a": -3.97406699566605,
    "b": 13.4288768923438,
    "C": 14.0045686501144,
    "h": -1.28307357623483,
    "CMY_C": 0.1094654,
    "CMY_M": 0.114832,
    "CMY_Y": 0.227618,
    "CMYK_C": 0,
    "CMYK_M": 0.006026251,
    "CMYK_Y": 0.1326761,
    "CMYK_K": 0.1094654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06078",
    "Farbtonhilfsbezeichnung": "H2.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "225",
    "Bcolor": "205",
    "Y": 74,
    "L": 89.0492286248865,
    "a": -3.00599178391908,
    "b": 9.21096931315279,
    "C": 9.68906302450508,
    "h": -1.25534467381807,
    "CMY_C": 0.1164368,
    "CMY_M": 0.117825,
    "CMY_Y": 0.1980125,
    "CMYK_C": 0,
    "CMYK_M": 0.001571116,
    "CMYK_Y": 0.09232579,
    "CMYK_K": 0.1164368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06079",
    "Farbtonhilfsbezeichnung": "H3.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "229",
    "Bcolor": "215",
    "Y": 78,
    "L": 90.722758602594,
    "a": -2.17725832308735,
    "b": 5.90866368783167,
    "C": 6.29704378112092,
    "h": -1.21774898198588,
    "CMY_C": 0.1017521,
    "CMY_M": 0.1002623,
    "CMY_Y": 0.155207,
    "CMYK_C": 0.001655857,
    "CMYK_M": 0,
    "CMYK_Y": 0.06106747,
    "CMYK_K": 0.1002623
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06080",
    "Farbtonhilfsbezeichnung": "H5.55.67",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "191",
    "Bcolor": "54",
    "Y": 46,
    "L": 73.3718275442934,
    "a": -26.3852667979344,
    "b": 62.1242851572612,
    "C": 67.495252501927,
    "h": -1.16916504213949,
    "CMY_C": 0.3495164,
    "CMY_M": 0.2499543,
    "CMY_Y": 0.7894158,
    "CMYK_C": 0.1327414,
    "CMYK_M": 0,
    "CMYK_Y": 0.7192382,
    "CMYK_K": 0.2499543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06081",
    "Farbtonhilfsbezeichnung": "H3.54.38",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "118",
    "Bcolor": "45",
    "Y": 16,
    "L": 47.458434121502,
    "a": -14.9365017842588,
    "b": 37.8851810548115,
    "C": 40.7232860794289,
    "h": -1.19525050453018,
    "CMY_C": 0.5779044,
    "CMY_M": 0.5362033,
    "CMY_Y": 0.825211,
    "CMYK_C": 0.08991262,
    "CMYK_M": 0,
    "CMYK_Y": 0.6231346,
    "CMYK_K": 0.5362033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06082",
    "Farbtonhilfsbezeichnung": "H3.49.33",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "100",
    "Bcolor": "46",
    "Y": 12,
    "L": 40.6576499449645,
    "a": -12.0047795019224,
    "b": 29.1902346169232,
    "C": 31.5623910355473,
    "h": -1.18062079234764,
    "CMY_C": 0.6390092,
    "CMY_M": 0.6065369,
    "CMY_Y": 0.8204759,
    "CMYK_C": 0.08252945,
    "CMYK_M": 0,
    "CMYK_Y": 0.5437333,
    "CMYK_K": 0.6065369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06083",
    "Farbtonhilfsbezeichnung": "H4.41.28",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "91",
    "Bcolor": "50",
    "Y": 10,
    "L": 37.137947443731,
    "a": -10.4842485582125,
    "b": 22.0834575974874,
    "C": 24.4458292412101,
    "h": -1.12754729221613,
    "CMY_C": 0.6747643,
    "CMY_M": 0.6417668,
    "CMY_Y": 0.8020664,
    "CMYK_C": 0.09211154,
    "CMYK_M": 0,
    "CMYK_Y": 0.4474728,
    "CMYK_K": 0.6417668
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06084",
    "Farbtonhilfsbezeichnung": "H4.29.25",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "84",
    "Bcolor": "57",
    "Y": 8,
    "L": 34.6685143691135,
    "a": -7.38545339205385,
    "b": 15.1213705387613,
    "C": 16.8285700158011,
    "h": -1.11646230900174,
    "CMY_C": 0.6912951,
    "CMY_M": 0.6693041,
    "CMY_Y": 0.7779008,
    "CMYK_C": 0.06649941,
    "CMYK_M": 0,
    "CMYK_Y": 0.3283886,
    "CMYK_K": 0.6693041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06085",
    "Farbtonhilfsbezeichnung": "H4.20.27",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "81",
    "Bcolor": "62",
    "Y": 8,
    "L": 33.6137961365262,
    "a": -4.74101246275987,
    "b": 10.3792091945607,
    "C": 11.4107485589902,
    "h": -1.14231869184455,
    "CMY_C": 0.694319,
    "CMY_M": 0.6830325,
    "CMY_Y": 0.7570444,
    "CMYK_C": 0.03560785,
    "CMYK_M": 0,
    "CMYK_Y": 0.2335,
    "CMYK_K": 0.6830325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06086",
    "Farbtonhilfsbezeichnung": "H4.18.17",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "60",
    "Bcolor": "48",
    "Y": 4,
    "L": 24.6844301592544,
    "a": -3.75946836047331,
    "b": 6.68961499369196,
    "C": 7.67362698580196,
    "h": -1.05879759227413,
    "CMY_C": 0.776792,
    "CMY_M": 0.7646438,
    "CMY_Y": 0.8117554,
    "CMYK_C": 0.05161624,
    "CMYK_M": 0,
    "CMYK_Y": 0.2001713,
    "CMYK_K": 0.7646438
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06087",
    "Farbtonhilfsbezeichnung": "H2.13.17",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "62",
    "Bcolor": "52",
    "Y": 5,
    "L": 26.1613936776193,
    "a": -1.8025132046682,
    "b": 5.91506119836017,
    "C": 6.18360759050486,
    "h": -1.27500318299535,
    "CMY_C": 0.7535866,
    "CMY_M": 0.7549642,
    "CMY_Y": 0.7943816,
    "CMYK_C": 0,
    "CMYK_M": 0.005590355,
    "CMYK_Y": 0.1655548,
    "CMYK_K": 0.7535866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06088",
    "Farbtonhilfsbezeichnung": "H3.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "60",
    "Bcolor": "56",
    "Y": 4,
    "L": 24.9013318615284,
    "a": -1.11143859159063,
    "b": 1.81684526176425,
    "C": 2.12984094431302,
    "h": -1.02178849549435,
    "CMY_C": 0.770421,
    "CMY_M": 0.766502,
    "CMY_Y": 0.7810948,
    "CMYK_C": 0.01678434,
    "CMYK_M": 0,
    "CMYK_Y": 0.06249665,
    "CMYK_K": 0.766502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06089",
    "Farbtonhilfsbezeichnung": "H3.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "82",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.6572990839312,
    "a": -1.55118897417325,
    "b": 2.35070389801662,
    "C": 2.81637995479075,
    "h": -0.98750499099571,
    "CMY_C": 0.6840515,
    "CMY_M": 0.6777451,
    "CMY_Y": 0.6977642,
    "CMYK_C": 0.01956954,
    "CMYK_M": 0,
    "CMYK_Y": 0.06212189,
    "CMYK_K": 0.6777451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06090",
    "Farbtonhilfsbezeichnung": "H5.12.37",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "110",
    "Bcolor": "94",
    "Y": 15,
    "L": 45.6839655569902,
    "a": -4.03376984285803,
    "b": 8.23477211210283,
    "C": 9.16966579998515,
    "h": -1.1153048976946,
    "CMY_C": 0.5804811,
    "CMY_M": 0.5693604,
    "CMY_Y": 0.6331218,
    "CMYK_C": 0.02582368,
    "CMYK_M": 0,
    "CMYK_Y": 0.148062,
    "CMYK_K": 0.5693604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06091",
    "Farbtonhilfsbezeichnung": "H3.20.42",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "120",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.4073516079317,
    "a": -6.0392111647955,
    "b": 15.4214294035713,
    "C": 16.5617799871368,
    "h": -1.19754215032945,
    "CMY_C": 0.5399924,
    "CMY_M": 0.530286,
    "CMY_Y": 0.6456347,
    "CMYK_C": 0.02066448,
    "CMYK_M": 0,
    "CMYK_Y": 0.2455721,
    "CMYK_K": 0.530286
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06092",
    "Farbtonhilfsbezeichnung": "H3.22.34",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "102",
    "Bcolor": "75",
    "Y": 13,
    "L": 42.3073077543227,
    "a": -6.02536888086419,
    "b": 14.8288152866732,
    "C": 16.0062123238685,
    "h": -1.18484636005755,
    "CMY_C": 0.6107236,
    "CMY_M": 0.5994639,
    "CMY_Y": 0.7075251,
    "CMYK_C": 0.02811152,
    "CMYK_M": 0,
    "CMYK_Y": 0.2697913,
    "CMYK_K": 0.5994639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06093",
    "Farbtonhilfsbezeichnung": "H5.38.34",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "102",
    "Bcolor": "59",
    "Y": 12,
    "L": 41.5548741302858,
    "a": -11.2586127894271,
    "b": 23.0236766515093,
    "C": 25.6290079498896,
    "h": -1.115986155193,
    "CMY_C": 0.6358609,
    "CMY_M": 0.5984423,
    "CMY_Y": 0.7694216,
    "CMYK_C": 0.09318363,
    "CMYK_M": 0,
    "CMYK_Y": 0.4257902,
    "CMYK_K": 0.5984423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06094",
    "Farbtonhilfsbezeichnung": "H4.44.39",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "118",
    "Bcolor": "58",
    "Y": 16,
    "L": 47.4286503526704,
    "a": -14.0966066950278,
    "b": 30.8192017021463,
    "C": 33.8900798740852,
    "h": -1.14180820629955,
    "CMY_C": 0.583365,
    "CMY_M": 0.5371825,
    "CMY_Y": 0.7714633,
    "CMYK_C": 0.09978548,
    "CMYK_M": 0,
    "CMYK_Y": 0.5062056,
    "CMYK_K": 0.5371825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06095",
    "Farbtonhilfsbezeichnung": "H4.56.41",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "127",
    "Bcolor": "45",
    "Y": 19,
    "L": 50.564259084572,
    "a": -17.0205734646201,
    "b": 41.1209189716166,
    "C": 44.5042683136661,
    "h": -1.17835193883791,
    "CMY_C": 0.5556998,
    "CMY_M": 0.5020322,
    "CMY_Y": 0.8229915,
    "CMYK_C": 0.1077734,
    "CMYK_M": 0,
    "CMYK_Y": 0.6445384,
    "CMYK_K": 0.5020322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06096",
    "Farbtonhilfsbezeichnung": "H4.05.47",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "134",
    "Bcolor": "126",
    "Y": 22,
    "L": 55.4736328125,
    "a": -1.64093506336212,
    "b": 3.52790856361389,
    "C": 3.89086198806763,
    "h": 114.944541931152,
    "CMY_C": 0.48003053665161,
    "CMY_M": 0.47606861591339,
    "CMY_Y": 0.50701189041138,
    "CMYK_C": 0.00756190763786,
    "CMYK_M": 0,
    "CMYK_Y": 0.05905978381634,
    "CMYK_K": 0.47606861591339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06097",
    "Farbtonhilfsbezeichnung": "H4.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "144",
    "Bcolor": "110",
    "Y": 27,
    "L": 58.8825279311926,
    "a": -6.83328587116844,
    "b": 17.162296944581,
    "C": 18.4726346851521,
    "h": -1.1918798922856,
    "CMY_C": 0.44571,
    "CMY_M": 0.433678,
    "CMY_Y": 0.566797,
    "CMYK_C": 0.02124582,
    "CMYK_M": 0,
    "CMYK_Y": 0.2350588,
    "CMYK_K": 0.433678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06098",
    "Farbtonhilfsbezeichnung": "H5.35.43",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "127",
    "Bcolor": "75",
    "Y": 19,
    "L": 51.0905636599769,
    "a": -12.1233991304029,
    "b": 26.6641474564744,
    "C": 29.2908444066685,
    "h": -1.14406527105264,
    "CMY_C": 0.5408186,
    "CMY_M": 0.5038186,
    "CMY_Y": 0.7076755,
    "CMYK_C": 0.07456962,
    "CMYK_M": 0,
    "CMYK_Y": 0.4108516,
    "CMYK_K": 0.5038186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06099",
    "Farbtonhilfsbezeichnung": "H5.41.48",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "141",
    "Bcolor": "73",
    "Y": 24,
    "L": 56.0425509984025,
    "a": -15.8746974651623,
    "b": 33.7064402448621,
    "C": 37.2576184637571,
    "h": -1.13064184006698,
    "CMY_C": 0.5033254,
    "CMY_M": 0.4479173,
    "CMY_Y": 0.7128366,
    "CMYK_C": 0.1003621,
    "CMYK_M": 0,
    "CMYK_Y": 0.4798544,
    "CMYK_K": 0.4479173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06100",
    "Farbtonhilfsbezeichnung": "H4.52.44",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "133",
    "Bcolor": "53",
    "Y": 21,
    "L": 52.9656055931456,
    "a": -17.011455678186,
    "b": 40.2928250638886,
    "C": 43.7367279974168,
    "h": -1.1713033804519,
    "CMY_C": 0.5321212,
    "CMY_M": 0.4778484,
    "CMY_Y": 0.7930584,
    "CMYK_C": 0.1039408,
    "CMYK_M": 0,
    "CMYK_Y": 0.6036753,
    "CMYK_K": 0.4778484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06101",
    "Farbtonhilfsbezeichnung": "H2.60.43",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "130",
    "Bcolor": "39",
    "Y": 20,
    "L": 51.7923779999245,
    "a": -17.6006580427214,
    "b": 45.0336287497144,
    "C": 48.3509139717536,
    "h": -1.19821685499851,
    "CMY_C": 0.5418221,
    "CMY_M": 0.4890833,
    "CMY_Y": 0.8456658,
    "CMYK_C": 0.103224,
    "CMYK_M": 0,
    "CMYK_Y": 0.6979268,
    "CMYK_K": 0.4890833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06102",
    "Farbtonhilfsbezeichnung": "H5.05.47",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "132",
    "Bcolor": "121",
    "Y": 23,
    "L": 54.6156464412459,
    "a": -2.14906217082206,
    "b": 5.05717756931321,
    "C": 5.49486243518644,
    "h": -1.16896559141856,
    "CMY_C": 0.4878237,
    "CMY_M": 0.4840308,
    "CMY_Y": 0.5257997,
    "CMYK_C": 0.007351049,
    "CMYK_M": 0,
    "CMYK_Y": 0.08095226,
    "CMYK_K": 0.4840308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06103",
    "Farbtonhilfsbezeichnung": "H5.06.55",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "151",
    "Bcolor": "138",
    "Y": 30,
    "L": 62.0358642606697,
    "a": -2.50457194508857,
    "b": 5.89573715149969,
    "C": 6.40566914441407,
    "h": -1.16908606949559,
    "CMY_C": 0.4124106,
    "CMY_M": 0.4078707,
    "CMY_Y": 0.4575243,
    "CMYK_C": 0.007667001,
    "CMYK_M": 0,
    "CMYK_Y": 0.08385601,
    "CMYK_K": 0.4078707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06104",
    "Farbtonhilfsbezeichnung": "H2.25.57",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "159",
    "Bcolor": "110",
    "Y": 33,
    "L": 64.3630643176838,
    "a": -8.58700472634949,
    "b": 24.9008650851023,
    "C": 26.3398886132196,
    "h": -1.23871893066248,
    "CMY_C": 0.3834818,
    "CMY_M": 0.3749534,
    "CMY_Y": 0.5677449,
    "CMYK_C": 0.01364439,
    "CMYK_M": 0,
    "CMYK_Y": 0.3084433,
    "CMYK_K": 0.3749534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06105",
    "Farbtonhilfsbezeichnung": "H5.23.55",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "156",
    "Bcolor": "112",
    "Y": 31,
    "L": 62.6289913641358,
    "a": -9.887162338369,
    "b": 21.596832863956,
    "C": 23.7524560595091,
    "h": -1.14146982009779,
    "CMY_C": 0.4181268,
    "CMY_M": 0.3897549,
    "CMY_Y": 0.5615873,
    "CMYK_C": 0.04649254,
    "CMYK_M": 0,
    "CMYK_Y": 0.2815794,
    "CMYK_K": 0.3897549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06106",
    "Farbtonhilfsbezeichnung": "H4.35.50",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "142",
    "Bcolor": "83",
    "Y": 25,
    "L": 56.9283590567926,
    "a": -12.667391508299,
    "b": 29.9326869920689,
    "C": 32.5027469329855,
    "h": -1.17045472905237,
    "CMY_C": 0.4789432,
    "CMY_M": 0.4443349,
    "CMY_Y": 0.6762002,
    "CMYK_C": 0.06228276,
    "CMYK_M": 0,
    "CMYK_Y": 0.4172753,
    "CMYK_K": 0.4443349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06107",
    "Farbtonhilfsbezeichnung": "H5.46.55",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "159",
    "Bcolor": "72",
    "Y": 31,
    "L": 62.4092277504279,
    "a": -18.925234704994,
    "b": 42.0327875342697,
    "C": 46.0968516987892,
    "h": -1.14773507144193,
    "CMY_C": 0.4441508,
    "CMY_M": 0.3777553,
    "CMY_Y": 0.7165099,
    "CMYK_C": 0.1067033,
    "CMYK_M": 0,
    "CMYK_Y": 0.5444074,
    "CMYK_K": 0.3777553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06108",
    "Farbtonhilfsbezeichnung": "H3.56.50",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "151",
    "Bcolor": "45",
    "Y": 27,
    "L": 59.4037705920267,
    "a": -20.0623254845318,
    "b": 50.7911496385622,
    "C": 54.6098689382616,
    "h": -1.19461075430105,
    "CMY_C": 0.4712703,
    "CMY_M": 0.4077705,
    "CMY_Y": 0.8228614,
    "CMYK_C": 0.1072216,
    "CMYK_M": 0,
    "CMYK_Y": 0.7008953,
    "CMYK_K": 0.4077705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06109",
    "Farbtonhilfsbezeichnung": "H2.16.67",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "185",
    "Bcolor": "147",
    "Y": 47,
    "L": 74.366530072198,
    "a": -6.3604421948128,
    "b": 19.0146761276655,
    "C": 20.050265164171,
    "h": -1.24799457787497,
    "CMY_C": 0.2748616,
    "CMY_M": 0.272828,
    "CMY_Y": 0.424951,
    "CMYK_C": 0.002796578,
    "CMYK_M": 0,
    "CMYK_Y": 0.209198,
    "CMYK_K": 0.272828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06110",
    "Farbtonhilfsbezeichnung": "H5.22.64",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "179",
    "Bcolor": "129",
    "Y": 42,
    "L": 71.162621828596,
    "a": -10.6320758706713,
    "b": 23.7951884007334,
    "C": 26.062463973042,
    "h": -1.15059319607048,
    "CMY_C": 0.3285389,
    "CMY_M": 0.298961,
    "CMY_Y": 0.4926554,
    "CMYK_C": 0.04219155,
    "CMYK_M": 0,
    "CMYK_Y": 0.2762961,
    "CMYK_K": 0.298961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06111",
    "Farbtonhilfsbezeichnung": "H3.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "171",
    "Bcolor": "108",
    "Y": 37,
    "L": 68.170166015625,
    "a": -11.4249477386475,
    "b": 31.2487678527832,
    "C": 33.2718353271484,
    "h": 110.083053588867,
    "CMY_C": 0.34978717565536,
    "CMY_M": 0.33032292127609,
    "CMY_Y": 0.57676947116852,
    "CMYK_C": 0.02906513400376,
    "CMYK_M": 0,
    "CMYK_Y": 0.3680080473423,
    "CMYK_K": 0.33032292127609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06112",
    "Farbtonhilfsbezeichnung": "H5.38.58",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "167",
    "Bcolor": "91",
    "Y": 35,
    "L": 65.9839235725037,
    "a": -16.769634249078,
    "b": 37.338372341699,
    "C": 40.9313410722786,
    "h": -1.14866944781386,
    "CMY_C": 0.3991711,
    "CMY_M": 0.343771,
    "CMY_Y": 0.6447538,
    "CMYK_C": 0.08442198,
    "CMYK_M": 0,
    "CMYK_Y": 0.4586551,
    "CMYK_K": 0.343771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06113",
    "Farbtonhilfsbezeichnung": "H3.54.61",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "179",
    "Bcolor": "61",
    "Y": 40,
    "L": 69.5852604246107,
    "a": -21.7556061366522,
    "b": 55.2258251961789,
    "C": 59.3565343241336,
    "h": -1.19552584833137,
    "CMY_C": 0.3671515,
    "CMY_M": 0.2983907,
    "CMY_Y": 0.7589894,
    "CMYK_C": 0.09800447,
    "CMYK_M": 0,
    "CMYK_Y": 0.6564889,
    "CMYK_K": 0.2983907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06114",
    "Farbtonhilfsbezeichnung": "H2.61.54",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "158",
    "Bcolor": "29",
    "Y": 31,
    "L": 62.0994431969251,
    "a": -20.8641654381151,
    "b": 59.0317843917875,
    "C": 62.6104221987644,
    "h": -1.23106064080483,
    "CMY_C": 0.4381258,
    "CMY_M": 0.3791145,
    "CMY_Y": 0.8858754,
    "CMYK_C": 0.09504373,
    "CMYK_M": 0,
    "CMYK_Y": 0.8161906,
    "CMYK_K": 0.3791145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06115",
    "Farbtonhilfsbezeichnung": "H2.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "204",
    "Bcolor": "189",
    "Y": 59,
    "L": 81.5324769964343,
    "a": -2.16069483823383,
    "b": 6.52123073632245,
    "C": 6.86986553728142,
    "h": -1.2508477187163,
    "CMY_C": 0.2010338,
    "CMY_M": 0.2018027,
    "CMY_Y": 0.2591475,
    "CMYK_C": 0,
    "CMYK_M": 0.0009623207,
    "CMYK_Y": 0.07273608,
    "CMYK_K": 0.2010338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06116",
    "Farbtonhilfsbezeichnung": "H4.07.72",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "199",
    "Bcolor": "179",
    "Y": 56,
    "L": 79.4780289995396,
    "a": -3.56144044621642,
    "b": 8.68414957086885,
    "C": 9.38607009462256,
    "h": -1.18160651976688,
    "CMY_C": 0.2274144,
    "CMY_M": 0.2215247,
    "CMY_Y": 0.2968536,
    "CMYK_C": 0.007565612,
    "CMYK_M": 0,
    "CMYK_Y": 0.09676463,
    "CMYK_K": 0.2215247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06117",
    "Farbtonhilfsbezeichnung": "H4.23.66",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "183",
    "Bcolor": "129",
    "Y": 45,
    "L": 72.8248944072323,
    "a": -10.3677916206289,
    "b": 26.380258768441,
    "C": 28.3444731081509,
    "h": -1.19632746993232,
    "CMY_C": 0.3028135,
    "CMY_M": 0.2822598,
    "CMY_Y": 0.4946226,
    "CMYK_C": 0.0286367,
    "CMYK_M": 0,
    "CMYK_Y": 0.2958771,
    "CMYK_K": 0.2822598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06118",
    "Farbtonhilfsbezeichnung": "H2.32.62",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "177",
    "Bcolor": "109",
    "Y": 41,
    "L": 70.3013744743896,
    "a": -12.0454461196314,
    "b": 33.2653474493632,
    "C": 35.3790349380505,
    "h": -1.22338123075787,
    "CMY_C": 0.3272959,
    "CMY_M": 0.3068602,
    "CMY_Y": 0.5707293,
    "CMYK_C": 0.02948287,
    "CMYK_M": 0,
    "CMYK_Y": 0.3806867,
    "CMYK_K": 0.3068602
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06119",
    "Farbtonhilfsbezeichnung": "H5.44.66",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "188",
    "Bcolor": "90",
    "Y": 45,
    "L": 73.1292032604769,
    "a": -21.0434840769823,
    "b": 46.600021519335,
    "C": 51.1311082189765,
    "h": -1.14663198708355,
    "CMY_C": 0.3366194,
    "CMY_M": 0.2608462,
    "CMY_Y": 0.6479274,
    "CMYK_C": 0.1025135,
    "CMYK_M": 0,
    "CMYK_Y": 0.5236815,
    "CMYK_K": 0.2608462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06121",
    "Farbtonhilfsbezeichnung": "H2.62.59",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "172",
    "Bcolor": "20",
    "Y": 36,
    "L": 66.5929154463593,
    "a": -24.2492674467767,
    "b": 65.2839797223953,
    "C": 69.6421207323515,
    "h": -1.21514789557471,
    "CMY_C": 0.4056967,
    "CMY_M": 0.3264247,
    "CMY_Y": 0.9230294,
    "CMYK_C": 0.1176884,
    "CMYK_M": 0,
    "CMYK_Y": 0.8857284,
    "CMYK_K": 0.3264247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06122",
    "Farbtonhilfsbezeichnung": "H3.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "205",
    "Bcolor": "164",
    "Y": 59,
    "L": 81.3365739754252,
    "a": -7.14781020330263,
    "b": 19.3075075356942,
    "C": 20.5881285682629,
    "h": -1.21623271694596,
    "CMY_C": 0.2041854,
    "CMY_M": 0.1957974,
    "CMY_Y": 0.3550782,
    "CMYK_C": 0.01043014,
    "CMYK_M": 0,
    "CMYK_Y": 0.1980605,
    "CMYK_K": 0.1957974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06123",
    "Farbtonhilfsbezeichnung": "H4.25.69",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "193",
    "Bcolor": "132",
    "Y": 51,
    "L": 76.4095469700648,
    "a": -11.556584809849,
    "b": 29.5036313912323,
    "C": 31.6862575533454,
    "h": -1.19746517211388,
    "CMY_C": 0.2656299,
    "CMY_M": 0.2418437,
    "CMY_Y": 0.4815498,
    "CMYK_C": 0.03137371,
    "CMYK_M": 0,
    "CMYK_Y": 0.3161697,
    "CMYK_K": 0.2418437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06124",
    "Farbtonhilfsbezeichnung": "H4.35.70",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "196",
    "Bcolor": "111",
    "Y": 51,
    "L": 76.7243014150046,
    "a": -16.0667925509357,
    "b": 40.6872076452347,
    "C": 43.7446075401443,
    "h": -1.19470667266897,
    "CMY_C": 0.2718366,
    "CMY_M": 0.2310059,
    "CMY_Y": 0.5637964,
    "CMYK_C": 0.05309628,
    "CMYK_M": 0,
    "CMYK_Y": 0.4327608,
    "CMYK_K": 0.2310059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06125",
    "Farbtonhilfsbezeichnung": "H2.62.61",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "176",
    "Bcolor": "21",
    "Y": 39,
    "L": 68.6553111990317,
    "a": -21.237745072485,
    "b": 67.0873342039252,
    "C": 70.3686878259998,
    "h": -1.26420911716055,
    "CMY_C": 0.3599742,
    "CMY_M": 0.3102571,
    "CMY_Y": 0.9183075,
    "CMYK_C": 0.07208055,
    "CMYK_M": 0,
    "CMYK_Y": 0.8815609,
    "CMYK_K": 0.3102571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06126",
    "Farbtonhilfsbezeichnung": "H4.45.70",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "197",
    "Bcolor": "86",
    "Y": 51,
    "L": 76.44492724808,
    "a": -20.3475917167908,
    "b": 52.266061082512,
    "C": 56.0871253475705,
    "h": -1.19954110222451,
    "CMY_C": 0.2857414,
    "CMY_M": 0.2270868,
    "CMY_Y": 0.6613404,
    "CMYK_C": 0.07588769,
    "CMYK_M": 0,
    "CMYK_Y": 0.5618401,
    "CMYK_K": 0.2270868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06127",
    "Farbtonhilfsbezeichnung": "H9.31.79",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "226",
    "Bcolor": "142",
    "Y": 69,
    "L": 86.3083901754704,
    "a": -21.7151991068378,
    "b": 37.8096809236161,
    "C": 43.601855967324,
    "h": -1.04946641039373,
    "CMY_C": 0.2148651,
    "CMY_M": 0.1139736,
    "CMY_Y": 0.444997,
    "CMYK_C": 0.1138696,
    "CMYK_M": 0,
    "CMYK_Y": 0.3736044,
    "CMYK_K": 0.1139736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06129",
    "Farbtonhilfsbezeichnung": "H6.10.84",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "234",
    "Bcolor": "201",
    "Y": 79,
    "L": 91.4294999195616,
    "a": -6.65924222033915,
    "b": 14.7122654028831,
    "C": 16.1491876029111,
    "h": -1.14575577845683,
    "CMY_C": 0.1016602,
    "CMY_M": 0.08428339,
    "CMY_Y": 0.2136406,
    "CMYK_C": 0.01897621,
    "CMYK_M": 0,
    "CMYK_Y": 0.1412634,
    "CMYK_K": 0.08428339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06130",
    "Farbtonhilfsbezeichnung": "H9.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "238",
    "Bcolor": "222",
    "Y": 84,
    "L": 93.511428894174,
    "a": -3.43935182446203,
    "b": 6.38223564539098,
    "C": 7.24997053826631,
    "h": -1.07651935735272,
    "CMY_C": 0.07900744,
    "CMY_M": 0.06624057,
    "CMY_Y": 0.1282798,
    "CMYK_C": 0.01367254,
    "CMYK_M": 0,
    "CMYK_Y": 0.06644033,
    "CMYK_K": 0.06624057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06131",
    "Farbtonhilfsbezeichnung": "H6.40.74",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "211",
    "Bcolor": "109",
    "Y": 59,
    "L": 81.2121380780391,
    "a": -22.2850152934104,
    "b": 47.5304375031119,
    "C": 52.4953749949913,
    "h": -1.13237140854313,
    "CMY_C": 0.2552828,
    "CMY_M": 0.1706878,
    "CMY_Y": 0.5740672,
    "CMYK_C": 0.1020061,
    "CMYK_M": 0,
    "CMYK_Y": 0.4864023,
    "CMYK_K": 0.1706878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06132",
    "Farbtonhilfsbezeichnung": "H6.15.83",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "233",
    "Bcolor": "187",
    "Y": 78,
    "L": 90.7839994302852,
    "a": -9.72693665748187,
    "b": 20.6524676204304,
    "C": 22.8284409356309,
    "h": -1.13063157141889,
    "CMY_C": 0.1156668,
    "CMY_M": 0.08599296,
    "CMY_Y": 0.2655112,
    "CMYK_C": 0.03246562,
    "CMYK_M": 0,
    "CMYK_Y": 0.1964079,
    "CMYK_K": 0.08599296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06133",
    "Farbtonhilfsbezeichnung": "H8.13.84",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "233",
    "Bcolor": "194",
    "Y": 78,
    "L": 90.6914691752646,
    "a": -8.9538799463631,
    "b": 17.2713149534776,
    "C": 19.4543127947533,
    "h": -1.09251766977039,
    "CMY_C": 0.1202813,
    "CMY_M": 0.08798131,
    "CMY_Y": 0.2410773,
    "CMYK_C": 0.03541589,
    "CMYK_M": 0,
    "CMYK_Y": 0.167865,
    "CMYK_K": 0.08798131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06134",
    "Farbtonhilfsbezeichnung": "H9.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "228",
    "Bcolor": "204",
    "Y": 76,
    "L": 89.7135195702248,
    "a": -5.54938115838532,
    "b": 10.1447452525574,
    "C": 11.5633683449213,
    "h": -1.07024370429712,
    "CMY_C": 0.1259669,
    "CMY_M": 0.1048371,
    "CMY_Y": 0.1980995,
    "CMYK_C": 0.02360447,
    "CMYK_M": 0,
    "CMYK_Y": 0.1041849,
    "CMYK_K": 0.1048371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06135",
    "Farbtonhilfsbezeichnung": "H8.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "232",
    "Bcolor": "216",
    "Y": 80,
    "L": 91.4702758789062,
    "a": -2.39534401893616,
    "b": 6.45981597900391,
    "C": 6.8896222114563,
    "h": 110.34513092041,
    "CMY_C": 0.09333461523056,
    "CMY_M": 0.09152728319168,
    "CMY_Y": 0.15113580226898,
    "CMYK_C": 0.00198941817507,
    "CMYK_M": 0,
    "CMYK_Y": 0.06561399251223,
    "CMYK_K": 0.09152728319168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06136",
    "Farbtonhilfsbezeichnung": "H9.44.73",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "213",
    "Bcolor": "102",
    "Y": 58,
    "L": 80.68407870725,
    "a": -28.3348901624623,
    "b": 49.7921626819063,
    "C": 57.2898373628362,
    "h": -1.05343511409614,
    "CMY_C": 0.3032948,
    "CMY_M": 0.1652744,
    "CMY_Y": 0.5995992,
    "CMYK_C": 0.1653482,
    "CMYK_M": 0,
    "CMYK_Y": 0.5203205,
    "CMYK_K": 0.1652744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06137",
    "Farbtonhilfsbezeichnung": "H9.30.73",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "208",
    "Bcolor": "133",
    "Y": 57,
    "L": 80.3021230250118,
    "a": -19.7171110555908,
    "b": 34.0435090487718,
    "C": 39.3411359359679,
    "h": -1.04583092681092,
    "CMY_C": 0.2740598,
    "CMY_M": 0.183689,
    "CMY_Y": 0.4775357,
    "CMYK_C": 0.1107063,
    "CMYK_M": 0,
    "CMYK_Y": 0.359969,
    "CMYK_K": 0.183689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06138",
    "Farbtonhilfsbezeichnung": "H8.26.79",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "224",
    "Bcolor": "153",
    "Y": 69,
    "L": 86.3732576730673,
    "a": -17.6656919253326,
    "b": 31.9977068590616,
    "C": 36.5503750382838,
    "h": -1.06634805866065,
    "CMY_C": 0.1964801,
    "CMY_M": 0.1204654,
    "CMY_Y": 0.3989923,
    "CMYK_C": 0.08642597,
    "CMYK_M": 0,
    "CMYK_Y": 0.3166753,
    "CMYK_K": 0.1204654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06139",
    "Farbtonhilfsbezeichnung": "H9.15.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "225",
    "Bcolor": "182",
    "Y": 72,
    "L": 87.9293219738518,
    "a": -10.3632180196126,
    "b": 19.3609991823003,
    "C": 21.9600677835716,
    "h": -1.07933820948599,
    "CMY_C": 0.1559358,
    "CMY_M": 0.1161355,
    "CMY_Y": 0.2864508,
    "CMYK_C": 0.04502988,
    "CMYK_M": 0,
    "CMYK_Y": 0.1926939,
    "CMYK_K": 0.1161355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06140",
    "Farbtonhilfsbezeichnung": "H9.14.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "227",
    "Bcolor": "187",
    "Y": 73,
    "L": 88.6508171783336,
    "a": -9.80528046391188,
    "b": 17.6770086136434,
    "C": 20.2143552581524,
    "h": -1.06435859127004,
    "CMY_C": 0.1484126,
    "CMY_M": 0.1089559,
    "CMY_Y": 0.2661299,
    "CMYK_C": 0.04428148,
    "CMYK_M": 0,
    "CMYK_Y": 0.1763931,
    "CMYK_K": 0.1089559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06141",
    "Farbtonhilfsbezeichnung": "H6.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "192",
    "Y": 70,
    "L": 86.7845473558207,
    "a": -5.713523335723,
    "b": 12.2436904221104,
    "C": 13.5111918075471,
    "h": -1.13418250442229,
    "CMY_C": 0.1532496,
    "CMY_M": 0.1374997,
    "CMY_Y": 0.2452485,
    "CMYK_C": 0.01826073,
    "CMYK_M": 0,
    "CMYK_Y": 0.1249261,
    "CMYK_K": 0.1374997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06142",
    "Farbtonhilfsbezeichnung": "H6.08.79",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "195",
    "Y": 70,
    "L": 86.8539512605733,
    "a": -5.02744450936427,
    "b": 10.7627786102134,
    "C": 11.8790825280071,
    "h": -1.13380189864228,
    "CMY_C": 0.1516454,
    "CMY_M": 0.137919,
    "CMY_Y": 0.2334888,
    "CMYK_C": 0.01592241,
    "CMYK_M": 0,
    "CMYK_Y": 0.1108595,
    "CMYK_K": 0.137919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06143",
    "Farbtonhilfsbezeichnung": "H8.04.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 71,
    "L": 87.7064805798255,
    "a": -3.01758618716058,
    "b": 5.67370296678991,
    "C": 6.42625332151658,
    "h": -1.08199081023436,
    "CMY_C": 0.1425645,
    "CMY_M": 0.1317685,
    "CMY_Y": 0.1865124,
    "CMYK_C": 0.01243455,
    "CMYK_M": 0,
    "CMYK_Y": 0.06305227,
    "CMYK_K": 0.1317685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06144",
    "Farbtonhilfsbezeichnung": "H6.59.65",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "188",
    "Bcolor": "47",
    "Y": 43,
    "L": 71.5775180139287,
    "a": -31.0283409488367,
    "b": 62.394422769071,
    "C": 69.6837279048906,
    "h": -1.10931626009211,
    "CMY_C": 0.4037653,
    "CMY_M": 0.2610704,
    "CMY_Y": 0.8158062,
    "CMYK_C": 0.1931103,
    "CMYK_M": 0,
    "CMYK_Y": 0.7507288,
    "CMYK_K": 0.2610704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06145",
    "Farbtonhilfsbezeichnung": "H7.42.70",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "198",
    "Bcolor": "100",
    "Y": 50,
    "L": 76.2324109196826,
    "a": -23.8200188076997,
    "b": 45.5628833679234,
    "C": 51.4137105916132,
    "h": -1.0890799544826,
    "CMY_C": 0.3253626,
    "CMY_M": 0.2219042,
    "CMY_Y": 0.609102,
    "CMYK_C": 0.1329636,
    "CMYK_M": 0,
    "CMYK_Y": 0.4976223,
    "CMYK_K": 0.2219042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06146",
    "Farbtonhilfsbezeichnung": "H6.28.78",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "220",
    "Bcolor": "146",
    "Y": 66,
    "L": 85.2126764865248,
    "a": -16.3742039951983,
    "b": 34.3955890538185,
    "C": 38.094239759254,
    "h": -1.12648727625683,
    "CMY_C": 0.1937104,
    "CMY_M": 0.1364356,
    "CMY_Y": 0.4290286,
    "CMYK_C": 0.06632368,
    "CMYK_M": 0,
    "CMYK_Y": 0.3388202,
    "CMYK_K": 0.1364356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06147",
    "Farbtonhilfsbezeichnung": "H6.20.80",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "225",
    "Bcolor": "169",
    "Y": 71,
    "L": 87.3783145808132,
    "a": -12.2645803117515,
    "b": 25.3218076514607,
    "C": 28.1356335091459,
    "h": -1.11974811087681,
    "CMY_C": 0.1605708,
    "CMY_M": 0.1193969,
    "CMY_Y": 0.33712,
    "CMYK_C": 0.04675651,
    "CMYK_M": 0,
    "CMYK_Y": 0.2472432,
    "CMYK_K": 0.1193969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06148",
    "Farbtonhilfsbezeichnung": "H7.08.75",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "205",
    "Bcolor": "184",
    "Y": 60,
    "L": 81.5871321975303,
    "a": -5.06094273801522,
    "b": 9.12429522852749,
    "C": 10.433882537905,
    "h": -1.0643772973507,
    "CMY_C": 0.2146243,
    "CMY_M": 0.1953216,
    "CMY_Y": 0.2778751,
    "CMYK_C": 0.02398811,
    "CMYK_M": 0,
    "CMYK_Y": 0.1025919,
    "CMYK_K": 0.1953216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06149",
    "Farbtonhilfsbezeichnung": "H9.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "213",
    "Bcolor": "190",
    "Y": 64,
    "L": 84.0917476976662,
    "a": -5.70520200520563,
    "b": 9.43315550909474,
    "C": 11.0242347933526,
    "h": -1.02685259371714,
    "CMY_C": 0.1913377,
    "CMY_M": 0.1665203,
    "CMY_Y": 0.2534863,
    "CMYK_C": 0.02977571,
    "CMYK_M": 0,
    "CMYK_Y": 0.1043409,
    "CMYK_K": 0.1665203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06150",
    "Farbtonhilfsbezeichnung": "H6.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "212",
    "Bcolor": "196",
    "Y": 64,
    "L": 84.3022842407227,
    "a": -3.79427456855774,
    "b": 6.76123142242432,
    "C": 7.75311374664307,
    "h": 119.300315856934,
    "CMY_C": 0.18256765604019,
    "CMY_M": 0.16780489683151,
    "CMY_Y": 0.23142409324646,
    "CMYK_C": 0.01773954182863,
    "CMYK_M": 0,
    "CMYK_Y": 0.07644745707512,
    "CMYK_K": 0.16780489683151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06151",
    "Farbtonhilfsbezeichnung": "H9.57.62",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "182",
    "Bcolor": "57",
    "Y": 39,
    "L": 69.0220473039111,
    "a": -32.0133972347893,
    "b": 56.0628901444719,
    "C": 64.5593157790844,
    "h": -1.05195334761642,
    "CMY_C": 0.4486104,
    "CMY_M": 0.2862958,
    "CMY_Y": 0.7771916,
    "CMYK_C": 0.2274255,
    "CMYK_M": 0,
    "CMYK_Y": 0.6878141,
    "CMYK_K": 0.2862958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06152",
    "Farbtonhilfsbezeichnung": "H6.36.68",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "193",
    "Bcolor": "106",
    "Y": 48,
    "L": 74.9552681976478,
    "a": -19.5876286104034,
    "b": 41.1541363576856,
    "C": 45.5778250240846,
    "h": -1.12656687282319,
    "CMY_C": 0.3160299,
    "CMY_M": 0.2432349,
    "CMY_Y": 0.5860253,
    "CMYK_C": 0.09619237,
    "CMYK_M": 0,
    "CMYK_Y": 0.4529681,
    "CMYK_K": 0.2432349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06153",
    "Farbtonhilfsbezeichnung": "H6.28.71",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "199",
    "Bcolor": "131",
    "Y": 53,
    "L": 77.8076136806056,
    "a": -15.5869227976284,
    "b": 31.9582916874462,
    "C": 35.556779520636,
    "h": -1.11701520891037,
    "CMY_C": 0.2746299,
    "CMY_M": 0.2188383,
    "CMY_Y": 0.4864176,
    "CMYK_C": 0.07142134,
    "CMYK_M": 0,
    "CMYK_Y": 0.3425402,
    "CMYK_K": 0.2188383
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06154",
    "Farbtonhilfsbezeichnung": "H9.23.73",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "203",
    "Bcolor": "147",
    "Y": 55,
    "L": 79.2325683416723,
    "a": -14.6504501251202,
    "b": 25.337290463219,
    "C": 29.2679684448061,
    "h": -1.04654780487084,
    "CMY_C": 0.2680679,
    "CMY_M": 0.2040389,
    "CMY_Y": 0.4225098,
    "CMYK_C": 0.08044235,
    "CMYK_M": 0,
    "CMYK_Y": 0.2744743,
    "CMYK_K": 0.2040389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06155",
    "Farbtonhilfsbezeichnung": "H6.14.75",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "210",
    "Bcolor": "171",
    "Y": 62,
    "L": 82.6636668695942,
    "a": -8.75589504833285,
    "b": 17.7873000541799,
    "C": 19.8255830006295,
    "h": -1.11336354597104,
    "CMY_C": 0.2058852,
    "CMY_M": 0.1774297,
    "CMY_Y": 0.3302831,
    "CMYK_C": 0.03459342,
    "CMYK_M": 0,
    "CMYK_Y": 0.1858241,
    "CMYK_K": 0.1774297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06156",
    "Farbtonhilfsbezeichnung": "H6.07.74",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "183",
    "Y": 57,
    "L": 80.3075538995946,
    "a": -4.20106406648019,
    "b": 7.99996156361042,
    "C": 9.03594623212839,
    "h": -1.08724308413861,
    "CMY_C": 0.2253785,
    "CMY_M": 0.210908,
    "CMY_Y": 0.2832045,
    "CMYK_C": 0.01833817,
    "CMYK_M": 0,
    "CMYK_Y": 0.09161988,
    "CMYK_K": 0.210908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06157",
    "Farbtonhilfsbezeichnung": "H9.62.62",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "181",
    "Bcolor": "26",
    "Y": 38,
    "L": 68.0413844244284,
    "a": -36.2040740572004,
    "b": 64.7524046594873,
    "C": 74.1863119957128,
    "h": -1.0609815880325,
    "CMY_C": 0.4801109,
    "CMY_M": 0.2906148,
    "CMY_Y": 0.8997996,
    "CMYK_C": 0.2671272,
    "CMYK_M": 0,
    "CMYK_Y": 0.8587504,
    "CMYK_K": 0.2906148
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06158",
    "Farbtonhilfsbezeichnung": "H6.50.64",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "185",
    "Bcolor": "75",
    "Y": 43,
    "L": 71.3017447443021,
    "a": -25.0638877615131,
    "b": 51.0256469752155,
    "C": 56.84905556789,
    "h": -1.11421204813949,
    "CMY_C": 0.3787604,
    "CMY_M": 0.273516,
    "CMY_Y": 0.7046003,
    "CMYK_C": 0.1448681,
    "CMYK_M": 0,
    "CMYK_Y": 0.5933844,
    "CMYK_K": 0.273516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06159",
    "Farbtonhilfsbezeichnung": "H8.30.69",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "195",
    "Bcolor": "121",
    "Y": 49,
    "L": 75.7529039029336,
    "a": -18.800613984541,
    "b": 34.2184352068055,
    "C": 39.0431094330109,
    "h": -1.06839130966553,
    "CMY_C": 0.3159601,
    "CMY_M": 0.235093,
    "CMY_Y": 0.5248171,
    "CMYK_C": 0.1057215,
    "CMYK_M": 0,
    "CMYK_Y": 0.3787704,
    "CMYK_K": 0.235093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06160",
    "Farbtonhilfsbezeichnung": "H7.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "205",
    "Bcolor": "152",
    "Y": 58,
    "L": 80.4799693200905,
    "a": -12.4857224404197,
    "b": 24.5534037430052,
    "C": 27.5456512035244,
    "h": -1.10036161683674,
    "CMY_C": 0.2400474,
    "CMY_M": 0.1947659,
    "CMY_Y": 0.4034687,
    "CMYK_C": 0.05623391,
    "CMYK_M": 0,
    "CMYK_Y": 0.2591828,
    "CMYK_K": 0.1947659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06161",
    "Farbtonhilfsbezeichnung": "H9.15.75",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "210",
    "Bcolor": "169",
    "Y": 61,
    "L": 82.4409726393088,
    "a": -10.5946645478268,
    "b": 18.2397435542617,
    "C": 21.0934862411648,
    "h": -1.04457224171289,
    "CMY_C": 0.2211483,
    "CMY_M": 0.1760005,
    "CMY_Y": 0.3362456,
    "CMYK_C": 0.05479099,
    "CMYK_M": 0,
    "CMYK_Y": 0.1944723,
    "CMYK_K": 0.1760005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06162",
    "Farbtonhilfsbezeichnung": "H6.09.71",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "196",
    "Bcolor": "174",
    "Y": 54,
    "L": 78.3784791505704,
    "a": -4.36970584675217,
    "b": 10.1831103555909,
    "C": 11.0810678953466,
    "h": -1.16544702835672,
    "CMY_C": 0.2409644,
    "CMY_M": 0.232003,
    "CMY_Y": 0.3193951,
    "CMYK_C": 0.01166845,
    "CMYK_M": 0,
    "CMYK_Y": 0.1137922,
    "CMYK_K": 0.232003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06163",
    "Farbtonhilfsbezeichnung": "H9.08.72",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "199",
    "Bcolor": "178",
    "Y": 55,
    "L": 79.2768634613794,
    "a": -4.9990871806978,
    "b": 8.8769692579874,
    "C": 10.1878091780064,
    "h": -1.05791135835611,
    "CMY_C": 0.2399582,
    "CMY_M": 0.2205496,
    "CMY_Y": 0.300586,
    "CMYK_C": 0.02490035,
    "CMYK_M": 0,
    "CMYK_Y": 0.1026831,
    "CMYK_K": 0.2205496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06164",
    "Farbtonhilfsbezeichnung": "H9.04.71",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "197",
    "Bcolor": "185",
    "Y": 55,
    "L": 78.93465975695,
    "a": -2.86268170034715,
    "b": 4.82913385835324,
    "C": 5.61386500901082,
    "h": -1.0356921852588,
    "CMY_C": 0.2399225,
    "CMY_M": 0.2280051,
    "CMY_Y": 0.2747339,
    "CMYK_C": 0.01543714,
    "CMYK_M": 0,
    "CMYK_Y": 0.06052994,
    "CMYK_K": 0.2280051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06165",
    "Farbtonhilfsbezeichnung": "H6.58.55",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "161",
    "Bcolor": "25",
    "Y": 31,
    "L": 62.1596825614164,
    "a": -27.362256046821,
    "b": 59.7505916069446,
    "C": 65.7177773007554,
    "h": -1.1413581761433,
    "CMY_C": 0.4826106,
    "CMY_M": 0.3671949,
    "CMY_Y": 0.9004338,
    "CMYK_C": 0.1823874,
    "CMYK_M": 0,
    "CMYK_Y": 0.842659,
    "CMYK_K": 0.3671949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06166",
    "Farbtonhilfsbezeichnung": "H4.49.55",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "158",
    "Bcolor": "61",
    "Y": 30,
    "L": 61.9022121607195,
    "a": -20.1302231783025,
    "b": 46.8435553468701,
    "C": 50.9857290106119,
    "h": -1.16492359679695,
    "CMY_C": 0.4505478,
    "CMY_M": 0.3813757,
    "CMY_Y": 0.7615296,
    "CMYK_C": 0.111816,
    "CMYK_M": 0,
    "CMYK_Y": 0.6145149,
    "CMYK_K": 0.3813757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06167",
    "Farbtonhilfsbezeichnung": "H6.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "168",
    "Bcolor": "88",
    "Y": 35,
    "L": 66.0457048950992,
    "a": -18.5886880084553,
    "b": 38.6162620291625,
    "C": 42.857379936023,
    "h": -1.12216395130907,
    "CMY_C": 0.4092228,
    "CMY_M": 0.3398534,
    "CMY_Y": 0.6543356,
    "CMYK_C": 0.1050818,
    "CMYK_M": 0,
    "CMYK_Y": 0.4763823,
    "CMYK_K": 0.3398534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06168",
    "Farbtonhilfsbezeichnung": "H6.31.61",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "172",
    "Bcolor": "107",
    "Y": 38,
    "L": 67.952795110702,
    "a": -14.5258737509899,
    "b": 31.477346839103,
    "C": 34.667338695938,
    "h": -1.13844440227955,
    "CMY_C": 0.3737263,
    "CMY_M": 0.3264915,
    "CMY_Y": 0.581234,
    "CMYK_C": 0.07013244,
    "CMYK_M": 0,
    "CMYK_Y": 0.3782321,
    "CMYK_K": 0.3264915
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06169",
    "Farbtonhilfsbezeichnung": "H6.15.67",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "186",
    "Bcolor": "150",
    "Y": 47,
    "L": 74.135819386259,
    "a": -8.02913902780389,
    "b": 16.869780451546,
    "C": 18.6830555855076,
    "h": -1.12657475488832,
    "CMY_C": 0.2951643,
    "CMY_M": 0.2712658,
    "CMY_Y": 0.4121718,
    "CMYK_C": 0.03279451,
    "CMYK_M": 0,
    "CMYK_Y": 0.1933572,
    "CMYK_K": 0.2712658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06171",
    "Farbtonhilfsbezeichnung": "H6.04.71",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "195",
    "Bcolor": "182",
    "Y": 54,
    "L": 78.1940488132445,
    "a": -2.81796418444724,
    "b": 5.55801915581138,
    "C": 6.23157276144583,
    "h": -1.10155747427039,
    "CMY_C": 0.2452658,
    "CMY_M": 0.2363107,
    "CMY_Y": 0.2878391,
    "CMYK_C": 0.0117261,
    "CMYK_M": 0,
    "CMYK_Y": 0.067473,
    "CMYK_K": 0.2363107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06172",
    "Farbtonhilfsbezeichnung": "H8.68.54",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "165",
    "Bcolor": "0",
    "Y": 31,
    "L": 62.2631428488854,
    "a": -35.117851463519,
    "b": 65.0309255139262,
    "C": 73.9072713920058,
    "h": -1.07564935189178,
    "CMY_C": 0.5344065,
    "CMY_M": 0.3538409,
    "CMY_Y": 1,
    "CMYK_C": 0.2794444,
    "CMYK_M": 0,
    "CMYK_Y": 1,
    "CMYK_K": 0.3538409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06173",
    "Farbtonhilfsbezeichnung": "H9.50.49",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "150",
    "Bcolor": "63",
    "Y": 26,
    "L": 58.0897578483277,
    "a": -25.5604515614318,
    "b": 41.2624720208426,
    "C": 48.5379056129859,
    "h": -1.01619074319806,
    "CMY_C": 0.539229,
    "CMY_M": 0.4108923,
    "CMY_Y": 0.754099,
    "CMYK_C": 0.2178493,
    "CMYK_M": 0,
    "CMYK_Y": 0.5825874,
    "CMYK_K": 0.4108923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06174",
    "Farbtonhilfsbezeichnung": "H6.31.53",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "149",
    "Bcolor": "93",
    "Y": 28,
    "L": 59.665982931389,
    "a": -13.5600869263647,
    "b": 27.6272401596986,
    "C": 30.7756455056954,
    "h": -1.11451717407187,
    "CMY_C": 0.4615554,
    "CMY_M": 0.414232,
    "CMY_Y": 0.6337239,
    "CMYK_C": 0.0807886,
    "CMYK_M": 0,
    "CMYK_Y": 0.3747078,
    "CMYK_K": 0.414232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06175",
    "Farbtonhilfsbezeichnung": "H9.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "169",
    "Bcolor": "108",
    "Y": 36,
    "L": 66.5385751349307,
    "a": -16.9335666192033,
    "b": 28.6381233891448,
    "C": 33.2699231994737,
    "h": -1.03680247451641,
    "CMY_C": 0.4124678,
    "CMY_M": 0.3363093,
    "CMY_Y": 0.5748632,
    "CMYK_C": 0.11475,
    "CMYK_M": 0,
    "CMYK_Y": 0.3594353,
    "CMYK_K": 0.3363093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06176",
    "Farbtonhilfsbezeichnung": "H6.10.61",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "170",
    "Bcolor": "148",
    "Y": 39,
    "L": 68.7161442566054,
    "a": -4.46540090752218,
    "b": 10.3572791950732,
    "C": 11.2788757236524,
    "h": -1.16373952733386,
    "CMY_C": 0.3442909,
    "CMY_M": 0.3350523,
    "CMY_Y": 0.4209154,
    "CMYK_C": 0.01389355,
    "CMYK_M": 0,
    "CMYK_Y": 0.1291275,
    "CMYK_K": 0.3350523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06177",
    "Farbtonhilfsbezeichnung": "H7.09.62",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "172",
    "Bcolor": "152",
    "Y": 40,
    "L": 69.3273161233193,
    "a": -4.93375287111003,
    "b": 8.90211400132799,
    "C": 10.1778952188469,
    "h": -1.06471696909227,
    "CMY_C": 0.3455084,
    "CMY_M": 0.3272577,
    "CMY_Y": 0.4044979,
    "CMYK_C": 0.02712888,
    "CMYK_M": 0,
    "CMYK_Y": 0.1148139,
    "CMYK_K": 0.3272577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06178",
    "Farbtonhilfsbezeichnung": "H7.05.63",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "172",
    "Bcolor": "159",
    "Y": 41,
    "L": 69.915793497913,
    "a": -2.64486484840898,
    "b": 5.68796843328812,
    "C": 6.27282192991571,
    "h": -1.13554450448043,
    "CMY_C": 0.3318875,
    "CMY_M": 0.3252298,
    "CMY_Y": 0.3755228,
    "CMYK_C": 0.009866616,
    "CMYK_M": 0,
    "CMYK_Y": 0.07453356,
    "CMYK_K": 0.3252298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06181",
    "Farbtonhilfsbezeichnung": "H6.34.44",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "129",
    "Bcolor": "74",
    "Y": 20,
    "L": 51.8885150427197,
    "a": -13.468947683395,
    "b": 27.9175793028511,
    "C": 30.996835093748,
    "h": -1.12128379204279,
    "CMY_C": 0.5396076,
    "CMY_M": 0.4935359,
    "CMY_Y": 0.7093617,
    "CMYK_C": 0.09096729,
    "CMYK_M": 0,
    "CMYK_Y": 0.4261423,
    "CMYK_K": 0.4935359
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06182",
    "Farbtonhilfsbezeichnung": "H6.20.49",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "142",
    "Bcolor": "108",
    "Y": 24,
    "L": 57.6763191223145,
    "a": -8.64562797546387,
    "b": 16.5920963287354,
    "C": 18.7094764709473,
    "h": 117.52262878418,
    "CMY_C": 0.47215807437897,
    "CMY_M": 0.44224232435226,
    "CMY_Y": 0.57490032911301,
    "CMYK_C": 0.05363574624062,
    "CMYK_M": 0,
    "CMYK_Y": 0.23784165084362,
    "CMYK_K": 0.44224232435226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06183",
    "Farbtonhilfsbezeichnung": "H6.15.58",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "162",
    "Bcolor": "129",
    "Y": 34,
    "L": 65.3614349365234,
    "a": -7.95528221130371,
    "b": 15.777626991272,
    "C": 17.6697483062744,
    "h": 116.757820129395,
    "CMY_C": 0.39015883207321,
    "CMY_M": 0.36407375335693,
    "CMY_Y": 0.49337923526764,
    "CMYK_C": 0.04101902991533,
    "CMYK_M": 0,
    "CMYK_Y": 0.20333409309387,
    "CMYK_K": 0.36407375335693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06184",
    "Farbtonhilfsbezeichnung": "H8.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "151",
    "Bcolor": "140",
    "Y": 30,
    "L": 61.886310873204,
    "a": -2.74162594910571,
    "b": 4.98990326798106,
    "C": 5.69347411240429,
    "h": -1.06838723959732,
    "CMY_C": 0.4183488,
    "CMY_M": 0.4086866,
    "CMY_Y": 0.4528565,
    "CMYK_C": 0.01634017,
    "CMYK_M": 0,
    "CMYK_Y": 0.07469792,
    "CMYK_K": 0.4086866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06185",
    "Farbtonhilfsbezeichnung": "H9.60.51",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "151",
    "Bcolor": "46",
    "Y": 26,
    "L": 57.9261229538392,
    "a": -29.7521681040492,
    "b": 48.3332358311972,
    "C": 56.7564374569592,
    "h": -1.01901172139011,
    "CMY_C": 0.5612937,
    "CMY_M": 0.4064471,
    "CMY_Y": 0.8185406,
    "CMYK_C": 0.260881,
    "CMYK_M": 0,
    "CMYK_Y": 0.6942827,
    "CMYK_K": 0.4064471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06186",
    "Farbtonhilfsbezeichnung": "H9.51.41",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "126",
    "Bcolor": "58",
    "Y": 18,
    "L": 49.7141670319827,
    "a": -20.3743485795352,
    "b": 33.5095098607321,
    "C": 39.2173600736575,
    "h": -1.02450288428521,
    "CMY_C": 0.5997255,
    "CMY_M": 0.5040124,
    "CMY_Y": 0.771727,
    "CMYK_C": 0.1929748,
    "CMYK_M": 0,
    "CMYK_Y": 0.5397606,
    "CMYK_K": 0.5040124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06190",
    "Farbtonhilfsbezeichnung": "H9.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "129",
    "Bcolor": "47",
    "Y": 19,
    "L": 50.248788956605,
    "a": -23.3742365440191,
    "b": 39.5922417675506,
    "C": 45.9771741432195,
    "h": -1.03748471461648,
    "CMY_C": 0.6058216,
    "CMY_M": 0.4943791,
    "CMY_Y": 0.8152749,
    "CMYK_C": 0.2204072,
    "CMYK_M": 0,
    "CMYK_Y": 0.634657,
    "CMYK_K": 0.4943791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06191",
    "Farbtonhilfsbezeichnung": "H9.41.39",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "118",
    "Bcolor": "62",
    "Y": 16,
    "L": 46.8300872880833,
    "a": -17.0851774549912,
    "b": 28.0397820781527,
    "C": 32.8349306023149,
    "h": -1.02355264036301,
    "CMY_C": 0.6149313,
    "CMY_M": 0.5375817,
    "CMY_Y": 0.7576656,
    "CMYK_C": 0.167272,
    "CMYK_M": 0,
    "CMYK_Y": 0.4759412,
    "CMYK_K": 0.5375817
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06192",
    "Farbtonhilfsbezeichnung": "H7.32.30",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "97",
    "Bcolor": "65",
    "Y": 11,
    "L": 39.3027531439753,
    "a": -10.5044565529457,
    "b": 16.5194137955366,
    "C": 19.5763796351851,
    "h": -1.00440746684508,
    "CMY_C": 0.6655113,
    "CMY_M": 0.6203845,
    "CMY_Y": 0.7463629,
    "CMYK_C": 0.1188752,
    "CMYK_M": 0,
    "CMYK_Y": 0.3318579,
    "CMYK_K": 0.6203845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06193",
    "Farbtonhilfsbezeichnung": "H8.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "99",
    "Bcolor": "78",
    "Y": 11,
    "L": 41.1165428161621,
    "a": -6.12632656097412,
    "b": 10.8796710968018,
    "C": 12.4859571456909,
    "h": 119.383796691895,
    "CMY_C": 0.63187694549561,
    "CMY_M": 0.60996842384338,
    "CMY_Y": 0.69293075799942,
    "CMYK_C": 0.05617114901543,
    "CMYK_M": 0,
    "CMYK_Y": 0.21270671486855,
    "CMYK_K": 0.60996842384338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06194",
    "Farbtonhilfsbezeichnung": "H8.17.26",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "85",
    "Bcolor": "70",
    "Y": 9,
    "L": 35.5247265938964,
    "a": -4.5653488121872,
    "b": 7.7996279869302,
    "C": 9.03751107946452,
    "h": -1.0412341422463,
    "CMY_C": 0.681599,
    "CMY_M": 0.6651413,
    "CMY_Y": 0.7239909,
    "CMYK_C": 0.04914802,
    "CMYK_M": 0,
    "CMYK_Y": 0.1757444,
    "CMYK_K": 0.6651413
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06195",
    "Farbtonhilfsbezeichnung": "H6.13.29",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "90",
    "Bcolor": "76",
    "Y": 10,
    "L": 37.6931535981841,
    "a": -3.31818216901647,
    "b": 7.30811204186318,
    "C": 8.02613446954413,
    "h": -1.14458702595345,
    "CMY_C": 0.6544174,
    "CMY_M": 0.6470792,
    "CMY_Y": 0.7011456,
    "CMYK_C": 0.02079265,
    "CMYK_M": 0,
    "CMYK_Y": 0.1531971,
    "CMYK_K": 0.6470792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06196",
    "Farbtonhilfsbezeichnung": "H8.07.30",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "91",
    "Bcolor": "83",
    "Y": 10,
    "L": 38.201518976332,
    "a": -2.23813870431372,
    "b": 4.04215852017075,
    "C": 4.62042317996264,
    "h": -1.06511770985187,
    "CMY_C": 0.6509907,
    "CMY_M": 0.6436831,
    "CMY_Y": 0.675882,
    "CMYK_C": 0.02050856,
    "CMYK_M": 0,
    "CMYK_Y": 0.09036563,
    "CMYK_K": 0.6436831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06197",
    "Farbtonhilfsbezeichnung": "H9.05.36",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "103",
    "Bcolor": "96",
    "Y": 13,
    "L": 43.2047418133179,
    "a": -2.05697186885173,
    "b": 3.00825219166267,
    "C": 3.64427146599847,
    "h": -0.97104186719525,
    "CMY_C": 0.6051534,
    "CMY_M": 0.5961382,
    "CMY_Y": 0.6225907,
    "CMYK_C": 0.02232252,
    "CMYK_M": 0,
    "CMYK_Y": 0.06549889,
    "CMYK_K": 0.5961382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06198",
    "Farbtonhilfsbezeichnung": "H9.50.33",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "107",
    "Bcolor": "49",
    "Y": 13,
    "L": 42.2808557732426,
    "a": -18.2921750233049,
    "b": 29.4035170980926,
    "C": 34.6290410612399,
    "h": -1.01427906593247,
    "CMY_C": 0.6652969,
    "CMY_M": 0.5803905,
    "CMY_Y": 0.8089566,
    "CMYK_C": 0.2023461,
    "CMYK_M": 0,
    "CMYK_Y": 0.5447115,
    "CMYK_K": 0.5803905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06199",
    "Farbtonhilfsbezeichnung": "H9.41.30",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "97",
    "Bcolor": "55",
    "Y": 11,
    "L": 39.0797859232684,
    "a": -13.7050702062908,
    "b": 21.7529401351386,
    "C": 25.7102966509973,
    "h": -1.00858595706873,
    "CMY_C": 0.6784425,
    "CMY_M": 0.6178278,
    "CMY_Y": 0.7833659,
    "CMYK_C": 0.1586058,
    "CMYK_M": 0,
    "CMYK_Y": 0.4331506,
    "CMYK_K": 0.6178278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06200",
    "Farbtonhilfsbezeichnung": "H8.30.21",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "75",
    "Bcolor": "51",
    "Y": 6,
    "L": 30.5041154570333,
    "a": -7.52420312293703,
    "b": 13.1798292617059,
    "C": 15.1763477820896,
    "h": -1.05205800080191,
    "CMY_C": 0.7344233,
    "CMY_M": 0.7071247,
    "CMY_Y": 0.801855,
    "CMYK_C": 0.093209,
    "CMYK_M": 0,
    "CMYK_Y": 0.3234495,
    "CMYK_K": 0.7071247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06201",
    "Farbtonhilfsbezeichnung": "H8.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "70",
    "Bcolor": "52",
    "Y": 6,
    "L": 28.6689604819648,
    "a": -5.90524135738515,
    "b": 9.61766846533034,
    "C": 11.2858948337286,
    "h": -1.02014679146279,
    "CMY_C": 0.7483594,
    "CMY_M": 0.7259617,
    "CMY_Y": 0.7955676,
    "CMYK_C": 0.08173215,
    "CMYK_M": 0,
    "CMYK_Y": 0.2540009,
    "CMYK_K": 0.7259617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06202",
    "Farbtonhilfsbezeichnung": "H6.17.14",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "57",
    "Bcolor": "46",
    "Y": 4,
    "L": 23.4461918646115,
    "a": -2.94567119885794,
    "b": 6.49355579405002,
    "C": 7.13044498346504,
    "h": -1.14492785979147,
    "CMY_C": 0.7830667,
    "CMY_M": 0.7768641,
    "CMY_Y": 0.8209286,
    "CMYK_C": 0.02779796,
    "CMYK_M": 0,
    "CMYK_Y": 0.1974786,
    "CMYK_K": 0.7768641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06203",
    "Farbtonhilfsbezeichnung": "H7.11.21",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "69",
    "Bcolor": "59",
    "Y": 6,
    "L": 28.8763678618085,
    "a": -3.0441000241781,
    "b": 5.63622675377111,
    "C": 6.40574718336014,
    "h": -1.07558922072616,
    "CMY_C": 0.7377172,
    "CMY_M": 0.7284293,
    "CMY_Y": 0.7694253,
    "CMYK_C": 0.03420045,
    "CMYK_M": 0,
    "CMYK_Y": 0.1509587,
    "CMYK_K": 0.7284293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06204",
    "Farbtonhilfsbezeichnung": "H6.08.19",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "62",
    "Bcolor": "53",
    "Y": 5,
    "L": 25.8233707257148,
    "a": -2.75672431836191,
    "b": 5.0963302978781,
    "C": 5.79414458505466,
    "h": -1.07494841119728,
    "CMY_C": 0.7643427,
    "CMY_M": 0.7560734,
    "CMY_Y": 0.7925688,
    "CMYK_C": 0.03390043,
    "CMYK_M": 0,
    "CMYK_Y": 0.1496162,
    "CMYK_K": 0.7560734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06205",
    "Farbtonhilfsbezeichnung": "H8.22.85",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "240",
    "Bcolor": "175",
    "Y": 81,
    "L": 92.3483707684662,
    "a": -15.0158044439181,
    "b": 28.9046996013599,
    "C": 32.5723201835983,
    "h": -1.09167578676334,
    "CMY_C": 0.1171499,
    "CMY_M": 0.05864116,
    "CMY_Y": 0.3120969,
    "CMYK_C": 0.06215348,
    "CMYK_M": 0,
    "CMYK_Y": 0.2692446,
    "CMYK_K": 0.05864116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06206",
    "Farbtonhilfsbezeichnung": "H7.18.80",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "224",
    "Bcolor": "171",
    "Y": 70,
    "L": 87.0810862859256,
    "a": -11.7646886821429,
    "b": 23.99942001572,
    "C": 26.7278891960941,
    "h": -1.11501359742565,
    "CMY_C": 0.163491,
    "CMY_M": 0.1235036,
    "CMY_Y": 0.3302675,
    "CMYK_C": 0.04562185,
    "CMYK_M": 0,
    "CMYK_Y": 0.2358982,
    "CMYK_K": 0.1235036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06207",
    "Farbtonhilfsbezeichnung": "J0.14.85",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "235",
    "Bcolor": "194",
    "Y": 79,
    "L": 91.2435455322266,
    "a": -11.2903251647949,
    "b": 17.8693313598633,
    "C": 21.1372756958008,
    "h": 122.285797119141,
    "CMY_C": 0.13076174259186,
    "CMY_M": 0.07675015926361,
    "CMY_Y": 0.23998773097992,
    "CMYK_C": 0.05850159004331,
    "CMYK_M": 0,
    "CMYK_Y": 0.17680758237839,
    "CMYK_K": 0.07675015926361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06208",
    "Farbtonhilfsbezeichnung": "H8.09.87",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "239",
    "Bcolor": "210",
    "Y": 85,
    "L": 93.3193969726562,
    "a": -6.30524158477783,
    "b": 12.4902715682983,
    "C": 13.9915313720703,
    "h": 116.785194396973,
    "CMY_C": 0.08443063497543,
    "CMY_M": 0.06332886219025,
    "CMY_Y": 0.17644721269608,
    "CMYK_C": 0.02252847515047,
    "CMYK_M": 0,
    "CMYK_Y": 0.12076634913683,
    "CMYK_K": 0.06332886219025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06209",
    "Farbtonhilfsbezeichnung": "J3.38.75",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "216",
    "Bcolor": "125",
    "Y": 59,
    "L": 81.4646258054984,
    "a": -29.0865674499126,
    "b": 39.683611546468,
    "C": 49.2018031314838,
    "h": -0.93828920257455,
    "CMY_C": 0.3227624,
    "CMY_M": 0.1538535,
    "CMY_Y": 0.5109044,
    "CMYK_C": 0.1996213,
    "CMYK_M": 0,
    "CMYK_Y": 0.4219728,
    "CMYK_K": 0.1538535
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06210",
    "Farbtonhilfsbezeichnung": "J3.23.78",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "223",
    "Bcolor": "159",
    "Y": 67,
    "L": 85.521728515625,
    "a": -19.0957832336426,
    "b": 28.0333633422852,
    "C": 33.9192924499512,
    "h": 124.261932373047,
    "CMY_C": 0.22725242376328,
    "CMY_M": 0.12624174356461,
    "CMY_Y": 0.37818509340286,
    "CMYK_C": 0.11560483276844,
    "CMYK_M": 0,
    "CMYK_Y": 0.28834444284439,
    "CMYK_K": 0.12624174356461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06211",
    "Farbtonhilfsbezeichnung": "J0.21.80",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "224",
    "Bcolor": "166",
    "Y": 69,
    "L": 86.5227810940554,
    "a": -15.1151841248909,
    "b": 25.5313986405349,
    "C": 29.6702057234402,
    "h": -1.03626265632539,
    "CMY_C": 0.191541,
    "CMY_M": 0.1228775,
    "CMY_Y": 0.3482027,
    "CMYK_C": 0.07828264,
    "CMYK_M": 0,
    "CMYK_Y": 0.2568913,
    "CMYK_K": 0.1228775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06212",
    "Farbtonhilfsbezeichnung": "J1.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "227",
    "Bcolor": "192",
    "Y": 73,
    "L": 88.564197165697,
    "a": -9.55803613967565,
    "b": 15.1353883240292,
    "C": 17.9007272077563,
    "h": -1.0075346885644,
    "CMY_C": 0.1549197,
    "CMY_M": 0.1098787,
    "CMY_Y": 0.2481317,
    "CMYK_C": 0.05060096,
    "CMYK_M": 0,
    "CMYK_Y": 0.1553193,
    "CMYK_K": 0.1098787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06213",
    "Farbtonhilfsbezeichnung": "J1.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "236",
    "Bcolor": "211",
    "Y": 81,
    "L": 92.0246490745597,
    "a": -6.74949807647435,
    "b": 9.91049669803288,
    "C": 11.9905658367757,
    "h": -0.9729051715282,
    "CMY_C": 0.1105087,
    "CMY_M": 0.07622865,
    "CMY_Y": 0.1713836,
    "CMYK_C": 0.03710883,
    "CMYK_M": 0,
    "CMYK_Y": 0.1030071,
    "CMYK_K": 0.07622865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06214",
    "Farbtonhilfsbezeichnung": "J5.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "241",
    "Bcolor": "224",
    "Y": 86,
    "L": 94.2930461814582,
    "a": -4.35779521650032,
    "b": 6.86007911192361,
    "C": 8.12718060404736,
    "h": -1.00486743045591,
    "CMY_C": 0.07599513,
    "CMY_M": 0.05544628,
    "CMY_Y": 0.1233676,
    "CMYK_C": 0.02175509,
    "CMYK_M": 0,
    "CMYK_Y": 0.07190833,
    "CMYK_K": 0.05544628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06215",
    "Farbtonhilfsbezeichnung": "JN.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "238",
    "Bcolor": "228",
    "Y": 83,
    "L": 93.2009791997316,
    "a": -3.54172713990963,
    "b": 3.11328501642691,
    "C": 4.7155460688112,
    "h": -0.72110802109222,
    "CMY_C": 0.09427819,
    "CMY_M": 0.068597,
    "CMY_Y": 0.1073525,
    "CMYK_C": 0.02757258,
    "CMYK_M": 0,
    "CMYK_Y": 0.04160976,
    "CMYK_K": 0.068597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06216",
    "Farbtonhilfsbezeichnung": "J0.41.71",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "202",
    "Bcolor": "100",
    "Y": 51,
    "L": 76.6468769156262,
    "a": -28.0569299488715,
    "b": 45.5561958894872,
    "C": 53.5028812502394,
    "h": -1.01878561120358,
    "CMY_C": 0.3536862,
    "CMY_M": 0.2095364,
    "CMY_Y": 0.6059549,
    "CMYK_C": 0.1823611,
    "CMYK_M": 0,
    "CMYK_Y": 0.5015013,
    "CMYK_K": 0.2095364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06217",
    "Farbtonhilfsbezeichnung": "J3.27.75",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "216",
    "Bcolor": "148",
    "Y": 61,
    "L": 82.5884900077732,
    "a": -21.6634898237701,
    "b": 29.344079078136,
    "C": 36.4743988064024,
    "h": -0.93485279868856,
    "CMY_C": 0.276324,
    "CMY_M": 0.153866,
    "CMY_Y": 0.4189889,
    "CMYK_C": 0.1447265,
    "CMYK_M": 0,
    "CMYK_Y": 0.3133343,
    "CMYK_K": 0.153866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06218",
    "Farbtonhilfsbezeichnung": "J3.20.79",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "223",
    "Bcolor": "170",
    "Y": 68,
    "L": 85.94974058624,
    "a": -16.515650010555,
    "b": 22.9527312653072,
    "C": 28.2771032428811,
    "h": -0.94706935062849,
    "CMY_C": 0.2159967,
    "CMY_M": 0.1257974,
    "CMY_Y": 0.3352009,
    "CMYK_C": 0.1031789,
    "CMYK_M": 0,
    "CMYK_Y": 0.2395366,
    "CMYK_K": 0.1257974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06219",
    "Farbtonhilfsbezeichnung": "J2.13.81",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "228",
    "Bcolor": "191",
    "Y": 74,
    "L": 88.759482792888,
    "a": -10.8130892003818,
    "b": 15.8164594707271,
    "C": 19.1594177428377,
    "h": -0.97112082369902,
    "CMY_C": 0.1606359,
    "CMY_M": 0.1051122,
    "CMY_Y": 0.2512929,
    "CMYK_C": 0.06204544,
    "CMYK_M": 0,
    "CMYK_Y": 0.1633508,
    "CMYK_K": 0.1051122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06220",
    "Farbtonhilfsbezeichnung": "J4.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "232",
    "Bcolor": "209",
    "Y": 78,
    "L": 90.8373204015201,
    "a": -6.92073555445,
    "b": 9.23353838026053,
    "C": 11.5392725782162,
    "h": -0.92760152714091,
    "CMY_C": 0.127247,
    "CMY_M": 0.08895899,
    "CMY_Y": 0.1793231,
    "CMYK_C": 0.04202667,
    "CMYK_M": 0,
    "CMYK_Y": 0.09918773,
    "CMYK_K": 0.08895899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06221",
    "Farbtonhilfsbezeichnung": "J1.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "226",
    "Bcolor": "216",
    "Y": 75,
    "L": 89.506844412863,
    "a": -2.56856107348313,
    "b": 3.9358603972975,
    "C": 4.69984074785813,
    "h": -0.9925921987372,
    "CMY_C": 0.1248144,
    "CMY_M": 0.1123576,
    "CMY_Y": 0.1539865,
    "CMYK_C": 0.01403357,
    "CMYK_M": 0,
    "CMYK_Y": 0.04689832,
    "CMYK_K": 0.1123576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06222",
    "Farbtonhilfsbezeichnung": "J1.49.66",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "193",
    "Bcolor": "80",
    "Y": 45,
    "L": 72.9264989342132,
    "a": -32.622938736545,
    "b": 50.5269969849263,
    "C": 60.1434415054802,
    "h": -0.99748262549428,
    "CMY_C": 0.4207968,
    "CMY_M": 0.2425559,
    "CMY_Y": 0.6861041,
    "CMYK_C": 0.2353189,
    "CMYK_M": 0,
    "CMYK_Y": 0.5855854,
    "CMYK_K": 0.2425559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06223",
    "Farbtonhilfsbezeichnung": "J1.34.73",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "209",
    "Bcolor": "127",
    "Y": 56,
    "L": 79.8735138089316,
    "a": -24.5465654793284,
    "b": 36.6789201090859,
    "C": 44.1347601919355,
    "h": -0.98102249143925,
    "CMY_C": 0.3103881,
    "CMY_M": 0.1794477,
    "CMY_Y": 0.5029666,
    "CMYK_C": 0.159576,
    "CMYK_M": 0,
    "CMYK_Y": 0.3942698,
    "CMYK_K": 0.1794477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06224",
    "Farbtonhilfsbezeichnung": "J0.26.74",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "209",
    "Bcolor": "144",
    "Y": 58,
    "L": 80.9278679107737,
    "a": -18.1452945821668,
    "b": 29.554187401916,
    "C": 34.6799900297157,
    "h": -1.0201702517503,
    "CMY_C": 0.2659552,
    "CMY_M": 0.1791809,
    "CMY_Y": 0.4370348,
    "CMYK_C": 0.1057167,
    "CMYK_M": 0,
    "CMYK_Y": 0.3141422,
    "CMYK_K": 0.1791809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06225",
    "Farbtonhilfsbezeichnung": "J4.13.79",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "214",
    "Bcolor": "179",
    "Y": 63,
    "L": 83.6909484429507,
    "a": -11.3843810183712,
    "b": 14.6713596992857,
    "C": 18.5702161160628,
    "h": -0.91088708007791,
    "CMY_C": 0.2241636,
    "CMY_M": 0.1597739,
    "CMY_Y": 0.296984,
    "CMYK_C": 0.07663375,
    "CMYK_M": 0,
    "CMYK_Y": 0.1633015,
    "CMYK_K": 0.1597739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06226",
    "Farbtonhilfsbezeichnung": "J5.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "227",
    "Bcolor": "200",
    "Y": 74,
    "L": 88.7647840094272,
    "a": -8.463657956016,
    "b": 10.9210338496946,
    "C": 13.8167465903739,
    "h": -0.91149445494228,
    "CMY_C": 0.1570665,
    "CMY_M": 0.1090511,
    "CMY_Y": 0.2145649,
    "CMYK_C": 0.05389237,
    "CMYK_M": 0,
    "CMYK_Y": 0.1184286,
    "CMYK_K": 0.1090511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06228",
    "Farbtonhilfsbezeichnung": "J2.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "223",
    "Bcolor": "210",
    "Y": 72,
    "L": 88.1233897728738,
    "a": -3.33565169975686,
    "b": 4.68543795002154,
    "C": 5.75151293535822,
    "h": -0.95211582940299,
    "CMY_C": 0.1436959,
    "CMY_M": 0.1261522,
    "CMY_Y": 0.1747432,
    "CMYK_C": 0.0200764,
    "CMYK_M": 0,
    "CMYK_Y": 0.0556058,
    "CMYK_K": 0.1261522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06229",
    "Farbtonhilfsbezeichnung": "J1.42.65",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "189",
    "Bcolor": "95",
    "Y": 43,
    "L": 71.8088763905257,
    "a": -28.6368193317983,
    "b": 42.2653345195261,
    "C": 51.0531676146496,
    "h": -0.97529784778957,
    "CMY_C": 0.4172336,
    "CMY_M": 0.2605974,
    "CMY_Y": 0.6283446,
    "CMYK_C": 0.2118416,
    "CMYK_M": 0,
    "CMYK_Y": 0.4973572,
    "CMYK_K": 0.2605974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06231",
    "Farbtonhilfsbezeichnung": "J4.20.72",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "204",
    "Bcolor": "157",
    "Y": 55,
    "L": 79.247732624517,
    "a": -16.298427760862,
    "b": 20.3891029617906,
    "C": 26.1027635905192,
    "h": -0.89643993247957,
    "CMY_C": 0.2942246,
    "CMY_M": 0.1995388,
    "CMY_Y": 0.3862701,
    "CMYK_C": 0.118289,
    "CMYK_M": 0,
    "CMYK_Y": 0.2332796,
    "CMYK_K": 0.1995388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06232",
    "Farbtonhilfsbezeichnung": "J1.13.76",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "209",
    "Bcolor": "177",
    "Y": 61,
    "L": 82.1229979135716,
    "a": -9.29224900580794,
    "b": 13.5448472435104,
    "C": 16.4258570076563,
    "h": -0.96950397391078,
    "CMY_C": 0.2281583,
    "CMY_M": 0.1812336,
    "CMY_Y": 0.3050177,
    "CMYK_C": 0.05731144,
    "CMYK_M": 0,
    "CMYK_Y": 0.1511836,
    "CMYK_K": 0.1812336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06233",
    "Farbtonhilfsbezeichnung": "J0.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "219",
    "Bcolor": "197",
    "Y": 69,
    "L": 86.3441566945247,
    "a": -6.08298364669219,
    "b": 8.99032049247785,
    "C": 10.8548861165556,
    "h": -0.97593815843624,
    "CMY_C": 0.1709911,
    "CMY_M": 0.1407337,
    "CMY_Y": 0.2260988,
    "CMYK_C": 0.03521305,
    "CMYK_M": 0,
    "CMYK_Y": 0.09934651,
    "CMYK_K": 0.1407337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06234",
    "Farbtonhilfsbezeichnung": "J0.04.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "220",
    "Bcolor": "207",
    "Y": 70,
    "L": 86.97296033865,
    "a": -3.31634397789493,
    "b": 4.66741859138051,
    "C": 5.72563827768437,
    "h": -0.9530377193121,
    "CMY_C": 0.1562912,
    "CMY_M": 0.1389314,
    "CMY_Y": 0.1871338,
    "CMYK_C": 0.02016072,
    "CMYK_M": 0,
    "CMYK_Y": 0.05597973,
    "CMYK_K": 0.1389314
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06235",
    "Farbtonhilfsbezeichnung": "J5.04.80",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "220",
    "Bcolor": "207",
    "Y": 70,
    "L": 86.9060339250473,
    "a": -3.72236509766238,
    "b": 4.5313858161292,
    "C": 5.86425266636013,
    "h": -0.88310460439031,
    "CMY_C": 0.160681,
    "CMY_M": 0.1387059,
    "CMY_Y": 0.1869201,
    "CMYK_C": 0.02551415,
    "CMYK_M": 0,
    "CMYK_Y": 0.05597884,
    "CMYK_K": 0.1387059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06236",
    "Farbtonhilfsbezeichnung": "J0.51.60",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "173",
    "Bcolor": "66",
    "Y": 35,
    "L": 66.0717852450021,
    "a": -29.5177381161217,
    "b": 48.8726436483779,
    "C": 57.0949398867647,
    "h": -1.02746090892721,
    "CMY_C": 0.4726082,
    "CMY_M": 0.3213067,
    "CMY_Y": 0.7403263,
    "CMYK_C": 0.2229306,
    "CMYK_M": 0,
    "CMYK_Y": 0.6173918,
    "CMYK_K": 0.3213067
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06237",
    "Farbtonhilfsbezeichnung": "J0.41.60",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "175",
    "Bcolor": "87",
    "Y": 37,
    "L": 67.3337960797292,
    "a": -24.7145473036096,
    "b": 40.3984720895955,
    "C": 47.3586887022453,
    "h": -1.02176780235965,
    "CMY_C": 0.4378048,
    "CMY_M": 0.3152559,
    "CMY_Y": 0.656996,
    "CMYK_C": 0.1789705,
    "CMYK_M": 0,
    "CMYK_Y": 0.4990771,
    "CMYK_K": 0.3152559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06238",
    "Farbtonhilfsbezeichnung": "J2.34.66",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "193",
    "Bcolor": "117",
    "Y": 47,
    "L": 74.1771131546366,
    "a": -24.0506624675533,
    "b": 33.8991266942196,
    "C": 41.5642292814258,
    "h": -0.95373800641946,
    "CMY_C": 0.3743096,
    "CMY_M": 0.2420957,
    "CMY_Y": 0.5393277,
    "CMYK_C": 0.1744466,
    "CMYK_M": 0,
    "CMYK_Y": 0.3921762,
    "CMYK_K": 0.2420957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06239",
    "Farbtonhilfsbezeichnung": "J4.21.64",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "181",
    "Bcolor": "136",
    "Y": 42,
    "L": 70.9226384489413,
    "a": -15.3960758551782,
    "b": 19.9384476706014,
    "C": 25.1908881790958,
    "h": -0.91325030973931,
    "CMY_C": 0.3767588,
    "CMY_M": 0.2911918,
    "CMY_Y": 0.4681414,
    "CMYK_C": 0.1207195,
    "CMYK_M": 0,
    "CMYK_Y": 0.2496439,
    "CMYK_K": 0.2911918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06240",
    "Farbtonhilfsbezeichnung": "J1.15.73",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "205",
    "Bcolor": "167",
    "Y": 58,
    "L": 80.61960147633,
    "a": -10.7419187043221,
    "b": 16.7318349525335,
    "C": 19.8832371189675,
    "h": -1.00006216771445,
    "CMY_C": 0.2463553,
    "CMY_M": 0.1952962,
    "CMY_Y": 0.3443364,
    "CMYK_C": 0.06345079,
    "CMYK_M": 0,
    "CMYK_Y": 0.1852112,
    "CMYK_K": 0.1952962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06241",
    "Farbtonhilfsbezeichnung": "J2.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "196",
    "Y": 64,
    "L": 83.8280982698449,
    "a": -3.47164902604119,
    "b": 5.99735434234911,
    "C": 6.92969018554989,
    "h": -1.04606343410407,
    "CMY_C": 0.1876999,
    "CMY_M": 0.1735729,
    "CMY_Y": 0.2309075,
    "CMYK_C": 0.0170941,
    "CMYK_M": 0,
    "CMYK_Y": 0.06937648,
    "CMYK_K": 0.1735729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06242",
    "Farbtonhilfsbezeichnung": "J4.03.75",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "207",
    "Bcolor": "197",
    "Y": 61,
    "L": 82.3895319687102,
    "a": -3.55170803042615,
    "b": 3.45062114577286,
    "C": 4.95191036116854,
    "h": -0.77096298608603,
    "CMY_C": 0.2123356,
    "CMY_M": 0.1884785,
    "CMY_Y": 0.2278766,
    "CMYK_C": 0.02939799,
    "CMYK_M": 0,
    "CMYK_Y": 0.04854844,
    "CMYK_K": 0.1884785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06243",
    "Farbtonhilfsbezeichnung": "J2.55.55",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "168",
    "Bcolor": "70",
    "Y": 31,
    "L": 63.5249710083008,
    "a": -34.3194808959961,
    "b": 43.7505187988281,
    "C": 55.605167388916,
    "h": 128.111923217773,
    "CMY_C": 0.54873335361481,
    "CMY_M": 0.33991122245789,
    "CMY_Y": 0.72371190786362,
    "CMYK_C": 0.3163546025753,
    "CMYK_M": 0,
    "CMYK_Y": 0.58143800497055,
    "CMYK_K": 0.33991122245789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06244",
    "Farbtonhilfsbezeichnung": "J1.51.58",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "174",
    "Bcolor": "70",
    "Y": 36,
    "L": 66.2071387317988,
    "a": -30.3300432426628,
    "b": 47.1641935047091,
    "C": 56.0747061699964,
    "h": -0.9993057680111,
    "CMY_C": 0.4806487,
    "CMY_M": 0.318313,
    "CMY_Y": 0.7245131,
    "CMYK_C": 0.2381382,
    "CMYK_M": 0,
    "CMYK_Y": 0.5958748,
    "CMYK_K": 0.318313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06245",
    "Farbtonhilfsbezeichnung": "J1.35.56",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "163",
    "Bcolor": "97",
    "Y": 32,
    "L": 63.5437732542178,
    "a": -21.3793757175265,
    "b": 30.7933135312823,
    "C": 37.4874094104542,
    "h": -0.96391536255967,
    "CMY_C": 0.4723229,
    "CMY_M": 0.3599309,
    "CMY_Y": 0.6207305,
    "CMYK_C": 0.1755936,
    "CMYK_M": 0,
    "CMYK_Y": 0.4074553,
    "CMYK_K": 0.3599309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06246",
    "Farbtonhilfsbezeichnung": "J4.29.60",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "175",
    "Bcolor": "115",
    "Y": 38,
    "L": 67.8790502149905,
    "a": -20.7795131525905,
    "b": 26.7622502933965,
    "C": 33.8822402982017,
    "h": -0.91058183940494,
    "CMY_C": 0.4324676,
    "CMY_M": 0.3145883,
    "CMY_Y": 0.5487218,
    "CMYK_C": 0.1719831,
    "CMYK_M": 0,
    "CMYK_Y": 0.3415954,
    "CMYK_K": 0.3145883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06247",
    "Farbtonhilfsbezeichnung": "J4.14.67",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "191",
    "Bcolor": "157",
    "Y": 48,
    "L": 75.5387496948242,
    "a": -11.0816049575806,
    "b": 14.6943273544312,
    "C": 18.4044895172119,
    "h": 127.021461486816,
    "CMY_C": 0.30944538116455,
    "CMY_M": 0.24926817417145,
    "CMY_Y": 0.38254553079605,
    "CMYK_C": 0.08015806227922,
    "CMYK_M": 0,
    "CMYK_Y": 0.17752991616726,
    "CMYK_K": 0.24926817417145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06248",
    "Farbtonhilfsbezeichnung": "J4.07.70",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "193",
    "Bcolor": "176",
    "Y": 52,
    "L": 77.0221696862737,
    "a": -5.76039094088926,
    "b": 6.976294123138,
    "C": 9.04714228275475,
    "h": -0.88057438328543,
    "CMY_C": 0.2759961,
    "CMY_M": 0.2428128,
    "CMY_Y": 0.3108329,
    "CMYK_C": 0.04382433,
    "CMYK_M": 0,
    "CMYK_Y": 0.0898326,
    "CMYK_K": 0.2428128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06249",
    "Farbtonhilfsbezeichnung": "J4.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "202",
    "Bcolor": "184",
    "Y": 57,
    "L": 80.2132119719518,
    "a": -5.82362024511512,
    "b": 7.24062562162455,
    "C": 9.29199721006419,
    "h": -0.89344018058697,
    "CMY_C": 0.241322,
    "CMY_M": 0.2081405,
    "CMY_Y": 0.278949,
    "CMYK_C": 0.04190334,
    "CMYK_M": 0,
    "CMYK_Y": 0.08942056,
    "CMYK_K": 0.2081405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06250",
    "Farbtonhilfsbezeichnung": "J5.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "196",
    "Bcolor": "186",
    "Y": 54,
    "L": 78.5689315795898,
    "a": -3.80855560302734,
    "b": 3.80319786071777,
    "C": 5.38232374191284,
    "h": 135.040328979492,
    "CMY_C": 0.25449168682098,
    "CMY_M": 0.2295555472374,
    "CMY_Y": 0.27137929201126,
    "CMYK_C": 0.03236591443419,
    "CMYK_M": 0,
    "CMYK_Y": 0.05428521707654,
    "CMYK_K": 0.2295555472374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06251",
    "Farbtonhilfsbezeichnung": "J4.58.53",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "161",
    "Bcolor": "58",
    "Y": 29,
    "L": 60.524462670087,
    "a": -37.4859343097349,
    "b": 45.7131560257345,
    "C": 59.117576953956,
    "h": -0.88396368234287,
    "CMY_C": 0.6040785,
    "CMY_M": 0.3669857,
    "CMY_Y": 0.7709781,
    "CMYK_C": 0.3745457,
    "CMYK_M": 0,
    "CMYK_Y": 0.6382042,
    "CMYK_K": 0.3669857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06252",
    "Farbtonhilfsbezeichnung": "J4.50.49",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "153",
    "Bcolor": "74",
    "Y": 24,
    "L": 58.1901969909668,
    "a": -30.4280967712402,
    "b": 35.781852722168,
    "C": 46.9703102111816,
    "h": 130.377105712891,
    "CMY_C": 0.58854925632477,
    "CMY_M": 0.40128475427628,
    "CMY_Y": 0.71135580539703,
    "CMYK_C": 0.31277725100517,
    "CMYK_M": 0,
    "CMYK_Y": 0.51789402961731,
    "CMYK_K": 0.40128475427628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06253",
    "Farbtonhilfsbezeichnung": "J2.44.53",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "155",
    "Bcolor": "78",
    "Y": 28,
    "L": 59.9623238265153,
    "a": -25.1390111616386,
    "b": 35.7783330178101,
    "C": 43.727096813284,
    "h": -0.95830592548329,
    "CMY_C": 0.5273837,
    "CMY_M": 0.3915055,
    "CMY_Y": 0.6931567,
    "CMYK_C": 0.2233024,
    "CMYK_M": 0,
    "CMYK_Y": 0.4957338,
    "CMYK_K": 0.3915055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06254",
    "Farbtonhilfsbezeichnung": "J4.22.55",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "158",
    "Bcolor": "115",
    "Y": 31,
    "L": 62.4522771249736,
    "a": -15.1590567319044,
    "b": 19.2634678963088,
    "C": 24.5128169820039,
    "h": -0.90407406792437,
    "CMY_C": 0.464534,
    "CMY_M": 0.3808993,
    "CMY_Y": 0.5478162,
    "CMYK_C": 0.1350907,
    "CMYK_M": 0,
    "CMYK_Y": 0.2696118,
    "CMYK_K": 0.3808993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06255",
    "Farbtonhilfsbezeichnung": "J4.15.58",
    "Farbtonklasse": "03",
    "Rcolor": "148",
    "Gcolor": "163",
    "Bcolor": "133",
    "Y": 34,
    "L": 65.1782354923734,
    "a": -10.7737747924782,
    "b": 13.3563957354329,
    "C": 17.1600562446785,
    "h": -0.89202097972296,
    "CMY_C": 0.4196123,
    "CMY_M": 0.3597859,
    "CMY_Y": 0.4787099,
    "CMYK_C": 0.09344757,
    "CMYK_M": 0,
    "CMYK_Y": 0.1857566,
    "CMYK_K": 0.3597859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06256",
    "Farbtonhilfsbezeichnung": "J0.15.66",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "183",
    "Bcolor": "146",
    "Y": 45,
    "L": 72.6397854222333,
    "a": -9.69728066102082,
    "b": 16.8415987710194,
    "C": 19.4339059733912,
    "h": -1.0483660240006,
    "CMY_C": 0.323641,
    "CMY_M": 0.2837595,
    "CMY_Y": 0.4275709,
    "CMYK_C": 0.05568168,
    "CMYK_M": 0,
    "CMYK_Y": 0.2007864,
    "CMYK_K": 0.2837595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06257",
    "Farbtonhilfsbezeichnung": "J2.04.59",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "164",
    "Bcolor": "155",
    "Y": 36,
    "L": 66.9546127319336,
    "a": -3.05548167228699,
    "b": 3.56653881072998,
    "C": 4.69639921188354,
    "h": 130.5869140625,
    "CMY_C": 0.37256062030792,
    "CMY_M": 0.35494089126587,
    "CMY_Y": 0.3913362622261,
    "CMYK_C": 0.02731490693986,
    "CMYK_M": 0,
    "CMYK_Y": 0.05642176046968,
    "CMYK_K": 0.35494089126587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06258",
    "Farbtonhilfsbezeichnung": "J1.63.45",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "142",
    "Bcolor": "44",
    "Y": 22,
    "L": 54.0034493512975,
    "a": -31.5746763807914,
    "b": 44.7863042529916,
    "C": 54.7975659787297,
    "h": -0.95671758423311,
    "CMY_C": 0.6225898,
    "CMY_M": 0.4438201,
    "CMY_Y": 0.8262411,
    "CMYK_C": 0.3214242,
    "CMYK_M": 0,
    "CMYK_Y": 0.6875851,
    "CMYK_K": 0.4438201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06259",
    "Farbtonhilfsbezeichnung": "J0.55.49",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "149",
    "Bcolor": "56",
    "Y": 25,
    "L": 57.3108539913955,
    "a": -28.2404397280231,
    "b": 43.4875633560576,
    "C": 51.8525853037168,
    "h": -0.99484922398984,
    "CMY_C": 0.5640066,
    "CMY_M": 0.4147895,
    "CMY_Y": 0.7808884,
    "CMYK_C": 0.2549802,
    "CMYK_M": 0,
    "CMYK_Y": 0.6255849,
    "CMYK_K": 0.4147895
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06260",
    "Farbtonhilfsbezeichnung": "J2.39.46",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "137",
    "Bcolor": "77",
    "Y": 22,
    "L": 53.7720288274133,
    "a": -21.2456984966677,
    "b": 28.3892076418111,
    "C": 35.4588044798633,
    "h": -0.92833771774153,
    "CMY_C": 0.576108,
    "CMY_M": 0.4608917,
    "CMY_Y": 0.6966705,
    "CMYK_C": 0.2137166,
    "CMYK_M": 0,
    "CMYK_Y": 0.4373496,
    "CMYK_K": 0.4608917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06261",
    "Farbtonhilfsbezeichnung": "J4.30.51",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "150",
    "Bcolor": "97",
    "Y": 27,
    "L": 58.815611845495,
    "a": -19.0272130883548,
    "b": 24.2118128820977,
    "C": 30.7936149379603,
    "h": -0.90473399290331,
    "CMY_C": 0.5183147,
    "CMY_M": 0.4123766,
    "CMY_Y": 0.61865,
    "CMYK_C": 0.1802824,
    "CMYK_M": 0,
    "CMYK_Y": 0.3510299,
    "CMYK_K": 0.4123766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06262",
    "Farbtonhilfsbezeichnung": "J0.21.49",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "139",
    "Bcolor": "104",
    "Y": 24,
    "L": 56.0818123279147,
    "a": -10.792097241473,
    "b": 16.6466754205122,
    "C": 19.838880145444,
    "h": -0.99561467898413,
    "CMY_C": 0.5035297,
    "CMY_M": 0.4543334,
    "CMY_Y": 0.5910514,
    "CMYK_C": 0.090158,
    "CMYK_M": 0,
    "CMYK_Y": 0.2505522,
    "CMYK_K": 0.4543334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06263",
    "Farbtonhilfsbezeichnung": "J4.16.49",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "142",
    "Bcolor": "113",
    "Y": 25,
    "L": 57.2517779249544,
    "a": -10.1335783565814,
    "b": 13.202195867313,
    "C": 16.6429380227131,
    "h": -0.91614640470707,
    "CMY_C": 0.4960416,
    "CMY_M": 0.4430104,
    "CMY_Y": 0.5560666,
    "CMYK_C": 0.09521031,
    "CMYK_M": 0,
    "CMYK_Y": 0.2029771,
    "CMYK_K": 0.4430104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06264",
    "Farbtonhilfsbezeichnung": "JN.02.56",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "152",
    "Bcolor": "147",
    "Y": 31,
    "L": 62.5426430092723,
    "a": -2.02871206146005,
    "b": 1.86305321449698,
    "C": 2.75438557728598,
    "h": -0.74285733911168,
    "CMY_C": 0.415997,
    "CMY_M": 0.4026561,
    "CMY_Y": 0.4246618,
    "CMYK_C": 0.02233367,
    "CMYK_M": 0,
    "CMYK_Y": 0.03683916,
    "CMYK_K": 0.4026561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06266",
    "Farbtonhilfsbezeichnung": "J0.49.42",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "130",
    "Bcolor": "58",
    "Y": 19,
    "L": 50.7566196429367,
    "a": -23.0453186218535,
    "b": 34.5906059380926,
    "C": 41.5643685089423,
    "h": -0.98309570688446,
    "CMY_C": 0.607057,
    "CMY_M": 0.4892605,
    "CMY_Y": 0.7708301,
    "CMYK_C": 0.2306391,
    "CMYK_M": 0,
    "CMYK_Y": 0.5512978,
    "CMYK_K": 0.4892605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06267",
    "Farbtonhilfsbezeichnung": "J3.32.42",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "125",
    "Bcolor": "78",
    "Y": 18,
    "L": 49.5883510070096,
    "a": -17.3841459389941,
    "b": 22.7172294201551,
    "C": 28.6056120814815,
    "h": -0.91761238281193,
    "CMY_C": 0.6014202,
    "CMY_M": 0.5088876,
    "CMY_Y": 0.6952035,
    "CMYK_C": 0.1884143,
    "CMYK_M": 0,
    "CMYK_Y": 0.3793751,
    "CMYK_K": 0.5088876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06268",
    "Farbtonhilfsbezeichnung": "J1.30.39",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "118",
    "Bcolor": "76",
    "Y": 16,
    "L": 47.2704922448814,
    "a": -13.9569335543916,
    "b": 20.9305673685779,
    "C": 25.1571986638473,
    "h": -0.98268715949312,
    "CMY_C": 0.603249,
    "CMY_M": 0.537621,
    "CMY_Y": 0.7038449,
    "CMYK_C": 0.1419353,
    "CMYK_M": 0,
    "CMYK_Y": 0.359497,
    "CMYK_K": 0.537621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06269",
    "Farbtonhilfsbezeichnung": "J4.24.46",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "132",
    "Bcolor": "94",
    "Y": 21,
    "L": 52.632053810013,
    "a": -13.7384478693795,
    "b": 17.400333604897,
    "C": 22.1701727422536,
    "h": -0.90245938374228,
    "CMY_C": 0.5575348,
    "CMY_M": 0.483896,
    "CMY_Y": 0.6296881,
    "CMYK_C": 0.1426822,
    "CMYK_M": 0,
    "CMYK_Y": 0.2824859,
    "CMYK_K": 0.483896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06271",
    "Farbtonhilfsbezeichnung": "J0.10.43",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "123",
    "Bcolor": "106",
    "Y": 19,
    "L": 50.7563273498539,
    "a": -5.22539526780996,
    "b": 8.14330779072947,
    "C": 9.67565075224432,
    "h": -1.00029243250127,
    "CMY_C": 0.539301,
    "CMY_M": 0.5170559,
    "CMY_Y": 0.5843497,
    "CMYK_C": 0.04606144,
    "CMYK_M": 0,
    "CMYK_Y": 0.1393409,
    "CMYK_K": 0.5170559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06273",
    "Farbtonhilfsbezeichnung": "J5.49.40",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "125",
    "Bcolor": "63",
    "Y": 16,
    "L": 48.4650001525879,
    "a": -25.1131534576416,
    "b": 29.3042640686035,
    "C": 38.5928802490234,
    "h": 130.595901489258,
    "CMY_C": 0.65695345401764,
    "CMY_M": 0.50841438770294,
    "CMY_Y": 0.7533905506134,
    "CMYK_C": 0.3021631538868,
    "CMYK_M": 0,
    "CMYK_Y": 0.49833875894547,
    "CMYK_K": 0.50841438770294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06274",
    "Farbtonhilfsbezeichnung": "J3.42.36",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "113",
    "Bcolor": "61",
    "Y": 14,
    "L": 44.5718209759473,
    "a": -19.7103460189433,
    "b": 25.4078806559012,
    "C": 32.1567743968669,
    "h": -0.91101337493353,
    "CMY_C": 0.6614619,
    "CMY_M": 0.5551949,
    "CMY_Y": 0.7602543,
    "CMYK_C": 0.2389069,
    "CMYK_M": 0,
    "CMYK_Y": 0.4610097,
    "CMYK_K": 0.5551949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06275",
    "Farbtonhilfsbezeichnung": "J3.38.32",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "103",
    "Bcolor": "61",
    "Y": 12,
    "L": 40.8467688474401,
    "a": -16.6822052397919,
    "b": 20.3620525927567,
    "C": 26.3231676941194,
    "h": -0.88440985375357,
    "CMY_C": 0.6858742,
    "CMY_M": 0.5957524,
    "CMY_Y": 0.7588666,
    "CMYK_C": 0.2229374,
    "CMYK_M": 0,
    "CMYK_Y": 0.4035008,
    "CMYK_K": 0.5957524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06276",
    "Farbtonhilfsbezeichnung": "J4.28.36",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "111",
    "Bcolor": "75",
    "Y": 14,
    "L": 44.4599053142912,
    "a": -13.4053389174203,
    "b": 17.6019411762046,
    "C": 22.1253575035856,
    "h": -0.91992322839347,
    "CMY_C": 0.6342161,
    "CMY_M": 0.5656917,
    "CMY_Y": 0.7072495,
    "CMYK_C": 0.1577781,
    "CMYK_M": 0,
    "CMYK_Y": 0.3259385,
    "CMYK_K": 0.5656917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06277",
    "Farbtonhilfsbezeichnung": "J4.21.32",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "97",
    "Bcolor": "72",
    "Y": 11,
    "L": 39.4409543890728,
    "a": -9.77123671215893,
    "b": 12.1621649921441,
    "C": 15.6011321442124,
    "h": -0.89397798639991,
    "CMY_C": 0.6694487,
    "CMY_M": 0.6196201,
    "CMY_Y": 0.7169302,
    "CMYK_C": 0.1309967,
    "CMYK_M": 0,
    "CMYK_Y": 0.2558232,
    "CMYK_K": 0.6196201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06278",
    "Farbtonhilfsbezeichnung": "J2.14.30",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "92",
    "Bcolor": "76",
    "Y": 10,
    "L": 37.890844021058,
    "a": -5.98277215627738,
    "b": 7.3575875823308,
    "C": 9.48301944032576,
    "h": -0.88809247310639,
    "CMY_C": 0.670228,
    "CMY_M": 0.6402403,
    "CMY_Y": 0.7000096,
    "CMYK_C": 0.08335474,
    "CMYK_M": 0,
    "CMYK_Y": 0.1661368,
    "CMYK_K": 0.6402403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06279",
    "Farbtonhilfsbezeichnung": "JN.02.35",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "102",
    "Bcolor": "100",
    "Y": 13,
    "L": 43.1591938261558,
    "a": -0.86605700897485,
    "b": 0.43702117611021,
    "C": 0.97007332257063,
    "h": -0.46732894117153,
    "CMY_C": 0.604927,
    "CMY_M": 0.5983551,
    "CMY_Y": 0.6064457,
    "CMYK_C": 0.01636262,
    "CMYK_M": 0,
    "CMYK_Y": 0.0201438,
    "CMYK_K": 0.5983551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06280",
    "Farbtonhilfsbezeichnung": "J3.46.32",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "104",
    "Bcolor": "59",
    "Y": 12,
    "L": 40.9493026245617,
    "a": -18.1506706809426,
    "b": 22.031066212297,
    "C": 28.544959706026,
    "h": -0.88167075013818,
    "CMY_C": 0.6919469,
    "CMY_M": 0.5926342,
    "CMY_Y": 0.7694148,
    "CMYK_C": 0.2437923,
    "CMYK_M": 0,
    "CMYK_Y": 0.4339603,
    "CMYK_K": 0.5926342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06281",
    "Farbtonhilfsbezeichnung": "J5.32.27",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "91",
    "Bcolor": "63",
    "Y": 9,
    "L": 36.4252354068536,
    "a": -12.3352071722624,
    "b": 13.5907240325736,
    "C": 18.3538855753273,
    "h": -0.83378742886652,
    "CMY_C": 0.7119363,
    "CMY_M": 0.644124,
    "CMY_Y": 0.7534541,
    "CMYK_C": 0.1905503,
    "CMYK_M": 0,
    "CMYK_Y": 0.307214,
    "CMYK_K": 0.644124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06282",
    "Farbtonhilfsbezeichnung": "J1.32.26",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "88",
    "Bcolor": "58",
    "Y": 9,
    "L": 35.6103485949198,
    "a": -10.6829473095128,
    "b": 15.2874145616558,
    "C": 18.6502119880111,
    "h": -0.96087170204807,
    "CMY_C": 0.7039468,
    "CMY_M": 0.6548325,
    "CMY_Y": 0.7712181,
    "CMYK_C": 0.142291,
    "CMYK_M": 0,
    "CMYK_Y": 0.3371857,
    "CMYK_K": 0.6548325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06283",
    "Farbtonhilfsbezeichnung": "J5.28.22",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "75",
    "Bcolor": "54",
    "Y": 6,
    "L": 30.3471280078213,
    "a": -9.81429620994362,
    "b": 10.6736366587055,
    "C": 14.4998941243919,
    "h": -0.82731732851027,
    "CMY_C": 0.7566946,
    "CMY_M": 0.7043321,
    "CMY_Y": 0.7880927,
    "CMYK_C": 0.1770989,
    "CMYK_M": 0,
    "CMYK_Y": 0.2832927,
    "CMYK_K": 0.7043321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06284",
    "Farbtonhilfsbezeichnung": "J0.15.23",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "79",
    "Bcolor": "66",
    "Y": 8,
    "L": 32.9633101633644,
    "a": -4.09876585517671,
    "b": 6.85380819899046,
    "C": 7.98589809377201,
    "h": -1.03182844860413,
    "CMY_C": 0.7044772,
    "CMY_M": 0.689545,
    "CMY_Y": 0.7409728,
    "CMYK_C": 0.04809781,
    "CMYK_M": 0,
    "CMYK_Y": 0.165653,
    "CMYK_K": 0.689545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06286",
    "Farbtonhilfsbezeichnung": "J7.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "59",
    "Bcolor": "56",
    "Y": 4,
    "L": 24.5717320717017,
    "a": -1.92938311780963,
    "b": 1.20734826339531,
    "C": 2.27600725930575,
    "h": -0.55915215737099,
    "CMY_C": 0.7800757,
    "CMY_M": 0.7677827,
    "CMY_Y": 0.7804822,
    "CMYK_C": 0.052937,
    "CMYK_M": 0,
    "CMYK_Y": 0.0546878,
    "CMYK_K": 0.7677827
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06287",
    "Farbtonhilfsbezeichnung": "K1.21.80",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "230",
    "Bcolor": "177",
    "Y": 71,
    "L": 87.2754150421909,
    "a": -22.977007308639,
    "b": 20.6321191033893,
    "C": 30.8808549680493,
    "h": -0.73167931130841,
    "CMY_C": 0.2621792,
    "CMY_M": 0.0974585,
    "CMY_Y": 0.3049353,
    "CMYK_C": 0.1825077,
    "CMYK_M": 0,
    "CMYK_Y": 0.2298806,
    "CMYK_K": 0.0974585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06288",
    "Farbtonhilfsbezeichnung": "J8.10.85",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "239",
    "Bcolor": "210",
    "Y": 82,
    "L": 92.6233845441206,
    "a": -10.3505015874177,
    "b": 11.306832233571,
    "C": 15.3289705547782,
    "h": -0.82952685467728,
    "CMY_C": 0.1283461,
    "CMY_M": 0.06179385,
    "CMY_Y": 0.1758112,
    "CMYK_C": 0.07093561,
    "CMYK_M": 0,
    "CMYK_Y": 0.121527,
    "CMYK_K": 0.06179385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06289",
    "Farbtonhilfsbezeichnung": "K0.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "232",
    "Bcolor": "220",
    "Y": 79,
    "L": 91.202816193616,
    "a": -4.79782135623114,
    "b": 4.39704724501075,
    "C": 6.50792703102641,
    "h": -0.74183901966325,
    "CMY_C": 0.1222348,
    "CMY_M": 0.08843115,
    "CMY_Y": 0.1391091,
    "CMYK_C": 0.03708295,
    "CMYK_M": 0,
    "CMYK_Y": 0.05559416,
    "CMYK_K": 0.08843115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06290",
    "Farbtonhilfsbezeichnung": "J8.32.72",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "210",
    "Bcolor": "136",
    "Y": 55,
    "L": 79.1402284220433,
    "a": -29.9140036180729,
    "b": 30.822787243516,
    "C": 42.9522039704731,
    "h": -0.80035970156657,
    "CMY_C": 0.3783818,
    "CMY_M": 0.1766018,
    "CMY_Y": 0.4670593,
    "CMYK_C": 0.2450576,
    "CMYK_M": 0,
    "CMYK_Y": 0.3527547,
    "CMYK_K": 0.1766018
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06291",
    "Farbtonhilfsbezeichnung": "K0.25.76",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "220",
    "Bcolor": "158",
    "Y": 63,
    "L": 83.2386453399711,
    "a": -26.566789928689,
    "b": 24.9117366098701,
    "C": 36.4196231176907,
    "h": -0.75325887081981,
    "CMY_C": 0.3231899,
    "CMY_M": 0.1363761,
    "CMY_Y": 0.3799181,
    "CMYK_C": 0.2163138,
    "CMYK_M": 0,
    "CMYK_Y": 0.282,
    "CMYK_K": 0.1363761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06292",
    "Farbtonhilfsbezeichnung": "J8.12.81",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "231",
    "Bcolor": "200",
    "Y": 75,
    "L": 89.5358502049986,
    "a": -11.5928859117572,
    "b": 12.0636680575697,
    "C": 16.7310218087912,
    "h": -0.80529624373321,
    "CMY_C": 0.170119,
    "CMY_M": 0.09386472,
    "CMY_Y": 0.2151718,
    "CMYK_C": 0.08415335,
    "CMYK_M": 0,
    "CMYK_Y": 0.133873,
    "CMYK_K": 0.09386472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06293",
    "Farbtonhilfsbezeichnung": "J8.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "231",
    "Bcolor": "205",
    "Y": 76,
    "L": 89.9605789576713,
    "a": -8.92082082281193,
    "b": 9.96821766042932,
    "C": 13.3770851637571,
    "h": -0.84079141898308,
    "CMY_C": 0.1506107,
    "CMY_M": 0.0944669,
    "CMY_Y": 0.1946135,
    "CMYK_C": 0.06200084,
    "CMYK_M": 0,
    "CMYK_Y": 0.110594,
    "CMYK_K": 0.0944669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06294",
    "Farbtonhilfsbezeichnung": "J7.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "238",
    "Bcolor": "218",
    "Y": 83,
    "L": 92.8963224561649,
    "a": -6.57602030886434,
    "b": 7.57341729830558,
    "C": 10.0299896648437,
    "h": -0.85577197935117,
    "CMY_C": 0.1070393,
    "CMY_M": 0.0662412,
    "CMY_Y": 0.1443911,
    "CMYK_C": 0.04369228,
    "CMYK_M": 0,
    "CMYK_Y": 0.0836939,
    "CMYK_K": 0.0662412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06297",
    "Farbtonhilfsbezeichnung": "J8.12.80",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "233",
    "Bcolor": "199",
    "Y": 78,
    "L": 90.2722930908203,
    "a": -11.8410940170288,
    "b": 13.470269203186,
    "C": 17.9348735809326,
    "h": 131.31721496582,
    "CMY_C": 0.15947234630585,
    "CMY_M": 0.08540368080139,
    "CMY_Y": 0.21770769357681,
    "CMYK_C": 0.08098509162664,
    "CMYK_M": 0,
    "CMYK_Y": 0.14465837180614,
    "CMYK_K": 0.08540368080139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06298",
    "Farbtonhilfsbezeichnung": "KN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "223",
    "Bcolor": "214",
    "Y": 73,
    "L": 88.26627461881,
    "a": -3.34786662207248,
    "b": 3.22346123959258,
    "C": 4.64746310177313,
    "h": -0.76646888063175,
    "CMY_C": 0.1471137,
    "CMY_M": 0.1241434,
    "CMY_Y": 0.1624185,
    "CMYK_C": 0.02622613,
    "CMYK_M": 0,
    "CMYK_Y": 0.04370025,
    "CMYK_K": 0.1241434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06299",
    "Farbtonhilfsbezeichnung": "J8.48.65",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "192",
    "Bcolor": "96",
    "Y": 43,
    "L": 71.2313320631118,
    "a": -40.2509934340292,
    "b": 40.6726090805401,
    "C": 57.2224047191718,
    "h": -0.79060816169971,
    "CMY_C": 0.5289553,
    "CMY_M": 0.2472024,
    "CMY_Y": 0.6241978,
    "CMYK_C": 0.3742744,
    "CMYK_M": 0,
    "CMYK_Y": 0.5007925,
    "CMYK_K": 0.2472024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06300",
    "Farbtonhilfsbezeichnung": "K1.31.70",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "209",
    "Bcolor": "119",
    "Y": 53,
    "L": 77.8909154937672,
    "a": -35.4649018729914,
    "b": 37.5954025691392,
    "C": 51.6833973263808,
    "h": -0.81455075352387,
    "CMY_C": 0.4216947,
    "CMY_M": 0.1816495,
    "CMY_Y": 0.5323905,
    "CMYK_C": 0.2933281,
    "CMYK_M": 0,
    "CMYK_Y": 0.4285951,
    "CMYK_K": 0.1816495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06301",
    "Farbtonhilfsbezeichnung": "J9.18.72",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "208",
    "Bcolor": "163",
    "Y": 57,
    "L": 80.0491957322875,
    "a": -18.2799711895566,
    "b": 17.7634934018788,
    "C": 25.4891946622409,
    "h": -0.7710698392865,
    "CMY_C": 0.3095995,
    "CMY_M": 0.1862456,
    "CMY_Y": 0.3590306,
    "CMYK_C": 0.1515861,
    "CMYK_M": 0,
    "CMYK_Y": 0.2123306,
    "CMYK_K": 0.1862456
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06302",
    "Farbtonhilfsbezeichnung": "J8.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "218",
    "Bcolor": "192",
    "Y": 67,
    "L": 85.4393478786641,
    "a": -9.56001936969852,
    "b": 10.4926440387448,
    "C": 14.1947014506406,
    "h": -0.83187344095499,
    "CMY_C": 0.2036752,
    "CMY_M": 0.1434274,
    "CMY_Y": 0.2473805,
    "CMYK_C": 0.07033585,
    "CMYK_M": 0,
    "CMYK_Y": 0.1213593,
    "CMYK_K": 0.1434274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06303",
    "Farbtonhilfsbezeichnung": "J9.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "205",
    "Bcolor": "187",
    "Y": 59,
    "L": 81.0608479958781,
    "a": -6.35837552742785,
    "b": 6.70388804126933,
    "C": 9.23964578420988,
    "h": -0.81184319451579,
    "CMY_C": 0.2380812,
    "CMY_M": 0.1975864,
    "CMY_Y": 0.2661095,
    "CMYK_C": 0.05046622,
    "CMYK_M": 0,
    "CMYK_Y": 0.08539627,
    "CMYK_K": 0.1975864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06304",
    "Farbtonhilfsbezeichnung": "KN.01.76",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "210",
    "Bcolor": "203",
    "Y": 63,
    "L": 83.673111258047,
    "a": -1.81498688274151,
    "b": 1.83763078295225,
    "C": 2.58284035104329,
    "h": -0.79159744626955,
    "CMY_C": 0.1901294,
    "CMY_M": 0.1779432,
    "CMY_Y": 0.2020495,
    "CMYK_C": 0.01482407,
    "CMYK_M": 0,
    "CMYK_Y": 0.02932439,
    "CMYK_K": 0.1779432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06305",
    "Farbtonhilfsbezeichnung": "J8.49.63",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "190",
    "Bcolor": "89",
    "Y": 41,
    "L": 70.4216083919599,
    "a": -40.4666342959711,
    "b": 43.2561230781479,
    "C": 59.2337798472775,
    "h": -0.81870400941296,
    "CMY_C": 0.5326545,
    "CMY_M": 0.2560024,
    "CMY_Y": 0.6529103,
    "CMYK_C": 0.3718454,
    "CMYK_M": 0,
    "CMYK_Y": 0.53348,
    "CMYK_K": 0.2560024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06306",
    "Farbtonhilfsbezeichnung": "J9.25.69",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "201",
    "Bcolor": "143",
    "Y": 51,
    "L": 76.7871902016657,
    "a": -23.7327516175169,
    "b": 24.1614232567749,
    "C": 33.8676523120776,
    "h": -0.79434831639706,
    "CMY_C": 0.3701419,
    "CMY_M": 0.2126424,
    "CMY_Y": 0.4405238,
    "CMYK_C": 0.2000356,
    "CMYK_M": 0,
    "CMYK_Y": 0.2894256,
    "CMYK_K": 0.2126424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06307",
    "Farbtonhilfsbezeichnung": "K1.19.69",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "200",
    "Bcolor": "158",
    "Y": 52,
    "L": 77.3259947450482,
    "a": -19.154070942681,
    "b": 17.0410783041025,
    "C": 25.6374098427241,
    "h": -0.72708655968233,
    "CMY_C": 0.3481195,
    "CMY_M": 0.2141405,
    "CMY_Y": 0.3822334,
    "CMYK_C": 0.1704873,
    "CMYK_M": 0,
    "CMYK_Y": 0.2138969,
    "CMYK_K": 0.2141405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06309",
    "Farbtonhilfsbezeichnung": "J8.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "210",
    "Bcolor": "196",
    "Y": 63,
    "L": 83.3686288873082,
    "a": -4.3198930877052,
    "b": 5.37005100088999,
    "C": 6.89194631735932,
    "h": -0.89335287808605,
    "CMY_C": 0.2013652,
    "CMY_M": 0.1765308,
    "CMY_Y": 0.2314016,
    "CMYK_C": 0.03015822,
    "CMYK_M": 0,
    "CMYK_Y": 0.06663369,
    "CMYK_K": 0.1765308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06310",
    "Farbtonhilfsbezeichnung": "J7.55.60",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "183",
    "Bcolor": "73",
    "Y": 37,
    "L": 67.6486216207734,
    "a": -41.9263154794985,
    "b": 47.1147653806326,
    "C": 63.0683521788741,
    "h": -0.84360263992827,
    "CMY_C": 0.5666542,
    "CMY_M": 0.2842529,
    "CMY_Y": 0.7129398,
    "CMYK_C": 0.3945546,
    "CMYK_M": 0,
    "CMYK_Y": 0.5989363,
    "CMYK_K": 0.2842529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06311",
    "Farbtonhilfsbezeichnung": "J8.42.62",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "184",
    "Bcolor": "101",
    "Y": 39,
    "L": 69.0119880336517,
    "a": -35.9215639834421,
    "b": 35.2626165991638,
    "C": 50.3369733738149,
    "h": -0.77614149207061,
    "CMY_C": 0.5267471,
    "CMY_M": 0.2775164,
    "CMY_Y": 0.6034248,
    "CMYK_C": 0.3449638,
    "CMYK_M": 0,
    "CMYK_Y": 0.4510946,
    "CMYK_K": 0.2775164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06312",
    "Farbtonhilfsbezeichnung": "J9.32.66",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "194",
    "Bcolor": "126",
    "Y": 46,
    "L": 73.6605305465441,
    "a": -28.353023298187,
    "b": 28.4822736664703,
    "C": 40.1887278146403,
    "h": -0.78767228093312,
    "CMY_C": 0.4297715,
    "CMY_M": 0.2389971,
    "CMY_Y": 0.5049221,
    "CMYK_C": 0.2506881,
    "CMYK_M": 0,
    "CMYK_Y": 0.3494402,
    "CMYK_K": 0.2389971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06313",
    "Farbtonhilfsbezeichnung": "K1.14.66",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "185",
    "Bcolor": "157",
    "Y": 45,
    "L": 72.9260365625665,
    "a": -12.6015526573741,
    "b": 11.3537709203829,
    "C": 16.9619351339729,
    "h": -0.73335732599993,
    "CMY_C": 0.359244,
    "CMY_M": 0.2735264,
    "CMY_Y": 0.3858806,
    "CMYK_C": 0.1179914,
    "CMYK_M": 0,
    "CMYK_Y": 0.154657,
    "CMYK_K": 0.2735264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06314",
    "Farbtonhilfsbezeichnung": "K0.11.70",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "198",
    "Bcolor": "173",
    "Y": 53,
    "L": 78.0747785955417,
    "a": -10.5006760063826,
    "b": 9.89243747289488,
    "C": 14.4265212628046,
    "h": -0.75558131992638,
    "CMY_C": 0.2926382,
    "CMY_M": 0.221961,
    "CMY_Y": 0.321397,
    "CMYK_C": 0.09084018,
    "CMYK_M": 0,
    "CMYK_Y": 0.1278034,
    "CMYK_K": 0.221961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06315",
    "Farbtonhilfsbezeichnung": "K1.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "197",
    "Bcolor": "188",
    "Y": 55,
    "L": 78.7552300292943,
    "a": -3.5898027119502,
    "b": 2.98678270182529,
    "C": 4.66985593125181,
    "h": -0.69396187850781,
    "CMY_C": 0.2534976,
    "CMY_M": 0.2278337,
    "CMY_Y": 0.263493,
    "CMYK_C": 0.03323628,
    "CMYK_M": 0,
    "CMYK_Y": 0.04618088,
    "CMYK_K": 0.2278337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06316",
    "Farbtonhilfsbezeichnung": "J8.50.58",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "177",
    "Bcolor": "81",
    "Y": 35,
    "L": 65.8532580670393,
    "a": -40.2520013182404,
    "b": 41.4706228788009,
    "C": 57.7930460529582,
    "h": -0.80030873756331,
    "CMY_C": 0.5841028,
    "CMY_M": 0.3055351,
    "CMY_Y": 0.6837537,
    "CMYK_C": 0.4011256,
    "CMYK_M": 0,
    "CMYK_Y": 0.5446188,
    "CMYK_K": 0.3055351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06317",
    "Farbtonhilfsbezeichnung": "K0.45.52",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "157",
    "Bcolor": "81",
    "Y": 27,
    "L": 59.1255023052522,
    "a": -34.5258559124124,
    "b": 32.8014499342374,
    "C": 47.6232069927356,
    "h": -0.75979147913996,
    "CMY_C": 0.6234862,
    "CMY_M": 0.3847434,
    "CMY_Y": 0.6807912,
    "CMYK_C": 0.3880378,
    "CMYK_M": 0,
    "CMYK_Y": 0.4811778,
    "CMYK_K": 0.3847434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06318",
    "Farbtonhilfsbezeichnung": "K1.52.35",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "115",
    "Bcolor": "57",
    "Y": 13,
    "L": 43.506418445036,
    "a": -30.4479098084507,
    "b": 26.2830347477012,
    "C": 40.222793628146,
    "h": -0.71211511244208,
    "CMY_C": 0.7608072,
    "CMY_M": 0.5497907,
    "CMY_Y": 0.778075,
    "CMYK_C": 0.4687074,
    "CMYK_M": 0,
    "CMYK_Y": 0.5070626,
    "CMYK_K": 0.5497907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06319",
    "Farbtonhilfsbezeichnung": "K0.50.29",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "101",
    "Bcolor": "59",
    "Y": 11,
    "L": 39.0166674906979,
    "a": -23.4654281546081,
    "b": 19.4792006098112,
    "C": 30.4969764874544,
    "h": -0.69284088637617,
    "CMY_C": 0.7595111,
    "CMY_M": 0.6029518,
    "CMY_Y": 0.7704338,
    "CMYK_C": 0.3943079,
    "CMYK_M": 0,
    "CMYK_Y": 0.4218179,
    "CMYK_K": 0.6029518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06320",
    "Farbtonhilfsbezeichnung": "K1.44.23",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "83",
    "Bcolor": "48",
    "Y": 7,
    "L": 32.1432055352496,
    "a": -20.2595321807741,
    "b": 16.9144404621085,
    "C": 26.3921757407387,
    "h": -0.6956550877726,
    "CMY_C": 0.802966,
    "CMY_M": 0.6727763,
    "CMY_Y": 0.8132715,
    "CMYK_C": 0.3978614,
    "CMYK_M": 0,
    "CMYK_Y": 0.4293553,
    "CMYK_K": 0.6727763
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06321",
    "Farbtonhilfsbezeichnung": "K1.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "95",
    "Bcolor": "74",
    "Y": 10,
    "L": 38.3613591705387,
    "a": -10.9902460037504,
    "b": 9.53661118685382,
    "C": 14.5510295220708,
    "h": -0.71469994957071,
    "CMY_C": 0.6951657,
    "CMY_M": 0.6273228,
    "CMY_Y": 0.7101531,
    "CMYK_C": 0.1820421,
    "CMYK_M": 0,
    "CMYK_Y": 0.2222576,
    "CMYK_K": 0.6273228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06322",
    "Farbtonhilfsbezeichnung": "J7.12.28",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "88",
    "Bcolor": "76",
    "Y": 9,
    "L": 36.4056083835411,
    "a": -5.8730970134116,
    "b": 5.2364608871699,
    "C": 7.8685317024083,
    "h": -0.72815550620441,
    "CMY_C": 0.6890352,
    "CMY_M": 0.6539916,
    "CMY_Y": 0.7002397,
    "CMYK_C": 0.1012796,
    "CMYK_M": 0,
    "CMYK_Y": 0.1336619,
    "CMYK_K": 0.6539916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06323",
    "Farbtonhilfsbezeichnung": "J8.17.16",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "66",
    "Bcolor": "55",
    "Y": 5,
    "L": 26.9239967552479,
    "a": -5.92348602189055,
    "b": 5.24791206715352,
    "C": 7.91380235513297,
    "h": -0.72499818337099,
    "CMY_C": 0.7746322,
    "CMY_M": 0.7408106,
    "CMY_Y": 0.784389,
    "CMYK_C": 0.1304899,
    "CMYK_M": 0,
    "CMYK_Y": 0.1681336,
    "CMYK_K": 0.7408106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06324",
    "Farbtonhilfsbezeichnung": "K0.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "74",
    "Bcolor": "67",
    "Y": 7,
    "L": 30.8492867845119,
    "a": -3.89961412387141,
    "b": 2.92018749314772,
    "C": 4.87180513877903,
    "h": -0.64275836969878,
    "CMY_C": 0.7327085,
    "CMY_M": 0.7084651,
    "CMY_Y": 0.7358027,
    "CMYK_C": 0.08315774,
    "CMYK_M": 0,
    "CMYK_Y": 0.09377106,
    "CMYK_K": 0.7084651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06325",
    "Farbtonhilfsbezeichnung": "KN.02.18",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "69",
    "Bcolor": "67",
    "Y": 6,
    "L": 28.8192981624767,
    "a": -1.10734398465487,
    "b": -0.11594989398598,
    "C": 1.11339798736421,
    "h": 0.10432972684055,
    "CMY_C": 0.7410772,
    "CMY_M": 0.7312882,
    "CMY_Y": 0.735343,
    "CMYK_C": 0.03642946,
    "CMYK_M": 0,
    "CMYK_Y": 0.01508966,
    "CMYK_K": 0.7312882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06326",
    "Farbtonhilfsbezeichnung": "J9.60.41",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "133",
    "Bcolor": "55",
    "Y": 18,
    "L": 49.9333246815243,
    "a": -37.171840368103,
    "b": 34.7521148041989,
    "C": 50.886689808986,
    "h": -0.75176801523085,
    "CMY_C": 0.7391177,
    "CMY_M": 0.4765292,
    "CMY_Y": 0.7831125,
    "CMYK_C": 0.5016297,
    "CMYK_M": 0,
    "CMYK_Y": 0.5856742,
    "CMYK_K": 0.4765292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06327",
    "Farbtonhilfsbezeichnung": "K1.50.41",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "129",
    "Bcolor": "68",
    "Y": 17,
    "L": 48.7461400379116,
    "a": -31.6046447535057,
    "b": 26.9502623788285,
    "C": 41.5351683791338,
    "h": -0.70607745292514,
    "CMY_C": 0.7180544,
    "CMY_M": 0.4955595,
    "CMY_Y": 0.7351587,
    "CMYK_C": 0.4410726,
    "CMYK_M": 0,
    "CMYK_Y": 0.4749801,
    "CMYK_K": 0.4955595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06328",
    "Farbtonhilfsbezeichnung": "J7.43.35",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "109",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.5166621641001,
    "a": -21.8803747208731,
    "b": 23.4314506258363,
    "C": 32.0590654317437,
    "h": -0.81961595275137,
    "CMY_C": 0.7025182,
    "CMY_M": 0.5717167,
    "CMY_Y": 0.7655637,
    "CMYK_C": 0.305409,
    "CMYK_M": 0,
    "CMYK_Y": 0.452614,
    "CMYK_K": 0.5717167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06329",
    "Farbtonhilfsbezeichnung": "K0.43.35",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "113",
    "Bcolor": "66",
    "Y": 13,
    "L": 43.4134363387356,
    "a": -25.5288348492086,
    "b": 21.0648652525907,
    "C": 33.0975823417356,
    "h": -0.68988339879987,
    "CMY_C": 0.7313058,
    "CMY_M": 0.5570778,
    "CMY_Y": 0.7419551,
    "CMYK_C": 0.3933603,
    "CMYK_M": 0,
    "CMYK_Y": 0.4174035,
    "CMYK_K": 0.5570778
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06330",
    "Farbtonhilfsbezeichnung": "K1.30.31",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "106",
    "Bcolor": "77",
    "Y": 12.5789909362793,
    "L": 42.1219177246094,
    "a": -14.7718887329102,
    "b": 12.675630569458,
    "C": 19.4648475646973,
    "h": 139.367385864258,
    "CMY_C": 0.67941230535507,
    "CMY_M": 0.58531212806702,
    "CMY_Y": 0.69653558731079,
    "CMYK_C": 0.22691808640957,
    "CMYK_M": 0,
    "CMYK_Y": 0.26821005344391,
    "CMYK_K": 0.58531212806702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06331",
    "Farbtonhilfsbezeichnung": "K0.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "92",
    "Bcolor": "82",
    "Y": 10,
    "L": 37.9590564921021,
    "a": -5.37618596181541,
    "b": 4.07937866904718,
    "C": 6.74868178398554,
    "h": -0.64910095138041,
    "CMY_C": 0.6745182,
    "CMY_M": 0.6400353,
    "CMY_Y": 0.6787352,
    "CMYK_C": 0.09579526,
    "CMYK_M": 0,
    "CMYK_Y": 0.1075102,
    "CMYK_K": 0.6400353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06332",
    "Farbtonhilfsbezeichnung": "J6.11.37",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "109",
    "Bcolor": "95",
    "Y": 14,
    "L": 44.9189623014557,
    "a": -5.56002941317557,
    "b": 6.05128722518068,
    "C": 8.21778584273236,
    "h": -0.82768148255409,
    "CMY_C": 0.6043652,
    "CMY_M": 0.5733749,
    "CMY_Y": 0.6263977,
    "CMYK_C": 0.07264046,
    "CMYK_M": 0,
    "CMYK_Y": 0.1242842,
    "CMYK_K": 0.5733749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06333",
    "Farbtonhilfsbezeichnung": "J9.05.24",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "74",
    "Bcolor": "69",
    "Y": 7,
    "L": 30.9146019234235,
    "a": -2.97792638899094,
    "b": 1.84972709328266,
    "C": 3.50564343564381,
    "h": -0.55582310484833,
    "CMY_C": 0.7290018,
    "CMY_M": 0.7093183,
    "CMY_Y": 0.7286485,
    "CMYK_C": 0.06771496,
    "CMYK_M": 0,
    "CMYK_Y": 0.0664994,
    "CMYK_K": 0.7093183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06334",
    "Farbtonhilfsbezeichnung": "K1.61.41",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "133",
    "Bcolor": "56",
    "Y": 18,
    "L": 49.6006797660779,
    "a": -39.3981408963038,
    "b": 34.1696649982992,
    "C": 52.1515053683113,
    "h": -0.71444729756715,
    "CMY_C": 0.769665,
    "CMY_M": 0.4768695,
    "CMY_Y": 0.7822084,
    "CMYK_C": 0.5596988,
    "CMYK_M": 0,
    "CMYK_Y": 0.5836764,
    "CMYK_K": 0.4768695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06335",
    "Farbtonhilfsbezeichnung": "K1.49.42",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "131",
    "Bcolor": "68",
    "Y": 18,
    "L": 49.6355174792979,
    "a": -32.0208841663308,
    "b": 27.6103500146351,
    "C": 42.2808284063148,
    "h": -0.71156910793838,
    "CMY_C": 0.7111789,
    "CMY_M": 0.4860003,
    "CMY_Y": 0.7317299,
    "CMYK_C": 0.438091,
    "CMYK_M": 0,
    "CMYK_Y": 0.4780734,
    "CMYK_K": 0.4860003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06336",
    "Farbtonhilfsbezeichnung": "K0.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "124",
    "Bcolor": "74",
    "Y": 17,
    "L": 47.9960758870481,
    "a": -25.2837110860005,
    "b": 22.6227272204989,
    "C": 33.9271842800643,
    "h": -0.72990974943594,
    "CMY_C": 0.6802643,
    "CMY_M": 0.5119777,
    "CMY_Y": 0.710657,
    "CMYK_C": 0.3448339,
    "CMYK_M": 0,
    "CMYK_Y": 0.4071112,
    "CMYK_K": 0.5119777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06337",
    "Farbtonhilfsbezeichnung": "K1.34.41",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "126",
    "Bcolor": "82",
    "Y": 18,
    "L": 48.9070486523764,
    "a": -22.6828037054471,
    "b": 19.128256437024,
    "C": 29.6715314444738,
    "h": -0.70058757162831,
    "CMY_C": 0.6594491,
    "CMY_M": 0.5063829,
    "CMY_Y": 0.6778802,
    "CMYK_C": 0.3100909,
    "CMYK_M": 0,
    "CMYK_Y": 0.3474297,
    "CMYK_K": 0.5063829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06338",
    "Farbtonhilfsbezeichnung": "K0.21.39",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "121",
    "Bcolor": "93",
    "Y": 17,
    "L": 48.3433023680767,
    "a": -13.0828495788232,
    "b": 11.9150788832617,
    "C": 17.6954812846801,
    "h": -0.73871740155377,
    "CMY_C": 0.6094954,
    "CMY_M": 0.5269887,
    "CMY_Y": 0.6334237,
    "CMYK_C": 0.1744287,
    "CMYK_M": 0,
    "CMYK_Y": 0.2250158,
    "CMYK_K": 0.5269887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06339",
    "Farbtonhilfsbezeichnung": "J6.08.46",
    "Farbtonklasse": "02",
    "Rcolor": "122",
    "Gcolor": "129",
    "Bcolor": "116",
    "Y": 21,
    "L": 53.1773403753882,
    "a": -5.16523466127472,
    "b": 5.75935480841911,
    "C": 7.73626634206024,
    "h": -0.83972839377084,
    "CMY_C": 0.5216956,
    "CMY_M": 0.4924628,
    "CMY_Y": 0.545007,
    "CMYK_C": 0.05759748,
    "CMYK_M": 0,
    "CMYK_Y": 0.1035278,
    "CMYK_K": 0.4924628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06340",
    "Farbtonhilfsbezeichnung": "J8.64.44",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "144",
    "Bcolor": "55",
    "Y": 22,
    "L": 53.5747536828193,
    "a": -39.5879667832562,
    "b": 39.1778739473052,
    "C": 55.6966149874759,
    "h": -0.78019172966062,
    "CMY_C": 0.7137929,
    "CMY_M": 0.4360793,
    "CMY_Y": 0.7844316,
    "CMYK_C": 0.4924693,
    "CMYK_M": 0,
    "CMYK_Y": 0.6177328,
    "CMYK_K": 0.4360793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06341",
    "Farbtonhilfsbezeichnung": "K1.37.47",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "140",
    "Bcolor": "85",
    "Y": 22,
    "L": 53.5677312428952,
    "a": -26.9516301882871,
    "b": 23.4898474403788,
    "C": 35.7514097984744,
    "h": -0.71687592375273,
    "CMY_C": 0.6376133,
    "CMY_M": 0.4529309,
    "CMY_Y": 0.6649501,
    "CMYK_C": 0.3375852,
    "CMYK_M": 0,
    "CMYK_Y": 0.3875549,
    "CMYK_K": 0.4529309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06342",
    "Farbtonhilfsbezeichnung": "K1.30.52",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "149",
    "Bcolor": "103",
    "Y": 26,
    "L": 57.9940876040769,
    "a": -22.341279459683,
    "b": 19.8018197088781,
    "C": 29.8537239164324,
    "h": -0.72521291688356,
    "CMY_C": 0.565133,
    "CMY_M": 0.414337,
    "CMY_Y": 0.5961906,
    "CMYK_C": 0.2574791,
    "CMYK_M": 0,
    "CMYK_Y": 0.3105089,
    "CMYK_K": 0.414337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06343",
    "Farbtonhilfsbezeichnung": "J6.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "149",
    "Bcolor": "134",
    "Y": 29,
    "L": 60.7392996239912,
    "a": -5.40353154775308,
    "b": 6.66287042092515,
    "C": 8.57857770458496,
    "h": -0.88938906789646,
    "CMY_C": 0.4446137,
    "CMY_M": 0.415312,
    "CMY_Y": 0.4762232,
    "CMYK_C": 0.05011513,
    "CMYK_M": 0,
    "CMYK_Y": 0.1041773,
    "CMYK_K": 0.415312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06344",
    "Farbtonhilfsbezeichnung": "K1.04.50",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "138",
    "Bcolor": "130",
    "Y": 25,
    "L": 56.8222029298442,
    "a": -3.51148743703639,
    "b": 2.84993388841166,
    "C": 4.52246251380612,
    "h": -0.68177603279932,
    "CMY_C": 0.4820407,
    "CMY_M": 0.4583617,
    "CMY_Y": 0.4892825,
    "CMYK_C": 0.04371737,
    "CMYK_M": 0,
    "CMYK_Y": 0.05708752,
    "CMYK_K": 0.4583617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06345",
    "Farbtonhilfsbezeichnung": "J7.59.55",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "171",
    "Bcolor": "67",
    "Y": 32,
    "L": 63.3430022013459,
    "a": -42.1395328441971,
    "b": 44.8489921766826,
    "C": 61.5400059115313,
    "h": -0.81653541561059,
    "CMY_C": 0.620745,
    "CMY_M": 0.3300024,
    "CMY_Y": 0.7367885,
    "CMYK_C": 0.4339458,
    "CMYK_M": 0,
    "CMYK_Y": 0.6071455,
    "CMYK_K": 0.3300024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06346",
    "Farbtonhilfsbezeichnung": "J9.55.47",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "151",
    "Bcolor": "67",
    "Y": 24,
    "L": 56.3317788726554,
    "a": -37.9389215504054,
    "b": 36.8229258506555,
    "C": 52.8704987361637,
    "h": -0.77047192951163,
    "CMY_C": 0.6742857,
    "CMY_M": 0.4094293,
    "CMY_Y": 0.7388358,
    "CMYK_C": 0.4484754,
    "CMYK_M": 0,
    "CMYK_Y": 0.5577766,
    "CMYK_K": 0.4094293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06347",
    "Farbtonhilfsbezeichnung": "K0.36.55",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "164",
    "Bcolor": "102",
    "Y": 31,
    "L": 62.7152084075857,
    "a": -28.7019373375364,
    "b": 26.6146306195861,
    "C": 39.1425570184789,
    "h": -0.74768221364093,
    "CMY_C": 0.5517322,
    "CMY_M": 0.3553578,
    "CMY_Y": 0.5997693,
    "CMYK_C": 0.3046254,
    "CMYK_M": 0,
    "CMYK_Y": 0.3791429,
    "CMYK_K": 0.3553578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06348",
    "Farbtonhilfsbezeichnung": "K0.21.54",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "143",
    "Bcolor": "111",
    "Y": 25,
    "L": 56.7782251835544,
    "a": -15.2109517931395,
    "b": 13.8828307209238,
    "C": 20.5938350794367,
    "h": -0.73978018057715,
    "CMY_C": 0.5373524,
    "CMY_M": 0.4384127,
    "CMY_Y": 0.5660769,
    "CMYK_C": 0.1761787,
    "CMYK_M": 0,
    "CMYK_Y": 0.2273275,
    "CMYK_K": 0.4384127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06349",
    "Farbtonhilfsbezeichnung": "K0.14.58",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "164",
    "Bcolor": "137",
    "Y": 34,
    "L": 65.1252328576632,
    "a": -11.4243814774778,
    "b": 10.8079511446612,
    "C": 15.7266747943843,
    "h": -0.75767851511843,
    "CMY_C": 0.4327292,
    "CMY_M": 0.3584974,
    "CMY_Y": 0.4615552,
    "CMYK_C": 0.1157156,
    "CMYK_M": 0,
    "CMYK_Y": 0.1606506,
    "CMYK_K": 0.3584974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06350",
    "Farbtonhilfsbezeichnung": "K0.07.61",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "170",
    "Bcolor": "155",
    "Y": 39,
    "L": 68.4644125218465,
    "a": -6.86034127428109,
    "b": 5.69273038718581,
    "C": 8.91467675582202,
    "h": -0.69265106072697,
    "CMY_C": 0.3789918,
    "CMY_M": 0.3315084,
    "CMY_Y": 0.3911316,
    "CMYK_C": 0.07103061,
    "CMYK_M": 0,
    "CMYK_Y": 0.08919068,
    "CMYK_K": 0.3315084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06351",
    "Farbtonhilfsbezeichnung": "J6.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "175",
    "Bcolor": "156",
    "Y": 41,
    "L": 70.1523916182866,
    "a": -6.45557731577834,
    "b": 7.77478658781461,
    "C": 10.1055323939936,
    "h": -0.87783779133484,
    "CMY_C": 0.3516828,
    "CMY_M": 0.3150128,
    "CMY_Y": 0.3882886,
    "CMYK_C": 0.05353377,
    "CMYK_M": 0,
    "CMYK_Y": 0.1069739,
    "CMYK_K": 0.3150128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06352",
    "Farbtonhilfsbezeichnung": "K1.27.60",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "174",
    "Bcolor": "124",
    "Y": 37,
    "L": 67.1646982567206,
    "a": -23.5385401047646,
    "b": 20.6469629371708,
    "C": 31.3107002283966,
    "h": -0.72004958304497,
    "CMY_C": 0.4796527,
    "CMY_M": 0.3160977,
    "CMY_Y": 0.5122731,
    "CMYK_C": 0.2391496,
    "CMYK_M": 0,
    "CMYK_Y": 0.2868471,
    "CMYK_K": 0.3160977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06353",
    "Farbtonhilfsbezeichnung": "K2.45.64",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "191",
    "Bcolor": "107",
    "Y": 42,
    "L": 70.7704362497514,
    "a": -41.665609169569,
    "b": 34.2062916683962,
    "C": 53.9081939706262,
    "h": -0.6873984756835,
    "CMY_C": 0.5683857,
    "CMY_M": 0.2491259,
    "CMY_Y": 0.5790944,
    "CMYK_C": 0.4251841,
    "CMYK_M": 0,
    "CMYK_Y": 0.4394458,
    "CMYK_K": 0.2491259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06354",
    "Farbtonhilfsbezeichnung": "K5.31.72",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "213",
    "Bcolor": "147",
    "Y": 55,
    "L": 79.1686123279872,
    "a": -35.1286748046067,
    "b": 24.8213666445689,
    "C": 43.0130681959788,
    "h": -0.61513123653383,
    "CMY_C": 0.4459493,
    "CMY_M": 0.1659994,
    "CMY_Y": 0.4228207,
    "CMYK_C": 0.335671,
    "CMYK_M": 0,
    "CMYK_Y": 0.3079389,
    "CMYK_K": 0.1659994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06355",
    "Farbtonhilfsbezeichnung": "K4.23.77",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "221",
    "Bcolor": "170",
    "Y": 63,
    "L": 83.6034721862644,
    "a": -25.9045575573001,
    "b": 19.0504447109753,
    "C": 32.1553346417885,
    "h": -0.6340972812271,
    "CMY_C": 0.3328643,
    "CMY_M": 0.1324134,
    "CMY_Y": 0.3324279,
    "CMYK_C": 0.2310444,
    "CMYK_M": 0,
    "CMYK_Y": 0.2305413,
    "CMYK_K": 0.1324134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06356",
    "Farbtonhilfsbezeichnung": "K6.12.80",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "225",
    "Bcolor": "195",
    "Y": 70,
    "L": 86.8309979083508,
    "a": -15.0459666724371,
    "b": 10.5696707608681,
    "C": 18.3874700027284,
    "h": -0.61239646988959,
    "CMY_C": 0.2333258,
    "CMY_M": 0.1163042,
    "CMY_Y": 0.2337998,
    "CMYK_C": 0.1324229,
    "CMYK_M": 0,
    "CMYK_Y": 0.1329593,
    "CMYK_K": 0.1163042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06357",
    "Farbtonhilfsbezeichnung": "K1.16.84",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "240",
    "Bcolor": "198",
    "Y": 79,
    "L": 91.3868784617004,
    "a": -18.0192645131169,
    "b": 15.9385009491428,
    "C": 24.0568016598112,
    "h": -0.7241996357512,
    "CMY_C": 0.1903883,
    "CMY_M": 0.06034612,
    "CMY_Y": 0.2250499,
    "CMYK_C": 0.1383937,
    "CMYK_M": 0,
    "CMYK_Y": 0.1752813,
    "CMYK_K": 0.06034612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06358",
    "Farbtonhilfsbezeichnung": "K2.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "234",
    "Bcolor": "213",
    "Y": 79,
    "L": 91.1384874564806,
    "a": -8.43649053507756,
    "b": 7.58969807773691,
    "C": 11.3480346077925,
    "h": -0.73260920942139,
    "CMY_C": 0.1415765,
    "CMY_M": 0.08176724,
    "CMY_Y": 0.1640436,
    "CMYK_C": 0.06513514,
    "CMYK_M": 0,
    "CMYK_Y": 0.08960297,
    "CMYK_K": 0.08176724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06359",
    "Farbtonhilfsbezeichnung": "K3.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "236",
    "Bcolor": "216",
    "Y": 80,
    "L": 91.8851798880071,
    "a": -8.42205991976214,
    "b": 7.0049452762718,
    "C": 10.9544671990757,
    "h": -0.693795888825,
    "CMY_C": 0.1351862,
    "CMY_M": 0.07327945,
    "CMY_Y": 0.1515178,
    "CMYK_C": 0.06680195,
    "CMYK_M": 0,
    "CMYK_Y": 0.08442494,
    "CMYK_K": 0.07327945
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06360",
    "Farbtonhilfsbezeichnung": "K6.42.64",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "191",
    "Bcolor": "119",
    "Y": 41,
    "L": 70.3852504914923,
    "a": -42.3715587444304,
    "b": 27.4418554422688,
    "C": 50.4817236289243,
    "h": -0.57472001887825,
    "CMY_C": 0.6065376,
    "CMY_M": 0.2512164,
    "CMY_Y": 0.5324711,
    "CMYK_C": 0.4745313,
    "CMYK_M": 0,
    "CMYK_Y": 0.3756154,
    "CMYK_K": 0.2512164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06361",
    "Farbtonhilfsbezeichnung": "K3.25.75",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "216",
    "Bcolor": "160",
    "Y": 60,
    "L": 81.8376110184839,
    "a": -26.4683981150536,
    "b": 22.0916794680723,
    "C": 34.4763455211979,
    "h": -0.69551105864509,
    "CMY_C": 0.3464541,
    "CMY_M": 0.1515605,
    "CMY_Y": 0.3735324,
    "CMYK_C": 0.2297083,
    "CMYK_M": 0,
    "CMYK_Y": 0.2616238,
    "CMYK_K": 0.1515605
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06362",
    "Farbtonhilfsbezeichnung": "K5.18.79",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "223",
    "Bcolor": "183",
    "Y": 66,
    "L": 85.218946588607,
    "a": -20.2996376764831,
    "b": 14.5101572888073,
    "C": 24.9523536834188,
    "h": -0.62058917026336,
    "CMY_C": 0.2819493,
    "CMY_M": 0.1244048,
    "CMY_Y": 0.2809149,
    "CMYK_C": 0.1799285,
    "CMYK_M": 0,
    "CMYK_Y": 0.1787471,
    "CMYK_K": 0.1244048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06363",
    "Farbtonhilfsbezeichnung": "K5.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "232",
    "Bcolor": "201",
    "Y": 75,
    "L": 89.1855320409692,
    "a": -14.6624081234999,
    "b": 10.9210288511226,
    "C": 18.2826443149543,
    "h": -0.64018529171324,
    "CMY_C": 0.2032096,
    "CMY_M": 0.0909245,
    "CMY_Y": 0.2109341,
    "CMYK_C": 0.1235157,
    "CMYK_M": 0,
    "CMYK_Y": 0.1320128,
    "CMYK_K": 0.0909245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06364",
    "Farbtonhilfsbezeichnung": "K5.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "227",
    "Bcolor": "204",
    "Y": 73,
    "L": 88.2625268698101,
    "a": -9.55682317934292,
    "b": 8.39520537196277,
    "C": 12.7205480431725,
    "h": -0.72078147417341,
    "CMY_C": 0.1796641,
    "CMY_M": 0.1116006,
    "CMY_Y": 0.2014853,
    "CMYK_C": 0.07661369,
    "CMYK_M": 0,
    "CMYK_Y": 0.1011761,
    "CMYK_K": 0.1116006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06365",
    "Farbtonhilfsbezeichnung": "K7.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "237",
    "Bcolor": "221",
    "Y": 82,
    "L": 92.3675318544201,
    "a": -7.46932476784518,
    "b": 5.23188169618847,
    "C": 9.11939683150466,
    "h": -0.61102729986234,
    "CMY_C": 0.128157,
    "CMY_M": 0.06953802,
    "CMY_Y": 0.1328841,
    "CMYK_C": 0.06299985,
    "CMYK_M": 0,
    "CMYK_Y": 0.06808021,
    "CMYK_K": 0.06953802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06366",
    "Farbtonhilfsbezeichnung": "K5.43.63",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "190",
    "Bcolor": "115",
    "Y": 41,
    "L": 70.167472080735,
    "a": -43.0091825616016,
    "b": 29.6234499558658,
    "C": 52.2239271972614,
    "h": -0.60314946319681,
    "CMY_C": 0.6071084,
    "CMY_M": 0.2529529,
    "CMY_Y": 0.5509105,
    "CMYK_C": 0.4740738,
    "CMYK_M": 0,
    "CMYK_Y": 0.3988472,
    "CMYK_K": 0.2529529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06367",
    "Farbtonhilfsbezeichnung": "K5.39.67",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "201",
    "Bcolor": "127",
    "Y": 47,
    "L": 74.3895988858752,
    "a": -40.7310021274528,
    "b": 28.6833240081226,
    "C": 49.8171417331575,
    "h": -0.61354826264899,
    "CMY_C": 0.5399143,
    "CMY_M": 0.2100887,
    "CMY_Y": 0.5011955,
    "CMYK_C": 0.4175476,
    "CMYK_M": 0,
    "CMYK_Y": 0.368531,
    "CMYK_K": 0.2100887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06368",
    "Farbtonhilfsbezeichnung": "K3.29.72",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "210",
    "Bcolor": "146",
    "Y": 55,
    "L": 79.0341741452715,
    "a": -30.4544848953569,
    "b": 25.3888820893542,
    "C": 39.6493503602348,
    "h": -0.69493483317392,
    "CMY_C": 0.4011966,
    "CMY_M": 0.175844,
    "CMY_Y": 0.4276551,
    "CMYK_C": 0.2734344,
    "CMYK_M": 0,
    "CMYK_Y": 0.3055381,
    "CMYK_K": 0.175844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06369",
    "Farbtonhilfsbezeichnung": "K6.21.77",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "221",
    "Bcolor": "175",
    "Y": 64,
    "L": 83.7896271265697,
    "a": -24.3215243632064,
    "b": 17.0262910444642,
    "C": 29.6889059091245,
    "h": -0.61075973902077,
    "CMY_C": 0.3238313,
    "CMY_M": 0.132951,
    "CMY_Y": 0.3152561,
    "CMYK_C": 0.2201494,
    "CMYK_M": 0,
    "CMYK_Y": 0.2102593,
    "CMYK_K": 0.132951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06370",
    "Farbtonhilfsbezeichnung": "K3.15.82",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "233",
    "Bcolor": "194",
    "Y": 74,
    "L": 89.0155416285978,
    "a": -17.7126370883843,
    "b": 14.5336172736561,
    "C": 22.9120829188863,
    "h": -0.6871299952664,
    "CMY_C": 0.2184881,
    "CMY_M": 0.08729529,
    "CMY_Y": 0.2400695,
    "CMYK_C": 0.1437407,
    "CMYK_M": 0,
    "CMYK_Y": 0.1673862,
    "CMYK_K": 0.08729529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06371",
    "Farbtonhilfsbezeichnung": "K6.08.81",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "227",
    "Bcolor": "205",
    "Y": 72,
    "L": 88.0948034713183,
    "a": -11.0170993231122,
    "b": 7.48988024245671,
    "C": 13.3219662040429,
    "h": -0.59706819914663,
    "CMY_C": 0.1965951,
    "CMY_M": 0.1100552,
    "CMY_Y": 0.1968281,
    "CMYK_C": 0.09724186,
    "CMYK_M": 0,
    "CMYK_Y": 0.09750371,
    "CMYK_K": 0.1100552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06372",
    "Farbtonhilfsbezeichnung": "K5.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "233",
    "Bcolor": "214",
    "Y": 78,
    "L": 90.680188376222,
    "a": -9.30509982749439,
    "b": 6.48924244099132,
    "C": 11.3443884920078,
    "h": -0.6089691641678,
    "CMY_C": 0.1575384,
    "CMY_M": 0.08468285,
    "CMY_Y": 0.161007,
    "CMYK_C": 0.07959599,
    "CMYK_M": 0,
    "CMYK_Y": 0.08338546,
    "CMYK_K": 0.08468285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06373",
    "Farbtonhilfsbezeichnung": "K7.51.55",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "170",
    "Bcolor": "93",
    "Y": 31,
    "L": 62.0882526647903,
    "a": -46.7756411807666,
    "b": 30.3102363667801,
    "C": 55.7375191095003,
    "h": -0.5749622518706,
    "CMY_C": 0.7437192,
    "CMY_M": 0.335065,
    "CMY_Y": 0.6359877,
    "CMYK_C": 0.6145776,
    "CMYK_M": 0,
    "CMYK_Y": 0.4525596,
    "CMYK_K": 0.335065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06374",
    "Farbtonhilfsbezeichnung": "K6.45.56",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "171",
    "Bcolor": "105",
    "Y": 32,
    "L": 63.3292828663927,
    "a": -40.4041740659138,
    "b": 25.7438506244998,
    "C": 47.908695733919,
    "h": -0.56729455290888,
    "CMY_C": 0.6669686,
    "CMY_M": 0.3302683,
    "CMY_Y": 0.5894345,
    "CMYK_C": 0.5027391,
    "CMYK_M": 0,
    "CMYK_Y": 0.3869702,
    "CMYK_K": 0.3302683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06375",
    "Farbtonhilfsbezeichnung": "K2.40.63",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "188",
    "Bcolor": "112",
    "Y": 41,
    "L": 70.3341891486213,
    "a": -35.9467168360542,
    "b": 31.5853673115311,
    "C": 47.8518743571847,
    "h": -0.72090583741903,
    "CMY_C": 0.5242027,
    "CMY_M": 0.2626281,
    "CMY_Y": 0.5626364,
    "CMYK_C": 0.354739,
    "CMYK_M": 0,
    "CMYK_Y": 0.4068616,
    "CMYK_K": 0.2626281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06376",
    "Farbtonhilfsbezeichnung": "K5.23.75",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "219",
    "Bcolor": "167",
    "Y": 62,
    "L": 82.7695378035062,
    "a": -26.5962310058377,
    "b": 19.3301106532735,
    "C": 32.8787572998689,
    "h": -0.62848628857531,
    "CMY_C": 0.3470428,
    "CMY_M": 0.140429,
    "CMY_Y": 0.3433679,
    "CMYK_C": 0.2403685,
    "CMYK_M": 0,
    "CMYK_Y": 0.2360932,
    "CMYK_K": 0.140429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06377",
    "Farbtonhilfsbezeichnung": "K5.12.76",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "214",
    "Bcolor": "186",
    "Y": 62,
    "L": 82.9686219134253,
    "a": -13.8877476047507,
    "b": 10.1021132890622,
    "C": 17.1732998121592,
    "h": -0.62888732652035,
    "CMY_C": 0.267023,
    "CMY_M": 0.1613834,
    "CMY_Y": 0.2715718,
    "CMYK_C": 0.1259688,
    "CMYK_M": 0,
    "CMYK_Y": 0.1313931,
    "CMYK_K": 0.1613834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06378",
    "Farbtonhilfsbezeichnung": "K3.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "218",
    "Bcolor": "200",
    "Y": 67,
    "L": 85.4426205675426,
    "a": -7.80964477312529,
    "b": 6.04880726124735,
    "C": 9.87818914407503,
    "h": -0.65901661392153,
    "CMY_C": 0.2042633,
    "CMY_M": 0.1461082,
    "CMY_Y": 0.214491,
    "CMYK_C": 0.06810583,
    "CMYK_M": 0,
    "CMYK_Y": 0.08008362,
    "CMYK_K": 0.1461082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06379",
    "Farbtonhilfsbezeichnung": "K3.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "222",
    "Bcolor": "212",
    "Y": 71,
    "L": 87.6823255531319,
    "a": -3.66235211139815,
    "b": 3.28572663855131,
    "C": 4.92024618603055,
    "h": -0.73124546002792,
    "CMY_C": 0.155844,
    "CMY_M": 0.1299134,
    "CMY_Y": 0.1693001,
    "CMYK_C": 0.02980237,
    "CMYK_M": 0,
    "CMYK_Y": 0.0452676,
    "CMYK_K": 0.1299134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06380",
    "Farbtonhilfsbezeichnung": "K2.54.53",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "160",
    "Bcolor": "74",
    "Y": 27,
    "L": 59.3191351287642,
    "a": -42.0863805002971,
    "b": 36.6258651503762,
    "C": 55.7917325562608,
    "h": -0.71613599591848,
    "CMY_C": 0.6875958,
    "CMY_M": 0.3720116,
    "CMY_Y": 0.7095659,
    "CMYK_C": 0.5025318,
    "CMYK_M": 0,
    "CMYK_Y": 0.5375167,
    "CMYK_K": 0.3720116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06381",
    "Farbtonhilfsbezeichnung": "K7.41.61",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "187",
    "Bcolor": "118",
    "Y": 39,
    "L": 68.9761172820079,
    "a": -41.157799151598,
    "b": 25.9926392685816,
    "C": 48.6783496757017,
    "h": -0.56328568884838,
    "CMY_C": 0.6139116,
    "CMY_M": 0.2682181,
    "CMY_Y": 0.5356709,
    "CMYK_C": 0.4723996,
    "CMYK_M": 0,
    "CMYK_Y": 0.3654816,
    "CMYK_K": 0.2682181
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06383",
    "Farbtonhilfsbezeichnung": "K5.13.72",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "202",
    "Bcolor": "173",
    "Y": 54,
    "L": 78.4333707735948,
    "a": -15.0955651827208,
    "b": 10.2946028187463,
    "C": 18.2716976600838,
    "h": -0.59851710963913,
    "CMY_C": 0.3249218,
    "CMY_M": 0.2086598,
    "CMY_Y": 0.3211867,
    "CMYK_C": 0.1469178,
    "CMYK_M": 0,
    "CMYK_Y": 0.1421979,
    "CMYK_K": 0.2086598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06384",
    "Farbtonhilfsbezeichnung": "K7.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "207",
    "Bcolor": "190",
    "Y": 59,
    "L": 81.4593466153536,
    "a": -8.03776384309574,
    "b": 5.71033463170385,
    "C": 9.8596941739292,
    "h": -0.6176971813199,
    "CMY_C": 0.2504434,
    "CMY_M": 0.1893086,
    "CMY_Y": 0.2548832,
    "CMYK_C": 0.07541066,
    "CMYK_M": 0,
    "CMYK_Y": 0.08088727,
    "CMYK_K": 0.1893086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06385",
    "Farbtonhilfsbezeichnung": "K5.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "195",
    "Bcolor": "187",
    "Y": 53,
    "L": 77.9839780973955,
    "a": -3.70589389370435,
    "b": 2.44192899045641,
    "C": 4.43809269234281,
    "h": -0.58262812147845,
    "CMY_C": 0.2645199,
    "CMY_M": 0.2357788,
    "CMY_Y": 0.267822,
    "CMYK_C": 0.03760841,
    "CMYK_M": 0,
    "CMYK_Y": 0.04192925,
    "CMYK_K": 0.2357788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06386",
    "Farbtonhilfsbezeichnung": "K2.62.53",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "164",
    "Bcolor": "62",
    "Y": 28,
    "L": 59.812831110732,
    "a": -49.6283232153319,
    "b": 42.8015016585118,
    "C": 65.5357841899297,
    "h": -0.71167252249274,
    "CMY_C": 0.7555026,
    "CMY_M": 0.357062,
    "CMY_Y": 0.7563629,
    "CMYK_C": 0.6197186,
    "CMYK_M": 0,
    "CMYK_Y": 0.6210565,
    "CMYK_K": 0.357062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06387",
    "Farbtonhilfsbezeichnung": "K2.51.50",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "153",
    "Bcolor": "75",
    "Y": 25,
    "L": 56.8430822099289,
    "a": -39.1799056728044,
    "b": 33.2907417694347,
    "C": 51.4134077463169,
    "h": -0.7043135872532,
    "CMY_C": 0.6928739,
    "CMY_M": 0.4018718,
    "CMY_Y": 0.7071741,
    "CMYK_C": 0.4865212,
    "CMYK_M": 0,
    "CMYK_Y": 0.5104295,
    "CMYK_K": 0.4018718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06388",
    "Farbtonhilfsbezeichnung": "K1.41.61",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "179",
    "Bcolor": "105",
    "Y": 37,
    "L": 67.3377405330236,
    "a": -34.8756209918092,
    "b": 31.3081006873165,
    "C": 46.8668977873666,
    "h": -0.73154698965006,
    "CMY_C": 0.5462503,
    "CMY_M": 0.2966899,
    "CMY_Y": 0.5900135,
    "CMYK_C": 0.354837,
    "CMYK_M": 0,
    "CMYK_Y": 0.4170616,
    "CMYK_K": 0.2966899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06389",
    "Farbtonhilfsbezeichnung": "K7.27.59",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "175",
    "Bcolor": "129",
    "Y": 36,
    "L": 66.6962408821214,
    "a": -26.7486366735584,
    "b": 17.230872780847,
    "C": 31.8181165483403,
    "h": -0.57227125480925,
    "CMY_C": 0.5242917,
    "CMY_M": 0.3148029,
    "CMY_Y": 0.4931255,
    "CMYK_C": 0.3057351,
    "CMYK_M": 0,
    "CMYK_Y": 0.2602501,
    "CMYK_K": 0.3148029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06390",
    "Farbtonhilfsbezeichnung": "K7.24.70",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "202",
    "Bcolor": "154",
    "Y": 51,
    "L": 76.6570255169761,
    "a": -26.6248135062518,
    "b": 17.7455384652283,
    "C": 31.9966377868611,
    "h": -0.58788981753445,
    "CMY_C": 0.4178228,
    "CMY_M": 0.2074576,
    "CMY_Y": 0.3954122,
    "CMYK_C": 0.2654308,
    "CMYK_M": 0,
    "CMYK_Y": 0.237154,
    "CMYK_K": 0.2074576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06391",
    "Farbtonhilfsbezeichnung": "K6.18.72",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "206",
    "Bcolor": "167",
    "Y": 55,
    "L": 79.0177383422852,
    "a": -20.6272411346436,
    "b": 14.4810066223145,
    "C": 25.2028293609619,
    "h": 144.929885864258,
    "CMY_C": 0.35120320320129,
    "CMY_M": 0.19221776723862,
    "CMY_Y": 0.34621745347977,
    "CMYK_C": 0.19681720435619,
    "CMYK_M": 0,
    "CMYK_Y": 0.19064505398273,
    "CMYK_K": 0.19221776723862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06392",
    "Farbtonhilfsbezeichnung": "K5.13.67",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "189",
    "Bcolor": "164",
    "Y": 47,
    "L": 74.1531559890933,
    "a": -13.5362194169469,
    "b": 9.26090980861367,
    "C": 16.4010269979355,
    "h": -0.6000142844416,
    "CMY_C": 0.3607808,
    "CMY_M": 0.2579651,
    "CMY_Y": 0.3583493,
    "CMYK_C": 0.138559,
    "CMYK_M": 0,
    "CMYK_Y": 0.1352822,
    "CMYK_K": 0.2579651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06393",
    "Farbtonhilfsbezeichnung": "K6.06.70",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "195",
    "Bcolor": "180",
    "Y": 52,
    "L": 77.3981437873721,
    "a": -7.42420891923623,
    "b": 5.08645908380192,
    "C": 8.99949687969599,
    "h": -0.60066805389358,
    "CMY_C": 0.2912129,
    "CMY_M": 0.2346651,
    "CMY_Y": 0.2935322,
    "CMYK_C": 0.07388643,
    "CMYK_M": 0,
    "CMYK_Y": 0.07691685,
    "CMYK_K": 0.2346651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06394",
    "Farbtonhilfsbezeichnung": "K4.50.45",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "139",
    "Bcolor": "74",
    "Y": 20,
    "L": 51.9297386385569,
    "a": -37.0208911944559,
    "b": 27.1710935119324,
    "C": 45.9218325795685,
    "h": -0.63314288948188,
    "CMY_C": 0.7424818,
    "CMY_M": 0.4553012,
    "CMY_Y": 0.7081221,
    "CMYK_C": 0.5272282,
    "CMYK_M": 0,
    "CMYK_Y": 0.464148,
    "CMYK_K": 0.4553012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06395",
    "Farbtonhilfsbezeichnung": "K2.46.53",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "162",
    "Bcolor": "90",
    "Y": 29,
    "L": 60.609682790091,
    "a": -35.8961023865493,
    "b": 30.1223743792372,
    "C": 46.8602988124122,
    "h": -0.69816387423002,
    "CMY_C": 0.6297733,
    "CMY_M": 0.3666479,
    "CMY_Y": 0.646965,
    "CMYK_C": 0.4154488,
    "CMYK_M": 0,
    "CMYK_Y": 0.4425928,
    "CMYK_K": 0.3666479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06396",
    "Farbtonhilfsbezeichnung": "K2.31.59",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "174",
    "Bcolor": "118",
    "Y": 36,
    "L": 66.5488421799561,
    "a": -27.0631977963621,
    "b": 23.0011150275125,
    "C": 35.5171503287338,
    "h": -0.7044382206917,
    "CMY_C": 0.5090988,
    "CMY_M": 0.3168755,
    "CMY_Y": 0.5358252,
    "CMYK_C": 0.2813884,
    "CMYK_M": 0,
    "CMYK_Y": 0.3205122,
    "CMYK_K": 0.3168755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06397",
    "Farbtonhilfsbezeichnung": "K5.21.64",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "185",
    "Bcolor": "146",
    "Y": 43,
    "L": 71.2662093849079,
    "a": -21.1265068561927,
    "b": 14.7916051748009,
    "C": 25.7899374871664,
    "h": -0.61082286128771,
    "CMY_C": 0.4357778,
    "CMY_M": 0.2754969,
    "CMY_Y": 0.4287007,
    "CMYK_C": 0.2212287,
    "CMYK_M": 0,
    "CMYK_Y": 0.2114606,
    "CMYK_K": 0.2754969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06398",
    "Farbtonhilfsbezeichnung": "K2.16.63",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "179",
    "Bcolor": "148",
    "Y": 41,
    "L": 70.1574403860894,
    "a": -14.8788757360732,
    "b": 12.1474379392717,
    "C": 19.2078419313041,
    "h": -0.6846743097682,
    "CMY_C": 0.4039224,
    "CMY_M": 0.2987666,
    "CMY_Y": 0.4203234,
    "CMYK_C": 0.1499584,
    "CMYK_M": 0,
    "CMYK_Y": 0.1733472,
    "CMYK_K": 0.2987666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06399",
    "Farbtonhilfsbezeichnung": "K6.08.61",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "170",
    "Bcolor": "155",
    "Y": 38,
    "L": 68.0231793699024,
    "a": -7.75661038355252,
    "b": 5.20337426295454,
    "C": 9.34024134391679,
    "h": -0.59088002623281,
    "CMY_C": 0.3921262,
    "CMY_M": 0.3341737,
    "CMY_Y": 0.3923752,
    "CMYK_C": 0.08703837,
    "CMYK_M": 0,
    "CMYK_Y": 0.08741239,
    "CMYK_K": 0.3341737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06400",
    "Farbtonhilfsbezeichnung": "K2.63.43",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "137",
    "Bcolor": "54",
    "Y": 19,
    "L": 50.5916809560743,
    "a": -42.5187140538062,
    "b": 36.254178096107,
    "C": 55.8767077968413,
    "h": -0.70603863944637,
    "CMY_C": 0.7906825,
    "CMY_M": 0.4627639,
    "CMY_Y": 0.7899611,
    "CMYK_C": 0.6103808,
    "CMYK_M": 0,
    "CMYK_Y": 0.6090379,
    "CMYK_K": 0.4627639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06401",
    "Farbtonhilfsbezeichnung": "K2.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "139",
    "Bcolor": "72",
    "Y": 20,
    "L": 52.2873686461321,
    "a": -35.0860255488382,
    "b": 28.7632808801958,
    "C": 45.3691030967856,
    "h": -0.68669390964028,
    "CMY_C": 0.7116495,
    "CMY_M": 0.4545588,
    "CMY_Y": 0.7159198,
    "CMYK_C": 0.4713444,
    "CMYK_M": 0,
    "CMYK_Y": 0.4791735,
    "CMYK_K": 0.4545588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06402",
    "Farbtonhilfsbezeichnung": "K2.28.53",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "157",
    "Bcolor": "112",
    "Y": 29,
    "L": 60.7976561695553,
    "a": -22.5587543937831,
    "b": 18.6009568309163,
    "C": 29.2385532272826,
    "h": -0.68953581404453,
    "CMY_C": 0.5425228,
    "CMY_M": 0.3845994,
    "CMY_Y": 0.5605748,
    "CMYK_C": 0.2566189,
    "CMYK_M": 0,
    "CMYK_Y": 0.2859526,
    "CMYK_K": 0.3845994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06404",
    "Farbtonhilfsbezeichnung": "K6.13.58",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "164",
    "Bcolor": "142",
    "Y": 34,
    "L": 65.028893047727,
    "a": -12.6725865961039,
    "b": 7.78982636303185,
    "C": 14.8753435524004,
    "h": -0.55115754164288,
    "CMY_C": 0.4533051,
    "CMY_M": 0.3563748,
    "CMY_Y": 0.4416953,
    "CMYK_C": 0.1506005,
    "CMYK_M": 0,
    "CMYK_Y": 0.1325624,
    "CMYK_K": 0.3563748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06405",
    "Farbtonhilfsbezeichnung": "K7.08.53",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "149",
    "Bcolor": "135",
    "Y": 28,
    "L": 60.0518206883941,
    "a": -7.80217428819741,
    "b": 4.54154655096652,
    "C": 9.02771115499408,
    "h": -0.52714425994274,
    "CMY_C": 0.4763062,
    "CMY_M": 0.4170012,
    "CMY_Y": 0.4689546,
    "CMYK_C": 0.101724,
    "CMYK_M": 0,
    "CMYK_Y": 0.08911403,
    "CMYK_K": 0.4170012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06406",
    "Farbtonhilfsbezeichnung": "K5.04.54",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "152",
    "Bcolor": "144",
    "Y": 30,
    "L": 61.8207642393395,
    "a": -4.37930616828119,
    "b": 2.54838653074958,
    "C": 5.06681324163932,
    "h": -0.52701599723698,
    "CMY_C": 0.4387627,
    "CMY_M": 0.4052959,
    "CMY_Y": 0.4370103,
    "CMYK_C": 0.05627477,
    "CMYK_M": 0,
    "CMYK_Y": 0.05332815,
    "CMYK_K": 0.4052959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06407",
    "Farbtonhilfsbezeichnung": "K2.57.43",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "110",
    "Bcolor": "48",
    "Y": 12,
    "L": 41.1457177931915,
    "a": -33.6601941851288,
    "b": 28.048623364027,
    "C": 43.8147685740507,
    "h": -0.69471130183674,
    "CMY_C": 0.8130469,
    "CMY_M": 0.5691308,
    "CMY_Y": 0.8126262,
    "CMYK_C": 0.5661023,
    "CMYK_M": 0,
    "CMYK_Y": 0.5651262,
    "CMYK_K": 0.5691308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06408",
    "Farbtonhilfsbezeichnung": "K4.53.40",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "128",
    "Bcolor": "64",
    "Y": 17,
    "L": 47.6377020293658,
    "a": -37.8563179691973,
    "b": 27.5591841939445,
    "C": 46.825307725852,
    "h": -0.62926808053328,
    "CMY_C": 0.7971249,
    "CMY_M": 0.4982595,
    "CMY_Y": 0.7508559,
    "CMYK_C": 0.5956573,
    "CMYK_M": 0,
    "CMYK_Y": 0.5034403,
    "CMYK_K": 0.4982595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06409",
    "Farbtonhilfsbezeichnung": "K3.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "129",
    "Bcolor": "72",
    "Y": 17,
    "L": 48.6493074636935,
    "a": -31.8426792865594,
    "b": 24.3432557521787,
    "C": 40.081795428382,
    "h": -0.6527073391601,
    "CMY_C": 0.7300114,
    "CMY_M": 0.495856,
    "CMY_Y": 0.7176801,
    "CMYK_C": 0.4644614,
    "CMYK_M": 0,
    "CMYK_Y": 0.4400014,
    "CMYK_K": 0.495856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06410",
    "Farbtonhilfsbezeichnung": "K7.39.40",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "124",
    "Bcolor": "81",
    "Y": 16,
    "L": 47.4972896115221,
    "a": -27.8653466463853,
    "b": 17.6390793553336,
    "C": 32.9790033843804,
    "h": -0.56433952008916,
    "CMY_C": 0.7255492,
    "CMY_M": 0.5123385,
    "CMY_Y": 0.6816854,
    "CMYK_C": 0.4372104,
    "CMYK_M": 0,
    "CMYK_Y": 0.3472634,
    "CMYK_K": 0.5123385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06411",
    "Farbtonhilfsbezeichnung": "K7.28.50",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "148",
    "Bcolor": "108",
    "Y": 25,
    "L": 57.0560973668535,
    "a": -25.2390678994019,
    "b": 15.3795246461309,
    "C": 29.5557156362617,
    "h": -0.54726899987755,
    "CMY_C": 0.6145129,
    "CMY_M": 0.4183939,
    "CMY_Y": 0.5750802,
    "CMYK_C": 0.3372024,
    "CMYK_M": 0,
    "CMYK_Y": 0.2694027,
    "CMYK_K": 0.4183939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06412",
    "Farbtonhilfsbezeichnung": "K7.09.45",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "128",
    "Bcolor": "116",
    "Y": 20,
    "L": 52.2044408724957,
    "a": -7.79859757810097,
    "b": 4.35670549660045,
    "C": 8.93302899185215,
    "h": -0.50946187324889,
    "CMY_C": 0.5550764,
    "CMY_M": 0.4967077,
    "CMY_Y": 0.5455278,
    "CMYK_C": 0.1159737,
    "CMYK_M": 0,
    "CMYK_Y": 0.09700145,
    "CMYK_K": 0.4967077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06413",
    "Farbtonhilfsbezeichnung": "K3.53.35",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "114",
    "Bcolor": "55",
    "Y": 13,
    "L": 42.8992744311737,
    "a": -32.9687908527634,
    "b": 26.1359159504603,
    "C": 42.0716920608475,
    "h": -0.67030281764476,
    "CMY_C": 0.7938266,
    "CMY_M": 0.5523881,
    "CMY_Y": 0.7829774,
    "CMYK_C": 0.5393926,
    "CMYK_M": 0,
    "CMYK_Y": 0.5151545,
    "CMYK_K": 0.5523881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06414",
    "Farbtonhilfsbezeichnung": "K7.52.35",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "115",
    "Bcolor": "62",
    "Y": 13,
    "L": 42.987468985792,
    "a": -34.972777609204,
    "b": 22.6522120776638,
    "C": 41.6679479422049,
    "h": -0.57476357889145,
    "CMY_C": 0.8319686,
    "CMY_M": 0.5484348,
    "CMY_Y": 0.7581753,
    "CMYK_C": 0.6278912,
    "CMYK_M": 0,
    "CMYK_Y": 0.4644744,
    "CMYK_K": 0.5484348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06415",
    "Farbtonhilfsbezeichnung": "K5.47.31",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "102",
    "Bcolor": "59",
    "Y": 11,
    "L": 38.7977395268462,
    "a": -28.0108411585452,
    "b": 18.9577178962659,
    "C": 33.8231029067951,
    "h": -0.59498474199653,
    "CMY_C": 0.8071266,
    "CMY_M": 0.5986316,
    "CMY_Y": 0.7696154,
    "CMYK_C": 0.5194604,
    "CMYK_M": 0,
    "CMYK_Y": 0.4260021,
    "CMYK_K": 0.5986316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06416",
    "Farbtonhilfsbezeichnung": "K2.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "121",
    "Bcolor": "82",
    "Y": 16,
    "L": 47.3582536388395,
    "a": -20.910007447876,
    "b": 16.8992406093885,
    "C": 26.8851770432005,
    "h": -0.6797144021026,
    "CMY_C": 0.6662362,
    "CMY_M": 0.5243863,
    "CMY_Y": 0.6769785,
    "CMYK_C": 0.2982461,
    "CMYK_M": 0,
    "CMYK_Y": 0.3208322,
    "CMYK_K": 0.5243863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06417",
    "Farbtonhilfsbezeichnung": "K2.25.33",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "106",
    "Bcolor": "81",
    "Y": 13,
    "L": 42.3349642209478,
    "a": -14.1673272775094,
    "b": 10.8414336944673,
    "C": 17.8395584793905,
    "h": -0.65318482878157,
    "CMY_C": 0.6781582,
    "CMY_M": 0.5839375,
    "CMY_Y": 0.682609,
    "CMYK_C": 0.2264581,
    "CMYK_M": 0,
    "CMYK_Y": 0.2371556,
    "CMYK_K": 0.5839375
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06418",
    "Farbtonhilfsbezeichnung": "K2.06.39",
    "Farbtonklasse": "02",
    "Rcolor": "105",
    "Gcolor": "113",
    "Bcolor": "105",
    "Y": 16,
    "L": 46.9393159123749,
    "a": -4.4966984789872,
    "b": 2.89870620783104,
    "C": 5.3500275597649,
    "h": -0.57259082512733,
    "CMY_C": 0.5866341,
    "CMY_M": 0.5550029,
    "CMY_Y": 0.5865751,
    "CMYK_C": 0.07108181,
    "CMYK_M": 0,
    "CMYK_Y": 0.07094916,
    "CMYK_K": 0.5550029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06419",
    "Farbtonhilfsbezeichnung": "K4.06.31",
    "Farbtonklasse": "02",
    "Rcolor": "86",
    "Gcolor": "94",
    "Bcolor": "87",
    "Y": 11,
    "L": 38.8752085242384,
    "a": -4.42441819103434,
    "b": 2.41616116094067,
    "C": 5.0411616800886,
    "h": -0.49984166889647,
    "CMY_C": 0.6642536,
    "CMY_M": 0.6327775,
    "CMY_Y": 0.6597158,
    "CMYK_C": 0.08571391,
    "CMYK_M": 0,
    "CMYK_Y": 0.07335708,
    "CMYK_K": 0.6327775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06420",
    "Farbtonhilfsbezeichnung": "K3.52.28",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "97",
    "Bcolor": "54",
    "Y": 9,
    "L": 36.757615128371,
    "a": -25.7506290014385,
    "b": 18.8115962226101,
    "C": 31.8899834809026,
    "h": -0.63092314683747,
    "CMY_C": 0.804179,
    "CMY_M": 0.6214973,
    "CMY_Y": 0.7863417,
    "CMYK_C": 0.4826431,
    "CMYK_M": 0,
    "CMYK_Y": 0.435517,
    "CMYK_K": 0.6214973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06421",
    "Farbtonhilfsbezeichnung": "K4.20.25",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "82",
    "Bcolor": "66",
    "Y": 8,
    "L": 33.1286733123054,
    "a": -10.6833510565635,
    "b": 7.02187355096602,
    "C": 12.7843927491114,
    "h": -0.5814707668022,
    "CMY_C": 0.7479453,
    "CMY_M": 0.6766095,
    "CMY_Y": 0.7413706,
    "CMYK_C": 0.2205874,
    "CMYK_M": 0,
    "CMYK_Y": 0.2002568,
    "CMYK_K": 0.6766095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06422",
    "Farbtonhilfsbezeichnung": "K7.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "76",
    "Bcolor": "69",
    "Y": 7,
    "L": 31.3652999082706,
    "a": -4.68352092661434,
    "b": 2.42765133981568,
    "C": 5.27530655959853,
    "h": -0.47821090502386,
    "CMY_C": 0.7347956,
    "CMY_M": 0.702242,
    "CMY_Y": 0.7283086,
    "CMYK_C": 0.1093292,
    "CMYK_M": 0,
    "CMYK_Y": 0.08754301,
    "CMYK_K": 0.702242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06423",
    "Farbtonhilfsbezeichnung": "K5.08.19",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "72",
    "Bcolor": "67",
    "Y": 6,
    "L": 29.9531736317485,
    "a": -3.04800748776221,
    "b": 1.56766697130047,
    "C": 3.42752525568535,
    "h": -0.47504195915503,
    "CMY_C": 0.7388998,
    "CMY_M": 0.7178583,
    "CMY_Y": 0.7355354,
    "CMYK_C": 0.0745779,
    "CMYK_M": 0,
    "CMYK_Y": 0.06265368,
    "CMYK_K": 0.7178583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06424",
    "Farbtonhilfsbezeichnung": "K7.05.25",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "105",
    "Bcolor": "99",
    "Y": 14,
    "L": 43.8136659397284,
    "a": -3.88176213403807,
    "b": 2.16312142731265,
    "C": 4.44377897453855,
    "h": -0.50839424739654,
    "CMY_C": 0.6145443,
    "CMY_M": 0.5864697,
    "CMY_Y": 0.611627,
    "CMYK_C": 0.06789027,
    "CMYK_M": 0,
    "CMYK_Y": 0.06083573,
    "CMYK_K": 0.5864697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06425",
    "Farbtonhilfsbezeichnung": "K4.03.27",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "83",
    "Bcolor": "81",
    "Y": 9,
    "L": 35.1071974217745,
    "a": -1.80170552070011,
    "b": 0.63124661882731,
    "C": 1.90908749854536,
    "h": -0.33699602630925,
    "CMY_C": 0.6864669,
    "CMY_M": 0.6726992,
    "CMY_Y": 0.683098,
    "CMYK_C": 0.04206428,
    "CMYK_M": 0,
    "CMYK_Y": 0.03177115,
    "CMYK_K": 0.6726992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06426",
    "Farbtonhilfsbezeichnung": "K2.40.23",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "84",
    "Bcolor": "56",
    "Y": 7,
    "L": 32.8128614856975,
    "a": -17.0575567853276,
    "b": 12.9440206930911,
    "C": 21.4127979299261,
    "h": -0.64913713648956,
    "CMY_C": 0.7821274,
    "CMY_M": 0.6705716,
    "CMY_Y": 0.7818025,
    "CMYK_C": 0.3386344,
    "CMYK_M": 0,
    "CMYK_Y": 0.3376481,
    "CMYK_K": 0.6705716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06427",
    "Farbtonhilfsbezeichnung": "K2.30.20",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "72",
    "Bcolor": "52",
    "Y": 6,
    "L": 28.2812463312789,
    "a": -12.3306062089727,
    "b": 9.00334352401028,
    "C": 15.2677452196483,
    "h": -0.63068361271297,
    "CMY_C": 0.7973258,
    "CMY_M": 0.7189143,
    "CMY_Y": 0.7960256,
    "CMYK_C": 0.2789596,
    "CMYK_M": 0,
    "CMYK_Y": 0.2743339,
    "CMYK_K": 0.7189143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06428",
    "Farbtonhilfsbezeichnung": "K2.24.16",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "67",
    "Bcolor": "55",
    "Y": 5,
    "L": 26.926557573316,
    "a": -8.36160041473069,
    "b": 5.49134373368599,
    "C": 10.00356024109,
    "h": -0.58109428601755,
    "CMY_C": 0.7905818,
    "CMY_M": 0.7367923,
    "CMY_Y": 0.7861041,
    "CMYK_C": 0.2043615,
    "CMYK_M": 0,
    "CMYK_Y": 0.1873491,
    "CMYK_K": 0.7367923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06429",
    "Farbtonhilfsbezeichnung": "K7.14.15",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "66",
    "Bcolor": "59",
    "Y": 5,
    "L": 26.847099346054,
    "a": -5.04286124352377,
    "b": 2.57878571903289,
    "C": 5.66397257286104,
    "h": -0.47270497276701,
    "CMY_C": 0.7768228,
    "CMY_M": 0.7424739,
    "CMY_Y": 0.7691388,
    "CMYK_C": 0.1333802,
    "CMYK_M": 0,
    "CMYK_Y": 0.1035426,
    "CMYK_K": 0.7424739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06430",
    "Farbtonhilfsbezeichnung": "K6.11.12",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "58",
    "Bcolor": "54",
    "Y": 4,
    "L": 23.7433165183484,
    "a": -3.71569312054021,
    "b": 1.24282005743452,
    "C": 3.91803229455697,
    "h": -0.32278099433911,
    "CMY_C": 0.7987105,
    "CMY_M": 0.7719122,
    "CMY_Y": 0.7880165,
    "CMYK_C": 0.1174909,
    "CMYK_M": 0,
    "CMYK_Y": 0.07060546,
    "CMYK_K": 0.7719122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06431",
    "Farbtonhilfsbezeichnung": "K7.10.11",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "58",
    "Bcolor": "54",
    "Y": 4,
    "L": 23.6861647739896,
    "a": -3.09801404192689,
    "b": 1.18511762867418,
    "C": 3.31695565206569,
    "h": -0.36536557926259,
    "CMY_C": 0.7953187,
    "CMY_M": 0.7734672,
    "CMY_Y": 0.7881067,
    "CMYK_C": 0.09646069,
    "CMYK_M": 0,
    "CMYK_Y": 0.06462443,
    "CMYK_K": 0.7734672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06432",
    "Farbtonhilfsbezeichnung": "K3.06.16",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "64",
    "Bcolor": "61",
    "Y": 5,
    "L": 26.5495711733345,
    "a": -2.33773347690144,
    "b": 0.80333064539921,
    "C": 2.47190977482254,
    "h": -0.33099460400894,
    "CMY_C": 0.7665626,
    "CMY_M": 0.7495061,
    "CMY_Y": 0.7609627,
    "CMYK_C": 0.06809174,
    "CMYK_M": 0,
    "CMYK_Y": 0.04573628,
    "CMYK_K": 0.7495061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06433",
    "Farbtonhilfsbezeichnung": "K9.30.71",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "210",
    "Bcolor": "151",
    "Y": 53,
    "L": 78.1654309048042,
    "a": -35.2635268238475,
    "b": 21.1629457076016,
    "C": 41.1264707345416,
    "h": -0.54052019841379,
    "CMY_C": 0.472112,
    "CMY_M": 0.1761984,
    "CMY_Y": 0.4061391,
    "CMYK_C": 0.3592049,
    "CMYK_M": 0,
    "CMYK_Y": 0.2791215,
    "CMYK_K": 0.1761984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06435",
    "Farbtonhilfsbezeichnung": "K9.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "235",
    "Bcolor": "215",
    "Y": 78,
    "L": 90.8398232025221,
    "a": -11.2682585425437,
    "b": 6.27096461437737,
    "C": 12.8956833000963,
    "h": -0.50783202418397,
    "CMY_C": 0.1728996,
    "CMY_M": 0.07852631,
    "CMY_Y": 0.1579178,
    "CMYK_C": 0.1024156,
    "CMYK_M": 0,
    "CMYK_Y": 0.08615708,
    "CMYK_K": 0.07852631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06436",
    "Farbtonhilfsbezeichnung": "L1.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "239",
    "Bcolor": "221",
    "Y": 82,
    "L": 92.5024611745332,
    "a": -10.3146201447699,
    "b": 5.23500023991661,
    "C": 11.5670487265689,
    "h": -0.46965507191766,
    "CMY_C": 0.1502889,
    "CMY_M": 0.06167843,
    "CMY_Y": 0.1318242,
    "CMYK_C": 0.09443502,
    "CMYK_M": 0,
    "CMYK_Y": 0.07475661,
    "CMYK_K": 0.06167843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06437",
    "Farbtonhilfsbezeichnung": "L1.36.64",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "193",
    "Bcolor": "136",
    "Y": 43,
    "L": 71.5296700956829,
    "a": -39.144070953992,
    "b": 20.2663490941231,
    "C": 44.0792830755677,
    "h": -0.47773662044991,
    "CMY_C": 0.5889683,
    "CMY_M": 0.2425656,
    "CMY_Y": 0.4680211,
    "CMYK_C": 0.4573368,
    "CMYK_M": 0,
    "CMYK_Y": 0.2976568,
    "CMYK_K": 0.2425656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06438",
    "Farbtonhilfsbezeichnung": "L1.17.78",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "226",
    "Bcolor": "189",
    "Y": 67,
    "L": 85.6738015166017,
    "a": -22.5225484477671,
    "b": 12.0264293418938,
    "C": 25.5323361895769,
    "h": -0.49045508618217,
    "CMY_C": 0.3057674,
    "CMY_M": 0.1143642,
    "CMY_Y": 0.258047,
    "CMYK_C": 0.2161196,
    "CMYK_M": 0,
    "CMYK_Y": 0.1622369,
    "CMYK_K": 0.1143642
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06439",
    "Farbtonhilfsbezeichnung": "K9.11.78",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "224",
    "Bcolor": "200",
    "Y": 69,
    "L": 86.4200054362671,
    "a": -14.1738949828097,
    "b": 7.45266258113852,
    "C": 16.0137902612724,
    "h": -0.48407551934245,
    "CMY_C": 0.2414742,
    "CMY_M": 0.1219406,
    "CMY_Y": 0.215135,
    "CMYK_C": 0.1361338,
    "CMYK_M": 0,
    "CMYK_Y": 0.1061368,
    "CMYK_K": 0.1219406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06440",
    "Farbtonhilfsbezeichnung": "K9.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "229",
    "Bcolor": "209",
    "Y": 75,
    "L": 88.8577270507813,
    "a": -9.82401466369629,
    "b": 6.18344068527222,
    "C": 11.6080236434937,
    "h": 147.812835693359,
    "CMY_C": 0.1829172372818,
    "CMY_M": 0.10379612445831,
    "CMY_Y": 0.17871123552322,
    "CMYK_C": 0.08828472346067,
    "CMYK_M": 0,
    "CMYK_Y": 0.08359159529209,
    "CMYK_K": 0.10379612445831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06441",
    "Farbtonhilfsbezeichnung": "LN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "223",
    "Bcolor": "217",
    "Y": 72,
    "L": 88.107806700826,
    "a": -3.30557248325963,
    "b": 1.41413218236923,
    "C": 3.59535523575844,
    "h": -0.40424199598449,
    "CMY_C": 0.1547504,
    "CMY_M": 0.1254996,
    "CMY_Y": 0.1508281,
    "CMYK_C": 0.03344855,
    "CMYK_M": 0,
    "CMYK_Y": 0.02896339,
    "CMYK_K": 0.1254996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06442",
    "Farbtonhilfsbezeichnung": "LN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "230",
    "Y": 84,
    "L": 93.3629919321296,
    "a": -4.00647238126195,
    "b": 2.06705143493466,
    "C": 4.50827268213451,
    "h": -0.47630869201943,
    "CMY_C": 0.09988348,
    "CMY_M": 0.06540848,
    "CMY_Y": 0.09782844,
    "CMYK_C": 0.03688778,
    "CMYK_M": 0,
    "CMYK_Y": 0.03468892,
    "CMYK_K": 0.06540848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06443",
    "Farbtonhilfsbezeichnung": "K9.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "185",
    "Bcolor": "122",
    "Y": 38,
    "L": 68.3546228041245,
    "a": -41.365951453253,
    "b": 23.3624132793929,
    "C": 47.5073077943809,
    "h": -0.51411520123274,
    "CMY_C": 0.635098,
    "CMY_M": 0.2742214,
    "CMY_Y": 0.5227158,
    "CMYK_C": 0.4972268,
    "CMYK_M": 0,
    "CMYK_Y": 0.3423832,
    "CMYK_K": 0.2742214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06444",
    "Farbtonhilfsbezeichnung": "K9.51.28",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "99",
    "Bcolor": "60",
    "Y": 10,
    "L": 37.3328375897375,
    "a": -29.5803547793516,
    "b": 16.2422297581155,
    "C": 33.7462207719282,
    "h": -0.50214305879141,
    "CMY_C": 0.8521892,
    "CMY_M": 0.6104504,
    "CMY_Y": 0.7649435,
    "CMYK_C": 0.6205598,
    "CMYK_M": 0,
    "CMYK_Y": 0.3965942,
    "CMYK_K": 0.6104504
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06445",
    "Farbtonhilfsbezeichnung": "L0.49.21",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "82",
    "Bcolor": "54",
    "Y": 7,
    "L": 30.8200353163695,
    "a": -23.4468115440762,
    "b": 11.2956576833773,
    "C": 26.0258497283655,
    "h": -0.44894671329987,
    "CMY_C": 0.8665794,
    "CMY_M": 0.6800597,
    "CMY_Y": 0.7896212,
    "CMYK_C": 0.5829826,
    "CMYK_M": 0,
    "CMYK_Y": 0.3424433,
    "CMYK_K": 0.6800597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06446",
    "Farbtonhilfsbezeichnung": "L0.44.18",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "77",
    "Bcolor": "55",
    "Y": 6,
    "L": 29.586197522816,
    "a": -17.7833577795664,
    "b": 8.70230306898727,
    "C": 19.798431569712,
    "h": -0.45509213584523,
    "CMY_C": 0.8313869,
    "CMY_M": 0.6988675,
    "CMY_Y": 0.7836199,
    "CMYK_C": 0.44007,
    "CMYK_M": 0,
    "CMYK_Y": 0.2814455,
    "CMYK_K": 0.6988675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06447",
    "Farbtonhilfsbezeichnung": "L1.30.21",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "86",
    "Bcolor": "69",
    "Y": 7,
    "L": 34.217472076416,
    "a": -12.4263124465942,
    "b": 6.52051973342896,
    "C": 14.0331897735596,
    "h": 152.312438964844,
    "CMY_C": 0.75289767980576,
    "CMY_M": 0.66350424289703,
    "CMY_Y": 0.72876882553101,
    "CMYK_C": 0.26565992832184,
    "CMYK_M": 0,
    "CMYK_Y": 0.19395366311073,
    "CMYK_K": 0.66350424289703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06449",
    "Farbtonhilfsbezeichnung": "K9.29.20",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "77",
    "Bcolor": "60",
    "Y": 6,
    "L": 30.4941112138106,
    "a": -12.3687640826939,
    "b": 6.95456916351098,
    "C": 14.1898681171954,
    "h": -0.51221375340919,
    "CMY_C": 0.7843329,
    "CMY_M": 0.6982577,
    "CMY_Y": 0.7644058,
    "CMYK_C": 0.2852609,
    "CMYK_M": 0,
    "CMYK_Y": 0.2192207,
    "CMYK_K": 0.6982577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06451",
    "Farbtonhilfsbezeichnung": "L1.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "63",
    "Bcolor": "55",
    "Y": 5,
    "L": 25.4413615781881,
    "a": -7.29096056594022,
    "b": 2.87569818580463,
    "C": 7.83758547193812,
    "h": -0.37568650156338,
    "CMY_C": 0.8036788,
    "CMY_M": 0.7512956,
    "CMY_Y": 0.7833186,
    "CMYK_C": 0.2106243,
    "CMYK_M": 0,
    "CMYK_Y": 0.1287594,
    "CMYK_K": 0.7512956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06452",
    "Farbtonhilfsbezeichnung": "K9.62.30",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "108",
    "Bcolor": "59",
    "Y": 11,
    "L": 40.3877625955952,
    "a": -34.5088445382631,
    "b": 20.5869093147635,
    "C": 40.1830957804436,
    "h": -0.53789293913854,
    "CMY_C": 0.8654039,
    "CMY_M": 0.5746722,
    "CMY_Y": 0.7673506,
    "CMYK_C": 0.6835473,
    "CMYK_M": 0,
    "CMYK_Y": 0.4530114,
    "CMYK_K": 0.5746722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06453",
    "Farbtonhilfsbezeichnung": "K8.40.29",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "96",
    "Bcolor": "63",
    "Y": 9,
    "L": 36.891689239333,
    "a": -23.4987586536534,
    "b": 14.1793580866281,
    "C": 27.4453248115499,
    "h": -0.54292221202512,
    "CMY_C": 0.7975051,
    "CMY_M": 0.6226785,
    "CMY_Y": 0.7546551,
    "CMYK_C": 0.463336,
    "CMYK_M": 0,
    "CMYK_Y": 0.3497724,
    "CMYK_K": 0.6226785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06454",
    "Farbtonhilfsbezeichnung": "L0.36.25",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "95",
    "Bcolor": "71",
    "Y": 9,
    "L": 37.3763580322266,
    "a": -17.3262901306152,
    "b": 9.74275016784668,
    "C": 19.8776626586914,
    "h": 150.650497436523,
    "CMY_C": 0.75308549404144,
    "CMY_M": 0.62643301486969,
    "CMY_Y": 0.72118735313416,
    "CMYK_C": 0.33903551101685,
    "CMYK_M": 0,
    "CMYK_Y": 0.25364750623703,
    "CMYK_K": 0.62643301486969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06455",
    "Farbtonhilfsbezeichnung": "K8.30.21",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "77",
    "Bcolor": "59",
    "Y": 6,
    "L": 30.4124129349952,
    "a": -13.6900485718537,
    "b": 7.43901219070218,
    "C": 15.580639661873,
    "h": -0.49775288023767,
    "CMY_C": 0.7938262,
    "CMY_M": 0.6970527,
    "CMY_Y": 0.7682325,
    "CMYK_C": 0.3194402,
    "CMYK_M": 0,
    "CMYK_Y": 0.2349576,
    "CMYK_K": 0.6970527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06456",
    "Farbtonhilfsbezeichnung": "K8.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "74",
    "Bcolor": "61",
    "Y": 6,
    "L": 29.8306701158427,
    "a": -9.69071863952511,
    "b": 5.20847079615377,
    "C": 11.0017360350458,
    "h": -0.49317240099617,
    "CMY_C": 0.7755263,
    "CMY_M": 0.7082863,
    "CMY_Y": 0.7593089,
    "CMYK_C": 0.2305,
    "CMYK_M": 0,
    "CMYK_Y": 0.1749066,
    "CMYK_K": 0.7082863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06457",
    "Farbtonhilfsbezeichnung": "K8.12.28",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "90",
    "Bcolor": "80",
    "Y": 10,
    "L": 36.9627305005121,
    "a": -7.50032490753541,
    "b": 3.50584157198869,
    "C": 8.27923902580909,
    "h": -0.43724993875374,
    "CMY_C": 0.7005775,
    "CMY_M": 0.6454638,
    "CMY_Y": 0.684557,
    "CMYK_C": 0.1554531,
    "CMYK_M": 0,
    "CMYK_Y": 0.1102657,
    "CMYK_K": 0.6454638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06458",
    "Farbtonhilfsbezeichnung": "K9.10.32",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "95",
    "Bcolor": "86",
    "Y": 11,
    "L": 38.8165804737113,
    "a": -6.96628978542793,
    "b": 3.05093093579732,
    "C": 7.60508862207158,
    "h": -0.41279342279432,
    "CMY_C": 0.6810029,
    "CMY_M": 0.6287783,
    "CMY_Y": 0.6645501,
    "CMYK_C": 0.1406828,
    "CMYK_M": 0,
    "CMYK_Y": 0.09636232,
    "CMYK_K": 0.6287783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06459",
    "Farbtonhilfsbezeichnung": "K8.61.36",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "118",
    "Bcolor": "59",
    "Y": 14,
    "L": 43.5754649657572,
    "a": -39.883918257264,
    "b": 24.5452627396554,
    "C": 46.8315797140224,
    "h": -0.55167886094336,
    "CMY_C": 0.896015,
    "CMY_M": 0.5365341,
    "CMY_Y": 0.7668215,
    "CMYK_C": 0.7756361,
    "CMYK_M": 0,
    "CMYK_Y": 0.496881,
    "CMYK_K": 0.5365341
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06460",
    "Farbtonhilfsbezeichnung": "K9.52.32",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "106",
    "Bcolor": "65",
    "Y": 11,
    "L": 39.8977616984398,
    "a": -30.5410328974061,
    "b": 16.7554607682812,
    "C": 34.8353291357761,
    "h": -0.50178408170169,
    "CMY_C": 0.8352507,
    "CMY_M": 0.5841401,
    "CMY_Y": 0.7455696,
    "CMYK_C": 0.6038346,
    "CMYK_M": 0,
    "CMYK_Y": 0.3881826,
    "CMYK_K": 0.5841401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06461",
    "Farbtonhilfsbezeichnung": "K9.40.31",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "102",
    "Bcolor": "68",
    "Y": 11,
    "L": 39.1021903188907,
    "a": -23.6132019808347,
    "b": 13.8798806287513,
    "C": 27.3904069713482,
    "h": -0.53140188727712,
    "CMY_C": 0.7788926,
    "CMY_M": 0.6010841,
    "CMY_Y": 0.7329747,
    "CMYK_C": 0.4457292,
    "CMYK_M": 0,
    "CMYK_Y": 0.3306225,
    "CMYK_K": 0.6010841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06462",
    "Farbtonhilfsbezeichnung": "K8.32.29",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "102",
    "Bcolor": "77",
    "Y": 10,
    "L": 40.2253646850586,
    "a": -17.0779113769531,
    "b": 10.3682022094727,
    "C": 19.9788551330566,
    "h": 148.737579345703,
    "CMY_C": 0.72256767749786,
    "CMY_M": 0.59952473640442,
    "CMY_Y": 0.69929480552673,
    "CMYK_C": 0.30724230408669,
    "CMYK_M": 0,
    "CMYK_Y": 0.24912916123867,
    "CMYK_K": 0.59952473640442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06463",
    "Farbtonhilfsbezeichnung": "K9.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "97",
    "Bcolor": "79",
    "Y": 11,
    "L": 38.8155953803814,
    "a": -12.0724488405619,
    "b": 6.80038471237592,
    "C": 13.8560186649809,
    "h": -0.51299535043579,
    "CMY_C": 0.7073078,
    "CMY_M": 0.62063,
    "CMY_Y": 0.6888213,
    "CMYK_C": 0.2284783,
    "CMYK_M": 0,
    "CMYK_Y": 0.1797488,
    "CMYK_K": 0.62063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06464",
    "Farbtonhilfsbezeichnung": "K9.09.36",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "107",
    "Bcolor": "97",
    "Y": 14,
    "L": 43.801780876425,
    "a": -6.90614665358885,
    "b": 3.38441626067369,
    "C": 7.69084748427565,
    "h": -0.45566287136912,
    "CMY_C": 0.6327062,
    "CMY_M": 0.5810912,
    "CMY_Y": 0.6199468,
    "CMYK_C": 0.123213,
    "CMYK_M": 0,
    "CMYK_Y": 0.09275449,
    "CMYK_K": 0.5810912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06465",
    "Farbtonhilfsbezeichnung": "L0.67.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "64",
    "Y": 16,
    "L": 47.1617587466782,
    "a": -48.5560843632133,
    "b": 26.4694265556148,
    "C": 55.3021145244065,
    "h": -0.49909732680011,
    "CMY_C": 1,
    "CMY_M": 0.489722,
    "CMY_Y": 0.7491827,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.5084693,
    "CMYK_K": 0.489722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06466",
    "Farbtonhilfsbezeichnung": "K8.45.34",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "115",
    "Bcolor": "74",
    "Y": 14,
    "L": 43.8855976479841,
    "a": -28.4466304759537,
    "b": 17.111853374662,
    "C": 33.1967816414692,
    "h": -0.54155282057161,
    "CMY_C": 0.7690984,
    "CMY_M": 0.5475866,
    "CMY_Y": 0.7115163,
    "CMYK_C": 0.4896225,
    "CMYK_M": 0,
    "CMYK_Y": 0.362345,
    "CMYK_K": 0.5475866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06467",
    "Farbtonhilfsbezeichnung": "L0.35.37",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "117",
    "Bcolor": "82",
    "Y": 14,
    "L": 44.8429978725395,
    "a": -25.2257551346846,
    "b": 13.3139403300656,
    "C": 28.523669631161,
    "h": -0.48563286274795,
    "CMY_C": 0.7420284,
    "CMY_M": 0.5421481,
    "CMY_Y": 0.6770687,
    "CMYK_C": 0.4365611,
    "CMYK_M": 0,
    "CMYK_Y": 0.2946817,
    "CMYK_K": 0.5421481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06468",
    "Farbtonhilfsbezeichnung": "K8.27.36",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "117",
    "Bcolor": "91",
    "Y": 14,
    "L": 45.9719543457031,
    "a": -17.3619136810303,
    "b": 10.1472368240356,
    "C": 20.1097602844238,
    "h": 149.695678710938,
    "CMY_C": 0.67163252830505,
    "CMY_M": 0.54277944564819,
    "CMY_Y": 0.64468044042587,
    "CMYK_C": 0.28181821107864,
    "CMYK_M": 0,
    "CMYK_Y": 0.22287054359913,
    "CMYK_K": 0.54277944564819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06469",
    "Farbtonhilfsbezeichnung": "K8.21.31",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "99",
    "Bcolor": "80",
    "Y": 11,
    "L": 39.3607182663034,
    "a": -14.1039217219961,
    "b": 7.38442370150889,
    "C": 15.9201231573,
    "h": -0.48232718172339,
    "CMY_C": 0.7163245,
    "CMY_M": 0.6121325,
    "CMY_Y": 0.6877778,
    "CMYK_C": 0.2686278,
    "CMYK_M": 0,
    "CMYK_Y": 0.1950287,
    "CMYK_K": 0.6121325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06470",
    "Farbtonhilfsbezeichnung": "K9.17.40",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "120",
    "Bcolor": "100",
    "Y": 17,
    "L": 47.9164988992993,
    "a": -13.0001470753791,
    "b": 7.63936960125091,
    "C": 15.0785871979441,
    "h": -0.53127958435866,
    "CMY_C": 0.6261179,
    "CMY_M": 0.5305265,
    "CMY_Y": 0.609266,
    "CMYK_C": 0.2036141,
    "CMYK_M": 0,
    "CMYK_Y": 0.1677188,
    "CMYK_K": 0.5305265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06471",
    "Farbtonhilfsbezeichnung": "K8.05.45",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "126",
    "Bcolor": "120",
    "Y": 20,
    "L": 52.0257677228217,
    "a": -4.58899790209155,
    "b": 1.71195058009608,
    "C": 4.8979257379111,
    "h": -0.35706475176061,
    "CMY_C": 0.5413691,
    "CMY_M": 0.5041944,
    "CMY_Y": 0.5293387,
    "CMYK_C": 0.0749783,
    "CMYK_M": 0,
    "CMYK_Y": 0.05071394,
    "CMYK_K": 0.5041944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06472",
    "Farbtonhilfsbezeichnung": "LN.02.44",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "126",
    "Bcolor": "123",
    "Y": 20,
    "L": 52.211984519252,
    "a": -2.3667737462757,
    "b": 0.20398941188719,
    "C": 2.37554828328577,
    "h": -0.08597633768195,
    "CMY_C": 0.5280715,
    "CMY_M": 0.5064782,
    "CMY_Y": 0.5172466,
    "CMYK_C": 0.04375339,
    "CMYK_M": 0,
    "CMYK_Y": 0.02181944,
    "CMYK_K": 0.5064782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06473",
    "Farbtonhilfsbezeichnung": "K9.51.41",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "128",
    "Bcolor": "73",
    "Y": 16,
    "L": 47.3743342281794,
    "a": -38.3537835613827,
    "b": 22.0937099546875,
    "C": 44.2622269326256,
    "h": -0.52262327784486,
    "CMY_C": 0.8349043,
    "CMY_M": 0.4995845,
    "CMY_Y": 0.7148087,
    "CMYK_C": 0.6700827,
    "CMYK_M": 0,
    "CMYK_Y": 0.4300911,
    "CMYK_K": 0.4995845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06474",
    "Farbtonhilfsbezeichnung": "K9.41.40",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "123",
    "Bcolor": "80",
    "Y": 16,
    "L": 46.5237339566197,
    "a": -30.5224189050789,
    "b": 16.7051040744034,
    "C": 34.7948064796136,
    "h": -0.50077255523405,
    "CMY_C": 0.767381,
    "CMY_M": 0.5181339,
    "CMY_Y": 0.6847987,
    "CMYK_C": 0.5172539,
    "CMYK_M": 0,
    "CMYK_Y": 0.3458737,
    "CMYK_K": 0.5181339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06475",
    "Farbtonhilfsbezeichnung": "K8.33.40",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "127",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.0153431398071,
    "a": -24.4947315390423,
    "b": 14.7648108779251,
    "C": 28.6005509287959,
    "h": -0.54245741592541,
    "CMY_C": 0.68896,
    "CMY_M": 0.5017048,
    "CMY_Y": 0.6476749,
    "CMYK_C": 0.3757917,
    "CMYK_M": 0,
    "CMYK_Y": 0.2929392,
    "CMYK_K": 0.5017048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06476",
    "Farbtonhilfsbezeichnung": "L0.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "121",
    "Bcolor": "88",
    "Y": 16,
    "L": 46.5189987070842,
    "a": -24.1560592474468,
    "b": 12.4501611927019,
    "C": 27.1757559617101,
    "h": -0.47589576565246,
    "CMY_C": 0.7187793,
    "CMY_M": 0.5269001,
    "CMY_Y": 0.6556161,
    "CMYK_C": 0.4055786,
    "CMYK_M": 0,
    "CMYK_Y": 0.2720695,
    "CMYK_K": 0.5269001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06477",
    "Farbtonhilfsbezeichnung": "K8.15.50",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "143",
    "Bcolor": "121",
    "Y": 25,
    "L": 56.8733677699024,
    "a": -13.2672773408855,
    "b": 8.24617374752519,
    "C": 15.6211404677875,
    "h": -0.55610899683869,
    "CMY_C": 0.538743,
    "CMY_M": 0.4398794,
    "CMY_Y": 0.5265125,
    "CMYK_C": 0.176504,
    "CMYK_M": 0,
    "CMYK_Y": 0.1546686,
    "CMYK_K": 0.4398794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06478",
    "Farbtonhilfsbezeichnung": "K9.60.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "138",
    "Bcolor": "69",
    "Y": 19,
    "L": 50.2866715725088,
    "a": -48.2671238685278,
    "b": 27.8539171199753,
    "C": 55.7275151560363,
    "h": -0.52339488864037,
    "CMY_C": 1,
    "CMY_M": 0.4577728,
    "CMY_Y": 0.7302644,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.5025415,
    "CMYK_K": 0.4577728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06479",
    "Farbtonhilfsbezeichnung": "K9.38.44",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "137",
    "Bcolor": "91",
    "Y": 20,
    "L": 52.0417902227318,
    "a": -31.2827353425776,
    "b": 17.8892599443751,
    "C": 36.0365807461138,
    "h": -0.51946923488068,
    "CMY_C": 0.7148551,
    "CMY_M": 0.4610665,
    "CMY_Y": 0.641254,
    "CMYK_C": 0.4709088,
    "CMYK_M": 0,
    "CMYK_Y": 0.3343408,
    "CMYK_K": 0.4610665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06480",
    "Farbtonhilfsbezeichnung": "K9.16.56",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "161",
    "Bcolor": "136",
    "Y": 31,
    "L": 63.298755645752,
    "a": -15.1964988708496,
    "b": 8.82917881011963,
    "C": 17.5752086639404,
    "h": 149.843383789063,
    "CMY_C": 0.48793631792068,
    "CMY_M": 0.36986607313156,
    "CMY_Y": 0.46674078702927,
    "CMYK_C": 0.18737325072289,
    "CMYK_M": 0,
    "CMYK_Y": 0.1537367105484,
    "CMYK_K": 0.36986607313156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06481",
    "Farbtonhilfsbezeichnung": "K8.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "154",
    "Bcolor": "145",
    "Y": 31,
    "L": 62.5859521025427,
    "a": -4.97333401923267,
    "b": 2.68417837274684,
    "C": 5.6514480271501,
    "h": -0.49491186473978,
    "CMY_C": 0.4349941,
    "CMY_M": 0.3961749,
    "CMY_Y": 0.430237,
    "CMYK_C": 0.06428892,
    "CMYK_M": 0,
    "CMYK_Y": 0.05641057,
    "CMYK_K": 0.3961749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06482",
    "Farbtonhilfsbezeichnung": "LN.02.52",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "145",
    "Bcolor": "142",
    "Y": 28,
    "L": 59.4644996312222,
    "a": -2.24465652568806,
    "b": -0.22038073911341,
    "C": 2.25544908798363,
    "h": 0.09786650894968,
    "CMY_C": 0.4558138,
    "CMY_M": 0.4333082,
    "CMY_Y": 0.4417766,
    "CMYK_C": 0.03971395,
    "CMYK_M": 0,
    "CMYK_Y": 0.01494342,
    "CMYK_K": 0.4333082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06483",
    "Farbtonhilfsbezeichnung": "K9.45.50",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "152",
    "Bcolor": "94",
    "Y": 24,
    "L": 56.5232908965884,
    "a": -39.5927358368126,
    "b": 22.1646384181638,
    "C": 45.3746176540537,
    "h": -0.51034807271476,
    "CMY_C": 0.7480156,
    "CMY_M": 0.4031137,
    "CMY_Y": 0.6295297,
    "CMYK_C": 0.5778351,
    "CMYK_M": 0,
    "CMYK_Y": 0.3793284,
    "CMYK_K": 0.4031137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06484",
    "Farbtonhilfsbezeichnung": "L0.39.48",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "148",
    "Bcolor": "98",
    "Y": 24,
    "L": 55.6519422096334,
    "a": -34.1909928013303,
    "b": 18.857196257066,
    "C": 39.0463550080942,
    "h": -0.50401348302147,
    "CMY_C": 0.7061054,
    "CMY_M": 0.4195517,
    "CMY_Y": 0.6139427,
    "CMYK_C": 0.4936764,
    "CMYK_M": 0,
    "CMYK_Y": 0.3348981,
    "CMYK_K": 0.4195517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06485",
    "Farbtonhilfsbezeichnung": "K9.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "151",
    "Bcolor": "111",
    "Y": 26,
    "L": 57.6953531180845,
    "a": -26.933137509378,
    "b": 14.9079011115183,
    "C": 30.7837523971635,
    "h": -0.50553801766434,
    "CMY_C": 0.6259084,
    "CMY_M": 0.4088951,
    "CMY_Y": 0.5658481,
    "CMYK_C": 0.3671315,
    "CMYK_M": 0,
    "CMYK_Y": 0.2655248,
    "CMYK_K": 0.4088951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06486",
    "Farbtonhilfsbezeichnung": "K8.20.59",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "173",
    "Bcolor": "139",
    "Y": 37,
    "L": 67.0646891756344,
    "a": -20.5667334021317,
    "b": 12.2165260677542,
    "C": 23.9214136705688,
    "h": -0.53599197328506,
    "CMY_C": 0.4832226,
    "CMY_M": 0.320897,
    "CMY_Y": 0.4531016,
    "CMYK_C": 0.2390293,
    "CMYK_M": 0,
    "CMYK_Y": 0.1946753,
    "CMYK_K": 0.320897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06487",
    "Farbtonhilfsbezeichnung": "LN.01.59",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "165",
    "Bcolor": "163",
    "Y": 37,
    "L": 67.3845247314695,
    "a": -2.13468568337133,
    "b": -0.0969751572992,
    "C": 2.13688725671799,
    "h": 0.04539709537541,
    "CMY_C": 0.373068,
    "CMY_M": 0.3514989,
    "CMY_Y": 0.3612759,
    "CMYK_C": 0.03325995,
    "CMYK_M": 0,
    "CMYK_Y": 0.01507629,
    "CMYK_K": 0.3514989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06488",
    "Farbtonhilfsbezeichnung": "K8.51.50",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "157",
    "Bcolor": "87",
    "Y": 26,
    "L": 57.5864633233656,
    "a": -44.362226200395,
    "b": 27.3431975398892,
    "C": 52.1119714188632,
    "h": -0.55236370729681,
    "CMY_C": 0.7769148,
    "CMY_M": 0.3860125,
    "CMY_Y": 0.6571316,
    "CMYK_C": 0.6366617,
    "CMYK_M": 0,
    "CMYK_Y": 0.4415711,
    "CMYK_K": 0.3860125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06489",
    "Farbtonhilfsbezeichnung": "K8.34.55",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "166",
    "Bcolor": "115",
    "Y": 31,
    "L": 62.4476510680085,
    "a": -33.0997995098915,
    "b": 19.1116281178209,
    "C": 38.2210813152754,
    "h": -0.52363162926766,
    "CMY_C": 0.6228468,
    "CMY_M": 0.349813,
    "CMY_Y": 0.5495481,
    "CMYK_C": 0.4199312,
    "CMYK_M": 0,
    "CMYK_Y": 0.3071965,
    "CMYK_K": 0.349813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06490",
    "Farbtonhilfsbezeichnung": "L0.29.59",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "175",
    "Bcolor": "131",
    "Y": 36,
    "L": 66.3971960222273,
    "a": -30.1293543383631,
    "b": 16.0331635564157,
    "C": 34.1297571991571,
    "h": -0.48903113528759,
    "CMY_C": 0.5644014,
    "CMY_M": 0.3120159,
    "CMY_Y": 0.4881147,
    "CMYK_C": 0.3668479,
    "CMYK_M": 0,
    "CMYK_Y": 0.2559635,
    "CMYK_K": 0.3120159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06491",
    "Farbtonhilfsbezeichnung": "K8.20.63",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "182",
    "Bcolor": "147",
    "Y": 41,
    "L": 70.4686739033547,
    "a": -19.7680738269054,
    "b": 12.7112423425144,
    "C": 23.5021791482431,
    "h": -0.57145182949721,
    "CMY_C": 0.4395464,
    "CMY_M": 0.2861651,
    "CMY_Y": 0.4218392,
    "CMYK_C": 0.2148694,
    "CMYK_M": 0,
    "CMYK_Y": 0.1900637,
    "CMYK_K": 0.2861651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06492",
    "Farbtonhilfsbezeichnung": "K9.09.72",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "203",
    "Bcolor": "184",
    "Y": 56,
    "L": 79.5969467163086,
    "a": -10.5456218719482,
    "b": 6.07107210159302,
    "C": 12.1683216094971,
    "h": 150.071136474609,
    "CMY_C": 0.28953522443771,
    "CMY_M": 0.20435041189194,
    "CMY_Y": 0.27771091461182,
    "CMYK_C": 0.10706322640181,
    "CMYK_M": 0,
    "CMYK_Y": 0.0922020226717,
    "CMYK_K": 0.20435041189194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06493",
    "Farbtonhilfsbezeichnung": "L0.04.65",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "181",
    "Bcolor": "173",
    "Y": 45,
    "L": 72.7302322387695,
    "a": -4.7391529083252,
    "b": 2.37970542907715,
    "C": 5.30307149887085,
    "h": 153.337066650391,
    "CMY_C": 0.32872444391251,
    "CMY_M": 0.28990912437439,
    "CMY_Y": 0.32312643527985,
    "CMYK_C": 0.05466246604919,
    "CMYK_M": 0,
    "CMYK_Y": 0.04677895829082,
    "CMYK_K": 0.28990912437439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06494",
    "Farbtonhilfsbezeichnung": "LN.01.67",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "186",
    "Bcolor": "182",
    "Y": 48,
    "L": 75.0706604609913,
    "a": -2.15454105805063,
    "b": 0.72333989712656,
    "C": 2.27272254743094,
    "h": -0.32390426094045,
    "CMY_C": 0.2894113,
    "CMY_M": 0.2701488,
    "CMY_Y": 0.28632,
    "CMYK_C": 0.02639237,
    "CMYK_M": 0,
    "CMYK_Y": 0.02215684,
    "CMYK_K": 0.2701488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06495",
    "Farbtonhilfsbezeichnung": "L0.45.54",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "165",
    "Bcolor": "104",
    "Y": 29,
    "L": 60.9366140629574,
    "a": -41.476965320148,
    "b": 22.7069335886851,
    "C": 47.2857640857131,
    "h": -0.50089017317423,
    "CMY_C": 0.7215775,
    "CMY_M": 0.3537864,
    "CMY_Y": 0.5910782,
    "CMYK_C": 0.5691478,
    "CMYK_M": 0,
    "CMYK_Y": 0.3672034,
    "CMYK_K": 0.3537864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06496",
    "Farbtonhilfsbezeichnung": "K9.29.62",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "185",
    "Bcolor": "138",
    "Y": 40,
    "L": 69.6898606399264,
    "a": -30.3148956781503,
    "b": 16.7218528959562,
    "C": 34.6209945589542,
    "h": -0.50407474447046,
    "CMY_C": 0.5294039,
    "CMY_M": 0.2764575,
    "CMY_Y": 0.4598565,
    "CMYK_C": 0.3495944,
    "CMYK_M": 0,
    "CMYK_Y": 0.2534737,
    "CMYK_K": 0.2764575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06497",
    "Farbtonhilfsbezeichnung": "L0.19.69",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "199",
    "Bcolor": "165",
    "Y": 50,
    "L": 76.370367113446,
    "a": -21.324330010095,
    "b": 11.582513823165,
    "C": 24.2668843662149,
    "h": -0.49757627295297,
    "CMY_C": 0.3956668,
    "CMY_M": 0.2191882,
    "CMY_Y": 0.3529873,
    "CMYK_C": 0.2260194,
    "CMYK_M": 0,
    "CMYK_Y": 0.1713589,
    "CMYK_K": 0.2191882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06498",
    "Farbtonhilfsbezeichnung": "L1.08.73",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "204",
    "Bcolor": "187",
    "Y": 57,
    "L": 79.9857151845706,
    "a": -10.2952946510773,
    "b": 5.24472475574314,
    "C": 11.5542299490709,
    "h": -0.47116256333907,
    "CMY_C": 0.2862323,
    "CMY_M": 0.2004496,
    "CMY_Y": 0.2675629,
    "CMYK_C": 0.1072886,
    "CMYK_M": 0,
    "CMYK_Y": 0.0839387,
    "CMYK_K": 0.2004496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06499",
    "Farbtonhilfsbezeichnung": "K9.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "218",
    "Bcolor": "200",
    "Y": 66,
    "L": 85.1504454824435,
    "a": -9.92800777487052,
    "b": 5.58663423988726,
    "C": 11.3919190880277,
    "h": -0.51255241262389,
    "CMY_C": 0.2263352,
    "CMY_M": 0.1445928,
    "CMY_Y": 0.2145586,
    "CMYK_C": 0.09555966,
    "CMYK_M": 0,
    "CMYK_Y": 0.08179238,
    "CMYK_K": 0.1445928
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06500",
    "Farbtonhilfsbezeichnung": "K9.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "209",
    "Bcolor": "198",
    "Y": 61,
    "L": 82.630401860662,
    "a": -6.35109956646118,
    "b": 3.26186719376016,
    "C": 7.13976493260333,
    "h": -0.47446115039997,
    "CMY_C": 0.2326283,
    "CMY_M": 0.17954,
    "CMY_Y": 0.2242958,
    "CMYK_C": 0.06470558,
    "CMYK_M": 0,
    "CMYK_Y": 0.05454959,
    "CMYK_K": 0.17954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06501",
    "Farbtonhilfsbezeichnung": "L0.22.76",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "218",
    "Bcolor": "175",
    "Y": 61,
    "L": 82.1986998205851,
    "a": -27.3507911719875,
    "b": 14.4142720113465,
    "C": 30.9166139049987,
    "h": -0.48502516045778,
    "CMY_C": 0.3784037,
    "CMY_M": 0.1443169,
    "CMY_Y": 0.3132643,
    "CMYK_C": 0.2735671,
    "CMYK_M": 0,
    "CMYK_Y": 0.1974415,
    "CMYK_K": 0.1443169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06502",
    "Farbtonhilfsbezeichnung": "L1.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "214",
    "Bcolor": "191",
    "Y": 62,
    "L": 82.7995183348489,
    "a": -14.3347047291776,
    "b": 7.02775595730865,
    "C": 15.9647459568949,
    "h": -0.45582662045049,
    "CMY_C": 0.2834535,
    "CMY_M": 0.1615705,
    "CMY_Y": 0.2509943,
    "CMYK_C": 0.1453705,
    "CMYK_M": 0,
    "CMYK_Y": 0.1066563,
    "CMYK_K": 0.1615705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06503",
    "Farbtonhilfsbezeichnung": "L1.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "219",
    "Bcolor": "204",
    "Y": 68,
    "L": 85.7862619720691,
    "a": -7.69647275552815,
    "b": 4.56653116270569,
    "C": 8.9492401764926,
    "h": -0.53549901828149,
    "CMY_C": 0.2047003,
    "CMY_M": 0.1421741,
    "CMY_Y": 0.1998926,
    "CMYK_C": 0.07288915,
    "CMYK_M": 0,
    "CMYK_Y": 0.06728461,
    "CMYK_K": 0.1421741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06504",
    "Farbtonhilfsbezeichnung": "LN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "221",
    "Bcolor": "214",
    "Y": 70,
    "L": 87.2121308775482,
    "a": -4.20896209169092,
    "b": 1.22763106654433,
    "C": 4.38434030668651,
    "h": -0.28379785850878,
    "CMY_C": 0.1725324,
    "CMY_M": 0.1333089,
    "CMY_Y": 0.1593882,
    "CMYK_C": 0.04525658,
    "CMYK_M": 0,
    "CMYK_Y": 0.03009063,
    "CMYK_K": 0.1333089
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06505",
    "Farbtonhilfsbezeichnung": "LN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "224",
    "Bcolor": "217",
    "Y": 73,
    "L": 88.6328708461743,
    "a": -2.3938009359244,
    "b": 1.80478838090874,
    "C": 2.99792328465818,
    "h": -0.64601956921964,
    "CMY_C": 0.1403117,
    "CMY_M": 0.121886,
    "CMY_Y": 0.1478219,
    "CMYK_C": 0.0209832,
    "CMYK_M": 0,
    "CMYK_Y": 0.02953587,
    "CMYK_K": 0.121886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06506",
    "Farbtonhilfsbezeichnung": "L6.39.63",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "191",
    "Bcolor": "141",
    "Y": 41,
    "L": 70.1323094464924,
    "a": -43.0010466610238,
    "b": 15.1859521529794,
    "C": 45.6037625282841,
    "h": -0.33948103474286,
    "CMY_C": 0.6835796,
    "CMY_M": 0.2508734,
    "CMY_Y": 0.4460906,
    "CMYK_C": 0.5776141,
    "CMYK_M": 0,
    "CMYK_Y": 0.2605931,
    "CMYK_K": 0.2508734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06507",
    "Farbtonhilfsbezeichnung": "L7.30.69",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "206",
    "Bcolor": "164",
    "Y": 50,
    "L": 76.2995165935553,
    "a": -36.2646650228881,
    "b": 11.9855677846755,
    "C": 38.1939754980197,
    "h": -0.31920077698235,
    "CMY_C": 0.5453464,
    "CMY_M": 0.1932776,
    "CMY_Y": 0.3586577,
    "CMYK_C": 0.4364188,
    "CMYK_M": 0,
    "CMYK_Y": 0.2050025,
    "CMYK_K": 0.1932776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06508",
    "Farbtonhilfsbezeichnung": "L3.22.75",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "220",
    "Bcolor": "180",
    "Y": 62,
    "L": 82.6884900326627,
    "a": -28.415274305735,
    "b": 12.3342778235789,
    "C": 30.9768013729532,
    "h": -0.40952963608299,
    "CMY_C": 0.3918856,
    "CMY_M": 0.1364349,
    "CMY_Y": 0.2929541,
    "CMYK_C": 0.2958095,
    "CMYK_M": 0,
    "CMYK_Y": 0.1812477,
    "CMYK_K": 0.1364349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06509",
    "Farbtonhilfsbezeichnung": "L2.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "235",
    "Bcolor": "207",
    "Y": 75,
    "L": 89.6165754631859,
    "a": -17.4790603382561,
    "b": 8.31209597016427,
    "C": 19.3548053393885,
    "h": -0.44389367046665,
    "CMY_C": 0.2321547,
    "CMY_M": 0.07955477,
    "CMY_Y": 0.1872966,
    "CMYK_C": 0.1657892,
    "CMYK_M": 0,
    "CMYK_Y": 0.1170541,
    "CMYK_K": 0.07955477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06510",
    "Farbtonhilfsbezeichnung": "L7.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "233",
    "Bcolor": "213",
    "Y": 75,
    "L": 89.2481344184585,
    "a": -15.5328241965424,
    "b": 4.86335349360854,
    "C": 16.2763888723663,
    "h": -0.30343293254737,
    "CMY_C": 0.2322545,
    "CMY_M": 0.08687238,
    "CMY_Y": 0.1654769,
    "CMYK_C": 0.1592134,
    "CMYK_M": 0,
    "CMYK_Y": 0.08608276,
    "CMYK_K": 0.08687238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06511",
    "Farbtonhilfsbezeichnung": "L6.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "235",
    "Bcolor": "219",
    "Y": 78,
    "L": 90.7694892802167,
    "a": -11.0393444597318,
    "b": 4.1554160835402,
    "C": 11.7955334312593,
    "h": -0.36001391274373,
    "CMY_C": 0.1794539,
    "CMY_M": 0.07925888,
    "CMY_Y": 0.1429496,
    "CMYK_C": 0.10882,
    "CMYK_M": 0,
    "CMYK_Y": 0.0691733,
    "CMYK_K": 0.07925888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06512",
    "Farbtonhilfsbezeichnung": "L2.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "239",
    "Bcolor": "222",
    "Y": 82,
    "L": 92.5536167112589,
    "a": -9.87996798066448,
    "b": 4.88109508526877,
    "C": 11.0199299693959,
    "h": -0.45886790181236,
    "CMY_C": 0.147352,
    "CMY_M": 0.06196994,
    "CMY_Y": 0.1285626,
    "CMYK_C": 0.0910227,
    "CMYK_M": 0,
    "CMYK_Y": 0.07099198,
    "CMYK_K": 0.06196994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06513",
    "Farbtonhilfsbezeichnung": "L6.41.61",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "186",
    "Bcolor": "135",
    "Y": 38,
    "L": 68.0109234171278,
    "a": -44.2960724123231,
    "b": 15.3103275701052,
    "C": 46.8673464307688,
    "h": -0.33278199860323,
    "CMY_C": 0.7288229,
    "CMY_M": 0.27211,
    "CMY_Y": 0.4686368,
    "CMYK_C": 0.6274478,
    "CMYK_M": 0,
    "CMYK_Y": 0.2699952,
    "CMYK_K": 0.27211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06514",
    "Farbtonhilfsbezeichnung": "L5.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "230",
    "Bcolor": "207",
    "Y": 72,
    "L": 88.1433421378122,
    "a": -16.7932160763562,
    "b": 6.18090804079856,
    "C": 17.8945726519522,
    "h": -0.3526722872505,
    "CMY_C": 0.2502748,
    "CMY_M": 0.09694394,
    "CMY_Y": 0.1874376,
    "CMYK_C": 0.1697911,
    "CMYK_M": 0,
    "CMYK_Y": 0.1002082,
    "CMYK_K": 0.09694394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06515",
    "Farbtonhilfsbezeichnung": "L2.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "228",
    "Bcolor": "207",
    "Y": 72,
    "L": 87.988303490023,
    "a": -12.8352716946017,
    "b": 6.15598052963537,
    "C": 14.235178107614,
    "h": -0.44720649580391,
    "CMY_C": 0.2177666,
    "CMY_M": 0.1069916,
    "CMY_Y": 0.1883932,
    "CMYK_C": 0.1240469,
    "CMYK_M": 0,
    "CMYK_Y": 0.09115431,
    "CMYK_K": 0.1069916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06516",
    "Farbtonhilfsbezeichnung": "L5.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "237",
    "Bcolor": "224",
    "Y": 81,
    "L": 92.061360458616,
    "a": -7.92655910854867,
    "b": 3.36811620937332,
    "C": 8.61246457764322,
    "h": -0.40179890014947,
    "CMY_C": 0.1419415,
    "CMY_M": 0.07144502,
    "CMY_Y": 0.1224526,
    "CMYK_C": 0.07592069,
    "CMYK_M": 0,
    "CMYK_Y": 0.05493226,
    "CMYK_K": 0.07144502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06517",
    "Farbtonhilfsbezeichnung": "L5.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "240",
    "Bcolor": "228",
    "Y": 83,
    "L": 93.1542476774296,
    "a": -7.2675064817494,
    "b": 2.769994089394,
    "C": 7.77750073722576,
    "h": -0.36414959636792,
    "CMY_C": 0.126519,
    "CMY_M": 0.0604884,
    "CMY_Y": 0.1058329,
    "CMYK_C": 0.0702818,
    "CMYK_M": 0,
    "CMYK_Y": 0.04826395,
    "CMYK_K": 0.0604884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06519",
    "Farbtonhilfsbezeichnung": "L6.36.63",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "190",
    "Bcolor": "141",
    "Y": 41,
    "L": 70.1594328319904,
    "a": -41.1645853731679,
    "b": 15.1300969428116,
    "C": 43.8570738016538,
    "h": -0.35222436687017,
    "CMY_C": 0.657133,
    "CMY_M": 0.253395,
    "CMY_Y": 0.4451751,
    "CMYK_C": 0.5407652,
    "CMYK_M": 0,
    "CMYK_Y": 0.2568696,
    "CMYK_K": 0.253395
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06520",
    "Farbtonhilfsbezeichnung": "L7.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "202",
    "Bcolor": "175",
    "Y": 51,
    "L": 76.9600921640179,
    "a": -24.0855067993139,
    "b": 7.16549278572269,
    "C": 25.128786772187,
    "h": -0.28916372056748,
    "CMY_C": 0.4326934,
    "CMY_M": 0.2065328,
    "CMY_Y": 0.3153369,
    "CMYK_C": 0.2850283,
    "CMYK_M": 0,
    "CMYK_Y": 0.1371248,
    "CMYK_K": 0.2065328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06521",
    "Farbtonhilfsbezeichnung": "L5.19.72",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "216",
    "Bcolor": "184",
    "Y": 61,
    "L": 82.3608385285029,
    "a": -21.7407549289672,
    "b": 9.85054084381332,
    "C": 23.8682546449682,
    "h": -0.42542144604635,
    "CMY_C": 0.3425615,
    "CMY_M": 0.1522011,
    "CMY_Y": 0.2773154,
    "CMYK_C": 0.2245349,
    "CMYK_M": 0,
    "CMYK_Y": 0.1475755,
    "CMYK_K": 0.1522011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06522",
    "Farbtonhilfsbezeichnung": "L5.08.81",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "227",
    "Bcolor": "208",
    "Y": 72,
    "L": 88.0740762535847,
    "a": -11.8872163790874,
    "b": 5.68409407644066,
    "C": 13.1762983691578,
    "h": -0.44603048468642,
    "CMY_C": 0.210524,
    "CMY_M": 0.1079457,
    "CMY_Y": 0.1838457,
    "CMYK_C": 0.1149911,
    "CMYK_M": 0,
    "CMYK_Y": 0.0850845,
    "CMYK_K": 0.1079457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06523",
    "Farbtonhilfsbezeichnung": "L3.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "228",
    "Bcolor": "212",
    "Y": 73,
    "L": 88.65152077266,
    "a": -9.80866180003842,
    "b": 4.29774135324599,
    "C": 10.7088947630899,
    "h": -0.41296240132195,
    "CMY_C": 0.1917869,
    "CMY_M": 0.1056577,
    "CMY_Y": 0.1670288,
    "CMYK_C": 0.09630453,
    "CMYK_M": 0,
    "CMYK_Y": 0.06862148,
    "CMYK_K": 0.1056577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06524",
    "Farbtonhilfsbezeichnung": "L6.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "222",
    "Bcolor": "211",
    "Y": 70,
    "L": 87.1547806886509,
    "a": -7.17317101264819,
    "b": 3.08219398703788,
    "C": 7.80732362275503,
    "h": -0.40583100595612,
    "CMY_C": 0.1907097,
    "CMY_M": 0.1277856,
    "CMY_Y": 0.1740456,
    "CMYK_C": 0.07214287,
    "CMYK_M": 0,
    "CMYK_Y": 0.05303742,
    "CMYK_K": 0.1277856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06525",
    "Farbtonhilfsbezeichnung": "L5.51.51",
    "Farbtonklasse": "03",
    "Rcolor": "24",
    "Gcolor": "162",
    "Bcolor": "107",
    "Y": 27,
    "L": 59.1584831516762,
    "a": -47.6117535864298,
    "b": 18.5621389047808,
    "C": 51.1021729508178,
    "h": -0.37173857379688,
    "CMY_C": 0.9061416,
    "CMY_M": 0.3635677,
    "CMY_Y": 0.5798403,
    "CMYK_C": 0.8525242,
    "CMYK_M": 0,
    "CMYK_Y": 0.3398203,
    "CMYK_K": 0.3635677
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06526",
    "Farbtonhilfsbezeichnung": "L2.40.54",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "166",
    "Bcolor": "113",
    "Y": 30,
    "L": 61.4996449265191,
    "a": -40.271987916049,
    "b": 18.5964773630046,
    "C": 44.3583360939423,
    "h": -0.43260030491978,
    "CMY_C": 0.7215573,
    "CMY_M": 0.348864,
    "CMY_Y": 0.5562353,
    "CMYK_C": 0.572374,
    "CMYK_M": 0,
    "CMYK_Y": 0.3184761,
    "CMYK_K": 0.348864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06527",
    "Farbtonhilfsbezeichnung": "L2.26.65",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "189",
    "Bcolor": "148",
    "Y": 43,
    "L": 71.5320449677425,
    "a": -29.136842664894,
    "b": 13.858765769412,
    "C": 32.2648568744727,
    "h": -0.44397368999852,
    "CMY_C": 0.5103233,
    "CMY_M": 0.2579983,
    "CMY_Y": 0.4204475,
    "CMYK_C": 0.3400598,
    "CMYK_M": 0,
    "CMYK_Y": 0.2189336,
    "CMYK_K": 0.2579983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06528",
    "Farbtonhilfsbezeichnung": "L4.23.69",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "202",
    "Bcolor": "167",
    "Y": 51,
    "L": 76.5667110063853,
    "a": -26.9605891596884,
    "b": 10.9139209151179,
    "C": 29.0858563150366,
    "h": -0.38464619254563,
    "CMY_C": 0.448624,
    "CMY_M": 0.2063934,
    "CMY_Y": 0.346885,
    "CMYK_C": 0.3052275,
    "CMYK_M": 0,
    "CMYK_Y": 0.1770292,
    "CMYK_K": 0.2063934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06529",
    "Farbtonhilfsbezeichnung": "L2.16.72",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "208",
    "Bcolor": "177",
    "Y": 56,
    "L": 79.5812813757272,
    "a": -20.2622441985843,
    "b": 9.77676955185252,
    "C": 22.4976390502002,
    "h": -0.44955932899924,
    "CMY_C": 0.3591081,
    "CMY_M": 0.1857048,
    "CMY_Y": 0.3060544,
    "CMYK_C": 0.2129489,
    "CMYK_M": 0,
    "CMYK_Y": 0.147796,
    "CMYK_K": 0.1857048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06530",
    "Farbtonhilfsbezeichnung": "L7.10.77",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "220",
    "Bcolor": "202",
    "Y": 66,
    "L": 85.161427043158,
    "a": -14.0849355487881,
    "b": 4.41343459220158,
    "C": 14.7602105104621,
    "h": -0.30365388854574,
    "CMY_C": 0.2656506,
    "CMY_M": 0.135326,
    "CMY_Y": 0.2064123,
    "CMYK_C": 0.1507211,
    "CMYK_M": 0,
    "CMYK_Y": 0.08221174,
    "CMYK_K": 0.135326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06531",
    "Farbtonhilfsbezeichnung": "L4.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "227",
    "Bcolor": "208",
    "Y": 71,
    "L": 87.5908860782604,
    "a": -12.8221225057441,
    "b": 4.92819694174569,
    "C": 13.7365916678389,
    "h": -0.3669435896703,
    "CMY_C": 0.2265148,
    "CMY_M": 0.1111318,
    "CMY_Y": 0.1836575,
    "CMYK_C": 0.1298089,
    "CMYK_M": 0,
    "CMYK_Y": 0.08159338,
    "CMYK_K": 0.1111318
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06532",
    "Farbtonhilfsbezeichnung": "L3.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "213",
    "Bcolor": "202",
    "Y": 64,
    "L": 83.9751850091149,
    "a": -7.01477912095716,
    "b": 2.83392240485614,
    "C": 7.56559596545851,
    "h": -0.38394396297073,
    "CMY_C": 0.2249341,
    "CMY_M": 0.1631927,
    "CMY_Y": 0.2067472,
    "CMYK_C": 0.07378212,
    "CMYK_M": 0,
    "CMYK_Y": 0.05204841,
    "CMYK_K": 0.1631927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06533",
    "Farbtonhilfsbezeichnung": "L7.51.51",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "159",
    "Bcolor": "107",
    "Y": 26,
    "L": 57.8861720420724,
    "a": -49.3317525482743,
    "b": 16.8723167271652,
    "C": 52.1372887790106,
    "h": -0.32954572944206,
    "CMY_C": 1,
    "CMY_M": 0.3746201,
    "CMY_Y": 0.5805636,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3293094,
    "CMYK_K": 0.3746201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06535",
    "Farbtonhilfsbezeichnung": "L4.35.55",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "166",
    "Bcolor": "123",
    "Y": 31,
    "L": 62.1215918599725,
    "a": -34.2484835445675,
    "b": 13.8966940570038,
    "C": 36.9604752514964,
    "h": -0.38546274721726,
    "CMY_C": 0.6631333,
    "CMY_M": 0.3505206,
    "CMY_Y": 0.5162873,
    "CMYK_C": 0.4813282,
    "CMYK_M": 0,
    "CMYK_Y": 0.2552301,
    "CMYK_K": 0.3505206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06536",
    "Farbtonhilfsbezeichnung": "L7.29.61",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "182",
    "Bcolor": "147",
    "Y": 38,
    "L": 68.3638117033881,
    "a": -31.4840451688542,
    "b": 9.84712497831008,
    "C": 32.9880428418073,
    "h": -0.30312678258885,
    "CMY_C": 0.586386,
    "CMY_M": 0.2873955,
    "CMY_Y": 0.4246221,
    "CMYK_C": 0.4195742,
    "CMYK_M": 0,
    "CMYK_Y": 0.1925705,
    "CMYK_K": 0.2873955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06537",
    "Farbtonhilfsbezeichnung": "L4.11.67",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "190",
    "Bcolor": "169",
    "Y": 47,
    "L": 74.116367746029,
    "a": -14.012449857406,
    "b": 6.27488094539874,
    "C": 15.3532694200697,
    "h": -0.42102919404635,
    "CMY_C": 0.3755895,
    "CMY_M": 0.2566949,
    "CMY_Y": 0.3374903,
    "CMYK_C": 0.159954,
    "CMYK_M": 0,
    "CMYK_Y": 0.1086975,
    "CMYK_K": 0.2566949
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06538",
    "Farbtonhilfsbezeichnung": "L5.11.72",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "207",
    "Bcolor": "188",
    "Y": 57,
    "L": 80.4049153687073,
    "a": -14.8921663827356,
    "b": 5.17733001991676,
    "C": 15.7664633227053,
    "h": -0.33458384247937,
    "CMY_C": 0.3207243,
    "CMY_M": 0.1862829,
    "CMY_Y": 0.2632231,
    "CMYK_C": 0.1652189,
    "CMYK_M": 0,
    "CMYK_Y": 0.09455405,
    "CMYK_K": 0.1862829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06539",
    "Farbtonhilfsbezeichnung": "L4.05.70",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "195",
    "Bcolor": "184",
    "Y": 52,
    "L": 77.2076615042903,
    "a": -7.02079409642892,
    "b": 2.76580820929559,
    "C": 7.54594227350422,
    "h": -0.37527585814425,
    "CMY_C": 0.2979911,
    "CMY_M": 0.2369964,
    "CMY_Y": 0.2788551,
    "CMYK_C": 0.07994021,
    "CMYK_M": 0,
    "CMYK_Y": 0.05486037,
    "CMYK_K": 0.2369964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06540",
    "Farbtonhilfsbezeichnung": "L5.47.51",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "160",
    "Bcolor": "109",
    "Y": 27,
    "L": 58.5180730890773,
    "a": -44.8529370718989,
    "b": 16.9517635787284,
    "C": 47.9494343283091,
    "h": -0.36134657879388,
    "CMY_C": 0.8552339,
    "CMY_M": 0.3738608,
    "CMY_Y": 0.5744156,
    "CMYK_C": 0.7687957,
    "CMYK_M": 0,
    "CMYK_Y": 0.3203038,
    "CMYK_K": 0.3738608
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06541",
    "Farbtonhilfsbezeichnung": "L6.39.53",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "164",
    "Bcolor": "121",
    "Y": 29,
    "L": 60.8735433001009,
    "a": -37.5755873685709,
    "b": 13.4850540909649,
    "C": 39.9220672051104,
    "h": -0.34456201135387,
    "CMY_C": 0.7217252,
    "CMY_M": 0.3586143,
    "CMY_Y": 0.5261996,
    "CMYK_C": 0.566135,
    "CMYK_M": 0,
    "CMYK_Y": 0.2612863,
    "CMYK_K": 0.3586143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06542",
    "Farbtonhilfsbezeichnung": "L6.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "151",
    "Bcolor": "120",
    "Y": 25,
    "L": 57.5328024633872,
    "a": -28.3301494908569,
    "b": 9.47910632620323,
    "C": 29.8739154935835,
    "h": -0.32288498804574,
    "CMY_C": 0.6655782,
    "CMY_M": 0.4072917,
    "CMY_Y": 0.5303423,
    "CMYK_C": 0.4357734,
    "CMYK_M": 0,
    "CMYK_Y": 0.2076075,
    "CMYK_K": 0.4072917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06543",
    "Farbtonhilfsbezeichnung": "L5.25.59",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "174",
    "Bcolor": "142",
    "Y": 36,
    "L": 66.3205754451852,
    "a": -26.8783274217464,
    "b": 9.87129474474799,
    "C": 28.633668031328,
    "h": -0.3519664060828,
    "CMY_C": 0.5588675,
    "CMY_M": 0.3171114,
    "CMY_Y": 0.4450038,
    "CMYK_C": 0.3540198,
    "CMYK_M": 0,
    "CMYK_Y": 0.1872814,
    "CMYK_K": 0.3171114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06544",
    "Farbtonhilfsbezeichnung": "L3.18.63",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "181",
    "Bcolor": "152",
    "Y": 41,
    "L": 69.8991641712518,
    "a": -20.2690806030967,
    "b": 9.34700170636433,
    "C": 22.3204406182676,
    "h": -0.43208403374242,
    "CMY_C": 0.4620607,
    "CMY_M": 0.2905956,
    "CMY_Y": 0.4038949,
    "CMYK_C": 0.2417029,
    "CMYK_M": 0,
    "CMYK_Y": 0.1597104,
    "CMYK_K": 0.2905956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06545",
    "Farbtonhilfsbezeichnung": "L5.12.62",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "164",
    "Bcolor": "144",
    "Y": 33,
    "L": 64.4837280566039,
    "a": -14.1757871260357,
    "b": 5.88807620912593,
    "C": 15.3499961591902,
    "h": -0.39367851021829,
    "CMY_C": 0.477833,
    "CMY_M": 0.3587442,
    "CMY_Y": 0.4342272,
    "CMYK_C": 0.1857118,
    "CMYK_M": 0,
    "CMYK_Y": 0.1177112,
    "CMYK_K": 0.3587442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06546",
    "Farbtonhilfsbezeichnung": "L3.06.61",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "172",
    "Bcolor": "161",
    "Y": 39,
    "L": 68.9185364766362,
    "a": -7.25490635000947,
    "b": 3.19755833802617,
    "C": 7.92830659551511,
    "h": -0.41513024655862,
    "CMY_C": 0.3856256,
    "CMY_M": 0.3252656,
    "CMY_Y": 0.3690127,
    "CMYK_C": 0.08945736,
    "CMYK_M": 0,
    "CMYK_Y": 0.06483597,
    "CMYK_K": 0.3252656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06547",
    "Farbtonhilfsbezeichnung": "L2.49.45",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "143",
    "Bcolor": "90",
    "Y": 21,
    "L": 52.9570895984731,
    "a": -40.8656517232941,
    "b": 19.9795071422493,
    "C": 45.4882643812309,
    "h": -0.4547339702072,
    "CMY_C": 0.8226063,
    "CMY_M": 0.4383386,
    "CMY_Y": 0.6483578,
    "CMYK_C": 0.6841625,
    "CMYK_M": 0,
    "CMYK_Y": 0.3739249,
    "CMYK_K": 0.4383386
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06548",
    "Farbtonhilfsbezeichnung": "L6.46.45",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "143",
    "Bcolor": "101",
    "Y": 21,
    "L": 53.2406589265408,
    "a": -38.411025393134,
    "b": 13.8341933713984,
    "C": 40.8263613121378,
    "h": -0.34569902465474,
    "CMY_C": 0.822021,
    "CMY_M": 0.4377469,
    "CMY_Y": 0.603049,
    "CMYK_C": 0.683454,
    "CMYK_M": 0,
    "CMYK_Y": 0.2939995,
    "CMYK_K": 0.4377469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06549",
    "Farbtonhilfsbezeichnung": "L7.38.49",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "149",
    "Bcolor": "113",
    "Y": 24,
    "L": 55.9293265135685,
    "a": -34.6197420924566,
    "b": 10.7122791418019,
    "C": 36.2391979348343,
    "h": -0.30008272280601,
    "CMY_C": 0.7528483,
    "CMY_M": 0.414583,
    "CMY_Y": 0.5552598,
    "CMYK_C": 0.5778194,
    "CMYK_M": 0,
    "CMYK_Y": 0.2403019,
    "CMYK_K": 0.414583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06550",
    "Farbtonhilfsbezeichnung": "L6.26.53",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "157",
    "Bcolor": "129",
    "Y": 28,
    "L": 60.2973738324925,
    "a": -25.6699848172826,
    "b": 8.4218830022764,
    "C": 27.0162216792717,
    "h": -0.31701774279473,
    "CMY_C": 0.6146151,
    "CMY_M": 0.3825433,
    "CMY_Y": 0.4953609,
    "CMYK_C": 0.3758512,
    "CMYK_M": 0,
    "CMYK_Y": 0.1827134,
    "CMYK_K": 0.3825433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06551",
    "Farbtonhilfsbezeichnung": "L5.20.53",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "156",
    "Bcolor": "133",
    "Y": 29,
    "L": 60.7276710797859,
    "a": -19.3817610577638,
    "b": 6.97965711871718,
    "C": 20.600200853271,
    "h": -0.34565711951836,
    "CMY_C": 0.5565958,
    "CMY_M": 0.3886188,
    "CMY_Y": 0.4803506,
    "CMYK_C": 0.27475,
    "CMYK_M": 0,
    "CMYK_Y": 0.1500402,
    "CMYK_K": 0.3886188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06552",
    "Farbtonhilfsbezeichnung": "L3.13.57",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "163",
    "Bcolor": "144",
    "Y": 33,
    "L": 64.4518850754655,
    "a": -14.1585595694843,
    "b": 5.87842738528852,
    "C": 15.3303854356877,
    "h": -0.39352832195079,
    "CMY_C": 0.478048,
    "CMY_M": 0.3591092,
    "CMY_Y": 0.4344819,
    "CMYK_C": 0.1855835,
    "CMYK_M": 0,
    "CMYK_Y": 0.1176062,
    "CMYK_K": 0.3591092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06553",
    "Farbtonhilfsbezeichnung": "L5.04.53",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "149",
    "Bcolor": "143",
    "Y": 29,
    "L": 60.8836274936584,
    "a": -4.29918810034779,
    "b": 1.54820977046428,
    "C": 4.5694607795158,
    "h": -0.34565895746387,
    "CMY_C": 0.4509876,
    "CMY_M": 0.4148737,
    "CMY_Y": 0.4396764,
    "CMYK_C": 0.06171976,
    "CMYK_M": 0,
    "CMYK_Y": 0.04238859,
    "CMYK_K": 0.4148737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06554",
    "Farbtonhilfsbezeichnung": "L5.60.42",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "137",
    "Bcolor": "82",
    "Y": 18,
    "L": 49.6261357556341,
    "a": -49.7634884731712,
    "b": 19.461154419945,
    "C": 53.4335224028548,
    "h": -0.37278703795975,
    "CMY_C": 1,
    "CMY_M": 0.4617629,
    "CMY_Y": 0.6772783,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.4004098,
    "CMYK_K": 0.4617629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06555",
    "Farbtonhilfsbezeichnung": "L4.50.43",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "135",
    "Bcolor": "90",
    "Y": 18,
    "L": 49.8717607957116,
    "a": -39.2370359274949,
    "b": 15.7874669935753,
    "C": 42.2940788107361,
    "h": -0.38254037010022,
    "CMY_C": 0.8661849,
    "CMY_M": 0.4718516,
    "CMY_Y": 0.6484719,
    "CMYK_C": 0.7466336,
    "CMYK_M": 0,
    "CMYK_Y": 0.3344141,
    "CMYK_K": 0.4718516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06556",
    "Farbtonhilfsbezeichnung": "L6.44.44",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "138",
    "Bcolor": "98",
    "Y": 20,
    "L": 51.2975152482525,
    "a": -37.4851595580182,
    "b": 13.1865257883509,
    "C": 39.7369053834962,
    "h": -0.33825959810895,
    "CMY_C": 0.8350829,
    "CMY_M": 0.4590691,
    "CMY_Y": 0.6171083,
    "CMYK_C": 0.6951235,
    "CMYK_M": 0,
    "CMYK_Y": 0.2921616,
    "CMYK_K": 0.4590691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06557",
    "Farbtonhilfsbezeichnung": "L7.40.45",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "144",
    "Bcolor": "105",
    "Y": 22,
    "L": 53.7084276504112,
    "a": -35.9994600644069,
    "b": 12.4478363294531,
    "C": 38.0908093142385,
    "h": -0.33290900485963,
    "CMY_C": 0.7865973,
    "CMY_M": 0.4360361,
    "CMY_Y": 0.5888054,
    "CMYK_C": 0.6216022,
    "CMYK_M": 0,
    "CMYK_Y": 0.2708848,
    "CMYK_K": 0.4360361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06558",
    "Farbtonhilfsbezeichnung": "L6.35.40",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "126",
    "Bcolor": "96",
    "Y": 17,
    "L": 47.9849850123808,
    "a": -28.1084973782392,
    "b": 9.60593415434621,
    "C": 29.70457196864,
    "h": -0.32930171838112,
    "CMY_C": 0.7593893,
    "CMY_M": 0.505679,
    "CMY_Y": 0.6234646,
    "CMYK_C": 0.5132501,
    "CMYK_M": 0,
    "CMYK_Y": 0.2382776,
    "CMYK_K": 0.505679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06559",
    "Farbtonhilfsbezeichnung": "L4.28.50",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "150",
    "Bcolor": "119",
    "Y": 25,
    "L": 57.5270967204348,
    "a": -26.8675420701273,
    "b": 10.0859638884511,
    "C": 28.698283649884,
    "h": -0.35911767479188,
    "CMY_C": 0.6472682,
    "CMY_M": 0.409829,
    "CMY_Y": 0.5343679,
    "CMYK_C": 0.4023228,
    "CMYK_M": 0,
    "CMYK_Y": 0.2110218,
    "CMYK_K": 0.409829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06560",
    "Farbtonhilfsbezeichnung": "L7.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "145",
    "Bcolor": "125",
    "Y": 25,
    "L": 56.6666961818534,
    "a": -19.152113973174,
    "b": 5.44421181337538,
    "C": 19.9108742126091,
    "h": -0.27695615567613,
    "CMY_C": 0.6011868,
    "CMY_M": 0.4307577,
    "CMY_Y": 0.510309,
    "CMYK_C": 0.2993964,
    "CMYK_M": 0,
    "CMYK_Y": 0.1397496,
    "CMYK_K": 0.4307577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06561",
    "Farbtonhilfsbezeichnung": "L6.14.48",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "138",
    "Bcolor": "122",
    "Y": 23,
    "L": 55.0135975948974,
    "a": -13.5507288064649,
    "b": 4.50255191935147,
    "C": 14.2791885264119,
    "h": -0.32079665593701,
    "CMY_C": 0.5724648,
    "CMY_M": 0.4575115,
    "CMY_Y": 0.5196202,
    "CMYK_C": 0.2119001,
    "CMYK_M": 0,
    "CMYK_Y": 0.1144886,
    "CMYK_K": 0.4575115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06562",
    "Farbtonhilfsbezeichnung": "L6.57.38",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "81",
    "Y": 15,
    "L": 46.0634192963722,
    "a": -41.7674961559585,
    "b": 15.4930449027378,
    "C": 44.548380166918,
    "h": -0.35520247448653,
    "CMY_C": 1,
    "CMY_M": 0.5076661,
    "CMY_Y": 0.6823751,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3548589,
    "CMYK_K": 0.5076661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06563",
    "Farbtonhilfsbezeichnung": "L6.50.40",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "132",
    "Bcolor": "90",
    "Y": 17,
    "L": 48.8085959302287,
    "a": -40.4748307052955,
    "b": 13.873568321946,
    "C": 42.78653781981,
    "h": -0.33021961049983,
    "CMY_C": 0.9464895,
    "CMY_M": 0.4808694,
    "CMY_Y": 0.6456828,
    "CMYK_C": 0.8969229,
    "CMYK_M": 0,
    "CMYK_Y": 0.3174797,
    "CMYK_K": 0.4808694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06564",
    "Farbtonhilfsbezeichnung": "L3.45.40",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "128",
    "Bcolor": "88",
    "Y": 17,
    "L": 48.0574404202602,
    "a": -33.8491281160113,
    "b": 14.2816995578975,
    "C": 36.738677391493,
    "h": -0.39926086149302,
    "CMY_C": 0.8063954,
    "CMY_M": 0.4975233,
    "CMY_Y": 0.654668,
    "CMYK_C": 0.6146993,
    "CMYK_M": 0,
    "CMYK_Y": 0.3127402,
    "CMYK_K": 0.4975233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06565",
    "Farbtonhilfsbezeichnung": "L7.41.40",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "128",
    "Bcolor": "94",
    "Y": 17,
    "L": 48.0470539474321,
    "a": -33.4217460227872,
    "b": 11.0156083827296,
    "C": 35.1902931964676,
    "h": -0.3183814260338,
    "CMY_C": 0.8218546,
    "CMY_M": 0.4976632,
    "CMY_Y": 0.6328762,
    "CMYK_C": 0.6453666,
    "CMYK_M": 0,
    "CMYK_Y": 0.269168,
    "CMYK_K": 0.4976632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06566",
    "Farbtonhilfsbezeichnung": "L7.31.39",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "122",
    "Bcolor": "98",
    "Y": 16,
    "L": 47.1602494138454,
    "a": -23.7765888023865,
    "b": 7.10313082055809,
    "C": 24.8149278163716,
    "h": -0.29030478156105,
    "CMY_C": 0.7320775,
    "CMY_M": 0.5200675,
    "CMY_Y": 0.6142587,
    "CMYK_C": 0.4417497,
    "CMYK_M": 0,
    "CMYK_Y": 0.1962593,
    "CMYK_K": 0.5200675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06567",
    "Farbtonhilfsbezeichnung": "L5.24.44",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "133",
    "Bcolor": "110",
    "Y": 20,
    "L": 52.1127979751316,
    "a": -19.7011413578951,
    "b": 7.3530772401136,
    "C": 21.0286165903238,
    "h": -0.35721888939509,
    "CMY_C": 0.6431926,
    "CMY_M": 0.4767647,
    "CMY_Y": 0.5678697,
    "CMYK_C": 0.3180749,
    "CMYK_M": 0,
    "CMYK_Y": 0.1741185,
    "CMYK_K": 0.4767647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06568",
    "Farbtonhilfsbezeichnung": "L5.17.40",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "123",
    "Bcolor": "107",
    "Y": 17,
    "L": 48.7652943582426,
    "a": -14.4476879813236,
    "b": 4.66992664574839,
    "C": 15.1836722462767,
    "h": -0.31263019141251,
    "CMY_C": 0.6401024,
    "CMY_M": 0.5189019,
    "CMY_Y": 0.5817961,
    "CMYK_C": 0.2519248,
    "CMYK_M": 0,
    "CMYK_Y": 0.1307303,
    "CMYK_K": 0.5189019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06569",
    "Farbtonhilfsbezeichnung": "L7.10.43",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "124",
    "Bcolor": "115",
    "Y": 19,
    "L": 50.3943744599699,
    "a": -9.10917393566185,
    "b": 2.19198933735512,
    "C": 9.36919778023817,
    "h": -0.23614564923214,
    "CMY_C": 0.5900919,
    "CMY_M": 0.5118031,
    "CMY_Y": 0.5490427,
    "CMYK_C": 0.1603632,
    "CMYK_M": 0,
    "CMYK_Y": 0.07627986,
    "CMYK_K": 0.5118031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06570",
    "Farbtonhilfsbezeichnung": "L5.63.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "71",
    "Y": 13,
    "L": 42.3980626725629,
    "a": -42.8413179600324,
    "b": 16.5539516378149,
    "C": 45.9283337318013,
    "h": -0.36872889083343,
    "CMY_C": 1,
    "CMY_M": 0.5438376,
    "CMY_Y": 0.7232503,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3933087,
    "CMYK_K": 0.5438376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06571",
    "Farbtonhilfsbezeichnung": "L6.50.32",
    "Farbtonklasse": "03",
    "Rcolor": "25",
    "Gcolor": "111",
    "Bcolor": "76",
    "Y": 12,
    "L": 41.2448074450857,
    "a": -33.6212366898656,
    "b": 12.1948642566612,
    "C": 35.7645392923544,
    "h": -0.3479553580807,
    "CMY_C": 0.9007414,
    "CMY_M": 0.5660732,
    "CMY_Y": 0.7038609,
    "CMYK_C": 0.771255,
    "CMYK_M": 0,
    "CMYK_Y": 0.3175367,
    "CMYK_K": 0.5660732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06572",
    "Farbtonhilfsbezeichnung": "L4.44.35",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "116",
    "Bcolor": "81",
    "Y": 14,
    "L": 43.6794576109088,
    "a": -30.8624749659896,
    "b": 12.4484290650855,
    "C": 33.2784577048697,
    "h": -0.38339235541281,
    "CMY_C": 0.8232027,
    "CMY_M": 0.5455166,
    "CMY_Y": 0.682842,
    "CMYK_C": 0.6109928,
    "CMYK_M": 0,
    "CMYK_Y": 0.3021572,
    "CMYK_K": 0.5455166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06573",
    "Farbtonhilfsbezeichnung": "L5.35.33",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "108",
    "Bcolor": "83",
    "Y": 12,
    "L": 41.6018634827759,
    "a": -23.8397308929579,
    "b": 8.56036869867985,
    "C": 25.3300746407505,
    "h": -0.34474082480775,
    "CMY_C": 0.7799595,
    "CMY_M": 0.5754231,
    "CMY_Y": 0.6758536,
    "CMYK_C": 0.4817418,
    "CMYK_M": 0,
    "CMYK_Y": 0.2365426,
    "CMYK_K": 0.5754231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06574",
    "Farbtonhilfsbezeichnung": "L7.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "100",
    "Bcolor": "81",
    "Y": 11,
    "L": 39.1388543039402,
    "a": -19.1933289577568,
    "b": 6.07692324712271,
    "C": 20.132383679835,
    "h": -0.30663065833467,
    "CMY_C": 0.7676653,
    "CMY_M": 0.6059377,
    "CMY_Y": 0.6821128,
    "CMYK_C": 0.4104113,
    "CMYK_M": 0,
    "CMYK_Y": 0.1933073,
    "CMYK_K": 0.6059377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06575",
    "Farbtonhilfsbezeichnung": "L6.27.35",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "112",
    "Bcolor": "90",
    "Y": 14,
    "L": 43.854793763815,
    "a": -19.318079772519,
    "b": 7.2526023768926,
    "C": 20.6346419240731,
    "h": -0.35914831502927,
    "CMY_C": 0.7195116,
    "CMY_M": 0.5599464,
    "CMY_Y": 0.6459031,
    "CMYK_C": 0.362604,
    "CMYK_M": 0,
    "CMYK_Y": 0.1953323,
    "CMYK_K": 0.5599464
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06576",
    "Farbtonhilfsbezeichnung": "L5.20.31",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "98",
    "Bcolor": "84",
    "Y": 11,
    "L": 39.0139676434919,
    "a": -13.2496546257108,
    "b": 4.09899941319878,
    "C": 13.8692156912359,
    "h": -0.30002761765051,
    "CMY_C": 0.7241388,
    "CMY_M": 0.6162172,
    "CMY_Y": 0.6700587,
    "CMYK_C": 0.2812049,
    "CMYK_M": 0,
    "CMYK_Y": 0.1402917,
    "CMYK_K": 0.6162172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06577",
    "Farbtonhilfsbezeichnung": "L3.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "107",
    "Bcolor": "93",
    "Y": 13,
    "L": 43.2511280797823,
    "a": -11.2730011312227,
    "b": 4.64700458864776,
    "C": 12.1932442832685,
    "h": -0.39099991546352,
    "CMY_C": 0.6668756,
    "CMY_M": 0.5787929,
    "CMY_Y": 0.6337878,
    "CMYK_C": 0.2091198,
    "CMYK_M": 0,
    "CMYK_Y": 0.1305651,
    "CMYK_K": 0.5787929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06578",
    "Farbtonhilfsbezeichnung": "L5.64.32",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "115",
    "Bcolor": "69",
    "Y": 12,
    "L": 41.8017576852321,
    "a": -43.8419920919821,
    "b": 16.802722877819,
    "C": 46.9515896078312,
    "h": -0.36598941387731,
    "CMY_C": 1,
    "CMY_M": 0.548755,
    "CMY_Y": 0.7304448,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.4026413,
    "CMYK_K": 0.548755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06579",
    "Farbtonhilfsbezeichnung": "L7.58.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "68",
    "Y": 10,
    "L": 37.8594104380888,
    "a": -36.3354787768408,
    "b": 11.8254064685568,
    "C": 38.2113498333785,
    "h": -0.31463947450497,
    "CMY_C": 1,
    "CMY_M": 0.5962052,
    "CMY_Y": 0.7324258,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.337351,
    "CMYK_K": 0.5962052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06580",
    "Farbtonhilfsbezeichnung": "L6.54.31",
    "Farbtonklasse": "03",
    "Rcolor": "3",
    "Gcolor": "107",
    "Bcolor": "73",
    "Y": 11,
    "L": 39.6426090052751,
    "a": -35.1860403603706,
    "b": 11.6317239841821,
    "C": 37.0587970539496,
    "h": -0.31926853208173,
    "CMY_C": 0.9877281,
    "CMY_M": 0.5799209,
    "CMY_Y": 0.714954,
    "CMYK_C": 0.9707866,
    "CMYK_M": 0,
    "CMYK_Y": 0.3214469,
    "CMYK_K": 0.5799209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06581",
    "Farbtonhilfsbezeichnung": "L6.40.31",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "104",
    "Bcolor": "79",
    "Y": 11,
    "L": 39.8022490320941,
    "a": -25.6318500858987,
    "b": 8.40521266531677,
    "C": 26.9747908013239,
    "h": -0.31687124531816,
    "CMY_C": 0.8188834,
    "CMY_M": 0.590455,
    "CMY_Y": 0.6916144,
    "CMYK_C": 0.5577613,
    "CMYK_M": 0,
    "CMYK_Y": 0.2470045,
    "CMYK_K": 0.590455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06582",
    "Farbtonhilfsbezeichnung": "L6.39.23",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "86",
    "Bcolor": "64",
    "Y": 8,
    "L": 32.950411306572,
    "a": -21.4494697888511,
    "b": 7.61655111426179,
    "C": 22.7616257130065,
    "h": -0.34120456233378,
    "CMY_C": 0.8415828,
    "CMY_M": 0.6620933,
    "CMY_Y": 0.7478991,
    "CMYK_C": 0.5311808,
    "CMYK_M": 0,
    "CMYK_Y": 0.2539332,
    "CMYK_K": 0.6620933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06583",
    "Farbtonhilfsbezeichnung": "L7.26.25",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "88",
    "Bcolor": "74",
    "Y": 8,
    "L": 34.8467060230825,
    "a": -14.13370283272,
    "b": 4.35083743638165,
    "C": 14.7882163279233,
    "h": -0.29862856840243,
    "CMY_C": 0.7686797,
    "CMY_M": 0.6544474,
    "CMY_Y": 0.7098525,
    "CMYK_C": 0.3305784,
    "CMYK_M": 0,
    "CMYK_Y": 0.1603376,
    "CMYK_K": 0.6544474
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06584",
    "Farbtonhilfsbezeichnung": "L4.13.24",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "85",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.5520697908735,
    "a": -7.87159141601129,
    "b": 2.41943302990851,
    "C": 8.23502323049759,
    "h": -0.29819773749688,
    "CMY_C": 0.7287735,
    "CMY_M": 0.6671887,
    "CMY_Y": 0.6998783,
    "CMYK_C": 0.1850442,
    "CMYK_M": 0,
    "CMYK_Y": 0.09822282,
    "CMYK_K": 0.6671887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06585",
    "Farbtonhilfsbezeichnung": "L6.05.34",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "102",
    "Bcolor": "98",
    "Y": 13,
    "L": 42.5677607625827,
    "a": -3.70153827186731,
    "b": 0.76879498036508,
    "C": 3.78053320312532,
    "h": -0.20478456400843,
    "CMY_C": 0.6294553,
    "CMY_M": 0.5985119,
    "CMY_Y": 0.6145222,
    "CMYK_C": 0.07707164,
    "CMYK_M": 0,
    "CMYK_Y": 0.03987713,
    "CMYK_K": 0.5985119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06586",
    "Farbtonhilfsbezeichnung": "L7.53.22",
    "Farbtonklasse": "03",
    "Rcolor": "13",
    "Gcolor": "86",
    "Bcolor": "60",
    "Y": 7,
    "L": 32.0126331271182,
    "a": -28.2735663643309,
    "b": 8.86165516909997,
    "C": 29.6297736625553,
    "h": -0.30372775773176,
    "CMY_C": 0.9471234,
    "CMY_M": 0.6622575,
    "CMY_Y": 0.7646514,
    "CMYK_C": 0.8434411,
    "CMYK_M": 0,
    "CMYK_Y": 0.3031714,
    "CMYK_K": 0.6622575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06587",
    "Farbtonhilfsbezeichnung": "L7.50.30",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "108",
    "Bcolor": "77",
    "Y": 11,
    "L": 40.8075408935547,
    "a": -30.2377777099609,
    "b": 10.721209526062,
    "C": 32.0821990966797,
    "h": 160.477355957031,
    "CMY_C": 0.85682022571564,
    "CMY_M": 0.57462775707245,
    "CMY_Y": 0.69787329435349,
    "CMYK_C": 0.66340124607086,
    "CMYK_M": 0,
    "CMYK_Y": 0.28973573446274,
    "CMYK_K": 0.57462775707245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06588",
    "Farbtonhilfsbezeichnung": "L5.45.28",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "96",
    "Bcolor": "68",
    "Y": 9,
    "L": 35.9838728128584,
    "a": -27.3862278107832,
    "b": 9.77078803558608,
    "C": 29.0770317009915,
    "h": -0.34269981562383,
    "CMY_C": 0.8736579,
    "CMY_M": 0.6254276,
    "CMY_Y": 0.735082,
    "CMYK_C": 0.6627033,
    "CMYK_M": 0,
    "CMYK_Y": 0.2927455,
    "CMYK_K": 0.6254276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06589",
    "Farbtonhilfsbezeichnung": "L4.29.20",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "75",
    "Bcolor": "58",
    "Y": 6,
    "L": 28.9734383719339,
    "a": -15.23584146162,
    "b": 6.07208778647218,
    "C": 16.401253462167,
    "h": -0.37924686996458,
    "CMY_C": 0.8241683,
    "CMY_M": 0.7077325,
    "CMY_Y": 0.7726566,
    "CMYK_C": 0.3983878,
    "CMYK_M": 0,
    "CMYK_Y": 0.2221393,
    "CMYK_K": 0.7077325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06590",
    "Farbtonhilfsbezeichnung": "L5.27.13",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "67",
    "Bcolor": "58",
    "Y": 5,
    "L": 26.7784471610462,
    "a": -9.26782344013677,
    "b": 2.73868949226124,
    "C": 9.66400390379529,
    "h": -0.28732798820451,
    "CMY_C": 0.8070317,
    "CMY_M": 0.7361421,
    "CMY_Y": 0.7711459,
    "CMYK_C": 0.2686658,
    "CMYK_M": 0,
    "CMYK_Y": 0.1326616,
    "CMYK_K": 0.7361421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06591",
    "Farbtonhilfsbezeichnung": "L2.18.16",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "76",
    "Bcolor": "69",
    "Y": 4,
    "L": 31.1209716796875,
    "a": -6.19717407226563,
    "b": 2.5252697467804,
    "C": 6.6919322013855,
    "h": 157.829727172852,
    "CMY_C": 0.74719887971878,
    "CMY_M": 0.70182013511658,
    "CMY_Y": 0.73125445842743,
    "CMYK_C": 0.15218581259251,
    "CMYK_M": 0,
    "CMYK_Y": 0.09871331602335,
    "CMYK_K": 0.70182013511658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06592",
    "Farbtonhilfsbezeichnung": "L1.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "64",
    "Bcolor": "62",
    "Y": 5,
    "L": 26.5761409844706,
    "a": -2.27383140428025,
    "b": 0.29354876904363,
    "C": 2.29270149275874,
    "h": -0.12838862022138,
    "CMY_C": 0.7673794,
    "CMY_M": 0.7492727,
    "CMY_Y": 0.7577218,
    "CMYK_C": 0.07221678,
    "CMYK_M": 0,
    "CMYK_Y": 0.03369834,
    "CMYK_K": 0.7492727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06593",
    "Farbtonhilfsbezeichnung": "M2.31.69",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "208",
    "Bcolor": "175",
    "Y": 51,
    "L": 76.856175459312,
    "a": -37.1580071455093,
    "b": 6.60248281829214,
    "C": 37.7400354317741,
    "h": -0.17585131443453,
    "CMY_C": 0.5815517,
    "CMY_M": 0.1844485,
    "CMY_Y": 0.3140057,
    "CMYK_C": 0.4869137,
    "CMYK_M": 0,
    "CMYK_Y": 0.1588583,
    "CMYK_K": 0.1844485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06594",
    "Farbtonhilfsbezeichnung": "M1.24.70",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "206",
    "Bcolor": "177",
    "Y": 52,
    "L": 77.3078159980601,
    "a": -29.8466102089891,
    "b": 6.00203289338579,
    "C": 30.4441215971264,
    "h": -0.19844915027076,
    "CMY_C": 0.4932535,
    "CMY_M": 0.1919451,
    "CMY_Y": 0.3040102,
    "CMYK_C": 0.3728811,
    "CMYK_M": 0,
    "CMYK_Y": 0.1386849,
    "CMYK_K": 0.1919451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06596",
    "Farbtonhilfsbezeichnung": "L8.10.84",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "239",
    "Bcolor": "219",
    "Y": 79,
    "L": 91.2788823629566,
    "a": -15.2844219065761,
    "b": 4.56340339519741,
    "C": 15.9511191947626,
    "h": -0.29014036013995,
    "CMY_C": 0.209058,
    "CMY_M": 0.06452207,
    "CMY_Y": 0.1409674,
    "CMYK_C": 0.1545049,
    "CMYK_M": 0,
    "CMYK_Y": 0.08171799,
    "CMYK_K": 0.06452207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06597",
    "Farbtonhilfsbezeichnung": "M3.06.85",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "239",
    "Bcolor": "229",
    "Y": 82,
    "L": 92.6767989605299,
    "a": -9.15667668444431,
    "b": 1.4619492151781,
    "C": 9.2726492121295,
    "h": -0.15832311535676,
    "CMY_C": 0.1525453,
    "CMY_M": 0.06126275,
    "CMY_Y": 0.101633,
    "CMYK_C": 0.09723968,
    "CMYK_M": 0,
    "CMYK_Y": 0.0430049,
    "CMYK_K": 0.06126275
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06598",
    "Farbtonhilfsbezeichnung": "M0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "238",
    "Bcolor": "230",
    "Y": 82,
    "L": 92.6055108551591,
    "a": -6.2028347777171,
    "b": 1.02328385353814,
    "C": 6.28667393178369,
    "h": -0.16349775910379,
    "CMY_C": 0.1301286,
    "CMY_M": 0.06858222,
    "CMY_Y": 0.09875619,
    "CMYK_C": 0.06607816,
    "CMYK_M": 0,
    "CMYK_Y": 0.03239573,
    "CMYK_K": 0.06858222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06599",
    "Farbtonhilfsbezeichnung": "Z0.39.35",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "72",
    "Bcolor": "122",
    "Y": 14,
    "L": 44.2703588170837,
    "a": 43.9547839564058,
    "b": -10.5754917303828,
    "C": 45.2091147667559,
    "h": -0.23611159577195,
    "CMY_C": 0.3556371,
    "CMY_M": 0.7161795,
    "CMY_Y": 0.5200028,
    "CMYK_C": 0,
    "CMYK_M": 0.5595332,
    "CMYK_Y": 0.2550825,
    "CMYK_K": 0.3556371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06600",
    "Farbtonhilfsbezeichnung": "M1.37.63",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "191",
    "Bcolor": "152",
    "Y": 41,
    "L": 70.2484125546879,
    "a": -42.61320515561,
    "b": 9.38108459987597,
    "C": 43.6335880017233,
    "h": -0.21668861908734,
    "CMY_C": 0.7198984,
    "CMY_M": 0.249038,
    "CMY_Y": 0.4033681,
    "CMYK_C": 0.6270096,
    "CMYK_M": 0,
    "CMYK_Y": 0.2055099,
    "CMYK_K": 0.249038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06601",
    "Farbtonhilfsbezeichnung": "M1.32.65",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "196",
    "Bcolor": "162",
    "Y": 44,
    "L": 72.4242299766783,
    "a": -37.4176418537729,
    "b": 7.12487481770219,
    "C": 38.0899430698596,
    "h": -0.18816231579198,
    "CMY_C": 0.631309,
    "CMY_M": 0.2329284,
    "CMY_Y": 0.3641691,
    "CMYK_C": 0.5193526,
    "CMYK_M": 0,
    "CMYK_Y": 0.1710932,
    "CMYK_K": 0.2329284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06602",
    "Farbtonhilfsbezeichnung": "M2.21.73",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "214",
    "Bcolor": "189",
    "Y": 57,
    "L": 80.3823569345005,
    "a": -27.0743388518679,
    "b": 4.54331719743171,
    "C": 27.4528970315018,
    "h": -0.16625991149032,
    "CMY_C": 0.4383367,
    "CMY_M": 0.1626979,
    "CMY_Y": 0.2604389,
    "CMYK_C": 0.3291988,
    "CMYK_M": 0,
    "CMYK_Y": 0.1167333,
    "CMYK_K": 0.1626979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06603",
    "Farbtonhilfsbezeichnung": "L8.15.79",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "227",
    "Bcolor": "203",
    "Y": 69,
    "L": 86.4904216675762,
    "a": -20.108988932629,
    "b": 5.72347596954896,
    "C": 20.907644847438,
    "h": -0.27729022366613,
    "CMY_C": 0.2998811,
    "CMY_M": 0.1085337,
    "CMY_Y": 0.2024525,
    "CMYK_C": 0.2146434,
    "CMYK_M": 0,
    "CMYK_Y": 0.1053532,
    "CMYK_K": 0.1085337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06604",
    "Farbtonhilfsbezeichnung": "M3.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "234",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.39983394906,
    "a": -11.7832125536222,
    "b": 1.9669496307533,
    "C": 11.9462541800249,
    "h": -0.16540306286689,
    "CMY_C": 0.1981935,
    "CMY_M": 0.0811978,
    "CMY_Y": 0.1308832,
    "CMYK_C": 0.127335,
    "CMYK_M": 0,
    "CMYK_Y": 0.05407624,
    "CMYK_K": 0.0811978
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06605",
    "Farbtonhilfsbezeichnung": "M3.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "230",
    "Bcolor": "224",
    "Y": 77,
    "L": 90.2197744873859,
    "a": -5.05549735101768,
    "b": 0.71073819457288,
    "C": 5.10521324210571,
    "h": -0.13967180272361,
    "CMY_C": 0.1481778,
    "CMY_M": 0.09780622,
    "CMY_Y": 0.1226576,
    "CMYK_C": 0.05583231,
    "CMYK_M": 0,
    "CMYK_Y": 0.02754555,
    "CMYK_K": 0.09780622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06606",
    "Farbtonhilfsbezeichnung": "M0.40.61",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "187",
    "Bcolor": "146",
    "Y": 39,
    "L": 68.5253334825643,
    "a": -43.0892109627933,
    "b": 10.3229445329733,
    "C": 44.3085012748903,
    "h": -0.23513972666618,
    "CMY_C": 0.7421613,
    "CMY_M": 0.2673352,
    "CMY_Y": 0.4277686,
    "CMYK_C": 0.6480811,
    "CMYK_M": 0,
    "CMYK_Y": 0.2189725,
    "CMYK_K": 0.2673352
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06607",
    "Farbtonhilfsbezeichnung": "M2.32.63",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "189",
    "Bcolor": "157",
    "Y": 41,
    "L": 70.1162097825936,
    "a": -35.9916132770635,
    "b": 6.39470664798403,
    "C": 36.5552800481608,
    "h": -0.17583721398545,
    "CMY_C": 0.6425842,
    "CMY_M": 0.260269,
    "CMY_Y": 0.382721,
    "CMYK_C": 0.5168301,
    "CMYK_M": 0,
    "CMYK_Y": 0.1655358,
    "CMYK_K": 0.260269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06608",
    "Farbtonhilfsbezeichnung": "M3.18.72",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "210",
    "Bcolor": "188",
    "Y": 56,
    "L": 79.5432519064575,
    "a": -23.5503261801998,
    "b": 3.43574382357694,
    "C": 23.7996260225881,
    "h": -0.1448674329687,
    "CMY_C": 0.4168869,
    "CMY_M": 0.1782825,
    "CMY_Y": 0.2609287,
    "CMYK_C": 0.2903728,
    "CMYK_M": 0,
    "CMYK_Y": 0.1005774,
    "CMYK_K": 0.1782825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06609",
    "Farbtonhilfsbezeichnung": "M2.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "224",
    "Bcolor": "208",
    "Y": 68,
    "L": 86.2306309438535,
    "a": -14.7764849284862,
    "b": 2.78671655737661,
    "C": 15.0369643217285,
    "h": -0.18640198185003,
    "CMY_C": 0.2665089,
    "CMY_M": 0.1215885,
    "CMY_Y": 0.1829645,
    "CMYK_C": 0.16498,
    "CMYK_M": 0,
    "CMYK_Y": 0.06987161,
    "CMYK_K": 0.1215885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06610",
    "Farbtonhilfsbezeichnung": "M0.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "220",
    "Bcolor": "210",
    "Y": 68,
    "L": 86.1991034456536,
    "a": -7.90971435394411,
    "b": 1.90626747742157,
    "C": 8.13618072909302,
    "h": -0.23649344765156,
    "CMY_C": 0.2114629,
    "CMY_M": 0.1364267,
    "CMY_Y": 0.1759309,
    "CMYK_C": 0.0868904,
    "CMYK_M": 0,
    "CMYK_Y": 0.04574512,
    "CMYK_K": 0.1364267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06611",
    "Farbtonhilfsbezeichnung": "L8.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "234",
    "Bcolor": "226",
    "Y": 80,
    "L": 91.7672089681045,
    "a": -4.87116814590299,
    "b": 1.58864046892018,
    "C": 5.12367618465013,
    "h": -0.31525479352963,
    "CMY_C": 0.1263835,
    "CMY_M": 0.08117729,
    "CMY_Y": 0.1120545,
    "CMYK_C": 0.04920014,
    "CMYK_M": 0,
    "CMYK_Y": 0.03360519,
    "CMYK_K": 0.08117729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06612",
    "Farbtonhilfsbezeichnung": "MN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "223",
    "Bcolor": "220",
    "Y": 73,
    "L": 88.5173202545843,
    "a": -1.86601011401355,
    "b": 0.19645826493224,
    "C": 1.87632342506857,
    "h": -0.10489609803513,
    "CMY_C": 0.142955,
    "CMY_M": 0.1239411,
    "CMY_Y": 0.1371733,
    "CMYK_C": 0.02170393,
    "CMYK_M": 0,
    "CMYK_Y": 0.01510422,
    "CMYK_K": 0.1239411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06613",
    "Farbtonhilfsbezeichnung": "M3.45.53",
    "Farbtonklasse": "03",
    "Rcolor": "13",
    "Gcolor": "167",
    "Bcolor": "132",
    "Y": 29,
    "L": 60.9979267704409,
    "a": -43.9863991436474,
    "b": 7.05243594327376,
    "C": 44.5481779914538,
    "h": -0.15897914887937,
    "CMY_C": 0.9477364,
    "CMY_M": 0.3467416,
    "CMY_Y": 0.4810305,
    "CMYK_C": 0.9199955,
    "CMYK_M": 0,
    "CMYK_Y": 0.2055679,
    "CMYK_K": 0.3467416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06614",
    "Farbtonhilfsbezeichnung": "M2.27.59",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "176",
    "Bcolor": "150",
    "Y": 36,
    "L": 66.4237842444468,
    "a": -29.9054935289289,
    "b": 5.01547848806287,
    "C": 30.3231523373318,
    "h": -0.16616455662365,
    "CMY_C": 0.6146058,
    "CMY_M": 0.3098188,
    "CMY_Y": 0.4102813,
    "CMYK_C": 0.4416043,
    "CMYK_M": 0,
    "CMYK_Y": 0.1455596,
    "CMYK_K": 0.3098188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06615",
    "Farbtonhilfsbezeichnung": "M2.25.63",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "187",
    "Bcolor": "163",
    "Y": 42,
    "L": 70.8343945811048,
    "a": -28.2836211694937,
    "b": 4.5049075821455,
    "C": 28.6401365007764,
    "h": -0.157949445239,
    "CMY_C": 0.5525786,
    "CMY_M": 0.2649946,
    "CMY_Y": 0.3609642,
    "CMYK_C": 0.3912679,
    "CMYK_M": 0,
    "CMYK_Y": 0.13057,
    "CMYK_K": 0.2649946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06616",
    "Farbtonhilfsbezeichnung": "M6.19.68",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 48,
    "L": 74.8160212064302,
    "a": -23.5012784644226,
    "b": 1.78188247790838,
    "C": 23.5687334116072,
    "h": -0.07567586862732,
    "CMY_C": 0.4742028,
    "CMY_M": 0.2297225,
    "CMY_Y": 0.2992613,
    "CMYK_C": 0.3173925,
    "CMYK_M": 0,
    "CMYK_Y": 0.09027757,
    "CMYK_K": 0.2297225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06617",
    "Farbtonhilfsbezeichnung": "L8.11.76",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "216",
    "Bcolor": "198",
    "Y": 63,
    "L": 83.443712684453,
    "a": -15.1924825950957,
    "b": 4.20026301669918,
    "C": 15.7624153229046,
    "h": -0.26973218210234,
    "CMY_C": 0.2946096,
    "CMY_M": 0.1519791,
    "CMY_Y": 0.2235559,
    "CMYK_C": 0.1681923,
    "CMYK_M": 0,
    "CMYK_Y": 0.08440462,
    "CMYK_K": 0.1519791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06618",
    "Farbtonhilfsbezeichnung": "M3.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "220",
    "Bcolor": "208",
    "Y": 67,
    "L": 85.4394055970162,
    "a": -11.1405636915208,
    "b": 1.80227070673569,
    "C": 11.2854038060315,
    "h": -0.16038600176797,
    "CMY_C": 0.2473121,
    "CMY_M": 0.1377924,
    "CMY_Y": 0.1838724,
    "CMYK_C": 0.1270224,
    "CMYK_M": 0,
    "CMYK_Y": 0.05344414,
    "CMYK_K": 0.1377924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06619",
    "Farbtonhilfsbezeichnung": "M2.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "226",
    "Bcolor": "220",
    "Y": 74,
    "L": 88.7335173466308,
    "a": -5.78233686666779,
    "b": 0.67643313463843,
    "C": 5.82176789517259,
    "h": -0.11645336337543,
    "CMY_C": 0.1706497,
    "CMY_M": 0.1127071,
    "CMY_Y": 0.1388642,
    "CMYK_C": 0.06530266,
    "CMYK_M": 0,
    "CMYK_Y": 0.02947958,
    "CMYK_K": 0.1127071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06620",
    "Farbtonhilfsbezeichnung": "MN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 71,
    "L": 87.6696834108421,
    "a": -3.58263794941716,
    "b": 0.22762780823615,
    "C": 3.58986198838985,
    "h": -0.06345107987581,
    "CMY_C": 0.1659956,
    "CMY_M": 0.1293898,
    "CMY_Y": 0.1469438,
    "CMYK_C": 0.04204611,
    "CMYK_M": 0,
    "CMYK_Y": 0.02016285,
    "CMYK_K": 0.1293898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06621",
    "Farbtonhilfsbezeichnung": "M1.51.49",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "159",
    "Bcolor": "120",
    "Y": 26,
    "L": 57.7661523303732,
    "a": -46.4651591735518,
    "b": 9.6259442023328,
    "C": 47.4517630737776,
    "h": -0.20427517797862,
    "CMY_C": 1,
    "CMY_M": 0.3783824,
    "CMY_Y": 0.5311627,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2457787,
    "CMYK_K": 0.3783824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06622",
    "Farbtonhilfsbezeichnung": "M1.36.55",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "168",
    "Bcolor": "136",
    "Y": 31,
    "L": 62.3686938323347,
    "a": -37.9329298103318,
    "b": 7.16499415518197,
    "C": 38.6036825346929,
    "h": -0.18668640844842,
    "CMY_C": 0.7556887,
    "CMY_M": 0.3409051,
    "CMY_Y": 0.4673789,
    "CMYK_C": 0.629323,
    "CMYK_M": 0,
    "CMYK_Y": 0.1918901,
    "CMYK_K": 0.3409051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06623",
    "Farbtonhilfsbezeichnung": "M0.30.60",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "179",
    "Bcolor": "147",
    "Y": 37,
    "L": 66.9219791369794,
    "a": -33.2412854008919,
    "b": 7.56847143335315,
    "C": 34.0920051469701,
    "h": -0.22386656963324,
    "CMY_C": 0.6346473,
    "CMY_M": 0.2995363,
    "CMY_Y": 0.4234951,
    "CMYK_C": 0.478413,
    "CMYK_M": 0,
    "CMYK_Y": 0.1769667,
    "CMYK_K": 0.2995363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06624",
    "Farbtonhilfsbezeichnung": "M0.19.63",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "185",
    "Bcolor": "164",
    "Y": 42,
    "L": 70.9851498054031,
    "a": -22.7168223308022,
    "b": 4.39507017904226,
    "C": 23.1380781113718,
    "h": -0.19111087756931,
    "CMY_C": 0.4941464,
    "CMY_M": 0.2732763,
    "CMY_Y": 0.3579409,
    "CMYK_C": 0.3039258,
    "CMYK_M": 0,
    "CMYK_Y": 0.1165017,
    "CMYK_K": 0.2732763
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06625",
    "Farbtonhilfsbezeichnung": "L9.16.73",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "213",
    "Bcolor": "189",
    "Y": 59,
    "L": 81.2461181507119,
    "a": -21.289529630116,
    "b": 5.71179790820759,
    "C": 22.0424297030929,
    "h": -0.26211865317721,
    "CMY_C": 0.3670492,
    "CMY_M": 0.1644102,
    "CMY_Y": 0.2589637,
    "CMYK_C": 0.2425101,
    "CMYK_M": 0,
    "CMYK_Y": 0.1131578,
    "CMYK_K": 0.1644102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06626",
    "Farbtonhilfsbezeichnung": "M2.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "207",
    "Bcolor": "192",
    "Y": 57,
    "L": 80.226255812268,
    "a": -15.1981991021974,
    "b": 2.42117019241088,
    "C": 15.3898447377046,
    "h": -0.15797888966451,
    "CMY_C": 0.3360904,
    "CMY_M": 0.1869171,
    "CMY_Y": 0.2452157,
    "CMYK_C": 0.1834664,
    "CMYK_M": 0,
    "CMYK_Y": 0.07170078,
    "CMYK_K": 0.1869171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06627",
    "Farbtonhilfsbezeichnung": "M2.07.73",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "203",
    "Bcolor": "193",
    "Y": 57,
    "L": 79.9056014751539,
    "a": -9.15475845294028,
    "b": 1.66275325004648,
    "C": 9.30453387882605,
    "h": -0.17966863434302,
    "CMY_C": 0.2906218,
    "CMY_M": 0.202821,
    "CMY_Y": 0.242387,
    "CMYK_C": 0.1101394,
    "CMYK_M": 0,
    "CMYK_Y": 0.04963251,
    "CMYK_K": 0.202821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06628",
    "Farbtonhilfsbezeichnung": "MN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "212",
    "Bcolor": "206",
    "Y": 64,
    "L": 83.9425118132893,
    "a": -3.78800990267741,
    "b": 0.61538001906367,
    "C": 3.83767007318828,
    "h": -0.16104777137985,
    "CMY_C": 0.207048,
    "CMY_M": 0.170152,
    "CMY_Y": 0.1904959,
    "CMYK_C": 0.04446121,
    "CMYK_M": 0,
    "CMYK_Y": 0.02451521,
    "CMYK_K": 0.170152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06629",
    "Farbtonhilfsbezeichnung": "L8.54.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "144",
    "Bcolor": "100",
    "Y": 21,
    "L": 52.5513852667067,
    "a": -45.6366164311305,
    "b": 13.527220445101,
    "C": 47.5992274333575,
    "h": -0.28816140041476,
    "CMY_C": 1,
    "CMY_M": 0.4352785,
    "CMY_Y": 0.6084213,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3065985,
    "CMYK_K": 0.4352785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06630",
    "Farbtonhilfsbezeichnung": "M0.45.49",
    "Farbtonklasse": "03",
    "Rcolor": "30",
    "Gcolor": "155",
    "Bcolor": "118",
    "Y": 25,
    "L": 57.174782132065,
    "a": -41.4862438532263,
    "b": 9.46769569465751,
    "C": 42.5528576104589,
    "h": -0.22437040713117,
    "CMY_C": 0.8820441,
    "CMY_M": 0.3914048,
    "CMY_Y": 0.5353391,
    "CMYK_C": 0.8061833,
    "CMYK_M": 0,
    "CMYK_Y": 0.2365025,
    "CMYK_K": 0.3914048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06631",
    "Farbtonhilfsbezeichnung": "M3.41.56",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "172",
    "Bcolor": "138",
    "Y": 32,
    "L": 63.0540787239381,
    "a": -42.9906536686679,
    "b": 7.00328065235938,
    "C": 43.5573443032867,
    "h": -0.1614839268609,
    "CMY_C": 0.8582116,
    "CMY_M": 0.3260714,
    "CMY_Y": 0.4599148,
    "CMYK_C": 0.7896093,
    "CMYK_M": 0,
    "CMYK_Y": 0.1986018,
    "CMYK_K": 0.3260714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06633",
    "Farbtonhilfsbezeichnung": "L8.20.61",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "174",
    "Bcolor": "150",
    "Y": 37,
    "L": 67.0311076335366,
    "a": -21.7288806866922,
    "b": 6.38102009048878,
    "C": 22.6464494632542,
    "h": -0.28563513590945,
    "CMY_C": 0.5167437,
    "CMY_M": 0.3178625,
    "CMY_Y": 0.4126281,
    "CMYK_C": 0.2915559,
    "CMYK_M": 0,
    "CMYK_Y": 0.1389245,
    "CMYK_K": 0.3178625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06634",
    "Farbtonhilfsbezeichnung": "M0.11.66",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "189",
    "Bcolor": "173",
    "Y": 47,
    "L": 73.9423445610735,
    "a": -14.0524854776199,
    "b": 3.52268105589515,
    "C": 14.4872920147377,
    "h": -0.24561882822992,
    "CMY_C": 0.3880407,
    "CMY_M": 0.2578139,
    "CMY_Y": 0.3197146,
    "CMYK_C": 0.1754638,
    "CMYK_M": 0,
    "CMYK_Y": 0.08340325,
    "CMYK_K": 0.2578139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06635",
    "Farbtonhilfsbezeichnung": "L8.06.70",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "197",
    "Bcolor": "187",
    "Y": 53,
    "L": 77.7515411376953,
    "a": -8.23671627044678,
    "b": 1.88411772251129,
    "C": 8.44946098327637,
    "h": 167.115478515625,
    "CMY_C": 0.30519872903824,
    "CMY_M": 0.22824543714523,
    "CMY_Y": 0.26690018177032,
    "CMYK_C": 0.09971213340759,
    "CMYK_M": 0,
    "CMYK_Y": 0.05008683726192,
    "CMYK_K": 0.22824543714523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06636",
    "Farbtonhilfsbezeichnung": "MN.02.74",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "205",
    "Bcolor": "202",
    "Y": 60,
    "L": 81.6783205884105,
    "a": -3.39536431374016,
    "b": -0.146724017382,
    "C": 3.39853303063202,
    "h": 0.04318617292039,
    "CMY_C": 0.2311805,
    "CMY_M": 0.1956217,
    "CMY_Y": 0.2094488,
    "CMYK_C": 0.04420656,
    "CMYK_M": 0,
    "CMYK_Y": 0.01718978,
    "CMYK_K": 0.1956217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06637",
    "Farbtonhilfsbezeichnung": "M2.57.42",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "141",
    "Bcolor": "105",
    "Y": 19,
    "L": 51.0397836712581,
    "a": -47.6356243852535,
    "b": 8.47564582394276,
    "C": 48.3837708607533,
    "h": -0.17608390771753,
    "CMY_C": 1,
    "CMY_M": 0.4477351,
    "CMY_Y": 0.5889043,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2556185,
    "CMYK_K": 0.4477351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06638",
    "Farbtonhilfsbezeichnung": "M2.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "139",
    "Bcolor": "106",
    "Y": 19,
    "L": 51.0053316320954,
    "a": -43.3083114278413,
    "b": 7.73080785163252,
    "C": 43.9928997540484,
    "h": -0.17664577117538,
    "CMY_C": 1,
    "CMY_M": 0.4533789,
    "CMY_Y": 0.5837834,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2385647,
    "CMYK_K": 0.4533789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06639",
    "Farbtonhilfsbezeichnung": "M1.41.51",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "161",
    "Bcolor": "125",
    "Y": 27,
    "L": 59.4688415527344,
    "a": -39.0891761779785,
    "b": 9.24231147766113,
    "C": 40.1669502258301,
    "h": 166.697189331055,
    "CMY_C": 0.79453390836716,
    "CMY_M": 0.37048375606537,
    "CMY_Y": 0.51086390018463,
    "CMYK_C": 0.67361271381378,
    "CMYK_M": 0,
    "CMYK_Y": 0.22299686074257,
    "CMYK_K": 0.37048375606537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06641",
    "Farbtonhilfsbezeichnung": "M2.30.49",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "149",
    "Bcolor": "125",
    "Y": 25,
    "L": 56.6445215523305,
    "a": -28.9953051004683,
    "b": 4.94957780148375,
    "C": 29.4147248547761,
    "h": -0.16907307142683,
    "CMY_C": 0.7070283,
    "CMY_M": 0.4145487,
    "CMY_Y": 0.5083269,
    "CMYK_C": 0.4995798,
    "CMYK_M": 0,
    "CMYK_Y": 0.1601811,
    "CMYK_K": 0.4145487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06642",
    "Farbtonhilfsbezeichnung": "M1.14.57",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "166",
    "Bcolor": "151",
    "Y": 34,
    "L": 65.2336082316336,
    "a": -15.3112360214677,
    "b": 3.11802095125722,
    "C": 15.6254920932932,
    "h": -0.20089565890746,
    "CMY_C": 0.4903957,
    "CMY_M": 0.3480354,
    "CMY_Y": 0.4074888,
    "CMYK_C": 0.2183559,
    "CMYK_M": 0,
    "CMYK_Y": 0.0911912,
    "CMYK_K": 0.3480354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06643",
    "Farbtonhilfsbezeichnung": "L8.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "174",
    "Bcolor": "162",
    "Y": 39,
    "L": 68.9470748901367,
    "a": -10.325909614563,
    "b": 2.83478164672852,
    "C": 10.7079591751099,
    "h": 164.648727416992,
    "CMY_C": 0.41128319501877,
    "CMY_M": 0.31852954626083,
    "CMY_Y": 0.36657154560089,
    "CMYK_C": 0.13610810041428,
    "CMYK_M": 0,
    "CMYK_Y": 0.07049755007029,
    "CMYK_K": 0.31852954626083
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06644",
    "Farbtonhilfsbezeichnung": "M3.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "196",
    "Bcolor": "191",
    "Y": 54,
    "L": 78.1758120464658,
    "a": -4.29183946280648,
    "b": 0.54932782637038,
    "C": 4.32685186195781,
    "h": -0.12730140901958,
    "CMY_C": 0.2735968,
    "CMY_M": 0.2318921,
    "CMY_Y": 0.2522682,
    "CMYK_C": 0.05429536,
    "CMYK_M": 0,
    "CMYK_Y": 0.02652764,
    "CMYK_K": 0.2318921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06645",
    "Farbtonhilfsbezeichnung": "M2.62.38",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "96",
    "Y": 16,
    "L": 47.0317196757971,
    "a": -47.1372326930362,
    "b": 8.10667648819285,
    "C": 47.8292474291793,
    "h": -0.17031422408999,
    "CMY_C": 1,
    "CMY_M": 0.4900063,
    "CMY_Y": 0.6246198,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2639513,
    "CMYK_K": 0.4900063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06646",
    "Farbtonhilfsbezeichnung": "M0.54.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "94",
    "Y": 17,
    "L": 48.3106261261001,
    "a": -43.1865000355395,
    "b": 11.0624826077293,
    "C": 44.5808513463568,
    "h": -0.25076413349532,
    "CMY_C": 1,
    "CMY_M": 0.4820811,
    "CMY_Y": 0.6318112,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2890994,
    "CMYK_K": 0.4820811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06647",
    "Farbtonhilfsbezeichnung": "M0.49.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "105",
    "Y": 20,
    "L": 52.166699472271,
    "a": -44.0872213426235,
    "b": 9.86397177871734,
    "C": 45.1772179861134,
    "h": -0.22011260549173,
    "CMY_C": 1,
    "CMY_M": 0.4406497,
    "CMY_Y": 0.5870562,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2617438,
    "CMYK_K": 0.4406497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06648",
    "Farbtonhilfsbezeichnung": "M1.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "153",
    "Bcolor": "127",
    "Y": 26,
    "L": 58.0106739014511,
    "a": -28.3847200957039,
    "b": 6.01147214758273,
    "C": 29.0143090955587,
    "h": -0.20870166422263,
    "CMY_C": 0.6793424,
    "CMY_M": 0.4015044,
    "CMY_Y": 0.5019259,
    "CMYK_C": 0.4642273,
    "CMYK_M": 0,
    "CMYK_Y": 0.1677899,
    "CMYK_K": 0.4015044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06649",
    "Farbtonhilfsbezeichnung": "M2.22.54",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "159",
    "Bcolor": "140",
    "Y": 30,
    "L": 61.2576965907725,
    "a": -22.387175740256,
    "b": 3.57387889135021,
    "C": 22.6706472769338,
    "h": -0.15830379966465,
    "CMY_C": 0.5943835,
    "CMY_M": 0.3770185,
    "CMY_Y": 0.4519744,
    "CMYK_C": 0.348911,
    "CMYK_M": 0,
    "CMYK_Y": 0.120318,
    "CMYK_K": 0.3770185
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06650",
    "Farbtonhilfsbezeichnung": "M1.14.49",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "142",
    "Bcolor": "130",
    "Y": 24,
    "L": 56.4471788738967,
    "a": -14.1984802470581,
    "b": 2.44486034219877,
    "C": 14.4074350048493,
    "h": -0.17051951436518,
    "CMY_C": 0.5716158,
    "CMY_M": 0.4412091,
    "CMY_Y": 0.4916152,
    "CMYK_C": 0.2333729,
    "CMYK_M": 0,
    "CMYK_Y": 0.09020571,
    "CMYK_K": 0.4412091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06651",
    "Farbtonhilfsbezeichnung": "M3.09.53",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "150",
    "Bcolor": "142",
    "Y": 28,
    "L": 60.333820521998,
    "a": -9.41250041935798,
    "b": 0.86962101107281,
    "C": 9.45258720389891,
    "h": -0.0921284707988,
    "CMY_C": 0.4989598,
    "CMY_M": 0.4099935,
    "CMY_Y": 0.4412584,
    "CMYK_C": 0.1507886,
    "CMYK_M": 0,
    "CMYK_Y": 0.05299086,
    "CMYK_K": 0.4099935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06652",
    "Farbtonhilfsbezeichnung": "M0.06.62",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "173",
    "Bcolor": "165",
    "Y": 40,
    "L": 69.3062453750386,
    "a": -7.34995738576094,
    "b": 1.31734723489996,
    "C": 7.46707957034076,
    "h": -0.17734889789175,
    "CMY_C": 0.3889182,
    "CMY_M": 0.3204839,
    "CMY_Y": 0.3518178,
    "CMYK_C": 0.1007104,
    "CMYK_M": 0,
    "CMYK_Y": 0.04611209,
    "CMYK_K": 0.3204839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06653",
    "Farbtonhilfsbezeichnung": "L8.57.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "74",
    "Y": 12,
    "L": 40.7453435994024,
    "a": -40.4124112645877,
    "b": 12.3401787051131,
    "C": 42.2545026558389,
    "h": -0.29636342973419,
    "CMY_C": 1,
    "CMY_M": 0.5627161,
    "CMY_Y": 0.7101399,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3371352,
    "CMYK_K": 0.5627161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06654",
    "Farbtonhilfsbezeichnung": "M0.49.35",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "118",
    "Bcolor": "88",
    "Y": 14,
    "L": 43.7391902306983,
    "a": -36.3798169879577,
    "b": 8.45791743746379,
    "C": 37.3500662844961,
    "h": -0.22843131129746,
    "CMY_C": 1,
    "CMY_M": 0.5368971,
    "CMY_Y": 0.6567586,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2588226,
    "CMYK_K": 0.5368971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06655",
    "Farbtonhilfsbezeichnung": "M2.46.43",
    "Farbtonklasse": "03",
    "Rcolor": "16",
    "Gcolor": "137",
    "Bcolor": "107",
    "Y": 19,
    "L": 50.7176582998728,
    "a": -37.7889920539707,
    "b": 6.61472259629408,
    "C": 38.3635566062505,
    "h": -0.17328800617345,
    "CMY_C": 0.9353922,
    "CMY_M": 0.4634403,
    "CMY_Y": 0.5785004,
    "CMYK_C": 0.8795888,
    "CMYK_M": 0,
    "CMYK_Y": 0.2144404,
    "CMYK_K": 0.4634403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06656",
    "Farbtonhilfsbezeichnung": "M2.42.45",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "144",
    "Bcolor": "115",
    "Y": 21,
    "L": 53.4020921434033,
    "a": -36.6531428587032,
    "b": 6.20661216636316,
    "C": 37.1749232145024,
    "h": -0.16774249767675,
    "CMY_C": 0.858622,
    "CMY_M": 0.4371061,
    "CMY_Y": 0.5495812,
    "CMYK_C": 0.7488372,
    "CMYK_M": 0,
    "CMYK_Y": 0.1998158,
    "CMYK_K": 0.4371061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06658",
    "Farbtonhilfsbezeichnung": "M3.23.44",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "135",
    "Bcolor": "119",
    "Y": 21,
    "L": 52.5990631333642,
    "a": -20.4238987507965,
    "b": 2.83042846629618,
    "C": 20.6190922565861,
    "h": -0.13770703083122,
    "CMY_C": 0.6649216,
    "CMY_M": 0.4696354,
    "CMY_Y": 0.5330096,
    "CMYK_C": 0.3682112,
    "CMYK_M": 0,
    "CMYK_Y": 0.1194917,
    "CMYK_K": 0.4696354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06659",
    "Farbtonhilfsbezeichnung": "M2.16.41",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "126",
    "Bcolor": "114",
    "Y": 18,
    "L": 50.2848434448242,
    "a": -12.7482099533081,
    "b": 2.74445652961731,
    "C": 13.0402793884277,
    "h": 167.850692749023,
    "CMY_C": 0.61848139762878,
    "CMY_M": 0.50630581378937,
    "CMY_Y": 0.55418705940247,
    "CMYK_C": 0.22721673548222,
    "CMYK_M": 0,
    "CMYK_Y": 0.09698563814163,
    "CMYK_K": 0.50630581378937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06660",
    "Farbtonhilfsbezeichnung": "M1.09.44",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "131",
    "Bcolor": "124",
    "Y": 21,
    "L": 52.9954696976087,
    "a": -7.82773553201632,
    "b": 0.97788032343997,
    "C": 7.88857994103894,
    "h": -0.12428120583828,
    "CMY_C": 0.5589237,
    "CMY_M": 0.4879078,
    "CMY_Y": 0.5152978,
    "CMYK_C": 0.1386778,
    "CMYK_M": 0,
    "CMYK_Y": 0.0534865,
    "CMYK_K": 0.4879078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06661",
    "Farbtonhilfsbezeichnung": "MN.01.54",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "147",
    "Bcolor": "145",
    "Y": 29,
    "L": 60.5183225348334,
    "a": -1.67264441813625,
    "b": -0.23694893044143,
    "C": 1.6893442944408,
    "h": 0.14072490227175,
    "CMY_C": 0.4408744,
    "CMY_M": 0.4237223,
    "CMY_Y": 0.4308865,
    "CMYK_C": 0.02976353,
    "CMYK_M": 0,
    "CMYK_Y": 0.01243183,
    "CMYK_K": 0.4237223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06662",
    "Farbtonhilfsbezeichnung": "M3.54.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "86",
    "Y": 12,
    "L": 41.6686087967671,
    "a": -36.8086473195783,
    "b": 6.22803427660179,
    "C": 37.331821927782,
    "h": -0.1676128196071,
    "CMY_C": 1,
    "CMY_M": 0.5567744,
    "CMY_Y": 0.6615794,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2364597,
    "CMYK_K": 0.5567744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06663",
    "Farbtonhilfsbezeichnung": "L8.45.35",
    "Farbtonklasse": "03",
    "Rcolor": "35",
    "Gcolor": "117",
    "Bcolor": "86",
    "Y": 14,
    "L": 43.7959118820432,
    "a": -32.2264059614617,
    "b": 9.60636980289211,
    "C": 33.6277204398819,
    "h": -0.28970359387149,
    "CMY_C": 0.8632893,
    "CMY_M": 0.5420025,
    "CMY_Y": 0.6632835,
    "CMYK_C": 0.7015033,
    "CMYK_M": 0,
    "CMYK_Y": 0.2648072,
    "CMYK_K": 0.5420025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06664",
    "Farbtonhilfsbezeichnung": "L8.40.36",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "119",
    "Bcolor": "90",
    "Y": 14,
    "L": 44.8954788504745,
    "a": -29.2376334051848,
    "b": 8.63744211065843,
    "C": 30.486794081224,
    "h": -0.28725158271334,
    "CMY_C": 0.8113771,
    "CMY_M": 0.5349527,
    "CMY_Y": 0.6463354,
    "CMYK_C": 0.5944006,
    "CMYK_M": 0,
    "CMYK_Y": 0.2395083,
    "CMYK_K": 0.5349527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06665",
    "Farbtonhilfsbezeichnung": "M2.35.40",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "126",
    "Bcolor": "105",
    "Y": 17,
    "L": 48.0726799060626,
    "a": -27.9189008088269,
    "b": 4.5953161875582,
    "C": 28.2945569542404,
    "h": -0.16313249130163,
    "CMY_C": 0.7859358,
    "CMY_M": 0.5040954,
    "CMY_Y": 0.589501,
    "CMYK_C": 0.5683359,
    "CMYK_M": 0,
    "CMYK_Y": 0.1722218,
    "CMYK_K": 0.5040954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06666",
    "Farbtonhilfsbezeichnung": "M3.29.34",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "111",
    "Bcolor": "95",
    "Y": 13,
    "L": 42.9482848549268,
    "a": -21.0130053587066,
    "b": 3.00736624930517,
    "C": 21.2271205292308,
    "h": -0.14215394198348,
    "CMY_C": 0.7643512,
    "CMY_M": 0.565356,
    "CMY_Y": 0.6272013,
    "CMYK_C": 0.457835,
    "CMYK_M": 0,
    "CMYK_Y": 0.1422896,
    "CMYK_K": 0.565356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06667",
    "Farbtonhilfsbezeichnung": "M3.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "97",
    "Bcolor": "87",
    "Y": 10,
    "L": 38.5165958596848,
    "a": -12.9567995448156,
    "b": 1.4175230258627,
    "C": 13.0341100951843,
    "h": -0.10897041032794,
    "CMY_C": 0.7366192,
    "CMY_M": 0.6208954,
    "CMY_Y": 0.6577374,
    "CMYK_C": 0.3052554,
    "CMYK_M": 0,
    "CMYK_Y": 0.09718141,
    "CMYK_K": 0.6208954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06668",
    "Farbtonhilfsbezeichnung": "M2.09.36",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "109",
    "Bcolor": "102",
    "Y": 14,
    "L": 44.4213898143223,
    "a": -7.51850417820438,
    "b": 1.01458260105349,
    "C": 7.58665162848784,
    "h": -0.13413445788799,
    "CMY_C": 0.6392449,
    "CMY_M": 0.5733836,
    "CMY_Y": 0.5988836,
    "CMYK_C": 0.1543804,
    "CMYK_M": 0,
    "CMYK_Y": 0.05977274,
    "CMYK_K": 0.5733836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06669",
    "Farbtonhilfsbezeichnung": "MN.02.36",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "105",
    "Bcolor": "103",
    "Y": 14,
    "L": 43.9776735076622,
    "a": -2.27610141394796,
    "b": -0.03172282437657,
    "C": 2.27632246928293,
    "h": 0.01393644868865,
    "CMY_C": 0.6083844,
    "CMY_M": 0.5875186,
    "CMY_Y": 0.5957975,
    "CMYK_C": 0.05058617,
    "CMYK_M": 0,
    "CMYK_Y": 0.02007098,
    "CMYK_K": 0.5875186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06670",
    "Farbtonhilfsbezeichnung": "M2.59.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "115",
    "Bcolor": "83",
    "Y": 12,
    "L": 41.9281825629358,
    "a": -42.1314045327794,
    "b": 8.33663853129412,
    "C": 42.9482804068587,
    "h": -0.19534887389549,
    "CMY_C": 1,
    "CMY_M": 0.5481271,
    "CMY_Y": 0.6733735,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2771719,
    "CMYK_K": 0.5481271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06671",
    "Farbtonhilfsbezeichnung": "M2.48.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "110",
    "Bcolor": "84",
    "Y": 12,
    "L": 40.5076161525093,
    "a": -35.3904997278418,
    "b": 6.23899075532134,
    "C": 35.9362279132264,
    "h": -0.17449704726441,
    "CMY_C": 1,
    "CMY_M": 0.5701464,
    "CMY_Y": 0.6722641,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2375638,
    "CMYK_K": 0.5701464
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06672",
    "Farbtonhilfsbezeichnung": "M3.48.24",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "91",
    "Bcolor": "73",
    "Y": 8,
    "L": 34.310157591902,
    "a": -25.8998682976867,
    "b": 4.04015177381661,
    "C": 26.2130884138628,
    "h": -0.15474410871459,
    "CMY_C": 0.9145854,
    "CMY_M": 0.6424904,
    "CMY_Y": 0.7140098,
    "CMYK_C": 0.7610845,
    "CMYK_M": 0,
    "CMYK_Y": 0.200049,
    "CMYK_K": 0.6424904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06673",
    "Farbtonhilfsbezeichnung": "M2.45.27",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "98",
    "Bcolor": "78",
    "Y": 10,
    "L": 36.9689061156418,
    "a": -26.5195290260086,
    "b": 4.63892712548052,
    "C": 26.9222039334976,
    "h": -0.17317283965445,
    "CMY_C": 0.8876253,
    "CMY_M": 0.6161398,
    "CMY_Y": 0.693688,
    "CMYK_C": 0.707251,
    "CMYK_M": 0,
    "CMYK_Y": 0.2020219,
    "CMYK_K": 0.6161398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06674",
    "Farbtonhilfsbezeichnung": "L8.34.25",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "88",
    "Bcolor": "69",
    "Y": 8,
    "L": 33.9032571487731,
    "a": -20.8315681300794,
    "b": 5.96003541463364,
    "C": 21.6674006955571,
    "h": -0.27866171847282,
    "CMY_C": 0.8340222,
    "CMY_M": 0.653644,
    "CMY_Y": 0.7290671,
    "CMYK_C": 0.5207886,
    "CMYK_M": 0,
    "CMYK_Y": 0.217762,
    "CMYK_K": 0.653644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06675",
    "Farbtonhilfsbezeichnung": "L8.19.21",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "75",
    "Bcolor": "66",
    "Y": 6,
    "L": 30.0479996704921,
    "a": -10.3607368869797,
    "b": 2.6409703999357,
    "C": 10.6920341139822,
    "h": -0.24958676704133,
    "CMY_C": 0.7871726,
    "CMY_M": 0.7047117,
    "CMY_Y": 0.7419618,
    "CMYK_C": 0.2792553,
    "CMYK_M": 0,
    "CMYK_Y": 0.126148,
    "CMYK_K": 0.7047117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06676",
    "Farbtonhilfsbezeichnung": "M3.10.28",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "91",
    "Bcolor": "86",
    "Y": 10,
    "L": 37.2831929503127,
    "a": -6.55471615312375,
    "b": 0.29376606224473,
    "C": 6.56129578264448,
    "h": -0.04478753999536,
    "CMY_C": 0.701178,
    "CMY_M": 0.6434221,
    "CMY_Y": 0.6614589,
    "CMYK_C": 0.1619726,
    "CMYK_M": 0,
    "CMYK_Y": 0.05058318,
    "CMYK_K": 0.6434221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06677",
    "Farbtonhilfsbezeichnung": "MN.02.26",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "83",
    "Bcolor": "82",
    "Y": 8,
    "L": 34.9880920133803,
    "a": -1.78426994306807,
    "b": -0.31987853328411,
    "C": 1.81271660934415,
    "h": 0.17739252418953,
    "CMY_C": 0.690289,
    "CMY_M": 0.6736144,
    "CMY_Y": 0.6783339,
    "CMYK_C": 0.05108846,
    "CMYK_M": 0,
    "CMYK_Y": 0.0144597,
    "CMYK_K": 0.6736144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06678",
    "Farbtonhilfsbezeichnung": "M0.52.21",
    "Farbtonklasse": "03",
    "Rcolor": "18",
    "Gcolor": "84",
    "Bcolor": "62",
    "Y": 7,
    "L": 31.5640087185358,
    "a": -26.1699626319965,
    "b": 6.71872889973702,
    "C": 27.0186650704333,
    "h": -0.25130678293393,
    "CMY_C": 0.9289896,
    "CMY_M": 0.6687967,
    "CMY_Y": 0.7551031,
    "CMYK_C": 0.7855988,
    "CMYK_M": 0,
    "CMYK_Y": 0.2605844,
    "CMYK_K": 0.6687967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06679",
    "Farbtonhilfsbezeichnung": "M2.44.14",
    "Farbtonklasse": "03",
    "Rcolor": "33",
    "Gcolor": "70",
    "Bcolor": "58",
    "Y": 5,
    "L": 26.8380489966497,
    "a": -16.8394770996041,
    "b": 3.01899975521051,
    "C": 17.1079615533252,
    "h": -0.17739649961556,
    "CMY_C": 0.8718885,
    "CMY_M": 0.7244212,
    "CMY_Y": 0.7730758,
    "CMYK_C": 0.5351183,
    "CMYK_M": 0,
    "CMYK_Y": 0.1765543,
    "CMYK_K": 0.7244212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06680",
    "Farbtonhilfsbezeichnung": "M1.37.17",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "73",
    "Bcolor": "60",
    "Y": 6,
    "L": 28.1243034086528,
    "a": -17.2253023183521,
    "b": 3.69319833538506,
    "C": 17.6167747872054,
    "h": -0.21120778948144,
    "CMY_C": 0.8607801,
    "CMY_M": 0.7122443,
    "CMY_Y": 0.7659435,
    "CMYK_C": 0.516187,
    "CMYK_M": 0,
    "CMYK_Y": 0.1866138,
    "CMYK_K": 0.7122443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06681",
    "Farbtonhilfsbezeichnung": "L8.30.18",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "72",
    "Bcolor": "59",
    "Y": 5,
    "L": 27.9975432394864,
    "a": -14.4251606624603,
    "b": 3.73870209512009,
    "C": 14.9017835675414,
    "h": -0.25359910985214,
    "CMY_C": 0.8348606,
    "CMY_M": 0.7174261,
    "CMY_Y": 0.7670321,
    "CMYK_C": 0.4155887,
    "CMYK_M": 0,
    "CMYK_Y": 0.1755508,
    "CMYK_K": 0.7174261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06682",
    "Farbtonhilfsbezeichnung": "L9.28.13",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "66",
    "Bcolor": "57",
    "Y": 5,
    "L": 26.0125540385063,
    "a": -10.3024966270591,
    "b": 2.47318128959717,
    "C": 10.5951905335288,
    "h": -0.23559840361823,
    "CMY_C": 0.8225425,
    "CMY_M": 0.7413432,
    "CMY_Y": 0.7763341,
    "CMYK_C": 0.3139267,
    "CMYK_M": 0,
    "CMYK_Y": 0.1352793,
    "CMYK_K": 0.7413432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06683",
    "Farbtonhilfsbezeichnung": "M1.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "76",
    "Bcolor": "68",
    "Y": 6,
    "L": 30.3581281638644,
    "a": -10.4566559695644,
    "b": 1.71810247917402,
    "C": 10.5968641679872,
    "h": -0.16285197651998,
    "CMY_C": 0.7885321,
    "CMY_M": 0.7015251,
    "CMY_Y": 0.7336431,
    "CMYK_C": 0.2915054,
    "CMYK_M": 0,
    "CMYK_Y": 0.1076071,
    "CMYK_K": 0.7015251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06684",
    "Farbtonhilfsbezeichnung": "L6.12.17",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "65",
    "Bcolor": "60",
    "Y": 5,
    "L": 26.6176022142488,
    "a": -5.24651144263732,
    "b": 1.54438361517204,
    "C": 5.46909526965258,
    "h": -0.28627808140613,
    "CMY_C": 0.7832894,
    "CMY_M": 0.7439584,
    "CMY_Y": 0.7650521,
    "CMYK_C": 0.1536119,
    "CMYK_M": 0,
    "CMYK_Y": 0.08238433,
    "CMYK_K": 0.7439584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06685",
    "Farbtonhilfsbezeichnung": "M2.05.13",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "60",
    "Bcolor": "58",
    "Y": 4,
    "L": 24.6977978644326,
    "a": -1.85165185272168,
    "b": -0.1105129944777,
    "C": 1.85494682016387,
    "h": 0.05961274741306,
    "CMY_C": 0.7821913,
    "CMY_M": 0.7665277,
    "CMY_Y": 0.7717139,
    "CMYK_C": 0.06709018,
    "CMYK_M": 0,
    "CMYK_Y": 0.02221335,
    "CMYK_K": 0.7665277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06686",
    "Farbtonhilfsbezeichnung": "M9.35.66",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "201",
    "Bcolor": "180",
    "Y": 47,
    "L": 73.9720270944522,
    "a": -39.6773603219526,
    "b": -0.52543640973334,
    "C": 39.6808392746264,
    "h": 0.01324195192112,
    "CMY_C": 0.7116273,
    "CMY_M": 0.2105014,
    "CMY_Y": 0.2935297,
    "CMYK_C": 0.6347395,
    "CMYK_M": 0,
    "CMYK_Y": 0.1051659,
    "CMYK_K": 0.2105014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06687",
    "Farbtonhilfsbezeichnung": "M8.29.67",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "203",
    "Bcolor": "181",
    "Y": 49,
    "L": 75.3133153440022,
    "a": -35.7116020308219,
    "b": 0.88207097070123,
    "C": 35.7224938771799,
    "h": -0.02469482206251,
    "CMY_C": 0.6186064,
    "CMY_M": 0.2025618,
    "CMY_Y": 0.28897,
    "CMYK_C": 0.5217265,
    "CMYK_M": 0,
    "CMYK_Y": 0.1083572,
    "CMYK_K": 0.2025618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06688",
    "Farbtonhilfsbezeichnung": "M8.23.74",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "217",
    "Bcolor": "198",
    "Y": 59,
    "L": 81.2652854625079,
    "a": -29.701308269778,
    "b": 0.62753825250341,
    "C": 29.7079369393894,
    "h": -0.02112516031369,
    "CMY_C": 0.478135,
    "CMY_M": 0.1471229,
    "CMY_Y": 0.2228192,
    "CMYK_C": 0.3881122,
    "CMYK_M": 0,
    "CMYK_Y": 0.08875407,
    "CMYK_K": 0.1471229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06689",
    "Farbtonhilfsbezeichnung": "M8.16.78",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "225",
    "Bcolor": "209",
    "Y": 66,
    "L": 85.1404932149625,
    "a": -22.1503258194412,
    "b": 0.60149793548758,
    "C": 22.1584912318912,
    "h": -0.02714859166885,
    "CMY_C": 0.3564982,
    "CMY_M": 0.1182332,
    "CMY_Y": 0.1797351,
    "CMYK_C": 0.2702131,
    "CMYK_M": 0,
    "CMYK_Y": 0.06974848,
    "CMYK_K": 0.1182332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06690",
    "Farbtonhilfsbezeichnung": "M4.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "236",
    "Bcolor": "225",
    "Y": 79,
    "L": 91.2274340664222,
    "a": -10.8737371938408,
    "b": 1.50874058167194,
    "C": 10.9779077561938,
    "h": -0.1378706219865,
    "CMY_C": 0.1830349,
    "CMY_M": 0.07377161,
    "CMY_Y": 0.1182391,
    "CMYK_C": 0.1179658,
    "CMYK_M": 0,
    "CMYK_Y": 0.04800919,
    "CMYK_K": 0.07377161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06691",
    "Farbtonhilfsbezeichnung": "M4.45.56",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "173",
    "Bcolor": "140",
    "Y": 32,
    "L": 62.9852880321747,
    "a": -46.8115546742791,
    "b": 5.5267599887781,
    "C": 47.1366813320219,
    "h": -0.11751998638722,
    "CMY_C": 1,
    "CMY_M": 0.3210975,
    "CMY_Y": 0.4507351,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1909517,
    "CMYK_K": 0.3210975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06692",
    "Farbtonhilfsbezeichnung": "M9.34.63",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "191",
    "Bcolor": "172",
    "Y": 42,
    "L": 70.5748370474868,
    "a": -38.3391131485552,
    "b": -0.83433328244058,
    "C": 38.3481904272406,
    "h": 0.02175850047092,
    "CMY_C": 0.7341946,
    "CMY_M": 0.2498368,
    "CMY_Y": 0.3269872,
    "CMYK_C": 0.6456699,
    "CMYK_M": 0,
    "CMYK_Y": 0.1028449,
    "CMYK_K": 0.2498368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06693",
    "Farbtonhilfsbezeichnung": "M8.28.70",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "209",
    "Bcolor": "186",
    "Y": 52,
    "L": 77.4184750495868,
    "a": -35.3221065603604,
    "b": 1.21734457212985,
    "C": 35.3430776768061,
    "h": -0.03445046337931,
    "CMY_C": 0.5867406,
    "CMY_M": 0.1800544,
    "CMY_Y": 0.2689663,
    "CMYK_C": 0.4959916,
    "CMYK_M": 0,
    "CMYK_Y": 0.1084363,
    "CMYK_K": 0.1800544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06694",
    "Farbtonhilfsbezeichnung": "M9.17.77",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "225",
    "Bcolor": "210",
    "Y": 66,
    "L": 85.0296983172426,
    "a": -22.7162065959149,
    "b": 0.08439210687918,
    "C": 22.7163633563119,
    "h": -0.00371504451128,
    "CMY_C": 0.3658054,
    "CMY_M": 0.1182261,
    "CMY_Y": 0.1772199,
    "CMYK_C": 0.2807741,
    "CMYK_M": 0,
    "CMYK_Y": 0.06690346,
    "CMYK_K": 0.1182261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06695",
    "Farbtonhilfsbezeichnung": "M4.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "233",
    "Bcolor": "216",
    "Y": 74,
    "L": 89.0381040516635,
    "a": -17.3426404630699,
    "b": 2.62374125197362,
    "C": 17.5399884945407,
    "h": -0.15014980984666,
    "CMY_C": 0.2597977,
    "CMY_M": 0.08487184,
    "CMY_Y": 0.1514411,
    "CMYK_C": 0.191149,
    "CMYK_M": 0,
    "CMYK_Y": 0.07274309,
    "CMYK_K": 0.08487184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06696",
    "Farbtonhilfsbezeichnung": "M9.49.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "166",
    "Bcolor": "143",
    "Y": 28,
    "L": 59.9454531418482,
    "a": -48.4401029259114,
    "b": -0.48911167382579,
    "C": 48.4425722036141,
    "h": 0.01009690365913,
    "CMY_C": 1,
    "CMY_M": 0.3503499,
    "CMY_Y": 0.4400474,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1380704,
    "CMYK_K": 0.3503499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06697",
    "Farbtonhilfsbezeichnung": "M9.38.61",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "186",
    "Bcolor": "163",
    "Y": 38,
    "L": 68.1495630128417,
    "a": -41.69219535444,
    "b": 0.25652922387846,
    "C": 41.6929845503472,
    "h": -0.00615285389735,
    "CMY_C": 0.8352697,
    "CMY_M": 0.2713448,
    "CMY_Y": 0.3603592,
    "CMYK_C": 0.7739257,
    "CMYK_M": 0,
    "CMYK_Y": 0.1221625,
    "CMYK_K": 0.2713448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06698",
    "Farbtonhilfsbezeichnung": "M6.32.66",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "201",
    "Bcolor": "174",
    "Y": 47,
    "L": 74.0504885869013,
    "a": -38.2209882406656,
    "b": 3.01261621465776,
    "C": 38.3395331029203,
    "h": -0.07865836627328,
    "CMY_C": 0.6541359,
    "CMY_M": 0.2128339,
    "CMY_Y": 0.3178534,
    "CMYK_C": 0.5606212,
    "CMYK_M": 0,
    "CMYK_Y": 0.1334146,
    "CMYK_K": 0.2128339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06699",
    "Farbtonhilfsbezeichnung": "M5.24.70",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "207",
    "Bcolor": "184",
    "Y": 53,
    "L": 77.6184069171272,
    "a": -29.9525507149739,
    "b": 2.81165164126262,
    "C": 30.0842264199181,
    "h": -0.09359592315861,
    "CMY_C": 0.5081193,
    "CMY_M": 0.1875753,
    "CMY_Y": 0.2777131,
    "CMYK_C": 0.3945523,
    "CMYK_M": 0,
    "CMYK_Y": 0.110949,
    "CMYK_K": 0.1875753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06700",
    "Farbtonhilfsbezeichnung": "M9.16.74",
    "Farbtonklasse": "01",
    "Rcolor": "154",
    "Gcolor": "213",
    "Bcolor": "199",
    "Y": 58,
    "L": 80.9625211681894,
    "a": -21.1518999080249,
    "b": -0.11455824710129,
    "C": 21.152210128284,
    "h": 0.00541592611128,
    "CMY_C": 0.3948259,
    "CMY_M": 0.1663333,
    "CMY_Y": 0.2196686,
    "CMYK_C": 0.2740814,
    "CMYK_M": 0,
    "CMYK_Y": 0.06397682,
    "CMYK_K": 0.1663333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06701",
    "Farbtonhilfsbezeichnung": "M9.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "219",
    "Bcolor": "213",
    "Y": 68,
    "L": 85.9865317906015,
    "a": -7.06928529359502,
    "b": 0.26675721077142,
    "C": 7.07431650208961,
    "h": -0.03771678399746,
    "CMY_C": 0.2128572,
    "CMY_M": 0.1401858,
    "CMY_Y": 0.1661217,
    "CMYK_C": 0.08451991,
    "CMYK_M": 0,
    "CMYK_Y": 0.0301646,
    "CMYK_K": 0.1401858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06702",
    "Farbtonhilfsbezeichnung": "M5.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "227",
    "Bcolor": "217",
    "Y": 74,
    "L": 89.0001160252188,
    "a": -6.09368808029354,
    "b": 2.69415016215377,
    "C": 6.66269311285945,
    "h": -0.41628283151638,
    "CMY_C": 0.1630088,
    "CMY_M": 0.1095948,
    "CMY_Y": 0.1508645,
    "CMYK_C": 0.05998844,
    "CMYK_M": 0,
    "CMYK_Y": 0.04634938,
    "CMYK_K": 0.1095948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06703",
    "Farbtonhilfsbezeichnung": "M8.50.50",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "161",
    "Bcolor": "135",
    "Y": 25,
    "L": 58.742073059082,
    "a": -45.7721710205078,
    "b": 1.96969187259674,
    "C": 45.8145332336426,
    "h": 177.535934448242,
    "CMY_C": 1,
    "CMY_M": 0.36736136674881,
    "CMY_Y": 0.46881586313248,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.16036722064018,
    "CMYK_K": 0.36736136674881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06704",
    "Farbtonhilfsbezeichnung": "M6.36.55",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "169",
    "Bcolor": "144",
    "Y": 31,
    "L": 62.6788252137745,
    "a": -37.6552641803821,
    "b": 2.92328045506842,
    "C": 37.7685648272919,
    "h": -0.07747731826234,
    "CMY_C": 0.7865288,
    "CMY_M": 0.3370984,
    "CMY_Y": 0.4347897,
    "CMYK_C": 0.6779746,
    "CMYK_M": 0,
    "CMYK_Y": 0.1473692,
    "CMYK_K": 0.3370984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06705",
    "Farbtonhilfsbezeichnung": "M9.29.60",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "183",
    "Bcolor": "165",
    "Y": 38,
    "L": 68.6951599121094,
    "a": -30.9006500244141,
    "b": 0.33712276816368,
    "C": 30.9024887084961,
    "h": 179.374938964844,
    "CMY_C": 0.63116991519928,
    "CMY_M": 0.28264838457108,
    "CMY_Y": 0.35409939289093,
    "CMYK_C": 0.48584476113319,
    "CMYK_M": 0,
    "CMYK_Y": 0.0996038839221,
    "CMYK_K": 0.28264838457108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06707",
    "Farbtonhilfsbezeichnung": "M5.15.70",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "201",
    "Bcolor": "185",
    "Y": 52,
    "L": 77.2601222748446,
    "a": -19.5583564175379,
    "b": 2.02009952722746,
    "C": 19.6624034099434,
    "h": -0.10292080165214,
    "CMY_C": 0.4089389,
    "CMY_M": 0.2106064,
    "CMY_Y": 0.2745595,
    "CMYK_C": 0.2512467,
    "CMYK_M": 0,
    "CMYK_Y": 0.08101548,
    "CMYK_K": 0.2106064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06709",
    "Farbtonhilfsbezeichnung": "M6.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "222",
    "Bcolor": "217",
    "Y": 71,
    "L": 87.4984462916438,
    "a": -4.20110833459003,
    "b": 0.06281428552326,
    "C": 4.20157790281552,
    "h": -0.01495072259083,
    "CMY_C": 0.1734881,
    "CMY_M": 0.1298299,
    "CMY_Y": 0.1476941,
    "CMYK_C": 0.05017194,
    "CMYK_M": 0,
    "CMYK_Y": 0.02052955,
    "CMYK_K": 0.1298299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06710",
    "Farbtonhilfsbezeichnung": "M6.52.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "148",
    "Bcolor": "122",
    "Y": 22,
    "L": 53.7723103538941,
    "a": -47.3103899445197,
    "b": 2.60084981941475,
    "C": 47.3818258036313,
    "h": -0.05491889839611,
    "CMY_C": 1,
    "CMY_M": 0.4182553,
    "CMY_Y": 0.5226963,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1795306,
    "CMYK_K": 0.4182553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06711",
    "Farbtonhilfsbezeichnung": "M7.46.47",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "149",
    "Bcolor": "126",
    "Y": 23,
    "L": 54.7594449971969,
    "a": -41.8110073970219,
    "b": 1.67894553396557,
    "C": 41.8447033405644,
    "h": -0.0401340243497,
    "CMY_C": 1,
    "CMY_M": 0.4148465,
    "CMY_Y": 0.5061945,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1561094,
    "CMYK_K": 0.4148465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06712",
    "Farbtonhilfsbezeichnung": "M8.31.51",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "154",
    "Bcolor": "138",
    "Y": 26,
    "L": 58.3554871066617,
    "a": -29.3341323440852,
    "b": 0.34939969384135,
    "C": 29.3362131251865,
    "h": -0.01191046551963,
    "CMY_C": 0.7235828,
    "CMY_M": 0.3951294,
    "CMY_Y": 0.4599712,
    "CMYK_C": 0.5430143,
    "CMYK_M": 0,
    "CMYK_Y": 0.1071995,
    "CMYK_K": 0.3951294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06713",
    "Farbtonhilfsbezeichnung": "M6.27.59",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "177",
    "Bcolor": "156",
    "Y": 36,
    "L": 66.7029952503402,
    "a": -29.6792543418441,
    "b": 2.18072559144227,
    "C": 29.7592624638623,
    "h": -0.07334462674238,
    "CMY_C": 0.6255842,
    "CMY_M": 0.3065551,
    "CMY_Y": 0.3875434,
    "CMYK_C": 0.4600642,
    "CMYK_M": 0,
    "CMYK_Y": 0.1167912,
    "CMYK_K": 0.3065551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06714",
    "Farbtonhilfsbezeichnung": "M6.15.64",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "185",
    "Bcolor": "172",
    "Y": 43,
    "L": 71.5288178443125,
    "a": -17.7727282403647,
    "b": 0.63815675137792,
    "C": 17.7841815427415,
    "h": -0.03589109679235,
    "CMY_C": 0.4582766,
    "CMY_M": 0.2757645,
    "CMY_Y": 0.325077,
    "CMYK_C": 0.2520066,
    "CMYK_M": 0,
    "CMYK_Y": 0.06808906,
    "CMYK_K": 0.2757645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06715",
    "Farbtonhilfsbezeichnung": "M8.07.73",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "208",
    "Bcolor": "201",
    "Y": 59,
    "L": 81.3656250614152,
    "a": -9.41110668839001,
    "b": -0.48816854450217,
    "C": 9.42375920894102,
    "h": 0.05182508656064,
    "CMY_C": 0.2853135,
    "CMY_M": 0.1857358,
    "CMY_Y": 0.2111406,
    "CMYK_C": 0.1222916,
    "CMYK_M": 0,
    "CMYK_Y": 0.03119976,
    "CMYK_K": 0.1857358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06716",
    "Farbtonhilfsbezeichnung": "M4.05.74",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "207",
    "Bcolor": "199",
    "Y": 60,
    "L": 81.7412366497033,
    "a": -7.45979751674408,
    "b": 1.2010465426707,
    "C": 7.55586472804288,
    "h": -0.15963265003981,
    "CMY_C": 0.2586063,
    "CMY_M": 0.1862963,
    "CMY_Y": 0.2190727,
    "CMYK_C": 0.08886526,
    "CMYK_M": 0,
    "CMYK_Y": 0.0402806,
    "CMYK_K": 0.1862963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06717",
    "Farbtonhilfsbezeichnung": "M4.55.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "145",
    "Bcolor": "113",
    "Y": 20,
    "L": 52.3341248965245,
    "a": -48.5931595598334,
    "b": 5.63261718475292,
    "C": 48.9185193189389,
    "h": -0.11539879366925,
    "CMY_C": 1,
    "CMY_M": 0.4324309,
    "CMY_Y": 0.5573379,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2200737,
    "CMYK_K": 0.4324309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06718",
    "Farbtonhilfsbezeichnung": "M7.42.44",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "143",
    "Bcolor": "121",
    "Y": 21,
    "L": 53.1478203824967,
    "a": -36.3802164758769,
    "b": 2.33596658859441,
    "C": 36.4551353136248,
    "h": -0.06412177866553,
    "CMY_C": 0.9139867,
    "CMY_M": 0.439335,
    "CMY_Y": 0.5260051,
    "CMYK_C": 0.8465871,
    "CMYK_M": 0,
    "CMYK_Y": 0.1545844,
    "CMYK_K": 0.439335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06719",
    "Farbtonhilfsbezeichnung": "M9.41.48",
    "Farbtonklasse": "03",
    "Rcolor": "18",
    "Gcolor": "152",
    "Bcolor": "132",
    "Y": 24,
    "L": 56.1813580932668,
    "a": -37.2798070298512,
    "b": 0.11879965859773,
    "C": 37.2799963189621,
    "h": -0.00318669182931,
    "CMY_C": 0.931007,
    "CMY_M": 0.4058761,
    "CMY_Y": 0.4810383,
    "CMYK_C": 0.8838744,
    "CMYK_M": 0,
    "CMYK_Y": 0.1265093,
    "CMYK_K": 0.4058761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06720",
    "Farbtonhilfsbezeichnung": "M7.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "151",
    "Bcolor": "133",
    "Y": 25,
    "L": 57.2013015063426,
    "a": -29.0786898978562,
    "b": 1.20705291797736,
    "C": 29.1037314260987,
    "h": -0.04148606278827,
    "CMY_C": 0.7265658,
    "CMY_M": 0.4077905,
    "CMY_Y": 0.477374,
    "CMYK_C": 0.5382813,
    "CMYK_M": 0,
    "CMYK_Y": 0.1174981,
    "CMYK_K": 0.4077905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06721",
    "Farbtonhilfsbezeichnung": "M8.19.61",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "181",
    "Bcolor": "167",
    "Y": 40,
    "L": 69.3561010753743,
    "a": -21.4660050931305,
    "b": 0.14356185864472,
    "C": 21.4664851493103,
    "h": -0.00668777062552,
    "CMY_C": 0.5187317,
    "CMY_M": 0.292028,
    "CMY_Y": 0.3447774,
    "CMYK_C": 0.3202157,
    "CMYK_M": 0,
    "CMYK_Y": 0.07450789,
    "CMYK_K": 0.292028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06723",
    "Farbtonhilfsbezeichnung": "M9.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "194",
    "Bcolor": "188",
    "Y": 51,
    "L": 76.6619472652165,
    "a": -7.66363097639561,
    "b": -0.34214206280931,
    "C": 7.67126462413556,
    "h": 0.04461527699553,
    "CMY_C": 0.3202916,
    "CMY_M": 0.2406883,
    "CMY_Y": 0.2624987,
    "CMYK_C": 0.1048361,
    "CMYK_M": 0,
    "CMYK_Y": 0.02872393,
    "CMYK_K": 0.2406883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06724",
    "Farbtonhilfsbezeichnung": "M6.03.62",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "173",
    "Bcolor": "169",
    "Y": 41,
    "L": 69.8854845353376,
    "a": -3.90171527084276,
    "b": 0.10869908021853,
    "C": 3.90322911763683,
    "h": -0.02785210191628,
    "CMY_C": 0.3598702,
    "CMY_M": 0.3213676,
    "CMY_Y": 0.3368518,
    "CMYK_C": 0.0567355,
    "CMYK_M": 0,
    "CMYK_Y": 0.0228168,
    "CMYK_K": 0.3213676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06725",
    "Farbtonhilfsbezeichnung": "M8.56.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "141",
    "Bcolor": "118",
    "Y": 19,
    "L": 51.0265745654115,
    "a": -46.6041694593108,
    "b": 0.61310205594442,
    "C": 46.6082021228363,
    "h": -0.01315476055777,
    "CMY_C": 1,
    "CMY_M": 0.4475961,
    "CMY_Y": 0.5362651,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1605147,
    "CMYK_K": 0.4475961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06726",
    "Farbtonhilfsbezeichnung": "M6.55.39",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "103",
    "Y": 16,
    "L": 47.0929829832853,
    "a": -44.2196822366211,
    "b": 4.02292444473538,
    "C": 44.4022996949009,
    "h": -0.09072612709398,
    "CMY_C": 1,
    "CMY_M": 0.4920893,
    "CMY_Y": 0.5967519,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.206065,
    "CMYK_K": 0.4920893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06727",
    "Farbtonhilfsbezeichnung": "M8.40.40",
    "Farbtonklasse": "03",
    "Rcolor": "25",
    "Gcolor": "130",
    "Bcolor": "114",
    "Y": 17,
    "L": 48.7278562001238,
    "a": -32.1123296858431,
    "b": -0.00613425002105,
    "C": 32.1123302717399,
    "h": 0.00019102475611,
    "CMY_C": 0.9011794,
    "CMY_M": 0.4903815,
    "CMY_Y": 0.5532718,
    "CMYK_C": 0.8060892,
    "CMYK_M": 0,
    "CMYK_Y": 0.1234066,
    "CMYK_K": 0.4903815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06728",
    "Farbtonhilfsbezeichnung": "M7.36.40",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "127",
    "Bcolor": "109",
    "Y": 17,
    "L": 48.2062920359681,
    "a": -28.5241650477428,
    "b": 2.11075682092261,
    "C": 28.6021552689294,
    "h": -0.07386427283794,
    "CMY_C": 0.8114928,
    "CMY_M": 0.5013282,
    "CMY_Y": 0.5719181,
    "CMYK_C": 0.6219814,
    "CMYK_M": 0,
    "CMYK_Y": 0.1415559,
    "CMYK_K": 0.5013282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06729",
    "Farbtonhilfsbezeichnung": "M9.21.51",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "151",
    "Bcolor": "139",
    "Y": 27,
    "L": 58.6079082776491,
    "a": -19.9330403427778,
    "b": -0.15604774119575,
    "C": 19.9336511508639,
    "h": 0.00782843714424,
    "CMY_C": 0.6146731,
    "CMY_M": 0.4080404,
    "CMY_Y": 0.452966,
    "CMYK_C": 0.3490654,
    "CMYK_M": 0,
    "CMYK_Y": 0.07589293,
    "CMYK_K": 0.4080404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06730",
    "Farbtonhilfsbezeichnung": "M8.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "123",
    "Bcolor": "114",
    "Y": 17,
    "L": 48.5346981397982,
    "a": -16.2287878405319,
    "b": 0.17508284259206,
    "C": 16.2297322459357,
    "h": -0.01078799305076,
    "CMY_C": 0.6766098,
    "CMY_M": 0.5171102,
    "CMY_Y": 0.5547187,
    "CMYK_C": 0.3303022,
    "CMYK_M": 0,
    "CMYK_Y": 0.07788205,
    "CMYK_K": 0.5171102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06731",
    "Farbtonhilfsbezeichnung": "M5.07.53",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "153",
    "Bcolor": "144",
    "Y": 30,
    "L": 61.4691158163101,
    "a": -7.85273616910931,
    "b": 1.43513907951291,
    "C": 7.98279960409772,
    "h": -0.18076170340743,
    "CMY_C": 0.4729461,
    "CMY_M": 0.4015138,
    "CMY_Y": 0.4334015,
    "CMYK_C": 0.1193549,
    "CMYK_M": 0,
    "CMYK_Y": 0.05328055,
    "CMYK_K": 0.4015138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06732",
    "Farbtonhilfsbezeichnung": "N0.03.55",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "154",
    "Bcolor": "151",
    "Y": 32,
    "L": 62.9307742873779,
    "a": -3.69788581512021,
    "b": -0.10756912452192,
    "C": 3.69945004267089,
    "h": 0.02908115716954,
    "CMY_C": 0.4310676,
    "CMY_M": 0.3945672,
    "CMY_Y": 0.4073813,
    "CMYK_C": 0.06028818,
    "CMYK_M": 0,
    "CMYK_Y": 0.02116521,
    "CMYK_K": 0.3945672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06733",
    "Farbtonhilfsbezeichnung": "M7.56.36",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "124",
    "Bcolor": "101",
    "Y": 15,
    "L": 45.4446221713896,
    "a": -41.3800768919652,
    "b": 2.78428265316151,
    "C": 41.473642153513,
    "h": -0.06718431747347,
    "CMY_C": 1,
    "CMY_M": 0.5122377,
    "CMY_Y": 0.6040941,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1883221,
    "CMYK_K": 0.5122377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06734",
    "Farbtonhilfsbezeichnung": "M9.53.39",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "137",
    "Bcolor": "116",
    "Y": 17,
    "L": 50.3801422119141,
    "a": -40.3088684082031,
    "b": 1.11074542999268,
    "C": 40.3241691589355,
    "h": 178.42155456543,
    "CMY_C": 1,
    "CMY_M": 0.46245533227921,
    "CMY_Y": 0.54533123970032,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.15417492389679,
    "CMYK_K": 0.46245533227921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06735",
    "Farbtonhilfsbezeichnung": "M5.44.35",
    "Farbtonklasse": "03",
    "Rcolor": "1",
    "Gcolor": "114",
    "Bcolor": "93",
    "Y": 13,
    "L": 42.4931748391998,
    "a": -32.7717395129739,
    "b": 3.26210681039741,
    "C": 32.9336947752398,
    "h": -0.09921342369992,
    "CMY_C": 0.9977491,
    "CMY_M": 0.5531273,
    "CMY_Y": 0.6343306,
    "CMYK_C": 0.9949631,
    "CMYK_M": 0,
    "CMYK_Y": 0.1817146,
    "CMYK_K": 0.5531273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06736",
    "Farbtonhilfsbezeichnung": "M9.40.35",
    "Farbtonklasse": "03",
    "Rcolor": "18",
    "Gcolor": "115",
    "Bcolor": "99",
    "Y": 13,
    "L": 43.0898757359942,
    "a": -30.0059828710616,
    "b": 0.45353885137666,
    "C": 30.0094102832454,
    "h": -0.01511379644908,
    "CMY_C": 0.9310661,
    "CMY_M": 0.5503166,
    "CMY_Y": 0.6103153,
    "CMYK_C": 0.8467057,
    "CMYK_M": 0,
    "CMYK_Y": 0.1334241,
    "CMYK_K": 0.5503166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06737",
    "Farbtonhilfsbezeichnung": "M8.31.38",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "121",
    "Bcolor": "109",
    "Y": 16,
    "L": 46.5384965301447,
    "a": -24.274235510491,
    "b": -0.20387500996714,
    "C": 24.275091650465,
    "h": 0.00839862562449,
    "CMY_C": 0.7862519,
    "CMY_M": 0.5239963,
    "CMY_Y": 0.572442,
    "CMYK_C": 0.5509528,
    "CMYK_M": 0,
    "CMYK_Y": 0.1017758,
    "CMYK_K": 0.5239963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06738",
    "Farbtonhilfsbezeichnung": "M9.21.31",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "102",
    "Bcolor": "95",
    "Y": 11,
    "L": 40.7098197937012,
    "a": -13.0630130767822,
    "b": 0.01295184809715,
    "C": 13.0630197525024,
    "h": 179.94319152832,
    "CMY_C": 0.723004758358,
    "CMY_M": 0.59932029247284,
    "CMY_Y": 0.62833535671234,
    "CMYK_C": 0.30868661403656,
    "CMYK_M": 0,
    "CMYK_Y": 0.07241460680962,
    "CMYK_K": 0.59932029247284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06739",
    "Farbtonhilfsbezeichnung": "N0.04.48",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "137",
    "Bcolor": "134",
    "Y": 24,
    "L": 55.9104313398503,
    "a": -4.73196123630554,
    "b": -0.61827537516772,
    "C": 4.77218205661069,
    "h": 0.12992342372198,
    "CMY_C": 0.5117242,
    "CMY_M": 0.4642301,
    "CMY_Y": 0.4752375,
    "CMYK_C": 0.08864654,
    "CMYK_M": 0,
    "CMYK_Y": 0.02054508,
    "CMYK_K": 0.4642301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06740",
    "Farbtonhilfsbezeichnung": "M7.59.31",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "92",
    "Y": 12,
    "L": 41.0604840203531,
    "a": -39.4199638910342,
    "b": 1.77664945965151,
    "C": 39.4599801884507,
    "h": -0.04503930971566,
    "CMY_C": 1,
    "CMY_M": 0.5588597,
    "CMY_Y": 0.63884,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1813036,
    "CMYK_K": 0.5588597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06742",
    "Farbtonhilfsbezeichnung": "M8.45.33",
    "Farbtonklasse": "03",
    "Rcolor": "1",
    "Gcolor": "112",
    "Bcolor": "97",
    "Y": 12,
    "L": 41.764460456452,
    "a": -30.569729438918,
    "b": -0.00496831641114,
    "C": 30.5697298426535,
    "h": 0.0001625240543,
    "CMY_C": 0.9972838,
    "CMY_M": 0.562656,
    "CMY_Y": 0.6199889,
    "CMYK_C": 0.9937891,
    "CMYK_M": 0,
    "CMYK_Y": 0.1310933,
    "CMYK_K": 0.562656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06743",
    "Farbtonhilfsbezeichnung": "M6.45.34",
    "Farbtonklasse": "03",
    "Rcolor": "6",
    "Gcolor": "115",
    "Bcolor": "96",
    "Y": 13,
    "L": 43.0217140119055,
    "a": -32.0938119808195,
    "b": 2.28191152365852,
    "C": 32.1748331411679,
    "h": -0.07098183993676,
    "CMY_C": 0.9776649,
    "CMY_M": 0.5485458,
    "CMY_Y": 0.6229562,
    "CMYK_C": 0.9505263,
    "CMYK_M": 0,
    "CMYK_Y": 0.1648237,
    "CMYK_K": 0.5485458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06744",
    "Farbtonhilfsbezeichnung": "M8.31.30",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "100",
    "Bcolor": "89",
    "Y": 10,
    "L": 38.4945999389349,
    "a": -20.653356707338,
    "b": 0.3201167581054,
    "C": 20.6558373836396,
    "h": -0.01549826170938,
    "CMY_C": 0.8192914,
    "CMY_M": 0.608796,
    "CMY_Y": 0.6518256,
    "CMYK_C": 0.5380708,
    "CMYK_M": 0,
    "CMYK_Y": 0.1099928,
    "CMYK_K": 0.608796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06745",
    "Farbtonhilfsbezeichnung": "M4.21.31",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "99",
    "Bcolor": "88",
    "Y": 11,
    "L": 39.2206541767699,
    "a": -14.6073062042655,
    "b": 2.08643953754424,
    "C": 14.7555624931414,
    "h": -0.14187568702603,
    "CMY_C": 0.7417141,
    "CMY_M": 0.6115772,
    "CMY_Y": 0.6555815,
    "CMYK_C": 0.3350393,
    "CMYK_M": 0,
    "CMYK_Y": 0.1132897,
    "CMYK_K": 0.6115772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06746",
    "Farbtonhilfsbezeichnung": "M8.04.39",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "116",
    "Bcolor": "114",
    "Y": 17,
    "L": 47.902658594342,
    "a": -3.3634396077597,
    "b": -0.58292900019014,
    "C": 3.41358055629414,
    "h": 0.17160867197048,
    "CMY_C": 0.5801636,
    "CMY_M": 0.5469479,
    "CMY_Y": 0.5544658,
    "CMYK_C": 0.07331545,
    "CMYK_M": 0,
    "CMYK_Y": 0.01659404,
    "CMYK_K": 0.5469479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06747",
    "Farbtonhilfsbezeichnung": "M4.64.26",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "72",
    "Y": 9,
    "L": 35.3941270302645,
    "a": -37.2903159386148,
    "b": 6.26426951481842,
    "C": 37.8128117885459,
    "h": -0.16643256033947,
    "CMY_C": 1,
    "CMY_M": 0.618465,
    "CMY_Y": 0.7192534,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2641656,
    "CMYK_K": 0.618465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06748",
    "Farbtonhilfsbezeichnung": "M6.52.26",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "93",
    "Bcolor": "78",
    "Y": 8,
    "L": 34.5057195755804,
    "a": -29.9503725345026,
    "b": 1.26325396330841,
    "C": 29.9770016100894,
    "h": -0.04215325366093,
    "CMY_C": 1,
    "CMY_M": 0.6348991,
    "CMY_Y": 0.6953618,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1656053,
    "CMYK_K": 0.6348991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06749",
    "Farbtonhilfsbezeichnung": "M8.51.30",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "109",
    "Bcolor": "93",
    "Y": 11,
    "L": 40.8539428710938,
    "a": -29.5038833618164,
    "b": 1.23335337638855,
    "C": 29.5296516418457,
    "h": 177.606262207031,
    "CMY_C": 0.94340217113495,
    "CMY_M": 0.57338488101959,
    "CMY_Y": 0.63639724254608,
    "CMYK_C": 0.86733281612396,
    "CMYK_M": 0,
    "CMYK_Y": 0.14770306646824,
    "CMYK_K": 0.57338488101959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06750",
    "Farbtonhilfsbezeichnung": "M8.43.28",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "100",
    "Bcolor": "87",
    "Y": 10,
    "L": 37.9913449026201,
    "a": -24.9589573016821,
    "b": 0.66473416436533,
    "C": 24.9678076950393,
    "h": -0.02662679586774,
    "CMY_C": 0.8843176,
    "CMY_M": 0.6075612,
    "CMY_Y": 0.6590955,
    "CMYK_C": 0.7052218,
    "CMYK_M": 0,
    "CMYK_Y": 0.131318,
    "CMYK_K": 0.6075612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06751",
    "Farbtonhilfsbezeichnung": "M4.38.23",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "88",
    "Bcolor": "75",
    "Y": 8,
    "L": 33.8588162700755,
    "a": -19.3542164090439,
    "b": 2.41796890238494,
    "C": 19.504672938068,
    "h": -0.12428844397886,
    "CMY_C": 0.8368948,
    "CMY_M": 0.6555007,
    "CMY_Y": 0.7073863,
    "CMYK_C": 0.5265442,
    "CMYK_M": 0,
    "CMYK_Y": 0.1506118,
    "CMYK_K": 0.6555007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06752",
    "Farbtonhilfsbezeichnung": "M8.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "79",
    "Bcolor": "74",
    "Y": 7,
    "L": 31.4537493819356,
    "a": -10.3250444055725,
    "b": -0.49550272288946,
    "C": 10.3369272477577,
    "h": 0.04795358109631,
    "CMY_C": 0.786309,
    "CMY_M": 0.6911807,
    "CMY_Y": 0.710397,
    "CMYK_C": 0.3080387,
    "CMYK_M": 0,
    "CMYK_Y": 0.06222501,
    "CMYK_K": 0.6911807
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06753",
    "Farbtonhilfsbezeichnung": "M9.10.30",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "97",
    "Bcolor": "93",
    "Y": 11,
    "L": 39.67669046556,
    "a": -6.61864331630871,
    "b": -0.4471512028474,
    "C": 6.63373074119879,
    "h": 0.0674568386579,
    "CMY_C": 0.6820877,
    "CMY_M": 0.6204272,
    "CMY_Y": 0.6344597,
    "CMYK_C": 0.1624471,
    "CMYK_M": 0,
    "CMYK_Y": 0.03696923,
    "CMYK_K": 0.6204272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06754",
    "Farbtonhilfsbezeichnung": "M7.64.25",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "94",
    "Bcolor": "77",
    "Y": 8,
    "L": 34.2728446313337,
    "a": -36.474724651226,
    "b": 1.55235847823295,
    "C": 36.5077437707084,
    "h": -0.04253417201535,
    "CMY_C": 1,
    "CMY_M": 0.6295155,
    "CMY_Y": 0.6998373,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1898102,
    "CMYK_K": 0.6295155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06755",
    "Farbtonhilfsbezeichnung": "M9.58.23",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "78",
    "Y": 7,
    "L": 32.9126278666861,
    "a": -28.8220384422907,
    "b": -1.03482301921636,
    "C": 28.8406095401949,
    "h": 0.03588846449453,
    "CMY_C": 1,
    "CMY_M": 0.6511713,
    "CMY_Y": 0.695566,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1272679,
    "CMYK_K": 0.6511713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06756",
    "Farbtonhilfsbezeichnung": "M8.43.21",
    "Farbtonklasse": "03",
    "Rcolor": "9",
    "Gcolor": "78",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.2931101410939,
    "a": -22.7742369313487,
    "b": -0.01650956139563,
    "C": 22.7742429154258,
    "h": 0.00072492257604,
    "CMY_C": 0.9652517,
    "CMY_M": 0.693252,
    "CMY_Y": 0.7338498,
    "CMYK_C": 0.8867205,
    "CMYK_M": 0,
    "CMYK_Y": 0.132349,
    "CMYK_K": 0.693252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06757",
    "Farbtonhilfsbezeichnung": "M8.40.21",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "81",
    "Bcolor": "72",
    "Y": 7,
    "L": 31.032917246301,
    "a": -19.7582860923659,
    "b": 0.08513172864214,
    "C": 19.7584694933338,
    "h": -0.00430863291681,
    "CMY_C": 0.8847861,
    "CMY_M": 0.68105,
    "CMY_Y": 0.7186267,
    "CMYK_C": 0.6387714,
    "CMYK_M": 0,
    "CMYK_Y": 0.1178138,
    "CMYK_K": 0.68105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06758",
    "Farbtonhilfsbezeichnung": "M7.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "78",
    "Bcolor": "70",
    "Y": 6,
    "L": 30.3324793528984,
    "a": -15.4553801036581,
    "b": -0.04203359903083,
    "C": 15.4554372624005,
    "h": 0.00271966752766,
    "CMY_C": 0.8413418,
    "CMY_M": 0.6936954,
    "CMY_Y": 0.7237386,
    "CMYK_C": 0.4820247,
    "CMYK_M": 0,
    "CMYK_Y": 0.09808267,
    "CMYK_K": 0.6936954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06759",
    "Farbtonhilfsbezeichnung": "M4.17.14",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "62",
    "Bcolor": "58",
    "Y": 4,
    "L": 24.9516873549786,
    "a": -7.0805921709661,
    "b": 0.13468020942155,
    "C": 7.08187293379063,
    "h": -0.01901874409196,
    "CMY_C": 0.8153642,
    "CMY_M": 0.7554217,
    "CMY_Y": 0.771477,
    "CMYK_C": 0.245085,
    "CMYK_M": 0,
    "CMYK_Y": 0.0656448,
    "CMYK_K": 0.7554217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06760",
    "Farbtonhilfsbezeichnung": "M6.09.20",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "71",
    "Bcolor": "69",
    "Y": 6,
    "L": 29.395227318333,
    "a": -4.6476260502088,
    "b": -0.23856442195996,
    "C": 4.65374482390306,
    "h": 0.05128537153557,
    "CMY_C": 0.7603319,
    "CMY_M": 0.719645,
    "CMY_Y": 0.7298553,
    "CMYK_C": 0.1451262,
    "CMYK_M": 0,
    "CMYK_Y": 0.03641906,
    "CMYK_K": 0.719645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06761",
    "Farbtonhilfsbezeichnung": "N0.05.30",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "91",
    "Bcolor": "90",
    "Y": 10,
    "L": 37.9997500722111,
    "a": -3.36808013384371,
    "b": -0.71073806000733,
    "C": 3.44225396766939,
    "h": 0.20797055729256,
    "CMY_C": 0.6747084,
    "CMY_M": 0.6423224,
    "CMY_Y": 0.6481645,
    "CMYK_C": 0.09054517,
    "CMYK_M": 0,
    "CMYK_Y": 0.01633344,
    "CMYK_K": 0.6423224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06762",
    "Farbtonhilfsbezeichnung": "M4.64.20",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "67",
    "Y": 7,
    "L": 32.2705166965498,
    "a": -31.5884398491623,
    "b": 5.06088523182896,
    "C": 31.9912814909608,
    "h": -0.15886313977573,
    "CMY_C": 1,
    "CMY_M": 0.6551628,
    "CMY_Y": 0.7391513,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2435599,
    "CMYK_K": 0.6551628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06763",
    "Farbtonhilfsbezeichnung": "M6.61.20",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "69",
    "Y": 7,
    "L": 31.995460905993,
    "a": -32.5036153362374,
    "b": 3.37856626866476,
    "C": 32.678734980991,
    "h": -0.10357237775487,
    "CMY_C": 1,
    "CMY_M": 0.6564421,
    "CMY_Y": 0.7313055,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.2179064,
    "CMYK_K": 0.6564421
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06764",
    "Farbtonhilfsbezeichnung": "M8.51.20",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "80",
    "Bcolor": "68",
    "Y": 6,
    "L": 29.584330407607,
    "a": -26.4993265302511,
    "b": 0.52501190895979,
    "C": 26.5045268597917,
    "h": -0.01980968198921,
    "CMY_C": 1,
    "CMY_M": 0.6859572,
    "CMY_Y": 0.7348506,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1556903,
    "CMYK_K": 0.6859572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06765",
    "Farbtonhilfsbezeichnung": "M4.30.18",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "71",
    "Bcolor": "61",
    "Y": 5,
    "L": 27.5220518179346,
    "a": -14.393998059249,
    "b": 1.75748577012951,
    "C": 14.5008943297257,
    "h": -0.12149713377714,
    "CMY_C": 0.8474169,
    "CMY_M": 0.7214236,
    "CMY_Y": 0.7593518,
    "CMYK_C": 0.4522757,
    "CMYK_M": 0,
    "CMYK_Y": 0.13615,
    "CMYK_K": 0.7214236
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06766",
    "Farbtonhilfsbezeichnung": "M7.25.16",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "66",
    "Bcolor": "61",
    "Y": 5,
    "L": 25.6888021986079,
    "a": -12.2003766343167,
    "b": -0.75934290045383,
    "C": 12.2239842792623,
    "h": 0.06215912010198,
    "CMY_C": 0.8548564,
    "CMY_M": 0.7407176,
    "CMY_Y": 0.7603008,
    "CMYK_C": 0.4402103,
    "CMYK_M": 0,
    "CMYK_Y": 0.07552855,
    "CMYK_K": 0.7407176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06767",
    "Farbtonhilfsbezeichnung": "M7.12.12",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "58",
    "Bcolor": "56",
    "Y": 4,
    "L": 23.3107349576748,
    "a": -4.80907042771545,
    "b": -0.69128816819921,
    "C": 4.85850159104836,
    "h": 0.14276874527081,
    "CMY_C": 0.8158205,
    "CMY_M": 0.7734296,
    "CMY_Y": 0.7806647,
    "CMYK_C": 0.187098,
    "CMYK_M": 0,
    "CMYK_Y": 0.03193337,
    "CMYK_K": 0.7734296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06768",
    "Farbtonhilfsbezeichnung": "M7.11.11",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "60",
    "Bcolor": "59",
    "Y": 4,
    "L": 24.5578744532277,
    "a": -3.45246609808494,
    "b": -0.89983191867931,
    "C": 3.56780319528698,
    "h": 0.25496232928066,
    "CMY_C": 0.7964294,
    "CMY_M": 0.7647562999999999,
    "CMY_Y": 0.7685044,
    "CMYK_C": 0.1346394,
    "CMYK_M": 0,
    "CMYK_Y": 0.01593276,
    "CMYK_K": 0.7647562999999999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06769",
    "Farbtonhilfsbezeichnung": "M9.08.17",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "67",
    "Bcolor": "65",
    "Y": 5,
    "L": 27.4837392438983,
    "a": -4.06338782055463,
    "b": -0.76989305536615,
    "C": 4.13568082628879,
    "h": 0.18725106760176,
    "CMY_C": 0.7747931,
    "CMY_M": 0.7377595,
    "CMY_Y": 0.7436317,
    "CMYK_C": 0.1412202,
    "CMYK_M": 0,
    "CMYK_Y": 0.02239229,
    "CMYK_K": 0.7377595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06770",
    "Farbtonhilfsbezeichnung": "N0.25.68",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "203",
    "Bcolor": "188",
    "Y": 50,
    "L": 76.2826713462209,
    "a": -29.3297428675558,
    "b": -1.47220039743521,
    "C": 29.3666680215367,
    "h": 0.05015270192938,
    "CMY_C": 0.5404885,
    "CMY_M": 0.2023087,
    "CMY_Y": 0.2610503,
    "CMYK_C": 0.4239482,
    "CMYK_M": 0,
    "CMYK_Y": 0.07363956,
    "CMYK_K": 0.2023087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06771",
    "Farbtonhilfsbezeichnung": "N3.16.77",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "223",
    "Bcolor": "214",
    "Y": 66,
    "L": 84.7464196617452,
    "a": -21.1012431398992,
    "b": -2.56338422552109,
    "C": 21.2563731792795,
    "h": 0.12088790338841,
    "CMY_C": 0.3656649,
    "CMY_M": 0.1238409,
    "CMY_Y": 0.1607176,
    "CMYK_C": 0.2760047,
    "CMYK_M": 0,
    "CMYK_Y": 0.04208902,
    "CMYK_K": 0.1238409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06772",
    "Farbtonhilfsbezeichnung": "N2.11.81",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "229",
    "Bcolor": "220",
    "Y": 72,
    "L": 87.8099606008349,
    "a": -14.3915604833476,
    "b": -0.81817800042698,
    "C": 14.4147989367259,
    "h": 0.05679010550594,
    "CMY_C": 0.2607995,
    "CMY_M": 0.103834,
    "CMY_Y": 0.1391255,
    "CMYK_C": 0.1751523,
    "CMYK_M": 0,
    "CMYK_Y": 0.03938062,
    "CMYK_K": 0.103834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06773",
    "Farbtonhilfsbezeichnung": "N5.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "232",
    "Bcolor": "226",
    "Y": 76,
    "L": 89.7433759212299,
    "a": -10.9641002113808,
    "b": -1.48564017408241,
    "C": 11.0642948339263,
    "h": 0.13468015754372,
    "CMY_C": 0.2119823,
    "CMY_M": 0.08937077,
    "CMY_Y": 0.1124533,
    "CMYK_C": 0.1346448,
    "CMYK_M": 0,
    "CMYK_Y": 0.02534788,
    "CMYK_K": 0.08937077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06774",
    "Farbtonhilfsbezeichnung": "N3.05.85",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "237",
    "Bcolor": "230",
    "Y": 81,
    "L": 92.0500364587265,
    "a": -7.10090674563341,
    "b": -0.09202936346406,
    "C": 7.10150308131466,
    "h": 0.01295950145986,
    "CMY_C": 0.1479541,
    "CMY_M": 0.07247017,
    "CMY_Y": 0.09674226,
    "CMYK_C": 0.08138167,
    "CMYK_M": 0,
    "CMYK_Y": 0.02616854,
    "CMYK_K": 0.07247017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06775",
    "Farbtonhilfsbezeichnung": "N2.31.65",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "197",
    "Bcolor": "184",
    "Y": 46,
    "L": 73.2357144859798,
    "a": -34.0042738737887,
    "b": -3.50240298816982,
    "C": 34.1841698506073,
    "h": 0.10263697568671,
    "CMY_C": 0.6521852,
    "CMY_M": 0.2271451,
    "CMY_Y": 0.2794921,
    "CMYK_C": 0.549961,
    "CMYK_M": 0,
    "CMYK_Y": 0.06773198,
    "CMYK_K": 0.2271451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06776",
    "Farbtonhilfsbezeichnung": "N5.19.76",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "218",
    "Bcolor": "210",
    "Y": 61,
    "L": 82.6133335771634,
    "a": -22.7343845660179,
    "b": -3.49619096221594,
    "C": 23.0016432639034,
    "h": 0.15258888461723,
    "CMY_C": 0.4101495,
    "CMY_M": 0.1441085,
    "CMY_Y": 0.177379,
    "CMYK_C": 0.3108349,
    "CMYK_M": 0,
    "CMYK_Y": 0.03887228,
    "CMYK_K": 0.1441085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06777",
    "Farbtonhilfsbezeichnung": "N5.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "230",
    "Bcolor": "223",
    "Y": 73,
    "L": 88.2721148429344,
    "a": -13.952198487771,
    "b": -2.00056838845384,
    "C": 14.0948968254131,
    "h": 0.14241659234692,
    "CMY_C": 0.2568526,
    "CMY_M": 0.09927259,
    "CMY_Y": 0.1252689,
    "CMYK_C": 0.1749475,
    "CMYK_M": 0,
    "CMYK_Y": 0.02886145,
    "CMYK_K": 0.09927259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06778",
    "Farbtonhilfsbezeichnung": "N2.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "231",
    "Bcolor": "225",
    "Y": 75,
    "L": 89.6147430453506,
    "a": -9.45323782459451,
    "b": -0.96048073014243,
    "C": 9.50190657717277,
    "h": 0.10125588478446,
    "CMY_C": 0.1981382,
    "CMY_M": 0.09425572,
    "CMY_Y": 0.1175609,
    "CMYK_C": 0.1146929,
    "CMYK_M": 0,
    "CMYK_Y": 0.02573042,
    "CMYK_K": 0.09425572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06779",
    "Farbtonhilfsbezeichnung": "NN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "229",
    "Bcolor": "222",
    "Y": 77,
    "L": 90.2107916563489,
    "a": -3.47054693543464,
    "b": 1.48155971632702,
    "C": 3.77355471990241,
    "h": -0.40347477586867,
    "CMY_C": 0.1326183,
    "CMY_M": 0.101755,
    "CMY_Y": 0.1282413,
    "CMYK_C": 0.03435953,
    "CMYK_M": 0,
    "CMYK_Y": 0.02948675,
    "CMYK_K": 0.101755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06780",
    "Farbtonhilfsbezeichnung": "N3.34.65",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "199",
    "Bcolor": "185",
    "Y": 46,
    "L": 73.3403089291563,
    "a": -38.0286943473395,
    "b": -4.15093502904547,
    "C": 38.2545664643939,
    "h": 0.10872228907599,
    "CMY_C": 0.7271354,
    "CMY_M": 0.2192095,
    "CMY_Y": 0.2741763,
    "CMYK_C": 0.6505278,
    "CMYK_M": 0,
    "CMYK_Y": 0.07039896,
    "CMYK_K": 0.2192095
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06781",
    "Farbtonhilfsbezeichnung": "N3.24.69",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "204",
    "Bcolor": "193",
    "Y": 51,
    "L": 76.6826470170918,
    "a": -28.5542150543944,
    "b": -3.2786433497431,
    "C": 28.741828396736,
    "h": 0.11432104474562,
    "CMY_C": 0.538132,
    "CMY_M": 0.1988283,
    "CMY_Y": 0.2437144,
    "CMYK_C": 0.4235094,
    "CMYK_M": 0,
    "CMYK_Y": 0.05602559,
    "CMYK_K": 0.1988283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06782",
    "Farbtonhilfsbezeichnung": "N3.17.73",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "211",
    "Bcolor": "202",
    "Y": 57,
    "L": 80.2610586401298,
    "a": -22.3405352431602,
    "b": -2.73175933386893,
    "C": 22.5069327987858,
    "h": 0.12167412813209,
    "CMY_C": 0.4272988,
    "CMY_M": 0.171086,
    "CMY_Y": 0.2084169,
    "CMYK_C": 0.3090946,
    "CMYK_M": 0,
    "CMYK_Y": 0.0450359,
    "CMYK_K": 0.171086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06783",
    "Farbtonhilfsbezeichnung": "N0.09.79",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "224",
    "Bcolor": "214",
    "Y": 69,
    "L": 86.3653546189743,
    "a": -13.4064625565479,
    "b": 0.12875410384471,
    "C": 13.4070808119955,
    "h": -0.00960358819441,
    "CMY_C": 0.2636743,
    "CMY_M": 0.122255,
    "CMY_Y": 0.1617975,
    "CMYK_C": 0.1611167,
    "CMYK_M": 0,
    "CMYK_Y": 0.04505018,
    "CMYK_K": 0.122255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06784",
    "Farbtonhilfsbezeichnung": "N5.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "220",
    "Bcolor": "215",
    "Y": 68,
    "L": 86.1836921207858,
    "a": -7.63084180010004,
    "b": -0.74882779160936,
    "C": 7.66749565631704,
    "h": 0.09781855105189,
    "CMY_C": 0.2192424,
    "CMY_M": 0.1364811,
    "CMY_Y": 0.1565982,
    "CMYK_C": 0.0958419,
    "CMYK_M": 0,
    "CMYK_Y": 0.02329664,
    "CMYK_K": 0.1364811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06785",
    "Farbtonhilfsbezeichnung": "N1.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 79,
    "L": 91.0890214615928,
    "a": -6.82388231701403,
    "b": -0.36292396572295,
    "C": 6.83352644550036,
    "h": 0.05313432180354,
    "CMY_C": 0.1572569,
    "CMY_M": 0.08378597,
    "CMY_Y": 0.1053408,
    "CMYK_C": 0.0801897,
    "CMYK_M": 0,
    "CMYK_Y": 0.02352602,
    "CMYK_K": 0.08378597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06786",
    "Farbtonhilfsbezeichnung": "N4.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "227",
    "Bcolor": "223",
    "Y": 75,
    "L": 89.2446946362633,
    "a": -4.62519996871485,
    "b": -0.26235794893829,
    "C": 4.63263493532255,
    "h": 0.05666287037152,
    "CMY_C": 0.1589401,
    "CMY_M": 0.1093788,
    "CMY_Y": 0.1261589,
    "CMYK_C": 0.05564799,
    "CMYK_M": 0,
    "CMYK_Y": 0.01884096,
    "CMYK_K": 0.1093788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06787",
    "Farbtonhilfsbezeichnung": "N5.37.59",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "182",
    "Bcolor": "173",
    "Y": 37,
    "L": 67.1966003113661,
    "a": -38.5801865523482,
    "b": -6.89468679035978,
    "C": 39.1914212596475,
    "h": 0.17684368593622,
    "CMY_C": 0.8923196,
    "CMY_M": 0.2846971,
    "CMY_Y": 0.3197978,
    "CMYK_C": 0.8494617,
    "CMYK_M": 0,
    "CMYK_Y": 0.04907105,
    "CMYK_K": 0.2846971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06788",
    "Farbtonhilfsbezeichnung": "N3.28.60",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "179",
    "Bcolor": "169",
    "Y": 37,
    "L": 67.5307070840224,
    "a": -29.1537649770672,
    "b": -3.76298212552442,
    "C": 29.3956127137212,
    "h": 0.12836391687213,
    "CMY_C": 0.6496816,
    "CMY_M": 0.297103,
    "CMY_Y": 0.337291,
    "CMYK_C": 0.5016077,
    "CMYK_M": 0,
    "CMYK_Y": 0.05717492,
    "CMYK_K": 0.297103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06789",
    "Farbtonhilfsbezeichnung": "N3.11.76",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "216",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.3482099211702,
    "a": -14.1395504420052,
    "b": -1.24803731061756,
    "C": 14.1945230223035,
    "h": 0.08803754395513,
    "CMY_C": 0.3084956,
    "CMY_M": 0.1537703,
    "CMY_Y": 0.1847209,
    "CMYK_C": 0.1828407,
    "CMYK_M": 0,
    "CMYK_Y": 0.0365747,
    "CMYK_K": 0.1537703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06790",
    "Farbtonhilfsbezeichnung": "N3.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "205",
    "Bcolor": "200",
    "Y": 57,
    "L": 80.1772315775306,
    "a": -10.1669489625508,
    "b": -1.47303183723342,
    "C": 10.2731043993827,
    "h": 0.14388315568493,
    "CMY_C": 0.3083677,
    "CMY_M": 0.1968562,
    "CMY_Y": 0.2169496,
    "CMYK_C": 0.1388438,
    "CMYK_M": 0,
    "CMYK_Y": 0.02501841,
    "CMYK_K": 0.1968562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06791",
    "Farbtonhilfsbezeichnung": "N0.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "223",
    "Bcolor": "215",
    "Y": 71,
    "L": 87.6877789680818,
    "a": -5.66333828670323,
    "b": 1.61493836558304,
    "C": 5.8890938585041,
    "h": -0.2777839991221,
    "CMY_C": 0.1777549,
    "CMY_M": 0.1248524,
    "CMY_Y": 0.157228,
    "CMYK_C": 0.06044976,
    "CMYK_M": 0,
    "CMYK_Y": 0.03699436,
    "CMYK_K": 0.1248524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06792",
    "Farbtonhilfsbezeichnung": "N2.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "223",
    "Bcolor": "218",
    "Y": 72,
    "L": 87.8438812001785,
    "a": -4.02812625784732,
    "b": 0.14684574448933,
    "C": 4.03080200727271,
    "h": -0.03643896330669,
    "CMY_C": 0.1679847,
    "CMY_M": 0.1264183,
    "CMY_Y": 0.1444986,
    "CMYK_C": 0.04758159,
    "CMYK_M": 0,
    "CMYK_Y": 0.02069668,
    "CMYK_K": 0.1264183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06793",
    "Farbtonhilfsbezeichnung": "N3.38.54",
    "Farbtonklasse": "03",
    "Rcolor": "34",
    "Gcolor": "167",
    "Bcolor": "156",
    "Y": 31,
    "L": 62.0949084620666,
    "a": -36.2875611727014,
    "b": -4.60105192162645,
    "C": 36.5780914571557,
    "h": 0.1261211896518,
    "CMY_C": 0.8656729,
    "CMY_M": 0.34364,
    "CMY_Y": 0.3886226,
    "CMYK_C": 0.7953454,
    "CMYK_M": 0,
    "CMYK_Y": 0.06853346,
    "CMYK_K": 0.34364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06794",
    "Farbtonhilfsbezeichnung": "N1.27.58",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "175",
    "Bcolor": "161",
    "Y": 35,
    "L": 65.9343391731187,
    "a": -28.7554083976274,
    "b": -1.70510233815777,
    "C": 28.8059175534808,
    "h": 0.05922740100004,
    "CMY_C": 0.647404,
    "CMY_M": 0.3153957,
    "CMY_Y": 0.3682534,
    "CMYK_C": 0.4849637,
    "CMYK_M": 0,
    "CMYK_Y": 0.07720906,
    "CMYK_K": 0.3153957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06795",
    "Farbtonhilfsbezeichnung": "N4.19.63",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "184",
    "Bcolor": "176",
    "Y": 42,
    "L": 70.6250351809297,
    "a": -20.8789419193218,
    "b": -3.11199370968336,
    "C": 21.1095883550467,
    "h": 0.14796013343637,
    "CMY_C": 0.5160961,
    "CMY_M": 0.2786586,
    "CMY_Y": 0.3084657,
    "CMYK_C": 0.329161,
    "CMYK_M": 0,
    "CMYK_Y": 0.04132179,
    "CMYK_K": 0.2786586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06796",
    "Farbtonhilfsbezeichnung": "N4.12.67",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "189",
    "Bcolor": "183",
    "Y": 47,
    "L": 73.9090594809234,
    "a": -13.669143724157,
    "b": -2.01848072459403,
    "C": 13.817371478947,
    "h": 0.14660745614377,
    "CMY_C": 0.4075933,
    "CMY_M": 0.2575057,
    "CMY_Y": 0.2806069,
    "CMYK_C": 0.2021396,
    "CMYK_M": 0,
    "CMYK_Y": 0.03111294,
    "CMYK_K": 0.2575057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06797",
    "Farbtonhilfsbezeichnung": "N1.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "208",
    "Bcolor": "202",
    "Y": 60,
    "L": 81.8139767637787,
    "a": -7.22316515773874,
    "b": -0.49680659563733,
    "C": 7.24023008539368,
    "h": 0.06867147532231,
    "CMY_C": 0.2621692,
    "CMY_M": 0.1855527,
    "CMY_Y": 0.2059464,
    "CMYK_C": 0.09407178,
    "CMYK_M": 0,
    "CMYK_Y": 0.0250399,
    "CMYK_K": 0.1855527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06798",
    "Farbtonhilfsbezeichnung": "NN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "219",
    "Bcolor": "216",
    "Y": 70,
    "L": 86.8961498259697,
    "a": -2.39092249102962,
    "b": -0.10019896647945,
    "C": 2.3930211430313,
    "h": 0.04188356971431,
    "CMY_C": 0.1660615,
    "CMY_M": 0.1405956,
    "CMY_Y": 0.1528558,
    "CMYK_C": 0.02963206,
    "CMYK_M": 0,
    "CMYK_Y": 0.01426597,
    "CMYK_K": 0.1405956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06799",
    "Farbtonhilfsbezeichnung": "NN.01.76",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "211",
    "Bcolor": "209",
    "Y": 65,
    "L": 84.2613571262946,
    "a": -1.83559730216443,
    "b": -0.28791660731537,
    "C": 1.85804021175036,
    "h": 0.15558407467025,
    "CMY_C": 0.1911601,
    "CMY_M": 0.1708496,
    "CMY_Y": 0.1801858,
    "CMYK_C": 0.02449553,
    "CMYK_M": 0,
    "CMYK_Y": 0.01125996,
    "CMYK_K": 0.1708496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06800",
    "Farbtonhilfsbezeichnung": "N0.50.51",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "163",
    "Bcolor": "142",
    "Y": 27,
    "L": 59.1973008073084,
    "a": -47.830960250362,
    "b": -1.22353060511204,
    "C": 47.8466068348985,
    "h": 0.02557472879866,
    "CMY_C": 1,
    "CMY_M": 0.3590254,
    "CMY_Y": 0.442529,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1302761,
    "CMYK_K": 0.3590254
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06801",
    "Farbtonhilfsbezeichnung": "N4.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "153",
    "Bcolor": "144",
    "Y": 26,
    "L": 57.9434111612147,
    "a": -28.3212029803281,
    "b": -4.15547983794962,
    "C": 28.6244397488676,
    "h": 0.14568725928449,
    "CMY_C": 0.7491454,
    "CMY_M": 0.3999683,
    "CMY_Y": 0.4333893,
    "CMYK_C": 0.5819312,
    "CMYK_M": 0,
    "CMYK_Y": 0.0556988,
    "CMYK_K": 0.3999683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06802",
    "Farbtonhilfsbezeichnung": "N4.21.54",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "158",
    "Bcolor": "151",
    "Y": 29,
    "L": 60.8641098306373,
    "a": -20.9445951449824,
    "b": -3.20761433806809,
    "C": 21.188790799123,
    "h": 0.15196684794512,
    "CMY_C": 0.6183331,
    "CMY_M": 0.3820164,
    "CMY_Y": 0.4092953,
    "CMYK_C": 0.3823996,
    "CMYK_M": 0,
    "CMYK_Y": 0.04414179,
    "CMYK_K": 0.3820164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06803",
    "Farbtonhilfsbezeichnung": "N1.19.63",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "183",
    "Bcolor": "173",
    "Y": 41,
    "L": 70.4570208712272,
    "a": -20.5236161278257,
    "b": -1.54089137320057,
    "C": 20.5813790885438,
    "h": 0.07493834711705,
    "CMY_C": 0.5061879,
    "CMY_M": 0.2815306,
    "CMY_Y": 0.3212737,
    "CMYK_C": 0.3126887,
    "CMYK_M": 0,
    "CMYK_Y": 0.05531635,
    "CMYK_K": 0.2815306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06804",
    "Farbtonhilfsbezeichnung": "N0.13.66",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "189",
    "Bcolor": "181",
    "Y": 46,
    "L": 73.4847038898167,
    "a": -14.9595710553802,
    "b": -1.09861135860112,
    "C": 14.9998571019266,
    "h": 0.0733070952067,
    "CMY_C": 0.4196935,
    "CMY_M": 0.2597521,
    "CMY_Y": 0.2918004,
    "CMYK_C": 0.2160646,
    "CMYK_M": 0,
    "CMYK_Y": 0.04329398,
    "CMYK_K": 0.2597521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06805",
    "Farbtonhilfsbezeichnung": "N5.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "198",
    "Bcolor": "195",
    "Y": 55,
    "L": 78.9468862641267,
    "a": -3.57170087631592,
    "b": -0.75210980047266,
    "C": 3.65002963026918,
    "h": 0.20754254601618,
    "CMY_C": 0.2641953,
    "CMY_M": 0.22478,
    "CMY_Y": 0.2345538,
    "CMYK_C": 0.05084399,
    "CMYK_M": 0,
    "CMYK_Y": 0.0126078,
    "CMYK_K": 0.22478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06806",
    "Farbtonhilfsbezeichnung": "NN.02.76",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "209",
    "Bcolor": "207",
    "Y": 62,
    "L": 82.9124248806609,
    "a": -3.41703658427911,
    "b": -1.31089201650958,
    "C": 3.65986022919597,
    "h": 0.36631878926496,
    "CMY_C": 0.2221515,
    "CMY_M": 0.1817496,
    "CMY_Y": 0.1876286,
    "CMYK_C": 0.04937595,
    "CMYK_M": 0,
    "CMYK_Y": 0.007184926,
    "CMYK_K": 0.1817496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06807",
    "Farbtonhilfsbezeichnung": "NN.02.72",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "201",
    "Bcolor": "199",
    "Y": 57,
    "L": 80.2647209312498,
    "a": -2.8431652587973,
    "b": -0.84583756399174,
    "C": 2.96631587554181,
    "h": 0.28916031632591,
    "CMY_C": 0.2445328,
    "CMY_M": 0.2120759,
    "CMY_Y": 0.2195919,
    "CMYK_C": 0.04119287,
    "CMYK_M": 0,
    "CMYK_Y": 0.009539002,
    "CMYK_K": 0.2120759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06808",
    "Farbtonhilfsbezeichnung": "N5.49.50",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "159",
    "Bcolor": "151",
    "Y": 26,
    "L": 57.9665630276997,
    "a": -43.6361011396975,
    "b": -8.05639486640606,
    "C": 44.3735824665686,
    "h": 0.18257091770031,
    "CMY_C": 1,
    "CMY_M": 0.376181,
    "CMY_Y": 0.4079992,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.05100539,
    "CMYK_K": 0.376181
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06809",
    "Farbtonhilfsbezeichnung": "N3.46.48",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "153",
    "Bcolor": "140",
    "Y": 24,
    "L": 56.1592919606782,
    "a": -41.2832790173525,
    "b": -4.25168153516935,
    "C": 41.5016375857758,
    "h": 0.10262616546869,
    "CMY_C": 1,
    "CMY_M": 0.39948,
    "CMY_Y": 0.4520245,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.08749834,
    "CMYK_K": 0.39948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06810",
    "Farbtonhilfsbezeichnung": "N2.21.53",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "159",
    "Bcolor": "150",
    "Y": 30,
    "L": 61.5330616251466,
    "a": -20.7334743403285,
    "b": -1.76824535317421,
    "C": 20.8087397468006,
    "h": 0.08507869212522,
    "CMY_C": 0.6014467,
    "CMY_M": 0.3757499,
    "CMY_Y": 0.4122926,
    "CMYK_C": 0.3615487,
    "CMYK_M": 0,
    "CMYK_Y": 0.05853858,
    "CMYK_K": 0.3757499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06811",
    "Farbtonhilfsbezeichnung": "N5.13.58",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "165",
    "Bcolor": "160",
    "Y": 34,
    "L": 65.0171746923766,
    "a": -14.136487950687,
    "b": -2.3314416458073,
    "C": 14.3274530788875,
    "h": 0.16345232276761,
    "CMY_C": 0.5050111,
    "CMY_M": 0.3511886,
    "CMY_Y": 0.3717862,
    "CMYK_C": 0.2370835,
    "CMYK_M": 0,
    "CMYK_Y": 0.03174671,
    "CMYK_K": 0.3511886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06812",
    "Farbtonhilfsbezeichnung": "N2.06.61",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "172",
    "Bcolor": "168",
    "Y": 39,
    "L": 68.8277340098233,
    "a": -6.54699004769543,
    "b": -1.1095389138374,
    "C": 6.64034300966016,
    "h": 0.16787804419597,
    "CMY_C": 0.3962483,
    "CMY_M": 0.3265875,
    "CMY_Y": 0.3397181,
    "CMYK_C": 0.1034445,
    "CMYK_M": 0,
    "CMYK_Y": 0.01949861,
    "CMYK_K": 0.3265875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06813",
    "Farbtonhilfsbezeichnung": "N1.04.66",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "184",
    "Bcolor": "180",
    "Y": 46,
    "L": 73.5610374749447,
    "a": -5.38894519154831,
    "b": -0.51957413877001,
    "C": 5.41393457322771,
    "h": 0.09611771607833,
    "CMY_C": 0.3352358,
    "CMY_M": 0.2788747,
    "CMY_Y": 0.2939142,
    "CMYK_C": 0.07815718,
    "CMYK_M": 0,
    "CMYK_Y": 0.02085564,
    "CMYK_K": 0.2788747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06814",
    "Farbtonhilfsbezeichnung": "N2.53.37",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "112",
    "Y": 15,
    "L": 45.989998246277,
    "a": -40.3385251917245,
    "b": -3.30174348494339,
    "C": 40.4734249191214,
    "h": 0.0816688154063,
    "CMY_C": 1,
    "CMY_M": 0.5066662,
    "CMY_Y": 0.5590013,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1060844,
    "CMYK_K": 0.5066662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06815",
    "Farbtonhilfsbezeichnung": "N5.51.41",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "134",
    "Bcolor": "126",
    "Y": 18,
    "L": 49.0066720626625,
    "a": -40.1118983785615,
    "b": -7.10762186351959,
    "C": 40.73674852129,
    "h": 0.17537450106805,
    "CMY_C": 1,
    "CMY_M": 0.4750554,
    "CMY_Y": 0.5043984,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.05589738,
    "CMYK_K": 0.4750554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06816",
    "Farbtonhilfsbezeichnung": "N3.42.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "140",
    "Bcolor": "130",
    "Y": 20,
    "L": 52.1062585947537,
    "a": -35.3437652165572,
    "b": -4.36323145322848,
    "C": 35.6120699819256,
    "h": 0.12282976680554,
    "CMY_C": 1,
    "CMY_M": 0.4500932,
    "CMY_Y": 0.4913996,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07511532,
    "CMYK_K": 0.4500932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06817",
    "Farbtonhilfsbezeichnung": "N4.36.39",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "127",
    "Bcolor": "119",
    "Y": 17,
    "L": 47.8994666150747,
    "a": -28.2721440384829,
    "b": -4.05158456098347,
    "C": 28.5609780292538,
    "h": 0.1423374852997,
    "CMY_C": 0.874312,
    "CMY_M": 0.5034161,
    "CMY_Y": 0.5344118,
    "CMYK_C": 0.7468947,
    "CMYK_M": 0,
    "CMYK_Y": 0.06241802,
    "CMYK_K": 0.5034161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06818",
    "Farbtonhilfsbezeichnung": "N1.16.49",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "143",
    "Bcolor": "136",
    "Y": 24,
    "L": 56.334997071799,
    "a": -15.2211913060071,
    "b": -1.26020761119492,
    "C": 15.2732703766213,
    "h": 0.08260456968708,
    "CMY_C": 0.5974206,
    "CMY_M": 0.4395952,
    "CMY_Y": 0.46787,
    "CMYK_C": 0.2816275,
    "CMYK_M": 0,
    "CMYK_Y": 0.05045426,
    "CMYK_K": 0.4395952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06819",
    "Farbtonhilfsbezeichnung": "N1.14.57",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "166",
    "Bcolor": "159",
    "Y": 34,
    "L": 65.1170799785015,
    "a": -14.8711852609938,
    "b": -1.26468324042093,
    "C": 14.924864313132,
    "h": 0.08483840074708,
    "CMY_C": 0.5059511,
    "CMY_M": 0.3490087,
    "CMY_Y": 0.3782298,
    "CMYK_C": 0.2410822,
    "CMYK_M": 0,
    "CMYK_Y": 0.04488708,
    "CMYK_K": 0.3490087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06820",
    "Farbtonhilfsbezeichnung": "N1.07.53",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "150",
    "Bcolor": "146",
    "Y": 29,
    "L": 60.5465600550173,
    "a": -7.75924835433994,
    "b": -1.02999338357153,
    "C": 7.82731252694871,
    "h": 0.13197241289357,
    "CMY_C": 0.4904986,
    "CMY_M": 0.4106034,
    "CMY_Y": 0.425937,
    "CMYK_C": 0.1355543,
    "CMYK_M": 0,
    "CMYK_Y": 0.02601584,
    "CMYK_K": 0.4106034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06821",
    "Farbtonhilfsbezeichnung": "NN.02.61",
    "Farbtonklasse": "01",
    "Rcolor": "160",
    "Gcolor": "168",
    "Bcolor": "167",
    "Y": 38,
    "L": 68.2474680809343,
    "a": -3.03326412137028,
    "b": -0.88347346614148,
    "C": 3.15930634718577,
    "h": 0.2834207910221,
    "CMY_C": 0.3736689,
    "CMY_M": 0.3402653,
    "CMY_Y": 0.3469208,
    "CMYK_C": 0.05063187,
    "CMYK_M": 0,
    "CMYK_Y": 0.01008823,
    "CMYK_K": 0.3402653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06822",
    "Farbtonhilfsbezeichnung": "N5.56.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "108",
    "Y": 13,
    "L": 42.4881052661461,
    "a": -38.9810833136489,
    "b": -6.07417547095586,
    "C": 39.4514950788636,
    "h": 0.15458054548657,
    "CMY_C": 1,
    "CMY_M": 0.5433165,
    "CMY_Y": 0.5748104,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.06896237,
    "CMYK_K": 0.5433165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06823",
    "Farbtonhilfsbezeichnung": "N2.45.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "114",
    "Y": 16,
    "L": 47.0772527155992,
    "a": -35.5181089747261,
    "b": -2.75370785942559,
    "C": 35.6246960985716,
    "h": 0.07737490466463,
    "CMY_C": 1,
    "CMY_M": 0.5019115,
    "CMY_Y": 0.5516033,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09976492,
    "CMYK_K": 0.5019115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06824",
    "Farbtonhilfsbezeichnung": "N0.41.44",
    "Farbtonklasse": "03",
    "Rcolor": "9",
    "Gcolor": "139",
    "Bcolor": "122",
    "Y": 20,
    "L": 51.5966657825286,
    "a": -34.8789476068658,
    "b": -0.76173052471086,
    "C": 34.8872644320927,
    "h": 0.02183579231265,
    "CMY_C": 0.9665962,
    "CMY_M": 0.4568502,
    "CMY_Y": 0.5204185,
    "CMYK_C": 0.9384999,
    "CMYK_M": 0,
    "CMYK_Y": 0.1170363,
    "CMYK_K": 0.4568502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06825",
    "Farbtonhilfsbezeichnung": "N1.35.39",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "123",
    "Bcolor": "111",
    "Y": 16,
    "L": 46.7637618909623,
    "a": -28.0550667650827,
    "b": -1.29923505850789,
    "C": 28.0851345542531,
    "h": 0.04627711168419,
    "CMY_C": 0.8522551,
    "CMY_M": 0.5158458,
    "CMY_Y": 0.5634811,
    "CMYK_C": 0.6948391,
    "CMYK_M": 0,
    "CMYK_Y": 0.09838867,
    "CMYK_K": 0.5158458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06826",
    "Farbtonhilfsbezeichnung": "N1.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "140",
    "Bcolor": "131",
    "Y": 21,
    "L": 54.2085838317871,
    "a": -20.8475933074951,
    "b": -1.83250069618225,
    "C": 20.9279766082764,
    "h": 185.023376464844,
    "CMY_C": 0.67729514837265,
    "CMY_M": 0.45140355825424,
    "CMY_Y": 0.48593884706497,
    "CMYK_C": 0.41176277399063,
    "CMYK_M": 0,
    "CMYK_Y": 0.06295208632946,
    "CMYK_K": 0.45140355825424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06827",
    "Farbtonhilfsbezeichnung": "N2.17.40",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "121",
    "Bcolor": "116",
    "Y": 17,
    "L": 48.0646532373234,
    "a": -14.0038966547849,
    "b": -1.67678213521827,
    "C": 14.1039256892144,
    "h": 0.11916947972467,
    "CMY_C": 0.6690587,
    "CMY_M": 0.5251999,
    "CMY_Y": 0.5469359,
    "CMYK_C": 0.302988,
    "CMYK_M": 0,
    "CMYK_Y": 0.04577906,
    "CMYK_K": 0.5251999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06828",
    "Farbtonhilfsbezeichnung": "N3.09.45",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "131",
    "Bcolor": "128",
    "Y": 21,
    "L": 53.049193314036,
    "a": -8.01771590108979,
    "b": -1.27147868768376,
    "C": 8.11790775531615,
    "h": 0.15727396567345,
    "CMY_C": 0.5681069,
    "CMY_M": 0.4864409,
    "CMY_Y": 0.4998283,
    "CMYK_C": 0.1590197,
    "CMYK_M": 0,
    "CMYK_Y": 0.02606794,
    "CMYK_K": 0.4864409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06829",
    "Farbtonhilfsbezeichnung": "N0.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "155",
    "Bcolor": "152",
    "Y": 31,
    "L": 62.8437277481419,
    "a": -4.56445420525292,
    "b": -1.01764913734057,
    "C": 4.67652135230676,
    "h": 0.21936321823103,
    "CMY_C": 0.4418119,
    "CMY_M": 0.3934051,
    "CMY_Y": 0.4021324,
    "CMYK_C": 0.07980094,
    "CMYK_M": 0,
    "CMYK_Y": 0.01438745,
    "CMYK_K": 0.3934051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06830",
    "Farbtonhilfsbezeichnung": "N0.52.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "98",
    "Y": 12,
    "L": 41.4741454677619,
    "a": -36.0765673078633,
    "b": -1.24734885922972,
    "C": 36.0981244373639,
    "h": 0.0345612752978,
    "CMY_C": 1,
    "CMY_M": 0.5581599,
    "CMY_Y": 0.6152611,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.129235,
    "CMYK_K": 0.5581599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06831",
    "Farbtonhilfsbezeichnung": "N3.49.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "104",
    "Y": 13,
    "L": 42.4656202714053,
    "a": -33.5016175942347,
    "b": -3.5214038045039,
    "C": 33.6861791568102,
    "h": 0.1047268969776,
    "CMY_C": 1,
    "CMY_M": 0.5510119,
    "CMY_Y": 0.5910014,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.08906585,
    "CMYK_K": 0.5510119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06832",
    "Farbtonhilfsbezeichnung": "N1.44.28",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "87",
    "Y": 9,
    "L": 36.258649297586,
    "a": -29.4404126785649,
    "b": -1.85754405606436,
    "C": 29.4989553815796,
    "h": 0.06301151400896,
    "CMY_C": 1,
    "CMY_M": 0.6179018,
    "CMY_Y": 0.6597564,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1095389,
    "CMYK_K": 0.6179018
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06833",
    "Farbtonhilfsbezeichnung": "N0.40.31",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "103",
    "Bcolor": "91",
    "Y": 11,
    "L": 38.8331938491347,
    "a": -26.0921658239911,
    "b": -0.85629910662552,
    "C": 26.1062131598333,
    "h": 0.0328064710649,
    "CMY_C": 0.913559,
    "CMY_M": 0.5974653,
    "CMY_Y": 0.6417533,
    "CMYK_C": 0.7852583,
    "CMYK_M": 0,
    "CMYK_Y": 0.1100228,
    "CMYK_K": 0.5974653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06834",
    "Farbtonhilfsbezeichnung": "N2.29.35",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "111",
    "Bcolor": "103",
    "Y": 13,
    "L": 43.0825636923754,
    "a": -21.028075796503,
    "b": -1.54865800888264,
    "C": 21.085025808188,
    "h": 0.07351443739223,
    "CMY_C": 0.7897271,
    "CMY_M": 0.5630123,
    "CMY_Y": 0.5966391,
    "CMYK_C": 0.5188127,
    "CMYK_M": 0,
    "CMYK_Y": 0.07695124,
    "CMYK_K": 0.5630123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06835",
    "Farbtonhilfsbezeichnung": "N2.20.31",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "99",
    "Bcolor": "94",
    "Y": 11,
    "L": 39.225935513262,
    "a": -13.7319487365075,
    "b": -1.75136376117229,
    "C": 13.8431821170574,
    "h": 0.12685448730062,
    "CMY_C": 0.7508044,
    "CMY_M": 0.6121004,
    "CMY_Y": 0.6312292,
    "CMYK_C": 0.3575771,
    "CMYK_M": 0,
    "CMYK_Y": 0.04931354,
    "CMYK_K": 0.6121004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06836",
    "Farbtonhilfsbezeichnung": "N4.10.36",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "107",
    "Bcolor": "104",
    "Y": 13,
    "L": 43.4372618494738,
    "a": -7.75361767487778,
    "b": -1.47352874058873,
    "C": 7.89239342642764,
    "h": 0.18780444089542,
    "CMY_C": 0.6593577,
    "CMY_M": 0.581919,
    "CMY_Y": 0.5923532,
    "CMYK_C": 0.185224,
    "CMYK_M": 0,
    "CMYK_Y": 0.02495723,
    "CMYK_K": 0.581919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06837",
    "Farbtonhilfsbezeichnung": "N5.58.27",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "93",
    "Y": 9,
    "L": 36.5401600453637,
    "a": -34.7473157783283,
    "b": -5.11231102854915,
    "C": 35.1213849079373,
    "h": 0.14608019316873,
    "CMY_C": 1,
    "CMY_M": 0.6079084,
    "CMY_Y": 0.6371902,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07468097,
    "CMYK_K": 0.6079084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06838",
    "Farbtonhilfsbezeichnung": "N3.46.28",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "91",
    "Y": 10,
    "L": 37.3654342274075,
    "a": -28.6631183155691,
    "b": -3.12995753493353,
    "C": 28.8335045692126,
    "h": 0.10876712676027,
    "CMY_C": 1,
    "CMY_M": 0.6078453,
    "CMY_Y": 0.6414029,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.08557234,
    "CMYK_K": 0.6078453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06839",
    "Farbtonhilfsbezeichnung": "N2.41.21",
    "Farbtonklasse": "03",
    "Rcolor": "10",
    "Gcolor": "78",
    "Bcolor": "71",
    "Y": 6,
    "L": 29.372272076775,
    "a": -21.5943077559586,
    "b": -1.96320439869229,
    "C": 21.6833645675688,
    "h": 0.09066381466354,
    "CMY_C": 0.9618114,
    "CMY_M": 0.6936492,
    "CMY_Y": 0.7213086,
    "CMYK_C": 0.8753436,
    "CMYK_M": 0,
    "CMYK_Y": 0.09028662,
    "CMYK_K": 0.6936492
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06840",
    "Farbtonhilfsbezeichnung": "N1.37.23",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "82",
    "Bcolor": "75",
    "Y": 7,
    "L": 31.2743973767063,
    "a": -21.064498615579,
    "b": -1.38590969926493,
    "C": 21.1100413931438,
    "h": 0.06569893386761,
    "CMY_C": 0.9156407,
    "CMY_M": 0.676685,
    "CMY_Y": 0.7076208,
    "CMYK_C": 0.73908,
    "CMYK_M": 0,
    "CMYK_Y": 0.09568336,
    "CMYK_K": 0.676685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06841",
    "Farbtonhilfsbezeichnung": "N2.29.25",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "87",
    "Bcolor": "80",
    "Y": 8,
    "L": 33.4907936674367,
    "a": -17.728280939204,
    "b": -1.76848662682638,
    "C": 17.8162703731339,
    "h": 0.09942618191957,
    "CMY_C": 0.8467674,
    "CMY_M": 0.660466,
    "CMY_Y": 0.6847994,
    "CMYK_C": 0.5486972,
    "CMYK_M": 0,
    "CMYK_Y": 0.07166716,
    "CMYK_K": 0.660466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06843",
    "Farbtonhilfsbezeichnung": "N4.12.27",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "89",
    "Bcolor": "86",
    "Y": 9,
    "L": 36.2540968979644,
    "a": -8.18594376129431,
    "b": -1.35110356137285,
    "C": 8.29669549258182,
    "h": 0.16357690387294,
    "CMY_C": 0.7290476,
    "CMY_M": 0.649845,
    "CMY_Y": 0.6609522,
    "CMYK_C": 0.226193,
    "CMYK_M": 0,
    "CMYK_Y": 0.03172084,
    "CMYK_K": 0.649845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06844",
    "Farbtonhilfsbezeichnung": "N3.05.30",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "91",
    "Bcolor": "90",
    "Y": 10,
    "L": 37.8794320347797,
    "a": -3.73931346119749,
    "b": -1.30907084328815,
    "C": 3.9618343773863,
    "h": 0.33674894273132,
    "CMY_C": 0.6804514,
    "CMY_M": 0.6426101,
    "CMY_Y": 0.6455935,
    "CMYK_C": 0.1058824,
    "CMYK_M": 0,
    "CMYK_Y": 0.008347853,
    "CMYK_K": 0.6426101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06845",
    "Farbtonhilfsbezeichnung": "N2.54.19",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "79",
    "Bcolor": "71",
    "Y": 6,
    "L": 29.3380226603478,
    "a": -25.0503623004219,
    "b": -2.15782219722814,
    "C": 25.1431272521389,
    "h": 0.08592725328755,
    "CMY_C": 1,
    "CMY_M": 0.6895122,
    "CMY_Y": 0.7207286,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.1005399,
    "CMYK_K": 0.6895122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06846",
    "Farbtonhilfsbezeichnung": "N2.47.25",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "92",
    "Bcolor": "83",
    "Y": 8,
    "L": 34.042930668036,
    "a": -28.0921226038452,
    "b": -2.86953026936824,
    "C": 28.2382994593564,
    "h": 0.10179408881403,
    "CMY_C": 1,
    "CMY_M": 0.6408367,
    "CMY_Y": 0.6738409,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.09189216,
    "CMYK_K": 0.6408367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06847",
    "Farbtonhilfsbezeichnung": "N5.48.17",
    "Farbtonklasse": "03",
    "Rcolor": "37",
    "Gcolor": "82",
    "Bcolor": "79",
    "Y": 6,
    "L": 31.8972263336182,
    "a": -16.407527923584,
    "b": -3.29519581794739,
    "C": 16.7351512908936,
    "h": 191.355895996094,
    "CMY_C": 0.85651624202728,
    "CMY_M": 0.67702609300613,
    "CMY_Y": 0.68992167711258,
    "CMYK_C": 0.55574196577072,
    "CMYK_M": 0,
    "CMYK_Y": 0.03992763534188,
    "CMYK_K": 0.67702609300613
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06848",
    "Farbtonhilfsbezeichnung": "N4.38.20",
    "Farbtonklasse": "03",
    "Rcolor": "23",
    "Gcolor": "77",
    "Bcolor": "73",
    "Y": 6,
    "L": 29.4408249834239,
    "a": -18.4626497356672,
    "b": -3.30208127642614,
    "C": 18.7556171857408,
    "h": 0.17698071489309,
    "CMY_C": 0.9108228,
    "CMY_M": 0.6969485,
    "CMY_Y": 0.7123658,
    "CMYK_C": 0.7057359,
    "CMYK_M": 0,
    "CMYK_Y": 0.05087341,
    "CMYK_K": 0.6969485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06849",
    "Farbtonhilfsbezeichnung": "N1.32.16",
    "Farbtonklasse": "03",
    "Rcolor": "24",
    "Gcolor": "64",
    "Bcolor": "58",
    "Y": 4,
    "L": 24.3823984132466,
    "a": -15.9400767422422,
    "b": -0.81509553189543,
    "C": 15.960903084559,
    "h": 0.05109048243677,
    "CMY_C": 0.9071716,
    "CMY_M": 0.7471349,
    "CMY_Y": 0.7717058,
    "CMYK_C": 0.6328936,
    "CMYK_M": 0,
    "CMYK_Y": 0.09717018,
    "CMYK_K": 0.7471349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06850",
    "Farbtonhilfsbezeichnung": "N2.19.14",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "65",
    "Bcolor": "63",
    "Y": 5,
    "L": 26.0645971318036,
    "a": -7.3771278707041,
    "b": -1.44327646360604,
    "C": 7.51698493886468,
    "h": 0.19320173889666,
    "CMY_C": 0.8137712,
    "CMY_M": 0.7446952,
    "CMY_Y": 0.7525206,
    "CMYK_C": 0.2705632,
    "CMYK_M": 0,
    "CMYK_Y": 0.03065101,
    "CMYK_K": 0.7446952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06851",
    "Farbtonhilfsbezeichnung": "N5.09.11",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "59",
    "Bcolor": "58",
    "Y": 4,
    "L": 24.2025947266219,
    "a": -2.81995116149192,
    "b": -0.8973036306809,
    "C": 2.95926990300526,
    "h": 0.30806773628979,
    "CMY_C": 0.7952089,
    "CMY_M": 0.7689782,
    "CMY_Y": 0.7715458,
    "CMYK_C": 0.113542,
    "CMYK_M": 0,
    "CMYK_Y": 0.0111138,
    "CMYK_K": 0.7689782
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06852",
    "Farbtonhilfsbezeichnung": "N3.04.16",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "66",
    "Bcolor": "66",
    "Y": 5,
    "L": 27.5209382714974,
    "a": -2.32273884013379,
    "b": -1.18253328089254,
    "C": 2.60643447642263,
    "h": 0.47091028879284,
    "CMY_C": 0.7638382,
    "CMY_M": 0.7404336,
    "CMY_Y": 0.7406788,
    "CMYK_C": 0.09016797,
    "CMYK_M": 0,
    "CMYK_Y": 0.0009445484,
    "CMYK_K": 0.7404336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06853",
    "Farbtonhilfsbezeichnung": "N6.31.64",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "192",
    "Bcolor": "184",
    "Y": 43,
    "L": 71.6309518701849,
    "a": -32.6824205153138,
    "b": -6.24422234989763,
    "C": 33.27357695672,
    "h": 0.18878242603346,
    "CMY_C": 0.6745655,
    "CMY_M": 0.2461721,
    "CMY_Y": 0.2769283,
    "CMYK_C": 0.5682907,
    "CMYK_M": 0,
    "CMYK_Y": 0.04079999,
    "CMYK_K": 0.2461721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06854",
    "Farbtonhilfsbezeichnung": "N9.21.70",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "204",
    "Bcolor": "200",
    "Y": 52,
    "L": 77.4715775304751,
    "a": -23.7027336376203,
    "b": -6.19296213205343,
    "C": 24.4984154970281,
    "h": 0.25556315541447,
    "CMY_C": 0.4910409,
    "CMY_M": 0.1982448,
    "CMY_Y": 0.2137481,
    "CMYK_C": 0.3651939,
    "CMYK_M": 0,
    "CMYK_Y": 0.01933673,
    "CMYK_K": 0.1982448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06855",
    "Farbtonhilfsbezeichnung": "N7.17.78",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "227",
    "Bcolor": "219",
    "Y": 67,
    "L": 85.6853016731706,
    "a": -21.737788422044,
    "b": -4.04759295891046,
    "C": 22.1114100464573,
    "h": 0.18409255075077,
    "CMY_C": 0.3695264,
    "CMY_M": 0.1117128,
    "CMY_Y": 0.1396245,
    "CMYK_C": 0.2902367,
    "CMYK_M": 0,
    "CMYK_Y": 0.03142197,
    "CMYK_K": 0.1117128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06856",
    "Farbtonhilfsbezeichnung": "N6.15.77",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "223",
    "Bcolor": "216",
    "Y": 65,
    "L": 84.6700027691904,
    "a": -19.7126762140453,
    "b": -3.54909524544853,
    "C": 20.0296200807966,
    "h": 0.17813291201131,
    "CMY_C": 0.3575118,
    "CMY_M": 0.1271718,
    "CMY_Y": 0.1541732,
    "CMYK_C": 0.2639008,
    "CMYK_M": 0,
    "CMYK_Y": 0.03093545,
    "CMYK_K": 0.1271718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06857",
    "Farbtonhilfsbezeichnung": "N9.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "231",
    "Bcolor": "227",
    "Y": 74,
    "L": 89.0323848414175,
    "a": -12.3446574060699,
    "b": -2.90779845866498,
    "C": 12.6825020539896,
    "h": 0.23133421806459,
    "CMY_C": 0.2379417,
    "CMY_M": 0.09394169,
    "CMY_Y": 0.1099788,
    "CMYK_C": 0.1589302,
    "CMYK_M": 0,
    "CMYK_Y": 0.01769988,
    "CMYK_K": 0.09394169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06858",
    "Farbtonhilfsbezeichnung": "N9.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "235",
    "Bcolor": "231",
    "Y": 78,
    "L": 90.8898573381459,
    "a": -9.7501427846563,
    "b": -2.40566203522841,
    "C": 10.0425342493279,
    "h": 0.2418995556822,
    "CMY_C": 0.1925403,
    "CMY_M": 0.07892588,
    "CMY_Y": 0.09278768,
    "CMYK_C": 0.12335,
    "CMYK_M": 0,
    "CMYK_Y": 0.0150496,
    "CMYK_K": 0.07892588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06859",
    "Farbtonhilfsbezeichnung": "N6.34.64",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "195",
    "Bcolor": "187",
    "Y": 44,
    "L": 72.1217642849111,
    "a": -37.0210867426596,
    "b": -7.0957653065451,
    "C": 37.6949698088896,
    "h": 0.18937153545149,
    "CMY_C": 0.758969,
    "CMY_M": 0.2334471,
    "CMY_Y": 0.2660948,
    "CMYK_C": 0.6855651,
    "CMYK_M": 0,
    "CMYK_Y": 0.04259034,
    "CMYK_K": 0.2334471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06860",
    "Farbtonhilfsbezeichnung": "N7.25.68",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "203",
    "Bcolor": "195",
    "Y": 50,
    "L": 76.1987292197171,
    "a": -28.290086048155,
    "b": -5.38731199872349,
    "C": 28.7984739037263,
    "h": 0.18817798608331,
    "CMY_C": 0.5540229,
    "CMY_M": 0.2040547,
    "CMY_Y": 0.2337474,
    "CMYK_C": 0.4396887,
    "CMYK_M": 0,
    "CMYK_Y": 0.0373049,
    "CMYK_K": 0.2040547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06861",
    "Farbtonhilfsbezeichnung": "N9.17.77",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 64,
    "L": 84.14390278773,
    "a": -21.0985479315303,
    "b": -5.54716159541242,
    "C": 21.815584488725,
    "h": 0.25709817253171,
    "CMY_C": 0.3874803,
    "CMY_M": 0.129726,
    "CMY_Y": 0.1454909,
    "CMYK_C": 0.296176,
    "CMYK_M": 0,
    "CMYK_Y": 0.01811487,
    "CMYK_K": 0.129726
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06862",
    "Farbtonhilfsbezeichnung": "N8.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "217",
    "Bcolor": "213",
    "Y": 62,
    "L": 83.0848198392084,
    "a": -18.0977535519388,
    "b": -4.54384798931617,
    "C": 18.6594543911853,
    "h": 0.24598780744393,
    "CMY_C": 0.363534,
    "CMY_M": 0.147707,
    "CMY_Y": 0.1640585,
    "CMYK_C": 0.253231,
    "CMYK_M": 0,
    "CMYK_Y": 0.01918528,
    "CMYK_K": 0.147707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06863",
    "Farbtonhilfsbezeichnung": "N8.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "228",
    "Bcolor": "224",
    "Y": 72,
    "L": 87.8034161370706,
    "a": -13.7607241655339,
    "b": -3.29816081445153,
    "C": 14.1504556222721,
    "h": 0.23524173035019,
    "CMY_C": 0.2658455,
    "CMY_M": 0.1045445,
    "CMY_Y": 0.1208504,
    "CMYK_C": 0.1801329,
    "CMYK_M": 0,
    "CMYK_Y": 0.01820957,
    "CMYK_K": 0.1045445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06864",
    "Farbtonhilfsbezeichnung": "N7.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "233",
    "Bcolor": "228",
    "Y": 76,
    "L": 89.9543415610482,
    "a": -11.3307516645456,
    "b": -2.12095037006881,
    "C": 11.5275480374578,
    "h": 0.18504393940207,
    "CMY_C": 0.2155214,
    "CMY_M": 0.08603577,
    "CMY_Y": 0.1054674,
    "CMYK_C": 0.1416747,
    "CMYK_M": 0,
    "CMYK_Y": 0.02126078,
    "CMYK_K": 0.08603577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06865",
    "Farbtonhilfsbezeichnung": "N6.44.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "166",
    "Bcolor": "157",
    "Y": 29,
    "L": 60.8325644869221,
    "a": -41.6216574189446,
    "b": -7.32752449354364,
    "C": 42.2617437111091,
    "h": 0.17426502260503,
    "CMY_C": 1,
    "CMY_M": 0.3485935,
    "CMY_Y": 0.3833528,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.05336047,
    "CMYK_K": 0.3485935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06866",
    "Farbtonhilfsbezeichnung": "N7.26.59",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "177",
    "Bcolor": "172",
    "Y": 37,
    "L": 66.9423722305803,
    "a": -26.2960500462252,
    "b": -6.13196262591329,
    "C": 27.0015409500861,
    "h": 0.22909551727472,
    "CMY_C": 0.6355132,
    "CMY_M": 0.3076657,
    "CMY_Y": 0.3265921,
    "CMYK_C": 0.4735393,
    "CMYK_M": 0,
    "CMYK_Y": 0.02733709,
    "CMYK_K": 0.3076657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06867",
    "Farbtonhilfsbezeichnung": "N6.17.72",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "208",
    "Bcolor": "201",
    "Y": 55,
    "L": 79.1693170959973,
    "a": -21.2061423806689,
    "b": -4.02062292794632,
    "C": 21.5839265055719,
    "h": 0.18737304800064,
    "CMY_C": 0.4339789,
    "CMY_M": 0.1849306,
    "CMY_Y": 0.2107712,
    "CMYK_C": 0.3055547,
    "CMYK_M": 0,
    "CMYK_Y": 0.03170349,
    "CMYK_K": 0.1849306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06868",
    "Farbtonhilfsbezeichnung": "N6.11.75",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "214",
    "Bcolor": "209",
    "Y": 61,
    "L": 82.6098836058153,
    "a": -14.5440983792394,
    "b": -2.84493763077216,
    "C": 14.8197323790944,
    "h": 0.1931686491435,
    "CMY_C": 0.3270294,
    "CMY_M": 0.1606419,
    "CMY_Y": 0.1811786,
    "CMYK_C": 0.1982318,
    "CMYK_M": 0,
    "CMYK_Y": 0.02446712,
    "CMYK_K": 0.1606419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06869",
    "Farbtonhilfsbezeichnung": "N8.09.73",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "205",
    "Bcolor": "201",
    "Y": 57,
    "L": 79.9751139512311,
    "a": -10.5758848911476,
    "b": -2.64214685099899,
    "C": 10.9009302911746,
    "h": 0.24481630078089,
    "CMY_C": 0.3188166,
    "CMY_M": 0.1978775,
    "CMY_Y": 0.210742,
    "CMYK_C": 0.1507738,
    "CMYK_M": 0,
    "CMYK_Y": 0.01603803,
    "CMYK_K": 0.1978775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06870",
    "Farbtonhilfsbezeichnung": "N9.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "219",
    "Bcolor": "217",
    "Y": 69,
    "L": 86.4014378556477,
    "a": -4.68758726518337,
    "b": -1.35473971952189,
    "C": 4.87942558877165,
    "h": 0.28134006716765,
    "CMY_C": 0.1946713,
    "CMY_M": 0.1404693,
    "CMY_Y": 0.1493864,
    "CMYK_C": 0.06306008,
    "CMYK_M": 0,
    "CMYK_Y": 0.01037439,
    "CMYK_K": 0.1404693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06871",
    "Farbtonhilfsbezeichnung": "N8.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "157",
    "Bcolor": "153",
    "Y": 26,
    "L": 58.2454798165,
    "a": -35.986133929278,
    "b": -8.96799354861102,
    "C": 37.0867461967731,
    "h": 0.2442320943913,
    "CMY_C": 1,
    "CMY_M": 0.3838285,
    "CMY_Y": 0.3982728,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02344205,
    "CMYK_K": 0.3838285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06872",
    "Farbtonhilfsbezeichnung": "N6.37.53",
    "Farbtonklasse": "03",
    "Rcolor": "20",
    "Gcolor": "166",
    "Bcolor": "159",
    "Y": 30,
    "L": 61.5635231685763,
    "a": -35.9521199962531,
    "b": -6.98174713307906,
    "C": 36.623759026829,
    "h": 0.19180832433646,
    "CMY_C": 0.9212637,
    "CMY_M": 0.3492134,
    "CMY_Y": 0.3776712,
    "CMYK_C": 0.8790136,
    "CMYK_M": 0,
    "CMYK_Y": 0.04372832,
    "CMYK_K": 0.3492134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06873",
    "Farbtonhilfsbezeichnung": "N8.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "179",
    "Bcolor": "175",
    "Y": 38,
    "L": 68.5103454589844,
    "a": -21.3393268585205,
    "b": -5.58319807052612,
    "C": 22.0576286315918,
    "h": 194.662139892578,
    "CMY_C": 0.55669593811035,
    "CMY_M": 0.29982197284698,
    "CMY_Y": 0.31342661380768,
    "CMYK_C": 0.36686950922012,
    "CMYK_M": 0,
    "CMYK_Y": 0.01943025924265,
    "CMYK_K": 0.29982197284698
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06874",
    "Farbtonhilfsbezeichnung": "N8.19.62",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "180",
    "Bcolor": "177",
    "Y": 40,
    "L": 69.4806316168302,
    "a": -19.8903771537889,
    "b": -5.14320226206457,
    "C": 20.5445767254639,
    "h": 0.25303508788413,
    "CMY_C": 0.5286506,
    "CMY_M": 0.2922259,
    "CMY_Y": 0.3061287,
    "CMYK_C": 0.3340398,
    "CMYK_M": 0,
    "CMYK_Y": 0.01964295,
    "CMYK_K": 0.2922259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06875",
    "Farbtonhilfsbezeichnung": "N7.12.65",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "186",
    "Bcolor": "183",
    "Y": 45,
    "L": 72.7462310791016,
    "a": -13.9199638366699,
    "b": -3.52329158782959,
    "C": 14.3589334487915,
    "h": 194.203872680664,
    "CMY_C": 0.42861413955688,
    "CMY_M": 0.26910090446472,
    "CMY_Y": 0.28230971097946,
    "CMYK_C": 0.2182424813509,
    "CMYK_M": 0,
    "CMYK_Y": 0.01807199791074,
    "CMYK_K": 0.26910090446472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06876",
    "Farbtonhilfsbezeichnung": "N6.08.77",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 66,
    "L": 85.1489727089226,
    "a": -10.6794007738787,
    "b": -2.18610912589801,
    "C": 10.900856571823,
    "h": 0.20191389523998,
    "CMY_C": 0.2622987,
    "CMY_M": 0.1409021,
    "CMY_Y": 0.1577916,
    "CMYK_C": 0.1413071,
    "CMYK_M": 0,
    "CMYK_Y": 0.01965949,
    "CMYK_K": 0.1409021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06877",
    "Farbtonhilfsbezeichnung": "N6.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "206",
    "Bcolor": "202",
    "Y": 59,
    "L": 81.0233748391025,
    "a": -7.40156409074788,
    "b": -1.38617041819107,
    "C": 7.5302469692379,
    "h": 0.18513613051735,
    "CMY_C": 0.2755316,
    "CMY_M": 0.1935661,
    "CMY_Y": 0.2080832,
    "CMYK_C": 0.1016395,
    "CMYK_M": 0,
    "CMYK_Y": 0.01800166,
    "CMYK_K": 0.1935661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06878",
    "Farbtonhilfsbezeichnung": "N8.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "205",
    "Bcolor": "202",
    "Y": 59,
    "L": 81.2176759888003,
    "a": -5.94285891600826,
    "b": -1.3568482101006,
    "C": 6.09578618070156,
    "h": 0.22446815815443,
    "CMY_C": 0.2612296,
    "CMY_M": 0.1946415,
    "CMY_Y": 0.2060057,
    "CMYK_C": 0.08268135,
    "CMYK_M": 0,
    "CMYK_Y": 0.01411071,
    "CMYK_K": 0.1946415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06879",
    "Farbtonhilfsbezeichnung": "N6.49.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "141",
    "Bcolor": "134",
    "Y": 20,
    "L": 51.6068457939646,
    "a": -39.6211743408655,
    "b": -7.50348402032781,
    "C": 40.3254228569593,
    "h": 0.18716411477496,
    "CMY_C": 1,
    "CMY_M": 0.4486526,
    "CMY_Y": 0.4758193,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04927338,
    "CMYK_K": 0.4486526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06880",
    "Farbtonhilfsbezeichnung": "N9.44.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "147",
    "Bcolor": "145",
    "Y": 22,
    "L": 54.1891971045946,
    "a": -36.8182766977876,
    "b": -10.1674385258256,
    "C": 38.1963650779926,
    "h": 0.26943684433529,
    "CMY_C": 1,
    "CMY_M": 0.4249074,
    "CMY_Y": 0.4316949,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.01180235,
    "CMYK_K": 0.4249074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06881",
    "Farbtonhilfsbezeichnung": "N8.29.49",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "150",
    "Bcolor": "146",
    "Y": 25,
    "L": 57.1000151080156,
    "a": -27.0747051785108,
    "b": -6.04250334445029,
    "C": 27.7407913941,
    "h": 0.21958043356126,
    "CMY_C": 0.7561594,
    "CMY_M": 0.410281,
    "CMY_Y": 0.429045,
    "CMYK_C": 0.586514,
    "CMYK_M": 0,
    "CMYK_Y": 0.03181852,
    "CMYK_K": 0.410281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06882",
    "Farbtonhilfsbezeichnung": "N9.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "161",
    "Bcolor": "158",
    "Y": 31,
    "L": 62.2934649413273,
    "a": -19.7214107325773,
    "b": -5.47941983308828,
    "C": 20.4684655748851,
    "h": 0.27100570066009,
    "CMY_C": 0.6033295,
    "CMY_M": 0.368622,
    "CMY_Y": 0.3788631,
    "CMYK_C": 0.3717385,
    "CMYK_M": 0,
    "CMYK_Y": 0.01622027,
    "CMYK_K": 0.368622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06884",
    "Farbtonhilfsbezeichnung": "N6.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "202",
    "Bcolor": "200",
    "Y": 57,
    "L": 80.4508095267181,
    "a": -4.56556615098042,
    "b": -1.04830091168333,
    "C": 4.68437072405827,
    "h": 0.22569821467711,
    "CMY_C": 0.2570896,
    "CMY_M": 0.206139,
    "CMY_Y": 0.2163473,
    "CMYK_C": 0.06418088,
    "CMYK_M": 0,
    "CMYK_Y": 0.01285911,
    "CMYK_K": 0.206139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06885",
    "Farbtonhilfsbezeichnung": "N8.55.41",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "133",
    "Bcolor": "131",
    "Y": 17,
    "L": 48.4526076730173,
    "a": -41.8443862177496,
    "b": -10.6146803648511,
    "C": 43.1697127299701,
    "h": 0.24843012175884,
    "CMY_C": 1,
    "CMY_M": 0.4777071,
    "CMY_Y": 0.4869102,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.01762051,
    "CMYK_K": 0.4777071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06886",
    "Farbtonhilfsbezeichnung": "N6.40.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "142",
    "Bcolor": "135",
    "Y": 21,
    "L": 52.7612966518484,
    "a": -34.0254867860491,
    "b": -6.29732157312186,
    "C": 34.6033236846246,
    "h": 0.1830058350416,
    "CMY_C": 1,
    "CMY_M": 0.4447145,
    "CMY_Y": 0.4718202,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04881391,
    "CMYK_K": 0.4447145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06887",
    "Farbtonhilfsbezeichnung": "N8.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "152",
    "Bcolor": "148",
    "Y": 25,
    "L": 57.5510453026886,
    "a": -27.0682859391596,
    "b": -6.85796004687118,
    "C": 27.9235334384562,
    "h": 0.24813639399149,
    "CMY_C": 0.7582161,
    "CMY_M": 0.4053831,
    "CMY_Y": 0.418918,
    "CMYK_C": 0.5933787,
    "CMYK_M": 0,
    "CMYK_Y": 0.02276252,
    "CMYK_K": 0.4053831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06888",
    "Farbtonhilfsbezeichnung": "N9.24.45",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "136",
    "Bcolor": "133",
    "Y": 21,
    "L": 52.6761179628524,
    "a": -20.027187556048,
    "b": -5.43537379202272,
    "C": 20.7516632987366,
    "h": 0.26501602041559,
    "CMY_C": 0.7051712,
    "CMY_M": 0.467536,
    "CMY_Y": 0.4771205,
    "CMYK_C": 0.4462934,
    "CMYK_M": 0,
    "CMYK_Y": 0.01800017,
    "CMYK_K": 0.467536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06889",
    "Farbtonhilfsbezeichnung": "N9.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "159",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.587258977512,
    "a": -13.8406902006229,
    "b": -4.27034281307728,
    "C": 14.4844928447916,
    "h": 0.29926892028099,
    "CMY_C": 0.5357994,
    "CMY_M": 0.3767034,
    "CMY_Y": 0.3835073,
    "CMYK_C": 0.2552493,
    "CMYK_M": 0,
    "CMYK_Y": 0.01091582,
    "CMYK_K": 0.3767034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06890",
    "Farbtonhilfsbezeichnung": "N8.13.57",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "165",
    "Bcolor": "162",
    "Y": 34,
    "L": 65.1358262498894,
    "a": -12.5981196250214,
    "b": -3.24473354397785,
    "C": 13.0092626177568,
    "h": 0.25207836383728,
    "CMY_C": 0.4939933,
    "CMY_M": 0.3526742,
    "CMY_Y": 0.3640518,
    "CMYK_C": 0.2183121,
    "CMYK_M": 0,
    "CMYK_Y": 0.0175763,
    "CMYK_K": 0.3526742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06891",
    "Farbtonhilfsbezeichnung": "N8.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "194",
    "Bcolor": "192",
    "Y": 51,
    "L": 76.886588300562,
    "a": -6.78485175539229,
    "b": -1.89627867073552,
    "C": 7.04486239324348,
    "h": 0.2725330454883,
    "CMY_C": 0.3165253,
    "CMY_M": 0.239721,
    "CMY_Y": 0.2488665,
    "CMYK_C": 0.1010213,
    "CMYK_M": 0,
    "CMYK_Y": 0.01202918,
    "CMYK_K": 0.239721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06892",
    "Farbtonhilfsbezeichnung": "N9.03.70",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "195",
    "Bcolor": "193",
    "Y": 53,
    "L": 77.9688689283155,
    "a": -3.13382474194279,
    "b": -1.25117011641322,
    "C": 3.37435685330083,
    "h": 0.37985706783279,
    "CMY_C": 0.2729786,
    "CMY_M": 0.2362091,
    "CMY_Y": 0.2414177,
    "CMYK_C": 0.04814089,
    "CMYK_M": 0,
    "CMYK_Y": 0.006819497,
    "CMYK_K": 0.2362091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06893",
    "Farbtonhilfsbezeichnung": "N6.51.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "108",
    "Y": 12,
    "L": 41.7368528624371,
    "a": -34.5879931745948,
    "b": -6.70850425666915,
    "C": 35.23256024202,
    "h": 0.19157608313306,
    "CMY_C": 1,
    "CMY_M": 0.5561761,
    "CMY_Y": 0.5776431,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.0483684,
    "CMYK_K": 0.5561761
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06894",
    "Farbtonhilfsbezeichnung": "N8.51.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "133",
    "Bcolor": "129",
    "Y": 17,
    "L": 48.6942499877093,
    "a": -40.2840900448697,
    "b": -9.04605038471786,
    "C": 41.2872733212794,
    "h": 0.22089218086442,
    "CMY_C": 1,
    "CMY_M": 0.4775849,
    "CMY_Y": 0.4947264,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.03281207,
    "CMYK_K": 0.4775849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06896",
    "Farbtonhilfsbezeichnung": "N7.31.40",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "130",
    "Bcolor": "128",
    "Y": 17,
    "L": 50.1591262817383,
    "a": -21.9948825836182,
    "b": -6.08581781387329,
    "C": 22.8213062286377,
    "h": 195.466369628906,
    "CMY_C": 0.76034289598465,
    "CMY_M": 0.48969411849976,
    "CMY_Y": 0.49812293052673,
    "CMYK_C": 0.53036576509476,
    "CMYK_M": 0,
    "CMYK_Y": 0.01651717536151,
    "CMYK_K": 0.48969411849976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06897",
    "Farbtonhilfsbezeichnung": "N8.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "149",
    "Bcolor": "146",
    "Y": 26,
    "L": 58.0494043875119,
    "a": -17.7203778087084,
    "b": -4.64954188519566,
    "C": 18.3202082254966,
    "h": 0.25659971408056,
    "CMY_C": 0.6211076,
    "CMY_M": 0.4166001,
    "CMY_Y": 0.4278791,
    "CMYK_C": 0.3505444,
    "CMYK_M": 0,
    "CMYK_Y": 0.01933329,
    "CMYK_K": 0.4166001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06898",
    "Farbtonhilfsbezeichnung": "N8.14.45",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "133",
    "Bcolor": "131",
    "Y": 21,
    "L": 52.9857242113865,
    "a": -11.4540834547529,
    "b": -3.16890491465502,
    "C": 11.8843588866446,
    "h": 0.26991031861657,
    "CMY_C": 0.6051354,
    "CMY_M": 0.4800937,
    "CMY_Y": 0.4882237,
    "CMYK_C": 0.2405081,
    "CMYK_M": 0,
    "CMYK_Y": 0.01563748,
    "CMYK_K": 0.4800937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06899",
    "Farbtonhilfsbezeichnung": "N7.59.31",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "109",
    "Y": 12,
    "L": 41.4645654683769,
    "a": -36.5324613808305,
    "b": -7.88988000557099,
    "C": 37.3747366685597,
    "h": 0.21270218469053,
    "CMY_C": 1,
    "CMY_M": 0.5561889,
    "CMY_Y": 0.5728512,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.03754376,
    "CMYK_K": 0.5561889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06900",
    "Farbtonhilfsbezeichnung": "N9.48.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "114",
    "Y": 13,
    "L": 42.6415372903848,
    "a": -30.8674117273454,
    "b": -9.36293398561008,
    "C": 32.2561876167093,
    "h": 0.29450671901138,
    "CMY_C": 1,
    "CMY_M": 0.5513433,
    "CMY_Y": 0.5515537,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004690689,
    "CMYK_K": 0.5513433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06901",
    "Farbtonhilfsbezeichnung": "N6.45.33",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "107",
    "Y": 12,
    "L": 41.6747560973503,
    "a": -31.6226138986725,
    "b": -6.30590713482867,
    "C": 32.2452194065663,
    "h": 0.19682945600654,
    "CMY_C": 1,
    "CMY_M": 0.560731,
    "CMY_Y": 0.5805851,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04519815,
    "CMYK_K": 0.560731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06902",
    "Farbtonhilfsbezeichnung": "N8.34.40",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "126",
    "Bcolor": "123",
    "Y": 17,
    "L": 48.1746358983762,
    "a": -25.7232681429241,
    "b": -6.05167945983336,
    "C": 26.4255434804536,
    "h": 0.23105920092742,
    "CMY_C": 0.8415255,
    "CMY_M": 0.5039484,
    "CMY_Y": 0.5183553,
    "CMYK_C": 0.6805282,
    "CMYK_M": 0,
    "CMYK_Y": 0.02904319,
    "CMYK_K": 0.5039484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06903",
    "Farbtonhilfsbezeichnung": "N8.27.36",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "114",
    "Bcolor": "112",
    "Y": 14,
    "L": 44.3258492507761,
    "a": -19.8164625509016,
    "b": -5.26224682194449,
    "C": 20.5032541233422,
    "h": 0.25955887303656,
    "CMY_C": 0.7872795,
    "CMY_M": 0.5517431,
    "CMY_Y": 0.5606361,
    "CMYK_C": 0.5254496,
    "CMYK_M": 0,
    "CMYK_Y": 0.01983905,
    "CMYK_K": 0.5517431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06904",
    "Farbtonhilfsbezeichnung": "N8.20.41",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "126",
    "Bcolor": "123",
    "Y": 18,
    "L": 49.594056605601,
    "a": -16.1788362293463,
    "b": -3.90423280094614,
    "C": 16.6432501483332,
    "h": 0.23679014776029,
    "CMY_C": 0.685809,
    "CMY_M": 0.5056043,
    "CMY_Y": 0.5175326,
    "CMYK_C": 0.3644947,
    "CMYK_M": 0,
    "CMYK_Y": 0.02412687,
    "CMYK_K": 0.5056043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06905",
    "Farbtonhilfsbezeichnung": "N8.51.30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "110",
    "Bcolor": "107",
    "Y": 10,
    "L": 41.3444175720215,
    "a": -28.2924308776856,
    "b": -7.01123476028442,
    "C": 29.1482257843018,
    "h": 193.918258666992,
    "CMY_C": 1,
    "CMY_M": 0.56832849979401,
    "CMY_Y": 0.57898706197739,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02469137310982,
    "CMYK_K": 0.56832849979401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06906",
    "Farbtonhilfsbezeichnung": "N6.49.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "109",
    "Y": 13,
    "L": 42.0786291860223,
    "a": -33.0028628099517,
    "b": -6.87713986637122,
    "C": 33.7117784519613,
    "h": 0.20544021046825,
    "CMY_C": 1,
    "CMY_M": 0.554755,
    "CMY_Y": 0.5731412,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.0412945,
    "CMYK_K": 0.554755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06907",
    "Farbtonhilfsbezeichnung": "N8.43.31",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "108",
    "Bcolor": "106",
    "Y": 12,
    "L": 40.9768229160484,
    "a": -23.9075534497545,
    "b": -6.85092119215002,
    "C": 24.8697855466009,
    "h": 0.27908031481754,
    "CMY_C": 0.9138963,
    "CMY_M": 0.5781693,
    "CMY_Y": 0.5831861,
    "CMYK_C": 0.795881,
    "CMYK_M": 0,
    "CMYK_Y": 0.01189289,
    "CMYK_K": 0.5781693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06908",
    "Farbtonhilfsbezeichnung": "N6.39.33",
    "Farbtonklasse": "03",
    "Rcolor": "22",
    "Gcolor": "113",
    "Bcolor": "109",
    "Y": 13,
    "L": 42.9265405436771,
    "a": -25.9906936375707,
    "b": -5.44021808446582,
    "C": 26.5539475138558,
    "h": 0.20633515352237,
    "CMY_C": 0.9152764,
    "CMY_M": 0.5562553,
    "CMY_Y": 0.5735966,
    "CMYK_C": 0.8090714,
    "CMYK_M": 0,
    "CMYK_Y": 0.03907937,
    "CMYK_K": 0.5562553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06909",
    "Farbtonhilfsbezeichnung": "N7.32.30",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "101",
    "Bcolor": "99",
    "Y": 11,
    "L": 39.1029848296994,
    "a": -19.0499104812303,
    "b": -5.03125649798154,
    "C": 19.7031122234882,
    "h": 0.25821319285646,
    "CMY_C": 0.8298609,
    "CMY_M": 0.6040962,
    "CMY_Y": 0.6122139,
    "CMYK_C": 0.5702513,
    "CMYK_M": 0,
    "CMYK_Y": 0.02050415,
    "CMYK_K": 0.6040962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06910",
    "Farbtonhilfsbezeichnung": "N8.14.36",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "111",
    "Bcolor": "109",
    "Y": 14,
    "L": 44.4752455060024,
    "a": -10.6769062129315,
    "b": -2.95319784189858,
    "C": 11.0778022988827,
    "h": 0.26985011446348,
    "CMY_C": 0.6795717,
    "CMY_M": 0.5661573,
    "CMY_Y": 0.5731713,
    "CMYK_C": 0.2614181,
    "CMYK_M": 0,
    "CMYK_Y": 0.01616712,
    "CMYK_K": 0.5661573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06911",
    "Farbtonhilfsbezeichnung": "N7.05.36",
    "Farbtonklasse": "02",
    "Rcolor": "97",
    "Gcolor": "107",
    "Bcolor": "107",
    "Y": 14,
    "L": 44.4387815633825,
    "a": -3.76754986180827,
    "b": -1.46727934320829,
    "C": 4.04318446675604,
    "h": 0.3713802205678,
    "CMY_C": 0.6194487,
    "CMY_M": 0.5797579,
    "CMY_Y": 0.58233,
    "CMYK_C": 0.09444746,
    "CMYK_M": 0,
    "CMYK_Y": 0.006120677,
    "CMYK_K": 0.5797579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06912",
    "Farbtonhilfsbezeichnung": "N8.55.29",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "102",
    "Bcolor": "100",
    "Y": 10,
    "L": 37.5203549939498,
    "a": -33.3507688782562,
    "b": -8.32008751484006,
    "C": 34.3729201701785,
    "h": 0.24448178730504,
    "CMY_C": 1,
    "CMY_M": 0.5992005,
    "CMY_Y": 0.6076957,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02119553,
    "CMYK_K": 0.5992005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06913",
    "Farbtonhilfsbezeichnung": "N6.48.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "85",
    "Y": 8,
    "L": 33.0068760146187,
    "a": -26.4343464437375,
    "b": -5.73904551493809,
    "C": 27.0501629446121,
    "h": 0.21378788725576,
    "CMY_C": 1,
    "CMY_M": 0.6522368,
    "CMY_Y": 0.6655938,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.03840842,
    "CMYK_K": 0.6522368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06914",
    "Farbtonhilfsbezeichnung": "N6.41.29",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "94",
    "Y": 10,
    "L": 36.9874128725131,
    "a": -26.5245626031837,
    "b": -5.14293952474479,
    "C": 27.0185537778282,
    "h": 0.19151706221356,
    "CMY_C": 1,
    "CMY_M": 0.6138993,
    "CMY_Y": 0.6321532,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04727742,
    "CMYK_K": 0.6138993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06915",
    "Farbtonhilfsbezeichnung": "N9.32.25",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "92",
    "Bcolor": "90",
    "Y": 9,
    "L": 35.6522313068908,
    "a": -16.8127262020867,
    "b": -4.37207309587668,
    "C": 17.3718964279096,
    "h": 0.25441063828056,
    "CMY_C": 0.8317031,
    "CMY_M": 0.6407691,
    "CMY_Y": 0.6486422,
    "CMYK_C": 0.5315078,
    "CMYK_M": 0,
    "CMYK_Y": 0.0219168,
    "CMYK_K": 0.6407691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06916",
    "Farbtonhilfsbezeichnung": "N8.24.26",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "87",
    "Bcolor": "86",
    "Y": 8,
    "L": 34.2806043563659,
    "a": -14.1605537208085,
    "b": -3.98873073244197,
    "C": 14.7116027181212,
    "h": 0.27456496750515,
    "CMY_C": 0.8128257,
    "CMY_M": 0.6579245,
    "CMY_Y": 0.6635332,
    "CMYK_C": 0.4528273,
    "CMYK_M": 0,
    "CMYK_Y": 0.01639571,
    "CMYK_K": 0.6579245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06917",
    "Farbtonhilfsbezeichnung": "N8.19.31",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "99",
    "Bcolor": "98",
    "Y": 11,
    "L": 39.478619215568,
    "a": -12.9271599578122,
    "b": -3.5862356543969,
    "C": 13.4153848526135,
    "h": 0.27061344523249,
    "CMY_C": 0.7497677,
    "CMY_M": 0.6105671,
    "CMY_Y": 0.617192,
    "CMYK_C": 0.3574444,
    "CMYK_M": 0,
    "CMYK_Y": 0.01701181,
    "CMYK_K": 0.6105671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06918",
    "Farbtonhilfsbezeichnung": "N8.10.31",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "96",
    "Bcolor": "95",
    "Y": 11,
    "L": 39.1523843931099,
    "a": -6.98707272247873,
    "b": -2.07513698904422,
    "C": 7.28871585071786,
    "h": 0.28869912831984,
    "CMY_C": 0.6957074,
    "CMY_M": 0.6243629,
    "CMY_Y": 0.6291887,
    "CMYK_C": 0.1899294,
    "CMYK_M": 0,
    "CMYK_Y": 0.01284683,
    "CMYK_K": 0.6243629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06919",
    "Farbtonhilfsbezeichnung": "N7.52.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "85",
    "Y": 8,
    "L": 32.9953841300076,
    "a": -28.3256311597048,
    "b": -5.60769897594789,
    "C": 28.8753817013817,
    "h": 0.19544538326827,
    "CMY_C": 1,
    "CMY_M": 0.6500003,
    "CMY_Y": 0.6666514,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04757436,
    "CMYK_K": 0.6500003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06920",
    "Farbtonhilfsbezeichnung": "N6.45.24",
    "Farbtonklasse": "03",
    "Rcolor": "8",
    "Gcolor": "92",
    "Bcolor": "88",
    "Y": 8,
    "L": 34.8132968783491,
    "a": -23.2468577185876,
    "b": -4.84957050879193,
    "C": 23.7473099088718,
    "h": 0.20566232661979,
    "CMY_C": 0.9693821,
    "CMY_M": 0.6393737,
    "CMY_Y": 0.6540591,
    "CMYK_C": 0.915098,
    "CMYK_M": 0,
    "CMYK_Y": 0.04072167,
    "CMYK_K": 0.6393737
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06921",
    "Farbtonhilfsbezeichnung": "N8.40.21",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "87",
    "Bcolor": "86",
    "Y": 7,
    "L": 34.0194435119629,
    "a": -14.0913572311401,
    "b": -4.48419618606567,
    "C": 14.7876424789429,
    "h": 197.652282714844,
    "CMY_C": 0.81741166114807,
    "CMY_M": 0.6603696346283,
    "CMY_Y": 0.66289734840393,
    "CMYK_C": 0.46239101886749,
    "CMYK_M": 0,
    "CMYK_Y": 0.00744254374877,
    "CMYK_K": 0.6603696346283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06922",
    "Farbtonhilfsbezeichnung": "N9.37.22",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "91",
    "Bcolor": "88",
    "Y": 7,
    "L": 35.3121032714844,
    "a": -16.2135810852051,
    "b": -4.12379169464111,
    "C": 16.7297897338867,
    "h": 194.270126342773,
    "CMY_C": 0.82631450891495,
    "CMY_M": 0.64497143030167,
    "CMY_Y": 0.65329945087433,
    "CMYK_C": 0.51078444719315,
    "CMYK_M": 0,
    "CMYK_Y": 0.02345732599497,
    "CMYK_K": 0.64497143030167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06923",
    "Farbtonhilfsbezeichnung": "N8.29.21",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "80",
    "Bcolor": "78",
    "Y": 7,
    "L": 31.2724359864288,
    "a": -13.5270235106364,
    "b": -3.80009424804933,
    "C": 14.0506612424956,
    "h": 0.27386728845778,
    "CMY_C": 0.8332925,
    "CMY_M": 0.6870543,
    "CMY_Y": 0.6923025,
    "CMYK_C": 0.4672958,
    "CMYK_M": 0,
    "CMYK_Y": 0.01677004,
    "CMYK_K": 0.6870543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06924",
    "Farbtonhilfsbezeichnung": "N9.26.20",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "77",
    "Bcolor": "76",
    "Y": 6,
    "L": 30.2077259711326,
    "a": -12.6808119071067,
    "b": -3.92396690301063,
    "C": 13.2740538977112,
    "h": 0.30009587192859,
    "CMY_C": 0.8351431,
    "CMY_M": 0.6981643,
    "CMY_Y": 0.7011731,
    "CMYK_C": 0.4538192,
    "CMYK_M": 0,
    "CMYK_Y": 0.009968277,
    "CMYK_K": 0.6981643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06925",
    "Farbtonhilfsbezeichnung": "N5.10.16",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "64",
    "Bcolor": "63",
    "Y": 5,
    "L": 26.2551106025587,
    "a": -4.90814564195377,
    "b": -1.07049512405232,
    "C": 5.02352997933222,
    "h": 0.21474285330366,
    "CMY_C": 0.7924604,
    "CMY_M": 0.7471969,
    "CMY_Y": 0.7527918,
    "CMYK_C": 0.1790467,
    "CMYK_M": 0,
    "CMYK_Y": 0.02213146,
    "CMYK_K": 0.7471969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06926",
    "Farbtonhilfsbezeichnung": "N8.10.20",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "71",
    "Bcolor": "71",
    "Y": 6,
    "L": 29.300796165151,
    "a": -4.47710573192489,
    "b": -1.99695555804181,
    "C": 4.90227572007418,
    "h": 0.41955354869864,
    "CMY_C": 0.7658437,
    "CMY_M": 0.7203948,
    "CMY_Y": 0.7201611,
    "CMYK_C": 0.1632463,
    "CMYK_M": 0.000835255,
    "CMYK_Y": 0,
    "CMYK_K": 0.7201611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06927",
    "Farbtonhilfsbezeichnung": "N8.50.23",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "91",
    "Bcolor": "88",
    "Y": 8,
    "L": 33.717637300089,
    "a": -26.6331848004157,
    "b": -6.59704990485551,
    "C": 27.4380684462345,
    "h": 0.24281314332896,
    "CMY_C": 1,
    "CMY_M": 0.6449775,
    "CMY_Y": 0.6537295,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02465201,
    "CMYK_K": 0.6449775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06928",
    "Farbtonhilfsbezeichnung": "N8.46.21",
    "Farbtonklasse": "03",
    "Rcolor": "14",
    "Gcolor": "84",
    "Bcolor": "83",
    "Y": 7,
    "L": 32.0311059792634,
    "a": -20.5527145364052,
    "b": -5.43453263000925,
    "C": 21.2590738208793,
    "h": 0.2585029762552,
    "CMY_C": 0.9460347,
    "CMY_M": 0.6693653,
    "CMY_Y": 0.6760015,
    "CMYK_C": 0.8367826,
    "CMYK_M": 0,
    "CMYK_Y": 0.02007098,
    "CMYK_K": 0.6693653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06929",
    "Farbtonhilfsbezeichnung": "N7.34.19",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "85",
    "Bcolor": "82",
    "Y": 6,
    "L": 33.3872032165527,
    "a": -13.8611516952515,
    "b": -3.0965793132782,
    "C": 14.2028284072876,
    "h": 192.59309387207,
    "CMY_C": 0.81315243244171,
    "CMY_M": 0.66698902845383,
    "CMY_Y": 0.67723941802979,
    "CMYK_C": 0.43891468644142,
    "CMYK_M": 0,
    "CMYK_Y": 0.03078093566,
    "CMYK_K": 0.66698902845383
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06930",
    "Farbtonhilfsbezeichnung": "N6.37.15",
    "Farbtonklasse": "03",
    "Rcolor": "26",
    "Gcolor": "69",
    "Bcolor": "66",
    "Y": 5,
    "L": 26.3739199639386,
    "a": -15.2642325984895,
    "b": -3.28290206569245,
    "C": 15.6132713674527,
    "h": 0.2118445415572,
    "CMY_C": 0.896465,
    "CMY_M": 0.7295557,
    "CMY_Y": 0.7396562,
    "CMYK_C": 0.617167,
    "CMYK_M": 0,
    "CMYK_Y": 0.03734764,
    "CMYK_K": 0.7295557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06931",
    "Farbtonhilfsbezeichnung": "N7.19.21",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "77",
    "Bcolor": "76",
    "Y": 7,
    "L": 30.701618447726,
    "a": -9.6942860582914,
    "b": -2.79103790148533,
    "C": 10.0880659567387,
    "h": 0.28032428840375,
    "CMY_C": 0.7974107,
    "CMY_M": 0.6986099,
    "CMY_Y": 0.7032506,
    "CMYK_C": 0.327817,
    "CMYK_M": 0,
    "CMYK_Y": 0.01539751,
    "CMYK_K": 0.6986099
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06932",
    "Farbtonhilfsbezeichnung": "N7.18.15",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "67",
    "Bcolor": "66",
    "Y": 5,
    "L": 26.7758807499635,
    "a": -7.53681771584069,
    "b": -2.16199231162382,
    "C": 7.84078006561405,
    "h": 0.2793562273645,
    "CMY_C": 0.811638,
    "CMY_M": 0.7379086,
    "CMY_Y": 0.742017,
    "CMYK_C": 0.2813117,
    "CMYK_M": 0,
    "CMYK_Y": 0.01567527,
    "CMYK_K": 0.7379086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06933",
    "Farbtonhilfsbezeichnung": "N6.23.11",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "61",
    "Bcolor": "61",
    "Y": 4,
    "L": 24.3047075685517,
    "a": -5.85755917911959,
    "b": -2.47472485181501,
    "C": 6.35887274830052,
    "h": 0.39973761801873,
    "CMY_C": 0.8212378,
    "CMY_M": 0.7625632,
    "CMY_Y": 0.7617902,
    "CMYK_C": 0.2495597,
    "CMYK_M": 0.003245075,
    "CMYK_Y": 0,
    "CMYK_K": 0.7617902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06934",
    "Farbtonhilfsbezeichnung": "N7.19.11",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "60",
    "Bcolor": "59",
    "Y": 4,
    "L": 24.154257481798,
    "a": -5.97989263720369,
    "b": -1.80675826798731,
    "C": 6.24687853182879,
    "h": 0.29341794398563,
    "CMY_C": 0.8209617,
    "CMY_M": 0.7638397,
    "CMY_Y": 0.7669982,
    "CMYK_C": 0.2418778,
    "CMYK_M": 0,
    "CMYK_Y": 0.01337418,
    "CMYK_K": 0.7638397
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06935",
    "Farbtonhilfsbezeichnung": "P3.15.77",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "222",
    "Bcolor": "222",
    "Y": 65,
    "L": 84.7368726803794,
    "a": -17.022922321162,
    "b": -6.99724895908098,
    "C": 18.4049280723309,
    "h": 0.38999462634595,
    "CMY_C": 0.3473681,
    "CMY_M": 0.1308641,
    "CMY_Y": 0.1278973,
    "CMYK_C": 0.2516571,
    "CMYK_M": 0.003401865,
    "CMYK_Y": 0,
    "CMYK_K": 0.1278973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06936",
    "Farbtonhilfsbezeichnung": "P0.11.80",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "227",
    "Bcolor": "224",
    "Y": 71,
    "L": 87.4368850364258,
    "a": -13.2796154786233,
    "b": -3.6381849626828,
    "C": 13.7689715332258,
    "h": 0.26740618443292,
    "CMY_C": 0.2669216,
    "CMY_M": 0.1095515,
    "CMY_Y": 0.1223305,
    "CMYK_C": 0.1767313,
    "CMYK_M": 0,
    "CMYK_Y": 0.01435114,
    "CMYK_K": 0.1095515
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06937",
    "Farbtonhilfsbezeichnung": "P3.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "238",
    "Bcolor": "236",
    "Y": 83,
    "L": 92.9502144278338,
    "a": -5.23961084244606,
    "b": -1.63187102107565,
    "C": 5.48785247703551,
    "h": 0.3019269941356,
    "CMY_C": 0.1281866,
    "CMY_M": 0.06615338,
    "CMY_Y": 0.07503778,
    "CMYK_C": 0.06642767,
    "CMYK_M": 0,
    "CMYK_Y": 0.00951377,
    "CMYK_K": 0.06615338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06938",
    "Farbtonhilfsbezeichnung": "P1.26.67",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "200",
    "Bcolor": "199",
    "Y": 48,
    "L": 75.1204688842404,
    "a": -27.7111640148406,
    "b": -8.85632539155801,
    "C": 29.0919767375569,
    "h": 0.30933473293966,
    "CMY_C": 0.5832298,
    "CMY_M": 0.2159527,
    "CMY_Y": 0.2204562,
    "CMYK_C": 0.4684374,
    "CMYK_M": 0,
    "CMYK_Y": 0.005743865,
    "CMYK_K": 0.2159527
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06939",
    "Farbtonhilfsbezeichnung": "P3.24.72",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "216",
    "Bcolor": "216",
    "Y": 58,
    "L": 80.8990345374206,
    "a": -26.3884661542615,
    "b": -9.55119498904757,
    "C": 28.063792895712,
    "h": 0.34727708462915,
    "CMY_C": 0.5066369,
    "CMY_M": 0.1545207,
    "CMY_Y": 0.152493,
    "CMYK_C": 0.4178655,
    "CMYK_M": 0.002392537,
    "CMYK_Y": 0,
    "CMYK_K": 0.152493
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06940",
    "Farbtonhilfsbezeichnung": "P3.17.76",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "221",
    "Bcolor": "220",
    "Y": 64,
    "L": 83.8054245307218,
    "a": -20.6364166277949,
    "b": -7.25563606739099,
    "C": 21.8747787641008,
    "h": 0.3380939763919,
    "CMY_C": 0.395539,
    "CMY_M": 0.1339123,
    "CMY_Y": 0.1366744,
    "CMYK_C": 0.3020787,
    "CMYK_M": 0,
    "CMYK_Y": 0.003189198,
    "CMYK_K": 0.1339123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06941",
    "Farbtonhilfsbezeichnung": "P1.11.75",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "215",
    "Bcolor": "213",
    "Y": 62,
    "L": 83.16016647393,
    "a": -13.7454911769631,
    "b": -4.25708604586217,
    "C": 14.3896250575838,
    "h": 0.30033908067484,
    "CMY_C": 0.3200888,
    "CMY_M": 0.155828,
    "CMY_Y": 0.1648038,
    "CMYK_C": 0.1945822,
    "CMYK_M": 0,
    "CMYK_Y": 0.01063266,
    "CMYK_K": 0.155828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06942",
    "Farbtonhilfsbezeichnung": "P3.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "230",
    "Bcolor": "226",
    "Y": 75,
    "L": 89.6128823493107,
    "a": -8.13499822025571,
    "b": -1.30478725649616,
    "C": 8.23897237695808,
    "h": 0.15903728893487,
    "CMY_C": 0.1882082,
    "CMY_M": 0.09708923,
    "CMY_Y": 0.1148644,
    "CMYK_C": 0.1009169,
    "CMYK_M": 0,
    "CMYK_Y": 0.01968648,
    "CMYK_K": 0.09708923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06943",
    "Farbtonhilfsbezeichnung": "P0.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "231",
    "Bcolor": "229",
    "Y": 77,
    "L": 90.5106233755437,
    "a": -4.64909131136776,
    "b": -1.48965158004735,
    "C": 4.88191682143118,
    "h": 0.31008188401821,
    "CMY_C": 0.1497238,
    "CMY_M": 0.09486245,
    "CMY_Y": 0.1031088,
    "CMYK_C": 0.0606111,
    "CMYK_M": 0,
    "CMYK_Y": 0.009110565,
    "CMYK_K": 0.09486245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06944",
    "Farbtonhilfsbezeichnung": "P0.34.64",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "195",
    "Bcolor": "193",
    "Y": 44,
    "L": 72.250155583617,
    "a": -35.3354218810099,
    "b": -10.0195528255089,
    "C": 36.7285104289857,
    "h": 0.27630265407905,
    "CMY_C": 0.7581787,
    "CMY_M": 0.2339994,
    "CMY_Y": 0.2437901,
    "CMYK_C": 0.6843067,
    "CMYK_M": 0,
    "CMYK_Y": 0.01278166,
    "CMYK_K": 0.2339994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06945",
    "Farbtonhilfsbezeichnung": "P4.25.67",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "200",
    "Bcolor": "203",
    "Y": 49,
    "L": 75.5299311610329,
    "a": -25.9568621172303,
    "b": -10.762161085785,
    "C": 28.0995160493786,
    "h": 0.39304354544221,
    "CMY_C": 0.5697145,
    "CMY_M": 0.2140827,
    "CMY_Y": 0.2022175,
    "CMYK_C": 0.4606481,
    "CMYK_M": 0.01487271,
    "CMYK_Y": 0,
    "CMYK_K": 0.2022175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06946",
    "Farbtonhilfsbezeichnung": "P0.18.72",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "208",
    "Bcolor": "206",
    "Y": 55,
    "L": 79.3150860750085,
    "a": -21.0532844289148,
    "b": -6.25251366311059,
    "C": 21.9621199421224,
    "h": 0.28868862330646,
    "CMY_C": 0.4427995,
    "CMY_M": 0.1830071,
    "CMY_Y": 0.1930623,
    "CMYK_C": 0.3179861,
    "CMYK_M": 0,
    "CMYK_Y": 0.01230756,
    "CMYK_K": 0.1830071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06947",
    "Farbtonhilfsbezeichnung": "P4.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "215",
    "Bcolor": "214",
    "Y": 62,
    "L": 83.1070991970924,
    "a": -14.1582650954702,
    "b": -5.16063308125601,
    "C": 15.0694593238432,
    "h": 0.34953016487395,
    "CMY_C": 0.3285925,
    "CMY_M": 0.1553027,
    "CMY_Y": 0.1588547,
    "CMYK_C": 0.2051502,
    "CMYK_M": 0,
    "CMYK_Y": 0.004205095,
    "CMYK_K": 0.1553027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06948",
    "Farbtonhilfsbezeichnung": "P3.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 69,
    "L": 86.6200559006772,
    "a": -6.70760070643939,
    "b": -2.07837160517328,
    "C": 7.02221729699507,
    "h": 0.30047174352467,
    "CMY_C": 0.211835,
    "CMY_M": 0.1333185,
    "CMY_Y": 0.141946,
    "CMYK_C": 0.09059443,
    "CMYK_M": 0,
    "CMYK_Y": 0.009954648,
    "CMYK_K": 0.1333185
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06949",
    "Farbtonhilfsbezeichnung": "P5.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "220",
    "Bcolor": "219",
    "Y": 70,
    "L": 87.0145724348293,
    "a": -3.61350718758946,
    "b": -1.4321130200142,
    "C": 3.88695020509073,
    "h": 0.37733182104982,
    "CMY_C": 0.1794464,
    "CMY_M": 0.1361033,
    "CMY_Y": 0.1419495,
    "CMYK_C": 0.05017161,
    "CMYK_M": 0,
    "CMYK_Y": 0.006767235,
    "CMYK_K": 0.1361033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06950",
    "Farbtonhilfsbezeichnung": "P4.38.55",
    "Farbtonklasse": "03",
    "Rcolor": "2",
    "Gcolor": "169",
    "Bcolor": "176",
    "Y": 32,
    "L": 63.0893315305404,
    "a": -32.9439853192843,
    "b": -14.5892057198019,
    "C": 36.0298638944407,
    "h": 0.41689112982914,
    "CMY_C": 0.9917424,
    "CMY_M": 0.3355362,
    "CMY_Y": 0.3089669,
    "CMYK_C": 0.9880504,
    "CMYK_M": 0.03844865,
    "CMYK_Y": 0,
    "CMYK_K": 0.3089669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06952",
    "Farbtonhilfsbezeichnung": "P4.18.70",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "205",
    "Bcolor": "206",
    "Y": 54,
    "L": 78.3558885741413,
    "a": -19.0198784688559,
    "b": -7.62749373100562,
    "C": 20.4923019103902,
    "h": 0.38139181266963,
    "CMY_C": 0.4393282,
    "CMY_M": 0.1970772,
    "CMY_Y": 0.1933338,
    "CMYK_C": 0.3049519,
    "CMYK_M": 0.004640619,
    "CMYK_Y": 0,
    "CMYK_K": 0.1933338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06953",
    "Farbtonhilfsbezeichnung": "P3.09.74",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "210",
    "Bcolor": "209",
    "Y": 60,
    "L": 81.9837827722609,
    "a": -10.1789511008331,
    "b": -3.74343926127509,
    "C": 10.8454775374811,
    "h": 0.35241065502218,
    "CMY_C": 0.2984462,
    "CMY_M": 0.1764141,
    "CMY_Y": 0.1809317,
    "CMYK_C": 0.1481717,
    "CMYK_M": 0,
    "CMYK_Y": 0.005485223,
    "CMYK_K": 0.1764141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06954",
    "Farbtonhilfsbezeichnung": "P5.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "224",
    "Bcolor": "223",
    "Y": 72,
    "L": 88.1677222722209,
    "a": -4.68108159096714,
    "b": -2.04969514958495,
    "C": 5.11016389830341,
    "h": 0.41271915584209,
    "CMY_C": 0.1778774,
    "CMY_M": 0.1207147,
    "CMY_Y": 0.1248648,
    "CMYK_C": 0.06501035,
    "CMYK_M": 0,
    "CMYK_Y": 0.00471986,
    "CMYK_K": 0.1207147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06955",
    "Farbtonhilfsbezeichnung": "PN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "225",
    "Bcolor": "223",
    "Y": 74,
    "L": 89.0600216526095,
    "a": -1.21407490746633,
    "b": -0.59284517427764,
    "C": 1.35108966453144,
    "h": 0.45425212049787,
    "CMY_C": 0.134514,
    "CMY_M": 0.1192121,
    "CMY_Y": 0.1252966,
    "CMYK_C": 0.01737298,
    "CMYK_M": 0,
    "CMYK_Y": 0.006908008,
    "CMYK_K": 0.1192121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06956",
    "Farbtonhilfsbezeichnung": "P0.37.54",
    "Farbtonklasse": "03",
    "Rcolor": "28",
    "Gcolor": "165",
    "Bcolor": "165",
    "Y": 30,
    "L": 61.6905723535073,
    "a": -33.2247545291278,
    "b": -10.3868956677306,
    "C": 34.8105144336179,
    "h": 0.30299892930575,
    "CMY_C": 0.8894614,
    "CMY_M": 0.3511538,
    "CMY_Y": 0.3526625,
    "CMYK_C": 0.8296382,
    "CMYK_M": 0,
    "CMYK_Y": 0.002325163,
    "CMYK_K": 0.3511538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06957",
    "Farbtonhilfsbezeichnung": "P0.30.61",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "184",
    "Bcolor": "180",
    "Y": 39,
    "L": 69.005374727145,
    "a": -30.8892006501341,
    "b": -7.76261852866971,
    "C": 31.8496619012807,
    "h": 0.24620676314496,
    "CMY_C": 0.6913227,
    "CMY_M": 0.277255,
    "CMY_Y": 0.2938817,
    "CMYK_C": 0.5729098,
    "CMYK_M": 0,
    "CMYK_Y": 0.02300492,
    "CMYK_K": 0.277255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06958",
    "Farbtonhilfsbezeichnung": "P1.27.59",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "177",
    "Bcolor": "177",
    "Y": 37,
    "L": 67.0930084049412,
    "a": -25.6343905487746,
    "b": -8.81850076292297,
    "C": 27.1088165457804,
    "h": 0.33132907293194,
    "CMY_C": 0.6449821,
    "CMY_M": 0.3064729,
    "CMY_Y": 0.3061714,
    "CMYK_C": 0.4883204,
    "CMYK_M": 0.000434597,
    "CMYK_Y": 0,
    "CMYK_K": 0.3061714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06959",
    "Farbtonhilfsbezeichnung": "P1.20.62",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "183",
    "Bcolor": "181",
    "Y": 41,
    "L": 70.3866685350944,
    "a": -19.7358541106332,
    "b": -6.13167779300006,
    "C": 20.6664319618402,
    "h": 0.3012325231708,
    "CMY_C": 0.522964,
    "CMY_M": 0.2825331,
    "CMY_Y": 0.2895731,
    "CMYK_C": 0.3351108,
    "CMYK_M": 0,
    "CMYK_Y": 0.009812262,
    "CMYK_K": 0.2825331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06960",
    "Farbtonhilfsbezeichnung": "P5.13.67",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "192",
    "Bcolor": "194",
    "Y": 48,
    "L": 75.0032998164677,
    "a": -13.2691091776053,
    "b": -6.43969589303275,
    "C": 14.74920138726,
    "h": 0.45183063209106,
    "CMY_C": 0.4123814,
    "CMY_M": 0.24528,
    "CMY_Y": 0.2374007,
    "CMYK_C": 0.2294529,
    "CMYK_M": 0.01033207,
    "CMYK_Y": 0,
    "CMYK_K": 0.2374007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06961",
    "Farbtonhilfsbezeichnung": "PN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "216",
    "Bcolor": "216",
    "Y": 68,
    "L": 85.9652616967721,
    "a": -1.95520257415988,
    "b": -1.20861918992645,
    "C": 2.29860336993138,
    "h": 0.55366226756905,
    "CMY_C": 0.1767217,
    "CMY_M": 0.1515628,
    "CMY_Y": 0.1548738,
    "CMYK_C": 0.02965323,
    "CMYK_M": 0,
    "CMYK_Y": 0.003902543,
    "CMYK_K": 0.1515628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06962",
    "Farbtonhilfsbezeichnung": "P4.44.48",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "151",
    "Bcolor": "157",
    "Y": 24,
    "L": 55.891210428527,
    "a": -36.0090847489688,
    "b": -14.4683135545485,
    "C": 38.8070390724563,
    "h": 0.38205386894399,
    "CMY_C": 1,
    "CMY_M": 0.4070859,
    "CMY_Y": 0.3851837,
    "CMYK_C": 1,
    "CMYK_M": 0.03562392,
    "CMYK_Y": 0,
    "CMYK_K": 0.3851837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06963",
    "Farbtonhilfsbezeichnung": "P2.40.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "165",
    "Bcolor": "170",
    "Y": 30,
    "L": 61.3419619266234,
    "a": -34.6091765149149,
    "b": -13.5282077756705,
    "C": 37.1592182999353,
    "h": 0.37262400145267,
    "CMY_C": 1,
    "CMY_M": 0.3518621,
    "CMY_Y": 0.3348004,
    "CMYK_C": 1,
    "CMYK_M": 0.02564907,
    "CMYK_Y": 0,
    "CMYK_K": 0.3348004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06964",
    "Farbtonhilfsbezeichnung": "P4.35.54",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "166",
    "Bcolor": "172",
    "Y": 31,
    "L": 62.2899520174603,
    "a": -30.9224847831771,
    "b": -13.3122979610614,
    "C": 33.6662641552325,
    "h": 0.40652454889531,
    "CMY_C": 0.8605285,
    "CMY_M": 0.3476045,
    "CMY_Y": 0.326028,
    "CMYK_C": 0.7930604,
    "CMYK_M": 0.03201389,
    "CMYK_Y": 0,
    "CMYK_K": 0.326028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06965",
    "Farbtonhilfsbezeichnung": "P4.28.58",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "173",
    "Bcolor": "176",
    "Y": 35,
    "L": 65.5523376482574,
    "a": -25.1779701091511,
    "b": -10.8655381311272,
    "C": 27.4224378510789,
    "h": 0.4074049515833,
    "CMY_C": 0.6723779,
    "CMY_M": 0.3231351,
    "CMY_Y": 0.3081117,
    "CMYK_C": 0.5264812,
    "CMYK_M": 0.02171362,
    "CMYK_Y": 0,
    "CMYK_K": 0.3081117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06966",
    "Farbtonhilfsbezeichnung": "P2.12.66",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "189",
    "Bcolor": "188",
    "Y": 46,
    "L": 73.7109190017985,
    "a": -12.9949065234968,
    "b": -4.82376581245707,
    "C": 13.8613243295094,
    "h": 0.35543883053889,
    "CMY_C": 0.4159523,
    "CMY_M": 0.2602285,
    "CMY_Y": 0.262706,
    "CMYK_C": 0.2105025,
    "CMYK_M": 0,
    "CMYK_Y": 0.003348997,
    "CMYK_K": 0.2602285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06967",
    "Farbtonhilfsbezeichnung": "P5.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "194",
    "Bcolor": "193",
    "Y": 51,
    "L": 76.8312025598253,
    "a": -6.35338640392835,
    "b": -2.96319100951836,
    "C": 7.01042222384017,
    "h": 0.4364044867126,
    "CMY_C": 0.3176382,
    "CMY_M": 0.240953,
    "CMY_Y": 0.2417736,
    "CMYK_C": 0.1010283,
    "CMYK_M": 0,
    "CMYK_Y": 0.001081031,
    "CMYK_K": 0.240953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06968",
    "Farbtonhilfsbezeichnung": "PN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "220",
    "Bcolor": "218",
    "Y": 71,
    "L": 87.3409609162928,
    "a": -1.11732359278793,
    "b": -0.34554896593355,
    "C": 1.16953670265549,
    "h": 0.2999348775355,
    "CMY_C": 0.151858,
    "CMY_M": 0.1385597,
    "CMY_Y": 0.1460066,
    "CMYK_C": 0.0154372,
    "CMYK_M": 0,
    "CMYK_Y": 0.008644654,
    "CMYK_K": 0.1385597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06969",
    "Farbtonhilfsbezeichnung": "P2.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "142",
    "Bcolor": "146",
    "Y": 20,
    "L": 51.9404641996777,
    "a": -39.1944001103202,
    "b": -14.5262759672103,
    "C": 41.7996853275646,
    "h": 0.35492621491653,
    "CMY_C": 1,
    "CMY_M": 0.4439283,
    "CMY_Y": 0.425572,
    "CMYK_C": 1,
    "CMYK_M": 0.03195587,
    "CMYK_Y": 0,
    "CMYK_K": 0.425572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06970",
    "Farbtonhilfsbezeichnung": "P0.41.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "142",
    "Bcolor": "141",
    "Y": 21,
    "L": 52.5843563480991,
    "a": -34.7179272099947,
    "b": -10.1011179847439,
    "C": 36.1575310869009,
    "h": 0.28313183071543,
    "CMY_C": 1,
    "CMY_M": 0.4445955,
    "CMY_Y": 0.4482446,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.006570113,
    "CMYK_K": 0.4445955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06971",
    "Farbtonhilfsbezeichnung": "P5.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "151",
    "Bcolor": "156",
    "Y": 25,
    "L": 57.3010995741392,
    "a": -25.4202982624866,
    "b": -11.5965578454211,
    "C": 27.9405031739941,
    "h": 0.42799193749596,
    "CMY_C": 0.7813106,
    "CMY_M": 0.4093785,
    "CMY_Y": 0.3891965,
    "CMYK_C": 0.6419644,
    "CMYK_M": 0.03304172,
    "CMYK_Y": 0,
    "CMYK_K": 0.3891965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06972",
    "Farbtonhilfsbezeichnung": "P5.21.54",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "159",
    "Bcolor": "163",
    "Y": 30,
    "L": 62.0033261059544,
    "a": -17.4570497021636,
    "b": -8.29449771868447,
    "C": 19.3273711794717,
    "h": 0.44356046042354,
    "CMY_C": 0.5983356,
    "CMY_M": 0.374984,
    "CMY_Y": 0.3622886,
    "CMYK_C": 0.3701471,
    "CMYK_M": 0.01990777,
    "CMYK_Y": 0,
    "CMYK_K": 0.3622886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06973",
    "Farbtonhilfsbezeichnung": "PN.01.75",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "207",
    "Bcolor": "203",
    "Y": 62,
    "L": 82.7499532758392,
    "a": -1.24282673843051,
    "b": 0.53586046053182,
    "C": 1.35342703346697,
    "h": -0.40707885977307,
    "CMY_C": 0.2001322,
    "CMY_M": 0.1890056,
    "CMY_Y": 0.2025108,
    "CMYK_C": 0.0137198,
    "CMYK_M": 0,
    "CMYK_Y": 0.01665265,
    "CMYK_K": 0.1890056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06974",
    "Farbtonhilfsbezeichnung": "P5.54.22",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "96",
    "Y": 8,
    "L": 33.4724614338431,
    "a": -23.7272952348449,
    "b": -11.6551383655744,
    "C": 26.4353322181163,
    "h": 0.45659273675924,
    "CMY_C": 1,
    "CMY_M": 0.6498554,
    "CMY_Y": 0.6246312,
    "CMYK_C": 1,
    "CMYK_M": 0.06719849,
    "CMYK_Y": 0,
    "CMYK_K": 0.6246312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06975",
    "Farbtonhilfsbezeichnung": "P2.49.16",
    "Farbtonklasse": "03",
    "Rcolor": "12",
    "Gcolor": "73",
    "Bcolor": "74",
    "Y": 5,
    "L": 27.5217897411558,
    "a": -17.2058255350694,
    "b": -6.88917213076383,
    "C": 18.5337833426028,
    "h": 0.38084913283672,
    "CMY_C": 0.9535199,
    "CMY_M": 0.7155449,
    "CMY_Y": 0.7081318,
    "CMYK_C": 0.8407497,
    "CMYK_M": 0.02539882,
    "CMYK_Y": 0,
    "CMYK_K": 0.7081318
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06976",
    "Farbtonhilfsbezeichnung": "P2.46.15",
    "Farbtonklasse": "03",
    "Rcolor": "26",
    "Gcolor": "69",
    "Bcolor": "71",
    "Y": 5,
    "L": 26.5756653188519,
    "a": -13.8044646216021,
    "b": -6.34547340445758,
    "C": 15.1930338055222,
    "h": 0.43086485345969,
    "CMY_C": 0.8987632,
    "CMY_M": 0.7290993,
    "CMY_Y": 0.7196274,
    "CMYK_C": 0.6389205,
    "CMYK_M": 0.03378299,
    "CMYK_Y": 0,
    "CMYK_K": 0.7196274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06977",
    "Farbtonhilfsbezeichnung": "P3.34.15",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "67",
    "Bcolor": "68",
    "Y": 5,
    "L": 25.9046164840427,
    "a": -12.8287494207164,
    "b": -5.3040585168138,
    "C": 13.8819972788254,
    "h": 0.39204796797192,
    "CMY_C": 0.8853024,
    "CMY_M": 0.7368324,
    "CMY_Y": 0.7317065,
    "CMYK_C": 0.5724919,
    "CMYK_M": 0.01910589,
    "CMYK_Y": 0,
    "CMYK_K": 0.7317065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06978",
    "Farbtonhilfsbezeichnung": "P4.25.14",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "65",
    "Bcolor": "66",
    "Y": 5,
    "L": 25.5438816710631,
    "a": -8.97365131156544,
    "b": -4.38956880077207,
    "C": 9.98973133363814,
    "h": 0.45493963957531,
    "CMY_C": 0.8441715,
    "CMY_M": 0.7461184,
    "CMY_Y": 0.7399661,
    "CMYK_C": 0.4007376,
    "CMYK_M": 0.02365949,
    "CMYK_Y": 0,
    "CMYK_K": 0.7399661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06979",
    "Farbtonhilfsbezeichnung": "P2.24.16",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "69",
    "Bcolor": "70",
    "Y": 5,
    "L": 27.3143978272637,
    "a": -9.26982615569666,
    "b": -4.39731196906306,
    "C": 10.2599234651192,
    "h": 0.4429328256623,
    "CMY_C": 0.8312321,
    "CMY_M": 0.7297563,
    "CMY_Y": 0.7241505,
    "CMYK_C": 0.3881883,
    "CMYK_M": 0.02032165,
    "CMYK_Y": 0,
    "CMYK_K": 0.7241505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06980",
    "Farbtonhilfsbezeichnung": "P1.15.15",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "65",
    "Bcolor": "64",
    "Y": 5,
    "L": 26.0059214443838,
    "a": -6.33282741594646,
    "b": -2.37091558852853,
    "C": 6.76209611053338,
    "h": 0.35823138270395,
    "CMY_C": 0.8097852,
    "CMY_M": 0.7467229,
    "CMY_Y": 0.7474847,
    "CMYK_C": 0.2489853,
    "CMYK_M": 0,
    "CMYK_Y": 0.003007944,
    "CMYK_K": 0.7467229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06981",
    "Farbtonhilfsbezeichnung": "P4.07.15",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "67",
    "Bcolor": "68",
    "Y": 5,
    "L": 27.6215312125826,
    "a": -2.91901772238759,
    "b": -2.05699750195983,
    "C": 3.57098070376778,
    "h": 0.61386551821569,
    "CMY_C": 0.7698255,
    "CMY_M": 0.7382557,
    "CMY_Y": 0.7346694,
    "CMYK_C": 0.1324993,
    "CMYK_M": 0.01351659,
    "CMYK_Y": 0,
    "CMYK_K": 0.7346694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06982",
    "Farbtonhilfsbezeichnung": "P2.52.24",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "92",
    "Bcolor": "95",
    "Y": 8,
    "L": 34.2127106547341,
    "a": -26.5989284706338,
    "b": -10.1270653778512,
    "C": 28.4615609015593,
    "h": 0.3637865612954,
    "CMY_C": 1,
    "CMY_M": 0.6394057,
    "CMY_Y": 0.627281,
    "CMYK_C": 1,
    "CMYK_M": 0.0325304,
    "CMYK_Y": 0,
    "CMYK_K": 0.627281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06984",
    "Farbtonhilfsbezeichnung": "P4.37.21",
    "Farbtonklasse": "03",
    "Rcolor": "30",
    "Gcolor": "82",
    "Bcolor": "84",
    "Y": 7,
    "L": 31.5228780733558,
    "a": -15.9411196087851,
    "b": -7.03511464595991,
    "C": 17.424469359593,
    "h": 0.41561117065759,
    "CMY_C": 0.8829401,
    "CMY_M": 0.6803179,
    "CMY_Y": 0.670561,
    "CMYK_C": 0.6446689,
    "CMYK_M": 0.02961677,
    "CMYK_Y": 0,
    "CMYK_K": 0.670561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06985",
    "Farbtonhilfsbezeichnung": "P2.29.25",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "87",
    "Bcolor": "89",
    "Y": 8,
    "L": 33.969302669376,
    "a": -14.8471845816733,
    "b": -6.4105102049551,
    "C": 16.1719983641513,
    "h": 0.40758756390627,
    "CMY_C": 0.8386727,
    "CMY_M": 0.6592019,
    "CMY_Y": 0.6515791,
    "CMYK_C": 0.5369758,
    "CMYK_M": 0.02187808,
    "CMYK_Y": 0,
    "CMYK_K": 0.6515791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06986",
    "Farbtonhilfsbezeichnung": "P3.11.27",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "89",
    "Bcolor": "89",
    "Y": 9,
    "L": 36.3401764376831,
    "a": -6.22012785969225,
    "b": -3.05444481443065,
    "C": 6.9296193052232,
    "h": 0.45646861773304,
    "CMY_C": 0.719372,
    "CMY_M": 0.6521049,
    "CMY_Y": 0.6493784,
    "CMYK_C": 0.1996271,
    "CMYK_M": 0.007776237,
    "CMYK_Y": 0,
    "CMYK_K": 0.6493784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06987",
    "Farbtonhilfsbezeichnung": "P1.09.37",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "111",
    "Bcolor": "111",
    "Y": 15,
    "L": 45.2778232242667,
    "a": -6.24978247662,
    "b": -2.90389636006898,
    "C": 6.89147263471954,
    "h": 0.43496129607527,
    "CMY_C": 0.6354526,
    "CMY_M": 0.5664578,
    "CMY_Y": 0.5652495,
    "CMYK_C": 0.1614791,
    "CMYK_M": 0.002779338,
    "CMYK_Y": 0,
    "CMYK_K": 0.5652495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06990",
    "Farbtonhilfsbezeichnung": "P0.43.29",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "102",
    "Bcolor": "102",
    "Y": 10,
    "L": 38.5041930750866,
    "a": -25.6718970177817,
    "b": -7.73124702875218,
    "C": 26.8107903112008,
    "h": 0.29251705044705,
    "CMY_C": 1,
    "CMY_M": 0.5996704,
    "CMY_Y": 0.6014463,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.004435966,
    "CMYK_K": 0.5996704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06991",
    "Farbtonhilfsbezeichnung": "P5.41.29",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "104",
    "Bcolor": "108",
    "Y": 11,
    "L": 39.3887191020037,
    "a": -23.3507998560685,
    "b": -10.1341275831132,
    "C": 25.4550662106581,
    "h": 0.40946465620984,
    "CMY_C": 1,
    "CMY_M": 0.5936878,
    "CMY_Y": 0.5775929,
    "CMYK_C": 1,
    "CMYK_M": 0.03810294,
    "CMYK_Y": 0,
    "CMYK_K": 0.5775929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06992",
    "Farbtonhilfsbezeichnung": "P4.25.35",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "110",
    "Bcolor": "114",
    "Y": 13,
    "L": 43.3453053059345,
    "a": -15.9797456984246,
    "b": -7.61838844841303,
    "C": 17.7028843733792,
    "h": 0.44487748920555,
    "CMY_C": 0.7670379,
    "CMY_M": 0.5669693,
    "CMY_Y": 0.5546542,
    "CMYK_C": 0.476896,
    "CMYK_M": 0.0276527,
    "CMYK_Y": 0,
    "CMYK_K": 0.5546542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06993",
    "Farbtonhilfsbezeichnung": "P0.18.31",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "102",
    "Bcolor": "101",
    "Y": 12,
    "L": 40.8789348528739,
    "a": -11.3963157196215,
    "b": -3.74885138127847,
    "C": 11.9970787552723,
    "h": 0.31780301912483,
    "CMY_C": 0.7233582,
    "CMY_M": 0.5996329,
    "CMY_Y": 0.6026943,
    "CMYK_C": 0.3090295,
    "CMYK_M": 0,
    "CMYK_Y": 0.007646292,
    "CMYK_K": 0.5996329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06994",
    "Farbtonhilfsbezeichnung": "P2.07.45",
    "Farbtonklasse": "02",
    "Rcolor": "115",
    "Gcolor": "131",
    "Bcolor": "131",
    "Y": 22,
    "L": 53.5912980824717,
    "a": -5.82701132307734,
    "b": -2.53224136372825,
    "C": 6.3534484560314,
    "h": 0.40994809360944,
    "CMY_C": 0.5500838,
    "CMY_M": 0.4849526,
    "CMY_Y": 0.4857858,
    "CMYK_C": 0.1264566,
    "CMYK_M": 0,
    "CMYK_Y": 0.001617645,
    "CMYK_K": 0.4849526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06995",
    "Farbtonhilfsbezeichnung": "P2.06.53",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "151",
    "Bcolor": "150",
    "Y": 29,
    "L": 61.115906903324,
    "a": -6.00188109893091,
    "b": -2.28524738188094,
    "C": 6.42222175902528,
    "h": 0.36380674533682,
    "CMY_C": 0.475324,
    "CMY_M": 0.4079611,
    "CMY_Y": 0.4113431,
    "CMYK_C": 0.1137811,
    "CMYK_M": 0,
    "CMYK_Y": 0.005712356,
    "CMYK_K": 0.4079611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06996",
    "Farbtonhilfsbezeichnung": "P0.04.39",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "113",
    "Bcolor": "113",
    "Y": 16,
    "L": 47.058157393692,
    "a": -3.33566403579688,
    "b": -1.54567963152619,
    "C": 3.67638138432667,
    "h": 0.43392476659124,
    "CMY_C": 0.5913618,
    "CMY_M": 0.5550488,
    "CMY_Y": 0.556422,
    "CMYK_C": 0.08161119,
    "CMYK_M": 0,
    "CMYK_Y": 0.003086205,
    "CMYK_K": 0.5550488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06997",
    "Farbtonhilfsbezeichnung": "P2.54.28",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "102",
    "Bcolor": "106",
    "Y": 10,
    "L": 37.7341102804085,
    "a": -29.7924034328689,
    "b": -11.4986925231225,
    "C": 31.9344208033922,
    "h": 0.36834512787705,
    "CMY_C": 1,
    "CMY_M": 0.6007663,
    "CMY_Y": 0.585394,
    "CMYK_C": 1,
    "CMYK_M": 0.037077,
    "CMYK_Y": 0,
    "CMYK_K": 0.585394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06998",
    "Farbtonhilfsbezeichnung": "P4.47.23",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "92",
    "Y": 8,
    "L": 33.0733791710196,
    "a": -22.3443897904654,
    "b": -9.9700754735096,
    "C": 24.4678188659253,
    "h": 0.41968967992109,
    "CMY_C": 1,
    "CMY_M": 0.6559467,
    "CMY_Y": 0.6386672,
    "CMYK_C": 1,
    "CMYK_M": 0.04782171,
    "CMYK_Y": 0,
    "CMYK_K": 0.6386672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI06999",
    "Farbtonhilfsbezeichnung": "P3.51.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "115",
    "Bcolor": "120",
    "Y": 13,
    "L": 42.952851994956,
    "a": -30.8474488722366,
    "b": -12.3334560659073,
    "C": 33.2216682370847,
    "h": 0.38035200722371,
    "CMY_C": 1,
    "CMY_M": 0.5474885,
    "CMY_Y": 0.52939,
    "CMYK_C": 1,
    "CMYK_M": 0.03845761,
    "CMYK_Y": 0,
    "CMYK_K": 0.52939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07000",
    "Farbtonhilfsbezeichnung": "P4.46.35",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "120",
    "Bcolor": "125",
    "Y": 15,
    "L": 44.9954939972897,
    "a": -28.3098003277323,
    "b": -11.9942113657014,
    "C": 30.7458273735022,
    "h": 0.40074952382764,
    "CMY_C": 1,
    "CMY_M": 0.5306268,
    "CMY_Y": 0.5112319,
    "CMYK_C": 1,
    "CMYK_M": 0.03968116,
    "CMYK_Y": 0,
    "CMYK_K": 0.5112319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07001",
    "Farbtonhilfsbezeichnung": "P5.35.40",
    "Farbtonklasse": "03",
    "Rcolor": "31",
    "Gcolor": "126",
    "Bcolor": "131",
    "Y": 17,
    "L": 48.0021035272585,
    "a": -24.2138742092229,
    "b": -11.2216972733988,
    "C": 26.6877911022227,
    "h": 0.43397491055595,
    "CMY_C": 0.880116,
    "CMY_M": 0.5066473,
    "CMY_Y": 0.4860299,
    "CMYK_C": 0.766749,
    "CMYK_M": 0.04011413,
    "CMYK_Y": 0,
    "CMYK_K": 0.4860299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07002",
    "Farbtonhilfsbezeichnung": "P2.33.40",
    "Farbtonklasse": "03",
    "Rcolor": "35",
    "Gcolor": "126",
    "Bcolor": "128",
    "Y": 17,
    "L": 48.0918916475666,
    "a": -24.7452926009266,
    "b": -9.37503016736854,
    "C": 26.4616835546143,
    "h": 0.36215148900751,
    "CMY_C": 0.8638546,
    "CMY_M": 0.5054217,
    "CMY_Y": 0.4972917,
    "CMYK_C": 0.7291762,
    "CMYK_M": 0.01617239,
    "CMYK_Y": 0,
    "CMYK_K": 0.4972917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07003",
    "Farbtonhilfsbezeichnung": "P0.17.41",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "122",
    "Bcolor": "121",
    "Y": 17,
    "L": 48.6548455937346,
    "a": -13.162339778037,
    "b": -4.14856074979995,
    "C": 13.8006429099254,
    "h": 0.30532833424644,
    "CMY_C": 0.6671349,
    "CMY_M": 0.5201898,
    "CMY_Y": 0.524883,
    "CMYK_C": 0.3062568,
    "CMYK_M": 0,
    "CMYK_Y": 0.009781361,
    "CMYK_K": 0.5201898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07004",
    "Farbtonhilfsbezeichnung": "P0.14.49",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "144",
    "Bcolor": "143",
    "Y": 25,
    "L": 57.1266959816995,
    "a": -12.9054830985708,
    "b": -4.26682136298386,
    "C": 13.5925442265645,
    "h": 0.3193073061505,
    "CMY_C": 0.5820816,
    "CMY_M": 0.4349698,
    "CMY_Y": 0.4393373,
    "CMYK_C": 0.2603611,
    "CMYK_M": 0,
    "CMYK_Y": 0.007729772,
    "CMYK_K": 0.4349698
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07005",
    "Farbtonhilfsbezeichnung": "P2.54.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "135",
    "Y": 16,
    "L": 47.5891387492005,
    "a": -38.3568872669623,
    "b": -14.601771533332,
    "C": 41.0422042868323,
    "h": 0.36374270599298,
    "CMY_C": 1,
    "CMY_M": 0.4899968,
    "CMY_Y": 0.4690619,
    "CMYK_C": 1,
    "CMYK_M": 0.03943003,
    "CMYK_Y": 0,
    "CMYK_K": 0.4690619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07006",
    "Farbtonhilfsbezeichnung": "P4.40.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "137",
    "Bcolor": "143",
    "Y": 19,
    "L": 51.1758030183312,
    "a": -30.5405542408819,
    "b": -13.6359260980861,
    "C": 33.4464337993263,
    "h": 0.41992773750138,
    "CMY_C": 1,
    "CMY_M": 0.4642045,
    "CMY_Y": 0.4386238,
    "CMYK_C": 1,
    "CMYK_M": 0.04556778,
    "CMYK_Y": 0,
    "CMYK_K": 0.4386238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07007",
    "Farbtonhilfsbezeichnung": "P1.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "149",
    "Bcolor": "150",
    "Y": 24,
    "L": 56.5273657889898,
    "a": -26.4630502266597,
    "b": -9.4722153297508,
    "C": 28.107221323921,
    "h": 0.34373177298421,
    "CMY_C": 0.7866299,
    "CMY_M": 0.4163176,
    "CMY_Y": 0.4116247,
    "CMYK_C": 0.6373571,
    "CMYK_M": 0.007976109,
    "CMYK_Y": 0,
    "CMYK_K": 0.4116247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07008",
    "Farbtonhilfsbezeichnung": "P2.21.54",
    "Farbtonklasse": "01",
    "Rcolor": "98",
    "Gcolor": "159",
    "Bcolor": "159",
    "Y": 30,
    "L": 61.5042024107935,
    "a": -19.2708061671408,
    "b": -7.14123721277937,
    "C": 20.5514291293987,
    "h": 0.35488367934774,
    "CMY_C": 0.6162945,
    "CMY_M": 0.3772502,
    "CMY_Y": 0.3755674,
    "CMYK_C": 0.3855134,
    "CMYK_M": 0.002694882,
    "CMYK_Y": 0,
    "CMYK_K": 0.3755674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07009",
    "Farbtonhilfsbezeichnung": "P2.13.57",
    "Farbtonklasse": "01",
    "Rcolor": "128",
    "Gcolor": "165",
    "Bcolor": "165",
    "Y": 34,
    "L": 65.0729519314227,
    "a": -12.2873817102309,
    "b": -4.85880002254073,
    "C": 13.2131633968538,
    "h": 0.37656057162242,
    "CMY_C": 0.499026,
    "CMY_M": 0.3535059,
    "CMY_Y": 0.3534909,
    "CMYK_C": 0.2251092,
    "CMYK_M": 2.330736e-05,
    "CMYK_Y": 0,
    "CMYK_K": 0.3534909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07010",
    "Farbtonhilfsbezeichnung": "P0.06.60",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "171",
    "Bcolor": "169",
    "Y": 39,
    "L": 68.438230049486,
    "a": -6.49284403125644,
    "b": -2.21611558543144,
    "C": 6.86062620335888,
    "h": 0.32891822378306,
    "CMY_C": 0.4039927,
    "CMY_M": 0.3305165,
    "CMY_Y": 0.3360507,
    "CMYK_C": 0.1097505,
    "CMYK_M": 0,
    "CMYK_Y": 0.008266373,
    "CMYK_K": 0.3305165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07011",
    "Farbtonhilfsbezeichnung": "P7.35.63",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "189",
    "Bcolor": "200",
    "Y": 41,
    "L": 70.4207562662702,
    "a": -32.0765551730638,
    "b": -16.679049654935,
    "C": 36.1537838844345,
    "h": 0.47950066521044,
    "CMY_C": 0.81054,
    "CMY_M": 0.2574156,
    "CMY_Y": 0.2159796,
    "CMYK_C": 0.758348,
    "CMYK_M": 0.05285067,
    "CMYK_Y": 0,
    "CMYK_K": 0.2159796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07012",
    "Farbtonhilfsbezeichnung": "P8.42.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "165",
    "Bcolor": "179",
    "Y": 30,
    "L": 61.2673934451173,
    "a": -33.1032332952536,
    "b": -19.0107861839335,
    "C": 38.173735027257,
    "h": 0.52129894971655,
    "CMY_C": 1,
    "CMY_M": 0.3533735,
    "CMY_Y": 0.297703,
    "CMYK_C": 1,
    "CMYK_M": 0.07926912,
    "CMYK_Y": 0,
    "CMYK_K": 0.297703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07013",
    "Farbtonhilfsbezeichnung": "P8.38.52",
    "Farbtonklasse": "03",
    "Rcolor": "17",
    "Gcolor": "159",
    "Bcolor": "171",
    "Y": 28,
    "L": 59.7971680197046,
    "a": -29.2077151062823,
    "b": -16.355447592754,
    "C": 33.4752339452479,
    "h": 0.51046557132139,
    "CMY_C": 0.9320861,
    "CMY_M": 0.3758072,
    "CMY_Y": 0.331127,
    "CMYK_C": 0.8984652,
    "CMYK_M": 0.06679928,
    "CMYK_Y": 0,
    "CMYK_K": 0.331127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07014",
    "Farbtonhilfsbezeichnung": "P9.37.51",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "154",
    "Bcolor": "166",
    "Y": 26,
    "L": 57.7682002935952,
    "a": -28.8825492316868,
    "b": -16.8594277345777,
    "C": 33.4431151906974,
    "h": 0.52836563713029,
    "CMY_C": 1,
    "CMY_M": 0.3974607,
    "CMY_Y": 0.3488956,
    "CMYK_C": 1,
    "CMYK_M": 0.0745889,
    "CMYK_Y": 0,
    "CMYK_K": 0.3488956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07015",
    "Farbtonhilfsbezeichnung": "P9.46.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "157",
    "Y": 21,
    "L": 53.2856551625175,
    "a": -32.4720496046276,
    "b": -18.7674497829334,
    "C": 37.5053486436311,
    "h": 0.5240537366948,
    "CMY_C": 1,
    "CMY_M": 0.4381369,
    "CMY_Y": 0.382858,
    "CMYK_C": 1,
    "CMYK_M": 0.08957237,
    "CMYK_Y": 0,
    "CMYK_K": 0.382858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07016",
    "Farbtonhilfsbezeichnung": "P8.52.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "139",
    "Bcolor": "154",
    "Y": 19,
    "L": 51.1755064583052,
    "a": -35.4514375987502,
    "b": -20.3093232531263,
    "C": 40.8567379855276,
    "h": 0.52023753841056,
    "CMY_C": 1,
    "CMY_M": 0.4552966,
    "CMY_Y": 0.3945371,
    "CMYK_C": 1,
    "CMYK_M": 0.1003521,
    "CMYK_Y": 0,
    "CMYK_K": 0.3945371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07017",
    "Farbtonhilfsbezeichnung": "P7.50.41",
    "Farbtonklasse": "01",
    "Rcolor": "0",
    "Gcolor": "134",
    "Bcolor": "147",
    "Y": 18,
    "L": 49.4211346560202,
    "a": -33.8312104051547,
    "b": -18.5280831347239,
    "C": 38.5725376676864,
    "h": 0.50104676549639,
    "CMY_C": 1,
    "CMY_M": 0.4761364,
    "CMY_Y": 0.4242695,
    "CMYK_C": 1,
    "CMYK_M": 0.09008889,
    "CMYK_Y": 0,
    "CMYK_K": 0.4242695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07018",
    "Farbtonhilfsbezeichnung": "P6.56.38",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "139",
    "Y": 16,
    "L": 46.9732292748587,
    "a": -34.6227683351758,
    "b": -17.6184951880226,
    "C": 38.8477471661051,
    "h": 0.4707185656555,
    "CMY_C": 1,
    "CMY_M": 0.5003605,
    "CMY_Y": 0.4551932,
    "CMYK_C": 1,
    "CMYK_M": 0.08290509,
    "CMYK_Y": 0,
    "CMYK_K": 0.4551932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07019",
    "Farbtonhilfsbezeichnung": "P9.52.32",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "126",
    "Y": 13,
    "L": 42.3048176090539,
    "a": -27.9461977430855,
    "b": -17.2168667751877,
    "C": 32.8239313588454,
    "h": 0.55215332268541,
    "CMY_C": 1,
    "CMY_M": 0.5565466,
    "CMY_Y": 0.5041463,
    "CMYK_C": 1,
    "CMYK_M": 0.105677,
    "CMYK_Y": 0,
    "CMYK_K": 0.5041463
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07020",
    "Farbtonhilfsbezeichnung": "P8.50.31",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "105",
    "Bcolor": "116",
    "Y": 11,
    "L": 39.1993860915114,
    "a": -28.9540346290664,
    "b": -15.4684785635466,
    "C": 32.8269698627832,
    "h": 0.49066496078013,
    "CMY_C": 1,
    "CMY_M": 0.5863973,
    "CMY_Y": 0.5460218,
    "CMYK_C": 1,
    "CMYK_M": 0.08893716,
    "CMYK_Y": 0,
    "CMYK_K": 0.5460218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07021",
    "Farbtonhilfsbezeichnung": "P7.53.28",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "109",
    "Y": 10,
    "L": 37.1083021831868,
    "a": -27.6965852917648,
    "b": -14.4570013471105,
    "C": 31.2426907415856,
    "h": 0.48107482671381,
    "CMY_C": 1,
    "CMY_M": 0.6088087,
    "CMY_Y": 0.5726728,
    "CMYK_C": 1,
    "CMYK_M": 0.08456246,
    "CMYK_Y": 0,
    "CMYK_K": 0.5726728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07022",
    "Farbtonhilfsbezeichnung": "P7.46.21",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "84",
    "Bcolor": "90",
    "Y": 7,
    "L": 31.7022295439047,
    "a": -19.6053163896139,
    "b": -10.6393802233459,
    "C": 22.306161531599,
    "h": 0.49720458863401,
    "CMY_C": 1,
    "CMY_M": 0.6724784,
    "CMY_Y": 0.6472171,
    "CMYK_C": 1,
    "CMYK_M": 0.07160586,
    "CMYK_Y": 0,
    "CMYK_K": 0.6472171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07023",
    "Farbtonhilfsbezeichnung": "P8.28.63",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "189",
    "Bcolor": "199",
    "Y": 43,
    "L": 71.4671746200474,
    "a": -25.8613400882201,
    "b": -14.2903466289115,
    "C": 29.5469612300998,
    "h": 0.50481852106242,
    "CMY_C": 0.6436127,
    "CMY_M": 0.2574371,
    "CMY_Y": 0.2210144,
    "CMYK_C": 0.5424983,
    "CMYK_M": 0.04675661,
    "CMYK_Y": 0,
    "CMYK_K": 0.2210144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07024",
    "Farbtonhilfsbezeichnung": "P8.32.63",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "189",
    "Bcolor": "200",
    "Y": 42,
    "L": 70.826911931385,
    "a": -28.6450650361878,
    "b": -16.317921737494,
    "C": 32.9668670146013,
    "h": 0.51781118220808,
    "CMY_C": 0.7193931,
    "CMY_M": 0.2589154,
    "CMY_Y": 0.2138356,
    "CMYK_C": 0.6430683,
    "CMYK_M": 0.05734136,
    "CMYK_Y": 0,
    "CMYK_K": 0.2138356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07025",
    "Farbtonhilfsbezeichnung": "P7.32.62",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "188",
    "Bcolor": "197",
    "Y": 42,
    "L": 70.7578500910343,
    "a": -28.1241902229791,
    "b": -14.5810446918078,
    "C": 31.6792825045456,
    "h": 0.47830006284336,
    "CMY_C": 0.6912346,
    "CMY_M": 0.2610776,
    "CMY_Y": 0.2268189,
    "CMYK_C": 0.6006559,
    "CMYK_M": 0.04430873,
    "CMYK_Y": 0,
    "CMYK_K": 0.2268189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07026",
    "Farbtonhilfsbezeichnung": "P9.37.53",
    "Farbtonklasse": "03",
    "Rcolor": "19",
    "Gcolor": "162",
    "Bcolor": "174",
    "Y": 29,
    "L": 60.7449942479308,
    "a": -29.2557064049582,
    "b": -16.8945019767312,
    "C": 33.7834360936671,
    "h": 0.52369393150998,
    "CMY_C": 0.924795,
    "CMY_M": 0.3655818,
    "CMY_Y": 0.3174694,
    "CMYK_C": 0.8898145,
    "CMYK_M": 0.07049125,
    "CMYK_Y": 0,
    "CMYK_K": 0.3174694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07027",
    "Farbtonhilfsbezeichnung": "P6.43.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "147",
    "Y": 19,
    "L": 50.8965905080753,
    "a": -31.1485768663439,
    "b": -16.4053342467587,
    "C": 35.2046706069863,
    "h": 0.48476313710386,
    "CMY_C": 1,
    "CMY_M": 0.4654039,
    "CMY_Y": 0.4230981,
    "CMYK_C": 1,
    "CMYK_M": 0.07333282,
    "CMYK_Y": 0,
    "CMYK_K": 0.4230981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07028",
    "Farbtonhilfsbezeichnung": "P8.48.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "138",
    "Bcolor": "150",
    "Y": 19,
    "L": 51.2039269553961,
    "a": -32.5379013745835,
    "b": -17.4804137795837,
    "C": 36.9361596781201,
    "h": 0.49298799039681,
    "CMY_C": 1,
    "CMY_M": 0.4599324,
    "CMY_Y": 0.4129016,
    "CMYK_C": 1,
    "CMYK_M": 0.08010714,
    "CMYK_Y": 0,
    "CMYK_K": 0.4129016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07029",
    "Farbtonhilfsbezeichnung": "P8.42.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "137",
    "Y": 17,
    "L": 47.8859230458458,
    "a": -26.4239588240744,
    "b": -15.0691538367035,
    "C": 30.4188263628072,
    "h": 0.51828265538801,
    "CMY_C": 1,
    "CMY_M": 0.5034066,
    "CMY_Y": 0.4621205,
    "CMYK_C": 1,
    "CMYK_M": 0.07675721,
    "CMYK_Y": 0,
    "CMYK_K": 0.4621205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07030",
    "Farbtonhilfsbezeichnung": "P8.48.34",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "124",
    "Y": 13,
    "L": 42.2729280167266,
    "a": -28.8617941738224,
    "b": -15.764374552642,
    "C": 32.8864511306416,
    "h": 0.49992273382269,
    "CMY_C": 1,
    "CMY_M": 0.5560225,
    "CMY_Y": 0.5138732,
    "CMYK_C": 1,
    "CMYK_M": 0.08670445,
    "CMYK_Y": 0,
    "CMYK_K": 0.5138732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07031",
    "Farbtonhilfsbezeichnung": "P6.44.30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "108",
    "Y": 10,
    "L": 37.6240484448813,
    "a": -25.1521169986241,
    "b": -12.9110434418906,
    "C": 28.2723191880479,
    "h": 0.47424543961665,
    "CMY_C": 1,
    "CMY_M": 0.6076167,
    "CMY_Y": 0.5772343,
    "CMYK_C": 1,
    "CMYK_M": 0.07186574,
    "CMYK_Y": 0,
    "CMYK_K": 0.5772343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07032",
    "Farbtonhilfsbezeichnung": "P6.38.25",
    "Farbtonklasse": "03",
    "Rcolor": "4",
    "Gcolor": "89",
    "Bcolor": "94",
    "Y": 8,
    "L": 33.8082806968826,
    "a": -19.8998189084233,
    "b": -9.85835368216784,
    "C": 22.2078799058072,
    "h": 0.45996017202188,
    "CMY_C": 0.9832559,
    "CMY_M": 0.6523863,
    "CMY_Y": 0.6322612,
    "CMYK_C": 0.9544674,
    "CMYK_M": 0.05472652,
    "CMYK_Y": 0,
    "CMYK_K": 0.6322612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07033",
    "Farbtonhilfsbezeichnung": "P8.41.20",
    "Farbtonklasse": "03",
    "Rcolor": "17",
    "Gcolor": "78",
    "Bcolor": "84",
    "Y": 6,
    "L": 29.8631941980519,
    "a": -16.2816980646237,
    "b": -9.26962805147891,
    "C": 18.7355196373182,
    "h": 0.51756124125162,
    "CMY_C": 0.9332834,
    "CMY_M": 0.6946784,
    "CMY_Y": 0.6723789,
    "CMYK_C": 0.7963605,
    "CMYK_M": 0.06806509,
    "CMYK_Y": 0,
    "CMYK_K": 0.6723789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07035",
    "Farbtonhilfsbezeichnung": "P8.25.68",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "201",
    "Bcolor": "209",
    "Y": 50,
    "L": 76.2485501215222,
    "a": -23.4904683789754,
    "b": -12.8189740627674,
    "C": 26.76057175558,
    "h": 0.49954326998757,
    "CMY_C": 0.5451776,
    "CMY_M": 0.2101387,
    "CMY_Y": 0.1794268,
    "CMYK_C": 0.4457259,
    "CMYK_M": 0.0374274,
    "CMYK_Y": 0,
    "CMYK_K": 0.1794268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07036",
    "Farbtonhilfsbezeichnung": "P2.28.63",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "190",
    "Bcolor": "190",
    "Y": 43,
    "L": 71.4049132841608,
    "a": -27.6264287619951,
    "b": -9.70027865453815,
    "C": 29.2799414636928,
    "h": 0.33767504668699,
    "CMY_C": 0.63077,
    "CMY_M": 0.2563319,
    "CMY_Y": 0.2543516,
    "CMYK_C": 0.5048202,
    "CMYK_M": 0.002655791,
    "CMYK_Y": 0,
    "CMYK_K": 0.2543516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07037",
    "Farbtonhilfsbezeichnung": "P8.31.54",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "162",
    "Bcolor": "172",
    "Y": 30,
    "L": 61.4224699304582,
    "a": -25.385651534064,
    "b": -14.5430629316965,
    "C": 29.2563152711378,
    "h": 0.52024346572324,
    "CMY_C": 0.7611994,
    "CMY_M": 0.3654611,
    "CMY_Y": 0.3261728,
    "CMYK_C": 0.6456056,
    "CMYK_M": 0.05830619,
    "CMYK_Y": 0,
    "CMYK_K": 0.3261728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07038",
    "Farbtonhilfsbezeichnung": "P6.35.49",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "150",
    "Bcolor": "157",
    "Y": 25,
    "L": 56.7940643453352,
    "a": -27.1867730791786,
    "b": -13.2803479076196,
    "C": 30.2570367188554,
    "h": 0.45439375301298,
    "CMY_C": 0.8489532,
    "CMY_M": 0.4113394,
    "CMY_Y": 0.383174,
    "CMYK_C": 0.7551225,
    "CMYK_M": 0.0456618,
    "CMYK_Y": 0,
    "CMYK_K": 0.383174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07039",
    "Farbtonhilfsbezeichnung": "P8.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "153",
    "Bcolor": "162",
    "Y": 27,
    "L": 58.7286404401237,
    "a": -22.7420295227608,
    "b": -12.8924904932042,
    "C": 26.1422305462155,
    "h": 0.51572673876866,
    "CMY_C": 0.732802,
    "CMY_M": 0.3985934,
    "CMY_Y": 0.365373,
    "CMYK_C": 0.5789684,
    "CMYK_M": 0.05234629,
    "CMYK_Y": 0,
    "CMYK_K": 0.365373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07040",
    "Farbtonhilfsbezeichnung": "P8.41.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "138",
    "Bcolor": "150",
    "Y": 20,
    "L": 51.920952802476,
    "a": -28.7533877682519,
    "b": -16.2707442989833,
    "C": 33.0377727486941,
    "h": 0.51494747969396,
    "CMY_C": 1,
    "CMY_M": 0.4584521,
    "CMY_Y": 0.413334,
    "CMYK_C": 1,
    "CMYK_M": 0.07690598,
    "CMYK_Y": 0,
    "CMYK_K": 0.413334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07041",
    "Farbtonhilfsbezeichnung": "P9.36.43",
    "Farbtonklasse": "03",
    "Rcolor": "24",
    "Gcolor": "134",
    "Bcolor": "145",
    "Y": 19,
    "L": 51.1403827337094,
    "a": -24.6285361650662,
    "b": -14.8389237604828,
    "C": 28.7534076589784,
    "h": 0.54226258131036,
    "CMY_C": 0.9055014,
    "CMY_M": 0.4731744,
    "CMY_Y": 0.430513,
    "CMYK_C": 0.8340637,
    "CMYK_M": 0.074912,
    "CMYK_Y": 0,
    "CMYK_K": 0.430513
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07042",
    "Farbtonhilfsbezeichnung": "P7.38.32",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "101",
    "Bcolor": "109",
    "Y": 10,
    "L": 38.4352632238097,
    "a": -22.4011631146475,
    "b": -12.4900248453234,
    "C": 25.6478620848959,
    "h": 0.50863000030786,
    "CMY_C": 1,
    "CMY_M": 0.6037015,
    "CMY_Y": 0.5718439,
    "CMYK_C": 1,
    "CMYK_M": 0.0744066,
    "CMYK_Y": 0,
    "CMYK_K": 0.5718439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07043",
    "Farbtonhilfsbezeichnung": "P6.34.30",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "99",
    "Bcolor": "104",
    "Y": 10,
    "L": 38.2199354449089,
    "a": -19.4830442422372,
    "b": -9.75252530313202,
    "C": 21.787628662459,
    "h": 0.46409931238108,
    "CMY_C": 0.8933556,
    "CMY_M": 0.6107904,
    "CMY_Y": 0.5909401,
    "CMYK_C": 0.739294,
    "CMYK_M": 0.04852685,
    "CMYK_Y": 0,
    "CMYK_K": 0.5909401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07044",
    "Farbtonhilfsbezeichnung": "P6.35.25",
    "Farbtonklasse": "03",
    "Rcolor": "26",
    "Gcolor": "88",
    "Bcolor": "92",
    "Y": 8,
    "L": 33.8980107293001,
    "a": -17.4925273510072,
    "b": -8.79360526311499,
    "C": 19.5784577188607,
    "h": 0.46581037569283,
    "CMY_C": 0.8987064,
    "CMY_M": 0.6552897,
    "CMY_Y": 0.637792,
    "CMYK_C": 0.7203441,
    "CMYK_M": 0.04830841,
    "CMYK_Y": 0,
    "CMYK_K": 0.637792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07045",
    "Farbtonhilfsbezeichnung": "P9.37.24",
    "Farbtonklasse": "03",
    "Rcolor": "16",
    "Gcolor": "86",
    "Bcolor": "94",
    "Y": 8,
    "L": 33.19882209731,
    "a": -17.6335138996709,
    "b": -10.7388445819418,
    "C": 20.6461520726015,
    "h": 0.54701231186375,
    "CMY_C": 0.9388564,
    "CMY_M": 0.6611732,
    "CMY_Y": 0.6324105,
    "CMYK_C": 0.8336633,
    "CMYK_M": 0.07824664,
    "CMYK_Y": 0,
    "CMYK_K": 0.6324105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07046",
    "Farbtonhilfsbezeichnung": "P7.16.73",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "210",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.7146145447275,
    "a": -17.0337582533848,
    "b": -9.15112011336339,
    "C": 19.3362850507526,
    "h": 0.49298953227935,
    "CMY_C": 0.4019337,
    "CMY_M": 0.1746676,
    "CMY_Y": 0.1563954,
    "CMYK_C": 0.2910585,
    "CMYK_M": 0.02165974,
    "CMYK_Y": 0,
    "CMYK_K": 0.1563954
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07047",
    "Farbtonhilfsbezeichnung": "P7.20.72",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "208",
    "Bcolor": "213",
    "Y": 55,
    "L": 79.2839358338293,
    "a": -20.8078008246412,
    "b": -10.4457195990225,
    "C": 23.2825607075197,
    "h": 0.46525414336149,
    "CMY_C": 0.4647023,
    "CMY_M": 0.1826223,
    "CMY_Y": 0.1630983,
    "CMYK_C": 0.3603816,
    "CMYK_M": 0.02332884,
    "CMYK_Y": 0,
    "CMYK_K": 0.1630983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07048",
    "Farbtonhilfsbezeichnung": "P8.23.63",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "186",
    "Bcolor": "194",
    "Y": 43,
    "L": 71.2774561271093,
    "a": -20.6278264586858,
    "b": -11.7447818800646,
    "C": 23.7370412187356,
    "h": 0.51758982880726,
    "CMY_C": 0.5574057,
    "CMY_M": 0.2697098,
    "CMY_Y": 0.2405528,
    "CMYK_C": 0.4172153,
    "CMYK_M": 0.03839248,
    "CMYK_Y": 0,
    "CMYK_K": 0.2405528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07049",
    "Farbtonhilfsbezeichnung": "P9.28.59",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "175",
    "Bcolor": "185",
    "Y": 36,
    "L": 66.8129448499414,
    "a": -23.4566320990073,
    "b": -13.7106770210723,
    "C": 27.169767275491,
    "h": 0.52895322885897,
    "CMY_C": 0.657513,
    "CMY_M": 0.3118785,
    "CMY_Y": 0.2747525,
    "CMYK_C": 0.5277654,
    "CMYK_M": 0.0511908,
    "CMYK_Y": 0,
    "CMYK_K": 0.2747525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07050",
    "Farbtonhilfsbezeichnung": "P6.25.59",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "175",
    "Bcolor": "180",
    "Y": 36,
    "L": 66.6906415369629,
    "a": -22.9233718473966,
    "b": -11.0170752660104,
    "C": 25.4333820847907,
    "h": 0.44801114878346,
    "CMY_C": 0.6303251,
    "CMY_M": 0.3149042,
    "CMY_Y": 0.294805,
    "CMYK_C": 0.4757834,
    "CMYK_M": 0.0285015,
    "CMYK_Y": 0,
    "CMYK_K": 0.294805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07051",
    "Farbtonhilfsbezeichnung": "P9.28.58",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "174",
    "Bcolor": "183",
    "Y": 36,
    "L": 66.193218852008,
    "a": -23.2707357977752,
    "b": -13.5811642092915,
    "C": 26.9439263257899,
    "h": 0.52828501842537,
    "CMY_C": 0.6608543,
    "CMY_M": 0.3188494,
    "CMY_Y": 0.2822309,
    "CMYK_C": 0.5275002,
    "CMYK_M": 0.05101712,
    "CMYK_Y": 0,
    "CMYK_K": 0.2822309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07052",
    "Farbtonhilfsbezeichnung": "P6.30.44",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "135",
    "Bcolor": "140",
    "Y": 20,
    "L": 51.8602636833864,
    "a": -22.3867565582906,
    "b": -10.8358250905748,
    "C": 24.8713082605981,
    "h": 0.45078885207174,
    "CMY_C": 0.7880777,
    "CMY_M": 0.4705293,
    "CMY_Y": 0.4496208,
    "CMYK_C": 0.6149521,
    "CMYK_M": 0.03798931,
    "CMYK_Y": 0,
    "CMYK_K": 0.4496208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07053",
    "Farbtonhilfsbezeichnung": "P6.39.35",
    "Farbtonklasse": "03",
    "Rcolor": "7",
    "Gcolor": "114",
    "Bcolor": "120",
    "Y": 13,
    "L": 43.2864955024966,
    "a": -23.6991154170508,
    "b": -11.7300284253358,
    "C": 26.4431775399607,
    "h": 0.45960458005297,
    "CMY_C": 0.9722567,
    "CMY_M": 0.5544224,
    "CMY_Y": 0.5294475,
    "CMYK_C": 0.941041,
    "CMYK_M": 0.05307584,
    "CMYK_Y": 0,
    "CMYK_K": 0.5294475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07054",
    "Farbtonhilfsbezeichnung": "P8.33.33",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "108",
    "Bcolor": "116",
    "Y": 12,
    "L": 41.5060184549688,
    "a": -19.481339231212,
    "b": -11.6846003181418,
    "C": 22.7167881276443,
    "h": 0.54026084087243,
    "CMY_C": 0.8742967,
    "CMY_M": 0.5783291,
    "CMY_Y": 0.5468617,
    "CMYK_C": 0.7225938,
    "CMYK_M": 0.06944332,
    "CMYK_Y": 0,
    "CMYK_K": 0.5468617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07055",
    "Farbtonhilfsbezeichnung": "P8.31.29",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "101",
    "Bcolor": "106",
    "Y": 11,
    "L": 39.4734932870134,
    "a": -15.3347055587255,
    "b": -9.0285514737509,
    "C": 17.7951660932675,
    "h": 0.5321181672906,
    "CMY_C": 0.8081832,
    "CMY_M": 0.6053019,
    "CMY_Y": 0.5831092,
    "CMYK_C": 0.5398871,
    "CMYK_M": 0.05323367,
    "CMYK_Y": 0,
    "CMYK_K": 0.5831092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07056",
    "Farbtonhilfsbezeichnung": "P8.31.25",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "90",
    "Bcolor": "95",
    "Y": 9,
    "L": 35.0802392342472,
    "a": -14.4934132382821,
    "b": -8.65221423772444,
    "C": 16.8795686707656,
    "h": 0.53819271806119,
    "CMY_C": 0.8395143,
    "CMY_M": 0.6486976,
    "CMY_Y": 0.6272867,
    "CMYK_C": 0.5694126,
    "CMYK_M": 0.05744602,
    "CMYK_Y": 0,
    "CMYK_K": 0.6272867
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07057",
    "Farbtonhilfsbezeichnung": "P7.33.19",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "78",
    "Bcolor": "81",
    "Y": 6,
    "L": 30.4901954043492,
    "a": -12.524893228584,
    "b": -6.30317730340603,
    "C": 14.021518979968,
    "h": 0.4662458065921,
    "CMY_C": 0.8449354,
    "CMY_M": 0.6952274,
    "CMY_Y": 0.6842204,
    "CMYK_C": 0.5089467,
    "CMYK_M": 0.03485641,
    "CMYK_Y": 0,
    "CMYK_K": 0.6842204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07058",
    "Farbtonhilfsbezeichnung": "P6.08.81",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "228",
    "Bcolor": "229",
    "Y": 73,
    "L": 88.4512852121363,
    "a": -10.0005162439193,
    "b": -4.98086299922511,
    "C": 11.1722567712143,
    "h": 0.46209487596999,
    "CMY_C": 0.232173,
    "CMY_M": 0.1048932,
    "CMY_Y": 0.1008231,
    "CMYK_C": 0.1460779,
    "CMYK_M": 0.004526451,
    "CMYK_Y": 0,
    "CMYK_K": 0.1008231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07059",
    "Farbtonhilfsbezeichnung": "P9.18.63",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "184",
    "Bcolor": "190",
    "Y": 42,
    "L": 71.1487612658901,
    "a": -16.8138190890623,
    "b": -9.96915187823868,
    "C": 19.5470842206992,
    "h": 0.53519305284468,
    "CMY_C": 0.5058414,
    "CMY_M": 0.2788014,
    "CMY_Y": 0.254081,
    "CMYK_C": 0.337517,
    "CMYK_M": 0.03314081,
    "CMYK_Y": 0,
    "CMYK_K": 0.254081
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07060",
    "Farbtonhilfsbezeichnung": "P6.20.61",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "179",
    "Bcolor": "184",
    "Y": 40,
    "L": 69.2204592383169,
    "a": -17.8476132131036,
    "b": -9.24481705867881,
    "C": 20.0998492495091,
    "h": 0.4779328028317,
    "CMY_C": 0.5328473,
    "CMY_M": 0.2976896,
    "CMY_Y": 0.2798554,
    "CMYK_C": 0.3513071,
    "CMYK_M": 0.02476485,
    "CMYK_Y": 0,
    "CMYK_K": 0.2798554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07061",
    "Farbtonhilfsbezeichnung": "P9.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "179",
    "Bcolor": "185",
    "Y": 40,
    "L": 69.1608544889894,
    "a": -17.6688365766216,
    "b": -10.1448775826696,
    "C": 20.3741583173076,
    "h": 0.52120865822305,
    "CMY_C": 0.536807,
    "CMY_M": 0.298405,
    "CMY_Y": 0.2741516,
    "CMYK_C": 0.3618599,
    "CMYK_M": 0.03341392,
    "CMYK_Y": 0,
    "CMYK_K": 0.2741516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07062",
    "Farbtonhilfsbezeichnung": "P8.26.54",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "161",
    "Bcolor": "169",
    "Y": 30,
    "L": 61.9555567711622,
    "a": -21.4212169990741,
    "b": -12.3096186521282,
    "C": 24.7061783585047,
    "h": 0.52156826850653,
    "CMY_C": 0.672638,
    "CMY_M": 0.3672782,
    "CMY_Y": 0.3355777,
    "CMYK_C": 0.5072984,
    "CMYK_M": 0.04771134,
    "CMYK_Y": 0,
    "CMYK_K": 0.3355777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07063",
    "Farbtonhilfsbezeichnung": "P8.21.54",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "158",
    "Bcolor": "164",
    "Y": 30,
    "L": 61.528072490826,
    "a": -16.6751732139993,
    "b": -9.77893337440372,
    "C": 19.3310356592166,
    "h": 0.53038677843256,
    "CMY_C": 0.6036224,
    "CMY_M": 0.3809617,
    "CMY_Y": 0.3569638,
    "CMYK_C": 0.3835843,
    "CMYK_M": 0.03731966,
    "CMYK_Y": 0,
    "CMYK_K": 0.3569638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07064",
    "Farbtonhilfsbezeichnung": "P6.25.40",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 16,
    "L": 47.4550156365077,
    "a": -17.2611442816434,
    "b": -8.97140660418523,
    "C": 19.4533605932068,
    "h": 0.47931914755093,
    "CMY_C": 0.7496198,
    "CMY_M": 0.523852,
    "CMY_Y": 0.5055994,
    "CMYK_C": 0.4935682,
    "CMYK_M": 0.03691864,
    "CMYK_Y": 0,
    "CMYK_K": 0.5055994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07065",
    "Farbtonhilfsbezeichnung": "P9.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "121",
    "Bcolor": "130",
    "Y": 16,
    "L": 46.8429119746805,
    "a": -20.6029639310518,
    "b": -12.3057064321134,
    "C": 23.998177712851,
    "h": 0.5384159601242,
    "CMY_C": 0.8342308,
    "CMY_M": 0.5236184,
    "CMY_Y": 0.4902131,
    "CMYK_C": 0.6748266,
    "CMYK_M": 0.06552797,
    "CMYK_Y": 0,
    "CMYK_K": 0.4902131
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07066",
    "Farbtonhilfsbezeichnung": "P9.26.35",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "111",
    "Bcolor": "118",
    "Y": 14,
    "L": 43.6798482339144,
    "a": -15.1926832277052,
    "b": -9.93656914886503,
    "C": 18.1535955145963,
    "h": 0.57920758876402,
    "CMY_C": 0.7702186,
    "CMY_M": 0.5643674,
    "CMY_Y": 0.5364136,
    "CMYK_C": 0.5043395,
    "CMYK_M": 0.06029886,
    "CMYK_Y": 0,
    "CMYK_K": 0.5364136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07067",
    "Farbtonhilfsbezeichnung": "P6.25.30",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "96",
    "Bcolor": "101",
    "Y": 10,
    "L": 37.9164010395425,
    "a": -14.173828379708,
    "b": -7.77750790176145,
    "C": 16.1674685742505,
    "h": 0.50186238320446,
    "CMY_C": 0.8012592,
    "CMY_M": 0.622454,
    "CMY_Y": 0.6058013,
    "CMYK_C": 0.495836,
    "CMYK_M": 0.0422444,
    "CMYK_Y": 0,
    "CMYK_K": 0.6058013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07068",
    "Farbtonhilfsbezeichnung": "P9.19.21",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "79",
    "Bcolor": "80",
    "Y": 7,
    "L": 31.7163931867523,
    "a": -8.27364091884447,
    "b": -4.28622079232261,
    "C": 9.31798383420557,
    "h": 0.47798894111711,
    "CMY_C": 0.7828429,
    "CMY_M": 0.6912622,
    "CMY_Y": 0.684808,
    "CMYK_C": 0.3110321,
    "CMYK_M": 0.02047695,
    "CMYK_Y": 0,
    "CMYK_K": 0.684808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07069",
    "Farbtonhilfsbezeichnung": "P4.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "231",
    "Bcolor": "230",
    "Y": 75,
    "L": 89.3555341439151,
    "a": -10.0719582674543,
    "b": -3.91135871722865,
    "C": 10.8047707220552,
    "h": 0.37041566370755,
    "CMY_C": 0.2184025,
    "CMY_M": 0.09495676,
    "CMY_Y": 0.098703,
    "CMYK_C": 0.1363977,
    "CMYK_M": 0,
    "CMYK_Y": 0.004139291,
    "CMYK_K": 0.09495676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07070",
    "Farbtonhilfsbezeichnung": "P7.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "226",
    "Bcolor": "226",
    "Y": 71,
    "L": 87.3093643188477,
    "a": -10.9365978240967,
    "b": -4.87963438034058,
    "C": 11.97580909729,
    "h": 204.045227050781,
    "CMY_C": 0.25251245498657,
    "CMY_M": 0.11559665203094,
    "CMY_Y": 0.11431753635406,
    "CMYK_C": 0.15603213012218,
    "CMYK_M": 0.00144421472214,
    "CMYK_Y": 0,
    "CMYK_K": 0.11431753635406
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07071",
    "Farbtonhilfsbezeichnung": "P7.10.76",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "215",
    "Bcolor": "214",
    "Y": 63,
    "L": 83.6175246838706,
    "a": -10.9264430719307,
    "b": -4.31889999579305,
    "C": 11.7490448708737,
    "h": 0.37642253539009,
    "CMY_C": 0.2899396,
    "CMY_M": 0.156687,
    "CMY_Y": 0.1590099,
    "CMYK_C": 0.1580108,
    "CMYK_M": 0,
    "CMYK_Y": 0.002754523,
    "CMYK_K": 0.156687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07073",
    "Farbtonhilfsbezeichnung": "P8.13.63",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "180",
    "Bcolor": "183",
    "Y": 42,
    "L": 70.5819395202289,
    "a": -12.6420184243672,
    "b": -6.70705425639995,
    "C": 14.3110169673693,
    "h": 0.48777745910022,
    "CMY_C": 0.4540489,
    "CMY_M": 0.2939542,
    "CMY_Y": 0.2826662,
    "CMYK_C": 0.2389163,
    "CMYK_M": 0.01573598,
    "CMYK_Y": 0,
    "CMYK_K": 0.2826662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07074",
    "Farbtonhilfsbezeichnung": "P7.13.58",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "168",
    "Bcolor": "170",
    "Y": 36,
    "L": 66.1527481730169,
    "a": -12.1234107664444,
    "b": -6.26895931369631,
    "C": 13.6483310147695,
    "h": 0.47723016723304,
    "CMY_C": 0.4929575,
    "CMY_M": 0.3420789,
    "CMY_Y": 0.3324074,
    "CMYK_C": 0.2404911,
    "CMYK_M": 0.01448718,
    "CMYK_Y": 0,
    "CMYK_K": 0.3324074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07075",
    "Farbtonhilfsbezeichnung": "P7.24.45",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "136",
    "Bcolor": "141",
    "Y": 21,
    "L": 53.069938224847,
    "a": -17.0694816155664,
    "b": -9.41005957257135,
    "C": 19.4914448870139,
    "h": 0.50382521420348,
    "CMY_C": 0.6926893,
    "CMY_M": 0.4675147,
    "CMY_Y": 0.4463808,
    "CMYK_C": 0.444906,
    "CMYK_M": 0.03817401,
    "CMYK_Y": 0,
    "CMYK_K": 0.4463808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07076",
    "Farbtonhilfsbezeichnung": "P8.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "120",
    "Bcolor": "125",
    "Y": 16,
    "L": 47.6105624520526,
    "a": -12.7950700021585,
    "b": -7.84713067127152,
    "C": 15.0097060641489,
    "h": 0.55013668766462,
    "CMY_C": 0.6926405,
    "CMY_M": 0.530253,
    "CMY_Y": 0.5109792,
    "CMYK_C": 0.3714798,
    "CMYK_M": 0.0394131,
    "CMYK_Y": 0,
    "CMYK_K": 0.5109792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07077",
    "Farbtonhilfsbezeichnung": "P6.15.29",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "94",
    "Bcolor": "97",
    "Y": 10,
    "L": 38.2608367386191,
    "a": -8.41759330387465,
    "b": -5.05845692854622,
    "C": 9.82058366531198,
    "h": 0.54110937841424,
    "CMY_C": 0.7277281,
    "CMY_M": 0.6295501,
    "CMY_Y": 0.6190373,
    "CMYK_C": 0.2853056,
    "CMYK_M": 0.02759543,
    "CMYK_Y": 0,
    "CMYK_K": 0.6190373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07078",
    "Farbtonhilfsbezeichnung": "P6.19.25",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "84",
    "Bcolor": "87",
    "Y": 8,
    "L": 33.4946836486661,
    "a": -10.0884538270213,
    "b": -5.7968662318986,
    "C": 11.6353151538953,
    "h": 0.52153664741063,
    "CMY_C": 0.7898548,
    "CMY_M": 0.671384,
    "CMY_Y": 0.6593459,
    "CMYK_C": 0.3831127,
    "CMYK_M": 0.03533829,
    "CMYK_Y": 0,
    "CMYK_K": 0.6593459
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07079",
    "Farbtonhilfsbezeichnung": "P9.26.15",
    "Farbtonklasse": "03",
    "Rcolor": "42",
    "Gcolor": "70",
    "Bcolor": "73",
    "Y": 5,
    "L": 27.7612775758728,
    "a": -9.28414952014395,
    "b": -5.76489941376938,
    "C": 10.928380372373,
    "h": 0.55567440576333,
    "CMY_C": 0.8342356,
    "CMY_M": 0.725364,
    "CMY_Y": 0.7120112,
    "CMYK_C": 0.4244069,
    "CMYK_M": 0.04636602,
    "CMYK_Y": 0,
    "CMYK_K": 0.7120112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07080",
    "Farbtonhilfsbezeichnung": "Z0.38.28",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "60",
    "Bcolor": "102",
    "Y": 10,
    "L": 37.379296016986,
    "a": 39.3755423335759,
    "b": -8.64263946510029,
    "C": 40.3128831887144,
    "h": -0.21606626098089,
    "CMY_C": 0.4503953,
    "CMY_M": 0.766135,
    "CMY_Y": 0.5997306,
    "CMYK_C": 0,
    "CMYK_M": 0.5744851,
    "CMYK_Y": 0.271714,
    "CMYK_K": 0.4503953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07081",
    "Farbtonhilfsbezeichnung": "Z0.34.30",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "66",
    "Bcolor": "106",
    "Y": 11,
    "L": 38.9945278129941,
    "a": 37.0162273991357,
    "b": -8.50659989985899,
    "C": 37.9810917789471,
    "h": -0.22588537800077,
    "CMY_C": 0.4451328,
    "CMY_M": 0.7406042,
    "CMY_Y": 0.5853739,
    "CMYK_C": 0,
    "CMYK_M": 0.5325084,
    "CMYK_Y": 0.2527472,
    "CMYK_K": 0.4451328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07083",
    "Farbtonhilfsbezeichnung": "P7.18.14",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "63",
    "Bcolor": "65",
    "Y": 5,
    "L": 25.4866440692113,
    "a": -6.2663355537331,
    "b": -3.57838924445132,
    "C": 7.21608140591446,
    "h": 0.51886048170136,
    "CMY_C": 0.8184991,
    "CMY_M": 0.7511714,
    "CMY_Y": 0.7449859,
    "CMYK_C": 0.2882709,
    "CMYK_M": 0.02425516,
    "CMYK_Y": 0,
    "CMYK_K": 0.7449859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07084",
    "Farbtonhilfsbezeichnung": "P7.10.34",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "105",
    "Bcolor": "107",
    "Y": 13,
    "L": 43.2226327895666,
    "a": -6.21723357905687,
    "b": -3.74144786030759,
    "C": 7.25619910614039,
    "h": 0.54173214175213,
    "CMY_C": 0.6579196,
    "CMY_M": 0.5862828,
    "CMY_Y": 0.579733,
    "CMYK_C": 0.1860403,
    "CMYK_M": 0.0155848,
    "CMYK_Y": 0,
    "CMYK_K": 0.579733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07085",
    "Farbtonhilfsbezeichnung": "P9.17.41",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "122",
    "Bcolor": "125",
    "Y": 17,
    "L": 48.6324391255333,
    "a": -11.5042214778218,
    "b": -6.52321708561323,
    "C": 13.2249564444202,
    "h": 0.5158225636126,
    "CMY_C": 0.6635023,
    "CMY_M": 0.5227555,
    "CMY_Y": 0.5093839,
    "CMYK_C": 0.3141324,
    "CMYK_M": 0.0272548,
    "CMYK_Y": 0,
    "CMYK_K": 0.5093839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07086",
    "Farbtonhilfsbezeichnung": "P7.15.48",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "140",
    "Bcolor": "144",
    "Y": 24,
    "L": 55.8907162703179,
    "a": -11.6118219350603,
    "b": -6.50843429967922,
    "C": 13.3114283863449,
    "h": 0.51086940529506,
    "CMY_C": 0.5930721,
    "CMY_M": 0.4494314,
    "CMY_Y": 0.4366481,
    "CMYK_C": 0.2776665,
    "CMYK_M": 0.02269142,
    "CMYK_Y": 0,
    "CMYK_K": 0.4366481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07087",
    "Farbtonhilfsbezeichnung": "P9.10.53",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "151",
    "Bcolor": "154",
    "Y": 29,
    "L": 60.5086848088434,
    "a": -8.15401694049889,
    "b": -5.54108437628029,
    "C": 9.8585804419805,
    "h": 0.59687073986413,
    "CMY_C": 0.5120914,
    "CMY_M": 0.4089976,
    "CMY_Y": 0.3956023,
    "CMYK_C": 0.192736,
    "CMYK_M": 0.02216312,
    "CMYK_Y": 0,
    "CMYK_K": 0.3956023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07091",
    "Farbtonhilfsbezeichnung": "P7.09.77",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "217",
    "Bcolor": "218",
    "Y": 65,
    "L": 84.5502640348658,
    "a": -10.1142449702987,
    "b": -5.04649460304092,
    "C": 11.303320711089,
    "h": 0.46280662889381,
    "CMY_C": 0.2757874,
    "CMY_M": 0.1479191,
    "CMY_Y": 0.1433811,
    "CMYK_C": 0.1545686,
    "CMYK_M": 0.005297583,
    "CMYK_Y": 0,
    "CMYK_K": 0.1433811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07092",
    "Farbtonhilfsbezeichnung": "P6.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 79,
    "L": 91.3869823596751,
    "a": -6.43088755705468,
    "b": -2.81357186688111,
    "C": 7.01943740064583,
    "h": 0.41241808477219,
    "CMY_C": 0.1600918,
    "CMY_M": 0.08063436,
    "CMY_Y": 0.0838107,
    "CMYK_C": 0.08642633,
    "CMYK_M": 0,
    "CMYK_Y": 0.003454935,
    "CMYK_K": 0.08063436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07093",
    "Farbtonhilfsbezeichnung": "P5.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "229",
    "Bcolor": "227",
    "Y": 76,
    "L": 89.7405463567683,
    "a": -5.62652726710988,
    "b": -1.85145709511871,
    "C": 5.92331853462199,
    "h": 0.31789835883851,
    "CMY_C": 0.1677203,
    "CMY_M": 0.1011286,
    "CMY_Y": 0.1090849,
    "CMYK_C": 0.0740837,
    "CMYK_M": 0,
    "CMYK_Y": 0.008851492,
    "CMYK_K": 0.1011286
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07094",
    "Farbtonhilfsbezeichnung": "P6.03.75",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "210",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.2546371276701,
    "a": -3.37945040020604,
    "b": -1.34809624554926,
    "C": 3.63841290877173,
    "h": 0.37956628884728,
    "CMY_C": 0.2182675,
    "CMY_M": 0.1780739,
    "CMY_Y": 0.1836319,
    "CMYK_C": 0.04890171,
    "CMYK_M": 0,
    "CMYK_Y": 0.006762199,
    "CMYK_K": 0.1780739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07095",
    "Farbtonhilfsbezeichnung": "P9.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "206",
    "Bcolor": "206",
    "Y": 60,
    "L": 81.7427326826172,
    "a": -4.28668329912857,
    "b": -2.67106213758577,
    "C": 5.05076495690227,
    "h": 0.55723685949969,
    "CMY_C": 0.2469,
    "CMY_M": 0.1922066,
    "CMY_Y": 0.1905862,
    "CMYK_C": 0.06957351,
    "CMYK_M": 0.002001897,
    "CMYK_Y": 0,
    "CMYK_K": 0.1905862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07096",
    "Farbtonhilfsbezeichnung": "P8.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "197",
    "Bcolor": "197",
    "Y": 55,
    "L": 78.8529078140966,
    "a": -3.43060445962068,
    "b": -1.78398446090804,
    "C": 3.86673602863328,
    "h": 0.4795353859479,
    "CMY_C": 0.2677906,
    "CMY_M": 0.2258252,
    "CMY_Y": 0.2281286,
    "CMYK_C": 0.05420665,
    "CMYK_M": 0,
    "CMYK_Y": 0.002975353,
    "CMYK_K": 0.2258252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07097",
    "Farbtonhilfsbezeichnung": "P9.04.54",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "150",
    "Bcolor": "151",
    "Y": 30,
    "L": 61.4111233751588,
    "a": -3.38181439980018,
    "b": -2.17410276644583,
    "C": 4.02037205663397,
    "h": 0.57135405573373,
    "CMY_C": 0.4513468,
    "CMY_M": 0.4103895,
    "CMY_Y": 0.4087646,
    "CMYK_C": 0.0720224,
    "CMYK_M": 0.002748381,
    "CMYK_Y": 0,
    "CMYK_K": 0.4087646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07098",
    "Farbtonhilfsbezeichnung": "P9.08.45",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "129",
    "Bcolor": "130",
    "Y": 21,
    "L": 52.5635844740406,
    "a": -6.04639661561107,
    "b": -3.65365906787352,
    "C": 7.06456910345758,
    "h": 0.54355365399297,
    "CMY_C": 0.5661734,
    "CMY_M": 0.494549,
    "CMY_Y": 0.4886217,
    "CMYK_C": 0.1516523,
    "CMYK_M": 0.01159082,
    "CMYK_Y": 0,
    "CMYK_K": 0.4886217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07099",
    "Farbtonhilfsbezeichnung": "P5.04.39",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "112",
    "Bcolor": "113",
    "Y": 16,
    "L": 46.6325256617799,
    "a": -3.06010695861847,
    "b": -1.98022214321194,
    "C": 3.64493269274648,
    "h": 0.57434005699945,
    "CMY_C": 0.5949151,
    "CMY_M": 0.5596529,
    "CMY_Y": 0.5577125,
    "CMYK_C": 0.08411403,
    "CMYK_M": 0.004387218,
    "CMYK_Y": 0,
    "CMYK_K": 0.5577125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07100",
    "Farbtonhilfsbezeichnung": "P3.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "103",
    "Bcolor": "103",
    "Y": 13,
    "L": 42.6109722921849,
    "a": -3.69906091274863,
    "b": -1.7750155732192,
    "C": 4.10289311600917,
    "h": 0.44740271370288,
    "CMY_C": 0.6373789,
    "CMY_M": 0.5974791,
    "CMY_Y": 0.5978904,
    "CMYK_C": 0.09912485,
    "CMYK_M": 0,
    "CMYK_Y": 0.001021912,
    "CMYK_K": 0.5974791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07101",
    "Farbtonhilfsbezeichnung": "P9.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "94",
    "Bcolor": "97",
    "Y": 11,
    "L": 38.8317266766236,
    "a": -5.01128990979319,
    "b": -3.74467551623745,
    "C": 6.25584696758986,
    "h": 0.6417373925989,
    "CMY_C": 0.6896973,
    "CMY_M": 0.630617,
    "CMY_Y": 0.6215259,
    "CMYK_C": 0.1801216,
    "CMYK_M": 0.02402049,
    "CMYK_Y": 0,
    "CMYK_K": 0.6215259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07102",
    "Farbtonhilfsbezeichnung": "P8.09.18",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "70",
    "Bcolor": "71",
    "Y": 6,
    "L": 28.7419756719514,
    "a": -3.45517141590399,
    "b": -2.79314627904641,
    "C": 4.44295798420723,
    "h": 0.67983944546698,
    "CMY_C": 0.7662038,
    "CMY_M": 0.7270627,
    "CMY_Y": 0.7203255,
    "CMYK_C": 0.1640418,
    "CMYK_M": 0.02408954,
    "CMYK_Y": 0,
    "CMYK_K": 0.7203255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07103",
    "Farbtonhilfsbezeichnung": "P5.05.16",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "62",
    "Bcolor": "63",
    "Y": 5,
    "L": 25.5988482950818,
    "a": -2.46997276192196,
    "b": -1.77702273595353,
    "C": 3.04279070077653,
    "h": 0.62366095716877,
    "CMY_C": 0.7835257,
    "CMY_M": 0.7571068,
    "CMY_Y": 0.7541758,
    "CMYK_C": 0.1193937,
    "CMYK_M": 0.0119229,
    "CMYK_Y": 0,
    "CMYK_K": 0.7541758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07104",
    "Farbtonhilfsbezeichnung": "Q1.22.72",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "210",
    "Bcolor": "220",
    "Y": 57,
    "L": 79.9387712817943,
    "a": -20.7866228455378,
    "b": -13.2459878571997,
    "C": 24.6483241547112,
    "h": 0.56735000828159,
    "CMY_C": 0.4749235,
    "CMY_M": 0.1746254,
    "CMY_Y": 0.1356729,
    "CMYK_C": 0.3925025,
    "CMYK_M": 0.04506686,
    "CMYK_Y": 0,
    "CMYK_K": 0.1356729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07105",
    "Farbtonhilfsbezeichnung": "Q3.20.74",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "214",
    "Bcolor": "225",
    "Y": 59,
    "L": 81.3970010681459,
    "a": -18.6362453098075,
    "b": -13.6226657884363,
    "C": 23.0843380331937,
    "h": 0.63121478330705,
    "CMY_C": 0.4371076,
    "CMY_M": 0.1626305,
    "CMY_Y": 0.1166404,
    "CMYK_C": 0.3627823,
    "CMYK_M": 0.05206269,
    "CMYK_Y": 0,
    "CMYK_K": 0.1166404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07106",
    "Farbtonhilfsbezeichnung": "Q1.17.76",
    "Farbtonklasse": "03",
    "Rcolor": "159",
    "Gcolor": "218",
    "Bcolor": "226",
    "Y": 63,
    "L": 83.5382805681861,
    "a": -16.4735976148648,
    "b": -10.7692363965806,
    "C": 19.6813584628174,
    "h": 0.57899083147205,
    "CMY_C": 0.3745177,
    "CMY_M": 0.1441567,
    "CMY_Y": 0.1135101,
    "CMYK_C": 0.2944282,
    "CMYK_M": 0.0345707,
    "CMYK_Y": 0,
    "CMYK_K": 0.1135101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07107",
    "Farbtonhilfsbezeichnung": "Q2.09.81",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "229",
    "Bcolor": "232",
    "Y": 74,
    "L": 88.8964594023058,
    "a": -9.23692334744497,
    "b": -5.63608465328063,
    "C": 10.8206378345049,
    "h": 0.54786320261849,
    "CMY_C": 0.2233353,
    "CMY_M": 0.1014039,
    "CMY_Y": 0.09095927,
    "CMYK_C": 0.1456216,
    "CMYK_M": 0.01148972,
    "CMYK_Y": 0,
    "CMYK_K": 0.09095927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07108",
    "Farbtonhilfsbezeichnung": "P7.07.84",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "235",
    "Bcolor": "234",
    "Y": 79,
    "L": 91.0241065393505,
    "a": -8.33171168620722,
    "b": -3.82322910499326,
    "C": 9.16703334843664,
    "h": 0.43021129773415,
    "CMY_C": 0.1844845,
    "CMY_M": 0.0801478,
    "CMY_Y": 0.08060509,
    "CMYK_C": 0.1134277,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004971364,
    "CMYK_K": 0.0801478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07109",
    "Farbtonhilfsbezeichnung": "Q4.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "237",
    "Bcolor": "237",
    "Y": 82,
    "L": 92.629522049521,
    "a": -4.19644855704193,
    "b": -2.79312020622864,
    "C": 5.04100198158481,
    "h": 0.58725784115955,
    "CMY_C": 0.127434,
    "CMY_M": 0.07181051,
    "CMY_Y": 0.06983469,
    "CMYK_C": 0.06192369,
    "CMYK_M": 0.002124171,
    "CMYK_Y": 0,
    "CMYK_K": 0.06983469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07110",
    "Farbtonhilfsbezeichnung": "QN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "237",
    "Bcolor": "235",
    "Y": 84,
    "L": 93.6133767396196,
    "a": -1.03963742067892,
    "b": -0.31581635995341,
    "C": 1.08654771625094,
    "h": 0.29491693131703,
    "CMY_C": 0.08147065,
    "CMY_M": 0.0688684,
    "CMY_Y": 0.07688309,
    "CMYK_C": 0.01353434,
    "CMYK_M": 0,
    "CMYK_Y": 0.008607469,
    "CMYK_K": 0.0688684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07111",
    "Farbtonhilfsbezeichnung": "Q0.30.65",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "193",
    "Bcolor": "205",
    "Y": 45,
    "L": 72.6698277476429,
    "a": -26.0588936028426,
    "b": -15.9573965259963,
    "C": 30.5565776829171,
    "h": 0.54945743137156,
    "CMY_C": 0.6477445,
    "CMY_M": 0.2435451,
    "CMY_Y": 0.1961889,
    "CMYK_C": 0.5617684,
    "CMYK_M": 0.05891467,
    "CMYK_Y": 0,
    "CMYK_K": 0.1961889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07112",
    "Farbtonhilfsbezeichnung": "Q2.18.75",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "215",
    "Bcolor": "224",
    "Y": 61,
    "L": 82.5204942077483,
    "a": -16.5077410786555,
    "b": -11.4745207822602,
    "C": 20.1039832546302,
    "h": 0.60742938774462,
    "CMY_C": 0.3897357,
    "CMY_M": 0.1551291,
    "CMY_Y": 0.1196179,
    "CMYK_C": 0.3068189,
    "CMYK_M": 0.0403361,
    "CMYK_Y": 0,
    "CMYK_K": 0.1196179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07113",
    "Farbtonhilfsbezeichnung": "Q0.11.79",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "225",
    "Bcolor": "228",
    "Y": 69,
    "L": 86.6845852183992,
    "a": -12.6542037165727,
    "b": -7.12430980103131,
    "C": 14.5218684005053,
    "h": 0.51276878759878,
    "CMY_C": 0.2850722,
    "CMY_M": 0.1182423,
    "CMY_Y": 0.104943,
    "CMYK_C": 0.2012489,
    "CMYK_M": 0.01485863,
    "CMYK_Y": 0,
    "CMYK_K": 0.104943
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07114",
    "Farbtonhilfsbezeichnung": "Q2.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "228",
    "Bcolor": "231",
    "Y": 72,
    "L": 88.1906381903472,
    "a": -10.59892856198,
    "b": -6.50951997103413,
    "C": 12.4382931672818,
    "h": 0.55077187466733,
    "CMY_C": 0.2470455,
    "CMY_M": 0.1060522,
    "CMY_Y": 0.09252276,
    "CMYK_C": 0.1702773,
    "CMYK_M": 0.01490881,
    "CMYK_Y": 0,
    "CMYK_K": 0.09252276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07115",
    "Farbtonhilfsbezeichnung": "Q3.05.84",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 79,
    "L": 91.3311971013065,
    "a": -5.8759030778055,
    "b": -2.85820176562412,
    "C": 6.53418352304104,
    "h": 0.45273089962792,
    "CMY_C": 0.1561739,
    "CMY_M": 0.08250152,
    "CMY_Y": 0.08402754,
    "CMYK_C": 0.08029696,
    "CMYK_M": 0,
    "CMYK_Y": 0.001663249,
    "CMYK_K": 0.08250152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07116",
    "Farbtonhilfsbezeichnung": "Q5.35.62",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "188",
    "Bcolor": "208",
    "Y": 41,
    "L": 70.6669158935547,
    "a": -26.5244770050049,
    "b": -20.7091255187988,
    "C": 33.6513862609863,
    "h": 217.98112487793,
    "CMY_C": 0.73544538021088,
    "CMY_M": 0.26296508312225,
    "CMY_Y": 0.18429934978485,
    "CMYK_C": 0.67567193508148,
    "CMYK_M": 0.09643946588039,
    "CMYK_Y": 0,
    "CMYK_K": 0.18429934978485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07117",
    "Farbtonhilfsbezeichnung": "Q2.24.71",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 57,
    "L": 80.1299589519157,
    "a": -21.7264062190522,
    "b": -15.3581730834255,
    "C": 26.6065820363256,
    "h": 0.61533498255757,
    "CMY_C": 0.4983051,
    "CMY_M": 0.1700705,
    "CMY_Y": 0.1183702,
    "CMYK_C": 0.4309461,
    "CMYK_M": 0.05864166,
    "CMYK_Y": 0,
    "CMYK_K": 0.1183702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07118",
    "Farbtonhilfsbezeichnung": "Q4.17.74",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "211",
    "Bcolor": "222",
    "Y": 59,
    "L": 81.0714472855488,
    "a": -15.3126362711359,
    "b": -12.0746225695774,
    "C": 19.5005984464542,
    "h": 0.66771382347305,
    "CMY_C": 0.3964382,
    "CMY_M": 0.1733317,
    "CMY_Y": 0.1311056,
    "CMYK_C": 0.3053681,
    "CMYK_M": 0.04859756,
    "CMYK_Y": 0,
    "CMYK_K": 0.1311056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07119",
    "Farbtonhilfsbezeichnung": "Q1.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "223",
    "Bcolor": "223",
    "Y": 71,
    "L": 87.2878335126723,
    "a": -7.57310992921933,
    "b": -3.43416173836859,
    "C": 8.31537496721075,
    "h": 0.42573403222465,
    "CMY_C": 0.2172508,
    "CMY_M": 0.1236071,
    "CMY_Y": 0.1247573,
    "CMYK_C": 0.1068512,
    "CMYK_M": 0,
    "CMYK_Y": 0.001312415,
    "CMYK_K": 0.1236071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07120",
    "Farbtonhilfsbezeichnung": "Q4.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "231",
    "Bcolor": "232",
    "Y": 77,
    "L": 90.2619267326117,
    "a": -5.53115251963077,
    "b": -3.88640524533201,
    "C": 6.76001434365061,
    "h": 0.61249512459225,
    "CMY_C": 0.1690688,
    "CMY_M": 0.09493617,
    "CMY_Y": 0.08825106,
    "CMYK_C": 0.08864035,
    "CMYK_M": 0.00733218,
    "CMYK_Y": 0,
    "CMYK_K": 0.08825106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07121",
    "Farbtonhilfsbezeichnung": "QN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "224",
    "Bcolor": "223",
    "Y": 74,
    "L": 88.8453659286703,
    "a": -1.36695147613364,
    "b": -0.67253181783131,
    "C": 1.52343538888245,
    "h": 0.45722225794222,
    "CMY_C": 0.1383934,
    "CMY_M": 0.1212153,
    "CMY_Y": 0.1270955,
    "CMYK_C": 0.01954765,
    "CMYK_M": 0,
    "CMYK_Y": 0.00669131,
    "CMYK_K": 0.1212153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07122",
    "Farbtonhilfsbezeichnung": "Q4.41.56",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "172",
    "Bcolor": "195",
    "Y": 33,
    "L": 64.1723924872624,
    "a": -29.2002543725545,
    "b": -23.2871570762601,
    "C": 37.3489831202444,
    "h": 0.67321373345319,
    "CMY_C": 1,
    "CMY_M": 0.3273404,
    "CMY_Y": 0.2367518,
    "CMYK_C": 1,
    "CMYK_M": 0.1186883,
    "CMYK_Y": 0,
    "CMYK_K": 0.2367518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07123",
    "Farbtonhilfsbezeichnung": "Q3.33.63",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "189",
    "Bcolor": "208",
    "Y": 42,
    "L": 71.2048408714855,
    "a": -25.7190779261721,
    "b": -20.0216534856999,
    "C": 32.5935204860407,
    "h": 0.66147730709899,
    "CMY_C": 0.7035884,
    "CMY_M": 0.258772,
    "CMY_Y": 0.183239,
    "CMYK_C": 0.637089,
    "CMYK_M": 0.09247864,
    "CMYK_Y": 0,
    "CMYK_K": 0.183239
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07124",
    "Farbtonhilfsbezeichnung": "Q4.26.66",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "197",
    "Bcolor": "211",
    "Y": 48,
    "L": 74.6962140142361,
    "a": -21.9233595153626,
    "b": -16.342017006817,
    "C": 27.3440160234545,
    "h": 0.64056071336806,
    "CMY_C": 0.5688578,
    "CMY_M": 0.2289136,
    "CMY_Y": 0.1709894,
    "CMYK_C": 0.4799317,
    "CMYK_M": 0.06987157,
    "CMYK_Y": 0,
    "CMYK_K": 0.1709894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07125",
    "Farbtonhilfsbezeichnung": "Q1.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "211",
    "Bcolor": "217",
    "Y": 60,
    "L": 81.7333962008593,
    "a": -12.1310170436806,
    "b": -8.33137506449308,
    "C": 14.7164324813905,
    "h": 0.60180023982707,
    "CMY_C": 0.3392401,
    "CMY_M": 0.1737215,
    "CMY_Y": 0.1506183,
    "CMYK_C": 0.2220695,
    "CMYK_M": 0.02719996,
    "CMYK_Y": 0,
    "CMYK_K": 0.1506183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07126",
    "Farbtonhilfsbezeichnung": "Q3.09.74",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "207",
    "Bcolor": "211",
    "Y": 59,
    "L": 81.2998789762271,
    "a": -7.85431696248795,
    "b": -5.95096548885397,
    "C": 9.85415065831434,
    "h": 0.64839066318002,
    "CMY_C": 0.2947619,
    "CMY_M": 0.1882605,
    "CMY_Y": 0.1721029,
    "CMYK_C": 0.1481574,
    "CMYK_M": 0.01951653,
    "CMYK_Y": 0,
    "CMYK_K": 0.1721029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07127",
    "Farbtonhilfsbezeichnung": "Q4.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "223",
    "Bcolor": "223",
    "Y": 72,
    "L": 87.9510589880716,
    "a": -3.24673351429455,
    "b": -2.42070863156905,
    "C": 4.04982824225872,
    "h": 0.64066809514864,
    "CMY_C": 0.169822,
    "CMY_M": 0.1262835,
    "CMY_Y": 0.1243357,
    "CMYK_C": 0.05194489,
    "CMYK_M": 0.002224403,
    "CMYK_Y": 0,
    "CMYK_K": 0.1243357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07128",
    "Farbtonhilfsbezeichnung": "QN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "212",
    "Bcolor": "212",
    "Y": 65,
    "L": 84.7344486548288,
    "a": -1.10371049339458,
    "b": -1.1123245149907,
    "C": 1.56698522005749,
    "h": 0.78928527627181,
    "CMY_C": 0.1830677,
    "CMY_M": 0.1671071,
    "CMY_Y": 0.1689207,
    "CMYK_C": 0.01916281,
    "CMYK_M": 0,
    "CMYK_Y": 0.002177365,
    "CMYK_K": 0.1671071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07129",
    "Farbtonhilfsbezeichnung": "Q5.42.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "164",
    "Bcolor": "186",
    "Y": 29,
    "L": 61.6223411560059,
    "a": -27.0756072998047,
    "b": -22.4300937652588,
    "C": 35.1596031188965,
    "h": 219.639175415039,
    "CMY_C": 1,
    "CMY_M": 0.35814762115479,
    "CMY_Y": 0.26986217498779,
    "CMYK_C": 1,
    "CMYK_M": 0.12091613560915,
    "CMYK_Y": 0,
    "CMYK_K": 0.26986217498779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07130",
    "Farbtonhilfsbezeichnung": "Q3.36.58",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "174",
    "Bcolor": "193",
    "Y": 34,
    "L": 65.2603127180833,
    "a": -27.6662770001828,
    "b": -20.468454368816,
    "C": 34.4148297583926,
    "h": 0.63696310440331,
    "CMY_C": 0.848974,
    "CMY_M": 0.319169,
    "CMY_Y": 0.2445689,
    "CMYK_C": 0.8000798,
    "CMYK_M": 0.09875173,
    "CMYK_Y": 0,
    "CMYK_K": 0.2445689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07131",
    "Farbtonhilfsbezeichnung": "Q4.29.62",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "185",
    "Bcolor": "202",
    "Y": 41,
    "L": 70.3140666373797,
    "a": -22.0639795015248,
    "b": -17.6618842828659,
    "C": 28.262366282126,
    "h": 0.67503659434891,
    "CMY_C": 0.6315966,
    "CMY_M": 0.2756605,
    "CMY_Y": 0.2092766,
    "CMYK_C": 0.5340931,
    "CMYK_M": 0.08395346,
    "CMYK_Y": 0,
    "CMYK_K": 0.2092766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07132",
    "Farbtonhilfsbezeichnung": "Q4.13.73",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "208",
    "Bcolor": "216",
    "Y": 58,
    "L": 80.8878801537102,
    "a": -12.0119486921638,
    "b": -9.28308077044917,
    "C": 15.1809914028649,
    "h": 0.65794700515567,
    "CMY_C": 0.3517411,
    "CMY_M": 0.182967,
    "CMY_Y": 0.1529755,
    "CMYK_C": 0.2346633,
    "CMYK_M": 0.03540802,
    "CMYK_Y": 0,
    "CMYK_K": 0.1529755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07133",
    "Farbtonhilfsbezeichnung": "Q0.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "211",
    "Bcolor": "218",
    "Y": 60,
    "L": 81.6850590154823,
    "a": -12.4167970778704,
    "b": -8.98413008368097,
    "C": 15.326168569917,
    "h": 0.62635481063273,
    "CMY_C": 0.3455691,
    "CMY_M": 0.1734632,
    "CMY_Y": 0.1464465,
    "CMYK_C": 0.2332866,
    "CMYK_M": 0.0316521,
    "CMYK_Y": 0,
    "CMYK_K": 0.1464465
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07134",
    "Farbtonhilfsbezeichnung": "Q0.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "214",
    "Bcolor": "213",
    "Y": 64,
    "L": 84.0828151510419,
    "a": -7.12605462052551,
    "b": -2.70655393934052,
    "C": 7.62273498695007,
    "h": 0.36298184850215,
    "CMY_C": 0.245365,
    "CMY_M": 0.160235,
    "CMY_Y": 0.1651982,
    "CMYK_C": 0.1013736,
    "CMYK_M": 0,
    "CMYK_Y": 0.005910184,
    "CMYK_K": 0.160235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07136",
    "Farbtonhilfsbezeichnung": "QN.01.76",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "209",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.5161660577592,
    "a": -1.96288933450606,
    "b": -1.07327992566262,
    "C": 2.23715541220273,
    "h": 0.50037211111359,
    "CMY_C": 0.2030696,
    "CMY_M": 0.1785103,
    "CMY_Y": 0.1825976,
    "CMYK_C": 0.02989605,
    "CMYK_M": 0,
    "CMYK_Y": 0.004975478,
    "CMYK_K": 0.1785103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07137",
    "Farbtonhilfsbezeichnung": "Q5.44.49",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "154",
    "Bcolor": "175",
    "Y": 24,
    "L": 57.8612060546875,
    "a": -27.1192359924316,
    "b": -22.1186542510986,
    "C": 34.9955406188965,
    "h": 219.200942993164,
    "CMY_C": 1,
    "CMY_M": 0.39767283201218,
    "CMY_Y": 0.31194150447845,
    "CMYK_C": 1,
    "CMYK_M": 0.12459889054298,
    "CMYK_Y": 0,
    "CMYK_K": 0.31194150447845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07138",
    "Farbtonhilfsbezeichnung": "Q5.36.53",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "159",
    "Bcolor": "180",
    "Y": 29,
    "L": 60.4346677636679,
    "a": -23.9763489241022,
    "b": -20.7152572443427,
    "C": 31.6857569016362,
    "h": 0.71255848391484,
    "CMY_C": 0.8329632,
    "CMY_M": 0.3763224,
    "CMY_Y": 0.2940618,
    "CMYK_C": 0.7633833,
    "CMYK_M": 0.1165267,
    "CMYK_Y": 0,
    "CMYK_K": 0.2940618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07139",
    "Farbtonhilfsbezeichnung": "Q2.30.54",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "161",
    "Bcolor": "173",
    "Y": 30,
    "L": 61.547391385531,
    "a": -21.6768628000689,
    "b": -15.2177046019536,
    "C": 26.4851829181021,
    "h": 0.61208388660346,
    "CMY_C": 0.7055092,
    "CMY_M": 0.3702651,
    "CMY_Y": 0.3198882,
    "CMYK_C": 0.5669965,
    "CMYK_M": 0.07407158,
    "CMYK_Y": 0,
    "CMYK_K": 0.3198882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07140",
    "Farbtonhilfsbezeichnung": "Q4.24.63",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "185",
    "Bcolor": "198",
    "Y": 42,
    "L": 71.1391754150391,
    "a": -18.7833881378174,
    "b": -14.4125127792358,
    "C": 23.6756458282471,
    "h": 217.499053955078,
    "CMY_C": 0.55517315864563,
    "CMY_M": 0.27384233474731,
    "CMY_Y": 0.22300040721893,
    "CMYK_C": 0.42750698328018,
    "CMYK_M": 0.06543365865946,
    "CMYK_Y": 0,
    "CMYK_K": 0.22300040721893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07141",
    "Farbtonhilfsbezeichnung": "Q4.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "203",
    "Bcolor": "214",
    "Y": 53,
    "L": 77.8252248783624,
    "a": -17.2337646510448,
    "b": -13.0265210930378,
    "C": 21.6030760734428,
    "h": 0.64724864331219,
    "CMY_C": 0.4569228,
    "CMY_M": 0.2047866,
    "CMY_Y": 0.1600754,
    "CMYK_C": 0.3534214,
    "CMYK_M": 0.05323236,
    "CMYK_Y": 0,
    "CMYK_K": 0.1600754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07142",
    "Farbtonhilfsbezeichnung": "Q2.10.64",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "181",
    "Bcolor": "185",
    "Y": 43,
    "L": 71.4798552889191,
    "a": -9.29538070453495,
    "b": -6.36707141444242,
    "C": 11.2669295213403,
    "h": 0.60056839347297,
    "CMY_C": 0.4129831,
    "CMY_M": 0.2912465,
    "CMY_Y": 0.2751353,
    "CMYK_C": 0.1901705,
    "CMYK_M": 0.02222659,
    "CMYK_Y": 0,
    "CMYK_K": 0.2751353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07143",
    "Farbtonhilfsbezeichnung": "Q3.06.65",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "182",
    "Bcolor": "184",
    "Y": 45,
    "L": 72.7331751895414,
    "a": -5.25120058534112,
    "b": -4.02969645984572,
    "C": 6.61918130481256,
    "h": 0.65453544906127,
    "CMY_C": 0.3559632,
    "CMY_M": 0.2870491,
    "CMY_Y": 0.2778302,
    "CMYK_C": 0.1081921,
    "CMYK_M": 0.01276557,
    "CMYK_Y": 0,
    "CMYK_K": 0.2778302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07144",
    "Farbtonhilfsbezeichnung": "QN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "196",
    "Bcolor": "195",
    "Y": 54,
    "L": 78.6823369762096,
    "a": -1.13099042280412,
    "b": -1.18327507391671,
    "C": 1.63685040154171,
    "h": 0.80798665132781,
    "CMY_C": 0.2492608,
    "CMY_M": 0.2330272,
    "CMY_Y": 0.2339805,
    "CMYK_C": 0.02116577,
    "CMYK_M": 0,
    "CMYK_Y": 0.001242969,
    "CMYK_K": 0.2330272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07145",
    "Farbtonhilfsbezeichnung": "Q5.47.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "141",
    "Bcolor": "162",
    "Y": 20,
    "L": 53.0667304992676,
    "a": -26.1242904663086,
    "b": -21.8578777313232,
    "C": 34.0623741149902,
    "h": 219.918823242188,
    "CMY_C": 1,
    "CMY_M": 0.44900387525558,
    "CMY_Y": 0.36390674114227,
    "CMYK_C": 1,
    "CMYK_M": 0.13378091156483,
    "CMYK_Y": 0,
    "CMYK_K": 0.36390674114227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07146",
    "Farbtonhilfsbezeichnung": "Q0.45.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "138",
    "Bcolor": "154",
    "Y": 20,
    "L": 51.4440624072572,
    "a": -31.0739015020783,
    "b": -19.4183188225966,
    "C": 36.6423042460061,
    "h": 0.55853290495467,
    "CMY_C": 1,
    "CMY_M": 0.4589961,
    "CMY_Y": 0.3974054,
    "CMYK_C": 1,
    "CMYK_M": 0.1022092,
    "CMYK_Y": 0,
    "CMYK_K": 0.3974054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07147",
    "Farbtonhilfsbezeichnung": "Q2.39.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "137",
    "Bcolor": "153",
    "Y": 20,
    "L": 52.0437760555899,
    "a": -24.8558330711841,
    "b": -17.9286070942988,
    "C": 30.6471432600872,
    "h": 0.62488119580951,
    "CMY_C": 1,
    "CMY_M": 0.4626814,
    "CMY_Y": 0.4007047,
    "CMYK_C": 1,
    "CMYK_M": 0.1034159,
    "CMYK_Y": 0,
    "CMYK_K": 0.4007047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07148",
    "Farbtonhilfsbezeichnung": "Q1.31.49",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "150",
    "Bcolor": "161",
    "Y": 24,
    "L": 57.7079963684082,
    "a": -20.435001373291,
    "b": -13.9965591430664,
    "C": 24.7687892913818,
    "h": 214.408432006836,
    "CMY_C": 0.72037535905838,
    "CMY_M": 0.41280382871628,
    "CMY_Y": 0.36825692653656,
    "CMYK_C": 0.55737602710724,
    "CMYK_M": 0.07051426917315,
    "CMYK_Y": 0,
    "CMYK_K": 0.36825692653656
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07149",
    "Farbtonhilfsbezeichnung": "Q4.19.63",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "183",
    "Bcolor": "194",
    "Y": 42,
    "L": 71.1698725240615,
    "a": -15.3471293158625,
    "b": -11.8697055401129,
    "C": 19.401656832518,
    "h": 0.65831929500898,
    "CMY_C": 0.501174,
    "CMY_M": 0.2808471,
    "CMY_Y": 0.240284,
    "CMYK_C": 0.3434046,
    "CMYK_M": 0.05339237,
    "CMYK_Y": 0,
    "CMYK_K": 0.240284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07150",
    "Farbtonhilfsbezeichnung": "Q2.05.69",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "192",
    "Bcolor": "194",
    "Y": 51,
    "L": 76.4660844898986,
    "a": -4.80509206119911,
    "b": -3.81686165859865,
    "C": 6.13655788186497,
    "h": 0.67127824580837,
    "CMY_C": 0.3120274,
    "CMY_M": 0.2480191,
    "CMY_Y": 0.2393983,
    "CMYK_C": 0.09548894,
    "CMYK_M": 0.01133406,
    "CMYK_Y": 0,
    "CMYK_K": 0.2393983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07151",
    "Farbtonhilfsbezeichnung": "Q2.04.62",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "173",
    "Bcolor": "173",
    "Y": 40,
    "L": 69.7405726537597,
    "a": -3.51370403069201,
    "b": -2.42752780950377,
    "C": 4.27071507844008,
    "h": 0.60457503965983,
    "CMY_C": 0.3673255,
    "CMY_M": 0.32305,
    "CMY_Y": 0.3205414,
    "CMYK_C": 0.06885485,
    "CMYK_M": 0.003692008,
    "CMYK_Y": 0,
    "CMYK_K": 0.3205414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07152",
    "Farbtonhilfsbezeichnung": "Q3.55.38",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "125",
    "Bcolor": "146",
    "Y": 16,
    "L": 46.5856323529062,
    "a": -30.152030592295,
    "b": -22.4975874776079,
    "C": 37.6202922789192,
    "h": 0.64102509218562,
    "CMY_C": 1,
    "CMY_M": 0.5089456,
    "CMY_Y": 0.4267922,
    "CMYK_C": 1,
    "CMYK_M": 0.1433222,
    "CMYK_Y": 0,
    "CMYK_K": 0.4267922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07153",
    "Farbtonhilfsbezeichnung": "Q2.45.40",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "142",
    "Y": 16,
    "L": 47.3120751060675,
    "a": -27.7621542874979,
    "b": -18.9199684357437,
    "C": 33.5961666904481,
    "h": 0.59820313687205,
    "CMY_C": 1,
    "CMY_M": 0.5061087,
    "CMY_Y": 0.4427311,
    "CMYK_C": 1,
    "CMYK_M": 0.1137289,
    "CMYK_Y": 0,
    "CMYK_K": 0.4427311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07154",
    "Farbtonhilfsbezeichnung": "Q5.41.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "135",
    "Bcolor": "155",
    "Y": 20,
    "L": 51.2819968898119,
    "a": -24.7476351074835,
    "b": -20.430290648003,
    "C": 32.0911548463908,
    "h": 0.69012434359434,
    "CMY_C": 1,
    "CMY_M": 0.4698651,
    "CMY_Y": 0.391859,
    "CMYK_C": 1,
    "CMYK_M": 0.1282697,
    "CMYK_Y": 0,
    "CMYK_K": 0.391859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07155",
    "Farbtonhilfsbezeichnung": "Q2.30.44",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "135",
    "Bcolor": "146",
    "Y": 20,
    "L": 52.0025239517349,
    "a": -20.1045960280707,
    "b": -14.103278326123,
    "C": 24.5580382155417,
    "h": 0.61172877340435,
    "CMY_C": 0.782241,
    "CMY_M": 0.4718938,
    "CMY_Y": 0.4262381,
    "CMYK_C": 0.6204717,
    "CMYK_M": 0.07957261,
    "CMYK_Y": 0,
    "CMYK_K": 0.4262381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07156",
    "Farbtonhilfsbezeichnung": "Q3.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "157",
    "Bcolor": "167",
    "Y": 30,
    "L": 61.7126332401228,
    "a": -14.6374300204854,
    "b": -11.0856115654117,
    "C": 18.361512502618,
    "h": 0.64818653733867,
    "CMY_C": 0.5878788,
    "CMY_M": 0.3824295,
    "CMY_Y": 0.3458707,
    "CMYK_C": 0.3699697,
    "CMYK_M": 0.05588927,
    "CMYK_Y": 0,
    "CMYK_K": 0.3458707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07157",
    "Farbtonhilfsbezeichnung": "Q2.15.59",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "169",
    "Bcolor": "176",
    "Y": 36,
    "L": 66.6035098557912,
    "a": -12.1113819899064,
    "b": -8.57003089682209,
    "C": 14.8368124365685,
    "h": 0.6158093801331,
    "CMY_C": 0.4992444,
    "CMY_M": 0.3366991,
    "CMY_Y": 0.3116672,
    "CMYK_C": 0.2725095,
    "CMYK_M": 0.0363659,
    "CMYK_Y": 0,
    "CMYK_K": 0.3116672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07158",
    "Farbtonhilfsbezeichnung": "Q1.05.54",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "152",
    "Bcolor": "154",
    "Y": 30,
    "L": 61.9721231454639,
    "a": -3.63862783146129,
    "b": -3.05832003455859,
    "C": 4.75320249196972,
    "h": 0.69896149542323,
    "CMY_C": 0.4508026,
    "CMY_M": 0.4038192,
    "CMY_Y": 0.3969889,
    "CMYK_C": 0.08924158,
    "CMYK_M": 0.01132701,
    "CMYK_Y": 0,
    "CMYK_K": 0.3969889
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07159",
    "Farbtonhilfsbezeichnung": "QN.02.59",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "164",
    "Bcolor": "164",
    "Y": 36,
    "L": 66.8785948522846,
    "a": -1.53357741524851,
    "b": -1.30425289091098,
    "C": 2.01319032682207,
    "h": 0.70476357070961,
    "CMY_C": 0.3778422,
    "CMY_M": 0.3577888,
    "CMY_Y": 0.358067,
    "CMYK_C": 0.03122563,
    "CMYK_M": 0,
    "CMYK_Y": 0.0004331985,
    "CMYK_K": 0.3577888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07160",
    "Farbtonhilfsbezeichnung": "Q2.49.35",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "130",
    "Y": 13,
    "L": 42.55401342787,
    "a": -26.549473639734,
    "b": -18.8145596692776,
    "C": 32.5401629697169,
    "h": 0.61651467259869,
    "CMY_C": 1,
    "CMY_M": 0.5555477,
    "CMY_Y": 0.4912718,
    "CMYK_C": 1,
    "CMYK_M": 0.1263463,
    "CMYK_Y": 0,
    "CMYK_K": 0.4912718
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07161",
    "Farbtonhilfsbezeichnung": "Q4.44.35",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "111",
    "Bcolor": "128",
    "Y": 13,
    "L": 42.2546664569329,
    "a": -23.2563049414429,
    "b": -17.9200850187793,
    "C": 29.3595838970797,
    "h": 0.65652226925963,
    "CMY_C": 1,
    "CMY_M": 0.5635121,
    "CMY_Y": 0.4997911,
    "CMYK_C": 1,
    "CMYK_M": 0.1273889,
    "CMYK_Y": 0,
    "CMYK_K": 0.4997911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07162",
    "Farbtonhilfsbezeichnung": "Q1.36.32",
    "Farbtonklasse": "03",
    "Rcolor": "21",
    "Gcolor": "105",
    "Bcolor": "116",
    "Y": 12,
    "L": 40.5911229107821,
    "a": -19.582704864097,
    "b": -13.5053611637121,
    "C": 23.7881716396328,
    "h": 0.60375097594684,
    "CMY_C": 0.918428,
    "CMY_M": 0.5866039,
    "CMY_Y": 0.5442078,
    "CMYK_C": 0.8210326,
    "CMYK_M": 0.09301655,
    "CMYK_Y": 0,
    "CMYK_K": 0.5442078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07163",
    "Farbtonhilfsbezeichnung": "Q0.34.40",
    "Farbtonklasse": "03",
    "Rcolor": "29",
    "Gcolor": "124",
    "Bcolor": "134",
    "Y": 16,
    "L": 47.448707773817,
    "a": -22.4936831451663,
    "b": -13.80931804937,
    "C": 26.3943752800439,
    "h": 0.55059184425325,
    "CMY_C": 0.8877911,
    "CMY_M": 0.5141549,
    "CMY_Y": 0.474472,
    "CMYK_C": 0.7864835,
    "CMYK_M": 0.07551049,
    "CMYK_Y": 0,
    "CMYK_K": 0.474472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07164",
    "Farbtonhilfsbezeichnung": "Q0.21.50",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "146",
    "Bcolor": "152",
    "Y": 25,
    "L": 57.2534698512537,
    "a": -15.0720532997626,
    "b": -9.49263967356009,
    "C": 17.8122710130666,
    "h": 0.56205593206179,
    "CMY_C": 0.6288099,
    "CMY_M": 0.428259,
    "CMY_Y": 0.4029588,
    "CMYK_C": 0.378284,
    "CMYK_M": 0.04237594,
    "CMYK_Y": 0,
    "CMYK_K": 0.4029588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07165",
    "Farbtonhilfsbezeichnung": "Q0.07.52",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "147",
    "Bcolor": "149",
    "Y": 28,
    "L": 59.7541575625547,
    "a": -5.94448192606939,
    "b": -3.86617718880256,
    "C": 7.0911347064192,
    "h": 0.57664290460891,
    "CMY_C": 0.4946248,
    "CMY_M": 0.4216774,
    "CMY_Y": 0.4145005,
    "CMYK_C": 0.1368477,
    "CMYK_M": 0.01225763,
    "CMYK_Y": 0,
    "CMYK_K": 0.4145005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07167",
    "Farbtonhilfsbezeichnung": "Q2.49.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "108",
    "Y": 8,
    "L": 37.1547431945801,
    "a": -19.5548496246338,
    "b": -13.8524217605591,
    "C": 23.9641761779785,
    "h": 215.31330871582,
    "CMY_C": 1,
    "CMY_M": 0.61983639001846,
    "CMY_Y": 0.57544565200806,
    "CMYK_C": 1,
    "CMYK_M": 0.10455843806267,
    "CMYK_Y": 0,
    "CMYK_K": 0.57544565200806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07168",
    "Farbtonhilfsbezeichnung": "Q2.44.30",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "99",
    "Bcolor": "113",
    "Y": 10,
    "L": 37.6462741533303,
    "a": -21.7042359300935,
    "b": -16.1185478489684,
    "C": 27.0348190685391,
    "h": 0.6387774317652,
    "CMY_C": 1,
    "CMY_M": 0.6113222,
    "CMY_Y": 0.5565783,
    "CMYK_C": 1,
    "CMYK_M": 0.1234579,
    "CMYK_Y": 0,
    "CMYK_K": 0.5565783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07169",
    "Farbtonhilfsbezeichnung": "Q4.30.30",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "97",
    "Bcolor": "107",
    "Y": 10,
    "L": 38.2422390475668,
    "a": -14.6313761552696,
    "b": -11.3054006895977,
    "C": 18.4902475091424,
    "h": 0.65786024498683,
    "CMY_C": 0.8297944,
    "CMY_M": 0.6176521,
    "CMY_Y": 0.5805626,
    "CMYK_C": 0.594205,
    "CMYK_M": 0.08842684,
    "CMYK_Y": 0,
    "CMYK_K": 0.5805626
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07170",
    "Farbtonhilfsbezeichnung": "Q0.20.31",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "98",
    "Bcolor": "103",
    "Y": 11,
    "L": 39.1397081472815,
    "a": -10.8978483957125,
    "b": -7.39396763118868,
    "C": 13.1694288785429,
    "h": 0.59613625021998,
    "CMY_C": 0.7532002,
    "CMY_M": 0.6162704,
    "CMY_Y": 0.5962307,
    "CMYK_C": 0.3887603,
    "CMYK_M": 0.04963144,
    "CMYK_Y": 0,
    "CMYK_K": 0.5962307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07171",
    "Farbtonhilfsbezeichnung": "Q5.18.43",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "129",
    "Bcolor": "137",
    "Y": 20,
    "L": 51.4199918503561,
    "a": -10.7253339736124,
    "b": -9.26110063262144,
    "C": 14.170418969567,
    "h": 0.71226745501372,
    "CMY_C": 0.642743,
    "CMY_M": 0.4955698,
    "CMY_Y": 0.4634266,
    "CMYK_C": 0.334188,
    "CMYK_M": 0.05990458,
    "CMYK_Y": 0,
    "CMYK_K": 0.4634266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07172",
    "Farbtonhilfsbezeichnung": "Q3.54.23",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "100",
    "Y": 7,
    "L": 32.133204472162,
    "a": -23.0366230371023,
    "b": -16.5785495096518,
    "C": 28.3819362411646,
    "h": 0.6237994794491,
    "CMY_C": 1,
    "CMY_M": 0.6621351,
    "CMY_Y": 0.6069972,
    "CMYK_C": 1,
    "CMYK_M": 0.1402989,
    "CMYK_Y": 0,
    "CMYK_K": 0.6069972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07173",
    "Farbtonhilfsbezeichnung": "Q4.47.22",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "103",
    "Y": 8,
    "L": 33.808721107868,
    "a": -20.0055754744505,
    "b": -15.5583630557077,
    "C": 25.3433563490937,
    "h": 0.66099554675524,
    "CMY_C": 1,
    "CMY_M": 0.6506683,
    "CMY_Y": 0.5970624,
    "CMYK_C": 1,
    "CMYK_M": 0.1330378,
    "CMYK_Y": 0,
    "CMYK_K": 0.5970624
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07174",
    "Farbtonhilfsbezeichnung": "Q0.46.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "87",
    "Bcolor": "97",
    "Y": 8,
    "L": 33.0170293498854,
    "a": -21.0753468066542,
    "b": -13.1959288549097,
    "C": 24.8656948699325,
    "h": 0.55941223544658,
    "CMY_C": 1,
    "CMY_M": 0.6573552,
    "CMY_Y": 0.6192659,
    "CMYK_C": 1,
    "CMYK_M": 0.1000419,
    "CMYK_Y": 0,
    "CMYK_K": 0.6192659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07175",
    "Farbtonhilfsbezeichnung": "Q5.36.25",
    "Farbtonklasse": "04",
    "Rcolor": "17",
    "Gcolor": "88",
    "Bcolor": "100",
    "Y": 8,
    "L": 33.972190781674,
    "a": -16.0004491937804,
    "b": -13.5120865422717,
    "C": 20.9425609018712,
    "h": 0.70128167032014,
    "CMY_C": 0.9320839,
    "CMY_M": 0.6555308,
    "CMY_Y": 0.6078681,
    "CMYK_C": 0.826803,
    "CMYK_M": 0.1215476,
    "CMYK_Y": 0,
    "CMYK_K": 0.6078681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07176",
    "Farbtonhilfsbezeichnung": "Q0.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "93",
    "Bcolor": "99",
    "Y": 10,
    "L": 37.3171042556907,
    "a": -10.8494652882118,
    "b": -7.58888359704113,
    "C": 13.2401680989915,
    "h": 0.61037067316247,
    "CMY_C": 0.7709926,
    "CMY_M": 0.6336817,
    "CMY_Y": 0.6123913,
    "CMYK_C": 0.4091789,
    "CMYK_M": 0.05492753,
    "CMYK_Y": 0,
    "CMYK_K": 0.6123913
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07177",
    "Farbtonhilfsbezeichnung": "Q0.09.37",
    "Farbtonklasse": "02",
    "Rcolor": "94",
    "Gcolor": "111",
    "Bcolor": "114",
    "Y": 15,
    "L": 45.4418376892136,
    "a": -5.28347087224818,
    "b": -4.43576013968023,
    "C": 6.89862540472165,
    "h": 0.69839839062414,
    "CMY_C": 0.6321593,
    "CMY_M": 0.5663028,
    "CMY_Y": 0.553667,
    "CMYK_C": 0.1758605,
    "CMYK_M": 0.0283104,
    "CMYK_Y": 0,
    "CMYK_K": 0.553667
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07178",
    "Farbtonhilfsbezeichnung": "Q1.10.27",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "88",
    "Bcolor": "90",
    "Y": 9,
    "L": 36.3123089421007,
    "a": -4.97499460088613,
    "b": -3.74186867219745,
    "C": 6.22512268463994,
    "h": 0.6448662513449,
    "CMY_C": 0.7126622,
    "CMY_M": 0.654452,
    "CMY_Y": 0.6452482,
    "CMYK_C": 0.1900315,
    "CMYK_M": 0.02594432,
    "CMYK_Y": 0,
    "CMYK_K": 0.6452482
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07180",
    "Farbtonhilfsbezeichnung": "T9.08.17",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "65",
    "Bcolor": "72",
    "Y": 5,
    "L": 27.0849993118077,
    "a": -0.50404274211071,
    "b": -5.92321115943101,
    "C": 5.94461853486685,
    "h": 1.48590464635075,
    "CMY_C": 0.7709832,
    "CMY_M": 0.74648,
    "CMY_Y": 0.7163844,
    "CMYK_C": 0.1925099,
    "CMYK_M": 0.1061141,
    "CMYK_Y": 0,
    "CMYK_K": 0.7163844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07181",
    "Farbtonhilfsbezeichnung": "Q1.44.17",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 6,
    "L": 29.6446298039449,
    "a": -14.6579154512132,
    "b": -10.7142395704324,
    "C": 18.1562500243727,
    "h": 0.63119883006111,
    "CMY_C": 0.9220834,
    "CMY_M": 0.6986759,
    "CMY_Y": 0.665562,
    "CMYK_C": 0.7670223,
    "CMYK_M": 0.09901386,
    "CMYK_Y": 0,
    "CMYK_K": 0.665562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07182",
    "Farbtonhilfsbezeichnung": "Q5.38.14",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "68",
    "Bcolor": "77",
    "Y": 5,
    "L": 26.5648257827096,
    "a": -10.8412124315415,
    "b": -9.85935903689919,
    "C": 14.6539703699815,
    "h": 0.73800246276386,
    "CMY_C": 0.8884102,
    "CMY_M": 0.7326948,
    "CMY_Y": 0.698697,
    "CMYK_C": 0.6296425,
    "CMYK_M": 0.1128359,
    "CMYK_Y": 0,
    "CMYK_K": 0.698697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07183",
    "Farbtonhilfsbezeichnung": "Q0.26.19",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "75",
    "Bcolor": "79",
    "Y": 6,
    "L": 29.7861458686209,
    "a": -10.6441030396894,
    "b": -6.51642009673764,
    "C": 12.4804110668155,
    "h": 0.54934867575365,
    "CMY_C": 0.8330842,
    "CMY_M": 0.7045846,
    "CMY_Y": 0.6892244,
    "CMYK_C": 0.4629058,
    "CMYK_M": 0.0494254,
    "CMYK_Y": 0,
    "CMYK_K": 0.6892244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07184",
    "Farbtonhilfsbezeichnung": "Q1.19.11",
    "Farbtonklasse": "03",
    "Rcolor": "39",
    "Gcolor": "55",
    "Bcolor": "57",
    "Y": 3,
    "L": 21.7544569346165,
    "a": -5.65065997787906,
    "b": -3.84186975807087,
    "C": 6.83300237257267,
    "h": 0.5971065845507,
    "CMY_C": 0.8467306,
    "CMY_M": 0.7848912,
    "CMY_Y": 0.7760921,
    "CMYK_C": 0.3154804,
    "CMYK_M": 0.03929794,
    "CMYK_Y": 0,
    "CMYK_K": 0.7760921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07185",
    "Farbtonhilfsbezeichnung": "Q5.14.16",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "66",
    "Bcolor": "70",
    "Y": 5,
    "L": 26.8054144275806,
    "a": -5.13067352023408,
    "b": -4.70472760843585,
    "C": 6.96119764414212,
    "h": 0.74211778127643,
    "CMY_C": 0.8027388,
    "CMY_M": 0.7410505,
    "CMY_Y": 0.7265184,
    "CMYK_C": 0.2787038,
    "CMYK_M": 0.05313735,
    "CMYK_Y": 0,
    "CMYK_K": 0.7265184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07186",
    "Farbtonhilfsbezeichnung": "Q0.17.11",
    "Farbtonklasse": "03",
    "Rcolor": "43",
    "Gcolor": "58",
    "Bcolor": "60",
    "Y": 4,
    "L": 23.13981625737,
    "a": -5.225788038657,
    "b": -3.7923561373527,
    "C": 6.45684332297814,
    "h": 0.62776708833491,
    "CMY_C": 0.8314931,
    "CMY_M": 0.7735257,
    "CMY_Y": 0.764284,
    "CMYK_C": 0.2851272,
    "CMYK_M": 0.03920685,
    "CMYK_Y": 0,
    "CMYK_K": 0.764284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07187",
    "Farbtonhilfsbezeichnung": "Q4.10.16",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 4,
    "L": 25.0190666364447,
    "a": -4.21828250186279,
    "b": -3.58860020192611,
    "C": 5.53822703351767,
    "h": 0.70491506391841,
    "CMY_C": 0.8070694,
    "CMY_M": 0.758749,
    "CMY_Y": 0.7488686,
    "CMYK_C": 0.2317543,
    "CMYK_M": 0.03934356,
    "CMYK_Y": 0,
    "CMYK_K": 0.7488686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07188",
    "Farbtonhilfsbezeichnung": "P5.06.16",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "60",
    "Bcolor": "61",
    "Y": 4,
    "L": 24.6835292152531,
    "a": -2.59488486039289,
    "b": -1.88853045781732,
    "C": 3.20935737006646,
    "h": 0.62913432728452,
    "CMY_C": 0.7926649,
    "CMY_M": 0.7649257,
    "CMY_Y": 0.7615685,
    "CMYK_C": 0.130421,
    "CMYK_M": 0.0140804,
    "CMYK_Y": 0,
    "CMYK_K": 0.7615685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07189",
    "Farbtonhilfsbezeichnung": "Q2.03.31",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "95",
    "Bcolor": "96",
    "Y": 11,
    "L": 39.7477173904949,
    "a": -1.94641992835579,
    "b": -1.9716701228113,
    "C": 2.77056557595868,
    "h": 0.79184259029233,
    "CMY_C": 0.6523846,
    "CMY_M": 0.6282128,
    "CMY_Y": 0.6236741,
    "CMYK_C": 0.07629167,
    "CMYK_M": 0.01206047,
    "CMYK_Y": 0,
    "CMYK_K": 0.6236741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07190",
    "Farbtonhilfsbezeichnung": "Q7.27.67",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "194",
    "Bcolor": "212",
    "Y": 47,
    "L": 73.945500955249,
    "a": -20.3469863107296,
    "b": -18.0242850385908,
    "C": 27.1822497796151,
    "h": 0.72493963555973,
    "CMY_C": 0.5699265,
    "CMY_M": 0.2394873,
    "CMY_Y": 0.1670327,
    "CMYK_C": 0.483685,
    "CMYK_M": 0.0869838,
    "CMYK_Y": 0,
    "CMYK_K": 0.1670327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07191",
    "Farbtonhilfsbezeichnung": "Q7.23.71",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "207",
    "Bcolor": "223",
    "Y": 55,
    "L": 79.0028158024173,
    "a": -18.0142760072366,
    "b": -16.0749964850139,
    "C": 24.1437290420952,
    "h": 0.72857114950785,
    "CMY_C": 0.4718256,
    "CMY_M": 0.1894255,
    "CMY_Y": 0.1252501,
    "CMYK_C": 0.3961995,
    "CMYK_M": 0.07336435,
    "CMYK_Y": 0,
    "CMYK_K": 0.1252501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07192",
    "Farbtonhilfsbezeichnung": "Q6.42.21",
    "Farbtonklasse": "04",
    "Rcolor": "3",
    "Gcolor": "79",
    "Bcolor": "93",
    "Y": 6,
    "L": 30.5487333311413,
    "a": -15.2321562657955,
    "b": -14.2056318876224,
    "C": 20.8283115454001,
    "h": 0.75054131217117,
    "CMY_C": 0.9875838,
    "CMY_M": 0.6884995,
    "CMY_Y": 0.636013,
    "CMYK_C": 0.9658884,
    "CMYK_M": 0.1441987,
    "CMYK_Y": 0,
    "CMYK_K": 0.636013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07193",
    "Farbtonhilfsbezeichnung": "Q8.39.20",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "81",
    "Bcolor": "93",
    "Y": 7,
    "L": 31.7515932205995,
    "a": -12.4477560030589,
    "b": -12.5393723738296,
    "C": 17.6686866812802,
    "h": 0.78906468957216,
    "CMY_C": 0.8800186,
    "CMY_M": 0.6820166,
    "CMY_Y": 0.6346269,
    "CMYK_C": 0.6716195,
    "CMYK_M": 0.1297023,
    "CMYK_Y": 0,
    "CMYK_K": 0.6346269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07194",
    "Farbtonhilfsbezeichnung": "Q9.33.15",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "65",
    "Bcolor": "74",
    "Y": 4,
    "L": 25.1979430598961,
    "a": -10.0535275462666,
    "b": -10.2412238115576,
    "C": 14.3511700318112,
    "h": 0.79464641240152,
    "CMY_C": 0.895135,
    "CMY_M": 0.7460577,
    "CMY_Y": 0.7088047,
    "CMYK_C": 0.6398808,
    "CMYK_M": 0.1279314,
    "CMYK_Y": 0,
    "CMYK_K": 0.7088047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07195",
    "Farbtonhilfsbezeichnung": "Q7.30.14",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "67",
    "Bcolor": "75",
    "Y": 5,
    "L": 26.8110214608958,
    "a": -7.92783854594273,
    "b": -7.90912622638735,
    "C": 11.1984330008918,
    "h": 0.78421660423403,
    "CMY_C": 0.8415183,
    "CMY_M": 0.7355539,
    "CMY_Y": 0.7077749,
    "CMYK_C": 0.4576727,
    "CMYK_M": 0.09506011,
    "CMYK_Y": 0,
    "CMYK_K": 0.7077749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07196",
    "Farbtonhilfsbezeichnung": "R4.08.60",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "170",
    "Bcolor": "175",
    "Y": 38,
    "L": 68.3162120529054,
    "a": -4.49320294643962,
    "b": -5.63010421848535,
    "C": 7.2032594170209,
    "h": 0.89723487688294,
    "CMY_C": 0.4021278,
    "CMY_M": 0.3350799,
    "CMY_Y": 0.3132507,
    "CMYK_C": 0.1294171,
    "CMYK_M": 0.03178628,
    "CMYK_Y": 0,
    "CMYK_K": 0.3132507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07197",
    "Farbtonhilfsbezeichnung": "Q6.48.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "91",
    "Bcolor": "108",
    "Y": 8,
    "L": 34.6864175667639,
    "a": -19.7247860947632,
    "b": -17.7458300353031,
    "C": 26.5326529040356,
    "h": 0.73263364044906,
    "CMY_C": 1,
    "CMY_M": 0.6420739,
    "CMY_Y": 0.5750105,
    "CMYK_C": 1,
    "CMYK_M": 0.1578002,
    "CMYK_Y": 0,
    "CMYK_K": 0.5750105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07198",
    "Farbtonhilfsbezeichnung": "Q7.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "89",
    "Bcolor": "102",
    "Y": 8,
    "L": 34.3583736256929,
    "a": -15.32390478272,
    "b": -13.9683478913185,
    "C": 20.7349174245467,
    "h": 0.73915417937166,
    "CMY_C": 0.9172134,
    "CMY_M": 0.6527781,
    "CMY_Y": 0.6013076,
    "CMYK_C": 0.7923547,
    "CMYK_M": 0.1290984,
    "CMYK_Y": 0,
    "CMYK_K": 0.6013076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07200",
    "Farbtonhilfsbezeichnung": "Q5.34.21",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "80",
    "Bcolor": "90",
    "Y": 7,
    "L": 31.4091173585173,
    "a": -12.2217932734722,
    "b": -10.8369786019461,
    "C": 16.3343912050167,
    "h": 0.72541433604602,
    "CMY_C": 0.8651127,
    "CMY_M": 0.6860192,
    "CMY_Y": 0.6481975,
    "CMYK_C": 0.6165824,
    "CMYK_M": 0.1075085,
    "CMYK_Y": 0,
    "CMYK_K": 0.6481975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07201",
    "Farbtonhilfsbezeichnung": "Q8.19.21",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "76",
    "Bcolor": "83",
    "Y": 7,
    "L": 30.9975066903732,
    "a": -6.57357735602873,
    "b": -6.86596505266823,
    "C": 9.5054403033292,
    "h": 0.80715050960553,
    "CMY_C": 0.7866084,
    "CMY_M": 0.700097,
    "CMY_Y": 0.6756337,
    "CMYK_C": 0.3421278,
    "CMYK_M": 0.07541876,
    "CMYK_Y": 0,
    "CMYK_K": 0.6756337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07202",
    "Farbtonhilfsbezeichnung": "Q7.15.16",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "64",
    "Bcolor": "69",
    "Y": 5,
    "L": 26.0939261764931,
    "a": -4.77118544900021,
    "b": -5.34128791240842,
    "C": 7.16195274712083,
    "h": 0.84171471544098,
    "CMY_C": 0.808751,
    "CMY_M": 0.7478479,
    "CMY_Y": 0.7291027,
    "CMYK_C": 0.2940167,
    "CMYK_M": 0.06919662,
    "CMYK_Y": 0,
    "CMYK_K": 0.7291027
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07203",
    "Farbtonhilfsbezeichnung": "Q4.09.16",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "67",
    "Bcolor": "69",
    "Y": 5,
    "L": 27.4613536359378,
    "a": -3.18479564858962,
    "b": -3.3064880070799,
    "C": 4.5908372073336,
    "h": 0.80414300827378,
    "CMY_C": 0.7773371,
    "CMY_M": 0.7389145,
    "CMY_Y": 0.7287285,
    "CMYK_C": 0.1791878,
    "CMYK_M": 0.03754931,
    "CMYK_Y": 0,
    "CMYK_K": 0.7287285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07204",
    "Farbtonhilfsbezeichnung": "Q6.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "85",
    "Bcolor": "87",
    "Y": 9,
    "L": 35.6325503335172,
    "a": -2.63703504705426,
    "b": -2.44024125106612,
    "C": 3.59287227755138,
    "h": 0.74665783800046,
    "CMY_C": 0.6970704,
    "CMY_M": 0.6654819,
    "CMY_Y": 0.6593974,
    "CMYK_C": 0.110607,
    "CMYK_M": 0.01786412,
    "CMYK_Y": 0,
    "CMYK_K": 0.6593974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07205",
    "Farbtonhilfsbezeichnung": "Q8.43.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "92",
    "Bcolor": "110",
    "Y": 9,
    "L": 35.3429605419796,
    "a": -17.3472865099239,
    "b": -17.413964373859,
    "C": 24.5799614416178,
    "h": 0.78731632745837,
    "CMY_C": 1,
    "CMY_M": 0.6393842,
    "CMY_Y": 0.570554,
    "CMYK_C": 1,
    "CMYK_M": 0.1602767,
    "CMYK_Y": 0,
    "CMYK_K": 0.570554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07206",
    "Farbtonhilfsbezeichnung": "Q6.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "6",
    "Gcolor": "99",
    "Bcolor": "115",
    "Y": 10,
    "L": 38.3689934035718,
    "a": -17.8465692151069,
    "b": -16.4197568557036,
    "C": 24.2509473619079,
    "h": 0.74378329603548,
    "CMY_C": 0.9772569,
    "CMY_M": 0.609948,
    "CMY_Y": 0.5473431,
    "CMYK_C": 0.9497564,
    "CMYK_M": 0.1383053,
    "CMYK_Y": 0,
    "CMYK_K": 0.5473431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07207",
    "Farbtonhilfsbezeichnung": "Q9.31.27",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "94",
    "Bcolor": "106",
    "Y": 10,
    "L": 37.1694124993108,
    "a": -12.0238475554968,
    "b": -12.5047134181939,
    "C": 17.347644442661,
    "h": 0.80499997671884,
    "CMY_C": 0.8169807,
    "CMY_M": 0.6317837,
    "CMY_Y": 0.5831689,
    "CMYK_C": 0.5609269,
    "CMYK_M": 0.1166295,
    "CMYK_Y": 0,
    "CMYK_K": 0.5831689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07208",
    "Farbtonhilfsbezeichnung": "Q8.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "85",
    "Bcolor": "94",
    "Y": 8,
    "L": 34.1300540731516,
    "a": -9.51721775201328,
    "b": -9.68523556422149,
    "C": 13.578704712663,
    "h": 0.79414774981071,
    "CMY_C": 0.7997679,
    "CMY_M": 0.6653799,
    "CMY_Y": 0.6294596,
    "CMYK_C": 0.4596212,
    "CMYK_M": 0.09694038,
    "CMYK_Y": 0,
    "CMYK_K": 0.6294596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07210",
    "Farbtonhilfsbezeichnung": "Q5.20.25",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "86",
    "Bcolor": "93",
    "Y": 8,
    "L": 34.6494548648963,
    "a": -8.26110831936977,
    "b": -7.64818408389097,
    "C": 11.2579141249809,
    "h": 0.74689102919526,
    "CMY_C": 0.7718747,
    "CMY_M": 0.6631968,
    "CMY_Y": 0.6370079,
    "CMYK_C": 0.3715418,
    "CMYK_M": 0.07214724,
    "CMYK_Y": 0,
    "CMYK_K": 0.6370079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07211",
    "Farbtonhilfsbezeichnung": "Q5.10.21",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "72",
    "Bcolor": "75",
    "Y": 6,
    "L": 29.4038620872897,
    "a": -4.43000143795522,
    "b": -4.10543046379565,
    "C": 6.03982384125122,
    "h": 0.74739016681892,
    "CMY_C": 0.7722185,
    "CMY_M": 0.7190356,
    "CMY_Y": 0.70661,
    "CMYK_C": 0.2236221,
    "CMYK_M": 0.04235201,
    "CMYK_Y": 0,
    "CMYK_K": 0.70661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07212",
    "Farbtonhilfsbezeichnung": "Q8.05.29",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "90",
    "Bcolor": "92",
    "Y": 10,
    "L": 37.5003479194115,
    "a": -2.61820199320736,
    "b": -3.07140451347895,
    "C": 4.03590229845246,
    "h": 0.8648847947042,
    "CMY_C": 0.6818398,
    "CMY_M": 0.647871,
    "CMY_Y": 0.6380342,
    "CMYK_C": 0.1210211,
    "CMYK_M": 0.02717603,
    "CMYK_Y": 0,
    "CMYK_K": 0.6380342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07213",
    "Farbtonhilfsbezeichnung": "Q8.50.31",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "106",
    "Bcolor": "126",
    "Y": 11,
    "L": 40.322530862297,
    "a": -20.6915605602601,
    "b": -19.9912978792693,
    "C": 28.7713862946607,
    "h": 0.76818714227648,
    "CMY_C": 1,
    "CMY_M": 0.5856258,
    "CMY_Y": 0.5055685,
    "CMYK_C": 1,
    "CMYK_M": 0.1619178,
    "CMYK_Y": 0,
    "CMYK_K": 0.5055685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07215",
    "Farbtonhilfsbezeichnung": "Q6.41.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "111",
    "Bcolor": "128",
    "Y": 13,
    "L": 42.5271049661821,
    "a": -21.055491141756,
    "b": -17.8774273139501,
    "C": 27.6212982060246,
    "h": 0.70394952784716,
    "CMY_C": 1,
    "CMY_M": 0.5641174,
    "CMY_Y": 0.4971918,
    "CMYK_C": 1,
    "CMYK_M": 0.1331035,
    "CMYK_Y": 0,
    "CMYK_K": 0.4971918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07216",
    "Farbtonhilfsbezeichnung": "Q6.34.30",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "99",
    "Bcolor": "112",
    "Y": 10,
    "L": 38.6584503969559,
    "a": -15.2327451499361,
    "b": -13.7676432432199,
    "C": 20.5325235973438,
    "h": 0.73492099933774,
    "CMY_C": 0.8574256,
    "CMY_M": 0.6120009,
    "CMY_Y": 0.5610672,
    "CMYK_C": 0.6751795,
    "CMYK_M": 0.11604,
    "CMYK_Y": 0,
    "CMYK_K": 0.5610672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07217",
    "Farbtonhilfsbezeichnung": "Q9.29.31",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "104",
    "Bcolor": "116",
    "Y": 12,
    "L": 41.4527502535011,
    "a": -11.3184032403164,
    "b": -11.6594884546989,
    "C": 16.2496130087969,
    "h": 0.80024113376008,
    "CMY_C": 0.7602234,
    "CMY_M": 0.5921175,
    "CMY_Y": 0.5468599,
    "CMYK_C": 0.4708557,
    "CMYK_M": 0.09987561,
    "CMYK_Y": 0,
    "CMYK_K": 0.5468599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07218",
    "Farbtonhilfsbezeichnung": "Q6.27.34",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "108",
    "Bcolor": "118",
    "Y": 13,
    "L": 42.9283393892354,
    "a": -13.2330744636185,
    "b": -11.0749878890465,
    "C": 17.2560023325856,
    "h": 0.69684963216482,
    "CMY_C": 0.7628965,
    "CMY_M": 0.5746856,
    "CMY_Y": 0.5363052,
    "CMYK_C": 0.4886647,
    "CMYK_M": 0.08277077,
    "CMYK_Y": 0,
    "CMYK_K": 0.5363052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07219",
    "Farbtonhilfsbezeichnung": "Q8.20.30",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "97",
    "Bcolor": "105",
    "Y": 11,
    "L": 38.9416433134084,
    "a": -8.81311717176666,
    "b": -9.07590440939225,
    "C": 12.6508132201734,
    "h": 0.80008696772463,
    "CMY_C": 0.7442463,
    "CMY_M": 0.621309,
    "CMY_Y": 0.5873524,
    "CMYK_C": 0.3802128,
    "CMYK_M": 0.08228963,
    "CMYK_Y": 0,
    "CMYK_K": 0.5873524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07220",
    "Farbtonhilfsbezeichnung": "Q4.15.30",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "95",
    "Bcolor": "101",
    "Y": 10,
    "L": 38.6502306758344,
    "a": -7.56427178203944,
    "b": -6.58336430484819,
    "C": 10.0279057216803,
    "h": 0.71617527718436,
    "CMY_C": 0.7236794,
    "CMY_M": 0.626962,
    "CMY_Y": 0.6056912,
    "CMYK_C": 0.2992279,
    "CMYK_M": 0.05394445,
    "CMYK_Y": 0,
    "CMYK_K": 0.6056912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07221",
    "Farbtonhilfsbezeichnung": "Q6.03.33",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "100",
    "Bcolor": "102",
    "Y": 12,
    "L": 41.8416775367112,
    "a": -1.91352182857679,
    "b": -2.3224435331153,
    "C": 3.00920417269234,
    "h": 0.88163561110084,
    "CMY_C": 0.6335494,
    "CMY_M": 0.6082202,
    "CMY_Y": 0.6015593,
    "CMYK_C": 0.08028828,
    "CMYK_M": 0.01671742,
    "CMYK_Y": 0,
    "CMYK_K": 0.6015593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07222",
    "Farbtonhilfsbezeichnung": "Q6.49.32",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "128",
    "Y": 12,
    "L": 40.6987566940796,
    "a": -22.650216607678,
    "b": -20.4570412481905,
    "C": 30.5208592442104,
    "h": 0.73456482193667,
    "CMY_C": 1,
    "CMY_M": 0.5789227,
    "CMY_Y": 0.4989734,
    "CMYK_C": 1,
    "CMYK_M": 0.1595711,
    "CMYK_Y": 0,
    "CMYK_K": 0.4989734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07223",
    "Farbtonhilfsbezeichnung": "Q8.45.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "134",
    "Y": 13,
    "L": 43.1604199789671,
    "a": -20.835540465948,
    "b": -20.1184196163081,
    "C": 28.9632621499376,
    "h": 0.76788953740794,
    "CMY_C": 1,
    "CMY_M": 0.5575171,
    "CMY_Y": 0.4763775,
    "CMYK_C": 1,
    "CMYK_M": 0.1549581,
    "CMYK_Y": 0,
    "CMYK_K": 0.4763775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07224",
    "Farbtonhilfsbezeichnung": "Q8.36.37",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "119",
    "Bcolor": "136",
    "Y": 15,
    "L": 46.1237246361309,
    "a": -17.2137973989069,
    "b": -16.7284147969376,
    "C": 24.0032223359493,
    "h": 0.77109887386648,
    "CMY_C": 0.8338789,
    "CMY_M": 0.5349579,
    "CMY_Y": 0.4682972,
    "CMYK_C": 0.6875677,
    "CMYK_M": 0.1253722,
    "CMYK_Y": 0,
    "CMYK_K": 0.4682972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07225",
    "Farbtonhilfsbezeichnung": "Q9.29.41",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "125",
    "Bcolor": "141",
    "Y": 18,
    "L": 49.012472942589,
    "a": -14.4258023089694,
    "b": -15.3262063228277,
    "C": 21.0474790059843,
    "h": 0.81565256693315,
    "CMY_C": 0.7457011,
    "CMY_M": 0.5113015,
    "CMY_Y": 0.4480647,
    "CMYK_C": 0.5392597,
    "CMYK_M": 0.1145729,
    "CMYK_Y": 0,
    "CMYK_K": 0.4480647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07226",
    "Farbtonhilfsbezeichnung": "Q8.25.34",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "108",
    "Bcolor": "119",
    "Y": 13,
    "L": 42.8841014656635,
    "a": -11.36507493367,
    "b": -11.701827840159,
    "C": 16.3125014344414,
    "h": 0.7999960913822,
    "CMY_C": 0.746892,
    "CMY_M": 0.5781359,
    "CMY_Y": 0.532557,
    "CMYK_C": 0.4585267,
    "CMYK_M": 0.09750701,
    "CMYK_Y": 0,
    "CMYK_K": 0.532557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07227",
    "Farbtonhilfsbezeichnung": "Q8.22.41",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "123",
    "Bcolor": "134",
    "Y": 18,
    "L": 49.2363283402583,
    "a": -11.1857117938633,
    "b": -11.1354553930664,
    "C": 15.7834886874336,
    "h": 0.78314665408099,
    "CMY_C": 0.6789633,
    "CMY_M": 0.5160401,
    "CMY_Y": 0.4730759,
    "CMYK_C": 0.3907345,
    "CMYK_M": 0.08153778,
    "CMYK_Y": 0,
    "CMYK_K": 0.4730759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07229",
    "Farbtonhilfsbezeichnung": "Q7.05.39",
    "Farbtonklasse": "02",
    "Rcolor": "105",
    "Gcolor": "114",
    "Bcolor": "116",
    "Y": 16,
    "L": 47.3317521395925,
    "a": -2.51043532172096,
    "b": -3.07536413690916,
    "C": 3.96990555040435,
    "h": 0.88619204412262,
    "CMY_C": 0.5878595,
    "CMY_M": 0.5536214,
    "CMY_Y": 0.543725,
    "CMYK_C": 0.09672779,
    "CMYK_M": 0.02168955,
    "CMYK_Y": 0,
    "CMYK_K": 0.543725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07230",
    "Farbtonhilfsbezeichnung": "Q6.46.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "133",
    "Y": 13,
    "L": 43.2461981302604,
    "a": -22.8370605804481,
    "b": -19.7811616118233,
    "C": 30.2130053233393,
    "h": 0.71381662766513,
    "CMY_C": 1,
    "CMY_M": 0.5537635,
    "CMY_Y": 0.4778372,
    "CMYK_C": 1,
    "CMYK_M": 0.1454073,
    "CMYK_Y": 0,
    "CMYK_K": 0.4778372
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07231",
    "Farbtonhilfsbezeichnung": "Q8.40.40",
    "Farbtonklasse": "04",
    "Rcolor": "19",
    "Gcolor": "126",
    "Bcolor": "146",
    "Y": 17,
    "L": 48.5787376569631,
    "a": -20.4848940008571,
    "b": -19.4682568699399,
    "C": 28.260288529672,
    "h": 0.75995792214507,
    "CMY_C": 0.9251249,
    "CMY_M": 0.5042822,
    "CMY_Y": 0.4256797,
    "CMYK_C": 0.8696283,
    "CMYK_M": 0.1368618,
    "CMYK_Y": 0,
    "CMYK_K": 0.4256797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07232",
    "Farbtonhilfsbezeichnung": "Q9.30.45",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "135",
    "Bcolor": "153",
    "Y": 21,
    "L": 52.7301323689436,
    "a": -16.2652522327426,
    "b": -16.9718033823272,
    "C": 23.5074571198824,
    "h": 0.8066528965637,
    "CMY_C": 0.7436286,
    "CMY_M": 0.4701562,
    "CMY_Y": 0.3993271,
    "CMYK_C": 0.573193,
    "CMYK_M": 0.1179163,
    "CMYK_Y": 0,
    "CMYK_K": 0.3993271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07233",
    "Farbtonhilfsbezeichnung": "Q9.27.43",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "132",
    "Bcolor": "147",
    "Y": 20,
    "L": 52.056446459824,
    "a": -13.591280539238,
    "b": -14.3610089053162,
    "C": 19.7727459770979,
    "h": 0.81292842687665,
    "CMY_C": 0.6965596,
    "CMY_M": 0.4824769,
    "CMY_Y": 0.4234024,
    "CMYK_C": 0.4737398,
    "CMYK_M": 0.1024537,
    "CMYK_Y": 0,
    "CMYK_K": 0.4234024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07234",
    "Farbtonhilfsbezeichnung": "Q6.20.44",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "132",
    "Bcolor": "141",
    "Y": 20,
    "L": 52.3807015346367,
    "a": -12.0433529370705,
    "b": -10.5516111985847,
    "C": 16.0118346498127,
    "h": 0.71947285394464,
    "CMY_C": 0.6529937,
    "CMY_M": 0.4831154,
    "CMY_Y": 0.4452859,
    "CMYK_C": 0.3744411,
    "CMYK_M": 0.06819638,
    "CMYK_Y": 0,
    "CMYK_K": 0.4452859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07235",
    "Farbtonhilfsbezeichnung": "Q8.15.44",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "130",
    "Bcolor": "139",
    "Y": 21,
    "L": 52.5284981318137,
    "a": -8.66732542718945,
    "b": -8.58905039426558,
    "C": 12.202225892682,
    "h": 0.78086218800523,
    "CMY_C": 0.6096179,
    "CMY_M": 0.4884779,
    "CMY_Y": 0.456497,
    "CMYK_C": 0.2817296,
    "CMYK_M": 0.058842,
    "CMYK_Y": 0,
    "CMYK_K": 0.456497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07236",
    "Farbtonhilfsbezeichnung": "Q5.10.44",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "129",
    "Bcolor": "134",
    "Y": 21,
    "L": 52.7662218465235,
    "a": -5.9475631166811,
    "b": -5.3067827190407,
    "C": 7.97091273657004,
    "h": 0.72852330486931,
    "CMY_C": 0.5698839,
    "CMY_M": 0.4922671,
    "CMY_Y": 0.4756132,
    "CMYK_C": 0.1797733,
    "CMYK_M": 0.03175883,
    "CMYK_Y": 0,
    "CMYK_K": 0.4756132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07237",
    "Farbtonhilfsbezeichnung": "Q6.04.47",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "135",
    "Bcolor": "136",
    "Y": 23,
    "L": 55.47621316079,
    "a": -2.83787631686711,
    "b": -2.27159547435216,
    "C": 3.63506368430216,
    "h": 0.67501900417115,
    "CMY_C": 0.5073962,
    "CMY_M": 0.4720807,
    "CMY_Y": 0.468288,
    "CMYK_C": 0.07355134,
    "CMYK_M": 0.007132949,
    "CMYK_Y": 0,
    "CMYK_K": 0.468288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07238",
    "Farbtonhilfsbezeichnung": "Q7.49.41",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "155",
    "Y": 18,
    "L": 48.9835736045484,
    "a": -25.9558112883647,
    "b": -23.9207690116013,
    "C": 35.2974125077686,
    "h": 0.74461922264826,
    "CMY_C": 1,
    "CMY_M": 0.4902856,
    "CMY_Y": 0.3924783,
    "CMYK_C": 1,
    "CMYK_M": 0.1609938,
    "CMYK_Y": 0,
    "CMYK_K": 0.3924783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07239",
    "Farbtonhilfsbezeichnung": "Q7.41.43",
    "Farbtonklasse": "04",
    "Rcolor": "5",
    "Gcolor": "134",
    "Bcolor": "157",
    "Y": 20,
    "L": 51.4266385480737,
    "a": -21.9553876618813,
    "b": -21.08473659239,
    "C": 30.4401899559441,
    "h": 0.76517209864085,
    "CMY_C": 0.9795223,
    "CMY_M": 0.4726031,
    "CMY_Y": 0.3857892,
    "CMYK_C": 0.9666603,
    "CMYK_M": 0.1413423,
    "CMYK_Y": 0,
    "CMYK_K": 0.3857892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07240",
    "Farbtonhilfsbezeichnung": "Q6.26.49",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "146",
    "Bcolor": "159",
    "Y": 25,
    "L": 56.8701544099788,
    "a": -16.2647601660617,
    "b": -13.7224332138624,
    "C": 21.2802160836872,
    "h": 0.70081999442048,
    "CMY_C": 0.6731032,
    "CMY_M": 0.4288326,
    "CMY_Y": 0.3784221,
    "CMYK_C": 0.4740855,
    "CMYK_M": 0.08110088,
    "CMYK_Y": 0,
    "CMYK_K": 0.3784221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07241",
    "Farbtonhilfsbezeichnung": "Q9.22.53",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "156",
    "Bcolor": "169",
    "Y": 29,
    "L": 61.1664574045008,
    "a": -13.4048713742188,
    "b": -13.3081301107892,
    "C": 18.8890683625488,
    "h": 0.78177667441737,
    "CMY_C": 0.5937568,
    "CMY_M": 0.3897717,
    "CMY_Y": 0.3362223,
    "CMYK_C": 0.387983,
    "CMYK_M": 0.08067365,
    "CMYK_Y": 0,
    "CMYK_K": 0.3362223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07243",
    "Farbtonhilfsbezeichnung": "Q8.10.49",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "140",
    "Bcolor": "147",
    "Y": 25,
    "L": 56.8044627858646,
    "a": -6.69264311550238,
    "b": -6.72795954016061,
    "C": 9.48983200301879,
    "h": 0.78802966542791,
    "CMY_C": 0.5419114,
    "CMY_M": 0.4495628,
    "CMY_Y": 0.425346,
    "CMYK_C": 0.2028444,
    "CMYK_M": 0.04214157,
    "CMYK_Y": 0,
    "CMYK_K": 0.425346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07244",
    "Farbtonhilfsbezeichnung": "Q6.10.53",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "151",
    "Bcolor": "157",
    "Y": 29,
    "L": 60.9920567267102,
    "a": -6.97041337968923,
    "b": -6.47559236127129,
    "C": 9.51419776508276,
    "h": 0.74861416722451,
    "CMY_C": 0.5011334,
    "CMY_M": 0.4061216,
    "CMY_Y": 0.3841093,
    "CMYK_C": 0.1900079,
    "CMYK_M": 0.03574063,
    "CMYK_Y": 0,
    "CMYK_K": 0.3841093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07245",
    "Farbtonhilfsbezeichnung": "Q9.39.51",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "153",
    "Bcolor": "178",
    "Y": 26,
    "L": 58.1869563046451,
    "a": -22.7589019809071,
    "b": -23.2438595831142,
    "C": 32.5306721064301,
    "h": 0.79593969660378,
    "CMY_C": 0.8941554,
    "CMY_M": 0.4010237,
    "CMY_Y": 0.3004753,
    "CMYK_C": 0.8486907,
    "CMYK_M": 0.1437382,
    "CMYK_Y": 0,
    "CMYK_K": 0.3004753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07246",
    "Farbtonhilfsbezeichnung": "Q8.32.48",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "146",
    "Bcolor": "164",
    "Y": 24,
    "L": 56.3778955411956,
    "a": -18.3978848803792,
    "b": -17.7272776223506,
    "C": 25.5487483053784,
    "h": 0.76683685607611,
    "CMY_C": 0.7401065,
    "CMY_M": 0.4289304,
    "CMY_Y": 0.3566354,
    "CMYK_C": 0.5960401,
    "CMYK_M": 0.1123703,
    "CMYK_Y": 0,
    "CMYK_K": 0.3566354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07247",
    "Farbtonhilfsbezeichnung": "Q8.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "151",
    "Bcolor": "168",
    "Y": 26,
    "L": 58.3308686941863,
    "a": -18.0308562304141,
    "b": -17.2658280527138,
    "C": 24.9643865285679,
    "h": 0.763727334232,
    "CMY_C": 0.7080588,
    "CMY_M": 0.4095504,
    "CMY_Y": 0.3393257,
    "CMYK_C": 0.5581164,
    "CMYK_M": 0.1062924,
    "CMYK_Y": 0,
    "CMYK_K": 0.3393257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07248",
    "Farbtonhilfsbezeichnung": "Q6.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "156",
    "Bcolor": "167",
    "Y": 30,
    "L": 61.3189760048782,
    "a": -13.8011681950382,
    "b": -11.599029692618,
    "C": 18.0280263300775,
    "h": 0.69891671895923,
    "CMY_C": 0.5862435,
    "CMY_M": 0.3879468,
    "CMY_Y": 0.3463786,
    "CMYK_C": 0.3669784,
    "CMYK_M": 0.06359664,
    "CMYK_Y": 0,
    "CMYK_K": 0.3463786
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07249",
    "Farbtonhilfsbezeichnung": "Q6.15.59",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "168",
    "Bcolor": "178",
    "Y": 36,
    "L": 66.5819654727729,
    "a": -10.7387611817523,
    "b": -9.84867350835219,
    "C": 14.5711139448166,
    "h": 0.74219056045009,
    "CMY_C": 0.4929183,
    "CMY_M": 0.3392685,
    "CMY_Y": 0.30285,
    "CMYK_C": 0.2726362,
    "CMYK_M": 0.05223915,
    "CMYK_Y": 0,
    "CMYK_K": 0.30285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07250",
    "Farbtonhilfsbezeichnung": "Q9.15.57",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "162",
    "Bcolor": "171",
    "Y": 33,
    "L": 64.2814385795198,
    "a": -9.50531821273171,
    "b": -9.61951389628182,
    "C": 13.5235395487294,
    "h": 0.79136916098652,
    "CMY_C": 0.5040573,
    "CMY_M": 0.3659449,
    "CMY_Y": 0.328538,
    "CMYK_C": 0.2613987,
    "CMYK_M": 0.05570958,
    "CMYK_Y": 0,
    "CMYK_K": 0.328538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07252",
    "Farbtonhilfsbezeichnung": "Q5.05.69",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "192",
    "Bcolor": "194",
    "Y": 51,
    "L": 76.503148306566,
    "a": -5.04449803121138,
    "b": -3.6430716557081,
    "C": 6.22245381465537,
    "h": 0.62546199028014,
    "CMY_C": 0.312933,
    "CMY_M": 0.2471456,
    "CMY_Y": 0.2402716,
    "CMYK_C": 0.09564126,
    "CMYK_M": 0.009047901,
    "CMYK_Y": 0,
    "CMYK_K": 0.2402716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07253",
    "Farbtonhilfsbezeichnung": "Q7.39.52",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "160",
    "Bcolor": "182",
    "Y": 29,
    "L": 60.7869495722589,
    "a": -25.0630448849285,
    "b": -21.3814348631101,
    "C": 32.9442252255135,
    "h": 0.70629451641399,
    "CMY_C": 0.8735867,
    "CMY_M": 0.3705972,
    "CMY_Y": 0.285829,
    "CMYK_C": 0.822993,
    "CMYK_M": 0.1186946,
    "CMYK_Y": 0,
    "CMYK_K": 0.285829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07254",
    "Farbtonhilfsbezeichnung": "Q7.36.55",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "167",
    "Bcolor": "189",
    "Y": 32,
    "L": 63.6065514743458,
    "a": -22.8931269254222,
    "b": -20.9105695192569,
    "C": 31.0055991402064,
    "h": 0.74016898205775,
    "CMY_C": 0.7630963,
    "CMY_M": 0.3447083,
    "CMY_Y": 0.2588223,
    "CMYK_C": 0.6803685,
    "CMYK_M": 0.1158777,
    "CMYK_Y": 0,
    "CMYK_K": 0.2588223
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07255",
    "Farbtonhilfsbezeichnung": "Q7.28.57",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "168",
    "Bcolor": "185",
    "Y": 33,
    "L": 64.5416013623773,
    "a": -19.1459887740348,
    "b": -17.0416136696528,
    "C": 25.6317280455525,
    "h": 0.72731175568347,
    "CMY_C": 0.6516596,
    "CMY_M": 0.3426741,
    "CMY_Y": 0.2753502,
    "CMYK_C": 0.5192983,
    "CMYK_M": 0.09290543,
    "CMYK_Y": 0,
    "CMYK_K": 0.2753502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07256",
    "Farbtonhilfsbezeichnung": "Q7.20.62",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "178",
    "Bcolor": "191",
    "Y": 40,
    "L": 69.5196942199554,
    "a": -14.1984524851864,
    "b": -12.9029885799199,
    "C": 19.1854936675509,
    "h": 0.73763396565083,
    "CMY_C": 0.5125816,
    "CMY_M": 0.3004105,
    "CMY_Y": 0.2505891,
    "CMYK_C": 0.3495979,
    "CMYK_M": 0.06648074,
    "CMYK_Y": 0,
    "CMYK_K": 0.2505891
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07257",
    "Farbtonhilfsbezeichnung": "Q6.14.64",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "183",
    "Bcolor": "191",
    "Y": 44,
    "L": 72.0072602737293,
    "a": -10.3630531539623,
    "b": -8.85607585498154,
    "C": 13.6316891917706,
    "h": 0.70714798588024,
    "CMY_C": 0.4283482,
    "CMY_M": 0.2826993,
    "CMY_Y": 0.2520548,
    "CMYK_C": 0.2357036,
    "CMYK_M": 0.04097159,
    "CMYK_Y": 0,
    "CMYK_K": 0.2520548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07258",
    "Farbtonhilfsbezeichnung": "Q6.10.64",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "181",
    "Bcolor": "187",
    "Y": 43,
    "L": 71.7603695237126,
    "a": -8.30490171640902,
    "b": -7.03850234797074,
    "C": 10.8863174591596,
    "h": 0.7030477712999,
    "CMY_C": 0.4043089,
    "CMY_M": 0.2901111,
    "CMY_Y": 0.267296,
    "CMYK_C": 0.1869962,
    "CMYK_M": 0.03113824,
    "CMYK_Y": 0,
    "CMYK_K": 0.267296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07259",
    "Farbtonhilfsbezeichnung": "Q8.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "217",
    "Bcolor": "219",
    "Y": 66,
    "L": 85.20951917765,
    "a": -5.46738049793799,
    "b": -4.48515215986067,
    "C": 7.07169282465914,
    "h": 0.68702542546933,
    "CMY_C": 0.2261572,
    "CMY_M": 0.1509793,
    "CMY_Y": 0.1396628,
    "CMYK_C": 0.1005355,
    "CMYK_M": 0.01315358,
    "CMYK_Y": 0,
    "CMYK_K": 0.1396628
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07260",
    "Farbtonhilfsbezeichnung": "Q3.03.75",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "209",
    "Bcolor": "210",
    "Y": 62,
    "L": 83.0295093788627,
    "a": -2.91065808473162,
    "b": -2.46159815407272,
    "C": 3.81200681509724,
    "h": 0.70200332847485,
    "CMY_C": 0.2209888,
    "CMY_M": 0.1812856,
    "CMY_Y": 0.1779303,
    "CMYK_C": 0.0523782,
    "CMYK_M": 0.004081534,
    "CMYK_Y": 0,
    "CMYK_K": 0.1779303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07261",
    "Farbtonhilfsbezeichnung": "Q5.32.54",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "163",
    "Bcolor": "181",
    "Y": 31,
    "L": 62.2904936687497,
    "a": -21.8282402498837,
    "b": -18.344523869955,
    "C": 28.5130431280492,
    "h": 0.69889620006151,
    "CMY_C": 0.7300929,
    "CMY_M": 0.3612421,
    "CMY_Y": 0.2905105,
    "CMYK_C": 0.6195756,
    "CMYK_M": 0.09969363,
    "CMYK_Y": 0,
    "CMYK_K": 0.2905105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07262",
    "Farbtonhilfsbezeichnung": "Q8.30.59",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "175",
    "Bcolor": "196",
    "Y": 37,
    "L": 66.9768662868857,
    "a": -20.2322491663257,
    "b": -19.5242220188738,
    "C": 28.1165280888406,
    "h": 0.76759094140398,
    "CMY_C": 0.6607088,
    "CMY_M": 0.314109,
    "CMY_Y": 0.2320571,
    "CMYK_C": 0.5581818,
    "CMYK_M": 0.1068463,
    "CMYK_Y": 0,
    "CMYK_K": 0.2320571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07263",
    "Farbtonhilfsbezeichnung": "Q9.18.69",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "196",
    "Bcolor": "209",
    "Y": 50,
    "L": 76.0676763368377,
    "a": -12.9219519187648,
    "b": -12.6829761854176,
    "C": 18.106206844912,
    "h": 0.77606524147713,
    "CMY_C": 0.4292472,
    "CMY_M": 0.2326191,
    "CMY_Y": 0.1812712,
    "CMYK_C": 0.3028793,
    "CMYK_M": 0.06271663,
    "CMYK_Y": 0,
    "CMYK_K": 0.1812712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07264",
    "Farbtonhilfsbezeichnung": "Q6.17.70",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "198",
    "Bcolor": "209",
    "Y": 51,
    "L": 76.8763942682382,
    "a": -13.9669957345963,
    "b": -11.5974610761591,
    "C": 18.154285258948,
    "h": 0.69297360148593,
    "CMY_C": 0.4252085,
    "CMY_M": 0.2220599,
    "CMY_Y": 0.1803479,
    "CMYK_C": 0.2987372,
    "CMYK_M": 0.05088982,
    "CMYK_Y": 0,
    "CMYK_K": 0.1803479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07265",
    "Farbtonhilfsbezeichnung": "Q8.11.78",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "223",
    "Bcolor": "227",
    "Y": 70,
    "L": 86.7746310713244,
    "a": -9.2804346676344,
    "b": -6.36306477328401,
    "C": 11.2523357988125,
    "h": 0.60102524441872,
    "CMY_C": 0.249967,
    "CMY_M": 0.1247052,
    "CMY_Y": 0.1091283,
    "CMYK_C": 0.1580909,
    "CMYK_M": 0.01748494,
    "CMYK_Y": 0,
    "CMYK_K": 0.1091283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07266",
    "Farbtonhilfsbezeichnung": "Q8.10.77",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "216",
    "Bcolor": "220",
    "Y": 65,
    "L": 84.3872214797478,
    "a": -9.24830154098422,
    "b": -6.21420089011169,
    "C": 11.1421440529027,
    "h": 0.59163683131394,
    "CMY_C": 0.2748953,
    "CMY_M": 0.1512432,
    "CMY_Y": 0.1365433,
    "CMYK_C": 0.1602304,
    "CMYK_M": 0.01702446,
    "CMYK_Y": 0,
    "CMYK_K": 0.1365433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07268",
    "Farbtonhilfsbezeichnung": "Q8.34.61",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "183",
    "Bcolor": "208",
    "Y": 40,
    "L": 69.5039918889476,
    "a": -22.454917948189,
    "b": -22.3404803822633,
    "C": 31.6752332867525,
    "h": 0.78284349659597,
    "CMY_C": 0.6941618,
    "CMY_M": 0.282169,
    "CMY_Y": 0.1850796,
    "CMYK_C": 0.6247018,
    "CMYK_M": 0.1191398,
    "CMYK_Y": 0,
    "CMYK_K": 0.1850796
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07269",
    "Farbtonhilfsbezeichnung": "Q8.25.64",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "186",
    "Bcolor": "204",
    "Y": 43,
    "L": 71.6589235826121,
    "a": -17.9145772819466,
    "b": -16.8594388944644,
    "C": 24.6002593284504,
    "h": 0.75506474589309,
    "CMY_C": 0.5562423,
    "CMY_M": 0.2691421,
    "CMY_Y": 0.1999814,
    "CMYK_C": 0.4453157,
    "CMYK_M": 0.08644883,
    "CMYK_Y": 0,
    "CMYK_K": 0.1999814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07270",
    "Farbtonhilfsbezeichnung": "Q9.17.75",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "215",
    "Bcolor": "228",
    "Y": 62,
    "L": 82.8601455688477,
    "a": -13.7003383636475,
    "b": -12.8110933303833,
    "C": 18.7569561004639,
    "h": 223.078918457031,
    "CMY_C": 0.36486446857452,
    "CMY_M": 0.15669232606888,
    "CMY_Y": 0.10582584142685,
    "CMYK_C": 0.28969594836235,
    "CMYK_M": 0.05688655003905,
    "CMYK_Y": 0,
    "CMYK_K": 0.10582584142685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07271",
    "Farbtonhilfsbezeichnung": "Q8.15.72",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "206",
    "Bcolor": "218",
    "Y": 57,
    "L": 80.0726209781389,
    "a": -12.1362621678728,
    "b": -11.3673225873196,
    "C": 16.6284359520529,
    "h": 0.75269398546729,
    "CMY_C": 0.3719805,
    "CMY_M": 0.1910105,
    "CMY_Y": 0.1468561,
    "CMYK_C": 0.2638763,
    "CMYK_M": 0.05175491,
    "CMYK_Y": 0,
    "CMYK_K": 0.1468561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07272",
    "Farbtonhilfsbezeichnung": "Q7.13.79",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "224",
    "Bcolor": "231",
    "Y": 69,
    "L": 86.52824493226,
    "a": -11.0101550208374,
    "b": -9.05775021060315,
    "C": 14.2571509236787,
    "h": 0.68841347632257,
    "CMY_C": 0.2805189,
    "CMY_M": 0.1229035,
    "CMY_Y": 0.09228764,
    "CMYK_C": 0.2073688,
    "CMYK_M": 0.03372862,
    "CMYK_Y": 0,
    "CMYK_K": 0.09228764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07273",
    "Farbtonhilfsbezeichnung": "Q6.11.80",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "227",
    "Bcolor": "233",
    "Y": 72,
    "L": 88.0583119245141,
    "a": -9.98543853317668,
    "b": -7.4291525611119,
    "C": 12.4459346967644,
    "h": 0.63964915305516,
    "CMY_C": 0.2470296,
    "CMY_M": 0.1085825,
    "CMY_Y": 0.08714429,
    "CMYK_C": 0.1751485,
    "CMYK_M": 0.02348481,
    "CMYK_Y": 0,
    "CMYK_K": 0.08714429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07274",
    "Farbtonhilfsbezeichnung": "Q7.08.81",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "229",
    "Bcolor": "234",
    "Y": 74,
    "L": 89.0529303402787,
    "a": -8.00037230261913,
    "b": -6.28959972959056,
    "C": 10.1766901170754,
    "h": 0.66624685015853,
    "CMY_C": 0.2134863,
    "CMY_M": 0.1021876,
    "CMY_Y": 0.08424594,
    "CMYK_C": 0.14113,
    "CMYK_M": 0.01959222,
    "CMYK_Y": 0,
    "CMYK_K": 0.08424594
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07276",
    "Farbtonhilfsbezeichnung": "Q7.13.80",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "226",
    "Bcolor": "235",
    "Y": 70,
    "L": 87.1670512339416,
    "a": -11.9022176509146,
    "b": -10.012336364225,
    "C": 15.5534454215176,
    "h": 0.69937236517014,
    "CMY_C": 0.2864926,
    "CMY_M": 0.1136062,
    "CMY_Y": 0.07827758,
    "CMYK_C": 0.2258978,
    "CMYK_M": 0.0383289,
    "CMYK_Y": 0,
    "CMYK_K": 0.07827758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07277",
    "Farbtonhilfsbezeichnung": "Q4.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "226",
    "Bcolor": "230",
    "Y": 72,
    "L": 87.769900203627,
    "a": -9.75384595610634,
    "b": -6.43859850970063,
    "C": 11.6873034402539,
    "h": 0.58344871608247,
    "CMY_C": 0.2437013,
    "CMY_M": 0.1125913,
    "CMY_Y": 0.09760924,
    "CMYK_C": 0.1618945,
    "CMYK_M": 0.01660264,
    "CMYK_Y": 0,
    "CMYK_K": 0.09760924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07278",
    "Farbtonhilfsbezeichnung": "Q3.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 74,
    "L": 89.083064944133,
    "a": -7.02645873708641,
    "b": -4.58831999472238,
    "C": 8.39188910543669,
    "h": 0.57848552786409,
    "CMY_C": 0.1976002,
    "CMY_M": 0.1045183,
    "CMY_Y": 0.09634154,
    "CMYK_C": 0.1120541,
    "CMYK_M": 0.00904851,
    "CMYK_Y": 0,
    "CMYK_K": 0.09634154
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07279",
    "Farbtonhilfsbezeichnung": "R2.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "234",
    "Bcolor": "238",
    "Y": 80,
    "L": 91.7054635129029,
    "a": -3.92744688477492,
    "b": -4.72445869981999,
    "C": 6.14372436222793,
    "h": 0.87725870454175,
    "CMY_C": 0.1428857,
    "CMY_M": 0.0822126,
    "CMY_Y": 0.06576338,
    "CMYK_C": 0.08255121,
    "CMYK_M": 0.01760713,
    "CMYK_Y": 0,
    "CMYK_K": 0.06576338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07280",
    "Farbtonhilfsbezeichnung": "R1.14.78",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "221",
    "Bcolor": "233",
    "Y": 67,
    "L": 85.4936920198619,
    "a": -10.757104659131,
    "b": -11.3925741633945,
    "C": 15.6686325732638,
    "h": 0.81408007987005,
    "CMY_C": 0.3005699,
    "CMY_M": 0.1342083,
    "CMY_Y": 0.0866347,
    "CMYK_C": 0.2342274,
    "CMYK_M": 0.0520861,
    "CMYK_Y": 0,
    "CMYK_K": 0.0866347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07281",
    "Farbtonhilfsbezeichnung": "R0.18.75",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "217",
    "Bcolor": "232",
    "Y": 63,
    "L": 83.5503403109639,
    "a": -14.2667224304034,
    "b": -13.7690588269882,
    "C": 19.8274140998578,
    "h": 0.7676490114228,
    "CMY_C": 0.3683369,
    "CMY_M": 0.1476149,
    "CMY_Y": 0.09125205,
    "CMYK_C": 0.3049084,
    "CMYK_M": 0.06202248,
    "CMYK_Y": 0,
    "CMYK_K": 0.09125205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07282",
    "Farbtonhilfsbezeichnung": "R3.15.74",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "211",
    "Bcolor": "224",
    "Y": 60,
    "L": 82.0212892281022,
    "a": -11.5650564712966,
    "b": -12.114056659982,
    "C": 16.7481610914612,
    "h": 0.80857900833652,
    "CMY_C": 0.3493658,
    "CMY_M": 0.1705984,
    "CMY_Y": 0.1199332,
    "CMYK_C": 0.260699,
    "CMYK_M": 0.05756969,
    "CMYK_Y": 0,
    "CMYK_K": 0.1199332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07283",
    "Farbtonhilfsbezeichnung": "R0.09.76",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "214",
    "Bcolor": "220",
    "Y": 64,
    "L": 83.7374304176646,
    "a": -7.1801969821037,
    "b": -7.30867542397622,
    "C": 10.245582714265,
    "h": 0.79426531820334,
    "CMY_C": 0.268415,
    "CMY_M": 0.162577,
    "CMY_Y": 0.1354601,
    "CMYK_C": 0.1537869,
    "CMYK_M": 0.03136574,
    "CMYK_Y": 0,
    "CMYK_K": 0.1354601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07284",
    "Farbtonhilfsbezeichnung": "R1.29.63",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "185",
    "Bcolor": "210",
    "Y": 42,
    "L": 71.0347634941204,
    "a": -18.6833302216149,
    "b": -20.9334568213422,
    "C": 28.0584469039345,
    "h": 0.84213450810782,
    "CMY_C": 0.6045679,
    "CMY_M": 0.2731006,
    "CMY_Y": 0.1779971,
    "CMYK_C": 0.5189408,
    "CMYK_M": 0.1156973,
    "CMYK_Y": 0,
    "CMYK_K": 0.1779971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07285",
    "Farbtonhilfsbezeichnung": "R1.24.70",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "202",
    "Bcolor": "221",
    "Y": 52,
    "L": 77.3954928542688,
    "a": -16.7061101760392,
    "b": -17.569172298115,
    "C": 24.2439669290076,
    "h": 0.8105731501982,
    "CMY_C": 0.4843441,
    "CMY_M": 0.2091,
    "CMY_Y": 0.1320707,
    "CMYK_C": 0.405878,
    "CMYK_M": 0.0887507,
    "CMYK_Y": 0,
    "CMYK_K": 0.1320707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07286",
    "Farbtonhilfsbezeichnung": "R0.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "206",
    "Bcolor": "211",
    "Y": 59,
    "L": 81.0681257945086,
    "a": -7.89085955832008,
    "b": -6.36082249362182,
    "C": 10.1353701148254,
    "h": 0.67844944880722,
    "CMY_C": 0.2992976,
    "CMY_M": 0.1905969,
    "CMY_Y": 0.1716695,
    "CMYK_C": 0.1540786,
    "CMYK_M": 0.02285003,
    "CMYK_Y": 0,
    "CMYK_K": 0.1716695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07287",
    "Farbtonhilfsbezeichnung": "R1.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "217",
    "Bcolor": "220",
    "Y": 68,
    "L": 85.7955915548731,
    "a": -3.23319014265011,
    "b": -3.63629708118334,
    "C": 4.86581698804551,
    "h": 0.84401173791191,
    "CMY_C": 0.1978839,
    "CMY_M": 0.1498023,
    "CMY_Y": 0.1391435,
    "CMYK_C": 0.06823485,
    "CMYK_M": 0.01238159,
    "CMYK_Y": 0,
    "CMYK_K": 0.1391435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07288",
    "Farbtonhilfsbezeichnung": "R2.35.61",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "181",
    "Bcolor": "209",
    "Y": 39,
    "L": 68.8784518862629,
    "a": -21.1251406241823,
    "b": -23.8492931438643,
    "C": 31.8600117679427,
    "h": 0.84589538576694,
    "CMY_C": 0.6963496,
    "CMY_M": 0.290776,
    "CMY_Y": 0.181141,
    "CMYK_C": 0.6291786,
    "CMYK_M": 0.1338874,
    "CMYK_Y": 0,
    "CMYK_K": 0.181141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07289",
    "Farbtonhilfsbezeichnung": "R2.26.65",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "189",
    "Bcolor": "211",
    "Y": 45,
    "L": 72.7239683613391,
    "a": -16.7091789592118,
    "b": -19.2885535372721,
    "C": 25.5195015439404,
    "h": 0.85692971687221,
    "CMY_C": 0.5475416,
    "CMY_M": 0.2592024,
    "CMY_Y": 0.1710357,
    "CMYK_C": 0.4541883,
    "CMYK_M": 0.1063576,
    "CMYK_Y": 0,
    "CMYK_K": 0.1710357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07290",
    "Farbtonhilfsbezeichnung": "R1.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "200",
    "Bcolor": "216",
    "Y": 52,
    "L": 77.1664397281105,
    "a": -14.5439264547209,
    "b": -14.9292998136277,
    "C": 20.8424996016676,
    "h": 0.7984727890195,
    "CMY_C": 0.4466948,
    "CMY_M": 0.2167224,
    "CMY_Y": 0.1533367,
    "CMYK_C": 0.3464874,
    "CMYK_M": 0.0748653,
    "CMYK_Y": 0,
    "CMYK_K": 0.1533367
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07291",
    "Farbtonhilfsbezeichnung": "R3.16.70",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "198",
    "Bcolor": "212",
    "Y": 52,
    "L": 77.0383629445932,
    "a": -11.5491180611125,
    "b": -12.7564571036281,
    "C": 17.2078274580558,
    "h": 0.83503070611513,
    "CMY_C": 0.4058407,
    "CMY_M": 0.2248695,
    "CMY_Y": 0.1700107,
    "CMYK_C": 0.2841362,
    "CMYK_M": 0.06609575,
    "CMYK_Y": 0,
    "CMYK_K": 0.1700107
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07292",
    "Farbtonhilfsbezeichnung": "R1.09.73",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "206",
    "Bcolor": "213",
    "Y": 59,
    "L": 81.2089336824285,
    "a": -6.67353665194947,
    "b": -7.011634028808,
    "C": 9.67982970918659,
    "h": 0.81009852142324,
    "CMY_C": 0.2899771,
    "CMY_M": 0.1915077,
    "CMY_Y": 0.1652766,
    "CMYK_C": 0.1493914,
    "CMYK_M": 0.03142489,
    "CMYK_Y": 0,
    "CMYK_K": 0.1652766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07293",
    "Farbtonhilfsbezeichnung": "R3.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "216",
    "Bcolor": "218",
    "Y": 67,
    "L": 85.3748815745569,
    "a": -4.15677417463245,
    "b": -3.61916589926541,
    "C": 5.51154545887965,
    "h": 0.71637060750278,
    "CMY_C": 0.2100315,
    "CMY_M": 0.152352,
    "CMY_Y": 0.1440082,
    "CMYK_C": 0.07713076,
    "CMYK_M": 0.009747534,
    "CMYK_Y": 0,
    "CMYK_K": 0.1440082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07294",
    "Farbtonhilfsbezeichnung": "RN.02.79",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "212",
    "Bcolor": "211",
    "Y": 65,
    "L": 84.5797535288668,
    "a": -1.65845888568245,
    "b": -0.75414666521542,
    "C": 1.82187350498178,
    "h": 0.4267782572742,
    "CMY_C": 0.1879084,
    "CMY_M": 0.1676279,
    "CMY_Y": 0.1732944,
    "CMYK_C": 0.02436461,
    "CMYK_M": 0,
    "CMYK_Y": 0.006807622,
    "CMYK_K": 0.1676279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07295",
    "Farbtonhilfsbezeichnung": "R1.39.53",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "160",
    "Bcolor": "189",
    "Y": 29,
    "L": 61.1431508834089,
    "a": -21.3027972771263,
    "b": -24.7784600000653,
    "C": 32.6769223123166,
    "h": 0.86068027287309,
    "CMY_C": 0.8242812,
    "CMY_M": 0.3721181,
    "CMY_Y": 0.2583231,
    "CMYK_C": 0.763079,
    "CMYK_M": 0.1534293,
    "CMYK_Y": 0,
    "CMYK_K": 0.2583231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07296",
    "Farbtonhilfsbezeichnung": "R3.27.60",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "174",
    "Bcolor": "195",
    "Y": 37,
    "L": 67.368747518036,
    "a": -15.3390610390849,
    "b": -18.1291910830889,
    "C": 23.7477233200979,
    "h": 0.86857230355636,
    "CMY_C": 0.581292,
    "CMY_M": 0.3194682,
    "CMY_Y": 0.2371498,
    "CMYK_C": 0.4511268,
    "CMYK_M": 0.107909,
    "CMYK_Y": 0,
    "CMYK_K": 0.2371498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07297",
    "Farbtonhilfsbezeichnung": "R2.24.63",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "184",
    "Bcolor": "204",
    "Y": 42,
    "L": 71.1842934318899,
    "a": -15.28857688029,
    "b": -17.7642981623442,
    "C": 23.437381940507,
    "h": 0.86016040318822,
    "CMY_C": 0.5369694,
    "CMY_M": 0.2789868,
    "CMY_Y": 0.1984748,
    "CMYK_C": 0.4223131,
    "CMYK_M": 0.1004485,
    "CMYK_Y": 0,
    "CMYK_K": 0.1984748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07298",
    "Farbtonhilfsbezeichnung": "R1.19.70",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "199",
    "Bcolor": "216",
    "Y": 52,
    "L": 77.350497785382,
    "a": -13.0473955439238,
    "b": -14.5163574907695,
    "C": 19.5181752548598,
    "h": 0.8386410439794,
    "CMY_C": 0.4269034,
    "CMY_M": 0.2178683,
    "CMY_Y": 0.1541274,
    "CMYK_C": 0.3224788,
    "CMYK_M": 0.07535519,
    "CMYK_Y": 0,
    "CMYK_K": 0.1541274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07299",
    "Farbtonhilfsbezeichnung": "R0.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "203",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.5142111753727,
    "a": -4.96548445732165,
    "b": -4.95203115536271,
    "C": 7.0127489944804,
    "h": 0.78404164486676,
    "CMY_C": 0.2745223,
    "CMY_M": 0.2034484,
    "CMY_Y": 0.1875273,
    "CMYK_C": 0.1070744,
    "CMYK_M": 0.01959578,
    "CMYK_Y": 0,
    "CMYK_K": 0.1875273
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07301",
    "Farbtonhilfsbezeichnung": "RN.02.76",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "209",
    "Bcolor": "210",
    "Y": 63,
    "L": 83.2122363406984,
    "a": -2.17666932726207,
    "b": -2.12730906223901,
    "C": 3.04357244147856,
    "h": 0.77393014551762,
    "CMY_C": 0.2118655,
    "CMY_M": 0.1810507,
    "CMY_Y": 0.1782729,
    "CMYK_C": 0.04088048,
    "CMYK_M": 0.003380558,
    "CMYK_Y": 0,
    "CMYK_K": 0.1782729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07302",
    "Farbtonhilfsbezeichnung": "R0.04.70",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "196",
    "Bcolor": "198",
    "Y": 54,
    "L": 78.5441465623125,
    "a": -3.07419076848092,
    "b": -2.69496681582533,
    "C": 4.08821416016982,
    "h": 0.71975960665429,
    "CMY_C": 0.2715668,
    "CMY_M": 0.2297094,
    "CMY_Y": 0.224864,
    "CMYK_C": 0.06025109,
    "CMYK_M": 0.006251086,
    "CMYK_Y": 0,
    "CMYK_K": 0.224864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07303",
    "Farbtonhilfsbezeichnung": "R4.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "204",
    "Bcolor": "210",
    "Y": 59,
    "L": 81.0254159562922,
    "a": -4.66908154423645,
    "b": -5.62402979274357,
    "C": 7.30958504816769,
    "h": 0.87790881856093,
    "CMY_C": 0.2692139,
    "CMY_M": 0.1983328,
    "CMY_Y": 0.1770715,
    "CMYK_C": 0.1119689,
    "CMYK_M": 0.02583607,
    "CMYK_Y": 0,
    "CMYK_K": 0.1770715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07304",
    "Farbtonhilfsbezeichnung": "R0.09.72",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "200",
    "Bcolor": "207",
    "Y": 55,
    "L": 78.7562028513228,
    "a": -7.35018736757032,
    "b": -7.27881110470627,
    "C": 10.344387146486,
    "h": 0.78051910782687,
    "CMY_C": 0.3232155,
    "CMY_M": 0.216699,
    "CMY_Y": 0.1901559,
    "CMYK_C": 0.1643027,
    "CMYK_M": 0.03277558,
    "CMYK_Y": 0,
    "CMYK_K": 0.1901559
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07305",
    "Farbtonhilfsbezeichnung": "Q9.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "195",
    "Bcolor": "203",
    "Y": 51,
    "L": 76.9113343861452,
    "a": -8.35465498058435,
    "b": -7.89401921569945,
    "C": 11.4941637026116,
    "h": 0.75705662496813,
    "CMY_C": 0.3543063,
    "CMY_M": 0.2343834,
    "CMY_Y": 0.2058688,
    "CMYK_C": 0.186918,
    "CMYK_M": 0.03590668,
    "CMYK_Y": 0,
    "CMYK_K": 0.2058688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07306",
    "Farbtonhilfsbezeichnung": "R0.28.60",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "176",
    "Bcolor": "196",
    "Y": 38,
    "L": 67.7450967007491,
    "a": -18.2679102496836,
    "b": -18.2884955356191,
    "C": 25.8492865249093,
    "h": 0.78596127356425,
    "CMY_C": 0.614447,
    "CMY_M": 0.3099207,
    "CMY_Y": 0.2322568,
    "CMYK_C": 0.4978099,
    "CMYK_M": 0.1011587,
    "CMYK_Y": 0,
    "CMYK_K": 0.2322568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07307",
    "Farbtonhilfsbezeichnung": "R2.34.55",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "164",
    "Bcolor": "191",
    "Y": 32,
    "L": 63.2869898785065,
    "a": -18.727585202885,
    "b": -22.2485405490339,
    "C": 29.0812655173967,
    "h": 0.87111461101578,
    "CMY_C": 0.7086112,
    "CMY_M": 0.3549871,
    "CMY_Y": 0.2526164,
    "CMYK_C": 0.6101215,
    "CMYK_M": 0.136972,
    "CMYK_Y": 0,
    "CMYK_K": 0.2526164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07308",
    "Farbtonhilfsbezeichnung": "R2.45.53",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "161",
    "Bcolor": "195",
    "Y": 29,
    "L": 60.8606623482884,
    "a": -23.8224388512982,
    "b": -28.669986873365,
    "C": 37.2756856428257,
    "h": 0.87748455408313,
    "CMY_C": 1,
    "CMY_M": 0.3694612,
    "CMY_Y": 0.2346929,
    "CMYK_C": 1,
    "CMYK_M": 0.1760971,
    "CMYK_Y": 0,
    "CMYK_K": 0.2346929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07309",
    "Farbtonhilfsbezeichnung": "R2.45.44",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "166",
    "Y": 20,
    "L": 51.7148095744595,
    "a": -21.9991726116109,
    "b": -26.2044182646434,
    "C": 34.214545622934,
    "h": 0.8724171127622,
    "CMY_C": 1,
    "CMY_M": 0.4679107,
    "CMY_Y": 0.3485725,
    "CMYK_C": 1,
    "CMYK_M": 0.183195,
    "CMYK_Y": 0,
    "CMYK_K": 0.3485725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07310",
    "Farbtonhilfsbezeichnung": "R2.33.53",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "157",
    "Bcolor": "181",
    "Y": 29,
    "L": 60.8274005666725,
    "a": -17.9191140794927,
    "b": -20.873958069518,
    "C": 27.5103030677939,
    "h": 0.86142074144642,
    "CMY_C": 0.71143,
    "CMY_M": 0.3826544,
    "CMY_Y": 0.2882938,
    "CMYK_C": 0.5945378,
    "CMYK_M": 0.1325836,
    "CMYK_Y": 0,
    "CMYK_K": 0.2882938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07311",
    "Farbtonhilfsbezeichnung": "R2.28.53",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "156",
    "Bcolor": "176",
    "Y": 29,
    "L": 60.8807758863481,
    "a": -14.5199660095408,
    "b": -17.5827607823273,
    "C": 22.8031333295836,
    "h": 0.88051632497771,
    "CMY_C": 0.6374525,
    "CMY_M": 0.3893414,
    "CMY_Y": 0.3100255,
    "CMYK_C": 0.4745495,
    "CMYK_M": 0.1149549,
    "CMYK_Y": 0,
    "CMYK_K": 0.3100255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07312",
    "Farbtonhilfsbezeichnung": "R1.20.63",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "181",
    "Bcolor": "197",
    "Y": 42,
    "L": 70.6683323103915,
    "a": -12.9471743042595,
    "b": -14.43164418602,
    "C": 19.3881839370469,
    "h": 0.8395647731068,
    "CMY_C": 0.496404,
    "CMY_M": 0.2901395,
    "CMY_Y": 0.2273571,
    "CMYK_C": 0.3482164,
    "CMYK_M": 0.08125677,
    "CMYK_Y": 0,
    "CMYK_K": 0.2273571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07313",
    "Farbtonhilfsbezeichnung": "R3.14.66",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "186",
    "Bcolor": "197",
    "Y": 46,
    "L": 73.3453127134426,
    "a": -8.96139674081592,
    "b": -10.5352332742667,
    "C": 13.8310437671754,
    "h": 0.86594702301773,
    "CMY_C": 0.4094693,
    "CMY_M": 0.270752,
    "CMY_Y": 0.2256377,
    "CMYK_C": 0.2373973,
    "CMYK_M": 0.05825989,
    "CMYK_Y": 0,
    "CMYK_K": 0.2256377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07314",
    "Farbtonhilfsbezeichnung": "R2.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "194",
    "Bcolor": "203",
    "Y": 51,
    "L": 76.7470270615103,
    "a": -7.17922268292226,
    "b": -8.16198594107631,
    "C": 10.8701082254646,
    "h": 0.84937110394243,
    "CMY_C": 0.3468979,
    "CMY_M": 0.2385844,
    "CMY_Y": 0.2055936,
    "CMYK_C": 0.1778741,
    "CMYK_M": 0.04152885,
    "CMYK_Y": 0,
    "CMYK_K": 0.2055936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07315",
    "Farbtonhilfsbezeichnung": "R0.06.68",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "190",
    "Bcolor": "194",
    "Y": 50,
    "L": 75.7715935096827,
    "a": -5.02369353342463,
    "b": -5.01893241668581,
    "C": 7.10120970828436,
    "h": 0.78492407261623,
    "CMY_C": 0.3258797,
    "CMY_M": 0.2546804,
    "CMY_Y": 0.2383042,
    "CMYK_C": 0.1149744,
    "CMYK_M": 0.02149963,
    "CMYK_Y": 0,
    "CMYK_K": 0.2383042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07316",
    "Farbtonhilfsbezeichnung": "RN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "185",
    "Bcolor": "186",
    "Y": 48,
    "L": 74.7725416056232,
    "a": -1.73159453603366,
    "b": -1.94816742544321,
    "C": 2.60648728268136,
    "h": 0.84418548330793,
    "CMY_C": 0.2985123,
    "CMY_M": 0.273552,
    "CMY_Y": 0.2704392,
    "CMYK_C": 0.03847947,
    "CMYK_M": 0.004266595,
    "CMYK_Y": 0,
    "CMYK_K": 0.2704392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07317",
    "Farbtonhilfsbezeichnung": "Q8.05.64",
    "Farbtonklasse": "01",
    "Rcolor": "164",
    "Gcolor": "178",
    "Bcolor": "181",
    "Y": 43,
    "L": 71.671153141717,
    "a": -3.94558093392211,
    "b": -3.86000600332936,
    "C": 5.51971514227577,
    "h": 0.77443531037906,
    "CMY_C": 0.3558487,
    "CMY_M": 0.3012372,
    "CMY_Y": 0.2901447,
    "CMYK_C": 0.09255965,
    "CMYK_M": 0.01562642,
    "CMYK_Y": 0,
    "CMYK_K": 0.2901447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07318",
    "Farbtonhilfsbezeichnung": "R3.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "176",
    "Bcolor": "183",
    "Y": 42,
    "L": 70.6572552012307,
    "a": -5.23850995569403,
    "b": -6.29747626982231,
    "C": 8.19147080351756,
    "h": 0.87693838637122,
    "CMY_C": 0.3865772,
    "CMY_M": 0.308532,
    "CMY_Y": 0.2838991,
    "CMYK_C": 0.143385,
    "CMYK_M": 0.03439858,
    "CMYK_Y": 0,
    "CMYK_K": 0.2838991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07319",
    "Farbtonhilfsbezeichnung": "R1.10.63",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "177",
    "Bcolor": "185",
    "Y": 41,
    "L": 70.4461277869814,
    "a": -7.44160989513848,
    "b": -7.73641103044949,
    "C": 10.7345057391332,
    "h": 0.80481861840985,
    "CMY_C": 0.4135373,
    "CMY_M": 0.3057068,
    "CMY_Y": 0.2762815,
    "CMYK_C": 0.1896535,
    "CMYK_M": 0.04065846,
    "CMYK_Y": 0,
    "CMYK_K": 0.2762815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07320",
    "Farbtonhilfsbezeichnung": "R2.35.44",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "134",
    "Bcolor": "156",
    "Y": 20,
    "L": 52.0142710594783,
    "a": -16.9395841663276,
    "b": -20.0263557464647,
    "C": 26.2298386615712,
    "h": 0.86870801572302,
    "CMY_C": 0.7936599,
    "CMY_M": 0.4752945,
    "CMY_Y": 0.3863791,
    "CMYK_C": 0.6637336,
    "CMYK_M": 0.1449029,
    "CMYK_Y": 0,
    "CMYK_K": 0.3863791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07321",
    "Farbtonhilfsbezeichnung": "R1.37.44",
    "Farbtonklasse": "03",
    "Rcolor": "36",
    "Gcolor": "134",
    "Bcolor": "159",
    "Y": 20,
    "L": 51.8944488040793,
    "a": -18.8750754580783,
    "b": -21.570386994387,
    "C": 28.6626947204162,
    "h": 0.85194041644576,
    "CMY_C": 0.8573169,
    "CMY_M": 0.4727405,
    "CMY_Y": 0.3774647,
    "CMYK_C": 0.7708032,
    "CMYK_M": 0.1530449,
    "CMYK_Y": 0,
    "CMYK_K": 0.3774647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07322",
    "Farbtonhilfsbezeichnung": "R2.49.43",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "169",
    "Y": 20,
    "L": 51.5232915780671,
    "a": -23.1540828200384,
    "b": -28.1202518684078,
    "C": 36.426091148789,
    "h": 0.88195186640567,
    "CMY_C": 1,
    "CMY_M": 0.4673634,
    "CMY_Y": 0.3378219,
    "CMYK_C": 1,
    "CMYK_M": 0.1956294,
    "CMYK_Y": 0,
    "CMYK_K": 0.3378219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07323",
    "Farbtonhilfsbezeichnung": "R0.50.35",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "137",
    "Y": 13,
    "L": 42.4243381069324,
    "a": -21.5874207516753,
    "b": -23.4111510275086,
    "C": 31.8449168179582,
    "h": 0.82590462064996,
    "CMY_C": 1,
    "CMY_M": 0.562582,
    "CMY_Y": 0.4625661,
    "CMYK_C": 1,
    "CMYK_M": 0.186099,
    "CMYK_Y": 0,
    "CMYK_K": 0.4625661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07324",
    "Farbtonhilfsbezeichnung": "R1.42.43",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "134",
    "Bcolor": "161",
    "Y": 20,
    "L": 51.2835313329477,
    "a": -20.4757277186341,
    "b": -24.0750102769958,
    "C": 31.6047709285338,
    "h": 0.86601370994676,
    "CMY_C": 1,
    "CMY_M": 0.4754775,
    "CMY_Y": 0.3672076,
    "CMYK_C": 1,
    "CMYK_M": 0.1710986,
    "CMYK_Y": 0,
    "CMYK_K": 0.3672076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07325",
    "Farbtonhilfsbezeichnung": "R2.30.44",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "131",
    "Bcolor": "151",
    "Y": 20,
    "L": 51.513014106361,
    "a": -14.7736334717269,
    "b": -17.7810807415682,
    "C": 23.1176789123626,
    "h": 0.87751801126689,
    "CMY_C": 0.7436867,
    "CMY_M": 0.484823,
    "CMY_Y": 0.4063274,
    "CMYK_C": 0.5682581,
    "CMYK_M": 0.1322203,
    "CMYK_Y": 0,
    "CMYK_K": 0.4063274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07326",
    "Farbtonhilfsbezeichnung": "R2.22.53",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "154",
    "Bcolor": "171",
    "Y": 29,
    "L": 60.9755288215456,
    "a": -11.8705219876505,
    "b": -14.7959565489081,
    "C": 18.9691755871591,
    "h": 0.89466578277273,
    "CMY_C": 0.5886327,
    "CMY_M": 0.3942132,
    "CMY_Y": 0.327883,
    "CMYK_C": 0.3879528,
    "CMYK_M": 0.0986885,
    "CMYK_Y": 0,
    "CMYK_K": 0.327883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07328",
    "Farbtonhilfsbezeichnung": "R0.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "142",
    "Bcolor": "147",
    "Y": 25,
    "L": 57.4672428307225,
    "a": -6.1957993124519,
    "b": -6.20560257067926,
    "C": 8.76911810762066,
    "h": 0.78618865920411,
    "CMY_C": 0.5289721,
    "CMY_M": 0.4439447,
    "CMY_Y": 0.4220514,
    "CMYK_C": 0.1850005,
    "CMYK_M": 0.03788101,
    "CMYK_Y": 0,
    "CMYK_K": 0.4220514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07329",
    "Farbtonhilfsbezeichnung": "R0.08.52",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "148",
    "Bcolor": "152",
    "Y": 28,
    "L": 60.0000611640649,
    "a": -4.69019855675545,
    "b": -5.0642441632077,
    "C": 6.90250182516268,
    "h": 0.82372556383171,
    "CMY_C": 0.4866823,
    "CMY_M": 0.4213922,
    "CMY_Y": 0.4036881,
    "CMYK_C": 0.1391792,
    "CMYK_M": 0.02968937,
    "CMYK_Y": 0,
    "CMYK_K": 0.4036881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07330",
    "Farbtonhilfsbezeichnung": "R1.04.54",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "149",
    "Bcolor": "152",
    "Y": 29,
    "L": 60.9289741583843,
    "a": -2.35504008976833,
    "b": -3.32214806319007,
    "C": 4.07220843992219,
    "h": 0.95412829393057,
    "CMY_C": 0.4524238,
    "CMY_M": 0.4172157,
    "CMY_Y": 0.4057489,
    "CMYK_C": 0.07854392,
    "CMYK_M": 0.0192962,
    "CMYK_Y": 0,
    "CMYK_K": 0.4057489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07331",
    "Farbtonhilfsbezeichnung": "R2.10.36",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "109",
    "Bcolor": "115",
    "Y": 14,
    "L": 44.9324670284652,
    "a": -4.53491116234012,
    "b": -5.86329613526464,
    "C": 7.41239912714677,
    "h": 0.91246125138299,
    "CMY_C": 0.6367203,
    "CMY_M": 0.5723265,
    "CMY_Y": 0.5493516,
    "CMYK_C": 0.1938733,
    "CMYK_M": 0.05098196,
    "CMYK_Y": 0,
    "CMYK_K": 0.5493516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07332",
    "Farbtonhilfsbezeichnung": "R1.19.39",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "118",
    "Bcolor": "129",
    "Y": 16,
    "L": 47.5704256841071,
    "a": -8.64772654720142,
    "b": -10.5407739723667,
    "C": 13.6341882916328,
    "h": 0.88373526098892,
    "CMY_C": 0.6676178,
    "CMY_M": 0.5373859,
    "CMY_Y": 0.4934055,
    "CMYK_C": 0.3438891,
    "CMYK_M": 0.08681574,
    "CMYK_Y": 0,
    "CMYK_K": 0.4934055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07333",
    "Farbtonhilfsbezeichnung": "R0.28.35",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "108",
    "Bcolor": "123",
    "Y": 13,
    "L": 42.958852279247,
    "a": -12.2087081056925,
    "b": -14.0539623555678,
    "C": 18.6162942472909,
    "h": 0.8555443711369,
    "CMY_C": 0.7717897,
    "CMY_M": 0.5752702,
    "CMY_Y": 0.5167983,
    "CMYK_C": 0.5277121,
    "CMYK_M": 0.1210094,
    "CMYK_Y": 0,
    "CMYK_K": 0.5167983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07334",
    "Farbtonhilfsbezeichnung": "R2.45.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "111",
    "Bcolor": "137",
    "Y": 13,
    "L": 42.7165238240783,
    "a": -18.0575664342792,
    "b": -22.608584189548,
    "C": 28.9348195878994,
    "h": 0.8968461334049,
    "CMY_C": 1,
    "CMY_M": 0.5653771,
    "CMY_Y": 0.464561,
    "CMYK_C": 1,
    "CMYK_M": 0.1882869,
    "CMYK_Y": 0,
    "CMYK_K": 0.464561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07335",
    "Farbtonhilfsbezeichnung": "R2.49.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "140",
    "Y": 13,
    "L": 43.3293813597026,
    "a": -19.669850074771,
    "b": -23.9173246690635,
    "C": 30.9667793173485,
    "h": 0.8825392588625,
    "CMY_C": 1,
    "CMY_M": 0.5564059,
    "CMY_Y": 0.4499902,
    "CMYK_C": 1,
    "CMYK_M": 0.1934796,
    "CMYK_Y": 0,
    "CMYK_K": 0.4499902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07336",
    "Farbtonhilfsbezeichnung": "R2.55.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "115",
    "Bcolor": "144",
    "Y": 14,
    "L": 43.5156207949746,
    "a": -21.7973022410065,
    "b": -26.0104545838756,
    "C": 33.9362068099197,
    "h": 0.87329804014623,
    "CMY_C": 1,
    "CMY_M": 0.5506215,
    "CMY_Y": 0.4346376,
    "CMYK_C": 1,
    "CMYK_M": 0.2051496,
    "CMYK_Y": 0,
    "CMYK_K": 0.4346376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07339",
    "Farbtonhilfsbezeichnung": "R0.39.25",
    "Farbtonklasse": "04",
    "Rcolor": "20",
    "Gcolor": "87",
    "Bcolor": "103",
    "Y": 8,
    "L": 33.8009595729708,
    "a": -14.116817486219,
    "b": -15.3793323125935,
    "C": 20.8760244855289,
    "h": 0.82817475206314,
    "CMY_C": 0.9199683,
    "CMY_M": 0.6594639,
    "CMY_Y": 0.5978312,
    "CMYK_C": 0.8009997,
    "CMYK_M": 0.1532508,
    "CMYK_Y": 0,
    "CMYK_K": 0.5978312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07340",
    "Farbtonhilfsbezeichnung": "R1.21.29",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "96",
    "Bcolor": "105",
    "Y": 11,
    "L": 38.8407305749372,
    "a": -8.1915521063495,
    "b": -9.00061145160895,
    "C": 12.1701492354808,
    "h": 0.8324232444028,
    "CMY_C": 0.7390707,
    "CMY_M": 0.623384,
    "CMY_Y": 0.5887396,
    "CMYK_C": 0.3655373,
    "CMYK_M": 0.08423948,
    "CMYK_Y": 0,
    "CMYK_K": 0.5887396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07341",
    "Farbtonhilfsbezeichnung": "R3.13.27",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "88",
    "Bcolor": "94",
    "Y": 9,
    "L": 36.1421453757509,
    "a": -4.21150953925273,
    "b": -6.20755785369778,
    "C": 7.50137234819214,
    "h": 0.97468122637446,
    "CMY_C": 0.7179388,
    "CMY_M": 0.6568117,
    "CMY_Y": 0.6314856,
    "CMYK_C": 0.2345993,
    "CMYK_M": 0.06872471,
    "CMYK_Y": 0,
    "CMYK_K": 0.6314856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07342",
    "Farbtonhilfsbezeichnung": "R1.04.08",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "55",
    "Bcolor": "56",
    "Y": 4,
    "L": 22.9300739568869,
    "a": -0.73716927192352,
    "b": -1.27270938272253,
    "C": 1.47078472535521,
    "h": 1.04580195220463,
    "CMY_C": 0.7936735,
    "CMY_M": 0.783695,
    "CMY_Y": 0.7801902,
    "CMYK_C": 0.06134071,
    "CMYK_M": 0.015945,
    "CMYK_Y": 0,
    "CMYK_K": 0.7801902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07343",
    "Farbtonhilfsbezeichnung": "R0.08.15",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "64",
    "Bcolor": "66",
    "Y": 5,
    "L": 26.3326005979974,
    "a": -2.50555860849863,
    "b": -2.78896397821095,
    "C": 3.74915243920274,
    "h": 0.83887515848083,
    "CMY_C": 0.7806775,
    "CMY_M": 0.750306,
    "CMY_Y": 0.7417649,
    "CMYK_C": 0.1506866,
    "CMYK_M": 0.03307464,
    "CMYK_Y": 0,
    "CMYK_K": 0.7417649
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07344",
    "Farbtonhilfsbezeichnung": "R0.19.20",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "74",
    "Bcolor": "81",
    "Y": 6,
    "L": 29.9849266543091,
    "a": -6.60977774227361,
    "b": -7.39531863501246,
    "C": 9.91866420016417,
    "h": 0.84142909955822,
    "CMY_C": 0.7985155,
    "CMY_M": 0.70915,
    "CMY_Y": 0.6817643,
    "CMYK_C": 0.3668702,
    "CMYK_M": 0.08605475,
    "CMYK_Y": 0,
    "CMYK_K": 0.6817643
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07345",
    "Farbtonhilfsbezeichnung": "R3.40.13",
    "Farbtonklasse": "04",
    "Rcolor": "24",
    "Gcolor": "62",
    "Bcolor": "74",
    "Y": 4,
    "L": 23.9615144588288,
    "a": -8.94351176412875,
    "b": -11.8039523639137,
    "C": 14.8094461099885,
    "h": 0.92240386141281,
    "CMY_C": 0.9064856,
    "CMY_M": 0.7583143,
    "CMY_Y": 0.7107694,
    "CMYK_C": 0.6766788,
    "CMYK_M": 0.164384,
    "CMYK_Y": 0,
    "CMYK_K": 0.7107694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07346",
    "Farbtonhilfsbezeichnung": "R2.39.20",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "78",
    "Bcolor": "93",
    "Y": 6,
    "L": 30.3140531677694,
    "a": -11.8972593656773,
    "b": -14.7024293347355,
    "C": 18.9131226601291,
    "h": 0.890468548613,
    "CMY_C": 0.9120458,
    "CMY_M": 0.6955358,
    "CMY_Y": 0.6349723,
    "CMYK_C": 0.7590479,
    "CMYK_M": 0.1659148,
    "CMYK_Y": 0,
    "CMYK_K": 0.6349723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07347",
    "Farbtonhilfsbezeichnung": "R0.44.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "75",
    "Bcolor": "91",
    "Y": 6,
    "L": 28.8685398319396,
    "a": -14.1397385381402,
    "b": -15.9236246563258,
    "C": 21.2953992243047,
    "h": 0.84466621215641,
    "CMY_C": 1,
    "CMY_M": 0.7050974,
    "CMY_Y": 0.6413472,
    "CMYK_C": 1,
    "CMYK_M": 0.1777491,
    "CMYK_Y": 0,
    "CMYK_K": 0.6413472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07348",
    "Farbtonhilfsbezeichnung": "R3.52.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "91",
    "Bcolor": "114",
    "Y": 8,
    "L": 34.8059617842674,
    "a": -17.0824886859214,
    "b": -21.0348537922713,
    "C": 27.0975366734111,
    "h": 0.88871835616913,
    "CMY_C": 1,
    "CMY_M": 0.6437411,
    "CMY_Y": 0.5531711,
    "CMYK_C": 1,
    "CMYK_M": 0.202695,
    "CMYK_Y": 0,
    "CMYK_K": 0.5531711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07349",
    "Farbtonhilfsbezeichnung": "R4.40.59",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "177",
    "Bcolor": "212",
    "Y": 37,
    "L": 67.1225470626394,
    "a": -21.763911238672,
    "b": -28.5106028784242,
    "C": 35.8681238552563,
    "h": 0.91879823242056,
    "CMY_C": 0.8040468,
    "CMY_M": 0.306801,
    "CMY_Y": 0.1675701,
    "CMYK_C": 0.7646009,
    "CMYK_M": 0.1672584,
    "CMYK_Y": 0,
    "CMYK_K": 0.1675701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07350",
    "Farbtonhilfsbezeichnung": "R7.27.67",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "195",
    "Bcolor": "224",
    "Y": 49,
    "L": 75.2005268233498,
    "a": -14.6289538857842,
    "b": -22.3555468734245,
    "C": 26.716600977712,
    "h": 0.99135033719048,
    "CMY_C": 0.5176192,
    "CMY_M": 0.2354863,
    "CMY_Y": 0.1217436,
    "CMYK_C": 0.4507517,
    "CMYK_M": 0.1295097,
    "CMYK_Y": 0,
    "CMYK_K": 0.1217436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07351",
    "Farbtonhilfsbezeichnung": "R4.20.72",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "202",
    "Bcolor": "220",
    "Y": 54,
    "L": 78.2717054630155,
    "a": -13.0941730090879,
    "b": -15.2099008658384,
    "C": 20.0698393401781,
    "h": 0.86000934634947,
    "CMY_C": 0.4214227,
    "CMY_M": 0.2075231,
    "CMY_Y": 0.1390311,
    "CMYK_C": 0.3279928,
    "CMYK_M": 0.07955233,
    "CMYK_Y": 0,
    "CMYK_K": 0.1390311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07352",
    "Farbtonhilfsbezeichnung": "R6.19.73",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "206",
    "Bcolor": "226",
    "Y": 57,
    "L": 80.2967432216434,
    "a": -10.4819592476048,
    "b": -15.7030032945164,
    "C": 18.8800366031435,
    "h": 0.98220801098003,
    "CMY_C": 0.376188,
    "CMY_M": 0.1906514,
    "CMY_Y": 0.1128593,
    "CMYK_C": 0.2968286,
    "CMYK_M": 0.08768849,
    "CMYK_Y": 0,
    "CMYK_K": 0.1128593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07353",
    "Farbtonhilfsbezeichnung": "R1.11.80",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "222",
    "Bcolor": "232",
    "Y": 69,
    "L": 86.5524767627381,
    "a": -8.57515371328976,
    "b": -9.23331725584453,
    "C": 12.6010876020137,
    "h": 0.82233924218505,
    "CMY_C": 0.2587785,
    "CMY_M": 0.1278454,
    "CMY_Y": 0.09044258,
    "CMYK_C": 0.1850745,
    "CMYK_M": 0.04112195,
    "CMYK_Y": 0,
    "CMYK_K": 0.09044258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07354",
    "Farbtonhilfsbezeichnung": "R8.07.80",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "220",
    "Bcolor": "225",
    "Y": 69,
    "L": 86.535078282459,
    "a": -4.45923838558859,
    "b": -5.38188649920675,
    "C": 6.98924239598618,
    "h": 0.8788792412208,
    "CMY_C": 0.2067818,
    "CMY_M": 0.138337,
    "CMY_Y": 0.1183741,
    "CMYK_C": 0.1002781,
    "CMYK_M": 0.02264331,
    "CMYK_Y": 0,
    "CMYK_K": 0.1183741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07355",
    "Farbtonhilfsbezeichnung": "R4.04.80",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "223",
    "Bcolor": "225",
    "Y": 72,
    "L": 87.9268420456965,
    "a": -3.01731218715662,
    "b": -3.25338249954272,
    "C": 4.43719173837403,
    "h": 0.82302698988139,
    "CMY_C": 0.1713192,
    "CMY_M": 0.1268359,
    "CMY_Y": 0.1184506,
    "CMYK_C": 0.05997237,
    "CMYK_M": 0.009512016,
    "CMYK_Y": 0,
    "CMYK_K": 0.1184506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07356",
    "Farbtonhilfsbezeichnung": "R5.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "220",
    "Bcolor": "221",
    "Y": 70,
    "L": 87.1802226950851,
    "a": -2.04685065766691,
    "b": -2.12718643407306,
    "C": 2.952036541118,
    "h": 0.80464232852307,
    "CMY_C": 0.1674378,
    "CMY_M": 0.137668,
    "CMY_Y": 0.1348217,
    "CMYK_C": 0.03769872,
    "CMYK_M": 0.003289847,
    "CMYK_Y": 0,
    "CMYK_K": 0.1348217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07357",
    "Farbtonhilfsbezeichnung": "R7.11.79",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "220",
    "Bcolor": "231",
    "Y": 68,
    "L": 85.908904869641,
    "a": -7.17541615451695,
    "b": -9.93116970311208,
    "C": 12.2521315966861,
    "h": 0.94511909291243,
    "CMY_C": 0.2563423,
    "CMY_M": 0.1378295,
    "CMY_Y": 0.09230772,
    "CMYK_C": 0.1807161,
    "CMYK_M": 0.05015111,
    "CMYK_Y": 0,
    "CMYK_K": 0.09230772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07358",
    "Farbtonhilfsbezeichnung": "R7.13.73",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "206",
    "Bcolor": "221",
    "Y": 58,
    "L": 80.978578798041,
    "a": -7.7607268480035,
    "b": -11.5831983068805,
    "C": 13.9427172468584,
    "h": 0.98049053426076,
    "CMY_C": 0.3224262,
    "CMY_M": 0.1902811,
    "CMY_Y": 0.1348471,
    "CMYK_C": 0.2168161,
    "CMYK_M": 0.06407413,
    "CMYK_Y": 0,
    "CMYK_K": 0.1348471
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07359",
    "Farbtonhilfsbezeichnung": "R4.24.68",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "195",
    "Bcolor": "217",
    "Y": 49,
    "L": 75.2789895553434,
    "a": -14.3442524585555,
    "b": -18.6005784139289,
    "C": 23.4891271853063,
    "h": 0.91388201778653,
    "CMY_C": 0.4875877,
    "CMY_M": 0.2364445,
    "CMY_Y": 0.1477208,
    "CMYK_C": 0.3987741,
    "CMYK_M": 0.1041017,
    "CMYK_Y": 0,
    "CMYK_K": 0.1477208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07360",
    "Farbtonhilfsbezeichnung": "R4.32.62",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "184",
    "Bcolor": "212",
    "Y": 41,
    "L": 70.2968519549548,
    "a": -19.0681928537386,
    "b": -23.3646039935331,
    "C": 30.1579292804064,
    "h": 0.88630639605206,
    "CMY_C": 0.6406407,
    "CMY_M": 0.2795032,
    "CMY_Y": 0.1688884,
    "CMYK_C": 0.567616,
    "CMYK_M": 0.1330925,
    "CMYK_Y": 0,
    "CMYK_K": 0.1688884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07361",
    "Farbtonhilfsbezeichnung": "R6.32.60",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "177",
    "Bcolor": "207",
    "Y": 38,
    "L": 68.3087743718503,
    "a": -16.3772183555518,
    "b": -23.6319788335337,
    "C": 28.7521078297576,
    "h": 0.96477646736007,
    "CMY_C": 0.6277432,
    "CMY_M": 0.3057011,
    "CMY_Y": 0.1884672,
    "CMYK_C": 0.5412917,
    "CMYK_M": 0.1444599,
    "CMYK_Y": 0,
    "CMYK_K": 0.1884672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07362",
    "Farbtonhilfsbezeichnung": "R4.45.58",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "173",
    "Bcolor": "211",
    "Y": 35,
    "L": 65.4224240953763,
    "a": -24.1756422805859,
    "b": -30.5995524624377,
    "C": 38.9973626105706,
    "h": 0.90214259985031,
    "CMY_C": 1,
    "CMY_M": 0.3199614,
    "CMY_Y": 0.1717116,
    "CMYK_C": 1,
    "CMYK_M": 0.1789833,
    "CMYK_Y": 0,
    "CMYK_K": 0.1717116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07363",
    "Farbtonhilfsbezeichnung": "R7.45.53",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "160",
    "Bcolor": "202",
    "Y": 29,
    "L": 61.1262231960642,
    "a": -20.3894367148124,
    "b": -31.8545036630094,
    "C": 37.8211387079239,
    "h": 1.00142625022537,
    "CMY_C": 1,
    "CMY_M": 0.3713885,
    "CMY_Y": 0.2095347,
    "CMYK_C": 1,
    "CMYK_M": 0.2047575,
    "CMYK_Y": 0,
    "CMYK_K": 0.2095347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07364",
    "Farbtonhilfsbezeichnung": "R5.39.59",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "176",
    "Bcolor": "211",
    "Y": 37,
    "L": 66.9756382501336,
    "a": -20.2719862401159,
    "b": -27.8622908620717,
    "C": 34.4566492596441,
    "h": 0.94180048947674,
    "CMY_C": 0.7589846,
    "CMY_M": 0.3112618,
    "CMY_Y": 0.1736145,
    "CMYK_C": 0.7083499,
    "CMYK_M": 0.1665655,
    "CMYK_Y": 0,
    "CMYK_K": 0.1736145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07365",
    "Farbtonhilfsbezeichnung": "R7.22.64",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "180",
    "Bcolor": "201",
    "Y": 42,
    "L": 70.6124202449293,
    "a": -11.8340411649024,
    "b": -16.4432091085855,
    "C": 20.2589154714974,
    "h": 0.9469763442525,
    "CMY_C": 0.4972769,
    "CMY_M": 0.2923166,
    "CMY_Y": 0.2136622,
    "CMYK_C": 0.3606779,
    "CMYK_M": 0.1000262,
    "CMYK_Y": 0,
    "CMYK_K": 0.2136622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07366",
    "Farbtonhilfsbezeichnung": "R3.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "207",
    "Bcolor": "215",
    "Y": 59,
    "L": 81.1995428363517,
    "a": -7.18009803858594,
    "b": -8.23549880335113,
    "C": 10.9259895837267,
    "h": 0.85375467511351,
    "CMY_C": 0.2997328,
    "CMY_M": 0.1901426,
    "CMY_Y": 0.1565828,
    "CMYK_C": 0.1697263,
    "CMYK_M": 0.0397903,
    "CMYK_Y": 0,
    "CMYK_K": 0.1565828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07367",
    "Farbtonhilfsbezeichnung": "R9.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "216",
    "Bcolor": "228",
    "Y": 66,
    "L": 84.8058547973633,
    "a": -6.26573419570923,
    "b": -9.52041244506836,
    "C": 11.3972663879395,
    "h": 236.649612426758,
    "CMY_C": 0.25840353965759,
    "CMY_M": 0.15212976932526,
    "CMY_Y": 0.10743123292923,
    "CMYK_C": 0.16914361715317,
    "CMYK_M": 0.05007853358984,
    "CMYK_Y": 0,
    "CMYK_K": 0.10743123292923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07368",
    "Farbtonhilfsbezeichnung": "R5.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "199",
    "Bcolor": "202",
    "Y": 56,
    "L": 79.5318355234309,
    "a": -2.8957961776207,
    "b": -3.7544817429662,
    "C": 4.74149434889352,
    "h": 0.91380794365107,
    "CMY_C": 0.2634503,
    "CMY_M": 0.2190945,
    "CMY_Y": 0.2065579,
    "CMYK_C": 0.0717033,
    "CMYK_M": 0.01580021,
    "CMYK_Y": 0,
    "CMYK_K": 0.2065579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07369",
    "Farbtonhilfsbezeichnung": "R4.14.67",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "189",
    "Bcolor": "202",
    "Y": 47,
    "L": 74.3983822016914,
    "a": -8.24131200081629,
    "b": -11.3538608957014,
    "C": 14.0295894713187,
    "h": 0.94292474619536,
    "CMY_C": 0.395716,
    "CMY_M": 0.260696,
    "CMY_Y": 0.2083694,
    "CMYK_C": 0.2366592,
    "CMYK_M": 0.06609985,
    "CMYK_Y": 0,
    "CMYK_K": 0.2083694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07370",
    "Farbtonhilfsbezeichnung": "R4.20.65",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "186",
    "Bcolor": "204",
    "Y": 45,
    "L": 72.9442429300921,
    "a": -11.2759265230679,
    "b": -14.9771723659958,
    "C": 18.7473254368289,
    "h": 0.92545827233485,
    "CMY_C": 0.4585406,
    "CMY_M": 0.2689388,
    "CMY_Y": 0.1987123,
    "CMYK_C": 0.3242634,
    "CMYK_M": 0.08764211,
    "CMYK_Y": 0,
    "CMYK_K": 0.1987123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07371",
    "Farbtonhilfsbezeichnung": "R6.29.56",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "164",
    "Bcolor": "190",
    "Y": 33,
    "L": 64.1296133658641,
    "a": -14.2056618450991,
    "b": -20.5327728595107,
    "C": 24.9678911756192,
    "h": 0.96555905633675,
    "CMY_C": 0.6205833,
    "CMY_M": 0.3550266,
    "CMY_Y": 0.2550815,
    "CMYK_C": 0.4906601,
    "CMYK_M": 0.1341692,
    "CMYK_Y": 0,
    "CMYK_K": 0.2550815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07372",
    "Farbtonhilfsbezeichnung": "R4.41.53",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "161",
    "Bcolor": "195",
    "Y": 30,
    "L": 61.6649782627709,
    "a": -19.7576346417935,
    "b": -27.0214942565463,
    "C": 33.4742479899872,
    "h": 0.93944780925885,
    "CMY_C": 0.8164176,
    "CMY_M": 0.3685724,
    "CMY_Y": 0.2371021,
    "CMYK_C": 0.7593617,
    "CMYK_M": 0.1723302,
    "CMYK_Y": 0,
    "CMYK_K": 0.2371021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07373",
    "Farbtonhilfsbezeichnung": "R6.41.52",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "157",
    "Bcolor": "192",
    "Y": 28,
    "L": 60.0705061643616,
    "a": -19.2641917882417,
    "b": -27.9924936039022,
    "C": 33.9807119321927,
    "h": 0.968039678579,
    "CMY_C": 0.8506716,
    "CMY_M": 0.3857636,
    "CMY_Y": 0.2475297,
    "CMYK_C": 0.8015492,
    "CMYK_M": 0.1837069,
    "CMYK_Y": 0,
    "CMYK_K": 0.2475297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07374",
    "Farbtonhilfsbezeichnung": "R3.50.47",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "147",
    "Bcolor": "183",
    "Y": 23,
    "L": 55.5214039361594,
    "a": -24.0424659138475,
    "b": -29.9382082672817,
    "C": 38.3970894922213,
    "h": 0.89418645805317,
    "CMY_C": 1,
    "CMY_M": 0.4242737,
    "CMY_Y": 0.2832799,
    "CMYK_C": 1,
    "CMYK_M": 0.1967209,
    "CMYK_Y": 0,
    "CMYK_K": 0.2832799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07375",
    "Farbtonhilfsbezeichnung": "R4.31.54",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "160",
    "Bcolor": "185",
    "Y": 30,
    "L": 62.0508193492773,
    "a": -15.9490077406633,
    "b": -20.7213874664153,
    "C": 26.14855151715,
    "h": 0.91481337221879,
    "CMY_C": 0.6676191,
    "CMY_M": 0.3734966,
    "CMY_Y": 0.2761517,
    "CMYK_C": 0.5408141,
    "CMYK_M": 0.1344824,
    "CMYK_Y": 0,
    "CMYK_K": 0.2761517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07376",
    "Farbtonhilfsbezeichnung": "R9.28.53",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "156",
    "Bcolor": "183",
    "Y": 30,
    "L": 61.4242383183847,
    "a": -11.9740117697464,
    "b": -20.6747964219308,
    "C": 23.8919267735004,
    "h": 1.04584143718006,
    "CMY_C": 0.6241053,
    "CMY_M": 0.3874762,
    "CMY_Y": 0.2827959,
    "CMYK_C": 0.4758888,
    "CMYK_M": 0.1459561,
    "CMYK_Y": 0,
    "CMYK_K": 0.2827959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07377",
    "Farbtonhilfsbezeichnung": "R5.21.61",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "176",
    "Bcolor": "195",
    "Y": 40,
    "L": 69.103401184082,
    "a": -11.6000394821167,
    "b": -15.923454284668,
    "C": 19.7006931304932,
    "h": 233.927124023438,
    "CMY_C": 0.50772833824158,
    "CMY_M": 0.30901211500168,
    "CMY_Y": 0.23357981443405,
    "CMYK_C": 0.35770002007484,
    "CMYK_M": 0.09842159599066,
    "CMYK_Y": 0,
    "CMYK_K": 0.23357981443405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07379",
    "Farbtonhilfsbezeichnung": "R7.10.67",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "190",
    "Bcolor": "200",
    "Y": 49,
    "L": 75.6064251249956,
    "a": -5.98246482141973,
    "b": -8.31168855209126,
    "C": 10.2408032852159,
    "h": 0.94692787610801,
    "CMY_C": 0.3492512,
    "CMY_M": 0.2534167,
    "CMY_Y": 0.2167189,
    "CMYK_C": 0.1692014,
    "CMYK_M": 0.04685138,
    "CMYK_Y": 0,
    "CMYK_K": 0.2167189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07380",
    "Farbtonhilfsbezeichnung": "R6.03.72",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "197",
    "Bcolor": "199",
    "Y": 55,
    "L": 78.9799987999947,
    "a": -2.25643372991174,
    "b": -2.82670273457493,
    "C": 3.6168690226682,
    "h": 0.89711942079612,
    "CMY_C": 0.260811,
    "CMY_M": 0.2267863,
    "CMY_Y": 0.2191136,
    "CMYK_C": 0.05339749,
    "CMYK_M": 0.009825624,
    "CMYK_Y": 0,
    "CMYK_K": 0.2191136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07381",
    "Farbtonhilfsbezeichnung": "R6.13.61",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "172",
    "Bcolor": "184",
    "Y": 39,
    "L": 68.4659634438358,
    "a": -7.34203585294685,
    "b": -10.3600107115878,
    "C": 12.6978467627457,
    "h": 0.95426193534479,
    "CMY_C": 0.4449936,
    "CMY_M": 0.3261261,
    "CMY_Y": 0.2789411,
    "CMYK_C": 0.2302897,
    "CMYK_M": 0.0654384,
    "CMYK_Y": 0,
    "CMYK_K": 0.2789411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07382",
    "Farbtonhilfsbezeichnung": "R7.05.55",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "152",
    "Bcolor": "156",
    "Y": 31,
    "L": 62.2436489770215,
    "a": -2.46052237768557,
    "b": -4.12200794029849,
    "C": 4.80053328610221,
    "h": 1.03264221358716,
    "CMY_C": 0.4427191,
    "CMY_M": 0.4032171,
    "CMY_Y": 0.386769,
    "CMYK_C": 0.09123826,
    "CMYK_M": 0.02682216,
    "CMYK_Y": 0,
    "CMYK_K": 0.386769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07383",
    "Farbtonhilfsbezeichnung": "R4.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "155",
    "Bcolor": "171",
    "Y": 30,
    "L": 61.2568622980258,
    "a": -10.7989306956904,
    "b": -13.863881789388,
    "C": 17.5733924567925,
    "h": 0.90903845248472,
    "CMY_C": 0.5693905,
    "CMY_M": 0.3936405,
    "CMY_Y": 0.3312114,
    "CMYK_C": 0.3561352,
    "CMYK_M": 0.09334657,
    "CMYK_Y": 0,
    "CMYK_K": 0.3312114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07384",
    "Farbtonhilfsbezeichnung": "R6.23.51",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "149",
    "Bcolor": "168",
    "Y": 27,
    "L": 58.9898628828237,
    "a": -10.6153334942473,
    "b": -15.7381880509337,
    "C": 18.9835683769054,
    "h": 0.97739348159961,
    "CMY_C": 0.6017778,
    "CMY_M": 0.4168511,
    "CMY_Y": 0.3421508,
    "CMYK_C": 0.3946603,
    "CMYK_M": 0.1135522,
    "CMYK_Y": 0,
    "CMYK_K": 0.3421508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07385",
    "Farbtonhilfsbezeichnung": "R5.37.47",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "139",
    "Bcolor": "168",
    "Y": 22,
    "L": 54.087238797019,
    "a": -16.2799205469921,
    "b": -23.3584347618415,
    "C": 28.4719561593435,
    "h": 0.96211280106635,
    "CMY_C": 0.7960855,
    "CMY_M": 0.4542663,
    "CMY_Y": 0.3424021,
    "CMYK_C": 0.68991,
    "CMYK_M": 0.1701104,
    "CMYK_Y": 0,
    "CMYK_K": 0.3424021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07386",
    "Farbtonhilfsbezeichnung": "R6.39.49",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "149",
    "Bcolor": "180",
    "Y": 25,
    "L": 57.4900706412906,
    "a": -17.0598885159567,
    "b": -25.2552671066897,
    "C": 30.4773409733709,
    "h": 0.97670445226003,
    "CMY_C": 0.7905108,
    "CMY_M": 0.4173473,
    "CMY_Y": 0.2936963,
    "CMYK_C": 0.7034008,
    "CMYK_M": 0.1750678,
    "CMYK_Y": 0,
    "CMYK_K": 0.2936963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07387",
    "Farbtonhilfsbezeichnung": "R7.45.46",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "141",
    "Bcolor": "178",
    "Y": 22,
    "L": 54.3784556013309,
    "a": -18.2230146080541,
    "b": -29.0838116644542,
    "C": 34.3212232057483,
    "h": 1.01106954183746,
    "CMY_C": 1,
    "CMY_M": 0.4459572,
    "CMY_Y": 0.3008249,
    "CMYK_C": 1,
    "CMYK_M": 0.2075763,
    "CMYK_Y": 0,
    "CMYK_K": 0.3008249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07388",
    "Farbtonhilfsbezeichnung": "R4.57.42",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "171",
    "Y": 18,
    "L": 49.7253646988726,
    "a": -24.0137996613889,
    "b": -32.043884452514,
    "C": 40.0433902783392,
    "h": 0.92767707734625,
    "CMY_C": 1,
    "CMY_M": 0.4829028,
    "CMY_Y": 0.3305297,
    "CMYK_C": 1,
    "CMYK_M": 0.2276025,
    "CMYK_Y": 0,
    "CMYK_K": 0.3305297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07389",
    "Farbtonhilfsbezeichnung": "R4.55.37",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "120",
    "Bcolor": "156",
    "Y": 15,
    "L": 45.678399411123,
    "a": -20.9489234465491,
    "b": -29.7642373542366,
    "C": 36.3973518109313,
    "h": 0.95750540769615,
    "CMY_C": 1,
    "CMY_M": 0.5291227,
    "CMY_Y": 0.3877716,
    "CMYK_C": 1,
    "CMYK_M": 0.2308796,
    "CMYK_Y": 0,
    "CMYK_K": 0.3877716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07390",
    "Farbtonhilfsbezeichnung": "R4.35.39",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "122",
    "Bcolor": "144",
    "Y": 17,
    "L": 47.7230085725909,
    "a": -14.5049279828341,
    "b": -19.1539705824559,
    "C": 24.0263922564498,
    "h": 0.92265197250427,
    "CMY_C": 0.7960227,
    "CMY_M": 0.5228411,
    "CMY_Y": 0.4360119,
    "CMYK_C": 0.6383304,
    "CMYK_M": 0.1539557,
    "CMYK_Y": 0,
    "CMYK_K": 0.4360119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07391",
    "Farbtonhilfsbezeichnung": "R5.26.44",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "132",
    "Bcolor": "150",
    "Y": 20,
    "L": 52.3482873984678,
    "a": -10.8267543486844,
    "b": -15.6293639648121,
    "C": 19.0130383598025,
    "h": 0.96497380360958,
    "CMY_C": 0.6713328,
    "CMY_M": 0.4841643,
    "CMY_Y": 0.4117276,
    "CMYK_C": 0.441301,
    "CMYK_M": 0.1231347,
    "CMYK_Y": 0,
    "CMYK_K": 0.4117276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07392",
    "Farbtonhilfsbezeichnung": "R7.08.52",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "148",
    "Bcolor": "154",
    "Y": 29,
    "L": 60.3481934668199,
    "a": -3.53946167430447,
    "b": -5.78302140841438,
    "C": 6.78020099658183,
    "h": 1.02156821587293,
    "CMY_C": 0.476736,
    "CMY_M": 0.4200039,
    "CMY_Y": 0.3950858,
    "CMYK_C": 0.1349782,
    "CMYK_M": 0.04119284,
    "CMYK_Y": 0,
    "CMYK_K": 0.3950858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07393",
    "Farbtonhilfsbezeichnung": "R6.03.39",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "106",
    "Bcolor": "108",
    "Y": 14,
    "L": 44.2314478112938,
    "a": -1.386560379396,
    "b": -2.42416905993716,
    "C": 2.79269499173601,
    "h": 1.05123954228435,
    "CMY_C": 0.6073227,
    "CMY_M": 0.5862417,
    "CMY_Y": 0.5779165,
    "CMYK_C": 0.06966911,
    "CMYK_M": 0.01972391,
    "CMYK_Y": 0,
    "CMYK_K": 0.5779165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07394",
    "Farbtonhilfsbezeichnung": "R6.07.49",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "138",
    "Bcolor": "143",
    "Y": 24,
    "L": 56.4584875897783,
    "a": -3.55595519373708,
    "b": -5.14456642740553,
    "C": 6.25390926268153,
    "h": 0.96599678969309,
    "CMY_C": 0.5135641,
    "CMY_M": 0.4598716,
    "CMY_Y": 0.4391735,
    "CMYK_C": 0.1326444,
    "CMYK_M": 0.03690644,
    "CMYK_Y": 0,
    "CMYK_K": 0.4391735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07395",
    "Farbtonhilfsbezeichnung": "R5.25.34",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "107",
    "Bcolor": "122",
    "Y": 13,
    "L": 42.9587092164043,
    "a": -9.05193412047811,
    "b": -13.4799761500193,
    "C": 16.2372186142382,
    "h": 0.97944837597133,
    "CMY_C": 0.7330663,
    "CMY_M": 0.5809578,
    "CMY_Y": 0.5202155,
    "CMYK_C": 0.4436384,
    "CMYK_M": 0.1266033,
    "CMYK_Y": 0,
    "CMYK_K": 0.5202155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07396",
    "Farbtonhilfsbezeichnung": "R6.30.39",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "119",
    "Bcolor": "139",
    "Y": 16,
    "L": 47.1184160697886,
    "a": -11.7893310590526,
    "b": -17.4378986545141,
    "C": 21.0491956213306,
    "h": 0.97630836714572,
    "CMY_C": 0.7494249,
    "CMY_M": 0.5341033,
    "CMY_Y": 0.453178,
    "CMYK_C": 0.5417611,
    "CMYK_M": 0.1479921,
    "CMYK_Y": 0,
    "CMYK_K": 0.453178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07397",
    "Farbtonhilfsbezeichnung": "R7.38.37",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "117",
    "Bcolor": "143",
    "Y": 15,
    "L": 45.8874464929886,
    "a": -13.6170304830558,
    "b": -21.7065980267187,
    "C": 25.6242056866163,
    "h": 1.0105288688237,
    "CMY_C": 0.8332775,
    "CMY_M": 0.5417251,
    "CMY_Y": 0.4379272,
    "CMYK_C": 0.7033791,
    "CMYK_M": 0.1846698,
    "CMYK_Y": 0,
    "CMYK_K": 0.4379272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07398",
    "Farbtonhilfsbezeichnung": "R4.54.31",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "106",
    "Bcolor": "136",
    "Y": 11,
    "L": 40.3977190566333,
    "a": -19.0442300577549,
    "b": -25.7348547835197,
    "C": 32.0150815901122,
    "h": 0.9337150122197,
    "CMY_C": 1,
    "CMY_M": 0.5854713,
    "CMY_Y": 0.4679105,
    "CMYK_C": 1,
    "CMYK_M": 0.2209419,
    "CMYK_Y": 0,
    "CMYK_K": 0.4679105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07399",
    "Farbtonhilfsbezeichnung": "R6.56.35",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "153",
    "Y": 14,
    "L": 44.0670397531203,
    "a": -20.2288403664231,
    "b": -30.4417209612693,
    "C": 36.5500254124947,
    "h": 0.98428800483435,
    "CMY_C": 1,
    "CMY_M": 0.5459769,
    "CMY_Y": 0.399964,
    "CMYK_C": 1,
    "CMYK_M": 0.2433403,
    "CMYK_Y": 0,
    "CMYK_K": 0.399964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07400",
    "Farbtonhilfsbezeichnung": "R6.49.32",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "108",
    "Bcolor": "139",
    "Y": 12,
    "L": 41.8158881639728,
    "a": -17.1145266591273,
    "b": -25.541310919333,
    "C": 30.745171754993,
    "h": 0.98043963549652,
    "CMY_C": 1,
    "CMY_M": 0.5746825,
    "CMY_Y": 0.4546729,
    "CMYK_C": 1,
    "CMYK_M": 0.220069,
    "CMYK_Y": 0,
    "CMYK_K": 0.4546729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07401",
    "Farbtonhilfsbezeichnung": "R4.45.29",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "124",
    "Y": 11,
    "L": 38.879223583406,
    "a": -15.4460222955554,
    "b": -21.0347707366518,
    "C": 26.0967657900035,
    "h": 0.93741329596608,
    "CMY_C": 1,
    "CMY_M": 0.6073042,
    "CMY_Y": 0.5129074,
    "CMYK_C": 1,
    "CMYK_M": 0.1937966,
    "CMYK_Y": 0,
    "CMYK_K": 0.5129074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07402",
    "Farbtonhilfsbezeichnung": "R5.29.30",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "98",
    "Bcolor": "113",
    "Y": 11,
    "L": 39.0933443375254,
    "a": -9.38992204382419,
    "b": -13.8296662533394,
    "C": 16.7161689590603,
    "h": 0.974324647072,
    "CMY_C": 0.7768702,
    "CMY_M": 0.6174943,
    "CMY_Y": 0.5559697,
    "CMYK_C": 0.4974897,
    "CMYK_M": 0.1385596,
    "CMYK_Y": 0,
    "CMYK_K": 0.5559697
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07403",
    "Farbtonhilfsbezeichnung": "R3.20.34",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "105",
    "Bcolor": "116",
    "Y": 13,
    "L": 42.529995980489,
    "a": -8.31493018463827,
    "b": -10.1098343392907,
    "C": 13.0899508915545,
    "h": 0.88250975600039,
    "CMY_C": 0.7109433,
    "CMY_M": 0.5874162,
    "CMY_Y": 0.5459478,
    "CMYK_C": 0.3633845,
    "CMYK_M": 0.09132947,
    "CMYK_Y": 0,
    "CMYK_K": 0.5459478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07404",
    "Farbtonhilfsbezeichnung": "R4.14.34",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "104",
    "Bcolor": "111",
    "Y": 13,
    "L": 42.5994475845134,
    "a": -4.88413056770914,
    "b": -7.16680059621475,
    "C": 8.67281743081998,
    "h": 0.97259886883694,
    "CMY_C": 0.6669863,
    "CMY_M": 0.5939069,
    "CMY_Y": 0.5637398,
    "CMYK_C": 0.2366628,
    "CMYK_M": 0.06914955,
    "CMYK_Y": 0,
    "CMYK_K": 0.5637398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07405",
    "Farbtonhilfsbezeichnung": "R2.06.37",
    "Farbtonklasse": "02",
    "Rcolor": "99",
    "Gcolor": "109",
    "Bcolor": "112",
    "Y": 15,
    "L": 45.1683841527953,
    "a": -2.66531768087552,
    "b": -3.73021278486223,
    "C": 4.58458348820668,
    "h": 0.95039065059957,
    "CMY_C": 0.612157,
    "CMY_M": 0.5742602,
    "CMY_Y": 0.5605939,
    "CMYK_C": 0.1173472,
    "CMYK_M": 0.03110163,
    "CMYK_Y": 0,
    "CMYK_K": 0.5605939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07406",
    "Farbtonhilfsbezeichnung": "R6.03.35",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "108",
    "Bcolor": "111",
    "Y": 15,
    "L": 45.1089156334536,
    "a": -1.52864573004707,
    "b": -2.90895458233158,
    "C": 3.28614889042768,
    "h": 1.0869601088072,
    "CMY_C": 0.60154,
    "CMY_M": 0.577327,
    "CMY_Y": 0.5663333,
    "CMYK_C": 0.08118372,
    "CMYK_M": 0.02535041,
    "CMYK_Y": 0,
    "CMYK_K": 0.5663333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07407",
    "Farbtonhilfsbezeichnung": "Q9.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "71",
    "Bcolor": "74",
    "Y": 6,
    "L": 29.7643377947856,
    "a": -2.33363072444431,
    "b": -2.99926898245256,
    "C": 3.80019036196511,
    "h": 0.90957328598174,
    "CMY_C": 0.7499152,
    "CMY_M": 0.7198132,
    "CMY_Y": 0.7097654,
    "CMYK_C": 0.1383357,
    "CMYK_M": 0.03461969,
    "CMYK_Y": 0,
    "CMYK_K": 0.7097654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07408",
    "Farbtonhilfsbezeichnung": "R6.06.30",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "91",
    "Bcolor": "94",
    "Y": 10,
    "L": 37.9370973117685,
    "a": -2.03738304614023,
    "b": -3.22761766006199,
    "C": 3.81686329808177,
    "h": 1.00772645941093,
    "CMY_C": 0.6741406,
    "CMY_M": 0.6448374,
    "CMY_Y": 0.6328923,
    "CMYK_C": 0.1123601,
    "CMYK_M": 0.03253835,
    "CMYK_Y": 0,
    "CMYK_K": 0.6328923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07409",
    "Farbtonhilfsbezeichnung": "R5.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "77",
    "Bcolor": "86",
    "Y": 7,
    "L": 31.5151765711538,
    "a": -4.90966335482038,
    "b": -7.86202774091915,
    "C": 9.2691032174989,
    "h": 1.01257247074219,
    "CMY_C": 0.7726349,
    "CMY_M": 0.697982,
    "CMY_Y": 0.6646662,
    "CMYK_C": 0.3219737,
    "CMYK_M": 0.09935117,
    "CMYK_Y": 0,
    "CMYK_K": 0.6646662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07410",
    "Farbtonhilfsbezeichnung": "R4.20.25",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "84",
    "Bcolor": "94",
    "Y": 8,
    "L": 34.457555588738,
    "a": -5.66416885625298,
    "b": -8.61393179043984,
    "C": 10.3093467165721,
    "h": 0.98912552373602,
    "CMY_C": 0.7556247,
    "CMY_M": 0.6692587,
    "CMY_Y": 0.6326307,
    "CMYK_C": 0.3347967,
    "CMYK_M": 0.09970326,
    "CMYK_Y": 0,
    "CMYK_K": 0.6326307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07411",
    "Farbtonhilfsbezeichnung": "R4.33.20",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "76",
    "Bcolor": "90",
    "Y": 6,
    "L": 30.2128392485242,
    "a": -9.39147274540911,
    "b": -12.7774605767994,
    "C": 15.8575931061251,
    "h": 0.93696254497585,
    "CMY_C": 0.8571069,
    "CMY_M": 0.7009805,
    "CMY_Y": 0.6474042,
    "CMYK_C": 0.5947397,
    "CMYK_M": 0.1519482,
    "CMYK_Y": 0,
    "CMYK_K": 0.6474042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07412",
    "Farbtonhilfsbezeichnung": "R4.39.25",
    "Farbtonklasse": "04",
    "Rcolor": "29",
    "Gcolor": "87",
    "Bcolor": "105",
    "Y": 8,
    "L": 34.3145973572623,
    "a": -12.1154511349605,
    "b": -16.221275524277,
    "C": 20.2463314167807,
    "h": 0.9292908602039,
    "CMY_C": 0.88479,
    "CMY_M": 0.6575198,
    "CMY_Y": 0.58754,
    "CMYK_C": 0.7206759,
    "CMYK_M": 0.1696643,
    "CMYK_Y": 0,
    "CMYK_K": 0.58754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07413",
    "Farbtonhilfsbezeichnung": "R4.51.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "84",
    "Bcolor": "105",
    "Y": 7,
    "L": 32.292764428372,
    "a": -14.1943385819233,
    "b": -19.0084661134882,
    "C": 23.723427909261,
    "h": 0.92938635082184,
    "CMY_C": 1,
    "CMY_M": 0.6723577,
    "CMY_Y": 0.5899479,
    "CMYK_C": 1,
    "CMYK_M": 0.2009739,
    "CMYK_Y": 0,
    "CMYK_K": 0.5899479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07414",
    "Farbtonhilfsbezeichnung": "R4.58.28",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "130",
    "Y": 10,
    "L": 38.1382136783413,
    "a": -19.2336687092126,
    "b": -26.0211854454055,
    "C": 32.3579372642931,
    "h": 0.93427273730561,
    "CMY_C": 1,
    "CMY_M": 0.6069977,
    "CMY_Y": 0.4888404,
    "CMYK_C": 1,
    "CMYK_M": 0.2311554,
    "CMYK_Y": 0,
    "CMYK_K": 0.4888404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07415",
    "Farbtonhilfsbezeichnung": "R4.57.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "116",
    "Y": 8,
    "L": 33.7909719541256,
    "a": -18.6380340688456,
    "b": -23.9688887491351,
    "C": 30.36254175493,
    "h": 0.90986845606951,
    "CMY_C": 1,
    "CMY_M": 0.6501318,
    "CMY_Y": 0.5449103,
    "CMYK_C": 1,
    "CMYK_M": 0.2312105,
    "CMYK_Y": 0,
    "CMYK_K": 0.5449103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07416",
    "Farbtonhilfsbezeichnung": "R4.45.20",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "77",
    "Bcolor": "95",
    "Y": 6,
    "L": 29.6463164421198,
    "a": -13.5418045798376,
    "b": -17.321375942538,
    "C": 21.9865990053315,
    "h": 0.90725357369736,
    "CMY_C": 1,
    "CMY_M": 0.6984015,
    "CMY_Y": 0.6255076,
    "CMYK_C": 1,
    "CMYK_M": 0.194647,
    "CMYK_Y": 0,
    "CMYK_K": 0.6255076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07417",
    "Farbtonhilfsbezeichnung": "R6.38.21",
    "Farbtonklasse": "04",
    "Rcolor": "26",
    "Gcolor": "78",
    "Bcolor": "96",
    "Y": 7,
    "L": 30.6508405642272,
    "a": -10.5286607479845,
    "b": -15.8366259312629,
    "C": 19.0171348534131,
    "h": 0.98406648299766,
    "CMY_C": 0.8975207,
    "CMY_M": 0.6942303,
    "CMY_Y": 0.6247998,
    "CMYK_C": 0.7268677,
    "CMYK_M": 0.1850491,
    "CMYK_Y": 0,
    "CMYK_K": 0.6247998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07418",
    "Farbtonhilfsbezeichnung": "R4.29.16",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "64",
    "Bcolor": "74",
    "Y": 5,
    "L": 25.4045512547537,
    "a": -7.59976670296619,
    "b": -9.85238590787303,
    "C": 12.4429081012908,
    "h": 0.91376245252243,
    "CMY_C": 0.8625124,
    "CMY_M": 0.7481393,
    "CMY_Y": 0.7090316,
    "CMYK_C": 0.5274825,
    "CMYK_M": 0.1344052,
    "CMYK_Y": 0,
    "CMYK_K": 0.7090316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07419",
    "Farbtonhilfsbezeichnung": "R7.24.16",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "66",
    "Bcolor": "76",
    "Y": 5,
    "L": 26.7589088598711,
    "a": -5.22577844348385,
    "b": -9.01819222035568,
    "C": 10.4228859373815,
    "h": 1.04560866463525,
    "CMY_C": 0.8233607,
    "CMY_M": 0.7401821,
    "CMY_Y": 0.7014639,
    "CMYK_C": 0.4083149,
    "CMYK_M": 0.1296933,
    "CMYK_Y": 0,
    "CMYK_K": 0.7014639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07420",
    "Farbtonhilfsbezeichnung": "R6.18.13",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "65",
    "Bcolor": "71",
    "Y": 5,
    "L": 26.4369680410715,
    "a": -3.99741333214934,
    "b": -6.16300337975902,
    "C": 7.34587802832081,
    "h": 0.99539571505223,
    "CMY_C": 0.8031545,
    "CMY_M": 0.7459141,
    "CMY_Y": 0.7211226,
    "CMYK_C": 0.2941507,
    "CMYK_M": 0.08889759,
    "CMYK_Y": 0,
    "CMYK_K": 0.7211226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07421",
    "Farbtonhilfsbezeichnung": "R7.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "73",
    "Bcolor": "78",
    "Y": 6,
    "L": 30.3901354601459,
    "a": -2.44804495138209,
    "b": -4.78219830053561,
    "C": 5.37236862748947,
    "h": 1.09766786502415,
    "CMY_C": 0.7513685,
    "CMY_M": 0.7134849,
    "CMY_Y": 0.6933879,
    "CMYK_C": 0.1891009,
    "CMYK_M": 0.0655455,
    "CMYK_Y": 0,
    "CMYK_K": 0.6933879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07422",
    "Farbtonhilfsbezeichnung": "R7.11.09",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "57",
    "Bcolor": "60",
    "Y": 4,
    "L": 23.4855469580657,
    "a": -1.84648675817267,
    "b": -3.08371718245976,
    "C": 3.59427670185596,
    "h": 1.03126993227341,
    "CMY_C": 0.8017979,
    "CMY_M": 0.7764526,
    "CMY_Y": 0.7650398,
    "CMYK_C": 0.1564438,
    "CMYK_M": 0.04857332,
    "CMYK_Y": 0,
    "CMYK_K": 0.7650398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07423",
    "Farbtonhilfsbezeichnung": "S0.30.66",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "190",
    "Bcolor": "226",
    "Y": 45,
    "L": 73.1732142271873,
    "a": -14.3273014990935,
    "b": -26.3426655079262,
    "C": 29.9867903302173,
    "h": 1.07266237103358,
    "CMY_C": 0.5679083,
    "CMY_M": 0.2566055,
    "CMY_Y": 0.1156482,
    "CMYK_C": 0.511403,
    "CMYK_M": 0.1593906,
    "CMYK_Y": 0,
    "CMYK_K": 0.1156482
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07424",
    "Farbtonhilfsbezeichnung": "R9.30.64",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "186",
    "Bcolor": "216",
    "Y": 43,
    "L": 71.8371304502519,
    "a": -14.4777106375048,
    "b": -23.0101258123057,
    "C": 27.185841815207,
    "h": 1.00919059729293,
    "CMY_C": 0.5580099,
    "CMY_M": 0.2718317,
    "CMY_Y": 0.1541071,
    "CMYK_C": 0.4774869,
    "CMYK_M": 0.1391719,
    "CMYK_Y": 0,
    "CMYK_K": 0.1541071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07426",
    "Farbtonhilfsbezeichnung": "R7.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "231",
    "Bcolor": "239",
    "Y": 77,
    "L": 90.115982294458,
    "a": -5.56922305915131,
    "b": -7.69100208886346,
    "C": 9.49567051942541,
    "h": 0.94406394095748,
    "CMY_C": 0.1864998,
    "CMY_M": 0.0953406,
    "CMY_Y": 0.06174621,
    "CMYK_C": 0.1329636,
    "CMYK_M": 0.03580523,
    "CMYK_Y": 0,
    "CMYK_K": 0.06174621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07427",
    "Farbtonhilfsbezeichnung": "R8.40.60",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "179",
    "Bcolor": "220",
    "Y": 38,
    "L": 68.463981628418,
    "a": -19.0400047302246,
    "b": -30.7188835144043,
    "C": 36.1409950256348,
    "h": 238.208770751953,
    "CMY_C": 0.75374293327332,
    "CMY_M": 0.29661583900452,
    "CMY_Y": 0.13703733682632,
    "CMYK_C": 0.71463763713837,
    "CMYK_M": 0.1849193572998,
    "CMYK_Y": 0,
    "CMYK_K": 0.13703733682632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07428",
    "Farbtonhilfsbezeichnung": "R8.25.63",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "182",
    "Bcolor": "209",
    "Y": 42,
    "L": 70.9708914407243,
    "a": -12.367606224585,
    "b": -20.5175420462187,
    "C": 23.9567780668592,
    "h": 1.02833370599653,
    "CMY_C": 0.5248513,
    "CMY_M": 0.2861,
    "CMY_Y": 0.1810466,
    "CMYK_C": 0.4198099,
    "CMYK_M": 0.1282777,
    "CMYK_Y": 0,
    "CMYK_K": 0.1810466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07429",
    "Farbtonhilfsbezeichnung": "S1.18.73",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "208",
    "Bcolor": "229",
    "Y": 59,
    "L": 81.0645694016555,
    "a": -8.95028044126461,
    "b": -16.2530944669629,
    "C": 18.5545304367775,
    "h": 1.06742994742675,
    "CMY_C": 0.3559222,
    "CMY_M": 0.1853083,
    "CMY_Y": 0.1002068,
    "CMYK_C": 0.2841935,
    "CMYK_M": 0.09457894,
    "CMYK_Y": 0,
    "CMYK_K": 0.1002068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07430",
    "Farbtonhilfsbezeichnung": "R8.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "222",
    "Bcolor": "231",
    "Y": 70,
    "L": 87.0923696259131,
    "a": -5.34866909890447,
    "b": -7.75078333705825,
    "C": 9.41716005320051,
    "h": 0.96675840786543,
    "CMY_C": 0.217956,
    "CMY_M": 0.1294522,
    "CMY_Y": 0.09494063,
    "CMYK_C": 0.1359197,
    "CMYK_M": 0.03813188,
    "CMYK_Y": 0,
    "CMYK_K": 0.09494063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07431",
    "Farbtonhilfsbezeichnung": "S1.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "222",
    "Bcolor": "228",
    "Y": 72,
    "L": 87.8117980957031,
    "a": -2.98366355895996,
    "b": -5.21473789215088,
    "C": 6.00797319412231,
    "h": 240.223541259766,
    "CMY_C": 0.17979097366333,
    "CMY_M": 0.12758439779282,
    "CMY_Y": 0.10530000925064,
    "CMYK_C": 0.08325803279877,
    "CMYK_M": 0.02490710653365,
    "CMYK_Y": 0,
    "CMYK_K": 0.10530000925064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07432",
    "Farbtonhilfsbezeichnung": "R9.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "230",
    "Bcolor": "235",
    "Y": 78,
    "L": 90.6061393666685,
    "a": -2.86142448128585,
    "b": -4.64217615325866,
    "C": 5.45321460241437,
    "h": 1.01840721103351,
    "CMY_C": 0.1457977,
    "CMY_M": 0.0969826,
    "CMY_Y": 0.07848788,
    "CMYK_C": 0.07304284,
    "CMYK_M": 0.02006997,
    "CMYK_Y": 0,
    "CMYK_K": 0.07848788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07433",
    "Farbtonhilfsbezeichnung": "S0.29.60",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "175",
    "Bcolor": "207",
    "Y": 38,
    "L": 68.0110835385094,
    "a": -13.1909212980704,
    "b": -23.8491242952862,
    "C": 27.254011344092,
    "h": 1.06557713575772,
    "CMY_C": 0.5911388,
    "CMY_M": 0.3148825,
    "CMY_Y": 0.1899001,
    "CMYK_C": 0.4952954,
    "CMYK_M": 0.1542802,
    "CMYK_Y": 0,
    "CMYK_K": 0.1899001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07434",
    "Farbtonhilfsbezeichnung": "R9.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "208",
    "Bcolor": "223",
    "Y": 60,
    "L": 81.8261184692383,
    "a": -7.11950016021729,
    "b": -11.3992166519165,
    "C": 13.4398441314697,
    "h": 238.012725830078,
    "CMY_C": 0.30664682388306,
    "CMY_M": 0.18243318796158,
    "CMY_Y": 0.12677139043808,
    "CMYK_C": 0.20598894357681,
    "CMYK_M": 0.06374252587557,
    "CMYK_Y": 0,
    "CMYK_K": 0.12677139043808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07435",
    "Farbtonhilfsbezeichnung": "R8.09.76",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "211",
    "Bcolor": "221",
    "Y": 63,
    "L": 83.3565644808374,
    "a": -5.20864277652799,
    "b": -8.30042102028343,
    "C": 9.79933409408212,
    "h": 1.01039016337392,
    "CMY_C": 0.2596408,
    "CMY_M": 0.1708143,
    "CMY_Y": 0.1321948,
    "CMYK_C": 0.1468601,
    "CMYK_M": 0.04450253,
    "CMYK_Y": 0,
    "CMYK_K": 0.1321948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07436",
    "Farbtonhilfsbezeichnung": "SN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "220",
    "Bcolor": "222",
    "Y": 71,
    "L": 87.4761061415419,
    "a": -1.26489147168934,
    "b": -2.20464272872378,
    "C": 2.54173169246226,
    "h": 1.0499095704546,
    "CMY_C": 0.158154,
    "CMY_M": 0.1361854,
    "CMY_Y": 0.1308937,
    "CMYK_C": 0.03136588,
    "CMYK_M": 0.006088653,
    "CMYK_Y": 0,
    "CMYK_K": 0.1308937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07437",
    "Farbtonhilfsbezeichnung": "R8.50.50",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "151",
    "Bcolor": "196",
    "Y": 25,
    "L": 57.3298239795263,
    "a": -22.0134082994905,
    "b": -34.7542584204507,
    "C": 41.1393804439924,
    "h": 1.00617810031814,
    "CMY_C": 1,
    "CMY_M": 0.4071077,
    "CMY_Y": 0.2308087,
    "CMYK_C": 1,
    "CMYK_M": 0.2292005,
    "CMYK_Y": 0,
    "CMYK_K": 0.2308087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07438",
    "Farbtonhilfsbezeichnung": "R9.40.53",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "159",
    "Bcolor": "196",
    "Y": 30,
    "L": 61.2440603934117,
    "a": -16.5693025366051,
    "b": -28.7071698026492,
    "C": 33.1457898476969,
    "h": 1.04732269474166,
    "CMY_C": 0.7769156,
    "CMY_M": 0.3780569,
    "CMY_Y": 0.2297402,
    "CMYK_C": 0.7103776,
    "CMYK_M": 0.1925541,
    "CMYK_Y": 0,
    "CMYK_K": 0.2297402
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07439",
    "Farbtonhilfsbezeichnung": "R7.24.71",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "203",
    "Bcolor": "230",
    "Y": 54,
    "L": 78.2773639463128,
    "a": -13.6189793367628,
    "b": -20.6414668146144,
    "C": 24.7294712930543,
    "h": 0.98757143866237,
    "CMY_C": 0.4602386,
    "CMY_M": 0.2046333,
    "CMY_Y": 0.0998866,
    "CMYK_C": 0.4003407,
    "CMYK_M": 0.1163705,
    "CMYK_Y": 0,
    "CMYK_K": 0.0998866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07440",
    "Farbtonhilfsbezeichnung": "R9.18.71",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "199",
    "Bcolor": "220",
    "Y": 53,
    "L": 77.7994360642578,
    "a": -9.63218240794195,
    "b": -15.9199067414024,
    "C": 18.6070515825269,
    "h": 1.02667908939385,
    "CMY_C": 0.3958306,
    "CMY_M": 0.2195868,
    "CMY_Y": 0.1387537,
    "CMYK_C": 0.2984941,
    "CMYK_M": 0.09385598,
    "CMYK_Y": 0,
    "CMYK_K": 0.1387537
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07441",
    "Farbtonhilfsbezeichnung": "R9.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "204",
    "Bcolor": "210",
    "Y": 58,
    "L": 80.947380065918,
    "a": -3.53370594978333,
    "b": -5.68106031417847,
    "C": 6.69040536880493,
    "h": 238.117767333984,
    "CMY_C": 0.26081222295761,
    "CMY_M": 0.2016773223877,
    "CMY_Y": 0.17736905813217,
    "CMYK_C": 0.10143450647593,
    "CMYK_M": 0.02954941615462,
    "CMYK_Y": 0,
    "CMYK_K": 0.17736905813217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07442",
    "Farbtonhilfsbezeichnung": "S0.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "196",
    "Bcolor": "199",
    "Y": 54,
    "L": 78.4729245483278,
    "a": -1.90186297819855,
    "b": -3.45510841732135,
    "C": 3.94396462500453,
    "h": 1.06760801418018,
    "CMY_C": 0.2657198,
    "CMY_M": 0.2328973,
    "CMY_Y": 0.2200257,
    "CMYK_C": 0.05858412,
    "CMYK_M": 0.01650268,
    "CMYK_Y": 0,
    "CMYK_K": 0.2200257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07443",
    "Farbtonhilfsbezeichnung": "R9.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "171",
    "Bcolor": "190",
    "Y": 37,
    "L": 67.5815895566858,
    "a": -9.26742506336414,
    "b": -15.3923349272332,
    "C": 17.9668901543142,
    "h": 1.02884843426049,
    "CMY_C": 0.497363,
    "CMY_M": 0.3299819,
    "CMY_Y": 0.253409,
    "CMYK_C": 0.3267572,
    "CMYK_M": 0.1025634,
    "CMYK_Y": 0,
    "CMYK_K": 0.253409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07444",
    "Farbtonhilfsbezeichnung": "R8.36.54",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "159",
    "Bcolor": "192",
    "Y": 30,
    "L": 61.7741627676584,
    "a": -15.8630420657036,
    "b": -25.4029808693199,
    "C": 29.9490824671694,
    "h": 1.01258834784351,
    "CMY_C": 0.7150232,
    "CMY_M": 0.3749704,
    "CMY_Y": 0.246798,
    "CMYK_C": 0.6216463,
    "CMYK_M": 0.17017,
    "CMYK_Y": 0,
    "CMYK_K": 0.246798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07445",
    "Farbtonhilfsbezeichnung": "S0.41.49",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "148",
    "Bcolor": "185",
    "Y": 25,
    "L": 57.2325999367989,
    "a": -15.6865627453228,
    "b": -28.5583298070033,
    "C": 32.5829165687868,
    "h": 1.06850490094558,
    "CMY_C": 0.8154892,
    "CMY_M": 0.4212728,
    "CMY_Y": 0.273803,
    "CMYK_C": 0.7459219,
    "CMYK_M": 0.2030713,
    "CMYK_Y": 0,
    "CMYK_K": 0.273803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07446",
    "Farbtonhilfsbezeichnung": "R9.49.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "133",
    "Bcolor": "173",
    "Y": 19,
    "L": 50.9879455321738,
    "a": -18.7908959836961,
    "b": -31.3679796987613,
    "C": 36.5656658937313,
    "h": 1.03107781306462,
    "CMY_C": 1,
    "CMY_M": 0.4786702,
    "CMY_Y": 0.3213879,
    "CMYK_C": 1,
    "CMYK_M": 0.2317706,
    "CMYK_Y": 0,
    "CMYK_K": 0.3213879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07447",
    "Farbtonhilfsbezeichnung": "R8.52.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "129",
    "Bcolor": "168",
    "Y": 18,
    "L": 49.3866056548801,
    "a": -18.8475914144035,
    "b": -30.9227819468506,
    "C": 36.2139495975897,
    "h": 1.02341712496225,
    "CMY_C": 1,
    "CMY_M": 0.4949021,
    "CMY_Y": 0.3412458,
    "CMYK_C": 1,
    "CMYK_M": 0.2332529,
    "CMYK_Y": 0,
    "CMYK_K": 0.3412458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07448",
    "Farbtonhilfsbezeichnung": "R9.44.43",
    "Farbtonklasse": "04",
    "Rcolor": "4",
    "Gcolor": "132",
    "Bcolor": "169",
    "Y": 19,
    "L": 51.248460719452,
    "a": -16.5385156212492,
    "b": -28.4257819805354,
    "C": 32.8868907037323,
    "h": 1.0438562841833,
    "CMY_C": 0.9852207,
    "CMY_M": 0.4808748,
    "CMY_Y": 0.3381997,
    "CMYK_C": 0.9776681,
    "CMYK_M": 0.2155863,
    "CMYK_Y": 0,
    "CMYK_K": 0.3381997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07449",
    "Farbtonhilfsbezeichnung": "R9.41.45",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "138",
    "Bcolor": "172",
    "Y": 22,
    "L": 53.6702632495124,
    "a": -15.7155300846157,
    "b": -26.7469766458138,
    "C": 31.0222282489858,
    "h": 1.03957197849238,
    "CMY_C": 0.841504,
    "CMY_M": 0.4583317,
    "CMY_Y": 0.3239165,
    "CMYK_C": 0.7655675,
    "CMYK_M": 0.1988146,
    "CMYK_Y": 0,
    "CMYK_K": 0.3239165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07450",
    "Farbtonhilfsbezeichnung": "R9.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "147",
    "Bcolor": "176",
    "Y": 26,
    "L": 57.9146162674852,
    "a": -12.6137006577127,
    "b": -22.2533419278806,
    "C": 25.5796143685074,
    "h": 1.05512917530167,
    "CMY_C": 0.682637,
    "CMY_M": 0.4220363,
    "CMY_Y": 0.3092851,
    "CMYK_C": 0.5405296,
    "CMYK_M": 0.1632385,
    "CMYK_Y": 0,
    "CMYK_K": 0.3092851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07451",
    "Farbtonhilfsbezeichnung": "R9.06.69",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "193",
    "Bcolor": "199",
    "Y": 52,
    "L": 77.0589148204881,
    "a": -3.52171559902725,
    "b": -5.78659980805856,
    "C": 6.77401048855515,
    "h": 1.02407842248522,
    "CMY_C": 0.3028049,
    "CMY_M": 0.2438782,
    "CMY_Y": 0.2187788,
    "CMYK_C": 0.1075574,
    "CMYK_M": 0.03212843,
    "CMYK_Y": 0,
    "CMYK_K": 0.2187788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07452",
    "Farbtonhilfsbezeichnung": "R8.04.56",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "153",
    "Bcolor": "156",
    "Y": 31,
    "L": 62.653661504132,
    "a": -1.70693869094973,
    "b": -3.05774785820732,
    "C": 3.50192256611031,
    "h": 1.06165344569978,
    "CMY_C": 0.4288898,
    "CMY_M": 0.4008903,
    "CMY_Y": 0.3897429,
    "CMYK_C": 0.06414834,
    "CMYK_M": 0.01826684,
    "CMYK_Y": 0,
    "CMYK_K": 0.3897429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07453",
    "Farbtonhilfsbezeichnung": "R9.37.43",
    "Farbtonklasse": "03",
    "Rcolor": "50",
    "Gcolor": "131",
    "Bcolor": "162",
    "Y": 20,
    "L": 51.4250503254754,
    "a": -14.0182584958857,
    "b": -24.4256971713068,
    "C": 28.1624972891585,
    "h": 1.04977831281488,
    "CMY_C": 0.8031406,
    "CMY_M": 0.4848508,
    "CMY_Y": 0.3629053,
    "CMYK_C": 0.6910045,
    "CMYK_M": 0.1914087,
    "CMYK_Y": 0,
    "CMYK_K": 0.3629053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07454",
    "Farbtonhilfsbezeichnung": "S0.41.43",
    "Farbtonklasse": "03",
    "Rcolor": "35",
    "Gcolor": "131",
    "Bcolor": "167",
    "Y": 19,
    "L": 51.0795535531434,
    "a": -14.3542373276799,
    "b": -27.3927109832119,
    "C": 30.9257941574527,
    "h": 1.08812049461811,
    "CMY_C": 0.8620809,
    "CMY_M": 0.4867034,
    "CMY_Y": 0.3467248,
    "CMYK_C": 0.7888805,
    "CMYK_M": 0.2142721,
    "CMYK_Y": 0,
    "CMYK_K": 0.3467248
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07455",
    "Farbtonhilfsbezeichnung": "R9.42.39",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "124",
    "Bcolor": "157",
    "Y": 17,
    "L": 48.2085865871044,
    "a": -15.02837227749,
    "b": -26.2399822831958,
    "C": 30.2388598252854,
    "h": 1.05067120012405,
    "CMY_C": 0.9120877,
    "CMY_M": 0.5147345,
    "CMY_Y": 0.3843753,
    "CMYK_C": 0.8571983,
    "CMYK_M": 0.2117511,
    "CMYK_Y": 0,
    "CMYK_K": 0.3843753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07456",
    "Farbtonhilfsbezeichnung": "R9.57.37",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "119",
    "Bcolor": "161",
    "Y": 15,
    "L": 45.1104564157703,
    "a": -19.9818102639958,
    "b": -33.2885589653235,
    "C": 38.8252610991111,
    "h": 1.03018523341756,
    "CMY_C": 1,
    "CMY_M": 0.5349563,
    "CMY_Y": 0.3704245,
    "CMYK_C": 1,
    "CMYK_M": 0.2613377,
    "CMYK_Y": 0,
    "CMYK_K": 0.3704245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07457",
    "Farbtonhilfsbezeichnung": "R9.53.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "110",
    "Bcolor": "148",
    "Y": 13,
    "L": 42.1718912169878,
    "a": -17.8806126589924,
    "b": -30.2624509440983,
    "C": 35.1501386370648,
    "h": 1.03713086822199,
    "CMY_C": 1,
    "CMY_M": 0.5683128,
    "CMY_Y": 0.4205176,
    "CMYK_C": 1,
    "CMYK_M": 0.2550468,
    "CMYK_Y": 0,
    "CMYK_K": 0.4205176
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07458",
    "Farbtonhilfsbezeichnung": "R8.48.38",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "158",
    "Y": 16,
    "L": 47.185051282173,
    "a": -16.521530270117,
    "b": -28.18175033597,
    "C": 32.6675988475636,
    "h": 1.04054902595846,
    "CMY_C": 1,
    "CMY_M": 0.5217496,
    "CMY_Y": 0.3822734,
    "CMYK_C": 1,
    "CMYK_M": 0.2257895,
    "CMYK_Y": 0,
    "CMYK_K": 0.3822734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07459",
    "Farbtonhilfsbezeichnung": "R9.29.41",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "123",
    "Bcolor": "146",
    "Y": 17,
    "L": 48.708665590413,
    "a": -11.1226080326098,
    "b": -18.8342585022027,
    "C": 21.8733102838796,
    "h": 1.03735288950831,
    "CMY_C": 0.7354317,
    "CMY_M": 0.5190613,
    "CMY_Y": 0.4277855,
    "CMYK_C": 0.5376413,
    "CMYK_M": 0.1595134,
    "CMYK_Y": 0,
    "CMYK_K": 0.4277855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07460",
    "Farbtonhilfsbezeichnung": "R8.26.43",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "128",
    "Bcolor": "147",
    "Y": 19,
    "L": 50.9936600723762,
    "a": -9.96520741616996,
    "b": -16.1828691759187,
    "C": 19.0050154857129,
    "h": 1.01884922670463,
    "CMY_C": 0.6794751,
    "CMY_M": 0.4991951,
    "CMY_Y": 0.4218472,
    "CMYK_C": 0.4456051,
    "CMYK_M": 0.1337844,
    "CMYK_Y": 0,
    "CMYK_K": 0.4218472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07461",
    "Farbtonhilfsbezeichnung": "R8.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "157",
    "Bcolor": "171",
    "Y": 32,
    "L": 63.2406995352605,
    "a": -6.5007619366631,
    "b": -11.2338727708833,
    "C": 12.979206570109,
    "h": 1.04620453226958,
    "CMY_C": 0.4953823,
    "CMY_M": 0.3823833,
    "CMY_Y": 0.3280132,
    "CMYK_C": 0.249066,
    "CMYK_M": 0.08090942,
    "CMYK_Y": 0,
    "CMYK_K": 0.3280132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07462",
    "Farbtonhilfsbezeichnung": "SN.02.51",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "143",
    "Bcolor": "145",
    "Y": 27,
    "L": 59.2001590161284,
    "a": -1.41871602151827,
    "b": -2.14434495533959,
    "C": 2.57118074767275,
    "h": 0.98630397928776,
    "CMY_C": 0.4587723,
    "CMY_M": 0.4372582,
    "CMY_Y": 0.4313092,
    "CMYK_C": 0.04829182,
    "CMYK_M": 0.01046086,
    "CMYK_Y": 0,
    "CMYK_K": 0.4313092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07463",
    "Farbtonhilfsbezeichnung": "SN.02.44",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "123",
    "Bcolor": "125",
    "Y": 19,
    "L": 51.2449267139001,
    "a": -1.14526919860491,
    "b": -2.497983188317,
    "C": 2.74801047057458,
    "h": 1.14091487819169,
    "CMY_C": 0.5375754,
    "CMY_M": 0.5179378,
    "CMY_Y": 0.5088205,
    "CMYK_C": 0.05854256,
    "CMYK_M": 0.01856215,
    "CMYK_Y": 0,
    "CMYK_K": 0.5088205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07464",
    "Farbtonhilfsbezeichnung": "R8.18.47",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "135",
    "Bcolor": "150",
    "Y": 23,
    "L": 54.5781387293508,
    "a": -7.63704176419405,
    "b": -12.3460689858765,
    "C": 14.5172251588266,
    "h": 1.01682635703059,
    "CMY_C": 0.5984832,
    "CMY_M": 0.4686835,
    "CMY_Y": 0.4104831,
    "CMYK_C": 0.3189054,
    "CMYK_M": 0.0987256,
    "CMYK_Y": 0,
    "CMYK_K": 0.4104831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07465",
    "Farbtonhilfsbezeichnung": "R9.29.33",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "106",
    "Bcolor": "125",
    "Y": 13,
    "L": 42.3285574391508,
    "a": -9.29144756505132,
    "b": -16.2609513639846,
    "C": 18.7283084424614,
    "h": 1.05167453496041,
    "CMY_C": 0.7603864,
    "CMY_M": 0.5857944,
    "CMY_Y": 0.5086445,
    "CMYK_C": 0.5123417,
    "CMYK_M": 0.1570145,
    "CMYK_Y": 0,
    "CMYK_K": 0.5086445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07466",
    "Farbtonhilfsbezeichnung": "S0.42.33",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "108",
    "Bcolor": "138",
    "Y": 13,
    "L": 42.2252735859215,
    "a": -12.915379310948,
    "b": -24.1132703728722,
    "C": 27.3542835918051,
    "h": 1.07906591097238,
    "CMY_C": 0.9129346,
    "CMY_M": 0.577989,
    "CMY_Y": 0.4594538,
    "CMYK_C": 0.8389307,
    "CMYK_M": 0.2192879,
    "CMYK_Y": 0,
    "CMYK_K": 0.4594538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07467",
    "Farbtonhilfsbezeichnung": "R9.49.33",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "110",
    "Bcolor": "143",
    "Y": 13,
    "L": 42.3291980190507,
    "a": -16.1383513441477,
    "b": -27.3936451446086,
    "C": 31.7939959491709,
    "h": 1.03840962584005,
    "CMY_C": 1,
    "CMY_M": 0.5705611,
    "CMY_Y": 0.4374045,
    "CMYK_C": 1,
    "CMYK_M": 0.2366826,
    "CMYK_Y": 0,
    "CMYK_K": 0.4374045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07468",
    "Farbtonhilfsbezeichnung": "R9.51.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "135",
    "Y": 11,
    "L": 39.6240019658911,
    "a": -16.080593267176,
    "b": -26.3672079393033,
    "C": 30.8838976545838,
    "h": 1.02315039592381,
    "CMY_C": 1,
    "CMY_M": 0.5973104,
    "CMY_Y": 0.4714798,
    "CMYK_C": 1,
    "CMYK_M": 0.2380809,
    "CMYK_Y": 0,
    "CMYK_K": 0.4714798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07469",
    "Farbtonhilfsbezeichnung": "R9.42.29",
    "Farbtonklasse": "04",
    "Rcolor": "29",
    "Gcolor": "97",
    "Bcolor": "123",
    "Y": 10,
    "L": 38.2659097583838,
    "a": -11.5099148248609,
    "b": -21.1411575888961,
    "C": 24.0712833782101,
    "h": 1.07223830793545,
    "CMY_C": 0.8875826,
    "CMY_M": 0.6195022,
    "CMY_Y": 0.5180436,
    "CMYK_C": 0.7667478,
    "CMYK_M": 0.2105141,
    "CMYK_Y": 0,
    "CMYK_K": 0.5180436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07471",
    "Farbtonhilfsbezeichnung": "R9.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "94",
    "Bcolor": "108",
    "Y": 10,
    "L": 37.9835963397733,
    "a": -7.32699658507216,
    "b": -12.3990952661187,
    "C": 14.4021679748553,
    "h": 1.03707268425273,
    "CMY_C": 0.7575175,
    "CMY_M": 0.6320934,
    "CMY_Y": 0.5755789,
    "CMYK_C": 0.4286748,
    "CMYK_M": 0.1331566,
    "CMYK_Y": 0,
    "CMYK_K": 0.5755789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07472",
    "Farbtonhilfsbezeichnung": "R8.21.28",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "93",
    "Bcolor": "105",
    "Y": 10,
    "L": 38.0885815170355,
    "a": -5.89728392299674,
    "b": -10.1685682199147,
    "C": 11.7549026925575,
    "h": 1.04524827132611,
    "CMY_C": 0.7314829,
    "CMY_M": 0.6343059,
    "CMY_Y": 0.5884287,
    "CMYK_C": 0.3475804,
    "CMYK_M": 0.1114684,
    "CMYK_Y": 0,
    "CMYK_K": 0.5884287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07473",
    "Farbtonhilfsbezeichnung": "S0.19.38",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "116",
    "Bcolor": "130",
    "Y": 16,
    "L": 46.9216478495051,
    "a": -7.04692089349601,
    "b": -11.9038248726077,
    "C": 13.8332982573537,
    "h": 1.03628886796048,
    "CMY_C": 0.6662317,
    "CMY_M": 0.5463686,
    "CMY_Y": 0.490847,
    "CMYK_C": 0.3444636,
    "CMYK_M": 0.109047,
    "CMYK_Y": 0,
    "CMYK_K": 0.490847
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07474",
    "Farbtonhilfsbezeichnung": "S0.09.30",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "99",
    "Bcolor": "104",
    "Y": 11,
    "L": 41.0800094604492,
    "a": -2.84386420249939,
    "b": -5.18178701400757,
    "C": 5.91087818145752,
    "h": 241.241180419922,
    "CMY_C": 0.65759778022766,
    "CMY_M": 0.61293280124664,
    "CMY_Y": 0.59081614017487,
    "CMYK_C": 0.16320692002773,
    "CMYK_M": 0.05405066907406,
    "CMYK_Y": 0,
    "CMYK_K": 0.59081614017487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07475",
    "Farbtonhilfsbezeichnung": "S0.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "84",
    "Bcolor": "93",
    "Y": 7,
    "L": 34.8032836914063,
    "a": -3.88377046585083,
    "b": -7.85962915420532,
    "C": 8.76683807373047,
    "h": 243.7041015625,
    "CMY_C": 0.7344696521759,
    "CMY_M": 0.66945952177048,
    "CMY_Y": 0.63385617733002,
    "CMYK_C": 0.27479222416878,
    "CMYK_M": 0.09723868966103,
    "CMYK_Y": 0,
    "CMYK_K": 0.63385617733002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07477",
    "Farbtonhilfsbezeichnung": "R9.40.21",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "81",
    "Bcolor": "101",
    "Y": 7,
    "L": 32.0428102175005,
    "a": -9.4663947061708,
    "b": -17.2938611724986,
    "C": 19.7152292146623,
    "h": 1.06996325441941,
    "CMY_C": 0.8803537,
    "CMY_M": 0.6826328,
    "CMY_Y": 0.6025602,
    "CMYK_C": 0.6989576,
    "CMYK_M": 0.2014711,
    "CMYK_Y": 0,
    "CMYK_K": 0.6025602
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07478",
    "Farbtonhilfsbezeichnung": "R8.52.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "91",
    "Bcolor": "119",
    "Y": 9,
    "L": 35.4758509798802,
    "a": -13.2853699392942,
    "b": -23.0645328713104,
    "C": 26.6171698532293,
    "h": 1.0482043665052,
    "CMY_C": 1,
    "CMY_M": 0.6425062,
    "CMY_Y": 0.5336432,
    "CMYK_C": 1,
    "CMYK_M": 0.2334327,
    "CMYK_Y": 0,
    "CMYK_K": 0.5336432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07480",
    "Farbtonhilfsbezeichnung": "R9.33.20",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "77",
    "Bcolor": "91",
    "Y": 6,
    "L": 30.5680493605298,
    "a": -8.10457713758386,
    "b": -12.8054269134112,
    "C": 15.154640510872,
    "h": 1.00653502063396,
    "CMY_C": 0.838917,
    "CMY_M": 0.6998152,
    "CMY_Y": 0.6438058,
    "CMYK_C": 0.5477661,
    "CMYK_M": 0.1572439,
    "CMYK_Y": 0,
    "CMYK_K": 0.6438058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07481",
    "Farbtonhilfsbezeichnung": "S0.41.14",
    "Farbtonklasse": "04",
    "Rcolor": "7",
    "Gcolor": "66",
    "Bcolor": "84",
    "Y": 5,
    "L": 25.3819412618009,
    "a": -9.88980872512576,
    "b": -16.6021174405769,
    "C": 19.3245600242355,
    "h": 1.03354781921224,
    "CMY_C": 0.9707742,
    "CMY_M": 0.7428057,
    "CMY_Y": 0.6695864,
    "CMYK_C": 0.9115478,
    "CMYK_M": 0.2215991,
    "CMYK_Y": 0,
    "CMYK_K": 0.6695864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07483",
    "Farbtonhilfsbezeichnung": "R8.21.10",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "57",
    "Bcolor": "63",
    "Y": 4,
    "L": 23.1940389361523,
    "a": -3.78760182284771,
    "b": -5.69015312962443,
    "C": 6.83547878403656,
    "h": 0.98350381928896,
    "CMY_C": 0.8276935,
    "CMY_M": 0.7749893,
    "CMY_Y": 0.7527238,
    "CMYK_C": 0.3031819,
    "CMYK_M": 0.09004299,
    "CMYK_Y": 0,
    "CMYK_K": 0.7527238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07484",
    "Farbtonhilfsbezeichnung": "R9.10.19",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "70",
    "Bcolor": "76",
    "Y": 6,
    "L": 29.2760550711194,
    "a": -2.35439874611229,
    "b": -5.05867273540551,
    "C": 5.57972788759723,
    "h": 1.13519479515453,
    "CMY_C": 0.7616246,
    "CMY_M": 0.7236695,
    "CMY_Y": 0.7018675,
    "CMYK_C": 0.2004379,
    "CMYK_M": 0.0731283,
    "CMYK_Y": 0,
    "CMYK_K": 0.7018675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07485",
    "Farbtonhilfsbezeichnung": "R8.04.16",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 5,
    "L": 25.7424689865842,
    "a": -1.49206984311803,
    "b": -2.53718452695229,
    "C": 2.94339561400576,
    "h": 1.03918694706931,
    "CMY_C": 0.7780991,
    "CMY_M": 0.7574165,
    "CMY_Y": 0.7483631,
    "CMYK_C": 0.1181704,
    "CMYK_M": 0.03597792,
    "CMYK_Y": 0,
    "CMYK_K": 0.7483631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07486",
    "Farbtonhilfsbezeichnung": "SN.01.18",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "74",
    "Bcolor": "74",
    "Y": 5,
    "L": 31.4265060424805,
    "a": -0.34517452120781,
    "b": -0.59200346469879,
    "C": 0.68528354167938,
    "h": 239.755172729492,
    "CMY_C": 0.71400225162506,
    "CMY_M": 0.70903813838959,
    "CMY_Y": 0.70900493860245,
    "CMYK_C": 0.0171731878072,
    "CMYK_M": 0.00011409055151,
    "CMYK_Y": 0,
    "CMYK_K": 0.70900493860245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07487",
    "Farbtonhilfsbezeichnung": "S5.31.64",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "185",
    "Bcolor": "225",
    "Y": 44,
    "L": 71.9386121143292,
    "a": -11.3204860212887,
    "b": -28.2176031651783,
    "C": 30.4037256293644,
    "h": 1.18926860508059,
    "CMY_C": 0.5589098,
    "CMY_M": 0.2751537,
    "CMY_Y": 0.1156986,
    "CMYK_C": 0.5011993,
    "CMYK_M": 0.1803176,
    "CMYK_Y": 0,
    "CMYK_K": 0.1156986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07488",
    "Farbtonhilfsbezeichnung": "S3.25.69",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "197",
    "Bcolor": "227",
    "Y": 51,
    "L": 76.6570411418763,
    "a": -10.5846272652416,
    "b": -21.8789338811915,
    "C": 24.3047748831715,
    "h": 1.12020735652261,
    "CMY_C": 0.4527193,
    "CMY_M": 0.2280315,
    "CMY_Y": 0.1086525,
    "CMYK_C": 0.3860075,
    "CMYK_M": 0.133931,
    "CMYK_Y": 0,
    "CMYK_K": 0.1086525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07489",
    "Farbtonhilfsbezeichnung": "S3.12.73",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "206",
    "Bcolor": "222",
    "Y": 59,
    "L": 81.1312107253076,
    "a": -5.73066371346881,
    "b": -12.1931984972119,
    "C": 13.4727352898095,
    "h": 1.1314448157361,
    "CMY_C": 0.3053436,
    "CMY_M": 0.1928358,
    "CMY_Y": 0.1285201,
    "CMYK_C": 0.2029003,
    "CMYK_M": 0.07380059,
    "CMYK_Y": 0,
    "CMYK_K": 0.1285201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07490",
    "Farbtonhilfsbezeichnung": "S5.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "219",
    "Bcolor": "233",
    "Y": 68,
    "L": 85.9929911088202,
    "a": -4.43155714398097,
    "b": -10.3901511481416,
    "C": 11.2957487401941,
    "h": 1.16764301209055,
    "CMY_C": 0.23325,
    "CMY_M": 0.1428662,
    "CMY_Y": 0.08768664,
    "CMYK_C": 0.1595541,
    "CMYK_M": 0.06048311,
    "CMYK_Y": 0,
    "CMYK_K": 0.08768664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07491",
    "Farbtonhilfsbezeichnung": "S6.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "222",
    "Bcolor": "233",
    "Y": 71,
    "L": 87.5253897040479,
    "a": -3.30009076551291,
    "b": -8.23873012632206,
    "C": 8.87509285331653,
    "h": 1.18980885050915,
    "CMY_C": 0.1976942,
    "CMY_M": 0.129142,
    "CMY_Y": 0.08629664,
    "CMYK_C": 0.1219187,
    "CMYK_M": 0.04689193,
    "CMYK_Y": 0,
    "CMYK_K": 0.08629664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07492",
    "Farbtonhilfsbezeichnung": "S2.10.78",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "217",
    "Bcolor": "230",
    "Y": 67,
    "L": 85.4997511275732,
    "a": -4.87862403668188,
    "b": -9.71643523651509,
    "C": 10.8724461919424,
    "h": 1.10546997284927,
    "CMY_C": 0.2395938,
    "CMY_M": 0.1475191,
    "CMY_Y": 0.09814633,
    "CMYK_C": 0.1568408,
    "CMYK_M": 0.05474587,
    "CMYK_Y": 0,
    "CMYK_K": 0.09814633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07493",
    "Farbtonhilfsbezeichnung": "S7.16.73",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "205",
    "Bcolor": "228",
    "Y": 58,
    "L": 80.5730895996094,
    "a": -5.94265365600586,
    "b": -16.3883380889893,
    "C": 17.4325199127197,
    "h": 250.068603515625,
    "CMY_C": 0.33340471982956,
    "CMY_M": 0.19710350036621,
    "CMY_Y": 0.10435181856155,
    "CMYK_C": 0.25573980808258,
    "CMYK_M": 0.10355816781521,
    "CMYK_Y": 0,
    "CMYK_K": 0.10435181856155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07494",
    "Farbtonhilfsbezeichnung": "S4.20.70",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "199",
    "Bcolor": "226",
    "Y": 53,
    "L": 77.9907501549074,
    "a": -8.64436806698882,
    "b": -19.1851921014424,
    "C": 21.0427349754452,
    "h": 1.14746432720185,
    "CMY_C": 0.402067,
    "CMY_M": 0.2185139,
    "CMY_Y": 0.1130541,
    "CMYK_C": 0.3258517,
    "CMYK_M": 0.1189021,
    "CMYK_Y": 0,
    "CMYK_K": 0.1130541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07495",
    "Farbtonhilfsbezeichnung": "S2.23.69",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "196",
    "Bcolor": "224",
    "Y": 50,
    "L": 76.1566293915269,
    "a": -10.8232973803896,
    "b": -20.858324582641,
    "C": 23.4992227654268,
    "h": 1.09214658908958,
    "CMY_C": 0.4542416,
    "CMY_M": 0.233308,
    "CMY_Y": 0.1215374,
    "CMYK_C": 0.3787346,
    "CMYK_M": 0.1272344,
    "CMYK_Y": 0,
    "CMYK_K": 0.1215374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07496",
    "Farbtonhilfsbezeichnung": "S5.30.63",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "180",
    "Bcolor": "218",
    "Y": 41,
    "L": 70.2905696108809,
    "a": -10.2837360600758,
    "b": -26.8525532881705,
    "C": 28.7543882815708,
    "h": 1.20505618731144,
    "CMY_C": 0.553748,
    "CMY_M": 0.2953298,
    "CMY_Y": 0.1434973,
    "CMYK_C": 0.4789835,
    "CMYK_M": 0.1772703,
    "CMYK_Y": 0,
    "CMYK_K": 0.1434973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07497",
    "Farbtonhilfsbezeichnung": "S6.42.53",
    "Farbtonklasse": "03",
    "Rcolor": "51",
    "Gcolor": "156",
    "Bcolor": "206",
    "Y": 29,
    "L": 60.5900712429283,
    "a": -12.5202739519744,
    "b": -34.9285323998672,
    "C": 37.1047117687371,
    "h": 1.22661000043787,
    "CMY_C": 0.798196,
    "CMY_M": 0.3899626,
    "CMY_Y": 0.1935028,
    "CMYK_C": 0.7497771,
    "CMYK_M": 0.2435963,
    "CMYK_Y": 0,
    "CMYK_K": 0.1935028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07498",
    "Farbtonhilfsbezeichnung": "S4.34.61",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "175",
    "Bcolor": "218",
    "Y": 38,
    "L": 68.1784107296184,
    "a": -12.4997839863004,
    "b": -30.0544178709194,
    "C": 32.550155656525,
    "h": 1.1766543391399,
    "CMY_C": 0.6346334,
    "CMY_M": 0.3122395,
    "CMY_Y": 0.1443378,
    "CMYK_C": 0.5730013,
    "CMYK_M": 0.1962243,
    "CMYK_Y": 0,
    "CMYK_K": 0.1443378
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07500",
    "Farbtonhilfsbezeichnung": "S6.17.69",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "193",
    "Bcolor": "218",
    "Y": 50,
    "L": 76.3533548213811,
    "a": -6.17288443155167,
    "b": -17.0412769334487,
    "C": 18.124834391734,
    "h": 1.22326682372422,
    "CMY_C": 0.3840927,
    "CMY_M": 0.2422143,
    "CMY_Y": 0.146242,
    "CMYK_C": 0.2785926,
    "CMYK_M": 0.1124116,
    "CMYK_Y": 0,
    "CMYK_K": 0.146242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07501",
    "Farbtonhilfsbezeichnung": "S2.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "209",
    "Bcolor": "225",
    "Y": 61,
    "L": 82.3306081500963,
    "a": -6.25402411410464,
    "b": -11.9838027811976,
    "C": 13.517556980403,
    "h": 1.08980376059234,
    "CMY_C": 0.296149,
    "CMY_M": 0.1786271,
    "CMY_Y": 0.116863,
    "CMYK_C": 0.2030104,
    "CMYK_M": 0.06993717,
    "CMYK_Y": 0,
    "CMYK_K": 0.116863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07502",
    "Farbtonhilfsbezeichnung": "S5.09.74",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "205",
    "Bcolor": "217",
    "Y": 59,
    "L": 81.2589826270464,
    "a": -4.86873304320007,
    "b": -9.31642969441528,
    "C": 10.5119181740028,
    "h": 1.08923540586683,
    "CMY_C": 0.2836515,
    "CMY_M": 0.194232,
    "CMY_Y": 0.1478354,
    "CMYK_C": 0.1593779,
    "CMYK_M": 0.05444559,
    "CMYK_Y": 0,
    "CMYK_K": 0.1478354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07503",
    "Farbtonhilfsbezeichnung": "S6.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "204",
    "Bcolor": "218",
    "Y": 58,
    "L": 80.8131713867188,
    "a": -4.37371301651001,
    "b": -10.301118850708,
    "C": 11.1911754608154,
    "h": 246.994598388672,
    "CMY_C": 0.28839904069901,
    "CMY_M": 0.19987297058105,
    "CMY_Y": 0.14554792642593,
    "CMYK_C": 0.16718447208405,
    "CMYK_M": 0.06357880681753,
    "CMYK_Y": 0,
    "CMYK_K": 0.14554792642593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07504",
    "Farbtonhilfsbezeichnung": "S2.18.69",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "195",
    "Bcolor": "218",
    "Y": 51,
    "L": 76.5342650907492,
    "a": -7.94098966850976,
    "b": -16.6846975291457,
    "C": 18.4780531592064,
    "h": 1.12657766261015,
    "CMY_C": 0.3970709,
    "CMY_M": 0.2366107,
    "CMY_Y": 0.1469944,
    "CMYK_C": 0.2931709,
    "CMYK_M": 0.1050594,
    "CMYK_Y": 0,
    "CMYK_K": 0.1469944
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07506",
    "Farbtonhilfsbezeichnung": "S6.38.53",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "155",
    "Bcolor": "200",
    "Y": 29,
    "L": 60.5325448519267,
    "a": -11.7199798841316,
    "b": -31.7846501818679,
    "C": 33.8765688296227,
    "h": 1.21753322665919,
    "CMY_C": 0.7362077,
    "CMY_M": 0.39327,
    "CMY_Y": 0.2158055,
    "CMYK_C": 0.6636137,
    "CMYK_M": 0.2263015,
    "CMYK_Y": 0,
    "CMYK_K": 0.2158055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07507",
    "Farbtonhilfsbezeichnung": "S6.45.49",
    "Farbtonklasse": "03",
    "Rcolor": "18",
    "Gcolor": "149",
    "Bcolor": "200",
    "Y": 26,
    "L": 57.847102039015,
    "a": -13.5527167142057,
    "b": -36.3347111833903,
    "C": 38.779986682771,
    "h": 1.2137833874037,
    "CMY_C": 0.9303439,
    "CMY_M": 0.4158439,
    "CMY_Y": 0.2137545,
    "CMYK_C": 0.9114067,
    "CMYK_M": 0.2570309,
    "CMYK_Y": 0,
    "CMYK_K": 0.2137545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07508",
    "Farbtonhilfsbezeichnung": "S2.49.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "137",
    "Bcolor": "183",
    "Y": 21,
    "L": 52.7033213708463,
    "a": -16.8578621407879,
    "b": -34.6473534672949,
    "C": 38.5308528097353,
    "h": 1.11796200966082,
    "CMY_C": 1,
    "CMY_M": 0.4632756,
    "CMY_Y": 0.2809423,
    "CMYK_C": 1,
    "CMYK_M": 0.2535726,
    "CMYK_Y": 0,
    "CMYK_K": 0.2809423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07509",
    "Farbtonhilfsbezeichnung": "S6.34.57",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "163",
    "Bcolor": "207",
    "Y": 33,
    "L": 64.0544487574496,
    "a": -10.877712905601,
    "b": -29.9568156739476,
    "C": 31.87060469115,
    "h": 1.22248753276512,
    "CMY_C": 0.6592258,
    "CMY_M": 0.3588854,
    "CMY_Y": 0.1901005,
    "CMYK_C": 0.579239,
    "CMYK_M": 0.2084022,
    "CMYK_Y": 0,
    "CMYK_K": 0.1901005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07510",
    "Farbtonhilfsbezeichnung": "S6.27.56",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "162",
    "Bcolor": "195",
    "Y": 32,
    "L": 63.9044342041016,
    "a": -9.05385303497314,
    "b": -23.4345607757568,
    "C": 25.1227169036865,
    "h": 248.87614440918,
    "CMY_C": 0.5837949514389,
    "CMY_M": 0.36636596918106,
    "CMY_Y": 0.23691070079803,
    "CMYK_C": 0.45457884669304,
    "CMYK_M": 0.16964629292488,
    "CMYK_Y": 0,
    "CMYK_K": 0.23691070079803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07511",
    "Farbtonhilfsbezeichnung": "S3.14.64",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "182",
    "Bcolor": "198",
    "Y": 44,
    "L": 72.39856659931,
    "a": -5.68923710859393,
    "b": -12.1117072140866,
    "C": 13.3813628049448,
    "h": 1.13165628081729,
    "CMY_C": 0.3974056,
    "CMY_M": 0.2872874,
    "CMY_Y": 0.2243192,
    "CMYK_C": 0.2231412,
    "CMYK_M": 0.08117796,
    "CMYK_Y": 0,
    "CMYK_K": 0.2243192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07512",
    "Farbtonhilfsbezeichnung": "S2.11.71",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "197",
    "Bcolor": "210",
    "Y": 54,
    "L": 78.1863509963783,
    "a": -4.94037559716004,
    "b": -10.2171150374281,
    "C": 11.3488656141948,
    "h": 1.12040386538672,
    "CMY_C": 0.3210805,
    "CMY_M": 0.2272291,
    "CMY_Y": 0.1749638,
    "CMYK_C": 0.1771034,
    "CMYK_M": 0.06334908,
    "CMYK_Y": 0,
    "CMYK_K": 0.1749638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07513",
    "Farbtonhilfsbezeichnung": "S7.09.71",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "197",
    "Bcolor": "210",
    "Y": 54,
    "L": 78.6200438351899,
    "a": -3.139659505001,
    "b": -9.3520768145642,
    "C": 9.86502927278234,
    "h": 1.24690120790643,
    "CMY_C": 0.2973593,
    "CMY_M": 0.2267724,
    "CMY_Y": 0.1762376,
    "CMYK_C": 0.1470348,
    "CMYK_M": 0.06134641,
    "CMYK_Y": 0,
    "CMYK_K": 0.1762376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07514",
    "Farbtonhilfsbezeichnung": "S6.04.63",
    "Farbtonklasse": "01",
    "Rcolor": "165",
    "Gcolor": "173",
    "Bcolor": "177",
    "Y": 41,
    "L": 70.2542847991446,
    "a": -1.49601081240058,
    "b": -3.85767629259504,
    "C": 4.13759770026875,
    "h": 1.20085034103714,
    "CMY_C": 0.3512446,
    "CMY_M": 0.3216334,
    "CMY_Y": 0.3048511,
    "CMYK_C": 0.06673893,
    "CMYK_M": 0.024142,
    "CMYK_Y": 0,
    "CMYK_K": 0.3048511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07515",
    "Farbtonhilfsbezeichnung": "S7.11.64",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "176",
    "Bcolor": "191",
    "Y": 42,
    "L": 70.7775444699187,
    "a": -4.00120559670425,
    "b": -10.8585506286553,
    "C": 11.5722844755116,
    "h": 1.21775023784735,
    "CMY_C": 0.3940818,
    "CMY_M": 0.3085482,
    "CMY_Y": 0.2503979,
    "CMYK_C": 0.1916803,
    "CMYK_M": 0.07757497,
    "CMYK_Y": 0,
    "CMYK_K": 0.2503979
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07516",
    "Farbtonhilfsbezeichnung": "S3.19.61",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "172",
    "Bcolor": "194",
    "Y": 38,
    "L": 68.0809415569084,
    "a": -7.96232239803935,
    "b": -16.7760832993304,
    "C": 18.5697482168281,
    "h": 1.12765527277882,
    "CMY_C": 0.487051,
    "CMY_M": 0.3269184,
    "CMY_Y": 0.2382411,
    "CMYK_C": 0.3266256,
    "CMYK_M": 0.1164113,
    "CMYK_Y": 0,
    "CMYK_K": 0.2382411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07517",
    "Farbtonhilfsbezeichnung": "S7.19.59",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "170",
    "Bcolor": "194",
    "Y": 36,
    "L": 67.5831069946289,
    "a": -6.38368558883667,
    "b": -17.5040969848633,
    "C": 18.6318244934082,
    "h": 249.963256835938,
    "CMY_C": 0.4810431599617,
    "CMY_M": 0.33517706394196,
    "CMY_Y": 0.23834592103958,
    "CMYK_C": 0.31864497065544,
    "CMYK_M": 0.12713269889355,
    "CMYK_Y": 0,
    "CMYK_K": 0.23834592103958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07518",
    "Farbtonhilfsbezeichnung": "S6.33.52",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "153",
    "Bcolor": "192",
    "Y": 29,
    "L": 60.3632834143256,
    "a": -10.6629405344406,
    "b": -27.5908315026411,
    "C": 29.5795923543267,
    "h": 1.20201065779945,
    "CMY_C": 0.6765051,
    "CMY_M": 0.3985825,
    "CMY_Y": 0.2464607,
    "CMYK_C": 0.5706993,
    "CMYK_M": 0.2018765,
    "CMYK_Y": 0,
    "CMYK_K": 0.2464607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07519",
    "Farbtonhilfsbezeichnung": "S7.38.50",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "145",
    "Bcolor": "190",
    "Y": 25,
    "L": 56.9155863683287,
    "a": -11.4628608123393,
    "b": -31.830263273355,
    "C": 33.8313883554039,
    "h": 1.22513044653025,
    "CMY_C": 0.7811509,
    "CMY_M": 0.4309926,
    "CMY_Y": 0.2545415,
    "CMYK_C": 0.7064235,
    "CMYK_M": 0.2367015,
    "CMYK_Y": 0,
    "CMYK_K": 0.2545415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07520",
    "Farbtonhilfsbezeichnung": "S5.48.43",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "130",
    "Bcolor": "180",
    "Y": 19,
    "L": 50.524350783193,
    "a": -13.8604313636337,
    "b": -36.2264671109359,
    "C": 38.787478352243,
    "h": 1.20537489180348,
    "CMY_C": 1,
    "CMY_M": 0.4897943,
    "CMY_Y": 0.2933663,
    "CMYK_C": 1,
    "CMYK_M": 0.2779772,
    "CMYK_Y": 0,
    "CMYK_K": 0.2933663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07521",
    "Farbtonhilfsbezeichnung": "S5.50.44",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "132",
    "Bcolor": "185",
    "Y": 20,
    "L": 50.9806675848725,
    "a": -14.7993250818197,
    "b": -38.0665854397385,
    "C": 40.8421957039321,
    "h": 1.20000423577489,
    "CMY_C": 1,
    "CMY_M": 0.4828456,
    "CMY_Y": 0.2761622,
    "CMYK_C": 1,
    "CMYK_M": 0.2855382,
    "CMYK_Y": 0,
    "CMYK_K": 0.2761622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07523",
    "Farbtonhilfsbezeichnung": "S5.49.41",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "125",
    "Bcolor": "173",
    "Y": 17,
    "L": 48.4258315224662,
    "a": -13.9965678034884,
    "b": -35.5956814919541,
    "C": 38.2486137154576,
    "h": 1.19615731407782,
    "CMY_C": 1,
    "CMY_M": 0.5108083,
    "CMY_Y": 0.3199021,
    "CMYK_C": 1,
    "CMYK_M": 0.280704,
    "CMYK_Y": 0,
    "CMYK_K": 0.3199021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07524",
    "Farbtonhilfsbezeichnung": "S3.43.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "134",
    "Bcolor": "178",
    "Y": 20,
    "L": 52.2378234529797,
    "a": -14.7849642234473,
    "b": -31.9879801141355,
    "C": 35.2395521945292,
    "h": 1.13784023637258,
    "CMY_C": 1,
    "CMY_M": 0.4725728,
    "CMY_Y": 0.3037043,
    "CMYK_C": 1,
    "CMYK_M": 0.2425241,
    "CMYK_Y": 0,
    "CMYK_K": 0.3037043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07525",
    "Farbtonhilfsbezeichnung": "S7.31.47",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "135",
    "Bcolor": "170",
    "Y": 22,
    "L": 53.9047590211357,
    "a": -8.7784748336075,
    "b": -24.8144383310061,
    "C": 26.321435562818,
    "h": 1.23077150962676,
    "CMY_C": 0.6992978,
    "CMY_M": 0.4692336,
    "CMY_Y": 0.3339173,
    "CMYK_C": 0.5485512,
    "CMYK_M": 0.2031523,
    "CMYK_Y": 0,
    "CMYK_K": 0.3339173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07526",
    "Farbtonhilfsbezeichnung": "S6.22.52",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "149",
    "Bcolor": "176",
    "Y": 28,
    "L": 59.8864129543949,
    "a": -6.82169945822908,
    "b": -18.8156840662995,
    "C": 20.0141337654469,
    "h": 1.22298170844219,
    "CMY_C": 0.572502,
    "CMY_M": 0.4140505,
    "CMY_Y": 0.3113779,
    "CMYK_C": 0.379198,
    "CMYK_M": 0.1490988,
    "CMYK_Y": 0,
    "CMYK_K": 0.3113779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07527",
    "Farbtonhilfsbezeichnung": "S3.20.55",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "158",
    "Bcolor": "180",
    "Y": 32,
    "L": 63.1771982530258,
    "a": -7.7472825735318,
    "b": -15.9989019405031,
    "C": 17.7759739698275,
    "h": 1.11983732340403,
    "CMY_C": 0.5316339,
    "CMY_M": 0.3790381,
    "CMY_Y": 0.2959811,
    "CMYK_C": 0.3347251,
    "CMYK_M": 0.1179756,
    "CMYK_Y": 0,
    "CMYK_K": 0.2959811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07528",
    "Farbtonhilfsbezeichnung": "S7.15.55",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "156",
    "Bcolor": "173",
    "Y": 31,
    "L": 62.7360950119933,
    "a": -5.18369797395213,
    "b": -13.14093165338,
    "C": 14.1263869904501,
    "h": 1.19506661408454,
    "CMY_C": 0.4979137,
    "CMY_M": 0.3897462,
    "CMY_Y": 0.3200609,
    "CMYK_C": 0.2615716,
    "CMYK_M": 0.1024876,
    "CMYK_Y": 0,
    "CMYK_K": 0.3200609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07529",
    "Farbtonhilfsbezeichnung": "S7.08.51",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "143",
    "Bcolor": "153",
    "Y": 27,
    "L": 58.7592804839595,
    "a": -2.58282996163123,
    "b": -7.23186410202437,
    "C": 7.67924924721477,
    "h": 1.22776976766302,
    "CMY_C": 0.4908229,
    "CMY_M": 0.4378778,
    "CMY_Y": 0.4014794,
    "CMYK_C": 0.1492739,
    "CMYK_M": 0.0608139,
    "CMYK_Y": 0,
    "CMYK_K": 0.4014794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07530",
    "Farbtonhilfsbezeichnung": "S6.16.48",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "136",
    "Bcolor": "154",
    "Y": 23,
    "L": 55.3214886176142,
    "a": -4.93916348622786,
    "b": -13.0464649475059,
    "C": 13.9501105217911,
    "h": 1.20888852841892,
    "CMY_C": 0.5702578,
    "CMY_M": 0.4662717,
    "CMY_Y": 0.3978848,
    "CMYK_C": 0.2862792,
    "CMYK_M": 0.1135778,
    "CMYK_Y": 0,
    "CMYK_K": 0.3978848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07531",
    "Farbtonhilfsbezeichnung": "S7.24.44",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "127",
    "Bcolor": "154",
    "Y": 20,
    "L": 51.4494923057409,
    "a": -6.3898338121916,
    "b": -19.0920194049705,
    "C": 20.1329377167665,
    "h": 1.2478287629308,
    "CMY_C": 0.6560798,
    "CMY_M": 0.5004466,
    "CMY_Y": 0.3975487,
    "CMYK_C": 0.429132,
    "CMYK_M": 0.1707987,
    "CMYK_Y": 0,
    "CMYK_K": 0.3975487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07532",
    "Farbtonhilfsbezeichnung": "S7.55.40",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "125",
    "Bcolor": "180",
    "Y": 17,
    "L": 48.2630432685902,
    "a": -14.0320084658336,
    "b": -39.5321721083955,
    "C": 41.9486578234993,
    "h": 1.22971709478614,
    "CMY_C": 1,
    "CMY_M": 0.5107579,
    "CMY_Y": 0.2953357,
    "CMYK_C": 1,
    "CMYK_M": 0.3057089,
    "CMYK_Y": 0,
    "CMYK_K": 0.2953357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07533",
    "Farbtonhilfsbezeichnung": "S3.54.37",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "119",
    "Bcolor": "167",
    "Y": 15,
    "L": 45.9466918827753,
    "a": -15.8301833093965,
    "b": -35.7470769222654,
    "C": 39.0953732824672,
    "h": 1.15391381016023,
    "CMY_C": 1,
    "CMY_M": 0.5323131,
    "CMY_Y": 0.3451808,
    "CMYK_C": 1,
    "CMYK_M": 0.2857771,
    "CMYK_Y": 0,
    "CMYK_K": 0.3451808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07534",
    "Farbtonhilfsbezeichnung": "S3.46.42",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "170",
    "Y": 18,
    "L": 49.4883852493418,
    "a": -15.1821252170233,
    "b": -32.0687661990244,
    "C": 35.4810187513417,
    "h": 1.12863460811791,
    "CMY_C": 1,
    "CMY_M": 0.4995446,
    "CMY_Y": 0.3322838,
    "CMYK_C": 1,
    "CMYK_M": 0.2504968,
    "CMYK_Y": 0,
    "CMYK_K": 0.3322838
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07535",
    "Farbtonhilfsbezeichnung": "S6.42.43",
    "Farbtonklasse": "03",
    "Rcolor": "33",
    "Gcolor": "129",
    "Bcolor": "172",
    "Y": 19,
    "L": 50.6641249250477,
    "a": -11.4071149761423,
    "b": -31.3352720012619,
    "C": 33.3469870223983,
    "h": 1.22167387318577,
    "CMY_C": 0.8698487,
    "CMY_M": 0.4946227,
    "CMY_Y": 0.3245172,
    "CMYK_C": 0.8073211,
    "CMYK_M": 0.2518281,
    "CMYK_Y": 0,
    "CMYK_K": 0.3245172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07536",
    "Farbtonhilfsbezeichnung": "S7.36.43",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "127",
    "Bcolor": "165",
    "Y": 19,
    "L": 50.5105966453581,
    "a": -9.63215543198476,
    "b": -27.3335235121236,
    "C": 28.9810269979124,
    "h": 1.23199082586001,
    "CMY_C": 0.7750229,
    "CMY_M": 0.5008683,
    "CMY_Y": 0.3527291,
    "CMYK_C": 0.6524221,
    "CMYK_M": 0.2288673,
    "CMYK_Y": 0,
    "CMYK_K": 0.3527291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07537",
    "Farbtonhilfsbezeichnung": "S6.20.33",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "103",
    "Bcolor": "121",
    "Y": 13,
    "L": 42.0913670180903,
    "a": -5.29935411558155,
    "b": -13.702873366642,
    "C": 14.691898874705,
    "h": 1.20177902604159,
    "CMY_C": 0.706406,
    "CMY_M": 0.5961285,
    "CMY_Y": 0.5270239,
    "CMYK_C": 0.3792625,
    "CMYK_M": 0.146106,
    "CMYK_Y": 0,
    "CMYK_K": 0.5270239
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07538",
    "Farbtonhilfsbezeichnung": "S6.23.41",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "120",
    "Bcolor": "144",
    "Y": 17,
    "L": 48.418479602075,
    "a": -6.56651240682771,
    "b": -17.8439810308199,
    "C": 19.0138566371287,
    "h": 1.21818030525407,
    "CMY_C": 0.680626,
    "CMY_M": 0.5306653,
    "CMY_Y": 0.4368713,
    "CMYK_C": 0.4328578,
    "CMYK_M": 0.1665588,
    "CMYK_Y": 0,
    "CMYK_K": 0.4368713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07539",
    "Farbtonhilfsbezeichnung": "S2.38.35",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "109",
    "Bcolor": "141",
    "Y": 13,
    "L": 43.2384226471337,
    "a": -11.2716268995109,
    "b": -24.5061931674609,
    "C": 26.9741186421852,
    "h": 1.13969874170224,
    "CMY_C": 0.8628104,
    "CMY_M": 0.5707717,
    "CMY_Y": 0.446512,
    "CMYK_C": 0.7521362,
    "CMYK_M": 0.224503,
    "CMYK_Y": 0,
    "CMYK_K": 0.446512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07540",
    "Farbtonhilfsbezeichnung": "S6.46.33",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "108",
    "Bcolor": "149",
    "Y": 13,
    "L": 42.5732532252217,
    "a": -11.1719062695604,
    "b": -30.0546978387666,
    "C": 32.0639416147704,
    "h": 1.21490512968725,
    "CMY_C": 1,
    "CMY_M": 0.5753868,
    "CMY_Y": 0.4173141,
    "CMYK_C": 1,
    "CMYK_M": 0.2712828,
    "CMYK_Y": 0,
    "CMYK_K": 0.4173141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07541",
    "Farbtonhilfsbezeichnung": "S2.48.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "109",
    "Bcolor": "149",
    "Y": 13,
    "L": 42.5075145777066,
    "a": -13.9812640675253,
    "b": -30.7053624384253,
    "C": 33.7386281197225,
    "h": 1.14351365769954,
    "CMY_C": 1,
    "CMY_M": 0.5710884,
    "CMY_Y": 0.4139433,
    "CMYK_C": 1,
    "CMYK_M": 0.2681397,
    "CMYK_Y": 0,
    "CMYK_K": 0.4139433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07542",
    "Farbtonhilfsbezeichnung": "S5.59.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "113",
    "Bcolor": "167",
    "Y": 13,
    "L": 43.3693611562777,
    "a": -14.4063992958914,
    "b": -39.8124503339179,
    "C": 42.338818385299,
    "h": 1.22359809830641,
    "CMY_C": 1,
    "CMY_M": 0.558313,
    "CMY_Y": 0.3454008,
    "CMYK_C": 1,
    "CMYK_M": 0.3252557,
    "CMYK_Y": 0,
    "CMYK_K": 0.3454008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07543",
    "Farbtonhilfsbezeichnung": "S6.54.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "114",
    "Bcolor": "163",
    "Y": 13,
    "L": 44.9341011047363,
    "a": -10.4366769790649,
    "b": -35.117618560791,
    "C": 36.6356582641602,
    "h": 253.448471069336,
    "CMY_C": 1,
    "CMY_M": 0.55163478851318,
    "CMY_Y": 0.35963183641434,
    "CMYK_C": 1,
    "CMYK_M": 0.29983213543892,
    "CMYK_Y": 0,
    "CMYK_K": 0.35963183641434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07544",
    "Farbtonhilfsbezeichnung": "S5.51.33",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "109",
    "Bcolor": "151",
    "Y": 13,
    "L": 42.2855807670592,
    "a": -13.0281483482086,
    "b": -32.0358717170668,
    "C": 34.5836627044518,
    "h": 1.18454998240779,
    "CMY_C": 1,
    "CMY_M": 0.5743077,
    "CMY_Y": 0.4075191,
    "CMYK_C": 1,
    "CMYK_M": 0.2815089,
    "CMYK_Y": 0,
    "CMYK_K": 0.4075191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07545",
    "Farbtonhilfsbezeichnung": "S4.45.29",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "131",
    "Y": 10,
    "L": 37.6899270649677,
    "a": -10.488749327598,
    "b": -27.1786878148497,
    "C": 29.1323691757853,
    "h": 1.2024880923459,
    "CMY_C": 1,
    "CMY_M": 0.6245617,
    "CMY_Y": 0.485432,
    "CMYK_C": 1,
    "CMYK_M": 0.2703815,
    "CMYK_Y": 0,
    "CMYK_K": 0.485432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07546",
    "Farbtonhilfsbezeichnung": "S7.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "19",
    "Gcolor": "84",
    "Bcolor": "116",
    "Y": 8,
    "L": 33.4855048388261,
    "a": -7.76615325706254,
    "b": -24.0124631064513,
    "C": 25.2371060316129,
    "h": 1.25799254670635,
    "CMY_C": 0.9242117,
    "CMY_M": 0.6697914,
    "CMY_Y": 0.5469632,
    "CMYK_C": 0.8327106,
    "CMYK_M": 0.2711219,
    "CMYK_Y": 0,
    "CMYK_K": 0.5469632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07547",
    "Farbtonhilfsbezeichnung": "S2.24.30",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "96",
    "Bcolor": "114",
    "Y": 11,
    "L": 39.0525261083883,
    "a": -6.91101540482431,
    "b": -14.3907294704864,
    "C": 15.964185811323,
    "h": 1.12308066292944,
    "CMY_C": 0.7550118,
    "CMY_M": 0.6220768,
    "CMY_Y": 0.5526198,
    "CMYK_C": 0.4523937,
    "CMYK_M": 0.1552527,
    "CMYK_Y": 0,
    "CMYK_K": 0.5526198
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07549",
    "Farbtonhilfsbezeichnung": "S3.03.26",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "83",
    "Bcolor": "85",
    "Y": 8,
    "L": 34.9601774842588,
    "a": -0.75023442304972,
    "b": -2.32895621118894,
    "C": 2.44681195091987,
    "h": 1.25915941227049,
    "CMY_C": 0.6897097,
    "CMY_M": 0.6753778,
    "CMY_Y": 0.6661174,
    "CMYK_C": 0.07066066,
    "CMYK_M": 0.02773578,
    "CMYK_Y": 0,
    "CMYK_K": 0.6661174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07550",
    "Farbtonhilfsbezeichnung": "S3.10.16",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "64",
    "Bcolor": "70",
    "Y": 5,
    "L": 26.3998240258661,
    "a": -2.28114569330143,
    "b": -5.1833178729961,
    "C": 5.6630742398973,
    "h": 1.15621092829604,
    "CMY_C": 0.7869009,
    "CMY_M": 0.7495173,
    "CMY_Y": 0.7270665,
    "CMYK_C": 0.2192273,
    "CMYK_M": 0.08225772,
    "CMYK_Y": 0,
    "CMYK_K": 0.7270665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07551",
    "Farbtonhilfsbezeichnung": "S7.14.24",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "80",
    "Bcolor": "90",
    "Y": 8,
    "L": 32.9760488423772,
    "a": -2.8389568491701,
    "b": -8.56168422306165,
    "C": 9.02009494001436,
    "h": 1.25061685722948,
    "CMY_C": 0.7458809,
    "CMY_M": 0.6881079,
    "CMY_Y": 0.6466091,
    "CMYK_C": 0.2809121,
    "CMYK_M": 0.1174303,
    "CMYK_Y": 0,
    "CMYK_K": 0.6466091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07552",
    "Farbtonhilfsbezeichnung": "S2.23.20",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "74",
    "Bcolor": "89",
    "Y": 6,
    "L": 29.9893620253683,
    "a": -5.65324584040425,
    "b": -12.1610887296208,
    "C": 13.4108637910374,
    "h": 1.13565092140951,
    "CMY_C": 0.8150878,
    "CMY_M": 0.7094158,
    "CMY_Y": 0.6529287,
    "CMYK_C": 0.4672213,
    "CMYK_M": 0.1627536,
    "CMYK_Y": 0,
    "CMYK_K": 0.6529287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07553",
    "Farbtonhilfsbezeichnung": "S4.29.30",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "96",
    "Bcolor": "119",
    "Y": 10,
    "L": 38.5567570204289,
    "a": -7.66170253781351,
    "b": -18.3153130289636,
    "C": 19.8532711946133,
    "h": 1.17459538157332,
    "CMY_C": 0.7953754,
    "CMY_M": 0.6242263,
    "CMY_Y": 0.5327588,
    "CMYK_C": 0.5620579,
    "CMYK_M": 0.1957607,
    "CMYK_Y": 0,
    "CMYK_K": 0.5327588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07554",
    "Farbtonhilfsbezeichnung": "S7.36.24",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "84",
    "Bcolor": "112",
    "Y": 8,
    "L": 33.7202852538958,
    "a": -7.31952853348791,
    "b": -21.3543448117398,
    "C": 22.5739571252189,
    "h": 1.24058115117593,
    "CMY_C": 0.8725144,
    "CMY_M": 0.6693,
    "CMY_Y": 0.5611414,
    "CMYK_C": 0.7095063,
    "CMYK_M": 0.2464542,
    "CMYK_Y": 0,
    "CMYK_K": 0.5611414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07555",
    "Farbtonhilfsbezeichnung": "S4.37.20",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "79",
    "Bcolor": "103",
    "Y": 7,
    "L": 31.4683430502627,
    "a": -7.2260368738106,
    "b": -19.1934837037079,
    "C": 20.5086670845809,
    "h": 1.2107253713119,
    "CMY_C": 0.8732137,
    "CMY_M": 0.6910142,
    "CMY_Y": 0.5962734,
    "CMYK_C": 0.6859601,
    "CMYK_M": 0.2346658,
    "CMYK_Y": 0,
    "CMYK_K": 0.5962734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07556",
    "Farbtonhilfsbezeichnung": "S7.46.29",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "137",
    "Y": 10,
    "L": 37.8194844648792,
    "a": -9.60751527876189,
    "b": -30.5430049279404,
    "C": 32.0184243812814,
    "h": 1.26603858605887,
    "CMY_C": 1,
    "CMY_M": 0.6235207,
    "CMY_Y": 0.4626449,
    "CMYK_C": 1,
    "CMYK_M": 0.2993846,
    "CMYK_Y": 0,
    "CMYK_K": 0.4626449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07557",
    "Farbtonhilfsbezeichnung": "S7.52.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "89",
    "Bcolor": "132",
    "Y": 8,
    "L": 34.8138345710766,
    "a": -10.0136911183585,
    "b": -32.1095354175295,
    "C": 33.6347480225952,
    "h": 1.26849430145649,
    "CMY_C": 1,
    "CMY_M": 0.650595,
    "CMY_Y": 0.483135,
    "CMYK_C": 1,
    "CMYK_M": 0.3239918,
    "CMYK_Y": 0,
    "CMYK_K": 0.483135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07558",
    "Farbtonhilfsbezeichnung": "S7.51.22",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "81",
    "Bcolor": "120",
    "Y": 7,
    "L": 31.6515665200165,
    "a": -9.69208870821822,
    "b": -29.5799907079999,
    "C": 31.1273582851699,
    "h": 1.25416321260896,
    "CMY_C": 1,
    "CMY_M": 0.6815348,
    "CMY_Y": 0.5305872,
    "CMYK_C": 1,
    "CMYK_M": 0.321567,
    "CMYK_Y": 0,
    "CMYK_K": 0.5305872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07559",
    "Farbtonhilfsbezeichnung": "S6.46.22",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "78",
    "Bcolor": "112",
    "Y": 6,
    "L": 30.600311752416,
    "a": -7.91702352373361,
    "b": -26.3080283256232,
    "C": 27.4734711286569,
    "h": 1.27848136183896,
    "CMY_C": 1,
    "CMY_M": 0.6953149,
    "CMY_Y": 0.5610664,
    "CMYK_C": 1,
    "CMYK_M": 0.3058514,
    "CMYK_Y": 0,
    "CMYK_K": 0.5610664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07560",
    "Farbtonhilfsbezeichnung": "S6.43.17",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "72",
    "Bcolor": "103",
    "Y": 6,
    "L": 28.1374030412964,
    "a": -7.80593700343754,
    "b": -24.2819953535206,
    "C": 25.5058415044482,
    "h": 1.25976034980753,
    "CMY_C": 1,
    "CMY_M": 0.7186607,
    "CMY_Y": 0.5973548,
    "CMYK_C": 1,
    "CMYK_M": 0.3012723,
    "CMYK_Y": 0,
    "CMYK_K": 0.5973548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07561",
    "Farbtonhilfsbezeichnung": "S6.30.23",
    "Farbtonklasse": "04",
    "Rcolor": "42",
    "Gcolor": "82",
    "Bcolor": "104",
    "Y": 7,
    "L": 32.8949030886734,
    "a": -6.52001291327386,
    "b": -17.5659102386036,
    "C": 18.7369093209082,
    "h": 1.21538398238209,
    "CMY_C": 0.8336353,
    "CMY_M": 0.6795887,
    "CMY_Y": 0.5924948,
    "CMYK_C": 0.5917482,
    "CMYK_M": 0.2137247,
    "CMYK_Y": 0,
    "CMYK_K": 0.5924948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07562",
    "Farbtonhilfsbezeichnung": "S5.32.15",
    "Farbtonklasse": "04",
    "Rcolor": "37",
    "Gcolor": "66",
    "Bcolor": "84",
    "Y": 5,
    "L": 26.5649525782823,
    "a": -5.0377484778697,
    "b": -14.623437411412,
    "C": 15.4668623660962,
    "h": 1.23903123408873,
    "CMY_C": 0.8567503,
    "CMY_M": 0.7405971,
    "CMY_Y": 0.670013,
    "CMYK_C": 0.5658928,
    "CMYK_M": 0.2138995,
    "CMYK_Y": 0,
    "CMYK_K": 0.670013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07563",
    "Farbtonhilfsbezeichnung": "S4.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "75",
    "Bcolor": "88",
    "Y": 7,
    "L": 30.7109812881029,
    "a": -4.70122172008203,
    "b": -10.6865652459915,
    "C": 11.674937362496,
    "h": 1.15635742407724,
    "CMY_C": 0.7917078,
    "CMY_M": 0.704918,
    "CMY_Y": 0.6550235,
    "CMYK_C": 0.3962134,
    "CMYK_M": 0.1446318,
    "CMYK_Y": 0,
    "CMYK_K": 0.6550235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07564",
    "Farbtonhilfsbezeichnung": "S4.18.16",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "65",
    "Bcolor": "76",
    "Y": 5,
    "L": 26.5994100643426,
    "a": -3.79983610041992,
    "b": -9.30332929023047,
    "C": 10.0494124341931,
    "h": 1.18303677636884,
    "CMY_C": 0.8140837,
    "CMY_M": 0.7439674,
    "CMY_Y": 0.7011116,
    "CMYK_C": 0.3779742,
    "CMYK_M": 0.143384,
    "CMYK_Y": 0,
    "CMYK_K": 0.7011116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07565",
    "Farbtonhilfsbezeichnung": "S3.04.14",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "59",
    "Bcolor": "63",
    "Y": 4,
    "L": 24.8534724780985,
    "a": -0.6281611034683,
    "b": -3.0445951629401,
    "C": 3.10872097141393,
    "h": 1.36733122294622,
    "CMY_C": 0.7816966,
    "CMY_M": 0.7666967,
    "CMY_Y": 0.7531534,
    "CMYK_C": 0.1156313,
    "CMYK_M": 0.05486533,
    "CMYK_Y": 0,
    "CMYK_K": 0.7531534
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07566",
    "Farbtonhilfsbezeichnung": "S8.34.56",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "165",
    "Bcolor": "210",
    "Y": 34,
    "L": 64.8956123773349,
    "a": -9.72480470475173,
    "b": -30.6865761863283,
    "C": 32.1906474707312,
    "h": 1.26390118103172,
    "CMY_C": 0.6402343,
    "CMY_M": 0.3520523,
    "CMY_Y": 0.1757221,
    "CMYK_C": 0.5635384,
    "CMYK_M": 0.2139209,
    "CMYK_Y": 0,
    "CMYK_K": 0.1757221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07567",
    "Farbtonhilfsbezeichnung": "T0.26.64",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "181",
    "Bcolor": "220",
    "Y": 43,
    "L": 71.3113348407877,
    "a": -6.75147868085768,
    "b": -25.857449933102,
    "C": 26.7243368752332,
    "h": 1.31539462976457,
    "CMY_C": 0.4953851,
    "CMY_M": 0.2920403,
    "CMY_Y": 0.1389783,
    "CMYK_C": 0.4139348,
    "CMYK_M": 0.1777679,
    "CMYK_Y": 0,
    "CMYK_K": 0.1389783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07568",
    "Farbtonhilfsbezeichnung": "T1.08.79",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "216",
    "Bcolor": "231",
    "Y": 68,
    "L": 85.5466537475586,
    "a": -2.03089904785156,
    "b": -10.0000467300415,
    "C": 10.2041893005371,
    "h": 258.519989013672,
    "CMY_C": 0.21581876277924,
    "CMY_M": 0.15334534645081,
    "CMY_Y": 0.09520959854126,
    "CMYK_C": 0.13330066204071,
    "CMYK_M": 0.06425327807665,
    "CMYK_Y": 0,
    "CMYK_K": 0.09520959854126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07569",
    "Farbtonhilfsbezeichnung": "T1.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "223",
    "Bcolor": "227",
    "Y": 72,
    "L": 88.2770538330078,
    "a": -2.14833235740662,
    "b": -3.80740833282471,
    "C": 4.37169170379639,
    "h": 240.566116333008,
    "CMY_C": 0.16240376234055,
    "CMY_M": 0.12476640939713,
    "CMY_Y": 0.11039340496063,
    "CMYK_C": 0.05846444517374,
    "CMYK_M": 0.01615658402443,
    "CMYK_Y": 0,
    "CMYK_K": 0.11039340496063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07570",
    "Farbtonhilfsbezeichnung": "T1.23.63",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "180",
    "Bcolor": "216",
    "Y": 42,
    "L": 71.4262084960938,
    "a": -4.76066732406616,
    "b": -23.4747886657715,
    "C": 23.9526538848877,
    "h": 258.535949707031,
    "CMY_C": 0.45854341983795,
    "CMY_M": 0.2958505153656,
    "CMY_Y": 0.15440833568573,
    "CMYK_C": 0.3596713244915,
    "CMYK_M": 0.1672700792551,
    "CMYK_Y": 0,
    "CMYK_K": 0.15440833568573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07571",
    "Farbtonhilfsbezeichnung": "S9.20.69",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "199",
    "Bcolor": "229",
    "Y": 54,
    "L": 78.233523755036,
    "a": -6.26176380333093,
    "b": -20.2228927973053,
    "C": 21.1701459376171,
    "h": 1.2705215063497,
    "CMY_C": 0.3817989,
    "CMY_M": 0.2206057,
    "CMY_Y": 0.1026481,
    "CMYK_C": 0.3110829,
    "CMYK_M": 0.1314508,
    "CMYK_Y": 0,
    "CMYK_K": 0.1026481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07572",
    "Farbtonhilfsbezeichnung": "T0.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "215",
    "Bcolor": "228",
    "Y": 66,
    "L": 85.0403914754514,
    "a": -2.51976952712402,
    "b": -9.14852826784271,
    "C": 9.48919427229414,
    "h": 1.30203136902518,
    "CMY_C": 0.2219605,
    "CMY_M": 0.1580925,
    "CMY_Y": 0.1071017,
    "CMYK_C": 0.1286359,
    "CMYK_M": 0.05710704,
    "CMYK_Y": 0,
    "CMYK_K": 0.1071017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07573",
    "Farbtonhilfsbezeichnung": "S8.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "207",
    "Bcolor": "214",
    "Y": 61,
    "L": 82.4097068465936,
    "a": -2.13853541080777,
    "b": -5.73878580440657,
    "C": 6.124295568646,
    "h": 1.2140910579455,
    "CMY_C": 0.2337565,
    "CMY_M": 0.1888649,
    "CMY_Y": 0.1608132,
    "CMYK_C": 0.0869213,
    "CMYK_M": 0.03342722,
    "CMYK_Y": 0,
    "CMYK_K": 0.1608132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07574",
    "Farbtonhilfsbezeichnung": "S9.46.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "134",
    "Bcolor": "189",
    "Y": 21,
    "L": 52.5277337284376,
    "a": -11.2235515531832,
    "b": -37.8601366066093,
    "C": 39.4887079218614,
    "h": 1.2826016734515,
    "CMY_C": 1,
    "CMY_M": 0.4736306,
    "CMY_Y": 0.2607109,
    "CMYK_C": 1,
    "CMYK_M": 0.2880061,
    "CMYK_Y": 0,
    "CMYK_K": 0.2607109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07575",
    "Farbtonhilfsbezeichnung": "S8.31.59",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "172",
    "Bcolor": "215",
    "Y": 38,
    "L": 67.8182059475325,
    "a": -8.31033635934253,
    "b": -28.6546993525797,
    "C": 29.835440090472,
    "h": 1.28852366091465,
    "CMY_C": 0.5714951,
    "CMY_M": 0.324877,
    "CMY_Y": 0.1577995,
    "CMYK_C": 0.491208,
    "CMYK_M": 0.198382,
    "CMYK_Y": 0,
    "CMYK_K": 0.1577995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07577",
    "Farbtonhilfsbezeichnung": "S6.15.70",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "196",
    "Bcolor": "216",
    "Y": 53,
    "L": 77.6647870055522,
    "a": -5.72326187582461,
    "b": -14.315741827031,
    "C": 15.4173989556433,
    "h": 1.19047271670699,
    "CMY_C": 0.3523742,
    "CMY_M": 0.2298875,
    "CMY_Y": 0.1513342,
    "CMYK_C": 0.2368895,
    "CMYK_M": 0.09256089,
    "CMYK_Y": 0,
    "CMYK_K": 0.1513342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07578",
    "Farbtonhilfsbezeichnung": "S9.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "204",
    "Bcolor": "219",
    "Y": 58,
    "L": 80.9178303112661,
    "a": -2.90398045324158,
    "b": -10.6384925887794,
    "C": 11.0277208449581,
    "h": 1.30431914432525,
    "CMY_C": 0.2761161,
    "CMY_M": 0.2019262,
    "CMY_Y": 0.1417878,
    "CMYK_C": 0.1565211,
    "CMYK_M": 0.07007408,
    "CMYK_Y": 0,
    "CMYK_K": 0.1417878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07579",
    "Farbtonhilfsbezeichnung": "S9.05.74",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "204",
    "Bcolor": "210",
    "Y": 60,
    "L": 81.5793959952611,
    "a": -1.77743177234146,
    "b": -4.91023102176673,
    "C": 5.22203335803682,
    "h": 1.22348427639578,
    "CMY_C": 0.236642,
    "CMY_M": 0.1990017,
    "CMY_Y": 0.1758358,
    "CMYK_C": 0.07377924,
    "CMYK_M": 0.02810844,
    "CMYK_Y": 0,
    "CMYK_K": 0.1758358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07580",
    "Farbtonhilfsbezeichnung": "TN.02.75",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "208",
    "Bcolor": "211",
    "Y": 63,
    "L": 83.3703113982651,
    "a": -0.51959753792568,
    "b": -2.49124156043916,
    "C": 2.54485090209187,
    "h": 1.36517440114856,
    "CMY_C": 0.1982207,
    "CMY_M": 0.1830265,
    "CMY_Y": 0.1736885,
    "CMYK_C": 0.02968871,
    "CMYK_M": 0.01130079,
    "CMYK_Y": 0,
    "CMYK_K": 0.1736885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07581",
    "Farbtonhilfsbezeichnung": "T0.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "201",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.705946582021,
    "a": -1.19646622593167,
    "b": -4.37116167519145,
    "C": 4.53195165689769,
    "h": 1.30362224476589,
    "CMY_C": 0.2393844,
    "CMY_M": 0.2100024,
    "CMY_Y": 0.1891644,
    "CMYK_C": 0.06193617,
    "CMYK_M": 0.02569939,
    "CMYK_Y": 0,
    "CMYK_K": 0.1891644
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07582",
    "Farbtonhilfsbezeichnung": "T1.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "202",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.4823133181861,
    "a": -1.88308600740222,
    "b": -9.13454777827192,
    "C": 9.32662725881154,
    "h": 1.36749446644041,
    "CMY_C": 0.2659252,
    "CMY_M": 0.2094395,
    "CMY_Y": 0.1573075,
    "CMYK_C": 0.1288936,
    "CMYK_M": 0.06186358,
    "CMYK_Y": 0,
    "CMYK_K": 0.1573075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07583",
    "Farbtonhilfsbezeichnung": "T0.20.61",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "172",
    "Bcolor": "201",
    "Y": 39,
    "L": 68.5355930900632,
    "a": -5.17747528835438,
    "b": -20.0052555023411,
    "C": 20.6643775148314,
    "h": 1.31754721750565,
    "CMY_C": 0.4732603,
    "CMY_M": 0.3268241,
    "CMY_Y": 0.2104322,
    "CMYK_C": 0.3328759,
    "CMYK_M": 0.1474121,
    "CMYK_Y": 0,
    "CMYK_K": 0.2104322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07584",
    "Farbtonhilfsbezeichnung": "S9.40.50",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "148",
    "Bcolor": "198",
    "Y": 26,
    "L": 58.0298474338255,
    "a": -9.91806819107099,
    "b": -34.5185975770301,
    "C": 35.9152008949926,
    "h": 1.2910078263334,
    "CMY_C": 0.7742292,
    "CMY_M": 0.4214234,
    "CMY_Y": 0.2239849,
    "CMYK_C": 0.7090639,
    "CMYK_M": 0.2544261,
    "CMYK_Y": 0,
    "CMYK_K": 0.2239849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07585",
    "Farbtonhilfsbezeichnung": "S9.51.41",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "126",
    "Bcolor": "183",
    "Y": 18,
    "L": 49.3426837131308,
    "a": -11.2305561294929,
    "b": -39.685690007335,
    "C": 41.2441436125904,
    "h": 1.29501942514687,
    "CMY_C": 1,
    "CMY_M": 0.5047806,
    "CMY_Y": 0.2825902,
    "CMYK_C": 1,
    "CMYK_M": 0.3097119,
    "CMYK_Y": 0,
    "CMYK_K": 0.2825902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07586",
    "Farbtonhilfsbezeichnung": "S8.41.41",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "123",
    "Bcolor": "168",
    "Y": 17,
    "L": 48.7274805415857,
    "a": -9.50731710062969,
    "b": -31.653345168166,
    "C": 33.0503152600241,
    "h": 1.27901165599118,
    "CMY_C": 0.859988,
    "CMY_M": 0.5172387,
    "CMY_Y": 0.342672,
    "CMYK_C": 0.7869982,
    "CMYK_M": 0.2655702,
    "CMYK_Y": 0,
    "CMYK_K": 0.342672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07587",
    "Farbtonhilfsbezeichnung": "T1.34.47",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "137",
    "Bcolor": "179",
    "Y": 23,
    "L": 54.6286050908711,
    "a": -6.91971533777358,
    "b": -28.9100149490563,
    "C": 29.7266113896366,
    "h": 1.33586265753129,
    "CMY_C": 0.7035494,
    "CMY_M": 0.4639709,
    "CMY_Y": 0.2984902,
    "CMYK_C": 0.5774106,
    "CMYK_M": 0.2358922,
    "CMYK_Y": 0,
    "CMYK_K": 0.2984902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07588",
    "Farbtonhilfsbezeichnung": "S9.21.59",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "170",
    "Bcolor": "198",
    "Y": 37,
    "L": 67.6127094452863,
    "a": -6.14618262810451,
    "b": -19.4398502516002,
    "C": 20.3883137778153,
    "h": 1.26457684299991,
    "CMY_C": 0.4891508,
    "CMY_M": 0.3347256,
    "CMY_Y": 0.2244692,
    "CMYK_C": 0.3412908,
    "CMYK_M": 0.142169,
    "CMYK_Y": 0,
    "CMYK_K": 0.2244692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07590",
    "Farbtonhilfsbezeichnung": "S8.07.68",
    "Farbtonklasse": "01",
    "Rcolor": "176",
    "Gcolor": "189",
    "Bcolor": "199",
    "Y": 50,
    "L": 75.981721485288,
    "a": -2.56336715896105,
    "b": -7.06043761828652,
    "C": 7.51136675667987,
    "h": 1.22253388319966,
    "CMY_C": 0.3114068,
    "CMY_M": 0.257235,
    "CMY_Y": 0.2211869,
    "CMYK_C": 0.1158428,
    "CMYK_M": 0.04628588,
    "CMYK_Y": 0,
    "CMYK_K": 0.2211869
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07591",
    "Farbtonhilfsbezeichnung": "TN.02.66",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "181",
    "Bcolor": "185",
    "Y": 46,
    "L": 73.3340762093062,
    "a": -0.31189268447584,
    "b": -3.32603293323614,
    "C": 3.34062451041732,
    "h": 1.47729656777791,
    "CMY_C": 0.3075901,
    "CMY_M": 0.2917262,
    "CMY_Y": 0.2758039,
    "CMYK_C": 0.04389165,
    "CMYK_M": 0.0219862,
    "CMYK_Y": 0,
    "CMYK_K": 0.2758039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07593",
    "Farbtonhilfsbezeichnung": "S9.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "141",
    "Bcolor": "165",
    "Y": 25,
    "L": 56.9275307678046,
    "a": -5.16975940846304,
    "b": -17.3255629027054,
    "C": 18.0804187517047,
    "h": 1.28081806147892,
    "CMY_C": 0.5782753,
    "CMY_M": 0.4481467,
    "CMY_Y": 0.3524295,
    "CMYK_C": 0.3487585,
    "CMYK_M": 0.1478097,
    "CMYK_Y": 0,
    "CMYK_K": 0.3524295
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07595",
    "Farbtonhilfsbezeichnung": "S9.39.41",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "123",
    "Bcolor": "167",
    "Y": 18,
    "L": 48.9404163071061,
    "a": -8.23328945597818,
    "b": -30.8961869791438,
    "C": 31.9743870170507,
    "h": 1.31036599429802,
    "CMY_C": 0.8165434,
    "CMY_M": 0.5177423,
    "CMY_Y": 0.3453779,
    "CMYK_C": 0.7197519,
    "CMYK_M": 0.2633036,
    "CMYK_Y": 0,
    "CMYK_K": 0.3453779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07596",
    "Farbtonhilfsbezeichnung": "S9.51.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "157",
    "Y": 12,
    "L": 41.7691934822412,
    "a": -10.9325466215659,
    "b": -36.3986235479259,
    "C": 38.0050045627722,
    "h": 1.27901291731242,
    "CMY_C": 1,
    "CMY_M": 0.581059,
    "CMY_Y": 0.3843341,
    "CMYK_C": 1,
    "CMYK_M": 0.319532,
    "CMYK_Y": 0,
    "CMYK_K": 0.3843341
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07597",
    "Farbtonhilfsbezeichnung": "T1.52.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "108",
    "Bcolor": "165",
    "Y": 13,
    "L": 42.3426857616843,
    "a": -8.36275020022037,
    "b": -40.2536527225455,
    "C": 41.1131627148603,
    "h": 1.36595878854174,
    "CMY_C": 1,
    "CMY_M": 0.578261,
    "CMY_Y": 0.352966,
    "CMYK_C": 1,
    "CMYK_M": 0.3481964,
    "CMYK_Y": 0,
    "CMYK_K": 0.352966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07598",
    "Farbtonhilfsbezeichnung": "T0.48.31",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "100",
    "Bcolor": "148",
    "Y": 11,
    "L": 39.3657125530877,
    "a": -8.64514214470366,
    "b": -34.8490402042615,
    "C": 35.9053489867508,
    "h": 1.32763115305082,
    "CMY_C": 1,
    "CMY_M": 0.608686,
    "CMY_Y": 0.4191478,
    "CMYK_C": 1,
    "CMYK_M": 0.3263106,
    "CMYK_Y": 0,
    "CMYK_K": 0.4191478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07599",
    "Farbtonhilfsbezeichnung": "T0.33.37",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "111",
    "Bcolor": "147",
    "Y": 14,
    "L": 44.7108312087022,
    "a": -6.2910868194766,
    "b": -25.7518134433505,
    "C": 26.5091242592304,
    "h": 1.33119249831944,
    "CMY_C": 0.7770821,
    "CMY_M": 0.5648592,
    "CMY_Y": 0.4230138,
    "CMYK_C": 0.6136512,
    "CMYK_M": 0.2458384,
    "CMYK_Y": 0,
    "CMYK_K": 0.4230138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07600",
    "Farbtonhilfsbezeichnung": "S8.09.44",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "125",
    "Bcolor": "135",
    "Y": 20,
    "L": 51.7095715499116,
    "a": -2.48192839651779,
    "b": -7.4863707618783,
    "C": 7.88706001940822,
    "h": 1.25067303154189,
    "CMY_C": 0.5612731,
    "CMY_M": 0.5091844,
    "CMY_Y": 0.471408,
    "CMYK_C": 0.1700084,
    "CMYK_M": 0.07146613,
    "CMYK_Y": 0,
    "CMYK_K": 0.471408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07601",
    "Farbtonhilfsbezeichnung": "S8.04.54",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "152",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.4816507595599,
    "a": -1.55610959174463,
    "b": -4.01629053195487,
    "C": 4.30721101161644,
    "h": 1.20115598191639,
    "CMY_C": 0.4329009,
    "CMY_M": 0.4027267,
    "CMY_Y": 0.3849292,
    "CMYK_C": 0.07799374,
    "CMYK_M": 0.02893557,
    "CMYK_Y": 0,
    "CMYK_K": 0.3849292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07602",
    "Farbtonhilfsbezeichnung": "S8.17.39",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "113",
    "Bcolor": "131",
    "Y": 16,
    "L": 46.4623745646898,
    "a": -3.85741302581694,
    "b": -13.1584975302991,
    "C": 13.7122460781095,
    "h": 1.28563576004017,
    "CMY_C": 0.6485912,
    "CMY_M": 0.5566038,
    "CMY_Y": 0.4869804,
    "CMYK_C": 0.3150186,
    "CMYK_M": 0.1357128,
    "CMYK_Y": 0,
    "CMYK_K": 0.4869804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07603",
    "Farbtonhilfsbezeichnung": "S8.44.36",
    "Farbtonklasse": "04",
    "Rcolor": "8",
    "Gcolor": "112",
    "Bcolor": "156",
    "Y": 14,
    "L": 44.1299311302233,
    "a": -9.44500360174644,
    "b": -31.7686238814919,
    "C": 33.1429261888672,
    "h": 1.28181288874459,
    "CMY_C": 0.9668135,
    "CMY_M": 0.5625578,
    "CMY_Y": 0.3899392,
    "CMYK_C": 0.9456013,
    "CMYK_M": 0.282953,
    "CMYK_Y": 0,
    "CMYK_K": 0.3899392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07604",
    "Farbtonhilfsbezeichnung": "S8.51.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "98",
    "Bcolor": "143",
    "Y": 10,
    "L": 38.2826087530833,
    "a": -11.0163505443351,
    "b": -33.5449685552963,
    "C": 35.3075755991755,
    "h": 1.25348740322227,
    "CMY_C": 1,
    "CMY_M": 0.6155806,
    "CMY_Y": 0.4388022,
    "CMYK_C": 1,
    "CMYK_M": 0.315002,
    "CMYK_Y": 0,
    "CMYK_K": 0.4388022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07605",
    "Farbtonhilfsbezeichnung": "T0.54.29",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "142",
    "Y": 10,
    "L": 37.7209067500548,
    "a": -12.632875391015,
    "b": -33.7971459295654,
    "C": 36.0809730138926,
    "h": 1.21309104843352,
    "CMY_C": 1,
    "CMY_M": 0.6182158,
    "CMY_Y": 0.4430258,
    "CMYK_C": 1,
    "CMYK_M": 0.3145388,
    "CMYK_Y": 0,
    "CMYK_K": 0.4430258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07606",
    "Farbtonhilfsbezeichnung": "T1.54.28",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "151",
    "Y": 10,
    "L": 37.8132712034254,
    "a": -9.26697643838609,
    "b": -39.2821048394324,
    "C": 40.3603842019097,
    "h": 1.33912373141132,
    "CMY_C": 1,
    "CMY_M": 0.6205025,
    "CMY_Y": 0.4066422,
    "CMYK_C": 1,
    "CMYK_M": 0.3604238,
    "CMYK_Y": 0,
    "CMYK_K": 0.4066422
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07607",
    "Farbtonhilfsbezeichnung": "S8.49.28",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "138",
    "Y": 10,
    "L": 38.342198835736,
    "a": -10.0314635431522,
    "b": -30.4744618848447,
    "C": 32.0830654393941,
    "h": 1.25279196570911,
    "CMY_C": 1,
    "CMY_M": 0.6178643,
    "CMY_Y": 0.4578007,
    "CMYK_C": 1,
    "CMYK_M": 0.2952117,
    "CMYK_Y": 0,
    "CMYK_K": 0.4578007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07608",
    "Farbtonhilfsbezeichnung": "S9.40.31",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "99",
    "Bcolor": "136",
    "Y": 11,
    "L": 39.3292391386902,
    "a": -7.98136459622875,
    "b": -27.2423441633608,
    "C": 28.3874531498148,
    "h": 1.28579556989014,
    "CMY_C": 0.8946381,
    "CMY_M": 0.6131845,
    "CMY_Y": 0.4683269,
    "CMYK_C": 0.8018295,
    "CMYK_M": 0.2724562,
    "CMYK_Y": 0,
    "CMYK_K": 0.4683269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07609",
    "Farbtonhilfsbezeichnung": "T0.28.33",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "102",
    "Bcolor": "129",
    "Y": 12,
    "L": 41.4412725734269,
    "a": -5.50061391305332,
    "b": -19.6122601319572,
    "C": 20.3690328907397,
    "h": 1.29735358021301,
    "CMY_C": 0.7512206,
    "CMY_M": 0.6001135,
    "CMY_Y": 0.4957136,
    "CMYK_C": 0.5066703,
    "CMYK_M": 0.2070248,
    "CMYK_Y": 0,
    "CMYK_K": 0.4957136
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07610",
    "Farbtonhilfsbezeichnung": "S9.12.25",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "82",
    "Bcolor": "92",
    "Y": 8,
    "L": 34.3632917381624,
    "a": -1.93160391469038,
    "b": -7.67997068963787,
    "C": 7.91915674026875,
    "h": 1.32439521885675,
    "CMY_C": 0.7226337,
    "CMY_M": 0.6772363,
    "CMY_Y": 0.6389167,
    "CMYK_C": 0.2318495,
    "CMYK_M": 0.1061239,
    "CMYK_Y": 0,
    "CMYK_K": 0.6389167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07611",
    "Farbtonhilfsbezeichnung": "T1.06.29",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "90",
    "Bcolor": "96",
    "Y": 10,
    "L": 37.6700192308246,
    "a": -1.07189702232802,
    "b": -5.01642389813535,
    "C": 5.12966587140518,
    "h": 1.36028455818714,
    "CMY_C": 0.6758742,
    "CMY_M": 0.6487603,
    "CMY_Y": 0.6241531,
    "CMYK_C": 0.1376121,
    "CMYK_M": 0.06547138,
    "CMYK_Y": 0,
    "CMYK_K": 0.6241531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07612",
    "Farbtonhilfsbezeichnung": "T0.14.21",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "74",
    "Bcolor": "85",
    "Y": 6,
    "L": 30.4933665429727,
    "a": -2.4907231882898,
    "b": -8.82647823424276,
    "C": 9.1711733175339,
    "h": 1.29576016696047,
    "CMY_C": 0.7667218,
    "CMY_M": 0.7113853,
    "CMY_Y": 0.6680893,
    "CMYK_C": 0.2971657,
    "CMYK_M": 0.1304447,
    "CMYK_Y": 0,
    "CMYK_K": 0.6680893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07613",
    "Farbtonhilfsbezeichnung": "T0.19.26",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "87",
    "Bcolor": "104",
    "Y": 9,
    "L": 36.0189117115612,
    "a": -3.41346190497388,
    "b": -12.7127540437534,
    "C": 13.1630481862552,
    "h": 1.3084766834248,
    "CMY_C": 0.7419154,
    "CMY_M": 0.6575949,
    "CMY_Y": 0.5922232,
    "CMYK_C": 0.3670934,
    "CMYK_M": 0.1603125,
    "CMYK_Y": 0,
    "CMYK_K": 0.5922232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07614",
    "Farbtonhilfsbezeichnung": "T1.23.25",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "89",
    "Bcolor": "108",
    "Y": 9,
    "L": 36.7967720031738,
    "a": -2.59794330596924,
    "b": -13.7807579040527,
    "C": 14.0235013961792,
    "h": 259.323913574219,
    "CMY_C": 0.73300802707672,
    "CMY_M": 0.65150064229965,
    "CMY_Y": 0.57800459861755,
    "CMYK_C": 0.36731070280075,
    "CMYK_M": 0.17416313290596,
    "CMYK_Y": 0,
    "CMYK_K": 0.57800459861755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07615",
    "Farbtonhilfsbezeichnung": "S9.30.29",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "97",
    "Bcolor": "123",
    "Y": 11,
    "L": 39.4662830903033,
    "a": -5.56777936603942,
    "b": -19.4220105979866,
    "C": 20.2043228725241,
    "h": 1.29160990011265,
    "CMY_C": 0.7704881,
    "CMY_M": 0.6189495,
    "CMY_Y": 0.5165951,
    "CMYK_C": 0.5252182,
    "CMYK_M": 0.2117364,
    "CMYK_Y": 0,
    "CMYK_K": 0.5165951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07616",
    "Farbtonhilfsbezeichnung": "S8.33.26",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "84",
    "Bcolor": "112",
    "Y": 8,
    "L": 33.7974231310751,
    "a": -6.3067960843928,
    "b": -21.4331482362479,
    "C": 22.3417886519207,
    "h": 1.2846191145104,
    "CMY_C": 0.8569213,
    "CMY_M": 0.670291,
    "CMY_Y": 0.559829,
    "CMYK_C": 0.6749473,
    "CMYK_M": 0.2509526,
    "CMYK_Y": 0,
    "CMYK_K": 0.559829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07617",
    "Farbtonhilfsbezeichnung": "T1.48.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "85",
    "Bcolor": "126",
    "Y": 8,
    "L": 33.9183301222209,
    "a": -6.70108630715843,
    "b": -30.020513897042,
    "C": 30.7593207392243,
    "h": 1.35117970320084,
    "CMY_C": 1,
    "CMY_M": 0.6652873,
    "CMY_Y": 0.5050867,
    "CMYK_C": 1,
    "CMYK_M": 0.3236943,
    "CMYK_Y": 0,
    "CMYK_K": 0.5050867
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07618",
    "Farbtonhilfsbezeichnung": "S9.54.27",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "93",
    "Bcolor": "141",
    "Y": 9,
    "L": 36.2132279065665,
    "a": -9.91876735522312,
    "b": -35.4501254068633,
    "C": 36.8115924296868,
    "h": 1.29797774289921,
    "CMY_C": 1,
    "CMY_M": 0.636215,
    "CMY_Y": 0.4477179,
    "CMYK_C": 1,
    "CMYK_M": 0.3413058,
    "CMYK_Y": 0,
    "CMYK_K": 0.4477179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07619",
    "Farbtonhilfsbezeichnung": "T0.51.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "88",
    "Bcolor": "133",
    "Y": 8,
    "L": 34.9540035508844,
    "a": -7.35518932147652,
    "b": -32.4854119359169,
    "C": 33.3076687656308,
    "h": 1.34813533598848,
    "CMY_C": 1,
    "CMY_M": 0.6535306,
    "CMY_Y": 0.4791908,
    "CMYK_C": 1,
    "CMYK_M": 0.3347479,
    "CMYK_Y": 0,
    "CMYK_K": 0.4791908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07620",
    "Farbtonhilfsbezeichnung": "T0.41.23",
    "Farbtonklasse": "04",
    "Rcolor": "18",
    "Gcolor": "83",
    "Bcolor": "118",
    "Y": 8,
    "L": 33.0539439713454,
    "a": -5.93060399639364,
    "b": -26.2919380429052,
    "C": 26.9525150925476,
    "h": 1.34894189456929,
    "CMY_C": 0.9302565,
    "CMY_M": 0.6760654,
    "CMY_Y": 0.536922,
    "CMYK_C": 0.8493916,
    "CMYK_M": 0.300475,
    "CMYK_Y": 0,
    "CMYK_K": 0.536922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07621",
    "Farbtonhilfsbezeichnung": "T0.34.21",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "78",
    "Bcolor": "106",
    "Y": 7,
    "L": 31.2168587978435,
    "a": -5.28246665289397,
    "b": -21.5971453293165,
    "C": 22.2337837606323,
    "h": 1.33091496189975,
    "CMY_C": 0.8730521,
    "CMY_M": 0.6957995,
    "CMY_Y": 0.5838354,
    "CMYK_C": 0.6949574,
    "CMYK_M": 0.2690381,
    "CMYK_Y": 0,
    "CMYK_K": 0.5838354
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07622",
    "Farbtonhilfsbezeichnung": "T0.31.20",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "76",
    "Bcolor": "100",
    "Y": 7,
    "L": 30.8366576471449,
    "a": -4.26811610324737,
    "b": -17.9472453636507,
    "C": 18.447775779586,
    "h": 1.33731879121018,
    "CMY_C": 0.8312358,
    "CMY_M": 0.7022874,
    "CMY_Y": 0.6097308,
    "CMYK_C": 0.5675699,
    "CMYK_M": 0.237161,
    "CMYK_Y": 0,
    "CMYK_K": 0.6097308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07623",
    "Farbtonhilfsbezeichnung": "S8.27.15",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "65",
    "Bcolor": "82",
    "Y": 5,
    "L": 26.1614161119356,
    "a": -4.10195520491496,
    "b": -13.6038367339914,
    "C": 14.2088145314176,
    "h": 1.27793710698077,
    "CMY_C": 0.844183,
    "CMY_M": 0.7460921,
    "CMY_Y": 0.6797216,
    "CMYK_C": 0.5134953,
    "CMYK_M": 0.2072275,
    "CMYK_Y": 0,
    "CMYK_K": 0.6797216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07624",
    "Farbtonhilfsbezeichnung": "S9.20.21",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "80",
    "Bcolor": "93",
    "Y": 6,
    "L": 33.0025482177734,
    "a": -2.71934080123901,
    "b": -10.3625993728638,
    "C": 10.7134628295898,
    "h": 255.296051025391,
    "CMY_C": 0.7526148557663,
    "CMY_M": 0.68756651878357,
    "CMY_Y": 0.63534462451935,
    "CMYK_C": 0.32159194350243,
    "CMYK_M": 0.14320889115334,
    "CMYK_Y": 0,
    "CMYK_K": 0.63534462451935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07625",
    "Farbtonhilfsbezeichnung": "S9.04.14",
    "Farbtonklasse": "03",
    "Rcolor": "58",
    "Gcolor": "62",
    "Bcolor": "64",
    "Y": 5,
    "L": 25.9354743385806,
    "a": -0.69297438627455,
    "b": -2.39403149582832,
    "C": 2.49230822793863,
    "h": 1.28903784522497,
    "CMY_C": 0.7706491,
    "CMY_M": 0.7572096,
    "CMY_Y": 0.7474161,
    "CMYK_C": 0.09198128,
    "CMYK_M": 0.03877325,
    "CMYK_Y": 0,
    "CMYK_K": 0.7474161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07626",
    "Farbtonhilfsbezeichnung": "TN.02.08",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "52",
    "Bcolor": "53",
    "Y": 3,
    "L": 21.3841220942993,
    "a": -0.42136321249647,
    "b": -1.77165594263784,
    "C": 1.82107433564073,
    "h": 1.33729867785077,
    "CMY_C": 0.8063633,
    "CMY_M": 0.7974836,
    "CMY_Y": 0.7906064,
    "CMYK_C": 0.07524972,
    "CMYK_M": 0.03284317,
    "CMYK_Y": 0,
    "CMYK_K": 0.7906064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07627",
    "Farbtonhilfsbezeichnung": "S9.10.16",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "63",
    "Bcolor": "70",
    "Y": 5,
    "L": 26.0482724348212,
    "a": -1.66544041201819,
    "b": -6.11021292722308,
    "C": 6.33311880371649,
    "h": 1.30469376454589,
    "CMY_C": 0.7889894,
    "CMY_M": 0.7535012,
    "CMY_Y": 0.7247123,
    "CMYK_C": 0.2334905,
    "CMYK_M": 0.1045777,
    "CMYK_Y": 0,
    "CMYK_K": 0.7247123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07628",
    "Farbtonhilfsbezeichnung": "S9.16.15",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "63",
    "Bcolor": "73",
    "Y": 5,
    "L": 25.7989753711309,
    "a": -2.66855973083852,
    "b": -8.29517830982782,
    "C": 8.71385071187767,
    "h": 1.25955195919803,
    "CMY_C": 0.8074667,
    "CMY_M": 0.7533332,
    "CMY_Y": 0.7142124,
    "CMYK_C": 0.3263062,
    "CMYK_M": 0.1368873,
    "CMYK_Y": 0,
    "CMYK_K": 0.7142124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07629",
    "Farbtonhilfsbezeichnung": "S8.24.14",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "67",
    "Bcolor": "81",
    "Y": 5,
    "L": 27.1639673948882,
    "a": -3.64612392439603,
    "b": -11.4979863530438,
    "C": 12.0622514418675,
    "h": 1.26371733004317,
    "CMY_C": 0.8187717,
    "CMY_M": 0.738569,
    "CMY_Y": 0.6829345,
    "CMYK_C": 0.4284201,
    "CMYK_M": 0.1754672,
    "CMYK_Y": 0,
    "CMYK_K": 0.6829345
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07630",
    "Farbtonhilfsbezeichnung": "S9.29.17",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "67",
    "Bcolor": "86",
    "Y": 5,
    "L": 27.5317518800064,
    "a": -3.10407874441837,
    "b": -14.2948111811388,
    "C": 14.6279503538931,
    "h": 1.35696870898098,
    "CMY_C": 0.8262547,
    "CMY_M": 0.7353813,
    "CMY_Y": 0.6628436,
    "CMYK_C": 0.4846746,
    "CMYK_M": 0.2151456,
    "CMYK_Y": 0,
    "CMYK_K": 0.6628436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07631",
    "Farbtonhilfsbezeichnung": "S8.37.14",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "67",
    "Bcolor": "90",
    "Y": 5,
    "L": 26.7764887924815,
    "a": -4.87081663925221,
    "b": -17.9442106655186,
    "C": 18.5935351975284,
    "h": 1.30574074141143,
    "CMY_C": 0.8793488,
    "CMY_M": 0.7379214,
    "CMY_Y": 0.6482533,
    "CMYK_C": 0.6569942,
    "CMYK_M": 0.2549225,
    "CMYK_Y": 0,
    "CMYK_K": 0.6482533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07632",
    "Farbtonhilfsbezeichnung": "S8.44.20",
    "Farbtonklasse": "04",
    "Rcolor": "17",
    "Gcolor": "79",
    "Bcolor": "110",
    "Y": 7,
    "L": 31.3795255157621,
    "a": -6.94484099357778,
    "b": -23.7440726192362,
    "C": 24.7388722655994,
    "h": 1.28624603832219,
    "CMY_C": 0.9334877,
    "CMY_M": 0.6907202,
    "CMY_Y": 0.5691765,
    "CMYK_C": 0.8456158,
    "CMYK_M": 0.2821195,
    "CMYK_Y": 0,
    "CMYK_K": 0.5691765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07633",
    "Farbtonhilfsbezeichnung": "T2.32.55",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "158",
    "Bcolor": "208",
    "Y": 31,
    "L": 63.0785293579102,
    "a": -5.53098583221436,
    "b": -32.2308311462402,
    "C": 32.701961517334,
    "h": 260.262573242188,
    "CMY_C": 0.61981654167175,
    "CMY_M": 0.3788041472435,
    "CMY_Y": 0.18449008464813,
    "CMYK_C": 0.53380888700485,
    "CMYK_M": 0.23827308416367,
    "CMYK_Y": 0,
    "CMYK_K": 0.18449008464813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07634",
    "Farbtonhilfsbezeichnung": "T5.25.64",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "179",
    "Bcolor": "222",
    "Y": 43,
    "L": 71.4625067649772,
    "a": -3.84872445768769,
    "b": -27.115060268634,
    "C": 27.3868430696722,
    "h": 1.42979772451564,
    "CMY_C": 0.4713606,
    "CMY_M": 0.296105,
    "CMY_Y": 0.1281215,
    "CMYK_C": 0.3936776,
    "CMYK_M": 0.1926684,
    "CMYK_Y": 0,
    "CMYK_K": 0.1281215
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07635",
    "Farbtonhilfsbezeichnung": "T5.15.74",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "206",
    "Bcolor": "234",
    "Y": 61,
    "L": 81.6355895996094,
    "a": -1.97324705123901,
    "b": -17.8319969177246,
    "C": 17.9408416748047,
    "h": 263.685485839844,
    "CMY_C": 0.29283004999161,
    "CMY_M": 0.19383382797241,
    "CMY_Y": 0.08165460824966,
    "CMYK_C": 0.22995209693909,
    "CMYK_M": 0.12215362489223,
    "CMYK_Y": 0,
    "CMYK_K": 0.08165460824966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07636",
    "Farbtonhilfsbezeichnung": "T2.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "219",
    "Bcolor": "233",
    "Y": 69,
    "L": 86.6265283043806,
    "a": -2.5099733591093,
    "b": -9.48971076328629,
    "C": 9.81603670705596,
    "h": 1.31222327596656,
    "CMY_C": 0.2059826,
    "CMY_M": 0.1405099,
    "CMY_Y": 0.08701088,
    "CMYK_C": 0.1303101,
    "CMYK_M": 0.05859769,
    "CMYK_Y": 0,
    "CMYK_K": 0.08701088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07637",
    "Farbtonhilfsbezeichnung": "T5.35.54",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "154",
    "Bcolor": "208",
    "Y": 30,
    "L": 61.6707349431553,
    "a": -4.61748738166695,
    "b": -34.5498111452183,
    "C": 34.8570027381889,
    "h": 1.43793636997259,
    "CMY_C": 0.6450199,
    "CMY_M": 0.3943322,
    "CMY_Y": 0.1837087,
    "CMYK_C": 0.5651307,
    "CMYK_M": 0.258025,
    "CMYK_Y": 0,
    "CMYK_K": 0.1837087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07638",
    "Farbtonhilfsbezeichnung": "T4.32.56",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "161",
    "Bcolor": "211",
    "Y": 33,
    "L": 64.1374869042319,
    "a": -4.88579797697164,
    "b": -32.3203037851497,
    "C": 32.6875061550456,
    "h": 1.42076420768397,
    "CMY_C": 0.6006857,
    "CMY_M": 0.3690741,
    "CMY_Y": 0.1722219,
    "CMYK_C": 0.5176071,
    "CMYK_M": 0.237808,
    "CMYK_Y": 0,
    "CMYK_K": 0.1722219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07639",
    "Farbtonhilfsbezeichnung": "T4.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "205",
    "Bcolor": "225",
    "Y": 59,
    "L": 81.2914428863565,
    "a": -2.46406712854236,
    "b": -13.5816792328061,
    "C": 13.8033922496175,
    "h": 1.39132267109033,
    "CMY_C": 0.2811539,
    "CMY_M": 0.1979059,
    "CMY_Y": 0.116328,
    "CMYK_C": 0.1865238,
    "CMYK_M": 0.09231698,
    "CMYK_Y": 0,
    "CMYK_K": 0.116328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07640",
    "Farbtonhilfsbezeichnung": "T4.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "215",
    "Bcolor": "226",
    "Y": 67,
    "L": 85.2819317859415,
    "a": -1.776422791612,
    "b": -7.93748401670158,
    "C": 8.1338386048625,
    "h": 1.35062269093028,
    "CMY_C": 0.2081665,
    "CMY_M": 0.1575088,
    "CMY_Y": 0.1131835,
    "CMYK_C": 0.1071056,
    "CMYK_M": 0.04998248,
    "CMYK_Y": 0,
    "CMYK_K": 0.1131835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07641",
    "Farbtonhilfsbezeichnung": "T2.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "220",
    "Bcolor": "230",
    "Y": 70,
    "L": 87.1847644916557,
    "a": -1.80170719366696,
    "b": -6.97014207048745,
    "C": 7.19923810513934,
    "h": 1.3178438246001,
    "CMY_C": 0.1837233,
    "CMY_M": 0.1367438,
    "CMY_Y": 0.09920555,
    "CMYK_C": 0.09382575,
    "CMYK_M": 0.04167242,
    "CMYK_Y": 0,
    "CMYK_K": 0.09920555
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07642",
    "Farbtonhilfsbezeichnung": "T4.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 69,
    "L": 86.4973611299463,
    "a": -0.50274190106369,
    "b": -3.86301749819311,
    "C": 3.89559412804149,
    "h": 1.4413814108385,
    "CMY_C": 0.1688183,
    "CMY_M": 0.1482898,
    "CMY_Y": 0.1294104,
    "CMYK_C": 0.04526582,
    "CMYK_M": 0.02168574,
    "CMYK_Y": 0,
    "CMYK_K": 0.1294104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07643",
    "Farbtonhilfsbezeichnung": "T5.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "212",
    "Bcolor": "219",
    "Y": 65,
    "L": 84.7062480225897,
    "a": -0.76217117657656,
    "b": -4.73088359293068,
    "C": 4.79188527327865,
    "h": 1.41106338444545,
    "CMY_C": 0.1937458,
    "CMY_M": 0.1671523,
    "CMY_Y": 0.1427989,
    "CMYK_C": 0.05943399,
    "CMYK_M": 0.02841032,
    "CMYK_Y": 0,
    "CMYK_K": 0.1427989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07644",
    "Farbtonhilfsbezeichnung": "T7.09.74",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "202",
    "Bcolor": "217",
    "Y": 58,
    "L": 80.9697186119393,
    "a": -1.03855735027186,
    "b": -9.34200663783482,
    "C": 9.39955793594324,
    "h": 1.46008025090171,
    "CMY_C": 0.2544869,
    "CMY_M": 0.2059906,
    "CMY_Y": 0.1503671,
    "CMYK_C": 0.1225468,
    "CMYK_M": 0.06546767,
    "CMYK_Y": 0,
    "CMYK_K": 0.1503671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07645",
    "Farbtonhilfsbezeichnung": "T7.15.69",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "190",
    "Bcolor": "220",
    "Y": 50,
    "L": 76.3005271909207,
    "a": -1.32296437610646,
    "b": -18.3328871844934,
    "C": 18.3805600366204,
    "h": 1.49875775272743,
    "CMY_C": 0.3468128,
    "CMY_M": 0.2529778,
    "CMY_Y": 0.1370649,
    "CMYK_C": 0.2430634,
    "CMYK_M": 0.1343241,
    "CMYK_Y": 0,
    "CMYK_K": 0.1370649
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07646",
    "Farbtonhilfsbezeichnung": "T4.16.69",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "192",
    "Bcolor": "219",
    "Y": 51,
    "L": 76.5444830582696,
    "a": -3.20286687397936,
    "b": -17.3557791028386,
    "C": 17.6488363491467,
    "h": 1.38830762510251,
    "CMY_C": 0.3562987,
    "CMY_M": 0.2465051,
    "CMY_Y": 0.1415743,
    "CMYK_C": 0.2501374,
    "CMYK_M": 0.1222364,
    "CMYK_Y": 0,
    "CMYK_K": 0.1415743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07647",
    "Farbtonhilfsbezeichnung": "T3.24.59",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "168",
    "Bcolor": "205",
    "Y": 37,
    "L": 67.0290278273149,
    "a": -4.62531352832962,
    "b": -24.5448375182419,
    "C": 24.976840753631,
    "h": 1.38453713758609,
    "CMY_C": 0.5105057,
    "CMY_M": 0.3422691,
    "CMY_Y": 0.1949347,
    "CMYK_C": 0.3919818,
    "CMYK_M": 0.1830094,
    "CMYK_Y": 0,
    "CMYK_K": 0.1949347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07648",
    "Farbtonhilfsbezeichnung": "T2.34.53",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "153",
    "Bcolor": "202",
    "Y": 29,
    "L": 61.0141516119821,
    "a": -6.29463046696693,
    "b": -32.0632459531937,
    "C": 32.6752829179896,
    "h": 1.37694249975991,
    "CMY_C": 0.6516481,
    "CMY_M": 0.3987143,
    "CMY_Y": 0.2082209,
    "CMYK_C": 0.560039,
    "CMYK_M": 0.240589,
    "CMYK_Y": 0,
    "CMYK_K": 0.2082209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07649",
    "Farbtonhilfsbezeichnung": "T7.39.52",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "149",
    "Bcolor": "209",
    "Y": 28,
    "L": 59.5851010538022,
    "a": -3.60057669101294,
    "b": -38.5974289175378,
    "C": 38.7650057597345,
    "h": 1.47778011521576,
    "CMY_C": 0.697418,
    "CMY_M": 0.4161968,
    "CMY_Y": 0.1784481,
    "CMYK_C": 0.6316946,
    "CMYK_M": 0.2893897,
    "CMYK_Y": 0,
    "CMYK_K": 0.1784481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07650",
    "Farbtonhilfsbezeichnung": "T5.45.44",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "131",
    "Bcolor": "193",
    "Y": 20,
    "L": 52.0579630179709,
    "a": -5.20933285687969,
    "b": -41.0685628013851,
    "C": 41.3976327751368,
    "h": 1.44462534675404,
    "CMY_C": 0.8894774,
    "CMY_M": 0.4881727,
    "CMY_Y": 0.2436444,
    "CMYK_C": 0.8538748,
    "CMYK_M": 0.323298,
    "CMYK_Y": 0,
    "CMYK_K": 0.2436444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07651",
    "Farbtonhilfsbezeichnung": "T6.35.52",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "148",
    "Bcolor": "202",
    "Y": 27,
    "L": 59.3807486437748,
    "a": -4.08320679791829,
    "b": -34.4709359267699,
    "C": 34.7119288058449,
    "h": 1.45289211668376,
    "CMY_C": 0.6636642,
    "CMY_M": 0.4190187,
    "CMY_Y": 0.2091971,
    "CMYK_C": 0.5746906,
    "CMYK_M": 0.2653273,
    "CMYK_Y": 0,
    "CMYK_K": 0.2091971
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07652",
    "Farbtonhilfsbezeichnung": "T6.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "156",
    "Bcolor": "195",
    "Y": 31,
    "L": 62.880327833924,
    "a": -3.49961799644921,
    "b": -25.4402416915932,
    "C": 25.6798213281898,
    "h": 1.4340920271176,
    "CMY_C": 0.5485729,
    "CMY_M": 0.3876003,
    "CMY_Y": 0.2335631,
    "CMYK_C": 0.4110056,
    "CMYK_M": 0.2009784,
    "CMYK_Y": 0,
    "CMYK_K": 0.2335631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07653",
    "Farbtonhilfsbezeichnung": "T2.17.63",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "177",
    "Bcolor": "204",
    "Y": 42,
    "L": 70.8953646537026,
    "a": -3.87332649134997,
    "b": -17.7934145277801,
    "C": 18.2101141859684,
    "h": 1.35645698613173,
    "CMY_C": 0.4244431,
    "CMY_M": 0.3053523,
    "CMY_Y": 0.200266,
    "CMYK_C": 0.2803145,
    "CMYK_M": 0.1314015,
    "CMYK_Y": 0,
    "CMYK_K": 0.200266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07654",
    "Farbtonhilfsbezeichnung": "T4.16.64",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "182",
    "Bcolor": "207",
    "Y": 45,
    "L": 72.7988510768306,
    "a": -2.96909331104467,
    "b": -16.5816546104848,
    "C": 16.84537873457,
    "h": 1.39361507535881,
    "CMY_C": 0.3901885,
    "CMY_M": 0.2874506,
    "CMY_Y": 0.1880473,
    "CMYK_C": 0.2489569,
    "CMYK_M": 0.122425,
    "CMYK_Y": 0,
    "CMYK_K": 0.1880473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07655",
    "Farbtonhilfsbezeichnung": "T4.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "193",
    "Bcolor": "211",
    "Y": 52,
    "L": 77.306011569442,
    "a": -2.17912532761283,
    "b": -11.6802317565599,
    "C": 11.8817675907415,
    "h": 1.38635153573454,
    "CMY_C": 0.3131318,
    "CMY_M": 0.2424044,
    "CMY_Y": 0.1737579,
    "CMYK_C": 0.1686841,
    "CMYK_M": 0.08308277,
    "CMYK_Y": 0,
    "CMYK_K": 0.1737579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07656",
    "Farbtonhilfsbezeichnung": "T7.06.69",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "190",
    "Bcolor": "200",
    "Y": 51,
    "L": 76.5658358324712,
    "a": -0.63119275358358,
    "b": -6.96354843028739,
    "C": 6.99209632607664,
    "h": 1.48040094925035,
    "CMY_C": 0.2890955,
    "CMY_M": 0.2553196,
    "CMY_Y": 0.2153393,
    "CMYK_C": 0.09399757,
    "CMYK_M": 0.05095237,
    "CMYK_Y": 0,
    "CMYK_K": 0.2153393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07657",
    "Farbtonhilfsbezeichnung": "T3.03.71",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "194",
    "Bcolor": "198",
    "Y": 53,
    "L": 78.0302367193381,
    "a": -0.90461596122937,
    "b": -3.51818820663687,
    "C": 3.63262691376774,
    "h": 1.3191226198684,
    "CMY_C": 0.2627712,
    "CMY_M": 0.239926,
    "CMY_Y": 0.2242197,
    "CMYK_C": 0.04969384,
    "CMYK_M": 0.02024575,
    "CMYK_Y": 0,
    "CMYK_K": 0.2242197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07658",
    "Farbtonhilfsbezeichnung": "T2.04.63",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "176",
    "Bcolor": "181",
    "Y": 43,
    "L": 71.3329364849839,
    "a": -0.8693316367595,
    "b": -4.20411366583999,
    "C": 4.2930535997089,
    "h": 1.36688897368053,
    "CMY_C": 0.3362461,
    "CMY_M": 0.3115023,
    "CMY_Y": 0.2909285,
    "CMYK_C": 0.06391116,
    "CMYK_M": 0.02901514,
    "CMYK_Y": 0,
    "CMYK_K": 0.2909285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07659",
    "Farbtonhilfsbezeichnung": "T2.05.64",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "179",
    "Bcolor": "187",
    "Y": 45,
    "L": 72.6096424095681,
    "a": -1.39525521131856,
    "b": -5.62185715581229,
    "C": 5.79241011885981,
    "h": 1.32752753308739,
    "CMY_C": 0.3321557,
    "CMY_M": 0.2963508,
    "CMY_Y": 0.267425,
    "CMYK_C": 0.08836058,
    "CMYK_M": 0.03948512,
    "CMYK_Y": 0,
    "CMYK_K": 0.267425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07660",
    "Farbtonhilfsbezeichnung": "T5.10.64",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "178",
    "Bcolor": "195",
    "Y": 43,
    "L": 71.8252134260876,
    "a": -1.80557782355495,
    "b": -11.2451888880368,
    "C": 11.389222291471,
    "h": 1.411590730287,
    "CMY_C": 0.3662083,
    "CMY_M": 0.3020877,
    "CMY_Y": 0.2361821,
    "CMYK_C": 0.1702319,
    "CMYK_M": 0.08628438,
    "CMYK_Y": 0,
    "CMYK_K": 0.2361821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07661",
    "Farbtonhilfsbezeichnung": "T2.13.63",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "177",
    "Bcolor": "198",
    "Y": 42,
    "L": 71.0450086983494,
    "a": -2.94836766752843,
    "b": -14.4564815319952,
    "C": 14.7540750366753,
    "h": 1.36960769906963,
    "CMY_C": 0.3983927,
    "CMY_M": 0.3068556,
    "CMY_Y": 0.222073,
    "CMYK_C": 0.2266533,
    "CMYK_M": 0.1089853,
    "CMYK_Y": 0,
    "CMYK_K": 0.222073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07662",
    "Farbtonhilfsbezeichnung": "T5.19.60",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "166",
    "Bcolor": "197",
    "Y": 37,
    "L": 66.9665389871844,
    "a": -2.89552817455091,
    "b": -19.7598899859495,
    "C": 19.9709122392154,
    "h": 1.42529621369279,
    "CMY_C": 0.4668468,
    "CMY_M": 0.3482589,
    "CMY_Y": 0.2288876,
    "CMYK_C": 0.3085922,
    "CMYK_M": 0.154804,
    "CMYK_Y": 0,
    "CMYK_K": 0.2288876
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07663",
    "Farbtonhilfsbezeichnung": "T2.37.43",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "128",
    "Bcolor": "174",
    "Y": 20,
    "L": 51.3279194900306,
    "a": -6.07009797980351,
    "b": -31.038825148434,
    "C": 31.6268043924687,
    "h": 1.37766911024721,
    "CMY_C": 0.7514402,
    "CMY_M": 0.4979756,
    "CMY_Y": 0.3190967,
    "CMYK_C": 0.6349557,
    "CMYK_M": 0.2627083,
    "CMYK_Y": 0,
    "CMYK_K": 0.3190967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07664",
    "Farbtonhilfsbezeichnung": "T2.43.44",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "133",
    "Bcolor": "187",
    "Y": 20,
    "L": 52.9391632080078,
    "a": -6.81149625778198,
    "b": -36.0076904296875,
    "C": 36.6462860107422,
    "h": 259.288055419922,
    "CMY_C": 0.80853527784348,
    "CMY_M": 0.47843044996262,
    "CMY_Y": 0.26852291822433,
    "CMYK_C": 0.73824918270111,
    "CMYK_M": 0.28696390986443,
    "CMYK_Y": 0,
    "CMYK_K": 0.26852291822433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07665",
    "Farbtonhilfsbezeichnung": "T3.38.38",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "115",
    "Bcolor": "161",
    "Y": 16,
    "L": 46.5198429031146,
    "a": -4.81862166020741,
    "b": -31.1165625017204,
    "C": 31.4874510976625,
    "h": 1.41715954476554,
    "CMY_C": 0.7916939,
    "CMY_M": 0.5478982,
    "CMY_Y": 0.3690252,
    "CMYK_C": 0.6698662,
    "CMYK_M": 0.2834867,
    "CMYK_Y": 0,
    "CMYK_K": 0.3690252
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07666",
    "Farbtonhilfsbezeichnung": "T6.37.42",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "124",
    "Bcolor": "174",
    "Y": 19,
    "L": 50.1272976411332,
    "a": -3.78910755574996,
    "b": -33.3650924049493,
    "C": 33.5795581754711,
    "h": 1.45771577485821,
    "CMY_C": 0.7574943,
    "CMY_M": 0.5134106,
    "CMY_Y": 0.3160732,
    "CMYK_C": 0.6454216,
    "CMYK_M": 0.2885358,
    "CMYK_Y": 0,
    "CMYK_K": 0.3160732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07667",
    "Farbtonhilfsbezeichnung": "T4.29.50",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "145",
    "Bcolor": "187",
    "Y": 26,
    "L": 58.3500764151512,
    "a": -4.33751624477763,
    "b": -27.8523527273628,
    "C": 28.1880754863319,
    "h": 1.41630480121721,
    "CMY_C": 0.6223586,
    "CMY_M": 0.4316278,
    "CMY_Y": 0.2657589,
    "CMYK_C": 0.485671,
    "CMYK_M": 0.2259053,
    "CMYK_Y": 0,
    "CMYK_K": 0.2657589
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07668",
    "Farbtonhilfsbezeichnung": "T4.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "142",
    "Bcolor": "172",
    "Y": 26,
    "L": 57.745643846442,
    "a": -3.4611718201486,
    "b": -19.8102973994277,
    "C": 20.1103852131769,
    "h": 1.39782643541737,
    "CMY_C": 0.5676261,
    "CMY_M": 0.4424537,
    "CMY_Y": 0.3268638,
    "CMYK_C": 0.3576724,
    "CMYK_M": 0.1717184,
    "CMYK_Y": 0,
    "CMYK_K": 0.3268638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07669",
    "Farbtonhilfsbezeichnung": "T5.15.47",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "132",
    "Bcolor": "153",
    "Y": 22,
    "L": 54.124648550985,
    "a": -2.01527702222332,
    "b": -14.6111320871066,
    "C": 14.7494583745701,
    "h": 1.4337336141789,
    "CMY_C": 0.564348,
    "CMY_M": 0.4838072,
    "CMY_Y": 0.3994404,
    "CMYK_C": 0.2745899,
    "CMYK_M": 0.1404802,
    "CMYK_Y": 0,
    "CMYK_K": 0.3994404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07670",
    "Farbtonhilfsbezeichnung": "T4.13.55",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "155",
    "Bcolor": "175",
    "Y": 32,
    "L": 63.0029007463574,
    "a": -2.03262119645625,
    "b": -13.5691614037599,
    "C": 13.7205572091505,
    "h": 1.42210480813456,
    "CMY_C": 0.469887,
    "CMY_M": 0.3934631,
    "CMY_Y": 0.3139773,
    "CMYK_C": 0.2272661,
    "CMYK_M": 0.1158646,
    "CMYK_Y": 0,
    "CMYK_K": 0.3139773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07671",
    "Farbtonhilfsbezeichnung": "T2.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "176",
    "Bcolor": "189",
    "Y": 43,
    "L": 71.2467029475648,
    "a": -1.61198055116829,
    "b": -8.68928069833992,
    "C": 8.83753813863835,
    "h": 1.38736791265478,
    "CMY_C": 0.3601563,
    "CMY_M": 0.3094447,
    "CMY_Y": 0.2603717,
    "CMYK_C": 0.1349118,
    "CMYK_M": 0.06634817,
    "CMYK_Y": 0,
    "CMYK_K": 0.2603717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07672",
    "Farbtonhilfsbezeichnung": "T7.03.55",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "152",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.5400895174587,
    "a": -0.52414179735943,
    "b": -4.20743516801354,
    "C": 4.23995699468477,
    "h": 1.4468596842831,
    "CMY_C": 0.4250768,
    "CMY_M": 0.4043056,
    "CMY_Y": 0.3828927,
    "CMYK_C": 0.06835777,
    "CMYK_M": 0.03469874,
    "CMYK_Y": 0,
    "CMYK_K": 0.3828927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07673",
    "Farbtonhilfsbezeichnung": "T4.04.46",
    "Farbtonklasse": "02",
    "Rcolor": "123",
    "Gcolor": "128",
    "Bcolor": "134",
    "Y": 21,
    "L": 53.4262647828173,
    "a": -0.79954758238326,
    "b": -4.24081949368611,
    "C": 4.31553314371736,
    "h": 1.38444764999943,
    "CMY_C": 0.5193858,
    "CMY_M": 0.4964264,
    "CMY_Y": 0.475498,
    "CMYK_C": 0.08367509,
    "CMYK_M": 0.03990155,
    "CMYK_Y": 0,
    "CMYK_K": 0.475498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07674",
    "Farbtonhilfsbezeichnung": "T4.10.51",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "145",
    "Bcolor": "159",
    "Y": 27,
    "L": 59.2784800160852,
    "a": -1.93113922387339,
    "b": -9.91361715868495,
    "C": 10.0999556370786,
    "h": 1.3784089759583,
    "CMY_C": 0.4911551,
    "CMY_M": 0.4331515,
    "CMY_Y": 0.3778673,
    "CMYK_C": 0.1820958,
    "CMYK_M": 0.08886243,
    "CMYK_Y": 0,
    "CMYK_K": 0.3778673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07675",
    "Farbtonhilfsbezeichnung": "T6.17.38",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "113",
    "Bcolor": "135",
    "Y": 16,
    "L": 46.7787090442353,
    "a": -2.04167788585646,
    "b": -14.9288698236023,
    "C": 15.0678333810691,
    "h": 1.43487913425451,
    "CMY_C": 0.6385267,
    "CMY_M": 0.5565389,
    "CMY_Y": 0.4721257,
    "CMYK_C": 0.3152285,
    "CMYK_M": 0.1599115,
    "CMYK_Y": 0,
    "CMYK_K": 0.4721257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07676",
    "Farbtonhilfsbezeichnung": "T3.20.44",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "128",
    "Bcolor": "153",
    "Y": 20,
    "L": 52.2653568407478,
    "a": -3.38438697806165,
    "b": -17.4029473069067,
    "C": 17.7289776970993,
    "h": 1.37872170213076,
    "CMY_C": 0.6090441,
    "CMY_M": 0.4987621,
    "CMY_Y": 0.4001007,
    "CMYK_C": 0.3482975,
    "CMYK_M": 0.1644633,
    "CMYK_Y": 0,
    "CMYK_K": 0.4001007
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07677",
    "Farbtonhilfsbezeichnung": "T6.24.41",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "120",
    "Bcolor": "154",
    "Y": 18,
    "L": 49.3811323933382,
    "a": -1.84948201345136,
    "b": -22.3898712962711,
    "C": 22.4661282908663,
    "h": 1.48837992614672,
    "CMY_C": 0.6522312,
    "CMY_M": 0.5288194,
    "CMY_Y": 0.3966558,
    "CMYK_C": 0.4235981,
    "CMYK_M": 0.2190517,
    "CMYK_Y": 0,
    "CMYK_K": 0.3966558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07678",
    "Farbtonhilfsbezeichnung": "T3.32.44",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "128",
    "Bcolor": "170",
    "Y": 20,
    "L": 51.625594240234,
    "a": -5.05903943945474,
    "b": -28.4362779700284,
    "C": 28.8827939236958,
    "h": 1.39473053635054,
    "CMY_C": 0.7086897,
    "CMY_M": 0.4979505,
    "CMY_Y": 0.3333048,
    "CMYK_C": 0.5630533,
    "CMYK_M": 0.246958,
    "CMYK_Y": 0,
    "CMYK_K": 0.3333048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07679",
    "Farbtonhilfsbezeichnung": "T6.39.34",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "105",
    "Bcolor": "153",
    "Y": 13,
    "L": 42.5291090740491,
    "a": -4.25734583668602,
    "b": -32.4403211317924,
    "C": 32.7184875675353,
    "h": 1.44030581865615,
    "CMY_C": 0.8528255,
    "CMY_M": 0.5871846,
    "CMY_Y": 0.4018022,
    "CMYK_C": 0.7539702,
    "CMYK_M": 0.3099015,
    "CMYK_Y": 0,
    "CMYK_K": 0.4018022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07680",
    "Farbtonhilfsbezeichnung": "T4.44.36",
    "Farbtonklasse": "04",
    "Rcolor": "30",
    "Gcolor": "114",
    "Bcolor": "166",
    "Y": 15,
    "L": 45.6396523918485,
    "a": -5.20651406967565,
    "b": -35.5086924173918,
    "C": 35.8883689508268,
    "h": 1.42520730089153,
    "CMY_C": 0.8814102,
    "CMY_M": 0.5539873,
    "CMY_Y": 0.3493079,
    "CMYK_C": 0.8177482,
    "CMYK_M": 0.3145565,
    "CMYK_Y": 0,
    "CMYK_K": 0.3493079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07681",
    "Farbtonhilfsbezeichnung": "T5.49.35",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "169",
    "Y": 13,
    "L": 44.8397521972656,
    "a": -4.63404226303101,
    "b": -38.7864112854004,
    "C": 39.0622596740723,
    "h": 263.186828613281,
    "CMY_C": 0.99957203865051,
    "CMY_M": 0.56144464015961,
    "CMY_Y": 0.33606445789337,
    "CMYK_C": 0.9993554353714,
    "CMYK_M": 0.33946093916893,
    "CMYK_Y": 0,
    "CMYK_K": 0.33606445789337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07682",
    "Farbtonhilfsbezeichnung": "T2.46.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "159",
    "Y": 13,
    "L": 42.735049924874,
    "a": -6.60705040247536,
    "b": -35.9608166953563,
    "C": 36.5627331092448,
    "h": 1.3890936306838,
    "CMY_C": 1,
    "CMY_M": 0.5794369,
    "CMY_Y": 0.3768577,
    "CMYK_C": 1,
    "CMYK_M": 0.3250931,
    "CMYK_Y": 0,
    "CMYK_K": 0.3768577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07683",
    "Farbtonhilfsbezeichnung": "T7.31.36",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "107",
    "Bcolor": "145",
    "Y": 14,
    "L": 43.8376052523137,
    "a": -2.5261642930472,
    "b": -26.0302506792522,
    "C": 26.1525420649729,
    "h": 1.474052033943,
    "CMY_C": 0.7417862,
    "CMY_M": 0.580354,
    "CMY_Y": 0.4298675,
    "CMYK_C": 0.5470987,
    "CMYK_M": 0.26395,
    "CMYK_Y": 0,
    "CMYK_K": 0.4298675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07684",
    "Farbtonhilfsbezeichnung": "T2.26.36",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "110",
    "Bcolor": "139",
    "Y": 14,
    "L": 44.8702022557388,
    "a": -4.00401026394548,
    "b": -20.8337348298958,
    "C": 21.2150089596067,
    "h": 1.38092270437844,
    "CMY_C": 0.709295,
    "CMY_M": 0.5693612,
    "CMY_Y": 0.4531965,
    "CMYK_C": 0.4683555,
    "CMYK_M": 0.2124432,
    "CMYK_Y": 0,
    "CMYK_K": 0.4531965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07685",
    "Farbtonhilfsbezeichnung": "T3.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "73",
    "Gcolor": "96",
    "Bcolor": "116",
    "Y": 11,
    "L": 39.5161322788436,
    "a": -2.71224053863306,
    "b": -15.0089187959649,
    "C": 15.2520127249905,
    "h": 1.39201712219592,
    "CMY_C": 0.714687,
    "CMY_M": 0.625237,
    "CMY_Y": 0.543822,
    "CMYK_C": 0.3745579,
    "CMYK_M": 0.1784722,
    "CMYK_Y": 0,
    "CMYK_K": 0.543822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07686",
    "Farbtonhilfsbezeichnung": "T4.10.43",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "123",
    "Bcolor": "136",
    "Y": 19,
    "L": 50.9123173086354,
    "a": -1.18486985532124,
    "b": -9.47003259447725,
    "C": 9.5438689175046,
    "h": 1.4463253242827,
    "CMY_C": 0.5668339,
    "CMY_M": 0.5192049,
    "CMY_Y": 0.4661956,
    "CMYK_C": 0.1885303,
    "CMYK_M": 0.09930482,
    "CMYK_Y": 0,
    "CMYK_K": 0.4661956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07687",
    "Farbtonhilfsbezeichnung": "T3.05.38",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "111",
    "Bcolor": "117",
    "Y": 16,
    "L": 46.4090291360506,
    "a": -0.75506441634876,
    "b": -5.0088714758433,
    "C": 5.06546303257192,
    "h": 1.42117744542518,
    "CMY_C": 0.5905942,
    "CMY_M": 0.5656852,
    "CMY_Y": 0.5400255,
    "CMYK_C": 0.1099381,
    "CMYK_M": 0.05578482,
    "CMYK_Y": 0,
    "CMYK_K": 0.5400255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07688",
    "Farbtonhilfsbezeichnung": "T3.11.34",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "103",
    "Bcolor": "116",
    "Y": 13,
    "L": 42.8602117821362,
    "a": -2.01737877020075,
    "b": -9.6159201518635,
    "C": 9.82526017311863,
    "h": 1.36399980447392,
    "CMY_C": 0.6518902,
    "CMY_M": 0.5962427,
    "CMY_Y": 0.5452769,
    "CMYK_C": 0.2344577,
    "CMYK_M": 0.112081,
    "CMYK_Y": 0,
    "CMYK_K": 0.5452769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07689",
    "Farbtonhilfsbezeichnung": "T4.12.25",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "82",
    "Bcolor": "94",
    "Y": 8,
    "L": 34.1888250264461,
    "a": -1.17576449570791,
    "b": -9.04333729647691,
    "C": 9.11945018119062,
    "h": 1.44150711607931,
    "CMY_C": 0.7239882,
    "CMY_M": 0.6799033,
    "CMY_Y": 0.6321128,
    "CMYK_C": 0.249738,
    "CMYK_M": 0.1299053,
    "CMYK_Y": 0,
    "CMYK_K": 0.6321128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07691",
    "Farbtonhilfsbezeichnung": "T3.25.24",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "83",
    "Bcolor": "106",
    "Y": 8,
    "L": 34.2520234061151,
    "a": -3.30211388599277,
    "b": -16.784061663639,
    "C": 17.1058084300305,
    "h": 1.37653632922889,
    "CMY_C": 0.7803143,
    "CMY_M": 0.6729786,
    "CMY_Y": 0.5839926,
    "CMYK_C": 0.4719187,
    "CMYK_M": 0.2139048,
    "CMYK_Y": 0,
    "CMYK_K": 0.5839926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07692",
    "Farbtonhilfsbezeichnung": "T2.32.24",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "83",
    "Bcolor": "113",
    "Y": 8,
    "L": 33.9801613657218,
    "a": -3.66507994599513,
    "b": -21.3261813124446,
    "C": 21.6388266868099,
    "h": 1.40060068248854,
    "CMY_C": 0.8193685,
    "CMY_M": 0.6732982,
    "CMY_Y": 0.5585205,
    "CMYK_C": 0.5908496,
    "CMYK_M": 0.2599843,
    "CMYK_Y": 0,
    "CMYK_K": 0.5585205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07693",
    "Farbtonhilfsbezeichnung": "T2.34.34",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "107",
    "Bcolor": "143",
    "Y": 13,
    "L": 43.1941618337469,
    "a": -5.24710009254847,
    "b": -25.3858585456082,
    "C": 25.9224588625163,
    "h": 1.36697276420723,
    "CMY_C": 0.7765347,
    "CMY_M": 0.5816551,
    "CMY_Y": 0.440825,
    "CMYK_C": 0.600366,
    "CMYK_M": 0.2518533,
    "CMYK_Y": 0,
    "CMYK_K": 0.440825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07694",
    "Farbtonhilfsbezeichnung": "T2.39.33",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "104",
    "Bcolor": "147",
    "Y": 12,
    "L": 41.8363174895676,
    "a": -5.70668257384593,
    "b": -30.5076508549762,
    "C": 31.0368005227305,
    "h": 1.38587595640055,
    "CMY_C": 0.8616933,
    "CMY_M": 0.5919586,
    "CMY_Y": 0.4215906,
    "CMYK_C": 0.7608844,
    "CMYK_M": 0.2945457,
    "CMYK_Y": 0,
    "CMYK_K": 0.4215906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07695",
    "Farbtonhilfsbezeichnung": "T2.50.25",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "91",
    "Bcolor": "139",
    "Y": 9,
    "L": 36.1069194279639,
    "a": -6.64010457914943,
    "b": -34.5799252812932,
    "C": 35.2116773426354,
    "h": 1.38108360816151,
    "CMY_C": 1,
    "CMY_M": 0.6430801,
    "CMY_Y": 0.4541607,
    "CMYK_C": 1,
    "CMYK_M": 0.3461081,
    "CMYK_Y": 0,
    "CMYK_K": 0.4541607
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07696",
    "Farbtonhilfsbezeichnung": "T4.43.26",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "94",
    "Bcolor": "136",
    "Y": 9,
    "L": 37.8150253295898,
    "a": -4.25701475143433,
    "b": -29.7138175964356,
    "C": 30.0172138214111,
    "h": 261.846862792969,
    "CMY_C": 0.87803947925568,
    "CMY_M": 0.63322412967682,
    "CMY_Y": 0.46763503551483,
    "CMYK_C": 0.77090805768967,
    "CMYK_M": 0.31104430556297,
    "CMYK_Y": 0,
    "CMYK_K": 0.46763503551483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07697",
    "Farbtonhilfsbezeichnung": "T2.39.28",
    "Farbtonklasse": "04",
    "Rcolor": "28",
    "Gcolor": "92",
    "Bcolor": "132",
    "Y": 11,
    "L": 37.1657664692951,
    "a": -5.64131799933748,
    "b": -28.1968790478259,
    "C": 28.755668255274,
    "h": 1.37333453743702,
    "CMY_C": 0.8918892,
    "CMY_M": 0.6374553,
    "CMY_Y": 0.4839267,
    "CMYK_C": 0.7905126,
    "CMYK_M": 0.2974939,
    "CMYK_Y": 0,
    "CMYK_K": 0.4839267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07698",
    "Farbtonhilfsbezeichnung": "T3.34.28",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "88",
    "Bcolor": "125",
    "Y": 9,
    "L": 35.7818401023683,
    "a": -4.49130190954741,
    "b": -26.2974089537335,
    "C": 26.6781841683914,
    "h": 1.40163966298492,
    "CMY_C": 0.8611528,
    "CMY_M": 0.6532239,
    "CMY_Y": 0.5097198,
    "CMYK_C": 0.7168003,
    "CMYK_M": 0.2926982,
    "CMYK_Y": 0,
    "CMYK_K": 0.5097198
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07699",
    "Farbtonhilfsbezeichnung": "T2.30.21",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "74",
    "Bcolor": "99",
    "Y": 6,
    "L": 30.1422321111428,
    "a": -3.78436667563145,
    "b": -18.7837184906052,
    "C": 19.161145880921,
    "h": 1.37198714757479,
    "CMY_C": 0.8391293,
    "CMY_M": 0.7091805,
    "CMY_Y": 0.6112399,
    "CMYK_C": 0.5861955,
    "CMYK_M": 0.2519306,
    "CMYK_Y": 0,
    "CMYK_K": 0.6112399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07701",
    "Farbtonhilfsbezeichnung": "T4.19.24",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "82",
    "Bcolor": "100",
    "Y": 8,
    "L": 33.9298568047033,
    "a": -2.12263428305515,
    "b": -13.5380177702335,
    "C": 13.7034120366702,
    "h": 1.41527188660354,
    "CMY_C": 0.7544248,
    "CMY_M": 0.6791728,
    "CMY_Y": 0.6070193,
    "CMYK_C": 0.375096,
    "CMYK_M": 0.1836056,
    "CMYK_Y": 0,
    "CMYK_K": 0.6070193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07702",
    "Farbtonhilfsbezeichnung": "T6.15.20",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "70",
    "Bcolor": "84",
    "Y": 6,
    "L": 29.1815263204675,
    "a": -1.26160138119663,
    "b": -10.4464948364321,
    "C": 10.5223995558352,
    "h": 1.45061045750183,
    "CMY_C": 0.7759611,
    "CMY_M": 0.7250498,
    "CMY_Y": 0.6703906,
    "CMYK_C": 0.3202897,
    "CMYK_M": 0.1658302,
    "CMYK_Y": 0,
    "CMYK_K": 0.6703906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07703",
    "Farbtonhilfsbezeichnung": "T7.04.29",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "86",
    "Bcolor": "92",
    "Y": 9,
    "L": 36.3285768205896,
    "a": -0.08168413195575,
    "b": -4.57531100717313,
    "C": 4.57604011234309,
    "h": 1.55294498185495,
    "CMY_C": 0.6797774,
    "CMY_M": 0.6633828,
    "CMY_Y": 0.6394271,
    "CMYK_C": 0.1119059,
    "CMYK_M": 0.06643765,
    "CMYK_Y": 0,
    "CMYK_K": 0.6394271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07704",
    "Farbtonhilfsbezeichnung": "S9.05.20",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "70",
    "Bcolor": "75",
    "Y": 6,
    "L": 29.4977166432895,
    "a": -0.95339841622302,
    "b": -4.03122386493856,
    "C": 4.14243097580476,
    "h": 1.33856006186781,
    "CMY_C": 0.7461706,
    "CMY_M": 0.7245234,
    "CMY_Y": 0.7058629,
    "CMYK_C": 0.1370371,
    "CMYK_M": 0.06344129,
    "CMYK_Y": 0,
    "CMYK_K": 0.7058629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07705",
    "Farbtonhilfsbezeichnung": "T5.12.15",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "64",
    "Bcolor": "73",
    "Y": 5,
    "L": 26.4539956020717,
    "a": -1.01336240577851,
    "b": -7.3594643393148,
    "C": 7.42890427499853,
    "h": 1.43396165915827,
    "CMY_C": 0.7854838,
    "CMY_M": 0.7507583,
    "CMY_Y": 0.7136554,
    "CMYK_C": 0.2508461,
    "CMYK_M": 0.1295742,
    "CMYK_Y": 0,
    "CMYK_K": 0.7136554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07706",
    "Farbtonhilfsbezeichnung": "T4.18.21",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "73",
    "Bcolor": "90",
    "Y": 6,
    "L": 30.3917770039675,
    "a": -1.74098942196338,
    "b": -12.1812025762707,
    "C": 12.3049884344331,
    "h": 1.42883349335564,
    "CMY_C": 0.7769338,
    "CMY_M": 0.7127072,
    "CMY_Y": 0.6487246,
    "CMYK_C": 0.3649822,
    "CMYK_M": 0.1821438,
    "CMYK_Y": 0,
    "CMYK_K": 0.6487246
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07707",
    "Farbtonhilfsbezeichnung": "T4.22.14",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "64",
    "Bcolor": "79",
    "Y": 5,
    "L": 26.3181484379172,
    "a": -2.12590499051662,
    "b": -11.3845483575847,
    "C": 11.5813390130368,
    "h": 1.38618653432575,
    "CMY_C": 0.8128171,
    "CMY_M": 0.7488126,
    "CMY_Y": 0.6912489,
    "CMYK_C": 0.3937418,
    "CMYK_M": 0.1864402,
    "CMYK_Y": 0,
    "CMYK_K": 0.6912489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07708",
    "Farbtonhilfsbezeichnung": "T4.28.14",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "64",
    "Bcolor": "84",
    "Y": 5,
    "L": 26.2805088685761,
    "a": -1.175429258643,
    "b": -15.1017801008327,
    "C": 15.1474551049337,
    "h": 1.49311911144018,
    "CMY_C": 0.8247702,
    "CMY_M": 0.7497005,
    "CMY_Y": 0.6695287,
    "CMYK_C": 0.469758,
    "CMYK_M": 0.2425985,
    "CMYK_Y": 0,
    "CMYK_K": 0.6695287
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07709",
    "Farbtonhilfsbezeichnung": "T3.29.20",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "72",
    "Bcolor": "97",
    "Y": 6,
    "L": 29.1914863585706,
    "a": -3.09628321721631,
    "b": -18.9217785694153,
    "C": 19.1734366765898,
    "h": 1.40859789590702,
    "CMY_C": 0.8419042,
    "CMY_M": 0.718959,
    "CMY_Y": 0.6194208,
    "CMYK_C": 0.5845914,
    "CMYK_M": 0.2615438,
    "CMYK_Y": 0,
    "CMYK_K": 0.6194208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07710",
    "Farbtonhilfsbezeichnung": "T2.33.20",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "73",
    "Bcolor": "101",
    "Y": 6,
    "L": 29.6457851221106,
    "a": -4.32732756789683,
    "b": -20.9578777760609,
    "C": 21.3999627279159,
    "h": 1.36718035149499,
    "CMY_C": 0.8703024,
    "CMY_M": 0.7119886,
    "CMY_Y": 0.602815,
    "CMYK_C": 0.673458,
    "CMYK_M": 0.2748684,
    "CMYK_Y": 0,
    "CMYK_K": 0.602815
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07711",
    "Farbtonhilfsbezeichnung": "T3.46.24",
    "Farbtonklasse": "04",
    "Rcolor": "1",
    "Gcolor": "86",
    "Bcolor": "129",
    "Y": 8,
    "L": 34.5534773323745,
    "a": -4.98477235920228,
    "b": -30.7713587512337,
    "C": 31.1724954867299,
    "h": 1.41019754303007,
    "CMY_C": 0.9958414,
    "CMY_M": 0.6620429,
    "CMY_Y": 0.4938957,
    "CMYK_C": 0.9917831,
    "CMYK_M": 0.3322381,
    "CMYK_Y": 0,
    "CMYK_K": 0.4938957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07712",
    "Farbtonhilfsbezeichnung": "T4.39.20",
    "Farbtonklasse": "04",
    "Rcolor": "21",
    "Gcolor": "75",
    "Bcolor": "110",
    "Y": 6,
    "L": 30.2527624974194,
    "a": -4.23343387325409,
    "b": -25.412579279687,
    "C": 25.762786107205,
    "h": 1.40572407158353,
    "CMY_C": 0.9183671,
    "CMY_M": 0.7050076,
    "CMY_Y": 0.5697358,
    "CMYK_C": 0.8102726,
    "CMYK_M": 0.3143924,
    "CMYK_Y": 0,
    "CMYK_K": 0.5697358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07713",
    "Farbtonhilfsbezeichnung": "T5.34.20",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "77",
    "Bcolor": "107",
    "Y": 7,
    "L": 31.5483960756465,
    "a": -2.27278048144355,
    "b": -21.8730185465057,
    "C": 21.9907815107288,
    "h": 1.46725993433066,
    "CMY_C": 0.8325248,
    "CMY_M": 0.6979913,
    "CMY_Y": 0.578724,
    "CMYK_C": 0.6024574,
    "CMYK_M": 0.2831095,
    "CMYK_Y": 0,
    "CMYK_K": 0.578724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07714",
    "Farbtonhilfsbezeichnung": "T3.33.15",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "71",
    "Bcolor": "99",
    "Y": 6,
    "L": 28.6904238913032,
    "a": -3.36577653715753,
    "b": -20.9358048733496,
    "C": 21.2046310364752,
    "h": 1.4113937651541,
    "CMY_C": 0.8675465,
    "CMY_M": 0.7223026,
    "CMY_Y": 0.6120358,
    "CMYK_C": 0.6585936,
    "CMYK_M": 0.2842192,
    "CMYK_Y": 0,
    "CMYK_K": 0.6120358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07715",
    "Farbtonhilfsbezeichnung": "T3.24.09",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "59",
    "Bcolor": "74",
    "Y": 4,
    "L": 24.089378511449,
    "a": -1.61839129696439,
    "b": -11.6810486015185,
    "C": 11.7926284950017,
    "h": 1.43312430469987,
    "CMY_C": 0.8298272,
    "CMY_M": 0.7692683,
    "CMY_Y": 0.7097813,
    "CMYK_C": 0.4136394,
    "CMYK_M": 0.2049728,
    "CMYK_Y": 0,
    "CMYK_K": 0.7097813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07716",
    "Farbtonhilfsbezeichnung": "T6.23.13",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "63",
    "Bcolor": "81",
    "Y": 5,
    "L": 26.0324687422607,
    "a": -0.82617154857378,
    "b": -13.4477925688358,
    "C": 13.4731467891546,
    "h": 1.50943796775316,
    "CMY_C": 0.8149651,
    "CMY_M": 0.7530543,
    "CMY_Y": 0.6815838,
    "CMYK_C": 0.4188896,
    "CMYK_M": 0.2244562,
    "CMYK_Y": 0,
    "CMYK_K": 0.6815838
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07717",
    "Farbtonhilfsbezeichnung": "T2.16.12",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "59",
    "Bcolor": "70",
    "Y": 4,
    "L": 24.1100534832998,
    "a": -2.39608292780308,
    "b": -8.87140734879292,
    "C": 9.18929168897835,
    "h": 1.30700013489157,
    "CMY_C": 0.822616,
    "CMY_M": 0.7685292,
    "CMY_Y": 0.7260225,
    "CMYK_C": 0.3525603,
    "CMYK_M": 0.1551469,
    "CMYK_Y": 0,
    "CMYK_K": 0.7260225
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07718",
    "Farbtonhilfsbezeichnung": "T7.08.11",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "55",
    "Bcolor": "61",
    "Y": 4,
    "L": 22.6093269824932,
    "a": -0.69237561898358,
    "b": -5.29817786280966,
    "C": 5.34322680257251,
    "h": 1.44085087525065,
    "CMY_C": 0.8089769,
    "CMY_M": 0.7855751,
    "CMY_Y": 0.759845,
    "CMYK_C": 0.2045842,
    "CMYK_M": 0.1071397,
    "CMYK_Y": 0,
    "CMYK_K": 0.759845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07719",
    "Farbtonhilfsbezeichnung": "T7.06.16",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "65",
    "Bcolor": "70",
    "Y": 5,
    "L": 27.3613398692497,
    "a": -0.72222717218609,
    "b": -4.14601577988397,
    "C": 4.20845089496014,
    "h": 1.39832904820733,
    "CMY_C": 0.7639292,
    "CMY_M": 0.7440746,
    "CMY_Y": 0.7244183,
    "CMYK_C": 0.1433726,
    "CMYK_M": 0.07132654,
    "CMYK_Y": 0,
    "CMYK_K": 0.7244183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07720",
    "Farbtonhilfsbezeichnung": "T8.20.69",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "193",
    "Bcolor": "232",
    "Y": 52,
    "L": 77.1592321439096,
    "a": -1.56917567955572,
    "b": -23.493609601058,
    "C": 23.5459551600743,
    "h": 1.50410378756589,
    "CMY_C": 0.3663629,
    "CMY_M": 0.2413727,
    "CMY_Y": 0.09057755,
    "CMYK_C": 0.3032532,
    "CMYK_M": 0.1658142,
    "CMYK_Y": 0,
    "CMYK_K": 0.09057755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07721",
    "Farbtonhilfsbezeichnung": "U0.17.68",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "189",
    "Bcolor": "223",
    "Y": 50,
    "L": 75.8473608456396,
    "a": -0.29390201488299,
    "b": -20.3624639882416,
    "C": 20.364584897974,
    "h": 1.55636380976685,
    "CMY_C": 0.3524383,
    "CMY_M": 0.2594621,
    "CMY_Y": 0.1274344,
    "CMYK_C": 0.2578647,
    "CMYK_M": 0.1513098,
    "CMYK_Y": 0,
    "CMYK_K": 0.1274344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07722",
    "Farbtonhilfsbezeichnung": "T8.09.80",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "221",
    "Bcolor": "238",
    "Y": 71,
    "L": 87.5724604591165,
    "a": -0.9655087553132,
    "b": -10.6601223847581,
    "C": 10.7037571167608,
    "h": 1.48047076359223,
    "CMY_C": 0.1873865,
    "CMY_M": 0.1332415,
    "CMY_Y": 0.0676984,
    "CMYK_C": 0.1283792,
    "CMYK_M": 0.07030244,
    "CMYK_Y": 0,
    "CMYK_K": 0.0676984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07723",
    "Farbtonhilfsbezeichnung": "U0.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "225",
    "Bcolor": "239",
    "Y": 75,
    "L": 89.3671653111574,
    "a": 0.00290343302328,
    "b": -8.64469645972208,
    "C": 8.64469694729982,
    "h": -1.57046046388431,
    "CMY_C": 0.1513306,
    "CMY_M": 0.1162389,
    "CMY_Y": 0.06237487,
    "CMYK_C": 0.09487341,
    "CMYK_M": 0.05744734,
    "CMYK_Y": 0,
    "CMYK_K": 0.06237487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07724",
    "Farbtonhilfsbezeichnung": "U0.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "223",
    "Bcolor": "238",
    "Y": 73,
    "L": 88.2978106011975,
    "a": -0.26646366633198,
    "b": -9.61326576627681,
    "C": 9.61695802104516,
    "h": 1.54308509292375,
    "CMY_C": 0.1692461,
    "CMY_M": 0.1271693,
    "CMY_Y": 0.06721392,
    "CMYK_C": 0.1093843,
    "CMYK_M": 0.06427556,
    "CMYK_Y": 0,
    "CMYK_K": 0.06721392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07725",
    "Farbtonhilfsbezeichnung": "UN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "228",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.5002575677296,
    "a": -0.01834154932206,
    "b": -2.22182260097479,
    "C": 2.22189830609637,
    "h": 1.56254133259137,
    "CMY_C": 0.1147489,
    "CMY_M": 0.1055351,
    "CMY_Y": 0.09718922,
    "CMYK_C": 0.01945006,
    "CMYK_M": 0.009244322,
    "CMYK_Y": 0,
    "CMYK_K": 0.09718922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07726",
    "Farbtonhilfsbezeichnung": "T8.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "220",
    "Bcolor": "230",
    "Y": 71,
    "L": 87.3557348109603,
    "a": -0.49712917822153,
    "b": -6.95361391376332,
    "C": 6.97136169492891,
    "h": 1.49942555362512,
    "CMY_C": 0.1709962,
    "CMY_M": 0.1378883,
    "CMY_Y": 0.09726693,
    "CMYK_C": 0.08167335,
    "CMYK_M": 0.04499822,
    "CMYK_Y": 0,
    "CMYK_K": 0.09726693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07727",
    "Farbtonhilfsbezeichnung": "T8.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "216",
    "Bcolor": "233",
    "Y": 68,
    "L": 85.8117055433396,
    "a": -0.54582149577414,
    "b": -10.9961545739257,
    "C": 11.009692843986,
    "h": 1.52119954511591,
    "CMY_C": 0.2045309,
    "CMY_M": 0.1535577,
    "CMY_Y": 0.08480162,
    "CMYK_C": 0.1308233,
    "CMYK_M": 0.07512691,
    "CMYK_Y": 0,
    "CMYK_K": 0.08480162
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07728",
    "Farbtonhilfsbezeichnung": "T8.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "203",
    "Bcolor": "221",
    "Y": 59,
    "L": 81.1608487334444,
    "a": -1.3458568521359,
    "b": -11.6832504513793,
    "C": 11.7605132445866,
    "h": 1.45610644265522,
    "CMY_C": 0.2646987,
    "CMY_M": 0.2024717,
    "CMY_Y": 0.1313772,
    "CMYK_C": 0.1534861,
    "CMYK_M": 0.08184744,
    "CMYK_Y": 0,
    "CMYK_K": 0.1313772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07729",
    "Farbtonhilfsbezeichnung": "T8.11.72",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "202",
    "Bcolor": "225",
    "Y": 58,
    "L": 80.8648329522392,
    "a": -0.56082226394249,
    "b": -13.8293639281495,
    "C": 13.8407307707698,
    "h": 1.53026553035759,
    "CMY_C": 0.2704621,
    "CMY_M": 0.2067962,
    "CMY_Y": 0.1190324,
    "CMYK_C": 0.1718902,
    "CMYK_M": 0.09962201,
    "CMYK_Y": 0,
    "CMYK_K": 0.1190324
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07732",
    "Farbtonhilfsbezeichnung": "T8.37.44",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "133",
    "Bcolor": "188",
    "Y": 21,
    "L": 53.8884735107422,
    "a": -2.08837389945984,
    "b": -35.1639709472656,
    "C": 35.2259292602539,
    "h": 266.601226806641,
    "CMY_C": 0.70739221572876,
    "CMY_M": 0.47850733995438,
    "CMY_Y": 0.26369678974152,
    "CMYK_C": 0.60259878635406,
    "CMYK_M": 0.29174196720123,
    "CMYK_Y": 0,
    "CMYK_K": 0.26369678974152
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07734",
    "Farbtonhilfsbezeichnung": "T9.11.76",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "212",
    "Bcolor": "235",
    "Y": 65,
    "L": 84.5668038625671,
    "a": -0.39048927527368,
    "b": -13.7624358443473,
    "C": 13.7679745149342,
    "h": 1.54243037898355,
    "CMY_C": 0.2285526,
    "CMY_M": 0.1667225,
    "CMY_Y": 0.07843039,
    "CMYK_C": 0.1628984,
    "CMYK_M": 0.09580623,
    "CMYK_Y": 0,
    "CMYK_K": 0.07843039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07735",
    "Farbtonhilfsbezeichnung": "U0.07.75",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "207",
    "Bcolor": "220",
    "Y": 62,
    "L": 82.7337722716481,
    "a": -0.27546607389755,
    "b": -8.30124391696632,
    "C": 8.30581315265633,
    "h": 1.53762478855467,
    "CMY_C": 0.224939,
    "CMY_M": 0.1888171,
    "CMY_Y": 0.138441,
    "CMYK_C": 0.1003971,
    "CMYK_M": 0.05847094,
    "CMYK_Y": 0,
    "CMYK_K": 0.138441
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07736",
    "Farbtonhilfsbezeichnung": "T8.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "211",
    "Bcolor": "225",
    "Y": 64,
    "L": 84.1332233271174,
    "a": -0.82938636823171,
    "b": -9.31390703495725,
    "C": 9.35076178734303,
    "h": 1.4819824156245,
    "CMY_C": 0.218332,
    "CMY_M": 0.1718926,
    "CMY_Y": 0.1157224,
    "CMYK_C": 0.1160378,
    "CMYK_M": 0.06352102,
    "CMYK_Y": 0,
    "CMYK_K": 0.1157224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07737",
    "Farbtonhilfsbezeichnung": "UN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "227",
    "Bcolor": "230",
    "Y": 77,
    "L": 90.098586303893,
    "a": -0.0636108862822,
    "b": -2.65132750590102,
    "C": 2.6520904751536998,
    "h": 1.54680883935169,
    "CMY_C": 0.1211152,
    "CMY_M": 0.109773,
    "CMY_Y": 0.09847452,
    "CMYK_C": 0.02511377,
    "CMYK_M": 0.01253258,
    "CMYK_Y": 0,
    "CMYK_K": 0.09847452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07738",
    "Farbtonhilfsbezeichnung": "UN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "219",
    "Bcolor": "222",
    "Y": 71,
    "L": 87.3189791460061,
    "a": -0.16282347231905,
    "b": -2.54254078391025,
    "C": 2.54774903021962,
    "h": 1.50684398610552,
    "CMY_C": 0.1522622,
    "CMY_M": 0.1403999,
    "CMY_Y": 0.1299974,
    "CMYK_C": 0.02559167,
    "CMYK_M": 0.01195679,
    "CMYK_Y": 0,
    "CMYK_K": 0.1299974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07739",
    "Farbtonhilfsbezeichnung": "T9.03.79",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "217",
    "Bcolor": "222",
    "Y": 69,
    "L": 86.5768145222622,
    "a": -0.11568827585761,
    "b": -3.59370732856694,
    "C": 3.59556895922838,
    "h": 1.53861553776255,
    "CMY_C": 0.1638492,
    "CMY_M": 0.1483977,
    "CMY_Y": 0.1304572,
    "CMYK_C": 0.03840187,
    "CMYK_M": 0.02063213,
    "CMYK_Y": 0,
    "CMYK_K": 0.1304572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07740",
    "Farbtonhilfsbezeichnung": "T5.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "207",
    "Bcolor": "216",
    "Y": 62,
    "L": 82.7906094482281,
    "a": -0.73905693076786,
    "b": -6.24511400570604,
    "C": 6.28869255816993,
    "h": 1.45300255492055,
    "CMY_C": 0.2201415,
    "CMY_M": 0.1877531,
    "CMY_Y": 0.152795,
    "CMYK_C": 0.07949255,
    "CMYK_M": 0.04126281,
    "CMYK_Y": 0,
    "CMYK_K": 0.152795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07741",
    "Farbtonhilfsbezeichnung": "T9.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "200",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.4629239223045,
    "a": -0.09169120753532,
    "b": -8.95432840577612,
    "C": 8.95479784674274,
    "h": 1.560556809232,
    "CMY_C": 0.2506053,
    "CMY_M": 0.2137951,
    "CMY_Y": 0.1586048,
    "CMYK_C": 0.1093428,
    "CMYK_M": 0.06559388,
    "CMYK_Y": 0,
    "CMYK_K": 0.1586048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07742",
    "Farbtonhilfsbezeichnung": "T9.39.43",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "125",
    "Bcolor": "184",
    "Y": 19,
    "L": 50.9008038096782,
    "a": -0.26335455504916,
    "b": -37.958382839212,
    "C": 37.959296402724,
    "h": 1.56385845668827,
    "CMY_C": 0.7473841,
    "CMY_M": 0.5108275,
    "CMY_Y": 0.2767684,
    "CMYK_C": 0.6507123,
    "CMYK_M": 0.3236295,
    "CMYK_Y": 0,
    "CMYK_K": 0.2767684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07743",
    "Farbtonhilfsbezeichnung": "T9.42.44",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "130",
    "Bcolor": "195",
    "Y": 21,
    "L": 52.8417814679998,
    "a": -0.34778398464852,
    "b": -40.9061371089157,
    "C": 40.9076155119482,
    "h": 1.56229453146903,
    "CMY_C": 0.7605435,
    "CMY_M": 0.4900442,
    "CMY_Y": 0.2359262,
    "CMYK_C": 0.6866056,
    "CMYK_M": 0.332583,
    "CMYK_Y": 0,
    "CMYK_K": 0.2359262
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07744",
    "Farbtonhilfsbezeichnung": "T8.33.50",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "142",
    "Bcolor": "196",
    "Y": 26,
    "L": 57.6627823844774,
    "a": -1.51470898272982,
    "b": -34.0135214245232,
    "C": 34.0472316495609,
    "h": 1.526293175944,
    "CMY_C": 0.6462426,
    "CMY_M": 0.4420083,
    "CMY_Y": 0.2307822,
    "CMYK_C": 0.5401075,
    "CMYK_M": 0.2745986,
    "CMYK_Y": 0,
    "CMYK_K": 0.2307822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07745",
    "Farbtonhilfsbezeichnung": "T9.26.52",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "146",
    "Bcolor": "192",
    "Y": 28,
    "L": 59.662869066842,
    "a": -0.37903735827482,
    "b": -28.4883241615711,
    "C": 28.4908455973796,
    "h": 1.55749210460327,
    "CMY_C": 0.5704408,
    "CMY_M": 0.4261669,
    "CMY_Y": 0.246969,
    "CMYK_C": 0.4295596,
    "CMYK_M": 0.2379688,
    "CMYK_Y": 0,
    "CMYK_K": 0.246969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07746",
    "Farbtonhilfsbezeichnung": "T9.16.63",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "176",
    "Bcolor": "208",
    "Y": 42,
    "L": 71.1806742045591,
    "a": -0.36057865438476,
    "b": -19.7038285565682,
    "C": 19.7071275621951,
    "h": 1.55249844065796,
    "CMY_C": 0.3993519,
    "CMY_M": 0.3093519,
    "CMY_Y": 0.1833208,
    "CMYK_C": 0.2645238,
    "CMYK_M": 0.1543214,
    "CMYK_Y": 0,
    "CMYK_K": 0.1833208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07747",
    "Farbtonhilfsbezeichnung": "UN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "194",
    "Bcolor": "198",
    "Y": 54,
    "L": 78.5101799979953,
    "a": 0.51256730383775,
    "b": -3.07839897503945,
    "C": 3.12077962863248,
    "h": -1.40580543045372,
    "CMY_C": 0.2448974,
    "CMY_M": 0.238115,
    "CMY_Y": 0.222018,
    "CMYK_C": 0.02940859,
    "CMYK_M": 0.02069063,
    "CMYK_Y": 0,
    "CMYK_K": 0.222018
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07749",
    "Farbtonhilfsbezeichnung": "T9.05.61",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "166",
    "Bcolor": "176",
    "Y": 38,
    "L": 68.1681032153504,
    "a": 1.62054492075508,
    "b": -6.50306107405927,
    "C": 6.70193771778953,
    "h": -1.32657333791069,
    "CMY_C": 0.3585,
    "CMY_M": 0.3498141,
    "CMY_Y": 0.3079974,
    "CMYK_C": 0.07298032,
    "CMYK_M": 0.06042849,
    "CMYK_Y": 0,
    "CMYK_K": 0.3079974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07750",
    "Farbtonhilfsbezeichnung": "T9.15.55",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "156",
    "Bcolor": "183",
    "Y": 32,
    "L": 63.6137351989746,
    "a": -0.63348162174225,
    "b": -17.1164379119873,
    "C": 17.1281566619873,
    "h": 267.880432128906,
    "CMY_C": 0.46810042858124,
    "CMY_M": 0.38897460699081,
    "CMY_Y": 0.28292727470398,
    "CMYK_C": 0.25823482871056,
    "CMYK_M": 0.14788922667503,
    "CMYK_Y": 0,
    "CMYK_K": 0.28292727470398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07751",
    "Farbtonhilfsbezeichnung": "T8.16.61",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "170",
    "Bcolor": "200",
    "Y": 39,
    "L": 68.8961966318205,
    "a": -0.6746805768994,
    "b": -18.5008515935198,
    "C": 18.5131494772308,
    "h": 1.53434493804942,
    "CMY_C": 0.420242,
    "CMY_M": 0.3332166,
    "CMY_Y": 0.2166266,
    "CMYK_C": 0.2599212,
    "CMYK_M": 0.1488307,
    "CMYK_Y": 0,
    "CMYK_K": 0.2166266
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07752",
    "Farbtonhilfsbezeichnung": "T8.29.46",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "131",
    "Bcolor": "175",
    "Y": 21,
    "L": 53.4584391546405,
    "a": -1.85262107640455,
    "b": -28.2297440972523,
    "C": 28.2904693607068,
    "h": 1.50526373568429,
    "CMY_C": 0.6496695,
    "CMY_M": 0.4860657,
    "CMY_Y": 0.3150854,
    "CMYK_C": 0.4885047,
    "CMYK_M": 0.2496374,
    "CMYK_Y": 0,
    "CMYK_K": 0.3150854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07753",
    "Farbtonhilfsbezeichnung": "U0.40.39",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "119",
    "Bcolor": "173",
    "Y": 17,
    "L": 48.3664097891494,
    "a": -1.33548457901772,
    "b": -35.4197550065626,
    "C": 35.4449229620507,
    "h": 1.53310966682358,
    "CMY_C": 0.7654459,
    "CMY_M": 0.5347785,
    "CMY_Y": 0.3208508,
    "CMYK_C": 0.6546354,
    "CMYK_M": 0.3149937,
    "CMYK_Y": 0,
    "CMYK_K": 0.3208508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07754",
    "Farbtonhilfsbezeichnung": "U1.48.34",
    "Farbtonklasse": "04",
    "Rcolor": "2",
    "Gcolor": "104",
    "Bcolor": "170",
    "Y": 13,
    "L": 42.4189197242572,
    "a": 0.82643720119063,
    "b": -43.1984231891258,
    "C": 43.2063278290844,
    "h": -1.5516674712413,
    "CMY_C": 0.9922225,
    "CMY_M": 0.593181,
    "CMY_Y": 0.332274,
    "CMYK_C": 0.9883524,
    "CMYK_M": 0.3907396,
    "CMYK_Y": 0,
    "CMYK_K": 0.332274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07755",
    "Farbtonhilfsbezeichnung": "U0.48.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "96",
    "Bcolor": "158",
    "Y": 11,
    "L": 38.9759103823977,
    "a": 0.03767302521057,
    "b": -41.1655973008756,
    "C": 41.165614539257,
    "h": -1.56988116906214,
    "CMY_C": 1,
    "CMY_M": 0.6252788,
    "CMY_Y": 0.3818382,
    "CMYK_C": 1,
    "CMYK_M": 0.3938137,
    "CMYK_Y": 0,
    "CMYK_K": 0.3818382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07756",
    "Farbtonhilfsbezeichnung": "T8.38.38",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "114",
    "Bcolor": "166",
    "Y": 16,
    "L": 46.5525467190249,
    "a": -2.15407737212242,
    "b": -34.2414981278254,
    "C": 34.3091859909698,
    "h": 1.50797073048558,
    "CMY_C": 0.786647,
    "CMY_M": 0.5514324,
    "CMY_Y": 0.3478701,
    "CMYK_C": 0.6728366,
    "CMYK_M": 0.3121501,
    "CMYK_Y": 0,
    "CMYK_K": 0.3478701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07757",
    "Farbtonhilfsbezeichnung": "U0.34.37",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "113",
    "Bcolor": "162",
    "Y": 16,
    "L": 46.4369183713047,
    "a": 0.2732639935683,
    "b": -32.0882090274853,
    "C": 32.0893725679043,
    "h": -1.5622805075519,
    "CMY_C": 0.7320163,
    "CMY_M": 0.5582753,
    "CMY_Y": 0.3631209,
    "CMYK_C": 0.5792236,
    "CMYK_M": 0.306423,
    "CMYK_Y": 0,
    "CMYK_K": 0.3631209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07758",
    "Farbtonhilfsbezeichnung": "U0.31.39",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "117",
    "Bcolor": "163",
    "Y": 17,
    "L": 48.1978314967759,
    "a": -0.42343358029689,
    "b": -29.3684147701355,
    "C": 29.3714671425797,
    "h": 1.55637933335631,
    "CMY_C": 0.6982327,
    "CMY_M": 0.5407398,
    "CMY_Y": 0.3627125,
    "CMYK_C": 0.5264817,
    "CMYK_M": 0.2793517,
    "CMYK_Y": 0,
    "CMYK_K": 0.3627125
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07759",
    "Farbtonhilfsbezeichnung": "U1.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "142",
    "Bcolor": "176",
    "Y": 26,
    "L": 58.1587552578038,
    "a": -0.08983753884528,
    "b": -21.3730818738465,
    "C": 21.3732706802102,
    "h": 1.56659304856365,
    "CMY_C": 0.5408204,
    "CMY_M": 0.4447528,
    "CMY_Y": 0.3115802,
    "CMYK_C": 0.3329947,
    "CMYK_M": 0.1934467,
    "CMYK_Y": 0,
    "CMYK_K": 0.3115802
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07760",
    "Farbtonhilfsbezeichnung": "U1.11.55",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "154",
    "Bcolor": "174",
    "Y": 32,
    "L": 63.0874994497146,
    "a": -0.03212438100419,
    "b": -12.8231001933466,
    "C": 12.823140432221,
    "h": 1.56829113590379,
    "CMY_C": 0.4490838,
    "CMY_M": 0.3971419,
    "CMY_Y": 0.3180044,
    "CMYK_C": 0.1921997,
    "CMYK_M": 0.1160382,
    "CMYK_Y": 0,
    "CMYK_K": 0.3180044
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07761",
    "Farbtonhilfsbezeichnung": "U0.06.52",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "146",
    "Bcolor": "157",
    "Y": 29,
    "L": 60.4357163725437,
    "a": -0.09971047326529,
    "b": -7.38703527013895,
    "C": 7.3877081873038,
    "h": 1.55729910976106,
    "CMY_C": 0.4549372,
    "CMY_M": 0.4259701,
    "CMY_Y": 0.3828709,
    "CMYK_C": 0.1167766,
    "CMYK_M": 0.06983828,
    "CMYK_Y": 0,
    "CMYK_K": 0.3828709
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07762",
    "Farbtonhilfsbezeichnung": "T8.26.31",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "95",
    "Bcolor": "129",
    "Y": 11,
    "L": 39.428384577385,
    "a": -1.26886993072003,
    "b": -22.8419641052263,
    "C": 22.8771797887224,
    "h": 1.51530341130878,
    "CMY_C": 0.7493094,
    "CMY_M": 0.6261777,
    "CMY_Y": 0.4949119,
    "CMYK_C": 0.5036695,
    "CMYK_M": 0.259887,
    "CMYK_Y": 0,
    "CMYK_K": 0.4949119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07763",
    "Farbtonhilfsbezeichnung": "U0.30.36",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "108",
    "Bcolor": "150",
    "Y": 14,
    "L": 44.6953014670951,
    "a": -0.26895964130402,
    "b": -27.7302230322036,
    "C": 27.7315273417171,
    "h": 1.56109747917034,
    "CMY_C": 0.7206591,
    "CMY_M": 0.5758452,
    "CMY_Y": 0.4098228,
    "CMYK_C": 0.5266829,
    "CMYK_M": 0.2813093,
    "CMYK_Y": 0,
    "CMYK_K": 0.4098228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07764",
    "Farbtonhilfsbezeichnung": "U0.38.33",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "102",
    "Bcolor": "151",
    "Y": 12,
    "L": 41.9998656845889,
    "a": -0.57662679700151,
    "b": -32.4829484013769,
    "C": 32.4880660444652,
    "h": 1.55304651443,
    "CMY_C": 0.797973,
    "CMY_M": 0.5992662,
    "CMY_Y": 0.4067499,
    "CMYK_C": 0.6594573,
    "CMYK_M": 0.3245112,
    "CMYK_Y": 0,
    "CMYK_K": 0.4067499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07766",
    "Farbtonhilfsbezeichnung": "U0.46.28",
    "Farbtonklasse": "04",
    "Rcolor": "6",
    "Gcolor": "91",
    "Bcolor": "148",
    "Y": 10,
    "L": 37.0621642411882,
    "a": 0.163325815653,
    "b": -38.2000604103283,
    "C": 38.2004095616106,
    "h": -1.56652081469626,
    "CMY_C": 0.9779759,
    "CMY_M": 0.6448552,
    "CMY_Y": 0.4208305,
    "CMYK_C": 0.961973,
    "CMYK_M": 0.3868034,
    "CMYK_Y": 0,
    "CMYK_K": 0.4208305
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07767",
    "Farbtonhilfsbezeichnung": "U0.49.24",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "86",
    "Bcolor": "144",
    "Y": 9,
    "L": 35.2764250479295,
    "a": 0.31544028843852,
    "b": -38.9493968943512,
    "C": 38.9506742048101,
    "h": -1.56269778311102,
    "CMY_C": 1,
    "CMY_M": 0.661383,
    "CMY_Y": 0.4344312,
    "CMYK_C": 1,
    "CMYK_M": 0.4012806,
    "CMYK_Y": 0,
    "CMYK_K": 0.4344312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07768",
    "Farbtonhilfsbezeichnung": "U0.42.26",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "86",
    "Bcolor": "136",
    "Y": 9,
    "L": 35.4167506604775,
    "a": -0.20275013702661,
    "b": -33.5404218966863,
    "C": 33.5410346981989,
    "h": 1.5647514515064,
    "CMY_C": 0.8941659,
    "CMY_M": 0.6615666,
    "CMY_Y": 0.4673972,
    "CMYK_C": 0.8012889,
    "CMYK_M": 0.3645671,
    "CMYK_Y": 0,
    "CMYK_K": 0.4673972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07769",
    "Farbtonhilfsbezeichnung": "U0.39.28",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "92",
    "Bcolor": "140",
    "Y": 10,
    "L": 37.6387162768335,
    "a": -0.37198520933923,
    "b": -32.5620534144399,
    "C": 32.5641781035666,
    "h": 1.55937293700212,
    "CMY_C": 0.8501672,
    "CMY_M": 0.6409459,
    "CMY_Y": 0.4510146,
    "CMYK_C": 0.7270731,
    "CMYK_M": 0.3459679,
    "CMYK_Y": 0,
    "CMYK_K": 0.4510146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07770",
    "Farbtonhilfsbezeichnung": "U0.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "90",
    "Bcolor": "116",
    "Y": 10,
    "L": 37.5375910848905,
    "a": -0.0591516654998,
    "b": -17.9923503681932,
    "C": 17.992447601462,
    "h": 1.56750873783733,
    "CMY_C": 0.7261415,
    "CMY_M": 0.6480666,
    "CMY_Y": 0.5442128,
    "CMYK_C": 0.3991526,
    "CMYK_M": 0.2278559,
    "CMYK_Y": 0,
    "CMYK_K": 0.5442128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07771",
    "Farbtonhilfsbezeichnung": "T9.20.27",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "87",
    "Bcolor": "110",
    "Y": 9,
    "L": 36.1938428040028,
    "a": -0.6574952637941,
    "b": -16.3591693318821,
    "C": 16.3723767746501,
    "h": 1.53062670888692,
    "CMY_C": 0.7353022,
    "CMY_M": 0.6600245,
    "CMY_Y": 0.567606,
    "CMYK_C": 0.3878318,
    "CMYK_M": 0.2137367,
    "CMYK_Y": 0,
    "CMYK_K": 0.567606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07772",
    "Farbtonhilfsbezeichnung": "T9.05.46",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "131",
    "Bcolor": "139",
    "Y": 23,
    "L": 54.5555330157097,
    "a": -0.2673997828631,
    "b": -5.55053539943446,
    "C": 5.55697272480713,
    "h": 1.52265805115378,
    "CMY_C": 0.5087868,
    "CMY_M": 0.4858546,
    "CMY_Y": 0.4553517,
    "CMYK_C": 0.09810925,
    "CMYK_M": 0.05600471,
    "CMYK_Y": 0,
    "CMYK_K": 0.4553517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07773",
    "Farbtonhilfsbezeichnung": "T9.05.35",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "105",
    "Bcolor": "112",
    "Y": 14,
    "L": 44.2916216049312,
    "a": -0.05680772597715,
    "b": -4.89459183498966,
    "C": 4.89492148546615,
    "h": 1.55919062455296,
    "CMY_C": 0.6055159,
    "CMY_M": 0.5877032,
    "CMY_Y": 0.5613419,
    "CMYK_C": 0.1007025,
    "CMYK_M": 0.06009534,
    "CMYK_Y": 0,
    "CMYK_K": 0.5613419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07774",
    "Farbtonhilfsbezeichnung": "U0.10.31",
    "Farbtonklasse": "02",
    "Rcolor": "81",
    "Gcolor": "89",
    "Bcolor": "102",
    "Y": 10,
    "L": 37.686765488907,
    "a": -0.00303257090739,
    "b": -8.97413347834375,
    "C": 8.97413399073228,
    "h": 1.57045840327289,
    "CMY_C": 0.682562,
    "CMY_M": 0.6496083,
    "CMY_Y": 0.5992032,
    "CMYK_C": 0.2079826,
    "CMYK_M": 0.1257621,
    "CMYK_Y": 0,
    "CMYK_K": 0.5992032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07775",
    "Farbtonhilfsbezeichnung": "U1.20.20",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "75",
    "Bcolor": "96",
    "Y": 7,
    "L": 31.5522621890635,
    "a": -0.0308875183739,
    "b": -14.6605903789276,
    "C": 14.6606229164212,
    "h": 1.5686894899026,
    "CMY_C": 0.7644348,
    "CMY_M": 0.7045866,
    "CMY_Y": 0.6226077,
    "CMYK_C": 0.3758081,
    "CMYK_M": 0.2172246,
    "CMYK_Y": 0,
    "CMYK_K": 0.6226077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07777",
    "Farbtonhilfsbezeichnung": "T9.34.24",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "83",
    "Bcolor": "119",
    "Y": 8,
    "L": 34.5118071994088,
    "a": -0.46031843918378,
    "b": -24.6346437948269,
    "C": 24.6389441324797,
    "h": 1.55211268438674,
    "CMY_C": 0.8039508,
    "CMY_M": 0.6730975,
    "CMY_Y": 0.5324751,
    "CMYK_C": 0.5806658,
    "CMYK_M": 0.3007805,
    "CMYK_Y": 0,
    "CMYK_K": 0.5324751
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07778",
    "Farbtonhilfsbezeichnung": "T9.39.26",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "85",
    "Bcolor": "132",
    "Y": 8,
    "L": 34.9261270735951,
    "a": -0.18696162131318,
    "b": -31.8920325453885,
    "C": 31.8925805560473,
    "h": 1.56493406388247,
    "CMY_C": 0.8739499,
    "CMY_M": 0.6668528,
    "CMY_Y": 0.4827829,
    "CMYK_C": 0.7562918,
    "CMYK_M": 0.3558852,
    "CMYK_Y": 0,
    "CMYK_K": 0.4827829
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07779",
    "Farbtonhilfsbezeichnung": "U1.41.23",
    "Farbtonklasse": "04",
    "Rcolor": "29",
    "Gcolor": "80",
    "Bcolor": "127",
    "Y": 8,
    "L": 33.0018049811303,
    "a": 0.40510093480702,
    "b": -31.6663606723122,
    "C": 31.6689517508291,
    "h": -1.55800423987997,
    "CMY_C": 0.8864191,
    "CMY_M": 0.6857806,
    "CMY_Y": 0.5035227,
    "CMYK_C": 0.7712263,
    "CMYK_M": 0.3671022,
    "CMYK_Y": 0,
    "CMYK_K": 0.5035227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07780",
    "Farbtonhilfsbezeichnung": "U1.47.23",
    "Farbtonklasse": "04",
    "Rcolor": "19",
    "Gcolor": "82",
    "Bcolor": "133",
    "Y": 8,
    "L": 33.8376549110303,
    "a": 0.33671175713997,
    "b": -34.3515011701814,
    "C": 34.353151346745,
    "h": -1.56099468894117,
    "CMY_C": 0.9253682,
    "CMY_M": 0.676805,
    "CMY_Y": 0.4782506,
    "CMYK_C": 0.8569586,
    "CMYK_M": 0.380555,
    "CMYK_Y": 0,
    "CMYK_K": 0.4782506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07782",
    "Farbtonhilfsbezeichnung": "U0.48.22",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "81",
    "Bcolor": "134",
    "Y": 7,
    "L": 32.9052389287242,
    "a": -0.17210694401101,
    "b": -36.443153248562,
    "C": 36.4435596436236,
    "h": 1.56607374795137,
    "CMY_C": 1,
    "CMY_M": 0.6834509,
    "CMY_Y": 0.4745595,
    "CMYK_C": 1,
    "CMYK_M": 0.3975547,
    "CMYK_Y": 0,
    "CMYK_K": 0.4745595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07783",
    "Farbtonhilfsbezeichnung": "T9.37.23",
    "Farbtonklasse": "04",
    "Rcolor": "36",
    "Gcolor": "80",
    "Bcolor": "120",
    "Y": 7,
    "L": 32.7123275181652,
    "a": -0.69689995138397,
    "b": -28.0076175811863,
    "C": 28.0162865511512,
    "h": 1.54591894560861,
    "CMY_C": 0.8595499,
    "CMY_M": 0.687894,
    "CMY_Y": 0.5292968,
    "CMYK_C": 0.7016165,
    "CMYK_M": 0.3369366,
    "CMYK_Y": 0,
    "CMYK_K": 0.5292968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07784",
    "Farbtonhilfsbezeichnung": "T8.30.15",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "67",
    "Bcolor": "93",
    "Y": 5,
    "L": 27.6621583201926,
    "a": -0.28806465841241,
    "b": -18.9117180623401,
    "C": 18.9139118459632,
    "h": 1.55556543227625,
    "CMY_C": 0.8272921,
    "CMY_M": 0.7377518,
    "CMY_Y": 0.6337966,
    "CMYK_C": 0.5283826,
    "CMYK_M": 0.2838731,
    "CMYK_Y": 0,
    "CMYK_K": 0.6337966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07785",
    "Farbtonhilfsbezeichnung": "T9.27.15",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "65",
    "Bcolor": "88",
    "Y": 5,
    "L": 26.7410768634022,
    "a": -1.37951861436217,
    "b": -16.8809133282711,
    "C": 16.9371870865257,
    "h": 1.48925690373199,
    "CMY_C": 0.8332323,
    "CMY_M": 0.7446615,
    "CMY_Y": 0.6546803,
    "CMYK_C": 0.5170628,
    "CMYK_M": 0.2605734,
    "CMYK_Y": 0,
    "CMYK_K": 0.6546803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07786",
    "Farbtonhilfsbezeichnung": "T8.10.19",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "72",
    "Bcolor": "81",
    "Y": 6,
    "L": 30.2591480240498,
    "a": -0.34741203842439,
    "b": -6.95302755803775,
    "C": 6.96170146927277,
    "h": 1.52087226763048,
    "CMY_C": 0.7453816,
    "CMY_M": 0.7180179,
    "CMY_Y": 0.6813338,
    "CMYK_C": 0.2009869,
    "CMYK_M": 0.1151173,
    "CMYK_Y": 0,
    "CMYK_K": 0.6813338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07787",
    "Farbtonhilfsbezeichnung": "T8.06.30",
    "Farbtonklasse": "02",
    "Rcolor": "88",
    "Gcolor": "93",
    "Bcolor": "100",
    "Y": 11,
    "L": 39.3058679543269,
    "a": -0.42024131800552,
    "b": -5.28633597150571,
    "C": 5.30301336685042,
    "h": 1.49146739031204,
    "CMY_C": 0.6568468,
    "CMY_M": 0.6345479,
    "CMY_Y": 0.6068696,
    "CMYK_C": 0.1271261,
    "CMYK_M": 0.07040475,
    "CMYK_Y": 0,
    "CMYK_K": 0.6068696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07788",
    "Farbtonhilfsbezeichnung": "UN.01.06",
    "Farbtonklasse": "03",
    "Rcolor": "41",
    "Gcolor": "42",
    "Bcolor": "43",
    "Y": 2,
    "L": 16.9183790094823,
    "a": -0.19577832427555,
    "b": -1.21651341192957,
    "C": 1.23216639852767,
    "h": 1.41123054729454,
    "CMY_C": 0.840887,
    "CMY_M": 0.8357273,
    "CMY_Y": 0.8313542,
    "CMYK_C": 0.05652533,
    "CMYK_M": 0.025931,
    "CMYK_Y": 0,
    "CMYK_K": 0.8313542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07789",
    "Farbtonhilfsbezeichnung": "U0.09.07",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "49",
    "Bcolor": "55",
    "Y": 3,
    "L": 20.343830198333,
    "a": 0.2023601632751,
    "b": -4.76613241167457,
    "C": 4.77042637520962,
    "h": -1.52836387202659,
    "CMY_C": 0.8204736,
    "CMY_M": 0.8067748,
    "CMY_Y": 0.7825064,
    "CMYK_C": 0.1745671,
    "CMYK_M": 0.1115822,
    "CMYK_Y": 0,
    "CMYK_K": 0.7825064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07790",
    "Farbtonhilfsbezeichnung": "U0.11.07",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "51",
    "Bcolor": "58",
    "Y": 3,
    "L": 21.1821934508124,
    "a": 0.13756274497989,
    "b": -5.40835828584706,
    "C": 5.41010747184351,
    "h": -1.5453665967711,
    "CMY_C": 0.8159393,
    "CMY_M": 0.799334,
    "CMY_Y": 0.7716048,
    "CMYK_C": 0.1941134,
    "CMYK_M": 0.1214094,
    "CMYK_Y": 0,
    "CMYK_K": 0.7716048
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07791",
    "Farbtonhilfsbezeichnung": "T7.15.16",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "59",
    "Bcolor": "73",
    "Y": 4,
    "L": 24.1465011076181,
    "a": -1.2146336592509,
    "b": -10.6555398108906,
    "C": 10.7245449128464,
    "h": 1.4572954272739,
    "CMY_C": 0.8211302,
    "CMY_M": 0.7697896,
    "CMY_Y": 0.7152104,
    "CMYK_C": 0.3719229,
    "CMYK_M": 0.1916474,
    "CMYK_Y": 0,
    "CMYK_K": 0.7152104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07792",
    "Farbtonhilfsbezeichnung": "U1.32.13",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "57",
    "Bcolor": "85",
    "Y": 4,
    "L": 23.3140897210322,
    "a": 0.30679383332607,
    "b": -20.5809478553797,
    "C": 20.5832343688261,
    "h": -1.55589073963006,
    "CMY_C": 0.875407,
    "CMY_M": 0.7764924,
    "CMY_Y": 0.6647086,
    "CMYK_C": 0.6284038,
    "CMYK_M": 0.3333928,
    "CMYK_Y": 0,
    "CMYK_K": 0.6647086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07793",
    "Farbtonhilfsbezeichnung": "U1.39.13",
    "Farbtonklasse": "04",
    "Rcolor": "27",
    "Gcolor": "61",
    "Bcolor": "94",
    "Y": 4,
    "L": 24.8213987681692,
    "a": -0.12430824921741,
    "b": -23.5664820653353,
    "C": 23.5668099130237,
    "h": 1.56552158549075,
    "CMY_C": 0.8928651,
    "CMY_M": 0.7614428,
    "CMY_Y": 0.6328972,
    "CMYK_C": 0.7081612,
    "CMYK_M": 0.3501624,
    "CMYK_Y": 0,
    "CMYK_K": 0.6328972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07794",
    "Farbtonhilfsbezeichnung": "T8.41.20",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "78",
    "Bcolor": "117",
    "Y": 7,
    "L": 32.0808498002111,
    "a": -1.48724437744743,
    "b": -27.0558951481117,
    "C": 27.096740728432,
    "h": 1.51588226413665,
    "CMY_C": 0.8679069,
    "CMY_M": 0.6925945,
    "CMY_Y": 0.5415006,
    "CMYK_C": 0.7119014,
    "CMYK_M": 0.3295402,
    "CMYK_Y": 0,
    "CMYK_K": 0.5415006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07795",
    "Farbtonhilfsbezeichnung": "U0.46.18",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "69",
    "Bcolor": "115",
    "Y": 5,
    "L": 27.9352914257641,
    "a": -0.79530372375821,
    "b": -32.4744355712904,
    "C": 32.484172664344,
    "h": 1.54631107345952,
    "CMY_C": 1,
    "CMY_M": 0.7290021,
    "CMY_Y": 0.5489918,
    "CMYK_C": 1,
    "CMYK_M": 0.3991286,
    "CMYK_Y": 0,
    "CMYK_K": 0.5489918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07796",
    "Farbtonhilfsbezeichnung": "U5.28.56",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "155",
    "Bcolor": "210",
    "Y": 32,
    "L": 63.7298598585362,
    "a": 4.26710037078426,
    "b": -32.2300068649228,
    "C": 32.5112517151726,
    "h": -1.43916658821442,
    "CMY_C": 0.5051429,
    "CMY_M": 0.3930323,
    "CMY_Y": 0.1765397,
    "CMYK_C": 0.3990517,
    "CMYK_M": 0.262906,
    "CMYK_Y": 0,
    "CMYK_K": 0.1765397
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07797",
    "Farbtonhilfsbezeichnung": "U2.20.64",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "178",
    "Bcolor": "219",
    "Y": 44,
    "L": 71.8695220947266,
    "a": 1.10522592067719,
    "b": -24.8070316314697,
    "C": 24.8316402435303,
    "h": 272.550994873047,
    "CMY_C": 0.40519601106644,
    "CMY_M": 0.30348747968674,
    "CMY_Y": 0.1395229101181,
    "CMYK_C": 0.30875092744827,
    "CMYK_M": 0.19055077433586,
    "CMYK_Y": 0,
    "CMYK_K": 0.1395229101181
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07798",
    "Farbtonhilfsbezeichnung": "U0.14.69",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "193",
    "Bcolor": "223",
    "Y": 52,
    "L": 77.4406244273049,
    "a": -0.0511516759391,
    "b": -18.0502081101569,
    "C": 18.0502805882326,
    "h": 1.56796247919053,
    "CMY_C": 0.3220338,
    "CMY_M": 0.2436573,
    "CMY_Y": 0.1263853,
    "CMYK_C": 0.2239528,
    "CMYK_M": 0.1342376,
    "CMYK_Y": 0,
    "CMYK_K": 0.1263853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07799",
    "Farbtonhilfsbezeichnung": "U5.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 66,
    "L": 84.909401074328,
    "a": 0.63213517655663,
    "b": -7.68498282790253,
    "C": 7.71093742333557,
    "h": -1.48872519298893,
    "CMY_C": 0.1914085,
    "CMY_M": 0.1672727,
    "CMY_Y": 0.1188427,
    "CMYK_C": 0.08235288,
    "CMYK_M": 0.05496181,
    "CMYK_Y": 0,
    "CMYK_K": 0.1188427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07800",
    "Farbtonhilfsbezeichnung": "U0.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "206",
    "Bcolor": "226",
    "Y": 61,
    "L": 82.5491333007813,
    "a": 0.80668824911118,
    "b": -12.0951728820801,
    "C": 12.1220445632935,
    "h": 273.815704345703,
    "CMY_C": 0.23330718278885,
    "CMY_M": 0.19212371110916,
    "CMY_Y": 0.11281710863113,
    "CMYK_C": 0.13581198453903,
    "CMYK_M": 0.08939149230719,
    "CMYK_Y": 0,
    "CMYK_K": 0.11281710863113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07801",
    "Farbtonhilfsbezeichnung": "U5.14.69",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "191",
    "Bcolor": "223",
    "Y": 52,
    "L": 77.2499422500072,
    "a": 1.87672401246036,
    "b": -18.2231700338688,
    "C": 18.3195529176407,
    "h": -1.46817252160566,
    "CMY_C": 0.3081837,
    "CMY_M": 0.2500677,
    "CMY_Y": 0.1270403,
    "CMYK_C": 0.2075049,
    "CMYK_M": 0.1409313,
    "CMYK_Y": 0,
    "CMYK_K": 0.1270403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07802",
    "Farbtonhilfsbezeichnung": "U3.15.69",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "190",
    "Bcolor": "221",
    "Y": 51,
    "L": 76.4848937988281,
    "a": 1.02509617805481,
    "b": -18.481897354126,
    "C": 18.5103034973145,
    "h": 273.174652099609,
    "CMY_C": 0.324911236763,
    "CMY_M": 0.25623613595963,
    "CMY_Y": 0.13371586799622,
    "CMYK_C": 0.22070746123791,
    "CMYK_M": 0.14143197238445,
    "CMYK_Y": 0,
    "CMYK_K": 0.13371586799622
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07803",
    "Farbtonhilfsbezeichnung": "U4.21.64",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "179",
    "Bcolor": "224",
    "Y": 45,
    "L": 72.9329528808594,
    "a": 3.08855080604553,
    "b": -25.9132347106934,
    "C": 26.0966453552246,
    "h": 276.796905517578,
    "CMY_C": 0.38163191080093,
    "CMY_M": 0.29628485441208,
    "CMY_Y": 0.11972826719284,
    "CMYK_C": 0.29752591252327,
    "CMYK_M": 0.20057055354118,
    "CMYK_Y": 0,
    "CMYK_K": 0.11972826719284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07804",
    "Farbtonhilfsbezeichnung": "U6.28.53",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "149",
    "Bcolor": "205",
    "Y": 30,
    "L": 61.5790843648925,
    "a": 4.88718474383493,
    "b": -32.6268140449809,
    "C": 32.9908103787424,
    "h": -1.42211133676939,
    "CMY_C": 0.5244863,
    "CMY_M": 0.4164135,
    "CMY_Y": 0.1972441,
    "CMYK_C": 0.4076485,
    "CMYK_M": 0.2730212,
    "CMYK_Y": 0,
    "CMYK_K": 0.1972441
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07805",
    "Farbtonhilfsbezeichnung": "U5.30.52",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "148",
    "Bcolor": "203",
    "Y": 29,
    "L": 60.9685363769531,
    "a": 4.1100435256958,
    "b": -32.6848907470703,
    "C": 32.9422912597656,
    "h": 277.167175292969,
    "CMY_C": 0.53900110721588,
    "CMY_M": 0.4208967089653,
    "CMY_Y": 0.20356303453445,
    "CMYK_C": 0.42117342352867,
    "CMYK_M": 0.27288246154785,
    "CMYK_Y": 0,
    "CMYK_K": 0.20356303453445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07807",
    "Farbtonhilfsbezeichnung": "U6.15.63",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "174",
    "Bcolor": "207",
    "Y": 42,
    "L": 71.1873345399595,
    "a": 3.08072140930071,
    "b": -19.1951987261801,
    "C": 19.4408461374311,
    "h": -1.41165906758715,
    "CMY_C": 0.367005,
    "CMY_M": 0.3172297,
    "CMY_Y": 0.1864805,
    "CMYK_C": 0.2219055,
    "CMYK_M": 0.1607205,
    "CMYK_Y": 0,
    "CMYK_K": 0.1864805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07808",
    "Farbtonhilfsbezeichnung": "U5.13.64",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "176",
    "Bcolor": "205",
    "Y": 44,
    "L": 71.9387390601701,
    "a": 2.142220360554,
    "b": -16.6647236916551,
    "C": 16.8018488206621,
    "h": -1.44294925166804,
    "CMY_C": 0.3555069,
    "CMY_M": 0.3079865,
    "CMY_Y": 0.1962668,
    "CMYK_C": 0.1981255,
    "CMYK_M": 0.139001,
    "CMYK_Y": 0,
    "CMYK_K": 0.1962668
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07810",
    "Farbtonhilfsbezeichnung": "U2.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "207",
    "Bcolor": "216",
    "Y": 63,
    "L": 83.0173645019531,
    "a": 0.08707474172115,
    "b": -5.84866857528687,
    "C": 5.84931659698486,
    "h": 270.852966308594,
    "CMY_C": 0.20947992801666,
    "CMY_M": 0.1872786283493,
    "CMY_Y": 0.15308332443237,
    "CMYK_C": 0.06659049540758,
    "CMYK_M": 0.04037623107433,
    "CMYK_Y": 0,
    "CMYK_K": 0.15308332443237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07811",
    "Farbtonhilfsbezeichnung": "U7.03.62",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "171",
    "Bcolor": "178",
    "Y": 41,
    "L": 70.0769408243412,
    "a": 0.95957638104293,
    "b": -4.56009056482123,
    "C": 4.65995845372328,
    "h": -1.36339306031774,
    "CMY_C": 0.3365751,
    "CMY_M": 0.3287989,
    "CMY_Y": 0.3014967,
    "CMYK_C": 0.05021938,
    "CMYK_M": 0.03908671,
    "CMYK_Y": 0,
    "CMYK_K": 0.3014967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07812",
    "Farbtonhilfsbezeichnung": "U5.06.63",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "175",
    "Bcolor": "189",
    "Y": 43,
    "L": 71.4408583567557,
    "a": 1.125967121345,
    "b": -8.42416172049256,
    "C": 8.49907657639124,
    "h": -1.43792458625891,
    "CMY_C": 0.3350906,
    "CMY_M": 0.3135994,
    "CMY_Y": 0.259842,
    "CMYK_C": 0.1016656,
    "CMYK_M": 0.0726296,
    "CMYK_Y": 0,
    "CMYK_K": 0.259842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07813",
    "Farbtonhilfsbezeichnung": "U5.11.63",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "173",
    "Bcolor": "196",
    "Y": 42,
    "L": 70.8937417616131,
    "a": 2.09936573623015,
    "b": -13.5666074253727,
    "C": 13.7280797465864,
    "h": -1.41726897660068,
    "CMY_C": 0.3535661,
    "CMY_M": 0.3199863,
    "CMY_Y": 0.2294175,
    "CMYK_C": 0.1611101,
    "CMYK_M": 0.1175329,
    "CMYK_Y": 0,
    "CMYK_K": 0.2294175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07814",
    "Farbtonhilfsbezeichnung": "U3.16.60",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "166",
    "Bcolor": "197",
    "Y": 38,
    "L": 67.7329786860288,
    "a": 1.24424555303343,
    "b": -18.8756879793721,
    "C": 18.9166525498265,
    "h": -1.50497366188927,
    "CMY_C": 0.4175214,
    "CMY_M": 0.3495696,
    "CMY_Y": 0.2263752,
    "CMYK_C": 0.2470787,
    "CMYK_M": 0.1592431,
    "CMYK_Y": 0,
    "CMYK_K": 0.2263752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07815",
    "Farbtonhilfsbezeichnung": "U5.17.62",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "171",
    "Bcolor": "209",
    "Y": 41,
    "L": 69.9816578796151,
    "a": 2.859951359101,
    "b": -22.0662619994649,
    "C": 22.2508256117712,
    "h": -1.44190739454032,
    "CMY_C": 0.3953438,
    "CMY_M": 0.3284453,
    "CMY_Y": 0.1794207,
    "CMYK_C": 0.263135,
    "CMYK_M": 0.1816091,
    "CMYK_Y": 0,
    "CMYK_K": 0.1794207
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07816",
    "Farbtonhilfsbezeichnung": "U2.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "155",
    "Bcolor": "201",
    "Y": 32,
    "L": 63.5855707495448,
    "a": 1.57260556271521,
    "b": -27.39435404207,
    "C": 27.4394555638074,
    "h": -1.51345307000394,
    "CMY_C": 0.5030835,
    "CMY_M": 0.3904282,
    "CMY_Y": 0.2119403,
    "CMYK_C": 0.3694431,
    "CMYK_M": 0.2264903,
    "CMYK_Y": 0,
    "CMYK_K": 0.2119403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07817",
    "Farbtonhilfsbezeichnung": "U6.30.49",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "139",
    "Bcolor": "194",
    "Y": 26,
    "L": 57.8394214878264,
    "a": 5.02415770253528,
    "b": -32.4781146511407,
    "C": 32.8644198474974,
    "h": -1.41731921512449,
    "CMY_C": 0.5617737,
    "CMY_M": 0.4549043,
    "CMY_Y": 0.2388497,
    "CMYK_C": 0.4242578,
    "CMYK_M": 0.2838528,
    "CMYK_Y": 0,
    "CMYK_K": 0.2388497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07818",
    "Farbtonhilfsbezeichnung": "U7.31.51",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "144",
    "Bcolor": "203",
    "Y": 28,
    "L": 59.6686184925206,
    "a": 5.66774380835311,
    "b": -34.5439380593878,
    "C": 35.0058134675934,
    "h": -1.40817181508827,
    "CMY_C": 0.549678,
    "CMY_M": 0.4369043,
    "CMY_Y": 0.2047746,
    "CMYK_C": 0.4337177,
    "CMYK_M": 0.2919042,
    "CMYK_Y": 0,
    "CMYK_K": 0.2047746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07819",
    "Farbtonhilfsbezeichnung": "U5.35.45",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "131",
    "Bcolor": "192",
    "Y": 21,
    "L": 54.2264595031738,
    "a": 4.55273199081421,
    "b": -37.1786727905273,
    "C": 37.4563903808594,
    "h": 276.981414794922,
    "CMY_C": 0.63959145545959,
    "CMY_M": 0.48821532726288,
    "CMY_Y": 0.24588888883591,
    "CMYK_C": 0.52207499742508,
    "CMYK_M": 0.32134050130844,
    "CMYK_Y": 0,
    "CMYK_K": 0.24588888883591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07820",
    "Farbtonhilfsbezeichnung": "U6.25.46",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "128",
    "Bcolor": "175",
    "Y": 22,
    "L": 53.685182769768,
    "a": 4.15463240810032,
    "b": -27.8244405877459,
    "C": 28.1329071456797,
    "h": -1.42257545684057,
    "CMY_C": 0.5842538,
    "CMY_M": 0.4966469,
    "CMY_Y": 0.3149134,
    "CMYK_C": 0.3931479,
    "CMYK_M": 0.2652708,
    "CMYK_Y": 0,
    "CMYK_K": 0.3149134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07821",
    "Farbtonhilfsbezeichnung": "U7.25.48",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "134",
    "Bcolor": "181",
    "Y": 24,
    "L": 56.2216344848774,
    "a": 5.38280786318651,
    "b": -27.4212015010145,
    "C": 27.9445327792616,
    "h": -1.37696006415787,
    "CMY_C": 0.5446054,
    "CMY_M": 0.4740829,
    "CMY_Y": 0.2905973,
    "CMYK_C": 0.3580591,
    "CMYK_M": 0.258648,
    "CMYK_Y": 0,
    "CMYK_K": 0.2905973
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07825",
    "Farbtonhilfsbezeichnung": "U6.12.53",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "147",
    "Bcolor": "170",
    "Y": 29,
    "L": 60.9465511984852,
    "a": 2.36658246831462,
    "b": -14.0209494604072,
    "C": 14.2192734114872,
    "h": -1.40358335997251,
    "CMY_C": 0.4566948,
    "CMY_M": 0.4240946,
    "CMY_Y": 0.3320542,
    "CMYK_C": 0.1866028,
    "CMYK_M": 0.1377962,
    "CMYK_Y": 0,
    "CMYK_K": 0.3320542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07826",
    "Farbtonhilfsbezeichnung": "U5.05.53",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "148",
    "Bcolor": "158",
    "Y": 30,
    "L": 61.348269354954,
    "a": 0.79940532992239,
    "b": -6.33994474006219,
    "C": 6.39014461405613,
    "h": -1.44536798226995,
    "CMY_C": 0.4348453,
    "CMY_M": 0.4188704,
    "CMY_Y": 0.3804716,
    "CMYK_C": 0.08776625,
    "CMYK_M": 0.06198068,
    "CMYK_Y": 0,
    "CMYK_K": 0.3804716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07827",
    "Farbtonhilfsbezeichnung": "U6.08.53",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "148",
    "Bcolor": "163",
    "Y": 30,
    "L": 61.243470135873,
    "a": 1.09019019935624,
    "b": -9.55060386345645,
    "C": 9.61262445055676,
    "h": -1.45713944713509,
    "CMY_C": 0.445705,
    "CMY_M": 0.4196306,
    "CMY_Y": 0.3596106,
    "CMYK_C": 0.1344406,
    "CMYK_M": 0.0937242,
    "CMYK_Y": 0,
    "CMYK_K": 0.3596106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07828",
    "Farbtonhilfsbezeichnung": "U3.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "143",
    "Bcolor": "161",
    "Y": 27,
    "L": 59.2501625415767,
    "a": 0.79210198614621,
    "b": -11.1775798265709,
    "C": 11.2056109309498,
    "h": -1.50004934655439,
    "CMY_C": 0.4748022,
    "CMY_M": 0.4388965,
    "CMY_Y": 0.3692881,
    "CMYK_C": 0.1672936,
    "CMYK_M": 0.1103649,
    "CMYK_Y": 0,
    "CMYK_K": 0.3692881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07829",
    "Farbtonhilfsbezeichnung": "U3.14.47",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "133",
    "Bcolor": "155",
    "Y": 23,
    "L": 55.1029893831782,
    "a": 0.47397528350057,
    "b": -14.4344047517631,
    "C": 14.4421844991363,
    "h": -1.53797162432574,
    "CMY_C": 0.5329719,
    "CMY_M": 0.4792405,
    "CMY_Y": 0.3902901,
    "CMYK_C": 0.2340159,
    "CMYK_M": 0.1458897,
    "CMYK_Y": 0,
    "CMYK_K": 0.3902901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07830",
    "Farbtonhilfsbezeichnung": "U4.19.51",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "146",
    "Bcolor": "180",
    "Y": 28,
    "L": 60.1751951785446,
    "a": 1.78155790367251,
    "b": -20.7669960404795,
    "C": 20.8432740496648,
    "h": -1.48521791201289,
    "CMY_C": 0.5004281,
    "CMY_M": 0.4284236,
    "CMY_Y": 0.2941696,
    "CMYK_C": 0.2922211,
    "CMYK_M": 0.1902072,
    "CMYK_Y": 0,
    "CMYK_K": 0.2941696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07831",
    "Farbtonhilfsbezeichnung": "U6.20.53",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "148",
    "Bcolor": "189",
    "Y": 30,
    "L": 61.4537373122661,
    "a": 4.12109485711359,
    "b": -23.7148247433461,
    "C": 24.0702375440905,
    "h": -1.39873741103669,
    "CMY_C": 0.481856,
    "CMY_M": 0.4194506,
    "CMY_Y": 0.2601011,
    "CMYK_C": 0.2997098,
    "CMYK_M": 0.2153667,
    "CMYK_Y": 0,
    "CMYK_K": 0.2601011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07832",
    "Farbtonhilfsbezeichnung": "U6.26.43",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "126",
    "Bcolor": "171",
    "Y": 21,
    "L": 52.7410230741367,
    "a": 4.32919618565619,
    "b": -27.1386727358863,
    "C": 27.4818030245368,
    "h": -1.41260785669311,
    "CMY_C": 0.5882594,
    "CMY_M": 0.5067126,
    "CMY_Y": 0.3294758,
    "CMYK_C": 0.3859421,
    "CMYK_M": 0.2643257,
    "CMYK_Y": 0,
    "CMYK_K": 0.3294758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07833",
    "Farbtonhilfsbezeichnung": "U6.30.43",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "124",
    "Bcolor": "177",
    "Y": 20,
    "L": 52.0146064835132,
    "a": 4.90019761443578,
    "b": -31.7263356450907,
    "C": 32.1025280955484,
    "h": -1.41755516428713,
    "CMY_C": 0.6191506,
    "CMY_M": 0.5133359,
    "CMY_Y": 0.3063594,
    "CMYK_C": 0.4509414,
    "CMYK_M": 0.2983916,
    "CMYK_Y": 0,
    "CMYK_K": 0.3063594
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07834",
    "Farbtonhilfsbezeichnung": "U6.35.44",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "126",
    "Bcolor": "189",
    "Y": 21,
    "L": 52.6799513929955,
    "a": 6.44848620456123,
    "b": -37.6359278071471,
    "C": 38.1843690040205,
    "h": -1.40110548217399,
    "CMY_C": 0.6391277,
    "CMY_M": 0.5075994,
    "CMY_Y": 0.2593297,
    "CMYK_C": 0.5127761,
    "CMYK_M": 0.3351959,
    "CMYK_Y": 0,
    "CMYK_K": 0.2593297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07835",
    "Farbtonhilfsbezeichnung": "U2.36.38",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "113",
    "Bcolor": "167",
    "Y": 16,
    "L": 46.9409245833757,
    "a": 2.28198849667965,
    "b": -34.1787181314179,
    "C": 34.2548134516289,
    "h": -1.50412891444707,
    "CMY_C": 0.7206964,
    "CMY_M": 0.5565988,
    "CMY_Y": 0.3438832,
    "CMYK_C": 0.5743081,
    "CMYK_M": 0.3242039,
    "CMYK_Y": 0,
    "CMYK_K": 0.3438832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07836",
    "Farbtonhilfsbezeichnung": "U4.31.47",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "135",
    "Bcolor": "192",
    "Y": 24,
    "L": 56.2090430021812,
    "a": 4.13618875326954,
    "b": -34.0583683533168,
    "C": 34.308606971034,
    "h": -1.44994401981846,
    "CMY_C": 0.5988568,
    "CMY_M": 0.4687502,
    "CMY_Y": 0.2457391,
    "CMYK_C": 0.4681639,
    "CMYK_M": 0.2956683,
    "CMYK_Y": 0,
    "CMYK_K": 0.2457391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07837",
    "Farbtonhilfsbezeichnung": "U4.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "118",
    "Bcolor": "165",
    "Y": 18,
    "L": 49.3558387667224,
    "a": 3.43872457616845,
    "b": -29.0676967418744,
    "C": 29.2703915345921,
    "h": -1.45304305921323,
    "CMY_C": 0.6434008,
    "CMY_M": 0.5375147,
    "CMY_Y": 0.3522783,
    "CMYK_C": 0.4494561,
    "CMYK_M": 0.2859815,
    "CMYK_Y": 0,
    "CMYK_K": 0.3522783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07838",
    "Farbtonhilfsbezeichnung": "U5.21.43",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "123",
    "Bcolor": "157",
    "Y": 20,
    "L": 51.3458996597303,
    "a": 2.44104070372991,
    "b": -21.2863382198549,
    "C": 21.4258459465973,
    "h": -1.45661868486662,
    "CMY_C": 0.5868942,
    "CMY_M": 0.5186731,
    "CMY_Y": 0.3832621,
    "CMYK_C": 0.330176,
    "CMYK_M": 0.21956,
    "CMYK_Y": 0,
    "CMYK_K": 0.3832621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07839",
    "Farbtonhilfsbezeichnung": "U3.17.42",
    "Farbtonklasse": "02",
    "Rcolor": "105",
    "Gcolor": "120",
    "Bcolor": "145",
    "Y": 18,
    "L": 49.9395755698501,
    "a": 0.88218537964868,
    "b": -16.0076107608898,
    "C": 16.0319011135991,
    "h": -1.51574164648565,
    "CMY_C": 0.5881047,
    "CMY_M": 0.5311025,
    "CMY_Y": 0.4327739,
    "CMYK_C": 0.2738428,
    "CMYK_M": 0.17335,
    "CMYK_Y": 0,
    "CMYK_K": 0.4327739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07840",
    "Farbtonhilfsbezeichnung": "U5.14.39",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "113",
    "Bcolor": "135",
    "Y": 17,
    "L": 47.6613222321718,
    "a": 1.69786343566508,
    "b": -13.9421047185597,
    "C": 14.0451067717356,
    "h": -1.44961346962899,
    "CMY_C": 0.59465,
    "CMY_M": 0.5558919,
    "CMY_Y": 0.4693178,
    "CMYK_C": 0.2361719,
    "CMYK_M": 0.1631373,
    "CMYK_Y": 0,
    "CMYK_K": 0.4693178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07841",
    "Farbtonhilfsbezeichnung": "U5.08.44",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "124",
    "Bcolor": "139",
    "Y": 20,
    "L": 52.1598518500779,
    "a": 1.32036599248397,
    "b": -9.33610280246682,
    "C": 9.42900747122076,
    "h": -1.43030224901189,
    "CMY_C": 0.5346369,
    "CMY_M": 0.5121075,
    "CMY_Y": 0.4542301,
    "CMYK_C": 0.1473273,
    "CMYK_M": 0.1060473,
    "CMYK_Y": 0,
    "CMYK_K": 0.4542301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07842",
    "Farbtonhilfsbezeichnung": "U4.48.21",
    "Farbtonklasse": "04",
    "Rcolor": "22",
    "Gcolor": "77",
    "Bcolor": "127",
    "Y": 7,
    "L": 31.8059459745914,
    "a": 1.90515823998758,
    "b": -33.9955939593405,
    "C": 34.048935909478,
    "h": -1.51481355661078,
    "CMY_C": 0.9142393,
    "CMY_M": 0.6985014,
    "CMY_Y": 0.5008797,
    "CMYK_C": 0.8281764,
    "CMYK_M": 0.39594,
    "CMYK_Y": 0,
    "CMYK_K": 0.5008797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07843",
    "Farbtonhilfsbezeichnung": "U6.35.15",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "63",
    "Bcolor": "95",
    "Y": 5,
    "L": 26.5531300122234,
    "a": 2.94515307507659,
    "b": -21.9838697421982,
    "C": 22.1802717629332,
    "h": -1.43762046068845,
    "CMY_C": 0.8272785,
    "CMY_M": 0.7525629,
    "CMY_Y": 0.6256861,
    "CMYK_C": 0.5385651,
    "CMYK_M": 0.3389584,
    "CMYK_Y": 0,
    "CMYK_K": 0.6256861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07844",
    "Farbtonhilfsbezeichnung": "U7.33.15",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "63",
    "Bcolor": "98",
    "Y": 5,
    "L": 26.4889236444227,
    "a": 3.96750905411594,
    "b": -23.4173672578557,
    "C": 23.7510887620712,
    "h": -1.40296417502203,
    "CMY_C": 0.8279811,
    "CMY_M": 0.7545641,
    "CMY_Y": 0.6176427,
    "CMYK_C": 0.5501094,
    "CMYK_M": 0.358098,
    "CMYK_Y": 0,
    "CMYK_K": 0.6176427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07845",
    "Farbtonhilfsbezeichnung": "U2.18.14",
    "Farbtonklasse": "03",
    "Rcolor": "48",
    "Gcolor": "61",
    "Bcolor": "77",
    "Y": 4,
    "L": 25.1169355875422,
    "a": -0.18254186638014,
    "b": -12.3161103821701,
    "C": 12.3174630699174,
    "h": 1.55597602266186,
    "CMY_C": 0.8122365,
    "CMY_M": 0.7626505,
    "CMY_Y": 0.6965991,
    "CMYK_C": 0.3811375,
    "CMYK_M": 0.2177033,
    "CMYK_Y": 0,
    "CMYK_K": 0.6965991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07846",
    "Farbtonhilfsbezeichnung": "U3.15.11",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "67",
    "Bcolor": "78",
    "Y": 4,
    "L": 28.4600429534912,
    "a": 0.93211358785629,
    "b": -7.68848991394043,
    "C": 7.74478626251221,
    "h": 276.912506103516,
    "CMY_C": 0.75512230396271,
    "CMY_M": 0.73644095659256,
    "CMY_Y": 0.69330441951752,
    "CMYK_C": 0.2015610486269,
    "CMYK_M": 0.14064936339855,
    "CMYK_Y": 0,
    "CMYK_K": 0.69330441951752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07847",
    "Farbtonhilfsbezeichnung": "U6.13.08",
    "Farbtonklasse": "03",
    "Rcolor": "44",
    "Gcolor": "50",
    "Bcolor": "62",
    "Y": 3,
    "L": 20.8900381479315,
    "a": 0.69952937305073,
    "b": -8.45766272009298,
    "C": 8.4865422894493,
    "h": -1.48827462046902,
    "CMY_C": 0.8256753,
    "CMY_M": 0.8020325,
    "CMY_Y": 0.7567587,
    "CMYK_C": 0.2833262,
    "CMYK_M": 0.1861272,
    "CMYK_Y": 0,
    "CMYK_K": 0.7567587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07848",
    "Farbtonhilfsbezeichnung": "U7.10.16",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "66",
    "Bcolor": "76",
    "Y": 5,
    "L": 27.903897496615,
    "a": 1.21639541162977,
    "b": -7.07795651322516,
    "C": 7.1817188889945,
    "h": -1.40060201694097,
    "CMY_C": 0.7559181,
    "CMY_M": 0.7421343,
    "CMY_Y": 0.701976,
    "CMYK_C": 0.180999,
    "CMYK_M": 0.1347485,
    "CMYK_Y": 0,
    "CMYK_K": 0.701976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07849",
    "Farbtonhilfsbezeichnung": "U5.14.12",
    "Farbtonklasse": "03",
    "Rcolor": "54",
    "Gcolor": "59",
    "Bcolor": "72",
    "Y": 4,
    "L": 24.9715237861127,
    "a": 1.08281791956802,
    "b": -9.06948464062273,
    "C": 9.13389546105216,
    "h": -1.45196746414679,
    "CMY_C": 0.790077,
    "CMY_M": 0.7672451,
    "CMY_Y": 0.7168232,
    "CMYK_C": 0.2586859,
    "CMYK_M": 0.1780579,
    "CMYK_Y": 0,
    "CMYK_K": 0.7168232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07850",
    "Farbtonhilfsbezeichnung": "U7.18.14",
    "Farbtonklasse": "03",
    "Rcolor": "55",
    "Gcolor": "62",
    "Bcolor": "80",
    "Y": 5,
    "L": 26.3433892352429,
    "a": 1.90695645053002,
    "b": -12.3132285413673,
    "C": 12.4600192622709,
    "h": -1.41714644413898,
    "CMY_C": 0.7853066,
    "CMY_M": 0.7557733,
    "CMY_Y": 0.6852046,
    "CMYK_C": 0.3179908,
    "CMYK_M": 0.2241733,
    "CMYK_Y": 0,
    "CMYK_K": 0.6852046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07851",
    "Farbtonhilfsbezeichnung": "U7.21.15",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "62",
    "Bcolor": "82",
    "Y": 5,
    "L": 26.1264904877955,
    "a": 2.16243367614743,
    "b": -13.7634280735967,
    "C": 13.93226728644,
    "h": -1.41495583076379,
    "CMY_C": 0.7917842,
    "CMY_M": 0.7577181,
    "CMY_Y": 0.6786169,
    "CMYK_C": 0.3521258,
    "CMYK_M": 0.2461275,
    "CMYK_Y": 0,
    "CMYK_K": 0.6786169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07852",
    "Farbtonhilfsbezeichnung": "U2.28.17",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "75",
    "Bcolor": "105",
    "Y": 5,
    "L": 31.6431121826172,
    "a": 1.30711436271667,
    "b": -20.1203727722168,
    "C": 20.1627864837646,
    "h": 273.716979980469,
    "CMY_C": 0.78216940164566,
    "CMY_M": 0.7044677734375,
    "CMY_Y": 0.58829653263092,
    "CMYK_C": 0.47090414166451,
    "CMYK_M": 0.282172113657,
    "CMYK_Y": 0,
    "CMYK_K": 0.58829653263092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07853",
    "Farbtonhilfsbezeichnung": "U4.28.21",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "75",
    "Bcolor": "109",
    "Y": 7,
    "L": 31.5136057410379,
    "a": 1.94044023093126,
    "b": -22.6947795488519,
    "C": 22.777583872325,
    "h": -1.48550215973953,
    "CMY_C": 0.7940541,
    "CMY_M": 0.7059301,
    "CMY_Y": 0.5737193,
    "CMYK_C": 0.5168773,
    "CMYK_M": 0.3101496,
    "CMYK_Y": 0,
    "CMYK_K": 0.5737193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07854",
    "Farbtonhilfsbezeichnung": "U2.32.18",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "73",
    "Bcolor": "108",
    "Y": 6,
    "L": 30.4658921956327,
    "a": 0.8060293602061,
    "b": -24.1679694023571,
    "C": 24.1814066663373,
    "h": -1.53745754281886,
    "CMY_C": 0.8273033,
    "CMY_M": 0.7126799,
    "CMY_Y": 0.5749572,
    "CMYK_C": 0.5936958,
    "CMYK_M": 0.3240209,
    "CMYK_Y": 0,
    "CMYK_K": 0.5749572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07855",
    "Farbtonhilfsbezeichnung": "U7.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "83",
    "Bcolor": "134",
    "Y": 9,
    "L": 35.1252201405935,
    "a": 4.86109543698188,
    "b": -33.0600318003884,
    "C": 33.4155046571219,
    "h": -1.42480402311613,
    "CMY_C": 0.8097789,
    "CMY_M": 0.6744432,
    "CMY_Y": 0.4730722,
    "CMYK_C": 0.6389996,
    "CMYK_M": 0.3821605,
    "CMYK_Y": 0,
    "CMYK_K": 0.4730722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07856",
    "Farbtonhilfsbezeichnung": "U4.39.30",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "90",
    "Bcolor": "146",
    "Y": 10,
    "L": 37.8398683663259,
    "a": 3.39031689124789,
    "b": -35.6157788178628,
    "C": 35.7767794725295,
    "h": -1.47589086712638,
    "CMY_C": 0.8264736,
    "CMY_M": 0.645114,
    "CMY_Y": 0.4291824,
    "CMYK_C": 0.6960038,
    "CMYK_M": 0.3782848,
    "CMYK_Y": 0,
    "CMYK_K": 0.4291824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07857",
    "Farbtonhilfsbezeichnung": "U6.35.24",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "80",
    "Bcolor": "127",
    "Y": 8,
    "L": 34.146847417619,
    "a": 4.65949347807712,
    "b": -29.9587466135959,
    "C": 30.3189277206481,
    "h": -1.41650218931457,
    "CMY_C": 0.7943037,
    "CMY_M": 0.6843877,
    "CMY_Y": 0.5024619,
    "CMYK_C": 0.5865718,
    "CMYK_M": 0.365652,
    "CMYK_Y": 0,
    "CMYK_K": 0.5024619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07858",
    "Farbtonhilfsbezeichnung": "U6.31.24",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "81",
    "Bcolor": "121",
    "Y": 8,
    "L": 34.3819098453942,
    "a": 3.23926500571339,
    "b": -25.6936102257853,
    "C": 25.8969968183923,
    "h": -1.4453851911726,
    "CMY_C": 0.7738538,
    "CMY_M": 0.6811143,
    "CMY_Y": 0.5268902,
    "CMYK_C": 0.5220006,
    "CMYK_M": 0.3259794,
    "CMYK_Y": 0,
    "CMYK_K": 0.5268902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07859",
    "Farbtonhilfsbezeichnung": "U6.27.18",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "83",
    "Bcolor": "108",
    "Y": 7,
    "L": 35.1520195007324,
    "a": 2.26567435264587,
    "b": -16.4552383422852,
    "C": 16.6104831695557,
    "h": 277.839599609375,
    "CMY_C": 0.72114264965057,
    "CMY_M": 0.67542779445648,
    "CMY_Y": 0.57687348127365,
    "CMYK_C": 0.34095987677574,
    "CMYK_M": 0.23291926085949,
    "CMYK_Y": 0,
    "CMYK_K": 0.57687348127365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07860",
    "Farbtonhilfsbezeichnung": "U6.16.15",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "65",
    "Bcolor": "84",
    "Y": 5,
    "L": 27.4808950554997,
    "a": 2.16921059689112,
    "b": -12.7249294093398,
    "C": 12.9084973210032,
    "h": -1.40195002668749,
    "CMY_C": 0.7749946,
    "CMY_M": 0.746076,
    "CMY_Y": 0.6722469,
    "CMYK_C": 0.3134911,
    "CMYK_M": 0.2252581,
    "CMYK_Y": 0,
    "CMYK_K": 0.6722469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07861",
    "Farbtonhilfsbezeichnung": "U4.12.22",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "70",
    "Bcolor": "85",
    "Y": 6,
    "L": 29.3530607271239,
    "a": 0.83973681353244,
    "b": -11.0427307892314,
    "C": 11.0746133656865,
    "h": -1.49489809440591,
    "CMY_C": 0.760947,
    "CMY_M": 0.727287,
    "CMY_Y": 0.6650446,
    "CMYK_C": 0.286314,
    "CMYK_M": 0.185823,
    "CMYK_Y": 0,
    "CMYK_K": 0.6650446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07862",
    "Farbtonhilfsbezeichnung": "U7.04.24",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "81",
    "Bcolor": "87",
    "Y": 8,
    "L": 34.6277906580129,
    "a": 0.68931117039294,
    "b": -4.12700901421147,
    "C": 4.18417892698331,
    "h": -1.40529961273471,
    "CMY_C": 0.6886806,
    "CMY_M": 0.6808204,
    "CMY_Y": 0.658001,
    "CMYK_C": 0.08970688,
    "CMYK_M": 0.06672355,
    "CMYK_Y": 0,
    "CMYK_K": 0.658001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07863",
    "Farbtonhilfsbezeichnung": "U6.04.34",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "103",
    "Bcolor": "110",
    "Y": 14,
    "L": 43.7593521135306,
    "a": 0.81846181996436,
    "b": -4.68787141394833,
    "C": 4.75878326302568,
    "h": -1.39794719042698,
    "CMY_C": 0.6036543,
    "CMY_M": 0.5946962,
    "CMY_Y": 0.5677344,
    "CMYK_C": 0.08309697,
    "CMYK_M": 0.06237316,
    "CMYK_Y": 0,
    "CMYK_K": 0.5677344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07864",
    "Farbtonhilfsbezeichnung": "U6.15.25",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "84",
    "Bcolor": "103",
    "Y": 9,
    "L": 35.7034914849932,
    "a": 1.94240960732436,
    "b": -12.6937464689927,
    "C": 12.8415012557602,
    "h": -1.41895318651577,
    "CMY_C": 0.7015259,
    "CMY_M": 0.6708949,
    "CMY_Y": 0.5948987,
    "CMYK_C": 0.2632113,
    "CMYK_M": 0.1875979,
    "CMYK_Y": 0,
    "CMYK_K": 0.5948987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07865",
    "Farbtonhilfsbezeichnung": "U6.18.27",
    "Farbtonklasse": "03",
    "Rcolor": "78",
    "Gcolor": "88",
    "Bcolor": "112",
    "Y": 10,
    "L": 37.3002768052078,
    "a": 2.72180567815658,
    "b": -15.6551832055646,
    "C": 15.8900279216066,
    "h": -1.3986572763681,
    "CMY_C": 0.6936016,
    "CMY_M": 0.6566444,
    "CMY_Y": 0.5609472,
    "CMYK_C": 0.3021376,
    "CMYK_M": 0.2179627,
    "CMYK_Y": 0,
    "CMYK_K": 0.5609472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07866",
    "Farbtonhilfsbezeichnung": "U5.24.33",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "103",
    "Bcolor": "137",
    "Y": 13,
    "L": 43.4006958007813,
    "a": 2.69723224639893,
    "b": -21.3899440765381,
    "C": 21.5593318939209,
    "h": 277.186950683594,
    "CMY_C": 0.66387784481049,
    "CMY_M": 0.59676003456116,
    "CMY_Y": 0.46392446756363,
    "CMYK_C": 0.37299478054047,
    "CMYK_M": 0.24779263138771,
    "CMYK_Y": 0,
    "CMYK_K": 0.46392446756363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07867",
    "Farbtonhilfsbezeichnung": "U6.29.30",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "93",
    "Bcolor": "134",
    "Y": 11,
    "L": 39.6282163990268,
    "a": 4.27597316190401,
    "b": -25.631298489134,
    "C": 25.9855230603582,
    "h": -1.4054923925304,
    "CMY_C": 0.7114747,
    "CMY_M": 0.6343802,
    "CMY_Y": 0.4747129,
    "CMYK_C": 0.4507283,
    "CMYK_M": 0.3039621,
    "CMYK_Y": 0,
    "CMYK_K": 0.4747129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07868",
    "Farbtonhilfsbezeichnung": "U6.38.34",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "102",
    "Bcolor": "160",
    "Y": 13,
    "L": 43.1238597391065,
    "a": 5.73899960964508,
    "b": -35.6400333310183,
    "C": 36.0991425432184,
    "h": -1.41114008012022,
    "CMY_C": 0.7346662,
    "CMY_M": 0.6000581,
    "CMY_Y": 0.374074,
    "CMYK_C": 0.5760939,
    "CMYK_M": 0.3610397,
    "CMYK_Y": 0,
    "CMYK_K": 0.374074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07869",
    "Farbtonhilfsbezeichnung": "U3.39.34",
    "Farbtonklasse": "04",
    "Rcolor": "55",
    "Gcolor": "103",
    "Bcolor": "163",
    "Y": 13,
    "L": 42.8544536556888,
    "a": 3.7337799409739,
    "b": -37.8559118828633,
    "C": 38.039600117913,
    "h": -1.47248294968963,
    "CMY_C": 0.7860965,
    "CMY_M": 0.597406,
    "CMY_Y": 0.3625442,
    "CMYK_C": 0.6644418,
    "CMYK_M": 0.3684363,
    "CMYK_Y": 0,
    "CMYK_K": 0.3625442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07870",
    "Farbtonhilfsbezeichnung": "U5.33.34",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "103",
    "Bcolor": "152",
    "Y": 14,
    "L": 43.5373736087,
    "a": 4.27844812383682,
    "b": -30.5028687643649,
    "C": 30.8014629718205,
    "h": -1.43144167091938,
    "CMY_C": 0.7049509,
    "CMY_M": 0.5952275,
    "CMY_Y": 0.4033733,
    "CMYK_C": 0.5054711,
    "CMYK_M": 0.3215649,
    "CMYK_Y": 0,
    "CMYK_K": 0.4033733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07871",
    "Farbtonhilfsbezeichnung": "U6.28.34",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "104",
    "Bcolor": "145",
    "Y": 14,
    "L": 43.7588429535626,
    "a": 3.7066165351925,
    "b": -25.7875268479225,
    "C": 26.0525535614321,
    "h": -1.42803731660168,
    "CMY_C": 0.6766702,
    "CMY_M": 0.5937933,
    "CMY_Y": 0.4317653,
    "CMYK_C": 0.4309925,
    "CMYK_M": 0.2851428,
    "CMYK_Y": 0,
    "CMYK_K": 0.4317653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07872",
    "Farbtonhilfsbezeichnung": "U6.19.35",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "101",
    "Bcolor": "130",
    "Y": 13,
    "L": 42.6132775016387,
    "a": 2.44993724793569,
    "b": -18.5452922889162,
    "C": 18.7064175779372,
    "h": -1.43945126117651,
    "CMY_C": 0.6588765,
    "CMY_M": 0.6048145,
    "CMY_Y": 0.4901646,
    "CMYK_C": 0.3309144,
    "CMYK_M": 0.2248763,
    "CMYK_Y": 0,
    "CMYK_K": 0.4901646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07873",
    "Farbtonhilfsbezeichnung": "U5.14.34",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "102",
    "Bcolor": "122",
    "Y": 13,
    "L": 43.0253134601846,
    "a": 1.67356978330802,
    "b": -13.2209783666329,
    "C": 13.3264813356931,
    "h": -1.4448816004403,
    "CMY_C": 0.6366445,
    "CMY_M": 0.6010165,
    "CMY_Y": 0.5202451,
    "CMYK_C": 0.2426227,
    "CMYK_M": 0.1683595,
    "CMYK_Y": 0,
    "CMYK_K": 0.5202451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07874",
    "Farbtonhilfsbezeichnung": "U6.09.34",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "102",
    "Bcolor": "116",
    "Y": 13,
    "L": 43.1322061217655,
    "a": 1.32817709509064,
    "b": -9.22500340800778,
    "C": 9.32012565761206,
    "h": -1.4278031762856,
    "CMY_C": 0.6221741,
    "CMY_M": 0.6004971,
    "CMY_Y": 0.5447806,
    "CMYK_C": 0.1700137,
    "CMYK_M": 0.1223949,
    "CMYK_Y": 0,
    "CMYK_K": 0.5447806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07875",
    "Farbtonhilfsbezeichnung": "U3.04.44",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "125",
    "Bcolor": "132",
    "Y": 20,
    "L": 52.3426296896559,
    "a": 0.16272694593061,
    "b": -5.03461669463763,
    "C": 5.03724580707114,
    "h": -1.53848595938133,
    "CMY_C": 0.5257773,
    "CMY_M": 0.5090663,
    "CMY_Y": 0.4809826,
    "CMYK_C": 0.08630675,
    "CMYK_M": 0.0541093,
    "CMYK_Y": 0,
    "CMYK_K": 0.4809826
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07877",
    "Farbtonhilfsbezeichnung": "V3.23.52",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "143",
    "Bcolor": "195",
    "Y": 29,
    "L": 60.6406086094649,
    "a": 9.97256285768638,
    "b": -28.4723481658733,
    "C": 30.1683048915449,
    "h": -1.23389496242684,
    "CMY_C": 0.4645049,
    "CMY_M": 0.4394986,
    "CMY_Y": 0.2356155,
    "CMYK_C": 0.2994427,
    "CMYK_M": 0.2667285,
    "CMYK_Y": 0,
    "CMYK_K": 0.2356155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07878",
    "Farbtonhilfsbezeichnung": "V3.13.69",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "189",
    "Bcolor": "221",
    "Y": 52,
    "L": 77.3429607952118,
    "a": 5.49919541918242,
    "b": -17.1863178451121,
    "C": 18.0446854040622,
    "h": -1.2611158825108,
    "CMY_C": 0.2722691,
    "CMY_M": 0.2579297,
    "CMY_Y": 0.1330457,
    "CMYK_C": 0.1605891,
    "CMYK_M": 0.1440491,
    "CMYK_Y": 0,
    "CMYK_K": 0.1330457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07879",
    "Farbtonhilfsbezeichnung": "V2.10.75",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "204",
    "Bcolor": "229",
    "Y": 61,
    "L": 82.4673538208008,
    "a": 4.45902442932129,
    "b": -13.7960577011108,
    "C": 14.4987621307373,
    "h": 287.911346435547,
    "CMY_C": 0.21108585596085,
    "CMY_M": 0.20108312368393,
    "CMY_Y": 0.10095244646072,
    "CMYK_C": 0.12250009179115,
    "CMYK_M": 0.11137416958809,
    "CMYK_Y": 0,
    "CMYK_K": 0.10095244646072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07880",
    "Farbtonhilfsbezeichnung": "U8.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "228",
    "Y": 65,
    "L": 84.7229253420374,
    "a": 2.02628578477165,
    "b": -9.74233322846842,
    "C": 9.95082362501153,
    "h": -1.36573218645681,
    "CMY_C": 0.1900912,
    "CMY_M": 0.1719587,
    "CMY_Y": 0.1057285,
    "CMYK_C": 0.09433675,
    "CMYK_M": 0.07406047,
    "CMYK_Y": 0,
    "CMYK_K": 0.1057285
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07881",
    "Farbtonhilfsbezeichnung": "V0.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "217",
    "Bcolor": "231",
    "Y": 71,
    "L": 86.9271240234375,
    "a": 2.22604322433472,
    "b": -7.89169120788574,
    "C": 8.1996374130249,
    "h": 285.752380371094,
    "CMY_C": 0.15710836648941,
    "CMY_M": 0.14873152971268,
    "CMY_Y": 0.09479755163193,
    "CMYK_C": 0.06883633136749,
    "CMYK_M": 0.05958222597837,
    "CMYK_Y": 0,
    "CMYK_K": 0.09479755163193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07882",
    "Farbtonhilfsbezeichnung": "U9.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "220",
    "Bcolor": "233",
    "Y": 72,
    "L": 87.8319712526288,
    "a": 1.99294963454638,
    "b": -7.87549107026677,
    "C": 8.12374346244945,
    "h": -1.32294238526718,
    "CMY_C": 0.1489645,
    "CMY_M": 0.1382133,
    "CMY_Y": 0.08489535,
    "CMYK_C": 0.07001291,
    "CMYK_M": 0.05826432,
    "CMYK_Y": 0,
    "CMYK_K": 0.08489535
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07883",
    "Farbtonhilfsbezeichnung": "U5.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "218",
    "Bcolor": "230",
    "Y": 70,
    "L": 87.0110026278967,
    "a": 0.88545539406409,
    "b": -7.5453187820401,
    "C": 7.59709594368034,
    "h": -1.45397899622613,
    "CMY_C": 0.1657513,
    "CMY_M": 0.1447614,
    "CMY_Y": 0.09657554,
    "CMYK_C": 0.0765706,
    "CMYK_M": 0.05333691,
    "CMYK_Y": 0,
    "CMYK_K": 0.09657554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07884",
    "Farbtonhilfsbezeichnung": "U9.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "216",
    "Bcolor": "232",
    "Y": 69,
    "L": 86.4501053188823,
    "a": 2.31695623496264,
    "b": -9.14439621052521,
    "C": 9.43335933004781,
    "h": -1.3226442539407,
    "CMY_C": 0.1664409,
    "CMY_M": 0.1538422,
    "CMY_Y": 0.09090677,
    "CMYK_C": 0.08308733,
    "CMYK_M": 0.06922883,
    "CMYK_Y": 0,
    "CMYK_K": 0.09090677
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07885",
    "Farbtonhilfsbezeichnung": "V1.08.74",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "202",
    "Bcolor": "223",
    "Y": 60,
    "L": 81.8029005448614,
    "a": 3.40251143219006,
    "b": -11.2117780502731,
    "C": 11.7166996673453,
    "h": -1.27615312030947,
    "CMY_C": 0.2165786,
    "CMY_M": 0.2066733,
    "CMY_Y": 0.1271496,
    "CMYK_C": 0.1024562,
    "CMYK_M": 0.09110806,
    "CMYK_Y": 0,
    "CMYK_K": 0.1271496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07886",
    "Farbtonhilfsbezeichnung": "V3.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "199",
    "Bcolor": "221",
    "Y": 58,
    "L": 80.8440371983471,
    "a": 4.11455452323684,
    "b": -11.9341520995377,
    "C": 12.6235314100131,
    "h": -1.23878706074075,
    "CMY_C": 0.2241141,
    "CMY_M": 0.2185594,
    "CMY_Y": 0.1324079,
    "CMYK_C": 0.105702,
    "CMYK_M": 0.09929952,
    "CMYK_Y": 0,
    "CMYK_K": 0.1324079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07887",
    "Farbtonhilfsbezeichnung": "V3.15.64",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "172",
    "Bcolor": "210",
    "Y": 42,
    "L": 71.12011910668,
    "a": 7.20675881832789,
    "b": -20.3844448160216,
    "C": 21.620891820713,
    "h": -1.23096948002713,
    "CMY_C": 0.3387851,
    "CMY_M": 0.3271811,
    "CMY_Y": 0.1783909,
    "CMYK_C": 0.1952196,
    "CMYK_M": 0.1810961,
    "CMYK_Y": 0,
    "CMYK_K": 0.1783909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07888",
    "Farbtonhilfsbezeichnung": "V2.27.52",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "142",
    "Bcolor": "200",
    "Y": 29,
    "L": 60.4080627492498,
    "a": 10.6964317124414,
    "b": -31.8759874643497,
    "C": 33.6227932838172,
    "h": -1.24703957816038,
    "CMY_C": 0.4787985,
    "CMY_M": 0.4421985,
    "CMY_Y": 0.214665,
    "CMYK_C": 0.3363324,
    "CMYK_M": 0.2897281,
    "CMYK_Y": 0,
    "CMYK_K": 0.214665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07889",
    "Farbtonhilfsbezeichnung": "V0.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "137",
    "Bcolor": "197",
    "Y": 26,
    "L": 57.8752937316895,
    "a": 9.27755260467529,
    "b": -33.8929061889648,
    "C": 35.1397514343262,
    "h": 285.308654785156,
    "CMY_C": 0.52980005741119,
    "CMY_M": 0.46365839242935,
    "CMY_Y": 0.22842741012573,
    "CMYK_C": 0.3905953168869,
    "CMYK_M": 0.30487212538719,
    "CMYK_Y": 0,
    "CMYK_K": 0.22842741012573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07890",
    "Farbtonhilfsbezeichnung": "V3.18.62",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "169",
    "Bcolor": "212",
    "Y": 41,
    "L": 70.3113531328284,
    "a": 7.67875914693311,
    "b": -23.0138990364461,
    "C": 24.261139521802,
    "h": -1.24875408482482,
    "CMY_C": 0.3553792,
    "CMY_M": 0.3358743,
    "CMY_Y": 0.1686521,
    "CMYK_C": 0.2246077,
    "CMYK_M": 0.2011459,
    "CMYK_Y": 0,
    "CMYK_K": 0.1686521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07891",
    "Farbtonhilfsbezeichnung": "V2.14.62",
    "Farbtonklasse": "02",
    "Rcolor": "165",
    "Gcolor": "169",
    "Bcolor": "203",
    "Y": 41,
    "L": 69.8629118249331,
    "a": 5.95425571202218,
    "b": -18.5198515899638,
    "C": 19.4534846235432,
    "h": -1.25972726747534,
    "CMY_C": 0.3541605,
    "CMY_M": 0.3381239,
    "CMY_Y": 0.2053281,
    "CMYK_C": 0.1872879,
    "CMYK_M": 0.1671076,
    "CMYK_Y": 0,
    "CMYK_K": 0.2053281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07892",
    "Farbtonhilfsbezeichnung": "V3.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "197",
    "Bcolor": "213",
    "Y": 57,
    "L": 79.9567515218689,
    "a": 3.12176757596738,
    "b": -8.70368995879718,
    "C": 9.2466021703774,
    "h": -1.22641711588447,
    "CMY_C": 0.2292204,
    "CMY_M": 0.2268585,
    "CMY_Y": 0.165556,
    "CMYK_C": 0.07629564,
    "CMYK_M": 0.07346503,
    "CMYK_Y": 0,
    "CMYK_K": 0.165556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07893",
    "Farbtonhilfsbezeichnung": "V0.05.76",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "209",
    "Bcolor": "222",
    "Y": 64,
    "L": 84.1564959911252,
    "a": 1.91566752138539,
    "b": -7.55950336114883,
    "C": 7.7984532517488,
    "h": -1.32260912370407,
    "CMY_C": 0.1887892,
    "CMY_M": 0.1785937,
    "CMY_Y": 0.1279005,
    "CMYK_C": 0.06981859,
    "CMYK_M": 0.05812777,
    "CMYK_Y": 0,
    "CMYK_K": 0.1279005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07896",
    "Farbtonhilfsbezeichnung": "VN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "220",
    "Bcolor": "220",
    "Y": 71,
    "L": 87.6462904465388,
    "a": 0.62794838338786,
    "b": -1.05401533029528,
    "C": 1.22689343004879,
    "h": -1.03349455723173,
    "CMY_C": 0.1371309,
    "CMY_M": 0.1390776,
    "CMY_Y": 0.1372157,
    "CMYK_C": 0,
    "CMYK_M": 0.002256114,
    "CMYK_Y": 9.833899e-05,
    "CMYK_K": 0.1371309
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07897",
    "Farbtonhilfsbezeichnung": "U8.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "211",
    "Bcolor": "220",
    "Y": 65,
    "L": 84.5459100973002,
    "a": 0.77224155265115,
    "b": -5.72041116077513,
    "C": 5.77230117578438,
    "h": -1.43660999452642,
    "CMY_C": 0.1868204,
    "CMY_M": 0.1721935,
    "CMY_Y": 0.1371521,
    "CMYK_C": 0.05756327,
    "CMYK_M": 0.04061136,
    "CMYK_Y": 0,
    "CMYK_K": 0.1371521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07898",
    "Farbtonhilfsbezeichnung": "V3.33.43",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "116",
    "Bcolor": "183",
    "Y": 19,
    "L": 50.6935218377076,
    "a": 14.1959090097062,
    "b": -37.0499162841155,
    "C": 39.676443001759,
    "h": -1.20489416819897,
    "CMY_C": 0.5796473,
    "CMY_M": 0.5455131,
    "CMY_Y": 0.2840112,
    "CMYK_C": 0.412906,
    "CMYK_M": 0.3652318,
    "CMYK_Y": 0,
    "CMYK_K": 0.2840112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07899",
    "Farbtonhilfsbezeichnung": "U8.20.59",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "165",
    "Bcolor": "207",
    "Y": 38,
    "L": 67.7483087811513,
    "a": 4.49484329453864,
    "b": -24.2301900641531,
    "C": 24.6435737422039,
    "h": -1.38737544313989,
    "CMY_C": 0.4154555,
    "CMY_M": 0.3548619,
    "CMY_Y": 0.1884328,
    "CMYK_C": 0.2797337,
    "CMYK_M": 0.2050713,
    "CMYK_Y": 0,
    "CMYK_K": 0.1884328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07900",
    "Farbtonhilfsbezeichnung": "V0.13.67",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "182",
    "Bcolor": "212",
    "Y": 48,
    "L": 74.3286590576172,
    "a": 3.84590530395508,
    "b": -17.0860366821289,
    "C": 17.5135269165039,
    "h": 282.685333251953,
    "CMY_C": 0.31776982545853,
    "CMY_M": 0.28632640838623,
    "CMY_Y": 0.16704046726227,
    "CMYK_C": 0.1809563934803,
    "CMYK_M": 0.14320737123489,
    "CMYK_Y": 0,
    "CMYK_K": 0.16704046726227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07901",
    "Farbtonhilfsbezeichnung": "V0.08.69",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "189",
    "Bcolor": "210",
    "Y": 51,
    "L": 76.9108724608578,
    "a": 3.07097525342559,
    "b": -11.5979288506182,
    "C": 11.9976182065922,
    "h": -1.31195007619298,
    "CMY_C": 0.2736751,
    "CMY_M": 0.2586972,
    "CMY_Y": 0.178047,
    "CMYK_C": 0.1163425,
    "CMYK_M": 0.09812017,
    "CMYK_Y": 0,
    "CMYK_K": 0.178047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07902",
    "Farbtonhilfsbezeichnung": "U9.04.74",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "210",
    "Y": 58,
    "L": 80.9275912604381,
    "a": 1.10316837945224,
    "b": -5.62728118325933,
    "C": 5.73439395131584,
    "h": -1.37721199707104,
    "CMY_C": 0.2232616,
    "CMY_M": 0.2125259,
    "CMY_Y": 0.1773933,
    "CMYK_C": 0.05575971,
    "CMYK_M": 0.04270883,
    "CMYK_Y": 0,
    "CMYK_K": 0.1773933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07903",
    "Farbtonhilfsbezeichnung": "V0.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "214",
    "Bcolor": "220",
    "Y": 67,
    "L": 85.5138310192717,
    "a": 1.05244891266076,
    "b": -4.32446588159687,
    "C": 4.45069139290248,
    "h": -1.33206653483947,
    "CMY_C": 0.1688489,
    "CMY_M": 0.1626367,
    "CMY_Y": 0.1366562,
    "CMYK_C": 0.03728838,
    "CMYK_M": 0.03009287,
    "CMYK_Y": 0,
    "CMYK_K": 0.1366562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07904",
    "Farbtonhilfsbezeichnung": "VN.01.73",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "198",
    "Bcolor": "203",
    "Y": 57,
    "L": 80.0773535391861,
    "a": 1.00222683964535,
    "b": -3.12779310457958,
    "C": 3.28444033941265,
    "h": -1.260706824644,
    "CMY_C": 0.2243019,
    "CMY_M": 0.2222656,
    "CMY_Y": 0.2046662,
    "CMYK_C": 0.02468864,
    "CMYK_M": 0.02212841,
    "CMYK_Y": 0,
    "CMYK_K": 0.2046662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07905",
    "Farbtonhilfsbezeichnung": "V0.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "196",
    "Bcolor": "210",
    "Y": 55,
    "L": 79.1862819750373,
    "a": 2.15563906901722,
    "b": -8.61646746635862,
    "C": 8.88202068195577,
    "h": -1.32565140045739,
    "CMY_C": 0.2449145,
    "CMY_M": 0.2329573,
    "CMY_Y": 0.1747139,
    "CMYK_C": 0.08506222,
    "CMYK_M": 0.07057361,
    "CMYK_Y": 0,
    "CMYK_K": 0.1747139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07906",
    "Farbtonhilfsbezeichnung": "V2.09.64",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "176",
    "Bcolor": "198",
    "Y": 44,
    "L": 72.3212555574054,
    "a": 3.65623299140483,
    "b": -12.1565287718501,
    "C": 12.6944567220601,
    "h": -1.27863976023838,
    "CMY_C": 0.3202188,
    "CMY_M": 0.308906,
    "CMY_Y": 0.223787,
    "CMYK_C": 0.1242337,
    "CMYK_M": 0.1096594,
    "CMYK_Y": 0,
    "CMYK_K": 0.223787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07907",
    "Farbtonhilfsbezeichnung": "V0.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "162",
    "Bcolor": "184",
    "Y": 37,
    "L": 66.9981095663965,
    "a": 3.59908583744528,
    "b": -12.6223681804611,
    "C": 13.1254560815393,
    "h": -1.29303181119702,
    "CMY_C": 0.3785925,
    "CMY_M": 0.3646752,
    "CMY_Y": 0.2775808,
    "CMYK_C": 0.1398242,
    "CMYK_M": 0.1205593,
    "CMYK_Y": 0,
    "CMYK_K": 0.2775808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07908",
    "Farbtonhilfsbezeichnung": "V3.19.53",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "144",
    "Bcolor": "185",
    "Y": 29,
    "L": 60.8624222743893,
    "a": 8.23078690843454,
    "b": -22.6573163071228,
    "C": 24.1060124320276,
    "h": -1.22234645759992,
    "CMY_C": 0.4483506,
    "CMY_M": 0.43536,
    "CMY_Y": 0.2732897,
    "CMYK_C": 0.2408951,
    "CMYK_M": 0.2230192,
    "CMYK_Y": 0,
    "CMYK_K": 0.2732897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07909",
    "Farbtonhilfsbezeichnung": "U9.25.54",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "150",
    "Bcolor": "202",
    "Y": 31,
    "L": 62.3905591514666,
    "a": 6.69064575558864,
    "b": -29.8982623249406,
    "C": 30.6377354038731,
    "h": -1.35064299923118,
    "CMY_C": 0.4825797,
    "CMY_M": 0.4133047,
    "CMY_Y": 0.2071193,
    "CMYK_C": 0.3474171,
    "CMYK_M": 0.2600459,
    "CMYK_Y": 0,
    "CMYK_K": 0.2071193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07910",
    "Farbtonhilfsbezeichnung": "V0.36.43",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "120",
    "Bcolor": "183",
    "Y": 19,
    "L": 51.1910488608465,
    "a": 8.89619357200638,
    "b": -36.7379947406721,
    "C": 37.799768751095,
    "h": -1.33321716913871,
    "CMY_C": 0.6227143,
    "CMY_M": 0.5282441,
    "CMY_Y": 0.2811872,
    "CMYK_C": 0.4751266,
    "CMYK_M": 0.3437013,
    "CMYK_Y": 0,
    "CMYK_K": 0.2811872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07911",
    "Farbtonhilfsbezeichnung": "V0.37.43",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "121",
    "Bcolor": "191",
    "Y": 20,
    "L": 51.7664975670203,
    "a": 10.3500069710064,
    "b": -40.1465265750102,
    "C": 41.459211766963,
    "h": -1.31848463838353,
    "CMY_C": 0.6268862,
    "CMY_M": 0.5243396,
    "CMY_Y": 0.2519317,
    "CMYK_C": 0.5012303,
    "CMYK_M": 0.3641485,
    "CMYK_Y": 0,
    "CMYK_K": 0.2519317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07912",
    "Farbtonhilfsbezeichnung": "V0.44.40",
    "Farbtonklasse": "04",
    "Rcolor": "85",
    "Gcolor": "116",
    "Bcolor": "195",
    "Y": 18,
    "L": 50.0099797116797,
    "a": 12.585979427386,
    "b": -45.3887531580629,
    "C": 47.1014415001298,
    "h": -1.30029966819537,
    "CMY_C": 0.6653873,
    "CMY_M": 0.5442283,
    "CMY_Y": 0.2354195,
    "CMYK_C": 0.5623577,
    "CMYK_M": 0.4038931,
    "CMYK_Y": 0,
    "CMYK_K": 0.2354195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07913",
    "Farbtonhilfsbezeichnung": "U9.35.41",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "118",
    "Bcolor": "179",
    "Y": 19,
    "L": 50.2207363956313,
    "a": 8.28577094696142,
    "b": -35.5356232428261,
    "C": 36.4888273234643,
    "h": -1.34172117595276,
    "CMY_C": 0.6305606,
    "CMY_M": 0.5369428,
    "CMY_Y": 0.299663,
    "CMYK_C": 0.4724834,
    "CMYK_M": 0.338808,
    "CMYK_Y": 0,
    "CMYK_K": 0.299663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07914",
    "Farbtonhilfsbezeichnung": "U9.31.41",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "117",
    "Bcolor": "170",
    "Y": 18,
    "L": 49.8365463976646,
    "a": 7.34777361534933,
    "b": -31.0651390141562,
    "C": 31.9222906300797,
    "h": -1.33853687590354,
    "CMY_C": 0.6138922,
    "CMY_M": 0.5405363,
    "CMY_Y": 0.333637,
    "CMYK_C": 0.4205744,
    "CMYK_M": 0.3104905,
    "CMYK_Y": 0,
    "CMYK_K": 0.333637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07915",
    "Farbtonhilfsbezeichnung": "V0.18.52",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "144",
    "Bcolor": "182",
    "Y": 28,
    "L": 60.1446940159948,
    "a": 5.34890827632073,
    "b": -22.108186147003,
    "C": 22.7460483262264,
    "h": -1.33341551792448,
    "CMY_C": 0.4769139,
    "CMY_M": 0.436222,
    "CMY_Y": 0.2849825,
    "CMYK_C": 0.2684289,
    "CMYK_M": 0.2115186,
    "CMYK_Y": 0,
    "CMYK_K": 0.2849825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07916",
    "Farbtonhilfsbezeichnung": "V3.10.56",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "154",
    "Bcolor": "174",
    "Y": 33,
    "L": 63.9635066499557,
    "a": 3.81068344507091,
    "b": -11.7444632687301,
    "C": 12.347215305043,
    "h": -1.25704714726451,
    "CMY_C": 0.4050606,
    "CMY_M": 0.3969934,
    "CMY_Y": 0.3157768,
    "CMYK_C": 0.1304892,
    "CMYK_M": 0.1186989,
    "CMYK_Y": 0,
    "CMYK_K": 0.3157768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07917",
    "Farbtonhilfsbezeichnung": "V3.07.63",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "172",
    "Bcolor": "188",
    "Y": 42,
    "L": 70.5501853533119,
    "a": 2.87446039124956,
    "b": -9.38945142194243,
    "C": 9.81958861388191,
    "h": -1.27371862510221,
    "CMY_C": 0.3344179,
    "CMY_M": 0.3267222,
    "CMY_Y": 0.2623676,
    "CMYK_C": 0.09767784,
    "CMYK_M": 0.08724485,
    "CMYK_Y": 0,
    "CMYK_K": 0.2623676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07918",
    "Farbtonhilfsbezeichnung": "V0.05.64",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "176",
    "Bcolor": "188",
    "Y": 44,
    "L": 72.1592287688888,
    "a": 1.84203376119813,
    "b": -6.75787278241249,
    "C": 7.00442238308522,
    "h": -1.30468510651299,
    "CMY_C": 0.3156528,
    "CMY_M": 0.3081181,
    "CMY_Y": 0.2638209,
    "CMYK_C": 0.07040669,
    "CMYK_M": 0.06017183,
    "CMYK_Y": 0,
    "CMYK_K": 0.2638209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07919",
    "Farbtonhilfsbezeichnung": "U8.04.69",
    "Farbtonklasse": "02",
    "Rcolor": "186",
    "Gcolor": "189",
    "Bcolor": "197",
    "Y": 51,
    "L": 76.5137838523242,
    "a": 1.12968183261958,
    "b": -5.30221937331632,
    "C": 5.42122784300029,
    "h": -1.36087681841644,
    "CMY_C": 0.2694818,
    "CMY_M": 0.2604019,
    "CMY_Y": 0.2275417,
    "CMYK_C": 0.05429429,
    "CMYK_M": 0.04253977,
    "CMYK_Y": 0,
    "CMYK_K": 0.2275417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07920",
    "Farbtonhilfsbezeichnung": "V0.05.60",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "165",
    "Bcolor": "175",
    "Y": 38,
    "L": 68.1796052730206,
    "a": 3.48761917292928,
    "b": -5.45721003919122,
    "C": 6.47646731692775,
    "h": -1.00213277354736,
    "CMY_C": 0.3404889,
    "CMY_M": 0.3542695,
    "CMY_Y": 0.3149364,
    "CMYK_C": 0.03729945,
    "CMYK_M": 0.05741525,
    "CMYK_Y": 0,
    "CMYK_K": 0.3149364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07921",
    "Farbtonhilfsbezeichnung": "V2.11.47",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "129",
    "Bcolor": "152",
    "Y": 23,
    "L": 54.5909168166498,
    "a": 4.16971543878208,
    "b": -12.8728861602913,
    "C": 13.531360793957,
    "h": -1.25754647128149,
    "CMY_C": 0.5024152,
    "CMY_M": 0.4929422,
    "CMY_Y": 0.4056346,
    "CMYK_C": 0.1628301,
    "CMYK_M": 0.146892,
    "CMYK_Y": 0,
    "CMYK_K": 0.4056346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07922",
    "Farbtonhilfsbezeichnung": "V2.20.44",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "124",
    "Bcolor": "162",
    "Y": 21,
    "L": 53.1030232860906,
    "a": 7.28474507327132,
    "b": -21.4141891364359,
    "C": 22.6193502814205,
    "h": -1.24289370941018,
    "CMY_C": 0.5295838,
    "CMY_M": 0.5118942,
    "CMY_Y": 0.3636989,
    "CMYK_C": 0.2607018,
    "CMYK_M": 0.2329012,
    "CMYK_Y": 0,
    "CMYK_K": 0.3636989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07923",
    "Farbtonhilfsbezeichnung": "U9.25.45",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "127",
    "Bcolor": "173",
    "Y": 21,
    "L": 53.5675773620605,
    "a": 6.54927015304565,
    "b": -26.9904441833496,
    "C": 27.7736740112305,
    "h": 283.639282226563,
    "CMY_C": 0.55907726287842,
    "CMY_M": 0.50346148014069,
    "CMY_Y": 0.32155507802963,
    "CMYK_C": 0.35009795427322,
    "CMYK_M": 0.2681225836277,
    "CMYK_Y": 0,
    "CMYK_K": 0.32155507802963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07924",
    "Farbtonhilfsbezeichnung": "U9.34.38",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "108",
    "Bcolor": "166",
    "Y": 15,
    "L": 46.2628190062256,
    "a": 8.75199341493044,
    "b": -34.6303823917684,
    "C": 35.7191933466461,
    "h": -1.32325379181279,
    "CMY_C": 0.6610872,
    "CMY_M": 0.5769684,
    "CMY_Y": 0.3475618,
    "CMYK_C": 0.4805442,
    "CMYK_M": 0.3516142,
    "CMYK_Y": 0,
    "CMYK_K": 0.3475618
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07925",
    "Farbtonhilfsbezeichnung": "V1.37.34",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "99",
    "Bcolor": "158",
    "Y": 13,
    "L": 42.806636171484,
    "a": 9.45597334664811,
    "b": -34.8460575857784,
    "C": 36.1062759254386,
    "h": -1.30581340069099,
    "CMY_C": 0.6917222,
    "CMY_M": 0.6116049,
    "CMY_Y": 0.3823013,
    "CMYK_C": 0.5009253,
    "CMYK_M": 0.3712224,
    "CMYK_Y": 0,
    "CMYK_K": 0.3823013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07926",
    "Farbtonhilfsbezeichnung": "U8.40.39",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "110",
    "Bcolor": "180",
    "Y": 16,
    "L": 46.9525575209982,
    "a": 8.65370309101915,
    "b": -41.3963067277626,
    "C": 42.2911431376183,
    "h": -1.36471869014678,
    "CMY_C": 0.7098486,
    "CMY_M": 0.5669134,
    "CMY_Y": 0.2954185,
    "CMYK_C": 0.5881932,
    "CMYK_M": 0.3853278,
    "CMYK_Y": 0,
    "CMYK_K": 0.2954185
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07928",
    "Farbtonhilfsbezeichnung": "V3.36.33",
    "Farbtonklasse": "04",
    "Rcolor": "86",
    "Gcolor": "97",
    "Bcolor": "158",
    "Y": 13,
    "L": 42.7433106856785,
    "a": 12.5277372446624,
    "b": -35.0659386606128,
    "C": 37.2365983223651,
    "h": -1.22766647567176,
    "CMY_C": 0.6645077,
    "CMY_M": 0.6191923,
    "CMY_Y": 0.3813051,
    "CMYK_C": 0.4577419,
    "CMYK_M": 0.3844984,
    "CMYK_Y": 0,
    "CMYK_K": 0.3813051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07929",
    "Farbtonhilfsbezeichnung": "U9.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "94",
    "Bcolor": "139",
    "Y": 12,
    "L": 40.4907353077979,
    "a": 6.37252270566294,
    "b": -27.1690783381661,
    "C": 27.906412585275,
    "h": -1.34041032182637,
    "CMY_C": 0.6932296,
    "CMY_M": 0.6300814,
    "CMY_Y": 0.4559843,
    "CMYK_C": 0.4361002,
    "CMYK_M": 0.3200223,
    "CMYK_Y": 0,
    "CMYK_K": 0.4559843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07930",
    "Farbtonhilfsbezeichnung": "V1.24.36",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "103",
    "Bcolor": "143",
    "Y": 14,
    "L": 44.138323540895,
    "a": 6.59139732040831,
    "b": -23.8763796245394,
    "C": 24.7694978271786,
    "h": -1.30144164215852,
    "CMY_C": 0.6366837,
    "CMY_M": 0.5971043,
    "CMY_Y": 0.4400366,
    "CMYK_C": 0.3511785,
    "CMYK_M": 0.2804964,
    "CMYK_Y": 0,
    "CMYK_K": 0.4400366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07931",
    "Farbtonhilfsbezeichnung": "U8.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "115",
    "Bcolor": "148",
    "Y": 17,
    "L": 48.7113333522006,
    "a": 3.86773392717438,
    "b": -20.1683823664104,
    "C": 20.5358957196698,
    "h": -1.38132453900654,
    "CMY_C": 0.595401,
    "CMY_M": 0.5481318,
    "CMY_Y": 0.4176863,
    "CMYK_C": 0.3051873,
    "CMYK_M": 0.2240125,
    "CMYK_Y": 0,
    "CMYK_K": 0.4176863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07932",
    "Farbtonhilfsbezeichnung": "V0.20.39",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "112",
    "Bcolor": "147",
    "Y": 16,
    "L": 47.6058446844969,
    "a": 5.46118141628937,
    "b": -21.2081172307713,
    "C": 21.8999712085602,
    "h": -1.31876735742798,
    "CMY_C": 0.5983019,
    "CMY_M": 0.5620468,
    "CMY_Y": 0.4220572,
    "CMYK_C": 0.3049518,
    "CMYK_M": 0.2422204,
    "CMYK_Y": 0,
    "CMYK_K": 0.4220572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07933",
    "Farbtonhilfsbezeichnung": "V0.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "113",
    "Bcolor": "130",
    "Y": 17,
    "L": 47.8514267988007,
    "a": 2.67491728389391,
    "b": -10.4818713590603,
    "C": 10.8178005927066,
    "h": -1.32093460732676,
    "CMY_C": 0.5712642,
    "CMY_M": 0.5571919,
    "CMY_Y": 0.4898641,
    "CMYK_C": 0.1595655,
    "CMYK_M": 0.1319801,
    "CMYK_Y": 0,
    "CMYK_K": 0.4898641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07934",
    "Farbtonhilfsbezeichnung": "VN.02.62",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "170",
    "Bcolor": "175",
    "Y": 40,
    "L": 69.7552356218114,
    "a": 1.58038010884654,
    "b": -3.41865120928273,
    "C": 3.76626836260616,
    "h": -1.13777595390313,
    "CMY_C": 0.3312635,
    "CMY_M": 0.3339303,
    "CMY_Y": 0.3128093,
    "CMYK_C": 0.02685465,
    "CMYK_M": 0.0307354,
    "CMYK_Y": 0,
    "CMYK_K": 0.3128093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07935",
    "Farbtonhilfsbezeichnung": "U7.10.40",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "118",
    "Bcolor": "134",
    "Y": 18,
    "L": 49.4818586271947,
    "a": 1.61347279340751,
    "b": -10.4223797591458,
    "C": 10.5465299648234,
    "h": -1.41720705644478,
    "CMY_C": 0.5630398,
    "CMY_M": 0.5389335,
    "CMY_Y": 0.47403,
    "CMYK_C": 0.1692297,
    "CMYK_M": 0.1233977,
    "CMYK_Y": 0,
    "CMYK_K": 0.47403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07936",
    "Farbtonhilfsbezeichnung": "V3.14.37",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "107",
    "Bcolor": "130",
    "Y": 15,
    "L": 45.7051572287143,
    "a": 5.02990176612605,
    "b": -13.8918874100281,
    "C": 14.7744525309663,
    "h": -1.22340524313615,
    "CMY_C": 0.5879924,
    "CMY_M": 0.5821078,
    "CMY_Y": 0.488952,
    "CMYK_C": 0.1937986,
    "CMYK_M": 0.1822839,
    "CMYK_Y": 0,
    "CMYK_K": 0.488952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07937",
    "Farbtonhilfsbezeichnung": "V3.19.33",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "97",
    "Bcolor": "128",
    "Y": 13,
    "L": 42.13443032691,
    "a": 6.80833280180676,
    "b": -18.1177142954956,
    "C": 19.3547143309676,
    "h": -1.21133918517689,
    "CMY_C": 0.6269378,
    "CMY_M": 0.6188829,
    "CMY_Y": 0.4973056,
    "CMYK_C": 0.2578749,
    "CMYK_M": 0.2418513,
    "CMYK_Y": 0,
    "CMYK_K": 0.4973056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07938",
    "Farbtonhilfsbezeichnung": "U8.28.36",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "107",
    "Bcolor": "150",
    "Y": 15,
    "L": 45.4408879060887,
    "a": 4.33416711960033,
    "b": -26.2379682441306,
    "C": 26.5935327138128,
    "h": -1.40708782321088,
    "CMY_C": 0.6567771,
    "CMY_M": 0.5787321,
    "CMY_Y": 0.4115163,
    "CMYK_C": 0.4167675,
    "CMYK_M": 0.2841468,
    "CMYK_Y": 0,
    "CMYK_K": 0.4115163
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07939",
    "Farbtonhilfsbezeichnung": "U7.29.35",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "103",
    "Bcolor": "149",
    "Y": 14,
    "L": 43.7379790851215,
    "a": 4.98227736274992,
    "b": -28.2577453066632,
    "C": 28.6936100471101,
    "h": -1.39627457491888,
    "CMY_C": 0.68047,
    "CMY_M": 0.5957222,
    "CMY_Y": 0.4158482,
    "CMYK_C": 0.4530018,
    "CMYK_M": 0.3079234,
    "CMYK_Y": 0,
    "CMYK_K": 0.4158482
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07940",
    "Farbtonhilfsbezeichnung": "V2.36.29",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "88",
    "Bcolor": "143",
    "Y": 10,
    "L": 38.325364553817,
    "a": 9.99734936400934,
    "b": -33.3127188607643,
    "C": 34.7805151227289,
    "h": -1.27924221701639,
    "CMY_C": 0.7217135,
    "CMY_M": 0.6557349,
    "CMY_Y": 0.4384956,
    "CMYK_C": 0.5043912,
    "CMYK_M": 0.3868879,
    "CMYK_Y": 0,
    "CMYK_K": 0.4384956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07942",
    "Farbtonhilfsbezeichnung": "V2.43.30",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "89",
    "Bcolor": "159",
    "Y": 11,
    "L": 39.0181097458965,
    "a": 13.1298580099039,
    "b": -42.0091120514739,
    "C": 44.0131646977757,
    "h": -1.26786785837186,
    "CMY_C": 0.7525787,
    "CMY_M": 0.6521627,
    "CMY_Y": 0.3751232,
    "CMYK_C": 0.6040478,
    "CMYK_M": 0.4433506,
    "CMYK_Y": 0,
    "CMYK_K": 0.3751232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07943",
    "Farbtonhilfsbezeichnung": "V0.44.27",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "89",
    "Bcolor": "147",
    "Y": 10,
    "L": 38.155612318469,
    "a": 8.05618284746168,
    "b": -35.7811659270032,
    "C": 36.6768853253309,
    "h": -1.34933769809645,
    "CMY_C": 0.7634968,
    "CMY_M": 0.6518688,
    "CMY_Y": 0.4245659,
    "CMYK_C": 0.5890003,
    "CMYK_M": 0.3950112,
    "CMYK_Y": 0,
    "CMYK_K": 0.4245659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07944",
    "Farbtonhilfsbezeichnung": "V1.39.26",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "81",
    "Bcolor": "139",
    "Y": 9,
    "L": 35.3993515778687,
    "a": 10.753261994061,
    "b": -35.2346558955377,
    "C": 36.839023054227,
    "h": -1.27458496053586,
    "CMY_C": 0.7590289,
    "CMY_M": 0.6835807,
    "CMY_Y": 0.4561373,
    "CMYK_C": 0.5569265,
    "CMYK_M": 0.4182001,
    "CMYK_Y": 0,
    "CMYK_K": 0.4561373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07945",
    "Farbtonhilfsbezeichnung": "V1.35.21",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "72",
    "Bcolor": "118",
    "Y": 7,
    "L": 31.4268458645398,
    "a": 7.69131359787395,
    "b": -28.8268763075578,
    "C": 29.8352996048653,
    "h": -1.3100596453645,
    "CMY_C": 0.7818202,
    "CMY_M": 0.7159483,
    "CMY_Y": 0.5363992,
    "CMYK_C": 0.5293802,
    "CMYK_M": 0.3872926,
    "CMYK_Y": 0,
    "CMYK_K": 0.5363992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07946",
    "Farbtonhilfsbezeichnung": "U8.29.30",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "93",
    "Bcolor": "134",
    "Y": 11,
    "L": 39.5673788661854,
    "a": 4.87419768960462,
    "b": -25.8579036126416,
    "C": 26.3132852824958,
    "h": -1.3844831544729,
    "CMY_C": 0.7079636,
    "CMY_M": 0.6361213,
    "CMY_Y": 0.4738362,
    "CMYK_C": 0.4449705,
    "CMYK_M": 0.3084308,
    "CMYK_Y": 0,
    "CMYK_K": 0.4738362
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07947",
    "Farbtonhilfsbezeichnung": "V0.25.27",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "84",
    "Bcolor": "119",
    "Y": 9,
    "L": 35.9912255643158,
    "a": 5.33218434996868,
    "b": -21.8703056563892,
    "C": 22.5109408831781,
    "h": -1.33165261928428,
    "CMY_C": 0.7156812,
    "CMY_M": 0.6720491,
    "CMY_Y": 0.5346989,
    "CMYK_C": 0.3889573,
    "CMYK_M": 0.2951857,
    "CMYK_Y": 0,
    "CMYK_K": 0.5346989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07948",
    "Farbtonhilfsbezeichnung": "U8.23.32",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "97",
    "Bcolor": "132",
    "Y": 12,
    "L": 41.3475483284235,
    "a": 3.95765013742391,
    "b": -21.4840172466649,
    "C": 21.8455027789531,
    "h": -1.38862495447274,
    "CMY_C": 0.6735741,
    "CMY_M": 0.619003,
    "CMY_Y": 0.4839101,
    "CMYK_C": 0.367502,
    "CMYK_M": 0.2617623,
    "CMYK_Y": 0,
    "CMYK_K": 0.4839101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07949",
    "Farbtonhilfsbezeichnung": "V0.20.30",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "92",
    "Bcolor": "121",
    "Y": 11,
    "L": 39.3113351064046,
    "a": 4.59789158603785,
    "b": -17.9655327888983,
    "C": 18.5445672752409,
    "h": -1.32024574345343,
    "CMY_C": 0.6704494,
    "CMY_M": 0.6408927,
    "CMY_Y": 0.5265189,
    "CMYK_C": 0.3039836,
    "CMYK_M": 0.2415594,
    "CMYK_Y": 0,
    "CMYK_K": 0.5265189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07950",
    "Farbtonhilfsbezeichnung": "V1.09.29",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "90",
    "Bcolor": "103",
    "Y": 10,
    "L": 38.3944771169989,
    "a": 2.41755622166986,
    "b": -8.59365242106348,
    "C": 8.927230254619,
    "h": -1.29656509474056,
    "CMY_C": 0.6568827,
    "CMY_M": 0.6479647,
    "CMY_Y": 0.5945641,
    "CMYK_C": 0.1537076,
    "CMYK_M": 0.1317114,
    "CMYK_Y": 0,
    "CMYK_K": 0.5945641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07951",
    "Farbtonhilfsbezeichnung": "V1.40.23",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "75",
    "Bcolor": "130",
    "Y": 7,
    "L": 32.8516701137404,
    "a": 9.36757287561846,
    "b": -33.8794553145044,
    "C": 35.150660221218,
    "h": -1.30103875988705,
    "CMY_C": 0.789425,
    "CMY_M": 0.7043766,
    "CMY_Y": 0.4906155,
    "CMYK_C": 0.5866089,
    "CMYK_M": 0.4196459,
    "CMYK_Y": 0,
    "CMYK_K": 0.4906155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07952",
    "Farbtonhilfsbezeichnung": "V3.46.20",
    "Farbtonklasse": "04",
    "Rcolor": "46",
    "Gcolor": "68",
    "Bcolor": "128",
    "Y": 6,
    "L": 30.1031656786492,
    "a": 12.1504542816295,
    "b": -37.4153841120257,
    "C": 39.3388422236902,
    "h": -1.25679519575982,
    "CMY_C": 0.8203256,
    "CMY_M": 0.7334731,
    "CMY_Y": 0.4961062,
    "CMYK_C": 0.6434279,
    "CMYK_M": 0.4710652,
    "CMYK_Y": 0,
    "CMYK_K": 0.4961062
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07953",
    "Farbtonhilfsbezeichnung": "V0.38.20",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "72",
    "Bcolor": "121",
    "Y": 7,
    "L": 31.0273924280613,
    "a": 8.16548932139985,
    "b": -31.5311397751964,
    "C": 32.5712755565524,
    "h": -1.31739715301448,
    "CMY_C": 0.8018388,
    "CMY_M": 0.719336,
    "CMY_Y": 0.5236039,
    "CMYK_C": 0.5840409,
    "CMYK_M": 0.4108599,
    "CMYK_Y": 0,
    "CMYK_K": 0.5236039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07954",
    "Farbtonhilfsbezeichnung": "U9.29.20",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "71",
    "Bcolor": "108",
    "Y": 6,
    "L": 30.5463272300027,
    "a": 5.35008293568953,
    "b": -23.8740733531814,
    "C": 24.4661963919986,
    "h": -1.35034254715625,
    "CMY_C": 0.7791099,
    "CMY_M": 0.7210461,
    "CMY_Y": 0.5756571,
    "CMYK_C": 0.4794537,
    "CMYK_M": 0.3426214,
    "CMYK_Y": 0,
    "CMYK_K": 0.5756571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07955",
    "Farbtonhilfsbezeichnung": "U9.28.15",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "68",
    "Bcolor": "97",
    "Y": 6,
    "L": 29.111234995326,
    "a": 3.84531713701261,
    "b": -19.10410345986,
    "C": 19.4872582188782,
    "h": -1.37216812834378,
    "CMY_C": 0.7779056,
    "CMY_M": 0.7326846,
    "CMY_Y": 0.6185765,
    "CMYK_C": 0.4177222,
    "CMYK_M": 0.2991638,
    "CMYK_Y": 0,
    "CMYK_K": 0.6185765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07956",
    "Farbtonhilfsbezeichnung": "V1.20.25",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "80",
    "Bcolor": "108",
    "Y": 8,
    "L": 34.6023784918237,
    "a": 5.02685348486109,
    "b": -17.5442818837896,
    "C": 18.2502351430366,
    "h": -1.29174845271866,
    "CMY_C": 0.7096962,
    "CMY_M": 0.6858102,
    "CMY_Y": 0.5752249,
    "CMYK_C": 0.3165706,
    "CMYK_M": 0.2603386,
    "CMYK_Y": 0,
    "CMYK_K": 0.5752249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07957",
    "Farbtonhilfsbezeichnung": "V3.14.24",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "81",
    "Bcolor": "101",
    "Y": 9,
    "L": 35.0453543494375,
    "a": 4.41204768410183,
    "b": -12.3678051006516,
    "C": 13.1312134920765,
    "h": -1.22813280899319,
    "CMY_C": 0.688143,
    "CMY_M": 0.6821663,
    "CMY_Y": 0.6029961,
    "CMYK_C": 0.2144736,
    "CMYK_M": 0.1994192,
    "CMYK_Y": 0,
    "CMYK_K": 0.6029961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07958",
    "Farbtonhilfsbezeichnung": "V1.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "72",
    "Bcolor": "83",
    "Y": 6,
    "L": 30.5587576528778,
    "a": 1.93284117386877,
    "b": -7.81456981391493,
    "C": 8.0500544333534,
    "h": -1.32832450715716,
    "CMY_C": 0.7297823,
    "CMY_M": 0.7194877,
    "CMY_Y": 0.6731745,
    "CMYK_C": 0.1732049,
    "CMYK_M": 0.1417061,
    "CMYK_Y": 0,
    "CMYK_K": 0.6731745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07959",
    "Farbtonhilfsbezeichnung": "U9.04.12",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "59",
    "Bcolor": "63",
    "Y": 4,
    "L": 24.6420969279941,
    "a": 0.30224700316203,
    "b": -3.07437932255402,
    "C": 3.08920078173436,
    "h": -1.47279968278464,
    "CMY_C": 0.7775419,
    "CMY_M": 0.7702644,
    "CMY_Y": 0.7547476,
    "CMYK_C": 0.09294183,
    "CMYK_M": 0.06326868,
    "CMYK_Y": 0,
    "CMYK_K": 0.7547476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07960",
    "Farbtonhilfsbezeichnung": "V3.12.13",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "59",
    "Bcolor": "72",
    "Y": 4,
    "L": 25.0559343278516,
    "a": 2.70661077648074,
    "b": -8.58332327109601,
    "C": 8.99995445941256,
    "h": -1.26533198642771,
    "CMY_C": 0.776306,
    "CMY_M": 0.7697634,
    "CMY_Y": 0.7187588,
    "CMYK_C": 0.2046189,
    "CMYK_M": 0.1813556,
    "CMYK_Y": 0,
    "CMYK_K": 0.7187588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07961",
    "Farbtonhilfsbezeichnung": "V0.19.20",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "67",
    "Bcolor": "92",
    "Y": 6,
    "L": 28.8282211046694,
    "a": 3.75699606894211,
    "b": -16.3859883863167,
    "C": 16.8111758916071,
    "h": -1.3454109064243,
    "CMY_C": 0.7674331,
    "CMY_M": 0.7359993,
    "CMY_Y": 0.637641,
    "CMYK_C": 0.3581866,
    "CMYK_M": 0.271439,
    "CMYK_Y": 0,
    "CMYK_K": 0.637641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07962",
    "Farbtonhilfsbezeichnung": "U8.23.15",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "62",
    "Bcolor": "86",
    "Y": 5,
    "L": 26.0325652168597,
    "a": 2.71966627638606,
    "b": -16.2950498617618,
    "C": 16.5204489845831,
    "h": -1.4054192902993,
    "CMY_C": 0.8005081,
    "CMY_M": 0.7587804,
    "CMY_Y": 0.6644707,
    "CMYK_C": 0.4054411,
    "CMYK_M": 0.2810774,
    "CMYK_Y": 0,
    "CMYK_K": 0.6644707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07963",
    "Farbtonhilfsbezeichnung": "V0.31.16",
    "Farbtonklasse": "04",
    "Rcolor": "49",
    "Gcolor": "63",
    "Bcolor": "95",
    "Y": 5,
    "L": 26.715987815496,
    "a": 4.56580077247243,
    "b": -21.7351046848566,
    "C": 22.2094869899236,
    "h": -1.36374117348862,
    "CMY_C": 0.8091592,
    "CMY_M": 0.7544138,
    "CMY_Y": 0.6255139,
    "CMYK_C": 0.490393,
    "CMYK_M": 0.344205,
    "CMYK_Y": 0,
    "CMYK_K": 0.6255139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07964",
    "Farbtonhilfsbezeichnung": "V1.40.13",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "58",
    "Bcolor": "101",
    "Y": 4,
    "L": 24.9566659884646,
    "a": 7.77927142031623,
    "b": -28.3883574776893,
    "C": 29.4349435894147,
    "h": -1.30333181884252,
    "CMY_C": 0.8425868,
    "CMY_M": 0.7735658,
    "CMY_Y": 0.602325,
    "CMYK_C": 0.6041662,
    "CMYK_M": 0.4306048,
    "CMYK_Y": 0,
    "CMYK_K": 0.602325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07965",
    "Farbtonhilfsbezeichnung": "U9.48.19",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "70",
    "Bcolor": "128",
    "Y": 6,
    "L": 30.1446749439725,
    "a": 8.1992957145561,
    "b": -36.9113484521014,
    "C": 37.8110578371882,
    "h": -1.35221067240844,
    "CMY_C": 0.8671736,
    "CMY_M": 0.7247008,
    "CMY_Y": 0.4990571,
    "CMYK_C": 0.7348471,
    "CMYK_M": 0.450438,
    "CMYK_Y": 0,
    "CMYK_K": 0.4990571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07968",
    "Farbtonhilfsbezeichnung": "V5.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "145",
    "Bcolor": "202",
    "Y": 30,
    "L": 61.7855490547539,
    "a": 11.9582568030136,
    "b": -30.5262447724872,
    "C": 32.7849283311192,
    "h": -1.19743353642265,
    "CMY_C": 0.4463025,
    "CMY_M": 0.4317586,
    "CMY_Y": 0.2088819,
    "CMYK_C": 0.3001076,
    "CMYK_M": 0.2817238,
    "CMYK_Y": 0,
    "CMYK_K": 0.2088819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07970",
    "Farbtonhilfsbezeichnung": "V5.15.64",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "173",
    "Bcolor": "211",
    "Y": 43,
    "L": 71.8524037147378,
    "a": 8.15455478161386,
    "b": -20.2017774165918,
    "C": 21.7855129495695,
    "h": -1.18714279522667,
    "CMY_C": 0.3224871,
    "CMY_M": 0.3217863,
    "CMY_Y": 0.1715777,
    "CMYK_C": 0.1821648,
    "CMYK_M": 0.1813188,
    "CMYK_Y": 0,
    "CMYK_K": 0.1715777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07971",
    "Farbtonhilfsbezeichnung": "V6.11.68",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "183",
    "Bcolor": "208",
    "Y": 48,
    "L": 75.0881335773279,
    "a": 5.878078395949,
    "b": -13.6145439091121,
    "C": 14.8292822308453,
    "h": -1.16322234702179,
    "CMY_C": 0.2788365,
    "CMY_M": 0.284209,
    "CMY_Y": 0.1832054,
    "CMYK_C": 0.1170811,
    "CMYK_M": 0.1236585,
    "CMYK_Y": 0,
    "CMYK_K": 0.1832054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07972",
    "Farbtonhilfsbezeichnung": "V9.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "200",
    "Bcolor": "226",
    "Y": 60,
    "L": 81.6847194519049,
    "a": 7.20437170701882,
    "b": -13.4316692180583,
    "C": 15.2418079530031,
    "h": -1.07847621757894,
    "CMY_C": 0.1961344,
    "CMY_M": 0.2164052,
    "CMY_Y": 0.1119355,
    "CMYK_C": 0.09481176,
    "CMYK_M": 0.1176375,
    "CMYK_Y": 0,
    "CMYK_K": 0.1119355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07973",
    "Farbtonhilfsbezeichnung": "V9.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "208",
    "Bcolor": "228",
    "Y": 65,
    "L": 84.2266017752215,
    "a": 5.61438567872119,
    "b": -10.3341153488448,
    "C": 11.7607511066538,
    "h": -1.07312201791395,
    "CMY_C": 0.1689878,
    "CMY_M": 0.1858216,
    "CMY_Y": 0.1064708,
    "CMYK_C": 0.06996635,
    "CMYK_M": 0.08880602,
    "CMYK_Y": 0,
    "CMYK_K": 0.1064708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07974",
    "Farbtonhilfsbezeichnung": "V9.04.79",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "213",
    "Bcolor": "225",
    "Y": 68,
    "L": 85.8921134562758,
    "a": 3.23840930242009,
    "b": -6.0618590151986,
    "C": 6.87265811241513,
    "h": -1.08014342737765,
    "CMY_C": 0.1536426,
    "CMY_M": 0.1631503,
    "CMY_Y": 0.1195137,
    "CMYK_C": 0.03876145,
    "CMYK_M": 0.04955975,
    "CMYK_Y": 0,
    "CMYK_K": 0.1195137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07975",
    "Farbtonhilfsbezeichnung": "V9.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "187",
    "Bcolor": "213",
    "Y": 51,
    "L": 76.8722024362327,
    "a": 6.70737270593202,
    "b": -13.5390502762594,
    "C": 15.1094252372273,
    "h": -1.11082794118552,
    "CMY_C": 0.2527893,
    "CMY_M": 0.2671264,
    "CMY_Y": 0.1641713,
    "CMYK_C": 0.1060242,
    "CMYK_M": 0.1231774,
    "CMYK_Y": 0,
    "CMYK_K": 0.1641713
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07976",
    "Farbtonhilfsbezeichnung": "W1.11.66",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "185",
    "Bcolor": "213",
    "Y": 50,
    "L": 76.1886335490996,
    "a": 7.61609027094562,
    "b": -14.7716411366807,
    "C": 16.6194528455684,
    "h": -1.09475572523451,
    "CMY_C": 0.257845,
    "CMY_M": 0.2762415,
    "CMY_Y": 0.1627456,
    "CMYK_C": 0.1135848,
    "CMYK_M": 0.1355573,
    "CMYK_Y": 0,
    "CMYK_K": 0.1627456
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07977",
    "Farbtonhilfsbezeichnung": "V7.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "173",
    "Bcolor": "207",
    "Y": 44,
    "L": 71.9741493902623,
    "a": 8.1769182757036,
    "b": -17.7581882964565,
    "C": 19.5503259323199,
    "h": -1.13927878395891,
    "CMY_C": 0.3106783,
    "CMY_M": 0.3214221,
    "CMY_Y": 0.1875028,
    "CMYK_C": 0.1516011,
    "CMYK_M": 0.1648243,
    "CMYK_Y": 0,
    "CMYK_K": 0.1875028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07978",
    "Farbtonhilfsbezeichnung": "V8.21.53",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "139",
    "Bcolor": "187",
    "Y": 28,
    "L": 59.8517172048522,
    "a": 12.0880484261273,
    "b": -25.0778797898328,
    "C": 27.839198435043,
    "h": -1.1216356182549,
    "CMY_C": 0.4390243,
    "CMY_M": 0.453998,
    "CMY_Y": 0.2671619,
    "CMYK_C": 0.2345161,
    "CMYK_M": 0.2549486,
    "CMYK_Y": 0,
    "CMYK_K": 0.2671619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07979",
    "Farbtonhilfsbezeichnung": "V9.25.50",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "132",
    "Bcolor": "188",
    "Y": 26,
    "L": 57.8094876045429,
    "a": 15.8246725331647,
    "b": -28.8243901947643,
    "C": 32.8826052934058,
    "h": -1.06871899997767,
    "CMY_C": 0.4480927,
    "CMY_M": 0.4824711,
    "CMY_Y": 0.2631477,
    "CMYK_C": 0.2509933,
    "CMYK_M": 0.2976491,
    "CMYK_Y": 0,
    "CMYK_K": 0.2631477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07980",
    "Farbtonhilfsbezeichnung": "V8.28.48",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "126",
    "Bcolor": "186",
    "Y": 24,
    "L": 55.6345232095762,
    "a": 16.2325374064976,
    "b": -31.2726041756805,
    "C": 35.2345149332602,
    "h": -1.0920127227221,
    "CMY_C": 0.4792221,
    "CMY_M": 0.5042865,
    "CMY_Y": 0.2698213,
    "CMYK_C": 0.2867802,
    "CMYK_M": 0.3211067,
    "CMYK_Y": 0,
    "CMYK_K": 0.2698213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07981",
    "Farbtonhilfsbezeichnung": "V8.26.49",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "131",
    "Bcolor": "189",
    "Y": 25,
    "L": 57.3722474455217,
    "a": 15.3366552466851,
    "b": -29.8859315289391,
    "C": 33.5913961827744,
    "h": -1.09666588388454,
    "CMY_C": 0.4615382,
    "CMY_M": 0.4851872,
    "CMY_Y": 0.2606637,
    "CMYK_C": 0.2716958,
    "CMYK_M": 0.3036825,
    "CMYK_Y": 0,
    "CMYK_K": 0.2606637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07982",
    "Farbtonhilfsbezeichnung": "V6.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "137",
    "Bcolor": "178",
    "Y": 27,
    "L": 58.5196772202912,
    "a": 9.25517612247928,
    "b": -22.3391114095723,
    "C": 24.180450443021,
    "h": -1.17802032514173,
    "CMY_C": 0.4628685,
    "CMY_M": 0.4617397,
    "CMY_Y": 0.300303,
    "CMYK_C": 0.232337,
    "CMYK_M": 0.2307238,
    "CMYK_Y": 0,
    "CMYK_K": 0.300303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07983",
    "Farbtonhilfsbezeichnung": "V9.15.64",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "173",
    "Bcolor": "213",
    "Y": 44,
    "L": 72.4836873660152,
    "a": 10.9257211563181,
    "b": -19.9273309379435,
    "C": 22.7259741506484,
    "h": -1.06927599556179,
    "CMY_C": 0.2924879,
    "CMY_M": 0.3219962,
    "CMY_Y": 0.1663111,
    "CMYK_C": 0.1513475,
    "CMYK_M": 0.1867425,
    "CMYK_Y": 0,
    "CMYK_K": 0.1663111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07984",
    "Farbtonhilfsbezeichnung": "V5.10.69",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "190",
    "Bcolor": "216",
    "Y": 53,
    "L": 77.936465901928,
    "a": 5.91394396349526,
    "b": -13.4963499355483,
    "C": 14.7352025702444,
    "h": -1.15780822797827,
    "CMY_C": 0.2474031,
    "CMY_M": 0.2537892,
    "CMY_Y": 0.1529123,
    "CMYK_C": 0.1115479,
    "CMYK_M": 0.1190867,
    "CMYK_Y": 0,
    "CMYK_K": 0.1529123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07985",
    "Farbtonhilfsbezeichnung": "V9.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "197",
    "Bcolor": "214",
    "Y": 57,
    "L": 80.394252615772,
    "a": 5.05979334542467,
    "b": -8.73637597496499,
    "C": 10.0958295287881,
    "h": -1.04583841654202,
    "CMY_C": 0.2093326,
    "CMY_M": 0.2267279,
    "CMY_Y": 0.1602967,
    "CMYK_C": 0.05839664,
    "CMYK_M": 0.07911269,
    "CMYK_Y": 0,
    "CMYK_K": 0.1602967
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07986",
    "Farbtonhilfsbezeichnung": "V6.06.76",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "205",
    "Bcolor": "219",
    "Y": 62,
    "L": 82.7690400893106,
    "a": 3.31550966589322,
    "b": -7.95239506779504,
    "C": 8.61586859573208,
    "h": -1.17578967766769,
    "CMY_C": 0.1942593,
    "CMY_M": 0.1969683,
    "CMY_Y": 0.1401388,
    "CMYK_C": 0.06294095,
    "CMYK_M": 0.06609151,
    "CMYK_Y": 0,
    "CMYK_K": 0.1401388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07987",
    "Farbtonhilfsbezeichnung": "V5.05.65",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "178",
    "Bcolor": "191",
    "Y": 45,
    "L": 72.9935780648427,
    "a": 2.40458176933434,
    "b": -7.24860534212588,
    "C": 7.63703429947194,
    "h": -1.25048922729315,
    "CMY_C": 0.3042171,
    "CMY_M": 0.3003986,
    "CMY_Y": 0.2513679,
    "CMYK_C": 0.07059436,
    "CMYK_M": 0.06549375,
    "CMYK_Y": 0,
    "CMYK_K": 0.2513679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07988",
    "Farbtonhilfsbezeichnung": "V6.09.67",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "181",
    "Bcolor": "204",
    "Y": 47,
    "L": 74.4972097991077,
    "a": 5.45502276344767,
    "b": -12.0373248569362,
    "C": 13.2156900334847,
    "h": -1.14530465123497,
    "CMY_C": 0.2823529,
    "CMY_M": 0.2900268,
    "CMY_Y": 0.2008845,
    "CMYK_C": 0.1019482,
    "CMYK_M": 0.1115513,
    "CMYK_Y": 0,
    "CMYK_K": 0.2008845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07989",
    "Farbtonhilfsbezeichnung": "V9.10.55",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "152",
    "Bcolor": "174",
    "Y": 33,
    "L": 63.8409353238977,
    "a": 6.39368784114541,
    "b": -11.7942631703934,
    "C": 13.415807390631,
    "h": -1.07403743575003,
    "CMY_C": 0.3867628,
    "CMY_M": 0.4042144,
    "CMY_Y": 0.3164363,
    "CMYK_C": 0.1028821,
    "CMYK_M": 0.1284125,
    "CMYK_Y": 0,
    "CMYK_K": 0.3164363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07990",
    "Farbtonhilfsbezeichnung": "V5.14.61",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "162",
    "Bcolor": "195",
    "Y": 37,
    "L": 67.6365003453247,
    "a": 7.14615995674817,
    "b": -17.8710240924463,
    "C": 19.2468466050994,
    "h": -1.1903984752869,
    "CMY_C": 0.3653037,
    "CMY_M": 0.364514,
    "CMY_Y": 0.2338109,
    "CMYK_C": 0.1716193,
    "CMYK_M": 0.1705886,
    "CMYK_Y": 0,
    "CMYK_K": 0.2338109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07991",
    "Farbtonhilfsbezeichnung": "V8.20.51",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "127",
    "Bcolor": "171",
    "Y": 23,
    "L": 55.1715833841226,
    "a": 12.0848182826075,
    "b": -23.3526579765963,
    "C": 26.2942858335329,
    "h": -1.09325308691166,
    "CMY_C": 0.4796194,
    "CMY_M": 0.5018558,
    "CMY_Y": 0.3285748,
    "CMYK_C": 0.2249612,
    "CMYK_M": 0.2580793,
    "CMYK_Y": 0,
    "CMYK_K": 0.3285748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07992",
    "Farbtonhilfsbezeichnung": "V4.25.43",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "118",
    "Bcolor": "164",
    "Y": 19,
    "L": 50.7718065446466,
    "a": 9.73776963271211,
    "b": -26.3122506060686,
    "C": 28.0563484683294,
    "h": -1.21634163275551,
    "CMY_C": 0.556904,
    "CMY_M": 0.5387607,
    "CMY_Y": 0.3552119,
    "CMYK_C": 0.3128038,
    "CMYK_M": 0.2846653,
    "CMYK_Y": 0,
    "CMYK_K": 0.3552119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07993",
    "Farbtonhilfsbezeichnung": "V6.30.39",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "113",
    "Bcolor": "167",
    "Y": 18,
    "L": 49.3873102614709,
    "a": 12.2170202745581,
    "b": -30.2215773991114,
    "C": 32.5975355645092,
    "h": -1.18663302440013,
    "CMY_C": 0.5707768,
    "CMY_M": 0.5565881,
    "CMY_Y": 0.3435741,
    "CMYK_C": 0.3461209,
    "CMYK_M": 0.3245058,
    "CMYK_Y": 0,
    "CMYK_K": 0.3435741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07994",
    "Farbtonhilfsbezeichnung": "V9.30.40",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "108",
    "Bcolor": "165",
    "Y": 17,
    "L": 48.3149733453207,
    "a": 15.947179653798,
    "b": -30.7137781429201,
    "C": 34.6070615152895,
    "h": -1.09189193471302,
    "CMY_C": 0.5539709,
    "CMY_M": 0.5759838,
    "CMY_Y": 0.3512717,
    "CMYK_C": 0.3124562,
    "CMYK_M": 0.3463885,
    "CMYK_Y": 0,
    "CMYK_K": 0.3512717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07995",
    "Farbtonhilfsbezeichnung": "V8.25.42",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "115",
    "Bcolor": "165",
    "Y": 19,
    "L": 50.7027705333072,
    "a": 13.1036060862944,
    "b": -26.9635016554401,
    "C": 29.9789078184596,
    "h": -1.11843098719486,
    "CMY_C": 0.5337735,
    "CMY_M": 0.5472065,
    "CMY_Y": 0.3513114,
    "CMYK_C": 0.2812785,
    "CMYK_M": 0.3019863,
    "CMYK_Y": 0,
    "CMYK_K": 0.3513114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07996",
    "Farbtonhilfsbezeichnung": "V7.20.45",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "123",
    "Bcolor": "164",
    "Y": 21,
    "L": 53.1447279229313,
    "a": 9.7871715332199,
    "b": -22.2664186029462,
    "C": 24.3224613068312,
    "h": -1.15666775865142,
    "CMY_C": 0.5132568,
    "CMY_M": 0.5169732,
    "CMY_Y": 0.3573385,
    "CMYK_C": 0.2426135,
    "CMYK_M": 0.2483963,
    "CMYK_Y": 0,
    "CMYK_K": 0.3573385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07997",
    "Farbtonhilfsbezeichnung": "V4.16.51",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "139",
    "Bcolor": "172",
    "Y": 27,
    "L": 58.6344801437842,
    "a": 6.85583844546395,
    "b": -18.4376274513543,
    "C": 19.6710098069528,
    "h": -1.21479936782606,
    "CMY_C": 0.4635041,
    "CMY_M": 0.4563725,
    "CMY_Y": 0.3258269,
    "CMYK_C": 0.2042163,
    "CMYK_M": 0.1936381,
    "CMYK_Y": 0,
    "CMYK_K": 0.3258269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07998",
    "Farbtonhilfsbezeichnung": "V4.11.53",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "144",
    "Bcolor": "169",
    "Y": 28,
    "L": 60.3123654791568,
    "a": 4.97828660750621,
    "b": -13.9060212401979,
    "C": 14.7702662223573,
    "h": -1.22701680982562,
    "CMY_C": 0.4421849,
    "CMY_M": 0.4365074,
    "CMY_Y": 0.3392111,
    "CMYK_C": 0.1558346,
    "CMYK_M": 0.1472427,
    "CMYK_Y": 0,
    "CMYK_K": 0.3392111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI07999",
    "Farbtonhilfsbezeichnung": "V9.03.63",
    "Farbtonklasse": "01",
    "Rcolor": "174",
    "Gcolor": "172",
    "Bcolor": "179",
    "Y": 42,
    "L": 70.6345921303711,
    "a": 2.29831593148011,
    "b": -4.25170542965894,
    "C": 4.83314133680017,
    "h": -1.07522703779446,
    "CMY_C": 0.3193962,
    "CMY_M": 0.3260516,
    "CMY_Y": 0.2975957,
    "CMYK_C": 0.03103704,
    "CMYK_M": 0.04051214,
    "CMYK_Y": 0,
    "CMYK_K": 0.2975957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08000",
    "Farbtonhilfsbezeichnung": "V8.03.46",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "131",
    "Bcolor": "137",
    "Y": 23,
    "L": 54.9417544767955,
    "a": 1.60957453644966,
    "b": -3.68147125836229,
    "C": 4.0179548049393,
    "h": -1.15862966584486,
    "CMY_C": 0.4846247,
    "CMY_M": 0.4865313,
    "CMY_Y": 0.4637128,
    "CMYK_C": 0.03899395,
    "CMYK_M": 0.04254914,
    "CMYK_Y": 0,
    "CMYK_K": 0.4637128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08001",
    "Farbtonhilfsbezeichnung": "V5.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "142",
    "Bcolor": "162",
    "Y": 28,
    "L": 59.5513839130401,
    "a": 4.88177766786235,
    "b": -11.452490064166,
    "C": 12.449549464469,
    "h": -1.16785603180532,
    "CMY_C": 0.4411882,
    "CMY_M": 0.4448475,
    "CMY_Y": 0.3638473,
    "CMYK_C": 0.1215761,
    "CMYK_M": 0.1273284,
    "CMYK_Y": 0,
    "CMYK_K": 0.3638473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08002",
    "Farbtonhilfsbezeichnung": "V9.15.46",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "126",
    "Bcolor": "157",
    "Y": 22,
    "L": 54.0478140667193,
    "a": 8.28647067648375,
    "b": -16.5701656004014,
    "C": 18.5266290591934,
    "h": -1.10708171400823,
    "CMY_C": 0.4914545,
    "CMY_M": 0.506521,
    "CMY_Y": 0.386122,
    "CMYK_C": 0.1715854,
    "CMYK_M": 0.1961286,
    "CMYK_Y": 0,
    "CMYK_K": 0.386122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08003",
    "Farbtonhilfsbezeichnung": "V4.21.43",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "119",
    "Bcolor": "159",
    "Y": 19,
    "L": 51.1593097207815,
    "a": 8.40742773721298,
    "b": -22.740441926877,
    "C": 24.244845641623,
    "h": -1.21666923067668,
    "CMY_C": 0.5463704,
    "CMY_M": 0.5332428,
    "CMY_Y": 0.3750058,
    "CMYK_C": 0.2741859,
    "CMYK_M": 0.2531816,
    "CMYK_Y": 0,
    "CMYK_K": 0.3750058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08004",
    "Farbtonhilfsbezeichnung": "V9.26.40",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "106",
    "Bcolor": "158",
    "Y": 16,
    "L": 47.4265711146299,
    "a": 15.3337444094414,
    "b": -27.9284835375707,
    "C": 31.8610092483341,
    "h": -1.06869349042,
    "CMY_C": 0.5541967,
    "CMY_M": 0.5842855,
    "CMY_Y": 0.3789659,
    "CMYK_C": 0.2821598,
    "CMYK_M": 0.3306093,
    "CMYK_Y": 0,
    "CMYK_K": 0.3789659
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08005",
    "Farbtonhilfsbezeichnung": "V9.32.37",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "98",
    "Bcolor": "159",
    "Y": 14,
    "L": 44.6046724632116,
    "a": 18.4306528338553,
    "b": -32.7522449996155,
    "C": 37.5818908039089,
    "h": -1.05823258283701,
    "CMY_C": 0.5824671,
    "CMY_M": 0.6171728,
    "CMY_Y": 0.3765175,
    "CMYK_C": 0.3303214,
    "CMYK_M": 0.3859857,
    "CMYK_Y": 0,
    "CMYK_K": 0.3765175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08006",
    "Farbtonhilfsbezeichnung": "V5.34.35",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "96",
    "Bcolor": "157",
    "Y": 13,
    "L": 42.5347242903718,
    "a": 13.7840941905503,
    "b": -34.7297573096934,
    "C": 37.3651882832693,
    "h": -1.19296886073032,
    "CMY_C": 0.6531391,
    "CMY_M": 0.6243245,
    "CMY_Y": 0.3855746,
    "CMYK_C": 0.4354711,
    "CMYK_M": 0.3885743,
    "CMYK_Y": 0,
    "CMYK_K": 0.3855746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08007",
    "Farbtonhilfsbezeichnung": "V4.44.29",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "86",
    "Bcolor": "161",
    "Y": 10,
    "L": 38.4660872323854,
    "a": 16.4018740275676,
    "b": -43.9442497964594,
    "C": 46.9054214541327,
    "h": -1.21356712090352,
    "CMY_C": 0.7395693,
    "CMY_M": 0.6640695,
    "CMY_Y": 0.3681705,
    "CMYK_C": 0.587815,
    "CMYK_M": 0.468321,
    "CMYK_Y": 0,
    "CMYK_K": 0.3681705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08008",
    "Farbtonhilfsbezeichnung": "V4.32.33",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "95",
    "Bcolor": "148",
    "Y": 12,
    "L": 41.6201476533472,
    "a": 10.8360711150157,
    "b": -30.7862254592947,
    "C": 32.6375874604757,
    "h": -1.23236054252054,
    "CMY_C": 0.6641695,
    "CMY_M": 0.627843,
    "CMY_Y": 0.4208237,
    "CMYK_C": 0.4201585,
    "CMYK_M": 0.3574374,
    "CMYK_Y": 0,
    "CMYK_K": 0.4208237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08009",
    "Farbtonhilfsbezeichnung": "V9.29.32",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "90",
    "Bcolor": "140",
    "Y": 12,
    "L": 40.6819013956203,
    "a": 14.6943058620117,
    "b": -27.4919307788549,
    "C": 31.1725661875262,
    "h": -1.07993484624364,
    "CMY_C": 0.6243303,
    "CMY_M": 0.6473442,
    "CMY_Y": 0.4513114,
    "CMYK_C": 0.3153315,
    "CMYK_M": 0.357275,
    "CMYK_Y": 0,
    "CMYK_K": 0.4513114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08010",
    "Farbtonhilfsbezeichnung": "V9.21.40",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "112",
    "Bcolor": "151",
    "Y": 18,
    "L": 49.1083768939699,
    "a": 11.2923369415359,
    "b": -20.7082060605309,
    "C": 23.5870021801539,
    "h": -1.07156305682902,
    "CMY_C": 0.5356632,
    "CMY_M": 0.560931,
    "CMY_Y": 0.4093741,
    "CMYK_C": 0.2138226,
    "CMYK_M": 0.256604,
    "CMYK_Y": 0,
    "CMYK_K": 0.4093741
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08011",
    "Farbtonhilfsbezeichnung": "V5.16.44",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "122",
    "Bcolor": "154",
    "Y": 20,
    "L": 52.2183092455172,
    "a": 6.81256600119673,
    "b": -18.0454231455537,
    "C": 19.2885549490559,
    "h": -1.20981536777664,
    "CMY_C": 0.5272104,
    "CMY_M": 0.5208189,
    "CMY_Y": 0.3953509,
    "CMYK_C": 0.218076,
    "CMYK_M": 0.2075055,
    "CMYK_Y": 0,
    "CMYK_K": 0.3953509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08012",
    "Farbtonhilfsbezeichnung": "V9.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "136",
    "Bcolor": "157",
    "Y": 26,
    "L": 57.7217734307484,
    "a": 5.95418999575198,
    "b": -11.4902136438152,
    "C": 12.9413055016111,
    "h": -1.09269761121804,
    "CMY_C": 0.4519909,
    "CMY_M": 0.4658775,
    "CMY_Y": 0.3824496,
    "CMYK_C": 0.1126084,
    "CMYK_M": 0.1350948,
    "CMYK_Y": 0,
    "CMYK_K": 0.3824496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08013",
    "Farbtonhilfsbezeichnung": "V1.05.40",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "114",
    "Bcolor": "124",
    "Y": 17,
    "L": 48.2732136540091,
    "a": 1.51763805010857,
    "b": -6.17728234424237,
    "C": 6.36097810180368,
    "h": -1.32988715316678,
    "CMY_C": 0.5599454,
    "CMY_M": 0.551861,
    "CMY_Y": 0.5138335,
    "CMYK_C": 0.09484793,
    "CMYK_M": 0.07821905,
    "CMYK_Y": 0,
    "CMYK_K": 0.5138335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08014",
    "Farbtonhilfsbezeichnung": "V7.07.34",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "99",
    "Bcolor": "112",
    "Y": 13,
    "L": 42.5743194381864,
    "a": 3.35190325614698,
    "b": -7.37333761823451,
    "C": 8.09946683869012,
    "h": -1.14412543027506,
    "CMY_C": 0.6062582,
    "CMY_M": 0.6106347,
    "CMY_Y": 0.5618216,
    "CMYK_C": 0.1014121,
    "CMYK_M": 0.1114,
    "CMYK_Y": 0,
    "CMYK_K": 0.5618216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08015",
    "Farbtonhilfsbezeichnung": "V7.09.47",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "130",
    "Bcolor": "149",
    "Y": 23,
    "L": 54.8732080061066,
    "a": 4.6992988143249,
    "b": -10.9379452362367,
    "C": 11.9047072764192,
    "h": -1.16500830378753,
    "CMY_C": 0.4881576,
    "CMY_M": 0.4919103,
    "CMY_Y": 0.4156092,
    "CMYK_C": 0.1241435,
    "CMYK_M": 0.1305652,
    "CMYK_Y": 0,
    "CMYK_K": 0.4156092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08016",
    "Farbtonhilfsbezeichnung": "V6.18.40",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "114",
    "Bcolor": "148",
    "Y": 18,
    "L": 49.1010878053206,
    "a": 7.90899538795115,
    "b": -19.1481558889832,
    "C": 20.7172411772281,
    "h": -1.17909752600627,
    "CMY_C": 0.5546498,
    "CMY_M": 0.5536663,
    "CMY_Y": 0.420021,
    "CMYK_C": 0.232127,
    "CMYK_M": 0.2304312,
    "CMYK_Y": 0,
    "CMYK_K": 0.420021
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08017",
    "Farbtonhilfsbezeichnung": "V4.23.33",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "97",
    "Bcolor": "135",
    "Y": 12,
    "L": 41.9787262160066,
    "a": 7.62045893547536,
    "b": -22.3352916061964,
    "C": 23.599505196531,
    "h": -1.24199629724494,
    "CMY_C": 0.641638,
    "CMY_M": 0.6206172,
    "CMY_Y": 0.4717958,
    "CMYK_C": 0.3215464,
    "CMYK_M": 0.2817496,
    "CMYK_Y": 0,
    "CMYK_K": 0.4717958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08018",
    "Farbtonhilfsbezeichnung": "V5.25.35",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "99",
    "Bcolor": "143",
    "Y": 13,
    "L": 43.3706920928343,
    "a": 10.0357534840291,
    "b": -24.9762462873079,
    "C": 26.9170805734289,
    "h": -1.18872892597077,
    "CMY_C": 0.6217564,
    "CMY_M": 0.6117942,
    "CMY_Y": 0.4404657,
    "CMYK_C": 0.3240029,
    "CMYK_M": 0.3061984,
    "CMYK_Y": 0,
    "CMYK_K": 0.4404657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08019",
    "Farbtonhilfsbezeichnung": "V6.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "86",
    "Bcolor": "136",
    "Y": 10,
    "L": 38.4306887308216,
    "a": 12.1254435534081,
    "b": -28.6328916059492,
    "C": 31.0945149999951,
    "h": -1.17021423351066,
    "CMY_C": 0.6726176,
    "CMY_M": 0.6617575,
    "CMY_Y": 0.4671097,
    "CMYK_C": 0.3856477,
    "CMYK_M": 0.3652681,
    "CMYK_Y": 0,
    "CMYK_K": 0.4671097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08020",
    "Farbtonhilfsbezeichnung": "V5.33.26",
    "Farbtonklasse": "04",
    "Rcolor": "68",
    "Gcolor": "74",
    "Bcolor": "126",
    "Y": 8,
    "L": 33.1244706447526,
    "a": 12.8236012352281,
    "b": -31.2545820776216,
    "C": 33.7830378960645,
    "h": -1.18144650705941,
    "CMY_C": 0.7343835,
    "CMY_M": 0.7109971,
    "CMY_Y": 0.5040488,
    "CMYK_C": 0.4644302,
    "CMYK_M": 0.4172755,
    "CMYK_Y": 0,
    "CMYK_K": 0.5040488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08021",
    "Farbtonhilfsbezeichnung": "V4.40.24",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "76",
    "Bcolor": "132",
    "Y": 8,
    "L": 33.7107866898523,
    "a": 11.6728997135902,
    "b": -33.663218063703,
    "C": 35.6296062022576,
    "h": -1.23701501654878,
    "CMY_C": 0.7553139,
    "CMY_M": 0.7018517,
    "CMY_Y": 0.4831432,
    "CMYK_C": 0.5265883,
    "CMYK_M": 0.4231511,
    "CMYK_Y": 0,
    "CMYK_K": 0.4831432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08023",
    "Farbtonhilfsbezeichnung": "V4.34.24",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "75",
    "Bcolor": "125",
    "Y": 8,
    "L": 33.228233372456,
    "a": 11.1772047936682,
    "b": -29.9463054282438,
    "C": 31.9642161768635,
    "h": -1.21356822125131,
    "CMY_C": 0.7394708,
    "CMY_M": 0.7068533,
    "CMY_Y": 0.5112869,
    "CMYK_C": 0.4669078,
    "CMYK_M": 0.400166,
    "CMYK_Y": 0,
    "CMYK_K": 0.5112869
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08024",
    "Farbtonhilfsbezeichnung": "V8.33.25",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "77",
    "Bcolor": "128",
    "Y": 8,
    "L": 34.9170241878884,
    "a": 13.9954416722893,
    "b": -29.467636649281,
    "C": 32.622292949707,
    "h": -1.12739466666237,
    "CMY_C": 0.6965417,
    "CMY_M": 0.6982936,
    "CMY_Y": 0.4971541,
    "CMYK_C": 0.3965183,
    "CMYK_M": 0.4000022,
    "CMYK_Y": 0,
    "CMYK_K": 0.4971541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08025",
    "Farbtonhilfsbezeichnung": "V4.28.33",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "94",
    "Bcolor": "141",
    "Y": 12,
    "L": 41.3839446204467,
    "a": 9.865799399978,
    "b": -26.9580799207631,
    "C": 28.7066555142681,
    "h": -1.21996738134563,
    "CMY_C": 0.6529924,
    "CMY_M": 0.6294888,
    "CMY_Y": 0.4479735,
    "CMYK_C": 0.3713932,
    "CMYK_M": 0.3288161,
    "CMYK_Y": 0,
    "CMYK_K": 0.4479735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08026",
    "Farbtonhilfsbezeichnung": "V6.21.30",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "85",
    "Bcolor": "120",
    "Y": 10,
    "L": 37.4210402131685,
    "a": 8.66920174812158,
    "b": -20.6233331439506,
    "C": 22.3713416878828,
    "h": -1.17286328639128,
    "CMY_C": 0.6693772,
    "CMY_M": 0.6665,
    "CMY_Y": 0.5281153,
    "CMYK_C": 0.2993568,
    "CMYK_M": 0.2932596,
    "CMYK_Y": 0,
    "CMYK_K": 0.5281153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08027",
    "Farbtonhilfsbezeichnung": "V8.20.35",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "101",
    "Bcolor": "135",
    "Y": 14,
    "L": 44.034925585567,
    "a": 9.10723475790959,
    "b": -19.2255679066627,
    "C": 21.2735560325342,
    "h": -1.12840567178801,
    "CMY_C": 0.5959241,
    "CMY_M": 0.605502,
    "CMY_Y": 0.4709117,
    "CMYK_C": 0.236279,
    "CMYK_M": 0.2543815,
    "CMYK_Y": 0,
    "CMYK_K": 0.4709117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08028",
    "Farbtonhilfsbezeichnung": "V8.09.35",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "102",
    "Bcolor": "119",
    "Y": 14,
    "L": 43.7776395858882,
    "a": 4.77489125642705,
    "b": -9.8986749333132,
    "C": 10.9901479492365,
    "h": -1.1213464043549,
    "CMY_C": 0.5934571,
    "CMY_M": 0.6014087,
    "CMY_Y": 0.533789,
    "CMYK_C": 0.1279851,
    "CMYK_M": 0.1450409,
    "CMYK_Y": 0,
    "CMYK_K": 0.533789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08029",
    "Farbtonhilfsbezeichnung": "V8.03.29",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "86",
    "Bcolor": "91",
    "Y": 10,
    "L": 37.0531777954571,
    "a": 1.89535199756588,
    "b": -3.09794101558365,
    "C": 3.63174857757423,
    "h": -1.02173806309606,
    "CMY_C": 0.6547507,
    "CMY_M": 0.6609805,
    "CMY_Y": 0.6415768,
    "CMYK_C": 0.03675505,
    "CMYK_M": 0.05413634,
    "CMYK_Y": 0,
    "CMYK_K": 0.6415768
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08030",
    "Farbtonhilfsbezeichnung": "V9.04.24",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "78",
    "Bcolor": "84",
    "Y": 8,
    "L": 33.4928705123439,
    "a": 1.9430719659301,
    "b": -4.0363509218025,
    "C": 4.47969389899794,
    "h": -1.12214463655533,
    "CMY_C": 0.6903946,
    "CMY_M": 0.6938052,
    "CMY_Y": 0.6689495,
    "CMYK_C": 0.06477886,
    "CMYK_M": 0.07508091,
    "CMYK_Y": 0,
    "CMYK_K": 0.6689495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08032",
    "Farbtonhilfsbezeichnung": "V6.16.26",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "83",
    "Bcolor": "107",
    "Y": 9,
    "L": 35.9755856654094,
    "a": 5.70235073851938,
    "b": -14.4270857018047,
    "C": 15.5131430017359,
    "h": -1.1943887677415,
    "CMY_C": 0.6783302,
    "CMY_M": 0.675625,
    "CMY_Y": 0.5811902,
    "CMYK_C": 0.231943,
    "CMYK_M": 0.2254836,
    "CMYK_Y": 0,
    "CMYK_K": 0.5811902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08033",
    "Farbtonhilfsbezeichnung": "V9.18.29",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "80",
    "Bcolor": "113",
    "Y": 9,
    "L": 35.8443660263881,
    "a": 10.0783711452206,
    "b": -18.3290473302289,
    "C": 20.9171590082062,
    "h": -1.06806223407531,
    "CMY_C": 0.6641097,
    "CMY_M": 0.6851693,
    "CMY_Y": 0.5578348,
    "CMYK_C": 0.2403511,
    "CMYK_M": 0.2879795,
    "CMYK_Y": 0,
    "CMYK_K": 0.5578348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08034",
    "Farbtonhilfsbezeichnung": "V5.27.20",
    "Farbtonklasse": "04",
    "Rcolor": "64",
    "Gcolor": "68",
    "Bcolor": "104",
    "Y": 6,
    "L": 29.9119841851573,
    "a": 8.70435587781254,
    "b": -22.3063023405242,
    "C": 23.9444552110606,
    "h": -1.19874967807635,
    "CMY_C": 0.7482372,
    "CMY_M": 0.7344921,
    "CMY_Y": 0.5911229,
    "CMYK_C": 0.3842579,
    "CMYK_M": 0.3506413,
    "CMYK_Y": 0,
    "CMYK_K": 0.5911229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08035",
    "Farbtonhilfsbezeichnung": "V4.30.23",
    "Farbtonklasse": "04",
    "Rcolor": "69",
    "Gcolor": "76",
    "Bcolor": "118",
    "Y": 8,
    "L": 33.6012992497148,
    "a": 8.74326013353291,
    "b": -25.0559967282916,
    "C": 26.5376632319197,
    "h": -1.23505829018663,
    "CMY_C": 0.7276233,
    "CMY_M": 0.7001205,
    "CMY_Y": 0.5381811,
    "CMYK_C": 0.4102089,
    "CMYK_M": 0.3506556,
    "CMYK_Y": 0,
    "CMYK_K": 0.5381811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08036",
    "Farbtonhilfsbezeichnung": "V9.36.23",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "72",
    "Bcolor": "128",
    "Y": 8,
    "L": 33.2921809887793,
    "a": 16.7593658170765,
    "b": -31.674708284684,
    "C": 35.8352269074778,
    "h": -1.08413379111472,
    "CMY_C": 0.7026894,
    "CMY_M": 0.7188579,
    "CMY_Y": 0.4994632,
    "CMYK_C": 0.4060166,
    "CMYK_M": 0.438319,
    "CMYK_Y": 0,
    "CMYK_K": 0.4994632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08037",
    "Farbtonhilfsbezeichnung": "V4.42.18",
    "Farbtonklasse": "04",
    "Rcolor": "48",
    "Gcolor": "65",
    "Bcolor": "120",
    "Y": 6,
    "L": 28.7995834156343,
    "a": 11.6330046129702,
    "b": -34.1954259482242,
    "C": 36.1199937999146,
    "h": -1.24288587560615,
    "CMY_C": 0.8107997,
    "CMY_M": 0.745522,
    "CMY_Y": 0.5291269,
    "CMYK_C": 0.5981925,
    "CMYK_M": 0.4595613,
    "CMYK_Y": 0,
    "CMYK_K": 0.5291269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08038",
    "Farbtonhilfsbezeichnung": "V5.38.14",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "55",
    "Bcolor": "98",
    "Y": 4,
    "L": 24.4531555608783,
    "a": 9.82230389748837,
    "b": -26.7325982090862,
    "C": 28.4799835123382,
    "h": -1.21868063069424,
    "CMY_C": 0.8160038,
    "CMY_M": 0.7830589,
    "CMY_Y": 0.6169302,
    "CMYK_C": 0.5196798,
    "CMYK_M": 0.4336773,
    "CMYK_Y": 0,
    "CMYK_K": 0.6169302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08039",
    "Farbtonhilfsbezeichnung": "V9.31.21",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "69",
    "Bcolor": "112",
    "Y": 7,
    "L": 31.773544358976,
    "a": 13.3334018097868,
    "b": -24.5467092051948,
    "C": 27.9342180242373,
    "h": -1.07320049029618,
    "CMY_C": 0.7067202,
    "CMY_M": 0.7274612,
    "CMY_Y": 0.5589586,
    "CMYK_C": 0.3350288,
    "CMYK_M": 0.3820562,
    "CMYK_Y": 0,
    "CMYK_K": 0.5589586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08040",
    "Farbtonhilfsbezeichnung": "V9.26.17",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "63",
    "Bcolor": "95",
    "Y": 6,
    "L": 28.2974342780819,
    "a": 9.42466514574339,
    "b": -18.9991533463886,
    "C": 21.2083035858359,
    "h": -1.11030800011294,
    "CMY_C": 0.7421361,
    "CMY_M": 0.751763,
    "CMY_Y": 0.6265206,
    "CMYK_C": 0.3095632,
    "CMYK_M": 0.3353396,
    "CMYK_Y": 0,
    "CMYK_K": 0.6265206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08041",
    "Farbtonhilfsbezeichnung": "V4.24.24",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "75",
    "Bcolor": "110",
    "Y": 8,
    "L": 33.0459432845101,
    "a": 7.54643192424762,
    "b": -21.2310178798652,
    "C": 22.5323046979766,
    "h": -1.2292801258435,
    "CMY_C": 0.7224291,
    "CMY_M": 0.704089,
    "CMY_Y": 0.5673844,
    "CMYK_C": 0.358389,
    "CMYK_M": 0.3159955,
    "CMYK_Y": 0,
    "CMYK_K": 0.5673844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08043",
    "Farbtonhilfsbezeichnung": "V4.20.23",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "76",
    "Bcolor": "103",
    "Y": 8,
    "L": 32.9792185364661,
    "a": 5.64880195025386,
    "b": -16.6378984780722,
    "C": 17.570675264196,
    "h": -1.24349339054203,
    "CMY_C": 0.7160224,
    "CMY_M": 0.7023156,
    "CMY_Y": 0.596427,
    "CMYK_C": 0.2963416,
    "CMYK_M": 0.2623779,
    "CMYK_Y": 0,
    "CMYK_K": 0.596427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08044",
    "Farbtonhilfsbezeichnung": "V6.11.22",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "64",
    "Bcolor": "82",
    "Y": 5,
    "L": 27.7394440902295,
    "a": 4.14019798761825,
    "b": -11.0882862138548,
    "C": 11.8360183565691,
    "h": -1.21344243749838,
    "CMY_C": 0.7519258,
    "CMY_M": 0.7482061,
    "CMY_Y": 0.6794155,
    "CMYK_C": 0.2261817,
    "CMYK_M": 0.214579,
    "CMYK_Y": 0,
    "CMYK_K": 0.6794155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08045",
    "Farbtonhilfsbezeichnung": "V6.09.24",
    "Farbtonklasse": "03",
    "Rcolor": "76",
    "Gcolor": "76",
    "Bcolor": "90",
    "Y": 7,
    "L": 32.778777644505,
    "a": 3.38507755367373,
    "b": -8.57561276624651,
    "C": 9.21953818588523,
    "h": -1.19483867693506,
    "CMY_C": 0.7022468,
    "CMY_M": 0.702015,
    "CMY_Y": 0.6477866,
    "CMYK_C": 0.1546228,
    "CMYK_M": 0.1539644,
    "CMYK_Y": 0,
    "CMYK_K": 0.6477866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08046",
    "Farbtonhilfsbezeichnung": "V7.11.16",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "70",
    "Bcolor": "82",
    "Y": 5,
    "L": 30.3023529052734,
    "a": 3.81891679763794,
    "b": -7.46290445327759,
    "C": 8.38326072692871,
    "h": 297.099731445313,
    "CMY_C": 0.71812748908997,
    "CMY_M": 0.72568714618683,
    "CMY_Y": 0.67747277021408,
    "CMYK_C": 0.12605050206184,
    "CMYK_M": 0.14948931336403,
    "CMYK_Y": 0,
    "CMYK_K": 0.67747277021408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08047",
    "Farbtonhilfsbezeichnung": "V7.14.17",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "63",
    "Bcolor": "81",
    "Y": 5,
    "L": 27.4611368500395,
    "a": 4.54771179073177,
    "b": -10.7894494010933,
    "C": 11.7087104717093,
    "h": -1.17189717905539,
    "CMY_C": 0.7505135,
    "CMY_M": 0.7515975,
    "CMY_Y": 0.6837156,
    "CMYK_C": 0.2111955,
    "CMYK_M": 0.2146229,
    "CMYK_Y": 0,
    "CMYK_K": 0.6837156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08048",
    "Farbtonhilfsbezeichnung": "V6.15.14",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "60",
    "Bcolor": "76",
    "Y": 5,
    "L": 25.7083273430835,
    "a": 4.19044497824411,
    "b": -10.5244237823349,
    "C": 11.3279885710512,
    "h": -1.19187384848427,
    "CMY_C": 0.7675846,
    "CMY_M": 0.766412,
    "CMY_Y": 0.7013548,
    "CMYK_C": 0.2217676,
    "CMYK_M": 0.2178411,
    "CMYK_Y": 0,
    "CMYK_K": 0.7013548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08049",
    "Farbtonhilfsbezeichnung": "V9.19.11",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "58",
    "Bcolor": "82",
    "Y": 5,
    "L": 25.348191340195,
    "a": 5.8846921335575,
    "b": -14.9495437408896,
    "C": 16.0660654663028,
    "h": -1.19578738320974,
    "CMY_C": 0.7765762,
    "CMY_M": 0.7715858,
    "CMY_Y": 0.678517,
    "CMYK_C": 0.3050213,
    "CMYK_M": 0.2894982,
    "CMYK_Y": 0,
    "CMYK_K": 0.678517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08050",
    "Farbtonhilfsbezeichnung": "V4.20.16",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "63",
    "Bcolor": "86",
    "Y": 5,
    "L": 27.3520487764814,
    "a": 4.63484969396677,
    "b": -14.2681934103371,
    "C": 15.0021056815519,
    "h": -1.25671106700232,
    "CMY_C": 0.7646689,
    "CMY_M": 0.7516241,
    "CMY_Y": 0.664064,
    "CMYK_C": 0.2994764,
    "CMYK_M": 0.2606453,
    "CMYK_Y": 0,
    "CMYK_K": 0.664064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08051",
    "Farbtonhilfsbezeichnung": "V4.26.15",
    "Farbtonklasse": "04",
    "Rcolor": "54",
    "Gcolor": "59",
    "Bcolor": "89",
    "Y": 5,
    "L": 25.7356566548808,
    "a": 6.46903249985875,
    "b": -19.0916000008754,
    "C": 20.1578166495693,
    "h": -1.24409635360603,
    "CMY_C": 0.787838,
    "CMY_M": 0.7679178,
    "CMY_Y": 0.6503956,
    "CMYK_C": 0.3931368,
    "CMYK_M": 0.3361576,
    "CMYK_Y": 0,
    "CMYK_K": 0.6503956
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08052",
    "Farbtonhilfsbezeichnung": "V9.30.14",
    "Farbtonklasse": "04",
    "Rcolor": "60",
    "Gcolor": "57",
    "Bcolor": "98",
    "Y": 5,
    "L": 25.9939432676852,
    "a": 12.8258876572133,
    "b": -24.2127764796203,
    "C": 27.4000353840558,
    "h": -1.08365973266731,
    "CMY_C": 0.7631851,
    "CMY_M": 0.7776717,
    "CMY_Y": 0.6170023,
    "CMYK_C": 0.3816806,
    "CMYK_M": 0.4195048,
    "CMYK_Y": 0,
    "CMYK_K": 0.6170023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08053",
    "Farbtonhilfsbezeichnung": "V5.34.14",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "58",
    "Bcolor": "90",
    "Y": 4,
    "L": 25.1900053037834,
    "a": 6.76698607037043,
    "b": -20.4880134656421,
    "C": 21.5766261552848,
    "h": -1.2517872639981,
    "CMY_C": 0.797691,
    "CMY_M": 0.7727678,
    "CMY_Y": 0.6472296,
    "CMYK_C": 0.4265138,
    "CMYK_M": 0.3558639,
    "CMYK_Y": 0,
    "CMYK_K": 0.6472296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08054",
    "Farbtonhilfsbezeichnung": "W4.24.55",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "144",
    "Bcolor": "202",
    "Y": 32,
    "L": 63.7150187191433,
    "a": 19.9027978587606,
    "b": -27.6724107528999,
    "C": 34.0864148816489,
    "h": -0.94728128928116,
    "CMY_C": 0.3495229,
    "CMY_M": 0.4335431,
    "CMY_Y": 0.2068627,
    "CMYK_C": 0.1798683,
    "CMYK_M": 0.2858022,
    "CMYK_Y": 0,
    "CMYK_K": 0.2068627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08055",
    "Farbtonhilfsbezeichnung": "W5.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "193",
    "Bcolor": "222",
    "Y": 57,
    "L": 80.0310443036706,
    "a": 11.2309668065226,
    "b": -13.7121381342435,
    "C": 17.7244844106052,
    "h": -0.88454523876441,
    "CMY_C": 0.1839362,
    "CMY_M": 0.24426,
    "CMY_Y": 0.1276948,
    "CMYK_C": 0.06447447,
    "CMYK_M": 0.133629,
    "CMYK_Y": 0,
    "CMYK_K": 0.1276948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08056",
    "Farbtonhilfsbezeichnung": "V9.07.75",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "202",
    "Bcolor": "222",
    "Y": 61,
    "L": 82.2683032759966,
    "a": 5.58556489622325,
    "b": -10.3087533002797,
    "C": 11.724714487609,
    "h": -1.07424931770455,
    "CMY_C": 0.1906002,
    "CMY_M": 0.2071369,
    "CMY_Y": 0.1282917,
    "CMYK_C": 0.07147872,
    "CMYK_M": 0.09044914,
    "CMYK_Y": 0,
    "CMYK_K": 0.1282917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08057",
    "Farbtonhilfsbezeichnung": "W4.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "214",
    "Bcolor": "230",
    "Y": 69,
    "L": 86.5258845069072,
    "a": 5.94732973079631,
    "b": -7.74105290863416,
    "C": 9.76189689871221,
    "h": -0.9156955688827,
    "CMY_C": 0.1314042,
    "CMY_M": 0.1622342,
    "CMY_Y": 0.09987696,
    "CMYK_C": 0.0350255,
    "CMYK_M": 0.06927633,
    "CMYK_Y": 0,
    "CMYK_K": 0.09987696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08058",
    "Farbtonhilfsbezeichnung": "WN.02.84",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "228",
    "Bcolor": "232",
    "Y": 78,
    "L": 90.939172655612,
    "a": 2.0344489154745,
    "b": -2.49575619932751,
    "C": 3.21990394206987,
    "h": -0.88687760154759,
    "CMY_C": 0.09446514,
    "CMY_M": 0.1054675,
    "CMY_Y": 0.09001638,
    "CMYK_C": 0.004888837,
    "CMYK_M": 0.01697956,
    "CMYK_Y": 0,
    "CMYK_K": 0.09001638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08059",
    "Farbtonhilfsbezeichnung": "W1.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "218",
    "Bcolor": "228",
    "Y": 72,
    "L": 87.5656051635742,
    "a": 2.85723662376404,
    "b": -5.26528978347778,
    "C": 5.99058246612549,
    "h": 298.486694335938,
    "CMY_C": 0.13528168201447,
    "CMY_M": 0.14400285482407,
    "CMY_Y": 0.10689979791641,
    "CMYK_C": 0.03177905827761,
    "CMYK_M": 0.04154411330819,
    "CMYK_Y": 0,
    "CMYK_K": 0.10689979791641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08060",
    "Farbtonhilfsbezeichnung": "W4.06.73",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "199",
    "Bcolor": "217",
    "Y": 59,
    "L": 81.2535378680265,
    "a": 6.655934801225,
    "b": -8.92516291981718,
    "C": 11.1337325827163,
    "h": -0.93002116352546,
    "CMY_C": 0.1882294,
    "CMY_M": 0.2212186,
    "CMY_Y": 0.1493217,
    "CMYK_C": 0.0457372,
    "CMYK_M": 0.08451717,
    "CMYK_Y": 0,
    "CMYK_K": 0.1493217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08061",
    "Farbtonhilfsbezeichnung": "W0.12.66",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "176",
    "Bcolor": "208",
    "Y": 46,
    "L": 73.4428101939985,
    "a": 9.0248337511315,
    "b": -15.665292061396,
    "C": 18.0789656674379,
    "h": -1.0481329332347,
    "CMY_C": 0.2798918,
    "CMY_M": 0.3086503,
    "CMY_Y": 0.1862109,
    "CMYK_C": 0.115117,
    "CMYK_M": 0.150456,
    "CMYK_Y": 0,
    "CMYK_K": 0.1862109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08062",
    "Farbtonhilfsbezeichnung": "W0.16.62",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "166",
    "Bcolor": "208",
    "Y": 41,
    "L": 70.0478174106206,
    "a": 12.4028714895607,
    "b": -21.2804936279202,
    "C": 24.631090723606,
    "h": -1.04309885903276,
    "CMY_C": 0.3126239,
    "CMY_M": 0.3508576,
    "CMY_Y": 0.1832343,
    "CMYK_C": 0.1584171,
    "CMYK_M": 0.2052282,
    "CMYK_Y": 0,
    "CMYK_K": 0.1832343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08063",
    "Farbtonhilfsbezeichnung": "W2.25.54",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "144",
    "Bcolor": "202",
    "Y": 32,
    "L": 63.0498948221429,
    "a": 18.5625813139867,
    "b": -28.610930357975,
    "C": 34.1050547717969,
    "h": -0.99526983504136,
    "CMY_C": 0.3708182,
    "CMY_M": 0.4364001,
    "CMY_Y": 0.2077373,
    "CMYK_C": 0.205842,
    "CMYK_M": 0.28862,
    "CMYK_Y": 0,
    "CMYK_K": 0.2077373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08064",
    "Farbtonhilfsbezeichnung": "W0.22.52",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "137",
    "Bcolor": "187",
    "Y": 27,
    "L": 59.4034561627111,
    "a": 14.3766264903038,
    "b": -25.5640285559627,
    "C": 29.3292847722508,
    "h": -1.05850016485635,
    "CMY_C": 0.4279652,
    "CMY_M": 0.4640354,
    "CMY_Y": 0.2684201,
    "CMYK_C": 0.2180829,
    "CMYK_M": 0.2673875,
    "CMYK_Y": 0,
    "CMYK_K": 0.2684201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08065",
    "Farbtonhilfsbezeichnung": "W0.17.60",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "160",
    "Bcolor": "202",
    "Y": 37,
    "L": 67.692268371582,
    "a": 12.0172109603882,
    "b": -21.3776550292969,
    "C": 24.5238151550293,
    "h": 299.342041015625,
    "CMY_C": 0.34110909700394,
    "CMY_M": 0.37447756528854,
    "CMY_Y": 0.20822185277939,
    "CMYK_C": 0.16783393919468,
    "CMYK_M": 0.2099776417017,
    "CMYK_Y": 0,
    "CMYK_K": 0.20822185277939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08066",
    "Farbtonhilfsbezeichnung": "W0.13.64",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "168",
    "Bcolor": "200",
    "Y": 41,
    "L": 70.2641149201692,
    "a": 9.48728210495309,
    "b": -16.4453745863603,
    "C": 18.9857543180319,
    "h": -1.04753780512792,
    "CMY_C": 0.3133627,
    "CMY_M": 0.3431049,
    "CMY_Y": 0.2151621,
    "CMYK_C": 0.1251221,
    "CMYK_M": 0.1630181,
    "CMYK_Y": 0,
    "CMYK_K": 0.2151621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08067",
    "Farbtonhilfsbezeichnung": "W0.09.72",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "194",
    "Bcolor": "218",
    "Y": 56,
    "L": 79.5630722045898,
    "a": 6.87629795074463,
    "b": -12.1486120223999,
    "C": 13.9596652984619,
    "h": 299.510528564453,
    "CMY_C": 0.21692031621933,
    "CMY_M": 0.23899275064468,
    "CMY_Y": 0.14462077617645,
    "CMYK_C": 0.0845233798027,
    "CMYK_M": 0.11032764613628,
    "CMYK_Y": 0,
    "CMYK_K": 0.14462077617645
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08068",
    "Farbtonhilfsbezeichnung": "WN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "215",
    "Bcolor": "222",
    "Y": 69,
    "L": 86.5772493345559,
    "a": 2.63528130384971,
    "b": -3.43343424970179,
    "C": 4.32818418016669,
    "h": -0.9161668821032,
    "CMY_C": 0.141453,
    "CMY_M": 0.1549568,
    "CMY_Y": 0.1312632,
    "CMYK_C": 0.01172946,
    "CMYK_M": 0.02727371,
    "CMYK_Y": 0,
    "CMYK_K": 0.1312632
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08069",
    "Farbtonhilfsbezeichnung": "WN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "212",
    "Bcolor": "218",
    "Y": 67,
    "L": 85.484804810189,
    "a": 2.71612424715784,
    "b": -3.30732866548098,
    "C": 4.27969085653519,
    "h": -0.88323521274416,
    "CMY_C": 0.1524341,
    "CMY_M": 0.1672096,
    "CMY_Y": 0.1441832,
    "CMYK_C": 0.009641011,
    "CMYK_M": 0.02690579,
    "CMYK_Y": 0,
    "CMYK_K": 0.1441832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08070",
    "Farbtonhilfsbezeichnung": "WN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "219",
    "Bcolor": "223",
    "Y": 71,
    "L": 87.5626476699511,
    "a": 1.58226968926956,
    "b": -2.94257307397121,
    "C": 3.34100488853901,
    "h": -1.07743281996308,
    "CMY_C": 0.1371258,
    "CMY_M": 0.1417137,
    "CMY_Y": 0.1241452,
    "CMYK_C": 0.01482054,
    "CMYK_M": 0.02005868,
    "CMYK_Y": 0,
    "CMYK_K": 0.1241452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08071",
    "Farbtonhilfsbezeichnung": "W4.05.73",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "196",
    "Bcolor": "209",
    "Y": 57,
    "L": 79.9584718753893,
    "a": 4.92442532996229,
    "b": -6.72901976459002,
    "C": 8.33844540802524,
    "h": -0.93903287860495,
    "CMY_C": 0.2078699,
    "CMY_M": 0.2317491,
    "CMY_Y": 0.1795271,
    "CMYK_C": 0.03454455,
    "CMYK_M": 0.06364871,
    "CMYK_Y": 0,
    "CMYK_K": 0.1795271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08072",
    "Farbtonhilfsbezeichnung": "W0.10.63",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "168",
    "Bcolor": "193",
    "Y": 41,
    "L": 70.0412541232037,
    "a": 7.29080919053438,
    "b": -12.6629384622722,
    "C": 14.6118414018245,
    "h": -1.04839132696049,
    "CMY_C": 0.3180234,
    "CMY_M": 0.3414128,
    "CMY_Y": 0.2443439,
    "CMYK_C": 0.09750406,
    "CMYK_M": 0.1284564,
    "CMYK_Y": 0,
    "CMYK_K": 0.2443439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08073",
    "Farbtonhilfsbezeichnung": "W0.16.54",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "145",
    "Bcolor": "184",
    "Y": 31,
    "L": 62.1257387496062,
    "a": 10.7219146733672,
    "b": -19.6425692741089,
    "C": 22.3783373366105,
    "h": -1.07114416347402,
    "CMY_C": 0.4024799,
    "CMY_M": 0.4295043,
    "CMY_Y": 0.2802288,
    "CMYK_C": 0.1698473,
    "CMYK_M": 0.2073931,
    "CMYK_Y": 0,
    "CMYK_K": 0.2802288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08074",
    "Farbtonhilfsbezeichnung": "W4.24.51",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "133",
    "Bcolor": "188",
    "Y": 27,
    "L": 59.2365771597627,
    "a": 18.8136714783454,
    "b": -26.4981587283097,
    "C": 32.4977945480274,
    "h": -0.95339096743057,
    "CMY_C": 0.4000869,
    "CMY_M": 0.4767934,
    "CMY_Y": 0.2634022,
    "CMYK_C": 0.1855622,
    "CMYK_M": 0.2896984,
    "CMYK_Y": 0,
    "CMYK_K": 0.2634022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08075",
    "Farbtonhilfsbezeichnung": "W0.25.52",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "135",
    "Bcolor": "194",
    "Y": 27,
    "L": 59.3419274613993,
    "a": 17.238287029918,
    "b": -30.0852325013911,
    "C": 34.6739059580631,
    "h": -1.05048019173947,
    "CMY_C": 0.4268714,
    "CMY_M": 0.4700839,
    "CMY_Y": 0.2379103,
    "CMYK_C": 0.2479512,
    "CMYK_M": 0.3046539,
    "CMYK_Y": 0,
    "CMYK_K": 0.2379103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08076",
    "Farbtonhilfsbezeichnung": "W2.29.45",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "121",
    "Bcolor": "181",
    "Y": 22,
    "L": 54.0982203651584,
    "a": 18.8582857505509,
    "b": -30.8537931671244,
    "C": 36.1606345941153,
    "h": -1.02217165171412,
    "CMY_C": 0.4725993,
    "CMY_M": 0.5265713,
    "CMY_Y": 0.2888519,
    "CMYK_C": 0.2583814,
    "CMYK_M": 0.3342755,
    "CMYK_Y": 0,
    "CMYK_K": 0.2888519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08077",
    "Farbtonhilfsbezeichnung": "W0.21.51",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "136",
    "Bcolor": "183",
    "Y": 26,
    "L": 58.8373947143555,
    "a": 13.660810470581,
    "b": -24.5268115997314,
    "C": 28.0745830535889,
    "h": 299.11669921875,
    "CMY_C": 0.43480932712555,
    "CMY_M": 0.46836948394775,
    "CMY_Y": 0.28161001205444,
    "CMYK_C": 0.21325369179249,
    "CMYK_M": 0.25996947288513,
    "CMYK_Y": 0,
    "CMYK_K": 0.28161001205444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08078",
    "Farbtonhilfsbezeichnung": "W1.10.61",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "163",
    "Bcolor": "189",
    "Y": 39,
    "L": 68.4338560062421,
    "a": 8.06956744587584,
    "b": -12.7750702056061,
    "C": 15.1102725826407,
    "h": -1.00741840040176,
    "CMY_C": 0.3295458,
    "CMY_M": 0.3601152,
    "CMY_Y": 0.2606927,
    "CMYK_C": 0.09313192,
    "CMYK_M": 0.1344806,
    "CMYK_Y": 0,
    "CMYK_K": 0.2606927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08079",
    "Farbtonhilfsbezeichnung": "W4.08.64",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "172",
    "Bcolor": "193",
    "Y": 43,
    "L": 71.6114358132344,
    "a": 7.70240238223019,
    "b": -10.5246146529542,
    "C": 13.0420288318561,
    "h": -0.93901504986586,
    "CMY_C": 0.2902766,
    "CMY_M": 0.3265437,
    "CMY_Y": 0.242453,
    "CMYK_C": 0.06312963,
    "CMYK_M": 0.111004,
    "CMYK_Y": 0,
    "CMYK_K": 0.242453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08080",
    "Farbtonhilfsbezeichnung": "W5.03.69",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "187",
    "Bcolor": "196",
    "Y": 51,
    "L": 76.6054363084327,
    "a": 3.65171816485871,
    "b": -4.75889270185252,
    "C": 5.99850858991669,
    "h": -0.91628577392449,
    "CMY_C": 0.2470625,
    "CMY_M": 0.2654627,
    "CMY_Y": 0.2301126,
    "CMYK_C": 0.02201611,
    "CMYK_M": 0.04591592,
    "CMYK_Y": 0,
    "CMYK_K": 0.2301126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08081",
    "Farbtonhilfsbezeichnung": "WN.02.73",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "200",
    "Bcolor": "207",
    "Y": 59,
    "L": 81.1747914107531,
    "a": 2.75597570869479,
    "b": -3.59399848571609,
    "C": 4.52904263859872,
    "h": -0.91661251977702,
    "CMY_C": 0.2003689,
    "CMY_M": 0.2143281,
    "CMY_Y": 0.1891715,
    "CMYK_C": 0.01380977,
    "CMYK_M": 0.0310258,
    "CMYK_Y": 0,
    "CMYK_K": 0.1891715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08082",
    "Farbtonhilfsbezeichnung": "WN.02.70",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "190",
    "Bcolor": "195",
    "Y": 52,
    "L": 77.4000831821413,
    "a": 1.70801217653799,
    "b": -2.7339216421806,
    "C": 3.22360561185538,
    "h": -1.01237821956323,
    "CMY_C": 0.2464103,
    "CMY_M": 0.2529596,
    "CMY_Y": 0.2362799,
    "CMYK_C": 0.01326453,
    "CMYK_M": 0.02183999,
    "CMYK_Y": 0,
    "CMYK_K": 0.2362799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08083",
    "Farbtonhilfsbezeichnung": "WN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "192",
    "Bcolor": "199",
    "Y": 54,
    "L": 78.2684257010865,
    "a": 2.79219437309774,
    "b": -3.73857367665342,
    "C": 4.66618501057605,
    "h": -0.92930729292524,
    "CMY_C": 0.2321573,
    "CMY_M": 0.2458438,
    "CMY_Y": 0.2195975,
    "CMYK_C": 0.01609396,
    "CMYK_M": 0.03363171,
    "CMYK_Y": 0,
    "CMYK_K": 0.2195975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08084",
    "Farbtonhilfsbezeichnung": "W1.06.62",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "169",
    "Bcolor": "186",
    "Y": 41,
    "L": 70.1962477151371,
    "a": 5.27796998700986,
    "b": -8.54065083876654,
    "C": 10.0399045779081,
    "h": -1.0172594610608,
    "CMY_C": 0.3165374,
    "CMY_M": 0.3363168,
    "CMY_Y": 0.2718113,
    "CMYK_C": 0.06142107,
    "CMYK_M": 0.08858353,
    "CMYK_Y": 0,
    "CMYK_K": 0.2718113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08085",
    "Farbtonhilfsbezeichnung": "W1.10.53",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "144",
    "Bcolor": "168",
    "Y": 29,
    "L": 60.9320359329301,
    "a": 7.31674231446439,
    "b": -12.3503218609115,
    "C": 14.3549701554682,
    "h": -1.03595913125984,
    "CMY_C": 0.4120794,
    "CMY_M": 0.4360978,
    "CMY_Y": 0.3430692,
    "CMYK_C": 0.1050494,
    "CMYK_M": 0.1416109,
    "CMYK_Y": 0,
    "CMYK_K": 0.3430692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08086",
    "Farbtonhilfsbezeichnung": "W0.23.43",
    "Farbtonklasse": "03",
    "Rcolor": "124",
    "Gcolor": "116",
    "Bcolor": "163",
    "Y": 19,
    "L": 51.1738651686472,
    "a": 13.8158503864024,
    "b": -24.7903545281708,
    "C": 28.3802642611349,
    "h": -1.06236007184336,
    "CMY_C": 0.5134972,
    "CMY_M": 0.5452054,
    "CMY_Y": 0.3607498,
    "CMYK_C": 0.2389478,
    "CMYK_M": 0.28855,
    "CMYK_Y": 0,
    "CMYK_K": 0.3607498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08087",
    "Farbtonhilfsbezeichnung": "W0.27.43",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "115",
    "Bcolor": "171",
    "Y": 20,
    "L": 51.4881380754053,
    "a": 16.6202193076948,
    "b": -28.8983259582878,
    "C": 33.3368404775755,
    "h": -1.04886630166107,
    "CMY_C": 0.5075699,
    "CMY_M": 0.5474413,
    "CMY_Y": 0.3298601,
    "CMYK_C": 0.2651831,
    "CMYK_M": 0.3246802,
    "CMYK_Y": 0,
    "CMYK_K": 0.3298601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08088",
    "Farbtonhilfsbezeichnung": "W0.31.43",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "111",
    "Bcolor": "173",
    "Y": 19,
    "L": 50.2118366990444,
    "a": 18.6743368402368,
    "b": -32.0712330792343,
    "C": 37.1119232544636,
    "h": -1.04351049159728,
    "CMY_C": 0.5199481,
    "CMY_M": 0.5638646,
    "CMY_Y": 0.3220337,
    "CMYK_C": 0.2919236,
    "CMYK_M": 0.3567005,
    "CMYK_Y": 0,
    "CMYK_K": 0.3220337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08089",
    "Farbtonhilfsbezeichnung": "W2.34.35",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "95",
    "Bcolor": "159",
    "Y": 14,
    "L": 44.1950117609159,
    "a": 20.7394482476428,
    "b": -33.4873891582848,
    "C": 39.3894649145564,
    "h": -1.01629110788602,
    "CMY_C": 0.5725396,
    "CMY_M": 0.6268353,
    "CMY_Y": 0.3758078,
    "CMYK_C": 0.3151782,
    "CMYK_M": 0.4021639,
    "CMYK_Y": 0,
    "CMYK_K": 0.3758078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08090",
    "Farbtonhilfsbezeichnung": "W4.29.40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "109",
    "Bcolor": "166",
    "Y": 18,
    "L": 49.8961247285589,
    "a": 20.2116195518737,
    "b": -28.5085808633065,
    "C": 34.9463695932691,
    "h": -0.9540781079433,
    "CMY_C": 0.4952729,
    "CMY_M": 0.5726336,
    "CMY_Y": 0.3488875,
    "CMYK_C": 0.2248235,
    "CMYK_M": 0.3436365,
    "CMYK_Y": 0,
    "CMYK_K": 0.3488875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08091",
    "Farbtonhilfsbezeichnung": "W0.19.43",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "117",
    "Bcolor": "156",
    "Y": 19,
    "L": 51.2237298340999,
    "a": 11.6849059056336,
    "b": -20.6071759093576,
    "C": 23.6895066428729,
    "h": -1.05497164532966,
    "CMY_C": 0.5110471,
    "CMY_M": 0.5411386,
    "CMY_Y": 0.388172,
    "CMYK_C": 0.2008328,
    "CMYK_M": 0.2500156,
    "CMYK_Y": 0,
    "CMYK_K": 0.388172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08092",
    "Farbtonhilfsbezeichnung": "W2.15.46",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "126",
    "Bcolor": "157",
    "Y": 22,
    "L": 54.4553080694177,
    "a": 10.1635014187617,
    "b": -15.9663664327305,
    "C": 18.9267434640351,
    "h": -1.00392953196315,
    "CMY_C": 0.471065,
    "CMY_M": 0.5070927,
    "CMY_Y": 0.3857454,
    "CMYK_C": 0.1388994,
    "CMYK_M": 0.1975522,
    "CMYK_Y": 0,
    "CMYK_K": 0.3857454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08093",
    "Farbtonhilfsbezeichnung": "W3.10.51",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "140",
    "Bcolor": "162",
    "Y": 28,
    "L": 59.5622874046132,
    "a": 7.59249592247974,
    "b": -11.2297088971599,
    "C": 13.5555286229576,
    "h": -0.97628587221454,
    "CMY_C": 0.4200809,
    "CMY_M": 0.4510844,
    "CMY_Y": 0.3649445,
    "CMYK_C": 0.08682135,
    "CMYK_M": 0.1356416,
    "CMYK_Y": 0,
    "CMYK_K": 0.3649445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08094",
    "Farbtonhilfsbezeichnung": "W1.07.53",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "145",
    "Bcolor": "160",
    "Y": 29,
    "L": 60.941898596778,
    "a": 4.85926201249481,
    "b": -8.33615371619776,
    "C": 9.64903550030535,
    "h": -1.04303468907649,
    "CMY_C": 0.4156843,
    "CMY_M": 0.4315593,
    "CMY_Y": 0.3705983,
    "CMYK_C": 0.07163309,
    "CMYK_M": 0.0968555,
    "CMYK_Y": 0,
    "CMYK_K": 0.3705983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08095",
    "Farbtonhilfsbezeichnung": "WN.02.53",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "148",
    "Bcolor": "153",
    "Y": 30,
    "L": 61.6312031581394,
    "a": 1.46656850212618,
    "b": -3.03366573879653,
    "C": 3.36956243244973,
    "h": -1.12049144454767,
    "CMY_C": 0.4154589,
    "CMY_M": 0.4183793,
    "CMY_Y": 0.4000451,
    "CMYK_C": 0.02569152,
    "CMYK_M": 0.03055925,
    "CMYK_Y": 0,
    "CMYK_K": 0.4000451
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08096",
    "Farbtonhilfsbezeichnung": "W2.04.52",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "146",
    "Bcolor": "155",
    "Y": 29,
    "L": 60.9165755816486,
    "a": 2.79287810749979,
    "b": -5.03000698344043,
    "C": 5.75335887780443,
    "h": -1.0639363989172,
    "CMY_C": 0.4197436,
    "CMY_M": 0.428111,
    "CMY_Y": 0.3936222,
    "CMYK_C": 0.04307772,
    "CMYK_M": 0.05687676,
    "CMYK_Y": 0,
    "CMYK_K": 0.3936222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08097",
    "Farbtonhilfsbezeichnung": "W1.05.46",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "128",
    "Bcolor": "139",
    "Y": 22,
    "L": 54.1035936829646,
    "a": 3.20760039771301,
    "b": -6.13152857056571,
    "C": 6.91985136567775,
    "h": -1.0888146270152,
    "CMY_C": 0.4897062,
    "CMY_M": 0.4977498,
    "CMY_Y": 0.4556483,
    "CMYK_C": 0.06256591,
    "CMYK_M": 0.07734247,
    "CMYK_Y": 0,
    "CMYK_K": 0.4556483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08098",
    "Farbtonhilfsbezeichnung": "W0.09.40",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "111",
    "Bcolor": "130",
    "Y": 17,
    "L": 47.851209149242,
    "a": 5.74412053761736,
    "b": -10.6569211743497,
    "C": 12.1063987075836,
    "h": -1.07643471026438,
    "CMY_C": 0.549484,
    "CMY_M": 0.5638522,
    "CMY_Y": 0.4884072,
    "CMYK_C": 0.1193855,
    "CMYK_M": 0.1474707,
    "CMYK_Y": 0,
    "CMYK_K": 0.4884072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08099",
    "Farbtonhilfsbezeichnung": "W5.10.44",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "120",
    "Bcolor": "142",
    "Y": 20,
    "L": 51.9884727192199,
    "a": 8.53025445060474,
    "b": -11.2325930895636,
    "C": 14.1044811498961,
    "h": -0.92129370585874,
    "CMY_C": 0.4904806,
    "CMY_M": 0.5293501,
    "CMY_Y": 0.44265,
    "CMYK_C": 0.08581803,
    "CMYK_M": 0.1555578,
    "CMYK_Y": 0,
    "CMYK_K": 0.44265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08100",
    "Farbtonhilfsbezeichnung": "W0.20.34",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "97",
    "Bcolor": "132",
    "Y": 13,
    "L": 42.95412144166,
    "a": 11.0434671520691,
    "b": -18.8426390602494,
    "C": 21.8404032356014,
    "h": -1.04066815788998,
    "CMY_C": 0.5907384,
    "CMY_M": 0.6204866,
    "CMY_Y": 0.4840694,
    "CMYK_C": 0.2067506,
    "CMYK_M": 0.26441,
    "CMYK_Y": 0,
    "CMYK_K": 0.4840694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08101",
    "Farbtonhilfsbezeichnung": "W2.25.35",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "98",
    "Bcolor": "143",
    "Y": 14,
    "L": 44.2280336194326,
    "a": 15.0520009931503,
    "b": -23.5829086425308,
    "C": 27.9770676436926,
    "h": -1.00271929547195,
    "CMY_C": 0.5688815,
    "CMY_M": 0.616209,
    "CMY_Y": 0.4402875,
    "CMYK_C": 0.2297499,
    "CMYK_M": 0.3143069,
    "CMYK_Y": 0,
    "CMYK_K": 0.4402875
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08102",
    "Farbtonhilfsbezeichnung": "W0.33.32",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "94",
    "Bcolor": "151",
    "Y": 13,
    "L": 42.9674606323242,
    "a": 16.8464679718018,
    "b": -30.5038871765137,
    "C": 34.8466720581055,
    "h": 298.910675048828,
    "CMY_C": 0.59989595413208,
    "CMY_M": 0.62974387407303,
    "CMY_Y": 0.40828007459641,
    "CMYK_C": 0.32382866740227,
    "CMYK_M": 0.37427133321762,
    "CMYK_Y": 0,
    "CMYK_K": 0.40828007459641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08104",
    "Farbtonhilfsbezeichnung": "W1.39.24",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "72",
    "Bcolor": "132",
    "Y": 8,
    "L": 34.2986260801318,
    "a": 19.6867556474772,
    "b": -32.9713170264357,
    "C": 38.4015116158363,
    "h": -1.03252124799791,
    "CMY_C": 0.6770936,
    "CMY_M": 0.716651,
    "CMY_Y": 0.4809804,
    "CMYK_C": 0.3778531,
    "CMYK_M": 0.4540688,
    "CMYK_Y": 0,
    "CMYK_K": 0.4809804
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08105",
    "Farbtonhilfsbezeichnung": "W4.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "83",
    "Bcolor": "134",
    "Y": 11,
    "L": 38.8970379845542,
    "a": 18.850426111415,
    "b": -26.4868891638971,
    "C": 32.5099040626465,
    "h": -0.95226843829921,
    "CMY_C": 0.6069745,
    "CMY_M": 0.6751255,
    "CMY_Y": 0.4754828,
    "CMYK_C": 0.2506909,
    "CMYK_M": 0.3806219,
    "CMYK_Y": 0,
    "CMYK_K": 0.4754828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08106",
    "Farbtonhilfsbezeichnung": "W0.28.33",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "94",
    "Bcolor": "144",
    "Y": 13,
    "L": 42.6078003953167,
    "a": 14.7280661756394,
    "b": -26.7891678316577,
    "C": 30.5708267206947,
    "h": -1.06812440275452,
    "CMY_C": 0.6016622,
    "CMY_M": 0.6295151,
    "CMY_Y": 0.4361658,
    "CMYK_C": 0.2935195,
    "CMYK_M": 0.3429186,
    "CMYK_Y": 0,
    "CMYK_K": 0.4361658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08107",
    "Farbtonhilfsbezeichnung": "W0.19.30",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "88",
    "Bcolor": "121",
    "Y": 11,
    "L": 39.0100578018345,
    "a": 10.0548429830606,
    "b": -18.3126936455186,
    "C": 20.8914962596895,
    "h": -1.06867192732563,
    "CMY_C": 0.633953,
    "CMY_M": 0.6556694,
    "CMY_Y": 0.5268242,
    "CMYK_C": 0.2264038,
    "CMYK_M": 0.2722987,
    "CMYK_Y": 0,
    "CMYK_K": 0.5268242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08108",
    "Farbtonhilfsbezeichnung": "W1.15.35",
    "Farbtonklasse": "03",
    "Rcolor": "110",
    "Gcolor": "104",
    "Bcolor": "131",
    "Y": 15,
    "L": 45.4730732344521,
    "a": 8.16067246568036,
    "b": -14.6272129747688,
    "C": 16.7496846090116,
    "h": -1.06190025744561,
    "CMY_C": 0.5702342,
    "CMY_M": 0.5911101,
    "CMY_Y": 0.4862147,
    "CMYK_C": 0.1635303,
    "CMYK_M": 0.2041619,
    "CMYK_Y": 0,
    "CMYK_K": 0.4862147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08109",
    "Farbtonhilfsbezeichnung": "W1.08.33",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "99",
    "Bcolor": "113",
    "Y": 13,
    "L": 42.6936938580135,
    "a": 4.33495412681362,
    "b": -7.83255255141819,
    "C": 8.95213420097722,
    "h": -1.06530549426613,
    "CMY_C": 0.5998047,
    "CMY_M": 0.6114665,
    "CMY_Y": 0.5576326,
    "CMYK_C": 0.09533262,
    "CMYK_M": 0.1216949,
    "CMYK_Y": 0,
    "CMYK_K": 0.5576326
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08110",
    "Farbtonhilfsbezeichnung": "W3.05.43",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "120",
    "Bcolor": "132",
    "Y": 19,
    "L": 51.1254643162922,
    "a": 4.20327461691156,
    "b": -6.35649601080412,
    "C": 7.62053535130845,
    "h": -0.98654854731557,
    "CMY_C": 0.5131217,
    "CMY_M": 0.5295336,
    "CMY_Y": 0.4839805,
    "CMYK_C": 0.05647293,
    "CMYK_M": 0.08827783,
    "CMYK_Y": 0,
    "CMYK_K": 0.4839805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08111",
    "Farbtonhilfsbezeichnung": "W1.03.39",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "112",
    "Bcolor": "119",
    "Y": 16,
    "L": 47.6206011055029,
    "a": 2.30557072340171,
    "b": -4.22941979461742,
    "C": 4.81701652059744,
    "h": -1.07170211599728,
    "CMY_C": 0.554159,
    "CMY_M": 0.5604752,
    "CMY_Y": 0.5328516,
    "CMYK_C": 0.04561143,
    "CMYK_M": 0.05913223,
    "CMYK_Y": 0,
    "CMYK_K": 0.5328516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08112",
    "Farbtonhilfsbezeichnung": "W1.06.26",
    "Farbtonklasse": "02",
    "Rcolor": "81",
    "Gcolor": "80",
    "Bcolor": "88",
    "Y": 8,
    "L": 34.2995843696023,
    "a": 2.28913121022464,
    "b": -5.1485998968075,
    "C": 5.63455433863502,
    "h": -1.1524317781756,
    "CMY_C": 0.6841655,
    "CMY_M": 0.6867884,
    "CMY_Y": 0.6546244,
    "CMYK_C": 0.08553337,
    "CMYK_M": 0.09312763,
    "CMYK_Y": 0,
    "CMYK_K": 0.6546244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08113",
    "Farbtonhilfsbezeichnung": "W1.12.33",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "96",
    "Bcolor": "118",
    "Y": 13,
    "L": 42.0697601515259,
    "a": 7.21918099967272,
    "b": -12.0584618422827,
    "C": 14.0542903167617,
    "h": -1.03134669408868,
    "CMY_C": 0.6005141,
    "CMY_M": 0.6224638,
    "CMY_Y": 0.5365435,
    "CMYK_C": 0.1380291,
    "CMYK_M": 0.1853901,
    "CMYK_Y": 0,
    "CMYK_K": 0.5365435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08114",
    "Farbtonhilfsbezeichnung": "W2.14.25",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "85",
    "Bcolor": "106",
    "Y": 8,
    "L": 37.5237579345703,
    "a": 7.51821041107178,
    "b": -11.4099092483521,
    "C": 13.6641693115234,
    "h": 303.381652832031,
    "CMY_C": 0.63968682289124,
    "CMY_M": 0.66616857051849,
    "CMY_Y": 0.5848445892334,
    "CMYK_C": 0.13210049271584,
    "CMYK_M": 0.19588804244995,
    "CMYK_Y": 0,
    "CMYK_K": 0.5848445892334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08115",
    "Farbtonhilfsbezeichnung": "W0.27.24",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "70",
    "Bcolor": "112",
    "Y": 7,
    "L": 32.1525315770756,
    "a": 14.1000409602495,
    "b": -23.892436606727,
    "C": 27.7427410701824,
    "h": -1.03765345525786,
    "CMY_C": 0.694517,
    "CMY_M": 0.7261747,
    "CMY_Y": 0.5592092,
    "CMYK_C": 0.3069659,
    "CMYK_M": 0.3787863,
    "CMYK_Y": 0,
    "CMYK_K": 0.5592092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08116",
    "Farbtonhilfsbezeichnung": "W0.31.24",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "72",
    "Bcolor": "119",
    "Y": 8,
    "L": 33.0077735372184,
    "a": 14.7756653951788,
    "b": -26.8653890673402,
    "C": 30.6605514890037,
    "h": -1.06796164901219,
    "CMY_C": 0.6954628,
    "CMY_M": 0.7187746,
    "CMY_Y": 0.5323723,
    "CMYK_C": 0.3487615,
    "CMYK_M": 0.3986126,
    "CMYK_Y": 0,
    "CMYK_K": 0.5323723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08117",
    "Farbtonhilfsbezeichnung": "W2.35.28",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "76",
    "Bcolor": "134",
    "Y": 9,
    "L": 36.2001975689143,
    "a": 19.8942757213579,
    "b": -30.6740318414821,
    "C": 36.5606131771564,
    "h": -0.99542660208857,
    "CMY_C": 0.6451392,
    "CMY_M": 0.7009453,
    "CMY_Y": 0.4761779,
    "CMYK_C": 0.3225546,
    "CMYK_M": 0.4290912,
    "CMYK_Y": 0,
    "CMYK_K": 0.4761779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08118",
    "Farbtonhilfsbezeichnung": "W0.36.23",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "70",
    "Bcolor": "126",
    "Y": 7,
    "L": 32.7328473297538,
    "a": 17.0801717728828,
    "b": -31.5832020817782,
    "C": 35.9058619382633,
    "h": -1.075044469507,
    "CMY_C": 0.7051461,
    "CMY_M": 0.7247792,
    "CMY_Y": 0.5056264,
    "CMYK_C": 0.4035809,
    "CMYK_M": 0.4432939,
    "CMYK_Y": 0,
    "CMYK_K": 0.5056264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08119",
    "Farbtonhilfsbezeichnung": "W2.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "78",
    "Bcolor": "115",
    "Y": 9,
    "L": 35.3879139353871,
    "a": 12.4543162310354,
    "b": -20.4695757996112,
    "C": 23.9606662302754,
    "h": -1.02420090730417,
    "CMY_C": 0.6605183,
    "CMY_M": 0.6941144,
    "CMY_Y": 0.5487887,
    "CMYK_C": 0.2476214,
    "CMYK_M": 0.3220791,
    "CMYK_Y": 0,
    "CMYK_K": 0.5487887
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08120",
    "Farbtonhilfsbezeichnung": "W4.22.23",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "73",
    "Bcolor": "107",
    "Y": 8,
    "L": 33.2585833981313,
    "a": 12.8887969109288,
    "b": -18.4088378417451,
    "C": 22.4723473739357,
    "h": -0.95997519919215,
    "CMY_C": 0.6695106,
    "CMY_M": 0.7154401,
    "CMY_Y": 0.5822437,
    "CMYK_C": 0.2088942,
    "CMYK_M": 0.3188374,
    "CMYK_Y": 0,
    "CMYK_K": 0.5822437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08121",
    "Farbtonhilfsbezeichnung": "W1.21.20",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "70",
    "Bcolor": "100",
    "Y": 7,
    "L": 31.3640621025077,
    "a": 9.57480414864723,
    "b": -17.3286586494978,
    "C": 19.7979616394155,
    "h": -1.06600391366871,
    "CMY_C": 0.7056725,
    "CMY_M": 0.7252921,
    "CMY_Y": 0.607366,
    "CMYK_C": 0.2503769,
    "CMYK_M": 0.3003462,
    "CMYK_Y": 0,
    "CMYK_K": 0.607366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08122",
    "Farbtonhilfsbezeichnung": "W4.12.19",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "67",
    "Bcolor": "83",
    "Y": 6,
    "L": 29.6953561209673,
    "a": 6.03789116104017,
    "b": -9.03356791980084,
    "C": 10.8656099246302,
    "h": -0.98160582646832,
    "CMY_C": 0.7142978,
    "CMY_M": 0.7353224,
    "CMY_Y": 0.6734425,
    "CMYK_C": 0.1251092,
    "CMYK_M": 0.1894918,
    "CMYK_Y": 0,
    "CMYK_K": 0.6734425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08123",
    "Farbtonhilfsbezeichnung": "W3.07.26",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "83",
    "Bcolor": "94",
    "Y": 9,
    "L": 35.9642495972763,
    "a": 4.22105213584659,
    "b": -6.07117463416764,
    "C": 7.39435207250072,
    "h": -0.9632578534216,
    "CMY_C": 0.6587157,
    "CMY_M": 0.6751438,
    "CMY_Y": 0.6331539,
    "CMYK_C": 0.06968008,
    "CMYK_M": 0.1144619,
    "CMYK_Y": 0,
    "CMYK_K": 0.6331539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08124",
    "Farbtonhilfsbezeichnung": "W2.09.15",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "62",
    "Bcolor": "74",
    "Y": 5,
    "L": 26.9551691374173,
    "a": 3.98925393595981,
    "b": -6.87376835299536,
    "C": 7.94750516427711,
    "h": -1.04494387674377,
    "CMY_C": 0.7452404,
    "CMY_M": 0.7560961,
    "CMY_Y": 0.7115235,
    "CMYK_C": 0.1168794,
    "CMYK_M": 0.1545103,
    "CMYK_Y": 0,
    "CMYK_K": 0.7115235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08125",
    "Farbtonhilfsbezeichnung": "W2.04.16",
    "Farbtonklasse": "03",
    "Rcolor": "64",
    "Gcolor": "63",
    "Bcolor": "69",
    "Y": 5,
    "L": 26.8490337264166,
    "a": 1.86156366001622,
    "b": -3.92069418497709,
    "C": 4.34019148798831,
    "h": -1.12750742594187,
    "CMY_C": 0.750649,
    "CMY_M": 0.7535998,
    "CMY_Y": 0.730076,
    "CMYK_C": 0.07621764,
    "CMYK_M": 0.08714949,
    "CMYK_Y": 0,
    "CMYK_K": 0.730076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08126",
    "Farbtonhilfsbezeichnung": "W0.05.08",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "45",
    "Bcolor": "48",
    "Y": 3,
    "L": 18.7050163071781,
    "a": 1.90318087941913,
    "b": -2.21158365088702,
    "C": 2.91773879993691,
    "h": -0.86020857333421,
    "CMY_C": 0.8160688,
    "CMY_M": 0.824384,
    "CMY_Y": 0.8106835,
    "CMYK_C": 0.02844586,
    "CMYK_M": 0.07236838,
    "CMYK_Y": 0,
    "CMYK_K": 0.8106835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08127",
    "Farbtonhilfsbezeichnung": "W4.06.14",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "59",
    "Bcolor": "67",
    "Y": 5,
    "L": 25.4822586749586,
    "a": 2.88863837982251,
    "b": -4.95991009551914,
    "C": 5.73976827450519,
    "h": -1.04342053058842,
    "CMY_C": 0.75936,
    "CMY_M": 0.7673889,
    "CMY_Y": 0.7360749,
    "CMYK_C": 0.08822618,
    "CMYK_M": 0.1186475,
    "CMYK_Y": 0,
    "CMYK_K": 0.7360749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08128",
    "Farbtonhilfsbezeichnung": "W0.10.11",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "53",
    "Bcolor": "63",
    "Y": 4,
    "L": 22.3633348659613,
    "a": 2.69998927971948,
    "b": -6.90375631382313,
    "C": 7.41294768302413,
    "h": -1.19799460138398,
    "CMY_C": 0.7940215,
    "CMY_M": 0.7935942,
    "CMY_Y": 0.7524852,
    "CMYK_C": 0.1678132,
    "CMYK_M": 0.166087,
    "CMYK_Y": 0,
    "CMYK_K": 0.7524852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08129",
    "Farbtonhilfsbezeichnung": "W1.14.14",
    "Farbtonklasse": "03",
    "Rcolor": "63",
    "Gcolor": "60",
    "Bcolor": "77",
    "Y": 5,
    "L": 26.1029178056408,
    "a": 5.69223091249663,
    "b": -10.6168999739713,
    "C": 12.0465786768897,
    "h": -1.0786501230005,
    "CMY_C": 0.7543811,
    "CMY_M": 0.7659948,
    "CMY_Y": 0.6970808,
    "CMYK_C": 0.1891605,
    "CMYK_M": 0.2274996,
    "CMYK_Y": 0,
    "CMYK_K": 0.6970808
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08130",
    "Farbtonhilfsbezeichnung": "W0.20.14",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "58",
    "Bcolor": "80",
    "Y": 5,
    "L": 25.7690135752798,
    "a": 7.33877224351462,
    "b": -13.2815604777875,
    "C": 15.1742356238233,
    "h": -1.0659947972292,
    "CMY_C": 0.7561837,
    "CMY_M": 0.7715359,
    "CMY_Y": 0.684329,
    "CMYK_C": 0.2276256,
    "CMYK_M": 0.276259,
    "CMYK_Y": 0,
    "CMYK_K": 0.684329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08131",
    "Farbtonhilfsbezeichnung": "W0.22.12",
    "Farbtonklasse": "04",
    "Rcolor": "57",
    "Gcolor": "53",
    "Bcolor": "79",
    "Y": 4,
    "L": 23.4477361154021,
    "a": 8.89761234836436,
    "b": -16.1966558912342,
    "C": 18.4796960895145,
    "h": -1.06845326852427,
    "CMY_C": 0.7778873,
    "CMY_M": 0.7940448,
    "CMY_Y": 0.6885049,
    "CMYK_C": 0.2869464,
    "CMYK_M": 0.3388171,
    "CMYK_Y": 0,
    "CMYK_K": 0.6885049
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08132",
    "Farbtonhilfsbezeichnung": "W1.30.14",
    "Farbtonklasse": "04",
    "Rcolor": "65",
    "Gcolor": "58",
    "Bcolor": "93",
    "Y": 5,
    "L": 26.5743364499285,
    "a": 12.0202218558891,
    "b": -20.4429893388357,
    "C": 23.7150067799388,
    "h": -1.03925638558749,
    "CMY_C": 0.7460559,
    "CMY_M": 0.7723112,
    "CMY_Y": 0.6340293,
    "CMYK_C": 0.3061081,
    "CMYK_M": 0.3778494,
    "CMYK_Y": 0,
    "CMYK_K": 0.6340293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08133",
    "Farbtonhilfsbezeichnung": "W1.33.20",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "65",
    "Bcolor": "111",
    "Y": 6,
    "L": 30.3412291193179,
    "a": 15.2558019607819,
    "b": -25.8902401919104,
    "C": 30.050691018035,
    "h": -1.03831937059474,
    "CMY_C": 0.7127107,
    "CMY_M": 0.7444136,
    "CMY_Y": 0.5646011,
    "CMYK_C": 0.3401699,
    "CMYK_M": 0.4129834,
    "CMYK_Y": 0,
    "CMYK_K": 0.5646011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08134",
    "Farbtonhilfsbezeichnung": "X0.20.59",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "150",
    "Bcolor": "197",
    "Y": 36,
    "L": 66.5172946635364,
    "a": 21.3650404283999,
    "b": -20.4293225832107,
    "C": 29.5604833133027,
    "h": -0.76301328941169,
    "CMY_C": 0.2806089,
    "CMY_M": 0.4115381,
    "CMY_Y": 0.2265334,
    "CMYK_C": 0.06991314,
    "CMYK_M": 0.239189,
    "CMYK_Y": 0,
    "CMYK_K": 0.2265334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08135",
    "Farbtonhilfsbezeichnung": "W6.17.64",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "167",
    "Bcolor": "212",
    "Y": 44,
    "L": 71.9919110429392,
    "a": 17.3187783241364,
    "b": -20.3759488494296,
    "C": 26.7417159912214,
    "h": -0.86632443538411,
    "CMY_C": 0.2506683,
    "CMY_M": 0.3434149,
    "CMY_Y": 0.1678201,
    "CMYK_C": 0.0995556,
    "CMYK_M": 0.2110057,
    "CMYK_Y": 0,
    "CMYK_K": 0.1678201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08136",
    "Farbtonhilfsbezeichnung": "X0.16.64",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "167",
    "Bcolor": "206",
    "Y": 44,
    "L": 71.9671020163434,
    "a": 17.1767461791244,
    "b": -16.9061834372577,
    "C": 24.1010300135964,
    "h": -0.77745996495857,
    "CMY_C": 0.239134,
    "CMY_M": 0.3445861,
    "CMY_Y": 0.1925712,
    "CMYK_C": 0.05766798,
    "CMYK_M": 0.1882703,
    "CMYK_Y": 0,
    "CMYK_K": 0.1925712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08137",
    "Farbtonhilfsbezeichnung": "W9.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "188",
    "Bcolor": "215",
    "Y": 54,
    "L": 78.5634907478265,
    "a": 11.2472960936267,
    "b": -11.7195221497246,
    "C": 16.2434254033931,
    "h": -0.80595649765209,
    "CMY_C": 0.192642,
    "CMY_M": 0.2607939,
    "CMY_Y": 0.1581358,
    "CMYK_C": 0.04098792,
    "CMYK_M": 0.1219414,
    "CMYK_Y": 0,
    "CMYK_K": 0.1581358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08138",
    "Farbtonhilfsbezeichnung": "W6.07.75",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "199",
    "Bcolor": "220",
    "Y": 60,
    "L": 81.7804172232249,
    "a": 8.61600510540539,
    "b": -9.69439810078478,
    "C": 12.9698457397485,
    "h": -0.84422530783867,
    "CMY_C": 0.170122,
    "CMY_M": 0.2200848,
    "CMY_Y": 0.1377319,
    "CMYK_C": 0.03756388,
    "CMYK_M": 0.09550726,
    "CMYK_Y": 0,
    "CMYK_K": 0.1377319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08139",
    "Farbtonhilfsbezeichnung": "XN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "210",
    "Bcolor": "216",
    "Y": 66,
    "L": 84.8149261474609,
    "a": 4.22852039337158,
    "b": -2.94668102264404,
    "C": 5.15396118164063,
    "h": 325.128967285156,
    "CMY_C": 0.14683985710144,
    "CMY_M": 0.17827600240707,
    "CMY_Y": 0.15395683050156,
    "CMYK_C": 0,
    "CMYK_M": 0.03684671223164,
    "CMYK_Y": 0.0083418963477,
    "CMYK_K": 0.14683985710144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08140",
    "Farbtonhilfsbezeichnung": "X5.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "216",
    "Bcolor": "227",
    "Y": 71,
    "L": 87.4034531951375,
    "a": 4.98360074339632,
    "b": -5.22580809586861,
    "C": 7.22117349358304,
    "h": -0.80911764916769,
    "CMY_C": 0.1202312,
    "CMY_M": 0.1509883,
    "CMY_Y": 0.108705,
    "CMYK_C": 0.01293198,
    "CMYK_M": 0.04744023,
    "CMYK_Y": 0,
    "CMYK_K": 0.108705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08141",
    "Farbtonhilfsbezeichnung": "W8.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "195",
    "Bcolor": "216",
    "Y": 57,
    "L": 80.344102601192,
    "a": 8.83646432164165,
    "b": -9.56388000865427,
    "C": 13.0211713193392,
    "h": -0.82491030975072,
    "CMY_C": 0.1837339,
    "CMY_M": 0.2362446,
    "CMY_Y": 0.1544143,
    "CMYK_C": 0.03467377,
    "CMYK_M": 0.09677351,
    "CMYK_Y": 0,
    "CMYK_K": 0.1544143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08142",
    "Farbtonhilfsbezeichnung": "W6.10.68",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "180",
    "Bcolor": "209",
    "Y": 49,
    "L": 75.4016760001998,
    "a": 11.2668938699123,
    "b": -13.2143659054882,
    "C": 17.3655510641038,
    "h": -0.86478050045268,
    "CMY_C": 0.2323404,
    "CMY_M": 0.2942098,
    "CMY_Y": 0.1820025,
    "CMYK_C": 0.0615379,
    "CMYK_M": 0.1371731,
    "CMYK_Y": 0,
    "CMYK_K": 0.1820025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08143",
    "Farbtonhilfsbezeichnung": "X1.14.64",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "165",
    "Bcolor": "198",
    "Y": 42,
    "L": 70.7569116431916,
    "a": 15.8755484080221,
    "b": -14.5631559985141,
    "C": 21.5434108230918,
    "h": -0.74230894185635,
    "CMY_C": 0.2534045,
    "CMY_M": 0.3547367,
    "CMY_Y": 0.2223126,
    "CMYK_C": 0.03997992,
    "CMYK_M": 0.1702793,
    "CMYK_Y": 0,
    "CMYK_K": 0.2223126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08144",
    "Farbtonhilfsbezeichnung": "W8.19.53",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "139",
    "Bcolor": "182",
    "Y": 30,
    "L": 61.4951042427682,
    "a": 17.9593934789863,
    "b": -19.5847538173392,
    "C": 26.5725873075777,
    "h": -0.82866312428907,
    "CMY_C": 0.3553804,
    "CMY_M": 0.4543258,
    "CMY_Y": 0.2865763,
    "CMYK_C": 0.09644216,
    "CMYK_M": 0.2351331,
    "CMYK_Y": 0,
    "CMYK_K": 0.2865763
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08145",
    "Farbtonhilfsbezeichnung": "W9.21.54",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "137",
    "Bcolor": "185",
    "Y": 30,
    "L": 61.5492732410688,
    "a": 21.331072532307,
    "b": -21.4412468733681,
    "C": 30.244697433819,
    "h": -0.78797399044931,
    "CMY_C": 0.3377138,
    "CMY_M": 0.4621377,
    "CMY_Y": 0.2729365,
    "CMYK_C": 0.08909442,
    "CMYK_M": 0.2602265,
    "CMYK_Y": 0,
    "CMYK_K": 0.2729365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08146",
    "Farbtonhilfsbezeichnung": "W7.23.53",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "137",
    "Bcolor": "192",
    "Y": 30,
    "L": 61.4499775758159,
    "a": 21.5002244464716,
    "b": -25.3007337400278,
    "C": 33.202210454011,
    "h": -0.86642616657959,
    "CMY_C": 0.3521673,
    "CMY_M": 0.4620479,
    "CMY_Y": 0.2475428,
    "CMYK_C": 0.1390438,
    "CMYK_M": 0.2850728,
    "CMYK_Y": 0,
    "CMYK_K": 0.2475428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08147",
    "Farbtonhilfsbezeichnung": "W7.19.53",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "138",
    "Bcolor": "183",
    "Y": 29,
    "L": 60.9639987288642,
    "a": 17.6448627459627,
    "b": -20.9625087622543,
    "C": 27.4001451625981,
    "h": -0.87112054028593,
    "CMY_C": 0.3683896,
    "CMY_M": 0.4583852,
    "CMY_Y": 0.2828467,
    "CMYK_C": 0.1192812,
    "CMYK_M": 0.2447712,
    "CMYK_Y": 0,
    "CMYK_K": 0.2828467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08148",
    "Farbtonhilfsbezeichnung": "X0.15.54",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "142",
    "Bcolor": "177",
    "Y": 31,
    "L": 62.2764388981117,
    "a": 15.6738236684836,
    "b": -15.7357560160242,
    "C": 22.2099699636573,
    "h": -0.78736992704094,
    "CMY_C": 0.3495523,
    "CMY_M": 0.4417842,
    "CMY_Y": 0.3048682,
    "CMYK_C": 0.06428147,
    "CMYK_M": 0.1969641,
    "CMYK_Y": 0,
    "CMYK_K": 0.3048682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08149",
    "Farbtonhilfsbezeichnung": "W7.14.63",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "165",
    "Bcolor": "201",
    "Y": 41,
    "L": 70.3428026090924,
    "a": 14.5612693937962,
    "b": -16.9376910957432,
    "C": 22.3364264378509,
    "h": -0.86069995887518,
    "CMY_C": 0.2760351,
    "CMY_M": 0.3548335,
    "CMY_Y": 0.2102836,
    "CMYK_C": 0.08325966,
    "CMYK_M": 0.1830402,
    "CMYK_Y": 0,
    "CMYK_K": 0.2102836
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08150",
    "Farbtonhilfsbezeichnung": "W8.10.68",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "180",
    "Bcolor": "208",
    "Y": 49,
    "L": 75.5731029337182,
    "a": 11.6456114492702,
    "b": -12.6574934440027,
    "C": 17.1997792518493,
    "h": -0.82701004347633,
    "CMY_C": 0.2256169,
    "CMY_M": 0.2935244,
    "CMY_Y": 0.1840498,
    "CMYK_C": 0.05094327,
    "CMYK_M": 0.1341683,
    "CMYK_Y": 0,
    "CMYK_K": 0.1840498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08151",
    "Farbtonhilfsbezeichnung": "X0.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "203",
    "Bcolor": "216",
    "Y": 62,
    "L": 82.8186248864404,
    "a": 6.28200014108154,
    "b": -6.17643958676104,
    "C": 8.80976343277488,
    "h": -0.77692535054118,
    "CMY_C": 0.1641778,
    "CMY_M": 0.2041442,
    "CMY_Y": 0.1520917,
    "CMYK_C": 0.01425406,
    "CMYK_M": 0.06138928,
    "CMYK_Y": 0,
    "CMYK_K": 0.1520917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08152",
    "Farbtonhilfsbezeichnung": "XN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "215",
    "Bcolor": "217",
    "Y": 68,
    "L": 86.1930862816125,
    "a": 2.16478989587704,
    "b": -1.77290204829221,
    "C": 2.79812382966338,
    "h": -0.68620258184303,
    "CMY_C": 0.1436172,
    "CMY_M": 0.1585541,
    "CMY_Y": 0.1476971,
    "CMYK_C": 0,
    "CMYK_M": 0.01744183,
    "CMYK_Y": 0.004764067,
    "CMYK_K": 0.1436172
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08153",
    "Farbtonhilfsbezeichnung": "XN.02.73",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "197",
    "Bcolor": "202",
    "Y": 57,
    "L": 80.0527498750228,
    "a": 3.65112312175464,
    "b": -2.89803787835032,
    "C": 4.66147225611873,
    "h": -0.67091142505936,
    "CMY_C": 0.203336,
    "CMY_M": 0.2288353,
    "CMY_Y": 0.2062404,
    "CMYK_C": 0,
    "CMYK_M": 0.03200749,
    "CMYK_Y": 0.003645683,
    "CMYK_K": 0.203336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08154",
    "Farbtonhilfsbezeichnung": "W6.04.69",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "186",
    "Bcolor": "198",
    "Y": 51,
    "L": 76.4231083410392,
    "a": 5.31442728769727,
    "b": -5.70487612717616,
    "C": 7.79671398876769,
    "h": -0.82081651460324,
    "CMY_C": 0.2396476,
    "CMY_M": 0.2710871,
    "CMY_Y": 0.2251192,
    "CMYK_C": 0.01874923,
    "CMYK_M": 0.05932248,
    "CMYK_Y": 0,
    "CMYK_K": 0.2251192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08155",
    "Farbtonhilfsbezeichnung": "X1.07.60",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "162",
    "Bcolor": "179",
    "Y": 38,
    "L": 68.0803344297202,
    "a": 8.24965577058179,
    "b": -7.83402181495918,
    "C": 11.3766743000909,
    "h": -0.75956194097242,
    "CMY_C": 0.3143902,
    "CMY_M": 0.3658342,
    "CMY_Y": 0.2988543,
    "CMYK_C": 0.0221578,
    "CMYK_M": 0.09552926,
    "CMYK_Y": 0,
    "CMYK_K": 0.2988543
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08156",
    "Farbtonhilfsbezeichnung": "W7.09.63",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "169",
    "Bcolor": "190",
    "Y": 42,
    "L": 70.7713060742908,
    "a": 8.98757849643295,
    "b": -10.08004261004,
    "C": 13.5049556182079,
    "h": -0.84262979564476,
    "CMY_C": 0.2880413,
    "CMY_M": 0.3386762,
    "CMY_Y": 0.2544299,
    "CMYK_C": 0.04508151,
    "CMYK_M": 0.1129958,
    "CMYK_Y": 0,
    "CMYK_K": 0.2544299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08157",
    "Farbtonhilfsbezeichnung": "W9.12.60",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "160",
    "Bcolor": "190",
    "Y": 38,
    "L": 68.3169392929493,
    "a": 12.4718084804457,
    "b": -13.744395553027,
    "C": 18.5594831795227,
    "h": -0.83390209395684,
    "CMY_C": 0.3015132,
    "CMY_M": 0.3718484,
    "CMY_Y": 0.2546779,
    "CMYK_C": 0.06283901,
    "CMYK_M": 0.1572079,
    "CMYK_Y": 0,
    "CMYK_K": 0.2546779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08158",
    "Farbtonhilfsbezeichnung": "W9.15.51",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "135",
    "Bcolor": "168",
    "Y": 27,
    "L": 59.1177132976787,
    "a": 14.8061404201393,
    "b": -15.565165180186,
    "C": 21.4824617124611,
    "h": -0.81038447141007,
    "CMY_C": 0.3882399,
    "CMY_M": 0.4717936,
    "CMY_Y": 0.339393,
    "CMYK_C": 0.07394248,
    "CMYK_M": 0.2004226,
    "CMYK_Y": 0,
    "CMYK_K": 0.339393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08159",
    "Farbtonhilfsbezeichnung": "W6.19.48",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "124",
    "Bcolor": "167",
    "Y": 23,
    "L": 55.3122725209445,
    "a": 16.2988057339344,
    "b": -20.8314327040013,
    "C": 26.4499462542718,
    "h": -0.90687088450592,
    "CMY_C": 0.4365197,
    "CMY_M": 0.5119701,
    "CMY_Y": 0.3436198,
    "CMYK_C": 0.1415336,
    "CMYK_M": 0.2564829,
    "CMYK_Y": 0,
    "CMYK_K": 0.3436198
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08160",
    "Farbtonhilfsbezeichnung": "W9.25.48",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "123",
    "Bcolor": "178",
    "Y": 24,
    "L": 56.4944191987293,
    "a": 23.4802564687976,
    "b": -24.8033801359666,
    "C": 34.1545035099293,
    "h": -0.81279445574652,
    "CMY_C": 0.3885991,
    "CMY_M": 0.5178674,
    "CMY_Y": 0.303693,
    "CMYK_C": 0.1219377,
    "CMYK_M": 0.3075862,
    "CMYK_Y": 0,
    "CMYK_K": 0.303693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08161",
    "Farbtonhilfsbezeichnung": "X0.26.47",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "119",
    "Bcolor": "175",
    "Y": 23,
    "L": 55.1720196417754,
    "a": 24.5693803843053,
    "b": -25.4682454381853,
    "C": 35.3876529056157,
    "h": -0.80336001451755,
    "CMY_C": 0.3974597,
    "CMY_M": 0.533903,
    "CMY_Y": 0.3131255,
    "CMYK_C": 0.1227796,
    "CMYK_M": 0.3214233,
    "CMYK_Y": 0,
    "CMYK_K": 0.3131255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08162",
    "Farbtonhilfsbezeichnung": "W6.21.44",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "114",
    "Bcolor": "158",
    "Y": 20,
    "L": 51.553881352538,
    "a": 17.1188755837046,
    "b": -21.1287968629532,
    "C": 27.1934175514277,
    "h": -0.88985747606184,
    "CMY_C": 0.4704535,
    "CMY_M": 0.5512766,
    "CMY_Y": 0.3807638,
    "CMYK_C": 0.1448392,
    "CMYK_M": 0.2753598,
    "CMYK_Y": 0,
    "CMYK_K": 0.3807638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08164",
    "Farbtonhilfsbezeichnung": "W8.14.51",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "134",
    "Bcolor": "165",
    "Y": 26,
    "L": 58.2814675946434,
    "a": 13.1037092248096,
    "b": -15.1593211748267,
    "C": 20.0377696845211,
    "h": -0.85800179943926,
    "CMY_C": 0.4075783,
    "CMY_M": 0.4761077,
    "CMY_Y": 0.351077,
    "CMYK_C": 0.08706927,
    "CMYK_M": 0.1926742,
    "CMYK_Y": 0,
    "CMYK_K": 0.351077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08166",
    "Farbtonhilfsbezeichnung": "XN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "192",
    "Bcolor": "195",
    "Y": 53,
    "L": 78.1354747651864,
    "a": 2.27782745760569,
    "b": -1.73601325003025,
    "C": 2.86395529485064,
    "h": -0.65122271857357,
    "CMY_C": 0.2307189,
    "CMY_M": 0.2466526,
    "CMY_Y": 0.2354456,
    "CMYK_C": 0,
    "CMYK_M": 0.02071244,
    "CMYK_Y": 0.006144266,
    "CMYK_K": 0.2307189
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08167",
    "Farbtonhilfsbezeichnung": "XN.02.54",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "148",
    "Bcolor": "152",
    "Y": 30,
    "L": 61.7926674733807,
    "a": 2.40943812823968,
    "b": -2.35086033739074,
    "C": 3.36629416714167,
    "h": -0.77309329746808,
    "CMY_C": 0.4046454,
    "CMY_M": 0.4190154,
    "CMY_Y": 0.4029329,
    "CMYK_C": 0.00286818,
    "CMYK_M": 0.0269359,
    "CMYK_Y": 0,
    "CMYK_K": 0.4029329
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08168",
    "Farbtonhilfsbezeichnung": "W7.08.56",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "153",
    "Bcolor": "173",
    "Y": 34,
    "L": 64.6414488776104,
    "a": 8.00344019869303,
    "b": -9.74587503103139,
    "C": 12.6109926308176,
    "h": -0.8832537465341,
    "CMY_C": 0.359026,
    "CMY_M": 0.4004056,
    "CMY_Y": 0.3219258,
    "CMYK_C": 0.05471403,
    "CMYK_M": 0.1157392,
    "CMYK_Y": 0,
    "CMYK_K": 0.3219258
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08169",
    "Farbtonhilfsbezeichnung": "W9.10.50",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "137",
    "Bcolor": "159",
    "Y": 27,
    "L": 58.9781339169778,
    "a": 9.93636601617681,
    "b": -10.2947195272121,
    "C": 14.3077817900398,
    "h": -0.80310932572783,
    "CMY_C": 0.4059388,
    "CMY_M": 0.4629073,
    "CMY_Y": 0.3770739,
    "CMYK_C": 0.04633764,
    "CMYK_M": 0.1377907,
    "CMYK_Y": 0,
    "CMYK_K": 0.3770739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08170",
    "Farbtonhilfsbezeichnung": "W7.13.53",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "142",
    "Bcolor": "172",
    "Y": 30,
    "L": 61.2623991136707,
    "a": 11.7637716426938,
    "b": -14.0821741758178,
    "C": 18.3492221300936,
    "h": -0.87485955353745,
    "CMY_C": 0.3823317,
    "CMY_M": 0.4428557,
    "CMY_Y": 0.3272992,
    "CMYK_C": 0.08180819,
    "CMYK_M": 0.1717799,
    "CMYK_Y": 0,
    "CMYK_K": 0.3272992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08171",
    "Farbtonhilfsbezeichnung": "X0.15.45",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "119",
    "Bcolor": "151",
    "Y": 21,
    "L": 52.8622556743166,
    "a": 13.8297512636545,
    "b": -14.7761653602546,
    "C": 20.2385049538779,
    "h": -0.81847065761216,
    "CMY_C": 0.4568906,
    "CMY_M": 0.5323204,
    "CMY_Y": 0.4097006,
    "CMYK_C": 0.07994246,
    "CMYK_M": 0.2077247,
    "CMYK_Y": 0,
    "CMYK_K": 0.4097006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08172",
    "Farbtonhilfsbezeichnung": "X0.20.45",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "116",
    "Bcolor": "157",
    "Y": 21,
    "L": 52.680937871561,
    "a": 18.5889537594874,
    "b": -18.6427169657319,
    "C": 26.3267942928255,
    "h": -0.78684218048904,
    "CMY_C": 0.4395807,
    "CMY_M": 0.544965,
    "CMY_Y": 0.3854158,
    "CMYK_C": 0.08813262,
    "CMYK_M": 0.2596052,
    "CMYK_Y": 0,
    "CMYK_K": 0.3854158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08174",
    "Farbtonhilfsbezeichnung": "W6.27.44",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "114",
    "Bcolor": "171",
    "Y": 20,
    "L": 52.303777020914,
    "a": 22.1039113565423,
    "b": -27.4383740889758,
    "C": 35.2341775823484,
    "h": -0.89265985282358,
    "CMY_C": 0.4523476,
    "CMY_M": 0.554596,
    "CMY_Y": 0.3304886,
    "CMYK_C": 0.182012,
    "CMYK_M": 0.3347328,
    "CMYK_Y": 0,
    "CMYK_K": 0.3304886
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08175",
    "Farbtonhilfsbezeichnung": "X0.29.37",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "99",
    "Bcolor": "152",
    "Y": 16,
    "L": 47.269313180092,
    "a": 24.9384728339384,
    "b": -24.5137260483228,
    "C": 34.9692749719135,
    "h": -0.77680933719895,
    "CMY_C": 0.4736162,
    "CMY_M": 0.6131796,
    "CMY_Y": 0.4020911,
    "CMYK_C": 0.1196254,
    "CMYK_M": 0.3530445,
    "CMYK_Y": 0,
    "CMYK_K": 0.4020911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08176",
    "Farbtonhilfsbezeichnung": "W8.28.38",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "98",
    "Bcolor": "152",
    "Y": 16,
    "L": 46.6437380065869,
    "a": 23.8203602660383,
    "b": -25.0390741988631,
    "C": 34.5595833299539,
    "h": -0.81033625964812,
    "CMY_C": 0.4894086,
    "CMY_M": 0.6157864,
    "CMY_Y": 0.4052284,
    "CMYK_C": 0.1415337,
    "CMYK_M": 0.354015,
    "CMYK_Y": 0,
    "CMYK_K": 0.4052284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08177",
    "Farbtonhilfsbezeichnung": "X0.24.35",
    "Farbtonklasse": "03",
    "Rcolor": "119",
    "Gcolor": "93",
    "Bcolor": "135",
    "Y": 13,
    "L": 43.403729862716,
    "a": 19.5139194380153,
    "b": -20.2610049155399,
    "C": 28.1300794883499,
    "h": -0.8041787808936,
    "CMY_C": 0.5334209,
    "CMY_M": 0.6369976,
    "CMY_Y": 0.4696427,
    "CMYK_C": 0.1202553,
    "CMYK_M": 0.3155513,
    "CMYK_Y": 0,
    "CMYK_K": 0.4696427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08178",
    "Farbtonhilfsbezeichnung": "W9.19.39",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "101",
    "Bcolor": "138",
    "Y": 15,
    "L": 46.2734990162998,
    "a": 17.1892644640542,
    "b": -17.3669458515257,
    "C": 24.4352536517431,
    "h": -0.79053992576131,
    "CMY_C": 0.5098609,
    "CMY_M": 0.6044279,
    "CMY_Y": 0.4595312,
    "CMYK_C": 0.09312237,
    "CMYK_M": 0.2680944,
    "CMYK_Y": 0,
    "CMYK_K": 0.4595312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08179",
    "Farbtonhilfsbezeichnung": "W9.16.42",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "110",
    "Bcolor": "141",
    "Y": 18,
    "L": 49.3176069623743,
    "a": 14.7843255162301,
    "b": -14.8114078182344,
    "C": 20.9273524968618,
    "h": -0.78631323767991,
    "CMY_C": 0.4865156,
    "CMY_M": 0.5696131,
    "CMY_Y": 0.4455657,
    "CMYK_C": 0.07385886,
    "CMYK_M": 0.2237369,
    "CMYK_Y": 0,
    "CMYK_K": 0.4455657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08180",
    "Farbtonhilfsbezeichnung": "W7.09.48",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "130",
    "Bcolor": "150",
    "Y": 24,
    "L": 56.0203499495404,
    "a": 8.40099353076235,
    "b": -9.47137822363935,
    "C": 12.6603198126722,
    "h": -0.84521717782627,
    "CMY_C": 0.4444475,
    "CMY_M": 0.489375,
    "CMY_Y": 0.4132606,
    "CMYK_C": 0.05315298,
    "CMYK_M": 0.1297244,
    "CMYK_Y": 0,
    "CMYK_K": 0.4132606
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08181",
    "Farbtonhilfsbezeichnung": "X1.03.53",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "145",
    "Bcolor": "152",
    "Y": 29,
    "L": 60.8863721892047,
    "a": 3.57211827491816,
    "b": -3.81823412274125,
    "C": 5.22866529681045,
    "h": -0.81868817592018,
    "CMY_C": 0.4103197,
    "CMY_M": 0.4305262,
    "CMY_Y": 0.4020901,
    "CMYK_C": 0.01376384,
    "CMYK_M": 0.04755915,
    "CMYK_Y": 0,
    "CMYK_K": 0.4020901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08182",
    "Farbtonhilfsbezeichnung": "WN.02.46",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "128",
    "Bcolor": "133",
    "Y": 22,
    "L": 53.8058457236169,
    "a": 2.28025926969272,
    "b": -2.8795944536353,
    "C": 3.67309767831279,
    "h": -0.90103350661677,
    "CMY_C": 0.4886134,
    "CMY_M": 0.4996077,
    "CMY_Y": 0.4803798,
    "CMYK_C": 0.01584544,
    "CMYK_M": 0.03700373,
    "CMYK_Y": 0,
    "CMYK_K": 0.4803798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08183",
    "Farbtonhilfsbezeichnung": "X0.10.41",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "113",
    "Bcolor": "134",
    "Y": 18,
    "L": 49.5009935157603,
    "a": 9.04731112950275,
    "b": -10.1102619110849,
    "C": 13.567285453795,
    "h": -0.84082595738556,
    "CMY_C": 0.5079901,
    "CMY_M": 0.5554373,
    "CMY_Y": 0.4750909,
    "CMYK_C": 0.06267601,
    "CMYK_M": 0.1530673,
    "CMYK_Y": 0,
    "CMYK_K": 0.4750909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08184",
    "Farbtonhilfsbezeichnung": "W6.11.38",
    "Farbtonklasse": "02",
    "Rcolor": "117",
    "Gcolor": "106",
    "Bcolor": "127",
    "Y": 16,
    "L": 46.5358965280967,
    "a": 8.49608515857048,
    "b": -10.5669395277774,
    "C": 13.5588964892201,
    "h": -0.89360583824351,
    "CMY_C": 0.5428042,
    "CMY_M": 0.582927,
    "CMY_Y": 0.5018179,
    "CMYK_C": 0.08227173,
    "CMYK_M": 0.1628101,
    "CMYK_Y": 0,
    "CMYK_K": 0.5018179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08185",
    "Farbtonhilfsbezeichnung": "W6.19.34",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "130",
    "Y": 13,
    "L": 43.4127371124195,
    "a": 13.6239391938973,
    "b": -17.1223775449062,
    "C": 21.8812141333455,
    "h": -0.89869487903029,
    "CMY_C": 0.5615502,
    "CMY_M": 0.622963,
    "CMY_Y": 0.4902556,
    "CMYK_C": 0.1398634,
    "CMYK_M": 0.260341,
    "CMYK_Y": 0,
    "CMYK_K": 0.4902556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08186",
    "Farbtonhilfsbezeichnung": "W6.29.34",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "90",
    "Bcolor": "145",
    "Y": 13,
    "L": 42.7015738023177,
    "a": 21.8786800069897,
    "b": -27.2979786920028,
    "C": 34.9836573204874,
    "h": -0.89515591554049,
    "CMY_C": 0.5514195,
    "CMY_M": 0.6471074,
    "CMY_Y": 0.4313108,
    "CMYK_C": 0.2112027,
    "CMYK_M": 0.3794631,
    "CMYK_Y": 0,
    "CMYK_K": 0.4313108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08187",
    "Farbtonhilfsbezeichnung": "X0.35.34",
    "Farbtonklasse": "04",
    "Rcolor": "127",
    "Gcolor": "86",
    "Bcolor": "148",
    "Y": 13,
    "L": 43.0992860585878,
    "a": 29.1601383367747,
    "b": -28.4682443123414,
    "C": 40.7523570121655,
    "h": -0.7733926072698,
    "CMY_C": 0.5033345,
    "CMY_M": 0.6642259,
    "CMY_Y": 0.4190251,
    "CMYK_C": 0.1451171,
    "CMYK_M": 0.4220506,
    "CMYK_Y": 0,
    "CMYK_K": 0.4190251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08188",
    "Farbtonhilfsbezeichnung": "W8.29.30",
    "Farbtonklasse": "04",
    "Rcolor": "108",
    "Gcolor": "81",
    "Bcolor": "130",
    "Y": 11,
    "L": 38.9474085315452,
    "a": 21.8648850943895,
    "b": -24.2521263890294,
    "C": 32.6533127657871,
    "h": -0.83711687529806,
    "CMY_C": 0.577021,
    "CMY_M": 0.6838641,
    "CMY_Y": 0.4888769,
    "CMYK_C": 0.1724519,
    "CMYK_M": 0.3814878,
    "CMYK_Y": 0,
    "CMYK_K": 0.4888769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08189",
    "Farbtonhilfsbezeichnung": "W6.25.34",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "92",
    "Bcolor": "140",
    "Y": 13,
    "L": 42.9616097105381,
    "a": 19.3517765240571,
    "b": -24.0431182497119,
    "C": 30.8636159548209,
    "h": -0.89308807409427,
    "CMY_C": 0.5531035,
    "CMY_M": 0.639203,
    "CMY_Y": 0.449837,
    "CMYK_C": 0.1877017,
    "CMYK_M": 0.3441997,
    "CMYK_Y": 0,
    "CMYK_K": 0.449837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08190",
    "Farbtonhilfsbezeichnung": "W9.24.33",
    "Farbtonklasse": "04",
    "Rcolor": "115",
    "Gcolor": "87",
    "Bcolor": "130",
    "Y": 12,
    "L": 41.3323593008864,
    "a": 20.0282847625787,
    "b": -20.0216486084326,
    "C": 28.3195798614755,
    "h": -0.78523246639056,
    "CMY_C": 0.549912,
    "CMY_M": 0.6581659,
    "CMY_Y": 0.4919575,
    "CMYK_C": 0.1140742,
    "CMYK_M": 0.3271545,
    "CMYK_Y": 0,
    "CMYK_K": 0.4919575
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08191",
    "Farbtonhilfsbezeichnung": "X0.18.30",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "87",
    "Bcolor": "115",
    "Y": 11,
    "L": 39.6896628838227,
    "a": 13.9840453224302,
    "b": -13.853228381515,
    "C": 19.6841423529245,
    "h": -0.78069885342409,
    "CMY_C": 0.5843304,
    "CMY_M": 0.660291,
    "CMY_Y": 0.5478584,
    "CMYK_C": 0.08066504,
    "CMYK_M": 0.2486669,
    "CMYK_Y": 0,
    "CMYK_K": 0.5478584
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08192",
    "Farbtonhilfsbezeichnung": "X1.14.34",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "119",
    "Y": 13,
    "L": 42.9735924728345,
    "a": 11.5370530762106,
    "b": -11.2583928641258,
    "C": 16.1200187210282,
    "h": -0.77317439144388,
    "CMY_C": 0.5596853,
    "CMY_M": 0.6241207,
    "CMY_Y": 0.5323072,
    "CMYK_C": 0.05853873,
    "CMYK_M": 0.1963115,
    "CMYK_Y": 0,
    "CMYK_K": 0.5323072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08194",
    "Farbtonhilfsbezeichnung": "W7.07.35",
    "Farbtonklasse": "02",
    "Rcolor": "108",
    "Gcolor": "101",
    "Bcolor": "113",
    "Y": 14,
    "L": 43.8742052593244,
    "a": 5.17649887105287,
    "b": -6.13622449742837,
    "C": 8.02803784525532,
    "h": -0.87003146175262,
    "CMY_C": 0.5770001,
    "CMY_M": 0.6024754,
    "CMY_Y": 0.5568753,
    "CMYK_C": 0.04541564,
    "CMYK_M": 0.1029058,
    "CMYK_Y": 0,
    "CMYK_K": 0.5568753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08196",
    "Farbtonhilfsbezeichnung": "X7.03.29",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "86",
    "Bcolor": "91",
    "Y": 10,
    "L": 36.9490219996877,
    "a": 2.73496619013908,
    "b": -2.80649197959175,
    "C": 3.91872904048196,
    "h": -0.79830484167117,
    "CMY_C": 0.6492722,
    "CMY_M": 0.6637586,
    "CMY_Y": 0.6442679,
    "CMYK_C": 0.01406779,
    "CMYK_M": 0.05479047,
    "CMYK_Y": 0,
    "CMYK_K": 0.6442679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08197",
    "Farbtonhilfsbezeichnung": "X1.13.27",
    "Farbtonklasse": "03",
    "Rcolor": "95",
    "Gcolor": "82",
    "Bcolor": "103",
    "Y": 10,
    "L": 36.9391056671811,
    "a": 10.0040121758581,
    "b": -10.5198922161633,
    "C": 14.5171757533761,
    "h": -0.81052844211136,
    "CMY_C": 0.6257986,
    "CMY_M": 0.6775564,
    "CMY_Y": 0.5957546,
    "CMYK_C": 0.07432137,
    "CMYK_M": 0.2023568,
    "CMYK_Y": 0,
    "CMYK_K": 0.5957546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08198",
    "Farbtonhilfsbezeichnung": "W6.16.24",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "76",
    "Bcolor": "101",
    "Y": 8,
    "L": 34.2678777134162,
    "a": 10.061883069455,
    "b": -13.1746065259702,
    "C": 16.5774469692267,
    "h": -0.91856381446284,
    "CMY_C": 0.6596331,
    "CMY_M": 0.7014588,
    "CMY_Y": 0.604938,
    "CMYK_C": 0.1384468,
    "CMYK_M": 0.2443181,
    "CMYK_Y": 0,
    "CMYK_K": 0.604938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08199",
    "Farbtonhilfsbezeichnung": "W9.19.29",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "84",
    "Bcolor": "113",
    "Y": 10,
    "L": 38.5028811459072,
    "a": 13.345341027179,
    "b": -14.1584832934644,
    "C": 19.4566383608017,
    "h": -0.81495425225929,
    "CMY_C": 0.601032,
    "CMY_M": 0.6697297,
    "CMY_Y": 0.5576054,
    "CMYK_C": 0.09816276,
    "CMYK_M": 0.2534486,
    "CMYK_Y": 0,
    "CMYK_K": 0.5576054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08200",
    "Farbtonhilfsbezeichnung": "W7.19.30",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "83",
    "Bcolor": "117",
    "Y": 10,
    "L": 38.2750997861883,
    "a": 14.6816667080868,
    "b": -17.1637222798793,
    "C": 22.5863830621056,
    "h": -0.8631817269714,
    "CMY_C": 0.6048813,
    "CMY_M": 0.6740663,
    "CMY_Y": 0.5408714,
    "CMYK_C": 0.1394161,
    "CMYK_M": 0.2901037,
    "CMYK_Y": 0,
    "CMYK_K": 0.5408714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08201",
    "Farbtonhilfsbezeichnung": "X0.24.26",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "74",
    "Bcolor": "112",
    "Y": 9,
    "L": 35.2168809338225,
    "a": 17.2365124700843,
    "b": -18.5342859567835,
    "C": 25.3104152091425,
    "h": -0.82166250727809,
    "CMY_C": 0.6227383,
    "CMY_M": 0.7083728,
    "CMY_Y": 0.5620491,
    "CMYK_C": 0.1385753,
    "CMYK_M": 0.3341099,
    "CMYK_Y": 0,
    "CMYK_K": 0.5620491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08202",
    "Farbtonhilfsbezeichnung": "W6.32.25",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "70",
    "Bcolor": "121",
    "Y": 8,
    "L": 34.1240226170424,
    "a": 21.3768461647922,
    "b": -26.3201136715516,
    "C": 33.9074908484333,
    "h": -0.8886685203642,
    "CMY_C": 0.6358334,
    "CMY_M": 0.7261669,
    "CMY_Y": 0.5241572,
    "CMYK_C": 0.2346916,
    "CMYK_M": 0.4245304,
    "CMYK_Y": 0,
    "CMYK_K": 0.5241572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08203",
    "Farbtonhilfsbezeichnung": "W6.27.24",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "74",
    "Bcolor": "116",
    "Y": 8,
    "L": 34.8568440212023,
    "a": 17.5206437048911,
    "b": -21.8694152458336,
    "C": 28.022210459356,
    "h": -0.89535562552988,
    "CMY_C": 0.636651,
    "CMY_M": 0.7110492,
    "CMY_Y": 0.5448773,
    "CMYK_C": 0.2016461,
    "CMYK_M": 0.3651144,
    "CMYK_Y": 0,
    "CMYK_K": 0.5448773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08204",
    "Farbtonhilfsbezeichnung": "W7.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "72",
    "Bcolor": "112",
    "Y": 8,
    "L": 34.2399505401339,
    "a": 16.9223334922994,
    "b": -20.1680531635094,
    "C": 26.3270913553081,
    "h": -0.87268419324119,
    "CMY_C": 0.6400856,
    "CMY_M": 0.7158534,
    "CMY_Y": 0.5615119,
    "CMYK_C": 0.1791924,
    "CMYK_M": 0.3519856,
    "CMYK_Y": 0,
    "CMYK_K": 0.5615119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08205",
    "Farbtonhilfsbezeichnung": "X0.19.21",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "66",
    "Bcolor": "94",
    "Y": 7,
    "L": 30.8530205641197,
    "a": 13.0420349188159,
    "b": -13.9823383521052,
    "C": 19.1206814893289,
    "h": -0.82017877549251,
    "CMY_C": 0.6753216,
    "CMY_M": 0.739217,
    "CMY_Y": 0.6322054,
    "CMYK_C": 0.1172292,
    "CMYK_M": 0.2909549,
    "CMYK_Y": 0,
    "CMYK_K": 0.6322054
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08206",
    "Farbtonhilfsbezeichnung": "W7.20.24",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "72",
    "Bcolor": "104",
    "Y": 8,
    "L": 33.2301756138612,
    "a": 13.6469023264407,
    "b": -16.5126508188638,
    "C": 21.4220816022425,
    "h": -0.88013332800833,
    "CMY_C": 0.6577468,
    "CMY_M": 0.7182555,
    "CMY_Y": 0.5940832,
    "CMYK_C": 0.156839,
    "CMYK_M": 0.3059058,
    "CMYK_Y": 0,
    "CMYK_K": 0.5940832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08207",
    "Farbtonhilfsbezeichnung": "W8.13.16",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "60",
    "Bcolor": "76",
    "Y": 5,
    "L": 26.7858155504524,
    "a": 6.96552463250255,
    "b": -8.50039502073491,
    "C": 10.9897792932586,
    "h": -0.88431636645592,
    "CMY_C": 0.7330329,
    "CMY_M": 0.7633283,
    "CMY_Y": 0.703194,
    "CMYK_C": 0.1005336,
    "CMYK_M": 0.2026047,
    "CMYK_Y": 0,
    "CMYK_K": 0.703194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08208",
    "Farbtonhilfsbezeichnung": "W9.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "79",
    "Bcolor": "87",
    "Y": 8,
    "L": 34.3318193820123,
    "a": 3.29619189016248,
    "b": -4.5568195763734,
    "C": 5.62400974647029,
    "h": -0.94456813687985,
    "CMY_C": 0.6753094,
    "CMY_M": 0.6887156,
    "CMY_Y": 0.6578435,
    "CMYK_C": 0.05104661,
    "CMYK_M": 0.09022802,
    "CMYK_Y": 0,
    "CMYK_K": 0.6578435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08209",
    "Farbtonhilfsbezeichnung": "X0.10.11",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "54",
    "Bcolor": "65",
    "Y": 4,
    "L": 23.6868231337323,
    "a": 5.08305168384068,
    "b": -6.12908112215734,
    "C": 7.9626032064006,
    "h": -0.87842331569254,
    "CMY_C": 0.7650359,
    "CMY_M": 0.787131,
    "CMY_Y": 0.7450219,
    "CMYK_C": 0.07849278,
    "CMYK_M": 0.1651477,
    "CMYK_Y": 0,
    "CMYK_K": 0.7450219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08210",
    "Farbtonhilfsbezeichnung": "X1.12.11",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "54",
    "Bcolor": "66",
    "Y": 4,
    "L": 23.6946465831471,
    "a": 5.76511982170536,
    "b": -6.90280539344461,
    "C": 8.99362712471381,
    "h": -0.87496623286166,
    "CMY_C": 0.7631124,
    "CMY_M": 0.7882529,
    "CMY_Y": 0.7404199,
    "CMYK_C": 0.08742031,
    "CMYK_M": 0.1842709,
    "CMYK_Y": 0,
    "CMYK_K": 0.7404199
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08211",
    "Farbtonhilfsbezeichnung": "W6.16.16",
    "Farbtonklasse": "03",
    "Rcolor": "68",
    "Gcolor": "58",
    "Bcolor": "79",
    "Y": 5,
    "L": 26.1739393197651,
    "a": 9.32097983630914,
    "b": -11.7323288082896,
    "C": 14.9842652263868,
    "h": -0.89943662288852,
    "CMY_C": 0.734271,
    "CMY_M": 0.7728543,
    "CMY_Y": 0.6895475,
    "CMYK_C": 0.1440589,
    "CMYK_M": 0.2683399,
    "CMYK_Y": 0,
    "CMYK_K": 0.6895475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08212",
    "Farbtonhilfsbezeichnung": "W8.21.16",
    "Farbtonklasse": "04",
    "Rcolor": "67",
    "Gcolor": "51",
    "Bcolor": "80",
    "Y": 4,
    "L": 24.039852038799,
    "a": 14.1145310807725,
    "b": -15.830000743358,
    "C": 21.2086989503083,
    "h": -0.84262385883751,
    "CMY_C": 0.7378761,
    "CMY_M": 0.8012596,
    "CMY_Y": 0.6847633,
    "CMYK_C": 0.1684854,
    "CMYK_M": 0.369552,
    "CMYK_Y": 0,
    "CMYK_K": 0.6847633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08213",
    "Farbtonhilfsbezeichnung": "X1.18.14",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "55",
    "Bcolor": "76",
    "Y": 5,
    "L": 25.4797712501654,
    "a": 11.4536236212915,
    "b": -10.7346205988612,
    "C": 15.6976932528222,
    "h": -0.75300481548466,
    "CMY_C": 0.7243749,
    "CMY_M": 0.7841582,
    "CMY_Y": 0.7015511,
    "CMYK_C": 0.07647493,
    "CMYK_M": 0.2767882,
    "CMYK_Y": 0,
    "CMYK_K": 0.7015511
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08214",
    "Farbtonhilfsbezeichnung": "W6.28.14",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "53",
    "Bcolor": "88",
    "Y": 4,
    "L": 24.9077198215477,
    "a": 14.4421182828754,
    "b": -19.2140379550399,
    "C": 24.0365146191015,
    "h": -0.92624382355724,
    "CMY_C": 0.7402039,
    "CMY_M": 0.793192,
    "CMY_Y": 0.6568292,
    "CMYK_C": 0.242954,
    "CMYK_M": 0.3973612,
    "CMYK_Y": 0,
    "CMYK_K": 0.6568292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08215",
    "Farbtonhilfsbezeichnung": "W8.28.21",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "65",
    "Bcolor": "106",
    "Y": 7,
    "L": 31.35909193631,
    "a": 18.8038163830862,
    "b": -21.0125748152146,
    "C": 28.1977270526157,
    "h": -0.84081496171678,
    "CMY_C": 0.65872,
    "CMY_M": 0.746626,
    "CMY_Y": 0.5841904,
    "CMYK_C": 0.1792397,
    "CMYK_M": 0.3906489,
    "CMYK_Y": 0,
    "CMYK_K": 0.5841904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08216",
    "Farbtonhilfsbezeichnung": "X8.16.64",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "167",
    "Bcolor": "203",
    "Y": 45,
    "L": 73.1327185721743,
    "a": 21.4636369378836,
    "b": -13.5670352900618,
    "C": 25.3919703284929,
    "h": -0.56368433416773,
    "CMY_C": 0.1844419,
    "CMY_M": 0.3451178,
    "CMY_Y": 0.2029333,
    "CMYK_C": 0,
    "CMYK_M": 0.1970135,
    "CMYK_Y": 0.0226734,
    "CMYK_K": 0.1844419
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08217",
    "Farbtonhilfsbezeichnung": "X7.16.65",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "167",
    "Bcolor": "203",
    "Y": 45,
    "L": 73.0580457234478,
    "a": 20.9474330413963,
    "b": -13.525233382314,
    "C": 24.934451850198,
    "h": -0.57332877256757,
    "CMY_C": 0.1887373,
    "CMY_M": 0.3444918,
    "CMY_Y": 0.2041017,
    "CMYK_C": 0,
    "CMYK_M": 0.1919902,
    "CMYK_Y": 0.01893892,
    "CMYK_K": 0.1887373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08218",
    "Farbtonhilfsbezeichnung": "X4.15.64",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "165",
    "Bcolor": "201",
    "Y": 43,
    "L": 71.6355692337818,
    "a": 18.9908401267768,
    "b": -14.8384404374173,
    "C": 24.100442388794,
    "h": -0.66326337154161,
    "CMY_C": 0.2224708,
    "CMY_M": 0.3536794,
    "CMY_Y": 0.2105075,
    "CMYK_C": 0.01515322,
    "CMYK_M": 0.1813467,
    "CMYK_Y": 0,
    "CMYK_K": 0.2105075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08219",
    "Farbtonhilfsbezeichnung": "X4.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "216",
    "Bcolor": "227",
    "Y": 71,
    "L": 87.5854851948518,
    "a": 6.42109435868593,
    "b": -4.61266890411316,
    "C": 7.90614742982451,
    "h": -0.62294331607853,
    "CMY_C": 0.1049388,
    "CMY_M": 0.1527051,
    "CMY_Y": 0.1109966,
    "CMYK_C": 0,
    "CMYK_M": 0.05336653,
    "CMYK_Y": 0.006768077,
    "CMYK_K": 0.1049388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08220",
    "Farbtonhilfsbezeichnung": "X7.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "217",
    "Bcolor": "227",
    "Y": 75,
    "L": 88.0741424560547,
    "a": 7.03324794769287,
    "b": -3.9269597530365,
    "C": 8.05528354644775,
    "h": 330.823516845703,
    "CMY_C": 0.09244555234909,
    "CMY_M": 0.14900952577591,
    "CMY_Y": 0.11054134368896,
    "CMYK_C": 0,
    "CMYK_M": 0.0623257085681,
    "CMYK_Y": 0.01993907056749,
    "CMYK_K": 0.09244555234909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08221",
    "Farbtonhilfsbezeichnung": "X4.05.72",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "208",
    "Y": 57,
    "L": 80.0471426934647,
    "a": 7.20776946609725,
    "b": -5.81872186095953,
    "C": 9.2633398281404,
    "h": -0.67916706253156,
    "CMY_C": 0.1863081,
    "CMY_M": 0.2366159,
    "CMY_Y": 0.1848191,
    "CMYK_C": 0.001826614,
    "CMYK_M": 0.06354027,
    "CMYK_Y": 0,
    "CMYK_K": 0.1848191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08222",
    "Farbtonhilfsbezeichnung": "X4.08.72",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "190",
    "Bcolor": "210",
    "Y": 56,
    "L": 79.4560443803287,
    "a": 11.4971459845391,
    "b": -7.94510070111105,
    "C": 13.9752993148841,
    "h": -0.60469384350029,
    "CMY_C": 0.1679327,
    "CMY_M": 0.2530521,
    "CMY_Y": 0.1754236,
    "CMYK_C": 0,
    "CMYK_M": 0.1022987,
    "CMYK_Y": 0.009002792,
    "CMYK_K": 0.1679327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08223",
    "Farbtonhilfsbezeichnung": "X8.10.74",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "196",
    "Bcolor": "219",
    "Y": 60,
    "L": 81.9553333373543,
    "a": 14.2416515477509,
    "b": -8.72886819217864,
    "C": 16.7038252721939,
    "h": -0.54985900240203,
    "CMY_C": 0.122671,
    "CMY_M": 0.2328623,
    "CMY_Y": 0.1420672,
    "CMYK_C": 0,
    "CMYK_M": 0.1255986,
    "CMYK_Y": 0.02210821,
    "CMYK_K": 0.122671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08224",
    "Farbtonhilfsbezeichnung": "X3.13.63",
    "Farbtonklasse": "03",
    "Rcolor": "191",
    "Gcolor": "165",
    "Bcolor": "196",
    "Y": 42,
    "L": 70.7737129307489,
    "a": 15.827362459325,
    "b": -13.4472105114361,
    "C": 20.7685549077862,
    "h": -0.70427219573628,
    "CMY_C": 0.2497131,
    "CMY_M": 0.3548238,
    "CMY_Y": 0.2299652,
    "CMYK_C": 0.02564556,
    "CMYK_M": 0.1621467,
    "CMYK_Y": 0,
    "CMYK_K": 0.2299652
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08225",
    "Farbtonhilfsbezeichnung": "X3.16.62",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "160",
    "Bcolor": "200",
    "Y": 41,
    "L": 70.1049489862184,
    "a": 20.2804592817322,
    "b": -16.3352072388456,
    "C": 26.0410449908223,
    "h": -0.67806459964809,
    "CMY_C": 0.2350907,
    "CMY_M": 0.372719,
    "CMY_Y": 0.2164197,
    "CMYK_C": 0.02382787,
    "CMYK_M": 0.1994682,
    "CMYK_Y": 0,
    "CMYK_K": 0.2164197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08226",
    "Farbtonhilfsbezeichnung": "X9.26.53",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "128",
    "Bcolor": "179",
    "Y": 29,
    "L": 61.0044926534907,
    "a": 31.4405982309379,
    "b": -18.3010460208362,
    "C": 36.3791080508583,
    "h": -0.52714124628671,
    "CMY_C": 0.2653655,
    "CMY_M": 0.4986157,
    "CMY_Y": 0.2990303,
    "CMYK_C": 0,
    "CMYK_M": 0.3175051,
    "CMYK_Y": 0.04582515,
    "CMYK_K": 0.2653655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08227",
    "Farbtonhilfsbezeichnung": "X8.20.59",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "148",
    "Bcolor": "191",
    "Y": 37,
    "L": 67.1027926550074,
    "a": 25.3887609847993,
    "b": -16.1629077748429,
    "C": 30.0969894188994,
    "h": -0.56690927771046,
    "CMY_C": 0.2319858,
    "CMY_M": 0.4184617,
    "CMY_Y": 0.2493641,
    "CMYK_C": 0,
    "CMYK_M": 0.2428026,
    "CMYK_Y": 0.02262758,
    "CMYK_K": 0.2319858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08228",
    "Farbtonhilfsbezeichnung": "X2.09.62",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "165",
    "Bcolor": "187",
    "Y": 41,
    "L": 69.8906243834651,
    "a": 10.7003851099854,
    "b": -9.65642099931192,
    "C": 14.4133517274071,
    "h": -0.73415975467054,
    "CMY_C": 0.2833924,
    "CMY_M": 0.3522972,
    "CMY_Y": 0.2666039,
    "CMYK_C": 0.02289146,
    "CMYK_M": 0.1168446,
    "CMYK_Y": 0,
    "CMYK_K": 0.2666039
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08229",
    "Farbtonhilfsbezeichnung": "X7.07.64",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "171",
    "Bcolor": "187",
    "Y": 43,
    "L": 71.83600605072,
    "a": 9.67393035248454,
    "b": -6.49295685991358,
    "C": 11.65089770144,
    "h": -0.5911213040507,
    "CMY_C": 0.2594325,
    "CMY_M": 0.3302664,
    "CMY_Y": 0.268163,
    "CMYK_C": 0,
    "CMYK_M": 0.09564817,
    "CMYK_Y": 0.01178885,
    "CMYK_K": 0.2594325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08230",
    "Farbtonhilfsbezeichnung": "X6.05.71",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "191",
    "Bcolor": "202",
    "Y": 54,
    "L": 78.6449051904129,
    "a": 7.28085845578907,
    "b": -4.78056792615438,
    "C": 8.71003613940902,
    "h": -0.58099675853731,
    "CMY_C": 0.197595,
    "CMY_M": 0.2522513,
    "CMY_Y": 0.2074789,
    "CMYK_C": 0,
    "CMYK_M": 0.0681156,
    "CMYK_Y": 0.01231786,
    "CMYK_K": 0.197595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08231",
    "Farbtonhilfsbezeichnung": "X4.03.73",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "198",
    "Bcolor": "204",
    "Y": 58,
    "L": 80.5004511795086,
    "a": 4.27061915083971,
    "b": -3.01576012138582,
    "C": 5.22809688522123,
    "h": -0.61485131776212,
    "CMY_C": 0.1941292,
    "CMY_M": 0.2254286,
    "CMY_Y": 0.2004619,
    "CMYK_C": 0,
    "CMYK_M": 0.03883922,
    "CMYK_Y": 0.007858155,
    "CMYK_K": 0.1941292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08232",
    "Farbtonhilfsbezeichnung": "X5.03.69",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "186",
    "Bcolor": "193",
    "Y": 50,
    "L": 76.3458570026722,
    "a": 4.64301869676231,
    "b": -3.43637731213222,
    "C": 5.77635799183374,
    "h": -0.63714595983832,
    "CMY_C": 0.2378561,
    "CMY_M": 0.2709902,
    "CMY_Y": 0.2422038,
    "CMYK_C": 0,
    "CMYK_M": 0.04347486,
    "CMYK_Y": 0.005704569,
    "CMYK_K": 0.2378561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08233",
    "Farbtonhilfsbezeichnung": "X4.05.64",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "173",
    "Bcolor": "184",
    "Y": 43,
    "L": 71.7137315089458,
    "a": 6.06370403726675,
    "b": -5.39359506514745,
    "C": 8.11537888076385,
    "h": -0.72697720135318,
    "CMY_C": 0.2835798,
    "CMY_M": 0.3231239,
    "CMY_Y": 0.2776525,
    "CMYK_C": 0.008205618,
    "CMYK_M": 0.06294946,
    "CMYK_Y": 0,
    "CMYK_K": 0.2776525
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08234",
    "Farbtonhilfsbezeichnung": "X9.06.63",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "169",
    "Bcolor": "181",
    "Y": 42,
    "L": 70.7848222849015,
    "a": 8.37157995246896,
    "b": -4.90132959117062,
    "C": 9.70084443035063,
    "h": -0.52966900217485,
    "CMY_C": 0.2750022,
    "CMY_M": 0.3386453,
    "CMY_Y": 0.2906799,
    "CMYK_C": 0,
    "CMYK_M": 0.0877839,
    "CMYK_Y": 0.0216244,
    "CMYK_K": 0.2750022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08235",
    "Farbtonhilfsbezeichnung": "X2.06.62",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "167",
    "Bcolor": "182",
    "Y": 41,
    "L": 69.980652998829,
    "a": 7.53669930396778,
    "b": -6.70694779745975,
    "C": 10.0888545016904,
    "h": -0.72720977897332,
    "CMY_C": 0.2956121,
    "CMY_M": 0.3445362,
    "CMY_Y": 0.2866685,
    "CMYK_C": 0.0125378,
    "CMYK_M": 0.0811232,
    "CMYK_Y": 0,
    "CMYK_K": 0.2866685
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08236",
    "Farbtonhilfsbezeichnung": "X7.12.59",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "153",
    "Bcolor": "179",
    "Y": 36,
    "L": 66.3952978385794,
    "a": 15.8564132913079,
    "b": -10.6707740268155,
    "C": 19.1125942979001,
    "h": -0.59234870988516,
    "CMY_C": 0.2874505,
    "CMY_M": 0.4015629,
    "CMY_Y": 0.2960881,
    "CMYK_C": 0,
    "CMYK_M": 0.1601466,
    "CMYK_Y": 0.01212204,
    "CMYK_K": 0.2874505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08237",
    "Farbtonhilfsbezeichnung": "X3.20.52",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "132",
    "Bcolor": "177",
    "Y": 28,
    "L": 60.0525929007216,
    "a": 22.3712204033321,
    "b": -18.7138159415584,
    "C": 29.166391779392,
    "h": -0.69661184895428,
    "CMY_C": 0.3368391,
    "CMY_M": 0.4813193,
    "CMY_Y": 0.307342,
    "CMYK_C": 0.0425854,
    "CMYK_M": 0.2511736,
    "CMYK_Y": 0,
    "CMYK_K": 0.307342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08238",
    "Farbtonhilfsbezeichnung": "X3.23.52",
    "Farbtonklasse": "03",
    "Rcolor": "171",
    "Gcolor": "131",
    "Bcolor": "181",
    "Y": 28,
    "L": 60.0204366655016,
    "a": 24.9207319457166,
    "b": -21.0384631839668,
    "C": 32.6137979059997,
    "h": -0.70112614630955,
    "CMY_C": 0.3277887,
    "CMY_M": 0.4879442,
    "CMY_Y": 0.2915934,
    "CMYK_C": 0.0510939,
    "CMYK_M": 0.2771724,
    "CMYK_Y": 0,
    "CMYK_K": 0.2915934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08239",
    "Farbtonhilfsbezeichnung": "X6.30.50",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "117",
    "Bcolor": "180",
    "Y": 26,
    "L": 57.6186024320071,
    "a": 34.6868179747465,
    "b": -24.3410356086039,
    "C": 42.3752446094712,
    "h": -0.61189101739079,
    "CMY_C": 0.3002313,
    "CMY_M": 0.5408373,
    "CMY_Y": 0.2936899,
    "CMYK_C": 0.009261344,
    "CMYK_M": 0.3499134,
    "CMYK_Y": 0,
    "CMYK_K": 0.2936899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08240",
    "Farbtonhilfsbezeichnung": "X9.27.46",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "111",
    "Bcolor": "160",
    "Y": 22,
    "L": 54.1771232030181,
    "a": 30.2401155893486,
    "b": -18.1280950302924,
    "C": 35.2575157985426,
    "h": -0.54003099106137,
    "CMY_C": 0.3462366,
    "CMY_M": 0.5639023,
    "CMY_Y": 0.3720415,
    "CMYK_C": 0,
    "CMYK_M": 0.3329426,
    "CMYK_Y": 0.03947131,
    "CMYK_K": 0.3462366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08241",
    "Farbtonhilfsbezeichnung": "X3.26.42",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "107",
    "Bcolor": "155",
    "Y": 19,
    "L": 50.6414386955011,
    "a": 25.016456386628,
    "b": -20.7871842474432,
    "C": 32.5258377152874,
    "h": -0.69332438956498,
    "CMY_C": 0.4252459,
    "CMY_M": 0.582069,
    "CMY_Y": 0.3916748,
    "CMYK_C": 0.05518596,
    "CMYK_M": 0.3129809,
    "CMYK_Y": 0,
    "CMYK_K": 0.3916748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08242",
    "Farbtonhilfsbezeichnung": "X9.19.50",
    "Farbtonklasse": "03",
    "Rcolor": "166",
    "Gcolor": "125",
    "Bcolor": "159",
    "Y": 25,
    "L": 57.3007754917364,
    "a": 21.9965219726931,
    "b": -12.9680267050615,
    "C": 25.5346175909951,
    "h": -0.53269947131502,
    "CMY_C": 0.350158,
    "CMY_M": 0.5102407,
    "CMY_Y": 0.3750408,
    "CMYK_C": 0,
    "CMYK_M": 0.2463409,
    "CMYK_Y": 0.03829048,
    "CMYK_K": 0.350158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08243",
    "Farbtonhilfsbezeichnung": "X9.13.53",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "140",
    "Bcolor": "164",
    "Y": 30,
    "L": 61.5413530167543,
    "a": 16.1186795042475,
    "b": -9.48266843077241,
    "C": 18.7011451394992,
    "h": -0.53177440905307,
    "CMY_C": 0.3336476,
    "CMY_M": 0.4526032,
    "CMY_Y": 0.3552215,
    "CMYK_C": 0,
    "CMYK_M": 0.1785175,
    "CMYK_Y": 0.03237597,
    "CMYK_K": 0.3336476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08244",
    "Farbtonhilfsbezeichnung": "X8.11.50",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "157",
    "Bcolor": "177",
    "Y": 37,
    "L": 67.5595752400626,
    "a": 14.1323057608963,
    "b": -7.53132862535937,
    "C": 16.0138370474606,
    "h": -0.48963217837186,
    "CMY_C": 0.2770443,
    "CMY_M": 0.3860258,
    "CMY_Y": 0.3057332,
    "CMYK_C": 0,
    "CMYK_M": 0.1507444,
    "CMYK_Y": 0.03968276,
    "CMYK_K": 0.2770443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08245",
    "Farbtonhilfsbezeichnung": "X7.09.54",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "145",
    "Bcolor": "162",
    "Y": 31,
    "L": 62.2065513909825,
    "a": 10.2370258993882,
    "b": -6.94223986270703,
    "C": 12.368968977894,
    "h": -0.59591057596023,
    "CMY_C": 0.3591968,
    "CMY_M": 0.4317614,
    "CMY_Y": 0.3663402,
    "CMYK_C": 0,
    "CMYK_M": 0.11324,
    "CMYK_Y": 0.0111476,
    "CMYK_K": 0.3591968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08246",
    "Farbtonhilfsbezeichnung": "X3.03.63",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "171",
    "Bcolor": "177",
    "Y": 42,
    "L": 70.5813005639652,
    "a": 3.41577346105115,
    "b": -3.11520321550076,
    "C": 4.62298598430578,
    "h": -0.73940836396319,
    "CMY_C": 0.3077183,
    "CMY_M": 0.3295245,
    "CMY_Y": 0.3059909,
    "CMYK_C": 0.002489054,
    "CMYK_M": 0.03390957,
    "CMYK_Y": 0,
    "CMYK_K": 0.3059909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08247",
    "Farbtonhilfsbezeichnung": "X6.04.59",
    "Farbtonklasse": "02",
    "Rcolor": "169",
    "Gcolor": "161",
    "Bcolor": "169",
    "Y": 37,
    "L": 67.0668352329248,
    "a": 5.04346951518547,
    "b": -4.09481843854853,
    "C": 6.49647002573569,
    "h": -0.68195808895192,
    "CMY_C": 0.3360993,
    "CMY_M": 0.3699228,
    "CMY_Y": 0.3359013,
    "CMYK_C": 0.0002981146,
    "CMYK_M": 0.05122957,
    "CMYK_Y": 0,
    "CMYK_K": 0.3359013
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08248",
    "Farbtonhilfsbezeichnung": "X7.09.47",
    "Farbtonklasse": "03",
    "Rcolor": "144",
    "Gcolor": "125",
    "Bcolor": "142",
    "Y": 23,
    "L": 54.7360749139902,
    "a": 10.7486896019822,
    "b": -7.04492823773935,
    "C": 12.851666897125,
    "h": -0.58017742065677,
    "CMY_C": 0.4334941,
    "CMY_M": 0.5086163,
    "CMY_Y": 0.4422852,
    "CMYK_C": 0,
    "CMYK_M": 0.1326063,
    "CMYK_Y": 0.01551811,
    "CMYK_K": 0.4334941
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08249",
    "Farbtonhilfsbezeichnung": "X7.14.50",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "129",
    "Bcolor": "157",
    "Y": 25,
    "L": 57.5005971155268,
    "a": 16.1235380433624,
    "b": -11.1383959604952,
    "C": 19.5967431888192,
    "h": -0.60453548747082,
    "CMY_C": 0.381299,
    "CMY_M": 0.4930539,
    "CMY_Y": 0.3859541,
    "CMYK_C": 0,
    "CMYK_M": 0.1806283,
    "CMYK_Y": 0.007523933,
    "CMYK_K": 0.381299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08250",
    "Farbtonhilfsbezeichnung": "X4.15.45",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "118",
    "Bcolor": "146",
    "Y": 21,
    "L": 52.7251882335845,
    "a": 14.9869975006817,
    "b": -12.459318911226,
    "C": 19.4896054813091,
    "h": -0.69356184981066,
    "CMY_C": 0.4426215,
    "CMY_M": 0.5373996,
    "CMY_Y": 0.4263269,
    "CMYK_C": 0.02840398,
    "CMYK_M": 0.1936168,
    "CMYK_Y": 0,
    "CMYK_K": 0.4263269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08251",
    "Farbtonhilfsbezeichnung": "X6.20.49",
    "Farbtonklasse": "03",
    "Rcolor": "165",
    "Gcolor": "126",
    "Bcolor": "166",
    "Y": 26,
    "L": 57.7646886271667,
    "a": 22.0236898527913,
    "b": -15.9096506790825,
    "C": 27.1690982452928,
    "h": -0.62559402313598,
    "CMY_C": 0.3542031,
    "CMY_M": 0.5045642,
    "CMY_Y": 0.3504227,
    "CMYK_C": 0.005819757,
    "CMYK_M": 0.237295,
    "CMYK_Y": 0,
    "CMYK_K": 0.3504227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08252",
    "Farbtonhilfsbezeichnung": "X9.24.44",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "109",
    "Bcolor": "152",
    "Y": 21,
    "L": 52.47776555156,
    "a": 26.7686084866471,
    "b": -16.0551401025807,
    "C": 31.2141942715953,
    "h": -0.54025398628123,
    "CMY_C": 0.3799047,
    "CMY_M": 0.5710236,
    "CMY_Y": 0.4037609,
    "CMYK_C": 0,
    "CMYK_M": 0.3082089,
    "CMYK_Y": 0.0384718,
    "CMYK_K": 0.3799047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08253",
    "Farbtonhilfsbezeichnung": "X2.28.43",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "107",
    "Bcolor": "163",
    "Y": 20,
    "L": 51.4036546326343,
    "a": 27.2967723552028,
    "b": -24.3335847861426,
    "C": 36.5682530284966,
    "h": -0.72806870289319,
    "CMY_C": 0.4144982,
    "CMY_M": 0.5797628,
    "CMY_Y": 0.360077,
    "CMYK_C": 0.08504341,
    "CMYK_M": 0.3433004,
    "CMYK_Y": 0,
    "CMYK_K": 0.360077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08254",
    "Farbtonhilfsbezeichnung": "X6.29.40",
    "Farbtonklasse": "04",
    "Rcolor": "146",
    "Gcolor": "95",
    "Bcolor": "148",
    "Y": 16,
    "L": 47.5730561013409,
    "a": 30.0144634997876,
    "b": -21.5007345061675,
    "C": 36.9208559419305,
    "h": -0.62161226014999,
    "CMY_C": 0.4278212,
    "CMY_M": 0.6269649,
    "CMY_Y": 0.4181092,
    "CMYK_C": 0.01669036,
    "CMYK_M": 0.358926,
    "CMYK_Y": 0,
    "CMYK_K": 0.4181092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08256",
    "Farbtonhilfsbezeichnung": "X9.31.34",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "84",
    "Bcolor": "132",
    "Y": 14,
    "L": 43.7521007227465,
    "a": 31.0592443828699,
    "b": -17.6069169283944,
    "C": 35.7026635611157,
    "h": -0.51571175148312,
    "CMY_C": 0.4498669,
    "CMY_M": 0.6691611,
    "CMY_Y": 0.481952,
    "CMYK_C": 0,
    "CMYK_M": 0.3986202,
    "CMYK_Y": 0.05832246,
    "CMYK_K": 0.4498669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08257",
    "Farbtonhilfsbezeichnung": "X9.27.36",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "90",
    "Bcolor": "133",
    "Y": 15,
    "L": 45.0144255834889,
    "a": 27.7527564767622,
    "b": -16.2398265437654,
    "C": 32.1550533855886,
    "h": -0.52943689894749,
    "CMY_C": 0.452526,
    "CMY_M": 0.6469766,
    "CMY_Y": 0.478388,
    "CMYK_C": 0,
    "CMYK_M": 0.3551779,
    "CMYK_Y": 0.04723891,
    "CMYK_K": 0.452526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08258",
    "Farbtonhilfsbezeichnung": "X9.17.44",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "113",
    "Bcolor": "142",
    "Y": 20,
    "L": 51.8586340894512,
    "a": 18.8883253150205,
    "b": -11.2599474131025,
    "C": 21.9898896984928,
    "h": -0.53757100777484,
    "CMY_C": 0.4221969,
    "CMY_M": 0.5565778,
    "CMY_Y": 0.4426269,
    "CMYK_C": 0,
    "CMYK_M": 0.2325722,
    "CMYK_Y": 0.0353581,
    "CMYK_K": 0.4221969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08259",
    "Farbtonhilfsbezeichnung": "X8.16.40",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "105",
    "Bcolor": "133",
    "Y": 17,
    "L": 48.3503916525711,
    "a": 17.2157800157551,
    "b": -10.9404758564219,
    "C": 20.3979678771152,
    "h": -0.56610796775916,
    "CMY_C": 0.4680312,
    "CMY_M": 0.5866525,
    "CMY_Y": 0.4803134,
    "CMYK_C": 0,
    "CMYK_M": 0.2229854,
    "CMYK_Y": 0.02308823,
    "CMYK_K": 0.4680312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08260",
    "Farbtonhilfsbezeichnung": "X3.14.43",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "116",
    "Bcolor": "144",
    "Y": 20,
    "L": 51.6902710674651,
    "a": 14.3291478931888,
    "b": -12.4212747038714,
    "C": 18.9634528663403,
    "h": -0.7141974905193,
    "CMY_C": 0.4575139,
    "CMY_M": 0.5459811,
    "CMY_Y": 0.4372,
    "CMYK_C": 0.03609438,
    "CMYK_M": 0.1932857,
    "CMYK_Y": 0,
    "CMYK_K": 0.4372
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08261",
    "Farbtonhilfsbezeichnung": "X9.10.44",
    "Farbtonklasse": "03",
    "Rcolor": "140",
    "Gcolor": "119",
    "Bcolor": "137",
    "Y": 20,
    "L": 52.3550167363193,
    "a": 11.8976676406078,
    "b": -7.3484481180693,
    "C": 13.984068972596,
    "h": -0.55328755334604,
    "CMY_C": 0.4510781,
    "CMY_M": 0.5350125,
    "CMY_Y": 0.4642099,
    "CMYK_C": 0,
    "CMYK_M": 0.1529078,
    "CMYK_Y": 0.02392306,
    "CMYK_K": 0.4510781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08262",
    "Farbtonhilfsbezeichnung": "X3.06.53",
    "Farbtonklasse": "02",
    "Rcolor": "154",
    "Gcolor": "144",
    "Bcolor": "157",
    "Y": 29,
    "L": 60.8743441318561,
    "a": 6.71632098407621,
    "b": -6.13837349447839,
    "C": 9.09882391954351,
    "h": -0.74046838771997,
    "CMY_C": 0.3954004,
    "CMY_M": 0.4372196,
    "CMY_Y": 0.3860411,
    "CMYK_C": 0.01524414,
    "CMYK_M": 0.0833583,
    "CMYK_Y": 0,
    "CMYK_K": 0.3860411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08263",
    "Farbtonhilfsbezeichnung": "X2.03.43",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "120",
    "Bcolor": "126",
    "Y": 19,
    "L": 51.0406883324902,
    "a": 3.20730917062623,
    "b": -3.23149936527842,
    "C": 4.55295730968103,
    "h": -0.789155082198,
    "CMY_C": 0.5108486,
    "CMY_M": 0.5290605,
    "CMY_Y": 0.5055033,
    "CMYK_C": 0.01080949,
    "CMYK_M": 0.04763879,
    "CMYK_Y": 0,
    "CMYK_K": 0.5055033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08264",
    "Farbtonhilfsbezeichnung": "X9.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "111",
    "Bcolor": "126",
    "Y": 18,
    "L": 48.9795178004532,
    "a": 10.6809342550795,
    "b": -5.91174524222609,
    "C": 12.2078289785823,
    "h": -0.50551549488267,
    "CMY_C": 0.4890755,
    "CMY_M": 0.5657167,
    "CMY_Y": 0.5075209,
    "CMYK_C": 0,
    "CMYK_M": 0.150005,
    "CMYK_Y": 0.03610196,
    "CMYK_K": 0.4890755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08266",
    "Farbtonhilfsbezeichnung": "X9.18.34",
    "Farbtonklasse": "04",
    "Rcolor": "124",
    "Gcolor": "92",
    "Bcolor": "120",
    "Y": 13,
    "L": 43.1921083255064,
    "a": 18.4118564955108,
    "b": -11.1536909446712,
    "C": 21.5267573336191,
    "h": -0.54466488369106,
    "CMY_C": 0.5133924,
    "CMY_M": 0.6394804,
    "CMY_Y": 0.5300804,
    "CMYK_C": 0,
    "CMYK_M": 0.2591164,
    "CMYK_Y": 0.03429464,
    "CMYK_K": 0.5133924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08267",
    "Farbtonhilfsbezeichnung": "X8.20.39",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "100",
    "Bcolor": "135",
    "Y": 16,
    "L": 47.2578055996543,
    "a": 20.8647329077752,
    "b": -13.786186435376,
    "C": 25.0079190606444,
    "h": -0.58388905668875,
    "CMY_C": 0.4645597,
    "CMY_M": 0.6060883,
    "CMY_Y": 0.4724107,
    "CMYK_C": 0,
    "CMYK_M": 0.2643219,
    "CMYK_Y": 0.01466284,
    "CMYK_K": 0.4645597
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08268",
    "Farbtonhilfsbezeichnung": "X9.30.33",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "83",
    "Bcolor": "133",
    "Y": 13,
    "L": 43.2307440511488,
    "a": 31.4786550231674,
    "b": -18.8427606022201,
    "C": 36.6872641277618,
    "h": -0.53938097950751,
    "CMY_C": 0.4563192,
    "CMY_M": 0.6750365,
    "CMY_Y": 0.4792513,
    "CMYK_C": 0,
    "CMYK_M": 0.40229,
    "CMYK_Y": 0.04217927,
    "CMYK_K": 0.4563192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08269",
    "Farbtonhilfsbezeichnung": "X3.32.33",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "82",
    "Bcolor": "137",
    "Y": 12,
    "L": 41.6258595280156,
    "a": 28.0311160096712,
    "b": -23.9538166664025,
    "C": 36.8717886416603,
    "h": -0.70712607226186,
    "CMY_C": 0.5095823,
    "CMY_M": 0.6769553,
    "CMY_Y": 0.4631678,
    "CMYK_C": 0.08645997,
    "CMYK_M": 0.398239,
    "CMYK_Y": 0,
    "CMYK_K": 0.4631678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08270",
    "Farbtonhilfsbezeichnung": "X6.29.30",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "72",
    "Bcolor": "119",
    "Y": 10,
    "L": 37.5834554307306,
    "a": 27.7704288624454,
    "b": -19.3844102886586,
    "C": 33.8666809924326,
    "h": -0.60939818196644,
    "CMY_C": 0.5376505,
    "CMY_M": 0.7164535,
    "CMY_Y": 0.5325173,
    "CMYK_C": 0.01098054,
    "CMYK_M": 0.3934609,
    "CMYK_Y": 0,
    "CMYK_K": 0.5325173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08271",
    "Farbtonhilfsbezeichnung": "X3.28.32",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "87",
    "Bcolor": "134",
    "Y": 13,
    "L": 42.6630119097696,
    "a": 24.5897651716649,
    "b": -20.5605103404423,
    "C": 32.0529427144695,
    "h": -0.69639296148634,
    "CMY_C": 0.5092578,
    "CMY_M": 0.6581936,
    "CMY_Y": 0.4747009,
    "CMYK_C": 0.06578523,
    "CMYK_M": 0.3493109,
    "CMYK_Y": 0,
    "CMYK_K": 0.4747009
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08272",
    "Farbtonhilfsbezeichnung": "X9.28.25",
    "Farbtonklasse": "04",
    "Rcolor": "110",
    "Gcolor": "67",
    "Bcolor": "104",
    "Y": 8,
    "L": 34.6734395658716,
    "a": 24.775066346427,
    "b": -14.421360724994,
    "C": 28.6666977105885,
    "h": -0.52714755496345,
    "CMY_C": 0.5700156,
    "CMY_M": 0.7363268,
    "CMY_Y": 0.5919309,
    "CMYK_C": 0,
    "CMYK_M": 0.3867842,
    "CMYK_Y": 0.05096764,
    "CMYK_K": 0.5700156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08273",
    "Farbtonhilfsbezeichnung": "X3.16.33",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "94",
    "Bcolor": "118",
    "Y": 13,
    "L": 42.5080580216248,
    "a": 13.3633960317455,
    "b": -11.3671802266575,
    "C": 17.5440343081797,
    "h": -0.70485425618569,
    "CMY_C": 0.5526944,
    "CMY_M": 0.6329606,
    "CMY_Y": 0.5360002,
    "CMYK_C": 0.03597896,
    "CMYK_M": 0.2089664,
    "CMYK_Y": 0,
    "CMYK_K": 0.5360002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08274",
    "Farbtonhilfsbezeichnung": "X8.14.26",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "80",
    "Bcolor": "97",
    "Y": 9,
    "L": 36.4053458136205,
    "a": 11.6725560300935,
    "b": -7.68415134363905,
    "C": 13.9747896638061,
    "h": -0.58219434514305,
    "CMY_C": 0.6117803,
    "CMY_M": 0.6873298,
    "CMY_Y": 0.6182305,
    "CMYK_C": 0,
    "CMYK_M": 0.1946049,
    "CMYK_Y": 0.01661473,
    "CMYK_K": 0.6117803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08275",
    "Farbtonhilfsbezeichnung": "X3.11.33",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "96",
    "Bcolor": "114",
    "Y": 13,
    "L": 42.8459616066078,
    "a": 10.2587244105491,
    "b": -8.51325526255646,
    "C": 13.3310517851009,
    "h": -0.69268206214034,
    "CMY_C": 0.5606448,
    "CMY_M": 0.6231749,
    "CMY_Y": 0.5511783,
    "CMYK_C": 0.02109187,
    "CMYK_M": 0.1604125,
    "CMYK_Y": 0,
    "CMYK_K": 0.5511783
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08276",
    "Farbtonhilfsbezeichnung": "X4.08.42",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "117",
    "Bcolor": "132",
    "Y": 19,
    "L": 50.9300873380327,
    "a": 7.68614240279997,
    "b": -6.59562825038842,
    "C": 10.1281339373767,
    "h": -0.70918897452617,
    "CMY_C": 0.4915867,
    "CMY_M": 0.5392857,
    "CMY_Y": 0.4839638,
    "CMYK_C": 0.0147721,
    "CMYK_M": 0.1072054,
    "CMYK_Y": 0,
    "CMYK_K": 0.4839638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08277",
    "Farbtonhilfsbezeichnung": "X9.07.34",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "99",
    "Bcolor": "110",
    "Y": 14,
    "L": 43.5195408081795,
    "a": 7.58682206358069,
    "b": -5.07069366565316,
    "C": 9.12533852935494,
    "h": -0.58917083111525,
    "CMY_C": 0.561102,
    "CMY_M": 0.6115743,
    "CMY_Y": 0.5668548,
    "CMYK_C": 0,
    "CMYK_M": 0.1149978,
    "CMYK_Y": 0.01310732,
    "CMYK_K": 0.561102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08278",
    "Farbtonhilfsbezeichnung": "X6.09.25",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "71",
    "Bcolor": "85",
    "Y": 7,
    "L": 31.9331692391361,
    "a": 8.65443246333386,
    "b": -6.80327974659181,
    "C": 11.0083521279433,
    "h": -0.66620984862521,
    "CMY_C": 0.6702246,
    "CMY_M": 0.7215464,
    "CMY_Y": 0.6658865,
    "CMYK_C": 0.01298407,
    "CMYK_M": 0.16659,
    "CMYK_Y": 0,
    "CMYK_K": 0.6658865
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08279",
    "Farbtonhilfsbezeichnung": "X4.13.23",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "73",
    "Bcolor": "91",
    "Y": 8,
    "L": 33.218998182141,
    "a": 10.0971716189723,
    "b": -8.56163042180557,
    "C": 13.2383681087423,
    "h": -0.70328738924216,
    "CMY_C": 0.6544135,
    "CMY_M": 0.7126234,
    "CMY_Y": 0.6430789,
    "CMYK_C": 0.03175651,
    "CMYK_M": 0.1948456,
    "CMYK_Y": 0,
    "CMYK_K": 0.6430789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08280",
    "Farbtonhilfsbezeichnung": "X4.18.23",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "71",
    "Bcolor": "96",
    "Y": 8,
    "L": 33.4453535303313,
    "a": 14.5218688982408,
    "b": -11.6480334948378,
    "C": 18.6161585885638,
    "h": -0.67602189779281,
    "CMY_C": 0.6343079,
    "CMY_M": 0.7202076,
    "CMY_Y": 0.6216848,
    "CMYK_C": 0.03336684,
    "CMYK_M": 0.2604252,
    "CMYK_Y": 0,
    "CMYK_K": 0.6216848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08281",
    "Farbtonhilfsbezeichnung": "X3.22.25",
    "Farbtonklasse": "04",
    "Rcolor": "96",
    "Gcolor": "72",
    "Bcolor": "104",
    "Y": 8,
    "L": 34.1955848216011,
    "a": 16.9421783269502,
    "b": -15.17738512848,
    "C": 22.7462178350684,
    "h": -0.73050885891428,
    "CMY_C": 0.6232067,
    "CMY_M": 0.718274,
    "CMY_Y": 0.5926753,
    "CMYK_C": 0.07495607,
    "CMYK_M": 0.3083504,
    "CMYK_Y": 0,
    "CMYK_K": 0.5926753
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08282",
    "Farbtonhilfsbezeichnung": "X3.26.23",
    "Farbtonklasse": "04",
    "Rcolor": "98",
    "Gcolor": "69",
    "Bcolor": "105",
    "Y": 8,
    "L": 33.6519465429249,
    "a": 19.7157842492908,
    "b": -16.8088236199995,
    "C": 25.9084677287723,
    "h": -0.70597647901999,
    "CMY_C": 0.6167001,
    "CMY_M": 0.7300481,
    "CMY_Y": 0.5876394,
    "CMYK_C": 0.07047392,
    "CMYK_M": 0.3453498,
    "CMYK_Y": 0,
    "CMYK_K": 0.5876394
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08283",
    "Farbtonhilfsbezeichnung": "X2.32.24",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "70",
    "Bcolor": "116",
    "Y": 9,
    "L": 35.1652665198723,
    "a": 23.456756410324,
    "b": -21.523332135418,
    "C": 31.8350945892233,
    "h": -0.74244060354616,
    "CMY_C": 0.5945076,
    "CMY_M": 0.724789,
    "CMY_Y": 0.5434614,
    "CMYK_C": 0.1118114,
    "CMYK_M": 0.3971791,
    "CMYK_Y": 0,
    "CMYK_K": 0.5434614
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08284",
    "Farbtonhilfsbezeichnung": "X3.34.23",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "63",
    "Bcolor": "113",
    "Y": 8,
    "L": 33.3739251088333,
    "a": 26.9119313315768,
    "b": -22.4139785535737,
    "C": 35.0233990725567,
    "h": -0.69446122375736,
    "CMY_C": 0.5942582,
    "CMY_M": 0.7514283,
    "CMY_Y": 0.5552468,
    "CMYK_C": 0.08771483,
    "CMYK_M": 0.441102,
    "CMYK_Y": 0,
    "CMYK_K": 0.5552468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08285",
    "Farbtonhilfsbezeichnung": "X3.31.23",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "68",
    "Bcolor": "109",
    "Y": 8,
    "L": 33.7650225134871,
    "a": 22.0279740163222,
    "b": -19.0789781780229,
    "C": 29.1417063258354,
    "h": -0.71378126707475,
    "CMY_C": 0.6088679,
    "CMY_M": 0.7345804,
    "CMY_Y": 0.5723897,
    "CMYK_C": 0.08530728,
    "CMYK_M": 0.3792956,
    "CMYK_Y": 0,
    "CMYK_K": 0.5723897
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08286",
    "Farbtonhilfsbezeichnung": "X3.29.23",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "68",
    "Bcolor": "112",
    "Y": 8,
    "L": 34.0577441473686,
    "a": 23.0511400699199,
    "b": -20.2593954207413,
    "C": 30.6887302007923,
    "h": -0.72102842698373,
    "CMY_C": 0.6036537,
    "CMY_M": 0.7343531,
    "CMY_Y": 0.5621762,
    "CMYK_C": 0.09473571,
    "CMYK_M": 0.3932562,
    "CMYK_Y": 0,
    "CMYK_K": 0.5621762
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08287",
    "Farbtonhilfsbezeichnung": "X4.22.23",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "69",
    "Bcolor": "100",
    "Y": 8,
    "L": 33.2237863300451,
    "a": 16.9947106202875,
    "b": -14.2078924178295,
    "C": 22.1513971573788,
    "h": -0.6963208712841,
    "CMY_C": 0.6291976,
    "CMY_M": 0.7276479,
    "CMY_Y": 0.6079267,
    "CMYK_C": 0.05425218,
    "CMYK_M": 0.3053541,
    "CMYK_Y": 0,
    "CMYK_K": 0.6079267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08288",
    "Farbtonhilfsbezeichnung": "X8.20.21",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "66",
    "Bcolor": "89",
    "Y": 7,
    "L": 31.2813563751989,
    "a": 15.5741551580776,
    "b": -10.1315760544428,
    "C": 18.5796432214086,
    "h": -0.57675316835248,
    "CMY_C": 0.6443001,
    "CMY_M": 0.7430221,
    "CMY_Y": 0.6511574,
    "CMYK_C": 0,
    "CMYK_M": 0.2775431,
    "CMYK_Y": 0.0192785,
    "CMYK_K": 0.6443001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08289",
    "Farbtonhilfsbezeichnung": "X4.17.15",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "61",
    "Bcolor": "80",
    "Y": 6,
    "L": 28.2299937274639,
    "a": 11.6461275226563,
    "b": -9.15072945406072,
    "C": 14.8110815207866,
    "h": -0.6659798917858,
    "CMY_C": 0.6933123,
    "CMY_M": 0.7609347,
    "CMY_Y": 0.6856991,
    "CMYK_C": 0.02422284,
    "CMYK_M": 0.2393743,
    "CMYK_Y": 0,
    "CMYK_K": 0.6856991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08290",
    "Farbtonhilfsbezeichnung": "X9.13.16",
    "Farbtonklasse": "04",
    "Rcolor": "72",
    "Gcolor": "59",
    "Bcolor": "72",
    "Y": 5,
    "L": 26.5854215293476,
    "a": 8.73506424066472,
    "b": -6.48019876298811,
    "C": 10.8763193818668,
    "h": -0.63827141745332,
    "CMY_C": 0.718104,
    "CMY_M": 0.7695689,
    "CMY_Y": 0.7167087,
    "CMYK_C": 0.004925136,
    "CMYK_M": 0.1865931,
    "CMYK_Y": 0,
    "CMYK_K": 0.7167087
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08291",
    "Farbtonhilfsbezeichnung": "X6.09.20",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "70",
    "Bcolor": "80",
    "Y": 7,
    "L": 30.8011077240972,
    "a": 6.2461721883704,
    "b": -5.28178357800992,
    "C": 8.17996972926594,
    "h": -0.70193598677069,
    "CMY_C": 0.691233,
    "CMY_M": 0.7269126,
    "CMY_Y": 0.6857457,
    "CMYK_C": 0.01746133,
    "CMYK_M": 0.1309987,
    "CMYK_Y": 0,
    "CMYK_K": 0.6857457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08292",
    "Farbtonhilfsbezeichnung": "X2.04.17",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "63",
    "Bcolor": "68",
    "Y": 5,
    "L": 27.0027603006691,
    "a": 2.9685823630882,
    "b": -3.15092671011723,
    "C": 4.32906691782057,
    "h": -0.81518656754853,
    "CMY_C": 0.7399961,
    "CMY_M": 0.7546198,
    "CMY_Y": 0.7331209,
    "CMYK_C": 0.02576175,
    "CMYK_M": 0.08055668,
    "CMYK_Y": 0,
    "CMYK_K": 0.7331209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08293",
    "Farbtonhilfsbezeichnung": "X4.05.12",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "57",
    "Bcolor": "63",
    "Y": 4,
    "L": 24.7098622345741,
    "a": 3.29117138704429,
    "b": -3.29118377138157,
    "C": 4.65442796870942,
    "h": -0.78540004484215,
    "CMY_C": 0.7587637,
    "CMY_M": 0.7753782,
    "CMY_Y": 0.7525901,
    "CMYK_C": 0.02495314,
    "CMYK_M": 0.09210666,
    "CMYK_Y": 0,
    "CMYK_K": 0.7525901
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08294",
    "Farbtonhilfsbezeichnung": "X5.09.15",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "63",
    "Bcolor": "72",
    "Y": 5,
    "L": 27.5591156193042,
    "a": 5.53363755871536,
    "b": -5.14442574749205,
    "C": 7.55554504338929,
    "h": -0.74896462940711,
    "CMY_C": 0.7248259,
    "CMY_M": 0.7544189,
    "CMY_Y": 0.7161173,
    "CMYK_C": 0.03067671,
    "CMYK_M": 0.1349205,
    "CMYK_Y": 0,
    "CMYK_K": 0.7161173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08295",
    "Farbtonhilfsbezeichnung": "X4.14.15",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "59",
    "Bcolor": "74",
    "Y": 5,
    "L": 26.4733697389093,
    "a": 8.63648302762365,
    "b": -7.72570759681737,
    "C": 11.587726134059,
    "h": -0.72979212977706,
    "CMY_C": 0.7232615,
    "CMY_M": 0.7699643,
    "CMY_Y": 0.7104218,
    "CMYK_C": 0.04433955,
    "CMYK_M": 0.2056179,
    "CMYK_Y": 0,
    "CMYK_K": 0.7104218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08296",
    "Farbtonhilfsbezeichnung": "X9.19.12",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "52",
    "Bcolor": "69",
    "Y": 4,
    "L": 24.6689693429172,
    "a": 13.1120917675875,
    "b": -7.48157403025757,
    "C": 15.0963870012616,
    "h": -0.51851060153837,
    "CMY_C": 0.7131515,
    "CMY_M": 0.7962677,
    "CMY_Y": 0.727653,
    "CMYK_C": 0,
    "CMYK_M": 0.2897566,
    "CMYK_Y": 0.05055434,
    "CMYK_K": 0.7131515
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08297",
    "Farbtonhilfsbezeichnung": "X2.23.14",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "57",
    "Bcolor": "84",
    "Y": 5,
    "L": 27.2354757374065,
    "a": 15.1677077874562,
    "b": -13.1378125913809,
    "C": 20.066426667743,
    "h": -0.71380696693791,
    "CMY_C": 0.6935,
    "CMY_M": 0.7770192,
    "CMY_Y": 0.67093,
    "CMYK_C": 0.06858737,
    "CMYK_M": 0.322391,
    "CMYK_Y": 0,
    "CMYK_K": 0.67093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08298",
    "Farbtonhilfsbezeichnung": "X9.24.16",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "55",
    "Bcolor": "80",
    "Y": 5,
    "L": 27.4487163839303,
    "a": 17.5907897961251,
    "b": -9.96257982233757,
    "C": 20.216055064426,
    "h": -0.51531082810739,
    "CMY_C": 0.6687353,
    "CMY_M": 0.7826415,
    "CMY_Y": 0.6874746,
    "CMYK_C": 0,
    "CMYK_M": 0.3438523,
    "CMYK_Y": 0.05656892,
    "CMYK_K": 0.6687353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08299",
    "Farbtonhilfsbezeichnung": "X2.23.17",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "59",
    "Bcolor": "88",
    "Y": 6,
    "L": 28.3075493515527,
    "a": 15.3975073305093,
    "b": -14.2217716991723,
    "C": 20.960487166487,
    "h": -0.74572404836423,
    "CMY_C": 0.6854841,
    "CMY_M": 0.7677215,
    "CMY_Y": 0.654488,
    "CMYK_C": 0.08971039,
    "CMYK_M": 0.3277268,
    "CMYK_Y": 0,
    "CMYK_K": 0.654488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08300",
    "Farbtonhilfsbezeichnung": "X2.29.19",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "60",
    "Bcolor": "99",
    "Y": 6,
    "L": 29.8355654529983,
    "a": 20.4343351411206,
    "b": -18.8081964397214,
    "C": 27.772473890073,
    "h": -0.7439836869555,
    "CMY_C": 0.6555793,
    "CMY_M": 0.7657725,
    "CMY_Y": 0.6120831,
    "CMYK_C": 0.1121279,
    "CMYK_M": 0.3961916,
    "CMYK_Y": 0,
    "CMYK_K": 0.6120831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08301",
    "Farbtonhilfsbezeichnung": "Y3.20.64",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "159",
    "Bcolor": "201",
    "Y": 44,
    "L": 72.1321721736957,
    "a": 29.2259703272458,
    "b": -13.5574529523065,
    "C": 32.2174156648707,
    "h": -0.43433948907095,
    "CMY_C": 0.1426671,
    "CMY_M": 0.3781617,
    "CMY_Y": 0.2128647,
    "CMYK_C": 0,
    "CMYK_M": 0.2746828,
    "CMYK_Y": 0.08187905,
    "CMYK_K": 0.1426671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08302",
    "Farbtonhilfsbezeichnung": "Y2.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "190",
    "Bcolor": "215",
    "Y": 58,
    "L": 80.8017504031534,
    "a": 17.1714333669547,
    "b": -8.32826569528955,
    "C": 19.0844998196731,
    "h": -0.45158144252661,
    "CMY_C": 0.1129772,
    "CMY_M": 0.2532493,
    "CMY_Y": 0.1572254,
    "CMYK_C": 0,
    "CMYK_M": 0.1581381,
    "CMYK_Y": 0.04988394,
    "CMYK_K": 0.1129772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08303",
    "Farbtonhilfsbezeichnung": "Y7.09.78",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "202",
    "Bcolor": "220",
    "Y": 65,
    "L": 84.6434328878343,
    "a": 15.3166369089348,
    "b": -5.17375258491801,
    "C": 16.1668513325907,
    "h": -0.3257530014029,
    "CMY_C": 0.07335494,
    "CMY_M": 0.207609,
    "CMY_Y": 0.1381352,
    "CMYK_C": 0,
    "CMYK_M": 0.1448819,
    "CMYK_Y": 0.0699084,
    "CMYK_K": 0.07335494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08307",
    "Farbtonhilfsbezeichnung": "YN.00.83",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "222",
    "Bcolor": "226",
    "Y": 76,
    "L": 88.9397964477539,
    "a": 2.61609101295471,
    "b": -2.06666135787964,
    "C": 3.33391976356506,
    "h": 321.691955566406,
    "CMY_C": 0.11064928770065,
    "CMY_M": 0.12917751073837,
    "CMY_Y": 0.11524701118469,
    "CMYK_C": 0,
    "CMYK_M": 0.02083342708647,
    "CMYK_Y": 0.00516975298524,
    "CMYK_K": 0.11064928770065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08308",
    "Farbtonhilfsbezeichnung": "YN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "225",
    "Bcolor": "231",
    "Y": 79,
    "L": 90.3923187255859,
    "a": 3.82083129882813,
    "b": -2.49800300598145,
    "C": 4.56495046615601,
    "h": 326.823944091797,
    "CMY_C": 0.0865131020546,
    "CMY_M": 0.11584854125977,
    "CMY_Y": 0.0958257317543,
    "CMYK_C": 0,
    "CMYK_M": 0.03211369365454,
    "CMYK_Y": 0.01019459590316,
    "CMYK_K": 0.0865131020546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08309",
    "Farbtonhilfsbezeichnung": "Y7.08.71",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "188",
    "Bcolor": "202",
    "Y": 55,
    "L": 79.028239862926,
    "a": 12.8561922364415,
    "b": -4.03509060706404,
    "C": 13.4745550957186,
    "h": -0.30412665684979,
    "CMY_C": 0.1502004,
    "CMY_M": 0.2623772,
    "CMY_Y": 0.2079323,
    "CMYK_C": 0,
    "CMYK_M": 0.1320039,
    "CMYK_Y": 0.06793588,
    "CMYK_K": 0.1502004
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08310",
    "Farbtonhilfsbezeichnung": "Y1.17.63",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "159",
    "Bcolor": "196",
    "Y": 42,
    "L": 70.8625730691036,
    "a": 23.6924947809278,
    "b": -12.7834089970527,
    "C": 26.9211785501716,
    "h": -0.49478882811169,
    "CMY_C": 0.1916299,
    "CMY_M": 0.3755802,
    "CMY_Y": 0.2326978,
    "CMYK_C": 0,
    "CMYK_M": 0.227557,
    "CMYK_Y": 0.05080336,
    "CMYK_K": 0.1916299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08311",
    "Farbtonhilfsbezeichnung": "Y5.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "148",
    "Bcolor": "186",
    "Y": 38,
    "L": 67.9959957918494,
    "a": 27.9988275594524,
    "b": -11.4550278810836,
    "C": 30.2514794425058,
    "h": -0.38834815253175,
    "CMY_C": 0.1906936,
    "CMY_M": 0.4186026,
    "CMY_Y": 0.2721246,
    "CMYK_C": 0,
    "CMYK_M": 0.2816103,
    "CMYK_Y": 0.1006182,
    "CMYK_K": 0.1906936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08312",
    "Farbtonhilfsbezeichnung": "Y0.23.53",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "130",
    "Bcolor": "175",
    "Y": 29,
    "L": 61.0824845889307,
    "a": 28.322473908101,
    "b": -16.0898624317203,
    "C": 32.5737041391787,
    "h": -0.51662968232653,
    "CMY_C": 0.2779472,
    "CMY_M": 0.4891191,
    "CMY_Y": 0.313614,
    "CMYK_C": 0,
    "CMYK_M": 0.2924604,
    "CMYK_Y": 0.04939634,
    "CMYK_K": 0.2779472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08313",
    "Farbtonhilfsbezeichnung": "Y1.21.59",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "147",
    "Bcolor": "189",
    "Y": 37,
    "L": 67.3069320306794,
    "a": 27.9470198664539,
    "b": -14.6127225397751,
    "C": 31.5367655196347,
    "h": -0.48177757409768,
    "CMY_C": 0.2078813,
    "CMY_M": 0.4244468,
    "CMY_Y": 0.2576088,
    "CMYK_C": 0,
    "CMYK_M": 0.2734004,
    "CMYK_Y": 0.06277788,
    "CMYK_K": 0.2078813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08314",
    "Farbtonhilfsbezeichnung": "Y0.18.55",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "141",
    "Bcolor": "177",
    "Y": 33,
    "L": 63.9111307004479,
    "a": 23.2665324315786,
    "b": -13.1771807793871,
    "C": 26.7389159219731,
    "h": -0.51531513970459,
    "CMY_C": 0.2716322,
    "CMY_M": 0.4464759,
    "CMY_Y": 0.3042205,
    "CMYK_C": 0,
    "CMYK_M": 0.2400487,
    "CMYK_Y": 0.04474156,
    "CMYK_K": 0.2716322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08315",
    "Farbtonhilfsbezeichnung": "Y1.15.63",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "163",
    "Bcolor": "196",
    "Y": 43,
    "L": 71.7773988935968,
    "a": 21.2875233617457,
    "b": -11.7467014557954,
    "C": 24.3134457855824,
    "h": -0.50423297924701,
    "CMY_C": 0.1948028,
    "CMY_M": 0.3595718,
    "CMY_Y": 0.2304153,
    "CMYK_C": 0,
    "CMYK_M": 0.2046319,
    "CMYK_Y": 0.04422827,
    "CMYK_K": 0.1948028
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08316",
    "Farbtonhilfsbezeichnung": "Y0.10.68",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "179",
    "Bcolor": "203",
    "Y": 50,
    "L": 76.1398718673459,
    "a": 15.1426891029513,
    "b": -9.16070788257251,
    "C": 17.6980112492468,
    "h": -0.54405793601152,
    "CMY_C": 0.1818431,
    "CMY_M": 0.2976443,
    "CMY_Y": 0.2023261,
    "CMYK_C": 0,
    "CMYK_M": 0.1415391,
    "CMYK_Y": 0.02503555,
    "CMYK_K": 0.1818431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08317",
    "Farbtonhilfsbezeichnung": "YN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "216",
    "Bcolor": "217",
    "Y": 70,
    "L": 86.8491309596954,
    "a": 2.6742849300162,
    "b": -0.36170333717551,
    "C": 2.69863469017866,
    "h": -0.13443655870474,
    "CMY_C": 0.127635,
    "CMY_M": 0.1529558,
    "CMY_Y": 0.1507641,
    "CMYK_C": 0,
    "CMYK_M": 0.02902551,
    "CMYK_Y": 0.02651309,
    "CMYK_K": 0.127635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08318",
    "Farbtonhilfsbezeichnung": "YN.00.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "221",
    "Bcolor": "219",
    "Y": 72,
    "L": 88.0669905521366,
    "a": 0.28649910975647,
    "b": 0.06079324261281,
    "C": 0.29287806035726,
    "h": 0.2090920962793,
    "CMY_C": 0.1313298,
    "CMY_M": 0.1339368,
    "CMY_Y": 0.1408295,
    "CMYK_C": 0,
    "CMYK_M": 0.003001098,
    "CMYK_Y": 0.01093591,
    "CMYK_K": 0.1313298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08319",
    "Farbtonhilfsbezeichnung": "Y3.13.59",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "153",
    "Bcolor": "177",
    "Y": 37,
    "L": 67.0764516236529,
    "a": 17.8051243367628,
    "b": -8.05296779950084,
    "C": 19.541564497946,
    "h": -0.42475144236549,
    "CMY_C": 0.2586036,
    "CMY_M": 0.4005076,
    "CMY_Y": 0.3067551,
    "CMYK_C": 0,
    "CMYK_M": 0.191401,
    "CMYK_Y": 0.06494707,
    "CMYK_K": 0.2586036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08320",
    "Farbtonhilfsbezeichnung": "Y1.16.54",
    "Farbtonklasse": "03",
    "Rcolor": "179",
    "Gcolor": "140",
    "Bcolor": "170",
    "Y": 31,
    "L": 62.7673954667785,
    "a": 20.2459534480498,
    "b": -10.7495448757107,
    "C": 22.9227255372374,
    "h": -0.48809825447577,
    "CMY_C": 0.2967069,
    "CMY_M": 0.4506627,
    "CMY_Y": 0.3332563,
    "CMYK_C": 0,
    "CMYK_M": 0.2189071,
    "CMYK_Y": 0.05196906,
    "CMYK_K": 0.2967069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08321",
    "Farbtonhilfsbezeichnung": "Y5.17.52",
    "Farbtonklasse": "03",
    "Rcolor": "177",
    "Gcolor": "133",
    "Bcolor": "160",
    "Y": 29,
    "L": 60.3908859386948,
    "a": 21.7267030929815,
    "b": -8.87343884224894,
    "C": 23.468863291129,
    "h": -0.38773670832814,
    "CMY_C": 0.3070242,
    "CMY_M": 0.4796562,
    "CMY_Y": 0.3706297,
    "CMYK_C": 0,
    "CMYK_M": 0.2491169,
    "CMYK_Y": 0.09178606,
    "CMYK_K": 0.3070242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08322",
    "Farbtonhilfsbezeichnung": "Y0.28.43",
    "Farbtonklasse": "04",
    "Rcolor": "164",
    "Gcolor": "105",
    "Bcolor": "154",
    "Y": 20,
    "L": 52.2932406632172,
    "a": 31.3531479914984,
    "b": -17.2517869691118,
    "C": 35.7860872771027,
    "h": -0.50302820779378,
    "CMY_C": 0.3569193,
    "CMY_M": 0.5865641,
    "CMY_Y": 0.3972363,
    "CMYK_C": 0,
    "CMYK_M": 0.3571011,
    "CMYK_Y": 0.06269363,
    "CMYK_K": 0.3569193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08323",
    "Farbtonhilfsbezeichnung": "Y2.35.40",
    "Farbtonklasse": "04",
    "Rcolor": "166",
    "Gcolor": "91",
    "Bcolor": "148",
    "Y": 18,
    "L": 49.211202009315,
    "a": 39.04634847295,
    "b": -18.7777488139732,
    "C": 43.3269105705878,
    "h": -0.44825867232359,
    "CMY_C": 0.3483336,
    "CMY_M": 0.6430119,
    "CMY_Y": 0.4180507,
    "CMYK_C": 0,
    "CMYK_M": 0.4521919,
    "CMYK_Y": 0.1069828,
    "CMYK_K": 0.3483336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08324",
    "Farbtonhilfsbezeichnung": "Y1.34.39",
    "Farbtonklasse": "04",
    "Rcolor": "158",
    "Gcolor": "86",
    "Bcolor": "148",
    "Y": 16,
    "L": 47.0352508600853,
    "a": 39.1481012160715,
    "b": -21.7705307614562,
    "C": 44.7943058709396,
    "h": -0.50751974646083,
    "CMY_C": 0.3793671,
    "CMY_M": 0.663587,
    "CMY_Y": 0.4208989,
    "CMYK_C": 0,
    "CMYK_M": 0.4579518,
    "CMYK_Y": 0.06691843,
    "CMYK_K": 0.3793671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08325",
    "Farbtonhilfsbezeichnung": "Y5.26.42",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "102",
    "Bcolor": "142",
    "Y": 19,
    "L": 51.0641500700356,
    "a": 31.5015164977053,
    "b": -12.1704069288624,
    "C": 33.7707617099363,
    "h": -0.36867840345701,
    "CMY_C": 0.3554084,
    "CMY_M": 0.6012968,
    "CMY_Y": 0.4432127,
    "CMYK_C": 0,
    "CMYK_M": 0.3814639,
    "CMYK_Y": 0.1362169,
    "CMYK_K": 0.3554084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08326",
    "Farbtonhilfsbezeichnung": "Y2.26.59",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "140",
    "Bcolor": "192",
    "Y": 37,
    "L": 66.9663287766212,
    "a": 36.0685650558951,
    "b": -16.684432757493,
    "C": 39.7405546215782,
    "h": -0.43326232241079,
    "CMY_C": 0.165066,
    "CMY_M": 0.4526317,
    "CMY_Y": 0.245911,
    "CMYK_C": 0,
    "CMYK_M": 0.3444173,
    "CMYK_Y": 0.09682798,
    "CMYK_K": 0.165066
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08327",
    "Farbtonhilfsbezeichnung": "Y4.20.50",
    "Farbtonklasse": "03",
    "Rcolor": "173",
    "Gcolor": "124",
    "Bcolor": "157",
    "Y": 26,
    "L": 57.6572374877994,
    "a": 24.7993751783097,
    "b": -10.9098402756143,
    "C": 27.0930549047903,
    "h": -0.41444319817835,
    "CMY_C": 0.3224017,
    "CMY_M": 0.5153707,
    "CMY_Y": 0.3848292,
    "CMYK_C": 0,
    "CMYK_M": 0.2847838,
    "CMYK_Y": 0.09213049,
    "CMYK_K": 0.3224017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08328",
    "Farbtonhilfsbezeichnung": "Y0.16.53",
    "Farbtonklasse": "03",
    "Rcolor": "172",
    "Gcolor": "135",
    "Bcolor": "165",
    "Y": 29,
    "L": 60.4995999702165,
    "a": 19.6535069079599,
    "b": -11.4135861432397,
    "C": 22.7273025770851,
    "h": -0.52613766714264,
    "CMY_C": 0.3268963,
    "CMY_M": 0.4719723,
    "CMY_Y": 0.3525333,
    "CMYK_C": 0,
    "CMYK_M": 0.2155329,
    "CMYK_Y": 0.03808776,
    "CMYK_K": 0.3268963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08329",
    "Farbtonhilfsbezeichnung": "Y0.09.63",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "166",
    "Bcolor": "184",
    "Y": 41,
    "L": 70.4263547820712,
    "a": 12.0235605377931,
    "b": -7.11218756019536,
    "C": 13.9695819514176,
    "h": -0.53416155257321,
    "CMY_C": 0.2597264,
    "CMY_M": 0.3507959,
    "CMY_Y": 0.2785344,
    "CMYK_C": 0,
    "CMYK_M": 0.1230214,
    "CMYK_Y": 0.0254068,
    "CMYK_K": 0.2597264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08330",
    "Farbtonhilfsbezeichnung": "YN.01.70",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "192",
    "Bcolor": "194",
    "Y": 54,
    "L": 78.3898503304783,
    "a": 3.09135506712549,
    "b": -1.01662235115891,
    "C": 3.25422758207202,
    "h": -0.31771896868781,
    "CMY_C": 0.2194052,
    "CMY_M": 0.2460293,
    "CMY_Y": 0.2377599,
    "CMYK_C": 0,
    "CMYK_M": 0.03410735,
    "CMYK_Y": 0.0235137,
    "CMYK_K": 0.2194052
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08331",
    "Farbtonhilfsbezeichnung": "Y0.03.67",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "179",
    "Bcolor": "184",
    "Y": 46,
    "L": 73.7139120956186,
    "a": 4.33157714989063,
    "b": -2.03112676209223,
    "C": 4.78414428389674,
    "h": -0.43846903848848,
    "CMY_C": 0.2639122,
    "CMY_M": 0.2987771,
    "CMY_Y": 0.2803295,
    "CMYK_C": 0,
    "CMYK_M": 0.04736518,
    "CMYK_Y": 0.02230341,
    "CMYK_K": 0.2639122
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08332",
    "Farbtonhilfsbezeichnung": "Y5.03.53",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "146",
    "Bcolor": "151",
    "Y": 30,
    "L": 61.565007727416,
    "a": 4.2436710115808,
    "b": -2.07865219027563,
    "C": 4.72541411758471,
    "h": -0.45547377264945,
    "CMY_C": 0.3929195,
    "CMY_M": 0.4255896,
    "CMY_Y": 0.4068968,
    "CMYK_C": 0,
    "CMYK_M": 0.05381502,
    "CMYK_Y": 0.02302378,
    "CMYK_K": 0.3929195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08333",
    "Farbtonhilfsbezeichnung": "Y1.05.49",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "135",
    "Bcolor": "143",
    "Y": 25,
    "L": 57.4483007052418,
    "a": 6.03103305233871,
    "b": -3.22231528287087,
    "C": 6.83788530619117,
    "h": -0.49070114782716,
    "CMY_C": 0.4263162,
    "CMY_M": 0.4713138,
    "CMY_Y": 0.4409187,
    "CMYK_C": 0,
    "CMYK_M": 0.07843626,
    "CMYK_Y": 0.02545398,
    "CMYK_K": 0.4263162
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08334",
    "Farbtonhilfsbezeichnung": "Y4.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "131",
    "Bcolor": "147",
    "Y": 25,
    "L": 57.4428515192459,
    "a": 12.3556049212788,
    "b": -5.63141558856486,
    "C": 13.5784319603502,
    "h": -0.42764869203209,
    "CMY_C": 0.3904416,
    "CMY_M": 0.4858273,
    "CMY_Y": 0.424001,
    "CMYK_C": 0,
    "CMYK_M": 0.1564833,
    "CMYK_Y": 0.05505521,
    "CMYK_K": 0.3904416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08336",
    "Farbtonhilfsbezeichnung": "Y1.20.44",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "111",
    "Bcolor": "145",
    "Y": 20,
    "L": 52.121061636493,
    "a": 22.6303528599197,
    "b": -12.7033445926383,
    "C": 25.9520294852597,
    "h": -0.51150858651283,
    "CMY_C": 0.3998639,
    "CMY_M": 0.5637862,
    "CMY_Y": 0.4300117,
    "CMYK_C": 0,
    "CMYK_M": 0.2731419,
    "CMYK_Y": 0.0502349,
    "CMYK_K": 0.3998639
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08337",
    "Farbtonhilfsbezeichnung": "Y0.23.34",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "89",
    "Bcolor": "124",
    "Y": 13,
    "L": 43.5031475842882,
    "a": 23.7364658365293,
    "b": -13.0607644832962,
    "C": 27.0924967342778,
    "h": -0.50302782587386,
    "CMY_C": 0.4832442,
    "CMY_M": 0.6506846,
    "CMY_Y": 0.5142651,
    "CMYK_C": 0,
    "CMYK_M": 0.3240223,
    "CMYK_Y": 0.06003013,
    "CMYK_K": 0.4832442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08338",
    "Farbtonhilfsbezeichnung": "Y2.25.40",
    "Farbtonklasse": "03",
    "Rcolor": "149",
    "Gcolor": "97",
    "Bcolor": "137",
    "Y": 17,
    "L": 48.0222107246433,
    "a": 27.8577171370734,
    "b": -14.2047849422702,
    "C": 31.2702465507604,
    "h": -0.47154005120397,
    "CMY_C": 0.4148212,
    "CMY_M": 0.6188988,
    "CMY_Y": 0.4612008,
    "CMYK_C": 0,
    "CMYK_M": 0.348744,
    "CMYK_Y": 0.0792571,
    "CMYK_K": 0.4148212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08339",
    "Farbtonhilfsbezeichnung": "Y5.29.32",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "76",
    "Bcolor": "115",
    "Y": 12,
    "L": 40.4379056961431,
    "a": 30.4406303889728,
    "b": -12.3169424996416,
    "C": 32.838073192828,
    "h": -0.38448432212846,
    "CMY_C": 0.4740444,
    "CMY_M": 0.7011806,
    "CMY_Y": 0.5484052,
    "CMYK_C": 0,
    "CMYK_M": 0.4318543,
    "CMYK_Y": 0.1413824,
    "CMYK_K": 0.4740444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08340",
    "Farbtonhilfsbezeichnung": "Y5.40.30",
    "Farbtonklasse": "04",
    "Rcolor": "143",
    "Gcolor": "65",
    "Bcolor": "117",
    "Y": 11,
    "L": 39.5004158325682,
    "a": 39.6555704503592,
    "b": -14.6331179213196,
    "C": 42.269284449144,
    "h": -0.35350476293972,
    "CMY_C": 0.4389508,
    "CMY_M": 0.7435492,
    "CMY_Y": 0.5420143,
    "CMYK_C": 0,
    "CMYK_M": 0.5429085,
    "CMYK_Y": 0.1836978,
    "CMYK_K": 0.4389508
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08341",
    "Farbtonhilfsbezeichnung": "Y0.27.39",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "95",
    "Bcolor": "139",
    "Y": 16,
    "L": 47.1282246790615,
    "a": 28.3430716985507,
    "b": -16.3921081586296,
    "C": 32.7418833177537,
    "h": -0.52434541071742,
    "CMY_C": 0.4273939,
    "CMY_M": 0.6282434,
    "CMY_Y": 0.4560097,
    "CMYK_C": 0,
    "CMYK_M": 0.3507637,
    "CMYK_Y": 0.04997454,
    "CMYK_K": 0.4273939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08342",
    "Farbtonhilfsbezeichnung": "Y2.24.30",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "76",
    "Bcolor": "109",
    "Y": 10,
    "L": 38.2704653263672,
    "a": 23.7514032802643,
    "b": -11.9388408270361,
    "C": 26.5831728368728,
    "h": -0.46577201485745,
    "CMY_C": 0.5332341,
    "CMY_M": 0.7007301,
    "CMY_Y": 0.57264,
    "CMYK_C": 0,
    "CMYK_M": 0.3588437,
    "CMYK_Y": 0.0844233,
    "CMYK_K": 0.5332341
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08343",
    "Farbtonhilfsbezeichnung": "Y4.20.40",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "99",
    "Bcolor": "128",
    "Y": 16,
    "L": 47.3538404535109,
    "a": 22.1884119859441,
    "b": -9.8342611975538,
    "C": 24.2701116552788,
    "h": -0.41719812259733,
    "CMY_C": 0.4441675,
    "CMY_M": 0.6102743,
    "CMY_Y": 0.4968721,
    "CMYK_C": 0,
    "CMYK_M": 0.2988432,
    "CMYK_Y": 0.09482095,
    "CMYK_K": 0.4441675
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08344",
    "Farbtonhilfsbezeichnung": "Y1.15.40",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "104",
    "Bcolor": "129",
    "Y": 17,
    "L": 47.9488323129981,
    "a": 17.414543737844,
    "b": -9.46900988442885,
    "C": 19.8224237112593,
    "h": -0.49802551473415,
    "CMY_C": 0.4665703,
    "CMY_M": 0.5915793,
    "CMY_Y": 0.4938629,
    "CMYK_C": 0,
    "CMYK_M": 0.2343497,
    "CMYK_Y": 0.05116451,
    "CMYK_K": 0.4665703
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08345",
    "Farbtonhilfsbezeichnung": "Y3.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "107",
    "Bcolor": "122",
    "Y": 17,
    "L": 47.6521368199663,
    "a": 11.9334618125958,
    "b": -5.80553928944529,
    "C": 13.2707120108145,
    "h": -0.45278330863662,
    "CMY_C": 0.4940069,
    "CMY_M": 0.581727,
    "CMY_Y": 0.5211969,
    "CMYK_C": 0,
    "CMYK_M": 0.1733622,
    "CMYK_Y": 0.05373585,
    "CMYK_K": 0.4940069
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08346",
    "Farbtonhilfsbezeichnung": "X9.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "123",
    "Bcolor": "131",
    "Y": 21,
    "L": 52.7026679384605,
    "a": 5.97735829241208,
    "b": -3.87097919844321,
    "C": 7.12132656958291,
    "h": -0.57469114607446,
    "CMY_C": 0.4769765,
    "CMY_M": 0.5185921,
    "CMY_Y": 0.4843996,
    "CMYK_C": 0,
    "CMYK_M": 0.07956739,
    "CMYK_Y": 0.01419281,
    "CMYK_K": 0.4769765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08347",
    "Farbtonhilfsbezeichnung": "Y4.03.43",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "121",
    "Bcolor": "126",
    "Y": 20,
    "L": 51.816785851589,
    "a": 4.57360910919785,
    "b": -2.18808531973282,
    "C": 5.07007077368432,
    "h": -0.446231356676,
    "CMY_C": 0.490422,
    "CMY_M": 0.5246848,
    "CMY_Y": 0.5045093,
    "CMYK_C": 0,
    "CMYK_M": 0.06723762,
    "CMYK_Y": 0.02764517,
    "CMYK_K": 0.490422
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08348",
    "Farbtonhilfsbezeichnung": "Y0.05.39",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "111",
    "Bcolor": "118",
    "Y": 17,
    "L": 47.7280985143521,
    "a": 5.26260957549113,
    "b": -3.2787181531363,
    "C": 6.20040742788378,
    "h": -0.55717520465761,
    "CMY_C": 0.5297748,
    "CMY_M": 0.5661507,
    "CMY_Y": 0.5376263,
    "CMYK_C": 0,
    "CMYK_M": 0.07735829,
    "CMYK_Y": 0.01669732,
    "CMYK_K": 0.5297748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08349",
    "Farbtonhilfsbezeichnung": "X9.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "100",
    "Bcolor": "107",
    "Y": 13,
    "L": 43.2814526017262,
    "a": 5.45449132966119,
    "b": -3.53772698740029,
    "C": 6.50130663041896,
    "h": -0.57538316995992,
    "CMY_C": 0.5729169,
    "CMY_M": 0.6095054,
    "CMY_Y": 0.5791762,
    "CMYK_C": 0,
    "CMYK_M": 0.08567073,
    "CMYK_Y": 0.01465621,
    "CMYK_K": 0.5729169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08350",
    "Farbtonhilfsbezeichnung": "Y5.16.31",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "81",
    "Bcolor": "102",
    "Y": 10,
    "L": 38.6601021936253,
    "a": 17.6884692053373,
    "b": -7.21824844314537,
    "C": 19.1045820005342,
    "h": -0.38744942105526,
    "CMY_C": 0.5523488,
    "CMY_M": 0.6816968,
    "CMY_Y": 0.5989617,
    "CMYK_C": 0,
    "CMYK_M": 0.2889481,
    "CMYK_Y": 0.1041275,
    "CMYK_K": 0.5523488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08351",
    "Farbtonhilfsbezeichnung": "Y5.20.29",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "74",
    "Bcolor": "100",
    "Y": 9,
    "L": 36.478830691107,
    "a": 21.1847737793148,
    "b": -9.04306074728349,
    "C": 23.0341396140556,
    "h": -0.40345014801476,
    "CMY_C": 0.5584494,
    "CMY_M": 0.7110332,
    "CMY_Y": 0.6080928,
    "CMYK_C": 0,
    "CMYK_M": 0.3455634,
    "CMYK_Y": 0.1124297,
    "CMYK_K": 0.5584494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08352",
    "Farbtonhilfsbezeichnung": "Y5.32.32",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "75",
    "Bcolor": "119",
    "Y": 12,
    "L": 41.0877296862002,
    "a": 33.693323885788,
    "b": -13.5365111485057,
    "C": 36.3108414739487,
    "h": -0.38201966486548,
    "CMY_C": 0.4520919,
    "CMY_M": 0.7056751,
    "CMY_Y": 0.5339818,
    "CMYK_C": 0,
    "CMYK_M": 0.4628207,
    "CMYK_Y": 0.1494592,
    "CMYK_K": 0.4520919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08353",
    "Farbtonhilfsbezeichnung": "Y0.26.35",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "87",
    "Bcolor": "129",
    "Y": 14,
    "L": 43.7827036556459,
    "a": 27.1126999759455,
    "b": -15.5162298364789,
    "C": 31.2386281440794,
    "h": -0.51979255641453,
    "CMY_C": 0.4670491,
    "CMY_M": 0.6571616,
    "CMY_Y": 0.4954391,
    "CMYK_C": 0,
    "CMYK_M": 0.3567167,
    "CMYK_Y": 0.05326946,
    "CMYK_K": 0.4670491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08354",
    "Farbtonhilfsbezeichnung": "Y1.35.29",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "62",
    "Bcolor": "117",
    "Y": 9,
    "L": 36.9170568685358,
    "a": 36.9072212901629,
    "b": -18.6278794539117,
    "C": 41.3417570539826,
    "h": -0.46741791635004,
    "CMY_C": 0.4906609,
    "CMY_M": 0.7555674,
    "CMY_Y": 0.5428504,
    "CMYK_C": 0,
    "CMYK_M": 0.5200986,
    "CMYK_Y": 0.1024651,
    "CMYK_K": 0.4906609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08355",
    "Farbtonhilfsbezeichnung": "Y0.33.24",
    "Farbtonklasse": "04",
    "Rcolor": "114",
    "Gcolor": "63",
    "Bcolor": "107",
    "Y": 8,
    "L": 34.3927872660394,
    "a": 29.2567849321048,
    "b": -16.8673695079477,
    "C": 33.77081015731,
    "h": -0.5229822082618,
    "CMY_C": 0.5541701,
    "CMY_M": 0.7523016,
    "CMY_Y": 0.5791695,
    "CMYK_C": 0,
    "CMYK_M": 0.4444104,
    "CMYK_Y": 0.0560737,
    "CMYK_K": 0.5541701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08356",
    "Farbtonhilfsbezeichnung": "Y0.25.24",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "67",
    "Bcolor": "99",
    "Y": 8,
    "L": 34.0125510961427,
    "a": 22.6281789608651,
    "b": -12.5512772017128,
    "C": 25.8760322012315,
    "h": -0.50642510638158,
    "CMY_C": 0.5837538,
    "CMY_M": 0.7367082,
    "CMY_Y": 0.6099381,
    "CMYK_C": 0,
    "CMYK_M": 0.3674615,
    "CMYK_Y": 0.06290591,
    "CMYK_K": 0.5837538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08357",
    "Farbtonhilfsbezeichnung": "Y8.24.25",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "63",
    "Bcolor": "90",
    "Y": 8,
    "L": 32.9298612991562,
    "a": 24.5826554184379,
    "b": -7.98780178201829,
    "C": 25.8478611248681,
    "h": -0.3141744559583,
    "CMY_C": 0.5725352,
    "CMY_M": 0.7542803,
    "CMY_Y": 0.6476789,
    "CMYK_C": 0,
    "CMYK_M": 0.4251697,
    "CMYK_Y": 0.1757894,
    "CMYK_K": 0.5725352
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08358",
    "Farbtonhilfsbezeichnung": "Y3.15.30",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "82",
    "Bcolor": "102",
    "Y": 10,
    "L": 38.3699989609001,
    "a": 14.7406549123438,
    "b": -7.44872967774182,
    "C": 16.5157646222292,
    "h": -0.46789356982163,
    "CMY_C": 0.573353,
    "CMY_M": 0.6766849,
    "CMY_Y": 0.6006377,
    "CMYK_C": 0,
    "CMYK_M": 0.2421953,
    "CMYK_Y": 0.06395152,
    "CMYK_K": 0.573353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08359",
    "Farbtonhilfsbezeichnung": "Y0.10.29",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "85",
    "Bcolor": "100",
    "Y": 10,
    "L": 38.318807620028,
    "a": 9.65045331632422,
    "b": -6.22754106750608,
    "C": 11.4853609850987,
    "h": -0.57307165432756,
    "CMY_C": 0.6017674,
    "CMY_M": 0.6652026,
    "CMY_Y": 0.6093007,
    "CMYK_C": 0,
    "CMYK_M": 0.159292,
    "CMYK_Y": 0.01891706,
    "CMYK_K": 0.6017674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08360",
    "Farbtonhilfsbezeichnung": "Y4.09.21",
    "Farbtonklasse": "03",
    "Rcolor": "82",
    "Gcolor": "68",
    "Bcolor": "78",
    "Y": 7,
    "L": 30.649584310279,
    "a": 8.08473025430917,
    "b": -4.38651545480497,
    "C": 9.19806398761092,
    "h": -0.49711931524671,
    "CMY_C": 0.6788951,
    "CMY_M": 0.7325535,
    "CMY_Y": 0.6923106,
    "CMYK_C": 0,
    "CMYK_M": 0.1671056,
    "CMYK_Y": 0.04177914,
    "CMYK_K": 0.6788951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08362",
    "Farbtonhilfsbezeichnung": "Y5.04.24",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "77",
    "Bcolor": "81",
    "Y": 8,
    "L": 33.4196511796664,
    "a": 3.74740509177884,
    "b": -1.82897969523648,
    "C": 4.16991746290947,
    "h": -0.45405462602979,
    "CMY_C": 0.6729032,
    "CMY_M": 0.6987441,
    "CMY_Y": 0.6828841,
    "CMYK_C": 0,
    "CMYK_M": 0.07900086,
    "CMYK_Y": 0.03051371,
    "CMYK_K": 0.6729032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08363",
    "Farbtonhilfsbezeichnung": "Y3.04.20",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "71",
    "Bcolor": "75",
    "Y": 7,
    "L": 30.7535955277304,
    "a": 3.69322633667135,
    "b": -2.06883565004988,
    "C": 4.23320230095376,
    "h": -0.51061794491063,
    "CMY_C": 0.6984997,
    "CMY_M": 0.7228226,
    "CMY_Y": 0.7057557,
    "CMYK_C": 0,
    "CMYK_M": 0.08067279,
    "CMYK_Y": 0.02406604,
    "CMYK_K": 0.6984997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08364",
    "Farbtonhilfsbezeichnung": "Y5.08.25",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 8,
    "L": 34.2357111112064,
    "a": 7.78804448147841,
    "b": -3.35820486131833,
    "C": 8.48122495492652,
    "h": -0.40711036958547,
    "CMY_C": 0.6443333,
    "CMY_M": 0.6995865,
    "CMY_Y": 0.6655746,
    "CMYK_C": 0,
    "CMYK_M": 0.1553509,
    "CMYK_Y": 0.05972252,
    "CMYK_K": 0.6443333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08365",
    "Farbtonhilfsbezeichnung": "Y0.12.24",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "73",
    "Bcolor": "89",
    "Y": 8,
    "L": 33.3936518577657,
    "a": 11.1657140625854,
    "b": -7.07006135501439,
    "C": 13.2158593398646,
    "h": -0.56446982775951,
    "CMY_C": 0.6419112,
    "CMY_M": 0.7139892,
    "CMY_Y": 0.6504099,
    "CMYK_C": 0,
    "CMYK_M": 0.2012852,
    "CMYK_Y": 0.02373363,
    "CMYK_K": 0.6419112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08366",
    "Farbtonhilfsbezeichnung": "Y0.16.24",
    "Farbtonklasse": "04",
    "Rcolor": "97",
    "Gcolor": "73",
    "Bcolor": "93",
    "Y": 8,
    "L": 34.0580564771956,
    "a": 14.3717846260454,
    "b": -8.60863153079321,
    "C": 16.7528126047659,
    "h": -0.53968042727328,
    "CMY_C": 0.6206055,
    "CMY_M": 0.7152496,
    "CMY_Y": 0.6344562,
    "CMYK_C": 0,
    "CMYK_M": 0.2494608,
    "CMYK_Y": 0.03650721,
    "CMYK_K": 0.6206055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08367",
    "Farbtonhilfsbezeichnung": "Y0.21.24",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "71",
    "Bcolor": "96",
    "Y": 8,
    "L": 34.1900375028093,
    "a": 18.0631093620102,
    "b": -10.37783966367,
    "C": 20.8320780506598,
    "h": -0.52148271551751,
    "CMY_C": 0.6024398,
    "CMY_M": 0.7230334,
    "CMY_Y": 0.6220104,
    "CMYK_C": 0,
    "CMYK_M": 0.3033341,
    "CMYK_Y": 0.0492267,
    "CMYK_K": 0.6024398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08368",
    "Farbtonhilfsbezeichnung": "Y1.34.23",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "60",
    "Bcolor": "104",
    "Y": 8,
    "L": 33.5554039517123,
    "a": 29.9283344050981,
    "b": -16.0151554460109,
    "C": 33.9439303001769,
    "h": -0.49134483361937,
    "CMY_C": 0.5566423,
    "CMY_M": 0.7627931,
    "CMY_Y": 0.5924051,
    "CMYK_C": 0,
    "CMYK_M": 0.4649764,
    "CMYK_Y": 0.0806636,
    "CMYK_K": 0.5566423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08369",
    "Farbtonhilfsbezeichnung": "Y3.36.24",
    "Farbtonklasse": "04",
    "Rcolor": "123",
    "Gcolor": "57",
    "Bcolor": "99",
    "Y": 8,
    "L": 34.2110238053318,
    "a": 34.3589549473726,
    "b": -11.8309510704626,
    "C": 36.3388110469683,
    "h": -0.33161812913539,
    "CMY_C": 0.5162637,
    "CMY_M": 0.774821,
    "CMY_Y": 0.6111249,
    "CMYK_C": 0,
    "CMYK_M": 0.5345005,
    "CMYK_Y": 0.196101,
    "CMYK_K": 0.5162637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08370",
    "Farbtonhilfsbezeichnung": "Y0.23.16",
    "Farbtonklasse": "04",
    "Rcolor": "82",
    "Gcolor": "57",
    "Bcolor": "79",
    "Y": 5,
    "L": 27.5096101121767,
    "a": 15.3707085979622,
    "b": -9.25471551807608,
    "C": 17.9418071030759,
    "h": -0.54196275427499,
    "CMY_C": 0.6787429,
    "CMY_M": 0.7764823,
    "CMY_Y": 0.6913166,
    "CMYK_C": 0,
    "CMYK_M": 0.3042403,
    "CMYK_Y": 0.03913904,
    "CMYK_K": 0.6787429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08371",
    "Farbtonhilfsbezeichnung": "Y0.19.20",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "63",
    "Bcolor": "85",
    "Y": 6,
    "L": 30.3630068231739,
    "a": 15.6578013573996,
    "b": -9.28721474603731,
    "C": 18.204919694599,
    "h": -0.53535758357504,
    "CMY_C": 0.6502497,
    "CMY_M": 0.7517877,
    "CMY_Y": 0.6647791,
    "CMYK_C": 0,
    "CMYK_M": 0.2903158,
    "CMYK_Y": 0.04154205,
    "CMYK_K": 0.6502497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08372",
    "Farbtonhilfsbezeichnung": "Y1.18.15",
    "Farbtonklasse": "04",
    "Rcolor": "76",
    "Gcolor": "53",
    "Bcolor": "71",
    "Y": 5,
    "L": 25.3231785812603,
    "a": 14.3664451742449,
    "b": -7.62032240300724,
    "C": 16.2623510130103,
    "h": -0.48769035830189,
    "CMY_C": 0.7005075,
    "CMY_M": 0.7936604,
    "CMY_Y": 0.7208434,
    "CMYK_C": 0,
    "CMYK_M": 0.3110357,
    "CMYK_Y": 0.06790107,
    "CMYK_K": 0.7005075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08373",
    "Farbtonhilfsbezeichnung": "Y0.09.16",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "61",
    "Bcolor": "70",
    "Y": 5,
    "L": 27.2172995625965,
    "a": 6.20964659607623,
    "b": -4.36737246930717,
    "C": 7.59168315552114,
    "h": -0.6129510908325,
    "CMY_C": 0.7216086,
    "CMY_M": 0.7590854,
    "CMY_Y": 0.7237028,
    "CMYK_C": 0,
    "CMYK_M": 0.1346188,
    "CMYK_Y": 0.007522266,
    "CMYK_K": 0.7216086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08374",
    "Farbtonhilfsbezeichnung": "Y2.07.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "70",
    "Bcolor": "81",
    "Y": 7,
    "L": 31.4945102018991,
    "a": 7.71712484681453,
    "b": -4.51859763798418,
    "C": 8.94269201724617,
    "h": -0.52971083455942,
    "CMY_C": 0.6736177,
    "CMY_M": 0.7240765,
    "CMY_Y": 0.6838196,
    "CMYK_C": 0,
    "CMYK_M": 0.1546004,
    "CMYK_Y": 0.03125754,
    "CMYK_K": 0.6736177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08375",
    "Farbtonhilfsbezeichnung": "Y5.04.15",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "60",
    "Bcolor": "64",
    "Y": 5,
    "L": 26.1555605902333,
    "a": 3.36623277634482,
    "b": -1.75908014673244,
    "C": 3.7981424495622,
    "h": -0.48153732124314,
    "CMY_C": 0.7412683,
    "CMY_M": 0.7632421,
    "CMY_Y": 0.7487662,
    "CMYK_C": 0,
    "CMYK_M": 0.0849287,
    "CMYK_Y": 0.02897941,
    "CMYK_K": 0.7412683
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08377",
    "Farbtonhilfsbezeichnung": "Y6.22.62",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "152",
    "Bcolor": "193",
    "Y": 42,
    "L": 70.5656211087293,
    "a": 32.0786264234323,
    "b": -11.5376671084627,
    "C": 34.0904097294215,
    "h": -0.3452619630921,
    "CMY_C": 0.1357776,
    "CMY_M": 0.4041768,
    "CMY_Y": 0.2435217,
    "CMYK_C": 0,
    "CMYK_M": 0.3105672,
    "CMYK_Y": 0.1246717,
    "CMYK_K": 0.1357776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08378",
    "Farbtonhilfsbezeichnung": "Y9.16.70",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "178",
    "Bcolor": "207",
    "Y": 55,
    "L": 78.8537704364512,
    "a": 26.2255374410413,
    "b": -6.86833559102198,
    "C": 27.1100137931053,
    "h": -0.25614219241646,
    "CMY_C": 0.06769042,
    "CMY_M": 0.3001141,
    "CMY_Y": 0.1877249,
    "CMYK_C": 0,
    "CMYK_M": 0.2492988,
    "CMYK_Y": 0.1287497,
    "CMYK_K": 0.06769042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08379",
    "Farbtonhilfsbezeichnung": "Z1.10.81",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "204",
    "Bcolor": "221",
    "Y": 68,
    "L": 86.1277990548606,
    "a": 18.2214497528514,
    "b": -3.56024108784325,
    "C": 18.5660051626422,
    "h": -0.19295642711426,
    "CMY_C": 0.0308466,
    "CMY_M": 0.1997309,
    "CMY_Y": 0.1331473,
    "CMYK_C": 0,
    "CMYK_M": 0.1742596,
    "CMYK_Y": 0.1055568,
    "CMYK_K": 0.0308466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08380",
    "Farbtonhilfsbezeichnung": "Y9.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "216",
    "Bcolor": "227",
    "Y": 74,
    "L": 88.6939792748889,
    "a": 11.0637214395865,
    "b": -2.87903347502514,
    "C": 11.4321811498542,
    "h": -0.25457681611357,
    "CMY_C": 0.05168065,
    "CMY_M": 0.1527414,
    "CMY_Y": 0.1108301,
    "CMYK_C": 0,
    "CMYK_M": 0.1065682,
    "CMYK_Y": 0.06237287,
    "CMYK_K": 0.05168065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08381",
    "Farbtonhilfsbezeichnung": "ZN.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "225",
    "Bcolor": "226",
    "Y": 77,
    "L": 90.4867956491287,
    "a": 5.24963281626839,
    "b": 0.01524991820192,
    "C": 5.24965496634275,
    "h": 0.00290494132431,
    "CMY_C": 0.06601951,
    "CMY_M": 0.1190835,
    "CMY_Y": 0.1131442,
    "CMYK_C": 0,
    "CMYK_M": 0.05681491,
    "CMYK_Y": 0.0504558,
    "CMYK_K": 0.06601951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08382",
    "Farbtonhilfsbezeichnung": "ZN.02.73",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "195",
    "Bcolor": "197",
    "Y": 57,
    "L": 79.8958587646484,
    "a": 4.62759304046631,
    "b": -0.38363090157509,
    "C": 4.64346742630005,
    "h": 355.260986328125,
    "CMY_C": 0.18940222263336,
    "CMY_M": 0.23356974124908,
    "CMY_Y": 0.22589844465256,
    "CMYK_C": 0,
    "CMYK_M": 0.05448758974671,
    "CMYK_Y": 0.04502383619547,
    "CMYK_K": 0.18940222263336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08383",
    "Farbtonhilfsbezeichnung": "Z1.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "226",
    "Bcolor": "229",
    "Y": 79,
    "L": 91.2090211864158,
    "a": 5.72980258875289,
    "b": -0.40878577748779,
    "C": 5.74436624162802,
    "h": -0.07122310363566,
    "CMY_C": 0.05560763,
    "CMY_M": 0.1121196,
    "CMY_Y": 0.1019522,
    "CMYK_C": 0,
    "CMYK_M": 0.05983948,
    "CMYK_Y": 0.04907345,
    "CMYK_K": 0.05560763
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08384",
    "Farbtonhilfsbezeichnung": "Z1.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "213",
    "Bcolor": "223",
    "Y": 72,
    "L": 87.8849589473774,
    "a": 11.6083191248185,
    "b": -2.00176519851942,
    "C": 11.7796492653063,
    "h": -0.17076289106777,
    "CMY_C": 0.05401704,
    "CMY_M": 0.1633368,
    "CMY_Y": 0.1261206,
    "CMYK_C": 0,
    "CMYK_M": 0.115562,
    "CMYK_Y": 0.0762208,
    "CMYK_K": 0.05401704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08385",
    "Farbtonhilfsbezeichnung": "Y6.08.78",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "209",
    "Bcolor": "226",
    "Y": 70,
    "L": 86.9332666409055,
    "a": 13.8653570551444,
    "b": -5.16783343014382,
    "C": 14.7971155509564,
    "h": -0.35676631460068,
    "CMY_C": 0.0581226,
    "CMY_M": 0.1787073,
    "CMY_Y": 0.1131363,
    "CMYK_C": 0,
    "CMYK_M": 0.1280259,
    "CMYK_Y": 0.05840856,
    "CMYK_K": 0.0581226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08386",
    "Farbtonhilfsbezeichnung": "Z0.11.73",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "192",
    "Bcolor": "210",
    "Y": 60,
    "L": 81.5895173987475,
    "a": 18.1602546735709,
    "b": -4.24789591729471,
    "C": 18.6504549417198,
    "h": -0.22978036014969,
    "CMY_C": 0.08465017,
    "CMY_M": 0.2487328,
    "CMY_Y": 0.1778664,
    "CMYK_C": 0,
    "CMYK_M": 0.1792568,
    "CMYK_Y": 0.1018367,
    "CMYK_K": 0.08465017
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08387",
    "Farbtonhilfsbezeichnung": "Y8.17.62",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "155",
    "Bcolor": "187",
    "Y": 42,
    "L": 70.296257019043,
    "a": 26.9831066131592,
    "b": -8.627610206604,
    "C": 28.3288497924805,
    "h": 342.268768310547,
    "CMY_C": 0.16382074356079,
    "CMY_M": 0.39249497652054,
    "CMY_Y": 0.26738566160202,
    "CMYK_C": 0,
    "CMYK_M": 0.27347514033318,
    "CMYK_Y": 0.12385492026806,
    "CMYK_K": 0.16382074356079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08388",
    "Farbtonhilfsbezeichnung": "Y6.24.52",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "127",
    "Bcolor": "167",
    "Y": 29,
    "L": 60.878116607666,
    "a": 31.7860641479492,
    "b": -11.9382238388062,
    "C": 33.9540138244629,
    "h": 339.414794921875,
    "CMY_C": 0.24647760391235,
    "CMY_M": 0.50346159934998,
    "CMY_Y": 0.34351736307144,
    "CMYK_C": 0,
    "CMYK_M": 0.34104359149933,
    "CMYK_Y": 0.12878151237965,
    "CMYK_K": 0.24647760391235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08389",
    "Farbtonhilfsbezeichnung": "Y9.25.58",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "136",
    "Bcolor": "176",
    "Y": 35,
    "L": 65.6484669184054,
    "a": 35.3879821935289,
    "b": -9.55116767313877,
    "C": 36.6542506082164,
    "h": -0.26361734350324,
    "CMY_C": 0.1649457,
    "CMY_M": 0.4669122,
    "CMY_Y": 0.3091896,
    "CMYK_C": 0,
    "CMYK_M": 0.361613,
    "CMYK_Y": 0.172736,
    "CMYK_K": 0.1649457
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08390",
    "Farbtonhilfsbezeichnung": "Y6.28.52",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "122",
    "Bcolor": "169",
    "Y": 29,
    "L": 60.6512537321497,
    "a": 36.3933303721757,
    "b": -13.2278035065985,
    "C": 38.7227230600781,
    "h": -0.34862211285048,
    "CMY_C": 0.2240735,
    "CMY_M": 0.5204072,
    "CMY_Y": 0.3365726,
    "CMYK_C": 0,
    "CMYK_M": 0.3819095,
    "CMYK_Y": 0.1449869,
    "CMYK_K": 0.2240735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08391",
    "Farbtonhilfsbezeichnung": "Y8.25.49",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "115",
    "Bcolor": "154",
    "Y": 25,
    "L": 56.689113339816,
    "a": 32.8653330905682,
    "b": -10.5173940144632,
    "C": 34.5071832523239,
    "h": -0.30971639785144,
    "CMY_C": 0.2821517,
    "CMY_M": 0.5500819,
    "CMY_Y": 0.3964286,
    "CMYK_C": 0,
    "CMYK_M": 0.3732407,
    "CMYK_Y": 0.1591936,
    "CMYK_K": 0.2821517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08392",
    "Farbtonhilfsbezeichnung": "Y9.20.60",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "146",
    "Bcolor": "179",
    "Y": 37,
    "L": 67.6097704474781,
    "a": 29.4620230608582,
    "b": -8.49263569046716,
    "C": 30.6616317864777,
    "h": -0.28064892913907,
    "CMY_C": 0.1774005,
    "CMY_M": 0.4281142,
    "CMY_Y": 0.2965478,
    "CMYK_C": 0,
    "CMYK_M": 0.3047822,
    "CMYK_Y": 0.1448424,
    "CMYK_K": 0.1774005
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08393",
    "Farbtonhilfsbezeichnung": "Z0.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "182",
    "Bcolor": "198",
    "Y": 52,
    "L": 77.5043173947867,
    "a": 16.3359241542937,
    "b": -3.90844629071381,
    "C": 16.7969750366616,
    "h": -0.23484013305085,
    "CMY_C": 0.1420902,
    "CMY_M": 0.2879004,
    "CMY_Y": 0.2248192,
    "CMYK_C": 0,
    "CMYK_M": 0.1699599,
    "CMYK_Y": 0.09643092,
    "CMYK_K": 0.1420902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08394",
    "Farbtonhilfsbezeichnung": "Y8.09.73",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "192",
    "Bcolor": "209",
    "Y": 58,
    "L": 80.8145558937837,
    "a": 14.2230052651385,
    "b": -4.88839553782539,
    "C": 15.0396239881982,
    "h": -0.33104812956793,
    "CMY_C": 0.1232038,
    "CMY_M": 0.2463994,
    "CMY_Y": 0.1822336,
    "CMYK_C": 0,
    "CMYK_M": 0.1405066,
    "CMYK_Y": 0.06732448,
    "CMYK_K": 0.1232038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08395",
    "Farbtonhilfsbezeichnung": "Y9.04.76",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "206",
    "Bcolor": "212",
    "Y": 64,
    "L": 84.2112955685053,
    "a": 7.79562347102014,
    "b": -1.96023740702171,
    "C": 8.03830056627689,
    "h": -0.24634626703404,
    "CMY_C": 0.1232548,
    "CMY_M": 0.1939643,
    "CMY_Y": 0.1672548,
    "CMYK_C": 0,
    "CMYK_M": 0.08065,
    "CMYK_Y": 0.05018565,
    "CMYK_K": 0.1232548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08396",
    "Farbtonhilfsbezeichnung": "ZN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "226",
    "Bcolor": "226",
    "Y": 78,
    "L": 90.7249146795463,
    "a": 4.25585878398893,
    "b": 0.28050448861884,
    "C": 4.26509281931719,
    "h": 0.06581500312408,
    "CMY_C": 0.07010249,
    "CMY_M": 0.1140681,
    "CMY_Y": 0.1126126,
    "CMYK_C": 0,
    "CMYK_M": 0.04728006,
    "CMYK_Y": 0.04571481,
    "CMYK_K": 0.07010249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08397",
    "Farbtonhilfsbezeichnung": "ZN.02.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "220",
    "Bcolor": "221",
    "Y": 73,
    "L": 88.3140640258789,
    "a": 3.45319676399231,
    "b": -0.33839416503906,
    "C": 3.46973752975464,
    "h": 354.403198242188,
    "CMY_C": 0.10526102781296,
    "CMY_M": 0.13863331079483,
    "CMY_Y": 0.13474255800247,
    "CMYK_C": 0,
    "CMYK_M": 0.03729834407568,
    "CMYK_Y": 0.03294986858964,
    "CMYK_K": 0.10526102781296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08398",
    "Farbtonhilfsbezeichnung": "Z0.03.78",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "210",
    "Bcolor": "214",
    "Y": 67,
    "L": 85.2873545248856,
    "a": 6.06601229312648,
    "b": -1.15292951446024,
    "C": 6.1746053805628,
    "h": -0.18782354946048,
    "CMY_C": 0.1216774,
    "CMY_M": 0.1781413,
    "CMY_Y": 0.1616118,
    "CMYK_C": 0,
    "CMYK_M": 0.06428605,
    "CMYK_Y": 0.04546664,
    "CMYK_K": 0.1216774
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08399",
    "Farbtonhilfsbezeichnung": "Y8.05.73",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "195",
    "Bcolor": "204",
    "Y": 58,
    "L": 80.6312209422155,
    "a": 9.63275551458009,
    "b": -2.86109712635283,
    "C": 10.0486743190382,
    "h": -0.2887183306148,
    "CMY_C": 0.1521844,
    "CMY_M": 0.2372239,
    "CMY_Y": 0.1994405,
    "CMYK_C": 0,
    "CMYK_M": 0.1003042,
    "CMYK_Y": 0.05573859,
    "CMYK_K": 0.1521844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08400",
    "Farbtonhilfsbezeichnung": "Y9.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "181",
    "Bcolor": "198",
    "Y": 52,
    "L": 77.458219781343,
    "a": 16.9410662056491,
    "b": -4.02982891758774,
    "C": 17.4137659708982,
    "h": -0.23353322786024,
    "CMY_C": 0.1387416,
    "CMY_M": 0.2899725,
    "CMY_Y": 0.2243676,
    "CMYK_C": 0,
    "CMYK_M": 0.1755929,
    "CMYK_Y": 0.09941968,
    "CMYK_K": 0.1387416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08401",
    "Farbtonhilfsbezeichnung": "Z3.12.66",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "169",
    "Bcolor": "186",
    "Y": 46,
    "L": 73.6056039776602,
    "a": 19.2152107466667,
    "b": -3.2518309659,
    "C": 19.4884255051454,
    "h": -0.1676437568104,
    "CMY_C": 0.163714,
    "CMY_M": 0.3373809,
    "CMY_Y": 0.2708523,
    "CMYK_C": 0,
    "CMYK_M": 0.2076645,
    "CMYK_Y": 0.1281121,
    "CMYK_K": 0.163714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08402",
    "Farbtonhilfsbezeichnung": "Z0.20.54",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "132",
    "Bcolor": "163",
    "Y": 31,
    "L": 62.1061186099056,
    "a": 28.4751760293342,
    "b": -7.34107551880681,
    "C": 29.4062415088089,
    "h": -0.25231202716987,
    "CMY_C": 0.2415276,
    "CMY_M": 0.4823484,
    "CMY_Y": 0.362333,
    "CMYK_C": 0,
    "CMYK_M": 0.3175077,
    "CMYK_Y": 0.1592746,
    "CMYK_K": 0.2415276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08403",
    "Farbtonhilfsbezeichnung": "Z0.30.45",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "98",
    "Bcolor": "140",
    "Y": 20,
    "L": 52.2079445121462,
    "a": 38.2711087700751,
    "b": -8.8834855582927,
    "C": 39.2885999006749,
    "h": -0.22808083545356,
    "CMY_C": 0.2959106,
    "CMY_M": 0.6144347,
    "CMY_Y": 0.4522726,
    "CMYK_C": 0,
    "CMYK_M": 0.4523915,
    "CMYK_Y": 0.2220769,
    "CMYK_K": 0.2959106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08404",
    "Farbtonhilfsbezeichnung": "Y9.33.49",
    "Farbtonklasse": "03",
    "Rcolor": "201",
    "Gcolor": "107",
    "Bcolor": "159",
    "Y": 25,
    "L": 57.356781300248,
    "a": 44.0201601341181,
    "b": -12.2408235397297,
    "C": 45.6903956993611,
    "h": -0.27122102101119,
    "CMY_C": 0.2132946,
    "CMY_M": 0.5821711,
    "CMY_Y": 0.376558,
    "CMYK_C": 0,
    "CMYK_M": 0.4688877,
    "CMYK_Y": 0.207528,
    "CMYK_K": 0.2132946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08405",
    "Farbtonhilfsbezeichnung": "Z1.37.42",
    "Farbtonklasse": "04",
    "Rcolor": "184",
    "Gcolor": "85",
    "Bcolor": "137",
    "Y": 18,
    "L": 50.0523451852734,
    "a": 46.4661989687349,
    "b": -10.2514796988221,
    "C": 47.5836156950838,
    "h": -0.2171437987676,
    "CMY_C": 0.2772715,
    "CMY_M": 0.6681857,
    "CMY_Y": 0.4640112,
    "CMYK_C": 0,
    "CMYK_M": 0.5408866,
    "CMYK_Y": 0.2583815,
    "CMYK_K": 0.2772715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08406",
    "Farbtonhilfsbezeichnung": "Y6.33.42",
    "Farbtonklasse": "04",
    "Rcolor": "175",
    "Gcolor": "97",
    "Bcolor": "147",
    "Y": 19,
    "L": 51.5598487854004,
    "a": 38.8717727661133,
    "b": -14.1388139724731,
    "C": 41.3632774353027,
    "h": 340.012176513672,
    "CMY_C": 0.31191152334213,
    "CMY_M": 0.62089037895203,
    "CMY_Y": 0.42435103654861,
    "CMYK_C": 0,
    "CMYK_M": 0.44903942942619,
    "CMYK_Y": 0.16340851783752,
    "CMYK_K": 0.31191152334213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08407",
    "Farbtonhilfsbezeichnung": "Z0.24.50",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "118",
    "Bcolor": "154",
    "Y": 26,
    "L": 57.9725606574102,
    "a": 32.1487449111447,
    "b": -8.54846243408198,
    "C": 33.2658685344117,
    "h": -0.25988971700394,
    "CMY_C": 0.2674953,
    "CMY_M": 0.5355095,
    "CMY_Y": 0.3964683,
    "CMYK_C": 0,
    "CMYK_M": 0.3658873,
    "CMYK_Y": 0.1760711,
    "CMYK_K": 0.2674953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08408",
    "Farbtonhilfsbezeichnung": "Z0.21.52",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "126",
    "Bcolor": "156",
    "Y": 28,
    "L": 59.8197394045078,
    "a": 28.7274814644966,
    "b": -7.11294109428671,
    "C": 29.5949678544138,
    "h": -0.24271911436353,
    "CMY_C": 0.2644668,
    "CMY_M": 0.5065308,
    "CMY_Y": 0.3875295,
    "CMYK_C": 0,
    "CMYK_M": 0.3291001,
    "CMYK_Y": 0.1673109,
    "CMYK_K": 0.2644668
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08409",
    "Farbtonhilfsbezeichnung": "Y6.13.62",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "162",
    "Bcolor": "185",
    "Y": 42,
    "L": 71.0132986011109,
    "a": 19.7365839261783,
    "b": -6.74103368498649,
    "C": 20.8560370209012,
    "h": -0.32912739305404,
    "CMY_C": 0.1987173,
    "CMY_M": 0.3650296,
    "CMY_Y": 0.2738873,
    "CMYK_C": 0,
    "CMYK_M": 0.2075576,
    "CMYK_Y": 0.09381209,
    "CMYK_K": 0.1987173
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08410",
    "Farbtonhilfsbezeichnung": "Y7.04.68",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "183",
    "Bcolor": "189",
    "Y": 50,
    "L": 75.7939084794902,
    "a": 6.44631617113911,
    "b": -2.05895645744081,
    "C": 6.7671481343271,
    "h": -0.3091590152225,
    "CMY_C": 0.2259496,
    "CMY_M": 0.2816352,
    "CMY_Y": 0.2576838,
    "CMYK_C": 0,
    "CMYK_M": 0.07194056,
    "CMYK_Y": 0.04099767,
    "CMYK_K": 0.2259496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08411",
    "Farbtonhilfsbezeichnung": "ZN.02.63",
    "Farbtonklasse": "01",
    "Rcolor": "179",
    "Gcolor": "172",
    "Bcolor": "172",
    "Y": 42,
    "L": 70.840149769581,
    "a": 2.9606401212165,
    "b": -0.18818188176548,
    "C": 2.96661462748056,
    "h": -0.06347582501601,
    "CMY_C": 0.2988568,
    "CMY_M": 0.3265631,
    "CMY_Y": 0.323864,
    "CMYK_C": 0,
    "CMYK_M": 0.039516,
    "CMYK_Y": 0.03566644,
    "CMYK_K": 0.2988568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08412",
    "Farbtonhilfsbezeichnung": "Y7.03.63",
    "Farbtonklasse": "02",
    "Rcolor": "181",
    "Gcolor": "171",
    "Bcolor": "175",
    "Y": 42,
    "L": 70.7980804443359,
    "a": 4.79122161865234,
    "b": -1.7255791425705,
    "C": 5.09248733520508,
    "h": 340.193298339844,
    "CMY_C": 0.29074227809906,
    "CMY_M": 0.33082640171051,
    "CMY_Y": 0.31327468156815,
    "CMYK_C": 0,
    "CMYK_M": 0.056515596807,
    "CMYK_Y": 0.03176899254322,
    "CMYK_K": 0.29074227809906
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08413",
    "Farbtonhilfsbezeichnung": "Z0.12.60",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "154",
    "Bcolor": "174",
    "Y": 38,
    "L": 68.0772687428359,
    "a": 19.8332862954325,
    "b": -4.96120299842853,
    "C": 20.4443826140142,
    "h": -0.2451153946926,
    "CMY_C": 0.2252078,
    "CMY_M": 0.3965877,
    "CMY_Y": 0.3173605,
    "CMYK_C": 0,
    "CMYK_M": 0.2211947,
    "CMYK_Y": 0.1189386,
    "CMYK_K": 0.2252078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08414",
    "Farbtonhilfsbezeichnung": "Y9.19.53",
    "Farbtonklasse": "03",
    "Rcolor": "189",
    "Gcolor": "132",
    "Bcolor": "160",
    "Y": 30,
    "L": 61.4508475624663,
    "a": 26.6999358549597,
    "b": -6.91645136036896,
    "C": 27.5812232157914,
    "h": -0.25347214431111,
    "CMY_C": 0.2586835,
    "CMY_M": 0.4838564,
    "CMY_Y": 0.3722563,
    "CMYK_C": 0,
    "CMYK_M": 0.3037474,
    "CMYK_Y": 0.1532042,
    "CMYK_K": 0.2586835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08415",
    "Farbtonhilfsbezeichnung": "Z0.26.47",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "110",
    "Bcolor": "146",
    "Y": 23,
    "L": 55.1702404908192,
    "a": 34.0963416448482,
    "b": -8.00476634615415,
    "C": 35.0233750203879,
    "h": -0.23059310282129,
    "CMY_C": 0.2853892,
    "CMY_M": 0.5704157,
    "CMY_Y": 0.4285403,
    "CMYK_C": 0,
    "CMYK_M": 0.3988555,
    "CMYK_Y": 0.2003204,
    "CMYK_K": 0.2853892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08416",
    "Farbtonhilfsbezeichnung": "Y6.30.42",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "96",
    "Bcolor": "143",
    "Y": 19,
    "L": 50.7071231899972,
    "a": 37.0148811608948,
    "b": -13.0028316367947,
    "C": 39.2323215975042,
    "h": -0.33782054801177,
    "CMY_C": 0.3291478,
    "CMY_M": 0.6232671,
    "CMY_Y": 0.440713,
    "CMYK_C": 0,
    "CMYK_M": 0.4384264,
    "CMYK_Y": 0.1663037,
    "CMYK_K": 0.3291478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08417",
    "Farbtonhilfsbezeichnung": "Y8.35.39",
    "Farbtonklasse": "04",
    "Rcolor": "169",
    "Gcolor": "85",
    "Bcolor": "134",
    "Y": 17,
    "L": 47.6889288170767,
    "a": 40.7690549306845,
    "b": -12.1245754995497,
    "C": 42.5337650694769,
    "h": -0.28906658244535,
    "CMY_C": 0.3387941,
    "CMY_M": 0.6678503,
    "CMY_Y": 0.4764427,
    "CMYK_C": 0,
    "CMYK_M": 0.4976606,
    "CMYK_Y": 0.208178,
    "CMYK_K": 0.3387941
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08418",
    "Farbtonhilfsbezeichnung": "Z0.36.39",
    "Farbtonklasse": "04",
    "Rcolor": "172",
    "Gcolor": "85",
    "Bcolor": "132",
    "Y": 17,
    "L": 48.1460652338879,
    "a": 41.5064618300446,
    "b": -10.443129146482,
    "C": 42.8000621497102,
    "h": -0.24648631937119,
    "CMY_C": 0.325991,
    "CMY_M": 0.6669117,
    "CMY_Y": 0.4825999,
    "CMYK_C": 0,
    "CMYK_M": 0.5058103,
    "CMYK_Y": 0.2323543,
    "CMYK_K": 0.325991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08419",
    "Farbtonhilfsbezeichnung": "Z1.29.40",
    "Farbtonklasse": "04",
    "Rcolor": "163",
    "Gcolor": "92",
    "Bcolor": "128",
    "Y": 17,
    "L": 48.2062112165006,
    "a": 34.0120177253153,
    "b": -8.27001458663326,
    "C": 35.0030068852704,
    "h": -0.23852107729324,
    "CMY_C": 0.3622662,
    "CMY_M": 0.6394621,
    "CMY_Y": 0.497007,
    "CMYK_C": 0,
    "CMYK_M": 0.4346577,
    "CMYK_Y": 0.2112807,
    "CMYK_K": 0.3622662
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08420",
    "Farbtonhilfsbezeichnung": "Y8.24.40",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "97",
    "Bcolor": "129",
    "Y": 17,
    "L": 48.3064752574832,
    "a": 28.8763632002886,
    "b": -8.56311609206775,
    "C": 30.1192846674885,
    "h": -0.28828326650188,
    "CMY_C": 0.3912648,
    "CMY_M": 0.6214297,
    "CMY_Y": 0.4947756,
    "CMYK_C": 0,
    "CMYK_M": 0.3781036,
    "CMYK_Y": 0.1700424,
    "CMYK_K": 0.3912648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08421",
    "Farbtonhilfsbezeichnung": "Y6.20.52",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "130",
    "Bcolor": "163",
    "Y": 29,
    "L": 60.6598416273509,
    "a": 26.4830771929616,
    "b": -9.87782405407884,
    "C": 28.265257572711,
    "h": -0.35700403641054,
    "CMY_C": 0.2765133,
    "CMY_M": 0.490247,
    "CMY_Y": 0.3604296,
    "CMYK_C": 0,
    "CMYK_M": 0.2954218,
    "CMYK_Y": 0.1159889,
    "CMYK_K": 0.2765133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08422",
    "Farbtonhilfsbezeichnung": "Y9.18.50",
    "Farbtonklasse": "03",
    "Rcolor": "176",
    "Gcolor": "125",
    "Bcolor": "151",
    "Y": 26,
    "L": 58.0901192288824,
    "a": 24.5464558958382,
    "b": -6.9756714277301,
    "C": 25.5183951085091,
    "h": -0.2768828405534,
    "CMY_C": 0.3087334,
    "CMY_M": 0.5116358,
    "CMY_Y": 0.4068044,
    "CMYK_C": 0,
    "CMYK_M": 0.2935226,
    "CMYK_Y": 0.1418715,
    "CMYK_K": 0.3087334
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08423",
    "Farbtonhilfsbezeichnung": "Y7.08.54",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "144",
    "Bcolor": "157",
    "Y": 31,
    "L": 62.2638210115024,
    "a": 11.9323233110538,
    "b": -4.03562057690974,
    "C": 12.5962920353688,
    "h": -0.32613232571499,
    "CMY_C": 0.3380466,
    "CMY_M": 0.4362458,
    "CMY_Y": 0.3853757,
    "CMYK_C": 0,
    "CMYK_M": 0.1483476,
    "CMYK_Y": 0.07149916,
    "CMYK_K": 0.3380466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08424",
    "Farbtonhilfsbezeichnung": "ZN.02.53",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "144",
    "Bcolor": "146",
    "Y": 29,
    "L": 60.355867981536,
    "a": 3.20263694949408,
    "b": -0.63918288138178,
    "C": 3.26579824638881,
    "h": -0.19699186096634,
    "CMY_C": 0.4083785,
    "CMY_M": 0.4360039,
    "CMY_Y": 0.429187,
    "CMYK_C": 0,
    "CMYK_M": 0.04669444,
    "CMYK_Y": 0.03517201,
    "CMYK_K": 0.4083785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08425",
    "Farbtonhilfsbezeichnung": "Y6.05.52",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "142",
    "Bcolor": "149",
    "Y": 28,
    "L": 60.2195129394531,
    "a": 6.67368936538696,
    "b": -2.569331407547,
    "C": 7.15119504928589,
    "h": 338.943572998047,
    "CMY_C": 0.39124065637589,
    "CMY_M": 0.44482344388962,
    "CMY_Y": 0.41702628135681,
    "CMYK_C": 0,
    "CMYK_M": 0.08801965415478,
    "CMYK_Y": 0.04235766455531,
    "CMYK_K": 0.39124065637589
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08426",
    "Farbtonhilfsbezeichnung": "Y8.10.46",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "124",
    "Bcolor": "137",
    "Y": 23,
    "L": 54.8342437389406,
    "a": 12.4577145384553,
    "b": -3.9051888231211,
    "C": 13.0554644216846,
    "h": -0.30377337182605,
    "CMY_C": 0.4118845,
    "CMY_M": 0.512781,
    "CMY_Y": 0.4619791,
    "CMYK_C": 0,
    "CMYK_M": 0.171559,
    "CMYK_Y": 0.08517823,
    "CMYK_K": 0.4118845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08427",
    "Farbtonhilfsbezeichnung": "Z0.15.49",
    "Farbtonklasse": "03",
    "Rcolor": "167",
    "Gcolor": "125",
    "Bcolor": "146",
    "Y": 25,
    "L": 57.1363899626122,
    "a": 19.5952183003689,
    "b": -5.36353903017244,
    "C": 20.3160067721808,
    "h": -0.26717277180259,
    "CMY_C": 0.3457872,
    "CMY_M": 0.5078472,
    "CMY_Y": 0.4280058,
    "CMYK_C": 0,
    "CMYK_M": 0.2477175,
    "CMYK_Y": 0.1256756,
    "CMYK_K": 0.3457872
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08428",
    "Farbtonhilfsbezeichnung": "Z0.20.43",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "106",
    "Bcolor": "133",
    "Y": 20,
    "L": 51.4129250529164,
    "a": 25.8756296270083,
    "b": -6.62957615878361,
    "C": 26.7114112064342,
    "h": -0.25081408935045,
    "CMY_C": 0.3712292,
    "CMY_M": 0.5823536,
    "CMY_Y": 0.4766782,
    "CMYK_C": 0,
    "CMYK_M": 0.3357732,
    "CMYK_Y": 0.1677066,
    "CMYK_K": 0.3712292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08429",
    "Farbtonhilfsbezeichnung": "Z0.25.40",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "95",
    "Bcolor": "126",
    "Y": 17,
    "L": 47.8990300608971,
    "a": 29.9316832798738,
    "b": -7.75345067423954,
    "C": 30.9195999541479,
    "h": -0.25346698966709,
    "CMY_C": 0.3875874,
    "CMY_M": 0.6290776,
    "CMY_Y": 0.5039284,
    "CMYK_C": 0,
    "CMYK_M": 0.394326,
    "CMYK_Y": 0.1899716,
    "CMYK_K": 0.3875874
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08430",
    "Farbtonhilfsbezeichnung": "Z1.29.36",
    "Farbtonklasse": "04",
    "Rcolor": "153",
    "Gcolor": "83",
    "Bcolor": "118",
    "Y": 14,
    "L": 44.489385046218,
    "a": 34.0263402268974,
    "b": -7.83323054172744,
    "C": 34.916347603328,
    "h": -0.22626857479744,
    "CMY_C": 0.4011505,
    "CMY_M": 0.6761674,
    "CMY_Y": 0.5365627,
    "CMYK_C": 0,
    "CMYK_M": 0.459242,
    "CMYK_Y": 0.2261207,
    "CMYK_K": 0.4011505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08431",
    "Farbtonhilfsbezeichnung": "Y6.37.33",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "73",
    "Bcolor": "124",
    "Y": 13,
    "L": 42.4753555538774,
    "a": 39.4760867316356,
    "b": -14.2941010526234,
    "C": 41.984315506463,
    "h": -0.34740914615226,
    "CMY_C": 0.4073418,
    "CMY_M": 0.7136263,
    "CMY_Y": 0.5147995,
    "CMYK_C": 0,
    "CMYK_M": 0.5167978,
    "CMYK_Y": 0.1813148,
    "CMYK_K": 0.4073418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08432",
    "Farbtonhilfsbezeichnung": "Z0.25.32",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "79",
    "Bcolor": "106",
    "Y": 12,
    "L": 40.713912028801,
    "a": 26.5987813856546,
    "b": -6.3915107968212,
    "C": 27.3559240653231,
    "h": -0.23582235373753,
    "CMY_C": 0.4787558,
    "CMY_M": 0.688352,
    "CMY_Y": 0.5833296,
    "CMYK_C": 0,
    "CMYK_M": 0.4021075,
    "CMYK_Y": 0.2006233,
    "CMYK_K": 0.4787558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08433",
    "Farbtonhilfsbezeichnung": "Y9.21.39",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "98",
    "Bcolor": "124",
    "Y": 16,
    "L": 47.4222788008697,
    "a": 24.0604734358633,
    "b": -6.79377065923115,
    "C": 25.001234004107,
    "h": -0.27519791847715,
    "CMY_C": 0.4244625,
    "CMY_M": 0.6160454,
    "CMY_Y": 0.5155961,
    "CMYK_C": 0,
    "CMYK_M": 0.3328765,
    "CMYK_Y": 0.1583453,
    "CMYK_K": 0.4244625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08434",
    "Farbtonhilfsbezeichnung": "Z0.16.40",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "101",
    "Bcolor": "121",
    "Y": 16,
    "L": 47.4247235299553,
    "a": 20.1796394006541,
    "b": -5.57804024476858,
    "C": 20.9363888794771,
    "h": -0.26968517194248,
    "CMY_C": 0.4445203,
    "CMY_M": 0.6053962,
    "CMY_Y": 0.5239056,
    "CMYK_C": 0,
    "CMYK_M": 0.289616,
    "CMYK_Y": 0.142913,
    "CMYK_K": 0.4445203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08436",
    "Farbtonhilfsbezeichnung": "Y6.08.34",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "101",
    "Bcolor": "109",
    "Y": 14,
    "L": 44.482250213623,
    "a": 7.86907625198364,
    "b": -3.0180881023407,
    "C": 8.42800235748291,
    "h": 339.016296386719,
    "CMY_C": 0.54389226436615,
    "CMY_M": 0.60353875160217,
    "CMY_Y": 0.57061219215393,
    "CMYK_C": 0,
    "CMYK_M": 0.13077279925346,
    "CMYK_Y": 0.05858249217272,
    "CMYK_K": 0.54389226436615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08437",
    "Farbtonhilfsbezeichnung": "Y7.06.44",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "122",
    "Bcolor": "130",
    "Y": 20,
    "L": 52.9665908813477,
    "a": 7.44012689590454,
    "b": -2.73062491416931,
    "C": 7.92538976669312,
    "h": 339.84619140625,
    "CMY_C": 0.46094751358032,
    "CMY_M": 0.51963639259338,
    "CMY_Y": 0.48912805318832,
    "CMYK_C": 0,
    "CMYK_M": 0.10887414216995,
    "CMYK_Y": 0.05227791517973,
    "CMYK_K": 0.46094751358032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08438",
    "Farbtonhilfsbezeichnung": "Z1.04.38",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "106",
    "Bcolor": "110",
    "Y": 15,
    "L": 45.749813859721,
    "a": 4.79799710714507,
    "b": -1.19872318391105,
    "C": 4.94547404318517,
    "h": -0.2448264187356,
    "CMY_C": 0.5463298,
    "CMY_M": 0.5849121,
    "CMY_Y": 0.5703999,
    "CMYK_C": 0,
    "CMYK_M": 0.0850447,
    "CMYK_Y": 0.05305637,
    "CMYK_K": 0.5463298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08439",
    "Farbtonhilfsbezeichnung": "Y9.15.26",
    "Farbtonklasse": "04",
    "Rcolor": "102",
    "Gcolor": "75",
    "Bcolor": "90",
    "Y": 9,
    "L": 35.194975656016,
    "a": 14.50169998648,
    "b": -4.803739460498,
    "C": 15.2766231642408,
    "h": -0.31987757420776,
    "CMY_C": 0.5989277,
    "CMY_M": 0.7063313,
    "CMY_Y": 0.6470325,
    "CMYK_C": 0,
    "CMYK_M": 0.2677912,
    "CMYK_Y": 0.1199403,
    "CMYK_K": 0.5989277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08440",
    "Farbtonhilfsbezeichnung": "Y9.20.31",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "77",
    "Bcolor": "100",
    "Y": 10,
    "L": 38.0899338351577,
    "a": 21.0917755942257,
    "b": -6.85817087628954,
    "C": 22.1787624876944,
    "h": -0.31437528289567,
    "CMY_C": 0.5375043,
    "CMY_M": 0.6965053,
    "CMY_Y": 0.6062469,
    "CMYK_C": 0,
    "CMYK_M": 0.3437892,
    "CMYK_Y": 0.1486341,
    "CMYK_K": 0.5375043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08441",
    "Farbtonhilfsbezeichnung": "Z0.29.25",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "63",
    "Bcolor": "93",
    "Y": 8,
    "L": 34.7850474233058,
    "a": 28.9161764704887,
    "b": -7.35166257822807,
    "C": 29.8360889584504,
    "h": -0.24896570362905,
    "CMY_C": 0.5293106,
    "CMY_M": 0.7514413,
    "CMY_Y": 0.633594,
    "CMYK_C": 0,
    "CMYK_M": 0.4719262,
    "CMYK_Y": 0.2215546,
    "CMYK_K": 0.5293106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08442",
    "Farbtonhilfsbezeichnung": "Y9.30.30",
    "Farbtonklasse": "04",
    "Rcolor": "133",
    "Gcolor": "72",
    "Bcolor": "107",
    "Y": 11,
    "L": 39.0048518090021,
    "a": 31.1081371743364,
    "b": -9.29510335201874,
    "C": 32.4671394610311,
    "h": -0.29035527662417,
    "CMY_C": 0.4782096,
    "CMY_M": 0.7183415,
    "CMY_Y": 0.5811265,
    "CMYK_C": 0,
    "CMYK_M": 0.4602076,
    "CMYK_Y": 0.1972381,
    "CMYK_K": 0.4782096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08443",
    "Farbtonhilfsbezeichnung": "Y9.35.30",
    "Farbtonklasse": "04",
    "Rcolor": "140",
    "Gcolor": "73",
    "Bcolor": "109",
    "Y": 10,
    "L": 40.190055847168,
    "a": 33.4610176086426,
    "b": -9.08817863464355,
    "C": 34.6732559204102,
    "h": 344.804748535156,
    "CMY_C": 0.45259654521942,
    "CMY_M": 0.7153068780899,
    "CMY_Y": 0.5706622004509,
    "CMYK_C": 0,
    "CMYK_M": 0.47992086410522,
    "CMYK_Y": 0.2156830728054,
    "CMYK_K": 0.45259654521942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08444",
    "Farbtonhilfsbezeichnung": "Z0.38.24",
    "Farbtonklasse": "04",
    "Rcolor": "131",
    "Gcolor": "56",
    "Bcolor": "94",
    "Y": 8,
    "L": 34.9605903914181,
    "a": 36.9217205672826,
    "b": -7.22232308076458,
    "C": 37.6214752545863,
    "h": -0.19317256846375,
    "CMY_C": 0.4858731,
    "CMY_M": 0.7800269,
    "CMY_Y": 0.6317039,
    "CMYK_C": 0,
    "CMYK_M": 0.5721424,
    "CMYK_Y": 0.2836473,
    "CMYK_K": 0.4858731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08447",
    "Farbtonhilfsbezeichnung": "Y7.17.23",
    "Farbtonklasse": "04",
    "Rcolor": "100",
    "Gcolor": "70",
    "Bcolor": "87",
    "Y": 8,
    "L": 33.3582338639939,
    "a": 16.1438454342789,
    "b": -5.79589791944012,
    "C": 17.1527309224641,
    "h": -0.34468415372506,
    "CMY_C": 0.6097773,
    "CMY_M": 0.7270676,
    "CMY_Y": 0.6579307,
    "CMYK_C": 0,
    "CMYK_M": 0.3005729,
    "CMYK_Y": 0.1233999,
    "CMYK_K": 0.6097773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08448",
    "Farbtonhilfsbezeichnung": "Z1.36.22",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "54",
    "Bcolor": "88",
    "Y": 7,
    "L": 32.4862186416008,
    "a": 32.9303076128519,
    "b": -7.29031549562832,
    "C": 33.7276423650223,
    "h": -0.21787212000549,
    "CMY_C": 0.5320691,
    "CMY_M": 0.7876281,
    "CMY_Y": 0.6550076,
    "CMYK_C": 0,
    "CMYK_M": 0.5461469,
    "CMYK_Y": 0.2627279,
    "CMYK_K": 0.5320691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08449",
    "Farbtonhilfsbezeichnung": "Z1.31.19",
    "Farbtonklasse": "04",
    "Rcolor": "107",
    "Gcolor": "50",
    "Bcolor": "79",
    "Y": 6,
    "L": 29.3407996217176,
    "a": 29.2367242199656,
    "b": -6.53904171584577,
    "C": 29.9590572227481,
    "h": -0.2200372116155,
    "CMY_C": 0.5813773,
    "CMY_M": 0.8034399,
    "CMY_Y": 0.689013,
    "CMYK_C": 0,
    "CMYK_M": 0.5304601,
    "CMYK_Y": 0.2571186,
    "CMYK_K": 0.5813773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08450",
    "Farbtonhilfsbezeichnung": "Z0.26.15",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "49",
    "Bcolor": "68",
    "Y": 5,
    "L": 26.1451531104019,
    "a": 21.8807825054849,
    "b": -4.36818257883606,
    "C": 22.3125449488484,
    "h": -0.19704512585606,
    "CMY_C": 0.6458472,
    "CMY_M": 0.8084728,
    "CMY_Y": 0.731532,
    "CMYK_C": 0,
    "CMYK_M": 0.4591959,
    "CMYK_Y": 0.241943,
    "CMYK_K": 0.6458472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08451",
    "Farbtonhilfsbezeichnung": "Y6.23.17",
    "Farbtonklasse": "04",
    "Rcolor": "87",
    "Gcolor": "52",
    "Bcolor": "73",
    "Y": 5,
    "L": 26.5186094994947,
    "a": 19.5640315296131,
    "b": -6.70376496969866,
    "C": 20.6807106855798,
    "h": -0.33011883043923,
    "CMY_C": 0.6590855,
    "CMY_M": 0.797497,
    "CMY_Y": 0.7148497,
    "CMYK_C": 0,
    "CMYK_M": 0.4060006,
    "CMYK_Y": 0.1635725,
    "CMYK_K": 0.6590855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08452",
    "Farbtonhilfsbezeichnung": "Y8.20.13",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "53",
    "Bcolor": "66",
    "Y": 5,
    "L": 25.447789364166,
    "a": 13.9846065065369,
    "b": -3.74519838111879,
    "C": 14.477421388376,
    "h": -0.26166824142907,
    "CMY_C": 0.6922384,
    "CMY_M": 0.7927964,
    "CMY_Y": 0.7422789,
    "CMYK_C": 0,
    "CMYK_M": 0.3267399,
    "CMYK_Y": 0.1625948,
    "CMYK_K": 0.6922384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08453",
    "Farbtonhilfsbezeichnung": "Y7.16.13",
    "Farbtonklasse": "04",
    "Rcolor": "71",
    "Gcolor": "52",
    "Bcolor": "63",
    "Y": 4,
    "L": 24.2249786103326,
    "a": 10.6981820318418,
    "b": -4.16358647360489,
    "C": 11.4798323641771,
    "h": -0.37114965192361,
    "CMY_C": 0.7223638,
    "CMY_M": 0.7953203,
    "CMY_Y": 0.7510365,
    "CMYK_C": 0,
    "CMYK_M": 0.2627775,
    "CMYK_Y": 0.1032744,
    "CMYK_K": 0.7223638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08454",
    "Farbtonhilfsbezeichnung": "Y7.11.09",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "51",
    "Bcolor": "57",
    "Y": 4,
    "L": 22.6673661103487,
    "a": 6.20099936823987,
    "b": -2.09754526362473,
    "C": 6.54615072373573,
    "h": -0.32617728960036,
    "CMY_C": 0.7565412,
    "CMY_M": 0.7993164,
    "CMY_Y": 0.7770032,
    "CMYK_C": 0,
    "CMYK_M": 0.1756981,
    "CMYK_Y": 0.08404723,
    "CMYK_K": 0.7565412
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08455",
    "Farbtonhilfsbezeichnung": "Z1.08.07",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "49",
    "Bcolor": "52",
    "Y": 3,
    "L": 21.2178817979491,
    "a": 3.84432172859495,
    "b": -1.23742894149775,
    "C": 4.03856904586309,
    "h": -0.31141178189369,
    "CMY_C": 0.7806312,
    "CMY_M": 0.8071053,
    "CMY_Y": 0.7946243,
    "CMYK_C": 0,
    "CMYK_M": 0.120683,
    "CMYK_Y": 0.06378809,
    "CMYK_K": 0.7806312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08456",
    "Farbtonhilfsbezeichnung": "Y5.06.23",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "67",
    "Bcolor": "75",
    "Y": 6,
    "L": 29.6326356978698,
    "a": 6.06078786355463,
    "b": -3.45130843140249,
    "C": 6.97457378021632,
    "h": -0.51765240531021,
    "CMY_C": 0.6979862,
    "CMY_M": 0.737518,
    "CMY_Y": 0.7073751,
    "CMYK_C": 0,
    "CMYK_M": 0.130894,
    "CMYK_Y": 0.03108756,
    "CMYK_K": 0.6979862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08457",
    "Farbtonhilfsbezeichnung": "Z1.08.16",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "70",
    "Bcolor": "74",
    "Y": 5,
    "L": 30.8464698791504,
    "a": 6.06018209457397,
    "b": -1.50268387794495,
    "C": 6.24370622634888,
    "h": 346.073822021484,
    "CMY_C": 0.68166130781174,
    "CMY_M": 0.7270964384079,
    "CMY_Y": 0.7080482840538,
    "CMYK_C": 0,
    "CMYK_M": 0.14272575080395,
    "CMYK_Y": 0.08288963139057,
    "CMYK_K": 0.68166130781174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08458",
    "Farbtonhilfsbezeichnung": "Z0.19.16",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "55",
    "Bcolor": "70",
    "Y": 5,
    "L": 26.4711087810499,
    "a": 14.4386539754809,
    "b": -4.91792201997615,
    "C": 15.2532188608909,
    "h": -0.32828346395675,
    "CMY_C": 0.6828787,
    "CMY_M": 0.7846344,
    "CMY_Y": 0.7262774,
    "CMYK_C": 0,
    "CMYK_M": 0.3208731,
    "CMYK_Y": 0.1368519,
    "CMYK_K": 0.6828787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08459",
    "Farbtonhilfsbezeichnung": "Z1.20.20",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "59",
    "Bcolor": "75",
    "Y": 6,
    "L": 29.1648173007079,
    "a": 17.2112355579364,
    "b": -4.22762067428123,
    "C": 17.722849827169,
    "h": -0.24086287533145,
    "CMY_C": 0.6407408,
    "CMY_M": 0.7682403,
    "CMY_Y": 0.7057397,
    "CMYK_C": 0,
    "CMYK_M": 0.3548957,
    "CMYK_Y": 0.1809248,
    "CMYK_K": 0.6407408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08460",
    "Farbtonhilfsbezeichnung": "Y6.31.23",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "59",
    "Bcolor": "93",
    "Y": 7,
    "L": 32.223529822859,
    "a": 27.1262229671786,
    "b": -11.0548045931804,
    "C": 29.2923313694641,
    "h": -0.38698259151881,
    "CMY_C": 0.5729924,
    "CMY_M": 0.7677696,
    "CMY_Y": 0.6355039,
    "CMYK_C": 0,
    "CMYK_M": 0.4561446,
    "CMYK_Y": 0.1463944,
    "CMYK_K": 0.5729924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08462",
    "Farbtonhilfsbezeichnung": "Z3.27.53",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "122",
    "Bcolor": "158",
    "Y": 30,
    "L": 61.3711480717934,
    "a": 37.6217004570195,
    "b": -5.63884456420605,
    "C": 38.0419362453723,
    "h": -0.14877529234945,
    "CMY_C": 0.1902711,
    "CMY_M": 0.5201303,
    "CMY_Y": 0.3802208,
    "CMYK_C": 0,
    "CMYK_M": 0.40737,
    "CMYK_Y": 0.2345843,
    "CMYK_K": 0.1902711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08463",
    "Farbtonhilfsbezeichnung": "Z6.19.67",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "166",
    "Bcolor": "189",
    "Y": 49,
    "L": 75.1915768490302,
    "a": 29.3514235199445,
    "b": -2.29715332833391,
    "C": 29.4411782383285,
    "h": -0.07810456959989,
    "CMY_C": 0.07667884,
    "CMY_M": 0.350103,
    "CMY_Y": 0.2592169,
    "CMYK_C": 0,
    "CMYK_M": 0.2961311,
    "CMYK_Y": 0.1976972,
    "CMYK_K": 0.07667884
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08464",
    "Farbtonhilfsbezeichnung": "Z3.11.72",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "188",
    "Bcolor": "206",
    "Y": 58,
    "L": 80.7482522771163,
    "a": 19.4711015834066,
    "b": -3.27092677142196,
    "C": 19.7439296700365,
    "h": -0.16643479005904,
    "CMY_C": 0.0821553,
    "CMY_M": 0.2617213,
    "CMY_Y": 0.1938618,
    "CMYK_C": 0,
    "CMYK_M": 0.1956388,
    "CMYK_Y": 0.1217052,
    "CMYK_K": 0.0821553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08465",
    "Farbtonhilfsbezeichnung": "A3.11.75",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "193",
    "Bcolor": "200",
    "Y": 61,
    "L": 82.2153721870855,
    "a": 18.396594159283,
    "b": 2.1013251671109,
    "C": 18.516215707301,
    "h": 0.11373069081574,
    "CMY_C": 0.05811432,
    "CMY_M": 0.2445572,
    "CMY_Y": 0.2168219,
    "CMYK_C": 0,
    "CMYK_M": 0.1979464,
    "CMYK_Y": 0.1684998,
    "CMYK_K": 0.05811432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08466",
    "Farbtonhilfsbezeichnung": "Z2.10.75",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "198",
    "Bcolor": "214",
    "Y": 64,
    "L": 83.7179610605671,
    "a": 16.6060553395274,
    "b": -3.26372828938624,
    "C": 16.923740611531,
    "h": -0.19406493647838,
    "CMY_C": 0.06872663,
    "CMY_M": 0.2217456,
    "CMY_Y": 0.1619632,
    "CMYK_C": 0,
    "CMYK_M": 0.1643115,
    "CMYK_Y": 0.1001173,
    "CMYK_K": 0.06872663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08467",
    "Farbtonhilfsbezeichnung": "Z5.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "218",
    "Bcolor": "226",
    "Y": 75,
    "L": 89.4503642266779,
    "a": 11.8975687530216,
    "b": -1.24344555195997,
    "C": 11.9623701277617,
    "h": -0.10413452396755,
    "CMY_C": 0.03183576,
    "CMY_M": 0.1470479,
    "CMY_Y": 0.1143762,
    "CMYK_C": 0,
    "CMYK_M": 0.1190006,
    "CMYK_Y": 0.0852546,
    "CMYK_K": 0.03183576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08468",
    "Farbtonhilfsbezeichnung": "A0.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "215",
    "Bcolor": "221",
    "Y": 74,
    "L": 88.8485726205275,
    "a": 12.2509773180515,
    "b": 0.39474824014562,
    "C": 12.2573354127441,
    "h": 0.03221063104603,
    "CMY_C": 0.0310948,
    "CMY_M": 0.1551086,
    "CMY_Y": 0.1330035,
    "CMYK_C": 0,
    "CMYK_M": 0.1279938,
    "CMYK_Y": 0.1051792,
    "CMYK_K": 0.0310948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08469",
    "Farbtonhilfsbezeichnung": "Z6.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "217",
    "Bcolor": "220",
    "Y": 73,
    "L": 88.5103413152374,
    "a": 7.96670020647972,
    "b": 0.58237368916473,
    "C": 7.98795789258777,
    "h": 0.0729711967766,
    "CMY_C": 0.06590805,
    "CMY_M": 0.1479159,
    "CMY_Y": 0.1387172,
    "CMYK_C": 0,
    "CMYK_M": 0.08779413,
    "CMYK_Y": 0.07794645,
    "CMYK_K": 0.06590805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08470",
    "Farbtonhilfsbezeichnung": "A1.05.77",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "207",
    "Bcolor": "210",
    "Y": 67,
    "L": 85.1843719482422,
    "a": 9.36896991729736,
    "b": 0.88643336296082,
    "C": 9.41081047058105,
    "h": 5.40487909317017,
    "CMY_C": 0.09192609786987,
    "CMY_M": 0.18807572126389,
    "CMY_Y": 0.17713570594788,
    "CMYK_C": 0,
    "CMYK_M": 0.10588303953409,
    "CMYK_Y": 0.09383554011583,
    "CMYK_K": 0.09192609786987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08471",
    "Farbtonhilfsbezeichnung": "Z9.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "205",
    "Bcolor": "211",
    "Y": 67,
    "L": 85.2579469064743,
    "a": 12.6547638560578,
    "b": 0.28753211479593,
    "C": 12.6580299798044,
    "h": 0.02271734608265,
    "CMY_C": 0.06908194,
    "CMY_M": 0.1955741,
    "CMY_Y": 0.1715005,
    "CMYK_C": 0,
    "CMYK_M": 0.1358789,
    "CMYK_Y": 0.1100188,
    "CMYK_K": 0.06908194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08472",
    "Farbtonhilfsbezeichnung": "Z8.07.73",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "194",
    "Bcolor": "200",
    "Y": 59,
    "L": 81.1511831896351,
    "a": 12.8945717477139,
    "b": 0.19133635819266,
    "C": 12.8959912437512,
    "h": 0.01483743088729,
    "CMY_C": 0.1137082,
    "CMY_M": 0.2408447,
    "CMY_Y": 0.2153451,
    "CMYK_C": 0,
    "CMYK_M": 0.1434477,
    "CMYK_Y": 0.1146765,
    "CMYK_K": 0.1137082
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08473",
    "Farbtonhilfsbezeichnung": "Z6.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "196",
    "Bcolor": "208",
    "Y": 63,
    "L": 83.3957007275843,
    "a": 19.019168965951,
    "b": -0.35908600562,
    "C": 19.0225584744752,
    "h": -0.0188779724542,
    "CMY_C": 0.04712319,
    "CMY_M": 0.2327151,
    "CMY_Y": 0.1861641,
    "CMYK_C": 0,
    "CMYK_M": 0.1947701,
    "CMYK_Y": 0.1459169,
    "CMYK_K": 0.04712319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08474",
    "Farbtonhilfsbezeichnung": "Z4.20.64",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "158",
    "Bcolor": "186",
    "Y": 45,
    "L": 72.9342348954709,
    "a": 31.4749470984378,
    "b": -3.8586424240884,
    "C": 31.7105883926242,
    "h": -0.12198539902297,
    "CMY_C": 0.09272432,
    "CMY_M": 0.3800571,
    "CMY_Y": 0.2719947,
    "CMYK_C": 0,
    "CMYK_M": 0.3166984,
    "CMYK_Y": 0.197592,
    "CMYK_K": 0.09272432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08476",
    "Farbtonhilfsbezeichnung": "A1.31.50",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "107",
    "Bcolor": "137",
    "Y": 25,
    "L": 57.5321595665939,
    "a": 42.98128654503,
    "b": 1.22777726702192,
    "C": 42.9988189382382,
    "h": 0.0285576254508,
    "CMY_C": 0.1892565,
    "CMY_M": 0.5816674,
    "CMY_Y": 0.4645568,
    "CMYK_C": 0,
    "CMYK_M": 0.4840136,
    "CMYK_Y": 0.3395652,
    "CMYK_K": 0.1892565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08478",
    "Farbtonhilfsbezeichnung": "Z9.31.18",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "51",
    "Bcolor": "69",
    "Y": 6,
    "L": 29.0024618611993,
    "a": 27.1484382219024,
    "b": -0.39771163306308,
    "C": 27.1513512082092,
    "h": -0.01464847379845,
    "CMY_C": 0.5841133,
    "CMY_M": 0.8013179,
    "CMY_Y": 0.7285146,
    "CMYK_C": 0,
    "CMYK_M": 0.5222688,
    "CMYK_Y": 0.3472131,
    "CMYK_K": 0.5841133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08479",
    "Farbtonhilfsbezeichnung": "Z4.30.16",
    "Farbtonklasse": "04",
    "Rcolor": "94",
    "Gcolor": "47",
    "Bcolor": "67",
    "Y": 5,
    "L": 26.2070378508334,
    "a": 23.8430012739898,
    "b": -3.06358893185643,
    "C": 24.0390159302512,
    "h": -0.12778988340432,
    "CMY_C": 0.6329497,
    "CMY_M": 0.8145645,
    "CMY_Y": 0.7383059,
    "CMYK_C": 0,
    "CMYK_M": 0.4947954,
    "CMYK_Y": 0.2870347,
    "CMYK_K": 0.6329497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08480",
    "Farbtonhilfsbezeichnung": "Z8.27.16",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "51",
    "Bcolor": "65",
    "Y": 5,
    "L": 26.8520765461502,
    "a": 21.3704793030136,
    "b": -0.72511110228079,
    "C": 21.3827774564293,
    "h": -0.03391749036924,
    "CMY_C": 0.6346863,
    "CMY_M": 0.8017899,
    "CMY_Y": 0.7464923,
    "CMYK_C": 0,
    "CMYK_M": 0.4574251,
    "CMYK_Y": 0.3060546,
    "CMYK_K": 0.6346863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08481",
    "Farbtonhilfsbezeichnung": "Z6.21.13",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "49",
    "Bcolor": "59",
    "Y": 4,
    "L": 24.4419081718094,
    "a": 15.687060269007,
    "b": -0.72637277512437,
    "C": 15.7038682270292,
    "h": -0.04627089471676,
    "CMY_C": 0.6865501,
    "CMY_M": 0.8068272,
    "CMY_Y": 0.7683572,
    "CMYK_C": 0,
    "CMYK_M": 0.3837204,
    "CMYK_Y": 0.2609892,
    "CMYK_K": 0.6865501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08482",
    "Farbtonhilfsbezeichnung": "Z9.19.12",
    "Farbtonklasse": "04",
    "Rcolor": "84",
    "Gcolor": "63",
    "Bcolor": "69",
    "Y": 4,
    "L": 29.0806484222412,
    "a": 10.6120891571045,
    "b": -0.23836396634579,
    "C": 10.6147661209106,
    "h": 358.713256835938,
    "CMY_C": 0.66887390613556,
    "CMY_M": 0.75348061323166,
    "CMY_Y": 0.73092848062515,
    "CMYK_C": 0,
    "CMYK_M": 0.25551205873489,
    "CMYK_Y": 0.18740466237068,
    "CMYK_K": 0.66887390613556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08483",
    "Farbtonhilfsbezeichnung": "Z3.10.14",
    "Farbtonklasse": "04",
    "Rcolor": "73",
    "Gcolor": "60",
    "Bcolor": "65",
    "Y": 5,
    "L": 26.7160595600262,
    "a": 7.24065636010199,
    "b": -1.20740194422755,
    "C": 7.34063512102392,
    "h": -0.16523278027124,
    "CMY_C": 0.7120165,
    "CMY_M": 0.7665567,
    "CMY_Y": 0.7466169,
    "CMYK_C": 0,
    "CMYK_M": 0.1893867,
    "CMYK_Y": 0.1201471,
    "CMYK_K": 0.7120165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08484",
    "Farbtonhilfsbezeichnung": "Z3.05.17",
    "Farbtonklasse": "03",
    "Rcolor": "74",
    "Gcolor": "67",
    "Bcolor": "70",
    "Y": 6,
    "L": 29.0541922543059,
    "a": 4.12715739915254,
    "b": -1.31799089449015,
    "C": 4.33249676229983,
    "h": -0.30910951221251,
    "CMY_C": 0.7093331,
    "CMY_M": 0.7391803,
    "CMY_Y": 0.7255092,
    "CMYK_C": 0,
    "CMYK_M": 0.1026853,
    "CMYK_Y": 0.05565172,
    "CMYK_K": 0.7093331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08485",
    "Farbtonhilfsbezeichnung": "Z5.05.11",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "53",
    "Bcolor": "56",
    "Y": 4,
    "L": 22.8836761437068,
    "a": 3.22950338011024,
    "b": -1.30303617253565,
    "C": 3.48246971976496,
    "h": -0.38350174689035,
    "CMY_C": 0.7698381,
    "CMY_M": 0.79159,
    "CMY_Y": 0.7800022,
    "CMYK_C": 0,
    "CMYK_M": 0.09450702,
    "CMYK_Y": 0.04416055,
    "CMYK_K": 0.7698381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08486",
    "Farbtonhilfsbezeichnung": "Z3.04.30",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "90",
    "Bcolor": "94",
    "Y": 11,
    "L": 39.1473320095939,
    "a": 4.75761716493389,
    "b": -1.2233247113331,
    "C": 4.91237665875,
    "h": -0.25167763789557,
    "CMY_C": 0.6107723,
    "CMY_M": 0.6478563,
    "CMY_Y": 0.6332663,
    "CMYK_C": 0,
    "CMYK_M": 0.09527598,
    "CMYK_Y": 0.05779156,
    "CMYK_K": 0.6107723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08487",
    "Farbtonhilfsbezeichnung": "Z3.09.23",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "74",
    "Bcolor": "82",
    "Y": 8,
    "L": 33.4326413057637,
    "a": 8.28582542662101,
    "b": -2.33652038052138,
    "C": 8.60896221905004,
    "h": -0.27485312680684,
    "CMY_C": 0.6462424,
    "CMY_M": 0.7083309,
    "CMY_Y": 0.6791574,
    "CMYK_C": 0,
    "CMYK_M": 0.1755112,
    "CMYK_Y": 0.09304369,
    "CMYK_K": 0.6462424
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08488",
    "Farbtonhilfsbezeichnung": "Z3.13.17",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "60",
    "Bcolor": "69",
    "Y": 5,
    "L": 27.8679122417136,
    "a": 11.0700029208903,
    "b": -2.20289084895018,
    "C": 11.2870586408022,
    "h": -0.19643038427007,
    "CMY_C": 0.682097,
    "CMY_M": 0.7648328,
    "CMY_Y": 0.7300902,
    "CMYK_C": 0,
    "CMYK_M": 0.2602548,
    "CMYK_Y": 0.150968,
    "CMYK_K": 0.682097
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08489",
    "Farbtonhilfsbezeichnung": "Z9.19.20",
    "Farbtonklasse": "04",
    "Rcolor": "101",
    "Gcolor": "71",
    "Bcolor": "80",
    "Y": 7,
    "L": 33.6810340881348,
    "a": 14.3665714263916,
    "b": -0.38194179534912,
    "C": 14.3716478347778,
    "h": 358.477111816406,
    "CMY_C": 0.60422790050507,
    "CMY_M": 0.7211064696312,
    "CMY_Y": 0.68801373243332,
    "CMYK_C": 0,
    "CMYK_M": 0.29531785845757,
    "CMYK_Y": 0.21170221269131,
    "CMYK_K": 0.60422790050507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08490",
    "Farbtonhilfsbezeichnung": "Z4.24.15",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "54",
    "Bcolor": "67",
    "Y": 5,
    "L": 26.8834052668863,
    "a": 17.6127761621106,
    "b": -2.40226540631514,
    "C": 17.7758477496571,
    "h": -0.13555687741671,
    "CMY_C": 0.6566834,
    "CMY_M": 0.7901534,
    "CMY_Y": 0.7369168,
    "CMYK_C": 0,
    "CMYK_M": 0.3887665,
    "CMYK_Y": 0.2337008,
    "CMYK_K": 0.6566834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08491",
    "Farbtonhilfsbezeichnung": "Z9.30.21",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "54",
    "Bcolor": "73",
    "Y": 6,
    "L": 30.4598104389637,
    "a": 26.9038993090795,
    "b": -0.59444145361976,
    "C": 26.9104655975119,
    "h": -0.02209139805042,
    "CMY_C": 0.5708595,
    "CMY_M": 0.7870585,
    "CMY_Y": 0.7143148,
    "CMYK_C": 0,
    "CMYK_M": 0.5037955,
    "CMYK_Y": 0.3342851,
    "CMYK_K": 0.5708595
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08492",
    "Farbtonhilfsbezeichnung": "Z3.31.24",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "59",
    "Bcolor": "87",
    "Y": 8,
    "L": 33.6986585851348,
    "a": 30.0990826830483,
    "b": -4.74844741020727,
    "C": 30.4713395040074,
    "h": -0.15647093755217,
    "CMY_C": 0.5290881,
    "CMY_M": 0.7667031,
    "CMY_Y": 0.6593897,
    "CMYK_C": 0,
    "CMYK_M": 0.5045849,
    "CMYK_Y": 0.2767006,
    "CMYK_K": 0.5290881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08494",
    "Farbtonhilfsbezeichnung": "Z8.42.31",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "61",
    "Bcolor": "98",
    "Y": 12,
    "L": 40.5348623914261,
    "a": 44.5543909025549,
    "b": -1.32595811196669,
    "C": 44.5741170816917,
    "h": -0.02975165484787,
    "CMY_C": 0.3769145,
    "CMY_M": 0.7612277,
    "CMY_Y": 0.6140504,
    "CMYK_C": 0,
    "CMYK_M": 0.6167904,
    "CMYK_Y": 0.3805833,
    "CMYK_K": 0.3769145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08495",
    "Farbtonhilfsbezeichnung": "Z9.37.33",
    "Farbtonklasse": "04",
    "Rcolor": "161",
    "Gcolor": "73",
    "Bcolor": "102",
    "Y": 13,
    "L": 43.2684282047088,
    "a": 39.9927436291847,
    "b": 0.28117122687276,
    "C": 39.9937320120105,
    "h": 0.00703044024617,
    "CMY_C": 0.3672191,
    "CMY_M": 0.7139862,
    "CMY_Y": 0.5987821,
    "CMYK_C": 0,
    "CMYK_M": 0.5480049,
    "CMYK_Y": 0.365945,
    "CMYK_K": 0.3672191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08496",
    "Farbtonhilfsbezeichnung": "Z4.27.25",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "68",
    "Bcolor": "90",
    "Y": 9,
    "L": 35.7378318683924,
    "a": 25.4567871620097,
    "b": -3.46022055739023,
    "C": 25.6908765696627,
    "h": -0.13509732074317,
    "CMY_C": 0.529881,
    "CMY_M": 0.7326086,
    "CMY_Y": 0.6488219,
    "CMYK_C": 0,
    "CMYK_M": 0.4312262,
    "CMYK_Y": 0.2530019,
    "CMYK_K": 0.529881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08497",
    "Farbtonhilfsbezeichnung": "Z8.11.28",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "81",
    "Bcolor": "89",
    "Y": 10,
    "L": 37.1091760536876,
    "a": 11.7162181831308,
    "b": -1.19408408335185,
    "C": 11.7769098371703,
    "h": -0.10156650199636,
    "CMY_C": 0.5877948,
    "CMY_M": 0.6827924,
    "CMY_Y": 0.6516998,
    "CMYK_C": 0,
    "CMYK_M": 0.2304617,
    "CMYK_Y": 0.155032,
    "CMYK_K": 0.5877948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08498",
    "Farbtonhilfsbezeichnung": "Z3.08.34",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "97",
    "Bcolor": "104",
    "Y": 13,
    "L": 42.885743184354,
    "a": 8.40481710142671,
    "b": -1.797480057415,
    "C": 8.59487551191054,
    "h": -0.21068921696708,
    "CMY_C": 0.5528781,
    "CMY_M": 0.6204235,
    "CMY_Y": 0.5937056000000001,
    "CMYK_C": 0,
    "CMYK_M": 0.151067,
    "CMYK_Y": 0.09131178,
    "CMYK_K": 0.5528781
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08500",
    "Farbtonhilfsbezeichnung": "Z8.34.33",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "73",
    "Bcolor": "102",
    "Y": 13,
    "L": 42.3470670171445,
    "a": 37.8454518830427,
    "b": -1.20990776077148,
    "C": 37.8647871382011,
    "h": -0.03195881547284,
    "CMY_C": 0.3909615,
    "CMY_M": 0.7139176,
    "CMY_Y": 0.5985602,
    "CMYK_C": 0,
    "CMYK_M": 0.5302721,
    "CMYK_Y": 0.3408629,
    "CMYK_K": 0.3909615
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08501",
    "Farbtonhilfsbezeichnung": "Z9.31.30",
    "Farbtonklasse": "04",
    "Rcolor": "141",
    "Gcolor": "70",
    "Bcolor": "94",
    "Y": 11,
    "L": 39.3004691544759,
    "a": 32.7878914789074,
    "b": -0.39813103002598,
    "C": 32.7903085674667,
    "h": -0.01214202702727,
    "CMY_C": 0.4485714,
    "CMY_M": 0.7247289,
    "CMY_Y": 0.6332398,
    "CMYK_C": 0,
    "CMYK_M": 0.5008036,
    "CMYK_Y": 0.3348909,
    "CMYK_K": 0.4485714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08502",
    "Farbtonhilfsbezeichnung": "Z7.21.31",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "78",
    "Bcolor": "95",
    "Y": 11,
    "L": 39.40151250865,
    "a": 23.3879779330503,
    "b": -1.64226688710394,
    "C": 23.4455657284128,
    "h": -0.07010335454647,
    "CMY_C": 0.499834,
    "CMY_M": 0.6925463,
    "CMY_Y": 0.6258989,
    "CMYK_C": 0,
    "CMYK_M": 0.3852967,
    "CMYK_Y": 0.2520462,
    "CMYK_K": 0.499834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08503",
    "Farbtonhilfsbezeichnung": "Z8.17.40",
    "Farbtonklasse": "03",
    "Rcolor": "147",
    "Gcolor": "102",
    "Bcolor": "116",
    "Y": 17,
    "L": 48.1992008289939,
    "a": 20.5252339053644,
    "b": -0.96735005918795,
    "C": 20.5480167657837,
    "h": -0.04709494591076,
    "CMY_C": 0.4234532,
    "CMY_M": 0.6002464,
    "CMY_Y": 0.5460493,
    "CMYK_C": 0,
    "CMYK_M": 0.3066414,
    "CMYK_Y": 0.2126385,
    "CMYK_K": 0.4234532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08504",
    "Farbtonhilfsbezeichnung": "Z7.12.37",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "98",
    "Bcolor": "107",
    "Y": 14,
    "L": 44.7876400186603,
    "a": 14.3188046379089,
    "b": -1.09779958086107,
    "C": 14.3608262359218,
    "h": -0.07651868942456,
    "CMY_C": 0.4957392,
    "CMY_M": 0.6167119,
    "CMY_Y": 0.5791438,
    "CMYK_C": 0,
    "CMYK_M": 0.239901,
    "CMYK_Y": 0.1653998,
    "CMYK_K": 0.4957392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08506",
    "Farbtonhilfsbezeichnung": "Z8.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "111",
    "Bcolor": "117",
    "Y": 18,
    "L": 49.5294047120316,
    "a": 11.7158375201329,
    "b": -0.04101850815574,
    "C": 11.7159093251939,
    "h": -0.0035011018621,
    "CMY_C": 0.4609071,
    "CMY_M": 0.564532,
    "CMY_Y": 0.5402376,
    "CMYK_C": 0,
    "CMYK_M": 0.1922209,
    "CMYK_Y": 0.1471556,
    "CMYK_K": 0.4609071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08507",
    "Farbtonhilfsbezeichnung": "Z7.10.45",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "120",
    "Bcolor": "130",
    "Y": 22,
    "L": 53.705441499536,
    "a": 13.7758622794082,
    "b": -1.12550465895878,
    "C": 13.8217633563362,
    "h": -0.08152015005841,
    "CMY_C": 0.4076405,
    "CMY_M": 0.5281465,
    "CMY_Y": 0.4915711,
    "CMYK_C": 0,
    "CMYK_M": 0.2034339,
    "CMYK_Y": 0.1416886,
    "CMYK_K": 0.4076405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08508",
    "Farbtonhilfsbezeichnung": "Z3.19.43",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "106",
    "Bcolor": "127",
    "Y": 19,
    "L": 50.7069078840417,
    "a": 23.6566399942907,
    "b": -4.06588415201621,
    "C": 24.0035003646779,
    "h": -0.1702077846539,
    "CMY_C": 0.385749,
    "CMY_M": 0.5836323,
    "CMY_Y": 0.5007803,
    "CMYK_C": 0,
    "CMYK_M": 0.3221539,
    "CMYK_Y": 0.187271,
    "CMYK_K": 0.385749
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08509",
    "Farbtonhilfsbezeichnung": "Z9.23.43",
    "Farbtonklasse": "04",
    "Rcolor": "165",
    "Gcolor": "100",
    "Bcolor": "120",
    "Y": 18,
    "L": 50.0627555498578,
    "a": 29.3417586971363,
    "b": -0.58175399760411,
    "C": 29.3475252986466,
    "h": -0.01982423043607,
    "CMY_C": 0.3520893,
    "CMY_M": 0.6083722,
    "CMY_Y": 0.5290422,
    "CMYK_C": 0,
    "CMYK_M": 0.3955528,
    "CMYK_Y": 0.2731131,
    "CMYK_K": 0.3520893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08510",
    "Farbtonhilfsbezeichnung": "Z9.26.33",
    "Farbtonklasse": "04",
    "Rcolor": "142",
    "Gcolor": "77",
    "Bcolor": "98",
    "Y": 12,
    "L": 41.0559807925175,
    "a": 30.3017008620189,
    "b": -0.69683549650025,
    "C": 30.3097122196905,
    "h": -0.02299252770813,
    "CMY_C": 0.4434833,
    "CMY_M": 0.6990744,
    "CMY_Y": 0.6151707,
    "CMYK_C": 0,
    "CMYK_M": 0.4592695,
    "CMYK_Y": 0.3085037,
    "CMYK_K": 0.4434833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08511",
    "Farbtonhilfsbezeichnung": "Z6.41.40",
    "Farbtonklasse": "04",
    "Rcolor": "189",
    "Gcolor": "75",
    "Bcolor": "121",
    "Y": 17,
    "L": 48.5545829747588,
    "a": 50.5082542456975,
    "b": -3.05812864035941,
    "C": 50.6007499720015,
    "h": -0.06047328104921,
    "CMY_C": 0.2591128,
    "CMY_M": 0.7057362,
    "CMY_Y": 0.5246958,
    "CMYK_C": 0,
    "CMYK_M": 0.6028225,
    "CMYK_Y": 0.3584662,
    "CMYK_K": 0.2591128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08512",
    "Farbtonhilfsbezeichnung": "Z2.33.42",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "92",
    "Bcolor": "133",
    "Y": 19,
    "L": 50.8193493432631,
    "a": 41.0992914000527,
    "b": -7.25176286657185,
    "C": 41.7341564939252,
    "h": -0.17464734560219,
    "CMY_C": 0.2919134,
    "CMY_M": 0.6396983,
    "CMY_Y": 0.4765216,
    "CMYK_C": 0,
    "CMYK_M": 0.4911614,
    "CMYK_Y": 0.2607141,
    "CMYK_K": 0.2919134
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08513",
    "Farbtonhilfsbezeichnung": "Z6.30.39",
    "Farbtonklasse": "04",
    "Rcolor": "170",
    "Gcolor": "87",
    "Bcolor": "117",
    "Y": 17,
    "L": 47.808386754451,
    "a": 38.0497147971879,
    "b": -2.05343674095952,
    "C": 38.1050836319311,
    "h": -0.05391490347299,
    "CMY_C": 0.3315646,
    "CMY_M": 0.6602798,
    "CMY_Y": 0.5403711,
    "CMYK_C": 0,
    "CMYK_M": 0.4917681,
    "CMYK_Y": 0.3123809,
    "CMYK_K": 0.3315646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08514",
    "Farbtonhilfsbezeichnung": "Z8.27.47",
    "Farbtonklasse": "03",
    "Rcolor": "190",
    "Gcolor": "105",
    "Bcolor": "132",
    "Y": 23,
    "L": 54.7974996413212,
    "a": 37.4819389650231,
    "b": -0.64439994136409,
    "C": 37.487477907458,
    "h": -0.01719058514654,
    "CMY_C": 0.2543724,
    "CMY_M": 0.5885283,
    "CMY_Y": 0.48046,
    "CMYK_C": 0,
    "CMYK_M": 0.4481539,
    "CMYK_Y": 0.3032177,
    "CMYK_K": 0.2543724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08515",
    "Farbtonhilfsbezeichnung": "Z8.10.50",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "131",
    "Bcolor": "140",
    "Y": 26,
    "L": 58.0350364371421,
    "a": 13.6663052074138,
    "b": -0.67962817843905,
    "C": 13.6831937968851,
    "h": -0.04968927129076,
    "CMY_C": 0.3618731,
    "CMY_M": 0.4846116,
    "CMY_Y": 0.4510886,
    "CMYK_C": 0,
    "CMYK_M": 0.1923418,
    "CMYK_Y": 0.1398084,
    "CMYK_K": 0.3618731
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08516",
    "Farbtonhilfsbezeichnung": "Z6.04.59",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "160",
    "Bcolor": "164",
    "Y": 37,
    "L": 67.2176609797659,
    "a": 6.99878427302397,
    "b": -1.01997415839377,
    "C": 7.07271719950111,
    "h": -0.14471709725817,
    "CMY_C": 0.3108141,
    "CMY_M": 0.3738592,
    "CMY_Y": 0.3554093,
    "CMYK_C": 0,
    "CMYK_M": 0.09147765,
    "CMYK_Y": 0.0647071,
    "CMYK_K": 0.3108141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08517",
    "Farbtonhilfsbezeichnung": "Z9.37.43",
    "Farbtonklasse": "04",
    "Rcolor": "194",
    "Gcolor": "88",
    "Bcolor": "123",
    "Y": 20,
    "L": 51.627323610594,
    "a": 46.4529529641146,
    "b": 0.53007547614607,
    "C": 46.4559772160338,
    "h": 0.01141052262222,
    "CMY_C": 0.2391859,
    "CMY_M": 0.6564398,
    "CMY_Y": 0.518207,
    "CMYK_C": 0,
    "CMYK_M": 0.5484307,
    "CMYK_Y": 0.3667402,
    "CMYK_K": 0.2391859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08519",
    "Farbtonhilfsbezeichnung": "Z8.19.53",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "127",
    "Bcolor": "146",
    "Y": 29,
    "L": 60.5907999191922,
    "a": 28.7096674858974,
    "b": -0.06936463150768,
    "C": 28.7097512807565,
    "h": -0.0024160675693,
    "CMY_C": 0.2394997,
    "CMY_M": 0.500966,
    "CMY_Y": 0.4271346,
    "CMYK_C": 0,
    "CMYK_M": 0.3438082,
    "CMYK_Y": 0.2467256,
    "CMYK_K": 0.2394997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08521",
    "Farbtonhilfsbezeichnung": "Z9.10.60",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "155",
    "Bcolor": "165",
    "Y": 37,
    "L": 67.8756637573242,
    "a": 16.1952419281006,
    "b": -0.15350161492825,
    "C": 16.1959686279297,
    "h": 359.456970214844,
    "CMY_C": 0.23846817016602,
    "CMY_M": 0.39033442735672,
    "CMY_Y": 0.35331040620804,
    "CMYK_C": 0,
    "CMYK_M": 0.19942207634449,
    "CMYK_Y": 0.15080425143242,
    "CMYK_K": 0.23846817016602
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08522",
    "Farbtonhilfsbezeichnung": "Z7.09.54",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "143",
    "Bcolor": "153",
    "Y": 31,
    "L": 62.435863724236,
    "a": 12.8811472170791,
    "b": -1.38781581059253,
    "C": 12.9556932023028,
    "h": -0.10732607840539,
    "CMY_C": 0.3223463,
    "CMY_M": 0.4376479,
    "CMY_Y": 0.4015478,
    "CMYK_C": 0,
    "CMYK_M": 0.1701483,
    "CMYK_Y": 0.1168761,
    "CMYK_K": 0.3223463
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08523",
    "Farbtonhilfsbezeichnung": "Z7.04.68",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "183",
    "Bcolor": "186",
    "Y": 49,
    "L": 75.7332373853957,
    "a": 5.84736249711965,
    "b": -0.38309258091948,
    "C": 5.85989830101827,
    "h": -0.06542195316235,
    "CMY_C": 0.2257325,
    "CMY_M": 0.2813209,
    "CMY_Y": 0.2703319,
    "CMYK_C": 0,
    "CMYK_M": 0.07179473,
    "CMYK_Y": 0.05760206,
    "CMYK_K": 0.2257325
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08524",
    "Farbtonhilfsbezeichnung": "Z1.05.69",
    "Farbtonklasse": "02",
    "Rcolor": "208",
    "Gcolor": "187",
    "Bcolor": "195",
    "Y": 53,
    "L": 77.9000527823471,
    "a": 9.08032099464745,
    "b": -1.92433455519645,
    "C": 9.28198754826564,
    "h": -0.20883385726844,
    "CMY_C": 0.1833396,
    "CMY_M": 0.2655689,
    "CMY_Y": 0.2357162,
    "CMYK_C": 0,
    "CMYK_M": 0.1006897,
    "CMYK_Y": 0.06413508,
    "CMYK_K": 0.1833396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08525",
    "Farbtonhilfsbezeichnung": "Z6.06.63",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "168",
    "Bcolor": "174",
    "Y": 42,
    "L": 70.8977180085913,
    "a": 9.3987250568886,
    "b": -0.81878461199589,
    "C": 9.43432249479669,
    "h": -0.08689717546268,
    "CMY_C": 0.2539085,
    "CMY_M": 0.3411809,
    "CMY_Y": 0.3179714,
    "CMYK_C": 0,
    "CMYK_M": 0.1169728,
    "CMYK_Y": 0.08586463,
    "CMYK_K": 0.2539085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08526",
    "Farbtonhilfsbezeichnung": "Z8.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "166",
    "Bcolor": "175",
    "Y": 42,
    "L": 70.9670919713,
    "a": 13.569412516091,
    "b": -1.00182649203007,
    "C": 13.6063445624451,
    "h": -0.07369605410188,
    "CMY_C": 0.2247767,
    "CMY_M": 0.3509183,
    "CMY_Y": 0.3153875,
    "CMYK_C": 0,
    "CMYK_M": 0.1627164,
    "CMYK_Y": 0.1168834,
    "CMYK_K": 0.2247767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08527",
    "Farbtonhilfsbezeichnung": "Z6.10.65",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "168",
    "Bcolor": "182",
    "Y": 45,
    "L": 72.6346185963139,
    "a": 16.2620093956867,
    "b": -2.31812216844898,
    "C": 16.426400700496,
    "h": -0.14159439809726,
    "CMY_C": 0.1918444,
    "CMY_M": 0.3399857,
    "CMY_Y": 0.2881561,
    "CMYK_C": 0,
    "CMYK_M": 0.1833078,
    "CMYK_Y": 0.1191746,
    "CMYK_K": 0.1918444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08528",
    "Farbtonhilfsbezeichnung": "Z3.16.62",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "158",
    "Bcolor": "180",
    "Y": 42,
    "L": 70.8331213799801,
    "a": 24.4348909698916,
    "b": -3.75097180750046,
    "C": 24.7211182233157,
    "h": -0.15231979858642,
    "CMY_C": 0.1613179,
    "CMY_M": 0.3811046,
    "CMY_Y": 0.2960624,
    "CMYK_C": 0,
    "CMYK_M": 0.262062,
    "CMYK_Y": 0.1606622,
    "CMYK_K": 0.1613179
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08529",
    "Farbtonhilfsbezeichnung": "Z3.24.53",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "124",
    "Bcolor": "156",
    "Y": 29,
    "L": 60.6159203077283,
    "a": 33.9072043300998,
    "b": -5.47333650658433,
    "C": 34.3461194023058,
    "h": -0.16004053282426,
    "CMY_C": 0.220388,
    "CMY_M": 0.5154214,
    "CMY_Y": 0.3896642,
    "CMYK_C": 0,
    "CMYK_M": 0.3784361,
    "CMYK_Y": 0.2171287,
    "CMYK_K": 0.220388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08530",
    "Farbtonhilfsbezeichnung": "Z4.32.48",
    "Farbtonklasse": "04",
    "Rcolor": "196",
    "Gcolor": "100",
    "Bcolor": "140",
    "Y": 23,
    "L": 54.9124401445681,
    "a": 43.2442125751694,
    "b": -5.01402049728981,
    "C": 43.5339215186695,
    "h": -0.11543119538021,
    "CMY_C": 0.2295912,
    "CMY_M": 0.6072795,
    "CMY_Y": 0.4496365,
    "CMYK_C": 0,
    "CMYK_M": 0.490244,
    "CMYK_Y": 0.2856215,
    "CMYK_K": 0.2295912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08532",
    "Farbtonhilfsbezeichnung": "Z9.30.50",
    "Farbtonklasse": "04",
    "Rcolor": "206",
    "Gcolor": "109",
    "Bcolor": "139",
    "Y": 26,
    "L": 57.9763172717718,
    "a": 41.7468433406892,
    "b": 0.34296163165261,
    "C": 41.7482520782946,
    "h": 0.00821508619454,
    "CMY_C": 0.1926977,
    "CMY_M": 0.5720755,
    "CMY_Y": 0.4543986,
    "CMYK_C": 0,
    "CMYK_M": 0.4699329,
    "CMYK_Y": 0.3241672,
    "CMYK_K": 0.1926977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08534",
    "Farbtonhilfsbezeichnung": "Z9.10.71",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "184",
    "Bcolor": "196",
    "Y": 55,
    "L": 78.9442445012685,
    "a": 17.8132737356848,
    "b": -0.62951644876236,
    "C": 17.8243937384052,
    "h": -0.03532503835047,
    "CMY_C": 0.1064405,
    "CMY_M": 0.2774386,
    "CMY_Y": 0.2325288,
    "CMYK_C": 0,
    "CMYK_M": 0.1913673,
    "CMYK_Y": 0.1411079,
    "CMYK_K": 0.1064405
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08535",
    "Farbtonhilfsbezeichnung": "Z4.06.72",
    "Farbtonklasse": "02",
    "Rcolor": "217",
    "Gcolor": "192",
    "Bcolor": "200",
    "Y": 57,
    "L": 80.0105852204145,
    "a": 10.3208079800606,
    "b": -1.33950433136163,
    "C": 10.4073699470624,
    "h": -0.12906531201836,
    "CMY_C": 0.14933,
    "CMY_M": 0.2461237,
    "CMY_Y": 0.2170059,
    "CMYK_C": 0,
    "CMYK_M": 0.1137852,
    "CMYK_Y": 0.07955598,
    "CMYK_K": 0.14933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08536",
    "Farbtonhilfsbezeichnung": "Z9.05.71",
    "Farbtonklasse": "02",
    "Rcolor": "212",
    "Gcolor": "188",
    "Bcolor": "193",
    "Y": 54,
    "L": 78.3061784159597,
    "a": 9.56105118732808,
    "b": -0.32773394767629,
    "C": 9.56666657447448,
    "h": -0.03426460867871,
    "CMY_C": 0.1705491,
    "CMY_M": 0.2628742,
    "CMY_Y": 0.2427094,
    "CMYK_C": 0,
    "CMYK_M": 0.1113087,
    "CMYK_Y": 0.08699773,
    "CMYK_K": 0.1705491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08537",
    "Farbtonhilfsbezeichnung": "Z9.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "209",
    "Bcolor": "210",
    "Y": 66,
    "L": 85.063173247374,
    "a": 6.17823908767995,
    "b": 0.46104835631628,
    "C": 6.19541796906377,
    "h": 0.07448649454662,
    "CMY_C": 0.1181766,
    "CMY_M": 0.1813458,
    "CMY_Y": 0.1758093,
    "CMYK_C": 0,
    "CMYK_M": 0.07163469,
    "CMYK_Y": 0.06535627,
    "CMYK_K": 0.1181766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08538",
    "Farbtonhilfsbezeichnung": "Z9.05.75",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "202",
    "Bcolor": "207",
    "Y": 63,
    "L": 83.6786052759925,
    "a": 9.97846080564729,
    "b": 0.20860940499616,
    "C": 9.98064115844729,
    "h": 0.02090292535546,
    "CMY_C": 0.1063712,
    "CMY_M": 0.2059111,
    "CMY_Y": 0.1885055,
    "CMYK_C": 0,
    "CMYK_M": 0.1113884,
    "CMYK_Y": 0.09191107,
    "CMYK_K": 0.1063712
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08539",
    "Farbtonhilfsbezeichnung": "Z5.08.72",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "190",
    "Bcolor": "201",
    "Y": 57,
    "L": 80.2470172220585,
    "a": 14.1463608873836,
    "b": -1.6062006791268,
    "C": 14.2372541937595,
    "h": -0.11305744110065,
    "CMY_C": 0.1201786,
    "CMY_M": 0.2533424,
    "CMY_Y": 0.2120024,
    "CMYK_C": 0,
    "CMYK_M": 0.1513532,
    "CMYK_Y": 0.1043664,
    "CMYK_K": 0.1201786
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08540",
    "Farbtonhilfsbezeichnung": "Z9.12.69",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "175",
    "Bcolor": "186",
    "Y": 50,
    "L": 76.241632272322,
    "a": 19.8841612320793,
    "b": 0.82193303678908,
    "C": 19.9011417215267,
    "h": 0.04131254866494,
    "CMY_C": 0.1188496,
    "CMY_M": 0.3124676,
    "CMY_Y": 0.2714935,
    "CMYK_C": 0,
    "CMYK_M": 0.2197333,
    "CMYK_Y": 0.1732325,
    "CMYK_K": 0.1188496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08541",
    "Farbtonhilfsbezeichnung": "Z9.15.63",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "160",
    "Bcolor": "175",
    "Y": 43,
    "L": 71.5008074290366,
    "a": 23.6688509757963,
    "b": -0.24244623881961,
    "C": 23.6700926633837,
    "h": -0.01024290364122,
    "CMY_C": 0.1498487,
    "CMY_M": 0.3729945,
    "CMY_Y": 0.3136446,
    "CMYK_C": 0,
    "CMYK_M": 0.2624777,
    "CMYK_Y": 0.1926668,
    "CMYK_K": 0.1498487
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08542",
    "Farbtonhilfsbezeichnung": "Z3.19.63",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "154",
    "Bcolor": "182",
    "Y": 42,
    "L": 71.0428092155595,
    "a": 30.0770915016435,
    "b": -4.44642501256671,
    "C": 30.4039821173249,
    "h": -0.14677120905427,
    "CMY_C": 0.1245142,
    "CMY_M": 0.3954768,
    "CMY_Y": 0.2881865,
    "CMYK_C": 0,
    "CMYK_M": 0.3094997,
    "CMYK_Y": 0.1869502,
    "CMYK_K": 0.1245142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08543",
    "Farbtonhilfsbezeichnung": "Z8.26.58",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "125",
    "Bcolor": "155",
    "Y": 32,
    "L": 63.4077013698572,
    "a": 39.7604016543253,
    "b": -0.72802363556105,
    "C": 39.7670662499411,
    "h": -0.01830822278264,
    "CMY_C": 0.1440665,
    "CMY_M": 0.5083318,
    "CMY_Y": 0.3921497,
    "CMYK_C": 0,
    "CMYK_M": 0.4255767,
    "CMYK_Y": 0.2898394,
    "CMYK_K": 0.1440665
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08544",
    "Farbtonhilfsbezeichnung": "Z2.30.53",
    "Farbtonklasse": "04",
    "Rcolor": "210",
    "Gcolor": "117",
    "Bcolor": "161",
    "Y": 29,
    "L": 60.9424678424013,
    "a": 42.000467449642,
    "b": -8.1465213727089,
    "C": 42.7832335905602,
    "h": -0.19158371962741,
    "CMY_C": 0.175085,
    "CMY_M": 0.5392224,
    "CMY_Y": 0.3671089,
    "CMYK_C": 0,
    "CMYK_M": 0.4414242,
    "CMYK_Y": 0.2327802,
    "CMYK_K": 0.175085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08545",
    "Farbtonhilfsbezeichnung": "Z3.35.24",
    "Farbtonklasse": "04",
    "Rcolor": "126",
    "Gcolor": "57",
    "Bcolor": "90",
    "Y": 8,
    "L": 34.1524367587927,
    "a": 33.9212156776799,
    "b": -5.72650960846376,
    "C": 34.4011887199774,
    "h": -0.16724107108413,
    "CMY_C": 0.5067464,
    "CMY_M": 0.7762887,
    "CMY_Y": 0.6487477,
    "CMYK_C": 0,
    "CMYK_M": 0.5464578,
    "CMYK_Y": 0.2878869,
    "CMYK_K": 0.5067464
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08546",
    "Farbtonhilfsbezeichnung": "Z4.03.47",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "129",
    "Bcolor": "131",
    "Y": 22,
    "L": 54.5441753195134,
    "a": 3.72830903611676,
    "b": -1.06331864403995,
    "C": 3.87697495575518,
    "h": -0.27782533987111,
    "CMY_C": 0.4653735,
    "CMY_M": 0.4959098,
    "CMY_Y": 0.4849037,
    "CMYK_C": 0,
    "CMYK_M": 0.057117,
    "CMYK_Y": 0.03653044,
    "CMYK_K": 0.4653735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08547",
    "Farbtonhilfsbezeichnung": "Z2.11.68",
    "Farbtonklasse": "02",
    "Rcolor": "221",
    "Gcolor": "179",
    "Bcolor": "196",
    "Y": 51,
    "L": 76.8899531287759,
    "a": 18.2302917512449,
    "b": -3.73656960548627,
    "C": 18.609285041402,
    "h": -0.20216489537753,
    "CMY_C": 0.1352936,
    "CMY_M": 0.2996171,
    "CMY_Y": 0.2323969,
    "CMYK_C": 0,
    "CMYK_M": 0.1900339,
    "CMYK_Y": 0.1122963,
    "CMYK_K": 0.1352936
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08548",
    "Farbtonhilfsbezeichnung": "Z9.33.44",
    "Farbtonklasse": "04",
    "Rcolor": "192",
    "Gcolor": "93",
    "Bcolor": "125",
    "Y": 20,
    "L": 52.344127792109,
    "a": 43.4943362628912,
    "b": 0.38471838443412,
    "C": 43.4960376952289,
    "h": 0.00884502178209,
    "CMY_C": 0.2470912,
    "CMY_M": 0.6366417,
    "CMY_Y": 0.5106639,
    "CMYK_C": 0,
    "CMYK_M": 0.5173941,
    "CMYK_Y": 0.3500725,
    "CMYK_K": 0.2470912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08549",
    "Farbtonhilfsbezeichnung": "Z6.13.58",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "149",
    "Bcolor": "164",
    "Y": 36,
    "L": 66.4335465923159,
    "a": 20.1816838395994,
    "b": -1.46338775739554,
    "C": 20.2346699090952,
    "h": -0.07238400405108,
    "CMY_C": 0.231565,
    "CMY_M": 0.4157171,
    "CMY_Y": 0.3587031,
    "CMYK_C": 0,
    "CMYK_M": 0.2396457,
    "CMYK_Y": 0.1654508,
    "CMYK_K": 0.231565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08550",
    "Farbtonhilfsbezeichnung": "Y7.12.38",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "103",
    "Bcolor": "117",
    "Y": 16,
    "L": 46.43965559525,
    "a": 13.4387397820128,
    "b": -4.45717059984125,
    "C": 14.1586050402129,
    "h": -0.32024903905354,
    "CMY_C": 0.4929637,
    "CMY_M": 0.5976039,
    "CMY_Y": 0.5416467,
    "CMYK_C": 0,
    "CMYK_M": 0.2063761,
    "CMYK_Y": 0.09601469,
    "CMYK_K": 0.4929637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08551",
    "Farbtonhilfsbezeichnung": "Y6.34.23",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "55",
    "Bcolor": "95",
    "Y": 7,
    "L": 32.8974377990478,
    "a": 33.7362770916585,
    "b": -11.4962993377303,
    "C": 35.6412863189288,
    "h": -0.32842824271988,
    "CMY_C": 0.5323368,
    "CMY_M": 0.7850394,
    "CMY_Y": 0.6257121,
    "CMYK_C": 0,
    "CMYK_M": 0.5403517,
    "CMYK_Y": 0.1996636,
    "CMYK_K": 0.5323368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08553",
    "Farbtonhilfsbezeichnung": "Y1.05.73",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "195",
    "Bcolor": "207",
    "Y": 58,
    "L": 80.5291500151909,
    "a": 8.16882184386242,
    "b": -4.42140247181626,
    "C": 9.28861938796863,
    "h": -0.49610316732906,
    "CMY_C": 0.1691415,
    "CMY_M": 0.2341996,
    "CMY_Y": 0.1895096,
    "CMYK_C": 0,
    "CMYK_M": 0.07830232,
    "CMYK_Y": 0.02451452,
    "CMYK_K": 0.1691415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08554",
    "Farbtonhilfsbezeichnung": "Y0.33.34",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "76",
    "Bcolor": "130",
    "Y": 12,
    "L": 41.4821425932832,
    "a": 34.8927343689605,
    "b": -19.539694445613,
    "C": 39.9912811844126,
    "h": -0.51048315553312,
    "CMY_C": 0.4566854,
    "CMY_M": 0.7034214,
    "CMY_Y": 0.4920099,
    "CMYK_C": 0,
    "CMYK_M": 0.4541309,
    "CMYK_Y": 0.0650168,
    "CMYK_K": 0.4566854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08555",
    "Farbtonhilfsbezeichnung": "Y4.29.40",
    "Farbtonklasse": "04",
    "Rcolor": "159",
    "Gcolor": "92",
    "Bcolor": "138",
    "Y": 17,
    "L": 48.1090384819043,
    "a": 34.2299903187679,
    "b": -14.0922354572238,
    "C": 37.0173383349584,
    "h": -0.39054543305824,
    "CMY_C": 0.3759863,
    "CMY_M": 0.6388336,
    "CMY_Y": 0.4603048,
    "CMYK_C": 0,
    "CMYK_M": 0.4212204,
    "CMYK_Y": 0.1351228,
    "CMYK_K": 0.3759863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08556",
    "Farbtonhilfsbezeichnung": "Y2.25.50",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "119",
    "Bcolor": "165",
    "Y": 25,
    "L": 57.5308807679466,
    "a": 30.8682271287218,
    "b": -15.4781012021583,
    "C": 34.531421385379,
    "h": -0.46478696979881,
    "CMY_C": 0.2984917,
    "CMY_M": 0.5332531,
    "CMY_Y": 0.3547379,
    "CMYK_C": 0,
    "CMYK_M": 0.3346523,
    "CMYK_Y": 0.08017893,
    "CMYK_K": 0.2984917
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08557",
    "Farbtonhilfsbezeichnung": "Y2.15.49",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "127",
    "Bcolor": "153",
    "Y": 25,
    "L": 57.3899568868179,
    "a": 18.1272995302213,
    "b": -9.45309781050327,
    "C": 20.4440711814771,
    "h": -0.48068676789335,
    "CMY_C": 0.3640192,
    "CMY_M": 0.5000047,
    "CMY_Y": 0.3981785,
    "CMYK_C": 0,
    "CMYK_M": 0.2138201,
    "CMYK_Y": 0.05371117,
    "CMYK_K": 0.3640192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08558",
    "Farbtonhilfsbezeichnung": "Y0.11.50",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "133",
    "Bcolor": "153",
    "Y": 26,
    "L": 58.2178857880971,
    "a": 12.9636570100894,
    "b": -7.87347821805719,
    "C": 15.167335373277,
    "h": -0.5458064558161,
    "CMY_C": 0.3850169,
    "CMY_M": 0.4788247,
    "CMY_Y": 0.4009078,
    "CMYK_C": 0,
    "CMYK_M": 0.1525373,
    "CMYK_Y": 0.02583958,
    "CMYK_K": 0.3850169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08559",
    "Farbtonhilfsbezeichnung": "Y0.05.54",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "145",
    "Bcolor": "155",
    "Y": 30,
    "L": 61.4592764994551,
    "a": 6.36576633681329,
    "b": -4.30424396964766,
    "C": 7.68436706600834,
    "h": -0.59454263261157,
    "CMY_C": 0.3859194,
    "CMY_M": 0.4309523,
    "CMY_Y": 0.3925425,
    "CMYK_C": 0,
    "CMYK_M": 0.07333387,
    "CMYK_Y": 0.01078547,
    "CMYK_K": 0.3859194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08560",
    "Farbtonhilfsbezeichnung": "Y2.04.59",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "160",
    "Bcolor": "166",
    "Y": 37,
    "L": 67.0761402522583,
    "a": 6.38085225502322,
    "b": -2.27426847102954,
    "C": 6.77403665318944,
    "h": -0.34238341832676,
    "CMY_C": 0.3205328,
    "CMY_M": 0.3735047,
    "CMY_Y": 0.3482638,
    "CMYK_C": 0,
    "CMYK_M": 0.07796102,
    "CMYK_Y": 0.04081285,
    "CMYK_K": 0.3205328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08561",
    "Farbtonhilfsbezeichnung": "Y3.16.43",
    "Farbtonklasse": "03",
    "Rcolor": "146",
    "Gcolor": "112",
    "Bcolor": "138",
    "Y": 20,
    "L": 51.3054620695545,
    "a": 18.1670362297272,
    "b": -9.51912910328294,
    "C": 20.5098762613817,
    "h": -0.48264556617992,
    "CMY_C": 0.4274524,
    "CMY_M": 0.5606962,
    "CMY_Y": 0.4597621,
    "CMYK_C": 0,
    "CMYK_M": 0.232721,
    "CMYK_Y": 0.05643162,
    "CMYK_K": 0.4274524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08563",
    "Farbtonhilfsbezeichnung": "Y5.04.33",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "96",
    "Bcolor": "102",
    "Y": 12,
    "L": 41.7749139648849,
    "a": 4.32212201118776,
    "b": -2.45760909991231,
    "C": 4.97197960248888,
    "h": -0.51702004216524,
    "CMY_C": 0.591825,
    "CMY_M": 0.6217144,
    "CMY_Y": 0.6006302,
    "CMYK_C": 0,
    "CMYK_M": 0.0732268,
    "CMYK_Y": 0.02157214,
    "CMYK_K": 0.591825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08564",
    "Farbtonhilfsbezeichnung": "X8.23.58",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "143",
    "Bcolor": "191",
    "Y": 35,
    "L": 66.0022239610925,
    "a": 29.0708624354894,
    "b": -17.397807162589,
    "C": 33.8791785143882,
    "h": -0.53928786796101,
    "CMY_C": 0.2233138,
    "CMY_M": 0.440285,
    "CMY_Y": 0.2521871,
    "CMYK_C": 0,
    "CMYK_M": 0.279355,
    "CMYK_Y": 0.03717498,
    "CMYK_K": 0.2233138
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08565",
    "Farbtonhilfsbezeichnung": "X2.34.32",
    "Farbtonklasse": "04",
    "Rcolor": "122",
    "Gcolor": "78",
    "Bcolor": "139",
    "Y": 11,
    "L": 40.3692670297111,
    "a": 29.7593980481143,
    "b": -27.0539677739533,
    "C": 40.2186392671385,
    "h": -0.73781449987369,
    "CMY_C": 0.5223118,
    "CMY_M": 0.6928605,
    "CMY_Y": 0.455989,
    "CMYK_C": 0.1219144,
    "CMYK_M": 0.4354168,
    "CMYK_Y": 0,
    "CMYK_K": 0.455989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08566",
    "Farbtonhilfsbezeichnung": "X8.11.37",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "103",
    "Bcolor": "120",
    "Y": 15,
    "L": 45.843945390725,
    "a": 11.4825678265632,
    "b": -7.12839732337793,
    "C": 13.5153028930752,
    "h": -0.55557459597528,
    "CMY_C": 0.5188702,
    "CMY_M": 0.5977509,
    "CMY_Y": 0.5305238,
    "CMYK_C": 0,
    "CMYK_M": 0.163949,
    "CMYK_Y": 0.02422143,
    "CMYK_K": 0.5188702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08567",
    "Farbtonhilfsbezeichnung": "W9.05.64",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "173",
    "Bcolor": "186",
    "Y": 44,
    "L": 71.9123131459713,
    "a": 5.71904141963686,
    "b": -6.0484119363662,
    "C": 8.32410485947283,
    "h": -0.8133808146488,
    "CMY_C": 0.2862385,
    "CMY_M": 0.3200037,
    "CMY_Y": 0.2709743,
    "CMYK_C": 0.02093782,
    "CMYK_M": 0.06725334,
    "CMYK_Y": 0,
    "CMYK_K": 0.2709743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08568",
    "Farbtonhilfsbezeichnung": "W6.24.43",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "115",
    "Bcolor": "165",
    "Y": 20,
    "L": 52.0211715678224,
    "a": 19.2336842081334,
    "b": -24.2656470164626,
    "C": 30.9637890663556,
    "h": -0.90056535914766,
    "CMY_C": 0.4629118,
    "CMY_M": 0.5509616,
    "CMY_Y": 0.3548647,
    "CMYK_C": 0.1674798,
    "CMYK_M": 0.3039625,
    "CMYK_Y": 0,
    "CMYK_K": 0.3548647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08569",
    "Farbtonhilfsbezeichnung": "XN.02.38",
    "Farbtonklasse": "02",
    "Rcolor": "114",
    "Gcolor": "110",
    "Bcolor": "115",
    "Y": 16,
    "L": 46.9013214199852,
    "a": 2.63223311802385,
    "b": -2.85473345270586,
    "C": 3.88305991115505,
    "h": -0.82592665854502,
    "CMY_C": 0.5545657,
    "CMY_M": 0.5685703,
    "CMY_Y": 0.5487726,
    "CMYK_C": 0.01283852,
    "CMYK_M": 0.04387521,
    "CMYK_Y": 0,
    "CMYK_K": 0.5487726
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08570",
    "Farbtonhilfsbezeichnung": "W4.05.75",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "203",
    "Bcolor": "216",
    "Y": 61,
    "L": 82.4588451118758,
    "a": 4.89353147732535,
    "b": -6.77574218639443,
    "C": 8.3580699025588,
    "h": -0.94531711603909,
    "CMY_C": 0.180966,
    "CMY_M": 0.2045032,
    "CMY_Y": 0.1518716,
    "CMYK_C": 0.03430428,
    "CMYK_M": 0.06205621,
    "CMYK_Y": 0,
    "CMYK_K": 0.1518716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08571",
    "Farbtonhilfsbezeichnung": "V6.18.64",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "173",
    "Bcolor": "218",
    "Y": 44,
    "L": 72.2566908298701,
    "a": 9.94906317409716,
    "b": -23.2075696310462,
    "C": 25.2502504189966,
    "h": -1.16579672300392,
    "CMY_C": 0.3168365,
    "CMY_M": 0.3207728,
    "CMY_Y": 0.145695,
    "CMYK_C": 0.2003283,
    "CMYK_M": 0.204936,
    "CMYK_Y": 0,
    "CMYK_K": 0.145695
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08572",
    "Farbtonhilfsbezeichnung": "V9.37.23",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "70",
    "Bcolor": "127",
    "Y": 7,
    "L": 32.7764593522465,
    "a": 17.2036296379326,
    "b": -32.0640908612653,
    "C": 36.3877836021738,
    "h": -1.07834669790174,
    "CMY_C": 0.7064236,
    "CMY_M": 0.724458,
    "CMY_Y": 0.5021828,
    "CMYK_C": 0.4102725,
    "CMYK_M": 0.4464996,
    "CMYK_Y": 0,
    "CMYK_K": 0.5021828
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08573",
    "Farbtonhilfsbezeichnung": "V4.13.33",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "97",
    "Bcolor": "120",
    "Y": 12,
    "L": 41.7015091499731,
    "a": 5.29282467471609,
    "b": -13.8039563087372,
    "C": 14.7838832114843,
    "h": -1.2046571923511,
    "CMY_C": 0.6244485,
    "CMY_M": 0.6211551,
    "CMY_Y": 0.5292519,
    "CMYK_C": 0.202224,
    "CMYK_M": 0.195228,
    "CMYK_Y": 0,
    "CMYK_K": 0.5292519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08574",
    "Farbtonhilfsbezeichnung": "V6.24.23",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "75",
    "Bcolor": "110",
    "Y": 8,
    "L": 33.3526322727936,
    "a": 8.66319892476625,
    "b": -20.4780697058922,
    "C": 22.2351603207499,
    "h": -1.17058051299781,
    "CMY_C": 0.7073618,
    "CMY_M": 0.7040325,
    "CMY_Y": 0.5689499,
    "CMYK_C": 0.321104,
    "CMYK_M": 0.3133802,
    "CMYK_Y": 0,
    "CMYK_K": 0.5689499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08575",
    "Farbtonhilfsbezeichnung": "V3.41.33",
    "Farbtonklasse": "04",
    "Rcolor": "80",
    "Gcolor": "97",
    "Bcolor": "166",
    "Y": 13,
    "L": 42.740352624839,
    "a": 13.8064943803953,
    "b": -39.957887738747,
    "C": 42.2759042436492,
    "h": -1.23811268260974,
    "CMY_C": 0.6870342,
    "CMY_M": 0.6198653,
    "CMY_Y": 0.3492982,
    "CMYK_C": 0.5190336,
    "CMYK_M": 0.4158082,
    "CMYK_Y": 0,
    "CMYK_K": 0.3492982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08576",
    "Farbtonhilfsbezeichnung": "U5.25.55",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "152",
    "Bcolor": "201",
    "Y": 31,
    "L": 62.7522281903959,
    "a": 3.43639658060629,
    "b": -28.9574481864714,
    "C": 29.1606348856018,
    "h": -1.45267817439584,
    "CMY_C": 0.5034251,
    "CMY_M": 0.4025644,
    "CMY_Y": 0.2099904,
    "CMYK_C": 0.3714318,
    "CMYK_M": 0.2437617,
    "CMYK_Y": 0,
    "CMYK_K": 0.2099904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08577",
    "Farbtonhilfsbezeichnung": "U2.10.64",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "177",
    "Bcolor": "197",
    "Y": 43,
    "L": 71.7640641701907,
    "a": 0.37808201136646,
    "b": -12.7587514786621,
    "C": 12.7643521301154,
    "h": -1.54117184491006,
    "CMY_C": 0.3551139,
    "CMY_M": 0.3071251,
    "CMY_Y": 0.2259191,
    "CMYK_C": 0.1669009,
    "CMYK_M": 0.1049063,
    "CMYK_Y": 0,
    "CMYK_K": 0.2259191
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08578",
    "Farbtonhilfsbezeichnung": "U6.23.55",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "154",
    "Bcolor": "199",
    "Y": 32,
    "L": 63.6296382402456,
    "a": 3.35990370378236,
    "b": -26.4342793387477,
    "C": 26.6469524910004,
    "h": -1.44437020119523,
    "CMY_C": 0.4804671,
    "CMY_M": 0.3943059,
    "CMY_Y": 0.2179542,
    "CMYK_C": 0.3356746,
    "CMYK_M": 0.2255005,
    "CMYK_Y": 0,
    "CMYK_K": 0.2179542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08579",
    "Farbtonhilfsbezeichnung": "U3.18.51",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "144",
    "Bcolor": "176",
    "Y": 27,
    "L": 59.3341751924931,
    "a": 1.69197578174585,
    "b": -19.5926725982139,
    "C": 19.6655943613921,
    "h": -1.48465246612958,
    "CMY_C": 0.5039966,
    "CMY_M": 0.4372365,
    "CMY_Y": 0.3111024,
    "CMYK_C": 0.2800041,
    "CMYK_M": 0.1830955,
    "CMYK_Y": 0,
    "CMYK_K": 0.3111024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08580",
    "Farbtonhilfsbezeichnung": "U6.16.53",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "148",
    "Bcolor": "180",
    "Y": 30,
    "L": 61.2520458613808,
    "a": 3.34487801706923,
    "b": -18.9739165010094,
    "C": 19.2664920609941,
    "h": -1.39630099118431,
    "CMY_C": 0.4674328,
    "CMY_M": 0.4214773,
    "CMY_Y": 0.2948548,
    "CMYK_C": 0.2447411,
    "CMYK_M": 0.1795694,
    "CMYK_Y": 0,
    "CMYK_K": 0.2948548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08581",
    "Farbtonhilfsbezeichnung": "T9.32.52",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "149",
    "Bcolor": "204",
    "Y": 29,
    "L": 60.4606567305431,
    "a": -0.342720956921,
    "b": -34.042707253334,
    "C": 34.0444323611147,
    "h": 1.56072928434237,
    "CMY_C": 0.601666,
    "CMY_M": 0.4158729,
    "CMY_Y": 0.2000916,
    "CMYK_C": 0.5020255,
    "CMYK_M": 0.2697575,
    "CMYK_Y": 0,
    "CMYK_K": 0.2000916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08582",
    "Farbtonhilfsbezeichnung": "T9.21.62",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "174",
    "Bcolor": "213",
    "Y": 41,
    "L": 70.1753244422768,
    "a": -0.56578505033072,
    "b": -23.7963374421285,
    "C": 23.8030625841052,
    "h": 1.54702466553909,
    "CMY_C": 0.4332125,
    "CMY_M": 0.3180988,
    "CMY_Y": 0.16545,
    "CMYK_C": 0.3208466,
    "CMYK_M": 0.1829115,
    "CMYK_Y": 0,
    "CMYK_K": 0.16545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08583",
    "Farbtonhilfsbezeichnung": "T9.25.60",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "165",
    "Bcolor": "212",
    "Y": 36,
    "L": 66.6733041651993,
    "a": -1.18579442779876,
    "b": -28.8850474416522,
    "C": 28.9093769239584,
    "h": 1.5297671759791,
    "CMY_C": 0.5068049,
    "CMY_M": 0.3517095,
    "CMY_Y": 0.1681167,
    "CMYK_C": 0.4071343,
    "CMYK_M": 0.2206953,
    "CMYK_Y": 0,
    "CMYK_K": 0.1681167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08584",
    "Farbtonhilfsbezeichnung": "U0.43.32",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "101",
    "Bcolor": "158",
    "Y": 12,
    "L": 41.277288039728,
    "a": 0.41977676249366,
    "b": -37.930010805805,
    "C": 37.9323335989076,
    "h": -1.55972963800348,
    "CMY_C": 0.8669955,
    "CMY_M": 0.6057387,
    "CMY_Y": 0.3787881,
    "CMYK_C": 0.785895,
    "CMYK_M": 0.3653352,
    "CMYK_Y": 0,
    "CMYK_K": 0.3787881
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08585",
    "Farbtonhilfsbezeichnung": "T7.17.28",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "84",
    "Bcolor": "105",
    "Y": 8,
    "L": 34.9049191092698,
    "a": -0.87873982563904,
    "b": -14.910824356038,
    "C": 14.9366953057824,
    "h": 1.51193139738296,
    "CMY_C": 0.7417593,
    "CMY_M": 0.6720619,
    "CMY_Y": 0.5890909,
    "CMYK_C": 0.3715381,
    "CMYK_M": 0.2019206,
    "CMYK_Y": 0,
    "CMYK_K": 0.5890909
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08586",
    "Farbtonhilfsbezeichnung": "T5.25.21",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "74",
    "Bcolor": "96",
    "Y": 6,
    "L": 30.4238147012435,
    "a": -1.90570631266099,
    "b": -16.6142517525605,
    "C": 16.7231898227454,
    "h": 1.45659232677215,
    "CMY_C": 0.8021362,
    "CMY_M": 0.7107154,
    "CMY_Y": 0.6215951,
    "CMYK_C": 0.4771111,
    "CMYK_M": 0.2355158,
    "CMYK_Y": 0,
    "CMYK_K": 0.6215951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08587",
    "Farbtonhilfsbezeichnung": "S9.07.60",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "170",
    "Bcolor": "179",
    "Y": 40,
    "L": 69.4675422045433,
    "a": -0.44457390207075,
    "b": -6.15094304747434,
    "C": 6.1669884325881,
    "h": 1.49864443685172,
    "CMY_C": 0.359662,
    "CMY_M": 0.3316128,
    "CMY_Y": 0.2969714,
    "CMYK_C": 0.0891722,
    "CMYK_M": 0.04927455,
    "CMYK_Y": 0,
    "CMYK_K": 0.2969714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08588",
    "Farbtonhilfsbezeichnung": "S5.15.75",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "208",
    "Bcolor": "230",
    "Y": 60,
    "L": 81.9457349121683,
    "a": -5.81983586911439,
    "b": -14.8977410702392,
    "C": 15.9941607638326,
    "h": 1.19837424952892,
    "CMY_C": 0.3101427,
    "CMY_M": 0.1828667,
    "CMY_Y": 0.09992147,
    "CMYK_C": 0.2335588,
    "CMYK_M": 0.09215327,
    "CMYK_Y": 0,
    "CMYK_K": 0.09992147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08589",
    "Farbtonhilfsbezeichnung": "S5.40.54",
    "Farbtonklasse": "03",
    "Rcolor": "57",
    "Gcolor": "159",
    "Bcolor": "207",
    "Y": 30,
    "L": 61.6703282377483,
    "a": -13.0620632314363,
    "b": -33.8168446212326,
    "C": 36.251847897709,
    "h": 1.20219140467461,
    "CMY_C": 0.7749127,
    "CMY_M": 0.3781576,
    "CMY_Y": 0.1894547,
    "CMYK_C": 0.7223014,
    "CMYK_M": 0.2328098,
    "CMYK_Y": 0,
    "CMYK_K": 0.1894547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08590",
    "Farbtonhilfsbezeichnung": "S5.24.64",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "184",
    "Bcolor": "216",
    "Y": 44,
    "L": 72.2539291381836,
    "a": -9.97278881072998,
    "b": -22.5379257202148,
    "C": 24.6457824707031,
    "h": 246.131134033203,
    "CMY_C": 0.49803555011749,
    "CMY_M": 0.27649641036987,
    "CMY_Y": 0.15246123075485,
    "CMYK_C": 0.40773865580559,
    "CMYK_M": 0.14634749293327,
    "CMYK_Y": 0,
    "CMYK_K": 0.15246123075485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08591",
    "Farbtonhilfsbezeichnung": "S5.23.65",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "186",
    "Bcolor": "216",
    "Y": 45,
    "L": 73.0225109028952,
    "a": -8.8540701797753,
    "b": -21.2197952521245,
    "C": 22.9929178072395,
    "h": 1.17550382895434,
    "CMY_C": 0.4695204,
    "CMY_M": 0.2710109,
    "CMY_Y": 0.1532806,
    "CMYK_C": 0.3734883,
    "CMYK_M": 0.1390429,
    "CMYK_Y": 0,
    "CMYK_K": 0.1532806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08592",
    "Farbtonhilfsbezeichnung": "S2.32.38",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "115",
    "Bcolor": "142",
    "Y": 15,
    "L": 45.4541760431135,
    "a": -10.9157828907362,
    "b": -21.626024071667,
    "C": 24.2247648753504,
    "h": 1.10335420139214,
    "CMY_C": 0.7933714,
    "CMY_M": 0.5506942,
    "CMY_Y": 0.4426585,
    "CMYK_C": 0.6292604,
    "CMYK_M": 0.193841,
    "CMYK_Y": 0,
    "CMYK_K": 0.4426585
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08593",
    "Farbtonhilfsbezeichnung": "S7.13.34",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "101",
    "Bcolor": "113",
    "Y": 13,
    "L": 42.0016817451765,
    "a": -3.15490396115237,
    "b": -9.30016587223248,
    "C": 9.82071811300643,
    "h": 1.24374735527651,
    "CMY_C": 0.6677619,
    "CMY_M": 0.6023697,
    "CMY_Y": 0.555784,
    "CMYK_C": 0.2520797,
    "CMYK_M": 0.1048716,
    "CMYK_Y": 0,
    "CMYK_K": 0.555784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08594",
    "Farbtonhilfsbezeichnung": "R7.14.77",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "217",
    "Bcolor": "233",
    "Y": 65,
    "L": 84.5906481898719,
    "a": -9.17248769306905,
    "b": -12.7679944296461,
    "C": 15.7212026332268,
    "h": 0.94782985509994,
    "CMY_C": 0.3022002,
    "CMY_M": 0.1471688,
    "CMY_Y": 0.08643384,
    "CMYK_C": 0.2361803,
    "CMYK_M": 0.06648117,
    "CMYK_Y": 0,
    "CMYK_K": 0.08643384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08595",
    "Farbtonhilfsbezeichnung": "S0.45.24",
    "Farbtonklasse": "04",
    "Rcolor": "3",
    "Gcolor": "87",
    "Bcolor": "114",
    "Y": 8,
    "L": 34.178875602936,
    "a": -11.6851648802885,
    "b": -21.9303081114704,
    "C": 24.8491748785257,
    "h": 1.08122957260937,
    "CMY_C": 0.9896027,
    "CMY_M": 0.6576393,
    "CMY_Y": 0.5533735,
    "CMYK_C": 0.9767205,
    "CMYK_M": 0.2334518,
    "CMYK_Y": 0,
    "CMYK_K": 0.5533735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08596",
    "Farbtonhilfsbezeichnung": "H4.08.77",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "210",
    "Bcolor": "187",
    "Y": 63,
    "L": 83.3937594387508,
    "a": -3.95384693921952,
    "b": 10.4761094548668,
    "C": 11.1974003647777,
    "h": -1.20990957033509,
    "CMY_C": 0.1823322,
    "CMY_M": 0.1783792,
    "CMY_Y": 0.2683026,
    "CMYK_C": 0.004811226,
    "CMYK_M": 0,
    "CMYK_Y": 0.1094463,
    "CMYK_K": 0.1783792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08597",
    "Farbtonhilfsbezeichnung": "H2.27.83",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "232",
    "Bcolor": "153",
    "Y": 77,
    "L": 90.2218498290306,
    "a": -12.2975246336699,
    "b": 37.4505655217845,
    "C": 39.417939697772,
    "h": -1.25352223753981,
    "CMY_C": 0.1002344,
    "CMY_M": 0.08995937,
    "CMY_Y": 0.3994793,
    "CMYK_C": 0.01129076,
    "CMYK_M": 0,
    "CMYK_Y": 0.3401166,
    "CMYK_K": 0.08995937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08598",
    "Farbtonhilfsbezeichnung": "Q1.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "219",
    "Bcolor": "219",
    "Y": 68,
    "L": 85.9594967368453,
    "a": -5.5145118875588,
    "b": -3.08275065808954,
    "C": 6.3176888953144,
    "h": 0.50974586816058,
    "CMY_C": 0.2129034,
    "CMY_M": 0.1430003,
    "CMY_Y": 0.1416868,
    "CMYK_C": 0.08297269,
    "CMYK_M": 0.001530273,
    "CMYK_Y": 0,
    "CMYK_K": 0.1416868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08601",
    "Farbtonhilfsbezeichnung": "BN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "235",
    "Bcolor": "231",
    "Y": 83.0266571044922,
    "L": 93.0261077880859,
    "a": 0.67058455944061,
    "b": 1.1669043302536,
    "C": 1.34586381912231,
    "h": 60.1153221130371,
    "CMY_C": 0.06926250457764,
    "CMY_M": 0.07992166280746,
    "CMY_Y": 0.09420788288116,
    "CMYK_C": 0,
    "CMYK_M": 0.01145237870514,
    "CMYK_Y": 0.02680173330009,
    "CMYK_K": 0.06926250457764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08602",
    "Farbtonhilfsbezeichnung": "WN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "233",
    "Y": 82.6398391723633,
    "L": 92.8565292358398,
    "a": 0.89319622516632,
    "b": -0.28967741131783,
    "C": 0.93899548053741,
    "h": 342.031311035156,
    "CMY_C": 0.07438069581985,
    "CMY_M": 0.08193397521973,
    "CMY_Y": 0.08522987365723,
    "CMYK_C": 0,
    "CMYK_M": 0.00816024374217,
    "CMYK_Y": 0.01172099355608,
    "CMYK_K": 0.07438069581985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08603",
    "Farbtonhilfsbezeichnung": "AN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "230",
    "Y": 81.5968780517578,
    "L": 92.3966445922852,
    "a": 2.47080850601196,
    "b": 0.56559300422668,
    "C": 2.53471708297729,
    "h": 12.8934412002563,
    "CMY_C": 0.06421566009521,
    "CMY_M": 0.09113013744354,
    "CMY_Y": 0.09646850824356,
    "CMYK_C": 0,
    "CMYK_M": 0.02876141108572,
    "CMYK_Y": 0.03446611389518,
    "CMYK_K": 0.06421566009521
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08604",
    "Farbtonhilfsbezeichnung": "ZN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "233",
    "Bcolor": "233",
    "Y": 82.4477005004883,
    "L": 92.7720947265625,
    "a": 2.56166076660156,
    "b": -0.08391824364662,
    "C": 2.5630350112915,
    "h": 358.123687744141,
    "CMY_C": 0.06147015094757,
    "CMY_M": 0.08696573972702,
    "CMY_Y": 0.08746492862701,
    "CMYK_C": 0,
    "CMYK_M": 0.02716545388103,
    "CMYK_Y": 0.02769733779132,
    "CMYK_K": 0.06147015094757
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08605",
    "Farbtonhilfsbezeichnung": "ZN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 73.35400390625,
    "L": 88.6162796020508,
    "a": 1.59804427623749,
    "b": 0.12844760715961,
    "C": 1.60319817066193,
    "h": 4.59544086456299,
    "CMY_C": 0.11472326517105,
    "CMY_M": 0.13095903396606,
    "CMY_Y": 0.13510864973068,
    "CMYK_C": 0,
    "CMYK_M": 0.01833976618946,
    "CMYK_Y": 0.02302713319659,
    "CMYK_K": 0.11472326517105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08606",
    "Farbtonhilfsbezeichnung": "CN.00.88",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 82.700569152832,
    "L": 92.883186340332,
    "a": 0.79454147815704,
    "b": 1.2588506937027,
    "C": 1.48862397670746,
    "h": 57.7413482666016,
    "CMY_C": 0.06957709789276,
    "CMY_M": 0.08184510469437,
    "CMY_Y": 0.0964595079422,
    "CMYK_C": 0,
    "CMYK_M": 0.0131854088977,
    "CMYK_Y": 0.02889267913997,
    "CMYK_K": 0.06957709789276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08607",
    "Farbtonhilfsbezeichnung": "CN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "234",
    "Bcolor": "230",
    "Y": 82.9328994750977,
    "L": 92.9850540161133,
    "a": 1.00994372367859,
    "b": 1.48391604423523,
    "C": 1.79499113559723,
    "h": 55.7610511779785,
    "CMY_C": 0.06598097085953,
    "CMY_M": 0.0812863111496,
    "CMY_Y": 0.09697312116623,
    "CMYK_C": 0,
    "CMYK_M": 0.01638654060662,
    "CMYK_Y": 0.03318149596453,
    "CMYK_K": 0.06598097085953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08608",
    "Farbtonhilfsbezeichnung": "CN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 82.4842300415039,
    "L": 92.7881622314453,
    "a": 1.2925306558609,
    "b": 1.84773850440979,
    "C": 2.25494408607483,
    "h": 55.0264282226563,
    "CMY_C": 0.06475895643234,
    "CMY_M": 0.08427304029465,
    "CMY_Y": 0.10182017087936,
    "CMYK_C": 0,
    "CMYK_M": 0.02086529880762,
    "CMYK_Y": 0.03962744772434,
    "CMYK_K": 0.06475895643234
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08609",
    "Farbtonhilfsbezeichnung": "CN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 81.9281921386719,
    "L": 92.5431594848633,
    "a": 1.48053598403931,
    "b": 1.73902881145477,
    "C": 2.28390192985535,
    "h": 49.5903244018555,
    "CMY_C": 0.06639933586121,
    "CMY_M": 0.08743500709534,
    "CMY_Y": 0.10369890928268,
    "CMYK_C": 0,
    "CMYK_M": 0.0225317645818,
    "CMYK_Y": 0.03995238617063,
    "CMYK_K": 0.06639933586121
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08610",
    "Farbtonhilfsbezeichnung": "BN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 82.4132080078125,
    "L": 92.7569274902344,
    "a": 2.08316206932068,
    "b": 1.29686963558197,
    "C": 2.45386123657227,
    "h": 31.9042720794678,
    "CMY_C": 0.0607578754425,
    "CMY_M": 0.08637404441833,
    "CMY_Y": 0.09795999526978,
    "CMYK_C": 0,
    "CMYK_M": 0.0272732321173,
    "CMYK_Y": 0.03960865736008,
    "CMYK_K": 0.0607578754425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08611",
    "Farbtonhilfsbezeichnung": "AN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "233",
    "Bcolor": "231",
    "Y": 82.7116470336914,
    "L": 92.8880462646484,
    "a": 2.78769278526306,
    "b": 0.95740985870361,
    "C": 2.94751834869385,
    "h": 18.9546070098877,
    "CMY_C": 0.05491650104523,
    "CMY_M": 0.08652096986771,
    "CMY_Y": 0.09388339519501,
    "CMYK_C": 0,
    "CMYK_M": 0.0334409289062,
    "CMYK_Y": 0.04123116657138,
    "CMYK_K": 0.05491650104523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08612",
    "Farbtonhilfsbezeichnung": "ZN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "223",
    "Bcolor": "222",
    "Y": 74.3374252319336,
    "L": 89.0817184448242,
    "a": 2.12421083450317,
    "b": -0.00993577111512,
    "C": 2.12423396110535,
    "h": 359.731994628906,
    "CMY_C": 0.10591202974319,
    "CMY_M": 0.12702149152756,
    "CMY_Y": 0.12889468669891,
    "CMYK_C": 0,
    "CMYK_M": 0.02361004985869,
    "CMYK_Y": 0.02570514008403,
    "CMYK_K": 0.10591202974319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08613",
    "Farbtonhilfsbezeichnung": "DN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "227",
    "Y": 82.5994873046875,
    "L": 92.8388061523438,
    "a": 1.50147104263306,
    "b": 2.91695284843445,
    "C": 3.28070569038391,
    "h": 62.7633247375488,
    "CMY_C": 0.05903774499893,
    "CMY_M": 0.08451265096664,
    "CMY_Y": 0.10917842388153,
    "CMYK_C": 0,
    "CMYK_M": 0.02707324922085,
    "CMYK_Y": 0.05328660085797,
    "CMYK_K": 0.05903774499893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08614",
    "Farbtonhilfsbezeichnung": "D1.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 81.5826568603516,
    "L": 92.3903503417969,
    "a": 2.09575724601746,
    "b": 2.27101349830627,
    "C": 3.09025907516479,
    "h": 47.2982788085938,
    "CMY_C": 0.06156837940216,
    "CMY_M": 0.09078001976013,
    "CMY_Y": 0.10925340652466,
    "CMYK_C": 0,
    "CMYK_M": 0.03112814947963,
    "CMYK_Y": 0.05081353336573,
    "CMYK_K": 0.06156837940216
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08615",
    "Farbtonhilfsbezeichnung": "DN.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "228",
    "Y": 83.2210540771484,
    "L": 93.1111297607422,
    "a": 2.02966475486755,
    "b": 3.12196898460388,
    "C": 3.72373867034912,
    "h": 56.9711685180664,
    "CMY_C": 0.05120396614075,
    "CMY_M": 0.08280086517334,
    "CMY_Y": 0.10761457681656,
    "CMYK_C": 0,
    "CMYK_M": 0.03330209851265,
    "CMYK_Y": 0.05945494025946,
    "CMYK_K": 0.05120396614075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08616",
    "Farbtonhilfsbezeichnung": "D0.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 81.221809387207,
    "L": 92.2303085327148,
    "a": 2.1370255947113,
    "b": 3.80034422874451,
    "C": 4.35998773574829,
    "h": 60.64990234375,
    "CMY_C": 0.05810862779617,
    "CMY_M": 0.09309816360474,
    "CMY_Y": 0.12237077951431,
    "CMYK_C": 0,
    "CMYK_M": 0.03714816644788,
    "CMYK_Y": 0.06822670996189,
    "CMYK_K": 0.05810862779617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08617",
    "Farbtonhilfsbezeichnung": "D0.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "220",
    "Bcolor": "212",
    "Y": 72.7666778564453,
    "L": 88.3363189697266,
    "a": 2.80496788024902,
    "b": 4.0715856552124,
    "C": 4.94425487518311,
    "h": 55.4365425109863,
    "CMY_C": 0.09579050540924,
    "CMY_M": 0.1380677819252,
    "CMY_Y": 0.16701751947403,
    "CMYK_C": 0,
    "CMYK_M": 0.04675606265664,
    "CMYK_Y": 0.07877268642187,
    "CMYK_K": 0.09579050540924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08618",
    "Farbtonhilfsbezeichnung": "DN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "233",
    "Bcolor": "230",
    "Y": 81.9262237548828,
    "L": 92.5422821044922,
    "a": 0.42204338312149,
    "b": 0.85276412963867,
    "C": 0.95148688554764,
    "h": 63.6686325073242,
    "CMY_C": 0.07771587371826,
    "CMY_M": 0.08465176820755,
    "CMY_Y": 0.09727364778519,
    "CMYK_C": 0,
    "CMYK_M": 0.007520344574,
    "CMYK_Y": 0.02120580151677,
    "CMYK_K": 0.07771587371826
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08619",
    "Farbtonhilfsbezeichnung": "DN.00.88",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 81.3468780517578,
    "L": 92.2858276367188,
    "a": 1.04805588722229,
    "b": 2.16412138938904,
    "C": 2.40454626083374,
    "h": 64.1596984863281,
    "CMY_C": 0.07125943899155,
    "CMY_M": 0.08939182758331,
    "CMY_Y": 0.10976499319077,
    "CMYK_C": 0,
    "CMYK_M": 0.01952363178134,
    "CMYK_Y": 0.04145996645093,
    "CMYK_K": 0.07125943899155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08620",
    "Farbtonhilfsbezeichnung": "DN.01.89",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 82.6786880493164,
    "L": 92.8735809326172,
    "a": 1.10398459434509,
    "b": 2.02262282371521,
    "C": 2.30429697036743,
    "h": 61.373477935791,
    "CMY_C": 0.06469541788101,
    "CMY_M": 0.08291327953339,
    "CMY_Y": 0.10220086574554,
    "CMYK_C": 0,
    "CMYK_M": 0.01947799883783,
    "CMYK_Y": 0.04009971395135,
    "CMYK_K": 0.06469541788101
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08621",
    "Farbtonhilfsbezeichnung": "DN.00.84",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 81.7407150268555,
    "L": 92.4602966308594,
    "a": 1.61600005626678,
    "b": 2.56905126571655,
    "C": 3.03504204750061,
    "h": 57.8290405273438,
    "CMY_C": 0.0635370016098,
    "CMY_M": 0.08892321586609,
    "CMY_Y": 0.11076217889786,
    "CMYK_C": 0,
    "CMYK_M": 0.02710861340165,
    "CMYK_Y": 0.05042930319905,
    "CMYK_K": 0.0635370016098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08622",
    "Farbtonhilfsbezeichnung": "D0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "232",
    "Bcolor": "226",
    "Y": 82.2005996704102,
    "L": 92.6633224487305,
    "a": 2.34815406799316,
    "b": 3.0720841884613,
    "C": 3.86672067642212,
    "h": 52.6074333190918,
    "CMY_C": 0.05394178628922,
    "CMY_M": 0.08856797218323,
    "CMY_Y": 0.11214971542358,
    "CMYK_C": 0,
    "CMYK_M": 0.03660048171878,
    "CMYK_Y": 0.06152679398656,
    "CMYK_K": 0.05394178628922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08623",
    "Farbtonhilfsbezeichnung": "D8.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "221",
    "Bcolor": "212",
    "Y": 73.8910980224609,
    "L": 88.8709869384766,
    "a": 3.33593702316284,
    "b": 5.14925622940063,
    "C": 6.13541507720947,
    "h": 57.0628852844238,
    "CMY_C": 0.08247572183609,
    "CMY_M": 0.13373345136642,
    "CMY_Y": 0.16903519630432,
    "CMYK_C": 0,
    "CMYK_M": 0.05586525797844,
    "CMYK_Y": 0.09434025734663,
    "CMYK_K": 0.08247572183609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08624",
    "Farbtonhilfsbezeichnung": "EN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "226",
    "Y": 82.3922958374023,
    "L": 92.7477264404297,
    "a": 1.6863032579422,
    "b": 3.4258713722229,
    "C": 3.81840443611145,
    "h": 63.7923812866211,
    "CMY_C": 0.05697429180145,
    "CMY_M": 0.08612060546875,
    "CMY_Y": 0.11394214630127,
    "CMYK_C": 0,
    "CMYK_M": 0.0309072304517,
    "CMYK_Y": 0.06040965020657,
    "CMYK_K": 0.05697429180145
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08625",
    "Farbtonhilfsbezeichnung": "E1.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "220",
    "Bcolor": "211",
    "Y": 73.5609436035156,
    "L": 88.7145614624023,
    "a": 3.33063316345215,
    "b": 5.32702207565308,
    "C": 6.28253793716431,
    "h": 57.984992980957,
    "CMY_C": 0.08372634649277,
    "CMY_M": 0.13550090789795,
    "CMY_Y": 0.17205250263214,
    "CMYK_C": 0,
    "CMYK_M": 0.05650556460023,
    "CMYK_Y": 0.09639713913202,
    "CMYK_K": 0.08372634649277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08626",
    "Farbtonhilfsbezeichnung": "E2.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "209",
    "Bcolor": "196",
    "Y": 65.6850204467773,
    "L": 84.8354949951172,
    "a": 4.40719938278198,
    "b": 7.57429504394531,
    "C": 8.76318168640137,
    "h": 59.8064765930176,
    "CMY_C": 0.11246258020401,
    "CMY_M": 0.18143647909164,
    "CMY_Y": 0.23040616512299,
    "CMYK_C": 0,
    "CMYK_M": 0.07771379500628,
    "CMYK_Y": 0.13288857042789,
    "CMYK_K": 0.11246258020401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08627",
    "Farbtonhilfsbezeichnung": "E5.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "221",
    "Y": 81.1077270507813,
    "L": 92.1796035766602,
    "a": 2.20606184005737,
    "b": 5.13355779647827,
    "C": 5.58749723434448,
    "h": 66.7451858520508,
    "CMY_C": 0.05394119024277,
    "CMY_M": 0.09420096874237,
    "CMY_Y": 0.13281905651093,
    "CMYK_C": 0,
    "CMYK_M": 0.04255526140332,
    "CMYK_Y": 0.08337522298098,
    "CMYK_K": 0.05394119024277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08628",
    "Farbtonhilfsbezeichnung": "EN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "226",
    "Y": 83.1772384643555,
    "L": 93.0919799804688,
    "a": 1.98857736587524,
    "b": 4.10984563827515,
    "C": 4.5656623840332,
    "h": 64.1796646118164,
    "CMY_C": 0.04856407642365,
    "CMY_M": 0.08319246768951,
    "CMY_Y": 0.11518186330795,
    "CMYK_C": 0,
    "CMYK_M": 0.03639592602849,
    "CMYK_Y": 0.07001815736294,
    "CMYK_K": 0.04856407642365
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08629",
    "Farbtonhilfsbezeichnung": "E7.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "231",
    "Bcolor": "218",
    "Y": 81.2458190917969,
    "L": 92.240966796875,
    "a": 2.37259101867676,
    "b": 7.12740993499756,
    "C": 7.51193475723267,
    "h": 71.5882949829102,
    "CMY_C": 0.04585289955139,
    "CMY_M": 0.09446358680725,
    "CMY_Y": 0.14693129062653,
    "CMYK_C": 0,
    "CMYK_M": 0.05094674229622,
    "CMYK_Y": 0.10593585669994,
    "CMYK_K": 0.04585289955139
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08630",
    "Farbtonhilfsbezeichnung": "E4.05.87",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "231",
    "Bcolor": "217",
    "Y": 82.0593032836914,
    "L": 92.6010284423828,
    "a": 3.13891196250916,
    "b": 7.77832174301147,
    "C": 8.38779258728027,
    "h": 68.0236511230469,
    "CMY_C": 0.03403681516647,
    "CMY_M": 0.09248715639114,
    "CMY_Y": 0.14770340919495,
    "CMYK_C": 0,
    "CMYK_M": 0.06050990521908,
    "CMYK_Y": 0.11767176538706,
    "CMYK_K": 0.03403681516647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08632",
    "Farbtonhilfsbezeichnung": "FN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "227",
    "Y": 81.8730773925781,
    "L": 92.5188140869141,
    "a": 0.43430039286613,
    "b": 2.69623970985413,
    "C": 2.7309935092926,
    "h": 80.8496017456055,
    "CMY_C": 0.07169187068939,
    "CMY_M": 0.08546668291092,
    "CMY_Y": 0.11122912168503,
    "CMYK_C": 0,
    "CMYK_M": 0.01483862102032,
    "CMYK_Y": 0.04259065538645,
    "CMYK_K": 0.07169187068939
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08633",
    "Farbtonhilfsbezeichnung": "E0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "234",
    "Bcolor": "227",
    "Y": 83.179801940918,
    "L": 93.0931015014648,
    "a": 1.26910090446472,
    "b": 3.45233702659607,
    "C": 3.67821264266968,
    "h": 69.8162536621094,
    "CMY_C": 0.05624336004257,
    "CMY_M": 0.08125692605972,
    "CMY_Y": 0.11038196086884,
    "CMYK_C": 0,
    "CMYK_M": 0.0265042539686,
    "CMYK_Y": 0.05736500024796,
    "CMYK_K": 0.05624336004257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08634",
    "Farbtonhilfsbezeichnung": "E7.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "232",
    "Bcolor": "221",
    "Y": 81.9628295898438,
    "L": 92.5584487915039,
    "a": 2.12013292312622,
    "b": 5.83133125305176,
    "C": 6.2047872543335,
    "h": 70.0199432373047,
    "CMY_C": 0.04815900325775,
    "CMY_M": 0.08995270729065,
    "CMY_Y": 0.13384759426117,
    "CMYK_C": 0,
    "CMYK_M": 0.04390828311443,
    "CMYK_Y": 0.09002406150103,
    "CMYK_K": 0.04815900325775
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08635",
    "Farbtonhilfsbezeichnung": "E6.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 74.2172546386719,
    "L": 89.0250625610352,
    "a": 2.50944137573242,
    "b": 6.24141073226929,
    "C": 6.7269983291626,
    "h": 68.0967559814453,
    "CMY_C": 0.08366042375565,
    "CMY_M": 0.13032191991806,
    "CMY_Y": 0.17552608251572,
    "CMYK_C": 0,
    "CMYK_M": 0.05092161893845,
    "CMYK_Y": 0.10025285184383,
    "CMYK_K": 0.08366042375565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08636",
    "Farbtonhilfsbezeichnung": "F6.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "228",
    "Bcolor": "212",
    "Y": 78.6537780761719,
    "L": 91.0774078369141,
    "a": 0.88615131378174,
    "b": 8.55596828460693,
    "C": 8.60173606872559,
    "h": 84.0868988037109,
    "CMY_C": 0.0659407377243,
    "CMY_M": 0.10423201322556,
    "CMY_Y": 0.1704980134964,
    "CMYK_C": 0,
    "CMYK_M": 0.04099448025227,
    "CMYK_Y": 0.11193858832121,
    "CMYK_K": 0.0659407377243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08637",
    "Farbtonhilfsbezeichnung": "F0.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "223",
    "Bcolor": "204",
    "Y": 75.8331756591797,
    "L": 89.7818298339844,
    "a": 2.78507471084595,
    "b": 10.4944467544556,
    "C": 10.8577184677124,
    "h": 75.1371383666992,
    "CMY_C": 0.06064659357071,
    "CMY_M": 0.12372237443924,
    "CMY_Y": 0.19866353273392,
    "CMYK_C": 0,
    "CMYK_M": 0.06714808195829,
    "CMYK_Y": 0.14692759513855,
    "CMYK_K": 0.06064659357071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08638",
    "Farbtonhilfsbezeichnung": "F3.10.80",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "216",
    "Bcolor": "191",
    "Y": 70.4028167724609,
    "L": 87.1940536499023,
    "a": 2.20927572250366,
    "b": 13.5482597351074,
    "C": 13.7272081375122,
    "h": 80.7384567260742,
    "CMY_C": 0.08558398485184,
    "CMY_M": 0.15172159671783,
    "CMY_Y": 0.24921214580536,
    "CMYK_C": 0,
    "CMYK_M": 0.07232770323753,
    "CMYK_Y": 0.17894279956818,
    "CMYK_K": 0.08558398485184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08639",
    "Farbtonhilfsbezeichnung": "F0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "223",
    "Y": 81.4128799438477,
    "L": 92.3151092529297,
    "a": 0.20355315506458,
    "b": 4.19261980056763,
    "C": 4.19755840301514,
    "h": 87.2204513549805,
    "CMY_C": 0.07088041305542,
    "CMY_M": 0.08760994672775,
    "CMY_Y": 0.12462997436523,
    "CMYK_C": 0,
    "CMYK_M": 0.01800579205155,
    "CMYK_Y": 0.05784999206662,
    "CMYK_K": 0.07088041305542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08640",
    "Farbtonhilfsbezeichnung": "F6.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "222",
    "Y": 81.8438949584961,
    "L": 92.5059204101562,
    "a": 0.23166656494141,
    "b": 5.31371879577637,
    "C": 5.31876659393311,
    "h": 87.5036087036133,
    "CMY_C": 0.06491869688034,
    "CMY_M": 0.08585160970688,
    "CMY_Y": 0.1308565735817,
    "CMYK_C": 0,
    "CMYK_M": 0.0223861951381,
    "CMYK_Y": 0.07051566243172,
    "CMYK_K": 0.06491869688034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08641",
    "Farbtonhilfsbezeichnung": "F8.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "232",
    "Bcolor": "218",
    "Y": 80.9076919555664,
    "L": 92.0905990600586,
    "a": 0.40423715114594,
    "b": 6.52971458435059,
    "C": 6.54221534729004,
    "h": 86.4574890136719,
    "CMY_C": 0.0644211769104,
    "CMY_M": 0.09123605489731,
    "CMY_Y": 0.14443564414978,
    "CMYK_C": 0,
    "CMYK_M": 0.02866127155721,
    "CMYK_Y": 0.08552402257919,
    "CMYK_K": 0.0644211769104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08642",
    "Farbtonhilfsbezeichnung": "F5.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "228",
    "Bcolor": "216",
    "Y": 78.0397415161133,
    "L": 90.7980346679688,
    "a": 0.62736660242081,
    "b": 5.86887502670288,
    "C": 5.9023118019104,
    "h": 83.8984069824219,
    "CMY_C": 0.07927125692368,
    "CMY_M": 0.10600739717484,
    "CMY_Y": 0.15367561578751,
    "CMYK_C": 0,
    "CMYK_M": 0.02903802134097,
    "CMYK_Y": 0.08081029355526,
    "CMYK_K": 0.07927125692368
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08643",
    "Farbtonhilfsbezeichnung": "F6.04.82",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 73.4401702880859,
    "L": 88.6572265625,
    "a": 0.45389407873154,
    "b": 5.57447242736816,
    "C": 5.59292078018188,
    "h": 85.3450393676758,
    "CMY_C": 0.10544055700302,
    "CMY_M": 0.12929636240005,
    "CMY_Y": 0.17492401599884,
    "CMYK_C": 0,
    "CMYK_M": 0.0266676582396,
    "CMYK_Y": 0.07767338305712,
    "CMYK_K": 0.10544055700302
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08644",
    "Farbtonhilfsbezeichnung": "F8.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "221",
    "Y": 81.5133285522461,
    "L": 92.3596343994141,
    "a": 0.27506402134895,
    "b": 5.62271928787231,
    "C": 5.62944316864014,
    "h": 87.1993179321289,
    "CMY_C": 0.0652442574501,
    "CMY_M": 0.08767521381378,
    "CMY_Y": 0.13475739955902,
    "CMYK_C": 0,
    "CMYK_M": 0.02399659715593,
    "CMYK_Y": 0.07436503469944,
    "CMYK_K": 0.0652442574501
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08645",
    "Farbtonhilfsbezeichnung": "F3.05.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "218",
    "Bcolor": "203",
    "Y": 70.9756698608398,
    "L": 87.4731826782227,
    "a": 1.24089300632477,
    "b": 7.62220621109009,
    "C": 7.72255420684814,
    "h": 80.7533798217773,
    "CMY_C": 0.10640740394592,
    "CMY_M": 0.1448118686676,
    "CMY_Y": 0.2027490735054,
    "CMYK_C": 0,
    "CMYK_M": 0.04297760128975,
    "CMYK_Y": 0.10781386494637,
    "CMYK_K": 0.10640740394592
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08646",
    "Farbtonhilfsbezeichnung": "F6.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "215",
    "Y": 82.6408767700195,
    "L": 92.8569793701172,
    "a": 1.24584174156189,
    "b": 9.36482620239258,
    "C": 9.44733238220215,
    "h": 82.4222030639648,
    "CMY_C": 0.0407400727272,
    "CMY_M": 0.08544689416885,
    "CMY_Y": 0.156997859478,
    "CMYK_C": 0,
    "CMYK_M": 0.04660553485155,
    "CMYK_Y": 0.12119529396296,
    "CMYK_K": 0.0407400727272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08647",
    "Farbtonhilfsbezeichnung": "G0.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "209",
    "Y": 81.9691543579102,
    "L": 92.5612411499023,
    "a": 0.63059085607529,
    "b": 12.2932710647583,
    "C": 12.3094339370728,
    "h": 87.0635528564453,
    "CMY_C": 0.04022061824799,
    "CMY_M": 0.08802711963654,
    "CMY_Y": 0.18214821815491,
    "CMYK_C": 0,
    "CMYK_M": 0.04980988427997,
    "CMYK_Y": 0.14787523448467,
    "CMYK_K": 0.04022061824799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08648",
    "Farbtonhilfsbezeichnung": "F5.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "212",
    "Y": 82.7367782592773,
    "L": 92.8990783691406,
    "a": 0.91387730836868,
    "b": 10.7429332733154,
    "C": 10.7817335128784,
    "h": 85.1376800537109,
    "CMY_C": 0.03872793912888,
    "CMY_M": 0.08453470468521,
    "CMY_Y": 0.16685909032822,
    "CMYK_C": 0,
    "CMYK_M": 0.04765223711729,
    "CMYK_Y": 0.1332933306694,
    "CMYK_K": 0.03872793912888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08651",
    "Farbtonhilfsbezeichnung": "F6.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "220",
    "Bcolor": "198",
    "Y": 72.9047927856445,
    "L": 88.4022827148438,
    "a": 1.34637534618378,
    "b": 11.7050275802612,
    "C": 11.7822065353394,
    "h": 83.4383697509766,
    "CMY_C": 0.08341556787491,
    "CMY_M": 0.13584589958191,
    "CMY_Y": 0.22276169061661,
    "CMYK_C": 0,
    "CMYK_M": 0.05720185860991,
    "CMYK_Y": 0.15202759206295,
    "CMYK_K": 0.08341556787491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08652",
    "Farbtonhilfsbezeichnung": "F6.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "217",
    "Y": 84.8773803710938,
    "L": 93.8302536010742,
    "a": 0.82175177335739,
    "b": 9.73971176147461,
    "C": 9.77431678771973,
    "h": 85.1772994995117,
    "CMY_C": 0.03183698654175,
    "CMY_M": 0.07362413406372,
    "CMY_Y": 0.14919209480286,
    "CMYK_C": 0,
    "CMYK_M": 0.04316127300262,
    "CMYK_Y": 0.12121420353651,
    "CMYK_K": 0.03183698654175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08653",
    "Farbtonhilfsbezeichnung": "F6.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "234",
    "Bcolor": "212",
    "Y": 83.8997573852539,
    "L": 93.4069442749023,
    "a": 1.60810232162476,
    "b": 11.9232063293457,
    "C": 12.0311613082886,
    "h": 82.3187789916992,
    "CMY_C": 0.02434885501862,
    "CMY_M": 0.08083415031433,
    "CMY_Y": 0.170006275177,
    "CMYK_C": 0,
    "CMYK_M": 0.05789497122169,
    "CMYK_Y": 0.1492925286293,
    "CMYK_K": 0.02434885501862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08656",
    "Farbtonhilfsbezeichnung": "F6.08.79",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "215",
    "Bcolor": "194",
    "Y": 68.7064666748047,
    "L": 86.3584899902344,
    "a": 0.87257122993469,
    "b": 10.978494644165,
    "C": 11.0131158828735,
    "h": 85.455680847168,
    "CMY_C": 0.11183607578278,
    "CMY_M": 0.15709334611893,
    "CMY_Y": 0.23949378728867,
    "CMYK_C": 0,
    "CMYK_M": 0.05095598846674,
    "CMYK_Y": 0.14373214542866,
    "CMYK_K": 0.11183607578278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08657",
    "Farbtonhilfsbezeichnung": "G2.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "242",
    "Bcolor": "230",
    "Y": 88.6834106445313,
    "L": 95.4479598999023,
    "a": -0.2559888958931,
    "b": 5.50379371643066,
    "C": 5.50974369049072,
    "h": 92.6629867553711,
    "CMY_C": 0.03496479988098,
    "CMY_M": 0.05172049999237,
    "CMY_Y": 0.09984683990479,
    "CMYK_C": 0,
    "CMYK_M": 0.01736278645694,
    "CMYK_Y": 0.067232824862,
    "CMYK_K": 0.03496479988098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08658",
    "Farbtonhilfsbezeichnung": "G3.08.88",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "240",
    "Bcolor": "213",
    "Y": 86.9973907470703,
    "L": 94.7371673583984,
    "a": -0.65498650074005,
    "b": 13.1306009292603,
    "C": 13.1469268798828,
    "h": 92.8556823730469,
    "CMY_C": 0.02286940813065,
    "CMY_M": 0.06076872348785,
    "CMY_Y": 0.16486275196075,
    "CMYK_C": 0,
    "CMYK_M": 0.03878633677959,
    "CMYK_Y": 0.14531664550304,
    "CMYK_K": 0.02286940813065
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08659",
    "Farbtonhilfsbezeichnung": "G2.08.88",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "240",
    "Bcolor": "212",
    "Y": 87.140251159668,
    "L": 94.7977447509766,
    "a": -1.01260304450989,
    "b": 13.9123191833496,
    "C": 13.9491214752197,
    "h": 94.1629104614258,
    "CMY_C": 0.02265775203705,
    "CMY_M": 0.05942940711975,
    "CMY_Y": 0.17012095451355,
    "CMYK_C": 0,
    "CMYK_M": 0.03762413188815,
    "CMYK_Y": 0.15088184177876,
    "CMYK_K": 0.02265775203705
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08660",
    "Farbtonhilfsbezeichnung": "G5.09.88",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "240",
    "Bcolor": "210",
    "Y": 86.7814254760742,
    "L": 94.6454544067383,
    "a": -1.84123635292053,
    "b": 14.5459451675415,
    "C": 14.6620149612427,
    "h": 97.2141799926758,
    "CMY_C": 0.02887630462646,
    "CMY_M": 0.05932688713074,
    "CMY_Y": 0.17667257785797,
    "CMYK_C": 0,
    "CMYK_M": 0.03135602921247,
    "CMYK_Y": 0.15219098329544,
    "CMYK_K": 0.02887630462646
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08661",
    "Farbtonhilfsbezeichnung": "G5.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "240",
    "Bcolor": "221",
    "Y": 86.9641876220703,
    "L": 94.7230758666992,
    "a": -0.9431214928627,
    "b": 8.72883796691895,
    "C": 8.77964115142822,
    "h": 96.1666946411133,
    "CMY_C": 0.03834420442581,
    "CMY_M": 0.05910289287567,
    "CMY_Y": 0.13209456205368,
    "CMYK_C": 0,
    "CMYK_M": 0.02158640138805,
    "CMYK_Y": 0.09748847782612,
    "CMYK_K": 0.03834420442581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08662",
    "Farbtonhilfsbezeichnung": "G4.06.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "236",
    "Bcolor": "216",
    "Y": 83.6066131591797,
    "L": 93.2793731689453,
    "a": -0.80880379676819,
    "b": 9.30690479278564,
    "C": 9.3419828414917,
    "h": 94.9667282104492,
    "CMY_C": 0.05183374881744,
    "CMY_M": 0.07577961683273,
    "CMY_Y": 0.1522541642189,
    "CMYK_C": 0,
    "CMYK_M": 0.02525492571294,
    "CMYK_Y": 0.10591013729572,
    "CMYK_K": 0.05183374881744
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08663",
    "Farbtonhilfsbezeichnung": "G5.03.88",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "238",
    "Bcolor": "225",
    "Y": 85.5330505371094,
    "L": 94.1123352050781,
    "a": -0.43361416459084,
    "b": 6.0815577507019,
    "C": 6.09699630737305,
    "h": 94.0782775878906,
    "CMY_C": 0.04957330226898,
    "CMY_M": 0.06647121906281,
    "CMY_Y": 0.11896562576294,
    "CMYK_C": 0,
    "CMYK_M": 0.01777929440141,
    "CMYK_Y": 0.0730117559433,
    "CMYK_K": 0.04957330226898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08664",
    "Farbtonhilfsbezeichnung": "GN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "236",
    "Bcolor": "226",
    "Y": 83.5079727172852,
    "L": 93.2363815307617,
    "a": -0.15985515713692,
    "b": 4.16104316711426,
    "C": 4.16411256790161,
    "h": 92.2000579833984,
    "CMY_C": 0.06348127126694,
    "CMY_M": 0.07642304897308,
    "CMY_Y": 0.11428034305573,
    "CMYK_C": 0,
    "CMYK_M": 0.01381902676076,
    "CMYK_Y": 0.05424245074391,
    "CMYK_K": 0.06348127126694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08665",
    "Farbtonhilfsbezeichnung": "H3.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "220",
    "Y": 83.1491394042969,
    "L": 93.0796966552734,
    "a": -2.49301195144653,
    "b": 7.08053016662598,
    "C": 7.50659799575806,
    "h": 109.396858215332,
    "CMY_C": 0.07410264015198,
    "CMY_M": 0.07345288991928,
    "CMY_Y": 0.13809871673584,
    "CMYK_C": 0.00070125976345,
    "CMYK_M": 0,
    "CMYK_Y": 0.06977068632841,
    "CMYK_K": 0.07345288991928
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08666",
    "Farbtonhilfsbezeichnung": "H7.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "237",
    "Bcolor": "223",
    "Y": 83.5516891479492,
    "L": 93.2554397583008,
    "a": -2.2585506439209,
    "b": 5.61359357833862,
    "C": 6.05090761184692,
    "h": 111.916702270508,
    "CMY_C": 0.07502847909927,
    "CMY_M": 0.07163888216019,
    "CMY_Y": 0.12519615888596,
    "CMYK_C": 0.0036511621438,
    "CMYK_M": 0,
    "CMYK_Y": 0.05769013240933,
    "CMYK_K": 0.07163888216019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08667",
    "Farbtonhilfsbezeichnung": "JN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "226",
    "Y": 83.1039886474609,
    "L": 93.059944152832,
    "a": -2.40519309043884,
    "b": 4.03194904327393,
    "C": 4.6948447227478,
    "h": 120.817497253418,
    "CMY_C": 0.08361303806305,
    "CMY_M": 0.07305586338043,
    "CMY_Y": 0.11559170484543,
    "CMYK_C": 0.01138922385871,
    "CMYK_M": 0,
    "CMYK_Y": 0.04588824510574,
    "CMYK_K": 0.07305586338043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08668",
    "Farbtonhilfsbezeichnung": "J2.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "224",
    "Bcolor": "212",
    "Y": 73.4048614501953,
    "L": 88.6404495239258,
    "a": -2.56340384483337,
    "b": 4.58609676361084,
    "C": 5.25388622283936,
    "h": 119.203056335449,
    "CMY_C": 0.1322084069252,
    "CMY_M": 0.12214279174805,
    "CMY_Y": 0.16825872659683,
    "CMYK_C": 0.01146611850709,
    "CMYK_M": 0,
    "CMYK_Y": 0.05253238603473,
    "CMYK_K": 0.12214279174805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08669",
    "Farbtonhilfsbezeichnung": "LN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "232",
    "Y": 83.1833801269531,
    "L": 93.0946655273438,
    "a": -1.0087788105011,
    "b": 0.77984076738358,
    "C": 1.27506327629089,
    "h": 142.294021606445,
    "CMY_C": 0.0831726193428,
    "CMY_M": 0.07504391670227,
    "CMY_Y": 0.09080255031586,
    "CMYK_C": 0.00878820382059,
    "CMYK_M": 0,
    "CMYK_Y": 0.01703717000782,
    "CMYK_K": 0.07504391670227
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08670",
    "Farbtonhilfsbezeichnung": "MN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 78.9553527832031,
    "L": 91.2140884399414,
    "a": -2.85012078285217,
    "b": 0.75173449516296,
    "C": 2.94759106636047,
    "h": 165.22444152832,
    "CMY_C": 0.11904019117355,
    "CMY_M": 0.09176242351532,
    "CMY_Y": 0.11168152093887,
    "CMYK_C": 0.03003373555839,
    "CMYK_M": 0,
    "CMYK_Y": 0.02193159423769,
    "CMYK_K": 0.09176242351532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08671",
    "Farbtonhilfsbezeichnung": "M0.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "238",
    "Bcolor": "232",
    "Y": 83.8929214477539,
    "L": 93.4039764404297,
    "a": -3.62158584594727,
    "b": 0.91761714220047,
    "C": 3.73602795600891,
    "h": 165.781936645508,
    "CMY_C": 0.1003560423851,
    "CMY_M": 0.06548935174942,
    "CMY_Y": 0.08875566720963,
    "CMYK_C": 0.03731010481715,
    "CMYK_M": 0,
    "CMYK_Y": 0.02489678934216,
    "CMYK_K": 0.06548935174942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08672",
    "Farbtonhilfsbezeichnung": "L1.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 82.4952239990234,
    "L": 92.7929916381836,
    "a": -1.84782063961029,
    "b": 1.44753038883209,
    "C": 2.34729313850403,
    "h": 141.925857543945,
    "CMY_C": 0.09095251560211,
    "CMY_M": 0.07663589715958,
    "CMY_Y": 0.09923297166824,
    "CMYK_C": 0.01550484634936,
    "CMYK_M": 0,
    "CMYK_Y": 0.02447254955769,
    "CMYK_K": 0.07663589715958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08674",
    "Farbtonhilfsbezeichnung": "MN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "236",
    "Bcolor": "232",
    "Y": 83.472412109375,
    "L": 93.2208709716797,
    "a": -1.2451423406601,
    "b": 0.71558618545532,
    "C": 1.43612086772919,
    "h": 150.113906860352,
    "CMY_C": 0.08387899398804,
    "CMY_M": 0.07305192947388,
    "CMY_Y": 0.08895581960678,
    "CMYK_C": 0.01168033573776,
    "CMYK_M": 0,
    "CMYK_Y": 0.01715726032853,
    "CMYK_K": 0.07305192947388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08676",
    "Farbtonhilfsbezeichnung": "SN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "236",
    "Bcolor": "234",
    "Y": 83.9200134277344,
    "L": 93.4157485961914,
    "a": -0.21543782949448,
    "b": -0.03479140996933,
    "C": 0.21822901070118,
    "h": 189.173599243164,
    "CMY_C": 0.07606422901154,
    "CMY_M": 0.07309347391129,
    "CMY_Y": 0.08106106519699,
    "CMYK_C": 0.00320502114482,
    "CMYK_M": 0,
    "CMYK_Y": 0.00859589502215,
    "CMYK_K": 0.07309347391129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08677",
    "Farbtonhilfsbezeichnung": "SN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "237",
    "Bcolor": "236",
    "Y": 84.0131912231445,
    "L": 93.4562301635742,
    "a": -0.3976374566555,
    "b": -0.72890692949295,
    "C": 0.83031368255615,
    "h": 241.38639831543,
    "CMY_C": 0.0795077085495,
    "CMY_M": 0.07200479507446,
    "CMY_Y": 0.07546812295914,
    "CMYK_C": 0.00808507762849,
    "CMYK_M": 0,
    "CMYK_Y": 0.003732053563,
    "CMYK_K": 0.07200479507446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08678",
    "Farbtonhilfsbezeichnung": "UN.02.88",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "235",
    "Bcolor": "235",
    "Y": 82.8418426513672,
    "L": 92.9451522827148,
    "a": -0.15258793532848,
    "b": -1.04080963134766,
    "C": 1.05193519592285,
    "h": 261.659576416016,
    "CMY_C": 0.08435928821564,
    "CMY_M": 0.07822495698929,
    "CMY_Y": 0.07880395650864,
    "CMYK_C": 0.0066549112089,
    "CMYK_M": 0,
    "CMYK_Y": 0.00062813539989,
    "CMYK_K": 0.07822495698929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08679",
    "Farbtonhilfsbezeichnung": "UN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "233",
    "Bcolor": "234",
    "Y": 80.9072341918945,
    "L": 92.0904006958008,
    "a": -0.0445750541985,
    "b": -1.76898109912872,
    "C": 1.76954257488251,
    "h": 268.556549072266,
    "CMY_C": 0.09562397003174,
    "CMY_M": 0.08783346414566,
    "CMY_Y": 0.08288943767548,
    "CMYK_C": 0.01388549339026,
    "CMYK_M": 0.00539087271318,
    "CMYK_Y": 0,
    "CMYK_K": 0.08288943767548
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08680",
    "Farbtonhilfsbezeichnung": "RN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "234",
    "Bcolor": "233",
    "Y": 81.0811614990234,
    "L": 92.1677932739258,
    "a": -1.56520199775696,
    "b": -1.30284988880157,
    "C": 2.03648591041565,
    "h": 219.773468017578,
    "CMY_C": 0.10536551475525,
    "CMY_M": 0.0835120677948,
    "CMY_Y": 0.08569490909576,
    "CMYK_C": 0.02384477294981,
    "CMYK_M": 0,
    "CMYK_Y": 0.00238174572587,
    "CMYK_K": 0.0835120677948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08681",
    "Farbtonhilfsbezeichnung": "S9.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "222",
    "Bcolor": "225",
    "Y": 72.2086410522461,
    "L": 88.0689239501953,
    "a": -0.97138386964798,
    "b": -3.23636651039124,
    "C": 3.3790020942688,
    "h": 253.293060302734,
    "CMY_C": 0.15299582481384,
    "CMY_M": 0.12997668981552,
    "CMY_Y": 0.11673891544342,
    "CMYK_C": 0.04104891419411,
    "CMYK_M": 0.01498738583177,
    "CMYK_Y": 0,
    "CMYK_K": 0.11673891544342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08682",
    "Farbtonhilfsbezeichnung": "ON.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "231",
    "Y": 82.3443069458008,
    "L": 92.7266082763672,
    "a": -0.04414751008153,
    "b": 0.93399542570114,
    "C": 0.93503820896149,
    "h": 92.7062072753906,
    "CMY_C": 0.07906937599182,
    "CMY_M": 0.08150041103363,
    "CMY_Y": 0.09589850902557,
    "CMYK_C": 0,
    "CMYK_M": 0.00263975909911,
    "CMYK_Y": 0.01827405020595,
    "CMYK_K": 0.07906937599182
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08683",
    "Farbtonhilfsbezeichnung": "UN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 82.3969421386719,
    "L": 92.7497711181641,
    "a": 0.36082172393799,
    "b": -1.05612003803253,
    "C": 1.11605644226074,
    "h": 288.862640380859,
    "CMY_C": 0.08248561620712,
    "CMY_M": 0.08163166046143,
    "CMY_Y": 0.08079385757446,
    "CMYK_C": 0.00184045615606,
    "CMYK_M": 0.00091144180624,
    "CMYK_Y": 0,
    "CMYK_K": 0.08079385757446
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08684",
    "Farbtonhilfsbezeichnung": "UN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "236",
    "Y": 82.7817230224609,
    "L": 92.9187850952148,
    "a": 0.80915677547455,
    "b": -1.53692984580994,
    "C": 1.73691916465759,
    "h": 297.765747070313,
    "CMY_C": 0.07870280742645,
    "CMY_M": 0.08067101240158,
    "CMY_Y": 0.07527738809586,
    "CMYK_C": 0.00370426685549,
    "CMYK_M": 0.00583269447088,
    "CMYK_Y": 0,
    "CMYK_K": 0.07527738809586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08685",
    "Farbtonhilfsbezeichnung": "T3.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "222",
    "Bcolor": "225",
    "Y": 72.4558029174805,
    "L": 88.1875228881836,
    "a": -0.80417656898499,
    "b": -3.14112186431885,
    "C": 3.24242901802063,
    "h": 255.63981628418,
    "CMY_C": 0.1499884724617,
    "CMY_M": 0.12908113002777,
    "CMY_Y": 0.11610740423203,
    "CMYK_C": 0.03833165764809,
    "CMYK_M": 0.01467794366181,
    "CMYK_Y": 0,
    "CMYK_K": 0.11610740423203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08686",
    "Farbtonhilfsbezeichnung": "SN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "235",
    "Bcolor": "233",
    "Y": 82.9656448364258,
    "L": 92.9993896484375,
    "a": -0.14526252448559,
    "b": 0.0828467682004,
    "C": 0.16722676157951,
    "h": 150.302841186523,
    "CMY_C": 0.07975572347641,
    "CMY_M": 0.07796078920364,
    "CMY_Y": 0.0865558385849,
    "CMYK_C": 0.00194670062046,
    "CMYK_M": 0,
    "CMYK_Y": 0.00932178273797,
    "CMYK_K": 0.07796078920364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08687",
    "Farbtonhilfsbezeichnung": "ON.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "232",
    "Y": 82.6498336791992,
    "L": 92.8609161376953,
    "a": 0.5354408621788,
    "b": 0.37343457341194,
    "C": 0.65280187129974,
    "h": 34.8932228088379,
    "CMY_C": 0.07488757371902,
    "CMY_M": 0.08121967315674,
    "CMY_Y": 0.09016013145447,
    "CMYK_C": 0,
    "CMYK_M": 0.00684468122199,
    "CMYK_Y": 0.0165088661015,
    "CMYK_K": 0.07488757371902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08688",
    "Farbtonhilfsbezeichnung": "XN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "234",
    "Bcolor": "234",
    "Y": 82.5742645263672,
    "L": 92.8277282714844,
    "a": 1.46410739421844,
    "b": -0.92128479480743,
    "C": 1.72984862327576,
    "h": 327.819976806641,
    "CMY_C": 0.07235932350159,
    "CMY_M": 0.08344405889511,
    "CMY_Y": 0.0807768702507,
    "CMYK_C": 0,
    "CMYK_M": 0.01194938458502,
    "CMYK_Y": 0.00907414592803,
    "CMYK_K": 0.07235932350159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08689",
    "Farbtonhilfsbezeichnung": "XN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "235",
    "Bcolor": "236",
    "Y": 83.6634063720703,
    "L": 93.3041152954102,
    "a": 2.21821570396423,
    "b": -0.91773837804794,
    "C": 2.40056753158569,
    "h": 337.523742675781,
    "CMY_C": 0.06103479862213,
    "CMY_M": 0.07993513345718,
    "CMY_Y": 0.07539629936218,
    "CMYK_C": 0,
    "CMYK_M": 0.02012889832258,
    "CMYK_Y": 0.01529502961785,
    "CMYK_K": 0.06103479862213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08690",
    "Farbtonhilfsbezeichnung": "XN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "233",
    "Bcolor": "235",
    "Y": 82.8110733032227,
    "L": 92.9316635131836,
    "a": 2.54399251937866,
    "b": -1.02299559116364,
    "C": 2.74197340011597,
    "h": 338.093841552734,
    "CMY_C": 0.06301164627075,
    "CMY_M": 0.08486318588257,
    "CMY_Y": 0.07871532440186,
    "CMYK_C": 0,
    "CMYK_M": 0.0233210362494,
    "CMYK_Y": 0.01675973646343,
    "CMYK_K": 0.06301164627075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08691",
    "Farbtonhilfsbezeichnung": "VN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "234",
    "Bcolor": "236",
    "Y": 82.6039657592773,
    "L": 92.8407745361328,
    "a": 1.13319778442383,
    "b": -1.56947422027588,
    "C": 1.93581676483154,
    "h": 305.830169677734,
    "CMY_C": 0.07710433006287,
    "CMY_M": 0.08231198787689,
    "CMY_Y": 0.07586002349854,
    "CMYK_C": 0.00134644820355,
    "CMYK_M": 0.00698158796877,
    "CMYK_Y": 0,
    "CMYK_K": 0.07586002349854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08692",
    "Farbtonhilfsbezeichnung": "JN.00.88",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "241",
    "Bcolor": "236",
    "Y": 87.3801193237305,
    "L": 94.8993148803711,
    "a": -0.85544419288635,
    "b": 1.48506331443787,
    "C": 1.71382546424866,
    "h": 119.943328857422,
    "CMY_C": 0.05927431583405,
    "CMY_M": 0.0553412437439,
    "CMY_Y": 0.07597327232361,
    "CMYK_C": 0.00416348455474,
    "CMYK_M": 0,
    "CMYK_Y": 0.02184072136879,
    "CMYK_K": 0.0553412437439
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08693",
    "Farbtonhilfsbezeichnung": "GN.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "239",
    "Bcolor": "230",
    "Y": 86.8454742431641,
    "L": 94.6726684570312,
    "a": 0.11525525897741,
    "b": 4.11160755157471,
    "C": 4.11322259902954,
    "h": 88.3943176269531,
    "CMY_C": 0.04532223939896,
    "CMY_M": 0.06094843149185,
    "CMY_Y": 0.09797549247742,
    "CMYK_C": 0,
    "CMYK_M": 0.01636802777648,
    "CMYK_Y": 0.05515290796757,
    "CMYK_K": 0.04532223939896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08694",
    "Farbtonhilfsbezeichnung": "GN.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "240",
    "Bcolor": "230",
    "Y": 86.6820907592773,
    "L": 94.6032257080078,
    "a": -0.46320939064026,
    "b": 4.20627117156982,
    "C": 4.23169946670532,
    "h": 96.2842864990234,
    "CMY_C": 0.05034166574478,
    "CMY_M": 0.0603711605072,
    "CMY_Y": 0.09953641891479,
    "CMYK_C": 0,
    "CMYK_M": 0.01056116167456,
    "CMYK_Y": 0.05180258303881,
    "CMYK_K": 0.05034166574478
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08695",
    "Farbtonhilfsbezeichnung": "A0.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 74.0864105224609,
    "L": 88.9633026123047,
    "a": 4.76470518112183,
    "b": 0.46735352277756,
    "C": 4.78757095336914,
    "h": 5.60202598571777,
    "CMY_C": 0.08532106876373,
    "CMY_M": 0.13488078117371,
    "CMY_Y": 0.13334375619888,
    "CMYK_C": 0,
    "CMYK_M": 0.05418263375759,
    "CMYK_Y": 0.05250223353505,
    "CMYK_K": 0.08532106876373
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08696",
    "Farbtonhilfsbezeichnung": "Z9.07.75",
    "Farbtonklasse": "02",
    "Rcolor": "228",
    "Gcolor": "195",
    "Bcolor": "203",
    "Y": 59.9083061218262,
    "L": 81.7883224487305,
    "a": 13.2961540222168,
    "b": -0.33807563781738,
    "C": 13.3004512786865,
    "h": 358.543487548828,
    "CMY_C": 0.10526764392853,
    "CMY_M": 0.23479217290878,
    "CMY_Y": 0.20458084344864,
    "CMYK_C": 0,
    "CMYK_M": 0.14476343989372,
    "CMYK_Y": 0.1109976619482,
    "CMYK_K": 0.10526764392853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08697",
    "Farbtonhilfsbezeichnung": "A0.12.68",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "170",
    "Bcolor": "183",
    "Y": 47.5376052856445,
    "L": 74.532341003418,
    "a": 20.4130554199219,
    "b": -0.41407811641693,
    "C": 20.4172554016113,
    "h": 358.837921142578,
    "CMY_C": 0.13769745826721,
    "CMY_M": 0.33168983459473,
    "CMY_Y": 0.28084456920624,
    "CMYK_C": 0,
    "CMYK_M": 0.22497020661831,
    "CMYK_Y": 0.16600567102432,
    "CMYK_K": 0.13769745826721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08698",
    "Farbtonhilfsbezeichnung": "Z9.19.55",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "136",
    "Bcolor": "154",
    "Y": 32.0494804382324,
    "L": 63.3837585449219,
    "a": 26.6725559234619,
    "b": -0.42043685913086,
    "C": 26.6758689880371,
    "h": 359.096923828125,
    "CMY_C": 0.22171413898468,
    "CMY_M": 0.4660524725914,
    "CMY_Y": 0.39646714925766,
    "CMYK_C": 0,
    "CMYK_M": 0.31394419074059,
    "CMYK_Y": 0.2245357632637,
    "CMYK_K": 0.22171413898468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08699",
    "Farbtonhilfsbezeichnung": "Z9.32.39",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "88",
    "Bcolor": "115",
    "Y": 17.1666831970215,
    "L": 48.4693756103516,
    "a": 38.2741622924805,
    "b": 0.11988488584757,
    "C": 38.2743492126465,
    "h": 0.17946507036686,
    "CMY_C": 0.31905072927475,
    "CMY_M": 0.6552426815033,
    "CMY_Y": 0.54783320426941,
    "CMYK_C": 0,
    "CMYK_M": 0.49371072649956,
    "CMYK_Y": 0.33597579598427,
    "CMYK_K": 0.31905072927475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08700",
    "Farbtonhilfsbezeichnung": "Z9.24.26",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "73",
    "Bcolor": "87",
    "Y": 9.44402027130127,
    "L": 36.8255004882813,
    "a": 21.6556949615479,
    "b": -0.28545686602592,
    "C": 21.6575756072998,
    "h": 359.244781494141,
    "CMY_C": 0.53283357620239,
    "CMY_M": 0.71195340156555,
    "CMY_Y": 0.65864729881287,
    "CMYK_C": 0,
    "CMYK_M": 0.38341760635376,
    "CMYK_Y": 0.26931241154671,
    "CMYK_K": 0.53283357620239
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08701",
    "Farbtonhilfsbezeichnung": "A0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 83.2080154418945,
    "L": 93.1054382324219,
    "a": 3.55548739433289,
    "b": 0.65060818195343,
    "C": 3.6145236492157,
    "h": 10.3696613311768,
    "CMY_C": 0.04751473665237,
    "CMY_M": 0.08587664365768,
    "CMY_Y": 0.08908128738403,
    "CMYK_C": 0,
    "CMYK_M": 0.04027559235692,
    "CMYK_Y": 0.04364009946585,
    "CMYK_K": 0.04751473665237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08702",
    "Farbtonhilfsbezeichnung": "A0.06.82",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "217",
    "Bcolor": "221",
    "Y": 74.3793869018555,
    "L": 89.1014862060547,
    "a": 10.8968639373779,
    "b": 0.65200501680374,
    "C": 10.9163522720337,
    "h": 3.42416405677795,
    "CMY_C": 0.0373409986496,
    "CMY_M": 0.14883702993393,
    "CMY_Y": 0.13230693340302,
    "CMYK_C": 0,
    "CMYK_M": 0.11582089960575,
    "CMYK_Y": 0.09864960610867,
    "CMYK_K": 0.0373409986496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08703",
    "Farbtonhilfsbezeichnung": "A0.16.70",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "171",
    "Bcolor": "188",
    "Y": 50.9587516784668,
    "L": 76.6540145874023,
    "a": 27.4651260375977,
    "b": 0.32526805996895,
    "C": 27.4670524597168,
    "h": 0.67851918935776,
    "CMY_C": 0.06564772129059,
    "CMY_M": 0.329629778862,
    "CMY_Y": 0.26244008541107,
    "CMYK_C": 0,
    "CMYK_M": 0.28252947330475,
    "CMYK_Y": 0.2106190174818,
    "CMYK_K": 0.06564772129059
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08704",
    "Farbtonhilfsbezeichnung": "A3.23.60",
    "Farbtonklasse": "03",
    "Rcolor": "224",
    "Gcolor": "140",
    "Bcolor": "159",
    "Y": 37.3063430786133,
    "L": 67.506233215332,
    "a": 34.6426811218262,
    "b": 2.88251113891602,
    "C": 34.7623977661133,
    "h": 4.75644874572754,
    "CMY_C": 0.11983644962311,
    "CMY_M": 0.44935995340347,
    "CMY_Y": 0.37535667419434,
    "CMYK_C": 0,
    "CMYK_M": 0.37438893318176,
    "CMYK_Y": 0.29030993580818,
    "CMYK_K": 0.11983644962311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08705",
    "Farbtonhilfsbezeichnung": "A4.44.30",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "65",
    "Bcolor": "90",
    "Y": 12.1181468963623,
    "L": 41.4032821655273,
    "a": 42.8084716796875,
    "b": 5.09856462478638,
    "C": 43.111026763916,
    "h": 6.79203367233276,
    "CMY_C": 0.36627638339996,
    "CMY_M": 0.74661004543304,
    "CMY_Y": 0.64598858356476,
    "CMYK_C": 0,
    "CMYK_M": 0.6001570224762,
    "CMYK_Y": 0.44137886166573,
    "CMYK_K": 0.36627638339996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08706",
    "Farbtonhilfsbezeichnung": "A0.31.23",
    "Farbtonklasse": "04",
    "Rcolor": "119",
    "Gcolor": "63",
    "Bcolor": "79",
    "Y": 8.12276172637939,
    "L": 34.2372550964355,
    "a": 26.392370223999,
    "b": 1.13237977027893,
    "C": 26.4166526794434,
    "h": 2.45680141448975,
    "CMY_C": 0.53182649612427,
    "CMY_M": 0.75098580121994,
    "CMY_Y": 0.69046485424042,
    "CMYK_C": 0,
    "CMYK_M": 0.46811556816101,
    "CMYK_Y": 0.3388452231884,
    "CMYK_K": 0.53182649612427
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08707",
    "Farbtonhilfsbezeichnung": "A5.33.39",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "89",
    "Bcolor": "107",
    "Y": 17.4923534393311,
    "L": 48.8745040893555,
    "a": 38.1183967590332,
    "b": 5.59300661087036,
    "C": 38.5265350341797,
    "h": 8.34728813171387,
    "CMY_C": 0.30604958534241,
    "CMY_M": 0.6524430513382,
    "CMY_Y": 0.57912623882294,
    "CMYK_C": 0,
    "CMYK_M": 0.49916169047356,
    "CMYK_Y": 0.39351031184196,
    "CMYK_K": 0.30604958534241
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08708",
    "Farbtonhilfsbezeichnung": "A5.27.27",
    "Farbtonklasse": "04",
    "Rcolor": "128",
    "Gcolor": "74",
    "Bcolor": "85",
    "Y": 10.2089586257935,
    "L": 38.2148742675781,
    "a": 24.5535163879395,
    "b": 3.40660643577576,
    "C": 24.7887096405029,
    "h": 7.89891147613525,
    "CMY_C": 0.49628728628159,
    "CMY_M": 0.70869159698486,
    "CMY_Y": 0.66810554265976,
    "CMYK_C": 0,
    "CMYK_M": 0.42167750000954,
    "CMYK_Y": 0.34110367298126,
    "CMYK_K": 0.49628728628159
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08709",
    "Farbtonhilfsbezeichnung": "A7.32.19",
    "Farbtonklasse": "04",
    "Rcolor": "109",
    "Gcolor": "61",
    "Bcolor": "68",
    "Y": 6.93306922912598,
    "L": 31.6540508270264,
    "a": 22.1427268981934,
    "b": 4.31230306625366,
    "C": 22.5587310791016,
    "h": 11.0204267501831,
    "CMY_C": 0.57447057962418,
    "CMY_M": 0.76229763031006,
    "CMY_Y": 0.73351645469666,
    "CMYK_C": 0,
    "CMYK_M": 0.44139614701271,
    "CMYK_Y": 0.37375998497009,
    "CMYK_K": 0.57447057962418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08710",
    "Farbtonhilfsbezeichnung": "A0.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "218",
    "Bcolor": "217",
    "Y": 72.9070205688477,
    "L": 88.4033508300781,
    "a": 5.58045721054077,
    "b": 1.77071142196655,
    "C": 5.85464954376221,
    "h": 17.6045341491699,
    "CMY_C": 0.08126038312912,
    "CMY_M": 0.14345681667328,
    "CMY_Y": 0.14896488189697,
    "CMYK_C": 0,
    "CMYK_M": 0.06769756227732,
    "CMYK_Y": 0.07369280606508,
    "CMYK_K": 0.08126038312912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08711",
    "Farbtonhilfsbezeichnung": "A5.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 65.9395904541016,
    "L": 84.9655914306641,
    "a": 7.67392492294312,
    "b": 1.48593401908875,
    "C": 7.81646490097046,
    "h": 10.9587993621826,
    "CMY_C": 0.1049884557724,
    "CMY_M": 0.18638318777084,
    "CMY_Y": 0.18412744998932,
    "CMYK_C": 0,
    "CMYK_M": 0.09094265848398,
    "CMYK_Y": 0.08842231333256,
    "CMYK_K": 0.1049884557724
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08713",
    "Farbtonhilfsbezeichnung": "A5.11.61",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "158",
    "Bcolor": "164",
    "Y": 39.3284873962402,
    "L": 68.9885482788086,
    "a": 16.8981456756592,
    "b": 1.83822965621948,
    "C": 16.9978351593018,
    "h": 6.20838975906372,
    "CMY_C": 0.21649634838104,
    "CMY_M": 0.38117027282715,
    "CMY_Y": 0.35545587539673,
    "CMYK_C": 0,
    "CMYK_M": 0.21017633378506,
    "CMYK_Y": 0.17735658586025,
    "CMYK_K": 0.21649634838104
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08714",
    "Farbtonhilfsbezeichnung": "A5.23.32",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "86",
    "Bcolor": "95",
    "Y": 12.7658548355103,
    "L": 42.4083099365234,
    "a": 22.8765048980713,
    "b": 3.00124382972717,
    "C": 23.0725364685059,
    "h": 7.4741358757019,
    "CMY_C": 0.46236479282379,
    "CMY_M": 0.66386413574219,
    "CMY_Y": 0.62667143344879,
    "CMYK_C": 0,
    "CMYK_M": 0.37478822469711,
    "CMYK_Y": 0.30560991168022,
    "CMYK_K": 0.46236479282379
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08715",
    "Farbtonhilfsbezeichnung": "A3.20.13",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "62",
    "Bcolor": "67",
    "Y": 5.86547422409058,
    "L": 29.070499420166,
    "a": 12.3311634063721,
    "b": 1.15545880794525,
    "C": 12.3851795196533,
    "h": 5.3531174659729,
    "CMY_C": 0.65661287307739,
    "CMY_M": 0.75804424285889,
    "CMY_Y": 0.73906767368317,
    "CMYK_C": 0,
    "CMYK_M": 0.29538488388062,
    "CMYK_Y": 0.24012199044228,
    "CMYK_K": 0.65661287307739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08716",
    "Farbtonhilfsbezeichnung": "A5.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "193",
    "Bcolor": "196",
    "Y": 56.1624755859375,
    "L": 79.7061996459961,
    "a": 7.59071779251099,
    "b": 0.27936479449272,
    "C": 7.59585666656494,
    "h": 2.10773253440857,
    "CMY_C": 0.1675518155098,
    "CMY_M": 0.24302685260773,
    "CMY_Y": 0.23229879140854,
    "CMYK_C": 0,
    "CMYK_M": 0.09066634625196,
    "CMYK_Y": 0.0777789875865,
    "CMYK_K": 0.1675518155098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08717",
    "Farbtonhilfsbezeichnung": "A5.06.64",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "166",
    "Bcolor": "170",
    "Y": 41.457447052002,
    "L": 70.495231628418,
    "a": 11.1354188919067,
    "b": 0.59009498357773,
    "C": 11.1510429382324,
    "h": 3.03341603279114,
    "CMY_C": 0.24212872982025,
    "CMY_M": 0.35011237859726,
    "CMY_Y": 0.33182740211487,
    "CMYK_C": 0,
    "CMYK_M": 0.14248283207417,
    "CMYK_Y": 0.11835607886314,
    "CMYK_K": 0.24212872982025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08718",
    "Farbtonhilfsbezeichnung": "A4.10.56",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "143",
    "Bcolor": "149",
    "Y": 31.393123626709,
    "L": 62.8381042480469,
    "a": 14.1851835250854,
    "b": 1.51996445655823,
    "C": 14.2663841247559,
    "h": 6.11599588394165,
    "CMY_C": 0.30176711082458,
    "CMY_M": 0.43764561414719,
    "CMY_Y": 0.41709971427917,
    "CMYK_C": 0,
    "CMYK_M": 0.19460341334343,
    "CMYK_Y": 0.1651778370142,
    "CMYK_K": 0.30176711082458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08719",
    "Farbtonhilfsbezeichnung": "A5.16.41",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "109",
    "Bcolor": "117",
    "Y": 18.9619140625,
    "L": 50.6426162719727,
    "a": 19.0968780517578,
    "b": 2.06217527389526,
    "C": 19.2078971862793,
    "h": 6.16319990158081,
    "CMY_C": 0.39951062202454,
    "CMY_M": 0.57324761152267,
    "CMY_Y": 0.5420560836792,
    "CMYK_C": 0,
    "CMYK_M": 0.28932565450668,
    "CMYK_Y": 0.23738215863705,
    "CMYK_K": 0.39951062202454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08720",
    "Farbtonhilfsbezeichnung": "A6.22.19",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "66",
    "Bcolor": "71",
    "Y": 7.23014831542969,
    "L": 32.3252067565918,
    "a": 16.7856273651123,
    "b": 3.05262112617493,
    "C": 17.0609436035156,
    "h": 10.3071222305298,
    "CMY_C": 0.59758961200714,
    "CMY_M": 0.74065291881561,
    "CMY_Y": 0.72074139118195,
    "CMYK_C": 0,
    "CMYK_M": 0.35551592707634,
    "CMYK_Y": 0.30603528022766,
    "CMYK_K": 0.59758961200714
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08721",
    "Farbtonhilfsbezeichnung": "A5.09.71",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "182",
    "Bcolor": "188",
    "Y": 52.6789321899414,
    "L": 77.6850509643555,
    "a": 15.5467948913574,
    "b": 1.84829950332642,
    "C": 15.6562776565552,
    "h": 6.77985525131226,
    "CMY_C": 0.12928366661072,
    "CMY_M": 0.28556472063065,
    "CMY_Y": 0.26404869556427,
    "CMYK_C": 0,
    "CMYK_M": 0.17948561906815,
    "CMYK_Y": 0.15477488934994,
    "CMYK_K": 0.12928366661072
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08722",
    "Farbtonhilfsbezeichnung": "A5.16.60",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "149",
    "Bcolor": "158",
    "Y": 37.3666572570801,
    "L": 67.5512084960938,
    "a": 24.3189010620117,
    "b": 3.17478823661804,
    "C": 24.5252571105957,
    "h": 7.43779611587524,
    "CMY_C": 0.18169611692429,
    "CMY_M": 0.4171547293663,
    "CMY_Y": 0.37852907180786,
    "CMYK_C": 0,
    "CMYK_M": 0.28773981332779,
    "CMYK_Y": 0.24053773283958,
    "CMYK_K": 0.18169611692429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08723",
    "Farbtonhilfsbezeichnung": "A5.26.48",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "112",
    "Bcolor": "130",
    "Y": 24.8461246490479,
    "L": 56.9251823425293,
    "a": 34.8403968811035,
    "b": 4.10451364517212,
    "C": 35.0813369750977,
    "h": 6.71899080276489,
    "CMY_C": 0.23629301786423,
    "CMY_M": 0.55927467346191,
    "CMY_Y": 0.49107152223587,
    "CMYK_C": 0,
    "CMYK_M": 0.42291304469109,
    "CMYK_Y": 0.33360767364502,
    "CMYK_K": 0.23629301786423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08724",
    "Farbtonhilfsbezeichnung": "A5.35.32",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "77",
    "Bcolor": "93",
    "Y": 13.0623321533203,
    "L": 42.8570137023926,
    "a": 34.3816032409668,
    "b": 5.54738187789917,
    "C": 34.8262557983398,
    "h": 9.1655330657959,
    "CMY_C": 0.39215296506882,
    "CMY_M": 0.69797110557556,
    "CMY_Y": 0.63665175437927,
    "CMYK_C": 0,
    "CMYK_M": 0.50311696529388,
    "CMYK_Y": 0.40223735570908,
    "CMYK_K": 0.39215296506882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08725",
    "Farbtonhilfsbezeichnung": "AN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "230",
    "Y": 82.7352828979492,
    "L": 92.8984222412109,
    "a": 4.14222717285156,
    "b": 1.47807383537292,
    "C": 4.3980393409729,
    "h": 19.63796043396,
    "CMY_C": 0.04260402917862,
    "CMY_M": 0.08987176418304,
    "CMY_Y": 0.09744489192963,
    "CMYK_C": 0,
    "CMYK_M": 0.04937114566565,
    "CMYK_Y": 0.0572812743485,
    "CMYK_K": 0.04260402917862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08726",
    "Farbtonhilfsbezeichnung": "A7.08.79",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "208",
    "Bcolor": "211",
    "Y": 69.5748138427734,
    "L": 86.7879028320313,
    "a": 14.4795761108398,
    "b": 2.84136176109314,
    "C": 14.75572681427,
    "h": 11.1022176742554,
    "CMY_C": 0.03140783309937,
    "CMY_M": 0.18432557582855,
    "CMY_Y": 0.17317289113998,
    "CMYK_C": 0,
    "CMYK_M": 0.15787629783154,
    "CMYK_Y": 0.14636197686195,
    "CMYK_K": 0.03140783309937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08727",
    "Farbtonhilfsbezeichnung": "A7.16.70",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "171",
    "Bcolor": "180",
    "Y": 51.3087272644043,
    "L": 76.8656463623047,
    "a": 27.1779708862305,
    "b": 5.02073812484741,
    "C": 27.6378345489502,
    "h": 10.4665679931641,
    "CMY_C": 0.05395305156708,
    "CMY_M": 0.32795238494873,
    "CMY_Y": 0.29355019330978,
    "CMYK_C": 0,
    "CMYK_M": 0.28962552547455,
    "CMYK_Y": 0.25326135754585,
    "CMYK_K": 0.05395305156708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08728",
    "Farbtonhilfsbezeichnung": "A8.20.66",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "155",
    "Bcolor": "165",
    "Y": 44.3644828796387,
    "L": 72.4714431762695,
    "a": 32.0954971313477,
    "b": 6.94986724853516,
    "C": 32.8393287658691,
    "h": 12.2180347442627,
    "CMY_C": 0.06971347332001,
    "CMY_M": 0.39027315378189,
    "CMY_Y": 0.3524883389473,
    "CMYK_C": 0,
    "CMYK_M": 0.34458166360855,
    "CMYK_Y": 0.30396535992622,
    "CMYK_K": 0.06971347332001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08729",
    "Farbtonhilfsbezeichnung": "A6.32.52",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "111",
    "Bcolor": "132",
    "Y": 27.8979682922363,
    "L": 59.7964515686035,
    "a": 43.8505096435547,
    "b": 7.30579662322998,
    "C": 44.4549407958984,
    "h": 9.45898914337158,
    "CMY_C": 0.14773434400558,
    "CMY_M": 0.563596367836,
    "CMY_Y": 0.48224037885666,
    "CMYK_C": 0,
    "CMYK_M": 0.48794883489609,
    "CMYK_Y": 0.39249032735825,
    "CMYK_K": 0.14773434400558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08730",
    "Farbtonhilfsbezeichnung": "BN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "231",
    "Y": 83.2637939453125,
    "L": 93.1298065185547,
    "a": 2.69459223747253,
    "b": 1.58954703807831,
    "C": 3.12849593162537,
    "h": 30.5364685058594,
    "CMY_C": 0.0508314371109,
    "CMY_M": 0.08377194404602,
    "CMY_Y": 0.09591442346573,
    "CMYK_C": 0,
    "CMYK_M": 0.03470459207892,
    "CMYK_Y": 0.04749734327197,
    "CMYK_K": 0.0508314371109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08731",
    "Farbtonhilfsbezeichnung": "A8.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "218",
    "Bcolor": "220",
    "Y": 75.500358581543,
    "L": 89.6268463134766,
    "a": 10.7563571929932,
    "b": 2.35190939903259,
    "C": 11.0104808807373,
    "h": 12.3337812423706,
    "CMY_C": 0.02733021974564,
    "CMY_M": 0.14316624403,
    "CMY_Y": 0.13905888795853,
    "CMYK_C": 0,
    "CMYK_M": 0.11909080296755,
    "CMYK_Y": 0.11486803740263,
    "CMYK_K": 0.02733021974564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08732",
    "Farbtonhilfsbezeichnung": "A6.10.77",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "199",
    "Bcolor": "203",
    "Y": 64.6094512939453,
    "L": 84.2820816040039,
    "a": 18.051420211792,
    "b": 3.46367478370667,
    "C": 18.3807182312012,
    "h": 10.8617973327637,
    "CMY_C": 0.03333640098572,
    "CMY_M": 0.22151750326157,
    "CMY_Y": 0.20439094305038,
    "CMYK_C": 0,
    "CMYK_M": 0.19467072188854,
    "CMYK_Y": 0.17695353925228,
    "CMYK_K": 0.03333640098572
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08733",
    "Farbtonhilfsbezeichnung": "B1.29.54",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "121",
    "Bcolor": "130",
    "Y": 30.6849269866943,
    "L": 62.2407493591309,
    "a": 39.7685394287109,
    "b": 12.2190675735474,
    "C": 41.6033935546875,
    "h": 17.0798168182373,
    "CMY_C": 0.13388842344284,
    "CMY_M": 0.52451694011688,
    "CMY_Y": 0.49169719219208,
    "CMYK_C": 0,
    "CMYK_M": 0.45101407170296,
    "CMYK_Y": 0.41312086582184,
    "CMYK_K": 0.13388842344284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08734",
    "Farbtonhilfsbezeichnung": "B2.36.38",
    "Farbtonklasse": "04",
    "Rcolor": "173",
    "Gcolor": "82",
    "Bcolor": "92",
    "Y": 15.731671333313,
    "L": 46.6204643249512,
    "a": 38.5640754699707,
    "b": 11.4935121536255,
    "C": 40.2403869628906,
    "h": 16.5959911346436,
    "CMY_C": 0.32027477025986,
    "CMY_M": 0.67845380306244,
    "CMY_Y": 0.63827389478683,
    "CMYK_C": 0,
    "CMYK_M": 0.5269467830658,
    "CMYK_Y": 0.4678348004818,
    "CMYK_K": 0.32027477025986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08735",
    "Farbtonhilfsbezeichnung": "B1.06.80",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "209",
    "Bcolor": "208",
    "Y": 68.2479858398438,
    "L": 86.1303024291992,
    "a": 10.1854200363159,
    "b": 3.20945167541504,
    "C": 10.6791086196899,
    "h": 17.4897708892822,
    "CMY_C": 0.06850475072861,
    "CMY_M": 0.18045783042908,
    "CMY_Y": 0.18366360664368,
    "CMYK_C": 0,
    "CMYK_M": 0.12018641829491,
    "CMYK_Y": 0.12362796068192,
    "CMYK_K": 0.06850475072861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08736",
    "Farbtonhilfsbezeichnung": "B1.13.70",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "178",
    "Bcolor": "180",
    "Y": 52.7552604675293,
    "L": 77.7302780151367,
    "a": 21.7297325134277,
    "b": 6.06675624847412,
    "C": 22.5607357025146,
    "h": 15.5992813110352,
    "CMY_C": 0.0767834186554,
    "CMY_M": 0.30321156978607,
    "CMY_Y": 0.29270786046982,
    "CMYK_C": 0,
    "CMYK_M": 0.24526005983353,
    "CMYK_Y": 0.23388275504112,
    "CMYK_K": 0.0767834186554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08737",
    "Farbtonhilfsbezeichnung": "B1.22.61",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "144",
    "Bcolor": "150",
    "Y": 38.3294868469238,
    "L": 68.2627563476563,
    "a": 32.0907897949219,
    "b": 9.46856212615967,
    "C": 33.4585189819336,
    "h": 16.4389820098877,
    "CMY_C": 0.11323797702789,
    "CMY_M": 0.43519109487534,
    "CMY_Y": 0.41346436738968,
    "CMYK_C": 0,
    "CMYK_M": 0.36306598782539,
    "CMYK_Y": 0.33856478333473,
    "CMYK_K": 0.11323797702789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08738",
    "Farbtonhilfsbezeichnung": "B1.33.50",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "111",
    "Bcolor": "122",
    "Y": 27.4392433166504,
    "L": 59.3787117004395,
    "a": 42.1186370849609,
    "b": 12.7511129379273,
    "C": 44.0064811706543,
    "h": 16.8433074951172,
    "CMY_C": 0.15344506502151,
    "CMY_M": 0.56295984983444,
    "CMY_Y": 0.52316904067993,
    "CMYK_C": 0,
    "CMYK_M": 0.48374271392822,
    "CMYK_Y": 0.43673950433731,
    "CMYK_K": 0.15344506502151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08739",
    "Farbtonhilfsbezeichnung": "B8.56.27",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "55",
    "Bcolor": "58",
    "Y": 10.1643266677856,
    "L": 38.1357536315918,
    "a": 42.6378898620605,
    "b": 20.6959686279297,
    "C": 47.3952827453613,
    "h": 25.8914318084717,
    "CMY_C": 0.38628381490707,
    "CMY_M": 0.78397941589355,
    "CMY_Y": 0.77205234766006,
    "CMYK_C": 0,
    "CMYK_M": 0.64801222085953,
    "CMYK_Y": 0.62857806682587,
    "CMYK_K": 0.38628381490707
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08740",
    "Farbtonhilfsbezeichnung": "B1.07.76",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "197",
    "Bcolor": "198",
    "Y": 60.7575912475586,
    "L": 82.2482528686523,
    "a": 12.4092178344727,
    "b": 3.21450352668762,
    "C": 12.8188037872315,
    "h": 14.5227680206299,
    "CMY_C": 0.09626245498657,
    "CMY_M": 0.22853523492813,
    "CMY_Y": 0.22539925575256,
    "CMYK_C": 0,
    "CMYK_M": 0.14636193215847,
    "CMYK_Y": 0.14289192855358,
    "CMYK_K": 0.09626245498657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08741",
    "Farbtonhilfsbezeichnung": "B2.10.73",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "189",
    "Bcolor": "189",
    "Y": 57.8674392700195,
    "L": 80.6650314331055,
    "a": 17.6462593078613,
    "b": 5.44093227386475,
    "C": 18.466028213501,
    "h": 17.1362819671631,
    "CMY_C": 0.07210332155228,
    "CMY_M": 0.26019549369812,
    "CMY_Y": 0.25764578580856,
    "CMYK_C": 0,
    "CMYK_M": 0.20270809531212,
    "CMYK_Y": 0.19996026158333,
    "CMYK_K": 0.07210332155228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08742",
    "Farbtonhilfsbezeichnung": "B1.17.62",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "153",
    "Bcolor": "157",
    "Y": 40.4657325744629,
    "L": 69.7999649047852,
    "a": 26.4781703948975,
    "b": 7.15785646438599,
    "C": 27.4286060333252,
    "h": 15.1272230148315,
    "CMY_C": 0.1342665553093,
    "CMY_M": 0.40118789672852,
    "CMY_Y": 0.38257986307144,
    "CMYK_C": 0,
    "CMYK_M": 0.30831816792488,
    "CMYK_Y": 0.28682419657707,
    "CMYK_K": 0.1342665553093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08743",
    "Farbtonhilfsbezeichnung": "B1.25.43",
    "Farbtonklasse": "03",
    "Rcolor": "175",
    "Gcolor": "104",
    "Bcolor": "109",
    "Y": 20.1111602783203,
    "L": 51.9626617431641,
    "a": 29.4732856750488,
    "b": 9.03622627258301,
    "C": 30.8273887634277,
    "h": 17.045036315918,
    "CMY_C": 0.31272667646408,
    "CMY_M": 0.59278905391693,
    "CMY_Y": 0.5732034444809,
    "CMYK_C": 0,
    "CMYK_M": 0.40749782323837,
    "CMYK_Y": 0.37900024652481,
    "CMYK_K": 0.31272667646408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08744",
    "Farbtonhilfsbezeichnung": "B6.48.23",
    "Farbtonklasse": "04",
    "Rcolor": "137",
    "Gcolor": "59",
    "Bcolor": "64",
    "Y": 8.86961460113525,
    "L": 35.7320365905762,
    "a": 34.0854873657227,
    "b": 13.1222019195557,
    "C": 36.5241394042969,
    "h": 21.0556640625,
    "CMY_C": 0.46115005016327,
    "CMY_M": 0.76795727014542,
    "CMY_Y": 0.74846231937408,
    "CMYK_C": 0,
    "CMYK_M": 0.5693741440773,
    "CMYK_Y": 0.53319531679153,
    "CMYK_K": 0.46115005016327
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08745",
    "Farbtonhilfsbezeichnung": "B2.36.17",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "56",
    "Bcolor": "60",
    "Y": 6.61940956115723,
    "L": 30.9242935180664,
    "a": 25.5630645751953,
    "b": 8.7226505279541,
    "C": 27.010274887085,
    "h": 18.8407115936279,
    "CMY_C": 0.55861246585846,
    "CMY_M": 0.780930519104,
    "CMY_Y": 0.76571410894394,
    "CMYK_C": 0,
    "CMYK_M": 0.50367993116379,
    "CMYK_Y": 0.46920591592789,
    "CMYK_K": 0.55861246585846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08746",
    "Farbtonhilfsbezeichnung": "B3.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "219",
    "Y": 75.8969268798828,
    "L": 89.8114624023438,
    "a": 6.18474626541138,
    "b": 3.06154155731201,
    "C": 6.90102338790894,
    "h": 26.3360958099365,
    "CMY_C": 0.0569041967392,
    "CMY_M": 0.12973827123642,
    "CMY_Y": 0.14293164014816,
    "CMYK_C": 0,
    "CMYK_M": 0.07722871005535,
    "CMYK_Y": 0.09121813625097,
    "CMYK_K": 0.0569041967392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08747",
    "Farbtonhilfsbezeichnung": "B1.08.72",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "187",
    "Bcolor": "185",
    "Y": 54.4952812194824,
    "L": 78.7496490478516,
    "a": 12.9497575759888,
    "b": 4.66598796844482,
    "C": 13.7647256851196,
    "h": 19.8148365020752,
    "CMY_C": 0.12768912315369,
    "CMY_M": 0.26813316345215,
    "CMY_Y": 0.27323234081268,
    "CMYK_C": 0,
    "CMYK_M": 0.16100227832794,
    "CMYK_Y": 0.16684786975384,
    "CMYK_K": 0.12768912315369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08748",
    "Farbtonhilfsbezeichnung": "B1.18.51",
    "Farbtonklasse": "03",
    "Rcolor": "186",
    "Gcolor": "128",
    "Bcolor": "131",
    "Y": 27.4317588806152,
    "L": 59.3718605041504,
    "a": 23.3199901580811,
    "b": 6.98688316345215,
    "C": 24.3441677093506,
    "h": 16.6786994934082,
    "CMY_C": 0.27017730474472,
    "CMY_M": 0.49932461977005,
    "CMY_Y": 0.48783648014069,
    "CMYK_C": 0,
    "CMYK_M": 0.31397670507431,
    "CMYK_Y": 0.29823568463326,
    "CMYK_K": 0.27017730474472
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08749",
    "Farbtonhilfsbezeichnung": "B1.27.38",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "92",
    "Bcolor": "97",
    "Y": 16.0989952087402,
    "L": 47.1041030883789,
    "a": 29.1439151763916,
    "b": 8.7453670501709,
    "C": 30.427770614624,
    "h": 16.7031993865967,
    "CMY_C": 0.3682975769043,
    "CMY_M": 0.63948178291321,
    "CMY_Y": 0.61784243583679,
    "CMYK_C": 0,
    "CMYK_M": 0.4292910695076,
    "CMYK_Y": 0.39503547549248,
    "CMYK_K": 0.3682975769043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08750",
    "Farbtonhilfsbezeichnung": "B2.27.30",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "79",
    "Bcolor": "83",
    "Y": 11.5256423950195,
    "L": 40.4520492553711,
    "a": 24.5449447631836,
    "b": 7.71928834915161,
    "C": 25.7301712036133,
    "h": 17.4581565856934,
    "CMY_C": 0.465715944767,
    "CMY_M": 0.68872570991516,
    "CMY_Y": 0.67426991462708,
    "CMYK_C": 0,
    "CMYK_M": 0.41739925742149,
    "CMYK_Y": 0.39034286141396,
    "CMYK_K": 0.465715944767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08751",
    "Farbtonhilfsbezeichnung": "B6.38.18",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "62",
    "Bcolor": "65",
    "Y": 7.33265590667725,
    "L": 32.5525169372559,
    "a": 22.9862461090088,
    "b": 7.28879165649414,
    "C": 24.1141872406006,
    "h": 17.5934886932373,
    "CMY_C": 0.55651044845581,
    "CMY_M": 0.75743925571442,
    "CMY_Y": 0.7432633638382,
    "CMYK_C": 0,
    "CMYK_M": 0.45306321978569,
    "CMYK_Y": 0.42109879851341,
    "CMYK_K": 0.55651044845581
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08752",
    "Farbtonhilfsbezeichnung": "B7.15.63",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "157",
    "Bcolor": "152",
    "Y": 41.055290222168,
    "L": 70.2146453857422,
    "a": 21.1712188720703,
    "b": 10.5303573608398,
    "C": 23.6454849243164,
    "h": 26.4453048706055,
    "CMY_C": 0.15539836883545,
    "CMY_M": 0.38243305683136,
    "CMY_Y": 0.40271872282028,
    "CMYK_C": 0,
    "CMYK_M": 0.26880684494972,
    "CMYK_Y": 0.29282486438751,
    "CMYK_K": 0.15539836883545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08753",
    "Farbtonhilfsbezeichnung": "C0.49.27",
    "Farbtonklasse": "04",
    "Rcolor": "151",
    "Gcolor": "61",
    "Bcolor": "57",
    "Y": 10.2917556762695,
    "L": 38.3610458374023,
    "a": 37.7275428771973,
    "b": 21.3248977661133,
    "C": 43.3372688293457,
    "h": 29.476619720459,
    "CMY_C": 0.40627104043961,
    "CMY_M": 0.75936317443848,
    "CMY_Y": 0.77533304691315,
    "CMYK_C": 0,
    "CMYK_M": 0.59470254182816,
    "CMYK_Y": 0.62160015106201,
    "CMYK_K": 0.40627104043961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08754",
    "Farbtonhilfsbezeichnung": "CN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "231",
    "Bcolor": "225",
    "Y": 81.4100646972656,
    "L": 92.3138580322266,
    "a": 3.45995473861694,
    "b": 3.24403595924377,
    "C": 4.74289512634277,
    "h": 43.1552848815918,
    "CMY_C": 0.04877263307571,
    "CMY_M": 0.095230281353,
    "CMY_Y": 0.11712628602982,
    "CMYK_C": 0,
    "CMYK_M": 0.04883968830109,
    "CMYK_Y": 0.07185837626457,
    "CMYK_K": 0.04877263307571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08755",
    "Farbtonhilfsbezeichnung": "B7.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "205",
    "Bcolor": "201",
    "Y": 65.9648742675781,
    "L": 84.9784927368164,
    "a": 10.6090621948242,
    "b": 5.55754423141479,
    "C": 11.9765815734863,
    "h": 27.6477394104004,
    "CMY_C": 0.0718001127243,
    "CMY_M": 0.19481575489044,
    "CMY_Y": 0.21321642398834,
    "CMYK_C": 0,
    "CMYK_M": 0.1325314193964,
    "CMYK_Y": 0.15235544741154,
    "CMYK_K": 0.0718001127243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08756",
    "Farbtonhilfsbezeichnung": "B7.22.60",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "145",
    "Bcolor": "139",
    "Y": 37.9264068603516,
    "L": 67.9663391113281,
    "a": 29.7912197113037,
    "b": 14.6799392700195,
    "C": 33.2117042541504,
    "h": 26.2322616577148,
    "CMY_C": 0.12067514657974,
    "CMY_M": 0.43245792388916,
    "CMY_Y": 0.45300209522247,
    "CMYK_C": 0,
    "CMYK_M": 0.35457062721252,
    "CMYK_Y": 0.377934217453,
    "CMYK_K": 0.12067514657974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08757",
    "Farbtonhilfsbezeichnung": "B8.38.44",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "95",
    "Bcolor": "93",
    "Y": 20.2204113006592,
    "L": 52.0855026245117,
    "a": 39.2940940856934,
    "b": 19.2288799285889,
    "C": 43.7467231750488,
    "h": 26.0751838684082,
    "CMY_C": 0.2441800236702,
    "CMY_M": 0.62850111722946,
    "CMY_Y": 0.63697826862335,
    "CMYK_C": 0,
    "CMYK_M": 0.50848233699799,
    "CMYK_Y": 0.51969814300537,
    "CMYK_K": 0.2441800236702
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08758",
    "Farbtonhilfsbezeichnung": "B9.50.36",
    "Farbtonklasse": "03",
    "Rcolor": "181",
    "Gcolor": "69",
    "Bcolor": "70",
    "Y": 14.4069585800171,
    "L": 44.8109931945801,
    "a": 45.8554801940918,
    "b": 22.7763938903809,
    "C": 51.2004814147949,
    "h": 26.4135665893555,
    "CMY_C": 0.2919487953186,
    "CMY_M": 0.7313643693924,
    "CMY_Y": 0.72532021999359,
    "CMYK_C": 0,
    "CMYK_M": 0.62059855461121,
    "CMYK_Y": 0.6120622754097,
    "CMYK_K": 0.2919487953186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08759",
    "Farbtonhilfsbezeichnung": "B7.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "204",
    "Bcolor": "199",
    "Y": 64.4448165893555,
    "L": 84.1968307495117,
    "a": 9.61679553985596,
    "b": 5.02099752426147,
    "C": 10.8486480712891,
    "h": 27.5693817138672,
    "CMY_C": 0.08916217088699,
    "CMY_M": 0.2006744146347,
    "CMY_Y": 0.21790224313736,
    "CMYK_C": 0,
    "CMYK_M": 0.12242820858955,
    "CMYK_Y": 0.14134247601032,
    "CMYK_K": 0.08916217088699
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08760",
    "Farbtonhilfsbezeichnung": "B7.25.50",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "120",
    "Bcolor": "116",
    "Y": 26.3853034973145,
    "L": 58.4009857177734,
    "a": 29.1059246063232,
    "b": 14.0927400588989,
    "C": 32.3382148742676,
    "h": 25.8357105255127,
    "CMY_C": 0.23456937074661,
    "CMY_M": 0.52841663360596,
    "CMY_Y": 0.54427236318588,
    "CMYK_C": 0,
    "CMYK_M": 0.383897960186,
    "CMYK_Y": 0.40461274981499,
    "CMYK_K": 0.23456937074661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08761",
    "Farbtonhilfsbezeichnung": "B9.31.25",
    "Farbtonklasse": "04",
    "Rcolor": "126",
    "Gcolor": "71",
    "Bcolor": "70",
    "Y": 9.37723636627197,
    "L": 36.7006874084473,
    "a": 23.2108192443848,
    "b": 10.5273475646973,
    "C": 25.486608505249,
    "h": 24.3968334197998,
    "CMY_C": 0.50774991512299,
    "CMY_M": 0.72060614824295,
    "CMY_Y": 0.72602355480194,
    "CMYK_C": 0,
    "CMYK_M": 0.43241482973099,
    "CMYK_Y": 0.44342023134232,
    "CMYK_K": 0.50774991512299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08762",
    "Farbtonhilfsbezeichnung": "B9.30.21",
    "Farbtonklasse": "04",
    "Rcolor": "113",
    "Gcolor": "67",
    "Bcolor": "64",
    "Y": 7.92799425125122,
    "L": 33.8324737548828,
    "a": 19.8950233459473,
    "b": 9.75377368927002,
    "C": 22.1573467254639,
    "h": 26.1169586181641,
    "CMY_C": 0.55538105964661,
    "CMY_M": 0.73714417219162,
    "CMY_Y": 0.74738609790802,
    "CMYK_C": 0,
    "CMYK_M": 0.40880650281906,
    "CMYK_Y": 0.43184179067612,
    "CMYK_K": 0.55538105964661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08763",
    "Farbtonhilfsbezeichnung": "C1.20.67",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "166",
    "Bcolor": "153",
    "Y": 47.9734077453613,
    "L": 74.8081588745117,
    "a": 26.2306995391846,
    "b": 16.7535171508789,
    "C": 31.1244258880615,
    "h": 32.5663261413574,
    "CMY_C": 0.05929839611053,
    "CMY_M": 0.35024952888489,
    "CMY_Y": 0.39843142032623,
    "CMYK_C": 0,
    "CMYK_M": 0.30929163098335,
    "CMYK_Y": 0.36051073670387,
    "CMYK_K": 0.05929839611053
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08764",
    "Farbtonhilfsbezeichnung": "B7.53.35",
    "Farbtonklasse": "04",
    "Rcolor": "187",
    "Gcolor": "66",
    "Bcolor": "75",
    "Y": 14.977879524231,
    "L": 45.6038818359375,
    "a": 49.5943717956543,
    "b": 20.7538146972656,
    "C": 53.76171875,
    "h": 22.7079048156738,
    "CMY_C": 0.26648038625717,
    "CMY_M": 0.74125027656555,
    "CMY_Y": 0.70424461364746,
    "CMYK_C": 0,
    "CMYK_M": 0.64724910259247,
    "CMYK_Y": 0.59679961204529,
    "CMYK_K": 0.26648038625717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08765",
    "Farbtonhilfsbezeichnung": "B5.51.34",
    "Farbtonklasse": "04",
    "Rcolor": "182",
    "Gcolor": "62",
    "Bcolor": "74",
    "Y": 13.8364477157593,
    "L": 43.9974632263184,
    "a": 49.4879455566406,
    "b": 19.3330478668213,
    "C": 53.1302490234375,
    "h": 21.3386859893799,
    "CMY_C": 0.28724813461304,
    "CMY_M": 0.7574907541275,
    "CMY_Y": 0.70977139472961,
    "CMYK_C": 0,
    "CMYK_M": 0.65975642204285,
    "CMYK_Y": 0.59280556440353,
    "CMYK_K": 0.28724813461304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08766",
    "Farbtonhilfsbezeichnung": "CN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 83.2802047729492,
    "L": 93.1369781494141,
    "a": 2.29724478721619,
    "b": 2.47185897827148,
    "C": 3.37452530860901,
    "h": 47.0968704223633,
    "CMY_C": 0.05094820261002,
    "CMY_M": 0.08297717571259,
    "CMY_Y": 0.10245400667191,
    "CMYK_C": 0,
    "CMYK_M": 0.0337483920157,
    "CMYK_Y": 0.05427080392838,
    "CMYK_K": 0.05094820261002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08767",
    "Farbtonhilfsbezeichnung": "C3.41.53",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "113",
    "Bcolor": "98",
    "Y": 28.8529491424561,
    "L": 60.6516304016113,
    "a": 42.6781349182129,
    "b": 28.5264549255371,
    "C": 51.3340225219727,
    "h": 33.7591285705566,
    "CMY_C": 0.11484724283218,
    "CMY_M": 0.55600154399872,
    "CMY_Y": 0.61759841442108,
    "CMYK_C": 0,
    "CMYK_M": 0.49839341640472,
    "CMYK_Y": 0.5679823756218,
    "CMYK_K": 0.11484724283218
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08768",
    "Farbtonhilfsbezeichnung": "C1.58.37",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "67",
    "Bcolor": "65",
    "Y": 16.1959266662598,
    "L": 47.2304992675781,
    "a": 51.6340255737305,
    "b": 29.2344398498535,
    "C": 59.3356971740723,
    "h": 29.5179119110107,
    "CMY_C": 0.22984808683395,
    "CMY_M": 0.73694550991058,
    "CMY_Y": 0.74389243125916,
    "CMYK_C": 0,
    "CMYK_M": 0.65843820571899,
    "CMYK_Y": 0.66745835542679,
    "CMYK_K": 0.22984808683395
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08769",
    "Farbtonhilfsbezeichnung": "C2.63.35",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "56",
    "Bcolor": "53",
    "Y": 14.0884485244751,
    "L": 44.3595123291016,
    "a": 53.4038925170898,
    "b": 32.6384086608887,
    "C": 62.5878715515137,
    "h": 31.4316730499268,
    "CMY_C": 0.25360041856766,
    "CMY_M": 0.77993071079254,
    "CMY_Y": 0.79106867313385,
    "CMYK_C": 0,
    "CMYK_M": 0.70515888929367,
    "CMYK_Y": 0.72008115053177,
    "CMYK_K": 0.25360041856766
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08770",
    "Farbtonhilfsbezeichnung": "C3.12.70",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "183",
    "Bcolor": "172",
    "Y": 53.4814720153809,
    "L": 78.1584091186523,
    "a": 15.7432746887207,
    "b": 11.3951387405396,
    "C": 19.4345016479492,
    "h": 35.8973960876465,
    "CMY_C": 0.09879791736603,
    "CMY_M": 0.28364163637161,
    "CMY_Y": 0.32724183797836,
    "CMYK_C": 0,
    "CMYK_M": 0.20510795712471,
    "CMYK_Y": 0.25348800420761,
    "CMYK_K": 0.09879791736603
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08771",
    "Farbtonhilfsbezeichnung": "C3.25.60",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "145",
    "Bcolor": "130",
    "Y": 37.5757217407227,
    "L": 67.7067413330078,
    "a": 28.3102512359619,
    "b": 19.8625011444092,
    "C": 34.5830764770508,
    "h": 35.053539276123,
    "CMY_C": 0.1235631108284,
    "CMY_M": 0.43187355995178,
    "CMY_Y": 0.49195283651352,
    "CMYK_C": 0,
    "CMYK_M": 0.35177713632584,
    "CMYK_Y": 0.42032659053802,
    "CMYK_K": 0.1235631108284
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08772",
    "Farbtonhilfsbezeichnung": "C4.39.48",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "107",
    "Bcolor": "91",
    "Y": 24.4805278778076,
    "L": 56.5657386779785,
    "a": 38.1224746704102,
    "b": 26.5054035186768,
    "C": 46.4312324523926,
    "h": 34.8097229003906,
    "CMY_C": 0.18959438800812,
    "CMY_M": 0.58042520284653,
    "CMY_Y": 0.64373672008514,
    "CMYK_C": 0,
    "CMYK_M": 0.48226568102837,
    "CMYK_Y": 0.56038892269135,
    "CMYK_K": 0.18959438800812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08773",
    "Farbtonhilfsbezeichnung": "C5.57.42",
    "Farbtonklasse": "04",
    "Rcolor": "207",
    "Gcolor": "82",
    "Bcolor": "66",
    "Y": 19.7287216186523,
    "L": 51.5290946960449,
    "a": 49.1042442321777,
    "b": 34.1745567321777,
    "C": 59.8258056640625,
    "h": 34.8363494873047,
    "CMY_C": 0.18641817569733,
    "CMY_M": 0.67937242984772,
    "CMY_Y": 0.73924952745438,
    "CMYK_C": 0,
    "CMYK_M": 0.60590618848801,
    "CMYK_Y": 0.67950308322906,
    "CMYK_K": 0.18641817569733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08774",
    "Farbtonhilfsbezeichnung": "CN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "233",
    "Bcolor": "229",
    "Y": 82.2297744750977,
    "L": 92.6761779785156,
    "a": 2.26792573928833,
    "b": 1.78987300395966,
    "C": 2.88914036750793,
    "h": 38.2809066772461,
    "CMY_C": 0.05859518051147,
    "CMY_M": 0.08786576986313,
    "CMY_Y": 0.1024916768074,
    "CMYK_C": 0,
    "CMYK_M": 0.03109245747328,
    "CMYK_Y": 0.04662871360779,
    "CMYK_K": 0.05859518051147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08775",
    "Farbtonhilfsbezeichnung": "C3.07.78",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "205",
    "Bcolor": "197",
    "Y": 65.7204971313477,
    "L": 84.853645324707,
    "a": 10.9066648483276,
    "b": 7.46194791793823,
    "C": 13.214991569519,
    "h": 34.378532409668,
    "CMY_C": 0.06592440605164,
    "CMY_M": 0.19746750593185,
    "CMY_Y": 0.22839283943176,
    "CMYK_C": 0,
    "CMYK_M": 0.14082704484463,
    "CMYK_Y": 0.17393499612808,
    "CMYK_K": 0.06592440605164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08776",
    "Farbtonhilfsbezeichnung": "C3.20.64",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "157",
    "Bcolor": "144",
    "Y": 42.4240493774414,
    "L": 71.1623001098633,
    "a": 24.5140228271484,
    "b": 16.917989730835,
    "C": 29.7851581573486,
    "h": 34.6109199523926,
    "CMY_C": 0.11150074005127,
    "CMY_M": 0.38370001316071,
    "CMY_Y": 0.43722498416901,
    "CMYK_C": 0,
    "CMYK_M": 0.30635845661163,
    "CMYK_Y": 0.36660045385361,
    "CMYK_K": 0.11150074005127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08777",
    "Farbtonhilfsbezeichnung": "C3.39.26",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "70",
    "Bcolor": "62",
    "Y": 9.60274600982666,
    "L": 37.1198043823242,
    "a": 25.7811431884766,
    "b": 16.0920543670654,
    "C": 30.3911418914795,
    "h": 31.9715557098389,
    "CMY_C": 0.4831628203392,
    "CMY_M": 0.7259721159935,
    "CMY_Y": 0.75628620386124,
    "CMYK_C": 0,
    "CMYK_M": 0.46979841589928,
    "CMYK_Y": 0.52845150232315,
    "CMYK_K": 0.4831628203392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08778",
    "Farbtonhilfsbezeichnung": "DN.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "232",
    "Bcolor": "227",
    "Y": 81.9181747436523,
    "L": 92.5387344360352,
    "a": 2.14853429794312,
    "b": 2.7509663105011,
    "C": 3.49056077003479,
    "h": 52.0097808837891,
    "CMY_C": 0.05792725086212,
    "CMY_M": 0.0893856883049,
    "CMY_Y": 0.11116987466812,
    "CMYK_C": 0,
    "CMYK_M": 0.03339279070497,
    "CMYK_Y": 0.05651646852493,
    "CMYK_K": 0.05792725086212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08779",
    "Farbtonhilfsbezeichnung": "C3.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "205",
    "Bcolor": "198",
    "Y": 65.3908233642578,
    "L": 84.6847229003906,
    "a": 9.49949169158936,
    "b": 6.36239814758301,
    "C": 11.4333047866821,
    "h": 33.812671661377,
    "CMY_C": 0.0807853937149,
    "CMY_M": 0.19541728496552,
    "CMY_Y": 0.22241938114166,
    "CMYK_C": 0,
    "CMYK_M": 0.12470634281635,
    "CMYK_Y": 0.15408152341843,
    "CMYK_K": 0.0807853937149
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08780",
    "Farbtonhilfsbezeichnung": "C5.39.34",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "84",
    "Bcolor": "69",
    "Y": 14.0857276916504,
    "L": 44.3556289672852,
    "a": 29.4892749786377,
    "b": 21.8421192169189,
    "C": 36.6973495483398,
    "h": 36.526611328125,
    "CMY_C": 0.37903881072998,
    "CMY_M": 0.67043364048004,
    "CMY_Y": 0.72755169868469,
    "CMYK_C": 0,
    "CMYK_M": 0.46926414966583,
    "CMYK_Y": 0.56124746799469,
    "CMYK_K": 0.37903881072998
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08781",
    "Farbtonhilfsbezeichnung": "C4.33.22",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "70",
    "Bcolor": "63",
    "Y": 8.63112926483154,
    "L": 35.2641639709473,
    "a": 19.7842712402344,
    "b": 12.7742366790772,
    "C": 23.5499153137207,
    "h": 32.8493728637695,
    "CMY_C": 0.53697693347931,
    "CMY_M": 0.7243390083313,
    "CMY_Y": 0.75327122211456,
    "CMYK_C": 0,
    "CMYK_M": 0.40464955568314,
    "CMYK_Y": 0.46713501214981,
    "CMYK_K": 0.53697693347931
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08783",
    "Farbtonhilfsbezeichnung": "C9.10.79",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "207",
    "Bcolor": "194",
    "Y": 68.9020767211914,
    "L": 86.4555358886719,
    "a": 13.0753889083862,
    "b": 11.5021533966065,
    "C": 17.414514541626,
    "h": 41.3374328613281,
    "CMY_C": 0.02219045162201,
    "CMY_M": 0.1866609454155,
    "CMY_Y": 0.24032974243164,
    "CMYK_C": 0,
    "CMYK_M": 0.16820299625397,
    "CMYK_Y": 0.22308975458145,
    "CMYK_K": 0.02219045162201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08784",
    "Farbtonhilfsbezeichnung": "C2.59.33",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "61",
    "Bcolor": "56",
    "Y": 13.0474309921265,
    "L": 42.8346252441406,
    "a": 47.4463348388672,
    "b": 28.7997856140137,
    "C": 55.5029945373535,
    "h": 31.257625579834,
    "CMY_C": 0.30252373218536,
    "CMY_M": 0.76154458522797,
    "CMY_Y": 0.7812534570694,
    "CMYK_C": 0,
    "CMYK_M": 0.65811681747437,
    "CMYK_Y": 0.68637418746948,
    "CMYK_K": 0.30252373218536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08785",
    "Farbtonhilfsbezeichnung": "C3.38.25",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 9.48675918579102,
    "L": 36.9050674438477,
    "a": 23.9090995788574,
    "b": 14.7853240966797,
    "C": 28.1114006042481,
    "h": 31.732536315918,
    "CMY_C": 0.49637115001678,
    "CMY_M": 0.72180080413818,
    "CMY_Y": 0.75043243169785,
    "CMYK_C": 0,
    "CMYK_M": 0.4476106762886,
    "CMYK_Y": 0.50446134805679,
    "CMYK_K": 0.49637115001678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08786",
    "Farbtonhilfsbezeichnung": "D2.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "229",
    "Bcolor": "220",
    "Y": 80.74072265625,
    "L": 92.0161972045898,
    "a": 4.64181566238403,
    "b": 5.36814403533936,
    "C": 7.09671926498413,
    "h": 49.1501388549805,
    "CMY_C": 0.03656935691833,
    "CMY_M": 0.10205096006393,
    "CMY_Y": 0.13599634170532,
    "CMYK_C": 0,
    "CMYK_M": 0.06796711683273,
    "CMYK_Y": 0.10320097953081,
    "CMYK_K": 0.03656935691833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08787",
    "Farbtonhilfsbezeichnung": "C4.46.45",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "97",
    "Bcolor": "80",
    "Y": 21.8669738769531,
    "L": 53.8855781555176,
    "a": 41.5220832824707,
    "b": 28.9382839202881,
    "C": 50.6113395690918,
    "h": 34.8740768432617,
    "CMY_C": 0.20091873407364,
    "CMY_M": 0.62113475799561,
    "CMY_Y": 0.68439495563507,
    "CMYK_C": 0,
    "CMYK_M": 0.52587395906448,
    "CMYK_Y": 0.60504013299942,
    "CMYK_K": 0.20091873407364
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08788",
    "Farbtonhilfsbezeichnung": "C6.53.33",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "70",
    "Bcolor": "55",
    "Y": 12.9056215286255,
    "L": 42.6206932067871,
    "a": 39.0163764953613,
    "b": 28.3438949584961,
    "C": 48.2250366210938,
    "h": 35.9969596862793,
    "CMY_C": 0.34549248218536,
    "CMY_M": 0.72417271137238,
    "CMY_Y": 0.78287690877914,
    "CMYK_C": 0,
    "CMYK_M": 0.57857275009155,
    "CMYK_Y": 0.66826492547989,
    "CMYK_K": 0.34549248218536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08789",
    "Farbtonhilfsbezeichnung": "C6.41.26",
    "Farbtonklasse": "03",
    "Rcolor": "133",
    "Gcolor": "73",
    "Bcolor": "62",
    "Y": 10.0721406936646,
    "L": 37.9715957641602,
    "a": 24.5679187774658,
    "b": 17.2729206085205,
    "C": 30.0322570800781,
    "h": 35.1098289489746,
    "CMY_C": 0.47869890928268,
    "CMY_M": 0.71439552307129,
    "CMY_Y": 0.75642317533493,
    "CMYK_C": 0,
    "CMYK_M": 0.45213145017624,
    "CMYK_Y": 0.53275215625763,
    "CMYK_K": 0.47869890928268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08790",
    "Farbtonhilfsbezeichnung": "D3.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "228",
    "Bcolor": "218",
    "Y": 79.8099212646484,
    "L": 91.5995101928711,
    "a": 4.92829895019531,
    "b": 5.73065519332886,
    "C": 7.55834245681763,
    "h": 49.3048400878906,
    "CMY_C": 0.03803670406342,
    "CMY_M": 0.10750210285187,
    "CMY_Y": 0.14322072267532,
    "CMYK_C": 0,
    "CMYK_M": 0.07221210747957,
    "CMYK_Y": 0.10934306681156,
    "CMYK_K": 0.03803670406342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08791",
    "Farbtonhilfsbezeichnung": "D2.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "209",
    "Bcolor": "194",
    "Y": 68.7169876098633,
    "L": 86.3637161254883,
    "a": 10.3169088363648,
    "b": 11.4122695922852,
    "C": 15.3843593597412,
    "h": 47.8858184814453,
    "CMY_C": 0.04264134168625,
    "CMY_M": 0.18047106266022,
    "CMY_Y": 0.24111092090607,
    "CMYK_C": 0,
    "CMYK_M": 0.14396874606609,
    "CMYK_Y": 0.2073095291853,
    "CMYK_K": 0.04264134168625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08792",
    "Farbtonhilfsbezeichnung": "D3.19.73",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "187",
    "Bcolor": "159",
    "Y": 57.8015022277832,
    "L": 80.628303527832,
    "a": 18.4591598510742,
    "b": 21.8096771240234,
    "C": 28.5727596282959,
    "h": 49.7562675476074,
    "CMY_C": 0.03090268373489,
    "CMY_M": 0.26702839136124,
    "CMY_Y": 0.37606316804886,
    "CMYK_C": 0,
    "CMYK_M": 0.24365530908108,
    "CMYK_Y": 0.35616698861122,
    "CMYK_K": 0.03090268373489
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08793",
    "Farbtonhilfsbezeichnung": "C8.31.64",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "150",
    "Bcolor": "122",
    "Y": 42.2058563232422,
    "L": 71.0126190185547,
    "a": 32.6253395080566,
    "b": 28.6610584259033,
    "C": 43.4265937805176,
    "h": 41.2990036010742,
    "CMY_C": 0.04665958881378,
    "CMY_M": 0.41289865970612,
    "CMY_Y": 0.52005791664124,
    "CMYK_C": 0,
    "CMYK_M": 0.38416400551796,
    "CMYK_Y": 0.49656799435616,
    "CMYK_K": 0.04665958881378
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08794",
    "Farbtonhilfsbezeichnung": "C4.45.51",
    "Farbtonklasse": "03",
    "Rcolor": "227",
    "Gcolor": "107",
    "Bcolor": "89",
    "Y": 27.6464519500732,
    "L": 59.5679740905762,
    "a": 45.5445861816406,
    "b": 31.9389820098877,
    "C": 55.6274032592773,
    "h": 35.0407676696777,
    "CMY_C": 0.10922759771347,
    "CMY_M": 0.57935762405396,
    "CMY_Y": 0.6506455540657,
    "CMYK_C": 0,
    "CMYK_M": 0.52777796983719,
    "CMYK_Y": 0.60780727863312,
    "CMYK_K": 0.10922759771347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08795",
    "Farbtonhilfsbezeichnung": "C5.56.43",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "84",
    "Bcolor": "68",
    "Y": 20.2208042144775,
    "L": 52.0859451293945,
    "a": 48.7078552246094,
    "b": 34.0557670593262,
    "C": 59.4327392578125,
    "h": 34.9606399536133,
    "CMY_C": 0.18173164129257,
    "CMY_M": 0.67162537574768,
    "CMY_Y": 0.73352241516113,
    "CMYK_C": 0,
    "CMYK_M": 0.59869569540024,
    "CMYK_Y": 0.67433959245682,
    "CMYK_K": 0.18173164129257
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08796",
    "Farbtonhilfsbezeichnung": "C6.59.36",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "74",
    "Bcolor": "60",
    "Y": 15.3677196502685,
    "L": 46.1337814331055,
    "a": 43.3918914794922,
    "b": 30.2459869384766,
    "C": 52.8930625915527,
    "h": 34.8781318664551,
    "CMY_C": 0.28187525272369,
    "CMY_M": 0.7081041932106,
    "CMY_Y": 0.76304233074188,
    "CMYK_C": 0,
    "CMYK_M": 0.59353047609329,
    "CMYK_Y": 0.67003273963928,
    "CMYK_K": 0.28187525272369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08797",
    "Farbtonhilfsbezeichnung": "D0.39.55",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "128",
    "Bcolor": "96",
    "Y": 31.7729892730713,
    "L": 63.1548118591309,
    "a": 33.4576873779297,
    "b": 32.6745338439941,
    "C": 46.7658195495605,
    "h": 44.3215217590332,
    "CMY_C": 0.13003826141357,
    "CMY_M": 0.49811798334122,
    "CMY_Y": 0.62509375810623,
    "CMYK_C": 0,
    "CMYK_M": 0.42309874296188,
    "CMYK_Y": 0.56905430555344,
    "CMYK_K": 0.13003826141357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08798",
    "Farbtonhilfsbezeichnung": "DN.03.85",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "224",
    "Y": 81.0629730224609,
    "L": 92.1597061157227,
    "a": 2.82235884666443,
    "b": 3.82736754417419,
    "C": 4.75546550750732,
    "h": 53.5943717956543,
    "CMY_C": 0.05354833602905,
    "CMY_M": 0.09555834531784,
    "CMY_Y": 0.12325012683868,
    "CMYK_C": 0,
    "CMYK_M": 0.04438685253263,
    "CMYK_Y": 0.073645375669,
    "CMYK_K": 0.05354833602905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08799",
    "Farbtonhilfsbezeichnung": "C9.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "206",
    "Bcolor": "197",
    "Y": 64.5477142333984,
    "L": 84.250129699707,
    "a": 7.08352470397949,
    "b": 6.31095838546753,
    "C": 9.48707103729248,
    "h": 41.6989555358887,
    "CMY_C": 0.10313373804092,
    "CMY_M": 0.19408375024796,
    "CMY_Y": 0.22709488868713,
    "CMYK_C": 0,
    "CMYK_M": 0.10140866786242,
    "CMYK_Y": 0.13821586966515,
    "CMYK_K": 0.10313373804092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08800",
    "Farbtonhilfsbezeichnung": "C9.21.58",
    "Farbtonklasse": "02",
    "Rcolor": "206",
    "Gcolor": "148",
    "Bcolor": "128",
    "Y": 35.9213905334473,
    "L": 66.4598159790039,
    "a": 19.6214714050293,
    "b": 18.7522010803223,
    "C": 27.1412448883057,
    "h": 43.7023124694824,
    "CMY_C": 0.19122225046158,
    "CMY_M": 0.41921836137772,
    "CMY_Y": 0.49837791919708,
    "CMYK_C": 0,
    "CMYK_M": 0.28190204501152,
    "CMYK_Y": 0.37977758049965,
    "CMYK_K": 0.19122225046158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08801",
    "Farbtonhilfsbezeichnung": "D0.31.44",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "113",
    "Bcolor": "91",
    "Y": 21.4691009521484,
    "L": 53.4591217041016,
    "a": 22.0933685302734,
    "b": 21.7077941894531,
    "C": 30.9732990264893,
    "h": 44.4956474304199,
    "CMY_C": 0.3173805475235,
    "CMY_M": 0.55856335163116,
    "CMY_Y": 0.64434731006622,
    "CMYK_C": 0,
    "CMYK_M": 0.35331955552101,
    "CMYK_Y": 0.47898834943771,
    "CMYK_K": 0.3173805475235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08802",
    "Farbtonhilfsbezeichnung": "D1.43.36",
    "Farbtonklasse": "03",
    "Rcolor": "156",
    "Gcolor": "89",
    "Bcolor": "66",
    "Y": 14.6125984191895,
    "L": 45.0989608764648,
    "a": 25.6860313415527,
    "b": 24.7047901153564,
    "C": 35.6384468078613,
    "h": 43.8844451904297,
    "CMY_C": 0.38705313205719,
    "CMY_M": 0.65155988931656,
    "CMY_Y": 0.74057066440582,
    "CMYK_C": 0,
    "CMYK_M": 0.43153291940689,
    "CMYK_Y": 0.57675069570541,
    "CMYK_K": 0.38705313205719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08803",
    "Farbtonhilfsbezeichnung": "C8.42.29",
    "Farbtonklasse": "04",
    "Rcolor": "139",
    "Gcolor": "78",
    "Bcolor": "61",
    "Y": 11.2652025222778,
    "L": 40.0235977172852,
    "a": 23.8324947357178,
    "b": 20.5387306213379,
    "C": 31.4615211486816,
    "h": 40.7546081542969,
    "CMY_C": 0.45657962560654,
    "CMY_M": 0.69347035884857,
    "CMY_Y": 0.75918215513229,
    "CMYK_C": 0,
    "CMYK_M": 0.43592539429665,
    "CMYK_Y": 0.55684798955917,
    "CMYK_K": 0.45657962560654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08804",
    "Farbtonhilfsbezeichnung": "C7.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "228",
    "Bcolor": "221",
    "Y": 80.8737487792969,
    "L": 92.0754852294922,
    "a": 5.744797706604,
    "b": 5.2575831413269,
    "C": 7.78748226165771,
    "h": 42.4644470214844,
    "CMY_C": 0.02795094251633,
    "CMY_M": 0.10409677028656,
    "CMY_Y": 0.13435876369476,
    "CMYK_C": 0,
    "CMYK_M": 0.07833537459373,
    "CMYK_Y": 0.10946754366159,
    "CMYK_K": 0.02795094251633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08805",
    "Farbtonhilfsbezeichnung": "C9.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "207",
    "Bcolor": "197",
    "Y": 66.6139755249023,
    "L": 85.3086318969727,
    "a": 8.64906978607178,
    "b": 7.94353294372559,
    "C": 11.7433433532715,
    "h": 42.5651817321777,
    "CMY_C": 0.07549577951431,
    "CMY_M": 0.18686771392822,
    "CMY_Y": 0.22735631465912,
    "CMYK_C": 0,
    "CMYK_M": 0.1204666569829,
    "CMYK_Y": 0.16426159441471,
    "CMYK_K": 0.07549577951431
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08806",
    "Farbtonhilfsbezeichnung": "C9.14.71",
    "Farbtonklasse": "02",
    "Rcolor": "230",
    "Gcolor": "183",
    "Bcolor": "167",
    "Y": 53.5803451538086,
    "L": 78.2164001464844,
    "a": 14.9590749740601,
    "b": 14.0265922546387,
    "C": 20.5065650939941,
    "h": 43.1574058532715,
    "CMY_C": 0.09735375642776,
    "CMY_M": 0.28160202503204,
    "CMY_Y": 0.34563851356506,
    "CMYK_C": 0,
    "CMYK_M": 0.20412012934685,
    "CMYK_Y": 0.27506318688393,
    "CMYK_K": 0.09735375642776
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08807",
    "Farbtonhilfsbezeichnung": "D0.34.47",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "112",
    "Bcolor": "87",
    "Y": 22,
    "L": 54.800350189209,
    "a": 26.5016994476318,
    "b": 25.7451953887939,
    "C": 36.9480056762695,
    "h": 44.1704483032227,
    "CMY_C": 0.27289831638336,
    "CMY_M": 0.55913400650024,
    "CMY_Y": 0.6580725312233,
    "CMYK_C": 0,
    "CMYK_M": 0.39366665482521,
    "CMYK_Y": 0.52973914146423,
    "CMYK_K": 0.27289831638336
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08808",
    "Farbtonhilfsbezeichnung": "C5.33.31",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "84",
    "Bcolor": "72",
    "Y": 12.4790887832642,
    "L": 41.9676399230957,
    "a": 23.0459575653076,
    "b": 16.9383373260498,
    "C": 28.6011085510254,
    "h": 36.3151741027832,
    "CMY_C": 0.44406294822693,
    "CMY_M": 0.67196667194366,
    "CMY_Y": 0.71893179416656,
    "CMYK_C": 0,
    "CMYK_M": 0.40994518995285,
    "CMYK_Y": 0.49442440271378,
    "CMYK_K": 0.44406294822693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08809",
    "Farbtonhilfsbezeichnung": "C5.33.23",
    "Farbtonklasse": "04",
    "Rcolor": "118",
    "Gcolor": "72",
    "Bcolor": "63",
    "Y": 8.81235790252686,
    "L": 35.6204795837402,
    "a": 18.9608173370361,
    "b": 13.1642189025879,
    "C": 23.0826606750488,
    "h": 34.7716827392578,
    "CMY_C": 0.53696525096893,
    "CMY_M": 0.71880924701691,
    "CMY_Y": 0.75268882513046,
    "CMYK_C": 0,
    "CMYK_M": 0.39272212982178,
    "CMYK_Y": 0.46589067578316,
    "CMYK_K": 0.53696525096893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08810",
    "Farbtonhilfsbezeichnung": "D5.08.79",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "207",
    "Bcolor": "194",
    "Y": 66.3263702392578,
    "L": 85.1626205444336,
    "a": 7.94747734069824,
    "b": 9.49951839447021,
    "C": 12.3856067657471,
    "h": 50.0835113525391,
    "CMY_C": 0.07794409990311,
    "CMY_M": 0.1871120929718,
    "CMY_Y": 0.24039804935455,
    "CMYK_C": 0,
    "CMYK_M": 0.11839628219604,
    "CMYK_Y": 0.1761866658926,
    "CMYK_K": 0.07794409990311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08811",
    "Farbtonhilfsbezeichnung": "D5.13.72",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "185",
    "Bcolor": "165",
    "Y": 53.5090942382813,
    "L": 78.1746139526367,
    "a": 12.2071733474731,
    "b": 15.0806293487549,
    "C": 19.4020729064941,
    "h": 51.0111999511719,
    "CMY_C": 0.11367207765579,
    "CMY_M": 0.27509987354279,
    "CMY_Y": 0.35412222146988,
    "CMYK_C": 0,
    "CMYK_M": 0.18213100731373,
    "CMYK_Y": 0.27128800749779,
    "CMYK_K": 0.11367207765579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08812",
    "Farbtonhilfsbezeichnung": "D2.23.62",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "153",
    "Bcolor": "127",
    "Y": 39.243236541748,
    "L": 68.9270935058594,
    "a": 21.3056354522705,
    "b": 22.9758262634277,
    "C": 31.3339862823486,
    "h": 47.1600341796875,
    "CMY_C": 0.14586919546127,
    "CMY_M": 0.39925199747086,
    "CMY_Y": 0.50304394960403,
    "CMYK_C": 0,
    "CMYK_M": 0.29665574431419,
    "CMYK_Y": 0.41817337274551,
    "CMYK_K": 0.14586919546127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08813",
    "Farbtonhilfsbezeichnung": "D3.32.55",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "132",
    "Bcolor": "101",
    "Y": 30.7792186737061,
    "L": 62.3208160400391,
    "a": 25.8557090759277,
    "b": 28.0296573638916,
    "C": 38.1337051391602,
    "h": 47.3102836608887,
    "CMY_C": 0.18766438961029,
    "CMY_M": 0.48170846700668,
    "CMY_Y": 0.60238254070282,
    "CMYK_C": 0,
    "CMYK_M": 0.36197364330292,
    "CMYK_Y": 0.51052564382553,
    "CMYK_K": 0.18766438961029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08814",
    "Farbtonhilfsbezeichnung": "D3.42.47",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "112",
    "Bcolor": "76",
    "Y": 23.3677520751953,
    "L": 55.4491348266602,
    "a": 29.1003971099854,
    "b": 33.171932220459,
    "C": 44.1272048950195,
    "h": 48.7408294677734,
    "CMY_C": 0.24310201406479,
    "CMY_M": 0.56215941905975,
    "CMY_Y": 0.70267820358276,
    "CMYK_C": 0,
    "CMYK_M": 0.42153289914131,
    "CMYK_Y": 0.60718381404877,
    "CMYK_K": 0.24310201406479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08815",
    "Farbtonhilfsbezeichnung": "D4.54.38",
    "Farbtonklasse": "04",
    "Rcolor": "176",
    "Gcolor": "92",
    "Bcolor": "57",
    "Y": 17.0610694885254,
    "L": 48.3368911743164,
    "a": 31.4821338653564,
    "b": 34.6713333129883,
    "C": 46.8318901062012,
    "h": 47.7600402832031,
    "CMY_C": 0.31146275997162,
    "CMY_M": 0.64070284366608,
    "CMY_Y": 0.77765589952469,
    "CMYK_C": 0,
    "CMYK_M": 0.47817325592041,
    "CMYK_Y": 0.67707759141922,
    "CMYK_K": 0.31146275997162
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08816",
    "Farbtonhilfsbezeichnung": "D3.33.62",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "147",
    "Bcolor": "111",
    "Y": 38.8966217041016,
    "L": 68.6763153076172,
    "a": 27.9465980529785,
    "b": 31.6984672546387,
    "C": 42.2587890625,
    "h": 48.5993499755859,
    "CMY_C": 0.09699040651321,
    "CMY_M": 0.42323434352875,
    "CMY_Y": 0.56598937511444,
    "CMYK_C": 0,
    "CMYK_M": 0.36128512024879,
    "CMYK_Y": 0.51937317848206,
    "CMYK_K": 0.09699040651321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08817",
    "Farbtonhilfsbezeichnung": "D3.55.38",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "89",
    "Bcolor": "59",
    "Y": 16.8052749633789,
    "L": 48.0137405395508,
    "a": 33.9675674438477,
    "b": 33.2563858032227,
    "C": 47.5371742248535,
    "h": 44.393871307373,
    "CMY_C": 0.30389124155045,
    "CMY_M": 0.65235024690628,
    "CMY_Y": 0.76982247829437,
    "CMYK_C": 0,
    "CMYK_M": 0.50058126449585,
    "CMYK_Y": 0.66933685541153,
    "CMYK_K": 0.30389124155045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08818",
    "Farbtonhilfsbezeichnung": "D1.36.25",
    "Farbtonklasse": "04",
    "Rcolor": "120",
    "Gcolor": "76",
    "Bcolor": "63",
    "Y": 9.53701877593994,
    "L": 36.9983329772949,
    "a": 16.9739036560059,
    "b": 15.4093294143677,
    "C": 22.9251136779785,
    "h": 42.2339401245117,
    "CMY_C": 0.52991664409637,
    "CMY_M": 0.70106899738312,
    "CMY_Y": 0.75487917661667,
    "CMYK_C": 0,
    "CMYK_M": 0.36408936977386,
    "CMYK_Y": 0.47855880856514,
    "CMYK_K": 0.52991664409637
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08819",
    "Farbtonhilfsbezeichnung": "D3.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "221",
    "Bcolor": "211",
    "Y": 74.924430847168,
    "L": 89.3575820922852,
    "a": 5.37410259246826,
    "b": 6.17048072814941,
    "C": 8.18265342712402,
    "h": 48.946174621582,
    "CMY_C": 0.05871760845184,
    "CMY_M": 0.1336213350296,
    "CMY_Y": 0.17094701528549,
    "CMYK_C": 0,
    "CMYK_M": 0.07957625389099,
    "CMYK_Y": 0.11923032999039,
    "CMYK_K": 0.05871760845184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08820",
    "Farbtonhilfsbezeichnung": "D0.47.33",
    "Farbtonklasse": "04",
    "Rcolor": "155",
    "Gcolor": "81",
    "Bcolor": "58",
    "Y": 13.227560043335,
    "L": 43.1041412353516,
    "a": 28.8043804168701,
    "b": 27.0675582885742,
    "C": 39.5265121459961,
    "h": 43.2194900512695,
    "CMY_C": 0.39106720685959,
    "CMY_M": 0.6812047958374,
    "CMY_Y": 0.77322387695313,
    "CMYK_C": 0,
    "CMYK_M": 0.47646898031235,
    "CMYK_Y": 0.62758433818817,
    "CMYK_K": 0.39106720685959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08821",
    "Farbtonhilfsbezeichnung": "D9.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "226",
    "Bcolor": "211",
    "Y": 79.5850448608398,
    "L": 91.4983520507812,
    "a": 5.89562892913818,
    "b": 9.30222415924072,
    "C": 11.013165473938,
    "h": 57.6340103149414,
    "CMY_C": 0.02162563800812,
    "CMY_M": 0.11200058460236,
    "CMY_Y": 0.17066276073456,
    "CMYK_C": 0,
    "CMYK_M": 0.09237255901098,
    "CMYK_Y": 0.15233138203621,
    "CMYK_K": 0.02162563800812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08822",
    "Farbtonhilfsbezeichnung": "D8.51.60",
    "Farbtonklasse": "03",
    "Rcolor": "241",
    "Gcolor": "140",
    "Bcolor": "77",
    "Y": 37.807243347168,
    "L": 67.8783111572266,
    "a": 33.6287879943848,
    "b": 48.687915802002,
    "C": 59.1726989746094,
    "h": 55.3671264648438,
    "CMY_C": 0.05632698535919,
    "CMY_M": 0.45257765054703,
    "CMY_Y": 0.69825863838196,
    "CMYK_C": 0,
    "CMYK_M": 0.41990250349045,
    "CMYK_Y": 0.68024796247482,
    "CMYK_K": 0.05632698535919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08823",
    "Farbtonhilfsbezeichnung": "D6.66.53",
    "Farbtonklasse": "04",
    "Rcolor": "230",
    "Gcolor": "114",
    "Bcolor": "50",
    "Y": 29.0668067932129,
    "L": 60.8405418395996,
    "a": 41.2509155273438,
    "b": 53.5438232421875,
    "C": 67.5912628173828,
    "h": 52.3888397216797,
    "CMY_C": 0.09853398799896,
    "CMY_M": 0.55296456813812,
    "CMY_Y": 0.80268383026123,
    "CMYK_C": 0,
    "CMYK_M": 0.50410175323486,
    "CMYK_Y": 0.78111636638641,
    "CMYK_K": 0.09853398799896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08824",
    "Farbtonhilfsbezeichnung": "E2.05.86",
    "Farbtonklasse": "02",
    "Rcolor": "246",
    "Gcolor": "230",
    "Bcolor": "218",
    "Y": 81.279670715332,
    "L": 92.2559967041016,
    "a": 3.80248785018921,
    "b": 6.84715366363525,
    "C": 7.83214044570923,
    "h": 60.9549026489258,
    "CMY_C": 0.03572130203247,
    "CMY_M": 0.09771412611008,
    "CMY_Y": 0.14446777105331,
    "CMYK_C": 0,
    "CMYK_M": 0.06428932398558,
    "CMYK_Y": 0.11277493834496,
    "CMYK_K": 0.03572130203247
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08825",
    "Farbtonhilfsbezeichnung": "D6.57.45",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "100",
    "Bcolor": "57",
    "Y": 21.026985168457,
    "L": 52.9790191650391,
    "a": 34.5403175354004,
    "b": 40.4936637878418,
    "C": 53.2237777709961,
    "h": 49.5364608764648,
    "CMY_C": 0.23708444833755,
    "CMY_M": 0.60627895593643,
    "CMY_Y": 0.7763437628746,
    "CMYK_C": 0,
    "CMYK_M": 0.48392578959465,
    "CMYK_Y": 0.70684009790421,
    "CMYK_K": 0.23708444833755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08826",
    "Farbtonhilfsbezeichnung": "E3.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "220",
    "Y": 82.3105773925781,
    "L": 92.7117614746094,
    "a": 3.20588135719299,
    "b": 6.71246862411499,
    "C": 7.43874406814575,
    "h": 64.470817565918,
    "CMY_C": 0.03547275066376,
    "CMY_M": 0.09112596511841,
    "CMY_Y": 0.13855028152466,
    "CMYK_C": 0,
    "CMYK_M": 0.05769999325275,
    "CMYK_Y": 0.10686844587326,
    "CMYK_K": 0.03547275066376
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08827",
    "Farbtonhilfsbezeichnung": "E2.07.83",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "222",
    "Bcolor": "205",
    "Y": 75.8283920288086,
    "L": 89.7796020507813,
    "a": 5.74822044372559,
    "b": 10.2251110076904,
    "C": 11.7300863265991,
    "h": 60.65673828125,
    "CMY_C": 0.039646089077,
    "CMY_M": 0.13095945119858,
    "CMY_Y": 0.1962286233902,
    "CMYK_C": 0,
    "CMYK_M": 0.09508303552866,
    "CMYK_Y": 0.16304670274258,
    "CMYK_K": 0.039646089077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08828",
    "Farbtonhilfsbezeichnung": "D8.13.73",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "189",
    "Bcolor": "167",
    "Y": 55.4586067199707,
    "L": 79.3046951293945,
    "a": 10.5566463470459,
    "b": 15.1573057174683,
    "C": 18.4712390899658,
    "h": 55.1438484191895,
    "CMY_C": 0.11180752515793,
    "CMY_M": 0.25873553752899,
    "CMY_Y": 0.34315097332001,
    "CMYK_C": 0,
    "CMYK_M": 0.16542361676693,
    "CMYK_Y": 0.26046544313431,
    "CMYK_K": 0.11180752515793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08829",
    "Farbtonhilfsbezeichnung": "D5.20.65",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "166",
    "Bcolor": "139",
    "Y": 44.4609298706055,
    "L": 72.535514831543,
    "a": 16.2548274993896,
    "b": 21.4016742706299,
    "C": 26.8747291564941,
    "h": 52.7828941345215,
    "CMY_C": 0.13843417167664,
    "CMY_M": 0.34718436002731,
    "CMY_Y": 0.45660185813904,
    "CMYK_C": 0,
    "CMYK_M": 0.24229162931442,
    "CMYK_Y": 0.36929005384445,
    "CMYK_K": 0.13843417167664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08830",
    "Farbtonhilfsbezeichnung": "EN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "232",
    "Bcolor": "226",
    "Y": 81.1638412475586,
    "L": 92.2045516967773,
    "a": 1.22264695167542,
    "b": 2.34494924545288,
    "C": 2.64455151557922,
    "h": 62.462646484375,
    "CMY_C": 0.07020932435989,
    "CMY_M": 0.09077054262161,
    "CMY_Y": 0.11198133230209,
    "CMYK_C": 0,
    "CMYK_M": 0.02211381494999,
    "CMYK_Y": 0.04492624849081,
    "CMYK_K": 0.07020932435989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08831",
    "Farbtonhilfsbezeichnung": "E1.12.76",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "201",
    "Bcolor": "179",
    "Y": 62.416446685791,
    "L": 83.134391784668,
    "a": 8.1030101776123,
    "b": 14.5382394790649,
    "C": 16.643892288208,
    "h": 60.8665199279785,
    "CMY_C": 0.08686453104019,
    "CMY_M": 0.2109203338623,
    "CMY_Y": 0.29875898361206,
    "CMYK_C": 0,
    "CMYK_M": 0.13585695624352,
    "CMYK_Y": 0.23205149173737,
    "CMYK_K": 0.08686453104019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08832",
    "Farbtonhilfsbezeichnung": "D8.19.66",
    "Farbtonklasse": "02",
    "Rcolor": "214",
    "Gcolor": "168",
    "Bcolor": "139",
    "Y": 44.0073051452637,
    "L": 72.2333755493164,
    "a": 13.5090246200562,
    "b": 20.4072799682617,
    "C": 24.4734725952148,
    "h": 56.4966011047363,
    "CMY_C": 0.1610050201416,
    "CMY_M": 0.342888712883,
    "CMY_Y": 0.4531130194664,
    "CMYK_C": 0,
    "CMYK_M": 0.21678757667542,
    "CMYK_Y": 0.34816417098045,
    "CMYK_K": 0.1610050201416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08833",
    "Farbtonhilfsbezeichnung": "D6.38.51",
    "Farbtonklasse": "03",
    "Rcolor": "197",
    "Gcolor": "125",
    "Bcolor": "85",
    "Y": 27.1657581329346,
    "L": 59.12744140625,
    "a": 24.2355709075928,
    "b": 32.5512428283691,
    "C": 40.5825843811035,
    "h": 53.3309898376465,
    "CMY_C": 0.22776019573212,
    "CMY_M": 0.51014244556427,
    "CMY_Y": 0.66513073444366,
    "CMYK_C": 0,
    "CMYK_M": 0.36566653847694,
    "CMYK_Y": 0.56636619567871,
    "CMYK_K": 0.22776019573212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08834",
    "Farbtonhilfsbezeichnung": "E6.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "232",
    "Bcolor": "219",
    "Y": 81.8462600708008,
    "L": 92.5069580078125,
    "a": 2.6704740524292,
    "b": 6.88917446136475,
    "C": 7.38865041732788,
    "h": 68.8120040893555,
    "CMY_C": 0.0413104891777,
    "CMY_M": 0.0921539068222,
    "CMY_Y": 0.14219552278519,
    "CMYK_C": 0,
    "CMYK_M": 0.05303429067135,
    "CMYK_Y": 0.10523223131895,
    "CMYK_K": 0.0413104891777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08835",
    "Farbtonhilfsbezeichnung": "E2.11.81",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "213",
    "Bcolor": "191",
    "Y": 70.79541015625,
    "L": 87.3855133056641,
    "a": 8.32905006408691,
    "b": 14.3120470046997,
    "C": 16.5592193603516,
    "h": 59.8022727966309,
    "CMY_C": 0.03764992952347,
    "CMY_M": 0.16491568088531,
    "CMY_Y": 0.25177252292633,
    "CMYK_C": 0,
    "CMYK_M": 0.13224475085735,
    "CMYK_Y": 0.2224996984005,
    "CMYK_K": 0.03764992952347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08836",
    "Farbtonhilfsbezeichnung": "D8.13.77",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "202",
    "Bcolor": "179",
    "Y": 64.1134567260742,
    "L": 84.0248031616211,
    "a": 10.5159482955933,
    "b": 15.9818229675293,
    "C": 19.1312274932861,
    "h": 56.6553115844727,
    "CMY_C": 0.05673205852509,
    "CMY_M": 0.20770531892776,
    "CMY_Y": 0.29944932460785,
    "CMYK_C": 0,
    "CMYK_M": 0.1600534170866,
    "CMYK_Y": 0.25731527805328,
    "CMYK_K": 0.05673205852509
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08837",
    "Farbtonhilfsbezeichnung": "D8.20.72",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "184",
    "Bcolor": "152",
    "Y": 54.0507621765137,
    "L": 78.491325378418,
    "a": 14.8211812973023,
    "b": 22.5396270751953,
    "C": 26.9759559631348,
    "h": 56.6726379394531,
    "CMY_C": 0.07744312286377,
    "CMY_M": 0.28029924631119,
    "CMY_Y": 0.40417939424515,
    "CMYK_C": 0,
    "CMYK_M": 0.21988467872143,
    "CMYK_Y": 0.35416382551193,
    "CMYK_K": 0.07744312286377
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08838",
    "Farbtonhilfsbezeichnung": "D8.34.57",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "145",
    "Bcolor": "102",
    "Y": 35.1516914367676,
    "L": 65.8666000366211,
    "a": 20.8774108886719,
    "b": 32.4712371826172,
    "C": 38.6037254333496,
    "h": 57.2609710693359,
    "CMY_C": 0.16935300827026,
    "CMY_M": 0.43165874481201,
    "CMY_Y": 0.60076987743378,
    "CMYK_C": 0,
    "CMYK_M": 0.31578484177589,
    "CMYK_Y": 0.51937448978424,
    "CMYK_K": 0.16935300827026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08839",
    "Farbtonhilfsbezeichnung": "D9.42.42",
    "Farbtonklasse": "04",
    "Rcolor": "167",
    "Gcolor": "108",
    "Bcolor": "68",
    "Y": 19.2648105621338,
    "L": 50.9955902099609,
    "a": 19.8073062896729,
    "b": 31.30686378479,
    "C": 37.0465812683105,
    "h": 57.6791801452637,
    "CMY_C": 0.34528982639313,
    "CMY_M": 0.57808148860931,
    "CMY_Y": 0.73345029354095,
    "CMYK_C": 0,
    "CMYK_M": 0.35556444525719,
    "CMYK_Y": 0.59287375211716,
    "CMYK_K": 0.34528982639313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08840",
    "Farbtonhilfsbezeichnung": "D9.05.83",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "222",
    "Bcolor": "210",
    "Y": 75.2359237670898,
    "L": 89.5033874511719,
    "a": 4.68446779251099,
    "b": 7.24457168579102,
    "C": 8.62716960906982,
    "h": 57.1125793457031,
    "CMY_C": 0.05904215574265,
    "CMY_M": 0.13059622049332,
    "CMY_Y": 0.17738503217697,
    "CMYK_C": 0,
    "CMYK_M": 0.07604385912418,
    "CMYK_Y": 0.12576852738857,
    "CMYK_K": 0.05904215574265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08841",
    "Farbtonhilfsbezeichnung": "E1.20.71",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "186",
    "Bcolor": "151",
    "Y": 54.5394668579102,
    "L": 78.7752532958984,
    "a": 12.6966609954834,
    "b": 23.2820243835449,
    "C": 26.5190086364746,
    "h": 61.3945198059082,
    "CMY_C": 0.08646303415298,
    "CMY_M": 0.27181988954544,
    "CMY_Y": 0.40705436468124,
    "CMYK_C": 0,
    "CMYK_M": 0.20290023088455,
    "CMYK_Y": 0.3509341776371,
    "CMYK_K": 0.08646303415298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08842",
    "Farbtonhilfsbezeichnung": "E0.41.34",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "94",
    "Bcolor": "62",
    "Y": 14.3027591705322,
    "L": 44.6640319824219,
    "a": 17.5258159637451,
    "b": 26.27663230896,
    "C": 31.585054397583,
    "h": 56.2977676391602,
    "CMY_C": 0.43254387378693,
    "CMY_M": 0.63229602575302,
    "CMY_Y": 0.75704574584961,
    "CMYK_C": 0,
    "CMYK_M": 0.3520133793354,
    "CMYK_Y": 0.57185369729996,
    "CMYK_K": 0.43254387378693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08843",
    "Farbtonhilfsbezeichnung": "D7.31.23",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "76",
    "Bcolor": "61",
    "Y": 8.65879917144775,
    "L": 35.3188858032227,
    "a": 10.7028455734253,
    "b": 13.7447185516357,
    "C": 17.420337677002,
    "h": 52.0925407409668,
    "CMY_C": 0.5824089050293,
    "CMY_M": 0.70030027627945,
    "CMY_Y": 0.76046234369278,
    "CMYK_C": 0,
    "CMYK_M": 0.28231292963028,
    "CMYK_Y": 0.42638227343559,
    "CMYK_K": 0.5824089050293
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08844",
    "Farbtonhilfsbezeichnung": "D9.35.65",
    "Farbtonklasse": "03",
    "Rcolor": "237",
    "Gcolor": "160",
    "Bcolor": "112",
    "Y": 44.4083404541016,
    "L": 72.5005874633789,
    "a": 23.648853302002,
    "b": 36.0290832519531,
    "C": 43.0971374511719,
    "h": 56.7198143005371,
    "CMY_C": 0.07116121053696,
    "CMY_M": 0.37119442224503,
    "CMY_Y": 0.5608172416687,
    "CMYK_C": 0,
    "CMYK_M": 0.32301968336105,
    "CMYK_Y": 0.52717012166977,
    "CMYK_K": 0.07116121053696
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08845",
    "Farbtonhilfsbezeichnung": "D9.42.57",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "139",
    "Bcolor": "88",
    "Y": 34.1311264038086,
    "L": 65.066520690918,
    "a": 25.4995632171631,
    "b": 38.9081344604492,
    "C": 46.5195732116699,
    "h": 56.7600212097168,
    "CMY_C": 0.14454889297485,
    "CMY_M": 0.45446503162384,
    "CMY_Y": 0.65400928258896,
    "CMYK_C": 0,
    "CMYK_M": 0.36228388547897,
    "CMYK_Y": 0.59554588794708,
    "CMYK_K": 0.14454889297485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08846",
    "Farbtonhilfsbezeichnung": "D9.47.54",
    "Farbtonklasse": "04",
    "Rcolor": "217",
    "Gcolor": "129",
    "Bcolor": "74",
    "Y": 31.0268878936768,
    "L": 62.5303268432617,
    "a": 29.6318283081055,
    "b": 43.3460884094238,
    "C": 52.506462097168,
    "h": 55.6430892944336,
    "CMY_C": 0.14727401733398,
    "CMY_M": 0.49390298128128,
    "CMY_Y": 0.71004372835159,
    "CMYK_C": 0,
    "CMYK_M": 0.40649512410164,
    "CMYK_Y": 0.65996545553207,
    "CMYK_K": 0.14727401733398
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08847",
    "Farbtonhilfsbezeichnung": "D7.49.42",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "104",
    "Bcolor": "63",
    "Y": 19.5349445343018,
    "L": 51.3072776794434,
    "a": 25.8873710632324,
    "b": 34.640510559082,
    "C": 43.2448959350586,
    "h": 53.228687286377,
    "CMY_C": 0.30616253614426,
    "CMY_M": 0.59340798854828,
    "CMY_Y": 0.7522851228714,
    "CMYK_C": 0,
    "CMYK_M": 0.41399529576302,
    "CMYK_Y": 0.6429785490036,
    "CMYK_K": 0.30616253614426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08848",
    "Farbtonhilfsbezeichnung": "E1.22.73",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "190",
    "Bcolor": "150",
    "Y": 57.5413284301758,
    "L": 80.4831085205078,
    "a": 13.5755472183228,
    "b": 26.2053909301758,
    "C": 29.5130138397217,
    "h": 62.6138534545898,
    "CMY_C": 0.05559241771698,
    "CMY_M": 0.25639063119888,
    "CMY_Y": 0.41059696674347,
    "CMYK_C": 0,
    "CMYK_M": 0.21261817216873,
    "CMYK_Y": 0.37590184807777,
    "CMYK_K": 0.05559241771698
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08849",
    "Farbtonhilfsbezeichnung": "E7.17.80",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "211",
    "Bcolor": "173",
    "Y": 69.7603607177734,
    "L": 86.8791961669922,
    "a": 8.81693553924561,
    "b": 23.2838115692139,
    "C": 24.897274017334,
    "h": 69.2597122192383,
    "CMY_C": 0.01928108930588,
    "CMY_M": 0.17384761571884,
    "CMY_Y": 0.32329934835434,
    "CMYK_C": 0,
    "CMYK_M": 0.15760533511639,
    "CMYK_Y": 0.30999529361725,
    "CMYK_K": 0.01928108930588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08850",
    "Farbtonhilfsbezeichnung": "E2.34.70",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "174",
    "Bcolor": "117",
    "Y": 51.0627403259277,
    "L": 76.7169952392578,
    "a": 20.6347160339356,
    "b": 38.8275604248047,
    "C": 43.9701156616211,
    "h": 62.0118064880371,
    "CMY_C": 0.03549063205719,
    "CMY_M": 0.31845593452454,
    "CMY_Y": 0.54039132595062,
    "CMYK_C": 0,
    "CMYK_M": 0.29337745904922,
    "CMYK_Y": 0.52347928285599,
    "CMYK_K": 0.03549063205719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08851",
    "Farbtonhilfsbezeichnung": "E0.44.64",
    "Farbtonklasse": "03",
    "Rcolor": "243",
    "Gcolor": "154",
    "Bcolor": "88",
    "Y": 42.8882827758789,
    "L": 71.4790802001953,
    "a": 27.9422969818115,
    "b": 47.5501136779785,
    "C": 55.1523818969727,
    "h": 59.5598487854004,
    "CMY_C": 0.04532879590988,
    "CMY_M": 0.39670193195343,
    "CMY_Y": 0.65634453296661,
    "CMYK_C": 0,
    "CMYK_M": 0.36805671453476,
    "CMYK_Y": 0.64002740383148,
    "CMYK_K": 0.04532879590988
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08852",
    "Farbtonhilfsbezeichnung": "E0.62.53",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "120",
    "Bcolor": "51",
    "Y": 28.9220161437988,
    "L": 60.7127456665039,
    "a": 34.2499046325684,
    "b": 52.489128112793,
    "C": 62.6750717163086,
    "h": 56.8749771118164,
    "CMY_C": 0.13720244169235,
    "CMY_M": 0.52890622615814,
    "CMY_Y": 0.79872369766235,
    "CMYK_C": 0,
    "CMYK_M": 0.45399269461632,
    "CMYK_Y": 0.76671665906906,
    "CMYK_K": 0.13720244169235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08853",
    "Farbtonhilfsbezeichnung": "D9.55.43",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "106",
    "Bcolor": "57",
    "Y": 20.422046661377,
    "L": 52.3110656738281,
    "a": 25.9103698730469,
    "b": 39.007984161377,
    "C": 46.829158782959,
    "h": 56.4065933227539,
    "CMY_C": 0.29060024023056,
    "CMY_M": 0.58423751592636,
    "CMY_Y": 0.77476131916046,
    "CMYK_C": 0,
    "CMYK_M": 0.41392356157303,
    "CMYK_Y": 0.68249398469925,
    "CMYK_K": 0.29060024023056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08854",
    "Farbtonhilfsbezeichnung": "E3.40.73",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "178",
    "Bcolor": "103",
    "Y": 54.470085144043,
    "L": 78.7350463867188,
    "a": 22.4786357879639,
    "b": 48.9103660583496,
    "C": 53.8285522460938,
    "h": 65.3170394897461,
    "CMY_C": 0,
    "CMY_M": 0.30390506982803,
    "CMY_Y": 0.59686875343323,
    "CMYK_C": 0,
    "CMYK_M": 0.30390506982803,
    "CMYK_Y": 0.59686875343323,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08855",
    "Farbtonhilfsbezeichnung": "E1.39.67",
    "Farbtonklasse": "03",
    "Rcolor": "246",
    "Gcolor": "163",
    "Bcolor": "104",
    "Y": 46.7926139831543,
    "L": 74.0569229125977,
    "a": 25.0869674682617,
    "b": 42.5698051452637,
    "C": 49.4119834899902,
    "h": 59.4885787963867,
    "CMY_C": 0.0361191034317,
    "CMY_M": 0.36018335819244,
    "CMY_Y": 0.59372544288635,
    "CMYK_C": 0,
    "CMYK_M": 0.33620777726173,
    "CMYK_Y": 0.57850128412247,
    "CMYK_K": 0.0361191034317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08856",
    "Farbtonhilfsbezeichnung": "F4.08.85",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "229",
    "Bcolor": "206",
    "Y": 80.0207214355469,
    "L": 91.6941528320312,
    "a": 1.7922922372818,
    "b": 12.5032930374146,
    "C": 12.6310987472534,
    "h": 81.8424682617188,
    "CMY_C": 0.04075956344604,
    "CMY_M": 0.10056155920029,
    "CMY_Y": 0.19296056032181,
    "CMYK_C": 0,
    "CMYK_M": 0.06234307214618,
    "CMYK_Y": 0.1586682498455,
    "CMYK_K": 0.04075956344604
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08857",
    "Farbtonhilfsbezeichnung": "E3.65.58",
    "Farbtonklasse": "04",
    "Rcolor": "236",
    "Gcolor": "137",
    "Bcolor": "48",
    "Y": 35.810230255127,
    "L": 66.3746719360352,
    "a": 32.1299629211426,
    "b": 60.234489440918,
    "C": 68.2680587768555,
    "h": 61.9238815307617,
    "CMY_C": 0.07406431436539,
    "CMY_M": 0.46469676494598,
    "CMY_Y": 0.81352961063385,
    "CMYK_C": 0,
    "CMYK_M": 0.42187860608101,
    "CMYK_Y": 0.79861408472061,
    "CMYK_K": 0.07406431436539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08858",
    "Farbtonhilfsbezeichnung": "E8.13.84",
    "Farbtonklasse": "02",
    "Rcolor": "250",
    "Gcolor": "220",
    "Bcolor": "191",
    "Y": 75.288330078125,
    "L": 89.5278778076172,
    "a": 6.05795574188232,
    "b": 17.4672603607178,
    "C": 18.4879417419434,
    "h": 70.8725509643555,
    "CMY_C": 0.02142810821533,
    "CMY_M": 0.13633978366852,
    "CMY_Y": 0.2525087594986,
    "CMYK_C": 0,
    "CMYK_M": 0.11742793023586,
    "CMYK_Y": 0.2361406981945,
    "CMYK_K": 0.02142810821533
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08859",
    "Farbtonhilfsbezeichnung": "E1.28.66",
    "Farbtonklasse": "03",
    "Rcolor": "225",
    "Gcolor": "168",
    "Bcolor": "122",
    "Y": 45.199047088623,
    "L": 73.0227661132813,
    "a": 15.8460750579834,
    "b": 31.095947265625,
    "C": 34.9006576538086,
    "h": 62.9972267150879,
    "CMY_C": 0.11888772249222,
    "CMY_M": 0.34294545650482,
    "CMY_Y": 0.52150404453278,
    "CMYK_C": 0,
    "CMYK_M": 0.25428965687752,
    "CMYK_Y": 0.45694100856781,
    "CMYK_K": 0.11888772249222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08860",
    "Farbtonhilfsbezeichnung": "E2.40.63",
    "Farbtonklasse": "03",
    "Rcolor": "226",
    "Gcolor": "154",
    "Bcolor": "93",
    "Y": 40.0077743530273,
    "L": 69.4750671386719,
    "a": 21.3434829711914,
    "b": 41.9331169128418,
    "C": 47.0524253845215,
    "h": 63.0244216918945,
    "CMY_C": 0.11292779445648,
    "CMY_M": 0.39719927310944,
    "CMY_Y": 0.63509726524353,
    "CMYK_C": 0,
    "CMYK_M": 0.32046034932137,
    "CMYK_Y": 0.58864372968674,
    "CMYK_K": 0.11292779445648
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08861",
    "Farbtonhilfsbezeichnung": "E2.52.57",
    "Farbtonklasse": "04",
    "Rcolor": "220",
    "Gcolor": "138",
    "Bcolor": "66",
    "Y": 33.8706359863281,
    "L": 64.8597640991211,
    "a": 25.0618114471436,
    "b": 49.7574348449707,
    "C": 55.7126274108887,
    "h": 63.2665328979492,
    "CMY_C": 0.13879173994064,
    "CMY_M": 0.45687335729599,
    "CMY_Y": 0.7396764755249,
    "CMYK_C": 0,
    "CMYK_M": 0.36934342980385,
    "CMYK_Y": 0.69772291183472,
    "CMYK_K": 0.13879173994064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08862",
    "Farbtonhilfsbezeichnung": "E3.61.54",
    "Farbtonklasse": "04",
    "Rcolor": "214",
    "Gcolor": "128",
    "Bcolor": "52",
    "Y": 30.0429382324219,
    "L": 61.6912574768066,
    "a": 27.3052349090576,
    "b": 53.0881156921387,
    "C": 59.6986083984375,
    "h": 62.7815208435059,
    "CMY_C": 0.16181933879852,
    "CMY_M": 0.49644750356674,
    "CMY_Y": 0.79795372486115,
    "CMYK_C": 0,
    "CMYK_M": 0.3992315530777,
    "CMYK_Y": 0.75894665718079,
    "CMYK_K": 0.16181933879852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08863",
    "Farbtonhilfsbezeichnung": "E7.13.82",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "217",
    "Bcolor": "186",
    "Y": 72.8569946289063,
    "L": 88.3794708251953,
    "a": 6.5551905632019,
    "b": 18.1311759948731,
    "C": 19.2797832489014,
    "h": 70.1229248046875,
    "CMY_C": 0.02942824363708,
    "CMY_M": 0.15043097734451,
    "CMY_Y": 0.26963174343109,
    "CMYK_C": 0,
    "CMYK_M": 0.12467160075903,
    "CMYK_Y": 0.24748659133911,
    "CMYK_K": 0.02942824363708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08864",
    "Farbtonhilfsbezeichnung": "E4.32.68",
    "Farbtonklasse": "02",
    "Rcolor": "232",
    "Gcolor": "172",
    "Bcolor": "117",
    "Y": 48.1447792053223,
    "L": 74.9161529541016,
    "a": 15.7969446182251,
    "b": 36.5135650634766,
    "C": 39.7842178344727,
    "h": 66.6051330566406,
    "CMY_C": 0.08913683891296,
    "CMY_M": 0.32380199432373,
    "CMY_Y": 0.54241424798965,
    "CMYK_C": 0,
    "CMYK_M": 0.25762942433357,
    "CMYK_Y": 0.49763503670692,
    "CMYK_K": 0.08913683891296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08865",
    "Farbtonhilfsbezeichnung": "E4.42.62",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "154",
    "Bcolor": "85",
    "Y": 39.5806884765625,
    "L": 69.1698303222656,
    "a": 19.8622207641602,
    "b": 45.7514801025391,
    "C": 49.8769073486328,
    "h": 66.5327529907227,
    "CMY_C": 0.12082725763321,
    "CMY_M": 0.39676016569138,
    "CMY_Y": 0.66778832674026,
    "CMYK_C": 0,
    "CMYK_M": 0.31385517120361,
    "CMYK_Y": 0.62213152647018,
    "CMYK_K": 0.12082725763321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08866",
    "Farbtonhilfsbezeichnung": "E2.43.57",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "141",
    "Bcolor": "82",
    "Y": 33.9770927429199,
    "L": 64.9443817138672,
    "a": 22.125093460083,
    "b": 41.919849395752,
    "C": 47.4003524780273,
    "h": 62.1751251220703,
    "CMY_C": 0.16167336702347,
    "CMY_M": 0.44627666473389,
    "CMY_Y": 0.67869353294373,
    "CMYK_C": 0,
    "CMYK_M": 0.33948975801468,
    "CMYK_Y": 0.61672878265381,
    "CMYK_K": 0.16167336702347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08867",
    "Farbtonhilfsbezeichnung": "E2.53.43",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "108",
    "Bcolor": "58",
    "Y": 20.2520961761475,
    "L": 52.1210479736328,
    "a": 23.2177143096924,
    "b": 38.4077301025391,
    "C": 44.8800163269043,
    "h": 58.8467712402344,
    "CMY_C": 0.30743169784546,
    "CMY_M": 0.57790422439575,
    "CMY_Y": 0.77303397655487,
    "CMYK_C": 0,
    "CMYK_M": 0.39053553342819,
    "CMYK_Y": 0.67228353023529,
    "CMYK_K": 0.30743169784546
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08868",
    "Farbtonhilfsbezeichnung": "E8.32.27",
    "Farbtonklasse": "04",
    "Rcolor": "112",
    "Gcolor": "88",
    "Bcolor": "64",
    "Y": 10.7513446807861,
    "L": 39.1584739685059,
    "a": 6.79899549484253,
    "b": 17.0676593780518,
    "C": 18.3720264434814,
    "h": 68.2798614501953,
    "CMY_C": 0.56026256084442,
    "CMY_M": 0.65618687868118,
    "CMY_Y": 0.74816930294037,
    "CMYK_C": 0,
    "CMYK_M": 0.21813999116421,
    "CMYK_Y": 0.42731577157974,
    "CMYK_K": 0.56026256084442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08869",
    "Farbtonhilfsbezeichnung": "E7.12.81",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "214",
    "Bcolor": "187",
    "Y": 70.601448059082,
    "L": 87.2910079956055,
    "a": 5.87792444229126,
    "b": 16.220422744751,
    "C": 17.2525978088379,
    "h": 70.0805969238281,
    "CMY_C": 0.05126166343689,
    "CMY_M": 0.16027641296387,
    "CMY_Y": 0.26725786924362,
    "CMYK_C": 0,
    "CMYK_M": 0.11490496993065,
    "CMYK_Y": 0.22766678035259,
    "CMYK_K": 0.05126166343689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08870",
    "Farbtonhilfsbezeichnung": "E7.20.77",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "202",
    "Bcolor": "157",
    "Y": 63,
    "L": 83.9628982543945,
    "a": 9.20879936218262,
    "b": 27.5391349792481,
    "C": 29.0380077362061,
    "h": 71.5106048583984,
    "CMY_C": 0.04150551557541,
    "CMY_M": 0.20765101909637,
    "CMY_Y": 0.38528740406036,
    "CMYK_C": 0,
    "CMYK_M": 0.17334006726742,
    "CMYK_Y": 0.35866862535477,
    "CMYK_K": 0.04150551557541
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08871",
    "Farbtonhilfsbezeichnung": "E5.43.40",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "108",
    "Bcolor": "64",
    "Y": 18.0115585327148,
    "L": 49.510124206543,
    "a": 14.3353452682495,
    "b": 31.5631923675537,
    "C": 34.6660804748535,
    "h": 65.5734405517578,
    "CMY_C": 0.39103895425797,
    "CMY_M": 0.57787907123566,
    "CMY_Y": 0.75039625167847,
    "CMYK_C": 0,
    "CMYK_M": 0.30681785941124,
    "CMYK_Y": 0.59011542797089,
    "CMYK_K": 0.39103895425797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08872",
    "Farbtonhilfsbezeichnung": "E7.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "221",
    "Bcolor": "198",
    "Y": 74.6117630004883,
    "L": 89.210823059082,
    "a": 4.38573408126831,
    "b": 12.8663158416748,
    "C": 13.5932607650757,
    "h": 71.1773300170898,
    "CMY_C": 0.04882669448853,
    "CMY_M": 0.1345676779747,
    "CMY_Y": 0.22212815284729,
    "CMYK_C": 0,
    "CMYK_M": 0.090142339468,
    "CMYK_Y": 0.18219755589962,
    "CMYK_K": 0.04882669448853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08873",
    "Farbtonhilfsbezeichnung": "E7.23.73",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "188",
    "Bcolor": "141",
    "Y": 54.7323226928711,
    "L": 78.886833190918,
    "a": 9.88881206512451,
    "b": 28.6696624755859,
    "C": 30.327184677124,
    "h": 70.9695281982422,
    "CMY_C": 0.09319585561752,
    "CMY_M": 0.26451086997986,
    "CMY_Y": 0.44581663608551,
    "CMYK_C": 0,
    "CMYK_M": 0.18892173469067,
    "CMYK_Y": 0.38886103034019,
    "CMYK_K": 0.09319585561752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08874",
    "Farbtonhilfsbezeichnung": "E7.27.70",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "181",
    "Bcolor": "129",
    "Y": 51.4091567993164,
    "L": 76.9261932373047,
    "a": 11.1648750305176,
    "b": 32.4023361206055,
    "C": 34.2719383239746,
    "h": 70.9875869750977,
    "CMY_C": 0.10101181268692,
    "CMY_M": 0.28949284553528,
    "CMY_Y": 0.49292528629303,
    "CMYK_C": 0,
    "CMYK_M": 0.20965906977654,
    "CMYK_Y": 0.43594953417778,
    "CMYK_K": 0.10101181268692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08875",
    "Farbtonhilfsbezeichnung": "E5.37.44",
    "Farbtonklasse": "03",
    "Rcolor": "161",
    "Gcolor": "117",
    "Bcolor": "75",
    "Y": 20.7375621795654,
    "L": 52.6610717773438,
    "a": 12.5041856765747,
    "b": 29.277702331543,
    "C": 31.8361186981201,
    "h": 66.8731994628906,
    "CMY_C": 0.36952525377274,
    "CMY_M": 0.54194259643555,
    "CMY_Y": 0.70581865310669,
    "CMYK_C": 0,
    "CMYK_M": 0.2734722495079,
    "CMYK_Y": 0.5333970785141,
    "CMYK_K": 0.36952525377274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08876",
    "Farbtonhilfsbezeichnung": "E6.40.32",
    "Farbtonklasse": "03",
    "Rcolor": "129",
    "Gcolor": "93",
    "Bcolor": "61",
    "Y": 12.8737287521362,
    "L": 42.5723648071289,
    "a": 10.9411716461182,
    "b": 23.8012580871582,
    "C": 26.195592880249,
    "h": 65.3122940063477,
    "CMY_C": 0.49300158023834,
    "CMY_M": 0.63486081361771,
    "CMY_Y": 0.76081490516663,
    "CMYK_C": 0,
    "CMYK_M": 0.27980211377144,
    "CMYK_Y": 0.52823305130005,
    "CMYK_K": 0.49300158023834
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08877",
    "Farbtonhilfsbezeichnung": "E7.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "219",
    "Y": 82.6903457641602,
    "L": 92.8787002563477,
    "a": 2.36488914489746,
    "b": 7.55019426345825,
    "C": 7.91189813613892,
    "h": 72.6082763671875,
    "CMY_C": 0.03742986917496,
    "CMY_M": 0.08743417263031,
    "CMY_Y": 0.14307606220245,
    "CMYK_C": 0,
    "CMYK_M": 0.05194873735309,
    "CMYK_Y": 0.10975427925587,
    "CMYK_K": 0.03742986917496
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08878",
    "Farbtonhilfsbezeichnung": "E7.09.80",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "211",
    "Bcolor": "190",
    "Y": 67.822624206543,
    "L": 85.9176788330078,
    "a": 4.33528804779053,
    "b": 12.5633068084717,
    "C": 13.2902746200562,
    "h": 70.9617004394531,
    "CMY_C": 0.08714890480042,
    "CMY_M": 0.17067492008209,
    "CMY_Y": 0.25530356168747,
    "CMYK_C": 0,
    "CMYK_M": 0.09150015562773,
    "CMYK_Y": 0.18420819938183,
    "CMYK_K": 0.08714890480042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08879",
    "Farbtonhilfsbezeichnung": "E5.47.38",
    "Farbtonklasse": "03",
    "Rcolor": "151",
    "Gcolor": "101",
    "Bcolor": "59",
    "Y": 16.1279792785645,
    "L": 47.1419448852539,
    "a": 15.9987344741821,
    "b": 31.2644653320313,
    "C": 35.1201705932617,
    "h": 62.900146484375,
    "CMY_C": 0.40827310085297,
    "CMY_M": 0.60515856742859,
    "CMY_Y": 0.76937699317932,
    "CMYK_C": 0,
    "CMYK_M": 0.33273029327393,
    "CMYK_Y": 0.61025428771973,
    "CMYK_K": 0.40827310085297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08880",
    "Farbtonhilfsbezeichnung": "F0.15.79",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "209",
    "Bcolor": "173",
    "Y": 66.4863052368164,
    "L": 85.2438659667969,
    "a": 5.27138566970825,
    "b": 20.5112838745117,
    "C": 21.1778259277344,
    "h": 75.5869445800781,
    "CMY_C": 0.06850838661194,
    "CMY_M": 0.18225699663162,
    "CMY_Y": 0.32072168588638,
    "CMYK_C": 0,
    "CMYK_M": 0.1221144720912,
    "CMYK_Y": 0.27076283097267,
    "CMYK_K": 0.06850838661194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08881",
    "Farbtonhilfsbezeichnung": "F0.22.77",
    "Farbtonklasse": "02",
    "Rcolor": "240",
    "Gcolor": "202",
    "Bcolor": "154",
    "Y": 62.8399085998535,
    "L": 83.3580780029297,
    "a": 7.24015712738037,
    "b": 28.1031970977783,
    "C": 29.0208473205566,
    "h": 75.5531845092773,
    "CMY_C": 0.06046187877655,
    "CMY_M": 0.20937353372574,
    "CMY_Y": 0.39614874124527,
    "CMYK_C": 0,
    "CMYK_M": 0.15849453210831,
    "CMYK_Y": 0.35728925466537,
    "CMYK_K": 0.06046187877655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08882",
    "Farbtonhilfsbezeichnung": "E7.31.68",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "174",
    "Bcolor": "117",
    "Y": 47.7646217346191,
    "L": 74.6762237548828,
    "a": 12.0460271835327,
    "b": 35.7257270812988,
    "C": 37.7019157409668,
    "h": 71.3668823242188,
    "CMY_C": 0.11612623929977,
    "CMY_M": 0.31630003452301,
    "CMY_Y": 0.5399022102356,
    "CMYK_C": 0,
    "CMYK_M": 0.22647328674793,
    "CMYK_Y": 0.4794530570507,
    "CMYK_K": 0.11612623929977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08883",
    "Farbtonhilfsbezeichnung": "E8.52.58",
    "Farbtonklasse": "03",
    "Rcolor": "210",
    "Gcolor": "147",
    "Bcolor": "65",
    "Y": 35.1496620178223,
    "L": 65.8650207519531,
    "a": 16.2843475341797,
    "b": 51.2022552490234,
    "C": 53.7294235229492,
    "h": 72.3572769165039,
    "CMY_C": 0.17476171255112,
    "CMY_M": 0.42179554700851,
    "CMY_Y": 0.74546551704407,
    "CMYK_C": 0,
    "CMYK_M": 0.29934850335121,
    "CMYK_Y": 0.69156241416931,
    "CMYK_K": 0.17476171255112
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08884",
    "Farbtonhilfsbezeichnung": "E8.59.46",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "122",
    "Bcolor": "59",
    "Y": 23.7958946228027,
    "L": 55.8828544616699,
    "a": 15.6431694030762,
    "b": 42.2771224975586,
    "C": 45.0784187316895,
    "h": 69.6947708129883,
    "CMY_C": 0.30186802148819,
    "CMY_M": 0.52000331878662,
    "CMY_Y": 0.77002912759781,
    "CMYK_C": 0,
    "CMYK_M": 0.31245568394661,
    "CMYK_Y": 0.67059111595154,
    "CMYK_K": 0.30186802148819
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08885",
    "Farbtonhilfsbezeichnung": "E7.42.34",
    "Farbtonklasse": "04",
    "Rcolor": "132",
    "Gcolor": "97",
    "Bcolor": "63",
    "Y": 13.8902473449707,
    "L": 44.075122833252,
    "a": 9.90260219573975,
    "b": 24.8164596557617,
    "C": 26.7192478179932,
    "h": 68.246337890625,
    "CMY_C": 0.48163706064224,
    "CMY_M": 0.61819994449615,
    "CMY_Y": 0.75437319278717,
    "CMYK_C": 0,
    "CMYK_M": 0.26345032453537,
    "CMYK_Y": 0.52614897489548,
    "CMYK_K": 0.48163706064224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08886",
    "Farbtonhilfsbezeichnung": "F0.35.73",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "188",
    "Bcolor": "116",
    "Y": 56.6948776245117,
    "L": 80.0076675415039,
    "a": 12.438196182251,
    "b": 43.3375473022461,
    "C": 45.087158203125,
    "h": 73.9861297607422,
    "CMY_C": 0.04054820537567,
    "CMY_M": 0.26172691583633,
    "CMY_Y": 0.54378235340118,
    "CMYK_C": 0,
    "CMYK_M": 0.23052613437176,
    "CMYK_Y": 0.52450174093246,
    "CMYK_K": 0.04054820537567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08887",
    "Farbtonhilfsbezeichnung": "E8.38.68",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "175",
    "Bcolor": "102",
    "Y": 49.5167465209961,
    "L": 75.7716827392578,
    "a": 14.5357170104981,
    "b": 45.1250457763672,
    "C": 47.4084053039551,
    "h": 72.1451721191406,
    "CMY_C": 0.07519179582596,
    "CMY_M": 0.31277823448181,
    "CMY_Y": 0.59945923089981,
    "CMYK_C": 0,
    "CMYK_M": 0.25690346956253,
    "CMYK_Y": 0.56689316034317,
    "CMYK_K": 0.07519179582596
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08888",
    "Farbtonhilfsbezeichnung": "E7.44.66",
    "Farbtonklasse": "03",
    "Rcolor": "232",
    "Gcolor": "166",
    "Bcolor": "87",
    "Y": 45.0657997131348,
    "L": 72.9351959228516,
    "a": 17.0965576171875,
    "b": 49.1332054138184,
    "C": 52.0227279663086,
    "h": 70.8139724731445,
    "CMY_C": 0.08875739574432,
    "CMY_M": 0.35022813081741,
    "CMY_Y": 0.65830183029175,
    "CMYK_C": 0,
    "CMYK_M": 0.28693866729736,
    "CMYK_Y": 0.62501955032349,
    "CMYK_K": 0.08875739574432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08889",
    "Farbtonhilfsbezeichnung": "E5.56.50",
    "Farbtonklasse": "04",
    "Rcolor": "195",
    "Gcolor": "126",
    "Bcolor": "56",
    "Y": 26.8118419647217,
    "L": 58.7997589111328,
    "a": 20.7744407653809,
    "b": 47.1730842590332,
    "C": 51.5449066162109,
    "h": 66.2319030761719,
    "CMY_C": 0.23590183258057,
    "CMY_M": 0.50555139780045,
    "CMY_Y": 0.77920544147491,
    "CMYK_C": 0,
    "CMYK_M": 0.35289910435677,
    "CMYK_Y": 0.71103900671005,
    "CMYK_K": 0.23590183258057
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08890",
    "Farbtonhilfsbezeichnung": "F1.10.84",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "226",
    "Bcolor": "201",
    "Y": 78.7505798339844,
    "L": 91.1213226318359,
    "a": 3.86306071281433,
    "b": 14.4458980560303,
    "C": 14.953501701355,
    "h": 75.0285186767578,
    "CMY_C": 0.02673423290253,
    "CMY_M": 0.11248159408569,
    "CMY_Y": 0.21328085660934,
    "CMYK_C": 0,
    "CMYK_M": 0.08810272067785,
    "CMYK_Y": 0.19167079031467,
    "CMYK_K": 0.02673423290253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08891",
    "Farbtonhilfsbezeichnung": "F3.17.83",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "221",
    "Bcolor": "177",
    "Y": 75.5497665405273,
    "L": 89.6498870849609,
    "a": 4.93715763092041,
    "b": 24.7894191741943,
    "C": 25.2762889862061,
    "h": 78.7361373901367,
    "CMY_C": 0.0108146071434,
    "CMY_M": 0.13388425111771,
    "CMY_Y": 0.30593317747116,
    "CMYK_C": 0,
    "CMYK_M": 0.1244151443243,
    "CMYK_Y": 0.29834505915642,
    "CMYK_K": 0.0108146071434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08892",
    "Farbtonhilfsbezeichnung": "E8.54.71",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "177",
    "Bcolor": "69",
    "Y": 54.2922897338867,
    "L": 78.6318588256836,
    "a": 22.0367984771729,
    "b": 64.3365097045898,
    "C": 68.0059356689453,
    "h": 71.0924377441406,
    "CMY_C": 0,
    "CMY_M": 0.3058055639267,
    "CMY_Y": 0.72911494970322,
    "CMYK_C": 0,
    "CMYK_M": 0.3058055639267,
    "CMYK_Y": 0.72911494970322,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08893",
    "Farbtonhilfsbezeichnung": "E7.67.63",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "152",
    "Bcolor": "43",
    "Y": 42.1342124938965,
    "L": 70.9633560180664,
    "a": 27.6280078887939,
    "b": 66.3990707397461,
    "C": 71.9176177978516,
    "h": 67.4082794189453,
    "CMY_C": 0.03799241781235,
    "CMY_M": 0.40348279476166,
    "CMY_Y": 0.83105462789536,
    "CMYK_C": 0,
    "CMYK_M": 0.37992462515831,
    "CMYK_Y": 0.8243824839592,
    "CMYK_K": 0.03799241781235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08894",
    "Farbtonhilfsbezeichnung": "E6.64.53",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "131",
    "Bcolor": "45",
    "Y": 29.7037868499756,
    "L": 61.3977966308594,
    "a": 22.3134651184082,
    "b": 55.36328125,
    "C": 59.6907348632813,
    "h": 68.0487289428711,
    "CMY_C": 0.1906276345253,
    "CMY_M": 0.48470449447632,
    "CMY_Y": 0.8246260881424,
    "CMYK_C": 0,
    "CMYK_M": 0.36333939433098,
    "CMYK_Y": 0.78332108259201,
    "CMYK_K": 0.1906276345253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08895",
    "Farbtonhilfsbezeichnung": "E5.54.43",
    "Farbtonklasse": "04",
    "Rcolor": "171",
    "Gcolor": "111",
    "Bcolor": "53",
    "Y": 20.3576240539551,
    "L": 52.2391586303711,
    "a": 18.4683380126953,
    "b": 40.8359909057617,
    "C": 44.8180503845215,
    "h": 65.6648406982422,
    "CMY_C": 0.32914763689041,
    "CMY_M": 0.56350415945053,
    "CMY_Y": 0.79202878475189,
    "CMYK_C": 0,
    "CMYK_M": 0.34934142231941,
    "CMYK_Y": 0.68998956680298,
    "CMYK_K": 0.32914763689041
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08896",
    "Farbtonhilfsbezeichnung": "F2.16.84",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "222",
    "Bcolor": "181",
    "Y": 76.7645568847656,
    "L": 90.2131423950195,
    "a": 5.6226019859314,
    "b": 23.6962184906006,
    "C": 24.3541450500488,
    "h": 76.6517944335938,
    "CMY_C": 0.00198805332184,
    "CMY_M": 0.12911260128021,
    "CMY_Y": 0.29164510965347,
    "CMYK_C": 0,
    "CMYK_M": 0.1273777782917,
    "CMYK_Y": 0.29023405909538,
    "CMYK_K": 0.00198805332184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08898",
    "Farbtonhilfsbezeichnung": "E9.41.74",
    "Farbtonklasse": "02",
    "Rcolor": "253",
    "Gcolor": "188",
    "Bcolor": "101",
    "Y": 57.6453819274902,
    "L": 80.5412292480469,
    "a": 15.1876230239868,
    "b": 51.8825149536133,
    "C": 54.0597763061523,
    "h": 73.6836090087891,
    "CMY_C": 0.0063933134079,
    "CMY_M": 0.26463258266449,
    "CMY_Y": 0.6048367023468,
    "CMYK_C": 0,
    "CMYK_M": 0.25990089774132,
    "CMYK_Y": 0.60229402780533,
    "CMYK_K": 0.0063933134079
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08899",
    "Farbtonhilfsbezeichnung": "E8.49.68",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "172",
    "Bcolor": "78",
    "Y": 49.2571487426758,
    "L": 75.6110229492188,
    "a": 17.6245555877686,
    "b": 56.673656463623,
    "C": 59.3508911132813,
    "h": 72.7251815795898,
    "CMY_C": 0.04598140716553,
    "CMY_M": 0.32447040081024,
    "CMY_Y": 0.69360983371735,
    "CMYK_C": 0,
    "CMYK_M": 0.29191148281097,
    "CMYK_Y": 0.67884254455566,
    "CMYK_K": 0.04598140716553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08900",
    "Farbtonhilfsbezeichnung": "E8.66.68",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "166",
    "Bcolor": "33",
    "Y": 49.1898193359375,
    "L": 75.5692672729492,
    "a": 25.9420471191406,
    "b": 73.8906326293945,
    "C": 78.3122940063477,
    "h": 70.6544799804688,
    "CMY_C": 0,
    "CMY_M": 0.35078054666519,
    "CMY_Y": 0.87119269371033,
    "CMYK_C": 0,
    "CMYK_M": 0.35078054666519,
    "CMYK_Y": 0.87119269371033,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08901",
    "Farbtonhilfsbezeichnung": "E5.54.57",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "143",
    "Bcolor": "62",
    "Y": 34.9853897094727,
    "L": 65.7372894287109,
    "a": 22.2488498687744,
    "b": 52.6859474182129,
    "C": 57.1910858154297,
    "h": 67.1060638427734,
    "CMY_C": 0.14141321182251,
    "CMY_M": 0.43995690345764,
    "CMY_Y": 0.75668269395828,
    "CMYK_C": 0,
    "CMYK_M": 0.34771522879601,
    "CMYK_Y": 0.71660721302032,
    "CMYK_K": 0.14141321182251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08902",
    "Farbtonhilfsbezeichnung": "E5.59.49",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "124",
    "Bcolor": "49",
    "Y": 26.3209552764893,
    "L": 58.3404541015625,
    "a": 21.7127876281738,
    "b": 50.0516204833984,
    "C": 54.5583152770996,
    "h": 66.5484161376953,
    "CMY_C": 0.23387712240219,
    "CMY_M": 0.5131903886795,
    "CMY_Y": 0.80748027563095,
    "CMYK_C": 0,
    "CMYK_M": 0.36458024382591,
    "CMYK_Y": 0.74870908260345,
    "CMYK_K": 0.23387712240219
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08903",
    "Farbtonhilfsbezeichnung": "F1.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "232",
    "Bcolor": "212",
    "Y": 82.17431640625,
    "L": 92.651741027832,
    "a": 2.37125563621521,
    "b": 10.4745292663574,
    "C": 10.7395820617676,
    "h": 77.2442169189453,
    "CMY_C": 0.03134226799011,
    "CMY_M": 0.09076011180878,
    "CMY_Y": 0.16733306646347,
    "CMYK_C": 0,
    "CMYK_M": 0.06134039163589,
    "CMYK_Y": 0.14039097726345,
    "CMYK_K": 0.03134226799011
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08904",
    "Farbtonhilfsbezeichnung": "F1.26.80",
    "Farbtonklasse": "01",
    "Rcolor": "255",
    "Gcolor": "209",
    "Bcolor": "146",
    "Y": 68.9971008300781,
    "L": 86.5026092529297,
    "a": 9.39820098876953,
    "b": 36.4481735229492,
    "C": 37.6403427124023,
    "h": 75.5411758422852,
    "CMY_C": 0,
    "CMY_M": 0.18217790126801,
    "CMY_Y": 0.42564225196838,
    "CMYK_C": 0,
    "CMYK_M": 0.18217790126801,
    "CMYK_Y": 0.42564225196838,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08905",
    "Farbtonhilfsbezeichnung": "F1.68.69",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "173",
    "Bcolor": "41",
    "Y": 51.5051345825195,
    "L": 76.9839859008789,
    "a": 20.8098049163818,
    "b": 72.607795715332,
    "C": 75.5310516357422,
    "h": 74.0073928833008,
    "CMY_C": 0,
    "CMY_M": 0.32063680887222,
    "CMY_Y": 0.83889943361282,
    "CMYK_C": 0,
    "CMYK_M": 0.32063680887222,
    "CMYK_Y": 0.83889943361282,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08906",
    "Farbtonhilfsbezeichnung": "E9.61.53",
    "Farbtonklasse": "03",
    "Rcolor": "200",
    "Gcolor": "134",
    "Bcolor": "51",
    "Y": 29.4901313781738,
    "L": 61.2117767333984,
    "a": 18.8007793426514,
    "b": 52.3106422424316,
    "C": 55.5866241455078,
    "h": 70.2312393188477,
    "CMY_C": 0.21431797742844,
    "CMY_M": 0.47627902030945,
    "CMY_Y": 0.80023962259293,
    "CMYK_C": 0,
    "CMYK_M": 0.33341866731644,
    "CMYK_Y": 0.74574905633926,
    "CMYK_K": 0.21431797742844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08907",
    "Farbtonhilfsbezeichnung": "F2.17.83",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "221",
    "Bcolor": "178",
    "Y": 75.918083190918,
    "L": 89.8212966918945,
    "a": 5.53651762008667,
    "b": 24.6679306030273,
    "C": 25.2816104888916,
    "h": 77.3500518798828,
    "CMY_C": 0.00493729114532,
    "CMY_M": 0.13345271348953,
    "CMY_Y": 0.3030914068222,
    "CMYK_C": 0,
    "CMYK_M": 0.12915308773518,
    "CMYK_Y": 0.29963350296021,
    "CMYK_K": 0.00493729114532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08908",
    "Farbtonhilfsbezeichnung": "F0.27.75",
    "Farbtonklasse": "02",
    "Rcolor": "244",
    "Gcolor": "196",
    "Bcolor": "137",
    "Y": 60.5889511108398,
    "L": 82.1572723388672,
    "a": 9.8215446472168,
    "b": 35.480884552002,
    "C": 36.8151588439941,
    "h": 74.5272598266602,
    "CMY_C": 0.0439920425415,
    "CMY_M": 0.23038840293884,
    "CMY_Y": 0.46295940876007,
    "CMYK_C": 0,
    "CMYK_M": 0.19497364759445,
    "CMYK_Y": 0.43824672698975,
    "CMYK_K": 0.0439920425415
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08909",
    "Farbtonhilfsbezeichnung": "E9.36.74",
    "Farbtonklasse": "02",
    "Rcolor": "251",
    "Gcolor": "190",
    "Bcolor": "116",
    "Y": 58.4050064086914,
    "L": 80.9634399414063,
    "a": 14.1898574829102,
    "b": 44.9309196472168,
    "C": 47.1183586120605,
    "h": 72.4730987548828,
    "CMY_C": 0.01620531082153,
    "CMY_M": 0.25634914636612,
    "CMY_Y": 0.5459361076355,
    "CMYK_C": 0,
    "CMYK_M": 0.24409954249859,
    "CMYK_Y": 0.5384566783905,
    "CMYK_K": 0.01620531082153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08910",
    "Farbtonhilfsbezeichnung": "E8.56.62",
    "Farbtonklasse": "03",
    "Rcolor": "230",
    "Gcolor": "156",
    "Bcolor": "58",
    "Y": 40.9472885131836,
    "L": 70.1389770507813,
    "a": 19.4999256134033,
    "b": 59.4571380615234,
    "C": 62.5731430053711,
    "h": 71.8422622680664,
    "CMY_C": 0.09858399629593,
    "CMY_M": 0.3874124288559,
    "CMY_Y": 0.77390658855438,
    "CMYK_C": 0,
    "CMYK_M": 0.32041636109352,
    "CMYK_Y": 0.7491797208786,
    "CMYK_K": 0.09858399629593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08911",
    "Farbtonhilfsbezeichnung": "E8.58.54",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "138",
    "Bcolor": "52",
    "Y": 31.1475219726563,
    "L": 62.6319770812988,
    "a": 17.7265586853027,
    "b": 53.4980278015137,
    "C": 56.3584060668945,
    "h": 71.6673965454102,
    "CMY_C": 0.20263946056366,
    "CMY_M": 0.459039747715,
    "CMY_Y": 0.79711872339249,
    "CMYK_C": 0,
    "CMYK_M": 0.32156130671501,
    "CMYK_Y": 0.74555891752243,
    "CMYK_K": 0.20263946056366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08912",
    "Farbtonhilfsbezeichnung": "F5.12.84",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "226",
    "Bcolor": "192",
    "Y": 78.2849578857422,
    "L": 90.909782409668,
    "a": 2.2077054977417,
    "b": 18.5729961395264,
    "C": 18.7037467956543,
    "h": 83.2212677001953,
    "CMY_C": 0.03048729896545,
    "CMY_M": 0.11178690195084,
    "CMY_Y": 0.24656760692596,
    "CMYK_C": 0,
    "CMYK_M": 0.08385615050793,
    "CMYK_Y": 0.2228751629591,
    "CMYK_K": 0.03048729896545
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08913",
    "Farbtonhilfsbezeichnung": "F6.19.85",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "223",
    "Bcolor": "169",
    "Y": 76.4845199584961,
    "L": 90.0838241577148,
    "a": 2.95238065719604,
    "b": 29.3994865417481,
    "C": 29.5473575592041,
    "h": 84.2654190063477,
    "CMY_C": 0.00967168807983,
    "CMY_M": 0.12516587972641,
    "CMY_Y": 0.33634638786316,
    "CMYK_C": 0,
    "CMYK_M": 0.11662212759256,
    "CMYK_Y": 0.32986503839493,
    "CMYK_K": 0.00967168807983
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08914",
    "Farbtonhilfsbezeichnung": "F4.34.79",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "206",
    "Bcolor": "128",
    "Y": 67.0154190063477,
    "L": 85.5117340087891,
    "a": 8.17650890350342,
    "b": 44.5305709838867,
    "C": 45.275016784668,
    "h": 79.5954971313477,
    "CMY_C": 0.00094306468964,
    "CMY_M": 0.19130903482437,
    "CMY_Y": 0.49819606542587,
    "CMYK_C": 0,
    "CMYK_M": 0.19054566323757,
    "CMYK_Y": 0.49772238731384,
    "CMYK_K": 0.00094306468964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08915",
    "Farbtonhilfsbezeichnung": "F1.45.74",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "188",
    "Bcolor": "91",
    "Y": 57.4347496032715,
    "L": 80.4235000610352,
    "a": 14.2162065505981,
    "b": 56.3422164916992,
    "C": 58.1080551147461,
    "h": 75.8387832641602,
    "CMY_C": 0.00869911909103,
    "CMY_M": 0.26390027999878,
    "CMY_Y": 0.64316374063492,
    "CMYK_C": 0,
    "CMYK_M": 0.25744065642357,
    "CMYK_Y": 0.640032351017,
    "CMYK_K": 0.00869911909103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08916",
    "Farbtonhilfsbezeichnung": "F1.67.59",
    "Farbtonklasse": "03",
    "Rcolor": "217",
    "Gcolor": "150",
    "Bcolor": "37",
    "Y": 36.5792922973633,
    "L": 66.9601898193359,
    "a": 16.5653438568115,
    "b": 63.5351333618164,
    "C": 65.6591491699219,
    "h": 75.3867568969727,
    "CMY_C": 0.15030080080032,
    "CMY_M": 0.41260725259781,
    "CMY_Y": 0.85381501913071,
    "CMYK_C": 0,
    "CMYK_M": 0.30870506167412,
    "CMYK_Y": 0.82795679569244,
    "CMYK_K": 0.15030080080032
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08917",
    "Farbtonhilfsbezeichnung": "F1.55.50",
    "Farbtonklasse": "03",
    "Rcolor": "182",
    "Gcolor": "131",
    "Bcolor": "54",
    "Y": 26.2792797088623,
    "L": 58.3011932373047,
    "a": 12.3615751266479,
    "b": 47.4565391540527,
    "C": 49.0401039123535,
    "h": 75.3999176025391,
    "CMY_C": 0.28782665729523,
    "CMY_M": 0.48789912462234,
    "CMY_Y": 0.78999465703964,
    "CMYK_C": 0,
    "CMYK_M": 0.2809322476387,
    "CMYK_Y": 0.70512044429779,
    "CMYK_K": 0.28782665729523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08918",
    "Farbtonhilfsbezeichnung": "F3.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "226",
    "Bcolor": "208",
    "Y": 77.3126983642578,
    "L": 90.4653472900391,
    "a": 1.7723468542099,
    "b": 9.3194637298584,
    "C": 9.486496925354,
    "h": 79.2322540283203,
    "CMY_C": 0.06388032436371,
    "CMY_M": 0.11337488889694,
    "CMY_Y": 0.18269431591034,
    "CMYK_C": 0,
    "CMYK_M": 0.05287204682827,
    "CMYK_Y": 0.12692180275917,
    "CMYK_K": 0.06388032436371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08919",
    "Farbtonhilfsbezeichnung": "F0.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "212",
    "Bcolor": "188",
    "Y": 67.9273223876953,
    "L": 85.9700927734375,
    "a": 3.91163682937622,
    "b": 13.8556852340698,
    "C": 14.3972539901733,
    "h": 74.2349472045898,
    "CMY_C": 0.0862095952034,
    "CMY_M": 0.16938692331314,
    "CMY_Y": 0.26429706811905,
    "CMYK_C": 0,
    "CMYK_M": 0.091024518013,
    "CMYK_Y": 0.19488875567913,
    "CMYK_K": 0.0862095952034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08920",
    "Farbtonhilfsbezeichnung": "F0.12.77",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "204",
    "Bcolor": "176",
    "Y": 62.8388328552246,
    "L": 83.3575057983398,
    "a": 4.14485740661621,
    "b": 16.4074859619141,
    "C": 16.9229259490967,
    "h": 75.8225631713867,
    "CMY_C": 0.10743594169617,
    "CMY_M": 0.19916492700577,
    "CMY_Y": 0.31071180105209,
    "CMYK_C": 0,
    "CMYK_M": 0.10277020186186,
    "CMYK_Y": 0.22774371504784,
    "CMYK_K": 0.10743594169617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08921",
    "Farbtonhilfsbezeichnung": "E8.29.46",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "123",
    "Bcolor": "87",
    "Y": 22.1839466094971,
    "L": 54.2216339111328,
    "a": 8.54586791992188,
    "b": 24.4249496459961,
    "C": 25.876823425293,
    "h": 70.7159423828125,
    "CMY_C": 0.38231241703033,
    "CMY_M": 0.51590728759766,
    "CMY_Y": 0.65854668617249,
    "CMYK_C": 0,
    "CMYK_M": 0.21628226339817,
    "CMYK_Y": 0.44720709323883,
    "CMYK_K": 0.38231241703033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08922",
    "Farbtonhilfsbezeichnung": "F1.40.32",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "95",
    "Bcolor": "63",
    "Y": 12.6156587600708,
    "L": 42.1783332824707,
    "a": 6.94278717041016,
    "b": 21.9449863433838,
    "C": 23.017053604126,
    "h": 72.4440689086914,
    "CMY_C": 0.52159559726715,
    "CMY_M": 0.62885046005249,
    "CMY_Y": 0.75291323661804,
    "CMYK_C": 0,
    "CMYK_M": 0.22419288754463,
    "CMYK_Y": 0.4835190474987,
    "CMYK_K": 0.52159559726715
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08923",
    "Farbtonhilfsbezeichnung": "F8.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "236",
    "Bcolor": "212",
    "Y": 84.4907989501953,
    "L": 93.6632537841797,
    "a": 0.19965173304081,
    "b": 11.8856992721558,
    "C": 11.887375831604,
    "h": 89.0376586914063,
    "CMY_C": 0.03216046094894,
    "CMY_M": 0.07455408573151,
    "CMY_Y": 0.1671496629715,
    "CMYK_C": 0,
    "CMYK_M": 0.04380232840776,
    "CMYK_Y": 0.13947477936745,
    "CMYK_K": 0.03216046094894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08924",
    "Farbtonhilfsbezeichnung": "F6.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "220",
    "Bcolor": "187",
    "Y": 73.34912109375,
    "L": 88.6139526367188,
    "a": 1.79117560386658,
    "b": 18.1568565368652,
    "C": 18.2449932098389,
    "h": 84.3659973144531,
    "CMY_C": 0.06061863899231,
    "CMY_M": 0.13614213466644,
    "CMY_Y": 0.26814496517181,
    "CMYK_C": 0,
    "CMYK_M": 0.08039705455303,
    "CMYK_Y": 0.22091807425022,
    "CMYK_K": 0.06061863899231
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08925",
    "Farbtonhilfsbezeichnung": "F6.14.78",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "210",
    "Bcolor": "174",
    "Y": 65.8323593139648,
    "L": 84.9108352661133,
    "a": 1.68673741817474,
    "b": 19.7518138885498,
    "C": 19.8237037658691,
    "h": 85.1189804077148,
    "CMY_C": 0.09922313690186,
    "CMY_M": 0.1770321726799,
    "CMY_Y": 0.31927865743637,
    "CMYK_C": 0,
    "CMYK_M": 0.08637992292643,
    "CMYK_Y": 0.24429526925087,
    "CMYK_K": 0.09922313690186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08926",
    "Farbtonhilfsbezeichnung": "F6.18.74",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "198",
    "Bcolor": "156",
    "Y": 58.3486022949219,
    "L": 80.9322128295898,
    "a": 2.82478833198547,
    "b": 23.3731555938721,
    "C": 23.54323387146,
    "h": 83.1088714599609,
    "CMY_C": 0.12768232822418,
    "CMY_M": 0.2239111661911,
    "CMY_Y": 0.38730788230896,
    "CMYK_C": 0,
    "CMYK_M": 0.11031398177147,
    "CMYK_Y": 0.29762730002403,
    "CMYK_K": 0.12768232822418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08927",
    "Farbtonhilfsbezeichnung": "F3.20.67",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "180",
    "Bcolor": "139",
    "Y": 47.751106262207,
    "L": 74.6676712036133,
    "a": 3.89995694160461,
    "b": 23.6140251159668,
    "C": 23.9339065551758,
    "h": 80.6220092773438,
    "CMY_C": 0.18986415863037,
    "CMY_M": 0.29384118318558,
    "CMY_Y": 0.45320969820023,
    "CMYK_C": 0,
    "CMYK_M": 0.12834517657757,
    "CMYK_Y": 0.32506343722343,
    "CMYK_K": 0.18986415863037
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08928",
    "Farbtonhilfsbezeichnung": "F3.24.57",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "156",
    "Bcolor": "114",
    "Y": 34.8568229675293,
    "L": 65.6370391845703,
    "a": 4.26193332672119,
    "b": 24.8189449310303,
    "C": 25.1822185516357,
    "h": 80.2561492919922,
    "CMY_C": 0.28454524278641,
    "CMY_M": 0.38983577489853,
    "CMY_Y": 0.55215835571289,
    "CMYK_C": 0,
    "CMYK_M": 0.1471658796072,
    "CMYK_Y": 0.37404617667198,
    "CMYK_K": 0.28454524278641
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08929",
    "Farbtonhilfsbezeichnung": "F4.28.47",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "130",
    "Bcolor": "91",
    "Y": 23.700309753418,
    "L": 55.7864837646484,
    "a": 4.09385919570923,
    "b": 23.919340133667,
    "C": 24.2671489715576,
    "h": 80.2877807617188,
    "CMY_C": 0.39317804574966,
    "CMY_M": 0.4897626042366,
    "CMY_Y": 0.6411834359169,
    "CMYK_C": 0,
    "CMYK_M": 0.15916457772255,
    "CMYK_Y": 0.40869548916817,
    "CMYK_K": 0.39317804574966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08930",
    "Farbtonhilfsbezeichnung": "F6.08.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "234",
    "Bcolor": "210",
    "Y": 83.5286178588867,
    "L": 93.2453842163086,
    "a": 1.03962528705597,
    "b": 12.6491889953613,
    "C": 12.691840171814,
    "h": 85.3014755249023,
    "CMY_C": 0.02838641405106,
    "CMY_M": 0.08145141601563,
    "CMY_Y": 0.177281498909,
    "CMYK_C": 0,
    "CMYK_M": 0.05461533367634,
    "CMYK_Y": 0.1532451659441,
    "CMYK_K": 0.02838641405106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08931",
    "Farbtonhilfsbezeichnung": "F7.10.86",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "232",
    "Bcolor": "203",
    "Y": 82.3970108032227,
    "L": 92.7498016357422,
    "a": 1.55344486236572,
    "b": 15.4317064285278,
    "C": 15.5096988677979,
    "h": 84.2516403198242,
    "CMY_C": 0.02251482009888,
    "CMY_M": 0.08893179893494,
    "CMY_Y": 0.2033703327179,
    "CMYK_C": 0,
    "CMYK_M": 0.06794679164886,
    "CMYK_Y": 0.18502123653889,
    "CMYK_K": 0.02251482009888
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08932",
    "Farbtonhilfsbezeichnung": "F3.25.77",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "203",
    "Bcolor": "145",
    "Y": 63.3421669006348,
    "L": 83.6220855712891,
    "a": 6.01804399490356,
    "b": 33.0396385192871,
    "C": 33.5832481384277,
    "h": 79.6769638061523,
    "CMY_C": 0.05619215965271,
    "CMY_M": 0.20442914962769,
    "CMY_Y": 0.43046456575394,
    "CMYK_C": 0,
    "CMYK_M": 0.15706267952919,
    "CMYK_Y": 0.3965557217598,
    "CMYK_K": 0.05619215965271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08933",
    "Farbtonhilfsbezeichnung": "F1.34.58",
    "Farbtonklasse": "03",
    "Rcolor": "192",
    "Gcolor": "151",
    "Bcolor": "94",
    "Y": 34.3359069824219,
    "L": 65.2283248901367,
    "a": 8.55020332336426,
    "b": 35.1954154968262,
    "C": 36.2191009521484,
    "h": 76.3453598022461,
    "CMY_C": 0.24570560455322,
    "CMY_M": 0.40616744756699,
    "CMY_Y": 0.62987357378006,
    "CMYK_C": 0,
    "CMYK_M": 0.21273104846478,
    "CMYK_Y": 0.50930774211884,
    "CMYK_K": 0.24570560455322
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08934",
    "Farbtonhilfsbezeichnung": "F4.49.46",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "124",
    "Bcolor": "57",
    "Y": 22.3920745849609,
    "L": 54.4405479431152,
    "a": 7.41090965270996,
    "b": 40.9679107666016,
    "C": 41.6328163146973,
    "h": 79.746337890625,
    "CMY_C": 0.3653262257576,
    "CMY_M": 0.5134516954422,
    "CMY_Y": 0.77640056610107,
    "CMYK_C": 0,
    "CMYK_M": 0.23338836431503,
    "CMYK_Y": 0.64769393205643,
    "CMYK_K": 0.3653262257576
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08935",
    "Farbtonhilfsbezeichnung": "F7.05.88",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "235",
    "Bcolor": "216",
    "Y": 83.60107421875,
    "L": 93.2769622802734,
    "a": 0.60853892564774,
    "b": 9.26201725006104,
    "C": 9.28198719024658,
    "h": 86.2409210205078,
    "CMY_C": 0.04114425182343,
    "CMY_M": 0.07918441295624,
    "CMY_Y": 0.15172803401947,
    "CMYK_C": 0,
    "CMYK_M": 0.03967245295644,
    "CMYK_Y": 0.11532890051603,
    "CMYK_K": 0.04114425182343
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08936",
    "Farbtonhilfsbezeichnung": "F3.10.83",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "222",
    "Bcolor": "195",
    "Y": 75.0113754272461,
    "L": 89.398323059082,
    "a": 2.37061715126038,
    "b": 14.9487991333008,
    "C": 15.1356010437012,
    "h": 80.9889373779297,
    "CMY_C": 0.05582767724991,
    "CMY_M": 0.12808966636658,
    "CMY_Y": 0.23585277795792,
    "CMYK_C": 0,
    "CMYK_M": 0.07653474807739,
    "CMYK_Y": 0.19066974520683,
    "CMYK_K": 0.05582767724991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08937",
    "Farbtonhilfsbezeichnung": "F3.17.76",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "203",
    "Bcolor": "163",
    "Y": 62.3273315429688,
    "L": 83.0871887207031,
    "a": 4.00695705413818,
    "b": 23.0504169464111,
    "C": 23.3960990905762,
    "h": 80.1385650634766,
    "CMY_C": 0.09597331285477,
    "CMY_M": 0.20327883958817,
    "CMY_Y": 0.36228799819946,
    "CMYK_C": 0,
    "CMYK_M": 0.11869730055332,
    "CMYK_Y": 0.29458719491959,
    "CMYK_K": 0.09597331285477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08938",
    "Farbtonhilfsbezeichnung": "F0.25.69",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "180",
    "Bcolor": "130",
    "Y": 49.4542770385742,
    "L": 75.7330703735352,
    "a": 7.91899394989014,
    "b": 30.0740604400635,
    "C": 31.0991897583008,
    "h": 75.2479400634766,
    "CMY_C": 0.13931542634964,
    "CMY_M": 0.29355853796005,
    "CMY_Y": 0.48858577013016,
    "CMYK_C": 0,
    "CMYK_M": 0.17920979857445,
    "CMYK_Y": 0.40580528974533,
    "CMYK_K": 0.13931542634964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08939",
    "Farbtonhilfsbezeichnung": "E8.34.50",
    "Farbtonklasse": "03",
    "Rcolor": "174",
    "Gcolor": "132",
    "Bcolor": "84",
    "Y": 25.9598960876465,
    "L": 57.9989624023438,
    "a": 10.6064929962158,
    "b": 31.0413589477539,
    "C": 32.803409576416,
    "h": 71.1352691650391,
    "CMY_C": 0.3195766210556,
    "CMY_M": 0.4842586517334,
    "CMY_Y": 0.66863656044006,
    "CMYK_C": 0,
    "CMYK_M": 0.24202877283096,
    "CMYK_Y": 0.51300406455994,
    "CMYK_K": 0.3195766210556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08940",
    "Farbtonhilfsbezeichnung": "F3.12.83",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "221",
    "Bcolor": "189",
    "Y": 75.0467071533203,
    "L": 89.4148712158203,
    "a": 3.55265641212463,
    "b": 17.9161891937256,
    "C": 18.2650260925293,
    "h": 78.7841339111328,
    "CMY_C": 0.03946286439896,
    "CMY_M": 0.13150066137314,
    "CMY_Y": 0.25748580694199,
    "CMYK_C": 0,
    "CMYK_M": 0.09581909328699,
    "CMYK_Y": 0.22698023915291,
    "CMYK_K": 0.03946286439896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08941",
    "Farbtonhilfsbezeichnung": "F1.60.49",
    "Farbtonklasse": "04",
    "Rcolor": "178",
    "Gcolor": "129",
    "Bcolor": "49",
    "Y": 25.3334484100342,
    "L": 57.3988761901855,
    "a": 11.7097387313843,
    "b": 48.3215713500977,
    "C": 49.7201385498047,
    "h": 76.3781433105469,
    "CMY_C": 0.30099010467529,
    "CMY_M": 0.49537980556488,
    "CMY_Y": 0.80651265382767,
    "CMYK_C": 0,
    "CMYK_M": 0.27809292078018,
    "CMYK_Y": 0.72319799661636,
    "CMYK_K": 0.30099010467529
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08942",
    "Farbtonhilfsbezeichnung": "G0.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "237",
    "Bcolor": "216",
    "Y": 85.6738510131836,
    "L": 94.172721862793,
    "a": 0.32315653562546,
    "b": 10.6444282531738,
    "C": 10.6493320465088,
    "h": 88.2610778808594,
    "CMY_C": 0.02907437086105,
    "CMY_M": 0.06881803274155,
    "CMY_Y": 0.15227419137955,
    "CMYK_C": 0,
    "CMYK_M": 0.04093378409743,
    "CMYK_Y": 0.12688903510571,
    "CMYK_K": 0.02907437086105
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08943",
    "Farbtonhilfsbezeichnung": "F3.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "214",
    "Bcolor": "175",
    "Y": 69.7344589233398,
    "L": 86.8664627075195,
    "a": 3.58460474014282,
    "b": 21.8733882904053,
    "C": 22.1651649475098,
    "h": 80.693115234375,
    "CMY_C": 0.0587100982666,
    "CMY_M": 0.16061866283417,
    "CMY_Y": 0.31395661830902,
    "CMYK_C": 0,
    "CMYK_M": 0.10826480388641,
    "CMYK_Y": 0.27116674184799,
    "CMYK_K": 0.0587100982666
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08944",
    "Farbtonhilfsbezeichnung": "F2.32.74",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "193",
    "Bcolor": "121",
    "Y": 58.4662094116211,
    "L": 80.9972991943359,
    "a": 8.7294397354126,
    "b": 42.3624114990234,
    "C": 43.2524795532227,
    "h": 78.3562927246094,
    "CMY_C": 0.05365425348282,
    "CMY_M": 0.2413392663002,
    "CMY_Y": 0.52728426456451,
    "CMYK_C": 0,
    "CMYK_M": 0.1983260512352,
    "CMYK_Y": 0.50048303604126,
    "CMYK_K": 0.05365425348282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08945",
    "Farbtonhilfsbezeichnung": "F1.44.66",
    "Farbtonklasse": "03",
    "Rcolor": "231",
    "Gcolor": "172",
    "Bcolor": "87",
    "Y": 47.1638641357422,
    "L": 74.2944641113281,
    "a": 13.2596101760864,
    "b": 50.6419486999512,
    "C": 52.3490600585938,
    "h": 75.3275909423828,
    "CMY_C": 0.09377485513687,
    "CMY_M": 0.32582741975784,
    "CMY_Y": 0.65826833248138,
    "CMYK_C": 0,
    "CMYK_M": 0.25606501102448,
    "CMYK_Y": 0.62290644645691,
    "CMYK_K": 0.09377485513687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08946",
    "Farbtonhilfsbezeichnung": "F1.50.55",
    "Farbtonklasse": "04",
    "Rcolor": "198",
    "Gcolor": "143",
    "Bcolor": "64",
    "Y": 32.1016654968262,
    "L": 63.426815032959,
    "a": 13.1069612503052,
    "b": 48.7768783569336,
    "C": 50.5071907043457,
    "h": 74.9591979980469,
    "CMY_C": 0.22354900836945,
    "CMY_M": 0.43807303905487,
    "CMY_Y": 0.75056123733521,
    "CMYK_C": 0,
    "CMYK_M": 0.27628791332245,
    "CMYK_Y": 0.67874497175217,
    "CMYK_K": 0.22354900836945
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08947",
    "Farbtonhilfsbezeichnung": "F9.12.87",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "198",
    "Y": 81.7023391723633,
    "L": 92.4433212280273,
    "a": 0.34896838665009,
    "b": 17.7030353546143,
    "C": 17.7064743041992,
    "h": 88.8707122802734,
    "CMY_C": 0.02885311841965,
    "CMY_M": 0.08999818563461,
    "CMY_Y": 0.22386944293976,
    "CMYK_C": 0,
    "CMYK_M": 0.06296171247959,
    "CMYK_Y": 0.20081032812595,
    "CMYK_K": 0.02885311841965
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08948",
    "Farbtonhilfsbezeichnung": "F8.18.86",
    "Farbtonklasse": "01",
    "Rcolor": "252",
    "Gcolor": "229",
    "Bcolor": "181",
    "Y": 80.3021087646484,
    "L": 91.8202438354492,
    "a": 0.92067766189575,
    "b": 25.6198196411133,
    "C": 25.6363563537598,
    "h": 87.94189453125,
    "CMY_C": 0.01233369112015,
    "CMY_M": 0.10012811422348,
    "CMY_Y": 0.28984987735748,
    "CMYK_C": 0,
    "CMYK_M": 0.08889077603817,
    "CMYK_Y": 0.28098171949387,
    "CMYK_K": 0.01233369112015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08949",
    "Farbtonhilfsbezeichnung": "F6.11.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "230",
    "Bcolor": "201",
    "Y": 80.6721115112305,
    "L": 91.9855880737305,
    "a": 1.05110609531403,
    "b": 15.4425888061523,
    "C": 15.4783191680908,
    "h": 86.1061477661133,
    "CMY_C": 0.03488457202911,
    "CMY_M": 0.09625220298767,
    "CMY_Y": 0.21181613206863,
    "CMYK_C": 0,
    "CMYK_M": 0.06358579546213,
    "CMYK_Y": 0.1833268404007,
    "CMYK_K": 0.03488457202911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08950",
    "Farbtonhilfsbezeichnung": "F5.18.84",
    "Farbtonklasse": "01",
    "Rcolor": "251",
    "Gcolor": "223",
    "Bcolor": "177",
    "Y": 76.7396011352539,
    "L": 90.2016296386719,
    "a": 3.29572916030884,
    "b": 25.7388172149658,
    "C": 25.9489612579346,
    "h": 82.7032623291016,
    "CMY_C": 0.0138396024704,
    "CMY_M": 0.12392783164978,
    "CMY_Y": 0.30750405788422,
    "CMYK_C": 0,
    "CMYK_M": 0.11163318902254,
    "CMYK_Y": 0.29778569936752,
    "CMYK_K": 0.0138396024704
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08951",
    "Farbtonhilfsbezeichnung": "F3.64.74",
    "Farbtonklasse": "03",
    "Rcolor": "255",
    "Gcolor": "187",
    "Bcolor": "39",
    "Y": 58.5424346923828,
    "L": 81.039436340332,
    "a": 16.3258953094482,
    "b": 76.8604125976563,
    "C": 78.5751724243164,
    "h": 78.008056640625,
    "CMY_C": 0,
    "CMY_M": 0.26529407501221,
    "CMY_Y": 0.84760183095932,
    "CMYK_C": 0,
    "CMYK_M": 0.26529407501221,
    "CMYK_Y": 0.84760183095932,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08952",
    "Farbtonhilfsbezeichnung": "F2.64.70",
    "Farbtonklasse": "04",
    "Rcolor": "252",
    "Gcolor": "177",
    "Bcolor": "39",
    "Y": 52.3662376403809,
    "L": 77.4993209838867,
    "a": 17.0344963073731,
    "b": 73.3789825439453,
    "C": 75.3302688598633,
    "h": 76.9306106567383,
    "CMY_C": 0.01267611980438,
    "CMY_M": 0.30464953184128,
    "CMY_Y": 0.84602761268616,
    "CMYK_C": 0,
    "CMYK_M": 0.29572200775146,
    "CMYK_Y": 0.84405076503754,
    "CMYK_K": 0.01267611980438
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08953",
    "Farbtonhilfsbezeichnung": "F6.22.83",
    "Farbtonklasse": "01",
    "Rcolor": "253",
    "Gcolor": "220",
    "Bcolor": "163",
    "Y": 74.9120254516602,
    "L": 89.3517684936523,
    "a": 3.61345386505127,
    "b": 31.6705837249756,
    "C": 31.8760547637939,
    "h": 83.4909896850586,
    "CMY_C": 0.00889265537262,
    "CMY_M": 0.13535362482071,
    "CMY_Y": 0.36106151342392,
    "CMYK_C": 0,
    "CMYK_M": 0.12759563326836,
    "CMYK_Y": 0.35532867908478,
    "CMYK_K": 0.00889265537262
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08954",
    "Farbtonhilfsbezeichnung": "F4.36.81",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "211",
    "Bcolor": "121",
    "Y": 70.1628723144531,
    "L": 87.0766830444336,
    "a": 7.74578094482422,
    "b": 49.8220024108887,
    "C": 50.4205207824707,
    "h": 81.1630249023438,
    "CMY_C": 0,
    "CMY_M": 0.1739496588707,
    "CMY_Y": 0.52399909496307,
    "CMYK_C": 0,
    "CMYK_M": 0.1739496588707,
    "CMYK_Y": 0.52399909496307,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08955",
    "Farbtonhilfsbezeichnung": "F1.57.62",
    "Farbtonklasse": "03",
    "Rcolor": "222",
    "Gcolor": "159",
    "Bcolor": "54",
    "Y": 40.5844535827637,
    "L": 69.8837966918945,
    "a": 14.7734651565552,
    "b": 60.2517051696777,
    "C": 62.0364685058594,
    "h": 76.2231140136719,
    "CMY_C": 0.12802278995514,
    "CMY_M": 0.37721186876297,
    "CMY_Y": 0.78686159849167,
    "CMYK_C": 0,
    "CMYK_M": 0.28577476739883,
    "CMYK_Y": 0.75556886196136,
    "CMYK_K": 0.12802278995514
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08956",
    "Farbtonhilfsbezeichnung": "F1.64.54",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "139",
    "Bcolor": "48",
    "Y": 30.7069473266602,
    "L": 62.2594604492188,
    "a": 14.4907274246216,
    "b": 54.2987518310547,
    "C": 56.1990699768066,
    "h": 75.0576858520508,
    "CMY_C": 0.22442489862442,
    "CMY_M": 0.45420652627945,
    "CMY_Y": 0.80999231338501,
    "CMYK_C": 0,
    "CMYK_M": 0.29627257585526,
    "CMYK_Y": 0.7550106048584,
    "CMYK_K": 0.22442489862442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08957",
    "Farbtonhilfsbezeichnung": "F9.17.86",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "226",
    "Bcolor": "179",
    "Y": 77.7697143554688,
    "L": 90.6747131347656,
    "a": 1.19811844825745,
    "b": 25.212272644043,
    "C": 25.2407245635986,
    "h": 87.2792816162109,
    "CMY_C": 0.02442753314972,
    "CMY_M": 0.11345601081848,
    "CMY_Y": 0.29892736673355,
    "CMYK_C": 0,
    "CMYK_M": 0.0912576764822,
    "CMYK_Y": 0.28137308359146,
    "CMYK_K": 0.02442753314972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08958",
    "Farbtonhilfsbezeichnung": "F3.42.73",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "189",
    "Bcolor": "95",
    "Y": 56.3023147583008,
    "L": 79.7855682373047,
    "a": 9.4815616607666,
    "b": 53.2874870300293,
    "C": 54.1244506835938,
    "h": 79.9108200073242,
    "CMY_C": 0.04872876405716,
    "CMY_M": 0.25793427228928,
    "CMY_Y": 0.62593579292297,
    "CMYK_C": 0,
    "CMYK_M": 0.21992203593254,
    "CMYK_Y": 0.6067743897438,
    "CMYK_K": 0.04872876405716
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08959",
    "Farbtonhilfsbezeichnung": "F4.54.66",
    "Farbtonklasse": "02",
    "Rcolor": "226",
    "Gcolor": "172",
    "Bcolor": "63",
    "Y": 45.7985992431641,
    "L": 73.4146575927734,
    "a": 9.76229763031006,
    "b": 60.2641525268555,
    "C": 61.0497398376465,
    "h": 80.7984848022461,
    "CMY_C": 0.11533284187317,
    "CMY_M": 0.32722222805023,
    "CMY_Y": 0.75215035676956,
    "CMYK_C": 0,
    "CMYK_M": 0.23951311409473,
    "CMYK_Y": 0.71983855962753,
    "CMYK_K": 0.11533284187317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08960",
    "Farbtonhilfsbezeichnung": "F4.63.56",
    "Farbtonklasse": "03",
    "Rcolor": "199",
    "Gcolor": "148",
    "Bcolor": "38",
    "Y": 33.5358810424805,
    "L": 64.5924911499023,
    "a": 9.49550151824951,
    "b": 60.3232192993164,
    "C": 61.065990447998,
    "h": 81.0544509887695,
    "CMY_C": 0.22079908847809,
    "CMY_M": 0.4181741476059,
    "CMY_Y": 0.84954595565796,
    "CMYK_C": 0,
    "CMYK_M": 0.25330445170403,
    "CMYK_Y": 0.80691236257553,
    "CMYK_K": 0.22079908847809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08961",
    "Farbtonhilfsbezeichnung": "G2.12.87",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "197",
    "Y": 81.5737457275391,
    "L": 92.3863983154297,
    "a": -0.51632684469223,
    "b": 18.2248268127441,
    "C": 18.2321395874023,
    "h": 91.6228103637695,
    "CMY_C": 0.03451895713806,
    "CMY_M": 0.08868581056595,
    "CMY_Y": 0.22853583097458,
    "CMYK_C": 0,
    "CMYK_M": 0.05610348656774,
    "CMYK_Y": 0.20095358788967,
    "CMYK_K": 0.03451895713806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08962",
    "Farbtonhilfsbezeichnung": "G1.20.86",
    "Farbtonklasse": "01",
    "Rcolor": "254",
    "Gcolor": "231",
    "Bcolor": "177",
    "Y": 81.7174377441406,
    "L": 92.4500045776367,
    "a": 0.31240287423134,
    "b": 28.7475051879883,
    "C": 28.7492027282715,
    "h": 89.3773803710938,
    "CMY_C": 0.00236183404922,
    "CMY_M": 0.09230369329453,
    "CMY_Y": 0.306884765625,
    "CMYK_C": 0,
    "CMYK_M": 0.09015478938818,
    "CMYK_Y": 0.30524387955666,
    "CMYK_K": 0.00236183404922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08963",
    "Farbtonhilfsbezeichnung": "F8.31.81",
    "Farbtonklasse": "01",
    "Rcolor": "249",
    "Gcolor": "213",
    "Bcolor": "134",
    "Y": 69.3602066040039,
    "L": 86.6821136474609,
    "a": 2.81407952308655,
    "b": 42.8570251464844,
    "C": 42.9493141174316,
    "h": 86.2432327270508,
    "CMY_C": 0.02494466304779,
    "CMY_M": 0.16485679149628,
    "CMY_Y": 0.47455900907516,
    "CMYK_C": 0,
    "CMYK_M": 0.14349147677422,
    "CMYK_Y": 0.46111676096916,
    "CMYK_K": 0.02494466304779
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08964",
    "Farbtonhilfsbezeichnung": "F8.39.78",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "206",
    "Bcolor": "111",
    "Y": 65.0919342041016,
    "L": 84.5310897827148,
    "a": 3.43347239494324,
    "b": 51.6161003112793,
    "C": 51.7301712036133,
    "h": 86.1943206787109,
    "CMY_C": 0.03295987844467,
    "CMY_M": 0.19125556945801,
    "CMY_Y": 0.56588661670685,
    "CMYK_C": 0,
    "CMYK_M": 0.16369092464447,
    "CMYK_Y": 0.55109059810638,
    "CMYK_K": 0.03295987844467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08965",
    "Farbtonhilfsbezeichnung": "F6.48.68",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "179",
    "Bcolor": "75",
    "Y": 48.1050491333008,
    "L": 74.8911361694336,
    "a": 5.2138843536377,
    "b": 56.4481506347656,
    "C": 56.6884307861328,
    "h": 84.7228012084961,
    "CMY_C": 0.12916523218155,
    "CMY_M": 0.29986429214478,
    "CMY_Y": 0.70418238639832,
    "CMYK_C": 0,
    "CMYK_M": 0.19601774215698,
    "CMYK_Y": 0.66030567884445,
    "CMYK_K": 0.12916523218155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08966",
    "Farbtonhilfsbezeichnung": "F6.58.62",
    "Farbtonklasse": "03",
    "Rcolor": "207",
    "Gcolor": "164",
    "Bcolor": "52",
    "Y": 39.9433326721191,
    "L": 69.4291458129883,
    "a": 5.61618804931641,
    "b": 60.0847244262695,
    "C": 60.3466300964355,
    "h": 84.6600112915039,
    "CMY_C": 0.18712019920349,
    "CMY_M": 0.35863971710205,
    "CMY_Y": 0.79520976543427,
    "CMYK_C": 0,
    "CMYK_M": 0.21100232005119,
    "CMYK_Y": 0.74806827306747,
    "CMYK_K": 0.18712019920349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08967",
    "Farbtonhilfsbezeichnung": "F6.45.56",
    "Farbtonklasse": "03",
    "Rcolor": "185",
    "Gcolor": "150",
    "Bcolor": "73",
    "Y": 32.7019958496094,
    "L": 63.918888092041,
    "a": 4.53407526016235,
    "b": 44.2150955200195,
    "C": 44.446964263916,
    "h": 84.14501953125,
    "CMY_C": 0.27296614646912,
    "CMY_M": 0.41126298904419,
    "CMY_Y": 0.7120378613472,
    "CMYK_C": 0,
    "CMYK_M": 0.19022063910961,
    "CMYK_Y": 0.60392194986343,
    "CMYK_K": 0.27296614646912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08968",
    "Farbtonhilfsbezeichnung": "F8.10.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "232",
    "Bcolor": "201",
    "Y": 82.2001647949219,
    "L": 92.6631317138672,
    "a": 0.80444473028183,
    "b": 16.4326324462891,
    "C": 16.4523105621338,
    "h": 87.1973724365234,
    "CMY_C": 0.0263540148735,
    "CMY_M": 0.08833348751068,
    "CMY_Y": 0.21191507577896,
    "CMYK_C": 0,
    "CMYK_M": 0.06365709006786,
    "CMYK_Y": 0.1905837059021,
    "CMYK_K": 0.0263540148735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08969",
    "Farbtonhilfsbezeichnung": "F6.15.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "220",
    "Bcolor": "180",
    "Y": 73.1774826049805,
    "L": 88.5322952270508,
    "a": 2.03731727600098,
    "b": 21.3646297454834,
    "C": 21.4615478515625,
    "h": 84.5527801513672,
    "CMY_C": 0.05190712213516,
    "CMY_M": 0.13837689161301,
    "CMY_Y": 0.29279696941376,
    "CMYK_C": 0,
    "CMYK_M": 0.09120389819145,
    "CMYK_Y": 0.25407832860947,
    "CMYK_K": 0.05190712213516
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08970",
    "Farbtonhilfsbezeichnung": "F9.18.82",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "220",
    "Bcolor": "172",
    "Y": 73.0464553833008,
    "L": 88.4698638916016,
    "a": 0.76332938671112,
    "b": 25.4434909820557,
    "C": 25.4549388885498,
    "h": 88.2815856933594,
    "CMY_C": 0.05217653512955,
    "CMY_M": 0.13689625263214,
    "CMY_Y": 0.3241103887558,
    "CMYK_C": 0,
    "CMYK_M": 0.08938343822956,
    "CMYK_Y": 0.28690347075462,
    "CMYK_K": 0.05217653512955
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08971",
    "Farbtonhilfsbezeichnung": "F8.25.77",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "206",
    "Bcolor": "146",
    "Y": 63.9413414001465,
    "L": 83.9352188110352,
    "a": 1.96225953102112,
    "b": 33.1454467773438,
    "C": 33.2034797668457,
    "h": 86.6119613647461,
    "CMY_C": 0.07958680391312,
    "CMY_M": 0.1911318898201,
    "CMY_Y": 0.42891454696655,
    "CMYK_C": 0,
    "CMYK_M": 0.12119022756815,
    "CMYK_Y": 0.37953361868858,
    "CMYK_K": 0.07958680391312
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08972",
    "Farbtonhilfsbezeichnung": "F8.29.75",
    "Farbtonklasse": "02",
    "Rcolor": "231",
    "Gcolor": "201",
    "Bcolor": "133",
    "Y": 60.2975006103516,
    "L": 81.999626159668,
    "a": 2.04002261161804,
    "b": 37.0732002258301,
    "C": 37.1292877197266,
    "h": 86.8503723144531,
    "CMY_C": 0.09404438734055,
    "CMY_M": 0.21310019493103,
    "CMY_Y": 0.47840428352356,
    "CMYK_C": 0,
    "CMYK_M": 0.13141460716724,
    "CMYK_Y": 0.42425909638405,
    "CMYK_K": 0.09404438734055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08973",
    "Farbtonhilfsbezeichnung": "F6.35.68",
    "Farbtonklasse": "02",
    "Rcolor": "218",
    "Gcolor": "183",
    "Bcolor": "111",
    "Y": 49.8231048583984,
    "L": 75.9605560302734,
    "a": 4.22373723983765,
    "b": 40.4814567565918,
    "C": 40.7012062072754,
    "h": 84.0434494018555,
    "CMY_C": 0.14337903261185,
    "CMY_M": 0.28389227390289,
    "CMY_Y": 0.56480145454407,
    "CMYK_C": 0,
    "CMYK_M": 0.16403198242188,
    "CMYK_Y": 0.49195903539658,
    "CMYK_K": 0.14337903261185
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08974",
    "Farbtonhilfsbezeichnung": "G0.12.83",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "226",
    "Bcolor": "191",
    "Y": 76.4943008422852,
    "L": 90.0883483886719,
    "a": 0.06136851385236,
    "b": 17.8170223236084,
    "C": 17.8171272277832,
    "h": 89.8026504516602,
    "CMY_C": 0.05738633871078,
    "CMY_M": 0.11557114124298,
    "CMY_Y": 0.2501255273819,
    "CMYK_C": 0,
    "CMYK_M": 0.06172709539533,
    "CMYK_Y": 0.20447315275669,
    "CMYK_K": 0.05738633871078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08975",
    "Farbtonhilfsbezeichnung": "F4.67.63",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "163",
    "Bcolor": "25",
    "Y": 41.9029693603516,
    "L": 70.8039703369141,
    "a": 11.7027940750122,
    "b": 70.1806335449219,
    "C": 71.1496810913086,
    "h": 80.5328979492188,
    "CMY_C": 0.12735724449158,
    "CMY_M": 0.36049449443817,
    "CMY_Y": 0.90030634403229,
    "CMYK_C": 0,
    "CMYK_M": 0.26716229319572,
    "CMYK_Y": 0.88575661182404,
    "CMYK_K": 0.12735724449158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08976",
    "Farbtonhilfsbezeichnung": "F8.30.83",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "220",
    "Bcolor": "140",
    "Y": 74.7064361572266,
    "L": 89.2553024291992,
    "a": 2.54048609733582,
    "b": 43.3713874816895,
    "C": 43.445728302002,
    "h": 86.6477203369141,
    "CMY_C": 0,
    "CMY_M": 0.13594847917557,
    "CMY_Y": 0.45203673839569,
    "CMYK_C": 0,
    "CMYK_M": 0.13594847917557,
    "CMYK_Y": 0.45203673839569,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08977",
    "Farbtonhilfsbezeichnung": "F7.40.78",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "206",
    "Bcolor": "109",
    "Y": 65.0668487548828,
    "L": 84.5181732177734,
    "a": 4.29384183883667,
    "b": 52.6205291748047,
    "C": 52.7954292297363,
    "h": 85.3349914550781,
    "CMY_C": 0.02621215581894,
    "CMY_M": 0.19365239143372,
    "CMY_Y": 0.57393336296082,
    "CMYK_C": 0,
    "CMYK_M": 0.1719473451376,
    "CMYK_Y": 0.562464594841,
    "CMYK_K": 0.02621215581894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08978",
    "Farbtonhilfsbezeichnung": "F6.46.73",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "191",
    "Bcolor": "87",
    "Y": 56.2223129272461,
    "L": 79.7401733398438,
    "a": 5.77188396453857,
    "b": 56.860595703125,
    "C": 57.1527938842773,
    "h": 84.2037963867188,
    "CMY_C": 0.06815069913864,
    "CMY_M": 0.24954897165298,
    "CMY_Y": 0.65780866146088,
    "CMYK_C": 0,
    "CMYK_M": 0.19466482102871,
    "CMYK_Y": 0.63278251886368,
    "CMYK_K": 0.06815069913864
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08979",
    "Farbtonhilfsbezeichnung": "G0.24.86",
    "Farbtonklasse": "02",
    "Rcolor": "255",
    "Gcolor": "230",
    "Bcolor": "164",
    "Y": 80.9338684082031,
    "L": 92.1022567749023,
    "a": 0.1553226262331,
    "b": 34.907398223877,
    "C": 34.9077453613281,
    "h": 89.7450561523438,
    "CMY_C": 0,
    "CMY_M": 0.09703981876373,
    "CMY_Y": 0.35749304294586,
    "CMYK_C": 0,
    "CMYK_M": 0.09703981876373,
    "CMYK_Y": 0.35749304294586,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08981",
    "Farbtonhilfsbezeichnung": "F8.56.77",
    "Farbtonklasse": "03",
    "Rcolor": "253",
    "Gcolor": "205",
    "Bcolor": "67",
    "Y": 65.0017929077148,
    "L": 84.4846572875977,
    "a": 4.06724500656128,
    "b": 70.5132827758789,
    "C": 70.630485534668,
    "h": 86.6988067626953,
    "CMY_C": 0.00786066055298,
    "CMY_M": 0.19564342498779,
    "CMY_Y": 0.73653483390808,
    "CMYK_C": 0,
    "CMYK_M": 0.18927055597305,
    "CMYK_Y": 0.7344474196434,
    "CMYK_K": 0.00786066055298
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08982",
    "Farbtonhilfsbezeichnung": "F7.58.76",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "200",
    "Bcolor": "56",
    "Y": 61.6696701049805,
    "L": 82.7374420166016,
    "a": 5.06570339202881,
    "b": 72.5989761352539,
    "C": 72.7754974365234,
    "h": 86.0085678100586,
    "CMY_C": 0.02095156908035,
    "CMY_M": 0.21725177764893,
    "CMY_Y": 0.77936232089996,
    "CMYK_C": 0,
    "CMYK_M": 0.20050102472305,
    "CMYK_Y": 0.77464067935944,
    "CMYK_K": 0.02095156908035
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08983",
    "Farbtonhilfsbezeichnung": "F6.53.66",
    "Farbtonklasse": "03",
    "Rcolor": "219",
    "Gcolor": "172",
    "Bcolor": "67",
    "Y": 45.0038757324219,
    "L": 72.8944473266602,
    "a": 7.07307052612305,
    "b": 57.8507766723633,
    "C": 58.2815628051758,
    "h": 83.0293884277344,
    "CMY_C": 0.13986331224442,
    "CMY_M": 0.32568174600601,
    "CMY_Y": 0.73648363351822,
    "CMYK_C": 0,
    "CMYK_M": 0.21603360772133,
    "CMYK_Y": 0.69363433122635,
    "CMYK_K": 0.13986331224442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08984",
    "Farbtonhilfsbezeichnung": "F8.66.75",
    "Farbtonklasse": "03",
    "Rcolor": "249",
    "Gcolor": "199",
    "Bcolor": "30",
    "Y": 60.8377456665039,
    "L": 82.2914352416992,
    "a": 4.48048782348633,
    "b": 79.2738800048828,
    "C": 79.4003982543945,
    "h": 86.76513671875,
    "CMY_C": 0.02463513612747,
    "CMY_M": 0.22121566534042,
    "CMY_Y": 0.88185024261475,
    "CMYK_C": 0,
    "CMYK_M": 0.20154562592506,
    "CMYK_Y": 0.87886607646942,
    "CMYK_K": 0.02463513612747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08985",
    "Farbtonhilfsbezeichnung": "F7.71.77",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "202",
    "Bcolor": "0",
    "Y": 64.8614044189453,
    "L": 84.4122695922852,
    "a": 7.47303295135498,
    "b": 91.9343185424805,
    "C": 92.237548828125,
    "h": 85.3528366088867,
    "CMY_C": 0,
    "CMY_M": 0.20676869153976,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.20676869153976,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08986",
    "Farbtonhilfsbezeichnung": "F6.71.75",
    "Farbtonklasse": "04",
    "Rcolor": "255",
    "Gcolor": "196",
    "Bcolor": "0",
    "Y": 61.2192153930664,
    "L": 82.496452331543,
    "a": 9.37796783447266,
    "b": 87.6085739135742,
    "C": 88.1090698242188,
    "h": 83.8900985717773,
    "CMY_C": 0,
    "CMY_M": 0.23201823234558,
    "CMY_Y": 1,
    "CMYK_C": 0,
    "CMYK_M": 0.23201823234558,
    "CMYK_Y": 1,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08987",
    "Farbtonhilfsbezeichnung": "G4.15.86",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "188",
    "Y": 83.0286712646484,
    "L": 93.026985168457,
    "a": -2.72249889373779,
    "b": 23.42258644104,
    "C": 23.5802783966064,
    "h": 96.6299667358398,
    "CMY_C": 0.03022396564484,
    "CMY_M": 0.07748013734818,
    "CMY_Y": 0.26106786727905,
    "CMYK_C": 0,
    "CMYK_M": 0.04872895404696,
    "CMYK_Y": 0.23803836107254,
    "CMYK_K": 0.03022396564484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08988",
    "Farbtonhilfsbezeichnung": "G2.26.84",
    "Farbtonklasse": "02",
    "Rcolor": "249",
    "Gcolor": "225",
    "Bcolor": "152",
    "Y": 76.0087585449219,
    "L": 89.863410949707,
    "a": -1.32966375350952,
    "b": 37.6575889587402,
    "C": 37.6810569763184,
    "h": 92.0222396850586,
    "CMY_C": 0.02537274360657,
    "CMY_M": 0.11889070272446,
    "CMY_Y": 0.40240097045898,
    "CMYK_C": 0,
    "CMYK_M": 0.09595254063606,
    "CMYK_Y": 0.38684350252151,
    "CMYK_K": 0.02537274360657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08989",
    "Farbtonhilfsbezeichnung": "G0.54.78",
    "Farbtonklasse": "03",
    "Rcolor": "250",
    "Gcolor": "211",
    "Bcolor": "56",
    "Y": 66.9599761962891,
    "L": 85.4837341308594,
    "a": -0.59088689088821,
    "b": 75.2815170288086,
    "C": 75.2838363647461,
    "h": 90.44970703125,
    "CMY_C": 0.02076292037964,
    "CMY_M": 0.17394816875458,
    "CMY_Y": 0.78173720836639,
    "CMYK_C": 0,
    "CMYK_M": 0.15643325448036,
    "CMYK_Y": 0.7771093249321,
    "CMYK_K": 0.02076292037964
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08990",
    "Farbtonhilfsbezeichnung": "G0.59.76",
    "Farbtonklasse": "03",
    "Rcolor": "238",
    "Gcolor": "200",
    "Bcolor": "48",
    "Y": 59.8308753967285,
    "L": 81.7461776733398,
    "a": -0.38402184844017,
    "b": 73.8180160522461,
    "C": 73.8190155029297,
    "h": 90.2980651855469,
    "CMY_C": 0.06583827733994,
    "CMY_M": 0.21487700939178,
    "CMY_Y": 0.81059265136719,
    "CMYK_C": 0,
    "CMYK_M": 0.15954275429249,
    "CMYK_Y": 0.79724353551865,
    "CMYK_K": 0.06583827733994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08991",
    "Farbtonhilfsbezeichnung": "G0.64.69",
    "Farbtonklasse": "03",
    "Rcolor": "220",
    "Gcolor": "184",
    "Bcolor": "32",
    "Y": 49.5524711608887,
    "L": 75.7937469482422,
    "a": 0.05837351456285,
    "b": 72.4676818847656,
    "C": 72.4677047729492,
    "h": 89.9538497924805,
    "CMY_C": 0.13539010286331,
    "CMY_M": 0.27958089113235,
    "CMY_Y": 0.87352126836777,
    "CMYK_C": 0,
    "CMYK_M": 0.16676975786686,
    "CMYK_Y": 0.8537158370018,
    "CMYK_K": 0.13539010286331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08992",
    "Farbtonhilfsbezeichnung": "G2.10.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "233",
    "Bcolor": "202",
    "Y": 82.0532531738281,
    "L": 92.5983581542969,
    "a": -0.57175713777542,
    "b": 15.6971282958984,
    "C": 15.707537651062,
    "h": 92.0860366821289,
    "CMY_C": 0.03930521011353,
    "CMY_M": 0.08557885885239,
    "CMY_Y": 0.20734810829163,
    "CMYK_C": 0,
    "CMYK_M": 0.0481668561697,
    "CMYK_Y": 0.17491808533669,
    "CMYK_K": 0.03930521011353
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08993",
    "Farbtonhilfsbezeichnung": "G2.23.83",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "223",
    "Bcolor": "159",
    "Y": 74.5702896118164,
    "L": 89.1913299560547,
    "a": -1.52513718605042,
    "b": 33.4558219909668,
    "C": 33.4905662536621,
    "h": 92.6101150512695,
    "CMY_C": 0.04279559850693,
    "CMY_M": 0.12509137392044,
    "CMY_Y": 0.37735843658447,
    "CMYK_C": 0,
    "CMYK_M": 0.0859751328826,
    "CMYK_Y": 0.34952080249786,
    "CMYK_K": 0.04279559850693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08994",
    "Farbtonhilfsbezeichnung": "F9.35.78",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "210",
    "Bcolor": "125",
    "Y": 66.2841110229492,
    "L": 85.1411285400391,
    "a": 0.6770920753479,
    "b": 45.0905151367188,
    "C": 45.0956001281738,
    "h": 89.1396942138672,
    "CMY_C": 0.0534975528717,
    "CMY_M": 0.17694485187531,
    "CMY_Y": 0.50838840007782,
    "CMYK_C": 0,
    "CMYK_M": 0.13042470812798,
    "CMYK_Y": 0.48060187697411,
    "CMYK_K": 0.0534975528717
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08995",
    "Farbtonhilfsbezeichnung": "F9.43.74",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "200",
    "Bcolor": "98",
    "Y": 59.7217903137207,
    "L": 81.6867370605469,
    "a": 1.20773243904114,
    "b": 53.8732986450195,
    "C": 53.886833190918,
    "h": 88.7157592773438,
    "CMY_C": 0.07773971557617,
    "CMY_M": 0.21708303689957,
    "CMY_Y": 0.61426067352295,
    "CMYK_C": 0,
    "CMYK_M": 0.15108893811703,
    "CMYK_Y": 0.58174568414688,
    "CMYK_K": 0.07773971557617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08996",
    "Farbtonhilfsbezeichnung": "F9.44.69",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "187",
    "Bcolor": "90",
    "Y": 51.1728630065918,
    "L": 76.7835998535156,
    "a": 0.4892064332962,
    "b": 51.6344718933105,
    "C": 51.6367874145508,
    "h": 89.4571762084961,
    "CMY_C": 0.1422563791275,
    "CMY_M": 0.2678359746933,
    "CMY_Y": 0.64579129219055,
    "CMYK_C": 0,
    "CMYK_M": 0.14640691876411,
    "CMYK_Y": 0.58704596757889,
    "CMYK_K": 0.1422563791275
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08997",
    "Farbtonhilfsbezeichnung": "G4.18.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "234",
    "Bcolor": "181",
    "Y": 82.1659469604492,
    "L": 92.6480484008789,
    "a": -2.79605197906494,
    "b": 26.7803382873535,
    "C": 26.9259071350098,
    "h": 95.9604797363281,
    "CMY_C": 0.02695727348328,
    "CMY_M": 0.08227425813675,
    "CMY_Y": 0.2904868721962,
    "CMYK_C": 0,
    "CMYK_M": 0.05684949085116,
    "CMYK_Y": 0.27083045244217,
    "CMYK_K": 0.02695727348328
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08998",
    "Farbtonhilfsbezeichnung": "G5.28.84",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "227",
    "Bcolor": "147",
    "Y": 76.7849502563477,
    "L": 90.222541809082,
    "a": -3.97082853317261,
    "b": 40.870304107666,
    "C": 41.0627479553223,
    "h": 95.5492553710938,
    "CMY_C": 0.03353774547577,
    "CMY_M": 0.10927098989487,
    "CMY_Y": 0.42409437894821,
    "CMYK_C": 0,
    "CMYK_M": 0.07836130261421,
    "CMYK_Y": 0.40410956740379,
    "CMYK_K": 0.03353774547577
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI08999",
    "Farbtonhilfsbezeichnung": "G2.51.77",
    "Farbtonklasse": "03",
    "Rcolor": "242",
    "Gcolor": "208",
    "Bcolor": "74",
    "Y": 64.3050308227539,
    "L": 84.1243362426758,
    "a": -1.69297468662262,
    "b": 67.209846496582,
    "C": 67.2311630249023,
    "h": 91.4429397583008,
    "CMY_C": 0.05201345682144,
    "CMY_M": 0.18534898757935,
    "CMY_Y": 0.70981800556183,
    "CMYK_C": 0,
    "CMYK_M": 0.14065128564835,
    "CMYK_Y": 0.69389653205872,
    "CMYK_K": 0.05201345682144
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09000",
    "Farbtonhilfsbezeichnung": "G2.41.72",
    "Farbtonklasse": "02",
    "Rcolor": "219",
    "Gcolor": "195",
    "Bcolor": "97",
    "Y": 55.0011405944824,
    "L": 79.0419235229492,
    "a": -2.98723125457764,
    "b": 51.0901756286621,
    "C": 51.177433013916,
    "h": 93.3462600708008,
    "CMY_C": 0.13934808969498,
    "CMY_M": 0.23548805713654,
    "CMY_Y": 0.61957180500031,
    "CMYK_C": 0,
    "CMYK_M": 0.11170598119497,
    "CMYK_Y": 0.55797672271729,
    "CMYK_K": 0.13934808969498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09001",
    "Farbtonhilfsbezeichnung": "G2.54.66",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "179",
    "Bcolor": "60",
    "Y": 45.7135391235352,
    "L": 73.3592681884766,
    "a": -2.96922278404236,
    "b": 60.8966026306152,
    "C": 60.9689483642578,
    "h": 92.7914428710938,
    "CMY_C": 0.19315606355667,
    "CMY_M": 0.29740077257156,
    "CMY_Y": 0.76520383358002,
    "CMYK_C": 0,
    "CMYK_M": 0.12920059263706,
    "CMYK_Y": 0.70899432897568,
    "CMYK_K": 0.19315606355667
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09002",
    "Farbtonhilfsbezeichnung": "G2.49.52",
    "Farbtonklasse": "03",
    "Rcolor": "162",
    "Gcolor": "142",
    "Bcolor": "63",
    "Y": 27.4375438690186,
    "L": 59.3771553039551,
    "a": -2.29819846153259,
    "b": 43.7808876037598,
    "C": 43.8411674499512,
    "h": 93.0048828125,
    "CMY_C": 0.36521595716476,
    "CMY_M": 0.44219380617142,
    "CMY_Y": 0.7548508644104,
    "CMYK_C": 0,
    "CMYK_M": 0.1212662011385,
    "CMYK_Y": 0.61380702257156,
    "CMYK_K": 0.36521595716476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09003",
    "Farbtonhilfsbezeichnung": "G2.12.86",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "231",
    "Bcolor": "192",
    "Y": 80.2748260498047,
    "L": 91.8080291748047,
    "a": -0.81756788492203,
    "b": 19.7309322357178,
    "C": 19.7478637695313,
    "h": 92.3727416992188,
    "CMY_C": 0.03939944505692,
    "CMY_M": 0.09477752447128,
    "CMY_Y": 0.24609023332596,
    "CMYK_C": 0,
    "CMYK_M": 0.05764943361282,
    "CMYK_Y": 0.2151682972908,
    "CMYK_K": 0.03939944505692
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09004",
    "Farbtonhilfsbezeichnung": "G2.20.84",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "228",
    "Bcolor": "170",
    "Y": 77.9452743530273,
    "L": 90.7549285888672,
    "a": -1.28256368637085,
    "b": 29.7074127197266,
    "C": 29.73508644104,
    "h": 92.4721069335938,
    "CMY_C": 0.03108143806458,
    "CMY_M": 0.10757052898407,
    "CMY_Y": 0.33243489265442,
    "CMYK_C": 0,
    "CMYK_M": 0.078942745924,
    "CMYK_Y": 0.31102040410042,
    "CMYK_K": 0.03108143806458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09005",
    "Farbtonhilfsbezeichnung": "G2.30.81",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "216",
    "Bcolor": "137",
    "Y": 69.597900390625,
    "L": 86.7992706298828,
    "a": -1.76142489910126,
    "b": 41.4141731262207,
    "C": 41.4516143798828,
    "h": 92.435432434082,
    "CMY_C": 0.05684977769852,
    "CMY_M": 0.15237635374069,
    "CMY_Y": 0.46329522132874,
    "CMYK_C": 0,
    "CMYK_M": 0.10128457844257,
    "CMYK_Y": 0.43094453215599,
    "CMYK_K": 0.05684977769852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09006",
    "Farbtonhilfsbezeichnung": "G2.44.79",
    "Farbtonklasse": "02",
    "Rcolor": "245",
    "Gcolor": "211",
    "Bcolor": "96",
    "Y": 66.71044921875,
    "L": 85.3575134277344,
    "a": -0.48275431990623,
    "b": 59.2557373046875,
    "C": 59.2577018737793,
    "h": 90.4667739868164,
    "CMY_C": 0.03863978385925,
    "CMY_M": 0.17382770776749,
    "CMY_Y": 0.62277293205261,
    "CMYK_C": 0,
    "CMYK_M": 0.14062151312828,
    "CMYK_Y": 0.60761111974716,
    "CMYK_K": 0.03863978385925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09007",
    "Farbtonhilfsbezeichnung": "G1.61.63",
    "Farbtonklasse": "03",
    "Rcolor": "198",
    "Gcolor": "171",
    "Bcolor": "46",
    "Y": 41.5587577819824,
    "L": 70.5656356811523,
    "a": -2.77560353279114,
    "b": 63.0284576416016,
    "C": 63.089542388916,
    "h": 92.5215225219727,
    "CMY_C": 0.22220247983932,
    "CMY_M": 0.32750326395035,
    "CMY_Y": 0.81874990463257,
    "CMYK_C": 0,
    "CMYK_M": 0.13538329303265,
    "CMYK_Y": 0.76697009801865,
    "CMYK_K": 0.22220247983932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09008",
    "Farbtonhilfsbezeichnung": "G8.46.57",
    "Farbtonklasse": "04",
    "Rcolor": "179",
    "Gcolor": "157",
    "Bcolor": "72",
    "Y": 34.0307540893555,
    "L": 64.9869766235352,
    "a": -2.1227126121521,
    "b": 45.9210739135742,
    "C": 45.9701080322266,
    "h": 92.6466293334961,
    "CMY_C": 0.29966861009598,
    "CMY_M": 0.38529235124588,
    "CMY_Y": 0.71743899583817,
    "CMYK_C": 0,
    "CMYK_M": 0.12226174771786,
    "CMYK_Y": 0.59653240442276,
    "CMYK_K": 0.29966861009598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09009",
    "Farbtonhilfsbezeichnung": "H0.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "211",
    "Y": 82.1320495605469,
    "L": 92.6331100463867,
    "a": -2.30667877197266,
    "b": 10.9433603286743,
    "C": 11.1838235855103,
    "h": 101.902763366699,
    "CMY_C": 0.06569653749466,
    "CMY_M": 0.07989984750748,
    "CMY_Y": 0.17176097631454,
    "CMYK_C": 0,
    "CMYK_M": 0.01520203053951,
    "CMYK_Y": 0.11352246999741,
    "CMYK_K": 0.06569653749466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09010",
    "Farbtonhilfsbezeichnung": "G5.09.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "223",
    "Bcolor": "196",
    "Y": 73.7047882080078,
    "L": 88.7827682495117,
    "a": -1.09306573867798,
    "b": 13.2330551147461,
    "C": 13.2781229019165,
    "h": 94.7219772338867,
    "CMY_C": 0.09303027391434,
    "CMY_M": 0.12622362375259,
    "CMY_Y": 0.23033946752548,
    "CMYK_C": 0,
    "CMYK_M": 0.03659807890654,
    "CMYK_Y": 0.15139335393906,
    "CMYK_K": 0.09303027391434
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09011",
    "Farbtonhilfsbezeichnung": "G5.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "219",
    "Bcolor": "178",
    "Y": 70.2840881347656,
    "L": 87.1360092163086,
    "a": -3.01232957839966,
    "b": 20.7295265197754,
    "C": 20.9472522735596,
    "h": 98.2681121826172,
    "CMY_C": 0.10570329427719,
    "CMY_M": 0.14172369241714,
    "CMY_Y": 0.30379676818848,
    "CMYK_C": 0,
    "CMYK_M": 0.0402779057622,
    "CMYK_Y": 0.22150754928589,
    "CMYK_K": 0.10570329427719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09012",
    "Farbtonhilfsbezeichnung": "G5.20.78",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "212",
    "Bcolor": "160",
    "Y": 65.6362915039063,
    "L": 84.8105545043945,
    "a": -3.53723454475403,
    "b": 26.8871955871582,
    "C": 27.1188735961914,
    "h": 97.4946975708008,
    "CMY_C": 0.12088167667389,
    "CMY_M": 0.1674280166626,
    "CMY_Y": 0.37413018941879,
    "CMYK_C": 0,
    "CMYK_M": 0.05294661596417,
    "CMYK_Y": 0.28807100653648,
    "CMYK_K": 0.12088167667389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09013",
    "Farbtonhilfsbezeichnung": "G5.24.72",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "196",
    "Bcolor": "138",
    "Y": 54.4882774353027,
    "L": 78.7455902099609,
    "a": -4.4374794960022,
    "b": 29.6416168212891,
    "C": 29.9719314575195,
    "h": 98.5142059326172,
    "CMY_C": 0.18898487091064,
    "CMY_M": 0.2320037484169,
    "CMY_Y": 0.45738166570663,
    "CMYK_C": 0,
    "CMYK_M": 0.05304324999452,
    "CMYK_Y": 0.33093932271004,
    "CMYK_K": 0.18898487091064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09014",
    "Farbtonhilfsbezeichnung": "G5.28.60",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "166",
    "Bcolor": "112",
    "Y": 37.7803726196289,
    "L": 67.8584289550781,
    "a": -3.09898972511292,
    "b": 28.7134952545166,
    "C": 28.8802452087402,
    "h": 96.1599731445312,
    "CMY_C": 0.30112832784653,
    "CMY_M": 0.35071259737015,
    "CMY_Y": 0.55964797735214,
    "CMYK_C": 0,
    "CMYK_M": 0.07094903290272,
    "CMYK_Y": 0.36991003155708,
    "CMYK_K": 0.30112832784653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09015",
    "Farbtonhilfsbezeichnung": "G5.10.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "232",
    "Bcolor": "201",
    "Y": 80.9581604003906,
    "L": 92.1130676269531,
    "a": -1.39774894714355,
    "b": 15.4909086227417,
    "C": 15.553840637207,
    "h": 95.1558532714844,
    "CMY_C": 0.0515508055687,
    "CMY_M": 0.08899056911469,
    "CMY_Y": 0.2112010717392,
    "CMYK_C": 0,
    "CMYK_M": 0.03947471827269,
    "CMYK_Y": 0.16832768917084,
    "CMYK_K": 0.0515508055687
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09016",
    "Farbtonhilfsbezeichnung": "G2.16.81",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "217",
    "Bcolor": "174",
    "Y": 70.0800399780273,
    "L": 87.0361099243164,
    "a": -1.16266870498657,
    "b": 22.5796794891357,
    "C": 22.6095943450928,
    "h": 92.9476623535156,
    "CMY_C": 0.08884823322296,
    "CMY_M": 0.14754301309586,
    "CMY_Y": 0.31826746463776,
    "CMYK_C": 0,
    "CMYK_M": 0.06441822648048,
    "CMYK_Y": 0.25179037451744,
    "CMYK_K": 0.08884823322296
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09017",
    "Farbtonhilfsbezeichnung": "G5.20.82",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "222",
    "Bcolor": "165",
    "Y": 73.1386032104492,
    "L": 88.5137786865234,
    "a": -2.74046874046326,
    "b": 29.3984413146973,
    "C": 29.5258960723877,
    "h": 95.3256149291992,
    "CMY_C": 0.06774038076401,
    "CMY_M": 0.12894731760025,
    "CMY_Y": 0.35401040315628,
    "CMYK_C": 0,
    "CMYK_M": 0.06565438956022,
    "CMYK_Y": 0.30707114934921,
    "CMYK_K": 0.06774038076401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09018",
    "Farbtonhilfsbezeichnung": "G5.25.77",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "207",
    "Bcolor": "143",
    "Y": 61.7508125305176,
    "L": 82.7807235717773,
    "a": -4.51398706436157,
    "b": 32.6283340454102,
    "C": 32.9390983581543,
    "h": 97.8766250610352,
    "CMY_C": 0.1382828950882,
    "CMY_M": 0.1885342001915,
    "CMY_Y": 0.43830853700638,
    "CMYK_C": 0,
    "CMYK_M": 0.05831531435251,
    "CMYK_Y": 0.34817185997963,
    "CMYK_K": 0.1382828950882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09019",
    "Farbtonhilfsbezeichnung": "G5.31.68",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "186",
    "Bcolor": "113",
    "Y": 48.8201103210449,
    "L": 75.3392791748047,
    "a": -4.31168365478516,
    "b": 38.1860084533691,
    "C": 38.4286575317383,
    "h": 96.4421310424805,
    "CMY_C": 0.20987486839294,
    "CMY_M": 0.2703897356987,
    "CMY_Y": 0.55571126937866,
    "CMYK_C": 0,
    "CMYK_M": 0.0765889659524,
    "CMYK_Y": 0.43769827485085,
    "CMYK_K": 0.20987486839294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09020",
    "Farbtonhilfsbezeichnung": "G5.42.44",
    "Farbtonklasse": "03",
    "Rcolor": "137",
    "Gcolor": "126",
    "Bcolor": "70",
    "Y": 20.6563396453857,
    "L": 52.5713119506836,
    "a": -3.76894021034241,
    "b": 31.5020236968994,
    "C": 31.7266826629639,
    "h": 96.822509765625,
    "CMY_C": 0.46336138248444,
    "CMY_M": 0.50601524114609,
    "CMY_Y": 0.72641813755035,
    "CMYK_C": 0,
    "CMYK_M": 0.07948339730501,
    "CMYK_Y": 0.49019348621368,
    "CMYK_K": 0.46336138248444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09021",
    "Farbtonhilfsbezeichnung": "G3.42.79",
    "Farbtonklasse": "02",
    "Rcolor": "237",
    "Gcolor": "213",
    "Bcolor": "100",
    "Y": 66.792121887207,
    "L": 85.3988571166992,
    "a": -4.74966621398926,
    "b": 57.2008094787598,
    "C": 57.3976631164551,
    "h": 94.7466659545898,
    "CMY_C": 0.06887853145599,
    "CMY_M": 0.16315960884094,
    "CMY_Y": 0.60613906383514,
    "CMYK_C": 0,
    "CMYK_M": 0.10125540196896,
    "CMYK_Y": 0.57700371742249,
    "CMYK_K": 0.06887853145599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09022",
    "Farbtonhilfsbezeichnung": "G5.46.50",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "142",
    "Bcolor": "69",
    "Y": 26.4466648101807,
    "L": 58.4586181640625,
    "a": -5.45641279220581,
    "b": 39.3351211547852,
    "C": 39.7117652893066,
    "h": 97.8974533081055,
    "CMY_C": 0.40041208267212,
    "CMY_M": 0.4443119764328,
    "CMY_Y": 0.72965776920319,
    "CMYK_C": 0,
    "CMYK_M": 0.07321677356958,
    "CMYK_Y": 0.54911994934082,
    "CMYK_K": 0.40041208267212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09023",
    "Farbtonhilfsbezeichnung": "G5.38.78",
    "Farbtonklasse": "02",
    "Rcolor": "235",
    "Gcolor": "214",
    "Bcolor": "113",
    "Y": 67.1493148803711,
    "L": 85.5792922973633,
    "a": -5.31248331069946,
    "b": 51.7360954284668,
    "C": 52.0081329345703,
    "h": 95.8628234863281,
    "CMY_C": 0.07829558849335,
    "CMY_M": 0.15915936231613,
    "CMY_Y": 0.55877673625946,
    "CMYK_C": 0,
    "CMYK_M": 0.08773287385702,
    "CMYK_Y": 0.52129638195038,
    "CMYK_K": 0.07829558849335
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09024",
    "Farbtonhilfsbezeichnung": "G4.50.75",
    "Farbtonklasse": "02",
    "Rcolor": "224",
    "Gcolor": "206",
    "Bcolor": "73",
    "Y": 60.5266227722168,
    "L": 82.1235961914063,
    "a": -8.22894763946533,
    "b": 65.1675872802734,
    "C": 65.6850814819336,
    "h": 97.1968536376953,
    "CMY_C": 0.12045848369598,
    "CMY_M": 0.19202280044556,
    "CMY_Y": 0.71465957164764,
    "CMYK_C": 0,
    "CMYK_M": 0.08136548101902,
    "CMYK_Y": 0.6755805015564,
    "CMYK_K": 0.12045848369598
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09025",
    "Farbtonhilfsbezeichnung": "G5.53.70",
    "Farbtonklasse": "03",
    "Rcolor": "208",
    "Gcolor": "192",
    "Bcolor": "61",
    "Y": 51.3019790649414,
    "L": 76.861572265625,
    "a": -8.47362518310547,
    "b": 64.0987243652344,
    "C": 64.6563873291016,
    "h": 97.530632019043,
    "CMY_C": 0.18450349569321,
    "CMY_M": 0.24823313951492,
    "CMY_Y": 0.7619696855545,
    "CMYK_C": 0,
    "CMYK_M": 0.07814827561378,
    "CMYK_Y": 0.70811605453491,
    "CMYK_K": 0.18450349569321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09026",
    "Farbtonhilfsbezeichnung": "H1.23.84",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "163",
    "Y": 77.1906356811523,
    "L": 90.4092864990234,
    "a": -8.54848861694336,
    "b": 32.6703834533691,
    "C": 33.770263671875,
    "h": 104.663192749023,
    "CMY_C": 0.08096766471863,
    "CMY_M": 0.0952467918396,
    "CMY_Y": 0.36004555225372,
    "CMYK_C": 0,
    "CMYK_M": 0.01553713250905,
    "CMYK_Y": 0.30366492271423,
    "CMYK_K": 0.08096766471863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09027",
    "Farbtonhilfsbezeichnung": "H0.20.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "228",
    "Bcolor": "170",
    "Y": 75.6315002441406,
    "L": 89.6879730224609,
    "a": -6.88694047927856,
    "b": 28.300142288208,
    "C": 29.126070022583,
    "h": 103.677268981934,
    "CMY_C": 0.08696663379669,
    "CMY_M": 0.10616815090179,
    "CMY_Y": 0.33416372537613,
    "CMYK_C": 0,
    "CMYK_M": 0.02103046514094,
    "CMYK_Y": 0.27074268460274,
    "CMYK_K": 0.08696663379669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09028",
    "Farbtonhilfsbezeichnung": "H1.30.79",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "220",
    "Bcolor": "136",
    "Y": 68.3120727539063,
    "L": 86.1622543334961,
    "a": -10.6645479202271,
    "b": 40.4851188659668,
    "C": 41.8661842346191,
    "h": 104.757545471191,
    "CMY_C": 0.12808567285538,
    "CMY_M": 0.13909143209457,
    "CMY_Y": 0.46478313207626,
    "CMYK_C": 0,
    "CMYK_M": 0.01262252405286,
    "CMYK_Y": 0.38615888357162,
    "CMYK_K": 0.12808567285538
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09029",
    "Farbtonhilfsbezeichnung": "H1.37.76",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "212",
    "Bcolor": "112",
    "Y": 62.2096252441406,
    "L": 83.024772644043,
    "a": -13.9612693786621,
    "b": 48.3356018066406,
    "C": 50.3115043640137,
    "h": 106.110847473145,
    "CMY_C": 0.17280334234238,
    "CMY_M": 0.16775810718536,
    "CMY_Y": 0.55982065200806,
    "CMYK_C": 0.00606222217903,
    "CMYK_M": 0,
    "CMYK_Y": 0.47109204530716,
    "CMYK_K": 0.16775810718536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09030",
    "Farbtonhilfsbezeichnung": "H1.33.78",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "217",
    "Bcolor": "128",
    "Y": 66.1609268188477,
    "L": 85.0784378051758,
    "a": -12.6116275787354,
    "b": 43.424732208252,
    "C": 45.2190284729004,
    "h": 106.194618225098,
    "CMY_C": 0.14870887994766,
    "CMY_M": 0.14731270074844,
    "CMY_Y": 0.49934977293015,
    "CMYK_C": 0.00163738708943,
    "CMYK_M": 0,
    "CMYK_Y": 0.41285601258278,
    "CMYK_K": 0.14731270074844
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09031",
    "Farbtonhilfsbezeichnung": "H2.49.69",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "198",
    "Bcolor": "78",
    "Y": 51.818775177002,
    "L": 77.1723480224609,
    "a": -18.3888835906982,
    "b": 57.065299987793,
    "C": 59.9549789428711,
    "h": 107.861167907715,
    "CMY_C": 0.25653833150864,
    "CMY_M": 0.22358363866806,
    "CMY_Y": 0.69526690244675,
    "CMYK_C": 0.04244461283088,
    "CMYK_M": 0,
    "CMYK_Y": 0.60751330852509,
    "CMYK_K": 0.22358363866806
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09032",
    "Farbtonhilfsbezeichnung": "H1.18.84",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "231",
    "Bcolor": "176",
    "Y": 77.5361785888672,
    "L": 90.5678253173828,
    "a": -6.95780277252197,
    "b": 26.5402488708496,
    "C": 27.4371242523193,
    "h": 104.690101623535,
    "CMY_C": 0.08177310228348,
    "CMY_M": 0.09584486484528,
    "CMY_Y": 0.31158429384232,
    "CMYK_C": 0,
    "CMYK_M": 0.0153249297291,
    "CMYK_Y": 0.25027713179588,
    "CMYK_K": 0.08177310228348
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09033",
    "Farbtonhilfsbezeichnung": "H0.27.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "224",
    "Bcolor": "147",
    "Y": 71.6909255981445,
    "L": 87.8196105957031,
    "a": -9.44086074829102,
    "b": 37.3351936340332,
    "C": 38.5103416442871,
    "h": 104.190773010254,
    "CMY_C": 0.10680639743805,
    "CMY_M": 0.12290662527084,
    "CMY_Y": 0.42302066087723,
    "CMYK_C": 0,
    "CMYK_M": 0.01802546344697,
    "CMYK_Y": 0.35402655601501,
    "CMYK_K": 0.10680639743805
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09034",
    "Farbtonhilfsbezeichnung": "H1.33.74",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "206",
    "Bcolor": "120",
    "Y": 58.2193069458008,
    "L": 80.8605651855469,
    "a": -13.2845163345337,
    "b": 41.8849105834961,
    "C": 43.9411430358887,
    "h": 107.597312927246,
    "CMY_C": 0.203773021698,
    "CMY_M": 0.19192260503769,
    "CMY_Y": 0.53058838844299,
    "CMYK_C": 0.01466495264322,
    "CMYK_M": 0,
    "CMYK_Y": 0.41910067200661,
    "CMYK_K": 0.19192260503769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09035",
    "Farbtonhilfsbezeichnung": "H1.42.68",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "189",
    "Bcolor": "95",
    "Y": 48.0047149658203,
    "L": 74.8279037475586,
    "a": -13.6832361221313,
    "b": 46.3320159912109,
    "C": 48.3103179931641,
    "h": 106.453460693359,
    "CMY_C": 0.2659495472908,
    "CMY_M": 0.25705772638321,
    "CMY_Y": 0.62666583061218,
    "CMYK_C": 0.01196838729084,
    "CMYK_M": 0,
    "CMYK_Y": 0.49749237298965,
    "CMYK_K": 0.25705772638321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09036",
    "Farbtonhilfsbezeichnung": "H1.12.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "197",
    "Y": 80.3455123901367,
    "L": 91.8396606445312,
    "a": -4.13372182846069,
    "b": 17.3344078063965,
    "C": 17.8204765319824,
    "h": 103.412773132324,
    "CMY_C": 0.07017284631729,
    "CMY_M": 0.08607935905457,
    "CMY_Y": 0.22838360071182,
    "CMYK_C": 0,
    "CMYK_M": 0.01710695587099,
    "CMYK_Y": 0.17015071213245,
    "CMYK_K": 0.07017284631729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09037",
    "Farbtonhilfsbezeichnung": "H2.20.76",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "204",
    "Bcolor": "152",
    "Y": 58.9108276367188,
    "L": 81.2425537109375,
    "a": -6.48002052307129,
    "b": 25.6473922729492,
    "C": 26.4533443450928,
    "h": 104.179489135742,
    "CMY_C": 0.18461579084396,
    "CMY_M": 0.19958180189133,
    "CMY_Y": 0.40256524085999,
    "CMYK_C": 0,
    "CMYK_M": 0.01835455186665,
    "CMYK_Y": 0.26729664206505,
    "CMYK_K": 0.18461579084396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09038",
    "Farbtonhilfsbezeichnung": "H0.38.37",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "112",
    "Bcolor": "71",
    "Y": 15.4401807785034,
    "L": 46.2312889099121,
    "a": -6.00690889358521,
    "b": 22.0971527099609,
    "C": 22.8990631103516,
    "h": 105.207832336426,
    "CMY_C": 0.55762779712677,
    "CMY_M": 0.56266987323761,
    "CMY_Y": 0.71983563899994,
    "CMYK_C": 0,
    "CMYK_M": 0.01139781437814,
    "CMYK_Y": 0.36667728424072,
    "CMYK_K": 0.55762779712677
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09039",
    "Farbtonhilfsbezeichnung": "H1.08.78",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "214",
    "Bcolor": "189",
    "Y": 66.7571868896484,
    "L": 85.3811798095703,
    "a": -2.89563584327698,
    "b": 12.2267446517944,
    "C": 12.5649509429932,
    "h": 103.323768615723,
    "CMY_C": 0.14729309082031,
    "CMY_M": 0.15936362743378,
    "CMY_Y": 0.25972276926041,
    "CMYK_C": 0,
    "CMYK_M": 0.01415555179119,
    "CMYK_Y": 0.13185031712055,
    "CMYK_K": 0.14729309082031
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09040",
    "Farbtonhilfsbezeichnung": "H1.11.70",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "192",
    "Bcolor": "164",
    "Y": 51.6927070617676,
    "L": 77.0967254638672,
    "a": -3.70118761062622,
    "b": 13.6789112091065,
    "C": 14.1707935333252,
    "h": 105.140342712402,
    "CMY_C": 0.2399246096611,
    "CMY_M": 0.24813532829285,
    "CMY_Y": 0.3579004406929,
    "CMYK_C": 0,
    "CMYK_M": 0.01080250553787,
    "CMYK_Y": 0.15521596372128,
    "CMYK_K": 0.2399246096611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09041",
    "Farbtonhilfsbezeichnung": "H1.16.58",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "162",
    "Bcolor": "131",
    "Y": 35.3067665100098,
    "L": 65.9868087768555,
    "a": -4.30226564407349,
    "b": 16.0102806091309,
    "C": 16.5782566070557,
    "h": 105.041137695313,
    "CMY_C": 0.35689282417297,
    "CMY_M": 0.36525851488113,
    "CMY_Y": 0.48816418647766,
    "CMYK_C": 0,
    "CMYK_M": 0.01300823688507,
    "CMYK_Y": 0.20412050187588,
    "CMYK_K": 0.35689282417297
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09042",
    "Farbtonhilfsbezeichnung": "H1.26.33",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "102",
    "Bcolor": "72",
    "Y": 12.8157062530518,
    "L": 42.4842414855957,
    "a": -4.18015098571777,
    "b": 16.3974304199219,
    "C": 16.9218616485596,
    "h": 104.301635742188,
    "CMY_C": 0.59383916854858,
    "CMY_M": 0.60155612230301,
    "CMY_Y": 0.71583104133606,
    "CMYK_C": 0,
    "CMYK_M": 0.01899974793196,
    "CMYK_Y": 0.30035361647606,
    "CMYK_K": 0.59383916854858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09043",
    "Farbtonhilfsbezeichnung": "G9.20.19",
    "Farbtonklasse": "04",
    "Rcolor": "78",
    "Gcolor": "77",
    "Bcolor": "63",
    "Y": 7.30853080749512,
    "L": 32.4992141723633,
    "a": -2.16646766662598,
    "b": 8.05030918121338,
    "C": 8.33673000335693,
    "h": 105.062362670898,
    "CMY_C": 0.69362723827362,
    "CMY_M": 0.69761824607849,
    "CMY_Y": 0.752161860466,
    "CMYK_C": 0,
    "CMYK_M": 0.01302664075047,
    "CMYK_Y": 0.19105687737465,
    "CMYK_K": 0.69362723827362
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09044",
    "Farbtonhilfsbezeichnung": "H9.09.69",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "192",
    "Bcolor": "167",
    "Y": 50.732795715332,
    "L": 76.5168685913086,
    "a": -6.14397001266479,
    "b": 10.7425956726074,
    "C": 12.3754482269287,
    "h": 119.766357421875,
    "CMY_C": 0.27278196811676,
    "CMY_M": 0.2483206987381,
    "CMY_Y": 0.34321928024292,
    "CMYK_C": 0.03254216164351,
    "CMYK_M": 0,
    "CMYK_Y": 0.12624876201153,
    "CMYK_K": 0.2483206987381
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09045",
    "Farbtonhilfsbezeichnung": "H8.12.61",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 37.6743011474609,
    "L": 67.7798767089844,
    "a": -6.0133695602417,
    "b": 11.5027923583984,
    "C": 12.9797859191895,
    "h": 117.59944152832,
    "CMY_C": 0.36226361989975,
    "CMY_M": 0.34184545278549,
    "CMY_Y": 0.43872976303101,
    "CMYK_C": 0.03102336265147,
    "CMYK_M": 0,
    "CMYK_Y": 0.14720602333546,
    "CMYK_K": 0.34184545278549
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09046",
    "Farbtonhilfsbezeichnung": "H7.15.53",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "148",
    "Bcolor": "119",
    "Y": 28.2160587310791,
    "L": 60.0834350585938,
    "a": -6.54847478866577,
    "b": 13.7978639602661,
    "C": 15.2729682922363,
    "h": 115.389038085938,
    "CMY_C": 0.43973278999329,
    "CMY_M": 0.42125451564789,
    "CMY_Y": 0.53182542324066,
    "CMYK_C": 0.03192815184593,
    "CMYK_M": 0,
    "CMYK_Y": 0.19105273485184,
    "CMYK_K": 0.42125451564789
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09047",
    "Farbtonhilfsbezeichnung": "H7.21.43",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "127",
    "Bcolor": "97",
    "Y": 20.1642513275146,
    "L": 52.0224075317383,
    "a": -6.42449283599854,
    "b": 15.1186475753784,
    "C": 16.427038192749,
    "h": 113.022499084473,
    "CMY_C": 0.51724642515182,
    "CMY_M": 0.50345778465271,
    "CMY_Y": 0.61891162395477,
    "CMYK_C": 0.02776932157576,
    "CMYK_M": 0,
    "CMYK_Y": 0.23251566290855,
    "CMYK_K": 0.50345778465271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09048",
    "Farbtonhilfsbezeichnung": "H7.18.35",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "106",
    "Bcolor": "84",
    "Y": 13.8372182846069,
    "L": 43.9985733032227,
    "a": -5.03020191192627,
    "b": 11.2892913818359,
    "C": 12.3592491149902,
    "h": 114.016456604004,
    "CMY_C": 0.59589350223541,
    "CMY_M": 0.58438301086426,
    "CMY_Y": 0.66884255409241,
    "CMYK_C": 0.02769494988024,
    "CMYK_M": 0,
    "CMYK_Y": 0.203214854002,
    "CMYK_K": 0.58438301086426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09049",
    "Farbtonhilfsbezeichnung": "H0.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "237",
    "Bcolor": "208",
    "Y": 83.8701782226563,
    "L": 93.3940887451172,
    "a": -3.76574063301086,
    "b": 13.9182853698731,
    "C": 14.418719291687,
    "h": 105.139511108398,
    "CMY_C": 0.05955421924591,
    "CMY_M": 0.06870198249817,
    "CMY_Y": 0.18591898679733,
    "CMYK_C": 0,
    "CMYK_M": 0.00972705055028,
    "CMYK_Y": 0.13436688482761,
    "CMYK_K": 0.05955421924591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09050",
    "Farbtonhilfsbezeichnung": "H1.16.81",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "220",
    "Bcolor": "176",
    "Y": 70.3750152587891,
    "L": 87.1804656982422,
    "a": -5.18381643295288,
    "b": 21.7623710632324,
    "C": 22.3712482452393,
    "h": 103.398223876953,
    "CMY_C": 0.11857908964157,
    "CMY_M": 0.13648051023483,
    "CMY_Y": 0.3113802075386,
    "CMYK_C": 0,
    "CMYK_M": 0.02030972950161,
    "CMYK_Y": 0.21873898804188,
    "CMYK_K": 0.11857908964157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09051",
    "Farbtonhilfsbezeichnung": "H1.21.68",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "185",
    "Bcolor": "136",
    "Y": 46.9266319274902,
    "L": 74.1428146362305,
    "a": -6.38685131072998,
    "b": 24.3005809783936,
    "C": 25.1258850097656,
    "h": 104.72583770752,
    "CMY_C": 0.26480835676193,
    "CMY_M": 0.27620202302933,
    "CMY_Y": 0.4654386639595,
    "CMYK_C": 0,
    "CMYK_M": 0.0154975457117,
    "CMYK_Y": 0.27289524674416,
    "CMYK_K": 0.26480835676193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09052",
    "Farbtonhilfsbezeichnung": "H1.29.58",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "160",
    "Bcolor": "106",
    "Y": 33.9746170043945,
    "L": 64.9424209594727,
    "a": -7.65293884277344,
    "b": 28.0164089202881,
    "C": 29.0428409576416,
    "h": 105.278144836426,
    "CMY_C": 0.36447602510452,
    "CMY_M": 0.37135344743729,
    "CMY_Y": 0.58419394493103,
    "CMYK_C": 0,
    "CMYK_M": 0.01082165632397,
    "CMYK_Y": 0.34572720527649,
    "CMYK_K": 0.36447602510452
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09053",
    "Farbtonhilfsbezeichnung": "H1.44.44",
    "Farbtonklasse": "03",
    "Rcolor": "131",
    "Gcolor": "132",
    "Bcolor": "67",
    "Y": 21.6202354431152,
    "L": 53.6217269897461,
    "a": -9.70646572113037,
    "b": 34.3146057128906,
    "C": 35.6610107421875,
    "h": 105.794456481934,
    "CMY_C": 0.48581957817078,
    "CMY_M": 0.48404622077942,
    "CMY_Y": 0.73862779140472,
    "CMYK_C": 0.00343704689294,
    "CMYK_M": 0,
    "CMYK_Y": 0.49341934919357,
    "CMYK_K": 0.48404622077942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09054",
    "Farbtonhilfsbezeichnung": "H7.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "232",
    "Bcolor": "209",
    "Y": 79.4403762817383,
    "L": 91.4331741333008,
    "a": -3.77551603317261,
    "b": 10.4529514312744,
    "C": 11.1138973236084,
    "h": 109.859283447266,
    "CMY_C": 0.0919976234436,
    "CMY_M": 0.08977019786835,
    "CMY_Y": 0.18142068386078,
    "CMYK_C": 0.0024471024517,
    "CMYK_M": 0,
    "CMYK_Y": 0.10068939626217,
    "CMYK_K": 0.08977019786835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09055",
    "Farbtonhilfsbezeichnung": "H7.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "233",
    "Bcolor": "202",
    "Y": 79.3659744262695,
    "L": 91.3996276855469,
    "a": -5.87005805969238,
    "b": 13.9491310119629,
    "C": 15.1339302062988,
    "h": 112.822280883789,
    "CMY_C": 0.0981063246727,
    "CMY_M": 0.08619904518127,
    "CMY_Y": 0.20814603567123,
    "CMYK_C": 0.0130304954946,
    "CMYK_M": 0,
    "CMYK_Y": 0.1334502696991,
    "CMYK_K": 0.08619904518127
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09056",
    "Farbtonhilfsbezeichnung": "H7.13.80",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "220",
    "Bcolor": "183",
    "Y": 69.4534530639648,
    "L": 86.7281036376953,
    "a": -6.79144477844238,
    "b": 16.9678554534912,
    "C": 18.276538848877,
    "h": 111.813934326172,
    "CMY_C": 0.14846414327621,
    "CMY_M": 0.13678920269012,
    "CMY_Y": 0.28089827299118,
    "CMYK_C": 0.01352501660585,
    "CMYK_M": 0,
    "CMYK_Y": 0.16694539785385,
    "CMYK_K": 0.13678920269012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09057",
    "Farbtonhilfsbezeichnung": "H7.18.71",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "195",
    "Bcolor": "149",
    "Y": 51.8010749816895,
    "L": 77.161735534668,
    "a": -10.968544960022,
    "b": 21.3468551635742,
    "C": 23.9999408721924,
    "h": 117.19522857666,
    "CMY_C": 0.27280151844025,
    "CMY_M": 0.23336911201477,
    "CMY_Y": 0.41392427682877,
    "CMYK_C": 0.05143597349524,
    "CMYK_M": 0,
    "CMYK_Y": 0.23551772534847,
    "CMYK_K": 0.23336911201477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09058",
    "Farbtonhilfsbezeichnung": "H7.26.62",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "172",
    "Bcolor": "117",
    "Y": 38.6092224121094,
    "L": 68.4672470092773,
    "a": -12.3193607330322,
    "b": 26.4738712310791,
    "C": 29.1998710632324,
    "h": 114.954460144043,
    "CMY_C": 0.36319524049759,
    "CMY_M": 0.32458275556564,
    "CMY_Y": 0.53924006223679,
    "CMYK_C": 0.0571683421731,
    "CMYK_M": 0,
    "CMYK_Y": 0.3178143799305,
    "CMYK_K": 0.32458275556564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09059",
    "Farbtonhilfsbezeichnung": "H6.45.44",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "132",
    "Bcolor": "66",
    "Y": 20.707181930542,
    "L": 52.6275253295898,
    "a": -15.5209693908691,
    "b": 33.0910911560059,
    "C": 36.5502510070801,
    "h": 115.128341674805,
    "CMY_C": 0.53683805465698,
    "CMY_M": 0.48306685686111,
    "CMY_Y": 0.74030566215515,
    "CMYK_C": 0.10401963442564,
    "CMYK_M": 0,
    "CMYK_Y": 0.49762490391731,
    "CMYK_K": 0.48306685686111
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09060",
    "Farbtonhilfsbezeichnung": "J4.26.26",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "89",
    "Bcolor": "65",
    "Y": 8.97535800933838,
    "L": 35.9368095397949,
    "a": -10.1041774749756,
    "b": 11.8819036483765,
    "C": 15.5972442626953,
    "h": 130.377304077148,
    "CMY_C": 0.70500421524048,
    "CMY_M": 0.65218436717987,
    "CMY_Y": 0.74663901329041,
    "CMYK_C": 0.15186162292957,
    "CMYK_M": 0,
    "CMYK_Y": 0.27156525850296,
    "CMYK_K": 0.65218436717987
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09061",
    "Farbtonhilfsbezeichnung": "H7.15.84",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "230",
    "Bcolor": "184",
    "Y": 75.7886505126953,
    "L": 89.7611236572266,
    "a": -9.46885395050049,
    "b": 20.7838039398193,
    "C": 22.8391265869141,
    "h": 114.493446350098,
    "CMY_C": 0.12470924854279,
    "CMY_M": 0.09799063205719,
    "CMY_Y": 0.27738624811172,
    "CMYK_C": 0.02962121926248,
    "CMYK_M": 0,
    "CMYK_Y": 0.19888442754745,
    "CMYK_K": 0.09799063205719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09062",
    "Farbtonhilfsbezeichnung": "H7.23.82",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "227",
    "Bcolor": "162",
    "Y": 72.1473541259766,
    "L": 88.0394668579102,
    "a": -12.9847040176392,
    "b": 29.6676273345947,
    "C": 32.3847274780273,
    "h": 113.637672424316,
    "CMY_C": 0.14775341749191,
    "CMY_M": 0.11133128404617,
    "CMY_Y": 0.36301428079605,
    "CMYK_C": 0.04098505154252,
    "CMYK_M": 0,
    "CMYK_Y": 0.28321352601051,
    "CMYK_K": 0.11133128404617
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09063",
    "Farbtonhilfsbezeichnung": "H7.44.70",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "201",
    "Bcolor": "92",
    "Y": 52.1880226135254,
    "L": 77.3931274414063,
    "a": -22.8185329437256,
    "b": 50.5075263977051,
    "C": 55.4228820800781,
    "h": 114.312728881836,
    "CMY_C": 0.29618602991104,
    "CMY_M": 0.21178996562958,
    "CMY_Y": 0.63757789134979,
    "CMYK_C": 0.10707306861877,
    "CMYK_M": 0,
    "CMYK_Y": 0.54019600152969,
    "CMYK_K": 0.21178996562958
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09064",
    "Farbtonhilfsbezeichnung": "H6.54.63",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "181",
    "Bcolor": "69",
    "Y": 40.1290283203125,
    "L": 69.5613327026367,
    "a": -25.1651344299316,
    "b": 52.0406188964844,
    "C": 57.805793762207,
    "h": 115.806884765625,
    "CMY_C": 0.39678817987442,
    "CMY_M": 0.29205858707428,
    "CMY_Y": 0.73130851984024,
    "CMYK_C": 0.14793539047241,
    "CMYK_M": 0,
    "CMYK_Y": 0.62046086788177,
    "CMYK_K": 0.29205858707428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09065",
    "Farbtonhilfsbezeichnung": "J7.39.25",
    "Farbtonklasse": "04",
    "Rcolor": "74",
    "Gcolor": "93",
    "Bcolor": "64",
    "Y": 9.66988468170166,
    "L": 37.2433128356934,
    "a": -13.0284614562988,
    "b": 13.9878902435303,
    "C": 19.1154880523682,
    "h": 132.966125488281,
    "CMY_C": 0.70835655927658,
    "CMY_M": 0.6352863907814,
    "CMY_Y": 0.74881744384766,
    "CMYK_C": 0.20034945011139,
    "CMYK_M": 0,
    "CMYK_Y": 0.31128823757172,
    "CMYK_K": 0.6352863907814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09066",
    "Farbtonhilfsbezeichnung": "H7.34.75",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "210",
    "Bcolor": "120",
    "Y": 58.1034355163574,
    "L": 80.7962646484375,
    "a": -20.764591217041,
    "b": 41.5773849487305,
    "C": 46.4741554260254,
    "h": 116.538475036621,
    "CMY_C": 0.2600936293602,
    "CMY_M": 0.17736965417862,
    "CMY_Y": 0.53062111139297,
    "CMYK_C": 0.10056032240391,
    "CMYK_M": 0,
    "CMYK_Y": 0.42941701412201,
    "CMYK_K": 0.17736965417862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09067",
    "Farbtonhilfsbezeichnung": "J2.46.39",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "122",
    "Bcolor": "65",
    "Y": 16.8338127136231,
    "L": 48.0499572753906,
    "a": -19.1051330566406,
    "b": 27.6119327545166,
    "C": 33.5771484375,
    "h": 124.679969787598,
    "CMY_C": 0.61840271949768,
    "CMY_M": 0.52201700210571,
    "CMY_Y": 0.74387049674988,
    "CMYK_C": 0.20165093243122,
    "CMYK_M": 0,
    "CMYK_Y": 0.46414515376091,
    "CMYK_K": 0.52201700210571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09068",
    "Farbtonhilfsbezeichnung": "J3.25.76",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "215",
    "Bcolor": "151",
    "Y": 61.3528137207031,
    "L": 82.5680465698242,
    "a": -19.4522342681885,
    "b": 27.7898483276367,
    "C": 33.9214553833008,
    "h": 124.991111755371,
    "CMY_C": 0.26296192407608,
    "CMY_M": 0.15817147493362,
    "CMY_Y": 0.40714871883392,
    "CMYK_C": 0.12447956204414,
    "CMYK_M": 0,
    "CMYK_Y": 0.29575768113136,
    "CMYK_K": 0.15817147493362
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09069",
    "Farbtonhilfsbezeichnung": "J3.29.73",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "206",
    "Bcolor": "138",
    "Y": 55.2116279602051,
    "L": 79.1630096435547,
    "a": -21.5650272369385,
    "b": 30.0263214111328,
    "C": 36.9679641723633,
    "h": 125.686065673828,
    "CMY_C": 0.31076002120972,
    "CMY_M": 0.19184446334839,
    "CMY_Y": 0.45930802822113,
    "CMYK_C": 0.14714439213276,
    "CMYK_M": 0,
    "CMYK_Y": 0.33095556497574,
    "CMYK_K": 0.19184446334839
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09070",
    "Farbtonhilfsbezeichnung": "J4.39.66",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "194",
    "Bcolor": "107",
    "Y": 46.0211143493652,
    "L": 73.5592346191406,
    "a": -29.3147926330566,
    "b": 38.1931304931641,
    "C": 48.1463623046875,
    "h": 127.507720947266,
    "CMY_C": 0.41327464580536,
    "CMY_M": 0.23988050222397,
    "CMY_Y": 0.57928943634033,
    "CMYK_C": 0.22811432182789,
    "CMYK_M": 0,
    "CMYK_Y": 0.44652050733566,
    "CMYK_K": 0.23988050222397
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09071",
    "Farbtonhilfsbezeichnung": "J1.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "238",
    "Bcolor": "216",
    "Y": 83.5368881225586,
    "L": 93.2489852905273,
    "a": -5.52558946609497,
    "b": 9.02745723724365,
    "C": 10.5842866897583,
    "h": 121.470252990723,
    "CMY_C": 0.08992612361908,
    "CMY_M": 0.06502878665924,
    "CMY_Y": 0.15121638774872,
    "CMYK_C": 0.02662898786366,
    "CMYK_M": 0,
    "CMYK_Y": 0.0921820923686,
    "CMYK_K": 0.06502878665924
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09072",
    "Farbtonhilfsbezeichnung": "J3.09.86",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "236",
    "Bcolor": "206",
    "Y": 80.9757308959961,
    "L": 92.1208877563477,
    "a": -8.05855083465576,
    "b": 12.6527948379517,
    "C": 15.0011148452759,
    "h": 122.493011474609,
    "CMY_C": 0.11118322610855,
    "CMY_M": 0.07285094261169,
    "CMY_Y": 0.19098776578903,
    "CMYK_C": 0.04134425148368,
    "CMYK_M": 0,
    "CMYK_Y": 0.12741945683956,
    "CMYK_K": 0.07285094261169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09073",
    "Farbtonhilfsbezeichnung": "J3.17.83",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "229",
    "Bcolor": "182",
    "Y": 73.1022872924805,
    "L": 88.4964752197266,
    "a": -14.0210580825806,
    "b": 20.1461620330811,
    "C": 24.5450172424316,
    "h": 124.836639404297,
    "CMY_C": 0.17618781328201,
    "CMY_M": 0.10207736492157,
    "CMY_Y": 0.28686982393265,
    "CMYK_C": 0.08253545314074,
    "CMYK_M": 0,
    "CMYK_Y": 0.20579998195171,
    "CMYK_K": 0.10207736492157
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09074",
    "Farbtonhilfsbezeichnung": "J4.34.70",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "199",
    "Bcolor": "123",
    "Y": 50.0068016052246,
    "L": 76.0734329223633,
    "a": -25.1999816894531,
    "b": 33.7377967834473,
    "C": 42.1103057861328,
    "h": 126.757385253906,
    "CMY_C": 0.36368358135223,
    "CMY_M": 0.21932077407837,
    "CMY_Y": 0.51925992965698,
    "CMYK_C": 0.18491949141026,
    "CMYK_M": 0,
    "CMYK_Y": 0.38420280814171,
    "CMYK_K": 0.21932077407837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09075",
    "Farbtonhilfsbezeichnung": "J3.47.62",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "181",
    "Bcolor": "85",
    "Y": 39.1450729370117,
    "L": 68.8562240600586,
    "a": -30.245584487915,
    "b": 43.20068359375,
    "C": 52.736083984375,
    "h": 124.996559143066,
    "CMY_C": 0.45965498685837,
    "CMY_M": 0.28968191146851,
    "CMY_Y": 0.66551691293716,
    "CMYK_C": 0.2392914891243,
    "CMYK_M": 0,
    "CMYK_Y": 0.52910804748535,
    "CMYK_K": 0.28968191146851
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09076",
    "Farbtonhilfsbezeichnung": "J6.63.48",
    "Farbtonklasse": "04",
    "Rcolor": "91",
    "Gcolor": "151",
    "Bcolor": "58",
    "Y": 24.7433490753174,
    "L": 56.8244895935059,
    "a": -36.5418739318848,
    "b": 41.4244613647461,
    "C": 55.238525390625,
    "h": 131.416564941406,
    "CMY_C": 0.64373987913132,
    "CMY_M": 0.40681326389313,
    "CMY_Y": 0.77071291208267,
    "CMYK_C": 0.39941319823265,
    "CMYK_M": 0,
    "CMYK_Y": 0.61346560716629,
    "CMYK_K": 0.40681326389313
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09077",
    "Farbtonhilfsbezeichnung": "J3.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "235",
    "Bcolor": "214",
    "Y": 80.9984893798828,
    "L": 92.1310195922852,
    "a": -5.53784418106079,
    "b": 8.89096832275391,
    "C": 10.4745903015137,
    "h": 121.917198181152,
    "CMY_C": 0.10294246673584,
    "CMY_M": 0.07750695943832,
    "CMY_Y": 0.16244399547577,
    "CMYK_C": 0.02757257409394,
    "CMYK_M": 0,
    "CMYK_Y": 0.09207336604595,
    "CMYK_K": 0.07750695943832
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09078",
    "Farbtonhilfsbezeichnung": "J3.13.81",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "224",
    "Bcolor": "188",
    "Y": 70.8048095703125,
    "L": 87.3900909423828,
    "a": -10.584602355957,
    "b": 15.6103620529175,
    "C": 18.860466003418,
    "h": 124.139221191406,
    "CMY_C": 0.1745223402977,
    "CMY_M": 0.12077230215073,
    "CMY_Y": 0.26439410448074,
    "CMYK_C": 0.06113323941827,
    "CMYK_M": 0,
    "CMYK_Y": 0.16334995627403,
    "CMYK_K": 0.12077230215073
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09079",
    "Farbtonhilfsbezeichnung": "J4.18.75",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "211",
    "Bcolor": "165",
    "Y": 60.7263107299805,
    "L": 82.2313919067383,
    "a": -13.7869548797607,
    "b": 20.0677509307861,
    "C": 24.347375869751,
    "h": 124.489852905273,
    "CMY_C": 0.24308466911316,
    "CMY_M": 0.17192041873932,
    "CMY_Y": 0.35240691900253,
    "CMYK_C": 0.08593890070915,
    "CMYK_M": 0,
    "CMYK_Y": 0.21795791387558,
    "CMYK_K": 0.17192041873932
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09080",
    "Farbtonhilfsbezeichnung": "J3.23.69",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "194",
    "Bcolor": "139",
    "Y": 49.2305564880371,
    "L": 75.5945358276367,
    "a": -16.8653450012207,
    "b": 24.5214710235596,
    "C": 29.7614250183106,
    "h": 124.51936340332,
    "CMY_C": 0.32635760307312,
    "CMY_M": 0.23891639709473,
    "CMY_Y": 0.45416653156281,
    "CMYK_C": 0.11489041149616,
    "CMYK_M": 0,
    "CMYK_Y": 0.28282061219215,
    "CMYK_K": 0.23891639709473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09081",
    "Farbtonhilfsbezeichnung": "J2.51.45",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "139",
    "Bcolor": "66",
    "Y": 21.9766807556152,
    "L": 54.0022506713867,
    "a": -24.1798934936523,
    "b": 34.7945365905762,
    "C": 42.3712997436523,
    "h": 124.796737670898,
    "CMY_C": 0.58266949653625,
    "CMY_M": 0.45446592569351,
    "CMY_Y": 0.74218535423279,
    "CMYK_C": 0.23500561714172,
    "CMYK_M": 0,
    "CMYK_Y": 0.52740871906281,
    "CMYK_K": 0.45446592569351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09082",
    "Farbtonhilfsbezeichnung": "J8.38.37",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "117",
    "Bcolor": "75",
    "Y": 15.4282388687134,
    "L": 46.2152404785156,
    "a": -18.6174488067627,
    "b": 19.5670700073242,
    "C": 27.0088806152344,
    "h": 133.575393676758,
    "CMY_C": 0.651282787323,
    "CMY_M": 0.53990483283997,
    "CMY_Y": 0.70512783527374,
    "CMYK_C": 0.24207590520382,
    "CMYK_M": 0,
    "CMYK_Y": 0.35910615324974,
    "CMYK_K": 0.53990483283997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09083",
    "Farbtonhilfsbezeichnung": "J3.23.57",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "162",
    "Bcolor": "120",
    "Y": 33.5075798034668,
    "L": 64.5698089599609,
    "a": -12.1414251327515,
    "b": 19.7514610290527,
    "C": 23.1847877502441,
    "h": 121.579467773438,
    "CMY_C": 0.41882222890854,
    "CMY_M": 0.36469984054565,
    "CMY_Y": 0.52985638380051,
    "CMYK_C": 0.08519183844328,
    "CMYK_M": 0,
    "CMYK_Y": 0.25996616482735,
    "CMYK_K": 0.36469984054565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09084",
    "Farbtonhilfsbezeichnung": "J2.39.42",
    "Farbtonklasse": "03",
    "Rcolor": "105",
    "Gcolor": "128",
    "Bcolor": "74",
    "Y": 18.960916519165,
    "L": 50.6414527893066,
    "a": -18.0093460083008,
    "b": 25.9690971374512,
    "C": 31.6026992797852,
    "h": 124.74097442627,
    "CMY_C": 0.58830237388611,
    "CMY_M": 0.497722864151,
    "CMY_Y": 0.70813190937042,
    "CMYK_C": 0.18033771216869,
    "CMYK_M": 0,
    "CMYK_Y": 0.41891026496887,
    "CMYK_K": 0.497722864151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09085",
    "Farbtonhilfsbezeichnung": "J3.40.31",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "105",
    "Bcolor": "64",
    "Y": 12.6527757644653,
    "L": 42.2353363037109,
    "a": -13.7604694366455,
    "b": 20.7445945739746,
    "C": 24.8935470581055,
    "h": 123.557426452637,
    "CMY_C": 0.65089195966721,
    "CMY_M": 0.58720850944519,
    "CMY_Y": 0.74844390153885,
    "CMYK_C": 0.1542751044035,
    "CMYK_M": 0,
    "CMYK_Y": 0.39059767127037,
    "CMYK_K": 0.58720850944519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09086",
    "Farbtonhilfsbezeichnung": "J2.04.87",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "235",
    "Bcolor": "222",
    "Y": 81.724479675293,
    "L": 92.4531173706055,
    "a": -3.48530507087708,
    "b": 5.23145771026611,
    "C": 6.28613567352295,
    "h": 123.672378540039,
    "CMY_C": 0.09498715400696,
    "CMY_M": 0.07766407728195,
    "CMY_Y": 0.13136738538742,
    "CMYK_C": 0.01878174394369,
    "CMYK_M": 0,
    "CMYK_Y": 0.05822532251477,
    "CMYK_K": 0.07766407728195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09087",
    "Farbtonhilfsbezeichnung": "J3.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "226",
    "Bcolor": "205",
    "Y": 74.0657653808594,
    "L": 88.9535598754883,
    "a": -6.02024793624878,
    "b": 8.88156509399414,
    "C": 10.7296590805054,
    "h": 124.130844116211,
    "CMY_C": 0.14207208156586,
    "CMY_M": 0.11188215017319,
    "CMY_Y": 0.19706547260284,
    "CMYK_C": 0.03399315848947,
    "CMYK_M": 0,
    "CMYK_Y": 0.09591443836689,
    "CMYK_K": 0.11188215017319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09088",
    "Farbtonhilfsbezeichnung": "J3.11.76",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "207",
    "Bcolor": "177",
    "Y": 59.6869468688965,
    "L": 81.6677322387695,
    "a": -8.72534656524658,
    "b": 13.1071882247925,
    "C": 15.745795249939,
    "h": 123.651382446289,
    "CMY_C": 0.22998762130737,
    "CMY_M": 0.18731951713562,
    "CMY_Y": 0.30655068159103,
    "CMYK_C": 0.05250292643905,
    "CMYK_M": 0,
    "CMYK_Y": 0.14671346545219,
    "CMYK_K": 0.18731951713562
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09089",
    "Farbtonhilfsbezeichnung": "J3.14.63",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "175",
    "Bcolor": "145",
    "Y": 40.5599555969238,
    "L": 69.8665084838867,
    "a": -9.40974140167236,
    "b": 13.4039735794067,
    "C": 16.3771095275879,
    "h": 125.069290161133,
    "CMY_C": 0.36034709215164,
    "CMY_M": 0.31312853097916,
    "CMY_Y": 0.43138402700424,
    "CMYK_C": 0.06874439120293,
    "CMYK_M": 0,
    "CMYK_Y": 0.17216539382935,
    "CMYK_K": 0.31312853097916
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09090",
    "Farbtonhilfsbezeichnung": "J3.19.55",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "156",
    "Bcolor": "121",
    "Y": 31.1003513336182,
    "L": 62.5922584533691,
    "a": -10.7729940414429,
    "b": 16.367280960083,
    "C": 19.5945224761963,
    "h": 123.353042602539,
    "CMY_C": 0.43790197372437,
    "CMY_M": 0.387362241745,
    "CMY_Y": 0.52549207210541,
    "CMYK_C": 0.08249529451132,
    "CMYK_M": 0,
    "CMYK_Y": 0.22546738386154,
    "CMYK_K": 0.387362241745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09091",
    "Farbtonhilfsbezeichnung": "J3.25.46",
    "Farbtonklasse": "03",
    "Rcolor": "121",
    "Gcolor": "136",
    "Bcolor": "100",
    "Y": 22.6162204742432,
    "L": 54.6748123168945,
    "a": -12.0298156738281,
    "b": 17.1824111938477,
    "C": 20.975025177002,
    "h": 124.996780395508,
    "CMY_C": 0.52525019645691,
    "CMY_M": 0.46635472774506,
    "CMY_Y": 0.60843884944916,
    "CMYK_C": 0.11036445200443,
    "CMYK_M": 0,
    "CMYK_Y": 0.26625201106071,
    "CMYK_K": 0.46635472774506
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09092",
    "Farbtonhilfsbezeichnung": "J2.33.36",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "112",
    "Bcolor": "74",
    "Y": 14.5756425857544,
    "L": 45.0474090576172,
    "a": -12.8311996459961,
    "b": 18.8468952178955,
    "C": 22.8001136779785,
    "h": 124.247520446777,
    "CMY_C": 0.62155723571777,
    "CMY_M": 0.56113463640213,
    "CMY_Y": 0.71006143093109,
    "CMYK_C": 0.13767912983894,
    "CMYK_M": 0,
    "CMYK_Y": 0.33934506773949,
    "CMYK_K": 0.56113463640213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09093",
    "Farbtonhilfsbezeichnung": "J0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "234",
    "Bcolor": "224",
    "Y": 80.7850799560547,
    "L": 92.0359725952148,
    "a": -2.44641828536987,
    "b": 3.51656746864319,
    "C": 4.28383111953735,
    "h": 124.825698852539,
    "CMY_C": 0.09711098670959,
    "CMY_M": 0.08428645133972,
    "CMY_Y": 0.1230656504631,
    "CMYK_C": 0.01400496438146,
    "CMYK_M": 0,
    "CMYK_Y": 0.04234861209989,
    "CMYK_K": 0.08428645133972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09094",
    "Farbtonhilfsbezeichnung": "K0.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "224",
    "Bcolor": "210",
    "Y": 72.7916030883789,
    "L": 88.3482284545898,
    "a": -4.70586252212524,
    "b": 5.46436262130737,
    "C": 7.21140766143799,
    "h": 130.734756469727,
    "CMY_C": 0.14947557449341,
    "CMY_M": 0.12070310115814,
    "CMY_Y": 0.17822688817978,
    "CMYK_C": 0.0327221378684,
    "CMYK_M": 0,
    "CMYK_Y": 0.06542021036148,
    "CMYK_K": 0.12070310115814
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09095",
    "Farbtonhilfsbezeichnung": "K0.05.77",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "211",
    "Bcolor": "195",
    "Y": 63.2682075500488,
    "L": 83.5832977294922,
    "a": -5.73530387878418,
    "b": 6.31109094619751,
    "C": 8.52781200408936,
    "h": 132.263488769531,
    "CMY_C": 0.20706915855408,
    "CMY_M": 0.17122375965118,
    "CMY_Y": 0.23615103960037,
    "CMYK_C": 0.04325099661946,
    "CMYK_M": 0,
    "CMYK_Y": 0.0783411487937,
    "CMYK_K": 0.17122375965118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09096",
    "Farbtonhilfsbezeichnung": "J9.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "199",
    "Bcolor": "182",
    "Y": 54.8998641967773,
    "L": 78.9835586547852,
    "a": -6.79301500320435,
    "b": 6.50421142578125,
    "C": 9.40477657318115,
    "h": 136.244216918945,
    "CMY_C": 0.26452839374542,
    "CMY_M": 0.21918004751205,
    "CMY_Y": 0.28683227300644,
    "CMYK_C": 0.05807785317302,
    "CMYK_M": 0,
    "CMYK_Y": 0.08664254099131,
    "CMYK_K": 0.21918004751205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09097",
    "Farbtonhilfsbezeichnung": "J9.10.64",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "179",
    "Bcolor": "159",
    "Y": 43.0319213867188,
    "L": 71.5766296386719,
    "a": -8.05302810668945,
    "b": 7.95451211929321,
    "C": 11.3192548751831,
    "h": 135.352615356445,
    "CMY_C": 0.3484258055687,
    "CMY_M": 0.29652976989746,
    "CMY_Y": 0.37505483627319,
    "CMYK_C": 0.07377147674561,
    "CMYK_M": 0,
    "CMYK_Y": 0.11162528395653,
    "CMYK_K": 0.29652976989746
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09098",
    "Farbtonhilfsbezeichnung": "J9.15.50",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "144",
    "Bcolor": "120",
    "Y": 25.7288360595703,
    "L": 57.7787590026855,
    "a": -10.3064117431641,
    "b": 9.87073612213135,
    "C": 14.2707233428955,
    "h": 136.236968994141,
    "CMY_C": 0.50158643722534,
    "CMY_M": 0.43658167123795,
    "CMY_Y": 0.52822285890579,
    "CMYK_C": 0.11537566781044,
    "CMYK_M": 0,
    "CMYK_Y": 0.16265211999416,
    "CMYK_K": 0.43658167123795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09099",
    "Farbtonhilfsbezeichnung": "J8.19.33",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "103",
    "Bcolor": "84",
    "Y": 12.7184925079346,
    "L": 42.3359832763672,
    "a": -7.58186149597168,
    "b": 9.33622455596924,
    "C": 12.0270404815674,
    "h": 129.079727172852,
    "CMY_C": 0.63417160511017,
    "CMY_M": 0.59525179862976,
    "CMY_Y": 0.67199665307999,
    "CMYK_C": 0.09615807235241,
    "CMYK_M": 0,
    "CMYK_Y": 0.18961136043072,
    "CMYK_K": 0.59525179862976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09100",
    "Farbtonhilfsbezeichnung": "J9.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "235",
    "Bcolor": "221",
    "Y": 80.7004547119141,
    "L": 91.9982299804688,
    "a": -4.54527473449707,
    "b": 4.74151945114136,
    "C": 6.56822109222412,
    "h": 133.789428710938,
    "CMY_C": 0.11018079519272,
    "CMY_M": 0.0801767706871,
    "CMY_Y": 0.13288307189941,
    "CMYK_C": 0.03261933848262,
    "CMYK_M": 0,
    "CMYK_Y": 0.05730046704412,
    "CMYK_K": 0.0801767706871
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09101",
    "Farbtonhilfsbezeichnung": "J9.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "227",
    "Bcolor": "203",
    "Y": 73.3964385986328,
    "L": 88.6364440917969,
    "a": -8.19339752197266,
    "b": 9.24178504943848,
    "C": 12.3508033752441,
    "h": 131.55891418457,
    "CMY_C": 0.1617169380188,
    "CMY_M": 0.11063569784164,
    "CMY_Y": 0.20348930358887,
    "CMYK_C": 0.0574356764555,
    "CMYK_M": 0,
    "CMYK_Y": 0.10440446436405,
    "CMYK_K": 0.11063569784164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09102",
    "Farbtonhilfsbezeichnung": "J9.07.78",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "214",
    "Bcolor": "195",
    "Y": 64.2688446044922,
    "L": 84.1055526733398,
    "a": -7.81043577194214,
    "b": 7.01708316802979,
    "C": 10.4996366500854,
    "h": 138.062713623047,
    "CMY_C": 0.21555787324905,
    "CMY_M": 0.16107493638992,
    "CMY_Y": 0.23598593473434,
    "CMYK_C": 0.06494374573231,
    "CMYK_M": 0,
    "CMYK_Y": 0.0892940312624,
    "CMYK_K": 0.16107493638992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09103",
    "Farbtonhilfsbezeichnung": "J9.15.72",
    "Farbtonklasse": "02",
    "Rcolor": "178",
    "Gcolor": "203",
    "Bcolor": "168",
    "Y": 54.7976303100586,
    "L": 78.924560546875,
    "a": -14.2480010986328,
    "b": 13.967339515686,
    "C": 19.9522457122803,
    "h": 135.569915771484,
    "CMY_C": 0.30061948299408,
    "CMY_M": 0.20584917068481,
    "CMY_Y": 0.34251040220261,
    "CMYK_C": 0.11933540552855,
    "CMYK_M": 0,
    "CMYK_Y": 0.1720847338438,
    "CMYK_K": 0.20584917068481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09104",
    "Farbtonhilfsbezeichnung": "J9.21.65",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "184",
    "Bcolor": "145",
    "Y": 43.6653938293457,
    "L": 72.004280090332,
    "a": -16.5195922851563,
    "b": 16.3962230682373,
    "C": 23.2751598358154,
    "h": 135.214736938477,
    "CMY_C": 0.38457858562469,
    "CMY_M": 0.27668595314026,
    "CMY_Y": 0.43194484710693,
    "CMYK_C": 0.14916430413723,
    "CMYK_M": 0,
    "CMYK_Y": 0.21464934945107,
    "CMYK_K": 0.27668595314026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09105",
    "Farbtonhilfsbezeichnung": "J9.30.47",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "140",
    "Bcolor": "98",
    "Y": 23.26881980896,
    "L": 55.3481559753418,
    "a": -17.9549598693848,
    "b": 19.1985607147217,
    "C": 26.2862186431885,
    "h": 133.082916259766,
    "CMY_C": 0.55784028768539,
    "CMY_M": 0.44906789064407,
    "CMY_Y": 0.61676234006882,
    "CMYK_C": 0.19743339717388,
    "CMYK_M": 0,
    "CMYK_Y": 0.30438315868378,
    "CMYK_K": 0.44906789064407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09106",
    "Farbtonhilfsbezeichnung": "J9.21.41",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "123",
    "Bcolor": "96",
    "Y": 18.1005687713623,
    "L": 49.617862701416,
    "a": -11.5885810852051,
    "b": 12.0971670150757,
    "C": 16.7522144317627,
    "h": 133.769927978516,
    "CMY_C": 0.5854252576828,
    "CMY_M": 0.51703786849976,
    "CMY_Y": 0.6223509311676,
    "CMYK_C": 0.14159989356995,
    "CMYK_M": 0,
    "CMYK_Y": 0.21805655956268,
    "CMYK_K": 0.51703786849976
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09107",
    "Farbtonhilfsbezeichnung": "K0.13.80",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "223",
    "Bcolor": "189",
    "Y": 68.8549118041992,
    "L": 86.4321517944336,
    "a": -13.9556751251221,
    "b": 13.5619058609009,
    "C": 19.4598598480225,
    "h": 135.81982421875,
    "CMY_C": 0.21853238344193,
    "CMY_M": 0.12371736764908,
    "CMY_Y": 0.26000988483429,
    "CMYK_C": 0.10820140689611,
    "CMYK_M": 0,
    "CMYK_Y": 0.15553487837315,
    "CMYK_K": 0.12371736764908
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09108",
    "Farbtonhilfsbezeichnung": "J9.20.70",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "196",
    "Bcolor": "151",
    "Y": 49.8563117980957,
    "L": 75.9809799194336,
    "a": -18.2859859466553,
    "b": 18.411771774292,
    "C": 25.9493865966797,
    "h": 134.803619384766,
    "CMY_C": 0.35090398788452,
    "CMY_M": 0.23073476552963,
    "CMY_Y": 0.40594923496246,
    "CMYK_C": 0.15621298551559,
    "CMYK_M": 0,
    "CMYK_Y": 0.22776859998703,
    "CMYK_K": 0.23073476552963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09109",
    "Farbtonhilfsbezeichnung": "J9.30.59",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "173",
    "Bcolor": "119",
    "Y": 36.5574760437012,
    "L": 66.9436950683594,
    "a": -22.3421649932861,
    "b": 23.4839591979981,
    "C": 32.4140205383301,
    "h": 133.572723388672,
    "CMY_C": 0.46352732181549,
    "CMY_M": 0.32109582424164,
    "CMY_Y": 0.53459542989731,
    "CMYK_C": 0.20979617536068,
    "CMYK_M": 0,
    "CMYK_Y": 0.31447678804398,
    "CMYK_K": 0.32109582424164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09110",
    "Farbtonhilfsbezeichnung": "J9.47.61",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "183",
    "Bcolor": "95",
    "Y": 38.7532196044922,
    "L": 68.5721282958984,
    "a": -36.6408576965332,
    "b": 37.9823455810547,
    "C": 52.7750968933105,
    "h": 133.970123291016,
    "CMY_C": 0.53043240308762,
    "CMY_M": 0.28146684169769,
    "CMY_Y": 0.62875413894653,
    "CMYK_C": 0.34649139642715,
    "CMYK_M": 0,
    "CMYK_Y": 0.48332813382149,
    "CMYK_K": 0.28146684169769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09111",
    "Farbtonhilfsbezeichnung": "J9.50.38",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "124",
    "Bcolor": "65",
    "Y": 16.4398078918457,
    "L": 47.5462913513184,
    "a": -26.9139995574951,
    "b": 26.8511657714844,
    "C": 38.0177383422852,
    "h": 135.066970825195,
    "CMY_C": 0.68706738948822,
    "CMY_M": 0.51457852125168,
    "CMY_Y": 0.74463218450546,
    "CMYK_C": 0.35533836483955,
    "CMYK_M": 0,
    "CMYK_Y": 0.47392559051514,
    "CMYK_K": 0.51457852125168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09112",
    "Farbtonhilfsbezeichnung": "J9.13.83",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "233",
    "Bcolor": "197",
    "Y": 76.1333084106445,
    "L": 89.9211959838867,
    "a": -13.1535177230835,
    "b": 14.1107044219971,
    "C": 19.2905941009521,
    "h": 132.989303588867,
    "CMY_C": 0.17198151350021,
    "CMY_M": 0.08664971590042,
    "CMY_Y": 0.22646951675415,
    "CMYK_C": 0.09342724084854,
    "CMYK_M": 0,
    "CMYK_Y": 0.15308453142643,
    "CMYK_K": 0.08664971590042
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09113",
    "Farbtonhilfsbezeichnung": "J9.21.79",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "226",
    "Bcolor": "172",
    "Y": 68.4361419677734,
    "L": 86.2240676879883,
    "a": -20.5930519104004,
    "b": 21.9201469421387,
    "C": 30.0760135650635,
    "h": 133.212036132813,
    "CMY_C": 0.24931085109711,
    "CMY_M": 0.11419981718063,
    "CMY_Y": 0.32528805732727,
    "CMYK_C": 0.15252992510796,
    "CMYK_M": 0,
    "CMYK_Y": 0.23830232024193,
    "CMYK_K": 0.11419981718063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09114",
    "Farbtonhilfsbezeichnung": "J9.34.69",
    "Farbtonklasse": "02",
    "Rcolor": "150",
    "Gcolor": "204",
    "Bcolor": "129",
    "Y": 51.0628776550293,
    "L": 76.7170791625977,
    "a": -30.8324413299561,
    "b": 31.3233547210693,
    "C": 43.9521560668945,
    "h": 134.547485351563,
    "CMY_C": 0.41078400611877,
    "CMY_M": 0.20167660713196,
    "CMY_Y": 0.49565452337265,
    "CMYK_C": 0.2619332075119,
    "CMYK_M": 0,
    "CMYK_Y": 0.36824414134026,
    "CMYK_K": 0.20167660713196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09115",
    "Farbtonhilfsbezeichnung": "K5.38.62",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "185",
    "Bcolor": "116",
    "Y": 39.7180862426758,
    "L": 69.2682647705078,
    "a": -34.6491966247559,
    "b": 27.7107410430908,
    "C": 44.3672409057617,
    "h": 141.348876953125,
    "CMY_C": 0.53556299209595,
    "CMY_M": 0.27568870782852,
    "CMY_Y": 0.54429662227631,
    "CMYK_C": 0.35878810286522,
    "CMYK_M": 0,
    "CMYK_Y": 0.37084594368935,
    "CMYK_K": 0.27568870782852
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09116",
    "Farbtonhilfsbezeichnung": "K5.61.45",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "147",
    "Bcolor": "70",
    "Y": 22.1208114624023,
    "L": 54.154956817627,
    "a": -43.6758117675781,
    "b": 32.3601722717285,
    "C": 54.3576774597168,
    "h": 143.464614868164,
    "CMY_C": 0.78170639276505,
    "CMY_M": 0.42372679710388,
    "CMY_Y": 0.72652751207352,
    "CMYK_C": 0.62119770050049,
    "CMYK_M": 0,
    "CMYK_Y": 0.52544647455215,
    "CMYK_K": 0.42372679710388
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09117",
    "Farbtonhilfsbezeichnung": "K5.59.31",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "111",
    "Bcolor": "63",
    "Y": 12.5555629730225,
    "L": 42.0858116149902,
    "a": -30.4508380889893,
    "b": 20.7865982055664,
    "C": 36.8691787719727,
    "h": 145.681457519531,
    "CMY_C": 0.79400718212128,
    "CMY_M": 0.56320095062256,
    "CMY_Y": 0.75284421443939,
    "CMYK_C": 0.52840369939804,
    "CMYK_M": 0,
    "CMYK_Y": 0.43416592478752,
    "CMYK_K": 0.56320095062256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09118",
    "Farbtonhilfsbezeichnung": "K6.12.82",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "228",
    "Bcolor": "198",
    "Y": 71.8262100219727,
    "L": 87.8848724365234,
    "a": -14.3680114746094,
    "b": 10.7536745071411,
    "C": 17.9466228485107,
    "h": 143.187149047852,
    "CMY_C": 0.21550440788269,
    "CMY_M": 0.10601341724396,
    "CMY_Y": 0.22370421886444,
    "CMYK_C": 0.12247498333454,
    "CMYK_M": 0,
    "CMYK_Y": 0.13164716959,
    "CMYK_K": 0.10601341724396
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09119",
    "Farbtonhilfsbezeichnung": "K6.22.74",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "211",
    "Bcolor": "162",
    "Y": 56.7503204345703,
    "L": 80.0389556884766,
    "a": -25.7201042175293,
    "b": 18.4676055908203,
    "C": 31.6634845733643,
    "h": 144.320816040039,
    "CMY_C": 0.37129431962967,
    "CMY_M": 0.17210960388184,
    "CMY_Y": 0.3654437661171,
    "CMYK_C": 0.24059310555458,
    "CMYK_M": 0,
    "CMYK_Y": 0.23352627456188,
    "CMYK_K": 0.17210960388184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09120",
    "Farbtonhilfsbezeichnung": "K5.31.66",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "197",
    "Bcolor": "136",
    "Y": 46.7491836547852,
    "L": 74.029052734375,
    "a": -32.0161209106445,
    "b": 23.9249458312988,
    "C": 39.9679260253906,
    "h": 143.230041503906,
    "CMY_C": 0.47353935241699,
    "CMY_M": 0.22776198387146,
    "CMY_Y": 0.46826326847076,
    "CMYK_C": 0.31826633214951,
    "CMYK_M": 0,
    "CMYK_Y": 0.31143414974213,
    "CMYK_K": 0.22776198387146
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09121",
    "Farbtonhilfsbezeichnung": "K5.47.30",
    "Farbtonklasse": "04",
    "Rcolor": "61",
    "Gcolor": "105",
    "Bcolor": "64",
    "Y": 11.3763837814331,
    "L": 40.2073020935059,
    "a": -24.3568286895752,
    "b": 17.9622631072998,
    "C": 30.2638072967529,
    "h": 143.592590332031,
    "CMY_C": 0.76102995872498,
    "CMY_M": 0.5898569226265,
    "CMY_Y": 0.74987983703613,
    "CMYK_C": 0.41734957695007,
    "CMYK_M": 0,
    "CMYK_Y": 0.39016363024712,
    "CMYK_K": 0.5898569226265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09122",
    "Farbtonhilfsbezeichnung": "K6.10.81",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "228",
    "Bcolor": "202",
    "Y": 72.4449615478516,
    "L": 88.1823272705078,
    "a": -12.1456823348999,
    "b": 9.2877311706543,
    "C": 15.2898511886597,
    "h": 142.595077514648,
    "CMY_C": 0.19876724481583,
    "CMY_M": 0.10707312822342,
    "CMY_Y": 0.2093248963356,
    "CMYK_C": 0.1026893928647,
    "CMYK_M": 0,
    "CMYK_Y": 0.11451303958893,
    "CMYK_K": 0.10707312822342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09123",
    "Farbtonhilfsbezeichnung": "K5.14.77",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "218",
    "Bcolor": "185",
    "Y": 63.9741134643555,
    "L": 83.9522933959961,
    "a": -16.1267185211182,
    "b": 11.7814779281616,
    "C": 19.9718360900879,
    "h": 143.849761962891,
    "CMY_C": 0.26938498020172,
    "CMY_M": 0.1462704539299,
    "CMY_Y": 0.27370846271515,
    "CMYK_C": 0.14420787990093,
    "CMYK_M": 0,
    "CMYK_Y": 0.14927211403847,
    "CMYK_K": 0.1462704539299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09124",
    "Farbtonhilfsbezeichnung": "K5.29.61",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "178",
    "Bcolor": "129",
    "Y": 37.9071426391602,
    "L": 67.9521255493164,
    "a": -26.0969200134277,
    "b": 19.2975749969482,
    "C": 32.4568290710449,
    "h": 143.518630981445,
    "CMY_C": 0.49821901321411,
    "CMY_M": 0.30290335416794,
    "CMY_Y": 0.49515628814697,
    "CMYK_C": 0.28018447756767,
    "CMYK_M": 0,
    "CMYK_Y": 0.27579092979431,
    "CMYK_K": 0.30290335416794
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09125",
    "Farbtonhilfsbezeichnung": "K4.46.34",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "114",
    "Bcolor": "70",
    "Y": 13.6679382324219,
    "L": 43.7529029846191,
    "a": -24.7171840667725,
    "b": 18.9500389099121,
    "C": 31.1455154418945,
    "h": 142.523529052734,
    "CMY_C": 0.72733843326569,
    "CMY_M": 0.55461668968201,
    "CMY_Y": 0.72447842359543,
    "CMYK_C": 0.38780471682549,
    "CMYK_M": 0,
    "CMYK_Y": 0.38138324022293,
    "CMYK_K": 0.55461668968201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09126",
    "Farbtonhilfsbezeichnung": "L4.25.23",
    "Farbtonklasse": "04",
    "Rcolor": "66",
    "Gcolor": "87",
    "Bcolor": "74",
    "Y": 8.46713638305664,
    "L": 34.9374084472656,
    "a": -10.8430242538452,
    "b": 4.50789737701416,
    "C": 11.7427558898926,
    "h": 157.425308227539,
    "CMY_C": 0.74078381061554,
    "CMY_M": 0.65895938873291,
    "CMY_Y": 0.70963007211685,
    "CMYK_C": 0.23992574214935,
    "CMYK_M": 0,
    "CMYK_Y": 0.14857669174671,
    "CMYK_K": 0.65895938873291
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09127",
    "Farbtonhilfsbezeichnung": "K5.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "237",
    "Bcolor": "224",
    "Y": 82.3316955566406,
    "L": 92.7210540771484,
    "a": -4.99278116226196,
    "b": 4.15907764434814,
    "C": 6.49813747406006,
    "h": 140.205078125,
    "CMY_C": 0.10773861408234,
    "CMY_M": 0.07088851928711,
    "CMY_Y": 0.12064874172211,
    "CMYK_C": 0.03966164961457,
    "CMYK_M": 0,
    "CMYK_Y": 0.05355678498745,
    "CMYK_K": 0.07088851928711
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09128",
    "Farbtonhilfsbezeichnung": "K6.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "224",
    "Bcolor": "209",
    "Y": 72.1748275756836,
    "L": 88.0526733398438,
    "a": -6.10660552978516,
    "b": 5.22118806838989,
    "C": 8.03439044952393,
    "h": 139.469329833984,
    "CMY_C": 0.16475182771683,
    "CMY_M": 0.12075179815292,
    "CMY_Y": 0.17985361814499,
    "CMYK_C": 0.05004278570414,
    "CMYK_M": 0,
    "CMYK_Y": 0.06721858680248,
    "CMYK_K": 0.12075179815292
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09129",
    "Farbtonhilfsbezeichnung": "K5.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "212",
    "Bcolor": "194",
    "Y": 62.8520736694336,
    "L": 83.3644866943359,
    "a": -7.74047136306763,
    "b": 6.430251121521,
    "C": 10.0629529953003,
    "h": 140.282516479492,
    "CMY_C": 0.22500723600388,
    "CMY_M": 0.16922986507416,
    "CMY_Y": 0.2396554350853,
    "CMYK_C": 0.06713935732841,
    "CMYK_M": 0,
    "CMYK_Y": 0.08477142453194,
    "CMYK_K": 0.16922986507416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09130",
    "Farbtonhilfsbezeichnung": "K5.09.67",
    "Farbtonklasse": "01",
    "Rcolor": "169",
    "Gcolor": "188",
    "Bcolor": "169",
    "Y": 47.1921157836914,
    "L": 74.3124847412109,
    "a": -9.83517456054688,
    "b": 6.86214208602905,
    "C": 11.9924831390381,
    "h": 145.095962524414,
    "CMY_C": 0.3372106552124,
    "CMY_M": 0.26325815916061,
    "CMY_Y": 0.33905524015427,
    "CMYK_C": 0.10037776082754,
    "CMYK_M": 0,
    "CMYK_Y": 0.10288146883249,
    "CMYK_K": 0.26325815916061
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09131",
    "Farbtonhilfsbezeichnung": "K5.15.51",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "148",
    "Bcolor": "126",
    "Y": 27.3849220275879,
    "L": 59.3289337158203,
    "a": -11.6959228515625,
    "b": 9.00466060638428,
    "C": 14.7607088088989,
    "h": 142.407424926758,
    "CMY_C": 0.49935954809189,
    "CMY_M": 0.41779482364655,
    "CMY_Y": 0.50717222690582,
    "CMYK_C": 0.14009618759155,
    "CMYK_M": 0,
    "CMYK_Y": 0.15351529419422,
    "CMYK_K": 0.41779482364655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09132",
    "Farbtonhilfsbezeichnung": "K5.25.35",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "113",
    "Bcolor": "88",
    "Y": 14.5828742980957,
    "L": 45.057502746582,
    "a": -13.4982013702393,
    "b": 10.7216444015503,
    "C": 17.238187789917,
    "h": 141.539825439453,
    "CMY_C": 0.64764308929443,
    "CMY_M": 0.55846226215363,
    "CMY_Y": 0.65648639202118,
    "CMYK_C": 0.20197781920433,
    "CMYK_M": 0,
    "CMYK_Y": 0.2220062315464,
    "CMYK_K": 0.55846226215363
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09133",
    "Farbtonhilfsbezeichnung": "K0.32.20",
    "Farbtonklasse": "03",
    "Rcolor": "70",
    "Gcolor": "85",
    "Bcolor": "66",
    "Y": 8.21682548522949,
    "L": 34.4304313659668,
    "a": -9.94009304046631,
    "b": 9.026930809021,
    "C": 13.42724609375,
    "h": 137.756362915039,
    "CMY_C": 0.72507107257843,
    "CMY_M": 0.66607868671417,
    "CMY_Y": 0.74212205410004,
    "CMYK_C": 0.17666552960873,
    "CMYK_M": 0,
    "CMYK_Y": 0.22772839665413,
    "CMYK_K": 0.66607868671417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09134",
    "Farbtonhilfsbezeichnung": "KN.02.86",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "236",
    "Bcolor": "229",
    "Y": 82.6204986572266,
    "L": 92.8480377197266,
    "a": -3.30614995956421,
    "b": 1.94248831272125,
    "C": 3.83456492424011,
    "h": 149.564147949219,
    "CMY_C": 0.10036450624466,
    "CMY_M": 0.07274967432022,
    "CMY_Y": 0.10250896215439,
    "CMYK_C": 0.02978141978383,
    "CMYK_M": 0,
    "CMYK_Y": 0.0320941247046,
    "CMYK_K": 0.07274967432022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09135",
    "Farbtonhilfsbezeichnung": "L2.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "222",
    "Bcolor": "212",
    "Y": 70.8131408691406,
    "L": 87.3941421508789,
    "a": -6.04681968688965,
    "b": 2.9737229347229,
    "C": 6.73847579956055,
    "h": 153.81282043457,
    "CMY_C": 0.17926323413849,
    "CMY_M": 0.12759321928024,
    "CMY_Y": 0.17048168182373,
    "CMYK_C": 0.05922697484493,
    "CMYK_M": 0,
    "CMYK_Y": 0.0491610839963,
    "CMYK_K": 0.12759321928024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09136",
    "Farbtonhilfsbezeichnung": "L2.05.77",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "211",
    "Bcolor": "199",
    "Y": 62.3741683959961,
    "L": 83.1119995117188,
    "a": -6.97361612319946,
    "b": 3.08217906951904,
    "C": 7.62437868118286,
    "h": 156.155670166016,
    "CMY_C": 0.23306542634964,
    "CMY_M": 0.17281460762024,
    "CMY_Y": 0.21787893772125,
    "CMYK_C": 0.07283835113049,
    "CMYK_M": 0,
    "CMYK_Y": 0.05447911843657,
    "CMYK_K": 0.17281460762024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09137",
    "Farbtonhilfsbezeichnung": "L1.11.53",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "151",
    "Bcolor": "135",
    "Y": 28.5940856933594,
    "L": 60.4217071533203,
    "a": -10.8513097763062,
    "b": 5.21760272979736,
    "C": 12.04052734375,
    "h": 154.320495605469,
    "CMY_C": 0.49417132139206,
    "CMY_M": 0.40730285644531,
    "CMY_Y": 0.47024929523468,
    "CMYK_C": 0.14656467735767,
    "CMYK_M": 0,
    "CMYK_Y": 0.10620337724686,
    "CMYK_K": 0.40730285644531
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09138",
    "Farbtonhilfsbezeichnung": "L0.19.38",
    "Farbtonklasse": "02",
    "Rcolor": "93",
    "Gcolor": "118",
    "Bcolor": "99",
    "Y": 16.1052722930908,
    "L": 47.1122970581055,
    "a": -13.0881061553955,
    "b": 6.98628568649292,
    "C": 14.8359937667847,
    "h": 151.907196044922,
    "CMY_C": 0.63666772842407,
    "CMY_M": 0.53819394111633,
    "CMY_Y": 0.61264955997467,
    "CMYK_C": 0.21323624253273,
    "CMYK_M": 0,
    "CMYK_Y": 0.16122703254223,
    "CMYK_K": 0.53819394111633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09139",
    "Farbtonhilfsbezeichnung": "K5.22.27",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "95",
    "Bcolor": "78",
    "Y": 10.479022026062,
    "L": 38.6887817382813,
    "a": -9.06940841674805,
    "b": 7.53472661972046,
    "C": 11.790940284729,
    "h": 140.280700683594,
    "CMY_C": 0.68391185998917,
    "CMY_M": 0.62715315818787,
    "CMY_Y": 0.69424736499786,
    "CMYK_C": 0.15223060548306,
    "CMYK_M": 0,
    "CMYK_Y": 0.17995111644268,
    "CMYK_K": 0.62715315818787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09140",
    "Farbtonhilfsbezeichnung": "K5.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "237",
    "Bcolor": "222",
    "Y": 81.6457366943359,
    "L": 92.4182739257812,
    "a": -6.19654655456543,
    "b": 4.87368154525757,
    "C": 7.88352489471436,
    "h": 141.814392089844,
    "CMY_C": 0.11841785907745,
    "CMY_M": 0.07172757387161,
    "CMY_Y": 0.12947738170624,
    "CMYK_C": 0.05029804259539,
    "CMYK_M": 0,
    "CMYK_Y": 0.06221213191748,
    "CMYK_K": 0.07172757387161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09141",
    "Farbtonhilfsbezeichnung": "K5.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "238",
    "Bcolor": "218",
    "Y": 81.5781326293945,
    "L": 92.3883438110352,
    "a": -8.13178443908691,
    "b": 6.86493539810181,
    "C": 10.6420516967773,
    "h": 139.828598022461,
    "CMY_C": 0.12769967317581,
    "CMY_M": 0.06822037696838,
    "CMY_Y": 0.14491283893585,
    "CMYK_C": 0.06383407860994,
    "CMYK_M": 0,
    "CMYK_Y": 0.08230751007795,
    "CMYK_K": 0.06822037696838
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09142",
    "Farbtonhilfsbezeichnung": "K6.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "228",
    "Bcolor": "205",
    "Y": 73.0979766845703,
    "L": 88.4944229125977,
    "a": -10.1196060180664,
    "b": 7.85683965682983,
    "C": 12.8115711212158,
    "h": 142.174301147461,
    "CMY_C": 0.18353676795959,
    "CMY_M": 0.10762691497803,
    "CMY_Y": 0.19507241249084,
    "CMYK_C": 0.08506515622139,
    "CMYK_M": 0,
    "CMYK_Y": 0.09799208492041,
    "CMYK_K": 0.10762691497803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09143",
    "Farbtonhilfsbezeichnung": "K5.12.77",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "216",
    "Bcolor": "188",
    "Y": 63.8984870910645,
    "L": 83.9128875732422,
    "a": -13.622034072876,
    "b": 10.22718334198,
    "C": 17.0339393615723,
    "h": 143.101425170898,
    "CMY_C": 0.25419467687607,
    "CMY_M": 0.15153330564499,
    "CMY_Y": 0.26236933469772,
    "CMYK_C": 0.12099634855986,
    "CMYK_M": 0,
    "CMYK_Y": 0.13063097000122,
    "CMYK_K": 0.15153330564499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09144",
    "Farbtonhilfsbezeichnung": "K6.16.68",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "192",
    "Bcolor": "160",
    "Y": 48.0475921630859,
    "L": 74.8549346923828,
    "a": -15.9108753204346,
    "b": 12.001727104187,
    "C": 19.9298114776611,
    "h": 142.972396850586,
    "CMY_C": 0.36372578144073,
    "CMY_M": 0.24624669551849,
    "CMY_Y": 0.37100917100906,
    "CMYK_C": 0.15585879981518,
    "CMYK_M": 0,
    "CMYK_Y": 0.16552163660526,
    "CMYK_K": 0.24624669551849
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09145",
    "Farbtonhilfsbezeichnung": "K5.24.54",
    "Farbtonklasse": "02",
    "Rcolor": "124",
    "Gcolor": "157",
    "Bcolor": "120",
    "Y": 29.5978164672852,
    "L": 61.3056411743164,
    "a": -18.6471271514893,
    "b": 15.1823797225952,
    "C": 24.0462055206299,
    "h": 140.847717285156,
    "CMY_C": 0.51553404331207,
    "CMY_M": 0.38560038805008,
    "CMY_Y": 0.53116011619568,
    "CMYK_C": 0.211480692029,
    "CMYK_M": 0,
    "CMYK_Y": 0.23691377043724,
    "CMYK_K": 0.38560038805008
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09146",
    "Farbtonhilfsbezeichnung": "L1.37.22",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "88",
    "Bcolor": "69",
    "Y": 8.41476154327393,
    "L": 34.8321647644043,
    "a": -15.4846258163452,
    "b": 7.63629388809204,
    "C": 17.2651844024658,
    "h": 153.749633789063,
    "CMY_C": 0.76815795898438,
    "CMY_M": 0.65308725833893,
    "CMY_Y": 0.73056989908218,
    "CMYK_C": 0.3316992521286,
    "CMYK_M": 0,
    "CMYK_Y": 0.22334907948971,
    "CMYK_K": 0.65308725833893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09147",
    "Farbtonhilfsbezeichnung": "L1.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "237",
    "Bcolor": "216",
    "Y": 79.9104614257813,
    "L": 91.6446685791016,
    "a": -10.2796249389648,
    "b": 6.69137048721313,
    "C": 12.2656078338623,
    "h": 146.9384765625,
    "CMY_C": 0.15425610542297,
    "CMY_M": 0.07175076007843,
    "CMY_Y": 0.15208655595779,
    "CMYK_C": 0.08888275176287,
    "CMYK_M": 0,
    "CMYK_Y": 0.08654550462961,
    "CMYK_K": 0.07175076007843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09148",
    "Farbtonhilfsbezeichnung": "L1.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "228",
    "Bcolor": "196",
    "Y": 69.4148101806641,
    "L": 86.7090454101563,
    "a": -20.0729179382324,
    "b": 10.050666809082,
    "C": 22.4485626220703,
    "h": 153.40251159668,
    "CMY_C": 0.28008425235748,
    "CMY_M": 0.10720682144165,
    "CMY_Y": 0.23199892044067,
    "CMYK_C": 0.19363659620285,
    "CMYK_M": 0,
    "CMYK_Y": 0.13977716863155,
    "CMYK_K": 0.10720682144165
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09149",
    "Farbtonhilfsbezeichnung": "L1.26.66",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "194",
    "Bcolor": "150",
    "Y": 45.3704528808594,
    "L": 73.1351547241211,
    "a": -29.2569541931152,
    "b": 14.7007694244385,
    "C": 32.7426643371582,
    "h": 153.321807861328,
    "CMY_C": 0.49128353595734,
    "CMY_M": 0.24054884910583,
    "CMY_Y": 0.41005873680115,
    "CMYK_C": 0.33015248179436,
    "CMYK_M": 0,
    "CMYK_Y": 0.22320051491261,
    "CMYK_K": 0.24054884910583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09150",
    "Farbtonhilfsbezeichnung": "L1.38.56",
    "Farbtonklasse": "02",
    "Rcolor": "93",
    "Gcolor": "172",
    "Bcolor": "117",
    "Y": 33.0901908874512,
    "L": 64.2338714599609,
    "a": -36.3179588317871,
    "b": 20.1807975769043,
    "C": 41.5482711791992,
    "h": 150.940383911133,
    "CMY_C": 0.63465142250061,
    "CMY_M": 0.3259089589119,
    "CMY_Y": 0.53999042510986,
    "CMYK_C": 0.4580129981041,
    "CMYK_M": 0,
    "CMYK_Y": 0.31758537888527,
    "CMYK_K": 0.3259089589119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09151",
    "Farbtonhilfsbezeichnung": "L1.54.44",
    "Farbtonklasse": "03",
    "Rcolor": "52",
    "Gcolor": "145",
    "Bcolor": "89",
    "Y": 21.7964363098145,
    "L": 53.8103446960449,
    "a": -40.4554100036621,
    "b": 21.2512664794922,
    "C": 45.6974449157715,
    "h": 152.287002563477,
    "CMY_C": 0.79683649539948,
    "CMY_M": 0.43019115924835,
    "CMY_Y": 0.64908146858215,
    "CMYK_C": 0.64345324039459,
    "CMYK_M": 0,
    "CMYK_Y": 0.38414692878723,
    "CMYK_K": 0.43019115924835
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09152",
    "Farbtonhilfsbezeichnung": "L1.46.38",
    "Farbtonklasse": "03",
    "Rcolor": "62",
    "Gcolor": "125",
    "Bcolor": "83",
    "Y": 16.3778133392334,
    "L": 47.4663200378418,
    "a": -30.1873931884766,
    "b": 16.3107566833496,
    "C": 34.3120880126953,
    "h": 151.616897583008,
    "CMY_C": 0.75583434104919,
    "CMY_M": 0.50903749465942,
    "CMY_Y": 0.67334491014481,
    "CMYK_C": 0.50267964601517,
    "CMYK_M": 0,
    "CMYK_Y": 0.33466386795044,
    "CMYK_K": 0.50903749465942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09153",
    "Farbtonhilfsbezeichnung": "L1.10.83",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "231",
    "Bcolor": "207",
    "Y": 74.0395660400391,
    "L": 88.9411773681641,
    "a": -14.3542861938477,
    "b": 7.66182565689087,
    "C": 16.2711124420166,
    "h": 151.908233642578,
    "CMY_C": 0.21481573581696,
    "CMY_M": 0.09348583221436,
    "CMY_Y": 0.18937939405441,
    "CMYK_C": 0.13384225964546,
    "CMYK_M": 0,
    "CMYK_Y": 0.10578274726868,
    "CMYK_K": 0.09348583221436
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09154",
    "Farbtonhilfsbezeichnung": "L2.19.77",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "222",
    "Bcolor": "185",
    "Y": 64.2637100219727,
    "L": 84.1028823852539,
    "a": -24.7042427062988,
    "b": 12.1135997772217,
    "C": 27.5143394470215,
    "h": 153.879211425781,
    "CMY_C": 0.3422811627388,
    "CMY_M": 0.12763679027557,
    "CMY_Y": 0.27577412128448,
    "CMYK_C": 0.24604931473732,
    "CMYK_M": 0,
    "CMYK_Y": 0.16981153190136,
    "CMYK_K": 0.12763679027557
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09155",
    "Farbtonhilfsbezeichnung": "L1.25.71",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "207",
    "Bcolor": "163",
    "Y": 53.1627540588379,
    "L": 77.9709930419922,
    "a": -29.9640026092529,
    "b": 14.762547492981,
    "C": 33.403205871582,
    "h": 153.771636962891,
    "CMY_C": 0.44712609052658,
    "CMY_M": 0.18636363744736,
    "CMY_Y": 0.36054462194443,
    "CMYK_C": 0.32049015164375,
    "CMYK_M": 0,
    "CMYK_Y": 0.2140771895647,
    "CMYK_K": 0.18636363744736
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09156",
    "Farbtonhilfsbezeichnung": "L1.40.58",
    "Farbtonklasse": "02",
    "Rcolor": "88",
    "Gcolor": "178",
    "Bcolor": "121",
    "Y": 35.2672386169434,
    "L": 65.9561996459961,
    "a": -39.8515510559082,
    "b": 20.6731567382813,
    "C": 44.894603729248,
    "h": 152.581787109375,
    "CMY_C": 0.65566253662109,
    "CMY_M": 0.30204564332962,
    "CMY_Y": 0.52695846557617,
    "CMYK_C": 0.50664758682251,
    "CMYK_M": 0,
    "CMYK_Y": 0.32224574685097,
    "CMYK_K": 0.30204564332962
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09157",
    "Farbtonhilfsbezeichnung": "L7.10.83",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "233",
    "Bcolor": "213",
    "Y": 75.3647918701172,
    "L": 89.563591003418,
    "a": -14.5739583969116,
    "b": 4.98844385147095,
    "C": 15.404052734375,
    "h": 161.104705810547,
    "CMY_C": 0.21991169452667,
    "CMY_M": 0.08537358045578,
    "CMY_Y": 0.16282433271408,
    "CMYK_C": 0.14709624648094,
    "CMYK_M": 0,
    "CMYK_Y": 0.08468020707369,
    "CMYK_K": 0.08537358045578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09158",
    "Farbtonhilfsbezeichnung": "L7.15.81",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "232",
    "Bcolor": "205",
    "Y": 71.9707870483398,
    "L": 87.9545288085938,
    "a": -20.6549777984619,
    "b": 6.9069299697876,
    "C": 21.7792053222656,
    "h": 161.510299682617,
    "CMY_C": 0.2842276096344,
    "CMY_M": 0.09134292602539,
    "CMY_Y": 0.19538193941116,
    "CMYK_C": 0.21227444708347,
    "CMYK_M": 0,
    "CMYK_Y": 0.11449755728245,
    "CMYK_K": 0.09134292602539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09159",
    "Farbtonhilfsbezeichnung": "L7.23.73",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "212",
    "Bcolor": "176",
    "Y": 55.9974479675293,
    "L": 79.6123657226563,
    "a": -29.3999309539795,
    "b": 10.2041206359863,
    "C": 31.1204109191895,
    "h": 160.859146118164,
    "CMY_C": 0.44379663467407,
    "CMY_M": 0.1682745218277,
    "CMY_Y": 0.31006956100464,
    "CMYK_C": 0.3312656879425,
    "CMYK_M": 0,
    "CMYK_Y": 0.17048297822475,
    "CMYK_K": 0.1682745218277
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09160",
    "Farbtonhilfsbezeichnung": "L7.33.64",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "195",
    "Bcolor": "151",
    "Y": 43.7268676757813,
    "L": 72.0455551147461,
    "a": -38.6364593505859,
    "b": 12.7736225128174,
    "C": 40.6932601928711,
    "h": 161.70556640625,
    "CMY_C": 0.61645877361298,
    "CMY_M": 0.23629951477051,
    "CMY_Y": 0.40866696834564,
    "CMYK_C": 0.49778580665588,
    "CMYK_M": 0,
    "CMYK_Y": 0.22570033371449,
    "CMYK_K": 0.23629951477051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09161",
    "Farbtonhilfsbezeichnung": "L7.46.56",
    "Farbtonklasse": "03",
    "Rcolor": "47",
    "Gcolor": "176",
    "Bcolor": "125",
    "Y": 32.9955406188965,
    "L": 64.1572952270508,
    "a": -46.1979789733887,
    "b": 15.4753179550171,
    "C": 48.7210311889648,
    "h": 161.480270385742,
    "CMY_C": 0.81636154651642,
    "CMY_M": 0.3112256526947,
    "CMY_Y": 0.50868582725525,
    "CMYK_C": 0.73338371515274,
    "CMYK_M": 0,
    "CMYK_Y": 0.28668341040611,
    "CMYK_K": 0.3112256526947
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09162",
    "Farbtonhilfsbezeichnung": "L7.54.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "151",
    "Bcolor": "102",
    "Y": 22.9910297393799,
    "L": 55.0630912780762,
    "a": -46.843879699707,
    "b": 15.732744216919,
    "C": 49.4152641296387,
    "h": 161.435134887695,
    "CMY_C": 1,
    "CMY_M": 0.40766030550003,
    "CMY_Y": 0.59961569309235,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.3240630030632,
    "CMYK_K": 0.40766030550003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09163",
    "Farbtonhilfsbezeichnung": "L7.08.85",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "240",
    "Bcolor": "222",
    "Y": 81.3993682861328,
    "L": 92.3091125488281,
    "a": -11.8594598770142,
    "b": 4.64105081558228,
    "C": 12.7352323532104,
    "h": 158.627731323242,
    "CMY_C": 0.16768604516983,
    "CMY_M": 0.06028693914413,
    "CMY_Y": 0.12974256277084,
    "CMYK_C": 0.11428925395012,
    "CMYK_M": 0,
    "CMYK_Y": 0.07391152530909,
    "CMYK_K": 0.06028693914413
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09164",
    "Farbtonhilfsbezeichnung": "L7.23.68",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "200",
    "Bcolor": "166",
    "Y": 49.274169921875,
    "L": 75.6215744018555,
    "a": -27.919921875,
    "b": 9.60487937927246,
    "C": 29.5258483886719,
    "h": 161.016006469727,
    "CMY_C": 0.47374624013901,
    "CMY_M": 0.21470957994461,
    "CMY_Y": 0.34744942188263,
    "CMYK_C": 0.32986098527908,
    "CMYK_M": 0,
    "CMYK_Y": 0.16903279721737,
    "CMYK_K": 0.21470957994461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09165",
    "Farbtonhilfsbezeichnung": "L7.38.56",
    "Farbtonklasse": "02",
    "Rcolor": "76",
    "Gcolor": "171",
    "Bcolor": "129",
    "Y": 32.3478317260742,
    "L": 63.6293258666992,
    "a": -38.1478538513184,
    "b": 12.8725709915161,
    "C": 40.2611694335938,
    "h": 161.353607177734,
    "CMY_C": 0.70273733139038,
    "CMY_M": 0.3282373547554,
    "CMY_Y": 0.49460172653198,
    "CMYK_C": 0.55748856067657,
    "CMYK_M": 0,
    "CMYK_Y": 0.24765349924564,
    "CMYK_K": 0.3282373547554
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09166",
    "Farbtonhilfsbezeichnung": "L7.55.43",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "144",
    "Bcolor": "99",
    "Y": 20.8442859649658,
    "L": 52.7786483764648,
    "a": -44.1727104187012,
    "b": 14.6039943695068,
    "C": 46.524242401123,
    "h": 161.705535888672,
    "CMY_C": 1,
    "CMY_M": 0.43496739864349,
    "CMY_Y": 0.6134330034256,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.31585010886192,
    "CMYK_K": 0.43496739864349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09167",
    "Farbtonhilfsbezeichnung": "L7.47.36",
    "Farbtonklasse": "03",
    "Rcolor": "49",
    "Gcolor": "124",
    "Bcolor": "92",
    "Y": 15.8617448806763,
    "L": 46.7925758361816,
    "a": -31.2309703826904,
    "b": 10.5077228546143,
    "C": 32.9512634277344,
    "h": 161.404373168945,
    "CMY_C": 0.80669170618057,
    "CMY_M": 0.51337575912476,
    "CMY_Y": 0.64106863737106,
    "CMYK_C": 0.60275655984879,
    "CMYK_M": 0,
    "CMYK_Y": 0.2624055147171,
    "CMYK_K": 0.51337575912476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09168",
    "Farbtonhilfsbezeichnung": "L9.55.25",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "99",
    "Bcolor": "73",
    "Y": 9.77464866638184,
    "L": 37.4349060058594,
    "a": -27.8159027099609,
    "b": 8.49409961700439,
    "C": 29.0839157104492,
    "h": 163.018981933594,
    "CMY_C": 0.87295526266098,
    "CMY_M": 0.61057209968567,
    "CMY_Y": 0.71397548913956,
    "CMYK_C": 0.67376571893692,
    "CMYK_M": 0,
    "CMYK_Y": 0.26552641391754,
    "CMYK_K": 0.61057209968567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09169",
    "Farbtonhilfsbezeichnung": "L1.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "237",
    "Bcolor": "219",
    "Y": 80.998908996582,
    "L": 92.1312026977539,
    "a": -8.8901948928833,
    "b": 5.82617378234863,
    "C": 10.6291990280151,
    "h": 146.761245727539,
    "CMY_C": 0.14039123058319,
    "CMY_M": 0.06914007663727,
    "CMY_Y": 0.14010924100876,
    "CMYK_C": 0.07654336839914,
    "CMYK_M": 0,
    "CMYK_Y": 0.07624043524265,
    "CMYK_K": 0.06914007663727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09170",
    "Farbtonhilfsbezeichnung": "L1.10.78",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "219",
    "Bcolor": "198",
    "Y": 66.032112121582,
    "L": 85.0127944946289,
    "a": -12.826250076294,
    "b": 6.78068590164185,
    "C": 14.5082874298096,
    "h": 152.136520385742,
    "CMY_C": 0.24771815538406,
    "CMY_M": 0.14020186662674,
    "CMY_Y": 0.22519659996033,
    "CMYK_C": 0.12504829466343,
    "CMYK_M": 0,
    "CMYK_Y": 0.09885428845882,
    "CMYK_K": 0.14020186662674
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09171",
    "Farbtonhilfsbezeichnung": "L1.19.68",
    "Farbtonklasse": "01",
    "Rcolor": "148",
    "Gcolor": "195",
    "Bcolor": "163",
    "Y": 47.9037628173828,
    "L": 74.7641906738281,
    "a": -21.4014854431152,
    "b": 10.1612215042114,
    "C": 23.6912212371826,
    "h": 154.602081298828,
    "CMY_C": 0.41854274272919,
    "CMY_M": 0.23618370294571,
    "CMY_Y": 0.3595182299614,
    "CMYK_C": 0.23874725401402,
    "CMYK_M": 0,
    "CMYK_Y": 0.16147145628929,
    "CMYK_K": 0.23618370294571
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09172",
    "Farbtonhilfsbezeichnung": "L1.21.58",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "170",
    "Bcolor": "139",
    "Y": 34.8461685180664,
    "L": 65.6287231445313,
    "a": -21.1026000976563,
    "b": 10.225887298584,
    "C": 23.4497013092041,
    "h": 154.146133422852,
    "CMY_C": 0.50990986824036,
    "CMY_M": 0.33472067117691,
    "CMY_Y": 0.45373958349228,
    "CMYK_C": 0.26333180069923,
    "CMYK_M": 0,
    "CMYK_Y": 0.17890065908432,
    "CMYK_K": 0.33472067117691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09173",
    "Farbtonhilfsbezeichnung": "L1.32.51",
    "Farbtonklasse": "02",
    "Rcolor": "98",
    "Gcolor": "157",
    "Bcolor": "116",
    "Y": 28.0565624237061,
    "L": 59.9398078918457,
    "a": -28.0392379760742,
    "b": 14.8400535583496,
    "C": 31.7242183685303,
    "h": 152.109512329102,
    "CMY_C": 0.61437952518463,
    "CMY_M": 0.38363569974899,
    "CMY_Y": 0.54356920719147,
    "CMYK_C": 0.37436273694038,
    "CMYK_M": 0,
    "CMYK_Y": 0.25947886705399,
    "CMYK_K": 0.38363569974899
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09174",
    "Farbtonhilfsbezeichnung": "L8.43.24",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "94",
    "Bcolor": "72",
    "Y": 9.03275585174561,
    "L": 36.0472869873047,
    "a": -22.2056255340576,
    "b": 7.04552125930786,
    "C": 23.2965488433838,
    "h": 162.396530151367,
    "CMY_C": 0.82317036390305,
    "CMY_M": 0.63144212961197,
    "CMY_Y": 0.71673059463501,
    "CMYK_C": 0.52021199464798,
    "CMYK_M": 0,
    "CMYK_Y": 0.23141132295132,
    "CMYK_K": 0.63144212961197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09175",
    "Farbtonhilfsbezeichnung": "L6.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "238",
    "Bcolor": "225",
    "Y": 82.6581954956055,
    "L": 92.8645858764648,
    "a": -6.77867126464844,
    "b": 3.72881388664246,
    "C": 7.73656511306763,
    "h": 151.185684204102,
    "CMY_C": 0.12223517894745,
    "CMY_M": 0.06508654356003,
    "CMY_Y": 0.11611181497574,
    "CMYK_C": 0.06112719327211,
    "CMYK_M": 0,
    "CMYK_Y": 0.05457753315568,
    "CMYK_K": 0.06508654356003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09176",
    "Farbtonhilfsbezeichnung": "L8.07.78",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "217",
    "Bcolor": "203",
    "Y": 65.5538864135742,
    "L": 84.7683486938477,
    "a": -9.89141273498535,
    "b": 3.38134956359863,
    "C": 10.4533996582031,
    "h": 161.127166748047,
    "CMY_C": 0.2380838394165,
    "CMY_M": 0.14829808473587,
    "CMY_Y": 0.2025465965271,
    "CMYK_C": 0.10541922599077,
    "CMYK_M": 0,
    "CMYK_Y": 0.0636942461133,
    "CMYK_K": 0.14829808473587
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09177",
    "Farbtonhilfsbezeichnung": "L7.09.70",
    "Farbtonklasse": "01",
    "Rcolor": "166",
    "Gcolor": "194",
    "Bcolor": "179",
    "Y": 50.0288619995117,
    "L": 76.0869750976563,
    "a": -12.3484468460083,
    "b": 3.60825943946838,
    "C": 12.8648233413696,
    "h": 163.711456298828,
    "CMY_C": 0.35066384077072,
    "CMY_M": 0.23811334371567,
    "CMY_Y": 0.29747897386551,
    "CMYK_C": 0.1477260440588,
    "CMYK_M": 0,
    "CMYK_Y": 0.07791924476624,
    "CMYK_K": 0.23811334371567
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09178",
    "Farbtonhilfsbezeichnung": "L7.13.61",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "174",
    "Bcolor": "158",
    "Y": 38.8131713867188,
    "L": 68.6157150268555,
    "a": -13.6333112716675,
    "b": 4.43489170074463,
    "C": 14.3365068435669,
    "h": 161.980377197266,
    "CMY_C": 0.43631130456924,
    "CMY_M": 0.31583148241043,
    "CMY_Y": 0.38164979219437,
    "CMYK_C": 0.17609670758247,
    "CMYK_M": 0,
    "CMYK_Y": 0.09620189666748,
    "CMYK_K": 0.31583148241043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09179",
    "Farbtonhilfsbezeichnung": "M3.18.38",
    "Farbtonklasse": "03",
    "Rcolor": "88",
    "Gcolor": "119",
    "Bcolor": "108",
    "Y": 16.4122352600098,
    "L": 47.5107460021973,
    "a": -13.3334217071533,
    "b": 1.92405271530151,
    "C": 13.4715299606323,
    "h": 171.788726806641,
    "CMY_C": 0.65324974060059,
    "CMY_M": 0.53271675109863,
    "CMY_Y": 0.57576888799667,
    "CMYK_C": 0.25794416666031,
    "CMYK_M": 0,
    "CMYK_Y": 0.09213285148144,
    "CMYK_K": 0.53271675109863
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09180",
    "Farbtonhilfsbezeichnung": "M3.43.18",
    "Farbtonklasse": "04",
    "Rcolor": "43",
    "Gcolor": "82",
    "Bcolor": "69",
    "Y": 7.00797128677368,
    "L": 31.8250484466553,
    "a": -17.4537734985352,
    "b": 3.16184592247009,
    "C": 17.7378540039063,
    "h": 169.731918334961,
    "CMY_C": 0.83177208900452,
    "CMY_M": 0.67753148078918,
    "CMY_Y": 0.73005521297455,
    "CMYK_C": 0.47831213474274,
    "CMYK_M": 0,
    "CMYK_Y": 0.16288018226624,
    "CMYK_K": 0.67753148078918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09181",
    "Farbtonhilfsbezeichnung": "L0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "234",
    "Bcolor": "229",
    "Y": 81.3798675537109,
    "L": 92.3004608154297,
    "a": -2.42252135276794,
    "b": 1.33009731769562,
    "C": 2.7636513710022,
    "h": 151.230804443359,
    "CMY_C": 0.10147452354431,
    "CMY_M": 0.08077263832092,
    "CMY_Y": 0.10389590263367,
    "CMYK_C": 0.02252096310258,
    "CMYK_M": 0,
    "CMYK_Y": 0.02515510842204,
    "CMYK_K": 0.08077263832092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09182",
    "Farbtonhilfsbezeichnung": "N1.29.19",
    "Farbtonklasse": "04",
    "Rcolor": "53",
    "Gcolor": "83",
    "Bcolor": "77",
    "Y": 7.45115947723389,
    "L": 32.8126754760742,
    "a": -12.065541267395,
    "b": -0.8410672545433,
    "C": 12.094820022583,
    "h": 183.987548828125,
    "CMY_C": 0.79047071933746,
    "CMY_M": 0.67569923400879,
    "CMY_Y": 0.69613659381866,
    "CMYK_C": 0.35390445590019,
    "CMYK_M": 0,
    "CMYK_Y": 0.0630197674036,
    "CMYK_K": 0.67569923400879
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09183",
    "Farbtonhilfsbezeichnung": "M2.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "240",
    "Bcolor": "230",
    "Y": 83.6267242431641,
    "L": 93.2881317138672,
    "a": -8.04995536804199,
    "b": 1.89984536170959,
    "C": 8.27110576629639,
    "h": 166.720794677734,
    "CMY_C": 0.13476049900055,
    "CMY_M": 0.05695527791977,
    "CMY_Y": 0.09797036647797,
    "CMYK_C": 0.08250427246094,
    "CMYK_M": 0,
    "CMYK_Y": 0.04349219799042,
    "CMYK_K": 0.05695527791977
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09184",
    "Farbtonhilfsbezeichnung": "M4.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "227",
    "Bcolor": "216",
    "Y": 72.9247817993164,
    "L": 88.4118270874023,
    "a": -9.65910911560059,
    "b": 2.17314076423645,
    "C": 9.90055179595947,
    "h": 167.320510864258,
    "CMY_C": 0.20096999406815,
    "CMY_M": 0.10806602239609,
    "CMY_Y": 0.15395206212997,
    "CMYK_C": 0.10416014492512,
    "CMYK_M": 0,
    "CMYK_Y": 0.05144555494189,
    "CMYK_K": 0.10806602239609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09185",
    "Farbtonhilfsbezeichnung": "M4.11.75",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "209",
    "Bcolor": "195",
    "Y": 58.3081321716309,
    "L": 80.909797668457,
    "a": -15.4162940979004,
    "b": 2.25538420677185,
    "C": 15.580400466919,
    "h": 171.676742553711,
    "CMY_C": 0.331407725811,
    "CMY_M": 0.17891591787338,
    "CMY_Y": 0.23670601844788,
    "CMYK_C": 0.18572008609772,
    "CMYK_M": 0,
    "CMYK_Y": 0.07038268446922,
    "CMYK_K": 0.17891591787338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09186",
    "Farbtonhilfsbezeichnung": "M4.15.67",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "190",
    "Bcolor": "174",
    "Y": 45.8982009887695,
    "L": 73.4794311523438,
    "a": -18.4528141021729,
    "b": 2.21257734298706,
    "C": 18.5849895477295,
    "h": 173.162612915039,
    "CMY_C": 0.43740212917328,
    "CMY_M": 0.25383460521698,
    "CMY_Y": 0.31581771373749,
    "CMYK_C": 0.24601452052593,
    "CMYK_M": 0,
    "CMYK_Y": 0.08306886255741,
    "CMYK_K": 0.25383460521698
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09187",
    "Farbtonhilfsbezeichnung": "M3.19.53",
    "Farbtonklasse": "02",
    "Rcolor": "109",
    "Gcolor": "155",
    "Bcolor": "139",
    "Y": 28.4141979217529,
    "L": 60.2611045837402,
    "a": -18.7255268096924,
    "b": 2.41508030891418,
    "C": 18.8806247711182,
    "h": 172.650985717773,
    "CMY_C": 0.57433354854584,
    "CMY_M": 0.39360815286636,
    "CMY_Y": 0.45366638898849,
    "CMYK_C": 0.29803401231766,
    "CMYK_M": 0,
    "CMYK_Y": 0.09904196113348,
    "CMYK_K": 0.39360815286636
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09188",
    "Farbtonhilfsbezeichnung": "M5.46.21",
    "Farbtonklasse": "03",
    "Rcolor": "40",
    "Gcolor": "89",
    "Bcolor": "76",
    "Y": 8.19093132019043,
    "L": 34.3773994445801,
    "a": -20.4161186218262,
    "b": 2.50085306167603,
    "C": 20.568717956543,
    "h": 173.016403198242,
    "CMY_C": 0.84369277954102,
    "CMY_M": 0.64907348155975,
    "CMY_Y": 0.70330452919006,
    "CMYK_C": 0.55458706617355,
    "CMYK_M": 0,
    "CMYK_Y": 0.15453676879406,
    "CMYK_K": 0.64907348155975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09189",
    "Farbtonhilfsbezeichnung": "M4.28.19",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "80",
    "Bcolor": "72",
    "Y": 7.11145496368408,
    "L": 32.0593032836914,
    "a": -11.176778793335,
    "b": 1.62054026126862,
    "C": 11.2936506271362,
    "h": 171.750076293945,
    "CMY_C": 0.77958047389984,
    "CMY_M": 0.68465512990952,
    "CMY_Y": 0.71789133548737,
    "CMYK_C": 0.30102074146271,
    "CMYK_M": 0,
    "CMYK_Y": 0.10539637506008,
    "CMYK_K": 0.68465512990952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09190",
    "Farbtonhilfsbezeichnung": "M3.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "230",
    "Bcolor": "217",
    "Y": 73.698974609375,
    "L": 88.7800216674805,
    "a": -11.9871206283569,
    "b": 2.08877611160278,
    "C": 12.1677465438843,
    "h": 170.115356445313,
    "CMY_C": 0.21717637777328,
    "CMY_M": 0.09888929128647,
    "CMY_Y": 0.14960670471191,
    "CMYK_C": 0.13126809895039,
    "CMYK_M": 0,
    "CMYK_Y": 0.05628322064877,
    "CMYK_K": 0.09888929128647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09191",
    "Farbtonhilfsbezeichnung": "M4.12.75",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "214",
    "Bcolor": "198",
    "Y": 60.626880645752,
    "L": 82.1777496337891,
    "a": -16.823600769043,
    "b": 2.34817481040955,
    "C": 16.9866847991943,
    "h": 172.05419921875,
    "CMY_C": 0.3301283121109,
    "CMY_M": 0.16213190555573,
    "CMY_Y": 0.22391676902771,
    "CMYK_C": 0.20050460100174,
    "CMYK_M": 0,
    "CMYK_Y": 0.07374056428671,
    "CMYK_K": 0.16213190555573
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09192",
    "Farbtonhilfsbezeichnung": "M4.17.68",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "196",
    "Bcolor": "177",
    "Y": 48.410228729248,
    "L": 75.0829391479492,
    "a": -20.7965660095215,
    "b": 3.1813952922821,
    "C": 21.0384979248047,
    "h": 171.302490234375,
    "CMY_C": 0.43838179111481,
    "CMY_M": 0.23222655057907,
    "CMY_Y": 0.30611509084702,
    "CMYK_C": 0.26851052045822,
    "CMYK_M": 0,
    "CMYK_Y": 0.09623742848635,
    "CMYK_K": 0.23222655057907
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09193",
    "Farbtonhilfsbezeichnung": "M3.26.57",
    "Farbtonklasse": "02",
    "Rcolor": "100",
    "Gcolor": "170",
    "Bcolor": "147",
    "Y": 33.3843193054199,
    "L": 64.4708938598633,
    "a": -27.1724529266357,
    "b": 4.05401563644409,
    "C": 27.4732093811035,
    "h": 171.514297485352,
    "CMY_C": 0.60928404331207,
    "CMY_M": 0.33502221107483,
    "CMY_Y": 0.42321962118149,
    "CMYK_C": 0.41243758797646,
    "CMYK_M": 0,
    "CMYK_Y": 0.13263212144375,
    "CMYK_K": 0.33502221107483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09194",
    "Farbtonhilfsbezeichnung": "M3.47.41",
    "Farbtonklasse": "03",
    "Rcolor": "25",
    "Gcolor": "135",
    "Bcolor": "106",
    "Y": 18.6113662719727,
    "L": 50.2293891906738,
    "a": -36.6314125061035,
    "b": 6.71551513671875,
    "C": 37.2418937683105,
    "h": 169.611511230469,
    "CMY_C": 0.90261375904083,
    "CMY_M": 0.47008174657822,
    "CMY_Y": 0.58375704288483,
    "CMYK_C": 0.81622403860092,
    "CMYK_M": 0,
    "CMYK_Y": 0.21451477706432,
    "CMYK_K": 0.47008174657822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09195",
    "Farbtonhilfsbezeichnung": "M3.41.25",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "99",
    "Bcolor": "81",
    "Y": 10.1121587753296,
    "L": 38.0429801940918,
    "a": -22.528600692749,
    "b": 4.20603704452515,
    "C": 22.9178657531738,
    "h": 169.424758911133,
    "CMY_C": 0.82280278205872,
    "CMY_M": 0.6112185716629,
    "CMY_Y": 0.68070507049561,
    "CMYK_C": 0.54422408342361,
    "CMYK_M": 0,
    "CMYK_Y": 0.17872895300388,
    "CMYK_K": 0.6112185716629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09196",
    "Farbtonhilfsbezeichnung": "M2.06.86",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 81.2659378051758,
    "L": 92.2499008178711,
    "a": -8.52769088745117,
    "b": 2.1041316986084,
    "C": 8.78344345092773,
    "h": 166.139617919922,
    "CMY_C": 0.14951002597809,
    "CMY_M": 0.06761491298676,
    "CMY_Y": 0.11105108261108,
    "CMYK_C": 0.08783400058746,
    "CMYK_M": 0,
    "CMYK_Y": 0.0465860851109,
    "CMYK_K": 0.06761491298676
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09197",
    "Farbtonhilfsbezeichnung": "M3.17.73",
    "Farbtonklasse": "01",
    "Rcolor": "153",
    "Gcolor": "210",
    "Bcolor": "189",
    "Y": 56.332103729248,
    "L": 79.8024597167969,
    "a": -22.0229969024658,
    "b": 3.29829359054565,
    "C": 22.2686138153076,
    "h": 171.482345581055,
    "CMY_C": 0.39983820915222,
    "CMY_M": 0.17829740047455,
    "CMY_Y": 0.25697147846222,
    "CMYK_C": 0.2696119248867,
    "CMYK_M": 0,
    "CMYK_Y": 0.09574519842863,
    "CMYK_K": 0.17829740047455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09198",
    "Farbtonhilfsbezeichnung": "M3.26.62",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "183",
    "Bcolor": "158",
    "Y": 39.4785385131836,
    "L": 69.0964965820313,
    "a": -29.5117588043213,
    "b": 4.79079914093018,
    "C": 29.8980884552002,
    "h": 170.779296875,
    "CMY_C": 0.58306866884232,
    "CMY_M": 0.28171104192734,
    "CMY_Y": 0.38114833831787,
    "CMYK_C": 0.41954928636551,
    "CMYK_M": 0,
    "CMYK_Y": 0.13843634724617,
    "CMYK_K": 0.28171104192734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09199",
    "Farbtonhilfsbezeichnung": "M3.56.41",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "140",
    "Bcolor": "105",
    "Y": 19.2837409973145,
    "L": 51.0175285339355,
    "a": -45.1869506835938,
    "b": 8.16322898864746,
    "C": 45.9183921813965,
    "h": 169.759704589844,
    "CMY_C": 1,
    "CMY_M": 0.45095431804657,
    "CMY_Y": 0.58676493167877,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.24735757708549,
    "CMYK_K": 0.45095431804657
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09200",
    "Farbtonhilfsbezeichnung": "M2.53.37",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "97",
    "Y": 16.0910263061523,
    "L": 47.0936889648438,
    "a": -38.388240814209,
    "b": 7.2793550491333,
    "C": 39.0723190307617,
    "h": 169.262802124023,
    "CMY_C": 1,
    "CMY_M": 0.50002646446228,
    "CMY_Y": 0.6176660656929,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.235291659832,
    "CMYK_K": 0.50002646446228
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09201",
    "Farbtonhilfsbezeichnung": "M3.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "238",
    "Bcolor": "224",
    "Y": 80.4624404907227,
    "L": 91.8919525146484,
    "a": -10.4411144256592,
    "b": 2.89424681663513,
    "C": 10.8348293304443,
    "h": 164.506790161133,
    "CMY_C": 0.1667149066925,
    "CMY_M": 0.06761384010315,
    "CMY_Y": 0.12114274501801,
    "CMYK_C": 0.10628757625818,
    "CMYK_M": 0,
    "CMYK_Y": 0.05741066113114,
    "CMYK_K": 0.06761384010315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09202",
    "Farbtonhilfsbezeichnung": "M3.09.82",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "233",
    "Bcolor": "218",
    "Y": 75.6577758789063,
    "L": 89.7002105712891,
    "a": -13.911509513855,
    "b": 3.0383574962616,
    "C": 14.2394418716431,
    "h": 167.679718017578,
    "CMY_C": 0.22019505500793,
    "CMY_M": 0.08473736047745,
    "CMY_Y": 0.14679455757141,
    "CMYK_C": 0.14799872040749,
    "CMYK_M": 0,
    "CMYK_Y": 0.06780260801315,
    "CMYK_K": 0.08473736047745
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09203",
    "Farbtonhilfsbezeichnung": "M3.15.80",
    "Farbtonklasse": "01",
    "Rcolor": "175",
    "Gcolor": "230",
    "Bcolor": "209",
    "Y": 70.5667114257813,
    "L": 87.2740631103516,
    "a": -21.5883903503418,
    "b": 3.99137806892395,
    "C": 21.9542636871338,
    "h": 169.525131225586,
    "CMY_C": 0.31259632110596,
    "CMY_M": 0.09636729955673,
    "CMY_Y": 0.18136781454086,
    "CMYK_C": 0.23928861320019,
    "CMYK_M": 0,
    "CMYK_Y": 0.09406533837318,
    "CMYK_K": 0.09636729955673
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09204",
    "Farbtonhilfsbezeichnung": "M3.24.71",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "211",
    "Bcolor": "183",
    "Y": 54.920970916748,
    "L": 78.9957275390625,
    "a": -31.0477886199951,
    "b": 5.41644048690796,
    "C": 31.5167102813721,
    "h": 170.104064941406,
    "CMY_C": 0.49143320322037,
    "CMY_M": 0.17103880643845,
    "CMY_Y": 0.28203988075256,
    "CMYK_C": 0.38650107383728,
    "CMYK_M": 0,
    "CMYK_Y": 0.13390383124352,
    "CMYK_K": 0.17103880643845
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09205",
    "Farbtonhilfsbezeichnung": "M3.39.59",
    "Farbtonklasse": "02",
    "Rcolor": "60",
    "Gcolor": "185",
    "Bcolor": "149",
    "Y": 37.6470718383789,
    "L": 67.7596893310547,
    "a": -42.2630348205566,
    "b": 7.51289463043213,
    "C": 42.9256057739258,
    "h": 169.920104980469,
    "CMY_C": 0.76287984848022,
    "CMY_M": 0.27634239196777,
    "CMY_Y": 0.41559648513794,
    "CMYK_C": 0.67233103513718,
    "CMYK_M": 0,
    "CMYK_Y": 0.19243091344833,
    "CMYK_K": 0.27634239196777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09206",
    "Farbtonhilfsbezeichnung": "M3.51.44",
    "Farbtonklasse": "02",
    "Rcolor": "0",
    "Gcolor": "147",
    "Bcolor": "113",
    "Y": 21.7223091125488,
    "L": 53.7311248779297,
    "a": -43.3936882019043,
    "b": 7.83278465270996,
    "C": 44.0949516296387,
    "h": 169.768005371094,
    "CMY_C": 1,
    "CMY_M": 0.42479002475739,
    "CMY_Y": 0.55808347463608,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.23173007369041,
    "CMYK_K": 0.42479002475739
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09207",
    "Farbtonhilfsbezeichnung": "M3.47.29",
    "Farbtonklasse": "03",
    "Rcolor": "38",
    "Gcolor": "109",
    "Bcolor": "87",
    "Y": 11.9842081069946,
    "L": 41.1910095214844,
    "a": -27.5926418304443,
    "b": 5.15935802459717,
    "C": 28.0708541870117,
    "h": 169.408966064453,
    "CMY_C": 0.85223668813705,
    "CMY_M": 0.57345652580261,
    "CMY_Y": 0.65819424390793,
    "CMYK_C": 0.65357971191406,
    "CMYK_M": 0,
    "CMYK_Y": 0.19866138696671,
    "CMYK_K": 0.57345652580261
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09208",
    "Farbtonhilfsbezeichnung": "M9.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "238",
    "Bcolor": "227",
    "Y": 79.7877883911133,
    "L": 91.5895614624023,
    "a": -11.8185911178589,
    "b": 1.0127364397049,
    "C": 11.8619022369385,
    "h": 175.102279663086,
    "CMY_C": 0.18918257951736,
    "CMY_M": 0.06749045848846,
    "CMY_Y": 0.11067998409271,
    "CMYK_C": 0.13049960136414,
    "CMYK_M": 0,
    "CMYK_Y": 0.0463153719902,
    "CMYK_K": 0.06749045848846
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09209",
    "Farbtonhilfsbezeichnung": "M9.13.80",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "229",
    "Bcolor": "217",
    "Y": 70.4702987670898,
    "L": 87.2270126342773,
    "a": -18.8431091308594,
    "b": -0.23672845959663,
    "C": 18.844596862793,
    "h": 180.719772338867,
    "CMY_C": 0.3058072924614,
    "CMY_M": 0.10129934549332,
    "CMY_Y": 0.15036815404892,
    "CMYK_C": 0.22755958139896,
    "CMYK_M": 0,
    "CMYK_Y": 0.05459972470999,
    "CMYK_K": 0.10129934549332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09210",
    "Farbtonhilfsbezeichnung": "N1.20.76",
    "Farbtonklasse": "01",
    "Rcolor": "145",
    "Gcolor": "222",
    "Bcolor": "206",
    "Y": 62.5545501708984,
    "L": 83.2074508666992,
    "a": -26.997200012207,
    "b": -0.43710207939148,
    "C": 27.0007381439209,
    "h": 180.927581787109,
    "CMY_C": 0.43280237913132,
    "CMY_M": 0.13021558523178,
    "CMY_Y": 0.19373375177383,
    "CMYK_C": 0.34788712859154,
    "CMYK_M": 0,
    "CMYK_Y": 0.07302748411894,
    "CMYK_K": 0.13021558523178
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09211",
    "Farbtonhilfsbezeichnung": "N0.31.67",
    "Farbtonklasse": "02",
    "Rcolor": "87",
    "Gcolor": "202",
    "Bcolor": "183",
    "Y": 47.5031547546387,
    "L": 74.5104675292969,
    "a": -36.8477439880371,
    "b": -1.0232949256897,
    "C": 36.8619499206543,
    "h": 181.590744018555,
    "CMY_C": 0.66042149066925,
    "CMY_M": 0.2090522646904,
    "CMY_Y": 0.28395837545395,
    "CMYK_C": 0.57066881656647,
    "CMYK_M": 0,
    "CMYK_Y": 0.09470424801111,
    "CMYK_K": 0.2090522646904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09212",
    "Farbtonhilfsbezeichnung": "M8.45.55",
    "Farbtonklasse": "02",
    "Rcolor": "0",
    "Gcolor": "173",
    "Bcolor": "146",
    "Y": 31.5254440307617,
    "L": 62.9487152099609,
    "a": -45.1261672973633,
    "b": 2.16287040710449,
    "C": 45.1779708862305,
    "h": 177.255950927734,
    "CMY_C": 1,
    "CMY_M": 0.323137819767,
    "CMY_Y": 0.42754191160202,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.15424719452858,
    "CMYK_K": 0.323137819767
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09213",
    "Farbtonhilfsbezeichnung": "M8.49.22",
    "Farbtonklasse": "04",
    "Rcolor": "31",
    "Gcolor": "88",
    "Bcolor": "77",
    "Y": 7.87978935241699,
    "L": 33.7312660217285,
    "a": -21.6620788574219,
    "b": 0.94808459281921,
    "C": 21.6828155517578,
    "h": 177.493942260742,
    "CMY_C": 0.87700498104095,
    "CMY_M": 0.6531440615654,
    "CMY_Y": 0.69969654083252,
    "CMYK_C": 0.64540028572083,
    "CMYK_M": 0,
    "CMYK_Y": 0.1342127174139,
    "CMYK_K": 0.6531440615654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09214",
    "Farbtonhilfsbezeichnung": "M9.10.79",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "223",
    "Bcolor": "212",
    "Y": 67.8648376464844,
    "L": 85.9388198852539,
    "a": -13.7061424255371,
    "b": 0.43367719650269,
    "C": 13.7130012512207,
    "h": 178.187713623047,
    "CMY_C": 0.26968270540237,
    "CMY_M": 0.12642878293991,
    "CMY_Y": 0.16873300075531,
    "CMYK_C": 0.16398653388023,
    "CMYK_M": 0,
    "CMYK_Y": 0.04842675477266,
    "CMYK_K": 0.12642878293991
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09215",
    "Farbtonhilfsbezeichnung": "N0.12.75",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "212",
    "Bcolor": "201",
    "Y": 59.9488792419434,
    "L": 81.8103942871094,
    "a": -15.7743215560913,
    "b": 0.23934277892113,
    "C": 15.7761373519898,
    "h": 179.130722045898,
    "CMY_C": 0.33340555429459,
    "CMY_M": 0.16775554418564,
    "CMY_Y": 0.21241825819016,
    "CMYK_C": 0.19904008507729,
    "CMYK_M": 0,
    "CMYK_Y": 0.05366537719965,
    "CMYK_K": 0.16775554418564
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09216",
    "Farbtonhilfsbezeichnung": "M9.29.52",
    "Farbtonklasse": "02",
    "Rcolor": "81",
    "Gcolor": "158",
    "Bcolor": "143",
    "Y": 28.2459774017334,
    "L": 60.1103134155273,
    "a": -27.4435024261475,
    "b": 0.0561126023531,
    "C": 27.4435596466064,
    "h": 179.882858276367,
    "CMY_C": 0.68168842792511,
    "CMY_M": 0.37970668077469,
    "CMY_Y": 0.44002437591553,
    "CMYK_C": 0.48683699965477,
    "CMYK_M": 0,
    "CMYK_Y": 0.09724060446024,
    "CMYK_K": 0.37970668077469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09217",
    "Farbtonhilfsbezeichnung": "M9.36.24",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "92",
    "Bcolor": "83",
    "Y": 8.92413139343262,
    "L": 35.8378067016602,
    "a": -17.9532985687256,
    "b": 0.12308672815561,
    "C": 17.9537200927734,
    "h": 179.607192993164,
    "CMY_C": 0.81530845165253,
    "CMY_M": 0.63829386234283,
    "CMY_Y": 0.67494922876358,
    "CMYK_C": 0.48938784003258,
    "CMYK_M": 0,
    "CMYK_Y": 0.10134018212557,
    "CMYK_K": 0.63829386234283
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09218",
    "Farbtonhilfsbezeichnung": "P0.07.82",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "227",
    "Bcolor": "223",
    "Y": 72.7038116455078,
    "L": 88.3062591552734,
    "a": -8.91968727111816,
    "b": -2.03280282020569,
    "C": 9.14839363098145,
    "h": 192.838470458984,
    "CMY_C": 0.21209251880646,
    "CMY_M": 0.10969823598862,
    "CMY_Y": 0.12401282787323,
    "CMYK_C": 0.11501076072454,
    "CMYK_M": 0,
    "CMYK_Y": 0.01607836037874,
    "CMYK_K": 0.10969823598862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09219",
    "Farbtonhilfsbezeichnung": "N4.43.26",
    "Farbtonklasse": "04",
    "Rcolor": "29",
    "Gcolor": "98",
    "Bcolor": "92",
    "Y": 9.84842300415039,
    "L": 37.5690002441406,
    "a": -22.6071243286133,
    "b": -3.24713325500488,
    "C": 22.83913230896,
    "h": 188.173675537109,
    "CMY_C": 0.88624274730682,
    "CMY_M": 0.61411738395691,
    "CMY_Y": 0.63823640346527,
    "CMYK_C": 0.705202460289,
    "CMYK_M": 0,
    "CMYK_Y": 0.06250351667404,
    "CMYK_K": 0.61411738395691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09220",
    "Farbtonhilfsbezeichnung": "M9.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "229",
    "Bcolor": "221",
    "Y": 73.9057693481445,
    "L": 88.8779296875,
    "a": -9.69454574584961,
    "b": 0.01134171057492,
    "C": 9.69455242156982,
    "h": 179.932968139648,
    "CMY_C": 0.20444351434708,
    "CMY_M": 0.10220175981522,
    "CMY_Y": 0.13289082050323,
    "CMYK_C": 0.11388054490089,
    "CMYK_M": 0,
    "CMYK_Y": 0.03418258205056,
    "CMYK_K": 0.10220175981522
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09221",
    "Farbtonhilfsbezeichnung": "N1.11.83",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 75.6918258666992,
    "L": 89.716064453125,
    "a": -15.9781084060669,
    "b": -0.19340024888515,
    "C": 15.9792785644531,
    "h": 180.693481445312,
    "CMY_C": 0.25185346603394,
    "CMY_M": 0.0793342590332,
    "CMY_Y": 0.12296152114868,
    "CMYK_C": 0.18738527595997,
    "CMYK_M": 0,
    "CMYK_Y": 0.04738664627075,
    "CMYK_K": 0.0793342590332
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09222",
    "Farbtonhilfsbezeichnung": "N5.20.74",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "214",
    "Bcolor": "205",
    "Y": 58.1906852722168,
    "L": 80.8446884155273,
    "a": -25.0186309814453,
    "b": -3.39838528633118,
    "C": 25.248384475708,
    "h": 187.735382080078,
    "CMY_C": 0.45309060811996,
    "CMY_M": 0.15937781333923,
    "CMY_Y": 0.19757491350174,
    "CMYK_C": 0.34939929842949,
    "CMYK_M": 0,
    "CMYK_Y": 0.04543908312917,
    "CMYK_K": 0.15937781333923
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09223",
    "Farbtonhilfsbezeichnung": "N5.28.62",
    "Farbtonklasse": "02",
    "Rcolor": "89",
    "Gcolor": "184",
    "Bcolor": "173",
    "Y": 39.2315635681152,
    "L": 68.9186706542969,
    "a": -30.1880664825439,
    "b": -4.14487075805664,
    "C": 30.4712867736816,
    "h": 187.817932128906,
    "CMY_C": 0.65122497081757,
    "CMY_M": 0.28031861782074,
    "CMY_Y": 0.32016468048096,
    "CMYK_C": 0.51537579298019,
    "CMYK_M": 0,
    "CMYK_Y": 0.05536625534296,
    "CMYK_K": 0.28031861782074
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09224",
    "Farbtonhilfsbezeichnung": "N7.49.44",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "137",
    "Y": 20.7824878692627,
    "L": 52.7106132507324,
    "a": -37.4971885681152,
    "b": -7.50375175476074,
    "C": 38.2406272888184,
    "h": 191.316268920898,
    "CMY_C": 1,
    "CMY_M": 0.44006139039993,
    "CMY_Y": 0.46456229686737,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.04375641420484,
    "CMYK_K": 0.44006139039993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09225",
    "Farbtonhilfsbezeichnung": "N4.50.33",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "116",
    "Bcolor": "107",
    "Y": 13.3703155517578,
    "L": 43.3160018920898,
    "a": -32.0388488769531,
    "b": -4.12767601013184,
    "C": 32.3036460876465,
    "h": 187.341171264648,
    "CMY_C": 1,
    "CMY_M": 0.5442910194397,
    "CMY_Y": 0.57880556583405,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.07573813199997,
    "CMYK_K": 0.5442910194397
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09226",
    "Farbtonhilfsbezeichnung": "N7.08.84",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "237",
    "Bcolor": "232",
    "Y": 79.5049133300781,
    "L": 91.4622650146484,
    "a": -10.6849126815796,
    "b": -1.91454815864563,
    "C": 10.8550844192505,
    "h": 190.158584594727,
    "CMY_C": 0.19243329763412,
    "CMY_M": 0.07057470083237,
    "CMY_Y": 0.09019780158997,
    "CMYK_C": 0.1311117708683,
    "CMYK_M": 0,
    "CMYK_Y": 0.02111315540969,
    "CMYK_K": 0.07057470083237
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09227",
    "Farbtonhilfsbezeichnung": "P0.05.86",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "238",
    "Bcolor": "235",
    "Y": 82.0085220336914,
    "L": 92.5786209106445,
    "a": -6.64143800735474,
    "b": -1.58734822273254,
    "C": 6.8284969329834,
    "h": 193.441909790039,
    "CMY_C": 0.14393043518066,
    "CMY_M": 0.06712490320206,
    "CMY_Y": 0.07969182729721,
    "CMYK_C": 0.0823320671916,
    "CMYK_M": 0,
    "CMYK_Y": 0.01347117498517,
    "CMYK_K": 0.06712490320206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09228",
    "Farbtonhilfsbezeichnung": "P1.18.70",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "201",
    "Bcolor": "199",
    "Y": 51.577262878418,
    "L": 77.0273742675781,
    "a": -20.0955581665039,
    "b": -6.02378797531128,
    "C": 20.9789772033691,
    "h": 196.686477661133,
    "CMY_C": 0.45594823360443,
    "CMY_M": 0.20997101068497,
    "CMY_Y": 0.21935743093491,
    "CMYK_C": 0.31135213375092,
    "CMYK_M": 0,
    "CMYK_Y": 0.01188110839576,
    "CMYK_K": 0.20997101068497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09229",
    "Farbtonhilfsbezeichnung": "P1.24.61",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "179",
    "Bcolor": "178",
    "Y": 38.5059013366699,
    "L": 68.3918380737305,
    "a": -23.2588024139404,
    "b": -7.4792857170105,
    "C": 24.4317741394043,
    "h": 197.826126098633,
    "CMY_C": 0.59139364957809,
    "CMY_M": 0.29711681604385,
    "CMY_Y": 0.30158704519272,
    "CMYK_C": 0.41867104172707,
    "CMYK_M": 0,
    "CMYK_Y": 0.00635984633118,
    "CMYK_K": 0.29711681604385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09230",
    "Farbtonhilfsbezeichnung": "P1.38.55",
    "Farbtonklasse": "03",
    "Rcolor": "31",
    "Gcolor": "168",
    "Bcolor": "170",
    "Y": 31.0166454315186,
    "L": 62.5216827392578,
    "a": -32.544548034668,
    "b": -11.8028812408447,
    "C": 34.6187171936035,
    "h": 199.934112548828,
    "CMY_C": 0.87884056568146,
    "CMY_M": 0.34300047159195,
    "CMY_Y": 0.33415722846985,
    "CMYK_C": 0.81803596019745,
    "CMYK_M": 0.01328127831221,
    "CMYK_Y": 0,
    "CMYK_K": 0.33415722846985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09231",
    "Farbtonhilfsbezeichnung": "P0.53.37",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "127",
    "Bcolor": "127",
    "Y": 16.1038017272949,
    "L": 47.1103782653809,
    "a": -33.3165054321289,
    "b": -10.413161277771,
    "C": 34.9059219360352,
    "h": 197.356781005859,
    "CMY_C": 1,
    "CMY_M": 0.50270634889603,
    "CMY_Y": 0.50095069408417,
    "CMYK_C": 1,
    "CMYK_M": 0.00351799861528,
    "CMYK_Y": 0,
    "CMYK_K": 0.50095069408417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09232",
    "Farbtonhilfsbezeichnung": "N9.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "239",
    "Bcolor": "234",
    "Y": 83.1627349853516,
    "L": 93.0856399536133,
    "a": -5.9544939994812,
    "b": -0.37065306305885,
    "C": 5.96601915359497,
    "h": 183.561920166016,
    "CMY_C": 0.12789762020111,
    "CMY_M": 0.0633357167244,
    "CMY_Y": 0.08301562070847,
    "CMYK_C": 0.06892747431993,
    "CMYK_M": 0,
    "CMYK_Y": 0.0210106279701,
    "CMYK_K": 0.0633357167244
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09233",
    "Farbtonhilfsbezeichnung": "P0.08.82",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "229",
    "Bcolor": "224",
    "Y": 73.5711898803711,
    "L": 88.7194213867188,
    "a": -10.8813428878784,
    "b": -1.9686461687088,
    "C": 11.0579919815063,
    "h": 190.254989624023,
    "CMY_C": 0.22439849376678,
    "CMY_M": 0.10083520412445,
    "CMY_Y": 0.12018120288849,
    "CMYK_C": 0.13742007315159,
    "CMYK_M": 0,
    "CMYK_Y": 0.02151552028954,
    "CMYK_K": 0.10083520412445
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09234",
    "Farbtonhilfsbezeichnung": "P1.12.73",
    "Farbtonklasse": "01",
    "Rcolor": "163",
    "Gcolor": "206",
    "Bcolor": "205",
    "Y": 56.5602111816406,
    "L": 79.9315948486328,
    "a": -14.1420497894287,
    "b": -4.80353403091431,
    "C": 14.9355783462524,
    "h": 198.7607421875,
    "CMY_C": 0.36073076725006,
    "CMY_M": 0.19033747911453,
    "CMY_Y": 0.19603782892227,
    "CMYK_C": 0.21044977009296,
    "CMYK_M": 0,
    "CMYK_Y": 0.00704040238634,
    "CMYK_K": 0.19033747911453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09235",
    "Farbtonhilfsbezeichnung": "P1.21.54",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "159",
    "Bcolor": "158",
    "Y": 30.2015933990479,
    "L": 61.8277740478516,
    "a": -18.5464859008789,
    "b": -6.09879684448242,
    "C": 19.5235099792481,
    "h": 198.202850341797,
    "CMY_C": 0.59912252426147,
    "CMY_M": 0.37544023990631,
    "CMY_Y": 0.37929862737656,
    "CMYK_C": 0.35814392566681,
    "CMYK_M": 0,
    "CMYK_Y": 0.00617777137086,
    "CMYK_K": 0.37544023990631
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09236",
    "Farbtonhilfsbezeichnung": "N5.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "222",
    "Bcolor": "218",
    "Y": 71.125617980957,
    "L": 87.5460052490234,
    "a": -4.64660406112671,
    "b": -0.32836538553238,
    "C": 4.65819215774536,
    "h": 184.042251586914,
    "CMY_C": 0.17801153659821,
    "CMY_M": 0.12815618515015,
    "CMY_Y": 0.14435702562332,
    "CMYK_C": 0.05718380957842,
    "CMYK_M": 0,
    "CMYK_Y": 0.01858227327466,
    "CMYK_K": 0.12815618515015
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09237",
    "Farbtonhilfsbezeichnung": "N6.08.61",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "169",
    "Bcolor": "166",
    "Y": 37.3426132202148,
    "L": 67.5332870483398,
    "a": -8.53368949890137,
    "b": -1.69109082221985,
    "C": 8.69963455200195,
    "h": 191.208877563477,
    "CMY_C": 0.42809730768204,
    "CMY_M": 0.33596062660217,
    "CMY_Y": 0.34941828250885,
    "CMYK_C": 0.13875183463097,
    "CMYK_M": 0,
    "CMYK_Y": 0.02026635222137,
    "CMYK_K": 0.33596062660217
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09238",
    "Farbtonhilfsbezeichnung": "P0.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "229",
    "Bcolor": "226",
    "Y": 75.892822265625,
    "L": 89.8095550537109,
    "a": -5.82189178466797,
    "b": -1.06543719768524,
    "C": 5.9185791015625,
    "h": 190.370681762695,
    "CMY_C": 0.16560012102127,
    "CMY_M": 0.10011792182922,
    "CMY_Y": 0.11415547132492,
    "CMYK_C": 0.07276753336191,
    "CMYK_M": 0,
    "CMYK_Y": 0.01559932064265,
    "CMYK_K": 0.10011792182922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09239",
    "Farbtonhilfsbezeichnung": "P2.11.62",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "175",
    "Bcolor": "174",
    "Y": 39.5082626342773,
    "L": 69.1178436279297,
    "a": -11.1793518066406,
    "b": -3.73897790908813,
    "C": 11.7880392074585,
    "h": 198.492721557617,
    "CMY_C": 0.44267761707306,
    "CMY_M": 0.31327724456787,
    "CMY_Y": 0.31882095336914,
    "CMYK_C": 0.18843175470829,
    "CMYK_M": 0,
    "CMYK_Y": 0.00807270314544,
    "CMYK_K": 0.31327724456787
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09240",
    "Farbtonhilfsbezeichnung": "P2.15.51",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "149",
    "Bcolor": "150",
    "Y": 27.2416744232178,
    "L": 59.1973533630371,
    "a": -12.4877138137817,
    "b": -5.17391347885132,
    "C": 13.5171146392822,
    "h": 202.505218505859,
    "CMY_C": 0.56175875663757,
    "CMY_M": 0.41420513391495,
    "CMY_Y": 0.41203784942627,
    "CMYK_C": 0.25464379787445,
    "CMYK_M": 0.00368609535508,
    "CMYK_Y": 0,
    "CMYK_K": 0.41203784942627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09241",
    "Farbtonhilfsbezeichnung": "P4.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "238",
    "Bcolor": "235",
    "Y": 82.366081237793,
    "L": 92.7361907958984,
    "a": -5.79737949371338,
    "b": -1.53572070598602,
    "C": 5.99733686447144,
    "h": 194.836837768555,
    "CMY_C": 0.13486242294312,
    "CMY_M": 0.0672858953476,
    "CMY_Y": 0.07821017503738,
    "CMYK_C": 0.07245149463415,
    "CMYK_M": 0,
    "CMYK_Y": 0.01171235647053,
    "CMYK_K": 0.0672858953476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09242",
    "Farbtonhilfsbezeichnung": "P7.11.81",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "228",
    "Bcolor": "229",
    "Y": 71.1496276855469,
    "L": 87.5576553344727,
    "a": -13.491096496582,
    "b": -6.36391401290894,
    "C": 14.9167385101318,
    "h": 205.253829956055,
    "CMY_C": 0.27986097335815,
    "CMY_M": 0.10695916414261,
    "CMY_Y": 0.10096371173859,
    "CMYK_C": 0.19898781180382,
    "CMYK_M": 0.00666875485331,
    "CMYK_Y": 0,
    "CMYK_K": 0.10096371173859
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09243",
    "Farbtonhilfsbezeichnung": "P7.16.76",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "217",
    "Bcolor": "220",
    "Y": 62.3021240234375,
    "L": 83.0738296508789,
    "a": -17.5459575653076,
    "b": -8.20454597473145,
    "C": 19.3694400787354,
    "h": 205.060943603516,
    "CMY_C": 0.37671536207199,
    "CMY_M": 0.14788198471069,
    "CMY_Y": 0.13744515180588,
    "CMYK_C": 0.27739709615707,
    "CMYK_M": 0.01209990680218,
    "CMYK_Y": 0,
    "CMYK_K": 0.13744515180588
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09244",
    "Farbtonhilfsbezeichnung": "P6.19.72",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "206",
    "Bcolor": "211",
    "Y": 54.4425773620605,
    "L": 78.7190933227539,
    "a": -19.8505249023438,
    "b": -9.84889507293701,
    "C": 22.1595134735107,
    "h": 206.388442993164,
    "CMY_C": 0.45673668384552,
    "CMY_M": 0.19083881378174,
    "CMY_Y": 0.173468708992,
    "CMYK_C": 0.342718988657,
    "CMYK_M": 0.02101566456258,
    "CMYK_Y": 0,
    "CMYK_K": 0.173468708992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09245",
    "Farbtonhilfsbezeichnung": "P7.25.61",
    "Farbtonklasse": "02",
    "Rcolor": "102",
    "Gcolor": "180",
    "Bcolor": "186",
    "Y": 39.1096801757813,
    "L": 68.8306427001953,
    "a": -22.25559425354,
    "b": -11.0272064208984,
    "C": 24.8376884460449,
    "h": 206.357498168945,
    "CMY_C": 0.59857296943665,
    "CMY_M": 0.29322373867035,
    "CMY_Y": 0.27193933725357,
    "CMYK_C": 0.44863519072533,
    "CMYK_M": 0.02923437952995,
    "CMYK_Y": 0,
    "CMYK_K": 0.27193933725357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09246",
    "Farbtonhilfsbezeichnung": "P6.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "226",
    "Bcolor": "225",
    "Y": 71.8976745605469,
    "L": 87.9193115234375,
    "a": -8.2191162109375,
    "b": -3.64222192764282,
    "C": 8.98997497558594,
    "h": 203.90007019043,
    "CMY_C": 0.21675407886505,
    "CMY_M": 0.11508476734161,
    "CMY_Y": 0.11634206771851,
    "CMYK_C": 0.11489158123732,
    "CMYK_M": 0,
    "CMYK_Y": 0.00142081442755,
    "CMYK_K": 0.11508476734161
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09247",
    "Farbtonhilfsbezeichnung": "P6.12.76",
    "Farbtonklasse": "02",
    "Rcolor": "173",
    "Gcolor": "215",
    "Bcolor": "216",
    "Y": 62.6842575073242,
    "L": 83.2759704589844,
    "a": -13.1126089096069,
    "b": -5.8648853302002,
    "C": 14.3644485473633,
    "h": 204.097564697266,
    "CMY_C": 0.32028913497925,
    "CMY_M": 0.15539407730103,
    "CMY_Y": 0.15175241231918,
    "CMYK_C": 0.19868811964989,
    "CMYK_M": 0.00429316284135,
    "CMYK_Y": 0,
    "CMYK_K": 0.15175241231918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09248",
    "Farbtonhilfsbezeichnung": "P6.17.72",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "206",
    "Bcolor": "209",
    "Y": 54.6409301757813,
    "L": 78.8339920043945,
    "a": -18.2309761047363,
    "b": -8.61184215545654,
    "C": 20.1626472473145,
    "h": 205.28483581543,
    "CMY_C": 0.43140697479248,
    "CMY_M": 0.1930918097496,
    "CMY_Y": 0.18095695972443,
    "CMYK_C": 0.30578371882439,
    "CMYK_M": 0.01481588836759,
    "CMYK_Y": 0,
    "CMYK_K": 0.18095695972443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09249",
    "Farbtonhilfsbezeichnung": "P7.22.61",
    "Farbtonklasse": "02",
    "Rcolor": "111",
    "Gcolor": "179",
    "Bcolor": "184",
    "Y": 38.9652481079102,
    "L": 68.7260818481445,
    "a": -19.5951385498047,
    "b": -10.2325963973999,
    "C": 22.1060047149658,
    "h": 207.573593139648,
    "CMY_C": 0.56306803226471,
    "CMY_M": 0.29942512512207,
    "CMY_Y": 0.27835994958878,
    "CMYK_C": 0.39452922344208,
    "CMYK_M": 0.02919069677591,
    "CMYK_Y": 0,
    "CMYK_K": 0.27835994958878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09250",
    "Farbtonhilfsbezeichnung": "P7.32.45",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "141",
    "Bcolor": "148",
    "Y": 22.0471611022949,
    "L": 54.0770072937012,
    "a": -22.0017604827881,
    "b": -11.8349313735962,
    "C": 24.9828548431396,
    "h": 208.276184082031,
    "CMY_C": 0.76560550928116,
    "CMY_M": 0.44821923971176,
    "CMY_Y": 0.42037683725357,
    "CMYK_C": 0.59560883045197,
    "CMYK_M": 0.04803535342216,
    "CMYK_Y": 0,
    "CMYK_K": 0.42037683725357
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09251",
    "Farbtonhilfsbezeichnung": "P5.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "208",
    "Gcolor": "225",
    "Bcolor": "223",
    "Y": 72.4758911132813,
    "L": 88.197151184082,
    "a": -5.58991003036499,
    "b": -1.92046070098877,
    "C": 5.91060590744019,
    "h": 198.960586547852,
    "CMY_C": 0.18461066484451,
    "CMY_M": 0.11834675073624,
    "CMY_Y": 0.1256103515625,
    "CMYK_C": 0.07515870034695,
    "CMYK_M": 0,
    "CMYK_Y": 0.0082386136055,
    "CMYK_K": 0.11834675073624
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09252",
    "Farbtonhilfsbezeichnung": "P7.08.76",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "212",
    "Bcolor": "212",
    "Y": 61.6363945007324,
    "L": 82.7196807861328,
    "a": -9.25647830963135,
    "b": -4.12770700454712,
    "C": 10.1351051330566,
    "h": 204.033355712891,
    "CMY_C": 0.284070789814,
    "CMY_M": 0.17017722129822,
    "CMY_Y": 0.17000603675842,
    "CMYK_C": 0.13742841780186,
    "CMYK_M": 0.00020624793251,
    "CMYK_Y": 0,
    "CMYK_K": 0.17000603675842
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09253",
    "Farbtonhilfsbezeichnung": "P8.10.66",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "187",
    "Bcolor": "188",
    "Y": 46.0026550292969,
    "L": 73.5472564697266,
    "a": -9.98383617401123,
    "b": -4.90894174575806,
    "C": 11.1254072189331,
    "h": 206.182830810547,
    "CMY_C": 0.39109909534454,
    "CMY_M": 0.268090903759,
    "CMY_Y": 0.26349550485611,
    "CMYK_C": 0.17325568199158,
    "CMYK_M": 0.00623947149143,
    "CMYK_Y": 0,
    "CMYK_K": 0.26349550485611
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09254",
    "Farbtonhilfsbezeichnung": "P8.12.61",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "173",
    "Bcolor": "176",
    "Y": 38.683422088623,
    "L": 68.5213241577148,
    "a": -10.8730344772339,
    "b": -5.87721538543701,
    "C": 12.3597955703735,
    "h": 208.392608642578,
    "CMY_C": 0.45547842979431,
    "CMY_M": 0.31962966918945,
    "CMY_Y": 0.31009751558304,
    "CMYK_C": 0.21072675287724,
    "CMYK_M": 0.01381666772068,
    "CMYK_Y": 0,
    "CMYK_K": 0.31009751558304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09255",
    "Farbtonhilfsbezeichnung": "P8.16.50",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "146",
    "Bcolor": "150",
    "Y": 26.143928527832,
    "L": 58.1734199523926,
    "a": -11.5398683547974,
    "b": -6.71224927902222,
    "C": 13.3500127792358,
    "h": 210.18473815918,
    "CMY_C": 0.57059013843536,
    "CMY_M": 0.42612940073013,
    "CMY_Y": 0.41198092699051,
    "CMYK_C": 0.26973479986191,
    "CMYK_M": 0.02406124956906,
    "CMYK_Y": 0,
    "CMYK_K": 0.41198092699051
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09256",
    "Farbtonhilfsbezeichnung": "P8.18.45",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "134",
    "Bcolor": "137",
    "Y": 21.3981800079346,
    "L": 53.3825492858887,
    "a": -12.3646755218506,
    "b": -6.60039663314819,
    "C": 14.0160779953003,
    "h": 208.093780517578,
    "CMY_C": 0.62534201145172,
    "CMY_M": 0.47349327802658,
    "CMY_Y": 0.46148896217346,
    "CMYK_C": 0.30427053570747,
    "CMYK_M": 0.02229168079793,
    "CMYK_Y": 0,
    "CMYK_K": 0.46148896217346
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09257",
    "Farbtonhilfsbezeichnung": "P7.25.34",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "110",
    "Bcolor": "114",
    "Y": 13.527666091919,
    "L": 43.5477828979492,
    "a": -13.9115676879883,
    "b": -7.53539896011353,
    "C": 15.8213129043579,
    "h": 208.442810058594,
    "CMY_C": 0.7418771982193,
    "CMY_M": 0.56844758987427,
    "CMY_Y": 0.55302369594574,
    "CMYK_C": 0.42251345515251,
    "CMYK_M": 0.03450718522072,
    "CMYK_Y": 0,
    "CMYK_K": 0.55302369594574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09258",
    "Farbtonhilfsbezeichnung": "Q2.04.81",
    "Farbtonklasse": "01",
    "Rcolor": "210",
    "Gcolor": "224",
    "Bcolor": "224",
    "Y": 72.3685531616211,
    "L": 88.1456909179688,
    "a": -4.02109575271606,
    "b": -2.66310405731201,
    "C": 4.82300043106079,
    "h": 213.515838623047,
    "CMY_C": 0.17495620250702,
    "CMY_M": 0.12225884199142,
    "CMY_Y": 0.12050741910934,
    "CMYK_C": 0.06190931424499,
    "CMYK_M": 0.00199140142649,
    "CMYK_Y": 0,
    "CMYK_K": 0.12050741910934
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09259",
    "Farbtonhilfsbezeichnung": "Q3.06.77",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "212",
    "Bcolor": "214",
    "Y": 62.8915596008301,
    "L": 83.3852920532227,
    "a": -5.78535079956055,
    "b": -4.20692491531372,
    "C": 7.15321636199951,
    "h": 216.023468017578,
    "CMY_C": 0.24749791622162,
    "CMY_M": 0.17041307687759,
    "CMY_Y": 0.1617266535759,
    "CMYK_C": 0.10231896489859,
    "CMYK_M": 0.01036228053272,
    "CMYK_Y": 0,
    "CMYK_K": 0.1617266535759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09260",
    "Farbtonhilfsbezeichnung": "Q3.08.73",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "203",
    "Bcolor": "207",
    "Y": 56.6027030944824,
    "L": 79.9556121826172,
    "a": -7.81829738616943,
    "b": -5.54741239547729,
    "C": 9.58642578125,
    "h": 215.357315063477,
    "CMY_C": 0.30713766813278,
    "CMY_M": 0.20312255620956,
    "CMY_Y": 0.18965011835098,
    "CMYK_C": 0.14498373866081,
    "CMYK_M": 0.01662545837462,
    "CMYK_Y": 0,
    "CMYK_K": 0.18965011835098
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09261",
    "Farbtonhilfsbezeichnung": "Q4.12.59",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "167",
    "Bcolor": "172",
    "Y": 35.7530097961426,
    "L": 66.3307723999023,
    "a": -8.95415306091309,
    "b": -7.21009731292725,
    "C": 11.4961891174316,
    "h": 218.841842651367,
    "CMY_C": 0.46697932481766,
    "CMY_M": 0.34624576568604,
    "CMY_Y": 0.3236477971077,
    "CMYK_C": 0.21191847324371,
    "CMYK_M": 0.03341154009104,
    "CMYK_Y": 0,
    "CMYK_K": 0.3236477971077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09262",
    "Farbtonhilfsbezeichnung": "Q4.16.46",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "137",
    "Bcolor": "143",
    "Y": 22.7904205322266,
    "L": 54.8558044433594,
    "a": -9.99904727935791,
    "b": -7.53067970275879,
    "C": 12.5176706314087,
    "h": 216.984848022461,
    "CMY_C": 0.59353935718536,
    "CMY_M": 0.46271806955338,
    "CMY_Y": 0.44013017416,
    "CMYK_C": 0.27400866150856,
    "CMYK_M": 0.04034490510821,
    "CMYK_Y": 0,
    "CMYK_K": 0.44013017416
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09263",
    "Farbtonhilfsbezeichnung": "Q4.20.38",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "119",
    "Bcolor": "125",
    "Y": 16.4784412384033,
    "L": 47.5960311889648,
    "a": -10.5470190048218,
    "b": -8.09739971160889,
    "C": 13.2968978881836,
    "h": 217.514999389648,
    "CMY_C": 0.67251646518707,
    "CMY_M": 0.5343371629715,
    "CMY_Y": 0.50927191972733,
    "CMYK_C": 0.3326578438282,
    "CMYK_M": 0.05107766389847,
    "CMYK_Y": 0,
    "CMYK_K": 0.50927191972733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09264",
    "Farbtonhilfsbezeichnung": "Q3.21.27",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "94",
    "Bcolor": "100",
    "Y": 10.1542310714722,
    "L": 38.1178245544434,
    "a": -8.54376125335693,
    "b": -6.82319211959839,
    "C": 10.9339752197266,
    "h": 218.611450195312,
    "CMY_C": 0.73823404312134,
    "CMY_M": 0.63022571802139,
    "CMY_Y": 0.60935151576996,
    "CMYK_C": 0.32991942763329,
    "CMYK_M": 0.05343474447727,
    "CMYK_Y": 0,
    "CMYK_K": 0.60935151576996
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09265",
    "Farbtonhilfsbezeichnung": "Q2.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "222",
    "Bcolor": "223",
    "Y": 70.5259628295898,
    "L": 87.2541885375977,
    "a": -5.91433000564575,
    "b": -3.44966602325439,
    "C": 6.84686040878296,
    "h": 210.253845214844,
    "CMY_C": 0.20355731248856,
    "CMY_M": 0.12764477729797,
    "CMY_Y": 0.12480211257935,
    "CMYK_C": 0.0899855941534,
    "CMYK_M": 0.00324802519754,
    "CMYK_Y": 0,
    "CMYK_K": 0.12480211257935
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09266",
    "Farbtonhilfsbezeichnung": "Q3.16.65",
    "Farbtonklasse": "02",
    "Rcolor": "138",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 43.3845176696777,
    "L": 71.8151779174805,
    "a": -12.9212656021118,
    "b": -9.87302494049072,
    "C": 16.2614803314209,
    "h": 217.383117675781,
    "CMY_C": 0.45935547351837,
    "CMY_M": 0.27928602695465,
    "CMY_Y": 0.24720615148544,
    "CMYK_C": 0.28181597590446,
    "CMYK_M": 0.04261442273855,
    "CMYK_Y": 0,
    "CMYK_K": 0.24720615148544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09267",
    "Farbtonhilfsbezeichnung": "Q3.23.56",
    "Farbtonklasse": "02",
    "Rcolor": "101",
    "Gcolor": "165",
    "Bcolor": "175",
    "Y": 32.663818359375,
    "L": 63.887767791748,
    "a": -17.2449512481689,
    "b": -12.5419702529907,
    "C": 21.3234462738037,
    "h": 216.027786254883,
    "CMY_C": 0.60247397422791,
    "CMY_M": 0.35438793897629,
    "CMY_Y": 0.31326931715012,
    "CMYK_C": 0.42113256454468,
    "CMYK_M": 0.05987590551376,
    "CMYK_Y": 0,
    "CMYK_K": 0.31326931715012
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09268",
    "Farbtonhilfsbezeichnung": "Q2.41.34",
    "Farbtonklasse": "03",
    "Rcolor": "27",
    "Gcolor": "115",
    "Bcolor": "127",
    "Y": 13.9629516601563,
    "L": 44.1797523498535,
    "a": -20.3165855407715,
    "b": -14.4398946762085,
    "C": 24.9253730773926,
    "h": 215.403091430664,
    "CMY_C": 0.89499950408936,
    "CMY_M": 0.54995405673981,
    "CMY_Y": 0.50285720825195,
    "CMYK_C": 0.78879207372665,
    "CMYK_M": 0.09473505616188,
    "CMYK_Y": 0,
    "CMYK_K": 0.50285720825195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09269",
    "Farbtonhilfsbezeichnung": "Q1.41.24",
    "Farbtonklasse": "04",
    "Rcolor": "32",
    "Gcolor": "92",
    "Bcolor": "101",
    "Y": 8.94991874694824,
    "L": 35.8876914978027,
    "a": -15.8335695266724,
    "b": -11.4294910430908,
    "C": 19.5278053283691,
    "h": 215.823715209961,
    "CMY_C": 0.87496030330658,
    "CMY_M": 0.63822221755981,
    "CMY_Y": 0.60248458385468,
    "CMYK_C": 0.68544691801071,
    "CMYK_M": 0.08990251272917,
    "CMYK_Y": 0,
    "CMYK_K": 0.60248458385468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09270",
    "Farbtonhilfsbezeichnung": "Q2.08.81",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "226",
    "Bcolor": "229",
    "Y": 71.4720153808594,
    "L": 87.7138290405273,
    "a": -8.74120616912842,
    "b": -5.70285940170288,
    "C": 10.4370155334473,
    "h": 213.120864868164,
    "CMY_C": 0.23212188482285,
    "CMY_M": 0.11562323570251,
    "CMY_Y": 0.10351860523224,
    "CMYK_C": 0.14345337450504,
    "CMYK_M": 0.01350237801671,
    "CMYK_Y": 0,
    "CMYK_K": 0.10351860523224
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09271",
    "Farbtonhilfsbezeichnung": "Q3.10.77",
    "Farbtonklasse": "01",
    "Rcolor": "182",
    "Gcolor": "216",
    "Bcolor": "219",
    "Y": 63.9835968017578,
    "L": 83.9572296142578,
    "a": -10.0077924728394,
    "b": -6.34328651428223,
    "C": 11.8487634658813,
    "h": 212.367950439453,
    "CMY_C": 0.2868509888649,
    "CMY_M": 0.15429949760437,
    "CMY_Y": 0.14041930437088,
    "CMYK_C": 0.17035245895386,
    "CMYK_M": 0.01614763215184,
    "CMYK_Y": 0,
    "CMYK_K": 0.14041930437088
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09272",
    "Farbtonhilfsbezeichnung": "Q3.30.56",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "168",
    "Bcolor": "182",
    "Y": 32.9988555908203,
    "L": 64.1599807739258,
    "a": -21.6594467163086,
    "b": -15.8937282562256,
    "C": 26.8652610778809,
    "h": 216.271270751953,
    "CMY_C": 0.68116354942322,
    "CMY_M": 0.34257286787033,
    "CMY_Y": 0.28760027885437,
    "CMYK_C": 0.55244725942612,
    "CMYK_M": 0.0771653726697,
    "CMYK_Y": 0,
    "CMYK_K": 0.28760027885437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09273",
    "Farbtonhilfsbezeichnung": "Q2.40.44",
    "Farbtonklasse": "03",
    "Rcolor": "12",
    "Gcolor": "138",
    "Bcolor": "152",
    "Y": 20.4065608978271,
    "L": 52.2938003540039,
    "a": -24.682674407959,
    "b": -17.3305702209473,
    "C": 30.1592960357666,
    "h": 215.074035644531,
    "CMY_C": 0.95383375883102,
    "CMY_M": 0.4605804681778,
    "CMY_Y": 0.40211176872253,
    "CMYK_C": 0.92278450727463,
    "CMYK_M": 0.09779202193022,
    "CMYK_Y": 0,
    "CMYK_K": 0.40211176872253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09274",
    "Farbtonhilfsbezeichnung": "Q2.50.36",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "120",
    "Bcolor": "136",
    "Y": 14.8260517120361,
    "L": 45.3950233459473,
    "a": -25.6812152862549,
    "b": -18.1814594268799,
    "C": 31.4657001495361,
    "h": 215.297241210938,
    "CMY_C": 1,
    "CMY_M": 0.5286653637886,
    "CMY_Y": 0.46680682897568,
    "CMYK_C": 1,
    "CMYK_M": 0.11601524055004,
    "CMYK_Y": 0,
    "CMYK_K": 0.46680682897568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09275",
    "Farbtonhilfsbezeichnung": "Q0.18.75",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "215",
    "Bcolor": "221",
    "Y": 60.0028228759766,
    "L": 81.8397216796875,
    "a": -18.6365737915039,
    "b": -10.8146686553955,
    "C": 21.5471324920654,
    "h": 210.126281738281,
    "CMY_C": 0.41562515497208,
    "CMY_M": 0.15858340263367,
    "CMY_Y": 0.13215291500092,
    "CMYK_C": 0.3266384601593,
    "CMYK_M": 0.03045523539186,
    "CMYK_Y": 0,
    "CMYK_K": 0.13215291500092
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09276",
    "Farbtonhilfsbezeichnung": "P9.36.58",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "175",
    "Bcolor": "186",
    "Y": 34.888858795166,
    "L": 65.6620407104492,
    "a": -29.6788368225098,
    "b": -16.2697124481201,
    "C": 33.8457794189453,
    "h": 208.731216430664,
    "CMY_C": 0.81873279809952,
    "CMY_M": 0.31282335519791,
    "CMY_Y": 0.26972097158432,
    "CMYK_C": 0.7517836689949,
    "CMYK_M": 0.05902180075645,
    "CMYK_Y": 0,
    "CMYK_K": 0.26972097158432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09277",
    "Farbtonhilfsbezeichnung": "Q3.08.83",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "231",
    "Bcolor": "233",
    "Y": 75.5397872924805,
    "L": 89.6452331542969,
    "a": -8.99516201019287,
    "b": -5.35370826721191,
    "C": 10.4678144454956,
    "h": 210.760101318359,
    "CMY_C": 0.21179091930389,
    "CMY_M": 0.09363925457001,
    "CMY_Y": 0.08469516038895,
    "CMYK_C": 0.13885620236397,
    "CMYK_M": 0.00977171119303,
    "CMYK_Y": 0,
    "CMYK_K": 0.08469516038895
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09278",
    "Farbtonhilfsbezeichnung": "Q9.11.82",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "228",
    "Bcolor": "235",
    "Y": 73.2165603637695,
    "L": 88.550895690918,
    "a": -9.52138423919678,
    "b": -7.78515529632568,
    "C": 12.298999786377,
    "h": 219.271133422852,
    "CMY_C": 0.23903799057007,
    "CMY_M": 0.10397857427597,
    "CMY_Y": 0.07898640632629,
    "CMYK_C": 0.17377765476704,
    "CMYK_M": 0.02713550440967,
    "CMYK_Y": 0,
    "CMYK_K": 0.07898640632629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09279",
    "Farbtonhilfsbezeichnung": "Q9.35.60",
    "Farbtonklasse": "03",
    "Rcolor": "65",
    "Gcolor": "178",
    "Bcolor": "202",
    "Y": 37.3964500427246,
    "L": 67.5734100341797,
    "a": -23.6808338165283,
    "b": -22.3780860900879,
    "C": 32.581600189209,
    "h": 223.379852294922,
    "CMY_C": 0.74335283041,
    "CMY_M": 0.30067819356918,
    "CMY_Y": 0.20590603351593,
    "CMYK_C": 0.67680501937866,
    "CMYK_M": 0.11934627592564,
    "CMYK_Y": 0,
    "CMYK_K": 0.20590603351593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09280",
    "Farbtonhilfsbezeichnung": "Q9.45.53",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "163",
    "Bcolor": "193",
    "Y": 29.7086601257324,
    "L": 61.4020309448242,
    "a": -25.7579078674316,
    "b": -26.7551078796387,
    "C": 37.1390037536621,
    "h": 226.087905883789,
    "CMY_C": 1,
    "CMY_M": 0.36121374368668,
    "CMY_Y": 0.24224054813385,
    "CMYK_C": 1,
    "CMYK_M": 0.15700654685497,
    "CMYK_Y": 0,
    "CMYK_K": 0.24224054813385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09281",
    "Farbtonhilfsbezeichnung": "Q9.47.41",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "133",
    "Bcolor": "158",
    "Y": 18.894588470459,
    "L": 50.5636520385742,
    "a": -23.1229763031006,
    "b": -23.3215751647949,
    "C": 32.8415565490723,
    "h": 225.244995117188,
    "CMY_C": 1,
    "CMY_M": 0.47880536317825,
    "CMY_Y": 0.37990480661392,
    "CMYK_C": 1,
    "CMYK_M": 0.15949253737926,
    "CMYK_Y": 0,
    "CMYK_K": 0.37990480661392
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09282",
    "Farbtonhilfsbezeichnung": "Q7.17.76",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "215",
    "Bcolor": "227",
    "Y": 61.6951332092285,
    "L": 82.7510299682617,
    "a": -14.0090494155884,
    "b": -12.2890911102295,
    "C": 18.6353225708008,
    "h": 221.258056640625,
    "CMY_C": 0.36633116006851,
    "CMY_M": 0.15742015838623,
    "CMY_Y": 0.11086732149124,
    "CMYK_C": 0.28731802105904,
    "CMYK_M": 0.05235758051276,
    "CMYK_Y": 0,
    "CMYK_K": 0.11086732149124
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09283",
    "Farbtonhilfsbezeichnung": "Q8.23.71",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "204",
    "Bcolor": "221",
    "Y": 53.1273231506348,
    "L": 77.9501113891602,
    "a": -18.4729461669922,
    "b": -16.3596858978271,
    "C": 24.6756782531738,
    "h": 221.528167724609,
    "CMY_C": 0.49050575494766,
    "CMY_M": 0.19996553659439,
    "CMY_Y": 0.1348437666893,
    "CMYK_C": 0.4110956788063,
    "CMYK_M": 0.0752716884017,
    "CMYK_Y": 0,
    "CMYK_K": 0.1348437666893
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09284",
    "Farbtonhilfsbezeichnung": "Q9.33.62",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "184",
    "Bcolor": "207",
    "Y": 40.3290252685547,
    "L": 69.703239440918,
    "a": -22.5068168640137,
    "b": -21.4668502807617,
    "C": 31.1027717590332,
    "h": 223.645217895508,
    "CMY_C": 0.68277394771576,
    "CMY_M": 0.28022241592407,
    "CMY_Y": 0.18908113241196,
    "CMYK_C": 0.60880666971207,
    "CMYK_M": 0.11239260435104,
    "CMYK_Y": 0,
    "CMYK_K": 0.18908113241196
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09285",
    "Farbtonhilfsbezeichnung": "R0.48.46",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "143",
    "Bcolor": "173",
    "Y": 22.316707611084,
    "L": 54.3614311218262,
    "a": -24.1838283538818,
    "b": -26.269681930542,
    "C": 35.7064933776855,
    "h": 227.367385864258,
    "CMY_C": 1,
    "CMY_M": 0.43729418516159,
    "CMY_Y": 0.32047122716904,
    "CMYK_C": 1,
    "CMYK_M": 0.17191760241985,
    "CMYK_Y": 0,
    "CMYK_K": 0.32047122716904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09286",
    "Farbtonhilfsbezeichnung": "R0.52.39",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "128",
    "Bcolor": "156",
    "Y": 17.2154808044434,
    "L": 48.530403137207,
    "a": -23.2828998565674,
    "b": -25.0833625793457,
    "C": 34.2238006591797,
    "h": 227.131881713867,
    "CMY_C": 1,
    "CMY_M": 0.49856346845627,
    "CMY_Y": 0.3892759680748,
    "CMYK_C": 1,
    "CMYK_M": 0.17894743382931,
    "CMYK_Y": 0,
    "CMYK_K": 0.3892759680748
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09287",
    "Farbtonhilfsbezeichnung": "Q9.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "229",
    "Bcolor": "232",
    "Y": 75.1530532836914,
    "L": 89.4646377563477,
    "a": -6.12699794769287,
    "b": -4.94239711761475,
    "C": 7.87193727493286,
    "h": 218.891693115234,
    "CMY_C": 0.18711096048355,
    "CMY_M": 0.10215324163437,
    "CMY_Y": 0.08937931060791,
    "CMYK_C": 0.10732421278954,
    "CMYK_M": 0.0140277184546,
    "CMYK_Y": 0,
    "CMYK_K": 0.08937931060791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09288",
    "Farbtonhilfsbezeichnung": "R0.10.82",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "226",
    "Bcolor": "233",
    "Y": 72.1135787963867,
    "L": 88.0232315063477,
    "a": -8.65381526947021,
    "b": -7.74574613571167,
    "C": 11.6140041351318,
    "h": 221.830688476562,
    "CMY_C": 0.23681718111038,
    "CMY_M": 0.11176508665085,
    "CMY_Y": 0.08504158258438,
    "CMYK_C": 0.16588251292706,
    "CMYK_M": 0.02920734323561,
    "CMYK_Y": 0,
    "CMYK_K": 0.08504158258438
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09289",
    "Farbtonhilfsbezeichnung": "Q9.12.76",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "212",
    "Bcolor": "220",
    "Y": 61.5862236022949,
    "L": 82.6928863525391,
    "a": -9.6650972366333,
    "b": -8.75516319274902,
    "C": 13.0409736633301,
    "h": 222.171966552734,
    "CMY_C": 0.3081881403923,
    "CMY_M": 0.16824275255203,
    "CMY_Y": 0.13671863079071,
    "CMYK_C": 0.19862528145313,
    "CMYK_M": 0.03651662543416,
    "CMYK_Y": 0,
    "CMYK_K": 0.13671863079071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09290",
    "Farbtonhilfsbezeichnung": "Q9.19.65",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "184",
    "Bcolor": "198",
    "Y": 43.5067253112793,
    "L": 71.8975524902344,
    "a": -13.0948686599731,
    "b": -13.1504602432251,
    "C": 18.558292388916,
    "h": 225.121353149414,
    "CMY_C": 0.4776713848114,
    "CMY_M": 0.27707666158676,
    "CMY_Y": 0.22316640615463,
    "CMYK_C": 0.32761839032173,
    "CMYK_M": 0.06939742714167,
    "CMYK_Y": 0,
    "CMYK_K": 0.22316640615463
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09291",
    "Farbtonhilfsbezeichnung": "Q9.28.53",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "157",
    "Bcolor": "175",
    "Y": 29.0372905731201,
    "L": 60.8145332336426,
    "a": -16.9752254486084,
    "b": -16.9720439910889,
    "C": 24.0043449401856,
    "h": 224.99462890625,
    "CMY_C": 0.6638588309288,
    "CMY_M": 0.38572388887405,
    "CMY_Y": 0.31513583660126,
    "CMYK_C": 0.50918561220169,
    "CMYK_M": 0.10306868702173,
    "CMYK_Y": 0,
    "CMYK_K": 0.31513583660126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09292",
    "Farbtonhilfsbezeichnung": "Q9.33.43",
    "Farbtonklasse": "03",
    "Rcolor": "61",
    "Gcolor": "132",
    "Bcolor": "149",
    "Y": 19.5517024993896,
    "L": 51.3265228271484,
    "a": -16.7597713470459,
    "b": -16.4875659942627,
    "C": 23.5102062225342,
    "h": 224.530914306641,
    "CMY_C": 0.7620764374733,
    "CMY_M": 0.48366957902908,
    "CMY_Y": 0.41700553894043,
    "CMYK_C": 0.59189397096634,
    "CMYK_M": 0.11434763669968,
    "CMYK_Y": 0,
    "CMYK_K": 0.41700553894043
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09293",
    "Farbtonhilfsbezeichnung": "Q8.38.32",
    "Farbtonklasse": "04",
    "Rcolor": "40",
    "Gcolor": "107",
    "Bcolor": "122",
    "Y": 12.3080730438232,
    "L": 41.7016220092773,
    "a": -15.5067300796509,
    "b": -15.5392227172852,
    "C": 21.9528160095215,
    "h": 225.059967041016,
    "CMY_C": 0.84502565860748,
    "CMY_M": 0.58158957958221,
    "CMY_Y": 0.51997911930084,
    "CMYK_C": 0.67715084552765,
    "CMYK_M": 0.1283495426178,
    "CMYK_Y": 0,
    "CMYK_K": 0.51997911930084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09294",
    "Farbtonhilfsbezeichnung": "R1.10.65",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "181",
    "Bcolor": "188",
    "Y": 43.8457107543945,
    "L": 72.1252517700195,
    "a": -6.87682723999023,
    "b": -7.02196216583252,
    "C": 9.82846450805664,
    "h": 225.598266601562,
    "CMY_C": 0.38806283473969,
    "CMY_M": 0.28920012712479,
    "CMY_Y": 0.26335430145264,
    "CMYK_C": 0.16929242014885,
    "CMYK_M": 0.03508583083749,
    "CMYK_Y": 0,
    "CMYK_K": 0.26335430145264
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09295",
    "Farbtonhilfsbezeichnung": "R0.13.56",
    "Farbtonklasse": "02",
    "Rcolor": "130",
    "Gcolor": "159",
    "Bcolor": "167",
    "Y": 32.2700691223145,
    "L": 63.5654678344727,
    "a": -7.88244152069092,
    "b": -8.49231338500977,
    "C": 11.5867280960083,
    "h": 227.132965087891,
    "CMY_C": 0.49162006378174,
    "CMY_M": 0.37699317932129,
    "CMY_Y": 0.34363776445389,
    "CMYK_C": 0.22545827925205,
    "CMYK_M": 0.05081860721111,
    "CMYK_Y": 0,
    "CMYK_K": 0.34363776445389
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09296",
    "Farbtonhilfsbezeichnung": "R0.20.42",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "128",
    "Bcolor": "138",
    "Y": 19.3342380523682,
    "L": 51.0759773254395,
    "a": -10.234842300415,
    "b": -10.5379314422607,
    "C": 14.6901321411133,
    "h": 225.835922241211,
    "CMY_C": 0.64816844463348,
    "CMY_M": 0.49955880641937,
    "CMY_Y": 0.45839989185333,
    "CMYK_C": 0.35038501024246,
    "CMYK_M": 0.07599502801895,
    "CMYK_Y": 0,
    "CMYK_K": 0.45839989185333
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09297",
    "Farbtonhilfsbezeichnung": "Q8.34.27",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "98",
    "Bcolor": "111",
    "Y": 10.6399621963501,
    "L": 38.9673347473145,
    "a": -12.2916097640991,
    "b": -12.3897924423218,
    "C": 17.4525241851807,
    "h": 225.227920532227,
    "CMY_C": 0.80108827352524,
    "CMY_M": 0.61420398950577,
    "CMY_Y": 0.56652325391769,
    "CMYK_C": 0.54112482070923,
    "CMYK_M": 0.1099960654974,
    "CMYK_Y": 0,
    "CMYK_K": 0.56652325391769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09298",
    "Farbtonhilfsbezeichnung": "Q9.23.29",
    "Farbtonklasse": "03",
    "Rcolor": "69",
    "Gcolor": "99",
    "Bcolor": "108",
    "Y": 11.3366889953613,
    "L": 40.1418533325195,
    "a": -8.71225833892822,
    "b": -8.84620761871338,
    "C": 12.4160718917847,
    "h": 225.437088012695,
    "CMY_C": 0.73077416419983,
    "CMY_M": 0.61006492376328,
    "CMY_Y": 0.57722771167755,
    "CMYK_C": 0.36318948864937,
    "CMYK_M": 0.07767115533352,
    "CMYK_Y": 0,
    "CMYK_K": 0.57722771167755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09299",
    "Farbtonhilfsbezeichnung": "R6.06.73",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "199",
    "Bcolor": "205",
    "Y": 55.3631134033203,
    "L": 79.2499618530273,
    "a": -3.85594391822815,
    "b": -5.55431938171387,
    "C": 6.76156568527222,
    "h": 235.230682373047,
    "CMY_C": 0.2812215089798,
    "CMY_M": 0.21946489810944,
    "CMY_Y": 0.19677799940109,
    "CMYK_C": 0.10513097047806,
    "CMYK_M": 0.02824486792088,
    "CMYK_Y": 0,
    "CMYK_K": 0.19677799940109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09300",
    "Farbtonhilfsbezeichnung": "R6.14.65",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "183",
    "Bcolor": "196",
    "Y": 44.5181312561035,
    "L": 72.5734634399414,
    "a": -7.71964406967163,
    "b": -11.001651763916,
    "C": 13.4398384094238,
    "h": 234.943420410156,
    "CMY_C": 0.40850913524628,
    "CMY_M": 0.28145623207092,
    "CMY_Y": 0.23051035404205,
    "CMYK_C": 0.23132055997849,
    "CMYK_M": 0.06620735675097,
    "CMYK_Y": 0,
    "CMYK_K": 0.23051035404205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09301",
    "Farbtonhilfsbezeichnung": "R5.21.52",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "151",
    "Bcolor": "168",
    "Y": 28.1373882293701,
    "L": 60.0126571655273,
    "a": -10.300464630127,
    "b": -14.2205085754395,
    "C": 17.5591125488281,
    "h": 234.082733154297,
    "CMY_C": 0.57918584346771,
    "CMY_M": 0.40737020969391,
    "CMY_Y": 0.34176200628281,
    "CMYK_C": 0.36069604754448,
    "CMYK_M": 0.09967246651649,
    "CMYK_Y": 0,
    "CMYK_K": 0.34176200628281
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09302",
    "Farbtonhilfsbezeichnung": "R2.22.18",
    "Farbtonklasse": "04",
    "Rcolor": "59",
    "Gcolor": "77",
    "Bcolor": "85",
    "Y": 6.92214965820313,
    "L": 31.629020690918,
    "a": -5.08043003082275,
    "b": -7.13130807876587,
    "C": 8.75593090057373,
    "h": 234.533462524414,
    "CMY_C": 0.76974892616272,
    "CMY_M": 0.69682717323303,
    "CMY_Y": 0.66805732250214,
    "CMYK_C": 0.30635291337967,
    "CMYK_M": 0.08667114377022,
    "CMYK_Y": 0,
    "CMYK_K": 0.66805732250214
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09303",
    "Farbtonhilfsbezeichnung": "R5.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "194",
    "Gcolor": "222",
    "Bcolor": "231",
    "Y": 69.3204116821289,
    "L": 86.662467956543,
    "a": -6.75869417190552,
    "b": -8.75008010864258,
    "C": 11.0563936233521,
    "h": 232.316955566406,
    "CMY_C": 0.23920947313309,
    "CMY_M": 0.13074880838394,
    "CMY_Y": 0.09254914522171,
    "CMYK_C": 0.16161793470383,
    "CMYK_M": 0.04209557175636,
    "CMYK_Y": 0,
    "CMYK_K": 0.09254914522171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09304",
    "Farbtonhilfsbezeichnung": "R6.11.74",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "207",
    "Bcolor": "218",
    "Y": 59.0762252807617,
    "L": 81.3334808349609,
    "a": -7.41026449203491,
    "b": -9.66962051391602,
    "C": 12.1825113296509,
    "h": 232.535430908203,
    "CMY_C": 0.30665957927704,
    "CMY_M": 0.18772804737091,
    "CMY_Y": 0.14475858211517,
    "CMYK_C": 0.18930444121361,
    "CMYK_M": 0.05024249851704,
    "CMYK_Y": 0,
    "CMYK_K": 0.14475858211517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09305",
    "Farbtonhilfsbezeichnung": "R5.19.67",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "192",
    "Bcolor": "211",
    "Y": 48.5699729919434,
    "L": 75.1830139160156,
    "a": -11.0603637695313,
    "b": -15.0606594085693,
    "C": 18.6856918334961,
    "h": 233.706893920898,
    "CMY_C": 0.43309652805328,
    "CMY_M": 0.24523347616196,
    "CMY_Y": 0.17372930049896,
    "CMYK_C": 0.31390103697777,
    "CMYK_M": 0.08653844147921,
    "CMYK_Y": 0,
    "CMYK_K": 0.17372930049896
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09306",
    "Farbtonhilfsbezeichnung": "R4.41.34",
    "Farbtonklasse": "04",
    "Rcolor": "41",
    "Gcolor": "113",
    "Bcolor": "136",
    "Y": 14.0556545257568,
    "L": 44.3126411437988,
    "a": -14.4255886077881,
    "b": -19.5497074127197,
    "C": 24.2958564758301,
    "h": 233.57666015625,
    "CMY_C": 0.84103715419769,
    "CMY_M": 0.55658143758774,
    "CMY_Y": 0.46798706054688,
    "CMYK_C": 0.70120489597321,
    "CMYK_M": 0.16652673482895,
    "CMYK_Y": 0,
    "CMYK_K": 0.46798706054688
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09307",
    "Farbtonhilfsbezeichnung": "R3.43.26",
    "Farbtonklasse": "04",
    "Rcolor": "38",
    "Gcolor": "98",
    "Bcolor": "116",
    "Y": 10.4161233901978,
    "L": 38.5791397094727,
    "a": -12.7522802352905,
    "b": -16.6367244720459,
    "C": 20.9619007110596,
    "h": 232.529342651367,
    "CMY_C": 0.84906709194183,
    "CMY_M": 0.61590611934662,
    "CMY_Y": 0.54353415966034,
    "CMYK_C": 0.66934454441071,
    "CMYK_M": 0.15854847431183,
    "CMYK_Y": 0,
    "CMYK_K": 0.54353415966034
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09308",
    "Farbtonhilfsbezeichnung": "R5.12.80",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "223",
    "Bcolor": "234",
    "Y": 69.7190017700195,
    "L": 86.8588638305664,
    "a": -8.39528751373291,
    "b": -10.0558128356934,
    "C": 13.0996265411377,
    "h": 230.142532348633,
    "CMY_C": 0.25755071640015,
    "CMY_M": 0.12456995248795,
    "CMY_Y": 0.08097779750824,
    "CMYK_C": 0.19213128089905,
    "CMYK_M": 0.04743319004774,
    "CMYK_Y": 0,
    "CMYK_K": 0.08097779750824
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09309",
    "Farbtonhilfsbezeichnung": "R6.19.75",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "213",
    "Bcolor": "232",
    "Y": 60.546215057373,
    "L": 82.1341857910156,
    "a": -12.3222818374634,
    "b": -16.1037540435791,
    "C": 20.2773151397705,
    "h": 232.577484130859,
    "CMY_C": 0.3769303560257,
    "CMY_M": 0.16650980710983,
    "CMY_Y": 0.08977460861206,
    "CMYK_C": 0.31547763943672,
    "CMYK_M": 0.08430351316929,
    "CMYK_Y": 0,
    "CMYK_K": 0.08977460861206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09310",
    "Farbtonhilfsbezeichnung": "R5.31.61",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "179",
    "Bcolor": "207",
    "Y": 39.12548828125,
    "L": 68.8420715332031,
    "a": -16.7932434082031,
    "b": -22.8787803649902,
    "C": 28.3804798126221,
    "h": 233.720977783203,
    "CMY_C": 0.6206636428833,
    "CMY_M": 0.29948711395264,
    "CMY_Y": 0.18799525499344,
    "CMYK_C": 0.5328397154808,
    "CMYK_M": 0.13730444014072,
    "CMYK_Y": 0,
    "CMYK_K": 0.18799525499344
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09311",
    "Farbtonhilfsbezeichnung": "R4.41.54",
    "Farbtonklasse": "03",
    "Rcolor": "46",
    "Gcolor": "162",
    "Bcolor": "195",
    "Y": 30.5450496673584,
    "L": 62.1216888427734,
    "a": -20.3172111511231,
    "b": -26.7338848114014,
    "C": 33.5781135559082,
    "h": 232.765899658203,
    "CMY_C": 0.81793236732483,
    "CMY_M": 0.36290496587753,
    "CMY_Y": 0.23421210050583,
    "CMYK_C": 0.76224797964096,
    "CMYK_M": 0.1680528819561,
    "CMYK_Y": 0,
    "CMYK_K": 0.23421210050583
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09312",
    "Farbtonhilfsbezeichnung": "R4.51.47",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "145",
    "Bcolor": "183",
    "Y": 23.2313365936279,
    "L": 55.3098335266113,
    "a": -21.479419708252,
    "b": -30.2453937530518,
    "C": 37.0964851379395,
    "h": 234.618713378906,
    "CMY_C": 1,
    "CMY_M": 0.43053364753723,
    "CMY_Y": 0.28326708078384,
    "CMYK_C": 1,
    "CMYK_M": 0.20546923577785,
    "CMYK_Y": 0,
    "CMYK_K": 0.28326708078384
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09313",
    "Farbtonhilfsbezeichnung": "R6.53.38",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "122",
    "Bcolor": "157",
    "Y": 16.0276355743408,
    "L": 47.0107269287109,
    "a": -18.7174873352051,
    "b": -27.9368209838867,
    "C": 33.6275215148926,
    "h": 236.178176879883,
    "CMY_C": 1,
    "CMY_M": 0.52001082897186,
    "CMY_Y": 0.38584703207016,
    "CMYK_C": 1,
    "CMYK_M": 0.21845339238644,
    "CMYK_Y": 0,
    "CMYK_K": 0.38584703207016
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09314",
    "Farbtonhilfsbezeichnung": "R3.53.32",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "112",
    "Bcolor": "139",
    "Y": 13.1969318389893,
    "L": 43.0584869384766,
    "a": -17.8907070159912,
    "b": -23.7670402526856,
    "C": 29.7481021881104,
    "h": 233.029296875,
    "CMY_C": 1,
    "CMY_M": 0.56190192699432,
    "CMY_Y": 0.45359182357788,
    "CMYK_C": 1,
    "CMYK_M": 0.19822196662426,
    "CMYK_Y": 0,
    "CMYK_K": 0.45359182357788
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09315",
    "Farbtonhilfsbezeichnung": "R4.12.78",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "217",
    "Bcolor": "228",
    "Y": 65.1631546020508,
    "L": 84.567741394043,
    "a": -8.14784145355225,
    "b": -9.98920059204102,
    "C": 12.8907508850098,
    "h": 230.797088623047,
    "CMY_C": 0.27986431121826,
    "CMY_M": 0.15048658847809,
    "CMY_Y": 0.10686546564102,
    "CMYK_C": 0.19369852542877,
    "CMYK_M": 0.04884048551321,
    "CMYK_Y": 0,
    "CMYK_K": 0.10686546564102
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09316",
    "Farbtonhilfsbezeichnung": "R5.16.71",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "199",
    "Bcolor": "215",
    "Y": 52.5696983337402,
    "L": 77.6202545166016,
    "a": -9.95400524139404,
    "b": -13.8634366989136,
    "C": 17.0668411254883,
    "h": 234.321502685547,
    "CMY_C": 0.38999897241592,
    "CMY_M": 0.22150194644928,
    "CMY_Y": 0.15552943944931,
    "CMYK_C": 0.27765271067619,
    "CMYK_M": 0.07812292128801,
    "CMYK_Y": 0,
    "CMYK_K": 0.15552943944931
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09317",
    "Farbtonhilfsbezeichnung": "R5.29.55",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "160",
    "Bcolor": "184",
    "Y": 30.8180446624756,
    "L": 62.3537330627441,
    "a": -14.8560190200806,
    "b": -19.7730846405029,
    "C": 24.7320880889893,
    "h": 233.081527709961,
    "CMY_C": 0.64217901229858,
    "CMY_M": 0.3726578950882,
    "CMY_Y": 0.27936714887619,
    "CMYK_C": 0.50346285104752,
    "CMYK_M": 0.1294566988945,
    "CMYK_Y": 0,
    "CMYK_K": 0.27936714887619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09318",
    "Farbtonhilfsbezeichnung": "S1.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "222",
    "Bcolor": "227",
    "Y": 71.2245178222656,
    "L": 87.5939712524414,
    "a": -2.85323190689087,
    "b": -5.16709518432617,
    "C": 5.90252542495728,
    "h": 241.092834472656,
    "CMY_C": 0.18091183900833,
    "CMY_M": 0.13031184673309,
    "CMY_Y": 0.10804396867752,
    "CMYK_C": 0.08169446140528,
    "CMYK_M": 0.02496521919966,
    "CMYK_Y": 0,
    "CMYK_K": 0.10804396867752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09319",
    "Farbtonhilfsbezeichnung": "S2.11.63",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "176",
    "Bcolor": "189",
    "Y": 41.5106086730957,
    "L": 70.5321884155273,
    "a": -4.92446708679199,
    "b": -9.77833271026611,
    "C": 10.9483404159546,
    "h": 243.269714355469,
    "CMY_C": 0.39982098340988,
    "CMY_M": 0.30948561429977,
    "CMY_Y": 0.2607234120369,
    "CMYK_C": 0.18815362453461,
    "CMYK_M": 0.06595934927464,
    "CMYK_Y": 0,
    "CMYK_K": 0.2607234120369
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09320",
    "Farbtonhilfsbezeichnung": "S2.14.54",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "153",
    "Bcolor": "168",
    "Y": 30.2269134521484,
    "L": 61.8495140075684,
    "a": -5.4270224571228,
    "b": -11.3912878036499,
    "C": 12.6180038452148,
    "h": 244.526000976562,
    "CMY_C": 0.50087159872055,
    "CMY_M": 0.39895510673523,
    "CMY_Y": 0.34140032529831,
    "CMYK_C": 0.24213688075542,
    "CMYK_M": 0.08738962560892,
    "CMYK_Y": 0,
    "CMYK_K": 0.34140032529831
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09321",
    "Farbtonhilfsbezeichnung": "S2.17.39",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "118",
    "Bcolor": "133",
    "Y": 17.05126953125,
    "L": 48.3245697021484,
    "a": -5.18253040313721,
    "b": -11.502347946167,
    "C": 12.615966796875,
    "h": 245.74543762207,
    "CMY_C": 0.63397419452667,
    "CMY_M": 0.536212682724,
    "CMY_Y": 0.47925066947937,
    "CMYK_C": 0.29711708426476,
    "CMYK_M": 0.10938470810652,
    "CMYK_Y": 0,
    "CMYK_K": 0.47925066947937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09322",
    "Farbtonhilfsbezeichnung": "S2.18.28",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "95",
    "Bcolor": "107",
    "Y": 10.8299427032471,
    "L": 39.2925605773926,
    "a": -4.55494832992554,
    "b": -9.33794498443604,
    "C": 10.3896474838257,
    "h": 243.997375488281,
    "CMY_C": 0.70485156774521,
    "CMY_M": 0.62557977437973,
    "CMY_Y": 0.58193218708038,
    "CMYK_C": 0.29401779174805,
    "CMYK_M": 0.10440313071012,
    "CMYK_Y": 0,
    "CMYK_K": 0.58193218708038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09323",
    "Farbtonhilfsbezeichnung": "S1.07.81",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "223",
    "Bcolor": "232",
    "Y": 71.5545883178711,
    "L": 87.7537536621094,
    "a": -4.3581485748291,
    "b": -7.54098796844482,
    "C": 8.70976257324219,
    "h": 239.975173950195,
    "CMY_C": 0.2013298869133,
    "CMY_M": 0.12439423799515,
    "CMY_Y": 0.08901697397232,
    "CMYK_C": 0.12328760325909,
    "CMYK_M": 0.03883416205645,
    "CMYK_Y": 0,
    "CMYK_K": 0.08901697397232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09324",
    "Farbtonhilfsbezeichnung": "S1.10.80",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "220",
    "Bcolor": "232",
    "Y": 69.0074768066406,
    "L": 86.5077514648438,
    "a": -5.3979868888855,
    "b": -9.25497817993164,
    "C": 10.7141437530518,
    "h": 239.747039794922,
    "CMY_C": 0.23114395141602,
    "CMY_M": 0.13533663749695,
    "CMY_Y": 0.0904004573822,
    "CMYK_C": 0.15473127365112,
    "CMYK_M": 0.04940215870738,
    "CMYK_Y": 0,
    "CMYK_K": 0.0904004573822
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09325",
    "Farbtonhilfsbezeichnung": "S1.12.72",
    "Farbtonklasse": "02",
    "Rcolor": "172",
    "Gcolor": "201",
    "Bcolor": "216",
    "Y": 55.3112144470215,
    "L": 79.2201919555664,
    "a": -5.90346479415894,
    "b": -11.478723526001,
    "C": 12.907826423645,
    "h": 242.783401489258,
    "CMY_C": 0.32409054040909,
    "CMY_M": 0.21349620819092,
    "CMY_Y": 0.15469914674759,
    "CMYK_C": 0.20039184391499,
    "CMYK_M": 0.06955755501986,
    "CMYK_Y": 0,
    "CMYK_K": 0.15469914674759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09326",
    "Farbtonhilfsbezeichnung": "S1.20.60",
    "Farbtonklasse": "02",
    "Rcolor": "126",
    "Gcolor": "169",
    "Bcolor": "192",
    "Y": 36.5636749267578,
    "L": 66.9483871459961,
    "a": -8.54037380218506,
    "b": -17.1033210754395,
    "C": 19.1170501708984,
    "h": 243.465209960938,
    "CMY_C": 0.50634771585464,
    "CMY_M": 0.33757644891739,
    "CMY_Y": 0.24817806482315,
    "CMYK_C": 0.34339201450348,
    "CMYK_M": 0.11890898644924,
    "CMYK_Y": 0,
    "CMYK_K": 0.24817806482315
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09327",
    "Farbtonhilfsbezeichnung": "S1.33.42",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "128",
    "Bcolor": "156",
    "Y": 19.060001373291,
    "L": 50.7573318481445,
    "a": -11.4958744049072,
    "b": -21.5588626861572,
    "C": 24.4323501586914,
    "h": 241.932037353516,
    "CMY_C": 0.74108600616455,
    "CMY_M": 0.49702781438828,
    "CMY_Y": 0.38873499631882,
    "CMYK_C": 0.57642924785614,
    "CMYK_M": 0.17716181278229,
    "CMYK_Y": 0,
    "CMYK_K": 0.38873499631882
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09328",
    "Farbtonhilfsbezeichnung": "S0.47.28",
    "Farbtonklasse": "03",
    "Rcolor": "20",
    "Gcolor": "100",
    "Bcolor": "129",
    "Y": 10.823618888855,
    "L": 39.281795501709,
    "a": -12.0724048614502,
    "b": -23.0709438323975,
    "C": 26.0386524200439,
    "h": 242.378143310547,
    "CMY_C": 0.92008888721466,
    "CMY_M": 0.60819590091705,
    "CMY_Y": 0.4957070350647,
    "CMYK_C": 0.84153831005096,
    "CMYK_M": 0.22306253015995,
    "CMYK_Y": 0,
    "CMYK_K": 0.4957070350647
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09329",
    "Farbtonhilfsbezeichnung": "R6.51.23",
    "Farbtonklasse": "04",
    "Rcolor": "16",
    "Gcolor": "89",
    "Bcolor": "113",
    "Y": 8.46904277801514,
    "L": 34.9412307739258,
    "a": -11.9797945022583,
    "b": -20.2895793914795,
    "C": 23.5623111724854,
    "h": 239.440673828125,
    "CMY_C": 0.93720704317093,
    "CMY_M": 0.65055537223816,
    "CMY_Y": 0.55615997314453,
    "CMYK_C": 0.85852342844009,
    "CMYK_M": 0.21267887949944,
    "CMYK_Y": 0,
    "CMYK_K": 0.55615997314453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09330",
    "Farbtonhilfsbezeichnung": "S1.16.68",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "190",
    "Bcolor": "209",
    "Y": 48.0417022705078,
    "L": 74.8512268066406,
    "a": -7.35284805297852,
    "b": -14.5482501983643,
    "C": 16.3007965087891,
    "h": 243.187454223633,
    "CMY_C": 0.39836478233337,
    "CMY_M": 0.25668692588806,
    "CMY_Y": 0.18061047792435,
    "CMYK_C": 0.2657518684864,
    "CMYK_M": 0.09284527599812,
    "CMYK_Y": 0,
    "CMYK_K": 0.18061047792435
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09331",
    "Farbtonhilfsbezeichnung": "S1.26.51",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "149",
    "Bcolor": "175",
    "Y": 27.3586502075195,
    "L": 59.3048439025879,
    "a": -9.53365230560303,
    "b": -19.6381130218506,
    "C": 21.8299331665039,
    "h": 244.104965209961,
    "CMY_C": 0.61177408695221,
    "CMY_M": 0.41443121433258,
    "CMY_Y": 0.31215238571167,
    "CMYK_C": 0.43559312820435,
    "CMYK_M": 0.14869402348995,
    "CMYK_Y": 0,
    "CMYK_K": 0.31215238571167
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09332",
    "Farbtonhilfsbezeichnung": "S1.41.44",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "133",
    "Bcolor": "168",
    "Y": 20.1038494110107,
    "L": 51.9544219970703,
    "a": -13.8442230224609,
    "b": -26.6302490234375,
    "C": 30.0138740539551,
    "h": 242.531509399414,
    "CMY_C": 0.82331472635269,
    "CMY_M": 0.47904938459396,
    "CMY_Y": 0.3426108956337,
    "CMYK_C": 0.73123180866241,
    "CMYK_M": 0.20754601061344,
    "CMYK_Y": 0,
    "CMYK_K": 0.3426108956337
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09333",
    "Farbtonhilfsbezeichnung": "S0.52.35",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "115",
    "Bcolor": "152",
    "Y": 14.2164316177368,
    "L": 44.5417327880859,
    "a": -15.592565536499,
    "b": -29.3049297332764,
    "C": 33.1949844360352,
    "h": 241.983459472656,
    "CMY_C": 1,
    "CMY_M": 0.54905098676682,
    "CMY_Y": 0.40220165252686,
    "CMYK_C": 1,
    "CMYK_M": 0.24565029144287,
    "CMYK_Y": 0,
    "CMYK_K": 0.40220165252686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09334",
    "Farbtonhilfsbezeichnung": "R6.06.83",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "229",
    "Bcolor": "233",
    "Y": 75.7062149047852,
    "L": 89.7227630615234,
    "a": -4.74152803421021,
    "b": -5.20661544799805,
    "C": 7.04208278656006,
    "h": 227.676696777344,
    "CMY_C": 0.17352819442749,
    "CMY_M": 0.10232949256897,
    "CMY_Y": 0.08438372612,
    "CMYK_C": 0.09736007452011,
    "CMYK_M": 0.0195996593684,
    "CMYK_Y": 0,
    "CMYK_K": 0.08438372612
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09335",
    "Farbtonhilfsbezeichnung": "R4.14.79",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "222",
    "Bcolor": "236",
    "Y": 68.0116424560547,
    "L": 86.0122680664063,
    "a": -10.1738042831421,
    "b": -12.2062997817993,
    "C": 15.8902502059937,
    "h": 230.189193725586,
    "CMY_C": 0.29341900348663,
    "CMY_M": 0.12944233417511,
    "CMY_Y": 0.07483327388763,
    "CMYK_C": 0.23626631498337,
    "CMYK_M": 0.05902618169785,
    "CMYK_Y": 0,
    "CMYK_K": 0.07483327388763
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09336",
    "Farbtonhilfsbezeichnung": "R8.25.70",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "200",
    "Bcolor": "227",
    "Y": 51.8186264038086,
    "L": 77.1722564697266,
    "a": -14.0727033615112,
    "b": -20.9914016723633,
    "C": 25.2721176147461,
    "h": 236.161972045898,
    "CMY_C": 0.47978490591049,
    "CMY_M": 0.21563881635666,
    "CMY_Y": 0.10966390371323,
    "CMYK_C": 0.4157093167305,
    "CMYK_M": 0.11902798712254,
    "CMYK_Y": 0,
    "CMYK_K": 0.10966390371323
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09337",
    "Farbtonhilfsbezeichnung": "S7.51.34",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "111",
    "Bcolor": "156",
    "Y": 13.5902690887451,
    "L": 43.6395034790039,
    "a": -10.9258718490601,
    "b": -33.1083488464355,
    "C": 34.864559173584,
    "h": 251.736923217773,
    "CMY_C": 1,
    "CMY_M": 0.564248919487,
    "CMY_Y": 0.38636338710785,
    "CMYK_C": 1,
    "CMYK_M": 0.28988742828369,
    "CMYK_Y": 0,
    "CMYK_K": 0.38636338710785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09338",
    "Farbtonhilfsbezeichnung": "R8.23.72",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "206",
    "Bcolor": "233",
    "Y": 55.5878105163574,
    "L": 79.3786468505859,
    "a": -13.2222881317139,
    "b": -20.7034149169922,
    "C": 24.5654296875,
    "h": 237.435562133789,
    "CMY_C": 0.44417691230774,
    "CMY_M": 0.19338172674179,
    "CMY_Y": 0.08716034889221,
    "CMYK_C": 0.39110544323921,
    "CMYK_M": 0.11636367440224,
    "CMYK_Y": 0,
    "CMYK_K": 0.08716034889221
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09339",
    "Farbtonhilfsbezeichnung": "R9.34.64",
    "Farbtonklasse": "02",
    "Rcolor": "90",
    "Gcolor": "184",
    "Bcolor": "223",
    "Y": 41.9097900390625,
    "L": 70.8086776733398,
    "a": -16.4405193328857,
    "b": -28.4456043243408,
    "C": 32.8548774719238,
    "h": 239.973663330078,
    "CMY_C": 0.64558792114258,
    "CMY_M": 0.27719354629517,
    "CMY_Y": 0.12702757120132,
    "CMYK_C": 0.59401684999466,
    "CMYK_M": 0.17201685905457,
    "CMYK_Y": 0,
    "CMYK_K": 0.12702757120132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09340",
    "Farbtonhilfsbezeichnung": "S2.43.55",
    "Farbtonklasse": "03",
    "Rcolor": "33",
    "Gcolor": "164",
    "Bcolor": "209",
    "Y": 31.3197917938232,
    "L": 62.7766723632813,
    "a": -17.4061660766602,
    "b": -33.570011138916,
    "C": 37.8142852783203,
    "h": 242.593109130859,
    "CMY_C": 0.87036418914795,
    "CMY_M": 0.35873103141785,
    "CMY_Y": 0.17940425872803,
    "CMYK_C": 0.84202229976654,
    "CMYK_M": 0.21853241324425,
    "CMYK_Y": 0,
    "CMYK_K": 0.17940425872803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09341",
    "Farbtonhilfsbezeichnung": "S5.52.45",
    "Farbtonklasse": "03",
    "Rcolor": "0",
    "Gcolor": "136",
    "Bcolor": "188",
    "Y": 20.6652011871338,
    "L": 52.5811157226563,
    "a": -14.6182165145874,
    "b": -37.7577209472656,
    "C": 40.4887351989746,
    "h": 248.835678100586,
    "CMY_C": 1,
    "CMY_M": 0.4671373963356,
    "CMY_Y": 0.26105469465256,
    "CMYK_C": 1,
    "CMYK_M": 0.27888762950897,
    "CMYK_Y": 0,
    "CMYK_K": 0.26105469465256
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09342",
    "Farbtonhilfsbezeichnung": "S1.09.81",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "224",
    "Bcolor": "234",
    "Y": 71.6423721313477,
    "L": 87.7961654663086,
    "a": -4.49219369888306,
    "b": -8.22941970825195,
    "C": 9.3756685256958,
    "h": 241.371200561523,
    "CMY_C": 0.20487362146378,
    "CMY_M": 0.12341010570526,
    "CMY_Y": 0.08350050449371,
    "CMYK_C": 0.13243119418621,
    "CMYK_M": 0.04354568943381,
    "CMYK_Y": 0,
    "CMYK_K": 0.08350050449371
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09343",
    "Farbtonhilfsbezeichnung": "S9.50.30",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "103",
    "Bcolor": "149",
    "Y": 11.7335510253906,
    "L": 40.7894706726074,
    "a": -8.57351398468018,
    "b": -32.8933296203613,
    "C": 33.9922981262207,
    "h": 255.391128540039,
    "CMY_C": 1,
    "CMY_M": 0.59597992897034,
    "CMY_Y": 0.41710674762726,
    "CMYK_C": 1,
    "CMYK_M": 0.30687126517296,
    "CMYK_Y": 0,
    "CMYK_K": 0.41710674762726
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09344",
    "Farbtonhilfsbezeichnung": "S2.08.79",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "216",
    "Bcolor": "228",
    "Y": 65.9806671142578,
    "L": 84.9865570068359,
    "a": -4.54069471359253,
    "b": -9.29543209075928,
    "C": 10.3451900482178,
    "h": 243.965118408203,
    "CMY_C": 0.24042242765427,
    "CMY_M": 0.15404742956161,
    "CMY_Y": 0.10686838626862,
    "CMYK_C": 0.14953455328941,
    "CMYK_M": 0.05282428860664,
    "CMYK_Y": 0,
    "CMYK_K": 0.10686838626862
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09345",
    "Farbtonhilfsbezeichnung": "S4.14.76",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "211",
    "Bcolor": "230",
    "Y": 61.6564102172852,
    "L": 82.7303619384766,
    "a": -6.96195888519287,
    "b": -14.0908994674683,
    "C": 15.7169437408447,
    "h": 243.707183837891,
    "CMY_C": 0.30822956562042,
    "CMY_M": 0.17201006412506,
    "CMY_Y": 0.09720551967621,
    "CMYK_C": 0.23374538123608,
    "CMYK_M": 0.08285888284445,
    "CMYK_Y": 0,
    "CMYK_K": 0.09720551967621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09346",
    "Farbtonhilfsbezeichnung": "S6.18.73",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "202",
    "Bcolor": "227",
    "Y": 55.1605834960938,
    "L": 79.133674621582,
    "a": -7.53712224960327,
    "b": -17.944314956665,
    "C": 19.4629554748535,
    "h": 247.216201782227,
    "CMY_C": 0.3720543384552,
    "CMY_M": 0.20883828401566,
    "CMY_Y": 0.10922729969025,
    "CMYK_C": 0.2950551211834,
    "CMYK_M": 0.11182536929846,
    "CMYK_Y": 0,
    "CMYK_K": 0.10922729969025
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09347",
    "Farbtonhilfsbezeichnung": "S7.42.25",
    "Farbtonklasse": "04",
    "Rcolor": "33",
    "Gcolor": "90",
    "Bcolor": "121",
    "Y": 9.0858039855957,
    "L": 36.1489753723145,
    "a": -7.43852615356445,
    "b": -23.4863319396973,
    "C": 24.6361408233643,
    "h": 252.42610168457,
    "CMY_C": 0.87082594633102,
    "CMY_M": 0.64563632011414,
    "CMY_Y": 0.5239474773407,
    "CMYK_C": 0.72865587472916,
    "CMYK_M": 0.25562062859535,
    "CMYK_Y": 0,
    "CMYK_K": 0.5239474773407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09348",
    "Farbtonhilfsbezeichnung": "S6.30.20",
    "Farbtonklasse": "04",
    "Rcolor": "52",
    "Gcolor": "79",
    "Bcolor": "97",
    "Y": 7.14527082443237,
    "L": 32.1353607177734,
    "a": -4.53412389755249,
    "b": -14.3314199447632,
    "C": 15.0315628051758,
    "h": 252.443862915039,
    "CMY_C": 0.7972514629364,
    "CMY_M": 0.69107842445374,
    "CMY_Y": 0.6194406747818,
    "CMYK_C": 0.46723538637161,
    "CMYK_M": 0.18824331462383,
    "CMYK_Y": 0,
    "CMYK_K": 0.6194406747818
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09349",
    "Farbtonhilfsbezeichnung": "S8.23.53",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "152",
    "Bcolor": "181",
    "Y": 29.3507995605469,
    "L": 61.0899887084961,
    "a": -6.40637445449829,
    "b": -19.8691234588623,
    "C": 20.8763904571533,
    "h": 252.129196166992,
    "CMY_C": 0.56217157840729,
    "CMY_M": 0.40211194753647,
    "CMY_Y": 0.29137682914734,
    "CMYK_C": 0.38214209675789,
    "CMYK_M": 0.15626798570156,
    "CMYK_Y": 0,
    "CMYK_K": 0.29137682914734
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09350",
    "Farbtonhilfsbezeichnung": "S7.27.25",
    "Farbtonklasse": "03",
    "Rcolor": "59",
    "Gcolor": "88",
    "Bcolor": "108",
    "Y": 9.0568675994873,
    "L": 36.0935554504395,
    "a": -4.81095027923584,
    "b": -15.2656888961792,
    "C": 16.0058269500732,
    "h": 252.507858276367,
    "CMY_C": 0.7680715918541,
    "CMY_M": 0.65354514122009,
    "CMY_Y": 0.57573342323303,
    "CMYK_C": 0.45334273576736,
    "CMYK_M": 0.18340289592743,
    "CMYK_Y": 0,
    "CMYK_K": 0.57573342323303
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09351",
    "Farbtonhilfsbezeichnung": "T4.20.39",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "117",
    "Bcolor": "140",
    "Y": 16.9447059631348,
    "L": 48.1902885437012,
    "a": -2.37937188148499,
    "b": -16.207010269165,
    "C": 16.3807392120361,
    "h": 261.647979736328,
    "CMY_C": 0.63407707214355,
    "CMY_M": 0.54159319400787,
    "CMY_Y": 0.44955307245255,
    "CMYK_C": 0.33522579073906,
    "CMYK_M": 0.16720980405807,
    "CMYK_Y": 0,
    "CMYK_K": 0.44955307245255
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09352",
    "Farbtonhilfsbezeichnung": "T5.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "208",
    "Bcolor": "219",
    "Y": 62.2563972473145,
    "L": 83.0495834350586,
    "a": -1.44317102432251,
    "b": -7.54351902008057,
    "C": 7.68032693862915,
    "h": 259.169464111328,
    "CMY_C": 0.22812056541443,
    "CMY_M": 0.18288397789001,
    "CMY_Y": 0.14061403274536,
    "CMYK_C": 0.10182448476553,
    "CMYK_M": 0.04918621852994,
    "CMYK_Y": 0,
    "CMYK_K": 0.14061403274536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09353",
    "Farbtonhilfsbezeichnung": "T5.10.71",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "195",
    "Bcolor": "214",
    "Y": 53.1117858886719,
    "L": 77.9409484863281,
    "a": -1.48805046081543,
    "b": -12.2531023025513,
    "C": 12.3431282043457,
    "h": 263.075744628906,
    "CMY_C": 0.30293399095535,
    "CMY_M": 0.23689591884613,
    "CMY_Y": 0.16263455152512,
    "CMYK_C": 0.16754864156246,
    "CMYK_M": 0.08868453651667,
    "CMYK_Y": 0,
    "CMYK_K": 0.16263455152512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09354",
    "Farbtonhilfsbezeichnung": "T4.16.56",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "157",
    "Bcolor": "182",
    "Y": 32.4447288513184,
    "L": 63.7087593078613,
    "a": -2.58627820014954,
    "b": -16.7921485900879,
    "C": 16.9901466369629,
    "h": 261.244262695313,
    "CMY_C": 0.48264509439468,
    "CMY_M": 0.38390946388245,
    "CMY_Y": 0.2843514084816,
    "CMYK_C": 0.27708247303963,
    "CMYK_M": 0.13911584019661,
    "CMYK_Y": 0,
    "CMYK_K": 0.2843514084816
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09355",
    "Farbtonhilfsbezeichnung": "T3.32.21",
    "Farbtonklasse": "03",
    "Rcolor": "53",
    "Gcolor": "82",
    "Bcolor": "108",
    "Y": 7.8900351524353,
    "L": 33.7528114318848,
    "a": -2.88041353225708,
    "b": -18.5728340148926,
    "C": 18.794864654541,
    "h": 261.184387207031,
    "CMY_C": 0.79247957468033,
    "CMY_M": 0.67777633666992,
    "CMY_Y": 0.57772791385651,
    "CMYK_C": 0.50856226682663,
    "CMYK_M": 0.23692880570889,
    "CMYK_Y": 0,
    "CMYK_K": 0.57772791385651
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09356",
    "Farbtonhilfsbezeichnung": "T4.05.83",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "226",
    "Bcolor": "235",
    "Y": 75.3974075317383,
    "L": 89.5788192749023,
    "a": -0.82009947299957,
    "b": -6.06159591674805,
    "C": 6.11682176589966,
    "h": 262.294982910156,
    "CMY_C": 0.14569979906082,
    "CMY_M": 0.11272472143173,
    "CMY_Y": 0.07917255163193,
    "CMYK_C": 0.07224724441767,
    "CMYK_M": 0.03643697872758,
    "CMYK_Y": 0,
    "CMYK_K": 0.07917255163193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09357",
    "Farbtonhilfsbezeichnung": "T4.08.76",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "210",
    "Bcolor": "224",
    "Y": 63.0821304321289,
    "L": 83.4855728149414,
    "a": -1.53735148906708,
    "b": -9.52983570098877,
    "C": 9.65304183959961,
    "h": 260.835998535156,
    "CMY_C": 0.23215246200562,
    "CMY_M": 0.17727965116501,
    "CMY_Y": 0.12138772010803,
    "CMYK_C": 0.12606783211231,
    "CMYK_M": 0.0636138767004,
    "CMYK_Y": 0,
    "CMYK_K": 0.12138772010803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09358",
    "Farbtonhilfsbezeichnung": "T4.16.66",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "183",
    "Bcolor": "211",
    "Y": 45.8281860351563,
    "L": 73.4339065551758,
    "a": -2.79466533660889,
    "b": -17.6995754241943,
    "C": 17.9188480377197,
    "h": 261.027404785156,
    "CMY_C": 0.38736844062805,
    "CMY_M": 0.28066384792328,
    "CMY_Y": 0.17317414283752,
    "CMYK_C": 0.25905612111092,
    "CMYK_M": 0.13000284135342,
    "CMYK_Y": 0,
    "CMYK_K": 0.17317414283752
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09359",
    "Farbtonhilfsbezeichnung": "T3.25.51",
    "Farbtonklasse": "02",
    "Rcolor": "106",
    "Gcolor": "145",
    "Bcolor": "180",
    "Y": 26.5659294128418,
    "L": 58.5703773498535,
    "a": -3.94300174713135,
    "b": -23.2930870056152,
    "C": 23.6244602203369,
    "h": 260.392181396484,
    "CMY_C": 0.58454716205597,
    "CMY_M": 0.43183052539825,
    "CMY_Y": 0.29449665546417,
    "CMYK_C": 0.4111256301403,
    "CMYK_M": 0.19466082751751,
    "CMYK_Y": 0,
    "CMYK_K": 0.29449665546417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09360",
    "Farbtonhilfsbezeichnung": "T3.32.34",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "108",
    "Bcolor": "143",
    "Y": 13.8367443084717,
    "L": 43.9978904724121,
    "a": -3.65476632118225,
    "b": -24.1028709411621,
    "C": 24.3783855438232,
    "h": 261.377807617188,
    "CMY_C": 0.73782229423523,
    "CMY_M": 0.5773411989212,
    "CMY_Y": 0.44082480669022,
    "CMYK_C": 0.53113496303558,
    "CMYK_M": 0.24413885176182,
    "CMYK_Y": 0,
    "CMYK_K": 0.44082480669022
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09361",
    "Farbtonhilfsbezeichnung": "T3.37.22",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "84",
    "Bcolor": "115",
    "Y": 8.04468727111816,
    "L": 34.0757789611816,
    "a": -3.361492395401,
    "b": -22.6509075164795,
    "C": 22.8989791870117,
    "h": 261.558654785156,
    "CMY_C": 0.82606607675552,
    "CMY_M": 0.67248791456223,
    "CMY_Y": 0.54933196306229,
    "CMYK_C": 0.61405313014984,
    "CMYK_M": 0.27327421307564,
    "CMYK_Y": 0,
    "CMYK_K": 0.54933196306229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09362",
    "Farbtonhilfsbezeichnung": "T4.20.66",
    "Farbtonklasse": "02",
    "Rcolor": "147",
    "Gcolor": "183",
    "Bcolor": "218",
    "Y": 45.0014305114746,
    "L": 72.8928375244141,
    "a": -3.45088982582092,
    "b": -22.4527473449707,
    "C": 22.7163925170898,
    "h": 261.262268066406,
    "CMY_C": 0.42420583963394,
    "CMY_M": 0.28338617086411,
    "CMY_Y": 0.14541178941727,
    "CMYK_C": 0.3262320458889,
    "CMYK_M": 0.16145130991936,
    "CMYK_Y": 0,
    "CMYK_K": 0.14541178941727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09363",
    "Farbtonhilfsbezeichnung": "T4.23.56",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "159",
    "Bcolor": "196",
    "Y": 32.6693801879883,
    "L": 63.8922996520996,
    "a": -3.43557810783386,
    "b": -23.8993625640869,
    "C": 24.1450347900391,
    "h": 261.819671630859,
    "CMY_C": 0.52763468027115,
    "CMY_M": 0.37777441740036,
    "CMY_Y": 0.23330914974213,
    "CMYK_C": 0.38389074802399,
    "CMYK_M": 0.18842701613903,
    "CMYK_Y": 0,
    "CMYK_K": 0.23330914974213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09364",
    "Farbtonhilfsbezeichnung": "T3.33.46",
    "Farbtonklasse": "03",
    "Rcolor": "81",
    "Gcolor": "134",
    "Bcolor": "178",
    "Y": 22.1110401153564,
    "L": 54.1446266174316,
    "a": -4.67474555969238,
    "b": -29.2615261077881,
    "C": 29.6325855255127,
    "h": 260.923278808594,
    "CMY_C": 0.6832360625267,
    "CMY_M": 0.47310882806778,
    "CMY_Y": 0.30108052492142,
    "CMYK_C": 0.54678046703339,
    "CMYK_M": 0.24613465368748,
    "CMYK_Y": 0,
    "CMYK_K": 0.30108052492142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09365",
    "Farbtonhilfsbezeichnung": "T7.48.24",
    "Farbtonklasse": "04",
    "Rcolor": "16",
    "Gcolor": "88",
    "Bcolor": "135",
    "Y": 8.88893127441406,
    "L": 35.7695617675781,
    "a": -2.6202540397644,
    "b": -32.8025436401367,
    "C": 32.9070281982422,
    "h": 265.432922363281,
    "CMY_C": 0.93577408790588,
    "CMY_M": 0.65411484241486,
    "CMY_Y": 0.46864092350006,
    "CMYK_C": 0.87912899255753,
    "CMYK_M": 0.34905570745468,
    "CMYK_Y": 0,
    "CMYK_K": 0.46864092350006
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09366",
    "Farbtonhilfsbezeichnung": "T9.38.22",
    "Farbtonklasse": "04",
    "Rcolor": "45",
    "Gcolor": "82",
    "Bcolor": "120",
    "Y": 8.03107357025146,
    "L": 34.0475158691406,
    "a": -0.54979306459427,
    "b": -26.0736865997314,
    "C": 26.0794830322266,
    "h": 268.792022705078,
    "CMY_C": 0.82242739200592,
    "CMY_M": 0.67666161060333,
    "CMY_Y": 0.52809679508209,
    "CMYK_C": 0.6237096786499,
    "CMYK_M": 0.3148205280304,
    "CMYK_Y": 0,
    "CMYK_K": 0.52809679508209
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09367",
    "Farbtonhilfsbezeichnung": "T2.49.28",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "97",
    "Bcolor": "145",
    "Y": 10.5705299377441,
    "L": 38.8475074768066,
    "a": -5.51967287063599,
    "b": -33.9722633361816,
    "C": 34.4177474975586,
    "h": 260.771453857422,
    "CMY_C": 1,
    "CMY_M": 0.61944770812988,
    "CMY_Y": 0.42993384599686,
    "CMYK_C": 1,
    "CMYK_M": 0.33244186639786,
    "CMYK_Y": 0,
    "CMYK_K": 0.42993384599686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09368",
    "Farbtonhilfsbezeichnung": "T2.42.23",
    "Farbtonklasse": "04",
    "Rcolor": "34",
    "Gcolor": "85",
    "Bcolor": "122",
    "Y": 8.26360416412354,
    "L": 34.525951385498,
    "a": -3.91361808776855,
    "b": -26.2641334533691,
    "C": 26.5541172027588,
    "h": 261.524719238281,
    "CMY_C": 0.8668669462204,
    "CMY_M": 0.66597682237625,
    "CMY_Y": 0.52238708734512,
    "CMYK_C": 0.72125321626663,
    "CMYK_M": 0.3006404042244,
    "CMYK_Y": 0,
    "CMYK_K": 0.52238708734512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09369",
    "Farbtonhilfsbezeichnung": "S3.08.80",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "219",
    "Bcolor": "229",
    "Y": 68.8652954101563,
    "L": 86.4373016357422,
    "a": -3.78374981880188,
    "b": -7.91340208053589,
    "C": 8.77147006988525,
    "h": 244.445465087891,
    "CMY_C": 0.21235173940659,
    "CMY_M": 0.14016270637512,
    "CMY_Y": 0.10081934928894,
    "CMYK_C": 0.12403780221939,
    "CMYK_M": 0.04375467449427,
    "CMYK_Y": 0,
    "CMYK_K": 0.10081934928894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09370",
    "Farbtonhilfsbezeichnung": "S5.12.76",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "211",
    "Bcolor": "227",
    "Y": 62.1146125793457,
    "L": 82.9743347167969,
    "a": -5.21942901611328,
    "b": -11.9589920043945,
    "C": 13.0483684539795,
    "h": 246.421432495117,
    "CMY_C": 0.27985417842865,
    "CMY_M": 0.17383617162704,
    "CMY_Y": 0.10980659723282,
    "CMYK_C": 0.19102318584919,
    "CMYK_M": 0.07192771136761,
    "CMYK_Y": 0,
    "CMYK_K": 0.10980659723282
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09371",
    "Farbtonhilfsbezeichnung": "SN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "235",
    "Bcolor": "235",
    "Y": 82.9407272338867,
    "L": 92.9884796142578,
    "a": -0.6164373755455,
    "b": -0.99903386831284,
    "C": 1.17390954494476,
    "h": 238.324020385742,
    "CMY_C": 0.08745628595352,
    "CMY_M": 0.07665014266968,
    "CMY_Y": 0.07869577407837,
    "CMYK_C": 0.01170319505036,
    "CMYK_M": 0,
    "CMYK_Y": 0.00221544574015,
    "CMYK_K": 0.07665014266968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09372",
    "Farbtonhilfsbezeichnung": "U1.43.21",
    "Farbtonklasse": "04",
    "Rcolor": "35",
    "Gcolor": "83",
    "Bcolor": "132",
    "Y": 8.14204406738281,
    "L": 34.2769775390625,
    "a": 1.95521330833435,
    "b": -33.1305656433105,
    "C": 33.1882095336914,
    "h": 273.377410888672,
    "CMY_C": 0.86276805400848,
    "CMY_M": 0.67641317844391,
    "CMY_Y": 0.48139798641205,
    "CMYK_C": 0.73538100719452,
    "CMYK_M": 0.37604016065598,
    "CMYK_Y": 0,
    "CMYK_K": 0.48139798641205
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09373",
    "Farbtonhilfsbezeichnung": "T6.07.79",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "217",
    "Bcolor": "231",
    "Y": 68.3171615600586,
    "L": 86.164794921875,
    "a": -1.06458365917206,
    "b": -9.03229999542236,
    "C": 9.09482192993164,
    "h": 263.277893066406,
    "CMY_C": 0.19696646928787,
    "CMY_M": 0.1490570306778,
    "CMY_Y": 0.09531253576279,
    "CMYK_C": 0.1123635917902,
    "CMYK_M": 0.05940669775009,
    "CMYK_Y": 0,
    "CMYK_K": 0.09531253576279
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09374",
    "Farbtonhilfsbezeichnung": "T3.10.76",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "209",
    "Bcolor": "228",
    "Y": 62.3538970947266,
    "L": 83.1012649536133,
    "a": -2.32503294944763,
    "b": -12.2118158340454,
    "C": 12.4311790466309,
    "h": 259.220367431641,
    "CMY_C": 0.25432741641998,
    "CMY_M": 0.17885154485703,
    "CMY_Y": 0.10622763633728,
    "CMYK_C": 0.16570189595222,
    "CMYK_M": 0.08125548809767,
    "CMYK_Y": 0,
    "CMYK_K": 0.10622763633728
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09375",
    "Farbtonhilfsbezeichnung": "U2.45.31",
    "Farbtonklasse": "04",
    "Rcolor": "44",
    "Gcolor": "101",
    "Bcolor": "160",
    "Y": 12.4727487564087,
    "L": 41.957820892334,
    "a": 1.90511381626129,
    "b": -37.8059501647949,
    "C": 37.8539199829102,
    "h": 272.884796142578,
    "CMY_C": 0.82597386837006,
    "CMY_M": 0.6022607088089,
    "CMY_Y": 0.37238603830338,
    "CMYK_C": 0.7227178812027,
    "CMYK_M": 0.36626762151718,
    "CMYK_Y": 0,
    "CMYK_K": 0.37238603830338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09376",
    "Farbtonhilfsbezeichnung": "T9.13.72",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "198",
    "Bcolor": "224",
    "Y": 55.275821685791,
    "L": 79.1998748779297,
    "a": -0.91662758588791,
    "b": -16.0900287628174,
    "C": 16.116117477417,
    "h": 266.739471435547,
    "CMY_C": 0.30157124996185,
    "CMY_M": 0.22330993413925,
    "CMY_Y": 0.12114816904068,
    "CMYK_C": 0.20529408752918,
    "CMYK_M": 0.11624458432198,
    "CMYK_Y": 0,
    "CMYK_K": 0.12114816904068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09377",
    "Farbtonhilfsbezeichnung": "T9.17.61",
    "Farbtonklasse": "02",
    "Rcolor": "143",
    "Gcolor": "167",
    "Bcolor": "198",
    "Y": 37.5440444946289,
    "L": 67.6832122802734,
    "a": -0.7666267156601,
    "b": -19.5522480010986,
    "C": 19.5672721862793,
    "h": 267.754638671875,
    "CMY_C": 0.43895226716995,
    "CMY_M": 0.34539926052094,
    "CMY_Y": 0.22238808870316,
    "CMYK_C": 0.27849903702736,
    "CMYK_M": 0.1581909507513,
    "CMYK_Y": 0,
    "CMYK_K": 0.22238808870316
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09378",
    "Farbtonhilfsbezeichnung": "U0.23.51",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "144",
    "Bcolor": "181",
    "Y": 26.9132442474365,
    "L": 58.8939361572266,
    "a": -0.0821498632431,
    "b": -23.5782337188721,
    "C": 23.5783767700195,
    "h": 269.800384521484,
    "CMY_C": 0.54539024829865,
    "CMY_M": 0.4364772439003,
    "CMY_Y": 0.28876513242722,
    "CMYK_C": 0.36081627011299,
    "CMYK_M": 0.20768401026726,
    "CMYK_Y": 0,
    "CMYK_K": 0.28876513242722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09379",
    "Farbtonhilfsbezeichnung": "U0.30.41",
    "Farbtonklasse": "03",
    "Rcolor": "84",
    "Gcolor": "120",
    "Bcolor": "163",
    "Y": 17.9399318695068,
    "L": 49.4231719970703,
    "a": -0.13809664547443,
    "b": -27.9809799194336,
    "C": 27.9813213348389,
    "h": 269.717224121094,
    "CMY_C": 0.67174029350281,
    "CMY_M": 0.52979761362076,
    "CMY_Y": 0.35906767845154,
    "CMYK_C": 0.48784029483795,
    "CMYK_M": 0.26637747883797,
    "CMYK_Y": 0,
    "CMYK_K": 0.35906767845154
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09380",
    "Farbtonhilfsbezeichnung": "U7.39.20",
    "Farbtonklasse": "04",
    "Rcolor": "51",
    "Gcolor": "76",
    "Bcolor": "120",
    "Y": 7.21394872665405,
    "L": 32.2890892028809,
    "a": 4.91896772384644,
    "b": -28.8587417602539,
    "C": 29.274959564209,
    "h": 279.673095703125,
    "CMY_C": 0.80165636539459,
    "CMY_M": 0.70234155654907,
    "CMY_Y": 0.52783846855164,
    "CMYK_C": 0.57992422580719,
    "CMYK_M": 0.36958345770836,
    "CMYK_Y": 0,
    "CMYK_K": 0.52783846855164
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09381",
    "Farbtonhilfsbezeichnung": "U0.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "221",
    "Bcolor": "226",
    "Y": 72.0278396606445,
    "L": 87.9819869995117,
    "a": -0.10426017642021,
    "b": -3.92122292518616,
    "C": 3.92260885238647,
    "h": 268.476928710938,
    "CMY_C": 0.14946365356445,
    "CMY_M": 0.13276743888855,
    "CMY_Y": 0.11255168914795,
    "CMYK_C": 0.04159336909652,
    "CMYK_M": 0.02277963608503,
    "CMYK_Y": 0,
    "CMYK_K": 0.11255168914795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09382",
    "Farbtonhilfsbezeichnung": "U0.24.39",
    "Farbtonklasse": "03",
    "Rcolor": "93",
    "Gcolor": "118",
    "Bcolor": "153",
    "Y": 17.5373191833496,
    "L": 48.930046081543,
    "a": 0.4424315392971,
    "b": -22.4606704711914,
    "C": 22.4650268554688,
    "h": 271.128479003906,
    "CMY_C": 0.63537812232971,
    "CMY_M": 0.53790998458862,
    "CMY_Y": 0.40064907073975,
    "CMYK_C": 0.39163875579834,
    "CMYK_M": 0.22901593148708,
    "CMYK_Y": 0,
    "CMYK_K": 0.40064907073975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09383",
    "Farbtonhilfsbezeichnung": "T9.26.21",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "79",
    "Bcolor": "105",
    "Y": 7.54796695709229,
    "L": 33.0231628417969,
    "a": -0.4038000702858,
    "b": -17.7929267883301,
    "C": 17.7975082397461,
    "h": 268.699920654297,
    "CMY_C": 0.77085900306702,
    "CMY_M": 0.68938255310059,
    "CMY_Y": 0.58939832448959,
    "CMYK_C": 0.44193848967552,
    "CMYK_M": 0.24350662529469,
    "CMYK_Y": 0,
    "CMYK_K": 0.58939832448959
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09384",
    "Farbtonhilfsbezeichnung": "U1.06.71",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "193",
    "Bcolor": "206",
    "Y": 53.217155456543,
    "L": 78.0030364990234,
    "a": 0.13346108794212,
    "b": -7.92915296554565,
    "C": 7.93027591705322,
    "h": 270.964294433594,
    "CMY_C": 0.27123928070068,
    "CMY_M": 0.24125498533249,
    "CMY_Y": 0.19277089834213,
    "CMYK_C": 0.09720707684755,
    "CMYK_M": 0.06006236374378,
    "CMYK_Y": 0,
    "CMYK_K": 0.19277089834213
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09385",
    "Farbtonhilfsbezeichnung": "U0.11.50",
    "Farbtonklasse": "02",
    "Rcolor": "129",
    "Gcolor": "141",
    "Bcolor": "159",
    "Y": 26.1049365997314,
    "L": 58.1365242004395,
    "a": -0.0244732350111,
    "b": -11.5482358932495,
    "C": 11.548261642456,
    "h": 269.878570556641,
    "CMY_C": 0.49409556388855,
    "CMY_M": 0.44835495948792,
    "CMY_Y": 0.37840938568115,
    "CMYK_C": 0.18611313402653,
    "CMYK_M": 0.11252675205469,
    "CMYK_Y": 0,
    "CMYK_K": 0.37840938568115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09386",
    "Farbtonhilfsbezeichnung": "U1.14.39",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "115",
    "Bcolor": "135",
    "Y": 16.9014701843262,
    "L": 48.1356468200684,
    "a": 0.61458051204681,
    "b": -13.041971206665,
    "C": 13.0564441680908,
    "h": 272.697967529297,
    "CMY_C": 0.59470802545547,
    "CMY_M": 0.5492479801178,
    "CMY_Y": 0.4705228805542,
    "CMYK_C": 0.23454298079014,
    "CMYK_M": 0.14868460595608,
    "CMYK_Y": 0,
    "CMYK_K": 0.4705228805542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09387",
    "Farbtonhilfsbezeichnung": "UN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "222",
    "Bcolor": "226",
    "Y": 73.2293930053711,
    "L": 88.5570068359375,
    "a": 0.63958418369293,
    "b": -2.77164483070374,
    "C": 2.84448289871216,
    "h": 282.994110107422,
    "CMY_C": 0.1329892873764,
    "CMY_M": 0.12849205732346,
    "CMY_Y": 0.1145526766777,
    "CMYK_C": 0.02082180418074,
    "CMYK_M": 0.01574275456369,
    "CMYK_Y": 0,
    "CMYK_K": 0.1145526766777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09388",
    "Farbtonhilfsbezeichnung": "U6.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "209",
    "Bcolor": "218",
    "Y": 63.4708061218262,
    "L": 83.6894760131836,
    "a": 0.74795216321945,
    "b": -5.68913793563843,
    "C": 5.73809385299683,
    "h": 277.489715576172,
    "CMY_C": 0.19624853134155,
    "CMY_M": 0.1815100312233,
    "CMY_Y": 0.14678919315338,
    "CMYK_C": 0.05796848610044,
    "CMYK_M": 0.04069432616234,
    "CMYK_Y": 0,
    "CMYK_K": 0.14678919315338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09389",
    "Farbtonhilfsbezeichnung": "U5.06.67",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "183",
    "Bcolor": "197",
    "Y": 47.3310012817383,
    "L": 74.400993347168,
    "a": 1.04601216316223,
    "b": -8.60939979553223,
    "C": 8.67271041870117,
    "h": 276.927276611328,
    "CMY_C": 0.30504500865936,
    "CMY_M": 0.28183269500732,
    "CMY_Y": 0.22677558660507,
    "CMYK_C": 0.10122471302748,
    "CMYK_M": 0.07120456546545,
    "CMYK_Y": 0,
    "CMYK_K": 0.22677558660507
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09390",
    "Farbtonhilfsbezeichnung": "U6.09.58",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "161",
    "Bcolor": "180",
    "Y": 35.3170204162598,
    "L": 65.994743347168,
    "a": 1.44569492340088,
    "b": -11.7699937820435,
    "C": 11.8584480285645,
    "h": 277.002502441406,
    "CMY_C": 0.40271371603012,
    "CMY_M": 0.37052458524704,
    "CMY_Y": 0.29439508914948,
    "CMYK_C": 0.15351171791553,
    "CMYK_M": 0.10789252817631,
    "CMYK_Y": 0,
    "CMYK_K": 0.29439508914948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09391",
    "Farbtonhilfsbezeichnung": "U6.14.43",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "125",
    "Bcolor": "149",
    "Y": 20.4510631561279,
    "L": 52.3434066772461,
    "a": 2.3773238658905,
    "b": -14.6928396224976,
    "C": 14.8839244842529,
    "h": 279.190887451172,
    "CMY_C": 0.54631644487381,
    "CMY_M": 0.51086258888245,
    "CMY_Y": 0.41675531864166,
    "CMYK_C": 0.2221385538578,
    "CMYK_M": 0.1613512635231,
    "CMYK_Y": 0,
    "CMYK_K": 0.41675531864166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09392",
    "Farbtonhilfsbezeichnung": "UN.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "221",
    "Bcolor": "226",
    "Y": 72.3306427001953,
    "L": 88.1274948120117,
    "a": 0.5792732834816,
    "b": -3.50502467155457,
    "C": 3.55257034301758,
    "h": 279.384399414063,
    "CMY_C": 0.14085382223129,
    "CMY_M": 0.13289046287537,
    "CMY_Y": 0.11391264200211,
    "CMYK_C": 0.03040465526283,
    "CMYK_M": 0.02141755074263,
    "CMYK_Y": 0,
    "CMYK_K": 0.11391264200211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09393",
    "Farbtonhilfsbezeichnung": "U6.11.65",
    "Farbtonklasse": "01",
    "Rcolor": "168",
    "Gcolor": "177",
    "Bcolor": "202",
    "Y": 44.0377159118652,
    "L": 72.2537002563477,
    "a": 2.21433162689209,
    "b": -14.4410581588745,
    "C": 14.6098403930664,
    "h": 278.717590332031,
    "CMY_C": 0.34192043542862,
    "CMY_M": 0.30552977323532,
    "CMY_Y": 0.20854836702347,
    "CMYK_C": 0.16851575672626,
    "CMYK_M": 0.12253611534834,
    "CMYK_Y": 0,
    "CMYK_K": 0.20854836702347
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09394",
    "Farbtonhilfsbezeichnung": "U6.17.56",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "154",
    "Bcolor": "190",
    "Y": 32.3592681884766,
    "L": 63.6387100219727,
    "a": 3.20744490623474,
    "b": -20.8377552032471,
    "C": 21.0831623077393,
    "h": 278.750549316406,
    "CMY_C": 0.45275110006332,
    "CMY_M": 0.39590990543365,
    "CMY_Y": 0.25658828020096,
    "CMYK_C": 0.26386833190918,
    "CMYK_M": 0.18740843236446,
    "CMYK_Y": 0,
    "CMYK_K": 0.25658828020096
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09395",
    "Farbtonhilfsbezeichnung": "T8.11.76",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "207",
    "Bcolor": "228",
    "Y": 60.8129959106445,
    "L": 82.2781066894531,
    "a": -1.59019327163696,
    "b": -13.2405090332031,
    "C": 13.3356590270996,
    "h": 263.151550292969,
    "CMY_C": 0.26141214370728,
    "CMY_M": 0.18920075893402,
    "CMY_Y": 0.10778552293777,
    "CMYK_C": 0.17218574881554,
    "CMYK_M": 0.09125074744225,
    "CMYK_Y": 0,
    "CMYK_K": 0.10778552293777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09396",
    "Farbtonhilfsbezeichnung": "U0.15.69",
    "Farbtonklasse": "02",
    "Rcolor": "166",
    "Gcolor": "188",
    "Bcolor": "219",
    "Y": 49.1739845275879,
    "L": 75.559440612793,
    "a": -0.32373562455177,
    "b": -19.1014595031738,
    "C": 19.1042022705078,
    "h": 269.029022216797,
    "CMY_C": 0.34957057237625,
    "CMY_M": 0.26290667057037,
    "CMY_Y": 0.13962304592133,
    "CMYK_C": 0.24401807785034,
    "CMYK_M": 0.14329025149345,
    "CMYK_Y": 0,
    "CMYK_K": 0.13962304592133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09397",
    "Farbtonhilfsbezeichnung": "U3.27.51",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "143",
    "Bcolor": "191",
    "Y": 27.0538501739502,
    "L": 59.0241432189941,
    "a": 1.86225998401642,
    "b": -28.916296005249,
    "C": 28.9762001037598,
    "h": 273.684844970703,
    "CMY_C": 0.55746185779572,
    "CMY_M": 0.43732756376266,
    "CMY_Y": 0.25071674585342,
    "CMYK_C": 0.40938472747803,
    "CMYK_M": 0.24905243515968,
    "CMYK_Y": 0,
    "CMYK_K": 0.25071674585342
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09399",
    "Farbtonhilfsbezeichnung": "U6.33.40",
    "Farbtonklasse": "03",
    "Rcolor": "89",
    "Gcolor": "115",
    "Bcolor": "168",
    "Y": 17.2645893096924,
    "L": 48.5917053222656,
    "a": 5.29176187515259,
    "b": -31.9899768829346,
    "C": 32.4247016906738,
    "h": 279.392791748047,
    "CMY_C": 0.65274250507355,
    "CMY_M": 0.54779875278473,
    "CMY_Y": 0.34077304601669,
    "CMYK_C": 0.47323527932167,
    "CMYK_M": 0.31404313445091,
    "CMYK_Y": 0,
    "CMYK_K": 0.34077304601669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09400",
    "Farbtonhilfsbezeichnung": "U6.31.25",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "84",
    "Bcolor": "121",
    "Y": 8.86509990692139,
    "L": 35.723258972168,
    "a": 2.96538138389587,
    "b": -23.9143466949463,
    "C": 24.0974998474121,
    "h": 277.068603515625,
    "CMY_C": 0.75123965740204,
    "CMY_M": 0.66886311769485,
    "CMY_Y": 0.5247358083725,
    "CMYK_C": 0.47658514976501,
    "CMYK_M": 0.30325725674629,
    "CMYK_Y": 0,
    "CMYK_K": 0.5247358083725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09401",
    "Farbtonhilfsbezeichnung": "U7.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "211",
    "Bcolor": "227",
    "Y": 65.1653594970703,
    "L": 84.5688705444336,
    "a": 1.62829375267029,
    "b": -9.59721851348877,
    "C": 9.7343692779541,
    "h": 279.629272460938,
    "CMY_C": 0.19444006681442,
    "CMY_M": 0.17272961139679,
    "CMY_Y": 0.10854017734528,
    "CMYK_C": 0.09635867923498,
    "CMYK_M": 0.07200485467911,
    "CMYK_Y": 0,
    "CMYK_K": 0.10854017734528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09402",
    "Farbtonhilfsbezeichnung": "V3.34.18",
    "Farbtonklasse": "04",
    "Rcolor": "62",
    "Gcolor": "71",
    "Bcolor": "111",
    "Y": 6.66199827194214,
    "L": 31.024715423584,
    "a": 8.03909969329834,
    "b": -24.6389808654785,
    "C": 25.9173011779785,
    "h": 288.070251464844,
    "CMY_C": 0.75576663017273,
    "CMY_M": 0.72209942340851,
    "CMY_Y": 0.56611430644989,
    "CMYK_C": 0.43710204958916,
    "CMYK_M": 0.35950741171837,
    "CMYK_Y": 0,
    "CMYK_K": 0.56611430644989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09403",
    "Farbtonhilfsbezeichnung": "V2.19.49",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "136",
    "Bcolor": "175",
    "Y": 25.4343338012695,
    "L": 57.4961891174316,
    "a": 7.13835430145264,
    "b": -22.2640781402588,
    "C": 23.3804473876953,
    "h": 287.777008056641,
    "CMY_C": 0.4900563955307,
    "CMY_M": 0.46716052293777,
    "CMY_Y": 0.31185781955719,
    "CMYK_C": 0.25895604491234,
    "CMYK_M": 0.22568403184414,
    "CMYK_Y": 0,
    "CMYK_K": 0.31185781955719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09404",
    "Farbtonhilfsbezeichnung": "V2.25.41",
    "Farbtonklasse": "03",
    "Rcolor": "108",
    "Gcolor": "116",
    "Bcolor": "161",
    "Y": 18.1979084014893,
    "L": 49.7352752685547,
    "a": 8.43471431732178,
    "b": -25.9745845794678,
    "C": 27.3097686767578,
    "h": 287.990142822266,
    "CMY_C": 0.57641571760178,
    "CMY_M": 0.54605937004089,
    "CMY_Y": 0.36839526891708,
    "CMYK_C": 0.32935225963593,
    "CMYK_M": 0.28129002451897,
    "CMYK_Y": 0,
    "CMYK_K": 0.36839526891708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09405",
    "Farbtonhilfsbezeichnung": "V2.04.78",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "211",
    "Bcolor": "221",
    "Y": 65.7903900146484,
    "L": 84.8893814086914,
    "a": 1.94658195972443,
    "b": -5.89737462997437,
    "C": 6.21033096313477,
    "h": 288.266815185547,
    "CMY_C": 0.17430925369263,
    "CMY_M": 0.17111027240753,
    "CMY_Y": 0.1319328546524,
    "CMYK_C": 0.04881696030498,
    "CMYK_M": 0.04513178393245,
    "CMYK_Y": 0,
    "CMYK_K": 0.1319328546524
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09406",
    "Farbtonhilfsbezeichnung": "V2.09.71",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "190",
    "Bcolor": "213",
    "Y": 52.474422454834,
    "L": 77.5636596679688,
    "a": 4.08833837509155,
    "b": -12.6745309829712,
    "C": 13.3175916671753,
    "h": 287.877807617188,
    "CMY_C": 0.26274579763412,
    "CMY_M": 0.25369518995285,
    "CMY_Y": 0.16309612989426,
    "CMYK_C": 0.1190694347024,
    "CMYK_M": 0.10825503617525,
    "CMYK_Y": 0,
    "CMYK_K": 0.16309612989426
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09407",
    "Farbtonhilfsbezeichnung": "V3.10.66",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "176",
    "Bcolor": "200",
    "Y": 44.3519287109375,
    "L": 72.4631042480469,
    "a": 4.44310760498047,
    "b": -13.1934509277344,
    "C": 13.9215068817139,
    "h": 288.611785888672,
    "CMY_C": 0.31656849384308,
    "CMY_M": 0.30887788534164,
    "CMY_Y": 0.21484345197678,
    "CMYK_C": 0.12956020236015,
    "CMYK_M": 0.11976519972086,
    "CMYK_Y": 0,
    "CMYK_K": 0.21484345197678
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09408",
    "Farbtonhilfsbezeichnung": "V2.13.57",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "156",
    "Bcolor": "185",
    "Y": 34.0422248840332,
    "L": 64.9960708618164,
    "a": 5.23190879821777,
    "b": -16.3575382232666,
    "C": 17.1738739013672,
    "h": 287.736724853516,
    "CMY_C": 0.40180814266205,
    "CMY_M": 0.38802063465118,
    "CMY_Y": 0.27283489704132,
    "CMYK_C": 0.17736445367336,
    "CMYK_M": 0.15840382874012,
    "CMYK_Y": 0,
    "CMYK_K": 0.27283489704132
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09409",
    "Farbtonhilfsbezeichnung": "V2.20.43",
    "Farbtonklasse": "03",
    "Rcolor": "117",
    "Gcolor": "123",
    "Bcolor": "160",
    "Y": 20.4282722473145,
    "L": 52.3180084228516,
    "a": 6.71180438995361,
    "b": -21.4995803833008,
    "C": 22.5228824615479,
    "h": 287.337463378906,
    "CMY_C": 0.54249250888824,
    "CMY_M": 0.51834613084793,
    "CMY_Y": 0.37135833501816,
    "CMYK_C": 0.27222847938538,
    "CMYK_M": 0.2338180989027,
    "CMYK_Y": 0,
    "CMYK_K": 0.37135833501816
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09410",
    "Farbtonhilfsbezeichnung": "V0.28.18",
    "Farbtonklasse": "04",
    "Rcolor": "63",
    "Gcolor": "71",
    "Bcolor": "102",
    "Y": 6.60022735595703,
    "L": 30.8789196014404,
    "a": 5.35553169250488,
    "b": -19.6429443359375,
    "C": 20.3599357604981,
    "h": 285.250671386719,
    "CMY_C": 0.7520397901535,
    "CMY_M": 0.71967720985413,
    "CMY_Y": 0.59826970100403,
    "CMYK_C": 0.38276946544647,
    "CMYK_M": 0.30221149325371,
    "CMYK_Y": 0,
    "CMYK_K": 0.59826970100403
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09411",
    "Farbtonhilfsbezeichnung": "V2.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "185",
    "Bcolor": "201",
    "Y": 49.2615966796875,
    "L": 75.6137847900391,
    "a": 2.96222043037415,
    "b": -8.82542896270752,
    "C": 9.30929374694824,
    "h": 288.554138183594,
    "CMY_C": 0.27773380279541,
    "CMY_M": 0.27321523427963,
    "CMY_Y": 0.21191900968552,
    "CMYK_C": 0.08351273089647,
    "CMYK_M": 0.07777909189463,
    "CMYK_Y": 0,
    "CMYK_K": 0.21191900968552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09412",
    "Farbtonhilfsbezeichnung": "V2.10.55",
    "Farbtonklasse": "02",
    "Rcolor": "145",
    "Gcolor": "149",
    "Bcolor": "172",
    "Y": 30.5951595306396,
    "L": 62.1643829345703,
    "a": 3.80037355422974,
    "b": -13.2095336914063,
    "C": 13.7453489303589,
    "h": 286.050476074219,
    "CMY_C": 0.42950683832169,
    "CMY_M": 0.41504490375519,
    "CMY_Y": 0.32465517520905,
    "CMYK_C": 0.15525647997856,
    "CMYK_M": 0.13384233415127,
    "CMYK_Y": 0,
    "CMYK_K": 0.32465517520905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09413",
    "Farbtonhilfsbezeichnung": "V2.16.41",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "117",
    "Bcolor": "146",
    "Y": 18.3002777099609,
    "L": 49.8583106994629,
    "a": 5.72014951705933,
    "b": -16.644811630249,
    "C": 17.6002807617188,
    "h": 288.965759277344,
    "CMY_C": 0.55321758985519,
    "CMY_M": 0.54214853048325,
    "CMY_Y": 0.42894357442856,
    "CMYK_C": 0.21762125194073,
    "CMYK_M": 0.19823777675629,
    "CMYK_Y": 0,
    "CMYK_K": 0.42894357442856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09414",
    "Farbtonhilfsbezeichnung": "V2.23.24",
    "Farbtonklasse": "03",
    "Rcolor": "77",
    "Gcolor": "84",
    "Bcolor": "113",
    "Y": 9.12180328369141,
    "L": 36.2177581787109,
    "a": 5.15290355682373,
    "b": -18.1894836425781,
    "C": 18.9052829742432,
    "h": 285.816925048828,
    "CMY_C": 0.69652128219604,
    "CMY_M": 0.67090725898743,
    "CMY_Y": 0.55547547340393,
    "CMYK_C": 0.31729590892792,
    "CMYK_M": 0.25967472791672,
    "CMYK_Y": 0,
    "CMYK_K": 0.55547547340393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09415",
    "Farbtonhilfsbezeichnung": "VN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "219",
    "Bcolor": "221",
    "Y": 71.4973373413086,
    "L": 87.72607421875,
    "a": 1.19778406620026,
    "b": -1.6927741765976,
    "C": 2.07368540763855,
    "h": 305.28271484375,
    "CMY_C": 0.13396102190018,
    "CMY_M": 0.13933086395264,
    "CMY_Y": 0.13157051801682,
    "CMYK_C": 0.00275267474353,
    "CMYK_M": 0.00893606897444,
    "CMYK_Y": 0,
    "CMYK_K": 0.13157051801682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09416",
    "Farbtonhilfsbezeichnung": "VN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "210",
    "Bcolor": "216",
    "Y": 64.8141708374023,
    "L": 84.3878860473633,
    "a": 1.86334085464478,
    "b": -3.56938076019287,
    "C": 4.02647733688354,
    "h": 297.566131591797,
    "CMY_C": 0.17208516597748,
    "CMY_M": 0.17711454629898,
    "CMY_Y": 0.15441220998764,
    "CMYK_C": 0.02090020291507,
    "CMYK_M": 0.02684799395502,
    "CMYK_Y": 0,
    "CMYK_K": 0.15441220998764
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09417",
    "Farbtonhilfsbezeichnung": "V8.11.39",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "112",
    "Bcolor": "133",
    "Y": 16.9956912994385,
    "L": 48.2546043395996,
    "a": 5.67369508743286,
    "b": -11.4323129653931,
    "C": 12.7627820968628,
    "h": 296.394561767578,
    "CMY_C": 0.54883116483688,
    "CMY_M": 0.55949246883392,
    "CMY_Y": 0.47932314872742,
    "CMYK_C": 0.13349549472332,
    "CMYK_M": 0.15397135913372,
    "CMYK_Y": 0,
    "CMYK_K": 0.47932314872742
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09418",
    "Farbtonhilfsbezeichnung": "V9.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "210",
    "Bcolor": "224",
    "Y": 66.006477355957,
    "L": 84.9997177124023,
    "a": 4.49843454360962,
    "b": -7.18431758880615,
    "C": 8.4764575958252,
    "h": 302.052581787109,
    "CMY_C": 0.1576042175293,
    "CMY_M": 0.17561268806458,
    "CMY_Y": 0.12100774049759,
    "CMYK_C": 0.04163458570838,
    "CMYK_M": 0.06212221831083,
    "CMYK_Y": 0,
    "CMYK_K": 0.12100774049759
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09419",
    "Farbtonhilfsbezeichnung": "V7.12.57",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "154",
    "Bcolor": "183",
    "Y": 33.6270408630371,
    "L": 64.6654434204102,
    "a": 7.3087911605835,
    "b": -15.6870813369751,
    "C": 17.3061542510986,
    "h": 294.981353759766,
    "CMY_C": 0.38621228933334,
    "CMY_M": 0.39652937650681,
    "CMY_Y": 0.28076940774918,
    "CMYK_C": 0.14660511910915,
    "CMYK_M": 0.16094972193241,
    "CMYK_Y": 0,
    "CMYK_K": 0.28076940774918
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09420",
    "Farbtonhilfsbezeichnung": "V8.19.38",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "109",
    "Bcolor": "144",
    "Y": 16.4860801696777,
    "L": 47.6058578491211,
    "a": 9.16398429870605,
    "b": -18.9348983764648,
    "C": 21.0358982086182,
    "h": 295.825744628906,
    "CMY_C": 0.55907529592514,
    "CMY_M": 0.57121849060059,
    "CMY_Y": 0.43658286333084,
    "CMYK_C": 0.21740984916687,
    "CMYK_M": 0.23896260559559,
    "CMYK_Y": 0,
    "CMYK_K": 0.43658286333084
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09421",
    "Farbtonhilfsbezeichnung": "V8.24.27",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "86",
    "Bcolor": "120",
    "Y": 10.1957693099976,
    "L": 38.191520690918,
    "a": 9.97159671783447,
    "b": -19.4957790374756,
    "C": 21.8979034423828,
    "h": 297.088592529297,
    "CMY_C": 0.64734470844269,
    "CMY_M": 0.6626832485199,
    "CMY_Y": 0.52747130393982,
    "CMYK_C": 0.25368490815163,
    "CMYK_M": 0.28614547848701,
    "CMYK_Y": 0,
    "CMYK_K": 0.52747130393982
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09422",
    "Farbtonhilfsbezeichnung": "V8.15.20",
    "Farbtonklasse": "04",
    "Rcolor": "77",
    "Gcolor": "76",
    "Bcolor": "95",
    "Y": 7.54434490203857,
    "L": 33.0153198242188,
    "a": 5.45169115066528,
    "b": -11.6702661514282,
    "C": 12.8808403015137,
    "h": 295.039337158203,
    "CMY_C": 0.69699788093567,
    "CMY_M": 0.70320749282837,
    "CMY_Y": 0.62649714946747,
    "CMYK_C": 0.18875554203987,
    "CMYK_M": 0.20538087189198,
    "CMYK_Y": 0,
    "CMYK_K": 0.62649714946747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09423",
    "Farbtonhilfsbezeichnung": "V7.05.81",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "216",
    "Bcolor": "229",
    "Y": 69.7269668579102,
    "L": 86.8627777099609,
    "a": 3.26797938346863,
    "b": -6.79015207290649,
    "C": 7.5356388092041,
    "h": 295.70068359375,
    "CMY_C": 0.145348072052,
    "CMY_M": 0.15227818489075,
    "CMY_Y": 0.10344886779785,
    "CMYK_C": 0.04673375934362,
    "CMYK_M": 0.05446350574493,
    "CMYK_Y": 0,
    "CMYK_K": 0.10344886779785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09424",
    "Farbtonhilfsbezeichnung": "V6.08.76",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "207",
    "Bcolor": "227",
    "Y": 63.3136672973633,
    "L": 83.6071472167969,
    "a": 4.3544020652771,
    "b": -10.9950542449951,
    "C": 11.8259048461914,
    "h": 291.605194091797,
    "CMY_C": 0.18835407495499,
    "CMY_M": 0.1893065571785,
    "CMY_Y": 0.10867547988892,
    "CMYK_C": 0.08939347416162,
    "CMYK_M": 0.0904620885849,
    "CMYK_Y": 0,
    "CMYK_K": 0.10867547988892
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09425",
    "Farbtonhilfsbezeichnung": "V6.11.70",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "187",
    "Bcolor": "219",
    "Y": 51.1790046691895,
    "L": 76.7873153686523,
    "a": 7.37656211853027,
    "b": -16.6034183502197,
    "C": 18.1683006286621,
    "h": 293.95458984375,
    "CMY_C": 0.26062726974487,
    "CMY_M": 0.26859158277512,
    "CMY_Y": 0.1431223154068,
    "CMYK_C": 0.13713154196739,
    "CMYK_M": 0.14642611145973,
    "CMYK_Y": 0,
    "CMYK_K": 0.1431223154068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09426",
    "Farbtonhilfsbezeichnung": "W1.31.21",
    "Farbtonklasse": "04",
    "Rcolor": "81",
    "Gcolor": "72",
    "Bcolor": "112",
    "Y": 7.59656047821045,
    "L": 33.1281394958496,
    "a": 13.2155332565308,
    "b": -22.2399654388428,
    "C": 25.8701839447021,
    "h": 300.719818115234,
    "CMY_C": 0.6841943860054,
    "CMY_M": 0.71587455272675,
    "CMY_Y": 0.55990654230118,
    "CMYK_C": 0.28241237998009,
    "CMYK_M": 0.35439747571945,
    "CMYK_Y": 0,
    "CMYK_K": 0.55990654230118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09427",
    "Farbtonhilfsbezeichnung": "W3.32.30",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "88",
    "Bcolor": "139",
    "Y": 11,
    "L": 40.5633659362793,
    "a": 17.9456520080566,
    "b": -27.0723934173584,
    "C": 32.4801635742188,
    "h": 303.539459228516,
    "CMY_C": 0.59948194026947,
    "CMY_M": 0.65685153007507,
    "CMY_Y": 0.45493304729462,
    "CMYK_C": 0.26519474387169,
    "CMYK_M": 0.37044712901115,
    "CMYK_Y": 0,
    "CMYK_K": 0.45493304729462
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09428",
    "Farbtonhilfsbezeichnung": "W0.29.18",
    "Farbtonklasse": "04",
    "Rcolor": "75",
    "Gcolor": "69",
    "Bcolor": "106",
    "Y": 6.85117101669312,
    "L": 31.4656658172607,
    "a": 11.582896232605,
    "b": -20.7416858673096,
    "C": 23.7567043304443,
    "h": 299.180541992188,
    "CMY_C": 0.70495343208313,
    "CMY_M": 0.72766482830048,
    "CMY_Y": 0.58541262149811,
    "CMYK_C": 0.28833684325218,
    "CMYK_M": 0.34311756491661,
    "CMYK_Y": 0,
    "CMYK_K": 0.58541262149811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09429",
    "Farbtonhilfsbezeichnung": "WN.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "226",
    "Y": 73.8678741455078,
    "L": 88.8600006103516,
    "a": 2.10299205780029,
    "b": -2.26802778244019,
    "C": 3.09298014640808,
    "h": 312.837707519531,
    "CMY_C": 0.11626291275024,
    "CMY_M": 0.1287693977356,
    "CMY_Y": 0.11471545696259,
    "CMYK_C": 0.00174797559157,
    "CMYK_M": 0.01587505452335,
    "CMYK_Y": 0,
    "CMYK_K": 0.11471545696259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09430",
    "Farbtonhilfsbezeichnung": "W4.21.41",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "112",
    "Bcolor": "155",
    "Y": 18.592679977417,
    "L": 50.207218170166,
    "a": 15.2406330108643,
    "b": -21.3954257965088,
    "C": 26.2686347961426,
    "h": 305.463470458984,
    "CMY_C": 0.49853950738907,
    "CMY_M": 0.55958390235901,
    "CMY_Y": 0.39313584566116,
    "CMYK_C": 0.17368575930595,
    "CMYK_M": 0.27427563071251,
    "CMYK_Y": 0,
    "CMYK_K": 0.39313584566116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09431",
    "Farbtonhilfsbezeichnung": "W4.24.29",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "87",
    "Bcolor": "126",
    "Y": 10.9589395523071,
    "L": 39.5112266540527,
    "a": 14.2360982894898,
    "b": -20.4959983825684,
    "C": 24.9550075531006,
    "h": 304.783050537109,
    "CMY_C": 0.60840964317322,
    "CMY_M": 0.66010016202927,
    "CMY_Y": 0.50768220424652,
    "CMYK_C": 0.20459841191769,
    "CMYK_M": 0.30959263443947,
    "CMYK_Y": 0,
    "CMYK_K": 0.50768220424652
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09432",
    "Farbtonhilfsbezeichnung": "VN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 81.640983581543,
    "L": 92.4161682128906,
    "a": 0.64651811122894,
    "b": -0.24024887382984,
    "C": 0.68971383571625,
    "h": 339.614715576172,
    "CMY_C": 0.08109843730927,
    "CMY_M": 0.08628404140472,
    "CMY_Y": 0.09052306413651,
    "CMYK_C": 0,
    "CMYK_M": 0.00564326392487,
    "CMYK_Y": 0.01025640498847,
    "CMYK_K": 0.08109843730927
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09433",
    "Farbtonhilfsbezeichnung": "WN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "220",
    "Bcolor": "222",
    "Y": 72.0879135131836,
    "L": 88.0108871459961,
    "a": 1.8655561208725,
    "b": -1.68095803260803,
    "C": 2.51115894317627,
    "h": 317.979583740234,
    "CMY_C": 0.12551635503769,
    "CMY_M": 0.13777512311935,
    "CMY_Y": 0.12843102216721,
    "CMYK_C": 0,
    "CMYK_M": 0.01401829347014,
    "CMYK_Y": 0.00333301513456,
    "CMYK_K": 0.12551635503769
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09434",
    "Farbtonhilfsbezeichnung": "W2.04.69",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "185",
    "Bcolor": "197",
    "Y": 49.611255645752,
    "L": 75.8300323486328,
    "a": 4.10838413238525,
    "b": -6.43837642669678,
    "C": 7.63750696182251,
    "h": 302.542297363281,
    "CMY_C": 0.25778990983963,
    "CMY_M": 0.27432370185852,
    "CMY_Y": 0.22643637657166,
    "CMYK_C": 0.04053129255772,
    "CMYK_M": 0.06190483272076,
    "CMYK_Y": 0,
    "CMYK_K": 0.22643637657166
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09435",
    "Farbtonhilfsbezeichnung": "W3.07.55",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "151",
    "Bcolor": "168",
    "Y": 32.2688484191895,
    "L": 63.5644683837891,
    "a": 5.73840284347534,
    "b": -8.76485538482666,
    "C": 10.4762563705444,
    "h": 303.213012695313,
    "CMY_C": 0.383524954319,
    "CMY_M": 0.4064729809761,
    "CMY_Y": 0.34023839235306,
    "CMYK_C": 0.065609395504,
    "CMYK_M": 0.10039170086384,
    "CMYK_Y": 0,
    "CMYK_K": 0.34023839235306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09436",
    "Farbtonhilfsbezeichnung": "W4.13.37",
    "Farbtonklasse": "03",
    "Rcolor": "115",
    "Gcolor": "107",
    "Bcolor": "130",
    "Y": 15.6791610717773,
    "L": 46.5507164001465,
    "a": 8.53339576721191,
    "b": -12.3011493682861,
    "C": 14.971209526062,
    "h": 304.749328613281,
    "CMY_C": 0.54842090606689,
    "CMY_M": 0.58229243755341,
    "CMY_Y": 0.49043947458267,
    "CMYK_C": 0.11378713697195,
    "CMYK_M": 0.1802591830492,
    "CMYK_Y": 0,
    "CMYK_K": 0.49043947458267
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09437",
    "Farbtonhilfsbezeichnung": "W3.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "212",
    "Bcolor": "225",
    "Y": 67.369255065918,
    "L": 85.6900787353516,
    "a": 4.80217981338501,
    "b": -6.4767894744873,
    "C": 8.06286144256592,
    "h": 306.554870605469,
    "CMY_C": 0.14505153894424,
    "CMY_M": 0.16899055242538,
    "CMY_Y": 0.11851066350937,
    "CMYK_C": 0.03010912798345,
    "CMYK_M": 0.05726658925414,
    "CMYK_Y": 0,
    "CMYK_K": 0.11851066350937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09438",
    "Farbtonhilfsbezeichnung": "W4.07.70",
    "Farbtonklasse": "01",
    "Rcolor": "195",
    "Gcolor": "187",
    "Bcolor": "206",
    "Y": 51.4610290527344,
    "L": 76.9574356079102,
    "a": 7.18754243850708,
    "b": -9.63793182373047,
    "C": 12.0229158401489,
    "h": 306.713958740234,
    "CMY_C": 0.23347568511963,
    "CMY_M": 0.26862341165543,
    "CMY_Y": 0.19104647636414,
    "CMYK_C": 0.05244950205088,
    "CMYK_M": 0.09589789062738,
    "CMYK_Y": 0,
    "CMYK_K": 0.19104647636414
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09439",
    "Farbtonhilfsbezeichnung": "W4.11.57",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "153",
    "Bcolor": "181",
    "Y": 33.9748344421387,
    "L": 64.9425888061523,
    "a": 9.45583057403564,
    "b": -13.7459554672241,
    "C": 16.6842441558838,
    "h": 304.524047851563,
    "CMY_C": 0.35952842235565,
    "CMY_M": 0.39945417642593,
    "CMY_Y": 0.29099011421204,
    "CMYK_C": 0.09666763246059,
    "CMYK_M": 0.15297961235046,
    "CMYK_Y": 0,
    "CMYK_K": 0.29099011421204
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09440",
    "Farbtonhilfsbezeichnung": "W4.17.45",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "122",
    "Bcolor": "157",
    "Y": 21.3586769104004,
    "L": 53.3398246765137,
    "a": 12.1107063293457,
    "b": -17.9676208496094,
    "C": 21.6680545806885,
    "h": 303.981140136719,
    "CMY_C": 0.47589898109436,
    "CMY_M": 0.52217590808868,
    "CMY_Y": 0.38374543190002,
    "CMYK_C": 0.14953811466694,
    "CMYK_M": 0.22463196516037,
    "CMYK_Y": 0,
    "CMYK_K": 0.38374543190002
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09441",
    "Farbtonhilfsbezeichnung": "W4.19.32",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "96",
    "Bcolor": "127",
    "Y": 13.0724029541016,
    "L": 42.8721351623535,
    "a": 11.2288827896118,
    "b": -15.8997278213501,
    "C": 19.4650745391846,
    "h": 305.230926513672,
    "CMY_C": 0.57884109020233,
    "CMY_M": 0.6227525472641,
    "CMY_Y": 0.50371336936951,
    "CMYK_C": 0.1513797044754,
    "CMYK_M": 0.23985973000526,
    "CMYK_Y": 0,
    "CMYK_K": 0.50371336936951
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09442",
    "Farbtonhilfsbezeichnung": "W4.21.27",
    "Farbtonklasse": "04",
    "Rcolor": "95",
    "Gcolor": "83",
    "Bcolor": "115",
    "Y": 9.87724018096924,
    "L": 37.6212005615234,
    "a": 12.3270807266235,
    "b": -17.1230182647705,
    "C": 21.0986881256104,
    "h": 305.750610351563,
    "CMY_C": 0.62680417299271,
    "CMY_M": 0.67440092563629,
    "CMY_Y": 0.54776525497437,
    "CMYK_C": 0.17477409541607,
    "CMYK_M": 0.28002199530602,
    "CMYK_Y": 0,
    "CMYK_K": 0.54776525497437
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09443",
    "Farbtonhilfsbezeichnung": "VN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "222",
    "Bcolor": "226",
    "Y": 73.8979644775391,
    "L": 88.8742370605469,
    "a": 1.94215106964111,
    "b": -2.46450543403625,
    "C": 3.13779187202454,
    "h": 308.239837646484,
    "CMY_C": 0.11805760860443,
    "CMY_M": 0.12816822528839,
    "CMY_Y": 0.1131334900856,
    "CMYK_C": 0.00555226579309,
    "CMYK_M": 0.01695264689624,
    "CMYK_Y": 0,
    "CMYK_K": 0.1131334900856
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09444",
    "Farbtonhilfsbezeichnung": "X0.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "210",
    "Bcolor": "224",
    "Y": 67.3693008422852,
    "L": 85.6900939941406,
    "a": 7.01988840103149,
    "b": -6.05313158035278,
    "C": 9.26926326751709,
    "h": 319.229339599609,
    "CMY_C": 0.12635570764542,
    "CMY_M": 0.17456132173538,
    "CMY_Y": 0.12131452560425,
    "CMYK_C": 0.00573718594387,
    "CMYK_M": 0.06059824302793,
    "CMYK_Y": 0,
    "CMYK_K": 0.12131452560425
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09445",
    "Farbtonhilfsbezeichnung": "W7.11.70",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "185",
    "Bcolor": "215",
    "Y": 51.9560050964355,
    "L": 77.254524230957,
    "a": 11.9765872955322,
    "b": -13.9709243774414,
    "C": 18.4017753601074,
    "h": 310.604858398438,
    "CMY_C": 0.20957690477371,
    "CMY_M": 0.27590453624725,
    "CMY_Y": 0.15627527236938,
    "CMYK_C": 0.06317419558764,
    "CMYK_M": 0.14178708195686,
    "CMYK_Y": 0,
    "CMYK_K": 0.15627527236938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09446",
    "Farbtonhilfsbezeichnung": "W7.18.59",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "150",
    "Bcolor": "196",
    "Y": 34.8075790405273,
    "L": 65.5985794067383,
    "a": 17.9295387268066,
    "b": -21.0752830505371,
    "C": 27.6701259613037,
    "h": 310.389068603516,
    "CMY_C": 0.31760108470917,
    "CMY_M": 0.41149246692657,
    "CMY_Y": 0.23234617710114,
    "CMYK_C": 0.11105905473232,
    "CMYK_M": 0.23336859047413,
    "CMYK_Y": 0,
    "CMYK_K": 0.23234617710114
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09447",
    "Farbtonhilfsbezeichnung": "W7.20.53",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "135",
    "Bcolor": "184",
    "Y": 28.5416927337646,
    "L": 60.375,
    "a": 19.8304882049561,
    "b": -22.4191913604736,
    "C": 29.9310607910156,
    "h": 311.493774414063,
    "CMY_C": 0.36442005634308,
    "CMY_M": 0.46959400177002,
    "CMY_Y": 0.27894991636276,
    "CMYK_C": 0.11853565275669,
    "CMYK_M": 0.26439782977104,
    "CMYK_Y": 0,
    "CMYK_K": 0.27894991636276
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09448",
    "Farbtonhilfsbezeichnung": "W7.26.41",
    "Farbtonklasse": "03",
    "Rcolor": "136",
    "Gcolor": "108",
    "Bcolor": "159",
    "Y": 18.4783592224121,
    "L": 50.0712432861328,
    "a": 21.3522872924805,
    "b": -24.2573528289795,
    "C": 32.3162384033203,
    "h": 311.355529785156,
    "CMY_C": 0.46808350086212,
    "CMY_M": 0.57583236694336,
    "CMY_Y": 0.37506681680679,
    "CMYK_C": 0.14884260296822,
    "CMYK_M": 0.32125923037529,
    "CMYK_Y": 0,
    "CMYK_K": 0.37506681680679
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09449",
    "Farbtonhilfsbezeichnung": "W8.27.20",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "71",
    "Bcolor": "105",
    "Y": 7.64328622817993,
    "L": 33.2286605834961,
    "a": 15.7022676467896,
    "b": -17.2473449707031,
    "C": 23.3244953155518,
    "h": 312.315246582031,
    "CMY_C": 0.64712870121002,
    "CMY_M": 0.72309601306915,
    "CMY_Y": 0.58940845727921,
    "CMYK_C": 0.14057825505733,
    "CMYK_M": 0.32559743523598,
    "CMYK_Y": 0,
    "CMYK_K": 0.58940845727921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09450",
    "Farbtonhilfsbezeichnung": "X1.04.83",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "222",
    "Bcolor": "231",
    "Y": 74.7624816894531,
    "L": 89.2816162109375,
    "a": 5.06427526473999,
    "b": -4.26940155029297,
    "C": 6.62379598617554,
    "h": 319.86767578125,
    "CMY_C": 0.09533929824829,
    "CMY_M": 0.1306825876236,
    "CMY_Y": 0.09491473436356,
    "CMYK_C": 0.0004690871574,
    "CMYK_M": 0.03951876610518,
    "CMYK_Y": 0,
    "CMYK_K": 0.09491473436356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09451",
    "Farbtonhilfsbezeichnung": "W8.08.76",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "200",
    "Bcolor": "223",
    "Y": 60.7588577270508,
    "L": 82.2489395141602,
    "a": 9.41162204742432,
    "b": -10.898681640625,
    "C": 14.399995803833,
    "h": 310.812438964844,
    "CMY_C": 0.16319018602371,
    "CMY_M": 0.21655541658401,
    "CMY_Y": 0.1237605214119,
    "CMYK_C": 0.04499873146415,
    "CMYK_M": 0.10590129345655,
    "CMYK_Y": 0,
    "CMYK_K": 0.1237605214119
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09452",
    "Farbtonhilfsbezeichnung": "W7.14.64",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "166",
    "Bcolor": "205",
    "Y": 42.2468795776367,
    "L": 71.0408020019531,
    "a": 15.9134569168091,
    "b": -17.9373226165771,
    "C": 23.9788589477539,
    "h": 311.578491210938,
    "CMY_C": 0.26219981908798,
    "CMY_M": 0.35061037540436,
    "CMY_Y": 0.19553244113922,
    "CMYK_C": 0.08287142962217,
    "CMYK_M": 0.19277089834213,
    "CMYK_Y": 0,
    "CMYK_K": 0.19553244113922
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09453",
    "Farbtonhilfsbezeichnung": "W7.23.48",
    "Farbtonklasse": "02",
    "Rcolor": "149",
    "Gcolor": "122",
    "Bcolor": "173",
    "Y": 23.2282943725586,
    "L": 55.306713104248,
    "a": 21.0103874206543,
    "b": -24.227481842041,
    "C": 32.068790435791,
    "h": 310.932250976563,
    "CMY_C": 0.41614484786987,
    "CMY_M": 0.5231214761734,
    "CMY_Y": 0.32039546966553,
    "CMYK_C": 0.14088985323906,
    "CMYK_M": 0.29829996824265,
    "CMYK_Y": 0,
    "CMYK_K": 0.32039546966553
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09454",
    "Farbtonhilfsbezeichnung": "W8.28.34",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "92",
    "Bcolor": "142",
    "Y": 13.5368566513062,
    "L": 43.5612678527832,
    "a": 22.0945606231689,
    "b": -24.3186359405518,
    "C": 32.8567428588867,
    "h": 312.256530761719,
    "CMY_C": 0.52956521511078,
    "CMY_M": 0.64082998037338,
    "CMY_Y": 0.44169980287552,
    "CMYK_C": 0.15738022327423,
    "CMYK_M": 0.35667222738266,
    "CMYK_Y": 0,
    "CMYK_K": 0.44169980287552
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09455",
    "Farbtonhilfsbezeichnung": "X0.16.24",
    "Farbtonklasse": "04",
    "Rcolor": "92",
    "Gcolor": "77",
    "Bcolor": "100",
    "Y": 8.55060195922852,
    "L": 35.1042366027832,
    "a": 10.9616346359253,
    "b": -11.5592288970947,
    "C": 15.9302606582642,
    "h": 313.480010986328,
    "CMY_C": 0.64045345783234,
    "CMY_M": 0.6963951587677,
    "CMY_Y": 0.60679268836975,
    "CMYK_C": 0.08560565859079,
    "CMYK_M": 0.22787590324879,
    "CMYK_Y": 0,
    "CMYK_K": 0.60679268836975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09456",
    "Farbtonhilfsbezeichnung": "WN.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "221",
    "Bcolor": "224",
    "Y": 73.2688217163086,
    "L": 88.5757675170898,
    "a": 2.26205801963806,
    "b": -1.93892776966095,
    "C": 2.97932004928589,
    "h": 319.398406982422,
    "CMY_C": 0.11702913045883,
    "CMY_M": 0.13239693641663,
    "CMY_Y": 0.12025368213654,
    "CMYK_C": 0,
    "CMYK_M": 0.0174046587199,
    "CMYK_Y": 0.00365193444304,
    "CMYK_K": 0.11702913045883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09457",
    "Farbtonhilfsbezeichnung": "X0.03.78",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "209",
    "Bcolor": "219",
    "Y": 65.7090072631836,
    "L": 84.847770690918,
    "a": 4.79234743118286,
    "b": -4.45399904251099,
    "C": 6.54253005981445,
    "h": 317.095672607422,
    "CMY_C": 0.1472994685173,
    "CMY_M": 0.17882972955704,
    "CMY_Y": 0.14254015684128,
    "CMYK_C": 0.00555047765374,
    "CMYK_M": 0.04232218489051,
    "CMYK_Y": 0,
    "CMYK_K": 0.14254015684128
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09458",
    "Farbtonhilfsbezeichnung": "X0.06.70",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "186",
    "Bcolor": "204",
    "Y": 51.5615348815918,
    "L": 77.0179138183594,
    "a": 7.83949851989746,
    "b": -8.13324356079102,
    "C": 11.2963438034058,
    "h": 313.946441650391,
    "CMY_C": 0.22252249717712,
    "CMY_M": 0.27004396915436,
    "CMY_Y": 0.20105051994324,
    "CMYK_C": 0.02687526308,
    "CMYK_M": 0.08635520935059,
    "CMYK_Y": 0,
    "CMYK_K": 0.20105051994324
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09459",
    "Farbtonhilfsbezeichnung": "W9.10.56",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "148",
    "Bcolor": "174",
    "Y": 32.3024673461914,
    "L": 63.5920906066895,
    "a": 10.9889430999756,
    "b": -11.7491855621338,
    "C": 16.0872688293457,
    "h": 313.085052490234,
    "CMY_C": 0.35528272390366,
    "CMY_M": 0.41780483722687,
    "CMY_Y": 0.31884241104126,
    "CMYK_C": 0.05349762365222,
    "CMYK_M": 0.14528565108776,
    "CMYK_Y": 0,
    "CMYK_K": 0.31884241104126
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09460",
    "Farbtonhilfsbezeichnung": "X0.16.43",
    "Farbtonklasse": "02",
    "Rcolor": "137",
    "Gcolor": "116",
    "Bcolor": "148",
    "Y": 19.9625759124756,
    "L": 51.7948722839355,
    "a": 14.6354284286499,
    "b": -14.9389133453369,
    "C": 20.9133186340332,
    "h": 314.412078857422,
    "CMY_C": 0.46279031038284,
    "CMY_M": 0.54482316970825,
    "CMY_Y": 0.41948157548904,
    "CMYK_C": 0.07460355013609,
    "CMYK_M": 0.21591320633888,
    "CMYK_Y": 0,
    "CMYK_K": 0.41948157548904
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09461",
    "Farbtonhilfsbezeichnung": "X2.31.24",
    "Farbtonklasse": "04",
    "Rcolor": "105",
    "Gcolor": "75",
    "Bcolor": "116",
    "Y": 9.26271533966064,
    "L": 36.4852676391602,
    "a": 21.2575492858887,
    "b": -19.4104461669922,
    "C": 28.7862606048584,
    "h": 317.600524902344,
    "CMY_C": 0.58800828456879,
    "CMY_M": 0.70716905593872,
    "CMY_Y": 0.5438084602356,
    "CMYK_C": 0.09688874334097,
    "CMYK_M": 0.35809651017189,
    "CMYK_Y": 0,
    "CMYK_K": 0.5438084602356
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09462",
    "Farbtonhilfsbezeichnung": "X0.22.27",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "82",
    "Bcolor": "114",
    "Y": 10.0812768936157,
    "L": 37.987907409668,
    "a": 15.5653066635132,
    "b": -15.8302335739136,
    "C": 22.2007904052734,
    "h": 314.516540527344,
    "CMY_C": 0.59728842973709,
    "CMY_M": 0.67944300174713,
    "CMY_Y": 0.55195581912994,
    "CMYK_C": 0.10117888450623,
    "CMYK_M": 0.28454154729843,
    "CMYK_Y": 0,
    "CMYK_K": 0.55195581912994
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09463",
    "Farbtonhilfsbezeichnung": "XN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "220",
    "Bcolor": "222",
    "Y": 72.2886352539063,
    "L": 88.1073379516602,
    "a": 1.46691787242889,
    "b": -1.2428959608078,
    "C": 1.92266440391541,
    "h": 319.725921630859,
    "CMY_C": 0.12606573104858,
    "CMY_M": 0.13588482141495,
    "CMY_Y": 0.13064193725586,
    "CMYK_C": 0,
    "CMYK_M": 0.01123550254852,
    "CMYK_Y": 0.00523632764816,
    "CMYK_K": 0.12606573104858
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09464",
    "Farbtonhilfsbezeichnung": "W9.03.68",
    "Farbtonklasse": "01",
    "Rcolor": "190",
    "Gcolor": "184",
    "Bcolor": "192",
    "Y": 48.8965835571289,
    "L": 75.3869476318359,
    "a": 3.9131076335907,
    "b": -4.05185317993164,
    "C": 5.63293218612671,
    "h": 314.002044677734,
    "CMY_C": 0.2557618021965,
    "CMY_M": 0.27932000160217,
    "CMY_Y": 0.24819880723953,
    "CMYK_C": 0.01005983352661,
    "CMYK_M": 0.04139551147819,
    "CMYK_Y": 0,
    "CMYK_K": 0.24819880723953
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09465",
    "Farbtonhilfsbezeichnung": "W8.04.58",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "156",
    "Bcolor": "168",
    "Y": 34.4603881835938,
    "L": 65.3263702392578,
    "a": 5.05847549438477,
    "b": -6.11926651000977,
    "C": 7.93937015533447,
    "h": 309.578735351563,
    "CMY_C": 0.36100286245346,
    "CMY_M": 0.38745337724686,
    "CMY_Y": 0.34010308980942,
    "CMYK_C": 0.03167127072811,
    "CMYK_M": 0.07175406813622,
    "CMYK_Y": 0,
    "CMYK_K": 0.34010308980942
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09466",
    "Farbtonhilfsbezeichnung": "W9.10.32",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "97",
    "Bcolor": "113",
    "Y": 12.8854303359985,
    "L": 42.5901069641113,
    "a": 7.48508930206299,
    "b": -8.2455415725708,
    "C": 11.1362257003784,
    "h": 312.232360839844,
    "CMY_C": 0.58064061403275,
    "CMY_M": 0.61927527189255,
    "CMY_Y": 0.5556765794754,
    "CMYK_C": 0.05618437752128,
    "CMYK_M": 0.14313603937626,
    "CMYK_Y": 0,
    "CMYK_K": 0.5556765794754
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09467",
    "Farbtonhilfsbezeichnung": "XN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "207",
    "Bcolor": "212",
    "Y": 63.7135391235352,
    "L": 83.8163986206055,
    "a": 3.12587761878967,
    "b": -2.66704034805298,
    "C": 4.1090407371521,
    "h": 319.528747558594,
    "CMY_C": 0.16538828611374,
    "CMY_M": 0.18664389848709,
    "CMY_Y": 0.16706031560898,
    "CMYK_C": 0,
    "CMYK_M": 0.02546766586602,
    "CMYK_Y": 0.00200336216949,
    "CMYK_K": 0.16538828611374
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09468",
    "Farbtonhilfsbezeichnung": "X5.04.69",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "183",
    "Bcolor": "193",
    "Y": 48.7136459350586,
    "L": 75.272834777832,
    "a": 5.03327894210815,
    "b": -4.69852352142334,
    "C": 6.88549327850342,
    "h": 316.970092773438,
    "CMY_C": 0.25073158740997,
    "CMY_M": 0.28300410509109,
    "CMY_Y": 0.24468249082565,
    "CMYK_C": 0.00800868030638,
    "CMYK_M": 0.05073576793075,
    "CMYK_Y": 0,
    "CMYK_K": 0.24468249082565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09469",
    "Farbtonhilfsbezeichnung": "X4.06.55",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "147",
    "Bcolor": "162",
    "Y": 30.8617763519287,
    "L": 62.3907737731934,
    "a": 7.35622644424438,
    "b": -6.74775266647339,
    "C": 9.98229598999023,
    "h": 317.470306396484,
    "CMY_C": 0.37705188989639,
    "CMY_M": 0.42297518253326,
    "CMY_Y": 0.36610502004623,
    "CMYK_C": 0.01726921647787,
    "CMYK_M": 0.08971543610096,
    "CMYK_Y": 0,
    "CMYK_K": 0.36610502004623
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09470",
    "Farbtonhilfsbezeichnung": "X5.10.40",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "113",
    "Bcolor": "129",
    "Y": 17.8483657836914,
    "L": 49.3116760253906,
    "a": 9.00210762023926,
    "b": -7.30277442932129,
    "C": 11.5917406082153,
    "h": 320.950012207031,
    "CMY_C": 0.50110173225403,
    "CMY_M": 0.5580358505249,
    "CMY_Y": 0.49533903598785,
    "CMYK_C": 0.01141894608736,
    "CMYK_M": 0.12423551082611,
    "CMYK_Y": 0,
    "CMYK_K": 0.49533903598785
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09471",
    "Farbtonhilfsbezeichnung": "Y0.13.21",
    "Farbtonklasse": "04",
    "Rcolor": "90",
    "Gcolor": "72",
    "Bcolor": "85",
    "Y": 7.53142404556274,
    "L": 32.9873199462891,
    "a": 10.1360626220703,
    "b": -5.34404420852661,
    "C": 11.4585590362549,
    "h": 332.200408935547,
    "CMY_C": 0.64723098278046,
    "CMY_M": 0.71577113866806,
    "CMY_Y": 0.66479158401489,
    "CMYK_C": 0,
    "CMYK_M": 0.19429187476635,
    "CMYK_Y": 0.04977931827307,
    "CMYK_K": 0.64723098278046
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09472",
    "Farbtonhilfsbezeichnung": "YN.00.86",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "233",
    "Bcolor": "232",
    "Y": 81.7460861206055,
    "L": 92.4626770019531,
    "a": 1.66743946075439,
    "b": -0.24696378409863,
    "C": 1.68562912940979,
    "h": 351.5751953125,
    "CMY_C": 0.0725240111351,
    "CMY_M": 0.08821356296539,
    "CMY_Y": 0.0898152589798,
    "CMYK_C": 0,
    "CMYK_M": 0.01691639609635,
    "CMYK_Y": 0.01864333823323,
    "CMYK_K": 0.0725240111351
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09473",
    "Farbtonhilfsbezeichnung": "Y0.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "219",
    "Bcolor": "224",
    "Y": 72.3906707763672,
    "L": 88.1562957763672,
    "a": 4.71802711486816,
    "b": -2.08977580070496,
    "C": 5.1601300239563,
    "h": 336.109802246094,
    "CMY_C": 0.10311931371689,
    "CMY_M": 0.14294230937958,
    "CMY_Y": 0.12343776226044,
    "CMYK_C": 0,
    "CMYK_M": 0.04440166428685,
    "CMYK_Y": 0.02265457250178,
    "CMYK_K": 0.10311931371689
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09474",
    "Farbtonhilfsbezeichnung": "X5.03.78",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "208",
    "Bcolor": "217",
    "Y": 65.4002685546875,
    "L": 84.6895751953125,
    "a": 5.73405599594116,
    "b": -3.80135178565979,
    "C": 6.87965631484985,
    "h": 326.457885742188,
    "CMY_C": 0.13957434892654,
    "CMY_M": 0.18305569887161,
    "CMY_Y": 0.14890474081039,
    "CMYK_C": 0,
    "CMYK_M": 0.05053469911218,
    "CMYK_Y": 0.01084392610937,
    "CMYK_K": 0.13957434892654
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09475",
    "Farbtonhilfsbezeichnung": "X5.07.71",
    "Farbtonklasse": "02",
    "Rcolor": "201",
    "Gcolor": "185",
    "Bcolor": "201",
    "Y": 51.2251243591309,
    "L": 76.8151779174805,
    "a": 9.10660457611084,
    "b": -6.98278617858887,
    "C": 11.475606918335,
    "h": 322.519622802734,
    "CMY_C": 0.21130353212357,
    "CMY_M": 0.27570182085037,
    "CMY_Y": 0.21129304170609,
    "CMYK_C": 1.330077976e-05,
    "CMYK_M": 0.08166376501322,
    "CMYK_Y": 0,
    "CMYK_K": 0.21129304170609
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09476",
    "Farbtonhilfsbezeichnung": "X5.11.59",
    "Farbtonklasse": "02",
    "Rcolor": "174",
    "Gcolor": "153",
    "Bcolor": "176",
    "Y": 34.7554969787598,
    "L": 65.557861328125,
    "a": 12.5024499893188,
    "b": -9.93473434448242,
    "C": 15.9690389633179,
    "h": 321.528533935547,
    "CMY_C": 0.31754785776138,
    "CMY_M": 0.40186315774918,
    "CMY_Y": 0.31043344736099,
    "CMYK_C": 0.01031722128391,
    "CMYK_M": 0.13259011507034,
    "CMYK_Y": 0,
    "CMYK_K": 0.31043344736099
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09477",
    "Farbtonhilfsbezeichnung": "X5.19.37",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "100",
    "Bcolor": "130",
    "Y": 15.1988687515259,
    "L": 45.9053802490234,
    "a": 17.2547588348389,
    "b": -13.2295980453491,
    "C": 21.742790222168,
    "h": 322.521820068359,
    "CMY_C": 0.49954897165298,
    "CMY_M": 0.60963523387909,
    "CMY_Y": 0.4899697303772,
    "CMYK_C": 0.01878171041608,
    "CMYK_M": 0.23462431132793,
    "CMYK_Y": 0,
    "CMYK_K": 0.4899697303772
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09478",
    "Farbtonhilfsbezeichnung": "X7.04.83",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "221",
    "Bcolor": "231",
    "Y": 74.9179229736328,
    "L": 89.3545379638672,
    "a": 6.95603132247925,
    "b": -4.44878578186035,
    "C": 8.25700092315674,
    "h": 327.398712158203,
    "CMY_C": 0.08048802614212,
    "CMY_M": 0.13450145721436,
    "CMY_Y": 0.09253066778183,
    "CMYK_C": 0,
    "CMYK_M": 0.05874141305685,
    "CMYK_Y": 0.01309677492827,
    "CMYK_K": 0.08048802614212
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09479",
    "Farbtonhilfsbezeichnung": "X6.06.80",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "210",
    "Bcolor": "227",
    "Y": 68.1255722045898,
    "L": 86.0691986083984,
    "a": 9.97692203521729,
    "b": -7.12582683563232,
    "C": 12.2603578567505,
    "h": 324.464385986328,
    "CMY_C": 0.10326319932938,
    "CMY_M": 0.17747795581818,
    "CMY_Y": 0.1089072227478,
    "CMYK_C": 0,
    "CMYK_M": 0.08276091516018,
    "CMYK_Y": 0.00629395758733,
    "CMYK_K": 0.10326319932938
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09480",
    "Farbtonhilfsbezeichnung": "X4.09.76",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "198",
    "Bcolor": "222",
    "Y": 61.0524101257324,
    "L": 82.4069137573242,
    "a": 13.0557737350464,
    "b": -9.95717525482178,
    "C": 16.4194564819336,
    "h": 322.668518066406,
    "CMY_C": 0.13054811954498,
    "CMY_M": 0.22443169355392,
    "CMY_Y": 0.12837183475494,
    "CMYK_C": 0.00249680411071,
    "CMYK_M": 0.11020738631487,
    "CMYK_Y": 0,
    "CMYK_K": 0.12837183475494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09481",
    "Farbtonhilfsbezeichnung": "X4.11.72",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "185",
    "Bcolor": "216",
    "Y": 53.7306976318359,
    "L": 78.304443359375,
    "a": 15.9758758544922,
    "b": -12.7889671325684,
    "C": 20.4642677307129,
    "h": 321.322113037109,
    "CMY_C": 0.16407555341721,
    "CMY_M": 0.27540719509125,
    "CMY_Y": 0.15273135900497,
    "CMYK_C": 0.01338913477957,
    "CMYK_M": 0.14478977024555,
    "CMYK_Y": 0,
    "CMYK_K": 0.15273135900497
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09482",
    "Farbtonhilfsbezeichnung": "X4.19.59",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "148",
    "Bcolor": "193",
    "Y": 35.6180801391602,
    "L": 66.2270736694336,
    "a": 23.1895065307617,
    "b": -18.3586616516113,
    "C": 29.5769119262695,
    "h": 321.632049560547,
    "CMY_C": 0.26372516155243,
    "CMY_M": 0.4203879237175,
    "CMY_Y": 0.24381321668625,
    "CMYK_C": 0.02633204497397,
    "CMYK_M": 0.23350673913956,
    "CMYK_Y": 0,
    "CMYK_K": 0.24381321668625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09483",
    "Farbtonhilfsbezeichnung": "X6.22.46",
    "Farbtonklasse": "03",
    "Rcolor": "155",
    "Gcolor": "117",
    "Bcolor": "158",
    "Y": 22.2658977508545,
    "L": 54.3079948425293,
    "a": 22.3883819580078,
    "b": -16.6767292022705,
    "C": 27.9168930053711,
    "h": 323.318206787109,
    "CMY_C": 0.39065343141556,
    "CMY_M": 0.53989237546921,
    "CMY_Y": 0.3812221288681,
    "CMYK_C": 0.01524182222784,
    "CMYK_M": 0.25642520189285,
    "CMYK_Y": 0,
    "CMYK_K": 0.3812221288681
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09484",
    "Farbtonhilfsbezeichnung": "X7.30.21",
    "Farbtonklasse": "04",
    "Rcolor": "103",
    "Gcolor": "69",
    "Bcolor": "103",
    "Y": 8.07510566711426,
    "L": 34.1388130187988,
    "a": 21.2529277801514,
    "b": -14.4382925033569,
    "C": 25.6934089660645,
    "h": 325.8095703125,
    "CMY_C": 0.59565281867981,
    "CMY_M": 0.73080635070801,
    "CMY_Y": 0.59732830524445,
    "CMYK_C": 0,
    "CMYK_M": 0.33425119519234,
    "CMYK_Y": 0.00414368323982,
    "CMYK_K": 0.59565281867981
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09485",
    "Farbtonhilfsbezeichnung": "Y0.05.79",
    "Farbtonklasse": "02",
    "Rcolor": "227",
    "Gcolor": "210",
    "Bcolor": "221",
    "Y": 67.4585647583008,
    "L": 85.734992980957,
    "a": 8.1502799987793,
    "b": -4.15131044387817,
    "C": 9.14660835266113,
    "h": 333.008178710938,
    "CMY_C": 0.11078917980194,
    "CMY_M": 0.17746949195862,
    "CMY_Y": 0.13454800844193,
    "CMYK_C": 0,
    "CMYK_M": 0.07498819380999,
    "CMYK_Y": 0.02671900577843,
    "CMYK_K": 0.11078917980194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09486",
    "Farbtonhilfsbezeichnung": "Y1.12.59",
    "Farbtonklasse": "03",
    "Rcolor": "184",
    "Gcolor": "152",
    "Bcolor": "176",
    "Y": 35.9407119750977,
    "L": 66.4746017456055,
    "a": 16.2465229034424,
    "b": -8.80872535705566,
    "C": 18.4808864593506,
    "h": 331.533843994141,
    "CMY_C": 0.27802842855453,
    "CMY_M": 0.4023442864418,
    "CMY_Y": 0.30807739496231,
    "CMYK_C": 0,
    "CMYK_M": 0.17218941450119,
    "CMYK_Y": 0.04162070527673,
    "CMYK_K": 0.27802842855453
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09487",
    "Farbtonhilfsbezeichnung": "Y1.18.47",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "121",
    "Bcolor": "151",
    "Y": 23.2555027008057,
    "L": 55.3345489501953,
    "a": 20.6003322601318,
    "b": -10.8322830200195,
    "C": 23.2747077941895,
    "h": 332.263244628906,
    "CMY_C": 0.37362593412399,
    "CMY_M": 0.52681291103363,
    "CMY_Y": 0.40977746248245,
    "CMYK_C": 0,
    "CMYK_M": 0.24456149339676,
    "CMYK_Y": 0.05771555751562,
    "CMYK_K": 0.37362593412399
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09488",
    "Farbtonhilfsbezeichnung": "Y1.22.29",
    "Farbtonklasse": "04",
    "Rcolor": "121",
    "Gcolor": "85",
    "Bcolor": "112",
    "Y": 11.6537036895752,
    "L": 40.6603584289551,
    "a": 20.0904483795166,
    "b": -10.1928510665894,
    "C": 22.5282115936279,
    "h": 333.09912109375,
    "CMY_C": 0.52598714828491,
    "CMY_M": 0.66837787628174,
    "CMY_Y": 0.56076401472092,
    "CMYK_C": 0,
    "CMYK_M": 0.30039423704147,
    "CMYK_Y": 0.07336692512035,
    "CMYK_K": 0.52598714828491
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09489",
    "Farbtonhilfsbezeichnung": "Y0.15.70",
    "Farbtonklasse": "03",
    "Rcolor": "221",
    "Gcolor": "177",
    "Bcolor": "211",
    "Y": 51.4562492370605,
    "L": 76.9545593261719,
    "a": 21.9042015075684,
    "b": -12.2480401992798,
    "C": 25.0959873199463,
    "h": 330.787658691406,
    "CMY_C": 0.13477653264999,
    "CMY_M": 0.30615991353989,
    "CMY_Y": 0.17062532901764,
    "CMYK_C": 0,
    "CMYK_M": 0.19807989895344,
    "CMYK_Y": 0.04143299162388,
    "CMYK_K": 0.13477653264999
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09490",
    "Farbtonhilfsbezeichnung": "Y0.18.66",
    "Farbtonklasse": "03",
    "Rcolor": "214",
    "Gcolor": "164",
    "Bcolor": "204",
    "Y": 45.2156562805176,
    "L": 73.0336685180664,
    "a": 25.2966823577881,
    "b": -14.3248414993286,
    "C": 29.0710029602051,
    "h": 330.478271484375,
    "CMY_C": 0.16144740581512,
    "CMY_M": 0.35670655965805,
    "CMY_Y": 0.19818925857544,
    "CMYK_C": 0,
    "CMYK_M": 0.23285260796547,
    "CMYK_Y": 0.04381579905748,
    "CMYK_K": 0.16144740581512
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09491",
    "Farbtonhilfsbezeichnung": "Y1.22.59",
    "Farbtonklasse": "03",
    "Rcolor": "202",
    "Gcolor": "143",
    "Bcolor": "190",
    "Y": 35.9229545593262,
    "L": 66.4610137939453,
    "a": 29.9415798187256,
    "b": -16.4677391052246,
    "C": 34.1714019775391,
    "h": 331.189392089844,
    "CMY_C": 0.20966362953186,
    "CMY_M": 0.43849223852158,
    "CMY_Y": 0.25358915328979,
    "CMYK_C": 0,
    "CMYK_M": 0.28953319787979,
    "CMYK_Y": 0.05557826533914,
    "CMYK_K": 0.20966362953186
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09492",
    "Farbtonhilfsbezeichnung": "Y2.28.50",
    "Farbtonklasse": "03",
    "Rcolor": "187",
    "Gcolor": "118",
    "Bcolor": "169",
    "Y": 26.3477268218994,
    "L": 58.3656425476074,
    "a": 35.162899017334,
    "b": -16.7497634887695,
    "C": 38.9484786987305,
    "h": 334.529327392578,
    "CMY_C": 0.26631635427475,
    "CMY_M": 0.53811550140381,
    "CMY_Y": 0.33693116903305,
    "CMYK_C": 0,
    "CMYK_M": 0.3704582452774,
    "CMYK_Y": 0.09624695032835,
    "CMYK_K": 0.26631635427475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09493",
    "Farbtonhilfsbezeichnung": "Y3.31.45",
    "Farbtonklasse": "04",
    "Rcolor": "175",
    "Gcolor": "103",
    "Bcolor": "155",
    "Y": 21.2711868286133,
    "L": 53.2450218200684,
    "a": 36.7091407775879,
    "b": -16.4778633117676,
    "C": 40.2378044128418,
    "h": 335.825805664063,
    "CMY_C": 0.31217116117477,
    "CMY_M": 0.59523171186447,
    "CMY_Y": 0.39189291000366,
    "CMYK_C": 0,
    "CMYK_M": 0.41152760386467,
    "CMYK_Y": 0.11590346693993,
    "CMYK_K": 0.31217116117477
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09494",
    "Farbtonhilfsbezeichnung": "Y4.04.83",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "220",
    "Bcolor": "230",
    "Y": 75.2943725585938,
    "L": 89.5307006835938,
    "a": 8.16790676116943,
    "b": -3.59815526008606,
    "C": 8.92532444000244,
    "h": 336.225372314453,
    "CMY_C": 0.06636881828308,
    "CMY_M": 0.13585007190704,
    "CMY_Y": 0.09667521715164,
    "CMYK_C": 0,
    "CMYK_M": 0.07442045211792,
    "CMYK_Y": 0.03246078267694,
    "CMYK_K": 0.06636881828308
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09495",
    "Farbtonhilfsbezeichnung": "Y2.10.77",
    "Farbtonklasse": "02",
    "Rcolor": "233",
    "Gcolor": "196",
    "Bcolor": "219",
    "Y": 61.8913040161133,
    "L": 82.855583190918,
    "a": 17.2106647491455,
    "b": -7.45468997955322,
    "C": 18.7557830810547,
    "h": 336.580444335938,
    "CMY_C": 0.0869272351265,
    "CMY_M": 0.23135828971863,
    "CMY_Y": 0.14099246263504,
    "CMYK_C": 0,
    "CMYK_M": 0.15818132460117,
    "CMYK_Y": 0.05921239778399,
    "CMYK_K": 0.0869272351265
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09496",
    "Farbtonhilfsbezeichnung": "Y3.14.72",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "183",
    "Bcolor": "214",
    "Y": 55.604808807373,
    "L": 79.3883743286133,
    "a": 21.8924522399902,
    "b": -10.1216678619385,
    "C": 24.1190299987793,
    "h": 335.187194824219,
    "CMY_C": 0.10097324848175,
    "CMY_M": 0.28078484535217,
    "CMY_Y": 0.15920174121857,
    "CMYK_C": 0,
    "CMYK_M": 0.20000694692135,
    "CMYK_Y": 0.06476836651564,
    "CMYK_K": 0.10097324848175
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09497",
    "Farbtonhilfsbezeichnung": "Y5.26.58",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "135",
    "Bcolor": "183",
    "Y": 34.4601593017578,
    "L": 65.3261871337891,
    "a": 35.5073738098145,
    "b": -14.1790685653687,
    "C": 38.2337493896484,
    "h": 338.231811523438,
    "CMY_C": 0.17997425794601,
    "CMY_M": 0.46879953145981,
    "CMY_Y": 0.2807981967926,
    "CMYK_C": 0,
    "CMYK_M": 0.35221487283707,
    "CMYK_Y": 0.12295216321945,
    "CMYK_K": 0.17997425794601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09498",
    "Farbtonhilfsbezeichnung": "Y7.33.48",
    "Farbtonklasse": "03",
    "Rcolor": "194",
    "Gcolor": "105",
    "Bcolor": "158",
    "Y": 24.0240669250488,
    "L": 56.1118850708008,
    "a": 42.4416809082031,
    "b": -13.6005754470825,
    "C": 44.5676116943359,
    "h": 342.231781005859,
    "CMY_C": 0.23960727453232,
    "CMY_M": 0.58825051784515,
    "CMY_Y": 0.38060289621353,
    "CMYK_C": 0,
    "CMYK_M": 0.45850417017937,
    "CMYK_Y": 0.18542474508286,
    "CMYK_K": 0.23960727453232
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09499",
    "Farbtonhilfsbezeichnung": "Y5.34.38",
    "Farbtonklasse": "04",
    "Rcolor": "160",
    "Gcolor": "87",
    "Bcolor": "135",
    "Y": 15.9373998641968,
    "L": 46.8922538757324,
    "a": 36.8954658508301,
    "b": -14.187421798706,
    "C": 39.5292091369629,
    "h": 338.966735839844,
    "CMY_C": 0.37399166822433,
    "CMY_M": 0.66017371416092,
    "CMY_Y": 0.47164332866669,
    "CMYK_C": 0,
    "CMYK_M": 0.45715373754501,
    "CMYK_Y": 0.15599098801613,
    "CMYK_K": 0.37399166822433
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09500",
    "Farbtonhilfsbezeichnung": "Y1.07.81",
    "Farbtonklasse": "02",
    "Rcolor": "234",
    "Gcolor": "210",
    "Bcolor": "225",
    "Y": 69.1256790161133,
    "L": 86.5662460327148,
    "a": 11.1367893218994,
    "b": -5.12341642379761,
    "C": 12.258770942688,
    "h": 335.295471191406,
    "CMY_C": 0.08229106664658,
    "CMY_M": 0.17561721801758,
    "CMY_Y": 0.11788576841354,
    "CMYK_C": 0,
    "CMYK_M": 0.10169471800327,
    "CMYK_Y": 0.03878648206592,
    "CMYK_K": 0.08229106664658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09501",
    "Farbtonhilfsbezeichnung": "Y2.12.74",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "187",
    "Bcolor": "216",
    "Y": 57.4383087158203,
    "L": 80.4254913330078,
    "a": 20.0513725280762,
    "b": -9.40512275695801,
    "C": 22.1475486755371,
    "h": 334.871002197266,
    "CMY_C": 0.100062251091,
    "CMY_M": 0.26474446058273,
    "CMY_Y": 0.15322405099869,
    "CMYK_C": 0,
    "CMYK_M": 0.18299289047718,
    "CMYK_Y": 0.05907275155187,
    "CMYK_K": 0.100062251091
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09502",
    "Farbtonhilfsbezeichnung": "Y7.18.60",
    "Farbtonklasse": "03",
    "Rcolor": "204",
    "Gcolor": "149",
    "Bcolor": "179",
    "Y": 37.7159194946289,
    "L": 67.8107147216797,
    "a": 25.5191097259521,
    "b": -7.96697950363159,
    "C": 26.7338314056396,
    "h": 342.661804199219,
    "CMY_C": 0.19911646842957,
    "CMY_M": 0.41439294815063,
    "CMY_Y": 0.29858422279358,
    "CMYK_C": 0,
    "CMYK_M": 0.26879873871803,
    "CMYK_Y": 0.12419752776623,
    "CMYK_K": 0.19911646842957
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09503",
    "Farbtonhilfsbezeichnung": "Y7.27.43",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "104",
    "Bcolor": "143",
    "Y": 20.4535522460938,
    "L": 52.3461761474609,
    "a": 31.9013710021973,
    "b": -10.6508750915527,
    "C": 33.6324043273926,
    "h": 341.537445068359,
    "CMY_C": 0.33541071414948,
    "CMY_M": 0.5903987288475,
    "CMY_Y": 0.44010561704636,
    "CMYK_C": 0,
    "CMYK_M": 0.38367760181427,
    "CMYK_Y": 0.15753324329853,
    "CMYK_K": 0.33541071414948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09504",
    "Farbtonhilfsbezeichnung": "Y7.30.40",
    "Farbtonklasse": "03",
    "Rcolor": "164",
    "Gcolor": "95",
    "Bcolor": "136",
    "Y": 17.8452606201172,
    "L": 49.3078842163086,
    "a": 33.9164886474609,
    "b": -11.1949806213379,
    "C": 35.7163238525391,
    "h": 341.733245849609,
    "CMY_C": 0.35774803161621,
    "CMY_M": 0.62705183029175,
    "CMY_Y": 0.4670404791832,
    "CMYK_C": 0,
    "CMYK_M": 0.41931176185608,
    "CMYK_Y": 0.17017066478729,
    "CMYK_K": 0.35774803161621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09505",
    "Farbtonhilfsbezeichnung": "Y8.35.26",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "67",
    "Bcolor": "103",
    "Y": 9.7121696472168,
    "L": 37.3208122253418,
    "a": 31.9276294708252,
    "b": -9.44368457794189,
    "C": 33.294994354248,
    "h": 343.522613525391,
    "CMY_C": 0.49163520336151,
    "CMY_M": 0.73714351654053,
    "CMY_Y": 0.59630298614502,
    "CMYK_C": 0,
    "CMYK_M": 0.48293727636337,
    "CMYK_Y": 0.20589108765125,
    "CMYK_K": 0.49163520336151
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09506",
    "Farbtonhilfsbezeichnung": "Z0.04.84",
    "Farbtonklasse": "02",
    "Rcolor": "243",
    "Gcolor": "222",
    "Bcolor": "231",
    "Y": 77.2538528442383,
    "L": 90.4383239746094,
    "a": 8.83770275115967,
    "b": -2.49948453903198,
    "C": 9.18435668945313,
    "h": 344.2080078125,
    "CMY_C": 0.04745560884476,
    "CMY_M": 0.12782174348831,
    "CMY_Y": 0.09461450576782,
    "CMYK_C": 0,
    "CMYK_M": 0.08436996489763,
    "CMYK_Y": 0.04950834438205,
    "CMYK_K": 0.04745560884476
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09507",
    "Farbtonhilfsbezeichnung": "Y2.07.80",
    "Farbtonklasse": "02",
    "Rcolor": "236",
    "Gcolor": "210",
    "Bcolor": "226",
    "Y": 69.5965118408203,
    "L": 86.798583984375,
    "a": 12.1161756515503,
    "b": -5.56972169876099,
    "C": 13.3350486755371,
    "h": 335.312072753906,
    "CMY_C": 0.07384842634201,
    "CMY_M": 0.17545157670975,
    "CMY_Y": 0.11192446947098,
    "CMYK_C": 0,
    "CMYK_M": 0.10970466583967,
    "CMYK_Y": 0.04111210629344,
    "CMYK_K": 0.07384842634201
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09508",
    "Farbtonhilfsbezeichnung": "Y7.12.75",
    "Farbtonklasse": "03",
    "Rcolor": "233",
    "Gcolor": "190",
    "Bcolor": "213",
    "Y": 58.8800506591797,
    "L": 81.2256164550781,
    "a": 19.5862369537354,
    "b": -6.51172256469727,
    "C": 20.6403293609619,
    "h": 341.609893798828,
    "CMY_C": 0.08547258377075,
    "CMY_M": 0.2557914853096,
    "CMY_Y": 0.16533815860748,
    "CMYK_C": 0,
    "CMYK_M": 0.18623706698418,
    "CMYK_Y": 0.08732988685369,
    "CMYK_K": 0.08547258377075
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09509",
    "Farbtonhilfsbezeichnung": "Z1.37.40",
    "Farbtonklasse": "04",
    "Rcolor": "180",
    "Gcolor": "86",
    "Bcolor": "134",
    "Y": 18.0686893463135,
    "L": 49.5793151855469,
    "a": 44.3255043029785,
    "b": -9.28756523132324,
    "C": 45.2880706787109,
    "h": 348.165954589844,
    "CMY_C": 0.29221874475479,
    "CMY_M": 0.66429698467255,
    "CMY_Y": 0.47530889511108,
    "CMYK_C": 0,
    "CMYK_M": 0.52569663524628,
    "CMYK_Y": 0.25868183374405,
    "CMYK_K": 0.29221874475479
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09510",
    "Farbtonhilfsbezeichnung": "Z0.04.79",
    "Farbtonklasse": "02",
    "Rcolor": "225",
    "Gcolor": "209",
    "Bcolor": "215",
    "Y": 66.4629364013672,
    "L": 85.2320022583008,
    "a": 7.06961536407471,
    "b": -1.84126436710358,
    "C": 7.30545806884766,
    "h": 345.401763916016,
    "CMY_C": 0.11695367097855,
    "CMY_M": 0.18098974227905,
    "CMY_Y": 0.15706062316895,
    "CMYK_C": 0,
    "CMYK_M": 0.07251722365618,
    "CMYK_Y": 0.04541885480285,
    "CMYK_K": 0.11695367097855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09511",
    "Farbtonhilfsbezeichnung": "Y7.07.72",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "187",
    "Bcolor": "202",
    "Y": 54.3876342773438,
    "L": 78.6872253417969,
    "a": 12.4983949661255,
    "b": -4.33673667907715,
    "C": 13.2294054031372,
    "h": 340.864074707031,
    "CMY_C": 0.15746128559113,
    "CMY_M": 0.26499378681183,
    "CMY_Y": 0.20950865745544,
    "CMYK_C": 0,
    "CMYK_M": 0.12762914597988,
    "CMYK_Y": 0.06177445873618,
    "CMYK_K": 0.15746128559113
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09512",
    "Farbtonhilfsbezeichnung": "Y8.12.61",
    "Farbtonklasse": "03",
    "Rcolor": "196",
    "Gcolor": "155",
    "Bcolor": "177",
    "Y": 38.4498252868652,
    "L": 68.3508453369141,
    "a": 18.6966514587402,
    "b": -6.1116156578064,
    "C": 19.6701965332031,
    "h": 341.898315429688,
    "CMY_C": 0.23304373025894,
    "CMY_M": 0.39023315906525,
    "CMY_Y": 0.30664330720901,
    "CMYK_C": 0,
    "CMYK_M": 0.20495226979256,
    "CMYK_Y": 0.0959632024169,
    "CMYK_K": 0.23304373025894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09513",
    "Farbtonhilfsbezeichnung": "Y5.28.19",
    "Farbtonklasse": "04",
    "Rcolor": "106",
    "Gcolor": "64",
    "Bcolor": "90",
    "Y": 7.51830577850342,
    "L": 32.9588623046875,
    "a": 22.5619506835938,
    "b": -7.93706560134888,
    "C": 23.917329788208,
    "h": 340.61865234375,
    "CMY_C": 0.58306610584259,
    "CMY_M": 0.74784535169601,
    "CMY_Y": 0.64794832468033,
    "CMYK_C": 0,
    "CMYK_M": 0.39521673321724,
    "CMYK_Y": 0.15561752021313,
    "CMYK_K": 0.58306610584259
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09514",
    "Farbtonhilfsbezeichnung": "ZN.02.85",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "222",
    "Bcolor": "223",
    "Y": 74.7451629638672,
    "L": 89.2734909057617,
    "a": 3.79491138458252,
    "b": -0.20449471473694,
    "C": 3.80041718482971,
    "h": 356.915496826172,
    "CMY_C": 0.09148365259171,
    "CMY_M": 0.12887954711914,
    "CMY_Y": 0.12511664628983,
    "CMYK_C": 0,
    "CMYK_M": 0.04116149991751,
    "CMYK_Y": 0.03701968863606,
    "CMYK_K": 0.09148365259171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09515",
    "Farbtonhilfsbezeichnung": "Z0.03.80",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "209",
    "Bcolor": "214",
    "Y": 66.0390319824219,
    "L": 85.0163192749023,
    "a": 5.56693840026855,
    "b": -1.71608936786652,
    "C": 5.82544136047363,
    "h": 342.867340087891,
    "CMY_C": 0.13027983903885,
    "CMY_M": 0.17968845367432,
    "CMY_Y": 0.1605384349823,
    "CMYK_C": 0,
    "CMYK_M": 0.05680978298187,
    "CMYK_Y": 0.03479118645191,
    "CMYK_K": 0.13027983903885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09516",
    "Farbtonhilfsbezeichnung": "Y6.05.70",
    "Farbtonklasse": "02",
    "Rcolor": "204",
    "Gcolor": "185",
    "Bcolor": "196",
    "Y": 51.5896034240723,
    "L": 77.0347900390625,
    "a": 9.02721214294434,
    "b": -3.6465892791748,
    "C": 9.73592185974121,
    "h": 338.003509521484,
    "CMY_C": 0.19858384132385,
    "CMY_M": 0.27417516708374,
    "CMY_Y": 0.23272693157196,
    "CMYK_C": 0,
    "CMYK_M": 0.09432218968868,
    "CMYK_Y": 0.04260344803333,
    "CMYK_K": 0.19858384132385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09517",
    "Farbtonhilfsbezeichnung": "Y7.09.57",
    "Farbtonklasse": "03",
    "Rcolor": "178",
    "Gcolor": "150",
    "Bcolor": "165",
    "Y": 34.1017761230469,
    "L": 65.0432739257813,
    "a": 13.0253849029541,
    "b": -4.68894672393799,
    "C": 13.8436584472656,
    "h": 340.201873779297,
    "CMY_C": 0.30299586057663,
    "CMY_M": 0.410160779953,
    "CMY_Y": 0.35192114114761,
    "CMYK_C": 0,
    "CMYK_M": 0.15375076234341,
    "CMYK_Y": 0.07019367069006,
    "CMYK_K": 0.30299586057663
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09518",
    "Farbtonhilfsbezeichnung": "Y7.14.45",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "117",
    "Bcolor": "138",
    "Y": 21.2502174377441,
    "L": 53.2222633361816,
    "a": 17.6520767211914,
    "b": -6.68742418289185,
    "C": 18.8763732910156,
    "h": 339.2509765625,
    "CMY_C": 0.40285980701447,
    "CMY_M": 0.54127049446106,
    "CMY_Y": 0.45913589000702,
    "CMYK_C": 0,
    "CMYK_M": 0.23178926110268,
    "CMYK_Y": 0.09424266219139,
    "CMYK_K": 0.40285980701447
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09519",
    "Farbtonhilfsbezeichnung": "Y7.24.32",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "87",
    "Bcolor": "115",
    "Y": 13.1493644714356,
    "L": 42.9874420166016,
    "a": 24.046106338501,
    "b": -8.63641929626465,
    "C": 25.5500087738037,
    "h": 340.243713378906,
    "CMY_C": 0.47507071495056,
    "CMY_M": 0.65810072422028,
    "CMY_Y": 0.54743206501007,
    "CMYK_C": 0,
    "CMYK_M": 0.3486755490303,
    "CMYK_Y": 0.13784970343113,
    "CMYK_K": 0.47507071495056
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09520",
    "Farbtonhilfsbezeichnung": "Y7.17.34",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "95",
    "Bcolor": "114",
    "Y": 13.9212045669556,
    "L": 44.1197166442871,
    "a": 17.20827293396,
    "b": -6.30485200881958,
    "C": 18.3269157409668,
    "h": 339.8779296875,
    "CMY_C": 0.4981005191803,
    "CMY_M": 0.62899577617645,
    "CMY_Y": 0.55201935768127,
    "CMYK_C": 0,
    "CMYK_M": 0.26079973578453,
    "CMYK_Y": 0.1074295565486,
    "CMYK_K": 0.4981005191803
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09521",
    "Farbtonhilfsbezeichnung": "A0.03.78",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "206",
    "Bcolor": "208",
    "Y": 64.1351547241211,
    "L": 84.0360870361328,
    "a": 6.70914220809937,
    "b": 0.02239911071956,
    "C": 6.70917940139771,
    "h": 0.19128669798374,
    "CMY_C": 0.12699258327484,
    "CMY_M": 0.19373279809952,
    "CMY_Y": 0.18372583389282,
    "CMYK_C": 0,
    "CMYK_M": 0.07644861936569,
    "CMYK_Y": 0.06498599052429,
    "CMYK_K": 0.12699258327484
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09522",
    "Farbtonhilfsbezeichnung": "Z9.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "210",
    "Gcolor": "182",
    "Bcolor": "188",
    "Y": 50.804256439209,
    "L": 76.5602874755859,
    "a": 11.3241996765137,
    "b": 0.12370033562183,
    "C": 11.3248748779297,
    "h": 0.62584775686264,
    "CMY_C": 0.17588311433792,
    "CMY_M": 0.2861407995224,
    "CMY_Y": 0.26436370611191,
    "CMYK_C": 0,
    "CMYK_M": 0.13378889858723,
    "CMYK_Y": 0.10736412554979,
    "CMYK_K": 0.17588311433792
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09523",
    "Farbtonhilfsbezeichnung": "Z9.17.42",
    "Farbtonklasse": "03",
    "Rcolor": "154",
    "Gcolor": "109",
    "Bcolor": "122",
    "Y": 19.0997428894043,
    "L": 50.8036994934082,
    "a": 20.3635349273682,
    "b": -0.92714619636536,
    "C": 20.3846302032471,
    "h": 357.393127441406,
    "CMY_C": 0.39699333906174,
    "CMY_M": 0.57428067922592,
    "CMY_Y": 0.52076530456543,
    "CMYK_C": 0,
    "CMYK_M": 0.29400560259819,
    "CMYK_Y": 0.20525804162025,
    "CMYK_K": 0.39699333906174
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09524",
    "Farbtonhilfsbezeichnung": "Z3.21.24",
    "Farbtonklasse": "04",
    "Rcolor": "111",
    "Gcolor": "74",
    "Bcolor": "89",
    "Y": 8.99919700622559,
    "L": 35.9827499389648,
    "a": 18.2745800018311,
    "b": -2.86228370666504,
    "C": 18.4973773956299,
    "h": 351.098297119141,
    "CMY_C": 0.56520646810532,
    "CMY_M": 0.70950555801392,
    "CMY_Y": 0.65111541748047,
    "CMYK_C": 0,
    "CMYK_M": 0.33187955617905,
    "CMYK_Y": 0.19758561253548,
    "CMYK_K": 0.56520646810532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09525",
    "Farbtonhilfsbezeichnung": "Z5.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "219",
    "Bcolor": "223",
    "Y": 73.3227386474609,
    "L": 88.6014099121094,
    "a": 6.21304225921631,
    "b": -0.95906943082809,
    "C": 6.28662919998169,
    "h": 351.224853515625,
    "CMY_C": 0.08297473192215,
    "CMY_M": 0.14203882217407,
    "CMY_Y": 0.12663358449936,
    "CMYK_C": 0,
    "CMYK_M": 0.06440835446119,
    "CMYK_Y": 0.04760921373963,
    "CMYK_K": 0.08297473192215
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09526",
    "Farbtonhilfsbezeichnung": "Z4.05.78",
    "Farbtonklasse": "02",
    "Rcolor": "229",
    "Gcolor": "205",
    "Bcolor": "213",
    "Y": 65.2682418823242,
    "L": 84.6217727661133,
    "a": 9.95712184906006,
    "b": -1.43101024627686,
    "C": 10.0594263076782,
    "h": 351.821594238281,
    "CMY_C": 0.10100370645523,
    "CMY_M": 0.19503748416901,
    "CMY_Y": 0.16632050275803,
    "CMYK_C": 0,
    "CMYK_M": 0.10459862649441,
    "CMYK_Y": 0.07265524566174,
    "CMYK_K": 0.10100370645523
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09527",
    "Farbtonhilfsbezeichnung": "Z3.08.71",
    "Farbtonklasse": "03",
    "Rcolor": "216",
    "Gcolor": "182",
    "Bcolor": "195",
    "Y": 51.9090538024902,
    "L": 77.2264251708984,
    "a": 14.9069776535034,
    "b": -2.63000226020813,
    "C": 15.1372022628784,
    "h": 349.994415283203,
    "CMY_C": 0.15139502286911,
    "CMY_M": 0.28745013475418,
    "CMY_Y": 0.23711830377579,
    "CMYK_C": 0,
    "CMYK_M": 0.1603279709816,
    "CMYK_Y": 0.10101670771837,
    "CMYK_K": 0.15139502286911
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09528",
    "Farbtonhilfsbezeichnung": "Z3.13.63",
    "Farbtonklasse": "03",
    "Rcolor": "203",
    "Gcolor": "158",
    "Bcolor": "176",
    "Y": 40.1683464050293,
    "L": 69.5892639160156,
    "a": 20.1304759979248,
    "b": -3.79983377456665,
    "C": 20.4859657287598,
    "h": 349.310607910156,
    "CMY_C": 0.20345044136047,
    "CMY_M": 0.38194584846497,
    "CMY_Y": 0.30946040153503,
    "CMYK_C": 0,
    "CMYK_M": 0.22408574819565,
    "CMYK_Y": 0.13308645784855,
    "CMYK_K": 0.20345044136047
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09529",
    "Farbtonhilfsbezeichnung": "Z3.16.54",
    "Farbtonklasse": "03",
    "Rcolor": "183",
    "Gcolor": "134",
    "Bcolor": "155",
    "Y": 29.5451469421387,
    "L": 61.2597694396973,
    "a": 22.4113082885742,
    "b": -4.17980241775513,
    "C": 22.7977523803711,
    "h": 349.435485839844,
    "CMY_C": 0.2806441783905,
    "CMY_M": 0.47423541545868,
    "CMY_Y": 0.39336585998535,
    "CMYK_C": 0,
    "CMYK_M": 0.26911750435829,
    "CMYK_Y": 0.15669809281826,
    "CMYK_K": 0.2806441783905
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09530",
    "Farbtonhilfsbezeichnung": "Z3.21.46",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "113",
    "Bcolor": "137",
    "Y": 21.9624481201172,
    "L": 53.9871406555176,
    "a": 26.0490951538086,
    "b": -4.78285360336304,
    "C": 26.4845428466797,
    "h": 349.595855712891,
    "CMY_C": 0.33822202682495,
    "CMY_M": 0.55790686607361,
    "CMY_Y": 0.46292531490326,
    "CMYK_C": 0,
    "CMYK_M": 0.33196154236794,
    "CMYK_Y": 0.18843674659729,
    "CMYK_K": 0.33822202682495
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09531",
    "Farbtonhilfsbezeichnung": "Z3.29.29",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "78",
    "Bcolor": "103",
    "Y": 11.504566192627,
    "L": 40.4176177978516,
    "a": 26.8675308227539,
    "b": -4.54289579391479,
    "C": 27.2488918304443,
    "h": 350.402923583984,
    "CMY_C": 0.47631752490997,
    "CMY_M": 0.69260835647583,
    "CMY_Y": 0.59770053625107,
    "CMYK_C": 0,
    "CMYK_M": 0.41301903128624,
    "CMYK_Y": 0.23178742825985,
    "CMYK_K": 0.47631752490997
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09532",
    "Farbtonhilfsbezeichnung": "XN.01.88",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "232",
    "Bcolor": "233",
    "Y": 82.0137176513672,
    "L": 92.5809173583984,
    "a": 2.32042527198792,
    "b": -0.37883996963501,
    "C": 2.35114717483521,
    "h": 350.727508544922,
    "CMY_C": 0.06650865077972,
    "CMY_M": 0.08843177556992,
    "CMY_Y": 0.0874320268631,
    "CMYK_C": 0,
    "CMYK_M": 0.02348508685827,
    "CMYK_Y": 0.0224141087383,
    "CMYK_K": 0.06650865077972
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09533",
    "Farbtonhilfsbezeichnung": "Z4.06.81",
    "Farbtonklasse": "02",
    "Rcolor": "241",
    "Gcolor": "214",
    "Bcolor": "223",
    "Y": 72.1729888916016,
    "L": 88.0517883300781,
    "a": 11.3482522964478,
    "b": -1.69135534763336,
    "C": 11.4736003875732,
    "h": 351.522979736328,
    "CMY_C": 0.0530726313591,
    "CMY_M": 0.16088074445724,
    "CMY_Y": 0.12659418582916,
    "CMYK_C": 0,
    "CMYK_M": 0.11385045945644,
    "CMYK_Y": 0.07764223217964,
    "CMYK_K": 0.0530726313591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09534",
    "Farbtonhilfsbezeichnung": "Z4.12.73",
    "Farbtonklasse": "03",
    "Rcolor": "234",
    "Gcolor": "185",
    "Bcolor": "202",
    "Y": 56.452033996582,
    "L": 79.8703994750977,
    "a": 20.4910621643066,
    "b": -2.87101316452026,
    "C": 20.6912136077881,
    "h": 352.024169921875,
    "CMY_C": 0.08389335870743,
    "CMY_M": 0.27408480644226,
    "CMY_Y": 0.20610213279724,
    "CMYK_C": 0,
    "CMYK_M": 0.20760841667652,
    "CMYK_Y": 0.133400157094,
    "CMYK_K": 0.08389335870743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09535",
    "Farbtonhilfsbezeichnung": "Z5.16.68",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "166",
    "Bcolor": "190",
    "Y": 47.6501007080078,
    "L": 74.6036987304688,
    "a": 26.7231941223145,
    "b": -3.87394213676453,
    "C": 27.0025291442871,
    "h": 351.751556396484,
    "CMY_C": 0.10439586639404,
    "CMY_M": 0.34789377450943,
    "CMY_Y": 0.25475305318832,
    "CMYK_C": 0,
    "CMYK_M": 0.27188119292259,
    "CMYK_Y": 0.16788353025913,
    "CMYK_K": 0.10439586639404
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09536",
    "Farbtonhilfsbezeichnung": "Z3.26.49",
    "Farbtonklasse": "04",
    "Rcolor": "190",
    "Gcolor": "116",
    "Bcolor": "148",
    "Y": 25.4491176605225,
    "L": 57.510425567627,
    "a": 33.6310501098633,
    "b": -5.5101842880249,
    "C": 34.079460144043,
    "h": 350.695220947266,
    "CMY_C": 0.25656980276108,
    "CMY_M": 0.5460718870163,
    "CMY_Y": 0.42132073640823,
    "CMYK_C": 0,
    "CMYK_M": 0.38941395282745,
    "CMYK_Y": 0.22160914540291,
    "CMYK_K": 0.25656980276108
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09537",
    "Farbtonhilfsbezeichnung": "Y7.24.17",
    "Farbtonklasse": "04",
    "Rcolor": "99",
    "Gcolor": "64",
    "Bcolor": "83",
    "Y": 6.92370843887329,
    "L": 31.6325950622559,
    "a": 18.368803024292,
    "b": -5.50818014144897,
    "C": 19.1768856048584,
    "h": 343.307800292969,
    "CMY_C": 0.61343598365784,
    "CMY_M": 0.74875867366791,
    "CMY_Y": 0.67539644241333,
    "CMYK_C": 0,
    "CMYK_M": 0.35006541013718,
    "CMYK_Y": 0.160285115242,
    "CMYK_K": 0.61343598365784
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09538",
    "Farbtonhilfsbezeichnung": "XN.02.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "233",
    "Bcolor": "235",
    "Y": 82.6740570068359,
    "L": 92.8715515136719,
    "a": 2.4387538433075,
    "b": -1.2562381029129,
    "C": 2.74329257011414,
    "h": 332.746337890625,
    "CMY_C": 0.06531727313995,
    "CMY_M": 0.08521145582199,
    "CMY_Y": 0.07766574621201,
    "CMYK_C": 0,
    "CMYK_M": 0.02128442376852,
    "CMYK_Y": 0.01321140583605,
    "CMYK_K": 0.06531727313995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09539",
    "Farbtonhilfsbezeichnung": "Y8.06.81",
    "Farbtonklasse": "02",
    "Rcolor": "238",
    "Gcolor": "212",
    "Bcolor": "223",
    "Y": 70.507194519043,
    "L": 87.2450256347656,
    "a": 11.4423389434815,
    "b": -3.21949172019958,
    "C": 11.8866415023804,
    "h": 344.285186767578,
    "CMY_C": 0.06626629829407,
    "CMY_M": 0.1695368885994,
    "CMY_Y": 0.12427824735641,
    "CMYK_C": 0,
    "CMYK_M": 0.11059961467981,
    "CMYK_Y": 0.06212900951505,
    "CMYK_K": 0.06626629829407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09540",
    "Farbtonhilfsbezeichnung": "Y9.17.67",
    "Farbtonklasse": "03",
    "Rcolor": "228",
    "Gcolor": "167",
    "Bcolor": "198",
    "Y": 48.1443862915039,
    "L": 74.9159088134766,
    "a": 27.3761882781982,
    "b": -7.7747654914856,
    "C": 28.4587879180908,
    "h": 344.145599365234,
    "CMY_C": 0.10708647966385,
    "CMY_M": 0.34519469738007,
    "CMY_Y": 0.22376716136932,
    "CMYK_C": 0,
    "CMYK_M": 0.26666435599327,
    "CMYK_Y": 0.13067410886288,
    "CMYK_K": 0.10708647966385
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09541",
    "Farbtonhilfsbezeichnung": "Z1.24.58",
    "Farbtonklasse": "03",
    "Rcolor": "213",
    "Gcolor": "135",
    "Bcolor": "174",
    "Y": 34.6411552429199,
    "L": 65.4683227539063,
    "a": 35.6184501647949,
    "b": -8.46853637695313,
    "C": 36.6113395690918,
    "h": 346.625854492188,
    "CMY_C": 0.16283971071243,
    "CMY_M": 0.46988868713379,
    "CMY_Y": 0.31848579645157,
    "CMYK_C": 0,
    "CMYK_M": 0.36677441000938,
    "CMYK_Y": 0.18592149019241,
    "CMYK_K": 0.16283971071243
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09542",
    "Farbtonhilfsbezeichnung": "Z3.35.35",
    "Farbtonklasse": "04",
    "Rcolor": "162",
    "Gcolor": "81",
    "Bcolor": "117",
    "Y": 14.9641857147217,
    "L": 45.5851058959961,
    "a": 37.8865356445313,
    "b": -5.35891675949097,
    "C": 38.2636604309082,
    "h": 351.949127197266,
    "CMY_C": 0.36318135261536,
    "CMY_M": 0.68044060468674,
    "CMY_Y": 0.54103446006775,
    "CMYK_C": 0,
    "CMYK_M": 0.49819403886795,
    "CMYK_Y": 0.27928376197815,
    "CMYK_K": 0.36318135261536
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09543",
    "Farbtonhilfsbezeichnung": "Z2.32.26",
    "Farbtonklasse": "04",
    "Rcolor": "130",
    "Gcolor": "68",
    "Bcolor": "96",
    "Y": 9.74289608001709,
    "L": 37.3769836425781,
    "a": 30.2104625701904,
    "b": -5.23777389526367,
    "C": 30.661153793335,
    "h": 350.1640625,
    "CMY_C": 0.49137002229691,
    "CMY_M": 0.73221063613892,
    "CMY_Y": 0.62188875675201,
    "CMYK_C": 0,
    "CMYK_M": 0.47350850701332,
    "CMYK_Y": 0.25660842657089,
    "CMYK_K": 0.49137002229691
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09544",
    "Farbtonhilfsbezeichnung": "Z8.27.55",
    "Farbtonklasse": "04",
    "Rcolor": "212",
    "Gcolor": "123",
    "Bcolor": "154",
    "Y": 30.4886703491211,
    "L": 62.0735893249512,
    "a": 38.8182106018066,
    "b": -2.19207143783569,
    "C": 38.880054473877,
    "h": 356.767944335938,
    "CMY_C": 0.1678004860878,
    "CMY_M": 0.5182329416275,
    "CMY_Y": 0.39609998464584,
    "CMYK_C": 0,
    "CMYK_M": 0.42109188437462,
    "CMYK_Y": 0.27433264255524,
    "CMYK_K": 0.1678004860878
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09545",
    "Farbtonhilfsbezeichnung": "Z7.37.42",
    "Farbtonklasse": "04",
    "Rcolor": "186",
    "Gcolor": "88",
    "Bcolor": "127",
    "Y": 18.9708805084229,
    "L": 50.6531219482422,
    "a": 43.9639434814453,
    "b": -3.3430495262146,
    "C": 44.0908660888672,
    "h": 355.651550292969,
    "CMY_C": 0.27043431997299,
    "CMY_M": 0.65433239936829,
    "CMY_Y": 0.50313019752502,
    "CMYK_C": 0,
    "CMYK_M": 0.52620083093643,
    "CMYK_Y": 0.31895124912262,
    "CMYK_K": 0.27043431997299
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09546",
    "Farbtonhilfsbezeichnung": "Z7.41.30",
    "Farbtonklasse": "04",
    "Rcolor": "157",
    "Gcolor": "66",
    "Bcolor": "102",
    "Y": 11.9650506973267,
    "L": 41.1605186462402,
    "a": 42.0157928466797,
    "b": -2.55347990989685,
    "C": 42.0933151245117,
    "h": 356.522155761719,
    "CMY_C": 0.38483101129532,
    "CMY_M": 0.74253857135773,
    "CMY_Y": 0.6008722782135,
    "CMYK_C": 0,
    "CMYK_M": 0.581478536129,
    "CMYK_Y": 0.35119011998177,
    "CMYK_K": 0.38483101129532
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09547",
    "Farbtonhilfsbezeichnung": "ZN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "207",
    "Bcolor": "208",
    "Y": 63.087718963623,
    "L": 83.4885101318359,
    "a": 2.56755709648132,
    "b": -0.57092177867889,
    "C": 2.63026642799377,
    "h": 347.463684082031,
    "CMY_C": 0.16622525453568,
    "CMY_M": 0.1895078420639,
    "CMY_Y": 0.1859410405159,
    "CMYK_C": 0,
    "CMYK_M": 0.02792431414127,
    "CMYK_Y": 0.02364641800523,
    "CMYK_K": 0.16622525453568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09548",
    "Farbtonhilfsbezeichnung": "YN.01.73",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "193",
    "Bcolor": "196",
    "Y": 54.2028961181641,
    "L": 78.5798950195313,
    "a": 3.11899185180664,
    "b": -1.69441723823547,
    "C": 3.54952955245972,
    "h": 331.486633300781,
    "CMY_C": 0.2193575501442,
    "CMY_M": 0.24382102489471,
    "CMY_Y": 0.23085272312164,
    "CMYK_C": 0,
    "CMYK_M": 0.03133761882782,
    "CMYK_Y": 0.01472527254373,
    "CMYK_K": 0.2193575501442
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09549",
    "Farbtonhilfsbezeichnung": "Y7.12.21",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "73",
    "Bcolor": "82",
    "Y": 7.48077487945557,
    "L": 32.8772621154785,
    "a": 9.00495052337646,
    "b": -3.33849287033081,
    "C": 9.60388851165771,
    "h": 339.658264160156,
    "CMY_C": 0.64975488185883,
    "CMY_M": 0.71473550796509,
    "CMY_Y": 0.67809987068176,
    "CMYK_C": 0,
    "CMYK_M": 0.18552899360657,
    "CMYK_Y": 0.08092900365591,
    "CMYK_K": 0.64975488185883
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09550",
    "Farbtonhilfsbezeichnung": "Z3.04.68",
    "Farbtonklasse": "02",
    "Rcolor": "196",
    "Gcolor": "179",
    "Bcolor": "184",
    "Y": 47.566162109375,
    "L": 74.5504684448242,
    "a": 6.93672275543213,
    "b": -1.02910780906677,
    "C": 7.01264476776123,
    "h": 351.561340332031,
    "CMY_C": 0.23261266946793,
    "CMY_M": 0.29636520147324,
    "CMY_Y": 0.27818548679352,
    "CMYK_C": 0,
    "CMYK_M": 0.08307738602161,
    "CMYK_Y": 0.05938698351383,
    "CMYK_K": 0.23261266946793
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09551",
    "Farbtonhilfsbezeichnung": "Z2.07.54",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "142",
    "Bcolor": "151",
    "Y": 29.4083118438721,
    "L": 61.1403007507324,
    "a": 10.2181730270386,
    "b": -2.5399534702301,
    "C": 10.5291223526001,
    "h": 346.040771484375,
    "CMY_C": 0.35716557502747,
    "CMY_M": 0.44391721487045,
    "CMY_Y": 0.40734457969666,
    "CMYK_C": 0,
    "CMYK_M": 0.13495177030563,
    "CMYK_Y": 0.07805898785591,
    "CMYK_K": 0.35716557502747
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09552",
    "Farbtonhilfsbezeichnung": "Z3.12.39",
    "Farbtonklasse": "03",
    "Rcolor": "135",
    "Gcolor": "107",
    "Bcolor": "118",
    "Y": 17.0185298919678,
    "L": 48.2833786010742,
    "a": 13.3873376846313,
    "b": -2.57934045791626,
    "C": 13.6335544586182,
    "h": 349.094451904297,
    "CMY_C": 0.46963661909103,
    "CMY_M": 0.58009922504425,
    "CMY_Y": 0.53572231531143,
    "CMYK_C": 0,
    "CMYK_M": 0.20827721059322,
    "CMYK_Y": 0.12460456043482,
    "CMYK_K": 0.46963661909103
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09553",
    "Farbtonhilfsbezeichnung": "AN.02.76",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "203",
    "Bcolor": "202",
    "Y": 61.1156349182129,
    "L": 82.4408645629883,
    "a": 3.93166017532349,
    "b": 1.02491080760956,
    "C": 4.0630521774292,
    "h": 14.6107807159424,
    "CMY_C": 0.16221386194229,
    "CMY_M": 0.20466005802155,
    "CMY_Y": 0.20869237184525,
    "CMYK_C": 0,
    "CMYK_M": 0.05066471546888,
    "CMYK_Y": 0.05547777563334,
    "CMYK_K": 0.16221386194229
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09554",
    "Farbtonhilfsbezeichnung": "A4.04.63",
    "Farbtonklasse": "02",
    "Rcolor": "183",
    "Gcolor": "165",
    "Bcolor": "167",
    "Y": 39.8429985046387,
    "L": 69.3575592041016,
    "a": 6.90567970275879,
    "b": 0.58704841136932,
    "C": 6.93058729171753,
    "h": 4.85900354385376,
    "CMY_C": 0.2838761806488,
    "CMY_M": 0.35166877508163,
    "CMY_Y": 0.34429198503494,
    "CMYK_C": 0,
    "CMYK_M": 0.09466602653265,
    "CMYK_Y": 0.0843650251627,
    "CMYK_K": 0.2838761806488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09555",
    "Farbtonhilfsbezeichnung": "A4.07.48",
    "Farbtonklasse": "03",
    "Rcolor": "152",
    "Gcolor": "129",
    "Bcolor": "132",
    "Y": 24.0654277801514,
    "L": 56.153247833252,
    "a": 9.58123207092285,
    "b": 0.86509853601456,
    "C": 9.62020778656006,
    "h": 5.15930032730103,
    "CMY_C": 0.40404969453812,
    "CMY_M": 0.49385184049606,
    "CMY_Y": 0.48092520236969,
    "CMYK_C": 0,
    "CMYK_M": 0.15068730711937,
    "CMYK_Y": 0.12899650633335,
    "CMYK_K": 0.40404969453812
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09556",
    "Farbtonhilfsbezeichnung": "A5.10.37",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "104",
    "Bcolor": "109",
    "Y": 15.9521160125732,
    "L": 46.9116020202637,
    "a": 12.0718450546265,
    "b": 0.82104241847992,
    "C": 12.0997333526611,
    "h": 3.89086604118347,
    "CMY_C": 0.48322731256485,
    "CMY_M": 0.59111738204956,
    "CMY_Y": 0.57125794887543,
    "CMYK_C": 0,
    "CMYK_M": 0.20877665281296,
    "CMYK_Y": 0.17034691572189,
    "CMYK_K": 0.48322731256485
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09557",
    "Farbtonhilfsbezeichnung": "A5.15.27",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "82",
    "Bcolor": "87",
    "Y": 10.0237083435059,
    "L": 37.8849449157715,
    "a": 13.2849369049072,
    "b": 1.42657363414764,
    "C": 13.3613119125366,
    "h": 6.12909460067749,
    "CMY_C": 0.56514477729797,
    "CMY_M": 0.68009424209595,
    "CMY_Y": 0.66050618886948,
    "CMYK_C": 0,
    "CMYK_M": 0.26433962583542,
    "CMYK_Y": 0.21929462254047,
    "CMYK_K": 0.56514477729797
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09558",
    "Farbtonhilfsbezeichnung": "CN.02.76",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "205",
    "Bcolor": "202",
    "Y": 62.0199508666992,
    "L": 82.9240264892578,
    "a": 3.07169961929321,
    "b": 1.72274267673492,
    "C": 3.52181506156921,
    "h": 29.2856044769287,
    "CMY_C": 0.1611555814743,
    "CMY_M": 0.19752615690231,
    "CMY_Y": 0.20864564180374,
    "CMYK_C": 0,
    "CMYK_M": 0.04335794970393,
    "CMYK_Y": 0.0566136687994,
    "CMYK_K": 0.1611555814743
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09559",
    "Farbtonhilfsbezeichnung": "BN.02.72",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "191",
    "Bcolor": "189",
    "Y": 53.0581665039063,
    "L": 77.9093246459961,
    "a": 3.55588150024414,
    "b": 1.13880586624146,
    "C": 3.73378801345825,
    "h": 17.7581729888916,
    "CMY_C": 0.21422833204269,
    "CMY_M": 0.25288742780685,
    "CMY_Y": 0.25828659534454,
    "CMYK_C": 0,
    "CMYK_M": 0.04919889196754,
    "CMYK_Y": 0.05607005953789,
    "CMYK_K": 0.21422833204269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09560",
    "Farbtonhilfsbezeichnung": "B1.04.58",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "154",
    "Bcolor": "154",
    "Y": 34.0014305114746,
    "L": 64.9637069702148,
    "a": 5.89386463165283,
    "b": 1.58533227443695,
    "C": 6.10335302352905,
    "h": 15.0550956726074,
    "CMY_C": 0.3347784280777,
    "CMY_M": 0.39535838365555,
    "CMY_Y": 0.39690274000168,
    "CMYK_C": 0,
    "CMYK_M": 0.09106733649969,
    "CMYK_Y": 0.09338890016079,
    "CMYK_K": 0.3347784280777
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09561",
    "Farbtonhilfsbezeichnung": "B1.08.37",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "104",
    "Bcolor": "105",
    "Y": 15.4538478851318,
    "L": 46.249641418457,
    "a": 9.45922470092773,
    "b": 2.13509798049927,
    "C": 9.69719409942627,
    "h": 12.7194223403931,
    "CMY_C": 0.50284314155579,
    "CMY_M": 0.5915738940239,
    "CMY_Y": 0.58646327257156,
    "CMYK_C": 0,
    "CMYK_M": 0.17847637832165,
    "CMYK_Y": 0.16819667816162,
    "CMYK_K": 0.50284314155579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09562",
    "Farbtonhilfsbezeichnung": "B0.18.12",
    "Farbtonklasse": "04",
    "Rcolor": "83",
    "Gcolor": "62",
    "Bcolor": "65",
    "Y": 5.64604187011719,
    "L": 28.5012969970703,
    "a": 9.6777458190918,
    "b": 1.44993829727173,
    "C": 9.78575897216797,
    "h": 8.52078533172607,
    "CMY_C": 0.67587471008301,
    "CMY_M": 0.75688278675079,
    "CMY_Y": 0.7461923956871,
    "CMYK_C": 0,
    "CMYK_M": 0.24992828071117,
    "CMYK_Y": 0.21694600582123,
    "CMYK_K": 0.67587471008301
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09563",
    "Farbtonhilfsbezeichnung": "BN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "220",
    "Bcolor": "217",
    "Y": 72.9370346069336,
    "L": 88.4176788330078,
    "a": 3.04624390602112,
    "b": 1.62832987308502,
    "C": 3.45413661003113,
    "h": 28.1261501312256,
    "CMY_C": 0.100794672966,
    "CMY_M": 0.13706666231155,
    "CMY_Y": 0.14812141656876,
    "CMYK_C": 0,
    "CMYK_M": 0.04033782705665,
    "CMYK_Y": 0.05263174325228,
    "CMYK_K": 0.100794672966
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09564",
    "Farbtonhilfsbezeichnung": "BN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "208",
    "Bcolor": "206",
    "Y": 64.2956466674805,
    "L": 84.1194610595703,
    "a": 3.82670497894287,
    "b": 1.18339407444,
    "C": 4.0055079460144,
    "h": 17.1840267181396,
    "CMY_C": 0.1439927816391,
    "CMY_M": 0.18612176179886,
    "CMY_Y": 0.1916651725769,
    "CMYK_C": 0,
    "CMYK_M": 0.04921568185091,
    "CMYK_Y": 0.05569157749414,
    "CMYK_K": 0.1439927816391
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09565",
    "Farbtonhilfsbezeichnung": "B0.07.55",
    "Farbtonklasse": "02",
    "Rcolor": "167",
    "Gcolor": "143",
    "Bcolor": "145",
    "Y": 29.8713111877441,
    "L": 61.543025970459,
    "a": 9.63024616241455,
    "b": 1.7001725435257,
    "C": 9.77917289733887,
    "h": 10.0121192932129,
    "CMY_C": 0.34508991241455,
    "CMY_M": 0.43955540657043,
    "CMY_Y": 0.43216967582703,
    "CMYK_C": 0,
    "CMYK_M": 0.14424192905426,
    "CMYK_Y": 0.13296446204185,
    "CMYK_K": 0.34508991241455
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09566",
    "Farbtonhilfsbezeichnung": "BN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "219",
    "Bcolor": "217",
    "Y": 71.9231185913086,
    "L": 87.9315719604492,
    "a": 3.20833873748779,
    "b": 0.88142454624176,
    "C": 3.32721304893494,
    "h": 15.3618297576904,
    "CMY_C": 0.10739159584045,
    "CMY_M": 0.14262062311172,
    "CMY_Y": 0.14794033765793,
    "CMYK_C": 0,
    "CMYK_M": 0.03946750611067,
    "CMYK_Y": 0.04542724788189,
    "CMYK_K": 0.10739159584045
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09567",
    "Farbtonhilfsbezeichnung": "B6.05.73",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "192",
    "Bcolor": "190",
    "Y": 55.5106353759766,
    "L": 79.3344879150391,
    "a": 7.68141794204712,
    "b": 2.88864898681641,
    "C": 8.20661163330078,
    "h": 20.6091079711914,
    "CMY_C": 0.16321682929993,
    "CMY_M": 0.24800187349319,
    "CMY_Y": 0.25501829385757,
    "CMYK_C": 0,
    "CMYK_M": 0.10132259875536,
    "CMYK_Y": 0.10970758646727,
    "CMYK_K": 0.16321682929993
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09568",
    "Farbtonhilfsbezeichnung": "B8.06.68",
    "Farbtonklasse": "02",
    "Rcolor": "207",
    "Gcolor": "180",
    "Bcolor": "177",
    "Y": 48.8422546386719,
    "L": 75.3530883789063,
    "a": 9.67208003997803,
    "b": 4.38123369216919,
    "C": 10.6181135177612,
    "h": 24.3694515228271,
    "CMY_C": 0.18875640630722,
    "CMY_M": 0.29606646299362,
    "CMY_Y": 0.30768692493439,
    "CMYK_C": 0,
    "CMYK_M": 0.13227845728397,
    "CMYK_Y": 0.1466027200222,
    "CMYK_K": 0.18875640630722
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09569",
    "Farbtonhilfsbezeichnung": "B7.10.59",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "153",
    "Bcolor": "149",
    "Y": 35.5787887573242,
    "L": 66.1968231201172,
    "a": 13.1744289398193,
    "b": 6.06689691543579,
    "C": 14.5042343139648,
    "h": 24.7263298034668,
    "CMY_C": 0.2608231306076,
    "CMY_M": 0.40165829658508,
    "CMY_Y": 0.41414898633957,
    "CMYK_C": 0,
    "CMYK_M": 0.19052971899509,
    "CMYK_Y": 0.20742782950401,
    "CMYK_K": 0.2608231306076
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09570",
    "Farbtonhilfsbezeichnung": "B7.17.39",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "104",
    "Bcolor": "101",
    "Y": 16.8615055084229,
    "L": 48.0850601196289,
    "a": 16.4623413085938,
    "b": 7.64172220230103,
    "C": 18.149507522583,
    "h": 24.9004516601563,
    "CMY_C": 0.43026149272919,
    "CMY_M": 0.59265553951263,
    "CMY_Y": 0.60348182916641,
    "CMYK_C": 0,
    "CMYK_M": 0.28503260016441,
    "CMYK_Y": 0.30403479933739,
    "CMYK_K": 0.43026149272919
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09571",
    "Farbtonhilfsbezeichnung": "CN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "218",
    "Bcolor": "214",
    "Y": 71.9153518676758,
    "L": 87.9278335571289,
    "a": 3.73688650131226,
    "b": 2.85709285736084,
    "C": 4.70396661758423,
    "h": 37.4002647399902,
    "CMY_C": 0.09708714485168,
    "CMY_M": 0.14450281858444,
    "CMY_Y": 0.16241830587387,
    "CMYK_C": 0,
    "CMYK_M": 0.05251412093639,
    "CMYK_Y": 0.07235600054264,
    "CMYK_K": 0.09708714485168
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09572",
    "Farbtonhilfsbezeichnung": "C2.06.68",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "180",
    "Bcolor": "175",
    "Y": 48.183895111084,
    "L": 74.9407653808594,
    "a": 7.83193016052246,
    "b": 4.8276801109314,
    "C": 9.2003059387207,
    "h": 31.6500968933106,
    "CMY_C": 0.20489865541458,
    "CMY_M": 0.29602098464966,
    "CMY_Y": 0.31547337770462,
    "CMYK_C": 0,
    "CMYK_M": 0.11460467427969,
    "CMYK_Y": 0.13906997442245,
    "CMYK_K": 0.20489865541458
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09573",
    "Farbtonhilfsbezeichnung": "C3.12.54",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "142",
    "Bcolor": "134",
    "Y": 30.7510147094727,
    "L": 62.2968826293945,
    "a": 13.0691633224487,
    "b": 9.21301555633545,
    "C": 15.9900808334351,
    "h": 35.1816558837891,
    "CMY_C": 0.29643130302429,
    "CMY_M": 0.44236868619919,
    "CMY_Y": 0.47531914710999,
    "CMYK_C": 0,
    "CMYK_M": 0.20742449164391,
    "CMYK_Y": 0.25425782799721,
    "CMYK_K": 0.29643130302429
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09574",
    "Farbtonhilfsbezeichnung": "C3.20.39",
    "Farbtonklasse": "03",
    "Rcolor": "150",
    "Gcolor": "105",
    "Bcolor": "97",
    "Y": 17.509126663208,
    "L": 48.8952369689941,
    "a": 16.9852199554443,
    "b": 11.4899883270264,
    "C": 20.5065231323242,
    "h": 34.0771636962891,
    "CMY_C": 0.41157978773117,
    "CMY_M": 0.58706951141357,
    "CMY_Y": 0.62074041366577,
    "CMYK_C": 0,
    "CMYK_M": 0.29823878407478,
    "CMYK_Y": 0.35546132922173,
    "CMYK_K": 0.41157978773117
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09575",
    "Farbtonhilfsbezeichnung": "C5.27.28",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "81",
    "Bcolor": "72",
    "Y": 10.6781463623047,
    "L": 39.0330123901367,
    "a": 17.6103229522705,
    "b": 12.3272838592529,
    "C": 21.4961719512939,
    "h": 34.9921455383301,
    "CMY_C": 0.50996506214142,
    "CMY_M": 0.68320405483246,
    "CMY_Y": 0.71725904941559,
    "CMYK_C": 0,
    "CMYK_M": 0.35352376103401,
    "CMYK_Y": 0.42301878333092,
    "CMYK_K": 0.50996506214142
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09576",
    "Farbtonhilfsbezeichnung": "C0.23.18",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "67",
    "Bcolor": "63",
    "Y": 6.91791343688965,
    "L": 31.6192989349365,
    "a": 12.9417781829834,
    "b": 7.30187082290649,
    "C": 14.8595743179321,
    "h": 29.4320907592773,
    "CMY_C": 0.61738038063049,
    "CMY_M": 0.73814505338669,
    "CMY_Y": 0.75318145751953,
    "CMYK_C": 0,
    "CMYK_M": 0.31562593579292,
    "CMYK_Y": 0.35492449998856,
    "CMYK_K": 0.61738038063049
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09577",
    "Farbtonhilfsbezeichnung": "BN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "219",
    "Bcolor": "215",
    "Y": 72.7202529907227,
    "L": 88.3141250610352,
    "a": 3.505286693573,
    "b": 2.55377745628357,
    "C": 4.33691310882568,
    "h": 36.0752182006836,
    "CMY_C": 0.09548753499985,
    "CMY_M": 0.1395857334137,
    "CMY_Y": 0.1559961438179,
    "CMYK_C": 0,
    "CMYK_M": 0.0487535558641,
    "CMYK_Y": 0.06689637899399,
    "CMYK_K": 0.09548753499985
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09578",
    "Farbtonhilfsbezeichnung": "C3.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "168",
    "Gcolor": "140",
    "Bcolor": "133",
    "Y": 28.6678009033203,
    "L": 60.4873199462891,
    "a": 9.87508487701416,
    "b": 6.71289730072021,
    "C": 11.9406986236572,
    "h": 34.2071304321289,
    "CMY_C": 0.34196388721466,
    "CMY_M": 0.45224398374557,
    "CMY_Y": 0.47690778970718,
    "CMYK_C": 0,
    "CMYK_M": 0.16758973896503,
    "CMYK_Y": 0.20507065951824,
    "CMYK_K": 0.34196388721466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09579",
    "Farbtonhilfsbezeichnung": "C3.16.38",
    "Farbtonklasse": "03",
    "Rcolor": "138",
    "Gcolor": "103",
    "Bcolor": "96",
    "Y": 16.0376987457275,
    "L": 47.0239105224609,
    "a": 13.1691226959229,
    "b": 9.19077587127686,
    "C": 16.0591449737549,
    "h": 34.911319732666,
    "CMY_C": 0.45742183923721,
    "CMY_M": 0.59484958648682,
    "CMY_Y": 0.62412536144257,
    "CMYK_C": 0,
    "CMYK_M": 0.25328654050827,
    "CMYK_Y": 0.30724334716797,
    "CMYK_K": 0.45742183923721
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09580",
    "Farbtonhilfsbezeichnung": "C4.23.20",
    "Farbtonklasse": "03",
    "Rcolor": "99",
    "Gcolor": "69",
    "Bcolor": "63",
    "Y": 7.23347139358521,
    "L": 32.3326110839844,
    "a": 12.5665283203125,
    "b": 8.32005977630615,
    "C": 15.0711984634399,
    "h": 33.5077896118164,
    "CMY_C": 0.61066401004791,
    "CMY_M": 0.73098754882813,
    "CMY_Y": 0.75311481952667,
    "CMYK_C": 0,
    "CMYK_M": 0.3090480864048,
    "CMYK_Y": 0.36588144302368,
    "CMYK_K": 0.61066401004791
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09581",
    "Farbtonhilfsbezeichnung": "CN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "218",
    "Bcolor": "215",
    "Y": 71.4960708618164,
    "L": 87.7254638671875,
    "a": 2.68145537376404,
    "b": 2.01934123039246,
    "C": 3.35677552223206,
    "h": 36.9825477600098,
    "CMY_C": 0.11003661155701,
    "CMY_M": 0.14394986629486,
    "CMY_Y": 0.15862917900085,
    "CMYK_C": 0,
    "CMYK_M": 0.03810634836555,
    "CMYK_Y": 0.05460063740611,
    "CMYK_K": 0.11003661155701
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09582",
    "Farbtonhilfsbezeichnung": "C0.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "204",
    "Bcolor": "201",
    "Y": 61.9815635681152,
    "L": 82.9036178588867,
    "a": 3.96813535690308,
    "b": 2.22612190246582,
    "C": 4.54991388320923,
    "h": 29.2924041748047,
    "CMY_C": 0.15306997299194,
    "CMY_M": 0.20003998279572,
    "CMY_Y": 0.21239227056503,
    "CMYK_C": 0,
    "CMYK_M": 0.05545913800597,
    "CMYK_Y": 0.07004392147064,
    "CMYK_K": 0.15306997299194
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09583",
    "Farbtonhilfsbezeichnung": "C2.05.67",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "178",
    "Bcolor": "173",
    "Y": 46.6128921508789,
    "L": 73.9414749145508,
    "a": 6.44452047348022,
    "b": 3.93317914009094,
    "C": 7.54994964599609,
    "h": 31.3962898254395,
    "CMY_C": 0.22806298732758,
    "CMY_M": 0.30303782224655,
    "CMY_Y": 0.31984704732895,
    "CMYK_C": 0,
    "CMYK_M": 0.09712558984756,
    "CMYK_Y": 0.11890096962452,
    "CMYK_K": 0.22806298732758
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09584",
    "Farbtonhilfsbezeichnung": "C1.04.62",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "164",
    "Bcolor": "161",
    "Y": 38.6938285827637,
    "L": 68.5289001464844,
    "a": 5.36615562438965,
    "b": 2.90375328063965,
    "C": 6.10142660140991,
    "h": 28.4188652038574,
    "CMY_C": 0.29686796665192,
    "CMY_M": 0.35732167959213,
    "CMY_Y": 0.36929476261139,
    "CMYK_C": 0,
    "CMYK_M": 0.08597775548697,
    "CMYK_Y": 0.10300596803427,
    "CMYK_K": 0.29686796665192
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09585",
    "Farbtonhilfsbezeichnung": "B5.05.52",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "138",
    "Bcolor": "137",
    "Y": 27.1718711853027,
    "L": 59.1330795288086,
    "a": 6.55320024490356,
    "b": 2.77940678596497,
    "C": 7.11825370788574,
    "h": 22.9832439422607,
    "CMY_C": 0.38806819915771,
    "CMY_M": 0.45706051588058,
    "CMY_Y": 0.46430712938309,
    "CMYK_C": 0,
    "CMYK_M": 0.11274510622025,
    "CMYK_Y": 0.12458729743958,
    "CMYK_K": 0.38806819915771
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09586",
    "Farbtonhilfsbezeichnung": "C3.13.14",
    "Farbtonklasse": "03",
    "Rcolor": "80",
    "Gcolor": "66",
    "Bcolor": "64",
    "Y": 5.96064186096191,
    "L": 29.3129482269287,
    "a": 5.57988119125366,
    "b": 3.21711897850037,
    "C": 6.44087934494019,
    "h": 29.9658946990967,
    "CMY_C": 0.68756306171417,
    "CMY_M": 0.74097180366516,
    "CMY_Y": 0.75004231929779,
    "CMYK_C": 0,
    "CMYK_M": 0.17094247043133,
    "CMYK_Y": 0.19997398555279,
    "CMYK_K": 0.68756306171417
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09587",
    "Farbtonhilfsbezeichnung": "CN.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "205",
    "Bcolor": "200",
    "Y": 62.2546195983887,
    "L": 83.0486373901367,
    "a": 3.59999942779541,
    "b": 3.08038115501404,
    "C": 4.73801040649414,
    "h": 40.5523338317871,
    "CMY_C": 0.15157502889633,
    "CMY_M": 0.197809278965,
    "CMY_Y": 0.21707707643509,
    "CMYK_C": 0,
    "CMYK_M": 0.05449421331286,
    "CMYK_Y": 0.07720428705215,
    "CMYK_K": 0.15157502889633
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09588",
    "Farbtonhilfsbezeichnung": "DN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "204",
    "Bcolor": "198",
    "Y": 61.5072021484375,
    "L": 82.6506576538086,
    "a": 3.16103601455688,
    "b": 3.17723536491394,
    "C": 4.481849193573,
    "h": 45.1464385986328,
    "CMY_C": 0.15894323587418,
    "CMY_M": 0.20112550258636,
    "CMY_Y": 0.22213608026505,
    "CMYK_C": 0,
    "CMYK_M": 0.050153888762,
    "CMYK_Y": 0.07513505220413,
    "CMYK_K": 0.15894323587418
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09589",
    "Farbtonhilfsbezeichnung": "C8.04.67",
    "Farbtonklasse": "02",
    "Rcolor": "192",
    "Gcolor": "178",
    "Bcolor": "172",
    "Y": 45.9830093383789,
    "L": 73.5345077514648,
    "a": 4.24962568283081,
    "b": 4.28902530670166,
    "C": 6.03780221939087,
    "h": 45.2643775939941,
    "CMY_C": 0.24709135293961,
    "CMY_M": 0.30221009254456,
    "CMY_Y": 0.32695633172989,
    "CMYK_C": 0,
    "CMYK_M": 0.07320773601532,
    "CMYK_Y": 0.10607525706291,
    "CMYK_K": 0.24709135293961
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09590",
    "Farbtonhilfsbezeichnung": "D2.05.63",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "166",
    "Bcolor": "159",
    "Y": 39.6846160888672,
    "L": 69.2443084716797,
    "a": 4.95063972473145,
    "b": 5.04916334152222,
    "C": 7.0712718963623,
    "h": 45.5644912719727,
    "CMY_C": 0.28610736131668,
    "CMY_M": 0.34940242767334,
    "CMY_Y": 0.37692230939865,
    "CMYK_C": 0,
    "CMYK_M": 0.08866188675165,
    "CMYK_Y": 0.12721092998981,
    "CMYK_K": 0.28610736131668
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09591",
    "Farbtonhilfsbezeichnung": "C3.11.36",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "102",
    "Bcolor": "97",
    "Y": 14.9248571395874,
    "L": 45.5311050415039,
    "a": 9.06054878234863,
    "b": 6.33645153045654,
    "C": 11.0564079284668,
    "h": 34.9668312072754,
    "CMY_C": 0.5028925538063,
    "CMY_M": 0.59860825538635,
    "CMY_Y": 0.62043678760529,
    "CMYK_C": 0,
    "CMYK_M": 0.19254529476166,
    "CMYK_Y": 0.23645639419556,
    "CMYK_K": 0.5028925538063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09592",
    "Farbtonhilfsbezeichnung": "C3.14.31",
    "Farbtonklasse": "03",
    "Rcolor": "118",
    "Gcolor": "91",
    "Bcolor": "85",
    "Y": 11.9316320419312,
    "L": 41.1072540283203,
    "a": 10.1706352233887,
    "b": 7.3444561958313,
    "C": 12.5452327728272,
    "h": 35.8339424133301,
    "CMY_C": 0.53872191905975,
    "CMY_M": 0.64371860027313,
    "CMY_Y": 0.66812926530838,
    "CMYK_C": 0,
    "CMYK_M": 0.22762122750282,
    "CMYK_Y": 0.28054085373878,
    "CMYK_K": 0.53872191905975
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09593",
    "Farbtonhilfsbezeichnung": "D0.18.16",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "67",
    "Bcolor": "61",
    "Y": 6.23299837112427,
    "L": 29.9928493499756,
    "a": 6.77243900299072,
    "b": 6.12566709518433,
    "C": 9.13179779052734,
    "h": 42.1293258666992,
    "CMY_C": 0.66853594779968,
    "CMY_M": 0.7380998134613,
    "CMY_Y": 0.76129698753357,
    "CMYK_C": 0,
    "CMYK_M": 0.20986850559711,
    "CMYK_Y": 0.27985247969627,
    "CMYK_K": 0.66853594779968
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09594",
    "Farbtonhilfsbezeichnung": "D6.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "220",
    "Gcolor": "207",
    "Bcolor": "200",
    "Y": 63.7732086181641,
    "L": 83.8475494384766,
    "a": 3.65441679954529,
    "b": 4.29519367218018,
    "C": 5.63945484161377,
    "h": 49.6083526611328,
    "CMY_C": 0.13863015174866,
    "CMY_M": 0.18954616785049,
    "CMY_Y": 0.21727287769318,
    "CMYK_C": 0,
    "CMYK_M": 0.05911051481962,
    "CMYK_Y": 0.09129960089922,
    "CMYK_K": 0.13863015174866
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09595",
    "Farbtonhilfsbezeichnung": "D5.06.68",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "181",
    "Bcolor": "172",
    "Y": 48.4828033447266,
    "L": 75.1284332275391,
    "a": 5.48392724990845,
    "b": 6.43096256256104,
    "C": 8.45167064666748,
    "h": 49.544506072998,
    "CMY_C": 0.21496659517288,
    "CMY_M": 0.2887362241745,
    "CMY_Y": 0.32523900270462,
    "CMYK_C": 0,
    "CMYK_M": 0.09397005289793,
    "CMYK_Y": 0.14046843349934,
    "CMYK_K": 0.21496659517288
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09596",
    "Farbtonhilfsbezeichnung": "C9.13.37",
    "Farbtonklasse": "03",
    "Rcolor": "130",
    "Gcolor": "105",
    "Bcolor": "96",
    "Y": 15.6401681900024,
    "L": 46.4988174438477,
    "a": 9.04097270965576,
    "b": 8.33376884460449,
    "C": 12.2959709167481,
    "h": 42.6691780090332,
    "CMY_C": 0.48894876241684,
    "CMY_M": 0.58967673778534,
    "CMY_Y": 0.62417906522751,
    "CMYK_C": 0,
    "CMYK_M": 0.19709956645966,
    "CMYK_Y": 0.26461201906204,
    "CMYK_K": 0.48894876241684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09597",
    "Farbtonhilfsbezeichnung": "D0.20.26",
    "Farbtonklasse": "03",
    "Rcolor": "111",
    "Gcolor": "81",
    "Bcolor": "71",
    "Y": 9.71439933776855,
    "L": 37.3248901367188,
    "a": 11.3122129440308,
    "b": 10.554801940918,
    "C": 15.4715871810913,
    "h": 43.0162315368652,
    "CMY_C": 0.56418931484222,
    "CMY_M": 0.68260383605957,
    "CMY_Y": 0.72262448072433,
    "CMYK_C": 0,
    "CMYK_M": 0.27171093225479,
    "CMYK_Y": 0.36354127526283,
    "CMYK_K": 0.56418931484222
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09598",
    "Farbtonhilfsbezeichnung": "D4.18.17",
    "Farbtonklasse": "04",
    "Rcolor": "88",
    "Gcolor": "73",
    "Bcolor": "66",
    "Y": 7.16251039505005,
    "L": 32.1740417480469,
    "a": 5.39368343353271,
    "b": 5.96287441253662,
    "C": 8.04037857055664,
    "h": 47.8692665100098,
    "CMY_C": 0.65605342388153,
    "CMY_M": 0.71539306640625,
    "CMY_Y": 0.74127125740051,
    "CMYK_C": 0,
    "CMYK_M": 0.1725257486105,
    "CMYK_Y": 0.24776473641396,
    "CMYK_K": 0.65605342388153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09599",
    "Farbtonhilfsbezeichnung": "EN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 83.3793792724609,
    "L": 93.1802825927734,
    "a": 0.53774577379227,
    "b": 1.7198657989502,
    "C": 1.80197358131409,
    "h": 72.6372451782227,
    "CMY_C": 0.06671541929245,
    "CMY_M": 0.07803446054459,
    "CMY_Y": 0.09663033485413,
    "CMYK_C": 0,
    "CMYK_M": 0.01212817803025,
    "CMYK_Y": 0.03205337002873,
    "CMYK_K": 0.06671541929245
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09600",
    "Farbtonhilfsbezeichnung": "DN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "217",
    "Bcolor": "214",
    "Y": 70.3117752075195,
    "L": 87.1495513916016,
    "a": 1.57025921344757,
    "b": 1.45326244831085,
    "C": 2.1395525932312,
    "h": 42.7840156555176,
    "CMY_C": 0.12681186199188,
    "CMY_M": 0.14748847484589,
    "CMY_Y": 0.1609308719635,
    "CMYK_C": 0,
    "CMYK_M": 0.02367944829166,
    "CMYK_Y": 0.03907406330109,
    "CMYK_K": 0.12681186199188
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09601",
    "Farbtonhilfsbezeichnung": "DN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "192",
    "Bcolor": "188",
    "Y": 53.2306976318359,
    "L": 78.0110092163086,
    "a": 2.12843775749207,
    "b": 1.86195921897888,
    "C": 2.82792139053345,
    "h": 41.1794624328613,
    "CMY_C": 0.22149211168289,
    "CMY_M": 0.24862706661224,
    "CMY_Y": 0.26257711648941,
    "CMYK_C": 0,
    "CMYK_M": 0.03485507890582,
    "CMYK_Y": 0.05277403816581,
    "CMYK_K": 0.22149211168289
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09602",
    "Farbtonhilfsbezeichnung": "D0.03.56",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "152",
    "Bcolor": "148",
    "Y": 32.3376960754395,
    "L": 63.6210098266602,
    "a": 3.12873697280884,
    "b": 2.80972290039063,
    "C": 4.2051796913147,
    "h": 41.9250259399414,
    "CMY_C": 0.36472684144974,
    "CMY_M": 0.40316540002823,
    "CMY_Y": 0.41946995258331,
    "CMYK_C": 0,
    "CMYK_M": 0.0605071336031,
    "CMYK_Y": 0.08617255836725,
    "CMYK_K": 0.36472684144974
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09603",
    "Farbtonhilfsbezeichnung": "C8.04.45",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "125",
    "Bcolor": "121",
    "Y": 21.2747554779053,
    "L": 53.248893737793,
    "a": 3.6150689125061,
    "b": 3.21764492988586,
    "C": 4.83962440490723,
    "h": 41.6711463928223,
    "CMY_C": 0.46707433462143,
    "CMY_M": 0.50969338417053,
    "CMY_Y": 0.52623188495636,
    "CMYK_C": 0,
    "CMYK_M": 0.07997184991837,
    "CMYK_Y": 0.11100525408983,
    "CMYK_K": 0.46707433462143
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09604",
    "Farbtonhilfsbezeichnung": "C9.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "72",
    "Bcolor": "69",
    "Y": 6.71525907516479,
    "L": 31.149694442749,
    "a": 2.77475357055664,
    "b": 2.42427682876587,
    "C": 3.68461346626282,
    "h": 41.1434135437012,
    "CMY_C": 0.6889026761055,
    "CMY_M": 0.71842205524445,
    "CMY_Y": 0.7293313741684,
    "CMYK_C": 0,
    "CMYK_M": 0.09488792717457,
    "CMYK_Y": 0.12995514273643,
    "CMYK_K": 0.6889026761055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09605",
    "Farbtonhilfsbezeichnung": "E0.03.83",
    "Farbtonklasse": "01",
    "Rcolor": "233",
    "Gcolor": "225",
    "Bcolor": "217",
    "Y": 76.2649917602539,
    "L": 89.9822387695313,
    "a": 1.38666522502899,
    "b": 4.23892831802368,
    "C": 4.4599723815918,
    "h": 71.8857116699219,
    "CMY_C": 0.08770090341568,
    "CMY_M": 0.11645418405533,
    "CMY_Y": 0.15044754743576,
    "CMYK_C": 0,
    "CMYK_M": 0.03151738271117,
    "CMYK_Y": 0.06877858936787,
    "CMYK_K": 0.08770090341568
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09606",
    "Farbtonhilfsbezeichnung": "EN.02.81",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "219",
    "Bcolor": "213",
    "Y": 71.4172515869141,
    "L": 87.6873321533203,
    "a": 1.62798702716827,
    "b": 2.66819787025452,
    "C": 3.12563943862915,
    "h": 58.6107635498047,
    "CMY_C": 0.11644822359085,
    "CMY_M": 0.1420271396637,
    "CMY_Y": 0.16396081447601,
    "CMYK_C": 0,
    "CMYK_M": 0.02895010448992,
    "CMYK_Y": 0.05377453938127,
    "CMYK_K": 0.11644822359085
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09607",
    "Farbtonhilfsbezeichnung": "E1.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "205",
    "Bcolor": "199",
    "Y": 62.2426147460938,
    "L": 83.0422744750977,
    "a": 2.15159440040588,
    "b": 3.43763828277588,
    "C": 4.05545520782471,
    "h": 57.9578285217285,
    "CMY_C": 0.16139668226242,
    "CMY_M": 0.1945184469223,
    "CMY_Y": 0.21994578838348,
    "CMYK_C": 0,
    "CMYK_M": 0.03949634358287,
    "CMYK_Y": 0.06981740146875,
    "CMYK_K": 0.16139668226242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09608",
    "Farbtonhilfsbezeichnung": "D2.08.53",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "143",
    "Bcolor": "133",
    "Y": 29.1655158996582,
    "L": 60.927433013916,
    "a": 6.44246244430542,
    "b": 7.28088092803955,
    "C": 9.72196197509766,
    "h": 48.4961013793945,
    "CMY_C": 0.35839295387268,
    "CMY_M": 0.43965423107147,
    "CMY_Y": 0.47687244415283,
    "CMYK_C": 0,
    "CMYK_M": 0.12665271759033,
    "CMYK_Y": 0.18466052412987,
    "CMYK_K": 0.35839295387268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09609",
    "Farbtonhilfsbezeichnung": "D5.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "220",
    "Bcolor": "213",
    "Y": 73.3096237182617,
    "L": 88.5951766967773,
    "a": 2.85625123977661,
    "b": 3.9723687171936,
    "C": 4.89263582229614,
    "h": 54.2827415466309,
    "CMY_C": 0.09281927347183,
    "CMY_M": 0.13530015945435,
    "CMY_Y": 0.16345167160034,
    "CMYK_C": 0,
    "CMYK_M": 0.04682736843824,
    "CMYK_Y": 0.07785923779011,
    "CMYK_K": 0.09281927347183
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09610",
    "Farbtonhilfsbezeichnung": "D5.10.65",
    "Farbtonklasse": "02",
    "Rcolor": "198",
    "Gcolor": "171",
    "Bcolor": "156",
    "Y": 43.3554306030273,
    "L": 71.7955474853516,
    "a": 7.81564521789551,
    "b": 10.2273769378662,
    "C": 12.8718118667603,
    "h": 52.6133499145508,
    "CMY_C": 0.22530907392502,
    "CMY_M": 0.33074206113815,
    "CMY_Y": 0.38648629188538,
    "CMYK_C": 0,
    "CMYK_M": 0.13609683513641,
    "CMYK_Y": 0.20805357396603,
    "CMYK_K": 0.22530907392502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09611",
    "Farbtonhilfsbezeichnung": "D5.12.55",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "144",
    "Bcolor": "130",
    "Y": 30.1020679473877,
    "L": 61.7421836853027,
    "a": 8.22849941253662,
    "b": 10.4054756164551,
    "C": 13.2658252716065,
    "h": 51.6635627746582,
    "CMY_C": 0.33064568042755,
    "CMY_M": 0.43633222579956,
    "CMY_Y": 0.48979651927948,
    "CMYK_C": 0,
    "CMYK_M": 0.15789327025414,
    "CMYK_Y": 0.23776769638062,
    "CMYK_K": 0.33064568042755
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09612",
    "Farbtonhilfsbezeichnung": "D2.11.43",
    "Farbtonklasse": "03",
    "Rcolor": "142",
    "Gcolor": "118",
    "Bcolor": "109",
    "Y": 19.8806438446045,
    "L": 51.7019996643066,
    "a": 7.77675008773804,
    "b": 8.29372787475586,
    "C": 11.3694219589233,
    "h": 46.8425369262695,
    "CMY_C": 0.44351381063461,
    "CMY_M": 0.53578990697861,
    "CMY_Y": 0.57434689998627,
    "CMYK_C": 0,
    "CMYK_M": 0.16581919789314,
    "CMYK_Y": 0.23510572314262,
    "CMYK_K": 0.44351381063461
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09613",
    "Farbtonhilfsbezeichnung": "D2.12.24",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "81",
    "Bcolor": "74",
    "Y": 8.83260917663574,
    "L": 35.6599922180176,
    "a": 5.65088510513306,
    "b": 5.9074068069458,
    "C": 8.17495918273926,
    "h": 46.2714004516602,
    "CMY_C": 0.62144911289215,
    "CMY_M": 0.68400490283966,
    "CMY_Y": 0.70965301990509,
    "CMYK_C": 0,
    "CMYK_M": 0.16525067389011,
    "CMYK_Y": 0.23300409317017,
    "CMYK_K": 0.62144911289215
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09614",
    "Farbtonhilfsbezeichnung": "CN.02.82",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "219",
    "Bcolor": "213",
    "Y": 72.7301864624023,
    "L": 88.3188705444336,
    "a": 3.44626498222351,
    "b": 3.69628953933716,
    "C": 5.05364227294922,
    "h": 47.0048141479492,
    "CMY_C": 0.09229630231857,
    "CMY_M": 0.13970947265625,
    "CMY_Y": 0.16435444355011,
    "CMYK_C": 0,
    "CMYK_M": 0.0522341914475,
    "CMYK_Y": 0.07938509434462,
    "CMYK_K": 0.09229630231857
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09615",
    "Farbtonhilfsbezeichnung": "C9.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "206",
    "Bcolor": "200",
    "Y": 63.8868255615234,
    "L": 83.9068069458008,
    "a": 4.91803550720215,
    "b": 3.98820734024048,
    "C": 6.33189296722412,
    "h": 39.0398063659668,
    "CMY_C": 0.12953227758408,
    "CMY_M": 0.19187474250793,
    "CMY_Y": 0.21421641111374,
    "CMYK_C": 0,
    "CMYK_M": 0.07161950320005,
    "CMYK_Y": 0.09728578478098,
    "CMYK_K": 0.12953227758408
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09616",
    "Farbtonhilfsbezeichnung": "D0.22.41",
    "Farbtonklasse": "03",
    "Rcolor": "153",
    "Gcolor": "108",
    "Bcolor": "93",
    "Y": 18.3200035095215,
    "L": 49.8819618225098,
    "a": 16.0581798553467,
    "b": 15.2890167236328,
    "C": 22.1724872589111,
    "h": 43.5944213867188,
    "CMY_C": 0.39985013008118,
    "CMY_M": 0.57582211494446,
    "CMY_Y": 0.63650131225586,
    "CMYK_C": 0,
    "CMYK_M": 0.29321339726448,
    "CMYK_Y": 0.39432013034821,
    "CMYK_K": 0.39985013008118
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09617",
    "Farbtonhilfsbezeichnung": "D1.26.21",
    "Farbtonklasse": "03",
    "Rcolor": "101",
    "Gcolor": "73",
    "Bcolor": "63",
    "Y": 7.85096788406372,
    "L": 33.6705627441406,
    "a": 10.7243709564209,
    "b": 9.92959690093994,
    "C": 14.6153697967529,
    "h": 42.7963180541992,
    "CMY_C": 0.6046906709671,
    "CMY_M": 0.71469265222549,
    "CMY_Y": 0.75141942501068,
    "CMYK_C": 0,
    "CMYK_M": 0.27826809883118,
    "CMYK_Y": 0.37117451429367,
    "CMYK_K": 0.6046906709671
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09618",
    "Farbtonhilfsbezeichnung": "D6.25.43",
    "Farbtonklasse": "03",
    "Rcolor": "157",
    "Gcolor": "112",
    "Bcolor": "90",
    "Y": 19.5590534210205,
    "L": 51.3349571228027,
    "a": 14.9286775588989,
    "b": 19.1524753570557,
    "C": 24.2833843231201,
    "h": 52.0648460388184,
    "CMY_C": 0.38450437784195,
    "CMY_M": 0.55941289663315,
    "CMY_Y": 0.6486788392067,
    "CMYK_C": 0,
    "CMYK_M": 0.28417506814003,
    "CMYK_Y": 0.42920607328415,
    "CMYK_K": 0.38450437784195
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09619",
    "Farbtonhilfsbezeichnung": "E7.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "210",
    "Bcolor": "191",
    "Y": 66.1992263793945,
    "L": 85.0979385375977,
    "a": 3.64520692825317,
    "b": 10.5177001953125,
    "C": 11.1314668655396,
    "h": 70.8847885131836,
    "CMY_C": 0.10684454441071,
    "CMY_M": 0.17747473716736,
    "CMY_Y": 0.24921065568924,
    "CMYK_C": 0,
    "CMYK_M": 0.07907939702272,
    "CMYK_Y": 0.15939678251743,
    "CMYK_K": 0.10684454441071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09620",
    "Farbtonhilfsbezeichnung": "E2.17.58",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "153",
    "Bcolor": "127",
    "Y": 34.9702301025391,
    "L": 65.7254791259766,
    "a": 9.40196323394775,
    "b": 17.7320289611816,
    "C": 20.0704193115234,
    "h": 62.0663528442383,
    "CMY_C": 0.26447957754135,
    "CMY_M": 0.39985597133636,
    "CMY_Y": 0.50048363208771,
    "CMYK_C": 0,
    "CMYK_M": 0.18405525386333,
    "CMYK_Y": 0.32086676359177,
    "CMYK_K": 0.26447957754135
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09621",
    "Farbtonhilfsbezeichnung": "D8.24.44",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "117",
    "Bcolor": "93",
    "Y": 20.5589427947998,
    "L": 52.4633674621582,
    "a": 12.0756864547729,
    "b": 18.388635635376,
    "C": 21.9991855621338,
    "h": 56.7073783874512,
    "CMY_C": 0.39011180400848,
    "CMY_M": 0.54086434841156,
    "CMY_Y": 0.63347411155701,
    "CMYK_C": 0,
    "CMYK_M": 0.24718062579632,
    "CMYK_Y": 0.39902773499489,
    "CMYK_K": 0.39011180400848
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09622",
    "Farbtonhilfsbezeichnung": "DN.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "232",
    "Bcolor": "224",
    "Y": 81.5048294067383,
    "L": 92.3558654785156,
    "a": 1.98660087585449,
    "b": 3.63872575759888,
    "C": 4.14570951461792,
    "h": 61.3671989440918,
    "CMY_C": 0.05837386846542,
    "CMY_M": 0.09128618240356,
    "CMY_Y": 0.11980718374252,
    "CMYK_C": 0,
    "CMYK_M": 0.03495263308287,
    "CMYK_Y": 0.0652417242527,
    "CMYK_K": 0.05837386846542
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09623",
    "Farbtonhilfsbezeichnung": "D8.05.78",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "208",
    "Bcolor": "196",
    "Y": 65.6929702758789,
    "L": 84.8395614624023,
    "a": 4.97895383834839,
    "b": 7.70302629470825,
    "C": 9.1720552444458,
    "h": 57.1228523254395,
    "CMY_C": 0.10787659883499,
    "CMY_M": 0.18282049894333,
    "CMY_Y": 0.23121511936188,
    "CMYK_C": 0,
    "CMYK_M": 0.08400620520115,
    "CMYK_Y": 0.13825276494026,
    "CMYK_K": 0.10787659883499
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09624",
    "Farbtonhilfsbezeichnung": "E1.08.74",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "197",
    "Bcolor": "182",
    "Y": 58.345043182373,
    "L": 80.9302444458008,
    "a": 5.57192945480347,
    "b": 9.43526268005371,
    "C": 10.9576721191406,
    "h": 59.4363212585449,
    "CMY_C": 0.14234322309494,
    "CMY_M": 0.22731572389603,
    "CMY_Y": 0.28550028800964,
    "CMYK_C": 0,
    "CMYK_M": 0.09907518327236,
    "CMYK_Y": 0.1669165045023,
    "CMYK_K": 0.14234322309494
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09625",
    "Farbtonhilfsbezeichnung": "D6.19.41",
    "Farbtonklasse": "03",
    "Rcolor": "145",
    "Gcolor": "112",
    "Bcolor": "94",
    "Y": 18.4231872558594,
    "L": 50.0054206848145,
    "a": 10.7356643676758,
    "b": 14.3583841323853,
    "C": 17.9281253814697,
    "h": 53.2147903442383,
    "CMY_C": 0.43095880746841,
    "CMY_M": 0.56091523170471,
    "CMY_Y": 0.63014286756516,
    "CMYK_C": 0,
    "CMYK_M": 0.22837787866592,
    "CMYK_Y": 0.35003450512886,
    "CMYK_K": 0.43095880746841
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09626",
    "Farbtonhilfsbezeichnung": "D5.29.23",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "77",
    "Bcolor": "64",
    "Y": 8.96200752258301,
    "L": 35.9110412597656,
    "a": 11.5442667007446,
    "b": 13.0245218276978,
    "C": 17.404260635376,
    "h": 48.4478721618652,
    "CMY_C": 0.5730687379837,
    "CMY_M": 0.69674497842789,
    "CMY_Y": 0.75059688091278,
    "CMYK_C": 0,
    "CMYK_M": 0.28968653082848,
    "CMYK_Y": 0.41582372784615,
    "CMYK_K": 0.5730687379837
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09627",
    "Farbtonhilfsbezeichnung": "E1.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "233",
    "Bcolor": "224",
    "Y": 82.3613128662109,
    "L": 92.7341003417969,
    "a": 1.70594835281372,
    "b": 4.42767190933228,
    "C": 4.74494886398315,
    "h": 68.9287033081055,
    "CMY_C": 0.05376535654068,
    "CMY_M": 0.08659982681274,
    "CMY_Y": 0.12153780460358,
    "CMYK_C": 0,
    "CMYK_M": 0.03470013663173,
    "CMYK_Y": 0.07162330299616,
    "CMYK_K": 0.05376535654068
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09628",
    "Farbtonhilfsbezeichnung": "E5.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "218",
    "Bcolor": "207",
    "Y": 71.5538558959961,
    "L": 87.7534027099609,
    "a": 2.60473704338074,
    "b": 5.85007476806641,
    "C": 6.40375137329102,
    "h": 65.9990539550781,
    "CMY_C": 0.09834897518158,
    "CMY_M": 0.1445135474205,
    "CMY_Y": 0.18647730350494,
    "CMYK_C": 0,
    "CMYK_M": 0.05120004341006,
    "CMYK_Y": 0.09774105995893,
    "CMYK_K": 0.09834897518158
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09629",
    "Farbtonhilfsbezeichnung": "E1.10.70",
    "Farbtonklasse": "02",
    "Rcolor": "211",
    "Gcolor": "186",
    "Bcolor": "167",
    "Y": 51.601749420166,
    "L": 77.0420913696289,
    "a": 6.65459442138672,
    "b": 11.7942981719971,
    "C": 13.5421228408813,
    "h": 60.5673866271973,
    "CMY_C": 0.17170542478561,
    "CMY_M": 0.27246654033661,
    "CMY_Y": 0.34328752756119,
    "CMYK_C": 0,
    "CMYK_M": 0.12164889276028,
    "CMYK_Y": 0.20715107023716,
    "CMYK_K": 0.17170542478561
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09630",
    "Farbtonhilfsbezeichnung": "E1.15.62",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "163",
    "Bcolor": "141",
    "Y": 39.4670791625977,
    "L": 69.088264465332,
    "a": 8.37786674499512,
    "b": 15.0292043685913,
    "C": 17.2065582275391,
    "h": 60.8629951477051,
    "CMY_C": 0.23999279737473,
    "CMY_M": 0.36172634363174,
    "CMY_Y": 0.44790625572205,
    "CMYK_C": 0,
    "CMYK_M": 0.16017420589924,
    "CMYK_Y": 0.27356773614883,
    "CMYK_K": 0.23999279737473
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09631",
    "Farbtonhilfsbezeichnung": "D8.14.51",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "135",
    "Bcolor": "119",
    "Y": 26.2674388885498,
    "L": 58.2900352478027,
    "a": 7.65646982192993,
    "b": 12.0401811599731,
    "C": 14.2684087753296,
    "h": 57.5473136901855,
    "CMY_C": 0.36731052398682,
    "CMY_M": 0.47046941518784,
    "CMY_Y": 0.53523373603821,
    "CMYK_C": 0,
    "CMYK_M": 0.16304822266102,
    "CMYK_Y": 0.26541173458099,
    "CMYK_K": 0.36731052398682
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09632",
    "Farbtonhilfsbezeichnung": "D8.21.29",
    "Farbtonklasse": "03",
    "Rcolor": "112",
    "Gcolor": "88",
    "Bcolor": "73",
    "Y": 10.9603157043457,
    "L": 39.5135498046875,
    "a": 7.85544013977051,
    "b": 12.0769996643066,
    "C": 14.4070072174072,
    "h": 56.9581604003906,
    "CMY_C": 0.55903506278992,
    "CMY_M": 0.65433222055435,
    "CMY_Y": 0.71301019191742,
    "CMYK_C": 0,
    "CMYK_M": 0.21611051261425,
    "CMYK_Y": 0.34917771816254,
    "CMYK_K": 0.55903506278992
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09633",
    "Farbtonhilfsbezeichnung": "F0.03.87",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "234",
    "Bcolor": "225",
    "Y": 82.5629043579102,
    "L": 92.8227386474609,
    "a": 0.74544429779053,
    "b": 4.22727155685425,
    "C": 4.29249477386475,
    "h": 79.9991836547852,
    "CMY_C": 0.0608497262001,
    "CMY_M": 0.08323913812637,
    "CMY_Y": 0.11920946836472,
    "CMYK_C": 0,
    "CMYK_M": 0.0238400734961,
    "CMYK_Y": 0.06214100494981,
    "CMYK_K": 0.0608497262001
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09634",
    "Farbtonhilfsbezeichnung": "D8.06.74",
    "Farbtonklasse": "02",
    "Rcolor": "215",
    "Gcolor": "195",
    "Bcolor": "184",
    "Y": 57.0888938903809,
    "L": 80.2295684814453,
    "a": 5.46850728988647,
    "b": 7.62408781051636,
    "C": 9.3824987411499,
    "h": 54.3493728637695,
    "CMY_C": 0.1557776927948,
    "CMY_M": 0.23418325185776,
    "CMY_Y": 0.27988064289093,
    "CMYK_C": 0,
    "CMYK_M": 0.09287311881781,
    "CMYK_Y": 0.14700269699097,
    "CMYK_K": 0.1557776927948
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09635",
    "Farbtonhilfsbezeichnung": "E1.08.69",
    "Farbtonklasse": "02",
    "Rcolor": "203",
    "Gcolor": "183",
    "Bcolor": "168",
    "Y": 49.6413841247559,
    "L": 75.8486175537109,
    "a": 4.99936771392822,
    "b": 9.45577335357666,
    "C": 10.6960430145264,
    "h": 62.1341133117676,
    "CMY_C": 0.20236188173294,
    "CMY_M": 0.28065067529678,
    "CMY_Y": 0.33931142091751,
    "CMYK_C": 0,
    "CMYK_M": 0.09815076738596,
    "CMYK_Y": 0.17169383168221,
    "CMYK_K": 0.20236188173294
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09636",
    "Farbtonhilfsbezeichnung": "D8.14.39",
    "Farbtonklasse": "03",
    "Rcolor": "132",
    "Gcolor": "110",
    "Bcolor": "97",
    "Y": 17.0028629302979,
    "L": 48.2636375427246,
    "a": 6.65195465087891,
    "b": 10.0818061828613,
    "C": 12.0785474777222,
    "h": 56.5832557678223,
    "CMY_C": 0.48182010650635,
    "CMY_M": 0.56735163927078,
    "CMY_Y": 0.61920249462128,
    "CMYK_C": 0,
    "CMYK_M": 0.16506145894527,
    "CMYK_Y": 0.26512488722801,
    "CMYK_K": 0.48182010650635
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09637",
    "Farbtonhilfsbezeichnung": "D6.13.24",
    "Farbtonklasse": "03",
    "Rcolor": "97",
    "Gcolor": "82",
    "Bcolor": "74",
    "Y": 9.09271621704102,
    "L": 36.1621971130371,
    "a": 4.9505729675293,
    "b": 6.40201473236084,
    "C": 8.09283447265625,
    "h": 52.2858085632324,
    "CMY_C": 0.6196990609169,
    "CMY_M": 0.67794442176819,
    "CMY_Y": 0.70826369524002,
    "CMYK_C": 0,
    "CMYK_M": 0.15315596759319,
    "CMYK_Y": 0.2328803986311,
    "CMYK_K": 0.6196990609169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09638",
    "Farbtonhilfsbezeichnung": "E0.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "221",
    "Bcolor": "213",
    "Y": 73.1036529541016,
    "L": 88.4971237182617,
    "a": 1.54707849025726,
    "b": 4.10502481460571,
    "C": 4.38687610626221,
    "h": 69.3498611450195,
    "CMY_C": 0.1034734249115,
    "CMY_M": 0.13327407836914,
    "CMY_Y": 0.16568922996521,
    "CMYK_C": 0,
    "CMYK_M": 0.03324012458324,
    "CMYK_Y": 0.06939649581909,
    "CMYK_K": 0.1034734249115
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09639",
    "Farbtonhilfsbezeichnung": "E3.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "208",
    "Bcolor": "198",
    "Y": 64.1135482788086,
    "L": 84.0248565673828,
    "a": 2.44603681564331,
    "b": 5.27346754074097,
    "C": 5.8131365776062,
    "h": 65.1163177490234,
    "CMY_C": 0.14271634817123,
    "CMY_M": 0.184974193573,
    "CMY_Y": 0.22265642881393,
    "CMYK_C": 0,
    "CMYK_M": 0.04929272457957,
    "CMYK_Y": 0.09324811398983,
    "CMYK_K": 0.14271634817123
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09640",
    "Farbtonhilfsbezeichnung": "E0.03.72",
    "Farbtonklasse": "02",
    "Rcolor": "202",
    "Gcolor": "191",
    "Bcolor": "184",
    "Y": 53.4725646972656,
    "L": 78.1531829833984,
    "a": 2.7647807598114,
    "b": 4.23886442184448,
    "C": 5.06082820892334,
    "h": 56.8857765197754,
    "CMY_C": 0.20792269706726,
    "CMY_M": 0.24923491477966,
    "CMY_Y": 0.27801066637039,
    "CMYK_C": 0,
    "CMYK_M": 0.05215679854155,
    "CMYK_Y": 0.08848627656698,
    "CMYK_K": 0.20792269706726
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09641",
    "Farbtonhilfsbezeichnung": "E0.04.67",
    "Farbtonklasse": "02",
    "Rcolor": "193",
    "Gcolor": "181",
    "Bcolor": "172",
    "Y": 47.1961708068848,
    "L": 74.315071105957,
    "a": 2.99376726150513,
    "b": 5.22677659988403,
    "C": 6.02344036102295,
    "h": 60.1969985961914,
    "CMY_C": 0.24498677253723,
    "CMY_M": 0.29118639230728,
    "CMY_Y": 0.32558810710907,
    "CMYK_C": 0,
    "CMYK_M": 0.0611904785037,
    "CMYK_Y": 0.10675486177206,
    "CMYK_K": 0.24498677253723
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09642",
    "Farbtonhilfsbezeichnung": "E0.07.57",
    "Farbtonklasse": "02",
    "Rcolor": "170",
    "Gcolor": "155",
    "Bcolor": "145",
    "Y": 33.9986457824707,
    "L": 64.9614944458008,
    "a": 3.98936057090759,
    "b": 6.6117787361145,
    "C": 7.72208642959595,
    "h": 58.8944053649902,
    "CMY_C": 0.33410823345184,
    "CMY_M": 0.39223748445511,
    "CMY_Y": 0.43188202381134,
    "CMYK_C": 0,
    "CMYK_M": 0.08729534596205,
    "CMYK_Y": 0.1468313485384,
    "CMYK_K": 0.33410823345184
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09643",
    "Farbtonhilfsbezeichnung": "E3.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "73",
    "Bcolor": "64",
    "Y": 7.14014863967896,
    "L": 32.1238555908203,
    "a": 3.48545122146606,
    "b": 7.25566816329956,
    "C": 8.04941558837891,
    "h": 64.3414764404297,
    "CMY_C": 0.66490411758423,
    "CMY_M": 0.71208298206329,
    "CMY_Y": 0.74983930587769,
    "CMYK_C": 0,
    "CMYK_M": 0.14079213142395,
    "CMYK_Y": 0.25346532464027,
    "CMYK_K": 0.66490411758423
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09644",
    "Farbtonhilfsbezeichnung": "E3.07.69",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "183",
    "Bcolor": "169",
    "Y": 48.9558715820313,
    "L": 75.4238662719727,
    "a": 4.07285737991333,
    "b": 8.2732048034668,
    "C": 9.22139263153076,
    "h": 63.7892074584961,
    "CMY_C": 0.2167004942894,
    "CMY_M": 0.28267979621887,
    "CMY_Y": 0.33546656370163,
    "CMYK_C": 0,
    "CMYK_M": 0.08423253148794,
    "CMYK_Y": 0.15162280201912,
    "CMYK_K": 0.2167004942894
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09645",
    "Farbtonhilfsbezeichnung": "E1.08.63",
    "Farbtonklasse": "02",
    "Rcolor": "188",
    "Gcolor": "169",
    "Bcolor": "156",
    "Y": 41.6490745544434,
    "L": 70.6282958984375,
    "a": 4.9002947807312,
    "b": 8.90996074676514,
    "C": 10.1685934066773,
    "h": 61.190113067627,
    "CMY_C": 0.26124310493469,
    "CMY_M": 0.33570426702499,
    "CMY_Y": 0.38970392942429,
    "CMYK_C": 0,
    "CMYK_M": 0.10079251229763,
    "CMYK_Y": 0.17388781905174,
    "CMYK_K": 0.26124310493469
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09646",
    "Farbtonhilfsbezeichnung": "D8.12.43",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "120",
    "Bcolor": "107",
    "Y": 20.2515106201172,
    "L": 52.1203918457031,
    "a": 6.34980916976929,
    "b": 9.64042854309082,
    "C": 11.543740272522,
    "h": 56.6285171508789,
    "CMY_C": 0.44515752792358,
    "CMY_M": 0.52863740921021,
    "CMY_Y": 0.57943618297577,
    "CMYK_C": 0,
    "CMYK_M": 0.15045690536499,
    "CMYK_Y": 0.24201221764088,
    "CMYK_K": 0.44515752792358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09647",
    "Farbtonhilfsbezeichnung": "D6.17.33",
    "Farbtonklasse": "03",
    "Rcolor": "122",
    "Gcolor": "97",
    "Bcolor": "84",
    "Y": 13.3478851318359,
    "L": 43.2828140258789,
    "a": 8.05984306335449,
    "b": 10.8299083709717,
    "C": 13.4999256134033,
    "h": 53.3426094055176,
    "CMY_C": 0.52235174179077,
    "CMY_M": 0.61884999275208,
    "CMY_Y": 0.67051470279694,
    "CMYK_C": 0,
    "CMYK_M": 0.20202785730362,
    "CMYK_Y": 0.31019261479378,
    "CMYK_K": 0.52235174179077
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09648",
    "Farbtonhilfsbezeichnung": "D7.18.18",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "71",
    "Bcolor": "64",
    "Y": 6.83270406723022,
    "L": 31.422981262207,
    "a": 5.16714715957642,
    "b": 6.39893007278442,
    "C": 8.22470188140869,
    "h": 51.0790634155273,
    "CMY_C": 0.66355669498444,
    "CMY_M": 0.72180515527725,
    "CMY_Y": 0.75059282779694,
    "CMYK_C": 0,
    "CMYK_M": 0.17313009500504,
    "CMYK_Y": 0.25869479775429,
    "CMYK_K": 0.66355669498444
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09649",
    "Farbtonhilfsbezeichnung": "E7.08.74",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "197",
    "Bcolor": "180",
    "Y": 57.8671875,
    "L": 80.6648941040039,
    "a": 3.76448917388916,
    "b": 10.2412481307983,
    "C": 10.9112119674683,
    "h": 69.8175277709961,
    "CMY_C": 0.15602242946625,
    "CMY_M": 0.22602206468582,
    "CMY_Y": 0.29442483186722,
    "CMYK_C": 0,
    "CMYK_M": 0.08294016122818,
    "CMYK_Y": 0.16398824751377,
    "CMYK_K": 0.15602242946625
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09650",
    "Farbtonhilfsbezeichnung": "E7.10.70",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "186",
    "Bcolor": "165",
    "Y": 50.7939338684082,
    "L": 76.5540161132813,
    "a": 4.41938781738281,
    "b": 12.22487449646,
    "C": 12.9991750717163,
    "h": 70.1246795654297,
    "CMY_C": 0.19152563810349,
    "CMY_M": 0.27239060401917,
    "CMY_Y": 0.35182982683182,
    "CMYK_C": 0,
    "CMYK_M": 0.10002168267965,
    "CMYK_Y": 0.19827987253666,
    "CMYK_K": 0.19152563810349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09651",
    "Farbtonhilfsbezeichnung": "E1.14.50",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "136",
    "Bcolor": "118",
    "Y": 26.3358688354492,
    "L": 58.3544921875,
    "a": 6.85918092727661,
    "b": 12.4526329040527,
    "C": 14.2167654037476,
    "h": 61.1530723571777,
    "CMY_C": 0.37080526351929,
    "CMY_M": 0.46801972389221,
    "CMY_Y": 0.53752851486206,
    "CMYK_C": 0,
    "CMYK_M": 0.15450616180897,
    "CMYK_Y": 0.26497876644135,
    "CMYK_K": 0.37080526351929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09652",
    "Farbtonhilfsbezeichnung": "E1.15.37",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "106",
    "Bcolor": "90",
    "Y": 15.4492769241333,
    "L": 46.2435035705566,
    "a": 6.14305877685547,
    "b": 11.219072341919,
    "C": 12.790807723999,
    "h": 61.2968711853027,
    "CMY_C": 0.5030882358551,
    "CMY_M": 0.58606684207916,
    "CMY_Y": 0.64574861526489,
    "CMYK_C": 0,
    "CMYK_M": 0.16698861122131,
    "CMYK_Y": 0.28709399700165,
    "CMYK_K": 0.5030882358551
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09653",
    "Farbtonhilfsbezeichnung": "E7.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "219",
    "Bcolor": "203",
    "Y": 72.652473449707,
    "L": 88.2817001342773,
    "a": 3.19254183769226,
    "b": 8.76521015167236,
    "C": 9.32851696014404,
    "h": 69.9869232177734,
    "CMY_C": 0.07943856716156,
    "CMY_M": 0.14087402820587,
    "CMY_Y": 0.20210182666779,
    "CMYK_C": 0,
    "CMYK_M": 0.06673695147038,
    "CMYK_Y": 0.13324831426144,
    "CMYK_K": 0.07943856716156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09654",
    "Farbtonhilfsbezeichnung": "E4.10.76",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "200",
    "Bcolor": "179",
    "Y": 60.5580635070801,
    "L": 82.1405868530273,
    "a": 5.77397632598877,
    "b": 13.0289649963379,
    "C": 14.2510604858398,
    "h": 66.0987701416016,
    "CMY_C": 0.11804246902466,
    "CMY_M": 0.21557682752609,
    "CMY_Y": 0.29868531227112,
    "CMYK_C": 0,
    "CMYK_M": 0.11058849841356,
    "CMYK_Y": 0.20482033491135,
    "CMYK_K": 0.11804246902466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09655",
    "Farbtonhilfsbezeichnung": "E4.14.68",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "176",
    "Bcolor": "152",
    "Y": 46.5336036682129,
    "L": 73.8904495239258,
    "a": 7.42738199234009,
    "b": 15.8530950546265,
    "C": 17.5067596435547,
    "h": 64.8963012695313,
    "CMY_C": 0.19163680076599,
    "CMY_M": 0.30895388126373,
    "CMY_Y": 0.40485066175461,
    "CMYK_C": 0,
    "CMYK_M": 0.14512917399406,
    "CMYK_Y": 0.26375997066498,
    "CMYK_K": 0.19163680076599
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09656",
    "Farbtonhilfsbezeichnung": "D9.19.42",
    "Farbtonklasse": "03",
    "Rcolor": "143",
    "Gcolor": "113",
    "Bcolor": "94",
    "Y": 18.5290622711182,
    "L": 50.1316146850586,
    "a": 9.01600933074951,
    "b": 14.5495080947876,
    "C": 17.1165599822998,
    "h": 58.2144203186035,
    "CMY_C": 0.43948143720627,
    "CMY_M": 0.55556416511536,
    "CMY_Y": 0.63051068782806,
    "CMYK_C": 0,
    "CMYK_M": 0.20709881186485,
    "CMYK_Y": 0.3408080637455,
    "CMYK_K": 0.43948143720627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09657",
    "Farbtonhilfsbezeichnung": "E3.23.26",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "84",
    "Bcolor": "68",
    "Y": 9.85863876342773,
    "L": 37.587516784668,
    "a": 7.34578704833984,
    "b": 12.3202314376831,
    "C": 14.3439426422119,
    "h": 59.195011138916,
    "CMY_C": 0.58063209056854,
    "CMY_M": 0.67122346162796,
    "CMY_Y": 0.73197513818741,
    "CMYK_C": 0,
    "CMYK_M": 0.21601884067059,
    "CMYK_Y": 0.36088371276855,
    "CMYK_K": 0.58063209056854
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09658",
    "Farbtonhilfsbezeichnung": "F8.07.85",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "233",
    "Bcolor": "214",
    "Y": 82.0830078125,
    "L": 92.6114807128906,
    "a": 0.454909324646,
    "b": 9.67544651031494,
    "C": 9.68613529205322,
    "h": 87.3081130981445,
    "CMY_C": 0.04859662055969,
    "CMY_M": 0.08637011051178,
    "CMY_Y": 0.16212064027786,
    "CMYK_C": 0,
    "CMYK_M": 0.0397029183805,
    "CMYK_Y": 0.11932270228863,
    "CMYK_K": 0.04859662055969
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09659",
    "Farbtonhilfsbezeichnung": "E7.12.72",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "191",
    "Bcolor": "165",
    "Y": 54.6117973327637,
    "L": 78.8171310424805,
    "a": 5.5026593208313,
    "b": 15.4739904403687,
    "C": 16.4232654571533,
    "h": 70.4242553710938,
    "CMY_C": 0.15096700191498,
    "CMY_M": 0.25146615505219,
    "CMY_Y": 0.351393699646,
    "CMYK_C": 0,
    "CMYK_M": 0.118368960917,
    "CMYK_Y": 0.23606467247009,
    "CMYK_K": 0.15096700191498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09660",
    "Farbtonhilfsbezeichnung": "E7.18.65",
    "Farbtonklasse": "02",
    "Rcolor": "200",
    "Gcolor": "168",
    "Bcolor": "137",
    "Y": 42.3143119812012,
    "L": 71.0870819091797,
    "a": 7.31683969497681,
    "b": 20.2338428497314,
    "C": 21.5161457061768,
    "h": 70.1193008422852,
    "CMY_C": 0.21392202377319,
    "CMY_M": 0.33929598331451,
    "CMY_Y": 0.46464455127716,
    "CMYK_C": 0,
    "CMYK_M": 0.15949302911758,
    "CMYK_Y": 0.3189537525177,
    "CMYK_K": 0.21392202377319
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09661",
    "Farbtonhilfsbezeichnung": "E4.22.49",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "131",
    "Bcolor": "103",
    "Y": 25.2185516357422,
    "L": 57.2877502441406,
    "a": 8.73505115509033,
    "b": 19.5859031677246,
    "C": 21.4454822540283,
    "h": 65.9637680053711,
    "CMY_C": 0.35639780759811,
    "CMY_M": 0.4847714304924,
    "CMY_Y": 0.59615010023117,
    "CMYK_C": 0,
    "CMYK_M": 0.19946113228798,
    "CMYK_Y": 0.37251627445221,
    "CMYK_K": 0.35639780759811
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09662",
    "Farbtonhilfsbezeichnung": "E5.25.31",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "92",
    "Bcolor": "71",
    "Y": 11.8359088897705,
    "L": 40.9541244506836,
    "a": 6.71755456924438,
    "b": 15.4760046005249,
    "C": 16.8710479736328,
    "h": 66.5361404418945,
    "CMY_C": 0.54523754119873,
    "CMY_M": 0.63881683349609,
    "CMY_Y": 0.72184944152832,
    "CMYK_C": 0,
    "CMYK_M": 0.20577619969845,
    "CMYK_Y": 0.38836076855659,
    "CMYK_K": 0.54523754119873
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09663",
    "Farbtonhilfsbezeichnung": "F3.04.85",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "228",
    "Bcolor": "213",
    "Y": 78.5793991088867,
    "L": 91.0436477661133,
    "a": 1.69096505641937,
    "b": 7.55046796798706,
    "C": 7.73750162124634,
    "h": 77.3766174316406,
    "CMY_C": 0.06323677301407,
    "CMY_M": 0.10627657175064,
    "CMY_Y": 0.16328871250153,
    "CMYK_C": 0,
    "CMYK_M": 0.04594522714615,
    "CMYK_Y": 0.10680601000786,
    "CMYK_K": 0.06323677301407
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09664",
    "Farbtonhilfsbezeichnung": "F1.11.77",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "203",
    "Bcolor": "179",
    "Y": 61.4373512268066,
    "L": 82.6132965087891,
    "a": 3.75002145767212,
    "b": 13.7759389877319,
    "C": 14.2772254943848,
    "h": 74.7721862792969,
    "CMY_C": 0.12517291307449,
    "CMY_M": 0.20569026470184,
    "CMY_Y": 0.29944533109665,
    "CMYK_C": 0,
    "CMYK_M": 0.0920380204916,
    "CMYK_Y": 0.19920784235001,
    "CMYK_K": 0.12517291307449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09665",
    "Farbtonhilfsbezeichnung": "F1.11.72",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "192",
    "Bcolor": "166",
    "Y": 54.4743423461914,
    "L": 78.7375183105469,
    "a": 3.44120454788208,
    "b": 14.7223711013794,
    "C": 15.1191959381104,
    "h": 76.8438873291016,
    "CMY_C": 0.1680212020874,
    "CMY_M": 0.24717700481415,
    "CMY_Y": 0.34714263677597,
    "CMYK_C": 0,
    "CMYK_M": 0.09514161199331,
    "CMYK_Y": 0.21529567241669,
    "CMYK_K": 0.1680212020874
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09666",
    "Farbtonhilfsbezeichnung": "E5.31.41",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "110",
    "Bcolor": "78",
    "Y": 17.847583770752,
    "L": 49.3107223510742,
    "a": 10.0475406646729,
    "b": 23.1828327178955,
    "C": 25.2665157318115,
    "h": 66.5678863525391,
    "CMY_C": 0.4278336763382,
    "CMY_M": 0.56772148609161,
    "CMY_Y": 0.69559818506241,
    "CMYK_C": 0,
    "CMYK_M": 0.24448801577091,
    "CMYK_Y": 0.46798369288445,
    "CMYK_K": 0.4278336763382
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09667",
    "Farbtonhilfsbezeichnung": "E6.31.26",
    "Farbtonklasse": "03",
    "Rcolor": "109",
    "Gcolor": "83",
    "Bcolor": "62",
    "Y": 9.78099822998047,
    "L": 37.4464721679688,
    "a": 7.76598978042603,
    "b": 16.1049385070801,
    "C": 17.8795871734619,
    "h": 64.2560882568359,
    "CMY_C": 0.57352888584137,
    "CMY_M": 0.67419373989105,
    "CMY_Y": 0.75705564022064,
    "CMYK_C": 0,
    "CMYK_M": 0.23604144155979,
    "CMYK_Y": 0.4303380548954,
    "CMYK_K": 0.57352888584137
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09668",
    "Farbtonhilfsbezeichnung": "F3.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "233",
    "Bcolor": "221",
    "Y": 82.3676834106445,
    "L": 92.7369003295898,
    "a": 1.18017745018005,
    "b": 6.18611192703247,
    "C": 6.29768228530884,
    "h": 79.1989898681641,
    "CMY_C": 0.05225080251694,
    "CMY_M": 0.08578211069107,
    "CMY_Y": 0.13466256856918,
    "CMYK_C": 0,
    "CMYK_M": 0.03537993878126,
    "CMYK_Y": 0.08695524930954,
    "CMYK_K": 0.05225080251694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09669",
    "Farbtonhilfsbezeichnung": "F0.08.79",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "212",
    "Bcolor": "191",
    "Y": 67.8504638671875,
    "L": 85.9316253662109,
    "a": 3.23403239250183,
    "b": 12.0053825378418,
    "C": 12.433349609375,
    "h": 74.9234390258789,
    "CMY_C": 0.09644734859467,
    "CMY_M": 0.16770541667938,
    "CMY_Y": 0.2512384057045,
    "CMYK_C": 0,
    "CMYK_M": 0.07886432111263,
    "CMYK_Y": 0.17131382226944,
    "CMYK_K": 0.09644734859467
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09670",
    "Farbtonhilfsbezeichnung": "E7.15.62",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "165",
    "Bcolor": "138",
    "Y": 39.7832794189453,
    "L": 69.3148956298828,
    "a": 5.65682411193848,
    "b": 16.6311740875244,
    "C": 17.5668888092041,
    "h": 71.2150955200195,
    "CMY_C": 0.25191342830658,
    "CMY_M": 0.35312080383301,
    "CMY_Y": 0.45735168457031,
    "CMYK_C": 0,
    "CMYK_M": 0.1352883130312,
    "CMYK_Y": 0.27461829781532,
    "CMYK_K": 0.25191342830658
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09671",
    "Farbtonhilfsbezeichnung": "F0.07.79",
    "Farbtonklasse": "01",
    "Rcolor": "227",
    "Gcolor": "211",
    "Bcolor": "193",
    "Y": 66.6062622070313,
    "L": 85.3047180175781,
    "a": 3.13759517669678,
    "b": 9.98588466644287,
    "C": 10.4672060012817,
    "h": 72.55712890625,
    "CMY_C": 0.10970765352249,
    "CMY_M": 0.17384392023087,
    "CMY_Y": 0.24318134784698,
    "CMYK_C": 0,
    "CMYK_M": 0.07203955948353,
    "CMYK_Y": 0.14992119371891,
    "CMYK_K": 0.10970765352249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09672",
    "Farbtonhilfsbezeichnung": "F0.09.75",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "200",
    "Bcolor": "179",
    "Y": 59.7433967590332,
    "L": 81.6985168457031,
    "a": 3.55150723457336,
    "b": 12.0709495544434,
    "C": 12.5825681686401,
    "h": 73.605094909668,
    "CMY_C": 0.14120936393738,
    "CMY_M": 0.21474748849869,
    "CMY_Y": 0.29676699638367,
    "CMYK_C": 0,
    "CMYK_M": 0.08562986552715,
    "CMYK_Y": 0.18113568425179,
    "CMYK_K": 0.14120936393738
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09673",
    "Farbtonhilfsbezeichnung": "F0.13.73",
    "Farbtonklasse": "02",
    "Rcolor": "216",
    "Gcolor": "192",
    "Bcolor": "163",
    "Y": 55.1816101074219,
    "L": 79.1457595825195,
    "a": 4.34109020233154,
    "b": 17.1141166687012,
    "C": 17.6561050415039,
    "h": 75.7667999267578,
    "CMY_C": 0.15143007040024,
    "CMY_M": 0.24549043178558,
    "CMY_Y": 0.36002153158188,
    "CMYK_C": 0,
    "CMYK_M": 0.11084573715925,
    "CMYK_Y": 0.24581529200077,
    "CMYK_K": 0.15143007040024
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09674",
    "Farbtonhilfsbezeichnung": "F0.17.64",
    "Farbtonklasse": "02",
    "Rcolor": "197",
    "Gcolor": "170",
    "Bcolor": "138",
    "Y": 42.601448059082,
    "L": 71.2836227416992,
    "a": 5.21476984024048,
    "b": 19.3932113647461,
    "C": 20.0820941925049,
    "h": 74.9493560791016,
    "CMY_C": 0.2273234128952,
    "CMY_M": 0.33196240663528,
    "CMY_Y": 0.45705664157867,
    "CMYK_C": 0,
    "CMYK_M": 0.13542404770851,
    "CMYK_Y": 0.29732131958008,
    "CMYK_K": 0.2273234128952
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09675",
    "Farbtonhilfsbezeichnung": "E8.30.29",
    "Farbtonklasse": "03",
    "Rcolor": "113",
    "Gcolor": "90",
    "Bcolor": "66",
    "Y": 11.3132019042969,
    "L": 40.1030540466309,
    "a": 5.90223550796509,
    "b": 17.1609058380127,
    "C": 18.1475372314453,
    "h": 71.0201187133789,
    "CMY_C": 0.5556817650795,
    "CMY_M": 0.64531314373016,
    "CMY_Y": 0.74049466848373,
    "CMYK_C": 0,
    "CMYK_M": 0.20172788202763,
    "CMYK_Y": 0.41594713926315,
    "CMYK_K": 0.5556817650795
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09676",
    "Farbtonhilfsbezeichnung": "F0.03.84",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "226",
    "Bcolor": "217",
    "Y": 76.6986999511719,
    "L": 90.1827545166016,
    "a": 0.48269701004028,
    "b": 4.26994752883911,
    "C": 4.29714441299438,
    "h": 83.5503692626953,
    "CMY_C": 0.09233069419861,
    "CMY_M": 0.11207407712936,
    "CMY_Y": 0.14860916137695,
    "CMYK_C": 0,
    "CMYK_M": 0.02175173535943,
    "CMYK_Y": 0.06200327351689,
    "CMYK_K": 0.09233069419861
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09677",
    "Farbtonhilfsbezeichnung": "F4.06.73",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "197",
    "Bcolor": "182",
    "Y": 56.4644088745117,
    "L": 79.8774032592773,
    "a": 1.47551953792572,
    "b": 7.97750377655029,
    "C": 8.11281204223633,
    "h": 79.52099609375,
    "CMY_C": 0.18758690357208,
    "CMY_M": 0.2285481095314,
    "CMY_Y": 0.28677177429199,
    "CMYK_C": 0,
    "CMYK_M": 0.0504191853106,
    "CMYK_Y": 0.1220867484808,
    "CMYK_K": 0.18758690357208
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09678",
    "Farbtonhilfsbezeichnung": "F0.09.71",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "187",
    "Bcolor": "167",
    "Y": 51.3424644470215,
    "L": 76.8859939575195,
    "a": 3.24186897277832,
    "b": 11.6484651565552,
    "C": 12.0911722183228,
    "h": 74.4476547241211,
    "CMY_C": 0.19762676954269,
    "CMY_M": 0.265884578228,
    "CMY_Y": 0.34441822767258,
    "CMYK_C": 0,
    "CMYK_M": 0.08506989479065,
    "CMYK_Y": 0.18294660747051,
    "CMYK_K": 0.19762676954269
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09679",
    "Farbtonhilfsbezeichnung": "F0.11.61",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "162",
    "Bcolor": "142",
    "Y": 37.5217704772949,
    "L": 67.6666564941406,
    "a": 3.28139019012451,
    "b": 12.1408948898315,
    "C": 12.5765199661255,
    "h": 74.8756942749023,
    "CMY_C": 0.29607337713242,
    "CMY_M": 0.36376440525055,
    "CMY_Y": 0.44292169809341,
    "CMYK_C": 0,
    "CMYK_M": 0.09616205096245,
    "CMYK_Y": 0.20861311256886,
    "CMYK_K": 0.29607337713242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09680",
    "Farbtonhilfsbezeichnung": "E5.15.25",
    "Farbtonklasse": "03",
    "Rcolor": "94",
    "Gcolor": "81",
    "Bcolor": "70",
    "Y": 8.69360065460205,
    "L": 35.3875465393066,
    "a": 3.26927971839905,
    "b": 8.24183559417725,
    "C": 8.86656856536865,
    "h": 68.3633193969727,
    "CMY_C": 0.63321250677109,
    "CMY_M": 0.68191862106323,
    "CMY_Y": 0.72687780857086,
    "CMYK_C": 0,
    "CMYK_M": 0.13279110193253,
    "CMYK_Y": 0.25536668300629,
    "CMYK_K": 0.63321250677109
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09681",
    "Farbtonhilfsbezeichnung": "F1.03.82",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "222",
    "Bcolor": "211",
    "Y": 73.5333633422852,
    "L": 88.7014770507813,
    "a": 1.41815960407257,
    "b": 5.57420778274536,
    "C": 5.75177955627441,
    "h": 75.725944519043,
    "CMY_C": 0.0975860953331,
    "CMY_M": 0.13110339641571,
    "CMY_Y": 0.17429792881012,
    "CMYK_C": 0,
    "CMYK_M": 0.03714182600379,
    "CMYK_Y": 0.08500736951828,
    "CMYK_K": 0.0975860953331
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09682",
    "Farbtonhilfsbezeichnung": "F0.06.79",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "209",
    "Bcolor": "195",
    "Y": 64.6084060668945,
    "L": 84.2815399169922,
    "a": 2.13645482063293,
    "b": 7.61338043212891,
    "C": 7.9074649810791,
    "h": 74.3249053955078,
    "CMY_C": 0.1352276802063,
    "CMY_M": 0.18204563856125,
    "CMY_Y": 0.23699182271957,
    "CMYK_C": 0,
    "CMYK_M": 0.05413905903697,
    "CMYK_Y": 0.11767738312483,
    "CMYK_K": 0.1352276802063
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09683",
    "Farbtonhilfsbezeichnung": "F0.07.74",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "201",
    "Bcolor": "183",
    "Y": 59.734691619873,
    "L": 81.6937637329102,
    "a": 2.74216771125793,
    "b": 10.1242418289185,
    "C": 10.4890298843384,
    "h": 74.8449554443359,
    "CMY_C": 0.15232783555984,
    "CMY_M": 0.21237576007843,
    "CMY_Y": 0.28281825780869,
    "CMYK_C": 0,
    "CMYK_M": 0.07083861529827,
    "CMYK_Y": 0.15393972396851,
    "CMYK_K": 0.15232783555984
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09684",
    "Farbtonhilfsbezeichnung": "F0.09.65",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "174",
    "Bcolor": "156",
    "Y": 43.4212646484375,
    "L": 71.8399658203125,
    "a": 2.81882452964783,
    "b": 10.4247531890869,
    "C": 10.7991323471069,
    "h": 74.8692169189453,
    "CMY_C": 0.25869554281235,
    "CMY_M": 0.31838274002075,
    "CMY_Y": 0.38819980621338,
    "CMYK_C": 0,
    "CMYK_M": 0.08051644265652,
    "CMYK_Y": 0.17469780147076,
    "CMYK_K": 0.25869554281235
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09685",
    "Farbtonhilfsbezeichnung": "F0.10.54",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "146",
    "Bcolor": "131",
    "Y": 29.8061637878418,
    "L": 61.4866142272949,
    "a": 2.69854378700256,
    "b": 9.65709209442139,
    "C": 10.0270414352417,
    "h": 74.3877029418945,
    "CMY_C": 0.37164658308029,
    "CMY_M": 0.42584872245789,
    "CMY_Y": 0.48807549476624,
    "CMYK_C": 0,
    "CMYK_M": 0.08626059442759,
    "CMYK_Y": 0.18529208004475,
    "CMYK_K": 0.37164658308029
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09686",
    "Farbtonhilfsbezeichnung": "E8.17.22",
    "Farbtonklasse": "03",
    "Rcolor": "90",
    "Gcolor": "78",
    "Bcolor": "67",
    "Y": 7.99025058746338,
    "L": 33.962574005127,
    "a": 3.22355508804321,
    "b": 7.9020414352417,
    "C": 8.53425884246826,
    "h": 67.8075103759766,
    "CMY_C": 0.64774525165558,
    "CMY_M": 0.69487655162811,
    "CMY_Y": 0.73752105236053,
    "CMYK_C": 0,
    "CMYK_M": 0.13379891216755,
    "CMYK_Y": 0.25486043095589,
    "CMYK_K": 0.64774525165558
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09687",
    "Farbtonhilfsbezeichnung": "E9.05.79",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "215",
    "Bcolor": "201",
    "Y": 69.4506378173828,
    "L": 86.7267150878906,
    "a": 2.22725677490234,
    "b": 7.66828584671021,
    "C": 7.98519134521484,
    "h": 73.8040390014648,
    "CMY_C": 0.1072051525116,
    "CMY_M": 0.15541678667068,
    "CMY_Y": 0.21101933717728,
    "CMYK_C": 0,
    "CMYK_M": 0.05400079861283,
    "CMYK_Y": 0.11627999693155,
    "CMYK_K": 0.1072051525116
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09688",
    "Farbtonhilfsbezeichnung": "F0.06.74",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "198",
    "Bcolor": "183",
    "Y": 57.2353553771973,
    "L": 80.3117904663086,
    "a": 2.06674146652222,
    "b": 7.80224704742432,
    "C": 8.07133674621582,
    "h": 75.1636352539063,
    "CMY_C": 0.1789932847023,
    "CMY_M": 0.2251872420311,
    "CMY_Y": 0.2808044552803,
    "CMYK_C": 0,
    "CMYK_M": 0.05626501888037,
    "CMYK_Y": 0.12400771677494,
    "CMYK_K": 0.1789932847023
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09689",
    "Farbtonhilfsbezeichnung": "F0.06.64",
    "Farbtonklasse": "02",
    "Rcolor": "182",
    "Gcolor": "172",
    "Bcolor": "159",
    "Y": 41.8886947631836,
    "L": 70.7941131591797,
    "a": 1.78276169300079,
    "b": 7.30962705612183,
    "C": 7.52388763427734,
    "h": 76.293586730957,
    "CMY_C": 0.2856251001358,
    "CMY_M": 0.32627862691879,
    "CMY_Y": 0.37719714641571,
    "CMYK_C": 0,
    "CMYK_M": 0.05690783262253,
    "CMYK_Y": 0.12818485498428,
    "CMYK_K": 0.2856251001358
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09690",
    "Farbtonhilfsbezeichnung": "F0.08.59",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "159",
    "Bcolor": "144",
    "Y": 35.4931488037109,
    "L": 66.1308212280273,
    "a": 2.11363124847412,
    "b": 8.68855094909668,
    "C": 8.94194316864014,
    "h": 76.3274459838867,
    "CMY_C": 0.32920700311661,
    "CMY_M": 0.37628751993179,
    "CMY_Y": 0.43464773893356,
    "CMYK_C": 0,
    "CMYK_M": 0.07018635421991,
    "CMYK_Y": 0.15718819200993,
    "CMYK_K": 0.32920700311661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09691",
    "Farbtonhilfsbezeichnung": "E7.10.53",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "143",
    "Bcolor": "128",
    "Y": 28.6062507629395,
    "L": 60.4325370788574,
    "a": 3.46183133125305,
    "b": 9.50518989562988,
    "C": 10.1159734725952,
    "h": 69.9881591796875,
    "CMY_C": 0.37793308496475,
    "CMY_M": 0.43833804130554,
    "CMY_Y": 0.49743849039078,
    "CMYK_C": 0,
    "CMYK_M": 0.09710363298655,
    "CMYK_Y": 0.19211021065712,
    "CMYK_K": 0.37793308496475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09692",
    "Farbtonhilfsbezeichnung": "E7.10.35",
    "Farbtonklasse": "03",
    "Rcolor": "114",
    "Gcolor": "102",
    "Bcolor": "91",
    "Y": 13.9199924468994,
    "L": 44.1179733276367,
    "a": 2.94650030136108,
    "b": 7.44692325592041,
    "C": 8.00865364074707,
    "h": 68.4129333496094,
    "CMY_C": 0.55214047431946,
    "CMY_M": 0.59869629144669,
    "CMY_Y": 0.64177894592285,
    "CMYK_C": 0,
    "CMYK_M": 0.10395182669163,
    "CMYK_Y": 0.20014862716198,
    "CMYK_K": 0.55214047431946
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09693",
    "Farbtonhilfsbezeichnung": "E5.09.13",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "67",
    "Bcolor": "63",
    "Y": 5.7275915145874,
    "L": 28.7145328521729,
    "a": 1.77892303466797,
    "b": 2.94354891777039,
    "C": 3.43933820724487,
    "h": 58.8534851074219,
    "CMY_C": 0.71595764160156,
    "CMY_M": 0.73845171928406,
    "CMY_Y": 0.75415843725204,
    "CMYK_C": 0,
    "CMYK_M": 0.07919269055128,
    "CMYK_Y": 0.13448978960514,
    "CMYK_K": 0.71595764160156
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09694",
    "Farbtonhilfsbezeichnung": "F6.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "234",
    "Bcolor": "224",
    "Y": 82.8918228149414,
    "L": 92.9670562744141,
    "a": 0.53425705432892,
    "b": 4.97314357757568,
    "C": 5.00175857543945,
    "h": 83.8683242797852,
    "CMY_C": 0.05847364664078,
    "CMY_M": 0.08132320642471,
    "CMY_Y": 0.12319749593735,
    "CMYK_C": 0,
    "CMYK_M": 0.02426863461733,
    "CMYK_Y": 0.06874353438616,
    "CMYK_K": 0.05847364664078
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09695",
    "Farbtonhilfsbezeichnung": "F8.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "223",
    "Bcolor": "208",
    "Y": 73.9034881591797,
    "L": 88.8768539428711,
    "a": 0.09702645987272,
    "b": 7.40001249313354,
    "C": 7.40064859390259,
    "h": 89.2487945556641,
    "CMY_C": 0.10008180141449,
    "CMY_M": 0.12650293111801,
    "CMY_Y": 0.1860454082489,
    "CMYK_C": 0,
    "CMYK_M": 0.02935947850347,
    "CMYK_Y": 0.09552380442619,
    "CMYK_K": 0.10008180141449
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09696",
    "Farbtonhilfsbezeichnung": "F6.06.78",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "212",
    "Bcolor": "195",
    "Y": 66.4485092163086,
    "L": 85.2246780395508,
    "a": 1.04803192615509,
    "b": 8.71299362182617,
    "C": 8.77579784393311,
    "h": 83.1411972045898,
    "CMY_C": 0.12964683771133,
    "CMY_M": 0.16940104961395,
    "CMY_Y": 0.23504930734634,
    "CMYK_C": 0,
    "CMYK_M": 0.0456759557128,
    "CMYK_Y": 0.12110310047865,
    "CMYK_K": 0.12964683771133
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09697",
    "Farbtonhilfsbezeichnung": "F0.14.45",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "126",
    "Bcolor": "107",
    "Y": 21.5216541290283,
    "L": 53.5157432556152,
    "a": 3.03695583343506,
    "b": 11.9508390426636,
    "C": 12.3306789398193,
    "h": 75.7417602539063,
    "CMY_C": 0.4467316865921,
    "CMY_M": 0.50776797533035,
    "CMY_Y": 0.58187019824982,
    "CMYK_C": 0,
    "CMYK_M": 0.11031951010227,
    "CMYK_Y": 0.24425493180752,
    "CMYK_K": 0.4467316865921
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09698",
    "Farbtonhilfsbezeichnung": "F4.16.22",
    "Farbtonklasse": "03",
    "Rcolor": "87",
    "Gcolor": "79",
    "Bcolor": "67",
    "Y": 7.94426488876343,
    "L": 33.8665390014648,
    "a": 1.42313539981842,
    "b": 7.82551288604736,
    "C": 7.95386505126953,
    "h": 79.6929168701172,
    "CMY_C": 0.65949022769928,
    "CMY_M": 0.69204699993134,
    "CMY_Y": 0.73816072940826,
    "CMYK_C": 0,
    "CMYK_M": 0.09561185538769,
    "CMYK_Y": 0.23103742301464,
    "CMYK_K": 0.65949022769928
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09699",
    "Farbtonhilfsbezeichnung": "F4.06.78",
    "Farbtonklasse": "02",
    "Rcolor": "222",
    "Gcolor": "211",
    "Bcolor": "195",
    "Y": 66.2242889404297,
    "L": 85.1106948852539,
    "a": 1.38033068180084,
    "b": 8.83963203430176,
    "C": 8.94675445556641,
    "h": 81.1247940063477,
    "CMY_C": 0.1280729174614,
    "CMY_M": 0.17147332429886,
    "CMY_Y": 0.23715054988861,
    "CMYK_C": 0,
    "CMYK_M": 0.0497752726078,
    "CMYK_Y": 0.12509949505329,
    "CMYK_K": 0.1280729174614
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09700",
    "Farbtonhilfsbezeichnung": "F3.09.75",
    "Farbtonklasse": "02",
    "Rcolor": "220",
    "Gcolor": "205",
    "Bcolor": "182",
    "Y": 62.1446914672852,
    "L": 82.9903030395508,
    "a": 1.95578408241272,
    "b": 12.5184984207153,
    "C": 12.6703548431397,
    "h": 81.1203765869141,
    "CMY_C": 0.13714933395386,
    "CMY_M": 0.19697427749634,
    "CMY_Y": 0.28657495975494,
    "CMYK_C": 0,
    "CMYK_M": 0.06933406740427,
    "CMYK_Y": 0.17317669093609,
    "CMYK_K": 0.13714933395386
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09701",
    "Farbtonhilfsbezeichnung": "F3.12.67",
    "Farbtonklasse": "02",
    "Rcolor": "195",
    "Gcolor": "178",
    "Bcolor": "154",
    "Y": 45.8520278930664,
    "L": 73.4494171142578,
    "a": 2.45130944252014,
    "b": 13.9825897216797,
    "C": 14.1958351135254,
    "h": 80.0564346313477,
    "CMY_C": 0.2347936630249,
    "CMY_M": 0.30129015445709,
    "CMY_Y": 0.39689582586288,
    "CMYK_C": 0,
    "CMYK_M": 0.08690007776022,
    "CMYK_Y": 0.21184112131596,
    "CMYK_K": 0.2347936630249
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09702",
    "Farbtonhilfsbezeichnung": "F0.20.54",
    "Farbtonklasse": "02",
    "Rcolor": "171",
    "Gcolor": "145",
    "Bcolor": "114",
    "Y": 30.1262340545654,
    "L": 61.7629852294922,
    "a": 5.12869215011597,
    "b": 19.3798427581787,
    "C": 20.046989440918,
    "h": 75.1770172119141,
    "CMY_C": 0.33126294612885,
    "CMY_M": 0.43071907758713,
    "CMY_Y": 0.55190801620483,
    "CMYK_C": 0,
    "CMYK_M": 0.14872232079506,
    "CMYK_Y": 0.32994294166565,
    "CMYK_K": 0.33126294612885
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09703",
    "Farbtonhilfsbezeichnung": "F0.19.48",
    "Farbtonklasse": "02",
    "Rcolor": "153",
    "Gcolor": "131",
    "Bcolor": "105",
    "Y": 24.0052185058594,
    "L": 56.093017578125,
    "a": 4.7417197227478,
    "b": 16.5042839050293,
    "C": 17.1719341278076,
    "h": 73.9705200195313,
    "CMY_C": 0.39956426620483,
    "CMY_M": 0.4867662191391,
    "CMY_Y": 0.58739775419235,
    "CMYK_C": 0,
    "CMYK_M": 0.14523111283779,
    "CMYK_Y": 0.31282863020897,
    "CMYK_K": 0.39956426620483
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09704",
    "Farbtonhilfsbezeichnung": "E8.17.38",
    "Farbtonklasse": "03",
    "Rcolor": "127",
    "Gcolor": "110",
    "Bcolor": "91",
    "Y": 16.3319530487061,
    "L": 47.4070243835449,
    "a": 3.93212723731995,
    "b": 12.4468517303467,
    "C": 13.0531892776489,
    "h": 72.4679718017578,
    "CMY_C": 0.50231492519379,
    "CMY_M": 0.57007151842117,
    "CMY_Y": 0.64319205284119,
    "CMYK_C": 0,
    "CMYK_M": 0.13614350557327,
    "CMYK_Y": 0.2830648124218,
    "CMYK_K": 0.50231492519379
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09705",
    "Farbtonhilfsbezeichnung": "F3.11.77",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "204",
    "Bcolor": "177",
    "Y": 61,
    "L": 82.9368743896484,
    "a": 2.972815990448,
    "b": 15.319935798645,
    "C": 15.6057062149048,
    "h": 79.0183029174805,
    "CMY_C": 0.12315255403519,
    "CMY_M": 0.20066386461258,
    "CMY_Y": 0.30740875005722,
    "CMYK_C": 0,
    "CMYK_M": 0.08839771151543,
    "CMYK_Y": 0.21013483405113,
    "CMYK_K": 0.12315255403519
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09706",
    "Farbtonhilfsbezeichnung": "F3.13.73",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "195",
    "Bcolor": "164",
    "Y": 56.3174247741699,
    "L": 79.7941360473633,
    "a": 3.31279993057251,
    "b": 17.3915576934814,
    "C": 17.7042636871338,
    "h": 79.2153091430664,
    "CMY_C": 0.15069407224655,
    "CMY_M": 0.23608195781708,
    "CMY_Y": 0.35544502735138,
    "CMYK_C": 0,
    "CMYK_M": 0.10053843259811,
    "CMYK_Y": 0.24108032882214,
    "CMYK_K": 0.15069407224655
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09707",
    "Farbtonhilfsbezeichnung": "F0.20.61",
    "Farbtonklasse": "02",
    "Rcolor": "189",
    "Gcolor": "160",
    "Bcolor": "126",
    "Y": 37.5653762817383,
    "L": 67.6990585327148,
    "a": 5.68985939025879,
    "b": 21.2459697723389,
    "C": 21.9946746826172,
    "h": 75.0074996948242,
    "CMY_C": 0.25968843698502,
    "CMY_M": 0.37107676267624,
    "CMY_Y": 0.50615531206131,
    "CMYK_C": 0,
    "CMYK_M": 0.15046142041683,
    "CMYK_Y": 0.33292317390442,
    "CMYK_K": 0.25968843698502
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09708",
    "Farbtonhilfsbezeichnung": "F1.27.46",
    "Farbtonklasse": "02",
    "Rcolor": "155",
    "Gcolor": "127",
    "Bcolor": "90",
    "Y": 22.834114074707,
    "L": 54.9010543823242,
    "a": 6.0840048789978,
    "b": 23.3769359588623,
    "C": 24.1556663513184,
    "h": 75.4120101928711,
    "CMY_C": 0.39140456914902,
    "CMY_M": 0.50312089920044,
    "CMY_Y": 0.64543724060059,
    "CMYK_C": 0,
    "CMYK_M": 0.18356420099735,
    "CMYK_Y": 0.41740810871124,
    "CMYK_K": 0.39140456914902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09709",
    "Farbtonhilfsbezeichnung": "F1.35.35",
    "Farbtonklasse": "02",
    "Rcolor": "128",
    "Gcolor": "103",
    "Bcolor": "68",
    "Y": 14.762547492981,
    "L": 45.3072395324707,
    "a": 5.41751956939697,
    "b": 23.0294513702393,
    "C": 23.658088684082,
    "h": 76.7622451782227,
    "CMY_C": 0.49646800756454,
    "CMY_M": 0.5956512093544,
    "CMY_Y": 0.73223519325256,
    "CMYK_C": 0,
    "CMYK_M": 0.19697497785091,
    "CMYK_Y": 0.46822682023048,
    "CMYK_K": 0.49646800756454
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09710",
    "Farbtonhilfsbezeichnung": "F1.30.26",
    "Farbtonklasse": "03",
    "Rcolor": "103",
    "Gcolor": "84",
    "Bcolor": "63",
    "Y": 9.62477684020996,
    "L": 37.1603965759277,
    "a": 4.5124659538269,
    "b": 15.1171522140503,
    "C": 15.7762680053711,
    "h": 73.3796539306641,
    "CMY_C": 0.59613227844238,
    "CMY_M": 0.66943502426147,
    "CMY_Y": 0.7539130449295,
    "CMYK_C": 0,
    "CMYK_M": 0.18150186538696,
    "CMYK_Y": 0.39067435264587,
    "CMYK_K": 0.59613227844238
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09711",
    "Farbtonhilfsbezeichnung": "F6.09.80",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "216",
    "Bcolor": "191",
    "Y": 70.173942565918,
    "L": 87.0821075439453,
    "a": 1.57700645923615,
    "b": 13.756139755249,
    "C": 13.8462390899658,
    "h": 83.4601516723633,
    "CMY_C": 0.09089839458466,
    "CMY_M": 0.15148949623108,
    "CMY_Y": 0.25204640626907,
    "CMYK_C": 0,
    "CMYK_M": 0.0666494295001,
    "CMYK_Y": 0.17726072669029,
    "CMYK_K": 0.09089839458466
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09712",
    "Farbtonhilfsbezeichnung": "F3.12.78",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "209",
    "Bcolor": "180",
    "Y": 65.9092864990234,
    "L": 84.9501266479492,
    "a": 2.79014921188354,
    "b": 16.6061248779297,
    "C": 16.8388938903809,
    "h": 80.4622955322266,
    "CMY_C": 0.09866517782211,
    "CMY_M": 0.17852312326431,
    "CMY_Y": 0.29553806781769,
    "CMYK_C": 0,
    "CMYK_M": 0.08859964460135,
    "CMYK_Y": 0.21842370927334,
    "CMYK_K": 0.09866517782211
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09713",
    "Farbtonhilfsbezeichnung": "F3.17.59",
    "Farbtonklasse": "02",
    "Rcolor": "179",
    "Gcolor": "157",
    "Bcolor": "127",
    "Y": 35.432487487793,
    "L": 66.0840072631836,
    "a": 3.75054001808167,
    "b": 18.1667900085449,
    "C": 18.5499000549316,
    "h": 78.3351516723633,
    "CMY_C": 0.29619425535202,
    "CMY_M": 0.38267868757248,
    "CMY_Y": 0.50095009803772,
    "CMYK_C": 0,
    "CMYK_M": 0.12288111448288,
    "CMYK_Y": 0.29092663526535,
    "CMYK_K": 0.29619425535202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09714",
    "Farbtonhilfsbezeichnung": "F3.23.51",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "136",
    "Bcolor": "101",
    "Y": 25.9401836395264,
    "L": 57.9802284240723,
    "a": 4.1488151550293,
    "b": 21.4021244049072,
    "C": 21.8005409240723,
    "h": 79.0292434692383,
    "CMY_C": 0.37397676706314,
    "CMY_M": 0.46733641624451,
    "CMY_Y": 0.60282403230667,
    "CMYK_C": 0,
    "CMYK_M": 0.14913128316402,
    "CMYK_Y": 0.36555713415146,
    "CMYK_K": 0.37397676706314
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09715",
    "Farbtonhilfsbezeichnung": "F3.39.32",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "98",
    "Bcolor": "64",
    "Y": 13.0538997650147,
    "L": 42.8443489074707,
    "a": 4.28640222549438,
    "b": 22.3217639923096,
    "C": 22.7295932769775,
    "h": 79.1299362182617,
    "CMY_C": 0.52926313877106,
    "CMY_M": 0.6166079044342,
    "CMY_Y": 0.74999868869781,
    "CMYK_C": 0,
    "CMYK_M": 0.18554902076721,
    "CMYK_Y": 0.46891495585442,
    "CMYK_K": 0.52926313877106
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09716",
    "Farbtonhilfsbezeichnung": "F3.20.61",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "162",
    "Bcolor": "127",
    "Y": 38.1113243103027,
    "L": 68.1025848388672,
    "a": 3.98706746101379,
    "b": 21.436336517334,
    "C": 21.8039722442627,
    "h": 79.4636306762695,
    "CMY_C": 0.26597291231155,
    "CMY_M": 0.36287063360214,
    "CMY_Y": 0.50379085540771,
    "CMYK_C": 0,
    "CMYK_M": 0.13200837373734,
    "CMYK_Y": 0.32399070262909,
    "CMYK_K": 0.26597291231155
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09717",
    "Farbtonhilfsbezeichnung": "F3.28.38",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "110",
    "Bcolor": "78",
    "Y": 16.4550342559814,
    "L": 47.5659103393555,
    "a": 3.98961925506592,
    "b": 20.2190666198731,
    "C": 20.608922958374,
    "h": 78.8378067016602,
    "CMY_C": 0.48594111204147,
    "CMY_M": 0.57012248039246,
    "CMY_Y": 0.69304311275482,
    "CMYK_C": 0,
    "CMYK_M": 0.16375821828842,
    "CMYK_Y": 0.40287601947784,
    "CMYK_K": 0.48594111204147
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09718",
    "Farbtonhilfsbezeichnung": "F8.37.27",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "92",
    "Bcolor": "63",
    "Y": 10.8992214202881,
    "L": 39.410213470459,
    "a": 0.68797415494919,
    "b": 17.6945648193359,
    "C": 17.7079334259033,
    "h": 87.7734298706055,
    "CMY_C": 0.59179675579071,
    "CMY_M": 0.64074170589447,
    "CMY_Y": 0.75109469890594,
    "CMYK_C": 0,
    "CMYK_M": 0.11990338563919,
    "CMYK_Y": 0.39024174213409,
    "CMYK_K": 0.59179675579071
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09719",
    "Farbtonhilfsbezeichnung": "F6.04.86",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "234",
    "Bcolor": "219",
    "Y": 82.8415908813477,
    "L": 92.9450378417969,
    "a": 0.65013265609741,
    "b": 7.1022801399231,
    "C": 7.13197422027588,
    "h": 84.7697982788086,
    "CMY_C": 0.05113780498505,
    "CMY_M": 0.08242619037628,
    "CMY_Y": 0.13927179574966,
    "CMYK_C": 0,
    "CMYK_M": 0.03297463431954,
    "CMYK_Y": 0.09288387000561,
    "CMYK_K": 0.05113780498505
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09720",
    "Farbtonhilfsbezeichnung": "F8.07.83",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "222",
    "Bcolor": "200",
    "Y": 74.068473815918,
    "L": 88.954833984375,
    "a": 0.96078604459763,
    "b": 11.4186811447144,
    "C": 11.4590311050415,
    "h": 85.1903686523438,
    "CMY_C": 0.08088570833206,
    "CMY_M": 0.12873297929764,
    "CMY_Y": 0.21474009752274,
    "CMYK_C": 0,
    "CMYK_M": 0.05205802246928,
    "CMYK_Y": 0.14563409984112,
    "CMYK_K": 0.08088570833206
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09721",
    "Farbtonhilfsbezeichnung": "F8.12.71",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "190",
    "Bcolor": "161",
    "Y": 52.1034317016602,
    "L": 77.342643737793,
    "a": 1.06570971012115,
    "b": 15.6623859405518,
    "C": 15.698600769043,
    "h": 86.1074447631836,
    "CMY_C": 0.19775921106339,
    "CMY_M": 0.25681048631668,
    "CMY_Y": 0.36885845661163,
    "CMYK_C": 0,
    "CMYK_M": 0.07360792160034,
    "CMYK_Y": 0.21327666938305,
    "CMYK_K": 0.19775921106339
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09722",
    "Farbtonhilfsbezeichnung": "F6.13.63",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "169",
    "Bcolor": "143",
    "Y": 40.7237319946289,
    "L": 69.9819259643555,
    "a": 1.52220928668976,
    "b": 15.0592365264893,
    "C": 15.1359748840332,
    "h": 84.2280654907227,
    "CMY_C": 0.27615880966187,
    "CMY_M": 0.33607643842697,
    "CMY_Y": 0.44018590450287,
    "CMYK_C": 0,
    "CMYK_M": 0.08277731388807,
    "CMYK_Y": 0.22660647332668,
    "CMYK_K": 0.27615880966187
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09723",
    "Farbtonhilfsbezeichnung": "F3.22.43",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "121",
    "Bcolor": "91",
    "Y": 20.0969409942627,
    "L": 51.9466361999512,
    "a": 3.67523431777954,
    "b": 18.7495956420898,
    "C": 19.1064033508301,
    "h": 78.9096832275391,
    "CMY_C": 0.44515818357468,
    "CMY_M": 0.52615118026733,
    "CMY_Y": 0.64234852790833,
    "CMYK_C": 0,
    "CMYK_M": 0.1459749341011,
    "CMYK_Y": 0.35539922118187,
    "CMYK_K": 0.44515818357468
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09724",
    "Farbtonhilfsbezeichnung": "F4.33.25",
    "Farbtonklasse": "03",
    "Rcolor": "104",
    "Gcolor": "87",
    "Bcolor": "63",
    "Y": 10.142861366272,
    "L": 38.0976181030273,
    "a": 3.02162218093872,
    "b": 16.1188488006592,
    "C": 16.3996181488037,
    "h": 79.3826141357422,
    "CMY_C": 0.59376955032349,
    "CMY_M": 0.65767401456833,
    "CMY_Y": 0.75223052501678,
    "CMYK_C": 0,
    "CMYK_M": 0.15731087327003,
    "CMYK_Y": 0.3900765478611,
    "CMYK_K": 0.59376955032349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09725",
    "Farbtonhilfsbezeichnung": "F6.08.75",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "203",
    "Bcolor": "184",
    "Y": 60.5914764404297,
    "L": 82.1586303710938,
    "a": 0.9572166800499,
    "b": 10.2309942245483,
    "C": 10.2756757736206,
    "h": 84.6549453735352,
    "CMY_C": 0.15990763902664,
    "CMY_M": 0.20311564207077,
    "CMY_Y": 0.27892601490021,
    "CMYK_C": 0,
    "CMYK_M": 0.05143244192004,
    "CMYK_Y": 0.14167296886444,
    "CMYK_K": 0.15990763902664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09726",
    "Farbtonhilfsbezeichnung": "F3.09.65",
    "Farbtonklasse": "02",
    "Rcolor": "190",
    "Gcolor": "177",
    "Bcolor": "158",
    "Y": 44.7486991882324,
    "L": 72.7261123657227,
    "a": 1.76408338546753,
    "b": 10.7657127380371,
    "C": 10.9092874526978,
    "h": 80.6941452026367,
    "CMY_C": 0.25564193725586,
    "CMY_M": 0.30662000179291,
    "CMY_Y": 0.38161897659302,
    "CMYK_C": 0,
    "CMYK_M": 0.06848594546318,
    "CMYK_Y": 0.16924253106117,
    "CMYK_K": 0.25564193725586
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09727",
    "Farbtonhilfsbezeichnung": "F3.16.52",
    "Farbtonklasse": "02",
    "Rcolor": "158",
    "Gcolor": "140",
    "Bcolor": "116",
    "Y": 27.3088836669922,
    "L": 59.259147644043,
    "a": 2.84725832939148,
    "b": 15.0348796844482,
    "C": 15.3021068572998,
    "h": 79.276496887207,
    "CMY_C": 0.38149851560593,
    "CMY_M": 0.45013207197189,
    "CMY_Y": 0.5469126701355,
    "CMYK_C": 0,
    "CMYK_M": 0.11096748709679,
    "CMYK_Y": 0.26744341850281,
    "CMYK_K": 0.38149851560593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09728",
    "Farbtonhilfsbezeichnung": "F3.19.47",
    "Farbtonklasse": "02",
    "Rcolor": "151",
    "Gcolor": "131",
    "Bcolor": "103",
    "Y": 23.8045063018799,
    "L": 55.8915252685547,
    "a": 3.39291977882385,
    "b": 17.4415664672852,
    "C": 17.7685146331787,
    "h": 78.99169921875,
    "CMY_C": 0.40830367803574,
    "CMY_M": 0.48590964078903,
    "CMY_Y": 0.5959415435791,
    "CMYK_C": 0,
    "CMYK_M": 0.131158426404,
    "CMYK_Y": 0.31711852550507,
    "CMYK_K": 0.40830367803574
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09729",
    "Farbtonhilfsbezeichnung": "F3.08.75",
    "Farbtonklasse": "01",
    "Rcolor": "212",
    "Gcolor": "199",
    "Bcolor": "180",
    "Y": 57.9561538696289,
    "L": 80.7144088745117,
    "a": 1.85628235340118,
    "b": 10.2678995132446,
    "C": 10.434344291687,
    "h": 79.7524642944336,
    "CMY_C": 0.1691672205925,
    "CMY_M": 0.2209484577179,
    "CMY_Y": 0.29438894987106,
    "CMYK_C": 0,
    "CMYK_M": 0.06232449784875,
    "CMYK_Y": 0.15071833133698,
    "CMYK_K": 0.1691672205925
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09730",
    "Farbtonhilfsbezeichnung": "F4.08.69",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "187",
    "Bcolor": "169",
    "Y": 50.6101837158203,
    "L": 76.4422760009766,
    "a": 1.6205108165741,
    "b": 9.71415424346924,
    "C": 9.84839344024658,
    "h": 80.5291519165039,
    "CMY_C": 0.21918421983719,
    "CMY_M": 0.26636052131653,
    "CMY_Y": 0.33545851707458,
    "CMYK_C": 0,
    "CMYK_M": 0.06041924655437,
    "CMYK_Y": 0.14891386032104,
    "CMYK_K": 0.21918421983719
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09731",
    "Farbtonhilfsbezeichnung": "F7.04.77",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "211",
    "Bcolor": "198",
    "Y": 65.4877090454102,
    "L": 84.7344284057617,
    "a": 0.43601876497269,
    "b": 6.29771280288696,
    "C": 6.31278848648071,
    "h": 86.0394744873047,
    "CMY_C": 0.1468631029129,
    "CMY_M": 0.17270857095718,
    "CMY_Y": 0.22276812791824,
    "CMYK_C": 0,
    "CMYK_M": 0.03029463253915,
    "CMYK_Y": 0.08897168189287,
    "CMYK_K": 0.1468631029129
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09732",
    "Farbtonhilfsbezeichnung": "F6.06.69",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "186",
    "Bcolor": "170",
    "Y": 49.2563667297363,
    "L": 75.6105422973633,
    "a": 0.58452957868576,
    "b": 8.05456733703613,
    "C": 8.07574939727783,
    "h": 85.8492584228516,
    "CMY_C": 0.24033659696579,
    "CMY_M": 0.272465467453,
    "CMY_Y": 0.33247220516205,
    "CMYK_C": 0,
    "CMYK_M": 0.04229355975986,
    "CMYK_Y": 0.12128478288651,
    "CMYK_K": 0.24033659696579
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09733",
    "Farbtonhilfsbezeichnung": "F5.09.61",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "166",
    "Bcolor": "147",
    "Y": 38.7282104492188,
    "L": 68.5539321899414,
    "a": 1.12791538238525,
    "b": 10.6384010314941,
    "C": 10.6980266571045,
    "h": 83.9479370117188,
    "CMY_C": 0.30522441864014,
    "CMY_M": 0.34917557239532,
    "CMY_Y": 0.42370349168777,
    "CMYK_C": 0,
    "CMYK_M": 0.06325949728489,
    "CMYK_Y": 0.17052854597569,
    "CMYK_K": 0.30522441864014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09734",
    "Farbtonhilfsbezeichnung": "F6.08.48",
    "Farbtonklasse": "02",
    "Rcolor": "140",
    "Gcolor": "133",
    "Bcolor": "121",
    "Y": 23.7406558990479,
    "L": 55.8271903991699,
    "a": 0.7801348567009,
    "b": 6.63311338424683,
    "C": 6.67883253097534,
    "h": 83.2921371459961,
    "CMY_C": 0.45090889930725,
    "CMY_M": 0.4784317612648,
    "CMY_Y": 0.5240204334259,
    "CMYK_C": 0,
    "CMYK_M": 0.05012439936399,
    "CMYK_Y": 0.13315010070801,
    "CMYK_K": 0.45090889930725
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09735",
    "Farbtonhilfsbezeichnung": "GN.00.85",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 79.701545715332,
    "L": 91.55078125,
    "a": -0.46298715472221,
    "b": 1.7284814119339,
    "C": 1.78941476345062,
    "h": 104.995109558105,
    "CMY_C": 0.09282702207565,
    "CMY_M": 0.09387618303299,
    "CMY_Y": 0.11486995220184,
    "CMYK_C": 0,
    "CMYK_M": 0.00115651695523,
    "CMYK_Y": 0.02429848536849,
    "CMYK_K": 0.09282702207565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09736",
    "Farbtonhilfsbezeichnung": "G0.16.68",
    "Farbtonklasse": "02",
    "Rcolor": "199",
    "Gcolor": "184",
    "Bcolor": "149",
    "Y": 48.7382965087891,
    "L": 75.2882232666016,
    "a": 0.17051617801189,
    "b": 18.9878559112549,
    "C": 18.9886207580566,
    "h": 89.485481262207,
    "CMY_C": 0.21853423118591,
    "CMY_M": 0.27750885486603,
    "CMY_Y": 0.4141873717308,
    "CMYK_C": 0,
    "CMYK_M": 0.0754666775465,
    "CMYK_Y": 0.25036686658859,
    "CMYK_K": 0.21853423118591
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09737",
    "Farbtonhilfsbezeichnung": "F7.20.43",
    "Farbtonklasse": "03",
    "Rcolor": "134",
    "Gcolor": "121",
    "Bcolor": "94",
    "Y": 19.5297622680664,
    "L": 51.301326751709,
    "a": 0.80516421794891,
    "b": 16.0813827514648,
    "C": 16.101526260376,
    "h": 87.1336975097656,
    "CMY_C": 0.47485983371735,
    "CMY_M": 0.52572792768478,
    "CMY_Y": 0.63103723526001,
    "CMYK_C": 0,
    "CMYK_M": 0.09686574339867,
    "CMYK_Y": 0.29740136861801,
    "CMYK_K": 0.47485983371735
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09738",
    "Farbtonhilfsbezeichnung": "G5.09.78",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "212",
    "Bcolor": "185",
    "Y": 65.4593124389648,
    "L": 84.7198638916016,
    "a": -1.40235543251038,
    "b": 13.1525659561157,
    "C": 13.2271156311035,
    "h": 96.0860061645508,
    "CMY_C": 0.14083188772202,
    "CMY_M": 0.17030674219131,
    "CMY_Y": 0.27333933115005,
    "CMYK_C": 0,
    "CMYK_M": 0.03430627286434,
    "CMYK_Y": 0.15422761440277,
    "CMYK_K": 0.14083188772202
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09739",
    "Farbtonhilfsbezeichnung": "G5.13.66",
    "Farbtonklasse": "02",
    "Rcolor": "185",
    "Gcolor": "178",
    "Bcolor": "148",
    "Y": 44.4940338134766,
    "L": 72.5574798583984,
    "a": -2.26442623138428,
    "b": 15.8697652816773,
    "C": 16.0305042266846,
    "h": 98.12060546875,
    "CMY_C": 0.27284550666809,
    "CMY_M": 0.30043208599091,
    "CMY_Y": 0.42026978731155,
    "CMYK_C": 0,
    "CMYK_M": 0.0379377156496,
    "CMYK_Y": 0.20274133980274,
    "CMYK_K": 0.27284550666809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09740",
    "Farbtonhilfsbezeichnung": "G5.17.58",
    "Farbtonklasse": "02",
    "Rcolor": "164",
    "Gcolor": "156",
    "Bcolor": "125",
    "Y": 33.3078079223633,
    "L": 64.4093704223633,
    "a": -2.20671415328979,
    "b": 17.1189861297607,
    "C": 17.260627746582,
    "h": 97.3451843261719,
    "CMY_C": 0.35632079839706,
    "CMY_M": 0.38643449544907,
    "CMY_Y": 0.51132196187973,
    "CMYK_C": 0,
    "CMYK_M": 0.04678370431066,
    "CMYK_Y": 0.2408049851656,
    "CMYK_K": 0.35632079839706
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09741",
    "Farbtonhilfsbezeichnung": "G5.19.40",
    "Farbtonklasse": "03",
    "Rcolor": "123",
    "Gcolor": "118",
    "Bcolor": "92",
    "Y": 17.8425407409668,
    "L": 49.3045654296875,
    "a": -2.17415523529053,
    "b": 14.5323886871338,
    "C": 14.6941232681274,
    "h": 98.5087738037109,
    "CMY_C": 0.5174326300621,
    "CMY_M": 0.53887975215912,
    "CMY_Y": 0.64006757736206,
    "CMYK_C": 0,
    "CMYK_M": 0.04444378986955,
    "CMYK_Y": 0.25413021445274,
    "CMYK_K": 0.5174326300621
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09742",
    "Farbtonhilfsbezeichnung": "G5.30.26",
    "Farbtonklasse": "03",
    "Rcolor": "96",
    "Gcolor": "90",
    "Bcolor": "63",
    "Y": 10.0602436065674,
    "L": 37.9503364562988,
    "a": -1.89689970016479,
    "b": 15.6550922393799,
    "C": 15.7695951461792,
    "h": 96.9087448120117,
    "CMY_C": 0.6250524520874,
    "CMY_M": 0.64893788099289,
    "CMY_Y": 0.75143033266068,
    "CMYK_C": 0,
    "CMYK_M": 0.06370338797569,
    "CMYK_Y": 0.33705481886864,
    "CMYK_K": 0.6250524520874
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09743",
    "Farbtonhilfsbezeichnung": "G5.07.77",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "209",
    "Bcolor": "190",
    "Y": 63.5201034545898,
    "L": 83.7152786254883,
    "a": -0.95434492826462,
    "b": 9.43741798400879,
    "C": 9.4855489730835,
    "h": 95.7743225097656,
    "CMY_C": 0.15918999910355,
    "CMY_M": 0.18144452571869,
    "CMY_Y": 0.25683385133743,
    "CMYK_C": 0,
    "CMYK_M": 0.02646796219051,
    "CMYK_Y": 0.11613069474697,
    "CMYK_K": 0.15918999910355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09744",
    "Farbtonhilfsbezeichnung": "G5.07.73",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "199",
    "Bcolor": "179",
    "Y": 56.8593215942383,
    "L": 80.1004028320313,
    "a": -0.9236461520195,
    "b": 9.85387706756592,
    "C": 9.89707088470459,
    "h": 95.3549346923828,
    "CMY_C": 0.19744056463242,
    "CMY_M": 0.22102850675583,
    "CMY_Y": 0.29832178354263,
    "CMYK_C": 0,
    "CMYK_M": 0.02939089760184,
    "CMYK_Y": 0.12569937109947,
    "CMYK_K": 0.19744056463242
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09745",
    "Farbtonhilfsbezeichnung": "G3.12.56",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "154",
    "Bcolor": "131",
    "Y": 32.1851425170898,
    "L": 63.4956016540527,
    "a": -0.78956192731857,
    "b": 12.3533735275269,
    "C": 12.3785800933838,
    "h": 93.6570739746094,
    "CMY_C": 0.36766958236694,
    "CMY_M": 0.39798468351364,
    "CMY_Y": 0.48708355426788,
    "CMYK_C": 0,
    "CMYK_M": 0.04794186726213,
    "CMYK_Y": 0.18884742259979,
    "CMYK_K": 0.36766958236694
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09746",
    "Farbtonhilfsbezeichnung": "G5.14.50",
    "Farbtonklasse": "02",
    "Rcolor": "148",
    "Gcolor": "142",
    "Bcolor": "117",
    "Y": 26.8841381072998,
    "L": 58.8669319152832,
    "a": -1.57487392425537,
    "b": 13.7058486938477,
    "C": 13.7960329055786,
    "h": 96.5548400878906,
    "CMY_C": 0.41795247793198,
    "CMY_M": 0.44410121440887,
    "CMY_Y": 0.54238402843475,
    "CMYK_C": 0,
    "CMYK_M": 0.04492543265224,
    "CMYK_Y": 0.21378245949745,
    "CMYK_K": 0.41795247793198
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09747",
    "Farbtonhilfsbezeichnung": "G5.17.19",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "76",
    "Bcolor": "65",
    "Y": 7.13763904571533,
    "L": 32.1182174682617,
    "a": -0.61002594232559,
    "b": 6.39823055267334,
    "C": 6.42724561691284,
    "h": 95.4462890625,
    "CMY_C": 0.69127213954926,
    "CMY_M": 0.7037513256073,
    "CMY_Y": 0.74522650241852,
    "CMYK_C": 0,
    "CMYK_M": 0.04042131453753,
    "CMYK_Y": 0.17476350069046,
    "CMYK_K": 0.69127213954926
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09748",
    "Farbtonhilfsbezeichnung": "H0.01.86",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "236",
    "Bcolor": "228",
    "Y": 83.1505966186523,
    "L": 93.0803298950195,
    "a": -0.95224124193192,
    "b": 2.54159379005432,
    "C": 2.7141227722168,
    "h": 110.539115905762,
    "CMY_C": 0.0768523812294,
    "CMY_M": 0.07583701610565,
    "CMY_Y": 0.10406392812729,
    "CMYK_C": 0.00109868624713,
    "CMYK_M": 0,
    "CMYK_Y": 0.03054321929812,
    "CMYK_K": 0.07583701610565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09749",
    "Farbtonhilfsbezeichnung": "G6.04.66",
    "Farbtonklasse": "01",
    "Rcolor": "184",
    "Gcolor": "182",
    "Bcolor": "172",
    "Y": 46.7891998291016,
    "L": 74.0547256469727,
    "a": -1.01157224178314,
    "b": 4.8072190284729,
    "C": 4.91249752044678,
    "h": 101.883247375488,
    "CMY_C": 0.27842611074448,
    "CMY_M": 0.28464502096176,
    "CMY_Y": 0.32591187953949,
    "CMYK_C": 0,
    "CMYK_M": 0.00861853547394,
    "CMYK_Y": 0.06580860167742,
    "CMYK_K": 0.27842611074448
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09750",
    "Farbtonhilfsbezeichnung": "H1.09.41",
    "Farbtonklasse": "02",
    "Rcolor": "118",
    "Gcolor": "117",
    "Bcolor": "104",
    "Y": 17.6255760192871,
    "L": 49.0387840270996,
    "a": -1.95664608478546,
    "b": 6.60757398605347,
    "C": 6.89119005203247,
    "h": 106.495162963867,
    "CMY_C": 0.53775668144226,
    "CMY_M": 0.54030126333237,
    "CMY_Y": 0.59029603004456,
    "CMYK_C": 0,
    "CMYK_M": 0.00550485402346,
    "CMYK_Y": 0.1136616691947,
    "CMYK_K": 0.53775668144226
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09751",
    "Farbtonhilfsbezeichnung": "G0.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "222",
    "Bcolor": "213",
    "Y": 72.9272689819336,
    "L": 88.4130172729492,
    "a": -1.01017439365387,
    "b": 4.0232720375061,
    "C": 4.14815282821655,
    "h": 104.094619750977,
    "CMY_C": 0.12441301345825,
    "CMY_M": 0.1281304359436,
    "CMY_Y": 0.16637372970581,
    "CMYK_C": 0,
    "CMYK_M": 0.0042456346564,
    "CMYK_Y": 0.04792295396328,
    "CMYK_K": 0.12441301345825
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09752",
    "Farbtonhilfsbezeichnung": "J4.11.30",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "95",
    "Bcolor": "84",
    "Y": 11.0760231018066,
    "L": 39.7082176208496,
    "a": -3.93954873085022,
    "b": 5.25905227661133,
    "C": 6.57097196578979,
    "h": 126.83683013916,
    "CMY_C": 0.64494109153748,
    "CMY_M": 0.62640357017517,
    "CMY_Y": 0.6698409318924,
    "CMYK_C": 0.04961910843849,
    "CMYK_M": 0,
    "CMYK_Y": 0.11626813560724,
    "CMYK_K": 0.62640357017517
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09753",
    "Farbtonhilfsbezeichnung": "KN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "235",
    "Bcolor": "228",
    "Y": 81.7515335083008,
    "L": 92.4650802612305,
    "a": -2.05435824394226,
    "b": 2.01149892807007,
    "C": 2.87515497207642,
    "h": 135.603958129883,
    "CMY_C": 0.09432047605515,
    "CMY_M": 0.07998287677765,
    "CMY_Y": 0.1070864200592,
    "CMYK_C": 0.01558405719697,
    "CMYK_M": 0,
    "CMYK_Y": 0.02945982478559,
    "CMYK_K": 0.07998287677765
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09754",
    "Farbtonhilfsbezeichnung": "K0.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "219",
    "Bcolor": "213",
    "Y": 70.3141250610352,
    "L": 87.1507034301758,
    "a": -1.75222074985504,
    "b": 1.85146641731262,
    "C": 2.5491578578949,
    "h": 133.422470092773,
    "CMY_C": 0.15140932798386,
    "CMY_M": 0.13977754116058,
    "CMY_Y": 0.16430234909058,
    "CMYK_C": 0.01352183613926,
    "CMYK_M": 0,
    "CMYK_Y": 0.02850984409451,
    "CMYK_K": 0.13977754116058
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09755",
    "Farbtonhilfsbezeichnung": "K2.16.16",
    "Farbtonklasse": "03",
    "Rcolor": "66",
    "Gcolor": "73",
    "Bcolor": "65",
    "Y": 6.36103820800781,
    "L": 30.3056468963623,
    "a": -4.68939208984375,
    "b": 3.90632319450378,
    "C": 6.10325813293457,
    "h": 140.205276489258,
    "CMY_C": 0.74010944366455,
    "CMY_M": 0.71219313144684,
    "CMY_Y": 0.74667251110077,
    "CMYK_C": 0.09699668735266,
    "CMYK_M": 0,
    "CMYK_Y": 0.11980040371418,
    "CMYK_K": 0.71219313144684
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09756",
    "Farbtonhilfsbezeichnung": "K0.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "228",
    "Gcolor": "234",
    "Bcolor": "225",
    "Y": 80.7886581420898,
    "L": 92.0375671386719,
    "a": -2.94279193878174,
    "b": 2.66643214225769,
    "C": 3.97113132476807,
    "h": 137.820602416992,
    "CMY_C": 0.10395556688309,
    "CMY_M": 0.0828760266304,
    "CMY_Y": 0.11680316925049,
    "CMYK_C": 0.02298439480364,
    "CMYK_M": 0,
    "CMYK_Y": 0.03699297457933,
    "CMYK_K": 0.0828760266304
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09757",
    "Farbtonhilfsbezeichnung": "L0.03.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "223",
    "Bcolor": "216",
    "Y": 72.3593063354492,
    "L": 88.1412506103516,
    "a": -3.67313814163208,
    "b": 1.92303538322449,
    "C": 4.14608335494995,
    "h": 152.366134643555,
    "CMY_C": 0.15554738044739,
    "CMY_M": 0.12440013885498,
    "CMY_Y": 0.15425717830658,
    "CMYK_C": 0.03557246178389,
    "CMYK_M": 0,
    "CMYK_Y": 0.03409895300865,
    "CMYK_K": 0.12440013885498
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09758",
    "Farbtonhilfsbezeichnung": "L2.03.76",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "209",
    "Bcolor": "201",
    "Y": 61.7793006896973,
    "L": 82.7959136962891,
    "a": -4.47172260284424,
    "b": 2.08688426017761,
    "C": 4.9347128868103,
    "h": 154.982269287109,
    "CMY_C": 0.21982789039612,
    "CMY_M": 0.18156844377518,
    "CMY_Y": 0.21371448040009,
    "CMYK_C": 0.04674727842212,
    "CMYK_M": 0,
    "CMYK_Y": 0.03927761316299,
    "CMYK_K": 0.18156844377518
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09759",
    "Farbtonhilfsbezeichnung": "M3.08.26",
    "Farbtonklasse": "03",
    "Rcolor": "79",
    "Gcolor": "89",
    "Bcolor": "84",
    "Y": 9.38421726226807,
    "L": 36.7137603759766,
    "a": -4.43317604064941,
    "b": 0.64974224567413,
    "C": 4.48053741455078,
    "h": 171.661880493164,
    "CMY_C": 0.68981492519379,
    "CMY_M": 0.65273296833038,
    "CMY_Y": 0.66871225833893,
    "CMYK_C": 0.10678225755692,
    "CMYK_M": 0,
    "CMYK_Y": 0.04601441696286,
    "CMYK_K": 0.65273296833038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09761",
    "Farbtonhilfsbezeichnung": "N0.03.77",
    "Farbtonklasse": "01",
    "Rcolor": "200",
    "Gcolor": "211",
    "Bcolor": "206",
    "Y": 63.6011848449707,
    "L": 83.7576904296875,
    "a": -4.37798833847046,
    "b": 0.43026977777481,
    "C": 4.39908123016357,
    "h": 174.386978149414,
    "CMY_C": 0.21445125341415,
    "CMY_M": 0.17077600955963,
    "CMY_Y": 0.19123369455338,
    "CMYK_C": 0.05267002061009,
    "CMYK_M": 0,
    "CMYK_Y": 0.02467087842524,
    "CMYK_K": 0.17077600955963
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09762",
    "Farbtonhilfsbezeichnung": "N1.06.61",
    "Farbtonklasse": "02",
    "Rcolor": "152",
    "Gcolor": "170",
    "Bcolor": "166",
    "Y": 38.1959037780762,
    "L": 68.1647567749023,
    "a": -6.53486824035645,
    "b": -0.92548942565918,
    "C": 6.60007810592651,
    "h": 188.060806274414,
    "CMY_C": 0.40233480930328,
    "CMY_M": 0.33364504575729,
    "CMY_Y": 0.34792792797089,
    "CMYK_C": 0.10308284312487,
    "CMYK_M": 0,
    "CMYK_Y": 0.02143434621394,
    "CMYK_K": 0.33364504575729
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09763",
    "Farbtonhilfsbezeichnung": "N1.09.46",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "134",
    "Bcolor": "129",
    "Y": 22.0755882263184,
    "L": 54.1071166992188,
    "a": -8.12900638580322,
    "b": -0.65836906433105,
    "C": 8.15562343597412,
    "h": 184.630294799805,
    "CMY_C": 0.55628967285156,
    "CMY_M": 0.47570198774338,
    "CMY_Y": 0.49339640140533,
    "CMYK_C": 0.15370588004589,
    "CMYK_M": 0,
    "CMYK_Y": 0.03374877199531,
    "CMYK_K": 0.47570198774338
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09764",
    "Farbtonhilfsbezeichnung": "M9.18.13",
    "Farbtonklasse": "04",
    "Rcolor": "56",
    "Gcolor": "69",
    "Bcolor": "65",
    "Y": 5.48215484619141,
    "L": 28.0664863586426,
    "a": -5.80365371704102,
    "b": 0.0632363781333,
    "C": 5.80399799346924,
    "h": 179.375732421875,
    "CMY_C": 0.77927148342133,
    "CMY_M": 0.72969746589661,
    "CMY_Y": 0.74359494447708,
    "CMYK_C": 0.18340197205544,
    "CMYK_M": 0,
    "CMYK_Y": 0.05141453444958,
    "CMYK_K": 0.72969746589661
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09765",
    "Farbtonhilfsbezeichnung": "LN.01.82",
    "Farbtonklasse": "01",
    "Rcolor": "213",
    "Gcolor": "218",
    "Bcolor": "213",
    "Y": 69.0491485595703,
    "L": 86.5283813476563,
    "a": -2.30886316299438,
    "b": 1.06134593486786,
    "C": 2.54112267494202,
    "h": 155.312545776367,
    "CMY_C": 0.16537618637085,
    "CMY_M": 0.14514768123627,
    "CMY_Y": 0.1653835773468,
    "CMYK_C": 0.02366315759718,
    "CMYK_M": 0,
    "CMYK_Y": 0.02367180399597,
    "CMYK_K": 0.14514768123627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09766",
    "Farbtonhilfsbezeichnung": "L9.03.61",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "167",
    "Bcolor": "163",
    "Y": 37.6675682067871,
    "L": 67.7748870849609,
    "a": -3.46280169487,
    "b": 0.38587722182274,
    "C": 3.48423552513123,
    "h": 173.641479492188,
    "CMY_C": 0.37753808498383,
    "CMY_M": 0.34462714195251,
    "CMY_Y": 0.36075007915497,
    "CMYK_C": 0.0502171292901,
    "CMYK_M": 0,
    "CMYK_Y": 0.02460116706789,
    "CMYK_K": 0.34462714195251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09767",
    "Farbtonhilfsbezeichnung": "L8.04.50",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "141",
    "Bcolor": "137",
    "Y": 25.9329071044922,
    "L": 57.9733123779297,
    "a": -3.8363208770752,
    "b": 0.71098285913467,
    "C": 3.90164756774902,
    "h": 169.500549316406,
    "CMY_C": 0.47973382472992,
    "CMY_M": 0.44542562961578,
    "CMY_Y": 0.46335113048553,
    "CMYK_C": 0.06186401098967,
    "CMYK_M": 0,
    "CMYK_Y": 0.03232298791409,
    "CMYK_K": 0.44542562961578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09768",
    "Farbtonhilfsbezeichnung": "L8.05.45",
    "Farbtonklasse": "02",
    "Rcolor": "120",
    "Gcolor": "129",
    "Bcolor": "125",
    "Y": 21.2501735687256,
    "L": 53.2222099304199,
    "a": -4.34056615829468,
    "b": 0.80666148662567,
    "C": 4.41488599777222,
    "h": 169.472122192383,
    "CMY_C": 0.5306521654129,
    "CMY_M": 0.49247688055038,
    "CMY_Y": 0.51149463653564,
    "CMYK_C": 0.0752188116312,
    "CMYK_M": 0,
    "CMYK_Y": 0.03747170418501,
    "CMYK_K": 0.49247688055038
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09769",
    "Farbtonhilfsbezeichnung": "Q5.04.72",
    "Farbtonklasse": "01",
    "Rcolor": "183",
    "Gcolor": "197",
    "Bcolor": "198",
    "Y": 53.9709014892578,
    "L": 78.4447631835938,
    "a": -3.78406691551208,
    "b": -3.25730276107788,
    "C": 4.99291324615479,
    "h": 220.7216796875,
    "CMY_C": 0.28044539690018,
    "CMY_M": 0.22902196645737,
    "CMY_Y": 0.22198706865311,
    "CMYK_C": 0.07513798773289,
    "CMYK_M": 0.00904213450849,
    "CMYK_Y": 0,
    "CMYK_K": 0.22198706865311
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09770",
    "Farbtonhilfsbezeichnung": "R4.05.62",
    "Farbtonklasse": "02",
    "Rcolor": "160",
    "Gcolor": "172",
    "Bcolor": "177",
    "Y": 40.3477325439453,
    "L": 69.7164840698242,
    "a": -3.04520130157471,
    "b": -4.35327672958374,
    "C": 5.31265163421631,
    "h": 235.026473999023,
    "CMY_C": 0.37093937397003,
    "CMY_M": 0.32376265525818,
    "CMY_Y": 0.30724203586578,
    "CMYK_C": 0.09194746613503,
    "CMYK_M": 0.02384760603309,
    "CMYK_Y": 0,
    "CMYK_K": 0.30724203586578
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09771",
    "Farbtonhilfsbezeichnung": "R6.07.52",
    "Farbtonklasse": "02",
    "Rcolor": "133",
    "Gcolor": "147",
    "Bcolor": "152",
    "Y": 28.1174926757813,
    "L": 59.9947319030762,
    "a": -3.73906350135803,
    "b": -4.90964365005493,
    "C": 6.17132043838501,
    "h": 232.707992553711,
    "CMY_C": 0.47854447364807,
    "CMY_M": 0.42344796657562,
    "CMY_Y": 0.40468472242355,
    "CMYK_C": 0.12406829744577,
    "CMYK_M": 0.03151816502213,
    "CMYK_Y": 0,
    "CMYK_K": 0.40468472242355
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09772",
    "Farbtonhilfsbezeichnung": "S0.06.21",
    "Farbtonklasse": "03",
    "Rcolor": "75",
    "Gcolor": "80",
    "Bcolor": "83",
    "Y": 7.84304523468018,
    "L": 33.6538467407227,
    "a": -1.13663721084595,
    "b": -3.20971775054932,
    "C": 3.4050304889679,
    "h": 250.499740600586,
    "CMY_C": 0.70718669891357,
    "CMY_M": 0.68647682666779,
    "CMY_Y": 0.67283302545547,
    "CMYK_C": 0.10500349104404,
    "CMYK_M": 0.04170286655426,
    "CMYK_Y": 0,
    "CMYK_K": 0.67283302545547
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09773",
    "Farbtonhilfsbezeichnung": "RN.02.77",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "211",
    "Bcolor": "211",
    "Y": 63.8361053466797,
    "L": 83.8803634643555,
    "a": -2.117023229599,
    "b": -1.99318099021912,
    "C": 2.90767216682434,
    "h": 223.274169921875,
    "CMY_C": 0.20361518859863,
    "CMY_M": 0.17387527227402,
    "CMY_Y": 0.17195671796799,
    "CMYK_C": 0.03823287039995,
    "CMYK_M": 0.00231697340496,
    "CMYK_Y": 0,
    "CMYK_K": 0.17195671796799
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09774",
    "Farbtonhilfsbezeichnung": "S2.07.58",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "159",
    "Bcolor": "167",
    "Y": 33.4973754882813,
    "L": 64.5616302490234,
    "a": -3.33217906951904,
    "b": -6.66274166107178,
    "C": 7.44953298568726,
    "h": 243.429397583008,
    "CMY_C": 0.43551200628281,
    "CMY_M": 0.37657898664474,
    "CMY_Y": 0.34533679485321,
    "CMYK_C": 0.13774290680885,
    "CMYK_M": 0.0477225407958,
    "CMYK_Y": 0,
    "CMYK_K": 0.34533679485321
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09775",
    "Farbtonhilfsbezeichnung": "S0.16.22",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "82",
    "Bcolor": "90",
    "Y": 7.92475509643555,
    "L": 33.82568359375,
    "a": -3.40712714195251,
    "b": -6.9010796546936,
    "C": 7.69632482528687,
    "h": 243.724014282227,
    "CMY_C": 0.73567712306976,
    "CMY_M": 0.67966592311859,
    "CMY_Y": 0.64887285232544,
    "CMYK_C": 0.24721606075764,
    "CMYK_M": 0.08769778162241,
    "CMYK_Y": 0,
    "CMYK_K": 0.64887285232544
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09776",
    "Farbtonhilfsbezeichnung": "S2.04.76",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "209",
    "Bcolor": "213",
    "Y": 62.5694732666016,
    "L": 83.2153396606445,
    "a": -2.13691425323486,
    "b": -3.85074305534363,
    "C": 4.40393304824829,
    "h": 240.972549438477,
    "CMY_C": 0.2178316116333,
    "CMY_M": 0.18058407306671,
    "CMY_Y": 0.16571074724197,
    "CMYK_C": 0.06247337535024,
    "CMYK_M": 0.01782754063606,
    "CMYK_Y": 0,
    "CMYK_K": 0.16571074724197
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09777",
    "Farbtonhilfsbezeichnung": "S4.04.62",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "170",
    "Bcolor": "175",
    "Y": 39.5203475952148,
    "L": 69.1265258789063,
    "a": -1.7314829826355,
    "b": -4.12567567825317,
    "C": 4.47428560256958,
    "h": 247.232955932617,
    "CMY_C": 0.36586809158325,
    "CMY_M": 0.33292758464813,
    "CMY_Y": 0.31489491462708,
    "CMYK_C": 0.07440198212862,
    "CMYK_M": 0.02632102742791,
    "CMYK_Y": 0,
    "CMYK_K": 0.31489491462708
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09778",
    "Farbtonhilfsbezeichnung": "S3.09.53",
    "Farbtonklasse": "02",
    "Rcolor": "134",
    "Gcolor": "150",
    "Bcolor": "159",
    "Y": 29.3110218048096,
    "L": 61.0551490783691,
    "a": -3.45248174667358,
    "b": -7.28285074234009,
    "C": 8.05974864959717,
    "h": 244.636413574219,
    "CMY_C": 0.47475570440292,
    "CMY_M": 0.41246825456619,
    "CMY_Y": 0.37755256891251,
    "CMYK_C": 0.15616279840469,
    "CMYK_M": 0.05609419196844,
    "CMYK_Y": 0,
    "CMYK_K": 0.37755256891251
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09779",
    "Farbtonhilfsbezeichnung": "S2.13.39",
    "Farbtonklasse": "02",
    "Rcolor": "99",
    "Gcolor": "117",
    "Bcolor": "127",
    "Y": 16.8963661193848,
    "L": 48.1291885375977,
    "a": -3.98256182670593,
    "b": -8.4441967010498,
    "C": 9.33623313903809,
    "h": 244.749893188477,
    "CMY_C": 0.61209017038345,
    "CMY_M": 0.54137420654297,
    "CMY_Y": 0.50106167793274,
    "CMYK_C": 0.22252950072289,
    "CMYK_M": 0.08079661428928,
    "CMYK_Y": 0,
    "CMYK_K": 0.50106167793274
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09780",
    "Farbtonhilfsbezeichnung": "S5.03.16",
    "Farbtonklasse": "03",
    "Rcolor": "67",
    "Gcolor": "70",
    "Bcolor": "71",
    "Y": 5.98432922363281,
    "L": 29.3728923797607,
    "a": -0.55908387899399,
    "b": -1.86353099346161,
    "C": 1.94559049606323,
    "h": 253.300064086914,
    "CMY_C": 0.73769557476044,
    "CMY_M": 0.7269184589386,
    "CMY_Y": 0.71990525722504,
    "CMYK_C": 0.06351535767317,
    "CMYK_M": 0.02503867633641,
    "CMYK_Y": 0,
    "CMYK_K": 0.71990525722504
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09781",
    "Farbtonhilfsbezeichnung": "S9.06.72",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "197",
    "Bcolor": "206",
    "Y": 54.6320838928223,
    "L": 78.8288726806641,
    "a": -2.20754528045654,
    "b": -6.57648515701294,
    "C": 6.93710422515869,
    "h": 251.44450378418,
    "CMY_C": 0.27616304159164,
    "CMY_M": 0.22741603851318,
    "CMY_Y": 0.19379591941833,
    "CMYK_C": 0.1021665930748,
    "CMYK_M": 0.04170174896717,
    "CMYK_Y": 0,
    "CMYK_K": 0.19379591941833
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09782",
    "Farbtonhilfsbezeichnung": "T5.03.76",
    "Farbtonklasse": "01",
    "Rcolor": "201",
    "Gcolor": "207",
    "Bcolor": "212",
    "Y": 61.6084938049316,
    "L": 82.7047805786133,
    "a": -0.81491607427597,
    "b": -4.06925249099731,
    "C": 4.15004873275757,
    "h": 258.675628662109,
    "CMY_C": 0.21352601051331,
    "CMY_M": 0.18913990259171,
    "CMY_Y": 0.16953009366989,
    "CMYK_C": 0.05297713726759,
    "CMYK_M": 0.02361290715635,
    "CMYK_Y": 0,
    "CMYK_K": 0.16953009366989
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09783",
    "Farbtonhilfsbezeichnung": "T4.04.66",
    "Farbtonklasse": "01",
    "Rcolor": "170",
    "Gcolor": "178",
    "Bcolor": "187",
    "Y": 44.1665878295898,
    "L": 72.3397064208984,
    "a": -0.9615381360054,
    "b": -5.93810176849365,
    "C": 6.01544761657715,
    "h": 260.802124023438,
    "CMY_C": 0.33273100852966,
    "CMY_M": 0.30007773637772,
    "CMY_Y": 0.26801747083664,
    "CMYK_C": 0.08840858191252,
    "CMYK_M": 0.04379922151566,
    "CMYK_Y": 0,
    "CMYK_K": 0.26801747083664
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09784",
    "Farbtonhilfsbezeichnung": "T4.04.55",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "153",
    "Bcolor": "159",
    "Y": 31.293830871582,
    "L": 62.7548980712891,
    "a": -0.68327224254608,
    "b": -4.63792181015015,
    "C": 4.6879825592041,
    "h": 261.619293212891,
    "CMY_C": 0.42561167478561,
    "CMY_M": 0.40159964561462,
    "CMY_Y": 0.37773954868317,
    "CMYK_C": 0.07693261653185,
    "CMYK_M": 0.03834422677755,
    "CMYK_Y": 0,
    "CMYK_K": 0.37773954868317
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09785",
    "Farbtonhilfsbezeichnung": "T5.06.44",
    "Farbtonklasse": "02",
    "Rcolor": "119",
    "Gcolor": "127",
    "Bcolor": "135",
    "Y": 20,
    "L": 52.6534118652344,
    "a": -0.81202882528305,
    "b": -6.27163934707642,
    "C": 6.32399034500122,
    "h": 262.622589111328,
    "CMY_C": 0.53443133831024,
    "CMY_M": 0.50354933738708,
    "CMY_Y": 0.46978133916855,
    "CMYK_C": 0.12193082273006,
    "CMYK_M": 0.06368692964315,
    "CMYK_Y": 0,
    "CMYK_K": 0.46978133916855
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09786",
    "Farbtonhilfsbezeichnung": "UN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "219",
    "Bcolor": "221",
    "Y": 70.7785873413086,
    "L": 87.377326965332,
    "a": 0.40506687760353,
    "b": -1.87886726856232,
    "C": 1.92203569412231,
    "h": 282.166259765625,
    "CMY_C": 0.14473062753677,
    "CMY_M": 0.14125639200211,
    "CMY_Y": 0.13414865732193,
    "CMYK_C": 0.01222146302462,
    "CMYK_M": 0.00820895470679,
    "CMYK_Y": 0,
    "CMYK_K": 0.13414865732193
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09787",
    "Farbtonhilfsbezeichnung": "UN.02.76",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "208",
    "Bcolor": "213",
    "Y": 62.8240242004395,
    "L": 83.3497009277344,
    "a": 0.08304861932993,
    "b": -3.54198813438416,
    "C": 3.54296159744263,
    "h": 271.343170166016,
    "CMY_C": 0.19741266965866,
    "CMY_M": 0.18431836366653,
    "CMY_Y": 0.16619968414307,
    "CMYK_C": 0.03743460401893,
    "CMYK_M": 0.02173023857176,
    "CMYK_Y": 0,
    "CMYK_K": 0.16619968414307
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09788",
    "Farbtonhilfsbezeichnung": "U5.03.72",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "195",
    "Bcolor": "203",
    "Y": 54.6180267333984,
    "L": 78.8207321166992,
    "a": 0.26436257362366,
    "b": -5.00195407867432,
    "C": 5.00893545150757,
    "h": 273.025360107422,
    "CMY_C": 0.25039106607437,
    "CMY_M": 0.23359668254852,
    "CMY_Y": 0.20488709211349,
    "CMYK_C": 0.05722957476974,
    "CMYK_M": 0.03610756248236,
    "CMYK_Y": 0,
    "CMYK_K": 0.20488709211349
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09789",
    "Farbtonhilfsbezeichnung": "U6.05.62",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "168",
    "Bcolor": "179",
    "Y": 39.1511726379395,
    "L": 68.8606262207031,
    "a": 0.76373708248138,
    "b": -6.78866195678711,
    "C": 6.83148765563965,
    "h": 276.418884277344,
    "CMY_C": 0.35891705751419,
    "CMY_M": 0.34049940109253,
    "CMY_Y": 0.2987893819809,
    "CMYK_C": 0.08574838191271,
    "CMYK_M": 0.05948286876082,
    "CMYK_Y": 0,
    "CMYK_K": 0.2987893819809
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09790",
    "Farbtonhilfsbezeichnung": "U7.07.52",
    "Farbtonklasse": "02",
    "Rcolor": "139",
    "Gcolor": "144",
    "Bcolor": "158",
    "Y": 28.0276889801025,
    "L": 59.9137420654297,
    "a": 1.37752664089203,
    "b": -8.71447372436523,
    "C": 8.82267761230469,
    "h": 278.982604980469,
    "CMY_C": 0.45384806394577,
    "CMY_M": 0.43413001298904,
    "CMY_Y": 0.37907248735428,
    "CMYK_C": 0.12042561173439,
    "CMYK_M": 0.08866981416941,
    "CMYK_Y": 0,
    "CMYK_K": 0.37907248735428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09791",
    "Farbtonhilfsbezeichnung": "U6.09.35",
    "Farbtonklasse": "03",
    "Rcolor": "102",
    "Gcolor": "107",
    "Bcolor": "120",
    "Y": 14.6473665237427,
    "L": 45.1473808288574,
    "a": 1.46269798278809,
    "b": -8.70979976654053,
    "C": 8.83176612854004,
    "h": 279.533111572266,
    "CMY_C": 0.59985458850861,
    "CMY_M": 0.58147239685059,
    "CMY_Y": 0.52828860282898,
    "CMYK_C": 0.1517156213522,
    "CMYK_M": 0.11274646967649,
    "CMYK_Y": 0,
    "CMYK_K": 0.52828860282898
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09792",
    "Farbtonhilfsbezeichnung": "VN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "220",
    "Bcolor": "221",
    "Y": 71.6506881713867,
    "L": 87.800178527832,
    "a": 0.85426795482635,
    "b": -1.32068574428558,
    "C": 1.57289052009583,
    "h": 302.896270751953,
    "CMY_C": 0.13455635309219,
    "CMY_M": 0.13780468702316,
    "CMY_Y": 0.13353395462036,
    "CMYK_C": 0.00117996369954,
    "CMYK_M": 0.00492890924215,
    "CMYK_Y": 0,
    "CMYK_K": 0.13353395462036
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09793",
    "Farbtonhilfsbezeichnung": "WN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "209",
    "Bcolor": "212",
    "Y": 64.1511154174805,
    "L": 84.0443878173828,
    "a": 1.80570924282074,
    "b": -2.0954213142395,
    "C": 2.7661120891571,
    "h": 310.752807617188,
    "CMY_C": 0.17116475105286,
    "CMY_M": 0.1811757683754,
    "CMY_Y": 0.16890394687653,
    "CMYK_C": 0.0027202682104,
    "CMYK_M": 0.01476582791656,
    "CMYK_Y": 0,
    "CMYK_K": 0.16890394687653
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09794",
    "Farbtonhilfsbezeichnung": "VN.02.67",
    "Farbtonklasse": "01",
    "Rcolor": "180",
    "Gcolor": "180",
    "Bcolor": "186",
    "Y": 45.8336715698242,
    "L": 73.4374771118164,
    "a": 1.63027393817902,
    "b": -3.93193411827087,
    "C": 4.25651264190674,
    "h": 292.520080566406,
    "CMY_C": 0.29360979795456,
    "CMY_M": 0.29485028982162,
    "CMY_Y": 0.27017056941986,
    "CMYK_C": 0.03211603686213,
    "CMYK_M": 0.03381573781371,
    "CMYK_Y": 0,
    "CMYK_K": 0.27017056941986
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09795",
    "Farbtonhilfsbezeichnung": "V7.04.52",
    "Farbtonklasse": "02",
    "Rcolor": "142",
    "Gcolor": "141",
    "Bcolor": "150",
    "Y": 26.957691192627,
    "L": 58.9351425170898,
    "a": 2.43150043487549,
    "b": -5.63820838928223,
    "C": 6.14016199111938,
    "h": 293.328308105469,
    "CMY_C": 0.44477146863937,
    "CMY_M": 0.4473552107811,
    "CMY_Y": 0.40989106893539,
    "CMYK_C": 0.0591084100306,
    "CMYK_M": 0.06348682194948,
    "CMYK_Y": 0,
    "CMYK_K": 0.40989106893539
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09796",
    "Farbtonhilfsbezeichnung": "V6.05.46",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "130",
    "Bcolor": "142",
    "Y": 22.8533306121826,
    "L": 54.9209480285645,
    "a": 2.79703617095947,
    "b": -6.48882961273193,
    "C": 7.06599760055542,
    "h": 293.318664550781,
    "CMY_C": 0.48569631576538,
    "CMY_M": 0.48852515220642,
    "CMY_Y": 0.44504350423813,
    "CMYK_C": 0.07325404882431,
    "CMYK_M": 0.07835145294666,
    "CMYK_Y": 0,
    "CMYK_K": 0.44504350423813
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09797",
    "Farbtonhilfsbezeichnung": "V8.05.35",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "105",
    "Bcolor": "113",
    "Y": 14.2564039230347,
    "L": 44.5984230041504,
    "a": 2.40282726287842,
    "b": -4.95356559753418,
    "C": 5.50557804107666,
    "h": 295.876647949219,
    "CMY_C": 0.58527159690857,
    "CMY_M": 0.58983135223389,
    "CMY_Y": 0.55770993232727,
    "CMYK_C": 0.06231581047177,
    "CMYK_M": 0.07262523472309,
    "CMYK_Y": 0,
    "CMYK_K": 0.55770993232727
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09798",
    "Farbtonhilfsbezeichnung": "W9.10.13",
    "Farbtonklasse": "04",
    "Rcolor": "70",
    "Gcolor": "64",
    "Bcolor": "74",
    "Y": 5.50544834136963,
    "L": 28.1288108825684,
    "a": 4.65984487533569,
    "b": -5.32559633255005,
    "C": 7.07644891738892,
    "h": 311.185607910156,
    "CMY_C": 0.72564303874969,
    "CMY_M": 0.74747782945633,
    "CMY_Y": 0.70998907089233,
    "CMYK_C": 0.05397716537118,
    "CMYK_M": 0.12926670908928,
    "CMYK_Y": 0,
    "CMYK_K": 0.70998907089233
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09799",
    "Farbtonhilfsbezeichnung": "WN.00.79",
    "Farbtonklasse": "01",
    "Rcolor": "221",
    "Gcolor": "220",
    "Bcolor": "219",
    "Y": 71.471923828125,
    "L": 87.7137832641602,
    "a": 0.70931398868561,
    "b": -0.67631363868713,
    "C": 0.98006451129913,
    "h": 316.364318847656,
    "CMY_C": 0.13442748785019,
    "CMY_M": 0.1386034488678,
    "CMY_Y": 0.13923597335815,
    "CMYK_C": 0,
    "CMYK_M": 0.00482450751588,
    "CMYK_Y": 0.00555526604876,
    "CMYK_K": 0.13442748785019
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09800",
    "Farbtonhilfsbezeichnung": "WN.02.72",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "200",
    "Y": 54.8340873718262,
    "L": 78.9456024169922,
    "a": 2.01943683624268,
    "b": -3.2117486000061,
    "C": 3.79387068748474,
    "h": 302.160278320313,
    "CMY_C": 0.22894710302353,
    "CMY_M": 0.23684507608414,
    "CMY_Y": 0.21616691350937,
    "CMYK_C": 0.01630473323166,
    "CMYK_M": 0.02638082392514,
    "CMYK_Y": 0,
    "CMYK_K": 0.21616691350937
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09801",
    "Farbtonhilfsbezeichnung": "WN.02.68",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "183",
    "Bcolor": "190",
    "Y": 47.8856010437012,
    "L": 74.7527160644531,
    "a": 2.35988092422485,
    "b": -4.08418130874634,
    "C": 4.71694564819336,
    "h": 300.019744873047,
    "CMY_C": 0.27450048923492,
    "CMY_M": 0.28245693445206,
    "CMY_Y": 0.25495743751526,
    "CMYK_C": 0.02623078599572,
    "CMYK_M": 0.0369099676609,
    "CMYK_Y": 0,
    "CMYK_K": 0.25495743751526
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09802",
    "Farbtonhilfsbezeichnung": "W2.04.59",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "160",
    "Bcolor": "170",
    "Y": 35.5916366577148,
    "L": 66.2067184448242,
    "a": 3.11940550804138,
    "b": -5.55676031112671,
    "C": 6.37246227264404,
    "h": 299.30859375,
    "CMY_C": 0.36427557468414,
    "CMY_M": 0.37399178743362,
    "CMY_Y": 0.33501249551773,
    "CMYK_C": 0.04400545731187,
    "CMYK_M": 0.05861657857895,
    "CMYK_Y": 0,
    "CMYK_K": 0.33501249551773
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09803",
    "Farbtonhilfsbezeichnung": "W2.05.49",
    "Farbtonklasse": "02",
    "Rcolor": "141",
    "Gcolor": "137",
    "Bcolor": "150",
    "Y": 25.8136329650879,
    "L": 57.8597259521484,
    "a": 3.98013639450073,
    "b": -6.85186719894409,
    "C": 7.92398691177368,
    "h": 300.151580810547,
    "CMY_C": 0.44853943586349,
    "CMY_M": 0.46139478683472,
    "CMY_Y": 0.41252946853638,
    "CMYK_C": 0.06129663437605,
    "CMYK_M": 0.08317918330431,
    "CMYK_Y": 0,
    "CMYK_K": 0.41252946853638
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09804",
    "Farbtonhilfsbezeichnung": "W3.13.20",
    "Farbtonklasse": "04",
    "Rcolor": "79",
    "Gcolor": "73",
    "Bcolor": "89",
    "Y": 7.19259166717529,
    "L": 32.2413864135742,
    "a": 6.09084177017212,
    "b": -9.07621383666992,
    "C": 10.9305086135864,
    "h": 303.864654541016,
    "CMY_C": 0.69072794914246,
    "CMY_M": 0.71242213249207,
    "CMY_Y": 0.64950841665268,
    "CMYK_C": 0.11760491132736,
    "CMYK_M": 0.17950135469437,
    "CMYK_Y": 0,
    "CMYK_K": 0.64950841665268
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09805",
    "Farbtonhilfsbezeichnung": "AN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "220",
    "Bcolor": "218",
    "Y": 72.0986099243164,
    "L": 88.0160369873047,
    "a": 0.88242334127426,
    "b": 0.70893394947052,
    "C": 1.13192677497864,
    "h": 38.7782020568848,
    "CMY_C": 0.12501692771912,
    "CMY_M": 0.13606643676758,
    "CMY_Y": 0.14607053995132,
    "CMYK_C": 0,
    "CMYK_M": 0.01262825448066,
    "CMYK_Y": 0.02406173571944,
    "CMYK_K": 0.12501692771912
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09806",
    "Farbtonhilfsbezeichnung": "BN.01.77",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "208",
    "Bcolor": "206",
    "Y": 63.7715110778809,
    "L": 83.8466644287109,
    "a": 2.57119464874268,
    "b": 0.98715668916702,
    "C": 2.7541823387146,
    "h": 21.0032539367676,
    "CMY_C": 0.15714830160141,
    "CMY_M": 0.18604218959808,
    "CMY_Y": 0.19337451457977,
    "CMYK_C": 0,
    "CMYK_M": 0.03428110480309,
    "CMYK_Y": 0.04298052936792,
    "CMYK_K": 0.15714830160141
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09807",
    "Farbtonhilfsbezeichnung": "ZN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "196",
    "Gcolor": "193",
    "Bcolor": "193",
    "Y": 53.8953247070313,
    "L": 78.4006576538086,
    "a": 1.53934288024902,
    "b": -0.54661041498184,
    "C": 1.63351142406464,
    "h": 340.450378417969,
    "CMY_C": 0.22950124740601,
    "CMY_M": 0.24237668514252,
    "CMY_Y": 0.24122095108032,
    "CMYK_C": 0,
    "CMYK_M": 0.01671052351594,
    "CMYK_Y": 0.01521054189652,
    "CMYK_K": 0.22950124740601
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09808",
    "Farbtonhilfsbezeichnung": "ZN.02.56",
    "Farbtonklasse": "02",
    "Rcolor": "161",
    "Gcolor": "154",
    "Bcolor": "155",
    "Y": 32.8959121704102,
    "L": 64.0765380859375,
    "a": 3.18863248825073,
    "b": -0.68253284692764,
    "C": 3.2608630657196,
    "h": 347.918060302734,
    "CMY_C": 0.3700076341629,
    "CMY_M": 0.39765816926956,
    "CMY_Y": 0.39077663421631,
    "CMYK_C": 0,
    "CMYK_M": 0.04389027133584,
    "CMYK_Y": 0.03296706452966,
    "CMYK_K": 0.3700076341629
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09809",
    "Farbtonhilfsbezeichnung": "YN.02.45",
    "Farbtonklasse": "02",
    "Rcolor": "131",
    "Gcolor": "125",
    "Bcolor": "128",
    "Y": 21.0780849456787,
    "L": 53.034854888916,
    "a": 2.84136009216309,
    "b": -1.5034122467041,
    "C": 3.21458792686462,
    "h": 332.115905761719,
    "CMY_C": 0.48808968067169,
    "CMY_M": 0.50889348983765,
    "CMY_Y": 0.49714130163193,
    "CMYK_C": 0,
    "CMYK_M": 0.04063955694437,
    "CMYK_Y": 0.01768204383552,
    "CMYK_K": 0.48808968067169
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09810",
    "Farbtonhilfsbezeichnung": "CN.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "205",
    "Bcolor": "204",
    "Y": 61.5345191955566,
    "L": 82.6652603149414,
    "a": 0.70138293504715,
    "b": 0.16719859838486,
    "C": 0.72103631496429,
    "h": 13.408164024353,
    "CMY_C": 0.18715685606003,
    "CMY_M": 0.194311439991,
    "CMY_Y": 0.20048952102661,
    "CMYK_C": 0,
    "CMYK_M": 0.00880192406476,
    "CMYK_Y": 0.01640250720084,
    "CMYK_K": 0.18715685606003
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09811",
    "Farbtonhilfsbezeichnung": "CN.00.70",
    "Farbtonklasse": "01",
    "Rcolor": "192",
    "Gcolor": "190",
    "Bcolor": "189",
    "Y": 51.5762252807617,
    "L": 77.0267486572266,
    "a": 0.85773885250092,
    "b": -0.18000471591949,
    "C": 0.8764231801033,
    "h": 348.147918701172,
    "CMY_C": 0.24832087755203,
    "CMY_M": 0.25570780038834,
    "CMY_Y": 0.258649289608,
    "CMYK_C": 0,
    "CMYK_M": 0.00982722919434,
    "CMYK_Y": 0.0137404538691,
    "CMYK_K": 0.24832087755203
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09812",
    "Farbtonhilfsbezeichnung": "E7.03.76",
    "Farbtonklasse": "01",
    "Rcolor": "214",
    "Gcolor": "205",
    "Bcolor": "197",
    "Y": 62.0469207763672,
    "L": 82.9383697509766,
    "a": 1.82824087142944,
    "b": 4.26003122329712,
    "C": 4.63576650619507,
    "h": 66.7728576660156,
    "CMY_C": 0.16242337226868,
    "CMY_M": 0.19511044025421,
    "CMY_Y": 0.22708398103714,
    "CMYK_C": 0,
    "CMYK_M": 0.03902576491237,
    "CMYK_Y": 0.07719963043928,
    "CMYK_K": 0.16242337226868
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09813",
    "Farbtonhilfsbezeichnung": "C7.03.33",
    "Farbtonklasse": "03",
    "Rcolor": "107",
    "Gcolor": "101",
    "Bcolor": "98",
    "Y": 13.2850751876831,
    "L": 43.1896781921387,
    "a": 2.34702253341675,
    "b": 2.00888967514038,
    "C": 3.0893611907959,
    "h": 40.5612487792969,
    "CMY_C": 0.57859665155411,
    "CMY_M": 0.60507929325104,
    "CMY_Y": 0.61579620838165,
    "CMYK_C": 0,
    "CMYK_M": 0.06284392625093,
    "CMYK_Y": 0.08827541768551,
    "CMYK_K": 0.57859665155411
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09814",
    "Farbtonhilfsbezeichnung": "F3.03.80",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "216",
    "Bcolor": "205",
    "Y": 68.8725738525391,
    "L": 86.4409103393555,
    "a": 0.97475236654282,
    "b": 5.00861978530884,
    "C": 5.10258913040161,
    "h": 78.9870452880859,
    "CMY_C": 0.12786436080933,
    "CMY_M": 0.15486985445023,
    "CMY_Y": 0.19479942321777,
    "CMYK_C": 0,
    "CMYK_M": 0.03096478618681,
    "CMYK_Y": 0.07674845308065,
    "CMYK_K": 0.12786436080933
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09815",
    "Farbtonhilfsbezeichnung": "E6.05.68",
    "Farbtonklasse": "02",
    "Rcolor": "194",
    "Gcolor": "182",
    "Bcolor": "171",
    "Y": 47.9393196105957,
    "L": 74.7866363525391,
    "a": 2.57392382621765,
    "b": 6.5538387298584,
    "C": 7.04115676879883,
    "h": 68.5583114624023,
    "CMY_C": 0.23911106586456,
    "CMY_M": 0.28551465272903,
    "CMY_Y": 0.33012866973877,
    "CMYK_C": 0,
    "CMYK_M": 0.06098601967096,
    "CMYK_Y": 0.11962009221315,
    "CMYK_K": 0.23911106586456
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09816",
    "Farbtonhilfsbezeichnung": "EN.02.78",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "207",
    "Bcolor": "201",
    "Y": 62.5667037963867,
    "L": 83.2138748168945,
    "a": 0.97608721256256,
    "b": 2.69397473335266,
    "C": 2.86535263061523,
    "h": 70.0834197998047,
    "CMY_C": 0.17076516151428,
    "CMY_M": 0.18966370820999,
    "CMY_Y": 0.21285736560822,
    "CMYK_C": 0,
    "CMYK_M": 0.02279034256935,
    "CMYK_Y": 0.05076029524207,
    "CMYK_K": 0.17076516151428
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09817",
    "Farbtonhilfsbezeichnung": "EN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "191",
    "Bcolor": "185",
    "Y": 52.8137664794922,
    "L": 77.7649154663086,
    "a": 1.40988540649414,
    "b": 2.90616583824158,
    "C": 3.23010468482971,
    "h": 64.1203155517578,
    "CMY_C": 0.22626310586929,
    "CMY_M": 0.24988597631454,
    "CMY_Y": 0.27278161048889,
    "CMYK_C": 0,
    "CMYK_M": 0.0305308829993,
    "CMYK_Y": 0.06012186408043,
    "CMYK_K": 0.22626310586929
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09818",
    "Farbtonhilfsbezeichnung": "E6.03.67",
    "Farbtonklasse": "02",
    "Rcolor": "187",
    "Gcolor": "180",
    "Bcolor": "173",
    "Y": 46.0395469665527,
    "L": 73.5711898803711,
    "a": 1.57130169868469,
    "b": 3.61642360687256,
    "C": 3.94303297996521,
    "h": 66.515510559082,
    "CMY_C": 0.26811504364014,
    "CMY_M": 0.29538375139236,
    "CMY_Y": 0.32218605279922,
    "CMYK_C": 0,
    "CMYK_M": 0.03725818917155,
    "CMYK_Y": 0.07387910783291,
    "CMYK_K": 0.26811504364014
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09819",
    "Farbtonhilfsbezeichnung": "F3.03.44",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "124",
    "Bcolor": "120",
    "Y": 20.3885364532471,
    "L": 52.2736854553223,
    "a": 0.36229410767555,
    "b": 2.43103790283203,
    "C": 2.4578857421875,
    "h": 81.5236740112305,
    "CMY_C": 0.50126886367798,
    "CMY_M": 0.51212406158447,
    "CMY_Y": 0.53103822469711,
    "CMYK_C": 0,
    "CMYK_M": 0.02176563069224,
    "CMYK_Y": 0.05969019979239,
    "CMYK_K": 0.50126886367798
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09820",
    "Farbtonhilfsbezeichnung": "FN.01.84",
    "Farbtonklasse": "01",
    "Rcolor": "229",
    "Gcolor": "225",
    "Bcolor": "220",
    "Y": 75.7583923339844,
    "L": 89.7470474243164,
    "a": 0.54088741540909,
    "b": 2.09576725959778,
    "C": 2.16443967819214,
    "h": 75.5285720825195,
    "CMY_C": 0.10382223129272,
    "CMY_M": 0.11645239591599,
    "CMY_Y": 0.13732290267944,
    "CMYK_C": 0,
    "CMYK_M": 0.01409337017685,
    "CMYK_Y": 0.03738172724843,
    "CMYK_K": 0.10382223129272
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09821",
    "Farbtonhilfsbezeichnung": "FN.01.79",
    "Farbtonklasse": "01",
    "Rcolor": "216",
    "Gcolor": "213",
    "Bcolor": "207",
    "Y": 66.560417175293,
    "L": 85.2814712524414,
    "a": 0.59960997104645,
    "b": 2.53360605239868,
    "C": 2.60359215736389,
    "h": 76.6852035522461,
    "CMY_C": 0.15141820907593,
    "CMY_M": 0.1660680770874,
    "CMY_Y": 0.18933749198914,
    "CMYK_C": 0,
    "CMYK_M": 0.01726394332945,
    "CMYK_Y": 0.04468547925353,
    "CMYK_K": 0.15141820907593
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09822",
    "Farbtonhilfsbezeichnung": "F0.03.66",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "181",
    "Bcolor": "175",
    "Y": 46.4466171264648,
    "L": 73.8344039916992,
    "a": 0.5672555565834,
    "b": 2.84119868278503,
    "C": 2.89727258682251,
    "h": 78.7091522216797,
    "CMY_C": 0.27509385347366,
    "CMY_M": 0.29006683826447,
    "CMY_Y": 0.31406235694885,
    "CMYK_C": 0,
    "CMYK_M": 0.02065506577492,
    "CMYK_Y": 0.05375662073493,
    "CMYK_K": 0.27509385347366
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09823",
    "Farbtonhilfsbezeichnung": "F9.03.76",
    "Farbtonklasse": "01",
    "Rcolor": "211",
    "Gcolor": "207",
    "Bcolor": "199",
    "Y": 62.7845001220703,
    "L": 83.3288650512695,
    "a": 0.09988719969988,
    "b": 3.80521392822266,
    "C": 3.80652475357056,
    "h": 88.4963226318359,
    "CMY_C": 0.17264473438263,
    "CMY_M": 0.18665677309036,
    "CMY_Y": 0.21981620788574,
    "CMYK_C": 0,
    "CMYK_M": 0.01693593896925,
    "CMYK_Y": 0.05701477453113,
    "CMYK_K": 0.17264473438263
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09824",
    "Farbtonhilfsbezeichnung": "F4.04.73",
    "Farbtonklasse": "01",
    "Rcolor": "202",
    "Gcolor": "196",
    "Bcolor": "185",
    "Y": 55.3515014648438,
    "L": 79.2433090209961,
    "a": 0.81955271959305,
    "b": 5.47075319290161,
    "C": 5.53179979324341,
    "h": 81.480094909668,
    "CMY_C": 0.20673793554306,
    "CMY_M": 0.23323088884354,
    "CMY_Y": 0.27554285526276,
    "CMYK_C": 0,
    "CMYK_M": 0.03339748084545,
    "CMYK_Y": 0.08673667907715,
    "CMYK_K": 0.20673793554306
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09825",
    "Farbtonhilfsbezeichnung": "F6.04.63",
    "Farbtonklasse": "02",
    "Rcolor": "177",
    "Gcolor": "172",
    "Bcolor": "162",
    "Y": 41,
    "L": 70.3460006713867,
    "a": 0.30184522271156,
    "b": 5.01645135879517,
    "C": 5.0255241394043,
    "h": 86.5566024780273,
    "CMY_C": 0.30764734745026,
    "CMY_M": 0.32705664634705,
    "CMY_Y": 0.36593240499496,
    "CMYK_C": 0,
    "CMYK_M": 0.02803383395076,
    "CMYK_Y": 0.08418405801058,
    "CMYK_K": 0.30764734745026
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09826",
    "Farbtonhilfsbezeichnung": "FN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 72.6183090209961,
    "L": 88.2653579711914,
    "a": 0.30741360783577,
    "b": 2.12303757667542,
    "C": 2.14517879486084,
    "h": 81.7608947753906,
    "CMY_C": 0.12202304601669,
    "CMY_M": 0.13234293460846,
    "CMY_Y": 0.15381568670273,
    "CMYK_C": 0,
    "CMYK_M": 0.01175416819751,
    "CMYK_Y": 0.03621124848723,
    "CMYK_K": 0.12202304601669
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09827",
    "Farbtonhilfsbezeichnung": "JN.02.83",
    "Farbtonklasse": "01",
    "Rcolor": "226",
    "Gcolor": "226",
    "Bcolor": "222",
    "Y": 75.9302139282227,
    "L": 89.8269271850586,
    "a": -0.65405249595642,
    "b": 1.23953104019165,
    "C": 1.40150701999664,
    "h": 117.818878173828,
    "CMY_C": 0.11519515514374,
    "CMY_M": 0.11249613761902,
    "CMY_Y": 0.13028943538666,
    "CMYK_C": 0.00304113328457,
    "CMYK_M": 0,
    "CMYK_Y": 0.02004869841039,
    "CMYK_K": 0.11249613761902
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09828",
    "Farbtonhilfsbezeichnung": "JN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "220",
    "Bcolor": "215",
    "Y": 71.3743591308594,
    "L": 87.6665725708008,
    "a": -0.85719966888428,
    "b": 1.46041977405548,
    "C": 1.69340407848358,
    "h": 120.410987854004,
    "CMY_C": 0.1399849653244,
    "CMY_M": 0.13604718446732,
    "CMY_Y": 0.15566402673721,
    "CMYK_C": 0.00455786567181,
    "CMYK_M": 0,
    "CMYK_Y": 0.02270591817796,
    "CMYK_K": 0.13604718446732
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09829",
    "Farbtonhilfsbezeichnung": "JN.01.72",
    "Farbtonklasse": "01",
    "Rcolor": "193",
    "Gcolor": "195",
    "Bcolor": "190",
    "Y": 54.0924072265625,
    "L": 78.5155868530273,
    "a": -1.1740220785141,
    "b": 1.49157607555389,
    "C": 1.89819049835205,
    "h": 128.206344604492,
    "CMY_C": 0.24230140447617,
    "CMY_M": 0.23544943332672,
    "CMY_Y": 0.25498026609421,
    "CMYK_C": 0.00896209012717,
    "CMYK_M": 0,
    "CMYK_Y": 0.02554550766945,
    "CMYK_K": 0.23544943332672
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09830",
    "Farbtonhilfsbezeichnung": "JN.02.61",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "170",
    "Bcolor": "164",
    "Y": 39.6422080993652,
    "L": 69.2139358520508,
    "a": -1.78508043289185,
    "b": 1.72381591796875,
    "C": 2.48154258728027,
    "h": 136.000274658203,
    "CMY_C": 0.34525907039642,
    "CMY_M": 0.33348947763443,
    "CMY_Y": 0.35490292310715,
    "CMYK_C": 0.01765852421522,
    "CMYK_M": 0,
    "CMYK_Y": 0.03212769329548,
    "CMYK_K": 0.33348947763443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09831",
    "Farbtonhilfsbezeichnung": "LN.00.87",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "238",
    "Bcolor": "231",
    "Y": 84.7895202636719,
    "L": 93.7923431396484,
    "a": -0.89322781562805,
    "b": 2.02036261558533,
    "C": 2.20900917053223,
    "h": 113.85082244873,
    "CMY_C": 0.07017070055008,
    "CMY_M": 0.06784451007843,
    "CMY_Y": 0.09228038787842,
    "CMYK_C": 0.00249549630098,
    "CMYK_M": 0,
    "CMYK_Y": 0.02621437981725,
    "CMYK_K": 0.06784451007843
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09832",
    "Farbtonhilfsbezeichnung": "KN.01.74",
    "Farbtonklasse": "01",
    "Rcolor": "198",
    "Gcolor": "201",
    "Bcolor": "198",
    "Y": 57.9814376831055,
    "L": 80.7284698486328,
    "a": -1.32902824878693,
    "b": 0.62308597564697,
    "C": 1.46783936023712,
    "h": 154.881484985352,
    "CMY_C": 0.22247666120529,
    "CMY_M": 0.21085375547409,
    "CMY_Y": 0.22499203681946,
    "CMYK_C": 0.01472845580429,
    "CMYK_M": 0,
    "CMYK_Y": 0.01791592128575,
    "CMYK_K": 0.21085375547409
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09833",
    "Farbtonhilfsbezeichnung": "PN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "218",
    "Bcolor": "216",
    "Y": 69.6341934204102,
    "L": 86.817138671875,
    "a": -1.26959407329559,
    "b": -0.08493111282587,
    "C": 1.27243173122406,
    "h": 183.827163696289,
    "CMY_C": 0.15791672468185,
    "CMY_M": 0.1440412402153,
    "CMY_Y": 0.15368109941483,
    "CMYK_C": 0.01621045917273,
    "CMYK_M": 0,
    "CMYK_Y": 0.01126206014305,
    "CMYK_K": 0.1440412402153
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09834",
    "Farbtonhilfsbezeichnung": "NN.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "203",
    "Gcolor": "205",
    "Bcolor": "203",
    "Y": 60.8694496154785,
    "L": 82.3085098266602,
    "a": -0.78222411870956,
    "b": -0.08987082540989,
    "C": 0.78736990690231,
    "h": 186.554046630859,
    "CMY_C": 0.20346117019653,
    "CMY_M": 0.19468903541565,
    "CMY_Y": 0.20269101858139,
    "CMYK_C": 0.01089285407215,
    "CMYK_M": 0,
    "CMYK_Y": 0.00993651337922,
    "CMYK_K": 0.19468903541565
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09835",
    "Farbtonhilfsbezeichnung": "MN.00.70",
    "Farbtonklasse": "01",
    "Rcolor": "186",
    "Gcolor": "189",
    "Bcolor": "187",
    "Y": 50.3682899475098,
    "L": 76.2947616577148,
    "a": -1.1886488199234,
    "b": -0.35897016525269,
    "C": 1.24167048931122,
    "h": 196.804244995117,
    "CMY_C": 0.27250903844833,
    "CMY_M": 0.25885659456253,
    "CMY_Y": 0.26545721292496,
    "CMYK_C": 0.01842078566551,
    "CMYK_M": 0,
    "CMYK_Y": 0.00890599377453,
    "CMYK_K": 0.25885659456253
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09836",
    "Farbtonhilfsbezeichnung": "RN.01.61",
    "Farbtonklasse": "02",
    "Rcolor": "163",
    "Gcolor": "167",
    "Bcolor": "168",
    "Y": 38.2109489440918,
    "L": 68.1758041381836,
    "a": -0.92822134494781,
    "b": -1.58541774749756,
    "C": 1.83715653419495,
    "h": 239.652114868164,
    "CMY_C": 0.36063915491104,
    "CMY_M": 0.34541660547256,
    "CMY_Y": 0.34250670671463,
    "CMYK_C": 0.02757814899087,
    "CMYK_M": 0.00442574685439,
    "CMYK_Y": 0,
    "CMYK_K": 0.34250670671463
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09837",
    "Farbtonhilfsbezeichnung": "NN.01.54",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "151",
    "Bcolor": "149",
    "Y": 30.2714557647705,
    "L": 61.8877410888672,
    "a": -1.62716197967529,
    "b": -0.46870630979538,
    "C": 1.69332265853882,
    "h": 196.069122314453,
    "CMY_C": 0.42728406190872,
    "CMY_M": 0.40965163707733,
    "CMY_Y": 0.41532701253891,
    "CMYK_C": 0.02986782975495,
    "CMYK_M": 0,
    "CMYK_Y": 0.00961360428482,
    "CMYK_K": 0.40965163707733
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09838",
    "Farbtonhilfsbezeichnung": "R6.05.31",
    "Farbtonklasse": "02",
    "Rcolor": "91",
    "Gcolor": "97",
    "Bcolor": "99",
    "Y": 11.711220741272,
    "L": 40.7534217834473,
    "a": -1.45821130275726,
    "b": -2.58589291572571,
    "C": 2.96870708465576,
    "h": 240.580902099609,
    "CMY_C": 0.64145821332932,
    "CMY_M": 0.61943936347961,
    "CMY_Y": 0.61020994186401,
    "CMYK_C": 0.08016692847013,
    "CMYK_M": 0.02367793023586,
    "CMYK_Y": 0,
    "CMYK_K": 0.61020994186401
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09839",
    "Farbtonhilfsbezeichnung": "SN.00.81",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "219",
    "Bcolor": "217",
    "Y": 70.5224609375,
    "L": 87.2524795532227,
    "a": -0.03736318647861,
    "b": -0.19892385601997,
    "C": 0.20240233838558,
    "h": 259.362274169922,
    "CMY_C": 0.14376300573349,
    "CMY_M": 0.1420790553093,
    "CMY_Y": 0.14790600538254,
    "CMYK_C": 0.00196282705292,
    "CMYK_M": 0,
    "CMYK_Y": 0.0067919427529,
    "CMYK_K": 0.1420790553093
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09840",
    "Farbtonhilfsbezeichnung": "SN.00.76",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "205",
    "Bcolor": "205",
    "Y": 60.8698501586914,
    "L": 82.308723449707,
    "a": -0.11396580189466,
    "b": -1.13078236579895,
    "C": 1.13651084899902,
    "h": 264.244873046875,
    "CMY_C": 0.20180803537369,
    "CMY_M": 0.19593787193298,
    "CMY_Y": 0.19505488872528,
    "CMYK_C": 0.00838957447559,
    "CMYK_M": 0.00109694839921,
    "CMYK_Y": 0,
    "CMYK_K": 0.19505488872528
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09841",
    "Farbtonhilfsbezeichnung": "T7.05.25",
    "Farbtonklasse": "03",
    "Rcolor": "83",
    "Gcolor": "86",
    "Bcolor": "90",
    "Y": 9.21081352233887,
    "L": 36.3870544433594,
    "a": -0.12072207778692,
    "b": -3.25855946540833,
    "C": 3.26079487800598,
    "h": 267.878295898438,
    "CMY_C": 0.67515766620636,
    "CMY_M": 0.66309201717377,
    "CMY_Y": 0.64703559875488,
    "CMYK_C": 0.07967394590378,
    "CMYK_M": 0.04549019038677,
    "CMYK_Y": 0,
    "CMYK_K": 0.64703559875488
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09842",
    "Farbtonhilfsbezeichnung": "TN.01.71",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "193",
    "Bcolor": "194",
    "Y": 52.9664878845215,
    "L": 77.8552093505859,
    "a": 0.00196355790831,
    "b": -1.59487271308899,
    "C": 1.59487390518188,
    "h": 270.070526123047,
    "CMY_C": 0.25075381994247,
    "CMY_M": 0.24441337585449,
    "CMY_Y": 0.23976576328278,
    "CMYK_C": 0.0144535144791,
    "CMYK_M": 0.00611339556053,
    "CMYK_Y": 0,
    "CMYK_K": 0.23976576328278
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09843",
    "Farbtonhilfsbezeichnung": "TN.01.65",
    "Farbtonklasse": "02",
    "Rcolor": "175",
    "Gcolor": "178",
    "Bcolor": "181",
    "Y": 44.4427032470703,
    "L": 72.5234146118164,
    "a": -0.34347569942474,
    "b": -2.52802872657776,
    "C": 2.55125546455383,
    "h": 262.262786865234,
    "CMY_C": 0.31362307071686,
    "CMY_M": 0.30049228668213,
    "CMY_Y": 0.29005646705627,
    "CMYK_C": 0.03319504112005,
    "CMYK_M": 0.01469950657338,
    "CMYK_Y": 0,
    "CMYK_K": 0.29005646705627
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09844",
    "Farbtonhilfsbezeichnung": "TN.02.54",
    "Farbtonklasse": "02",
    "Rcolor": "146",
    "Gcolor": "150",
    "Bcolor": "153",
    "Y": 30.1257190704346,
    "L": 61.7625427246094,
    "a": -0.38288149237633,
    "b": -2.93577718734741,
    "C": 2.96063947677612,
    "h": 262.569488525391,
    "CMY_C": 0.42754572629929,
    "CMY_M": 0.41296780109406,
    "CMY_Y": 0.39958912134171,
    "CMYK_C": 0.04656245559454,
    "CMYK_M": 0.02228254079819,
    "CMYK_Y": 0,
    "CMYK_K": 0.39958912134171
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09845",
    "Farbtonhilfsbezeichnung": "T8.03.26",
    "Farbtonklasse": "03",
    "Rcolor": "85",
    "Gcolor": "87",
    "Bcolor": "89",
    "Y": 9.41333961486816,
    "L": 36.7682342529297,
    "a": -0.01244945824146,
    "b": -2.16401267051697,
    "C": 2.16404843330383,
    "h": 269.670379638672,
    "CMY_C": 0.66740489006042,
    "CMY_M": 0.66002547740936,
    "CMY_Y": 0.65024602413177,
    "CMYK_C": 0.04905981570482,
    "CMYK_M": 0.02796094864607,
    "CMYK_Y": 0,
    "CMYK_K": 0.65024602413177
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09846",
    "Farbtonhilfsbezeichnung": "T3.04.12",
    "Farbtonklasse": "03",
    "Rcolor": "60",
    "Gcolor": "62",
    "Bcolor": "65",
    "Y": 4.84073638916016,
    "L": 26.2761249542236,
    "a": -0.24166701734066,
    "b": -2.24739122390747,
    "C": 2.26034736633301,
    "h": 263.862426757813,
    "CMY_C": 0.76424807310104,
    "CMY_M": 0.75506335496902,
    "CMY_Y": 0.74521720409393,
    "CMYK_C": 0.07469448447227,
    "CMYK_M": 0.03864527493715,
    "CMYK_Y": 0,
    "CMYK_K": 0.74521720409393
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09847",
    "Farbtonhilfsbezeichnung": "ON.01.80",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "216",
    "Bcolor": "214",
    "Y": 68.8988265991211,
    "L": 86.4539260864258,
    "a": 0.16925145685673,
    "b": 0.19660618901253,
    "C": 0.25942254066467,
    "h": 49.2759780883789,
    "CMY_C": 0.14959770441055,
    "CMY_M": 0.15149265527725,
    "CMY_Y": 0.15952384471893,
    "CMYK_C": 0,
    "CMYK_M": 0.00222829938866,
    "CMYK_Y": 0.0116722881794,
    "CMYK_K": 0.14959770441055
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09848",
    "Farbtonhilfsbezeichnung": "SN.00.75",
    "Farbtonklasse": "01",
    "Rcolor": "205",
    "Gcolor": "205",
    "Bcolor": "204",
    "Y": 61.1251525878906,
    "L": 82.4459762573242,
    "a": -0.00888117775321,
    "b": -0.31651306152344,
    "C": 0.31663763523102,
    "h": 268.392730712891,
    "CMY_C": 0.19669735431671,
    "CMY_M": 0.19491422176361,
    "CMY_Y": 0.19945454597473,
    "CMYK_C": 0.00221483549103,
    "CMYK_M": 0,
    "CMYK_Y": 0.00563955353573,
    "CMYK_K": 0.19491422176361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09849",
    "Farbtonhilfsbezeichnung": "ON.01.70",
    "Farbtonklasse": "01",
    "Rcolor": "187",
    "Gcolor": "187",
    "Bcolor": "186",
    "Y": 49.502815246582,
    "L": 75.7630767822266,
    "a": 0.07803918421268,
    "b": -0.28650829195976,
    "C": 0.29694631695747,
    "h": 285.236602783203,
    "CMY_C": 0.26821058988571,
    "CMY_M": 0.26746594905853,
    "CMY_Y": 0.2714741230011,
    "CMYK_C": 0.00101652729791,
    "CMYK_M": 0,
    "CMYK_Y": 0.0054716556333,
    "CMYK_K": 0.26746594905853
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09850",
    "Farbtonhilfsbezeichnung": "ON.00.59",
    "Farbtonklasse": "02",
    "Rcolor": "159",
    "Gcolor": "160",
    "Bcolor": "160",
    "Y": 35.1962814331055,
    "L": 65.9011993408203,
    "a": -0.20274549722672,
    "b": -0.61878859996796,
    "C": 0.6511567234993,
    "h": 251.858673095703,
    "CMY_C": 0.37566316127777,
    "CMY_M": 0.37109881639481,
    "CMY_Y": 0.37279903888702,
    "CMYK_C": 0.00725765014067,
    "CMYK_M": 0,
    "CMYK_Y": 0.00270348112099,
    "CMYK_K": 0.37109881639481
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09982",
    "Farbtonhilfsbezeichnung": "A6.07.70",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "182",
    "Bcolor": "185",
    "Y": 51.4461441040039,
    "L": 76.9484786987305,
    "a": 12.4997320175171,
    "b": 2.19830965995789,
    "C": 12.6915664672852,
    "h": 9.97452354431152,
    "CMY_C": 0.15751349925995,
    "CMY_M": 0.28559148311615,
    "CMY_Y": 0.27483749389648,
    "CMYK_C": 0,
    "CMYK_M": 0.15202377736568,
    "CMYK_Y": 0.13925920426846,
    "CMYK_K": 0.15751349925995
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09983",
    "Farbtonhilfsbezeichnung": "NN.00.80",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "221",
    "Bcolor": "218",
    "Y": 71.8014907836914,
    "L": 87.8729553222656,
    "a": -0.7225895524025,
    "b": 0.39259165525436,
    "C": 0.82235264778137,
    "h": 151.484222412109,
    "CMY_C": 0.14028477668762,
    "CMY_M": 0.13377726078033,
    "CMY_Y": 0.14553660154343,
    "CMYK_C": 0.00751252006739,
    "CMYK_M": 0,
    "CMYK_Y": 0.01357542350888,
    "CMYK_K": 0.13377726078033
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09984",
    "Farbtonhilfsbezeichnung": "F7.07.86",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "236",
    "Bcolor": "214",
    "Y": 84.6292266845703,
    "L": 93.7231063842773,
    "a": 1.0785973072052,
    "b": 11.1215238571167,
    "C": 11.1737041473389,
    "h": 84.4606170654297,
    "CMY_C": 0.02704852819443,
    "CMY_M": 0.07580471038818,
    "CMY_Y": 0.16064631938934,
    "CMYK_C": 0,
    "CMYK_M": 0.05011162906885,
    "CMYK_Y": 0.13731187582016,
    "CMYK_K": 0.02704852819443
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09986",
    "Farbtonhilfsbezeichnung": "EN.01.81",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "221",
    "Bcolor": "216",
    "Y": 72.4141845703125,
    "L": 88.1675720214844,
    "a": 0.89542627334595,
    "b": 2.08439755439758,
    "C": 2.26859021186829,
    "h": 66.7523574829102,
    "CMY_C": 0.11866664886475,
    "CMY_M": 0.13480842113495,
    "CMY_Y": 0.15451979637146,
    "CMYK_C": 0,
    "CMYK_M": 0.01831517182291,
    "CMYK_Y": 0.04068057611585,
    "CMYK_K": 0.11866664886475
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09987",
    "Farbtonhilfsbezeichnung": "F7.08.86",
    "Farbtonklasse": "01",
    "Rcolor": "246",
    "Gcolor": "232",
    "Bcolor": "208",
    "Y": 81.8047256469727,
    "L": 92.4886016845703,
    "a": 1.29714703559875,
    "b": 12.5312328338623,
    "C": 12.5981893539429,
    "h": 84.0901794433594,
    "CMY_C": 0.03537344932556,
    "CMY_M": 0.0905054807663,
    "CMY_Y": 0.18460667133331,
    "CMYK_C": 0,
    "CMYK_M": 0.05715375766158,
    "CMYK_Y": 0.15470570325851,
    "CMYK_K": 0.03537344932556
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09988",
    "Farbtonhilfsbezeichnung": "E4.06.82",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "221",
    "Bcolor": "207",
    "Y": 74.6168670654297,
    "L": 89.2132263183594,
    "a": 4.03954458236694,
    "b": 8.32602310180664,
    "C": 9.2542200088501,
    "h": 64.1186904907227,
    "CMY_C": 0.06395488977432,
    "CMY_M": 0.1325164437294,
    "CMY_Y": 0.1886225938797,
    "CMYK_C": 0,
    "CMYK_M": 0.07324599474669,
    "CMYK_Y": 0.13318556547165,
    "CMYK_K": 0.06395488977432
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09990",
    "Farbtonhilfsbezeichnung": "F7.03.86",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "235",
    "Bcolor": "224",
    "Y": 83.2970809936523,
    "L": 93.1443481445312,
    "a": 0.2907962501049,
    "b": 5.16923427581787,
    "C": 5.17740726470947,
    "h": 86.7802124023438,
    "CMY_C": 0.05774372816086,
    "CMY_M": 0.07880866527557,
    "CMY_Y": 0.12273764610291,
    "CMYK_C": 0,
    "CMYK_M": 0.02235584706068,
    "CMYK_Y": 0.06897690147161,
    "CMYK_K": 0.05774372816086
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09991",
    "Farbtonhilfsbezeichnung": "LN.02.71",
    "Farbtonklasse": "01",
    "Rcolor": "185",
    "Gcolor": "192",
    "Bcolor": "187",
    "Y": 51.4537811279297,
    "L": 76.9530715942383,
    "a": -2.92788815498352,
    "b": 0.75346612930298,
    "C": 3.02328300476074,
    "h": 165.568572998047,
    "CMY_C": 0.27520430088043,
    "CMY_M": 0.24816673994064,
    "CMY_Y": 0.26661306619644,
    "CMYK_C": 0.03596217557788,
    "CMYK_M": 0,
    "CMYK_Y": 0.02453512884676,
    "CMYK_K": 0.24816673994064
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09992",
    "Farbtonhilfsbezeichnung": "F7.06.84",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "225",
    "Bcolor": "207",
    "Y": 76.1089477539063,
    "L": 89.9098968505859,
    "a": 0.91963922977448,
    "b": 9.2304162979126,
    "C": 9.27611541748047,
    "h": 84.3103179931641,
    "CMY_C": 0.07679980993271,
    "CMY_M": 0.11747640371323,
    "CMY_Y": 0.18821001052856,
    "CMYK_C": 0,
    "CMYK_M": 0.04406042769551,
    "CMYK_Y": 0.12067826837301,
    "CMYK_K": 0.07679980993271
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09993",
    "Farbtonhilfsbezeichnung": "F8.07.87",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "235",
    "Bcolor": "215",
    "Y": 83.9421234130859,
    "L": 93.4253616333008,
    "a": 0.42790776491165,
    "b": 10.2130813598633,
    "C": 10.2220420837402,
    "h": 87.6008224487305,
    "CMY_C": 0.03801262378693,
    "CMY_M": 0.07733696699142,
    "CMY_Y": 0.15722507238388,
    "CMYK_C": 0,
    "CMYK_M": 0.0408782325685,
    "CMYK_Y": 0.12392309308052,
    "CMYK_K": 0.03801262378693
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09994",
    "Farbtonhilfsbezeichnung": "MN.01.87",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "235",
    "Bcolor": "230",
    "Y": 82.1404266357422,
    "L": 92.6368026733398,
    "a": -2.3716504573822,
    "b": 0.98251163959503,
    "C": 2.56711030006409,
    "h": 157.4970703125,
    "CMY_C": 0.09853303432465,
    "CMY_M": 0.07702624797821,
    "CMY_Y": 0.09757894277573,
    "CMYK_C": 0.02330162376165,
    "CMYK_M": 0,
    "CMYK_Y": 0.02226790785789,
    "CMYK_K": 0.07702624797821
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09995",
    "Farbtonhilfsbezeichnung": "NN.01.85",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "238",
    "Bcolor": "233",
    "Y": 83.6916656494141,
    "L": 93.3164215087891,
    "a": -2.69235897064209,
    "b": 0.25928941369057,
    "C": 2.70481562614441,
    "h": 174.499053955078,
    "CMY_C": 0.09611302614212,
    "CMY_M": 0.06844937801361,
    "CMY_Y": 0.08469706773758,
    "CMYK_C": 0.02969634532928,
    "CMYK_M": 0,
    "CMYK_Y": 0.01744155399501,
    "CMYK_K": 0.06844937801361
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09996",
    "Farbtonhilfsbezeichnung": "QN.01.83",
    "Farbtonklasse": "01",
    "Rcolor": "222",
    "Gcolor": "228",
    "Bcolor": "227",
    "Y": 76.5202789306641,
    "L": 90.1003570556641,
    "a": -1.80096626281738,
    "b": -1.11779808998108,
    "C": 2.11965847015381,
    "h": 211.826461791992,
    "CMY_C": 0.12957006692886,
    "CMY_M": 0.10609263181686,
    "CMY_Y": 0.11001658439636,
    "CMYK_C": 0.0262638349086,
    "CMYK_M": 0,
    "CMYK_Y": 0.00438966369256,
    "CMYK_K": 0.10609263181686
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09998",
    "Farbtonhilfsbezeichnung": "C9.05.82",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "218",
    "Bcolor": "209",
    "Y": 73.159912109375,
    "L": 88.52392578125,
    "a": 7.00566959381104,
    "b": 6.37217235565186,
    "C": 9.47016334533691,
    "h": 42.2888298034668,
    "CMY_C": 0.05551338195801,
    "CMY_M": 0.14695531129837,
    "CMY_Y": 0.18127274513245,
    "CMYK_C": 0,
    "CMYK_M": 0.0968165397644,
    "CMYK_Y": 0.13315102458,
    "CMYK_K": 0.05551338195801
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI09999",
    "Farbtonhilfsbezeichnung": "C9.21.64",
    "Farbtonklasse": "02",
    "Rcolor": "223",
    "Gcolor": "161",
    "Bcolor": "140",
    "Y": 43.2100715637207,
    "L": 71.6973190307617,
    "a": 20.3719749450684,
    "b": 19.7232856750488,
    "C": 28.3553409576416,
    "h": 44.0731086730957,
    "CMY_C": 0.12554675340652,
    "CMY_M": 0.3669046163559,
    "CMY_Y": 0.45237874984741,
    "CMYK_C": 0,
    "CMYK_M": 0.27601003646851,
    "CMYK_Y": 0.37375581264496,
    "CMYK_K": 0.12554675340652
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI10000",
    "Farbtonhilfsbezeichnung": "V8.07.70",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "187",
    "Bcolor": "207",
    "Y": 50.9270057678223,
    "L": 76.6347732543945,
    "a": 5.74959182739258,
    "b": -10.8041372299194,
    "C": 12.2387571334839,
    "h": 298.020385742188,
    "CMY_C": 0.25236904621124,
    "CMY_M": 0.26823818683624,
    "CMY_Y": 0.18640494346619,
    "CMYK_C": 0.08107731491327,
    "CMYK_M": 0.10058227926493,
    "CMYK_Y": 0,
    "CMYK_K": 0.18640494346619
  },
  {
    "Farbtonkarten_Bezeichnung": "SIKKENS\/AKZO NOBEL",
    "Farbton_ID": "SI10002",
    "Farbtonhilfsbezeichnung": "B9.53.23",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "42",
    "Bcolor": "46",
    "Y": 6.88354873657227,
    "L": 31.540319442749,
    "a": 39.6350593566895,
    "b": 18.8493461608887,
    "C": 43.8889045715332,
    "h": 25.434476852417,
    "CMY_C": 0.47607868909836,
    "CMY_M": 0.83574175834656,
    "CMY_Y": 0.81795161962509,
    "CMYK_C": 0,
    "CMYK_M": 0.6864829659462,
    "CMYK_Y": 0.65252727270126,
    "CMYK_K": 0.47607868909836
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0001",
    "Farbtonhilfsbezeichnung": "BH01A",
    "Farbtonklasse": "04",
    "Rcolor": "181",
    "Gcolor": "73",
    "Bcolor": "59",
    "Y": 14.9213905334473,
    "L": 45.5263442993164,
    "a": 43.3581428527832,
    "b": 30.4864101409912,
    "C": 53.0032997131348,
    "h": 35.1122016906738,
    "CMY_C": 0.28899669647217,
    "CMY_M": 0.71419167518616,
    "CMY_Y": 0.7700526714325,
    "CMYK_C": 0,
    "CMYK_M": 0.59802109003067,
    "CMYK_Y": 0.67658752202988,
    "CMYK_K": 0.28899669647217
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0002",
    "Farbtonhilfsbezeichnung": "BH02A",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "180",
    "Bcolor": "79",
    "Y": 49.0891342163086,
    "L": 75.5067443847656,
    "a": 5.01199913024902,
    "b": 55.3598442077637,
    "C": 55.5862617492676,
    "h": 84.8268356323242,
    "CMY_C": 0.12437462806702,
    "CMY_M": 0.29271084070206,
    "CMY_Y": 0.68850553035736,
    "CMYK_C": 0,
    "CMYK_M": 0.19224683940411,
    "CMYK_Y": 0.64426058530807,
    "CMYK_K": 0.12437462806702
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0003",
    "Farbtonhilfsbezeichnung": "BH03A",
    "Farbtonklasse": "04",
    "Rcolor": "47",
    "Gcolor": "73",
    "Bcolor": "117",
    "Y": 6.66012668609619,
    "L": 31.0203075408936,
    "a": 4.65046167373657,
    "b": -28.7010974884033,
    "C": 29.0754146575928,
    "h": 279.203704833984,
    "CMY_C": 0.81646966934204,
    "CMY_M": 0.71334755420685,
    "CMY_Y": 0.54139888286591,
    "CMYK_C": 0.59980398416519,
    "CMYK_M": 0.37494167685509,
    "CMYK_Y": 0,
    "CMYK_K": 0.54139888286591
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0004",
    "Farbtonhilfsbezeichnung": "BH04A",
    "Farbtonklasse": "01",
    "Rcolor": "236",
    "Gcolor": "234",
    "Bcolor": "231",
    "Y": 82.4218215942383,
    "L": 92.7607192993164,
    "a": 0.33886778354645,
    "b": 0.78504526615143,
    "C": 0.85505992174149,
    "h": 66.6523742675781,
    "CMY_C": 0.07615894079208,
    "CMY_M": 0.08198964595795,
    "CMY_Y": 0.09435945749283,
    "CMYK_C": 0,
    "CMYK_M": 0.00631137238815,
    "CMYK_Y": 0.01970091834664,
    "CMYK_K": 0.07615894079208
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0005",
    "Farbtonhilfsbezeichnung": "BH05A",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "219",
    "Bcolor": "216",
    "Y": 70.6007232666016,
    "L": 87.290657043457,
    "a": -0.4789120554924,
    "b": 0.32607504725456,
    "C": 0.5793804526329,
    "h": 145.750381469727,
    "CMY_C": 0.14501971006393,
    "CMY_M": 0.1407704949379,
    "CMY_Y": 0.15140008926392,
    "CMYK_C": 0.0049453782849,
    "CMYK_M": 0,
    "CMYK_Y": 0.01237107720226,
    "CMYK_K": 0.1407704949379
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0006",
    "Farbtonhilfsbezeichnung": "BH06A",
    "Farbtonklasse": "01",
    "Rcolor": "204",
    "Gcolor": "204",
    "Bcolor": "202",
    "Y": 60.1693382263184,
    "L": 81.9301452636719,
    "a": 0.00478555867448,
    "b": -0.10050291568041,
    "C": 0.10061678290367,
    "h": 272.726135253906,
    "CMY_C": 0.20148175954819,
    "CMY_M": 0.20063579082489,
    "CMY_Y": 0.20660448074341,
    "CMYK_C": 0.00105830200482,
    "CMYK_M": 0,
    "CMYK_Y": 0.00746679631993,
    "CMYK_K": 0.20063579082489
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0007",
    "Farbtonhilfsbezeichnung": "BH07A",
    "Farbtonklasse": "01",
    "Rcolor": "188",
    "Gcolor": "189",
    "Bcolor": "187",
    "Y": 50.5970344543457,
    "L": 76.4342727661133,
    "a": -0.08752753585577,
    "b": -0.01027014292777,
    "C": 0.0881280079484,
    "h": 186.692276000977,
    "CMY_C": 0.26135319471359,
    "CMY_M": 0.25995641946793,
    "CMY_Y": 0.26631218194962,
    "CMYK_C": 0.00188742298633,
    "CMYK_M": 0,
    "CMYK_Y": 0.00858836248517,
    "CMYK_K": 0.25995641946793
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0008",
    "Farbtonhilfsbezeichnung": "BH08A",
    "Farbtonklasse": "01",
    "Rcolor": "159",
    "Gcolor": "159",
    "Bcolor": "158",
    "Y": 34.4424705505371,
    "L": 65.3122711181641,
    "a": 0.18786637485027,
    "b": -0.39375913143158,
    "C": 0.43627977371216,
    "h": 295.506286621094,
    "CMY_C": 0.37814915180206,
    "CMY_M": 0.37816166877747,
    "CMY_Y": 0.38040012121201,
    "CMYK_C": 0,
    "CMYK_M": 2.012858204e-05,
    "CMYK_Y": 0.00361978984438,
    "CMYK_K": 0.37814915180206
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0009",
    "Farbtonhilfsbezeichnung": "BH09A",
    "Farbtonklasse": "01",
    "Rcolor": "127",
    "Gcolor": "128",
    "Bcolor": "127",
    "Y": 21.4422187805176,
    "L": 53.4301147460938,
    "a": -0.11995240300894,
    "b": -0.19912186264992,
    "C": 0.23246096074581,
    "h": 238.934951782227,
    "CMY_C": 0.50101149082184,
    "CMY_M": 0.49888640642166,
    "CMY_Y": 0.50223058462143,
    "CMYK_C": 0.00424072379246,
    "CMYK_M": 0,
    "CMYK_Y": 0.00667349342257,
    "CMYK_K": 0.49888640642166
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0010",
    "Farbtonhilfsbezeichnung": "BH10A",
    "Farbtonklasse": "01",
    "Rcolor": "102",
    "Gcolor": "101",
    "Bcolor": "101",
    "Y": 12.4,
    "L": 42.8852691650391,
    "a": 0.34803482890129,
    "b": -0.08215413242579,
    "C": 0.35759970545769,
    "h": 346.718383789063,
    "CMY_C": 0.60077291727066,
    "CMY_M": 0.60331845283508,
    "CMY_Y": 0.60559785366058,
    "CMYK_C": 0,
    "CMYK_M": 0.0063761593774,
    "CMYK_Y": 0.01208569388837,
    "CMYK_K": 0.60077291727066
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0011",
    "Farbtonhilfsbezeichnung": "BH11A",
    "Farbtonklasse": "02",
    "Rcolor": "85",
    "Gcolor": "86",
    "Bcolor": "86",
    "Y": 8.5,
    "L": 36.3427848815918,
    "a": -0.11787340044975,
    "b": -0.81721967458725,
    "C": 0.8256767988205,
    "h": 261.792419433594,
    "CMY_C": 0.66797947883606,
    "CMY_M": 0.66412281990051,
    "CMY_Y": 0.66256153583527,
    "CMYK_C": 0.01605609245598,
    "CMYK_M": 0.004626870621,
    "CMYK_Y": 0,
    "CMYK_K": 0.66256153583527
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0012",
    "Farbtonhilfsbezeichnung": "BH12A",
    "Farbtonklasse": "02",
    "Rcolor": "70",
    "Gcolor": "69",
    "Bcolor": "69",
    "Y": 6.00168800354004,
    "L": 29.4167251586914,
    "a": 0.27001836895943,
    "b": 0.02903689257801,
    "C": 0.27157515287399,
    "h": 6.13781356811523,
    "CMY_C": 0.7264232635498,
    "CMY_M": 0.72855401039124,
    "CMY_Y": 0.7307288646698,
    "CMYK_C": 0,
    "CMYK_M": 0.00778847979382,
    "CMYK_Y": 0.01573818363249,
    "CMYK_K": 0.7264232635498
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0014",
    "Farbtonhilfsbezeichnung": "BH02B",
    "Farbtonklasse": "02",
    "Rcolor": "81",
    "Gcolor": "84",
    "Bcolor": "88",
    "Y": 8.70629692077637,
    "L": 35.4125518798828,
    "a": -0.03307064250112,
    "b": -3.27660155296326,
    "C": 3.27676844596863,
    "h": 269.421722412109,
    "CMY_C": 0.68363553285599,
    "CMY_M": 0.67233145236969,
    "CMY_Y": 0.65600574016571,
    "CMYK_C": 0.08032050728798,
    "CMYK_M": 0.04745925590396,
    "CMYK_Y": 0,
    "CMYK_K": 0.65600574016571
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0015",
    "Farbtonhilfsbezeichnung": "BH03B",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "108",
    "Bcolor": "106",
    "Y": 15.2255744934082,
    "L": 45.9416198730469,
    "a": 2.10328841209412,
    "b": 1.15046000480652,
    "C": 2.39736938476563,
    "h": 28.6778469085693,
    "CMY_C": 0.55572581291199,
    "CMY_M": 0.57779216766357,
    "CMY_Y": 0.5840255022049,
    "CMYK_C": 0,
    "CMYK_M": 0.04966832324862,
    "CMYK_Y": 0.0636987015605,
    "CMYK_K": 0.55572581291199
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0016",
    "Farbtonhilfsbezeichnung": "BH04B",
    "Farbtonklasse": "01",
    "Rcolor": "162",
    "Gcolor": "155",
    "Bcolor": "153",
    "Y": 33.4707641601563,
    "L": 64.5402908325195,
    "a": 2.29853010177612,
    "b": 1.4457745552063,
    "C": 2.71541976928711,
    "h": 32.1698760986328,
    "CMY_C": 0.36504423618317,
    "CMY_M": 0.39140492677689,
    "CMY_Y": 0.40077620744705,
    "CMYK_C": 0,
    "CMYK_M": 0.04151578992605,
    "CMYK_Y": 0.05627474188805,
    "CMYK_K": 0.36504423618317
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0017",
    "Farbtonhilfsbezeichnung": "BH05B",
    "Farbtonklasse": "01",
    "Rcolor": "224",
    "Gcolor": "217",
    "Bcolor": "212",
    "Y": 70.4303359985352,
    "L": 87.2074966430664,
    "a": 1.70432507991791,
    "b": 2.64569735527039,
    "C": 3.14713168144226,
    "h": 57.2108726501465,
    "CMY_C": 0.12126338481903,
    "CMY_M": 0.1475026011467,
    "CMY_Y": 0.16902577877045,
    "CMYK_C": 0,
    "CMYK_M": 0.02986016124487,
    "CMYK_Y": 0.05435347929597,
    "CMYK_K": 0.12126338481903
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0018",
    "Farbtonhilfsbezeichnung": "BH06B",
    "Farbtonklasse": "01",
    "Rcolor": "234",
    "Gcolor": "232",
    "Bcolor": "228",
    "Y": 81.0414581298828,
    "L": 92.1501388549805,
    "a": 0.18748800456524,
    "b": 1.30757665634155,
    "C": 1.32094979286194,
    "h": 81.840217590332,
    "CMY_C": 0.08241385221481,
    "CMY_M": 0.08860689401627,
    "CMY_Y": 0.1050283908844,
    "CMYK_C": 0,
    "CMYK_M": 0.00674927560613,
    "CMYK_Y": 0.02464568428695,
    "CMYK_K": 0.08241385221481
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0019",
    "Farbtonhilfsbezeichnung": "BH07B",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "228",
    "Bcolor": "218",
    "Y": 77.6584854125977,
    "L": 90.6238327026367,
    "a": -0.25139859318733,
    "b": 4.48833179473877,
    "C": 4.4953670501709,
    "h": 93.2058715820312,
    "CMY_C": 0.0923957824707,
    "CMY_M": 0.10548114776611,
    "CMY_Y": 0.14549201726913,
    "CMYK_C": 0,
    "CMYK_M": 0.01441747974604,
    "CMYK_Y": 0.05850153043866,
    "CMYK_K": 0.0923957824707
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0020",
    "Farbtonhilfsbezeichnung": "BH08B",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "211",
    "Bcolor": "199",
    "Y": 65.5881195068359,
    "L": 84.785888671875,
    "a": 0.36107817292213,
    "b": 5.68145990371704,
    "C": 5.69292211532593,
    "h": 86.363525390625,
    "CMY_C": 0.14875048398972,
    "CMY_M": 0.17180448770523,
    "CMY_Y": 0.21772456169128,
    "CMYK_C": 0,
    "CMYK_M": 0.02708254568279,
    "CMYK_Y": 0.08102685958147,
    "CMYK_K": 0.14875048398972
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0021",
    "Farbtonhilfsbezeichnung": "BH09B",
    "Farbtonklasse": "01",
    "Rcolor": "178",
    "Gcolor": "172",
    "Bcolor": "161",
    "Y": 41.7325401306152,
    "L": 70.6861267089844,
    "a": 0.52193301916122,
    "b": 5.70488357543945,
    "C": 5.72870922088623,
    "h": 84.7726287841797,
    "CMY_C": 0.30040943622589,
    "CMY_M": 0.32413673400879,
    "CMY_Y": 0.36720901727676,
    "CMYK_C": 0,
    "CMYK_M": 0.03391597792506,
    "CMYK_Y": 0.09548382461071,
    "CMYK_K": 0.30040943622589
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0022",
    "Farbtonhilfsbezeichnung": "BH10B",
    "Farbtonklasse": "01",
    "Rcolor": "167",
    "Gcolor": "170",
    "Bcolor": "164",
    "Y": 39.629020690918,
    "L": 69.2044830322266,
    "a": -1.81114423274994,
    "b": 1.97681307792664,
    "C": 2.6810507774353,
    "h": 132.495727539063,
    "CMY_C": 0.34473741054535,
    "CMY_M": 0.33359813690186,
    "CMY_Y": 0.35677546262741,
    "CMYK_C": 0.0167155507952,
    "CMYK_M": 0,
    "CMYK_Y": 0.03477980196476,
    "CMYK_K": 0.33359813690186
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0023",
    "Farbtonhilfsbezeichnung": "BH11B",
    "Farbtonklasse": "02",
    "Rcolor": "121",
    "Gcolor": "129",
    "Bcolor": "134",
    "Y": 21.6084175109863,
    "L": 53.6090393066406,
    "a": -1.8345228433609,
    "b": -4.20056390762329,
    "C": 4.58368968963623,
    "h": 246.40754699707,
    "CMY_C": 0.52519059181213,
    "CMY_M": 0.49242597818375,
    "CMY_Y": 0.47404986619949,
    "CMYK_C": 0.09723493456841,
    "CMYK_M": 0.03493888676167,
    "CMYK_Y": 0,
    "CMYK_K": 0.47404986619949
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0024",
    "Farbtonhilfsbezeichnung": "BH12B",
    "Farbtonklasse": "03",
    "Rcolor": "98",
    "Gcolor": "116",
    "Bcolor": "127",
    "Y": 16.6268196105957,
    "L": 47.7863426208496,
    "a": -3.94079542160034,
    "b": -8.68005275726318,
    "C": 9.53274250030518,
    "h": 245.581665039062,
    "CMY_C": 0.61606806516647,
    "CMY_M": 0.54476445913315,
    "CMY_Y": 0.50292754173279,
    "CMYK_C": 0.2276137471199,
    "CMYK_M": 0.08416663855314,
    "CMYK_Y": 0,
    "CMYK_K": 0.50292754173279
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0025",
    "Farbtonhilfsbezeichnung": "BH01C",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "206",
    "Bcolor": "233",
    "Y": 59.6088218688965,
    "L": 81.6250991821289,
    "a": -2.22998809814453,
    "b": -17.131591796875,
    "C": 17.2761192321777,
    "h": 262.583618164063,
    "CMY_C": 0.29188257455826,
    "CMY_M": 0.19360458850861,
    "CMY_Y": 0.08687955141068,
    "CMYK_C": 0.22450819611549,
    "CMYK_M": 0.11687947064638,
    "CMYK_Y": 0,
    "CMYK_K": 0.08687955141068
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0026",
    "Farbtonhilfsbezeichnung": "BH02C",
    "Farbtonklasse": "02",
    "Rcolor": "144",
    "Gcolor": "167",
    "Bcolor": "198",
    "Y": 37.8149757385254,
    "L": 67.8840255737305,
    "a": -0.80953365564346,
    "b": -19.2529983520508,
    "C": 19.2700099945068,
    "h": 267.59228515625,
    "CMY_C": 0.43573462963104,
    "CMY_M": 0.34329891204834,
    "CMY_Y": 0.22231501340866,
    "CMYK_C": 0.27442938089371,
    "CMYK_M": 0.15556928515434,
    "CMYK_Y": 0,
    "CMYK_K": 0.22231501340866
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0027",
    "Farbtonhilfsbezeichnung": "BH03C",
    "Farbtonklasse": "04",
    "Rcolor": "89",
    "Gcolor": "107",
    "Bcolor": "150",
    "Y": 14.944769859314,
    "L": 45.5584564208984,
    "a": 4.69265127182007,
    "b": -25.714204788208,
    "C": 26.1388854980469,
    "h": 280.342254638672,
    "CMY_C": 0.64922308921814,
    "CMY_M": 0.57855951786041,
    "CMY_Y": 0.413694024086,
    "CMYK_C": 0.40171697735786,
    "CMYK_M": 0.28119361400604,
    "CMYK_Y": 0,
    "CMYK_K": 0.413694024086
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0028",
    "Farbtonhilfsbezeichnung": "BH04C",
    "Farbtonklasse": "02",
    "Rcolor": "107",
    "Gcolor": "110",
    "Bcolor": "111",
    "Y": 15.3871040344238,
    "L": 46.1598968505859,
    "a": -0.43885001540184,
    "b": -1.37372839450836,
    "C": 1.44212305545807,
    "h": 252.283447265625,
    "CMY_C": 0.57857632637024,
    "CMY_M": 0.56971037387848,
    "CMY_Y": 0.5659231543541,
    "CMYK_C": 0.02914961241186,
    "CMYK_M": 0.00872476771474,
    "CMYK_Y": 0,
    "CMYK_K": 0.5659231543541
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0029",
    "Farbtonhilfsbezeichnung": "BH05C",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "189",
    "Bcolor": "187",
    "Y": 50.9520416259766,
    "L": 76.6499481201172,
    "a": 0.94823384284973,
    "b": 0.31183695793152,
    "C": 0.99819320440292,
    "h": 18.2040100097656,
    "CMY_C": 0.25007289648056,
    "CMY_M": 0.26010596752167,
    "CMY_Y": 0.26617306470871,
    "CMYK_C": 0,
    "CMYK_M": 0.01337872818112,
    "CMYK_Y": 0.0214689783752,
    "CMYK_K": 0.25007289648056
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0030",
    "Farbtonhilfsbezeichnung": "BH06C",
    "Farbtonklasse": "01",
    "Rcolor": "223",
    "Gcolor": "213",
    "Bcolor": "196",
    "Y": 67.0489501953125,
    "L": 85.5286560058594,
    "a": 0.94837331771851,
    "b": 8.63902854919434,
    "C": 8.69092750549316,
    "h": 83.7352828979492,
    "CMY_C": 0.12723135948181,
    "CMY_M": 0.16580605506897,
    "CMY_Y": 0.23125267028809,
    "CMYK_C": 0,
    "CMYK_M": 0.04419807717204,
    "CMYK_Y": 0.11918543279171,
    "CMYK_K": 0.12723135948181
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0031",
    "Farbtonhilfsbezeichnung": "BH07C",
    "Farbtonklasse": "03",
    "Rcolor": "193",
    "Gcolor": "102",
    "Bcolor": "60",
    "Y": 21.1110343933106,
    "L": 53.0707969665527,
    "a": 33.3223915100098,
    "b": 39.2207565307617,
    "C": 51.465030670166,
    "h": 49.6483993530273,
    "CMY_C": 0.24323916435242,
    "CMY_M": 0.60091459751129,
    "CMY_Y": 0.7665843963623,
    "CMYK_C": 0,
    "CMYK_M": 0.47263997793198,
    "CMYK_Y": 0.69155961275101,
    "CMYK_K": 0.24323916435242
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0032",
    "Farbtonhilfsbezeichnung": "BH08C",
    "Farbtonklasse": "03",
    "Rcolor": "218",
    "Gcolor": "153",
    "Bcolor": "81",
    "Y": 38.1254234313965,
    "L": 68.1129531860352,
    "a": 17.5683269500732,
    "b": 46.0907897949219,
    "C": 49.3255195617676,
    "h": 69.134765625,
    "CMY_C": 0.14610999822617,
    "CMY_M": 0.40141475200653,
    "CMY_Y": 0.68155020475388,
    "CMYK_C": 0,
    "CMYK_M": 0.29899021983147,
    "CMYK_Y": 0.62705993652344,
    "CMYK_K": 0.14610999822617
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0033",
    "Farbtonhilfsbezeichnung": "BH09C",
    "Farbtonklasse": "02",
    "Rcolor": "248",
    "Gcolor": "225",
    "Bcolor": "152",
    "Y": 75.8330001831055,
    "L": 89.7817459106445,
    "a": -1.47606956958771,
    "b": 37.713306427002,
    "C": 37.7421798706055,
    "h": 92.2413711547852,
    "CMY_C": 0.02722692489624,
    "CMY_M": 0.11945915222168,
    "CMY_Y": 0.40371507406235,
    "CMYK_C": 0,
    "CMYK_M": 0.09481371194124,
    "CMYK_Y": 0.38702565431595,
    "CMYK_K": 0.02722692489624
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0034",
    "Farbtonhilfsbezeichnung": "BH10C",
    "Farbtonklasse": "01",
    "Rcolor": "244",
    "Gcolor": "238",
    "Bcolor": "221",
    "Y": 85.530891418457,
    "L": 94.1114044189453,
    "a": -0.52374732494354,
    "b": 8.10995388031006,
    "C": 8.1268482208252,
    "h": 93.6950759887695,
    "CMY_C": 0.0439173579216,
    "CMY_M": 0.06681138277054,
    "CMY_Y": 0.13413655757904,
    "CMYK_C": 0,
    "CMYK_M": 0.0239456538111,
    "CMYK_Y": 0.09436339139938,
    "CMYK_K": 0.0439173579216
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0035",
    "Farbtonhilfsbezeichnung": "BH11C",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "240",
    "Bcolor": "234",
    "Y": 86.9723587036133,
    "L": 94.7265472412109,
    "a": -0.23096805810928,
    "b": 1.89745402336121,
    "C": 1.91145968437195,
    "h": 96.9402008056641,
    "CMY_C": 0.05482655763626,
    "CMY_M": 0.05889147520065,
    "CMY_Y": 0.08088874816895,
    "CMYK_C": 0,
    "CMYK_M": 0.00430071074516,
    "CMYK_Y": 0.02757397666574,
    "CMYK_K": 0.05482655763626
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0036",
    "Farbtonhilfsbezeichnung": "BH12C",
    "Farbtonklasse": "03",
    "Rcolor": "188",
    "Gcolor": "185",
    "Bcolor": "137",
    "Y": 47.2882652282715,
    "L": 74.373779296875,
    "a": -6.24357986450195,
    "b": 24.5215244293213,
    "C": 25.3039016723633,
    "h": 104.28490447998,
    "CMY_C": 0.26078444719315,
    "CMY_M": 0.27408367395401,
    "CMY_Y": 0.46467310190201,
    "CMYK_C": 0,
    "CMYK_M": 0.01799099892378,
    "CMYK_Y": 0.27581760287285,
    "CMYK_K": 0.26078444719315
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0037",
    "Farbtonhilfsbezeichnung": "BH01D",
    "Farbtonklasse": "02",
    "Rcolor": "205",
    "Gcolor": "194",
    "Bcolor": "196",
    "Y": 55.7870941162109,
    "L": 79.4924926757813,
    "a": 4.44988536834717,
    "b": -0.27478328347206,
    "C": 4.45836114883423,
    "h": 356.466430664063,
    "CMY_C": 0.19479012489319,
    "CMY_M": 0.23753720521927,
    "CMY_Y": 0.23104774951935,
    "CMYK_C": 0,
    "CMYK_M": 0.05308812111616,
    "CMYK_Y": 0.04502878710628,
    "CMYK_K": 0.19479012489319
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0038",
    "Farbtonhilfsbezeichnung": "BH02D",
    "Farbtonklasse": "01",
    "Rcolor": "243",
    "Gcolor": "234",
    "Bcolor": "216",
    "Y": 82.7807083129883,
    "L": 92.918342590332,
    "a": 0.57159894704819,
    "b": 8.66355800628662,
    "C": 8.68239402770996,
    "h": 86.2252426147461,
    "CMY_C": 0.04727411270142,
    "CMY_M": 0.08295226097107,
    "CMY_Y": 0.15120488405228,
    "CMYK_C": 0,
    "CMYK_M": 0.03744849190116,
    "CMYK_Y": 0.10908780246973,
    "CMYK_K": 0.04727411270142
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0039",
    "Farbtonhilfsbezeichnung": "BH03D",
    "Farbtonklasse": "01",
    "Rcolor": "248",
    "Gcolor": "234",
    "Bcolor": "197",
    "Y": 82.8433074951172,
    "L": 92.9457931518555,
    "a": -0.58673882484436,
    "b": 19.0744590759277,
    "C": 19.0834808349609,
    "h": 91.7618942260742,
    "CMY_C": 0.02645498514175,
    "CMY_M": 0.08246368169785,
    "CMY_Y": 0.22887647151947,
    "CMYK_C": 0,
    "CMYK_M": 0.05753067135811,
    "CMYK_Y": 0.20792205631733,
    "CMYK_K": 0.02645498514175
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0040",
    "Farbtonhilfsbezeichnung": "BH04D",
    "Farbtonklasse": "03",
    "Rcolor": "236",
    "Gcolor": "182",
    "Bcolor": "99",
    "Y": 52.0228729248047,
    "L": 77.2945175170898,
    "a": 10.6825275421143,
    "b": 48.6733512878418,
    "C": 49.8318328857422,
    "h": 77.621337890625,
    "CMY_C": 0.07633101940155,
    "CMY_M": 0.28701502084732,
    "CMY_Y": 0.61329984664917,
    "CMYK_C": 0,
    "CMYK_M": 0.2280946969986,
    "CMYK_Y": 0.58134335279465,
    "CMYK_K": 0.07633101940155
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0041",
    "Farbtonhilfsbezeichnung": "BH05D",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "185",
    "Bcolor": "117",
    "Y": 49.9098129272461,
    "L": 76.0138702392578,
    "a": 1.26514101028442,
    "b": 37.254337310791,
    "C": 37.2758140563965,
    "h": 88.0550079345703,
    "CMY_C": 0.16697031259537,
    "CMY_M": 0.27576410770416,
    "CMY_Y": 0.54056525230408,
    "CMYK_C": 0,
    "CMYK_M": 0.13060013949871,
    "CMYK_Y": 0.44847732782364,
    "CMYK_K": 0.16697031259537
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0042",
    "Farbtonhilfsbezeichnung": "BH06D",
    "Farbtonklasse": "01",
    "Rcolor": "207",
    "Gcolor": "197",
    "Bcolor": "182",
    "Y": 56.6770324707031,
    "L": 79.9975967407227,
    "a": 1.17805778980255,
    "b": 8.04506587982178,
    "C": 8.13086128234863,
    "h": 81.6692581176758,
    "CMY_C": 0.18825954198837,
    "CMY_M": 0.22656589746475,
    "CMY_Y": 0.28602796792984,
    "CMYK_C": 0,
    "CMYK_M": 0.04719039797783,
    "CMYK_Y": 0.1204429641366,
    "CMYK_K": 0.18825954198837
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0043",
    "Farbtonhilfsbezeichnung": "BH07D",
    "Farbtonklasse": "03",
    "Rcolor": "106",
    "Gcolor": "100",
    "Bcolor": "98",
    "Y": 13.0800724029541,
    "L": 42.8836479187012,
    "a": 2.18051218986511,
    "b": 1.73209667205811,
    "C": 2.78474283218384,
    "h": 38.4619827270508,
    "CMY_C": 0.5834025144577,
    "CMY_M": 0.60759443044662,
    "CMY_Y": 0.61695432662964,
    "CMYK_C": 0,
    "CMYK_M": 0.05807023867965,
    "CMYK_Y": 0.0805377215147,
    "CMYK_K": 0.5834025144577
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0044",
    "Farbtonhilfsbezeichnung": "BH08D",
    "Farbtonklasse": "01",
    "Rcolor": "231",
    "Gcolor": "227",
    "Bcolor": "220",
    "Y": 77.0232467651367,
    "L": 90.3323135375977,
    "a": 0.70192486047745,
    "b": 3.0250198841095,
    "C": 3.10538959503174,
    "h": 76.9362869262695,
    "CMY_C": 0.09298694133759,
    "CMY_M": 0.11058837175369,
    "CMY_Y": 0.13773149251938,
    "CMYK_C": 0,
    "CMYK_M": 0.01940592750907,
    "CMYK_Y": 0.04933176189661,
    "CMYK_K": 0.09298694133759
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0045",
    "Farbtonhilfsbezeichnung": "BH09D",
    "Farbtonklasse": "01",
    "Rcolor": "225",
    "Gcolor": "207",
    "Bcolor": "190",
    "Y": 64.5516128540039,
    "L": 84.2521514892578,
    "a": 3.89087963104248,
    "b": 9.88183784484863,
    "C": 10.6202478408813,
    "h": 68.508430480957,
    "CMY_C": 0.11625272035599,
    "CMY_M": 0.18717002868652,
    "CMY_Y": 0.25358700752258,
    "CMYK_C": 0,
    "CMYK_M": 0.08024614304304,
    "CMYK_Y": 0.15539994835854,
    "CMYK_K": 0.11625272035599
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0046",
    "Farbtonhilfsbezeichnung": "BH10D",
    "Farbtonklasse": "03",
    "Rcolor": "229",
    "Gcolor": "145",
    "Bcolor": "108",
    "Y": 38.1817970275879,
    "L": 68.1543884277344,
    "a": 28.3047428131104,
    "b": 32.3793258666992,
    "C": 43.0067329406738,
    "h": 48.8413124084473,
    "CMY_C": 0.10019624233246,
    "CMY_M": 0.42989921569824,
    "CMY_Y": 0.57589668035507,
    "CMYK_C": 0,
    "CMYK_M": 0.36641654372215,
    "CMYK_Y": 0.52867132425308,
    "CMYK_K": 0.10019624233246
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0047",
    "Farbtonhilfsbezeichnung": "BH11D",
    "Farbtonklasse": "04",
    "Rcolor": "203",
    "Gcolor": "105",
    "Bcolor": "90",
    "Y": 23.5375690460205,
    "L": 55.6217918395996,
    "a": 37.7503318786621,
    "b": 25.9271354675293,
    "C": 45.796329498291,
    "h": 34.4814910888672,
    "CMY_C": 0.20325714349747,
    "CMY_M": 0.58852922916412,
    "CMY_Y": 0.64879995584488,
    "CMYK_C": 0,
    "CMYK_M": 0.48355889320374,
    "CMYK_Y": 0.5592052936554,
    "CMYK_K": 0.20325714349747
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0048",
    "Farbtonhilfsbezeichnung": "BH12D",
    "Farbtonklasse": "04",
    "Rcolor": "177",
    "Gcolor": "89",
    "Bcolor": "76",
    "Y": 17.0803947448731,
    "L": 48.3611755371094,
    "a": 34.9048271179199,
    "b": 23.4207420349121,
    "C": 42.0342483520508,
    "h": 33.8611602783203,
    "CMY_C": 0.30464214086533,
    "CMY_M": 0.65041351318359,
    "CMY_Y": 0.70016264915466,
    "CMYK_C": 0,
    "CMYK_M": 0.49725672602654,
    "CMYK_Y": 0.56880140304565,
    "CMYK_K": 0.30464214086533
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0049",
    "Farbtonhilfsbezeichnung": "BH01E",
    "Farbtonklasse": "03",
    "Rcolor": "126",
    "Gcolor": "170",
    "Bcolor": "138",
    "Y": 35.1053581237793,
    "L": 65.8306121826172,
    "a": -21.4148044586182,
    "b": 10.9946985244751,
    "C": 24.0723342895508,
    "h": 152.823318481445,
    "CMY_C": 0.50774693489075,
    "CMY_M": 0.33218079805374,
    "CMY_Y": 0.45712321996689,
    "CMYK_C": 0.2628947198391,
    "CMYK_M": 0,
    "CMYK_Y": 0.18709018826485,
    "CMYK_K": 0.33218079805374
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0050",
    "Farbtonhilfsbezeichnung": "BH02E",
    "Farbtonklasse": "01",
    "Rcolor": "199",
    "Gcolor": "208",
    "Bcolor": "199",
    "Y": 61.3991851806641,
    "L": 82.5928726196289,
    "a": -4.39356756210327,
    "b": 2.34004044532776,
    "C": 4.9778733253479,
    "h": 151.9599609375,
    "CMY_C": 0.22053456306458,
    "CMY_M": 0.1840358376503,
    "CMY_Y": 0.21773546934128,
    "CMYK_C": 0.04473079368472,
    "CMYK_M": 0,
    "CMYK_Y": 0.04130038246512,
    "CMYK_K": 0.1840358376503
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0051",
    "Farbtonhilfsbezeichnung": "BH03E",
    "Farbtonklasse": "02",
    "Rcolor": "176",
    "Gcolor": "181",
    "Bcolor": "167",
    "Y": 44.9350852966309,
    "L": 72.8491287231445,
    "a": -3.57100248336792,
    "b": 5.64671039581299,
    "C": 6.68112230300903,
    "h": 122.309425354004,
    "CMY_C": 0.3079075217247,
    "CMY_M": 0.29202735424042,
    "CMY_Y": 0.3448503613472,
    "CMYK_C": 0.02243048138916,
    "CMYK_M": 0,
    "CMYK_Y": 0.0746116489172,
    "CMYK_K": 0.29202735424042
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0052",
    "Farbtonhilfsbezeichnung": "BH04E",
    "Farbtonklasse": "02",
    "Rcolor": "156",
    "Gcolor": "172",
    "Bcolor": "167",
    "Y": 39.4043617248535,
    "L": 69.0431671142578,
    "a": -6.17449808120728,
    "b": -0.0536839440465,
    "C": 6.17473125457764,
    "h": 180.498153686523,
    "CMY_C": 0.38715296983719,
    "CMY_M": 0.32535833120346,
    "CMY_Y": 0.34480851888657,
    "CMYK_C": 0.09159623831511,
    "CMYK_M": 0,
    "CMYK_Y": 0.02883039787412,
    "CMYK_K": 0.32535833120346
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0053",
    "Farbtonhilfsbezeichnung": "BH05E",
    "Farbtonklasse": "04",
    "Rcolor": "58",
    "Gcolor": "76",
    "Bcolor": "91",
    "Y": 6.78154516220093,
    "L": 31.3043308258057,
    "a": -2.63386487960815,
    "b": -11.5723876953125,
    "C": 11.868335723877,
    "h": 257.177947998047,
    "CMY_C": 0.77307897806168,
    "CMY_M": 0.70294106006622,
    "CMY_Y": 0.64393126964569,
    "CMYK_C": 0.36270442605019,
    "CMYK_M": 0.16572584211826,
    "CMYK_Y": 0,
    "CMYK_K": 0.64393126964569
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0054",
    "Farbtonhilfsbezeichnung": "BH06E",
    "Farbtonklasse": "02",
    "Rcolor": "127",
    "Gcolor": "153",
    "Bcolor": "167",
    "Y": 30.0370426177979,
    "L": 61.6861724853516,
    "a": -5.57182359695435,
    "b": -11.1831884384155,
    "C": 12.4943552017212,
    "h": 243.516036987305,
    "CMY_C": 0.50283551216125,
    "CMY_M": 0.400410592556,
    "CMY_Y": 0.34454953670502,
    "CMYK_C": 0.24149189889431,
    "CMYK_M": 0.08522544056177,
    "CMYK_Y": 0,
    "CMYK_K": 0.34454953670502
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0055",
    "Farbtonhilfsbezeichnung": "BH07E",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "202",
    "Bcolor": "228",
    "Y": 55.5850524902344,
    "L": 79.3770751953125,
    "a": -7.00915145874023,
    "b": -17.8729419708252,
    "C": 19.1981830596924,
    "h": 248.586608886719,
    "CMY_C": 0.36398124694824,
    "CMY_M": 0.20734399557114,
    "CMY_Y": 0.10699051618576,
    "CMYK_C": 0.28778052330017,
    "CMYK_M": 0.11237671971321,
    "CMYK_Y": 0,
    "CMYK_K": 0.10699051618576
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0056",
    "Farbtonhilfsbezeichnung": "BH08E",
    "Farbtonklasse": "01",
    "Rcolor": "209",
    "Gcolor": "221",
    "Bcolor": "226",
    "Y": 70.9943237304688,
    "L": 87.4822463989258,
    "a": -2.84423065185547,
    "b": -4.6321005821228,
    "C": 5.43562364578247,
    "h": 238.448989868164,
    "CMY_C": 0.17999887466431,
    "CMY_M": 0.13172918558121,
    "CMY_Y": 0.11320757865906,
    "CMYK_C": 0.0753178447485,
    "CMYK_M": 0.02088606730103,
    "CMYK_Y": 0,
    "CMYK_K": 0.11320757865906
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0058",
    "Farbtonhilfsbezeichnung": "BH10E",
    "Farbtonklasse": "03",
    "Rcolor": "248",
    "Gcolor": "212",
    "Bcolor": "131",
    "Y": 68.8991622924805,
    "L": 86.4540863037109,
    "a": 2.56811618804932,
    "b": 43.9223327636719,
    "C": 43.9973487854004,
    "h": 86.6537551879883,
    "CMY_C": 0.0275074839592,
    "CMY_M": 0.1669357419014,
    "CMY_Y": 0.48526495695114,
    "CMYK_C": 0,
    "CMYK_M": 0.14337205886841,
    "CMYK_Y": 0.4707053899765,
    "CMYK_K": 0.0275074839592
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0059",
    "Farbtonhilfsbezeichnung": "BH11E",
    "Farbtonklasse": "02",
    "Rcolor": "247",
    "Gcolor": "235",
    "Bcolor": "182",
    "Y": 82.4070663452148,
    "L": 92.7542266845703,
    "a": -3.26740670204163,
    "b": 26.4055328369141,
    "C": 26.6069183349609,
    "h": 97.0538940429688,
    "CMY_C": 0.03007262945175,
    "CMY_M": 0.07989984750748,
    "CMY_Y": 0.28660821914673,
    "CMYK_C": 0,
    "CMYK_M": 0.05137211084366,
    "CMYK_Y": 0.26448947191238,
    "CMYK_K": 0.03007262945175
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0060",
    "Farbtonhilfsbezeichnung": "BH12E",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "231",
    "Bcolor": "226",
    "Y": 80.4180068969727,
    "L": 91.8720932006836,
    "a": 0.53254997730255,
    "b": 2.23347234725952,
    "C": 2.29608535766602,
    "h": 76.5887908935547,
    "CMY_C": 0.07970207929611,
    "CMY_M": 0.09279882907867,
    "CMY_Y": 0.11492568254471,
    "CMYK_C": 0,
    "CMYK_M": 0.01423098891973,
    "CMYK_Y": 0.0382741317153,
    "CMYK_K": 0.07970207929611
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0061",
    "Farbtonhilfsbezeichnung": "BH01F",
    "Farbtonklasse": "03",
    "Rcolor": "92",
    "Gcolor": "119",
    "Bcolor": "139",
    "Y": 17.2599487304688,
    "L": 48.5859146118164,
    "a": -3.96659278869629,
    "b": -14.9464263916016,
    "C": 15.463812828064,
    "h": 255.13703918457,
    "CMY_C": 0.6378088593483,
    "CMY_M": 0.53495109081268,
    "CMY_Y": 0.45395112037659,
    "CMYK_C": 0.33670565485954,
    "CMYK_M": 0.14833831787109,
    "CMYK_Y": 0,
    "CMYK_K": 0.45395112037659
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0062",
    "Farbtonhilfsbezeichnung": "BH02F",
    "Farbtonklasse": "03",
    "Rcolor": "100",
    "Gcolor": "105",
    "Bcolor": "111",
    "Y": 14.0071716308594,
    "L": 44.2432136535645,
    "a": -0.3573149740696,
    "b": -4.56997489929199,
    "C": 4.58392238616943,
    "h": 265.529296875,
    "CMY_C": 0.60702723264694,
    "CMY_M": 0.58763206005096,
    "CMY_Y": 0.56392598152161,
    "CMYK_C": 0.09883929789066,
    "CMYK_M": 0.05436250939965,
    "CMYK_Y": 0,
    "CMYK_K": 0.56392598152161
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0063",
    "Farbtonhilfsbezeichnung": "BH03F",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "221",
    "Bcolor": "221",
    "Y": 73.5454711914063,
    "L": 88.7072219848633,
    "a": 3.65859031677246,
    "b": 0.02917104773223,
    "C": 3.65870666503906,
    "h": 0.45682689547539,
    "CMY_C": 0.09808254241943,
    "CMY_M": 0.13488805294037,
    "CMY_Y": 0.13309186697006,
    "CMYK_C": 0,
    "CMYK_M": 0.04080807045102,
    "CMYK_Y": 0.03881654888391,
    "CMYK_K": 0.09808254241943
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0064",
    "Farbtonhilfsbezeichnung": "BH04F",
    "Farbtonklasse": "02",
    "Rcolor": "180",
    "Gcolor": "158",
    "Bcolor": "127",
    "Y": 35.6709213256836,
    "L": 66.2677154541016,
    "a": 3.71299719810486,
    "b": 18.6600227355957,
    "C": 19.0258445739746,
    "h": 78.7461929321289,
    "CMY_C": 0.29341268539429,
    "CMY_M": 0.38078504800797,
    "CMY_Y": 0.5025829076767,
    "CMYK_C": 0,
    "CMYK_M": 0.12365402281284,
    "CMYK_Y": 0.29602885246277,
    "CMYK_K": 0.29341268539429
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0065",
    "Farbtonhilfsbezeichnung": "BH05F",
    "Farbtonklasse": "01",
    "Rcolor": "240",
    "Gcolor": "221",
    "Bcolor": "194",
    "Y": 74.3454208374023,
    "L": 89.0854873657227,
    "a": 2.4391462802887,
    "b": 15.1062326431274,
    "C": 15.3018856048584,
    "h": 80.8278274536133,
    "CMY_C": 0.05845028162003,
    "CMY_M": 0.13175964355469,
    "CMY_Y": 0.24037283658981,
    "CMYK_C": 0,
    "CMYK_M": 0.07786031812429,
    "CMYK_Y": 0.19321608543396,
    "CMYK_K": 0.05845028162003
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0066",
    "Farbtonhilfsbezeichnung": "BH06F",
    "Farbtonklasse": "03",
    "Rcolor": "141",
    "Gcolor": "82",
    "Bcolor": "70",
    "Y": 12.1,
    "L": 41.3135223388672,
    "a": 23.6940174102783,
    "b": 17.2668685913086,
    "C": 29.3181037902832,
    "h": 36.082462310791,
    "CMY_C": 0.44731628894806,
    "CMY_M": 0.68019306659698,
    "CMY_Y": 0.72678959369659,
    "CMYK_C": 0,
    "CMYK_M": 0.42135632038116,
    "CMYK_Y": 0.50566589832306,
    "CMYK_K": 0.44731628894806
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0067",
    "Farbtonhilfsbezeichnung": "BH07F",
    "Farbtonklasse": "04",
    "Rcolor": "211",
    "Gcolor": "89",
    "Bcolor": "64",
    "Y": 21.3481121063232,
    "L": 53.3283920288086,
    "a": 46.7562866210938,
    "b": 37.7291450500488,
    "C": 60.0802688598633,
    "h": 38.9011726379395,
    "CMY_C": 0.17351073026657,
    "CMY_M": 0.65050703287125,
    "CMY_Y": 0.74846142530441,
    "CMYK_C": 0,
    "CMYK_M": 0.57713550329208,
    "CMYK_Y": 0.69565415382385,
    "CMYK_K": 0.17351073026657
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0068",
    "Farbtonhilfsbezeichnung": "BH08F",
    "Farbtonklasse": "01",
    "Rcolor": "235",
    "Gcolor": "220",
    "Bcolor": "204",
    "Y": 73.1153335571289,
    "L": 88.5026931762695,
    "a": 3.03246545791626,
    "b": 8.86733055114746,
    "C": 9.37152099609375,
    "h": 71.120246887207,
    "CMY_C": 0.07785069942474,
    "CMY_M": 0.1380689740181,
    "CMY_Y": 0.20048344135284,
    "CMYK_C": 0,
    "CMYK_M": 0.0653020888567,
    "CMYK_Y": 0.13298577070236,
    "CMYK_K": 0.07785069942474
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0069",
    "Farbtonhilfsbezeichnung": "BH09F",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "230",
    "Bcolor": "216",
    "Y": 79.6835556030273,
    "L": 91.5426864624023,
    "a": 0.28211548924446,
    "b": 6.85617733001709,
    "C": 6.86197900772095,
    "h": 87.6437454223633,
    "CMY_C": 0.07050049304962,
    "CMY_M": 0.0971485376358,
    "CMY_Y": 0.1528879404068,
    "CMYK_C": 0,
    "CMYK_M": 0.02866923995316,
    "CMYK_Y": 0.08863635361195,
    "CMYK_K": 0.07050049304962
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0070",
    "Farbtonhilfsbezeichnung": "BH10F",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "204",
    "Bcolor": "195",
    "Y": 60.2078742980957,
    "L": 81.9510498046875,
    "a": -0.55917662382126,
    "b": 3.65956473350525,
    "C": 3.70203900337219,
    "h": 98.6875228881836,
    "CMY_C": 0.19322979450226,
    "CMY_M": 0.20013630390167,
    "CMY_Y": 0.23369210958481,
    "CMYK_C": 0,
    "CMYK_M": 0.00856069009751,
    "CMYK_Y": 0.05015345662832,
    "CMYK_K": 0.19322979450226
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0071",
    "Farbtonhilfsbezeichnung": "BH11F",
    "Farbtonklasse": "01",
    "Rcolor": "177",
    "Gcolor": "177",
    "Bcolor": "176",
    "Y": 44.0586776733398,
    "L": 72.2677001953125,
    "a": -0.02019453421235,
    "b": -0.20374763011932,
    "C": 0.20474597811699,
    "h": 264.339599609375,
    "CMY_C": 0.30597704648972,
    "CMY_M": 0.30458766222,
    "CMY_Y": 0.30912089347839,
    "CMYK_C": 0.00199792860076,
    "CMYK_M": 0,
    "CMYK_Y": 0.00651876721531,
    "CMYK_K": 0.30458766222
  },
  {
    "Farbtonkarten_Bezeichnung": "Sikkens Bauhaus",
    "Farbton_ID": "SIB0072",
    "Farbtonhilfsbezeichnung": "BH12F",
    "Farbtonklasse": "02",
    "Rcolor": "112",
    "Gcolor": "109",
    "Bcolor": "105",
    "Y": 15.3459224700928,
    "L": 46.1043891906738,
    "a": 0.65539646148682,
    "b": 2.11081051826477,
    "C": 2.21021842956543,
    "h": 72.7506790161133,
    "CMY_C": 0.56116938591003,
    "CMY_M": 0.57338947057724,
    "CMY_Y": 0.58884525299072,
    "CMYK_C": 0,
    "CMYK_M": 0.0278469286859,
    "CMYK_Y": 0.06306730955839,
    "CMYK_K": 0.56116938591003
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31800M",
    "Farbtonhilfsbezeichnung": "31800M",
    "Farbtonklasse": "03",
    "Y": 78,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31801M",
    "Farbtonhilfsbezeichnung": "31801M",
    "Farbtonklasse": "01",
    "Y": 83,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31802M",
    "Farbtonhilfsbezeichnung": "31802M",
    "Farbtonklasse": "02",
    "Y": 64,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31803M",
    "Farbtonhilfsbezeichnung": "31803M",
    "Farbtonklasse": "03",
    "Y": 78,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31804M",
    "Farbtonhilfsbezeichnung": "31804M",
    "Farbtonklasse": "02",
    "Y": 81,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31805M",
    "Farbtonhilfsbezeichnung": "31805M",
    "Farbtonklasse": "01",
    "Y": 73,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31806M",
    "Farbtonhilfsbezeichnung": "31806M",
    "Farbtonklasse": "01",
    "Y": 82,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31807M",
    "Farbtonhilfsbezeichnung": "31807M",
    "Farbtonklasse": "03",
    "Y": 73,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31808M",
    "Farbtonhilfsbezeichnung": "31808M",
    "Farbtonklasse": "01",
    "Y": 86,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "31809M",
    "Farbtonhilfsbezeichnung": "31809M",
    "Farbtonklasse": "03",
    "Y": 56,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32800M",
    "Farbtonhilfsbezeichnung": "32800M",
    "Farbtonklasse": "03",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32801M",
    "Farbtonhilfsbezeichnung": "32801M",
    "Farbtonklasse": "02",
    "Y": 67,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32802M",
    "Farbtonhilfsbezeichnung": "32802M",
    "Farbtonklasse": "01",
    "Y": 78,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32803M",
    "Farbtonhilfsbezeichnung": "32803M",
    "Farbtonklasse": "02",
    "Y": 73,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32804M",
    "Farbtonhilfsbezeichnung": "32804M",
    "Farbtonklasse": "01",
    "Y": 84,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32805M",
    "Farbtonhilfsbezeichnung": "32805M",
    "Farbtonklasse": "01",
    "Y": 62,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32806M",
    "Farbtonhilfsbezeichnung": "32806M",
    "Farbtonklasse": "03",
    "Y": 57,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32807M",
    "Farbtonhilfsbezeichnung": "32807M",
    "Farbtonklasse": "01",
    "Y": 57,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32808M",
    "Farbtonhilfsbezeichnung": "32808M",
    "Farbtonklasse": "01",
    "Y": 79,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "32809M",
    "Farbtonhilfsbezeichnung": "32809M",
    "Farbtonklasse": "03",
    "Y": 52,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33800M",
    "Farbtonhilfsbezeichnung": "33800M",
    "Farbtonklasse": "03",
    "Y": 29,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33801M",
    "Farbtonhilfsbezeichnung": "33801M",
    "Farbtonklasse": "03",
    "Y": 68,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33802M",
    "Farbtonhilfsbezeichnung": "33802M",
    "Farbtonklasse": "01",
    "Y": 82,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33803M",
    "Farbtonhilfsbezeichnung": "33803M",
    "Farbtonklasse": "03",
    "Y": 46,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33804M",
    "Farbtonhilfsbezeichnung": "33804M",
    "Farbtonklasse": "01",
    "Y": 81,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33805M",
    "Farbtonhilfsbezeichnung": "33805M",
    "Farbtonklasse": "03",
    "Y": 52,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33806M",
    "Farbtonhilfsbezeichnung": "33806M",
    "Farbtonklasse": "02",
    "Y": 68,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33807M",
    "Farbtonhilfsbezeichnung": "33807M",
    "Farbtonklasse": "03",
    "Y": 48,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33808M",
    "Farbtonhilfsbezeichnung": "33808M",
    "Farbtonklasse": "02",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "33809M",
    "Farbtonhilfsbezeichnung": "33809M",
    "Farbtonklasse": "03",
    "Y": 40,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34800M",
    "Farbtonhilfsbezeichnung": "34800M",
    "Farbtonklasse": "03",
    "Y": 39,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34801M",
    "Farbtonhilfsbezeichnung": "34801M",
    "Farbtonklasse": "01",
    "Y": 81,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34802M",
    "Farbtonhilfsbezeichnung": "34802M",
    "Farbtonklasse": "03",
    "Y": 56,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34803M",
    "Farbtonhilfsbezeichnung": "34803M",
    "Farbtonklasse": "01",
    "Y": 79,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34804M",
    "Farbtonhilfsbezeichnung": "34804M",
    "Farbtonklasse": "03",
    "Y": 44,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34805M",
    "Farbtonhilfsbezeichnung": "34805M",
    "Farbtonklasse": "01",
    "Y": 74,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34806M",
    "Farbtonhilfsbezeichnung": "34806M",
    "Farbtonklasse": "03",
    "Y": 58,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34807M",
    "Farbtonhilfsbezeichnung": "34807M",
    "Farbtonklasse": "02",
    "Y": 67,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34808M",
    "Farbtonhilfsbezeichnung": "34808M",
    "Farbtonklasse": "02",
    "Y": 61,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "34809M",
    "Farbtonhilfsbezeichnung": "34809M",
    "Farbtonklasse": "03",
    "Y": 43,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35800M",
    "Farbtonhilfsbezeichnung": "35800M",
    "Farbtonklasse": "03",
    "Y": 16,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35801M",
    "Farbtonhilfsbezeichnung": "35801M",
    "Farbtonklasse": "03",
    "Y": 53,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35802M",
    "Farbtonhilfsbezeichnung": "35802M",
    "Farbtonklasse": "01",
    "Y": 77,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35803M",
    "Farbtonhilfsbezeichnung": "35803M",
    "Farbtonklasse": "02",
    "Y": 57,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35804M",
    "Farbtonhilfsbezeichnung": "35804M",
    "Farbtonklasse": "03",
    "Y": 63,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35805M",
    "Farbtonhilfsbezeichnung": "35805M",
    "Farbtonklasse": "01",
    "Y": 75,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35806M",
    "Farbtonhilfsbezeichnung": "35806M",
    "Farbtonklasse": "03",
    "Y": 52,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35807M",
    "Farbtonhilfsbezeichnung": "35807M",
    "Farbtonklasse": "02",
    "Y": 80,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35808M",
    "Farbtonhilfsbezeichnung": "35808M",
    "Farbtonklasse": "03",
    "Y": 53,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "35809M",
    "Farbtonhilfsbezeichnung": "35809M",
    "Farbtonklasse": "02",
    "Y": 66,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36800M",
    "Farbtonhilfsbezeichnung": "36800M",
    "Farbtonklasse": "03",
    "Y": 65,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36801M",
    "Farbtonhilfsbezeichnung": "36801M",
    "Farbtonklasse": "02",
    "Y": 77,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36802M",
    "Farbtonhilfsbezeichnung": "36802M",
    "Farbtonklasse": "01",
    "Y": 59,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36803M",
    "Farbtonhilfsbezeichnung": "36803M",
    "Farbtonklasse": "01",
    "Y": 86,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36804M",
    "Farbtonhilfsbezeichnung": "36804M",
    "Farbtonklasse": "03",
    "Y": 59,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36805M",
    "Farbtonhilfsbezeichnung": "36805M",
    "Farbtonklasse": "01",
    "Y": 80,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36806M",
    "Farbtonhilfsbezeichnung": "36806M",
    "Farbtonklasse": "03",
    "Y": 72,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36807M",
    "Farbtonhilfsbezeichnung": "36807M",
    "Farbtonklasse": "02",
    "Y": 82,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36808M",
    "Farbtonhilfsbezeichnung": "36808M",
    "Farbtonklasse": "01",
    "Y": 75,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "36809M",
    "Farbtonhilfsbezeichnung": "36809M",
    "Farbtonklasse": "02",
    "Y": 86,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37800M",
    "Farbtonhilfsbezeichnung": "37800M",
    "Farbtonklasse": "01",
    "Y": 89,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37801M",
    "Farbtonhilfsbezeichnung": "37801M",
    "Farbtonklasse": "01",
    "Y": 51,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37802M",
    "Farbtonhilfsbezeichnung": "37802M",
    "Farbtonklasse": "03",
    "Y": 25,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37803M",
    "Farbtonhilfsbezeichnung": "37803M",
    "Farbtonklasse": "03",
    "Y": 19,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37804M",
    "Farbtonhilfsbezeichnung": "37804M",
    "Farbtonklasse": "03",
    "Y": 45,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37805M",
    "Farbtonhilfsbezeichnung": "37805M",
    "Farbtonklasse": "03",
    "Y": 45,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37807M",
    "Farbtonhilfsbezeichnung": "37807M",
    "Farbtonklasse": "01",
    "Y": 65,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "StoColor Metallic",
    "Farbton_ID": "37808M",
    "Farbtonhilfsbezeichnung": "37808M",
    "Farbtonklasse": "01",
    "Y": 30,
    "L": 0,
    "a": 0,
    "b": 0,
    "C": 0,
    "h": 0,
    "CMY_C": 0,
    "CMY_M": 0,
    "CMY_Y": 0,
    "CMYK_C": 0,
    "CMYK_M": 0,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00001",
    "Farbtonhilfsbezeichnung": "10DC110",
    "Farbtonklasse": "03",
    "Rcolor": "160",
    "Gcolor": "96",
    "Bcolor": "67",
    "Y": 17,
    "L": 47.4065742492676,
    "a": 23.055570602417,
    "b": 27.5106830596924,
    "C": 35.8942489624023,
    "h": 50.0350112915039,
    "CMY_C": 0.37207937240601,
    "CMY_M": 0.62178385257721,
    "CMY_Y": 0.73918998241425,
    "CMYK_C": 0,
    "CMYK_M": 0.3976688683033,
    "CMYK_Y": 0.5846449136734,
    "CMYK_K": 0.37207937240601
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00002",
    "Farbtonhilfsbezeichnung": "10DC120",
    "Farbtonklasse": "03",
    "Rcolor": "212",
    "Gcolor": "157",
    "Bcolor": "72",
    "Y": 38,
    "L": 68.4753646850586,
    "a": 12.3445625305176,
    "b": 50.6633033752441,
    "C": 52.1455497741699,
    "h": 76.3062133789063,
    "CMY_C": 0.16747492551804,
    "CMY_M": 0.38435411453247,
    "CMY_Y": 0.71668350696564,
    "CMYK_C": 0,
    "CMYK_M": 0.26050770282745,
    "CMYK_Y": 0.65969014167786,
    "CMYK_K": 0.16747492551804
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00004",
    "Farbtonhilfsbezeichnung": "10DC140",
    "Farbtonklasse": "02",
    "Rcolor": "209",
    "Gcolor": "170",
    "Bcolor": "110",
    "Y": 43,
    "L": 71.6983337402344,
    "a": 7.09397220611572,
    "b": 35.3641548156738,
    "C": 36.0686569213867,
    "h": 78.6571350097656,
    "CMY_C": 0.18153136968613,
    "CMY_M": 0.3351948261261,
    "CMY_Y": 0.56806534528732,
    "CMYK_C": 0,
    "CMYK_M": 0.18774507939816,
    "CMYK_Y": 0.47226485610008,
    "CMYK_K": 0.18153136968613
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00005",
    "Farbtonhilfsbezeichnung": "10DC150",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "208",
    "Bcolor": "82",
    "Y": 65,
    "L": 84.6456756591797,
    "a": -0.15620654821396,
    "b": 64.4842071533203,
    "C": 64.4843978881836,
    "h": 90.1387939453125,
    "CMY_C": 0.03886044025421,
    "CMY_M": 0.18300032615662,
    "CMY_Y": 0.6772124171257,
    "CMYK_C": 0,
    "CMYK_M": 0.149967700243,
    "CMYK_Y": 0.66416156291962,
    "CMYK_K": 0.03886044025421
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00006",
    "Farbtonhilfsbezeichnung": "10DC160",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "197",
    "Y": 86,
    "L": 94.3023681640625,
    "a": -4.04313325881958,
    "b": 20.7996921539307,
    "C": 21.1890087127686,
    "h": 101.000221252441,
    "CMY_C": 0.03226548433304,
    "CMY_M": 0.05948704481125,
    "CMY_Y": 0.22780084609985,
    "CMYK_C": 0,
    "CMYK_M": 0.02812916226685,
    "CMYK_Y": 0.20205475389957,
    "CMYK_K": 0.03226548433304
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00007",
    "Farbtonhilfsbezeichnung": "10DC170",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "240",
    "Bcolor": "221",
    "Y": 88,
    "L": 94.8052825927734,
    "a": -0.21014483273029,
    "b": 9.18598747253418,
    "C": 9.18839073181152,
    "h": 91.3105087280273,
    "CMY_C": 0.03035634756088,
    "CMY_M": 0.06005162000656,
    "CMY_Y": 0.13449841737747,
    "CMYK_C": 0,
    "CMYK_M": 0.03062493354082,
    "CMYK_Y": 0.10740241408348,
    "CMYK_K": 0.03035634756088
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00008",
    "Farbtonhilfsbezeichnung": "10DC310",
    "Farbtonklasse": "04",
    "Rcolor": "134",
    "Gcolor": "66",
    "Bcolor": "68",
    "Y": 9,
    "L": 36.6679306030273,
    "a": 29.5500297546387,
    "b": 11.8569717407227,
    "C": 31.8401012420654,
    "h": 21.8631610870361,
    "CMY_C": 0.47457361221313,
    "CMY_M": 0.74186646938324,
    "CMY_Y": 0.73332458734512,
    "CMYK_C": 0,
    "CMYK_M": 0.50871610641479,
    "CMYK_Y": 0.49245902895927,
    "CMYK_K": 0.47457361221313
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00009",
    "Farbtonhilfsbezeichnung": "10DC320",
    "Farbtonklasse": "04",
    "Rcolor": "156",
    "Gcolor": "62",
    "Bcolor": "78",
    "Y": 11,
    "L": 39.7021141052246,
    "a": 40.6127967834473,
    "b": 10.1099653244019,
    "C": 41.8522479854332,
    "h": 13.9788234170729,
    "CMY_C": 0.71372544765472,
    "CMY_M": 0.41176468133926,
    "CMY_Y": 0.76862746477127,
    "CMYK_C": 0.51333326101303,
    "CMYK_M": 0,
    "CMYK_Y": 0.6066666841507,
    "CMYK_K": 0.41176468
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00010",
    "Farbtonhilfsbezeichnung": "10DC330",
    "Farbtonklasse": "03",
    "Rcolor": "158",
    "Gcolor": "76",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.4071655273438,
    "a": 33.0926170349121,
    "b": 25.0816593170166,
    "C": 41.5236190175452,
    "h": 37.1593294331521,
    "CMY_C": 0.79215687513351,
    "CMY_M": 0.39999997615814,
    "CMY_Y": 0.70980393886566,
    "CMYK_C": 0.65359479188919,
    "CMYK_M": 0,
    "CMYK_Y": 0.51633989810944,
    "CMYK_K": 0.39999998
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00011",
    "Farbtonhilfsbezeichnung": "10DC340",
    "Farbtonklasse": "03",
    "Rcolor": "195",
    "Gcolor": "67",
    "Bcolor": "60",
    "Y": 15,
    "L": 46.9696273803711,
    "a": 50.6783332824707,
    "b": 32.1459732055664,
    "C": 60.0138053894043,
    "h": 32.387523651123,
    "CMY_C": 0.23535108566284,
    "CMY_M": 0.73529887199402,
    "CMY_Y": 0.76583611965179,
    "CMYK_C": 0,
    "CMYK_M": 0.65382659435272,
    "CMYK_Y": 0.69376289844513,
    "CMYK_K": 0.23535108566284
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00012",
    "Farbtonhilfsbezeichnung": "10DC510",
    "Farbtonklasse": "03",
    "Rcolor": "72",
    "Gcolor": "83",
    "Bcolor": "106",
    "Y": 8,
    "L": 35.0956764221191,
    "a": 2.26750755310059,
    "b": -15.2799739837647,
    "C": 15.4473038245479,
    "h": 278.440939739167,
    "CMY_C": 0.58823525905609,
    "CMY_M": 0.74117648601532,
    "CMY_Y": 0.68627452850342,
    "CMYK_C": 0,
    "CMYK_M": 0.37142866849899,
    "CMYK_Y": 0.23809534311295,
    "CMYK_K": 0.58823526
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00013",
    "Farbtonhilfsbezeichnung": "10DC520",
    "Farbtonklasse": "03",
    "Rcolor": "45",
    "Gcolor": "109",
    "Bcolor": "133",
    "Y": 13,
    "L": 43.068058013916,
    "a": -12.4310255050659,
    "b": -19.7847881317139,
    "C": 23.3659629821777,
    "h": 237.858352661133,
    "CMY_C": 0.82511520385742,
    "CMY_M": 0.5720482468605,
    "CMY_Y": 0.4788419008255,
    "CMYK_C": 0.6644304394722,
    "CMYK_M": 0.17884466052055,
    "CMYK_Y": 0,
    "CMYK_K": 0.4788419008255
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00014",
    "Farbtonhilfsbezeichnung": "10DC530",
    "Farbtonklasse": "03",
    "Rcolor": "71",
    "Gcolor": "108",
    "Bcolor": "148",
    "Y": 14,
    "L": 44.4839706420898,
    "a": -0.92875516414642,
    "b": -26.8170108795166,
    "C": 26.8330898284912,
    "h": 268.016448974609,
    "CMY_C": 0.72312748432159,
    "CMY_M": 0.57692694664001,
    "CMY_Y": 0.41799908876419,
    "CMYK_C": 0.52427476644516,
    "CMYK_M": 0.27307149767876,
    "CMYK_Y": 0,
    "CMYK_K": 0.41799908876419
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00015",
    "Farbtonhilfsbezeichnung": "10DC540",
    "Farbtonklasse": "02",
    "Rcolor": "157",
    "Gcolor": "158",
    "Bcolor": "181",
    "Y": 36,
    "L": 65.749153137207,
    "a": 4.6057276725769,
    "b": -12.6232481002808,
    "C": 13.4372291564941,
    "h": 290.045043945313,
    "CMY_C": 0.38374131917953,
    "CMY_M": 0.37998896837234,
    "CMY_Y": 0.29073637723923,
    "CMYK_C": 0.13112887740135,
    "CMYK_M": 0.12583838403225,
    "CMYK_Y": 0,
    "CMYK_K": 0.29073637723923
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00016",
    "Farbtonhilfsbezeichnung": "10DC550",
    "Farbtonklasse": "01",
    "Rcolor": "152",
    "Gcolor": "193",
    "Bcolor": "204",
    "Y": 50,
    "L": 75.4143905639648,
    "a": -10.5618667602539,
    "b": -10.966835975647,
    "C": 15.2257843017578,
    "h": 226.07763671875,
    "CMY_C": 0.40454828739166,
    "CMY_M": 0.24502319097519,
    "CMY_Y": 0.20037537813187,
    "CMYK_C": 0.2553359568119,
    "CMYK_M": 0.05583596602082,
    "CMYK_Y": 0,
    "CMYK_K": 0.20037537813187
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00017",
    "Farbtonhilfsbezeichnung": "10DC560",
    "Farbtonklasse": "01",
    "Rcolor": "218",
    "Gcolor": "213",
    "Bcolor": "215",
    "Y": 67,
    "L": 85.7032318115234,
    "a": 2.34586215019226,
    "b": -1.15842795372009,
    "C": 2.61629978245322,
    "h": 333.719030603764,
    "CMY_C": 0.10196077823639,
    "CMY_M": 0.1098039150238,
    "CMY_Y": 0.1098039150238,
    "CMYK_C": 0,
    "CMYK_M": 0.0087336236611,
    "CMYK_Y": 0.0087336236611,
    "CMYK_K": 0.10196078
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00019",
    "Farbtonhilfsbezeichnung": "10DC610",
    "Farbtonklasse": "03",
    "Rcolor": "32",
    "Gcolor": "125",
    "Bcolor": "129",
    "Y": 16,
    "L": 47.5335006713867,
    "a": -24.0858669281006,
    "b": -10.5281820297241,
    "C": 26.2863388061523,
    "h": 203.610641479492,
    "CMY_C": 0.87342441082001,
    "CMY_M": 0.51175427436829,
    "CMY_Y": 0.4952380657196,
    "CMYK_C": 0.74923706054688,
    "CMYK_M": 0.03272078931332,
    "CMYK_Y": 0,
    "CMYK_K": 0.4952380657196
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00020",
    "Farbtonhilfsbezeichnung": "10DC620",
    "Farbtonklasse": "03",
    "Rcolor": "128",
    "Gcolor": "121",
    "Bcolor": "71",
    "Y": 19,
    "L": 50.3898277282715,
    "a": -4.51317262649536,
    "b": 27.7849521636963,
    "C": 28.1491088867188,
    "h": 99.2261047363281,
    "CMY_C": 0.49635297060013,
    "CMY_M": 0.52562201023102,
    "CMY_Y": 0.72042566537857,
    "CMYK_C": 0,
    "CMYK_M": 0.05811418965459,
    "CMYK_Y": 0.44490027427673,
    "CMYK_K": 0.49635297060013
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00021",
    "Farbtonhilfsbezeichnung": "10DC630",
    "Farbtonklasse": "02",
    "Rcolor": "125",
    "Gcolor": "130",
    "Bcolor": "122",
    "Y": 23,
    "L": 53.7820930480957,
    "a": -3.61495065689087,
    "b": 3.33034133911133,
    "C": 4.91518497467041,
    "h": 137.346588134766,
    "CMY_C": 0.51174700260162,
    "CMY_M": 0.48894852399826,
    "CMY_Y": 0.52267467975616,
    "CMYK_C": 0.04461092501879,
    "CMYK_M": 0,
    "CMYK_Y": 0.06599365919828,
    "CMYK_K": 0.48894852399826
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00022",
    "Farbtonhilfsbezeichnung": "10DC640",
    "Farbtonklasse": "02",
    "Rcolor": "136",
    "Gcolor": "188",
    "Bcolor": "159",
    "Y": 44,
    "L": 71.9954299926758,
    "a": -22.761812210083,
    "b": 8.39440631866455,
    "C": 24.2603816986084,
    "h": 159.756362915039,
    "CMY_C": 0.46684455871582,
    "CMY_M": 0.263218998909,
    "CMY_Y": 0.37583595514297,
    "CMYK_C": 0.27637189626694,
    "CMYK_M": 0,
    "CMYK_Y": 0.15284997224808,
    "CMYK_K": 0.263218998909
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00023",
    "Farbtonhilfsbezeichnung": "10DC650",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "174",
    "Y": 54,
    "L": 78.2851791381836,
    "a": -2.47792291641235,
    "b": 9.9585542678833,
    "C": 10.2622079849243,
    "h": 103.972785949707,
    "CMY_C": 0.22844219207764,
    "CMY_M": 0.23716980218887,
    "CMY_Y": 0.31847536563873,
    "CMYK_C": 0,
    "CMYK_M": 0.01131167355925,
    "CMYK_Y": 0.11669012159109,
    "CMYK_K": 0.22844219207764
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00024",
    "Farbtonhilfsbezeichnung": "10DC660",
    "Farbtonklasse": "01",
    "Rcolor": "172",
    "Gcolor": "212",
    "Bcolor": "213",
    "Y": 61,
    "L": 82.2874603271484,
    "a": -12.4330472946167,
    "b": -5.65063810348511,
    "C": 13.6568803787231,
    "h": 204.441101074219,
    "CMY_C": 0.32366645336151,
    "CMY_M": 0.1677657365799,
    "CMY_Y": 0.16404718160629,
    "CMYK_C": 0.19094291329384,
    "CMYK_M": 0.00444828346372,
    "CMYK_Y": 0,
    "CMYK_K": 0.16404718160629
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00025",
    "Farbtonhilfsbezeichnung": "10DC710",
    "Farbtonklasse": "02",
    "Rcolor": "116",
    "Gcolor": "112",
    "Bcolor": "104",
    "Y": 16,
    "L": 47.2650184631348,
    "a": 0.25703683495522,
    "b": 4.10823488235474,
    "C": 4.11626815795898,
    "h": 86.4198837280273,
    "CMY_C": 0.54696702957153,
    "CMY_M": 0.56171959638596,
    "CMY_Y": 0.59070354700089,
    "CMYK_C": 0,
    "CMYK_M": 0.03256400302052,
    "CMYK_Y": 0.09654157608747,
    "CMYK_K": 0.54696702957153
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00026",
    "Farbtonhilfsbezeichnung": "10DC720",
    "Farbtonklasse": "01",
    "Rcolor": "191",
    "Gcolor": "168",
    "Bcolor": "143",
    "Y": 42,
    "L": 70.3193130493164,
    "a": 4.67904186248779,
    "b": 15.4770259857178,
    "C": 16.168851852417,
    "h": 73.1787872314453,
    "CMY_C": 0.25008845329285,
    "CMY_M": 0.33998477458954,
    "CMY_Y": 0.43918001651764,
    "CMYK_C": 0,
    "CMYK_M": 0.11987590044737,
    "CMYK_Y": 0.25215181708336,
    "CMYK_K": 0.25008845329285
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00028",
    "Farbtonhilfsbezeichnung": "10DC740",
    "Farbtonklasse": "02",
    "Rcolor": "184",
    "Gcolor": "179",
    "Bcolor": "162",
    "Y": 45,
    "L": 72.8699569702148,
    "a": -0.64776223897934,
    "b": 8.37093353271484,
    "C": 8.39595890045166,
    "h": 94.4248657226562,
    "CMY_C": 0.27791327238083,
    "CMY_M": 0.29899471998215,
    "CMY_Y": 0.3635162115097,
    "CMYK_C": 0,
    "CMYK_M": 0.02919517457485,
    "CMYK_Y": 0.11854938417673,
    "CMYK_K": 0.27791327238083
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00029",
    "Farbtonhilfsbezeichnung": "10DC750",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "215",
    "Bcolor": "191",
    "Y": 69,
    "L": 86.5521545410156,
    "a": 1.52029657363892,
    "b": 12.7435293197632,
    "C": 12.8338937759399,
    "h": 83.1968002319336,
    "CMY_C": 0.09999632835388,
    "CMY_M": 0.15694385766983,
    "CMY_Y": 0.25028306245804,
    "CMYK_C": 0,
    "CMYK_M": 0.06327477097511,
    "CMYK_Y": 0.16698457300663,
    "CMYK_K": 0.09999632835388
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00030",
    "Farbtonhilfsbezeichnung": "10DC760",
    "Farbtonklasse": "01",
    "Rcolor": "230",
    "Gcolor": "222",
    "Bcolor": "205",
    "Y": 74,
    "L": 88.6675491333008,
    "a": 0.46337306499481,
    "b": 8.22092247009277,
    "C": 8.23397159576416,
    "h": 86.7739334106445,
    "CMY_C": 0.09715563058853,
    "CMY_M": 0.12990766763687,
    "CMY_Y": 0.19432055950165,
    "CMYK_C": 0,
    "CMYK_M": 0.03627650439739,
    "CMYK_Y": 0.10762090235949,
    "CMYK_K": 0.09715563058853
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00031",
    "Farbtonhilfsbezeichnung": "10DC770",
    "Farbtonklasse": "01",
    "Rcolor": "245",
    "Gcolor": "238",
    "Bcolor": "225",
    "Y": 86,
    "L": 94.4031219482422,
    "a": 0.34123355150223,
    "b": 6.1272668838501,
    "C": 6.13676134476459,
    "h": 86.8124340601361,
    "CMY_C": 0.04705882072449,
    "CMY_M": 0.00392156839371,
    "CMY_Y": 0.00392156839371,
    "CMYK_C": 0.0433070845902,
    "CMYK_M": -1.40248e-09,
    "CMYK_Y": -1.40248e-09,
    "CMYK_K": 0.00392157
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00032",
    "Farbtonhilfsbezeichnung": "10DC910",
    "Farbtonklasse": "02",
    "Rcolor": "82",
    "Gcolor": "81",
    "Bcolor": "81",
    "Y": 8,
    "L": 34.7060737609863,
    "a": 0.46340614557266,
    "b": 0.01002065837383,
    "C": 0.46351447701454,
    "h": 1.23876643180847,
    "CMY_C": 0.67691588401794,
    "CMY_M": 0.68067336082458,
    "CMY_Y": 0.68269783258438,
    "CMYK_C": 0,
    "CMYK_M": 0.01163002662361,
    "CMYK_Y": 0.0178961083293,
    "CMYK_K": 0.67691588401794
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00033",
    "Farbtonhilfsbezeichnung": "10DC920",
    "Farbtonklasse": "02",
    "Rcolor": "135",
    "Gcolor": "134",
    "Bcolor": "125",
    "Y": 23,
    "L": 55.8343811035156,
    "a": -1.25570023059845,
    "b": 4.51573610305786,
    "C": 4.68707323074341,
    "h": 105.539764404297,
    "CMY_C": 0.47078204154968,
    "CMY_M": 0.47348171472549,
    "CMY_Y": 0.51001107692719,
    "CMYK_C": 0,
    "CMYK_M": 0.00510125001892,
    "CMYK_Y": 0.07412642240524,
    "CMYK_K": 0.47078204154968
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00035",
    "Farbtonhilfsbezeichnung": "10DC940",
    "Farbtonklasse": "01",
    "Rcolor": "173",
    "Gcolor": "175",
    "Bcolor": "171",
    "Y": 43,
    "L": 71.1666946411133,
    "a": -1.04134929180145,
    "b": 0.92494362592697,
    "C": 1.39281332492828,
    "h": 138.387985229492,
    "CMY_C": 0.32166177034378,
    "CMY_M": 0.31428456306458,
    "CMY_Y": 0.32878810167313,
    "CMYK_C": 0.0107584092766,
    "CMYK_M": 0,
    "CMYK_Y": 0.021150957793,
    "CMYK_K": 0.31428456306458
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00036",
    "Farbtonhilfsbezeichnung": "10DC950",
    "Farbtonklasse": "01",
    "Rcolor": "215",
    "Gcolor": "213",
    "Bcolor": "203",
    "Y": 68,
    "L": 85.2965774536133,
    "a": -0.84123939275742,
    "b": 4.55694913864136,
    "C": 4.63394737243652,
    "h": 100.459381103516,
    "CMY_C": 0.15583109855652,
    "CMY_M": 0.16308009624481,
    "CMY_Y": 0.20416152477264,
    "CMYK_C": 0,
    "CMYK_M": 0.00858714152128,
    "CMYK_Y": 0.05725207924843,
    "CMYK_K": 0.15583109855652
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00037",
    "Farbtonhilfsbezeichnung": "10DC960",
    "Farbtonklasse": "00",
    "Rcolor": "242",
    "Gcolor": "238",
    "Bcolor": "228",
    "Y": 86,
    "L": 94.1375503540039,
    "a": 0.05734280124307,
    "b": 4.18110084533691,
    "C": 4.18149404827168,
    "h": 89.2142513069175,
    "CMY_C": 0.03529411554337,
    "CMY_M": 0.01176470518112,
    "CMY_Y": 0.00392156839371,
    "CMYK_C": 0.03149606287479,
    "CMYK_M": 0.00787401385605,
    "CMYK_Y": -1.40248e-09,
    "CMYK_K": 0.00392157
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00038",
    "Farbtonhilfsbezeichnung": "10DC97R",
    "Farbtonklasse": "00",
    "Rcolor": "246",
    "Gcolor": "245",
    "Bcolor": "237",
    "Y": 91,
    "L": 96.4264144897461,
    "a": -0.78536921739578,
    "b": 3.0378749370575,
    "C": 3.13775229454041,
    "h": 104.495071411133,
    "CMY_C": 0.03622192144394,
    "CMY_M": 0.03873527050018,
    "CMY_Y": 0.07057118415833,
    "CMYK_C": 0,
    "CMYK_M": 0.00260780891404,
    "CMYK_Y": 0.03564022108912,
    "CMYK_K": 0.03622192144394
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00039",
    "Farbtonhilfsbezeichnung": "12DC610",
    "Farbtonklasse": "02",
    "Rcolor": "162",
    "Gcolor": "173",
    "Bcolor": "145",
    "Y": 40,
    "L": 69.0301895141602,
    "a": -8.62499809265137,
    "b": 12.4432258605957,
    "C": 15.1401605606079,
    "h": 124.727699279785,
    "CMY_C": 0.36594951152802,
    "CMY_M": 0.3233996629715,
    "CMY_Y": 0.43300592899323,
    "CMYK_C": 0.0628877133131,
    "CMYK_M": 0,
    "CMYK_Y": 0.16199558973312,
    "CMYK_K": 0.3233996629715
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00040",
    "Farbtonhilfsbezeichnung": "12DC620",
    "Farbtonklasse": "02",
    "Rcolor": "213",
    "Gcolor": "214",
    "Bcolor": "141",
    "Y": 64,
    "L": 84.0768203735352,
    "a": -11.1172971725464,
    "b": 35.416145324707,
    "C": 37.120044708252,
    "h": 107.427322387695,
    "CMY_C": 0.16506844758987,
    "CMY_M": 0.16023570299149,
    "CMY_Y": 0.44743978977203,
    "CMYK_C": 0.00575488200411,
    "CMYK_M": 0,
    "CMYK_Y": 0.34200558066368,
    "CMYK_K": 0.16023570299149
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00041",
    "Farbtonhilfsbezeichnung": "12DC630",
    "Farbtonklasse": "02",
    "Rcolor": "132",
    "Gcolor": "126",
    "Bcolor": "100",
    "Y": 21,
    "L": 52.6163635253906,
    "a": -2.05240440368652,
    "b": 14.2559156417847,
    "C": 14.4028987884522,
    "h": 98.192497253418,
    "CMY_C": 0.48387336730957,
    "CMY_M": 0.50624215602875,
    "CMY_Y": 0.60675650835037,
    "CMYK_C": 0,
    "CMYK_M": 0.04333972930908,
    "CMYK_Y": 0.23808719217777,
    "CMYK_K": 0.48387336730957
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00042",
    "Farbtonhilfsbezeichnung": "12DC640",
    "Farbtonklasse": "01",
    "Rcolor": "238",
    "Gcolor": "239",
    "Bcolor": "216",
    "Y": 85,
    "L": 93.9358520507812,
    "a": -3.92871332168579,
    "b": 10.5165615081787,
    "C": 11.2264356613159,
    "h": 110.484375,
    "CMY_C": 0.06493985652924,
    "CMY_M": 0.06138449907303,
    "CMY_Y": 0.15457367897034,
    "CMYK_C": 0.00378787424415,
    "CMYK_M": 0,
    "CMYK_Y": 0.09928365796804,
    "CMYK_K": 0.06138449907303
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00043",
    "Farbtonhilfsbezeichnung": "12DC650",
    "Farbtonklasse": "03",
    "Rcolor": "163",
    "Gcolor": "150",
    "Bcolor": "63",
    "Y": 30,
    "L": 61.5576934814453,
    "a": -6.00891780853271,
    "b": 46.0961303710938,
    "C": 46.4861297607422,
    "h": 97.4269790649414,
    "CMY_C": 0.36159110069275,
    "CMY_M": 0.41230773925781,
    "CMY_Y": 0.75382286310196,
    "CMYK_C": 0,
    "CMYK_M": 0.07944224774837,
    "CMYK_Y": 0.61438953876495,
    "CMYK_K": 0.36159110069275
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00046",
    "Farbtonhilfsbezeichnung": "12DC310",
    "Farbtonklasse": "04",
    "Rcolor": "125",
    "Gcolor": "55",
    "Bcolor": "69",
    "Y": 8,
    "L": 32.8411979675293,
    "a": 32.1203880310059,
    "b": 5.88524055480957,
    "C": 32.6550979614258,
    "h": 10.3828220367432,
    "CMY_C": 0.51070785522461,
    "CMY_M": 0.78579914569855,
    "CMY_Y": 0.7307413816452,
    "CMYK_C": 0,
    "CMYK_M": 0.56222295761108,
    "CMYK_Y": 0.44969764351845,
    "CMYK_K": 0.51070785522461
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00047",
    "Farbtonhilfsbezeichnung": "12DC320",
    "Farbtonklasse": "00",
    "Rcolor": "243",
    "Gcolor": "239",
    "Bcolor": "231",
    "Y": 86,
    "L": 94.5911178588867,
    "a": 0.15731665492058,
    "b": 3.5050847530365,
    "C": 3.50861335229237,
    "h": 87.4301519357964,
    "CMY_C": 0.02352941036224,
    "CMY_M": 0.01176470518112,
    "CMY_Y": 0,
    "CMYK_C": 0.02352941036224,
    "CMYK_M": 0.01176470518112,
    "CMYK_Y": 0,
    "CMYK_K": 0
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00048",
    "Farbtonhilfsbezeichnung": "12DC330",
    "Farbtonklasse": "04",
    "Rcolor": "183",
    "Gcolor": "90",
    "Bcolor": "141",
    "Y": 20,
    "L": 51.0629119873047,
    "a": 44.1939010620117,
    "b": -11.2696266174316,
    "C": 45.6081733703613,
    "h": 345.694213867188,
    "CMY_C": 0.28063994646072,
    "CMY_M": 0.64773851633072,
    "CMY_Y": 0.44748139381409,
    "CMYK_C": 0,
    "CMYK_M": 0.51031267642975,
    "CMYK_Y": 0.23193037509918,
    "CMYK_K": 0.28063994646072
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00050",
    "Farbtonhilfsbezeichnung": "12DC350",
    "Farbtonklasse": "03",
    "Rcolor": "168",
    "Gcolor": "66",
    "Bcolor": "60",
    "Y": 13,
    "L": 42.0535087585449,
    "a": 41.6667785644531,
    "b": 24.6620025634766,
    "C": 48.4183311462402,
    "h": 30.6207141876221,
    "CMY_C": 0.34242486953735,
    "CMY_M": 0.74055850505829,
    "CMY_Y": 0.76311248540878,
    "CMYK_C": 0,
    "CMYK_M": 0.60545724630356,
    "CMYK_Y": 0.63975596427917,
    "CMYK_K": 0.34242486953735
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00052",
    "Farbtonhilfsbezeichnung": "12DC520",
    "Farbtonklasse": "01",
    "Rcolor": "219",
    "Gcolor": "222",
    "Bcolor": "221",
    "Y": 71,
    "L": 88.2739944458008,
    "a": -1.07165706157684,
    "b": -0.74068224430084,
    "C": 1.30271220207214,
    "h": 214.650527954102,
    "CMY_C": 0.14257287979126,
    "CMY_M": 0.12819516658783,
    "CMY_Y": 0.13284438848495,
    "CMYK_C": 0.0164918936789,
    "CMYK_M": 0,
    "CMYK_Y": 0.00533286994323,
    "CMYK_K": 0.12819516658783
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00053",
    "Farbtonhilfsbezeichnung": "12DC530",
    "Farbtonklasse": "04",
    "Rcolor": "26",
    "Gcolor": "70",
    "Bcolor": "114",
    "Y": 6,
    "L": 28.9110584259033,
    "a": 1.68128657341003,
    "b": -30.2254810333252,
    "C": 30.2722053527832,
    "h": 273.183776855469,
    "CMY_C": 0.89800947904587,
    "CMY_M": 0.7258312702179,
    "CMY_Y": 0.55301088094711,
    "CMYK_C": 0.77182775735855,
    "CMYK_M": 0.38663220405579,
    "CMYK_Y": 0,
    "CMYK_K": 0.55301088094711
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00054",
    "Farbtonhilfsbezeichnung": "12DC540",
    "Farbtonklasse": "02",
    "Rcolor": "110",
    "Gcolor": "191",
    "Bcolor": "200",
    "Y": 46,
    "L": 72.8187103271484,
    "a": -22.1346187591553,
    "b": -13.09645652771,
    "C": 25.7188358306885,
    "h": 210.611663818359,
    "CMY_C": 0.5681459903717,
    "CMY_M": 0.24988228082657,
    "CMY_Y": 0.21452414989471,
    "CMYK_C": 0.450200766325,
    "CMYK_M": 0.04501491785049,
    "CMYK_Y": 0,
    "CMYK_K": 0.21452414989471
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00055",
    "Farbtonhilfsbezeichnung": "12DC550",
    "Farbtonklasse": "03",
    "Rcolor": "125",
    "Gcolor": "149",
    "Bcolor": "153",
    "Y": 28,
    "L": 59.9518547058105,
    "a": -7.14553737640381,
    "b": -5.59264707565308,
    "C": 9.07394123077393,
    "h": 218.049468994141,
    "CMY_C": 0.50940316915512,
    "CMY_M": 0.41672915220261,
    "CMY_Y": 0.40086382627487,
    "CMYK_C": 0.18115971982479,
    "CMYK_M": 0.02648033387959,
    "CMYK_Y": 0,
    "CMYK_K": 0.40086382627487
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00056",
    "Farbtonhilfsbezeichnung": "12DC560",
    "Farbtonklasse": "04",
    "Rcolor": "0",
    "Gcolor": "107",
    "Bcolor": "104",
    "Y": 11,
    "L": 39.4394035339355,
    "a": -32.4170799255371,
    "b": -7.57975435256958,
    "C": 33.2914352416992,
    "h": 193.160461425781,
    "CMY_C": 1,
    "CMY_M": 0.58160436153412,
    "CMY_Y": 0.59398806095123,
    "CMYK_C": 1,
    "CMYK_M": 0,
    "CMYK_Y": 0.02959806099534,
    "CMYK_K": 0.58160436153412
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00057",
    "Farbtonhilfsbezeichnung": "12DC91R",
    "Farbtonklasse": "00",
    "Rcolor": "246",
    "Gcolor": "245",
    "Bcolor": "237",
    "Y": 91,
    "L": 96.4264144897461,
    "a": -0.78536921739578,
    "b": 3.0378749370575,
    "C": 3.13775229454041,
    "h": 104.495071411133,
    "CMY_C": 0.03622192144394,
    "CMY_M": 0.03873527050018,
    "CMY_Y": 0.07057118415833,
    "CMYK_C": 0,
    "CMYK_M": 0.00260780891404,
    "CMYK_Y": 0.03564022108912,
    "CMYK_K": 0.03622192144394
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00058",
    "Farbtonhilfsbezeichnung": "12DC920",
    "Farbtonklasse": "01",
    "Rcolor": "197",
    "Gcolor": "195",
    "Bcolor": "174",
    "Y": 53,
    "L": 78.2851791381836,
    "a": -2.47792291641235,
    "b": 9.9585542678833,
    "C": 10.2622079849243,
    "h": 103.972785949707,
    "CMY_C": 0.22844219207764,
    "CMY_M": 0.23716980218887,
    "CMY_Y": 0.31847536563873,
    "CMYK_C": 0,
    "CMYK_M": 0.01131167355925,
    "CMYK_Y": 0.11669012159109,
    "CMYK_K": 0.22844219207764
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00059",
    "Farbtonhilfsbezeichnung": "12DC930",
    "Farbtonklasse": "01",
    "Rcolor": "92",
    "Gcolor": "94",
    "Bcolor": "92",
    "Y": 11,
    "L": 39.6572532653809,
    "a": -0.8177433013916,
    "b": 0.08228448778391,
    "C": 0.82187277078629,
    "h": 174.254013061523,
    "CMY_C": 0.63896942138672,
    "CMY_M": 0.631791472435,
    "CMY_Y": 0.63731801509857,
    "CMYK_C": 0.01949425041676,
    "CMYK_M": 0,
    "CMYK_Y": 0.01500927377492,
    "CMYK_K": 0.631791472435
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00061",
    "Farbtonhilfsbezeichnung": "12DC950",
    "Farbtonklasse": "02",
    "Rcolor": "67",
    "Gcolor": "68",
    "Bcolor": "66",
    "Y": 6,
    "L": 28.665958404541,
    "a": -0.33345240354538,
    "b": 0.41785714030266,
    "C": 0.53459806876953,
    "h": 128.590068671383,
    "CMY_C": 0.76078432798386,
    "CMY_M": 0.76862746477127,
    "CMY_Y": 0.74901962280273,
    "CMYK_C": 0.046875,
    "CMYK_M": 0.078125,
    "CMYK_Y": 0,
    "CMYK_K": 0.74901962
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00063",
    "Farbtonhilfsbezeichnung": "12DC210",
    "Farbtonklasse": "03",
    "Rcolor": "235",
    "Gcolor": "147",
    "Bcolor": "63",
    "Y": 38,
    "L": 68.5451431274414,
    "a": 26.8658466339111,
    "b": 55.8780632019043,
    "C": 62.0010604858398,
    "h": 64.322021484375,
    "CMY_C": 0.07941085100174,
    "CMY_M": 0.4251070022583,
    "CMY_Y": 0.75396662950516,
    "CMYK_C": 0,
    "CMYK_M": 0.37551620602608,
    "CMYK_Y": 0.73274356126785,
    "CMYK_K": 0.07941085100174
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00065",
    "Farbtonhilfsbezeichnung": "12DC230",
    "Farbtonklasse": "03",
    "Rcolor": "223",
    "Gcolor": "170",
    "Bcolor": "105",
    "Y": 45,
    "L": 73.0315322875977,
    "a": 12.3135042190552,
    "b": 40.2637176513672,
    "C": 42.1045036315918,
    "h": 72.995246887207,
    "CMY_C": 0.12698501348495,
    "CMY_M": 0.33513820171356,
    "CMY_Y": 0.5901392698288,
    "CMYK_C": 0,
    "CMYK_M": 0.23843026161194,
    "CMYK_Y": 0.53052270412445,
    "CMYK_K": 0.12698501348495
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00066",
    "Farbtonhilfsbezeichnung": "12DC240",
    "Farbtonklasse": "01",
    "Rcolor": "247",
    "Gcolor": "239",
    "Bcolor": "217",
    "Y": 86,
    "L": 94.5722351074219,
    "a": -0.59063202142715,
    "b": 11.0050868988037,
    "C": 11.0209245681763,
    "h": 93.0720596313477,
    "CMY_C": 0.03045511245728,
    "CMY_M": 0.06223398447037,
    "CMY_Y": 0.150734603405,
    "CMYK_C": 0,
    "CMYK_M": 0.03277710080147,
    "CMYK_Y": 0.12405768036842,
    "CMYK_K": 0.03045511245728
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00070",
    "Farbtonhilfsbezeichnung": "14DC110",
    "Farbtonklasse": "01",
    "Rcolor": "206",
    "Gcolor": "196",
    "Bcolor": "179",
    "Y": 56.3,
    "L": 79.6149597167969,
    "a": 0.89551919698715,
    "b": 9.36609268188477,
    "C": 9.40880680084229,
    "h": 84.5383834838867,
    "CMY_C": 0.19075798988342,
    "CMY_M": 0.23038429021835,
    "CMY_Y": 0.29965978860855,
    "CMYK_C": 0,
    "CMYK_M": 0.04896718263626,
    "CMYK_Y": 0.13457259535789,
    "CMYK_K": 0.19075798988342
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00071",
    "Farbtonhilfsbezeichnung": "14DC120",
    "Farbtonklasse": "04",
    "Rcolor": "50",
    "Gcolor": "66",
    "Bcolor": "101",
    "Y": 4.9,
    "L": 28.1230163574219,
    "a": 4.7369556427002,
    "b": -23.1953620910645,
    "C": 23.6741123199463,
    "h": 281.542236328125,
    "CMY_C": 0.80352121591568,
    "CMY_M": 0.74173158407211,
    "CMY_Y": 0.60326182842255,
    "CMYK_C": 0.50476461648941,
    "CMYK_M": 0.34902051091194,
    "CMYK_Y": 0,
    "CMYK_K": 0.60326182842255
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00072",
    "Farbtonhilfsbezeichnung": "14DC130",
    "Farbtonklasse": "03",
    "Rcolor": "209",
    "Gcolor": "170",
    "Bcolor": "79",
    "Y": 42.2,
    "L": 71.3867416381836,
    "a": 4.79129791259766,
    "b": 50.4869422912598,
    "C": 50.7137832641602,
    "h": 84.5787658691406,
    "CMY_C": 0.17908543348312,
    "CMY_M": 0.33508777618408,
    "CMY_Y": 0.68905258178711,
    "CMYK_C": 0,
    "CMYK_M": 0.19003480672836,
    "CMYK_Y": 0.62121832370758,
    "CMYK_K": 0.17908543348312
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00073",
    "Farbtonhilfsbezeichnung": "14DC140",
    "Farbtonklasse": "02",
    "Rcolor": "104",
    "Gcolor": "94",
    "Bcolor": "85",
    "Y": 11.2,
    "L": 40.5921859741211,
    "a": 2.88374137878418,
    "b": 5.96396541595459,
    "C": 6.6245641708374,
    "h": 64.194953918457,
    "CMY_C": 0.59045481681824,
    "CMY_M": 0.6319032907486,
    "CMY_Y": 0.66521108150482,
    "CMYK_C": 0,
    "CMYK_M": 0.10120610892773,
    "CMYK_Y": 0.18253484368324,
    "CMYK_K": 0.59045481681824
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00075",
    "Farbtonhilfsbezeichnung": "14DC160",
    "Farbtonklasse": "03",
    "Rcolor": "91",
    "Gcolor": "123",
    "Bcolor": "137",
    "Y": 17.6,
    "L": 49.6118850708008,
    "a": -7.38158655166626,
    "b": -12.2120742797852,
    "C": 14.2696380615234,
    "h": 238.849136352539,
    "CMY_C": 0.64459723234177,
    "CMY_M": 0.51903140544891,
    "CMY_Y": 0.46185946464539,
    "CMYK_C": 0.33957257866859,
    "CMYK_M": 0.10623979568481,
    "CMYK_Y": 0,
    "CMYK_K": 0.46185946464539
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00076",
    "Farbtonhilfsbezeichnung": "14DC170",
    "Farbtonklasse": "01",
    "Rcolor": "157",
    "Gcolor": "152",
    "Bcolor": "145",
    "Y": 31.6,
    "L": 62.9514617919922,
    "a": 0.90100717544556,
    "b": 3.53640985488892,
    "C": 3.64938473701477,
    "h": 75.7062759399414,
    "CMY_C": 0.3853765130043,
    "CMY_M": 0.40524989366531,
    "CMY_Y": 0.43159013986588,
    "CMYK_C": 0,
    "CMYK_M": 0.0323342345655,
    "CMYK_Y": 0.07519014179707,
    "CMYK_K": 0.3853765130043
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00077",
    "Farbtonhilfsbezeichnung": "14DC180",
    "Farbtonklasse": "03",
    "Rcolor": "245",
    "Gcolor": "133",
    "Bcolor": "116",
    "Y": 26.1,
    "L": 67.4854507446289,
    "a": 41.3040199279785,
    "b": 27.816822052002,
    "C": 49.7975654602051,
    "h": 33.9588966369629,
    "CMY_C": 0.04112166166306,
    "CMY_M": 0.47944182157516,
    "CMY_Y": 0.54682552814484,
    "CMYK_C": 0,
    "CMYK_M": 0.45711758732796,
    "CMYK_Y": 0.52739107608795,
    "CMYK_K": 0.04112166166306
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00078",
    "Farbtonhilfsbezeichnung": "14DC190",
    "Farbtonklasse": "01",
    "Rcolor": "239",
    "Gcolor": "226",
    "Bcolor": "207",
    "Y": 77.19,
    "L": 90.5317840576172,
    "a": 1.57251214981079,
    "b": 10.2353067398071,
    "C": 10.3553994862219,
    "h": 81.2655975524227,
    "CMY_C": 0.13333332538605,
    "CMY_M": 0.02352941036224,
    "CMY_Y": 0.05098038911819,
    "CMYK_C": 0.11244979500771,
    "CMYK_M": 0,
    "CMYK_Y": 0.02811244875193,
    "CMYK_K": 0.02352941
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00079",
    "Farbtonhilfsbezeichnung": "14DC200",
    "Farbtonklasse": "04",
    "Rcolor": "93",
    "Gcolor": "121",
    "Bcolor": "68",
    "Y": 15.5,
    "L": 47.5283432006836,
    "a": -20.1273345947266,
    "b": 25.6278820037842,
    "C": 32.5867767333984,
    "h": 128.144973754883,
    "CMY_C": 0.63544207811356,
    "CMY_M": 0.52526092529297,
    "CMY_Y": 0.734898686409,
    "CMYK_C": 0.2320878058672,
    "CMYK_M": 0,
    "CMYK_Y": 0.44158521294594,
    "CMYK_K": 0.52526092529297
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00080",
    "Farbtonhilfsbezeichnung": "14DC210",
    "Farbtonklasse": "04",
    "Rcolor": "136",
    "Gcolor": "58",
    "Bcolor": "90",
    "Y": 7.4,
    "L": 36.0879135131836,
    "a": 36.9569206237793,
    "b": -2.8026864528656,
    "C": 37.0630416870117,
    "h": 355.663177490234,
    "CMY_C": 0.46576899290085,
    "CMY_M": 0.77097326517105,
    "CMY_Y": 0.64797729253769,
    "CMYK_C": 0,
    "CMYK_M": 0.57129645347595,
    "CMYK_Y": 0.34106650948524,
    "CMYK_K": 0.46576899290085
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00081",
    "Farbtonhilfsbezeichnung": "14DC220",
    "Farbtonklasse": "01",
    "Rcolor": "189",
    "Gcolor": "180",
    "Bcolor": "172",
    "Y": 45.8,
    "L": 73.830924987793,
    "a": 2.22826862335205,
    "b": 4.43045330047607,
    "C": 4.95924377441406,
    "h": 63.300178527832,
    "CMY_C": 0.25808614492416,
    "CMY_M": 0.29435217380524,
    "CMY_Y": 0.32513296604156,
    "CMYK_C": 0,
    "CMYK_M": 0.04888172447681,
    "CMYK_Y": 0.09037008881569,
    "CMYK_K": 0.25808614492416
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00082",
    "Farbtonhilfsbezeichnung": "14DC230",
    "Farbtonklasse": "03",
    "Rcolor": "169",
    "Gcolor": "179",
    "Bcolor": "75",
    "Y": 41.2,
    "L": 70.2430419921875,
    "a": -17.7693481445313,
    "b": 50.1548461914063,
    "C": 53.2095680236816,
    "h": 109.508720397949,
    "CMY_C": 0.33904629945755,
    "CMY_M": 0.29839539527893,
    "CMY_Y": 0.70547437667847,
    "CMYK_C": 0.05793990567327,
    "CMYK_M": 0,
    "CMYK_Y": 0.58021140098572,
    "CMYK_K": 0.29839539527893
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00083",
    "Farbtonhilfsbezeichnung": "14DC240",
    "Farbtonklasse": "03",
    "Rcolor": "139",
    "Gcolor": "126",
    "Bcolor": "115",
    "Y": 20.6,
    "L": 53.6445465087891,
    "a": 3.52961730957031,
    "b": 6.9746789932251,
    "C": 7.81692695617676,
    "h": 63.1577758789063,
    "CMY_C": 0.45389592647552,
    "CMY_M": 0.50646489858627,
    "CMY_Y": 0.54733890295029,
    "CMYK_C": 0,
    "CMYK_M": 0.09626182168722,
    "CMYK_Y": 0.1711083650589,
    "CMYK_K": 0.45389592647552
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00084",
    "Farbtonhilfsbezeichnung": "14DC250",
    "Farbtonklasse": "01",
    "Rcolor": "241",
    "Gcolor": "231",
    "Bcolor": "217",
    "Y": 81.2,
    "L": 92.0921325683594,
    "a": 1.2193763256073,
    "b": 7.0555682182312,
    "C": 7.1601619720459,
    "h": 80.1947326660156,
    "CMY_C": 0.05652844905853,
    "CMY_M": 0.0933164358139,
    "CMY_Y": 0.14820426702499,
    "CMYK_C": 0,
    "CMYK_M": 0.038992151618,
    "CMYK_Y": 0.09716860949993,
    "CMYK_K": 0.05652844905853
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00085",
    "Farbtonhilfsbezeichnung": "14DC260",
    "Farbtonklasse": "03",
    "Rcolor": "56",
    "Gcolor": "168",
    "Bcolor": "168",
    "Y": 32.2,
    "L": 63.1853942871094,
    "a": -30.6220531463623,
    "b": -9.54533100128174,
    "C": 32.0752792358398,
    "h": 197.313003540039,
    "CMY_C": 0.77976965904236,
    "CMY_M": 0.33961588144302,
    "CMY_Y": 0.34263455867767,
    "CMYK_C": 0.66651177406311,
    "CMYK_M": 0,
    "CMYK_Y": 0.00457109324634,
    "CMYK_K": 0.33961588144302
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00086",
    "Farbtonhilfsbezeichnung": "14DC270",
    "Farbtonklasse": "03",
    "Rcolor": "116",
    "Gcolor": "94",
    "Bcolor": "140",
    "Y": 12.9,
    "L": 43.7081871032715,
    "a": 18.4096431732178,
    "b": -22.4681529998779,
    "C": 29.0470809936523,
    "h": 309.330017089844,
    "CMY_C": 0.54595124721527,
    "CMY_M": 0.63022601604462,
    "CMY_Y": 0.45246934890747,
    "CMYK_C": 0.1707336306572,
    "CMYK_M": 0.32465153932571,
    "CMYK_Y": 0,
    "CMYK_K": 0.45246934890747
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00088",
    "Farbtonhilfsbezeichnung": "14DC290",
    "Farbtonklasse": "02",
    "Rcolor": "191",
    "Gcolor": "164",
    "Bcolor": "144",
    "Y": 39.7,
    "L": 69.2118530273438,
    "a": 7.12027978897095,
    "b": 13.2032651901245,
    "C": 15.0008201599121,
    "h": 61.6628265380859,
    "CMY_C": 0.25104922056198,
    "CMY_M": 0.35694259405136,
    "CMY_Y": 0.43403548002243,
    "CMYK_C": 0,
    "CMYK_M": 0.14138896763325,
    "CMYK_Y": 0.24432347714901,
    "CMYK_K": 0.25104922056198
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00089",
    "Farbtonhilfsbezeichnung": "14DC300",
    "Farbtonklasse": "03",
    "Rcolor": "120",
    "Gcolor": "89",
    "Bcolor": "98",
    "Y": 12.8,
    "L": 41.3737678527832,
    "a": 14.1514616012573,
    "b": -0.31472435593605,
    "C": 14.1549606323242,
    "h": 358.725982666016,
    "CMY_C": 0.52926921844482,
    "CMY_M": 0.64903092384338,
    "CMY_Y": 0.6167733669281,
    "CMYK_C": 0,
    "CMYK_M": 0.25441655516624,
    "CMYK_Y": 0.18589000403881,
    "CMYK_K": 0.52926921844482
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00091",
    "Farbtonhilfsbezeichnung": "14DC320",
    "Farbtonklasse": "01",
    "Rcolor": "232",
    "Gcolor": "231",
    "Bcolor": "222",
    "Y": 80,
    "L": 91.4208831787109,
    "a": -0.64816069602966,
    "b": 3.24333381652832,
    "C": 3.30746531486511,
    "h": 101.301338195801,
    "CMY_C": 0.09066474437714,
    "CMY_M": 0.09531193971634,
    "CMY_Y": 0.12756133079529,
    "CMYK_C": 0,
    "CMYK_M": 0.00511054135859,
    "CMYK_Y": 0.04057534039021,
    "CMYK_K": 0.09066474437714
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00092",
    "Farbtonhilfsbezeichnung": "14DC330",
    "Farbtonklasse": "02",
    "Rcolor": "113",
    "Gcolor": "199",
    "Bcolor": "198",
    "Y": 48.5,
    "L": 75.1085968017578,
    "a": -25.9501972198486,
    "b": -8.56125640869141,
    "C": 27.3259563446045,
    "h": 198.258285522461,
    "CMY_C": 0.55847656726837,
    "CMY_M": 0.21932196617126,
    "CMY_Y": 0.22251039743423,
    "CMYK_C": 0.43443593382835,
    "CMYK_M": 0,
    "CMYK_Y": 0.00408418197185,
    "CMYK_K": 0.21932196617126
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00093",
    "Farbtonhilfsbezeichnung": "14DC340",
    "Farbtonklasse": "03",
    "Rcolor": "86",
    "Gcolor": "79",
    "Bcolor": "83",
    "Y": 8.7,
    "L": 34.3646202087402,
    "a": 3.74819898605347,
    "b": -1.76041078567505,
    "C": 4.14101934432983,
    "h": 334.842041015625,
    "CMY_C": 0.66390478610992,
    "CMY_M": 0.69007217884064,
    "CMY_Y": 0.67460989952087,
    "CMYK_C": 0,
    "CMYK_M": 0.07785708457232,
    "CMYK_Y": 0.03185142949224,
    "CMYK_K": 0.66390478610992
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00094",
    "Farbtonhilfsbezeichnung": "14DC350",
    "Farbtonklasse": "01",
    "Rcolor": "181",
    "Gcolor": "180",
    "Bcolor": "176",
    "Y": 45,
    "L": 73.2462463378906,
    "a": -0.02772470191121,
    "b": 1.5191650390625,
    "C": 1.51941800117493,
    "h": 91.045524597168,
    "CMY_C": 0.29000759124756,
    "CMY_M": 0.29462796449661,
    "CMY_Y": 0.31097757816315,
    "CMYK_C": 0,
    "CMYK_M": 0.00650763744488,
    "CMYK_Y": 0.02953550778329,
    "CMYK_K": 0.29000759124756
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00095",
    "Farbtonhilfsbezeichnung": "14DC360",
    "Farbtonklasse": "01",
    "Rcolor": "237",
    "Gcolor": "231",
    "Bcolor": "160",
    "Y": 78,
    "L": 90.5470352172852,
    "a": -8.16872787475586,
    "b": 34.6943664550781,
    "C": 35.6430511474609,
    "h": 103.248886108398,
    "CMY_C": 0.0721675157547,
    "CMY_M": 0.09494459629059,
    "CMY_Y": 0.37399077415466,
    "CMYK_C": 0,
    "CMYK_M": 0.02454870007932,
    "CMYK_Y": 0.32529929280281,
    "CMYK_K": 0.0721675157547
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00096",
    "Farbtonhilfsbezeichnung": "14DC370",
    "Farbtonklasse": "03",
    "Rcolor": "206",
    "Gcolor": "140",
    "Bcolor": "180",
    "Y": 35.2,
    "L": 66.0052032470703,
    "a": 31.2216548919678,
    "b": -11.1521635055542,
    "C": 33.1536178588867,
    "h": 340.343627929688,
    "CMY_C": 0.19120711088181,
    "CMY_M": 0.44919908046722,
    "CMY_Y": 0.29496252536774,
    "CMYK_C": 0,
    "CMYK_M": 0.3189839720726,
    "CMYK_Y": 0.12828427553177,
    "CMYK_K": 0.19120711088181
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00098",
    "Farbtonhilfsbezeichnung": "14DC390",
    "Farbtonklasse": "02",
    "Rcolor": "70",
    "Gcolor": "71",
    "Bcolor": "68",
    "Y": 5.7,
    "L": 29.8108196258545,
    "a": -0.66264206171036,
    "b": 0.7540374994278,
    "C": 1.00382626056671,
    "h": 131.308746337891,
    "CMY_C": 0.72684562206268,
    "CMY_M": 0.72338759899139,
    "CMY_Y": 0.73165369033813,
    "CMYK_C": 0.01250133104622,
    "CMYK_M": 0,
    "CMYK_Y": 0.02988329902291,
    "CMYK_K": 0.72338759899139
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00099",
    "Farbtonhilfsbezeichnung": "14DC400",
    "Farbtonklasse": "01",
    "Rcolor": "217",
    "Gcolor": "184",
    "Bcolor": "165",
    "Y": 51.7,
    "L": 77.1694641113281,
    "a": 9.42502307891846,
    "b": 13.3530149459839,
    "C": 16.3442363739014,
    "h": 54.7842216491699,
    "CMY_C": 0.1475710272789,
    "CMY_M": 0.27835637331009,
    "CMY_Y": 0.35267615318298,
    "CMYK_C": 0,
    "CMYK_M": 0.1534266769886,
    "CMYK_Y": 0.2406125664711,
    "CMYK_K": 0.1475710272789
  },
  {
    "Farbtonkarten_Bezeichnung": "Designer Collection",
    "Farbton_ID": "DC00100",
    "Farbtonhilfsbezeichnung": "14DC410",
    "Farbtonklasse": "01",
    "Rcolor": "242",
    "Gcolor": "229",
    "Bcolor": "216",
    "Y": 79,
    "L": 91.6624603271484,
    "a": 2.28701210021973,
    "b": 7.17263412475586,
    "C": 7.52841997146606,
    "h": 72.3149871826172,
    "CMY_C": 0.05289101600647,
    "CMY_M": 0.10072189569473,
    "CMY_Y": 0.15362322330475,
    "CMYK_C": 0,
    "CMYK_M": 0.05050197988749,
    "CMYK_Y": 0.10635756701231,
    "CMYK_K": 0.05289101600647
  }
];


  

 // Gruppierung der Farben nach Farbtonkarten-Bezeichnung
    var groupedColors = {};
    farben.forEach(function(color) {
        if (!groupedColors[color.Farbtonkarten_Bezeichnung]) {
            groupedColors[color.Farbtonkarten_Bezeichnung] = [];
        }
        groupedColors[color.Farbtonkarten_Bezeichnung].push(color);
    });

    // Anzeigen der Farbgruppen als Akkordeon
    var container = document.getElementById("colors_container");
    for (var groupKey in groupedColors) {
        if (groupedColors.hasOwnProperty(groupKey)) {
            var group = groupedColors[groupKey];

            // Erstellen des Gruppenkopfs (h3-Element)
            var groupHeader = document.createElement("h3");
            groupHeader.textContent = groupKey;
            container.appendChild(groupHeader);

            // Erstellen der Farbenliste (ul-Element)
            var ul = document.createElement("ul");
            ul.className = "accordionAll"; // Füge der ul-Klasse 'accordion' hinzu
            group.forEach(function(color) {
                var li = document.createElement("li");
                li.textContent = color.Farbton_ID + ' - ' + color.Farbtonhilfsbezeichnung;
var div = document.createElement("div");
div.textContent = " ";
div.style.background = "rgb(" + color.Rcolor + "," + color.Gcolor + "," + color.Bcolor + ")";
div.classList.add("ansicht"); 
li.appendChild(div);


                ul.appendChild(li);
            });
            container.appendChild(ul);

            // Klickereignis-Listener für das Akkordeon
            groupHeader.addEventListener("click", function() {
                // Suche das nächste ul-Element (Farbenliste)
                var ul = this.nextElementSibling;
                
                // Wenn das nächste Element eine Farbenliste (ul) ist
                if (ul && ul.classList.contains("accordionAll")) {
                    // Toggle-Klasse "active" für das Gruppenkopf-Element
                    this.classList.toggle("active");

                    // Toggle-Klasse "show" für die Farbenliste (ul)
                    if (ul.style.maxHeight) {
                        // Wenn die Farbenliste sichtbar ist, verstecke sie
                        ul.style.maxHeight = null;
                    } else {
                        // Wenn die Farbenliste versteckt ist, zeige sie
                        ul.style.maxHeight = ul.scrollHeight + "px";
                    }
                }
            });
        }
    } 
  






  // Gruppierung der Farben nach Farbtonkarten-Bezeichnung
var groupedColors = {};
farben.forEach(function(color) {
    if (!groupedColors[color.Farbtonkarten_Bezeichnung]) {
        groupedColors[color.Farbtonkarten_Bezeichnung] = [];
    }
    groupedColors[color.Farbtonkarten_Bezeichnung].push(color);
});

// Anzeigen der Farbgruppen
var container = document.getElementById("colors_container");

function searchColor() {
    var searchTerm = document.getElementById("search_input").value.toLowerCase();
    var results = [];
    for (var groupKey in groupedColors) {
        if (groupedColors.hasOwnProperty(groupKey)) {
            var group = groupedColors[groupKey];
            group.forEach(function(color) {
                if (color.Farbtonhilfsbezeichnung.toLowerCase().includes(searchTerm)) {
                    results.push({ Farbtonkarten_Bezeichnung: color.Farbtonkarten_Bezeichnung, Farbtonhilfsbezeichnung: color.Farbtonhilfsbezeichnung });
                }
            });
        }
    }
    displaySearchResults(results);
}

function displaySearchResults(results) {
    var searchResultsDiv = document.getElementById("search_results");
    searchResultsDiv.innerHTML = ""; // Clear previous results
    results.forEach(function(result) {
        var div = document.createElement("div");
        div.textContent = result.Farbtonkarten_Bezeichnung + " - " + result.Farbtonhilfsbezeichnung;
        searchResultsDiv.appendChild(div);
    });
}

// Event Listener für die Suchfunktion
document.getElementById("search_button").addEventListener("click", searchColor);

});

   

